
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3c19"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3c19"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ayMG0", function(module, exports) {
'use strict';

module.exports = (parcelRequire("8rWe0"));

});
parcelRegister("8rWe0", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $626e029de0d7793d$export$ffb0004e005737fa, (v) => $626e029de0d7793d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $626e029de0d7793d$export$34b9dba7ce09269b, (v) => $626e029de0d7793d$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $626e029de0d7793d$export$25062201e9e25d76, (v) => $626e029de0d7793d$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $626e029de0d7793d$export$ffb0004e005737fa;
var $626e029de0d7793d$export$34b9dba7ce09269b;
var $626e029de0d7793d$export$25062201e9e25d76;
"use strict";
var $626e029de0d7793d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $626e029de0d7793d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $626e029de0d7793d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $626e029de0d7793d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$626e029de0d7793d$export$ffb0004e005737fa = $626e029de0d7793d$var$REACT_FRAGMENT_TYPE;
$626e029de0d7793d$export$34b9dba7ce09269b = $626e029de0d7793d$var$jsxProd;
$626e029de0d7793d$export$25062201e9e25d76 = $626e029de0d7793d$var$jsxProd;

});


parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9Qu0I"));

});
parcelRegister("9Qu0I", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $72b03fdf46effee2$export$9c16c1426311996d, (v) => $72b03fdf46effee2$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $72b03fdf46effee2$export$dca3b0875bd9a954, (v) => $72b03fdf46effee2$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $72b03fdf46effee2$export$16fa2f45be04daa8, (v) => $72b03fdf46effee2$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $72b03fdf46effee2$export$ffb0004e005737fa, (v) => $72b03fdf46effee2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $72b03fdf46effee2$export$e2c29f18771995cb, (v) => $72b03fdf46effee2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $72b03fdf46effee2$export$221d75b3f55bb0bd, (v) => $72b03fdf46effee2$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $72b03fdf46effee2$export$5f8d39834fd61797, (v) => $72b03fdf46effee2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $72b03fdf46effee2$export$74bf444e3cd11ea5, (v) => $72b03fdf46effee2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "ViewTransition", () => $72b03fdf46effee2$export$8cdaa4703948c5e9, (v) => $72b03fdf46effee2$export$8cdaa4703948c5e9 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $72b03fdf46effee2$export$1ced07cd6b1985ce, (v) => $72b03fdf46effee2$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $72b03fdf46effee2$export$abd8e32b826d7ea7, (v) => $72b03fdf46effee2$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "addTransitionType", () => $72b03fdf46effee2$export$87c99536b1b8cdd8, (v) => $72b03fdf46effee2$export$87c99536b1b8cdd8 = v);
$parcel$export(module.exports, "cache", () => $72b03fdf46effee2$export$69a3209f1a06c04d, (v) => $72b03fdf46effee2$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $72b03fdf46effee2$export$8c538325882c7eec, (v) => $72b03fdf46effee2$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $72b03fdf46effee2$export$e530037191fcd5d7, (v) => $72b03fdf46effee2$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $72b03fdf46effee2$export$fd42f52fd3ae1109, (v) => $72b03fdf46effee2$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $72b03fdf46effee2$export$c8a8987d4410bf2d, (v) => $72b03fdf46effee2$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $72b03fdf46effee2$export$7d1e3a5e95ceca43, (v) => $72b03fdf46effee2$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $72b03fdf46effee2$export$257a8862b851cb5b, (v) => $72b03fdf46effee2$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $72b03fdf46effee2$export$a8257692ac88316c, (v) => $72b03fdf46effee2$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $72b03fdf46effee2$export$488013bae63b21da, (v) => $72b03fdf46effee2$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $72b03fdf46effee2$export$7c73462e0d25e514, (v) => $72b03fdf46effee2$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $72b03fdf46effee2$export$7568632d0d33d16d, (v) => $72b03fdf46effee2$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $72b03fdf46effee2$export$f93f40ac0ca7e3a8, (v) => $72b03fdf46effee2$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $72b03fdf46effee2$export$1f96ae73734a86cc, (v) => $72b03fdf46effee2$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $72b03fdf46effee2$export$9a47ced3238df325, (v) => $72b03fdf46effee2$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $72b03fdf46effee2$export$35808ee640e87ca7, (v) => $72b03fdf46effee2$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $72b03fdf46effee2$export$fae74005e78b1a27, (v) => $72b03fdf46effee2$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $72b03fdf46effee2$export$dc8fbce3eb94dc1e, (v) => $72b03fdf46effee2$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $72b03fdf46effee2$export$6a7bc4e911dc01cf, (v) => $72b03fdf46effee2$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $72b03fdf46effee2$export$6d9c69b0de29b591, (v) => $72b03fdf46effee2$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $72b03fdf46effee2$export$7f54fc3180508a52, (v) => $72b03fdf46effee2$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $72b03fdf46effee2$export$f680877a34711e37, (v) => $72b03fdf46effee2$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $72b03fdf46effee2$export$d5a552a76deda3c2, (v) => $72b03fdf46effee2$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $72b03fdf46effee2$export$aaabe4eda9ed9969, (v) => $72b03fdf46effee2$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $72b03fdf46effee2$export$e5c5a5f917a5871c, (v) => $72b03fdf46effee2$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $72b03fdf46effee2$export$1538c33de8887b59, (v) => $72b03fdf46effee2$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $72b03fdf46effee2$export$fca7f784ae7a249a, (v) => $72b03fdf46effee2$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $72b03fdf46effee2$export$13e3392192263954, (v) => $72b03fdf46effee2$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $72b03fdf46effee2$export$b8f5890fc79d6aca, (v) => $72b03fdf46effee2$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $72b03fdf46effee2$export$60241385465d0a34, (v) => $72b03fdf46effee2$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $72b03fdf46effee2$export$306c0aa65ff9ec16, (v) => $72b03fdf46effee2$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $72b03fdf46effee2$export$7b286972b8d8ccbf, (v) => $72b03fdf46effee2$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $72b03fdf46effee2$export$83d89fbfd8236492, (v) => $72b03fdf46effee2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $72b03fdf46effee2$export$9c16c1426311996d;
var $72b03fdf46effee2$export$dca3b0875bd9a954;
var $72b03fdf46effee2$export$16fa2f45be04daa8;
var $72b03fdf46effee2$export$ffb0004e005737fa;
var $72b03fdf46effee2$export$e2c29f18771995cb;
var $72b03fdf46effee2$export$221d75b3f55bb0bd;
var $72b03fdf46effee2$export$5f8d39834fd61797;
var $72b03fdf46effee2$export$74bf444e3cd11ea5;
var $72b03fdf46effee2$export$8cdaa4703948c5e9;
var $72b03fdf46effee2$export$1ced07cd6b1985ce;
var $72b03fdf46effee2$export$abd8e32b826d7ea7;
var $72b03fdf46effee2$export$87c99536b1b8cdd8;
var $72b03fdf46effee2$export$69a3209f1a06c04d;
var $72b03fdf46effee2$export$8c538325882c7eec;
var $72b03fdf46effee2$export$e530037191fcd5d7;
var $72b03fdf46effee2$export$fd42f52fd3ae1109;
var $72b03fdf46effee2$export$c8a8987d4410bf2d;
var $72b03fdf46effee2$export$7d1e3a5e95ceca43;
var $72b03fdf46effee2$export$257a8862b851cb5b;
var $72b03fdf46effee2$export$a8257692ac88316c;
var $72b03fdf46effee2$export$488013bae63b21da;
var $72b03fdf46effee2$export$7c73462e0d25e514;
var $72b03fdf46effee2$export$7568632d0d33d16d;
var $72b03fdf46effee2$export$f93f40ac0ca7e3a8;
var $72b03fdf46effee2$export$1f96ae73734a86cc;
var $72b03fdf46effee2$export$9a47ced3238df325;
var $72b03fdf46effee2$export$35808ee640e87ca7;
var $72b03fdf46effee2$export$fae74005e78b1a27;
var $72b03fdf46effee2$export$dc8fbce3eb94dc1e;
var $72b03fdf46effee2$export$6a7bc4e911dc01cf;
var $72b03fdf46effee2$export$6d9c69b0de29b591;
var $72b03fdf46effee2$export$7f54fc3180508a52;
var $72b03fdf46effee2$export$f680877a34711e37;
var $72b03fdf46effee2$export$d5a552a76deda3c2;
var $72b03fdf46effee2$export$aaabe4eda9ed9969;
var $72b03fdf46effee2$export$e5c5a5f917a5871c;
var $72b03fdf46effee2$export$1538c33de8887b59;
var $72b03fdf46effee2$export$fca7f784ae7a249a;
var $72b03fdf46effee2$export$13e3392192263954;
var $72b03fdf46effee2$export$b8f5890fc79d6aca;
var $72b03fdf46effee2$export$60241385465d0a34;
var $72b03fdf46effee2$export$306c0aa65ff9ec16;
var $72b03fdf46effee2$export$7b286972b8d8ccbf;
var $72b03fdf46effee2$export$83d89fbfd8236492;
"use strict";
var $72b03fdf46effee2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $72b03fdf46effee2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $72b03fdf46effee2$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $72b03fdf46effee2$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $72b03fdf46effee2$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $72b03fdf46effee2$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $72b03fdf46effee2$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $72b03fdf46effee2$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $72b03fdf46effee2$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $72b03fdf46effee2$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $72b03fdf46effee2$var$assign = Object.assign, $72b03fdf46effee2$var$emptyObject = {};
function $72b03fdf46effee2$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
$72b03fdf46effee2$var$Component.prototype.isReactComponent = {};
$72b03fdf46effee2$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$72b03fdf46effee2$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $72b03fdf46effee2$var$ComponentDummy() {}
$72b03fdf46effee2$var$ComponentDummy.prototype = $72b03fdf46effee2$var$Component.prototype;
function $72b03fdf46effee2$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
var $72b03fdf46effee2$var$pureComponentPrototype = $72b03fdf46effee2$var$PureComponent.prototype = new $72b03fdf46effee2$var$ComponentDummy();
$72b03fdf46effee2$var$pureComponentPrototype.constructor = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$var$assign($72b03fdf46effee2$var$pureComponentPrototype, $72b03fdf46effee2$var$Component.prototype);
$72b03fdf46effee2$var$pureComponentPrototype.isPureReactComponent = !0;
var $72b03fdf46effee2$var$isArrayImpl = Array.isArray;
function $72b03fdf46effee2$var$noop() {}
var $72b03fdf46effee2$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $72b03fdf46effee2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $72b03fdf46effee2$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $72b03fdf46effee2$var$cloneAndReplaceKey(oldElement, newKey) {
    return $72b03fdf46effee2$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $72b03fdf46effee2$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $72b03fdf46effee2$var$REACT_ELEMENT_TYPE;
}
function $72b03fdf46effee2$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $72b03fdf46effee2$var$userProvidedKeyEscapeRegex = /\/+/g;
function $72b03fdf46effee2$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $72b03fdf46effee2$var$escape("" + element.key) : index.toString(36);
}
function $72b03fdf46effee2$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $72b03fdf46effee2$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $72b03fdf46effee2$var$REACT_ELEMENT_TYPE:
                case $72b03fdf46effee2$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $72b03fdf46effee2$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $72b03fdf46effee2$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $72b03fdf46effee2$var$getElementKey(children, 0) : nameSoFar, $72b03fdf46effee2$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $72b03fdf46effee2$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($72b03fdf46effee2$var$isValidElement(callback) && (callback = $72b03fdf46effee2$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($72b03fdf46effee2$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $72b03fdf46effee2$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i++), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $72b03fdf46effee2$var$mapIntoArray($72b03fdf46effee2$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $72b03fdf46effee2$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $72b03fdf46effee2$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $72b03fdf46effee2$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result, thenable = ctor();
        thenable.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject, void 0 === thenable.status && (thenable.status = "fulfilled", thenable.value = moduleObject);
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error, void 0 === thenable.status && (thenable.status = "rejected", thenable.reason = error);
        });
        -1 === payload._status && (payload._status = 0, payload._result = thenable);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $72b03fdf46effee2$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $72b03fdf46effee2$var$startTransition(scope) {
    var prevTransition = $72b03fdf46effee2$var$ReactSharedInternals.T, currentTransition = {};
    currentTransition.types = null !== prevTransition ? prevTransition.types : null;
    $72b03fdf46effee2$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $72b03fdf46effee2$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$reportGlobalError);
    } catch (error) {
        $72b03fdf46effee2$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $72b03fdf46effee2$var$ReactSharedInternals.T = prevTransition;
    }
}
function $72b03fdf46effee2$var$addTransitionType(type) {
    var transition = $72b03fdf46effee2$var$ReactSharedInternals.T;
    if (null !== transition) {
        var transitionTypes = transition.types;
        null === transitionTypes ? transition.types = [
            type
        ] : -1 === transitionTypes.indexOf(type) && transitionTypes.push(type);
    } else $72b03fdf46effee2$var$startTransition($72b03fdf46effee2$var$addTransitionType.bind(null, type));
}
var $72b03fdf46effee2$var$Children = {
    map: $72b03fdf46effee2$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $72b03fdf46effee2$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $72b03fdf46effee2$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $72b03fdf46effee2$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$72b03fdf46effee2$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$72b03fdf46effee2$export$9c16c1426311996d = $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE;
$72b03fdf46effee2$export$dca3b0875bd9a954 = $72b03fdf46effee2$var$Children;
$72b03fdf46effee2$export$16fa2f45be04daa8 = $72b03fdf46effee2$var$Component;
$72b03fdf46effee2$export$ffb0004e005737fa = $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE;
$72b03fdf46effee2$export$e2c29f18771995cb = $72b03fdf46effee2$var$REACT_PROFILER_TYPE;
$72b03fdf46effee2$export$221d75b3f55bb0bd = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$export$5f8d39834fd61797 = $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE;
$72b03fdf46effee2$export$74bf444e3cd11ea5 = $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE;
$72b03fdf46effee2$export$8cdaa4703948c5e9 = $72b03fdf46effee2$var$REACT_VIEW_TRANSITION_TYPE;
$72b03fdf46effee2$export$1ced07cd6b1985ce = $72b03fdf46effee2$var$ReactSharedInternals;
$72b03fdf46effee2$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$72b03fdf46effee2$export$87c99536b1b8cdd8 = $72b03fdf46effee2$var$addTransitionType;
$72b03fdf46effee2$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$72b03fdf46effee2$export$8c538325882c7eec = function() {
    return null;
};
$72b03fdf46effee2$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $72b03fdf46effee2$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $72b03fdf46effee2$var$ReactElement(element.type, key, props);
};
$72b03fdf46effee2$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$72b03fdf46effee2$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $72b03fdf46effee2$var$ReactElement(type, key, props);
};
$72b03fdf46effee2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$72b03fdf46effee2$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$72b03fdf46effee2$export$a8257692ac88316c = $72b03fdf46effee2$var$isValidElement;
$72b03fdf46effee2$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $72b03fdf46effee2$var$lazyInitializer
    };
};
$72b03fdf46effee2$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$72b03fdf46effee2$export$7568632d0d33d16d = $72b03fdf46effee2$var$startTransition;
$72b03fdf46effee2$export$f93f40ac0ca7e3a8 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCacheRefresh();
};
$72b03fdf46effee2$export$1f96ae73734a86cc = function(usable) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.use(usable);
};
$72b03fdf46effee2$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$72b03fdf46effee2$export$35808ee640e87ca7 = function(callback, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$72b03fdf46effee2$export$fae74005e78b1a27 = function(Context) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useContext(Context);
};
$72b03fdf46effee2$export$dc8fbce3eb94dc1e = function() {};
$72b03fdf46effee2$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$72b03fdf46effee2$export$6d9c69b0de29b591 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffect(create, deps);
};
$72b03fdf46effee2$export$7f54fc3180508a52 = function(callback) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$72b03fdf46effee2$export$f680877a34711e37 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useId();
};
$72b03fdf46effee2$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$72b03fdf46effee2$export$aaabe4eda9ed9969 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$72b03fdf46effee2$export$e5c5a5f917a5871c = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$72b03fdf46effee2$export$1538c33de8887b59 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemo(create, deps);
};
$72b03fdf46effee2$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$72b03fdf46effee2$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$72b03fdf46effee2$export$b8f5890fc79d6aca = function(initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useRef(initialValue);
};
$72b03fdf46effee2$export$60241385465d0a34 = function(initialState) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useState(initialState);
};
$72b03fdf46effee2$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$72b03fdf46effee2$export$7b286972b8d8ccbf = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useTransition();
};
$72b03fdf46effee2$export$83d89fbfd8236492 = "19.3.1";

});


parcelRegister("iWoMt", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $dca0ddb82b882518$export$882461b6382ed46c, (v) => $dca0ddb82b882518$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $dca0ddb82b882518$export$757ceba2d55c277e, (v) => $dca0ddb82b882518$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $dca0ddb82b882518$export$83d89fbfd8236492, (v) => $dca0ddb82b882518$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $dca0ddb82b882518$export$882461b6382ed46c;
var $dca0ddb82b882518$export$757ceba2d55c277e;
var $dca0ddb82b882518$export$83d89fbfd8236492;
"use strict";

var $fO90s = parcelRequire("fO90s");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $dca0ddb82b882518$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $dca0ddb82b882518$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $dca0ddb82b882518$var$getNearestMountedFiber(fiber) {
    for(var node = fiber, nextNode = node; nextNode && !nextNode.alternate;)node = nextNode, 0 !== (node.flags & 4098) && (fiber = node.return), nextNode = node.return;
    for(; node.return;)node = node.return;
    return 3 === node.tag ? fiber : null;
}
function $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$assertIsMounted(fiber) {
    if ($dca0ddb82b882518$var$getNearestMountedFiber(fiber) !== fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
}
function $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $dca0ddb82b882518$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $dca0ddb82b882518$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $dca0ddb82b882518$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $dca0ddb82b882518$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $dca0ddb82b882518$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
function $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(child, searchWithinHosts, fn, a, b, c) {
    for(; null !== child;){
        if ((5 === child.tag || 27 === child.tag || 6 === child.tag) && fn(child, a, b, c) || (22 !== child.tag || null === child.memoizedState) && (searchWithinHosts || 5 !== child.tag && 27 !== child.tag) && $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(child.child, searchWithinHosts, fn, a, b, c)) return !0;
        child = child.sibling;
    }
    return !1;
}
function $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(fiber) {
    for(fiber = fiber.return; null !== fiber;){
        if (3 === fiber.tag || 5 === fiber.tag || 27 === fiber.tag) return fiber;
        fiber = fiber.return;
    }
    return null;
}
function $dca0ddb82b882518$var$fiberIsPortaledIntoHost(fiber) {
    var foundPortalParent = !1;
    for(fiber = fiber.return; null !== fiber;){
        4 === fiber.tag && (foundPortalParent = !0);
        if (3 === fiber.tag || 5 === fiber.tag || 27 === fiber.tag) break;
        fiber = fiber.return;
    }
    return foundPortalParent;
}
function $dca0ddb82b882518$var$getFragmentInstanceOrTextInstanceSiblings(fiber) {
    var result = [
        null,
        null
    ], parentHostFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(fiber);
    if (null === parentHostFiber) return result;
    $dca0ddb82b882518$var$findFragmentInstanceOrTextInstanceSiblings(result, fiber, parentHostFiber.child, {
        foundSelf: !1
    });
    return result;
}
function $dca0ddb82b882518$var$findFragmentInstanceOrTextInstanceSiblings(result, self, child, state) {
    for(; null !== child;){
        if (child === self) state.foundSelf = !0;
        else if (5 === child.tag || 27 === child.tag || 6 === child.tag) {
            if (state.foundSelf) return result[1] = child, !0;
            result[0] = child;
        } else if ((22 !== child.tag || null === child.memoizedState) && $dca0ddb82b882518$var$findFragmentInstanceOrTextInstanceSiblings(result, self, child.child, state)) return !0;
        child = child.sibling;
    }
    return !1;
}
function $dca0ddb82b882518$var$getInstanceFromHostFiber(fiber) {
    switch(fiber.tag){
        case 5:
        case 27:
        case 6:
            return fiber.stateNode;
        case 3:
            return fiber.stateNode.containerInfo;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(559));
    }
}
var $dca0ddb82b882518$var$searchTarget = null, $dca0ddb82b882518$var$searchBoundary = null;
function $dca0ddb82b882518$var$isFiberPrecedingCheck(child, target, boundary) {
    return child === boundary ? !0 : child === target ? ($dca0ddb82b882518$var$searchTarget = child, !0) : !1;
}
function $dca0ddb82b882518$var$isFiberFollowingCheck(child, target, boundary) {
    return child === boundary ? ($dca0ddb82b882518$var$searchBoundary = child, !1) : child === target ? (null !== $dca0ddb82b882518$var$searchBoundary && ($dca0ddb82b882518$var$searchTarget = child), !0) : !1;
}
function $dca0ddb82b882518$var$getParentForFragmentAncestors(inst) {
    if (null === inst) return null;
    do inst = null === inst ? null : inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag && 3 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$getLowestCommonAncestor(instA, instB, getParent) {
    for(var depthA = 0, tempA = instA; tempA; tempA = getParent(tempA))depthA++;
    tempA = 0;
    for(var tempB = instB; tempB; tempB = getParent(tempB))tempA++;
    for(; 0 < depthA - tempA;)instA = getParent(instA), depthA--;
    for(; 0 < tempA - depthA;)instB = getParent(instB), tempA--;
    for(; depthA--;){
        if (instA === instB || null !== instB && instA === instB.alternate) return instA;
        instA = getParent(instA);
        instB = getParent(instB);
    }
    return null;
}
var $dca0ddb82b882518$var$assign = Object.assign, $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $dca0ddb82b882518$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $dca0ddb82b882518$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $dca0ddb82b882518$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $dca0ddb82b882518$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $dca0ddb82b882518$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $dca0ddb82b882518$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $dca0ddb82b882518$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $dca0ddb82b882518$var$REACT_LEGACY_HIDDEN_TYPE = Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel"), $dca0ddb82b882518$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $dca0ddb82b882518$var$REACT_RECOVERABLE_TYPE = Symbol.for("react.recoverable"), $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $dca0ddb82b882518$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $dca0ddb82b882518$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return "Activity";
        case $dca0ddb82b882518$var$REACT_VIEW_TRANSITION_TYPE:
            return "ViewTransition";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $dca0ddb82b882518$var$getComponentNameFromType(type.type) || "Memo";
        case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $dca0ddb82b882518$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $dca0ddb82b882518$var$isArrayImpl = Array.isArray, $dca0ddb82b882518$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$ReactDOMSharedInternals = $1u0KT.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $dca0ddb82b882518$var$valueStack = [], $dca0ddb82b882518$var$index = -1;
function $dca0ddb82b882518$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $dca0ddb82b882518$var$pop(cursor) {
    0 > $dca0ddb82b882518$var$index || (cursor.current = $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index], $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = null, $dca0ddb82b882518$var$index--);
}
function $dca0ddb82b882518$var$push(cursor, value) {
    $dca0ddb82b882518$var$index++;
    $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = cursor.current;
    cursor.current = value;
}
var $dca0ddb82b882518$var$contextStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$contextFiberStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$rootInstanceStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$hostTransitionProviderCursor = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$pushHostContainer(fiber, nextRootInstance) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$rootInstanceStackCursor, nextRootInstance);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $dca0ddb82b882518$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $dca0ddb82b882518$var$getOwnHostContext(nextRootInstance), fiber = $dca0ddb82b882518$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, fiber);
}
function $dca0ddb82b882518$var$popHostContainer() {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$rootInstanceStackCursor);
}
function $dca0ddb82b882518$var$pushHostContext(fiber) {
    var stateHook = fiber.memoizedState;
    null !== stateHook && ($dca0ddb82b882518$var$HostTransitionContext._currentValue = stateHook.memoizedState, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$hostTransitionProviderCursor, fiber));
    stateHook = $dca0ddb82b882518$var$contextStackCursor.current;
    var JSCompiler_inline_result = $dca0ddb82b882518$var$getChildHostContextProd(stateHook, fiber.type);
    stateHook !== JSCompiler_inline_result && ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, JSCompiler_inline_result));
}
function $dca0ddb82b882518$var$popHostContext(fiber) {
    $dca0ddb82b882518$var$contextFiberStackCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor), $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor));
    $dca0ddb82b882518$var$hostTransitionProviderCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$hostTransitionProviderCursor), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $dca0ddb82b882518$var$sharedNotPendingObject);
}
var $dca0ddb82b882518$var$prefix, $dca0ddb82b882518$var$suffix;
function $dca0ddb82b882518$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $dca0ddb82b882518$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $dca0ddb82b882518$var$prefix = match && match[1] || "";
        $dca0ddb82b882518$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $dca0ddb82b882518$var$prefix + name + $dca0ddb82b882518$var$suffix;
}
var $dca0ddb82b882518$var$reentry = !1;
function $dca0ddb82b882518$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $dca0ddb82b882518$var$reentry) return "";
    $dca0ddb82b882518$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            Fake = !1;
                            try {
                                var prevProps = Object.getOwnPropertyDescriptor(fn.prototype, "props");
                                Object.defineProperty(fn.prototype, "props", {
                                    configurable: !0,
                                    set: function() {
                                        throw Error();
                                    }
                                });
                                Fake = !0;
                                new fn();
                            } finally{
                                Fake && (void 0 !== prevProps ? Object.defineProperty(fn.prototype, "props", prevProps) : delete fn.prototype.props);
                            }
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $dca0ddb82b882518$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $dca0ddb82b882518$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $dca0ddb82b882518$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense Fallback") : $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Activity");
        case 30:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("ViewTransition");
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $dca0ddb82b882518$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $dca0ddb82b882518$var$hasOwnProperty = Object.prototype.hasOwnProperty, $dca0ddb82b882518$var$scheduleCallback$3 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$cancelCallback$1 = $fO90s.unstable_cancelCallback, $dca0ddb82b882518$var$shouldYield = $fO90s.unstable_shouldYield, $dca0ddb82b882518$var$requestPaint = $fO90s.unstable_requestPaint, $dca0ddb82b882518$var$now = $fO90s.unstable_now, $dca0ddb82b882518$var$getCurrentPriorityLevel = $fO90s.unstable_getCurrentPriorityLevel, $dca0ddb82b882518$var$ImmediatePriority = $fO90s.unstable_ImmediatePriority, $dca0ddb82b882518$var$UserBlockingPriority = $fO90s.unstable_UserBlockingPriority, $dca0ddb82b882518$var$NormalPriority$1 = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$LowPriority = $fO90s.unstable_LowPriority, $dca0ddb82b882518$var$IdlePriority = $fO90s.unstable_IdlePriority, $dca0ddb82b882518$var$log$1 = $fO90s.log, $dca0ddb82b882518$var$unstable_setDisableYieldValue = $fO90s.unstable_setDisableYieldValue, $dca0ddb82b882518$var$rendererID = null, $dca0ddb82b882518$var$injectedHook = null;
function $dca0ddb82b882518$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $dca0ddb82b882518$var$log$1 && $dca0ddb82b882518$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.setStrictMode) try {
        $dca0ddb82b882518$var$injectedHook.setStrictMode($dca0ddb82b882518$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $dca0ddb82b882518$var$clz32 = Math.clz32 ? Math.clz32 : $dca0ddb82b882518$var$clz32Fallback, $dca0ddb82b882518$var$log = Math.log, $dca0ddb82b882518$var$LN2 = Math.LN2;
function $dca0ddb82b882518$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($dca0ddb82b882518$var$log(x) / $dca0ddb82b882518$var$LN2 | 0) | 0;
}
var $dca0ddb82b882518$var$nextTransitionUpdateLane = 256, $dca0ddb82b882518$var$nextTransitionDeferredLane = 262144, $dca0ddb82b882518$var$nextRetryLane = 4194304;
function $dca0ddb82b882518$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & -lanes;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $dca0ddb82b882518$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $dca0ddb82b882518$var$getEntangledLanes(root, renderLanes) {
    0 !== (renderLanes & 8) && (renderLanes |= renderLanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= renderLanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $dca0ddb82b882518$var$clz32(allEntangledLanes), lane = 1 << index$4;
        renderLanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    return renderLanes;
}
function $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $dca0ddb82b882518$var$claimNextRetryLane() {
    var lane = $dca0ddb82b882518$var$nextRetryLane;
    $dca0ddb82b882518$var$nextRetryLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextRetryLane & 62914560) && ($dca0ddb82b882518$var$nextRetryLane = 4194304);
    return lane;
}
function $dca0ddb82b882518$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $dca0ddb82b882518$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $dca0ddb82b882518$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $dca0ddb82b882518$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $dca0ddb82b882518$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $dca0ddb82b882518$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $dca0ddb82b882518$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $dca0ddb82b882518$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $dca0ddb82b882518$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $dca0ddb82b882518$var$resolveUpdatePriority() {
    var updatePriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $dca0ddb82b882518$var$getEventPriority(updatePriority.type);
}
function $dca0ddb82b882518$var$runWithPriority(priority, fn) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        return $dca0ddb82b882518$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $dca0ddb82b882518$var$randomKey = Math.random().toString(36).slice(2), $dca0ddb82b882518$var$internalInstanceKey = "__reactFiber$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalPropsKey = "__reactProps$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalContainerInstanceKey = "__reactContainer$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlersKey = "__reactEvents$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlerListenersKey = "__reactListeners$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlesSetKey = "__reactHandles$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalRootNodeResourcesKey = "__reactResources$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalHoistableMarker = "__reactMarker$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalLoadPendingKey = "__reactLoad$" + $dca0ddb82b882518$var$randomKey;
function $dca0ddb82b882518$var$detachDeletedInstance(node) {
    delete node[$dca0ddb82b882518$var$internalInstanceKey];
    delete node[$dca0ddb82b882518$var$internalPropsKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlerListenersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlesSetKey];
}
function $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode) {
    var targetInst;
    if (targetInst = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$dca0ddb82b882518$var$internalContainerInstanceKey] || parentNode[$dca0ddb82b882518$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return parentNode;
                targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $dca0ddb82b882518$var$getInstanceFromNode(node) {
    if (node = node[$dca0ddb82b882518$var$internalInstanceKey] || node[$dca0ddb82b882518$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $dca0ddb82b882518$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(33));
}
function $dca0ddb82b882518$var$getResourcesFromRoot(root) {
    var resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey];
    resources || (resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $dca0ddb82b882518$var$markNodeAsHoistable(node) {
    node[$dca0ddb82b882518$var$internalHoistableMarker] = !0;
}
function $dca0ddb82b882518$var$clearPendingLoadOnNode(node) {
    node[$dca0ddb82b882518$var$internalLoadPendingKey] = void 0;
}
var $dca0ddb82b882518$var$allNativeEvents = new Set(), $dca0ddb82b882518$var$registrationNameDependencies = {};
function $dca0ddb82b882518$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies);
    $dca0ddb82b882518$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$dca0ddb82b882518$var$allNativeEvents.add(dependencies[registrationName]);
}
var $dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $dca0ddb82b882518$var$illegalAttributeNameCache = {}, $dca0ddb82b882518$var$validatedAttributeNameCache = {};
function $dca0ddb82b882518$var$isAttributeNameSafe(attributeName) {
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $dca0ddb82b882518$var$validatedAttributeNameCache[attributeName] = !0;
    $dca0ddb82b882518$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
var $dca0ddb82b882518$var$viewTransitionMutationContext = !1;
function $dca0ddb82b882518$var$pushMutationContext() {
    var prev = $dca0ddb82b882518$var$viewTransitionMutationContext;
    $dca0ddb82b882518$var$viewTransitionMutationContext = !1;
    return prev;
}
function $dca0ddb82b882518$var$setValueForAttribute(node, name, value) {
    if ($dca0ddb82b882518$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, value);
        }
    }
}
function $dca0ddb82b882518$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, value);
    }
}
function $dca0ddb82b882518$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, value);
    }
}
function $dca0ddb82b882518$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $dca0ddb82b882518$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $dca0ddb82b882518$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $dca0ddb82b882518$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $dca0ddb82b882518$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $dca0ddb82b882518$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $dca0ddb82b882518$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
var $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $dca0ddb82b882518$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $dca0ddb82b882518$var$getToStringValue(value);
        } else element.value !== "" + $dca0ddb82b882518$var$getToStringValue(value) && (element.value = "" + $dca0ddb82b882518$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? "number" === type && element.value == value ? $dca0ddb82b882518$var$setDefaultValue(element, $dca0ddb82b882518$var$getToStringValue(element.value)) : $dca0ddb82b882518$var$setDefaultValue(element, $dca0ddb82b882518$var$getToStringValue(value)) : null != defaultValue ? $dca0ddb82b882518$var$setDefaultValue(element, $dca0ddb82b882518$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $dca0ddb82b882518$var$getToStringValue(name) : element.removeAttribute("name");
}
function $dca0ddb82b882518$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $dca0ddb82b882518$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $dca0ddb82b882518$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setDefaultValue(node, value) {
    node.defaultValue !== "" + value && (node.defaultValue = "" + value);
}
function $dca0ddb82b882518$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $dca0ddb82b882518$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $dca0ddb82b882518$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $dca0ddb82b882518$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
}
function $dca0ddb82b882518$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(92));
            if ($dca0ddb82b882518$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $dca0ddb82b882518$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $dca0ddb82b882518$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $dca0ddb82b882518$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $dca0ddb82b882518$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $dca0ddb82b882518$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "", $dca0ddb82b882518$var$viewTransitionMutationContext = !0);
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && ($dca0ddb82b882518$var$setValueForStyle(node, styleName$16, styleName), $dca0ddb82b882518$var$viewTransitionMutationContext = !0);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $dca0ddb82b882518$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $dca0ddb82b882518$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $dca0ddb82b882518$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "maskType",
        "mask-type"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $dca0ddb82b882518$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $dca0ddb82b882518$var$sanitizeURL(url) {
    return $dca0ddb82b882518$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $dca0ddb82b882518$var$noop$1() {}
var $dca0ddb82b882518$var$currentReplayingEvent = null;
function $dca0ddb82b882518$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreQueue = null;
function $dca0ddb82b882518$var$restoreStateOfTarget(target) {
    var internalInstance = $dca0ddb82b882518$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$dca0ddb82b882518$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $dca0ddb82b882518$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$dca0ddb82b882518$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(90));
                            $dca0ddb82b882518$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $dca0ddb82b882518$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $dca0ddb82b882518$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $dca0ddb82b882518$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $dca0ddb82b882518$var$isInsideEventHandler = !1;
function $dca0ddb82b882518$var$batchedUpdates$1(fn, a, b) {
    if ($dca0ddb82b882518$var$isInsideEventHandler) return fn(a, b);
    $dca0ddb82b882518$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($dca0ddb82b882518$var$isInsideEventHandler = !1, null !== $dca0ddb82b882518$var$restoreTarget || null !== $dca0ddb82b882518$var$restoreQueue) {
            if ($dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$restoreTarget && (a = $dca0ddb82b882518$var$restoreTarget, fn = $dca0ddb82b882518$var$restoreQueue, $dca0ddb82b882518$var$restoreQueue = $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$dca0ddb82b882518$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $dca0ddb82b882518$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$dca0ddb82b882518$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $dca0ddb82b882518$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) try {
    var $dca0ddb82b882518$var$options = {};
    Object.defineProperty($dca0ddb82b882518$var$options, "passive", {
        get: function() {
            $dca0ddb82b882518$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
    window.removeEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
} catch (e) {
    $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
}
var $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$startText = null, $dca0ddb82b882518$var$fallbackText = null;
function $dca0ddb82b882518$var$getData() {
    if ($dca0ddb82b882518$var$fallbackText) return $dca0ddb82b882518$var$fallbackText;
    var start, startValue = $dca0ddb82b882518$var$startText, startLength = startValue.length, end, endValue = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $dca0ddb82b882518$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $dca0ddb82b882518$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $dca0ddb82b882518$var$functionThatReturnsTrue() {
    return !0;
}
function $dca0ddb82b882518$var$functionThatReturnsFalse() {
    return !1;
}
function $dca0ddb82b882518$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $dca0ddb82b882518$var$functionThatReturnsTrue : $dca0ddb82b882518$var$functionThatReturnsFalse;
        this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsFalse;
        return this;
    }
    $dca0ddb82b882518$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $dca0ddb82b882518$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $dca0ddb82b882518$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $dca0ddb82b882518$var$SyntheticEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$EventInterface), $dca0ddb82b882518$var$UIEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    view: 0,
    detail: 0
}), $dca0ddb82b882518$var$SyntheticUIEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$UIEventInterface), $dca0ddb82b882518$var$lastMovementX, $dca0ddb82b882518$var$lastMovementY, $dca0ddb82b882518$var$lastMouseEvent, $dca0ddb82b882518$var$MouseEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $dca0ddb82b882518$var$lastMouseEvent && ($dca0ddb82b882518$var$lastMouseEvent && "mousemove" === event.type ? ($dca0ddb82b882518$var$lastMovementX = event.screenX - $dca0ddb82b882518$var$lastMouseEvent.screenX, $dca0ddb82b882518$var$lastMovementY = event.screenY - $dca0ddb82b882518$var$lastMouseEvent.screenY) : $dca0ddb82b882518$var$lastMovementY = $dca0ddb82b882518$var$lastMovementX = 0, $dca0ddb82b882518$var$lastMouseEvent = event);
        return $dca0ddb82b882518$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $dca0ddb82b882518$var$lastMovementY;
    }
}), $dca0ddb82b882518$var$SyntheticMouseEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$MouseEventInterface), $dca0ddb82b882518$var$DragEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    dataTransfer: 0
}), $dca0ddb82b882518$var$SyntheticDragEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$DragEventInterface), $dca0ddb82b882518$var$FocusEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    relatedTarget: 0
}), $dca0ddb82b882518$var$SyntheticFocusEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$FocusEventInterface), $dca0ddb82b882518$var$AnimationEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticAnimationEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$AnimationEventInterface), $dca0ddb82b882518$var$ClipboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $dca0ddb82b882518$var$SyntheticClipboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ClipboardEventInterface), $dca0ddb82b882518$var$CompositionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    data: 0
}), $dca0ddb82b882518$var$SyntheticCompositionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$CompositionEventInterface), $dca0ddb82b882518$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $dca0ddb82b882518$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $dca0ddb82b882518$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $dca0ddb82b882518$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $dca0ddb82b882518$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $dca0ddb82b882518$var$getEventModifierState() {
    return $dca0ddb82b882518$var$modifierStateGetter;
}
var $dca0ddb82b882518$var$KeyboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $dca0ddb82b882518$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $dca0ddb82b882518$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $dca0ddb82b882518$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $dca0ddb82b882518$var$SyntheticKeyboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$KeyboardEventInterface), $dca0ddb82b882518$var$PointerEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $dca0ddb82b882518$var$SyntheticPointerEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$PointerEventInterface), $dca0ddb82b882518$var$SubmitEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    submitter: 0
}), $dca0ddb82b882518$var$SyntheticSubmitEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$SubmitEventInterface), $dca0ddb82b882518$var$TouchEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState
}), $dca0ddb82b882518$var$SyntheticTouchEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TouchEventInterface), $dca0ddb82b882518$var$TransitionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticTransitionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TransitionEventInterface), $dca0ddb82b882518$var$WheelEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $dca0ddb82b882518$var$SyntheticWheelEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$WheelEventInterface), $dca0ddb82b882518$var$ToggleEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    newState: 0,
    oldState: 0,
    source: 0
}), $dca0ddb82b882518$var$SyntheticToggleEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ToggleEventInterface), $dca0ddb82b882518$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $dca0ddb82b882518$var$canUseCompositionEvent = $dca0ddb82b882518$var$canUseDOM && "CompositionEvent" in window, $dca0ddb82b882518$var$documentMode = null;
$dca0ddb82b882518$var$canUseDOM && "documentMode" in document && ($dca0ddb82b882518$var$documentMode = document.documentMode);
var $dca0ddb82b882518$var$canUseTextInputEvent = $dca0ddb82b882518$var$canUseDOM && "TextEvent" in window && !$dca0ddb82b882518$var$documentMode, $dca0ddb82b882518$var$useFallbackCompositionData = $dca0ddb82b882518$var$canUseDOM && (!$dca0ddb82b882518$var$canUseCompositionEvent || $dca0ddb82b882518$var$documentMode && 8 < $dca0ddb82b882518$var$documentMode && 11 >= $dca0ddb82b882518$var$documentMode), $dca0ddb82b882518$var$SPACEBAR_CHAR = String.fromCharCode(32), $dca0ddb82b882518$var$hasSpaceKeypress = !1;
function $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $dca0ddb82b882518$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $dca0ddb82b882518$var$isComposing = !1;
function $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $dca0ddb82b882518$var$hasSpaceKeypress = !0;
            return $dca0ddb82b882518$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $dca0ddb82b882518$var$SPACEBAR_CHAR && $dca0ddb82b882518$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($dca0ddb82b882518$var$isComposing) return "compositionend" === domEventName || !$dca0ddb82b882518$var$canUseCompositionEvent && $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $dca0ddb82b882518$var$getData(), $dca0ddb82b882518$var$fallbackText = $dca0ddb82b882518$var$startText = $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $dca0ddb82b882518$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $dca0ddb82b882518$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$dca0ddb82b882518$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $dca0ddb82b882518$var$restoreTarget ? $dca0ddb82b882518$var$restoreQueue ? $dca0ddb82b882518$var$restoreQueue.push(target) : $dca0ddb82b882518$var$restoreQueue = [
        target
    ] : $dca0ddb82b882518$var$restoreTarget = target;
    inst = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $dca0ddb82b882518$var$activeElement$1 = null, $dca0ddb82b882518$var$activeElementInst$1 = null;
function $dca0ddb82b882518$var$runEventInBatch(dispatchQueue) {
    $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, 0);
}
function $dca0ddb82b882518$var$getInstIfValueChanged(targetInst) {
    var targetNode = $dca0ddb82b882518$var$getNodeFromInstance(targetInst);
    if ($dca0ddb82b882518$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $dca0ddb82b882518$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $dca0ddb82b882518$var$isInputEventSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) {
    var $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$318;
    if ($dca0ddb82b882518$var$canUseDOM) {
        var $dca0ddb82b882518$var$isSupported$jscomp$inline_474 = "oninput" in document;
        if (!$dca0ddb82b882518$var$isSupported$jscomp$inline_474) {
            var $dca0ddb82b882518$var$element$jscomp$inline_475 = document.createElement("div");
            $dca0ddb82b882518$var$element$jscomp$inline_475.setAttribute("oninput", "return;");
            $dca0ddb82b882518$var$isSupported$jscomp$inline_474 = "function" === typeof $dca0ddb82b882518$var$element$jscomp$inline_475.oninput;
        }
        $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$318 = $dca0ddb82b882518$var$isSupported$jscomp$inline_474;
    } else $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$318 = !1;
    $dca0ddb82b882518$var$isInputEventSupported = $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$318 && (!document.documentMode || 9 < document.documentMode);
}
function $dca0ddb82b882518$var$stopWatchingForValueChange() {
    $dca0ddb82b882518$var$activeElement$1 && ($dca0ddb82b882518$var$activeElement$1.detachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange), $dca0ddb82b882518$var$activeElementInst$1 = $dca0ddb82b882518$var$activeElement$1 = null);
}
function $dca0ddb82b882518$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, $dca0ddb82b882518$var$activeElementInst$1, nativeEvent, $dca0ddb82b882518$var$getEventTarget(nativeEvent));
        $dca0ddb82b882518$var$batchedUpdates$1($dca0ddb82b882518$var$runEventInBatch, dispatchQueue);
    }
}
function $dca0ddb82b882518$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($dca0ddb82b882518$var$stopWatchingForValueChange(), $dca0ddb82b882518$var$activeElement$1 = target, $dca0ddb82b882518$var$activeElementInst$1 = targetInst, $dca0ddb82b882518$var$activeElement$1.attachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange)) : "focusout" === domEventName && $dca0ddb82b882518$var$stopWatchingForValueChange();
}
function $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1);
}
function $dca0ddb82b882518$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dca0ddb82b882518$var$objectIs = "function" === typeof Object.is ? Object.is : $dca0ddb82b882518$var$is;
function $dca0ddb82b882518$var$shallowEqual(objA, objB) {
    if ($dca0ddb82b882518$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$dca0ddb82b882518$var$hasOwnProperty.call(objB, currentKey) || !$dca0ddb82b882518$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $dca0ddb82b882518$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e$20) {
        return doc.body;
    }
}
function $dca0ddb82b882518$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $dca0ddb82b882518$var$getNodeForCharacterOffset(root, offset) {
    var node = $dca0ddb82b882518$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $dca0ddb82b882518$var$getLeafNode(node);
    }
}
function $dca0ddb82b882518$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $dca0ddb82b882518$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $dca0ddb82b882518$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $dca0ddb82b882518$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $dca0ddb82b882518$var$skipSelectionChangeEvent = $dca0ddb82b882518$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $dca0ddb82b882518$var$activeElement = null, $dca0ddb82b882518$var$activeElementInst = null, $dca0ddb82b882518$var$lastSelection = null, $dca0ddb82b882518$var$mouseDown = !1;
function $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $dca0ddb82b882518$var$mouseDown || null == $dca0ddb82b882518$var$activeElement || $dca0ddb82b882518$var$activeElement !== $dca0ddb82b882518$var$getActiveElement(doc) || (doc = $dca0ddb82b882518$var$activeElement, "selectionStart" in doc && $dca0ddb82b882518$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $dca0ddb82b882518$var$lastSelection && $dca0ddb82b882518$var$shallowEqual($dca0ddb82b882518$var$lastSelection, doc) || ($dca0ddb82b882518$var$lastSelection = doc, doc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners($dca0ddb82b882518$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $dca0ddb82b882518$var$activeElement)));
}
function $dca0ddb82b882518$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $dca0ddb82b882518$var$vendorPrefixes = {
    animationend: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionEnd")
}, $dca0ddb82b882518$var$prefixedEventNames = {}, $dca0ddb82b882518$var$style = {};
$dca0ddb82b882518$var$canUseDOM && ($dca0ddb82b882518$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $dca0ddb82b882518$var$vendorPrefixes.animationend.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationiteration.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $dca0ddb82b882518$var$vendorPrefixes.transitionend.transition);
function $dca0ddb82b882518$var$getVendorPrefixedEventName(eventName) {
    if ($dca0ddb82b882518$var$prefixedEventNames[eventName]) return $dca0ddb82b882518$var$prefixedEventNames[eventName];
    if (!$dca0ddb82b882518$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $dca0ddb82b882518$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $dca0ddb82b882518$var$style) return $dca0ddb82b882518$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $dca0ddb82b882518$var$ANIMATION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationend"), $dca0ddb82b882518$var$ANIMATION_ITERATION = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationiteration"), $dca0ddb82b882518$var$ANIMATION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationstart"), $dca0ddb82b882518$var$TRANSITION_RUN = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionrun"), $dca0ddb82b882518$var$TRANSITION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionstart"), $dca0ddb82b882518$var$TRANSITION_CANCEL = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitioncancel"), $dca0ddb82b882518$var$TRANSITION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionend"), $dca0ddb82b882518$var$topLevelEventsToReactNames = new Map(), $dca0ddb82b882518$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error fullscreenChange fullscreenError gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$dca0ddb82b882518$var$simpleEventPluginEvents.push("scrollEnd");
function $dca0ddb82b882518$var$registerSimpleEvent(domEventName, reactName) {
    $dca0ddb82b882518$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $dca0ddb82b882518$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $dca0ddb82b882518$var$globalClientIdCounter$1 = 0;
function $dca0ddb82b882518$var$getViewTransitionName(props, instance) {
    if (null != props.name && "auto" !== props.name) return props.name;
    if (null !== instance.autoName) return instance.autoName;
    props = $dca0ddb82b882518$var$pendingEffectsRoot.identifierPrefix;
    var globalClientId = $dca0ddb82b882518$var$globalClientIdCounter$1++;
    props = "_" + props + "t_" + globalClientId.toString(32) + "_";
    return instance.autoName = props;
}
function $dca0ddb82b882518$var$getClassNameByType(classByType) {
    if (null == classByType || "string" === typeof classByType) return classByType;
    var className = null, activeTypes = $dca0ddb82b882518$var$pendingTransitionTypes;
    if (null !== activeTypes) for(var i = 0; i < activeTypes.length; i++){
        var match = classByType[activeTypes[i]];
        if (null != match) {
            if ("none" === match) return "none";
            className = null == className ? match : className + (" " + match);
        }
    }
    return null == className ? classByType.default : className;
}
function $dca0ddb82b882518$var$getViewTransitionClassName(defaultClass, eventClass) {
    defaultClass = $dca0ddb82b882518$var$getClassNameByType(defaultClass);
    eventClass = $dca0ddb82b882518$var$getClassNameByType(eventClass);
    return null == eventClass ? "auto" === defaultClass ? null : defaultClass : "auto" === eventClass ? null : eventClass;
}
var $dca0ddb82b882518$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $dca0ddb82b882518$var$concurrentQueues = [], $dca0ddb82b882518$var$concurrentQueuesIndex = 0, $dca0ddb82b882518$var$concurrentlyUpdatedLanes = 0;
function $dca0ddb82b882518$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $dca0ddb82b882518$var$concurrentQueuesIndex, i = $dca0ddb82b882518$var$concurrentlyUpdatedLanes = $dca0ddb82b882518$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var queue = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var update = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var lane = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = fiber;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = queue;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = update;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = lane;
    $dca0ddb82b882518$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, null, null, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $dca0ddb82b882518$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $dca0ddb82b882518$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $dca0ddb82b882518$var$nestedUpdateCount) throw $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null, Error($dca0ddb82b882518$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $dca0ddb82b882518$var$emptyContextObject = {};
function $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $dca0ddb82b882518$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode);
}
function $dca0ddb82b882518$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $dca0ddb82b882518$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $dca0ddb82b882518$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 1206910976;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $dca0ddb82b882518$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 1206910978;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $dca0ddb82b882518$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof owner) $dca0ddb82b882518$var$shouldConstruct(owner) && (fiberTag = 1);
    else if ("string" === typeof owner) fiberTag = $dca0ddb82b882518$var$isHostHoistableType(type, pendingProps, $dca0ddb82b882518$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(owner){
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return $dca0ddb82b882518$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $dca0ddb82b882518$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_LEGACY_HIDDEN_TYPE:
        case $dca0ddb82b882518$var$REACT_VIEW_TRANSITION_TYPE:
            return type = mode | 32, type = $dca0ddb82b882518$var$createFiberImplClass(30, pendingProps, key, type), type.elementType = $dca0ddb82b882518$var$REACT_VIEW_TRANSITION_TYPE, type.lanes = lanes, type.stateNode = {
                autoName: null,
                paired: null,
                clones: null,
                ref: null
            }, type;
        default:
            if ("object" === typeof owner && null !== owner) switch(owner.$$typeof){
                case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $dca0ddb82b882518$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $dca0ddb82b882518$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $dca0ddb82b882518$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $dca0ddb82b882518$var$createFiberFromText(content, mode, lanes) {
    content = $dca0ddb82b882518$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $dca0ddb82b882518$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $dca0ddb82b882518$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $dca0ddb82b882518$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $dca0ddb82b882518$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $dca0ddb82b882518$var$CapturedStacks = new WeakMap();
function $dca0ddb82b882518$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $dca0ddb82b882518$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
        };
        $dca0ddb82b882518$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
    };
}
var $dca0ddb82b882518$var$forkStack = [], $dca0ddb82b882518$var$forkStackIndex = 0, $dca0ddb82b882518$var$treeForkProvider = null, $dca0ddb82b882518$var$treeForkCount = 0, $dca0ddb82b882518$var$idStack = [], $dca0ddb82b882518$var$idStackIndex = 0, $dca0ddb82b882518$var$treeContextProvider = null, $dca0ddb82b882518$var$treeContextId = 1, $dca0ddb82b882518$var$treeContextOverflow = "";
function $dca0ddb82b882518$var$pushTreeFork(workInProgress, totalChildren) {
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkCount;
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkProvider;
    $dca0ddb82b882518$var$treeForkProvider = workInProgress;
    $dca0ddb82b882518$var$treeForkCount = totalChildren;
}
function $dca0ddb82b882518$var$pushTreeId(workInProgress, totalChildren, index) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
    workInProgress = $dca0ddb82b882518$var$treeContextOverflow;
    var baseLength = 32 - $dca0ddb82b882518$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $dca0ddb82b882518$var$treeContextId = 1 << 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $dca0ddb82b882518$var$treeContextOverflow = length + workInProgress;
    } else $dca0ddb82b882518$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $dca0ddb82b882518$var$treeContextOverflow = workInProgress;
}
function $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($dca0ddb82b882518$var$pushTreeFork(workInProgress, 1), $dca0ddb82b882518$var$pushTreeId(workInProgress, 1, 0));
}
function $dca0ddb82b882518$var$popTreeContext(workInProgress) {
    for(; workInProgress === $dca0ddb82b882518$var$treeForkProvider;)$dca0ddb82b882518$var$treeForkProvider = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null, $dca0ddb82b882518$var$treeForkCount = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null;
    for(; workInProgress === $dca0ddb82b882518$var$treeContextProvider;)$dca0ddb82b882518$var$treeContextProvider = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextOverflow = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextId = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null;
}
function $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextId = suspendedContext.id;
    $dca0ddb82b882518$var$treeContextOverflow = suspendedContext.overflow;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
}
var $dca0ddb82b882518$var$hydrationParentFiber = null, $dca0ddb82b882518$var$nextHydratableInstance = null, $dca0ddb82b882518$var$isHydrating = !1, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, $dca0ddb82b882518$var$HydrationMismatchException = Error($dca0ddb82b882518$var$formatProdErrorMessage(519));
function $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber) {
    var error = Error($dca0ddb82b882518$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(error, fiber));
    throw $dca0ddb82b882518$var$HydrationMismatchException;
}
function $dca0ddb82b882518$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$dca0ddb82b882518$var$internalInstanceKey] = fiber;
    instance[$dca0ddb82b882518$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $dca0ddb82b882518$var$mediaEventTypes.length; type++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            $dca0ddb82b882518$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance), $dca0ddb82b882518$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", instance), $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $dca0ddb82b882518$var$noop$1), instance = !0) : instance = !1;
    instance || $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber, !0);
}
function $dca0ddb82b882518$var$popToNextHostParent(fiber) {
    for($dca0ddb82b882518$var$hydrationParentFiber = fiber.return; $dca0ddb82b882518$var$hydrationParentFiber;)switch($dca0ddb82b882518$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $dca0ddb82b882518$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $dca0ddb82b882518$var$rootOrSingletonContext = !0;
            return;
        default:
            $dca0ddb82b882518$var$hydrationParentFiber = $dca0ddb82b882518$var$hydrationParentFiber.return;
    }
}
function $dca0ddb82b882518$var$popHydrationState(fiber) {
    if (fiber !== $dca0ddb82b882518$var$hydrationParentFiber) return !1;
    if (!$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $dca0ddb82b882518$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $dca0ddb82b882518$var$nextHydratableInstance && $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
    $dca0ddb82b882518$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(fiber.type) ? (fiber = $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton, $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null, $dca0ddb82b882518$var$nextHydratableInstance = fiber) : $dca0ddb82b882518$var$nextHydratableInstance = tag) : $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber ? $dca0ddb82b882518$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $dca0ddb82b882518$var$resetHydrationState() {
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber = null;
    $dca0ddb82b882518$var$isHydrating = !1;
}
function $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $dca0ddb82b882518$var$hydrationErrors;
    null !== queuedErrors && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = queuedErrors : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, queuedErrors), $dca0ddb82b882518$var$hydrationErrors = null);
    return queuedErrors;
}
function $dca0ddb82b882518$var$queueHydrationError(error) {
    null === $dca0ddb82b882518$var$hydrationErrors ? $dca0ddb82b882518$var$hydrationErrors = [
        error
    ] : $dca0ddb82b882518$var$hydrationErrors.push(error);
}
var $dca0ddb82b882518$var$valueCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$lastContextDependency = null;
function $dca0ddb82b882518$var$pushProvider(providerFiber, context, nextValue) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $dca0ddb82b882518$var$popProvider(context) {
    context._currentValue = $dca0ddb82b882518$var$valueCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$valueCursor);
}
function $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else 13 === fiber.tag && null !== fiber.memoizedState && null === fiber.memoizedState.dehydrated ? (fiber.lanes |= renderLanes, nextFiber = fiber.alternate, null !== nextFiber && (nextFiber.lanes |= renderLanes), $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, workInProgress), nextFiber = fiber.child, nextFiber = null !== nextFiber ? nextFiber.sibling : null) : nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $dca0ddb82b882518$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $dca0ddb82b882518$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($dca0ddb82b882518$var$HostTransitionContext) : current = [
                $dca0ddb82b882518$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
    return null !== current;
}
function $dca0ddb82b882518$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$dca0ddb82b882518$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $dca0ddb82b882518$var$prepareToReadContext(workInProgress) {
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = workInProgress;
    $dca0ddb82b882518$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $dca0ddb82b882518$var$readContext(context) {
    return $dca0ddb82b882518$var$readContextForConsumer($dca0ddb82b882518$var$currentlyRenderingFiber$1, context);
}
function $dca0ddb82b882518$var$readContextDuringReconciliation(consumer, context) {
    null === $dca0ddb82b882518$var$currentlyRenderingFiber$1 && $dca0ddb82b882518$var$prepareToReadContext(consumer);
    return $dca0ddb82b882518$var$readContextForConsumer(consumer, context);
}
function $dca0ddb82b882518$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $dca0ddb82b882518$var$lastContextDependency) {
        if (null === consumer) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(308));
        $dca0ddb82b882518$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$lastContextDependency.next = context;
    return value;
}
var $dca0ddb82b882518$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $dca0ddb82b882518$var$scheduleCallback$2 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$NormalPriority = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$CacheContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $dca0ddb82b882518$var$createCache() {
    return {
        controller: new $dca0ddb82b882518$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $dca0ddb82b882518$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $dca0ddb82b882518$var$scheduleCallback$2($dca0ddb82b882518$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
function $dca0ddb82b882518$var$queueTransitionTypes(root, transitionTypes) {
    if (0 !== (root.pendingLanes & 4194048)) {
        var queued = root.transitionTypes;
        null === queued && (queued = root.transitionTypes = []);
        for(root = 0; root < transitionTypes.length; root++){
            var transitionType = transitionTypes[root];
            -1 === queued.indexOf(transitionType) && queued.push(transitionType);
        }
    }
}
var $dca0ddb82b882518$var$entangledTransitionTypes = null;
function $dca0ddb82b882518$var$claimQueuedTransitionTypes(root) {
    var claimed = root.transitionTypes;
    root.transitionTypes = null;
    return claimed;
}
var $dca0ddb82b882518$var$currentEntangledListeners = null, $dca0ddb82b882518$var$currentEntangledPendingCount = 0, $dca0ddb82b882518$var$currentEntangledLane = 0, $dca0ddb82b882518$var$currentEntangledActionThenable = null;
function $dca0ddb82b882518$var$entangleAsyncAction(transition, thenable) {
    if (null === $dca0ddb82b882518$var$currentEntangledListeners) {
        var entangledListeners = $dca0ddb82b882518$var$currentEntangledListeners = [];
        $dca0ddb82b882518$var$currentEntangledPendingCount = 0;
        $dca0ddb82b882518$var$currentEntangledLane = $dca0ddb82b882518$var$requestTransitionLane();
        $dca0ddb82b882518$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $dca0ddb82b882518$var$currentEntangledPendingCount++;
    thenable.then($dca0ddb82b882518$var$pingEngtangledActionScope, $dca0ddb82b882518$var$pingEngtangledActionScope);
    return thenable;
}
function $dca0ddb82b882518$var$pingEngtangledActionScope() {
    if (0 === --$dca0ddb82b882518$var$currentEntangledPendingCount && ($dca0ddb82b882518$var$entangledTransitionTypes = null, null !== $dca0ddb82b882518$var$currentEntangledListeners)) {
        null !== $dca0ddb82b882518$var$currentEntangledActionThenable && ($dca0ddb82b882518$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $dca0ddb82b882518$var$currentEntangledListeners;
        $dca0ddb82b882518$var$currentEntangledListeners = null;
        $dca0ddb82b882518$var$currentEntangledLane = 0;
        $dca0ddb82b882518$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $dca0ddb82b882518$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $dca0ddb82b882518$var$prevOnStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
$dca0ddb82b882518$var$ReactSharedInternals.S = function(transition, returnValue) {
    $dca0ddb82b882518$var$globalMostRecentTransitionTime = $dca0ddb82b882518$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $dca0ddb82b882518$var$entangleAsyncAction(transition, returnValue);
    if (null !== $dca0ddb82b882518$var$entangledTransitionTypes) for(var root$28 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$28;)$dca0ddb82b882518$var$queueTransitionTypes(root$28, $dca0ddb82b882518$var$entangledTransitionTypes), root$28 = root$28.next;
    root$28 = transition.types;
    if (null !== root$28) {
        for(var root$29 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$29;)$dca0ddb82b882518$var$queueTransitionTypes(root$29, root$28), root$29 = root$29.next;
        if (0 !== $dca0ddb82b882518$var$currentEntangledLane) {
            root$29 = $dca0ddb82b882518$var$entangledTransitionTypes;
            null === root$29 && (root$29 = $dca0ddb82b882518$var$entangledTransitionTypes = []);
            for(var i = 0; i < root$28.length; i++){
                var transitionType = root$28[i];
                -1 === root$29.indexOf(transitionType) && root$29.push(transitionType);
            }
        }
    }
    null !== $dca0ddb82b882518$var$prevOnStartTransitionFinish && $dca0ddb82b882518$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $dca0ddb82b882518$var$resumedCache = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $dca0ddb82b882518$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $dca0ddb82b882518$var$workInProgressRoot.pooledCache;
}
function $dca0ddb82b882518$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, $dca0ddb82b882518$var$resumedCache.current) : $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, prevCachePool.pool);
}
function $dca0ddb82b882518$var$getSuspendedCache() {
    var cacheFromPool = $dca0ddb82b882518$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $dca0ddb82b882518$var$SuspenseException = Error($dca0ddb82b882518$var$formatProdErrorMessage(460)), $dca0ddb82b882518$var$SuspenseyCommitException = Error($dca0ddb82b882518$var$formatProdErrorMessage(474)), $dca0ddb82b882518$var$SuspenseActionException = Error($dca0ddb82b882518$var$formatProdErrorMessage(542)), $dca0ddb82b882518$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $dca0ddb82b882518$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $dca0ddb82b882518$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            thenableState = thenable.reason;
            $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState);
            if (void 0 === thenableState && !("reason" in thenable)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(600));
            throw thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1);
            else {
                thenableState = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $dca0ddb82b882518$var$suspendedThenable = thenable;
            throw $dca0ddb82b882518$var$SuspenseException;
    }
}
function $dca0ddb82b882518$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $dca0ddb82b882518$var$suspendedThenable = x, $dca0ddb82b882518$var$SuspenseException;
        throw x;
    }
}
var $dca0ddb82b882518$var$suspendedThenable = null;
function $dca0ddb82b882518$var$getSuspendedThenable() {
    if (null === $dca0ddb82b882518$var$suspendedThenable) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(459));
    var thenable = $dca0ddb82b882518$var$suspendedThenable;
    $dca0ddb82b882518$var$suspendedThenable = null;
    return thenable;
}
function $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $dca0ddb82b882518$var$SuspenseException || rejectedReason === $dca0ddb82b882518$var$SuspenseActionException) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(483));
}
var $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
function $dca0ddb82b882518$var$unwrapThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter$1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 += 1;
    null === $dca0ddb82b882518$var$thenableState$1 && ($dca0ddb82b882518$var$thenableState$1 = []);
    return $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState$1, thenable, index);
}
function $dca0ddb82b882518$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $dca0ddb82b882518$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null === currentFirstChild.key ? existingChildren.set(currentFirstChild.index, currentFirstChild) : existingChildren.set(currentFirstChild.key, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $dca0ddb82b882518$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 2, lastPlacedIndex) : newIndex;
        newFiber.flags |= 134217730;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 134217730);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) return returnFiber = updateFragment(returnFiber, current, element.props.children, lanes, element.key), $dca0ddb82b882518$var$coerceRef(returnFiber, element), returnFiber;
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $dca0ddb82b882518$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $dca0ddb82b882518$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $dca0ddb82b882518$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $dca0ddb82b882518$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return newChild = $dca0ddb82b882518$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && (newFiber = nextOldFiber.alternate, null !== newFiber && oldFiber.delete(null === newFiber.key ? newIdx : newFiber.key)), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && (nextOldFiber = step.alternate, null !== nextOldFiber && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key)), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE && null === newChild.key && void 0 === newChild.props.ref && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE ? (lanes = $dca0ddb82b882518$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($dca0ddb82b882518$var$getIteratorFn(newChild)) {
                key = $dca0ddb82b882518$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $dca0ddb82b882518$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $dca0ddb82b882518$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $dca0ddb82b882518$var$SuspenseException || x === $dca0ddb82b882518$var$SuspenseActionException) throw x;
            var fiber = $dca0ddb82b882518$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $dca0ddb82b882518$var$reconcileChildFibers = $dca0ddb82b882518$var$createChildReconciler(!0), $dca0ddb82b882518$var$mountChildFibers = $dca0ddb82b882518$var$createChildReconciler(!1), $dca0ddb82b882518$var$hasForceUpdate = !1;
function $dca0ddb82b882518$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $dca0ddb82b882518$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $dca0ddb82b882518$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
        $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
function $dca0ddb82b882518$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
function $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $dca0ddb82b882518$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $dca0ddb82b882518$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $dca0ddb82b882518$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $dca0ddb82b882518$var$currentEntangledLane && ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $dca0ddb82b882518$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $dca0ddb82b882518$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $dca0ddb82b882518$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $dca0ddb82b882518$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$dca0ddb82b882518$var$callCallback(callbacks[updateQueue], context);
}
var $dca0ddb82b882518$var$currentTreeHiddenStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$prevEntangledRenderLanesCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushHiddenContext(fiber, context) {
    fiber = $dca0ddb82b882518$var$entangledRenderLanes;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, context);
    $dca0ddb82b882518$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $dca0ddb82b882518$var$reuseHiddenContextOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, $dca0ddb82b882518$var$entangledRenderLanes);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current);
}
function $dca0ddb82b882518$var$popHiddenContext() {
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$prevEntangledRenderLanesCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$currentTreeHiddenStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$prevEntangledRenderLanesCursor);
}
var $dca0ddb82b882518$var$suspenseHandlerStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$shellBoundary = null;
function $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, handler);
    null === $dca0ddb82b882518$var$shellBoundary && (null === current || null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current ? $dca0ddb82b882518$var$shellBoundary = handler : null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = handler));
}
function $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber);
    null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber);
}
function $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber), null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber)) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack();
}
function $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
}
function $dca0ddb82b882518$var$popSuspenseHandler(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
}
var $dca0ddb82b882518$var$suspenseStackCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushSuspenseListContext(fiber, newContext) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, newContext);
}
function $dca0ddb82b882518$var$popSuspenseListContext(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
}
function $dca0ddb82b882518$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $dca0ddb82b882518$var$isSuspenseInstancePending(state) || $dca0ddb82b882518$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && "independent" !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$renderLanes = 0, $dca0ddb82b882518$var$currentlyRenderingFiber = null, $dca0ddb82b882518$var$currentHook = null, $dca0ddb82b882518$var$workInProgressHook = null, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $dca0ddb82b882518$var$localIdCounter = 0, $dca0ddb82b882518$var$thenableIndexCounter = 0, $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$globalClientIdCounter = 0;
function $dca0ddb82b882518$var$throwInvalidHookError() {
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(321));
}
function $dca0ddb82b882518$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$dca0ddb82b882518$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $dca0ddb82b882518$var$renderLanes = nextRenderLanes;
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $dca0ddb82b882518$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate;
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $dca0ddb82b882518$var$finishRenderingHooks(current) {
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $dca0ddb82b882518$var$currentHook && null !== $dca0ddb82b882518$var$currentHook.next;
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(300));
    null === current || $dca0ddb82b882518$var$didReceiveUpdate || (current = current.dependencies, null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) && ($dca0ddb82b882518$var$didReceiveUpdate = !0));
}
function $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && ($dca0ddb82b882518$var$thenableState = null);
        $dca0ddb82b882518$var$thenableIndexCounter = 0;
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $dca0ddb82b882518$var$TransitionAwareHostComponent() {
    var dispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $dca0ddb82b882518$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$currentHook.memoizedState : null) !== dispatcher && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $dca0ddb82b882518$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $dca0ddb82b882518$var$localIdCounter;
    $dca0ddb82b882518$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $dca0ddb82b882518$var$resetHooksOnUnwind(workInProgress) {
    if ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    }
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = $dca0ddb82b882518$var$localIdCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
}
function $dca0ddb82b882518$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = hook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = hook;
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$updateWorkInProgressHook() {
    if (null === $dca0ddb82b882518$var$currentHook) {
        var nextCurrentHook = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $dca0ddb82b882518$var$currentHook.next;
    var nextWorkInProgressHook = null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $dca0ddb82b882518$var$workInProgressHook = nextWorkInProgressHook, $dca0ddb82b882518$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $dca0ddb82b882518$var$currentlyRenderingFiber.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(467));
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(310));
        }
        $dca0ddb82b882518$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $dca0ddb82b882518$var$currentHook.memoizedState,
            baseState: $dca0ddb82b882518$var$currentHook.baseState,
            baseQueue: $dca0ddb82b882518$var$currentHook.baseQueue,
            queue: $dca0ddb82b882518$var$currentHook.queue,
            next: null
        };
        null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = nextCurrentHook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = nextCurrentHook;
    }
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $dca0ddb82b882518$var$useThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter;
    $dca0ddb82b882518$var$thenableIndexCounter += 1;
    null === $dca0ddb82b882518$var$thenableState && ($dca0ddb82b882518$var$thenableState = []);
    thenable = $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState, thenable, index);
    index = $dca0ddb82b882518$var$currentlyRenderingFiber;
    null === (null === $dca0ddb82b882518$var$workInProgressHook ? index.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next) && (index = index.alternate, $dca0ddb82b882518$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $dca0ddb82b882518$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $dca0ddb82b882518$var$useThenable(usable);
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_RECOVERABLE_TYPE) return;
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return $dca0ddb82b882518$var$readContext(usable);
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(438, String(usable)));
}
function $dca0ddb82b882518$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $dca0ddb82b882518$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $dca0ddb82b882518$var$updateReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, reducer);
}
function $dca0ddb82b882518$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$64 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($dca0ddb82b882518$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$64 = !0);
                else if (($dca0ddb82b882518$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$64 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= revertLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= updateLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$dca0ddb82b882518$var$objectIs(pendingQueue, hook.memoizedState) && ($dca0ddb82b882518$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$64 && (reducer = $dca0ddb82b882518$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $dca0ddb82b882518$var$rerenderReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $dca0ddb82b882518$var$objectIs(newState, hook.memoizedState) || ($dca0ddb82b882518$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $dca0ddb82b882518$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $dca0ddb82b882518$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$dca0ddb82b882518$var$objectIs(($dca0ddb82b882518$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $dca0ddb82b882518$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $dca0ddb82b882518$var$updateEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    subscribe = hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $dca0ddb82b882518$var$workInProgressHook && 0 !== ($dca0ddb82b882518$var$workInProgressHook.memoizedState.tag & 1);
    $dca0ddb82b882518$var$pushSimpleEffect(subscribe ? 9 : 8, {
        destroy: void 0
    }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
    if (subscribe) {
        fiber.flags |= 2048;
        if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($dca0ddb82b882518$var$renderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $dca0ddb82b882518$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
}
function $dca0ddb82b882518$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
    });
}
function $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$dca0ddb82b882518$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $dca0ddb82b882518$var$forceStoreRerender(fiber) {
    var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $dca0ddb82b882518$var$mountStateImpl(initialState) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $dca0ddb82b882518$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, "function" === typeof reducer ? reducer : $dca0ddb82b882518$var$basicStateReducer);
}
function $dca0ddb82b882518$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $dca0ddb82b882518$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $dca0ddb82b882518$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
        currentTransition.types = null !== prevTransition ? prevTransition.types : null;
        $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$70) {
        $dca0ddb82b882518$var$onActionError(actionQueue, node, error$70);
    }
}
function $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
    }) : $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, returnValue);
}
function $dca0ddb82b882518$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $dca0ddb82b882518$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $dca0ddb82b882518$var$runActionStateAction(actionQueue, nextState)));
}
function $dca0ddb82b882518$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $dca0ddb82b882518$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $dca0ddb82b882518$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $dca0ddb82b882518$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $dca0ddb82b882518$var$mountActionState(action, initialStateProp) {
    if ($dca0ddb82b882518$var$isHydrating) {
        var ssrFormState = $dca0ddb82b882518$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $dca0ddb82b882518$var$currentlyRenderingFiber;
                if ($dca0ddb82b882518$var$isHydrating) {
                    if ($dca0ddb82b882518$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $dca0ddb82b882518$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $dca0ddb82b882518$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountStateImpl(!1);
    inRootOrSingleton = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $dca0ddb82b882518$var$dispatchActionState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $dca0ddb82b882518$var$updateActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, $dca0ddb82b882518$var$currentHook, action);
}
function $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $dca0ddb82b882518$var$updateReducerImpl(stateHook, currentStateHook, $dca0ddb82b882518$var$actionStateReducer)[0];
    stateHook = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $dca0ddb82b882518$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $dca0ddb82b882518$var$SuspenseException) throw $dca0ddb82b882518$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 2048, $dca0ddb82b882518$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $dca0ddb82b882518$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $dca0ddb82b882518$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $dca0ddb82b882518$var$rerenderActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook(), currentStateHook = $dca0ddb82b882518$var$currentHook;
    if (null !== currentStateHook) return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $dca0ddb82b882518$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $dca0ddb82b882518$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $dca0ddb82b882518$var$updateRef() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $dca0ddb82b882518$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $dca0ddb82b882518$var$currentHook && null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, $dca0ddb82b882518$var$currentHook.memoizedState.deps) ? hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $dca0ddb82b882518$var$mountEffect(create, deps) {
    $dca0ddb82b882518$var$mountEffectImpl(8390656, 8, create, deps);
}
function $dca0ddb82b882518$var$updateEffect(create, deps) {
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, deps);
}
function $dca0ddb82b882518$var$useEffectEventImpl(payload) {
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $dca0ddb82b882518$var$updateEvent(callback) {
    var ref = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
    $dca0ddb82b882518$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $dca0ddb82b882518$var$updateInsertionEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 2, create, deps);
}
function $dca0ddb82b882518$var$updateLayoutEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 4, create, deps);
}
function $dca0ddb82b882518$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $dca0ddb82b882518$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $dca0ddb82b882518$var$updateEffectImpl(4, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $dca0ddb82b882518$var$mountDebugValue() {}
function $dca0ddb82b882518$var$updateCallback(callback, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $dca0ddb82b882518$var$updateMemo(nextCreate, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $dca0ddb82b882518$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($dca0ddb82b882518$var$objectIs(value, prevValue)) return value;
    if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return hook = $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue), $dca0ddb82b882518$var$objectIs(hook, prevValue) || ($dca0ddb82b882518$var$didReceiveUpdate = !0), hook;
    if (0 === ($dca0ddb82b882518$var$renderLanes & 106) || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return $dca0ddb82b882518$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $dca0ddb82b882518$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
    currentTransition.types = null !== prevTransition ? prevTransition.types : null;
    $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
    $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $dca0ddb82b882518$var$chainThenableValue(returnValue, finishedState);
            $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
        } else $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, finishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
    } catch (error) {
        $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $dca0ddb82b882518$var$requestUpdateLane());
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$noop() {}
function $dca0ddb82b882518$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(476));
    var queue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).queue;
    $dca0ddb82b882518$var$startTransition(formFiber, queue, pendingState, $dca0ddb82b882518$var$sharedNotPendingObject, null === action ? $dca0ddb82b882518$var$noop : function() {
        $dca0ddb82b882518$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: $dca0ddb82b882518$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $dca0ddb82b882518$var$requestFormReset$1(formFiber) {
    var stateHook = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $dca0ddb82b882518$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $dca0ddb82b882518$var$requestUpdateLane());
}
function $dca0ddb82b882518$var$useHostTransitionStatus() {
    return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$HostTransitionContext);
}
function $dca0ddb82b882518$var$updateId() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$updateRefresh() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $dca0ddb82b882518$var$requestUpdateLane();
                fiber = $dca0ddb82b882518$var$createUpdate(lane);
                var root$73 = $dca0ddb82b882518$var$enqueueUpdate(provider, fiber, lane);
                null !== root$73 && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(root$73, provider, lane), $dca0ddb82b882518$var$entangleTransitions(root$73, provider, lane));
                provider = {
                    cache: $dca0ddb82b882518$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $dca0ddb82b882518$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) ? $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, action) : (action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane)));
}
function $dca0ddb82b882518$var$dispatchSetState(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($dca0ddb82b882518$var$objectIs(eagerState, currentState)) return $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, 0), null === $dca0ddb82b882518$var$workInProgressRoot && $dca0ddb82b882518$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $dca0ddb82b882518$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $dca0ddb82b882518$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $dca0ddb82b882518$var$currentlyRenderingFiber || null !== alternate && alternate === $dca0ddb82b882518$var$currentlyRenderingFiber;
}
function $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update) {
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $dca0ddb82b882518$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
var $dca0ddb82b882518$var$ContextOnlyDispatcher = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$throwInvalidHookError,
    useContext: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useImperativeHandle: $dca0ddb82b882518$var$throwInvalidHookError,
    useLayoutEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useInsertionEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemo: $dca0ddb82b882518$var$throwInvalidHookError,
    useReducer: $dca0ddb82b882518$var$throwInvalidHookError,
    useRef: $dca0ddb82b882518$var$throwInvalidHookError,
    useState: $dca0ddb82b882518$var$throwInvalidHookError,
    useDebugValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useDeferredValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useTransition: $dca0ddb82b882518$var$throwInvalidHookError,
    useSyncExternalStore: $dca0ddb82b882518$var$throwInvalidHookError,
    useId: $dca0ddb82b882518$var$throwInvalidHookError,
    useHostTransitionStatus: $dca0ddb82b882518$var$throwInvalidHookError,
    useFormState: $dca0ddb82b882518$var$throwInvalidHookError,
    useActionState: $dca0ddb82b882518$var$throwInvalidHookError,
    useOptimistic: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemoCache: $dca0ddb82b882518$var$throwInvalidHookError,
    useCacheRefresh: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffectEvent: $dca0ddb82b882518$var$throwInvalidHookError
}, $dca0ddb82b882518$var$HooksDispatcherOnMount = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: function(callback, deps) {
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $dca0ddb82b882518$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $dca0ddb82b882518$var$dispatchReducerAction.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $dca0ddb82b882518$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        return $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $dca0ddb82b882518$var$mountStateImpl(!1);
        stateHook = $dca0ddb82b882518$var$startTransition.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if ($dca0ddb82b882518$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
            0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $dca0ddb82b882518$var$mountEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), identifierPrefix = $dca0ddb82b882518$var$workInProgressRoot.identifierPrefix;
        if ($dca0ddb82b882518$var$isHydrating) {
            var JSCompiler_inline_result = $dca0ddb82b882518$var$treeContextOverflow;
            var idWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $dca0ddb82b882518$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $dca0ddb82b882518$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $dca0ddb82b882518$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$mountActionState,
    useActionState: $dca0ddb82b882518$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: function() {
        return $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = $dca0ddb82b882518$var$refreshCache.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $dca0ddb82b882518$var$HooksDispatcherOnUpdate = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$updateReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$updateActionState,
    useActionState: $dca0ddb82b882518$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh,
    useEffectEvent: $dca0ddb82b882518$var$updateEvent
}, $dca0ddb82b882518$var$HooksDispatcherOnRerender = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$rerenderReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return null === $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) : $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$rerenderActionState,
    useActionState: $dca0ddb82b882518$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        if (null !== $dca0ddb82b882518$var$currentHook) return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh,
    useEffectEvent: $dca0ddb82b882518$var$updateEvent
};
function $dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $dca0ddb82b882518$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $dca0ddb82b882518$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(callback, inst, lane), $dca0ddb82b882518$var$entangleTransitions(callback, inst, lane));
    }
};
function $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$dca0ddb82b882518$var$shallowEqual(oldProps, newProps) || !$dca0ddb82b882518$var$shallowEqual(oldState, newState) : !0;
}
function $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $dca0ddb82b882518$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $dca0ddb82b882518$var$assign({}, newProps));
        for(var propName$77 in Component)void 0 === newProps[propName$77] && (newProps[propName$77] = Component[propName$77]);
    }
    return newProps;
}
function $dca0ddb82b882518$var$defaultOnUncaughtError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $dca0ddb82b882518$var$defaultOnRecoverableError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$78) {
        setTimeout(function() {
            throw e$78;
        });
    }
}
function $dca0ddb82b882518$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$79) {
        setTimeout(function() {
            throw e$79;
        });
    }
}
function $dca0ddb82b882518$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $dca0ddb82b882518$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $dca0ddb82b882518$var$createClassErrorUpdate(lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $dca0ddb82b882518$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed ? $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $dca0ddb82b882518$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $dca0ddb82b882518$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                case 19:
                    return null === $dca0ddb82b882518$var$shellBoundary ? $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes);
        $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($dca0ddb82b882518$var$isHydrating) return returnFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $dca0ddb82b882518$var$HydrationMismatchException && (root = Error($dca0ddb82b882518$var$formatProdErrorMessage(422), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $dca0ddb82b882518$var$HydrationMismatchException && (returnFiber = Error($dca0ddb82b882518$var$formatProdErrorMessage(423), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $dca0ddb82b882518$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $dca0ddb82b882518$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($dca0ddb82b882518$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $dca0ddb82b882518$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $dca0ddb82b882518$var$workInProgressRootConcurrentErrors ? $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $dca0ddb82b882518$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $dca0ddb82b882518$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                returnFiber = sourceFiber.type;
                wrapperError = sourceFiber.stateNode;
                if (0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $dca0ddb82b882518$var$createClassErrorUpdate(rootRenderLanes), $dca0ddb82b882518$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
                break;
            case 22:
                if (null !== sourceFiber.memoizedState) return sourceFiber.flags |= 65536, !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $dca0ddb82b882518$var$SelectiveHydrationException = Error($dca0ddb82b882518$var$formatProdErrorMessage(461)), $dca0ddb82b882518$var$didReceiveUpdate = !1;
function $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    nextProps = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && key && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$dca0ddb82b882518$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $dca0ddb82b882518$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $dca0ddb82b882518$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($dca0ddb82b882518$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($dca0ddb82b882518$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($dca0ddb82b882518$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState) : $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($dca0ddb82b882518$var$pushTransition(workInProgress, prevState.cachePool), $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(), workInProgress.memoizedState = null) : (null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null), $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack());
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $dca0ddb82b882518$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null);
    $dca0ddb82b882518$var$reuseHiddenContextOnStack();
    $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, current.memoizedState = {
                baseLanes: 0,
                cachePool: null
            }, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, current);
            $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || didSuspend) {
            if (null === $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) {
                nextProps = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== nextProps && (dehydrated = $dca0ddb82b882518$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, dehydrated), $dca0ddb82b882518$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $dca0ddb82b882518$var$SelectiveHydrationException;
                $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            }
            workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(dehydrated.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 134221824;
        return workInProgress;
    }
    current = $dca0ddb82b882518$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $dca0ddb82b882518$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    Component = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && nextProps && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    Component = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && Component && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $dca0ddb82b882518$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $dca0ddb82b882518$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $dca0ddb82b882518$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $dca0ddb82b882518$var$readContext(contextType) : $dca0ddb82b882518$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $dca0ddb82b882518$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $dca0ddb82b882518$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $dca0ddb82b882518$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $dca0ddb82b882518$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $dca0ddb82b882518$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $dca0ddb82b882518$var$hasForceUpdate || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $dca0ddb82b882518$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $dca0ddb82b882518$var$resetHydrationState();
    workInProgress.flags |= 256;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $dca0ddb82b882518$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $dca0ddb82b882518$var$getSuspendedCache()
    };
}
function $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $dca0ddb82b882518$var$workInProgressDeferredLane);
    return current;
}
function $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($dca0ddb82b882518$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            showFallback ? $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack();
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            $dca0ddb82b882518$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        didSuspend = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(), showFallback = workInProgress.mode, didSuspend = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: didSuspend
        }, showFallback), nextProps = $dca0ddb82b882518$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), didSuspend.return = workInProgress, nextProps.return = workInProgress, didSuspend.sibling = nextProps, workInProgress.child = didSuspend, nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps);
        $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, didSuspend);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated$96 = prevState.dehydrated;
        if (null !== dehydrated$96) return $dca0ddb82b882518$var$updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, JSCompiler_temp, nextProps, dehydrated$96, prevState, renderLanes);
    }
    if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(), showFallback = nextProps.fallback, didSuspend = workInProgress.mode, prevState = current.child, dehydrated$96 = prevState.sibling, nextProps = $dca0ddb82b882518$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 1206910976, null !== dehydrated$96 ? showFallback = $dca0ddb82b882518$var$createWorkInProgress(dehydrated$96, showFallback) : (showFallback = $dca0ddb82b882518$var$createFiberFromFragment(showFallback, didSuspend, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, showFallback = current.child.memoizedState, null === showFallback ? showFallback = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) : (didSuspend = showFallback.cachePool, null !== didSuspend ? (prevState = $dca0ddb82b882518$var$CacheContext._currentValue, didSuspend = didSuspend.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : didSuspend) : didSuspend = $dca0ddb82b882518$var$getSuspendedCache(), showFallback = {
        baseLanes: showFallback.baseLanes | renderLanes,
        cachePool: didSuspend
    }), nextProps.memoizedState = showFallback, nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(current.child, nextProps);
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $dca0ddb82b882518$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $dca0ddb82b882518$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, didPrimaryChildrenDefer, nextProps, suspenseInstance, suspenseState, renderLanes) {
    if (didSuspend) {
        if (workInProgress.flags & 256) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        if (null !== workInProgress.memoizedState) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(), workInProgress.child = current.child, workInProgress.flags |= 128, null;
        $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack();
        suspenseInstance = nextProps.fallback;
        suspenseState = workInProgress.mode;
        nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, suspenseState);
        suspenseInstance = $dca0ddb82b882518$var$createFiberFromFragment(suspenseInstance, suspenseState, renderLanes, null);
        suspenseInstance.flags |= 2;
        nextProps.return = workInProgress;
        suspenseInstance.return = workInProgress;
        nextProps.sibling = suspenseInstance;
        workInProgress.child = nextProps;
        $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        nextProps = workInProgress.child;
        nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes);
        nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, didPrimaryChildrenDefer, renderLanes);
        workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER;
        return $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps);
    }
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    if ($dca0ddb82b882518$var$isSuspenseInstanceFallback(suspenseInstance)) {
        didPrimaryChildrenDefer = suspenseInstance.nextSibling && suspenseInstance.nextSibling.dataset;
        if (didPrimaryChildrenDefer) var digest = didPrimaryChildrenDefer.dgst;
        didPrimaryChildrenDefer = digest;
        "" !== didPrimaryChildrenDefer && (nextProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(419)), nextProps.stack = "", nextProps.digest = didPrimaryChildrenDefer, $dca0ddb82b882518$var$queueHydrationError({
            value: nextProps,
            source: null,
            stack: null
        }));
        return $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
    }
    $dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1);
    didPrimaryChildrenDefer = 0 !== (renderLanes & current.childLanes);
    if ($dca0ddb82b882518$var$didReceiveUpdate || didPrimaryChildrenDefer) {
        if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        didPrimaryChildrenDefer = $dca0ddb82b882518$var$workInProgressRoot;
        if (null !== didPrimaryChildrenDefer && (nextProps = $dca0ddb82b882518$var$getBumpedLaneForHydration(didPrimaryChildrenDefer, renderLanes), 0 !== nextProps && nextProps !== suspenseState.retryLane)) throw suspenseState.retryLane = nextProps, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, nextProps), $dca0ddb82b882518$var$scheduleUpdateOnFiber(didPrimaryChildrenDefer, current, nextProps), $dca0ddb82b882518$var$SelectiveHydrationException;
        $dca0ddb82b882518$var$isSuspenseInstancePending(suspenseInstance) || $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
    }
    if ($dca0ddb82b882518$var$isSuspenseInstancePending(suspenseInstance)) return workInProgress.flags |= 192, workInProgress.child = current.child, null;
    current = suspenseState.treeContext;
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(suspenseInstance.nextSibling);
    $dca0ddb82b882518$var$hydrationParentFiber = workInProgress;
    $dca0ddb82b882518$var$isHydrating = !0;
    $dca0ddb82b882518$var$hydrationErrors = null;
    $dca0ddb82b882518$var$rootOrSingletonContext = !1;
    null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current);
    workInProgress = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children);
    workInProgress.flags |= 134221824;
    return workInProgress;
}
function $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $dca0ddb82b882518$var$findLastContentRow(firstChild) {
    for(var lastContentRow = null; null !== firstChild;){
        var currentRow = firstChild.alternate;
        null !== currentRow && null === $dca0ddb82b882518$var$findFirstSuspended(currentRow) && (lastContentRow = firstChild);
        firstChild = firstChild.sibling;
    }
    return lastContentRow;
}
function $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $dca0ddb82b882518$var$reverseChildren(fiber) {
    var row = fiber.child;
    for(fiber.child = null; null !== row;){
        var nextRow = row.sibling;
        row.sibling = fiber.child;
        fiber.child = row;
        row = nextRow;
    }
}
function $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $dca0ddb82b882518$var$suspenseStackCursor.current;
    if (workInProgress.flags & 128) return $dca0ddb82b882518$var$pushSuspenseListContext(workInProgress, suspenseContext), null;
    var shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $dca0ddb82b882518$var$pushSuspenseListContext(workInProgress, suspenseContext);
    "backwards" === revealOrder && null !== current ? ($dca0ddb82b882518$var$reverseChildren(current), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes), $dca0ddb82b882518$var$reverseChildren(current)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "backwards":
            renderLanes = $dca0ddb82b882518$var$findLastContentRow(workInProgress.child);
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null, $dca0ddb82b882518$var$reverseChildren(workInProgress));
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, revealOrder, null, tailMode, nextProps);
            break;
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        case "independent":
            workInProgress.memoizedState = null;
            break;
        default:
            renderLanes = $dca0ddb82b882518$var$findLastContentRow(workInProgress.child), null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null), $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateContextProvider(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, newProps.value);
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, newProps.children, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) ? !0 : !1;
}
function $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
            $dca0ddb82b882518$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            break;
        case 4:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$108 = workInProgress.memoizedState;
            if (null !== state$108) {
                if (null !== state$108.dehydrated) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                state$108 = $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1);
                var primaryChildLanes = workInProgress.child.childLanes;
                if (state$108 || 0 !== (renderLanes & primaryChildLanes)) return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            if (workInProgress.flags & 128) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
            primaryChildLanes = 0 !== (current.flags & 128);
            state$108 = 0 !== (renderLanes & workInProgress.childLanes);
            state$108 || ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$108 = 0 !== (renderLanes & workInProgress.childLanes));
            if (primaryChildLanes) {
                if (state$108) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            primaryChildLanes = workInProgress.memoizedState;
            null !== primaryChildLanes && (primaryChildLanes.rendering = null, primaryChildLanes.tail = null, primaryChildLanes.lastEffect = null);
            $dca0ddb82b882518$var$pushSuspenseListContext(workInProgress, $dca0ddb82b882518$var$suspenseStackCursor.current);
            if (state$108) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
    }
    return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $dca0ddb82b882518$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $dca0ddb82b882518$var$didReceiveUpdate = !0;
        else {
            if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $dca0ddb82b882518$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $dca0ddb82b882518$var$pushTreeId(workInProgress, $dca0ddb82b882518$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $dca0ddb82b882518$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $dca0ddb82b882518$var$shouldConstruct(current) ? (props = $dca0ddb82b882518$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $dca0ddb82b882518$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $dca0ddb82b882518$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $dca0ddb82b882518$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $dca0ddb82b882518$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $dca0ddb82b882518$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) {
                            workInProgress.tag = 10;
                            workInProgress.type = current;
                            workInProgress = $dca0ddb82b882518$var$updateContextProvider(null, workInProgress, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $dca0ddb82b882518$var$getComponentNameFromType(current) || current;
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $dca0ddb82b882518$var$resolveClassComponentProps(props, workInProgress.pendingProps), $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
                $dca0ddb82b882518$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props);
                props !== prevState.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                    $dca0ddb82b882518$var$CacheContext
                ], renderLanes, !0);
                $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $dca0ddb82b882518$var$createCapturedValueAtFiber(Error($dca0ddb82b882518$var$formatProdErrorMessage(424)), workInProgress);
                        $dca0ddb82b882518$var$queueHydrationError($$typeof);
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(current.firstChild);
                        $dca0ddb82b882518$var$hydrationParentFiber = workInProgress;
                        $dca0ddb82b882518$var$isHydrating = !0;
                        $dca0ddb82b882518$var$hydrationErrors = null;
                        $dca0ddb82b882518$var$rootOrSingletonContext = !0;
                        renderLanes = $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 134221824, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $dca0ddb82b882518$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $dca0ddb82b882518$var$markRef(current, workInProgress), null === current ? (renderLanes = $dca0ddb82b882518$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $dca0ddb82b882518$var$isHydrating || (workInProgress.stateNode = $dca0ddb82b882518$var$createHoistableInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current, workInProgress)) : workInProgress.memoizedState = $dca0ddb82b882518$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $dca0ddb82b882518$var$pushHostContext(workInProgress), null === current && $dca0ddb82b882518$var$isHydrating && (props = workInProgress.stateNode = $dca0ddb82b882518$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$rootOrSingletonContext = !0, $$typeof = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(workInProgress.type) ? ($dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild)) : $dca0ddb82b882518$var$nextHydratableInstance = $$typeof), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $dca0ddb82b882518$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if ($$typeof = props = $dca0ddb82b882518$var$nextHydratableInstance) props = $dca0ddb82b882518$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild), $dca0ddb82b882518$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $dca0ddb82b882518$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $dca0ddb82b882518$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, $dca0ddb82b882518$var$TransitionAwareHostComponent, null, null, renderLanes), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $$typeof);
            $dca0ddb82b882518$var$markRef(current, workInProgress);
            $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (current = renderLanes = $dca0ddb82b882518$var$nextHydratableInstance) renderLanes = $dca0ddb82b882518$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return props = workInProgress.pendingProps, $dca0ddb82b882518$var$markRef(current, workInProgress), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 8:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return $dca0ddb82b882518$var$updateContextProvider(current, workInProgress, renderLanes);
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $dca0ddb82b882518$var$prepareToReadContext(workInProgress), $$typeof = $dca0ddb82b882518$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $dca0ddb82b882518$var$prepareToReadContext(workInProgress), props = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), null === current ? ($$typeof = $dca0ddb82b882518$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $dca0ddb82b882518$var$workInProgressRoot, prevState = $dca0ddb82b882518$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, null, null, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props)) : (props = prevState.cache, $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props), props !== $$typeof.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                $dca0ddb82b882518$var$CacheContext
            ], renderLanes, !0))), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 30:
            return null === workInProgress.stateNode && (workInProgress.stateNode = {
                autoName: null,
                paired: null,
                clones: null,
                ref: null
            }), props = workInProgress.pendingProps, null != props.name && "auto" !== props.name ? workInProgress.flags |= null === current ? 18882560 : 18874368 : $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress), null !== current && current.memoizedProps.name !== props.name ? workInProgress.flags |= 4194816 : $dca0ddb82b882518$var$markRef(current, workInProgress), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    var JSCompiler_temp;
    if (JSCompiler_temp = 0 !== (workInProgress.mode & 32)) JSCompiler_temp = null === oldProps ? $dca0ddb82b882518$var$maySuspendCommit(type, newProps) : $dca0ddb82b882518$var$maySuspendCommit(type, newProps) && (newProps.src !== oldProps.src || newProps.srcSet !== oldProps.srcSet);
    if (JSCompiler_temp) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$dca0ddb82b882518$var$preloadResource(resource)) {
        if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
    }
}
function $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $dca0ddb82b882518$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $dca0ddb82b882518$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$dca0ddb82b882518$var$isHydrating) switch(renderState.tailMode){
        case "visible":
            break;
        case "collapsed":
            for(var tailNode = renderState.tail, lastTailNode = null; null !== tailNode;)null !== tailNode.alternate && (lastTailNode = tailNode), tailNode = tailNode.sibling;
            null === lastTailNode ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode.sibling = null;
            break;
        default:
            hasRenderedATailFallback = renderState.tail;
            for(tailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (tailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === tailNode ? renderState.tail = null : tailNode.sibling = null;
    }
}
function $dca0ddb82b882518$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$113 = completedWork.child; null !== child$113;)newChildLanes |= child$113.lanes | child$113.childLanes, subtreeFlags |= child$113.subtreeFlags & 1206910976, subtreeFlags |= child$113.flags & 1206910976, child$113.return = completedWork, child$113 = child$113.sibling;
    else for(child$113 = completedWork.child; null !== child$113;)newChildLanes |= child$113.lanes | child$113.childLanes, subtreeFlags |= child$113.subtreeFlags, subtreeFlags |= child$113.flags, child$113.return = completedWork, child$113 = child$113.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $dca0ddb82b882518$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 1:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable());
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($dca0ddb82b882518$var$markUpdate(workInProgress), null !== nextResource ? ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    workInProgress.subtreeFlags &= -33554433;
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $dca0ddb82b882518$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $dca0ddb82b882518$var$markUpdate(workInProgress));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            workInProgress.subtreeFlags &= -33554433;
            return null;
        case 5:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    workInProgress.subtreeFlags &= -33554433;
                    return null;
                }
                nextResource = $dca0ddb82b882518$var$contextStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    nextResource[$dca0ddb82b882518$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($dca0ddb82b882518$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
                }
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            workInProgress.subtreeFlags &= -33554433;
            $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                current = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $dca0ddb82b882518$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(557));
                        current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
                        type[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null === current && $dca0ddb82b882518$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), workInProgress.flags |= 67108864, $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 19:
            $dca0ddb82b882518$var$popSuspenseListContext(workInProgress);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $dca0ddb82b882518$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $dca0ddb82b882518$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$dca0ddb82b882518$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $dca0ddb82b882518$var$pushSuspenseListContext(workInProgress, $dca0ddb82b882518$var$suspenseStackCursor.current & 1 | 2);
                            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $dca0ddb82b882518$var$now() > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $dca0ddb82b882518$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current), $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "collapsed" !== newProps.tailMode && "visible" !== newProps.tailMode && !nextResource.alternate && !$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
                    } else 2 * $dca0ddb82b882518$var$now() - newProps.renderingStartTime > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) {
                current = newProps.tail;
                a: {
                    for(renderLanes = current; null !== renderLanes;){
                        if (null !== renderLanes.alternate) {
                            renderLanes = !1;
                            break a;
                        }
                        renderLanes = renderLanes.sibling;
                    }
                    renderLanes = !0;
                }
                newProps.rendering = current;
                newProps.tail = current.sibling;
                newProps.renderingStartTime = $dca0ddb82b882518$var$now();
                current.sibling = null;
                nextResource = $dca0ddb82b882518$var$suspenseStackCursor.current;
                nextResource = type ? nextResource & 1 | 2 : nextResource & 1;
                "visible" === newProps.tailMode || "collapsed" === newProps.tailMode || !renderLanes || $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$pushSuspenseListContext(workInProgress, nextResource) : (renderLanes = nextResource, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, workInProgress), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, renderLanes), null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = workInProgress));
                $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                return current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $dca0ddb82b882518$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return workInProgress.flags |= 33554432, $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$unwindWork(current, workInProgress) {
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $dca0ddb82b882518$var$popSuspenseListContext(workInProgress), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, current = workInProgress.memoizedState, null !== current && (current.rendering = null, current.tail = null), workInProgress.flags |= 4, workInProgress) : null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$unwindInterruptedWork(current, interruptedWork) {
    $dca0ddb82b882518$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $dca0ddb82b882518$var$popHostContext(interruptedWork);
            break;
        case 4:
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $dca0ddb82b882518$var$popSuspenseListContext(interruptedWork);
            break;
        case 10:
            $dca0ddb82b882518$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            $dca0ddb82b882518$var$popHiddenContext();
            null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache);
            break;
        case 24:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $dca0ddb82b882518$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $dca0ddb82b882518$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    var instance = current.stateNode, name = $dca0ddb82b882518$var$getViewTransitionName(current.memoizedProps, instance);
                    if (null === instance.ref || instance.ref.name !== name) instance.ref = $dca0ddb82b882518$var$createViewTransitionInstance(name);
                    instanceToUse = instance.ref;
                    break;
                case 7:
                    if (null === current.stateNode) {
                        var fragmentInstance = new $dca0ddb82b882518$var$FragmentInstance(current);
                        $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(current.child, !1, $dca0ddb82b882518$var$addFragmentHandleToFiber, fragmentInstance, void 0, void 0);
                        current.stateNode = fragmentInstance;
                    }
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$148) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error$148);
        }
        else ref.current = null;
    }
}
function $dca0ddb82b882518$var$commitNewChildToFragmentInstances(fiber, parentFragmentInstances) {
    if ((5 === fiber.tag || 27 === fiber.tag || 6 === fiber.tag) && null === fiber.alternate && null !== parentFragmentInstances) for(var i = 0; i < parentFragmentInstances.length; i++)$dca0ddb82b882518$var$commitNewChildToFragmentInstance(fiber.stateNode, parentFragmentInstances[i]);
}
function $dca0ddb82b882518$var$commitFragmentInstanceInsertionEffects(fiber) {
    for(var parent = fiber.return; null !== parent;){
        $dca0ddb82b882518$var$isFragmentInstanceParent(parent) && $dca0ddb82b882518$var$commitNewChildToFragmentInstance(fiber.stateNode, parent.stateNode);
        if ($dca0ddb82b882518$var$isFragmentInstanceHostBoundary(parent)) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(fiber) {
    for(var parent = fiber.return; null !== parent;){
        $dca0ddb82b882518$var$isFragmentInstanceParent(parent) && $dca0ddb82b882518$var$deleteChildFromFragmentInstance(fiber.stateNode, parent.stateNode);
        if ($dca0ddb82b882518$var$isFragmentInstanceHostBoundary(parent)) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$isFragmentInstanceHostBoundary(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 27 === fiber.tag;
}
function $dca0ddb82b882518$var$isFragmentInstanceParent(fiber) {
    return fiber && 7 === fiber.tag && null !== fiber.stateNode;
}
function $dca0ddb82b882518$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $dca0ddb82b882518$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$dca0ddb82b882518$var$internalPropsKey] = newProps;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $dca0ddb82b882518$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $dca0ddb82b882518$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) tag = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(tag, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(tag), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $dca0ddb82b882518$var$noop$1)), $dca0ddb82b882518$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
    else if (4 !== tag && (27 === tag && ($dca0ddb82b882518$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), parentFragmentInstances = null, $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null)), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances), node = node.sibling;
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) tag = node.stateNode, before ? parent.insertBefore(tag, before) : parent.appendChild(tag), $dca0ddb82b882518$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
    else if (4 !== tag && (27 === tag && ($dca0ddb82b882518$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), parentFragmentInstances = null, $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode)), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances), node = node.sibling;
}
function $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $dca0ddb82b882518$var$setInitialProperties(singleton, type, props);
        singleton[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
        singleton[$dca0ddb82b882518$var$internalPropsKey] = props;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $dca0ddb82b882518$var$shouldStartViewTransition = !1, $dca0ddb82b882518$var$appearingViewTransitions = null;
function $dca0ddb82b882518$var$trackEnterViewTransitions(placement) {
    if (30 === placement.tag || 0 !== (placement.subtreeFlags & 33554432)) $dca0ddb82b882518$var$shouldStartViewTransition = !0;
}
var $dca0ddb82b882518$var$viewTransitionCancelableChildren = null;
function $dca0ddb82b882518$var$pushViewTransitionCancelableScope() {
    var prevChildren = $dca0ddb82b882518$var$viewTransitionCancelableChildren;
    $dca0ddb82b882518$var$viewTransitionCancelableChildren = null;
    return prevChildren;
}
var $dca0ddb82b882518$var$viewTransitionHostInstanceIdx = 0;
function $dca0ddb82b882518$var$applyViewTransitionToHostInstances(fiber, name, className, collectMeasurements, stopAtNestedViewTransitions) {
    $dca0ddb82b882518$var$viewTransitionHostInstanceIdx = 0;
    return $dca0ddb82b882518$var$applyViewTransitionToHostInstancesRecursive(fiber.child, name, className, collectMeasurements, stopAtNestedViewTransitions);
}
function $dca0ddb82b882518$var$applyViewTransitionToHostInstancesRecursive(child, name, className, collectMeasurements, stopAtNestedViewTransitions) {
    for(var inViewport = !1; null !== child;){
        if (5 === child.tag) {
            var instance = child.stateNode;
            if (null !== collectMeasurements) {
                var measurement = $dca0ddb82b882518$var$measureInstance(instance);
                collectMeasurements.push(measurement);
                measurement.view && (inViewport = !0);
            } else inViewport || $dca0ddb82b882518$var$measureInstance(instance).view && (inViewport = !0);
            $dca0ddb82b882518$var$shouldStartViewTransition = !0;
            $dca0ddb82b882518$var$applyViewTransitionName(instance, 0 === $dca0ddb82b882518$var$viewTransitionHostInstanceIdx ? name : name + "_" + $dca0ddb82b882518$var$viewTransitionHostInstanceIdx, className);
            $dca0ddb82b882518$var$viewTransitionHostInstanceIdx++;
        } else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions || $dca0ddb82b882518$var$applyViewTransitionToHostInstancesRecursive(child.child, name, className, collectMeasurements, stopAtNestedViewTransitions) && (inViewport = !0);
        child = child.sibling;
    }
    return inViewport;
}
function $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(child, stopAtNestedViewTransitions) {
    for(; null !== child;){
        if (5 === child.tag) $dca0ddb82b882518$var$restoreViewTransitionName(child.stateNode, child.memoizedProps);
        else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions || $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(child.child, stopAtNestedViewTransitions);
        child = child.sibling;
    }
}
function $dca0ddb82b882518$var$commitAppearingPairViewTransitions(placement) {
    if (0 !== (placement.subtreeFlags & 18874368)) for(placement = placement.child; null !== placement;){
        if (22 !== placement.tag || null === placement.memoizedState) {
            if ($dca0ddb82b882518$var$commitAppearingPairViewTransitions(placement), 30 === placement.tag && 0 !== (placement.flags & 18874368) && placement.stateNode.paired) {
                var props = placement.memoizedProps;
                if (null == props.name || "auto" === props.name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(544));
                var name = props.name;
                props = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, props.share);
                "none" !== props && ($dca0ddb82b882518$var$applyViewTransitionToHostInstances(placement, name, props, null, !1) || $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(placement.child, !1));
            }
        }
        placement = placement.sibling;
    }
}
function $dca0ddb82b882518$var$commitEnterViewTransitions(placement, gesture) {
    if (30 === placement.tag) {
        var state = placement.stateNode, props = placement.memoizedProps, name = $dca0ddb82b882518$var$getViewTransitionName(props, state), className = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, state.paired ? props.share : props.enter);
        "none" !== className ? $dca0ddb82b882518$var$applyViewTransitionToHostInstances(placement, name, className, null, !1) ? ($dca0ddb82b882518$var$commitAppearingPairViewTransitions(placement), state.paired || gesture || $dca0ddb82b882518$var$scheduleViewTransitionEvent(placement, props.onEnter)) : $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(placement.child, !1) : $dca0ddb82b882518$var$commitAppearingPairViewTransitions(placement);
    } else if (0 !== (placement.subtreeFlags & 33554432)) for(placement = placement.child; null !== placement;)$dca0ddb82b882518$var$commitEnterViewTransitions(placement, gesture), placement = placement.sibling;
    else $dca0ddb82b882518$var$commitAppearingPairViewTransitions(placement);
}
function $dca0ddb82b882518$var$commitDeletedPairViewTransitions(deletion) {
    if (null !== $dca0ddb82b882518$var$appearingViewTransitions && 0 !== $dca0ddb82b882518$var$appearingViewTransitions.size) {
        var pairs = $dca0ddb82b882518$var$appearingViewTransitions;
        if (0 !== (deletion.subtreeFlags & 18874368)) for(deletion = deletion.child; null !== deletion;){
            if (22 !== deletion.tag || null === deletion.memoizedState) {
                if (30 === deletion.tag && 0 !== (deletion.flags & 18874368)) {
                    var props = deletion.memoizedProps, name = props.name;
                    if (null != name && "auto" !== name) {
                        var pair = pairs.get(name);
                        if (void 0 !== pair) {
                            var className = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, props.share);
                            "none" !== className && ($dca0ddb82b882518$var$applyViewTransitionToHostInstances(deletion, name, className, null, !1) ? (className = deletion.stateNode, pair.paired = className, className.paired = pair, $dca0ddb82b882518$var$scheduleViewTransitionEvent(deletion, props.onShare)) : $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(deletion.child, !1));
                            pairs.delete(name);
                            if (0 === pairs.size) break;
                        }
                    }
                }
                $dca0ddb82b882518$var$commitDeletedPairViewTransitions(deletion);
            }
            deletion = deletion.sibling;
        }
    }
}
function $dca0ddb82b882518$var$commitExitViewTransitions(deletion) {
    if (30 === deletion.tag) {
        var props = deletion.memoizedProps, name = $dca0ddb82b882518$var$getViewTransitionName(props, deletion.stateNode), pair = null !== $dca0ddb82b882518$var$appearingViewTransitions ? $dca0ddb82b882518$var$appearingViewTransitions.get(name) : void 0, className = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, void 0 !== pair ? props.share : props.exit);
        "none" !== className && ($dca0ddb82b882518$var$applyViewTransitionToHostInstances(deletion, name, className, null, !1) ? void 0 !== pair ? (className = deletion.stateNode, pair.paired = className, className.paired = pair, $dca0ddb82b882518$var$appearingViewTransitions.delete(name), $dca0ddb82b882518$var$scheduleViewTransitionEvent(deletion, props.onShare)) : $dca0ddb82b882518$var$scheduleViewTransitionEvent(deletion, props.onExit) : $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(deletion.child, !1));
        null !== $dca0ddb82b882518$var$appearingViewTransitions && $dca0ddb82b882518$var$commitDeletedPairViewTransitions(deletion);
    } else if (0 !== (deletion.subtreeFlags & 33554432)) for(deletion = deletion.child; null !== deletion;)$dca0ddb82b882518$var$commitExitViewTransitions(deletion), deletion = deletion.sibling;
    else null !== $dca0ddb82b882518$var$appearingViewTransitions && $dca0ddb82b882518$var$commitDeletedPairViewTransitions(deletion);
}
function $dca0ddb82b882518$var$commitNestedViewTransitions(changedParent) {
    for(changedParent = changedParent.child; null !== changedParent;){
        if (30 === changedParent.tag) {
            var props = changedParent.memoizedProps, name = $dca0ddb82b882518$var$getViewTransitionName(props, changedParent.stateNode);
            props = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, props.update);
            changedParent.flags &= -5;
            "none" !== props && $dca0ddb82b882518$var$applyViewTransitionToHostInstances(changedParent, name, props, changedParent.memoizedState = [], !1);
        } else 0 !== (changedParent.subtreeFlags & 33554432) && $dca0ddb82b882518$var$commitNestedViewTransitions(changedParent);
        changedParent = changedParent.sibling;
    }
}
function $dca0ddb82b882518$var$restorePairedViewTransitions(parent) {
    if (0 !== (parent.subtreeFlags & 18874368)) for(parent = parent.child; null !== parent;){
        if (22 !== parent.tag || null === parent.memoizedState) {
            if (30 === parent.tag && 0 !== (parent.flags & 18874368)) {
                var instance = parent.stateNode;
                null !== instance.paired && (instance.paired = null, $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(parent.child, !1));
            }
            $dca0ddb82b882518$var$restorePairedViewTransitions(parent);
        }
        parent = parent.sibling;
    }
}
function $dca0ddb82b882518$var$restoreEnterOrExitViewTransitions(fiber) {
    if (30 === fiber.tag) fiber.stateNode.paired = null, $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(fiber.child, !1), $dca0ddb82b882518$var$restorePairedViewTransitions(fiber);
    else if (0 !== (fiber.subtreeFlags & 33554432)) for(fiber = fiber.child; null !== fiber;)$dca0ddb82b882518$var$restoreEnterOrExitViewTransitions(fiber), fiber = fiber.sibling;
    else $dca0ddb82b882518$var$restorePairedViewTransitions(fiber);
}
function $dca0ddb82b882518$var$restoreNestedViewTransitions(changedParent) {
    for(changedParent = changedParent.child; null !== changedParent;)30 === changedParent.tag ? $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(changedParent.child, !1) : 0 !== (changedParent.subtreeFlags & 33554432) && $dca0ddb82b882518$var$restoreNestedViewTransitions(changedParent), changedParent = changedParent.sibling;
}
function $dca0ddb82b882518$var$measureViewTransitionHostInstancesRecursive(parentViewTransition, child, newName, oldName, className, previousMeasurements, stopAtNestedViewTransitions) {
    for(var inViewport = !1; null !== child;){
        if (5 === child.tag) {
            var instance = child.stateNode;
            if (null !== previousMeasurements && $dca0ddb82b882518$var$viewTransitionHostInstanceIdx < previousMeasurements.length) {
                var previousMeasurement = previousMeasurements[$dca0ddb82b882518$var$viewTransitionHostInstanceIdx], nextMeasurement = $dca0ddb82b882518$var$measureInstance(instance);
                if (previousMeasurement.view || nextMeasurement.view) inViewport = !0;
                var JSCompiler_temp;
                if (JSCompiler_temp = 0 === (parentViewTransition.flags & 4)) {
                    if (nextMeasurement.clip) JSCompiler_temp = !0;
                    else {
                        JSCompiler_temp = previousMeasurement.rect;
                        var newRect = nextMeasurement.rect;
                        JSCompiler_temp = JSCompiler_temp.y !== newRect.y || JSCompiler_temp.x !== newRect.x || JSCompiler_temp.height !== newRect.height || JSCompiler_temp.width !== newRect.width;
                    }
                }
                JSCompiler_temp && (parentViewTransition.flags |= 4);
                nextMeasurement.abs ? nextMeasurement = !previousMeasurement.abs : (previousMeasurement = previousMeasurement.rect, nextMeasurement = nextMeasurement.rect, nextMeasurement = previousMeasurement.height !== nextMeasurement.height || previousMeasurement.width !== nextMeasurement.width);
                nextMeasurement && (parentViewTransition.flags |= 32);
            } else parentViewTransition.flags |= 32;
            0 !== (parentViewTransition.flags & 4) && $dca0ddb82b882518$var$applyViewTransitionName(instance, 0 === $dca0ddb82b882518$var$viewTransitionHostInstanceIdx ? newName : newName + "_" + $dca0ddb82b882518$var$viewTransitionHostInstanceIdx, className);
            inViewport && 0 !== (parentViewTransition.flags & 4) || (null === $dca0ddb82b882518$var$viewTransitionCancelableChildren && ($dca0ddb82b882518$var$viewTransitionCancelableChildren = []), $dca0ddb82b882518$var$viewTransitionCancelableChildren.push(instance, 0 === $dca0ddb82b882518$var$viewTransitionHostInstanceIdx ? oldName : oldName + "_" + $dca0ddb82b882518$var$viewTransitionHostInstanceIdx, child.memoizedProps));
            $dca0ddb82b882518$var$viewTransitionHostInstanceIdx++;
        } else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions ? parentViewTransition.flags |= child.flags & 32 : $dca0ddb82b882518$var$measureViewTransitionHostInstancesRecursive(parentViewTransition, child.child, newName, oldName, className, previousMeasurements, stopAtNestedViewTransitions) && (inViewport = !0);
        child = child.sibling;
    }
    return inViewport;
}
function $dca0ddb82b882518$var$measureNestedViewTransitions(changedParent, gesture) {
    for(changedParent = changedParent.child; null !== changedParent;){
        if (30 === changedParent.tag) {
            var props = changedParent.memoizedProps, state = changedParent.stateNode, name = $dca0ddb82b882518$var$getViewTransitionName(props, state), className = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, props.update);
            if (gesture) {
                state = state.clones;
                var previousMeasurements = null === state ? null : state.map($dca0ddb82b882518$var$measureClonedInstance);
            } else previousMeasurements = changedParent.memoizedState, changedParent.memoizedState = null;
            state = changedParent;
            var child = changedParent.child;
            $dca0ddb82b882518$var$viewTransitionHostInstanceIdx = 0;
            name = $dca0ddb82b882518$var$measureViewTransitionHostInstancesRecursive(state, child, name, name, className, previousMeasurements, !1);
            0 !== (changedParent.flags & 4) && name && (gesture || $dca0ddb82b882518$var$scheduleViewTransitionEvent(changedParent, props.onUpdate));
        } else 0 !== (changedParent.subtreeFlags & 33554432) && $dca0ddb82b882518$var$measureNestedViewTransitions(changedParent, gesture);
        changedParent = changedParent.sibling;
    }
}
var $dca0ddb82b882518$var$offscreenSubtreeIsHidden = !1, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = !1, $dca0ddb82b882518$var$offscreenDirectParentIsHidden = !1, $dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $dca0ddb82b882518$var$nextEffect = null, $dca0ddb82b882518$var$viewTransitionContextChanged = !1, $dca0ddb82b882518$var$inUpdateViewTransition = !1, $dca0ddb82b882518$var$rootViewTransitionAffected = !1, $dca0ddb82b882518$var$rootViewTransitionNameCanceled = !1;
function $dca0ddb82b882518$var$commitBeforeMutationEffects(root, firstChild, committedLanes) {
    root = root.containerInfo;
    $dca0ddb82b882518$var$eventsEnabled = $dca0ddb82b882518$var$_enabled;
    root = $dca0ddb82b882518$var$getActiveElementDeep(root);
    if ($dca0ddb82b882518$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$21) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $dca0ddb82b882518$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $dca0ddb82b882518$var$_enabled = !1;
    committedLanes = (committedLanes & 335544064) === committedLanes;
    $dca0ddb82b882518$var$nextEffect = firstChild;
    for(firstChild = committedLanes ? 9270 : 1024; null !== $dca0ddb82b882518$var$nextEffect;){
        root = $dca0ddb82b882518$var$nextEffect;
        if (committedLanes && (JSCompiler_temp = root.deletions, null !== JSCompiler_temp)) for(anchorOffset = 0; anchorOffset < JSCompiler_temp.length; anchorOffset++)committedLanes && $dca0ddb82b882518$var$commitExitViewTransitions(JSCompiler_temp[anchorOffset]);
        if (null === root.alternate && 0 !== (root.flags & 2)) committedLanes && $dca0ddb82b882518$var$trackEnterViewTransitions(root), $dca0ddb82b882518$var$commitBeforeMutationEffects_complete(committedLanes);
        else {
            if (22 === root.tag) {
                if (JSCompiler_temp = root.alternate, null !== root.memoizedState) {
                    null !== JSCompiler_temp && null === JSCompiler_temp.memoizedState && committedLanes && $dca0ddb82b882518$var$commitExitViewTransitions(JSCompiler_temp);
                    $dca0ddb82b882518$var$commitBeforeMutationEffects_complete(committedLanes);
                    continue;
                } else if (null !== JSCompiler_temp && null !== JSCompiler_temp.memoizedState) {
                    committedLanes && $dca0ddb82b882518$var$trackEnterViewTransitions(root);
                    $dca0ddb82b882518$var$commitBeforeMutationEffects_complete(committedLanes);
                    continue;
                }
            }
            JSCompiler_temp = root.child;
            0 !== (root.subtreeFlags & firstChild) && null !== JSCompiler_temp ? (JSCompiler_temp.return = root, $dca0ddb82b882518$var$nextEffect = JSCompiler_temp) : (committedLanes && $dca0ddb82b882518$var$commitNestedViewTransitions(root), $dca0ddb82b882518$var$commitBeforeMutationEffects_complete(committedLanes));
        }
    }
    $dca0ddb82b882518$var$appearingViewTransitions = null;
}
function $dca0ddb82b882518$var$commitBeforeMutationEffects_complete(isViewTransitionEligible$jscomp$0) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect, isViewTransitionEligible = isViewTransitionEligible$jscomp$0, current = fiber.alternate, flags = fiber.flags;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (flags & 1024) && null !== current) {
                    isViewTransitionEligible = void 0;
                    flags = current.memoizedProps;
                    current = current.memoizedState;
                    var instance = fiber.stateNode;
                    try {
                        var resolvedPrevProps = $dca0ddb82b882518$var$resolveClassComponentProps(fiber.type, flags);
                        isViewTransitionEligible = instance.getSnapshotBeforeUpdate(resolvedPrevProps, current);
                        instance.__reactInternalSnapshotBeforeUpdate = isViewTransitionEligible;
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(fiber, fiber.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (flags & 1024)) {
                    if (current = fiber.stateNode.containerInfo, isViewTransitionEligible = current.nodeType, 9 === isViewTransitionEligible) $dca0ddb82b882518$var$clearContainerSparingly(current);
                    else if (1 === isViewTransitionEligible) switch(current.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $dca0ddb82b882518$var$clearContainerSparingly(current);
                            break;
                        default:
                            current.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            case 30:
                isViewTransitionEligible && null !== current && (isViewTransitionEligible = $dca0ddb82b882518$var$getViewTransitionName(current.memoizedProps, current.stateNode), flags = fiber.memoizedProps, flags = $dca0ddb82b882518$var$getViewTransitionClassName(flags.default, flags.update), "none" !== flags && $dca0ddb82b882518$var$applyViewTransitionToHostInstances(current, isViewTransitionEligible, flags, current.memoizedState = [], !0));
                break;
            default:
                if (0 !== (flags & 1024)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(163));
        }
        current = fiber.sibling;
        if (null !== current) {
            current.return = fiber.return;
            $dca0ddb82b882518$var$nextEffect = current;
            break;
        }
        $dca0ddb82b882518$var$nextEffect = fiber.return;
    }
}
function $dca0ddb82b882518$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $dca0ddb82b882518$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$146) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$146);
                    }
                }
            }
            flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $dca0ddb82b882518$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $dca0ddb82b882518$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            if (!flags) {
                var newOffscreenSubtreeWasHidden = null !== current && null !== current.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                current = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
                prevProps = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = flags;
                ($dca0ddb82b882518$var$offscreenSubtreeWasHidden = newOffscreenSubtreeWasHidden) && !prevProps ? (flags = 2, 0 !== (finishedWork.subtreeFlags & 8772) && (flags |= 1), $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, flags)) : $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = current;
                $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevProps;
            }
            break;
        case 30:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 7:
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
        default:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $dca0ddb82b882518$var$hideOrUnhideAllChildren(parentFiber, isHidden) {
    for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$hideOrUnhideAllChildrenOnFiber(parentFiber, isHidden), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$hideOrUnhideAllChildrenOnFiber(fiber, isHidden) {
    switch(fiber.tag){
        case 5:
        case 26:
            try {
                var instance = fiber.stateNode;
                if (isHidden) {
                    var style = instance.style;
                    "function" === typeof style.setProperty ? style.setProperty("display", "none", "important") : style.display = "none";
                } else {
                    var instance$jscomp$0 = fiber.stateNode, styleProp = fiber.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                    instance$jscomp$0.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                }
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            $dca0ddb82b882518$var$hideOrUnhideNearestPortals(fiber, isHidden);
            break;
        case 6:
            try {
                fiber.stateNode.nodeValue = isHidden ? "" : fiber.memoizedProps, $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            break;
        case 18:
            try {
                var instance$jscomp$1 = fiber.stateNode;
                isHidden ? $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(instance$jscomp$1, !0) : $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(fiber.stateNode, !1);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            break;
        case 22:
        case 23:
            null === fiber.memoizedState && $dca0ddb82b882518$var$hideOrUnhideAllChildren(fiber, isHidden);
            break;
        default:
            $dca0ddb82b882518$var$hideOrUnhideAllChildren(fiber, isHidden);
    }
}
function $dca0ddb82b882518$var$hideOrUnhideNearestPortals(parentFiber, isHidden$jscomp$0) {
    if (parentFiber.subtreeFlags & 67108864) for(parentFiber = parentFiber.child; null !== parentFiber;){
        a: {
            var fiber = parentFiber, isHidden = isHidden$jscomp$0;
            switch(fiber.tag){
                case 4:
                    $dca0ddb82b882518$var$hideOrUnhideAllChildrenOnFiber(fiber, isHidden);
                    break a;
                case 22:
                    null === fiber.memoizedState && $dca0ddb82b882518$var$hideOrUnhideNearestPortals(fiber, isHidden);
                    break a;
                default:
                    $dca0ddb82b882518$var$hideOrUnhideNearestPortals(fiber, isHidden);
            }
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $dca0ddb82b882518$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $dca0ddb82b882518$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $dca0ddb82b882518$var$hostParent = null, $dca0ddb82b882518$var$hostParentIsContainer = !1;
function $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount) try {
        $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount($dca0ddb82b882518$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && !$dca0ddb82b882518$var$offscreenSubtreeWasHidden && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(deletedFiber);
            var prevHostParent = $dca0ddb82b882518$var$hostParent, prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$isSingletonScope(deletedFiber.type) && ($dca0ddb82b882518$var$hostParent = deletedFiber.stateNode, $dca0ddb82b882518$var$hostParentIsContainer = !1);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$releaseSingletonInstance(deletedFiber.stateNode, deletedFiber.type, deletedFiber.memoizedProps);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(deletedFiber);
        case 6:
            6 === deletedFiber.tag && $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(deletedFiber);
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = null;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $dca0ddb82b882518$var$hostParent) {
                if ($dca0ddb82b882518$var$hostParentIsContainer) try {
                    (9 === $dca0ddb82b882518$var$hostParent.nodeType ? $dca0ddb82b882518$var$hostParent.body : "HTML" === $dca0ddb82b882518$var$hostParent.nodeName ? $dca0ddb82b882518$var$hostParent.ownerDocument.body : $dca0ddb82b882518$var$hostParent).removeChild(deletedFiber.stateNode), $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $dca0ddb82b882518$var$hostParent.removeChild(deletedFiber.stateNode), $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $dca0ddb82b882518$var$hostParent && ($dca0ddb82b882518$var$hostParentIsContainer ? (finishedRoot = $dca0ddb82b882518$var$hostParent, $dca0ddb82b882518$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot)) : $dca0ddb82b882518$var$clearHydrationBoundary($dca0ddb82b882518$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = deletedFiber.stateNode.containerInfo;
            $dca0ddb82b882518$var$hostParentIsContainer = !0;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || ($dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = (prevHostParent = $dca0ddb82b882518$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        case 30:
            $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 7:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $dca0ddb82b882518$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $dca0ddb82b882518$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $dca0ddb82b882518$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $dca0ddb82b882518$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber, lanes) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($dca0ddb82b882518$var$isSingletonScope(parent.type)) {
                        $dca0ddb82b882518$var$hostParent = parent.stateNode;
                        $dca0ddb82b882518$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode;
                    $dca0ddb82b882518$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode.containerInfo;
                    $dca0ddb82b882518$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $dca0ddb82b882518$var$hostParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
        $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $dca0ddb82b882518$var$hostParent = null;
        $dca0ddb82b882518$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0, lanes), parentFiber = parentFiber.sibling;
}
var $dca0ddb82b882518$var$currentHoistableRoot = null;
function $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root, lanes) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            if (flags & 4 && (current = finishedWork.updateQueue, current = null !== current ? current.events : null, null !== current)) for(var ii = 0; ii < current.length; ii++){
                var _eventPayloads$ii2 = current[ii];
                _eventPayloads$ii2.ref.impl = _eventPayloads$ii2.nextImpl;
            }
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($dca0ddb82b882518$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $dca0ddb82b882518$var$commitHookEffectListMount(3, finishedWork), $dca0ddb82b882518$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags & 64 && $dca0ddb82b882518$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (root = finishedWork.callbacks, null !== root && (lanes = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === lanes ? root : lanes.concat(root))));
            break;
        case 26:
            ii = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                if (flags = null !== current ? current.memoizedState : null, lanes = finishedWork.memoizedState, null === current) {
                    if (null === lanes) {
                        if (null === finishedWork.stateNode) {
                            if ($dca0ddb82b882518$var$offscreenSubtreeIsHidden) finishedWork.stateNode = $dca0ddb82b882518$var$createHoistableInstance(finishedWork.type, finishedWork.memoizedProps, root.containerInfo, finishedWork);
                            else {
                                a: {
                                    root = finishedWork.type;
                                    lanes = finishedWork.memoizedProps;
                                    flags = ii.ownerDocument || ii;
                                    b: switch(root){
                                        case "title":
                                            current = flags.getElementsByTagName("title")[0];
                                            if (!current || current[$dca0ddb82b882518$var$internalHoistableMarker] || current[$dca0ddb82b882518$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === current.namespaceURI || current.hasAttribute("itemprop")) current = flags.createElement(root), flags.head.insertBefore(current, flags.querySelector("head > title"));
                                            $dca0ddb82b882518$var$setInitialProperties(current, root, lanes);
                                            current[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                            $dca0ddb82b882518$var$markNodeAsHoistable(current);
                                            root = current;
                                            break a;
                                        case "link":
                                            if (ii = $dca0ddb82b882518$var$getHydratableHoistableCache("link", "href", flags).get(root + (lanes.href || ""))) {
                                                for(_eventPayloads$ii2 = 0; _eventPayloads$ii2 < ii.length; _eventPayloads$ii2++)if (current = ii[_eventPayloads$ii2], current.getAttribute("href") === (null == lanes.href || "" === lanes.href ? null : lanes.href) && current.getAttribute("rel") === (null == lanes.rel ? null : lanes.rel) && current.getAttribute("title") === (null == lanes.title ? null : lanes.title) && current.getAttribute("crossorigin") === (null == lanes.crossOrigin ? null : lanes.crossOrigin)) {
                                                    ii.splice(_eventPayloads$ii2, 1);
                                                    break b;
                                                }
                                            }
                                            current = flags.createElement(root);
                                            $dca0ddb82b882518$var$setInitialProperties(current, root, lanes);
                                            flags.head.appendChild(current);
                                            break;
                                        case "meta":
                                            if (ii = $dca0ddb82b882518$var$getHydratableHoistableCache("meta", "content", flags).get(root + (lanes.content || ""))) {
                                                for(_eventPayloads$ii2 = 0; _eventPayloads$ii2 < ii.length; _eventPayloads$ii2++)if (current = ii[_eventPayloads$ii2], current.getAttribute("content") === (null == lanes.content ? null : "" + lanes.content) && current.getAttribute("name") === (null == lanes.name ? null : lanes.name) && current.getAttribute("property") === (null == lanes.property ? null : lanes.property) && current.getAttribute("http-equiv") === (null == lanes.httpEquiv ? null : lanes.httpEquiv) && current.getAttribute("charset") === (null == lanes.charSet ? null : lanes.charSet)) {
                                                    ii.splice(_eventPayloads$ii2, 1);
                                                    break b;
                                                }
                                            }
                                            current = flags.createElement(root);
                                            $dca0ddb82b882518$var$setInitialProperties(current, root, lanes);
                                            flags.head.appendChild(current);
                                            break;
                                        default:
                                            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(468, root));
                                    }
                                    current[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                    $dca0ddb82b882518$var$markNodeAsHoistable(current);
                                    root = current;
                                }
                                finishedWork.stateNode = root;
                            }
                        } else $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$mountHoistable(ii, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $dca0ddb82b882518$var$acquireResource(ii, lanes, finishedWork.memoizedProps);
                } else flags !== lanes ? (null === flags ? (root = current.stateNode, null === root || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || root.parentNode.removeChild(root)) : flags.count--, null === lanes ? $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$mountHoistable(ii, finishedWork.type, finishedWork.stateNode) : $dca0ddb82b882518$var$acquireResource(ii, lanes, finishedWork.memoizedProps)) : null === lanes && null !== finishedWork.stateNode && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            ii = $dca0ddb82b882518$var$offscreenDirectParentIsHidden;
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = !1;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = ii;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                root = finishedWork.stateNode;
                try {
                    $dca0ddb82b882518$var$setTextContent(root, ""), $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (root = finishedWork.memoizedProps, $dca0ddb82b882518$var$commitHostUpdate(finishedWork, root, null !== current ? current.memoizedProps : root));
            flags & 1024 && ($dca0ddb82b882518$var$needsFormReset = !0);
            break;
        case 6:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(162));
                root = finishedWork.memoizedProps;
                lanes = finishedWork.stateNode;
                try {
                    lanes.nodeValue = root, $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $dca0ddb82b882518$var$viewTransitionMutationContext = !1;
            $dca0ddb82b882518$var$tagCaches = null;
            ii = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(root.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$currentHoistableRoot = ii;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $dca0ddb82b882518$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $dca0ddb82b882518$var$needsFormReset && ($dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$recursivelyResetForms(finishedWork));
            $dca0ddb82b882518$var$viewTransitionMutationContext = !1;
            break;
        case 4:
            flags = $dca0ddb82b882518$var$offscreenDirectParentIsHidden;
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            current = $dca0ddb82b882518$var$pushMutationContext();
            ii = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = ii;
            $dca0ddb82b882518$var$viewTransitionMutationContext && $dca0ddb82b882518$var$inUpdateViewTransition && ($dca0ddb82b882518$var$rootViewTransitionAffected = !0);
            $dca0ddb82b882518$var$viewTransitionMutationContext = current;
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = flags;
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($dca0ddb82b882518$var$globalMostRecentFallbackTime = $dca0ddb82b882518$var$now());
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 22:
            ii = null !== finishedWork.memoizedState;
            _eventPayloads$ii2 = null !== current && null !== current.memoizedState;
            var prevOffscreenSubtreeIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden, prevOffscreenDirectParentIsHidden$166 = $dca0ddb82b882518$var$offscreenDirectParentIsHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || ii;
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = prevOffscreenDirectParentIsHidden$166 || ii;
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || _eventPayloads$ii2;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = prevOffscreenDirectParentIsHidden$166;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 8192 && (root = finishedWork.stateNode, root._visibility = ii ? root._visibility & -2 : root._visibility | 1, !ii || null === current || _eventPayloads$ii2 || $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || (root = _eventPayloads$ii2 || $dca0ddb82b882518$var$offscreenSubtreeWasHidden, lanes = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, current = $dca0ddb82b882518$var$offscreenSubtreeWasHidden, $dca0ddb82b882518$var$offscreenSubtreeIsHidden = ii || $dca0ddb82b882518$var$offscreenSubtreeIsHidden, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = root, $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, 2), $dca0ddb82b882518$var$offscreenSubtreeIsHidden = lanes, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = current), !ii && $dca0ddb82b882518$var$offscreenDirectParentIsHidden || $dca0ddb82b882518$var$hideOrUnhideAllChildren(finishedWork, ii));
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (lanes = root.retryQueue, null !== lanes && (root.retryQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, lanes))));
            break;
        case 19:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 30:
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags = $dca0ddb82b882518$var$pushMutationContext();
            ii = $dca0ddb82b882518$var$inUpdateViewTransition;
            _eventPayloads$ii2 = (lanes & 335544064) === lanes;
            prevOffscreenSubtreeIsHidden = finishedWork.memoizedProps;
            $dca0ddb82b882518$var$inUpdateViewTransition = _eventPayloads$ii2 && "none" !== $dca0ddb82b882518$var$getViewTransitionClassName(prevOffscreenSubtreeIsHidden.default, prevOffscreenSubtreeIsHidden.update);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            _eventPayloads$ii2 && null !== current && $dca0ddb82b882518$var$viewTransitionMutationContext && (finishedWork.flags |= 4);
            $dca0ddb82b882518$var$inUpdateViewTransition = ii;
            $dca0ddb82b882518$var$viewTransitionMutationContext = flags;
            break;
        case 21:
            break;
        case 7:
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return)), current && null !== current.stateNode && (current.stateNode._fragmentFiber = finishedWork);
        default:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes), $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($dca0ddb82b882518$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            parentFiber = null;
            for(var parent = finishedWork.return; null !== parent;){
                if ($dca0ddb82b882518$var$isFragmentInstanceParent(parent)) {
                    var fragmentInstance = parent.stateNode;
                    null === parentFiber ? parentFiber = [
                        fragmentInstance
                    ] : parentFiber.push(fragmentInstance);
                }
                if ($dca0ddb82b882518$var$isFragmentInstanceHostBoundary(parent)) break;
                parent = parent.return;
            }
            var JSCompiler_inline_result = parentFiber;
            if (null == hostParentFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent$jscomp$0 = hostParentFiber.stateNode, before = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before, parent$jscomp$0, JSCompiler_inline_result);
                    break;
                case 5:
                    var parent$149 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($dca0ddb82b882518$var$setTextContent(parent$149, ""), hostParentFiber.flags &= -33);
                    var before$150 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before$150, parent$149, JSCompiler_inline_result);
                    break;
                case 3:
                case 4:
                    var parent$151 = hostParentFiber.stateNode.containerInfo, before$152 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$152, parent$151, JSCompiler_inline_result);
                    break;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $dca0ddb82b882518$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $dca0ddb82b882518$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && (fiber = fiber.stateNode, $dca0ddb82b882518$var$_enabled = !0, fiber.reset(), $dca0ddb82b882518$var$_enabled = !1);
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 9270) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitAfterMutationEffectsOnFiber(parentFiber, root), parentFiber = parentFiber.sibling;
    else $dca0ddb82b882518$var$measureNestedViewTransitions(parentFiber, !1);
}
function $dca0ddb82b882518$var$commitAfterMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate;
    if (null === current) $dca0ddb82b882518$var$commitEnterViewTransitions(finishedWork, !1);
    else switch(finishedWork.tag){
        case 3:
            $dca0ddb82b882518$var$rootViewTransitionNameCanceled = $dca0ddb82b882518$var$viewTransitionContextChanged = !1;
            $dca0ddb82b882518$var$pushViewTransitionCancelableScope();
            $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            if (!$dca0ddb82b882518$var$viewTransitionContextChanged && !$dca0ddb82b882518$var$rootViewTransitionAffected) {
                finishedWork = $dca0ddb82b882518$var$viewTransitionCancelableChildren;
                if (null !== finishedWork) for(var i = 0; i < finishedWork.length; i += 3){
                    current = finishedWork[i];
                    var oldName = finishedWork[i + 1];
                    $dca0ddb82b882518$var$restoreViewTransitionName(current, finishedWork[i + 2]);
                    current = current.ownerDocument.documentElement;
                    null !== current && current.animate({
                        opacity: [
                            0,
                            0
                        ],
                        pointerEvents: [
                            "none",
                            "none"
                        ]
                    }, {
                        duration: 0,
                        fill: "forwards",
                        pseudoElement: "::view-transition-group(" + oldName + ")"
                    });
                }
                finishedWork = root.containerInfo;
                finishedWork = 9 === finishedWork.nodeType ? finishedWork.documentElement : finishedWork.ownerDocument.documentElement;
                null !== finishedWork && "" === finishedWork.style.viewTransitionName && (finishedWork.style.viewTransitionName = "none", finishedWork.animate({
                    opacity: [
                        0,
                        0
                    ],
                    pointerEvents: [
                        "none",
                        "none"
                    ]
                }, {
                    duration: 0,
                    fill: "forwards",
                    pseudoElement: "::view-transition-group(root)"
                }), finishedWork.animate({
                    width: [
                        0,
                        0
                    ],
                    height: [
                        0,
                        0
                    ]
                }, {
                    duration: 0,
                    fill: "forwards",
                    pseudoElement: "::view-transition"
                }));
                $dca0ddb82b882518$var$rootViewTransitionNameCanceled = !0;
            }
            $dca0ddb82b882518$var$viewTransitionCancelableChildren = null;
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            break;
        case 4:
            i = $dca0ddb82b882518$var$viewTransitionContextChanged;
            $dca0ddb82b882518$var$viewTransitionContextChanged = !1;
            $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$viewTransitionContextChanged && ($dca0ddb82b882518$var$rootViewTransitionAffected = !0);
            $dca0ddb82b882518$var$viewTransitionContextChanged = i;
            break;
        case 22:
            null === finishedWork.memoizedState && (null !== current.memoizedState ? $dca0ddb82b882518$var$commitEnterViewTransitions(finishedWork, !1) : $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork));
            break;
        case 30:
            i = $dca0ddb82b882518$var$viewTransitionContextChanged;
            oldName = $dca0ddb82b882518$var$pushViewTransitionCancelableScope();
            $dca0ddb82b882518$var$viewTransitionContextChanged = !1;
            $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$viewTransitionContextChanged && (finishedWork.flags |= 4);
            var props = finishedWork.memoizedProps, state = finishedWork.stateNode;
            root = $dca0ddb82b882518$var$getViewTransitionName(props, state);
            state = $dca0ddb82b882518$var$getViewTransitionName(current.memoizedProps, state);
            var className = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, props.update);
            "none" === className ? root = !1 : (props = current.memoizedState, current.memoizedState = null, current = finishedWork.child, $dca0ddb82b882518$var$viewTransitionHostInstanceIdx = 0, root = $dca0ddb82b882518$var$measureViewTransitionHostInstancesRecursive(finishedWork, current, root, state, className, props, !0), $dca0ddb82b882518$var$viewTransitionHostInstanceIdx !== (null === props ? 0 : props.length) && (finishedWork.flags |= 32));
            0 !== (finishedWork.flags & 4) && root ? ($dca0ddb82b882518$var$scheduleViewTransitionEvent(finishedWork, finishedWork.memoizedProps.onUpdate), $dca0ddb82b882518$var$viewTransitionCancelableChildren = oldName) : null !== oldName && (oldName.push.apply(oldName, $dca0ddb82b882518$var$viewTransitionCancelableChildren), $dca0ddb82b882518$var$viewTransitionCancelableChildren = oldName);
            $dca0ddb82b882518$var$viewTransitionContextChanged = 0 !== (finishedWork.flags & 32) ? !0 : i;
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(parentFiber, layoutEffectTraversalFlags$jscomp$0) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber, layoutEffectTraversalFlags = layoutEffectTraversalFlags$jscomp$0;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 1:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 27:
                0 !== (layoutEffectTraversalFlags & 2) && $dca0ddb82b882518$var$releaseSingletonInstance(finishedWork.stateNode, finishedWork.type, finishedWork.memoizedProps);
            case 5:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                5 !== finishedWork.tag && 27 !== finishedWork.tag || $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(finishedWork);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 6:
                $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(finishedWork);
                break;
            case 26:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState || null === instance || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || instance.parentNode.removeChild(instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 30:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 7:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, layoutEffectTraversalFlags) {
    layoutEffectTraversalFlags = 0 !== (parentFiber.subtreeFlags & 8772) ? layoutEffectTraversalFlags : layoutEffectTraversalFlags & -2;
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags, includeWorkInProgressEffects = 0 !== (layoutEffectTraversalFlags & 1);
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $dca0ddb82b882518$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$dca0ddb82b882518$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                0 !== (layoutEffectTraversalFlags & 2) && $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
            case 5:
                5 !== finishedWork.tag && 27 !== finishedWork.tag || $dca0ddb82b882518$var$commitFragmentInstanceInsertionEffects(finishedWork);
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 6:
                $dca0ddb82b882518$var$commitFragmentInstanceInsertionEffects(finishedWork);
                break;
            case 26:
                instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState || null === instance || $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$mountHoistable($dca0ddb82b882518$var$getHoistableRoot(instance.ownerDocument), finishedWork.type, instance);
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                break;
            case 31:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 7:
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $dca0ddb82b882518$var$releaseCache(previousCache));
}
function $dca0ddb82b882518$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $dca0ddb82b882518$var$releaseCache(current));
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    var isViewTransitionEligible = (committedLanes & 335544064) === committedLanes;
    if (parentFiber.subtreeFlags & (isViewTransitionEligible ? 10262 : 10256)) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
    else isViewTransitionEligible && $dca0ddb82b882518$var$restoreNestedViewTransitions(parentFiber);
}
function $dca0ddb82b882518$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var isViewTransitionEligible = (committedLanes & 335544064) === committedLanes;
    isViewTransitionEligible && null === finishedWork.alternate && null !== finishedWork.return && null !== finishedWork.return.alternate && $dca0ddb82b882518$var$restoreEnterOrExitViewTransitions(finishedWork);
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            isViewTransitionEligible && $dca0ddb82b882518$var$rootViewTransitionNameCanceled && (finishedRoot = finishedRoot.containerInfo, finishedRoot = 9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, "root" === finishedRoot.style.viewTransitionName && (finishedRoot.style.viewTransitionName = ""), finishedRoot = finishedRoot.ownerDocument.documentElement, null !== finishedRoot && "none" === finishedRoot.style.viewTransitionName && (finishedRoot.style.viewTransitionName = ""));
            flags & 2048 && (flags = null, null !== finishedWork.alternate && (flags = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== flags && (finishedWork.refCount++, null != flags && $dca0ddb82b882518$var$releaseCache(flags)));
            break;
        case 12:
            if (flags & 2048) {
                $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                flags = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", flags.passiveEffectDuration, -0);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? (isViewTransitionEligible && null !== id && null === id.memoizedState && $dca0ddb82b882518$var$restoreEnterOrExitViewTransitions(id), _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork)) : (isViewTransitionEligible && null !== id && null !== id.memoizedState && $dca0ddb82b882518$var$restoreEnterOrExitViewTransitions(finishedWork), _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1)));
            flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        case 30:
            isViewTransitionEligible && (flags = finishedWork.alternate, null !== flags && ($dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(flags.child, !0), $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(finishedWork.child, !0)));
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $dca0ddb82b882518$var$suspenseyCommitFlag = 8192;
function $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $dca0ddb82b882518$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && (null !== fiber.memoizedState ? $dca0ddb82b882518$var$suspendResource(suspendedState, $dca0ddb82b882518$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps) : (fiber = fiber.stateNode, (committedLanes & 335544128) === committedLanes && $dca0ddb82b882518$var$suspendInstance(suspendedState, fiber)));
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && (fiber = fiber.stateNode, (committedLanes & 335544128) === committedLanes && $dca0ddb82b882518$var$suspendInstance(suspendedState, fiber));
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $dca0ddb82b882518$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $dca0ddb82b882518$var$suspenseyCommitFlag, $dca0ddb82b882518$var$suspenseyCommitFlag = 16777216, $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $dca0ddb82b882518$var$suspenseyCommitFlag = previousHoistableRoot) : $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        case 30:
            if (0 !== (fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag) && (previousHoistableRoot = fiber.memoizedProps.name, null != previousHoistableRoot && "auto" !== previousHoistableRoot)) {
                var state = fiber.stateNode;
                state.paired = null;
                null === $dca0ddb82b882518$var$appearingViewTransitions && ($dca0ddb82b882518$var$appearingViewTransitions = new Map());
                $dca0ddb82b882518$var$appearingViewTransitions.set(previousHoistableRoot, state);
            }
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $dca0ddb82b882518$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $dca0ddb82b882518$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $dca0ddb82b882518$var$nextEffect;){
            cache = $dca0ddb82b882518$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $dca0ddb82b882518$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $dca0ddb82b882518$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $dca0ddb82b882518$var$nextEffect = sibling;
                break a;
            }
            $dca0ddb82b882518$var$nextEffect = returnFiber;
        }
    }
}
var $dca0ddb82b882518$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext).controller.signal;
    }
}, $dca0ddb82b882518$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $dca0ddb82b882518$var$executionContext = 0, $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgress = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1, $dca0ddb82b882518$var$workInProgressRootIsPrerendering = !1, $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1, $dca0ddb82b882518$var$entangledRenderLanes = 0, $dca0ddb82b882518$var$workInProgressRootExitStatus = 0, $dca0ddb82b882518$var$workInProgressRootSkippedLanes = 0, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = 0, $dca0ddb82b882518$var$workInProgressRootPingedLanes = 0, $dca0ddb82b882518$var$workInProgressDeferredLane = 0, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0, $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $dca0ddb82b882518$var$globalMostRecentFallbackTime = 0, $dca0ddb82b882518$var$globalMostRecentTransitionTime = 0, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = Infinity, $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null, $dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$pendingFinishedWork = null, $dca0ddb82b882518$var$pendingEffectsLanes = 0, $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0, $dca0ddb82b882518$var$pendingPassiveTransitions = null, $dca0ddb82b882518$var$pendingRecoverableErrors = null, $dca0ddb82b882518$var$pendingViewTransition = null, $dca0ddb82b882518$var$pendingViewTransitionEvents = null, $dca0ddb82b882518$var$pendingTransitionTypes = null, $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null;
function $dca0ddb82b882518$var$requestUpdateLane() {
    return 0 !== ($dca0ddb82b882518$var$executionContext & 2) && 0 !== $dca0ddb82b882518$var$workInProgressRootRenderLanes ? $dca0ddb82b882518$var$workInProgressRootRenderLanes & -$dca0ddb82b882518$var$workInProgressRootRenderLanes : null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? $dca0ddb82b882518$var$requestTransitionLane() : $dca0ddb82b882518$var$resolveUpdatePriority();
}
function $dca0ddb82b882518$var$requestDeferredLane() {
    if (0 === $dca0ddb82b882518$var$workInProgressDeferredLane) {
        if (0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || $dca0ddb82b882518$var$isHydrating) {
            var lane = $dca0ddb82b882518$var$nextTransitionDeferredLane;
            $dca0ddb82b882518$var$nextTransitionDeferredLane <<= 1;
            0 === ($dca0ddb82b882518$var$nextTransitionDeferredLane & 3932160) && ($dca0ddb82b882518$var$nextTransitionDeferredLane = 262144);
            $dca0ddb82b882518$var$workInProgressDeferredLane = lane;
        } else $dca0ddb82b882518$var$workInProgressDeferredLane = 536870912;
    }
    lane = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $dca0ddb82b882518$var$workInProgressDeferredLane;
}
function $dca0ddb82b882518$var$scheduleViewTransitionEvent(fiber, callback) {
    if (null != callback) {
        var state = fiber.stateNode, instance = state.ref;
        null === instance && (instance = state.ref = $dca0ddb82b882518$var$createViewTransitionInstance($dca0ddb82b882518$var$getViewTransitionName(fiber.memoizedProps, state)));
        null === $dca0ddb82b882518$var$pendingViewTransitionEvents && ($dca0ddb82b882518$var$pendingViewTransitionEvents = []);
        $dca0ddb82b882518$var$pendingViewTransitionEvents.push(callback.bind(null, instance));
    }
}
function $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $dca0ddb82b882518$var$workInProgressRoot && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $dca0ddb82b882518$var$prepareFreshStack(root, 0), $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
    $dca0ddb82b882518$var$markRootUpdated$1(root, lane);
    if (0 === ($dca0ddb82b882518$var$executionContext & 2) || root !== $dca0ddb82b882518$var$workInProgressRoot) root === $dca0ddb82b882518$var$workInProgressRoot && (0 === ($dca0ddb82b882518$var$executionContext & 2) && ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $dca0ddb82b882518$var$workInProgressRootExitStatus && $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1)), $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $dca0ddb82b882518$var$renderRootConcurrent(root$jscomp$0, lanes) : $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $dca0ddb82b882518$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$dca0ddb82b882518$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($dca0ddb82b882518$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $dca0ddb82b882518$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result && 6 !== JSCompiler_inline_result) {
                            if ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $dca0ddb82b882518$var$workInProgressRootRecoverableErrors;
                            $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $dca0ddb82b882518$var$prepareFreshStack(root$jscomp$0, 0);
                $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes && (lanes & 62914560) !== lanes) break;
                    case 6:
                        $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $dca0ddb82b882518$var$globalMostRecentFallbackTime + 300 - $dca0ddb82b882518$var$now(), 10 < exitStatus)) {
                    $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $dca0ddb82b882518$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $dca0ddb82b882518$var$scheduleTimeout($dca0ddb82b882518$var$completeRootWhenReady.bind(null, shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $dca0ddb82b882518$var$completeRootWhenReady(shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $dca0ddb82b882518$var$ensureRootIsScheduled(root$jscomp$0);
}
function $dca0ddb82b882518$var$completeRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    var subtreeFlags = finishedWork.subtreeFlags, isViewTransitionEligible = (lanes & 335544064) === lanes;
    suspendedCommitReason = null;
    if (isViewTransitionEligible || subtreeFlags & 8192 || 16785408 === (subtreeFlags & 16785408)) {
        if (suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $dca0ddb82b882518$var$noop$1
        }, $dca0ddb82b882518$var$appearingViewTransitions = null, $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason), isViewTransitionEligible && (subtreeFlags = suspendedCommitReason, isViewTransitionEligible = root.containerInfo, isViewTransitionEligible = (9 === isViewTransitionEligible.nodeType ? isViewTransitionEligible : isViewTransitionEligible.ownerDocument).__reactViewTransition, null != isViewTransitionEligible && (subtreeFlags.count++, subtreeFlags.waitingForViewTransition = !0, subtreeFlags = $dca0ddb82b882518$var$onUnsuspend.bind(subtreeFlags), isViewTransitionEligible.finished.then(subtreeFlags, subtreeFlags))), subtreeFlags = (lanes & 62914560) === lanes ? $dca0ddb82b882518$var$globalMostRecentFallbackTime - $dca0ddb82b882518$var$now() : (lanes & 4194048) === lanes ? $dca0ddb82b882518$var$globalMostRecentTransitionTime - $dca0ddb82b882518$var$now() : 0, subtreeFlags = $dca0ddb82b882518$var$waitForCommitToBeReady(suspendedCommitReason, subtreeFlags), null !== subtreeFlags) {
            $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = subtreeFlags($dca0ddb82b882518$var$completeRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $dca0ddb82b882518$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $dca0ddb82b882518$var$completeRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason);
}
function $dca0ddb82b882518$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$dca0ddb82b882518$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $dca0ddb82b882518$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes = $dca0ddb82b882518$var$getEntangledLanes(root, suspendedLanes);
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $dca0ddb82b882518$var$flushSyncWork$1() {
    return 0 === ($dca0ddb82b882518$var$executionContext & 6) ? ($dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $dca0ddb82b882518$var$resetWorkInProgressStack() {
    if (null !== $dca0ddb82b882518$var$workInProgress) {
        if (0 === $dca0ddb82b882518$var$workInProgressSuspendedReason) var interruptedWork = $dca0ddb82b882518$var$workInProgress.return;
        else interruptedWork = $dca0ddb82b882518$var$workInProgress, $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$resetHooksOnUnwind(interruptedWork), $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0, interruptedWork = $dca0ddb82b882518$var$workInProgress;
        for(; null !== interruptedWork;)$dca0ddb82b882518$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $dca0ddb82b882518$var$workInProgress = null;
    }
}
function $dca0ddb82b882518$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $dca0ddb82b882518$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $dca0ddb82b882518$var$pendingEffectsLanes = 0;
    $dca0ddb82b882518$var$resetWorkInProgressStack();
    $dca0ddb82b882518$var$workInProgressRoot = root;
    $dca0ddb82b882518$var$workInProgress = timeoutHandle = $dca0ddb82b882518$var$createWorkInProgress(root.current, null);
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = lanes;
    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
    $dca0ddb82b882518$var$workInProgressThrownValue = null;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1;
    $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = $dca0ddb82b882518$var$workInProgressDeferredLane = $dca0ddb82b882518$var$workInProgressRootPingedLanes = $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = $dca0ddb82b882518$var$workInProgressRootSkippedLanes = $dca0ddb82b882518$var$workInProgressRootExitStatus = 0;
    $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null;
    $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$getEntangledLanes(root, lanes);
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $dca0ddb82b882518$var$handleThrow(root, thrownValue) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    thrownValue === $dca0ddb82b882518$var$SuspenseException || thrownValue === $dca0ddb82b882518$var$SuspenseActionException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 3) : thrownValue === $dca0ddb82b882518$var$SuspenseyCommitException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 4) : $dca0ddb82b882518$var$workInProgressSuspendedReason = thrownValue === $dca0ddb82b882518$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $dca0ddb82b882518$var$workInProgressThrownValue = thrownValue;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 1, $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $dca0ddb82b882518$var$shouldRemainOnPreviousScreen() {
    var handler = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) === $dca0ddb82b882518$var$workInProgressRootRenderLanes ? null === $dca0ddb82b882518$var$shellBoundary ? !0 : !1 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) ? handler === $dca0ddb82b882518$var$shellBoundary : !1;
}
function $dca0ddb82b882518$var$pushDispatcher() {
    var prevDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $dca0ddb82b882518$var$ContextOnlyDispatcher : prevDispatcher;
}
function $dca0ddb82b882518$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.A;
    $dca0ddb82b882518$var$ReactSharedInternals.A = $dca0ddb82b882518$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() {
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 4;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings || ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && null !== $dca0ddb82b882518$var$suspenseHandlerStackCursor.current || ($dca0ddb82b882518$var$workInProgressRootIsPrerendering = !0);
    0 === ($dca0ddb82b882518$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $dca0ddb82b882518$var$workInProgressRoot || $dca0ddb82b882518$var$markRootSuspended($dca0ddb82b882518$var$workInProgressRoot, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
}
function $dca0ddb82b882518$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    if ($dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes) $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            var unitOfWork = $dca0ddb82b882518$var$workInProgress, thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $dca0ddb82b882518$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $dca0ddb82b882518$var$workInProgressSuspendedReason;
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $dca0ddb82b882518$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $dca0ddb82b882518$var$workInProgressSuspendedReason, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $dca0ddb82b882518$var$workLoopSync();
        exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$184) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$184);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $dca0ddb82b882518$var$workLoopSync() {
    for(; null !== $dca0ddb82b882518$var$workInProgress;)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    $dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes ? ($dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$prepareFreshStack(root, lanes)) : $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            lanes = $dca0ddb82b882518$var$workInProgress;
            var thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            b: switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 1:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($dca0ddb82b882518$var$isThenableResolved(thrownValue)) {
                        $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                        $dca0ddb82b882518$var$workInProgressThrownValue = null;
                        $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && 9 !== $dca0ddb82b882518$var$workInProgressSuspendedReason || $dca0ddb82b882518$var$workInProgressRoot !== root || ($dca0ddb82b882518$var$workInProgressSuspendedReason = 7);
                        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $dca0ddb82b882518$var$isThenableResolved(thrownValue) ? ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes)) : ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($dca0ddb82b882518$var$workInProgress.tag){
                        case 26:
                            resource = $dca0ddb82b882518$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $dca0ddb82b882518$var$workInProgress;
                            if (resource ? $dca0ddb82b882518$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                                $dca0ddb82b882518$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $dca0ddb82b882518$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($dca0ddb82b882518$var$workInProgress = returnFiber, $dca0ddb82b882518$var$completeUnitOfWork(returnFiber)) : $dca0ddb82b882518$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(462));
            }
        }
        $dca0ddb82b882518$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$186) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$186);
    }
    while (1);
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    if (null !== $dca0ddb82b882518$var$workInProgress) return 0;
    $dca0ddb82b882518$var$workInProgressRoot = null;
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return $dca0ddb82b882518$var$workInProgressRootExitStatus;
}
function $dca0ddb82b882518$var$workLoopConcurrentByScheduler() {
    for(; null !== $dca0ddb82b882518$var$workInProgress && !$dca0ddb82b882518$var$shouldYield();)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$performUnitOfWork(unitOfWork) {
    var next = $dca0ddb82b882518$var$beginWork(unitOfWork.alternate, unitOfWork, $dca0ddb82b882518$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $dca0ddb82b882518$var$resetHooksOnUnwind(next);
            var fiber = next;
            fiber === $dca0ddb82b882518$var$hydrationParentFiber && ($dca0ddb82b882518$var$isHydrating ? ($dca0ddb82b882518$var$popToNextHostParent(fiber), 5 === fiber.tag && null != fiber.stateNode && ($dca0ddb82b882518$var$nextHydratableInstance = fiber.stateNode)) : ($dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0));
        default:
            $dca0ddb82b882518$var$unwindInterruptedWork(current, next), next = $dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$resetWorkInProgress(next, $dca0ddb82b882518$var$entangledRenderLanes), next = $dca0ddb82b882518$var$beginWork(current, next, $dca0ddb82b882518$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$resetHooksOnUnwind(unitOfWork);
    $dca0ddb82b882518$var$thenableState$1 = null;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($dca0ddb82b882518$var$throwException(root, returnFiber, unitOfWork, thrownValue, $dca0ddb82b882518$var$workInProgressRootRenderLanes)) {
            $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
            $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
            $dca0ddb82b882518$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $dca0ddb82b882518$var$workInProgress = returnFiber, error;
        $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
        $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
        $dca0ddb82b882518$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($dca0ddb82b882518$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($dca0ddb82b882518$var$workInProgressRootIsPrerendering || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, root);
    } else $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork);
}
function $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $dca0ddb82b882518$var$unwindUnitOfWork(completedWork, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $dca0ddb82b882518$var$completeWork(completedWork.alternate, completedWork, $dca0ddb82b882518$var$entangledRenderLanes);
        if (null !== next) {
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $dca0ddb82b882518$var$workInProgress = completedWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 5);
}
function $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $dca0ddb82b882518$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $dca0ddb82b882518$var$workInProgress = unitOfWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
    $dca0ddb82b882518$var$workInProgress = null;
}
function $dca0ddb82b882518$var$completeRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedState) {
    root.cancelPendingCommit = null;
    do $dca0ddb82b882518$var$flushPendingEffects();
    while (0 !== $dca0ddb82b882518$var$pendingEffectsStatus);
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(177));
        root === $dca0ddb82b882518$var$workInProgressRoot && ($dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0);
        $dca0ddb82b882518$var$pendingFinishedWork = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsRoot = root;
        $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
        $dca0ddb82b882518$var$pendingPassiveTransitions = transitions;
        $dca0ddb82b882518$var$pendingRecoverableErrors = recoverableErrors;
        $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedState);
    }
}
function $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedState) {
    var remainingLanes = finishedWork.lanes | finishedWork.childLanes;
    $dca0ddb82b882518$var$pendingEffectsRemainingLanes = remainingLanes;
    remainingLanes |= $dca0ddb82b882518$var$concurrentlyUpdatedLanes;
    $dca0ddb82b882518$var$markRootFinished(root, lanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes);
    $dca0ddb82b882518$var$pendingViewTransitionEvents = null;
    (lanes & 335544064) === lanes ? ($dca0ddb82b882518$var$pendingTransitionTypes = $dca0ddb82b882518$var$claimQueuedTransitionTypes(root), spawnedLane = 10262) : ($dca0ddb82b882518$var$pendingTransitionTypes = null, spawnedLane = 10256);
    0 !== (finishedWork.subtreeFlags & spawnedLane) || 0 !== (finishedWork.flags & spawnedLane) ? (root.callbackNode = null, root.callbackPriority = 0, $dca0ddb82b882518$var$scheduleCallback$1($dca0ddb82b882518$var$NormalPriority$1, function() {
        $dca0ddb82b882518$var$flushPassiveEffects();
        return null;
    })) : (root.callbackNode = null, root.callbackPriority = 0);
    $dca0ddb82b882518$var$shouldStartViewTransition = !1;
    spawnedLane = 0 !== (finishedWork.flags & 13878);
    if (0 !== (finishedWork.subtreeFlags & 13878) || spawnedLane) {
        spawnedLane = $dca0ddb82b882518$var$ReactSharedInternals.T;
        $dca0ddb82b882518$var$ReactSharedInternals.T = null;
        updatedLanes = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
        suspendedRetryLanes = $dca0ddb82b882518$var$executionContext;
        $dca0ddb82b882518$var$executionContext |= 4;
        try {
            $dca0ddb82b882518$var$commitBeforeMutationEffects(root, finishedWork, lanes);
        } finally{
            $dca0ddb82b882518$var$executionContext = suspendedRetryLanes, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = updatedLanes, $dca0ddb82b882518$var$ReactSharedInternals.T = spawnedLane;
        }
    }
    $dca0ddb82b882518$var$pendingEffectsStatus = 1;
    $dca0ddb82b882518$var$shouldStartViewTransition ? $dca0ddb82b882518$var$pendingViewTransition = $dca0ddb82b882518$var$startViewTransition(suspendedState, root.containerInfo, $dca0ddb82b882518$var$pendingTransitionTypes, $dca0ddb82b882518$var$flushMutationEffects, $dca0ddb82b882518$var$flushLayoutEffects, $dca0ddb82b882518$var$flushAfterMutationEffects, $dca0ddb82b882518$var$flushSpawnedWork, $dca0ddb82b882518$var$flushPassiveEffects, $dca0ddb82b882518$var$reportViewTransitionError, null, null) : ($dca0ddb82b882518$var$flushMutationEffects(), $dca0ddb82b882518$var$flushLayoutEffects(), $dca0ddb82b882518$var$flushSpawnedWork());
}
function $dca0ddb82b882518$var$reportViewTransitionError(error) {
    if (0 !== $dca0ddb82b882518$var$pendingEffectsStatus) {
        var onRecoverableError = $dca0ddb82b882518$var$pendingEffectsRoot.onRecoverableError;
        onRecoverableError(error, {
            componentStack: null
        });
    }
}
function $dca0ddb82b882518$var$flushAfterMutationEffects() {
    3 === $dca0ddb82b882518$var$pendingEffectsStatus && ($dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$commitAfterMutationEffectsOnFiber($dca0ddb82b882518$var$pendingFinishedWork, $dca0ddb82b882518$var$pendingEffectsRoot), $dca0ddb82b882518$var$pendingEffectsStatus = 4);
}
function $dca0ddb82b882518$var$flushMutationEffects() {
    if (1 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, lanes = $dca0ddb82b882518$var$pendingEffectsLanes, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$inUpdateViewTransition = $dca0ddb82b882518$var$rootViewTransitionAffected = !1;
                $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root, lanes);
                lanes = $dca0ddb82b882518$var$selectionInformation;
                var curFocusedElem = $dca0ddb82b882518$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = lanes.focusedElem, priorSelectionRange = lanes.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $dca0ddb82b882518$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $dca0ddb82b882518$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $dca0ddb82b882518$var$_enabled = !!$dca0ddb82b882518$var$eventsEnabled;
                $dca0ddb82b882518$var$selectionInformation = $dca0ddb82b882518$var$eventsEnabled = null;
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsStatus = 2;
    }
}
function $dca0ddb82b882518$var$flushLayoutEffects() {
    if (2 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 3;
    }
}
function $dca0ddb82b882518$var$flushSpawnedWork() {
    if (4 === $dca0ddb82b882518$var$pendingEffectsStatus || 3 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var committedViewTransition = $dca0ddb82b882518$var$pendingViewTransition;
        $dca0ddb82b882518$var$pendingViewTransition = null;
        $dca0ddb82b882518$var$requestPaint();
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, lanes = $dca0ddb82b882518$var$pendingEffectsLanes, recoverableErrors = $dca0ddb82b882518$var$pendingRecoverableErrors, passiveSubtreeMask = (lanes & 335544064) === lanes ? 10262 : 10256;
        0 !== (finishedWork.subtreeFlags & passiveSubtreeMask) || 0 !== (finishedWork.flags & passiveSubtreeMask) ? $dca0ddb82b882518$var$pendingEffectsStatus = 5 : ($dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$releaseRootPooledCache(root, root.pendingLanes));
        passiveSubtreeMask = root.pendingLanes;
        0 === passiveSubtreeMask && ($dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $dca0ddb82b882518$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot($dca0ddb82b882518$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $dca0ddb82b882518$var$ReactSharedInternals.T;
            passiveSubtreeMask = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $dca0ddb82b882518$var$ReactSharedInternals.T = finishedWork, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = passiveSubtreeMask;
            }
        }
        recoverableErrors = $dca0ddb82b882518$var$pendingViewTransitionEvents;
        onRecoverableError = $dca0ddb82b882518$var$pendingTransitionTypes;
        $dca0ddb82b882518$var$pendingTransitionTypes = null;
        if (null !== recoverableErrors && ($dca0ddb82b882518$var$pendingViewTransitionEvents = null, null === onRecoverableError && (onRecoverableError = []), null !== committedViewTransition)) for(recoverableError = 0; recoverableError < recoverableErrors.length; recoverableError++)finishedWork = (0, recoverableErrors[recoverableError])(onRecoverableError), void 0 !== finishedWork && committedViewTransition.finished.finally(finishedWork);
        0 !== ($dca0ddb82b882518$var$pendingEffectsLanes & 3) && $dca0ddb82b882518$var$flushPendingEffects();
        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
        passiveSubtreeMask = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (passiveSubtreeMask & 42) ? root === $dca0ddb82b882518$var$rootWithNestedUpdates ? $dca0ddb82b882518$var$nestedUpdateCount++ : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = root) : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null);
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $dca0ddb82b882518$var$releaseCache(remainingLanes)));
}
function $dca0ddb82b882518$var$flushPendingEffects() {
    null !== $dca0ddb82b882518$var$pendingViewTransition && ($dca0ddb82b882518$var$pendingViewTransition.skipTransition(), $dca0ddb82b882518$var$pendingViewTransition = null);
    $dca0ddb82b882518$var$flushMutationEffects();
    $dca0ddb82b882518$var$flushLayoutEffects();
    $dca0ddb82b882518$var$flushSpawnedWork();
    return $dca0ddb82b882518$var$flushPassiveEffects();
}
function $dca0ddb82b882518$var$flushPassiveEffects() {
    if (5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return !1;
    var root = $dca0ddb82b882518$var$pendingEffectsRoot, remainingLanes = $dca0ddb82b882518$var$pendingEffectsRemainingLanes;
    $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $dca0ddb82b882518$var$lanesToEventPriority($dca0ddb82b882518$var$pendingEffectsLanes), prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $dca0ddb82b882518$var$ReactSharedInternals.T = null;
        renderPriority = $dca0ddb82b882518$var$pendingPassiveTransitions;
        $dca0ddb82b882518$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $dca0ddb82b882518$var$pendingEffectsRoot, lanes = $dca0ddb82b882518$var$pendingEffectsLanes;
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null;
        $dca0ddb82b882518$var$pendingEffectsLanes = 0;
        if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(331));
        var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
        $dca0ddb82b882518$var$executionContext |= 4;
        $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $dca0ddb82b882518$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $dca0ddb82b882518$var$executionContext = prevExecutionContext;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot($dca0ddb82b882518$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition, $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $dca0ddb82b882518$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($dca0ddb82b882518$var$markRootUpdated$1(rootFiber, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(rootFiber));
}
function $dca0ddb82b882518$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $dca0ddb82b882518$var$createClassErrorUpdate(2);
                instance = $dca0ddb82b882518$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($dca0ddb82b882518$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $dca0ddb82b882518$var$markRootUpdated$1(instance, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $dca0ddb82b882518$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $dca0ddb82b882518$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $dca0ddb82b882518$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $dca0ddb82b882518$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $dca0ddb82b882518$var$workInProgressRoot === root && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $dca0ddb82b882518$var$workInProgressRootExitStatus || 3 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes && 300 > $dca0ddb82b882518$var$now() - $dca0ddb82b882518$var$globalMostRecentFallbackTime ? 0 === ($dca0ddb82b882518$var$executionContext & 2) ? $dca0ddb82b882518$var$prepareFreshStack(root, 0) : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes === $dca0ddb82b882518$var$workInProgressRootRenderLanes && ($dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0));
    $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $dca0ddb82b882518$var$claimNextRetryLane());
    boundaryFiber = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($dca0ddb82b882518$var$markRootUpdated$1(boundaryFiber, retryLane), $dca0ddb82b882518$var$ensureRootIsScheduled(boundaryFiber));
}
function $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$scheduleCallback$1(priorityLevel, callback) {
    return $dca0ddb82b882518$var$scheduleCallback$3(priorityLevel, callback);
}
var $dca0ddb82b882518$var$firstScheduledRoot = null, $dca0ddb82b882518$var$lastScheduledRoot = null, $dca0ddb82b882518$var$didScheduleMicrotask = !1, $dca0ddb82b882518$var$mightHavePendingSyncWork = !1, $dca0ddb82b882518$var$isFlushingWork = !1, $dca0ddb82b882518$var$currentEventTransitionLane = 0;
function $dca0ddb82b882518$var$ensureRootIsScheduled(root) {
    root !== $dca0ddb82b882518$var$lastScheduledRoot && null === root.next && (null === $dca0ddb82b882518$var$lastScheduledRoot ? $dca0ddb82b882518$var$firstScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot = root : $dca0ddb82b882518$var$lastScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot.next = root);
    $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
    $dca0ddb82b882518$var$didScheduleMicrotask || ($dca0ddb82b882518$var$didScheduleMicrotask = !0, $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask());
}
function $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$dca0ddb82b882518$var$isFlushingWork && $dca0ddb82b882518$var$mightHavePendingSyncWork) {
        $dca0ddb82b882518$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$190 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$190;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$190.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$190.suspendedLanes, pingedLanes = root$190.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $dca0ddb82b882518$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$190, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $dca0ddb82b882518$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $dca0ddb82b882518$var$getNextLanes(root$190, root$190 === $dca0ddb82b882518$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$190.cancelPendingCommit || -1 !== root$190.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$190, JSCompiler_inline_result) || (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$190, JSCompiler_inline_result));
                }
                root$190 = root$190.next;
            }
        }while (didPerformSomeWork);
        $dca0ddb82b882518$var$isFlushingWork = !1;
    }
}
function $dca0ddb82b882518$var$processRootScheduleInImmediateTask() {
    $dca0ddb82b882518$var$processRootScheduleInMicrotask();
}
function $dca0ddb82b882518$var$processRootScheduleInMicrotask() {
    $dca0ddb82b882518$var$mightHavePendingSyncWork = $dca0ddb82b882518$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && $dca0ddb82b882518$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $dca0ddb82b882518$var$currentEventTransitionLane);
    for(var currentTime = $dca0ddb82b882518$var$now(), prev = null, root = $dca0ddb82b882518$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $dca0ddb82b882518$var$firstScheduledRoot = next : prev.next = next, null === next && ($dca0ddb82b882518$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus || $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$currentEventTransitionLane = 0);
}
function $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $dca0ddb82b882518$var$workInProgressRoot;
    suspendedLanes = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    suspendedLanes = $dca0ddb82b882518$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
        switch($dca0ddb82b882518$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $dca0ddb82b882518$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $dca0ddb82b882518$var$IdlePriority;
                break;
            default:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
        }
        pingedLanes = $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $dca0ddb82b882518$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($dca0ddb82b882518$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$getNextLanes(root, root === $dca0ddb82b882518$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, $dca0ddb82b882518$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $dca0ddb82b882518$var$performSyncWorkOnRoot(root, lanes) {
    if ($dca0ddb82b882518$var$flushPendingEffects()) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, lanes, !0);
}
function $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask() {
    $dca0ddb82b882518$var$scheduleMicrotask(function() {
        0 !== ($dca0ddb82b882518$var$executionContext & 6) ? $dca0ddb82b882518$var$scheduleCallback$3($dca0ddb82b882518$var$ImmediatePriority, $dca0ddb82b882518$var$processRootScheduleInImmediateTask) : $dca0ddb82b882518$var$processRootScheduleInMicrotask();
    });
}
function $dca0ddb82b882518$var$requestTransitionLane() {
    if (0 === $dca0ddb82b882518$var$currentEventTransitionLane) {
        var actionScopeLane = $dca0ddb82b882518$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $dca0ddb82b882518$var$nextTransitionUpdateLane, $dca0ddb82b882518$var$nextTransitionUpdateLane <<= 1, 0 === ($dca0ddb82b882518$var$nextTransitionUpdateLane & 261888) && ($dca0ddb82b882518$var$nextTransitionUpdateLane = 256));
        $dca0ddb82b882518$var$currentEventTransitionLane = actionScopeLane;
    }
    return $dca0ddb82b882518$var$currentEventTransitionLane;
}
function $dca0ddb82b882518$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $dca0ddb82b882518$var$sanitizeURL(actionProp);
}
function $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $dca0ddb82b882518$var$coerceFormActionProp((nativeEventTarget[$dca0ddb82b882518$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$dca0ddb82b882518$var$internalPropsKey] || null) ? $dca0ddb82b882518$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $dca0ddb82b882518$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $dca0ddb82b882518$var$currentEventTransitionLane) {
                                var formData = new FormData(nativeEventTarget, submitter);
                                $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = new FormData(nativeEventTarget, submitter), $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $dca0ddb82b882518$var$i$jscomp$inline_1667 = 0; $dca0ddb82b882518$var$i$jscomp$inline_1667 < $dca0ddb82b882518$var$simpleEventPluginEvents.length; $dca0ddb82b882518$var$i$jscomp$inline_1667++){
    var $dca0ddb82b882518$var$eventName$jscomp$inline_1668 = $dca0ddb82b882518$var$simpleEventPluginEvents[$dca0ddb82b882518$var$i$jscomp$inline_1667], $dca0ddb82b882518$var$domEventName$jscomp$inline_1669 = $dca0ddb82b882518$var$eventName$jscomp$inline_1668.toLowerCase(), $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1670 = $dca0ddb82b882518$var$eventName$jscomp$inline_1668[0].toUpperCase() + $dca0ddb82b882518$var$eventName$jscomp$inline_1668.slice(1);
    $dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$domEventName$jscomp$inline_1669, "on" + $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1670);
}
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_END, "onAnimationEnd");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_ITERATION, "onAnimationIteration");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_START, "onAnimationStart");
$dca0ddb82b882518$var$registerSimpleEvent("dblclick", "onDoubleClick");
$dca0ddb82b882518$var$registerSimpleEvent("focusin", "onFocus");
$dca0ddb82b882518$var$registerSimpleEvent("focusout", "onBlur");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_RUN, "onTransitionRun");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_START, "onTransitionStart");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_CANCEL, "onTransitionCancel");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_END, "onTransitionEnd");
$dca0ddb82b882518$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $dca0ddb82b882518$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $dca0ddb82b882518$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($dca0ddb82b882518$var$mediaEventTypes));
function $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $dca0ddb82b882518$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($dca0ddb82b882518$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $dca0ddb82b882518$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $dca0ddb82b882518$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $dca0ddb82b882518$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $dca0ddb82b882518$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$dca0ddb82b882518$var$listeningMarker]) {
        rootContainerElement[$dca0ddb82b882518$var$listeningMarker] = !0;
        $dca0ddb82b882518$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($dca0ddb82b882518$var$nonDelegatedEvents.has(domEventName) || $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$dca0ddb82b882518$var$listeningMarker] || (ownerDocument[$dca0ddb82b882518$var$listeningMarker] = !0, $dca0ddb82b882518$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $dca0ddb82b882518$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($dca0ddb82b882518$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $dca0ddb82b882518$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $dca0ddb82b882518$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $dca0ddb82b882518$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$dca0ddb82b882518$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $dca0ddb82b882518$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $dca0ddb82b882518$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $dca0ddb82b882518$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $dca0ddb82b882518$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $dca0ddb82b882518$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTouchEvent;
                        break;
                    case $dca0ddb82b882518$var$ANIMATION_END:
                    case $dca0ddb82b882518$var$ANIMATION_ITERATION:
                    case $dca0ddb82b882518$var$ANIMATION_START:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticAnimationEvent;
                        break;
                    case $dca0ddb82b882518$var$TRANSITION_END:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticPointerEvent;
                        break;
                    case "submit":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticSubmitEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $dca0ddb82b882518$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($dca0ddb82b882518$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                SyntheticEventCtor = "mouseover" === domEventName || "pointerover" === domEventName;
                reactName = "mouseout" === domEventName || "pointerout" === domEventName;
                if (SyntheticEventCtor && nativeEvent !== $dca0ddb82b882518$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$dca0ddb82b882518$var$internalContainerInstanceKey])) break a;
                if (reactName || SyntheticEventCtor) {
                    reactEventType = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (SyntheticEventCtor = nativeEventTarget.ownerDocument) ? SyntheticEventCtor.defaultView || SyntheticEventCtor.parentWindow : window;
                    if (reactName) {
                        if (SyntheticEventCtor = nativeEvent.relatedTarget || nativeEvent.toElement, reactName = targetInst, SyntheticEventCtor = SyntheticEventCtor ? $dca0ddb82b882518$var$getClosestInstanceFromNode(SyntheticEventCtor) : null, null !== SyntheticEventCtor && (accumulateTargetOnly = $dca0ddb82b882518$var$getNearestMountedFiber(SyntheticEventCtor), inCapturePhase = SyntheticEventCtor.tag, SyntheticEventCtor !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) SyntheticEventCtor = null;
                    } else reactName = null, SyntheticEventCtor = targetInst;
                    if (reactName !== SyntheticEventCtor) {
                        inCapturePhase = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $dca0ddb82b882518$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == reactName ? reactEventType : $dca0ddb82b882518$var$getNodeFromInstance(reactName);
                        lastHostComponent = null == SyntheticEventCtor ? reactEventType : $dca0ddb82b882518$var$getNodeFromInstance(SyntheticEventCtor);
                        reactEventType = new inCapturePhase(_instance, instance + "leave", reactName, nativeEvent, nativeEventTarget);
                        reactEventType.target = accumulateTargetOnly;
                        reactEventType.relatedTarget = lastHostComponent;
                        _instance = null;
                        $dca0ddb82b882518$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", SyntheticEventCtor, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        inCapturePhase = reactName && SyntheticEventCtor ? $dca0ddb82b882518$var$getLowestCommonAncestor(reactName, SyntheticEventCtor, $dca0ddb82b882518$var$getParent) : null;
                        null !== reactName && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactEventType, reactName, inCapturePhase, !1);
                        null !== SyntheticEventCtor && null !== accumulateTargetOnly && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, SyntheticEventCtor, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent;
                else if ($dca0ddb82b882518$var$isTextInputElement(reactName)) {
                    if ($dca0ddb82b882518$var$isInputEventSupported) getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $dca0ddb82b882518$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $dca0ddb82b882518$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent) : getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
            }
            handleEventFunc = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($dca0ddb82b882518$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $dca0ddb82b882518$var$activeElement = handleEventFunc, $dca0ddb82b882518$var$activeElementInst = targetInst, $dca0ddb82b882518$var$lastSelection = null;
                    break;
                case "focusout":
                    $dca0ddb82b882518$var$lastSelection = $dca0ddb82b882518$var$activeElementInst = $dca0ddb82b882518$var$activeElement = null;
                    break;
                case "mousedown":
                    $dca0ddb82b882518$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $dca0ddb82b882518$var$mouseDown = !1;
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($dca0ddb82b882518$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($dca0ddb82b882518$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $dca0ddb82b882518$var$isComposing ? $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($dca0ddb82b882518$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $dca0ddb82b882518$var$isComposing && (fallbackData = $dca0ddb82b882518$var$getData()) : ($dca0ddb82b882518$var$root = nativeEventTarget, $dca0ddb82b882518$var$startText = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, $dca0ddb82b882518$var$isComposing = !0)), handleEventFunc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $dca0ddb82b882518$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $dca0ddb82b882518$var$canUseTextInputEvent ? $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $dca0ddb82b882518$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $dca0ddb82b882518$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $dca0ddb82b882518$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $dca0ddb82b882518$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $dca0ddb82b882518$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.push($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $dca0ddb82b882518$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(clientText);
    return $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $dca0ddb82b882518$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            if ("string" === typeof value) "body" === tag || "textarea" === tag && "" === value || $dca0ddb82b882518$var$setTextContent(domElement, value);
            else if ("number" === typeof value || "bigint" === typeof value) "body" !== tag && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            else return;
            break;
        case "className":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            return;
        case "data":
            if ("object" !== tag) {
                $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL(value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $dca0ddb82b882518$var$setProp(domElement, tag, "name", props.name, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($dca0ddb82b882518$var$setProp(domElement, tag, "encType", props.encType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "method", props.method, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL(value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            return;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            return;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            return;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    (null != prevValue ? prevValue.__html : void 0) !== key && (domElement.innerHTML = key);
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $dca0ddb82b882518$var$sanitizeURL(value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "credentialless":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            return;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $dca0ddb82b882518$var$aliases.get(key) || key, $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            else return;
    }
    $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
}
function $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            return;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    (null != prevValue ? prevValue.__html : void 0) !== key && (domElement.innerHTML = key);
                }
            }
            break;
        case "children":
            if ("string" === typeof value) $dca0ddb82b882518$var$setTextContent(domElement, value);
            else if ("number" === typeof value || "bigint" === typeof value) $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            else return;
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            return;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            return;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            return;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            return;
        case "innerText":
        case "textContent":
            return;
        default:
            if (!$dca0ddb82b882518$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), prevValue = key.slice(2, props ? key.length - 7 : void 0), tag = domElement[$dca0ddb82b882518$var$internalPropsKey] || null, tag = null != tag ? tag[key] : null, "function" === typeof tag && domElement.removeEventListener(prevValue, tag, props), "function" === typeof value)) {
                    "function" !== typeof tag && null !== tag && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(prevValue, value, props);
                    break a;
                }
                $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            }
            return;
    }
    $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
}
function $dca0ddb82b882518$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $dca0ddb82b882518$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$204 = props[hasSrc];
                if (null != propValue$204) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$204;
                        break;
                    case "type":
                        propValue = propValue$204;
                        break;
                    case "checked":
                        checked = propValue$204;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$204;
                        break;
                    case "value":
                        propKey = propValue$204;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$204;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$204) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, hasSrc, propValue$204, props, null);
                }
            }
            $dca0ddb82b882518$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $dca0ddb82b882518$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $dca0ddb82b882518$var$mediaEventTypes.length; hasSrc++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement), $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(propValue$204 in props)props.hasOwnProperty(propValue$204) && (hasSrc = props[propValue$204], void 0 !== hasSrc && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propValue$204, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
var $dca0ddb82b882518$var$emptyProps = {};
function $dca0ddb82b882518$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $dca0ddb82b882518$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$221 in nextProps){
                var propKey = nextProps[propKey$221];
                lastProp = lastProps[propKey$221];
                if (nextProps.hasOwnProperty(propKey$221) && (null != propKey || null != lastProp)) switch(propKey$221){
                    case "type":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        type = propKey;
                        break;
                    case "name":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        name = propKey;
                        break;
                    case "checked":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        defaultChecked = propKey;
                        break;
                    case "value":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        value = propKey;
                        break;
                    case "defaultValue":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$221, propKey, nextProps, lastProp);
                }
            }
            $dca0ddb82b882518$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$221 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $dca0ddb82b882518$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    type !== lastDefaultValue && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                    propKey$221 = type;
                    break;
                case "defaultValue":
                    type !== lastDefaultValue && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                    defaultValue = type;
                    break;
                case "multiple":
                    type !== lastDefaultValue && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0), value = type;
                default:
                    type !== lastDefaultValue && $dca0ddb82b882518$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$221 ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, propKey$221, !1) : !!nextProps !== !!lastProps && (null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, tag, !0) : $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$221 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    name !== type && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                    propKey$221 = name;
                    break;
                case "defaultValue":
                    name !== type && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $dca0ddb82b882518$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $dca0ddb82b882518$var$updateTextarea(domElement, propKey$221, propKey);
            return;
        case "option":
            for(var propKey$237 in lastProps)if (propKey$221 = lastProps[propKey$237], lastProps.hasOwnProperty(propKey$237) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$237)) switch(propKey$237){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propKey$237, null, nextProps, propKey$221);
            }
            for(lastDefaultValue in nextProps)if (propKey$221 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$221 !== propKey && (null != propKey$221 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    propKey$221 !== propKey && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                    domElement.selected = propKey$221 && "function" !== typeof propKey$221 && "symbol" !== typeof propKey$221;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, lastDefaultValue, propKey$221, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$242 in lastProps)propKey$221 = lastProps[propKey$242], lastProps.hasOwnProperty(propKey$242) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$242) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$242, null, nextProps, propKey$221);
            for(checked in nextProps)if (propKey$221 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$221 !== propKey && (null != propKey$221 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$221) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, propKey$221, nextProps, propKey);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(var propKey$247 in lastProps)propKey$221 = lastProps[propKey$247], lastProps.hasOwnProperty(propKey$247) && void 0 !== propKey$221 && !nextProps.hasOwnProperty(propKey$247) && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propKey$247, void 0, nextProps, propKey$221);
                for(defaultChecked in nextProps)propKey$221 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$221 === propKey || void 0 === propKey$221 && void 0 === propKey || $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$221, nextProps, propKey);
                return;
            }
    }
    for(var propKey$252 in lastProps)propKey$221 = lastProps[propKey$252], lastProps.hasOwnProperty(propKey$252) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$252) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$252, null, nextProps, propKey$221);
    for(lastProp in nextProps)propKey$221 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$221 === propKey || null == propKey$221 && null == propKey || $dca0ddb82b882518$var$setProp(domElement, tag, lastProp, propKey$221, nextProps, propKey);
}
function $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $dca0ddb82b882518$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $dca0ddb82b882518$var$eventsEnabled = null, $dca0ddb82b882518$var$selectionInformation = null;
function $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $dca0ddb82b882518$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $dca0ddb82b882518$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $dca0ddb82b882518$var$createHoistableInstance(type, props, rootContainerInstance, internalInstanceHandle) {
    rootContainerInstance = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance).createElement(type);
    rootContainerInstance[$dca0ddb82b882518$var$internalInstanceKey] = internalInstanceHandle;
    rootContainerInstance[$dca0ddb82b882518$var$internalPropsKey] = props;
    $dca0ddb82b882518$var$setInitialProperties(rootContainerInstance, type, props);
    $dca0ddb82b882518$var$markNodeAsHoistable(rootContainerInstance);
    return rootContainerInstance;
}
function $dca0ddb82b882518$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
function $dca0ddb82b882518$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $dca0ddb82b882518$var$currentPopstateTransitionEvent) return !1;
        $dca0ddb82b882518$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $dca0ddb82b882518$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $dca0ddb82b882518$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $dca0ddb82b882518$var$localPromise = "function" === typeof Promise ? Promise : void 0, $dca0ddb82b882518$var$localRequestAnimationFrame = "function" === typeof requestAnimationFrame ? requestAnimationFrame : $dca0ddb82b882518$var$scheduleTimeout, $dca0ddb82b882518$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $dca0ddb82b882518$var$localPromise ? function(callback) {
    return $dca0ddb82b882518$var$localPromise.resolve(null).then(callback).catch($dca0ddb82b882518$var$handleErrorInNextTick);
} : $dca0ddb82b882518$var$scheduleTimeout;
function $dca0ddb82b882518$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $dca0ddb82b882518$var$isSingletonScope(type) {
    return "head" === type;
}
function $dca0ddb82b882518$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $dca0ddb82b882518$var$clearSingletonPreambleContribution(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $dca0ddb82b882518$var$clearSingletonPreambleContribution(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$dca0ddb82b882518$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $dca0ddb82b882518$var$clearSingletonPreambleContribution(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
}
function $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $dca0ddb82b882518$var$applyViewTransitionName(instance, name, className) {
    name = CSS.escape(name) !== name ? "r-" + btoa(name).replace(/=/g, "") : name;
    instance.style.viewTransitionName = name;
    null != className && (instance.style.viewTransitionClass = className);
    className = getComputedStyle(instance);
    if ("inline" === className.display) {
        name = instance.getClientRects();
        if (1 === name.length) var JSCompiler_inline_result = 1;
        else for(var i = JSCompiler_inline_result = 0; i < name.length; i++){
            var rect = name[i];
            0 < rect.width && 0 < rect.height && JSCompiler_inline_result++;
        }
        1 === JSCompiler_inline_result && (instance = instance.style, instance.display = 1 === name.length ? "inline-block" : "block", instance.marginTop = "-" + className.paddingTop, instance.marginBottom = "-" + className.paddingBottom);
    }
}
function $dca0ddb82b882518$var$restoreViewTransitionName(instance, props) {
    instance = instance.style;
    props = props.style;
    var viewTransitionName = null != props ? props.hasOwnProperty("viewTransitionName") ? props.viewTransitionName : props.hasOwnProperty("view-transition-name") ? props["view-transition-name"] : null : null;
    instance.viewTransitionName = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : ("" + viewTransitionName).trim();
    viewTransitionName = null != props ? props.hasOwnProperty("viewTransitionClass") ? props.viewTransitionClass : props.hasOwnProperty("view-transition-class") ? props["view-transition-class"] : null : null;
    instance.viewTransitionClass = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : ("" + viewTransitionName).trim();
    "inline-block" === instance.display && (null == props ? instance.display = instance.margin = "" : (viewTransitionName = props.display, instance.display = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : viewTransitionName, viewTransitionName = props.margin, null != viewTransitionName ? instance.margin = viewTransitionName : (viewTransitionName = props.hasOwnProperty("marginTop") ? props.marginTop : props["margin-top"], instance.marginTop = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : viewTransitionName, props = props.hasOwnProperty("marginBottom") ? props.marginBottom : props["margin-bottom"], instance.marginBottom = null == props || "boolean" === typeof props ? "" : props)));
}
function $dca0ddb82b882518$var$createMeasurement(rect, computedStyle, element) {
    element = element.ownerDocument.defaultView;
    return {
        rect: rect,
        abs: "absolute" === computedStyle.position || "fixed" === computedStyle.position,
        clip: "none" !== computedStyle.clipPath || "visible" !== computedStyle.overflow || "none" !== computedStyle.filter || "none" !== computedStyle.mask || "none" !== computedStyle.mask || "0px" !== computedStyle.borderRadius,
        view: 0 <= rect.bottom && 0 <= rect.right && rect.top <= element.innerHeight && rect.left <= element.innerWidth
    };
}
function $dca0ddb82b882518$var$measureInstance(instance) {
    var rect = instance.getBoundingClientRect(), computedStyle = getComputedStyle(instance);
    return $dca0ddb82b882518$var$createMeasurement(rect, computedStyle, instance);
}
function $dca0ddb82b882518$var$measureClonedInstance(instance) {
    var measuredRect = instance.getBoundingClientRect();
    measuredRect = new DOMRect(measuredRect.x + 2e4, measuredRect.y + 2e4, measuredRect.width, measuredRect.height);
    var computedStyle = getComputedStyle(instance);
    return $dca0ddb82b882518$var$createMeasurement(measuredRect, computedStyle, instance);
}
function $dca0ddb82b882518$var$forceLayout(ownerDocument) {
    return ownerDocument.documentElement.clientHeight;
}
function $dca0ddb82b882518$var$waitForImageToLoad(resolve) {
    this.addEventListener("load", resolve);
    this.addEventListener("error", resolve);
}
function $dca0ddb82b882518$var$startViewTransition(suspendedState, rootContainer, transitionTypes, mutationCallback, layoutCallback, afterMutationCallback, spawnedWorkCallback, passiveCallback, errorCallback) {
    var ownerDocument = 9 === rootContainer.nodeType ? rootContainer : rootContainer.ownerDocument;
    try {
        var transition = ownerDocument.startViewTransition({
            update: function() {
                var ownerWindow = ownerDocument.defaultView, pendingNavigation = ownerWindow.navigation && ownerWindow.navigation.transition, previousFontLoadingStatus = ownerDocument.fonts.status;
                mutationCallback();
                var blockingPromises = [];
                "loaded" === previousFontLoadingStatus && ($dca0ddb82b882518$var$forceLayout(ownerDocument), "loading" === ownerDocument.fonts.status && blockingPromises.push(ownerDocument.fonts.ready));
                previousFontLoadingStatus = blockingPromises.length;
                if (null !== suspendedState) for(var suspenseyImages = suspendedState.suspenseyImages, imgBytes = 0, i = 0; i < suspenseyImages.length; i++){
                    var suspenseyImage = suspenseyImages[i];
                    if (!suspenseyImage.complete) {
                        var rect = suspenseyImage.getBoundingClientRect();
                        if (0 < rect.bottom && 0 < rect.right && rect.top < ownerWindow.innerHeight && rect.left < ownerWindow.innerWidth) {
                            imgBytes += $dca0ddb82b882518$var$estimateImageBytes(suspenseyImage);
                            if (imgBytes > $dca0ddb82b882518$var$estimatedBytesWithinLimit) {
                                blockingPromises.length = previousFontLoadingStatus;
                                break;
                            }
                            suspenseyImage = new Promise($dca0ddb82b882518$var$waitForImageToLoad.bind(suspenseyImage));
                            blockingPromises.push(suspenseyImage);
                        }
                    }
                }
                if (0 < blockingPromises.length) return ownerWindow = Promise.race([
                    Promise.all(blockingPromises),
                    new Promise(function(resolve) {
                        return setTimeout(resolve, 500);
                    })
                ]).then(layoutCallback, layoutCallback), (pendingNavigation ? Promise.allSettled([
                    pendingNavigation.finished,
                    ownerWindow
                ]) : ownerWindow).then(afterMutationCallback, afterMutationCallback);
                layoutCallback();
                if (pendingNavigation) return pendingNavigation.finished.then(afterMutationCallback, afterMutationCallback);
                afterMutationCallback();
            },
            types: transitionTypes
        });
        ownerDocument.__reactViewTransition = transition;
        var viewTransitionAnimations = [];
        transition.ready.then(function() {
            for(var animations = ownerDocument.documentElement.getAnimations({
                subtree: !0
            }), i = 0; i < animations.length; i++){
                var animation = animations[i], effect = animation.effect, pseudoElement = effect.pseudoElement;
                if (null != pseudoElement && pseudoElement.startsWith("::view-transition")) {
                    viewTransitionAnimations.push(animation);
                    animation = effect.getKeyframes();
                    for(var height = pseudoElement = void 0, unchangedDimensions = !0, j = 0; j < animation.length; j++){
                        var keyframe = animation[j], w = keyframe.width;
                        if (void 0 === pseudoElement) pseudoElement = w;
                        else if (pseudoElement !== w) {
                            unchangedDimensions = !1;
                            break;
                        }
                        w = keyframe.height;
                        if (void 0 === height) height = w;
                        else if (height !== w) {
                            unchangedDimensions = !1;
                            break;
                        }
                        delete keyframe.width;
                        delete keyframe.height;
                        "none" === keyframe.transform && delete keyframe.transform;
                    }
                    unchangedDimensions && void 0 !== pseudoElement && void 0 !== height && (effect.setKeyframes(animation), unchangedDimensions = getComputedStyle(effect.target, effect.pseudoElement), unchangedDimensions.width !== pseudoElement || unchangedDimensions.height !== height) && (unchangedDimensions = animation[0], unchangedDimensions.width = pseudoElement, unchangedDimensions.height = height, unchangedDimensions = animation[animation.length - 1], unchangedDimensions.width = pseudoElement, unchangedDimensions.height = height, effect.setKeyframes(animation));
                }
            }
            spawnedWorkCallback();
        }, function(error) {
            ownerDocument.__reactViewTransition === transition && (ownerDocument.__reactViewTransition = null);
            try {
                if ("object" === typeof error && null !== error) switch(error.name){
                    case "InvalidStateError":
                        if ("View transition was skipped because document visibility state is hidden." === error.message || "Skipping view transition because document visibility state has become hidden." === error.message || "Skipping view transition because viewport size changed." === error.message || "Transition was aborted because of invalid state" === error.message) error = null;
                }
                null !== error && errorCallback(error);
            } finally{
                mutationCallback(), layoutCallback(), spawnedWorkCallback();
            }
        });
        transition.finished.finally(function() {
            for(var i = 0; i < viewTransitionAnimations.length; i++)viewTransitionAnimations[i].cancel();
            ownerDocument.__reactViewTransition === transition && (ownerDocument.__reactViewTransition = null);
            passiveCallback();
        });
        return transition;
    } catch (x) {
        return mutationCallback(), layoutCallback(), spawnedWorkCallback(), null;
    }
}
function $dca0ddb82b882518$var$ViewTransitionPseudoElement(pseudo, name) {
    this._scope = document.documentElement;
    this._selector = "::view-transition-" + pseudo + "(" + name + ")";
}
$dca0ddb82b882518$var$ViewTransitionPseudoElement.prototype.animate = function(keyframes, options) {
    options = "number" === typeof options ? {
        duration: options
    } : $dca0ddb82b882518$var$assign({}, options);
    options.pseudoElement = this._selector;
    return this._scope.animate(keyframes, options);
};
$dca0ddb82b882518$var$ViewTransitionPseudoElement.prototype.getAnimations = function() {
    for(var scope = this._scope, selector = this._selector, animations = scope.getAnimations({
        subtree: !0
    }), result = [], i = 0; i < animations.length; i++){
        var effect = animations[i].effect;
        null !== effect && effect.target === scope && effect.pseudoElement === selector && result.push(animations[i]);
    }
    return result;
};
$dca0ddb82b882518$var$ViewTransitionPseudoElement.prototype.getComputedStyle = function() {
    return getComputedStyle(this._scope, this._selector);
};
function $dca0ddb82b882518$var$createViewTransitionInstance(name) {
    return {
        name: name,
        group: new $dca0ddb82b882518$var$ViewTransitionPseudoElement("group", name),
        imagePair: new $dca0ddb82b882518$var$ViewTransitionPseudoElement("image-pair", name),
        old: new $dca0ddb82b882518$var$ViewTransitionPseudoElement("old", name),
        new: new $dca0ddb82b882518$var$ViewTransitionPseudoElement("new", name)
    };
}
function $dca0ddb82b882518$var$FragmentInstance(fragmentFiber) {
    this._fragmentFiber = fragmentFiber;
    this._observers = this._eventListeners = null;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.addEventListener = function(type, listener, optionsOrUseCapture) {
    var signal = null, cleanup = null;
    if (null != optionsOrUseCapture && "boolean" !== typeof optionsOrUseCapture && (signal = optionsOrUseCapture.signal || null, null !== signal && signal.aborted)) return;
    null === this._eventListeners && (this._eventListeners = []);
    var listeners = this._eventListeners;
    if (-1 === $dca0ddb82b882518$var$indexOfEventListener(listeners, type, listener, optionsOrUseCapture)) {
        var fragmentInstance = this, attachedListener = listener;
        null != optionsOrUseCapture && "boolean" !== typeof optionsOrUseCapture && !0 === optionsOrUseCapture.once && (attachedListener = function(event) {
            fragmentInstance.removeEventListener(type, listener, optionsOrUseCapture);
            "function" === typeof listener ? listener.call(this, event) : listener.handleEvent(event);
        });
        null !== signal && (cleanup = fragmentInstance.removeEventListener.bind(fragmentInstance, type, listener, optionsOrUseCapture), signal.addEventListener("abort", cleanup, {
            once: !0
        }), cleanup = signal.removeEventListener.bind(signal, "abort", cleanup));
        signal = $dca0ddb82b882518$var$getAttachOptions(optionsOrUseCapture);
        listeners.push({
            type: type,
            listener: listener,
            optionsOrUseCapture: optionsOrUseCapture,
            attachedListener: attachedListener,
            cleanup: cleanup
        });
        $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$addEventListenerToChild, type, attachedListener, signal);
    }
    this._eventListeners = listeners;
};
function $dca0ddb82b882518$var$addEventListenerToChild(child, type, listener, optionsOrUseCapture) {
    $dca0ddb82b882518$var$getInstanceFromHostFiber(child).addEventListener(type, listener, optionsOrUseCapture);
    return !1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.removeEventListener = function(type, listener, optionsOrUseCapture) {
    var listeners = this._eventListeners;
    if (null !== listeners && (listener = $dca0ddb82b882518$var$indexOfEventListener(listeners, type, listener, optionsOrUseCapture), -1 !== listener)) {
        var _listeners$index = listeners[listener];
        optionsOrUseCapture = _listeners$index.attachedListener;
        var cleanup = _listeners$index.cleanup;
        _listeners$index = $dca0ddb82b882518$var$getAttachOptions(_listeners$index.optionsOrUseCapture);
        $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$removeEventListenerFromChild, type, optionsOrUseCapture, _listeners$index);
        listeners.splice(listener, 1);
        null !== cleanup && cleanup();
    }
};
function $dca0ddb82b882518$var$removeEventListenerFromChild(child, type, listener, optionsOrUseCapture) {
    $dca0ddb82b882518$var$getInstanceFromHostFiber(child).removeEventListener(type, listener, optionsOrUseCapture);
    return !1;
}
function $dca0ddb82b882518$var$getAttachOptions(opts) {
    return null != opts && "boolean" !== typeof opts && (!0 === opts.once || opts.signal instanceof AbortSignal) ? {
        capture: opts.capture,
        passive: opts.passive
    } : opts;
}
function $dca0ddb82b882518$var$normalizeListenerOptions(opts) {
    return null == opts ? "c=0" : "boolean" === typeof opts ? "c=" + (opts ? "1" : "0") : "c=" + (opts.capture ? "1" : "0");
}
function $dca0ddb82b882518$var$indexOfEventListener(eventListeners, type, listener, optionsOrUseCapture) {
    if (0 === eventListeners.length) return -1;
    optionsOrUseCapture = $dca0ddb82b882518$var$normalizeListenerOptions(optionsOrUseCapture);
    for(var i = 0; i < eventListeners.length; i++){
        var item = eventListeners[i];
        if (item.type === type && item.listener === listener && $dca0ddb82b882518$var$normalizeListenerOptions(item.optionsOrUseCapture) === optionsOrUseCapture) return i;
    }
    return -1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.dispatchEvent = function(event) {
    var parentHostFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    if (null === parentHostFiber) return !0;
    parentHostFiber = $dca0ddb82b882518$var$getInstanceFromHostFiber(parentHostFiber);
    var eventListeners = this._eventListeners;
    if (null !== eventListeners && 0 < eventListeners.length || !event.bubbles) {
        var temp = 9 === parentHostFiber.nodeType ? parentHostFiber.createComment("") : document.createTextNode("");
        if (eventListeners) for(var i = 0; i < eventListeners.length; i++){
            var _eventListeners$i = eventListeners[i];
            temp.addEventListener(_eventListeners$i.type, _eventListeners$i.attachedListener, $dca0ddb82b882518$var$getAttachOptions(_eventListeners$i.optionsOrUseCapture));
        }
        parentHostFiber.appendChild(temp);
        event = temp.dispatchEvent(event);
        if (eventListeners) for(i = 0; i < eventListeners.length; i++)_eventListeners$i = eventListeners[i], temp.removeEventListener(_eventListeners$i.type, _eventListeners$i.attachedListener, $dca0ddb82b882518$var$getAttachOptions(_eventListeners$i.optionsOrUseCapture));
        parentHostFiber.removeChild(temp);
        return event;
    }
    return parentHostFiber.dispatchEvent(event);
};
$dca0ddb82b882518$var$FragmentInstance.prototype.focus = function(focusOptions) {
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !0, $dca0ddb82b882518$var$setFocusOnFiberIfFocusable, focusOptions, void 0, void 0);
};
function $dca0ddb82b882518$var$setFocusOnFiberIfFocusable(fiber, focusOptions) {
    if (6 === fiber.tag) return !1;
    fiber = $dca0ddb82b882518$var$getInstanceFromHostFiber(fiber);
    return $dca0ddb82b882518$var$setFocusIfFocusable(fiber, focusOptions);
}
$dca0ddb82b882518$var$FragmentInstance.prototype.focusLast = function(focusOptions) {
    var children = [];
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !0, $dca0ddb82b882518$var$collectChildren, children, void 0, void 0);
    for(var i = children.length - 1; 0 <= i && !$dca0ddb82b882518$var$setFocusOnFiberIfFocusable(children[i], focusOptions); i--);
};
function $dca0ddb82b882518$var$collectChildren(child, collection) {
    collection.push(child);
    return !1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.blur = function() {
    var parentHostFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    null !== parentHostFiber && (parentHostFiber = $dca0ddb82b882518$var$getInstanceFromHostFiber(parentHostFiber), parentHostFiber = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(parentHostFiber).activeElement, null !== parentHostFiber && $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$blurActiveElementWithinFragment, parentHostFiber, void 0, void 0));
};
function $dca0ddb82b882518$var$blurActiveElementWithinFragment(child, activeElement) {
    if (6 === child.tag) return !1;
    child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child);
    return child === activeElement || child.contains(activeElement) ? (activeElement.blur(), !0) : !1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.observeUsing = function(observer) {
    null === this._observers && (this._observers = new Set());
    this._observers.add(observer);
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$observeChild, observer, void 0, void 0);
};
function $dca0ddb82b882518$var$observeChild(child, observer) {
    if (6 === child.tag) return !1;
    child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child);
    observer.observe(child);
    return !1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.unobserveUsing = function(observer) {
    var observers = this._observers;
    if (null !== observers && observers.has(observer)) {
        observers.delete(observer);
        $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$unobserveChild, observer, void 0, void 0);
        for(var i = observers = 0; i < $dca0ddb82b882518$var$pendingIntersectionUnobserves.length; i++){
            var pending = $dca0ddb82b882518$var$pendingIntersectionUnobserves[i];
            pending.fragmentInstance === this && pending.observer === observer ? observer.unobserve(pending.instance) : $dca0ddb82b882518$var$pendingIntersectionUnobserves[observers++] = pending;
        }
        $dca0ddb82b882518$var$pendingIntersectionUnobserves.length = observers;
    }
};
function $dca0ddb82b882518$var$unobserveChild(child, observer) {
    if (6 === child.tag) return !1;
    child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child);
    observer.unobserve(child);
    return !1;
}
var $dca0ddb82b882518$var$pendingIntersectionUnobserves = [], $dca0ddb82b882518$var$intersectionUnobserveScheduled = !1;
function $dca0ddb82b882518$var$schedulePendingIntersectionUnobserve(fragmentInstance, observer, instance) {
    $dca0ddb82b882518$var$pendingIntersectionUnobserves.push({
        fragmentInstance: fragmentInstance,
        observer: observer,
        instance: instance
    });
    $dca0ddb82b882518$var$intersectionUnobserveScheduled || ($dca0ddb82b882518$var$intersectionUnobserveScheduled = !0, $dca0ddb82b882518$var$requestPostPaintCallback(function() {
        $dca0ddb82b882518$var$intersectionUnobserveScheduled = !1;
        var pending = $dca0ddb82b882518$var$pendingIntersectionUnobserves;
        $dca0ddb82b882518$var$pendingIntersectionUnobserves = [];
        for(var i = 0; i < pending.length; i++){
            var item = pending[i];
            item.observer.unobserve(item.instance);
        }
    }));
}
$dca0ddb82b882518$var$FragmentInstance.prototype.getClientRects = function() {
    var rects = [];
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$collectClientRects, rects, void 0, void 0);
    return rects;
};
function $dca0ddb82b882518$var$collectClientRects(child, rects) {
    if (6 === child.tag) {
        child = child.stateNode;
        var range = child.ownerDocument.createRange();
        range.selectNodeContents(child);
        rects.push.apply(rects, range.getClientRects());
    } else child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child), rects.push.apply(rects, child.getClientRects());
    return !1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.getRootNode = function(getRootNodeOptions) {
    var parentHostFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    return null === parentHostFiber ? this : $dca0ddb82b882518$var$getInstanceFromHostFiber(parentHostFiber).getRootNode(getRootNodeOptions);
};
$dca0ddb82b882518$var$FragmentInstance.prototype.compareDocumentPosition = function(otherNode) {
    var parentHostFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    if (null === parentHostFiber) return Node.DOCUMENT_POSITION_DISCONNECTED;
    var children = [];
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$collectChildren, children, void 0, void 0);
    var parentHostInstance = $dca0ddb82b882518$var$getInstanceFromHostFiber(parentHostFiber);
    if (0 === children.length) {
        children = parentHostInstance;
        if ($dca0ddb82b882518$var$fiberIsPortaledIntoHost(this._fragmentFiber)) {
            a: {
                for(parentHostFiber = this._fragmentFiber.return; null !== parentHostFiber;){
                    if (4 === parentHostFiber.tag) {
                        parentHostFiber = parentHostFiber.stateNode.containerInfo;
                        break a;
                    }
                    if (3 === parentHostFiber.tag || 5 === parentHostFiber.tag || 27 === parentHostFiber.tag) break;
                    parentHostFiber = parentHostFiber.return;
                }
                parentHostFiber = null;
            }
            null != parentHostFiber && (children = parentHostFiber);
        }
        parentHostFiber = this._fragmentFiber;
        var result = parentHostInstance = children.compareDocumentPosition(otherNode);
        children === otherNode ? result = Node.DOCUMENT_POSITION_CONTAINS : parentHostInstance & Node.DOCUMENT_POSITION_CONTAINED_BY && (children = $dca0ddb82b882518$var$getFragmentInstanceOrTextInstanceSiblings(parentHostFiber)[1], null === children ? result = Node.DOCUMENT_POSITION_PRECEDING : (otherNode = $dca0ddb82b882518$var$getInstanceFromHostFiber(children).compareDocumentPosition(otherNode), result = 0 === otherNode || otherNode & Node.DOCUMENT_POSITION_FOLLOWING ? Node.DOCUMENT_POSITION_FOLLOWING : Node.DOCUMENT_POSITION_PRECEDING));
        return result |= Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
    }
    parentHostFiber = $dca0ddb82b882518$var$getInstanceFromHostFiber(children[0]);
    result = $dca0ddb82b882518$var$getInstanceFromHostFiber(children[children.length - 1]);
    var parentHostInstanceFromDOM = $dca0ddb82b882518$var$fiberIsPortaledIntoHost(this._fragmentFiber) ? parentHostFiber.parentElement : parentHostInstance;
    if (null == parentHostInstanceFromDOM) return Node.DOCUMENT_POSITION_DISCONNECTED;
    parentHostInstance = parentHostInstanceFromDOM.compareDocumentPosition(parentHostFiber) & Node.DOCUMENT_POSITION_CONTAINED_BY;
    parentHostInstanceFromDOM = parentHostInstanceFromDOM.compareDocumentPosition(result) & Node.DOCUMENT_POSITION_CONTAINED_BY;
    var firstResult = parentHostFiber.compareDocumentPosition(otherNode), lastResult = result.compareDocumentPosition(otherNode), otherNodeIsWithinFirstOrLastChild = firstResult & Node.DOCUMENT_POSITION_CONTAINED_BY || lastResult & Node.DOCUMENT_POSITION_CONTAINED_BY;
    lastResult = parentHostInstance && parentHostInstanceFromDOM && firstResult & Node.DOCUMENT_POSITION_FOLLOWING && lastResult & Node.DOCUMENT_POSITION_PRECEDING;
    parentHostFiber = parentHostInstance && parentHostFiber === otherNode || parentHostInstanceFromDOM && result === otherNode || otherNodeIsWithinFirstOrLastChild || lastResult ? Node.DOCUMENT_POSITION_CONTAINED_BY : !parentHostInstance && parentHostFiber === otherNode || !parentHostInstanceFromDOM && result === otherNode ? Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC : firstResult;
    return parentHostFiber & Node.DOCUMENT_POSITION_DISCONNECTED || parentHostFiber & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC || $dca0ddb82b882518$var$validateDocumentPositionWithFiberTree(parentHostFiber, this._fragmentFiber, children[0], children[children.length - 1], otherNode) ? parentHostFiber : Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
};
function $dca0ddb82b882518$var$validateDocumentPositionWithFiberTree(documentPosition, fragmentFiber, precedingBoundaryFiber, followingBoundaryFiber, otherNode) {
    var otherFiber = $dca0ddb82b882518$var$getClosestInstanceFromNode(otherNode);
    if (documentPosition & Node.DOCUMENT_POSITION_CONTAINED_BY) {
        if (precedingBoundaryFiber = !!otherFiber) a: {
            for(; null !== otherFiber;){
                if (7 === otherFiber.tag && (otherFiber === fragmentFiber || otherFiber.alternate === fragmentFiber)) {
                    precedingBoundaryFiber = !0;
                    break a;
                }
                otherFiber = otherFiber.return;
            }
            precedingBoundaryFiber = !1;
        }
        return precedingBoundaryFiber;
    }
    if (documentPosition & Node.DOCUMENT_POSITION_CONTAINS) {
        if (null === otherFiber) return otherFiber = otherNode.ownerDocument, otherNode === otherFiber || otherNode === otherFiber.documentElement || otherNode === otherFiber.body;
        a: {
            otherFiber = fragmentFiber;
            for(fragmentFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(fragmentFiber); null !== otherFiber;){
                if (!(5 !== otherFiber.tag && 3 !== otherFiber.tag && 27 !== otherFiber.tag || otherFiber !== fragmentFiber && otherFiber.alternate !== fragmentFiber)) {
                    otherFiber = !0;
                    break a;
                }
                otherFiber = otherFiber.return;
            }
            otherFiber = !1;
        }
        return otherFiber;
    }
    return documentPosition & Node.DOCUMENT_POSITION_PRECEDING ? ((fragmentFiber = !!otherFiber) && !(fragmentFiber = otherFiber === precedingBoundaryFiber) && (fragmentFiber = $dca0ddb82b882518$var$getLowestCommonAncestor(precedingBoundaryFiber, otherFiber, $dca0ddb82b882518$var$getParentForFragmentAncestors), null === fragmentFiber ? fragmentFiber = !1 : ($dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(fragmentFiber, !0, $dca0ddb82b882518$var$isFiberPrecedingCheck, otherFiber, precedingBoundaryFiber), otherFiber = $dca0ddb82b882518$var$searchTarget, $dca0ddb82b882518$var$searchTarget = null, fragmentFiber = null !== otherFiber)), fragmentFiber) : documentPosition & Node.DOCUMENT_POSITION_FOLLOWING ? ((fragmentFiber = !!otherFiber) && !(fragmentFiber = otherFiber === followingBoundaryFiber) && (fragmentFiber = $dca0ddb82b882518$var$getLowestCommonAncestor(followingBoundaryFiber, otherFiber, $dca0ddb82b882518$var$getParentForFragmentAncestors), null === fragmentFiber ? fragmentFiber = !1 : ($dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(fragmentFiber, !0, $dca0ddb82b882518$var$isFiberFollowingCheck, otherFiber, followingBoundaryFiber), otherFiber = $dca0ddb82b882518$var$searchTarget, $dca0ddb82b882518$var$searchBoundary = $dca0ddb82b882518$var$searchTarget = null, fragmentFiber = null !== otherFiber)), fragmentFiber) : !1;
}
function $dca0ddb82b882518$var$scrollTextNodeIntoView(textNode, resolvedAlignToTop) {
    var range = textNode.ownerDocument.createRange();
    range.selectNodeContents(textNode);
    textNode = range.getBoundingClientRect();
    window.scrollTo(window.scrollX + textNode.left, resolvedAlignToTop ? window.scrollY + textNode.top : window.scrollY + textNode.bottom - window.innerHeight);
}
$dca0ddb82b882518$var$FragmentInstance.prototype.scrollIntoView = function(alignToTop) {
    if ("object" === typeof alignToTop) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(566));
    var children = [];
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$collectChildren, children, void 0, void 0);
    var resolvedAlignToTop = !1 !== alignToTop;
    if (0 === children.length) {
        var hostSiblings = $dca0ddb82b882518$var$getFragmentInstanceOrTextInstanceSiblings(this._fragmentFiber);
        hostSiblings = resolvedAlignToTop ? hostSiblings[1] || hostSiblings[0] || $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber) : hostSiblings[0] || hostSiblings[1];
        if (null === hostSiblings) return;
        if (6 === hostSiblings.tag) {
            alignToTop = $dca0ddb82b882518$var$getInstanceFromHostFiber(hostSiblings);
            $dca0ddb82b882518$var$scrollTextNodeIntoView(alignToTop, resolvedAlignToTop);
            return;
        }
        hostSiblings = $dca0ddb82b882518$var$getInstanceFromHostFiber(hostSiblings);
        if (9 !== hostSiblings.nodeType) {
            if (11 === hostSiblings.nodeType) {
                resolvedAlignToTop = "host" in hostSiblings ? hostSiblings.host : null;
                null !== resolvedAlignToTop && resolvedAlignToTop.scrollIntoView(alignToTop);
                return;
            }
            hostSiblings.scrollIntoView(alignToTop);
        }
    }
    for(hostSiblings = resolvedAlignToTop ? children.length - 1 : 0; hostSiblings !== (resolvedAlignToTop ? -1 : children.length);){
        var child = children[hostSiblings];
        6 === child.tag ? (child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child), $dca0ddb82b882518$var$scrollTextNodeIntoView(child, resolvedAlignToTop)) : $dca0ddb82b882518$var$getInstanceFromHostFiber(child).scrollIntoView(alignToTop);
        hostSiblings += resolvedAlignToTop ? -1 : 1;
    }
};
function $dca0ddb82b882518$var$addFragmentHandleToFiber(child, fragmentInstance) {
    child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child);
    $dca0ddb82b882518$var$addFragmentHandleToInstance(child, fragmentInstance);
    return !1;
}
function $dca0ddb82b882518$var$addFragmentHandleToInstance(instance, fragmentInstance) {
    null == instance.reactFragments && (instance.reactFragments = new Set());
    instance.reactFragments.add(fragmentInstance);
}
function $dca0ddb82b882518$var$commitNewChildToFragmentInstance(childInstance, fragmentInstance) {
    var eventListeners = fragmentInstance._eventListeners;
    if (null !== eventListeners) for(var i$jscomp$0 = 0; i$jscomp$0 < eventListeners.length; i$jscomp$0++){
        var _eventListeners$i3 = eventListeners[i$jscomp$0];
        childInstance.addEventListener(_eventListeners$i3.type, _eventListeners$i3.attachedListener, $dca0ddb82b882518$var$getAttachOptions(_eventListeners$i3.optionsOrUseCapture));
    }
    3 !== childInstance.nodeType && (eventListeners = fragmentInstance._observers, null !== eventListeners && eventListeners.forEach(function(observer) {
        for(var writeIdx = 0, i = 0; i < $dca0ddb82b882518$var$pendingIntersectionUnobserves.length; i++){
            var pending = $dca0ddb82b882518$var$pendingIntersectionUnobserves[i];
            if (pending.fragmentInstance !== fragmentInstance || pending.observer !== observer || pending.instance !== childInstance) $dca0ddb82b882518$var$pendingIntersectionUnobserves[writeIdx++] = pending;
        }
        $dca0ddb82b882518$var$pendingIntersectionUnobserves.length = writeIdx;
        observer.observe(childInstance);
    }), $dca0ddb82b882518$var$addFragmentHandleToInstance(childInstance, fragmentInstance));
}
function $dca0ddb82b882518$var$deleteChildFromFragmentInstance(childInstance, fragmentInstance) {
    var eventListeners = fragmentInstance._eventListeners;
    if (null !== eventListeners) for(var i = 0; i < eventListeners.length; i++){
        var _eventListeners$i4 = eventListeners[i];
        childInstance.removeEventListener(_eventListeners$i4.type, _eventListeners$i4.attachedListener, $dca0ddb82b882518$var$getAttachOptions(_eventListeners$i4.optionsOrUseCapture));
    }
    3 !== childInstance.nodeType && (eventListeners = fragmentInstance._observers, null !== eventListeners && eventListeners.forEach(function(observer) {
        "string" === typeof observer.rootMargin ? $dca0ddb82b882518$var$schedulePendingIntersectionUnobserve(fragmentInstance, observer, childInstance) : observer.unobserve(childInstance);
    }), null != childInstance.reactFragments && childInstance.reactFragments.delete(fragmentInstance));
}
function $dca0ddb82b882518$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $dca0ddb82b882518$var$clearContainerSparingly(node);
                $dca0ddb82b882518$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $dca0ddb82b882518$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$dca0ddb82b882518$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $dca0ddb82b882518$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $dca0ddb82b882518$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $dca0ddb82b882518$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $dca0ddb82b882518$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null;
function $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $dca0ddb82b882518$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$setFocusIfFocusable(node, focusOptions) {
    function handleFocus() {
        didFocus = !0;
    }
    if (node.ownerDocument.activeElement === node) return !0;
    var didFocus = !1;
    try {
        node.ownerDocument.addEventListener("focus", handleFocus, !0), (node.focus || HTMLElement.prototype.focus).call(node, focusOptions);
    } finally{
        node.ownerDocument.removeEventListener("focus", handleFocus, !0);
    }
    return didFocus;
}
function $dca0ddb82b882518$var$requestPostPaintCallback(callback) {
    $dca0ddb82b882518$var$localRequestAnimationFrame(function() {
        $dca0ddb82b882518$var$localRequestAnimationFrame(function(time) {
            return callback(time);
        });
    });
}
function $dca0ddb82b882518$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(451));
    }
}
function $dca0ddb82b882518$var$releaseSingletonInstance(instance, type, props) {
    for(var propKey in props){
        var propValue = props[propKey];
        props.hasOwnProperty(propKey) && null != propValue && $dca0ddb82b882518$var$setProp(instance, type, propKey, null, $dca0ddb82b882518$var$emptyProps, propValue);
    }
    null != props.dangerouslySetInnerHTML && (instance.textContent = "");
    instance.onclick === $dca0ddb82b882518$var$noop$1 && (instance.onclick = null);
    $dca0ddb82b882518$var$detachDeletedInstance(instance);
}
function $dca0ddb82b882518$var$clearSingletonPreambleContribution(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $dca0ddb82b882518$var$detachDeletedInstance(instance);
}
var $dca0ddb82b882518$var$preloadPropsMap = new Map(), $dca0ddb82b882518$var$preconnectsSet = new Set();
function $dca0ddb82b882518$var$getHoistableRoot(container) {
    if ("function" === typeof container.getRootNode) {
        var rootNode = container.getRootNode();
        if (9 === rootNode.nodeType || 11 === rootNode.nodeType) return rootNode;
    }
    return 9 === container.nodeType ? container : container.ownerDocument;
}
var $dca0ddb82b882518$var$previousDispatcher = $dca0ddb82b882518$var$ReactDOMSharedInternals.d;
$dca0ddb82b882518$var$ReactDOMSharedInternals.d = {
    f: $dca0ddb82b882518$var$flushSyncWork,
    r: $dca0ddb82b882518$var$requestFormReset,
    D: $dca0ddb82b882518$var$prefetchDNS,
    C: $dca0ddb82b882518$var$preconnect,
    L: $dca0ddb82b882518$var$preload,
    m: $dca0ddb82b882518$var$preloadModule,
    X: $dca0ddb82b882518$var$preinitScript,
    S: $dca0ddb82b882518$var$preinitStyle,
    M: $dca0ddb82b882518$var$preinitModuleScript
};
function $dca0ddb82b882518$var$flushSyncWork() {
    var previousWasRendering = $dca0ddb82b882518$var$previousDispatcher.f(), wasRendering = $dca0ddb82b882518$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $dca0ddb82b882518$var$requestFormReset(form) {
    var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $dca0ddb82b882518$var$requestFormReset$1(formInst) : $dca0ddb82b882518$var$previousDispatcher.r(form);
}
var $dca0ddb82b882518$var$globalDocument = "undefined" === typeof document ? null : document;
function $dca0ddb82b882518$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $dca0ddb82b882518$var$preconnectsSet.has(limitedEscapedHref) || ($dca0ddb82b882518$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(href, "link", rel), $dca0ddb82b882518$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $dca0ddb82b882518$var$prefetchDNS(href) {
    $dca0ddb82b882518$var$previousDispatcher.D(href);
    $dca0ddb82b882518$var$preconnectAs("dns-prefetch", href, null);
}
function $dca0ddb82b882518$var$preconnect(href, crossOrigin) {
    $dca0ddb82b882518$var$previousDispatcher.C(href, crossOrigin);
    $dca0ddb82b882518$var$preconnectAs("preconnect", href, crossOrigin);
}
function $dca0ddb82b882518$var$preload(href, as, options) {
    $dca0ddb82b882518$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $dca0ddb82b882518$var$getStyleKey(href);
                break;
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!($dca0ddb82b882518$var$preloadPropsMap.has(key) || (href = $dca0ddb82b882518$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))))) {
            var instance = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", href);
            "style" === as && (instance[$dca0ddb82b882518$var$internalLoadPendingKey] = !0, instance.onload = instance.onerror = function() {
                $dca0ddb82b882518$var$clearPendingLoadOnNode(instance);
            });
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            ownerDocument.head.appendChild(instance);
        }
    }
}
function $dca0ddb82b882518$var$preloadModule(href, options) {
    $dca0ddb82b882518$var$previousDispatcher.m(href, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!$dca0ddb82b882518$var$preloadPropsMap.has(key) && (href = $dca0ddb82b882518$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(as, "link", href);
            $dca0ddb82b882518$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $dca0ddb82b882518$var$preinitStyle(href, precedence, options) {
    $dca0ddb82b882518$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $dca0ddb82b882518$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $dca0ddb82b882518$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $dca0ddb82b882518$var$markNodeAsHoistable(link);
                $dca0ddb82b882518$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $dca0ddb82b882518$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $dca0ddb82b882518$var$preinitScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.X(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$preinitModuleScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.M(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $dca0ddb82b882518$var$rootInstanceStackCursor.current) ? $dca0ddb82b882518$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (pendingProps = $dca0ddb82b882518$var$getStyleKey(pendingProps.href), currentProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $dca0ddb82b882518$var$getStyleKey(pendingProps.href);
                var styles$268 = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$269 = styles$268.get(type);
                resource$269 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$269 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$268.set(type, resource$269), (styles$268 = JSCompiler_inline_result.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(type))) ? styles$268._p || (resource$269.instance = styles$268, resource$269.state.loading = 5) : (styles$268 = $dca0ddb82b882518$var$preloadPropsMap.get(type), styles$268 || (styles$268 = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $dca0ddb82b882518$var$preloadPropsMap.set(type, styles$268)), $dca0ddb82b882518$var$preloadStylesheet(JSCompiler_inline_result, type, styles$268, resource$269.state)));
                if (currentProps && null === currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(528, ""));
                return resource$269;
            }
            if (currentProps && null !== currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (pendingProps = $dca0ddb82b882518$var$getScriptKey(pendingProps), currentProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(444, type));
    }
}
function $dca0ddb82b882518$var$getStyleKey(href) {
    return 'href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $dca0ddb82b882518$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $dca0ddb82b882518$var$stylesheetPropsFromRawProps(rawProps) {
    return $dca0ddb82b882518$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $dca0ddb82b882518$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    if (key = ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]")) {
        if (!0 !== key[$dca0ddb82b882518$var$internalLoadPendingKey]) {
            state.loading = 1;
            return;
        }
    } else key = ownerDocument.createElement("link"), key[$dca0ddb82b882518$var$internalLoadPendingKey] = !0, key.onload = key.onerror = $dca0ddb82b882518$var$clearPendingLoadOnNode.bind(null, key), $dca0ddb82b882518$var$setInitialProperties(key, "link", preloadProps), $dca0ddb82b882518$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key);
    state.preload = key;
    key.addEventListener("load", function() {
        return state.loading |= 1;
    });
    key.addEventListener("error", function() {
        return state.loading |= 2;
    });
}
function $dca0ddb82b882518$var$getScriptKey(src) {
    return '[src="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $dca0ddb82b882518$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $dca0ddb82b882518$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $dca0ddb82b882518$var$markNodeAsHoistable(instance), instance;
            var styleProps = $dca0ddb82b882518$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            $dca0ddb82b882518$var$setInitialProperties(instance, "style", styleProps);
            $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $dca0ddb82b882518$var$getStyleKey(props.href);
            var instance$274 = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$274) return resource.state.loading |= 4, resource.instance = instance$274, $dca0ddb82b882518$var$markNodeAsHoistable(instance$274), instance$274;
            instance = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(styleProps)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$274 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance$274);
            var linkInstance = instance$274;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance$274, "link", instance);
            resource.state.loading |= 4;
            $dca0ddb82b882518$var$insertStylesheet(instance$274, props.precedence, hoistableRoot);
            return resource.instance = instance$274;
        case "script":
            instance$274 = $dca0ddb82b882518$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(instance$274))) return resource.instance = styleProps, $dca0ddb82b882518$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(instance$274)) instance = $dca0ddb82b882518$var$assign({}, props), $dca0ddb82b882518$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $dca0ddb82b882518$var$markNodeAsHoistable(styleProps);
            $dca0ddb82b882518$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $dca0ddb82b882518$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $dca0ddb82b882518$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $dca0ddb82b882518$var$tagCaches = null;
function $dca0ddb82b882518$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $dca0ddb82b882518$var$tagCaches) {
        var cache = new Map();
        var caches = $dca0ddb82b882518$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $dca0ddb82b882518$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$dca0ddb82b882518$var$internalHoistableMarker] || node[$dca0ddb82b882518$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $dca0ddb82b882518$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $dca0ddb82b882518$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$maySuspendCommit(type, props) {
    return "img" === type && null != props.src && "" !== props.src && null == props.onLoad && "lazy" !== props.loading;
}
function $dca0ddb82b882518$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $dca0ddb82b882518$var$estimateImageBytes(instance) {
    return (instance.width || 100) * (instance.height || 100) * ("number" === typeof devicePixelRatio ? devicePixelRatio : 1) * 0.25;
}
function $dca0ddb82b882518$var$suspendInstance(state, instance) {
    "function" === typeof instance.decode && (state.imgCount++, instance.complete || (state.imgBytes += $dca0ddb82b882518$var$estimateImageBytes(instance), state.suspenseyImages.push(instance)), state = $dca0ddb82b882518$var$onUnsuspendImg.bind(state), instance.decode().then(state, state));
}
function $dca0ddb82b882518$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $dca0ddb82b882518$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $dca0ddb82b882518$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (key = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $dca0ddb82b882518$var$estimatedBytesWithinLimit = 0;
function $dca0ddb82b882518$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $dca0ddb82b882518$var$estimatedBytesWithinLimit && ($dca0ddb82b882518$var$estimatedBytesWithinLimit = 62500 * $dca0ddb82b882518$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $dca0ddb82b882518$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $dca0ddb82b882518$var$checkIfFullyUnsuspended(state) {
    if (0 === state.count && (0 === state.imgCount || !state.waitingForImages)) {
        if (state.stylesheets) $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
        else if (state.unsuspend) {
            var unsuspend = state.unsuspend;
            state.unsuspend = null;
            unsuspend();
        }
    }
}
function $dca0ddb82b882518$var$onUnsuspend() {
    this.count--;
    $dca0ddb82b882518$var$checkIfFullyUnsuspended(this);
}
function $dca0ddb82b882518$var$onUnsuspendImg() {
    this.imgCount--;
    $dca0ddb82b882518$var$checkIfFullyUnsuspended(this);
}
var $dca0ddb82b882518$var$precedencesByRoot = null;
function $dca0ddb82b882518$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $dca0ddb82b882518$var$precedencesByRoot = new Map(), resources.forEach($dca0ddb82b882518$var$insertStylesheetIntoRoot, state), $dca0ddb82b882518$var$precedencesByRoot = null, $dca0ddb82b882518$var$onUnsuspend.call(state));
}
function $dca0ddb82b882518$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $dca0ddb82b882518$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $dca0ddb82b882518$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $dca0ddb82b882518$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $dca0ddb82b882518$var$HostTransitionContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $dca0ddb82b882518$var$sharedNotPendingObject,
    _currentValue2: $dca0ddb82b882518$var$sharedNotPendingObject,
    _threadCount: 0
};
function $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $dca0ddb82b882518$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $dca0ddb82b882518$var$createLaneMap(0);
    this.hiddenUpdates = $dca0ddb82b882518$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.transitionTypes = null;
    this.incompleteTransitions = new Map();
}
function $dca0ddb82b882518$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $dca0ddb82b882518$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $dca0ddb82b882518$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $dca0ddb82b882518$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $dca0ddb82b882518$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $dca0ddb82b882518$var$emptyContextObject;
    parentComponent = $dca0ddb82b882518$var$emptyContextObject;
    return parentComponent;
}
function $dca0ddb82b882518$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $dca0ddb82b882518$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $dca0ddb82b882518$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(element, rootFiber, lane), $dca0ddb82b882518$var$entangleTransitions(element, rootFiber, lane));
}
function $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
}
function $dca0ddb82b882518$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $dca0ddb82b882518$var$requestUpdateLane();
        lane = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane);
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $dca0ddb82b882518$var$_enabled = !0;
function $dca0ddb82b882518$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 8, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($dca0ddb82b882518$var$_enabled) {
        var blockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer), $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $dca0ddb82b882518$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $dca0ddb82b882518$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $dca0ddb82b882518$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $dca0ddb82b882518$var$ensureRootIsScheduled(fiber);
                                0 === ($dca0ddb82b882518$var$executionContext & 6) && ($dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2), $dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $dca0ddb82b882518$var$getEventTarget(nativeEvent);
    return $dca0ddb82b882518$var$findInstanceBlockingTarget(nativeEvent);
}
var $dca0ddb82b882518$var$return_targetInst = null;
function $dca0ddb82b882518$var$findInstanceBlockingTarget(targetNode) {
    $dca0ddb82b882518$var$return_targetInst = null;
    targetNode = $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $dca0ddb82b882518$var$return_targetInst = targetNode;
    return null;
}
function $dca0ddb82b882518$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "fullscreenerror":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "resize":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($dca0ddb82b882518$var$getCurrentPriorityLevel()){
                case $dca0ddb82b882518$var$ImmediatePriority:
                    return 2;
                case $dca0ddb82b882518$var$UserBlockingPriority:
                    return 8;
                case $dca0ddb82b882518$var$NormalPriority$1:
                case $dca0ddb82b882518$var$LowPriority:
                    return 32;
                case $dca0ddb82b882518$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1, $dca0ddb82b882518$var$queuedFocus = null, $dca0ddb82b882518$var$queuedDrag = null, $dca0ddb82b882518$var$queuedMouse = null, $dca0ddb82b882518$var$queuedPointers = new Map(), $dca0ddb82b882518$var$queuedPointerCaptures = new Map(), $dca0ddb82b882518$var$queuedExplicitHydrationTargets = [], $dca0ddb82b882518$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $dca0ddb82b882518$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $dca0ddb82b882518$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $dca0ddb82b882518$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $dca0ddb82b882518$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $dca0ddb82b882518$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn), null !== blockedOn && $dca0ddb82b882518$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $dca0ddb82b882518$var$queuedFocus = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $dca0ddb82b882518$var$queuedDrag = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $dca0ddb82b882518$var$queuedMouse = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $dca0ddb82b882518$var$queuedPointers.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $dca0ddb82b882518$var$queuedPointerCaptures.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $dca0ddb82b882518$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $dca0ddb82b882518$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $dca0ddb82b882518$var$currentReplayingEvent = null;
        } else return targetContainers = $dca0ddb82b882518$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $dca0ddb82b882518$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $dca0ddb82b882518$var$replayUnblockedEvents() {
    $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1;
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedFocus) && ($dca0ddb82b882518$var$queuedFocus = null);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedDrag) && ($dca0ddb82b882518$var$queuedDrag = null);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedMouse) && ($dca0ddb82b882518$var$queuedMouse = null);
    $dca0ddb82b882518$var$queuedPointers.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
}
function $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $dca0ddb82b882518$var$hasScheduledReplayAttempt || ($dca0ddb82b882518$var$hasScheduledReplayAttempt = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$replayUnblockedEvents)));
}
var $dca0ddb82b882518$var$lastScheduledReplayQueue = null;
function $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $dca0ddb82b882518$var$lastScheduledReplayQueue !== formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = formReplayingQueue, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, function() {
        $dca0ddb82b882518$var$lastScheduledReplayQueue === formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $dca0ddb82b882518$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $dca0ddb82b882518$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $dca0ddb82b882518$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedFocus, unblocked);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedDrag, unblocked);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedMouse, unblocked);
    $dca0ddb82b882518$var$queuedPointers.forEach(unblock);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && (i = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$dca0ddb82b882518$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $dca0ddb82b882518$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$dca0ddb82b882518$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$dca0ddb82b882518$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $dca0ddb82b882518$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $dca0ddb82b882518$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.render = $dca0ddb82b882518$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(409));
    var current = root.current, lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$updateContainerImpl(current, lane, children, root, null, null);
};
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unmount = $dca0ddb82b882518$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $dca0ddb82b882518$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $dca0ddb82b882518$var$flushSyncWork$1();
        container[$dca0ddb82b882518$var$internalContainerInstanceKey] = null;
    }
};
function $dca0ddb82b882518$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $dca0ddb82b882518$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i].priority; i++);
        $dca0ddb82b882518$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $dca0ddb82b882518$var$attemptExplicitHydrationTarget(target);
    }
};
var $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_2043 = $acw62.version;
if ("19.3.1" !== $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_2043) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(527, $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_2043, "19.3.1"));
$dca0ddb82b882518$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $dca0ddb82b882518$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $dca0ddb82b882518$var$internals$jscomp$inline_2586 = {
    bundleType: 0,
    version: "19.3.1",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $dca0ddb82b882518$var$ReactSharedInternals,
    reconcilerVersion: "19.3.1"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $dca0ddb82b882518$var$hook$jscomp$inline_2587 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$dca0ddb82b882518$var$hook$jscomp$inline_2587.isDisabled && $dca0ddb82b882518$var$hook$jscomp$inline_2587.supportsFiber) try {
        $dca0ddb82b882518$var$rendererID = $dca0ddb82b882518$var$hook$jscomp$inline_2587.inject($dca0ddb82b882518$var$internals$jscomp$inline_2586), $dca0ddb82b882518$var$injectedHook = $dca0ddb82b882518$var$hook$jscomp$inline_2587;
    } catch (err) {}
}
$dca0ddb82b882518$export$882461b6382ed46c = function(container, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $dca0ddb82b882518$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = options.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMRoot(options);
};
$dca0ddb82b882518$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $dca0ddb82b882518$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $dca0ddb82b882518$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $dca0ddb82b882518$var$requestUpdateLane();
    isStrictMode = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $dca0ddb82b882518$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $dca0ddb82b882518$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $dca0ddb82b882518$var$markRootUpdated$1(initialChildren, options);
    $dca0ddb82b882518$var$ensureRootIsScheduled(initialChildren);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = initialChildren.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMHydrationRoot(initialChildren);
};
$dca0ddb82b882518$export$83d89fbfd8236492 = "19.3.1";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1wAW3"));

});
parcelRegister("1wAW3", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $11c56e2ffb2d6006$export$c4744153514ff05d, (v) => $11c56e2ffb2d6006$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7, (v) => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $11c56e2ffb2d6006$export$e26fe2ed2fa76875, (v) => $11c56e2ffb2d6006$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $11c56e2ffb2d6006$export$502329bbf4b505b1, (v) => $11c56e2ffb2d6006$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $11c56e2ffb2d6006$export$6e3807111c4874c4, (v) => $11c56e2ffb2d6006$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $11c56e2ffb2d6006$export$c27134553091fb3a, (v) => $11c56e2ffb2d6006$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2, (v) => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $11c56e2ffb2d6006$export$b00a404bbd5edef2, (v) => $11c56e2ffb2d6006$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $11c56e2ffb2d6006$export$d66a1c1c77bd778b, (v) => $11c56e2ffb2d6006$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $11c56e2ffb2d6006$export$d3dfb8e4810cb555, (v) => $11c56e2ffb2d6006$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $11c56e2ffb2d6006$export$72fdf0e06517287b, (v) => $11c56e2ffb2d6006$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $11c56e2ffb2d6006$export$816d2913ae6b83b1, (v) => $11c56e2ffb2d6006$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $11c56e2ffb2d6006$export$61bcfe829111a1d0, (v) => $11c56e2ffb2d6006$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f, (v) => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $11c56e2ffb2d6006$export$b5836b71941fa3ed, (v) => $11c56e2ffb2d6006$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $11c56e2ffb2d6006$export$cf845f2c119da08a, (v) => $11c56e2ffb2d6006$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11c56e2ffb2d6006$export$c4744153514ff05d;
var $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7;
var $11c56e2ffb2d6006$export$e26fe2ed2fa76875;
var $11c56e2ffb2d6006$export$502329bbf4b505b1;
var $11c56e2ffb2d6006$export$6e3807111c4874c4;
var $11c56e2ffb2d6006$export$c27134553091fb3a;
var $11c56e2ffb2d6006$export$33ee1acdc04fd2a2;
var $11c56e2ffb2d6006$export$b00a404bbd5edef2;
var $11c56e2ffb2d6006$export$d66a1c1c77bd778b;
var $11c56e2ffb2d6006$export$d3dfb8e4810cb555;
var $11c56e2ffb2d6006$export$72fdf0e06517287b;
var $11c56e2ffb2d6006$export$816d2913ae6b83b1;
var $11c56e2ffb2d6006$export$61bcfe829111a1d0;
var $11c56e2ffb2d6006$export$7ee8c9beb337bc3f;
var $11c56e2ffb2d6006$export$b5836b71941fa3ed;
var $11c56e2ffb2d6006$export$cf845f2c119da08a;
"use strict";
function $11c56e2ffb2d6006$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $11c56e2ffb2d6006$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $11c56e2ffb2d6006$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $11c56e2ffb2d6006$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $11c56e2ffb2d6006$var$compare(left, last)) rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $11c56e2ffb2d6006$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$11c56e2ffb2d6006$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $11c56e2ffb2d6006$var$localPerformance = performance;
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localPerformance.now();
    };
} else {
    var $11c56e2ffb2d6006$var$localDate = Date, $11c56e2ffb2d6006$var$initialTime = $11c56e2ffb2d6006$var$localDate.now();
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localDate.now() - $11c56e2ffb2d6006$var$initialTime;
    };
}
var $11c56e2ffb2d6006$var$taskQueue = [], $11c56e2ffb2d6006$var$timerQueue = [], $11c56e2ffb2d6006$var$taskIdCounter = 1, $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = 3, $11c56e2ffb2d6006$var$isPerformingWork = !1, $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1, $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$needsPaint = !1, $11c56e2ffb2d6006$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $11c56e2ffb2d6006$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $11c56e2ffb2d6006$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $11c56e2ffb2d6006$var$advanceTimers(currentTime) {
    for(var timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue); null !== timer;){
        if (null === timer.callback) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue);
        else if (timer.startTime <= currentTime) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue), timer.sortIndex = timer.expirationTime, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, timer);
        else break;
        timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
    }
}
function $11c56e2ffb2d6006$var$handleTimeout(currentTime) {
    $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1;
    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
    if (!$11c56e2ffb2d6006$var$isHostCallbackScheduled) {
        if (null !== $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue)) $11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $11c56e2ffb2d6006$var$isMessageLoopRunning = !1, $11c56e2ffb2d6006$var$taskTimeoutID = -1, $11c56e2ffb2d6006$var$frameInterval = 5, $11c56e2ffb2d6006$var$startTime = -1;
function $11c56e2ffb2d6006$var$shouldYieldToHost() {
    return $11c56e2ffb2d6006$var$needsPaint ? !0 : $11c56e2ffb2d6006$export$c4744153514ff05d() - $11c56e2ffb2d6006$var$startTime < $11c56e2ffb2d6006$var$frameInterval ? !1 : !0;
}
function $11c56e2ffb2d6006$var$performWorkUntilDeadline() {
    $11c56e2ffb2d6006$var$needsPaint = !1;
    if ($11c56e2ffb2d6006$var$isMessageLoopRunning) {
        var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
        $11c56e2ffb2d6006$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1;
                $11c56e2ffb2d6006$var$isHostTimeoutScheduled && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1);
                $11c56e2ffb2d6006$var$isPerformingWork = !0;
                var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
                try {
                    b: {
                        $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                        for($11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue); null !== $11c56e2ffb2d6006$var$currentTask && !($11c56e2ffb2d6006$var$currentTask.expirationTime > currentTime && $11c56e2ffb2d6006$var$shouldYieldToHost());){
                            var callback = $11c56e2ffb2d6006$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $11c56e2ffb2d6006$var$currentTask.callback = null;
                                $11c56e2ffb2d6006$var$currentPriorityLevel = $11c56e2ffb2d6006$var$currentTask.priorityLevel;
                                var continuationCallback = callback($11c56e2ffb2d6006$var$currentTask.expirationTime <= currentTime);
                                currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $11c56e2ffb2d6006$var$currentTask.callback = continuationCallback;
                                    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $11c56e2ffb2d6006$var$currentTask === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                                $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                            } else $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                            $11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue);
                        }
                        if (null !== $11c56e2ffb2d6006$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
                            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel, $11c56e2ffb2d6006$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline() : $11c56e2ffb2d6006$var$isMessageLoopRunning = !1;
        }
    }
}
var $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $11c56e2ffb2d6006$var$localSetImmediate) $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetImmediate($11c56e2ffb2d6006$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $11c56e2ffb2d6006$var$channel = new MessageChannel(), $11c56e2ffb2d6006$var$port = $11c56e2ffb2d6006$var$channel.port2;
    $11c56e2ffb2d6006$var$channel.port1.onmessage = $11c56e2ffb2d6006$var$performWorkUntilDeadline;
    $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
        $11c56e2ffb2d6006$var$port.postMessage(null);
    };
} else $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetTimeout($11c56e2ffb2d6006$var$performWorkUntilDeadline, 0);
};
function $11c56e2ffb2d6006$var$requestHostTimeout(callback, ms) {
    $11c56e2ffb2d6006$var$taskTimeoutID = $11c56e2ffb2d6006$var$localSetTimeout(function() {
        callback($11c56e2ffb2d6006$export$c4744153514ff05d());
    }, ms);
}
$11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = 5;
$11c56e2ffb2d6006$export$e26fe2ed2fa76875 = 1;
$11c56e2ffb2d6006$export$502329bbf4b505b1 = 4;
$11c56e2ffb2d6006$export$6e3807111c4874c4 = 3;
$11c56e2ffb2d6006$export$c27134553091fb3a = null;
$11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = 2;
$11c56e2ffb2d6006$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$11c56e2ffb2d6006$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $11c56e2ffb2d6006$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$11c56e2ffb2d6006$export$d3dfb8e4810cb555 = function() {
    return $11c56e2ffb2d6006$var$currentPriorityLevel;
};
$11c56e2ffb2d6006$export$72fdf0e06517287b = function(eventHandler) {
    switch($11c56e2ffb2d6006$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$816d2913ae6b83b1 = function() {
    $11c56e2ffb2d6006$var$needsPaint = !0;
};
$11c56e2ffb2d6006$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $11c56e2ffb2d6006$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$timerQueue, priorityLevel), null === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && priorityLevel === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue) && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled ? ($11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1) : $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !0, $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, priorityLevel), $11c56e2ffb2d6006$var$isHostCallbackScheduled || $11c56e2ffb2d6006$var$isPerformingWork || ($11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$11c56e2ffb2d6006$export$b5836b71941fa3ed = $11c56e2ffb2d6006$var$shouldYieldToHost;
$11c56e2ffb2d6006$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
        $11c56e2ffb2d6006$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("5R2tS"));

});
parcelRegister("5R2tS", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $4433d39f12c5883f$export$69ce8ef3fe5cead0, (v) => $4433d39f12c5883f$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "browser", () => $4433d39f12c5883f$export$3f2684e5d7cb1006, (v) => $4433d39f12c5883f$export$3f2684e5d7cb1006 = v);
$parcel$export(module.exports, "createPortal", () => $4433d39f12c5883f$export$d39a5bbd09211389, (v) => $4433d39f12c5883f$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $4433d39f12c5883f$export$cd75ccfd720a3cd4, (v) => $4433d39f12c5883f$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $4433d39f12c5883f$export$a0816fa17a9e79be, (v) => $4433d39f12c5883f$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $4433d39f12c5883f$export$7292efcadded39f3, (v) => $4433d39f12c5883f$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $4433d39f12c5883f$export$da407abadb9b8f86, (v) => $4433d39f12c5883f$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $4433d39f12c5883f$export$314cfea32580671c, (v) => $4433d39f12c5883f$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $4433d39f12c5883f$export$513ccb98c53b8039, (v) => $4433d39f12c5883f$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $4433d39f12c5883f$export$dbca993bc2d264a, (v) => $4433d39f12c5883f$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $4433d39f12c5883f$export$4797a8006f0655d0, (v) => $4433d39f12c5883f$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $4433d39f12c5883f$export$c78a37762a8d58e1, (v) => $4433d39f12c5883f$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $4433d39f12c5883f$export$606f11b2eb45ecc6, (v) => $4433d39f12c5883f$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $4433d39f12c5883f$export$f7e8a0bf92324b1e, (v) => $4433d39f12c5883f$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $4433d39f12c5883f$export$83d89fbfd8236492, (v) => $4433d39f12c5883f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4433d39f12c5883f$export$69ce8ef3fe5cead0;
var $4433d39f12c5883f$export$3f2684e5d7cb1006;
var $4433d39f12c5883f$export$d39a5bbd09211389;
var $4433d39f12c5883f$export$cd75ccfd720a3cd4;
var $4433d39f12c5883f$export$a0816fa17a9e79be;
var $4433d39f12c5883f$export$7292efcadded39f3;
var $4433d39f12c5883f$export$da407abadb9b8f86;
var $4433d39f12c5883f$export$314cfea32580671c;
var $4433d39f12c5883f$export$513ccb98c53b8039;
var $4433d39f12c5883f$export$dbca993bc2d264a;
var $4433d39f12c5883f$export$4797a8006f0655d0;
var $4433d39f12c5883f$export$c78a37762a8d58e1;
var $4433d39f12c5883f$export$606f11b2eb45ecc6;
var $4433d39f12c5883f$export$f7e8a0bf92324b1e;
var $4433d39f12c5883f$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");
function $4433d39f12c5883f$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $4433d39f12c5883f$var$noop() {}
var $4433d39f12c5883f$var$Internals = {
    d: {
        f: $4433d39f12c5883f$var$noop,
        r: function() {
            throw Error($4433d39f12c5883f$var$formatProdErrorMessage(522));
        },
        D: $4433d39f12c5883f$var$noop,
        C: $4433d39f12c5883f$var$noop,
        L: $4433d39f12c5883f$var$noop,
        m: $4433d39f12c5883f$var$noop,
        X: $4433d39f12c5883f$var$noop,
        S: $4433d39f12c5883f$var$noop,
        M: $4433d39f12c5883f$var$noop
    },
    p: 0,
    findDOMNode: null
}, $4433d39f12c5883f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $4433d39f12c5883f$var$REACT_RECOVERABLE_TYPE = Symbol.for("react.recoverable"), $4433d39f12c5883f$var$REACT_OPTIMISTIC_KEY = Symbol.for("react.optimistic_key");
function $4433d39f12c5883f$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_PORTAL_TYPE,
        key: null == key ? null : key === $4433d39f12c5883f$var$REACT_OPTIMISTIC_KEY ? $4433d39f12c5883f$var$REACT_OPTIMISTIC_KEY : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $4433d39f12c5883f$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $4433d39f12c5883f$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$4433d39f12c5883f$export$69ce8ef3fe5cead0 = $4433d39f12c5883f$var$Internals;
$4433d39f12c5883f$export$3f2684e5d7cb1006 = function(reason) {
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_RECOVERABLE_TYPE,
        _reason: reason
    };
};
$4433d39f12c5883f$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($4433d39f12c5883f$var$formatProdErrorMessage(299));
    return $4433d39f12c5883f$var$createPortal$1(children, container, null, key);
};
$4433d39f12c5883f$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $4433d39f12c5883f$var$ReactSharedInternals.T, previousUpdatePriority = $4433d39f12c5883f$var$Internals.p;
    try {
        if ($4433d39f12c5883f$var$ReactSharedInternals.T = null, $4433d39f12c5883f$var$Internals.p = 2, fn) return fn();
    } finally{
        $4433d39f12c5883f$var$ReactSharedInternals.T = previousTransition, $4433d39f12c5883f$var$Internals.p = previousUpdatePriority, $4433d39f12c5883f$var$Internals.d.f();
    }
};
$4433d39f12c5883f$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $4433d39f12c5883f$var$Internals.d.C(href, options));
};
$4433d39f12c5883f$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $4433d39f12c5883f$var$Internals.d.D(href);
};
$4433d39f12c5883f$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $4433d39f12c5883f$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $4433d39f12c5883f$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$4433d39f12c5883f$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $4433d39f12c5883f$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                    fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
                });
            }
        } else null == options && $4433d39f12c5883f$var$Internals.d.M(href);
    }
};
$4433d39f12c5883f$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin);
        $4433d39f12c5883f$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$4433d39f12c5883f$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $4433d39f12c5883f$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
            });
        } else $4433d39f12c5883f$var$Internals.d.m(href);
    }
};
$4433d39f12c5883f$export$4797a8006f0655d0 = function(form) {
    $4433d39f12c5883f$var$Internals.d.r(form);
};
$4433d39f12c5883f$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$4433d39f12c5883f$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$4433d39f12c5883f$export$f7e8a0bf92324b1e = function() {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$4433d39f12c5883f$export$83d89fbfd8236492 = "19.3.1";

});



parcelRegister("eLeza", function(module, exports) {

$parcel$export(module.exports, "BRAND_DEFAULTS", () => $abf0c103b4b92127$export$c3e10d2aebbc7f30);
$parcel$export(module.exports, "configureBrandFromEnv", () => $abf0c103b4b92127$export$1c31b0413ff44cf2);
$parcel$export(module.exports, "brand", () => $abf0c103b4b92127$export$96ff94e0adb1d772);
$parcel$export(module.exports, "brandRevision", () => $abf0c103b4b92127$export$57a0b7719e4bc93b);
$parcel$export(module.exports, "isIranMarket", () => $abf0c103b4b92127$export$3cede7c619603eb2);
$parcel$export(module.exports, "brandLocales", () => $abf0c103b4b92127$export$1a326f4d00c1e158);
$parcel$export(module.exports, "brandDefaultLocale", () => $abf0c103b4b92127$export$879824979a5b153a);
$parcel$export(module.exports, "calendarSystem", () => $abf0c103b4b92127$export$a350347e69c4c055);
$parcel$export(module.exports, "brandName", () => $abf0c103b4b92127$export$63a39fc1c580d092);
$parcel$export(module.exports, "brandToken", () => $abf0c103b4b92127$export$6281f283246a2f65);
$parcel$export(module.exports, "PLACEHOLDER", () => $abf0c103b4b92127$export$55fc5ffc49a23c34);
$parcel$export(module.exports, "applyBrandTokens", () => $abf0c103b4b92127$export$1508028e88b5e6ae);
$parcel$export(module.exports, "brandString", () => $abf0c103b4b92127$export$62fa8a9cbf8a9cc6);
// ─────────────────────────────────────────────────────────────────────────────
// The brand — what the product is called, what its credit is called, which
// languages it offers, which calendar it reads and which market it serves — and
// how a deployment replaces it.
//
// THE PROBLEM THIS SOLVES
// One set of images runs as Parsina and as another brand (Proxia first). The
// brand is CONFIGURATION, set by the deployment (docs/rebranding/CONTRACT.md):
// the container writes `BRAND_B64` into env.js, the app decodes it at boot and
// hands it here. Everything that says the name — the catalogues' `{{brand}}`,
// the printed prescription's footer, the video call's window title — and
// everything that is Iranian by default rather than by nature — the calendar,
// the phone field's +98, the national-id rule — asks this module.
//
// WHY A REGISTRY
// The same shape as `setUiStrings` (uiStrings.js) and `configureClinical`
// (clinical/src/host.jsx): module state, set once at boot, readable from plain
// functions — a print builder, a phone parser, a locale resolver — and not only
// from components. It is not reactive: a brand does not change while a page is
// open, so it is configured BEFORE the first render and never again.
//
// THE DEFAULTS ARE THE POINT
// Every default below is the literal the framework shipped before it had a
// brand. An app that never calls `configureBrand` renders exactly what it
// rendered before, byte for byte (clinical/__tests__/brandParity.test.js holds
// the resolved catalogues to that). A deployment that configures a brand
// replaces only the fields it sets; a bad value is dropped with ONE console
// warning and its default kept — a brand must never be the reason a panel does
// not start.
//
// Brand is not market (CONTRACT §1.4). `market: 'intl'` does not rename the
// Iranian rails; it hides them (`isIranMarket()`), at the entry points.
// ─────────────────────────────────────────────────────────────────────────────
const $abf0c103b4b92127$var$deepFreeze = (value)=>{
    if (value && typeof value === 'object' && !Object.isFrozen(value)) {
        Object.values(value).forEach($abf0c103b4b92127$var$deepFreeze);
        Object.freeze(value);
    }
    return value;
};
const $abf0c103b4b92127$export$c3e10d2aebbc7f30 = $abf0c103b4b92127$var$deepFreeze({
    id: 'parsina',
    name: {
        fa: "\u067E\u0627\u0631\u0633\u06CC\u0646\u0627",
        en: 'Parsina',
        ar: 'Parsina',
        fr: 'Parsina',
        de: 'Parsina'
    },
    tagline: {
        fa: "\u062F\u0633\u062A\u06CC\u0627\u0631 \u0647\u0648\u0634\u0645\u0646\u062F \u067E\u0632\u0634\u06A9\u06CC",
        en: 'Intelligent Medical Assistant',
        ar: "\u0627\u0644\u0645\u0633\u0627\u0639\u062F \u0627\u0644\u0637\u0628\u064A \u0627\u0644\u0630\u0643\u064A",
        fr: "Assistant m\xe9dical intelligent",
        de: 'Intelligenter medizinischer Assistent'
    },
    // The credit's NAME, a label only — `parseh*` identifiers never change.
    // `faEz` is the Persian ezafe form («پارسهٔ کلینیک»): heh + U+0654.
    walletUnit: {
        fa: "\u067E\u0627\u0631\u0633\u0647",
        faEz: "\u067E\u0627\u0631\u0633\u0647\u0654",
        en: 'Parseh',
        ar: "\u0628\u0627\u0631\u0633\u0647",
        fr: 'Parseh',
        de: 'Parseh'
    },
    // null = the app's own list / default / calendar / market — today's behaviour.
    locales: null,
    defaultLocale: null,
    calendar: null,
    market: null,
    assetPack: null,
    // Per-locale overlay, consulted BEFORE the catalogue: { en: { '<key>': '<text>' } }.
    strings: {}
});
const $abf0c103b4b92127$var$CALENDARS = [
    'jalali',
    'gregory'
];
const $abf0c103b4b92127$var$MARKETS = [
    'ir',
    'intl'
];
const $abf0c103b4b92127$var$SLUG = /^[a-z0-9][a-z0-9-]*$/;
const $abf0c103b4b92127$var$LOCALE_ID = /^[a-z]{2,3}(-[a-z0-9]{2,8})*$/;
let $abf0c103b4b92127$var$configured = $abf0c103b4b92127$var$deepFreeze({}); // what the deployment set, after sanitising
let $abf0c103b4b92127$var$resolved = $abf0c103b4b92127$export$c3e10d2aebbc7f30; // the defaults with `configured` merged over them
let $abf0c103b4b92127$var$revision = 0;
// One warning per message per session — `brandLocales` runs on every render.
const $abf0c103b4b92127$var$warned = new Set();
function $abf0c103b4b92127$var$warnOnce(message) {
    if ($abf0c103b4b92127$var$warned.has(message)) return;
    $abf0c103b4b92127$var$warned.add(message);
    console.warn(`[brand] ${message}`);
}
const $abf0c103b4b92127$var$isPlainObject = (v)=>v != null && typeof v === 'object' && !Array.isArray(v);
const $abf0c103b4b92127$var$nonEmpty = (v)=>typeof v === 'string' && v.trim() !== '';
/** `{ fa: '…', en: '…' }` — keeps the entries whose value is a non-empty string. */ function $abf0c103b4b92127$var$sanitizeMap(value, field, problems) {
    if (!$abf0c103b4b92127$var$isPlainObject(value)) {
        problems.push(`${field} is not an object`);
        return undefined;
    }
    const out = {};
    for (const [key, text] of Object.entries(value))if ($abf0c103b4b92127$var$nonEmpty(text)) out[key] = text;
    else problems.push(`${field}.${key} is not a non-empty string`);
    return out;
}
function $abf0c103b4b92127$var$sanitizeLocales(value, problems) {
    if (!Array.isArray(value) || value.length === 0) {
        problems.push('locales is not a non-empty array');
        return undefined;
    }
    const ids = value.map((id)=>typeof id === 'string' ? id.trim().toLowerCase() : '');
    if (ids.some((id)=>!$abf0c103b4b92127$var$LOCALE_ID.test(id))) {
        problems.push(`locales has an entry that is not a language tag: ${JSON.stringify(value)}`);
        return undefined;
    }
    return [
        ...new Set(ids)
    ];
}
function $abf0c103b4b92127$var$sanitizeStrings(value, problems) {
    if (!$abf0c103b4b92127$var$isPlainObject(value)) {
        problems.push('strings is not an object');
        return undefined;
    }
    const out = {};
    for (const [locale, table] of Object.entries(value)){
        if (!$abf0c103b4b92127$var$isPlainObject(table)) {
            problems.push(`strings.${locale} is not an object`);
            continue;
        }
        const kept = {};
        for (const [key, text] of Object.entries(table)){
            const ok = typeof text === 'string' || Array.isArray(text) && text.every((item)=>typeof item === 'string');
            if (ok) kept[key] = text;
            else problems.push(`strings.${locale}.${key} is not a string`);
        }
        out[locale.toLowerCase()] = kept;
    }
    return out;
}
/**
 * Raw brand JSON → only the fields that are valid, with every problem noted.
 * Unknown fields are ignored without a word: the same object reaches every
 * runtime (CONTRACT §2) and may carry fields only a service reads.
 */ function $abf0c103b4b92127$var$sanitize(input, problems) {
    if (!$abf0c103b4b92127$var$isPlainObject(input)) {
        problems.push('the brand is not a JSON object');
        return {};
    }
    const out = {};
    const scalar = (field, test, normalise = (v)=>v)=>{
        const v = input[field];
        if (v === undefined || v === null) return;
        if (test(v)) out[field] = normalise(v);
        else problems.push(`${field} ${JSON.stringify(v)} is not valid`);
    };
    scalar('id', (v)=>typeof v === 'string' && $abf0c103b4b92127$var$SLUG.test(v));
    scalar('calendar', (v)=>$abf0c103b4b92127$var$CALENDARS.includes(v));
    scalar('market', (v)=>$abf0c103b4b92127$var$MARKETS.includes(v));
    scalar('assetPack', (v)=>typeof v === 'string' && $abf0c103b4b92127$var$SLUG.test(v));
    scalar('defaultLocale', (v)=>typeof v === 'string' && $abf0c103b4b92127$var$LOCALE_ID.test(v.trim().toLowerCase()), (v)=>v.trim().toLowerCase());
    for (const field of [
        'name',
        'tagline',
        'walletUnit'
    ]){
        if (input[field] == null) continue;
        const map = $abf0c103b4b92127$var$sanitizeMap(input[field], field, problems);
        if (map && Object.keys(map).length) out[field] = map;
    }
    if (input.locales != null) {
        const locales = $abf0c103b4b92127$var$sanitizeLocales(input.locales, problems);
        if (locales) out.locales = locales;
    }
    if (input.strings != null) {
        const strings = $abf0c103b4b92127$var$sanitizeStrings(input.strings, problems);
        if (strings) out.strings = strings;
    }
    // A first-visit language the brand does not offer is a contradiction; the
    // list wins, and `brandDefaultLocale` then answers from the list.
    if (out.defaultLocale && out.locales && !out.locales.includes(out.defaultLocale)) {
        problems.push(`defaultLocale "${out.defaultLocale}" is not one of locales`);
        delete out.defaultLocale;
    }
    return out;
}
function $abf0c103b4b92127$export$d9cd1c078c0b61d(word) {
    const w = String(word ?? '');
    if (/ه$/.test(w)) return `${w}\u{654}`;
    if (/[او]$/.test(w)) return `${w}\u{6CC}`;
    return w;
}
function $abf0c103b4b92127$var$merge(clean) {
    const unit = clean.walletUnit || {};
    return $abf0c103b4b92127$var$deepFreeze({
        ...$abf0c103b4b92127$export$c3e10d2aebbc7f30,
        ...clean,
        name: {
            ...$abf0c103b4b92127$export$c3e10d2aebbc7f30.name,
            ...clean.name
        },
        tagline: {
            ...$abf0c103b4b92127$export$c3e10d2aebbc7f30.tagline,
            ...clean.tagline
        },
        walletUnit: {
            ...$abf0c103b4b92127$export$c3e10d2aebbc7f30.walletUnit,
            ...unit,
            faEz: unit.faEz ?? (unit.fa ? $abf0c103b4b92127$export$d9cd1c078c0b61d(unit.fa) : $abf0c103b4b92127$export$c3e10d2aebbc7f30.walletUnit.faEz)
        },
        strings: clean.strings || {}
    });
}
function $abf0c103b4b92127$export$9b06eb23289fc34c(partial) {
    $abf0c103b4b92127$var$revision += 1;
    if (partial === null || partial === undefined) {
        $abf0c103b4b92127$var$configured = $abf0c103b4b92127$var$deepFreeze({});
        $abf0c103b4b92127$var$resolved = $abf0c103b4b92127$export$c3e10d2aebbc7f30;
        return $abf0c103b4b92127$var$resolved;
    }
    const problems = [];
    const clean = $abf0c103b4b92127$var$sanitize(partial, problems);
    if (problems.length) console.warn(`[brand] kept the default for what is not valid: ${problems.join('; ')}`);
    $abf0c103b4b92127$var$configured = $abf0c103b4b92127$var$deepFreeze(clean);
    $abf0c103b4b92127$var$resolved = Object.keys(clean).length ? $abf0c103b4b92127$var$merge(clean) : $abf0c103b4b92127$export$c3e10d2aebbc7f30;
    return $abf0c103b4b92127$var$resolved;
}
function $abf0c103b4b92127$export$3f8f5e31744c04b0(b64) {
    try {
        if (typeof atob !== 'function') return undefined;
        const binary = atob(String(b64).replace(/\s+/g, ''));
        const bytes = Uint8Array.from(binary, (c)=>c.charCodeAt(0));
        return JSON.parse(new TextDecoder('utf-8', {
            fatal: true
        }).decode(bytes));
    } catch  {
        return undefined;
    }
}
function $abf0c103b4b92127$export$1c31b0413ff44cf2(env = typeof window !== 'undefined' ? window.__ENV__ : undefined) {
    const b64 = env?.BRAND_B64;
    if (b64 === undefined || b64 === null || String(b64).trim() === '') return $abf0c103b4b92127$var$resolved;
    const decoded = $abf0c103b4b92127$export$3f8f5e31744c04b0(b64);
    if (decoded === undefined) {
        console.warn("[brand] BRAND_B64 is not base64 of a UTF-8 JSON object \u2014 Parsina defaults kept");
        return $abf0c103b4b92127$export$9b06eb23289fc34c(null);
    }
    return $abf0c103b4b92127$export$9b06eb23289fc34c(decoded);
}
function $abf0c103b4b92127$export$96ff94e0adb1d772() {
    return $abf0c103b4b92127$var$resolved;
}
function $abf0c103b4b92127$export$57a0b7719e4bc93b() {
    return $abf0c103b4b92127$var$revision;
}
function $abf0c103b4b92127$export$3cede7c619603eb2() {
    return $abf0c103b4b92127$var$resolved.market !== 'intl';
}
function $abf0c103b4b92127$export$1a326f4d00c1e158(appLocales) {
    const list = Array.isArray(appLocales) ? appLocales : [];
    const allowed = $abf0c103b4b92127$var$resolved.locales;
    if (!allowed) return list;
    const offered = list.filter((id)=>allowed.includes(String(id).toLowerCase()));
    if (offered.length) return offered;
    $abf0c103b4b92127$var$warnOnce(`locales ${JSON.stringify(allowed)} share nothing with this app's ${JSON.stringify(list)} \u{2014} offering the app's`);
    return list;
}
function $abf0c103b4b92127$export$879824979a5b153a(appDefault, appLocales) {
    const offered = appLocales ? $abf0c103b4b92127$export$1a326f4d00c1e158(appLocales) : $abf0c103b4b92127$var$resolved.locales;
    const wanted = $abf0c103b4b92127$var$resolved.defaultLocale;
    if (wanted && (!offered || offered.includes(wanted))) return wanted;
    if (!offered || offered.includes(appDefault)) return appDefault;
    return offered[0] ?? appDefault;
}
function $abf0c103b4b92127$export$a350347e69c4c055(appDefault = null) {
    return $abf0c103b4b92127$var$resolved.calendar || appDefault;
}
// ── Text ─────────────────────────────────────────────────────────────────────
/** A per-locale map read for `locale`: exact, then the base language, then English. */ function $abf0c103b4b92127$var$pick(map, locale) {
    if (!map) return undefined;
    const id = String(locale || '').toLowerCase();
    if (map[id] !== undefined) return map[id];
    const base = id.split(/[-_]/)[0];
    if (map[base] !== undefined) return map[base];
    return map.en;
}
/** What the deployment itself set for `field` in `locale`, or undefined. */ const $abf0c103b4b92127$var$configuredIn = (field, locale)=>{
    const map = $abf0c103b4b92127$var$configured[field];
    if (!map) return undefined;
    const id = String(locale || '').toLowerCase();
    return map[id] ?? map[id.split(/[-_]/)[0]];
};
function $abf0c103b4b92127$export$63a39fc1c580d092(locale) {
    return $abf0c103b4b92127$var$pick($abf0c103b4b92127$var$resolved.name, locale);
}
function $abf0c103b4b92127$export$6281f283246a2f65(name, locale, inline) {
    const has = inline !== undefined && inline !== null;
    switch(name){
        case 'brand':
            {
                const set = $abf0c103b4b92127$var$configuredIn('name', locale);
                return set ?? (has ? inline : $abf0c103b4b92127$var$pick($abf0c103b4b92127$var$resolved.name, locale));
            }
        case 'coin':
            {
                const set = $abf0c103b4b92127$var$configuredIn('walletUnit', locale);
                return set ?? (has ? inline : $abf0c103b4b92127$var$pick($abf0c103b4b92127$var$resolved.walletUnit, locale));
            }
        case 'coinEz':
            {
                const unit = $abf0c103b4b92127$var$configured.walletUnit;
                const set = unit && (unit.faEz ?? (unit.fa ? $abf0c103b4b92127$export$d9cd1c078c0b61d(unit.fa) : undefined));
                return set ?? (has ? inline : $abf0c103b4b92127$var$resolved.walletUnit.faEz);
            }
        case 'tagline':
            {
                const set = $abf0c103b4b92127$var$configuredIn('tagline', locale);
                return set ?? (has ? inline : $abf0c103b4b92127$var$pick($abf0c103b4b92127$var$resolved.tagline, locale));
            }
        default:
            return undefined;
    }
}
const $abf0c103b4b92127$export$936dfa1128462f2c = Object.freeze([
    'brand',
    'coin',
    'coinEz',
    'tagline'
]);
function $abf0c103b4b92127$export$168e20da34ba5ff3(locale) {
    return {
        brand: $abf0c103b4b92127$export$6281f283246a2f65('brand', locale),
        coin: $abf0c103b4b92127$export$6281f283246a2f65('coin', locale),
        coinEz: $abf0c103b4b92127$export$6281f283246a2f65('coinEz', locale),
        tagline: $abf0c103b4b92127$export$6281f283246a2f65('tagline', locale)
    };
}
const $abf0c103b4b92127$export$55fc5ffc49a23c34 = /\{\{\s*([\w.]+)\s*(?:\|([^{}]*?))?\s*\}\}/g;
function $abf0c103b4b92127$export$1508028e88b5e6ae(text, locale) {
    if (typeof text !== 'string' || text.indexOf('{{') === -1) return text;
    return text.replace($abf0c103b4b92127$export$55fc5ffc49a23c34, (match, name, inline)=>{
        const value = $abf0c103b4b92127$export$6281f283246a2f65(name, locale, inline);
        return value === undefined ? match : value;
    });
}
function $abf0c103b4b92127$export$62fa8a9cbf8a9cc6(locale, key) {
    const table = $abf0c103b4b92127$var$resolved.strings;
    const id = String(locale || '').toLowerCase();
    const own = table[id] ?? table[id.split(/[-_]/)[0]];
    if (!own) return undefined;
    return Object.prototype.hasOwnProperty.call(own, key) ? own[key] : undefined;
}

});

parcelRegister("5u54r", function(module, exports) {

$parcel$export(module.exports, "setClinicalClinicId", () => $0107cd2950f0456c$export$fe95d20db2db334f);
$parcel$export(module.exports, "setClinicalDefaultUploadKind", () => $0107cd2950f0456c$export$1cd548b9db27e203);

var $e317r = parcelRequire("e317r");

var $b9X92 = parcelRequire("b9X92");

var $iAkVL = parcelRequire("iAkVL");

var $5qKOB = parcelRequire("5qKOB");

var $58BYB = parcelRequire("58BYB");
// The clinic panel as a HOST of the clinical module (docs/CLINICAL_KIT_DESIGN.md).
//
// The visit room and the patient record are @parsina/framework/clinical — the
// SAME code the doctor panel renders. A doctor who also runs this clinic works
// them here, inside this panel, instead of being sent to another app. Two facts
// make that work without a line of clinical logic living in this repo:
//
//   1. They talk to the DOCTOR BFF, not this panel's. That is where visits,
//      notes, orders and the AI are, and it scopes every one of them to the
//      token's `sub` — this panel's token is the same Keycloak client's, so the
//      doctor BFF sees the same person it would in the doctor panel. The clinic
//      BFF exposes none of those operations and must not grow copies of them.
//   2. They send NO clinic header. The doctor BFF would read `x-active-clinic-id`
//      into the clinic of every write — orders, invoices — so the visit makes
//      exactly the requests it makes in the doctor panel.
//
// Imported first by App.jsx: configuration must precede the first render.
let $0107cd2950f0456c$var$clinicId = '';
function $0107cd2950f0456c$export$fe95d20db2db334f(id) {
    $0107cd2950f0456c$var$clinicId = id || '';
}
// The kind a file starts as when staff add one to a patient's record — what the
// clinic chose in Settings (PM-0684), or null for the kit's own آزمایش.
let $0107cd2950f0456c$var$defaultUploadKind = null;
function $0107cd2950f0456c$export$1cd548b9db27e203(kind) {
    $0107cd2950f0456c$var$defaultUploadKind = kind || null;
}
(0, $e317r.configureClinical)({
    bffUrl: (0, $iAkVL.DOCTOR_BFF_URL),
    auth: {
        getToken: $58BYB.getToken,
        getRefresh: $58BYB.getRefresh,
        getValidToken: $58BYB.getValidToken,
        refreshAccessToken: $58BYB.refreshAccessToken,
        logout: $58BYB.logout,
        parseJwt: $58BYB.parseJwt,
        isTokenExpired: $58BYB.isTokenExpired
    },
    activeClinicId: ()=>$0107cd2950f0456c$var$clinicId,
    // Read when a file is added, so a choice saved a moment ago applies at once. The
    // doctor panel passes nothing and keeps آزمایش. A kit before the release that
    // reads it ignores the key.
    defaultUploadKind: ()=>$0107cd2950f0456c$var$defaultUploadKind,
    // The clinic's wall clock (PM-0088), read when the kit asks: the visit room's
    // «امروز» decides whether an order sits in this visit and on its invoice, and
    // the service judges that on the clinic's day (PM-0618 §7.2, PM-0635(2)).
    // A kit before v0.27.0 ignores the key.
    clinicTimeZone: ()=>(0, $5qKOB.getClinicZone)()
});
// A dead session inside a visit ends the way it does everywhere else in this
// panel: back through Keycloak, to the page the person was on (redirectToLogin
// stashes it). The visit room keeps its own unsaved draft across that trip.
(0, $b9X92.onSessionEvent)((event)=>{
    if (event === (0, $b9X92.SessionEvent).EXPIRED) (0, $58BYB.redirectToLogin)();
});

});
parcelRegister("e317r", function(module, exports) {

$parcel$export(module.exports, "configureClinical", () => $a2c818bd066c02a1$export$ea0e7255dd85d322);
$parcel$export(module.exports, "hostBffUrl", () => $a2c818bd066c02a1$export$20af24a32eacf994);
$parcel$export(module.exports, "hostWsBase", () => $a2c818bd066c02a1$export$3b6b531768f3bab4);
$parcel$export(module.exports, "hostAuth", () => $a2c818bd066c02a1$export$52577b4f7e562784);
$parcel$export(module.exports, "hostActiveClinicId", () => $a2c818bd066c02a1$export$eb4e3d365e278024);
$parcel$export(module.exports, "hostVisitNow", () => $a2c818bd066c02a1$export$691735f88d76f4c6);
$parcel$export(module.exports, "hostDefaultUploadKind", () => $a2c818bd066c02a1$export$19185c9678d61fac);
$parcel$export(module.exports, "hostClinicTimeZone", () => $a2c818bd066c02a1$export$7e19874bce3b677);
$parcel$export(module.exports, "ClinicalHostProvider", () => $a2c818bd066c02a1$export$3bbc25d04279abb7);
$parcel$export(module.exports, "useClinicalHost", () => $a2c818bd066c02a1$export$746c366fc2da5120);
$parcel$export(module.exports, "useCapability", () => $a2c818bd066c02a1$export$12f4a5dc7ca76777);
$parcel$export(module.exports, "useIranianRails", () => $a2c818bd066c02a1$export$2d5b1aaea152528e);

var $acw62 = parcelRequire("acw62");

var $lHVFz = parcelRequire("lHVFz");

var $eLeza = parcelRequire("eLeza");
/**
 * The clinical module's HOST — everything the Visit and Patient Details screens
 * need from the application that renders them, and nothing else.
 *
 * The screens are the same code in the doctor panel and the clinic panel. What
 * differs is WHERE they live: which BFF they talk to and with which token, how
 * «back» and «top up credits» are routed, and what surrounds them. That is all a
 * host supplies. Clinical behaviour — what a visit is, what is saved when, what
 * the AI is asked — is never a host decision.
 *
 * Two halves, because the code that needs them runs in two different places:
 *
 *   configureClinical({...})  — module-level, set ONCE at boot, for code that
 *                               runs outside React: the GraphQL transport, the
 *                               transcription WebSocket, DICOM fetches.
 *   <ClinicalHostProvider>    — React context, for what changes per render:
 *                               navigation and the current pathname.
 *
 * Neither half grants anything. The doctor BFF scopes every visit to the token's
 * `sub` — a doctor reads only the visits they performed, and what was recorded in
 * them (PM-0599); refusing a patient the doctor may not open at all is PM-0615.
 * A host that mounts these screens for someone else gets nothing more than what
 * that BFF answers for the token it carries.
 */ const $a2c818bd066c02a1$var$DEFAULT_BFF_URL = 'https://api.parsinabot.ir/graphql';
const $a2c818bd066c02a1$var$deriveWsBase = (url)=>String(url || '').replace(/^https/, 'wss').replace(/^http/, 'ws').replace(/\/graphql\/?$/, '');
const $a2c818bd066c02a1$var$noAuth = {
    getToken: ()=>null,
    getRefresh: ()=>null,
    getValidToken: async ()=>null,
    refreshAccessToken: async ()=>false,
    logout: ()=>{}
};
let $a2c818bd066c02a1$var$host = {
    bffUrl: $a2c818bd066c02a1$var$DEFAULT_BFF_URL,
    wsBase: null,
    auth: $a2c818bd066c02a1$var$noAuth,
    /** The clinic the upload/record screens should default to, or '' for none. */ activeClinicId: null,
    /** What the clinic's country allows (PM-0218), or null: unknown — behave as before. */ capabilities: null,
    /** The clinic's IANA zone (`Membership.timezone`, PM-0088), or null: unknown. */ clinicTimeZone: null
};
function $a2c818bd066c02a1$export$ea0e7255dd85d322(cfg = {}) {
    $a2c818bd066c02a1$var$host = {
        ...$a2c818bd066c02a1$var$host,
        ...cfg,
        auth: {
            ...$a2c818bd066c02a1$var$noAuth,
            ...$a2c818bd066c02a1$var$host.auth,
            ...cfg.auth || {}
        }
    };
    return $a2c818bd066c02a1$var$host;
}
const $a2c818bd066c02a1$var$read = (v)=>typeof v === 'function' ? v() : v;
function $a2c818bd066c02a1$export$6268306c4a1a8f2a() {
    return $a2c818bd066c02a1$var$host;
}
const $a2c818bd066c02a1$export$20af24a32eacf994 = ()=>$a2c818bd066c02a1$var$read($a2c818bd066c02a1$var$host.bffUrl) || $a2c818bd066c02a1$var$DEFAULT_BFF_URL;
const $a2c818bd066c02a1$export$3b6b531768f3bab4 = ()=>$a2c818bd066c02a1$var$read($a2c818bd066c02a1$var$host.wsBase) || $a2c818bd066c02a1$var$deriveWsBase($a2c818bd066c02a1$export$20af24a32eacf994());
const $a2c818bd066c02a1$export$52577b4f7e562784 = ()=>$a2c818bd066c02a1$var$host.auth;
const $a2c818bd066c02a1$export$eb4e3d365e278024 = ()=>{
    const v = $a2c818bd066c02a1$var$read($a2c818bd066c02a1$var$host.activeClinicId);
    return v == null ? null : String(v);
};
const $a2c818bd066c02a1$export$691735f88d76f4c6 = ()=>$a2c818bd066c02a1$var$read($a2c818bd066c02a1$var$host.visitNow) === true;
const $a2c818bd066c02a1$export$19185c9678d61fac = ()=>{
    const v = $a2c818bd066c02a1$var$read($a2c818bd066c02a1$var$host.defaultUploadKind);
    return typeof v === 'string' && v ? v : null;
};
const $a2c818bd066c02a1$var$knownZones = new Map();
/** `zone` when this browser's Intl knows it, else null — never a throw on a bad value. */ function $a2c818bd066c02a1$var$validZone(zone) {
    if (typeof zone !== 'string' || !zone.trim()) return null;
    const z = zone.trim();
    if (!$a2c818bd066c02a1$var$knownZones.has(z)) {
        let ok = true;
        try {
            new Intl.DateTimeFormat('en-CA', {
                timeZone: z
            });
        } catch  {
            ok = false;
        }
        $a2c818bd066c02a1$var$knownZones.set(z, ok);
    }
    return $a2c818bd066c02a1$var$knownZones.get(z) ? z : null;
}
const $a2c818bd066c02a1$export$7e19874bce3b677 = ()=>$a2c818bd066c02a1$var$validZone($a2c818bd066c02a1$var$read($a2c818bd066c02a1$var$host.clinicTimeZone));
const $a2c818bd066c02a1$var$capabilitiesOrNull = (v)=>v && typeof v === 'object' && !Array.isArray(v) ? v : null;
const $a2c818bd066c02a1$export$15b252e68ca83dfd = ()=>$a2c818bd066c02a1$var$capabilitiesOrNull($a2c818bd066c02a1$var$read($a2c818bd066c02a1$var$host.capabilities));
// ── Per-render half ─────────────────────────────────────────────────────────
const $a2c818bd066c02a1$var$warn = (what)=>()=>{
        // Returning quietly is what made a missing route in the doctor panel so hard to
        // see (useAppNavigate's own note). A host that forgot to wire an intent says so.
        console.warn(`[clinical] the host provides no ${what}`);
    };
const $a2c818bd066c02a1$var$DEFAULT_NAV = {
    navigate: $a2c818bd066c02a1$var$warn('navigate()'),
    back: $a2c818bd066c02a1$var$warn('back()'),
    pathname: '',
    clinicCurrency: '',
    capabilities: null
};
const $a2c818bd066c02a1$var$HostContext = /*#__PURE__*/ (0, $acw62.createContext)($a2c818bd066c02a1$var$DEFAULT_NAV);
function $a2c818bd066c02a1$export$3bbc25d04279abb7({ navigate: navigate, back: back, pathname: pathname = '', clinicCurrency: clinicCurrency = '', capabilities: capabilities = null, children: children }) {
    const value = (0, $acw62.useMemo)(()=>({
            navigate: navigate || $a2c818bd066c02a1$var$DEFAULT_NAV.navigate,
            back: back || $a2c818bd066c02a1$var$DEFAULT_NAV.back,
            pathname: pathname,
            clinicCurrency: clinicCurrency || '',
            capabilities: $a2c818bd066c02a1$var$capabilitiesOrNull(capabilities)
        }), [
        navigate,
        back,
        pathname,
        clinicCurrency,
        capabilities
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a2c818bd066c02a1$var$HostContext.Provider, {
        value: value
    }, children);
}
function $a2c818bd066c02a1$export$746c366fc2da5120() {
    return (0, $acw62.useContext)($a2c818bd066c02a1$var$HostContext);
}
// The capabilities in force: the provider's, else configureClinical's, else null.
function $a2c818bd066c02a1$var$useCapabilities() {
    return (0, $acw62.useContext)($a2c818bd066c02a1$var$HostContext).capabilities || $a2c818bd066c02a1$export$15b252e68ca83dfd();
}
function $a2c818bd066c02a1$export$12f4a5dc7ca76777(key) {
    const caps = $a2c818bd066c02a1$var$useCapabilities();
    return caps ? caps[key] : undefined;
}
// The one e-prescription provider the Iranian rails are (op-naji).
const $a2c818bd066c02a1$var$IRANIAN_ERX = 'opnaji';
function $a2c818bd066c02a1$export$2d5b1aaea152528e() {
    const { clinicCurrency: clinicCurrency } = (0, $acw62.useContext)($a2c818bd066c02a1$var$HostContext);
    const caps = $a2c818bd066c02a1$var$useCapabilities();
    if (!(0, $eLeza.isIranMarket)()) return false;
    if ((0, $lHVFz.isClinicCurrency)(clinicCurrency) && clinicCurrency !== (0, $lHVFz.DEFAULT_CURRENCY)) return false;
    return caps ? caps.erx === $a2c818bd066c02a1$var$IRANIAN_ERX : true;
}

});
parcelRegister("lHVFz", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_CURRENCY", () => $fcda591c8cd139a4$export$c19ece7ea27dcd9e);
$parcel$export(module.exports, "CURRENCY_CODES", () => $fcda591c8cd139a4$export$729c9ac211f2ddda);
$parcel$export(module.exports, "isClinicCurrency", () => $fcda591c8cd139a4$export$68d15a182c6bcbf0);
$parcel$export(module.exports, "currencyInfo", () => $fcda591c8cd139a4$export$272b829bb65f9e96);
$parcel$export(module.exports, "toDisplay", () => $fcda591c8cd139a4$export$57a9131fd362a631);
$parcel$export(module.exports, "fromDisplay", () => $fcda591c8cd139a4$export$22f3da351f420435);
$parcel$export(module.exports, "parseAmount", () => $fcda591c8cd139a4$export$b94f7550e5b92f9c);
$parcel$export(module.exports, "formatAmount", () => $fcda591c8cd139a4$export$e251d23bea783311);
$parcel$export(module.exports, "unitLabel", () => $fcda591c8cd139a4$export$846d8329e0c3da65);
// ─────────────────────────────────────────────────────────────────────────────
// Currency — clinic money in the currency the clinic keeps its books in.
//
// `money.js` was written for one currency: whole RIALS on the wire, TOMAN in front
// of a human. That stays true for every Iranian clinic, byte for byte. A clinic may
// now keep its books in another currency, and this module is the one place that
// knows what each allowed currency looks like:
//
//   • ON THE WIRE an amount is an integer number of MINOR UNITS of the document's
//     currency — whole rials for IRR (exponent 0, a deliberate override of ISO's 2),
//     cents for USD, fils for KWD. Field names ending in `Rial` keep their names and
//     now mean "minor units of this row's `currency`".
//   • IN FRONT OF A HUMAN an amount is divided by `displayDivisor`. That is NOT
//     10**exponent: IRR's divisor is 10, because an Iranian reads toman.
//   • An EMPTY or ABSENT currency means IRR. That is how an older server, a lagging
//     proto copy or a historical row degrades to today's behaviour.
//   • Amounts in two currencies are never added, compared or charted together.
//     There is no exchange rate anywhere in Parsina: group (`sumByCurrency`) or
//     refuse (`assertSameCurrency` → MIXED_CURRENCY).
//
// For IRR every function here returns exactly what money.js returns today:
// `formatAmount(x, 'IRR')` is `fmtToman(x)`, `toDisplay` is `rialToToman`,
// `fromDisplay` is `tomanToRial` and `parseAmount` is `parseTomanToRial` for every
// input that one accepts. The tests hold each pair against the other. Both parsers
// read money.js's notation — a «.» decimal — unless the caller names a language
// that writes a decimal COMMA (French «1 234,5», German «1.234,5»): see `parseAmount`.
//
// The table below is the closed allow-list from docs/clinic-currency/CONTRACTS.md
// §1; `currency.cases.json` beside this file is its machine-readable twin, which the
// Python services copy byte for byte. Change one, change the other.
//
// DEPENDENCY-FREE ON PURPOSE: no imports at all, not even money.js. The file must be
// droppable into an older installed framework for local testing, and into any app
// or script, without dragging a module graph along.
// ─────────────────────────────────────────────────────────────────────────────
const $fcda591c8cd139a4$export$c19ece7ea27dcd9e = 'IRR';
function $fcda591c8cd139a4$var$deepFreeze(value) {
    for (const inner of Object.values(value))if (inner && typeof inner === 'object') $fcda591c8cd139a4$var$deepFreeze(inner);
    return Object.freeze(value);
}
const $fcda591c8cd139a4$export$76e9d3e89dba5250 = $fcda591c8cd139a4$var$deepFreeze({
    IRR: {
        code: 'IRR',
        exponent: 0,
        displayDivisor: 10,
        minDisplayDecimals: 0,
        maxDisplayDecimals: 1,
        labels: {
            fa: {
                long: "\u062A\u0648\u0645\u0627\u0646",
                short: "\u062A"
            },
            en: {
                long: 'Toman',
                short: 'T'
            },
            ar: {
                long: "\u062A\u0648\u0645\u0627\u0646",
                short: "\u062A"
            },
            fr: {
                long: 'toman',
                short: 'T'
            },
            de: {
                long: 'Toman',
                short: 'T'
            }
        }
    },
    USD: {
        code: 'USD',
        exponent: 2,
        displayDivisor: 100,
        minDisplayDecimals: 2,
        maxDisplayDecimals: 2,
        labels: {
            fa: {
                long: "\u062F\u0644\u0627\u0631 \u0622\u0645\u0631\u06CC\u06A9\u0627",
                short: 'USD'
            },
            en: {
                long: 'US dollar',
                short: 'USD'
            },
            ar: {
                long: "\u062F\u0648\u0644\u0627\u0631 \u0623\u0645\u0631\u064A\u0643\u064A",
                short: 'USD'
            },
            fr: {
                long: "dollar am\xe9ricain",
                short: 'USD'
            },
            de: {
                long: 'US-Dollar',
                short: 'USD'
            }
        }
    },
    EUR: {
        code: 'EUR',
        exponent: 2,
        displayDivisor: 100,
        minDisplayDecimals: 2,
        maxDisplayDecimals: 2,
        labels: {
            fa: {
                long: "\u06CC\u0648\u0631\u0648",
                short: 'EUR'
            },
            en: {
                long: 'Euro',
                short: 'EUR'
            },
            ar: {
                long: "\u064A\u0648\u0631\u0648",
                short: 'EUR'
            },
            fr: {
                long: 'euro',
                short: 'EUR'
            },
            de: {
                long: 'Euro',
                short: 'EUR'
            }
        }
    },
    GBP: {
        code: 'GBP',
        exponent: 2,
        displayDivisor: 100,
        minDisplayDecimals: 2,
        maxDisplayDecimals: 2,
        labels: {
            fa: {
                long: "\u067E\u0648\u0646\u062F \u0627\u0646\u06AF\u0644\u06CC\u0633",
                short: 'GBP'
            },
            en: {
                long: 'Pound sterling',
                short: 'GBP'
            },
            ar: {
                long: "\u062C\u0646\u064A\u0647 \u0625\u0633\u062A\u0631\u0644\u064A\u0646\u064A",
                short: 'GBP'
            },
            fr: {
                long: 'livre sterling',
                short: 'GBP'
            },
            de: {
                long: 'Pfund Sterling',
                short: 'GBP'
            }
        }
    },
    CHF: {
        code: 'CHF',
        exponent: 2,
        displayDivisor: 100,
        minDisplayDecimals: 2,
        maxDisplayDecimals: 2,
        labels: {
            fa: {
                long: "\u0641\u0631\u0627\u0646\u06A9 \u0633\u0648\u0626\u06CC\u0633",
                short: 'CHF'
            },
            en: {
                long: 'Swiss franc',
                short: 'CHF'
            },
            ar: {
                long: "\u0641\u0631\u0646\u0643 \u0633\u0648\u064A\u0633\u0631\u064A",
                short: 'CHF'
            },
            fr: {
                long: 'franc suisse',
                short: 'CHF'
            },
            de: {
                long: 'Schweizer Franken',
                short: 'CHF'
            }
        }
    },
    AED: {
        code: 'AED',
        exponent: 2,
        displayDivisor: 100,
        minDisplayDecimals: 2,
        maxDisplayDecimals: 2,
        labels: {
            fa: {
                long: "\u062F\u0631\u0647\u0645 \u0627\u0645\u0627\u0631\u0627\u062A",
                short: 'AED'
            },
            en: {
                long: 'UAE dirham',
                short: 'AED'
            },
            ar: {
                long: "\u062F\u0631\u0647\u0645 \u0625\u0645\u0627\u0631\u0627\u062A\u064A",
                short: 'AED'
            },
            fr: {
                long: "dirham des \xc9mirats arabes unis",
                short: 'AED'
            },
            de: {
                long: 'VAE-Dirham',
                short: 'AED'
            }
        }
    },
    SAR: {
        code: 'SAR',
        exponent: 2,
        displayDivisor: 100,
        minDisplayDecimals: 2,
        maxDisplayDecimals: 2,
        labels: {
            fa: {
                long: "\u0631\u06CC\u0627\u0644 \u0633\u0639\u0648\u062F\u06CC",
                short: 'SAR'
            },
            en: {
                long: 'Saudi riyal',
                short: 'SAR'
            },
            ar: {
                long: "\u0631\u064A\u0627\u0644 \u0633\u0639\u0648\u062F\u064A",
                short: 'SAR'
            },
            fr: {
                long: 'riyal saoudien',
                short: 'SAR'
            },
            de: {
                long: 'Saudi-Riyal',
                short: 'SAR'
            }
        }
    },
    QAR: {
        code: 'QAR',
        exponent: 2,
        displayDivisor: 100,
        minDisplayDecimals: 2,
        maxDisplayDecimals: 2,
        labels: {
            fa: {
                long: "\u0631\u06CC\u0627\u0644 \u0642\u0637\u0631",
                short: 'QAR'
            },
            en: {
                long: 'Qatari riyal',
                short: 'QAR'
            },
            ar: {
                long: "\u0631\u064A\u0627\u0644 \u0642\u0637\u0631\u064A",
                short: 'QAR'
            },
            fr: {
                long: 'riyal qatari',
                short: 'QAR'
            },
            de: {
                long: 'Katar-Riyal',
                short: 'QAR'
            }
        }
    },
    TRY: {
        code: 'TRY',
        exponent: 2,
        displayDivisor: 100,
        minDisplayDecimals: 2,
        maxDisplayDecimals: 2,
        labels: {
            fa: {
                long: "\u0644\u06CC\u0631 \u062A\u0631\u06A9\u06CC\u0647",
                short: 'TRY'
            },
            en: {
                long: 'Turkish lira',
                short: 'TRY'
            },
            ar: {
                long: "\u0644\u064A\u0631\u0629 \u062A\u0631\u0643\u064A\u0629",
                short: 'TRY'
            },
            fr: {
                long: 'livre turque',
                short: 'TRY'
            },
            de: {
                long: "T\xfcrkische Lira",
                short: 'TRY'
            }
        }
    },
    KWD: {
        code: 'KWD',
        exponent: 3,
        displayDivisor: 1000,
        minDisplayDecimals: 3,
        maxDisplayDecimals: 3,
        labels: {
            fa: {
                long: "\u062F\u06CC\u0646\u0627\u0631 \u06A9\u0648\u06CC\u062A",
                short: 'KWD'
            },
            en: {
                long: 'Kuwaiti dinar',
                short: 'KWD'
            },
            ar: {
                long: "\u062F\u064A\u0646\u0627\u0631 \u0643\u0648\u064A\u062A\u064A",
                short: 'KWD'
            },
            fr: {
                long: "dinar kowe\xeftien",
                short: 'KWD'
            },
            de: {
                long: 'Kuwait-Dinar',
                short: 'KWD'
            }
        }
    },
    BHD: {
        code: 'BHD',
        exponent: 3,
        displayDivisor: 1000,
        minDisplayDecimals: 3,
        maxDisplayDecimals: 3,
        labels: {
            fa: {
                long: "\u062F\u06CC\u0646\u0627\u0631 \u0628\u062D\u0631\u06CC\u0646",
                short: 'BHD'
            },
            en: {
                long: 'Bahraini dinar',
                short: 'BHD'
            },
            ar: {
                long: "\u062F\u064A\u0646\u0627\u0631 \u0628\u062D\u0631\u064A\u0646\u064A",
                short: 'BHD'
            },
            fr: {
                long: "dinar bahre\xefni",
                short: 'BHD'
            },
            de: {
                long: 'Bahrain-Dinar',
                short: 'BHD'
            }
        }
    },
    OMR: {
        code: 'OMR',
        exponent: 3,
        displayDivisor: 1000,
        minDisplayDecimals: 3,
        maxDisplayDecimals: 3,
        labels: {
            fa: {
                long: "\u0631\u06CC\u0627\u0644 \u0639\u0645\u0627\u0646",
                short: 'OMR'
            },
            en: {
                long: 'Omani rial',
                short: 'OMR'
            },
            ar: {
                long: "\u0631\u064A\u0627\u0644 \u0639\u0645\u0627\u0646\u064A",
                short: 'OMR'
            },
            fr: {
                long: 'riyal omanais',
                short: 'OMR'
            },
            de: {
                long: 'Omanischer Rial',
                short: 'OMR'
            }
        }
    },
    // Whole dinars: ISO's exponent is 3, but no fils circulate and CLDR prints IQD
    // with no decimals — the same deliberate override as IRR's.
    IQD: {
        code: 'IQD',
        exponent: 0,
        displayDivisor: 1,
        minDisplayDecimals: 0,
        maxDisplayDecimals: 0,
        labels: {
            fa: {
                long: "\u062F\u06CC\u0646\u0627\u0631 \u0639\u0631\u0627\u0642",
                short: 'IQD'
            },
            en: {
                long: 'Iraqi dinar',
                short: 'IQD'
            },
            ar: {
                long: "\u062F\u064A\u0646\u0627\u0631 \u0639\u0631\u0627\u0642\u064A",
                short: 'IQD'
            },
            fr: {
                long: 'dinar irakien',
                short: 'IQD'
            },
            de: {
                long: 'Irakischer Dinar',
                short: 'IQD'
            }
        }
    }
});
const $fcda591c8cd139a4$export$729c9ac211f2ddda = Object.freeze(Object.keys($fcda591c8cd139a4$export$76e9d3e89dba5250));
function $fcda591c8cd139a4$export$68d15a182c6bcbf0(code) {
    return typeof code === 'string' && Object.prototype.hasOwnProperty.call($fcda591c8cd139a4$export$76e9d3e89dba5250, code);
}
function $fcda591c8cd139a4$var$invalidCurrency(code) {
    const shown = typeof code === 'string' ? JSON.stringify(code) : String(code);
    const error = new Error(`Invalid currency ${shown}: expected one of ${$fcda591c8cd139a4$export$729c9ac211f2ddda.join(', ')}`);
    error.name = 'InvalidCurrencyError';
    error.code = 'INVALID_CURRENCY';
    error.currency = code;
    return error;
}
function $fcda591c8cd139a4$export$b91dea8e61ccd7ef(code) {
    if (code == null || code === '') return $fcda591c8cd139a4$export$c19ece7ea27dcd9e;
    if ($fcda591c8cd139a4$export$68d15a182c6bcbf0(code)) return code;
    throw $fcda591c8cd139a4$var$invalidCurrency(code);
}
function $fcda591c8cd139a4$export$272b829bb65f9e96(code) {
    return $fcda591c8cd139a4$export$76e9d3e89dba5250[$fcda591c8cd139a4$export$b91dea8e61ccd7ef(code)];
}
function $fcda591c8cd139a4$export$57a9131fd362a631(amountMinor, currency) {
    const { displayDivisor: displayDivisor } = $fcda591c8cd139a4$export$272b829bb65f9e96(currency);
    if (amountMinor == null || amountMinor === '' || !Number.isFinite(Number(amountMinor))) return null;
    return Number(amountMinor) / displayDivisor;
}
function $fcda591c8cd139a4$export$22f3da351f420435(displayValue, currency, locale) {
    const { displayDivisor: displayDivisor } = $fcda591c8cd139a4$export$272b829bb65f9e96(currency);
    const n = Number($fcda591c8cd139a4$var$dotDecimal(displayValue ?? '', locale).replace(/[,٬\s]/g, ''));
    return Number.isFinite(n) ? Math.round(n * displayDivisor) : NaN;
}
// ── Parsing what a human typed ──────────────────────────────────────────────
const $fcda591c8cd139a4$var$PERSIAN_DIGITS = "\u06F0\u06F1\u06F2\u06F3\u06F4\u06F5\u06F6\u06F7\u06F8\u06F9";
const $fcda591c8cd139a4$var$ARABIC_DIGITS = "\u0660\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669";
function $fcda591c8cd139a4$var$toAsciiDigits(text) {
    return text.replace(/[۰-۹]/g, (d)=>String($fcda591c8cd139a4$var$PERSIAN_DIGITS.indexOf(d))).replace(/[٠-٩]/g, (d)=>String($fcda591c8cd139a4$var$ARABIC_DIGITS.indexOf(d)));
}
// Characters a formatted figure carries that are not part of the number: ICU puts
// an LRM before a Persian negative and an ALM before an Arabic one, and a copy out
// of an RTL page can bring RLM or an isolate along.
const $fcda591c8cd139a4$var$BIDI_MARKS = /[‎‏؜‪-‮⁦-⁩]/g;
const $fcda591c8cd139a4$var$GROUPING = /[,٬\s]/;
const $fcda591c8cd139a4$var$GROUPING_ALL = /[,٬\s]/g;
/**
 * `value` as a string in the notation both parsers read: «.» the decimal, «,» a
 * grouping mark. A language whose decimal mark is a COMMA (French «1 234,5»,
 * grouped with U+202F; German «1.234,5», grouped with «.») writes the two the
 * other way round, so its text has them traded back; «٫» and «٬» are never
 * ambiguous and stay as they are. The mark is
 * the one `formatAmount` prints for that language, so whatever it prints reads
 * back. A number is never re-read: `String(1.5)` is «1.5» on every page.
 */ function $fcda591c8cd139a4$var$dotDecimal(value, locale) {
    const text = String(value);
    if (typeof value !== 'string' || $fcda591c8cd139a4$var$decimalMarkOf($fcda591c8cd139a4$var$languageOf(locale)) !== ',') return text;
    return text.replace(/[.,]/g, (mark)=>mark === ',' ? '.' : ',');
}
function $fcda591c8cd139a4$export$b94f7550e5b92f9c(input, currency, locale) {
    const info = $fcda591c8cd139a4$export$272b829bb65f9e96(currency);
    if (input == null) return NaN;
    const text = $fcda591c8cd139a4$var$toAsciiDigits($fcda591c8cd139a4$var$dotDecimal(input, locale)).replace($fcda591c8cd139a4$var$BIDI_MARKS, '').replace(/−/g, '-').replace(/٫/g, '.').trim();
    if (text === '') return NaN;
    if (info.code === $fcda591c8cd139a4$export$c19ece7ea27dcd9e) {
        const n = Number(text.replace($fcda591c8cd139a4$var$GROUPING_ALL, ''));
        return Number.isFinite(n) ? Math.round(n * info.displayDivisor) : NaN;
    }
    return $fcda591c8cd139a4$var$parseStrict(text, info);
}
function $fcda591c8cd139a4$var$parseStrict(text, { displayDivisor: displayDivisor, maxDisplayDecimals: maxDisplayDecimals }) {
    let body = text;
    let sign = 1;
    if (body[0] === '-' || body[0] === '+') {
        if (body[0] === '-') sign = -1;
        body = body.slice(1).trim();
    }
    const dot = body.indexOf('.');
    const whole = dot < 0 ? body : body.slice(0, dot);
    const fraction = dot < 0 ? '' : body.slice(dot + 1);
    if (!/^\d*$/.test(fraction) || fraction.length > maxDisplayDecimals) return NaN;
    const groups = whole.split($fcda591c8cd139a4$var$GROUPING);
    if (groups.length > 1 && (!/^\d{1,3}$/.test(groups[0]) || groups.slice(1).some((g)=>!/^\d{3}$/.test(g)))) return NaN;
    const digits = groups.join('');
    if (!/^\d*$/.test(digits) || digits === '' && fraction === '') return NaN;
    // Integer arithmetic: «0.29» must be 29 cents, not 28.999999999999996.
    const scale = 10 ** maxDisplayDecimals;
    const units = Number(digits || '0') * scale + Number(fraction.padEnd(maxDisplayDecimals, '0') || '0');
    const minor = Math.round(units * displayDivisor / scale);
    if (!Number.isSafeInteger(minor)) return NaN;
    return minor === 0 ? 0 : sign * minor;
}
// ── Showing an amount ───────────────────────────────────────────────────────
// The Intl tag per panel language. The numbering system is spelled out for Arabic
// because ICU's bare `ar` now prints Latin digits, while every Parsina panel renders
// Arabic with Arabic-Indic ones (`-nu-arab` in each app's i18n config). `fa-IR` is
// what `fmtToman` has always used. `fr-FR` groups with U+202F NARROW NO-BREAK SPACE
// and writes a decimal COMMA, «1 234,5» — `parseAmount` reads that back only when
// it is told the text is French. `de-DE` groups with «.» and writes a decimal
// COMMA too, «1.234,5» — read back only when the text is said to be German.
// Every language here needs `labels` on every row.
const $fcda591c8cd139a4$var$INTL_TAGS = {
    fa: 'fa-IR',
    en: 'en-US',
    ar: 'ar-u-nu-arab',
    fr: 'fr-FR',
    de: 'de-DE'
};
/** `en-GB` → `en`; unknown or unset → `fa`, as the kit's `kitCopy` falls back. */ function $fcda591c8cd139a4$var$languageOf(locale) {
    const base = String(locale || 'fa').toLowerCase().split(/[-_]/)[0];
    return Object.prototype.hasOwnProperty.call($fcda591c8cd139a4$var$INTL_TAGS, base) ? base : 'fa';
}
// The decimal mark a language prints, from the same Intl data as its formatter:
// «٫» fa and ar, «.» en, «,» fr and de. Read, not listed, so the parser can never
// disagree with the figure on screen — even on an ICU build without French data,
// where both fall back together.
const $fcda591c8cd139a4$var$decimalMarks = new Map();
function $fcda591c8cd139a4$var$decimalMarkOf(language) {
    let mark = $fcda591c8cd139a4$var$decimalMarks.get(language);
    if (mark === undefined) {
        const parts = new Intl.NumberFormat($fcda591c8cd139a4$var$INTL_TAGS[language]).formatToParts(1.5);
        mark = parts.find((p)=>p.type === 'decimal')?.value ?? '.';
        $fcda591c8cd139a4$var$decimalMarks.set(language, mark);
    }
    return mark;
}
// What joins a figure to its unit word. French and German typography never let a
// unit wrap away from its number (German: DIN 5008, «1.500 Toman»), so both take
// U+00A0 NO-BREAK SPACE; every other language keeps the plain space it has always
// had.
const $fcda591c8cd139a4$var$UNIT_JOINERS = {
    fr: '\u00a0',
    de: '\u00a0'
};
// A formatter per (language, currency). Constructing Intl.NumberFormat is not free
// and amounts render inside list rows.
const $fcda591c8cd139a4$var$numberFormats = new Map();
function $fcda591c8cd139a4$var$numberFormat(language, info) {
    const key = `${language}|${info.code}`;
    let nf = $fcda591c8cd139a4$var$numberFormats.get(key);
    if (!nf) {
        nf = new Intl.NumberFormat($fcda591c8cd139a4$var$INTL_TAGS[language], {
            minimumFractionDigits: info.minDisplayDecimals,
            maximumFractionDigits: info.maxDisplayDecimals
        });
        $fcda591c8cd139a4$var$numberFormats.set(key, nf);
    }
    return nf;
}
function $fcda591c8cd139a4$export$e251d23bea783311(amountMinor, currency, { locale: locale = 'fa', unit: unit = 'none', fallback: fallback = "\u2014" } = {}) {
    const info = $fcda591c8cd139a4$export$272b829bb65f9e96(currency);
    const value = $fcda591c8cd139a4$export$57a9131fd362a631(amountMinor, info.code);
    if (value == null) return fallback;
    const language = $fcda591c8cd139a4$var$languageOf(locale);
    const text = $fcda591c8cd139a4$var$numberFormat(language, info).format(value);
    if (unit !== 'short' && unit !== 'long') return text;
    return `${text}${$fcda591c8cd139a4$var$UNIT_JOINERS[language] ?? ' '}${info.labels[language][unit]}`;
}
function $fcda591c8cd139a4$export$846d8329e0c3da65(currency, locale = 'fa', style = 'long') {
    const info = $fcda591c8cd139a4$export$272b829bb65f9e96(currency);
    return info.labels[$fcda591c8cd139a4$var$languageOf(locale)][style === 'short' ? 'short' : 'long'];
}
class $fcda591c8cd139a4$export$7cfa96280ebafb15 extends Error {
    constructor(currencies = [], message){
        const list = [
            ...new Set(currencies)
        ];
        super(message || `Amounts in different currencies cannot be combined: ${list.join(', ')}`);
        this.name = 'MixedCurrencyError';
        this.code = 'MIXED_CURRENCY';
        this.currencies = list;
    }
}
function $fcda591c8cd139a4$export$73a0b246a0fd217a(...codes) {
    const seen = [];
    for (const code of codes.flat()){
        const normalized = $fcda591c8cd139a4$export$b91dea8e61ccd7ef(code);
        if (!seen.includes(normalized)) seen.push(normalized);
    }
    if (seen.length > 1) throw new $fcda591c8cd139a4$export$7cfa96280ebafb15(seen);
    return seen[0] || $fcda591c8cd139a4$export$c19ece7ea27dcd9e;
}
const $fcda591c8cd139a4$var$picker = (pick, fallbackKey)=>{
    if (typeof pick === 'function') return pick;
    const key = pick ?? fallbackKey;
    return (row)=>row?.[key];
};
function $fcda591c8cd139a4$export$b440d7571b9fe7a6(rows, pickAmount, pickCurrency) {
    const amountOf = $fcda591c8cd139a4$var$picker(pickAmount, 'amount');
    const currencyOf = $fcda591c8cd139a4$var$picker(pickCurrency, 'currency');
    const totals = {};
    for (const row of rows || []){
        const raw = amountOf(row);
        if (raw == null || raw === '') continue;
        const amount = Number(raw);
        if (!Number.isFinite(amount)) continue;
        const code = $fcda591c8cd139a4$export$b91dea8e61ccd7ef(currencyOf(row));
        totals[code] = (totals[code] || 0) + amount;
    }
    return totals;
}

});


parcelRegister("b9X92", function(module, exports) {

$parcel$export(module.exports, "SessionEvent", () => $81fe69ded19c5b5e$export$3b6ed64b5b4e542d);
$parcel$export(module.exports, "onSessionEvent", () => $81fe69ded19c5b5e$export$a883a9af61079ac7);
$parcel$export(module.exports, "emitSession", () => $81fe69ded19c5b5e$export$c21f8c101d467dce);
// The session EVENT BUS — the one channel by which clinical code says «this
// session is over» to whichever panel is hosting it.
//
// The doctor panel's full session module (return paths, the expiry watcher, the
// «extend session» button) is shell behaviour and stays in that shell; it
// re-exports THIS bus so a 401 raised inside a visit reaches the same listeners
// as one raised on پذیرش. The clinic panel subscribes to it the same way.
const $81fe69ded19c5b5e$export$3b6ed64b5b4e542d = {
    EXPIRING: 'expiring',
    EXPIRED: 'expired'
};
const $81fe69ded19c5b5e$export$9a8e643ece3bd90e = 120000;
const $81fe69ded19c5b5e$var$listeners = new Set();
function $81fe69ded19c5b5e$export$a883a9af61079ac7(listener) {
    $81fe69ded19c5b5e$var$listeners.add(listener);
    return ()=>$81fe69ded19c5b5e$var$listeners.delete(listener);
}
function $81fe69ded19c5b5e$export$c21f8c101d467dce(event) {
    for (const listener of $81fe69ded19c5b5e$var$listeners)try {
        listener(event);
    } catch  {}
}
function $81fe69ded19c5b5e$export$4a79209357ec4bed() {
    $81fe69ded19c5b5e$var$listeners.clear();
}

});

parcelRegister("iAkVL", function(module, exports) {

$parcel$export(module.exports, "BFF_URL", () => $d87bd335296b449f$export$bb117bdb9f34de64);
$parcel$export(module.exports, "BFF_WS_BASE", () => $d87bd335296b449f$export$d8ff6422767fc83a);
$parcel$export(module.exports, "PATIENT_ORIGIN", () => $d87bd335296b449f$export$ea1b7b9480ef6a30);
$parcel$export(module.exports, "KC_BASE_URL", () => $d87bd335296b449f$export$91dbb4a8660769db);
$parcel$export(module.exports, "kcRealm", () => $d87bd335296b449f$export$982c4c4b626b71dc);
$parcel$export(module.exports, "kcClientId", () => $d87bd335296b449f$export$7769b0c1484b082d);
$parcel$export(module.exports, "kcBffClientId", () => $d87bd335296b449f$export$c49a86c673af918f);
$parcel$export(module.exports, "GEOCODER", () => $d87bd335296b449f$export$c3c01270e3d8affe);
$parcel$export(module.exports, "GEOCODER_URL", () => $d87bd335296b449f$export$d9035fb8470c8c5f);
$parcel$export(module.exports, "MAP_TILE_URL", () => $d87bd335296b449f$export$78f3b16823fa1002);
$parcel$export(module.exports, "MAP_LIB_BASE", () => $d87bd335296b449f$export$dbbae022d435eb02);
$parcel$export(module.exports, "accountUrl", () => $d87bd335296b449f$export$cce6d3603c0b63d);
$parcel$export(module.exports, "DOCTOR_APP_URL", () => $d87bd335296b449f$export$baf252e32e45db95);
$parcel$export(module.exports, "DOCTOR_BFF_URL", () => $d87bd335296b449f$export$f480703833df44a);
// Runtime configuration, resolved once at module load.
//
// window.__ENV__ is written by docker-entrypoint.sh at container start from the
// k8s deployment env, so the same image serves every environment. process.env is
// the Parcel build-time fallback (baked in via the Dockerfile ARG) for local dev
// and any image built before the runtime mechanism existed.
const $d87bd335296b449f$var$runtime = typeof window !== 'undefined' && window.__ENV__ || {};
const $d87bd335296b449f$export$bb117bdb9f34de64 = $d87bd335296b449f$var$runtime.BFF_URL || "https://capi.parsinabot.ir/graphql";
const $d87bd335296b449f$export$d8ff6422767fc83a = $d87bd335296b449f$export$bb117bdb9f34de64.replace(/^https/, 'wss').replace(/^http/, 'ws').replace('/graphql', '');
const $d87bd335296b449f$export$ea1b7b9480ef6a30 = $d87bd335296b449f$var$runtime.PATIENT_ORIGIN || undefined || undefined || 'https://patient.parsinabot.ir';
const $d87bd335296b449f$export$91dbb4a8660769db = $d87bd335296b449f$var$runtime.KEYCLOAK_URL || $d87bd335296b449f$var$runtime.PARSINA_KC_BASE_URL || undefined || 'https://sso.itechtrade.ir';
// ── Keycloak identity: realm, client, roles client ──────────────────────────
// Which realm this panel signs in to, which client it signs in as, and which
// client's roles the BFFs read off the token. Parsina's own values are the
// fallbacks, so an image run with none of these set signs in exactly as before;
// a deployment on another realm sets them at container start, same image.
//
// Each lookup takes the first value that is set: the brand-neutral name in
// env.js, the legacy PARSINA_* name in env.js, what the image was built with,
// today's literal. docker-entrypoint.sh writes these keys only when they are
// set, so "nothing set" really does reach the build-time value.
//
// Read on every call, not once at load like the values above: what decides is
// the env.js of the page that is running, and a test can set its own.
const $d87bd335296b449f$var$runtimeNow = ()=>typeof window !== 'undefined' && window.__ENV__ || {};
function $d87bd335296b449f$export$982c4c4b626b71dc() {
    const env = $d87bd335296b449f$var$runtimeNow();
    return env.KEYCLOAK_REALM || env.PARSINA_KC_REALM || undefined || undefined || 'parsina';
}
function $d87bd335296b449f$export$7769b0c1484b082d() {
    const env = $d87bd335296b449f$var$runtimeNow();
    return env.KEYCLOAK_CLIENT_ID || env.PARSINA_KC_CLIENT_ID || "parsina-clinic";
}
function $d87bd335296b449f$export$c49a86c673af918f() {
    return $d87bd335296b449f$var$runtimeNow().KEYCLOAK_BFF_CLIENT_ID || 'parsina-bff';
}
const $d87bd335296b449f$export$c3c01270e3d8affe = $d87bd335296b449f$var$runtime.GEOCODER || undefined || 'nominatim';
const $d87bd335296b449f$export$d9035fb8470c8c5f = $d87bd335296b449f$var$runtime.GEOCODER_URL || undefined || '';
// A value without {z}/{x}/{y} is not a tile template, so it falls back to the
// default instead of silently drawing grey squares — images whose entrypoint
// truncated it to "https://{s" are still running.
const $d87bd335296b449f$var$isTileTemplate = (v)=>typeof v === 'string' && /\{z\}/.test(v) && /\{x\}/.test(v) && /\{y\}/.test(v);
const $d87bd335296b449f$export$78f3b16823fa1002 = [
    $d87bd335296b449f$var$runtime.MAP_TILE_URL,
    undefined
].find($d87bd335296b449f$var$isTileTemplate) || 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
const $d87bd335296b449f$export$dbbae022d435eb02 = ($d87bd335296b449f$var$runtime.MAP_LIB_BASE || undefined || 'https://unpkg.com/leaflet@1.9.4/dist').replace(/\/+$/, '');
const $d87bd335296b449f$export$5aec0b605bf1c5bb = ($d87bd335296b449f$var$runtime.ACCOUNT_APP_URL || undefined || 'https://account.parsinabot.ir').replace(/\/+$/, '');
function $d87bd335296b449f$export$cce6d3603c0b63d(section = '/') {
    const back = typeof window !== 'undefined' ? window.location.origin : '';
    const path = section.startsWith('/') ? section : `/${section}`;
    return `${$d87bd335296b449f$export$5aec0b605bf1c5bb}${path}${back ? `?return_url=${encodeURIComponent(back)}` : ''}`;
}
function $d87bd335296b449f$export$966f1db7e7e33f71(loc) {
    const host = loc?.hostname || '';
    if (!/(^|\.)clinic\./.test(host)) return '';
    return `${loc.protocol}//${host.replace(/(^|\.)clinic\./, '$1doctor.')}`;
}
const $d87bd335296b449f$export$baf252e32e45db95 = ($d87bd335296b449f$var$runtime.DOCTOR_APP_URL || undefined || $d87bd335296b449f$export$966f1db7e7e33f71(typeof window !== 'undefined' ? window.location : null) || 'https://doctor.parsinabot.ir').replace(/\/+$/, '');
function $d87bd335296b449f$export$53e8047d18844937(clinicBffUrl) {
    const url = String(clinicBffUrl || '');
    if (/\/\/(?:[^/]*\.)?capi\./.test(url)) return url.replace(/(\/\/(?:[^/]*\.)?)capi\./, '$1api.');
    if (/\/\/(?:localhost|127\.0\.0\.1):4002(?=\/|$)/.test(url)) return url.replace(':4002', ':4000');
    return '';
}
const $d87bd335296b449f$export$f480703833df44a = $d87bd335296b449f$var$runtime.DOCTOR_BFF_URL || undefined || $d87bd335296b449f$export$53e8047d18844937($d87bd335296b449f$export$bb117bdb9f34de64) || 'https://api.parsinabot.ir/graphql';

});

parcelRegister("5qKOB", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_TIMEZONE", () => $3f43b1f98b4af9cd$export$3d6925841111ef4c);
$parcel$export(module.exports, "getClinicZone", () => $3f43b1f98b4af9cd$export$1afa02c9f4872478);
$parcel$export(module.exports, "setClinicZone", () => $3f43b1f98b4af9cd$export$6acbdcae2f080aed);
$parcel$export(module.exports, "zoneOffsetMs", () => $3f43b1f98b4af9cd$export$2053a35c7e6e2c14);
$parcel$export(module.exports, "isoDayOf", () => $3f43b1f98b4af9cd$export$dc711e9ec15c4476);
$parcel$export(module.exports, "wallToMs", () => $3f43b1f98b4af9cd$export$7de3dfb5e8bc8df9);
$parcel$export(module.exports, "addDaysIso", () => $3f43b1f98b4af9cd$export$2a9490fd25e034bd);
$parcel$export(module.exports, "clinicDayStart", () => $3f43b1f98b4af9cd$export$3a4019aeb939fbf9);
$parcel$export(module.exports, "clinicDayEnd", () => $3f43b1f98b4af9cd$export$99aea7f2f9bed29b);
$parcel$export(module.exports, "clinicTodayIso", () => $3f43b1f98b4af9cd$export$c7a9ec666ee70e6a);
$parcel$export(module.exports, "clinicNow", () => $3f43b1f98b4af9cd$export$c85cc9503815d345);
$parcel$export(module.exports, "clinicMinuteOfDay", () => $3f43b1f98b4af9cd$export$c1f3ee3b154c960f);
/**
 * The active clinic's wall clock (PM-0088).
 *
 * Every date this panel turns into an instant or back — «امروز», a day window, the
 * hour picked on the booking grid — is on the CLINIC's IANA time zone
 * (`Membership.timezone`, owner: clinicmanagement), never on a hard-coded Tehran
 * and never on the browser's own zone. A desk in Baghdad, or a laptop whose clock
 * is set to Europe, must still book 09:00 at the clinic.
 *
 * A module mirror, for the reason clinicSignal.js gives: the date helpers are not
 * inside React and are called from ~40 places. `ClinicContextProvider` writes it
 * on every clinic change and nothing else may. Until a clinic is known it is
 * Asia/Tehran — every clinic that existed before the field.
 */ const $3f43b1f98b4af9cd$export$3d6925841111ef4c = 'Asia/Tehran';
const $3f43b1f98b4af9cd$var$DAY_MS = 86400000;
const $3f43b1f98b4af9cd$var$validity = new Map();
function $3f43b1f98b4af9cd$export$3cc3b5bd88997419(name) {
    if (typeof name !== 'string' || !name) return false;
    if (name !== 'UTC' && !name.includes('/')) return false;
    if ($3f43b1f98b4af9cd$var$validity.has(name)) return $3f43b1f98b4af9cd$var$validity.get(name);
    let ok = false;
    try {
        ok = new Intl.DateTimeFormat('en-US', {
            timeZone: name
        }).resolvedOptions().timeZone === name;
    } catch  {
        ok = false;
    }
    $3f43b1f98b4af9cd$var$validity.set(name, ok);
    return ok;
}
let $3f43b1f98b4af9cd$var$activeZone = $3f43b1f98b4af9cd$export$3d6925841111ef4c;
function $3f43b1f98b4af9cd$export$1afa02c9f4872478() {
    return $3f43b1f98b4af9cd$var$activeZone;
}
function $3f43b1f98b4af9cd$export$6acbdcae2f080aed(zone) {
    $3f43b1f98b4af9cd$var$activeZone = $3f43b1f98b4af9cd$export$3cc3b5bd88997419(zone) ? zone : $3f43b1f98b4af9cd$export$3d6925841111ef4c;
}
const $3f43b1f98b4af9cd$var$formatters = new Map();
function $3f43b1f98b4af9cd$var$partsFormatter(zone) {
    let f = $3f43b1f98b4af9cd$var$formatters.get(zone);
    if (!f) {
        f = new Intl.DateTimeFormat('en-CA', {
            timeZone: zone,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hourCycle: 'h23'
        });
        $3f43b1f98b4af9cd$var$formatters.set(zone, f);
    }
    return f;
}
function $3f43b1f98b4af9cd$export$45b9d81ae4e46597(ts, zone = $3f43b1f98b4af9cd$var$activeZone) {
    const d = new Date(Number(ts));
    if (Number.isNaN(d.getTime())) return null;
    const o = {};
    for (const { type: type, value: value } of $3f43b1f98b4af9cd$var$partsFormatter($3f43b1f98b4af9cd$export$3cc3b5bd88997419(zone) ? zone : $3f43b1f98b4af9cd$export$3d6925841111ef4c).formatToParts(d))o[type] = value;
    return {
        y: +o.year,
        m: +o.month,
        d: +o.day,
        hour: +o.hour,
        minute: +o.minute,
        second: +o.second
    };
}
function $3f43b1f98b4af9cd$export$2053a35c7e6e2c14(ts, zone = $3f43b1f98b4af9cd$var$activeZone) {
    const p = $3f43b1f98b4af9cd$export$45b9d81ae4e46597(ts, zone);
    if (!p) return 0;
    return Date.UTC(p.y, p.m - 1, p.d, p.hour, p.minute, p.second) - Math.floor(Number(ts) / 1000) * 1000;
}
const $3f43b1f98b4af9cd$var$pad2 = (n)=>String(n).padStart(2, '0');
function $3f43b1f98b4af9cd$export$dc711e9ec15c4476(ts, zone = $3f43b1f98b4af9cd$var$activeZone) {
    const p = $3f43b1f98b4af9cd$export$45b9d81ae4e46597(ts, zone);
    return p ? `${p.y}-${$3f43b1f98b4af9cd$var$pad2(p.m)}-${$3f43b1f98b4af9cd$var$pad2(p.d)}` : '';
}
function $3f43b1f98b4af9cd$export$7de3dfb5e8bc8df9(isoDay, minutes = 0, zone = $3f43b1f98b4af9cd$var$activeZone) {
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(isoDay || ''));
    if (!m) return NaN;
    const asIfUtc = Date.UTC(+m[1], +m[2] - 1, +m[3]) + Number(minutes) * 60000;
    const first = asIfUtc - $3f43b1f98b4af9cd$export$2053a35c7e6e2c14(asIfUtc, zone);
    return asIfUtc - $3f43b1f98b4af9cd$export$2053a35c7e6e2c14(first, zone);
}
function $3f43b1f98b4af9cd$export$2a9490fd25e034bd(isoDay, days) {
    const t = Date.parse(`${isoDay}T12:00:00Z`) + Number(days) * $3f43b1f98b4af9cd$var$DAY_MS;
    return new Date(t).toISOString().slice(0, 10);
}
function $3f43b1f98b4af9cd$export$3a4019aeb939fbf9(ts, zone = $3f43b1f98b4af9cd$var$activeZone) {
    return $3f43b1f98b4af9cd$export$7de3dfb5e8bc8df9($3f43b1f98b4af9cd$export$dc711e9ec15c4476(ts, zone), 0, zone);
}
function $3f43b1f98b4af9cd$export$99aea7f2f9bed29b(ts, zone = $3f43b1f98b4af9cd$var$activeZone) {
    return $3f43b1f98b4af9cd$export$7de3dfb5e8bc8df9($3f43b1f98b4af9cd$export$2a9490fd25e034bd($3f43b1f98b4af9cd$export$dc711e9ec15c4476(ts, zone), 1), 0, zone) - 1;
}
function $3f43b1f98b4af9cd$export$c7a9ec666ee70e6a(now = Date.now(), zone = $3f43b1f98b4af9cd$var$activeZone) {
    return $3f43b1f98b4af9cd$export$dc711e9ec15c4476(now, zone);
}
function $3f43b1f98b4af9cd$export$c85cc9503815d345(now = Date.now(), zone = $3f43b1f98b4af9cd$var$activeZone) {
    return new Date(Number(now) + $3f43b1f98b4af9cd$export$2053a35c7e6e2c14(now, zone));
}
function $3f43b1f98b4af9cd$export$c1f3ee3b154c960f(ts, zone = $3f43b1f98b4af9cd$var$activeZone) {
    const p = $3f43b1f98b4af9cd$export$45b9d81ae4e46597(ts, zone);
    return p ? p.hour * 60 + p.minute : NaN;
}

});

parcelRegister("58BYB", function(module, exports) {

$parcel$export(module.exports, "getToken", () => $3bdb28763df76ec7$export$257b2d10b709d8ef);
$parcel$export(module.exports, "getRefresh", () => $3bdb28763df76ec7$export$c8736e6c4fef498e);
$parcel$export(module.exports, "clearRedirectGuard", () => $3bdb28763df76ec7$export$639ddbdf19445d0c);
$parcel$export(module.exports, "redirectToLogin", () => $3bdb28763df76ec7$export$2fb87bbf5418dbe1);
$parcel$export(module.exports, "handleCallback", () => $3bdb28763df76ec7$export$f8ec4f1dc49ac9b7);
$parcel$export(module.exports, "getValidToken", () => $3bdb28763df76ec7$export$51699064a8fe557f);
$parcel$export(module.exports, "isTokenExpired", () => $3bdb28763df76ec7$export$b007d77a962aa175);
$parcel$export(module.exports, "refreshAccessToken", () => $3bdb28763df76ec7$export$f8f36faf9a051362);
$parcel$export(module.exports, "parseJwt", () => $3bdb28763df76ec7$export$83cd1f1503eb19c0);
$parcel$export(module.exports, "refreshUntilRole", () => $3bdb28763df76ec7$export$d1fd2b890117aecf);
$parcel$export(module.exports, "logout", () => $3bdb28763df76ec7$export$a0973bcfe11b05c9);
// OIDC Authorization Code + PKCE flow for Keycloak

var $eLeza = parcelRequire("eLeza");

var $iAkVL = parcelRequire("iAkVL");
// The realm's URL, resolved on every call like the client id (kcClientId()):
// both come from the deployment, and runtimeEnv.js says in which order.
const $3bdb28763df76ec7$var$kcBase = ()=>`${0, $iAkVL.KC_BASE_URL}/realms/${encodeURIComponent((0, $iAkVL.kcRealm)())}`;
// Always derived at call time so redirect_uri is consistent across
// the auth request and token exchange even if the page reloads.
function $3bdb28763df76ec7$var$getRedirectUri() {
    return `${window.location.origin}/`;
}
// ── Login language ───────────────────────────────────────────────────────────
// Tell Keycloak which language to serve the sign-in in, so the login page AND
// the errors it resolves server-side (bad password, locked account, expired
// code) come back in the language this panel is running in rather than the
// realm's own default.
//
// Read from `<html lang>`, which I18nProvider owns, so it follows the panel
// without this file knowing anything about the locale registry.
//
// `ui_locales` is the OIDC standard hint; `kc_locale` is what Keycloak acts on,
// and it sets the KEYCLOAK_LOCALE cookie so the choice survives every later
// step of the flow rather than just the first page.
//
// ── why this list is the THEME'S, not the panel's ─────────────────────────────
//
// Deliberately not the panel's locale list but the sign-in theme's: the
// languages the RELEASED sso/parsina.keycloakify carries message bundles for
// (IMPROVED_LANGUAGE_TAGS — fa, en, ar). Sending `kc_locale` for a language the
// theme lacks gets a login page half in Keycloak's own fallback, which is worse
// than a coherent one, so a language joins this list only once the theme that
// carries it is released and deployed (docs/I18N.md «Adding a language» step 8).
// (Until PM-0185 this said the theme shipped fa and en only; it had shipped `ar`
// for a while, so an Arabic panel signed in through the Persian page for nothing.)
//
// French is NOT here yet (PM-0185, T71): the theme with an `fr` bundle exists
// only on sso's feat/fr-locale and is unreleased. 'fr' is added to this list in
// the release that follows the theme's deployment, never before. Until then a
// French panel signs in through the ENGLISH page — LOGIN_NEAREST below — since
// missing French falls back to English, never to Persian (FRENCH.md D4).
//
// German is NOT here either (PM-0212, T71): the sign-in theme's `de` bundle is
// on sso's feat/de-locale only and unreleased, so 'de' joins this list in the
// release after that theme is deployed, never before. Until then a German panel
// signs in through the ENGLISH page as well (LOGIN_NEAREST) — missing German
// falls back to English, never to Persian.
//
// A BRAND narrows this to the languages it offers and moves the fallback to its
// own first-visit language (@parsina/framework/ui/lib/brand): a brand that does
// not offer Persian never sends `kc_locale=fa`. A brand of its own also signs
// in through a theme of its own — Proxia's (proxia.keycloakify, realm locales
// en + fa) carries no Arabic, French or German — so it keeps the two languages every
// theme carries, and its Arabic panel signs in through its default (English).
// With no brand this is the list below and Persian the fallback.
const $3bdb28763df76ec7$var$LOGIN_LOCALES = [
    'fa',
    'en',
    'ar'
];
const $3bdb28763df76ec7$var$ANY_THEME_LOCALES = [
    'fa',
    'en'
];
// A panel language the theme lacks signs in through its nearest one the theme
// has, before the brand's fallback: French and German read English (D4).
const $3bdb28763df76ec7$var$LOGIN_NEAREST = {
    fr: 'en',
    de: 'en'
};
function $3bdb28763df76ec7$var$panelLocale() {
    const lang = (document.documentElement.getAttribute('lang') || '').toLowerCase().split('-')[0];
    const theme = (0, $eLeza.brand)().id === (0, $eLeza.BRAND_DEFAULTS).id ? $3bdb28763df76ec7$var$LOGIN_LOCALES : $3bdb28763df76ec7$var$ANY_THEME_LOCALES;
    const offered = (0, $eLeza.brandLocales)(theme);
    if (offered.includes(lang)) return lang;
    const nearest = $3bdb28763df76ec7$var$LOGIN_NEAREST[lang];
    return nearest && offered.includes(nearest) ? nearest : (0, $eLeza.brandDefaultLocale)('fa', theme);
}
// ── PKCE helpers ─────────────────────────────────────────────────────────────
function $3bdb28763df76ec7$var$randomBytes(len) {
    const arr = new Uint8Array(len);
    crypto.getRandomValues(arr);
    return arr;
}
function $3bdb28763df76ec7$var$base64url(buf) {
    return btoa(String.fromCharCode(...buf)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}
async function $3bdb28763df76ec7$var$sha256(str) {
    const enc = new TextEncoder().encode(str);
    const buf = await crypto.subtle.digest('SHA-256', enc);
    return new Uint8Array(buf);
}
async function $3bdb28763df76ec7$var$generateChallenge(verifier) {
    return $3bdb28763df76ec7$var$base64url(await $3bdb28763df76ec7$var$sha256(verifier));
}
// ── Token storage ─────────────────────────────────────────────────────────────
// A sign-in lasts as long as Keycloak's refresh token — 30 days on beta1 — not
// as long as one tab (PM-0158). The REFRESH token and the id token (the logout
// hint) live in localStorage, so a new tab, a reopened browser or a Chrome that
// Android killed in the background signs in silently from them. The 5-minute
// ACCESS token stays per tab. Before this, all three lived in sessionStorage and
// every new tab or browser restart threw a valid 30-day token away and sent the
// user to the login form. A copy left in sessionStorage by an older build is
// still read, so a tab open across the deploy keeps working.
const $3bdb28763df76ec7$var$PERSISTED = [
    'kc_refresh',
    'kc_id_token'
];
function $3bdb28763df76ec7$var$durable() {
    try {
        return typeof window !== 'undefined' ? window.localStorage : null;
    } catch  {
        return null;
    }
}
function $3bdb28763df76ec7$var$readPersisted(key) {
    try {
        const v = $3bdb28763df76ec7$var$durable()?.getItem(key);
        if (v) return v;
    } catch  {}
    return sessionStorage.getItem(key);
}
function $3bdb28763df76ec7$export$257b2d10b709d8ef() {
    return sessionStorage.getItem('kc_token');
}
function $3bdb28763df76ec7$export$c8736e6c4fef498e() {
    return $3bdb28763df76ec7$var$readPersisted('kc_refresh');
}
function $3bdb28763df76ec7$export$393ade1005606e67() {
    return $3bdb28763df76ec7$var$readPersisted('kc_id_token');
}
function $3bdb28763df76ec7$var$saveTokens(token, refresh, idToken) {
    sessionStorage.setItem('kc_token', token);
    const pairs = [
        [
            'kc_refresh',
            refresh
        ],
        [
            'kc_id_token',
            idToken
        ]
    ].filter(([, v])=>v);
    try {
        const store = $3bdb28763df76ec7$var$durable();
        if (!store) throw new Error('no localStorage');
        pairs.forEach(([k, v])=>store.setItem(k, v));
        pairs.forEach(([k])=>sessionStorage.removeItem(k));
    } catch  {
        // Private mode or blocked storage: the tab still works, as it always did.
        pairs.forEach(([k, v])=>sessionStorage.setItem(k, v));
    }
}
function $3bdb28763df76ec7$export$67488bf92fa15f1e() {
    [
        'kc_token',
        'kc_refresh',
        'kc_id_token',
        'kc_verifier',
        'kc_state'
    ].forEach((k)=>sessionStorage.removeItem(k));
    try {
        $3bdb28763df76ec7$var$PERSISTED.forEach((k)=>$3bdb28763df76ec7$var$durable()?.removeItem(k));
    } catch  {}
}
// Keycloak ROTATES the refresh token. With it shared across tabs, two tabs
// refreshing at the same moment would present the same token twice and the
// second would be refused — and a refused refresh signs the user out. The
// browser's Web Locks serialise refreshes across every tab of this origin; each
// refresh reads the stored token inside the lock, so it uses the one the
// previous tab just received. Where Web Locks are missing, the per-tab
// single-flight below still holds.
async function $3bdb28763df76ec7$var$withRefreshLock(fn) {
    const locks = typeof navigator !== 'undefined' ? navigator.locks : null;
    if (!locks || typeof locks.request !== 'function') return fn();
    return locks.request('parsina-kc-refresh', ()=>fn());
}
// ── Redirect-loop guard ───────────────────────────────────────────────────────
// Records each redirect timestamp. If 3+ happen within 30 s, stops redirecting
// and lets the app render an error screen instead.
const $3bdb28763df76ec7$var$LOOP_KEY = 'kc_redirect_ts';
const $3bdb28763df76ec7$var$LOOP_LIMIT = 3;
const $3bdb28763df76ec7$var$LOOP_WIN = 30000; // ms
function $3bdb28763df76ec7$var$redirectAllowed() {
    const raw = sessionStorage.getItem($3bdb28763df76ec7$var$LOOP_KEY);
    const hist = raw ? JSON.parse(raw) : [];
    const now = Date.now();
    const recent = hist.filter((ts)=>now - ts < $3bdb28763df76ec7$var$LOOP_WIN);
    if (recent.length >= $3bdb28763df76ec7$var$LOOP_LIMIT) return false;
    sessionStorage.setItem($3bdb28763df76ec7$var$LOOP_KEY, JSON.stringify([
        ...recent,
        now
    ]));
    return true;
}
function $3bdb28763df76ec7$export$639ddbdf19445d0c() {
    sessionStorage.removeItem($3bdb28763df76ec7$var$LOOP_KEY);
}
// ── Where to come back to after signing in ───────────────────────────────────
//
// `redirect_uri` is pinned to the origin and MUST stay pinned — it is registered
// on the Keycloak client and a per-path value would have to be registered too. So
// the path is remembered on this side instead.
//
// Without this, every deep link dies at the login screen: the person arrives at
// `/c/mehr/payments`, signs in, and lands on `/`. The link that costs the most is
// `/invite/:code` from a printed QR code — the person scans it, authenticates, and
// ends up on a start page with no idea the code went nowhere.
//
// Only a same-origin PATH is ever honoured. It is stored by this app, but it is
// read back after a round trip through an external identity provider, so it is
// validated as if it were hostile: anything with a scheme or a host is discarded,
// which is what stops a crafted value turning the login flow into an open redirect.
const $3bdb28763df76ec7$var$RETURN_KEY = 'auth.return.v1';
/** Paths that must never be returned to — they are where you land WITHOUT one. */ const $3bdb28763df76ec7$var$NO_RETURN = [
    '/start',
    '/onboarding'
];
function $3bdb28763df76ec7$export$d4826ef27aa6bb7a(path) {
    try {
        const raw = String(path || '');
        if (!raw.startsWith('/') || raw.startsWith('//')) return;
        if ($3bdb28763df76ec7$var$NO_RETURN.some((p)=>raw === p || raw.startsWith(`${p}?`))) return;
        if (raw === '/' || raw.startsWith('/?')) return;
        sessionStorage.setItem($3bdb28763df76ec7$var$RETURN_KEY, raw);
    } catch  {}
}
function $3bdb28763df76ec7$export$e5c839e26770d4ca() {
    try {
        const raw = sessionStorage.getItem($3bdb28763df76ec7$var$RETURN_KEY);
        sessionStorage.removeItem($3bdb28763df76ec7$var$RETURN_KEY);
        if (!raw || !raw.startsWith('/') || raw.startsWith('//')) return '';
        return raw;
    } catch  {
        return '';
    }
}
async function $3bdb28763df76ec7$export$2fb87bbf5418dbe1() {
    // Before anything else: the current location is about to be replaced by
    // Keycloak's, and this is the last moment it exists.
    $3bdb28763df76ec7$export$d4826ef27aa6bb7a(window.location.pathname + window.location.search);
    if (!$3bdb28763df76ec7$var$redirectAllowed()) {
        // Too many consecutive redirects — surface the error to the user instead.
        $3bdb28763df76ec7$export$67488bf92fa15f1e();
        window.history.replaceState({}, '', '/?auth_error=loop');
        window.location.reload();
        return;
    }
    const verifier = $3bdb28763df76ec7$var$base64url($3bdb28763df76ec7$var$randomBytes(32));
    const challenge = await $3bdb28763df76ec7$var$generateChallenge(verifier);
    const state = $3bdb28763df76ec7$var$base64url($3bdb28763df76ec7$var$randomBytes(16));
    sessionStorage.setItem('kc_verifier', verifier);
    sessionStorage.setItem('kc_state', state);
    const params = new URLSearchParams({
        response_type: 'code',
        client_id: (0, $iAkVL.kcClientId)(),
        redirect_uri: $3bdb28763df76ec7$var$getRedirectUri(),
        scope: 'openid profile email',
        state: state,
        code_challenge: challenge,
        code_challenge_method: 'S256',
        ui_locales: $3bdb28763df76ec7$var$panelLocale(),
        kc_locale: $3bdb28763df76ec7$var$panelLocale()
    });
    window.location.href = `${$3bdb28763df76ec7$var$kcBase()}/protocol/openid-connect/auth?${params}`;
}
async function $3bdb28763df76ec7$export$cb38df48a6bc4232() {
    console.log('[reauthorize] starting silent KC re-auth with prompt=none');
    const verifier = $3bdb28763df76ec7$var$base64url($3bdb28763df76ec7$var$randomBytes(32));
    const challenge = await $3bdb28763df76ec7$var$generateChallenge(verifier);
    const state = $3bdb28763df76ec7$var$base64url($3bdb28763df76ec7$var$randomBytes(16));
    sessionStorage.setItem('kc_verifier', verifier);
    sessionStorage.setItem('kc_state', state);
    const params = new URLSearchParams({
        response_type: 'code',
        client_id: (0, $iAkVL.kcClientId)(),
        redirect_uri: $3bdb28763df76ec7$var$getRedirectUri(),
        scope: 'openid profile email',
        state: state,
        code_challenge: challenge,
        code_challenge_method: 'S256',
        prompt: 'none',
        ui_locales: $3bdb28763df76ec7$var$panelLocale(),
        kc_locale: $3bdb28763df76ec7$var$panelLocale()
    });
    const url = `${$3bdb28763df76ec7$var$kcBase()}/protocol/openid-connect/auth?${params}`;
    console.log('[reauthorize] redirecting to KC:', url);
    window.location.href = url;
}
async function $3bdb28763df76ec7$export$f8ec4f1dc49ac9b7() {
    const params = new URLSearchParams(window.location.search);
    const error = params.get('error');
    const code = params.get('code');
    const state = params.get('state');
    const verifier = sessionStorage.getItem('kc_verifier');
    const saved = sessionStorage.getItem('kc_state');
    console.log('[handleCallback] error:', error, '| hasCode:', !!code, '| stateMatch:', state === saved, '| hasVerifier:', !!verifier);
    // Keycloak returned an explicit error (access_denied, login_required, etc.)
    if (error) {
        console.warn('[handleCallback] KC returned error:', error, params.get('error_description'));
        $3bdb28763df76ec7$export$67488bf92fa15f1e();
        window.history.replaceState({}, '', '/');
        return false;
    }
    // Missing or mismatched PKCE / state — don't retry immediately
    if (!code || !verifier || state !== saved) {
        console.warn("[handleCallback] missing code/verifier or state mismatch \u2014 aborting");
        window.history.replaceState({}, '', '/');
        return false;
    }
    const res = await fetch(`${$3bdb28763df76ec7$var$kcBase()}/protocol/openid-connect/token`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams({
            grant_type: 'authorization_code',
            client_id: (0, $iAkVL.kcClientId)(),
            redirect_uri: $3bdb28763df76ec7$var$getRedirectUri(),
            code: code,
            code_verifier: verifier
        })
    });
    // Strip the OAuth query and restore the path the person actually asked for.
    // On failure this still lands on '/', because a return path is only meaningful
    // once there is a session to view it with.
    const returnTo = $3bdb28763df76ec7$export$e5c839e26770d4ca();
    window.history.replaceState({}, '', res.ok ? returnTo || '/' : '/');
    if (!res.ok) {
        console.error('[handleCallback] token exchange failed:', res.status, await res.text());
        return false;
    }
    const data = await res.json();
    if (!data.access_token) {
        console.error('[handleCallback] no access_token in response:', JSON.stringify(data));
        return false;
    }
    // Log roles from new token
    try {
        const claims = JSON.parse(atob(data.access_token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
        const roles = claims?.resource_access?.[(0, $iAkVL.kcBffClientId)()]?.roles || [];
        console.log('[handleCallback] new token roles:', roles, '| sub:', claims?.sub, '| clinic_id:', claims?.clinic_id);
    } catch  {}
    $3bdb28763df76ec7$var$saveTokens(data.access_token, data.refresh_token, data.id_token);
    $3bdb28763df76ec7$export$639ddbdf19445d0c();
    console.log('[handleCallback] tokens saved successfully');
    return true;
}
async function $3bdb28763df76ec7$export$51699064a8fe557f() {
    let token = $3bdb28763df76ec7$export$257b2d10b709d8ef();
    if (!token) return null;
    if ($3bdb28763df76ec7$export$b007d77a962aa175(token)) {
        const ok = await $3bdb28763df76ec7$export$f8f36faf9a051362();
        if (!ok) return null;
        token = $3bdb28763df76ec7$export$257b2d10b709d8ef();
    }
    return token;
}
async function $3bdb28763df76ec7$var$refreshAccessTokenInTab() {
    const refresh = $3bdb28763df76ec7$export$c8736e6c4fef498e();
    if (!refresh) return false;
    const res = await fetch(`${$3bdb28763df76ec7$var$kcBase()}/protocol/openid-connect/token`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams({
            grant_type: 'refresh_token',
            client_id: (0, $iAkVL.kcClientId)(),
            refresh_token: refresh
        })
    });
    if (!res.ok) {
        $3bdb28763df76ec7$export$67488bf92fa15f1e();
        return false;
    }
    const data = await res.json();
    if (!data.access_token) {
        $3bdb28763df76ec7$export$67488bf92fa15f1e();
        return false;
    }
    $3bdb28763df76ec7$var$saveTokens(data.access_token, data.refresh_token, data.id_token);
    return true;
}
function $3bdb28763df76ec7$export$cc4874c6c92c4b12(token = $3bdb28763df76ec7$export$257b2d10b709d8ef()) {
    return $3bdb28763df76ec7$export$83cd1f1503eb19c0(token || '')?.resource_access?.[(0, $iAkVL.kcBffClientId)()]?.roles || [];
}
const $3bdb28763df76ec7$var$pause = (ms)=>new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
async function $3bdb28763df76ec7$export$d1fd2b890117aecf(role, { attempts: attempts = 4, delayMs: delayMs = 750, wait: wait = $3bdb28763df76ec7$var$pause } = {}) {
    if ($3bdb28763df76ec7$export$cc4874c6c92c4b12().includes(role)) return true;
    for(let i = 0; i < attempts; i += 1){
        if (i > 0) await wait(delayMs);
        let ok = false;
        try {
            ok = await $3bdb28763df76ec7$export$f8f36faf9a051362();
        } catch  {
            ok = false;
        }
        if (!ok) return false;
        if ($3bdb28763df76ec7$export$cc4874c6c92c4b12().includes(role)) return true;
    }
    return false;
}
function $3bdb28763df76ec7$export$a0973bcfe11b05c9() {
    const idToken = $3bdb28763df76ec7$export$393ade1005606e67();
    $3bdb28763df76ec7$export$67488bf92fa15f1e();
    $3bdb28763df76ec7$export$639ddbdf19445d0c();
    const params = new URLSearchParams({
        client_id: (0, $iAkVL.kcClientId)(),
        post_logout_redirect_uri: $3bdb28763df76ec7$var$getRedirectUri(),
        ui_locales: $3bdb28763df76ec7$var$panelLocale(),
        kc_locale: $3bdb28763df76ec7$var$panelLocale()
    });
    if (idToken) params.set('id_token_hint', idToken);
    window.location.href = `${$3bdb28763df76ec7$var$kcBase()}/protocol/openid-connect/logout?${params}`;
}
function $3bdb28763df76ec7$export$83cd1f1503eb19c0(token) {
    try {
        const b64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
        const bytes = Uint8Array.from(atob(b64), (c)=>c.charCodeAt(0));
        return JSON.parse(new TextDecoder().decode(bytes));
    } catch  {
        return null;
    }
}
function $3bdb28763df76ec7$export$b007d77a962aa175(token) {
    const p = $3bdb28763df76ec7$export$83cd1f1503eb19c0(token);
    if (!p) return true;
    return Date.now() >= p.exp * 1000 - 30000; // 30 s buffer
}
function $3bdb28763df76ec7$export$f8f36faf9a051362() {
    return $3bdb28763df76ec7$var$withRefreshLock(()=>$3bdb28763df76ec7$var$refreshAccessTokenInTab());
}

});


parcelRegister("lzNIT", function(module, exports) {

$parcel$export(module.exports, "BrowserRouter", () => $040dbb9c344a508d$export$9ba4e89fdfa1fc54);
$parcel$export(module.exports, "useSearchParams", () => $040dbb9c344a508d$export$f1a78c17382fe22a);
$parcel$export(module.exports, "useLocation", () => (parcelRequire("aphAM")).useLocation);
$parcel$export(module.exports, "useNavigate", () => (parcelRequire("aphAM")).useNavigate);
/**
 * React Router DOM v6.30.6
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $2vsP7 = parcelRequire("2vsP7");
var $aphAM = parcelRequire("aphAM");

var $2vsP7 = parcelRequire("2vsP7");
function $040dbb9c344a508d$var$_extends() {
    return $040dbb9c344a508d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $040dbb9c344a508d$var$_extends.apply(null, arguments);
}
function $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
const $040dbb9c344a508d$var$defaultMethod = "get";
const $040dbb9c344a508d$var$defaultEncType = "application/x-www-form-urlencoded";
function $040dbb9c344a508d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $040dbb9c344a508d$var$isButtonElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $040dbb9c344a508d$var$isFormElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $040dbb9c344a508d$var$isInputElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $040dbb9c344a508d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $040dbb9c344a508d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$040dbb9c344a508d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $040dbb9c344a508d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $040dbb9c344a508d$var$_formDataSupportsSubmitter = null;
function $040dbb9c344a508d$var$isFormDataSubmitterSupported() {
    if ($040dbb9c344a508d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = true;
    }
    return $040dbb9c344a508d$var$_formDataSupportsSubmitter;
}
const $040dbb9c344a508d$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $040dbb9c344a508d$var$getFormEncType(encType) {
    if (encType != null && !$040dbb9c344a508d$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($040dbb9c344a508d$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $2vsP7.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($040dbb9c344a508d$var$isButtonElement(target) || $040dbb9c344a508d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $2vsP7.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("formenctype")) || $040dbb9c344a508d$var$getFormEncType(form.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$040dbb9c344a508d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($040dbb9c344a508d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $040dbb9c344a508d$var$defaultMethod;
        action = null;
        encType = $040dbb9c344a508d$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $040dbb9c344a508d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $040dbb9c344a508d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $040dbb9c344a508d$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $040dbb9c344a508d$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $040dbb9c344a508d$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $040dbb9c344a508d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $2vsP7.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $2vsP7.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $aphAM.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $2vsP7.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $2vsP7.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $aphAM.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $040dbb9c344a508d$var$_extends({}, state, {
        errors: $040dbb9c344a508d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $040dbb9c344a508d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $2vsP7.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $040dbb9c344a508d$export$7ad602f0e94e62d1 = /*#__PURE__*/ $acw62.createContext({
    isTransitioning: false
});
const $040dbb9c344a508d$export$148fd98d095596d4 = /*#__PURE__*/ $acw62.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $040dbb9c344a508d$var$START_TRANSITION = "startTransition";
const $040dbb9c344a508d$var$startTransitionImpl = $acw62[$040dbb9c344a508d$var$START_TRANSITION];
const $040dbb9c344a508d$var$FLUSH_SYNC = "flushSync";
const $040dbb9c344a508d$var$flushSyncImpl = $1u0KT[$040dbb9c344a508d$var$FLUSH_SYNC];
const $040dbb9c344a508d$var$USE_ID = "useId";
const $040dbb9c344a508d$var$useIdImpl = $acw62[$040dbb9c344a508d$var$USE_ID];
function $040dbb9c344a508d$var$startTransitionSafe(cb) {
    if ($040dbb9c344a508d$var$startTransitionImpl) $040dbb9c344a508d$var$startTransitionImpl(cb);
    else cb();
}
function $040dbb9c344a508d$var$flushSyncSafe(cb) {
    if ($040dbb9c344a508d$var$flushSyncImpl) $040dbb9c344a508d$var$flushSyncImpl(cb);
    else cb();
}
class $040dbb9c344a508d$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $040dbb9c344a508d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $acw62.useCallback((cb)=>{
        if (v7_startTransition) $040dbb9c344a508d$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $acw62.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $040dbb9c344a508d$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $040dbb9c344a508d$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $040dbb9c344a508d$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $acw62.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $acw62.useEffect(()=>(0, $aphAM.UNSAFE_logV6DeprecationWarnings)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $aphAM.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement((0, $aphAM.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $acw62.createElement((0, $aphAM.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $040dbb9c344a508d$var$MemoizedDataRoutes = /*#__PURE__*/ $acw62.memo($040dbb9c344a508d$var$DataRoutes);
function $040dbb9c344a508d$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $aphAM.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $040dbb9c344a508d$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $2vsP7.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $aphAM.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $aphAM.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $040dbb9c344a508d$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $2vsP7.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $aphAM.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $aphAM.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $040dbb9c344a508d$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $aphAM.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $aphAM.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $040dbb9c344a508d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $040dbb9c344a508d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref7, $040dbb9c344a508d$var$_excluded);
    let { basename: basename } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($040dbb9c344a508d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $2vsP7.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $aphAM.useHref)(to, {
        relative: relative
    });
    let internalOnClick = $040dbb9c344a508d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $acw62.createElement("a", $040dbb9c344a508d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $040dbb9c344a508d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $acw62.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref8, $040dbb9c344a508d$var$_excluded2);
    let path = (0, $aphAM.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, $aphAM.useLocation)();
    let routerState = $acw62.useContext((0, $aphAM.UNSAFE_DataRouterStateContext));
    let { navigator: navigator, basename: basename } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $040dbb9c344a508d$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $2vsP7.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a6c7ac8248d6e38a, $040dbb9c344a508d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $040dbb9c344a508d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $acw62.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $040dbb9c344a508d$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref9, $040dbb9c344a508d$var$_excluded3);
    let submit = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let formAction = $040dbb9c344a508d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $acw62.createElement("form", $040dbb9c344a508d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $040dbb9c344a508d$export$11aac1aab828f1fa(_ref0) {
    let { getKey: getKey, storageKey: storageKey } = _ref0;
    $040dbb9c344a508d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $040dbb9c344a508d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($040dbb9c344a508d$var$DataRouterHook || ($040dbb9c344a508d$var$DataRouterHook = {}));
var $040dbb9c344a508d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($040dbb9c344a508d$var$DataRouterStateHook || ($040dbb9c344a508d$var$DataRouterStateHook = {}));
// Internal hooks
function $040dbb9c344a508d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $040dbb9c344a508d$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $aphAM.UNSAFE_DataRouterContext));
    !ctx && (0, $2vsP7.UNSAFE_invariant)(false);
    return ctx;
}
function $040dbb9c344a508d$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $aphAM.UNSAFE_DataRouterStateContext));
    !state && (0, $2vsP7.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $040dbb9c344a508d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $aphAM.useNavigate)();
    let location = (0, $aphAM.useLocation)();
    let path = (0, $aphAM.useResolvedPath)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($040dbb9c344a508d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $2vsP7.createPath)(location) === (0, $2vsP7.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $040dbb9c344a508d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $acw62.useRef($040dbb9c344a508d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $aphAM.useLocation)();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $040dbb9c344a508d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $aphAM.useNavigate)();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $040dbb9c344a508d$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $040dbb9c344a508d$var$fetcherId = 0;
let $040dbb9c344a508d$var$getUniqueFetcherId = ()=>"__" + String(++$040dbb9c344a508d$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $040dbb9c344a508d$export$47c85c6e3a081d3() {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext));
    let currentRouteId = (0, $aphAM.UNSAFE_useRouteId)();
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $040dbb9c344a508d$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $040dbb9c344a508d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext));
    let routeContext = $acw62.useContext((0, $aphAM.UNSAFE_RouteContext));
    !routeContext && (0, $2vsP7.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $040dbb9c344a508d$var$_extends({}, (0, $aphAM.useResolvedPath)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $aphAM.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $2vsP7.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $2vsP7.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $040dbb9c344a508d$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseFetcher);
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $acw62.useContext($040dbb9c344a508d$export$148fd98d095596d4);
    let route = $acw62.useContext((0, $aphAM.UNSAFE_RouteContext));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $2vsP7.UNSAFE_invariant)(false);
    !route && (0, $2vsP7.UNSAFE_invariant)(false);
    !(routeId != null) && (0, $2vsP7.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $040dbb9c344a508d$var$useIdImpl ? $040dbb9c344a508d$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($040dbb9c344a508d$var$getUniqueFetcherId());
    // Registration/cleanup
    $acw62.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $acw62.useCallback((href, opts)=>{
        !routeId && (0, $2vsP7.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback((target, opts)=>{
        submitImpl(target, $040dbb9c344a508d$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a7fed597f4b8afd8, $040dbb9c344a508d$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $2vsP7.IDLE_FETCHER);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>$040dbb9c344a508d$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $040dbb9c344a508d$export$fa996778a3a31087() {
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref1)=>{
        let [key, fetcher] = _ref1;
        return $040dbb9c344a508d$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $040dbb9c344a508d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $040dbb9c344a508d$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext));
    let location = (0, $aphAM.useLocation)();
    let matches = (0, $aphAM.useMatches)();
    let navigation = (0, $aphAM.useNavigation)();
    // Trigger manual scroll restoration while we're active
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $040dbb9c344a508d$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $040dbb9c344a508d$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($040dbb9c344a508d$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $040dbb9c344a508d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($040dbb9c344a508d$var$_extends({}, location, {
                    pathname: (0, $2vsP7.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($040dbb9c344a508d$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $040dbb9c344a508d$export$39f4eb3dbd812741(_ref10) {
    let { when: when, message: message } = _ref10;
    let blocker = (0, $aphAM.useBlocker)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $040dbb9c344a508d$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $acw62.useContext($040dbb9c344a508d$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $2vsP7.UNSAFE_invariant)(false);
    let { basename: basename } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.useViewTransitionState);
    let path = (0, $aphAM.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $2vsP7.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $2vsP7.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $2vsP7.matchPath)(path.pathname, nextPath) != null || (0, $2vsP7.matchPath)(path.pathname, currentPath) != null;
}

});
parcelRegister("2vsP7", function(module, exports) {

$parcel$export(module.exports, "Action", () => $1d34d5c4a288b213$export$e19cd5f9376f8cee);
$parcel$export(module.exports, "createMemoryHistory", () => $1d34d5c4a288b213$export$2b76ad033c6e6d08);
$parcel$export(module.exports, "createPath", () => $1d34d5c4a288b213$export$fe53371bee54353d);
$parcel$export(module.exports, "parsePath", () => $1d34d5c4a288b213$export$8ccf933b0513f8d0);
$parcel$export(module.exports, "createBrowserHistory", () => $1d34d5c4a288b213$export$719fc203c4e16dee);
$parcel$export(module.exports, "createHashHistory", () => $1d34d5c4a288b213$export$b71fdd3798280242);
$parcel$export(module.exports, "UNSAFE_invariant", () => $1d34d5c4a288b213$export$3e9cee6b33872309);
$parcel$export(module.exports, "matchRoutes", () => $1d34d5c4a288b213$export$2708184779ceb39d);
$parcel$export(module.exports, "stripBasename", () => $1d34d5c4a288b213$export$b69e3301ce081aa3);
$parcel$export(module.exports, "UNSAFE_decodePath", () => $1d34d5c4a288b213$export$30d21fd6d7295f52);
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", () => $1d34d5c4a288b213$export$b3fac024fad9e8ff);
$parcel$export(module.exports, "joinPaths", () => $1d34d5c4a288b213$export$86d9a7913e44197e);
$parcel$export(module.exports, "matchPath", () => $1d34d5c4a288b213$export$81336c211d5ff295);
$parcel$export(module.exports, "UNSAFE_getResolveToMatches", () => $1d34d5c4a288b213$export$a5784978eca585fa);
$parcel$export(module.exports, "resolveTo", () => $1d34d5c4a288b213$export$cae722b0cc860f13);
$parcel$export(module.exports, "AbortedDeferredError", () => $1d34d5c4a288b213$export$42a99a7a4bc0e76a);
$parcel$export(module.exports, "UNSAFE_ErrorResponseImpl", () => $1d34d5c4a288b213$export$6c6580e81da25755);
$parcel$export(module.exports, "isRouteErrorResponse", () => $1d34d5c4a288b213$export$972111febbeef05b);
$parcel$export(module.exports, "IDLE_FETCHER", () => $1d34d5c4a288b213$export$52eace9c284d3585);
$parcel$export(module.exports, "IDLE_BLOCKER", () => $1d34d5c4a288b213$export$386d57f03f0b2883);
$parcel$export(module.exports, "createRouter", () => $1d34d5c4a288b213$export$baddd0131ee8c05b);
/**
 * @remix-run/router v1.23.4
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d34d5c4a288b213$var$_extends() {
    return $1d34d5c4a288b213$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1d34d5c4a288b213$var$_extends.apply(null, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1d34d5c4a288b213$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1d34d5c4a288b213$export$e19cd5f9376f8cee || ($1d34d5c4a288b213$export$e19cd5f9376f8cee = {}));
const $1d34d5c4a288b213$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1d34d5c4a288b213$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1d34d5c4a288b213$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1d34d5c4a288b213$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1d34d5c4a288b213$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1d34d5c4a288b213$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1d34d5c4a288b213$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1d34d5c4a288b213$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1d34d5c4a288b213$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1d34d5c4a288b213$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1d34d5c4a288b213$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1d34d5c4a288b213$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1d34d5c4a288b213$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1d34d5c4a288b213$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1d34d5c4a288b213$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $1d34d5c4a288b213$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $1d34d5c4a288b213$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1d34d5c4a288b213$var$ResultType || ($1d34d5c4a288b213$var$ResultType = {}));
const $1d34d5c4a288b213$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1d34d5c4a288b213$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1d34d5c4a288b213$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1d34d5c4a288b213$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($1d34d5c4a288b213$var$isIndexRoute(route)) {
            let indexRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1d34d5c4a288b213$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $1d34d5c4a288b213$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1d34d5c4a288b213$var$flattenRoutes(routes);
    $1d34d5c4a288b213$var$rankRouteBranches(branches);
    let matches = null;
    let decoded = $1d34d5c4a288b213$export$30d21fd6d7295f52(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)// Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    matches = $1d34d5c4a288b213$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $1d34d5c4a288b213$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1d34d5c4a288b213$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1d34d5c4a288b213$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $1d34d5c4a288b213$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1d34d5c4a288b213$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1d34d5c4a288b213$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1d34d5c4a288b213$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1d34d5c4a288b213$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1d34d5c4a288b213$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1d34d5c4a288b213$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1d34d5c4a288b213$var$paramRe = /^:[\w-]+$/;
const $1d34d5c4a288b213$var$dynamicSegmentValue = 3;
const $1d34d5c4a288b213$var$indexRouteValue = 2;
const $1d34d5c4a288b213$var$emptySegmentValue = 1;
const $1d34d5c4a288b213$var$staticSegmentValue = 10;
const $1d34d5c4a288b213$var$splatPenalty = -2;
const $1d34d5c4a288b213$var$isSplat = (s)=>s === "*";
function $1d34d5c4a288b213$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1d34d5c4a288b213$var$isSplat)) initialScore += $1d34d5c4a288b213$var$splatPenalty;
    if (index) initialScore += $1d34d5c4a288b213$var$indexRouteValue;
    return segments.filter((s)=>!$1d34d5c4a288b213$var$isSplat(s)).reduce((score, segment)=>score + ($1d34d5c4a288b213$var$paramRe.test(segment) ? $1d34d5c4a288b213$var$dynamicSegmentValue : segment === "" ? $1d34d5c4a288b213$var$emptySegmentValue : $1d34d5c4a288b213$var$staticSegmentValue), initialScore);
}
function $1d34d5c4a288b213$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1d34d5c4a288b213$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1d34d5c4a288b213$export$a5c6d149b50c1d86($1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1d34d5c4a288b213$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $1d34d5c4a288b213$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $1d34d5c4a288b213$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $1d34d5c4a288b213$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $1d34d5c4a288b213$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1d34d5c4a288b213$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1d34d5c4a288b213$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $1d34d5c4a288b213$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = $1d34d5c4a288b213$var$removeDoubleSlashes(toPathname);
        if (toPathname.startsWith("/")) pathname = $1d34d5c4a288b213$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $1d34d5c4a288b213$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $1d34d5c4a288b213$var$normalizeSearch(search),
        hash: $1d34d5c4a288b213$var$normalizeHash(hash)
    };
}
function $1d34d5c4a288b213$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1d34d5c4a288b213$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1d34d5c4a288b213$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $1d34d5c4a288b213$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1d34d5c4a288b213$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1d34d5c4a288b213$var$_extends({}, toArg);
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1d34d5c4a288b213$var$getInvalidPathError("?", "pathname", "search", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "pathname", "hash", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
const $1d34d5c4a288b213$var$removeDoubleSlashes = (path)=>path.replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$export$86d9a7913e44197e = (paths)=>$1d34d5c4a288b213$var$removeDoubleSlashes(paths.join("/"));
/**
 * @private
 */ const $1d34d5c4a288b213$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $1d34d5c4a288b213$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1d34d5c4a288b213$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $1d34d5c4a288b213$export$4051a07651545597(data, init) {
    return new $1d34d5c4a288b213$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $1d34d5c4a288b213$export$42a99a7a4bc0e76a extends Error {
}
class $1d34d5c4a288b213$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1d34d5c4a288b213$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1d34d5c4a288b213$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1d34d5c4a288b213$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1d34d5c4a288b213$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $1d34d5c4a288b213$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1d34d5c4a288b213$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1d34d5c4a288b213$var$unwrapTrackedPromise(value) {
    if (!$1d34d5c4a288b213$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $1d34d5c4a288b213$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1d34d5c4a288b213$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $1d34d5c4a288b213$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1d34d5c4a288b213$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1d34d5c4a288b213$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1d34d5c4a288b213$var$validMutationMethods = new Set($1d34d5c4a288b213$var$validMutationMethodsArr);
const $1d34d5c4a288b213$var$validRequestMethodsArr = [
    "get",
    ...$1d34d5c4a288b213$var$validMutationMethodsArr
];
const $1d34d5c4a288b213$var$validRequestMethods = new Set($1d34d5c4a288b213$var$validRequestMethodsArr);
const $1d34d5c4a288b213$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1d34d5c4a288b213$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1d34d5c4a288b213$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $1d34d5c4a288b213$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$1d34d5c4a288b213$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$1d34d5c4a288b213$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $1d34d5c4a288b213$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $1d34d5c4a288b213$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$1d34d5c4a288b213$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $1d34d5c4a288b213$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $1d34d5c4a288b213$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($1d34d5c4a288b213$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $1d34d5c4a288b213$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1d34d5c4a288b213$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $1d34d5c4a288b213$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $1d34d5c4a288b213$var$findNearestBoundary(matches).route.id,
            {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($1d34d5c4a288b213$var$isErrorResult(result) && $1d34d5c4a288b213$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1d34d5c4a288b213$var$_extends({
            matches: updatedMatches || matches
        }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $1d34d5c4a288b213$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $1d34d5c4a288b213$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $1d34d5c4a288b213$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($1d34d5c4a288b213$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $1d34d5c4a288b213$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $1d34d5c4a288b213$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $1d34d5c4a288b213$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult) || $1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(actionResult)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $1d34d5c4a288b213$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) result = await $1d34d5c4a288b213$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $1d34d5c4a288b213$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $1d34d5c4a288b213$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $1d34d5c4a288b213$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $1d34d5c4a288b213$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1d34d5c4a288b213$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $1d34d5c4a288b213$var$ResultType.redirect,
                response: $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $1d34d5c4a288b213$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: $1d34d5c4a288b213$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $1d34d5c4a288b213$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1d34d5c4a288b213$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1d34d5c4a288b213$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1d34d5c4a288b213$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$1d34d5c4a288b213$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1d34d5c4a288b213$export$4d0306f8f6a4585b = Symbol("deferred");
function $1d34d5c4a288b213$export$3336b097a6fbc59a(routes, opts) {
    $1d34d5c4a288b213$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1d34d5c4a288b213$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1d34d5c4a288b213$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1d34d5c4a288b213$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $1d34d5c4a288b213$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1d34d5c4a288b213$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1d34d5c4a288b213$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $1d34d5c4a288b213$var$isResponse(result) ? result : $1d34d5c4a288b213$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($1d34d5c4a288b213$var$isDataStrategyResult(e) && $1d34d5c4a288b213$var$isResponse(e.result)) {
                if (e.type === $1d34d5c4a288b213$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1d34d5c4a288b213$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1d34d5c4a288b213$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $1d34d5c4a288b213$var$_extends({}, context, {
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $1d34d5c4a288b213$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1d34d5c4a288b213$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($1d34d5c4a288b213$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1d34d5c4a288b213$export$fec11da027c70692(routes, context, error) {
    let newContext = $1d34d5c4a288b213$var$_extends({}, context, {
        statusCode: $1d34d5c4a288b213$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $1d34d5c4a288b213$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $1d34d5c4a288b213$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $1d34d5c4a288b213$export$cae722b0cc860f13(to ? to : ".", $1d34d5c4a288b213$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $1d34d5c4a288b213$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1d34d5c4a288b213$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1d34d5c4a288b213$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1d34d5c4a288b213$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1d34d5c4a288b213$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1d34d5c4a288b213$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $1d34d5c4a288b213$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $1d34d5c4a288b213$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1d34d5c4a288b213$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1d34d5c4a288b213$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1d34d5c4a288b213$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $1d34d5c4a288b213$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $1d34d5c4a288b213$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($1d34d5c4a288b213$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1d34d5c4a288b213$var$shouldRevalidateLoader(match, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1d34d5c4a288b213$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $1d34d5c4a288b213$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $1d34d5c4a288b213$var$shouldRevalidateLoader(fetcherMatch, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1d34d5c4a288b213$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $1d34d5c4a288b213$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1d34d5c4a288b213$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $1d34d5c4a288b213$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$1d34d5c4a288b213$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $1d34d5c4a288b213$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$1d34d5c4a288b213$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1d34d5c4a288b213$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1d34d5c4a288b213$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1d34d5c4a288b213$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$1d34d5c4a288b213$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $1d34d5c4a288b213$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $1d34d5c4a288b213$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $1d34d5c4a288b213$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $1d34d5c4a288b213$var$ResultType.data,
                result: undefined
            });
        };
        return $1d34d5c4a288b213$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $1d34d5c4a288b213$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($1d34d5c4a288b213$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: e
            };
        }
        if (type === $1d34d5c4a288b213$var$ResultType.error) return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: new $1d34d5c4a288b213$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $1d34d5c4a288b213$var$ResultType.error) {
        if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: new $1d34d5c4a288b213$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: result,
            statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($1d34d5c4a288b213$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $1d34d5c4a288b213$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $1d34d5c4a288b213$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $1d34d5c4a288b213$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    // Match Chrome's behavior:
    // https://github.com/chromium/chromium/blob/216dbeb61db0c667e62082e5f5400a32d6983df3/content/public/common/url_utils.cc#L82
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return $1d34d5c4a288b213$var$removeDoubleSlashes(url.pathname) + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1d34d5c4a288b213$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1d34d5c4a288b213$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $1d34d5c4a288b213$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1d34d5c4a288b213$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $1d34d5c4a288b213$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1d34d5c4a288b213$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1d34d5c4a288b213$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1d34d5c4a288b213$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1d34d5c4a288b213$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1d34d5c4a288b213$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1d34d5c4a288b213$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1d34d5c4a288b213$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $1d34d5c4a288b213$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $1d34d5c4a288b213$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $1d34d5c4a288b213$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) : path;
    return $1d34d5c4a288b213$export$fe53371bee54353d($1d34d5c4a288b213$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1d34d5c4a288b213$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1d34d5c4a288b213$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $1d34d5c4a288b213$var$ResultType.data || result.type === $1d34d5c4a288b213$var$ResultType.error);
}
function $1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result) {
    return $1d34d5c4a288b213$var$isResponse(result.result) && $1d34d5c4a288b213$var$redirectStatusCodes.has(result.result.status);
}
function $1d34d5c4a288b213$var$isDeferredResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.deferred;
}
function $1d34d5c4a288b213$var$isErrorResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.error;
}
function $1d34d5c4a288b213$var$isRedirectResult(result) {
    return (result && result.type) === $1d34d5c4a288b213$var$ResultType.redirect;
}
function $1d34d5c4a288b213$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $1d34d5c4a288b213$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1d34d5c4a288b213$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1d34d5c4a288b213$var$isRedirectResponse(result) {
    if (!$1d34d5c4a288b213$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1d34d5c4a288b213$var$isValidMethod(method) {
    return $1d34d5c4a288b213$var$validRequestMethods.has(method.toLowerCase());
}
function $1d34d5c4a288b213$var$isMutationMethod(method) {
    return $1d34d5c4a288b213$var$validMutationMethods.has(method.toLowerCase());
}
async function $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1d34d5c4a288b213$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $1d34d5c4a288b213$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $1d34d5c4a288b213$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $1d34d5c4a288b213$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $1d34d5c4a288b213$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1d34d5c4a288b213$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $1d34d5c4a288b213$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1d34d5c4a288b213$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $1d34d5c4a288b213$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $1d34d5c4a288b213$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $1d34d5c4a288b213$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $1d34d5c4a288b213$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});

parcelRegister("aphAM", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_DataRouterContext", () => $7939e29d663dd3ed$export$3add0d5dce533e2e);
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", () => $7939e29d663dd3ed$export$145dfa71566a64dc);
$parcel$export(module.exports, "UNSAFE_NavigationContext", () => $7939e29d663dd3ed$export$26749e8557646306);
$parcel$export(module.exports, "UNSAFE_RouteContext", () => $7939e29d663dd3ed$export$9072aa6dd1f93057);
$parcel$export(module.exports, "useHref", () => $7939e29d663dd3ed$export$b66bb29c5006f12f);
$parcel$export(module.exports, "useResolvedPath", () => $7939e29d663dd3ed$export$e75d2a2d1b3c245b);
$parcel$export(module.exports, "useLocation", () => $7939e29d663dd3ed$export$45d76561a5302f2b);
$parcel$export(module.exports, "useNavigate", () => $7939e29d663dd3ed$export$9770f232ac06a008);
$parcel$export(module.exports, "useParams", () => $7939e29d663dd3ed$export$99eaa27ddbbb95ef);
$parcel$export(module.exports, "UNSAFE_useRoutesImpl", () => $7939e29d663dd3ed$export$5fcee62552a12fbf);
$parcel$export(module.exports, "UNSAFE_useRouteId", () => $7939e29d663dd3ed$export$5fc8298006ad9e58);
$parcel$export(module.exports, "useNavigation", () => $7939e29d663dd3ed$export$d0fd4b7106de2769);
$parcel$export(module.exports, "useMatches", () => $7939e29d663dd3ed$export$2378eb7f5ff86053);
$parcel$export(module.exports, "useBlocker", () => $7939e29d663dd3ed$export$b273b3273281a049);
$parcel$export(module.exports, "UNSAFE_logV6DeprecationWarnings", () => $7939e29d663dd3ed$export$db5148ec97d6af7a);
$parcel$export(module.exports, "Router", () => $7939e29d663dd3ed$export$55185c17a0fcbe46);
$parcel$export(module.exports, "Navigate", () => $7939e29d663dd3ed$export$444b3ab0cb9aec40);
$parcel$export(module.exports, "Route", () => $7939e29d663dd3ed$export$e7b0ac011bb776c6);
$parcel$export(module.exports, "Routes", () => $7939e29d663dd3ed$export$3565eb3d00ca5a74);
$parcel$export(module.exports, "UNSAFE_mapRouteProperties", () => $7939e29d663dd3ed$export$52b333d321859367);
/**
 * React Router v6.30.6
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

var $2vsP7 = parcelRequire("2vsP7");
function $7939e29d663dd3ed$var$_extends() {
    return $7939e29d663dd3ed$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7939e29d663dd3ed$var$_extends.apply(null, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7939e29d663dd3ed$export$3add0d5dce533e2e = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$145dfa71566a64dc = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$var$AwaitContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7939e29d663dd3ed$export$26749e8557646306 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7939e29d663dd3ed$var$RouteErrorContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $7939e29d663dd3ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $2vsP7.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $7939e29d663dd3ed$export$9c954a9d03d32f4a() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $7939e29d663dd3ed$export$45d76561a5302f2b() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $7939e29d663dd3ed$export$1b3f31771c5d07c() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $7939e29d663dd3ed$export$6c330e8992e8a295(pattern) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let { pathname: pathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $2vsP7.matchPath)(pattern, (0, $2vsP7.UNSAFE_decodePath)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7939e29d663dd3ed$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $7939e29d663dd3ed$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7939e29d663dd3ed$var$useNavigateStable() : $7939e29d663dd3ed$var$useNavigateUnstable();
}
function $7939e29d663dd3ed$var$useNavigateUnstable() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $2vsP7.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $2vsP7.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $2vsP7.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$OutletContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $7939e29d663dd3ed$export$4138103a3ae699cc() {
    return $acw62.useContext($7939e29d663dd3ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $7939e29d663dd3ed$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $7939e29d663dd3ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $2vsP7.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $acw62.useMemo(()=>(0, $2vsP7.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $7939e29d663dd3ed$export$5d3fca4a98652595(routes, locationArg) {
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let { navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: parentMatches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $2vsP7.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $2vsP7.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $2vsP7.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7939e29d663dd3ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $2vsP7.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $2vsP7.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7939e29d663dd3ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $2vsP7.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7939e29d663dd3ed$var$DefaultErrorComponent() {
    let error = $7939e29d663dd3ed$export$ed527bf60f6e05f2();
    let message = (0, $2vsP7.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7939e29d663dd3ed$var$defaultErrorElement = /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DefaultErrorComponent, null);
class $7939e29d663dd3ed$var$RenderErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7939e29d663dd3ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7939e29d663dd3ed$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $2vsP7.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $7939e29d663dd3ed$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $7939e29d663dd3ed$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7939e29d663dd3ed$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7939e29d663dd3ed$var$DataRouterHook || {});
var $7939e29d663dd3ed$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7939e29d663dd3ed$var$DataRouterStateHook || {});
function $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $7939e29d663dd3ed$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    !ctx && (0, $2vsP7.UNSAFE_invariant)(false);
    return ctx;
}
function $7939e29d663dd3ed$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    !state && (0, $2vsP7.UNSAFE_invariant)(false);
    return state;
}
function $7939e29d663dd3ed$var$useRouteContext(hookName) {
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $2vsP7.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7939e29d663dd3ed$var$useCurrentRouteId(hookName) {
    let route = $7939e29d663dd3ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $2vsP7.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7939e29d663dd3ed$export$5fc8298006ad9e58() {
    return $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7939e29d663dd3ed$export$d0fd4b7106de2769() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7939e29d663dd3ed$export$600dc272ed516c15() {
    let dataRouterContext = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseRevalidator);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRevalidator);
    return $acw62.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7939e29d663dd3ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseMatches);
    return $acw62.useMemo(()=>matches.map((m)=>(0, $2vsP7.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7939e29d663dd3ed$export$1448a5050d252c4d() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7939e29d663dd3ed$export$fd5d37484eab868d(routeId) {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7939e29d663dd3ed$export$fdc00f3f26066d5e() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseActionData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7939e29d663dd3ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $acw62.useContext($7939e29d663dd3ed$var$RouteErrorContext);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$17f53340677d5831() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7939e29d663dd3ed$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7939e29d663dd3ed$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseBlocker);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7939e29d663dd3ed$var$_extends({}, currentLocation, {
                pathname: (0, $2vsP7.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7939e29d663dd3ed$var$_extends({}, nextLocation, {
                pathname: (0, $2vsP7.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $acw62.useEffect(()=>{
        let key = String(++$7939e29d663dd3ed$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $2vsP7.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7939e29d663dd3ed$var$useNavigateStable() {
    let { router: router } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseNavigateStable);
    let id = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7939e29d663dd3ed$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$alreadyWarned$1 = {};
function $7939e29d663dd3ed$var$warningOnce(key, cond, message) {
    if (!cond && !$7939e29d663dd3ed$var$alreadyWarned$1[key]) $7939e29d663dd3ed$var$alreadyWarned$1[key] = true;
}
const $7939e29d663dd3ed$var$alreadyWarned = {};
function $7939e29d663dd3ed$var$warnOnce(key, message) {}
const $7939e29d663dd3ed$var$logDeprecation = (flag, msg, link)=>$7939e29d663dd3ed$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $7939e29d663dd3ed$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $7939e29d663dd3ed$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7939e29d663dd3ed$var$START_TRANSITION = "startTransition";
const $7939e29d663dd3ed$var$startTransitionImpl = $acw62[$7939e29d663dd3ed$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7939e29d663dd3ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        if (v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl) $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $acw62.useEffect(()=>$7939e29d663dd3ed$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $7939e29d663dd3ed$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $7939e29d663dd3ed$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $2vsP7.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl ? $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>$7939e29d663dd3ed$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $7939e29d663dd3ed$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let { future: future, static: isStatic } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let navigate = $7939e29d663dd3ed$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $2vsP7.resolveTo)(to, (0, $2vsP7.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $7939e29d663dd3ed$export$910ae8079b2c2852(props) {
    return $7939e29d663dd3ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $7939e29d663dd3ed$export$e7b0ac011bb776c6(_props) {
    (0, $2vsP7.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $7939e29d663dd3ed$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $2vsP7.Action).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $7939e29d663dd3ed$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $2vsP7.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $2vsP7.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $7939e29d663dd3ed$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7939e29d663dd3ed$export$5d3fca4a98652595($7939e29d663dd3ed$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7939e29d663dd3ed$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$ResolveAwait, null, children));
}
var $7939e29d663dd3ed$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7939e29d663dd3ed$var$AwaitRenderStatus || {});
const $7939e29d663dd3ed$var$neverSettledPromise = new Promise(()=>{});
class $7939e29d663dd3ed$var$AwaitErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.error : "_data" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.success : $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $2vsP7.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $7939e29d663dd3ed$var$neverSettledPromise;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $7939e29d663dd3ed$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7939e29d663dd3ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $7939e29d663dd3ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7939e29d663dd3ed$export$e7b0ac011bb776c6) && (0, $2vsP7.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $2vsP7.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7939e29d663dd3ed$export$daf73786167a7f72(matches) {
    return $7939e29d663dd3ed$var$_renderMatches(matches);
}
function $7939e29d663dd3ed$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $acw62.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $acw62.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $acw62.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7939e29d663dd3ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $2vsP7.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7939e29d663dd3ed$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $2vsP7.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7939e29d663dd3ed$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}

});


parcelRegister("5N0ZI", function(module, exports) {

$parcel$export(module.exports, "FormField", () => (parcelRequire("7phmx")).default);
$parcel$export(module.exports, "TextInput", () => (parcelRequire("a7Rbr")).default);
$parcel$export(module.exports, "PhoneInput", () => (parcelRequire("lffTJ")).default);
$parcel$export(module.exports, "PhoneNumber", () => (parcelRequire("8ym5i")).default);
$parcel$export(module.exports, "PhoneListInput", () => (parcelRequire("6SCJ6")).default);
$parcel$export(module.exports, "phoneListRows", () => (parcelRequire("6SCJ6")).phoneListRows);
$parcel$export(module.exports, "phoneListPayload", () => (parcelRequire("6SCJ6")).phoneListPayload);
$parcel$export(module.exports, "phoneListProblems", () => (parcelRequire("6SCJ6")).phoneListProblems);
$parcel$export(module.exports, "PhoneCandidateList", () => (parcelRequire("9cQDs")).default);
$parcel$export(module.exports, "UNKNOWN_RELATION", () => (parcelRequire("9Bif4")).UNKNOWN_RELATION);
$parcel$export(module.exports, "phoneRelationLabel", () => (parcelRequire("9Bif4")).phoneRelationLabel);
$parcel$export(module.exports, "NationalIdInput", () => (parcelRequire("Ydgp5")).default);
$parcel$export(module.exports, "NumberInput", () => (parcelRequire("9iIGe")).default);
$parcel$export(module.exports, "MoneyInput", () => (parcelRequire("lkMIV")).default);
$parcel$export(module.exports, "Textarea", () => (parcelRequire("iygI2")).default);
$parcel$export(module.exports, "Select", () => (parcelRequire("fAR2n")).default);
$parcel$export(module.exports, "ToggleGroup", () => (parcelRequire("5Rv3V")).default);
$parcel$export(module.exports, "ChipSelector", () => (parcelRequire("bkKUS")).default);
$parcel$export(module.exports, "CardSelector", () => (parcelRequire("jIDmT")).default);
$parcel$export(module.exports, "SearchInput", () => (parcelRequire("amyVq")).default);
$parcel$export(module.exports, "Checkbox", () => (parcelRequire("9gEOi")).default);
$parcel$export(module.exports, "Toggle", () => (parcelRequire("3GEBR")).default);
$parcel$export(module.exports, "Button", () => (parcelRequire("aJ1FU")).default);
$parcel$export(module.exports, "Badge", () => (parcelRequire("bHjRG")).default);
$parcel$export(module.exports, "badgeVariants", () => (parcelRequire("bHjRG")).badgeVariants);
$parcel$export(module.exports, "Dialog", () => (parcelRequire("4fYdd")).Dialog);
$parcel$export(module.exports, "DialogContent", () => (parcelRequire("4fYdd")).DialogContent);
$parcel$export(module.exports, "DialogHeader", () => (parcelRequire("4fYdd")).DialogHeader);
$parcel$export(module.exports, "DialogBody", () => (parcelRequire("4fYdd")).DialogBody);
$parcel$export(module.exports, "DialogTitle", () => (parcelRequire("4fYdd")).DialogTitle);
$parcel$export(module.exports, "DialogDescription", () => (parcelRequire("4fYdd")).DialogDescription);
$parcel$export(module.exports, "DialogFooter", () => (parcelRequire("4fYdd")).DialogFooter);
$parcel$export(module.exports, "Drawer", () => (parcelRequire("beZBx")).default);
$parcel$export(module.exports, "DrawerHeader", () => (parcelRequire("beZBx")).DrawerHeader);
$parcel$export(module.exports, "DrawerBody", () => (parcelRequire("beZBx")).DrawerBody);
$parcel$export(module.exports, "DrawerFooter", () => (parcelRequire("beZBx")).DrawerFooter);
$parcel$export(module.exports, "BottomSheet", () => (parcelRequire("cZOyb")).default);
$parcel$export(module.exports, "Menu", () => (parcelRequire("bfs4Q")).default);
$parcel$export(module.exports, "TaskOverlay", () => (parcelRequire("gCvEY")).default);
$parcel$export(module.exports, "ToastProvider", () => (parcelRequire("6usBW")).ToastProvider);
$parcel$export(module.exports, "useToast", () => (parcelRequire("6usBW")).useToast);
$parcel$export(module.exports, "Spinner", () => (parcelRequire("hZDga")).Spinner);
$parcel$export(module.exports, "SessionCheck", () => (parcelRequire("fvho4")).SessionCheck);
$parcel$export(module.exports, "SessionError", () => (parcelRequire("fvho4")).SessionError);
$parcel$export(module.exports, "Skeleton", () => (parcelRequire("66joL")).default);
$parcel$export(module.exports, "SkeletonRegion", () => (parcelRequire("66joL")).SkeletonRegion);
$parcel$export(module.exports, "SkeletonText", () => (parcelRequire("66joL")).SkeletonText);
$parcel$export(module.exports, "SkeletonAvatar", () => (parcelRequire("66joL")).SkeletonAvatar);
$parcel$export(module.exports, "SkeletonButton", () => (parcelRequire("66joL")).SkeletonButton);
$parcel$export(module.exports, "SkeletonInput", () => (parcelRequire("66joL")).SkeletonInput);
$parcel$export(module.exports, "SkeletonCard", () => (parcelRequire("66joL")).SkeletonCard);
$parcel$export(module.exports, "SkeletonRow", () => (parcelRequire("66joL")).SkeletonRow);
$parcel$export(module.exports, "SkeletonTable", () => (parcelRequire("66joL")).SkeletonTable);
$parcel$export(module.exports, "SkeletonList", () => (parcelRequire("66joL")).SkeletonList);
$parcel$export(module.exports, "SkeletonTabs", () => (parcelRequire("66joL")).SkeletonTabs);
$parcel$export(module.exports, "SkeletonChart", () => (parcelRequire("66joL")).SkeletonChart);
$parcel$export(module.exports, "SkeletonForm", () => (parcelRequire("66joL")).SkeletonForm);
$parcel$export(module.exports, "SkeletonHeader", () => (parcelRequire("66joL")).SkeletonHeader);
$parcel$export(module.exports, "SkeletonFilters", () => (parcelRequire("66joL")).SkeletonFilters);
$parcel$export(module.exports, "SkeletonStats", () => (parcelRequire("66joL")).SkeletonStats);
$parcel$export(module.exports, "EmptyState", () => (parcelRequire("7gSBD")).default);
$parcel$export(module.exports, "Avatar", () => (parcelRequire("7wZCE")).default);
$parcel$export(module.exports, "avatarColor", () => (parcelRequire("7wZCE")).avatarColor);
$parcel$export(module.exports, "Card", () => (parcelRequire("g6X9N")).default);
$parcel$export(module.exports, "StatusBadge", () => (parcelRequire("7h7Jc")).default);
$parcel$export(module.exports, "KpiCard", () => (parcelRequire("lUcdx")).default);
$parcel$export(module.exports, "PageHeader", () => (parcelRequire("kyZIh")).default);
$parcel$export(module.exports, "InnerPageHeader", () => (parcelRequire("jOGbh")).default);
$parcel$export(module.exports, "MobileHeader", () => (parcelRequire("dSwFB")).default);
$parcel$export(module.exports, "DayContextCard", () => (parcelRequire("hU4vR")).default);
$parcel$export(module.exports, "DayStatStrip", () => (parcelRequire("aM2JY")).default);
$parcel$export(module.exports, "WeekPickerSheet", () => (parcelRequire("300tQ")).default);
$parcel$export(module.exports, "ChoiceSheet", () => (parcelRequire("gJslC")).default);
$parcel$export(module.exports, "WalkInToggle", () => (parcelRequire("dyHsi")).default);
$parcel$export(module.exports, "BottomNav", () => (parcelRequire("iuHQQ")).default);
$parcel$export(module.exports, "StatTiles", () => (parcelRequire("9y25V")).default);
$parcel$export(module.exports, "SectionNav", () => (parcelRequire("fh5c7")).default);
$parcel$export(module.exports, "DateNavigator", () => (parcelRequire("gehDE")).default);
$parcel$export(module.exports, "SaveBar", () => (parcelRequire("jbdF9")).default);
$parcel$export(module.exports, "SectionCard", () => (parcelRequire("eJIXW")).default);
$parcel$export(module.exports, "Table", () => (parcelRequire("jFCWB")).default);
$parcel$export(module.exports, "SegmentedControl", () => (parcelRequire("fYgeo")).default);
$parcel$export(module.exports, "Pager", () => (parcelRequire("hILSM")).default);
$parcel$export(module.exports, "ConfirmDialog", () => (parcelRequire("cjPik")).default);
$parcel$export(module.exports, "Alert", () => (parcelRequire("dOauK")).default);
$parcel$export(module.exports, "ErrorState", () => (parcelRequire("2vXUl")).default);
$parcel$export(module.exports, "SystemPage", () => (parcelRequire("2tqZa")).default);
$parcel$export(module.exports, "ConnectivityBanner", () => (parcelRequire("fx6O8")).default);
$parcel$export(module.exports, "IconButton", () => (parcelRequire("5MbI8")).default);
$parcel$export(module.exports, "AddTile", () => (parcelRequire("hsrVQ")).default);
$parcel$export(module.exports, "Switch", () => (parcelRequire("cT2Zr")).default);
$parcel$export(module.exports, "CollapsibleSection", () => (parcelRequire("lxEfx")).default);
$parcel$export(module.exports, "PrizeWheel", () => (parcelRequire("fW63i")).default);
$parcel$export(module.exports, "FileDropzone", () => (parcelRequire("jM6yW")).default);
$parcel$export(module.exports, "ImageStackViewer", () => (parcelRequire("bhQd4")).default);
$parcel$export(module.exports, "FilterChip", () => (parcelRequire("h4ZeB")).default);
$parcel$export(module.exports, "Sparkline", () => (parcelRequire("3Amwd")).default);
$parcel$export(module.exports, "TrendChart", () => (parcelRequire("ePaaC")).default);
$parcel$export(module.exports, "TimeRuler", () => (parcelRequire("cPdQE")).default);
$parcel$export(module.exports, "SeriesLane", () => (parcelRequire("kCQwN")).default);
$parcel$export(module.exports, "IntervalBars", () => (parcelRequire("ctU9L")).default);
$parcel$export(module.exports, "EventMarkers", () => (parcelRequire("cLQXb")).default);
$parcel$export(module.exports, "createTimeScale", () => (parcelRequire("cRX9v")).createTimeScale);
$parcel$export(module.exports, "useMeasuredWidth", () => (parcelRequire("3uzzV")).default);
$parcel$export(module.exports, "useKeyboardInset", () => (parcelRequire("iK5Lj")).default);
$parcel$export(module.exports, "usePublishedHeight", () => (parcelRequire("kLmaN")).default);
$parcel$export(module.exports, "useOverlayHistory", () => (parcelRequire("9BgRG")).default);
$parcel$export(module.exports, "useOnlineStatus", () => (parcelRequire("3EHig")).useOnlineStatus);
$parcel$export(module.exports, "useResponsive", () => (parcelRequire("k27hS")).default);
$parcel$export(module.exports, "JalaliDatePicker", () => (parcelRequire("4Qco3")).default);
$parcel$export(module.exports, "JalaliCalendar", () => (parcelRequire("4Qco3")).JalaliCalendar);
$parcel$export(module.exports, "JalaliCalendarPopup", () => (parcelRequire("4Qco3")).JalaliCalendarPopup);
$parcel$export(module.exports, "splitDateTime", () => (parcelRequire("4Qco3")).splitDateTime);
$parcel$export(module.exports, "DateRangeFilter", () => (parcelRequire("awevB")).default);
$parcel$export(module.exports, "rangeLabelFor", () => (parcelRequire("awevB")).rangeLabelFor);
$parcel$export(module.exports, "cn", () => (parcelRequire("5JYPc")).cn);
$parcel$export(module.exports, "toEnDigits", () => (parcelRequire("5JYPc")).toEnDigits);
$parcel$export(module.exports, "phone", () => (parcelRequire("5AX1S")));
$parcel$export(module.exports, "nationalId", () => (parcelRequire("3tGMU")));
// ─────────────────────────────────────────────────────────────────────────────
// @parsina/ui — the unified Parsina UI kit for all three web clients
// (doctor, clinic, patient).
//
// Canonical copy: /packages/ui (monorepo root). Each client app receives a
// synced copy at src/shared/ui via `python dev/sync_shared.py` — edit HERE,
// never in the synced copies.
//
// Import everything from the barrel:
//   import { Button, TextInput, useToast } from '@parsina/ui';
// Design tokens live in the sibling package:
//   import { C, CT, statusColors } from '@parsina/tokens';
// ─────────────────────────────────────────────────────────────────────────────
// Form primitives

var $7phmx = parcelRequire("7phmx");

var $a7Rbr = parcelRequire("a7Rbr");

var $lffTJ = parcelRequire("lffTJ");

var $8ym5i = parcelRequire("8ym5i");

var $6SCJ6 = parcelRequire("6SCJ6");

var $9cQDs = parcelRequire("9cQDs");

var $9Bif4 = parcelRequire("9Bif4");

var $9sT7p = parcelRequire("9sT7p");

var $Ydgp5 = parcelRequire("Ydgp5");

var $9iIGe = parcelRequire("9iIGe");

var $lkMIV = parcelRequire("lkMIV");

var $iygI2 = parcelRequire("iygI2");

var $fAR2n = parcelRequire("fAR2n");

var $5Rv3V = parcelRequire("5Rv3V");

var $bkKUS = parcelRequire("bkKUS");

var $jIDmT = parcelRequire("jIDmT");

var $amyVq = parcelRequire("amyVq");

var $9gEOi = parcelRequire("9gEOi");

var $3GEBR = parcelRequire("3GEBR");

var $aJ1FU = parcelRequire("aJ1FU");

var $bHjRG = parcelRequire("bHjRG");

var $4fYdd = parcelRequire("4fYdd");

var $beZBx = parcelRequire("beZBx");

var $cZOyb = parcelRequire("cZOyb");

var $bfs4Q = parcelRequire("bfs4Q");

var $gCvEY = parcelRequire("gCvEY");

var $6usBW = parcelRequire("6usBW");

var $hZDga = parcelRequire("hZDga");

var $fvho4 = parcelRequire("fvho4");

var $66joL = parcelRequire("66joL");

var $7gSBD = parcelRequire("7gSBD");

var $7wZCE = parcelRequire("7wZCE");

var $2xPWT = parcelRequire("2xPWT");

var $4LQcd = parcelRequire("4LQcd");

var $g6X9N = parcelRequire("g6X9N");

var $7h7Jc = parcelRequire("7h7Jc");

var $lUcdx = parcelRequire("lUcdx");

var $fkDNf = parcelRequire("fkDNf");

var $kyZIh = parcelRequire("kyZIh");

var $jOGbh = parcelRequire("jOGbh");

var $9TQrL = parcelRequire("9TQrL");

var $dSwFB = parcelRequire("dSwFB");

var $hU4vR = parcelRequire("hU4vR");

var $aM2JY = parcelRequire("aM2JY");

var $300tQ = parcelRequire("300tQ");

var $gJslC = parcelRequire("gJslC");

var $dyHsi = parcelRequire("dyHsi");

var $2vdhF = parcelRequire("2vdhF");

var $iuHQQ = parcelRequire("iuHQQ");

var $9y25V = parcelRequire("9y25V");

var $fHxBh = parcelRequire("fHxBh");

var $fh5c7 = parcelRequire("fh5c7");

var $gehDE = parcelRequire("gehDE");

var $jbdF9 = parcelRequire("jbdF9");

var $eJIXW = parcelRequire("eJIXW");

var $jFCWB = parcelRequire("jFCWB");

var $fYgeo = parcelRequire("fYgeo");

var $hILSM = parcelRequire("hILSM");

var $cjPik = parcelRequire("cjPik");

var $dOauK = parcelRequire("dOauK");

var $2vXUl = parcelRequire("2vXUl");

var $2tqZa = parcelRequire("2tqZa");

var $coDoE = parcelRequire("coDoE");

var $fx6O8 = parcelRequire("fx6O8");

var $5MbI8 = parcelRequire("5MbI8");

var $hsrVQ = parcelRequire("hsrVQ");

var $cT2Zr = parcelRequire("cT2Zr");

var $lxEfx = parcelRequire("lxEfx");

var $fW63i = parcelRequire("fW63i");

var $jM6yW = parcelRequire("jM6yW");

var $bhQd4 = parcelRequire("bhQd4");

var $h4ZeB = parcelRequire("h4ZeB");

var $cRmgx = parcelRequire("cRmgx");

var $11M2E = parcelRequire("11M2E");

var $dlbmi = parcelRequire("dlbmi");

var $3IEEe = parcelRequire("3IEEe");

var $21L1d = parcelRequire("21L1d");

var $3Amwd = parcelRequire("3Amwd");

var $ePaaC = parcelRequire("ePaaC");

var $cPdQE = parcelRequire("cPdQE");

var $kCQwN = parcelRequire("kCQwN");

var $ctU9L = parcelRequire("ctU9L");

var $cLQXb = parcelRequire("cLQXb");

var $cRX9v = parcelRequire("cRX9v");

var $3uzzV = parcelRequire("3uzzV");

var $iK5Lj = parcelRequire("iK5Lj");

var $drSko = parcelRequire("drSko");

var $kLmaN = parcelRequire("kLmaN");

var $9BgRG = parcelRequire("9BgRG");

var $3EHig = parcelRequire("3EHig");

var $2sptB = parcelRequire("2sptB");

var $k27hS = parcelRequire("k27hS");

var $2u27R = parcelRequire("2u27R");

var $fOdIP = parcelRequire("fOdIP");

var $l0ks6 = parcelRequire("l0ks6");

var $jeN3v = parcelRequire("jeN3v");

var $kaN2E = parcelRequire("kaN2E");

var $4Qco3 = parcelRequire("4Qco3");

var $IZwml = parcelRequire("IZwml");

var $j9AxR = parcelRequire("j9AxR");

var $awevB = parcelRequire("awevB");

var $1Ssl4 = parcelRequire("1Ssl4");

var $5JYPc = parcelRequire("5JYPc");

var $ev4PJ = parcelRequire("ev4PJ");

var $4UJrq = parcelRequire("4UJrq");

var $hlTfq = parcelRequire("hlTfq");

var $lHVFz = parcelRequire("lHVFz");

var $5AX1S = parcelRequire("5AX1S");

var $3tGMU = parcelRequire("3tGMU");

var $iIuoh = parcelRequire("iIuoh");

var $eLeza = parcelRequire("eLeza");

});
parcelRegister("7phmx", function(module, exports) {

$parcel$export(module.exports, "default", () => $221000a87dfafb8e$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $5JYPc = parcelRequire("5JYPc");
'use client';
// The field wrapper every kit input renders through — and therefore the one
// place that decides whether this design system produces labelled controls.
//
// It used to draw the label as a `<span>`. That looks identical and is not the
// same thing: a screen reader announcing an unlabelled text box says "edit
// text, blank", `getByLabelText` cannot find the control, and clicking the
// label does not focus the field. §12.3 says all form inputs are labelled
// through `FormField` with a real `<label for>` — this is that.
//
// The association is made here rather than at the call sites, because a rule
// that depends on every caller remembering to pass an `id` is a rule that is
// half-applied within a month. `useId` supplies one, the child's own `id` wins
// if it has one, and the error/helper line is wired as `aria-describedby` so
// the reason a field is red is announced with it.
const $221000a87dfafb8e$var$FormField = ({ label: label, required: required, error: error, helperText: helperText, children: children, className: className, style: style, htmlFor: htmlFor })=>{
    const generatedId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const only = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(children) ? children : null;
    const controlId = htmlFor || only?.props?.id || (only ? `${generatedId}-control` : undefined);
    // Derived from the control's id, not the wrapper's, so a component that owns
    // its own wiring (the inputs that wrap their control in a positioning div)
    // can point at this message without asking for the id back.
    const messageId = (error || helperText) && controlId ? `${controlId}-message` : undefined;
    // `htmlFor` means the caller has already put the id on the real control.
    // Cloning here too would stamp the same id onto its wrapper — two elements,
    // one id, and the label resolves to whichever the browser sees first.
    const control = only && !htmlFor ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(only, {
        id: controlId,
        // Never clobber a caller's own description — join, so a field that
        // already points at a hint keeps it AND gains the error line.
        'aria-describedby': [
            only.props['aria-describedby'],
            messageId
        ].filter(Boolean).join(' ') || undefined,
        'aria-invalid': only.props['aria-invalid'] ?? (error ? true : undefined)
    }) : children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $5JYPc.cn)('flex flex-col gap-1.5', className),
        style: style
    }, label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        htmlFor: controlId,
        className: "text-[0.71875rem] font-semibold text-[#5a6780] tracking-[0.01em] select-none leading-none"
    }, label, required && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "text-destructive ms-1"
    }, "*")), control, error ? // Announced, not merely displayed: §12.3 requires validation errors to
    // reach a screen reader when they appear, and a field whose only signal
    // is a red border tells a non-sighted user nothing at all.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        id: messageId,
        role: "alert",
        className: "m-0 text-[0.71875rem] text-destructive font-medium leading-snug"
    }, error) : helperText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        id: messageId,
        className: "m-0 text-[0.71875rem] text-muted-foreground leading-snug"
    }, helperText) : null);
};
var $221000a87dfafb8e$export$2e2bcd8739ae039 = $221000a87dfafb8e$var$FormField;

});
parcelRegister("5JYPc", function(module, exports) {

$parcel$export(module.exports, "cn", () => $42e05640dae453c1$export$1343a74baacb0543);
$parcel$export(module.exports, "toEnDigits", () => $42e05640dae453c1$export$e6aa7dbb1e28c5bd);

var $9QePP = parcelRequire("9QePP");

var $bvcna = parcelRequire("bvcna");
function $42e05640dae453c1$export$1343a74baacb0543(...inputs) {
    return (0, $bvcna.twMerge)((0, $9QePP.clsx)(inputs));
}
const $42e05640dae453c1$export$e6aa7dbb1e28c5bd = (str)=>String(str).replace(/[۰-۹]/g, (d)=>d.charCodeAt(0) - 0x06F0).replace(/[٠-٩]/g, (d)=>d.charCodeAt(0) - 0x0660);

});
parcelRegister("9QePP", function(module, exports) {

$parcel$export(module.exports, "clsx", () => $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37);
function $f2ccb2ae3c8742b7$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $f2ccb2ae3c8742b7$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $f2ccb2ae3c8742b7$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f2ccb2ae3c8742b7$export$2e2bcd8739ae039 = $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37;

});

parcelRegister("bvcna", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
/**
 * Concatenates two arrays faster than the array spread operator.
 */ const $85fc2fe65ff21506$var$concatArrays = (array1, array2)=>{
    // Pre-allocate for better V8 optimization
    const combinedArray = new Array(array1.length + array2.length);
    for(let i = 0; i < array1.length; i++)combinedArray[i] = array1[i];
    for(let i = 0; i < array2.length; i++)combinedArray[array1.length + i] = array2[i];
    return combinedArray;
};
// Factory function ensures consistent object shapes
const $85fc2fe65ff21506$var$createClassValidatorObject = (classGroupId, validator)=>({
        classGroupId: classGroupId,
        validator: validator
    });
// Factory ensures consistent ClassPartObject shape
const $85fc2fe65ff21506$var$createClassPartObject = (nextPart = new Map(), validators = null, classGroupId)=>({
        nextPart: nextPart,
        validators: validators,
        classGroupId: classGroupId
    });
const $85fc2fe65ff21506$var$CLASS_PART_SEPARATOR = '-';
const $85fc2fe65ff21506$var$EMPTY_CONFLICTS = [];
// I use two dots here because one dot is used as prefix for class groups in plugins
const $85fc2fe65ff21506$var$ARBITRARY_PROPERTY_PREFIX = 'arbitrary..';
const $85fc2fe65ff21506$var$createClassGroupUtils = (config)=>{
    const classMap = $85fc2fe65ff21506$var$createClassMap(config);
    const { conflictingClassGroups: conflictingClassGroups, conflictingClassGroupModifiers: conflictingClassGroupModifiers } = config;
    const getClassGroupId = (className)=>{
        if (className.startsWith('[') && className.endsWith(']')) return $85fc2fe65ff21506$var$getGroupIdForArbitraryProperty(className);
        const classParts = className.split($85fc2fe65ff21506$var$CLASS_PART_SEPARATOR);
        // Classes like `-inset-1` produce an empty string as first classPart. We assume that classes for negative values are used correctly and skip it.
        const startIndex = classParts[0] === '' && classParts.length > 1 ? 1 : 0;
        return $85fc2fe65ff21506$var$getGroupRecursive(classParts, startIndex, classMap);
    };
    const getConflictingClassGroupIds = (classGroupId, hasPostfixModifier)=>{
        if (hasPostfixModifier) {
            const modifierConflicts = conflictingClassGroupModifiers[classGroupId];
            const baseConflicts = conflictingClassGroups[classGroupId];
            if (modifierConflicts) {
                if (baseConflicts) // Merge base conflicts with modifier conflicts
                return $85fc2fe65ff21506$var$concatArrays(baseConflicts, modifierConflicts);
                // Only modifier conflicts
                return modifierConflicts;
            }
            // Fall back to without postfix if no modifier conflicts
            return baseConflicts || $85fc2fe65ff21506$var$EMPTY_CONFLICTS;
        }
        return conflictingClassGroups[classGroupId] || $85fc2fe65ff21506$var$EMPTY_CONFLICTS;
    };
    return {
        getClassGroupId: getClassGroupId,
        getConflictingClassGroupIds: getConflictingClassGroupIds
    };
};
const $85fc2fe65ff21506$var$getGroupRecursive = (classParts, startIndex, classPartObject)=>{
    const classPathsLength = classParts.length - startIndex;
    if (classPathsLength === 0) return classPartObject.classGroupId;
    const currentClassPart = classParts[startIndex];
    const nextClassPartObject = classPartObject.nextPart.get(currentClassPart);
    if (nextClassPartObject) {
        const result = $85fc2fe65ff21506$var$getGroupRecursive(classParts, startIndex + 1, nextClassPartObject);
        if (result) return result;
    }
    const validators = classPartObject.validators;
    if (validators === null) return undefined;
    // Build classRest string efficiently by joining from startIndex onwards
    const classRest = startIndex === 0 ? classParts.join($85fc2fe65ff21506$var$CLASS_PART_SEPARATOR) : classParts.slice(startIndex).join($85fc2fe65ff21506$var$CLASS_PART_SEPARATOR);
    const validatorsLength = validators.length;
    for(let i = 0; i < validatorsLength; i++){
        const validatorObj = validators[i];
        if (validatorObj.validator(classRest)) return validatorObj.classGroupId;
    }
    return undefined;
};
/**
 * Get the class group ID for an arbitrary property.
 *
 * @param className - The class name to get the group ID for. Is expected to be string starting with `[` and ending with `]`.
 */ const $85fc2fe65ff21506$var$getGroupIdForArbitraryProperty = (className)=>className.slice(1, -1).indexOf(':') === -1 ? undefined : (()=>{
        const content = className.slice(1, -1);
        const colonIndex = content.indexOf(':');
        const property = content.slice(0, colonIndex);
        return property ? $85fc2fe65ff21506$var$ARBITRARY_PROPERTY_PREFIX + property : undefined;
    })();
/**
 * Exported for testing only
 */ const $85fc2fe65ff21506$var$createClassMap = (config)=>{
    const { theme: theme, classGroups: classGroups } = config;
    return $85fc2fe65ff21506$var$processClassGroups(classGroups, theme);
};
// Split into separate functions to maintain monomorphic call sites
const $85fc2fe65ff21506$var$processClassGroups = (classGroups, theme)=>{
    const classMap = $85fc2fe65ff21506$var$createClassPartObject();
    for(const classGroupId in classGroups){
        const group = classGroups[classGroupId];
        $85fc2fe65ff21506$var$processClassesRecursively(group, classMap, classGroupId, theme);
    }
    return classMap;
};
const $85fc2fe65ff21506$var$processClassesRecursively = (classGroup, classPartObject, classGroupId, theme)=>{
    const len = classGroup.length;
    for(let i = 0; i < len; i++){
        const classDefinition = classGroup[i];
        $85fc2fe65ff21506$var$processClassDefinition(classDefinition, classPartObject, classGroupId, theme);
    }
};
// Split into separate functions for each type to maintain monomorphic call sites
const $85fc2fe65ff21506$var$processClassDefinition = (classDefinition, classPartObject, classGroupId, theme)=>{
    if (typeof classDefinition === 'string') {
        $85fc2fe65ff21506$var$processStringDefinition(classDefinition, classPartObject, classGroupId);
        return;
    }
    if (typeof classDefinition === 'function') {
        $85fc2fe65ff21506$var$processFunctionDefinition(classDefinition, classPartObject, classGroupId, theme);
        return;
    }
    $85fc2fe65ff21506$var$processObjectDefinition(classDefinition, classPartObject, classGroupId, theme);
};
const $85fc2fe65ff21506$var$processStringDefinition = (classDefinition, classPartObject, classGroupId)=>{
    const classPartObjectToEdit = classDefinition === '' ? classPartObject : $85fc2fe65ff21506$var$getPart(classPartObject, classDefinition);
    classPartObjectToEdit.classGroupId = classGroupId;
};
const $85fc2fe65ff21506$var$processFunctionDefinition = (classDefinition, classPartObject, classGroupId, theme)=>{
    if ($85fc2fe65ff21506$var$isThemeGetter(classDefinition)) {
        $85fc2fe65ff21506$var$processClassesRecursively(classDefinition(theme), classPartObject, classGroupId, theme);
        return;
    }
    if (classPartObject.validators === null) classPartObject.validators = [];
    classPartObject.validators.push($85fc2fe65ff21506$var$createClassValidatorObject(classGroupId, classDefinition));
};
const $85fc2fe65ff21506$var$processObjectDefinition = (classDefinition, classPartObject, classGroupId, theme)=>{
    const entries = Object.entries(classDefinition);
    const len = entries.length;
    for(let i = 0; i < len; i++){
        const [key, value] = entries[i];
        $85fc2fe65ff21506$var$processClassesRecursively(value, $85fc2fe65ff21506$var$getPart(classPartObject, key), classGroupId, theme);
    }
};
const $85fc2fe65ff21506$var$getPart = (classPartObject, path)=>{
    let current = classPartObject;
    const parts = path.split($85fc2fe65ff21506$var$CLASS_PART_SEPARATOR);
    const len = parts.length;
    for(let i = 0; i < len; i++){
        const part = parts[i];
        let next = current.nextPart.get(part);
        if (!next) {
            next = $85fc2fe65ff21506$var$createClassPartObject();
            current.nextPart.set(part, next);
        }
        current = next;
    }
    return current;
};
// Type guard maintains monomorphic check
const $85fc2fe65ff21506$var$isThemeGetter = (func)=>'isThemeGetter' in func && func.isThemeGetter === true;
// LRU cache implementation using plain objects for simplicity
const $85fc2fe65ff21506$var$createLruCache = (maxCacheSize)=>{
    if (maxCacheSize < 1) return {
        get: ()=>undefined,
        set: ()=>{}
    };
    let cacheSize = 0;
    let cache = Object.create(null);
    let previousCache = Object.create(null);
    const update = (key, value)=>{
        cache[key] = value;
        cacheSize++;
        if (cacheSize > maxCacheSize) {
            cacheSize = 0;
            previousCache = cache;
            cache = Object.create(null);
        }
    };
    return {
        get (key) {
            let value = cache[key];
            if (value !== undefined) return value;
            if ((value = previousCache[key]) !== undefined) {
                update(key, value);
                return value;
            }
        },
        set (key, value) {
            if (key in cache) cache[key] = value;
            else update(key, value);
        }
    };
};
const $85fc2fe65ff21506$var$IMPORTANT_MODIFIER = '!';
const $85fc2fe65ff21506$var$MODIFIER_SEPARATOR = ':';
const $85fc2fe65ff21506$var$EMPTY_MODIFIERS = [];
// Pre-allocated result object shape for consistency
const $85fc2fe65ff21506$var$createResultObject = (modifiers, hasImportantModifier, baseClassName, maybePostfixModifierPosition, isExternal)=>({
        modifiers: modifiers,
        hasImportantModifier: hasImportantModifier,
        baseClassName: baseClassName,
        maybePostfixModifierPosition: maybePostfixModifierPosition,
        isExternal: isExternal
    });
const $85fc2fe65ff21506$var$createParseClassName = (config)=>{
    const { prefix: prefix, experimentalParseClassName: experimentalParseClassName } = config;
    /**
   * Parse class name into parts.
   *
   * Inspired by `splitAtTopLevelOnly` used in Tailwind CSS
   * @see https://github.com/tailwindlabs/tailwindcss/blob/v3.2.2/src/util/splitAtTopLevelOnly.js
   */ let parseClassName = (className)=>{
        // Use simple array with push for better performance
        const modifiers = [];
        let bracketDepth = 0;
        let parenDepth = 0;
        let modifierStart = 0;
        let postfixModifierPosition;
        const len = className.length;
        for(let index = 0; index < len; index++){
            const currentCharacter = className[index];
            if (bracketDepth === 0 && parenDepth === 0) {
                if (currentCharacter === $85fc2fe65ff21506$var$MODIFIER_SEPARATOR) {
                    modifiers.push(className.slice(modifierStart, index));
                    modifierStart = index + 1;
                    continue;
                }
                if (currentCharacter === '/') {
                    postfixModifierPosition = index;
                    continue;
                }
            }
            if (currentCharacter === '[') bracketDepth++;
            else if (currentCharacter === ']') bracketDepth--;
            else if (currentCharacter === '(') parenDepth++;
            else if (currentCharacter === ')') parenDepth--;
        }
        const baseClassNameWithImportantModifier = modifiers.length === 0 ? className : className.slice(modifierStart);
        // Inline important modifier check
        let baseClassName = baseClassNameWithImportantModifier;
        let hasImportantModifier = false;
        if (baseClassNameWithImportantModifier.endsWith($85fc2fe65ff21506$var$IMPORTANT_MODIFIER)) {
            baseClassName = baseClassNameWithImportantModifier.slice(0, -1);
            hasImportantModifier = true;
        } else if (/**
     * In Tailwind CSS v3 the important modifier was at the start of the base class name. This is still supported for legacy reasons.
     * @see https://github.com/dcastil/tailwind-merge/issues/513#issuecomment-2614029864
     */ baseClassNameWithImportantModifier.startsWith($85fc2fe65ff21506$var$IMPORTANT_MODIFIER)) {
            baseClassName = baseClassNameWithImportantModifier.slice(1);
            hasImportantModifier = true;
        }
        const maybePostfixModifierPosition = postfixModifierPosition && postfixModifierPosition > modifierStart ? postfixModifierPosition - modifierStart : undefined;
        return $85fc2fe65ff21506$var$createResultObject(modifiers, hasImportantModifier, baseClassName, maybePostfixModifierPosition);
    };
    if (prefix) {
        const fullPrefix = prefix + $85fc2fe65ff21506$var$MODIFIER_SEPARATOR;
        const parseClassNameOriginal = parseClassName;
        parseClassName = (className)=>className.startsWith(fullPrefix) ? parseClassNameOriginal(className.slice(fullPrefix.length)) : $85fc2fe65ff21506$var$createResultObject($85fc2fe65ff21506$var$EMPTY_MODIFIERS, false, className, undefined, true);
    }
    if (experimentalParseClassName) {
        const parseClassNameOriginal = parseClassName;
        parseClassName = (className)=>experimentalParseClassName({
                className: className,
                parseClassName: parseClassNameOriginal
            });
    }
    return parseClassName;
};
/**
 * Sorts modifiers according to following schema:
 * - Predefined modifiers are sorted alphabetically
 * - When an arbitrary variant appears, it must be preserved which modifiers are before and after it
 */ const $85fc2fe65ff21506$var$createSortModifiers = (config)=>{
    // Pre-compute weights for all known modifiers for O(1) comparison
    const modifierWeights = new Map();
    // Assign weights to sensitive modifiers (highest priority, but preserve order)
    config.orderSensitiveModifiers.forEach((mod, index)=>{
        modifierWeights.set(mod, 1000000 + index); // High weights for sensitive mods
    });
    return (modifiers)=>{
        const result = [];
        let currentSegment = [];
        // Process modifiers in one pass
        for(let i = 0; i < modifiers.length; i++){
            const modifier = modifiers[i];
            // Check if modifier is sensitive (starts with '[' or in orderSensitiveModifiers)
            const isArbitrary = modifier[0] === '[';
            const isOrderSensitive = modifierWeights.has(modifier);
            if (isArbitrary || isOrderSensitive) {
                // Sort and flush current segment alphabetically
                if (currentSegment.length > 0) {
                    currentSegment.sort();
                    result.push(...currentSegment);
                    currentSegment = [];
                }
                result.push(modifier);
            } else // Regular modifier - add to current segment for batch sorting
            currentSegment.push(modifier);
        }
        // Sort and add any remaining segment items
        if (currentSegment.length > 0) {
            currentSegment.sort();
            result.push(...currentSegment);
        }
        return result;
    };
};
const $85fc2fe65ff21506$var$createConfigUtils = (config)=>({
        cache: $85fc2fe65ff21506$var$createLruCache(config.cacheSize),
        parseClassName: $85fc2fe65ff21506$var$createParseClassName(config),
        sortModifiers: $85fc2fe65ff21506$var$createSortModifiers(config),
        postfixLookupClassGroupIds: $85fc2fe65ff21506$var$createPostfixLookupClassGroupIds(config),
        ...$85fc2fe65ff21506$var$createClassGroupUtils(config)
    });
const $85fc2fe65ff21506$var$createPostfixLookupClassGroupIds = (config)=>{
    const lookup = Object.create(null);
    const classGroupIds = config.postfixLookupClassGroups;
    if (classGroupIds) for(let i = 0; i < classGroupIds.length; i++)lookup[classGroupIds[i]] = true;
    return lookup;
};
const $85fc2fe65ff21506$var$SPLIT_CLASSES_REGEX = /\s+/;
const $85fc2fe65ff21506$var$mergeClassList = (classList, configUtils)=>{
    const { parseClassName: parseClassName, getClassGroupId: getClassGroupId, getConflictingClassGroupIds: getConflictingClassGroupIds, sortModifiers: sortModifiers, postfixLookupClassGroupIds: postfixLookupClassGroupIds } = configUtils;
    /**
   * Set of classGroupIds in following format:
   * `{importantModifier}{variantModifiers}{classGroupId}`
   * @example 'float'
   * @example 'hover:focus:bg-color'
   * @example 'md:!pr'
   */ const classGroupsInConflict = [];
    const classNames = classList.trim().split($85fc2fe65ff21506$var$SPLIT_CLASSES_REGEX);
    let result = '';
    for(let index = classNames.length - 1; index >= 0; index -= 1){
        const originalClassName = classNames[index];
        const { isExternal: isExternal, modifiers: modifiers, hasImportantModifier: hasImportantModifier, baseClassName: baseClassName, maybePostfixModifierPosition: maybePostfixModifierPosition } = parseClassName(originalClassName);
        if (isExternal) {
            result = originalClassName + (result.length > 0 ? ' ' + result : result);
            continue;
        }
        let hasPostfixModifier = !!maybePostfixModifierPosition;
        let classGroupId;
        if (hasPostfixModifier) {
            const baseClassNameWithoutPostfix = baseClassName.substring(0, maybePostfixModifierPosition);
            classGroupId = getClassGroupId(baseClassNameWithoutPostfix);
            const classGroupIdWithPostfix = classGroupId && postfixLookupClassGroupIds[classGroupId] ? getClassGroupId(baseClassName) : undefined;
            if (classGroupIdWithPostfix && classGroupIdWithPostfix !== classGroupId) {
                classGroupId = classGroupIdWithPostfix;
                hasPostfixModifier = false;
            }
        } else classGroupId = getClassGroupId(baseClassName);
        if (!classGroupId) {
            if (!hasPostfixModifier) {
                // Not a Tailwind class
                result = originalClassName + (result.length > 0 ? ' ' + result : result);
                continue;
            }
            classGroupId = getClassGroupId(baseClassName);
            if (!classGroupId) {
                // Not a Tailwind class
                result = originalClassName + (result.length > 0 ? ' ' + result : result);
                continue;
            }
            hasPostfixModifier = false;
        }
        // Fast path: skip sorting for empty or single modifier
        const variantModifier = modifiers.length === 0 ? '' : modifiers.length === 1 ? modifiers[0] : sortModifiers(modifiers).join(':');
        const modifierId = hasImportantModifier ? variantModifier + $85fc2fe65ff21506$var$IMPORTANT_MODIFIER : variantModifier;
        const classId = modifierId + classGroupId;
        if (classGroupsInConflict.indexOf(classId) > -1) continue;
        classGroupsInConflict.push(classId);
        const conflictGroups = getConflictingClassGroupIds(classGroupId, hasPostfixModifier);
        for(let i = 0; i < conflictGroups.length; ++i){
            const group = conflictGroups[i];
            classGroupsInConflict.push(modifierId + group);
        }
        // Tailwind class not in conflict
        result = originalClassName + (result.length > 0 ? ' ' + result : result);
    }
    return result;
};
/**
 * The code in this file is copied from https://github.com/lukeed/clsx and modified to suit the needs of tailwind-merge better.
 *
 * Specifically:
 * - Runtime code from https://github.com/lukeed/clsx/blob/v1.2.1/src/index.js
 * - TypeScript types from https://github.com/lukeed/clsx/blob/v1.2.1/clsx.d.ts
 *
 * Original code has MIT license: Copyright (c) Luke Edwards <luke.edwards05@gmail.com> (lukeed.com)
 */ const $85fc2fe65ff21506$var$twJoin = (...classLists)=>{
    let index = 0;
    let argument;
    let resolvedValue;
    let string = '';
    while(index < classLists.length){
        if (argument = classLists[index++]) {
            if (resolvedValue = $85fc2fe65ff21506$var$toValue(argument)) {
                string && (string += ' ');
                string += resolvedValue;
            }
        }
    }
    return string;
};
const $85fc2fe65ff21506$var$toValue = (mix)=>{
    // Fast path for strings
    if (typeof mix === 'string') return mix;
    let resolvedValue;
    let string = '';
    for(let k = 0; k < mix.length; k++){
        if (mix[k]) {
            if (resolvedValue = $85fc2fe65ff21506$var$toValue(mix[k])) {
                string && (string += ' ');
                string += resolvedValue;
            }
        }
    }
    return string;
};
const $85fc2fe65ff21506$var$createTailwindMerge = (createConfigFirst, ...createConfigRest)=>{
    let configUtils;
    let cacheGet;
    let cacheSet;
    let functionToCall;
    const initTailwindMerge = (classList)=>{
        const config = createConfigRest.reduce((previousConfig, createConfigCurrent)=>createConfigCurrent(previousConfig), createConfigFirst());
        configUtils = $85fc2fe65ff21506$var$createConfigUtils(config);
        cacheGet = configUtils.cache.get;
        cacheSet = configUtils.cache.set;
        functionToCall = tailwindMerge;
        return tailwindMerge(classList);
    };
    const tailwindMerge = (classList)=>{
        const cachedResult = cacheGet(classList);
        if (cachedResult) return cachedResult;
        const result = $85fc2fe65ff21506$var$mergeClassList(classList, configUtils);
        cacheSet(classList, result);
        return result;
    };
    functionToCall = initTailwindMerge;
    return (...args)=>functionToCall($85fc2fe65ff21506$var$twJoin(...args));
};
const $85fc2fe65ff21506$var$fallbackThemeArr = [];
const $85fc2fe65ff21506$var$fromTheme = (key)=>{
    const themeGetter = (theme)=>theme[key] || $85fc2fe65ff21506$var$fallbackThemeArr;
    themeGetter.isThemeGetter = true;
    themeGetter.themeKey = key;
    return themeGetter;
};
const $85fc2fe65ff21506$var$arbitraryValueRegex = /^\[(?:(\w[\w-]*):)?(.+)\]$/i;
const $85fc2fe65ff21506$var$arbitraryVariableRegex = /^\((?:(\w[\w-]*):)?(.+)\)$/i;
const $85fc2fe65ff21506$var$fractionRegex = /^\d+(?:\.\d+)?\/\d+(?:\.\d+)?$/;
const $85fc2fe65ff21506$var$tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/;
const $85fc2fe65ff21506$var$lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/;
const $85fc2fe65ff21506$var$colorFunctionRegex = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix|color|light-dark)\(.+\)$/;
// Shadow always begins with x and y offset separated by underscore optionally prepended by inset
const $85fc2fe65ff21506$var$shadowRegex = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
const $85fc2fe65ff21506$var$imageRegex = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
const $85fc2fe65ff21506$var$isFraction = (value)=>$85fc2fe65ff21506$var$fractionRegex.test(value);
const $85fc2fe65ff21506$var$isNumber = (value)=>!!value && !Number.isNaN(Number(value));
const $85fc2fe65ff21506$var$isInteger = (value)=>!!value && Number.isInteger(Number(value));
const $85fc2fe65ff21506$var$isPercent = (value)=>value.endsWith('%') && $85fc2fe65ff21506$var$isNumber(value.slice(0, -1));
const $85fc2fe65ff21506$var$isTshirtSize = (value)=>$85fc2fe65ff21506$var$tshirtUnitRegex.test(value);
const $85fc2fe65ff21506$var$isAny = ()=>true;
const $85fc2fe65ff21506$var$isLengthOnly = (value)=>// `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
    // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
    // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
    $85fc2fe65ff21506$var$lengthUnitRegex.test(value) && !$85fc2fe65ff21506$var$colorFunctionRegex.test(value);
const $85fc2fe65ff21506$var$isNever = ()=>false;
const $85fc2fe65ff21506$var$isShadow = (value)=>$85fc2fe65ff21506$var$shadowRegex.test(value);
const $85fc2fe65ff21506$var$isImage = (value)=>$85fc2fe65ff21506$var$imageRegex.test(value);
const $85fc2fe65ff21506$var$isAnyNonArbitrary = (value)=>!$85fc2fe65ff21506$var$isArbitraryValue(value) && !$85fc2fe65ff21506$var$isArbitraryVariable(value);
const $85fc2fe65ff21506$var$isNamedContainerQuery = (value)=>value.startsWith('@container') && (value[10] === '/' && value[11] !== undefined || value[11] === 's' && value[16] !== undefined && value.startsWith('-size/', 10) || value[11] === 'n' && value[18] !== undefined && value.startsWith('-normal/', 10));
const $85fc2fe65ff21506$var$isArbitrarySize = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelSize, $85fc2fe65ff21506$var$isNever);
const $85fc2fe65ff21506$var$isArbitraryValue = (value)=>$85fc2fe65ff21506$var$arbitraryValueRegex.test(value);
const $85fc2fe65ff21506$var$isArbitraryLength = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelLength, $85fc2fe65ff21506$var$isLengthOnly);
const $85fc2fe65ff21506$var$isArbitraryNumber = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelNumber, $85fc2fe65ff21506$var$isNumber);
const $85fc2fe65ff21506$var$isArbitraryWeight = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelWeight, $85fc2fe65ff21506$var$isAny);
const $85fc2fe65ff21506$var$isArbitraryFamilyName = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelFamilyName, $85fc2fe65ff21506$var$isNever);
const $85fc2fe65ff21506$var$isArbitraryPosition = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelPosition, $85fc2fe65ff21506$var$isNever);
const $85fc2fe65ff21506$var$isArbitraryImage = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelImage, $85fc2fe65ff21506$var$isImage);
const $85fc2fe65ff21506$var$isArbitraryShadow = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelShadow, $85fc2fe65ff21506$var$isShadow);
const $85fc2fe65ff21506$var$isArbitraryVariable = (value)=>$85fc2fe65ff21506$var$arbitraryVariableRegex.test(value);
const $85fc2fe65ff21506$var$isArbitraryVariableLength = (value)=>$85fc2fe65ff21506$var$getIsArbitraryVariable(value, $85fc2fe65ff21506$var$isLabelLength);
const $85fc2fe65ff21506$var$isArbitraryVariableFamilyName = (value)=>$85fc2fe65ff21506$var$getIsArbitraryVariable(value, $85fc2fe65ff21506$var$isLabelFamilyName);
const $85fc2fe65ff21506$var$isArbitraryVariablePosition = (value)=>$85fc2fe65ff21506$var$getIsArbitraryVariable(value, $85fc2fe65ff21506$var$isLabelPosition);
const $85fc2fe65ff21506$var$isArbitraryVariableSize = (value)=>$85fc2fe65ff21506$var$getIsArbitraryVariable(value, $85fc2fe65ff21506$var$isLabelSize);
const $85fc2fe65ff21506$var$isArbitraryVariableImage = (value)=>$85fc2fe65ff21506$var$getIsArbitraryVariable(value, $85fc2fe65ff21506$var$isLabelImage);
const $85fc2fe65ff21506$var$isArbitraryVariableShadow = (value)=>$85fc2fe65ff21506$var$getIsArbitraryVariable(value, $85fc2fe65ff21506$var$isLabelShadow, true);
const $85fc2fe65ff21506$var$isArbitraryVariableWeight = (value)=>$85fc2fe65ff21506$var$getIsArbitraryVariable(value, $85fc2fe65ff21506$var$isLabelWeight, true);
// Helpers
const $85fc2fe65ff21506$var$getIsArbitraryValue = (value, testLabel, testValue)=>{
    const result = $85fc2fe65ff21506$var$arbitraryValueRegex.exec(value);
    if (result) {
        if (result[1]) return testLabel(result[1]);
        return testValue(result[2]);
    }
    return false;
};
const $85fc2fe65ff21506$var$getIsArbitraryVariable = (value, testLabel, shouldMatchNoLabel = false)=>{
    const result = $85fc2fe65ff21506$var$arbitraryVariableRegex.exec(value);
    if (result) {
        if (result[1]) return testLabel(result[1]);
        return shouldMatchNoLabel;
    }
    return false;
};
// Labels
const $85fc2fe65ff21506$var$isLabelPosition = (label)=>label === 'position' || label === 'percentage';
const $85fc2fe65ff21506$var$isLabelImage = (label)=>label === 'image' || label === 'url';
const $85fc2fe65ff21506$var$isLabelSize = (label)=>label === 'length' || label === 'size' || label === 'bg-size';
const $85fc2fe65ff21506$var$isLabelLength = (label)=>label === 'length';
const $85fc2fe65ff21506$var$isLabelNumber = (label)=>label === 'number';
const $85fc2fe65ff21506$var$isLabelFamilyName = (label)=>label === 'family-name';
const $85fc2fe65ff21506$var$isLabelWeight = (label)=>label === 'number' || label === 'weight';
const $85fc2fe65ff21506$var$isLabelShadow = (label)=>label === 'shadow';
const $85fc2fe65ff21506$var$validators = /*#__PURE__*/ Object.defineProperty({
    __proto__: null,
    isAny: $85fc2fe65ff21506$var$isAny,
    isAnyNonArbitrary: $85fc2fe65ff21506$var$isAnyNonArbitrary,
    isArbitraryFamilyName: $85fc2fe65ff21506$var$isArbitraryFamilyName,
    isArbitraryImage: $85fc2fe65ff21506$var$isArbitraryImage,
    isArbitraryLength: $85fc2fe65ff21506$var$isArbitraryLength,
    isArbitraryNumber: $85fc2fe65ff21506$var$isArbitraryNumber,
    isArbitraryPosition: $85fc2fe65ff21506$var$isArbitraryPosition,
    isArbitraryShadow: $85fc2fe65ff21506$var$isArbitraryShadow,
    isArbitrarySize: $85fc2fe65ff21506$var$isArbitrarySize,
    isArbitraryValue: $85fc2fe65ff21506$var$isArbitraryValue,
    isArbitraryVariable: $85fc2fe65ff21506$var$isArbitraryVariable,
    isArbitraryVariableFamilyName: $85fc2fe65ff21506$var$isArbitraryVariableFamilyName,
    isArbitraryVariableImage: $85fc2fe65ff21506$var$isArbitraryVariableImage,
    isArbitraryVariableLength: $85fc2fe65ff21506$var$isArbitraryVariableLength,
    isArbitraryVariablePosition: $85fc2fe65ff21506$var$isArbitraryVariablePosition,
    isArbitraryVariableShadow: $85fc2fe65ff21506$var$isArbitraryVariableShadow,
    isArbitraryVariableSize: $85fc2fe65ff21506$var$isArbitraryVariableSize,
    isArbitraryVariableWeight: $85fc2fe65ff21506$var$isArbitraryVariableWeight,
    isArbitraryWeight: $85fc2fe65ff21506$var$isArbitraryWeight,
    isFraction: $85fc2fe65ff21506$var$isFraction,
    isInteger: $85fc2fe65ff21506$var$isInteger,
    isNamedContainerQuery: $85fc2fe65ff21506$var$isNamedContainerQuery,
    isNumber: $85fc2fe65ff21506$var$isNumber,
    isPercent: $85fc2fe65ff21506$var$isPercent,
    isTshirtSize: $85fc2fe65ff21506$var$isTshirtSize
}, Symbol.toStringTag, {
    value: 'Module'
});
const $85fc2fe65ff21506$var$getDefaultConfig = ()=>{
    /**
   * Theme getters for theme variable namespaces
   * @see https://tailwindcss.com/docs/theme#theme-variable-namespaces
   */ /***/ const themeColor = $85fc2fe65ff21506$var$fromTheme('color');
    const themeFont = $85fc2fe65ff21506$var$fromTheme('font');
    const themeText = $85fc2fe65ff21506$var$fromTheme('text');
    const themeFontWeight = $85fc2fe65ff21506$var$fromTheme('font-weight');
    const themeTracking = $85fc2fe65ff21506$var$fromTheme('tracking');
    const themeLeading = $85fc2fe65ff21506$var$fromTheme('leading');
    const themeBreakpoint = $85fc2fe65ff21506$var$fromTheme('breakpoint');
    const themeContainer = $85fc2fe65ff21506$var$fromTheme('container');
    const themeSpacing = $85fc2fe65ff21506$var$fromTheme('spacing');
    const themeRadius = $85fc2fe65ff21506$var$fromTheme('radius');
    const themeShadow = $85fc2fe65ff21506$var$fromTheme('shadow');
    const themeInsetShadow = $85fc2fe65ff21506$var$fromTheme('inset-shadow');
    const themeTextShadow = $85fc2fe65ff21506$var$fromTheme('text-shadow');
    const themeDropShadow = $85fc2fe65ff21506$var$fromTheme('drop-shadow');
    const themeBlur = $85fc2fe65ff21506$var$fromTheme('blur');
    const themePerspective = $85fc2fe65ff21506$var$fromTheme('perspective');
    const themeAspect = $85fc2fe65ff21506$var$fromTheme('aspect');
    const themeEase = $85fc2fe65ff21506$var$fromTheme('ease');
    const themeAnimate = $85fc2fe65ff21506$var$fromTheme('animate');
    /**
   * Helpers to avoid repeating the same scales
   *
   * We use functions that create a new array every time they're called instead of static arrays.
   * This ensures that users who modify any scale by mutating the array (e.g. with `array.push(element)`) don't accidentally mutate arrays in other parts of the config.
   */ /***/ const scaleBreak = ()=>[
            'auto',
            'avoid',
            'all',
            'avoid-page',
            'page',
            'left',
            'right',
            'column'
        ];
    const scalePosition = ()=>[
            'center',
            'top',
            'bottom',
            'left',
            'right',
            'top-left',
            // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
            'left-top',
            'top-right',
            // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
            'right-top',
            'bottom-right',
            // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
            'right-bottom',
            'bottom-left',
            // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
            'left-bottom'
        ];
    const scalePositionWithArbitrary = ()=>[
            ...scalePosition(),
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleOverflow = ()=>[
            'auto',
            'hidden',
            'clip',
            'visible',
            'scroll'
        ];
    const scaleOverscroll = ()=>[
            'auto',
            'contain',
            'none'
        ];
    const scaleUnambiguousSpacing = ()=>[
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue,
            themeSpacing
        ];
    const scaleInset = ()=>[
            $85fc2fe65ff21506$var$isFraction,
            'full',
            'auto',
            ...scaleUnambiguousSpacing()
        ];
    const scaleGridTemplateColsRows = ()=>[
            $85fc2fe65ff21506$var$isInteger,
            'none',
            'subgrid',
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleGridColRowStartAndEnd = ()=>[
            'auto',
            {
                span: [
                    'full',
                    $85fc2fe65ff21506$var$isInteger,
                    $85fc2fe65ff21506$var$isArbitraryVariable,
                    $85fc2fe65ff21506$var$isArbitraryValue
                ]
            },
            $85fc2fe65ff21506$var$isInteger,
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleGridColRowStartOrEnd = ()=>[
            $85fc2fe65ff21506$var$isInteger,
            'auto',
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleGridAutoColsRows = ()=>[
            'auto',
            'min',
            'max',
            'fr',
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleAlignPrimaryAxis = ()=>[
            'start',
            'end',
            'center',
            'between',
            'around',
            'evenly',
            'stretch',
            'baseline',
            'center-safe',
            'end-safe'
        ];
    const scaleAlignSecondaryAxis = ()=>[
            'start',
            'end',
            'center',
            'stretch',
            'center-safe',
            'end-safe'
        ];
    const scaleMargin = ()=>[
            'auto',
            ...scaleUnambiguousSpacing()
        ];
    const scaleSizing = ()=>[
            $85fc2fe65ff21506$var$isFraction,
            'auto',
            'full',
            'dvw',
            'dvh',
            'lvw',
            'lvh',
            'svw',
            'svh',
            'min',
            'max',
            'fit',
            ...scaleUnambiguousSpacing()
        ];
    const scaleSizingInline = ()=>[
            themeContainer,
            $85fc2fe65ff21506$var$isFraction,
            'screen',
            'full',
            'dvw',
            'lvw',
            'svw',
            'min',
            'max',
            'fit',
            ...scaleUnambiguousSpacing()
        ];
    const scaleSizingBlock = ()=>[
            $85fc2fe65ff21506$var$isFraction,
            'screen',
            'full',
            'lh',
            'dvh',
            'lvh',
            'svh',
            'min',
            'max',
            'fit',
            ...scaleUnambiguousSpacing()
        ];
    const scaleColor = ()=>[
            themeColor,
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleBgPosition = ()=>[
            ...scalePosition(),
            $85fc2fe65ff21506$var$isArbitraryVariablePosition,
            $85fc2fe65ff21506$var$isArbitraryPosition,
            {
                position: [
                    $85fc2fe65ff21506$var$isArbitraryVariable,
                    $85fc2fe65ff21506$var$isArbitraryValue
                ]
            }
        ];
    const scaleBgRepeat = ()=>[
            'no-repeat',
            {
                repeat: [
                    '',
                    'x',
                    'y',
                    'space',
                    'round'
                ]
            }
        ];
    const scaleBgSize = ()=>[
            'auto',
            'cover',
            'contain',
            $85fc2fe65ff21506$var$isArbitraryVariableSize,
            $85fc2fe65ff21506$var$isArbitrarySize,
            {
                size: [
                    $85fc2fe65ff21506$var$isArbitraryVariable,
                    $85fc2fe65ff21506$var$isArbitraryValue
                ]
            }
        ];
    const scaleGradientStopPosition = ()=>[
            $85fc2fe65ff21506$var$isPercent,
            $85fc2fe65ff21506$var$isArbitraryVariableLength,
            $85fc2fe65ff21506$var$isArbitraryLength
        ];
    const scaleRadius = ()=>[
            // Deprecated since Tailwind CSS v4.0.0
            '',
            'none',
            'full',
            themeRadius,
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleBorderWidth = ()=>[
            '',
            $85fc2fe65ff21506$var$isNumber,
            $85fc2fe65ff21506$var$isArbitraryVariableLength,
            $85fc2fe65ff21506$var$isArbitraryLength
        ];
    const scaleLineStyle = ()=>[
            'solid',
            'dashed',
            'dotted',
            'double'
        ];
    const scaleBlendMode = ()=>[
            'normal',
            'multiply',
            'screen',
            'overlay',
            'darken',
            'lighten',
            'color-dodge',
            'color-burn',
            'hard-light',
            'soft-light',
            'difference',
            'exclusion',
            'hue',
            'saturation',
            'color',
            'luminosity'
        ];
    const scaleMaskImagePosition = ()=>[
            $85fc2fe65ff21506$var$isNumber,
            $85fc2fe65ff21506$var$isPercent,
            $85fc2fe65ff21506$var$isArbitraryVariablePosition,
            $85fc2fe65ff21506$var$isArbitraryPosition
        ];
    const scaleBlur = ()=>[
            // Deprecated since Tailwind CSS v4.0.0
            '',
            'none',
            themeBlur,
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleRotate = ()=>[
            'none',
            $85fc2fe65ff21506$var$isNumber,
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleScale = ()=>[
            'none',
            $85fc2fe65ff21506$var$isNumber,
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleSkew = ()=>[
            $85fc2fe65ff21506$var$isNumber,
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleTranslate = ()=>[
            $85fc2fe65ff21506$var$isFraction,
            'full',
            ...scaleUnambiguousSpacing()
        ];
    return {
        cacheSize: 500,
        theme: {
            animate: [
                'spin',
                'ping',
                'pulse',
                'bounce'
            ],
            aspect: [
                'video'
            ],
            blur: [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            breakpoint: [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            color: [
                $85fc2fe65ff21506$var$isAny
            ],
            container: [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            'drop-shadow': [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            ease: [
                'in',
                'out',
                'in-out'
            ],
            font: [
                $85fc2fe65ff21506$var$isAnyNonArbitrary
            ],
            'font-weight': [
                'thin',
                'extralight',
                'light',
                'normal',
                'medium',
                'semibold',
                'bold',
                'extrabold',
                'black'
            ],
            'inset-shadow': [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            leading: [
                'none',
                'tight',
                'snug',
                'normal',
                'relaxed',
                'loose'
            ],
            perspective: [
                'dramatic',
                'near',
                'normal',
                'midrange',
                'distant',
                'none'
            ],
            radius: [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            shadow: [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            spacing: [
                'px',
                $85fc2fe65ff21506$var$isNumber
            ],
            text: [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            'text-shadow': [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            tracking: [
                'tighter',
                'tight',
                'normal',
                'wide',
                'wider',
                'widest'
            ]
        },
        classGroups: {
            // --------------
            // --- Layout ---
            // --------------
            /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */ aspect: [
                {
                    aspect: [
                        'auto',
                        'square',
                        $85fc2fe65ff21506$var$isFraction,
                        $85fc2fe65ff21506$var$isArbitraryValue,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        themeAspect
                    ]
                }
            ],
            /**
       * Container
       * @see https://tailwindcss.com/docs/container
       * @deprecated since Tailwind CSS v4.0.0
       */ container: [
                'container'
            ],
            /**
       * Container Type
       * @see https://tailwindcss.com/docs/responsive-design#container-queries
       */ 'container-type': [
                {
                    '@container': [
                        '',
                        'normal',
                        'size',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Container Name
       * @see https://tailwindcss.com/docs/responsive-design#named-containers
       */ 'container-named': [
                $85fc2fe65ff21506$var$isNamedContainerQuery
            ],
            /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */ columns: [
                {
                    columns: [
                        $85fc2fe65ff21506$var$isNumber,
                        'auto',
                        $85fc2fe65ff21506$var$isArbitraryValue,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        themeContainer
                    ]
                }
            ],
            /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */ 'break-after': [
                {
                    'break-after': scaleBreak()
                }
            ],
            /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */ 'break-before': [
                {
                    'break-before': scaleBreak()
                }
            ],
            /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */ 'break-inside': [
                {
                    'break-inside': [
                        'auto',
                        'avoid',
                        'avoid-page',
                        'avoid-column'
                    ]
                }
            ],
            /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */ 'box-decoration': [
                {
                    'box-decoration': [
                        'slice',
                        'clone'
                    ]
                }
            ],
            /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */ box: [
                {
                    box: [
                        'border',
                        'content'
                    ]
                }
            ],
            /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */ display: [
                'block',
                'inline-block',
                'inline',
                'flex',
                'inline-flex',
                'table',
                'inline-table',
                'table-caption',
                'table-cell',
                'table-column',
                'table-column-group',
                'table-footer-group',
                'table-header-group',
                'table-row-group',
                'table-row',
                'flow-root',
                'grid',
                'inline-grid',
                'contents',
                'list-item',
                'hidden'
            ],
            /**
       * Screen Reader Only
       * @see https://tailwindcss.com/docs/display#screen-reader-only
       */ sr: [
                'sr-only',
                'not-sr-only'
            ],
            /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */ float: [
                {
                    float: [
                        'right',
                        'left',
                        'none',
                        'start',
                        'end'
                    ]
                }
            ],
            /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */ clear: [
                {
                    clear: [
                        'left',
                        'right',
                        'both',
                        'none',
                        'start',
                        'end'
                    ]
                }
            ],
            /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */ isolation: [
                'isolate',
                'isolation-auto'
            ],
            /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */ 'object-fit': [
                {
                    object: [
                        'contain',
                        'cover',
                        'fill',
                        'none',
                        'scale-down'
                    ]
                }
            ],
            /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */ 'object-position': [
                {
                    object: scalePositionWithArbitrary()
                }
            ],
            /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */ overflow: [
                {
                    overflow: scaleOverflow()
                }
            ],
            /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */ 'overflow-x': [
                {
                    'overflow-x': scaleOverflow()
                }
            ],
            /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */ 'overflow-y': [
                {
                    'overflow-y': scaleOverflow()
                }
            ],
            /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ overscroll: [
                {
                    overscroll: scaleOverscroll()
                }
            ],
            /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ 'overscroll-x': [
                {
                    'overscroll-x': scaleOverscroll()
                }
            ],
            /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ 'overscroll-y': [
                {
                    'overscroll-y': scaleOverscroll()
                }
            ],
            /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */ position: [
                'static',
                'fixed',
                'absolute',
                'relative',
                'sticky'
            ],
            /**
       * Inset
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ inset: [
                {
                    inset: scaleInset()
                }
            ],
            /**
       * Inset Inline
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ 'inset-x': [
                {
                    'inset-x': scaleInset()
                }
            ],
            /**
       * Inset Block
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ 'inset-y': [
                {
                    'inset-y': scaleInset()
                }
            ],
            /**
       * Inset Inline Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       * @todo class group will be renamed to `inset-s` in next major release
       */ start: [
                {
                    'inset-s': scaleInset(),
                    /**
         * @deprecated since Tailwind CSS v4.2.0 in favor of `inset-s-*` utilities.
         * @see https://github.com/tailwindlabs/tailwindcss/pull/19613
         */ start: scaleInset()
                }
            ],
            /**
       * Inset Inline End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       * @todo class group will be renamed to `inset-e` in next major release
       */ end: [
                {
                    'inset-e': scaleInset(),
                    /**
         * @deprecated since Tailwind CSS v4.2.0 in favor of `inset-e-*` utilities.
         * @see https://github.com/tailwindlabs/tailwindcss/pull/19613
         */ end: scaleInset()
                }
            ],
            /**
       * Inset Block Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ 'inset-bs': [
                {
                    'inset-bs': scaleInset()
                }
            ],
            /**
       * Inset Block End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ 'inset-be': [
                {
                    'inset-be': scaleInset()
                }
            ],
            /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ top: [
                {
                    top: scaleInset()
                }
            ],
            /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ right: [
                {
                    right: scaleInset()
                }
            ],
            /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ bottom: [
                {
                    bottom: scaleInset()
                }
            ],
            /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ left: [
                {
                    left: scaleInset()
                }
            ],
            /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */ visibility: [
                'visible',
                'invisible',
                'collapse'
            ],
            /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */ z: [
                {
                    z: [
                        $85fc2fe65ff21506$var$isInteger,
                        'auto',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // ------------------------
            // --- Flexbox and Grid ---
            // ------------------------
            /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */ basis: [
                {
                    basis: [
                        $85fc2fe65ff21506$var$isFraction,
                        'full',
                        'auto',
                        themeContainer,
                        ...scaleUnambiguousSpacing()
                    ]
                }
            ],
            /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */ 'flex-direction': [
                {
                    flex: [
                        'row',
                        'row-reverse',
                        'col',
                        'col-reverse'
                    ]
                }
            ],
            /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */ 'flex-wrap': [
                {
                    flex: [
                        'nowrap',
                        'wrap',
                        'wrap-reverse'
                    ]
                }
            ],
            /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */ flex: [
                {
                    flex: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isFraction,
                        'auto',
                        'initial',
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */ grow: [
                {
                    grow: [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */ shrink: [
                {
                    shrink: [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */ order: [
                {
                    order: [
                        $85fc2fe65ff21506$var$isInteger,
                        'first',
                        'last',
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */ 'grid-cols': [
                {
                    'grid-cols': scaleGridTemplateColsRows()
                }
            ],
            /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */ 'col-start-end': [
                {
                    col: scaleGridColRowStartAndEnd()
                }
            ],
            /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */ 'col-start': [
                {
                    'col-start': scaleGridColRowStartOrEnd()
                }
            ],
            /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */ 'col-end': [
                {
                    'col-end': scaleGridColRowStartOrEnd()
                }
            ],
            /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */ 'grid-rows': [
                {
                    'grid-rows': scaleGridTemplateColsRows()
                }
            ],
            /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */ 'row-start-end': [
                {
                    row: scaleGridColRowStartAndEnd()
                }
            ],
            /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */ 'row-start': [
                {
                    'row-start': scaleGridColRowStartOrEnd()
                }
            ],
            /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */ 'row-end': [
                {
                    'row-end': scaleGridColRowStartOrEnd()
                }
            ],
            /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */ 'grid-flow': [
                {
                    'grid-flow': [
                        'row',
                        'col',
                        'dense',
                        'row-dense',
                        'col-dense'
                    ]
                }
            ],
            /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */ 'auto-cols': [
                {
                    'auto-cols': scaleGridAutoColsRows()
                }
            ],
            /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */ 'auto-rows': [
                {
                    'auto-rows': scaleGridAutoColsRows()
                }
            ],
            /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */ gap: [
                {
                    gap: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */ 'gap-x': [
                {
                    'gap-x': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */ 'gap-y': [
                {
                    'gap-y': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */ 'justify-content': [
                {
                    justify: [
                        ...scaleAlignPrimaryAxis(),
                        'normal'
                    ]
                }
            ],
            /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */ 'justify-items': [
                {
                    'justify-items': [
                        ...scaleAlignSecondaryAxis(),
                        'normal'
                    ]
                }
            ],
            /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */ 'justify-self': [
                {
                    'justify-self': [
                        'auto',
                        ...scaleAlignSecondaryAxis()
                    ]
                }
            ],
            /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */ 'align-content': [
                {
                    content: [
                        'normal',
                        ...scaleAlignPrimaryAxis()
                    ]
                }
            ],
            /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */ 'align-items': [
                {
                    items: [
                        ...scaleAlignSecondaryAxis(),
                        {
                            baseline: [
                                '',
                                'last'
                            ]
                        }
                    ]
                }
            ],
            /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */ 'align-self': [
                {
                    self: [
                        'auto',
                        ...scaleAlignSecondaryAxis(),
                        {
                            baseline: [
                                '',
                                'last'
                            ]
                        }
                    ]
                }
            ],
            /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */ 'place-content': [
                {
                    'place-content': scaleAlignPrimaryAxis()
                }
            ],
            /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */ 'place-items': [
                {
                    'place-items': [
                        ...scaleAlignSecondaryAxis(),
                        'baseline'
                    ]
                }
            ],
            /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */ 'place-self': [
                {
                    'place-self': [
                        'auto',
                        ...scaleAlignSecondaryAxis()
                    ]
                }
            ],
            // Spacing
            /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */ p: [
                {
                    p: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Inline
       * @see https://tailwindcss.com/docs/padding
       */ px: [
                {
                    px: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Block
       * @see https://tailwindcss.com/docs/padding
       */ py: [
                {
                    py: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Inline Start
       * @see https://tailwindcss.com/docs/padding
       */ ps: [
                {
                    ps: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Inline End
       * @see https://tailwindcss.com/docs/padding
       */ pe: [
                {
                    pe: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Block Start
       * @see https://tailwindcss.com/docs/padding
       */ pbs: [
                {
                    pbs: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Block End
       * @see https://tailwindcss.com/docs/padding
       */ pbe: [
                {
                    pbe: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */ pt: [
                {
                    pt: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */ pr: [
                {
                    pr: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */ pb: [
                {
                    pb: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */ pl: [
                {
                    pl: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */ m: [
                {
                    m: scaleMargin()
                }
            ],
            /**
       * Margin Inline
       * @see https://tailwindcss.com/docs/margin
       */ mx: [
                {
                    mx: scaleMargin()
                }
            ],
            /**
       * Margin Block
       * @see https://tailwindcss.com/docs/margin
       */ my: [
                {
                    my: scaleMargin()
                }
            ],
            /**
       * Margin Inline Start
       * @see https://tailwindcss.com/docs/margin
       */ ms: [
                {
                    ms: scaleMargin()
                }
            ],
            /**
       * Margin Inline End
       * @see https://tailwindcss.com/docs/margin
       */ me: [
                {
                    me: scaleMargin()
                }
            ],
            /**
       * Margin Block Start
       * @see https://tailwindcss.com/docs/margin
       */ mbs: [
                {
                    mbs: scaleMargin()
                }
            ],
            /**
       * Margin Block End
       * @see https://tailwindcss.com/docs/margin
       */ mbe: [
                {
                    mbe: scaleMargin()
                }
            ],
            /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */ mt: [
                {
                    mt: scaleMargin()
                }
            ],
            /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */ mr: [
                {
                    mr: scaleMargin()
                }
            ],
            /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */ mb: [
                {
                    mb: scaleMargin()
                }
            ],
            /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */ ml: [
                {
                    ml: scaleMargin()
                }
            ],
            /**
       * Space Between X
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */ 'space-x': [
                {
                    'space-x': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */ 'space-x-reverse': [
                'space-x-reverse'
            ],
            /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */ 'space-y': [
                {
                    'space-y': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */ 'space-y-reverse': [
                'space-y-reverse'
            ],
            // --------------
            // --- Sizing ---
            // --------------
            /**
       * Size
       * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
       */ size: [
                {
                    size: scaleSizing()
                }
            ],
            /**
       * Inline Size
       * @see https://tailwindcss.com/docs/inline-size
       */ 'inline-size': [
                {
                    inline: [
                        'auto',
                        ...scaleSizingInline()
                    ]
                }
            ],
            /**
       * Min-Inline Size
       * @see https://tailwindcss.com/docs/min-inline-size
       */ 'min-inline-size': [
                {
                    'min-inline': [
                        'auto',
                        ...scaleSizingInline()
                    ]
                }
            ],
            /**
       * Max-Inline Size
       * @see https://tailwindcss.com/docs/max-inline-size
       */ 'max-inline-size': [
                {
                    'max-inline': [
                        'none',
                        ...scaleSizingInline()
                    ]
                }
            ],
            /**
       * Block Size
       * @see https://tailwindcss.com/docs/block-size
       */ 'block-size': [
                {
                    block: [
                        'auto',
                        ...scaleSizingBlock()
                    ]
                }
            ],
            /**
       * Min-Block Size
       * @see https://tailwindcss.com/docs/min-block-size
       */ 'min-block-size': [
                {
                    'min-block': [
                        'auto',
                        ...scaleSizingBlock()
                    ]
                }
            ],
            /**
       * Max-Block Size
       * @see https://tailwindcss.com/docs/max-block-size
       */ 'max-block-size': [
                {
                    'max-block': [
                        'none',
                        ...scaleSizingBlock()
                    ]
                }
            ],
            /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */ w: [
                {
                    w: [
                        themeContainer,
                        'screen',
                        ...scaleSizing()
                    ]
                }
            ],
            /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */ 'min-w': [
                {
                    'min-w': [
                        themeContainer,
                        'screen',
                        /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */ 'none',
                        ...scaleSizing()
                    ]
                }
            ],
            /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */ 'max-w': [
                {
                    'max-w': [
                        themeContainer,
                        'screen',
                        'none',
                        /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */ 'prose',
                        /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */ {
                            screen: [
                                themeBreakpoint
                            ]
                        },
                        ...scaleSizing()
                    ]
                }
            ],
            /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */ h: [
                {
                    h: [
                        'screen',
                        'lh',
                        ...scaleSizing()
                    ]
                }
            ],
            /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */ 'min-h': [
                {
                    'min-h': [
                        'screen',
                        'lh',
                        'none',
                        ...scaleSizing()
                    ]
                }
            ],
            /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */ 'max-h': [
                {
                    'max-h': [
                        'screen',
                        'lh',
                        'none',
                        ...scaleSizing()
                    ]
                }
            ],
            // ------------------
            // --- Typography ---
            // ------------------
            /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */ 'font-size': [
                {
                    text: [
                        'base',
                        themeText,
                        $85fc2fe65ff21506$var$isArbitraryVariableLength,
                        $85fc2fe65ff21506$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */ 'font-smoothing': [
                'antialiased',
                'subpixel-antialiased'
            ],
            /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */ 'font-style': [
                'italic',
                'not-italic'
            ],
            /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */ 'font-weight': [
                {
                    font: [
                        themeFontWeight,
                        $85fc2fe65ff21506$var$isArbitraryVariableWeight,
                        $85fc2fe65ff21506$var$isArbitraryWeight
                    ]
                }
            ],
            /**
       * Font Stretch
       * @see https://tailwindcss.com/docs/font-stretch
       */ 'font-stretch': [
                {
                    'font-stretch': [
                        'ultra-condensed',
                        'extra-condensed',
                        'condensed',
                        'semi-condensed',
                        'normal',
                        'semi-expanded',
                        'expanded',
                        'extra-expanded',
                        'ultra-expanded',
                        $85fc2fe65ff21506$var$isPercent,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */ 'font-family': [
                {
                    font: [
                        $85fc2fe65ff21506$var$isArbitraryVariableFamilyName,
                        $85fc2fe65ff21506$var$isArbitraryFamilyName,
                        themeFont
                    ]
                }
            ],
            /**
       * Font Feature Settings
       * @see https://tailwindcss.com/docs/font-feature-settings
       */ 'font-features': [
                {
                    'font-features': [
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-normal': [
                'normal-nums'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-ordinal': [
                'ordinal'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-slashed-zero': [
                'slashed-zero'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-figure': [
                'lining-nums',
                'oldstyle-nums'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-spacing': [
                'proportional-nums',
                'tabular-nums'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-fraction': [
                'diagonal-fractions',
                'stacked-fractions'
            ],
            /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */ tracking: [
                {
                    tracking: [
                        themeTracking,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */ 'line-clamp': [
                {
                    'line-clamp': [
                        $85fc2fe65ff21506$var$isNumber,
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryNumber
                    ]
                }
            ],
            /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */ leading: [
                {
                    leading: [
                        'none',
                        /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */ themeLeading,
                        ...scaleUnambiguousSpacing()
                    ]
                }
            ],
            /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */ 'list-image': [
                {
                    'list-image': [
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */ 'list-style-position': [
                {
                    list: [
                        'inside',
                        'outside'
                    ]
                }
            ],
            /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */ 'list-style-type': [
                {
                    list: [
                        'disc',
                        'decimal',
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */ 'text-alignment': [
                {
                    text: [
                        'left',
                        'center',
                        'right',
                        'justify',
                        'start',
                        'end'
                    ]
                }
            ],
            /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://v3.tailwindcss.com/docs/placeholder-color
       */ 'placeholder-color': [
                {
                    placeholder: scaleColor()
                }
            ],
            /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */ 'text-color': [
                {
                    text: scaleColor()
                }
            ],
            /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */ 'text-decoration': [
                'underline',
                'overline',
                'line-through',
                'no-underline'
            ],
            /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */ 'text-decoration-style': [
                {
                    decoration: [
                        ...scaleLineStyle(),
                        'wavy'
                    ]
                }
            ],
            /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */ 'text-decoration-thickness': [
                {
                    decoration: [
                        $85fc2fe65ff21506$var$isNumber,
                        'from-font',
                        'auto',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */ 'text-decoration-color': [
                {
                    decoration: scaleColor()
                }
            ],
            /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */ 'underline-offset': [
                {
                    'underline-offset': [
                        $85fc2fe65ff21506$var$isNumber,
                        'auto',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */ 'text-transform': [
                'uppercase',
                'lowercase',
                'capitalize',
                'normal-case'
            ],
            /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */ 'text-overflow': [
                'truncate',
                'text-ellipsis',
                'text-clip'
            ],
            /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */ 'text-wrap': [
                {
                    text: [
                        'wrap',
                        'nowrap',
                        'balance',
                        'pretty'
                    ]
                }
            ],
            /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */ indent: [
                {
                    indent: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Tab Size
       * @see https://tailwindcss.com/docs/tab-size
       */ 'tab-size': [
                {
                    tab: [
                        $85fc2fe65ff21506$var$isInteger,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */ 'vertical-align': [
                {
                    align: [
                        'baseline',
                        'top',
                        'middle',
                        'bottom',
                        'text-top',
                        'text-bottom',
                        'sub',
                        'super',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */ whitespace: [
                {
                    whitespace: [
                        'normal',
                        'nowrap',
                        'pre',
                        'pre-line',
                        'pre-wrap',
                        'break-spaces'
                    ]
                }
            ],
            /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */ break: [
                {
                    break: [
                        'normal',
                        'words',
                        'all',
                        'keep'
                    ]
                }
            ],
            /**
       * Overflow Wrap
       * @see https://tailwindcss.com/docs/overflow-wrap
       */ wrap: [
                {
                    wrap: [
                        'break-word',
                        'anywhere',
                        'normal'
                    ]
                }
            ],
            /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */ hyphens: [
                {
                    hyphens: [
                        'none',
                        'manual',
                        'auto'
                    ]
                }
            ],
            /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */ content: [
                {
                    content: [
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // -------------------
            // --- Backgrounds ---
            // -------------------
            /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */ 'bg-attachment': [
                {
                    bg: [
                        'fixed',
                        'local',
                        'scroll'
                    ]
                }
            ],
            /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */ 'bg-clip': [
                {
                    'bg-clip': [
                        'border',
                        'padding',
                        'content',
                        'text'
                    ]
                }
            ],
            /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */ 'bg-origin': [
                {
                    'bg-origin': [
                        'border',
                        'padding',
                        'content'
                    ]
                }
            ],
            /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */ 'bg-position': [
                {
                    bg: scaleBgPosition()
                }
            ],
            /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */ 'bg-repeat': [
                {
                    bg: scaleBgRepeat()
                }
            ],
            /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */ 'bg-size': [
                {
                    bg: scaleBgSize()
                }
            ],
            /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */ 'bg-image': [
                {
                    bg: [
                        'none',
                        {
                            linear: [
                                {
                                    to: [
                                        't',
                                        'tr',
                                        'r',
                                        'br',
                                        'b',
                                        'bl',
                                        'l',
                                        'tl'
                                    ]
                                },
                                $85fc2fe65ff21506$var$isInteger,
                                $85fc2fe65ff21506$var$isArbitraryVariable,
                                $85fc2fe65ff21506$var$isArbitraryValue
                            ],
                            radial: [
                                '',
                                $85fc2fe65ff21506$var$isArbitraryVariable,
                                $85fc2fe65ff21506$var$isArbitraryValue
                            ],
                            conic: [
                                '',
                                $85fc2fe65ff21506$var$isInteger,
                                $85fc2fe65ff21506$var$isArbitraryVariable,
                                $85fc2fe65ff21506$var$isArbitraryValue
                            ]
                        },
                        $85fc2fe65ff21506$var$isArbitraryVariableImage,
                        $85fc2fe65ff21506$var$isArbitraryImage
                    ]
                }
            ],
            /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */ 'bg-color': [
                {
                    bg: scaleColor()
                }
            ],
            /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-from-pos': [
                {
                    from: scaleGradientStopPosition()
                }
            ],
            /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-via-pos': [
                {
                    via: scaleGradientStopPosition()
                }
            ],
            /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-to-pos': [
                {
                    to: scaleGradientStopPosition()
                }
            ],
            /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-from': [
                {
                    from: scaleColor()
                }
            ],
            /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-via': [
                {
                    via: scaleColor()
                }
            ],
            /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-to': [
                {
                    to: scaleColor()
                }
            ],
            // ---------------
            // --- Borders ---
            // ---------------
            /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */ rounded: [
                {
                    rounded: scaleRadius()
                }
            ],
            /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-s': [
                {
                    'rounded-s': scaleRadius()
                }
            ],
            /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-e': [
                {
                    'rounded-e': scaleRadius()
                }
            ],
            /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-t': [
                {
                    'rounded-t': scaleRadius()
                }
            ],
            /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-r': [
                {
                    'rounded-r': scaleRadius()
                }
            ],
            /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-b': [
                {
                    'rounded-b': scaleRadius()
                }
            ],
            /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-l': [
                {
                    'rounded-l': scaleRadius()
                }
            ],
            /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-ss': [
                {
                    'rounded-ss': scaleRadius()
                }
            ],
            /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-se': [
                {
                    'rounded-se': scaleRadius()
                }
            ],
            /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-ee': [
                {
                    'rounded-ee': scaleRadius()
                }
            ],
            /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-es': [
                {
                    'rounded-es': scaleRadius()
                }
            ],
            /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-tl': [
                {
                    'rounded-tl': scaleRadius()
                }
            ],
            /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-tr': [
                {
                    'rounded-tr': scaleRadius()
                }
            ],
            /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-br': [
                {
                    'rounded-br': scaleRadius()
                }
            ],
            /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-bl': [
                {
                    'rounded-bl': scaleRadius()
                }
            ],
            /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w': [
                {
                    border: scaleBorderWidth()
                }
            ],
            /**
       * Border Width Inline
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-x': [
                {
                    'border-x': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Block
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-y': [
                {
                    'border-y': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Inline Start
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-s': [
                {
                    'border-s': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Inline End
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-e': [
                {
                    'border-e': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Block Start
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-bs': [
                {
                    'border-bs': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Block End
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-be': [
                {
                    'border-be': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-t': [
                {
                    'border-t': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-r': [
                {
                    'border-r': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-b': [
                {
                    'border-b': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-l': [
                {
                    'border-l': scaleBorderWidth()
                }
            ],
            /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/border-width#between-children
       */ 'divide-x': [
                {
                    'divide-x': scaleBorderWidth()
                }
            ],
            /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */ 'divide-x-reverse': [
                'divide-x-reverse'
            ],
            /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/border-width#between-children
       */ 'divide-y': [
                {
                    'divide-y': scaleBorderWidth()
                }
            ],
            /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */ 'divide-y-reverse': [
                'divide-y-reverse'
            ],
            /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */ 'border-style': [
                {
                    border: [
                        ...scaleLineStyle(),
                        'hidden',
                        'none'
                    ]
                }
            ],
            /**
       * Divide Style
       * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
       */ 'divide-style': [
                {
                    divide: [
                        ...scaleLineStyle(),
                        'hidden',
                        'none'
                    ]
                }
            ],
            /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color': [
                {
                    border: scaleColor()
                }
            ],
            /**
       * Border Color Inline
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-x': [
                {
                    'border-x': scaleColor()
                }
            ],
            /**
       * Border Color Block
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-y': [
                {
                    'border-y': scaleColor()
                }
            ],
            /**
       * Border Color Inline Start
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-s': [
                {
                    'border-s': scaleColor()
                }
            ],
            /**
       * Border Color Inline End
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-e': [
                {
                    'border-e': scaleColor()
                }
            ],
            /**
       * Border Color Block Start
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-bs': [
                {
                    'border-bs': scaleColor()
                }
            ],
            /**
       * Border Color Block End
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-be': [
                {
                    'border-be': scaleColor()
                }
            ],
            /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-t': [
                {
                    'border-t': scaleColor()
                }
            ],
            /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-r': [
                {
                    'border-r': scaleColor()
                }
            ],
            /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-b': [
                {
                    'border-b': scaleColor()
                }
            ],
            /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-l': [
                {
                    'border-l': scaleColor()
                }
            ],
            /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */ 'divide-color': [
                {
                    divide: scaleColor()
                }
            ],
            /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */ 'outline-style': [
                {
                    outline: [
                        ...scaleLineStyle(),
                        'none',
                        'hidden'
                    ]
                }
            ],
            /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */ 'outline-offset': [
                {
                    'outline-offset': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */ 'outline-w': [
                {
                    outline: [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariableLength,
                        $85fc2fe65ff21506$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */ 'outline-color': [
                {
                    outline: scaleColor()
                }
            ],
            // ---------------
            // --- Effects ---
            // ---------------
            /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */ shadow: [
                {
                    shadow: [
                        // Deprecated since Tailwind CSS v4.0.0
                        '',
                        // Deprecated since Tailwind CSS v4.0.0
                        'inner',
                        'none',
                        themeShadow,
                        $85fc2fe65ff21506$var$isArbitraryVariableShadow,
                        $85fc2fe65ff21506$var$isArbitraryShadow
                    ]
                }
            ],
            /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
       */ 'shadow-color': [
                {
                    shadow: scaleColor()
                }
            ],
            /**
       * Inset Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
       */ 'inset-shadow': [
                {
                    'inset-shadow': [
                        'none',
                        themeInsetShadow,
                        $85fc2fe65ff21506$var$isArbitraryVariableShadow,
                        $85fc2fe65ff21506$var$isArbitraryShadow
                    ]
                }
            ],
            /**
       * Inset Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
       */ 'inset-shadow-color': [
                {
                    'inset-shadow': scaleColor()
                }
            ],
            /**
       * Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
       */ 'ring-w': [
                {
                    ring: scaleBorderWidth()
                }
            ],
            /**
       * Ring Width Inset
       * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */ 'ring-w-inset': [
                'ring-inset'
            ],
            /**
       * Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
       */ 'ring-color': [
                {
                    ring: scaleColor()
                }
            ],
            /**
       * Ring Offset Width
       * @see https://v3.tailwindcss.com/docs/ring-offset-width
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */ 'ring-offset-w': [
                {
                    'ring-offset': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Ring Offset Color
       * @see https://v3.tailwindcss.com/docs/ring-offset-color
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */ 'ring-offset-color': [
                {
                    'ring-offset': scaleColor()
                }
            ],
            /**
       * Inset Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
       */ 'inset-ring-w': [
                {
                    'inset-ring': scaleBorderWidth()
                }
            ],
            /**
       * Inset Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
       */ 'inset-ring-color': [
                {
                    'inset-ring': scaleColor()
                }
            ],
            /**
       * Text Shadow
       * @see https://tailwindcss.com/docs/text-shadow
       */ 'text-shadow': [
                {
                    'text-shadow': [
                        'none',
                        themeTextShadow,
                        $85fc2fe65ff21506$var$isArbitraryVariableShadow,
                        $85fc2fe65ff21506$var$isArbitraryShadow
                    ]
                }
            ],
            /**
       * Text Shadow Color
       * @see https://tailwindcss.com/docs/text-shadow#setting-the-shadow-color
       */ 'text-shadow-color': [
                {
                    'text-shadow': scaleColor()
                }
            ],
            /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */ opacity: [
                {
                    opacity: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */ 'mix-blend': [
                {
                    'mix-blend': [
                        ...scaleBlendMode(),
                        'plus-darker',
                        'plus-lighter'
                    ]
                }
            ],
            /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */ 'bg-blend': [
                {
                    'bg-blend': scaleBlendMode()
                }
            ],
            /**
       * Mask Clip
       * @see https://tailwindcss.com/docs/mask-clip
       */ 'mask-clip': [
                {
                    'mask-clip': [
                        'border',
                        'padding',
                        'content',
                        'fill',
                        'stroke',
                        'view'
                    ]
                },
                'mask-no-clip'
            ],
            /**
       * Mask Composite
       * @see https://tailwindcss.com/docs/mask-composite
       */ 'mask-composite': [
                {
                    mask: [
                        'add',
                        'subtract',
                        'intersect',
                        'exclude'
                    ]
                }
            ],
            /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */ 'mask-image-linear-pos': [
                {
                    'mask-linear': [
                        $85fc2fe65ff21506$var$isNumber
                    ]
                }
            ],
            'mask-image-linear-from-pos': [
                {
                    'mask-linear-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-linear-to-pos': [
                {
                    'mask-linear-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-linear-from-color': [
                {
                    'mask-linear-from': scaleColor()
                }
            ],
            'mask-image-linear-to-color': [
                {
                    'mask-linear-to': scaleColor()
                }
            ],
            'mask-image-t-from-pos': [
                {
                    'mask-t-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-t-to-pos': [
                {
                    'mask-t-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-t-from-color': [
                {
                    'mask-t-from': scaleColor()
                }
            ],
            'mask-image-t-to-color': [
                {
                    'mask-t-to': scaleColor()
                }
            ],
            'mask-image-r-from-pos': [
                {
                    'mask-r-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-r-to-pos': [
                {
                    'mask-r-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-r-from-color': [
                {
                    'mask-r-from': scaleColor()
                }
            ],
            'mask-image-r-to-color': [
                {
                    'mask-r-to': scaleColor()
                }
            ],
            'mask-image-b-from-pos': [
                {
                    'mask-b-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-b-to-pos': [
                {
                    'mask-b-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-b-from-color': [
                {
                    'mask-b-from': scaleColor()
                }
            ],
            'mask-image-b-to-color': [
                {
                    'mask-b-to': scaleColor()
                }
            ],
            'mask-image-l-from-pos': [
                {
                    'mask-l-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-l-to-pos': [
                {
                    'mask-l-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-l-from-color': [
                {
                    'mask-l-from': scaleColor()
                }
            ],
            'mask-image-l-to-color': [
                {
                    'mask-l-to': scaleColor()
                }
            ],
            'mask-image-x-from-pos': [
                {
                    'mask-x-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-x-to-pos': [
                {
                    'mask-x-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-x-from-color': [
                {
                    'mask-x-from': scaleColor()
                }
            ],
            'mask-image-x-to-color': [
                {
                    'mask-x-to': scaleColor()
                }
            ],
            'mask-image-y-from-pos': [
                {
                    'mask-y-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-y-to-pos': [
                {
                    'mask-y-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-y-from-color': [
                {
                    'mask-y-from': scaleColor()
                }
            ],
            'mask-image-y-to-color': [
                {
                    'mask-y-to': scaleColor()
                }
            ],
            'mask-image-radial': [
                {
                    'mask-radial': [
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            'mask-image-radial-from-pos': [
                {
                    'mask-radial-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-radial-to-pos': [
                {
                    'mask-radial-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-radial-from-color': [
                {
                    'mask-radial-from': scaleColor()
                }
            ],
            'mask-image-radial-to-color': [
                {
                    'mask-radial-to': scaleColor()
                }
            ],
            'mask-image-radial-shape': [
                {
                    'mask-radial': [
                        'circle',
                        'ellipse'
                    ]
                }
            ],
            'mask-image-radial-size': [
                {
                    'mask-radial': [
                        {
                            closest: [
                                'side',
                                'corner'
                            ],
                            farthest: [
                                'side',
                                'corner'
                            ]
                        }
                    ]
                }
            ],
            'mask-image-radial-pos': [
                {
                    'mask-radial-at': scalePosition()
                }
            ],
            'mask-image-conic-pos': [
                {
                    'mask-conic': [
                        $85fc2fe65ff21506$var$isNumber
                    ]
                }
            ],
            'mask-image-conic-from-pos': [
                {
                    'mask-conic-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-conic-to-pos': [
                {
                    'mask-conic-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-conic-from-color': [
                {
                    'mask-conic-from': scaleColor()
                }
            ],
            'mask-image-conic-to-color': [
                {
                    'mask-conic-to': scaleColor()
                }
            ],
            /**
       * Mask Mode
       * @see https://tailwindcss.com/docs/mask-mode
       */ 'mask-mode': [
                {
                    mask: [
                        'alpha',
                        'luminance',
                        'match'
                    ]
                }
            ],
            /**
       * Mask Origin
       * @see https://tailwindcss.com/docs/mask-origin
       */ 'mask-origin': [
                {
                    'mask-origin': [
                        'border',
                        'padding',
                        'content',
                        'fill',
                        'stroke',
                        'view'
                    ]
                }
            ],
            /**
       * Mask Position
       * @see https://tailwindcss.com/docs/mask-position
       */ 'mask-position': [
                {
                    mask: scaleBgPosition()
                }
            ],
            /**
       * Mask Repeat
       * @see https://tailwindcss.com/docs/mask-repeat
       */ 'mask-repeat': [
                {
                    mask: scaleBgRepeat()
                }
            ],
            /**
       * Mask Size
       * @see https://tailwindcss.com/docs/mask-size
       */ 'mask-size': [
                {
                    mask: scaleBgSize()
                }
            ],
            /**
       * Mask Type
       * @see https://tailwindcss.com/docs/mask-type
       */ 'mask-type': [
                {
                    'mask-type': [
                        'alpha',
                        'luminance'
                    ]
                }
            ],
            /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */ 'mask-image': [
                {
                    mask: [
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // ---------------
            // --- Filters ---
            // ---------------
            /**
       * Filter
       * @see https://tailwindcss.com/docs/filter
       */ filter: [
                {
                    filter: [
                        // Deprecated since Tailwind CSS v3.0.0
                        '',
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */ blur: [
                {
                    blur: scaleBlur()
                }
            ],
            /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */ brightness: [
                {
                    brightness: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */ contrast: [
                {
                    contrast: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */ 'drop-shadow': [
                {
                    'drop-shadow': [
                        // Deprecated since Tailwind CSS v4.0.0
                        '',
                        'none',
                        themeDropShadow,
                        $85fc2fe65ff21506$var$isArbitraryVariableShadow,
                        $85fc2fe65ff21506$var$isArbitraryShadow
                    ]
                }
            ],
            /**
       * Drop Shadow Color
       * @see https://tailwindcss.com/docs/filter-drop-shadow#setting-the-shadow-color
       */ 'drop-shadow-color': [
                {
                    'drop-shadow': scaleColor()
                }
            ],
            /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */ grayscale: [
                {
                    grayscale: [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */ 'hue-rotate': [
                {
                    'hue-rotate': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */ invert: [
                {
                    invert: [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */ saturate: [
                {
                    saturate: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */ sepia: [
                {
                    sepia: [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Filter
       * @see https://tailwindcss.com/docs/backdrop-filter
       */ 'backdrop-filter': [
                {
                    'backdrop-filter': [
                        // Deprecated since Tailwind CSS v3.0.0
                        '',
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */ 'backdrop-blur': [
                {
                    'backdrop-blur': scaleBlur()
                }
            ],
            /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */ 'backdrop-brightness': [
                {
                    'backdrop-brightness': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */ 'backdrop-contrast': [
                {
                    'backdrop-contrast': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */ 'backdrop-grayscale': [
                {
                    'backdrop-grayscale': [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */ 'backdrop-hue-rotate': [
                {
                    'backdrop-hue-rotate': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */ 'backdrop-invert': [
                {
                    'backdrop-invert': [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */ 'backdrop-opacity': [
                {
                    'backdrop-opacity': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */ 'backdrop-saturate': [
                {
                    'backdrop-saturate': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */ 'backdrop-sepia': [
                {
                    'backdrop-sepia': [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // --------------
            // --- Tables ---
            // --------------
            /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */ 'border-collapse': [
                {
                    border: [
                        'collapse',
                        'separate'
                    ]
                }
            ],
            /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */ 'border-spacing': [
                {
                    'border-spacing': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */ 'border-spacing-x': [
                {
                    'border-spacing-x': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */ 'border-spacing-y': [
                {
                    'border-spacing-y': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */ 'table-layout': [
                {
                    table: [
                        'auto',
                        'fixed'
                    ]
                }
            ],
            /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */ caption: [
                {
                    caption: [
                        'top',
                        'bottom'
                    ]
                }
            ],
            // ---------------------------------
            // --- Transitions and Animation ---
            // ---------------------------------
            /**
       * Transition Property
       * @see https://tailwindcss.com/docs/transition-property
       */ transition: [
                {
                    transition: [
                        '',
                        'all',
                        'colors',
                        'opacity',
                        'shadow',
                        'transform',
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Transition Behavior
       * @see https://tailwindcss.com/docs/transition-behavior
       */ 'transition-behavior': [
                {
                    transition: [
                        'normal',
                        'discrete'
                    ]
                }
            ],
            /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */ duration: [
                {
                    duration: [
                        $85fc2fe65ff21506$var$isNumber,
                        'initial',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */ ease: [
                {
                    ease: [
                        'linear',
                        'initial',
                        themeEase,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */ delay: [
                {
                    delay: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */ animate: [
                {
                    animate: [
                        'none',
                        themeAnimate,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // ------------------
            // --- Transforms ---
            // ------------------
            /**
       * Backface Visibility
       * @see https://tailwindcss.com/docs/backface-visibility
       */ backface: [
                {
                    backface: [
                        'hidden',
                        'visible'
                    ]
                }
            ],
            /**
       * Perspective
       * @see https://tailwindcss.com/docs/perspective
       */ perspective: [
                {
                    perspective: [
                        themePerspective,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Perspective Origin
       * @see https://tailwindcss.com/docs/perspective-origin
       */ 'perspective-origin': [
                {
                    'perspective-origin': scalePositionWithArbitrary()
                }
            ],
            /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */ rotate: [
                {
                    rotate: scaleRotate()
                }
            ],
            /**
       * Rotate X
       * @see https://tailwindcss.com/docs/rotate
       */ 'rotate-x': [
                {
                    'rotate-x': scaleRotate()
                }
            ],
            /**
       * Rotate Y
       * @see https://tailwindcss.com/docs/rotate
       */ 'rotate-y': [
                {
                    'rotate-y': scaleRotate()
                }
            ],
            /**
       * Rotate Z
       * @see https://tailwindcss.com/docs/rotate
       */ 'rotate-z': [
                {
                    'rotate-z': scaleRotate()
                }
            ],
            /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */ scale: [
                {
                    scale: scaleScale()
                }
            ],
            /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */ 'scale-x': [
                {
                    'scale-x': scaleScale()
                }
            ],
            /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */ 'scale-y': [
                {
                    'scale-y': scaleScale()
                }
            ],
            /**
       * Scale Z
       * @see https://tailwindcss.com/docs/scale
       */ 'scale-z': [
                {
                    'scale-z': scaleScale()
                }
            ],
            /**
       * Scale 3D
       * @see https://tailwindcss.com/docs/scale
       */ 'scale-3d': [
                'scale-3d'
            ],
            /**
       * Skew
       * @see https://tailwindcss.com/docs/skew
       */ skew: [
                {
                    skew: scaleSkew()
                }
            ],
            /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */ 'skew-x': [
                {
                    'skew-x': scaleSkew()
                }
            ],
            /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */ 'skew-y': [
                {
                    'skew-y': scaleSkew()
                }
            ],
            /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */ transform: [
                {
                    transform: [
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue,
                        '',
                        'none',
                        'gpu',
                        'cpu'
                    ]
                }
            ],
            /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */ 'transform-origin': [
                {
                    origin: scalePositionWithArbitrary()
                }
            ],
            /**
       * Transform Style
       * @see https://tailwindcss.com/docs/transform-style
       */ 'transform-style': [
                {
                    transform: [
                        '3d',
                        'flat'
                    ]
                }
            ],
            /**
       * Translate
       * @see https://tailwindcss.com/docs/translate
       */ translate: [
                {
                    translate: scaleTranslate()
                }
            ],
            /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */ 'translate-x': [
                {
                    'translate-x': scaleTranslate()
                }
            ],
            /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */ 'translate-y': [
                {
                    'translate-y': scaleTranslate()
                }
            ],
            /**
       * Translate Z
       * @see https://tailwindcss.com/docs/translate
       */ 'translate-z': [
                {
                    'translate-z': scaleTranslate()
                }
            ],
            /**
       * Translate None
       * @see https://tailwindcss.com/docs/translate
       */ 'translate-none': [
                'translate-none'
            ],
            /**
       * Zoom
       * @see https://tailwindcss.com/docs/zoom
       */ zoom: [
                {
                    zoom: [
                        $85fc2fe65ff21506$var$isInteger,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // ---------------------
            // --- Interactivity ---
            // ---------------------
            /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */ accent: [
                {
                    accent: scaleColor()
                }
            ],
            /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */ appearance: [
                {
                    appearance: [
                        'none',
                        'auto'
                    ]
                }
            ],
            /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */ 'caret-color': [
                {
                    caret: scaleColor()
                }
            ],
            /**
       * Color Scheme
       * @see https://tailwindcss.com/docs/color-scheme
       */ 'color-scheme': [
                {
                    scheme: [
                        'normal',
                        'dark',
                        'light',
                        'light-dark',
                        'only-dark',
                        'only-light'
                    ]
                }
            ],
            /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */ cursor: [
                {
                    cursor: [
                        'auto',
                        'default',
                        'pointer',
                        'wait',
                        'text',
                        'move',
                        'help',
                        'not-allowed',
                        'none',
                        'context-menu',
                        'progress',
                        'cell',
                        'crosshair',
                        'vertical-text',
                        'alias',
                        'copy',
                        'no-drop',
                        'grab',
                        'grabbing',
                        'all-scroll',
                        'col-resize',
                        'row-resize',
                        'n-resize',
                        'e-resize',
                        's-resize',
                        'w-resize',
                        'ne-resize',
                        'nw-resize',
                        'se-resize',
                        'sw-resize',
                        'ew-resize',
                        'ns-resize',
                        'nesw-resize',
                        'nwse-resize',
                        'zoom-in',
                        'zoom-out',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Field Sizing
       * @see https://tailwindcss.com/docs/field-sizing
       */ 'field-sizing': [
                {
                    'field-sizing': [
                        'fixed',
                        'content'
                    ]
                }
            ],
            /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */ 'pointer-events': [
                {
                    'pointer-events': [
                        'auto',
                        'none'
                    ]
                }
            ],
            /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */ resize: [
                {
                    resize: [
                        'none',
                        '',
                        'y',
                        'x'
                    ]
                }
            ],
            /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */ 'scroll-behavior': [
                {
                    scroll: [
                        'auto',
                        'smooth'
                    ]
                }
            ],
            /**
       * Scrollbar Thumb Color
       * @see https://tailwindcss.com/docs/scrollbar-color
       */ 'scrollbar-thumb-color': [
                {
                    'scrollbar-thumb': scaleColor()
                }
            ],
            /**
       * Scrollbar Track Color
       * @see https://tailwindcss.com/docs/scrollbar-color
       */ 'scrollbar-track-color': [
                {
                    'scrollbar-track': scaleColor()
                }
            ],
            /**
       * Scrollbar Gutter
       * @see https://tailwindcss.com/docs/scrollbar-gutter
       */ 'scrollbar-gutter': [
                {
                    'scrollbar-gutter': [
                        'auto',
                        'stable',
                        'both'
                    ]
                }
            ],
            /**
       * Scrollbar Width
       * @see https://tailwindcss.com/docs/scrollbar-width
       */ 'scrollbar-w': [
                {
                    scrollbar: [
                        'auto',
                        'thin',
                        'none'
                    ]
                }
            ],
            /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-m': [
                {
                    'scroll-m': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Inline
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mx': [
                {
                    'scroll-mx': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Block
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-my': [
                {
                    'scroll-my': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Inline Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-ms': [
                {
                    'scroll-ms': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Inline End
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-me': [
                {
                    'scroll-me': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Block Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mbs': [
                {
                    'scroll-mbs': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Block End
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mbe': [
                {
                    'scroll-mbe': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mt': [
                {
                    'scroll-mt': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mr': [
                {
                    'scroll-mr': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mb': [
                {
                    'scroll-mb': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-ml': [
                {
                    'scroll-ml': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-p': [
                {
                    'scroll-p': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Inline
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-px': [
                {
                    'scroll-px': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Block
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-py': [
                {
                    'scroll-py': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Inline Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-ps': [
                {
                    'scroll-ps': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Inline End
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pe': [
                {
                    'scroll-pe': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Block Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pbs': [
                {
                    'scroll-pbs': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Block End
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pbe': [
                {
                    'scroll-pbe': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pt': [
                {
                    'scroll-pt': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pr': [
                {
                    'scroll-pr': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pb': [
                {
                    'scroll-pb': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pl': [
                {
                    'scroll-pl': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */ 'snap-align': [
                {
                    snap: [
                        'start',
                        'end',
                        'center',
                        'align-none'
                    ]
                }
            ],
            /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */ 'snap-stop': [
                {
                    snap: [
                        'normal',
                        'always'
                    ]
                }
            ],
            /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ 'snap-type': [
                {
                    snap: [
                        'none',
                        'x',
                        'y',
                        'both'
                    ]
                }
            ],
            /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ 'snap-strictness': [
                {
                    snap: [
                        'mandatory',
                        'proximity'
                    ]
                }
            ],
            /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */ touch: [
                {
                    touch: [
                        'auto',
                        'none',
                        'manipulation'
                    ]
                }
            ],
            /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */ 'touch-x': [
                {
                    'touch-pan': [
                        'x',
                        'left',
                        'right'
                    ]
                }
            ],
            /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */ 'touch-y': [
                {
                    'touch-pan': [
                        'y',
                        'up',
                        'down'
                    ]
                }
            ],
            /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */ 'touch-pz': [
                'touch-pinch-zoom'
            ],
            /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */ select: [
                {
                    select: [
                        'none',
                        'text',
                        'all',
                        'auto'
                    ]
                }
            ],
            /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */ 'will-change': [
                {
                    'will-change': [
                        'auto',
                        'scroll',
                        'contents',
                        'transform',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // -----------
            // --- SVG ---
            // -----------
            /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */ fill: [
                {
                    fill: [
                        'none',
                        ...scaleColor()
                    ]
                }
            ],
            /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */ 'stroke-w': [
                {
                    stroke: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariableLength,
                        $85fc2fe65ff21506$var$isArbitraryLength,
                        $85fc2fe65ff21506$var$isArbitraryNumber
                    ]
                }
            ],
            /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */ stroke: [
                {
                    stroke: [
                        'none',
                        ...scaleColor()
                    ]
                }
            ],
            // ---------------------
            // --- Accessibility ---
            // ---------------------
            /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */ 'forced-color-adjust': [
                {
                    'forced-color-adjust': [
                        'auto',
                        'none'
                    ]
                }
            ]
        },
        conflictingClassGroups: {
            'container-named': [
                'container-type'
            ],
            overflow: [
                'overflow-x',
                'overflow-y'
            ],
            overscroll: [
                'overscroll-x',
                'overscroll-y'
            ],
            inset: [
                'inset-x',
                'inset-y',
                'inset-bs',
                'inset-be',
                'start',
                'end',
                'top',
                'right',
                'bottom',
                'left'
            ],
            'inset-x': [
                'start',
                'end',
                'right',
                'left'
            ],
            'inset-y': [
                'inset-bs',
                'inset-be',
                'top',
                'bottom'
            ],
            flex: [
                'basis',
                'grow',
                'shrink'
            ],
            gap: [
                'gap-x',
                'gap-y'
            ],
            p: [
                'px',
                'py',
                'ps',
                'pe',
                'pbs',
                'pbe',
                'pt',
                'pr',
                'pb',
                'pl'
            ],
            px: [
                'ps',
                'pe',
                'pr',
                'pl'
            ],
            py: [
                'pbs',
                'pbe',
                'pt',
                'pb'
            ],
            m: [
                'mx',
                'my',
                'ms',
                'me',
                'mbs',
                'mbe',
                'mt',
                'mr',
                'mb',
                'ml'
            ],
            mx: [
                'ms',
                'me',
                'mr',
                'ml'
            ],
            my: [
                'mbs',
                'mbe',
                'mt',
                'mb'
            ],
            size: [
                'w',
                'h'
            ],
            'font-size': [
                'leading'
            ],
            'fvn-normal': [
                'fvn-ordinal',
                'fvn-slashed-zero',
                'fvn-figure',
                'fvn-spacing',
                'fvn-fraction'
            ],
            'fvn-ordinal': [
                'fvn-normal'
            ],
            'fvn-slashed-zero': [
                'fvn-normal'
            ],
            'fvn-figure': [
                'fvn-normal'
            ],
            'fvn-spacing': [
                'fvn-normal'
            ],
            'fvn-fraction': [
                'fvn-normal'
            ],
            'line-clamp': [
                'display',
                'overflow'
            ],
            rounded: [
                'rounded-s',
                'rounded-e',
                'rounded-t',
                'rounded-r',
                'rounded-b',
                'rounded-l',
                'rounded-ss',
                'rounded-se',
                'rounded-ee',
                'rounded-es',
                'rounded-tl',
                'rounded-tr',
                'rounded-br',
                'rounded-bl'
            ],
            'rounded-s': [
                'rounded-ss',
                'rounded-es'
            ],
            'rounded-e': [
                'rounded-se',
                'rounded-ee'
            ],
            'rounded-t': [
                'rounded-tl',
                'rounded-tr'
            ],
            'rounded-r': [
                'rounded-tr',
                'rounded-br'
            ],
            'rounded-b': [
                'rounded-br',
                'rounded-bl'
            ],
            'rounded-l': [
                'rounded-tl',
                'rounded-bl'
            ],
            'border-spacing': [
                'border-spacing-x',
                'border-spacing-y'
            ],
            'border-w': [
                'border-w-x',
                'border-w-y',
                'border-w-s',
                'border-w-e',
                'border-w-bs',
                'border-w-be',
                'border-w-t',
                'border-w-r',
                'border-w-b',
                'border-w-l'
            ],
            'border-w-x': [
                'border-w-s',
                'border-w-e',
                'border-w-r',
                'border-w-l'
            ],
            'border-w-y': [
                'border-w-bs',
                'border-w-be',
                'border-w-t',
                'border-w-b'
            ],
            'border-color': [
                'border-color-x',
                'border-color-y',
                'border-color-s',
                'border-color-e',
                'border-color-bs',
                'border-color-be',
                'border-color-t',
                'border-color-r',
                'border-color-b',
                'border-color-l'
            ],
            'border-color-x': [
                'border-color-s',
                'border-color-e',
                'border-color-r',
                'border-color-l'
            ],
            'border-color-y': [
                'border-color-bs',
                'border-color-be',
                'border-color-t',
                'border-color-b'
            ],
            translate: [
                'translate-x',
                'translate-y',
                'translate-none'
            ],
            'translate-none': [
                'translate',
                'translate-x',
                'translate-y',
                'translate-z'
            ],
            'scroll-m': [
                'scroll-mx',
                'scroll-my',
                'scroll-ms',
                'scroll-me',
                'scroll-mbs',
                'scroll-mbe',
                'scroll-mt',
                'scroll-mr',
                'scroll-mb',
                'scroll-ml'
            ],
            'scroll-mx': [
                'scroll-ms',
                'scroll-me',
                'scroll-mr',
                'scroll-ml'
            ],
            'scroll-my': [
                'scroll-mbs',
                'scroll-mbe',
                'scroll-mt',
                'scroll-mb'
            ],
            'scroll-p': [
                'scroll-px',
                'scroll-py',
                'scroll-ps',
                'scroll-pe',
                'scroll-pbs',
                'scroll-pbe',
                'scroll-pt',
                'scroll-pr',
                'scroll-pb',
                'scroll-pl'
            ],
            'scroll-px': [
                'scroll-ps',
                'scroll-pe',
                'scroll-pr',
                'scroll-pl'
            ],
            'scroll-py': [
                'scroll-pbs',
                'scroll-pbe',
                'scroll-pt',
                'scroll-pb'
            ],
            touch: [
                'touch-x',
                'touch-y',
                'touch-pz'
            ],
            'touch-x': [
                'touch'
            ],
            'touch-y': [
                'touch'
            ],
            'touch-pz': [
                'touch'
            ]
        },
        conflictingClassGroupModifiers: {
            'font-size': [
                'leading'
            ]
        },
        postfixLookupClassGroups: [
            'container-type'
        ],
        orderSensitiveModifiers: [
            '*',
            '**',
            'after',
            'backdrop',
            'before',
            'details-content',
            'file',
            'first-letter',
            'first-line',
            'marker',
            'placeholder',
            'selection'
        ]
    };
};
/**
 * @param baseConfig Config where other config will be merged into. This object will be mutated.
 * @param configExtension Partial config to merge into the `baseConfig`.
 */ const $85fc2fe65ff21506$var$mergeConfigs = (baseConfig, { cacheSize: cacheSize, prefix: prefix, experimentalParseClassName: experimentalParseClassName, extend: extend = {}, override: override = {} })=>{
    $85fc2fe65ff21506$var$overrideProperty(baseConfig, 'cacheSize', cacheSize);
    $85fc2fe65ff21506$var$overrideProperty(baseConfig, 'prefix', prefix);
    $85fc2fe65ff21506$var$overrideProperty(baseConfig, 'experimentalParseClassName', experimentalParseClassName);
    $85fc2fe65ff21506$var$overrideConfigProperties(baseConfig.theme, override.theme);
    $85fc2fe65ff21506$var$overrideConfigProperties(baseConfig.classGroups, override.classGroups);
    $85fc2fe65ff21506$var$overrideConfigProperties(baseConfig.conflictingClassGroups, override.conflictingClassGroups);
    $85fc2fe65ff21506$var$overrideConfigProperties(baseConfig.conflictingClassGroupModifiers, override.conflictingClassGroupModifiers);
    $85fc2fe65ff21506$var$overrideProperty(baseConfig, 'postfixLookupClassGroups', override.postfixLookupClassGroups);
    $85fc2fe65ff21506$var$overrideProperty(baseConfig, 'orderSensitiveModifiers', override.orderSensitiveModifiers);
    $85fc2fe65ff21506$var$mergeConfigProperties(baseConfig.theme, extend.theme);
    $85fc2fe65ff21506$var$mergeConfigProperties(baseConfig.classGroups, extend.classGroups);
    $85fc2fe65ff21506$var$mergeConfigProperties(baseConfig.conflictingClassGroups, extend.conflictingClassGroups);
    $85fc2fe65ff21506$var$mergeConfigProperties(baseConfig.conflictingClassGroupModifiers, extend.conflictingClassGroupModifiers);
    $85fc2fe65ff21506$var$mergeArrayProperties(baseConfig, extend, 'postfixLookupClassGroups');
    $85fc2fe65ff21506$var$mergeArrayProperties(baseConfig, extend, 'orderSensitiveModifiers');
    return baseConfig;
};
const $85fc2fe65ff21506$var$overrideProperty = (baseObject, overrideKey, overrideValue)=>{
    if (overrideValue !== undefined) baseObject[overrideKey] = overrideValue;
};
const $85fc2fe65ff21506$var$overrideConfigProperties = (baseObject, overrideObject)=>{
    if (overrideObject) for(const key in overrideObject)$85fc2fe65ff21506$var$overrideProperty(baseObject, key, overrideObject[key]);
};
const $85fc2fe65ff21506$var$mergeConfigProperties = (baseObject, mergeObject)=>{
    if (mergeObject) for(const key in mergeObject)$85fc2fe65ff21506$var$mergeArrayProperties(baseObject, mergeObject, key);
};
const $85fc2fe65ff21506$var$mergeArrayProperties = (baseObject, mergeObject, key)=>{
    const mergeValue = mergeObject[key];
    if (mergeValue !== undefined) baseObject[key] = baseObject[key] ? baseObject[key].concat(mergeValue) : mergeValue;
};
const $85fc2fe65ff21506$var$extendTailwindMerge = (configExtension, ...createConfig)=>typeof configExtension === 'function' ? $85fc2fe65ff21506$var$createTailwindMerge($85fc2fe65ff21506$var$getDefaultConfig, configExtension, ...createConfig) : $85fc2fe65ff21506$var$createTailwindMerge(()=>$85fc2fe65ff21506$var$mergeConfigs($85fc2fe65ff21506$var$getDefaultConfig(), configExtension), ...createConfig);
const $85fc2fe65ff21506$var$twMerge = /*#__PURE__*/ $85fc2fe65ff21506$var$createTailwindMerge($85fc2fe65ff21506$var$getDefaultConfig);
module.exports.createTailwindMerge = $85fc2fe65ff21506$var$createTailwindMerge;
module.exports.extendTailwindMerge = $85fc2fe65ff21506$var$extendTailwindMerge;
module.exports.fromTheme = $85fc2fe65ff21506$var$fromTheme;
module.exports.getDefaultConfig = $85fc2fe65ff21506$var$getDefaultConfig;
module.exports.mergeConfigs = $85fc2fe65ff21506$var$mergeConfigs;
module.exports.twJoin = $85fc2fe65ff21506$var$twJoin;
module.exports.twMerge = $85fc2fe65ff21506$var$twMerge;
module.exports.validators = $85fc2fe65ff21506$var$validators;

});



parcelRegister("a7Rbr", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $5JYPc = parcelRequire("5JYPc");

var $7phmx = parcelRequire("7phmx");
'use client';
const $6e2f2bccd0e2a9fb$var$TextInput = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ label: label, required: required, error: externalError, helperText: helperText, value: value, onChange: onChange, onBlur: onBlur, placeholder: placeholder, type: type = 'text', validate: validate, disabled: disabled = false, maxLength: maxLength, style: style, inputStyle: inputStyle, dir: // Unset: the field inherits the document's direction, which is what lets one
// component render a Persian and an English account. Pass dir="ltr" for a
// phone number, a code or any other Latin-digit run inside an RTL page.
dir, // Extra props (data-testid, aria-*, inputMode…) land on the real control:
// §17.2 requires a kit component to forward them, and these did not.
...rest }, ref)=>{
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [internalError, setInternalError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const error = externalError || (touched ? internalError : '');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        label: label,
        required: required,
        error: error,
        helperText: helperText,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ...rest,
        ref: ref,
        type: type,
        value: value,
        onChange: onChange,
        onBlur: (e)=>{
            setTouched(true);
            if (validate) setInternalError(validate(value) || '');
            onBlur?.(e);
        },
        placeholder: placeholder,
        disabled: disabled,
        maxLength: maxLength,
        dir: dir,
        className: (0, $5JYPc.cn)('w-full h-11 px-3.5 rounded-lg font-sans text-[0.84375rem] text-foreground', 'bg-white border-[1.5px] outline-none transition-[border-color,box-shadow] duration-150', error ? 'border-destructive shadow-ring-red focus:shadow-ring-red' : 'border-border focus:border-primary focus:shadow-ring-navy', disabled && 'bg-muted cursor-not-allowed opacity-70'),
        style: inputStyle
    }));
});
$6e2f2bccd0e2a9fb$var$TextInput.displayName = 'TextInput';
var $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039 = $6e2f2bccd0e2a9fb$var$TextInput;

});

parcelRegister("lffTJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f69d84dab43bb31$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $5JYPc = parcelRequire("5JYPc");

var $7phmx = parcelRequire("7phmx");

var $9sT7p = parcelRequire("9sT7p");

var $5AX1S = parcelRequire("5AX1S");

var $hlTfq = parcelRequire("hlTfq");

var $j9AxR = parcelRequire("j9AxR");
'use client';
// The one phone field. Everywhere in Parsina a human types a phone number, it types it
// here — a patient at the desk, a staff member being added, a supplier, a clinic line.
//
// ═══════════════════════════════════════════════════════════════════════════════
// WHAT IT WRITES, AND WHAT IT SHOWS — they are not the same thing, and that is the
// whole design.
//
//   `onChange` hands back **E.164 and only E.164** — `'+989121234567'`, or `''` while
//   the number is incomplete. Never an event object. The rules live in `lib/phone.js`;
//   this component owns none of them.
//
//   The BOX still shows `09121234567`, and always will. A stored `09121234567` and a
//   stored `+989121234567` render IDENTICALLY, because the draft is seeded through
//   `toNational`. Nothing on any screen changes shape on the day this ships. That is the
//   migration cushion, and it is what lets the wire format change without a coordinated
//   three-app cutover.
//
//   `showTrunk={false}` is the one opt-out: the box shows the number AFTER the dial chip
//   — `9121234567`, `2188000000` — with the trunk `0` off, because the chip already says
//   `+98` and a desk that deletes the zero is told, by the zero coming back, that its
//   edit did nothing. It changes only the SPELLING in the box: the emitted E.164 is the
//   same, a typed `0` still parses (and comes off on blur), and a stored `0…` or `+98…`
//   seeds the same trunkless draft.
//
// Why a bare string rather than the `{ target: { value } }` shim this component used to
// emit: `MoneyInput` already broke that pattern in this kit and states the rule in its
// own header — "Value in and value out are both the BARE ASCII numeric string… onChange
// is handed that string directly, not an event" — and `JalaliDatePicker` does the same.
// Entrenching a fake event in the one component whose output is a MATCHING KEY is the
// wrong direction. The second argument carries the rest: `{ ok, problem, e164, national,
// country, draft }`, for the rare caller that needs the national form or the reason.
//
// ═══════════════════════════════════════════════════════════════════════════════
// THE VALUE/DRAFT SPLIT — the subtlest thing in this file, and the thing a later
// "simplification" will break.
//
//   - The PARENT owns the canonical value (E.164). The COMPONENT owns the visible draft.
//   - The draft is seeded from the value on mount, and RE-seeded only when the `value`
//     PROP itself changed and the two no longer normalize to the same number. So typing
//     `0912` (parent holds `''`, draft holds `'0912'`, both normalize to `''`) does not
//     wipe the half-typed number; loading a patient re-seeds; a parent reset to `''`
//     clears it; and a parent that round-trips E.164 straight back never disturbs the
//     user's own typing.
//   - It NEVER calls `onChange` on mount or on a `value` prop change. These forms drive
//     `SaveBar` and dirty-tracking, and an emit-on-mount would mark every profile dirty
//     the moment it opened.
//
// Turning this into a plain controlled input wipes half-typed numbers on every keystroke
// — a regression visible only with a parent that round-trips through async state, which
// is why `PhoneInput.test.jsx` drives it from a real Host component.
//
// ═══════════════════════════════════════════════════════════════════════════════
// COUNTRY IS DERIVED, NEVER STORED.
//
// E.164 carries the country code inside the value, so `findByDialCode` recovers the
// picker on load. There is no `country_code` column, proto field or GraphQL field
// anywhere in this platform, and this change adds none: no schema change, no migration.
//
// THE PRESELECTION FOLLOWS THE LOCALE; A STORED NUMBER DOES NOT (PM-0078).
//
// An empty field preselects `countryForLocale(locale)` — Iran under `fa`, Iraq under
// `ar`, a tag's own region where it names one — so "the default is the default locale"
// and a patient from anywhere is one tap or one `+` away. A STORED value is never read
// through that preselection: an E.164 value names its own country, and a value stored
// in NATIONAL spelling (`09121234567`) is read as Iranian, always, because this field
// has only ever written E.164 and every national spelling in the platform's columns
// predates it — and those were Iranian. Read under Iraq, `09121234567` would come back
// as `+9649121234567`, the same digits and a different person.
//
// ═══════════════════════════════════════════════════════════════════════════════
// DIGITS ON SCREEN ARE THE LOCALE'S; DIGITS ON THE WIRE ARE ASCII.
//
// DESIGN_SYSTEM.md §6.4: displayed digit strings — phone included — use the locale's
// digit set "with no per-surface exceptions". This field used to render ASCII always,
// on the argument that a phone number is a KEY; the key is what is EMITTED, and that is
// still ASCII E.164. What changed is only the paint: the draft stays an ASCII string in
// state, and `localize` maps it digit-for-digit on the way to the DOM — the dial chip,
// the box, the default placeholder and the example in an error message alike. The
// mapping is one character to one character, so the caret arithmetic below (which
// counts kept characters in the ASCII draft) is untouched; `compactPhone` already folds
// whatever numerals come back in. `locale` defaults to <html lang>, as in `MoneyInput`.
// ─────────────────────────────────────────────────────────────────────────────
// Copy. The caller's props win; otherwise the kit's own words in `<html lang>`
// (lib/kitCopy.js, DESIGN.md rule 7).
//
// Five problems, not one: "invalid" alone tells nobody which digit to go looking for.
// The example is wrapped in U+2068 FSI … U+2069 PDI so an ASCII number inside a Persian
// sentence isolates itself without any CSS — the same reasoning as rule 8's LTR island,
// applied to a string rather than a box.
// ─────────────────────────────────────────────────────────────────────────────
const $5f69d84dab43bb31$var$isolate = (s)=>`\u2068${s}\u2069`;
const $5f69d84dab43bb31$var$defaultMessages = (locale)=>{
    const copy = (0, $j9AxR.kitCopy)(locale).phone;
    const isolated = (fn)=>(ctx)=>fn({
                ...ctx,
                example: $5f69d84dab43bb31$var$isolate(ctx.example)
            });
    return {
        required: copy.required,
        tooShort: isolated(copy.tooShort),
        tooLong: isolated(copy.tooLong),
        notMobile: isolated(copy.notMobile),
        invalid: copy.invalid
    };
};
/** A `Country`, an iso2 string, or nothing → a `Country`. */ const $5f69d84dab43bb31$var$asCountry = (value, fallback)=>(typeof value === 'string' ? (0, $5AX1S.findByIso2)(value) : value) || fallback;
/** The offered list: `Country` records or iso2 strings, defaulting to the whole catalog. */ function $5f69d84dab43bb31$var$resolveList(countries) {
    if (!Array.isArray(countries) || countries.length === 0) return 0, $5AX1S.COUNTRIES;
    const rows = countries.map((c)=>$5f69d84dab43bb31$var$asCountry(c, undefined)).filter(Boolean);
    return rows.length ? rows : (0, $5AX1S.COUNTRIES);
}
/**
 * What to put in the box for a value that arrived from somewhere else.
 *
 * A number becomes its national form. Anything else is shown AS STORED — and that rule
 * is load-bearing: a phone column in this platform can hold a note («تماس با منشی»), and
 * seeding an unparseable value to `''` would make the stored content vanish from the
 * field the moment the record opened, after which any save would silently wipe it.
 * Showing what is stored, emitting nothing until the user types, and letting the filter
 * strip it on the first keystroke is the honest behaviour.
 *
 * A number whose country is outside the catalog has no national form to render, so its
 * E.164 stands in — the alternative is a blank box over a real stored number.
 */ const $5f69d84dab43bb31$var$seedDraft = (parsed, value, showTrunk = true)=>parsed.ok ? $5f69d84dab43bb31$var$spellNational(parsed, showTrunk) || parsed.e164 : typeof value === 'string' ? value : '';
/**
 * `national` with the country's trunk prefix off — `'09121234567'` → `'9121234567'`.
 * Also used on a country's `example`, which is written in national form too. A string
 * that does not begin with the trunk is returned unchanged: India's example is already
 * trunkless, and a country without a trunk has nothing to take off.
 */ const $5f69d84dab43bb31$var$withoutTrunk = (national, country)=>country?.trunk && national.startsWith(country.trunk) ? national.slice(country.trunk.length) : national;
/** The national form as this field spells it: with its trunk, or without (`showTrunk`). */ const $5f69d84dab43bb31$var$spellNational = (parsed, showTrunk)=>showTrunk ? parsed.national : $5f69d84dab43bb31$var$withoutTrunk(parsed.national, parsed.country);
/**
 * The country a value arriving from STORAGE is read in. Written internationally (`+…`,
 * `00…`) it names its own country and `fallback` only matters for a dial code outside
 * the catalog; written nationally it is Iranian — see "THE PRESELECTION FOLLOWS THE
 * LOCALE" in the header. Typing never goes through here.
 */ const $5f69d84dab43bb31$var$storedCountry = (value, fallback)=>{
    const compact = (0, $5AX1S.compactPhone)(value);
    if (compact === '' || compact.startsWith('+') || compact.startsWith('00')) return fallback;
    return 0, $5AX1S.DEFAULT_COUNTRY;
};
/** The characters `compactPhone` keeps. Counting these is how the caret survives a
 *  separator being filtered out from under it. */ const $5f69d84dab43bb31$var$isKept = (ch)=>ch >= '0' && ch <= '9' || ch === '+';
const $5f69d84dab43bb31$var$countKept = (s)=>(0, $5AX1S.compactPhone)(s).length;
const $5f69d84dab43bb31$var$PhoneInput = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ value: // Value — E.164 preferred, ANY legacy shape accepted (09…, +98…, 0098…, 98…, 9…,
// Persian/Arabic-Indic/fullwidth digits, separators, invisible marks).
value, onChange: onChange, onBlur: onBlur, // Country — `country` is controlled (pair it with `onCountryChange`),
// `defaultCountry` is the uncontrolled seed, itself defaulting to the locale's
// country (`countryForLocale`). A DEFAULT, never a lock.
country: countryProp, defaultCountry: defaultCountry, onCountryChange: onCountryChange, countries: // Narrow the offered list. Resolving to exactly ONE renders a static dial chip
// instead of a `<select>` — see below.
countries, allowLandline: // Drop the selected country's `nsnPattern` for this field: a supplier's or a
// clinic's number is an office line. Iran only, in practice.
allowLandline = false, showTrunk: // `false` spells the box without the trunk prefix — `9121234567` beside `+98`, not
// `09121234567`. Display only; what is emitted is unchanged. See the header.
showTrunk = true, // Locale — defaults to <html lang>, which every client sets via applyDocumentLocale.
locale: localeProp, messages: // Copy — each entry `string | (ctx) => string`, ctx = { country, countryName, example }.
messages, label: // Chrome — the same contract as TextInput.
label, countryLabel: countryLabel, required: required, error: externalError, helperText: helperText, disabled: disabled = false, className: // `className` merges onto the bordered SHELL — the element that carries the box,
// and the one a caller sizing this field inside a 170px column means. `style` is
// the FormField's and `inputStyle` the real input's, as in `MoneyInput`.
className, style: style, inputStyle: inputStyle, // Extra props (data-testid, aria-*, name…) land on the real control.
// §17.2 requires a kit component to forward them, and a past bug was exactly this.
...rest }, ref)=>{
    const kit = (0, $j9AxR.kitCopy)(localeProp).phone;
    if (label === undefined) label = kit.label;
    if (countryLabel === undefined) countryLabel = kit.country;
    const generatedId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const controlId = rest.id || generatedId;
    const innerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const caret = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // ASCII in state, the locale's numerals in the DOM. See the header.
    const numerals = (0, $hlTfq.numeralsFor)(localeProp || (0, $hlTfq.documentLocale)());
    const localize = (str)=>String(str ?? '').replace(/\d/g, (d)=>numerals.digits[Number(d)]);
    const options = $5f69d84dab43bb31$var$resolveList(countries);
    const preselected = defaultCountry !== undefined ? defaultCountry : (0, $5AX1S.countryForLocale)(localeProp);
    const base = $5f69d84dab43bb31$var$asCountry(countryProp !== undefined ? countryProp : preselected, options[0] || (0, $5AX1S.DEFAULT_COUNTRY));
    const shellRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const opts = {
        allowLandline: allowLandline
    };
    const spell = (p)=>$5f69d84dab43bb31$var$spellNational(p, showTrunk);
    const exampleFor = (c)=>showTrunk ? c.example : $5f69d84dab43bb31$var$withoutTrunk(c.example, c);
    // Draft and country live in ONE state object so a re-seed moves both atomically —
    // a load that changes the number and the country must never render half-applied.
    const [own, setOwn] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>{
        const parsed = (0, $5AX1S.parsePhone)(value, {
            ...opts,
            country: $5f69d84dab43bb31$var$storedCountry(value, base)
        });
        return {
            draft: $5f69d84dab43bb31$var$seedDraft(parsed, value, showTrunk),
            country: parsed.ok ? parsed.country : base
        };
    });
    const country = countryProp !== undefined ? base : own.country;
    const draft = own.draft;
    // Re-seed on a `value` PROP change only. Comparing the normalized forms is what keeps
    // a parent that echoes E.164 back from rewriting what the user is still typing;
    // comparing the raw prop is what still lets a parent clear the field.
    const prevValue = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(value);
    if (prevValue.current !== value) {
        prevValue.current = value;
        const incoming = (0, $5AX1S.parsePhone)(value, {
            ...opts,
            country: $5f69d84dab43bb31$var$storedCountry(value, country)
        });
        if (incoming.e164 !== (0, $5AX1S.parsePhone)(draft, {
            ...opts,
            country: country
        }).e164) setOwn({
            draft: $5f69d84dab43bb31$var$seedDraft(incoming, value, showTrunk),
            country: incoming.ok ? incoming.country : country
        });
    }
    const parsed = (0, $5AX1S.parsePhone)(draft, {
        ...opts,
        country: country
    });
    // An empty field is never an error unless the caller says it is required. Every other
    // problem is reported as it stands — including for a stored note, which genuinely is
    // not a phone number and is never silently cleared.
    const problem = parsed.problem === 'required' && !required ? null : parsed.problem;
    const copy = {
        ...$5f69d84dab43bb31$var$defaultMessages(localeProp),
        ...messages
    };
    const entry = problem ? copy[problem] : null;
    const internalError = typeof entry === 'function' ? entry({
        country: parsed.country,
        countryName: (0, $5AX1S.countryName)(parsed.country, localeProp),
        example: localize(exampleFor(parsed.country))
    }) : entry || '';
    // On blur only (`touched`), never while typing; an external `error` always wins; and
    // the error is ADVISORY — `onChange` still fires and the value is never cleared.
    const error = externalError || (touched ? internalError : '');
    const emit = (nextDraft, nextCountry)=>{
        const next = (0, $5AX1S.parsePhone)(nextDraft, {
            ...opts,
            country: nextCountry
        });
        onChange?.(next.e164, {
            ...next,
            draft: nextDraft
        });
    };
    const handleChange = (event)=>{
        const el = event.target;
        const raw = el.value;
        // How many KEPT characters sat left of the caret. The filter removes characters, so
        // a separator typed or pasted mid-string shifts every index after it. Copied from
        // `MoneyInput.jsx`, which carries the same loop and the largest caret suite in the
        // kit; the counting is the part that has to be right.
        const keptLeft = $5f69d84dab43bb31$var$countKept(raw.slice(0, el.selectionStart ?? raw.length));
        const compact = (0, $5AX1S.compactPhone)(raw);
        const international = compact.startsWith('+') || compact.startsWith('00');
        // The picker follows an EXPLICITLY international number and nothing else. A bare
        // national number means whatever the selected country says it means, so reading a
        // country out of it would be guessing. An international number whose dial code is
        // not in the catalog leaves the picker where it was — the list is not a gate.
        let nextCountry = country;
        if (international && countryProp === undefined) {
            const claimed = (0, $5AX1S.findByDialCode)(compact.startsWith('+') ? compact.slice(1) : compact.slice(2));
            if (claimed) nextCountry = claimed;
        }
        const next = (0, $5AX1S.parsePhone)(compact, {
            ...opts,
            country: nextCountry
        });
        // What you typed stays on screen — no rewrite under the cursor — with ONE exception:
        // a number written internationally is re-spelled nationally once it resolves,
        // because the dial code is now showing in the chip beside it and printing `+98`
        // twice in one field is not what the user wrote either.
        const nextDraft = international && next.ok && next.national ? spell(next) : compact;
        let pos = 0;
        let seen = 0;
        while(pos < nextDraft.length && seen < keptLeft){
            if ($5f69d84dab43bb31$var$isKept(nextDraft[pos])) seen++;
            pos++;
        }
        caret.current = pos;
        setOwn({
            draft: nextDraft,
            country: nextCountry
        });
        if (nextCountry !== country) onCountryChange?.(nextCountry);
        emit(nextDraft, nextCountry);
    };
    const handleCountry = (picked)=>{
        const next = $5f69d84dab43bb31$var$asCountry(picked, null);
        if (!next) return;
        // An explicit international prefix is rewritten in place; a bare national number is
        // left exactly as typed, because its MEANING changed the moment the country did.
        const compact = (0, $5AX1S.compactPhone)(draft);
        let nextDraft = draft;
        if (compact.startsWith(`+${country.dial}`)) nextDraft = `+${next.dial}${compact.slice(1 + country.dial.length)}`;
        else if (compact.startsWith(`00${country.dial}`)) nextDraft = `00${next.dial}${compact.slice(2 + country.dial.length)}`;
        setOwn({
            draft: nextDraft,
            country: next
        });
        onCountryChange?.(next);
        emit(nextDraft, next);
    };
    const handleBlur = (event)=>{
        setTouched(true);
        // The one moment where moving the caret costs nothing: a number that parses is
        // re-spelled in its national form, which is the field's confirmation that it
        // understood you. The login theme does not do this because a login field is left
        // immediately; a form field that is filled and then revisited is a different
        // surface. No emit — the canonical value has not changed.
        const spelled = parsed.ok ? spell(parsed) : '';
        if (spelled && spelled !== draft) setOwn((s)=>({
                ...s,
                draft: spelled
            }));
        onBlur?.(event);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(()=>{
        if (caret.current != null && innerRef.current) {
            innerRef.current.setSelectionRange(caret.current, caret.current);
            caret.current = null;
        }
    });
    const setRefs = (node)=>{
        innerRef.current = node;
        if (typeof ref === 'function') ref(node);
        else if (ref) ref.current = node;
    };
    // A list that resolves to exactly one country gets a static chip, not a picker with
    // a single row: no fake choice, no tab stop, and — the practical reason — it is what
    // keeps the whole field inside the 170px and 160px boxes `SetupViews.jsx` wraps it
    // in, and off the ~150px clipping `ProfileSection.jsx` records in its own comment.
    // Every other field gets `CountryPicker`: flag, dial code, a searchable list. The
    // flags are images, never emoji (rule 10) — see that file's header.
    const single = options.length === 1;
    const testid = rest['data-testid'];
    // The error/helper line, JOINED to whatever the caller already pointed the field at —
    // never replacing it. `FormField` is passed `htmlFor`, which tells it this component
    // owns its own aria wiring, so its own join (see FormField) does not run for this
    // field and this is the only place the two ids can meet.
    //
    // Written as one value rather than an attribute before `{...rest}`, because that order
    // means a caller's `aria-describedby` OVERWRITES the message id: the field goes red,
    // and a screen reader reads the caller's hint and never says why. `MoneyInput` already
    // does it this way, for the same reason.
    const describedBy = [
        rest['aria-describedby'],
        error || helperText ? `${controlId}-message` : null
    ].filter(Boolean).join(' ') || undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        htmlFor: controlId,
        label: label,
        required: required,
        error: error,
        helperText: helperText,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: shellRef,
        className: (0, $5JYPc.cn)('flex items-center h-11 rounded-lg overflow-hidden bg-white border-[1.5px]', 'transition-[border-color,box-shadow] duration-150', error ? 'border-destructive shadow-ring-red focus-within:shadow-ring-red' : 'border-border focus-within:border-primary focus-within:shadow-ring-navy', disabled && 'bg-muted cursor-not-allowed opacity-70', className)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: "ltr",
        className: "flex items-center w-full h-full [unicode-bidi:isolate]"
    }, single ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "flex items-center gap-1.5 h-full ps-3 pe-2 shrink-0 font-sans text-[0.84375rem] text-muted-foreground select-none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9sT7p.Flag), {
        iso2: country.iso2
    }), localize(`+${country.dial}`)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9sT7p.default), {
        value: country,
        // A number pasted from outside the offered list still selects its own
        // country — validation must be right even where the list is narrowed —
        // so the picker always offers the current row, even when not asked for.
        countries: options,
        onSelect: handleCountry,
        locale: localeProp,
        label: countryLabel,
        disabled: disabled,
        anchorRef: shellRef,
        "data-testid": testid ? `${testid}-country` : undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": "true",
        className: "w-px h-5 shrink-0 bg-border"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        id: controlId,
        "aria-invalid": error ? true : undefined,
        ...rest,
        // A caller's placeholder is an example NUMBER like the default, and the
        // catalogues spell it in ASCII as often as not — so it gets the page's
        // numerals too, rather than being the one Latin run left in the field.
        placeholder: localize(rest.placeholder ?? exampleFor(country)),
        // After `{...rest}`: the joined value is the one that must win, and it
        // already contains the caller's own.
        "aria-describedby": describedBy,
        ref: setRefs,
        type: "tel",
        inputMode: "tel",
        autoComplete: "tel",
        value: localize(draft),
        onChange: handleChange,
        onBlur: handleBlur,
        disabled: disabled,
        // The DOM `maxLength={11}` is gone: one attribute cannot express both a
        // national and an international shape, and 11 silently truncated every
        // number written as `+98…`. 20 is a cap no real number reaches after
        // filtering.
        maxLength: 20,
        className: (0, $5JYPc.cn)('flex-1 min-w-0 w-full h-full ps-2.5 pe-3.5 bg-transparent border-0 outline-none', 'font-sans text-[0.84375rem] text-foreground tracking-[0.5px]', 'disabled:cursor-not-allowed disabled:bg-transparent'),
        style: inputStyle
    }))));
});
$5f69d84dab43bb31$var$PhoneInput.displayName = 'PhoneInput';
var $5f69d84dab43bb31$export$2e2bcd8739ae039 = $5f69d84dab43bb31$var$PhoneInput;

});
parcelRegister("9sT7p", function(module, exports) {

$parcel$export(module.exports, "Flag", () => $7801a9372e554ab2$export$48ea269755562084);
$parcel$export(module.exports, "default", () => $7801a9372e554ab2$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $jTCZr = parcelRequire("jTCZr");

var $5AX1S = parcelRequire("5AX1S");

var $fMnXH = parcelRequire("fMnXH");

var $hlTfq = parcelRequire("hlTfq");

var $j9AxR = parcelRequire("j9AxR");
'use client';
// ─────────────────────────────────────────────────────────────────────────────
// CountryPicker — the country half of `PhoneInput`: a button showing the flag and the
// dial code, opening a searchable, flagged list (PM-0078).
//
// PORTED from the sign-in theme (`sso/parsina.keycloakify/src/login/components/
// CountryPicker.tsx`, 6c0f939), so a doctor finds their country the same way when
// signing in and when a desk registers them. Same contract: a combobox in the WAI-ARIA
// sense — the search box owns focus and points at the active row with
// `aria-activedescendant`, so a screen reader announces each row as the arrows move.
// Search matches a name in ALL five languages, accents folded on both sides, plus the
// dial code in any digit set: a Persian reader may still type an English name, a French
// one «etats» for «États-Unis», a German one «osterreich» for «Österreich», and «+۹۷۱»
// must find the Emirates.
//
// WHY NOT THE NATIVE <select> THIS REPLACED. It could not show flags — <option> takes no
// markup — and on Chrome/Edge for Windows its open list inherited the transparent face
// and showed blank rows (the theme hit both).
//
// FLAGS ARE IMAGES, NOT EMOJI. DESIGN.md rule 10 still holds: an emoji flag is drawn by
// the OS and Windows draws none. These are the theme's flag-icons, rasterised into
// `lib/flags.js` — a named exception in DESIGN_SYSTEM.md §15.
//
// WHERE THE LIST RENDERS — the one subtle thing here.
//   - On a page: portaled to <body>, `position: fixed`, so the field's own
//     `overflow: hidden` shell and a narrow sidebar card cannot clip it.
//   - Inside a dialog or a sheet (`[role="dialog"]`): portaled INTO that dialog,
//     `position: absolute`. A modal Radix dialog sets `pointer-events: none` on <body>
//     and yanks focus back from anything outside it, so a search box portaled to <body>
//     could never be typed into (JalaliDatePicker documents the same trap, and avoids
//     typing in its popup for that reason). Inside the dialog it is in the focus scope,
//     it is not an outside click, and the kit BottomSheet's Tab trap includes it.
//   z 9999 — the `JalaliDatePicker` popup's rung of DESIGN_SYSTEM.md §9.4: a field's
//   popup must sit above the Dialog (1100) the field is in.
// ─────────────────────────────────────────────────────────────────────────────
const $7801a9372e554ab2$var$Z = 9999;
const $7801a9372e554ab2$var$GAP = 6;
const $7801a9372e554ab2$var$EDGE = 8;
const $7801a9372e554ab2$var$PANEL_WIDTH = 300;
const $7801a9372e554ab2$var$LIST_MAX = 280;
function $7801a9372e554ab2$export$48ea269755562084({ iso2: iso2, size: size = 20 }) {
    const src = (0, $fMnXH.flagUrl)(iso2);
    const box = {
        width: size,
        height: Math.round(size * 3 / 4),
        borderRadius: 2,
        flexShrink: 0 /* a flag's own corner, not a token radius */ 
    };
    if (!src) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": "true",
        style: {
            ...box,
            display: 'inline-block',
            background: (0, $jTCZr.C).border
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: src,
        alt: "",
        "aria-hidden": "true",
        width: box.width,
        height: box.height,
        style: {
            ...box,
            display: 'block',
            objectFit: 'cover',
            boxShadow: `0 0 0 1px ${(0, $jTCZr.C).border}`
        }
    });
}
const $7801a9372e554ab2$var$sameCountry = (a, b)=>a?.iso2 === b?.iso2;
function $7801a9372e554ab2$export$3abcf2ef1ee51ab5({ value: value, onSelect: onSelect, countries: // The offered rows; the selected one is always offered even when narrowed out.
countries = (0, $5AX1S.COUNTRIES), locale: localeProp, label: label, disabled: disabled = false, // Where the panel is measured from — the whole field shell, so the list lines up
// with the box rather than with the 70px button. Defaults to the button.
anchorRef: anchorProp, showDial: // `false` shows the country's two-letter code instead of its dial code — for a
// field whose country is not a phone prefix (NationalIdInput).
showDial = true, 'data-testid': testid }) {
    const locale = localeProp || (0, $hlTfq.documentLocale)();
    const copy = (0, $j9AxR.kitCopy)(localeProp).phone;
    const ariaLabel = label ?? copy.country;
    const numerals = (0, $hlTfq.numeralsFor)(locale);
    const localize = (s)=>String(s).replace(/\d/g, (d)=>numerals.digits[Number(d)]);
    const rtl = [
        'fa',
        'ar'
    ].includes(String(locale).split('-')[0]);
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [query, setQuery] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [active, setActive] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    const [pos, setPos] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [host, setHost] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const buttonRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const panelRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const searchRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const listId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const optionId = (iso2)=>`${listId}-${iso2}`;
    // The locale's own country first (the answer for nearly every user), the rest in the
    // reader's alphabet.
    const ordered = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const rows = countries.some((c)=>$7801a9372e554ab2$var$sameCountry(c, value)) || !value ? countries : [
            value,
            ...countries
        ];
        const home = (0, $5AX1S.countryForLocale)(locale);
        const collator = new Intl.Collator(locale);
        const first = rows.filter((c)=>$7801a9372e554ab2$var$sameCountry(c, home));
        const rest = rows.filter((c)=>!$7801a9372e554ab2$var$sameCountry(c, home)).sort((a, b)=>collator.compare((0, $5AX1S.countryName)(a, locale), (0, $5AX1S.countryName)(b, locale)));
        return [
            ...first,
            ...rest
        ];
    }, [
        countries,
        value,
        locale
    ]);
    // The rule — dial code, ISO code, a name in any language with accents folded on both
    // sides — is `countryMatches` in lib/phone.js, where it is tested without a DOM.
    const matches = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>ordered.filter((c)=>(0, $5AX1S.countryMatches)(c, query)), [
        ordered,
        query
    ]);
    const show = ()=>{
        if (disabled) return;
        setQuery('');
        setActive(Math.max(ordered.findIndex((c)=>$7801a9372e554ab2$var$sameCountry(c, value)), 0));
        setOpen(true);
    };
    const hide = (returnFocus)=>{
        setOpen(false);
        if (returnFocus) buttonRef.current?.focus();
    };
    const choose = (country)=>{
        onSelect?.(country);
        hide(true);
    };
    // Place the panel against the anchor — in <body> with fixed coordinates, or inside
    // the enclosing dialog with coordinates relative to it (see the header).
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(()=>{
        if (!open) {
            setPos(null);
            return undefined;
        }
        const anchor = anchorProp?.current || buttonRef.current;
        const dialog = anchor?.closest?.('[role="dialog"]') || null;
        setHost(dialog || document.body);
        const place = ()=>{
            const a = (anchorProp?.current || buttonRef.current)?.getBoundingClientRect();
            if (!a) return;
            const vw = window.innerWidth;
            const vh = window.innerHeight;
            const width = Math.min(Math.max(a.width, $7801a9372e554ab2$var$PANEL_WIDTH), vw - $7801a9372e554ab2$var$EDGE * 2);
            // The button sits at the LEFT of the field in every direction (the phone run is
            // an LTR island), so the panel lines up with the field's left edge.
            const left = Math.min(Math.max($7801a9372e554ab2$var$EDGE, a.left), vw - width - $7801a9372e554ab2$var$EDGE);
            const below = vh - a.bottom - $7801a9372e554ab2$var$EDGE * 2;
            const above = a.top - $7801a9372e554ab2$var$EDGE * 2;
            const up = below < 220 && above > below;
            const listMax = Math.max(120, Math.min($7801a9372e554ab2$var$LIST_MAX, (up ? above : below) - 60));
            const top = up ? null : a.bottom + $7801a9372e554ab2$var$GAP;
            const bottom = up ? a.top - $7801a9372e554ab2$var$GAP : null;
            if (!dialog) {
                setPos({
                    position: 'fixed',
                    left: left,
                    width: width,
                    listMax: listMax,
                    top: top,
                    bottomFromTop: bottom,
                    up: up
                });
                return;
            }
            // Relative to the dialog's padding box, scrolled with its content.
            const d = dialog.getBoundingClientRect();
            const bx = dialog.clientLeft || 0;
            const by = dialog.clientTop || 0;
            setPos({
                position: 'absolute',
                left: left - d.left - bx + dialog.scrollLeft,
                width: width,
                listMax: listMax,
                top: top == null ? null : top - d.top - by + dialog.scrollTop,
                bottomFromTop: bottom == null ? null : bottom - d.top - by + dialog.scrollTop,
                up: up
            });
        };
        place();
        window.addEventListener('resize', place);
        window.addEventListener('scroll', place, true);
        return ()=>{
            window.removeEventListener('resize', place);
            window.removeEventListener('scroll', place, true);
        };
    }, [
        open,
        anchorProp
    ]);
    // Focus the search box once the panel exists.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (open && pos) searchRef.current?.focus({
            preventScroll: true
        });
    }, [
        open,
        pos != null
    ]);
    // Keep the active row in view.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return;
        const row = matches[active];
        if (row) document.getElementById(optionId(row.iso2))?.scrollIntoView?.({
            block: 'nearest'
        });
    }, [
        open,
        active,
        matches
    ]);
    // A press anywhere else closes it, the way a native list does.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return undefined;
        const onDown = (e)=>{
            if (panelRef.current?.contains(e.target) || buttonRef.current?.contains(e.target)) return;
            hide(false);
        };
        document.addEventListener('mousedown', onDown);
        document.addEventListener('touchstart', onDown);
        return ()=>{
            document.removeEventListener('mousedown', onDown);
            document.removeEventListener('touchstart', onDown);
        };
    }, [
        open
    ]);
    const onSearchKey = (e)=>{
        const last = matches.length - 1;
        switch(e.key){
            case 'ArrowDown':
                e.preventDefault();
                setActive((i)=>i >= last ? 0 : i + 1);
                break;
            case 'ArrowUp':
                e.preventDefault();
                setActive((i)=>i <= 0 ? last : i - 1);
                break;
            case 'Home':
                e.preventDefault();
                setActive(0);
                break;
            case 'End':
                e.preventDefault();
                setActive(last);
                break;
            case 'Enter':
                // Never submit the surrounding form from inside the picker.
                e.preventDefault();
                if (matches[active]) choose(matches[active]);
                break;
            case 'Escape':
                // Closes the list, not the dialog or sheet the field sits in.
                e.preventDefault();
                e.stopPropagation();
                e.nativeEvent?.stopImmediatePropagation?.();
                hide(true);
                break;
            case 'Tab':
                hide(false);
                break;
            default:
        }
    };
    const onButtonKey = (e)=>{
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            e.preventDefault();
            show();
        }
    };
    const activeRow = open ? matches[active] : undefined;
    const country = value || ordered[0];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        ref: buttonRef,
        disabled: disabled,
        "aria-label": `${ariaLabel}: ${(0, $5AX1S.countryName)(country, locale)}`,
        "aria-haspopup": "listbox",
        "aria-expanded": open,
        "aria-controls": open ? listId : undefined,
        "data-testid": testid,
        "data-country": country?.iso2,
        onClick: ()=>open ? hide(false) : show(),
        onKeyDown: onButtonKey,
        className: "flex items-center gap-1.5 h-full ps-3 pe-2 shrink-0 bg-transparent border-0 font-sans text-[0.84375rem] text-muted-foreground cursor-pointer select-none disabled:cursor-not-allowed outline-none focus-visible:bg-muted"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7801a9372e554ab2$export$48ea269755562084, {
        iso2: country?.iso2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, showDial ? localize(`+${country?.dial ?? ''}`) : country?.iso2 ?? ''), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        width: "12",
        height: "12",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m6 9 6 6 6-6"
    }))), open && pos && host && /*#__PURE__*/ (0, $1u0KT.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: panelRef,
        "data-jalali-popup": "",
        "data-testid": testid ? `${testid}-panel` : undefined,
        dir: rtl ? 'rtl' : 'ltr',
        style: {
            position: pos.position,
            left: pos.left,
            width: pos.width,
            ...pos.up ? {
                top: pos.bottomFromTop,
                transform: 'translateY(-100%)'
            } : {
                top: pos.top
            },
            zIndex: $7801a9372e554ab2$var$Z,
            background: 'white',
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: (0, $jTCZr.RADIUS).card,
            boxShadow: (0, $jTCZr.SHADOW).floating,
            padding: 6,
            boxSizing: 'border-box',
            pointerEvents: 'auto',
            fontFamily: 'Meshkat, sans-serif'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '0 10px',
            height: 40,
            borderRadius: (0, $jTCZr.RADIUS).control,
            background: (0, $jTCZr.C).bg,
            marginBottom: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        width: "16",
        height: "16",
        "aria-hidden": "true",
        style: {
            color: (0, $jTCZr.C).textMuted,
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "11",
        cy: "11",
        r: "7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m20 20-3.5-3.5"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ref: searchRef,
        type: "search",
        role: "combobox",
        "aria-expanded": "true",
        "aria-controls": listId,
        "aria-autocomplete": "list",
        "aria-activedescendant": activeRow ? optionId(activeRow.iso2) : undefined,
        "aria-label": copy.countrySearch,
        placeholder: copy.countrySearch,
        autoComplete: "off",
        spellCheck: false,
        value: query,
        "data-testid": testid ? `${testid}-search` : undefined,
        onChange: (e)=>{
            setQuery(e.target.value);
            setActive(0);
        },
        onKeyDown: onSearchKey,
        style: {
            flex: 1,
            minWidth: 0,
            height: '100%',
            border: 0,
            outline: 'none',
            background: 'transparent',
            fontFamily: 'inherit',
            fontSize: '0.84375rem',
            color: (0, $jTCZr.C).textPrimary
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        id: listId,
        role: "listbox",
        "aria-label": ariaLabel,
        style: {
            listStyle: 'none',
            margin: 0,
            padding: 0,
            maxHeight: pos.listMax,
            overflowY: 'auto',
            overscrollBehavior: 'contain'
        }
    }, matches.map((c, i)=>{
        const selected = $7801a9372e554ab2$var$sameCountry(c, value);
        const isActive = i === active;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: c.iso2,
            id: optionId(c.iso2),
            role: "option",
            "aria-selected": selected,
            "data-testid": testid ? `${testid}-option-${c.iso2}` : undefined,
            // mousedown, not click: keeps focus in the search box, so the
            // outside-press handler never sees it.
            onMouseDown: (e)=>{
                e.preventDefault();
                choose(c);
            },
            onMouseMove: ()=>setActive(i),
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                minHeight: 40,
                padding: '0 10px',
                borderRadius: (0, $jTCZr.RADIUS).control,
                cursor: 'pointer',
                fontSize: '0.84375rem',
                color: (0, $jTCZr.C).textPrimary,
                background: isActive ? (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.08) : 'transparent',
                fontWeight: selected ? 600 : 400
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7801a9372e554ab2$export$48ea269755562084, {
            iso2: c.iso2
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                flex: 1,
                minWidth: 0,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            }
        }, (0, $5AX1S.countryName)(c, locale)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "ltr",
            style: {
                color: (0, $jTCZr.C).textMuted,
                unicodeBidi: 'isolate'
            }
        }, localize(`+${c.dial}`)), selected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            strokeWidth: "3",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            width: "14",
            height: "14",
            "aria-hidden": "true",
            style: {
                color: (0, $jTCZr.C).navy,
                flexShrink: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M20 6 9 17l-5-5"
        })));
    }), matches.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        role: "presentation",
        style: {
            padding: '10px',
            fontSize: '0.8125rem',
            color: (0, $jTCZr.C).textMuted
        }
    }, copy.countryNoMatch))), host));
}
var $7801a9372e554ab2$export$2e2bcd8739ae039 = $7801a9372e554ab2$export$3abcf2ef1ee51ab5;

});
parcelRegister("jTCZr", function(module, exports) {

$parcel$export(module.exports, "C", () => $e7c165fb515b04ea$export$e7094788287c5e9b);
$parcel$export(module.exports, "CT", () => $e7c165fb515b04ea$export$4b57bfb4dade55bd);
$parcel$export(module.exports, "RADIUS", () => $e7c165fb515b04ea$export$2d2c9be8b5b863f);
$parcel$export(module.exports, "SHADOW", () => $e7c165fb515b04ea$export$98b6069deb71e13e);
$parcel$export(module.exports, "SKELETON", () => $e7c165fb515b04ea$export$169e587b68892b4e);
$parcel$export(module.exports, "SCRIM", () => $e7c165fb515b04ea$export$959fb1d648dd9e6c);
$parcel$export(module.exports, "GRADIENT_BRAND", () => $e7c165fb515b04ea$export$7deb2be06092489e);
$parcel$export(module.exports, "GRADIENT_BRAND_DARK", () => $e7c165fb515b04ea$export$4c2e201e0b6dbaa3);
$parcel$export(module.exports, "GRADIENT_SIDEBAR", () => $e7c165fb515b04ea$export$4a4d076b923f4e78);
$parcel$export(module.exports, "creditLevel", () => $e7c165fb515b04ea$export$2e1a2382662bd4ea);
$parcel$export(module.exports, "CREDIT_LEVEL_META", () => $e7c165fb515b04ea$export$83bdaf7cc3f6b0e7);
$parcel$export(module.exports, "creditColor", () => $e7c165fb515b04ea$export$3b48083d65d829ca);
$parcel$export(module.exports, "soft", () => $e7c165fb515b04ea$export$7bce9182245b1545);
$parcel$export(module.exports, "DEFAULT_THEME", () => $e7c165fb515b04ea$export$2faeed762aac6741);
$parcel$export(module.exports, "DEFAULT_FONT_SIZE", () => $e7c165fb515b04ea$export$b1461457ea2c1179);
$parcel$export(module.exports, "readStoredAppearance", () => $e7c165fb515b04ea$export$dde01dc24facb6b0);
$parcel$export(module.exports, "applyAppearance", () => $e7c165fb515b04ea$export$48c323151b232e54);
$parcel$export(module.exports, "storeAppearance", () => $e7c165fb515b04ea$export$64464588479aad90);
$parcel$export(module.exports, "statusColors", () => $e7c165fb515b04ea$export$6881c75116d5bd6e);
$parcel$export(module.exports, "chartPalette", () => $e7c165fb515b04ea$export$c7989e6ff0cf1179);
// ─────────────────────────────────────────────────────────────────────────────
// @parsina/tokens — the single source of truth for the Parsina design system.
//
// Canonical copy: /packages/tokens (monorepo root). Each client app receives a
// synced copy at src/shared/tokens via `python dev/sync_shared.py` — edit HERE,
// never in the synced copies.
//
// Three historical token systems (constants/theme.js `C`, constants/unifiedTheme.js
// `CT`, and per-app CSS vars) are collapsed into this module + tokens.css +
// tailwind.preset.js. Prefer Tailwind classes; `C`/`CT` exist for the screens
// still written with inline style objects.
// ─────────────────────────────────────────────────────────────────────────────

var $eLeza = parcelRequire("eLeza");
const $e7c165fb515b04ea$export$e7094788287c5e9b = {
    navy: 'var(--p-navy)',
    navyDark: 'var(--p-navy-dark)',
    navyLight: 'var(--p-navy-light)',
    red: '#D93025',
    redLight: '#F5E8E7',
    teal: 'var(--p-teal)',
    tealLight: 'var(--p-teal-light)',
    green: '#1A9B6C',
    greenLight: '#E6F5EF',
    amber: '#F59E0B',
    amberLight: '#FEF3C7',
    bg: '#f5f7fa',
    card: '#ffffff',
    border: '#eef0f3',
    textPrimary: '#1a2332',
    textSecondary: '#5a6780',
    textMuted: '#9aa3b0'
};
const $e7c165fb515b04ea$export$4b57bfb4dade55bd = {
    // Backgrounds
    bg: '#f5f7fa',
    surface: '#ffffff',
    surface2: '#f3f2f0',
    // Borders
    border: '#eef0f3',
    border2: '#ece9e4',
    // Text
    ink: '#1a2332',
    ink2: '#5a6780',
    mute: '#9aa3b0',
    mute2: '#b0aca3',
    // Accent (teal — logo top hue). Themed; see the note on `C`.
    accent: 'var(--p-teal)',
    accentInk: 'var(--p-navy-dark)',
    accentSoft: 'color-mix(in srgb, var(--p-teal) 12%, transparent)',
    // Good (green)
    good: '#1A9B6C',
    goodInk: '#166534',
    goodSoft: 'rgba(22,163,74,0.12)',
    // Warn (amber)
    warn: '#F59E0B',
    warnInk: '#92400e',
    warnSoft: 'rgba(217,119,6,0.12)',
    // Danger (red)
    danger: '#D93025',
    dangerInk: '#991b1b',
    dangerSoft: 'rgba(220,38,38,0.08)',
    // Legacy aliases (keep older code working)
    navy: 'var(--p-navy)',
    navyDark: 'var(--p-navy-dark)',
    navyLight: 'var(--p-navy-light)',
    teal: 'var(--p-teal)',
    tealLight: 'var(--p-teal-light)',
    green: '#1A9B6C',
    greenLight: '#E6F5EF',
    amber: '#F59E0B',
    amberLight: '#FEF3C7',
    red: '#D93025',
    redLight: '#F5E8E7',
    card: '#ffffff',
    textPrimary: '#1a2332',
    textSecondary: '#5a6780',
    textMuted: '#9aa3b0'
};
const $e7c165fb515b04ea$export$2d2c9be8b5b863f = {
    chip: 6,
    control: 10,
    card: 14,
    hero: 20,
    pill: 999
};
const $e7c165fb515b04ea$export$98b6069deb71e13e = {
    card: '0 1px 4px rgba(0,0,0,0.06)',
    floating: '0 8px 24px rgba(0,0,0,0.10)',
    modal: '0 25px 60px rgba(0,0,0,0.20)'
};
const $e7c165fb515b04ea$export$169e587b68892b4e = {
    base: '#e9ecf1',
    sheen: '#f6f7f9',
    // On a gradient header, the sidebar or a dark canvas: white-alpha blocks.
    onDark: 'rgba(255,255,255,0.14)',
    onDarkSheen: 'rgba(255,255,255,0.26)'
};
const $e7c165fb515b04ea$export$959fb1d648dd9e6c = 'rgba(28,27,24,0.55)';
const $e7c165fb515b04ea$export$7deb2be06092489e = 'var(--gradient-brand)';
const $e7c165fb515b04ea$export$4c2e201e0b6dbaa3 = 'var(--gradient-brand-dark)';
const $e7c165fb515b04ea$export$4a4d076b923f4e78 = 'var(--gradient-sidebar)';
const $e7c165fb515b04ea$export$18e630330c8bca65 = 50;
const $e7c165fb515b04ea$export$63b7f4b4938ce481 = 200;
function $e7c165fb515b04ea$export$2e1a2382662bd4ea(balance) {
    if (balance == null) return null;
    if (balance < $e7c165fb515b04ea$export$18e630330c8bca65) return 'low';
    if (balance < $e7c165fb515b04ea$export$63b7f4b4938ce481) return 'mid';
    return 'ok';
}
const $e7c165fb515b04ea$export$83bdaf7cc3f6b0e7 = {
    low: {
        color: $e7c165fb515b04ea$export$e7094788287c5e9b.red,
        tint: $e7c165fb515b04ea$export$e7094788287c5e9b.redLight,
        labelKey: 'credits.level.low',
        shortLabelKey: 'credits.level.lowShort'
    },
    mid: {
        color: $e7c165fb515b04ea$export$e7094788287c5e9b.amber,
        tint: $e7c165fb515b04ea$export$e7094788287c5e9b.amberLight,
        labelKey: 'credits.level.mid',
        shortLabelKey: 'credits.level.midShort'
    },
    ok: {
        color: $e7c165fb515b04ea$export$e7094788287c5e9b.green,
        tint: $e7c165fb515b04ea$export$e7094788287c5e9b.greenLight,
        labelKey: 'credits.level.ok',
        shortLabelKey: 'credits.level.okShort'
    }
};
function $e7c165fb515b04ea$export$3b48083d65d829ca(balance, fallback = $e7c165fb515b04ea$export$e7094788287c5e9b.textMuted) {
    const level = $e7c165fb515b04ea$export$2e1a2382662bd4ea(balance);
    return level ? $e7c165fb515b04ea$export$83bdaf7cc3f6b0e7[level].color : fallback;
}
const $e7c165fb515b04ea$export$7bce9182245b1545 = (color, alpha = 0.12)=>{
    if (typeof color !== 'string' || !color) return 'transparent';
    const c = color.trim();
    if (c.startsWith('var(') || c.startsWith('color-mix(')) {
        const pct = Math.max(0, Math.min(100, Math.round(alpha * 100)));
        return `color-mix(in srgb, ${c} ${pct}%, transparent)`;
    }
    const h = c.replace('#', '');
    const full = h.length === 3 ? h.split('').map((x)=>x + x).join('') : h;
    const n = parseInt(full, 16);
    if (!/^[0-9a-fA-F]{6}$/.test(full) || Number.isNaN(n)) return c;
    return `rgba(${n >> 16 & 255}, ${n >> 8 & 255}, ${n & 255}, ${alpha})`;
};
const $e7c165fb515b04ea$export$a1d018c6ed60ae4c = [
    {
        id: 'default',
        get label () {
            return `\u{622}\u{628}\u{6CC} ${(0, $eLeza.brandName)('fa')}`;
        },
        swatch: '#0173BE',
        swatch2: '#00BEB2'
    },
    {
        id: 'teal',
        label: "\u0641\u06CC\u0631\u0648\u0632\u0647\u200C\u0627\u06CC",
        swatch: '#00A99E',
        swatch2: '#0173BE'
    },
    {
        id: 'ocean',
        label: "\u0644\u0627\u062C\u0648\u0631\u062F\u06CC",
        swatch: '#0A5C8A',
        swatch2: '#0E8F9E'
    },
    {
        id: 'slate',
        label: "\u062E\u0627\u06A9\u0633\u062A\u0631\u06CC \u0622\u0628\u06CC",
        swatch: '#3F5E75',
        swatch2: '#5C8A9E'
    }
];
const $e7c165fb515b04ea$export$7634868d3a6a0a2e = {
    doctor: {
        label: "\u067E\u0646\u0644 \u067E\u0632\u0634\u06A9",
        primary: '#0173BE',
        ink: '#083250'
    },
    clinic: {
        label: "\u067E\u0646\u0644 \u06A9\u0644\u06CC\u0646\u06CC\u06A9",
        primary: '#0A4F8F',
        ink: '#062F57'
    },
    patient: {
        label: "\u067E\u0631\u0648\u0646\u062F\u0647 \u0633\u0644\u0627\u0645\u062A \u0645\u0646",
        primary: '#007C8C',
        ink: '#06363F'
    },
    dentist: {
        label: "\u067E\u0646\u0644 \u062F\u0646\u062F\u0627\u0646\u200C\u067E\u0632\u0634\u06A9\u06CC",
        primary: '#007D74',
        ink: '#063F3C'
    }
};
function $e7c165fb515b04ea$export$32d6efa0a3310091(panel) {
    const id = $e7c165fb515b04ea$export$7634868d3a6a0a2e[panel];
    if (!id) return $e7c165fb515b04ea$export$a1d018c6ed60ae4c;
    return $e7c165fb515b04ea$export$a1d018c6ed60ae4c.map((t)=>t.id === 'default' ? {
            ...t,
            label: "\u0631\u0646\u06AF \u067E\u0646\u0644",
            swatch: id.primary
        } : t);
}
const $e7c165fb515b04ea$export$58c32c962db85532 = [
    {
        id: 'small',
        label: "\u06A9\u0648\u0686\u06A9"
    },
    {
        id: 'medium',
        label: "\u0645\u062A\u0648\u0633\u0637"
    },
    {
        id: 'large',
        label: "\u0628\u0632\u0631\u06AF"
    }
];
const $e7c165fb515b04ea$export$2faeed762aac6741 = 'default';
const $e7c165fb515b04ea$export$b1461457ea2c1179 = 'medium';
const $e7c165fb515b04ea$export$888c18c43ead4265 = (id)=>$e7c165fb515b04ea$export$a1d018c6ed60ae4c.some((t)=>t.id === id);
const $e7c165fb515b04ea$export$5414ec5c49c0af0f = (id)=>$e7c165fb515b04ea$export$58c32c962db85532.some((f)=>f.id === id);
const $e7c165fb515b04ea$export$ff61b65939f754cc = 'parsina.appearance';
function $e7c165fb515b04ea$export$dde01dc24facb6b0(storage) {
    const store = storage ?? (typeof localStorage !== 'undefined' ? localStorage : null);
    try {
        const raw = store?.getItem($e7c165fb515b04ea$export$ff61b65939f754cc);
        const parsed = raw ? JSON.parse(raw) : null;
        return {
            theme: $e7c165fb515b04ea$export$888c18c43ead4265(parsed?.theme) ? parsed.theme : $e7c165fb515b04ea$export$2faeed762aac6741,
            fontSize: $e7c165fb515b04ea$export$5414ec5c49c0af0f(parsed?.fontSize) ? parsed.fontSize : $e7c165fb515b04ea$export$b1461457ea2c1179
        };
    } catch  {
        // Private mode, quota, or a corrupt value — fall back rather than throw.
        return {
            theme: $e7c165fb515b04ea$export$2faeed762aac6741,
            fontSize: $e7c165fb515b04ea$export$b1461457ea2c1179
        };
    }
}
function $e7c165fb515b04ea$export$48c323151b232e54({ theme: theme, fontSize: fontSize } = {}, doc) {
    const root = (doc ?? (typeof document !== 'undefined' ? document : null))?.documentElement;
    if (!root) return {
        theme: $e7c165fb515b04ea$export$2faeed762aac6741,
        fontSize: $e7c165fb515b04ea$export$b1461457ea2c1179
    };
    const resolved = {
        theme: $e7c165fb515b04ea$export$888c18c43ead4265(theme) ? theme : $e7c165fb515b04ea$export$2faeed762aac6741,
        fontSize: $e7c165fb515b04ea$export$5414ec5c49c0af0f(fontSize) ? fontSize : $e7c165fb515b04ea$export$b1461457ea2c1179
    };
    root.setAttribute('data-theme', resolved.theme);
    root.setAttribute('data-font-size', resolved.fontSize);
    return resolved;
}
function $e7c165fb515b04ea$export$64464588479aad90(appearance, storage) {
    const store = storage ?? (typeof localStorage !== 'undefined' ? localStorage : null);
    try {
        store?.setItem($e7c165fb515b04ea$export$ff61b65939f754cc, JSON.stringify(appearance));
    } catch  {
    // Persisting the cache is best-effort; the server copy is the real record.
    }
}
const $e7c165fb515b04ea$export$6881c75116d5bd6e = {
    // Appointment lifecycle, in the scheduling service's own vocabulary and with the
    // same Persian labels the clinic day panel uses — the desk and the doctor must not
    // call the same patient two different things.
    scheduled: {
        bg: '#F1F5F9',
        text: '#475569',
        label: "\u0646\u0648\u0628\u062A\u200C\u062F\u0627\u0631"
    },
    arrived: {
        bg: '#D1FAE5',
        text: '#065F46',
        label: "\u062D\u0627\u0636\u0631"
    },
    in_visit: {
        bg: '#DBEAFE',
        text: '#1E40AF',
        label: "\u062F\u0631 \u062D\u0627\u0644 \u0648\u06CC\u0632\u06CC\u062A"
    },
    completed: {
        bg: '#D1FAE5',
        text: '#065F46',
        label: "\u0648\u06CC\u0632\u06CC\u062A\u200C\u0634\u062F\u0647"
    },
    cancelled: {
        bg: '#FEE2E2',
        text: '#991B1B',
        label: "\u0644\u063A\u0648 \u0634\u062F\u0647"
    },
    // A booked patient who never arrived. Distinct from `cancelled` — nobody
    // cancelled it — and neutral rather than red, because it is a fact about the
    // past, not a problem to act on. The patient app used to fork its own badge
    // for exactly this key (§1.1: missing keys get added here, never re-created
    // locally).
    no_show: {
        bg: '#F1F5F9',
        text: '#64748B',
        label: "\u0639\u062F\u0645 \u062D\u0636\u0648\u0631"
    },
    // ── Patient-originated requests (docs/PATIENT_CLINIC_CARE_CONTEXT_AND_SELF_SERVICE_DESIGN.md §3) ──
    // A patient asked for this slot from the app and the clinic has not answered yet.
    // It HOLDS the slot, so it is a real appointment state and belongs here — amber
    // because it is work waiting on the desk, not a settled fact.
    requested: {
        bg: '#FEF3C7',
        text: '#92400E',
        label: "\u062F\u0631 \u0627\u0646\u062A\u0638\u0627\u0631 \u062A\u0623\u06CC\u06CC\u062F \u06A9\u0644\u06CC\u0646\u06CC\u06A9"
    },
    // The clinic declined the request, or it expired unanswered. Terminal and neutral:
    // like `no_show`, it is a fact about the past rather than a problem to act on.
    rejected: {
        bg: '#F1F5F9',
        text: '#64748B',
        label: "\u0631\u062F \u0634\u062F\u0647"
    },
    // Patient-record statuses (Patients / PatientDetail screens), a different domain.
    waiting: {
        bg: '#FEF3C7',
        text: '#92400E',
        label: "\u062F\u0631 \u0627\u0646\u062A\u0638\u0627\u0631"
    },
    visited: {
        bg: '#D1FAE5',
        text: '#065F46',
        label: "\u0648\u06CC\u0632\u06CC\u062A \u0634\u062F"
    },
    inprogress: {
        bg: '#DBEAFE',
        text: '#1E40AF',
        label: "\u062F\u0631 \u062D\u0627\u0644 \u0648\u06CC\u0632\u06CC\u062A"
    }
};
const $e7c165fb515b04ea$export$c7989e6ff0cf1179 = [
    '#0173BE',
    '#00BEB2',
    '#F59E0B',
    '#7C4DBE'
];
const $e7c165fb515b04ea$export$6ee8bfc459aebd80 = {
    acquired: $e7c165fb515b04ea$export$c7989e6ff0cf1179[0],
    converted: $e7c165fb515b04ea$export$c7989e6ff0cf1179[1],
    lost: $e7c165fb515b04ea$export$c7989e6ff0cf1179[2],
    recovered: $e7c165fb515b04ea$export$c7989e6ff0cf1179[3]
};

});

parcelRegister("5AX1S", function(module, exports) {

$parcel$export(module.exports, "foldDigits", () => $412e1a8a99c19c1a$export$522be3011864bb18);
$parcel$export(module.exports, "SEPARATORS", () => $412e1a8a99c19c1a$export$bc4e24532d262f45);
$parcel$export(module.exports, "compactPhone", () => $412e1a8a99c19c1a$export$2ae1a93e018170a7);
$parcel$export(module.exports, "COUNTRIES", () => $412e1a8a99c19c1a$export$4d78c43b7fa734a7);
$parcel$export(module.exports, "DEFAULT_COUNTRY", () => $412e1a8a99c19c1a$export$84b76667b0a9e7b4);
$parcel$export(module.exports, "countryForLocale", () => $412e1a8a99c19c1a$export$7684f8e22afec32c);
$parcel$export(module.exports, "findByIso2", () => $412e1a8a99c19c1a$export$586b3eaa727579f5);
$parcel$export(module.exports, "findByDialCode", () => $412e1a8a99c19c1a$export$21894a57509f6ed5);
$parcel$export(module.exports, "countryName", () => $412e1a8a99c19c1a$export$3162e773cd568eb);
$parcel$export(module.exports, "countryMatches", () => $412e1a8a99c19c1a$export$10dfaa5ff1ea39fa);
$parcel$export(module.exports, "parsePhone", () => $412e1a8a99c19c1a$export$48c6adddc5539199);
$parcel$export(module.exports, "normalizePhone", () => $412e1a8a99c19c1a$export$e9b617754cf28d84);
$parcel$export(module.exports, "isValidPhone", () => $412e1a8a99c19c1a$export$f9c4d85d720ef909);
$parcel$export(module.exports, "toNational", () => $412e1a8a99c19c1a$export$317852993b4735b6);
$parcel$export(module.exports, "forDisplay", () => $412e1a8a99c19c1a$export$1069b069fb83ae5b);
$parcel$export(module.exports, "maskPhone", () => $412e1a8a99c19c1a$export$1f64b92865689d0d);
$parcel$export(module.exports, "telHref", () => $412e1a8a99c19c1a$export$d2b3d97ad6239e3e);
$parcel$export(module.exports, "lookupVariants", () => $412e1a8a99c19c1a$export$493e0fb9b5aae030);
// Phone numbers, reduced to one canonical form — and read back in whatever form a
// human wants to look at.
//
// ═══════════════════════════════════════════════════════════════════════════════
// THE THREE SIBLINGS OF THIS FILE
//
//   microservices/parsina.patientmanagement.microservice/app/domain/phone.py
//       `normalize_phone` — the matching key behind `patients.phone_normalized`.
//       Iran only. Its tests are tests/test_phone.py.
//   sso/parsina.keycloakify/spi/src/main/java/ir/parsinabot/keycloak/phoneotp/PhoneNumbers.java
//       `normalize` / `toNational` / `lookupVariants` / `mask`, inside the Keycloak
//       authenticator. Iran only. Its tests are PhoneNumbersTest.java.
//   sso/parsina.keycloakify/src/login/lib/{countries.ts,phone.ts}
//       The login screen's country-aware picker and E.164 parse. 62 countries,
//       Iran first, "the list is a convenience, never a gate". Its flags are the
//       ones `flags.js` rasterises (PM-0078).
//
// This module is the fourth hand-rolled implementation of the same rules, and it is
// deliberate. Keycloak is a Java process that cannot import Python; the login theme
// cannot `npm install @parsina/framework` (its own `digits.ts` header says why); the
// alembic backfill re-implements the rules in SQL on purpose, because a migration is a
// historical record of what a database was actually given and must not change meaning
// when a source file changes. What holds them together is not a shared module — it is a
// shared CASE TABLE. `PhoneNumbersTest` carries `test_phone.py`'s cases, `test_phone.py`
// carries the migration's, and `ui/lib/phone.test.js` beside this file carries
// `test_phone.py`'s. Adding a country is one row here and one row in `countries.ts`.
//
// ═══════════════════════════════════════════════════════════════════════════════
// WHY THIS EXISTS AT ALL
//
// A phone number is the only handle joining a walk-in patient record — typed at the
// clinic desk, on paper, in a hurry — to the Keycloak account that person later
// registers with themselves. The two are typed by different people, years apart, in
// whatever form each found natural: the desk's Persian-digit spelling, and
// `+98 912 345 6789` in the signup form. Compared literally they are two different
// strings and the match never happens — which is how a doctor whose realm record held
// `+989199118259` ended up with a SECOND account when a desk typed `09199118259`.
//
// So the canonical form is E.164 — `+`, country code, national significant number, ASCII
// digits and nothing else — and every comparison goes through `normalizePhone`.
//
// ═══════════════════════════════════════════════════════════════════════════════
// THE ONE PROMISE THIS FILE MAKES
//
//   With no options, `normalizePhone` is byte-identical to `phone.py#normalize_phone`
//   and `PhoneNumbers.normalize` for EVERY INPUT — not merely for the rows of
//   tests/test_phone.py — and is idempotent.
//
// "Every input" and "every row of the table" are not the same promise, and the weaker one
// was not enough: 74 real Iranian ranges written as `+9901234567` came back as
// `+9901234567` while both twins answered `+989901234567`, and 61 spellings the twins
// accept (`+0…`, `+00…`, `00<national>`, `+<national>`) were refused outright. Every one
// of those passed a green suite, because none of them was a row in the table.
//
// So the twins' algorithm is not APPROXIMATED here by a catalog that happens to contain
// Iran — it is TRANSCRIBED, in `peelIranianMobile`, and runs before the catalog is
// consulted at all. Everything else — countries, landlines, the picker — is the
// generalisation layered around it, and reaches a string only once the peel has declined
// it. `phone.test.js` executes the two implementations against each other over a
// generated corpus, so the promise is checked rather than asserted.
//
// ═══════════════════════════════════════════════════════════════════════════════
// TWO JOBS, NOT ONE
//
// `compactPhone` is LENIENT and `parsePhone` is STRICT, and the split is on purpose:
//
//   - A FIELD filters what a human may put in a box. Typing a word after a number should
//     make the letters simply not appear — the user watches them not arrive and nothing
//     is "rejected". That is `compactPhone`, and `PhoneInput` is its only real caller.
//   - A CANONICALISER judges a string that arrived from a database, an import or another
//     system, and can afford to refuse: `"09123456789abc"` is not a number with junk on
//     it, it is a string we do not understand, and guessing would be worse than
//     declining. That is `parsePhone`, and everything else calls it.
//
// Every non-field caller wants the second one.
//
// ═══════════════════════════════════════════════════════════════════════════════
// AND A THIRD JOB: READING
//
// DISPLAYING A PHONE IS NOT VALIDATING IT.
//
// `parsePhone`/`normalizePhone`/`isValidPhone`/`toNational` all JUDGE — they are the
// converters, and `''` is a verdict they are entitled to return. A READ SURFACE is not
// entitled to it. The value is already in the column; somebody stored it; a person is
// looking at the screen for it. Showing nothing, or showing `+98…` where a human expects
// `021…`, is the only way a read can fail.
//
// So every read goes through `forDisplay`, which is `toNational` with `allowLandline`
// ALWAYS on and the raw value as its fallback, and which therefore never blanks and never
// refuses. Restricting to mobiles belongs on the INPUT — `PhoneInput`, where a desk is
// still typing — and has no meaning at all on a value already written.
//
// The exports, by which job they do:
//
//   INPUT (lenient, shapes a keystroke)   compactPhone, foldDigits
//   CONVERT/VALIDATE (strict, may refuse) parsePhone, normalizePhone, isValidPhone,
//                                         toNational, lookupVariants
//   READ (never refuses)                  forDisplay, maskPhone
//   CATALOG                               COUNTRIES, DEFAULT_COUNTRY, findByIso2,
//                                         findByDialCode, countryName,
//                                         countryMatches, countryForLocale,
//                                         SEPARATORS
// The extension is NOT optional here, and the omission was a real break.
//
// The barrel resolves either spelling because a bundler is doing the resolving.
// But this module is imported DIRECTLY by DOM-free logic that runs under Node's
// own ESM resolver — the patient and student apps do exactly that, deliberately,
// so a `node` test environment does not pull raw JSX through the barrel. Node
// does not guess extensions, so `'./money'` failed there with
// ERR_MODULE_NOT_FOUND naming a file that plainly exists.

var $hlTfq = parcelRequire("hlTfq");

var $eLeza = parcelRequire("eLeza");
// ─────────────────────────────────────────────────────────────────────────────
// Digits
// ─────────────────────────────────────────────────────────────────────────────
/** Persian U+06F0–U+06F9 — the default on an Iranian keyboard. */ const $412e1a8a99c19c1a$var$FA_ZERO = 0x06f0;
/** Arabic-Indic U+0660–U+0669 — Arabic-locale keyboards and some legacy imports. */ const $412e1a8a99c19c1a$var$AR_ZERO = 0x0660;
/** Fullwidth U+FF10–U+FF19 — emitted by some IME keyboards. */ const $412e1a8a99c19c1a$var$FW_ZERO = 0xff10;
function $412e1a8a99c19c1a$export$522be3011864bb18(raw) {
    if (typeof raw !== 'string') return '';
    let out = '';
    for(let i = 0; i < raw.length; i++){
        const c = raw.charCodeAt(i);
        if (c >= $412e1a8a99c19c1a$var$FA_ZERO && c <= $412e1a8a99c19c1a$var$FA_ZERO + 9) out += String.fromCharCode(48 + (c - $412e1a8a99c19c1a$var$FA_ZERO));
        else if (c >= $412e1a8a99c19c1a$var$AR_ZERO && c <= $412e1a8a99c19c1a$var$AR_ZERO + 9) out += String.fromCharCode(48 + (c - $412e1a8a99c19c1a$var$AR_ZERO));
        else if (c >= $412e1a8a99c19c1a$var$FW_ZERO && c <= $412e1a8a99c19c1a$var$FW_ZERO + 9) out += String.fromCharCode(48 + (c - $412e1a8a99c19c1a$var$FW_ZERO));
        else out += raw[i];
    }
    return out;
}
const $412e1a8a99c19c1a$export$bc4e24532d262f45 = " 	\r\n\f\v\xa0\u202F\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u205F\u3000\u200B\u200C\u200D\u200E\u200F\u061C\uFEFF-\u2010\u2011\u2012\u2013\u2014\u2015\u2212()[]{}<>._/\\|,;:*#'\"`"; // everything else a desk has been seen to type
const $412e1a8a99c19c1a$var$SEPARATOR_SET = new Set($412e1a8a99c19c1a$export$bc4e24532d262f45.split(''));
const $412e1a8a99c19c1a$var$stripSeparators = (s)=>{
    let out = '';
    for(let i = 0; i < s.length; i++)if (!$412e1a8a99c19c1a$var$SEPARATOR_SET.has(s[i])) out += s[i];
    return out;
};
/**
 * What must remain once decoration is gone: digits, optionally introduced by ONE leading
 * `+`. Anything else — a letter, a second `+`, an interior symbol we did not list — means
 * this string is not a phone number.
 */ const $412e1a8a99c19c1a$var$DIGITS_ONLY = /^\+?[0-9]+$/;
/**
 * The national significant number of an Iranian mobile: ten digits, the first a 9.
 * `phone.py#_IR_MOBILE` character for character (`\d` and `[0-9]` are the same set here,
 * and Iran's catalog row spells the same rule `/^9\d{9}$/`).
 *
 * It is written out separately from that row because the twins' peel below is not a
 * catalog lookup and must not become one — see `peelIranianMobile`.
 */ const $412e1a8a99c19c1a$var$IR_MOBILE = /^9[0-9]{9}$/;
/** E.164 caps the whole number — country code included — at 15 digits. The floor is a
 *  sanity bound, not a standard: no plan in this catalog is shorter. */ const $412e1a8a99c19c1a$var$E164_MIN_DIGITS = 7;
const $412e1a8a99c19c1a$var$E164_MAX_DIGITS = 15;
function $412e1a8a99c19c1a$export$2ae1a93e018170a7(raw) {
    const ascii = $412e1a8a99c19c1a$var$stripSeparators($412e1a8a99c19c1a$export$522be3011864bb18(raw));
    const prefix = ascii.startsWith('+') ? '+' : '';
    return prefix + ascii.replace(/\D/g, '');
}
const $412e1a8a99c19c1a$export$4d78c43b7fa734a7 = Object.freeze([
    Object.freeze({
        iso2: 'IR',
        dial: '98',
        en: 'Iran',
        fa: "\u0627\u06CC\u0631\u0627\u0646",
        ar: "\u0625\u064A\u0631\u0627\u0646",
        fr: 'Iran',
        de: 'Iran',
        trunk: '0',
        nsnMin: 10,
        nsnMax: 10,
        nsnPattern: /^9\d{9}$/,
        example: '09121234567'
    }),
    Object.freeze({
        iso2: 'AF',
        dial: '93',
        en: 'Afghanistan',
        fa: "\u0627\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646",
        ar: "\u0623\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646",
        fr: 'Afghanistan',
        de: 'Afghanistan',
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0701234567'
    }),
    Object.freeze({
        iso2: 'DZ',
        dial: '213',
        en: 'Algeria',
        fa: "\u0627\u0644\u062C\u0632\u0627\u06CC\u0631",
        ar: "\u0627\u0644\u062C\u0632\u0627\u0626\u0631",
        fr: "Alg\xe9rie",
        de: 'Algerien',
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0551234567'
    }),
    Object.freeze({
        iso2: 'AM',
        dial: '374',
        en: 'Armenia',
        fa: "\u0627\u0631\u0645\u0646\u0633\u062A\u0627\u0646",
        ar: "\u0623\u0631\u0645\u064A\u0646\u064A\u0627",
        fr: "Arm\xe9nie",
        de: 'Armenien',
        trunk: '0',
        nsnMin: 8,
        nsnMax: 8,
        example: '077123456'
    }),
    Object.freeze({
        iso2: 'AU',
        dial: '61',
        en: 'Australia',
        fa: "\u0627\u0633\u062A\u0631\u0627\u0644\u06CC\u0627",
        ar: "\u0623\u0633\u062A\u0631\u0627\u0644\u064A\u0627",
        fr: 'Australie',
        de: 'Australien',
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0412345678'
    }),
    Object.freeze({
        iso2: 'AT',
        dial: '43',
        en: 'Austria',
        fa: "\u0627\u062A\u0631\u06CC\u0634",
        ar: "\u0627\u0644\u0646\u0645\u0633\u0627",
        fr: 'Autriche',
        de: "\xd6sterreich",
        trunk: '0',
        nsnMin: 7,
        nsnMax: 13,
        example: '06641234567'
    }),
    Object.freeze({
        iso2: 'AZ',
        dial: '994',
        en: 'Azerbaijan',
        fa: "\u0622\u0630\u0631\u0628\u0627\u06CC\u062C\u0627\u0646",
        ar: "\u0623\u0630\u0631\u0628\u064A\u062C\u0627\u0646",
        fr: "Azerba\xefdjan",
        de: 'Aserbaidschan',
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0401234567'
    }),
    Object.freeze({
        iso2: 'BH',
        dial: '973',
        en: 'Bahrain',
        fa: "\u0628\u062D\u0631\u06CC\u0646",
        ar: "\u0627\u0644\u0628\u062D\u0631\u064A\u0646",
        fr: "Bahre\xefn",
        de: 'Bahrain',
        nsnMin: 8,
        nsnMax: 8,
        example: '36001234'
    }),
    Object.freeze({
        iso2: 'BE',
        dial: '32',
        en: 'Belgium',
        fa: "\u0628\u0644\u0698\u06CC\u06A9",
        ar: "\u0628\u0644\u062C\u064A\u0643\u0627",
        fr: 'Belgique',
        de: 'Belgien',
        trunk: '0',
        nsnMin: 8,
        nsnMax: 9,
        example: '0470123456'
    }),
    Object.freeze({
        iso2: 'BR',
        dial: '55',
        en: 'Brazil',
        fa: "\u0628\u0631\u0632\u06CC\u0644",
        ar: "\u0627\u0644\u0628\u0631\u0627\u0632\u064A\u0644",
        fr: "Br\xe9sil",
        de: 'Brasilien',
        trunk: '0',
        nsnMin: 10,
        nsnMax: 11,
        example: '11912345678'
    }),
    Object.freeze({
        iso2: 'CA',
        dial: '1',
        en: 'Canada',
        fa: "\u06A9\u0627\u0646\u0627\u062F\u0627",
        ar: "\u0643\u0646\u062F\u0627",
        fr: 'Canada',
        de: 'Kanada',
        nsnMin: 10,
        nsnMax: 10,
        example: '4165550123'
    }),
    Object.freeze({
        iso2: 'CN',
        dial: '86',
        en: 'China',
        fa: "\u0686\u06CC\u0646",
        ar: "\u0627\u0644\u0635\u064A\u0646",
        fr: 'Chine',
        de: 'China',
        trunk: '0',
        nsnMin: 7,
        nsnMax: 12,
        example: '13123456789'
    }),
    Object.freeze({
        iso2: 'CY',
        dial: '357',
        en: 'Cyprus',
        fa: "\u0642\u0628\u0631\u0633",
        ar: "\u0642\u0628\u0631\u0635",
        fr: 'Chypre',
        de: 'Zypern',
        nsnMin: 8,
        nsnMax: 8,
        example: '96123456'
    }),
    Object.freeze({
        iso2: 'DK',
        dial: '45',
        en: 'Denmark',
        fa: "\u062F\u0627\u0646\u0645\u0627\u0631\u06A9",
        ar: "\u0627\u0644\u062F\u0646\u0645\u0627\u0631\u0643",
        fr: 'Danemark',
        de: "D\xe4nemark",
        nsnMin: 8,
        nsnMax: 8,
        example: '20123456'
    }),
    Object.freeze({
        iso2: 'EG',
        dial: '20',
        en: 'Egypt',
        fa: "\u0645\u0635\u0631",
        ar: "\u0645\u0635\u0631",
        fr: "\xc9gypte",
        de: "\xc4gypten",
        trunk: '0',
        nsnMin: 10,
        nsnMax: 10,
        example: '01001234567'
    }),
    Object.freeze({
        iso2: 'FI',
        dial: '358',
        en: 'Finland',
        fa: "\u0641\u0646\u0644\u0627\u0646\u062F",
        ar: "\u0641\u0646\u0644\u0646\u062F\u0627",
        fr: 'Finlande',
        de: 'Finnland',
        trunk: '0',
        nsnMin: 6,
        nsnMax: 12,
        example: '0401234567'
    }),
    Object.freeze({
        iso2: 'FR',
        dial: '33',
        en: 'France',
        fa: "\u0641\u0631\u0627\u0646\u0633\u0647",
        ar: "\u0641\u0631\u0646\u0633\u0627",
        fr: 'France',
        de: 'Frankreich',
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0612345678'
    }),
    Object.freeze({
        iso2: 'GE',
        dial: '995',
        en: 'Georgia',
        fa: "\u06AF\u0631\u062C\u0633\u062A\u0627\u0646",
        ar: "\u062C\u0648\u0631\u062C\u064A\u0627",
        fr: "G\xe9orgie",
        de: 'Georgien',
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '555123456'
    }),
    Object.freeze({
        iso2: 'DE',
        dial: '49',
        en: 'Germany',
        fa: "\u0622\u0644\u0645\u0627\u0646",
        ar: "\u0623\u0644\u0645\u0627\u0646\u064A\u0627",
        fr: 'Allemagne',
        de: 'Deutschland',
        trunk: '0',
        nsnMin: 6,
        nsnMax: 12,
        example: '015112345678'
    }),
    Object.freeze({
        iso2: 'GR',
        dial: '30',
        en: 'Greece',
        fa: "\u06CC\u0648\u0646\u0627\u0646",
        ar: "\u0627\u0644\u064A\u0648\u0646\u0627\u0646",
        fr: "Gr\xe8ce",
        de: 'Griechenland',
        nsnMin: 10,
        nsnMax: 10,
        example: '6912345678'
    }),
    Object.freeze({
        iso2: 'HU',
        dial: '36',
        en: 'Hungary',
        fa: "\u0645\u062C\u0627\u0631\u0633\u062A\u0627\u0646",
        ar: "\u0627\u0644\u0645\u062C\u0631",
        fr: 'Hongrie',
        de: 'Ungarn',
        trunk: '06',
        nsnMin: 8,
        nsnMax: 9,
        example: '06201234567'
    }),
    Object.freeze({
        iso2: 'IN',
        dial: '91',
        en: 'India',
        fa: "\u0647\u0646\u062F",
        ar: "\u0627\u0644\u0647\u0646\u062F",
        fr: 'Inde',
        de: 'Indien',
        trunk: '0',
        nsnMin: 10,
        nsnMax: 10,
        example: '9812345678'
    }),
    Object.freeze({
        iso2: 'ID',
        dial: '62',
        en: 'Indonesia',
        fa: "\u0627\u0646\u062F\u0648\u0646\u0632\u06CC",
        ar: "\u0625\u0646\u062F\u0648\u0646\u064A\u0633\u064A\u0627",
        fr: "Indon\xe9sie",
        de: 'Indonesien',
        trunk: '0',
        nsnMin: 8,
        nsnMax: 12,
        example: '081234567890'
    }),
    Object.freeze({
        iso2: 'IQ',
        dial: '964',
        en: 'Iraq',
        fa: "\u0639\u0631\u0627\u0642",
        ar: "\u0627\u0644\u0639\u0631\u0627\u0642",
        fr: 'Irak',
        de: 'Irak',
        trunk: '0',
        nsnMin: 8,
        nsnMax: 10,
        example: '07912345678'
    }),
    Object.freeze({
        iso2: 'IT',
        dial: '39',
        en: 'Italy',
        fa: "\u0627\u06CC\u062A\u0627\u0644\u06CC\u0627",
        ar: "\u0625\u064A\u0637\u0627\u0644\u064A\u0627",
        fr: 'Italie',
        de: 'Italien',
        nsnMin: 6,
        nsnMax: 11,
        example: '3123456789'
    }),
    Object.freeze({
        iso2: 'JP',
        dial: '81',
        en: 'Japan',
        fa: "\u0698\u0627\u067E\u0646",
        ar: "\u0627\u0644\u064A\u0627\u0628\u0627\u0646",
        fr: 'Japon',
        de: 'Japan',
        trunk: '0',
        nsnMin: 9,
        nsnMax: 10,
        example: '09012345678'
    }),
    Object.freeze({
        iso2: 'JO',
        dial: '962',
        en: 'Jordan',
        fa: "\u0627\u0631\u062F\u0646",
        ar: "\u0627\u0644\u0623\u0631\u062F\u0646",
        fr: 'Jordanie',
        de: 'Jordanien',
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0791234567'
    }),
    Object.freeze({
        iso2: 'KZ',
        dial: '7',
        en: 'Kazakhstan',
        fa: "\u0642\u0632\u0627\u0642\u0633\u062A\u0627\u0646",
        ar: "\u0643\u0627\u0632\u0627\u062E\u0633\u062A\u0627\u0646",
        fr: 'Kazakhstan',
        de: 'Kasachstan',
        trunk: '8',
        nsnMin: 10,
        nsnMax: 10,
        example: '87011234567'
    }),
    Object.freeze({
        iso2: 'KW',
        dial: '965',
        en: 'Kuwait',
        fa: "\u06A9\u0648\u06CC\u062A",
        ar: "\u0627\u0644\u0643\u0648\u064A\u062A",
        fr: "Kowe\xeft",
        de: 'Kuwait',
        nsnMin: 8,
        nsnMax: 8,
        example: '50012345'
    }),
    Object.freeze({
        iso2: 'LB',
        dial: '961',
        en: 'Lebanon',
        fa: "\u0644\u0628\u0646\u0627\u0646",
        ar: "\u0644\u0628\u0646\u0627\u0646",
        fr: 'Liban',
        de: 'Libanon',
        trunk: '0',
        nsnMin: 7,
        nsnMax: 8,
        example: '03123456'
    }),
    Object.freeze({
        iso2: 'LY',
        dial: '218',
        en: 'Libya',
        fa: "\u0644\u06CC\u0628\u06CC",
        ar: "\u0644\u064A\u0628\u064A\u0627",
        fr: 'Libye',
        de: 'Libyen',
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0912345678'
    }),
    Object.freeze({
        iso2: 'MY',
        dial: '60',
        en: 'Malaysia',
        fa: "\u0645\u0627\u0644\u0632\u06CC",
        ar: "\u0645\u0627\u0644\u064A\u0632\u064A\u0627",
        fr: 'Malaisie',
        de: 'Malaysia',
        trunk: '0',
        nsnMin: 8,
        nsnMax: 10,
        example: '0123456789'
    }),
    Object.freeze({
        iso2: 'MR',
        dial: '222',
        en: 'Mauritania',
        fa: "\u0645\u0648\u0631\u06CC\u062A\u0627\u0646\u06CC",
        ar: "\u0645\u0648\u0631\u064A\u062A\u0627\u0646\u064A\u0627",
        fr: 'Mauritanie',
        de: 'Mauretanien',
        nsnMin: 8,
        nsnMax: 8,
        example: '22123456'
    }),
    Object.freeze({
        iso2: 'MA',
        dial: '212',
        en: 'Morocco',
        fa: "\u0645\u0631\u0627\u06A9\u0634",
        ar: "\u0627\u0644\u0645\u063A\u0631\u0628",
        fr: 'Maroc',
        de: 'Marokko',
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0612345678'
    }),
    Object.freeze({
        iso2: 'NL',
        dial: '31',
        en: 'Netherlands',
        fa: "\u0647\u0644\u0646\u062F",
        ar: "\u0647\u0648\u0644\u0646\u062F\u0627",
        fr: 'Pays-Bas',
        de: 'Niederlande',
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0612345678'
    }),
    Object.freeze({
        iso2: 'NZ',
        dial: '64',
        en: 'New Zealand',
        fa: "\u0646\u06CC\u0648\u0632\u06CC\u0644\u0646\u062F",
        ar: "\u0646\u064A\u0648\u0632\u064A\u0644\u0646\u062F\u0627",
        fr: "Nouvelle-Z\xe9lande",
        de: 'Neuseeland',
        trunk: '0',
        nsnMin: 8,
        nsnMax: 10,
        example: '0211234567'
    }),
    Object.freeze({
        iso2: 'NO',
        dial: '47',
        en: 'Norway',
        fa: "\u0646\u0631\u0648\u0698",
        ar: "\u0627\u0644\u0646\u0631\u0648\u064A\u062C",
        fr: "Norv\xe8ge",
        de: 'Norwegen',
        nsnMin: 8,
        nsnMax: 8,
        example: '40612345'
    }),
    Object.freeze({
        iso2: 'OM',
        dial: '968',
        en: 'Oman',
        fa: "\u0639\u0645\u0627\u0646",
        ar: "\u0639\u064F\u0645\u0627\u0646",
        fr: 'Oman',
        de: 'Oman',
        nsnMin: 8,
        nsnMax: 8,
        example: '92123456'
    }),
    Object.freeze({
        iso2: 'PK',
        dial: '92',
        en: 'Pakistan',
        fa: "\u067E\u0627\u06A9\u0633\u062A\u0627\u0646",
        ar: "\u0628\u0627\u0643\u0633\u062A\u0627\u0646",
        fr: 'Pakistan',
        de: 'Pakistan',
        trunk: '0',
        nsnMin: 10,
        nsnMax: 10,
        example: '03012345678'
    }),
    Object.freeze({
        iso2: 'PS',
        dial: '970',
        en: 'Palestine',
        fa: "\u0641\u0644\u0633\u0637\u06CC\u0646",
        ar: "\u0641\u0644\u0633\u0637\u064A\u0646",
        fr: 'Palestine',
        de: "Pal\xe4stina",
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0599123456'
    }),
    Object.freeze({
        iso2: 'PL',
        dial: '48',
        en: 'Poland',
        fa: "\u0644\u0647\u0633\u062A\u0627\u0646",
        ar: "\u0628\u0648\u0644\u0646\u062F\u0627",
        fr: 'Pologne',
        de: 'Polen',
        nsnMin: 9,
        nsnMax: 9,
        example: '512345678'
    }),
    Object.freeze({
        iso2: 'QA',
        dial: '974',
        en: 'Qatar',
        fa: "\u0642\u0637\u0631",
        ar: "\u0642\u0637\u0631",
        fr: 'Qatar',
        de: 'Katar',
        nsnMin: 8,
        nsnMax: 8,
        example: '33123456'
    }),
    Object.freeze({
        iso2: 'RU',
        dial: '7',
        en: 'Russia',
        fa: "\u0631\u0648\u0633\u06CC\u0647",
        ar: "\u0631\u0648\u0633\u064A\u0627",
        fr: 'Russie',
        de: 'Russland',
        trunk: '8',
        nsnMin: 10,
        nsnMax: 10,
        example: '89123456789'
    }),
    Object.freeze({
        iso2: 'SA',
        dial: '966',
        en: 'Saudi Arabia',
        fa: "\u0639\u0631\u0628\u0633\u062A\u0627\u0646 \u0633\u0639\u0648\u062F\u06CC",
        ar: "\u0627\u0644\u0633\u0639\u0648\u062F\u064A\u0629",
        fr: 'Arabie saoudite',
        de: 'Saudi-Arabien',
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0501234567'
    }),
    Object.freeze({
        iso2: 'SG',
        dial: '65',
        en: 'Singapore',
        fa: "\u0633\u0646\u06AF\u0627\u067E\u0648\u0631",
        ar: "\u0633\u0646\u063A\u0627\u0641\u0648\u0631\u0629",
        fr: 'Singapour',
        de: 'Singapur',
        nsnMin: 8,
        nsnMax: 8,
        example: '81234567'
    }),
    Object.freeze({
        iso2: 'ZA',
        dial: '27',
        en: 'South Africa',
        fa: "\u0622\u0641\u0631\u06CC\u0642\u0627\u06CC \u062C\u0646\u0648\u0628\u06CC",
        ar: "\u062C\u0646\u0648\u0628 \u0623\u0641\u0631\u064A\u0642\u064A\u0627",
        fr: 'Afrique du Sud',
        de: "S\xfcdafrika",
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0821234567'
    }),
    Object.freeze({
        iso2: 'ES',
        dial: '34',
        en: 'Spain',
        fa: "\u0627\u0633\u067E\u0627\u0646\u06CC\u0627",
        ar: "\u0625\u0633\u0628\u0627\u0646\u064A\u0627",
        fr: 'Espagne',
        de: 'Spanien',
        nsnMin: 9,
        nsnMax: 9,
        example: '612345678'
    }),
    Object.freeze({
        iso2: 'SD',
        dial: '249',
        en: 'Sudan',
        fa: "\u0633\u0648\u062F\u0627\u0646",
        ar: "\u0627\u0644\u0633\u0648\u062F\u0627\u0646",
        fr: 'Soudan',
        de: 'Sudan',
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0912345678'
    }),
    Object.freeze({
        iso2: 'SE',
        dial: '46',
        en: 'Sweden',
        fa: "\u0633\u0648\u0626\u062F",
        ar: "\u0627\u0644\u0633\u0648\u064A\u062F",
        fr: "Su\xe8de",
        de: 'Schweden',
        trunk: '0',
        nsnMin: 7,
        nsnMax: 13,
        example: '0701234567'
    }),
    Object.freeze({
        iso2: 'CH',
        dial: '41',
        en: 'Switzerland',
        fa: "\u0633\u0648\u0626\u06CC\u0633",
        ar: "\u0633\u0648\u064A\u0633\u0631\u0627",
        fr: 'Suisse',
        de: 'Schweiz',
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0781234567'
    }),
    Object.freeze({
        iso2: 'SY',
        dial: '963',
        en: 'Syria',
        fa: "\u0633\u0648\u0631\u06CC\u0647",
        ar: "\u0633\u0648\u0631\u064A\u0627",
        fr: 'Syrie',
        de: 'Syrien',
        trunk: '0',
        nsnMin: 8,
        nsnMax: 9,
        example: '0944567890'
    }),
    Object.freeze({
        iso2: 'TJ',
        dial: '992',
        en: 'Tajikistan',
        fa: "\u062A\u0627\u062C\u06CC\u06A9\u0633\u062A\u0627\u0646",
        ar: "\u0637\u0627\u062C\u064A\u0643\u0633\u062A\u0627\u0646",
        fr: 'Tadjikistan',
        de: 'Tadschikistan',
        nsnMin: 9,
        nsnMax: 9,
        example: '917123456'
    }),
    Object.freeze({
        iso2: 'TH',
        dial: '66',
        en: 'Thailand',
        fa: "\u062A\u0627\u06CC\u0644\u0646\u062F",
        ar: "\u062A\u0627\u064A\u0644\u0627\u0646\u062F",
        fr: "Tha\xeflande",
        de: 'Thailand',
        trunk: '0',
        nsnMin: 8,
        nsnMax: 9,
        example: '0812345678'
    }),
    Object.freeze({
        iso2: 'TN',
        dial: '216',
        en: 'Tunisia',
        fa: "\u062A\u0648\u0646\u0633",
        ar: "\u062A\u0648\u0646\u0633",
        fr: 'Tunisie',
        de: 'Tunesien',
        nsnMin: 8,
        nsnMax: 8,
        example: '20123456'
    }),
    Object.freeze({
        iso2: 'TM',
        dial: '993',
        en: 'Turkmenistan',
        fa: "\u062A\u0631\u06A9\u0645\u0646\u0633\u062A\u0627\u0646",
        ar: "\u062A\u0631\u0643\u0645\u0627\u0646\u0633\u062A\u0627\u0646",
        fr: "Turkm\xe9nistan",
        de: 'Turkmenistan',
        trunk: '8',
        nsnMin: 8,
        nsnMax: 8,
        example: '65123456'
    }),
    Object.freeze({
        iso2: 'TR',
        dial: '90',
        en: "T\xfcrkiye",
        fa: "\u062A\u0631\u06A9\u06CC\u0647",
        ar: "\u062A\u0631\u0643\u064A\u0627",
        fr: 'Turquie',
        de: "T\xfcrkei",
        trunk: '0',
        nsnMin: 10,
        nsnMax: 10,
        example: '05321234567'
    }),
    Object.freeze({
        iso2: 'UA',
        dial: '380',
        en: 'Ukraine',
        fa: "\u0627\u0648\u06A9\u0631\u0627\u06CC\u0646",
        ar: "\u0623\u0648\u0643\u0631\u0627\u0646\u064A\u0627",
        fr: 'Ukraine',
        de: 'Ukraine',
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0501234567'
    }),
    Object.freeze({
        iso2: 'AE',
        dial: '971',
        en: 'United Arab Emirates',
        fa: "\u0627\u0645\u0627\u0631\u0627\u062A \u0645\u062A\u062D\u062F\u0647\u0654 \u0639\u0631\u0628\u06CC",
        ar: "\u0627\u0644\u0625\u0645\u0627\u0631\u0627\u062A \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0645\u062A\u062D\u062F\u0629",
        fr: "\xc9mirats arabes unis",
        de: 'Vereinigte Arabische Emirate',
        trunk: '0',
        nsnMin: 8,
        nsnMax: 9,
        example: '0501234567'
    }),
    Object.freeze({
        iso2: 'GB',
        dial: '44',
        en: 'United Kingdom',
        fa: "\u0628\u0631\u06CC\u062A\u0627\u0646\u06CC\u0627",
        ar: "\u0627\u0644\u0645\u0645\u0644\u0643\u0629 \u0627\u0644\u0645\u062A\u062D\u062F\u0629",
        fr: 'Royaume-Uni',
        de: "Vereinigtes K\xf6nigreich",
        trunk: '0',
        nsnMin: 9,
        nsnMax: 10,
        example: '07400123456'
    }),
    Object.freeze({
        iso2: 'US',
        dial: '1',
        en: 'United States',
        fa: "\u0627\u06CC\u0627\u0644\u0627\u062A \u0645\u062A\u062D\u062F\u0647",
        ar: "\u0627\u0644\u0648\u0644\u0627\u064A\u0627\u062A \u0627\u0644\u0645\u062A\u062D\u062F\u0629",
        fr: "\xc9tats-Unis",
        de: 'Vereinigte Staaten',
        nsnMin: 10,
        nsnMax: 10,
        example: '2025550123'
    }),
    Object.freeze({
        iso2: 'UZ',
        dial: '998',
        en: 'Uzbekistan',
        fa: "\u0627\u0632\u0628\u06A9\u0633\u062A\u0627\u0646",
        ar: "\u0623\u0648\u0632\u0628\u0643\u0633\u062A\u0627\u0646",
        fr: "Ouzb\xe9kistan",
        de: 'Usbekistan',
        nsnMin: 9,
        nsnMax: 9,
        example: '901234567'
    }),
    Object.freeze({
        iso2: 'YE',
        dial: '967',
        en: 'Yemen',
        fa: "\u06CC\u0645\u0646",
        ar: "\u0627\u0644\u064A\u0645\u0646",
        fr: "Y\xe9men",
        de: 'Jemen',
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0712345678'
    })
]);
const $412e1a8a99c19c1a$export$84b76667b0a9e7b4 = $412e1a8a99c19c1a$export$4d78c43b7fa734a7[0];
function $412e1a8a99c19c1a$export$7684f8e22afec32c(locale) {
    const tag = String(locale || (0, $hlTfq.documentLocale)()).replace(/_/g, '-');
    const parts = tag.split('-');
    const region = parts.slice(1).find((p)=>/^[A-Za-z]{2}$/.test(p));
    const byRegion = region ? $412e1a8a99c19c1a$export$586b3eaa727579f5(region) : undefined;
    if (byRegion) return byRegion;
    const language = parts[0].toLowerCase();
    if (language === 'ar' || !(0, $eLeza.isIranMarket)()) return $412e1a8a99c19c1a$export$586b3eaa727579f5('IQ') || $412e1a8a99c19c1a$export$84b76667b0a9e7b4;
    return $412e1a8a99c19c1a$export$84b76667b0a9e7b4;
}
function $412e1a8a99c19c1a$export$586b3eaa727579f5(iso2) {
    if (typeof iso2 !== 'string') return undefined;
    const key = iso2.toUpperCase();
    return $412e1a8a99c19c1a$export$4d78c43b7fa734a7.find((c)=>c.iso2 === key);
}
function $412e1a8a99c19c1a$export$21894a57509f6ed5(digits) {
    if (typeof digits !== 'string') return undefined;
    let best;
    for (const country of $412e1a8a99c19c1a$export$4d78c43b7fa734a7){
        if (!digits.startsWith(country.dial)) continue;
        if (best === undefined || country.dial.length > best.dial.length) best = country;
    }
    return best;
}
/**
 * The languages every row is named in — the only fields `countryName` reads and
 * `countryMatches` searches. A list rather than `country[language]`, so no locale can
 * ever read a field that is not a name (`dial`, `example`…).
 */ const $412e1a8a99c19c1a$var$NAME_LANGUAGES = Object.freeze([
    'fa',
    'en',
    'ar',
    'fr',
    'de'
]);
function $412e1a8a99c19c1a$export$3162e773cd568eb(country, locale) {
    if (!country) return '';
    const tag = locale || (0, $hlTfq.documentLocale)();
    const language = String(tag).split('-')[0];
    return $412e1a8a99c19c1a$var$NAME_LANGUAGES.includes(language) && country[language] || country.en;
}
/**
 * A name folded for SEARCH, never for display: lower case, decomposed (NFD) and stripped
 * of the combining marks U+0300–U+036F, so «etats», «Etats» and «ÉTATS» all reach
 * «États-Unis», and «turk» reaches «Türkiye» and «Türkei». «ß» has no decomposition, so
 * it is spelled out as «ss» (PM-0212): «Straße» and «strasse» fold alike.
 * Persian and Arabic letters come through unchanged — their marks sit outside that block
 * — and both sides of a comparison are folded alike, so every search that matched before
 * still matches.
 * @param {string} text
 * @returns {string}
 */ function $412e1a8a99c19c1a$var$foldForSearch(text) {
    return String(text).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ß/g, 'ss');
}
function $412e1a8a99c19c1a$export$10dfaa5ff1ea39fa(country, query) {
    if (!country) return false;
    const needle = $412e1a8a99c19c1a$export$522be3011864bb18(query).trim().toLowerCase().replace(/^\+/, '');
    if (!needle) return true;
    if (country.dial.startsWith(needle) || country.iso2.toLowerCase() === needle) return true;
    const folded = $412e1a8a99c19c1a$var$foldForSearch(needle);
    return $412e1a8a99c19c1a$var$NAME_LANGUAGES.some((language)=>{
        const name = country[language];
        return typeof name === 'string' && name !== '' && $412e1a8a99c19c1a$var$foldForSearch(name).includes(folded);
    });
}
// ─────────────────────────────────────────────────────────────────────────────
// The one parse
// ─────────────────────────────────────────────────────────────────────────────
/**
 * @typedef {'required'|'tooShort'|'tooLong'|'notMobile'|'invalid'} PhoneProblem
 * Why a number was refused. Each one gets its own message: "invalid" alone tells the
 * user nothing about which digit to go looking for.
 */ /**
 * @typedef {Object} PhoneParse
 * @property {boolean} ok
 * @property {string}  e164      `'+989121234567'`, or `''` when `ok` is false.
 * @property {string}  national  `'09121234567'`, or `''` when `ok` is false — and also
 *                               `''` for an accepted number whose country is not in the
 *                               catalog, because there is no national form to render
 *                               without knowing the plan.
 * @property {Country} country   The country the MESSAGE should name: the one the number
 *                               claims where it claimed one, otherwise the selected one.
 * @property {PhoneProblem|null} problem
 */ /**
 * @typedef {Object} PhoneOptions
 * @property {Country|string} [country]        A `Country` record OR an iso2 string
 *                                             (`{ country: 'TR' }`), so no caller has to
 *                                             import the catalog to name a country.
 *                                             Default: Iran.
 * @property {boolean}        [allowLandline]  Drop the country's `nsnPattern`. Iran only,
 *                                             in practice. Default: false.
 */ const $412e1a8a99c19c1a$var$resolveCountry = (c)=>(typeof c === 'string' ? $412e1a8a99c19c1a$export$586b3eaa727579f5(c) : c) || $412e1a8a99c19c1a$export$84b76667b0a9e7b4;
/** Does this NSN look like one of `country`'s? Length, plus — where the country declares
 *  one and the caller has not waived it — a shape. */ function $412e1a8a99c19c1a$var$fitsNsn(nsn, country, allowLandline) {
    if (nsn.length < country.nsnMin || nsn.length > country.nsnMax) return false;
    if (allowLandline || country.nsnPattern === undefined) return true;
    return country.nsnPattern.test(nsn);
}
/**
 * Drop a leading trunk prefix — the digits a number wears only when it is dialled INSIDE
 * its own country, and which are never part of the national significant number.
 *
 * **A trunk that begins with `0` comes off unconditionally.** In a plan that HAS a trunk
 * zero, no NSN begins with `0` — the zero IS the trunk, by construction — so keeping it
 * cannot produce a right answer, only one that is wrong by exactly a digit. Length bounds
 * are a check ON the NSN; they were never a way to choose whether to peel. Letting them
 * choose is what made `parsePhone('0218800000', { allowLandline: true })` — a Tehran
 * landline one digit short — answer `+980218800000`: the peeled body is nine digits and
 * misses Iran's 10/10 window, the trunk-kept string is ten and fits it, so the trunk was
 * kept and `judge`, with the mobile pattern waived, passed it on length alone. The number
 * was stored AND redisplayed («00218800000») wrong, stably and silently.
 *
 * **A trunk that is an ordinary digit stays conditional.** Russia's, Kazakhstan's and
 * Turkmenistan's trunk is `8`, and `8121234567` is St Petersburg — a real national number
 * that BEGINS with the trunk digit. There is no structural rule to appeal to, so the
 * heuristic is the best available: peel when the result is a number the country
 * recognises, or when keeping it cannot produce one.
 *
 * The `!fitsNsn(candidate)` half of that heuristic is also what makes a short Russian
 * number report "too short" rather than a shape complaint.
 *
 * ONE helper, used on BOTH branches of `parsePhone`. The live login theme peels the trunk
 * only on the national path, which is why it gets `"+98 0912 345 6789"` and
 * `"00980912 3456789"` wrong — and both of those are rows in tests/test_phone.py, i.e.
 * shapes this platform's data genuinely holds. This is the single rule here that the theme
 * does not yet have; it is filed as a follow-up against parsina.keycloakify. The theme's
 * direction is the safe one (it refuses rather than mis-reads), so the symptom there is a
 * rejected login and never a wrong number.
 *
 * What this function does NOT do is peel a SECOND zero. One trunk comes off; a string
 * wearing two (`+43 0 0664…`) is not a number this module claims to understand, and
 * `judge` refuses it rather than guessing which zero was the trunk — see the guard there.
 */ function $412e1a8a99c19c1a$var$peelTrunk(candidate, country, allowLandline) {
    const trunk = country.trunk;
    if (!trunk || !candidate.startsWith(trunk) || candidate.length <= trunk.length) return candidate;
    const without = candidate.slice(trunk.length);
    if (trunk[0] === '0') return without;
    return $412e1a8a99c19c1a$var$fitsNsn(without, country, allowLandline) || !$412e1a8a99c19c1a$var$fitsNsn(candidate, country, allowLandline) ? without : candidate;
}
/**
 * Iran's rule, exactly as the twins write it: drop a leading `+`, then peel `00`, then
 * the country code `98` when what is left would be too long to be an NSN, then the trunk
 * `0` — and require the remainder to be `9` plus nine digits.
 *
 * A LINEAR PEEL, not a catalog lookup, and the difference is the whole point of this
 * function existing. The peel never asks which country `990…` belongs to, so
 * `+9901234567` is read as the 0990 mobile it is. Asking the catalog instead is how this
 * kit used to answer `+9901234567` where both twins answer `+989901234567`: no row starts
 * with `990`, the number fell through to the generic "some foreign country" accept, and
 * `lookupVariants` then offered ONE spelling. A Keycloak probe in that spelling misses the
 * same person stored as `09901234567`, and the auto-provisioning flow mints a duplicate
 * account — the precise harm this module exists to prevent. Seventy-four live Iranian
 * ranges (0940–0949, 0950–0959, 0960–0962, 0967, 0969, 0970, 0972, 0975–0979, 0990, 0991,
 * 0996, 0997, 0999) were wrong that way.
 *
 * Line for line this is `phone.py#normalize_phone`'s body after its shared prelude, down
 * to the sequential `if`s — they are NOT mutually exclusive there and must not become so
 * here, because `+00989…` wears all three prefixes at once. `phone.test.js` executes this
 * against the real Python over a generated corpus so the two cannot drift silently.
 *
 * @param {string} s  Folded, separator-stripped, already matched against `DIGITS_ONLY`.
 * @returns {string|null}  The ten-digit NSN, or `null` when this is not an Iranian mobile.
 */ function $412e1a8a99c19c1a$var$peelIranianMobile(s) {
    let t = s;
    if (t[0] === '+') t = t.slice(1);
    if (t.startsWith('00')) t = t.slice(2);
    // The `length > 10` guard is what keeps 9812345678 — an ordinary 0981 mobile — from
    // being read as country code 98 followed by an eight-digit stub.
    if (t.startsWith('98') && t.length > 10) t = t.slice(2);
    if (t.startsWith('0')) t = t.slice(1);
    return $412e1a8a99c19c1a$var$IR_MOBILE.test(t) ? t : null;
}
/**
 * The last word on an NSN once the prefixes are off it.
 *
 * The first guard is not a length rule and deliberately runs before the length rules: in a
 * plan whose trunk prefix is a zero, an NSN that still BEGINS with one is not a number
 * this module can read. `peelTrunk` takes exactly one trunk off, so a leading zero here
 * means the string wore its trunk twice (`+43 0 0664 123 4567`, and 94 shapes like it
 * across 17 of the 52 rows). Accepting it was worse than refusing for a reason that has
 * nothing to do with the user's typing: `+430664123456` fed back through this module
 * peels the surviving zero and answers `+43664123456`, so the kit emitted an E.164 it
 * would later read as a DIFFERENT phone — the one thing a matching key may never do. A
 * number cannot be both, and guessing which zero was the trunk would be inventing data,
 * so the answer is `invalid` and the value is refused whole.
 *
 * Italy is the reason this is gated on the trunk rather than written as "no NSN begins
 * with 0": Italian landlines genuinely keep their leading zero (`+39 06 …` is Rome), which
 * is exactly why Italy's row carries no `trunk` at all.
 */ function $412e1a8a99c19c1a$var$judge(nsn, country, allowLandline) {
    const digits = country.dial + nsn;
    const fail = (problem)=>({
            ok: false,
            e164: '',
            national: '',
            country: country,
            problem: problem
        });
    if (country.trunk && country.trunk[0] === '0' && nsn[0] === '0') return fail('invalid');
    if (nsn.length < country.nsnMin || digits.length < $412e1a8a99c19c1a$var$E164_MIN_DIGITS) return fail('tooShort');
    if (nsn.length > country.nsnMax || digits.length > $412e1a8a99c19c1a$var$E164_MAX_DIGITS) return fail('tooLong');
    if (country.nsnPattern && !allowLandline && !country.nsnPattern.test(nsn)) return fail('notMobile');
    return {
        ok: true,
        e164: `+${digits}`,
        national: (country.trunk || '') + nsn,
        country: country,
        problem: null
    };
}
function $412e1a8a99c19c1a$export$48c6adddc5539199(raw, options = {}) {
    const selected = $412e1a8a99c19c1a$var$resolveCountry(options.country);
    const allowLandline = options.allowLandline === true;
    const fail = (problem, country = selected)=>({
            ok: false,
            e164: '',
            national: '',
            country: country,
            problem: problem
        });
    if (typeof raw !== 'string') return fail('invalid');
    let s = $412e1a8a99c19c1a$var$stripSeparators($412e1a8a99c19c1a$export$522be3011864bb18(raw));
    if (s === '') return fail('required');
    if (!$412e1a8a99c19c1a$var$DIGITS_ONLY.test(s)) return fail('invalid');
    // ── The twins ──────────────────────────────────────────────────────────────────
    // `allowLandline` does not switch this off: a landline is not an Iranian mobile, so the
    // peel declines it and the catalog below is what accepts it.
    if (selected.iso2 === 'IR') {
        const nsn = $412e1a8a99c19c1a$var$peelIranianMobile(s);
        if (nsn !== null) // Iran's trunk is `0` and its row is fixed (see COUNTRIES): `0` + NSN is the
        // national spelling, `+98` + NSN the canonical one.
        return {
            ok: true,
            e164: `+98${nsn}`,
            national: `0${nsn}`,
            country: selected,
            problem: null
        };
    }
    // ── The generalisation ─────────────────────────────────────────────────────────
    let international = false;
    if (s[0] === '+') {
        s = s.slice(1);
        international = true;
    }
    if (s.startsWith('00')) {
        s = s.slice(2);
        international = true;
    }
    if (s === '') return fail('required');
    if (international && s[0] !== '0') {
        const country = $412e1a8a99c19c1a$export$21894a57509f6ed5(s);
        if (country === undefined) {
            if (s.length < $412e1a8a99c19c1a$var$E164_MIN_DIGITS) return fail('tooShort');
            if (s.length > $412e1a8a99c19c1a$var$E164_MAX_DIGITS) return fail('tooLong');
            // Accepted, with no national form to offer and the picker left where it was.
            return {
                ok: true,
                e164: `+${s}`,
                national: '',
                country: selected,
                problem: null
            };
        }
        return $412e1a8a99c19c1a$var$judge($412e1a8a99c19c1a$var$peelTrunk(s.slice(country.dial.length), country, allowLandline), country, allowLandline);
    }
    const candidate = s.startsWith(selected.dial) && s.length > selected.nsnMax ? s.slice(selected.dial.length) : s;
    return $412e1a8a99c19c1a$var$judge($412e1a8a99c19c1a$var$peelTrunk(candidate, selected, allowLandline), selected, allowLandline);
}
function $412e1a8a99c19c1a$export$e9b617754cf28d84(raw, options) {
    return $412e1a8a99c19c1a$export$48c6adddc5539199(raw, options).e164;
}
function $412e1a8a99c19c1a$export$f9c4d85d720ef909(raw, options) {
    return $412e1a8a99c19c1a$export$e9b617754cf28d84(raw, options) !== '';
}
function $412e1a8a99c19c1a$export$317852993b4735b6(raw, options) {
    return $412e1a8a99c19c1a$export$48c6adddc5539199(raw, options).national;
}
function $412e1a8a99c19c1a$export$1069b069fb83ae5b(raw, options) {
    if (typeof raw !== 'string') return '';
    const parsed = $412e1a8a99c19c1a$export$48c6adddc5539199(raw, {
        ...options,
        allowLandline: true
    });
    if (!parsed.ok) return raw;
    // A number from ANOTHER country is shown internationally (PM-0078). A national
    // spelling carries no country, so `07400123456` on a desk in Tehran is dialled as an
    // Iranian number; `+447400123456` cannot be. Compared by dial code, not row, because
    // `+1` resolves to Canada whichever of the two the caller called home.
    const home = $412e1a8a99c19c1a$var$resolveCountry(options?.country);
    if (parsed.country.dial !== home.dial || !parsed.national) return parsed.e164;
    return parsed.national;
}
function $412e1a8a99c19c1a$export$1f64b92865689d0d(raw) {
    if (typeof raw !== 'string') return '';
    if (raw.length < 7) return raw;
    return `${raw.slice(0, 5)}***${raw.slice(-3)}`;
}
function $412e1a8a99c19c1a$export$d2b3d97ad6239e3e(raw, options) {
    const parsed = $412e1a8a99c19c1a$export$48c6adddc5539199(raw, {
        ...options,
        allowLandline: true
    });
    return parsed.ok ? `tel:${parsed.e164}` : null;
}
function $412e1a8a99c19c1a$export$493e0fb9b5aae030(raw, options) {
    const e164 = $412e1a8a99c19c1a$export$e9b617754cf28d84(raw, options);
    if (e164 === '') return [];
    const digits = e164.slice(1);
    const country = $412e1a8a99c19c1a$export$21894a57509f6ed5(digits);
    // An accepted number from outside the catalog has no known plan, so there is no trunk
    // prefix to add and no national spelling to guess at. One shape — the only one we
    // could ever have written.
    if (!country) return [
        e164
    ];
    const nsn = digits.slice(country.dial.length);
    const seen = new Set([
        e164,
        digits,
        `00${digits}`,
        ...country.trunk ? [
            country.trunk + nsn
        ] : [],
        nsn
    ]);
    return [
        ...seen
    ];
}

});
parcelRegister("hlTfq", function(module, exports) {

$parcel$export(module.exports, "stripAmount", () => $ca1f40e638c62a9a$export$8a2f5adb56df4f49);
$parcel$export(module.exports, "dotsAreGroups", () => $ca1f40e638c62a9a$export$bb91f232d86bf745);
$parcel$export(module.exports, "groupAmount", () => $ca1f40e638c62a9a$export$302430bce3371cb8);
$parcel$export(module.exports, "numeralsFor", () => $ca1f40e638c62a9a$export$20975da26e036f6b);
$parcel$export(module.exports, "documentLocale", () => $ca1f40e638c62a9a$export$594d280e896fc02b);
// Money — the one place the toman/rial boundary lives.
//
// Every service, every gRPC message and every GraphQL field in Parsina carries WHOLE
// RIALS. Iranian clinics quote, type and read TOMAN. Ten rials to the toman, and the
// conversion happens here, at the display edge, and nowhere else.
//
// Getting this wrong is not a cosmetic bug. A rial figure printed under a toman label
// reads as ten times the money — a 500,000 ت visit shows as 5,000,000 ت — and a toman
// figure typed into a rial field bills a tenth of what the cashier meant. Both of those
// shipped, in opposite directions, on the same screen.
//
// So: rials cross the wire, toman meets the human. Anything reaching for
// `.toLocaleString()` on a raw rial value is a bug.
//
// A clinic may keep its books in another currency: `currency.js` handles any
// allowed one, and for IRR each of its functions returns exactly what this file's
// does. New code that shows clinic money takes the document's currency and uses it.
// With its extension: phone.js imports this module under Node's own ESM resolver
// (see the note there), and Node does not guess one.

var $eLeza = parcelRequire("eLeza");
const $ca1f40e638c62a9a$export$166519e0fc2d4fb3 = 10;
const $ca1f40e638c62a9a$export$d3105a4d9be2f59 = (rial)=>rial == null || rial === '' || !Number.isFinite(Number(rial)) ? null : Number(rial) / $ca1f40e638c62a9a$export$166519e0fc2d4fb3;
const $ca1f40e638c62a9a$export$496c2c39d7e0791 = (toman)=>{
    const n = Number(String(toman ?? '').replace(/[,٬\s]/g, ''));
    return Number.isFinite(n) ? Math.round(n * $ca1f40e638c62a9a$export$166519e0fc2d4fb3) : NaN;
};
function $ca1f40e638c62a9a$export$1736ebd23f2adeaf(rial) {
    const t = $ca1f40e638c62a9a$export$d3105a4d9be2f59(rial);
    if (t == null) return "\u2014";
    // Sub-toman precision cannot exist (prices are entered in toman) but a percentage
    // discount can land on a half-toman; show it rather than silently rounding money away.
    return t.toLocaleString('fa-IR', {
        maximumFractionDigits: 1
    });
}
function $ca1f40e638c62a9a$export$cbc4bde7d9461cfb(n) {
    if (n == null || n === '' || !Number.isFinite(Number(n))) return "\u2014";
    return Number(n).toLocaleString('fa-IR');
}
function $ca1f40e638c62a9a$export$3d047decf6215cd7(input) {
    if (input == null || String(input).trim() === '') return NaN;
    return $ca1f40e638c62a9a$export$496c2c39d7e0791($ca1f40e638c62a9a$var$toAsciiDigits(input));
}
// Persian/Arabic-Indic digits → ASCII, so a pasted or typed «۵۰۰۰۰۰» parses.
function $ca1f40e638c62a9a$var$toAsciiDigits(input) {
    return String(input).replace(/[۰-۹]/g, (d)=>String("\u06F0\u06F1\u06F2\u06F3\u06F4\u06F5\u06F6\u06F7\u06F8\u06F9".indexOf(d))).replace(/[٠-٩]/g, (d)=>String("\u0660\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669".indexOf(d)));
}
function $ca1f40e638c62a9a$export$8a2f5adb56df4f49(input, allowDecimal = false, numerals = $ca1f40e638c62a9a$export$4b87c97d2471ab43) {
    let raw = String(input ?? '');
    // A locale whose decimal mark is not «.» (Persian uses «٫») would otherwise have
    // it stripped as punctuation, silently turning «۱٫۵» into «۱۵». Grouping marks
    // need no such care — they are non-digits and are meant to go.
    //
    // Under a decimal-COMMA language (French) a text that holds the comma names its
    // decimal with it, so any «.» beside it is a group mark and goes first: «1.234,5»
    // is 1234.5, as `currency.parseAmount(…, 'fr')` reads it — not «1.2345». A text
    // with no comma keeps «.» as a decimal point, which every language accepts here.
    //
    // A language that GROUPS with «.» (German «1.234,5») is different: there a dot is
    // a group mark even with no comma beside it, because that is what `groupAmount`
    // prints into a `MoneyInput` — reading it as a decimal turned a typed «12345» EUR,
    // shown «1.234» after four keys, into 1.23. Two dots are never one decimal point
    // either («1.234.567»). `NumberInput` follows the same rule: under such a
    // language it shows its value with the language's own decimal mark, so a «.» in
    // the box is never its decimal point. A text whose dots are NOT valid groups
    // («12.50», «1.5») is ambiguous there; `dotsAreGroups` lets a field refuse it.
    const dotGroups = numerals.decimal === ',' && (raw.includes(',') || numerals.group === '.');
    if (allowDecimal && dotGroups) raw = raw.split('.').join('');
    if (allowDecimal && numerals.decimal !== '.') raw = raw.split(numerals.decimal).join('.');
    let s = $ca1f40e638c62a9a$var$toAsciiDigits(raw).replace(allowDecimal ? /[^\d.]/g : /\D/g, '');
    if (allowDecimal) {
        const [intPart, ...rest] = s.split('.');
        if (rest.length) s = `${intPart}.${rest.join('')}`; // collapse extra dots
    }
    return s;
}
function $ca1f40e638c62a9a$export$bb91f232d86bf745(input, numerals = $ca1f40e638c62a9a$export$4b87c97d2471ab43) {
    const raw = $ca1f40e638c62a9a$var$toAsciiDigits(String(input ?? ''));
    const intPart = raw.split(numerals.decimal)[0].replace(/[^\d.]/g, '');
    if (!intPart.includes('.')) return true;
    return /^\d{1,3}(\.\d{3})+$/.test(intPart);
}
function $ca1f40e638c62a9a$export$302430bce3371cb8(value, numerals = $ca1f40e638c62a9a$export$4b87c97d2471ab43) {
    if (value == null || value === '') return '';
    const s = String(value);
    const neg = s.startsWith('-') ? '-' : '';
    const [intPart, ...rest] = (neg ? s.slice(1) : s).split('.');
    const grouped = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, numerals.group);
    const out = neg + (rest.length ? `${grouped}${numerals.decimal}${rest.join('')}` : grouped);
    // Only the ASCII digits are remapped; the separators are already the locale's.
    return numerals === $ca1f40e638c62a9a$export$4b87c97d2471ab43 ? out : out.replace(/\d/g, (d)=>numerals.digits[Number(d)]);
}
const $ca1f40e638c62a9a$export$4b87c97d2471ab43 = Object.freeze({
    locale: 'en',
    digits: Object.freeze([
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9'
    ]),
    group: ',',
    decimal: '.'
});
const $ca1f40e638c62a9a$var$numeralsCache = new Map([
    [
        'en',
        $ca1f40e638c62a9a$export$4b87c97d2471ab43
    ]
]);
function $ca1f40e638c62a9a$export$20975da26e036f6b(locale) {
    const key = locale || 'en';
    const hit = $ca1f40e638c62a9a$var$numeralsCache.get(key);
    if (hit) return hit;
    let resolved = $ca1f40e638c62a9a$export$4b87c97d2471ab43;
    try {
        const plain = new Intl.NumberFormat(key, {
            useGrouping: false
        });
        const digits = Array.from({
            length: 10
        }, (_, d)=>plain.format(d));
        // 1000.1 exercises both separators in one pass; a locale missing either
        // (none in practice) falls back to the Latin one rather than to undefined.
        const parts = new Intl.NumberFormat(key, {
            useGrouping: true
        }).formatToParts(1000.1);
        const part = (type, fallback)=>parts.find((p)=>p.type === type)?.value ?? fallback;
        resolved = Object.freeze({
            locale: key,
            digits: Object.freeze(digits),
            group: part('group', ','),
            decimal: part('decimal', '.')
        });
    } catch  {
        // An unsupported or malformed tag is a caller bug, not a reason to stop
        // rendering a price. Latin digits are always readable.
        resolved = $ca1f40e638c62a9a$export$4b87c97d2471ab43;
    }
    $ca1f40e638c62a9a$var$numeralsCache.set(key, resolved);
    return resolved;
}
function $ca1f40e638c62a9a$export$594d280e896fc02b(fallback = (0, $eLeza.brandDefaultLocale)('fa')) {
    if (typeof document === 'undefined') return fallback;
    return document.documentElement?.getAttribute('lang') || fallback;
}

});


parcelRegister("fMnXH", function(module, exports) {

$parcel$export(module.exports, "flagUrl", () => $b7cded1008753984$export$a2b8715397522463);
// GENERATED by tools/build-flags.cjs from flag-icons 7.5.0 (MIT, lipis/flag-icons) — do not
// edit by hand. 40×30 PNG (2× the drawn 20×15), base64, one per row of COUNTRIES.
// prettier-ignore
const $b7cded1008753984$var$PNG = {
    IR: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX////aAAAjn0BcuHLjQEDnVVVuwIHrc3P+9PTvjo72+/f74uKHy5fzqqqU0aOk16+XZwNwAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAr0lEQVR42mNQwgIYBqGgsbFxMhCCgRkQggDDmWPJf8yepZ05lvYmLe9wXlrOmbQ8Bi4uLoYFCxZwcXVvAJFgDgMMcG+fsYEBHczdXn0TXYy7nL2gHF0p51X2gtgJaIK8VzgLfC+ga58+s7ISw6bbriF7MWznuCiLUMjBwcHQ0NDAwcG9AUSCOQwhLiEuri4uYMoVzHZ1YagsDZ0eOrUUTFWWxIaGTw+NZBDEAgahIAAf7Fwe+04+vAAAAABJRU5ErkJggg==',
    AF: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEW/AAAAAAEAmQCAEQCAAADdeHfRRUXLMDDVVlbFFhbhhYTZZWTvvrzppqXDDQ2BDgJ/AJzcAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAeUlEQVR42mMQBAMRBjAwUgIDhqEmyJlRXoAhOG1aexm6IFvf87oXCWiCMxL2nGbrRBNMrYs5+jwMTbAnO7x02wk0wdCdMamzQ9EEdzXEHuVYjSZYkXYrKq0dTZDr6vTKmAVogpytV3dFTED30ay7d1diBsgDviEXcQB/Wk8LWL2d8wAAAABJRU5ErkJggg==',
    DZ: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX///8AYjPREDQTWzP87vG5GTP2z9bldopePTN6MjP++/zslaXeTmlERzPytsGQKjOhIQw3AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAa0lEQVR42mMQhAMGBBgcgsI39jmgCwpPUlJSd0ATNFXSTPErQxUUDlI1ZGBgc0ARlFQKFmTgcliAImik1CjowJ6Aqv2SkqHgniI0wSZVQcE1SqcdCAti1Y7VIqxOwup4rN7EHiBYg24QRTEAq40s8eFvTBUAAAAASUVORK5CYII=',
    AM: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAACVBMVEXZABIAM6DyqACw8tlJAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAF0lEQVR42mNgGHZAEAsY2oJKWMCQFgQAQLMn2UPulzIAAAAASUVORK5CYII=',
    AU: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEUAAIv/AgL//Pz/bGyNi8rd3fBUVLEYGJZzc780NKO2str+iIn/JSX/yMjvoaq2g62b1p0wAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA+klEQVR42mMwimTg2CjswDDvNAMC2FxqAAly2FxCEsyW1qrYKOy+5pAakiDnG6OQjcLrhFULkAQZWGwubRS+c8kBoqQTLKcEBBuFQSSIx6YEFhSEAxCPQzUBU5AhjQGLIASgmgkCIAM4dM9uFNY97AAT4wgtYGBf9GbLRuGlyqeA1k4AOxFo11TlcyAfLXrzjKE0AqzUhYEBqBHkdxbdwwypKjAjHm6DhNJUZQYOBwYcgBObYNIELIKVMAZ7ARZZjgZMsZRZkW4YglxKSgGYupWU4PphdrMvUlLSglrFFgUVZZ8WpJoJFWRRSoDpiVoKN2oJnLWAi4GaAACk7z96Qd+VoQAAAABJRU5ErkJggg==',
    AT: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAABlBMVEX////IEC5cagsYAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAFElEQVR42mMQxAIYhrTg8APDLo4As4YakeJ1P9cAAAAASUVORK5CYII=',
    AZ: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEU/mzUAueTtKTk/nDXuM0P////sKjnxV2Pza3b4qK/2lJz1iZHyanX1ho/6wsb6wcaXspUqAAAAAXRSTlP+GuMHfQAAAAlwSFlzAAAuIwAALiMBeKU/dgAAAFJJREFUeNpjEMQCGIa0YJISBKjvLlKCAZigytM5vU7ognoxSkolTmiCpZOUlDpXoAluPaSksjTKiQhBrNr1sVmk8nUGppOU1PciOZ7ZGBMMaUEAYGdewLA+W8AAAAAASUVORK5CYII=',
    BH: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAJ1BMVEXOESb////SJTjtp6/++Pn1z9T66evmiJLXPU7gaHXPFirQGC3icH2vW5DzAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAKUlEQVR42mMQFBSM2cCABoCCgukKWAQFnRuIFMSmPXIBFotGbR95tgMA4tMe9v5fIp8AAAAASUVORK5CYII=',
    BE: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAD1BMVEXbuwr5hhoAAAH/2QzzGDDlGv6LAAAAAnRSTlPHx/co26IAAAAJcEhZcwAALiMAAC4jAXilP3YAAAAaSURBVHjaY1ACAwVjMBBxAQOGUcFRQVoKAgBG03Gtsi/apQAAAABJRU5ErkJggg==',
    BR: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX45QkinkUrSaM+WaXa2RWbubxesjQ9pz20zhyJwChmfrhVaYXGvzGgoku93cV8h2YIpy45AAAACXBIWXMAAC4jAAAuIwF4pT92AAABA0lEQVR42mMQxAIYyBBMccMUlGBgaEcXFHNgYGBJRBUUb2AAAo5CFMEEBt7N1n8YOJEFKxh4jJSUlLZAjQULSjIwXAKKKSk7MEyECQIN5FECgw0MLIVQwQkMDKyhoYuBgroMYGOBgiVAe4+Ghr4LXaSkDWS6gQQlQY65paSkFffUSAnoWoZGQQaQqxkYPoFMXPpK6QADyA9wQS2g6LpgqCBE+yVjJeXFSspxIBXtIItSgIxTRkbKQHFTmEVgJ3ErKyktUlK2Bfof5ngHoOOBZhobb4CEFLI3FxkjeRMaIEbAAHFHDroUBt7d6EGHPZDB0QExEDniJLFEHPYoFhQsJCPZAACz20xO82VhQQAAAABJRU5ErkJggg==',
    CA: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEXqlY/pk4zplI3////VKx7qkYrjb2fYOCz++fj1y8n87u3zwL3uqqT54N7eVUvlfnalRQo6AAAAA3RSTlPEwsLgduwSAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAi0lEQVR42mNwAQIHYzgQAfEZ6C9ouhiL4PJgTMHdIbXBGIJTXFyS0QU7lri4BDejCu49Zu7isvPVXBTBFJcwF5ftLr4ogkdcwKAYWdDiC0SwEpvKVyiC1iUg2q0Z1UnTQXQwmjttgJQf0PEqKIIx2+bEN6MJGhubNWMJJbPFxApagrWrDFAUQwDYdgDA65dwevVm0gAAAABJRU5ErkJggg==',
    CN: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEXuHCXvJiP//wD0ahj94AX5ow/xRh7vLSL8zAjzXhr+8AL4mxD5swzvIiTwMCL1ehZhA9qiAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAZklEQVR42mNgwAMYsQluRRdgZmDg3foATVBKgIGBjx1N0MgASLAGoGh2WbTEmYGhNBBFYYaSSgJQP5o9SsqYruHx9wGSbAkogqIF0kDrKxqxuJ5zAoYQbyY2b3Y8wBIemQyjgBoAAEO/DOML4QfFAAAAAElFTkSuQmCC',
    CY: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX////UdgD07uT7+fXaiCHLzsK9wrPpuXzuyZqvtKLe4NjeljvlrGP027ydpI2Olnz/VpYUAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAn0lEQVR42mNgoAMwwBRiLlfAFCtpwFTYsheFq6HEwKC+URxVjaGgiKOgNJpmRUEgkEURuuK+ESQogWxnraMgBFxAEt0IEfLxOYwkWAgRRLXGBCwmg+oZDqCZItvRPch74giGn1mVGSzAzlBDEuR6CqVfIQvOnACmZ2Yh69dPA4mmxS9ACUe9sEnMU+OUUa1iWvY19OUqjPA1TTNgoDsAAH0MH3woys8hAAAAAElFTkSuQmCC',
    DK: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAADFBMVEXIEC7////QM0zXUWbL25x8AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAJ0lEQVR42mNgAANFQSEGDDDsBZXAwFBQWAkBGASxAEoFsVo0gkMeANYLEN9rIYw3AAAAAElFTkSuQmCC',
    EG: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX///8AAAHOESbt4LPm05f279n7+O/q2abz6cvv473gyH/SsUfizYnSsUjUtE7UtE+FUiyCAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAUUlEQVR42mNQwgIYhrQgHHAGMGAANtaABAzB5ow2CwxB6+M1mzEEq9es2o4h6Lui6wqGoL+x8RMMQfcWjxIMwWTLydMwBFknGyNcL4gFDGlBAONAN6Idm2N7AAAAAElFTkSuQmCC',
    FI: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAHlBMVEUAL2z////n6/HZ4On19/n2+PrFz933+Prf5eze5OxGbJvuAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAM0lEQVR42mMQBIECBgYGZkE4YACTAUNUUAkEGoCCbEpwwDBUANi1E9AcD/aXAza/D1FBANf4HwFP43uLAAAAAElFTkSuQmCC',
    FR: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAD1BMVEUAAJH////hAA/1qq+qqtocVNyOAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAGklEQVR42mNgAAMWQTAwUgIDhlHBUUFaCgIANE0qMRXTPuoAAAAASUVORK5CYII=',
    GE: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAIVBMVEX/////AAD/xMT/6en/KCj/ODj/uLj/aGj/t7f/Nzf/Jye3ao04AAAACXBIWXMAAC4jAAAuIwF4pT92AAAATElEQVR42mNggAJGQUEBBnRAlCBTEUJQXQEqyCGGEGxMgIgxu4o6wwStJoYYYAiaBM4ywK0du0WUOF4QC6Cf4ACFvEkg1pAPoWfIAwBUiRrZ67e50QAAAABJRU5ErkJggg==',
    DE: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAACVBMVEUAAAH/zAD/AABTrXiPAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAF0lEQVR42mNgGHZACQsY2oKCWMCQFgQAJmgn2fxJGEkAAAAASUVORK5CYII=',
    GR: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEWXudzc5/N0otAvdLlkmMzO3u6JsNdomswWZLFHhMH///8NXq9elMpdk8mvyuWUuNy9t6ayAAAACnRSTlPHx8fH7fnw4O3tua1jCQAAAAlwSFlzAAAuIwAALiMBeKU/dgAAAFxJREFUeNpj2L1796lVu1EBA+mCEwURAC54axUCYBc8c+bMr1VAwoEBCcBkXyNbRLwg8bbjFWw2RgASAsTFxSU1FEgUKSEAwyosgATB3VgACYKCWAAJtmMFlDkJADpQb8rhqOSNAAAAAElFTkSuQmCC',
    HU: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAD1BMVEU4jQDUNRb////UNhf//f0fKhQYAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAHUlEQVR42mMwxgIYBLGAISPoggUwKGEBQ0Zw2AEAn7AtKfgzYVIAAAAASUVORK5CYII=',
    IN: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX/////mTMSiAfj4/JjY7hlZbiUlM1bW7TW1uy3t93X1+yVlc1ubrzY2O1gYLVubrvbBsOsAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAQ0lEQVR42mMQxAIYhrQgXsDsGncBQ9DcanExhqDz7EwTDMGI/NOtmIJ7vmEKPp6WaYoheB2bRcwuLgb4Ha2EBQxpQQB5PzXw6CctoQAAAABJRU5ErkJggg==',
    ID: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAABlBMVEXnABH///9GPYQdAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAFElEQVR42mNgGAXkAkEsYFSQGEEARNwT7a82wgIAAAAASUVORK5CYII=',
    IQ: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX///8AAAHOESbe7uZsso/n8+2z2MYAej1bqYLO5tqEv6L0+ven0bwrkV5CnG8HfkLIbu0WAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAVUlEQVR42mNQwgIYhrQg6YCH4QADp9kGVMFlDA0MYS6oglwHMhsYUlAEOaNmrOro5nniEoAkyPa/vLzuBW/5lQvItmQaG5uGshqbGpDqPkEsYEgLAgC7sTrOTPRwzAAAAABJRU5ErkJggg==',
    IT: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAD1BMVEXOKzf///8Akkaq28HvuLydaqNBAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAGUlEQVR42mNQAgNlQTBwYICAUcFRQVoKAgAHkC93JNeyBwAAAABJRU5ErkJggg==',
    JP: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX///+8AC3z09u+BTH//v7+/P3WYX3BEjz22+HegpjsuMXUXXrtusb23uTeg5nBEz3t9p09AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAa0lEQVR42mNgoDdg1VoUgC7GkS4oWNaAKsYyWRAILB1QBL0FwWALiuBEiKAkshivIURQGNlUNkEoSEASjIcJliIJKsIEhZAED8IEpbAJyhDSjtUirE7C6niYN+UIBwgk6OwcCAcy9uigOQAAuKIYLYzUZfoAAAAASUVORK5CYII=',
    JO: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX/AAAAAAH///8AmQD+AAD/QED/srLEAABNAAHEIwBNawD/Dw//6Oj/qKj/KytAcwA4JMd5AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAe0lEQVR42n3Puw2AMAwE0GuokJBYgRWyACNQUTJHZqFhBQZiGHBCjH/iqtNTItvIow/mHCFyhF4JnRa0WtHoi1obKmWUii/r1IJIESn1vju1ln4t+i21IUJs0fdo0N9KYnk+c08cRmGM0hoqe1FbRWMFrRE6e9BbwuEt3d6mRppivxM/AAAAAElFTkSuQmCC',
    KZ: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEUAq8L/7C19y3mKz3EWsbVNv5VvyIE6uqAjtK1lxYcMrruZ02mz2Vqm1mHM4Err5zn1kEx1AAAACXBIWXMAAC4jAAAuIwF4pT92AAAA60lEQVR42mNgwArcvbAIqu3CInj2BhbBTbewCJ7GptJsC5Th4YAQnJwAoTuVNBtgYizWqWCaNT0yXBUmyGVpAabb4gTlIwugghw2EPmpDwUFv2vBlCZPAZuiKigoKJQB9xFYmkUTKCidDhPcfAVkzRKQSuGMpTDHHwESwQrTPwoKimslByAJxv1qihcUnFnwLgFJe18S6/Rs9Wmc5wqQLGIOn1CkllRQXuOA5CSuLa1d7V1LoyxQHO/MkJyerLCoAMWbXCUMng4s09EChIHTisE4AD3oOKL3bMcMZILRgTXisEYx1sSANdlgAQBsEkHVTQYmTgAAAABJRU5ErkJggg==',
    KW: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX////zGDAAAAEA2UEAgidRCBEAQRQADgUAwzoVAgWkECABAQIFBQYICAngFizfFiwsWLaJAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAbUlEQVR42mPIMMYEDOrOWASV1JqxCCqVYBNUysAmiGEsSBDDWLAgurEQQTRjoYKoxkIFlTYwIAPqCB6gTPACRYKaCwWRAFQwThBTcJYgpqDqQ0xBVAOhgnGCmIKzBDEFVT9iCmIYCBKMxxQTBABu501a6aV2MQAAAABJRU5ErkJggg==',
    LB: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX4sLTTr6WhrpH////uFh8CqVFNw4UotmvZ8+UWsF9jypSH1q05vHej4MDA6tTt+fModX5RAAAAA3RSTlPAyNIAJ7wgAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAmUlEQVR42mNwwQIYBlYQDhgRTAZjGGivgDPhgvZTQ/MwBM1mVkZ+Rhd8vm169GU0wV9hx1Zlogv2LgsNrZnWjCrYFnpsaWjZZRRB2/CdoaWhYaiCFtdjQkOrV1agCPZEhq06Gpq2G0Vw28rQ0ND0qedQBL+t/REaamyxvRnV8dahoY/RvWmx6t1xeIjAAosJGHZC8KAbfFEMAFLInkrFWlo3AAAAAElFTkSuQmCC',
    LY: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEUAAAHnABMjnkYQSiJ7AAoNDQ5BQUJsbG2jo6MkJCW3t7eWlpZ6AAri4uLt7e3///9apKbEAAAACXBIWXMAAC4jAAAuIwF4pT92AAAARElEQVR42mMQxAIYBlbwiAsG8GGgFqgowxTjWsoQGYAuWBvAwLYzAU2wm4Eh498EYgSxasdqEVYnkQmMsQAGJSxgYAUBQNozH9QbWmcAAAAASUVORK5CYII=',
    MY: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEUBAWXMAADUJib////nh4fibm7wtrbcTk5qVTwrIlX429upBBbyu7v7yQGwjCDitAxVRiJQAAAACXBIWXMAAC4jAAAuIwF4pT92AAAApUlEQVR42mNggANBOGAgILgKDkA8zglgQWM4AHI4/nVgan8/gYFz5gRUQY4bDAwzOjoZGFzggIGB/wMDw7y7L1HN5H3AwNl79wcDQzkcAFUCBfvv/piAYibfBQaGjv8dqCo57wEtm9mA5s5eoCUg55+BA5CH+jpIDBAUM7EI7oYDJO2CWABDGhaAZBKSmUpYAHYzQ7EA7Ga6YAHYzcRqO1YzsQkCAB2DeG8b518IAAAAAElFTkSuQmCC',
    MR: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEUAYjPNKj5mRjn/xAAcbS2goBI9eSaHlhjouwR0jxsQaDDFrgv4wQFchSCwphAscyohwGQSAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAjklEQVR42mMQxAIYKBRUwgIY8AO2BCyC7AWYYu4V7SWYupst0PSDuMXmICkkwQlAvPM2kOBEEgxhYOD6wL+AgcEVSbASxpiOJHhjAYTm6kUSXPMAQvOdQhJkNYXQwQFIgizN+0HUbwsHZIfmGL91YLlnfAzNP8ZAgO4nV5BgCLrfPaO3TmGgEsAacTRIIQCjVisn0uVIegAAAABJRU5ErkJggg==',
    MA: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEXBJy1mQi+uLS1uQDClLy5aRjAUWzIyUjEZWjKbMi57PC+NNy83UTF1Py8NXjNWRzBcvfykAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAPklEQVR42mNgGL6AxQGLIKMAFkH2AgwhztAf/aET0EVXHLbpwrTn7T1Mm5jK0hUwBJmztxlgukiBSYBhZAEA3FMKXRTvT/sAAAAASUVORK5CYII=',
    NL: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAACVBMVEUhRouuHCj///+QNKGcAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAF0lEQVR42mMQxAIYhrSgEhYwtAWHHQAA8cMn2RePrhMAAAAASUVORK5CYII=',
    NZ: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEUAJH3JES/++/wCImrklaPQMEnefo+PlbYcOoFpdKWBhKzYYnVCW5e3scfyxc3n4ukbs7NpAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAwElEQVR42mPY9MPYylGs2PhICAMCbH00GSRolfoISXCKiC5QsOLqfk0kQYurm747il0J029GEjQ23/rIUezpo2JjJEElIHAUA5Fg7gEwKQgHIB5nVgMWwTAsKnlmYTMTarulfpyjmF4Y3HZ2kDsvPfV1FLuvHQt05wmQ4NIbDAzn1WK7gD665OrDwLkN5KDjExgY9KOLQX4314tm4IiGmenqAwml89oMHCcZBhhMwCLWuesApiCXNBaVnMsZBhwAAPtnOCIlvtmpAAAAAElFTkSuQmCC',
    NO: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAFVBMVEUAJmTtKTn7ys4fQHf///8EKWb+8vMDntwIAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAPUlEQVR42mMQBAEhZwYTRUE4YBh+gkogoAYUTFKCAwYXMAAKuiAAgzEYmDIEGyMAA/EAq3asFmF10siIDgBIBDxNHFl+NQAAAABJRU5ErkJggg==',
    OM: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEXvLSn///8AkCX6ubjHPSjaNSjxQT397ez2gX/4nJrzYV/709LwOTX5sa/7yMf1dXKxEGopAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAVUlEQVR42mNgAIFEQRTAwLDgNxemYOf5xZiC7LfLMAR5i8t3b0AX5LIsP9GAob23sgGLRQxrD6ALcj5g4HiAoRIEDhujAIahD1hcUABEMEgJBQxpQQDyzjeG2etjuwAAAABJRU5ErkJggg==',
    PK: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEUMWQv////J2sg2djUWYBVtm2yyy7FWjFYmayXe6d79/v1+p36dvJz3+veGrYZOh01DlvGiAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAeklEQVR42mMQBAIFBjQwiAXZGzAFWVIZGDjQBdkmMDBwhzagChY+YGBoE0NTqVjAwPDnpgGKIMtCoCDzBlTtzIIBQMscGNAEEzDdyXJxMRbHJ0o6YApaCU4GckpQBfkEpVK/bwpA8/teIH0VPUCYTwrOacAMOofBHJsAmkIgJ8nEUEMAAAAASUVORK5CYII=',
    PS: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEXtLjgAljkAAAD////IMzOWVDiXHST82tzwT1fuNT/4q68qhDlfEhZfbDgqCAr0eoGf0o+MAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAeElEQVR42o3OsQ2AMAxEURcpKKDwCqzAJKyQFdiGLViJFViAxImQ8Z0QLp90X5Y840k6CcrIUDJDDBTEQEUIGMaAYQw0DIGOw7a46yg7Q7kY+sCDPvCNdH79fIk+v6q/ZpMipoPge9wwjA3j2DCOK8K4II4L4lj1BvDTQ+3mvvDBAAAAAElFTkSuQmCC',
    PL: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAABlBMVEXcFDz////vuDXSAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAFElEQVR42mMQxAIYRgWJERwF5AIAyagT7ZPvKigAAAAASUVORK5CYII=',
    QA: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEWNGz3////z5ummTGfhw8ytWnPChZiTKEjRpLHZs76ZM1KzZ378+fratcD69fe7dovPfIyeAAAACXBIWXMAAC4jAAAuIwF4pT92AAAANElEQVR42mMQBAGN7QwoACwoKOOKKSg0fwGm4GUGbNqfJBMpiFU7VouwOgmr40d9NJh9BABnYibF3uZjAAAAAABJRU5ErkJggg==',
    RU: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAACVBMVEX////VKx4AOaYLRJEfAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAF0lEQVR42mNgGHZACQsY2oKCWMCQFgQAJmgn2fxJGEkAAAAASUVORK5CYII=',
    SA: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEUWXTHD1so6dlCUtKC6z8KevKkqa0J6o4pXi2tKgV+JrZdumn+sxbbT4dhjk3Xo7ur50TcyAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAl0lEQVR42mNgGJyAc4Ym97Tq1ZrTlBQS4IJJzme0H04vtIhqiToAF1SWjepwPeIuveqJXQBckM+1OGlXh9M148rrCEH24v/iocqXgo1nxxrABdkqgqdFyV80X5xheAxhkWCwbqPNo2XLj9SZwQVniEQvdOrRm5LTtO8AFhez0SdgmFC5hoKCgrIivi4KmCq5SxUGaeQyAABIGCoBr6ooaAAAAABJRU5ErkJggg==',
    SG: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEXfAAD////mMzPhDg772NjudXXpS0vkJibrX1/1qKjwh4fznJzjHBz3wMD85OT97OwLMeD+AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAYklEQVR42mNgIAEwrUzAFNzoxKCALsYtf4DHFV1QUZSdIYkdTXChzNkABpUGVMGJAhwJDKxopm4UZjAAQlTQKMa8lekSmiCLCMMK5uloguwPJ2PxkdWTBAaygSAWMCpIjCAAWLQjMqdY6EMAAAAASUVORK5CYII=',
    ZA: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX9/v3+uRUUgE/brRp1pKfd6emZbw1kkTMvIQTrf3j50s8AeEcAAAHhOS0ADIr////nnyzWAAAAC3RSTlPv/eDZxsnBwd7m4E+UGYYAAAAJcEhZcwAALiMAAC4jAXilP3YAAAClSURBVHjaY9i9e1P8r7uogGH37t1b+DkxBXer/l+LKbjb4cNcFEEjkCCasQyC1bsxjGVIFNbGMJbhhKE4hrEMZ44JYhjLcOZMM4axQMEzcGNhACQIN5YBBoCCMGPhACwIMxZVEGYsYUFs2rFZhNVJ2BwP9ybLOyhACpCv7+CCiKDzQwjCDYx7hxDEMBAkiGEgSBDDQJggioFQQVQDIYJoBr579w4AID2uWajS1fMAAAAASUVORK5CYII=',
    ES: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEXxvwDOag2qFRvmsgu7YhjStSK1PBfbmQnNhg7UvW23VRPTp6e9oUDAc1fSwrl3SlO5GvFDAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAbUlEQVR42mNQwgIYBlZQEAtgwAMMsAkGYxETcfPA1NzSIY4uxlws6DnTHF10ckbePk40MfaLOXn7ZNEcwLE95f/u6gI0wcte/5fZogkyP/ZyW8aHpp012OvWklB0waM2Mw/EBDAQAFiDbvBFMQDs8UAnWwjUdAAAAABJRU5ErkJggg==',
    SD: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEUAmgAAAAH/////AAAAUwAWggBdYgD0BwDS7dKZ15koqijSGwCZPgAAGwH0+/Rdv10nNCULAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAdUlEQVR42o3OsQ2AMAxEURekANF4BVZgAqbJHqzEJCyESJwIGd8J4fJJ92XJK56kg6DMDCUzxEBBDFSEgGEMGMZAwxDoOO2Lu44yMpSLoQ886APfSOfXz5fo85v6azYoYjoJvscNw9gwjg3juCKMC+K4II5Vb7xWROdp9YXoAAAAAElFTkSuQmCC',
    SE: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAABlBMVEX+ywAAUpP1seVEAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAG0lEQVR42mMQBAEBBgZGQQRgGCGCAwtGcMgDAE6xGxmZ2zxDAAAAAElFTkSuQmCC',
    CH: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAElBMVEX/////AAD/0ND/YGD/Tk7/9vbc5piHAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAOUlEQVR42mMQxAIYaCkoYmzsiCEoxMCgOECCTkpKqgwMQUpKKkiCBgxQwEw9QawWDazfcUUHrRMDALp+J5UUpHr1AAAAAElFTkSuQmCC',
    SY: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX///8Aej0AAADOESb31tnWM0X99vfbT1/RHTHniJPzwMb76OrvsbjqmKHTKDvfYnCfYG3WAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAfUlEQVR42mMQxAIYhrQgTuAAIrg3gEgWuOAXEMF7AUT6w8TYOkEkewGInJEAEeOMswh3YDgabBrDwFLa/HQCRPSEcTXQsGBToNHbjXug2jOMQcYVm4MMNm6DCi71BBrH9uYc0Dj2KVFQwWVAyMCygRuoPQsIcQElLGBICwIAQ45Aa03Ys2UAAAAASUVORK5CYII=',
    TJ: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX////MAAAAZgDibW1uqG7//vv96aH/+ur+8sb74Hv97K3844X+9tf611L722f85I0rCMw5AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAdklEQVR42mMQxAIYBqGgMRbAAAc8BxgwwCrOCaswBNNYA9LQhFjbQWRFAKrgNYb67wy5qIIMoQzV24EECgBazdGA7gDOCQxsCSASxcyAzn2vZ7Cimdn7LGtZ3g10d9ZlT3uOLsZ+e0XX3gIYzwULYFDCAgahIADpxEPh9dNYsAAAAABJRU5ErkJggg==',
    TH: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAElBMVEWlGTEtKkr09fjV1t1LSWXo09kUPIcoAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAJUlEQVR42mNgoBcIxQIYlLAASgVdsAAGQSxgyAgaYwE0CTp6AQB3hDElR27URQAAAABJRU5ErkJggg==',
    TN: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEXnABP////pDyH/9/jybXj0goz1l5/qHC3+7u/uSlf3qK7wXGj71tn84uTsMkL5vMHVD65hAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAkUlEQVR42mNgGLyAfWt0AYbYQkFBKXTRFxIpbo330BQ2JrG7+ssqoAhyiTFsNhQ2TEARLGziFIwQFDRCEdyYwC/oGWIoiSIY6MB8tEBHUARd8FoBD5ogSLt3Cpr2wiY+wwx0i9ikGGYIShgGoDr+4nKmLf4yqI5neCu8NMrwOJrfmZIFBU0V0IOJaYqnwiCOWQCf5x5RzATURwAAAABJRU5ErkJggg==',
    TM: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEUAhD2qQDNyWTaIYzXPMTBLXTuCTTe2ZTHcWS+kcTiYZVlxu5Opg3sznWRtaEfT6t5XcMERAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA3klEQVR42mNgYGAutFpYzIAGmC0frXmELsi67lXWUnRBpjN5kUYMDHsZLiBrlzo1TQhIb+BGFixxcSkGqeRGUsosrpkoBBRj4N6AEGSLfPgyCKibgR9ZMDAxMQjEuI9sZubLyCQGBt7bf1EsEiwBWsS7F8VHhYKCmN4UCg0WQhdkU5ISUsImaIShXTg0EkM70HYRTIsqOjqKMARbw0Kb0AXZg+fNC8NQWRqIqZK5oh2LmVhtl6w5g+nNmWvWHMIQPLNm5SQMQa8zk50wBFtcXDCcxNbh4oEp6NLSgqodADs3OvJyxTvoAAAAAElFTkSuQmCC',
    TR: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEXjChf////lFCDmISzoND/3ubz+8/TqSFL6zc/84+XxhIv1pKnuY2vzlZvvdHvsWGBydz1BAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAhElEQVR42mNgGFqgemLGYnQxVUHJXVcPoIoxNYo9YGDwQRXkFkwHSTmgCDoKPgBRCvbIggvFFEAUs6VREUIwUBRMMRdOe4AQbJQGUx6CogyYKg+KGWCYyeRpfgDZ9gUgysAF2XZeQXFMdzI1Ci5iYKhB87u2oFjsjg/oIeLbOfXRYI5GAK4SGZ7PHOUxAAAAAElFTkSuQmCC',
    UA: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAABlBMVEX/1wAAV7hKNkFnAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAFElEQVR42mMQxAIYRgWJERwF5AIAyagT7ZPvKigAAAAASUVORK5CYII=',
    AE: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAFVBMVEUAAAH/AAAAcy/////AHAzAAAD/Pz+OQQvYAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAH0lEQVR42mMQBAMRJWTAMAwExYyRwXAQFGVAAUNZEADHSDmVngXCtwAAAABJRU5ErkJggg==',
    GB: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEXIEC7///8BIWnMIj387/Ht7/UTMXTZVmz0zdSgrMfqo6/L0uHigZEwSoVTaZp3iK/3wiHXAAAACXBIWXMAAC4jAAAuIwF4pT92AAABHklEQVR42r2SsUoDQRCGf1nh4EgzxIRAAsJCBAuPA5tgFxQOIU0KO5PiwMrmhCts5aqUB2Kd4DMINkIKfQHb1HmB4AM4M7uLV6R24GD2476f3dlFSceWa9gGDrvS/RQtmCd6acL7yqyQxtT5/oPJLR4JGTQgwOciGhO2aw3wUGSa4+w9bXGAgyyPqJ/DnmqAgyrvLKzdLjngTWC/AstWoAaQwIHKCl2AwLbKDMmXwNDvh+e+UsCEHv9WV74ueUuh379PPlUypdcDhRm+9Jj81TTAg/tzHV27gWzoqIhvBHaol44+BIpsFnc65JoDPmXINU1Q7vx1TGkZLXJsWIln4eJkdTGDynmAJxJQQuXGY+AAA5Ubz0YCoHLzgdWU/QIYAVlPDjvZVgAAAABJRU5ErkJggg==',
    US: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEUZL13///+9PUQmOWTtyMrlsrTLaG3DT1bcmJw1SHBLXID14eKKla3Rxs9kc5Krs8T8og+qAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA7ElEQVR42m2QTWoCQRCFH/Sqm8kMXsETFDYkjPiz8QpewSvMFWbZMAlkZNBx6Q96AG8g4gUkkK0iOYPdppMeob63e9R7Vd0Q+BN12h5EdWKGNMcGh2CKbvqQLvX7yIPfUTv4g0XLY73I9Khy8Y+xB6pQOhZdMdXL0ImkfjF92uGIt8yDuBgUAz2zuoTO2HZGqLDFNZhuOw3JbX+deCBlqVIlS1maxou+k9rtueH0mXtcvGcqej5eqCK2h07FitZ7j4vbM+cu3vgQEiShnYL5FTj/x1sMyBnQZsCEge9kzYyBXzRm4DtHDHwnZ94BDlKd9LTrU4QAAAAASUVORK5CYII=',
    UZ: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEUAmbX///8etTr10NRkdDJSY3wVobsKnbglqMBQucw7scaR1OC24+un3ebe8faAzNvLtHwcAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAc0lEQVR42mNgwAFWzyhgYNvQzfUBSYzzOZBgn5DJsQBJkG8CFt2NCQwMtWwXerk2IAkWNjAwcLE3ZLA1IAnyfMCine0kw/EatgO9nMjaGbimJbCxJ5SxF8BFQrEABmMsgEEQCxiMglgd74IFMChhAUNFEAB4jUr4vpG2xQAAAABJRU5ErkJggg==',
    YE: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAD1BMVEUAAAHxBgD///8pKSrzLimF/Ry1AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAHklEQVR42mMQxAIYhoqgCxbAoIQFDG1BYyyAYSgDAMCBL9EnDpIBAAAAAElFTkSuQmCC'
};
function $b7cded1008753984$export$a2b8715397522463(iso2) {
    const b64 = typeof iso2 === 'string' ? $b7cded1008753984$var$PNG[iso2.toUpperCase()] : undefined;
    return b64 ? `data:image/png;base64,${b64}` : undefined;
}

});

parcelRegister("j9AxR", function(module, exports) {

$parcel$export(module.exports, "kitCopy", () => $df1b34b618a72512$export$cddd06f8fa3400df);
// ─────────────────────────────────────────────────────────────────────────────
// The words the kit's components say when the caller did not pass their own.
//
// Rule 7 used to end at "copy arrives as props, with Persian defaults", and in
// practice no app passed all of it: an English clinic desk read «قبلی / بعدی»
// under every paged table, «ذخیره شد» on every save bar and «کد ملی وارد شده
// معتبر نیست» under a field labelled "National ID" — and a few components
// (the date-range filter, the save bar's confirmation, the national-id and
// number checks) had no prop to pass at all. The date picker moved to the page
// language in v0.19.0; this table does the same for everything else.
//
// A prop still wins. When it is absent, the default comes from here, keyed by the
// base language of `<html lang>` (or the component's own `locale` prop) — the
// channel `MoneyInput`, `PhoneInput` and the date picker already read; a region
// tag reads its base language (`fr-CA` → `fr`). Persian, English, Arabic,
// French and German each carry every word, and the test holds them to one shape, so no
// language falls through to another word by word. Adding a language is adding a
// complete entry; an unknown one reads the brand's default language, else
// Persian, as `documentLocale` falls back.
//
// Digits inside a default sentence are the caller's: a count passed in is
// rendered as given, so an app that localises its numerals keeps doing so. Nor is
// there a plural lookup — a count arrives as a finished string — so each
// language words a count to read right for any number (French «rendez-vous»
// is invariable; German reads it as a label, «Termine: 3»).
// ─────────────────────────────────────────────────────────────────────────────

var $hlTfq = parcelRequire("hlTfq");

var $eLeza = parcelRequire("eLeza");
const $df1b34b618a72512$export$6bdac007b5b42036 = {
    fa: {
        pager: {
            prev: "\u0642\u0628\u0644\u06CC",
            next: "\u0628\u0639\u062F\u06CC",
            page: (current, pages)=>`\u{635}\u{641}\u{62D}\u{647} ${current} \u{627}\u{632} ${pages}`
        },
        saveBar: {
            save: "\u0630\u062E\u06CC\u0631\u0647 \u062A\u063A\u06CC\u06CC\u0631\u0627\u062A",
            cancel: "\u0644\u063A\u0648",
            saved: "\u0630\u062E\u06CC\u0631\u0647 \u0634\u062F"
        },
        search: {
            placeholder: "\u062C\u0633\u062A\u062C\u0648...",
            clear: "\u067E\u0627\u06A9 \u06A9\u0631\u062F\u0646 \u062C\u0633\u062A\u062C\u0648"
        },
        select: {
            placeholder: "\u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F..."
        },
        confirm: {
            confirm: "\u062A\u0623\u06CC\u06CC\u062F",
            cancel: "\u0627\u0646\u0635\u0631\u0627\u0641"
        },
        errorState: {
            title: "\u062F\u0631 \u062F\u0633\u062A\u0631\u0633 \u0646\u06CC\u0633\u062A",
            retry: "\u062A\u0644\u0627\u0634 \u0645\u062C\u062F\u062F"
        },
        loading: "\u062F\u0631 \u062D\u0627\u0644 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC",
        close: "\u0628\u0633\u062A\u0646",
        back: "\u0628\u0627\u0632\u06AF\u0634\u062A",
        slotGrid: {
            label: "\u0633\u0627\u0639\u062A\u200C\u0647\u0627\u06CC \u0622\u0632\u0627\u062F",
            loading: "\u062F\u0631 \u062D\u0627\u0644 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u0632\u0645\u0627\u0646\u200C\u0647\u0627\u06CC \u0622\u0632\u0627\u062F"
        },
        phone: {
            label: "\u0634\u0645\u0627\u0631\u0647 \u0645\u0648\u0628\u0627\u06CC\u0644",
            country: "\u06A9\u0634\u0648\u0631",
            countrySearch: "\u062C\u0633\u062A\u062C\u0648\u06CC \u06A9\u0634\u0648\u0631 \u06CC\u0627 \u06A9\u062F",
            countryNoMatch: "\u06A9\u0634\u0648\u0631\u06CC \u067E\u06CC\u062F\u0627 \u0646\u0634\u062F",
            required: "\u0634\u0645\u0627\u0631\u0647 \u0645\u0648\u0628\u0627\u06CC\u0644 \u0631\u0627 \u0648\u0627\u0631\u062F \u06A9\u0646\u06CC\u062F",
            tooShort: (ctx)=>`\u{634}\u{645}\u{627}\u{631}\u{647}\u{654} ${ctx.countryName} \u{6A9}\u{648}\u{62A}\u{627}\u{647} \u{627}\u{633}\u{62A} \u{2014} \u{646}\u{645}\u{648}\u{646}\u{647}: ${ctx.example}`,
            tooLong: (ctx)=>`\u{634}\u{645}\u{627}\u{631}\u{647}\u{654} ${ctx.countryName} \u{628}\u{644}\u{646}\u{62F} \u{627}\u{633}\u{62A} \u{2014} \u{646}\u{645}\u{648}\u{646}\u{647}: ${ctx.example}`,
            notMobile: (ctx)=>`\u{627}\u{6CC}\u{646} \u{634}\u{645}\u{627}\u{631}\u{647} \u{645}\u{648}\u{628}\u{627}\u{6CC}\u{644} \u{646}\u{6CC}\u{633}\u{62A} \u{2014} \u{646}\u{645}\u{648}\u{646}\u{647}: ${ctx.example}`,
            invalid: "\u0634\u0645\u0627\u0631\u0647\u0654 \u0648\u0627\u0631\u062F\u0634\u062F\u0647 \u0645\u0639\u062A\u0628\u0631 \u0646\u06CC\u0633\u062A"
        },
        // «شماره‌های پرونده» (PM-0536): PhoneNumber, PhoneListInput, PhoneCandidateList.
        // The relation words are the ONE vocabulary of lib/phoneRelations.js.
        phoneRelation: {
            self: "\u062E\u0648\u062F \u0628\u06CC\u0645\u0627\u0631",
            spouse: "\u0647\u0645\u0633\u0631",
            father: "\u067E\u062F\u0631",
            mother: "\u0645\u0627\u062F\u0631",
            child: "\u0641\u0631\u0632\u0646\u062F",
            sibling: "\u062E\u0648\u0627\u0647\u0631 \u06CC\u0627 \u0628\u0631\u0627\u062F\u0631",
            legal_guardian: "\u0633\u0631\u067E\u0631\u0633\u062A \u0642\u0627\u0646\u0648\u0646\u06CC",
            caregiver: "\u0645\u0631\u0627\u0642\u0628",
            other: "\u0633\u0627\u06CC\u0631",
            unknown: "\u0646\u0627\u0645\u0634\u062E\u0635"
        },
        phoneNumber: {
            copy: "\u06A9\u067E\u06CC \u0634\u0645\u0627\u0631\u0647",
            copied: "\u06A9\u067E\u06CC \u0634\u062F",
            call: "\u062A\u0645\u0627\u0633",
            empty: "\u0628\u062F\u0648\u0646 \u0634\u0645\u0627\u0631\u0647"
        },
        phoneList: {
            title: "\u0634\u0645\u0627\u0631\u0647\u200C\u0647\u0627\u06CC \u062A\u0645\u0627\u0633",
            otherLabel: "\u0634\u0645\u0627\u0631\u0647\u0654 \u062F\u06CC\u06AF\u0631",
            relationLabel: "\u0635\u0627\u062D\u0628 \u0634\u0645\u0627\u0631\u0647",
            relationPlaceholder: "\u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F",
            primary: "\u0627\u0635\u0644\u06CC",
            primaryLabel: "\u0634\u0645\u0627\u0631\u0647\u0654 \u0627\u0635\u0644\u06CC",
            primaryHint: "\u067E\u06CC\u0627\u0645\u06A9 \u0648 \u06CC\u0627\u062F\u0622\u0648\u0631\u06CC \u0646\u0648\u0628\u062A \u0628\u0647 \u0634\u0645\u0627\u0631\u0647\u0654 \u0627\u0635\u0644\u06CC \u0641\u0631\u0633\u062A\u0627\u062F\u0647 \u0645\u06CC\u200C\u0634\u0648\u062F.",
            landline: "\u062A\u0644\u0641\u0646 \u062B\u0627\u0628\u062A",
            add: "\u0634\u0645\u0627\u0631\u0647\u0654 \u062F\u06CC\u06AF\u0631",
            addLabel: "\u0627\u0641\u0632\u0648\u062F\u0646 \u0634\u0645\u0627\u0631\u0647\u0654 \u062F\u06CC\u06AF\u0631",
            remove: "\u062D\u0630\u0641 \u0627\u06CC\u0646 \u0634\u0645\u0627\u0631\u0647",
            // `n` arrives already in the digits of the language on screen.
            limit: (n)=>`\u{62D}\u{62F}\u{627}\u{6A9}\u{62B}\u{631} ${n} \u{634}\u{645}\u{627}\u{631}\u{647}`,
            relationRequired: "\u0635\u0627\u062D\u0628 \u0627\u06CC\u0646 \u0634\u0645\u0627\u0631\u0647 \u0631\u0627 \u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F",
            duplicate: "\u0627\u06CC\u0646 \u0634\u0645\u0627\u0631\u0647 \u06CC\u06A9 \u0628\u0627\u0631 \u062F\u0631 \u0647\u0645\u06CC\u0646 \u0641\u0647\u0631\u0633\u062A \u0622\u0645\u062F\u0647 \u0627\u0633\u062A",
            locked: "\u0627\u06CC\u0646 \u0634\u0645\u0627\u0631\u0647 \u0631\u0627 \u0628\u06CC\u0645\u0627\u0631 \u0628\u0627 \u06A9\u062F \u062A\u0623\u06CC\u06CC\u062F \u06A9\u0631\u062F\u0647 \u0627\u0633\u062A\u061B \u0641\u0642\u0637 \u062E\u0648\u062F\u0634 \u0645\u06CC\u200C\u062A\u0648\u0627\u0646\u062F \u0622\u0646 \u0631\u0627 \u062D\u0630\u0641 \u06CC\u0627 \u0639\u0648\u0636 \u06A9\u0646\u062F.",
            cannotRemoveLast: "\u0634\u0645\u0627\u0631\u0647\u0654 \u0622\u062E\u0631 \u0631\u0627 \u0646\u0645\u06CC\u200C\u062A\u0648\u0627\u0646 \u062D\u0630\u0641 \u06A9\u0631\u062F\u061B \u0634\u0645\u0627\u0631\u0647\u0654 \u062F\u0631\u0633\u062A \u0631\u0627 \u062C\u0627\u06CC \u0622\u0646 \u0628\u0646\u0648\u06CC\u0633\u06CC\u062F."
        },
        phoneCandidates: {
            birthYear: (y)=>`\u{645}\u{62A}\u{648}\u{644}\u{62F} ${y}`,
            fileNumber: (n)=>`\u{67E}\u{631}\u{648}\u{646}\u{62F}\u{647} ${n}`,
            male: "\u0645\u0631\u062F",
            female: "\u0632\u0646",
            hasAppAccount: "\u062D\u0633\u0627\u0628 \u0627\u067E \u062F\u0627\u0631\u062F",
            inYourList: "\u062F\u0631 \u0644\u06CC\u0633\u062A \u0634\u0645\u0627",
            alreadyInList: "\u062F\u0631 \u0644\u06CC\u0633\u062A \u0634\u0645\u0627\u0633\u062A",
            addToList: "\u0627\u0641\u0632\u0648\u062F\u0646 \u0628\u0647 \u0644\u06CC\u0633\u062A",
            adding: "\u062F\u0631 \u062D\u0627\u0644 \u0627\u0641\u0632\u0648\u062F\u0646\u2026",
            linkFailed: "\u0627\u0641\u0632\u0648\u062F\u0646 \u0627\u06CC\u0646 \u067E\u0631\u0648\u0646\u062F\u0647 \u0627\u0646\u062C\u0627\u0645 \u0646\u0634\u062F\u061B \u062F\u0648\u0628\u0627\u0631\u0647 \u062A\u0644\u0627\u0634 \u06A9\u0646\u06CC\u062F.",
            newOnSameNumber: "\u0628\u06CC\u0645\u0627\u0631 \u062C\u062F\u06CC\u062F \u0628\u0627 \u0647\u0645\u06CC\u0646 \u0634\u0645\u0627\u0631\u0647",
            matchedOther: "\u06CC\u0627\u0641\u062A\u0647 \u0628\u0627 \u0634\u0645\u0627\u0631\u0647\u0654 \u062F\u06CC\u06AF\u0631"
        },
        dateRange: {
            title: "\u0628\u0627\u0632\u0647\u0654 \u0632\u0645\u0627\u0646\u06CC",
            custom: "\u0628\u0627\u0632\u0647\u0654 \u062F\u0644\u062E\u0648\u0627\u0647",
            from: "\u0627\u0632 \u062A\u0627\u0631\u06CC\u062E",
            to: "\u062A\u0627 \u062A\u0627\u0631\u06CC\u062E",
            needBoth: "\u0628\u0631\u0627\u06CC \u0627\u0639\u0645\u0627\u0644\u060C \u0647\u0631 \u062F\u0648 \u062A\u0627\u0631\u06CC\u062E \u0631\u0627 \u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F"
        },
        filters: {
            title: "\u0641\u06CC\u0644\u062A\u0631\u0647\u0627",
            clear: "\u062D\u0630\u0641 \u0641\u06CC\u0644\u062A\u0631\u0647\u0627",
            showResults: "\u0646\u0645\u0627\u06CC\u0634 \u0646\u062A\u0627\u06CC\u062C",
            applyRange: "\u0627\u0639\u0645\u0627\u0644 \u0628\u0627\u0632\u0647",
            activeCount: (n)=>`\u{641}\u{6CC}\u{644}\u{62A}\u{631}\u{647}\u{627} \u{2014} ${n} \u{641}\u{639}\u{627}\u{644}`,
            emptyTitle: "\u0645\u0648\u0631\u062F\u06CC \u0628\u0627 \u0627\u06CC\u0646 \u0641\u06CC\u0644\u062A\u0631\u0647\u0627 \u067E\u06CC\u062F\u0627 \u0646\u0634\u062F",
            emptyHint: "\u0641\u06CC\u0644\u062A\u0631\u0647\u0627 \u0631\u0627 \u062A\u063A\u06CC\u06CC\u0631 \u062F\u0647\u06CC\u062F \u06CC\u0627 \u062D\u0630\u0641 \u06A9\u0646\u06CC\u062F"
        },
        connectivity: {
            offline: "\u0627\u06CC\u0646\u062A\u0631\u0646\u062A \u0642\u0637\u0639 \u0627\u0633\u062A \u2014 \u062A\u063A\u06CC\u06CC\u0631\u0627\u062A \u062B\u0628\u062A \u0646\u0645\u06CC\u200C\u0634\u0648\u062F",
            degraded: "\u0627\u0631\u062A\u0628\u0627\u0637 \u0628\u0627 \u0633\u0631\u0648\u0631 \u0628\u0631\u0642\u0631\u0627\u0631 \u0646\u06CC\u0633\u062A \u2014 \u062F\u0631 \u062D\u0627\u0644 \u062A\u0644\u0627\u0634 \u0645\u062C\u062F\u062F",
            restored: "\u0627\u062A\u0635\u0627\u0644 \u062F\u0648\u0628\u0627\u0631\u0647 \u0628\u0631\u0642\u0631\u0627\u0631 \u0634\u062F",
            retry: "\u062A\u0644\u0627\u0634 \u0645\u062C\u062F\u062F",
            busy: "\u062F\u0631 \u062D\u0627\u0644 \u0628\u0631\u0631\u0633\u06CC\u2026"
        },
        nationalId: {
            label: "\u06A9\u062F \u0645\u0644\u06CC",
            // A country with no rule of its own (see lib/nationalId.js).
            genericLabel: "\u0634\u0645\u0627\u0631\u0647\u0654 \u0634\u0646\u0627\u0633\u0627\u06CC\u06CC \u0645\u0644\u06CC",
            country: "\u06A9\u0634\u0648\u0631 \u0635\u0627\u062F\u0631\u06A9\u0646\u0646\u062F\u0647",
            // `n` arrives already in the digits of the language on screen.
            placeholder: (n)=>`${n} \u{631}\u{642}\u{645}`,
            required: "\u06A9\u062F \u0645\u0644\u06CC \u0631\u0627 \u0648\u0627\u0631\u062F \u06A9\u0646\u06CC\u062F",
            incomplete: (n)=>`\u{6A9}\u{62F} \u{645}\u{644}\u{6CC} \u{628}\u{627}\u{6CC}\u{62F} ${n} \u{631}\u{642}\u{645} \u{628}\u{627}\u{634}\u{62F}`,
            tooShort: (n)=>`\u{62F}\u{633}\u{62A}\u{200C}\u{6A9}\u{645} ${n} \u{646}\u{648}\u{6CC}\u{633}\u{647} \u{648}\u{627}\u{631}\u{62F} \u{6A9}\u{646}\u{6CC}\u{62F}`,
            invalid: "\u06A9\u062F \u0645\u0644\u06CC \u0648\u0627\u0631\u062F \u0634\u062F\u0647 \u0645\u0639\u062A\u0628\u0631 \u0646\u06CC\u0633\u062A",
            valid: "\u06A9\u062F \u0645\u0644\u06CC \u0645\u0639\u062A\u0628\u0631 \u0627\u0633\u062A",
            notValid: "\u06A9\u062F \u0645\u0644\u06CC \u0645\u0639\u062A\u0628\u0631 \u0646\u06CC\u0633\u062A"
        },
        dayContext: {
            prevDay: "\u0631\u0648\u0632 \u0642\u0628\u0644",
            nextDay: "\u0631\u0648\u0632 \u0628\u0639\u062F",
            today: "\u0627\u0645\u0631\u0648\u0632",
            backToToday: "\u0628\u0627\u0632\u06AF\u0634\u062A \u0628\u0647 \u0627\u0645\u0631\u0648\u0632",
            pickDay: "\u0627\u0646\u062A\u062E\u0627\u0628 \u0631\u0648\u0632"
        },
        weekPicker: {
            title: "\u0627\u0646\u062A\u062E\u0627\u0628 \u0631\u0648\u0632",
            thisWeek: "\u0627\u06CC\u0646 \u0647\u0641\u062A\u0647",
            nextWeek: "\u0647\u0641\u062A\u0647\u0654 \u0628\u0639\u062F",
            prevWeek: "\u0647\u0641\u062A\u0647\u0654 \u0642\u0628\u0644",
            fullCalendar: "\u062A\u0642\u0648\u06CC\u0645 \u06A9\u0627\u0645\u0644",
            backToWeek: "\u0628\u0627\u0632\u06AF\u0634\u062A \u0628\u0647 \u0647\u0641\u062A\u0647",
            today: "\u0627\u0645\u0631\u0648\u0632",
            close: "\u0628\u0633\u062A\u0646",
            range: (from, to)=>`${from} \u{62A}\u{627} ${to}`,
            countAria: (n)=>`${n} \u{646}\u{648}\u{628}\u{62A}`
        },
        walkIn: {
            suggested: "\u067E\u06CC\u0634\u0646\u0647\u0627\u062F",
            or: "\u06CC\u0627"
        },
        mobileHeader: {
            greeting: "\u062E\u0648\u0634 \u0622\u0645\u062F\u06CC\u062F\u060C",
            clear: "\u067E\u0627\u06A9 \u06A9\u0631\u062F\u0646",
            unknownInitial: "\u061F"
        },
        errorBoundary: {
            title: "\u0627\u06CC\u0646 \u0635\u0641\u062D\u0647 \u0628\u0627\u0632 \u0646\u0634\u062F",
            body: "\u0647\u0646\u06AF\u0627\u0645 \u0646\u0645\u0627\u06CC\u0634 \u0627\u06CC\u0646 \u0635\u0641\u062D\u0647 \u062E\u0637\u0627\u06CC\u06CC \u0631\u062E \u062F\u0627\u062F.",
            retry: "\u062A\u0644\u0627\u0634 \u0645\u062C\u062F\u062F"
        },
        number: {
            invalid: "\u0645\u0642\u062F\u0627\u0631 \u0648\u0627\u0631\u062F \u0634\u062F\u0647 \u0635\u062D\u06CC\u062D \u0646\u06CC\u0633\u062A",
            min: (n)=>`\u{62D}\u{62F}\u{627}\u{642}\u{644} ${n}`,
            max: (n)=>`\u{62D}\u{62F}\u{627}\u{6A9}\u{62B}\u{631} ${n}`
        },
        account: {
            topUp: "\u0634\u0627\u0631\u0698 \u0627\u0639\u062A\u0628\u0627\u0631",
            menu: "\u062D\u0633\u0627\u0628 \u06A9\u0627\u0631\u0628\u0631\u06CC"
        },
        bottomNav: {
            label: "\u0646\u0627\u0648\u0628\u0631\u06CC \u0627\u0635\u0644\u06CC"
        },
        files: {
            phases: {
                queued: "\u062F\u0631 \u0635\u0641",
                preparing: "\u0622\u0645\u0627\u062F\u0647\u200C\u0633\u0627\u0632\u06CC",
                sending: "\u062F\u0631 \u062D\u0627\u0644 \u0627\u0631\u0633\u0627\u0644\u2026",
                done: "\u0627\u0631\u0633\u0627\u0644 \u0634\u062F",
                failed: "\u0627\u0631\u0633\u0627\u0644 \u0646\u0634\u062F"
            },
            remove: "\u062D\u0630\u0641",
            retry: "\u062A\u0644\u0627\u0634 \u0645\u062C\u062F\u062F",
            replace: "\u062C\u0627\u06CC\u06AF\u0632\u06CC\u0646\u06CC",
            drop: "\u0641\u0627\u06CC\u0644\u200C\u0647\u0627 \u0631\u0627 \u0627\u06CC\u0646\u062C\u0627 \u0631\u0647\u0627 \u06A9\u0646\u06CC\u062F \u06CC\u0627 \u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F",
            pick: "\u0627\u0646\u062A\u062E\u0627\u0628 \u0641\u0627\u06CC\u0644",
            camera: "\u0639\u06A9\u0633 \u06AF\u0631\u0641\u062A\u0646",
            directory: "\u0627\u0646\u062A\u062E\u0627\u0628 \u067E\u0648\u0634\u0647",
            dragging: "\u0631\u0647\u0627 \u06A9\u0646\u06CC\u062F"
        },
        imageStack: {
            frame: (i, n)=>`\u{62A}\u{635}\u{648}\u{6CC}\u{631} ${i} \u{627}\u{632} ${n}`,
            prev: "\u062A\u0635\u0648\u06CC\u0631 \u0642\u0628\u0644\u06CC",
            next: "\u062A\u0635\u0648\u06CC\u0631 \u0628\u0639\u062F\u06CC",
            slider: "\u062C\u0627\u0628\u0647\u200C\u062C\u0627\u06CC\u06CC \u0628\u06CC\u0646 \u062A\u0635\u0627\u0648\u06CC\u0631",
            zoomIn: "\u0628\u0632\u0631\u06AF\u200C\u0646\u0645\u0627\u06CC\u06CC",
            zoomOut: "\u06A9\u0648\u0686\u06A9\u200C\u0646\u0645\u0627\u06CC\u06CC",
            reset: "\u0628\u0627\u0632\u0646\u0634\u0627\u0646\u06CC \u0646\u0645\u0627",
            series: "\u0633\u0631\u06CC\u200C\u0647\u0627",
            presets: "\u062A\u0646\u0638\u06CC\u0645 \u0646\u0645\u0627\u06CC\u0634",
            viewport: "\u0646\u0645\u0627\u06CC \u062A\u0635\u0648\u06CC\u0631",
            loading: "\u062F\u0631 \u062D\u0627\u0644 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u062A\u0635\u0648\u06CC\u0631",
            error: "\u062A\u0635\u0648\u06CC\u0631 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u0646\u0634\u062F",
            retry: "\u062A\u0644\u0627\u0634 \u0645\u062C\u062F\u062F",
            empty: "\u062A\u0635\u0648\u06CC\u0631\u06CC \u0628\u0631\u0627\u06CC \u0646\u0645\u0627\u06CC\u0634 \u0646\u06CC\u0633\u062A"
        },
        prizeWheel: {
            label: "\u06AF\u0631\u062F\u0648\u0646\u0647\u0654 \u0634\u0627\u0646\u0633"
        },
        toman: "\u062A\u0648\u0645\u0627\u0646"
    },
    en: {
        pager: {
            prev: 'Previous',
            next: 'Next',
            page: (current, pages)=>`Page ${current} of ${pages}`
        },
        saveBar: {
            save: 'Save changes',
            cancel: 'Cancel',
            saved: 'Saved'
        },
        search: {
            placeholder: "Search\u2026",
            clear: 'Clear search'
        },
        select: {
            placeholder: "Choose\u2026"
        },
        confirm: {
            confirm: 'Confirm',
            cancel: 'Cancel'
        },
        errorState: {
            title: 'Not available',
            retry: 'Try again'
        },
        loading: 'Loading',
        close: 'Close',
        back: 'Back',
        slotGrid: {
            label: 'Free times',
            loading: 'Loading free times'
        },
        phone: {
            label: 'Mobile number',
            country: 'Country',
            countrySearch: 'Search country or code',
            countryNoMatch: 'No country found',
            required: 'Enter a mobile number',
            tooShort: (ctx)=>`This ${ctx.countryName} number is too short \u{2014} e.g. ${ctx.example}`,
            tooLong: (ctx)=>`This ${ctx.countryName} number is too long \u{2014} e.g. ${ctx.example}`,
            notMobile: (ctx)=>`That is not a mobile number \u{2014} e.g. ${ctx.example}`,
            invalid: 'That is not a valid number'
        },
        phoneRelation: {
            self: 'Patient',
            spouse: 'Spouse',
            father: 'Father',
            mother: 'Mother',
            child: 'Child',
            sibling: 'Sibling',
            legal_guardian: 'Legal guardian',
            caregiver: 'Caregiver',
            other: 'Other',
            unknown: 'Unknown'
        },
        phoneNumber: {
            copy: 'Copy number',
            copied: 'Copied',
            call: 'Call',
            empty: 'No number'
        },
        phoneList: {
            title: 'Contact numbers',
            otherLabel: 'Other number',
            relationLabel: 'Whose number',
            relationPlaceholder: "Choose\u2026",
            primary: 'Main',
            primaryLabel: 'Main number',
            primaryHint: 'Texts and appointment reminders go to the main number.',
            landline: 'Landline',
            add: 'Another number',
            addLabel: 'Add another number',
            remove: 'Remove this number',
            limit: (n)=>`At most ${n} numbers`,
            relationRequired: 'Choose whose number this is',
            duplicate: 'This number is already in the list',
            locked: 'The patient verified this number with a code; only they can remove or change it.',
            cannotRemoveLast: 'The last number cannot be removed; write the right number in its place.'
        },
        phoneCandidates: {
            birthYear: (y)=>`Born ${y}`,
            fileNumber: (n)=>`File ${n}`,
            male: 'Male',
            female: 'Female',
            hasAppAccount: 'Has an app account',
            inYourList: 'In your list',
            alreadyInList: 'Already in your list',
            addToList: 'Add to list',
            adding: "Adding\u2026",
            linkFailed: 'Could not add this record; try again.',
            newOnSameNumber: 'New patient on this number',
            matchedOther: 'Found by another number'
        },
        dateRange: {
            title: 'Date range',
            custom: 'Custom range',
            from: 'From',
            to: 'To',
            needBoth: 'Pick both dates to apply'
        },
        filters: {
            title: 'Filters',
            clear: 'Clear filters',
            showResults: 'Show results',
            applyRange: 'Apply range',
            activeCount: (n)=>`Filters \u{2014} ${n} active`,
            emptyTitle: 'Nothing matches these filters',
            emptyHint: 'Change or clear the filters'
        },
        connectivity: {
            offline: "You are offline \u2014 changes are not being saved",
            degraded: "Cannot reach the server \u2014 retrying",
            restored: 'Connection restored',
            retry: 'Try again',
            busy: "Checking\u2026"
        },
        nationalId: {
            label: 'National ID',
            genericLabel: 'National ID number',
            country: 'Issuing country',
            placeholder: (n)=>`${n} digits`,
            required: 'Enter the national ID',
            incomplete: (n)=>`A national ID has ${n} digits`,
            tooShort: (n)=>`Enter at least ${n} characters`,
            invalid: 'That national ID is not valid',
            valid: 'National ID is valid',
            notValid: 'National ID is not valid'
        },
        dayContext: {
            prevDay: 'Previous day',
            nextDay: 'Next day',
            today: 'Today',
            backToToday: 'Back to today',
            pickDay: 'Pick a day'
        },
        weekPicker: {
            title: 'Pick a day',
            thisWeek: 'This week',
            nextWeek: 'Next week',
            prevWeek: 'Last week',
            fullCalendar: 'Full calendar',
            backToWeek: 'Back to the week',
            today: 'Today',
            close: 'Close',
            range: (from, to)=>`${from} \u{2013} ${to}`,
            countAria: (n)=>`${n} appointments`
        },
        walkIn: {
            suggested: 'Suggested',
            or: 'or'
        },
        mobileHeader: {
            greeting: 'Welcome,',
            clear: 'Clear',
            unknownInitial: '?'
        },
        errorBoundary: {
            title: 'This page did not open',
            body: 'Something went wrong while showing this page.',
            retry: 'Try again'
        },
        number: {
            invalid: 'That is not a valid number',
            min: (n)=>`At least ${n}`,
            max: (n)=>`At most ${n}`
        },
        account: {
            topUp: 'Top up credit',
            menu: 'Account'
        },
        bottomNav: {
            label: 'Main navigation'
        },
        files: {
            phases: {
                queued: 'Queued',
                preparing: 'Preparing',
                sending: "Uploading\u2026",
                done: 'Uploaded',
                failed: 'Not uploaded'
            },
            remove: 'Remove',
            retry: 'Try again',
            replace: 'Replace',
            drop: 'Drop files here or choose them',
            pick: 'Choose files',
            camera: 'Take a photo',
            directory: 'Choose a folder',
            dragging: 'Drop them'
        },
        imageStack: {
            frame: (i, n)=>`Image ${i} of ${n}`,
            prev: 'Previous image',
            next: 'Next image',
            slider: 'Move between images',
            zoomIn: 'Zoom in',
            zoomOut: 'Zoom out',
            reset: 'Reset view',
            series: 'Series',
            presets: 'Display settings',
            viewport: 'Image view',
            loading: 'Loading image',
            error: 'The image did not load',
            retry: 'Try again',
            empty: 'No image to show'
        },
        prizeWheel: {
            label: 'Prize wheel'
        },
        toman: 'toman'
    },
    ar: {
        pager: {
            prev: "\u0627\u0644\u0633\u0627\u0628\u0642",
            next: "\u0627\u0644\u062A\u0627\u0644\u064A",
            page: (current, pages)=>`\u{627}\u{644}\u{635}\u{641}\u{62D}\u{629} ${current} \u{645}\u{646} ${pages}`
        },
        saveBar: {
            save: "\u062D\u0641\u0638 \u0627\u0644\u062A\u063A\u064A\u064A\u0631\u0627\u062A",
            cancel: "\u0625\u0644\u063A\u0627\u0621",
            saved: "\u062A\u0645 \u0627\u0644\u062D\u0641\u0638"
        },
        search: {
            placeholder: "\u0628\u062D\u062B...",
            clear: "\u0645\u0633\u062D \u0627\u0644\u0628\u062D\u062B"
        },
        select: {
            placeholder: "\u0627\u062E\u062A\u0631..."
        },
        confirm: {
            confirm: "\u062A\u0623\u0643\u064A\u062F",
            cancel: "\u0625\u0644\u063A\u0627\u0621"
        },
        errorState: {
            title: "\u063A\u064A\u0631 \u0645\u062A\u0627\u062D",
            retry: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629"
        },
        loading: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0645\u064A\u0644",
        close: "\u0625\u063A\u0644\u0627\u0642",
        back: "\u0631\u062C\u0648\u0639",
        slotGrid: {
            label: "\u0627\u0644\u0623\u0648\u0642\u0627\u062A \u0627\u0644\u0645\u062A\u0627\u062D\u0629",
            loading: "\u062C\u0627\u0631\u064D \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0623\u0648\u0642\u0627\u062A \u0627\u0644\u0645\u062A\u0627\u062D\u0629"
        },
        phone: {
            label: "\u0631\u0642\u0645 \u0627\u0644\u062C\u0648\u0627\u0644",
            country: "\u0627\u0644\u062F\u0648\u0644\u0629",
            countrySearch: "\u0627\u0628\u062D\u062B \u0639\u0646 \u062F\u0648\u0644\u0629 \u0623\u0648 \u0631\u0645\u0632",
            countryNoMatch: "\u0644\u0645 \u064A\u062A\u0645 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u062F\u0648\u0644\u0629",
            required: "\u0623\u062F\u062E\u0644 \u0631\u0642\u0645 \u0627\u0644\u062C\u0648\u0627\u0644",
            tooShort: (ctx)=>`\u{631}\u{642}\u{645} ${ctx.countryName} \u{642}\u{635}\u{64A}\u{631} \u{2014} \u{645}\u{62B}\u{627}\u{644}: ${ctx.example}`,
            tooLong: (ctx)=>`\u{631}\u{642}\u{645} ${ctx.countryName} \u{637}\u{648}\u{64A}\u{644} \u{2014} \u{645}\u{62B}\u{627}\u{644}: ${ctx.example}`,
            notMobile: (ctx)=>`\u{647}\u{630}\u{627} \u{644}\u{64A}\u{633} \u{631}\u{642}\u{645} \u{62C}\u{648}\u{627}\u{644} \u{2014} \u{645}\u{62B}\u{627}\u{644}: ${ctx.example}`,
            invalid: "\u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u0645\u064F\u062F\u062E\u064E\u0644 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D"
        },
        phoneRelation: {
            self: "\u0627\u0644\u0645\u0631\u064A\u0636 \u0646\u0641\u0633\u0647",
            spouse: "\u0627\u0644\u0632\u0648\u062C \u0623\u0648 \u0627\u0644\u0632\u0648\u062C\u0629",
            father: "\u0627\u0644\u0623\u0628",
            mother: "\u0627\u0644\u0623\u0645",
            child: "\u0627\u0644\u0627\u0628\u0646 \u0623\u0648 \u0627\u0644\u0627\u0628\u0646\u0629",
            sibling: "\u0627\u0644\u0623\u062E \u0623\u0648 \u0627\u0644\u0623\u062E\u062A",
            legal_guardian: "\u0627\u0644\u0648\u0635\u064A \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A",
            caregiver: "\u0645\u0642\u062F\u0651\u0645 \u0627\u0644\u0631\u0639\u0627\u064A\u0629",
            other: "\u063A\u064A\u0631 \u0630\u0644\u0643",
            unknown: "\u063A\u064A\u0631 \u0645\u062D\u062F\u062F"
        },
        phoneNumber: {
            copy: "\u0646\u0633\u062E \u0627\u0644\u0631\u0642\u0645",
            copied: "\u062A\u0645 \u0627\u0644\u0646\u0633\u062E",
            call: "\u0627\u062A\u0635\u0627\u0644",
            empty: "\u0628\u0644\u0627 \u0631\u0642\u0645"
        },
        phoneList: {
            title: "\u0623\u0631\u0642\u0627\u0645 \u0627\u0644\u0627\u062A\u0635\u0627\u0644",
            otherLabel: "\u0631\u0642\u0645 \u0622\u062E\u0631",
            relationLabel: "\u0635\u0627\u062D\u0628 \u0627\u0644\u0631\u0642\u0645",
            relationPlaceholder: "\u0627\u062E\u062A\u0631...",
            primary: "\u0631\u0626\u064A\u0633\u064A",
            primaryLabel: "\u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u0631\u0626\u064A\u0633\u064A",
            primaryHint: "\u062A\u064F\u0631\u0633\u0644 \u0627\u0644\u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u0646\u0635\u064A\u0629 \u0648\u062A\u0630\u0643\u064A\u0631\u0627\u062A \u0627\u0644\u0645\u0648\u0627\u0639\u064A\u062F \u0625\u0644\u0649 \u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u0631\u0626\u064A\u0633\u064A.",
            landline: "\u0647\u0627\u062A\u0641 \u0623\u0631\u0636\u064A",
            add: "\u0631\u0642\u0645 \u0622\u062E\u0631",
            addLabel: "\u0625\u0636\u0627\u0641\u0629 \u0631\u0642\u0645 \u0622\u062E\u0631",
            remove: "\u062D\u0630\u0641 \u0647\u0630\u0627 \u0627\u0644\u0631\u0642\u0645",
            limit: (n)=>`\u{627}\u{644}\u{62D}\u{62F} \u{627}\u{644}\u{623}\u{642}\u{635}\u{649} \u{644}\u{644}\u{623}\u{631}\u{642}\u{627}\u{645}: ${n}`,
            relationRequired: "\u0627\u062E\u062A\u0631 \u0635\u0627\u062D\u0628 \u0647\u0630\u0627 \u0627\u0644\u0631\u0642\u0645",
            duplicate: "\u0647\u0630\u0627 \u0627\u0644\u0631\u0642\u0645 \u0645\u0630\u0643\u0648\u0631 \u0641\u064A \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0645\u0646 \u0642\u0628\u0644",
            locked: "\u0623\u0643\u0651\u062F \u0627\u0644\u0645\u0631\u064A\u0636 \u0647\u0630\u0627 \u0627\u0644\u0631\u0642\u0645 \u0628\u0631\u0645\u0632\u061B \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u0644\u063A\u064A\u0631\u0647 \u062D\u0630\u0641\u0647 \u0623\u0648 \u062A\u063A\u064A\u064A\u0631\u0647.",
            cannotRemoveLast: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u062D\u0630\u0641 \u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u0623\u062E\u064A\u0631\u061B \u0627\u0643\u062A\u0628 \u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u0635\u062D\u064A\u062D \u0645\u0643\u0627\u0646\u0647."
        },
        phoneCandidates: {
            birthYear: (y)=>`\u{645}\u{648}\u{627}\u{644}\u{64A}\u{62F} ${y}`,
            fileNumber: (n)=>`\u{627}\u{644}\u{645}\u{644}\u{641} ${n}`,
            male: "\u0630\u0643\u0631",
            female: "\u0623\u0646\u062B\u0649",
            hasAppAccount: "\u0644\u062F\u064A\u0647 \u062D\u0633\u0627\u0628 \u0641\u064A \u0627\u0644\u062A\u0637\u0628\u064A\u0642",
            inYourList: "\u0641\u064A \u0642\u0627\u0626\u0645\u062A\u0643",
            alreadyInList: "\u0645\u0648\u062C\u0648\u062F \u0641\u064A \u0642\u0627\u0626\u0645\u062A\u0643",
            addToList: "\u0625\u0636\u0627\u0641\u0629 \u0625\u0644\u0649 \u0627\u0644\u0642\u0627\u0626\u0645\u0629",
            adding: "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0636\u0627\u0641\u0629\u2026",
            linkFailed: "\u062A\u0639\u0630\u0651\u0631\u062A \u0625\u0636\u0627\u0641\u0629 \u0647\u0630\u0627 \u0627\u0644\u0645\u0644\u0641\u061B \u062D\u0627\u0648\u0644 \u0645\u062C\u062F\u062F\u0627\u064B.",
            newOnSameNumber: "\u0645\u0631\u064A\u0636 \u062C\u062F\u064A\u062F \u0628\u0627\u0644\u0631\u0642\u0645 \u0646\u0641\u0633\u0647",
            matchedOther: "\u0648\u064F\u062C\u062F \u0639\u0628\u0631 \u0631\u0642\u0645 \u0622\u062E\u0631"
        },
        dateRange: {
            title: "\u0627\u0644\u0641\u062A\u0631\u0629 \u0627\u0644\u0632\u0645\u0646\u064A\u0629",
            custom: "\u0641\u062A\u0631\u0629 \u0645\u062E\u0635\u0635\u0629",
            from: "\u0645\u0646 \u062A\u0627\u0631\u064A\u062E",
            to: "\u0625\u0644\u0649 \u062A\u0627\u0631\u064A\u062E",
            needBoth: "\u0627\u062E\u062A\u0631 \u0627\u0644\u062A\u0627\u0631\u064A\u062E\u064A\u0646 \u0644\u062A\u0637\u0628\u064A\u0642 \u0627\u0644\u0641\u062A\u0631\u0629"
        },
        filters: {
            title: "\u0639\u0648\u0627\u0645\u0644 \u0627\u0644\u062A\u0635\u0641\u064A\u0629",
            clear: "\u0645\u0633\u062D \u0639\u0648\u0627\u0645\u0644 \u0627\u0644\u062A\u0635\u0641\u064A\u0629",
            showResults: "\u0639\u0631\u0636 \u0627\u0644\u0646\u062A\u0627\u0626\u062C",
            applyRange: "\u062A\u0637\u0628\u064A\u0642 \u0627\u0644\u0641\u062A\u0631\u0629",
            activeCount: (n)=>`\u{639}\u{648}\u{627}\u{645}\u{644} \u{627}\u{644}\u{62A}\u{635}\u{641}\u{64A}\u{629} \u{2014} ${n} \u{645}\u{641}\u{639}\u{651}\u{644}\u{629}`,
            emptyTitle: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0646\u062A\u0627\u0626\u062C \u062A\u0637\u0627\u0628\u0642 \u0639\u0648\u0627\u0645\u0644 \u0627\u0644\u062A\u0635\u0641\u064A\u0629 \u0647\u0630\u0647",
            emptyHint: "\u063A\u064A\u0651\u0631 \u0639\u0648\u0627\u0645\u0644 \u0627\u0644\u062A\u0635\u0641\u064A\u0629 \u0623\u0648 \u0627\u0645\u0633\u062D\u0647\u0627"
        },
        connectivity: {
            offline: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0627\u062A\u0635\u0627\u0644 \u0628\u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A \u2014 \u0644\u0627 \u062A\u064F\u062D\u0641\u0638 \u0627\u0644\u062A\u063A\u064A\u064A\u0631\u0627\u062A",
            degraded: "\u062A\u0639\u0630\u0651\u0631 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0627\u0644\u062E\u0627\u062F\u0645 \u2014 \u062C\u0627\u0631\u064D \u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629",
            restored: "\u0639\u0627\u062F \u0627\u0644\u0627\u062A\u0635\u0627\u0644",
            retry: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629",
            busy: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0642\u0642\u2026"
        },
        nationalId: {
            label: "\u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u0648\u0637\u0646\u064A",
            genericLabel: "\u0631\u0642\u0645 \u0627\u0644\u0647\u0648\u064A\u0629 \u0627\u0644\u0648\u0637\u0646\u064A\u0629",
            country: "\u0628\u0644\u062F \u0627\u0644\u0625\u0635\u062F\u0627\u0631",
            placeholder: (n)=>`${n} \u{623}\u{631}\u{642}\u{627}\u{645}`,
            required: "\u0623\u062F\u062E\u0644 \u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u0648\u0637\u0646\u064A",
            incomplete: (n)=>`\u{627}\u{644}\u{631}\u{642}\u{645} \u{627}\u{644}\u{648}\u{637}\u{646}\u{64A} \u{64A}\u{62A}\u{643}\u{648}\u{651}\u{646} \u{645}\u{646} ${n} \u{623}\u{631}\u{642}\u{627}\u{645}`,
            tooShort: (n)=>`\u{623}\u{62F}\u{62E}\u{644} ${n} \u{623}\u{62D}\u{631}\u{641} \u{639}\u{644}\u{649} \u{627}\u{644}\u{623}\u{642}\u{644}`,
            invalid: "\u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u0648\u0637\u0646\u064A \u0627\u0644\u0645\u064F\u062F\u062E\u064E\u0644 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
            valid: "\u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u0648\u0637\u0646\u064A \u0635\u0627\u0644\u062D",
            notValid: "\u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u0648\u0637\u0646\u064A \u063A\u064A\u0631 \u0635\u0627\u0644\u062D"
        },
        dayContext: {
            prevDay: "\u0627\u0644\u064A\u0648\u0645 \u0627\u0644\u0633\u0627\u0628\u0642",
            nextDay: "\u0627\u0644\u064A\u0648\u0645 \u0627\u0644\u062A\u0627\u0644\u064A",
            today: "\u0627\u0644\u064A\u0648\u0645",
            backToToday: "\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u064A\u0648\u0645",
            pickDay: "\u0627\u062E\u062A\u064A\u0627\u0631 \u064A\u0648\u0645"
        },
        weekPicker: {
            title: "\u0627\u062E\u062A\u064A\u0627\u0631 \u064A\u0648\u0645",
            thisWeek: "\u0647\u0630\u0627 \u0627\u0644\u0623\u0633\u0628\u0648\u0639",
            nextWeek: "\u0627\u0644\u0623\u0633\u0628\u0648\u0639 \u0627\u0644\u0642\u0627\u062F\u0645",
            prevWeek: "\u0627\u0644\u0623\u0633\u0628\u0648\u0639 \u0627\u0644\u0645\u0627\u0636\u064A",
            fullCalendar: "\u0627\u0644\u062A\u0642\u0648\u064A\u0645 \u0627\u0644\u0643\u0627\u0645\u0644",
            backToWeek: "\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0623\u0633\u0628\u0648\u0639",
            today: "\u0627\u0644\u064A\u0648\u0645",
            close: "\u0625\u063A\u0644\u0627\u0642",
            range: (from, to)=>`${from} \u{2013} ${to}`,
            countAria: (n)=>`${n} \u{645}\u{648}\u{627}\u{639}\u{64A}\u{62F}`
        },
        walkIn: {
            suggested: "\u0645\u0642\u062A\u0631\u062D",
            or: "\u0623\u0648"
        },
        mobileHeader: {
            greeting: "\u0623\u0647\u0644\u0627\u064B\u060C",
            clear: "\u0645\u0633\u062D",
            unknownInitial: "\u061F"
        },
        errorBoundary: {
            title: "\u062A\u0639\u0630\u0651\u0631 \u0641\u062A\u062D \u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629",
            body: "\u062D\u062F\u062B \u062E\u0637\u0623 \u0623\u062B\u0646\u0627\u0621 \u0639\u0631\u0636 \u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629.",
            retry: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629"
        },
        number: {
            invalid: "\u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u064F\u062F\u062E\u064E\u0644\u0629 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D\u0629",
            min: (n)=>`\u{627}\u{644}\u{62D}\u{62F} \u{627}\u{644}\u{623}\u{62F}\u{646}\u{649} ${n}`,
            max: (n)=>`\u{627}\u{644}\u{62D}\u{62F} \u{627}\u{644}\u{623}\u{642}\u{635}\u{649} ${n}`
        },
        account: {
            topUp: "\u0634\u062D\u0646 \u0627\u0644\u0631\u0635\u064A\u062F",
            menu: "\u0627\u0644\u062D\u0633\u0627\u0628"
        },
        bottomNav: {
            label: "\u0627\u0644\u062A\u0646\u0642\u0644 \u0627\u0644\u0631\u0626\u064A\u0633\u064A"
        },
        files: {
            phases: {
                queued: "\u0641\u064A \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631",
                preparing: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0636\u064A\u0631",
                sending: "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0631\u0633\u0627\u0644\u2026",
                done: "\u062A\u0645 \u0627\u0644\u0625\u0631\u0633\u0627\u0644",
                failed: "\u0644\u0645 \u064A\u064F\u0631\u0633\u0644"
            },
            remove: "\u062D\u0630\u0641",
            retry: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629",
            replace: "\u0627\u0633\u062A\u0628\u062F\u0627\u0644",
            drop: "\u0623\u0641\u0644\u062A \u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0647\u0646\u0627 \u0623\u0648 \u0627\u062E\u062A\u0631\u0647\u0627",
            pick: "\u0627\u062E\u062A\u064A\u0627\u0631 \u0645\u0644\u0641",
            camera: "\u0627\u0644\u062A\u0642\u0627\u0637 \u0635\u0648\u0631\u0629",
            directory: "\u0627\u062E\u062A\u064A\u0627\u0631 \u0645\u062C\u0644\u062F",
            dragging: "\u0623\u0641\u0644\u062A\u0647\u0627 \u0647\u0646\u0627"
        },
        imageStack: {
            frame: (i, n)=>`\u{627}\u{644}\u{635}\u{648}\u{631}\u{629} ${i} \u{645}\u{646} ${n}`,
            prev: "\u0627\u0644\u0635\u0648\u0631\u0629 \u0627\u0644\u0633\u0627\u0628\u0642\u0629",
            next: "\u0627\u0644\u0635\u0648\u0631\u0629 \u0627\u0644\u062A\u0627\u0644\u064A\u0629",
            slider: "\u0627\u0644\u062A\u0646\u0642\u0644 \u0628\u064A\u0646 \u0627\u0644\u0635\u0648\u0631",
            zoomIn: "\u062A\u0643\u0628\u064A\u0631",
            zoomOut: "\u062A\u0635\u063A\u064A\u0631",
            reset: "\u0625\u0639\u0627\u062F\u0629 \u0636\u0628\u0637 \u0627\u0644\u0639\u0631\u0636",
            series: "\u0627\u0644\u0633\u0644\u0627\u0633\u0644",
            presets: "\u0625\u0639\u062F\u0627\u062F\u0627\u062A \u0627\u0644\u0639\u0631\u0636",
            viewport: "\u0639\u0631\u0636 \u0627\u0644\u0635\u0648\u0631\u0629",
            loading: "\u062C\u0627\u0631\u064D \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0635\u0648\u0631\u0629",
            error: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0635\u0648\u0631\u0629",
            retry: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629",
            empty: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0635\u0648\u0631\u0629 \u0644\u0644\u0639\u0631\u0636"
        },
        prizeWheel: {
            label: "\u0639\u062C\u0644\u0629 \u0627\u0644\u062D\u0638"
        },
        toman: "\u062A\u0648\u0645\u0627\u0646"
    },
    // French (PM-0185): formal «vous», U+00A0 before ':', U+202F before ; ! ?,
    // the typographic apostrophe and a one-character ellipsis.
    fr: {
        pager: {
            prev: "Pr\xe9c\xe9dent",
            next: 'Suivant',
            page: (current, pages)=>`Page ${current} sur ${pages}`
        },
        saveBar: {
            save: 'Enregistrer les modifications',
            cancel: 'Annuler',
            saved: "Modifications enregistr\xe9es"
        },
        search: {
            placeholder: "Rechercher\u2026",
            clear: 'Effacer la recherche'
        },
        select: {
            placeholder: "Choisir\u2026"
        },
        confirm: {
            confirm: 'Confirmer',
            cancel: 'Annuler'
        },
        errorState: {
            title: 'Indisponible',
            retry: "R\xe9essayer"
        },
        loading: 'Chargement',
        close: 'Fermer',
        back: 'Retour',
        slotGrid: {
            label: "Cr\xe9neaux libres",
            loading: "Chargement des cr\xe9neaux libres"
        },
        phone: {
            label: "N\xb0 de portable",
            country: 'Pays',
            countrySearch: 'Rechercher un pays ou un indicatif',
            countryNoMatch: "Aucun pays trouv\xe9",
            required: "Saisissez un num\xe9ro de portable",
            // A French country name takes an article («l’Iran», «les Émirats»)
            // that a name passed in cannot carry, so it leads the message as a label.
            tooShort: (ctx)=>`${ctx.countryName}\xa0: num\xe9ro trop court \u{2014} ex.\xa0: ${ctx.example}`,
            tooLong: (ctx)=>`${ctx.countryName}\xa0: num\xe9ro trop long \u{2014} ex.\xa0: ${ctx.example}`,
            notMobile: (ctx)=>`Ce n\u{2019}est pas un num\xe9ro de portable \u{2014} ex.\xa0: ${ctx.example}`,
            invalid: "Ce num\xe9ro n\u2019est pas valide"
        },
        phoneRelation: {
            self: 'Patient',
            spouse: 'Conjoint',
            father: "P\xe8re",
            mother: "M\xe8re",
            child: 'Enfant',
            sibling: "Fr\xe8re ou s\u0153ur",
            legal_guardian: "Tuteur l\xe9gal",
            caregiver: 'Aidant',
            other: 'Autre',
            unknown: 'Inconnu'
        },
        phoneNumber: {
            copy: "Copier le num\xe9ro",
            copied: "Copi\xe9",
            call: 'Appeler',
            empty: "Aucun num\xe9ro"
        },
        phoneList: {
            title: "Num\xe9ros de contact",
            otherLabel: "Autre num\xe9ro",
            relationLabel: "Titulaire du num\xe9ro",
            relationPlaceholder: "Choisir\u2026",
            primary: 'Principal',
            primaryLabel: "Num\xe9ro principal",
            primaryHint: "Les SMS et les rappels de rendez-vous sont envoy\xe9s au num\xe9ro principal.",
            landline: "T\xe9l\xe9phone fixe",
            add: "Autre num\xe9ro",
            addLabel: "Ajouter un autre num\xe9ro",
            remove: "Supprimer ce num\xe9ro",
            limit: (n)=>`Maximum\xa0: ${n}\xa0num\xe9ros`,
            relationRequired: "Indiquez le titulaire de ce num\xe9ro",
            duplicate: "Ce num\xe9ro figure d\xe9j\xe0 dans la liste",
            locked: "Le patient a v\xe9rifi\xe9 ce num\xe9ro par code\u202F; lui seul peut le supprimer ou le modifier.",
            cannotRemoveLast: "Le dernier num\xe9ro ne peut pas \xeatre supprim\xe9\u202F; \xe9crivez le bon num\xe9ro \xe0 sa place."
        },
        phoneCandidates: {
            birthYear: (y)=>`N\xe9(e) en ${y}`,
            fileNumber: (n)=>`Dossier n\xb0\xa0${n}`,
            male: 'Homme',
            female: 'Femme',
            hasAppAccount: "Poss\xe8de un compte dans l\u2019application",
            inYourList: 'Dans votre liste',
            alreadyInList: "D\xe9j\xe0 dans votre liste",
            addToList: "Ajouter \xe0 la liste",
            adding: "Ajout\u2026",
            linkFailed: "Impossible d\u2019ajouter ce dossier\u202F; veuillez r\xe9essayer.",
            newOnSameNumber: "Nouveau patient sur ce num\xe9ro",
            matchedOther: "Trouv\xe9 par un autre num\xe9ro"
        },
        dateRange: {
            title: "P\xe9riode",
            custom: "P\xe9riode personnalis\xe9e",
            from: 'Du',
            to: 'Au',
            needBoth: "Choisissez les deux dates pour appliquer la p\xe9riode"
        },
        filters: {
            title: 'Filtres',
            clear: 'Effacer les filtres',
            showResults: "Afficher les r\xe9sultats",
            applyRange: "Appliquer la p\xe9riode",
            activeCount: (n)=>`Filtres\xa0: ${n} actifs`,
            emptyTitle: "Aucun r\xe9sultat avec ces filtres",
            emptyHint: 'Modifiez ou effacez les filtres'
        },
        connectivity: {
            offline: "Vous \xeates hors ligne \u2014 les modifications ne sont pas enregistr\xe9es",
            degraded: "Impossible de joindre le serveur \u2014 nouvelle tentative en cours",
            restored: "Connexion r\xe9tablie",
            retry: "R\xe9essayer",
            busy: "V\xe9rification\u2026"
        },
        nationalId: {
            label: "Num\xe9ro national",
            genericLabel: "Num\xe9ro d\u2019identification national",
            country: "Pays de d\xe9livrance",
            // `n` is never below 5, so the noun after it is always plural.
            placeholder: (n)=>`${n} chiffres`,
            required: "Saisissez le num\xe9ro national",
            incomplete: (n)=>`Le num\xe9ro national doit comporter ${n} chiffres`,
            tooShort: (n)=>`Saisissez au moins ${n} caract\xe8res`,
            invalid: "Ce num\xe9ro national n\u2019est pas valide",
            valid: "Num\xe9ro national valide",
            notValid: "Num\xe9ro national non valide"
        },
        dayContext: {
            prevDay: "Jour pr\xe9c\xe9dent",
            nextDay: 'Jour suivant',
            today: "Aujourd\u2019hui",
            backToToday: "Revenir \xe0 aujourd\u2019hui",
            pickDay: 'Choisir un jour'
        },
        weekPicker: {
            title: 'Choisir un jour',
            thisWeek: 'Cette semaine',
            nextWeek: 'Semaine prochaine',
            prevWeek: "Semaine derni\xe8re",
            fullCalendar: 'Calendrier complet',
            backToWeek: "Revenir \xe0 la semaine",
            today: "Aujourd\u2019hui",
            close: 'Fermer',
            range: (from, to)=>`${from} \u{2013} ${to}`,
            countAria: (n)=>`${n} rendez-vous`
        },
        walkIn: {
            suggested: "Sugg\xe9r\xe9",
            or: 'ou'
        },
        mobileHeader: {
            greeting: 'Bienvenue,',
            clear: 'Effacer',
            unknownInitial: '?'
        },
        errorBoundary: {
            title: "Impossible d\u2019ouvrir cette page",
            body: "Une erreur s\u2019est produite lors de l\u2019affichage de cette page.",
            retry: "R\xe9essayer"
        },
        number: {
            invalid: "Ce n\u2019est pas un nombre valide",
            min: (n)=>`Minimum\xa0: ${n}`,
            max: (n)=>`Maximum\xa0: ${n}`
        },
        account: {
            topUp: "Recharger le cr\xe9dit",
            menu: 'Compte'
        },
        bottomNav: {
            label: 'Navigation principale'
        },
        files: {
            phases: {
                queued: "En file d\u2019attente",
                preparing: "Pr\xe9paration",
                sending: "Import\u2026",
                done: "Import\xe9",
                failed: "\xc9chec de l\u2019import"
            },
            remove: 'Retirer',
            retry: "R\xe9essayer",
            replace: 'Remplacer',
            drop: "D\xe9posez les fichiers ici ou choisissez-les",
            pick: 'Choisir des fichiers',
            camera: 'Prendre une photo',
            directory: 'Choisir un dossier',
            dragging: "D\xe9posez-les ici"
        },
        imageStack: {
            frame: (i, n)=>`Image ${i} sur ${n}`,
            prev: "Image pr\xe9c\xe9dente",
            next: 'Image suivante',
            slider: 'Naviguer entre les images',
            zoomIn: 'Zoom avant',
            zoomOut: "Zoom arri\xe8re",
            reset: "R\xe9initialiser la vue",
            series: "S\xe9ries",
            presets: "Param\xe8tres d\u2019affichage",
            viewport: "Vue de l\u2019image",
            loading: "Chargement de l\u2019image",
            error: "Impossible de charger l\u2019image",
            retry: "R\xe9essayer",
            empty: "Aucune image \xe0 afficher"
        },
        prizeWheel: {
            label: 'Roue de la chance'
        },
        toman: 'toman'
    },
    // German (PM-0212): formal «Sie», infinitive buttons, no space of any kind
    // before : ; ! ?, „…“ quotes, a one-character ellipsis and the en dash with a
    // space either side. Counts arrive pre-localised and German has no
    // count-neutral noun, so a count reads as a label («Termine: 3»).
    de: {
        pager: {
            prev: "Zur\xfcck",
            next: 'Weiter',
            page: (current, pages)=>`Seite ${current} von ${pages}`
        },
        saveBar: {
            save: "\xc4nderungen speichern",
            cancel: 'Abbrechen',
            saved: 'Gespeichert'
        },
        search: {
            placeholder: "Suchen\u2026",
            clear: "Suche l\xf6schen"
        },
        select: {
            placeholder: "Ausw\xe4hlen\u2026"
        },
        confirm: {
            confirm: "Best\xe4tigen",
            cancel: 'Abbrechen'
        },
        errorState: {
            title: "Nicht verf\xfcgbar",
            retry: 'Erneut versuchen'
        },
        loading: 'Wird geladen',
        close: "Schlie\xdfen",
        back: "Zur\xfcck",
        slotGrid: {
            label: 'Freie Termine',
            loading: 'Freie Termine werden geladen'
        },
        phone: {
            label: 'Mobilnummer',
            country: 'Land',
            countrySearch: 'Land oder Vorwahl suchen',
            countryNoMatch: 'Kein Land gefunden',
            required: 'Geben Sie eine Mobilnummer ein',
            // Some German country names take an article («der Iran», «die Türkei»)
            // that a name passed in cannot carry, so it leads the message as a label.
            tooShort: (ctx)=>`${ctx.countryName}: Nummer zu kurz \u{2013} z. B. ${ctx.example}`,
            tooLong: (ctx)=>`${ctx.countryName}: Nummer zu lang \u{2013} z. B. ${ctx.example}`,
            notMobile: (ctx)=>`Das ist keine Mobilnummer \u{2013} z. B. ${ctx.example}`,
            invalid: "Diese Nummer ist ung\xfcltig"
        },
        phoneRelation: {
            self: 'Patient',
            spouse: 'Ehepartner',
            father: 'Vater',
            mother: 'Mutter',
            child: 'Kind',
            sibling: 'Geschwister',
            legal_guardian: 'Gesetzlicher Vormund',
            caregiver: 'Betreuungsperson',
            other: 'Andere',
            unknown: 'Unbekannt'
        },
        phoneNumber: {
            copy: 'Nummer kopieren',
            copied: 'Kopiert',
            call: 'Anrufen',
            empty: 'Keine Nummer'
        },
        phoneList: {
            title: 'Kontaktnummern',
            otherLabel: 'Weitere Nummer',
            relationLabel: 'Inhaber der Nummer',
            relationPlaceholder: "Ausw\xe4hlen\u2026",
            primary: 'Hauptnummer',
            primaryLabel: 'Hauptnummer',
            primaryHint: 'SMS und Terminerinnerungen gehen an die Hauptnummer.',
            landline: 'Festnetz',
            add: 'Weitere Nummer',
            addLabel: "Weitere Nummer hinzuf\xfcgen",
            remove: 'Diese Nummer entfernen',
            limit: (n)=>`H\xf6chstens ${n} Nummern`,
            relationRequired: "W\xe4hlen Sie, wem diese Nummer geh\xf6rt",
            duplicate: 'Diese Nummer steht bereits in der Liste',
            locked: "Der Patient hat diese Nummer per Code best\xe4tigt; nur er kann sie entfernen oder \xe4ndern.",
            cannotRemoveLast: 'Die letzte Nummer kann nicht entfernt werden; tragen Sie stattdessen die richtige Nummer ein.'
        },
        phoneCandidates: {
            birthYear: (y)=>`Jahrgang ${y}`,
            fileNumber: (n)=>`Akten-Nr. ${n}`,
            male: "M\xe4nnlich",
            female: 'Weiblich',
            hasAppAccount: 'Hat ein App-Konto',
            inYourList: 'In Ihrer Liste',
            alreadyInList: 'Bereits in Ihrer Liste',
            addToList: "Zur Liste hinzuf\xfcgen",
            adding: "Wird hinzugef\xfcgt\u2026",
            linkFailed: "Diese Akte konnte nicht hinzugef\xfcgt werden. Bitte versuchen Sie es erneut.",
            newOnSameNumber: 'Neuer Patient mit dieser Nummer',
            matchedOther: "\xdcber eine andere Nummer gefunden"
        },
        dateRange: {
            title: 'Zeitraum',
            custom: 'Benutzerdefinierter Zeitraum',
            from: 'Von',
            to: 'Bis',
            needBoth: "W\xe4hlen Sie beide Daten aus, um den Zeitraum anzuwenden"
        },
        filters: {
            title: 'Filter',
            clear: "Filter zur\xfccksetzen",
            showResults: 'Ergebnisse anzeigen',
            applyRange: 'Zeitraum anwenden',
            activeCount: (n)=>`Filter: ${n} aktiv`,
            emptyTitle: 'Keine Treffer mit diesen Filtern',
            emptyHint: "\xc4ndern Sie die Filter oder setzen Sie sie zur\xfcck"
        },
        connectivity: {
            offline: "Sie sind offline \u2013 \xc4nderungen werden nicht gespeichert",
            degraded: "Keine Verbindung zum Server \u2013 neuer Versuch l\xe4uft",
            restored: 'Verbindung wiederhergestellt',
            retry: 'Erneut versuchen',
            busy: "Wird gepr\xfcft\u2026"
        },
        nationalId: {
            label: 'Nationale ID',
            genericLabel: 'Nationale ID-Nummer',
            country: 'Ausstellungsland',
            // `n` is never below 5, so the noun after it is always plural.
            placeholder: (n)=>`${n} Ziffern`,
            required: 'Geben Sie die nationale ID ein',
            incomplete: (n)=>`Die nationale ID muss ${n} Ziffern haben`,
            tooShort: (n)=>`Geben Sie mindestens ${n} Zeichen ein`,
            invalid: "Diese nationale ID ist ung\xfcltig",
            valid: "Nationale ID ist g\xfcltig",
            notValid: "Nationale ID ist ung\xfcltig"
        },
        dayContext: {
            prevDay: 'Vorheriger Tag',
            nextDay: "N\xe4chster Tag",
            today: 'Heute',
            backToToday: "Zur\xfcck zu heute",
            pickDay: "Tag ausw\xe4hlen"
        },
        weekPicker: {
            title: "Tag ausw\xe4hlen",
            thisWeek: 'Diese Woche',
            nextWeek: "N\xe4chste Woche",
            prevWeek: 'Letzte Woche',
            fullCalendar: "Vollst\xe4ndiger Kalender",
            backToWeek: "Zur\xfcck zur Woche",
            today: 'Heute',
            close: "Schlie\xdfen",
            range: (from, to)=>`${from} bis ${to}`,
            countAria: (n)=>`Termine: ${n}`
        },
        walkIn: {
            suggested: 'Vorgeschlagen',
            or: 'oder'
        },
        mobileHeader: {
            greeting: 'Willkommen,',
            clear: "L\xf6schen",
            unknownInitial: '?'
        },
        errorBoundary: {
            title: "Diese Seite konnte nicht ge\xf6ffnet werden",
            body: 'Beim Anzeigen dieser Seite ist ein Fehler aufgetreten.',
            retry: 'Erneut versuchen'
        },
        number: {
            invalid: "Das ist keine g\xfcltige Zahl",
            min: (n)=>`Mindestens ${n}`,
            max: (n)=>`H\xf6chstens ${n}`
        },
        account: {
            topUp: 'Guthaben aufladen',
            menu: 'Konto'
        },
        bottomNav: {
            label: 'Hauptnavigation'
        },
        files: {
            phases: {
                queued: 'In Warteschlange',
                preparing: 'Wird vorbereitet',
                sending: "Wird hochgeladen\u2026",
                done: 'Hochgeladen',
                failed: 'Nicht hochgeladen'
            },
            remove: 'Entfernen',
            retry: 'Erneut versuchen',
            replace: 'Ersetzen',
            drop: "Dateien hierher ziehen oder ausw\xe4hlen",
            pick: "Dateien ausw\xe4hlen",
            camera: 'Foto aufnehmen',
            directory: "Ordner ausw\xe4hlen",
            dragging: 'Hier ablegen'
        },
        imageStack: {
            frame: (i, n)=>`Bild ${i} von ${n}`,
            prev: 'Vorheriges Bild',
            next: "N\xe4chstes Bild",
            slider: 'Zwischen Bildern wechseln',
            zoomIn: "Vergr\xf6\xdfern",
            zoomOut: 'Verkleinern',
            reset: "Ansicht zur\xfccksetzen",
            series: 'Serien',
            presets: 'Anzeigeeinstellungen',
            viewport: 'Bildansicht',
            loading: 'Bild wird geladen',
            error: 'Das Bild konnte nicht geladen werden',
            retry: 'Erneut versuchen',
            empty: 'Kein Bild zum Anzeigen'
        },
        prizeWheel: {
            label: "Gl\xfccksrad"
        },
        toman: 'Toman'
    }
};
function $df1b34b618a72512$export$cddd06f8fa3400df(locale) {
    const base = String(locale || (0, $hlTfq.documentLocale)()).toLowerCase().split(/[-_]/)[0];
    return $df1b34b618a72512$export$6bdac007b5b42036[base] || $df1b34b618a72512$export$6bdac007b5b42036[(0, $eLeza.brandDefaultLocale)('fa')] || $df1b34b618a72512$export$6bdac007b5b42036.fa;
}

});



parcelRegister("8ym5i", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1788dcf07756658$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $huNwV = parcelRequire("huNwV");
var $2uCMp = parcelRequire("2uCMp");
var $hwzM5 = parcelRequire("hwzM5");

var $5JYPc = parcelRequire("5JYPc");

var $5AX1S = parcelRequire("5AX1S");

var $hlTfq = parcelRequire("hlTfq");

var $j9AxR = parcelRequire("j9AxR");

var $k27hS = parcelRequire("k27hS");

var $aJ1FU = parcelRequire("aJ1FU");
'use client';
// The one way a stored phone number is SHOWN (PM-0536). `PhoneInput` is where a number
// is typed; this is where it is read — a record's «اطلاعات», a header, a table cell.
//
// What it renders, and why each part is here:
//
//   - **`phone.forDisplay`** decides the spelling: the national form for a home number,
//     E.164 for a foreign one (PM-0078), and anything unreadable exactly as stored —
//     a read surface never blanks a column a person typed on purpose.
//   - **An LTR island** (DESIGN.md rule 8, DESIGN_SYSTEM §6.4): `dir="ltr"` + isolate, so
//     `+98…` keeps its plus on the left inside a Persian sentence and the digits are one
//     run. The component's own layout sets no `dir`; its actions follow the page.
//   - **The page's digits**, painted one for one over the ASCII string — what
//     `formatDigits` does in the apps. What is COPIED is the ASCII national form, as the
//     apps' copy buttons have always written it: a pasted «۰۹۱۲…» is a number another
//     system may not read.
//
// Actions are opt-in and never colour alone: copying swaps the icon to a tick AND the
// button's name to «کپی شد», announced politely. «تماس» is a real `tel:` link built by
// `phone.telHref`, and appears only where there is something to dial — never over a
// masked number or a note. It shows on the touch tier, where a tap dials; on a desktop a
// `tel:` link opens whatever the OS has, so it is offered there only when the caller
// says `call="always"` (a clinic with a softphone).
//
// Props:
//   value      the stored number — E.164 preferred, any legacy spelling accepted
//   country    the home country a national spelling is read in (iso2 or a `Country`)
//   locale     digits + words; defaults to <html lang>
//   copy       show «کپی شماره»
//   call       true = on the touch tier, 'always' = on every tier
//   onCopy     (asciiText) after a successful copy — a host that also toasts
//   isMobile   override the tier; UNSET reads `useResponsive()`
//   messages   partial override of kitCopy().phoneNumber
//   className, data-testid, …rest land on the root
const $f1788dcf07756658$var$COPIED_MS = 1500;
function $f1788dcf07756658$export$2e2bcd8739ae039({ value: value, country: country, locale: locale, copy: copy = false, call: call = false, onCopy: onCopy, isMobile: isMobile, messages: messages, className: className, 'data-testid': testid = 'phone-number', ...rest }) {
    const auto = (0, $k27hS.default)();
    const touch = isMobile !== undefined ? isMobile : auto.isMobile;
    const words = {
        ...(0, $j9AxR.kitCopy)(locale).phoneNumber,
        ...messages
    };
    const [copied, setCopied] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const timer = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>()=>clearTimeout(timer.current), []);
    const options = country ? {
        country: country
    } : undefined;
    const shown = (0, $5AX1S.forDisplay)(value, options);
    if (!shown) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        ...rest,
        "data-testid": testid,
        "data-state": "empty",
        className: (0, $5JYPc.cn)('text-muted-foreground', className)
    }, words.empty);
    const numerals = (0, $hlTfq.numeralsFor)(locale || (0, $hlTfq.documentLocale)());
    const painted = shown.replace(/\d/g, (d)=>numerals.digits[Number(d)]);
    const tel = (0, $5AX1S.telHref)(value, options);
    const showCall = Boolean(tel) && (call === 'always' || call && touch);
    // ≥ 2.75rem on the touch tier (DC §4.2); a compact square beside desktop text.
    const action = touch ? 'h-11 w-11 px-0' : 'h-8 w-8 px-0 rounded-md';
    const doCopy = async ()=>{
        try {
            await navigator.clipboard.writeText(shown);
        } catch  {
            // No clipboard (an insecure origin, a refused permission): nothing was copied,
            // and saying «کپی شد» anyway would be the one wrong answer.
            return;
        }
        setCopied(true);
        clearTimeout(timer.current);
        timer.current = setTimeout(()=>setCopied(false), $f1788dcf07756658$var$COPIED_MS);
        onCopy?.(shown);
    };
    return(// `rest` first: the derived data-state is the component's own (DS §7).
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        ...rest,
        "data-testid": testid,
        "data-state": "content",
        className: (0, $5JYPc.cn)('inline-flex items-center gap-1 min-w-0 align-middle', className)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "ltr",
        "data-testid": `${testid}-value`,
        className: "[unicode-bidi:isolate] font-sans tracking-[0.5px] whitespace-nowrap overflow-hidden text-ellipsis"
    }, painted), copy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        type: "button",
        variant: "ghost",
        className: (0, $5JYPc.cn)(action, 'text-muted-foreground'),
        onClick: doCopy,
        "aria-label": copied ? words.copied : words.copy,
        title: copied ? words.copied : words.copy,
        "data-testid": `${testid}-copy`,
        "data-state": copied ? 'copied' : 'idle'
    }, copied ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
        size: 16,
        "aria-hidden": "true"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2uCMp.default), {
        size: 16,
        "aria-hidden": "true"
    })), showCall && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        asChild: true,
        variant: "ghost",
        className: (0, $5JYPc.cn)(action, 'text-muted-foreground')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
        href: tel,
        "aria-label": words.call,
        title: words.call,
        "data-testid": `${testid}-call`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hwzM5.default), {
        size: 16,
        "aria-hidden": "true"
    }))), copy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "sr-only",
        role: "status",
        "aria-live": "polite"
    }, copied ? words.copied : '')));
}

});
parcelRegister("huNwV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fbaf9031554177f$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $3fbaf9031554177f$export$a2387ed3b5d536eb = {
    name: "check",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M20 6 9 17l-5-5",
                key: "1gmf2c"
            }
        ]
    ]
};
$3fbaf9031554177f$export$a2387ed3b5d536eb.node;
const $3fbaf9031554177f$export$2e2bcd8739ae039 = (0, $9QBug.default)($3fbaf9031554177f$export$a2387ed3b5d536eb);

});
parcelRegister("9QBug", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb908d1b06653674$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $acw62 = parcelRequire("acw62");

var $d6HqV = parcelRequire("d6HqV");

var $8uM9A = parcelRequire("8uM9A");

var $kBnWl = parcelRequire("kBnWl");
function $cb908d1b06653674$export$2e2bcd8739ae039(iconDataOrName, iconNode = [], aliases = []) {
    const iconData = typeof iconDataOrName === "string" ? (0, $d6HqV.toLucideIconData)(iconDataOrName, iconNode, aliases) : iconDataOrName;
    const Component = (0, $acw62.forwardRef)(({ className: className, ...props }, ref)=>(0, $acw62.createElement)((0, $kBnWl.default), {
            ref: ref,
            icon: iconData,
            className: className,
            ...props
        }));
    if (iconData.name) Component.displayName = (0, $8uM9A.toPascalCase)(iconData.name);
    return Component;
}

});
parcelRegister("d6HqV", function(module, exports) {

$parcel$export(module.exports, "toLucideIconData", () => $9849370148eea58e$export$cffcae2df5126ae4);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $agXzh = parcelRequire("agXzh");
function $9849370148eea58e$export$cffcae2df5126ae4(iconName, iconNode, aliases = []) {
    if (iconNode == null) throw new Error("[lucide]: iconNode is required when icon name is used");
    return {
        name: (0, $agXzh.toKebabCase)(iconName),
        size: 24,
        node: iconNode,
        ...aliases.length > 0 ? {
            aliases: aliases
        } : {}
    };
}

});
parcelRegister("agXzh", function(module, exports) {

$parcel$export(module.exports, "toKebabCase", () => $ebab042c7bf4d462$export$73bda83cddbc7187);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $ebab042c7bf4d462$export$73bda83cddbc7187 = (string)=>string?.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();

});


parcelRegister("8uM9A", function(module, exports) {

$parcel$export(module.exports, "toPascalCase", () => $05938c6aab1a7024$export$6fb43ff9addf7357);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $lTrzp = parcelRequire("lTrzp");
const $05938c6aab1a7024$export$6fb43ff9addf7357 = (string)=>{
    const camelCase = (0, $lTrzp.toCamelCase)(string);
    return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
};

});
parcelRegister("lTrzp", function(module, exports) {

$parcel$export(module.exports, "toCamelCase", () => $679cfb4006de9dc2$export$86f54f62aa7a7514);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $679cfb4006de9dc2$export$86f54f62aa7a7514 = (string)=>{
    let out = "";
    let upperNext = false;
    for (const ch of string){
        if (ch === "-" || ch === "_" || ch <= " ") {
            upperNext = out.length > 0;
            continue;
        }
        if (out.length === 0) out += ch.toLowerCase();
        else out += upperNext ? ch.toUpperCase() : ch;
        upperNext = false;
    }
    return out;
};

});


parcelRegister("kBnWl", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c69f6577678916e$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $cFsMh = parcelRequire("cFsMh");

var $96Ez5 = parcelRequire("96Ez5");

var $cWxOD = parcelRequire("cWxOD");

var $efvHT = parcelRequire("efvHT");
"use strict";
"use client";
const $8c69f6577678916e$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)(({ color: color, size: size, width: width, height: height, strokeWidth: strokeWidth, absoluteStrokeWidth: absoluteStrokeWidth, nonScalingStroke: nonScalingStroke, className: className = "", children: children, iconNode: iconNode = [], icon: icon = {
    node: iconNode,
    aliases: [],
    size: 24
}, ...rest }, ref)=>{
    const { size: contextSize = 24, strokeWidth: contextStrokeWidth = 2, absoluteStrokeWidth: contextAbsoluteStrokeWidth = false, nonScalingStroke: contextNonScalingStroke = false, color: contextColor = "currentColor", className: contextClass = "" } = (0, $efvHT.useLucideContext)() ?? {};
    const hasAccessibleProp = Boolean(children) || (0, $cWxOD.hasA11yProp)(rest);
    const [name, svgAttributes, builtIconNode = []] = (0, $96Ez5.default)(icon, {
        color: color ?? contextColor,
        width: width ?? size ?? contextSize,
        height: height ?? size ?? contextSize,
        strokeWidth: strokeWidth ?? contextStrokeWidth,
        absoluteStrokeWidth: absoluteStrokeWidth ?? contextAbsoluteStrokeWidth,
        nonScalingStroke: nonScalingStroke ?? contextNonScalingStroke,
        className: (0, $cFsMh.mergeClasses)(contextClass, className),
        hasA11yProp: hasAccessibleProp,
        attributes: rest
    });
    return (0, $acw62.createElement)(name, {
        ref: ref,
        ...svgAttributes
    }, [
        ...builtIconNode.map(([tag, attrs])=>(0, $acw62.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [
            children
        ]
    ]);
});

});
parcelRegister("cFsMh", function(module, exports) {

$parcel$export(module.exports, "mergeClasses", () => $5921600fb4e81be8$export$3d46f4579dba46e5);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $5921600fb4e81be8$export$3d46f4579dba46e5 = (...classes)=>classes.filter((className, index, array)=>{
        return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
    }).join(" ").trim();

});

parcelRegister("96Ez5", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9986151c9447952$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $i86mG = parcelRequire("i86mG");
function $f9986151c9447952$export$2e2bcd8739ae039(icon, params = {}) {
    return (0, $i86mG.default)(icon, {
        ...params,
        attributeNames: {
            ...params.attributeNames,
            class: "className",
            "stroke-width": "strokeWidth",
            "stroke-linecap": "strokeLinecap",
            "stroke-linejoin": "strokeLinejoin",
            "vector-effect": "vectorEffect"
        }
    });
}

});
parcelRegister("i86mG", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ca0126f0d25626c$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $53lbM = parcelRequire("53lbM");

var $cFsMh = parcelRequire("cFsMh");
function $4ca0126f0d25626c$var$isDefined(value) {
    return value !== null && value !== void 0;
}
function $4ca0126f0d25626c$export$2e2bcd8739ae039(icon, params = {}) {
    const attributeNames = params.attributeNames ?? {};
    const getAttributeName = (attributeName)=>attributeNames[attributeName] ?? attributeName;
    const viewBoxWidth = icon.size ?? icon.width ?? (0, $53lbM.default)["width"];
    const viewBoxHeight = icon.size ?? icon.height ?? (0, $53lbM.default)["height"];
    const aliasClassNames = icon.aliases?.filter((alias)=>typeof alias === "string" && alias.trim() !== "").map((alias)=>`lucide-${alias}`) ?? [];
    const iconClassNames = [
        ...icon.name ? [
            `lucide-${icon.name}`
        ] : [],
        ...aliasClassNames
    ];
    const classNamesFromClassName = params.className?.split(" ").filter(Boolean) ?? [];
    const className = params.includeDefaultClasses === false ? (0, $cFsMh.mergeClasses)(...classNamesFromClassName) : (0, $cFsMh.mergeClasses)("lucide", ...iconClassNames, ...classNamesFromClassName);
    const calculatedStrokeWidth = params.absoluteStrokeWidth ? Number(params.strokeWidth ?? (0, $53lbM.default)["stroke-width"]) * Number(icon.size ?? icon.width ?? (0, $53lbM.default)["width"]) / Number(params.size ?? params.width ?? (0, $53lbM.default)["width"]) : params.strokeWidth ?? (0, $53lbM.default)["stroke-width"];
    const attributes = {
        ...Object.entries((0, $53lbM.default)).reduce((attrs, [attrName, value])=>{
            attrs[getAttributeName(attrName)] = value;
            return attrs;
        }, {}),
        ..."color" in params && params.color && {
            [getAttributeName("stroke")]: params.color
        },
        ..."size" in params && $4ca0126f0d25626c$var$isDefined(params.size) && {
            [getAttributeName("width")]: params.size,
            [getAttributeName("height")]: params.size
        },
        ..."width" in params && $4ca0126f0d25626c$var$isDefined(params.width) && {
            [getAttributeName("width")]: params.width
        },
        ..."height" in params && $4ca0126f0d25626c$var$isDefined(params.height) && {
            [getAttributeName("height")]: params.height
        },
        [getAttributeName("stroke-width")]: calculatedStrokeWidth,
        ...className && {
            [getAttributeName("class")]: className
        },
        [getAttributeName("viewBox")]: `0 0 ${viewBoxWidth} ${viewBoxHeight}`,
        ...params.hasA11yProp === false ? {
            [getAttributeName("aria-hidden")]: "true"
        } : {},
        ..."attributes" in params && params.attributes
    };
    return [
        "svg",
        attributes,
        icon.node.map((child)=>{
            const [name, attrs, children] = child;
            const nextAttrs = params.nonScalingStroke ? {
                [getAttributeName("vector-effect")]: "non-scaling-stroke",
                ...attrs
            } : attrs;
            return children ? [
                name,
                nextAttrs,
                children
            ] : [
                name,
                nextAttrs
            ];
        })
    ];
}

});
parcelRegister("53lbM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6be556545857de8$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $c6be556545857de8$export$2e2bcd8739ae039 = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": 2,
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
};

});



parcelRegister("cWxOD", function(module, exports) {

$parcel$export(module.exports, "hasA11yProp", () => $08ed9cd30f364255$export$ab365959aa6deed0);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $08ed9cd30f364255$export$ab365959aa6deed0 = (props)=>{
    for(const prop in props){
        if (prop.startsWith("aria-") || prop === "role" || prop === "title") return true;
    }
    return false;
};

});

parcelRegister("efvHT", function(module, exports) {

$parcel$export(module.exports, "useLucideContext", () => $fdd26cba762f63b6$export$52ee7576b6cde767);

var $acw62 = parcelRequire("acw62");
"use strict";
"use client";
const $fdd26cba762f63b6$var$LucideContext = (0, $acw62.createContext)({});
function $fdd26cba762f63b6$export$f4a5ae9d8b2d8a16({ children: children, size: size, color: color, strokeWidth: strokeWidth, absoluteStrokeWidth: absoluteStrokeWidth, nonScalingStroke: nonScalingStroke, className: className }) {
    const value = (0, $acw62.useMemo)(()=>({
            size: size,
            color: color,
            strokeWidth: strokeWidth,
            absoluteStrokeWidth: absoluteStrokeWidth,
            nonScalingStroke: nonScalingStroke,
            className: className
        }), [
        size,
        color,
        strokeWidth,
        absoluteStrokeWidth,
        nonScalingStroke,
        className
    ]);
    return (0, $acw62.createElement)($fdd26cba762f63b6$var$LucideContext.Provider, {
        value: value
    }, children);
}
const $fdd26cba762f63b6$export$52ee7576b6cde767 = ()=>(0, $acw62.useContext)($fdd26cba762f63b6$var$LucideContext);

});




parcelRegister("2uCMp", function(module, exports) {

$parcel$export(module.exports, "default", () => $807d71b9253536b4$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $807d71b9253536b4$export$a2387ed3b5d536eb = {
    name: "copy",
    size: 24,
    node: [
        [
            "rect",
            {
                width: "14",
                height: "14",
                x: "8",
                y: "8",
                rx: "2",
                ry: "2",
                key: "17jyea"
            }
        ],
        [
            "path",
            {
                d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2",
                key: "zix9uf"
            }
        ]
    ]
};
$807d71b9253536b4$export$a2387ed3b5d536eb.node;
const $807d71b9253536b4$export$2e2bcd8739ae039 = (0, $9QBug.default)($807d71b9253536b4$export$a2387ed3b5d536eb);

});

parcelRegister("hwzM5", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c9146903faa6a3a$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $4c9146903faa6a3a$export$a2387ed3b5d536eb = {
    name: "phone",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384",
                key: "9njp5v"
            }
        ]
    ]
};
$4c9146903faa6a3a$export$a2387ed3b5d536eb.node;
const $4c9146903faa6a3a$export$2e2bcd8739ae039 = (0, $9QBug.default)($4c9146903faa6a3a$export$a2387ed3b5d536eb);

});

parcelRegister("k27hS", function(module, exports) {

$parcel$export(module.exports, "default", () => $e959a5a9c1f6e19d$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * useResponsive — is this viewport the MOBILE surface?
 *
 * ≤ 768px is mobile across the whole product (DESIGN-CONCEPT-MOBILE preamble:
 * "everything rendered when `useResponsive()` reports ≤ 768px"). The boundary
 * is inclusive: 768 is mobile, 769 is desktop.
 *
 * It lives in the kit because it is the switch every `X.mobile.jsx` fork is
 * chosen by, and a byte-identical copy already existed in the doctor and the
 * clinic client — the second app needing it is DESIGN.md rule 4's trigger to
 * move it here. It sits beside `useKeyboardInset` and `useMeasuredWidth`: all
 * three are facts about the device's geometry that a whole class of screens
 * depends on.
 *
 * Hardened over the app-local copies in two ways:
 *   • `matchMedia` rather than a `resize` listener, so a rotation or a
 *     window drag fires once at the boundary instead of on every frame;
 *   • an SSR / no-window guard, so importing it in a Next.js server component
 *     or a node-environment test does not throw. It reports DESKTOP there —
 *     the surface with the full content, which is the safe default for a
 *     first paint that has not measured anything yet.
 *
 * @param breakpoint the inclusive mobile ceiling in px (default 768)
 * @returns { isMobile }
 */ const $e959a5a9c1f6e19d$var$query = (breakpoint)=>`(max-width: ${breakpoint}px)`;
const $e959a5a9c1f6e19d$var$read = (breakpoint)=>{
    if (typeof window === 'undefined') return false;
    if (typeof window.matchMedia === 'function') return window.matchMedia($e959a5a9c1f6e19d$var$query(breakpoint)).matches;
    return window.innerWidth <= breakpoint;
};
function $e959a5a9c1f6e19d$export$2e2bcd8739ae039(breakpoint = 768) {
    const [isMobile, setIsMobile] = (0, $acw62.useState)(()=>$e959a5a9c1f6e19d$var$read(breakpoint));
    (0, $acw62.useEffect)(()=>{
        if (typeof window === 'undefined') return undefined;
        // The state initialiser ran before mount; re-read now in case the viewport
        // is not what it was (hydration, a rotation during boot).
        setIsMobile($e959a5a9c1f6e19d$var$read(breakpoint));
        if (typeof window.matchMedia !== 'function') {
            const onResize = ()=>setIsMobile(window.innerWidth <= breakpoint);
            window.addEventListener('resize', onResize);
            return ()=>window.removeEventListener('resize', onResize);
        }
        const mq = window.matchMedia($e959a5a9c1f6e19d$var$query(breakpoint));
        const onChange = (e)=>setIsMobile(e.matches);
        // `addListener` is the pre-2019 Safari spelling; still worth keeping while
        // the product supports older iOS webviews.
        if (mq.addEventListener) mq.addEventListener('change', onChange);
        else mq.addListener(onChange);
        return ()=>{
            if (mq.removeEventListener) mq.removeEventListener('change', onChange);
            else mq.removeListener(onChange);
        };
    }, [
        breakpoint
    ]);
    return {
        isMobile: isMobile
    };
}

});

parcelRegister("aJ1FU", function(module, exports) {

$parcel$export(module.exports, "default", () => $39b6a9e95398564b$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $9UeUh = parcelRequire("9UeUh");

var $2DiCt = parcelRequire("2DiCt");

var $5JYPc = parcelRequire("5JYPc");
'use client';
const $39b6a9e95398564b$export$dca1ee5a936bb312 = (0, $2DiCt.cva)('inline-flex items-center justify-center gap-2 font-sans font-semibold rounded-lg transition-all duration-150 outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 disabled:pointer-events-none disabled:opacity-50 select-none', {
    variants: {
        variant: {
            default: 'bg-navy text-white hover:bg-navy-dark active:scale-[0.98]',
            destructive: 'bg-destructive text-destructive-foreground hover:bg-destructive/90 active:scale-[0.98]',
            outline: 'border-[1.5px] border-border bg-white text-foreground hover:bg-muted active:scale-[0.98]',
            ghost: 'bg-transparent text-foreground hover:bg-muted',
            link: 'text-primary underline-offset-4 hover:underline',
            teal: 'bg-clinic-teal text-white hover:opacity-90 active:scale-[0.98]',
            // Tonal primary — a navy-tinted pill for secondary actions that still read
            // as brand (jump-to-today, filter chips) without the weight of a solid fill.
            subtle: 'bg-navy/5 text-navy border-[1.5px] border-navy/20 hover:bg-navy/10 active:scale-[0.98]',
            // A sidebar destination, on the deep-azure gradient rail. Selected state
            // arrives as `data-active="true"` (set it beside `aria-current="page"`),
            // NOT as a className the caller assembles: all four staff shells were
            // writing the same four overrides onto `variant="ghost"`, which §17.1
            // calls a fork of a kit component. The active pill is the brand
            // gradient — the single lit moment on a deliberately teal-free rail.
            nav: 'w-full justify-start font-medium text-white/60 hover:bg-white/10 hover:text-white data-[active=true]:bg-gradient-brand data-[active=true]:text-white data-[active=true]:font-bold data-[active=true]:hover:bg-gradient-brand'
        },
        size: {
            default: 'h-11 px-5 text-[0.84375rem]',
            sm: 'h-9  px-4 text-xs rounded-md',
            lg: 'h-12 px-7 text-[0.9375rem]',
            icon: 'h-10 w-10'
        }
    },
    defaultVariants: {
        variant: 'default',
        size: 'default'
    }
});
const $39b6a9e95398564b$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ className: className, variant: variant, size: size, asChild: asChild = false, ...props }, ref)=>{
    const Comp = asChild ? (0, $9UeUh.Slot) : 'button';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Comp, {
        ref: ref,
        className: (0, $5JYPc.cn)($39b6a9e95398564b$export$dca1ee5a936bb312({
            variant: variant,
            size: size
        }), className),
        ...props
    });
});
$39b6a9e95398564b$export$353f5b6fc5456de1.displayName = 'Button';
var $39b6a9e95398564b$export$2e2bcd8739ae039 = $39b6a9e95398564b$export$353f5b6fc5456de1;

});
parcelRegister("9UeUh", function(module, exports) {

$parcel$export(module.exports, "createSlot", () => $cf381de56a25bc52$export$e88b45bda5c13eb9);
$parcel$export(module.exports, "Slot", () => $cf381de56a25bc52$export$be92b6f5f03c0fe9);

var $acw62 = parcelRequire("acw62");

var $htT6J = parcelRequire("htT6J");
var $cf381de56a25bc52$var$__defProp = Object.defineProperty;
var $cf381de56a25bc52$var$__name = (target, value)=>$cf381de56a25bc52$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
// @__NO_SIDE_EFFECTS__
function $cf381de56a25bc52$export$e88b45bda5c13eb9(ownerName) {
    const Slot2 = $acw62.forwardRef((props, forwardedRef)=>{
        let { children: children, ...slotProps } = props;
        let slottableElement = null;
        let hasSlottable = false;
        const newChildren = [];
        children = $cf381de56a25bc52$var$useUnwrappedLazy(children);
        $acw62.Children.forEach(children, (maybeSlottable)=>{
            if ($cf381de56a25bc52$var$isSlottable(maybeSlottable)) {
                hasSlottable = true;
                const slottable = maybeSlottable;
                let child = "child" in slottable.props ? slottable.props.child : slottable.props.children;
                while($cf381de56a25bc52$var$isLazyComponent(child) && typeof $cf381de56a25bc52$var$use === "function")child = $cf381de56a25bc52$var$use(child._payload);
                slottableElement = $cf381de56a25bc52$var$getSlottableElementFromSlottable(slottable, child);
                newChildren.push(slottableElement?.props?.children);
            } else newChildren.push(maybeSlottable);
        });
        if (slottableElement) slottableElement = $acw62.cloneElement(slottableElement, void 0, newChildren);
        else if (// A `Slottable` was found but it didn't resolve to a single element (e.g.
        // it wrapped multiple elements, text, or a render-prop `child` that
        // wasn't an element). Don't fall back to treating the `Slottable` wrapper
        // itself as the slot target — throw a descriptive error below instead.
        !hasSlottable && $acw62.Children.count(children) === 1 && $acw62.isValidElement(children)) slottableElement = children;
        const slottableElementRef = slottableElement ? $cf381de56a25bc52$var$getElementRef(slottableElement) : void 0;
        const composedRef = (0, $htT6J.useComposedRefs)(forwardedRef, slottableElementRef);
        if (!slottableElement) {
            if (children || children === 0) throw new Error(hasSlottable ? $cf381de56a25bc52$var$createSlottableError(ownerName) : $cf381de56a25bc52$var$createSlotError(ownerName));
            return children;
        }
        const mergedProps = $cf381de56a25bc52$var$mergeProps(slotProps, slottableElement.props ?? {});
        if (slottableElement.type !== $acw62.Fragment) mergedProps.ref = forwardedRef ? composedRef : slottableElementRef;
        return $acw62.cloneElement(slottableElement, mergedProps);
    });
    Slot2.displayName = `${ownerName}.Slot`;
    return Slot2;
}
$cf381de56a25bc52$var$__name($cf381de56a25bc52$export$e88b45bda5c13eb9, "createSlot");
var $cf381de56a25bc52$export$be92b6f5f03c0fe9 = /* @__PURE__ */ $cf381de56a25bc52$export$e88b45bda5c13eb9("Slot");
var $cf381de56a25bc52$var$SLOTTABLE_IDENTIFIER = Symbol.for("radix.slottable");
// @__NO_SIDE_EFFECTS__
function $cf381de56a25bc52$export$bf68c29d8281d0f7(ownerName) {
    const Slottable2 = /* @__PURE__ */ $cf381de56a25bc52$var$__name((props)=>"child" in props ? props.children(props.child) : props.children, "Slottable");
    Slottable2.displayName = `${ownerName}.Slottable`;
    Slottable2.__radixId = $cf381de56a25bc52$var$SLOTTABLE_IDENTIFIER;
    return Slottable2;
}
$cf381de56a25bc52$var$__name($cf381de56a25bc52$export$bf68c29d8281d0f7, "createSlottable");
var $cf381de56a25bc52$export$d9f1ccf0bdb05d45 = /* @__PURE__ */ $cf381de56a25bc52$export$bf68c29d8281d0f7("Slottable");
var $cf381de56a25bc52$var$getSlottableElementFromSlottable = /* @__PURE__ */ $cf381de56a25bc52$var$__name((slottable, child)=>{
    if ("child" in slottable.props) {
        if (!$acw62.isValidElement(child)) return null;
        return $acw62.cloneElement(child, void 0, slottable.props.children(child.props.children));
    }
    return $acw62.isValidElement(child) ? child : null;
}, "getSlottableElementFromSlottable");
function $cf381de56a25bc52$var$mergeProps(slotProps, childProps) {
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                const result = childPropValue(...args);
                slotPropValue(...args);
                return result;
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
        else if (propName === "aria-describedby") overrideProps[propName] = $cf381de56a25bc52$var$concatAriaDescribedby(childPropValue, slotPropValue);
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
$cf381de56a25bc52$var$__name($cf381de56a25bc52$var$mergeProps, "mergeProps");
function $cf381de56a25bc52$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}
$cf381de56a25bc52$var$__name($cf381de56a25bc52$var$getElementRef, "getElementRef");
function $cf381de56a25bc52$var$isSlottable(child) {
    return $acw62.isValidElement(child) && typeof child.type === "function" && "__radixId" in child.type && child.type.__radixId === $cf381de56a25bc52$var$SLOTTABLE_IDENTIFIER;
}
$cf381de56a25bc52$var$__name($cf381de56a25bc52$var$isSlottable, "isSlottable");
var $cf381de56a25bc52$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
function $cf381de56a25bc52$var$isLazyComponent(element) {
    return element != null && typeof element === "object" && "$$typeof" in element && element.$$typeof === $cf381de56a25bc52$var$REACT_LAZY_TYPE && "_payload" in element && $cf381de56a25bc52$var$isPromiseLike(element._payload);
}
$cf381de56a25bc52$var$__name($cf381de56a25bc52$var$isLazyComponent, "isLazyComponent");
function $cf381de56a25bc52$var$isPromiseLike(value) {
    return typeof value === "object" && value !== null && "then" in value;
}
$cf381de56a25bc52$var$__name($cf381de56a25bc52$var$isPromiseLike, "isPromiseLike");
function $cf381de56a25bc52$var$useUnwrappedLazy(value) {
    let unwrapped = value;
    while($cf381de56a25bc52$var$isLazyComponent(unwrapped) && typeof $cf381de56a25bc52$var$use === "function")unwrapped = $cf381de56a25bc52$var$use(unwrapped._payload);
    return unwrapped;
}
$cf381de56a25bc52$var$__name($cf381de56a25bc52$var$useUnwrappedLazy, "useUnwrappedLazy");
function $cf381de56a25bc52$var$concatAriaDescribedby(...values) {
    const ids = /* @__PURE__ */ new Set();
    for (const value of values){
        if (typeof value !== "string") continue;
        for (const id of String(value).trim().split(/\s+/))if (id) ids.add(id);
    }
    return ids.size > 0 ? Array.from(ids).join(" ") : void 0;
}
$cf381de56a25bc52$var$__name($cf381de56a25bc52$var$concatAriaDescribedby, "concatAriaDescribedby");
var $cf381de56a25bc52$var$createSlotError = /* @__PURE__ */ $cf381de56a25bc52$var$__name((ownerName)=>{
    return `${ownerName} failed to slot onto its children. Expected a single React element child or \`Slottable\`.`;
}, "createSlotError");
var $cf381de56a25bc52$var$createSlottableError = /* @__PURE__ */ $cf381de56a25bc52$var$__name((ownerName)=>{
    return `${ownerName} failed to slot onto its \`Slottable\`. Expected \`Slottable\` to receive a single React element child.`;
}, "createSlottableError");
var $cf381de56a25bc52$var$use = $acw62[" use ".trim().toString()];

});
parcelRegister("htT6J", function(module, exports) {

$parcel$export(module.exports, "useComposedRefs", () => $fb3356a19a5676fa$export$c7b2cbe3552a0d05);

var $acw62 = parcelRequire("acw62");
var $fb3356a19a5676fa$var$__defProp = Object.defineProperty;
var $fb3356a19a5676fa$var$__name = (target, value)=>$fb3356a19a5676fa$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
function $fb3356a19a5676fa$var$setRef(ref, value) {
    if (typeof ref === "function") return ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
$fb3356a19a5676fa$var$__name($fb3356a19a5676fa$var$setRef, "setRef");
function $fb3356a19a5676fa$export$43e446d32b3d21af(...refs) {
    return (node)=>{
        let hasCleanup = false;
        const cleanups = refs.map((ref)=>{
            const cleanup = $fb3356a19a5676fa$var$setRef(ref, node);
            if (!hasCleanup && typeof cleanup == "function") hasCleanup = true;
            return cleanup;
        });
        if (hasCleanup) return ()=>{
            for(let i = 0; i < cleanups.length; i++){
                const cleanup = cleanups[i];
                if (typeof cleanup == "function") cleanup();
                else $fb3356a19a5676fa$var$setRef(refs[i], null);
            }
        };
    };
}
$fb3356a19a5676fa$var$__name($fb3356a19a5676fa$export$43e446d32b3d21af, "composeRefs");
function $fb3356a19a5676fa$export$c7b2cbe3552a0d05(...refs) {
    return $acw62.useCallback($fb3356a19a5676fa$export$43e446d32b3d21af(...refs), refs);
}
$fb3356a19a5676fa$var$__name($fb3356a19a5676fa$export$c7b2cbe3552a0d05, "useComposedRefs");

});


parcelRegister("2DiCt", function(module, exports) {

$parcel$export(module.exports, "cva", () => $7d867aa0bbfd521e$export$87dc52566e90b739);
/**
 * Copyright 2022 Joe Bell. All rights reserved.
 *
 * This file is licensed to you under the Apache License, Version 2.0
 * (the "License"); you may not use this file except in compliance with the
 * License. You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR REPRESENTATIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations under
 * the License.
 */ 
var $9QePP = parcelRequire("9QePP");
const $7d867aa0bbfd521e$var$falsyToString = (value)=>typeof value === "boolean" ? `${value}` : value === 0 ? "0" : value;
const $7d867aa0bbfd521e$export$a274e22fb40f762e = (0, $9QePP.clsx);
const $7d867aa0bbfd521e$export$87dc52566e90b739 = (base, config)=>(props)=>{
        var _config_compoundVariants;
        if ((config === null || config === void 0 ? void 0 : config.variants) == null) return $7d867aa0bbfd521e$export$a274e22fb40f762e(base, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
        const { variants: variants, defaultVariants: defaultVariants } = config;
        const getVariantClassNames = Object.keys(variants).map((variant)=>{
            const variantProp = props === null || props === void 0 ? void 0 : props[variant];
            const defaultVariantProp = defaultVariants === null || defaultVariants === void 0 ? void 0 : defaultVariants[variant];
            if (variantProp === null) return null;
            const variantKey = $7d867aa0bbfd521e$var$falsyToString(variantProp) || $7d867aa0bbfd521e$var$falsyToString(defaultVariantProp);
            return variants[variant][variantKey];
        });
        const propsWithoutUndefined = props && Object.entries(props).reduce((acc, param)=>{
            let [key, value] = param;
            if (value === undefined) return acc;
            acc[key] = value;
            return acc;
        }, {});
        const getCompoundVariantClassNames = config === null || config === void 0 ? void 0 : (_config_compoundVariants = config.compoundVariants) === null || _config_compoundVariants === void 0 ? void 0 : _config_compoundVariants.reduce((acc, param)=>{
            let { class: cvClass, className: cvClassName, ...compoundVariantOptions } = param;
            return Object.entries(compoundVariantOptions).every((param)=>{
                let [key, value] = param;
                return Array.isArray(value) ? value.includes({
                    ...defaultVariants,
                    ...propsWithoutUndefined
                }[key]) : ({
                    ...defaultVariants,
                    ...propsWithoutUndefined
                })[key] === value;
            }) ? [
                ...acc,
                cvClass,
                cvClassName
            ] : acc;
        }, []);
        return $7d867aa0bbfd521e$export$a274e22fb40f762e(base, getVariantClassNames, getCompoundVariantClassNames, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
    };

});



parcelRegister("6SCJ6", function(module, exports) {

$parcel$export(module.exports, "phoneListRows", () => $574ce21a39658e4c$export$bc0cdec351529f1b);
$parcel$export(module.exports, "phoneListPayload", () => $574ce21a39658e4c$export$2aca5ab8502a9baf);
$parcel$export(module.exports, "phoneListProblems", () => $574ce21a39658e4c$export$b40004fd48f45f30);
$parcel$export(module.exports, "default", () => $574ce21a39658e4c$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $6lig1 = parcelRequire("6lig1");
var $8g4t5 = parcelRequire("8g4t5");
var $lUsTt = parcelRequire("lUsTt");

var $5JYPc = parcelRequire("5JYPc");

var $5AX1S = parcelRequire("5AX1S");

var $hlTfq = parcelRequire("hlTfq");

var $j9AxR = parcelRequire("j9AxR");

var $9Bif4 = parcelRequire("9Bif4");

var $k27hS = parcelRequire("k27hS");

var $aJ1FU = parcelRequire("aJ1FU");

var $9gEOi = parcelRequire("9gEOi");

var $7phmx = parcelRequire("7phmx");

var $5MbI8 = parcelRequire("5MbI8");

var $lffTJ = parcelRequire("lffTJ");

var $8ym5i = parcelRequire("8ym5i");

var $fAR2n = parcelRequire("fAR2n");
'use client';
// «شماره‌های تماس» — every number on a patient's record, edited as one list (PM-0536).
// The desk's registration form and record editor, and the clinical module's edit sheet,
// render this; the candidate lookups, the save and the noPhone choice stay with the host.
//
// ═══════════════════════════════════════════════════════════════════════════════
// THE ROW. Inline-start → inline-end, which mirrors by itself in RTL:
//
//     [ PhoneInput ][ صاحب شماره ▾ ][ ◉ اصلی ][ 🗑 ]
//       └ «تلفن ثابت» · the row's error · the host's `trailing` (candidates, an info line)
//
// On the touch tier the row stacks: the number full width, then relation + primary +
// remove on one line, every target ≥ 2.75rem. Tab order is DOM order — country, number,
// relation, primary, remove — then «+ شمارهٔ دیگر»; Enter in a number moves to its
// relation, as the e-prescription card's fields do.
//
// ═══════════════════════════════════════════════════════════════════════════════
// THE 90% PATH IS TODAY'S FIELD (DESIGN_CONCEPT §10). With one row there is no primary
// radio and no remove — one number is the main one and cannot be removed — so a
// registration looks as it did, plus «صاحب شماره» preset to «خود بیمار». More numbers
// sit behind the ghost «+ شمارهٔ دیگر» button, up to `max` (5, the service's cap).
//
// AN ADDED ROW HAS NO RELATION, and must be given one. Only «خود بیمار» / «نامشخص»
// numbers can claim a record in the patient app (lib/phoneRelations.js), so a default
// would turn every relative's number into a key to it. `unknown` is never offered: a
// stored one is shown, disabled, and stays until somebody changes it.
//
// «تلفن ثابت» is offered where it means something: on a row whose number reads as a
// landline (PhoneInput says «این شماره موبایل نیست»), and on every row already marked.
// Ticking it re-reads what is typed with landlines allowed.
//
// A LOCKED row — a number the patient proved with a code — shows its number read-only
// with the lock sentence; its relation and the primary choice stay editable (the
// service allows both), and it has no remove: the desk's one way to retire it is the
// host's «بیمار گزارش داد», which `trailing` is the place for.
//
// ═══════════════════════════════════════════════════════════════════════════════
// THE VALUE. Controlled: `value` is the rows, `onChange(rows)` hands back the next rows.
// A row is `{ key, id?, number, relation, isPrimary, landline, label?, locked? }` —
// `number` is what `PhoneInput` writes (E.164, `''` while incomplete; a stored unparsed
// value passes through untouched). Every emitted row carries a `key`; a row without one
// is given a stable one the first time it is emitted. `phoneListRows(phones)` seeds rows
// from a GraphQL `phones` list and `phoneListPayload(rows)` turns rows into the
// `PatientPhoneInput` list a save sends; `phoneListProblems(rows)` is the submit-time
// check, and the ref's `focus(key, field)` puts the caret on the row it names.
//
// Errors follow DESIGN_CONCEPT §5.3/§6.3: under the field, never a toast. A number
// typed twice is refused under its SECOND row as soon as both parse; a missing relation
// shows once its field was left, or everywhere once the host sets `showErrors` (after a
// submit); the host's own per-row refusal (`errors[key]`: shared number, locked, a
// server code) lands under that row's number.
//
// Props:
//   value, onChange      the rows (see above)
//   max                  the cap (default 5)
//   label                row 1's number label (default: PhoneInput's own)
//   required             row 1's number is required (PhoneInput's marker and empty check)
//   errors               { [rowKey]: string } — the host's per-row error
//   trailing             (row, index) => node — under the row (candidate list, spinner)
//   lockedText           the lock sentence (default kitCopy)
//   showErrors           true after a submit attempt
//   allowAdd             false hides «+» (the host's «بیمار شماره موبایل ندارد»)
//   footer               a node after «+» — where the host puts its noPhone checkbox
//   defaultCountry, countries   handed to every PhoneInput
//   locale, messages     words (partial override of kitCopy().phoneList)
//   disabled, isMobile, className, data-testid
const $574ce21a39658e4c$var$FIRST_ROW = Object.freeze({
    key: 'i0',
    number: '',
    relation: (0, $9Bif4.SELF_RELATION),
    isPrimary: true,
    landline: false
});
/** A row's stable key — its own, else its stored id, else its position when first seen. */ const $574ce21a39658e4c$var$keyOf = (row, index)=>row.key ?? (row.id ? `id:${row.id}` : `i${index}`);
/** What two rows are compared by: the E.164 when the number parses, else its digits. */ const $574ce21a39658e4c$var$matchKey = (number)=>number ? (0, $5AX1S.parsePhone)(number, {
        allowLandline: true
    }).e164 || (0, $5AX1S.compactPhone)(number) : '';
/** Index of each row whose number an EARLIER row already holds. */ function $574ce21a39658e4c$var$duplicateRows(rows) {
    const seen = new Set();
    const dup = new Set();
    rows.forEach((row, i)=>{
        const k = $574ce21a39658e4c$var$matchKey(row.number);
        if (!k) return;
        if (seen.has(k)) dup.add(i);
        seen.add(k);
    });
    return dup;
}
const $574ce21a39658e4c$var$primaryIndexOf = (rows)=>Math.max(0, rows.findIndex((r)=>r.isPrimary));
function $574ce21a39658e4c$export$bc0cdec351529f1b(phones) {
    if (!Array.isArray(phones) || phones.length === 0) return [
        {
            ...$574ce21a39658e4c$var$FIRST_ROW
        }
    ];
    return phones.map((p)=>{
        const number = p.number || p.raw || '';
        return {
            key: `id:${p.id}`,
            id: p.id,
            number: number,
            relation: p.relation || '',
            label: p.label || '',
            isPrimary: Boolean(p.isPrimary),
            landline: number !== '' && !(0, $5AX1S.parsePhone)(number).ok,
            locked: Boolean(p.locked)
        };
    });
}
function $574ce21a39658e4c$export$2aca5ab8502a9baf(rows) {
    const list = rows?.length ? rows : [
        $574ce21a39658e4c$var$FIRST_ROW
    ];
    const primary = $574ce21a39658e4c$var$primaryIndexOf(list);
    return list.map((row, i)=>({
            ...row.id ? {
                id: row.id
            } : {},
            number: row.number || '',
            relation: row.relation || '',
            label: row.label || '',
            isPrimary: i === primary,
            landline: Boolean(row.landline)
        }));
}
function $574ce21a39658e4c$export$b40004fd48f45f30(rows, { max: max = 5, locale: locale, messages: messages } = {}) {
    const list = rows?.length ? rows : [
        $574ce21a39658e4c$var$FIRST_ROW
    ];
    const words = {
        ...(0, $j9AxR.kitCopy)(locale).phoneList,
        ...messages
    };
    const required = messages?.required ?? (0, $j9AxR.kitCopy)(locale).phone.required;
    const numerals = (0, $hlTfq.numeralsFor)(locale || (0, $hlTfq.documentLocale)());
    const dup = $574ce21a39658e4c$var$duplicateRows(list);
    const problems = [];
    list.forEach((row, index)=>{
        const key = $574ce21a39658e4c$var$keyOf(row, index);
        const at = (field, code, message)=>problems.push({
                key: key,
                index: index,
                field: field,
                code: code,
                message: message
            });
        if (!row.locked) {
            if (index >= max) at('number', 'limit', words.limit(String(max).replace(/\d/g, (d)=>numerals.digits[d])));
            else if (index > 0 && !row.number) at('number', 'required', required);
            else if (dup.has(index)) at('number', 'duplicate', words.duplicate);
        }
        if (!row.relation) at('relation', 'relation', words.relationRequired);
    });
    return problems;
}
// The label-sized spacer that lines a radio or an icon button up with the inputs
// beside it, whose labels sit above them. Same metrics as FormField's <label>.
const $574ce21a39658e4c$var$LabelSpacer = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": "true",
        className: "block text-[0.71875rem] leading-none mb-1.5 invisible select-none"
    }, "\xa0");
let $574ce21a39658e4c$var$rowSeq = 0;
const $574ce21a39658e4c$var$PhoneListInput = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function PhoneListInput({ value: value, onChange: onChange, max: max = 5, label: label, required: required = false, errors: errors, trailing: trailing, lockedText: lockedText, showErrors: showErrors = false, allowAdd: allowAdd = true, footer: footer, defaultCountry: defaultCountry, countries: countries, locale: locale, messages: messages, disabled: disabled = false, isMobile: isMobile, className: className, 'data-testid': testid = 'phone-list' }, ref) {
    const auto = (0, $k27hS.default)();
    const touch = isMobile !== undefined ? isMobile : auto.isMobile;
    const words = {
        ...(0, $j9AxR.kitCopy)(locale).phoneList,
        ...messages
    };
    const numerals = (0, $hlTfq.numeralsFor)(locale || (0, $hlTfq.documentLocale)());
    const digits = (n)=>String(n).replace(/\d/g, (d)=>numerals.digits[d]);
    const uid = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const rows = (value?.length ? value : [
        $574ce21a39658e4c$var$FIRST_ROW
    ]).map((row, i)=>({
            ...row,
            key: $574ce21a39658e4c$var$keyOf(row, i)
        }));
    const multi = rows.length > 1;
    const atCap = rows.length >= max;
    const primary = $574ce21a39658e4c$var$primaryIndexOf(rows);
    const dup = $574ce21a39658e4c$var$duplicateRows(rows);
    // What PhoneInput last said about each row: its draft and country (to re-read it when
    // «تلفن ثابت» flips) and its problem (whether «تلفن ثابت» is worth offering).
    const lastInput = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef({});
    const [problems, setProblems] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({});
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({});
    // Focus is moved after the render that made the target exist (add, remove, arrows).
    const refs = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef({
        number: {},
        relation: {},
        primary: {}
    });
    const addRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const pendingFocus = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const focusNow = (key, field)=>{
        if (field === 'add') return addRef.current?.focus();
        refs.current[field]?.[key]?.focus();
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const p = pendingFocus.current;
        if (!p) return;
        pendingFocus.current = null;
        focusNow(p.key, p.field);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useImperativeHandle(ref, ()=>({
            /** Focus a row's field — `key` or index; `field` 'number' (default) or 'relation'. */ focus (keyOrIndex, field = 'number') {
                const row = typeof keyOrIndex === 'number' ? rows[keyOrIndex] : rows.find((r)=>r.key === keyOrIndex);
                if (!row) return;
                // A locked row has no number box; its relation is the field to land on.
                focusNow(row.key, row.locked && field === 'number' ? 'relation' : field);
            }
        }));
    const emit = (next)=>onChange?.(next);
    const update = (index, patch)=>emit(rows.map((row, i)=>i === index ? {
                ...row,
                ...patch
            } : row));
    const setRef = (field, key)=>(el)=>{
            if (el) refs.current[field][key] = el;
            else delete refs.current[field][key];
        };
    const setNumber = (index, key)=>(e164, info)=>{
            lastInput.current[key] = {
                draft: info?.draft ?? e164,
                country: info?.country
            };
            const problem = info?.problem || null;
            if ((problems[key] || null) !== problem) setProblems((p)=>({
                    ...p,
                    [key]: problem
                }));
            update(index, {
                number: e164
            });
        };
    const setLandline = (index, key, on)=>{
        const row = rows[index];
        const last = lastInput.current[key];
        const source = last ? last.draft : row.number;
        const parsed = (0, $5AX1S.parsePhone)(source, {
            country: last?.country,
            allowLandline: on
        });
        // A landline that does not parse is kept as typed — the service takes it so.
        const number = parsed.ok ? parsed.e164 : on ? (0, $5AX1S.compactPhone)(source) : '';
        if (last) setProblems((p)=>({
                ...p,
                [key]: parsed.problem
            }));
        update(index, {
            landline: on,
            number: number
        });
    };
    const setPrimary = (index)=>{
        if (index === primary) return;
        emit(rows.map((row, i)=>({
                ...row,
                isPrimary: i === index
            })));
    };
    const add = ()=>{
        if (atCap || disabled) return;
        $574ce21a39658e4c$var$rowSeq += 1;
        const key = `${uid}-n${$574ce21a39658e4c$var$rowSeq}`;
        pendingFocus.current = {
            key: key,
            field: 'number'
        };
        emit([
            ...rows.map((row, i)=>({
                    ...row,
                    isPrimary: i === primary
                })),
            {
                key: key,
                number: '',
                relation: '',
                isPrimary: false,
                landline: false
            }
        ]);
    };
    const remove = (index)=>{
        if (!multi || disabled) return;
        const gone = rows[index].key;
        delete lastInput.current[gone];
        const next = rows.filter((_, i)=>i !== index);
        // The main number went: the first one left takes over, as the service promotes.
        const keepPrimary = index === primary ? 0 : primary > index ? primary - 1 : primary;
        // Focus goes to the previous row's number, else to «+» (else, with no «+», the new
        // first row); a locked row has no number box, so its relation stands in.
        const target = index > 0 ? next[index - 1] : allowAdd ? null : next[0];
        pendingFocus.current = target ? {
            key: target.key,
            field: target.locked ? 'relation' : 'number'
        } : {
            field: 'add'
        };
        emit(next.map((row, i)=>({
                ...row,
                isPrimary: i === keepPrimary
            })));
    };
    const onRadioKey = (index)=>(event)=>{
            const rtl = event.currentTarget.closest('[dir]')?.getAttribute('dir') === 'rtl';
            const step = {
                ArrowDown: 1,
                ArrowUp: -1,
                ArrowRight: rtl ? -1 : 1,
                ArrowLeft: rtl ? 1 : -1
            }[event.key];
            if (!step) return;
            event.preventDefault();
            const next = (index + step + rows.length) % rows.length;
            pendingFocus.current = {
                key: rows[next].key,
                field: 'primary'
            };
            setPrimary(next);
        };
    const hintId = `${uid}-primary-hint`;
    const limitId = `${uid}-limit`;
    const relationOf = (row)=>(0, $9Bif4.phoneRelationOptions)(locale, row.relation);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "group",
        "aria-label": words.title,
        "data-testid": testid,
        "data-state": multi ? 'multi' : 'single',
        className: (0, $5JYPc.cn)('flex flex-col gap-3', className)
    }, rows.map((row, i)=>{
        const { key: key } = row;
        const numberId = `${uid}-number-${i}`;
        const relationId = `${uid}-relation-${i}`;
        const numberLabel = i === 0 ? label : words.otherLabel;
        const numberError = errors?.[key] || (dup.has(i) ? words.duplicate : '') || (showErrors && i > 0 && !row.number && !problems[key] ? (0, $j9AxR.kitCopy)(locale).phone.required : '');
        const relationError = !row.relation && (touched[key] || showErrors) ? words.relationRequired : '';
        const offerLandline = !row.locked && (row.landline || problems[key] === 'notMobile');
        const numberField = row.locked ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
            label: numberLabel ?? (0, $j9AxR.kitCopy)(locale).phone.label,
            helperText: lockedText ?? words.locked
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            id: numberId,
            "data-testid": `${testid}-number-${i}`,
            "data-state": "locked",
            className: "flex items-center gap-2 h-11 px-3 rounded-lg border-[1.5px] border-border bg-muted text-foreground"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6lig1.default), {
            size: 16,
            "aria-hidden": "true",
            className: "shrink-0 text-muted-foreground"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8ym5i.default), {
            value: row.number,
            locale: locale,
            isMobile: touch,
            "data-testid": `${testid}-locked-${i}`
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lffTJ.default), {
            ref: setRef('number', key),
            id: numberId,
            value: row.number,
            onChange: setNumber(i, key),
            onKeyDown: (event)=>{
                if (event.key !== 'Enter' || event.nativeEvent?.isComposing) return;
                event.preventDefault();
                focusNow(key, 'relation');
            },
            label: numberLabel,
            required: i === 0 && required,
            allowLandline: Boolean(row.landline),
            defaultCountry: defaultCountry,
            countries: countries,
            locale: locale,
            error: numberError || undefined,
            disabled: disabled,
            "data-testid": `${testid}-number-${i}`
        });
        const relationField = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fAR2n.default), {
            ref: setRef('relation', key),
            id: relationId,
            // Every row's select has the same label; its number says which row it is.
            // Select's own message id is overwritten by a caller's, so both go here.
            "aria-describedby": [
                relationError ? `${relationId}-message` : null,
                numberId
            ].filter(Boolean).join(' '),
            label: words.relationLabel,
            placeholder: words.relationPlaceholder,
            options: relationOf(row),
            value: row.relation || '',
            onChange: (event)=>update(i, {
                    relation: event.target.value
                }),
            onBlur: ()=>setTouched((t)=>t[key] ? t : {
                        ...t,
                        [key]: true
                    }),
            error: relationError || undefined,
            disabled: disabled,
            "data-testid": `${testid}-relation-${i}`
        });
        const primaryRadio = multi && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "shrink-0"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($574ce21a39658e4c$var$LabelSpacer, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
            className: (0, $5JYPc.cn)('inline-flex items-center gap-1.5 px-1 text-[0.8125rem] text-foreground', touch ? 'min-h-11' : 'h-11', disabled ? 'cursor-not-allowed' : 'cursor-pointer')
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
            ref: setRef('primary', key),
            type: "radio",
            name: `${uid}-primary`,
            value: key,
            checked: i === primary,
            tabIndex: i === primary ? 0 : -1,
            onChange: ()=>setPrimary(i),
            onKeyDown: onRadioKey(i),
            disabled: disabled,
            // The radios sit one per row, so no element can wrap them as a radiogroup;
            // each says what it chooses («شمارهٔ اصلی», holding the visible «اصلی»)
            // and for which number.
            "aria-label": words.primaryLabel,
            "aria-describedby": `${numberId} ${hintId}`,
            className: "h-4 w-4 accent-[hsl(var(--primary))] cursor-[inherit]",
            "data-testid": `${testid}-primary-${i}`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, words.primary)));
        const removeButton = multi && !row.locked && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "shrink-0"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($574ce21a39658e4c$var$LabelSpacer, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5MbI8.default), {
            variant: "ghost",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lUsTt.default), {
                size: 18,
                "aria-hidden": "true"
            }),
            label: words.remove,
            "aria-describedby": numberId,
            onClick: ()=>remove(i),
            disabled: disabled,
            "data-testid": `${testid}-remove-${i}`
        }));
        const landline = offerLandline && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9gEOi.default), {
            checked: Boolean(row.landline),
            onChange: (on)=>setLandline(i, key, on === true),
            label: words.landline,
            disabled: disabled,
            className: (0, $5JYPc.cn)('self-start', touch && 'min-h-11'),
            labelClassName: "text-[0.75rem] text-muted-foreground",
            "data-testid": `${testid}-landline-${i}`
        });
        const after = trailing?.(row, i);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: key,
            "data-testid": `${testid}-row-${i}`,
            "data-state": row.locked ? 'locked' : 'editable',
            className: "flex flex-col gap-1.5"
        }, touch ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "flex flex-col gap-1.5 min-w-0"
        }, numberField, landline), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "flex items-start gap-2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "flex-1 min-w-0"
        }, relationField), primaryRadio, removeButton)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "flex items-start gap-2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "flex flex-col gap-1.5 flex-1 min-w-0"
        }, numberField, landline), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "w-48 shrink-0"
        }, relationField), primaryRadio, removeButton), after != null && after !== false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": `${testid}-trailing-${i}`
        }, after));
    }), multi && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        id: hintId,
        className: "m-0 text-[0.71875rem] text-muted-foreground leading-snug"
    }, words.primaryHint), (allowAdd || footer) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "flex flex-wrap items-center gap-x-3 gap-y-1.5"
    }, allowAdd && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        ref: addRef,
        type: "button",
        variant: "ghost",
        size: touch ? 'default' : 'sm',
        onClick: add,
        disabled: disabled || atCap,
        "aria-label": words.addLabel,
        "aria-describedby": atCap ? limitId : undefined,
        className: (0, $5JYPc.cn)('px-2 text-primary', touch && 'min-h-11'),
        "data-testid": `${testid}-add`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8g4t5.default), {
        size: 16,
        "aria-hidden": "true"
    }), words.add), allowAdd && // Always in the tree as a polite live region: «+» is disabled at the cap and
    // so out of the tab order, and its description alone would never be read.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        id: limitId,
        role: "status",
        "data-testid": atCap ? `${testid}-limit` : undefined,
        className: (0, $5JYPc.cn)('text-[0.71875rem] text-muted-foreground', !atCap && 'sr-only')
    }, atCap ? words.limit(digits(max)) : ''), footer));
});
$574ce21a39658e4c$var$PhoneListInput.displayName = 'PhoneListInput';
var $574ce21a39658e4c$export$2e2bcd8739ae039 = $574ce21a39658e4c$var$PhoneListInput;

});
parcelRegister("6lig1", function(module, exports) {

$parcel$export(module.exports, "default", () => $5389c2c2de1c7f38$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $5389c2c2de1c7f38$export$a2387ed3b5d536eb = {
    name: "lock",
    size: 24,
    node: [
        [
            "rect",
            {
                width: "18",
                height: "11",
                x: "3",
                y: "11",
                rx: "2",
                ry: "2",
                key: "1w4ew1"
            }
        ],
        [
            "path",
            {
                d: "M7 11V7a5 5 0 0 1 10 0v4",
                key: "fwvmzm"
            }
        ]
    ]
};
$5389c2c2de1c7f38$export$a2387ed3b5d536eb.node;
const $5389c2c2de1c7f38$export$2e2bcd8739ae039 = (0, $9QBug.default)($5389c2c2de1c7f38$export$a2387ed3b5d536eb);

});

parcelRegister("8g4t5", function(module, exports) {

$parcel$export(module.exports, "default", () => $83905746e46531b9$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $83905746e46531b9$export$a2387ed3b5d536eb = {
    name: "plus",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M5 12h14",
                key: "1ays0h"
            }
        ],
        [
            "path",
            {
                d: "M12 5v14",
                key: "s699le"
            }
        ]
    ]
};
$83905746e46531b9$export$a2387ed3b5d536eb.node;
const $83905746e46531b9$export$2e2bcd8739ae039 = (0, $9QBug.default)($83905746e46531b9$export$a2387ed3b5d536eb);

});

parcelRegister("lUsTt", function(module, exports) {

$parcel$export(module.exports, "default", () => $1882f1d059ea7fa7$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $1882f1d059ea7fa7$export$a2387ed3b5d536eb = {
    name: "trash",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M10 11v6",
                key: "nco0om"
            }
        ],
        [
            "path",
            {
                d: "M14 11v6",
                key: "outv1u"
            }
        ],
        [
            "path",
            {
                d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6",
                key: "miytrc"
            }
        ],
        [
            "path",
            {
                d: "M3 6h18",
                key: "d0wm0j"
            }
        ],
        [
            "path",
            {
                d: "M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2",
                key: "e791ji"
            }
        ]
    ],
    aliases: [
        "trash-2"
    ]
};
$1882f1d059ea7fa7$export$a2387ed3b5d536eb.node;
const $1882f1d059ea7fa7$export$2e2bcd8739ae039 = (0, $9QBug.default)($1882f1d059ea7fa7$export$a2387ed3b5d536eb);

});

parcelRegister("9Bif4", function(module, exports) {

$parcel$export(module.exports, "SELF_RELATION", () => $6fd5b83c81baa8b0$export$6d8a854a71ae97f2);
$parcel$export(module.exports, "UNKNOWN_RELATION", () => $6fd5b83c81baa8b0$export$db563923a0040e3f);
$parcel$export(module.exports, "phoneRelationLabel", () => $6fd5b83c81baa8b0$export$e467684bb5884d3e);
$parcel$export(module.exports, "phoneRelationOptions", () => $6fd5b83c81baa8b0$export$e5a8336f9f87d712);
// ─────────────────────────────────────────────────────────────────────────────
// «صاحب شماره» — whose number a phone on a patient's record is (PM-0536).
//
// ONE vocabulary for every web client: the desk's list editor, the record's read
// view, the candidate list and — when PM-0121 lands — the guardian relation, which
// shares it. The service holds the same list (patientmanagement
// `app/domain/patient_phones.py`) and refuses anything outside it, so a value here
// that the service does not know is a save that fails.
//
// THE RELATION DECIDES WHETHER A NUMBER MAY CLAIM A RECORD. Only `self` and `unknown`
// numbers reach the patient app's record picker; a relative's number identifies and
// contacts, never claims. That is why an ADDED number has no default here: defaulting
// it to `self` would make every relative's number a key to the record.
//
// `unknown` («نامشخص») is what every number that existed before PM-0536 became. It is
// SHOWN, and it STAYS when nobody touches it, but no person ever writes it — the service
// refuses it on a new number and on a change — so it is never offered as a choice.
// ─────────────────────────────────────────────────────────────────────────────

var $j9AxR = parcelRequire("j9AxR");
const $6fd5b83c81baa8b0$export$d9704f34bcb9afb = Object.freeze([
    'self',
    'spouse',
    'father',
    'mother',
    'child',
    'sibling',
    'legal_guardian',
    'caregiver',
    'other'
]);
const $6fd5b83c81baa8b0$export$6d8a854a71ae97f2 = 'self';
const $6fd5b83c81baa8b0$export$db563923a0040e3f = 'unknown';
const $6fd5b83c81baa8b0$export$6c733408d4b40d49 = (value)=>$6fd5b83c81baa8b0$export$d9704f34bcb9afb.includes(value);
function $6fd5b83c81baa8b0$export$e467684bb5884d3e(relation, locale) {
    return (0, $j9AxR.kitCopy)(locale).phoneRelation[relation] || '';
}
function $6fd5b83c81baa8b0$export$e5a8336f9f87d712(locale, current) {
    const words = (0, $j9AxR.kitCopy)(locale).phoneRelation;
    const options = $6fd5b83c81baa8b0$export$d9704f34bcb9afb.map((value)=>({
            value: value,
            label: words[value]
        }));
    return current === $6fd5b83c81baa8b0$export$db563923a0040e3f ? [
        ...options,
        {
            value: $6fd5b83c81baa8b0$export$db563923a0040e3f,
            label: words[$6fd5b83c81baa8b0$export$db563923a0040e3f],
            disabled: true
        }
    ] : options;
}

});

parcelRegister("9gEOi", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a6c6e1277da35de$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $4pk8U = parcelRequire("4pk8U");

var $5JYPc = parcelRequire("5JYPc");
'use client';
// `label` takes a node, not just a string: a picker row is a checkbox whose
// label IS the row (name, value, trend), and wrapping it here keeps the whole
// row inside the native <label> hit area instead of re-implementing one.
// `className`/rest land on that <label> so callers can carry the §15.1
// `data-testid` / `data-state` contract without a wrapper element.
const $7a6c6e1277da35de$var$Checkbox = ({ checked: checked, onChange: onChange, label: label, disabled: disabled = false, className: className, labelClassName: labelClassName, style: style, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        className: (0, $5JYPc.cn)('flex items-center gap-2.5 select-none', disabled ? 'cursor-not-allowed' : 'cursor-pointer', className),
        style: style,
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4pk8U.Root, {
        checked: checked,
        onCheckedChange: onChange,
        disabled: disabled,
        className: (0, $5JYPc.cn)('h-[18px] w-[18px] shrink-0 rounded-[5px] border-[1.5px]', 'flex items-center justify-center', 'transition-all duration-150 outline-none', 'focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1', checked ? 'bg-navy border-navy' : 'bg-white border-border', disabled && 'opacity-50')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4pk8U.Indicator, {
        className: "flex items-center justify-center text-white"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "11",
        height: "11"
    }, checked === 'indeterminate' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M5 11h14v2H5z"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
    })))), label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $5JYPc.cn)('text-sm font-sans text-foreground', labelClassName)
    }, label));
var $7a6c6e1277da35de$export$2e2bcd8739ae039 = $7a6c6e1277da35de$var$Checkbox;

});
parcelRegister("4pk8U", function(module, exports) {

$parcel$export(module.exports, "Indicator", () => $99e5d66a1fc753c6$export$59aad738f51d1c05);
$parcel$export(module.exports, "Root", () => $99e5d66a1fc753c6$export$48513f6b9f8ce62d);

var $acw62 = parcelRequire("acw62");

var $htT6J = parcelRequire("htT6J");

var $jnK0n = parcelRequire("jnK0n");

var $2IwC4 = parcelRequire("2IwC4");

var $88UcQ = parcelRequire("88UcQ");

var $8727j = parcelRequire("8727j");

var $cTFdF = parcelRequire("cTFdF");

var $kFbxc = parcelRequire("kFbxc");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $99e5d66a1fc753c6$var$__defProp = Object.defineProperty;
var $99e5d66a1fc753c6$var$__name = (target, value)=>$99e5d66a1fc753c6$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $99e5d66a1fc753c6$var$CHECKBOX_NAME = "Checkbox";
var [$99e5d66a1fc753c6$var$createCheckboxContext, $99e5d66a1fc753c6$export$b566c4ff5488ea01] = (0, $jnK0n.createContextScope)($99e5d66a1fc753c6$var$CHECKBOX_NAME);
var [$99e5d66a1fc753c6$var$CheckboxProviderImpl, $99e5d66a1fc753c6$var$useCheckboxContext] = $99e5d66a1fc753c6$var$createCheckboxContext($99e5d66a1fc753c6$var$CHECKBOX_NAME);
function $99e5d66a1fc753c6$export$1335a92a9ee50a8d(props) {
    const { __scopeCheckbox: __scopeCheckbox, checked: checkedProp, children: children, defaultChecked: defaultChecked, disabled: disabled, form: form, name: name, onCheckedChange: onCheckedChange, required: required, value: value = "on", internal_do_not_use_render: // @ts-expect-error
    internal_do_not_use_render } = props;
    const [checked, setChecked] = (0, $88UcQ.useControllableState)({
        prop: checkedProp,
        defaultProp: defaultChecked ?? false,
        onChange: onCheckedChange,
        caller: $99e5d66a1fc753c6$var$CHECKBOX_NAME
    });
    const [control, setControl] = $acw62.useState(null);
    const [bubbleInput, setBubbleInput] = $acw62.useState(null);
    const [userClick, setUserClick] = $acw62.useState(null);
    const isFormControl = control ? !!form || !!control.closest("form") : // We set this to true by default so that events bubble to forms without JS (SSR)
    true;
    const context = {
        checked: checked,
        disabled: disabled,
        setChecked: setChecked,
        control: control,
        setControl: setControl,
        name: name,
        form: form,
        value: value,
        userClick: userClick,
        onUserClick: setUserClick,
        required: required,
        defaultChecked: $99e5d66a1fc753c6$var$isIndeterminate(defaultChecked) ? false : defaultChecked,
        isFormControl: isFormControl,
        bubbleInput: bubbleInput,
        setBubbleInput: setBubbleInput
    };
    return /* @__PURE__ */ (0, $ayMG0.jsx)($99e5d66a1fc753c6$var$CheckboxProviderImpl, {
        scope: __scopeCheckbox,
        ...context,
        children: $99e5d66a1fc753c6$var$isFunction(internal_do_not_use_render) ? internal_do_not_use_render(context) : children
    });
}
$99e5d66a1fc753c6$var$__name($99e5d66a1fc753c6$export$1335a92a9ee50a8d, "CheckboxProvider");
var $99e5d66a1fc753c6$var$TRIGGER_NAME = "CheckboxTrigger";
var $99e5d66a1fc753c6$export$1386466acbe59ca2 = /* @__PURE__ */ $acw62.forwardRef(/* @__PURE__ */ $99e5d66a1fc753c6$var$__name(function CheckboxTrigger2({ __scopeCheckbox: __scopeCheckbox, onKeyDown: onKeyDown, onClick: onClick, ...checkboxProps }, forwardedRef) {
    const { control: control, value: value, disabled: disabled, checked: checked, required: required, setControl: setControl, setChecked: setChecked, onUserClick: onUserClick, isFormControl: isFormControl, bubbleInput: bubbleInput } = $99e5d66a1fc753c6$var$useCheckboxContext($99e5d66a1fc753c6$var$TRIGGER_NAME, __scopeCheckbox);
    const composedRefs = (0, $htT6J.useComposedRefs)(forwardedRef, setControl);
    const initialCheckedStateRef = $acw62.useRef(checked);
    $acw62.useEffect(()=>{
        const form = control?.form;
        if (form) {
            const reset = /* @__PURE__ */ $99e5d66a1fc753c6$var$__name(()=>setChecked(initialCheckedStateRef.current), "reset");
            form.addEventListener("reset", reset);
            return ()=>form.removeEventListener("reset", reset);
        }
    }, [
        control,
        setChecked
    ]);
    return /* @__PURE__ */ (0, $ayMG0.jsx)((0, $kFbxc.Primitive).button, {
        type: "button",
        role: "checkbox",
        "aria-checked": $99e5d66a1fc753c6$var$isIndeterminate(checked) ? "mixed" : checked,
        "aria-required": required,
        "data-state": $99e5d66a1fc753c6$var$getState(checked),
        "data-disabled": disabled ? "" : void 0,
        disabled: disabled,
        value: value,
        ...checkboxProps,
        ref: composedRefs,
        onKeyDown: (0, $2IwC4.composeEventHandlers)(onKeyDown, (event)=>{
            if (event.key === "Enter") event.preventDefault();
        }),
        onClick: (0, $2IwC4.composeEventHandlers)(onClick, (event)=>{
            const hasConsumerStoppedPropagation = event.isPropagationStopped();
            onUserClick({
                requestedChecked: $99e5d66a1fc753c6$var$isIndeterminate(checked) ? true : !checked,
                hasConsumerStoppedPropagation: hasConsumerStoppedPropagation
            });
            setChecked((prevChecked)=>$99e5d66a1fc753c6$var$isIndeterminate(prevChecked) ? true : !prevChecked);
            if (bubbleInput && isFormControl) {
                if (!hasConsumerStoppedPropagation) event.stopPropagation();
            }
        })
    });
}, "CheckboxTrigger"));
var $99e5d66a1fc753c6$export$48513f6b9f8ce62d = /* @__PURE__ */ $acw62.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $99e5d66a1fc753c6$var$__name(function Checkbox2(props, forwardedRef) {
    const { __scopeCheckbox: __scopeCheckbox, name: name, checked: checked, defaultChecked: defaultChecked, required: required, disabled: disabled, value: value, onCheckedChange: onCheckedChange, form: form, ...checkboxProps } = props;
    return /* @__PURE__ */ (0, $ayMG0.jsx)($99e5d66a1fc753c6$export$1335a92a9ee50a8d, {
        __scopeCheckbox: __scopeCheckbox,
        checked: checked,
        defaultChecked: defaultChecked,
        disabled: disabled,
        required: required,
        onCheckedChange: onCheckedChange,
        name: name,
        form: form,
        value: value,
        internal_do_not_use_render: ({ isFormControl: isFormControl })=>/* @__PURE__ */ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /* @__PURE__ */ (0, $ayMG0.jsx)($99e5d66a1fc753c6$export$1386466acbe59ca2, {
                        ...checkboxProps,
                        ref: forwardedRef,
                        __scopeCheckbox: __scopeCheckbox
                    }),
                    isFormControl && /* @__PURE__ */ (0, $ayMG0.jsx)($99e5d66a1fc753c6$export$493083511fc9f964, {
                        __scopeCheckbox: __scopeCheckbox
                    })
                ]
            })
    });
}, "Checkbox"));
var $99e5d66a1fc753c6$var$INDICATOR_NAME = "CheckboxIndicator";
var $99e5d66a1fc753c6$export$59aad738f51d1c05 = /* @__PURE__ */ $acw62.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $99e5d66a1fc753c6$var$__name(function CheckboxIndicator2(props, forwardedRef) {
    const { __scopeCheckbox: __scopeCheckbox, forceMount: forceMount, ...indicatorProps } = props;
    const context = $99e5d66a1fc753c6$var$useCheckboxContext($99e5d66a1fc753c6$var$INDICATOR_NAME, __scopeCheckbox);
    return /* @__PURE__ */ (0, $ayMG0.jsx)((0, $cTFdF.Presence), {
        present: forceMount || $99e5d66a1fc753c6$var$isIndeterminate(context.checked) || context.checked === true,
        children: /* @__PURE__ */ (0, $ayMG0.jsx)((0, $kFbxc.Primitive).span, {
            "data-state": $99e5d66a1fc753c6$var$getState(context.checked),
            "data-disabled": context.disabled ? "" : void 0,
            ...indicatorProps,
            ref: forwardedRef,
            style: {
                pointerEvents: "none",
                ...props.style
            }
        })
    });
}, "CheckboxIndicator"));
var $99e5d66a1fc753c6$var$BUBBLE_INPUT_NAME = "CheckboxBubbleInput";
var $99e5d66a1fc753c6$export$493083511fc9f964 = /* @__PURE__ */ $acw62.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $99e5d66a1fc753c6$var$__name(function CheckboxBubbleInput2({ __scopeCheckbox: __scopeCheckbox, onClick: onClick, ...props }, forwardedRef) {
    const { control: control, userClick: userClick, checked: checked, defaultChecked: defaultChecked, required: required, disabled: disabled, name: name, value: value, form: form, bubbleInput: bubbleInput, setBubbleInput: setBubbleInput } = $99e5d66a1fc753c6$var$useCheckboxContext($99e5d66a1fc753c6$var$BUBBLE_INPUT_NAME, __scopeCheckbox);
    const composedRefs = (0, $htT6J.useComposedRefs)(forwardedRef, setBubbleInput);
    const controlSize = (0, $8727j.useSize)(control);
    const shouldStopClickPropagationRef = $acw62.useRef(false);
    const prevCheckedRef = $acw62.useRef(checked);
    const handledUserClickRef = $acw62.useRef(userClick);
    const pendingUserClickRef = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        const input = bubbleInput;
        if (!input) return;
        const inputProto = window.HTMLInputElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(inputProto, "checked");
        const setChecked = descriptor.set;
        if (!setChecked) return;
        const checkedChanged = prevCheckedRef.current !== checked;
        prevCheckedRef.current = checked;
        const isNewUserClick = userClick !== null && userClick !== handledUserClickRef.current;
        handledUserClickRef.current = userClick;
        if (isNewUserClick) {
            pendingUserClickRef.current = checkedChanged ? null : userClick;
            if (checkedChanged) {
                input.indeterminate = $99e5d66a1fc753c6$var$isIndeterminate(checked);
                setChecked.call(input, $99e5d66a1fc753c6$var$isIndeterminate(checked) ? false : checked);
            }
            input.dispatchEvent(new Event("click", {
                bubbles: !userClick.hasConsumerStoppedPropagation
            }));
        } else if (checkedChanged) {
            const pendingUserClick = pendingUserClickRef.current;
            pendingUserClickRef.current = null;
            const isPendingUserChange = pendingUserClick?.requestedChecked === checked;
            shouldStopClickPropagationRef.current = true;
            input.indeterminate = $99e5d66a1fc753c6$var$isIndeterminate(checked);
            setChecked.call(input, $99e5d66a1fc753c6$var$isIndeterminate(checked) ? false : checked);
            input.dispatchEvent(new Event("click", {
                bubbles: !(isPendingUserChange && pendingUserClick.hasConsumerStoppedPropagation)
            }));
            shouldStopClickPropagationRef.current = false;
        }
    }, [
        bubbleInput,
        checked,
        userClick
    ]);
    const defaultCheckedRef = $acw62.useRef($99e5d66a1fc753c6$var$isIndeterminate(checked) ? false : checked);
    return /* @__PURE__ */ (0, $ayMG0.jsx)((0, $kFbxc.Primitive).input, {
        type: "checkbox",
        "aria-hidden": true,
        defaultChecked: defaultChecked ?? defaultCheckedRef.current,
        required: required,
        disabled: disabled,
        name: name,
        value: value,
        form: form,
        ...props,
        tabIndex: -1,
        ref: composedRefs,
        onClick: (0, $2IwC4.composeEventHandlers)(onClick, (event)=>{
            if (shouldStopClickPropagationRef.current) event.stopPropagation();
        }),
        style: {
            ...props.style,
            ...controlSize,
            position: "absolute",
            pointerEvents: "none",
            opacity: 0,
            margin: 0,
            // We transform because the input is absolutely positioned but we have
            // rendered it **after** the button. This pulls it back to sit on top
            // of the button.
            transform: "translateX(-100%)"
        }
    });
}, "CheckboxBubbleInput"));
function $99e5d66a1fc753c6$var$isFunction(value) {
    return typeof value === "function";
}
$99e5d66a1fc753c6$var$__name($99e5d66a1fc753c6$var$isFunction, "isFunction");
function $99e5d66a1fc753c6$var$isIndeterminate(checked) {
    return checked === "indeterminate";
}
$99e5d66a1fc753c6$var$__name($99e5d66a1fc753c6$var$isIndeterminate, "isIndeterminate");
function $99e5d66a1fc753c6$var$getState(checked) {
    return $99e5d66a1fc753c6$var$isIndeterminate(checked) ? "indeterminate" : checked ? "checked" : "unchecked";
}
$99e5d66a1fc753c6$var$__name($99e5d66a1fc753c6$var$getState, "getState");

});
parcelRegister("jnK0n", function(module, exports) {

$parcel$export(module.exports, "createContextScope", () => $45e038b71f97d914$export$50c7b4e9d9f19c1);

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");
var $45e038b71f97d914$var$__defProp = Object.defineProperty;
var $45e038b71f97d914$var$__name = (target, value)=>$45e038b71f97d914$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
// @__NO_SIDE_EFFECTS__
function $45e038b71f97d914$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = $acw62.createContext(defaultContext);
    Context.displayName = rootComponentName + "Context";
    const Provider = /* @__PURE__ */ $45e038b71f97d914$var$__name((props)=>{
        const { children: children, ...context } = props;
        const value = $acw62.useMemo(()=>context, Object.values(context));
        return /* @__PURE__ */ (0, $ayMG0.jsx)(Context.Provider, {
            value: value,
            children: children
        });
    }, "Provider");
    Provider.displayName = rootComponentName + "Provider";
    function useContext2(consumerName, options = {}) {
        const { optional: optional = false } = options;
        const context = $acw62.useContext(Context);
        if (context) return context;
        if (defaultContext !== void 0) return defaultContext;
        if (optional) return void 0;
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    $45e038b71f97d914$var$__name(useContext2, "useContext");
    return [
        Provider,
        useContext2
    ];
}
$45e038b71f97d914$var$__name($45e038b71f97d914$export$fd42f52fd3ae1109, "createContext");
// @__NO_SIDE_EFFECTS__
function $45e038b71f97d914$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    function createContext3(rootComponentName, defaultContext) {
        const BaseContext = $acw62.createContext(defaultContext);
        BaseContext.displayName = rootComponentName + "Context";
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        const Provider = /* @__PURE__ */ $45e038b71f97d914$var$__name((props)=>{
            const { scope: scope, children: children, ...context } = props;
            const Context = scope?.[scopeName]?.[index] || BaseContext;
            const value = $acw62.useMemo(()=>context, Object.values(context));
            return /* @__PURE__ */ (0, $ayMG0.jsx)(Context.Provider, {
                value: value,
                children: children
            });
        }, "Provider");
        Provider.displayName = rootComponentName + "Provider";
        function useContext2(consumerName, scope, options = {}) {
            const { optional: optional = false } = options;
            const Context = scope?.[scopeName]?.[index] || BaseContext;
            const context = $acw62.useContext(Context);
            if (context) return context;
            if (defaultContext !== void 0) return defaultContext;
            if (optional) return void 0;
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        $45e038b71f97d914$var$__name(useContext2, "useContext");
        return [
            Provider,
            useContext2
        ];
    }
    $45e038b71f97d914$var$__name(createContext3, "createContext");
    const createScope = /* @__PURE__ */ $45e038b71f97d914$var$__name(()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return $acw62.createContext(defaultContext);
        });
        return /* @__PURE__ */ $45e038b71f97d914$var$__name(function useScope(scope) {
            const contexts = scope?.[scopeName] || scopeContexts;
            return $acw62.useMemo(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        }, "useScope");
    }, "createScope");
    createScope.scopeName = scopeName;
    return [
        createContext3,
        $45e038b71f97d914$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
$45e038b71f97d914$var$__name($45e038b71f97d914$export$50c7b4e9d9f19c1, "createContextScope");
function $45e038b71f97d914$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope = /* @__PURE__ */ $45e038b71f97d914$var$__name(()=>{
        const scopeHooks = scopes.map((createScope2)=>({
                useScope: createScope2(),
                scopeName: createScope2.scopeName
            }));
        return /* @__PURE__ */ $45e038b71f97d914$var$__name(function useComposedScopes(overrideScopes) {
            const nextScopes = scopeHooks.reduce((nextScopes2, { useScope: useScope, scopeName: scopeName })=>{
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes2,
                    ...currentScope
                };
            }, {});
            return $acw62.useMemo(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes
                }), [
                nextScopes
            ]);
        }, "useComposedScopes");
    }, "createScope");
    createScope.scopeName = baseScope.scopeName;
    return createScope;
}
$45e038b71f97d914$var$__name($45e038b71f97d914$var$composeContextScopes, "composeContextScopes");

});

parcelRegister("2IwC4", function(module, exports) {

$parcel$export(module.exports, "composeEventHandlers", () => $b4e9a20689651e16$export$b9ecd428b558ff10);
var $b4e9a20689651e16$var$__defProp = Object.defineProperty;
var $b4e9a20689651e16$var$__name = (target, value)=>$b4e9a20689651e16$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
// src/primitive.tsx
var $b4e9a20689651e16$export$71594e8a50f746f4 = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $b4e9a20689651e16$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {}) {
    return /* @__PURE__ */ $b4e9a20689651e16$var$__name(function handleEvent(event) {
        originalEventHandler?.(event);
        if (checkForDefaultPrevented === false || !event || !event.defaultPrevented) return ourEventHandler?.(event);
    }, "handleEvent");
}
$b4e9a20689651e16$var$__name($b4e9a20689651e16$export$b9ecd428b558ff10, "composeEventHandlers");
function $b4e9a20689651e16$export$f21a1ffae260145a(element) {
    if (!$b4e9a20689651e16$export$71594e8a50f746f4) throw new Error("Cannot access window outside of the DOM");
    return element?.ownerDocument?.defaultView ?? window;
}
$b4e9a20689651e16$var$__name($b4e9a20689651e16$export$f21a1ffae260145a, "getOwnerWindow");
function $b4e9a20689651e16$export$b204af158042fbac(element) {
    if (!$b4e9a20689651e16$export$71594e8a50f746f4) throw new Error("Cannot access document outside of the DOM");
    return element?.ownerDocument ?? document;
}
$b4e9a20689651e16$var$__name($b4e9a20689651e16$export$b204af158042fbac, "getOwnerDocument");
function $b4e9a20689651e16$export$cd4e5573fbe2b576(node, activeDescendant = false) {
    const { activeElement: activeElement } = $b4e9a20689651e16$export$b204af158042fbac(node);
    if (!activeElement?.nodeName) return null;
    if ($b4e9a20689651e16$export$6a12f24039de8f3a(activeElement) && activeElement.contentDocument) return $b4e9a20689651e16$export$cd4e5573fbe2b576(activeElement.contentDocument.body, activeDescendant);
    if (activeDescendant) {
        const id = activeElement.getAttribute("aria-activedescendant");
        if (id) {
            const element = $b4e9a20689651e16$export$b204af158042fbac(activeElement).getElementById(id);
            if (element) return element;
        }
    }
    return activeElement;
}
$b4e9a20689651e16$var$__name($b4e9a20689651e16$export$cd4e5573fbe2b576, "getActiveElement");
function $b4e9a20689651e16$export$6a12f24039de8f3a(element) {
    return element.tagName === "IFRAME";
}
$b4e9a20689651e16$var$__name($b4e9a20689651e16$export$6a12f24039de8f3a, "isFrame");

});

parcelRegister("88UcQ", function(module, exports) {

$parcel$export(module.exports, "useControllableState", () => $aef12de5508fd46e$export$6f32135080cb4c3);

var $acw62 = parcelRequire("acw62");

var $Go84F = parcelRequire("Go84F");

var $7g00o = parcelRequire("7g00o");

var $c0Rea = parcelRequire("c0Rea");
var $aef12de5508fd46e$var$__defProp = Object.defineProperty;
var $aef12de5508fd46e$var$__name = (target, value)=>$aef12de5508fd46e$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $aef12de5508fd46e$var$useInsertionEffect = $acw62[" useInsertionEffect ".trim().toString()] || (0, $7g00o.useLayoutEffect);
function $aef12de5508fd46e$export$6f32135080cb4c3({ prop: prop, defaultProp: defaultProp, onChange: onChange = /* @__PURE__ */ $aef12de5508fd46e$var$__name(()=>{}, "onChange"), caller: caller }) {
    const [uncontrolledProp, setUncontrolledProp, onChangeRef] = $aef12de5508fd46e$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== void 0;
    const value = isControlled ? prop : uncontrolledProp;
    if (0, $Go84F.IS_DEVELOPMENT) {
        const isControlledRef = $acw62.useRef(prop !== void 0);
        $acw62.useEffect(()=>{
            const wasControlled = isControlledRef.current;
            if (wasControlled !== isControlled) {
                const from = wasControlled ? "controlled" : "uncontrolled";
                const to = isControlled ? "controlled" : "uncontrolled";
                console.warn(`${caller} is changing from ${from} to ${to}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`);
            }
            isControlledRef.current = isControlled;
        }, [
            isControlled,
            caller
        ]);
    }
    const setValue = $acw62.useCallback((nextValue)=>{
        if (isControlled) {
            const value2 = $aef12de5508fd46e$var$isFunction(nextValue) ? nextValue(prop) : nextValue;
            if (value2 !== prop) onChangeRef.current?.(value2);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        onChangeRef
    ]);
    return [
        value,
        setValue
    ];
}
$aef12de5508fd46e$var$__name($aef12de5508fd46e$export$6f32135080cb4c3, "useControllableState");
function $aef12de5508fd46e$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const [value, setValue] = $acw62.useState(defaultProp);
    const prevValueRef = $acw62.useRef(value);
    const onChangeRef = $acw62.useRef(onChange);
    $aef12de5508fd46e$var$useInsertionEffect(()=>{
        onChangeRef.current = onChange;
    }, [
        onChange
    ]);
    $acw62.useEffect(()=>{
        if (prevValueRef.current !== value) {
            onChangeRef.current?.(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef
    ]);
    return [
        value,
        setValue,
        onChangeRef
    ];
}
$aef12de5508fd46e$var$__name($aef12de5508fd46e$var$useUncontrolledState, "useUncontrolledState");
function $aef12de5508fd46e$var$isFunction(value) {
    return typeof value === "function";
}
$aef12de5508fd46e$var$__name($aef12de5508fd46e$var$isFunction, "isFunction");
var $aef12de5508fd46e$var$SYNC_STATE = Symbol("RADIX:SYNC_STATE");
function $aef12de5508fd46e$export$bf6fc034f0c038af(reducer, userArgs, initialArg, init) {
    const { prop: controlledState, defaultProp: defaultProp, onChange: onChangeProp, caller: caller } = userArgs;
    const isControlled = controlledState !== void 0;
    const onChange = (0, $c0Rea.useEffectEvent)(onChangeProp);
    if (0, $Go84F.IS_DEVELOPMENT) {
        const isControlledRef = $acw62.useRef(controlledState !== void 0);
        $acw62.useEffect(()=>{
            const wasControlled = isControlledRef.current;
            if (wasControlled !== isControlled) {
                const from = wasControlled ? "controlled" : "uncontrolled";
                const to = isControlled ? "controlled" : "uncontrolled";
                console.warn(`${caller} is changing from ${from} to ${to}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`);
            }
            isControlledRef.current = isControlled;
        }, [
            isControlled,
            caller
        ]);
    }
    const args = [
        {
            ...initialArg,
            state: defaultProp
        }
    ];
    if (init) args.push(init);
    const [internalState, dispatch] = $acw62.useReducer((state2, action)=>{
        if (action.type === $aef12de5508fd46e$var$SYNC_STATE) return {
            ...state2,
            state: action.state
        };
        const next = reducer(state2, action);
        if (isControlled && !Object.is(next.state, state2.state)) onChange(next.state);
        return next;
    }, ...args);
    const uncontrolledState = internalState.state;
    const prevValueRef = $acw62.useRef(uncontrolledState);
    $acw62.useEffect(()=>{
        if (prevValueRef.current !== uncontrolledState) {
            prevValueRef.current = uncontrolledState;
            if (!isControlled) onChange(uncontrolledState);
        }
    }, [
        uncontrolledState,
        prevValueRef,
        isControlled
    ]);
    const state = $acw62.useMemo(()=>{
        const isControlled2 = controlledState !== void 0;
        if (isControlled2) return {
            ...internalState,
            state: controlledState
        };
        return internalState;
    }, [
        internalState,
        controlledState
    ]);
    $acw62.useEffect(()=>{
        if (isControlled && !Object.is(controlledState, internalState.state)) dispatch({
            type: $aef12de5508fd46e$var$SYNC_STATE,
            state: controlledState
        });
    }, [
        controlledState,
        internalState.state,
        isControlled
    ]);
    return [
        state,
        dispatch
    ];
}
$aef12de5508fd46e$var$__name($aef12de5508fd46e$export$bf6fc034f0c038af, "useControllableStateReducer");

});
parcelRegister("Go84F", function(module, exports) {

$parcel$export(module.exports, "IS_DEVELOPMENT", () => $e980dcb15c017255$export$26928cc6c201953c);
// src/internal/is-development.false.ts
var $e980dcb15c017255$export$26928cc6c201953c = false;

});

parcelRegister("7g00o", function(module, exports) {

$parcel$export(module.exports, "useLayoutEffect", () => $b68d88740313b08e$export$e5c5a5f917a5871c);
// src/use-layout-effect.tsx

var $acw62 = parcelRequire("acw62");
var $b68d88740313b08e$export$e5c5a5f917a5871c = globalThis?.document ? $acw62.useLayoutEffect : ()=>{};

});

parcelRegister("c0Rea", function(module, exports) {

$parcel$export(module.exports, "useEffectEvent", () => $07b0b1ce13d5e29f$export$7f54fc3180508a52);

var $7g00o = parcelRequire("7g00o");

var $acw62 = parcelRequire("acw62");
var $07b0b1ce13d5e29f$var$__defProp = Object.defineProperty;
var $07b0b1ce13d5e29f$var$__name = (target, value)=>$07b0b1ce13d5e29f$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $07b0b1ce13d5e29f$var$useReactEffectEvent = $acw62[" useEffectEvent ".trim().toString()];
var $07b0b1ce13d5e29f$var$useReactInsertionEffect = $acw62[" useInsertionEffect ".trim().toString()];
function $07b0b1ce13d5e29f$export$7f54fc3180508a52(callback) {
    if (typeof $07b0b1ce13d5e29f$var$useReactEffectEvent === "function") return $07b0b1ce13d5e29f$var$useReactEffectEvent(callback);
    const ref = $acw62.useRef(()=>{
        throw new Error("Cannot call an event handler while rendering.");
    });
    if (typeof $07b0b1ce13d5e29f$var$useReactInsertionEffect === "function") $07b0b1ce13d5e29f$var$useReactInsertionEffect(()=>{
        ref.current = callback;
    });
    else (0, $7g00o.useLayoutEffect)(()=>{
        ref.current = callback;
    });
    return $acw62.useMemo(()=>(...args)=>ref.current?.(...args), []);
}
$07b0b1ce13d5e29f$var$__name($07b0b1ce13d5e29f$export$7f54fc3180508a52, "useEffectEvent");

});


parcelRegister("8727j", function(module, exports) {

$parcel$export(module.exports, "useSize", () => $db5ba6ddde57f255$export$1ab7ae714698c4b8);

var $acw62 = parcelRequire("acw62");

var $7g00o = parcelRequire("7g00o");
var $db5ba6ddde57f255$var$__defProp = Object.defineProperty;
var $db5ba6ddde57f255$var$__name = (target, value)=>$db5ba6ddde57f255$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
function $db5ba6ddde57f255$export$1ab7ae714698c4b8(element) {
    const [size, setSize] = $acw62.useState(void 0);
    (0, $7g00o.useLayoutEffect)(()=>{
        if (element) {
            setSize({
                width: element.offsetWidth,
                height: element.offsetHeight
            });
            let rAF = 0;
            const resizeObserver = new ResizeObserver((entries)=>{
                if (!Array.isArray(entries)) return;
                if (!entries.length) return;
                const entry = entries[0];
                window.cancelAnimationFrame(rAF);
                rAF = window.requestAnimationFrame(()=>{
                    let width;
                    let height;
                    if ("borderBoxSize" in entry) {
                        const borderSizeEntry = entry["borderBoxSize"];
                        const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
                        width = borderSize["inlineSize"];
                        height = borderSize["blockSize"];
                    } else {
                        width = element.offsetWidth;
                        height = element.offsetHeight;
                    }
                    setSize({
                        width: width,
                        height: height
                    });
                });
            });
            resizeObserver.observe(element, {
                box: "border-box"
            });
            return ()=>{
                window.cancelAnimationFrame(rAF);
                resizeObserver.unobserve(element);
            };
        } else setSize(void 0);
    }, [
        element
    ]);
    return size;
}
$db5ba6ddde57f255$var$__name($db5ba6ddde57f255$export$1ab7ae714698c4b8, "useSize");

});

parcelRegister("cTFdF", function(module, exports) {

$parcel$export(module.exports, "Presence", () => $3207c0aa9f229d8f$export$99c2b779aa4e8b8b);

var $acw62 = parcelRequire("acw62");

var $7g00o = parcelRequire("7g00o");
"use client";
var $3207c0aa9f229d8f$var$__defProp = Object.defineProperty;
var $3207c0aa9f229d8f$var$__name = (target, value)=>$3207c0aa9f229d8f$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
function $3207c0aa9f229d8f$var$useStateMachine(initialState, machine) {
    return $acw62.useReducer((state, event)=>{
        const nextState = machine[state][event];
        return nextState ?? state;
    }, initialState);
}
$3207c0aa9f229d8f$var$__name($3207c0aa9f229d8f$var$useStateMachine, "useStateMachine");
// src/presence.tsx
var $3207c0aa9f229d8f$export$99c2b779aa4e8b8b = /* @__PURE__ */ $3207c0aa9f229d8f$var$__name((props)=>{
    const { present: present, children: children } = props;
    const presence = $3207c0aa9f229d8f$var$usePresence(present);
    const child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : $acw62.Children.only(children);
    const ref = $3207c0aa9f229d8f$var$useStableComposedRefs(presence.ref, $3207c0aa9f229d8f$var$getElementRef(child));
    const forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? $acw62.cloneElement(child, {
        ref: ref
    }) : null;
}, "Presence");
function $3207c0aa9f229d8f$var$usePresence(present) {
    const [node, setNode] = $acw62.useState();
    const stylesRef = $acw62.useRef(null);
    const prevPresentRef = $acw62.useRef(present);
    const prevAnimationNameRef = $acw62.useRef("none");
    const mountAnimationNameRef = $acw62.useRef(void 0);
    const initialState = present ? "mounted" : "unmounted";
    const [state, send] = $3207c0aa9f229d8f$var$useStateMachine(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    $acw62.useEffect(()=>{
        if (state === "mounted") {
            prevAnimationNameRef.current = mountAnimationNameRef.current ?? $3207c0aa9f229d8f$var$getAnimationName(stylesRef.current);
            mountAnimationNameRef.current = void 0;
        } else prevAnimationNameRef.current = "none";
    }, [
        state
    ]);
    (0, $7g00o.useLayoutEffect)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $3207c0aa9f229d8f$var$getAnimationName(styles);
            if (present) {
                mountAnimationNameRef.current = currentAnimationName;
                send("MOUNT");
            } else if (currentAnimationName === "none" || styles?.display === "none") send("UNMOUNT");
            else {
                const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $7g00o.useLayoutEffect)(()=>{
        if (node) {
            let timeoutId;
            const ownerWindow = node.ownerDocument.defaultView ?? window;
            const handleAnimationEnd = /* @__PURE__ */ $3207c0aa9f229d8f$var$__name((event)=>{
                const currentAnimationName = $3207c0aa9f229d8f$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(CSS.escape(event.animationName));
                if (event.target === node && isCurrentAnimation) {
                    send("ANIMATION_END");
                    if (!prevPresentRef.current) {
                        const currentFillMode = node.style.animationFillMode;
                        node.style.animationFillMode = "forwards";
                        timeoutId = ownerWindow.setTimeout(()=>{
                            if (node.style.animationFillMode === "forwards") node.style.animationFillMode = currentFillMode;
                        });
                    }
                }
            }, "handleAnimationEnd");
            const handleAnimationStart = /* @__PURE__ */ $3207c0aa9f229d8f$var$__name((event)=>{
                if (event.target === node) prevAnimationNameRef.current = $3207c0aa9f229d8f$var$getAnimationName(stylesRef.current);
            }, "handleAnimationStart");
            node.addEventListener("animationstart", handleAnimationStart);
            node.addEventListener("animationcancel", handleAnimationEnd);
            node.addEventListener("animationend", handleAnimationEnd);
            return ()=>{
                ownerWindow.clearTimeout(timeoutId);
                node.removeEventListener("animationstart", handleAnimationStart);
                node.removeEventListener("animationcancel", handleAnimationEnd);
                node.removeEventListener("animationend", handleAnimationEnd);
            };
        } else send("ANIMATION_END");
    }, [
        node,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: $acw62.useCallback((node2)=>{
            if (node2) {
                const styles = getComputedStyle(node2);
                stylesRef.current = styles;
                mountAnimationNameRef.current = $3207c0aa9f229d8f$var$getAnimationName(styles);
            } else stylesRef.current = null;
            setNode(node2);
        }, [])
    };
}
$3207c0aa9f229d8f$var$__name($3207c0aa9f229d8f$var$usePresence, "usePresence");
function $3207c0aa9f229d8f$var$setRef(ref, value) {
    if (typeof ref === "function") return ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
$3207c0aa9f229d8f$var$__name($3207c0aa9f229d8f$var$setRef, "setRef");
function $3207c0aa9f229d8f$var$useStableComposedRefs(...refs) {
    const refsRef = $acw62.useRef(refs);
    refsRef.current = refs;
    return $acw62.useCallback((node)=>{
        const currentRefs = refsRef.current;
        let hasCleanup = false;
        const cleanups = currentRefs.map((ref)=>{
            const cleanup = $3207c0aa9f229d8f$var$setRef(ref, node);
            if (!hasCleanup && typeof cleanup === "function") hasCleanup = true;
            return cleanup;
        });
        if (hasCleanup) return ()=>{
            for(let i = 0; i < cleanups.length; i++){
                const cleanup = cleanups[i];
                if (typeof cleanup === "function") cleanup();
                else $3207c0aa9f229d8f$var$setRef(currentRefs[i], null);
            }
        };
    }, []);
}
$3207c0aa9f229d8f$var$__name($3207c0aa9f229d8f$var$useStableComposedRefs, "useStableComposedRefs");
function $3207c0aa9f229d8f$var$getAnimationName(styles) {
    return styles?.animationName || "none";
}
$3207c0aa9f229d8f$var$__name($3207c0aa9f229d8f$var$getAnimationName, "getAnimationName");
function $3207c0aa9f229d8f$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}
$3207c0aa9f229d8f$var$__name($3207c0aa9f229d8f$var$getElementRef, "getElementRef");

});

parcelRegister("kFbxc", function(module, exports) {

$parcel$export(module.exports, "Primitive", () => $dc7d5df3de21cdcb$export$250ffa63cdc0d034);
$parcel$export(module.exports, "dispatchDiscreteCustomEvent", () => $dc7d5df3de21cdcb$export$6d1a0317bde7de7f);

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $9UeUh = parcelRequire("9UeUh");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $dc7d5df3de21cdcb$var$__defProp = Object.defineProperty;
var $dc7d5df3de21cdcb$var$__name = (target, value)=>$dc7d5df3de21cdcb$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $dc7d5df3de21cdcb$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "select",
    "span",
    "svg",
    "ul"
];
var $dc7d5df3de21cdcb$export$250ffa63cdc0d034 = $dc7d5df3de21cdcb$var$NODES.reduce((primitive, node)=>{
    const Slot = (0, $9UeUh.createSlot)(`Primitive.${node}`);
    const Node = $acw62.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? Slot : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $ayMG0.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function $dc7d5df3de21cdcb$export$6d1a0317bde7de7f(target, event) {
    if (target) $1u0KT.flushSync(()=>target.dispatchEvent(event));
}
$dc7d5df3de21cdcb$var$__name($dc7d5df3de21cdcb$export$6d1a0317bde7de7f, "dispatchDiscreteCustomEvent");

});



parcelRegister("5MbI8", function(module, exports) {

$parcel$export(module.exports, "default", () => $26386601b5f40a7d$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
'use client';
/**
 * Square icon-only button with a ≥44px touch target (mobile-safe) and a required
 * accessible label. `onGradient` variant is the white-alpha control for gradient
 * headers (§3.2). Encapsulates the affordance so screens never hand-roll a raw <button>.
 *
 * Props:
 *   icon     — lucide node (required)
 *   label    — accessible label / tooltip (required)
 *   variant  — 'default' | 'ghost' | 'outline' | 'onGradient'
 *   size     — px (default 44 — the mobile minimum)
 *   onClick, disabled
 */ const $26386601b5f40a7d$var$VARIANT = {
    default: {
        background: (0, $jTCZr.C).navy,
        color: '#fff',
        border: 'none'
    },
    ghost: {
        background: 'transparent',
        color: (0, $jTCZr.C).textSecondary,
        border: 'none'
    },
    outline: {
        background: (0, $jTCZr.C).card,
        color: (0, $jTCZr.C).textPrimary,
        border: `1px solid ${(0, $jTCZr.C).border}`
    },
    onGradient: {
        background: 'rgba(255,255,255,0.15)',
        color: '#fff',
        border: 'none'
    }
};
function $26386601b5f40a7d$export$2e2bcd8739ae039({ icon: icon, label: label, onClick: onClick, variant: variant = 'default', size: size = 44, disabled: disabled = false, style: style, ...rest }) {
    const v = $26386601b5f40a7d$var$VARIANT[variant] || $26386601b5f40a7d$var$VARIANT.default;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        ...rest,
        onClick: onClick,
        disabled: disabled,
        "aria-label": label,
        title: label,
        style: {
            width: size,
            height: size,
            minWidth: size,
            padding: 0,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 12,
            cursor: disabled ? 'default' : 'pointer',
            opacity: disabled ? 0.5 : 1,
            flexShrink: 0,
            fontFamily: 'inherit',
            ...v,
            ...style
        }
    }, icon);
}

});

parcelRegister("fAR2n", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f997edd3d0e9220$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $5JYPc = parcelRequire("5JYPc");

var $7phmx = parcelRequire("7phmx");

var $j9AxR = parcelRequire("j9AxR");
'use client';
const $2f997edd3d0e9220$var$Select = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ label: label, required: required, error: externalError, helperText: helperText, value: value, onChange: onChange, onBlur: onBlur, options: options = [], placeholder: placeholder, validate: validate, disabled: disabled = false, style: style, // Extra props (data-testid, aria-*, inputMode…) land on the real control:
// §17.2 requires a kit component to forward them, and these did not.
...rest }, ref)=>{
    if (placeholder === undefined) placeholder = (0, $j9AxR.kitCopy)().select.placeholder;
    const generatedId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const controlId = rest.id || generatedId;
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [internalError, setInternalError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const error = externalError || (touched ? internalError : '');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        htmlFor: controlId,
        label: label,
        required: required,
        error: error,
        helperText: helperText,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "relative"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("select", {
        ref: ref,
        id: controlId,
        "aria-describedby": error || helperText ? `${controlId}-message` : undefined,
        "aria-invalid": error ? true : undefined,
        ...rest,
        value: value,
        onChange: onChange,
        onBlur: (e)=>{
            setTouched(true);
            if (validate) setInternalError(validate(value) || '');
            onBlur?.(e);
        },
        disabled: disabled,
        className: (0, $5JYPc.cn)(// Logical padding, and no `dir` of its own: the room for the chevron
        // is on the field's END edge, whichever side that is. It used to be
        // `dir="rtl"` + `pr-3.5 pl-8`, which put a Persian-shaped control
        // inside an English page and the chevron on top of the text.
        'w-full h-11 ps-3.5 pe-8 rounded-lg font-sans text-[0.84375rem]', 'bg-white border-[1.5px] outline-none appearance-none cursor-pointer', 'transition-[border-color,box-shadow] duration-150', value ? 'text-foreground' : 'text-muted-foreground', error ? 'border-destructive shadow-ring-red focus:shadow-ring-red' : 'border-border focus:border-primary focus:shadow-ring-navy', disabled && 'bg-muted cursor-not-allowed opacity-70')
    }, placeholder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
        value: ""
    }, placeholder), options.map((o)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
            key: o.value,
            value: o.value,
            disabled: o.disabled
        }, o.label))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": "true",
        className: "absolute end-2.5 top-1/2 -translate-y-1/2 pointer-events-none text-muted-foreground flex"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "15",
        height: "15"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M7 10l5 5 5-5z"
    })))));
});
$2f997edd3d0e9220$var$Select.displayName = 'Select';
var $2f997edd3d0e9220$export$2e2bcd8739ae039 = $2f997edd3d0e9220$var$Select;

});


parcelRegister("9cQDs", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3d31b804305fdbe$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $5JYPc = parcelRequire("5JYPc");

var $hlTfq = parcelRequire("hlTfq");

var $j9AxR = parcelRequire("j9AxR");

var $9Bif4 = parcelRequire("9Bif4");

var $k27hS = parcelRequire("k27hS");

var $bHjRG = parcelRequire("bHjRG");

var $aJ1FU = parcelRequire("aJ1FU");
'use client';
function $c3d31b804305fdbe$export$2e2bcd8739ae039({ candidates: candidates, onChooseLinked: onChooseLinked, chooseLabel: chooseLabel, onLink: onLink, linkLabel: linkLabel, onNewPatient: onNewPatient, disabled: disabled = false, isMobile: isMobile, locale: locale, messages: messages, className: className, 'data-testid': testid = 'phone-candidates' }) {
    const words = {
        ...(0, $j9AxR.kitCopy)(locale).phoneCandidates,
        ...messages
    };
    const numerals = (0, $hlTfq.numeralsFor)(locale || (0, $hlTfq.documentLocale)());
    const digits = (v)=>String(v).replace(/\d/g, (d)=>numerals.digits[d]);
    const [busyId, setBusyId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [failedId, setFailedId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const auto = (0, $k27hS.default)();
    const touch = isMobile !== undefined ? isMobile : auto.isMobile;
    const size = touch ? 'default' : 'sm';
    const held = disabled || busyId !== null;
    const link = async (c)=>{
        setBusyId(c.patientId);
        setFailedId(null);
        try {
            await onLink(c);
        } catch  {
            setFailedId(c.patientId);
        } finally{
            setBusyId(null);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testid,
        className: (0, $5JYPc.cn)('border border-border rounded-lg overflow-hidden', className)
    }, candidates.map((c, i)=>{
        const gender = c.gender === 'male' ? words.male : c.gender === 'female' ? words.female : null;
        const meta = [
            c.birthYear ? words.birthYear(digits(c.birthYear)) : null,
            gender,
            c.isLinkedToThisClinic && c.fileNumber ? words.fileNumber(digits(c.fileNumber)) : null
        ].filter(Boolean);
        const matched = c.matchedIsPrimary === false && [
            words.matchedOther,
            c.matchedRelation && c.matchedRelation !== (0, $9Bif4.UNKNOWN_RELATION) ? (0, $9Bif4.phoneRelationLabel)(c.matchedRelation, locale) : null
        ].filter(Boolean);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: c.patientId,
            "data-testid": `phone-candidate-${c.patientId}`,
            className: (0, $5JYPc.cn)('flex items-center justify-between gap-2 py-2 px-3', i > 0 && 'border-t border-border')
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "min-w-0"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "flex items-center flex-wrap gap-2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "text-[0.8125rem] font-bold text-foreground"
        }, c.displayName), c.isLinkedToThisClinic && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bHjRG.default), {
            variant: "success"
        }, words.inYourList), c.hasAppAccount && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bHjRG.default), {
            variant: "outline"
        }, words.hasAppAccount)), meta.length > 0 && // Separate spans, never a joined string: a «·» beside Persian digits reads
        // as a zero, and a literal separator would be copy outside the catalogues.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "flex flex-wrap gap-2 mt-0.5 text-[0.71875rem] text-muted-foreground"
        }, meta.map((part)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                key: part
            }, part))), matched && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": `phone-candidate-matched-${c.patientId}`,
            className: "flex flex-wrap gap-2 mt-0.5 text-[0.71875rem] text-muted-foreground"
        }, matched.map((part)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                key: part
            }, part))), failedId === c.patientId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            role: "alert",
            className: "mt-0.5 text-[0.71875rem] font-semibold text-destructive"
        }, words.linkFailed)), c.isLinkedToThisClinic ? onChooseLinked ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            type: "button",
            size: size,
            variant: "outline",
            onClick: ()=>onChooseLinked(c),
            disabled: disabled,
            "data-testid": `phone-candidate-choose-${c.patientId}`
        }, chooseLabel || words.alreadyInList) : // The success chip's ink: the brand teal the clinic copy used is under
        // 3:1 on white, and this is a data value, not a decoration (DC §12.4).
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "text-xs font-bold whitespace-nowrap text-[var(--chip-success-ink)]"
        }, words.alreadyInList) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            type: "button",
            size: size,
            onClick: ()=>link(c),
            disabled: held,
            "data-testid": `phone-candidate-link-${c.patientId}`
        }, busyId === c.patientId ? words.adding : linkLabel || words.addToList));
    }), onNewPatient && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "py-2 px-3 border-t border-border bg-muted"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        type: "button",
        size: size,
        variant: "outline",
        onClick: onNewPatient,
        disabled: held,
        "data-testid": "phone-candidates-new"
    }, words.newOnSameNumber)));
}

});
parcelRegister("bHjRG", function(module, exports) {

$parcel$export(module.exports, "badgeVariants", () => $ddd0c49a5377bd48$export$48443d129636634d);
$parcel$export(module.exports, "default", () => $ddd0c49a5377bd48$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $2DiCt = parcelRequire("2DiCt");

var $5JYPc = parcelRequire("5JYPc");
'use client';
const $ddd0c49a5377bd48$export$48443d129636634d = (0, $2DiCt.cva)('inline-flex items-center rounded-full font-sans font-semibold whitespace-nowrap', {
    variants: {
        variant: {
            default: 'bg-accent text-accent-foreground text-[0.6875rem] px-2.5 py-0.5',
            // The three pale chip pairs are CSS variables (tokens.css), not
            // literals. Same pixels; the point is that a theme can reach them —
            // every raw hex left in a component is a future dark-mode bug (§11).
            destructive: 'bg-[var(--chip-danger-bg)]  text-[var(--chip-danger-ink)]  text-[0.6875rem] px-2.5 py-0.5',
            success: 'bg-[var(--chip-success-bg)] text-[var(--chip-success-ink)] text-[0.6875rem] px-2.5 py-0.5',
            warning: 'bg-[var(--chip-warning-bg)] text-[var(--chip-warning-ink)] text-[0.6875rem] px-2.5 py-0.5',
            outline: 'border border-border text-foreground text-[0.6875rem] px-2.5 py-0.5',
            // `count` — the ONE unread/tally chip. A solid navy pill, not the pale
            // tint `default` gives: every conversation row in every app was
            // overriding `default` with the same inline `background`/`color` to get
            // this, which is the hand-rolled primitive rule in slow motion.
            // `tabular-nums` keeps «۱» and «۹+» the same width so a live count does
            // not jitter the row, and `min-w-5` keeps a single digit round.
            // The swatch is navy, matching `BottomNav`'s `badgeTone: 'count'` —
            // one colour means "unread" everywhere (see DESIGN.md, Messaging).
            // `var(--p-navy)` rather than the `bg-navy` hex so the chip follows the
            // doctor's accent preset exactly as `C.navy` (which BottomNav uses) does.
            count: 'bg-[var(--p-navy)] text-white text-[0.6875rem] font-bold leading-5 min-w-5 justify-center px-1.5 tabular-nums shrink-0'
        }
    },
    defaultVariants: {
        variant: 'default'
    }
});
const $ddd0c49a5377bd48$export$37acb3580601e69a = ({ className: className, variant: variant, children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $5JYPc.cn)($ddd0c49a5377bd48$export$48443d129636634d({
            variant: variant
        }), className),
        ...props
    }, children);
var $ddd0c49a5377bd48$export$2e2bcd8739ae039 = $ddd0c49a5377bd48$export$37acb3580601e69a;

});


parcelRegister("Ydgp5", function(module, exports) {

$parcel$export(module.exports, "default", () => $6dabae5d3309de70$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $5JYPc = parcelRequire("5JYPc");

var $7phmx = parcelRequire("7phmx");

var $j9AxR = parcelRequire("j9AxR");

var $hlTfq = parcelRequire("hlTfq");

var $3tGMU = parcelRequire("3tGMU");

var $5AX1S = parcelRequire("5AX1S");

var $9sT7p = parcelRequire("9sT7p");
'use client';
// The one national-id field. Everywhere in Parsina a human types a «کد ملی», it
// types it here — and no screen keeps its own length check or checksum.
//
// What it does that a plain <input> cannot:
//
//   1. **The rules of the issuing COUNTRY.** `country` (ISO alpha-2, default
//      Iran) picks the rule from `lib/nationalId.js`: Iran's ten digits and
//      checksum today, another country's the day its entry is added, a
//      shape-only check for a country with no entry. Language never picks it.
//   2. **The numerals of the language on screen.** Persian digits under `fa`,
//      Arabic-Indic under `ar`, Latin under `en` — whatever keyboard typed them.
//      Resolved by `numeralsFor`, the seam `MoneyInput` uses; nothing here
//      branches on a locale.
//   3. **Anything typed or pasted becomes the code.** Persian, Arabic and
//      full-width digits fold to ASCII; the dashes and spaces of
//      «001-234567-9» are dropped; the caret stays where the typist left it.
//   4. **One verdict, said once.** Required / incomplete / invalid, in the page
//      language, on blur and live from then on (§6.3) — the same verdict
//      `nationalIdProblem` gives the screen on submit.
//
// Value in and value out are both the BARE ASCII code — «0012345679», never
// «۰۰۱۲۳۴۵۶۷۹». Two ways to listen, and they say the same thing:
//
//   onChange({ target: { value, name } }, info)   — event-shaped, so it drops
//                                                    into an existing handler
//   onValueChange(value, info)                    — the bare string
//
// `info` is `{ value, complete, valid, problem, country }`. `onComplete(value)`
// fires when the code becomes complete and acceptable — the moment to look a
// patient up.
//
// WHICH COUNTRY (PM-0076, owner 2026-10-05): a clinic's patients carry the
// national id of the country the CLINIC is in — `defaultCountry`, the clinic's
// stored country — but a clinic also sees patients from elsewhere. A patient form
// passes `allowOtherCountries`, and the field grows a country chip (the phone
// field's flagged, searchable picker) that starts on the clinic's country. Picking
// another country re-reads the typed value under that country's rule and reports
// it through `onCountryChange(iso2)`. `country` makes the choice CONTROLLED (a
// form that stores the issuing country); without it the field keeps its own.
const $6dabae5d3309de70$var$messageFor = (copy, problem, rule, localise)=>{
    if (problem === 'required') return copy.required;
    if (problem === 'incomplete') return rule.minLength === rule.maxLength ? copy.incomplete(localise(String(rule.maxLength))) : copy.tooShort(localise(String(rule.minLength)));
    if (problem === 'invalid') return copy.invalid;
    return '';
};
const $6dabae5d3309de70$var$NationalIdInput = ({ value: value, onChange: onChange, onValueChange: onValueChange, onBlur: onBlur, onComplete: onComplete, // Whose number it is — ISO 3166-1 alpha-2, or a locale tag with a region.
// Controlled when passed; otherwise the field starts on `defaultCountry` (the
// clinic's country; omitted is Iran — outside the Iranian market, the country
// the phone field would preselect: `defaultNationalIdCountry`) and keeps the
// person's own pick.
country: countryProp, defaultCountry: defaultCountry, allowOtherCountries: // Offer the other countries — on every form that registers or edits a PATIENT.
// Off for a field that can only hold one country's number (the doctor's own
// code for an Iranian insurer).
allowOtherCountries = false, onCountryChange: onCountryChange, // Locale — defaults to <html lang>, which every client sets via applyDocumentLocale.
locale: localeProp, label: // Chrome — the same contract as TextInput.
label, required: required, error: externalError, helperText: helperText, placeholder: placeholder, disabled: disabled = false, showValid: // `false` keeps the field from announcing «معتبر است» — for a dense form where
// the green line would push the row below it.
showValid = true, className: className, style: style, inputStyle: inputStyle, // Extra props (data-testid, aria-*, name, autoFocus…) land on the real control.
...rest })=>{
    const ref = (0, $acw62.useRef)(null);
    const caret = (0, $acw62.useRef)(null);
    const shellRef = (0, $acw62.useRef)(null);
    const [picked, setPicked] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const generatedId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const controlId = rest.id || generatedId;
    // Set by the first blur: from then on the verdict follows every keystroke.
    const [checked, setChecked] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const locale = localeProp || (0, $hlTfq.documentLocale)();
    const copy = (0, $j9AxR.kitCopy)(locale).nationalId;
    const numerals = (0, $acw62.useMemo)(()=>(0, $hlTfq.numeralsFor)(locale), [
        locale
    ]);
    const country = countryProp || picked || defaultCountry || (0, $3tGMU.defaultNationalIdCountry)(locale);
    const rule = (0, $3tGMU.nationalIdRule)(country);
    const countryRow = allowOtherCountries ? (0, $5AX1S.findByIso2)(rule.country || country) : null;
    const localise = (ascii)=>ascii.replace(/\d/g, (d)=>numerals.digits[Number(d)]);
    // A stored value may arrive in any digits, or as a number; it is read the way
    // typing is.
    const code = rule.normalize(value);
    const problem = code ? rule.check(code) : required ? 'required' : null;
    const isComplete = code.length >= rule.minLength;
    const isValid = rule.verifiable && !!code && problem === null;
    const isInvalid = problem === 'invalid';
    const error = externalError || (checked ? $6dabae5d3309de70$var$messageFor(copy, problem, rule, localise) : '');
    const statusShown = !externalError && rule.verifiable && isComplete && (isValid || isInvalid);
    if (label === undefined) label = rule.country === 'IR' ? copy.label : copy.genericLabel;
    if (placeholder === undefined) placeholder = rule.minLength === rule.maxLength && rule.charset === 'digits' ? copy.placeholder(localise(String(rule.maxLength))) : '';
    (0, $acw62.useLayoutEffect)(()=>{
        if (caret.current != null && ref.current) {
            ref.current.setSelectionRange(caret.current, caret.current);
            caret.current = null;
        }
    });
    const report = (next, nextRule, iso)=>{
        const nextProblem = next ? nextRule.check(next) : required ? 'required' : null;
        const info = {
            value: next,
            complete: next.length >= nextRule.minLength,
            valid: !!next && nextProblem === null,
            problem: nextProblem,
            country: iso
        };
        onChange?.({
            target: {
                value: next,
                name: rest.name
            }
        }, info);
        onValueChange?.(next, info);
        if (info.valid) onComplete?.(next);
    };
    const handleCountry = (row)=>{
        const iso = row?.iso2;
        if (!iso || iso === country) return;
        if (!countryProp) setPicked(iso);
        onCountryChange?.(iso);
        // The same characters, read under the new country's rule — a code typed
        // before the country was picked is kept, not cleared.
        const nextRule = (0, $3tGMU.nationalIdRule)(iso);
        report(nextRule.normalize(value), nextRule, iso);
        ref.current?.focus();
    };
    const handleChange = (e)=>{
        const el = e.target;
        // Digits map one to one, so the caret belongs after as many KEPT characters
        // as sat to its left — a pasted dash or space must not push it along.
        const keptLeft = rule.strip(el.value.slice(0, el.selectionStart ?? el.value.length)).length;
        const kept = rule.strip(el.value);
        const next = kept.slice(0, rule.maxLength);
        // A keystroke into a code that is already full is refused, the way a native
        // `maxLength` refuses it — otherwise a digit typed mid-code pushes the last
        // one out and silently rewrites the number. (The DOM attribute itself is not
        // used: it truncates a pasted «001-234567-9» before the dashes are dropped.)
        const overflow = code.length === rule.maxLength && kept.length > rule.maxLength;
        if (overflow || next === code) {
            // Nothing to report, so React will not re-render — put the field back by
            // hand, or the refused character stays on screen and the caret jumps.
            const pos = Math.max(0, Math.min(code.length, keptLeft - (kept.length - code.length)));
            el.value = localise(code);
            el.setSelectionRange(pos, pos);
            return;
        }
        caret.current = Math.min(keptLeft, next.length);
        report(next, rule, country);
    };
    const messageId = `${controlId}-message`;
    const validLine = showValid && isValid && !error;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        htmlFor: controlId,
        label: label,
        required: required,
        error: error,
        helperText: validLine ? '' : helperText,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: shellRef,
        className: "relative [unicode-bidi:isolate]",
        dir: "ltr"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        id: controlId,
        "aria-describedby": error || helperText || validLine ? messageId : undefined,
        "aria-invalid": error ? true : undefined,
        "aria-required": required || undefined,
        autoComplete: "off",
        ...rest,
        ref: ref,
        type: "text",
        inputMode: rule.charset === 'digits' ? 'numeric' : 'text',
        value: localise(code),
        onChange: handleChange,
        onBlur: (e)=>{
            setChecked(true);
            onBlur?.(e);
        },
        placeholder: placeholder,
        disabled: disabled,
        className: (0, $5JYPc.cn)('w-full h-11 rounded-lg font-sans text-[0.875rem] text-foreground tracking-[1.5px] tabular-nums', 'bg-white border-[1.5px] outline-none transition-[border-color,box-shadow] duration-150', // With the country chip the chip owns the start and the ✓/✗ moves to the end.
        countryRow ? 'ps-[84px] pe-10' : 'ps-10 pe-3.5', error ? 'border-destructive shadow-ring-red focus:shadow-ring-red' : statusShown && isValid ? 'border-clinic-green shadow-ring-green' : 'border-border focus:border-primary focus:shadow-ring-navy', disabled && 'bg-muted cursor-not-allowed opacity-70', className),
        style: inputStyle
    }), countryRow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "absolute inset-y-0 start-0 flex items-center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9sT7p.default), {
        value: countryRow,
        onSelect: handleCountry,
        locale: localeProp,
        label: copy.country,
        disabled: disabled,
        anchorRef: shellRef,
        showDial: false,
        "data-testid": rest['data-testid'] ? `${rest['data-testid']}-country` : undefined
    })), statusShown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        role: "img",
        "aria-label": isValid ? copy.valid : copy.notValid,
        className: (0, $5JYPc.cn)('absolute top-1/2 -translate-y-1/2 flex items-center', countryRow ? 'end-3' : 'start-3', isValid ? 'text-clinic-green' : 'text-destructive')
    }, isValid ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "17",
        height: "17",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "17",
        height: "17",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
    })))), validLine && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        id: messageId,
        className: "m-0 text-[0.71875rem] font-semibold text-clinic-green leading-snug"
    }, copy.valid));
};
var $6dabae5d3309de70$export$2e2bcd8739ae039 = $6dabae5d3309de70$var$NationalIdInput;

});
parcelRegister("3tGMU", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_NATIONAL_ID_COUNTRY", () => $2885454b73c45d9d$export$db3d38ac1c19b9cc);
$parcel$export(module.exports, "defaultNationalIdCountry", () => $2885454b73c45d9d$export$d285ab09de6b6713);
$parcel$export(module.exports, "GENERIC_RULE", () => $2885454b73c45d9d$export$1700237b484ebbcc);
$parcel$export(module.exports, "NATIONAL_ID_RULES", () => $2885454b73c45d9d$export$92a974607f6f02fc);
$parcel$export(module.exports, "nationalIdRule", () => $2885454b73c45d9d$export$8d56917ba3265ae0);
$parcel$export(module.exports, "normalizeNationalId", () => $2885454b73c45d9d$export$9997440a468738e3);
$parcel$export(module.exports, "nationalIdProblem", () => $2885454b73c45d9d$export$8b1749206e586151);
$parcel$export(module.exports, "isValidNationalId", () => $2885454b73c45d9d$export$89cadb74f28f5ec2);
$parcel$export(module.exports, "repairNationalId", () => $2885454b73c45d9d$export$f198e2644d3eb5b8);
$parcel$export(module.exports, "formatNationalId", () => $2885454b73c45d9d$export$6a9c909dc504d3aa);
// National id — the one place the rules of a national identity number live.
//
// «کد ملی» is Iran's: ten digits, the last a checksum of the nine before it. That
// rule was written down more than once (the input's own private copy, and a copy
// in whichever screen had to validate on submit), which is how a code one screen
// accepts is refused by the next. It is written here once, and `NationalIdInput`
// and every screen read it from here.
//
// Three things are kept apart on purpose:
//
//   - **The COUNTRY decides the rules.** How long the number is, whether it has a
//     checksum, whether letters may appear — a property of who issued it. Each
//     country is one entry in `NATIONAL_ID_RULES`; adding one is adding an entry,
//     and no component branches on a country code. Iran's entry is today's rule,
//     unchanged. A country with no entry gets `GENERIC_RULE`, which checks shape
//     only and therefore never claims a number is VALID — only that it is not
//     obviously malformed.
//   - **The LANGUAGE decides the digits on screen.** «۰۰۱۲۳۴۵۶۷۹» under `fa`,
//     «٠٠١٢٣٤٥٦٧٩» under `ar`, «0012345679» under `en` — resolved by `numeralsFor`,
//     the seam `MoneyInput` already uses. An English-speaking desk in Tehran still
//     enters Iranian codes: language never picks the rule.
//   - **The VALUE is always ASCII.** Localised digits exist only between a
//     component and the DOM. What a form stores, compares, sends and validates is
//     `normalizeNationalId`'s output.

var $5AX1S = parcelRequire("5AX1S");

var $hlTfq = parcelRequire("hlTfq");

var $eLeza = parcelRequire("eLeza");
const $2885454b73c45d9d$export$db3d38ac1c19b9cc = 'IR';
function $2885454b73c45d9d$export$d285ab09de6b6713(locale) {
    return (0, $eLeza.isIranMarket)() ? $2885454b73c45d9d$export$db3d38ac1c19b9cc : (0, $5AX1S.countryForLocale)(locale).iso2;
}
// ── Iran — «کد ملی» ──────────────────────────────────────────────────────────
// Ten digits. With the digits d0…d9 and S = Σ d[i] × (10 − i) for i = 0…8,
// r = S mod 11; the check digit d9 is r when r < 2, else 11 − r. Ten equal digits
// satisfy the arithmetic («1111111111») and are issued to nobody, so they are
// refused by name.
const $2885454b73c45d9d$var$IR_LENGTH = 10;
function $2885454b73c45d9d$var$iranChecksumHolds(code) {
    let sum = 0;
    for(let i = 0; i < 9; i++)sum += (code.charCodeAt(i) - 48) * (10 - i);
    const rem = sum % 11;
    return code.charCodeAt(9) - 48 === (rem < 2 ? rem : 11 - rem);
}
const $2885454b73c45d9d$var$IR_RULE = Object.freeze({
    country: 'IR',
    // What may be typed — decides the on-screen keyboard and what paste keeps.
    charset: 'digits',
    minLength: $2885454b73c45d9d$var$IR_LENGTH,
    maxLength: $2885454b73c45d9d$var$IR_LENGTH,
    // A rule with a checksum can say a number is VALID; one without can only say
    // it is not malformed, and the field then shows no «معتبر است».
    verifiable: true,
    // `strip` keeps every character the rule allows; `normalize` also cuts at the
    // length. The field needs both — it refuses a keystroke into a full code
    // instead of letting it push the last digit out.
    strip: (raw)=>(0, $5AX1S.foldDigits)(String(raw ?? '')).replace(/\D/g, ''),
    normalize: (raw)=>$2885454b73c45d9d$var$IR_RULE.strip(raw).slice(0, $2885454b73c45d9d$var$IR_LENGTH),
    check (value) {
        if (value.length < $2885454b73c45d9d$var$IR_LENGTH) return 'incomplete';
        if (/^(\d)\1{9}$/.test(value) || !$2885454b73c45d9d$var$iranChecksumHolds(value)) return 'invalid';
        return null;
    },
    // A code kept as a NUMBER somewhere upstream (a spreadsheet import, an integer
    // column) has lost its leading zeros: «0012345679» arrives as «12345679». Codes
    // begin with at most two zeros, so 8 or 9 digits can be restored — and are kept
    // only when the restored code passes the checksum.
    repair (value) {
        if (value.length !== 8 && value.length !== 9) return value;
        const padded = value.padStart($2885454b73c45d9d$var$IR_LENGTH, '0');
        return $2885454b73c45d9d$var$IR_RULE.check(padded) === null ? padded : value;
    }
});
// ── A country with no entry ──────────────────────────────────────────────────
// Latin letters and digits, a plausible length, no checksum. Deliberately loose:
// refusing a real document because its country was never written down here would
// stop a foreign patient being registered at all.
const $2885454b73c45d9d$var$GENERIC_MIN = 5;
const $2885454b73c45d9d$var$GENERIC_MAX = 20;
const $2885454b73c45d9d$export$1700237b484ebbcc = Object.freeze({
    country: null,
    charset: 'alphanumeric',
    minLength: $2885454b73c45d9d$var$GENERIC_MIN,
    maxLength: $2885454b73c45d9d$var$GENERIC_MAX,
    verifiable: false,
    strip: (raw)=>(0, $5AX1S.foldDigits)(String(raw ?? '')).toUpperCase().replace(/[^A-Z0-9]/g, ''),
    normalize: (raw)=>$2885454b73c45d9d$export$1700237b484ebbcc.strip(raw).slice(0, $2885454b73c45d9d$var$GENERIC_MAX),
    check: (value)=>value.length < $2885454b73c45d9d$var$GENERIC_MIN ? 'incomplete' : null,
    repair: (value)=>value
});
const $2885454b73c45d9d$export$92a974607f6f02fc = Object.freeze({
    IR: $2885454b73c45d9d$var$IR_RULE
});
function $2885454b73c45d9d$export$8d56917ba3265ae0(country) {
    const home = (0, $eLeza.isIranMarket)() ? $2885454b73c45d9d$var$IR_RULE : $2885454b73c45d9d$export$1700237b484ebbcc;
    const raw = String(country ?? '').trim();
    if (!raw) return home;
    const parts = raw.split(/[-_]/);
    const region = parts.length > 1 ? parts.slice(1).find((p)=>/^[A-Za-z]{2}$/.test(p)) : /^[A-Z]{2}$/.test(raw) ? raw : null;
    if (!region) return home;
    return $2885454b73c45d9d$export$92a974607f6f02fc[region.toUpperCase()] || $2885454b73c45d9d$export$1700237b484ebbcc;
}
function $2885454b73c45d9d$export$9997440a468738e3(input, country) {
    return $2885454b73c45d9d$export$8d56917ba3265ae0(country).normalize(input);
}
function $2885454b73c45d9d$export$8b1749206e586151(input, { country: country, required: required = false } = {}) {
    const rule = $2885454b73c45d9d$export$8d56917ba3265ae0(country);
    const value = rule.normalize(input);
    if (!value) return required ? 'required' : null;
    return rule.check(value);
}
function $2885454b73c45d9d$export$89cadb74f28f5ec2(input, country) {
    const rule = $2885454b73c45d9d$export$8d56917ba3265ae0(country);
    const value = rule.normalize(input);
    return !!value && rule.check(value) === null;
}
function $2885454b73c45d9d$export$f198e2644d3eb5b8(input, country) {
    const rule = $2885454b73c45d9d$export$8d56917ba3265ae0(country);
    return rule.repair(rule.normalize(input));
}
function $2885454b73c45d9d$export$6a9c909dc504d3aa(input, locale) {
    const ascii = (0, $5AX1S.foldDigits)(String(input ?? '')).trim();
    if (!ascii) return '';
    const { digits: digits } = (0, $hlTfq.numeralsFor)(locale || (0, $hlTfq.documentLocale)());
    return ascii.replace(/\d/g, (d)=>digits[Number(d)]);
}

});


parcelRegister("9iIGe", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fe0519cb1ec239e$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $5JYPc = parcelRequire("5JYPc");

var $7phmx = parcelRequire("7phmx");

var $j9AxR = parcelRequire("j9AxR");

var $hlTfq = parcelRequire("hlTfq");
'use client';
const $4fe0519cb1ec239e$var$NumberInput = ({ label: label, required: required, error: externalError, helperText: helperText, value: value, onChange: onChange, onBlur: onBlur, placeholder: placeholder, unit: unit, min: min, max: max, validate: validate, disabled: disabled = false, style: style, // The language whose decimal mark the field accepts; defaults to <html lang>.
locale: localeProp, // Extra props (data-testid, aria-*, inputMode…) land on the real control:
// §17.2 requires a kit component to forward them, and these did not.
...rest })=>{
    const generatedId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const controlId = rest.id || generatedId;
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [internalError, setInternalError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const defaultValidate = (v)=>{
        if (!v) return '';
        const n = parseFloat(v);
        const copy = (0, $j9AxR.kitCopy)().number;
        if (isNaN(n)) return copy.invalid;
        if (min !== undefined && n < min) return copy.min(min);
        if (max !== undefined && n > max) return copy.max(max);
        return '';
    };
    const error = externalError || (touched ? internalError : '');
    // The stored value is ASCII with «.» as the decimal point. The page language's
    // own decimal mark (French «,», Persian «٫») is folded to «.» before the strip —
    // stripping first turned «72,5» into «725». «.» is accepted in every language.
    //
    // German GROUPS with «.» (PM-0212). Echoing the stored «72.5» back made a single
    // dot the field's decimal point, so a German «1.500» was silently stored as 1.5 —
    // a factor of 1000 the box never showed. Under a language whose group mark is «.»
    // the field therefore shows its value with the language's own decimal mark
    // («72,5»), and every «.» typed into it is a group mark, as in `MoneyInput` and
    // `currency.parseAmount(…, 'de')`: «1.500» is 1500, «1.234,5» is 1234.5. A dot that
    // vanishes as it is typed («1.5» → «15») is visible; a decimal is written «1,5».
    const numerals = (0, $hlTfq.numeralsFor)(localeProp || (0, $hlTfq.documentLocale)());
    const localDecimal = numerals.group === '.' && numerals.decimal !== '.';
    const display = localDecimal && value != null && value !== '' ? String(value).replace('.', numerals.decimal) : value;
    const handleChange = (e)=>{
        const v = (0, $hlTfq.stripAmount)(e.target.value, true, numerals);
        onChange({
            target: {
                value: v
            }
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        htmlFor: controlId,
        label: label,
        required: required,
        error: error,
        helperText: helperText,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "relative"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        id: controlId,
        "aria-describedby": error || helperText ? `${controlId}-message` : undefined,
        "aria-invalid": error ? true : undefined,
        ...rest,
        type: "text",
        inputMode: "decimal",
        value: display,
        onChange: handleChange,
        onBlur: (e)=>{
            setTouched(true);
            setInternalError((validate || defaultValidate)(value));
            onBlur?.(e);
        },
        placeholder: placeholder,
        disabled: disabled,
        dir: "ltr",
        className: (0, $5JYPc.cn)('w-full h-11 rounded-lg font-sans text-[0.875rem] text-foreground', 'bg-white border-[1.5px] outline-none transition-[border-color,box-shadow] duration-150', unit ? 'pr-3.5 pl-11' : 'px-3.5', error ? 'border-destructive shadow-ring-red focus:shadow-ring-red' : 'border-border focus:border-primary focus:shadow-ring-navy', disabled && 'bg-muted cursor-not-allowed opacity-70')
    }), unit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "absolute left-3.5 top-1/2 -translate-y-1/2 text-[0.6875rem] font-semibold text-muted-foreground pointer-events-none select-none"
    }, unit)));
};
var $4fe0519cb1ec239e$export$2e2bcd8739ae039 = $4fe0519cb1ec239e$var$NumberInput;

});

parcelRegister("lkMIV", function(module, exports) {

$parcel$export(module.exports, "default", () => $b90d527c31e5b4da$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $5JYPc = parcelRequire("5JYPc");

var $7phmx = parcelRequire("7phmx");

var $hlTfq = parcelRequire("hlTfq");

var $j9AxR = parcelRequire("j9AxR");

var $lHVFz = parcelRequire("lHVFz");
'use client';
// The one money field. Everywhere in Parsina a human types a price, it types it here.
//
// Three things it does that a plain <input> cannot:
//
//   1. **Thousands separators as you type.** «500000» reads back as «۵۰۰٬۰۰۰».
//      Native <input type="number"> can't render a separator at all (the browser
//      rejects the comma), so this is a text input that DISPLAYS the grouped string
//      and reports the bare numeric one.
//   2. **The numerals of the language on screen.** Persian digits under `fa`, Latin
//      under `en`, each with that locale's own separators — resolved from CLDR, so
//      nothing here branches on a locale id. See `numeralsFor`.
//   3. **The unit, always.** A money field with no unit is how a rial figure ends up
//      read as toman; the label defaults rather than being optional.
//
// Value in and value out are both the BARE ASCII numeric string — «500000», never
// «۵۰۰٬۰۰۰». Localised digits exist only between here and the DOM, so no form, no
// parse and no toman↔rial conversion downstream sees them. onChange is handed that
// string directly, not an event: `onChange={setAmount}`.
//
// It preserves the caret across regrouping: inserting a digit that pushes a new
// separator in would otherwise fling the cursor to the end. We remember how many
// digits sat to the left of the caret and put it back after the same digit once
// React re-renders.
// The default chip. IRR — and no currency at all, which IS IRR — reads the kit's
// localised toman, exactly as before `currency` existed. Any other clinic currency
// reads its short form from the currency table («USD», «KWD»), because a non-IRR
// clinic must never see «تومان» beside its money. Anything that is not a currency
// («پارسه», a percentage) is still the caller's `unitLabel`.
const $b90d527c31e5b4da$var$unitLabelFor = (locale, info)=>info.code === (0, $lHVFz.DEFAULT_CURRENCY) ? (0, $j9AxR.kitCopy)(locale).toman : (0, $lHVFz.unitLabel)(info.code, locale, 'short');
// At most `places` digits after the decimal point. Applied only to a non-IRR
// currency: an IRR field (a toman price, a percentage discount) keeps what it
// always accepted.
function $b90d527c31e5b4da$var$limitFraction(raw, places) {
    const dot = raw.indexOf('.');
    return dot < 0 || raw.length - dot - 1 <= places ? raw : raw.slice(0, dot + 1 + places);
}
const $b90d527c31e5b4da$var$MoneyInput = ({ value: value, onChange: onChange, onBlur: onBlur, currency: // The clinic currency the figure is in. Omitted, blank or 'IRR' is today's toman
// field exactly. Another currency changes the default chip and allows up to its
// fraction digits. It never converts: value in and out stay DISPLAY units (toman,
// dollars), and the call site turns them into minor units with
// `currency.fromDisplay` — see docs/MONEY_INPUT.md §2.4 and §6.3.
currency, // Defaults to false for IRR and true for any other currency.
allowDecimal: allowDecimalProp, unit: // Unit — `unit` is a full node override, `unitLabel` just changes the text.
// `unit={null}` is the deliberate way to render none.
unit, unitLabel: unitLabel, // Locale — defaults to <html lang>, which every client sets via applyDocumentLocale.
locale: localeProp, label: // Chrome — the same contract as TextInput.
label, required: required, error: externalError, helperText: helperText, validate: validate, placeholder: placeholder, disabled: disabled = false, className: className, style: style, inputStyle: inputStyle, // Extra props (data-testid, aria-*, name…) land on the real control.
...rest })=>{
    const ref = (0, $acw62.useRef)(null);
    const caret = (0, $acw62.useRef)(null);
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [internalError, setInternalError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    // A pasted figure refused as ambiguous (see handlePaste); cleared by the next edit.
    const [pasteError, setPasteError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const locale = localeProp || (0, $hlTfq.documentLocale)();
    const numerals = (0, $acw62.useMemo)(()=>(0, $hlTfq.numeralsFor)(locale), [
        locale
    ]);
    // Throws INVALID_CURRENCY for a code outside the table rather than guessing.
    const info = (0, $lHVFz.currencyInfo)(currency);
    const isIrr = info.code === (0, $lHVFz.DEFAULT_CURRENCY);
    const allowDecimal = allowDecimalProp ?? !isIrr;
    const clean = (text)=>{
        const raw = (0, $hlTfq.stripAmount)(text, allowDecimal, numerals);
        return isIrr || !allowDecimal ? raw : $b90d527c31e5b4da$var$limitFraction(raw, info.maxDisplayDecimals);
    };
    const error = externalError || pasteError || (touched ? internalError : '');
    const display = (0, $hlTfq.groupAmount)(value ?? '', numerals);
    // `unit === null` means "no unit, I mean it"; `undefined` means "you choose".
    const unitNode = unit !== undefined ? unit : unitLabel ?? $b90d527c31e5b4da$var$unitLabelFor(locale, info);
    const hasUnit = unitNode != null && unitNode !== '';
    // The chip is painted beside the digits, which a screen reader never connects to
    // the field — «۵۰۰٬۰۰۰» alone does not say toman. Describing the input by it is
    // what makes the unit part of the field for a non-sighted reader too. A caller's
    // own `aria-describedby` is kept, not replaced.
    const unitId = `${(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId()}-unit`;
    const describedBy = [
        rest['aria-describedby'],
        hasUnit ? unitId : null
    ].filter(Boolean).join(' ') || undefined;
    (0, $acw62.useLayoutEffect)(()=>{
        if (caret.current != null && ref.current) {
            ref.current.setSelectionRange(caret.current, caret.current);
            caret.current = null;
        }
    });
    const handleChange = (e)=>{
        const el = e.target;
        // How many MEANINGFUL characters sat left of the caret — digits, plus the
        // decimal mark when one is allowed. Counting digits alone parks the caret
        // before a just-typed decimal mark, so «1.5» lands as «1.» + «5» = «15.».
        const keptLeft = (0, $hlTfq.stripAmount)(el.value.slice(0, el.selectionStart ?? el.value.length), allowDecimal, numerals).length;
        const raw = clean(el.value);
        const grouped = (0, $hlTfq.groupAmount)(raw, numerals);
        // Walk the regrouped string until that many are behind us; the separators it
        // inserted are skipped over. `\p{Nd}` rather than an ASCII range: «۵» is a
        // digit too, and an ASCII test flings the caret to the end in Persian.
        const isKept = (ch)=>/\p{Nd}/u.test(ch) || allowDecimal && ch === numerals.decimal;
        let pos = 0, seen = 0;
        while(pos < grouped.length && seen < keptLeft){
            if (isKept(grouped[pos])) seen++;
            pos++;
        }
        caret.current = pos;
        if (pasteError) setPasteError('');
        onChange(raw);
    };
    // Under a language that GROUPS with «.» (German) every dot is a group mark, which
    // is what the field prints as it regroups. A pasted «12.50» or «1.5» — an English
    // decimal — would silently store 1250 or 15, a hundred or ten times the amount, so
    // a paste whose dots are not groups of three is refused with the kit's «not a valid
    // number», as `currency.parseAmount(…, 'de')` refuses it. «1.234» and «1.234,5»
    // paste as before. No other language groups with «.», so none is affected.
    const handlePaste = (e)=>{
        rest.onPaste?.(e);
        if (e.defaultPrevented || numerals.group !== '.') return;
        const text = e.clipboardData?.getData('text') ?? '';
        if ((0, $hlTfq.dotsAreGroups)(text, numerals)) return;
        e.preventDefault();
        setPasteError((0, $j9AxR.kitCopy)(locale).number.invalid);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        label: label,
        required: required,
        error: error,
        helperText: helperText,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "relative"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ...rest,
        ref: ref,
        type: "text",
        inputMode: allowDecimal ? 'decimal' : 'numeric',
        // A number is an LTR run even inside an RTL form — the same rule that
        // keeps phone numbers and codes readable.
        dir: "ltr",
        value: display,
        onChange: handleChange,
        onPaste: handlePaste,
        "aria-describedby": describedBy,
        onBlur: (e)=>{
            setTouched(true);
            if (validate) setInternalError(validate(value) || '');
            onBlur?.(e);
        },
        placeholder: placeholder,
        disabled: disabled,
        className: (0, $5JYPc.cn)('w-full h-11 rounded-lg font-sans text-[0.84375rem] text-foreground', 'bg-white border-[1.5px] outline-none transition-[border-color,box-shadow] duration-150', hasUnit ? 'pr-3.5 pl-11' : 'px-3.5', error ? 'border-destructive shadow-ring-red focus:shadow-ring-red' : 'border-border focus:border-primary focus:shadow-ring-navy', disabled && 'bg-muted cursor-not-allowed opacity-70', className),
        style: inputStyle
    }), hasUnit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        id: unitId,
        className: "absolute left-3.5 top-1/2 -translate-y-1/2 text-[0.6875rem] font-semibold text-muted-foreground pointer-events-none select-none"
    }, unitNode)));
};
var $b90d527c31e5b4da$export$2e2bcd8739ae039 = $b90d527c31e5b4da$var$MoneyInput;

});

parcelRegister("iygI2", function(module, exports) {

$parcel$export(module.exports, "default", () => $26a45cd6e1b19edd$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $5JYPc = parcelRequire("5JYPc");

var $7phmx = parcelRequire("7phmx");
'use client';
const $26a45cd6e1b19edd$var$Textarea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ label: label, required: required, error: externalError, helperText: helperText, value: value, onChange: onChange, onBlur: onBlur, placeholder: placeholder, rows: rows = 3, maxLength: maxLength, showCount: showCount = false, validate: validate, disabled: disabled = false, style: style, inputStyle: // `style` dresses the FIELD (label + control + helper); `inputStyle` reaches
// the control itself — the same split `TextInput` already has. It exists for
// the mobile rule that a field's type must be ≥1rem or iOS zooms the page on
// focus (DESIGN-CONCEPT-MOBILE §6), which the 13.5px default is under.
inputStyle, dir: // Unset: inherits the document's direction (§16.3). It defaulted to 'rtl',
// which pinned every note field in the product to RTL whatever the language.
dir, // Extra props (data-testid, aria-*, inputMode…) land on the real control:
// §17.2 requires a kit component to forward them, and these did not.
...rest }, ref)=>{
    const generatedId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const controlId = rest.id || generatedId;
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [internalError, setInternalError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const error = externalError || (touched ? internalError : '');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        htmlFor: controlId,
        label: label,
        required: required,
        error: error,
        helperText: helperText,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "relative"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("textarea", {
        ref: ref,
        id: controlId,
        "aria-describedby": error || helperText ? `${controlId}-message` : undefined,
        "aria-invalid": error ? true : undefined,
        ...rest,
        value: value,
        onChange: onChange,
        onBlur: (e)=>{
            setTouched(true);
            if (validate) setInternalError(validate(value) || '');
            onBlur?.(e);
        },
        placeholder: placeholder,
        disabled: disabled,
        rows: rows,
        maxLength: maxLength,
        dir: dir,
        className: (0, $5JYPc.cn)('w-full px-3.5 py-3 rounded-lg font-sans text-[0.84375rem] text-foreground', 'bg-white border-[1.5px] outline-none resize-none leading-7', 'transition-[border-color,box-shadow] duration-150', showCount && maxLength && 'pb-6', error ? 'border-destructive shadow-ring-red focus:shadow-ring-red' : 'border-border focus:border-primary focus:shadow-ring-navy', disabled && 'bg-muted cursor-not-allowed opacity-70'),
        style: inputStyle
    }), showCount && maxLength && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "absolute bottom-2 end-3 text-[0.65625rem] text-muted-foreground pointer-events-none select-none"
    }, (value || '').length, "/", maxLength)));
});
$26a45cd6e1b19edd$var$Textarea.displayName = 'Textarea';
var $26a45cd6e1b19edd$export$2e2bcd8739ae039 = $26a45cd6e1b19edd$var$Textarea;

});

parcelRegister("5Rv3V", function(module, exports) {

$parcel$export(module.exports, "default", () => $43f8655df02249d5$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $YeY8y = parcelRequire("YeY8y");

var $5JYPc = parcelRequire("5JYPc");

var $7phmx = parcelRequire("7phmx");
'use client';
const $43f8655df02249d5$var$ToggleGroup = ({ label: label, required: required, error: externalError, helperText: helperText, value: value, onChange: onChange, options: options = [], validate: validate, disabled: disabled = false, style: style })=>{
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [internalError, setInternalError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const error = externalError || (touched ? internalError : '');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        label: label,
        required: required,
        error: error,
        helperText: helperText,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($YeY8y.Root, {
        type: "single",
        value: value,
        onValueChange: (v)=>{
            if (!v) return;
            onChange(v);
            setTouched(true);
            if (validate) setInternalError(validate(v) || '');
        },
        disabled: disabled,
        className: (0, $5JYPc.cn)('flex gap-1.5 p-1 rounded-xl bg-[#f4f6f9]', error && 'ring-[1.5px] ring-destructive')
    }, options.map((opt)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($YeY8y.Item, {
            key: opt.value,
            value: opt.value,
            className: (0, $5JYPc.cn)('flex-1 h-[38px] rounded-[9px] font-sans text-[0.8125rem]', 'flex items-center justify-center gap-1.5', 'transition-all duration-150 outline-none', 'focus-visible:ring-2 focus-visible:ring-ring', 'data-[state=on]:bg-white data-[state=on]:text-navy data-[state=on]:font-bold data-[state=on]:shadow-sm', 'data-[state=off]:bg-transparent data-[state=off]:text-muted-foreground data-[state=off]:font-medium', disabled && 'cursor-not-allowed opacity-50')
        }, opt.icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "text-[0.9375rem]"
        }, opt.icon), opt.label))));
};
var $43f8655df02249d5$export$2e2bcd8739ae039 = $43f8655df02249d5$var$ToggleGroup;

});
parcelRegister("YeY8y", function(module, exports) {

$parcel$export(module.exports, "Root", () => $57c1675cf83b8426$export$be92b6f5f03c0fe9);
$parcel$export(module.exports, "Item", () => $57c1675cf83b8426$export$6d08773d2e66f8f2);

var $acw62 = parcelRequire("acw62");

var $jnK0n = parcelRequire("jnK0n");

var $kFbxc = parcelRequire("kFbxc");

var $abA6z = parcelRequire("abA6z");

var $bTgTs = parcelRequire("bTgTs");

var $88UcQ = parcelRequire("88UcQ");

var $5ZQml = parcelRequire("5ZQml");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $57c1675cf83b8426$var$__defProp = Object.defineProperty;
var $57c1675cf83b8426$var$__name = (target, value)=>$57c1675cf83b8426$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $57c1675cf83b8426$var$TOGGLE_GROUP_NAME = "ToggleGroup";
var $57c1675cf83b8426$var$ToggleGroupType = {
    Single: "single",
    Multiple: "multiple"
};
var [$57c1675cf83b8426$var$createToggleGroupContext, $57c1675cf83b8426$export$d1c7c4bcd9f26dd4] = (0, $jnK0n.createContextScope)($57c1675cf83b8426$var$TOGGLE_GROUP_NAME, [
    (0, $abA6z.createRovingFocusGroupScope)
]);
var $57c1675cf83b8426$var$useRovingFocusGroupScope = (0, $abA6z.createRovingFocusGroupScope)();
var $57c1675cf83b8426$export$be92b6f5f03c0fe9 = /* @__PURE__ */ $acw62.forwardRef(/* @__PURE__ */ $57c1675cf83b8426$var$__name(function ToggleGroup2(props, forwardedRef) {
    const { type: type, ...toggleGroupProps } = props;
    if (type === $57c1675cf83b8426$var$ToggleGroupType.Single) {
        const singleProps = toggleGroupProps;
        return /* @__PURE__ */ (0, $ayMG0.jsx)($57c1675cf83b8426$var$ToggleGroupImplSingle, {
            role: "radiogroup",
            ...singleProps,
            ref: forwardedRef
        });
    }
    if (type === $57c1675cf83b8426$var$ToggleGroupType.Multiple) {
        const multipleProps = toggleGroupProps;
        return /* @__PURE__ */ (0, $ayMG0.jsx)($57c1675cf83b8426$var$ToggleGroupImplMultiple, {
            role: "toolbar",
            ...multipleProps,
            ref: forwardedRef
        });
    }
    throw new Error(`Missing prop \`type\` expected on \`${$57c1675cf83b8426$var$TOGGLE_GROUP_NAME}\``);
}, "ToggleGroup"));
var [$57c1675cf83b8426$var$ToggleGroupValueProvider, $57c1675cf83b8426$var$useToggleGroupValueContext] = $57c1675cf83b8426$var$createToggleGroupContext($57c1675cf83b8426$var$TOGGLE_GROUP_NAME);
var $57c1675cf83b8426$var$ToggleGroupImplSingle = /* @__PURE__ */ $acw62.forwardRef(/* @__PURE__ */ $57c1675cf83b8426$var$__name(function ToggleGroupImplSingle2(props, forwardedRef) {
    const { value: valueProp, defaultValue: defaultValue, onValueChange: onValueChange = /* @__PURE__ */ $57c1675cf83b8426$var$__name(()=>{}, "onValueChange"), ...toggleGroupSingleProps } = props;
    const [value, setValue] = (0, $88UcQ.useControllableState)({
        prop: valueProp,
        defaultProp: defaultValue ?? "",
        onChange: onValueChange,
        caller: $57c1675cf83b8426$var$TOGGLE_GROUP_NAME
    });
    return /* @__PURE__ */ (0, $ayMG0.jsx)($57c1675cf83b8426$var$ToggleGroupValueProvider, {
        scope: props.__scopeToggleGroup,
        type: $57c1675cf83b8426$var$ToggleGroupType.Single,
        value: $acw62.useMemo(()=>value ? [
                value
            ] : [], [
            value
        ]),
        onItemActivate: setValue,
        onItemDeactivate: $acw62.useCallback(()=>setValue(""), [
            setValue
        ]),
        children: /* @__PURE__ */ (0, $ayMG0.jsx)($57c1675cf83b8426$var$ToggleGroupImpl, {
            ...toggleGroupSingleProps,
            ref: forwardedRef
        })
    });
}, "ToggleGroupImplSingle"));
var $57c1675cf83b8426$var$ToggleGroupImplMultiple = /* @__PURE__ */ $acw62.forwardRef(/* @__PURE__ */ $57c1675cf83b8426$var$__name(function ToggleGroupImplMultiple2(props, forwardedRef) {
    const { value: valueProp, defaultValue: defaultValue, onValueChange: onValueChange = /* @__PURE__ */ $57c1675cf83b8426$var$__name(()=>{}, "onValueChange"), ...toggleGroupMultipleProps } = props;
    const [value, setValue] = (0, $88UcQ.useControllableState)({
        prop: valueProp,
        defaultProp: defaultValue ?? [],
        onChange: onValueChange,
        caller: $57c1675cf83b8426$var$TOGGLE_GROUP_NAME
    });
    const handleButtonActivate = $acw62.useCallback((itemValue)=>setValue((prevValue = [])=>[
                ...prevValue,
                itemValue
            ]), [
        setValue
    ]);
    const handleButtonDeactivate = $acw62.useCallback((itemValue)=>setValue((prevValue = [])=>prevValue.filter((value2)=>value2 !== itemValue)), [
        setValue
    ]);
    return /* @__PURE__ */ (0, $ayMG0.jsx)($57c1675cf83b8426$var$ToggleGroupValueProvider, {
        scope: props.__scopeToggleGroup,
        type: $57c1675cf83b8426$var$ToggleGroupType.Multiple,
        value: value,
        onItemActivate: handleButtonActivate,
        onItemDeactivate: handleButtonDeactivate,
        children: /* @__PURE__ */ (0, $ayMG0.jsx)($57c1675cf83b8426$var$ToggleGroupImpl, {
            ...toggleGroupMultipleProps,
            ref: forwardedRef
        })
    });
}, "ToggleGroupImplMultiple"));
var [$57c1675cf83b8426$var$ToggleGroupContext, $57c1675cf83b8426$var$useToggleGroupContext] = $57c1675cf83b8426$var$createToggleGroupContext($57c1675cf83b8426$var$TOGGLE_GROUP_NAME);
var $57c1675cf83b8426$var$ToggleGroupImpl = /* @__PURE__ */ $acw62.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $57c1675cf83b8426$var$__name(function ToggleGroupImpl2(props, forwardedRef) {
    const { __scopeToggleGroup: __scopeToggleGroup, disabled: disabled = false, rovingFocus: rovingFocus = true, orientation: orientation, dir: dir, loop: loop = true, ...toggleGroupProps } = props;
    const rovingFocusGroupScope = $57c1675cf83b8426$var$useRovingFocusGroupScope(__scopeToggleGroup);
    const direction = (0, $5ZQml.useDirection)(dir);
    const commonProps = {
        dir: direction,
        ...toggleGroupProps
    };
    return /* @__PURE__ */ (0, $ayMG0.jsx)($57c1675cf83b8426$var$ToggleGroupContext, {
        scope: __scopeToggleGroup,
        rovingFocus: rovingFocus,
        disabled: disabled,
        children: rovingFocus ? /* @__PURE__ */ (0, $ayMG0.jsx)($abA6z.Root, {
            asChild: true,
            ...rovingFocusGroupScope,
            orientation: orientation,
            dir: direction,
            loop: loop,
            children: /* @__PURE__ */ (0, $ayMG0.jsx)((0, $kFbxc.Primitive).div, {
                ...commonProps,
                ref: forwardedRef
            })
        }) : /* @__PURE__ */ (0, $ayMG0.jsx)((0, $kFbxc.Primitive).div, {
            ...commonProps,
            ref: forwardedRef
        })
    });
}, "ToggleGroupImpl"));
var $57c1675cf83b8426$var$ITEM_NAME = "ToggleGroupItem";
var $57c1675cf83b8426$export$6d08773d2e66f8f2 = /* @__PURE__ */ $acw62.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $57c1675cf83b8426$var$__name(function ToggleGroupItem2(props, forwardedRef) {
    const valueContext = $57c1675cf83b8426$var$useToggleGroupValueContext($57c1675cf83b8426$var$ITEM_NAME, props.__scopeToggleGroup);
    const context = $57c1675cf83b8426$var$useToggleGroupContext($57c1675cf83b8426$var$ITEM_NAME, props.__scopeToggleGroup);
    const rovingFocusGroupScope = $57c1675cf83b8426$var$useRovingFocusGroupScope(props.__scopeToggleGroup);
    const pressed = valueContext.value.includes(props.value);
    const disabled = context.disabled || props.disabled;
    const commonProps = {
        ...props,
        pressed: pressed,
        disabled: disabled
    };
    const ref = $acw62.useRef(null);
    return context.rovingFocus ? /* @__PURE__ */ (0, $ayMG0.jsx)($abA6z.Item, {
        asChild: true,
        ...rovingFocusGroupScope,
        focusable: !disabled,
        active: pressed,
        ref: ref,
        children: /* @__PURE__ */ (0, $ayMG0.jsx)($57c1675cf83b8426$var$ToggleGroupItemImpl, {
            ...commonProps,
            ref: forwardedRef
        })
    }) : /* @__PURE__ */ (0, $ayMG0.jsx)($57c1675cf83b8426$var$ToggleGroupItemImpl, {
        ...commonProps,
        ref: forwardedRef
    });
}, "ToggleGroupItem"));
var $57c1675cf83b8426$var$ToggleGroupItemImpl = /* @__PURE__ */ $acw62.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $57c1675cf83b8426$var$__name(function ToggleGroupItemImpl2(props, forwardedRef) {
    const { __scopeToggleGroup: __scopeToggleGroup, value: value, ...itemProps } = props;
    const valueContext = $57c1675cf83b8426$var$useToggleGroupValueContext($57c1675cf83b8426$var$ITEM_NAME, __scopeToggleGroup);
    const singleProps = {
        role: "radio",
        "aria-checked": props.pressed,
        "aria-pressed": void 0
    };
    const typeProps = valueContext.type === $57c1675cf83b8426$var$ToggleGroupType.Single ? singleProps : void 0;
    return /* @__PURE__ */ (0, $ayMG0.jsx)((0, $bTgTs.Toggle), {
        ...typeProps,
        ...itemProps,
        ref: forwardedRef,
        onPressedChange: (pressed)=>{
            if (pressed) valueContext.onItemActivate(value);
            else valueContext.onItemDeactivate(value);
        }
    });
}, "ToggleGroupItemImpl"));

});
parcelRegister("abA6z", function(module, exports) {

$parcel$export(module.exports, "createRovingFocusGroupScope", () => $0483c88073bf4923$export$c7109489551a4f4);
$parcel$export(module.exports, "Root", () => $0483c88073bf4923$export$be92b6f5f03c0fe9);
$parcel$export(module.exports, "Item", () => $0483c88073bf4923$export$6d08773d2e66f8f2);

var $acw62 = parcelRequire("acw62");

var $2IwC4 = parcelRequire("2IwC4");

var $9nBzD = parcelRequire("9nBzD");

var $htT6J = parcelRequire("htT6J");

var $jnK0n = parcelRequire("jnK0n");

var $g2NP0 = parcelRequire("g2NP0");

var $kFbxc = parcelRequire("kFbxc");

var $by19I = parcelRequire("by19I");

var $88UcQ = parcelRequire("88UcQ");

var $5ZQml = parcelRequire("5ZQml");

var $7g00o = parcelRequire("7g00o");

var $bFsLk = parcelRequire("bFsLk");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $0483c88073bf4923$var$__defProp = Object.defineProperty;
var $0483c88073bf4923$var$__name = (target, value)=>$0483c88073bf4923$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $0483c88073bf4923$var$ENTRY_FOCUS = "rovingFocusGroup.onEntryFocus";
var $0483c88073bf4923$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
var $0483c88073bf4923$var$GROUP_NAME = "RovingFocusGroup";
var [$0483c88073bf4923$var$Collection, $0483c88073bf4923$var$useCollection, $0483c88073bf4923$var$createCollectionScope] = (0, $9nBzD.createCollection)($0483c88073bf4923$var$GROUP_NAME);
var [$0483c88073bf4923$var$createRovingFocusGroupContext, $0483c88073bf4923$export$c7109489551a4f4] = (0, $jnK0n.createContextScope)($0483c88073bf4923$var$GROUP_NAME, [
    $0483c88073bf4923$var$createCollectionScope
]);
var $0483c88073bf4923$var$Orientation = {
    Vertical: "vertical",
    Horizontal: "horizontal"
};
var $0483c88073bf4923$var$Direction = {
    LTR: "ltr",
    RTL: "rtl"
};
var [$0483c88073bf4923$var$RovingFocusProvider, $0483c88073bf4923$var$useRovingFocusContext] = $0483c88073bf4923$var$createRovingFocusGroupContext($0483c88073bf4923$var$GROUP_NAME);
var $0483c88073bf4923$export$be92b6f5f03c0fe9 = /* @__PURE__ */ $acw62.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $0483c88073bf4923$var$__name(function RovingFocusGroup2(props, forwardedRef) {
    return /* @__PURE__ */ (0, $ayMG0.jsx)($0483c88073bf4923$var$Collection.Provider, {
        scope: props.__scopeRovingFocusGroup,
        children: /* @__PURE__ */ (0, $ayMG0.jsx)($0483c88073bf4923$var$Collection.Slot, {
            scope: props.__scopeRovingFocusGroup,
            children: /* @__PURE__ */ (0, $ayMG0.jsx)($0483c88073bf4923$var$RovingFocusGroupImpl, {
                ...props,
                ref: forwardedRef
            })
        })
    });
}, "RovingFocusGroup"));
var $0483c88073bf4923$var$RovingFocusGroupImpl = /* @__PURE__ */ $acw62.forwardRef(/* @__PURE__ */ $0483c88073bf4923$var$__name(function RovingFocusGroupImpl2(props, forwardedRef) {
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup, orientation: orientation, loop: loop = false, dir: dir, currentTabStopId: currentTabStopIdProp, defaultCurrentTabStopId: defaultCurrentTabStopId, onCurrentTabStopIdChange: onCurrentTabStopIdChange, onEntryFocus: onEntryFocus, preventScrollOnEntryFocus: preventScrollOnEntryFocus = false, ...groupProps } = props;
    const ref = $acw62.useRef(null);
    const composedRefs = (0, $htT6J.useComposedRefs)(forwardedRef, ref);
    const direction = (0, $5ZQml.useDirection)(dir);
    const [currentTabStopId, setCurrentTabStopId] = (0, $88UcQ.useControllableState)({
        prop: currentTabStopIdProp,
        defaultProp: defaultCurrentTabStopId ?? null,
        onChange: onCurrentTabStopIdChange,
        caller: $0483c88073bf4923$var$GROUP_NAME
    });
    const [isTabbingBackOut, setIsTabbingBackOut] = $acw62.useState(false);
    const handleEntryFocus = (0, $by19I.useCallbackRef)(onEntryFocus);
    const getItems = $0483c88073bf4923$var$useCollection(__scopeRovingFocusGroup);
    const isClickFocusRef = $acw62.useRef(false);
    const [focusableItemsCount, setFocusableItemsCount] = $acw62.useState(0);
    $acw62.useEffect(()=>{
        const node = ref.current;
        if (node) {
            node.addEventListener($0483c88073bf4923$var$ENTRY_FOCUS, handleEntryFocus);
            return ()=>node.removeEventListener($0483c88073bf4923$var$ENTRY_FOCUS, handleEntryFocus);
        }
    }, [
        handleEntryFocus
    ]);
    return /* @__PURE__ */ (0, $ayMG0.jsx)($0483c88073bf4923$var$RovingFocusProvider, {
        scope: __scopeRovingFocusGroup,
        orientation: orientation,
        dir: direction,
        loop: loop,
        currentTabStopId: currentTabStopId,
        onItemFocus: $acw62.useCallback((tabStopId)=>setCurrentTabStopId(tabStopId), [
            setCurrentTabStopId
        ]),
        onItemShiftTab: $acw62.useCallback(()=>setIsTabbingBackOut(true), []),
        onFocusableItemAdd: $acw62.useCallback(()=>setFocusableItemsCount((prevCount)=>prevCount + 1), []),
        onFocusableItemRemove: $acw62.useCallback(()=>setFocusableItemsCount((prevCount)=>prevCount - 1), []),
        children: /* @__PURE__ */ (0, $ayMG0.jsx)((0, $kFbxc.Primitive).div, {
            tabIndex: isTabbingBackOut || focusableItemsCount === 0 ? -1 : 0,
            "data-orientation": orientation,
            ...groupProps,
            ref: composedRefs,
            style: {
                outline: "none",
                ...props.style
            },
            onMouseDown: (0, $2IwC4.composeEventHandlers)(props.onMouseDown, ()=>{
                isClickFocusRef.current = true;
            }),
            onFocus: (0, $2IwC4.composeEventHandlers)(props.onFocus, (event)=>{
                const isKeyboardFocus = !isClickFocusRef.current;
                if (event.target === event.currentTarget && isKeyboardFocus && !isTabbingBackOut) {
                    const entryFocusEvent = new CustomEvent($0483c88073bf4923$var$ENTRY_FOCUS, $0483c88073bf4923$var$EVENT_OPTIONS);
                    event.currentTarget.dispatchEvent(entryFocusEvent);
                    if (!entryFocusEvent.defaultPrevented) {
                        const items = getItems().filter((item)=>item.focusable);
                        const activeItem = items.find((item)=>item.active);
                        const currentItem = items.find((item)=>item.id === currentTabStopId);
                        const candidateItems = [
                            activeItem,
                            currentItem,
                            ...items
                        ].filter(Boolean);
                        const candidateNodes = candidateItems.map((item)=>item.ref.current);
                        $0483c88073bf4923$var$focusFirst(candidateNodes, preventScrollOnEntryFocus);
                    }
                }
                isClickFocusRef.current = false;
            }),
            onBlur: (0, $2IwC4.composeEventHandlers)(props.onBlur, ()=>setIsTabbingBackOut(false))
        })
    });
}, "RovingFocusGroupImpl"));
var $0483c88073bf4923$var$ITEM_NAME = "RovingFocusGroupItem";
var $0483c88073bf4923$export$6d08773d2e66f8f2 = /* @__PURE__ */ $acw62.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $0483c88073bf4923$var$__name(function RovingFocusGroupItem2(props, forwardedRef) {
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup, focusable: focusable = true, active: active = false, tabStopId: tabStopId, children: children, ...itemProps } = props;
    const autoId = (0, $g2NP0.useId)();
    const id = tabStopId || autoId;
    const context = $0483c88073bf4923$var$useRovingFocusContext($0483c88073bf4923$var$ITEM_NAME, __scopeRovingFocusGroup);
    const isCurrentTabStop = context.currentTabStopId === id;
    const getItems = $0483c88073bf4923$var$useCollection(__scopeRovingFocusGroup);
    const { onFocusableItemAdd: onFocusableItemAdd, onFocusableItemRemove: onFocusableItemRemove, currentTabStopId: currentTabStopId } = context;
    const isHydrated = (0, $bFsLk.useIsHydrated)();
    (0, $7g00o.useLayoutEffect)(()=>{
        if (!isHydrated || !focusable) return;
        onFocusableItemAdd();
        return ()=>onFocusableItemRemove();
    }, [
        isHydrated,
        focusable,
        onFocusableItemAdd,
        onFocusableItemRemove
    ]);
    $acw62.useEffect(()=>{
        if (isHydrated || !focusable) return;
        onFocusableItemAdd();
        return ()=>onFocusableItemRemove();
    }, [
        isHydrated,
        focusable,
        onFocusableItemAdd,
        onFocusableItemRemove
    ]);
    return /* @__PURE__ */ (0, $ayMG0.jsx)($0483c88073bf4923$var$Collection.ItemSlot, {
        scope: __scopeRovingFocusGroup,
        id: id,
        focusable: focusable,
        active: active,
        children: /* @__PURE__ */ (0, $ayMG0.jsx)((0, $kFbxc.Primitive).span, {
            tabIndex: isCurrentTabStop ? 0 : -1,
            "data-orientation": context.orientation,
            ...itemProps,
            ref: forwardedRef,
            onMouseDown: (0, $2IwC4.composeEventHandlers)(props.onMouseDown, (event)=>{
                if (!focusable) event.preventDefault();
                else context.onItemFocus(id);
            }),
            onFocus: (0, $2IwC4.composeEventHandlers)(props.onFocus, ()=>context.onItemFocus(id)),
            onKeyDown: (0, $2IwC4.composeEventHandlers)(props.onKeyDown, (event)=>{
                if (event.key === "Tab" && event.shiftKey) {
                    context.onItemShiftTab();
                    return;
                }
                if (event.target !== event.currentTarget) return;
                const focusIntent = $0483c88073bf4923$var$getFocusIntent(event, context.orientation, context.dir);
                if (focusIntent !== void 0) {
                    if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
                    event.preventDefault();
                    const items = getItems().filter((item)=>item.focusable);
                    let candidateNodes = items.map((item)=>item.ref.current);
                    if (focusIntent === "last") candidateNodes.reverse();
                    else if (focusIntent === "prev" || focusIntent === "next") {
                        if (focusIntent === "prev") candidateNodes.reverse();
                        const currentIndex = candidateNodes.indexOf(event.currentTarget);
                        candidateNodes = context.loop ? $0483c88073bf4923$var$wrapArray(candidateNodes, currentIndex + 1) : candidateNodes.slice(currentIndex + 1);
                    }
                    setTimeout(()=>$0483c88073bf4923$var$focusFirst(candidateNodes));
                }
            }),
            children: typeof children === "function" ? children({
                isCurrentTabStop: isCurrentTabStop,
                hasTabStop: currentTabStopId != null
            }) : children
        })
    });
}, "RovingFocusGroupItem"));
var $0483c88073bf4923$var$MAP_KEY_TO_FOCUS_INTENT = {
    ArrowLeft: "prev",
    ArrowUp: "prev",
    ArrowRight: "next",
    ArrowDown: "next",
    PageUp: "first",
    Home: "first",
    PageDown: "last",
    End: "last"
};
function $0483c88073bf4923$var$getDirectionAwareKey(key, dir) {
    if (dir !== $0483c88073bf4923$var$Direction.RTL) return key;
    return key === "ArrowLeft" ? "ArrowRight" : key === "ArrowRight" ? "ArrowLeft" : key;
}
$0483c88073bf4923$var$__name($0483c88073bf4923$var$getDirectionAwareKey, "getDirectionAwareKey");
function $0483c88073bf4923$var$getFocusIntent(event, orientation, dir) {
    const key = $0483c88073bf4923$var$getDirectionAwareKey(event.key, dir);
    if (orientation === $0483c88073bf4923$var$Orientation.Vertical && [
        "ArrowLeft",
        "ArrowRight"
    ].includes(key)) return void 0;
    if (orientation === $0483c88073bf4923$var$Orientation.Horizontal && [
        "ArrowUp",
        "ArrowDown"
    ].includes(key)) return void 0;
    return $0483c88073bf4923$var$MAP_KEY_TO_FOCUS_INTENT[key];
}
$0483c88073bf4923$var$__name($0483c88073bf4923$var$getFocusIntent, "getFocusIntent");
function $0483c88073bf4923$var$focusFirst(candidates, preventScroll = false) {
    const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    for (const candidate of candidates){
        if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
        candidate.focus({
            preventScroll: preventScroll
        });
        if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
}
$0483c88073bf4923$var$__name($0483c88073bf4923$var$focusFirst, "focusFirst");
function $0483c88073bf4923$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
$0483c88073bf4923$var$__name($0483c88073bf4923$var$wrapArray, "wrapArray");

});
parcelRegister("9nBzD", function(module, exports) {

$parcel$export(module.exports, "createCollection", () => $a9634733d4b9bce9$export$c74125a8e3af6bb2);

var $acw62 = parcelRequire("acw62");

var $jnK0n = parcelRequire("jnK0n");

var $htT6J = parcelRequire("htT6J");

var $9UeUh = parcelRequire("9UeUh");

var $ayMG0 = parcelRequire("ayMG0");

var $7g00o = parcelRequire("7g00o");
"use client";
var $a9634733d4b9bce9$var$__defProp = Object.defineProperty;
var $a9634733d4b9bce9$var$__name = (target, value)=>$a9634733d4b9bce9$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
// @__NO_SIDE_EFFECTS__
function $a9634733d4b9bce9$export$c74125a8e3af6bb2(name) {
    const PROVIDER_NAME = name + "CollectionProvider";
    const [createCollectionContext, createCollectionScope] = (0, $jnK0n.createContextScope)(PROVIDER_NAME);
    const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionRef: {
            current: null
        },
        itemMap: /* @__PURE__ */ new Map()
    });
    const CollectionProvider = /* @__PURE__ */ $a9634733d4b9bce9$var$__name((props)=>{
        const { scope: scope, children: children } = props;
        const ref = $acw62.useRef(null);
        const itemMap = $acw62.useRef(/* @__PURE__ */ new Map()).current;
        return /* @__PURE__ */ (0, $ayMG0.jsx)(CollectionProviderImpl, {
            scope: scope,
            itemMap: itemMap,
            collectionRef: ref,
            children: children
        });
    }, "CollectionProvider");
    CollectionProvider.displayName = PROVIDER_NAME;
    const COLLECTION_SLOT_NAME = name + "CollectionSlot";
    const CollectionSlotImpl = (0, $9UeUh.createSlot)(COLLECTION_SLOT_NAME);
    const CollectionSlot = $acw62.forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, $htT6J.useComposedRefs)(forwardedRef, context.collectionRef);
        return /* @__PURE__ */ (0, $ayMG0.jsx)(CollectionSlotImpl, {
            ref: composedRefs,
            children: children
        });
    });
    CollectionSlot.displayName = COLLECTION_SLOT_NAME;
    const ITEM_SLOT_NAME = name + "CollectionItemSlot";
    const ITEM_DATA_ATTR = "data-radix-collection-item";
    const CollectionItemSlotImpl = (0, $9UeUh.createSlot)(ITEM_SLOT_NAME);
    const CollectionItemSlot = $acw62.forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children, ...itemData } = props;
        const ref = $acw62.useRef(null);
        const composedRefs = (0, $htT6J.useComposedRefs)(forwardedRef, ref);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        $acw62.useEffect(()=>{
            context.itemMap.set(ref, {
                ref: ref,
                ...itemData
            });
            return ()=>void context.itemMap.delete(ref);
        });
        return /* @__PURE__ */ (0, $ayMG0.jsx)(CollectionItemSlotImpl, {
            [ITEM_DATA_ATTR]: "",
            ref: composedRefs,
            children: children
        });
    });
    CollectionItemSlot.displayName = ITEM_SLOT_NAME;
    function useCollection(scope) {
        const context = useCollectionContext(name + "CollectionConsumer", scope);
        const getItems = $acw62.useCallback(()=>{
            const collectionNode = context.collectionRef.current;
            if (!collectionNode) return [];
            const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
            const items = Array.from(context.itemMap.values());
            const orderedItems = items.sort((a, b)=>orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current));
            return orderedItems;
        }, [
            context.collectionRef,
            context.itemMap
        ]);
        return getItems;
    }
    $a9634733d4b9bce9$var$__name(useCollection, "useCollection");
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        useCollection,
        createCollectionScope
    ];
}
$a9634733d4b9bce9$var$__name($a9634733d4b9bce9$export$c74125a8e3af6bb2, "createCollection");
// src/ordered-dictionary.ts
var $a9634733d4b9bce9$var$__instanciated = /* @__PURE__ */ new WeakMap();
var $a9634733d4b9bce9$var$OrderedDict = class _OrderedDict extends Map {
    static{
        $a9634733d4b9bce9$var$__name(this, "OrderedDict");
    }
    #keys;
    constructor(entries){
        super(entries);
        this.#keys = [
            ...super.keys()
        ];
        $a9634733d4b9bce9$var$__instanciated.set(this, true);
    }
    set(key, value) {
        if ($a9634733d4b9bce9$var$__instanciated.get(this) && !this.has(key)) this.#keys.push(key);
        super.set(key, value);
        return this;
    }
    /**
   * Sets a key-value pair so that it ends up at the given index.
   * - Existing keys are moved
   * - Negative indices count from the end of the resulting dictionary, so
   *   inserting at -1 makes the item the last one, -2 the second to last, etc.
   * - Out-of-range indices are clamped
   */ insert(index, key, value) {
        const has = this.has(key);
        const finalSize = has ? this.size : this.size + 1;
        const relativeIndex = $a9634733d4b9bce9$var$toSafeInteger(index);
        const targetIndex = relativeIndex >= 0 ? Math.min(relativeIndex, finalSize - 1) : Math.max(finalSize + relativeIndex, 0);
        if (has ? this.#keys.indexOf(key) === targetIndex : targetIndex === this.size) {
            this.set(key, value);
            return this;
        }
        const keys = this.#keys.filter((existingKey)=>existingKey !== key);
        keys.splice(targetIndex, 0, key);
        const entries = keys.map((entryKey)=>[
                entryKey,
                entryKey === key ? value : this.get(entryKey)
            ]);
        this.clear();
        for (const [entryKey, entryValue] of entries)this.set(entryKey, entryValue);
        return this;
    }
    with(index, key, value) {
        const copy = new _OrderedDict(this);
        copy.insert(index, key, value);
        return copy;
    }
    before(key) {
        const index = this.#keys.indexOf(key) - 1;
        if (index < 0) return void 0;
        return this.entryAt(index);
    }
    /**
   * Sets a new key-value pair at the position before the given key.
   */ setBefore(key, newKey, value) {
        const index = this.#keys.indexOf(key);
        if (index === -1) return this;
        const currentIndex = this.#keys.indexOf(newKey);
        const targetIndex = currentIndex !== -1 && currentIndex < index ? index - 1 : index;
        return this.insert(targetIndex, newKey, value);
    }
    after(key) {
        let index = this.#keys.indexOf(key);
        index = index === -1 || index === this.size - 1 ? -1 : index + 1;
        if (index === -1) return void 0;
        return this.entryAt(index);
    }
    /**
   * Sets a new key-value pair at the position after the given key.
   */ setAfter(key, newKey, value) {
        const index = this.#keys.indexOf(key);
        if (index === -1) return this;
        const currentIndex = this.#keys.indexOf(newKey);
        const targetIndex = currentIndex !== -1 && currentIndex <= index ? index : index + 1;
        return this.insert(targetIndex, newKey, value);
    }
    first() {
        return this.entryAt(0);
    }
    last() {
        return this.entryAt(-1);
    }
    clear() {
        this.#keys = [];
        return super.clear();
    }
    delete(key) {
        const deleted = super.delete(key);
        if (deleted) this.#keys.splice(this.#keys.indexOf(key), 1);
        return deleted;
    }
    deleteAt(index) {
        const key = this.keyAt(index);
        if (key !== void 0) return this.delete(key);
        return false;
    }
    at(index) {
        const key = $a9634733d4b9bce9$var$at(this.#keys, index);
        if (key !== void 0) return this.get(key);
    }
    entryAt(index) {
        const key = $a9634733d4b9bce9$var$at(this.#keys, index);
        if (key !== void 0) return [
            key,
            this.get(key)
        ];
    }
    indexOf(key) {
        return this.#keys.indexOf(key);
    }
    keyAt(index) {
        return $a9634733d4b9bce9$var$at(this.#keys, index);
    }
    from(key, offset) {
        const index = this.indexOf(key);
        if (index === -1) return void 0;
        let dest = index + offset;
        if (dest < 0) dest = 0;
        if (dest >= this.size) dest = this.size - 1;
        return this.at(dest);
    }
    keyFrom(key, offset) {
        const index = this.indexOf(key);
        if (index === -1) return void 0;
        let dest = index + offset;
        if (dest < 0) dest = 0;
        if (dest >= this.size) dest = this.size - 1;
        return this.keyAt(dest);
    }
    find(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return entry;
            index++;
        }
        return void 0;
    }
    findIndex(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return index;
            index++;
        }
        return -1;
    }
    filter(predicate, thisArg) {
        const entries = [];
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) entries.push(entry);
            index++;
        }
        return new _OrderedDict(entries);
    }
    map(callbackfn, thisArg) {
        const entries = [];
        let index = 0;
        for (const entry of this){
            entries.push([
                entry[0],
                Reflect.apply(callbackfn, thisArg, [
                    entry,
                    index,
                    this
                ])
            ]);
            index++;
        }
        return new _OrderedDict(entries);
    }
    reduce(...args) {
        const [callbackfn, initialValue] = args;
        const hasInitialValue = args.length > 1;
        if (!hasInitialValue && this.size === 0) throw new TypeError("Reduce of empty OrderedDict with no initial value");
        let index = 0;
        let accumulator = initialValue;
        for (const entry of this){
            if (index === 0 && !hasInitialValue) accumulator = entry;
            else accumulator = Reflect.apply(callbackfn, this, [
                accumulator,
                entry,
                index,
                this
            ]);
            index++;
        }
        return accumulator;
    }
    reduceRight(...args) {
        const [callbackfn, initialValue] = args;
        const hasInitialValue = args.length > 1;
        if (!hasInitialValue && this.size === 0) throw new TypeError("Reduce of empty OrderedDict with no initial value");
        let accumulator = initialValue;
        for(let index = this.size - 1; index >= 0; index--){
            const entry = this.entryAt(index);
            if (index === this.size - 1 && !hasInitialValue) accumulator = entry;
            else accumulator = Reflect.apply(callbackfn, this, [
                accumulator,
                entry,
                index,
                this
            ]);
        }
        return accumulator;
    }
    /**
   * Sorts the dictionary in place. This method mutates the dictionary and
   * returns a reference to the same object
   *
   * @param compareFn Function used to determine the order of the elements. It
   * is expected to return a negative value if the first argument is less than
   * the second argument, zero if they're equal, and a positive value otherwise.
   */ sort(compareFn) {
        if (typeof compareFn !== "function") throw new TypeError(`OrderedDict.sort requires a compare function`);
        const entries = [
            ...this.entries()
        ].sort(compareFn);
        this.clear();
        for (const [key, value] of entries)this.set(key, value);
        return this;
    }
    /**
   * Returns a copy of the dictionary with its elements sorted.
   *
   * @param compareFn Function used to determine the order of the elements. It
   * is expected to return a negative value if the first argument is less than
   * the second argument, zero if they're equal, and a positive value otherwise.
   */ toSorted(compareFn) {
        if (typeof compareFn !== "function") throw new TypeError(`OrderedDict.toSorted requires a compare function`);
        const entries = [
            ...this.entries()
        ].sort(compareFn);
        return new _OrderedDict(entries);
    }
    toReversed() {
        const reversed = new _OrderedDict();
        for(let index = this.size - 1; index >= 0; index--){
            const key = this.keyAt(index);
            const element = this.get(key);
            reversed.set(key, element);
        }
        return reversed;
    }
    toSpliced(...args) {
        const entries = [
            ...this.entries()
        ];
        entries.splice(...args);
        return new _OrderedDict(entries);
    }
    slice(start, end) {
        const result = new _OrderedDict();
        for (const key of this.#keys.slice(start, end))result.set(key, this.get(key));
        return result;
    }
    every(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (!Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return false;
            index++;
        }
        return true;
    }
    some(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return true;
            index++;
        }
        return false;
    }
};
function $a9634733d4b9bce9$var$at(array, index) {
    if ("at" in Array.prototype) return Array.prototype.at.call(array, index);
    const actualIndex = $a9634733d4b9bce9$var$toSafeIndex(array, index);
    return actualIndex === -1 ? void 0 : array[actualIndex];
}
$a9634733d4b9bce9$var$__name($a9634733d4b9bce9$var$at, "at");
function $a9634733d4b9bce9$var$toSafeIndex(array, index) {
    const length = array.length;
    const relativeIndex = $a9634733d4b9bce9$var$toSafeInteger(index);
    const actualIndex = relativeIndex >= 0 ? relativeIndex : length + relativeIndex;
    return actualIndex < 0 || actualIndex >= length ? -1 : actualIndex;
}
$a9634733d4b9bce9$var$__name($a9634733d4b9bce9$var$toSafeIndex, "toSafeIndex");
function $a9634733d4b9bce9$var$toSafeInteger(number) {
    return number !== number || number === 0 ? 0 : Math.trunc(number);
}
$a9634733d4b9bce9$var$__name($a9634733d4b9bce9$var$toSafeInteger, "toSafeInteger");
// @__NO_SIDE_EFFECTS__
function $a9634733d4b9bce9$export$ec5c5a85b7371a0f(name) {
    const PROVIDER_NAME = name + "CollectionProvider";
    const [createCollectionContext, createCollectionScope] = (0, $jnK0n.createContextScope)(PROVIDER_NAME);
    const [CollectionStableContextProvider, useStableCollectionContext] = createCollectionContext(PROVIDER_NAME);
    CollectionStableContextProvider.displayName = name + "CollectionStableContextProvider";
    const [CollectionStatefulContextProvider, useStatefulCollectionContext] = createCollectionContext(PROVIDER_NAME);
    CollectionStatefulContextProvider.displayName = name + "CollectionStatefulContextProvider";
    const CollectionProvider = /* @__PURE__ */ $a9634733d4b9bce9$var$__name(({ state: state, ...props })=>{
        return state ? /* @__PURE__ */ (0, $ayMG0.jsx)(CollectionProviderImpl, {
            ...props,
            state: state
        }) : /* @__PURE__ */ (0, $ayMG0.jsx)(CollectionInit, {
            ...props
        });
    }, "CollectionProvider");
    CollectionProvider.displayName = PROVIDER_NAME;
    const CollectionInit = /* @__PURE__ */ $a9634733d4b9bce9$var$__name((props)=>{
        const state = useInitCollection();
        return /* @__PURE__ */ (0, $ayMG0.jsx)(CollectionProviderImpl, {
            ...props,
            state: state
        });
    }, "CollectionInit");
    CollectionInit.displayName = name + "CollectionInit";
    const CollectionProviderImpl = /* @__PURE__ */ $a9634733d4b9bce9$var$__name((props)=>{
        const { scope: scope, children: children, state: state } = props;
        const ref = $acw62.useRef(null);
        const [collectionElement, setCollectionElement] = $acw62.useState(null);
        const composeRefs = (0, $htT6J.useComposedRefs)(ref, setCollectionElement);
        const [collection, setCollection] = state;
        const registryRef = $acw62.useRef(new $a9634733d4b9bce9$var$OrderedDict());
        const getCollection = $acw62.useCallback(()=>{
            const registry = registryRef.current;
            if (!$a9634733d4b9bce9$var$isInDocumentOrder(registry)) registry.sort($a9634733d4b9bce9$var$sortByDocumentPosition);
            return registry;
        }, []);
        $acw62.useEffect(()=>{
            if (!collectionElement) return;
            const observer = $a9634733d4b9bce9$var$getChildListObserver(()=>{
                setCollection((map)=>{
                    const sorted = map.toSorted($a9634733d4b9bce9$var$sortByDocumentPosition);
                    const orderChanged = sorted.some(([key], index)=>map.keyAt(index) !== key);
                    return orderChanged ? sorted : map;
                });
            });
            observer.observe(collectionElement, {
                childList: true,
                subtree: true
            });
            return ()=>{
                observer.disconnect();
            };
        }, [
            collectionElement,
            setCollection
        ]);
        return /* @__PURE__ */ (0, $ayMG0.jsx)(CollectionStableContextProvider, {
            scope: scope,
            collectionElementRef: composeRefs,
            collectionElementRefObject: ref,
            getCollection: getCollection,
            setCollection: setCollection,
            registryRef: registryRef,
            children: /* @__PURE__ */ (0, $ayMG0.jsx)(CollectionStatefulContextProvider, {
                scope: scope,
                collectionElement: collectionElement,
                collection: collection,
                children: children
            })
        });
    }, "CollectionProviderImpl");
    CollectionProviderImpl.displayName = name + "CollectionProviderImpl";
    const COLLECTION_SLOT_NAME = name + "CollectionSlot";
    const CollectionSlotImpl = (0, $9UeUh.createSlot)(COLLECTION_SLOT_NAME);
    const CollectionSlot = $acw62.forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children } = props;
        const context = useStableCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, $htT6J.useComposedRefs)(forwardedRef, context.collectionElementRef);
        return /* @__PURE__ */ (0, $ayMG0.jsx)(CollectionSlotImpl, {
            ref: composedRefs,
            children: children
        });
    });
    CollectionSlot.displayName = COLLECTION_SLOT_NAME;
    const ITEM_SLOT_NAME = name + "CollectionItemSlot";
    const ITEM_DATA_ATTR = "data-radix-collection-item";
    const CollectionItemSlotImpl = (0, $9UeUh.createSlot)(ITEM_SLOT_NAME);
    const CollectionItemSlot = $acw62.forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children, ...itemData } = props;
        const ref = $acw62.useRef(null);
        const context = useStableCollectionContext(ITEM_SLOT_NAME, scope);
        const { setCollection: setCollection, registryRef: registryRef } = context;
        const itemDataRef = $acw62.useRef(itemData);
        if (!$a9634733d4b9bce9$var$shallowEqual(itemDataRef.current, itemData)) itemDataRef.current = itemData;
        const memoizedItemData = itemDataRef.current;
        const registerElement = $acw62.useCallback((node)=>{
            const registry = registryRef.current;
            if (node) registry.set(node, {
                ...itemDataRef.current,
                element: node
            });
            else if (ref.current) registry.delete(ref.current);
        }, [
            registryRef
        ]);
        const composedRefs = (0, $htT6J.useComposedRefs)(forwardedRef, registerElement, ref);
        (0, $7g00o.useLayoutEffect)(()=>{
            const node = ref.current;
            const registry = registryRef.current;
            if (node && registry.has(node)) registry.set(node, {
                ...memoizedItemData,
                element: node
            });
        }, [
            memoizedItemData,
            registryRef
        ]);
        const registeredRef = $acw62.useRef(null);
        $acw62.useEffect(()=>{
            const element = ref.current;
            const registered = registeredRef.current;
            if ((registered?.element ?? null) === element && (!element || registered?.itemData === memoizedItemData)) return;
            registeredRef.current = element ? {
                element: element,
                itemData: memoizedItemData
            } : null;
            setCollection((map)=>{
                const next = new $a9634733d4b9bce9$var$OrderedDict(map);
                if (registered && registered.element !== element) next.delete(registered.element);
                if (element) next.set(element, {
                    ...memoizedItemData,
                    element: element
                });
                return next.sort($a9634733d4b9bce9$var$sortByDocumentPosition);
            });
        });
        $acw62.useEffect(()=>{
            return ()=>{
                const registered = registeredRef.current;
                registeredRef.current = null;
                if (!registered) return;
                setCollection((map)=>{
                    if (!map.has(registered.element)) return map;
                    const next = new $a9634733d4b9bce9$var$OrderedDict(map);
                    next.delete(registered.element);
                    return next;
                });
            };
        }, [
            setCollection
        ]);
        return /* @__PURE__ */ (0, $ayMG0.jsx)(CollectionItemSlotImpl, {
            [ITEM_DATA_ATTR]: "",
            ref: composedRefs,
            children: children
        });
    });
    CollectionItemSlot.displayName = ITEM_SLOT_NAME;
    function useInitCollection() {
        return $acw62.useState(new $a9634733d4b9bce9$var$OrderedDict());
    }
    $a9634733d4b9bce9$var$__name(useInitCollection, "useInitCollection");
    function useCollection(scope) {
        const { collection: collection } = useStatefulCollectionContext(name + "CollectionConsumer", scope);
        return collection;
    }
    $a9634733d4b9bce9$var$__name(useCollection, "useCollection");
    function useGetCollection(scope) {
        const { getCollection: getCollection } = useStableCollectionContext(name + "CollectionConsumer", scope);
        return getCollection;
    }
    $a9634733d4b9bce9$var$__name(useGetCollection, "useGetCollection");
    const functions = {
        createCollectionScope: createCollectionScope,
        useCollection: useCollection,
        useGetCollection: useGetCollection,
        useInitCollection: useInitCollection
    };
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        functions
    ];
}
$a9634733d4b9bce9$var$__name($a9634733d4b9bce9$export$ec5c5a85b7371a0f, "createCollection");
function $a9634733d4b9bce9$var$shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || typeof b !== "object") return false;
    if (a == null || b == null) return false;
    const keysA = Object.keys(a);
    const keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    for (const key of keysA){
        if (!Object.prototype.hasOwnProperty.call(b, key)) return false;
        if (a[key] !== b[key]) return false;
    }
    return true;
}
$a9634733d4b9bce9$var$__name($a9634733d4b9bce9$var$shallowEqual, "shallowEqual");
function $a9634733d4b9bce9$var$isElementPreceding(a, b) {
    return !!(b.compareDocumentPosition(a) & Node.DOCUMENT_POSITION_PRECEDING);
}
$a9634733d4b9bce9$var$__name($a9634733d4b9bce9$var$isElementPreceding, "isElementPreceding");
function $a9634733d4b9bce9$var$isInDocumentOrder(dict) {
    let previous;
    for (const element of dict.keys()){
        if (previous) {
            const position = previous.compareDocumentPosition(element);
            if (!(position & Node.DOCUMENT_POSITION_DISCONNECTED) && position & Node.DOCUMENT_POSITION_PRECEDING) return false;
        }
        previous = element;
    }
    return true;
}
$a9634733d4b9bce9$var$__name($a9634733d4b9bce9$var$isInDocumentOrder, "isInDocumentOrder");
function $a9634733d4b9bce9$var$sortByDocumentPosition(a, b) {
    return !a[1].element || !b[1].element ? 0 : $a9634733d4b9bce9$var$isElementPreceding(a[1].element, b[1].element) ? -1 : 1;
}
$a9634733d4b9bce9$var$__name($a9634733d4b9bce9$var$sortByDocumentPosition, "sortByDocumentPosition");
function $a9634733d4b9bce9$var$getChildListObserver(callback) {
    const observer = new MutationObserver((mutationsList)=>{
        for (const mutation of mutationsList)if (mutation.type === "childList") {
            callback();
            return;
        }
    });
    return observer;
}
$a9634733d4b9bce9$var$__name($a9634733d4b9bce9$var$getChildListObserver, "getChildListObserver");

});

parcelRegister("g2NP0", function(module, exports) {

$parcel$export(module.exports, "useId", () => $11885ec535b13ccc$export$f680877a34711e37);

var $acw62 = parcelRequire("acw62");

var $7g00o = parcelRequire("7g00o");
var $11885ec535b13ccc$var$__defProp = Object.defineProperty;
var $11885ec535b13ccc$var$__name = (target, value)=>$11885ec535b13ccc$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $11885ec535b13ccc$var$useReactId = $acw62[" useId ".trim().toString()] || (()=>void 0);
var $11885ec535b13ccc$var$count = 0;
function $11885ec535b13ccc$export$f680877a34711e37(deterministicId) {
    const [id, setId] = $acw62.useState($11885ec535b13ccc$var$useReactId());
    (0, $7g00o.useLayoutEffect)(()=>{
        if (!deterministicId) setId((reactId)=>reactId ?? String($11885ec535b13ccc$var$count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : "");
}
$11885ec535b13ccc$var$__name($11885ec535b13ccc$export$f680877a34711e37, "useId");

});

parcelRegister("by19I", function(module, exports) {

$parcel$export(module.exports, "useCallbackRef", () => $95d2d9f03fd0d4db$export$25bec8c6f54ee79a);

var $7g00o = parcelRequire("7g00o");

var $acw62 = parcelRequire("acw62");
var $95d2d9f03fd0d4db$var$__defProp = Object.defineProperty;
var $95d2d9f03fd0d4db$var$__name = (target, value)=>$95d2d9f03fd0d4db$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $95d2d9f03fd0d4db$var$useReactInsertionEffect = $acw62[" useInsertionEffect ".trim().toString()];
function $95d2d9f03fd0d4db$export$25bec8c6f54ee79a(callback) {
    const callbackRef = $acw62.useRef(callback);
    if (typeof $95d2d9f03fd0d4db$var$useReactInsertionEffect === "function") $95d2d9f03fd0d4db$var$useReactInsertionEffect(()=>{
        callbackRef.current = callback;
    });
    else (0, $7g00o.useLayoutEffect)(()=>{
        callbackRef.current = callback;
    });
    return $acw62.useMemo(()=>(...args)=>callbackRef.current?.(...args), []);
}
$95d2d9f03fd0d4db$var$__name($95d2d9f03fd0d4db$export$25bec8c6f54ee79a, "useCallbackRef");

});

parcelRegister("5ZQml", function(module, exports) {

$parcel$export(module.exports, "useDirection", () => $f9ad7d2f57cc5bec$export$b39126d51d94e6f3);

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $f9ad7d2f57cc5bec$var$__defProp = Object.defineProperty;
var $f9ad7d2f57cc5bec$var$__name = (target, value)=>$f9ad7d2f57cc5bec$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $f9ad7d2f57cc5bec$var$Direction = {
    LTR: "ltr",
    RTL: "rtl"
};
var $f9ad7d2f57cc5bec$var$DirectionContext = $acw62.createContext(void 0);
var $f9ad7d2f57cc5bec$export$c760c09fdd558351 = /* @__PURE__ */ $f9ad7d2f57cc5bec$var$__name((props)=>{
    const { dir: dir, children: children } = props;
    return /* @__PURE__ */ (0, $ayMG0.jsx)($f9ad7d2f57cc5bec$var$DirectionContext.Provider, {
        value: dir,
        children: children
    });
}, "DirectionProvider");
function $f9ad7d2f57cc5bec$export$b39126d51d94e6f3(localDir) {
    const globalDir = $acw62.useContext($f9ad7d2f57cc5bec$var$DirectionContext);
    return localDir || globalDir || $f9ad7d2f57cc5bec$var$Direction.LTR;
}
$f9ad7d2f57cc5bec$var$__name($f9ad7d2f57cc5bec$export$b39126d51d94e6f3, "useDirection");

});

parcelRegister("bFsLk", function(module, exports) {

$parcel$export(module.exports, "useIsHydrated", () => $05e93d8d36380231$export$fd0534379e135f3d);

var $acw62 = parcelRequire("acw62");
var $05e93d8d36380231$var$__defProp = Object.defineProperty;
var $05e93d8d36380231$var$__name = (target, value)=>$05e93d8d36380231$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $05e93d8d36380231$var$_isHydrated = false;
function $05e93d8d36380231$var$useIsHydrated() {
    const [isHydrated, setIsHydrated] = $acw62.useState($05e93d8d36380231$var$_isHydrated);
    $acw62.useEffect(()=>{
        if (!$05e93d8d36380231$var$_isHydrated) {
            $05e93d8d36380231$var$_isHydrated = true;
            setIsHydrated(true);
        }
    }, []);
    return isHydrated;
}
$05e93d8d36380231$var$__name($05e93d8d36380231$var$useIsHydrated, "useIsHydrated");
// src/use-is-hydrated.tsx
var $05e93d8d36380231$var$useReactSyncExternalStore = $acw62[" useSyncExternalStore ".trim().toString()];
function $05e93d8d36380231$var$subscribe() {
    return ()=>{};
}
$05e93d8d36380231$var$__name($05e93d8d36380231$var$subscribe, "subscribe");
function $05e93d8d36380231$var$useIsHydratedModern() {
    return $05e93d8d36380231$var$useReactSyncExternalStore($05e93d8d36380231$var$subscribe, ()=>true, ()=>false);
}
$05e93d8d36380231$var$__name($05e93d8d36380231$var$useIsHydratedModern, "useIsHydratedModern");
var $05e93d8d36380231$export$fd0534379e135f3d = typeof $05e93d8d36380231$var$useReactSyncExternalStore === "function" ? $05e93d8d36380231$var$useIsHydratedModern : $05e93d8d36380231$var$useIsHydrated;

});


parcelRegister("bTgTs", function(module, exports) {

$parcel$export(module.exports, "Toggle", () => $62b265af90252982$export$be92b6f5f03c0fe9);

var $acw62 = parcelRequire("acw62");

var $2IwC4 = parcelRequire("2IwC4");

var $88UcQ = parcelRequire("88UcQ");

var $kFbxc = parcelRequire("kFbxc");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $62b265af90252982$var$__defProp = Object.defineProperty;
var $62b265af90252982$var$__name = (target, value)=>$62b265af90252982$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $62b265af90252982$var$NAME = "Toggle";
var $62b265af90252982$export$be92b6f5f03c0fe9 = /* @__PURE__ */ $acw62.forwardRef(/* @__PURE__ */ $62b265af90252982$var$__name(function Toggle2(props, forwardedRef) {
    const { pressed: pressedProp, defaultPressed: defaultPressed, onPressedChange: onPressedChange, ...buttonProps } = props;
    const [pressed, setPressed] = (0, $88UcQ.useControllableState)({
        prop: pressedProp,
        onChange: onPressedChange,
        defaultProp: defaultPressed ?? false,
        caller: $62b265af90252982$var$NAME
    });
    return /* @__PURE__ */ (0, $ayMG0.jsx)((0, $kFbxc.Primitive).button, {
        type: "button",
        "aria-pressed": pressed,
        "data-state": pressed ? "on" : "off",
        "data-disabled": props.disabled ? "" : void 0,
        ...buttonProps,
        ref: forwardedRef,
        onClick: (0, $2IwC4.composeEventHandlers)(props.onClick, ()=>{
            if (!props.disabled) setPressed(!pressed);
        })
    });
}, "Toggle"));

});



parcelRegister("bkKUS", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcaca06c97c91379$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $5JYPc = parcelRequire("5JYPc");

var $7phmx = parcelRequire("7phmx");
'use client';
const $fcaca06c97c91379$var$ChipSelector = ({ label: label, required: required, error: externalError, helperText: helperText, value: value, onChange: onChange, options: options = [], multi: multi = false, activeColor: activeColor = 'var(--p-navy)', activeBg: activeBg = 'hsl(var(--accent))', validate: validate, disabled: disabled = false, style: style, touch: // `touch` sizes the chips for a finger (2.75rem); `testId` names the row and,
// with each option's `testKey` (else its value), every chip in it; `children`
// follow the chips in the same row — a «more» toggle belongs there.
touch = false, testId: testId, children: children })=>{
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [internalError, setInternalError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const error = externalError || (touched ? internalError : '');
    const isActive = (v)=>multi ? (value || []).includes(v) : value === v;
    const handleToggle = (optValue)=>{
        if (disabled) return;
        let next;
        if (multi) {
            const arr = value || [];
            next = arr.includes(optValue) ? arr.filter((v)=>v !== optValue) : [
                ...arr,
                optValue
            ];
        } else next = value === optValue ? '' : optValue;
        onChange(next);
        setTouched(true);
        if (validate) setInternalError(validate(next) || '');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        label: label,
        required: required,
        error: error,
        helperText: helperText,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "flex flex-wrap gap-1.5",
        "data-testid": testId
    }, options.map((opt)=>{
        const active = isActive(opt.value);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: opt.value,
            type: "button",
            onClick: ()=>handleToggle(opt.value),
            disabled: disabled,
            "aria-pressed": active,
            title: opt.title,
            "data-testid": testId ? `${testId}-${opt.testKey ?? opt.value}` : undefined,
            className: (0, $5JYPc.cn)(touch ? 'min-h-11' : 'h-[34px]', 'px-3.5 rounded-full font-sans text-xs whitespace-nowrap', 'border-[1.5px] transition-all duration-150 outline-none', 'focus-visible:ring-2 focus-visible:ring-ring', error && !active && 'border-destructive', !error && !active && 'border-border text-[#5a6780] font-medium', disabled && 'cursor-not-allowed opacity-50'),
            style: active ? {
                borderColor: activeColor,
                background: activeBg,
                color: activeColor,
                fontWeight: 700
            } : undefined
        }, opt.label);
    }), children));
};
var $fcaca06c97c91379$export$2e2bcd8739ae039 = $fcaca06c97c91379$var$ChipSelector;

});

parcelRegister("jIDmT", function(module, exports) {

$parcel$export(module.exports, "default", () => $995baf94da7c0c12$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $5JYPc = parcelRequire("5JYPc");

var $7phmx = parcelRequire("7phmx");
'use client';
const $995baf94da7c0c12$var$CardSelector = ({ label: label, required: required, error: externalError, helperText: helperText, value: value, onChange: onChange, options: options = [], columns: columns = 4, validate: validate, disabled: disabled = false, style: style })=>{
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [internalError, setInternalError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const error = externalError || (touched ? internalError : '');
    const handleSelect = (v)=>{
        if (disabled) return;
        onChange(v);
        setTouched(true);
        if (validate) setInternalError(validate(v) || '');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        label: label,
        required: required,
        error: error,
        helperText: helperText,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "grid gap-2",
        style: {
            gridTemplateColumns: `repeat(${columns}, 1fr)`
        }
    }, options.map((opt)=>{
        const active = value === opt.value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: opt.value,
            type: "button",
            onClick: ()=>handleSelect(opt.value),
            disabled: disabled,
            className: (0, $5JYPc.cn)('py-3.5 px-2 rounded-xl border-[1.5px] text-center font-sans', 'transition-all duration-150 outline-none', 'focus-visible:ring-2 focus-visible:ring-ring', active ? 'border-navy bg-accent text-navy shadow-sm' : error ? 'border-destructive bg-white text-muted-foreground' : 'border-border bg-white text-muted-foreground', disabled && 'cursor-not-allowed opacity-50')
        }, opt.icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "text-xl mb-1.5 leading-none"
        }, opt.icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $5JYPc.cn)('text-[0.6875rem] leading-snug', active ? 'font-bold' : 'font-medium')
        }, opt.label));
    })));
};
var $995baf94da7c0c12$export$2e2bcd8739ae039 = $995baf94da7c0c12$var$CardSelector;

});

parcelRegister("amyVq", function(module, exports) {

$parcel$export(module.exports, "default", () => $318ef1f4a903d866$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $5JYPc = parcelRequire("5JYPc");

var $j9AxR = parcelRequire("j9AxR");
'use client';
// A search box is a *labelled control*, and a filter toolbar needs to be
// selectable in tests (§15.1) — so the wrapper takes the rest props
// (`data-testid`, `id`, …) and the input takes the ones that belong to a text
// field (`aria-label`, `onKeyDown`, `name`, `autoFocus`, `disabled`).
// The clear button restores focus to the field: losing focus to <body> after
// clearing is a keyboard dead end.
const $318ef1f4a903d866$var$SearchInput = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ value: value, onChange: onChange, placeholder: placeholder, className: className, style: style, inputProps: inputProps, 'aria-label': ariaLabel, onKeyDown: onKeyDown, name: name, id: id, disabled: disabled = false, autoFocus: autoFocus, clearLabel: clearLabel, ...rest }, ref)=>{
    const copy = (0, $j9AxR.kitCopy)().search;
    if (placeholder === undefined) placeholder = copy.placeholder;
    if (clearLabel === undefined) clearLabel = copy.clear;
    const inputRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // The caller's ref wins; the internal one is what the clear button focuses.
    // A search box that a keyboard shortcut cannot focus is a search box the
    // keyboard-first flows (F3, `/`) have to reach by querySelector.
    const setRef = (node)=>{
        inputRef.current = node;
        if (typeof ref === 'function') ref(node);
        else if (ref) ref.current = node;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $5JYPc.cn)('relative', className),
        style: style,
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "absolute start-3 top-1/2 -translate-y-1/2 pointer-events-none text-muted-foreground flex"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        width: "15",
        height: "15",
        "aria-hidden": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "11",
        cy: "11",
        r: "7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
        x1: "21",
        y1: "21",
        x2: "16.65",
        y2: "16.65"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ref: setRef,
        type: "search",
        value: value,
        onChange: onChange,
        onKeyDown: onKeyDown,
        placeholder: placeholder,
        "aria-label": ariaLabel || placeholder,
        name: name,
        id: id,
        disabled: disabled,
        autoFocus: autoFocus,
        className: (0, $5JYPc.cn)(// min-h-11 (2.75rem), not h-10: this control ships in mobile filter
        // toolbars, where DESIGN-CONCEPT-MOBILE §368 puts the floor at 44px.
        'w-full min-h-11 ps-9 pe-8 rounded-lg font-sans text-[0.8125rem] text-foreground', 'bg-white border-[1.5px] border-border outline-none', 'transition-[border-color,box-shadow] duration-150', 'focus:border-primary focus:shadow-ring-navy', 'placeholder:text-muted-foreground', disabled && 'opacity-50 cursor-not-allowed', // The native search affordance would sit on top of our clear button.
        '[&::-webkit-search-cancel-button]:appearance-none'),
        ...inputProps
    }), value && !disabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        "aria-label": clearLabel,
        onClick: ()=>{
            onChange({
                target: {
                    value: ''
                }
            });
            inputRef.current?.focus();
        },
        className: "absolute end-2.5 top-1/2 -translate-y-1/2 flex p-0.5 rounded text-muted-foreground hover:text-foreground transition-colors"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "13",
        height: "13",
        "aria-hidden": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
    }))));
});
$318ef1f4a903d866$var$SearchInput.displayName = 'SearchInput';
var $318ef1f4a903d866$export$2e2bcd8739ae039 = $318ef1f4a903d866$var$SearchInput;

});

parcelRegister("3GEBR", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddccb5e00ce1ba3b$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
'use client';
function $ddccb5e00ce1ba3b$export$2e2bcd8739ae039({ checked: checked, onChange: onChange, label: label, description: description, disabled: disabled = false, id: id, ...rest }) {
    const reactId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const rowId = id || reactId;
    const labelId = `${rowId}-label`;
    const descId = description ? `${rowId}-desc` : undefined;
    // The kit styles inline, which cannot express :focus-visible — so the ring is
    // tracked here. Keyed on :focus-visible rather than :focus so a pointer tap
    // does not leave a ring behind, which is the behaviour the pseudo-class
    // exists to give. Setting only outlineColor (as this component did) paints
    // nothing: without an outline-style there is no outline to colour.
    const [focusRing, setFocusRing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 16,
            padding: '14px 0',
            borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
            opacity: disabled ? 0.55 : 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        id: labelId,
        htmlFor: rowId,
        style: {
            display: 'block',
            fontSize: '0.875rem',
            color: (0, $jTCZr.C).textPrimary,
            cursor: disabled ? 'not-allowed' : 'pointer'
        }
    }, label), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        id: descId,
        style: {
            display: 'block',
            fontSize: '0.75rem',
            color: (0, $jTCZr.C).textMuted,
            marginTop: 3
        }
    }, description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        id: rowId,
        role: "switch",
        "aria-checked": checked,
        "aria-labelledby": labelId,
        "aria-describedby": descId,
        disabled: disabled,
        onClick: ()=>!disabled && onChange(!checked),
        onFocus: (e)=>{
            // `matches` can throw on engines without :focus-visible; a ring on
            // plain focus is a better failure than no ring at all.
            let visible = true;
            try {
                visible = e.target.matches(':focus-visible');
            } catch  {}
            setFocusRing(visible);
        },
        onBlur: ()=>setFocusRing(false),
        style: {
            width: 44,
            height: 24,
            borderRadius: 999,
            flexShrink: 0,
            padding: 0,
            border: `1px solid ${checked ? 'transparent' : '#cbd2dc'}`,
            background: checked ? (0, $jTCZr.C).navy : '#d1d5db',
            cursor: disabled ? 'not-allowed' : 'pointer',
            position: 'relative',
            transition: 'background 0.25s, box-shadow 0.15s',
            outline: 'none',
            boxShadow: focusRing ? `0 0 0 3px ${(0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.45)}` : 'none'
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            position: 'absolute',
            top: 2,
            width: 18,
            height: 18,
            borderRadius: '50%',
            background: 'white',
            transition: 'inset-inline-end 0.25s',
            insetInlineEnd: checked ? 2 : 22,
            boxShadow: '0 1px 4px rgba(0,0,0,0.2)',
            pointerEvents: 'none'
        }
    })));
}

});

parcelRegister("4fYdd", function(module, exports) {

$parcel$export(module.exports, "Dialog", () => $ace11be13f1c53cf$export$3ddf2d174ce01153);
$parcel$export(module.exports, "DialogContent", () => $ace11be13f1c53cf$export$b6d9565de1e068cf);
$parcel$export(module.exports, "DialogHeader", () => $ace11be13f1c53cf$export$742513523b177e3b);
$parcel$export(module.exports, "DialogBody", () => $ace11be13f1c53cf$export$5d20f2c38fcde41f);
$parcel$export(module.exports, "DialogFooter", () => $ace11be13f1c53cf$export$7bbfb2d443473050);
$parcel$export(module.exports, "DialogTitle", () => $ace11be13f1c53cf$export$16f7638e4a34b909);
$parcel$export(module.exports, "DialogDescription", () => $ace11be13f1c53cf$export$94e94c2ec2c954d5);

var $acw62 = parcelRequire("acw62");

var $dBsUf = parcelRequire("dBsUf");

var $5JYPc = parcelRequire("5JYPc");
'use client';
const $ace11be13f1c53cf$export$3ddf2d174ce01153 = $dBsUf.Root;
const $ace11be13f1c53cf$export$2e1e1122cf0cba88 = $dBsUf.Trigger;
const $ace11be13f1c53cf$export$fba2fb7cd781b7ac = $dBsUf.Close;
const $ace11be13f1c53cf$export$dad7c95542bacce0 = $dBsUf.Portal;
// ── Overlay z-scale (keep these in sync; see DESIGN.md "Overlay layering") ──
// Drawer 11 < BottomSheet 1000 < Dialog/ConfirmDialog 1100 < Toast / JalaliDatePicker 9999
//
// The dialog layer MUST sit above BottomSheet: a ConfirmDialog is routinely opened from
// inside a sheet (destructive confirms, unsaved-changes guards). At the old z-50 it
// rendered *behind* the sheet while Radix's modal mode set `pointer-events: none` on
// <body> — so the sheet froze with an invisible modal trapping focus, unrecoverable by
// touch. Raising the dialog (rather than lowering the sheet) is the safe direction:
// mobile chrome that must stay under a sheet — the doctor app's MobileBottomNav (z-50)
// and MobileVisitClosureFlow (z-60) — keeps working unchanged.
const $ace11be13f1c53cf$var$Z_DIALOG = 'z-[1100]';
// A dialog is a transition the user asked for, so it animates — but §12.4 of the
// design concept says every transition collapses to instant under
// `prefers-reduced-motion`. Radix drives the animation through `data-state`
// classes, so the opt-out has to be a class too; without it the dialog was the
// one overlay that kept moving for a user who asked it not to.
const $ace11be13f1c53cf$var$MOTION_SAFE = 'motion-reduce:animate-none motion-reduce:transition-none';
const $ace11be13f1c53cf$export$bd1d06c79be19e17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($dBsUf.Overlay, {
        ref: ref,
        className: (0, $5JYPc.cn)('fixed inset-0 bg-black/45', $ace11be13f1c53cf$var$Z_DIALOG, 'data-[state=open]:animate-in data-[state=closed]:animate-out', 'data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0', $ace11be13f1c53cf$var$MOTION_SAFE, className),
        ...props
    }));
$ace11be13f1c53cf$export$bd1d06c79be19e17.displayName = 'DialogOverlay';
// Floating layers portaled to <body> (e.g. the Jalali calendar popup) live outside the
// dialog's DOM, so Radix would treat interacting with them as an outside click and close
// the dialog mid-pick. Anything inside [data-jalali-popup] is ours, not "outside".
const $ace11be13f1c53cf$var$isInFloatingLayer = (e)=>e.target instanceof Element && e.target.closest('[data-jalali-popup]');
// ── Width ────────────────────────────────────────────────────────────────────
// Four widths rather than a free `className` override, because "how wide is a
// dialog" is a design-system decision: a confirm and a full review surface must
// not each pick their own number. `md` is the historical default, so every
// existing call site keeps its exact width.
const $ace11be13f1c53cf$var$SIZE = {
    sm: 'max-w-md',
    md: 'max-w-lg',
    lg: 'max-w-3xl',
    xl: 'max-w-[52rem]'
};
// ── Layout ───────────────────────────────────────────────────────────────────
// `scroll` (default) is the classic dialog: one padded box that scrolls as a
// whole. `frame` is the surface with its own chrome — a fixed header, a
// scrolling body and a docked footer — which is what a review/receipt overlay
// needs so its primary action never scrolls out of reach. The three slot
// components read the mode from context rather than taking a prop, so a caller
// cannot half-apply it.
//
// `fullscreen` is the deep-work surface on a phone (DESIGN_CONCEPT §5.2: «image
// workspace … full-screen»): the whole viewport, edge to edge on black, for a
// photo viewer the person pinches and swipes. It keeps everything a modal owes —
// Radix's focus trap, Escape, the scroll lock, the dialog layer (so a confirm
// opened from inside it still stacks above) — and only fades: a surface that
// fills the screen has nowhere to zoom in from. Its content draws its own chrome
// and honours the safe areas; `size` does not apply and the stock ✕ is the
// caller's to replace (`showClose={false}`), since a dark ✕ on black is no
// control at all.
const $ace11be13f1c53cf$var$LayoutContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext('scroll');
const $ace11be13f1c53cf$export$b6d9565de1e068cf = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ className: className, children: children, showClose: showClose = true, size: size = 'md', layout: layout = 'scroll', ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ace11be13f1c53cf$export$dad7c95542bacce0, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ace11be13f1c53cf$export$bd1d06c79be19e17, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($dBsUf.Content, {
        ref: ref,
        onPointerDownOutside: (e)=>{
            if ($ace11be13f1c53cf$var$isInFloatingLayer(e)) e.preventDefault();
        },
        onFocusOutside: (e)=>{
            if ($ace11be13f1c53cf$var$isInFloatingLayer(e)) e.preventDefault();
        },
        onInteractOutside: (e)=>{
            if ($ace11be13f1c53cf$var$isInFloatingLayer(e)) e.preventDefault();
        },
        className: layout === 'fullscreen' ? (0, $5JYPc.cn)('fixed inset-0', $ace11be13f1c53cf$var$Z_DIALOG, 'h-[100vh] w-full overflow-hidden bg-black text-white outline-none [@supports(height:1dvh)]:h-[100dvh]', 'data-[state=open]:animate-in data-[state=closed]:animate-out', 'data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0', $ace11be13f1c53cf$var$MOTION_SAFE, className) : (0, $5JYPc.cn)('fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2', $ace11be13f1c53cf$var$Z_DIALOG, 'w-full bg-white rounded-2xl shadow-modal', $ace11be13f1c53cf$var$SIZE[size] || $ace11be13f1c53cf$var$SIZE.md, layout === 'frame' ? [
            'grid grid-rows-[auto_minmax(0,1fr)_auto] overflow-hidden',
            'max-h-[calc(100vh-3rem)] [@supports(height:1dvh)]:max-h-[calc(100dvh-3rem)]'
        ] : 'max-h-[90vh] overflow-y-auto p-8', 'data-[state=open]:animate-in data-[state=closed]:animate-out', 'data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0', 'data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95', 'data-[state=closed]:slide-out-to-left-1/2 data-[state=open]:slide-in-from-left-1/2', 'data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-top-[48%]', $ace11be13f1c53cf$var$MOTION_SAFE, className),
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ace11be13f1c53cf$var$LayoutContext.Provider, {
        value: layout
    }, children), showClose && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($dBsUf.Close, {
        className: "absolute end-5 top-5 rounded-sm opacity-70 hover:opacity-100 outline-none focus:ring-2 focus:ring-ring transition-opacity"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "18",
        height: "18"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
    }))))));
$ace11be13f1c53cf$export$b6d9565de1e068cf.displayName = 'DialogContent';
const $ace11be13f1c53cf$export$742513523b177e3b = ({ className: className, ...props })=>{
    const layout = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($ace11be13f1c53cf$var$LayoutContext);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $5JYPc.cn)('flex flex-col gap-1.5', layout === 'frame' ? 'px-5 py-4 border-b border-border' : 'mb-6', className),
        ...props
    });
};
// The scroll region of a `frame` dialog. `overscroll-contain` is what stops a
// flick at the end of the list from scrolling the page behind the dialog.
const $ace11be13f1c53cf$export$5d20f2c38fcde41f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ className: className, ...props }, ref)=>{
    const layout = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($ace11be13f1c53cf$var$LayoutContext);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: ref,
        className: (0, $5JYPc.cn)(layout === 'frame' ? 'overflow-y-auto overscroll-contain p-5' : '', className),
        ...props
    });
});
$ace11be13f1c53cf$export$5d20f2c38fcde41f.displayName = 'DialogBody';
const $ace11be13f1c53cf$export$7bbfb2d443473050 = ({ className: className, ...props })=>{
    const layout = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($ace11be13f1c53cf$var$LayoutContext);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $5JYPc.cn)('flex gap-2.5', layout === 'frame' ? 'px-5 py-3 border-t border-border flex-wrap' : 'mt-6', className),
        ...props
    });
};
const $ace11be13f1c53cf$export$16f7638e4a34b909 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($dBsUf.Title, {
        ref: ref,
        className: (0, $5JYPc.cn)('text-[1.125rem] font-extrabold text-foreground', className),
        ...props
    }));
$ace11be13f1c53cf$export$16f7638e4a34b909.displayName = 'DialogTitle';
const $ace11be13f1c53cf$export$94e94c2ec2c954d5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($dBsUf.Description, {
        ref: ref,
        className: (0, $5JYPc.cn)('text-sm text-muted-foreground leading-6', className),
        ...props
    }));
$ace11be13f1c53cf$export$94e94c2ec2c954d5.displayName = 'DialogDescription';

});
parcelRegister("dBsUf", function(module, exports) {

$parcel$export(module.exports, "Content", () => $eeaeb48e23f662e7$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "Description", () => $eeaeb48e23f662e7$export$393edc798c47379d);
$parcel$export(module.exports, "Close", () => $eeaeb48e23f662e7$export$f39c2d165cd861fe);
$parcel$export(module.exports, "Overlay", () => $eeaeb48e23f662e7$export$bd1d06c79be19e17);
$parcel$export(module.exports, "Portal", () => $eeaeb48e23f662e7$export$dad7c95542bacce0);
$parcel$export(module.exports, "Root", () => $eeaeb48e23f662e7$export$3ddf2d174ce01153);
$parcel$export(module.exports, "Title", () => $eeaeb48e23f662e7$export$16f7638e4a34b909);
$parcel$export(module.exports, "Trigger", () => $eeaeb48e23f662e7$export$2e1e1122cf0cba88);

var $acw62 = parcelRequire("acw62");

var $2IwC4 = parcelRequire("2IwC4");

var $htT6J = parcelRequire("htT6J");

var $jnK0n = parcelRequire("jnK0n");

var $g2NP0 = parcelRequire("g2NP0");

var $88UcQ = parcelRequire("88UcQ");

var $4yZYB = parcelRequire("4yZYB");

var $kNgwr = parcelRequire("kNgwr");

var $5nYva = parcelRequire("5nYva");

var $cTFdF = parcelRequire("cTFdF");

var $kFbxc = parcelRequire("kFbxc");

var $fg1c6 = parcelRequire("fg1c6");

var $7g00o = parcelRequire("7g00o");

var $hPyeV = parcelRequire("hPyeV");

var $6okVC = parcelRequire("6okVC");

var $9UeUh = parcelRequire("9UeUh");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $eeaeb48e23f662e7$var$__defProp = Object.defineProperty;
var $eeaeb48e23f662e7$var$__name = (target, value)=>$eeaeb48e23f662e7$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $eeaeb48e23f662e7$var$DIALOG_NAME = "Dialog";
var [$eeaeb48e23f662e7$var$createDialogContext, $eeaeb48e23f662e7$export$cc702773b8ea3e41] = (0, $jnK0n.createContextScope)($eeaeb48e23f662e7$var$DIALOG_NAME);
var [$eeaeb48e23f662e7$var$DialogProvider, $eeaeb48e23f662e7$var$useDialogContext] = $eeaeb48e23f662e7$var$createDialogContext($eeaeb48e23f662e7$var$DIALOG_NAME);
var $eeaeb48e23f662e7$export$3ddf2d174ce01153 = /* @__PURE__ */ $eeaeb48e23f662e7$var$__name((props)=>{
    const { __scopeDialog: __scopeDialog, children: children, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, modal: modal = true } = props;
    const triggerRef = $acw62.useRef(null);
    const contentRef = $acw62.useRef(null);
    const { nodes: branchNodes, registry: branchRegistry } = (0, $kNgwr.useFocusScopeBranchRegistry)();
    const [open, setOpen] = (0, $88UcQ.useControllableState)({
        prop: openProp,
        defaultProp: defaultOpen ?? false,
        onChange: onOpenChange,
        caller: $eeaeb48e23f662e7$var$DIALOG_NAME
    });
    const [titleCount, setTitleCount] = $acw62.useState(0);
    const [descriptionCount, setDescriptionCount] = $acw62.useState(0);
    return /* @__PURE__ */ (0, $ayMG0.jsx)($eeaeb48e23f662e7$var$DialogProvider, {
        scope: __scopeDialog,
        triggerRef: triggerRef,
        contentRef: contentRef,
        contentId: (0, $g2NP0.useId)(),
        titleId: (0, $g2NP0.useId)(),
        descriptionId: (0, $g2NP0.useId)(),
        titlePresent: titleCount > 0,
        descriptionPresent: descriptionCount > 0,
        setTitleCount: setTitleCount,
        setDescriptionCount: setDescriptionCount,
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: $acw62.useCallback(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        modal: modal,
        branchNodes: branchNodes,
        branchRegistry: branchRegistry,
        children: children
    });
}, "Dialog");
var $eeaeb48e23f662e7$var$TRIGGER_NAME = "DialogTrigger";
var $eeaeb48e23f662e7$export$2e1e1122cf0cba88 = /* @__PURE__ */ $acw62.forwardRef(/* @__PURE__ */ $eeaeb48e23f662e7$var$__name(function DialogTrigger2(props, forwardedRef) {
    const { __scopeDialog: __scopeDialog, ...triggerProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$TRIGGER_NAME, __scopeDialog);
    const composedTriggerRef = (0, $htT6J.useComposedRefs)(forwardedRef, context.triggerRef);
    return /* @__PURE__ */ (0, $ayMG0.jsx)((0, $kFbxc.Primitive).button, {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.open ? context.contentId : void 0,
        "data-state": $eeaeb48e23f662e7$var$getState(context.open),
        ...triggerProps,
        ref: composedTriggerRef,
        onClick: (0, $2IwC4.composeEventHandlers)(props.onClick, context.onOpenToggle)
    });
}, "DialogTrigger"));
var $eeaeb48e23f662e7$var$PORTAL_NAME = "DialogPortal";
var [$eeaeb48e23f662e7$var$PortalProvider, $eeaeb48e23f662e7$var$usePortalContext] = $eeaeb48e23f662e7$var$createDialogContext($eeaeb48e23f662e7$var$PORTAL_NAME, {
    forceMount: void 0
});
var $eeaeb48e23f662e7$export$dad7c95542bacce0 = /* @__PURE__ */ $eeaeb48e23f662e7$var$__name((props)=>{
    const { __scopeDialog: __scopeDialog, forceMount: forceMount, children: children, container: container } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$PORTAL_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $ayMG0.jsx)($eeaeb48e23f662e7$var$PortalProvider, {
        scope: __scopeDialog,
        forceMount: forceMount,
        children: $acw62.Children.map(children, (child)=>/* @__PURE__ */ (0, $ayMG0.jsx)((0, $cTFdF.Presence), {
                present: forceMount || context.open,
                children: /* @__PURE__ */ (0, $ayMG0.jsx)((0, $5nYva.Portal), {
                    asChild: true,
                    container: container,
                    children: child
                })
            }))
    });
}, "DialogPortal");
var $eeaeb48e23f662e7$var$OVERLAY_NAME = "DialogOverlay";
var $eeaeb48e23f662e7$export$bd1d06c79be19e17 = /* @__PURE__ */ $acw62.forwardRef(/* @__PURE__ */ $eeaeb48e23f662e7$var$__name(function DialogOverlay2(props, forwardedRef) {
    const portalContext = $eeaeb48e23f662e7$var$usePortalContext($eeaeb48e23f662e7$var$OVERLAY_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount, ...overlayProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$OVERLAY_NAME, props.__scopeDialog);
    return context.modal ? /* @__PURE__ */ (0, $ayMG0.jsx)((0, $cTFdF.Presence), {
        present: forceMount || context.open,
        children: /* @__PURE__ */ (0, $ayMG0.jsx)($eeaeb48e23f662e7$var$DialogOverlayImpl, {
            ...overlayProps,
            ref: forwardedRef
        })
    }) : null;
}, "DialogOverlay"));
var $eeaeb48e23f662e7$var$Slot = (0, $9UeUh.createSlot)("DialogOverlay.RemoveScroll");
var $eeaeb48e23f662e7$var$DialogOverlayImpl = /* @__PURE__ */ $acw62.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $eeaeb48e23f662e7$var$__name(function DialogOverlayImpl2(props, forwardedRef) {
    const { __scopeDialog: __scopeDialog, ...overlayProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$OVERLAY_NAME, __scopeDialog);
    const registerDismissableSurface = (0, $4yZYB.useDismissableLayerSurface)();
    const composedRefs = (0, $htT6J.useComposedRefs)(forwardedRef, registerDismissableSurface);
    return(// Make sure `Content` is scrollable even when it doesn't live inside
    // `RemoveScroll` (eg. when `Overlay` and `Content` are siblings). Nested
    // layers are registered as branches and added as shards so they remain
    // scrollable too. See https://github.com/radix-ui/primitives/issues/3423
    /* @__PURE__ */ (0, $ayMG0.jsx)((0, $hPyeV.default), {
        as: $eeaeb48e23f662e7$var$Slot,
        allowPinchZoom: true,
        shards: $acw62.useMemo(()=>[
                context.contentRef,
                ...context.branchNodes.map((node)=>({
                        current: node
                    }))
            ], [
            context.contentRef,
            context.branchNodes
        ]),
        children: /* @__PURE__ */ (0, $ayMG0.jsx)((0, $kFbxc.Primitive).div, {
            "data-state": $eeaeb48e23f662e7$var$getState(context.open),
            ...overlayProps,
            ref: composedRefs,
            style: {
                pointerEvents: "auto",
                ...overlayProps.style
            }
        })
    }));
}, "DialogOverlayImpl"));
var $eeaeb48e23f662e7$var$CONTENT_NAME = "DialogContent";
var $eeaeb48e23f662e7$export$7c6e2c02157bb7d2 = /* @__PURE__ */ $acw62.forwardRef(/* @__PURE__ */ $eeaeb48e23f662e7$var$__name(function DialogContent2(props, forwardedRef) {
    const portalContext = $eeaeb48e23f662e7$var$usePortalContext($eeaeb48e23f662e7$var$CONTENT_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$CONTENT_NAME, props.__scopeDialog);
    return /* @__PURE__ */ (0, $ayMG0.jsx)((0, $cTFdF.Presence), {
        present: forceMount || context.open,
        children: context.modal ? /* @__PURE__ */ (0, $ayMG0.jsx)($eeaeb48e23f662e7$var$DialogContentModal, {
            ...contentProps,
            ref: forwardedRef
        }) : /* @__PURE__ */ (0, $ayMG0.jsx)($eeaeb48e23f662e7$var$DialogContentNonModal, {
            ...contentProps,
            ref: forwardedRef
        })
    });
}, "DialogContent"));
var $eeaeb48e23f662e7$var$DialogContentModal = /* @__PURE__ */ $acw62.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $eeaeb48e23f662e7$var$__name(function DialogContentModal2(props, forwardedRef) {
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$CONTENT_NAME, props.__scopeDialog);
    const contentRef = $acw62.useRef(null);
    const composedRefs = (0, $htT6J.useComposedRefs)(forwardedRef, context.contentRef, contentRef);
    $acw62.useEffect(()=>{
        const content = contentRef.current;
        if (content) return (0, $6okVC.hideOthers)(content);
    }, []);
    return /* @__PURE__ */ (0, $ayMG0.jsx)($eeaeb48e23f662e7$var$DialogContentImpl, {
        ...props,
        ref: composedRefs,
        trapFocus: context.open,
        disableOutsidePointerEvents: context.open,
        onCloseAutoFocus: (0, $2IwC4.composeEventHandlers)(props.onCloseAutoFocus, (event)=>{
            event.preventDefault();
            context.triggerRef.current?.focus();
        }),
        onPointerDownOutside: (0, $2IwC4.composeEventHandlers)(props.onPointerDownOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
            if (isRightClick) event.preventDefault();
        }),
        onFocusOutside: (0, $2IwC4.composeEventHandlers)(props.onFocusOutside, (event)=>event.preventDefault())
    });
}, "DialogContentModal"));
var $eeaeb48e23f662e7$var$DialogContentNonModal = /* @__PURE__ */ $acw62.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $eeaeb48e23f662e7$var$__name(function DialogContentNonModal2(props, forwardedRef) {
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$CONTENT_NAME, props.__scopeDialog);
    const hasInteractedOutsideRef = $acw62.useRef(false);
    const hasPointerDownOutsideRef = $acw62.useRef(false);
    return /* @__PURE__ */ (0, $ayMG0.jsx)($eeaeb48e23f662e7$var$DialogContentImpl, {
        ...props,
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            props.onCloseAutoFocus?.(event);
            if (!event.defaultPrevented) {
                if (!hasInteractedOutsideRef.current) context.triggerRef.current?.focus();
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
            hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            props.onInteractOutside?.(event);
            if (!event.defaultPrevented) {
                hasInteractedOutsideRef.current = true;
                if (event.detail.originalEvent.type === "pointerdown") hasPointerDownOutsideRef.current = true;
            }
            const target = event.target;
            const targetIsTrigger = context.triggerRef.current?.contains(target);
            if (targetIsTrigger) event.preventDefault();
            if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) event.preventDefault();
        }
    });
}, "DialogContentNonModal"));
var $eeaeb48e23f662e7$var$DialogContentImpl = /* @__PURE__ */ $acw62.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $eeaeb48e23f662e7$var$__name(function DialogContentImpl2(props, forwardedRef) {
    const { __scopeDialog: __scopeDialog, trapFocus: trapFocus, onOpenAutoFocus: onOpenAutoFocus, onCloseAutoFocus: onCloseAutoFocus, "aria-describedby": ariaDescribedby, children: children, ...contentProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$CONTENT_NAME, __scopeDialog);
    (0, $fg1c6.useFocusGuards)();
    return /* @__PURE__ */ (0, $ayMG0.jsx)((0, $kNgwr.FocusScopeBranchProvider), {
        registry: context.branchRegistry,
        children: /* @__PURE__ */ (0, $ayMG0.jsx)((0, $kNgwr.FocusScope), {
            asChild: true,
            loop: true,
            trapped: trapFocus,
            branches: context.branchNodes,
            onMountAutoFocus: onOpenAutoFocus,
            onUnmountAutoFocus: onCloseAutoFocus,
            children: /* @__PURE__ */ (0, $ayMG0.jsx)((0, $4yZYB.DismissableLayer), {
                role: "dialog",
                id: context.contentId,
                "aria-labelledby": context.titlePresent ? context.titleId : void 0,
                "aria-describedby": context.descriptionPresent ? $eeaeb48e23f662e7$var$concatAriaDescribedby(ariaDescribedby, context.descriptionId) : ariaDescribedby,
                "data-state": $eeaeb48e23f662e7$var$getState(context.open),
                ...contentProps,
                ref: forwardedRef,
                deferPointerDownOutside: true,
                onDismiss: ()=>context.onOpenChange(false),
                children: children
            })
        })
    });
}, "DialogContentImpl"));
var $eeaeb48e23f662e7$export$16f7638e4a34b909 = /* @__PURE__ */ $acw62.forwardRef(/* @__PURE__ */ $eeaeb48e23f662e7$var$__name(function DialogTitle2(props, forwardedRef) {
    const { __scopeDialog: __scopeDialog, ...titleProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext("DialogTitle", __scopeDialog);
    const { setTitleCount: setTitleCount } = context;
    (0, $7g00o.useLayoutEffect)(()=>{
        setTitleCount((count)=>count + 1);
        return ()=>setTitleCount((count)=>count - 1);
    }, [
        setTitleCount
    ]);
    return /* @__PURE__ */ (0, $ayMG0.jsx)((0, $kFbxc.Primitive).h2, {
        id: context.titleId,
        ...titleProps,
        ref: forwardedRef
    });
}, "DialogTitle"));
var $eeaeb48e23f662e7$export$393edc798c47379d = /* @__PURE__ */ $acw62.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $eeaeb48e23f662e7$var$__name(function DialogDescription2(props, forwardedRef) {
    const { __scopeDialog: __scopeDialog, ...descriptionProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext("DialogDescription", __scopeDialog);
    const { setDescriptionCount: setDescriptionCount } = context;
    (0, $7g00o.useLayoutEffect)(()=>{
        setDescriptionCount((count)=>count + 1);
        return ()=>setDescriptionCount((count)=>count - 1);
    }, [
        setDescriptionCount
    ]);
    return /* @__PURE__ */ (0, $ayMG0.jsx)((0, $kFbxc.Primitive).p, {
        id: context.descriptionId,
        ...descriptionProps,
        ref: forwardedRef
    });
}, "DialogDescription"));
var $eeaeb48e23f662e7$var$CLOSE_NAME = "DialogClose";
var $eeaeb48e23f662e7$export$f39c2d165cd861fe = /* @__PURE__ */ $acw62.forwardRef(/* @__PURE__ */ $eeaeb48e23f662e7$var$__name(function DialogClose2(props, forwardedRef) {
    const { __scopeDialog: __scopeDialog, ...closeProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$CLOSE_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $ayMG0.jsx)((0, $kFbxc.Primitive).button, {
        type: "button",
        ...closeProps,
        ref: forwardedRef,
        onClick: (0, $2IwC4.composeEventHandlers)(props.onClick, ()=>context.onOpenChange(false))
    });
}, "DialogClose"));
var $eeaeb48e23f662e7$export$69b62a49393917d6 = /* @__PURE__ */ $eeaeb48e23f662e7$var$__name((props)=>{
    return props.children;
}, "WarningProvider");
function $eeaeb48e23f662e7$var$concatAriaDescribedby(...values) {
    const ids = /* @__PURE__ */ new Set();
    for (const value of values){
        if (typeof value !== "string") continue;
        for (const id of String(value).trim().split(/\s+/))if (id) ids.add(id);
    }
    return ids.size > 0 ? Array.from(ids).join(" ") : void 0;
}
$eeaeb48e23f662e7$var$__name($eeaeb48e23f662e7$var$concatAriaDescribedby, "concatAriaDescribedby");
function $eeaeb48e23f662e7$var$getState(open) {
    return open ? "open" : "closed";
}
$eeaeb48e23f662e7$var$__name($eeaeb48e23f662e7$var$getState, "getState");

});
parcelRegister("4yZYB", function(module, exports) {

$parcel$export(module.exports, "DismissableLayer", () => $30a399657994b369$export$177fb62ff3ec1f22);
$parcel$export(module.exports, "useDismissableLayerSurface", () => $30a399657994b369$export$210785236bdfcb27);

var $acw62 = parcelRequire("acw62");

var $2IwC4 = parcelRequire("2IwC4");

var $kFbxc = parcelRequire("kFbxc");

var $htT6J = parcelRequire("htT6J");

var $by19I = parcelRequire("by19I");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $30a399657994b369$var$__defProp = Object.defineProperty;
var $30a399657994b369$var$__name = (target, value)=>$30a399657994b369$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $30a399657994b369$var$CONTEXT_UPDATE = "dismissableLayer.update";
var $30a399657994b369$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
var $30a399657994b369$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
var $30a399657994b369$var$originalBodyPointerEvents;
var $30a399657994b369$var$DismissableLayerContext = $acw62.createContext({
    layers: /* @__PURE__ */ new Set(),
    layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
    branches: /* @__PURE__ */ new Set(),
    // Outside elements that belong to a layer's own dismiss affordance (eg, a
    // dialog overlay). Pressing them should dismiss the layer regardless of
    // whether or not they stop propagation.
    //
    // See https://github.com/radix-ui/primitives/issues/3346
    dismissableSurfaces: /* @__PURE__ */ new Set()
});
var $30a399657994b369$export$177fb62ff3ec1f22 = /* @__PURE__ */ $acw62.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $30a399657994b369$var$__name(function DismissableLayer2(props, forwardedRef) {
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false, deferPointerDownOutside: deferPointerDownOutside = false, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, onDismiss: onDismiss, ...layerProps } = props;
    const context = $acw62.useContext($30a399657994b369$var$DismissableLayerContext);
    const [node, setNode] = $acw62.useState(null);
    const ownerDocument = node?.ownerDocument ?? globalThis?.document;
    const [, force] = $acw62.useState({});
    const composedRefs = (0, $htT6J.useComposedRefs)(forwardedRef, setNode);
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1);
    const highestLayerWithOutsidePointerEventsDisabledIndex = highestLayerWithOutsidePointerEventsDisabled ? layers.indexOf(highestLayerWithOutsidePointerEventsDisabled) : -1;
    const index = node ? layers.indexOf(node) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const isDeferredPointerDownOutsideRef = $acw62.useRef(false);
    const pointerDownOutside = $30a399657994b369$var$usePointerDownOutside((event)=>{
        onPointerDownOutside?.(event);
        onInteractOutside?.(event);
        if (!event.defaultPrevented) onDismiss?.();
    }, {
        ownerDocument: ownerDocument,
        deferPointerDownOutside: deferPointerDownOutside,
        isDeferredPointerDownOutsideRef: isDeferredPointerDownOutsideRef,
        dismissableSurfaces: context.dismissableSurfaces,
        shouldHandlePointerDownOutside: $acw62.useCallback((target)=>{
            if (!(target instanceof Node)) return false;
            const isPointerDownOnBranch = [
                ...context.branches
            ].some((branch)=>branch.contains(target));
            return isPointerEventsEnabled && !isPointerDownOnBranch;
        }, [
            context.branches,
            isPointerEventsEnabled
        ])
    });
    const focusOutside = $30a399657994b369$var$useFocusOutside((event)=>{
        if (deferPointerDownOutside && isDeferredPointerDownOutsideRef.current) return;
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (isFocusInBranch) return;
        onFocusOutside?.(event);
        onInteractOutside?.(event);
        if (!event.defaultPrevented) onDismiss?.();
    }, ownerDocument);
    const isHighestLayer = node ? index === layers.length - 1 : false;
    const handleKeyDown = (0, $by19I.useCallbackRef)((event)=>{
        if (event.key !== "Escape") return;
        onEscapeKeyDown?.(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    });
    $acw62.useEffect(()=>{
        if (!isHighestLayer) return;
        ownerDocument.addEventListener("keydown", handleKeyDown, {
            capture: true
        });
        return ()=>ownerDocument.removeEventListener("keydown", handleKeyDown, {
                capture: true
            });
    }, [
        ownerDocument,
        isHighestLayer,
        handleKeyDown
    ]);
    $acw62.useEffect(()=>{
        if (!node) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $30a399657994b369$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = "none";
            }
            context.layersWithOutsidePointerEventsDisabled.add(node);
        }
        context.layers.add(node);
        $30a399657994b369$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents) {
                context.layersWithOutsidePointerEventsDisabled.delete(node);
                if (context.layersWithOutsidePointerEventsDisabled.size === 0) ownerDocument.body.style.pointerEvents = $30a399657994b369$var$originalBodyPointerEvents;
            }
        };
    }, [
        node,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            if (!node) return;
            context.layers.delete(node);
            context.layersWithOutsidePointerEventsDisabled.delete(node);
            $30a399657994b369$var$dispatchUpdate();
        };
    }, [
        node,
        context
    ]);
    $acw62.useEffect(()=>{
        const handleUpdate = /* @__PURE__ */ $30a399657994b369$var$__name(()=>force({}), "handleUpdate");
        document.addEventListener($30a399657994b369$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener($30a399657994b369$var$CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /* @__PURE__ */ (0, $ayMG0.jsx)((0, $kFbxc.Primitive).div, {
        ...layerProps,
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : void 0,
            ...props.style
        },
        onFocusCapture: (0, $2IwC4.composeEventHandlers)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0, $2IwC4.composeEventHandlers)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0, $2IwC4.composeEventHandlers)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    });
}, "DismissableLayer"));
var $30a399657994b369$export$aecb2ddcb55c95be = /* @__PURE__ */ $acw62.forwardRef(/* @__PURE__ */ $30a399657994b369$var$__name(function DismissableLayerBranch2(props, forwardedRef) {
    const context = $acw62.useContext($30a399657994b369$var$DismissableLayerContext);
    const ref = $acw62.useRef(null);
    const composedRefs = (0, $htT6J.useComposedRefs)(forwardedRef, ref);
    $acw62.useEffect(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /* @__PURE__ */ (0, $ayMG0.jsx)((0, $kFbxc.Primitive).div, {
        ...props,
        ref: composedRefs
    });
}, "DismissableLayerBranch"));
function $30a399657994b369$export$210785236bdfcb27() {
    const context = $acw62.useContext($30a399657994b369$var$DismissableLayerContext);
    const [node, setNode] = $acw62.useState(null);
    $acw62.useEffect(()=>{
        if (!node) return;
        context.dismissableSurfaces.add(node);
        return ()=>{
            context.dismissableSurfaces.delete(node);
        };
    }, [
        node,
        context.dismissableSurfaces
    ]);
    return setNode;
}
$30a399657994b369$var$__name($30a399657994b369$export$210785236bdfcb27, "useDismissableLayerSurface");
var $30a399657994b369$var$IS_TRUE = /* @__PURE__ */ $30a399657994b369$var$__name(()=>true, "IS_TRUE");
function $30a399657994b369$var$usePointerDownOutside(onPointerDownOutside, args) {
    const { ownerDocument: ownerDocument = globalThis?.document, deferPointerDownOutside: deferPointerDownOutside = false, isDeferredPointerDownOutsideRef: isDeferredPointerDownOutsideRef, dismissableSurfaces: dismissableSurfaces, shouldHandlePointerDownOutside: shouldHandlePointerDownOutside = $30a399657994b369$var$IS_TRUE } = args;
    const handlePointerDownOutside = (0, $by19I.useCallbackRef)(onPointerDownOutside);
    const isPointerInsideReactTreeRef = $acw62.useRef(false);
    const isPointerDownOutsideRef = $acw62.useRef(false);
    const interceptedOutsideInteractionEventsRef = $acw62.useRef(/* @__PURE__ */ new Map());
    const handleClickRef = $acw62.useRef(()=>{});
    $acw62.useEffect(()=>{
        function resetOutsideInteraction() {
            isPointerDownOutsideRef.current = false;
            isDeferredPointerDownOutsideRef.current = false;
            interceptedOutsideInteractionEventsRef.current.clear();
        }
        $30a399657994b369$var$__name(resetOutsideInteraction, "resetOutsideInteraction");
        function isOutsideInteractionIntercepted() {
            return Array.from(interceptedOutsideInteractionEventsRef.current.values()).some(Boolean);
        }
        $30a399657994b369$var$__name(isOutsideInteractionIntercepted, "isOutsideInteractionIntercepted");
        function handleInteractionCapture(event) {
            if (!isPointerDownOutsideRef.current) return;
            const target = event.target;
            const isDismissableSurface = target instanceof Node && [
                ...dismissableSurfaces
            ].some((surface)=>surface.contains(target));
            if (!isDismissableSurface) interceptedOutsideInteractionEventsRef.current.set(event.type, true);
            if (event.type === "click") window.setTimeout(()=>{
                if (isPointerDownOutsideRef.current) handleClickRef.current();
            }, 0);
        }
        $30a399657994b369$var$__name(handleInteractionCapture, "handleInteractionCapture");
        function handleInteractionBubble(event) {
            if (isPointerDownOutsideRef.current) interceptedOutsideInteractionEventsRef.current.set(event.type, false);
        }
        $30a399657994b369$var$__name(handleInteractionBubble, "handleInteractionBubble");
        const handlePointerDown = /* @__PURE__ */ $30a399657994b369$var$__name((event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                let handleAndDispatchPointerDownOutsideEvent2 = function() {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    const wasOutsideInteractionIntercepted = isOutsideInteractionIntercepted();
                    resetOutsideInteraction();
                    if (!wasOutsideInteractionIntercepted) $30a399657994b369$var$handleAndDispatchCustomEvent($30a399657994b369$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                };
                var handleAndDispatchPointerDownOutsideEvent = handleAndDispatchPointerDownOutsideEvent2;
                $30a399657994b369$var$__name(handleAndDispatchPointerDownOutsideEvent2, "handleAndDispatchPointerDownOutsideEvent");
                if (!shouldHandlePointerDownOutside(event.target)) {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    resetOutsideInteraction();
                    isPointerInsideReactTreeRef.current = false;
                    return;
                }
                const eventDetail = {
                    originalEvent: event
                };
                isPointerDownOutsideRef.current = true;
                isDeferredPointerDownOutsideRef.current = deferPointerDownOutside && event.button === 0;
                interceptedOutsideInteractionEventsRef.current.clear();
                if (!deferPointerDownOutside || event.button !== 0) handleAndDispatchPointerDownOutsideEvent2();
                else {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent2;
                    ownerDocument.addEventListener("click", handleClickRef.current, {
                        once: true
                    });
                }
            } else {
                ownerDocument.removeEventListener("click", handleClickRef.current);
                resetOutsideInteraction();
            }
            isPointerInsideReactTreeRef.current = false;
        }, "handlePointerDown");
        const outsideInteractionEvents = [
            "pointerup",
            "mousedown",
            "mouseup",
            "touchstart",
            "touchend",
            "click"
        ];
        for (const eventName of outsideInteractionEvents){
            ownerDocument.addEventListener(eventName, handleInteractionCapture, true);
            ownerDocument.addEventListener(eventName, handleInteractionBubble);
        }
        const timerId = window.setTimeout(()=>{
            ownerDocument.addEventListener("pointerdown", handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener("pointerdown", handlePointerDown);
            ownerDocument.removeEventListener("click", handleClickRef.current);
            for (const eventName of outsideInteractionEvents){
                ownerDocument.removeEventListener(eventName, handleInteractionCapture, true);
                ownerDocument.removeEventListener(eventName, handleInteractionBubble);
            }
        };
    }, [
        ownerDocument,
        handlePointerDownOutside,
        deferPointerDownOutside,
        isDeferredPointerDownOutsideRef,
        dismissableSurfaces,
        shouldHandlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: /* @__PURE__ */ $30a399657994b369$var$__name(()=>isPointerInsideReactTreeRef.current = true, "onPointerDownCapture")
    };
}
$30a399657994b369$var$__name($30a399657994b369$var$usePointerDownOutside, "usePointerDownOutside");
function $30a399657994b369$var$useFocusOutside(onFocusOutside, ownerDocument = globalThis?.document) {
    const handleFocusOutside = (0, $by19I.useCallbackRef)(onFocusOutside);
    const isFocusInsideReactTreeRef = $acw62.useRef(false);
    $acw62.useEffect(()=>{
        const handleFocus = /* @__PURE__ */ $30a399657994b369$var$__name((event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                $30a399657994b369$var$handleAndDispatchCustomEvent($30a399657994b369$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        }, "handleFocus");
        ownerDocument.addEventListener("focusin", handleFocus);
        return ()=>ownerDocument.removeEventListener("focusin", handleFocus);
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: /* @__PURE__ */ $30a399657994b369$var$__name(()=>isFocusInsideReactTreeRef.current = true, "onFocusCapture"),
        onBlurCapture: /* @__PURE__ */ $30a399657994b369$var$__name(()=>isFocusInsideReactTreeRef.current = false, "onBlurCapture")
    };
}
$30a399657994b369$var$__name($30a399657994b369$var$useFocusOutside, "useFocusOutside");
function $30a399657994b369$var$dispatchUpdate() {
    const event = new CustomEvent($30a399657994b369$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
$30a399657994b369$var$__name($30a399657994b369$var$dispatchUpdate, "dispatchUpdate");
function $30a399657994b369$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $kFbxc.dispatchDiscreteCustomEvent)(target, event);
    else target.dispatchEvent(event);
}
$30a399657994b369$var$__name($30a399657994b369$var$handleAndDispatchCustomEvent, "handleAndDispatchCustomEvent");

});

parcelRegister("kNgwr", function(module, exports) {

$parcel$export(module.exports, "FocusScope", () => $03c48a27777929a8$export$20e40289641fbbb6);
$parcel$export(module.exports, "FocusScopeBranchProvider", () => $03c48a27777929a8$export$8c6311edc7a51a87);
$parcel$export(module.exports, "useFocusScopeBranchRegistry", () => $03c48a27777929a8$export$cf83b8875a7b68e0);

var $acw62 = parcelRequire("acw62");

var $htT6J = parcelRequire("htT6J");

var $kFbxc = parcelRequire("kFbxc");

var $by19I = parcelRequire("by19I");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $03c48a27777929a8$var$__defProp = Object.defineProperty;
var $03c48a27777929a8$var$__name = (target, value)=>$03c48a27777929a8$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $03c48a27777929a8$var$AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
var $03c48a27777929a8$var$AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
var $03c48a27777929a8$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
var $03c48a27777929a8$export$20e40289641fbbb6 = /* @__PURE__ */ $acw62.forwardRef(/* @__PURE__ */ $03c48a27777929a8$var$__name(function FocusScope2(props, forwardedRef) {
    const { loop: loop = false, trapped: trapped = false, branches: branches, onMountAutoFocus: onMountAutoFocusProp, onUnmountAutoFocus: onUnmountAutoFocusProp, ...scopeProps } = props;
    const [container, setContainer] = $acw62.useState(null);
    const onMountAutoFocus = (0, $by19I.useCallbackRef)(onMountAutoFocusProp);
    const onUnmountAutoFocus = (0, $by19I.useCallbackRef)(onUnmountAutoFocusProp);
    const lastFocusedElementRef = $acw62.useRef(null);
    const composedRefs = (0, $htT6J.useComposedRefs)(forwardedRef, setContainer);
    const branchesRef = $acw62.useRef(branches);
    $acw62.useEffect(()=>{
        branchesRef.current = branches;
    });
    const isTargetInScope = $acw62.useCallback((target)=>{
        if (!target) return false;
        if (container?.contains(target)) return true;
        return Boolean(branchesRef.current?.some((branch)=>branch.contains(target)));
    }, [
        container
    ]);
    const focusScope = $acw62.useRef({
        paused: false,
        pause () {
            this.paused = true;
        },
        resume () {
            this.paused = false;
        }
    }).current;
    $acw62.useEffect(()=>{
        if (trapped) {
            let handleFocusIn2 = function(event) {
                if (focusScope.paused || !container) return;
                const target = event.target;
                if (isTargetInScope(target)) lastFocusedElementRef.current = target;
                else $03c48a27777929a8$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleFocusOut2 = function(event) {
                if (focusScope.paused || !container) return;
                const relatedTarget = event.relatedTarget;
                if (relatedTarget === null) return;
                if (!isTargetInScope(relatedTarget)) $03c48a27777929a8$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleMutations2 = function(mutations) {
                const focusedElement = document.activeElement;
                if (focusedElement !== document.body) return;
                for (const mutation of mutations)if (mutation.removedNodes.length > 0) $03c48a27777929a8$var$focus(container);
            };
            var handleFocusIn = handleFocusIn2, handleFocusOut = handleFocusOut2, handleMutations = handleMutations2;
            $03c48a27777929a8$var$__name(handleFocusIn2, "handleFocusIn");
            $03c48a27777929a8$var$__name(handleFocusOut2, "handleFocusOut");
            $03c48a27777929a8$var$__name(handleMutations2, "handleMutations");
            document.addEventListener("focusin", handleFocusIn2);
            document.addEventListener("focusout", handleFocusOut2);
            const mutationObserver = new MutationObserver(handleMutations2);
            if (container) mutationObserver.observe(container, {
                childList: true,
                subtree: true
            });
            return ()=>{
                document.removeEventListener("focusin", handleFocusIn2);
                document.removeEventListener("focusout", handleFocusOut2);
                mutationObserver.disconnect();
            };
        }
    }, [
        trapped,
        container,
        focusScope.paused,
        isTargetInScope
    ]);
    $acw62.useEffect(()=>{
        if (container) {
            $03c48a27777929a8$var$focusScopesStack.add(focusScope);
            const previouslyFocusedElement = document.activeElement;
            const hasFocusedCandidate = container.contains(previouslyFocusedElement);
            if (!hasFocusedCandidate) {
                const mountEvent = new CustomEvent($03c48a27777929a8$var$AUTOFOCUS_ON_MOUNT, $03c48a27777929a8$var$EVENT_OPTIONS);
                container.addEventListener($03c48a27777929a8$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                container.dispatchEvent(mountEvent);
                if (!mountEvent.defaultPrevented) {
                    $03c48a27777929a8$var$focusFirst($03c48a27777929a8$var$removeLinks($03c48a27777929a8$var$getTabbableCandidates(container)), {
                        select: true
                    });
                    if (document.activeElement === previouslyFocusedElement) $03c48a27777929a8$var$focus(container);
                }
            }
            return ()=>{
                container.removeEventListener($03c48a27777929a8$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                const ownerDocument = container.ownerDocument;
                const UnmountEvent = CustomEvent;
                setTimeout(()=>{
                    const unmountEvent = new UnmountEvent($03c48a27777929a8$var$AUTOFOCUS_ON_UNMOUNT, $03c48a27777929a8$var$EVENT_OPTIONS);
                    container.addEventListener($03c48a27777929a8$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    container.dispatchEvent(unmountEvent);
                    if (!unmountEvent.defaultPrevented) $03c48a27777929a8$var$focus(previouslyFocusedElement ?? ownerDocument.body, {
                        select: true
                    });
                    container.removeEventListener($03c48a27777929a8$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    $03c48a27777929a8$var$focusScopesStack.remove(focusScope);
                }, 0);
            };
        }
    }, [
        container,
        onMountAutoFocus,
        onUnmountAutoFocus,
        focusScope
    ]);
    const handleKeyDown = $acw62.useCallback((event)=>{
        if (!loop && !trapped) return;
        if (focusScope.paused) return;
        const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
        const focusedElement = document.activeElement;
        if (isTabKey && focusedElement) {
            const container2 = event.currentTarget;
            const [first, last] = $03c48a27777929a8$var$getTabbableEdges(container2);
            const hasTabbableElementsInside = first && last;
            if (!hasTabbableElementsInside) {
                if (focusedElement === container2) event.preventDefault();
            } else {
                if (!event.shiftKey && focusedElement === last) {
                    event.preventDefault();
                    if (loop) $03c48a27777929a8$var$focus(first, {
                        select: true
                    });
                } else if (event.shiftKey && focusedElement === first) {
                    event.preventDefault();
                    if (loop) $03c48a27777929a8$var$focus(last, {
                        select: true
                    });
                }
            }
        }
    }, [
        loop,
        trapped,
        focusScope.paused
    ]);
    return /* @__PURE__ */ (0, $ayMG0.jsx)((0, $kFbxc.Primitive).div, {
        tabIndex: -1,
        ...scopeProps,
        ref: composedRefs,
        onKeyDown: handleKeyDown
    });
}, "FocusScope"));
var $03c48a27777929a8$var$FocusScopeBranchContext = $acw62.createContext(null);
function $03c48a27777929a8$export$8c6311edc7a51a87({ registry: registry, children: children }) {
    if (!registry) return children;
    return /* @__PURE__ */ (0, $ayMG0.jsx)($03c48a27777929a8$var$FocusScopeBranchContext.Provider, {
        value: registry,
        children: children
    });
}
$03c48a27777929a8$var$__name($03c48a27777929a8$export$8c6311edc7a51a87, "FocusScopeBranchProvider");
function $03c48a27777929a8$export$cf83b8875a7b68e0() {
    const [nodes, setNodes] = $acw62.useState([]);
    const registry = $acw62.useMemo(()=>({
            add: /* @__PURE__ */ $03c48a27777929a8$var$__name((node)=>setNodes((prev)=>prev.includes(node) ? prev : [
                        ...prev,
                        node
                    ]), "add"),
            remove: /* @__PURE__ */ $03c48a27777929a8$var$__name((node)=>setNodes((prev)=>prev.filter((current)=>current !== node)), "remove")
        }), []);
    return {
        nodes: nodes,
        registry: registry
    };
}
$03c48a27777929a8$var$__name($03c48a27777929a8$export$cf83b8875a7b68e0, "useFocusScopeBranchRegistry");
function $03c48a27777929a8$export$48f5f90616c41047(node) {
    const registry = $acw62.useContext($03c48a27777929a8$var$FocusScopeBranchContext);
    $acw62.useEffect(()=>{
        if (!node || !registry) return;
        registry.add(node);
        return ()=>registry.remove(node);
    }, [
        node,
        registry
    ]);
}
$03c48a27777929a8$var$__name($03c48a27777929a8$export$48f5f90616c41047, "useFocusScopeBranch");
function $03c48a27777929a8$var$focusFirst(candidates, { select: select = false } = {}) {
    const previouslyFocusedElement = document.activeElement;
    for (const candidate of candidates){
        $03c48a27777929a8$var$focus(candidate, {
            select: select
        });
        if (document.activeElement !== previouslyFocusedElement) return;
    }
}
$03c48a27777929a8$var$__name($03c48a27777929a8$var$focusFirst, "focusFirst");
function $03c48a27777929a8$var$getTabbableEdges(container) {
    const candidates = $03c48a27777929a8$var$getTabbableCandidates(container);
    const first = $03c48a27777929a8$var$findVisible(candidates, container);
    const last = $03c48a27777929a8$var$findVisible(candidates.reverse(), container);
    return [
        first,
        last
    ];
}
$03c48a27777929a8$var$__name($03c48a27777929a8$var$getTabbableEdges, "getTabbableEdges");
function $03c48a27777929a8$var$getTabbableCandidates(container) {
    const nodes = [];
    const document2 = container.ownerDocument;
    const walker = document2.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: /* @__PURE__ */ $03c48a27777929a8$var$__name((node)=>{
            const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP;
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }, "acceptNode")
    });
    while(walker.nextNode())nodes.push(walker.currentNode);
    return nodes;
}
$03c48a27777929a8$var$__name($03c48a27777929a8$var$getTabbableCandidates, "getTabbableCandidates");
function $03c48a27777929a8$var$findVisible(elements, container) {
    const canUseCheckVisibility = typeof container.checkVisibility === "function" && container.checkVisibility({
        checkVisibilityCSS: true
    });
    for (const element of elements){
        const hidden = canUseCheckVisibility ? !element.checkVisibility({
            checkVisibilityCSS: true
        }) : $03c48a27777929a8$var$isHidden(element, {
            upTo: container
        });
        if (!hidden) return element;
    }
}
$03c48a27777929a8$var$__name($03c48a27777929a8$var$findVisible, "findVisible");
function $03c48a27777929a8$var$isHidden(node, { upTo: upTo }) {
    if (getComputedStyle(node).visibility === "hidden") return true;
    while(node){
        if (upTo !== void 0 && node === upTo) return false;
        if (getComputedStyle(node).display === "none") return true;
        node = node.parentElement;
    }
    return false;
}
$03c48a27777929a8$var$__name($03c48a27777929a8$var$isHidden, "isHidden");
function $03c48a27777929a8$var$isSelectableInput(element) {
    return element.tagName === "INPUT" && typeof element.select === "function";
}
$03c48a27777929a8$var$__name($03c48a27777929a8$var$isSelectableInput, "isSelectableInput");
function $03c48a27777929a8$var$focus(element, { select: select = false } = {}) {
    if (element && element.focus) {
        const ownerDocument = element.ownerDocument ?? document;
        const previouslyFocusedElement = ownerDocument.activeElement;
        element.focus({
            preventScroll: true
        });
        if (element !== previouslyFocusedElement && $03c48a27777929a8$var$isSelectableInput(element) && select) element.select();
    }
}
$03c48a27777929a8$var$__name($03c48a27777929a8$var$focus, "focus");
var $03c48a27777929a8$var$focusScopesStack = $03c48a27777929a8$var$createFocusScopesStack();
function $03c48a27777929a8$var$createFocusScopesStack() {
    let stack = [];
    return {
        add (focusScope) {
            const activeFocusScope = stack[0];
            if (focusScope !== activeFocusScope) activeFocusScope?.pause();
            stack = $03c48a27777929a8$var$arrayRemove(stack, focusScope);
            stack.unshift(focusScope);
        },
        remove (focusScope) {
            stack = $03c48a27777929a8$var$arrayRemove(stack, focusScope);
            stack[0]?.resume();
        }
    };
}
$03c48a27777929a8$var$__name($03c48a27777929a8$var$createFocusScopesStack, "createFocusScopesStack");
function $03c48a27777929a8$var$arrayRemove(array, item) {
    const updatedArray = [
        ...array
    ];
    const index = updatedArray.indexOf(item);
    if (index !== -1) updatedArray.splice(index, 1);
    return updatedArray;
}
$03c48a27777929a8$var$__name($03c48a27777929a8$var$arrayRemove, "arrayRemove");
function $03c48a27777929a8$var$removeLinks(items) {
    return items.filter((item)=>item.tagName !== "A");
}
$03c48a27777929a8$var$__name($03c48a27777929a8$var$removeLinks, "removeLinks");

});

parcelRegister("5nYva", function(module, exports) {

$parcel$export(module.exports, "Portal", () => $95d053caea9c023a$export$602eac185826482c);

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $kFbxc = parcelRequire("kFbxc");

var $7g00o = parcelRequire("7g00o");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $95d053caea9c023a$var$__defProp = Object.defineProperty;
var $95d053caea9c023a$var$__name = (target, value)=>$95d053caea9c023a$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $95d053caea9c023a$export$602eac185826482c = /* @__PURE__ */ $acw62.forwardRef(/* @__PURE__ */ $95d053caea9c023a$var$__name(function Portal2(props, forwardedRef) {
    const { container: containerProp, ...portalProps } = props;
    const [mounted, setMounted] = $acw62.useState(false);
    (0, $7g00o.useLayoutEffect)(()=>setMounted(true), []);
    const container = containerProp || mounted && globalThis?.document?.body;
    return container ? $1u0KT.createPortal(/* @__PURE__ */ (0, $ayMG0.jsx)((0, $kFbxc.Primitive).div, {
        ...portalProps,
        ref: forwardedRef
    }), container) : null;
}, "Portal"));

});

parcelRegister("fg1c6", function(module, exports) {

$parcel$export(module.exports, "useFocusGuards", () => $264faec0fdf8876a$export$b7ece24a22aeda8c);

var $acw62 = parcelRequire("acw62");
"use client";
var $264faec0fdf8876a$var$__defProp = Object.defineProperty;
var $264faec0fdf8876a$var$__name = (target, value)=>$264faec0fdf8876a$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $264faec0fdf8876a$var$count = 0;
var $264faec0fdf8876a$var$guards = null;
function $264faec0fdf8876a$export$ac5b58043b79449b(props) {
    $264faec0fdf8876a$export$b7ece24a22aeda8c();
    return props.children;
}
$264faec0fdf8876a$var$__name($264faec0fdf8876a$export$ac5b58043b79449b, "FocusGuards");
function $264faec0fdf8876a$export$b7ece24a22aeda8c() {
    $acw62.useEffect(()=>{
        if (!$264faec0fdf8876a$var$guards) $264faec0fdf8876a$var$guards = {
            start: $264faec0fdf8876a$var$createFocusGuard(),
            end: $264faec0fdf8876a$var$createFocusGuard()
        };
        const { start: start, end: end } = $264faec0fdf8876a$var$guards;
        if (document.body.firstElementChild !== start) document.body.insertAdjacentElement("afterbegin", start);
        if (document.body.lastElementChild !== end) document.body.insertAdjacentElement("beforeend", end);
        $264faec0fdf8876a$var$count++;
        return ()=>{
            if ($264faec0fdf8876a$var$count === 1) {
                $264faec0fdf8876a$var$guards?.start.remove();
                $264faec0fdf8876a$var$guards?.end.remove();
                $264faec0fdf8876a$var$guards = null;
            }
            $264faec0fdf8876a$var$count = Math.max(0, $264faec0fdf8876a$var$count - 1);
        };
    }, []);
}
$264faec0fdf8876a$var$__name($264faec0fdf8876a$export$b7ece24a22aeda8c, "useFocusGuards");
function $264faec0fdf8876a$var$createFocusGuard() {
    const element = document.createElement("span");
    element.setAttribute("data-radix-focus-guard", "");
    element.tabIndex = 0;
    element.style.outline = "none";
    element.style.opacity = "0";
    element.style.position = "fixed";
    element.style.pointerEvents = "none";
    return element;
}
$264faec0fdf8876a$var$__name($264faec0fdf8876a$var$createFocusGuard, "createFocusGuard");

});

parcelRegister("hPyeV", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfb1c25e3ef3d3bc$export$2e2bcd8739ae039);

var $7WQrb = parcelRequire("7WQrb");

var $acw62 = parcelRequire("acw62");

var $hphuJ = parcelRequire("hphuJ");

var $1fmze = parcelRequire("1fmze");
var $cfb1c25e3ef3d3bc$var$ReactRemoveScroll = $acw62.forwardRef(function(props, ref) {
    return $acw62.createElement((0, $hphuJ.RemoveScroll), (0, $7WQrb.__assign)({}, props, {
        ref: ref,
        sideCar: (0, $1fmze.default)
    }));
});
$cfb1c25e3ef3d3bc$var$ReactRemoveScroll.classNames = (0, $hphuJ.RemoveScroll).classNames;
var $cfb1c25e3ef3d3bc$export$2e2bcd8739ae039 = $cfb1c25e3ef3d3bc$var$ReactRemoveScroll;

});
parcelRegister("7WQrb", function(module, exports) {

$parcel$export(module.exports, "__assign", () => $5c96a02c592fcff1$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $5c96a02c592fcff1$export$3c9a16f847548506);
$parcel$export(module.exports, "__spreadArray", () => $5c96a02c592fcff1$export$1216008129fb82ed);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $5c96a02c592fcff1$var$ownKeys = function(o) {
    $5c96a02c592fcff1$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $5c96a02c592fcff1$var$ownKeys(o);
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $5c96a02c592fcff1$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $5c96a02c592fcff1$export$889dfb5d17574b0b(path, preserveJsx, extraExtensions, ignoreCase) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) {
        if (extraExtensions) for(var extension in extraExtensions){
            var suffix = path.slice(-extension.length);
            if (suffix === extension || ignoreCase && suffix.toLowerCase() === extension.toLowerCase()) {
                var output = extraExtensions[extension];
                return output === extension ? path : path.slice(0, -extension.length) + output;
            }
        }
        return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
            return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
        });
    }
    return path;
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __esDecorate: $5c96a02c592fcff1$export$3a84e1ae4e97e9b0,
    __runInitializers: $5c96a02c592fcff1$export$d831c04e792af3d,
    __propKey: $5c96a02c592fcff1$export$6a2a36740a146cb8,
    __setFunctionName: $5c96a02c592fcff1$export$d1a06452d3489bc7,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $5c96a02c592fcff1$export$889dfb5d17574b0b
};

});

parcelRegister("hphuJ", function(module, exports) {

$parcel$export(module.exports, "RemoveScroll", () => $cac2578984d345ac$export$22940b497e769dee);

var $7WQrb = parcelRequire("7WQrb");

var $acw62 = parcelRequire("acw62");

var $5shKQ = parcelRequire("5shKQ");

var $2DGpc = parcelRequire("2DGpc");

var $lbTxE = parcelRequire("lbTxE");
var $cac2578984d345ac$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $cac2578984d345ac$export$22940b497e769dee = $acw62.forwardRef(function(props, parentRef) {
    var ref = $acw62.useRef(null);
    var _a = $acw62.useState({
        onScrollCapture: $cac2578984d345ac$var$nothing,
        onWheelCapture: $cac2578984d345ac$var$nothing,
        onTouchMoveCapture: $cac2578984d345ac$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noRelative = props.noRelative, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? 'div' : _b, gapMode = props.gapMode, rest = (0, $7WQrb.__rest)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noRelative",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as",
        "gapMode"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $2DGpc.useMergeRefs)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, rest), callbacks);
    return $acw62.createElement($acw62.Fragment, null, enabled && $acw62.createElement(SideCar, {
        sideCar: (0, $lbTxE.effectCar),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noRelative: noRelative,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref,
        gapMode: gapMode
    }), forwardProps ? $acw62.cloneElement($acw62.Children.only(children), (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, containerProps), {
        ref: containerRef
    })) : $acw62.createElement(Container, (0, $7WQrb.__assign)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$cac2578984d345ac$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$cac2578984d345ac$export$22940b497e769dee.classNames = {
    fullWidth: (0, $5shKQ.fullWidthClassName),
    zeroRight: (0, $5shKQ.zeroRightClassName)
};

});
parcelRegister("5shKQ", function(module, exports) {

$parcel$export(module.exports, "zeroRightClassName", () => $3f8d56f1a38c65c8$export$1da7500147d4bc3);
$parcel$export(module.exports, "fullWidthClassName", () => $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e);
$parcel$export(module.exports, "noScrollbarsClassName", () => $3f8d56f1a38c65c8$export$bb813dfbbc432abc);
$parcel$export(module.exports, "removedBarSizeVariable", () => $3f8d56f1a38c65c8$export$63d0edf80fea83b1);
var $3f8d56f1a38c65c8$export$1da7500147d4bc3 = 'right-scroll-bar-position';
var $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e = 'width-before-scroll-bar';
var $3f8d56f1a38c65c8$export$bb813dfbbc432abc = 'with-scroll-bars-hidden';
var $3f8d56f1a38c65c8$export$63d0edf80fea83b1 = '--removed-body-scroll-bar-size';

});

parcelRegister("2DGpc", function(module, exports) {

$parcel$export(module.exports, "useMergeRefs", () => $1ec01e2201501f3d$export$74665b213cb5c4cf);

var $acw62 = parcelRequire("acw62");

var $dtd3m = parcelRequire("dtd3m");

var $uclLN = parcelRequire("uclLN");
var $1ec01e2201501f3d$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? $acw62.useLayoutEffect : $acw62.useEffect;
var $1ec01e2201501f3d$var$currentValues = new WeakMap();
function $1ec01e2201501f3d$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $uclLN.useCallbackRef)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $dtd3m.assignRef)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $1ec01e2201501f3d$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $1ec01e2201501f3d$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $dtd3m.assignRef)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $dtd3m.assignRef)(ref, current_1);
            });
        }
        $1ec01e2201501f3d$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}

});
parcelRegister("dtd3m", function(module, exports) {

$parcel$export(module.exports, "assignRef", () => $9ce81be4473c2c96$export$d734136a7b018efe);
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $9ce81be4473c2c96$export$d734136a7b018efe(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
    return ref;
}

});

parcelRegister("uclLN", function(module, exports) {

$parcel$export(module.exports, "useCallbackRef", () => $05ac61ef45da8ec5$export$25bec8c6f54ee79a);

var $acw62 = parcelRequire("acw62");
function $05ac61ef45da8ec5$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $acw62.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

});


parcelRegister("lbTxE", function(module, exports) {

$parcel$export(module.exports, "effectCar", () => $f6d5b57f3512e73c$export$e27363444bedfeac);

var $iXQwi = parcelRequire("iXQwi");
var $f6d5b57f3512e73c$export$e27363444bedfeac = (0, $iXQwi.createSidecarMedium)();

});
parcelRegister("iXQwi", function(module, exports) {

$parcel$export(module.exports, "createSidecarMedium", () => $dce67a1050af61cf$export$e13ec7dd7a14088d);

var $7WQrb = parcelRequire("7WQrb");
function $dce67a1050af61cf$var$ItoI(a) {
    return a;
}
function $dce67a1050af61cf$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $dce67a1050af61cf$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $dce67a1050af61cf$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $dce67a1050af61cf$var$ItoI;
    return $dce67a1050af61cf$var$innerCreateMedium(defaults, middleware);
}
function $dce67a1050af61cf$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $dce67a1050af61cf$var$innerCreateMedium(null);
    medium.options = (0, $7WQrb.__assign)({
        async: true,
        ssr: false
    }, options);
    return medium;
}

});



parcelRegister("1fmze", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e88b28988758ab2$export$2e2bcd8739ae039);

var $hcGtC = parcelRequire("hcGtC");

var $l793C = parcelRequire("l793C");

var $lbTxE = parcelRequire("lbTxE");
var $0e88b28988758ab2$export$2e2bcd8739ae039 = (0, $hcGtC.exportSidecar)((0, $lbTxE.effectCar), (0, $l793C.RemoveScrollSideCar));

});
parcelRegister("hcGtC", function(module, exports) {

$parcel$export(module.exports, "exportSidecar", () => $c86481a7b0dfcc68$export$6cacc8fb0a9b94ce);

var $7WQrb = parcelRequire("7WQrb");

var $acw62 = parcelRequire("acw62");
var $c86481a7b0dfcc68$var$SideCar = function(_a) {
    var sideCar = _a.sideCar, rest = (0, $7WQrb.__rest)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error('Sidecar: please provide `sideCar` property to import the right car');
    var Target = sideCar.read();
    if (!Target) throw new Error('Sidecar medium not found');
    return $acw62.createElement(Target, (0, $7WQrb.__assign)({}, rest));
};
$c86481a7b0dfcc68$var$SideCar.isSideCarExport = true;
function $c86481a7b0dfcc68$export$6cacc8fb0a9b94ce(medium, exported) {
    medium.useMedium(exported);
    return $c86481a7b0dfcc68$var$SideCar;
}

});

parcelRegister("l793C", function(module, exports) {

$parcel$export(module.exports, "RemoveScrollSideCar", () => $f5f147098910888d$export$a09dbff87b5da2d);

var $7WQrb = parcelRequire("7WQrb");

var $acw62 = parcelRequire("acw62");
parcelRequire("bFkre");
var $dFfX5 = parcelRequire("dFfX5");
parcelRequire("i39OQ");
var $kc8mv = parcelRequire("kc8mv");

var $9x4sU = parcelRequire("9x4sU");

var $epYFP = parcelRequire("epYFP");
var $f5f147098910888d$export$6e085704a79f4f56 = function(event) {
    return 'changedTouches' in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $f5f147098910888d$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $f5f147098910888d$var$extractRef = function(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};
var $f5f147098910888d$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $f5f147098910888d$var$generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $f5f147098910888d$var$idCounter = 0;
var $f5f147098910888d$var$lockStack = [];
function $f5f147098910888d$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $acw62.useRef([]);
    var touchStartRef = $acw62.useRef([
        0,
        0
    ]);
    var activeAxis = $acw62.useRef();
    var id = $acw62.useState($f5f147098910888d$var$idCounter++)[0];
    var Style = $acw62.useState((0, $kc8mv.styleSingleton))[0];
    var lastProps = $acw62.useRef(props);
    $acw62.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $acw62.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $7WQrb.__spreadArray)([
                props.lockRef.current
            ], (props.shards || []).map($f5f147098910888d$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $acw62.useCallback(function(event, parent) {
        if ('touches' in event && event.touches.length === 2 || event.type === 'wheel' && event.ctrlKey) return !lastProps.current.allowPinchZoom;
        var touch = $f5f147098910888d$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = 'deltaX' in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = 'deltaY' in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? 'h' : 'v';
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ('touches' in event && moveDirection === 'h' && target.type === 'range') return false;
        // allow drag selection (iOS); check if selection's anchorNode is the same as target or contains target
        var selection = window.getSelection();
        var anchorNode = selection && selection.anchorNode;
        var isTouchingSelection = anchorNode ? anchorNode === target || anchorNode.contains(target) : false;
        if (isTouchingSelection) return false;
        var canBeScrolledInMainDirection = (0, $epYFP.locationCouldBeScrolled)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === 'v' ? 'h' : 'v';
            canBeScrolledInMainDirection = (0, $epYFP.locationCouldBeScrolled)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && 'changedTouches' in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $epYFP.handleScroll)(cancelingAxis, parent, event, cancelingAxis === 'h' ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $acw62.useCallback(function(_event) {
        var event = _event;
        if (!$f5f147098910888d$var$lockStack.length || $f5f147098910888d$var$lockStack[$f5f147098910888d$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = 'deltaY' in event ? $f5f147098910888d$export$39efaa2ca254a28d(event) : $f5f147098910888d$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && (e.target === event.target || event.target === e.shadowParent) && $f5f147098910888d$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($f5f147098910888d$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = $acw62.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should,
            shadowParent: $f5f147098910888d$var$getOutermostShadowParent(target)
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $acw62.useCallback(function(event) {
        touchStartRef.current = $f5f147098910888d$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $acw62.useCallback(function(event) {
        shouldCancel(event.type, $f5f147098910888d$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $acw62.useCallback(function(event) {
        shouldCancel(event.type, $f5f147098910888d$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $acw62.useEffect(function() {
        $f5f147098910888d$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener('wheel', shouldPrevent, (0, $9x4sU.nonPassive));
        document.addEventListener('touchmove', shouldPrevent, (0, $9x4sU.nonPassive));
        document.addEventListener('touchstart', scrollTouchStart, (0, $9x4sU.nonPassive));
        return function() {
            $f5f147098910888d$var$lockStack = $f5f147098910888d$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener('wheel', shouldPrevent, (0, $9x4sU.nonPassive));
            document.removeEventListener('touchmove', shouldPrevent, (0, $9x4sU.nonPassive));
            document.removeEventListener('touchstart', scrollTouchStart, (0, $9x4sU.nonPassive));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $acw62.createElement($acw62.Fragment, null, inert ? $acw62.createElement(Style, {
        styles: $f5f147098910888d$var$generateStyle(id)
    }) : null, removeScrollBar ? $acw62.createElement((0, $dFfX5.RemoveScrollBar), {
        noRelative: props.noRelative,
        gapMode: props.gapMode
    }) : null);
}
function $f5f147098910888d$var$getOutermostShadowParent(node) {
    var shadowParent = null;
    while(node !== null){
        if (node instanceof ShadowRoot) {
            shadowParent = node.host;
            node = node.host;
        }
        node = node.parentNode;
    }
    return shadowParent;
}

});
parcelRegister("bFkre", function(module, exports) {

$parcel$export(module.exports, "RemoveScrollBar", () => (parcelRequire("dFfX5")).RemoveScrollBar);

var $dFfX5 = parcelRequire("dFfX5");

var $5shKQ = parcelRequire("5shKQ");

var $2ddNe = parcelRequire("2ddNe");

});
parcelRegister("dFfX5", function(module, exports) {

$parcel$export(module.exports, "RemoveScrollBar", () => $9f2b7a700f678519$export$9aa43b459c5ae9b9);

var $acw62 = parcelRequire("acw62");
parcelRequire("i39OQ");
var $kc8mv = parcelRequire("kc8mv");

var $5shKQ = parcelRequire("5shKQ");

var $2ddNe = parcelRequire("2ddNe");
var $9f2b7a700f678519$var$Style = (0, $kc8mv.styleSingleton)();
var $9f2b7a700f678519$export$65254d5f26cb9564 = 'data-scroll-locked';
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var $9f2b7a700f678519$var$getStyles = function(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = 'margin';
    return "\n  .".concat((0, $5shKQ.noScrollbarsClassName), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat($9f2b7a700f678519$export$65254d5f26cb9564, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === 'margin' && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === 'padding' && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(''), "\n  }\n  \n  .").concat((0, $5shKQ.zeroRightClassName), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $5shKQ.fullWidthClassName), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $5shKQ.zeroRightClassName), " .").concat((0, $5shKQ.zeroRightClassName), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, $5shKQ.fullWidthClassName), " .").concat((0, $5shKQ.fullWidthClassName), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat($9f2b7a700f678519$export$65254d5f26cb9564, "] {\n    ").concat((0, $5shKQ.removedBarSizeVariable), ": ").concat(gap, "px;\n  }\n");
};
var $9f2b7a700f678519$var$getCurrentUseCounter = function() {
    var counter = parseInt(document.body.getAttribute($9f2b7a700f678519$export$65254d5f26cb9564) || '0', 10);
    return isFinite(counter) ? counter : 0;
};
var $9f2b7a700f678519$export$a1939b1f9f9b02dc = function() {
    $acw62.useEffect(function() {
        document.body.setAttribute($9f2b7a700f678519$export$65254d5f26cb9564, ($9f2b7a700f678519$var$getCurrentUseCounter() + 1).toString());
        return function() {
            var newCounter = $9f2b7a700f678519$var$getCurrentUseCounter() - 1;
            if (newCounter <= 0) document.body.removeAttribute($9f2b7a700f678519$export$65254d5f26cb9564);
            else document.body.setAttribute($9f2b7a700f678519$export$65254d5f26cb9564, newCounter.toString());
        };
    }, []);
};
var $9f2b7a700f678519$export$9aa43b459c5ae9b9 = function(_a) {
    var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? 'margin' : _b;
    $9f2b7a700f678519$export$a1939b1f9f9b02dc();
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = $acw62.useMemo(function() {
        return (0, $2ddNe.getGapWidth)(gapMode);
    }, [
        gapMode
    ]);
    return $acw62.createElement($9f2b7a700f678519$var$Style, {
        styles: $9f2b7a700f678519$var$getStyles(gap, !noRelative, gapMode, !noImportant ? '!important' : '')
    });
};

});
parcelRegister("i39OQ", function(module, exports) {

$parcel$export(module.exports, "styleSingleton", () => (parcelRequire("kc8mv")).styleSingleton);

var $kc8mv = parcelRequire("kc8mv");

var $gjYQD = parcelRequire("gjYQD");

var $fCBo2 = parcelRequire("fCBo2");

});
parcelRegister("kc8mv", function(module, exports) {

$parcel$export(module.exports, "styleSingleton", () => $eb3b6a23a33fb1ba$export$c1248ee86ba532c8);

var $fCBo2 = parcelRequire("fCBo2");
var $eb3b6a23a33fb1ba$export$c1248ee86ba532c8 = function() {
    var useStyle = (0, $fCBo2.styleHookSingleton)();
    var Sheet = function(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};

});
parcelRegister("fCBo2", function(module, exports) {

$parcel$export(module.exports, "styleHookSingleton", () => $b5f767dd03f483e5$export$7d7b35c2d250e94c);

var $acw62 = parcelRequire("acw62");

var $gjYQD = parcelRequire("gjYQD");
var $b5f767dd03f483e5$export$7d7b35c2d250e94c = function() {
    var sheet = (0, $gjYQD.stylesheetSingleton)();
    return function(styles, isDynamic) {
        $acw62.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};

});
parcelRegister("gjYQD", function(module, exports) {

$parcel$export(module.exports, "stylesheetSingleton", () => $be1d9ed5bb532264$export$7c74eec858d5d226);

var $1EetQ = parcelRequire("1EetQ");
function $be1d9ed5bb532264$var$makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    var nonce = (0, $1EetQ.getNonce)();
    if (nonce) tag.setAttribute('nonce', nonce);
    return tag;
}
function $be1d9ed5bb532264$var$injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $be1d9ed5bb532264$var$insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}
var $be1d9ed5bb532264$export$7c74eec858d5d226 = function() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function(style) {
            if (counter == 0) {
                if (stylesheet = $be1d9ed5bb532264$var$makeStyleTag()) {
                    $be1d9ed5bb532264$var$injectStyles(stylesheet, style);
                    $be1d9ed5bb532264$var$insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};

});
parcelRegister("1EetQ", function(module, exports) {

$parcel$export(module.exports, "getNonce", () => $1334c25f36aeceaf$export$2b85b721e524d74b);
var $1334c25f36aeceaf$var$currentNonce;
var $1334c25f36aeceaf$export$c5f670b24c0ae95a = function(nonce) {
    $1334c25f36aeceaf$var$currentNonce = nonce;
};
var $1334c25f36aeceaf$export$2b85b721e524d74b = function() {
    if ($1334c25f36aeceaf$var$currentNonce) return $1334c25f36aeceaf$var$currentNonce;
    if (typeof __webpack_nonce__ !== 'undefined') return __webpack_nonce__;
    return undefined;
};

});





parcelRegister("2ddNe", function(module, exports) {

$parcel$export(module.exports, "getGapWidth", () => $19c77eb414ad2a19$export$75f2ca8f029c77f4);
var $19c77eb414ad2a19$export$efed13b5d0ca3386 = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var $19c77eb414ad2a19$var$parse = function(x) {
    return parseInt(x || '', 10) || 0;
};
var $19c77eb414ad2a19$var$getOffset = function(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === 'padding' ? 'paddingLeft' : 'marginLeft'];
    var top = cs[gapMode === 'padding' ? 'paddingTop' : 'marginTop'];
    var right = cs[gapMode === 'padding' ? 'paddingRight' : 'marginRight'];
    return [
        $19c77eb414ad2a19$var$parse(left),
        $19c77eb414ad2a19$var$parse(top),
        $19c77eb414ad2a19$var$parse(right)
    ];
};
var $19c77eb414ad2a19$export$75f2ca8f029c77f4 = function(gapMode) {
    if (gapMode === void 0) gapMode = 'margin';
    if (typeof window === 'undefined') return $19c77eb414ad2a19$export$efed13b5d0ca3386;
    var offsets = $19c77eb414ad2a19$var$getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};

});



parcelRegister("9x4sU", function(module, exports) {

$parcel$export(module.exports, "nonPassive", () => $6f0aa8d921410141$export$10a6e88623fa9454);
var $6f0aa8d921410141$var$passiveSupported = false;
if (typeof window !== 'undefined') try {
    var $6f0aa8d921410141$var$options = Object.defineProperty({}, 'passive', {
        get: function() {
            $6f0aa8d921410141$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener('test', $6f0aa8d921410141$var$options, $6f0aa8d921410141$var$options);
    // @ts-ignore
    window.removeEventListener('test', $6f0aa8d921410141$var$options, $6f0aa8d921410141$var$options);
} catch (err) {
    $6f0aa8d921410141$var$passiveSupported = false;
}
var $6f0aa8d921410141$export$10a6e88623fa9454 = $6f0aa8d921410141$var$passiveSupported ? {
    passive: false
} : false;

});

parcelRegister("epYFP", function(module, exports) {

$parcel$export(module.exports, "locationCouldBeScrolled", () => $a7f277057d6643d0$export$9ec64480cae49817);
$parcel$export(module.exports, "handleScroll", () => $a7f277057d6643d0$export$dde0441bd4a6ded8);
var $a7f277057d6643d0$var$alwaysContainsScroll = function(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === 'TEXTAREA';
};
var $a7f277057d6643d0$var$elementCanBeScrolled = function(node, overflow) {
    if (!(node instanceof Element)) return false;
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== 'hidden' && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !$a7f277057d6643d0$var$alwaysContainsScroll(node) && styles[overflow] === 'visible'));
};
var $a7f277057d6643d0$var$elementCouldBeVScrolled = function(node) {
    return $a7f277057d6643d0$var$elementCanBeScrolled(node, 'overflowY');
};
var $a7f277057d6643d0$var$elementCouldBeHScrolled = function(node) {
    return $a7f277057d6643d0$var$elementCanBeScrolled(node, 'overflowX');
};
var $a7f277057d6643d0$export$9ec64480cae49817 = function(axis, node) {
    var ownerDocument = node.ownerDocument;
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== 'undefined' && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $a7f277057d6643d0$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $a7f277057d6643d0$var$getScrollVariables(axis, current), scrollHeight = _a[1], clientHeight = _a[2];
            if (scrollHeight > clientHeight) return true;
        }
        current = current.parentNode;
    }while (current && current !== ownerDocument.body);
    return false;
};
var $a7f277057d6643d0$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $a7f277057d6643d0$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $a7f277057d6643d0$var$elementCouldBeScrolled = function(axis, node) {
    return axis === 'v' ? $a7f277057d6643d0$var$elementCouldBeVScrolled(node) : $a7f277057d6643d0$var$elementCouldBeHScrolled(node);
};
var $a7f277057d6643d0$var$getScrollVariables = function(axis, node) {
    return axis === 'v' ? $a7f277057d6643d0$var$getVScrollVariables(node) : $a7f277057d6643d0$var$getHScrollVariables(node);
};
var $a7f277057d6643d0$var$getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === 'h' && direction === 'rtl' ? -1 : 1;
};
var $a7f277057d6643d0$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $a7f277057d6643d0$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        if (!target) break;
        var _a = $a7f277057d6643d0$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($a7f277057d6643d0$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        var parent_1 = target.parentNode;
        // we will "bubble" from ShadowDom in case we are, or just to the parent in normal case
        // this is the same logic used in focus-lock
        target = parent_1 && parent_1.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? parent_1.host : parent_1;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    // handle epsilon around 0 (non standard zoom levels)
    if (isDeltaPositive && (noOverscroll && Math.abs(availableScroll) < 1 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && Math.abs(availableScrollTop) < 1 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};

});




parcelRegister("6okVC", function(module, exports) {

$parcel$export(module.exports, "hideOthers", () => $4a7537e072260c10$export$6e33d16126ed003c);
var $4a7537e072260c10$var$getDefaultParent = function(originalTarget) {
    if (typeof document === 'undefined') return null;
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var $4a7537e072260c10$var$counterMap = new WeakMap();
var $4a7537e072260c10$var$uncontrolledNodes = new WeakMap();
var $4a7537e072260c10$var$markerMap = {};
var $4a7537e072260c10$var$lockCount = 0;
var $4a7537e072260c10$var$unwrapHost = function(node) {
    return node && (node.host || $4a7537e072260c10$var$unwrapHost(node.parentNode));
};
var $4a7537e072260c10$var$correctTargets = function(parent, targets) {
    return targets.map(function(target) {
        if (parent.contains(target)) return target;
        var correctedTarget = $4a7537e072260c10$var$unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) return correctedTarget;
        console.error('aria-hidden', target, 'in not contained inside', parent, '. Doing nothing');
        return null;
    }).filter(function(x) {
        return Boolean(x);
    });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */ var $4a7537e072260c10$var$applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
    var targets = $4a7537e072260c10$var$correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    if (!$4a7537e072260c10$var$markerMap[markerName]) $4a7537e072260c10$var$markerMap[markerName] = new WeakMap();
    var markerCounter = $4a7537e072260c10$var$markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        Array.prototype.forEach.call(parent.children, function(node) {
            if (elementsToKeep.has(node)) deep(node);
            else try {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== 'false';
                var counterValue = ($4a7537e072260c10$var$counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                $4a7537e072260c10$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) $4a7537e072260c10$var$uncontrolledNodes.set(node, true);
                if (markerValue === 1) node.setAttribute(markerName, 'true');
                if (!alreadyHidden) node.setAttribute(controlAttribute, 'true');
            } catch (e) {
                console.error('aria-hidden: cannot operate on ', node, e);
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    $4a7537e072260c10$var$lockCount++;
    return function() {
        hiddenNodes.forEach(function(node) {
            var counterValue = $4a7537e072260c10$var$counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            $4a7537e072260c10$var$counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!$4a7537e072260c10$var$uncontrolledNodes.has(node)) node.removeAttribute(controlAttribute);
                $4a7537e072260c10$var$uncontrolledNodes.delete(node);
            }
            if (!markerValue) node.removeAttribute(markerName);
        });
        $4a7537e072260c10$var$lockCount--;
        if (!$4a7537e072260c10$var$lockCount) {
            // clear
            $4a7537e072260c10$var$counterMap = new WeakMap();
            $4a7537e072260c10$var$counterMap = new WeakMap();
            $4a7537e072260c10$var$uncontrolledNodes = new WeakMap();
            $4a7537e072260c10$var$markerMap = {};
        }
    };
};
var $4a7537e072260c10$export$6e33d16126ed003c = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-aria-hidden';
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    var activeParentNode = parentNode || $4a7537e072260c10$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    // we should not hide aria-live elements - https://github.com/theKashey/aria-hidden/issues/10
    // and script elements, as they have no impact on accessibility.
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll('[aria-live], script')));
    return $4a7537e072260c10$var$applyAttributeToOthers(targets, activeParentNode, markerName, 'aria-hidden');
};
var $4a7537e072260c10$export$59151cc8db999a24 = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-inert-ed';
    var activeParentNode = parentNode || $4a7537e072260c10$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    return $4a7537e072260c10$var$applyAttributeToOthers(originalTarget, activeParentNode, markerName, 'inert');
};
var $4a7537e072260c10$export$cc95fea82d705fca = function() {
    return typeof HTMLElement !== 'undefined' && HTMLElement.prototype.hasOwnProperty('inert');
};
var $4a7537e072260c10$export$9845d4b6bdad192b = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-suppressed';
    return ($4a7537e072260c10$export$cc95fea82d705fca() ? $4a7537e072260c10$export$59151cc8db999a24 : $4a7537e072260c10$export$6e33d16126ed003c)(originalTarget, parentNode, markerName);
};

});



parcelRegister("beZBx", function(module, exports) {

$parcel$export(module.exports, "default", () => $49383ac93d397699$export$2e2bcd8739ae039);
$parcel$export(module.exports, "DrawerHeader", () => $49383ac93d397699$export$bb68d554ded258ea);
$parcel$export(module.exports, "DrawerBody", () => $49383ac93d397699$export$4ed8420cdfcb2b8f);
$parcel$export(module.exports, "DrawerFooter", () => $49383ac93d397699$export$d05a7d25ec5abf06);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
'use client';
function $49383ac93d397699$export$2e2bcd8739ae039({ open: open, onClose: onClose, width: width = 400, children: children }) {
    (0, $acw62.useEffect)(()=>{
        if (!open) return;
        const h = (e)=>{
            if (e.key === 'Escape') onClose();
        };
        document.addEventListener('keydown', h);
        return ()=>document.removeEventListener('keydown', h);
    }, [
        open,
        onClose
    ]);
    if (!open) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        onClick: onClose,
        style: {
            position: 'absolute',
            inset: 0,
            background: 'rgba(0,0,0,0.25)',
            zIndex: 10,
            backdropFilter: 'blur(1px)'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            // Docks at the inline-END — the side away from the shell's sidebar, so
            // a drawer never covers the navigation it was opened from (§5.2). This
            // was `left: 0`, the inline-end under `rtl` and the inline-START under
            // `ltr`, i.e. straight over an English layout's sidebar.
            position: 'absolute',
            top: 0,
            insetInlineEnd: 0,
            width: width,
            height: '100%',
            background: '#fff',
            // No x-offset: a signed offset points at a physical side, and this
            // panel sits on whichever side the reading direction puts the end on.
            boxShadow: '0 0 24px rgba(0,0,0,0.12)',
            zIndex: 11,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
        }
    }, children));
}
function $49383ac93d397699$export$bb68d554ded258ea({ title: title, sub: sub, onClose: onClose, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '18px 20px',
            borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '1rem',
            fontWeight: 700,
            color: (0, $jTCZr.C).textPrimary
        }
    }, title), sub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.75rem',
            color: (0, $jTCZr.C).textMuted,
            marginTop: 2
        }
    }, sub), children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: onClose,
        style: {
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontSize: '1.375rem',
            color: (0, $jTCZr.C).textMuted,
            lineHeight: 1,
            padding: '2px 6px'
        }
    }, "\xd7"));
}
function $49383ac93d397699$export$4ed8420cdfcb2b8f({ children: children, style: style }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            overflow: 'auto',
            padding: 20,
            ...style
        }
    }, children);
}
function $49383ac93d397699$export$d05a7d25ec5abf06({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '16px 20px',
            borderTop: `1px solid ${(0, $jTCZr.C).border}`,
            display: 'flex',
            gap: 8,
            flexShrink: 0
        }
    }, children);
}

});

parcelRegister("cZOyb", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfba7d02b5e7069f$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $jTCZr = parcelRequire("jTCZr");

var $drSko = parcelRequire("drSko");

var $9BgRG = parcelRequire("9BgRG");

var $j9AxR = parcelRequire("j9AxR");
'use client';
// ─────────────────────────────────────────────────────────────────────────────
// BottomSheet — mobile-first modal that slides up from the bottom edge.
// Replaces the duplicated ClinicModal implementations in the patient app and
// ad-hoc bottom sheets elsewhere. For desktop-centred dialogs use Dialog.
//
// It is the default overlay for a mobile task or filter set
// (DESIGN-CONCEPT-MOBILE §6); `ConfirmDialog` stays a centered dialog and sits
// ABOVE this one on the z-scale (DESIGN.md, Overlay layering).
//
// ── What makes it phone-grade (v0.10.0) ─────────────────────────────────────
// Every one of these was a defect a phone could reproduce and a desktop could
// not, and each was found in all three apps at once because they all render
// this component:
//
//   dvh, not vh        `85vh` is measured against the LARGEST viewport, so on
//                      iOS Safari with the address bar expanded the sheet was
//                      taller than the screen and its own footer sat under the
//                      toolbar. `100dvh` tracks the live viewport; the `vh`
//                      declaration stays as the fallback for browsers without
//                      it, behind an `@supports` upgrade.
//   the keyboard       `position: fixed` is blind to the software keyboard, so
//                      a focused field's submit button sat *under* the keys.
//                      The sheet sits INSIDE the visible box: the scrim pads by
//                      what the keyboard covers (bottom) and by what the browser
//                      panned past (top), and the ceiling comes down by the
//                      same amount so the sheet's top edge does not move.
//                      (v0.23.3, PM-0108) It used to only shrink its ceiling
//                      while keeping its bottom edge on the LAYOUT viewport —
//                      so on Android Chrome, which paints the keyboard over the
//                      layout viewport (`resizes-visual`), the lower part of
//                      every sheet, footer included, sat under the keys, and
//                      Chrome's attempt to reveal the field panned the visual
//                      viewport so the title bar and the field left through the
//                      top of the screen. The booking sheet on a phone was the
//                      report. Repro: the doctor client's
//                      `e2e/booking.keyboard.mobile.spec.js`.
//   back closes it     the platform back button used to navigate the route
//                      underneath an open sheet, leaving the sheet floating
//                      over a different screen. `useOverlayHistory` puts the
//                      sheet in the history stack (opt out with
//                      `historyIntegration={false}` for a desktop dialog).
//   focus stays in     a modal that leaks focus to the page behind it is not a
//                      modal. Focus moves in on open, Tab cycles inside, and
//                      the previously-focused element gets it back on close.
//   the page is still  without a scroll lock, scrolling past the sheet's end
//                      scrolls the screen behind it — on iOS the page then
//                      rubber-bands and the sheet appears to drift.
//   44px close         the ✕ was 30px, under the 2.75rem minimum (§6).
//   tokens             surfaces, scrim, radius and text now come from the token
//                      layer instead of five literal hexes.
//   rendered at body   (v0.11.4) `position: fixed` and a z-index only mean
//                      what they say inside the ROOT stacking context. A sheet
//                      mounted deep in a screen — inside the scroller of a tab,
//                      say — sat in whatever context its ancestors made: iOS
//                      WebKit composites an overflow scroller and traps fixed
//                      descendants in it, so the sheet was clipped to the
//                      scroller and the screen's own docked bar, later in the
//                      DOM, painted OVER it. Chromium does not do this, which
//                      is why a browser test could not see it. The sheet now
//                      portals to `document.body`, exactly as the kit `Dialog`
//                      does through Radix: where a sheet happens to be mounted
//                      is no longer something a screen has to get right.
//
// Props:
//   open / onClose
//   title      — optional heading
//   footer     — optional docked commit row. §6 says "submit docks bottom", and
//                the sheet's body is a scroll region, so a footer placed in
//                `children` scrolls away exactly when it is needed. This slot
//                sticks to the bottom edge, above the safe-area inset AND above
//                the software keyboard.
//   fullHeight — a tall form (a stepper, a long picker) takes the whole
//                available height instead of hugging its content, so the footer
//                sits at the bottom edge rather than halfway up the screen.
//   snap       — cap the sheet at a fraction of the viewport (0.2–1, default
//                0.85). `snap={1}` with `fullHeight` is a full-screen task.
//   dir        — writing direction. UNSET by default, so the sheet INHERITS the
//                document's. It used to hardcode `dir="rtl"`, which renders
//                backwards in an app that also ships `en`; the three RTL apps
//                set `dir="rtl"` on <html>, so inheriting is identical for them.
//   closeLabel — accessible name of the close button (default «بستن»)
//   maxWidth   — the sheet's cap on a wide viewport
//   historyIntegration — false to opt out of the back-button behaviour
//   portal     — false to render in place instead of at `document.body`. Only
//                for a consumer that deliberately scopes CSS custom properties
//                to a subtree and needs the sheet inside it; the default is the
//                one that is correct on a phone.
//   className / data-testid and any other prop are forwarded to the overlay.
//
// `dir` inherits from `<html>` after the portal, which is what it inherited
// before in every app that sets the direction where the I18N rule says to.
// ─────────────────────────────────────────────────────────────────────────────
// Everything focusable a sheet can realistically contain. `[hidden]` and
// `disabled` are excluded because Tab skips them anyway, and a trap that
// disagrees with the browser about the cycle is worse than no trap.
const $cfba7d02b5e7069f$var$FOCUSABLE = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
].join(',');
const $cfba7d02b5e7069f$var$PANEL_CLASS = 'parsina-sheet-panel';
// One stylesheet for every sheet on the page, not one per instance: the rules
// are identical and the per-sheet numbers arrive as custom properties.
const $cfba7d02b5e7069f$var$SHEET_CSS = `
  @keyframes parsina-sheet-fade{from{opacity:0}to{opacity:1}}
  @keyframes parsina-sheet-up{from{transform:translateY(24px);opacity:0}to{transform:translateY(0);opacity:1}}
  .${$cfba7d02b5e7069f$var$PANEL_CLASS}{max-height:var(--parsina-sheet-vh)}
  .${$cfba7d02b5e7069f$var$PANEL_CLASS}[data-full-height]{height:var(--parsina-sheet-vh)}
  /* The upgrade. Guarded because a custom property holding an unsupported unit
     is invalid at computed-value time, which would drop max-height entirely. */
  @supports (height: 100dvh){
    .${$cfba7d02b5e7069f$var$PANEL_CLASS}{max-height:var(--parsina-sheet-dvh)}
    .${$cfba7d02b5e7069f$var$PANEL_CLASS}[data-full-height]{height:var(--parsina-sheet-dvh)}
  }
  @media (prefers-reduced-motion: reduce){
    .${$cfba7d02b5e7069f$var$PANEL_CLASS}, .parsina-sheet-scrim{animation:none!important}
  }
`;
function $cfba7d02b5e7069f$export$2e2bcd8739ae039({ open: open, onClose: onClose, title: title, children: children, footer: footer, fullHeight: fullHeight = false, snap: snap = 0.85, dir: dir, closeLabel: closeLabel, maxWidth: maxWidth = 480, historyIntegration: historyIntegration = true, portal: portal = true, className: className, 'data-testid': testId, ...rest }) {
    if (closeLabel === undefined) closeLabel = (0, $j9AxR.kitCopy)().close;
    const panelRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const restoreFocusRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // The box the user can see, as insets of the layout viewport (PM-0108).
    const { top: panInset, bottom: keyboardInset } = (0, $drSko.default)();
    // Back / hardware-back closes the sheet and leaves the route alone.
    (0, $9BgRG.default)(open, onClose, {
        enabled: historyIntegration,
        id: testId || 'sheet'
    });
    // Escape + the focus trap. One listener for both: they are the same contract
    // — while this is open, the keyboard belongs to it.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return undefined;
        const onKey = (e)=>{
            if (e.key === 'Escape') {
                onClose?.();
                return;
            }
            if (e.key !== 'Tab') return;
            const panel = panelRef.current;
            if (!panel) return;
            const items = [
                ...panel.querySelectorAll($cfba7d02b5e7069f$var$FOCUSABLE)
            ].filter((el)=>el.offsetParent !== null);
            if (items.length === 0) {
                e.preventDefault();
                panel.focus();
                return;
            }
            const first = items[0];
            const last = items[items.length - 1];
            const active = document.activeElement;
            // Wrapping by hand is what keeps focus inside: the browser's own next
            // stop after `last` is the page behind the scrim.
            if (e.shiftKey && (active === first || !panel.contains(active))) {
                e.preventDefault();
                last.focus();
            } else if (!e.shiftKey && (active === last || !panel.contains(active))) {
                e.preventDefault();
                first.focus();
            }
        };
        document.addEventListener('keydown', onKey);
        return ()=>document.removeEventListener('keydown', onKey);
    }, [
        open,
        onClose
    ]);
    // Move focus in on open and hand it back on close. Without the hand-back, a
    // sheet opened from a list left focus on <body>, so the next Tab started from
    // the top of the page instead of from the control that opened it.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return undefined;
        restoreFocusRef.current = document.activeElement;
        // After paint, so the panel and its children exist to receive it.
        const raf = typeof requestAnimationFrame === 'function' ? requestAnimationFrame(()=>{
            const panel = panelRef.current;
            if (!panel) return;
            const firstField = panel.querySelector($cfba7d02b5e7069f$var$FOCUSABLE);
            (firstField || panel).focus?.({
                preventScroll: true
            });
        }) : null;
        return ()=>{
            if (raf !== null) cancelAnimationFrame(raf);
            const previous = restoreFocusRef.current;
            restoreFocusRef.current = null;
            if (previous && typeof previous.focus === 'function' && document.contains(previous)) previous.focus({
                preventScroll: true
            });
        };
    }, [
        open
    ]);
    // When the visible box changes under an open sheet — the keyboard arriving,
    // the browser panning — the sheet re-lays out, and the field being typed into
    // may now sit below the body's shrunken edge. Bring it back the way a finger
    // would. `nearest` scrolls only the sheet's own scroller: the panel is inside
    // the visible box by construction, so nothing outside it has to move.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open || panInset === 0 && keyboardInset === 0) return undefined;
        if (typeof requestAnimationFrame !== 'function') return undefined;
        const raf = requestAnimationFrame(()=>{
            const panel = panelRef.current;
            const active = typeof document === 'undefined' ? null : document.activeElement;
            if (!panel || !active || active === panel || !panel.contains(active)) return;
            if (typeof active.scrollIntoView !== 'function') return;
            active.scrollIntoView({
                block: 'nearest',
                inline: 'nearest'
            });
        });
        return ()=>cancelAnimationFrame(raf);
    }, [
        open,
        panInset,
        keyboardInset
    ]);
    // Body scroll lock. Restores the exact previous inline values rather than
    // clearing them, so two stacked sheets do not leave the page unlocked when
    // the inner one closes.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open || typeof document === 'undefined') return undefined;
        const body = document.body;
        const previous = {
            overflow: body.style.overflow,
            touchAction: body.style.touchAction,
            overscroll: body.style.overscrollBehavior
        };
        body.style.overflow = 'hidden';
        // iOS ignores `overflow: hidden` on <body> for touch scrolling; these two
        // are what actually stop the page behind the scrim from moving.
        body.style.touchAction = 'none';
        body.style.overscrollBehavior = 'none';
        return ()=>{
            body.style.overflow = previous.overflow;
            body.style.touchAction = previous.touchAction;
            body.style.overscrollBehavior = previous.overscroll;
        };
    }, [
        open
    ]);
    if (!open) return null;
    // `calc()` multiplies a NUMBER by a length, so the snap stays a fraction.
    const cap = Math.min(Math.max(Number(snap) || 0.85, 0.2), 1);
    const tree = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: dir,
        className: className ? `parsina-sheet-scrim ${className}` : 'parsina-sheet-scrim',
        "data-testid": testId,
        onClick: onClose,
        style: {
            position: 'fixed',
            inset: 0,
            zIndex: 1000,
            background: (0, $jTCZr.SCRIM),
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'center',
            // The scrim keeps covering the whole layout viewport (a keyboard frame
            // in flight must never show the page behind); the PANEL is confined to
            // the box the user can see — above the keys, below what was panned past.
            paddingTop: panInset ? `${panInset}px` : undefined,
            paddingBottom: keyboardInset ? `${keyboardInset}px` : undefined,
            animation: 'parsina-sheet-fade 0.2s ease-out'
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", null, $cfba7d02b5e7069f$var$SHEET_CSS), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: panelRef,
        className: $cfba7d02b5e7069f$var$PANEL_CLASS,
        "data-full-height": fullHeight ? '' : undefined,
        role: "dialog",
        "aria-modal": "true",
        "aria-label": title || closeLabel,
        tabIndex: -1,
        onClick: (e)=>e.stopPropagation(),
        style: {
            width: '100%',
            maxWidth: maxWidth,
            display: 'flex',
            flexDirection: 'column',
            background: (0, $jTCZr.C).card,
            borderRadius: `${(0, $jTCZr.RADIUS).hero}px ${(0, $jTCZr.RADIUS).hero}px 0 0`,
            boxShadow: '0 -12px 40px rgba(0,0,0,0.18)',
            // The visible box lost `keyboardInset + panInset` pixels, so the
            // ceiling comes down by exactly that: the sheet's TOP edge stays
            // where it was and the content gives up the keyboard's height, rather
            // than the whole sheet jumping. Both units are published; the
            // stylesheet picks.
            '--parsina-sheet-vh': `calc(${cap} * 100vh - ${keyboardInset + panInset}px)`,
            '--parsina-sheet-dvh': `calc(${cap} * 100dvh - ${keyboardInset + panInset}px)`,
            animation: 'parsina-sheet-up 0.25s cubic-bezier(0.4,0,0.2,1)',
            // No `fontFamily` here: the typeface is set once at the app root and
            // inherited (§2.1 — a component-level font declaration is a defect).
            outline: 'none',
            padding: '1rem 1.25rem 0'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '0.75rem',
            marginBottom: title ? '0.75rem' : 0,
            flexShrink: 0
        }
    }, title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h3", {
        style: {
            fontSize: '0.9375rem',
            fontWeight: 700,
            color: (0, $jTCZr.C).textPrimary,
            margin: 0,
            minWidth: 0
        }
    }, title) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onClose,
        "aria-label": closeLabel,
        "data-testid": testId ? `${testId}-close` : undefined,
        style: {
            border: 'none',
            background: (0, $jTCZr.C).bg,
            cursor: 'pointer',
            // §6: 2.75rem is the floor for anything a thumb has to hit. The
            // glyph stays small; the TARGET is what grew.
            width: '2.75rem',
            height: '2.75rem',
            borderRadius: (0, $jTCZr.RADIUS).pill,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: (0, $jTCZr.C).textSecondary,
            flexShrink: 0,
            padding: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2.5",
        strokeLinecap: "round",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M18 6 6 18M6 6l12 12"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: fullHeight ? 1 : undefined,
            minHeight: 0,
            overflowY: 'auto',
            WebkitOverflowScrolling: 'touch',
            // The sheet is the one scroller while it is open; a flick that
            // reaches its end must not hand the gesture to the page behind it.
            overscrollBehavior: 'contain',
            paddingBottom: footer ? 0 : 'calc(1.25rem + env(safe-area-inset-bottom, 0px))'
        }
    }, children), footer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flexShrink: 0,
            marginTop: '0.75rem',
            marginInline: '-1.25rem',
            padding: '0.625rem 1.25rem',
            paddingBottom: 'calc(0.625rem + env(safe-area-inset-bottom, 0px))',
            background: (0, $jTCZr.C).card,
            borderTop: `1px solid ${(0, $jTCZr.C).border}`
        }
    }, footer)));
    // `document` is absent during a Next.js server render; a sheet that is open
    // on the server (rare, but a valid initial state) renders in place there and
    // moves to <body> on the client.
    if (portal && typeof document !== 'undefined') return /*#__PURE__*/ (0, $1u0KT.createPortal)(tree, document.body);
    return tree;
}

});
parcelRegister("drSko", function(module, exports) {

$parcel$export(module.exports, "useVisualViewportInsets", () => $0286d675359db131$export$9ff6616b10aa518d);
$parcel$export(module.exports, "default", () => $0286d675359db131$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
function $0286d675359db131$export$9ff6616b10aa518d() {
    const [insets, setInsets] = (0, $acw62.useState)({
        top: 0,
        bottom: 0
    });
    (0, $acw62.useEffect)(()=>{
        const vv = typeof window === 'undefined' ? null : window.visualViewport;
        if (!vv) return undefined;
        const read = ()=>{
            const top = Math.max(0, Math.round(vv.offsetTop));
            // Everything below the visual viewport's bottom edge is covered.
            const bottom = Math.max(0, Math.round(window.innerHeight - (vv.height + vv.offsetTop)));
            setInsets((prev)=>prev.top === top && prev.bottom === bottom ? prev : {
                    top: top,
                    bottom: bottom
                });
        };
        read();
        vv.addEventListener('resize', read);
        vv.addEventListener('scroll', read);
        return ()=>{
            vv.removeEventListener('resize', read);
            vv.removeEventListener('scroll', read);
        };
    }, []);
    return insets;
}
var $0286d675359db131$export$2e2bcd8739ae039 = $0286d675359db131$export$9ff6616b10aa518d;

});

parcelRegister("9BgRG", function(module, exports) {

$parcel$export(module.exports, "overlayHistoryDepth", () => $6fd4a6c8c2176e20$export$9452f2c4c9460e1e);
$parcel$export(module.exports, "overlayOwnsPop", () => $6fd4a6c8c2176e20$export$2846246580854e2f);
$parcel$export(module.exports, "default", () => $6fd4a6c8c2176e20$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
// ─────────────────────────────────────────────────────────────────────────────
// useOverlayHistory — put an overlay INTO the history stack.
//
// ── The problem ─────────────────────────────────────────────────────────────
// A bottom sheet, a full-screen picker and a closure overlay are all things a
// person opened and expects to be able to *back out of*. On a phone that means
// the hardware back button on Android and the browser's back gesture on iOS —
// neither of which the page can veto. Because no overlay pushed anything onto
// the history stack, pressing back with a sheet open navigated the ROUTE
// UNDERNEATH it: the sheet stayed on screen over a different screen, or the
// person left a half-finished form without ever being asked.
//
// Per-screen fixes for this do not work. Every app that tried one ended up with
// a `popstate` listener per screen, each guessing how many entries to unwind,
// and one of them (the doctor app's visit guard) hardcoded `history.go(-2)` —
// correct only while exactly one anchor exists, and wrong the moment a sheet is
// open on top of it.
//
// ── The rule this implements ────────────────────────────────────────────────
// Opening an overlay pushes ONE history entry tagged with a private token;
// closing it pops that entry. A `popstate` that removes the token is the
// platform saying "close this overlay", so `onClose` runs and nothing else
// happens — the route never changes. Overlays stack: the innermost one owns the
// newest entry, so back closes them one at a time, in order.
//
// The pushed entry deliberately CARRIES THE ROUTER'S OWN STATE FORWARD
// (`...history.state`), which keeps `idx`/`key` identical. React Router reads
// `state.idx` on `popstate` to compute a delta; leaving it untouched makes the
// delta zero, so the router sees the pop and correctly does nothing. Bumping it
// would make the router re-navigate to the same URL with a new key and reset
// screen state that the overlay was sitting on top of.
//
// ── Depth, for guarded routes ───────────────────────────────────────────────
// A route with a leave-guard (an open visit) has to unwind its own anchor PLUS
// whatever overlays are above it. `overlayHistoryDepth()` is that count, so the
// guard says `history.go(-(1 + overlayHistoryDepth()))` rather than a literal.
//
// ── Whose pop is this? (v0.11.5) ────────────────────────────────────────────
// A leave-guard is itself a `popstate` listener, and `popstate` does not say
// what was left — only what was landed on. So a guard that treats every pop
// as "the person is leaving" fires on the pops THIS hook makes: close a sheet
// with the ✕, the scrim or a submit, the cleanup below calls `back()` to drop
// the sheet's entry, and the guard asks «خروج از ویزیت؟» over a screen the
// person never tried to leave. Found on a phone in the doctor app, where every
// sheet on the visit did it.
//
// `overlayOwnsPop()` is the one question a guard needs to ask first. It is
// true in exactly the two cases where a pop is an overlay's business:
//   · an overlay still HOLDS an entry — the platform back is closing it, and
//     the overlay's own listener (registered later, so it runs after the
//     guard's) will handle it;
//   · this hook has just popped its own entry from inside the app. That is
//     announced BEFORE `back()` and consumed by the first reader within a
//     short window, so a `back()` that never produced a pop cannot swallow a
//     real one later.
//
// ── The hand-off (v0.26.12, PM-0561) ────────────────────────────────────────
// One sheet REPLACED by another in a single React commit — the documents
// gallery handing over to a document's detail, the detail to its extraction
// review, a review back to its detail — broke on a phone: React runs every
// effect destroy before every create, so the closing sheet's `back()` was QUEUED
// and the next sheet's `pushState` ran first. The traversal then resolved
// against the new entry, and the `popstate` reached the NEW sheet's listener as
// if the person had pressed back: the detail flashed and vanished. Sheets that
// refused that close (a busy extraction) survived by re-claiming, which is why
// it went unseen.
//
// So an in-app release is DEFERRED to a microtask — after the whole
// destroy-then-create flush — and an overlay mounting inside that same flush
// CLAIMS the pending entry with `replaceState` instead of pushing its own. Two
// sheets, one entry, no traversal: back still closes the second sheet exactly
// once. The clinic app's local copy of this hook found and fixed the same race
// for its step flows; this is the kit's port.
//
// jsdom cannot show the race — it drops a traversal that a `pushState`
// overtakes — so the tests assert the mechanism (claim, no push, no traversal)
// rather than the symptom. Chrome and WebKit both fire the pop.
//
// SSR/jsdom-safe: with no `window.history` it is inert, so a caller can add it
// unconditionally.
// ─────────────────────────────────────────────────────────────────────────────
const $6fd4a6c8c2176e20$var$MARK = 'parsinaOverlay';
let $6fd4a6c8c2176e20$var$sequence = 0;
/** Tokens of the overlays that currently own a history entry, innermost last. */ const $6fd4a6c8c2176e20$var$openTokens = [];
/** When this hook last popped its own entry (ms epoch); 0 when it has not. */ let $6fd4a6c8c2176e20$var$selfPopAt = 0;
// A history traversal completes within a frame or two; the window is only
// there so a `back()` that never produced a pop cannot claim a later one.
const $6fd4a6c8c2176e20$var$SELF_POP_WINDOW_MS = 1000;
/**
 * Tokens of overlays closed from inside the app in the current flush, innermost
 * last: their entries are still on the stack, waiting for the next overlay to
 * claim the top one (the hand-off) or for the microtask to pop them.
 */ const $6fd4a6c8c2176e20$var$pendingRelease = [];
let $6fd4a6c8c2176e20$var$releaseScheduled = false;
const $6fd4a6c8c2176e20$var$nextMicrotask = (fn)=>{
    if (typeof queueMicrotask === 'function') queueMicrotask(fn);
    else Promise.resolve().then(fn);
};
/**
 * Pop every entry no overlay claimed. One traversal for all of them: each
 * queued traversal resolves against the stack as it is when it RUNS, so issuing
 * several is the same race in miniature.
 */ function $6fd4a6c8c2176e20$var$flushRelease() {
    $6fd4a6c8c2176e20$var$releaseScheduled = false;
    const n = $6fd4a6c8c2176e20$var$pendingRelease.length;
    const top = $6fd4a6c8c2176e20$var$pendingRelease[n - 1];
    $6fd4a6c8c2176e20$var$pendingRelease.length = 0;
    if (n === 0 || typeof window === 'undefined' || !window.history) return;
    // A navigation took the entry over meanwhile (a push above it, or a replace
    // that wrote its own state): popping now would undo that navigation.
    if (window.history.state?.[$6fd4a6c8c2176e20$var$MARK] !== top) return;
    // Announced before the traversal, because the guard's listener will run
    // inside the resulting `popstate` and has no other way to know.
    $6fd4a6c8c2176e20$var$selfPopAt = Date.now();
    try {
        if (n === 1) window.history.back();
        else window.history.go(-n);
    } catch  {
        $6fd4a6c8c2176e20$var$selfPopAt = 0;
    }
}
function $6fd4a6c8c2176e20$export$9452f2c4c9460e1e() {
    return $6fd4a6c8c2176e20$var$openTokens.length;
}
function $6fd4a6c8c2176e20$export$2846246580854e2f() {
    // A pending release is an entry whose overlay has gone and whose pop is on
    // the way.
    if ($6fd4a6c8c2176e20$var$openTokens.length > 0 || $6fd4a6c8c2176e20$var$pendingRelease.length > 0) return true;
    if ($6fd4a6c8c2176e20$var$selfPopAt && Date.now() - $6fd4a6c8c2176e20$var$selfPopAt < $6fd4a6c8c2176e20$var$SELF_POP_WINDOW_MS) {
        $6fd4a6c8c2176e20$var$selfPopAt = 0;
        return true;
    }
    $6fd4a6c8c2176e20$var$selfPopAt = 0;
    return false;
}
function $6fd4a6c8c2176e20$export$b512be9f39899018() {
    $6fd4a6c8c2176e20$var$openTokens.length = 0;
    $6fd4a6c8c2176e20$var$pendingRelease.length = 0;
    $6fd4a6c8c2176e20$var$releaseScheduled = false;
    $6fd4a6c8c2176e20$var$sequence = 0;
    $6fd4a6c8c2176e20$var$selfPopAt = 0;
}
function $6fd4a6c8c2176e20$export$2e2bcd8739ae039(open, onClose, { enabled: enabled = true, id: id } = {}) {
    // `onClose` is almost always an inline arrow, so depending on it would tear
    // the history entry down and rebuild it on every render of the host screen.
    const onCloseRef = (0, $acw62.useRef)(onClose);
    onCloseRef.current = onClose;
    (0, $acw62.useEffect)(()=>{
        if (!enabled || !open) return undefined;
        if (typeof window === 'undefined' || !window.history?.pushState) return undefined;
        const seq = ++$6fd4a6c8c2176e20$var$sequence;
        const token = `${id || 'overlay'}#${seq}`;
        $6fd4a6c8c2176e20$var$openTokens.push(token);
        // True once the platform has already taken our entry off the stack, so the
        // cleanup below knows not to pop a second time.
        let popped = false;
        // Set by the cleanup; a reclaim scheduled before it must not fire after it.
        let disposed = false;
        let reclaimTimer = null;
        // The URL the entry was claimed on. A pop that lands on a different URL is
        // a navigation (a leave-guard's `go(-n)`), never a refused close.
        const claimedHref = window.location.href;
        const drop = ()=>{
            const at = $6fd4a6c8c2176e20$var$openTokens.indexOf(token);
            if (at !== -1) $6fd4a6c8c2176e20$var$openTokens.splice(at, 1);
        };
        const ours = ()=>window.history.state?.[$6fd4a6c8c2176e20$var$MARK] === token;
        const state = window.history.state || {};
        // The hand-off: a sheet that closed in this same flush left its entry on
        // top — take it over instead of stacking a second one (see the header).
        const handOff = $6fd4a6c8c2176e20$var$pendingRelease.length > 0 && state[$6fd4a6c8c2176e20$var$MARK] === $6fd4a6c8c2176e20$var$pendingRelease[$6fd4a6c8c2176e20$var$pendingRelease.length - 1];
        try {
            if (handOff) {
                window.history.replaceState({
                    ...state,
                    [$6fd4a6c8c2176e20$var$MARK]: token
                }, '');
                $6fd4a6c8c2176e20$var$pendingRelease.pop();
                // No pop will come for the entry that was claimed.
                if ($6fd4a6c8c2176e20$var$pendingRelease.length === 0) $6fd4a6c8c2176e20$var$selfPopAt = 0;
            } else window.history.pushState({
                ...state,
                [$6fd4a6c8c2176e20$var$MARK]: token
            }, '');
        } catch  {
            // iOS caps pushState calls per interval. An overlay that cannot claim an
            // entry still opens; it just does not intercept back, which is exactly
            // today's behaviour and strictly better than refusing to render.
            drop();
            return undefined;
        }
        // ── A refused close (v0.16.1) ─────────────────────────────────────────────
        // The platform back has ALREADY removed our entry by the time `onClose`
        // runs, and the page cannot veto that. A consumer may still refuse — a dirty
        // form that asks «خروج بدون ذخیره؟» and hears «بمانم», or TaskOverlay's
        // `busy` withholding `onClose` mid-write. Before this, the overlay stayed on
        // screen with no entry, so the NEXT back left the route under it.
        //
        // So one tick after `onClose`: if this effect is still alive (nothing set
        // `open` to false), claim the entry again. An honoured close has cleaned the
        // effect up by then and nothing here runs.
        const reclaim = ()=>{
            reclaimTimer = null;
            if (disposed || !popped || ours()) return;
            if (window.location.href !== claimedHref) return;
            const seqOf = (t)=>Number(t.slice(t.lastIndexOf('#') + 1));
            // Overlays opened DURING the refusal (a confirm sheet) already pushed
            // their entries above where ours belongs. With exactly one, rotate: the
            // top entry becomes ours and theirs is pushed back on top of it.
            const above = $6fd4a6c8c2176e20$var$openTokens.filter((t)=>seqOf(t) > seq);
            const state = window.history.state || {};
            try {
                if (above.length === 0) window.history.pushState({
                    ...state,
                    [$6fd4a6c8c2176e20$var$MARK]: token
                }, '');
                else if (above.length === 1 && state[$6fd4a6c8c2176e20$var$MARK] === above[0]) {
                    window.history.replaceState({
                        ...state,
                        [$6fd4a6c8c2176e20$var$MARK]: token
                    }, '');
                    window.history.pushState({
                        ...state,
                        [$6fd4a6c8c2176e20$var$MARK]: above[0]
                    }, '');
                } else // Two or more inner entries cannot be reordered without a traversal
                // the person would see; leave it as it was rather than misorder them.
                return;
            } catch  {
                return; // the iOS pushState cap — same fallback as the first claim
            }
            const at = above.length ? $6fd4a6c8c2176e20$var$openTokens.indexOf(above[0]) : -1;
            if (at === -1) $6fd4a6c8c2176e20$var$openTokens.push(token);
            else $6fd4a6c8c2176e20$var$openTokens.splice(at, 0, token);
            popped = false;
        };
        const onPop = ()=>{
            // Still ours: something DEEPER popped, and its own hook is handling it.
            if (ours()) return;
            popped = true;
            drop();
            onCloseRef.current?.();
            if (!disposed && reclaimTimer === null) reclaimTimer = setTimeout(reclaim, 0);
        };
        window.addEventListener('popstate', onPop);
        return ()=>{
            disposed = true;
            if (reclaimTimer !== null) {
                clearTimeout(reclaimTimer);
                reclaimTimer = null;
            }
            window.removeEventListener('popstate', onPop);
            drop();
            // Closed from inside the app (the ✕, a submit, Escape). Our entry is
            // still on the stack, so remove it — otherwise back would have to be
            // pressed once for the ghost entry and once for the actual route.
            //
            // `ours()` is the guard that makes this safe on unmount-by-navigation: a
            // sheet whose button routed somewhere else no longer owns the top entry,
            // and calling back() there would undo the navigation it just performed.
            if (!popped && ours()) {
                // Deferred to a microtask, so that an overlay replacing this one in the
                // same React flush can claim the entry instead (the hand-off). Announced
                // now: a guard may ask before the pop lands.
                $6fd4a6c8c2176e20$var$pendingRelease.push(token);
                $6fd4a6c8c2176e20$var$selfPopAt = Date.now();
                if (!$6fd4a6c8c2176e20$var$releaseScheduled) {
                    $6fd4a6c8c2176e20$var$releaseScheduled = true;
                    $6fd4a6c8c2176e20$var$nextMicrotask($6fd4a6c8c2176e20$var$flushRelease);
                }
            }
        };
    }, [
        open,
        enabled,
        id
    ]);
}

});


parcelRegister("bfs4Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $08d1958bc1315b40$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $jTCZr = parcelRequire("jTCZr");
'use client';
// ─────────────────────────────────────────────────────────────────────────────
// Menu — an anchored menu.
//
// PROMOTED from the clinic app's `src/components/common/ClinicMenu.jsx`, which
// had marked itself a promotion candidate: the kit had no menu primitive at any
// version — not a Menu, not a Popover, not a DropdownMenu — so per DESIGN.md
// rule 4 it lived in the app until a second app needed one. `AccountCard` is
// that second need, in all four panels at once.
//
// Not built from `Dialog`: a Dialog is a centred modal and this is an anchored
// menu, so the kit's overlay would be the wrong shape AND the wrong semantics
// (`role="dialog"` where a screen reader needs `role="menu"`).
//
// Portaled to `document.body` so a clipping ancestor cannot cut it off — the
// staff sidebars are fixed-width flex columns with `overflow: hidden`, and an
// anchored child of one is sliced at 260px (or at 68px when collapsed).
//
// LAYERING — z 900. Above every piece of app chrome (the doctor app's mobile
// bottom nav at z-50, its visit-closure flow at z-60) and below every kit
// overlay: BottomSheet 1000, Dialog/ConfirmDialog 1100. That order is the one
// DESIGN.md insists on — a ConfirmDialog raised from inside a menu row (sign
// out, a destructive switch) must render ABOVE the menu, and the fix for that
// ordering is never to lower the dialog. ClinicMenu sat at 11, the Drawer
// level, which was enough for the one trigger it had; 900 is what a menu opened
// from anywhere needs.
//
// Props:
//   open / onClose        — controlled
//   anchorRef             — ref to the trigger; the menu is measured against it
//   placement             — 'bottom' (default) | 'top' | 'auto'. 'auto' opens
//                           downward and flips up when the space below is too
//                           small. A menu at the FOOT of a sidebar wants 'top'.
//   width                 — px (default 300)
//   ariaLabel             — required in practice: the trigger's visible text is
//                           often a person's or a clinic's name, not the menu's
//   children              — the rows; give them role="menuitem"/"menuitemradio"
//   data-testid
// ─────────────────────────────────────────────────────────────────────────────
const $08d1958bc1315b40$var$Z = 900;
const $08d1958bc1315b40$var$GAP = 6; // breathing room between trigger and menu
const $08d1958bc1315b40$var$EDGE = 8; // never touch the viewport edge
const $08d1958bc1315b40$var$MIN_BELOW = 180; // 'auto' flips up below this much room
// Every focusable row, in DOM order. Radio rows come from ClinicSwitcher, plain
// menuitems from AccountCard; `[data-menu-focus]` lets a caller nominate
// something else entirely (ClinicSwitcher's search box).
const $08d1958bc1315b40$var$ROW_SELECTOR = '[data-menu-focus="true"], [role="menuitem"]:not([aria-disabled="true"]), [role="menuitemradio"]:not([aria-disabled="true"])';
function $08d1958bc1315b40$export$d9b273488cd8ce6f({ open: open, onClose: onClose, anchorRef: anchorRef, children: children, ariaLabel: ariaLabel, width: width = 300, placement: placement = 'bottom', 'data-testid': testId = 'menu' }) {
    const menuRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const [pos, setPos] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // Position against the trigger. Measured on open and on every resize/scroll,
    // rather than once: the sidebar collapses under a CSS transition, so a
    // position captured at open time is wrong 300ms later.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(()=>{
        if (!open) {
            setPos(null);
            return undefined;
        }
        const place = ()=>{
            const el = anchorRef?.current;
            if (!el) return;
            const r = el.getBoundingClientRect();
            const isRtl = typeof document !== 'undefined' && document.documentElement.dir === 'rtl';
            // Anchor to the INLINE-START edge in both directions, which is the visual
            // edge the trigger shares with its container in RTL and LTR alike.
            const left = isRtl ? Math.max($08d1958bc1315b40$var$EDGE, r.right - width) : Math.min(r.left, window.innerWidth - width - $08d1958bc1315b40$var$EDGE);
            const roomBelow = window.innerHeight - r.bottom - $08d1958bc1315b40$var$EDGE * 2;
            const roomAbove = r.top - $08d1958bc1315b40$var$EDGE * 2;
            const up = placement === 'top' || placement === 'auto' && roomBelow < $08d1958bc1315b40$var$MIN_BELOW && roomAbove > roomBelow;
            const room = up ? roomAbove : roomBelow;
            const maxHeight = Math.min(Math.max(160, room), Math.round(window.innerHeight * 0.6));
            setPos(up ? {
                bottom: Math.max($08d1958bc1315b40$var$EDGE, window.innerHeight - r.top + $08d1958bc1315b40$var$GAP),
                left: left,
                maxHeight: maxHeight
            } : {
                top: r.bottom + $08d1958bc1315b40$var$GAP,
                left: left,
                maxHeight: maxHeight
            });
        };
        place();
        window.addEventListener('resize', place);
        window.addEventListener('scroll', place, true);
        return ()=>{
            window.removeEventListener('resize', place);
            window.removeEventListener('scroll', place, true);
        };
    }, [
        open,
        anchorRef,
        width,
        placement
    ]);
    // Close on an outside press. `mousedown` rather than `click`, so a press that
    // starts outside and ends inside cannot re-open what it just closed.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return undefined;
        const onDown = (e)=>{
            if (menuRef.current?.contains(e.target)) return;
            if (anchorRef?.current?.contains(e.target)) return;
            onClose?.();
        };
        document.addEventListener('mousedown', onDown);
        return ()=>document.removeEventListener('mousedown', onDown);
    }, [
        open,
        onClose,
        anchorRef
    ]);
    // Escape closes, arrows walk the rows, Home/End jump. A menu you can open by
    // keyboard but only leave by mouse is a trap.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return undefined;
        const onKey = (e)=>{
            if (e.key === 'Escape') {
                e.stopPropagation();
                onClose?.();
                return;
            }
            if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp' && e.key !== 'Home' && e.key !== 'End') return;
            const rows = Array.from(menuRef.current?.querySelectorAll($08d1958bc1315b40$var$ROW_SELECTOR) || []);
            if (!rows.length) return;
            e.preventDefault();
            const at = rows.indexOf(document.activeElement);
            const next = e.key === 'Home' ? 0 : e.key === 'End' ? rows.length - 1 : e.key === 'ArrowDown' ? (at + 1) % rows.length : at <= 0 ? rows.length - 1 : at - 1;
            rows[next]?.focus?.();
        };
        document.addEventListener('keydown', onKey);
        return ()=>document.removeEventListener('keydown', onKey);
    }, [
        open,
        onClose
    ]);
    // Focus lands inside on open and returns to the trigger on close — a menu that
    // opens without focus is unreachable by keyboard, and one that drops focus on
    // close strands the caret at the top of the document.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return undefined;
        const t = window.setTimeout(()=>{
            menuRef.current?.querySelector($08d1958bc1315b40$var$ROW_SELECTOR)?.focus?.();
        }, 0);
        const anchor = anchorRef?.current;
        return ()=>{
            window.clearTimeout(t);
            if (anchor && document.contains(anchor)) anchor.focus?.();
        };
    }, [
        open,
        anchorRef
    ]);
    if (!open || !pos) return null;
    return /*#__PURE__*/ (0, $1u0KT.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: menuRef,
        role: "menu",
        "aria-label": ariaLabel,
        "data-testid": testId,
        style: {
            position: 'fixed',
            top: pos.top,
            bottom: pos.bottom,
            left: pos.left,
            width: width,
            maxHeight: pos.maxHeight,
            overflowY: 'auto',
            overflowX: 'hidden',
            background: 'white',
            borderRadius: 12,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            boxShadow: '0 18px 48px rgba(15, 34, 51, 0.18)',
            zIndex: $08d1958bc1315b40$var$Z,
            padding: 6,
            fontFamily: 'Meshkat, sans-serif'
        }
    }, children), document.body);
}
var $08d1958bc1315b40$export$2e2bcd8739ae039 = $08d1958bc1315b40$export$d9b273488cd8ce6f;

});

parcelRegister("gCvEY", function(module, exports) {

$parcel$export(module.exports, "default", () => $382b400f7624ec9d$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $cZOyb = parcelRequire("cZOyb");

var $4fYdd = parcelRequire("4fYdd");

var $k27hS = parcelRequire("k27hS");

var $jTCZr = parcelRequire("jTCZr");

var $j9AxR = parcelRequire("j9AxR");
'use client';
// The panel surface both shells paint on. A sticky header has to repaint it, or
// the body shows through as it scrolls under.
const $382b400f7624ec9d$var$OVERLAY_SURFACE = (0, $jTCZr.C).card;
function $382b400f7624ec9d$export$2e2bcd8739ae039({ open: open, onClose: onClose, title: title, description: description, header: header, footer: footer, children: children, busy: busy = false, size: size = 'md', isMobile: isMobile, historyIntegration: historyIntegration = true, snap: snap = 1, fullHeight: fullHeight = true, closeLabel: closeLabel, className: className, 'data-testid': testId, ...rest }) {
    if (closeLabel === undefined) closeLabel = (0, $j9AxR.kitCopy)().close;
    const auto = (0, $k27hS.default)();
    // ── Why this cannot be server-rendered blind ──────────────────────────────
    // WHICH SHELL this is depends on the viewport, and a server does not have
    // one. Rendering the desktop guess and then swapping to a sheet on the client
    // is a hydration mismatch — React discards the tree and re-renders it, and in
    // an app that streams the overlay open from a deep link (`?book=1`) that is a
    // visible flash of the wrong shape.
    //
    // So: when the caller TELLS us the tier we trust it and render on the server
    // like anything else. When it does not, we wait for the client, where the
    // question has an answer. One frame later than ideal, and never wrong.
    const told = isMobile !== undefined;
    const [mounted, setMounted] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(told);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setMounted(true);
    }, []);
    const mobile = told ? isMobile : auto.isMobile;
    // One guard for every way out, so "can this close right now?" has a single
    // answer rather than one per dismissal path. On the sheet tier a platform back
    // has already popped the sheet's history entry when this refuses; the sheet's
    // `useOverlayHistory` re-claims it one tick later (v0.16.1), so a busy overlay
    // keeps exactly one entry and the next back is delivered to it again.
    const close = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        if (busy) return;
        if (typeof onClose === 'function') onClose();
    }, [
        busy,
        onClose
    ]);
    if (!open || !mounted) return null;
    if (mobile) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: open,
        onClose: close,
        title: title,
        footer: footer,
        snap: snap,
        fullHeight: fullHeight,
        closeLabel: closeLabel,
        historyIntegration: historyIntegration,
        className: className,
        "data-testid": testId,
        "data-busy": busy || undefined,
        ...rest
    }, header ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId ? `${testId}-header` : undefined,
        style: {
            position: 'sticky',
            top: 0,
            zIndex: 1,
            background: $382b400f7624ec9d$var$OVERLAY_SURFACE,
            padding: '0 1.25rem 0.75rem'
        }
    }, header) : null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.Dialog), {
        open: open,
        onOpenChange: (next)=>{
            if (!next) close();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogContent), {
        size: size,
        layout: "frame",
        showClose: !busy,
        className: className,
        "data-testid": testId,
        "data-busy": busy || undefined,
        // Radix would otherwise close on Esc or an outside click mid-write.
        onEscapeKeyDown: (e)=>{
            if (busy) e.preventDefault();
        },
        onInteractOutside: (e)=>{
            if (busy) e.preventDefault();
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogTitle), {
        dir: "auto"
    }, title), description ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogDescription), {
        dir: "auto"
    }, description) : null, header ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId ? `${testId}-header` : undefined,
        style: {
            marginTop: '0.75rem'
        }
    }, header) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogBody), null, children), footer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogFooter), null, footer) : null));
}

});

parcelRegister("6usBW", function(module, exports) {

$parcel$export(module.exports, "ToastProvider", () => $352ffee698fbd002$export$f5d03d415824e0e);
$parcel$export(module.exports, "useToast", () => $352ffee698fbd002$export$a407b657d3044108);

var $acw62 = parcelRequire("acw62");

var $k27hS = parcelRequire("k27hS");

var $iK5Lj = parcelRequire("iK5Lj");
'use client';
// ─────────────────────────────────────────────────────────────────────────────
// Toast — the one notification system for every Parsina client.
//
// Replaces: native alert() calls (doctor app), the 5+ per-screen setToast/
// setTimeout implementations (clinic app), and inline-only feedback (patient app).
//
// Usage:
//   <ToastProvider>  ← once, at the app root
//   const toast = useToast();
//   toast.success('ذخیره شد');
//   toast.error('خطا در ارتباط با سرور');
//   toast.info('...'); toast.warn('...');
//
// The contract is DESIGN_SYSTEM §9.3 / DESIGN_CONCEPT §7 (PM-0022):
//   • one sentence, auto-dismissed after 4 s — an error after 6 s;
//   • at most 3 stacked on desktop, 2 on a phone (the oldest leaves);
//   • desktop: the bottom, inline-END corner (the one farthest from the sidebar);
//     phone: bottom-centre, ABOVE whatever is docked there — the bottom nav
//     (`--app-bottom-nav`), a screen's CTA footer (`--app-bottom-dock`, see
//     `usePublishedHeight`) and the software keyboard;
//   • polite to a screen reader, except an error, which interrupts.
// ─────────────────────────────────────────────────────────────────────────────
const $352ffee698fbd002$var$PALETTE = {
    success: {
        bg: '#1A9B6C',
        text: '#ffffff'
    },
    error: {
        bg: '#D93025',
        text: '#ffffff'
    },
    warn: {
        bg: '#F59E0B',
        text: '#1a2332'
    },
    info: {
        bg: '#0173BE',
        text: '#ffffff'
    }
};
const $352ffee698fbd002$var$ToastContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
const $352ffee698fbd002$export$beb43bca45d33d34 = 4000;
const $352ffee698fbd002$export$7a658dea7a198286 = 6000;
const $352ffee698fbd002$export$3b92a0a0bf23cbdd = {
    desktop: 3,
    mobile: 2
};
let $352ffee698fbd002$var$nextId = 1;
function $352ffee698fbd002$export$f5d03d415824e0e({ children: children, duration: duration = $352ffee698fbd002$export$beb43bca45d33d34, errorDuration: errorDuration = $352ffee698fbd002$export$7a658dea7a198286 }) {
    const [toasts, setToasts] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const timers = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Map());
    const { isMobile: isMobile } = (0, $k27hS.default)();
    const keyboardInset = (0, $iK5Lj.default)();
    const max = isMobile ? $352ffee698fbd002$export$3b92a0a0bf23cbdd.mobile : $352ffee698fbd002$export$3b92a0a0bf23cbdd.desktop;
    const dismiss = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((id)=>{
        setToasts((t)=>t.filter((x)=>x.id !== id));
        const timer = timers.current.get(id);
        if (timer) {
            clearTimeout(timer);
            timers.current.delete(id);
        }
    }, []);
    const push = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((message, type = 'info', opts = {})=>{
        const id = $352ffee698fbd002$var$nextId++;
        // The state keeps the desktop cap; the phone's smaller one is applied at
        // render, so a rotation never needs the list rewritten.
        setToasts((t)=>[
                ...t,
                {
                    id: id,
                    message: message,
                    type: type
                }
            ].slice(-$352ffee698fbd002$export$3b92a0a0bf23cbdd.desktop));
        const life = opts.duration ?? (type === 'error' ? errorDuration : duration);
        timers.current.set(id, setTimeout(()=>dismiss(id), life));
        return id;
    }, [
        dismiss,
        duration,
        errorDuration
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>()=>{
            timers.current.forEach(clearTimeout);
        }, []);
    const api = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
            show: push,
            success: (m, o)=>push(m, 'success', o),
            error: (m, o)=>push(m, 'error', o),
            warn: (m, o)=>push(m, 'warn', o),
            info: (m, o)=>push(m, 'info', o),
            dismiss: dismiss
        }), [
        push,
        dismiss
    ]);
    const visible = toasts.slice(-max);
    // Phone: clear the nav + a docked footer, or the keyboard when that is taller
    // (a footer that pads for the keyboard already contains it — hence `max`, not
    // a sum). Desktop has neither; the corner offset is all there is.
    const bottom = isMobile ? `calc(max(var(--app-bottom-nav, 0px) + var(--app-bottom-dock, 0px), env(safe-area-inset-bottom, 0px), ${keyboardInset}px) + 0.75rem)` : '1.5rem';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($352ffee698fbd002$var$ToastContext.Provider, {
        value: api
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "toast-stack",
        "data-placement": isMobile ? 'bottom-center' : 'bottom-end',
        style: {
            position: 'fixed',
            bottom: bottom,
            insetInline: 0,
            paddingInline: isMobile ? '1rem' : '1.5rem',
            display: 'flex',
            flexDirection: 'column',
            alignItems: isMobile ? 'center' : 'flex-end',
            gap: '0.5rem',
            zIndex: 9999,
            pointerEvents: 'none'
        }
    }, visible.map((t)=>{
        const p = $352ffee698fbd002$var$PALETTE[t.type] || $352ffee698fbd002$var$PALETTE.info;
        const isError = t.type === 'error';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: t.id,
            onClick: ()=>dismiss(t.id),
            role: isError ? 'alert' : 'status',
            "aria-live": isError ? 'assertive' : 'polite',
            "data-testid": "toast",
            "data-type": t.type,
            style: {
                pointerEvents: 'auto',
                cursor: 'pointer',
                background: p.bg,
                color: p.text,
                padding: '0.625rem 1.125rem',
                borderRadius: 'var(--radius, 10px)',
                fontSize: '0.8125rem',
                fontWeight: 600,
                boxShadow: '0 8px 24px rgba(0,0,0,0.18)',
                maxWidth: 'min(92vw, 26.25rem)',
                animation: 'parsina-toast-in 0.22s ease-out'
            }
        }, t.message);
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", null, `@keyframes parsina-toast-in{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}@media (prefers-reduced-motion: reduce){[data-testid="toast"]{animation:none !important}}`)));
}
function $352ffee698fbd002$export$a407b657d3044108() {
    const ctx = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($352ffee698fbd002$var$ToastContext);
    if (!ctx) throw new Error('useToast must be used inside <ToastProvider>');
    return ctx;
}

});
parcelRegister("iK5Lj", function(module, exports) {

$parcel$export(module.exports, "default", () => $da50fe1f8f323572$export$2e2bcd8739ae039);

var $drSko = parcelRequire("drSko");
'use client';
function $da50fe1f8f323572$export$a477a7ade7efed9c() {
    // One listener implementation for both facts: the bottom inset IS the
    // keyboard, `top` is the pan a sheet needs (PM-0108) and a composer does not.
    return (0, $drSko.useVisualViewportInsets)().bottom;
}
var $da50fe1f8f323572$export$2e2bcd8739ae039 = $da50fe1f8f323572$export$a477a7ade7efed9c;

});


parcelRegister("hZDga", function(module, exports) {

$parcel$export(module.exports, "Spinner", () => $31e8de2f297417a1$export$7f7cbe89f1eacd2);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $j9AxR = parcelRequire("j9AxR");
'use client';
function $31e8de2f297417a1$export$7f7cbe89f1eacd2({ size: size = 32, color: color = (0, $jTCZr.C).teal, thickness: thickness = 2, style: style, label: label }) {
    if (label === undefined) label = (0, $j9AxR.kitCopy)().loading;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "status",
        // The accessible name is a PROP (rule 7). It used to be a Persian string
        // literal with no way past it, so an English screen announced its loading
        // state in Persian and the app could do nothing about it.
        "aria-label": label,
        style: {
            width: size,
            height: size,
            borderRadius: '50%',
            border: `${thickness}px solid ${color}`,
            borderTopColor: 'transparent',
            animation: 'parsina-spin 0.8s linear infinite',
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", null, `@keyframes parsina-spin{to{transform:rotate(360deg)}}`));
}
function $31e8de2f297417a1$export$e2b0760399e6dece({ label: label, minHeight: minHeight = '60vh' }) {
    return(// No `dir` of its own — it inherits the document's, like every other
    // component in the kit. It is a centred column either way.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            minHeight: minHeight,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 12
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($31e8de2f297417a1$export$7f7cbe89f1eacd2, {
        label: label
    }), label ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.8125rem',
            color: '#9aa3b0',
            fontFamily: 'Meshkat, sans-serif'
        }
    }, label) : null));
}
var $31e8de2f297417a1$export$2e2bcd8739ae039 = $31e8de2f297417a1$export$7f7cbe89f1eacd2;

});

parcelRegister("fvho4", function(module, exports) {

$parcel$export(module.exports, "SessionCheck", () => $3c4ca280922aa4ea$export$cd72095868f03c30);
$parcel$export(module.exports, "SessionError", () => $3c4ca280922aa4ea$export$d422f67d76bf24e4);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
'use client';
// ─────────────────────────────────────────────────────────────────────────────
// SessionCheck / SessionError / SessionPage — what EVERY Parsina panel shows
// between opening the tab and knowing who is signed in.
//
// The Keycloak round trip, the token check and whatever read a panel needs
// before its first screen (onboarding status, memberships, appearance) all sit
// behind this one card. It was the doctor panel's (its App.jsx `AuthPage`),
// copied into the clinic panel in 2026-09 and drawn differently again in the
// dentist, student and admin panels — five front doors to one product. It is
// the kit's now, so a person who opens two panels in one morning meets one
// door, and a change to it is one release rather than five edits.
//
//   SessionPage   the canvas (145° navy gradient, two drifting discs) and the
//                 420px white card that rises in
//   SessionCheck  the loading state: brand hero, three bouncing dots, the
//                 progress track, and the manual sign-in link after 4s
//   SessionError  a boot that could not finish: logo, tone disc, message,
//                 one gradient action, and the SSO host it tried
//
// ── Continuing across a remount ─────────────────────────────────────────────
//
// A panel's boot often has two owners — the auth check, then a provider that
// reads what the panel needs — and each renders its own SessionCheck. Left
// alone the second mount would restart every animation: the card rising again,
// the track snapping back to 5%. So every animation is offset by the time since
// this MODULE loaded (≈ the page's start) with a negative `animation-delay`,
// and the manual link counts from the same moment. The second mount continues
// the first.
//
// Every word is a PROP (rule 7) and so is the logo: the kit ships no image, and
// a panel with its own mark (ParsinaDent) passes its own.
// ─────────────────────────────────────────────────────────────────────────────
const $3c4ca280922aa4ea$var$now = ()=>typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now();
const $3c4ca280922aa4ea$var$SESSION_T0 = $3c4ca280922aa4ea$var$now();
/** Milliseconds since the kit loaded — the one clock every session screen shares. */ const $3c4ca280922aa4ea$var$sinceBoot = ()=>$3c4ca280922aa4ea$var$now() - $3c4ca280922aa4ea$var$SESSION_T0;
const $3c4ca280922aa4ea$var$continued = (elapsedMs, ownDelayS = 0)=>({
        animationDelay: `${ownDelayS - elapsedMs / 1000}s`
    });
const $3c4ca280922aa4ea$export$6b89370abb8fc4ae = `linear-gradient(145deg, ${(0, $jTCZr.C).navyDark} 0%, ${(0, $jTCZr.C).navy} 55%, ${(0, $jTCZr.C).navyLight} 100%)`;
const $3c4ca280922aa4ea$export$e3b7f640fe979c0e = `linear-gradient(160deg, ${(0, $jTCZr.C).navyDark} 0%, ${(0, $jTCZr.C).navy} 60%, ${(0, $jTCZr.C).navyLight} 100%)`;
const $3c4ca280922aa4ea$var$SESSION_ACTION = `linear-gradient(135deg, ${(0, $jTCZr.C).navyDark}, ${(0, $jTCZr.C).navy})`;
// Reduced motion: the card simply appears, the dots rest, the track sits part
// filled. Those resting values are the base rules, so they hold wherever the
// animation does not.
const $3c4ca280922aa4ea$var$SESSION_CSS = `
  @keyframes parsina-session-rise { from { opacity: 0; transform: translateY(24px) } to { opacity: 1; transform: translateY(0) } }
  @keyframes parsina-session-dot { 0%, 65%, 100% { transform: translateY(0); opacity: 0.3 } 30% { transform: translateY(-9px); opacity: 1 } }
  @keyframes parsina-session-progress { 0% { width: 5% } 50% { width: 65% } 85% { width: 88% } 100% { width: 93% } }
  @keyframes parsina-session-float { 0%, 100% { transform: scale(1) } 50% { transform: scale(1.06) } }
  @keyframes parsina-session-appear { from { opacity: 0 } to { opacity: 1 } }
  [data-session-dot] { opacity: 0.6; }
  [data-session-progress] { width: 65%; }
  @media (prefers-reduced-motion: no-preference) {
    [data-session-card] { animation: parsina-session-rise 0.5s cubic-bezier(0.22, 1, 0.36, 1) both; }
    [data-session-dot] { animation: parsina-session-dot 1.5s ease-in-out infinite; }
    [data-session-progress] { animation: parsina-session-progress 3s ease-out both; }
    [data-session-float] { animation-name: parsina-session-float; animation-timing-function: ease-in-out; animation-iteration-count: infinite; }
    [data-session-appear] { animation: parsina-session-appear 0.4s ease both; }
  }
`;
function $3c4ca280922aa4ea$export$15364261a1aca489({ children: children, testId: testId }) {
    // Read once per mount: the offset must not move under a running animation.
    const [elapsed] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState($3c4ca280922aa4ea$var$sinceBoot);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId,
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100vw',
            height: '100vh',
            background: $3c4ca280922aa4ea$export$6b89370abb8fc4ae,
            fontFamily: 'Meshkat, sans-serif',
            position: 'relative',
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", null, $3c4ca280922aa4ea$var$SESSION_CSS), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": "true",
        "data-session-float": "",
        style: {
            position: 'absolute',
            top: -120,
            insetInlineEnd: -80,
            width: 380,
            height: 380,
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.04)',
            animationDuration: '9s',
            pointerEvents: 'none'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": "true",
        "data-session-float": "",
        style: {
            position: 'absolute',
            bottom: -160,
            insetInlineStart: -100,
            width: 500,
            height: 500,
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.03)',
            animationDuration: '12s',
            pointerEvents: 'none',
            ...$3c4ca280922aa4ea$var$continued(elapsed, 3)
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("main", {
        "data-session-card": "",
        style: {
            background: 'white',
            borderRadius: 16,
            width: 420,
            maxWidth: 'calc(100vw - 48px)',
            boxShadow: '0 32px 80px rgba(0,0,0,0.3), 0 8px 32px rgba(0,0,0,0.18)',
            textAlign: 'center',
            overflow: 'hidden',
            ...$3c4ca280922aa4ea$var$continued(elapsed)
        }
    }, children));
}
function $3c4ca280922aa4ea$export$cd72095868f03c30({ logo: logo, brandName: brandName, panelName: panelName, title: title, subtitle: subtitle, stuckLabel: stuckLabel, manualLabel: manualLabel, onManualSignIn: onManualSignIn, manualAfterMs: manualAfterMs = 4000, testId: testId = 'session-check' }) {
    const [elapsed] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState($3c4ca280922aa4ea$var$sinceBoot);
    const [showManual, setShowManual] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>elapsed >= manualAfterMs);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (showManual || !onManualSignIn) return undefined;
        const timer = setTimeout(()=>setShowManual(true), Math.max(0, manualAfterMs - $3c4ca280922aa4ea$var$sinceBoot()));
        return ()=>clearTimeout(timer);
    }, [
        showManual,
        onManualSignIn,
        manualAfterMs
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3c4ca280922aa4ea$export$15364261a1aca489, {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: $3c4ca280922aa4ea$export$e3b7f640fe979c0e,
            padding: '36px 44px 32px',
            position: 'relative',
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": "true",
        style: {
            position: 'absolute',
            top: -24,
            insetInlineEnd: -24,
            width: 100,
            height: 100,
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.05)'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": "true",
        style: {
            position: 'absolute',
            bottom: -30,
            insetInlineStart: -20,
            width: 120,
            height: 120,
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.04)'
        }
    }), logo ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            justifyContent: 'center',
            marginBottom: 14,
            position: 'relative'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 72,
            height: 72,
            borderRadius: 18,
            background: 'rgba(255,255,255,0.12)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: logo,
        alt: brandName || '',
        style: {
            width: 52,
            height: 52,
            objectFit: 'contain'
        }
    }))) : null, brandName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '1.625rem',
            fontWeight: 800,
            color: 'white',
            marginBottom: 4,
            letterSpacing: -0.5
        }
    }, brandName) : null, panelName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.8125rem',
            color: 'rgba(255,255,255,0.55)'
        }
    }, panelName) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '32px 44px 40px'
        },
        role: "status",
        "aria-live": "polite",
        "aria-busy": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": "true",
        style: {
            display: 'flex',
            justifyContent: 'center',
            gap: 10,
            marginBottom: 18
        }
    }, [
        0,
        0.18,
        0.36
    ].map((delay)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: delay,
            "data-session-dot": "",
            style: {
                width: 10,
                height: 10,
                borderRadius: '50%',
                background: (0, $jTCZr.C).navy,
                ...$3c4ca280922aa4ea$var$continued(elapsed, delay)
            }
        }))), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.9375rem',
            color: (0, $jTCZr.C).textSecondary,
            marginBottom: 6,
            fontWeight: 500
        }
    }, title) : null, subtitle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.8125rem',
            color: (0, $jTCZr.C).textMuted,
            marginBottom: 28
        }
    }, subtitle) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": "true",
        style: {
            width: '100%',
            height: 4,
            background: (0, $jTCZr.C).border,
            borderRadius: 4,
            overflow: 'hidden',
            marginBottom: 28
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-session-progress": "",
        style: {
            height: '100%',
            background: `linear-gradient(90deg, ${(0, $jTCZr.C).navyDark}, ${(0, $jTCZr.C).navyLight})`,
            borderRadius: 4,
            ...$3c4ca280922aa4ea$var$continued(elapsed)
        }
    })), showManual && onManualSignIn ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-session-appear": "",
        style: {
            marginTop: 18,
            fontSize: '0.8125rem',
            color: (0, $jTCZr.C).textMuted
        }
    }, stuckLabel, stuckLabel ? ' ' : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onManualSignIn,
        "data-testid": `${testId}-manual`,
        style: {
            background: 'none',
            border: 'none',
            padding: 0,
            cursor: 'pointer',
            font: 'inherit',
            fontSize: '0.8125rem',
            fontWeight: 600,
            color: (0, $jTCZr.C).navy,
            textDecoration: 'underline',
            textUnderlineOffset: 3
        }
    }, manualLabel)) : null));
}
// Filled glyphs (Material `error`, `cloud_off`) — the doctor card's family.
const $3c4ca280922aa4ea$var$ErrorGlyph = ({ color: color })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: color,
        width: "30",
        height: "30",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
    }));
const $3c4ca280922aa4ea$var$OfflineGlyph = ({ color: color })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: color,
        width: "30",
        height: "30",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M19.35 10.04C18.67 6.59 15.64 4 12 4c-1.48 0-2.85.43-4.01 1.17l1.46 1.46C10.21 6.23 11.08 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3 0 1.13-.64 2.11-1.56 2.62l1.45 1.45C23.16 18.16 24 16.68 24 15c0-2.64-2.05-4.78-4.65-4.96zM3 5.27l2.75 2.74C2.56 8.15 0 10.77 0 14c0 3.31 2.69 6 6 6h11.73l2 2L21 20.73 4.27 4 3 5.27zM7.73 10l8 8H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h1.73z"
    }));
const $3c4ca280922aa4ea$var$TONES = {
    /** The sign-in service failed, or the redirect looped. */ danger: {
        bg: '#FEF2F2',
        ring: '#FECACA',
        ink: (0, $jTCZr.C).red,
        Glyph: $3c4ca280922aa4ea$var$ErrorGlyph
    },
    /** Signed in, but the panel's backend did not answer. */ warning: {
        bg: '#FFFBEB',
        ring: '#FDE68A',
        ink: '#B45309',
        Glyph: $3c4ca280922aa4ea$var$OfflineGlyph
    }
};
function $3c4ca280922aa4ea$export$d422f67d76bf24e4({ tone: tone = 'danger', logo: logo, brandName: brandName, title: title, body: body, detail: detail, actionLabel: actionLabel, onAction: onAction, secondary: secondary, host: host, testId: testId = 'session-error', stateTestId: stateTestId }) {
    const look = $3c4ca280922aa4ea$var$TONES[tone] || $3c4ca280922aa4ea$var$TONES.danger;
    const { Glyph: Glyph } = look;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3c4ca280922aa4ea$export$15364261a1aca489, {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '40px 44px 44px'
        },
        role: "alert",
        "data-testid": stateTestId
    }, logo ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: logo,
        alt: brandName || '',
        style: {
            width: 52,
            height: 52,
            objectFit: 'contain',
            marginBottom: 20,
            opacity: 0.55
        }
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 60,
            height: 60,
            borderRadius: '50%',
            background: look.bg,
            border: `2px solid ${look.ring}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 20px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Glyph, {
        color: look.ink
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h1", {
        style: {
            margin: '0 0 10px',
            color: (0, $jTCZr.C).textPrimary,
            fontSize: '1.125rem',
            fontWeight: 800,
            letterSpacing: -0.3
        }
    }, title), body ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: (0, $jTCZr.C).textSecondary,
            fontSize: '0.875rem',
            marginBottom: detail ? 12 : 32,
            lineHeight: 1.8
        }
    }, body) : null, detail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: (0, $jTCZr.C).textMuted,
            fontSize: '0.75rem',
            marginBottom: 32,
            lineHeight: 1.7,
            wordBreak: 'break-word'
        }
    }, detail) : null, onAction ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onAction,
        style: {
            width: '100%',
            height: 50,
            background: $3c4ca280922aa4ea$var$SESSION_ACTION,
            color: 'white',
            border: 'none',
            borderRadius: 12,
            fontSize: '0.9375rem',
            fontWeight: 700,
            fontFamily: 'inherit',
            cursor: 'pointer',
            boxShadow: `0 4px 16px ${(0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.3)}`,
            marginBottom: secondary ? 10 : 20
        }
    }, actionLabel) : null, secondary ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: secondary.onClick,
        style: {
            width: '100%',
            height: 44,
            background: 'white',
            color: (0, $jTCZr.C).navy,
            border: `1.5px solid ${(0, $jTCZr.C).border}`,
            borderRadius: 12,
            fontSize: '0.875rem',
            fontWeight: 600,
            fontFamily: 'inherit',
            cursor: 'pointer',
            marginBottom: 20
        }
    }, secondary.label) : null, host ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 6,
            padding: '10px 14px',
            background: '#f8fafc',
            borderRadius: 10,
            border: `1px solid ${(0, $jTCZr.C).border}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: (0, $jTCZr.C).textMuted,
        width: "13",
        height: "13",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "ltr",
        style: {
            fontSize: '0.6875rem',
            color: (0, $jTCZr.C).textMuted,
            fontFamily: 'monospace',
            letterSpacing: 0.2
        }
    }, host)) : null));
}
var $3c4ca280922aa4ea$export$2e2bcd8739ae039 = $3c4ca280922aa4ea$export$cd72095868f03c30;

});

parcelRegister("66joL", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $c90190398471f24a$export$8f31e4c4a37b8e9c);
$parcel$export(module.exports, "SkeletonRegion", () => $c90190398471f24a$export$8b3e24dbbac64362);
$parcel$export(module.exports, "SkeletonText", () => $c90190398471f24a$export$cb6ddd830302c2a8);
$parcel$export(module.exports, "SkeletonAvatar", () => $c90190398471f24a$export$53c2c5a35a7e31a2);
$parcel$export(module.exports, "SkeletonButton", () => $c90190398471f24a$export$7387c3f2666b9f16);
$parcel$export(module.exports, "SkeletonInput", () => $c90190398471f24a$export$5ce4f4d8e50e2948);
$parcel$export(module.exports, "SkeletonCard", () => $c90190398471f24a$export$5956eb8f2ff4afde);
$parcel$export(module.exports, "SkeletonRow", () => $c90190398471f24a$export$8bbcb87f63697989);
$parcel$export(module.exports, "SkeletonTable", () => $c90190398471f24a$export$6a15d3f7c248c5bb);
$parcel$export(module.exports, "SkeletonList", () => $c90190398471f24a$export$9e2e66b17fdb9730);
$parcel$export(module.exports, "SkeletonTabs", () => $c90190398471f24a$export$452537ec11d5437e);
$parcel$export(module.exports, "SkeletonChart", () => $c90190398471f24a$export$9e5a4339fadac171);
$parcel$export(module.exports, "SkeletonForm", () => $c90190398471f24a$export$68fb050a45c52f04);
$parcel$export(module.exports, "SkeletonHeader", () => $c90190398471f24a$export$171a4533b2ae49b5);
$parcel$export(module.exports, "SkeletonFilters", () => $c90190398471f24a$export$f70e1ea07462d9df);
$parcel$export(module.exports, "SkeletonStats", () => $c90190398471f24a$export$3122f708803a735a);
$parcel$export(module.exports, "default", () => $c90190398471f24a$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $j9AxR = parcelRequire("j9AxR");
'use client';
// ─────────────────────────────────────────────────────────────────────────────
// Skeleton family — the loading state of every Parsina screen.
//
// A screen that is fetching draws ITS OWN SHAPE in placeholder blocks: the
// header, tabs, filters, table or cards it is about to show, at the sizes they
// will have. Not a centred spinner, not «در حال بارگذاری…», not a blank page —
// see DESIGN.md §"Loading & skeleton". The primitives here are the vocabulary;
// each screen composes its own skeleton from them (`PatientDetailSkeleton`,
// `ReceptionSkeleton`, …) so the skeleton matches THAT screen, desktop and
// mobile alike, and nothing jumps when the data lands.
//
// Sizes mirror the real components on purpose: `SkeletonInput` is 44px like a
// `TextInput`, `SkeletonButton` 44px like a `Button`, `SkeletonTable` rows are
// 52px (44 dense) like `Table`, `SkeletonCard` has the `Card` surface. If a real
// component's geometry changes, change its skeleton in the same commit.
//
// Every block is `aria-hidden`; a composite root carries `role="status"`,
// `aria-busy` and an accessible `label` (a prop, rule 7) so assistive tech hears
// ONE "loading" instead of forty empty boxes. Motion respects
// `prefers-reduced-motion`: the sheen stops, the blocks stay.
// ─────────────────────────────────────────────────────────────────────────────
const $c90190398471f24a$var$SHIMMER_CSS = `
  @keyframes parsina-shimmer {
    0%   { background-position: 200% 0 }
    100% { background-position: -200% 0 }
  }
  [data-skeleton] {
    background: linear-gradient(90deg, ${(0, $jTCZr.SKELETON).base} 25%, ${(0, $jTCZr.SKELETON).sheen} 50%, ${(0, $jTCZr.SKELETON).base} 75%);
    background-size: 200% 100%;
    animation: parsina-shimmer 1.4s ease-in-out infinite;
  }
  [data-skeleton][data-tone="onDark"] {
    background: linear-gradient(90deg, ${(0, $jTCZr.SKELETON).onDark} 25%, ${(0, $jTCZr.SKELETON).onDarkSheen} 50%, ${(0, $jTCZr.SKELETON).onDark} 75%);
    background-size: 200% 100%;
  }
  @media (prefers-reduced-motion: reduce) {
    [data-skeleton] { animation: none; background: ${(0, $jTCZr.SKELETON).base}; }
    [data-skeleton][data-tone="onDark"] { background: ${(0, $jTCZr.SKELETON).onDark}; }
  }
`;
// One stylesheet for the whole family. React 19 hoists a <style> with `href` +
// `precedence` into <head> once, however many skeletons are on screen.
const $c90190398471f24a$var$Styles = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", {
        href: "parsina-skeleton",
        precedence: "default"
    }, $c90190398471f24a$var$SHIMMER_CSS);
function $c90190398471f24a$export$8f31e4c4a37b8e9c({ width: width = '100%', height: height = 14, radius: radius = (0, $jTCZr.RADIUS).chip, circle: circle = false, tone: tone, style: style, className: className, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$var$Styles, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        "data-skeleton": "",
        // `tone="onDark"` — white-alpha blocks for a gradient header, a sidebar
        // or a dark image canvas, where the neutral grey would read as a hole.
        "data-tone": tone === 'onDark' ? 'onDark' : undefined,
        className: className,
        style: {
            width: width,
            height: circle ? width : height,
            borderRadius: circle ? '50%' : radius,
            flexShrink: 0,
            ...style
        },
        ...rest
    }));
}
// Whether we are already inside an announced skeleton region. A page skeleton
// composed of a SkeletonStats, a SkeletonTable and two SkeletonCards used to
// announce "loading" four times; only the OUTERMOST region speaks now, the
// nested ones are plain hidden boxes.
const $c90190398471f24a$var$Nested = /*#__PURE__*/ (0, $acw62.createContext)(false);
function $c90190398471f24a$export$8b3e24dbbac64362({ as: Tag = 'div', label: label, style: style, children: children, ...rest }) {
    const nested = (0, $acw62.useContext)($c90190398471f24a$var$Nested);
    if (nested) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, {
        "aria-hidden": true,
        "data-state": "loading",
        style: style,
        ...rest
    }, children);
    // An announced region is named in whatever language the page is showing: the
    // caller's `label`, or the kit's own word for "loading" in `<html lang>`.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$var$Nested.Provider, {
        value: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, {
        role: "status",
        "aria-busy": "true",
        "aria-label": label ?? (0, $j9AxR.kitCopy)().loading,
        "data-state": "loading",
        style: style,
        ...rest
    }, children));
}
const $c90190398471f24a$var$Root = $c90190398471f24a$export$8b3e24dbbac64362;
// Line widths for a paragraph — the last line is shorter, like real text.
const $c90190398471f24a$var$LINE_WIDTHS = [
    '100%',
    '92%',
    '96%',
    '85%',
    '70%'
];
function $c90190398471f24a$export$cb6ddd830302c2a8({ width: width = '60%', height: height = 14, lines: lines = 1, lastWidth: lastWidth = '60%', gap: gap = 8, style: style, ...rest }) {
    if (lines <= 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: width,
        height: height,
        style: style,
        ...rest
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: gap,
            width: '100%',
            ...style
        },
        ...rest
    }, Array.from({
        length: lines
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            key: i,
            height: height,
            width: i === lines - 1 ? lastWidth : $c90190398471f24a$var$LINE_WIDTHS[i % $c90190398471f24a$var$LINE_WIDTHS.length]
        })));
}
function $c90190398471f24a$export$53c2c5a35a7e31a2({ size: size = 40, style: style, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: size,
        circle: true,
        style: style,
        ...rest
    });
}
function $c90190398471f24a$export$7387c3f2666b9f16({ width: width = 112, size: size = 'default', style: style, ...rest }) {
    const height = size === 'sm' ? 36 : size === 'icon' ? 40 : 44;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: size === 'icon' ? height : width,
        height: height,
        radius: (0, $jTCZr.RADIUS).control,
        style: style,
        ...rest
    });
}
function $c90190398471f24a$export$5ce4f4d8e50e2948({ label: label = true, labelWidth: labelWidth = 88, multiline: multiline = false, width: width = '100%', style: style, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 6,
            width: width,
            ...style
        },
        ...rest
    }, label ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: labelWidth,
        height: 12
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: "100%",
        height: multiline ? 96 : 44,
        radius: (0, $jTCZr.RADIUS).control
    }));
}
function $c90190398471f24a$export$5956eb8f2ff4afde({ avatar: avatar = true, lines: lines = 0, chips: chips = 2, actions: actions = 2, padding: padding = 20, style: style, label: label, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$var$Root, {
        label: label,
        ...rest,
        style: {
            background: (0, $jTCZr.C).card,
            borderRadius: (0, $jTCZr.RADIUS).card,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            padding: padding,
            display: 'flex',
            flexDirection: 'column',
            gap: 14,
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 12
        }
    }, avatar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$53c2c5a35a7e31a2, {
        size: 48
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: "60%",
        height: 14
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: "40%",
        height: 11
    }))), lines > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$cb6ddd830302c2a8, {
        lines: lines,
        height: 12
    }) : null, chips > 0 || actions > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            height: 1,
            background: (0, $jTCZr.C).border
        }
    }) : null, chips > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 6
        }
    }, Array.from({
        length: chips
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            key: i,
            width: 60 + i % 2 * 12,
            height: 22,
            radius: (0, $jTCZr.RADIUS).pill
        }))) : null, actions > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 8
        }
    }, Array.from({
        length: actions
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            key: i,
            height: 36,
            radius: (0, $jTCZr.RADIUS).control,
            style: {
                flex: 1
            }
        }))) : null);
}
const $c90190398471f24a$var$ROW_WIDTHS = [
    48,
    120,
    100,
    70,
    80,
    70,
    100
];
function $c90190398471f24a$export$8bbcb87f63697989({ cols: cols = 7, widths: widths = $c90190398471f24a$var$ROW_WIDTHS, dense: dense = false, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", {
        "aria-hidden": true,
        style: {
            borderTop: `1px solid ${(0, $jTCZr.C).border}`,
            height: dense ? 44 : 52
        },
        ...rest
    }, Array.from({
        length: cols
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            key: i,
            style: {
                padding: '0 16px'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: widths[i % widths.length] || 80,
            height: i === 0 ? 18 : 13
        }))));
}
function $c90190398471f24a$export$6a15d3f7c248c5bb({ rows: rows = 6, columns: columns = 5, dense: dense = false, header: header = true, style: style, label: label, ...rest }) {
    const cols = Array.isArray(columns) ? columns : Array.from({
        length: columns
    }, (_, i)=>$c90190398471f24a$var$ROW_WIDTHS[(i + 1) % $c90190398471f24a$var$ROW_WIDTHS.length]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$var$Root, {
        label: label,
        ...rest,
        style: {
            background: (0, $jTCZr.C).card,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: (0, $jTCZr.RADIUS).card,
            overflow: 'hidden',
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("table", {
        style: {
            width: '100%',
            borderCollapse: 'collapse',
            tableLayout: 'fixed'
        }
    }, header ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", {
        style: {
            background: (0, $jTCZr.CT).surface2,
            height: 40
        }
    }, cols.map((w, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
            key: i,
            style: {
                padding: '0 16px',
                textAlign: 'start'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: Math.min(typeof w === 'number' ? w * 0.7 : 72, 96),
            height: 11
        }))))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tbody", null, Array.from({
        length: rows
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8bbcb87f63697989, {
            key: i,
            cols: cols.length,
            widths: cols,
            dense: dense
        })))));
}
function $c90190398471f24a$export$9e2e66b17fdb9730({ count: count = 5, avatar: avatar = true, trailing: trailing = 56, divided: divided = true, style: style, label: label, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$var$Root, {
        label: label,
        ...rest,
        style: {
            display: 'flex',
            flexDirection: 'column',
            ...style
        }
    }, Array.from({
        length: count
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                minHeight: avatar ? 64 : 52,
                padding: '0 4px',
                borderTop: divided && i > 0 ? `1px solid ${(0, $jTCZr.C).border}` : 'none'
            }
        }, avatar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$53c2c5a35a7e31a2, {
            size: 40
        }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                gap: 6
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: `${55 + i * 17 % 30}%`,
            height: 14
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: `${30 + i * 11 % 25}%`,
            height: 11
        })), trailing > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: trailing,
            height: 22,
            radius: (0, $jTCZr.RADIUS).pill
        }) : null)));
}
function $c90190398471f24a$export$452537ec11d5437e({ count: count = 4, widths: widths, gap: gap = 4, padding: padding = '12px 14px', style: style, ...rest }) {
    const ws = widths || Array.from({
        length: count
    }, (_, i)=>[
            72,
            60,
            96,
            84,
            68
        ][i % 5]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            display: 'flex',
            gap: gap,
            borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
            overflowX: 'hidden',
            ...style
        },
        ...rest
    }, ws.map((w, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                padding: padding
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: w,
            height: 13
        }))));
}
const $c90190398471f24a$var$BAR_HEIGHTS = [
    0.55,
    0.8,
    0.4,
    0.95,
    0.65,
    0.75,
    0.5,
    0.85,
    0.6,
    0.7,
    0.45,
    0.9
];
function $c90190398471f24a$export$9e5a4339fadac171({ height: height = 200, bars: bars = 8, line: line = false, legend: legend = 2, style: style, label: label, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$var$Root, {
        label: label,
        ...rest,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 12,
            ...style
        }
    }, legend > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 14
        }
    }, Array.from({
        length: legend
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 6
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: 10,
            circle: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: 56,
            height: 11
        })))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            height: height,
            display: 'flex',
            alignItems: 'flex-end',
            gap: 8,
            borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
            padding: '0 8px'
        }
    }, line ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: "100%",
        height: Math.round(height * 0.35),
        radius: (0, $jTCZr.RADIUS).card,
        style: {
            marginBottom: Math.round(height * 0.25)
        }
    }) : Array.from({
        length: bars
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            key: i,
            height: Math.round(height * $c90190398471f24a$var$BAR_HEIGHTS[i % $c90190398471f24a$var$BAR_HEIGHTS.length]),
            radius: (0, $jTCZr.RADIUS).chip,
            style: {
                flex: 1,
                width: 'auto'
            }
        }))));
}
function $c90190398471f24a$export$68fb050a45c52f04({ fields: fields = 4, columns: columns = 1, actions: actions = 1, multiline: multiline = [], gap: gap = 16, style: style, label: label, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$var$Root, {
        label: label,
        ...rest,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: gap,
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'grid',
            gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
            gap: gap
        }
    }, Array.from({
        length: fields
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$5ce4f4d8e50e2948, {
            key: i,
            multiline: multiline.includes(i),
            style: multiline.includes(i) && columns > 1 ? {
                gridColumn: '1 / -1'
            } : undefined
        }))), actions > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 8,
            justifyContent: 'flex-end'
        }
    }, Array.from({
        length: actions
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$7387c3f2666b9f16, {
            key: i,
            width: i === 0 ? 120 : 96
        }))) : null);
}
function $c90190398471f24a$export$171a4533b2ae49b5({ subtitle: subtitle = true, actions: actions = 1, back: back = false, style: style, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 12,
            minHeight: 44,
            ...style
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            minWidth: 0
        }
    }, back ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: 36,
        height: 36,
        radius: (0, $jTCZr.RADIUS).control
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: 160,
        height: 20
    }), subtitle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: 110,
        height: 12
    }) : null)), actions > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 8
        }
    }, Array.from({
        length: actions
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$7387c3f2666b9f16, {
            key: i,
            width: i === 0 ? 112 : 44
        }))) : null);
}
function $c90190398471f24a$export$f70e1ea07462d9df({ search: search = true, chips: chips = 3, style: style, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            flexWrap: 'wrap',
            ...style
        },
        ...rest
    }, search ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: 240,
        height: 44,
        radius: (0, $jTCZr.RADIUS).control,
        style: {
            maxWidth: '100%'
        }
    }) : null, Array.from({
        length: chips
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            key: i,
            width: [
                84,
                72,
                96,
                64
            ][i % 4],
            height: 36,
            radius: (0, $jTCZr.RADIUS).pill
        })));
}
function $c90190398471f24a$export$3122f708803a735a({ count: count = 4, icon: icon = true, style: style, label: label, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$var$Root, {
        label: label,
        ...rest,
        style: {
            display: 'grid',
            gridTemplateColumns: `repeat(${count}, minmax(0, 1fr))`,
            gap: 12,
            ...style
        }
    }, Array.from({
        length: count
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                background: (0, $jTCZr.C).card,
                borderRadius: 12,
                padding: '16px 20px',
                display: 'flex',
                alignItems: 'center',
                gap: 14,
                border: `1px solid ${(0, $jTCZr.C).border}`
            }
        }, icon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: 44,
            height: 44,
            radius: 12
        }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: 8,
                flex: 1
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: "55%",
            height: 22
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: "70%",
            height: 11
        })))));
}
var $c90190398471f24a$export$2e2bcd8739ae039 = $c90190398471f24a$export$8f31e4c4a37b8e9c;

});

parcelRegister("7gSBD", function(module, exports) {

$parcel$export(module.exports, "default", () => $838915ee2bfb8ab1$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $gYS9K = parcelRequire("gYS9K");

var $jTCZr = parcelRequire("jTCZr");
'use client';
function $838915ee2bfb8ab1$export$2e2bcd8739ae039({ icon: icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gYS9K.default), {
    size: 44,
    strokeWidth: 1.5,
    "aria-hidden": true
}), title: title, description: description, action: action, fill: fill = false, style: style, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...rest,
        style: {
            textAlign: 'center',
            padding: '60px 20px',
            animation: 'fadeUp .3s ease',
            ...fill && {
                flex: 1,
                minHeight: 0,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center'
            },
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '3.5rem',
            marginBottom: 16,
            color: (0, $jTCZr.C).textMuted,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }
    }, icon), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '1.125rem',
            fontWeight: 700,
            color: (0, $jTCZr.C).textPrimary,
            marginBottom: 8
        }
    }, title), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.8125rem',
            color: (0, $jTCZr.C).textMuted
        }
    }, description), action && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: 16
        }
    }, action));
}

});
parcelRegister("gYS9K", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c08c9e83bb1a976$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $5c08c9e83bb1a976$export$a2387ed3b5d536eb = {
    name: "inbox",
    size: 24,
    node: [
        [
            "polyline",
            {
                points: "22 12 16 12 14 15 10 15 8 12 2 12",
                key: "o97t9d"
            }
        ],
        [
            "path",
            {
                d: "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z",
                key: "oot6mr"
            }
        ]
    ]
};
$5c08c9e83bb1a976$export$a2387ed3b5d536eb.node;
const $5c08c9e83bb1a976$export$2e2bcd8739ae039 = (0, $9QBug.default)($5c08c9e83bb1a976$export$a2387ed3b5d536eb);

});


parcelRegister("7wZCE", function(module, exports) {

$parcel$export(module.exports, "avatarColor", () => $a53b6ea678d7efe0$export$75ef3c97b2be2f20);
$parcel$export(module.exports, "default", () => $a53b6ea678d7efe0$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
// Inlined so the component carries no bundler-specific asset import (Parcel's
// `url:` scheme does not exist in Next.js) — same default-avatar silhouette.
const $a53b6ea678d7efe0$var$defaultAvatarSrc = 'data:image/svg+xml;utf8,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40"><rect width="40" height="40" fill="#e2e8f0"/><circle cx="20" cy="15" r="7" fill="#94a3b8"/><path d="M6 38c1.8-8 7.5-12 14-12s12.2 4 14 12z" fill="#94a3b8"/></svg>');
const $a53b6ea678d7efe0$var$AVATAR_COLORS = [
    '#1d4ed8',
    '#0891b2',
    '#0d9488',
    '#7c3aed',
    '#db2777',
    '#ea580c',
    '#16a34a'
];
function $a53b6ea678d7efe0$export$75ef3c97b2be2f20(name) {
    const s = name || '';
    let h = 0;
    for(let i = 0; i < s.length; i++)h = s.charCodeAt(i) + ((h << 5) - h);
    return $a53b6ea678d7efe0$var$AVATAR_COLORS[Math.abs(h) % $a53b6ea678d7efe0$var$AVATAR_COLORS.length];
}
const $a53b6ea678d7efe0$var$Avatar = ({ name: name, size: size = 40, bg: bg, color: color = 'white', src: src })=>{
    const resolvedBg = bg ?? $a53b6ea678d7efe0$export$75ef3c97b2be2f20(name);
    const [status, setStatus] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(src ? 'loading' : 'idle');
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setStatus(src ? 'loading' : 'idle');
    }, [
        src
    ]);
    const initials = (name || '').split(' ').filter(Boolean).map((w)=>w[0]).join('').slice(0, 2) || '?';
    const isSkeleton = status === 'loading';
    const isError = status === 'error';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: size,
            height: size,
            borderRadius: '50%',
            background: isSkeleton ? '#e2e8f0' : src && !isError ? 'transparent' : resolvedBg,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: size * 0.35,
            fontWeight: '700',
            color: color,
            flexShrink: 0,
            overflow: 'hidden',
            position: 'relative',
            animation: isSkeleton ? 'avatar-pulse 1.4s ease-in-out infinite' : 'none'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", null, `@keyframes avatar-pulse{0%,100%{opacity:1}50%{opacity:.4}}`), src && !isError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: src,
        alt: name,
        onLoad: ()=>setStatus('loaded'),
        onError: ()=>setStatus('error'),
        style: {
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            opacity: isSkeleton ? 0 : 1,
            transition: 'opacity 0.25s',
            position: 'absolute',
            inset: 0
        }
    }), (!src || isError) && (isError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: $a53b6ea678d7efe0$var$defaultAvatarSrc,
        alt: "",
        style: {
            width: '100%',
            height: '100%',
            objectFit: 'cover'
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, initials)));
};
var $a53b6ea678d7efe0$export$2e2bcd8739ae039 = $a53b6ea678d7efe0$var$Avatar;

});

parcelRegister("2xPWT", function(module, exports) {

var $acw62 = parcelRequire("acw62");

var $7wZCE = parcelRequire("7wZCE");

var $66joL = parcelRequire("66joL");

var $jTCZr = parcelRequire("jTCZr");

var $5JYPc = parcelRequire("5JYPc");
'use client';
// ─────────────────────────────────────────────────────────────────────────────
// PersonRow — a person, offered for choosing or simply stated.
//
// ── Why this is kit ─────────────────────────────────────────────────────────
// RECEPTION_PRACTITIONER_BOOKING §6.2 specifies a row anatomy for the clinic's
// practitioner picker — avatar, name, a meta line of «حرفه · تخصص · مدت», a
// trailing availability phrase, an ordinal for the first nine, and a disabled
// state that still says WHY. The patient app's practitioner step is the same
// row with different words in it. Two apps, one anatomy, and a *document*
// specifying it app-agnostically: §17.1 answers yes twice over.
//
// The rule it encodes is DESIGN.md rule 12 — an avatar means a person. This is
// not for anything that is not somebody.
//
// ── One component, two sizes — deliberately not two components ──────────────
// `size="sm"` is the CHIP: the pill in the clinic `BookingModal`'s header and
// the identity line of the patient's booking overlay. It is the same person
// with the same avatar and the same two lines, smaller and not tappable —
// shipping it as a second export would be the many-components failure §17.1
// warns about, and would let the two drift.
//
// Interactivity follows `onClick`: with one it is a real `<button>` and grows a
// chevron; without one it is a `<div>` that states rather than offers. A caller
// never has to ask for both.
//
// ── Unbookable is shown, never hidden (§2.6, §8.5) ──────────────────────────
// `disabled` mutes the row and shows `disabledReason` instead of dropping it
// from the list. Omitting is what makes a list lie: a patient looking for a
// specific doctor concludes they have left the clinic. `action` is the way out
// of the reason — the «تعریف ↗» link the clinic offers somebody who may fix it
// — and is simply not passed to a caller who may not.
//
// ── No copy, no numbers of its own ──────────────────────────────────────────
// §16.2 / §16.1: `name`, `meta`, `trailing`, `disabledReason` and `ordinal` are
// rendered VERBATIM, so their digits are whatever the app's own seam already
// made them. This component must never call a formatter and carries no
// catalogue. The patient app's `formatNumber` and the clinic's `formatDigits`
// are different seams, and both stay on their side of this line.
// ─────────────────────────────────────────────────────────────────────────────
// The chevron points the way the reader travels, which flips with the document.
// `--dir-flip` is the kit's one mirror (§11) — there is no `dir` prop, because a
// component that took one could be told to disagree with <html>.
const $cff717c1fa706fb8$var$Chevron = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "16",
        height: "16",
        fill: "currentColor",
        "aria-hidden": true,
        style: {
            flexShrink: 0,
            color: (0, $jTCZr.C).textMuted,
            transform: 'scaleX(var(--dir-flip, 1))'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
    }));
const $cff717c1fa706fb8$var$SIZES = {
    md: {
        avatar: 34,
        pad: '0.6875rem 0.875rem',
        radius: (0, $jTCZr.RADIUS).card,
        name: '0.84375rem',
        meta: '0.75rem',
        gap: '0.625rem'
    },
    sm: {
        avatar: 28,
        pad: '0.3125rem 0.75rem',
        radius: (0, $jTCZr.RADIUS).pill,
        name: '0.8125rem',
        meta: '0.6875rem',
        gap: '0.5rem'
    }
};
function $cff717c1fa706fb8$export$2e2bcd8739ae039({ name: name, meta: meta, trailing: trailing, ordinal: ordinal, avatar: avatar, size: size = 'md', selected: selected = false, disabled: disabled = false, disabledReason: disabledReason, action: action, chevron: chevron, onClick: onClick, as: as, className: className, 'data-testid': testId, ...rest }) {
    const S = $cff717c1fa706fb8$var$SIZES[size] || $cff717c1fa706fb8$var$SIZES.md;
    const interactive = typeof onClick === 'function' && !disabled;
    const showChevron = chevron === undefined ? interactive : chevron && !disabled;
    const tail = disabled && disabledReason ? disabledReason : trailing;
    const Tag = as || (interactive ? 'button' : 'div');
    const isButton = Tag === 'button';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, {
        type: isButton ? 'button' : undefined,
        onClick: interactive ? onClick : undefined,
        disabled: isButton ? disabled : undefined,
        "aria-disabled": !isButton && disabled ? true : undefined,
        "aria-selected": rest.role === 'option' ? selected : undefined,
        "data-testid": testId,
        "data-state": disabled ? 'disabled' : selected ? 'selected' : 'default',
        className: (0, $5JYPc.cn)(interactive || size === 'md' ? 'w-full text-start' : 'text-start', className),
        style: {
            // A chip HUGS its contents; a row fills the list it is in. A
            // block-level chip stretched to the panel width reads as an empty field
            // rather than as a named person.
            display: size === 'sm' ? 'inline-flex' : 'flex',
            width: size === 'sm' ? 'fit-content' : undefined,
            maxWidth: '100%',
            alignItems: 'center',
            gap: S.gap,
            padding: S.pad,
            borderRadius: S.radius,
            border: size === 'sm' ? 'none' : `1px solid ${selected ? (0, $jTCZr.CT).accent : (0, $jTCZr.C).border}`,
            background: size === 'sm' ? (0, $jTCZr.C).bg : selected ? (0, $jTCZr.soft)((0, $jTCZr.CT).accent, 0.08) : (0, $jTCZr.C).card,
            cursor: disabled ? 'not-allowed' : interactive ? 'pointer' : 'default',
            opacity: disabled ? 0.6 : 1,
            // ≥ 2.75rem is the phone hit target (MOBILE_WEB_PWA §5); a chip is not a
            // target at all, so it is exempt.
            minHeight: size === 'sm' ? undefined : '2.75rem',
            minWidth: 0,
            transition: 'background 0.15s, border-color 0.15s'
        },
        ...rest
    }, ordinal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true,
        style: {
            flexShrink: 0,
            width: '1.25rem',
            textAlign: 'center',
            fontSize: '0.6875rem',
            fontWeight: 800,
            color: (0, $jTCZr.C).textMuted
        }
    }, ordinal) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7wZCE.default), {
        name: avatar?.name ?? (typeof name === 'string' ? name : ''),
        bg: avatar?.color,
        src: avatar?.src,
        size: S.avatar
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            minWidth: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: '0.125rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            fontSize: S.name,
            fontWeight: 700,
            color: (0, $jTCZr.C).textPrimary,
            lineHeight: 1.4,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        }
    }, name), meta ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            fontSize: S.meta,
            color: (0, $jTCZr.C).textMuted,
            lineHeight: 1.5,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        }
    }, meta) : null), tail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            flexShrink: 0,
            fontSize: '0.6875rem',
            fontWeight: 700,
            lineHeight: 1.5,
            color: disabled ? (0, $jTCZr.CT).warnInk : (0, $jTCZr.CT).accentInk,
            textAlign: 'end'
        }
    }, tail) : null, action, showChevron ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($cff717c1fa706fb8$var$Chevron, null) : null);
}
function $cff717c1fa706fb8$export$fb8511da6566433c({ count: count = 4, size: size = 'md', label: label, 'data-testid': testId }) {
    const S = $cff717c1fa706fb8$var$SIZES[size] || $cff717c1fa706fb8$var$SIZES.md;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonRegion), {
        label: label,
        "data-testid": testId,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem'
        }
    }, Array.from({
        length: count
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: S.gap,
                padding: S.pad,
                borderRadius: S.radius,
                border: `1px solid ${(0, $jTCZr.C).border}`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
            width: S.avatar,
            height: S.avatar,
            radius: (0, $jTCZr.RADIUS).pill
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                gap: '0.25rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
            width: "45%",
            height: 11,
            radius: (0, $jTCZr.RADIUS).chip
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
            width: "30%",
            height: 9,
            radius: (0, $jTCZr.RADIUS).chip
        })))));
}

});

parcelRegister("4LQcd", function(module, exports) {

var $acw62 = parcelRequire("acw62");

var $66joL = parcelRequire("66joL");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5JYPc");

var $j9AxR = parcelRequire("j9AxR");
'use client';
function $7718f00aead6941c$export$2e2bcd8739ae039({ state: state = 'content', slots: slots = [], value: value, onSelect: onSelect, notice: notice = null, label: label, loadingLabel: loadingLabel, min: min = '5rem', columns: columns, loadingCount: loadingCount = 12, className: className, 'data-testid': testId, ...rest }) {
    if (label === undefined) label = (0, $j9AxR.kitCopy)().slotGrid.label;
    if (loadingLabel === undefined) loadingLabel = (0, $j9AxR.kitCopy)().slotGrid.loading;
    const gridStyle = {
        display: 'grid',
        gridTemplateColumns: columns ? `repeat(${columns}, minmax(0, 1fr))` : `repeat(auto-fill, minmax(${min}, 1fr))`,
        gap: '0.5rem'
    };
    if (state === 'loading') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonRegion), {
        label: loadingLabel,
        "data-testid": testId,
        "data-state": "loading",
        style: gridStyle
    }, Array.from({
        length: loadingCount
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
            key: i,
            height: 44,
            radius: (0, $jTCZr.RADIUS).control
        })));
    if (state === 'error' || state === 'empty') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId,
        "data-state": state,
        className: className,
        ...rest
    }, notice);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "group",
        "aria-label": label,
        "data-testid": testId,
        "data-state": "content",
        className: className,
        style: gridStyle,
        ...rest
    }, slots.map((slot)=>{
        const selected = value != null && slot.value === value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: slot.value,
            type: "button",
            onClick: slot.disabled ? undefined : ()=>onSelect?.(slot),
            disabled: slot.disabled,
            "aria-pressed": selected,
            "data-testid": `${testId || 'slot'}-${slot.value}`,
            "data-state": slot.disabled ? 'disabled' : selected ? 'selected' : 'default',
            "data-held": slot.held || undefined,
            className: "tabular-nums",
            style: {
                // ≥ 2.75rem: a time is among the smallest things a thumb has to
                // hit on this screen, and there are dozens of them.
                minHeight: '2.75rem',
                padding: '0.5rem 0.625rem',
                borderRadius: (0, $jTCZr.RADIUS).control,
                fontSize: '0.8125rem',
                fontWeight: 600,
                cursor: slot.disabled ? 'not-allowed' : 'pointer',
                border: selected ? `2px solid ${(0, $jTCZr.CT).accent}` : slot.held ? `1.5px dashed ${(0, $jTCZr.CT).warn}` : `1.5px solid ${(0, $jTCZr.C).border}`,
                background: selected ? (0, $jTCZr.soft)((0, $jTCZr.CT).accent, 0.14) : slot.held ? (0, $jTCZr.soft)((0, $jTCZr.CT).warn, 0.1) : (0, $jTCZr.C).card,
                color: selected ? (0, $jTCZr.CT).accentInk : (0, $jTCZr.C).textPrimary,
                opacity: slot.disabled ? 0.45 : 1,
                transition: 'background 0.14s, border-color 0.14s'
            }
        }, slot.label);
    }));
}

});

parcelRegister("g6X9N", function(module, exports) {

$parcel$export(module.exports, "default", () => $9169df7fa2fdff01$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $5JYPc = parcelRequire("5JYPc");
'use client';
// Card — the system's surface unit.
//
// With `onClick` it becomes a REAL button (never a `<div onClick>`): callers used
// to wrap it in a `role="button"` div to get keyboard operation and a focus ring
// back, which nested two interactive elements and handed screen readers a control
// inside a control. Those semantics belong here. Pass `role="link"` when the tap
// navigates rather than acts.
const $9169df7fa2fdff01$var$Card = ({ children: children, style: style, onClick: onClick, role: role, disabled: disabled, className: className, ...rest })=>{
    const surface = {
        background: (0, $jTCZr.C).card,
        borderRadius: 16,
        padding: '16px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
        border: `1px solid ${(0, $jTCZr.C).border}`,
        ...style
    };
    if (!onClick) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        style: surface,
        ...rest
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        role: role,
        disabled: disabled,
        onClick: onClick,
        className: (0, $5JYPc.cn)('outline-none focus-visible:ring-2 focus-visible:ring-ring', className),
        style: {
            ...surface,
            display: 'block',
            width: '100%',
            textAlign: 'inherit',
            font: 'inherit',
            color: 'inherit',
            cursor: disabled ? 'default' : 'pointer',
            transition: 'transform 0.15s, box-shadow 0.15s'
        },
        onMouseDown: (e)=>{
            if (!disabled) e.currentTarget.style.transform = 'scale(0.98)';
        },
        onMouseUp: (e)=>{
            e.currentTarget.style.transform = 'scale(1)';
        },
        onMouseLeave: (e)=>{
            e.currentTarget.style.transform = 'scale(1)';
        },
        ...rest
    }, children);
};
var $9169df7fa2fdff01$export$2e2bcd8739ae039 = $9169df7fa2fdff01$var$Card;

});

parcelRegister("7h7Jc", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f942082497afe1e$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
'use client';
function $4f942082497afe1e$export$2e2bcd8739ae039({ status: status, style: style }) {
    const cfg = (0, $jTCZr.statusColors)[status] || {
        label: status || "\u2014",
        bg: '#f1f5f9',
        text: '#64748b'
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.6875rem',
            fontWeight: 700,
            padding: '3px 10px',
            borderRadius: 20,
            background: cfg.bg,
            color: cfg.text,
            ...style
        }
    }, cfg.label);
}

});

parcelRegister("lUcdx", function(module, exports) {

$parcel$export(module.exports, "default", () => $178f36e6e586ad89$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
'use client';
function $178f36e6e586ad89$export$2e2bcd8739ae039({ label: label, value: value, unit: unit, icon: icon, bg: bg, accent: accent, loading: loading, minWidth: minWidth = 140, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...rest,
        style: {
            background: '#fff',
            borderRadius: 12,
            padding: '16px 20px',
            display: 'flex',
            alignItems: 'center',
            gap: 14,
            boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
            flex: 1,
            minWidth: minWidth,
            ...rest.style
        }
    }, icon !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 44,
            height: 44,
            borderRadius: 12,
            background: bg || (0, $jTCZr.C).bg,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '1.375rem',
            flexShrink: 0
        }
    }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '1.375rem',
            fontWeight: 800,
            color: accent || (0, $jTCZr.C).textPrimary,
            lineHeight: 1.15
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            whiteSpace: 'nowrap'
        }
    }, loading ? "\u2014" : value), unit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("wbr", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.875rem',
            fontWeight: 500,
            color: (0, $jTCZr.C).textMuted,
            marginInlineStart: 4,
            whiteSpace: 'nowrap'
        }
    }, unit))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.75rem',
            color: (0, $jTCZr.C).textSecondary,
            marginTop: 4
        }
    }, label)));
}

});

parcelRegister("fkDNf", function(module, exports) {

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
'use client';
function $64626580dc6749e0$export$2e2bcd8739ae039({ stats: stats, loading: loading, style: style }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: '#fff',
            borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
            padding: '12px 32px',
            display: 'flex',
            gap: 12,
            flexShrink: 0,
            overflowX: 'auto',
            ...style
        }
    }, stats.map((s, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                background: s.bg,
                borderRadius: 10,
                padding: '8px 16px'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '1.25rem',
                fontWeight: 800,
                color: s.color
            }
        }, loading ? "\u2014" : s.value), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.6875rem',
                fontWeight: 600,
                color: s.color,
                opacity: 0.75
            }
        }, s.label))));
}

});

parcelRegister("kyZIh", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed420e5a4f8c639f$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
'use client';
function $ed420e5a4f8c639f$export$2e2bcd8739ae039({ title: title, sub: sub, breadcrumb: breadcrumb, children: children, autoFocus: autoFocus = false, ...rest }) {
    const hasMeta = sub || breadcrumb;
    const titleRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!autoFocus) return;
        // `preventScroll`: the heading is already at the top of the page, and
        // scrolling on focus would fight the route change's own scroll reset.
        titleRef.current?.focus({
            preventScroll: true
        });
    }, [
        autoFocus
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...rest,
        style: {
            background: '#fff',
            borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
            padding: hasMeta ? '14px 32px' : '0 32px',
            display: 'flex',
            alignItems: 'center',
            gap: 20,
            minHeight: 64,
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1
        }
    }, breadcrumb && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.75rem',
            color: (0, $jTCZr.C).textMuted,
            marginBottom: 3
        }
    }, breadcrumb), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h1", {
        ref: titleRef,
        // -1: reachable by script, never a stop in the tab order. A heading
        // that took a Tab of its own would be a new obstacle on every page.
        tabIndex: autoFocus ? -1 : undefined,
        style: {
            margin: 0,
            fontWeight: 800,
            fontSize: '1.125rem',
            color: (0, $jTCZr.C).textPrimary,
            lineHeight: 1.2,
            outline: 'none'
        }
    }, title), sub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.8125rem',
            color: (0, $jTCZr.C).textMuted,
            marginTop: 3
        }
    }, sub)), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            flexShrink: 0
        }
    }, children));
}

});

parcelRegister("jOGbh", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c79ee8367a72d83$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $d8YVq = parcelRequire("d8YVq");

var $jTCZr = parcelRequire("jTCZr");

var $aJ1FU = parcelRequire("aJ1FU");

var $j9AxR = parcelRequire("j9AxR");
'use client';
function $3c79ee8367a72d83$export$2e2bcd8739ae039({ onBack: onBack, backLabel: backLabel, title: title, sub: sub, avatar: avatar, status: status, badges: badges, meta: meta, stats: stats, children: children, className: className, 'data-testid': testId, ...rest }) {
    if (backLabel === undefined) backLabel = (0, $j9AxR.kitCopy)().back;
    const metaItems = (meta || []).filter(Boolean);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("header", {
        className: className,
        "data-testid": testId,
        style: {
            background: (0, $jTCZr.C).card,
            borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
            paddingInline: '1.75rem',
            paddingBlock: '0.75rem',
            display: 'flex',
            alignItems: 'center',
            gap: '1rem',
            minHeight: '4rem',
            flexShrink: 0,
            flexWrap: 'wrap'
        },
        ...rest
    }, onBack && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        onClick: onBack,
        "aria-label": backLabel,
        title: backLabel,
        "data-testid": testId ? `${testId}-back` : undefined,
        className: "shrink-0 gap-1.5 ps-2 pe-3 text-muted-foreground hover:text-foreground"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d8YVq.default), {
        size: 16,
        "aria-hidden": true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.8125rem',
            fontWeight: 600
        }
    }, backLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            flex: 1,
            minWidth: 0
        }
    }, avatar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flexShrink: 0
        }
    }, avatar), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            minWidth: 0,
            flex: 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5625rem',
            flexWrap: 'wrap'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h1", {
        dir: "auto",
        style: {
            margin: 0,
            fontWeight: 800,
            fontSize: '1.125rem',
            lineHeight: 1.2,
            letterSpacing: '-0.01em',
            color: (0, $jTCZr.C).textPrimary
        }
    }, title), status, badges), sub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.8125rem',
            color: (0, $jTCZr.C).textMuted,
            marginTop: '0.1875rem'
        }
    }, sub), metaItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            flexWrap: 'wrap',
            marginTop: '0.1875rem',
            fontSize: '0.78125rem',
            color: (0, $jTCZr.C).textMuted
        }
    }, metaItems.map((m, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
            key: i
        }, i > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "aria-hidden": true,
            style: {
                width: 3,
                height: 3,
                borderRadius: '50%',
                background: (0, $jTCZr.C).textMuted,
                opacity: 0.6,
                flexShrink: 0
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, m)))))), (stats?.length || children) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            flexShrink: 0,
            flexWrap: 'wrap'
        }
    }, stats?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: '0.5625rem'
        }
    }, stats.map((s, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                minWidth: '4.5rem',
                paddingInline: '0.75rem',
                paddingBlock: '0.375rem',
                borderRadius: 'var(--radius, 0.625rem)',
                textAlign: 'center',
                background: s.accent ? (0, $jTCZr.CT).accentSoft : (0, $jTCZr.C).bg,
                border: `1px solid ${s.accent ? 'transparent' : (0, $jTCZr.C).border}`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.65625rem',
                fontWeight: 600,
                marginBottom: '0.0625rem',
                color: s.accent ? (0, $jTCZr.CT).accentInk : (0, $jTCZr.C).textMuted
            }
        }, s.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '1rem',
                fontWeight: 800,
                letterSpacing: '-0.01em',
                color: s.accent ? (0, $jTCZr.CT).accentInk : (0, $jTCZr.C).textPrimary,
                fontVariantNumeric: 'tabular-nums'
            }
        }, s.value)))), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
        }
    }, children)));
}

});
parcelRegister("d8YVq", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a140ead2dcbdb51$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $2a140ead2dcbdb51$export$a2387ed3b5d536eb = {
    name: "arrow-right",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M5 12h14",
                key: "1ays0h"
            }
        ],
        [
            "path",
            {
                d: "m12 5 7 7-7 7",
                key: "xquz4c"
            }
        ]
    ]
};
$2a140ead2dcbdb51$export$a2387ed3b5d536eb.node;
const $2a140ead2dcbdb51$export$2e2bcd8739ae039 = (0, $9QBug.default)($2a140ead2dcbdb51$export$a2387ed3b5d536eb);

});


parcelRegister("9TQrL", function(module, exports) {

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
'use client';
const $ca91b548719491bb$var$TopBar = ({ title: title, subtitle: subtitle, onBack: onBack, action: action })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: (0, $jTCZr.C).navy,
            padding: '16px 20px 20px',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 12
        }
    }, onBack && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: onBack,
        style: {
            background: 'rgba(255,255,255,0.15)',
            border: 'none',
            borderRadius: 10,
            width: 36,
            height: 36,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            color: 'white',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2.5",
        width: "18",
        height: "18"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polyline", {
        points: "9 18 15 12 9 6"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: 'white',
            fontSize: '1.125rem',
            fontWeight: 700
        }
    }, title), subtitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: 'rgba(255,255,255,0.65)',
            fontSize: '0.75rem',
            marginTop: 2
        }
    }, subtitle))), action));
var $ca91b548719491bb$export$2e2bcd8739ae039 = $ca91b548719491bb$var$TopBar;

});

parcelRegister("dSwFB", function(module, exports) {

$parcel$export(module.exports, "default", () => $62f4a9fc87ba90f8$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $d8YVq = parcelRequire("d8YVq");
var $gKFEi = parcelRequire("gKFEi");
var $e5Ore = parcelRequire("e5Ore");
var $6TdpC = parcelRequire("6TdpC");

var $jTCZr = parcelRequire("jTCZr");

var $7wZCE = parcelRequire("7wZCE");

var $aJ1FU = parcelRequire("aJ1FU");

var $j9AxR = parcelRequire("j9AxR");

var $aM2JY = parcelRequire("aM2JY");
'use client';
/**
 * MobileHeader — the gradient screen header that is the mobile brand signature
 * (DESIGN-CONCEPT-MOBILE §3.2). Every top-level mobile screen opens with it.
 *
 * Two modes, chosen by the props you pass — never a mode flag:
 *
 *   • **Cockpit** (`user`) — the person's name as a *greeting*, not chrome:
 *     avatar + «خوش آمدید،» + name on the inline-start edge. What a top-level
 *     bottom-nav destination uses.
 *   • **Content screen** (`onBack` + `title`) — a drilled-into full-screen
 *     surface has no bottom nav, so the header itself carries the way back:
 *     back affordance above the screen title, on the same brand chrome rather
 *     than in a separate bar above it (§3.1).
 *   • **Compact** (`compact`) — one 3.75rem row for a WORKSPACE screen, where
 *     the chrome competes with the work (the visit room): icon-only back,
 *     the title and `subtitle` as two short lines beside an optional `avatar`,
 *     then `action`, then `actions`. The title shrinks a step at a time
 *     (0.9375 → 0.75rem) before it ellipsises, so a long name is read rather
 *     than cut. `onTitleClick` makes the identity block a button — the name IS
 *     the way into the record — and `titleActionLabel` says so under it.
 *
 * Both modes render `title` as the page's single `<h1>` (§12.1) and accept
 * `actions` — white-alpha square quick actions ≥2.75rem, the sanctioned way to
 * tint on-gradient chrome (§2.2). A control that navigates nowhere is a defect,
 * so a caller passes an action only when its destination exists.
 *
 * `children` is the optional context-widget row (a date navigator, a filter
 * strip) rendered inside the gradient below the identity row.
 *
 * Props:
 *   title      — screen title; rendered as the page's <h1>
 *   subtitle   — optional line under the title
 *   greeting   — cockpit lead-in above the name (default «خوش آمدید،»)
 *   user       — { name, avatar } → cockpit greeting mode
 *   onBack     — back handler → content mode; renders the «بازگشت» affordance
 *   backLabel  — label for the back affordance (default «بازگشت»)
 *   actions    — [{ key, icon, label, onClick, badge? }] end-side quick actions;
 *                `badge` = { color } renders a small status dot
 *   action     — a single trailing node (shorthand; rendered after `actions`;
 *                in compact mode BEFORE them, so a live control such as the
 *                visit's listen pill sits next to the identity, and «⋯» last)
 *   compact    — the one-row workspace layout (see above)
 *   figures    — compact only (PM-0120): [{ key, value, label, color? }] rendered
 *                as ONE inline row of figures under the identity row, on the
 *                gradient (`DayStatStrip onDark`) — the place a content screen
 *                used to spend four stat tiles and ~200 px on. Hidden when every
 *                value is null and nothing is loading: a row of «–» is not a
 *                glance. `figuresLoading`, `figuresFormat`, `figuresLabel` and
 *                `figuresTestIdPrefix` (→ `<prefix>-stats`) are the strip's own.
 *   avatar     — compact only: `{ name, src }` → a 2rem avatar before the title
 *   leading    — compact only: one node right after the back affordance, in
 *                the header's top inline-START corner (the visit's event bell).
 *                It renders nothing when it has nothing to say, so the slot
 *                costs the title no width until then.
 *   onTitleClick / titleActionLabel — compact only: make the identity block a
 *                button and name its destination under the title
 *   backTestId — override for the back control's `data-testid`. Defaults to
 *                `${testId}-back`; a screen whose selector contract already
 *                names its own back control passes it here rather than
 *                renaming the whole header (which is what an app fork did).
 *   sticky     — pin the header to the top of its scroller. A list destination
 *                whose filter bar lives in `children` needs the bar to stay
 *                reachable while the list scrolls under it (§3.2).
 *   search     — `{ value, onChange, placeholder, clearLabel, onClear, onSubmit,
 *                autoFocus, testId }`. Renders the on-gradient search field that a lookup
 *                screen opens into: a real `<input>` at ≥2.75rem with an inline
 *                clear control, sitting above `children`. Passing it is what
 *                turns a 🔍 quick action into a search surface, so no screen
 *                hand-rolls a white field on the brand chrome again.
 *   children   — optional context-widget row
 *   className / data-testid — forwarded to the root (§15.1)
 */ function $62f4a9fc87ba90f8$var$QuickActions({ actions: actions, testId: testId }) {
    if (!actions?.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: '0.375rem',
            flexShrink: 0
        }
    }, actions.map(({ key: key, icon: icon, label: label, onClick: onClick, badge: badge })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: key,
            style: {
                position: 'relative'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            size: "icon",
            onClick: onClick,
            "aria-label": label,
            title: label,
            "data-testid": testId ? `${testId}-action-${key}` : undefined,
            className: "min-w-11 min-h-11 text-white hover:bg-white/25",
            style: {
                background: 'rgba(255,255,255,0.14)',
                borderRadius: 'var(--radius, 0.625rem)'
            }
        }, icon), badge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "aria-hidden": true,
            style: {
                position: 'absolute',
                top: '0.25rem',
                insetInlineEnd: '0.25rem',
                width: '0.5rem',
                height: '0.5rem',
                borderRadius: '50%',
                background: badge.color,
                border: '1.5px solid rgba(1,94,156,0.9)'
            }
        }))));
}
// The compact title: tries each size in turn and keeps the largest at which
// the text still fits its box, then ellipsises. A patient's full name is the
// one thing on a visit header that must be READ, and a phone gives it ~9rem.
const $62f4a9fc87ba90f8$var$TITLE_SIZES = [
    '0.9375rem',
    '0.875rem',
    '0.8125rem',
    '0.75rem'
];
function $62f4a9fc87ba90f8$var$FitTitle({ children: children, testId: testId }) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const [step, setStep] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(()=>{
        const el = ref.current;
        if (!el) return undefined;
        const fit = ()=>{
            let k = 0;
            el.style.fontSize = $62f4a9fc87ba90f8$var$TITLE_SIZES[0];
            while(k < $62f4a9fc87ba90f8$var$TITLE_SIZES.length - 1 && el.scrollWidth > el.clientWidth + 1){
                k += 1;
                el.style.fontSize = $62f4a9fc87ba90f8$var$TITLE_SIZES[k];
            }
            setStep(k);
        };
        fit();
        const ro = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(fit) : null;
        ro?.observe(el.parentElement || el);
        return ()=>ro?.disconnect();
    }, [
        children
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h1", {
        ref: ref,
        dir: "auto",
        "data-testid": testId,
        style: {
            margin: 0,
            minWidth: 0,
            color: '#fff',
            fontWeight: 700,
            lineHeight: 1.25,
            fontSize: $62f4a9fc87ba90f8$var$TITLE_SIZES[step],
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    }, children);
}
function $62f4a9fc87ba90f8$var$CompactIdentity({ title: title, subtitle: subtitle, avatar: avatar, onTitleClick: onTitleClick, titleActionLabel: titleActionLabel, testId: testId }) {
    const body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, avatar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7wZCE.default), {
        name: avatar.name || title || (0, $j9AxR.kitCopy)().mobileHeader.unknownInitial,
        size: 32,
        bg: "rgba(255,255,255,0.2)",
        src: avatar.src || undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            minWidth: 0,
            gap: '0.0625rem',
            textAlign: 'start'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($62f4a9fc87ba90f8$var$FitTitle, {
        testId: `${testId}-title`
    }, title), (subtitle || onTitleClick && titleActionLabel) && /* One run of inline text, so a narrow slot ellipsises the whole line
             instead of clipping the hint. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            minWidth: 0,
            fontSize: '0.6875rem',
            lineHeight: 1.3,
            color: 'rgba(255,255,255,0.72)',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    }, subtitle, subtitle && onTitleClick && titleActionLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true
    }, " \xb7 "), onTitleClick && titleActionLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: 'rgba(255,255,255,0.9)',
            fontWeight: 600
        }
    }, titleActionLabel, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gKFEi.default), {
        size: 11,
        "aria-hidden": true,
        style: {
            display: 'inline-block',
            verticalAlign: '-0.125em',
            marginInlineStart: '0.125rem',
            transform: 'scaleX(var(--dir-flip, 1))'
        }
    })))));
    const layout = {
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        minWidth: 0,
        flex: 1,
        minHeight: '2.75rem'
    };
    if (!onTitleClick) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: layout
    }, body);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onTitleClick,
        "aria-label": titleActionLabel ? `${titleActionLabel} \u{2014} ${title}` : title,
        "data-testid": `${testId}-identity`,
        className: "rounded-lg hover:bg-white/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/60",
        style: {
            ...layout,
            background: 'transparent',
            border: 0,
            padding: '0 0.25rem',
            color: '#fff',
            cursor: 'pointer',
            font: 'inherit'
        }
    }, body);
}
function $62f4a9fc87ba90f8$export$2e2bcd8739ae039({ title: title, subtitle: subtitle, greeting: greeting, user: user, onBack: onBack, backLabel: backLabel, actions: actions = [], action: action, compact: compact = false, figures: figures, figuresLoading: figuresLoading = false, figuresFormat: figuresFormat, figuresLabel: figuresLabel, figuresTestIdPrefix: figuresTestIdPrefix = 'header', avatar: avatar, leading: leading, onTitleClick: onTitleClick, titleActionLabel: titleActionLabel, backTestId: backTestId, sticky: sticky = false, search: search, children: children, className: className, style: style, 'data-testid': testId = 'mobile-header', ...rest }) {
    if (greeting === undefined) greeting = (0, $j9AxR.kitCopy)().mobileHeader.greeting;
    if (backLabel === undefined) backLabel = (0, $j9AxR.kitCopy)().back;
    if (compact) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("header", {
        className: className,
        "data-testid": testId,
        "data-compact": "",
        style: {
            background: (0, $jTCZr.GRADIENT_BRAND_DARK),
            padding: 'calc(0.5rem + env(safe-area-inset-top, 0px)) 0.75rem 0.5rem',
            position: sticky ? 'sticky' : 'relative',
            ...sticky ? {
                top: 0,
                zIndex: 30
            } : null,
            overflow: 'hidden',
            flexShrink: 0,
            ...style
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            position: 'absolute',
            top: '-2.5rem',
            insetInlineEnd: '-1.875rem',
            width: '6.25rem',
            height: '6.25rem',
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.05)'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            gap: '0.375rem',
            minHeight: '2.75rem'
        }
    }, onBack && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "icon",
        onClick: onBack,
        "aria-label": backLabel,
        title: backLabel,
        "data-testid": backTestId || `${testId}-back`,
        className: "min-w-11 min-h-11 shrink-0 text-white/90 hover:bg-white/15 hover:text-white"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d8YVq.default), {
        size: 20,
        "aria-hidden": true
    })), leading, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($62f4a9fc87ba90f8$var$CompactIdentity, {
        title: title,
        subtitle: subtitle,
        avatar: avatar,
        onTitleClick: onTitleClick,
        titleActionLabel: titleActionLabel,
        testId: testId
    }), action, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($62f4a9fc87ba90f8$var$QuickActions, {
        actions: actions,
        testId: testId
    })), figures && (figuresLoading || figures.some((f)=>f.value != null)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aM2JY.default), {
        onDark: true,
        items: figures,
        loading: figuresLoading,
        format: figuresFormat,
        ariaLabel: figuresLabel,
        testIdPrefix: figuresTestIdPrefix,
        style: {
            marginTop: '0.125rem',
            minHeight: '2rem'
        }
    }), search && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($62f4a9fc87ba90f8$var$SearchField, {
        ...search,
        headerTestId: testId
    }), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: '0.5rem'
        }
    }, children));
    const hasTrailing = actions.length > 0 || Boolean(action);
    const trailing = hasTrailing && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.375rem',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($62f4a9fc87ba90f8$var$QuickActions, {
        actions: actions,
        testId: testId
    }), action);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("header", {
        className: className,
        "data-testid": testId,
        style: {
            background: (0, $jTCZr.GRADIENT_BRAND_DARK),
            padding: 'calc(1rem + env(safe-area-inset-top, 0px)) 1rem 1.5rem',
            // `sticky` keeps the filter bar in `children` reachable while a long
            // list scrolls under it; `relative` is the default so the decorative
            // circles below still clip to the header.
            position: sticky ? 'sticky' : 'relative',
            ...sticky ? {
                top: 0,
                zIndex: 30
            } : null,
            overflow: 'hidden',
            flexShrink: 0,
            // A caller's `style` is MERGED OVER the computed layout, the convention
            // the rest of the kit follows (`Card`, the chat family). It used to fall
            // into `...rest` and — because the spread sits after this attribute —
            // REPLACE the whole object: passing `style` for so much as a
            // `position: sticky` silently deleted the brand gradient, the padding
            // and the safe-area inset, and left white text on a white page.
            ...style
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            position: 'absolute',
            top: '-1.875rem',
            insetInlineEnd: '-1.875rem',
            width: '8.75rem',
            height: '8.75rem',
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.04)'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            position: 'absolute',
            bottom: '-1.25rem',
            insetInlineStart: '-0.625rem',
            width: '6.25rem',
            height: '6.25rem',
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.06)'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'relative'
        }
    }, onBack ? /* Content mode — the way back lives on the brand chrome (§3.1). */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        onClick: onBack,
        "aria-label": backLabel,
        "data-testid": backTestId || `${testId}-back`,
        className: "h-auto min-h-11 gap-1.5 ps-0 pe-2 text-white/85 hover:bg-white/15 hover:text-white"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d8YVq.default), {
        size: 16,
        "aria-hidden": true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.8125rem',
            fontWeight: 600
        }
    }, backLabel)), trailing), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h1", {
        style: {
            margin: '0.25rem 0 0',
            color: '#fff',
            fontSize: '1.25rem',
            fontWeight: 800,
            lineHeight: 1.25
        }
    }, title)) : /* Cockpit mode — greeting (or a bare title) + quick actions (§3.2). */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (user || hasTrailing) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '0.75rem'
        }
    }, user ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.625rem',
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7wZCE.default), {
        name: user.name || (0, $j9AxR.kitCopy)().mobileHeader.unknownInitial,
        size: 40,
        bg: "rgba(255,255,255,0.2)",
        src: user.avatar || undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: 'rgba(255,255,255,0.65)',
            fontSize: '0.6875rem'
        }
    }, greeting), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: "auto",
        style: {
            color: '#fff',
            fontSize: '0.9375rem',
            fontWeight: 700,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        }
    }, user.name || "\u2026"))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null), trailing), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h1", {
        style: {
            margin: user || hasTrailing ? '0.75rem 0 0' : 0,
            color: '#fff',
            fontSize: '1.25rem',
            fontWeight: 800,
            lineHeight: 1.25
        }
    }, title)), subtitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: 'rgba(255,255,255,0.7)',
            fontSize: '0.75rem',
            marginTop: '0.25rem'
        }
    }, subtitle), search && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($62f4a9fc87ba90f8$var$SearchField, {
        ...search,
        headerTestId: testId
    }), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: '0.875rem'
        }
    }, children)));
}
/**
 * The on-gradient search field (§3.2). A real `<input>` — not a kit `TextInput`
 * — because the kit field is painted for a white surface and this one sits on
 * the brand chrome; the shared contract it does keep is the 2.75rem height, the
 * ≥1rem font (anything smaller triggers iOS focus-zoom) and a clear control.
 */ function $62f4a9fc87ba90f8$var$SearchField({ value: value = '', onChange: onChange, onClear: onClear, onSubmit: onSubmit, placeholder: placeholder, clearLabel: clearLabel, autoFocus: autoFocus = false, testId: testId, headerTestId: headerTestId }) {
    if (clearLabel === undefined) clearLabel = (0, $j9AxR.kitCopy)().mobileHeader.clear;
    const id = testId || `${headerTestId}-search`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("form", {
        role: "search",
        onSubmit: (e)=>{
            e.preventDefault();
            onSubmit?.(value);
        },
        style: {
            marginTop: '0.875rem',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            background: 'rgba(255,255,255,0.16)',
            borderRadius: (0, $jTCZr.RADIUS).control,
            paddingInline: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e5Ore.default), {
        size: 17,
        color: "rgba(255,255,255,0.75)",
        "aria-hidden": true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        type: "search",
        inputMode: "search",
        enterKeyHint: "search",
        autoFocus: autoFocus,
        value: value,
        onChange: (e)=>onChange?.(e.target.value),
        placeholder: placeholder,
        "data-testid": id,
        style: {
            flex: 1,
            minWidth: 0,
            height: '2.75rem',
            border: 'none',
            outline: 'none',
            background: 'transparent',
            color: '#fff',
            // ≥1rem or iOS zooms the whole page on focus and never zooms back.
            fontSize: '1rem',
            fontFamily: 'inherit'
        }
    }), value ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        type: "button",
        variant: "ghost",
        size: "icon",
        onClick: ()=>onClear?.(),
        "aria-label": clearLabel,
        "data-testid": `${id}-clear`,
        className: "min-w-11 min-h-11 text-white/80 hover:bg-white/15 hover:text-white"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
        size: 16,
        "aria-hidden": true
    })) : null);
}

});
parcelRegister("gKFEi", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b40836209aae972$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $2b40836209aae972$export$a2387ed3b5d536eb = {
    name: "chevron-left",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m15 18-6-6 6-6",
                key: "1wnfg3"
            }
        ]
    ]
};
$2b40836209aae972$export$a2387ed3b5d536eb.node;
const $2b40836209aae972$export$2e2bcd8739ae039 = (0, $9QBug.default)($2b40836209aae972$export$a2387ed3b5d536eb);

});

parcelRegister("e5Ore", function(module, exports) {

$parcel$export(module.exports, "default", () => $30b4d9519dd12f8d$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $30b4d9519dd12f8d$export$a2387ed3b5d536eb = {
    name: "search",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m21 21-4.34-4.34",
                key: "14j7rj"
            }
        ],
        [
            "circle",
            {
                cx: "11",
                cy: "11",
                r: "8",
                key: "4ej97u"
            }
        ]
    ]
};
$30b4d9519dd12f8d$export$a2387ed3b5d536eb.node;
const $30b4d9519dd12f8d$export$2e2bcd8739ae039 = (0, $9QBug.default)($30b4d9519dd12f8d$export$a2387ed3b5d536eb);

});

parcelRegister("6TdpC", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b6a18bc128c0629$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $4b6a18bc128c0629$export$a2387ed3b5d536eb = {
    name: "x",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M18 6 6 18",
                key: "1bl5f8"
            }
        ],
        [
            "path",
            {
                d: "m6 6 12 12",
                key: "d8bk6v"
            }
        ]
    ]
};
$4b6a18bc128c0629$export$a2387ed3b5d536eb.node;
const $4b6a18bc128c0629$export$2e2bcd8739ae039 = (0, $9QBug.default)($4b6a18bc128c0629$export$a2387ed3b5d536eb);

});

parcelRegister("aM2JY", function(module, exports) {

$parcel$export(module.exports, "default", () => $93cce909f7881164$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $aJ1FU = parcelRequire("aJ1FU");
'use client';
// ─────────────────────────────────────────────────────────────────────────────
// DayStatStrip — a day's figures as ONE row: the mobile KPI zone of a
// LIST-DOMINANT cockpit (MOBILE_WEB_PWA §4, `StatStrip`), where the list is the
// screen's purpose and the counts only frame it. It replaces 4-up tiles, which
// cost ~100px above the first row.
//
//   «۱۲ نوبت · ۳ منتظر · ۵ انجام · ۱ لغو»                       [end]
//
// Each number carries its semantic ink. A count that has not loaded is «–»,
// never 0 — a zero is a claim. Below 360px the words go and the coloured
// numbers stay; the row keeps a sentence for assistive tech either way.
//
// With `onSelect` each figure is also the FILTER it counts (aria-pressed): the
// clinic desk's status chips and its counts were two rows saying the same
// numbers, and are one here. Without it the row only reads.
//
// Promoted from the doctor app (DOCTOR_MOBILE_RECEPTION_REDESIGN §4.3), PM-0052.
//
// Props:
//   items      — [{ key, value (number|null), label, color? }]
//   loading    — every value reads «–»
//   format     — (n) => string; the caller's digits (default: String)
//   ariaLabel  — the row read as one sentence
//   activeKey / onSelect(key) — makes the figures toggle filters
//   end        — optional trailing node (a money figure, a link)
//   testIdPrefix — default 'reception' → `reception-stats`, `reception-stat-<key>`
//   onDark     — the strip on brand chrome (MobileHeader `figures`, PM-0120): white
//                ink, no surface, no rule — the gradient is the background
// ─────────────────────────────────────────────────────────────────────────────
const $93cce909f7881164$var$useNarrow = ()=>{
    const [narrow, setNarrow] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>typeof window !== 'undefined' && window.innerWidth < 360);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (typeof window === 'undefined') return undefined;
        const onResize = ()=>setNarrow(window.innerWidth < 360);
        window.addEventListener('resize', onResize);
        return ()=>window.removeEventListener('resize', onResize);
    }, []);
    return narrow;
};
function $93cce909f7881164$export$2e2bcd8739ae039({ items: items, loading: loading = false, format: format = (n)=>String(n), ariaLabel: ariaLabel, activeKey: activeKey, onSelect: onSelect, end: end, testIdPrefix: testIdPrefix = 'reception', onDark: onDark = false, style: style }) {
    const narrow = $93cce909f7881164$var$useNarrow();
    const p = testIdPrefix;
    const n = (v)=>loading || v == null ? "\u2013" : format(v);
    const interactive = typeof onSelect === 'function';
    const figure = (it)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontWeight: 800,
                color: onDark ? 'rgba(255,255,255,0.95)' : it.color || (0, $jTCZr.C).textPrimary
            }
        }, n(it.value)), !narrow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontWeight: 500,
                color: onDark ? 'rgba(255,255,255,0.72)' : (0, $jTCZr.C).textSecondary,
                marginInlineStart: '0.1875rem'
            }
        }, it.label));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${p}-stats`,
        style: {
            flexShrink: 0,
            minHeight: interactive ? '2.75rem' : '2.5rem',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: onDark ? 0 : '0 0.875rem',
            background: onDark ? 'transparent' : (0, $jTCZr.C).bg,
            borderBottom: onDark ? 'none' : `1px solid ${(0, $jTCZr.C).border}`,
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "group",
        "aria-label": ariaLabel,
        className: "mobile-strip",
        style: {
            flex: 1,
            minWidth: 0,
            display: 'flex',
            alignItems: interactive ? 'center' : 'baseline',
            gap: interactive ? 0 : '0.375rem',
            overflowX: interactive ? 'auto' : 'hidden',
            whiteSpace: 'nowrap',
            scrollbarWidth: 'none'
        }
    }, items.map((it, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
            key: it.key
        }, i > 0 && !interactive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "aria-hidden": true,
            style: {
                color: onDark ? 'rgba(255,255,255,0.4)' : (0, $jTCZr.C).textMuted,
                fontSize: '0.75rem'
            }
        }, "\xb7"), interactive ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            size: "sm",
            "data-testid": `${p}-stat-${it.key}`,
            "aria-pressed": activeKey === it.key,
            "aria-label": `${it.label} ${n(it.value)}`,
            onClick: ()=>onSelect(it.key),
            className: "h-auto min-h-9 shrink-0 rounded-full px-1.5 py-0 font-normal",
            style: {
                fontSize: '0.78125rem',
                background: activeKey === it.key ? (0, $jTCZr.soft)(it.color || (0, $jTCZr.C).navy, 0.14) : 'transparent',
                boxShadow: activeKey === it.key ? `inset 0 0 0 1px ${(0, $jTCZr.soft)(it.color || (0, $jTCZr.C).navy, 0.45)}` : 'none'
            }
        }, figure(it)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "data-testid": `${p}-stat-${it.key}`,
            "aria-hidden": true,
            style: {
                fontSize: '0.78125rem'
            }
        }, figure(it))))), end ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flexShrink: 0
        }
    }, end) : null);
}

});


parcelRegister("hU4vR", function(module, exports) {

$parcel$export(module.exports, "default", () => $9dd7f5e3d401ab69$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $6Md3F = parcelRequire("6Md3F");
var $2WFPf = parcelRequire("2WFPf");
var $kzPvP = parcelRequire("kzPvP");

var $jTCZr = parcelRequire("jTCZr");

var $aJ1FU = parcelRequire("aJ1FU");

var $j9AxR = parcelRequire("j9AxR");
'use client';
// ─────────────────────────────────────────────────────────────────────────────
// DayContextCard — the context row of a LIST-DOMINANT cockpit's gradient
// header (MOBILE_WEB_PWA §3.2): one white-alpha inset card answering "what am
// I looking at", in two rows.
//
//   line     — the lens: WHERE / WHOSE list this is. The doctor's پذیرش says
//              where the presence schedule puts them («اکنون در کلینیک مهر ·
//              تا ۱۴:۰۰»); the clinic's says whose queue the desk is working
//              («دکتر رضایی · تزریق»). With a choice to make it is the trigger
//              for the caller's picker (`onOpen`); without one it only informs
//              — absent, never disabled.
//   date bar — ‹ day › with the label opening the week sheet. It replaces a
//              navigator + week strip stack that cost ~130px of a phone.
//
// Promoted from the doctor app (DOCTOR_MOBILE_RECEPTION_REDESIGN §4.2) when
// the clinic's phone reception was rebuilt on the same anatomy (PM-0052). The
// card renders; it decides nothing: the sentence, the icon and the picker are
// the caller's.
//
// Props:
//   line        — null | {
//                   icon      lucide component
//                   text      the sentence (already formatted)
//                   hint      optional second, smaller line
//                   pill      optional trailing chip (the lens as it stands)
//                   tone      'warn' | 'muted' | undefined
//                   state     forwarded as data-place-state (tests, styling)
//                   onOpen    makes the row a button that opens a picker
//                   openLabel the button's accessible name
//                   ariaLabel the live region's label (live lines only)
//                   live      announce changes politely (a schedule boundary
//                             flips the sentence once, so it is said once)
//                 }
//   action      — optional node at the END of the lens row, outside its button
//                 (the clinic desk's registry search). On-gradient, ≥2.75rem.
//   dateLabel / isToday / onPrev / onNext / onToday / onOpenWeek
//   labels      — { prevDay, nextDay, today, backToToday, pickDay } (kitCopy defaults)
//   testIdPrefix — default 'reception' → `reception-context`, `-place`,
//                  `-place-open`, `-place-lens`, `-place-hint`, `-datenav`,
//                  `-datenav-prev|pick|today|next`
// ─────────────────────────────────────────────────────────────────────────────
const $9dd7f5e3d401ab69$var$PREV_GLYPH = {
    transform: 'scaleX(var(--dir-flip, 1))'
};
const $9dd7f5e3d401ab69$var$NEXT_GLYPH = {
    transform: 'scaleX(calc(var(--dir-flip, 1) * -1))'
};
const $9dd7f5e3d401ab69$var$rowBase = {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    width: '100%',
    flex: 1,
    minWidth: 0,
    minHeight: '2.75rem',
    padding: '0 0.625rem',
    color: '#fff',
    textAlign: 'start'
};
function $9dd7f5e3d401ab69$export$2e2bcd8739ae039({ line: line, action: action, dateLabel: dateLabel, isToday: isToday, onPrev: onPrev, onNext: onNext, onToday: onToday, onOpenWeek: onOpenWeek, labels: labels, locale: locale, testIdPrefix: testIdPrefix = 'reception', style: style }) {
    const copy = {
        ...(0, $j9AxR.kitCopy)(locale).dayContext,
        ...labels
    };
    const p = testIdPrefix;
    const Icon = line?.icon;
    const warn = line?.tone === 'warn';
    const muted = line?.tone === 'muted';
    const lineBody = line && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, Icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        size: 15,
        "aria-hidden": true,
        style: {
            flexShrink: 0,
            color: warn ? (0, $jTCZr.C).amberLight : '#fff',
            opacity: muted ? 0.7 : 1
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            display: 'block',
            fontSize: '0.78125rem',
            fontWeight: 700,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            opacity: muted ? 0.8 : 1
        }
    }, line.text), line.hint && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": `${p}-place-hint`,
        style: {
            display: 'block',
            fontSize: '0.65625rem',
            fontWeight: 500,
            color: 'rgba(255,255,255,0.7)'
        }
    }, line.hint)), line.pill && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": `${p}-place-lens`,
        style: {
            flexShrink: 0,
            maxWidth: '40%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            fontSize: '0.65625rem',
            fontWeight: 700,
            borderRadius: '1rem',
            padding: '0.125rem 0.5rem',
            background: 'rgba(255,255,255,0.2)'
        }
    }, line.pill), line.onOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2WFPf.default), {
        size: 14,
        "aria-hidden": true,
        style: {
            flexShrink: 0,
            opacity: 0.75
        }
    }));
    const liveProps = line?.live ? {
        role: 'status',
        'aria-live': 'polite',
        'aria-label': line.ariaLabel ? `${line.ariaLabel}: ${line.text}` : undefined
    } : {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${p}-context`,
        style: {
            background: 'rgba(255,255,255,0.12)',
            borderRadius: '0.75rem',
            overflow: 'hidden',
            ...style
        }
    }, line && line.text != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...liveProps,
        "data-testid": `${p}-place`,
        "data-place-state": line.state,
        style: {
            borderBottom: '1px solid rgba(255,255,255,0.14)',
            ...action ? {
                display: 'flex',
                alignItems: 'center'
            } : null
        }
    }, line.onOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        "data-testid": `${p}-place-open`,
        "aria-haspopup": "dialog",
        "aria-label": line.openLabel,
        className: "h-auto justify-start rounded-none font-normal hover:bg-white/10",
        style: $9dd7f5e3d401ab69$var$rowBase,
        onClick: line.onOpen
    }, lineBody) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            ...$9dd7f5e3d401ab69$var$rowBase,
            minHeight: action ? '2.75rem' : '2.25rem',
            paddingBlock: '0.375rem'
        }
    }, lineBody), action ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flexShrink: 0,
            paddingInlineEnd: '0.25rem'
        }
    }, action) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${p}-datenav`,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.25rem',
            padding: '0.125rem 0.25rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "icon",
        "data-testid": `${p}-datenav-prev`,
        "aria-label": copy.prevDay,
        className: "min-w-11 min-h-11 text-white hover:bg-white/15",
        onClick: onPrev
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kzPvP.default), {
        size: 18,
        "aria-hidden": true,
        style: $9dd7f5e3d401ab69$var$PREV_GLYPH
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.375rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        "data-testid": `${p}-datenav-pick`,
        "aria-label": onOpenWeek ? `${dateLabel} \u{2014} ${copy.pickDay}` : undefined,
        "aria-haspopup": onOpenWeek ? 'dialog' : undefined,
        className: "h-auto min-h-11 gap-1.5 px-2 py-0 text-[0.84375rem] font-bold text-white hover:bg-white/15",
        onClick: onOpenWeek
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6Md3F.default), {
        size: 14,
        style: {
            opacity: 0.75
        },
        "aria-hidden": true
    }), dateLabel), isToday ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.65625rem',
            fontWeight: 700,
            borderRadius: '1rem',
            padding: '0.125rem 0.5rem',
            background: 'rgba(255,255,255,0.24)',
            color: '#fff',
            whiteSpace: 'nowrap'
        }
    }, copy.today) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        "data-testid": `${p}-datenav-today`,
        className: "h-auto min-h-8 px-2 py-0.5 text-[0.65625rem] font-bold text-white whitespace-nowrap rounded-full hover:bg-white/25",
        style: {
            background: 'rgba(255,255,255,0.18)'
        },
        onClick: onToday
    }, copy.backToToday)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "icon",
        "data-testid": `${p}-datenav-next`,
        "aria-label": copy.nextDay,
        className: "min-w-11 min-h-11 text-white hover:bg-white/15",
        onClick: onNext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kzPvP.default), {
        size: 18,
        "aria-hidden": true,
        style: $9dd7f5e3d401ab69$var$NEXT_GLYPH
    }))));
}

});
parcelRegister("6Md3F", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b56343e65588121$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $5b56343e65588121$export$a2387ed3b5d536eb = {
    name: "calendar-days",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M8 2v3",
                key: "1ioesn"
            }
        ],
        [
            "path",
            {
                d: "M16 2v3",
                key: "otl347"
            }
        ],
        [
            "rect",
            {
                x: "3",
                y: "3",
                width: "18",
                height: "18",
                rx: "2",
                key: "h1oib"
            }
        ],
        [
            "path",
            {
                d: "M3 9h18",
                key: "1pudct"
            }
        ],
        [
            "path",
            {
                d: "M8 13h.01",
                key: "1sbv64"
            }
        ],
        [
            "path",
            {
                d: "M12 13h.01",
                key: "y0uutt"
            }
        ],
        [
            "path",
            {
                d: "M16 13h.01",
                key: "wip0gl"
            }
        ],
        [
            "path",
            {
                d: "M8 17h.01",
                key: "p3bg7i"
            }
        ],
        [
            "path",
            {
                d: "M12 17h.01",
                key: "p32p05"
            }
        ],
        [
            "path",
            {
                d: "M16 17h.01",
                key: "ql8jdd"
            }
        ]
    ]
};
$5b56343e65588121$export$a2387ed3b5d536eb.node;
const $5b56343e65588121$export$2e2bcd8739ae039 = (0, $9QBug.default)($5b56343e65588121$export$a2387ed3b5d536eb);

});

parcelRegister("2WFPf", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc4be5d9d5a360aa$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $dc4be5d9d5a360aa$export$a2387ed3b5d536eb = {
    name: "chevron-down",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m6 9 6 6 6-6",
                key: "qrunsl"
            }
        ]
    ]
};
$dc4be5d9d5a360aa$export$a2387ed3b5d536eb.node;
const $dc4be5d9d5a360aa$export$2e2bcd8739ae039 = (0, $9QBug.default)($dc4be5d9d5a360aa$export$a2387ed3b5d536eb);

});

parcelRegister("kzPvP", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c8dd034124f4eb9$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $9c8dd034124f4eb9$export$a2387ed3b5d536eb = {
    name: "chevron-right",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m9 18 6-6-6-6",
                key: "mthhwq"
            }
        ]
    ]
};
$9c8dd034124f4eb9$export$a2387ed3b5d536eb.node;
const $9c8dd034124f4eb9$export$2e2bcd8739ae039 = (0, $9QBug.default)($9c8dd034124f4eb9$export$a2387ed3b5d536eb);

});


parcelRegister("300tQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3d011a6fde34c03$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $6Md3F = parcelRequire("6Md3F");
var $kzPvP = parcelRequire("kzPvP");

var $jTCZr = parcelRequire("jTCZr");

var $aJ1FU = parcelRequire("aJ1FU");

var $cZOyb = parcelRequire("cZOyb");

var $4Qco3 = parcelRequire("4Qco3");

var $j9AxR = parcelRequire("j9AxR");

var $hlTfq = parcelRequire("hlTfq");

var $2vdhF = parcelRequire("2vdhF");
'use client';
// ─────────────────────────────────────────────────────────────────────────────
// WeekPickerSheet — week browsing in a bottom sheet, opened from a day bar's
// label (`DayContextCard`). A seven-chip week strip answers a question asked a
// few times a day and costs ~64px on every screen load; the sheet costs none.
//
// Weeks are Jalali, Saturday → Friday, over Iran-local ISO dates, and the sheet
// opens on the week holding the selected day. Each row says what the day holds:
// the caller's `describeDay` line (the doctor: where the schedule puts them)
// and the count of appointments — `·` not counted yet, `—` counted and empty.
// A row described as `off` is muted but still tappable. Picking a day only
// calls `onPick(iso)` — the sheet never navigates.
//
// «تقویم کامل» swaps the body for the month grid (one sheet, two views — no
// stacked sheets) for far jumps.
//
// Promoted from the doctor app (DOCTOR_MOBILE_RECEPTION_REDESIGN §4.4), PM-0052.
//
// Props:
//   open / onClose / selISO / todayISO / onPick(iso)
//   useWeekCounts — a HOOK `(weekStartISO, { enabled }) => [{ iso, count|null }]`
//                   called on every render (pass a stable function); omit it
//                   and the count column stays blank
//   describeDay   — optional `(iso) => null | { text, aria?, off? }`
//   fmt           — { weekday(ms), dayMonth(ms), weekdayDayMonth(ms), number(n) };
//                   defaults use Intl with the Persian calendar
//   labels        — overrides for kitCopy().weekPicker
//   testIdPrefix  — default 'reception' → `reception-week-sheet`, `-week-<iso>`, …
// ─────────────────────────────────────────────────────────────────────────────
const $b3d011a6fde34c03$var$PREV_GLYPH = {
    transform: 'scaleX(var(--dir-flip, 1))'
};
const $b3d011a6fde34c03$var$NEXT_GLYPH = {
    transform: 'scaleX(calc(var(--dir-flip, 1) * -1))'
};
const $b3d011a6fde34c03$var$noCounts = ()=>null;
function $b3d011a6fde34c03$var$defaultFmt(locale) {
    const tag = `${locale || 'fa'}-IR-u-ca-persian`;
    const make = (opts)=>{
        try {
            const f = new Intl.DateTimeFormat(tag, {
                timeZone: 'UTC',
                ...opts
            });
            return (ms)=>f.format(ms);
        } catch  {
            return (ms)=>new Date(ms).toISOString().split('T')[0];
        }
    };
    const nf = (()=>{
        try {
            return new Intl.NumberFormat(tag);
        } catch  {
            return null;
        }
    })();
    return {
        weekday: make({
            weekday: 'long'
        }),
        dayMonth: make({
            day: 'numeric',
            month: 'long'
        }),
        weekdayDayMonth: make({
            weekday: 'long',
            day: 'numeric',
            month: 'long'
        }),
        number: (n)=>nf ? nf.format(n) : String(n)
    };
}
function $b3d011a6fde34c03$export$2e2bcd8739ae039({ open: open, onClose: onClose, selISO: selISO, todayISO: todayISO, onPick: onPick, useWeekCounts: useWeekCounts = $b3d011a6fde34c03$var$noCounts, describeDay: describeDay, fmt: fmtProp, labels: labels, locale: locale, testIdPrefix: testIdPrefix = 'reception' }) {
    const loc = locale || (0, $hlTfq.documentLocale)();
    const copy = {
        ...(0, $j9AxR.kitCopy)(loc).weekPicker,
        ...labels
    };
    const fmt = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
            ...$b3d011a6fde34c03$var$defaultFmt(loc),
            ...fmtProp
        }), [
        loc,
        fmtProp
    ]);
    const p = testIdPrefix;
    const [weekStart, setWeekStart] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>(0, $2vdhF.jalaliWeekStart)(selISO));
    const [view, setView] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('week');
    // Every opening starts on the selected day's week, in the week view.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (open) {
            setWeekStart((0, $2vdhF.jalaliWeekStart)(selISO));
            setView('week');
        }
    }, [
        open,
        selISO
    ]);
    const days = useWeekCounts(weekStart, {
        enabled: open
    }) || [];
    const countOf = new Map(days.map((d)=>[
            d.iso,
            d.count
        ]));
    const thisWeek = (0, $2vdhF.jalaliWeekStart)(todayISO);
    const isoDays = (0, $2vdhF.weekDaysFrom)(weekStart);
    const range = copy.range(fmt.dayMonth((0, $2vdhF.isoNoonMs)(isoDays[0])), fmt.dayMonth((0, $2vdhF.isoNoonMs)(isoDays[6])));
    const pick = (iso)=>{
        onClose();
        if (iso) onPick(iso);
    };
    const quick = [
        {
            key: 'this',
            label: copy.thisWeek,
            start: thisWeek
        },
        {
            key: 'next',
            label: copy.nextWeek,
            start: (0, $2vdhF.shiftISO)(thisWeek, 7)
        },
        {
            key: 'prev',
            label: copy.prevWeek,
            start: (0, $2vdhF.shiftISO)(thisWeek, -7)
        }
    ];
    const footer = view === 'week' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        "data-testid": `${p}-week-calendar`,
        className: "w-full min-h-11 gap-2",
        onClick: ()=>setView('month')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6Md3F.default), {
        size: 16,
        "aria-hidden": true
    }), copy.fullCalendar) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        "data-testid": `${p}-week-back`,
        className: "w-full min-h-11",
        onClick: ()=>setView('week')
    }, copy.backToWeek);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: open,
        onClose: onClose,
        title: copy.title,
        closeLabel: copy.close,
        footer: footer,
        "data-testid": `${p}-week-sheet`
    }, view === 'month' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4Qco3.JalaliCalendar), {
        value: selISO,
        onChange: (v)=>pick(v)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "group",
        style: {
            display: 'flex',
            gap: '0.375rem',
            flexWrap: 'wrap'
        }
    }, quick.map((q)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            key: q.key,
            variant: weekStart === q.start ? 'default' : 'outline',
            size: "sm",
            "aria-pressed": weekStart === q.start,
            "data-testid": `${p}-week-quick-${q.key}`,
            className: "min-h-9 rounded-full",
            onClick: ()=>setWeekStart(q.start)
        }, q.label))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.25rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "icon",
        "data-testid": `${p}-week-prev`,
        "aria-label": copy.prevWeek,
        className: "min-w-11 min-h-11",
        onClick: ()=>setWeekStart((s)=>(0, $2vdhF.shiftISO)(s, -7))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kzPvP.default), {
        size: 18,
        "aria-hidden": true,
        style: $b3d011a6fde34c03$var$PREV_GLYPH
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${p}-week-range`,
        style: {
            flex: 1,
            textAlign: 'center',
            fontSize: '0.875rem',
            fontWeight: 700,
            color: (0, $jTCZr.C).textPrimary
        }
    }, range), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "icon",
        "data-testid": `${p}-week-next`,
        "aria-label": copy.nextWeek,
        className: "min-w-11 min-h-11",
        onClick: ()=>setWeekStart((s)=>(0, $2vdhF.shiftISO)(s, 7))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kzPvP.default), {
        size: 18,
        "aria-hidden": true,
        style: $b3d011a6fde34c03$var$NEXT_GLYPH
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            borderTop: `1px solid ${(0, $jTCZr.C).border}`
        }
    }, isoDays.map((iso)=>{
        const ms = (0, $2vdhF.isoNoonMs)(iso);
        const desc = describeDay ? describeDay(iso) : null;
        const count = countOf.get(iso);
        const selected = iso === selISO;
        const today = iso === todayISO;
        const off = Boolean(desc?.off);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            key: iso,
            variant: "ghost",
            "data-testid": `${p}-week-${iso}`,
            "aria-current": selected ? 'date' : undefined,
            "aria-label": [
                fmt.weekdayDayMonth(ms),
                desc?.aria || (desc?.text && desc.text !== "\u2014" ? desc.text : null),
                count != null ? copy.countAria(fmt.number(count)) : null
            ].filter(Boolean).join(" \xb7 "),
            className: "h-auto min-h-[3.25rem] w-full justify-start gap-3 rounded-none px-2 py-1.5 font-normal",
            style: {
                borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
                background: selected ? (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.08) : 'transparent',
                textAlign: 'start'
            },
            onClick: ()=>pick(iso)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                width: '4.5rem',
                flexShrink: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                display: 'block',
                fontSize: '0.8125rem',
                fontWeight: selected ? 800 : 700,
                color: (0, $jTCZr.C).textPrimary
            }
        }, fmt.weekday(ms)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                display: 'block',
                fontSize: '0.6875rem',
                color: (0, $jTCZr.C).textSecondary
            }
        }, fmt.dayMonth(ms))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                flex: 1,
                minWidth: 0,
                fontSize: '0.75rem',
                color: off ? (0, $jTCZr.C).textMuted : (0, $jTCZr.C).textSecondary,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            }
        }, desc?.text || ''), today && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                flexShrink: 0,
                fontSize: '0.625rem',
                fontWeight: 700,
                borderRadius: '1rem',
                padding: '0.0625rem 0.4375rem',
                background: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.12),
                color: (0, $jTCZr.C).navy
            }
        }, copy.today), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "aria-hidden": true,
            style: {
                width: '1.75rem',
                flexShrink: 0,
                textAlign: 'center',
                fontSize: '0.875rem',
                fontWeight: 800,
                color: count ? (0, $jTCZr.C).textPrimary : (0, $jTCZr.C).textMuted
            }
        }, count == null ? useWeekCounts === $b3d011a6fde34c03$var$noCounts ? '' : "\xb7" : count === 0 ? "\u2014" : fmt.number(count)));
    }))));
}

});
parcelRegister("4Qco3", function(module, exports) {

$parcel$export(module.exports, "splitDateTime", () => $d9dd19094c9f758e$export$565a3e0423f3fda3);
$parcel$export(module.exports, "JalaliCalendar", () => $d9dd19094c9f758e$export$9c97d98ce20c6c7a);
$parcel$export(module.exports, "JalaliCalendarPopup", () => $d9dd19094c9f758e$export$bb703e6cd16789d6);
$parcel$export(module.exports, "default", () => $d9dd19094c9f758e$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $jTCZr = parcelRequire("jTCZr");

var $5JYPc = parcelRequire("5JYPc");

var $IZwml = parcelRequire("IZwml");
'use client';
// Everything the picker SHOWS — calendar, digits, month and weekday names, its own
// labels and its error messages — follows the page language (`<html lang>`, or the
// `locale` prop), from the table in lib/datePickerLocale.js. Under `en` that means a
// Gregorian, left-to-right calendar; under `fa` and `ar`, the Jalali one. `value` is
// Gregorian 'YYYY-MM-DD' in every language, so no caller changes with the language.
const $d9dd19094c9f758e$var$FA_DIGITS = (0, $IZwml.DATE_PICKER_LOCALES).fa.digits;
const $d9dd19094c9f758e$var$pad2 = (n)=>String(n).padStart(2, '0');
// ── Jalali math (works for years 1300–1500) ───────────────────────────────────
function $d9dd19094c9f758e$var$jIsLeap(y) {
    return (y * 8 + 29) % 33 < 8;
}
function $d9dd19094c9f758e$var$jMonthDays(y, m) {
    if (m <= 6) return 31;
    if (m <= 11) return 30;
    return $d9dd19094c9f758e$var$jIsLeap(y) ? 30 : 29;
}
// Anchor: 1400/01/01 = 2021-03-21 UTC. Works backward too.
function $d9dd19094c9f758e$var$jalaliToMs(jy, jm, jd) {
    const anchor = Date.UTC(2021, 2, 21);
    const md = [
        31,
        31,
        31,
        31,
        31,
        31,
        30,
        30,
        30,
        30,
        30,
        $d9dd19094c9f758e$var$jIsLeap(jy) ? 30 : 29
    ];
    let doy = jd - 1;
    for(let i = 0; i < jm - 1; i++)doy += md[i];
    let days = 0;
    if (jy >= 1400) for(let y = 1400; y < jy; y++)days += $d9dd19094c9f758e$var$jIsLeap(y) ? 366 : 365;
    else for(let y = jy; y < 1400; y++)days -= $d9dd19094c9f758e$var$jIsLeap(y) ? 366 : 365;
    return anchor + (days + doy) * 86400000;
}
function $d9dd19094c9f758e$var$msToJalali(ms) {
    const anchor = Date.UTC(2021, 2, 21);
    let days = Math.floor((ms - anchor) / 86400000);
    let y = 1400;
    if (days >= 0) while(true){
        const diy = $d9dd19094c9f758e$var$jIsLeap(y) ? 366 : 365;
        if (days < diy) break;
        days -= diy;
        y++;
    }
    else while(days < 0){
        y--;
        days += $d9dd19094c9f758e$var$jIsLeap(y) ? 366 : 365;
    }
    const md = [
        31,
        31,
        31,
        31,
        31,
        31,
        30,
        30,
        30,
        30,
        30,
        $d9dd19094c9f758e$var$jIsLeap(y) ? 30 : 29
    ];
    let m = 0;
    while(m < 11 && days >= md[m]){
        days -= md[m];
        m++;
    }
    return {
        y: y,
        m: m + 1,
        d: days + 1
    };
}
// ── The two calendars ─────────────────────────────────────────────────────────
// One shape, so the grids, the parser and the disableFuture rules below exist once
// and never ask which calendar they are drawing. Dates are `{ y, m, d }` with a
// 1-based month; `toMs`/`fromMs` read the day at UTC midnight.
const $d9dd19094c9f758e$var$JALALI = {
    id: 'jalali',
    firstYear: 1300,
    lastYear: 1500,
    weekStart: 6,
    monthDays: $d9dd19094c9f758e$var$jMonthDays,
    toMs: $d9dd19094c9f758e$var$jalaliToMs,
    fromMs: $d9dd19094c9f758e$var$msToJalali
};
const $d9dd19094c9f758e$var$GREGORIAN = {
    id: 'gregorian',
    firstYear: 1921,
    lastYear: 2121,
    weekStart: null,
    monthDays: (y, m)=>new Date(Date.UTC(y, m, 0)).getUTCDate(),
    toMs: (y, m, d)=>Date.UTC(y, m - 1, d),
    fromMs: (ms)=>{
        const t = new Date(ms);
        return {
            y: t.getUTCFullYear(),
            m: t.getUTCMonth() + 1,
            d: t.getUTCDate()
        };
    }
};
const $d9dd19094c9f758e$var$CALENDARS = {
    jalali: $d9dd19094c9f758e$var$JALALI,
    gregorian: $d9dd19094c9f758e$var$GREGORIAN
};
const $d9dd19094c9f758e$var$calendarOf = (id)=>$d9dd19094c9f758e$var$CALENDARS[id] || $d9dd19094c9f758e$var$JALALI;
const $d9dd19094c9f758e$var$todayIn = (cal)=>cal.fromMs(Date.now());
// 'YYYY-MM-DD' → the same day in `cal`.
function $d9dd19094c9f758e$var$valueToDate(cal, str) {
    if (!str || str.length < 10) return null;
    const [y, m, d] = str.split('-').map(Number);
    if (!y || !m || !d) return null;
    return cal.fromMs(Date.UTC(y, m - 1, d));
}
// A day in `cal` → 'YYYY-MM-DD'.
function $d9dd19094c9f758e$var$dateToValue(cal, y, m, d) {
    const dt = new Date(cal.toMs(y, m, d));
    return [
        dt.getUTCFullYear(),
        String(dt.getUTCMonth() + 1).padStart(2, '0'),
        String(dt.getUTCDate()).padStart(2, '0')
    ].join('-');
}
// The locale's data plus the calendar it resolves to — `calendar` pins one.
function $d9dd19094c9f758e$var$resolvePicker(locale, calendar) {
    const L = (0, $IZwml.datePickerLocale)(locale);
    const cal = $d9dd19094c9f758e$var$calendarOf(calendar || L.calendar);
    return {
        L: L,
        cal: cal,
        months: L.months[cal.id],
        weekStart: cal.weekStart ?? L.weekStart,
        num: (n)=>(0, $IZwml.withDigits)(n, L.digits)
    };
}
function $d9dd19094c9f758e$export$565a3e0423f3fda3(value) {
    const s = String(value || '').trim();
    if (!s) return {
        date: '',
        time: ''
    };
    const [date, rest = ''] = s.split(/[T\s]+/);
    const t = rest.match(/^(\d{1,2}):(\d{1,2})/);
    return {
        date: date,
        time: t ? `${$d9dd19094c9f758e$var$pad2(+t[1])}:${$d9dd19094c9f758e$var$pad2(+t[2])}` : ''
    };
}
function $d9dd19094c9f758e$export$26bc4d93216d514d(raw, { withTime: withTime = false, disableFuture: disableFuture = false, calendar: calendar = 'jalali' } = {}) {
    const cal = $d9dd19094c9f758e$var$calendarOf(calendar);
    const s = (0, $5JYPc.toEnDigits)(raw ?? '').replace(/[،,]+/g, ' ').replace(/\s+/g, ' ').trim();
    if (!s) return {
        empty: true
    };
    const m = s.match(/^(\d{4})\s*[/\-.]\s*(\d{1,2})\s*[/\-.]\s*(\d{1,2})(?:[ T]+(\d{1,2})\s*[:.]\s*(\d{1,2}))?$/);
    if (!m) return {
        error: 'format'
    };
    const y = +m[1], mo = +m[2], d = +m[3];
    if (y < cal.firstYear || y > cal.lastYear) return {
        error: 'range'
    };
    if (mo < 1 || mo > 12) return {
        error: 'range'
    };
    if (d < 1 || d > cal.monthDays(y, mo)) return {
        error: 'range'
    };
    const hasTime = m[4] !== undefined;
    let hh = 0, mi = 0;
    if (hasTime) {
        if (!withTime) return {
            error: 'noTime'
        };
        hh = +m[4];
        mi = +m[5];
        if (hh > 23 || mi > 59) return {
            error: 'time'
        };
    }
    if (disableFuture) {
        const t = $d9dd19094c9f758e$var$todayIn(cal);
        if (cal.toMs(y, mo, d) > cal.toMs(t.y, t.m, t.d)) return {
            error: 'future'
        };
    }
    const date = $d9dd19094c9f758e$var$dateToValue(cal, y, mo, d);
    return {
        j: {
            y: y,
            m: mo,
            d: d
        },
        hh: hh,
        mi: mi,
        hasTime: hasTime,
        value: withTime ? `${date} ${$d9dd19094c9f758e$var$pad2(hh)}:${$d9dd19094c9f758e$var$pad2(mi)}` : date
    };
}
function $d9dd19094c9f758e$export$c715042cb80ca422(value, { withTime: withTime = false, calendar: calendar = 'jalali', digits: digits = $d9dd19094c9f758e$var$FA_DIGITS } = {}) {
    const cal = $d9dd19094c9f758e$var$calendarOf(calendar);
    const { date: date, time: time } = $d9dd19094c9f758e$export$565a3e0423f3fda3(value);
    const c = $d9dd19094c9f758e$var$valueToDate(cal, date);
    if (!c) return '';
    const base = `${c.y}/${$d9dd19094c9f758e$var$pad2(c.m)}/${$d9dd19094c9f758e$var$pad2(c.d)}`;
    return (0, $IZwml.withDigits)(withTime ? `${base} ${time || '00:00'}` : base, digits);
}
const $d9dd19094c9f758e$export$5a5aa410a9e7d978 = (raw, opts = {})=>$d9dd19094c9f758e$export$26bc4d93216d514d(raw, {
        ...opts,
        calendar: 'jalali'
    });
const $d9dd19094c9f758e$export$544b31198dd3053c = (value, { withTime: withTime = false } = {})=>$d9dd19094c9f758e$export$c715042cb80ca422(value, {
        withTime: withTime,
        calendar: 'jalali',
        digits: $d9dd19094c9f758e$var$FA_DIGITS
    });
function $d9dd19094c9f758e$var$buildGrid(cal, y, m, weekStart) {
    const days = cal.monthDays(y, m);
    const offset = (new Date(cal.toMs(y, m, 1)).getUTCDay() - weekStart + 7) % 7;
    const cells = [
        ...Array(offset).fill(null),
        ...Array.from({
            length: days
        }, (_, i)=>i + 1)
    ];
    while(cells.length % 7)cells.push(null);
    const grid = [];
    for(let i = 0; i < cells.length; i += 7)grid.push(cells.slice(i, i + 7));
    return grid;
}
// ── Sub-components ────────────────────────────────────────────────────────────
const $d9dd19094c9f758e$var$NavBtn = ({ onClick: onClick, children: children, disabled: disabled })=>{
    const [hov, setHov] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: disabled ? undefined : onClick,
        onMouseEnter: ()=>setHov(true),
        onMouseLeave: ()=>setHov(false),
        style: {
            background: hov && !disabled ? '#e2e8f0' : '#f0f4f8',
            border: 'none',
            borderRadius: 6,
            width: 28,
            height: 28,
            cursor: disabled ? 'default' : 'pointer',
            padding: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: disabled ? '#c8c8c8' : (0, $jTCZr.C).textSecondary,
            flexShrink: 0,
            transition: 'background 0.12s'
        }
    }, children);
};
const $d9dd19094c9f758e$var$ChevR = ({ size: size = 14 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: size,
        height: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
    }));
const $d9dd19094c9f758e$var$ChevL = ({ size: size = 14 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: size,
        height: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
    }));
const $d9dd19094c9f758e$var$GridCell = ({ label: label, selected: selected, current: current, disabled: disabled, onClick: onClick })=>{
    const [hov, setHov] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    let bg = hov && !disabled ? '#e2e8f0' : '#f8fafc';
    let color = disabled ? '#c8c8c8' : (0, $jTCZr.C).textPrimary;
    let fw = 400;
    if (selected && !disabled) {
        bg = (0, $jTCZr.C).navy;
        color = 'white';
        fw = 700;
    } else if (current && !disabled) {
        bg = '#EAF4FC';
        color = (0, $jTCZr.C).navy;
        fw = 600;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: disabled ? undefined : onClick,
        onMouseEnter: ()=>setHov(true),
        onMouseLeave: ()=>setHov(false),
        style: {
            height: 36,
            borderRadius: 8,
            border: 'none',
            cursor: disabled ? 'default' : 'pointer',
            fontSize: '0.75rem',
            fontFamily: 'Meshkat, sans-serif',
            fontWeight: fw,
            background: bg,
            color: color,
            transition: 'background 0.12s'
        }
    }, label);
};
const $d9dd19094c9f758e$var$DayCell = ({ day: day, label: label, isToday: isToday, isSel: isSel, disabled: disabled, onClick: onClick })=>{
    const [hov, setHov] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    if (!day) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null);
    let bg = hov && !disabled ? '#f0f4f8' : 'transparent';
    let color = disabled ? '#d0d0d0' : (0, $jTCZr.C).textPrimary;
    let fw = 400;
    if (isSel && !disabled) {
        bg = (0, $jTCZr.C).navy;
        color = 'white';
        fw = 700;
    } else if (isToday) {
        bg = '#EAF4FC';
        color = (0, $jTCZr.C).navy;
        fw = 700;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: disabled ? undefined : onClick,
        onMouseEnter: ()=>setHov(true),
        onMouseLeave: ()=>setHov(false),
        style: {
            height: 34,
            borderRadius: 8,
            border: 'none',
            cursor: disabled ? 'default' : 'pointer',
            background: bg,
            color: color,
            fontWeight: fw,
            fontSize: '0.75rem',
            fontFamily: 'Meshkat, sans-serif',
            transition: 'background 0.12s'
        }
    }, label);
};
// ‹ label › — earlier on the LEFT and later on the RIGHT in every language. That is
// the reading order under `ltr`, and it is what the RTL picker has always drawn, so
// the row pins its own direction instead of mirroring with the card.
const $d9dd19094c9f758e$var$NavRow = ({ onPrev: onPrev, onNext: onNext, nextDisabled: nextDisabled, marginBottom: marginBottom, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: marginBottom,
            direction: 'ltr'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$NavBtn, {
        onClick: onPrev
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$ChevL, null)), children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$NavBtn, {
        onClick: onNext,
        disabled: nextDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$ChevR, null)));
const $d9dd19094c9f758e$export$9c97d98ce20c6c7a = ({ locale: locale, calendar: calendar, ...rest })=>{
    const picker = $d9dd19094c9f758e$var$resolvePicker(locale, calendar);
    // Keyed on the calendar: the view state is a year and month IN that calendar, so a
    // language switch that changes calendars starts over rather than reading 1405 as a
    // Gregorian year.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$CalendarBody, {
        key: picker.cal.id,
        picker: picker,
        ...rest
    });
};
const $d9dd19094c9f758e$var$CalendarBody = ({ value: value, onChange: onChange, disableFuture: disableFuture = false, picker: picker })=>{
    const { L: L, cal: cal, months: months, weekStart: weekStart, num: num } = picker;
    const today = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>$d9dd19094c9f758e$var$todayIn(cal), [
        cal
    ]);
    const [mode, setMode] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('day'); // 'day' | 'month' | 'year'
    const [viewY, setViewY] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(today.y);
    const [viewM, setViewM] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(today.m);
    const [sel, setSel] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const yrRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null); // scrollable year container
    const yrSelRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null); // selected/current year cell
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (value) {
            const c = $d9dd19094c9f758e$var$valueToDate(cal, value);
            if (c) {
                setSel(c);
                setViewY(c.y);
                setViewM(c.m);
                return;
            }
        }
        setSel(null);
    }, [
        value,
        cal
    ]);
    const changeMonth = (delta)=>{
        let m = viewM + delta, y = viewY;
        if (m > 12) {
            m = 1;
            y++;
        }
        if (m < 1) {
            m = 12;
            y--;
        }
        setViewM(m);
        setViewY(y);
    };
    const enterYearMode = ()=>setMode('year');
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (mode !== 'year') return;
        const t = setTimeout(()=>{
            if (yrSelRef.current && yrRef.current) {
                const el = yrSelRef.current;
                const container = yrRef.current;
                container.scrollTop = el.offsetTop - container.clientHeight / 2 + el.clientHeight / 2;
            }
        }, 30);
        return ()=>clearTimeout(t);
    }, [
        mode
    ]);
    const selectDay = (d)=>{
        if (!d) return;
        setSel({
            y: viewY,
            m: viewM,
            d: d
        });
        onChange($d9dd19094c9f758e$var$dateToValue(cal, viewY, viewM, d));
        setMode('day');
    };
    // disableFuture checks
    const yearDisabled = (y)=>disableFuture && y > today.y;
    const monthDisabled = (y, m)=>disableFuture && (y > today.y || y === today.y && m > today.m);
    const dayDisabled = (d)=>{
        if (!disableFuture || !d) return false;
        if (viewY > today.y) return true;
        if (viewY === today.y && viewM > today.m) return true;
        if (viewY === today.y && viewM === today.m && d > today.d) return true;
        return false;
    };
    const grid = $d9dd19094c9f758e$var$buildGrid(cal, viewY, viewM, weekStart);
    const weekdays = Array.from({
        length: 7
    }, (_, i)=>L.weekdays[(weekStart + i) % 7]);
    // Shared header label button style
    const labelBtn = (extra)=>({
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontFamily: 'Meshkat, sans-serif',
            borderRadius: 6,
            padding: '4px 10px',
            ...extra
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, mode === 'year' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            textAlign: 'center',
            fontSize: '0.75rem',
            fontWeight: 700,
            color: (0, $jTCZr.C).textSecondary,
            marginBottom: 10,
            letterSpacing: 1
        }
    }, L.strings.selectYear), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: yrRef,
        style: {
            maxHeight: 240,
            overflowY: 'auto',
            paddingLeft: 2,
            paddingRight: 2
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: 4
        }
    }, Array.from({
        length: today.y - cal.firstYear + 1 + (disableFuture ? 0 : 6)
    }, (_, i)=>cal.firstYear + i).map((yr)=>{
        const isFocused = yr === (sel?.y ?? today.y);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: yr,
            ref: isFocused ? yrSelRef : null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$GridCell, {
            label: num(yr),
            selected: sel ? yr === sel.y : false,
            current: yr === today.y,
            disabled: yearDisabled(yr),
            onClick: ()=>{
                setViewY(yr);
                setMode('month');
            }
        }));
    })))), mode === 'month' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$NavRow, {
        marginBottom: 12,
        onPrev: ()=>setViewY((y)=>y - 1),
        onNext: ()=>setViewY((y)=>y + 1),
        nextDisabled: yearDisabled(viewY + 1)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: enterYearMode,
        style: labelBtn({
            fontSize: '0.9375rem',
            fontWeight: 800,
            color: (0, $jTCZr.C).navy
        })
    }, num(viewY))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: 6
        }
    }, months.map((name, idx)=>{
        const mn = idx + 1;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$GridCell, {
            key: idx,
            label: name,
            selected: !!(sel && sel.y === viewY && sel.m === mn),
            current: viewY === today.y && mn === today.m,
            disabled: monthDisabled(viewY, mn),
            onClick: ()=>{
                setViewM(mn);
                setMode('day');
            }
        });
    }))), mode === 'day' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$NavRow, {
        marginBottom: 4,
        onPrev: ()=>setViewY((y)=>y - 1),
        onNext: ()=>setViewY((y)=>y + 1),
        nextDisabled: yearDisabled(viewY + 1)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: enterYearMode,
        style: labelBtn({
            fontSize: '0.8125rem',
            fontWeight: 800,
            color: (0, $jTCZr.C).textPrimary
        })
    }, num(viewY))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$NavRow, {
        marginBottom: 12,
        onPrev: ()=>changeMonth(-1),
        onNext: ()=>changeMonth(1),
        nextDisabled: monthDisabled(viewM === 12 ? viewY + 1 : viewY, viewM === 12 ? 1 : viewM + 1)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: ()=>setMode('month'),
        style: labelBtn({
            fontSize: '0.9375rem',
            fontWeight: 800,
            color: (0, $jTCZr.C).navy
        })
    }, months[viewM - 1])), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            height: 1,
            background: (0, $jTCZr.C).border,
            marginBottom: 10
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'grid',
            gridTemplateColumns: 'repeat(7, 1fr)',
            marginBottom: 4
        }
    }, weekdays.map((d, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                textAlign: 'center',
                fontSize: '0.6875rem',
                fontWeight: 700,
                color: (0, $jTCZr.C).textMuted,
                padding: '2px 0'
            }
        }, d))), grid.map((week, wi)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: wi,
            style: {
                display: 'grid',
                gridTemplateColumns: 'repeat(7, 1fr)',
                gap: 2
            }
        }, week.map((day, di)=>{
            const isToday = day && viewY === today.y && viewM === today.m && day === today.d;
            const isSel = day && sel && viewY === sel.y && viewM === sel.m && day === sel.d;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$DayCell, {
                key: di,
                day: day,
                label: day ? num(day) : '',
                isToday: isToday,
                isSel: isSel,
                disabled: dayDisabled(day),
                onClick: ()=>selectDay(day)
            });
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: ()=>{
            setViewY(today.y);
            setViewM(today.m);
        },
        style: {
            marginTop: 12,
            width: '100%',
            height: 32,
            background: '#f8fafc',
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: 8,
            fontSize: '0.75rem',
            fontWeight: 600,
            color: (0, $jTCZr.C).textSecondary,
            cursor: 'pointer',
            fontFamily: 'Meshkat, sans-serif'
        }
    }, L.strings.goToToday)));
};
// ── Popup shell ───────────────────────────────────────────────────────────────
// The floating card the calendar sits in, positioned under `anchorRef` (flipping above
// it when the viewport has no room below) and closed by a click anywhere outside both.
// Portaled to <body>: an ancestor with a CSS transform (e.g. a centered DialogContent)
// would otherwise become the containing block of this fixed card and misplace it, and
// an ancestor overflow would clip it. Dialog.jsx whitelists [data-jalali-popup] so the
// portaled card doesn't count as an outside click that dismisses the dialog.
//
// Placement is measured from the card's REAL height, never a guessed constant: the
// calendar is ~380px tall in day mode, so the old `spaceBelow > 320` test opened it
// downward with 60px too little room and the last week of the month fell off the
// bottom of the screen — the exact failure seen with the field low in a tall modal.
// The measured box is then clamped into the viewport on both axes, and re-placed on
// scroll/resize because a field inside a scrollable DialogContent moves under it.
const $d9dd19094c9f758e$var$POPUP_WIDTH = 300;
const $d9dd19094c9f758e$var$POPUP_GAP = 6; // breathing room between the trigger and the card
const $d9dd19094c9f758e$var$POPUP_MARGIN = 8; // never touch the viewport edge
const $d9dd19094c9f758e$export$bb703e6cd16789d6 = ({ anchorRef: anchorRef, onClose: onClose, children: children, width: width = $d9dd19094c9f758e$var$POPUP_WIDTH, locale: locale })=>{
    const cardRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // The card reads in the language its calendar is drawn in — pass the same `locale`
    // to both, or neither and let both read `<html lang>`.
    const rtl = (0, $IZwml.datePickerLocale)(locale).dir === 'rtl';
    // Positions the card by writing to the DOM node rather than through state: this runs
    // from a ResizeObserver (mode switches change the card's height) and from scroll, and
    // a setState there would re-render → re-measure → re-render without ever settling.
    const place = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        const card = cardRef.current;
        const anchor = anchorRef.current;
        if (!card || !anchor) return;
        const vh = window.innerHeight;
        const vw = window.innerWidth;
        const maxH = vh - $d9dd19094c9f758e$var$POPUP_MARGIN * 2;
        // Cap first, measure second — otherwise a card taller than the viewport reports a
        // height no placement can satisfy.
        card.style.maxHeight = `${maxH}px`;
        const h = Math.min(card.offsetHeight || 0, maxH);
        const rect = anchor.getBoundingClientRect();
        const roomBelow = vh - rect.bottom - $d9dd19094c9f758e$var$POPUP_GAP - $d9dd19094c9f758e$var$POPUP_MARGIN;
        const roomAbove = rect.top - $d9dd19094c9f758e$var$POPUP_GAP - $d9dd19094c9f758e$var$POPUP_MARGIN;
        // Below by default; flip above only when that side genuinely has more room.
        let top = h <= roomBelow || roomBelow >= roomAbove ? rect.bottom + $d9dd19094c9f758e$var$POPUP_GAP : rect.top - $d9dd19094c9f758e$var$POPUP_GAP - h;
        top = Math.max($d9dd19094c9f758e$var$POPUP_MARGIN, Math.min(top, vh - $d9dd19094c9f758e$var$POPUP_MARGIN - h));
        // The trigger's START edge: right edges align under RTL, left edges under LTR. Then
        // clamp so a trigger near either viewport edge can't push the card off-screen.
        let left = rtl ? rect.right - width : rect.left;
        left = Math.max($d9dd19094c9f758e$var$POPUP_MARGIN, Math.min(left, vw - $d9dd19094c9f758e$var$POPUP_MARGIN - width));
        card.style.top = `${top}px`;
        card.style.left = `${left}px`;
        card.style.visibility = 'visible';
    }, [
        anchorRef,
        width,
        rtl
    ]);
    // Layout effect, before paint: a card positioned after the fact is a card the user
    // sees jump from the corner of the screen to where it belongs.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(()=>{
        place();
        const onScroll = ()=>place();
        // capture:true — the scroll that matters is usually an ancestor's (the modal body),
        // and scroll events from those don't bubble to window.
        window.addEventListener('scroll', onScroll, true);
        window.addEventListener('resize', place);
        let ro;
        if (typeof ResizeObserver !== 'undefined' && cardRef.current) {
            ro = new ResizeObserver(()=>place());
            ro.observe(cardRef.current);
        }
        return ()=>{
            window.removeEventListener('scroll', onScroll, true);
            window.removeEventListener('resize', place);
            ro?.disconnect();
        };
    }, [
        place
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const h = (e)=>{
            if (cardRef.current?.contains(e.target)) return;
            if (anchorRef.current?.contains(e.target)) return; // the trigger toggles itself
            onClose();
        };
        document.addEventListener('mousedown', h);
        return ()=>document.removeEventListener('mousedown', h);
    }, [
        anchorRef,
        onClose
    ]);
    // A modal Radix dialog locks scrolling with react-remove-scroll, which cancels every
    // `wheel` and `touchmove` that reaches `document` from OUTSIDE the dialog — and this
    // card is portaled out of it. So in «ویرایش بیمار» and every other dialog with a date
    // field the year list (and a card taller than the screen) could not be scrolled by
    // wheel, trackpad or finger, only by dragging a scrollbar (PM-0121). Stopped here they
    // never reach that listener; the card's own scrolling is the browser's and needs
    // nothing more. Passive: nothing here cancels a scroll. The page behind stays locked.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const card = cardRef.current;
        if (!card) return undefined;
        const keep = (e)=>e.stopPropagation();
        card.addEventListener('wheel', keep, {
            passive: true
        });
        card.addEventListener('touchmove', keep, {
            passive: true
        });
        return ()=>{
            card.removeEventListener('wheel', keep);
            card.removeEventListener('touchmove', keep);
        };
    }, []);
    return /*#__PURE__*/ (0, $1u0KT.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: cardRef,
        "data-jalali-popup": "",
        style: {
            position: 'fixed',
            top: 0,
            left: 0,
            visibility: 'hidden',
            overflowY: 'auto',
            overscrollBehavior: 'contain',
            zIndex: 9999,
            width: width,
            background: 'white',
            borderRadius: 16,
            padding: '16px 14px',
            boxShadow: '0 16px 48px rgba(0,0,0,0.18)',
            border: `1px solid ${(0, $jTCZr.C).border}`,
            direction: rtl ? 'rtl' : 'ltr',
            boxSizing: 'border-box',
            pointerEvents: 'auto'
        }
    }, children), document.body);
};
// ── Time row ──────────────────────────────────────────────────────────────────
// Two spinnable segments under the calendar, shown only when `withTime`. Rendered LTR:
// an "HH:MM" pair inside an RTL paragraph gets its two numeric runs reordered by the
// bidi algorithm, so the minutes would appear where the hours belong.
//
// Steppers, not text boxes, on purpose. The popup is portaled to <body>, so inside a
// modal Radix dialog it sits outside the focus scope and anything focusable in it gets
// focus yanked straight back into the dialog — a text field there could never be typed
// into. Buttons don't need focus to be clicked, and an exact time can always be typed
// into the field itself, which does live inside the dialog.
const $d9dd19094c9f758e$var$StepBtn = ({ onClick: onClick, label: label, children: children })=>{
    const [hov, setHov] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        "aria-label": label,
        onClick: onClick,
        onMouseEnter: ()=>setHov(true),
        onMouseLeave: ()=>setHov(false),
        style: {
            background: hov ? '#e2e8f0' : 'transparent',
            border: 'none',
            borderRadius: 4,
            width: 26,
            height: 18,
            padding: 0,
            cursor: 'pointer',
            color: (0, $jTCZr.C).textSecondary,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'background 0.12s'
        }
    }, children);
};
const $d9dd19094c9f758e$var$ChevUp = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "12",
        height: "12"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
    }));
const $d9dd19094c9f758e$var$ChevDn = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "12",
        height: "12"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M12 16l6-6-1.41-1.41L12 13.17 7.41 8.59 6 10z"
    }));
const $d9dd19094c9f758e$var$TimeSegment = ({ value: value, onChange: onChange, max: max, step: step, label: label, L: L })=>{
    const wrap = (n)=>(n % (max + 1) + max + 1) % (max + 1);
    const shown = (0, $IZwml.withDigits)($d9dd19094c9f758e$var$pad2(value), L.digits);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "spinbutton",
        "aria-label": label,
        "aria-valuenow": value,
        "aria-valuemin": 0,
        "aria-valuemax": max,
        "aria-valuetext": shown,
        style: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$StepBtn, {
        label: (0, $IZwml.fillTemplate)(L.strings.stepUp, {
            label: label
        }),
        onClick: ()=>onChange(wrap(value + step))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$ChevUp, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 42,
            height: 30,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: 8,
            background: '#f8fafc',
            color: (0, $jTCZr.C).textPrimary,
            fontSize: '0.875rem',
            fontWeight: 700,
            fontFamily: 'Meshkat, sans-serif',
            boxSizing: 'border-box',
            userSelect: 'none'
        }
    }, shown), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$StepBtn, {
        label: (0, $IZwml.fillTemplate)(L.strings.stepDown, {
            label: label
        }),
        onClick: ()=>onChange(wrap(value - step))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$ChevDn, null)));
};
const $d9dd19094c9f758e$var$TimeRow = ({ hh: hh, mi: mi, onChange: onChange, minuteStep: minuteStep = 5, L: L })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: 12,
            paddingTop: 12,
            borderTop: `1px solid ${(0, $jTCZr.C).border}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.75rem',
            fontWeight: 700,
            color: (0, $jTCZr.C).textSecondary,
            fontFamily: 'Meshkat, sans-serif'
        }
    }, L.strings.time), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            direction: 'ltr'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$TimeSegment, {
        L: L,
        label: L.strings.hour,
        value: hh,
        max: 23,
        step: 1,
        onChange: (h)=>onChange(h, mi)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.875rem',
            fontWeight: 800,
            color: (0, $jTCZr.C).textMuted
        }
    }, ":"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$TimeSegment, {
        L: L,
        label: L.strings.minute,
        value: mi,
        max: 59,
        step: minuteStep,
        onChange: (m)=>onChange(hh, m)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: ()=>{
            const n = new Date();
            onChange(n.getHours(), Math.floor(n.getMinutes() / minuteStep) * minuteStep);
        },
        style: {
            background: '#f8fafc',
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: 8,
            height: 28,
            padding: '0 10px',
            fontSize: '0.75rem',
            fontWeight: 600,
            color: (0, $jTCZr.C).textSecondary,
            cursor: 'pointer',
            fontFamily: 'Meshkat, sans-serif'
        }
    }, L.strings.now));
// ── Main Component ────────────────────────────────────────────────────────────
// Editable input + the shared calendar. The selected moment lives entirely in `value` —
// the only local copy is `draft`, the half-typed text, which exists exactly while the
// field has focus and is discarded (never committed) if it never parses.
//
// Idle, the field reads «۱۲ مرداد ۱۴۰۴» (English: «August 3, 2025»); focused, it
// becomes the numeric «۱۴۰۴/۰۵/۱۲» («2025/08/03») the parser round-trips. The input is
// dir="ltr" while typed so date and time segments keep their order — bidi reorders two
// numeric runs inside an RTL field.
//
// `locale` (default `<html lang>`) and `calendar` behave as on `JalaliCalendar`.
const $d9dd19094c9f758e$var$JalaliDatePicker = ({ value: value, onChange: onChange, placeholder: placeholder, locale: locale, calendar: calendar, height: height = 44, fontSize: fontSize = 14, disabled: disabled = false, disableFuture: disableFuture = false, withTime: withTime = false, minuteStep: minuteStep = 5, readOnlyInput: readOnlyInput = false, id: // Forwarded to the typeable <input> (v0.16.1), so a FormField label can name it
// (DESIGN_CONCEPT §12.3) and a caller can validate on blur.
id, name: name, onBlur: onBlur, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, 'aria-describedby': ariaDescribedBy, 'aria-invalid': ariaInvalid, 'data-testid': testId })=>{
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [draft, setDraft] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // null ⇒ not typing
    // The error CODE, not its wording — so a language switch re-words a standing error.
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const triggerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const inputRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const { L: L, cal: cal, months: months, num: num } = $d9dd19094c9f758e$var$resolvePicker(locale, calendar);
    const rtl = L.dir === 'rtl';
    const { date: date, time: time } = $d9dd19094c9f758e$export$565a3e0423f3fda3(value);
    const sel = date ? $d9dd19094c9f758e$var$valueToDate(cal, date) : null;
    const [hh, mi] = time ? time.split(':').map(Number) : [
        0,
        0
    ];
    const prettyDate = sel ? (0, $IZwml.fillTemplate)(L.date, {
        d: num(sel.d),
        month: months[sel.m - 1],
        y: num(sel.y)
    }) : '';
    const prettyVal = sel && withTime && time ? (0, $IZwml.fillTemplate)(L.dateTime, {
        date: prettyDate,
        time: num(`${$d9dd19094c9f758e$var$pad2(hh)}:${$d9dd19094c9f758e$var$pad2(mi)}`)
    }) : prettyDate;
    // «Date format: 2026/09/26» — the example is today, in the calendar and digits shown.
    const errorText = (()=>{
        if (!error) return '';
        const t = $d9dd19094c9f758e$var$todayIn(cal);
        return (0, $IZwml.fillTemplate)(L.errors[error] || L.errors.format, {
            example: num(`${t.y}/${$d9dd19094c9f758e$var$pad2(t.m)}/${$d9dd19094c9f758e$var$pad2(t.d)}`)
        });
    })();
    const editable = !disabled && !readOnlyInput;
    const shownText = draft !== null ? draft : prettyVal;
    // The time a with-time field falls back to when a date arrives without one — by
    // picking or by typing, the same either way. Now, rounded down to the step: 00:00 is
    // almost never the moment someone meant, and the result is visible in the field.
    const fallbackTime = ()=>{
        const now = new Date();
        return `${$d9dd19094c9f758e$var$pad2(now.getHours())}:${$d9dd19094c9f758e$var$pad2(Math.floor(now.getMinutes() / minuteStep) * minuteStep)}`;
    };
    const emitDate = (gregorian)=>{
        if (!gregorian) {
            onChange('');
            return;
        }
        if (!withTime) {
            onChange(gregorian);
            setOpen(false);
            return;
        }
        onChange(`${gregorian} ${time || fallbackTime()}`); // popup stays open for the time
    };
    // Setting a time before a day picks today, so the field can never hold a bare time.
    // The draft is dropped: a modal's focus trap can bounce focus back into the field
    // while the popup is used, and a stale half-typed draft would then hide the new time.
    const emitTime = (h, m)=>{
        const t = $d9dd19094c9f758e$var$todayIn(cal);
        const d = date || $d9dd19094c9f758e$var$dateToValue(cal, t.y, t.m, t.d);
        setDraft(null);
        setError('');
        onChange(`${d} ${$d9dd19094c9f758e$var$pad2(h)}:${$d9dd19094c9f758e$var$pad2(m)}`);
    };
    const handleType = (raw)=>{
        setDraft(raw);
        if (!raw.trim()) {
            setError('');
            if (value) onChange('');
            return;
        }
        const r = $d9dd19094c9f758e$export$26bc4d93216d514d(raw, {
            withTime: withTime,
            disableFuture: disableFuture,
            calendar: cal.id
        });
        if (r.error) {
            setError(r.error);
            return;
        }
        setError('');
        // A date typed with no time keeps the time the field already holds.
        if (withTime && !r.hasTime) onChange(`${r.value.slice(0, 10)} ${time || fallbackTime()}`);
        else onChange(r.value);
    };
    const startEditing = ()=>{
        if (!editable || draft !== null) return;
        setDraft($d9dd19094c9f758e$export$c715042cb80ca422(value, {
            withTime: withTime,
            calendar: cal.id,
            digits: L.digits
        }));
    };
    const commit = ()=>{
        if (draft === null) return;
        setDraft(null); // whatever survived is already in `value`; anything else reverts
        setError('');
    };
    const clearDate = (e)=>{
        e.stopPropagation();
        e.preventDefault();
        setDraft(null);
        setError('');
        onChange('');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'relative',
            width: '100%'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: triggerRef,
        onMouseDown: (e)=>{
            // Only the box's own padding — the input and the icons handle their own clicks.
            if (disabled || e.target !== e.currentTarget) return;
            if (editable) {
                e.preventDefault();
                inputRef.current?.focus();
                setOpen(true);
            } else setOpen((o)=>!o);
        },
        style: {
            height: height,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '0 12px',
            gap: 6,
            border: `1.5px solid ${error ? (0, $jTCZr.C).red : open || draft !== null ? (0, $jTCZr.C).navy : (0, $jTCZr.C).border}`,
            borderRadius: 10,
            cursor: disabled ? 'default' : editable ? 'text' : 'pointer',
            background: disabled ? '#f8fafc' : 'white',
            transition: 'border-color 0.18s',
            boxSizing: 'border-box'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ref: inputRef,
        type: "text",
        id: id,
        name: name,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        "aria-describedby": ariaDescribedBy,
        "aria-invalid": ariaInvalid ?? (error ? true : undefined),
        "data-testid": testId,
        // Displayed in the reader's direction, edited LTR. «۱۷ مهر ۱۳۶۹» is
        // number/word/number: under an LTR base the day lands on the far left and the
        // whole thing reads backwards. The typed «۱۳۶۹/۰۷/۱۷ ۱۴:۳۰» is the opposite
        // case — two numeric runs that bidi would swap in an RTL field, putting the
        // minutes where the year belongs.
        dir: draft !== null ? 'ltr' : L.dir,
        value: shownText,
        placeholder: placeholder ?? L.strings.placeholder,
        disabled: disabled,
        readOnly: !editable,
        onFocus: startEditing,
        onClick: ()=>{
            if (disabled) return;
            if (editable) setOpen(true);
            else setOpen((o)=>!o);
        },
        onChange: (e)=>handleType(e.target.value),
        onBlur: (e)=>{
            commit();
            onBlur?.(e);
        },
        onKeyDown: (e)=>{
            if (e.key === 'Enter') {
                e.preventDefault();
                commit();
                setOpen(false);
                inputRef.current?.blur();
            } else if (e.key === 'Escape') {
                setDraft(null);
                setError('');
                setOpen(false);
            } else if (e.key === 'ArrowDown' && !open) setOpen(true);
        },
        style: {
            flex: 1,
            minWidth: 0,
            height: '100%',
            border: 'none',
            outline: 'none',
            // Pinned to the reader's side, so starting to type does not jump the text.
            background: 'transparent',
            padding: 0,
            textAlign: rtl ? 'right' : 'left',
            fontSize: typeof fontSize === 'number' ? `${fontSize / 16}rem` : fontSize,
            fontFamily: 'Meshkat, sans-serif',
            color: shownText ? (0, $jTCZr.C).textPrimary : (0, $jTCZr.C).textMuted,
            cursor: editable ? 'text' : disabled ? 'default' : 'pointer'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 4,
            flexShrink: 0
        }
    }, (sel || draft) && !disabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        "aria-label": L.strings.clear,
        onMouseDown: clearDate,
        style: {
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: 2,
            borderRadius: 4,
            color: (0, $jTCZr.C).textMuted,
            display: 'flex',
            alignItems: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "14",
        height: "14"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        "aria-label": L.strings.openCalendar,
        onMouseDown: (e)=>{
            e.preventDefault();
            if (!disabled) setOpen((o)=>!o);
        },
        style: {
            background: 'none',
            border: 'none',
            padding: 0,
            cursor: disabled ? 'default' : 'pointer',
            display: 'flex',
            alignItems: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: open ? (0, $jTCZr.C).navy : (0, $jTCZr.C).textMuted,
        width: "18",
        height: "18"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M20 3h-1V1h-2v2H7V1H5v2H4C2.9 5 2 5.9 2 7v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 18H4V8h16v13zM7 10h5v5H7z"
    }))))), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: 4,
            fontSize: '0.6875rem',
            fontWeight: 600,
            color: (0, $jTCZr.C).red,
            fontFamily: 'Meshkat, sans-serif'
        }
    }, errorText), open && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$export$bb703e6cd16789d6, {
        anchorRef: triggerRef,
        onClose: ()=>setOpen(false),
        locale: locale
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$export$9c97d98ce20c6c7a, {
        locale: locale,
        calendar: calendar,
        value: date,
        onChange: (v)=>{
            setDraft(null);
            setError('');
            emitDate(v);
        },
        disableFuture: disableFuture
    }), withTime && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$TimeRow, {
        L: L,
        hh: hh,
        mi: mi,
        minuteStep: minuteStep,
        onChange: emitTime
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: ()=>setOpen(false),
        style: {
            marginTop: 10,
            width: '100%',
            height: 34,
            background: (0, $jTCZr.C).navy,
            border: 'none',
            borderRadius: 8,
            fontSize: '0.8125rem',
            fontWeight: 700,
            color: 'white',
            cursor: 'pointer',
            fontFamily: 'Meshkat, sans-serif'
        }
    }, L.strings.confirm))));
};
var $d9dd19094c9f758e$export$2e2bcd8739ae039 = $d9dd19094c9f758e$var$JalaliDatePicker;

});
parcelRegister("IZwml", function(module, exports) {

$parcel$export(module.exports, "DATE_PICKER_LOCALES", () => $0873d4f32691c14e$export$4b8e9f545c94f612);
$parcel$export(module.exports, "datePickerLocale", () => $0873d4f32691c14e$export$90e478cf5247906b);
$parcel$export(module.exports, "fillTemplate", () => $0873d4f32691c14e$export$9a328bbde6508c84);
$parcel$export(module.exports, "withDigits", () => $0873d4f32691c14e$export$545c62727d3740ae);
// ─────────────────────────────────────────────────────────────────────────────
// What the date picker draws in each UI language.
//
// The picker used to be Persian whatever the page was: an English reception
// desk read «۴ مهر ۱۴۰۵» in a field whose own heading said «Saturday,
// September 26, 2026», and a mistyped date answered «قالب تاریخ: ۱۴۰۴/۰۵/۱۲».
// Everything the picker shows now comes from this table, keyed by the base
// language of `<html lang>` — the channel `MoneyInput` and `PhoneInput` already
// read (see `documentLocale` in money.js). The kit cannot import an app's i18n.
//
// `calendar` is the one entry that is not wording. It matches the calendar each
// app's locale descriptor hands Intl (`intl` in i18n/config.js): Persian and
// Arabic are Jalali (`-u-ca-persian`), English, French and German are Gregorian. The
// picker and the app's own `formatDate` have to agree, or the desk picks one day
// and reads back another. CLDR cannot supply it — it gives `ar` the Gregorian
// calendar, which both apps deliberately override — so it is data here, not
// `resolvedOptions().calendar`.
//
// `months` carries BOTH calendars' names for every language, because a caller
// can pin the calendar (`calendar="jalali"`) on a surface that is Jalali in
// every language — an accounting period is bounded by Jalali months whatever
// the UI language is.
//
// `date` is wording AND word order: DateRangeFilter reads the order of a range
// label off it (day first unless `{month}` leads), never off `calendar` — French
// and German are Gregorian like English and still put the day first; German's
// «{d}.» also gives every day of a range its ordinal dot. `weekStart` is the
// first column of a GREGORIAN grid only; a Jalali grid opens on Saturday in
// every language (JalaliDatePicker.jsx `JALALI.weekStart`).
//
// Adding a language is adding an entry. An unknown one gets Persian, the product
// default, exactly as `documentLocale` falls back — or the brand's default
// language when the brand names one.
//
// A BRAND that names a calendar (`calendar: 'gregory' | 'jalali'`,
// ui/lib/brand.js) moves every language's `calendar` to it, the same switch the
// apps' locale descriptors make, so picker and `formatDate` still agree. A caller
// that pins `calendar` on the picker still wins.
// ─────────────────────────────────────────────────────────────────────────────

var $hlTfq = parcelRequire("hlTfq");

var $eLeza = parcelRequire("eLeza");
// The brand's calendar ids → this table's.
const $0873d4f32691c14e$var$PICKER_CALENDAR = {
    gregory: 'gregorian',
    jalali: 'jalali'
};
const $0873d4f32691c14e$export$4b8e9f545c94f612 = {
    fa: {
        calendar: 'jalali',
        dir: 'rtl',
        digits: "\u06F0\u06F1\u06F2\u06F3\u06F4\u06F5\u06F6\u06F7\u06F8\u06F9",
        // First column of a Gregorian grid; a Jalali grid always opens on شنبه.
        weekStart: 6,
        // Indexed by `Date#getDay()` — 0 is Sunday.
        weekdays: [
            "\u06CC",
            "\u062F",
            "\u0633",
            "\u0686",
            "\u067E",
            "\u062C",
            "\u0634"
        ],
        months: {
            jalali: [
                "\u0641\u0631\u0648\u0631\u062F\u06CC\u0646",
                "\u0627\u0631\u062F\u06CC\u0628\u0647\u0634\u062A",
                "\u062E\u0631\u062F\u0627\u062F",
                "\u062A\u06CC\u0631",
                "\u0645\u0631\u062F\u0627\u062F",
                "\u0634\u0647\u0631\u06CC\u0648\u0631",
                "\u0645\u0647\u0631",
                "\u0622\u0628\u0627\u0646",
                "\u0622\u0630\u0631",
                "\u062F\u06CC",
                "\u0628\u0647\u0645\u0646",
                "\u0627\u0633\u0641\u0646\u062F"
            ],
            gregorian: [
                "\u0698\u0627\u0646\u0648\u06CC\u0647",
                "\u0641\u0648\u0631\u06CC\u0647",
                "\u0645\u0627\u0631\u0633",
                "\u0622\u0648\u0631\u06CC\u0644",
                "\u0645\u0647",
                "\u0698\u0648\u0626\u0646",
                "\u0698\u0648\u0626\u06CC\u0647",
                "\u0627\u0648\u062A",
                "\u0633\u067E\u062A\u0627\u0645\u0628\u0631",
                "\u0627\u06A9\u062A\u0628\u0631",
                "\u0646\u0648\u0627\u0645\u0628\u0631",
                "\u062F\u0633\u0627\u0645\u0628\u0631"
            ]
        },
        date: '{d} {month} {y}',
        dateTime: "{date} \u0633\u0627\u0639\u062A {time}",
        strings: {
            placeholder: "\u0627\u0646\u062A\u062E\u0627\u0628 \u062A\u0627\u0631\u06CC\u062E",
            selectYear: "\u0627\u0646\u062A\u062E\u0627\u0628 \u0633\u0627\u0644",
            goToToday: "\u0628\u0631\u0648 \u0628\u0647 \u0627\u0645\u0631\u0648\u0632",
            clear: "\u067E\u0627\u06A9 \u06A9\u0631\u062F\u0646 \u062A\u0627\u0631\u06CC\u062E",
            openCalendar: "\u0646\u0645\u0627\u06CC\u0634 \u062A\u0642\u0648\u06CC\u0645",
            time: "\u0633\u0627\u0639\u062A",
            hour: "\u0633\u0627\u0639\u062A",
            minute: "\u062F\u0642\u06CC\u0642\u0647",
            stepUp: "{label} \u0628\u06CC\u0634\u062A\u0631",
            stepDown: "{label} \u06A9\u0645\u062A\u0631",
            now: "\u0627\u06A9\u0646\u0648\u0646",
            confirm: "\u062A\u0627\u06CC\u06CC\u062F"
        },
        errors: {
            format: "\u0642\u0627\u0644\u0628 \u062A\u0627\u0631\u06CC\u062E: {example}",
            range: "\u062A\u0627\u0631\u06CC\u062E \u0646\u0627\u0645\u0639\u062A\u0628\u0631 \u0627\u0633\u062A",
            time: "\u0633\u0627\u0639\u062A \u0646\u0627\u0645\u0639\u062A\u0628\u0631 \u0627\u0633\u062A",
            noTime: "\u0627\u06CC\u0646 \u0641\u06CC\u0644\u062F \u0633\u0627\u0639\u062A \u0646\u0645\u06CC\u200C\u067E\u0630\u06CC\u0631\u062F",
            future: "\u062A\u0627\u0631\u06CC\u062E \u0622\u06CC\u0646\u062F\u0647 \u0645\u062C\u0627\u0632 \u0646\u06CC\u0633\u062A"
        }
    },
    en: {
        calendar: 'gregorian',
        dir: 'ltr',
        digits: '0123456789',
        weekStart: 0,
        weekdays: [
            'Su',
            'Mo',
            'Tu',
            'We',
            'Th',
            'Fr',
            'Sa'
        ],
        months: {
            // The Latin spellings ICU gives `en-US-u-ca-persian`, so a pinned-Jalali
            // picker and the app's `clinicCalendarIntl` labels name a month the same way.
            jalali: [
                'Farvardin',
                'Ordibehesht',
                'Khordad',
                'Tir',
                'Mordad',
                'Shahrivar',
                'Mehr',
                'Aban',
                'Azar',
                'Dey',
                'Bahman',
                'Esfand'
            ],
            gregorian: [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December'
            ]
        },
        date: '{month} {d}, {y}',
        dateTime: '{date}, {time}',
        strings: {
            placeholder: 'Select date',
            selectYear: 'Select year',
            goToToday: 'Go to today',
            clear: 'Clear date',
            openCalendar: 'Show calendar',
            time: 'Time',
            hour: 'Hour',
            minute: 'Minute',
            stepUp: '{label} up',
            stepDown: '{label} down',
            now: 'Now',
            confirm: 'Done'
        },
        errors: {
            format: 'Date format: {example}',
            range: 'Invalid date',
            time: 'Invalid time',
            noTime: 'This field does not take a time',
            future: 'Future dates are not allowed'
        }
    },
    ar: {
        calendar: 'jalali',
        dir: 'rtl',
        // Arabic-Indic, the set the apps' `-u-nu-arab` renders — NOT Persian's.
        digits: "\u0660\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669",
        weekStart: 6,
        weekdays: [
            "\u062D",
            "\u0646",
            "\u062B",
            "\u0631",
            "\u062E",
            "\u062C",
            "\u0633"
        ],
        months: {
            // The apps' corrected list (`monthNames` on their `ar` descriptor): CLDR's
            // Arabic names for the Persian calendar are not words in any language.
            jalali: [
                "\u0641\u0631\u0648\u0631\u062F\u064A\u0646",
                "\u0627\u0631\u062F\u064A\u0628\u0647\u0634\u062A",
                "\u062E\u0631\u062F\u0627\u062F",
                "\u062A\u064A\u0631",
                "\u0645\u0631\u062F\u0627\u062F",
                "\u0634\u0647\u0631\u064A\u0648\u0631",
                "\u0645\u0647\u0631",
                "\u0622\u0628\u0627\u0646",
                "\u0622\u0630\u0631",
                "\u062F\u064A",
                "\u0628\u0647\u0645\u0646",
                "\u0627\u0633\u0641\u0646\u062F"
            ],
            gregorian: [
                "\u064A\u0646\u0627\u064A\u0631",
                "\u0641\u0628\u0631\u0627\u064A\u0631",
                "\u0645\u0627\u0631\u0633",
                "\u0623\u0628\u0631\u064A\u0644",
                "\u0645\u0627\u064A\u0648",
                "\u064A\u0648\u0646\u064A\u0648",
                "\u064A\u0648\u0644\u064A\u0648",
                "\u0623\u063A\u0633\u0637\u0633",
                "\u0633\u0628\u062A\u0645\u0628\u0631",
                "\u0623\u0643\u062A\u0648\u0628\u0631",
                "\u0646\u0648\u0641\u0645\u0628\u0631",
                "\u062F\u064A\u0633\u0645\u0628\u0631"
            ]
        },
        date: '{d} {month} {y}',
        dateTime: "{date} \u0627\u0644\u0633\u0627\u0639\u0629 {time}",
        strings: {
            placeholder: "\u0627\u062E\u062A\u0631 \u0627\u0644\u062A\u0627\u0631\u064A\u062E",
            selectYear: "\u0627\u062E\u062A\u0631 \u0627\u0644\u0633\u0646\u0629",
            goToToday: "\u0627\u0644\u0630\u0647\u0627\u0628 \u0625\u0644\u0649 \u0627\u0644\u064A\u0648\u0645",
            clear: "\u0645\u0633\u062D \u0627\u0644\u062A\u0627\u0631\u064A\u062E",
            openCalendar: "\u0639\u0631\u0636 \u0627\u0644\u062A\u0642\u0648\u064A\u0645",
            time: "\u0627\u0644\u0648\u0642\u062A",
            hour: "\u0627\u0644\u0633\u0627\u0639\u0629",
            minute: "\u0627\u0644\u062F\u0642\u064A\u0642\u0629",
            stepUp: "\u0632\u064A\u0627\u062F\u0629 {label}",
            stepDown: "\u0625\u0646\u0642\u0627\u0635 {label}",
            now: "\u0627\u0644\u0622\u0646",
            confirm: "\u062A\u0623\u0643\u064A\u062F"
        },
        errors: {
            format: "\u0635\u064A\u063A\u0629 \u0627\u0644\u062A\u0627\u0631\u064A\u062E: {example}",
            range: "\u062A\u0627\u0631\u064A\u062E \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
            time: "\u0648\u0642\u062A \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
            noTime: "\u0647\u0630\u0627 \u0627\u0644\u062D\u0642\u0644 \u0644\u0627 \u064A\u0642\u0628\u0644 \u0648\u0642\u062A\u064B\u0627",
            future: "\u0644\u0627 \u064A\u064F\u0633\u0645\u062D \u0628\u062A\u0627\u0631\u064A\u062E \u0645\u0633\u062A\u0642\u0628\u0644\u064A"
        }
    },
    // PM-0185 (D3/D8/D9 = the workspace's docs/locale/FRENCH.md §9): Gregorian like
    // `en`, but day first and Monday first.
    fr: {
        calendar: 'gregorian',
        dir: 'ltr',
        digits: '0123456789',
        // Monday, as French calendars draw a week (CLDR fr firstDay 1, D9). Only the
        // Gregorian grid reads it; the panels' own week strips stay Saturday-first.
        weekStart: 1,
        // Indexed by `Date#getDay()` — 0 is Sunday. Two letters: CLDR's narrow
        // «D L M M J V S» names Tuesday and Wednesday alike.
        weekdays: [
            'Di',
            'Lu',
            'Ma',
            'Me',
            'Je',
            'Ve',
            'Sa'
        ],
        months: {
            // D8: the English UI's spellings, one fixed list — the `monthNames` the apps'
            // French descriptors pass (with `stripEra`) and server text's month names —
            // so picker, formatter and server name a month alike. Not ICU's
            // `fr-u-ca-persian` names (ordibehešt, khordâd …), which differ between ICU builds.
            jalali: [
                'Farvardin',
                'Ordibehesht',
                'Khordad',
                'Tir',
                'Mordad',
                'Shahrivar',
                'Mehr',
                'Aban',
                'Azar',
                'Dey',
                'Bahman',
                'Esfand'
            ],
            // Lower case, as French writes them, the calendar's heading included.
            gregorian: [
                'janvier',
                "f\xe9vrier",
                'mars',
                'avril',
                'mai',
                'juin',
                'juillet',
                "ao\xfbt",
                'septembre',
                'octobre',
                'novembre',
                "d\xe9cembre"
            ]
        },
        // What Intl prints for `fr-FR`: «26 septembre 2026», «26 septembre 2026 à 14:30».
        date: '{d} {month} {y}',
        dateTime: "{date} \xe0 {time}",
        strings: {
            placeholder: 'Choisir une date',
            selectYear: "Choisir l\u2019ann\xe9e",
            goToToday: "Aller \xe0 aujourd\u2019hui",
            clear: 'Effacer la date',
            openCalendar: 'Afficher le calendrier',
            time: 'Heure',
            hour: 'Heure',
            minute: 'Minute',
            // `{label}` is `hour` or `minute` above, capitalised — so it leads.
            stepUp: "{label}\xa0: augmenter",
            stepDown: "{label}\xa0: diminuer",
            now: 'Maintenant',
            confirm: 'OK'
        },
        errors: {
            format: "Format de date\xa0: {example}",
            range: 'Date non valide',
            time: 'Heure non valide',
            noTime: "Ce champ n\u2019accepte pas d\u2019heure",
            future: "Les dates futures ne sont pas autoris\xe9es"
        }
    },
    // PM-0212: German follows the French plan — Gregorian like `en`, day first and
    // Monday first, and the day is an ordinal («26. September 2026»).
    de: {
        calendar: 'gregorian',
        dir: 'ltr',
        digits: '0123456789',
        // Monday, as German calendars draw a week (CLDR de firstDay 1, DIN 1355). Only
        // the Gregorian grid reads it; the panels' own week strips stay Saturday-first.
        weekStart: 1,
        // Indexed by `Date#getDay()` — 0 is Sunday. The two-letter forms German
        // calendars print (CLDR `de` short: «So Mo Di Mi Do Fr Sa»).
        weekdays: [
            'So',
            'Mo',
            'Di',
            'Mi',
            'Do',
            'Fr',
            'Sa'
        ],
        months: {
            // The English UI's spellings, one fixed list — the `monthNames` the apps'
            // German descriptors pass (with `stripEra`) and server text's month names —
            // as for French (D8), not ICU's `de-u-ca-persian` names.
            jalali: [
                'Farvardin',
                'Ordibehesht',
                'Khordad',
                'Tir',
                'Mordad',
                'Shahrivar',
                'Mehr',
                'Aban',
                'Azar',
                'Dey',
                'Bahman',
                'Esfand'
            ],
            gregorian: [
                'Januar',
                'Februar',
                "M\xe4rz",
                'April',
                'Mai',
                'Juni',
                'Juli',
                'August',
                'September',
                'Oktober',
                'November',
                'Dezember'
            ]
        },
        // What Intl prints for `de-DE`: «26. September 2026», «26. September 2026 um 14:30».
        // The «.» after `{d}` is the ordinal; DateRangeFilter keeps it on every day.
        date: '{d}. {month} {y}',
        dateTime: '{date} um {time}',
        strings: {
            placeholder: "Datum w\xe4hlen",
            selectYear: "Jahr w\xe4hlen",
            goToToday: 'Zu heute springen',
            clear: "Datum l\xf6schen",
            openCalendar: 'Kalender anzeigen',
            time: 'Uhrzeit',
            hour: 'Stunde',
            minute: 'Minute',
            // `{label}` is `hour` or `minute` above, a capitalised noun — so it leads.
            stepUp: "{label} erh\xf6hen",
            stepDown: '{label} verringern',
            now: 'Jetzt',
            confirm: 'Fertig'
        },
        errors: {
            format: 'Datumsformat: {example}',
            range: "Ung\xfcltiges Datum",
            time: "Ung\xfcltige Uhrzeit",
            noTime: 'Dieses Feld nimmt keine Uhrzeit an',
            future: "Ein Datum in der Zukunft ist nicht zul\xe4ssig"
        }
    }
};
function $0873d4f32691c14e$export$90e478cf5247906b(locale) {
    const base = String(locale || (0, $hlTfq.documentLocale)()).toLowerCase().split(/[-_]/)[0];
    const L = $0873d4f32691c14e$export$4b8e9f545c94f612[base] || $0873d4f32691c14e$export$4b8e9f545c94f612[(0, $eLeza.brandDefaultLocale)('fa')] || $0873d4f32691c14e$export$4b8e9f545c94f612.fa;
    const calendar = $0873d4f32691c14e$var$PICKER_CALENDAR[(0, $eLeza.calendarSystem)(null)];
    return !calendar || calendar === L.calendar ? L : {
        ...L,
        calendar: calendar
    };
}
const $0873d4f32691c14e$export$9a328bbde6508c84 = (template, vars)=>String(template).replace(/\{(\w+)\}/g, (m, k)=>k in vars ? String(vars[k]) : m);
const $0873d4f32691c14e$export$545c62727d3740ae = (s, digits)=>String(s).replace(/\d/g, (d)=>digits[d]);

});


parcelRegister("2vdhF", function(module, exports) {

$parcel$export(module.exports, "shiftISO", () => $1d28c7ea24194f0d$export$c13cab26eb520a22);
$parcel$export(module.exports, "jalaliWeekStart", () => $1d28c7ea24194f0d$export$4905be222d58a860);
$parcel$export(module.exports, "weekDaysFrom", () => $1d28c7ea24194f0d$export$6b21eb5279a580dd);
$parcel$export(module.exports, "isoNoonMs", () => $1d28c7ea24194f0d$export$fa5589c3fde4793c);
// ─────────────────────────────────────────────────────────────────────────────
// Jalali weeks over Iran-local ISO dates ('YYYY-MM-DD').
//
// The reception surfaces of the doctor and clinic panels both browse a day at
// a time and a week at a time (`WeekPickerSheet`), and both speak an absolute
// ISO date in the URL or state. The arithmetic is done at UTC noon so neither
// DST nor the browser's own zone can move a day across midnight.
//
// A Jalali week opens on Saturday: شنبه = 0 … جمعه = 6.
// ─────────────────────────────────────────────────────────────────────────────
const $1d28c7ea24194f0d$var$DAY_MS = 86400000;
const $1d28c7ea24194f0d$var$noonMs = (iso)=>Date.parse(`${iso}T12:00:00Z`);
const $1d28c7ea24194f0d$export$c13cab26eb520a22 = (iso, days)=>new Date($1d28c7ea24194f0d$var$noonMs(iso) + days * $1d28c7ea24194f0d$var$DAY_MS).toISOString().split('T')[0];
const $1d28c7ea24194f0d$export$f9f83315c2979a2f = (iso)=>(new Date($1d28c7ea24194f0d$var$noonMs(iso)).getUTCDay() + 1) % 7;
const $1d28c7ea24194f0d$export$4905be222d58a860 = (iso)=>$1d28c7ea24194f0d$export$c13cab26eb520a22(iso, -$1d28c7ea24194f0d$export$f9f83315c2979a2f(iso));
const $1d28c7ea24194f0d$export$6b21eb5279a580dd = (startISO)=>Array.from({
        length: 7
    }, (_, i)=>$1d28c7ea24194f0d$export$c13cab26eb520a22(startISO, i));
const $1d28c7ea24194f0d$export$fa5589c3fde4793c = $1d28c7ea24194f0d$var$noonMs;

});


parcelRegister("gJslC", function(module, exports) {

$parcel$export(module.exports, "default", () => $336d0c00b1b6b543$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $huNwV = parcelRequire("huNwV");

var $jTCZr = parcelRequire("jTCZr");

var $aJ1FU = parcelRequire("aJ1FU");

var $cZOyb = parcelRequire("cZOyb");

var $j9AxR = parcelRequire("j9AxR");
'use client';
function $336d0c00b1b6b543$export$2e2bcd8739ae039({ open: open, onClose: onClose, title: title, closeLabel: closeLabel, groups: groups = [], locale: locale, testIdPrefix: testIdPrefix = 'choice' }) {
    const close = closeLabel || (0, $j9AxR.kitCopy)(locale).close;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: open,
        onClose: onClose,
        title: title,
        closeLabel: close,
        "data-testid": `${testIdPrefix}-sheet`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem'
        }
    }, groups.filter((g)=>g.options?.length).map((g)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
            key: g.key,
            "data-testid": `${testIdPrefix}-group-${g.key}`
        }, g.title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h3", {
            style: {
                margin: '0 0 0.25rem',
                padding: '0 0.25rem',
                fontSize: '0.75rem',
                fontWeight: 800,
                color: (0, $jTCZr.C).textSecondary
            }
        }, g.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            role: "radiogroup",
            "aria-label": g.label || g.title,
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: '0.25rem'
            }
        }, g.options.map((row)=>{
            const Icon = row.icon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
                key: row.id,
                variant: "ghost",
                role: "radio",
                "aria-checked": Boolean(row.checked),
                "data-testid": `${testIdPrefix}-option-${row.id}`,
                className: "h-auto min-h-[3.25rem] w-full justify-start gap-3 rounded-xl px-2.5 py-2 font-normal",
                style: {
                    background: row.checked ? (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.08) : 'transparent',
                    textAlign: 'start'
                },
                onClick: ()=>{
                    g.onPick?.(row.id);
                    if (!row.keepOpen) onClose?.();
                }
            }, Icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                "aria-hidden": true,
                style: {
                    width: '2rem',
                    height: '2rem',
                    borderRadius: '0.5rem',
                    flexShrink: 0,
                    display: 'grid',
                    placeItems: 'center',
                    background: row.quiet ? (0, $jTCZr.C).bg : (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.12),
                    color: row.quiet ? (0, $jTCZr.C).textSecondary : (0, $jTCZr.C).navy
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
                size: 16
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    flex: 1,
                    minWidth: 0
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                dir: "auto",
                style: {
                    display: 'block',
                    fontSize: '0.84375rem',
                    fontWeight: 700,
                    color: (0, $jTCZr.C).textPrimary,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                }
            }, row.name), row.meta && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    display: 'block',
                    fontSize: '0.71875rem',
                    color: (0, $jTCZr.C).textSecondary,
                    whiteSpace: 'normal'
                }
            }, row.meta)), row.checked && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
                size: 16,
                "aria-hidden": true,
                style: {
                    color: (0, $jTCZr.C).navy,
                    flexShrink: 0
                }
            }));
        }))))));
}

});

parcelRegister("dyHsi", function(module, exports) {

$parcel$export(module.exports, "default", () => $28cc8471170fac89$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $j9AxR = parcelRequire("j9AxR");
'use client';
function $28cc8471170fac89$export$2e2bcd8739ae039({ checked: checked = false, onChange: onChange, disabled: disabled = false, suggested: suggested = false, separated: separated = false, compact: compact = false, title: title, hint: hint = null, labels: labels, locale: locale, testId: testId = 'walkin-toggle', style: style }) {
    const copy = {
        ...(0, $j9AxR.kitCopy)(locale).walkIn,
        ...labels
    };
    const lead = suggested && !checked && !disabled;
    const ink = checked ? (0, $jTCZr.CT).warnInk : lead ? (0, $jTCZr.C).navy : (0, $jTCZr.C).textPrimary;
    const border = checked ? (0, $jTCZr.CT).warnInk : lead ? (0, $jTCZr.C).navy : (0, $jTCZr.C).border;
    const bg = checked ? (0, $jTCZr.CT).warnSoft : lead ? (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.07) : (0, $jTCZr.CT).surface;
    const track = {
        w: compact ? 34 : 40,
        h: compact ? 20 : 22
    };
    const knob = track.h - 6;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 8,
            ...style
        }
    }, separated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        "data-testid": `${testId}-or`,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            fontSize: '0.71875rem',
            color: (0, $jTCZr.C).textMuted
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            height: 1,
            background: (0, $jTCZr.C).border
        }
    }), copy.or, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            height: 1,
            background: (0, $jTCZr.C).border
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        role: "switch",
        "aria-checked": checked,
        disabled: disabled,
        onClick: ()=>onChange?.(!checked),
        "data-testid": testId,
        "data-suggested": lead ? 'true' : undefined,
        style: {
            position: 'relative',
            width: '100%',
            minHeight: compact ? 44 : 56,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: compact ? 10 : 12,
            padding: compact ? '6px 12px' : '10px 14px',
            borderRadius: 10,
            border: `1.5px solid ${border}`,
            background: bg,
            cursor: disabled ? 'not-allowed' : 'pointer',
            fontFamily: 'inherit',
            textAlign: 'start',
            transition: 'background .14s, border-color .14s'
        }
    }, lead && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": `${testId}-badge`,
        style: {
            position: 'absolute',
            top: -9,
            insetInlineEnd: 10,
            padding: '0 8px',
            borderRadius: 999,
            fontSize: '0.65625rem',
            fontWeight: 800,
            lineHeight: '17px',
            color: (0, $jTCZr.C).navy,
            background: (0, $jTCZr.CT).surface,
            border: `1px solid ${(0, $jTCZr.C).navy}`
        }
    }, copy.suggested), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            minWidth: 0,
            opacity: disabled ? 0.55 : 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: compact ? '0.8125rem' : '0.84375rem',
            fontWeight: 700,
            color: ink
        }
    }, title), hint && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": `${testId}-hint`,
        style: {
            fontSize: compact ? '0.6875rem' : '0.71875rem',
            lineHeight: 1.55,
            fontWeight: 500,
            color: checked ? (0, $jTCZr.CT).warnInk : (0, $jTCZr.C).textSecondary
        }
    }, hint)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true,
        style: {
            position: 'relative',
            flexShrink: 0,
            width: track.w,
            height: track.h,
            borderRadius: 999,
            background: checked ? (0, $jTCZr.CT).warnInk : '#d1d5db',
            opacity: disabled ? 0.5 : 1,
            transition: 'background .14s'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            position: 'absolute',
            top: 3,
            width: knob,
            height: knob,
            borderRadius: '50%',
            background: '#fff',
            boxShadow: '0 1px 3px rgba(0,0,0,0.25)',
            insetInlineStart: checked ? track.w - knob - 3 : 3,
            transition: 'inset-inline-start .14s'
        }
    }))));
}

});

parcelRegister("iuHQQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5943a0a75dff01a1$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $aJ1FU = parcelRequire("aJ1FU");

var $j9AxR = parcelRequire("j9AxR");
'use client';
function $5943a0a75dff01a1$export$2e2bcd8739ae039({ items: items = [], active: active, onSelect: onSelect, heightVar: heightVar = '--app-bottom-nav', className: className, 'data-testid': testId = 'bottom-nav', ...rest }) {
    const barRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // Publish the real height while this bar is mounted, and clear it when it is
    // not — the bar is absent on full-screen flows, and a stale value there would
    // push floating chrome up over nothing.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const el = barRef.current;
        if (!el || !heightVar || typeof document === 'undefined') return undefined;
        const root = document.documentElement;
        const publish = ()=>root.style.setProperty(heightVar, `${Math.round(el.offsetHeight)}px`);
        publish();
        // ResizeObserver is absent in jsdom and in older webviews; the one-shot
        // measurement above is already right for them, since what it would catch
        // (a rotation changing the inset, a text-size change) is rare and
        // self-correcting on the next navigation.
        const ro = typeof ResizeObserver === 'function' ? new ResizeObserver(publish) : null;
        if (ro) ro.observe(el);
        return ()=>{
            if (ro) ro.disconnect();
            root.style.removeProperty(heightVar);
        };
    }, [
        heightVar,
        items.length
    ]);
    if (!items.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("nav", {
        ref: barRef,
        className: className,
        "data-testid": testId,
        "aria-label": (0, $j9AxR.kitCopy)().bottomNav.label,
        style: {
            flexShrink: 0,
            background: (0, $jTCZr.C).card,
            borderTop: `1px solid ${(0, $jTCZr.C).border}`,
            display: 'flex',
            alignItems: 'stretch',
            justifyContent: 'space-around',
            paddingInline: '0.5rem',
            paddingTop: 0,
            // `max(…)`, not the bare inset: in a browser tab the inset is 0 because
            // the browser's own toolbar occupies that strip, which left the labels
            // sitting on the very edge of the window. The floor gives them the same
            // breathing room the home indicator provides in standalone mode.
            paddingBottom: 'max(env(safe-area-inset-bottom, 0px), 0.25rem)',
            position: 'relative',
            zIndex: 50
        },
        ...rest
    }, items.map((item)=>{
        const isActive = item.key === active;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            key: item.key,
            variant: "ghost",
            onClick: ()=>onSelect?.(item.key, item),
            "aria-current": isActive ? 'page' : undefined,
            "data-testid": `${testId}-${item.key}`,
            className: "h-auto min-h-11 flex-1 flex-col gap-1 rounded-none py-2 font-medium",
            style: {
                color: isActive ? (0, $jTCZr.C).navy : (0, $jTCZr.C).textMuted
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                position: 'relative',
                display: 'inline-flex'
            }
        }, item.icon, item.badge != null && item.badge !== 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "data-testid": `${testId}-${item.key}-badge`,
            // The count is decoration to the eye and information to a
            // screen reader; without a label it is read as a bare digit
            // beside the destination's name. The caller supplies the
            // sentence because only it knows what is being counted.
            "aria-label": item.badgeLabel,
            style: {
                position: 'absolute',
                top: '-0.25rem',
                insetInlineEnd: '-0.375rem',
                minWidth: '1rem',
                height: '1rem',
                paddingInline: '0.25rem',
                borderRadius: '0.5rem',
                // Tone is the caller's to choose, and the default is NOT the
                // safe one. Red carries "something is wrong"; an unread count
                // is not wrong, it is waiting — the colour budget reserves red
                // for destructive meaning, so a count uses `badgeTone="count"`.
                // ('accent' is the original spelling and still resolves here;
                // it drew navy from the start, and navy is the swatch the
                // whole unread family now agrees on.)
                // The default stays red only because it is what shipped, and
                // changing it silently would restyle callers that meant alarm.
                background: item.badgeTone === 'count' || item.badgeTone === 'accent' ? (0, $jTCZr.C).navy : (0, $jTCZr.C).red,
                color: '#fff',
                fontSize: '0.625rem',
                fontWeight: 700,
                lineHeight: '1rem',
                textAlign: 'center'
            }
        }, item.badge)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.625rem',
                fontWeight: isActive ? 700 : 500
            }
        }, item.label));
    }));
}

});

parcelRegister("9y25V", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea4bc4a14affb445$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
'use client';
function $ea4bc4a14affb445$export$2e2bcd8739ae039({ tiles: tiles = [], loading: loading = false, columns: columns = 4, className: className, 'data-testid': testId = 'stat-tiles', ...rest }) {
    if (!tiles.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        "data-testid": testId,
        "data-state": loading ? 'loading' : 'content',
        style: {
            display: 'grid',
            // minmax(0, 1fr) rather than 1fr: a grid track's default `min-width:auto`
            // is its content's minimum, so one long value would push the row past
            // 320px and take the whole page into horizontal scroll (§9).
            gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
            gap: '0.5rem'
        },
        ...rest
    }, tiles.map(({ key: key, label: label, value: value, icon: icon, color: color, solid: solid })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: key ?? label,
            "data-testid": `${testId}-${key ?? label}`,
            style: {
                background: solid ? (0, $jTCZr.C).navy : (0, $jTCZr.C).card,
                borderRadius: '0.875rem',
                padding: '0.625rem 0.25rem',
                textAlign: 'center',
                boxShadow: solid ? `0 4px 16px ${(0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.35)}` : '0 1px 4px rgba(0,0,0,0.06)',
                border: `1px solid ${solid ? 'transparent' : (0, $jTCZr.C).border}`,
                minWidth: 0
            }
        }, icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "aria-hidden": true,
            style: {
                display: 'flex',
                justifyContent: 'center',
                marginBottom: '0.1875rem',
                color: solid ? '#fff' : color || (0, $jTCZr.C).textMuted
            }
        }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '1.0625rem',
                fontWeight: 800,
                color: solid ? '#fff' : color || (0, $jTCZr.C).textPrimary,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            }
        }, loading || value == null || value === '' ? "\u2014" : value), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.59375rem',
                color: solid ? 'rgba(255,255,255,0.7)' : (0, $jTCZr.C).textMuted,
                marginTop: '0.125rem',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            }
        }, label))));
}

});

parcelRegister("fHxBh", function(module, exports) {

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $7wZCE = parcelRequire("7wZCE");

var $bfs4Q = parcelRequire("bfs4Q");

var $cZOyb = parcelRequire("cZOyb");

var $j9AxR = parcelRequire("j9AxR");
'use client';
// ─────────────────────────────────────────────────────────────────────────────
// AccountCard — the block at the foot of the sidebar.
//
// ONE component for the doctor, clinic, dentist and patient panels, each of
// which had hand-rolled its own version: three copies of the پارسه balance card
// that already disagreed about their hex values, and four different answers to
// «چطور از حسابم خارج شوم؟».
//
// ── TWO ZONES, ONE COMPONENT ────────────────────────────────────────────────
// The balance on top, the identity below it, separated by the hairline that was
// already there. Not one merged row: the balance is a number read at a glance
// many times an hour, the identity is a control pressed rarely. The doctor and
// clinic panels independently arrived at this same stacking; this makes it the
// rule rather than a coincidence.
//
// ── THE IDENTITY ROW IS THE MENU TRIGGER ────────────────────────────────────
// The two loose 16px glyphs are gone. A sign-out icon sat one pixel from an
// external-link icon, both unlabelled, and the only thing distinguishing «رفتن
// به حساب» from «خروج» was the shape of a 16px arrow. Now the whole row opens a
// menu whose every destination is named in words.
//
// ── ONE BALANCE: THE SIGNED-IN PERSON'S OWN ─────────────────────────────────
// In the clinic panel there are two pots of money — the clinic's shared pool
// that reception AI spends, and the person's own wallet. This card shows ONLY
// the person's. They are never summed and never offset, and a block labelled
// «حساب من» must not be able to show money that belongs to the clinic. Omit
// `credit` entirely (a receptionist owns no wallet; patients hold no پارسه at
// all) and the zone is not rendered — there is then no number here to be wrong
// about.
//
// ── THE APP FORMATS THE DIGITS ──────────────────────────────────────────────
// `credit.amount` is a STRING the app already localised — Persian digits in fa,
// Latin in en. Same seam as `BottomNav`'s badge: the digit boundary belongs to
// the app, which knows its locale; the kit does not. `credit.level` likewise
// comes from `creditLevel()` in @parsina/framework/tokens, so all four panels
// agree on what «کم» means.
//
// ── SURVIVING THE 68px RAIL ─────────────────────────────────────────────────
// Coin tile and avatar sit in fixed-width cells FIRST in DOM order, so under RTL
// they are rightmost and the collapse — which clips from the inline-end — takes
// only the fading text. Both zones stay operable collapsed, and the menu still
// opens (it is portaled, so the sidebar's `overflow: hidden` cannot slice it).
// Nothing focusable is left painted at zero opacity: the top-up button is not
// rendered at all when collapsed, rather than faded into an invisible tab stop.
//
// Props:
//   user       {name, subtitle?, avatarUrl?}                       — required
//   credit     {amount, level, unit, label, levelLabel, onClick?}  — omit to hide the zone
//   onTopUp    ()=>void  — shows «شارژ اعتبار», expanded + level 'low' only
//   topUpLabel string
//   items      MenuItem[] — {key, label, description?, icon?, href?, external?,
//                            onClick?, tone?, separatorBefore?, 'data-testid'?}
//   collapsed  boolean    — the 68px rail
//   overlay    'auto' | 'menu' | 'sheet'  — auto switches at 768px (DESIGN.md §6:
//              a BottomSheet is the default overlay for a task on mobile; a 236px
//              popover anchored to the bottom edge of a phone is not)
//   menuLabel  string     — accessible name; required, because the trigger's own
//                           visible text is a person's name
// ─────────────────────────────────────────────────────────────────────────────
const $a13c7c62f369d090$var$MINI = 68; // the collapsed rail, and so the width of every icon cell
const $a13c7c62f369d090$var$INSET = 10; // the card's inset from the sidebar edges
const $a13c7c62f369d090$var$NARROW_QUERY = '(max-width: 768px)';
function $a13c7c62f369d090$var$useNarrow(enabled) {
    const [narrow, setNarrow] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!enabled || typeof window === 'undefined' || !window.matchMedia) return undefined;
        const mq = window.matchMedia($a13c7c62f369d090$var$NARROW_QUERY);
        const sync = ()=>setNarrow(mq.matches);
        sync();
        // `addListener` is the Safari < 14 spelling; both are cheap to support and
        // the patient app is the one that actually meets phones.
        if (mq.addEventListener) mq.addEventListener('change', sync);
        else mq.addListener(sync);
        return ()=>{
            if (mq.removeEventListener) mq.removeEventListener('change', sync);
            else mq.removeListener(sync);
        };
    }, [
        enabled
    ]);
    return narrow;
}
const $a13c7c62f369d090$var$CoinGlyph = ({ size: size = 16 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        width: size,
        height: size,
        "aria-hidden": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "12",
        cy: "12",
        r: "8.5",
        stroke: "currentColor",
        strokeWidth: "1.8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M12 7.5v9M9.5 10h5M9.5 14h5",
        stroke: "currentColor",
        strokeWidth: "1.8",
        strokeLinecap: "round"
    }));
// Says the press LEAVES this panel. Without it a row that navigates to حساب
// پارسینا reads as a tab that never opens.
const $a13c7c62f369d090$var$ExternalGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        width: "13",
        height: "13",
        "aria-hidden": true,
        style: {
            flexShrink: 0,
            opacity: 0.55
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polyline", {
        points: "15 3 21 3 21 9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
        x1: "10",
        y1: "14",
        x2: "21",
        y2: "3"
    }));
// ── one menu row, in either presentation ────────────────────────────────────
function $a13c7c62f369d090$var$AccountMenuRow({ item: item, onDone: onDone, compact: compact, testIdBase: testIdBase }) {
    const destructive = item.tone === 'destructive';
    const ink = destructive ? (0, $jTCZr.C).red : (0, $jTCZr.C).textPrimary;
    const hover = destructive ? (0, $jTCZr.soft)((0, $jTCZr.C).red, 0.10) : (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.08);
    const style = {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        width: '100%',
        padding: compact ? '10px' : '13px 12px',
        minHeight: compact ? 40 : 48,
        border: 'none',
        borderRadius: 9,
        background: 'transparent',
        color: ink,
        textAlign: 'start',
        textDecoration: 'none',
        fontFamily: 'inherit',
        fontSize: '0.84375rem',
        fontWeight: 600,
        cursor: 'pointer',
        transition: 'background 0.14s'
    };
    const body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, item.icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flexShrink: 0,
            display: 'flex',
            color: destructive ? (0, $jTCZr.C).red : (0, $jTCZr.C).navy
        },
        "aria-hidden": true
    }, item.icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'block',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    }, item.label), item.description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            display: 'block',
            fontSize: '0.6875rem',
            fontWeight: 500,
            marginTop: 1,
            color: (0, $jTCZr.C).textMuted,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    }, item.description)), item.external && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a13c7c62f369d090$var$ExternalGlyph, null));
    const shared = {
        role: 'menuitem',
        'data-testid': item['data-testid'] || `${testIdBase}-item-${item.key}`,
        style: style,
        onMouseEnter: (e)=>{
            e.currentTarget.style.background = hover;
        },
        onMouseLeave: (e)=>{
            e.currentTarget.style.background = 'transparent';
        }
    };
    // A real <a> when the destination is a URL: it must be focusable, openable in
    // a new tab with the usual modifiers, and readable in the status bar.
    return item.href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
        ...shared,
        href: item.href,
        target: item.target,
        rel: item.target === '_blank' ? 'noopener noreferrer' : undefined,
        onClick: ()=>onDone?.()
    }, body) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        ...shared,
        type: "button",
        onClick: ()=>{
            onDone?.();
            item.onClick?.();
        }
    }, body);
}
// ── the balance, in either presentation ─────────────────────────────────────
// A real <a> when `credit.href` is given — the clinic panel's balance points at
// حساب پارسینا, and a link there must be middle-clickable and readable in the
// status bar rather than a button that happens to navigate. A <button> when the
// destination is inside this SPA, so it does not reload the app.
function $a13c7c62f369d090$var$CreditZone({ credit: credit, levelColor: levelColor, isLow: isLow, collapsed: collapsed, fade: fade, testId: testId }) {
    const bg = (hovered)=>isLow ? (0, $jTCZr.soft)((0, $jTCZr.C).red, hovered ? 0.24 : 0.16) : `rgba(255,255,255,${hovered ? 0.12 : 0.06})`;
    const props = {
        'data-testid': `${testId}-credit`,
        onClick: credit.onClick,
        title: collapsed ? `${credit.label} \u{2014} ${credit.amount} ${credit.unit}` : undefined,
        'aria-label': `${credit.label} \u{2014} ${credit.amount} ${credit.unit}`,
        style: {
            width: `calc(100% - ${$a13c7c62f369d090$var$INSET * 2}px)`,
            margin: `0 ${$a13c7c62f369d090$var$INSET}px`,
            display: 'flex',
            alignItems: 'center',
            borderRadius: 12,
            padding: 0,
            background: bg(false),
            border: `1px solid ${isLow ? (0, $jTCZr.soft)((0, $jTCZr.C).red, 0.4) : 'rgba(255,255,255,0.08)'}`,
            cursor: credit.href || credit.onClick ? 'pointer' : 'default',
            fontFamily: 'inherit',
            textAlign: 'start',
            textDecoration: 'none',
            color: 'inherit',
            transition: 'background 0.18s'
        },
        onMouseEnter: (e)=>{
            e.currentTarget.style.background = bg(true);
        },
        onMouseLeave: (e)=>{
            e.currentTarget.style.background = bg(false);
        }
    };
    const body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: $a13c7c62f369d090$var$MINI - $a13c7c62f369d090$var$INSET * 2,
            flexShrink: 0,
            display: 'flex',
            justifyContent: 'center',
            padding: '9px 0'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: 30,
            height: 30,
            borderRadius: 9,
            flexShrink: 0,
            background: (0, $jTCZr.soft)(levelColor, 0.22),
            color: levelColor,
            display: 'grid',
            placeItems: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a13c7c62f369d090$var$CoinGlyph, {
        size: 16
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            ...fade,
            flex: 1,
            minWidth: 0,
            paddingInlineEnd: $a13c7c62f369d090$var$INSET
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'block',
            fontSize: '0.65625rem',
            fontWeight: 600,
            color: 'rgba(255,255,255,0.5)',
            whiteSpace: 'nowrap'
        }
    }, credit.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 5,
            marginTop: 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.9375rem',
            fontWeight: 800,
            color: '#fff',
            whiteSpace: 'nowrap'
        }
    }, credit.amount), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.6875rem',
            color: 'rgba(255,255,255,0.5)'
        }
    }, credit.unit), credit.levelLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 4,
            marginInlineStart: 'auto',
            whiteSpace: 'nowrap'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: 6,
            height: 6,
            borderRadius: '50%',
            background: levelColor
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.65625rem',
            fontWeight: 700,
            color: 'rgba(255,255,255,0.6)'
        }
    }, credit.levelLabel)))));
    return credit.href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
        ...props,
        href: credit.href,
        target: credit.target,
        rel: credit.target === '_blank' ? 'noopener noreferrer' : undefined
    }, body) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        ...props,
        type: "button"
    }, body);
}
function $a13c7c62f369d090$export$2e2bcd8739ae039({ user: user, credit: credit = null, onTopUp: onTopUp, topUpLabel: topUpLabel, items: items = [], collapsed: collapsed = false, overlay: overlay = 'auto', menuLabel: menuLabel, 'data-testid': testId = 'account-card' }) {
    if (topUpLabel === undefined) topUpLabel = (0, $j9AxR.kitCopy)().account.topUp;
    if (menuLabel === undefined) menuLabel = (0, $j9AxR.kitCopy)().account.menu;
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const triggerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const narrow = $a13c7c62f369d090$var$useNarrow(overlay === 'auto');
    const asSheet = overlay === 'sheet' || overlay === 'auto' && narrow;
    // Collapsing must not leave the menu floating beside a rail that just changed
    // width — the anchor moves 192px under a CSS transition.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setOpen(false);
    }, [
        collapsed
    ]);
    const rows = items.filter(Boolean);
    const close = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>setOpen(false), []);
    const fade = {
        opacity: collapsed ? 0 : 1,
        pointerEvents: collapsed ? 'none' : 'auto',
        transition: 'opacity 0.16s ease'
    };
    const level = credit?.level || 'ok';
    const levelColor = (0, $jTCZr.CREDIT_LEVEL_META)[level]?.color || (0, $jTCZr.C).teal;
    const isLow = level === 'low';
    const rendered = rows.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
            key: item.key
        }, item.separatorBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            role: "separator",
            style: {
                height: 1,
                background: (0, $jTCZr.C).border,
                margin: '5px 8px'
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a13c7c62f369d090$var$AccountMenuRow, {
            item: item,
            onDone: close,
            compact: !asSheet,
            testIdBase: testId
        })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId,
        style: {
            flexShrink: 0,
            position: 'relative'
        }
    }, credit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '6px 0 2px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a13c7c62f369d090$var$CreditZone, {
        credit: credit,
        levelColor: levelColor,
        isLow: isLow,
        collapsed: collapsed,
        fade: fade,
        testId: testId
    }), onTopUp && isLow && !collapsed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        "data-testid": `${testId}-topup`,
        onClick: onTopUp,
        style: {
            width: `calc(100% - ${$a13c7c62f369d090$var$INSET * 2}px)`,
            margin: `6px ${$a13c7c62f369d090$var$INSET}px 0`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 5,
            background: (0, $jTCZr.C).teal,
            border: 'none',
            borderRadius: 10,
            padding: '7px 0',
            color: '#fff',
            cursor: 'pointer',
            fontFamily: 'inherit',
            fontSize: '0.75rem',
            fontWeight: 800
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a13c7c62f369d090$var$CoinGlyph, {
        size: 13
    }), " ", topUpLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        ref: triggerRef,
        type: "button",
        "data-testid": `${testId}-trigger`,
        onClick: ()=>setOpen((v)=>!v),
        "aria-haspopup": "menu",
        "aria-expanded": open,
        "aria-label": `${menuLabel} \u{2014} ${user?.name || ''}`,
        title: collapsed ? `${menuLabel} \u{2014} ${user?.name || ''}` : undefined,
        style: {
            width: '100%',
            marginTop: credit ? 10 : 0,
            display: 'flex',
            alignItems: 'center',
            padding: '12px 0',
            border: 'none',
            borderTop: '1px solid rgba(255,255,255,0.07)',
            background: open ? 'rgba(255,255,255,0.09)' : 'transparent',
            cursor: 'pointer',
            fontFamily: 'inherit',
            textAlign: 'start',
            overflow: 'hidden',
            transition: 'background 0.16s'
        },
        onMouseEnter: (e)=>{
            if (!open) e.currentTarget.style.background = 'rgba(255,255,255,0.06)';
        },
        onMouseLeave: (e)=>{
            if (!open) e.currentTarget.style.background = 'transparent';
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: $a13c7c62f369d090$var$MINI,
            flexShrink: 0,
            display: 'flex',
            justifyContent: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7wZCE.default), {
        name: user?.name || '',
        size: 36,
        bg: (0, $jTCZr.C).navy,
        src: user?.avatarUrl || undefined
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            ...fade,
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            flex: 1,
            minWidth: 0,
            paddingInlineEnd: 12
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            display: 'block',
            color: '#fff',
            fontSize: '0.8125rem',
            fontWeight: 700,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    }, user?.name || "\u2014"), user?.subtitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            display: 'block',
            color: 'rgba(255,255,255,0.42)',
            fontSize: '0.6875rem',
            marginTop: 2,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    }, user.subtitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2.4",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        width: "15",
        height: "15",
        "aria-hidden": true,
        style: {
            flexShrink: 0,
            color: open ? '#fff' : 'rgba(255,255,255,0.45)',
            transform: open ? 'rotate(180deg)' : 'none',
            transition: 'transform 0.18s, color 0.18s'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polyline", {
        points: "18 15 12 9 6 15"
    })))), asSheet ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: open,
        onClose: close,
        title: menuLabel,
        "data-testid": `${testId}-sheet`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "menu",
        "aria-label": menuLabel,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 2
        }
    }, rendered)) : // 'top': this card is the LAST thing in the sidebar, so a menu opening
    // downward would render off the bottom of the viewport.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bfs4Q.default), {
        open: open,
        onClose: close,
        anchorRef: triggerRef,
        ariaLabel: menuLabel,
        placement: "top",
        width: 236,
        "data-testid": `${testId}-menu`
    }, rendered));
}

});

parcelRegister("fh5c7", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd795e2724b3b1d0$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $aJ1FU = parcelRequire("aJ1FU");
'use client';
function $dd795e2724b3b1d0$export$2e2bcd8739ae039({ items: items = [], active: active, onSelect: onSelect, ariaLabel: ariaLabel, className: className, 'data-testid': testId = 'section-nav', ...rest }) {
    const activeRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // Keep the selected section in view: a strip long enough to scroll can put
    // the active item off-screen (or half-clipped at an edge) after a tap, a
    // route restore, or a rotation.
    //
    // Feature-detected, not assumed: `scrollIntoView` does not exist in jsdom and
    // is missing from some old webviews, and an unguarded call there throws from
    // inside an effect — which unmounts the whole record rather than merely
    // failing to centre a tab. Centring is a convenience; rendering is not.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const el = activeRef.current;
        if (typeof el?.scrollIntoView !== 'function') return;
        el.scrollIntoView({
            inline: 'center',
            block: 'nearest',
            behavior: 'smooth'
        });
    }, [
        active
    ]);
    if (!items.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        "data-testid": testId,
        role: "tablist",
        "aria-label": ariaLabel,
        style: {
            background: (0, $jTCZr.C).card,
            borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
            flexShrink: 0,
            display: 'flex',
            overflowX: 'auto',
            scrollbarWidth: 'none',
            padding: '0 0.25rem'
        },
        ...rest
    }, items.map(({ key: key, label: label, icon: icon })=>{
        const on = key === active;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            key: key,
            ref: on ? activeRef : undefined,
            variant: "ghost",
            role: "tab",
            "aria-selected": on,
            "data-testid": `${testId}-${key}`,
            onClick: ()=>onSelect?.(key, {
                    key: key,
                    label: label,
                    icon: icon
                }),
            className: "h-auto min-h-11 shrink-0 flex-col gap-0.5 rounded-none px-3.5 py-2 hover:bg-transparent",
            style: {
                color: on ? (0, $jTCZr.C).navy : (0, $jTCZr.C).textMuted,
                fontWeight: on ? 700 : 500,
                borderBottom: on ? `2.5px solid ${(0, $jTCZr.C).navy}` : '2.5px solid transparent'
            }
        }, icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "aria-hidden": true,
            style: {
                display: 'inline-flex'
            }
        }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.6875rem'
            }
        }, label));
    }));
}

});

parcelRegister("gehDE", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0ac3bcac665682a$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $6Md3F = parcelRequire("6Md3F");
var $kzPvP = parcelRequire("kzPvP");

var $aJ1FU = parcelRequire("aJ1FU");

var $cZOyb = parcelRequire("cZOyb");

var $4Qco3 = parcelRequire("4Qco3");
'use client';
/**
 * DateNavigator — the mobile day stepper (DESIGN-CONCEPT-MOBILE §4): prev/next
 * arrows around a TAPPABLE day label that opens the kit `JalaliCalendar` in a
 * `BottomSheet`. It is the mobile counterpart of the desktop header's
 * `JalaliDatePicker`, and it exists because §4 says arrow-stepping must never
 * be the ONLY path to a date — a doctor looking at next Tuesday should not
 * press an arrow five times.
 *
 * `variant="onGradient"` is the §3.2 "white-alpha inset card": the context
 * widget that lives INSIDE `MobileHeader`'s gradient.
 *
 * Every label is a prop and none is defaulted to Persian. The kit has no
 * translator, the calendar formatting stays with the app (the same rule
 * `TimeRuler.formatTick` and `ChatDayDivider.label` follow), and this component
 * is used by an app that ships in two languages.
 *
 * Props:
 *   value / onChange  — Gregorian 'YYYY-MM-DD', like every kit date component
 *   dateLabel         — the day, formatted by the caller (Jalaali under fa)
 *   subLabel          — optional second line, shown only when `isToday`
 *   isToday           — drives the «back to today» affordance
 *   onPrev / onNext / onToday
 *   prevLabel / nextLabel / pickLabel / todayLabel / sheetTitle — all required
 *                       in practice; they are this component's whole copy
 *   variant           — 'onGradient' (default) | 'plain'
 *   className / data-testid — forwarded to the root
 */ const $e0ac3bcac665682a$var$PREV_GLYPH = {
    transform: 'scaleX(var(--dir-flip, 1))'
};
const $e0ac3bcac665682a$var$NEXT_GLYPH = {
    transform: 'scaleX(calc(var(--dir-flip, 1) * -1))'
};
function $e0ac3bcac665682a$export$2e2bcd8739ae039({ value: value, onChange: onChange, dateLabel: dateLabel, subLabel: subLabel, isToday: isToday = true, onPrev: onPrev, onNext: onNext, onToday: onToday, prevLabel: prevLabel, nextLabel: nextLabel, pickLabel: pickLabel, todayLabel: todayLabel, sheetTitle: sheetTitle, closeLabel: closeLabel, variant: variant = 'onGradient', className: className, 'data-testid': testId = 'date-navigator', ...rest }) {
    const [pickerOpen, setPickerOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const onGradient = variant === 'onGradient';
    const arrowClass = onGradient ? 'min-w-11 min-h-11 text-white hover:bg-white/25' : 'min-w-11 min-h-11';
    const arrowStyle = onGradient ? {
        background: 'rgba(255,255,255,0.12)',
        borderRadius: '0.5rem'
    } : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        "data-testid": testId,
        style: {
            background: onGradient ? 'rgba(255,255,255,0.12)' : 'transparent',
            borderRadius: '0.75rem',
            padding: '0.375rem 0.5rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '0.375rem'
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "icon",
        "data-testid": `${testId}-prev`,
        "aria-label": prevLabel,
        title: prevLabel,
        className: arrowClass,
        style: arrowStyle,
        onClick: onPrev
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kzPvP.default), {
        size: 18,
        "aria-hidden": true,
        style: $e0ac3bcac665682a$var$PREV_GLYPH
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            textAlign: 'center',
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        "data-testid": `${testId}-pick`,
        "aria-label": pickLabel,
        className: onGradient ? 'h-auto min-h-11 gap-1.5 px-2 py-0 text-[0.84375rem] font-bold text-white hover:bg-white/15' : 'h-auto min-h-11 gap-1.5 px-2 py-0 text-[0.84375rem] font-bold',
        onClick: ()=>setPickerOpen(true)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6Md3F.default), {
        size: 14,
        style: {
            opacity: 0.7
        },
        "aria-hidden": true
    }), dateLabel), isToday ? subLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: onGradient ? 'rgba(255,255,255,0.6)' : undefined,
            fontSize: '0.6875rem'
        }
    }, subLabel) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        "data-testid": `${testId}-today`,
        className: onGradient ? 'mx-auto block h-auto min-h-0 p-0 text-[0.65625rem] font-semibold text-white/85 hover:bg-transparent hover:text-white' : 'mx-auto block h-auto min-h-0 p-0 text-[0.65625rem] font-semibold',
        onClick: onToday
    }, todayLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "icon",
        "data-testid": `${testId}-next`,
        "aria-label": nextLabel,
        title: nextLabel,
        className: arrowClass,
        style: arrowStyle,
        onClick: onNext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kzPvP.default), {
        size: 18,
        "aria-hidden": true,
        style: $e0ac3bcac665682a$var$NEXT_GLYPH
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: pickerOpen,
        onClose: ()=>setPickerOpen(false),
        title: sheetTitle || pickLabel,
        closeLabel: closeLabel,
        "data-testid": `${testId}-sheet`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4Qco3.JalaliCalendar), {
        value: value,
        onChange: (v)=>{
            setPickerOpen(false);
            if (v) onChange?.(v);
        }
    }), !isToday && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        className: "mt-3 w-full min-h-11",
        "data-testid": `${testId}-sheet-today`,
        onClick: ()=>{
            setPickerOpen(false);
            onToday?.();
        }
    }, todayLabel)));
}

});

parcelRegister("jbdF9", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1c3a031457b1019$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $huNwV = parcelRequire("huNwV");

var $jTCZr = parcelRequire("jTCZr");

var $aJ1FU = parcelRequire("aJ1FU");

var $hZDga = parcelRequire("hZDga");

var $j9AxR = parcelRequire("j9AxR");
'use client';
function $a1c3a031457b1019$export$2e2bcd8739ae039({ onSave: onSave, onCancel: onCancel, saving: saving = false, saved: saved = false, disabled: disabled = false, sticky: sticky = false, saveLabel: saveLabel, cancelLabel: cancelLabel, savedLabel: savedLabel, className: className, style: // Merged OVER the computed layout, the `Card`/messaging-family precedent
// (DESIGN.md). It used to arrive through `...rest`, which is spread after
// `style` — so a caller adding one padding value silently deleted `display`,
// `position` and the safe-area inset and took the whole bar's layout with it.
style, 'data-testid': testId = 'savebar', ...rest }) {
    const copy = (0, $j9AxR.kitCopy)().saveBar;
    if (saveLabel === undefined) saveLabel = copy.save;
    if (cancelLabel === undefined) cancelLabel = copy.cancel;
    if (savedLabel === undefined) savedLabel = copy.saved;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        "data-testid": testId,
        "data-state": saving ? 'saving' : saved ? 'saved' : 'idle',
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            marginTop: '1.75rem',
            ...sticky && {
                position: 'sticky',
                bottom: 0,
                marginTop: '1rem',
                background: (0, $jTCZr.C).card,
                borderTop: `1px solid ${(0, $jTCZr.C).border}`,
                padding: '0.75rem 0 calc(0.75rem + env(safe-area-inset-bottom, 0px))',
                zIndex: 5
            },
            ...style
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        onClick: onSave,
        disabled: saving || disabled,
        "data-testid": `${testId}-submit`
    }, saving && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 16,
        thickness: 2,
        color: "currentColor"
    }), saved && !saving && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
        size: 16,
        "aria-hidden": true
    }), saved && !saving ? savedLabel : saveLabel), onCancel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        onClick: onCancel,
        disabled: saving,
        "data-testid": `${testId}-cancel`
    }, cancelLabel));
}

});

parcelRegister("eJIXW", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f9cbffc25828c55$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
'use client';
function $5f9cbffc25828c55$export$2e2bcd8739ae039({ n: n, title: title, sub: sub, icon: Icon, children: children, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
        ...rest,
        style: {
            background: '#fff',
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: 18,
            boxShadow: '0 1px 2px rgba(22,39,61,.04), 0 8px 24px rgba(22,39,61,.05)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("header", {
        style: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: 13,
            padding: '18px 22px 0'
        }
    }, n != null && n !== '' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flexShrink: 0,
            width: 30,
            height: 30,
            borderRadius: '50%',
            background: (0, $jTCZr.C).navy,
            color: '#fff',
            fontWeight: 800,
            fontSize: '0.875rem',
            display: 'grid',
            placeItems: 'center'
        }
    }, n), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            fontSize: '1rem',
            fontWeight: 800,
            color: (0, $jTCZr.C).textPrimary
        }
    }, Icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        size: 17,
        color: (0, $jTCZr.C).teal
    }), title), sub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.78125rem',
            color: (0, $jTCZr.C).textMuted,
            marginTop: 3
        }
    }, sub))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '18px 22px 22px',
            display: 'flex',
            flexDirection: 'column',
            gap: 16
        }
    }, children));
}

});

parcelRegister("jFCWB", function(module, exports) {

$parcel$export(module.exports, "default", () => $82e7212e133be19c$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $2WFPf = parcelRequire("2WFPf");
var $azOWV = parcelRequire("azOWV");

var $jTCZr = parcelRequire("jTCZr");

var $66joL = parcelRequire("66joL");
'use client';
function $82e7212e133be19c$export$2e2bcd8739ae039({ columns: columns = [], rows: rows = [], rowKey: rowKey, onRowClick: onRowClick, onRowActivate: onRowActivate, rowProps: rowProps, empty: empty, loading: loading = false, skeletonRows: skeletonRows = 6, dense: dense = false, ariaLabel: ariaLabel, caption: caption, sort: sort, onSort: onSort, ...rest }) {
    const rowH = dense ? 44 : 52;
    // Logical, not physical. `'end'` used to resolve to `left`, which is the end
    // of an RTL row and the START of an LTR one — so a numeric column aligned to
    // the wrong edge the moment a table rendered in English.
    const alignOf = (a)=>a === 'center' ? 'center' : a === 'end' ? 'end' : 'start';
    const isEmpty = !loading && rows.length === 0;
    // Placeholder block widths for the loading body, derived from the REAL
    // column widths so a cell's block sits where that column's content will.
    // Without this the blocks cycled a generic width list, and a 70px status
    // column drew a 120px block that the <th> then clipped — the one thing a
    // skeleton exists to avoid. A column with no declared width (the flexible
    // ones, usually the name) keeps the generic rhythm; a percentage width is
    // relative to a table whose pixel size we do not know here, so it falls
    // back too. 60% of the column, because a cell is content plus padding.
    const skeletonWidths = columns.map((col, i)=>{
        const w = col.width;
        const px = typeof w === 'number' ? w : typeof w === 'string' && /^\d+(\.\d+)?px$/.test(w) ? parseFloat(w) : null;
        if (px == null) return [
            120,
            96,
            110,
            84
        ][i % 4];
        return Math.max(32, Math.round(px * 0.6));
    });
    const activate = onRowActivate || null;
    const interactive = !!(activate || onRowClick);
    const headerCell = (col)=>{
        if (!col.sortable || !onSort) return col.header;
        const key = col.sortKey || col.key;
        const active = sort?.key === key;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            type: "button",
            onClick: ()=>onSort(key),
            className: "inline-flex items-center gap-1 bg-transparent border-0 p-0 cursor-pointer text-inherit hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded",
            style: {
                fontSize: 'inherit',
                fontWeight: 'inherit',
                fontFamily: 'inherit'
            },
            "data-active": active ? 'true' : undefined
        }, col.header, active ? sort.dir === 'asc' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $azOWV.default), {
            size: 13,
            "aria-hidden": true
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2WFPf.default), {
            size: 13,
            "aria-hidden": true
        }) : null);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...rest,
        "data-state": loading ? 'loading' : isEmpty ? 'empty' : 'content',
        "aria-busy": loading ? 'true' : undefined,
        style: {
            width: '100%'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: '100%',
            overflowX: 'auto'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("table", {
        "aria-label": caption ? undefined : ariaLabel,
        style: {
            width: '100%',
            borderCollapse: 'collapse',
            fontSize: '0.84375rem'
        }
    }, caption && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("caption", {
        style: {
            captionSide: 'top',
            textAlign: 'start',
            padding: '0 14px 8px',
            fontSize: '0.78125rem',
            color: (0, $jTCZr.C).textSecondary
        }
    }, caption), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", null, columns.map((col)=>{
        const key = col.sortKey || col.key;
        const active = sort?.key === key;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
            key: col.key,
            scope: "col",
            "aria-sort": !col.sortable || !onSort ? undefined : active ? sort.dir === 'asc' ? 'ascending' : 'descending' : 'none',
            style: {
                position: 'sticky',
                top: 0,
                zIndex: 1,
                background: (0, $jTCZr.C).bg,
                color: (0, $jTCZr.C).textSecondary,
                fontWeight: 700,
                fontSize: '0.78125rem',
                textAlign: alignOf(col.align),
                padding: '10px 14px',
                borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
                width: col.width,
                whiteSpace: 'nowrap'
            }
        }, headerCell(col));
    }))), loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tbody", null, Array.from({
        length: skeletonRows
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonRow), {
            key: i,
            cols: columns.length,
            widths: skeletonWidths,
            dense: dense
        }))), !loading && !isEmpty && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tbody", null, rows.map((row, i)=>{
        const extra = rowProps ? rowProps(row, i) || {} : {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", {
            key: rowKey ? rowKey(row, i) : row.id ?? i,
            onClick: interactive ? ()=>(activate || onRowClick)(row) : undefined,
            // Hover and focus are CSS states. The onMouseEnter/onMouseLeave
            // pair this replaces mutated inline styles — which §1.3 forbids,
            // and which left a row stuck highlighted whenever the pointer
            // left during a re-render.
            className: interactive ? 'transition-colors hover:bg-muted focus-visible:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring' : undefined,
            ...activate ? {
                tabIndex: 0,
                role: 'link',
                onKeyDown: (e)=>{
                    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
                        e.preventDefault();
                        activate(row);
                    }
                }
            } : null,
            ...extra,
            style: {
                height: rowH,
                cursor: interactive ? 'pointer' : 'default',
                ...extra.style
            }
        }, columns.map((col)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
                key: col.key,
                style: {
                    textAlign: alignOf(col.align),
                    padding: '8px 14px',
                    borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
                    color: (0, $jTCZr.C).textPrimary,
                    verticalAlign: 'middle'
                }
            }, col.render ? col.render(row, i) : row[col.key])));
    })))), isEmpty && empty ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, empty) : null);
}

});
parcelRegister("azOWV", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f8899ae39ae38a1$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $7f8899ae39ae38a1$export$a2387ed3b5d536eb = {
    name: "chevron-up",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m18 15-6-6-6 6",
                key: "153udz"
            }
        ]
    ]
};
$7f8899ae39ae38a1$export$a2387ed3b5d536eb.node;
const $7f8899ae39ae38a1$export$2e2bcd8739ae039 = (0, $9QBug.default)($7f8899ae39ae38a1$export$a2387ed3b5d536eb);

});


parcelRegister("fYgeo", function(module, exports) {

$parcel$export(module.exports, "default", () => $24dfcaee8d76ee07$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
'use client';
function $24dfcaee8d76ee07$export$2e2bcd8739ae039({ options: options = [], value: value, onChange: onChange, size: size = 'md', semantics: semantics = 'tabs', ariaLabel: ariaLabel, ...rest }) {
    const h = size === 'lg' ? 44 : size === 'sm' ? 32 : 36;
    const isFilter = semantics === 'filter';
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const move = (delta)=>{
        const enabled = options.filter((o)=>!o.disabled);
        if (!enabled.length) return;
        const at = enabled.findIndex((o)=>o.value === value);
        const next = enabled[(at + delta + enabled.length) % enabled.length];
        if (next) onChange?.(next.value);
    };
    const onKeyDown = (e)=>{
        if (![
            'ArrowLeft',
            'ArrowRight',
            'Home',
            'End'
        ].includes(e.key)) return;
        e.preventDefault();
        if (e.key === 'Home' || e.key === 'End') {
            const enabled = options.filter((o)=>!o.disabled);
            const target = e.key === 'Home' ? enabled[0] : enabled[enabled.length - 1];
            if (target) onChange?.(target.value);
            return;
        }
        // Direction from the DOM, not an assumption: the visual "next" option is on
        // the left in an RTL group and on the right in an LTR one.
        const rtl = ref.current ? getComputedStyle(ref.current).direction === 'rtl' : true;
        const forward = rtl ? e.key === 'ArrowLeft' : e.key === 'ArrowRight';
        move(forward ? 1 : -1);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...rest,
        ref: ref,
        role: isFilter ? 'radiogroup' : 'tablist',
        "aria-label": ariaLabel,
        onKeyDown: onKeyDown,
        style: {
            display: 'inline-flex',
            gap: 4,
            padding: 4,
            background: (0, $jTCZr.C).bg,
            borderRadius: 12,
            border: `1px solid ${(0, $jTCZr.C).border}`
        }
    }, options.map((opt)=>{
        const active = opt.value === value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: opt.value,
            type: "button",
            role: isFilter ? 'radio' : 'tab',
            ...isFilter ? {
                'aria-checked': active
            } : {
                'aria-selected': active
            },
            // Roving tabindex: the group is ONE tab stop and the arrows move
            // inside it. Without this every option is its own stop, so tabbing
            // past a six-option filter takes six presses.
            tabIndex: active ? 0 : -1,
            disabled: opt.disabled,
            "data-state": active ? 'active' : 'inactive',
            onClick: ()=>!opt.disabled && onChange?.(opt.value),
            className: "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1",
            style: {
                height: h,
                padding: size === 'sm' ? '0 12px' : '0 16px',
                border: 'none',
                cursor: opt.disabled ? 'not-allowed' : 'pointer',
                borderRadius: 9,
                fontSize: size === 'sm' ? '0.78125rem' : '0.84375rem',
                fontWeight: 700,
                fontFamily: 'inherit',
                background: active ? '#fff' : 'transparent',
                color: active ? (0, $jTCZr.C).navy : (0, $jTCZr.C).textSecondary,
                boxShadow: active ? '0 1px 3px rgba(22,39,61,.12)' : 'none',
                opacity: opt.disabled ? 0.5 : 1,
                transition: 'all .15s',
                whiteSpace: 'nowrap'
            }
        }, opt.label);
    }));
}

});

parcelRegister("hILSM", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bca3244df749c49$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $j9AxR = parcelRequire("j9AxR");

var $IZwml = parcelRequire("IZwml");
'use client';
// The page's own numerals — the digit set the date picker draws for `<html lang>`.
const $7bca3244df749c49$var$pageNum = (n)=>(0, $IZwml.withDigits)(String(Math.trunc(Number(n))), (0, $IZwml.datePickerLocale)().digits);
function $7bca3244df749c49$export$2e2bcd8739ae039({ page: page = 1, pageCount: pageCount, total: total, pageSize: pageSize = 20, onChange: onChange, prevLabel: prevLabel, nextLabel: nextLabel, pageLabel: pageLabel, formatNumber: formatNumber = $7bca3244df749c49$var$pageNum }) {
    const copy = (0, $j9AxR.kitCopy)().pager;
    if (prevLabel === undefined) prevLabel = copy.prev;
    if (nextLabel === undefined) nextLabel = copy.next;
    if (pageLabel === undefined) pageLabel = copy.page;
    const pages = pageCount ?? Math.max(1, Math.ceil((total || 0) / pageSize));
    if (pages <= 1) return null;
    const go = (p)=>{
        if (p >= 1 && p <= pages && p !== page) onChange?.(p);
    };
    const btn = (label, target, disabled)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            onClick: ()=>go(target),
            disabled: disabled,
            style: {
                minWidth: 34,
                height: 34,
                padding: '0 10px',
                borderRadius: 9,
                border: `1px solid ${(0, $jTCZr.C).border}`,
                background: '#fff',
                cursor: disabled ? 'default' : 'pointer',
                color: disabled ? (0, $jTCZr.C).textMuted : (0, $jTCZr.C).textPrimary,
                fontFamily: 'inherit',
                fontSize: '0.8125rem',
                opacity: disabled ? 0.5 : 1
            }
        }, label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 8,
            padding: '12px 0'
        }
    }, btn(prevLabel, page - 1, page <= 1), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-live": "polite",
        style: {
            fontSize: '0.8125rem',
            color: (0, $jTCZr.C).textSecondary,
            fontWeight: 600,
            padding: '0 6px'
        }
    }, pageLabel(formatNumber(page), formatNumber(pages))), btn(nextLabel, page + 1, page >= pages));
}

});

parcelRegister("cjPik", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab3d370aebf1b917$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $4fYdd = parcelRequire("4fYdd");

var $aJ1FU = parcelRequire("aJ1FU");

var $j9AxR = parcelRequire("j9AxR");
'use client';
function $ab3d370aebf1b917$export$2e2bcd8739ae039({ open: open, onOpenChange: onOpenChange, title: title, description: description, confirmLabel: confirmLabel, cancelLabel: cancelLabel, destructive: destructive = false, loading: loading = false, confirmDisabled: confirmDisabled = false, onConfirm: onConfirm, children: children, confirmTestId: confirmTestId, cancelTestId: cancelTestId, ...rest }) {
    const copy = (0, $j9AxR.kitCopy)().confirm;
    if (confirmLabel === undefined) confirmLabel = copy.confirm;
    if (cancelLabel === undefined) cancelLabel = copy.cancel;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.Dialog), {
        open: open,
        onOpenChange: onOpenChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogContent), {
        size: "sm",
        showClose: false,
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogTitle), null, title)), typeof description === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        className: "text-sm text-muted-foreground leading-6"
    }, description) : description || null, children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "mt-4"
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogFooter), {
        className: "mt-6 flex gap-2 justify-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: destructive ? 'destructive' : 'default',
        disabled: loading || confirmDisabled,
        onClick: onConfirm,
        "data-testid": confirmTestId
    }, confirmLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        disabled: loading,
        autoFocus: true,
        onClick: ()=>onOpenChange?.(false),
        "data-testid": cancelTestId
    }, cancelLabel))));
}

});

parcelRegister("dOauK", function(module, exports) {

$parcel$export(module.exports, "default", () => $35331361c3270146$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
'use client';
/**
 * Inline alert / callout banner (zone ②). Tokened bg/ink per variant — never raw hex.
 *
 * Props:
 *   variant  — 'info' | 'success' | 'warning' | 'error' | 'neutral'
 *   title    — optional bold lead line
 *   icon     — optional leading lucide node
 *   action   — optional trailing node (e.g. a Button)
 *   children — body content
 */ const $35331361c3270146$var$VARIANT = {
    info: {
        bg: (0, $jTCZr.CT).accentSoft,
        ink: (0, $jTCZr.CT).accentInk
    },
    success: {
        bg: (0, $jTCZr.CT).goodSoft,
        ink: (0, $jTCZr.CT).goodInk
    },
    warning: {
        bg: (0, $jTCZr.CT).warnSoft,
        ink: (0, $jTCZr.CT).warnInk
    },
    error: {
        bg: (0, $jTCZr.CT).dangerSoft,
        ink: (0, $jTCZr.CT).dangerInk
    },
    neutral: {
        bg: (0, $jTCZr.CT).surface2,
        ink: (0, $jTCZr.CT).ink2
    }
};
function $35331361c3270146$export$2e2bcd8739ae039({ variant: variant = 'info', title: title, icon: icon, action: action, children: children, style: style, ...rest }) {
    const v = $35331361c3270146$var$VARIANT[variant] || $35331361c3270146$var$VARIANT.info;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...rest,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            background: v.bg,
            color: v.ink,
            padding: '11px 16px',
            borderRadius: 12,
            fontSize: '0.8125rem',
            ...style
        }
    }, icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'inline-flex',
            flexShrink: 0
        }
    }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: 0
        }
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontWeight: 700,
            marginBottom: children ? 4 : 0
        }
    }, title), children), action && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flexShrink: 0
        }
    }, action));
}

});

parcelRegister("2vXUl", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cbee9b1abdcb86a$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $QG9Z3 = parcelRequire("QG9Z3");

var $jTCZr = parcelRequire("jTCZr");

var $aJ1FU = parcelRequire("aJ1FU");

var $j9AxR = parcelRequire("j9AxR");
'use client';
function $3cbee9b1abdcb86a$export$2e2bcd8739ae039({ icon: icon, title: title, description: description, onRetry: onRetry, retryLabel: retryLabel, fill: fill = false, style: style, ...rest }) {
    const copy = (0, $j9AxR.kitCopy)().errorState;
    if (title === undefined) title = copy.title;
    if (retryLabel === undefined) retryLabel = copy.retry;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...rest,
        "data-state": "error",
        style: {
            textAlign: 'center',
            padding: '60px 20px',
            ...fill && {
                flex: 1,
                minHeight: 0,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center'
            },
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'inline-flex',
            marginBottom: 16,
            color: (0, $jTCZr.C).red
        }
    }, icon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $QG9Z3.default), {
        size: 44
    })), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '1.125rem',
            fontWeight: 700,
            color: (0, $jTCZr.C).textPrimary,
            marginBottom: 8
        }
    }, title), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.8125rem',
            color: (0, $jTCZr.C).textMuted,
            marginBottom: 16
        }
    }, description), onRetry && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        onClick: onRetry
    }, retryLabel));
}

});
parcelRegister("QG9Z3", function(module, exports) {

$parcel$export(module.exports, "default", () => $f66de94054a4f331$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $f66de94054a4f331$export$a2387ed3b5d536eb = {
    name: "triangle-alert",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
                key: "wmoenq"
            }
        ],
        [
            "path",
            {
                d: "M12 9v4",
                key: "juzpu7"
            }
        ],
        [
            "path",
            {
                d: "M12 17h.01",
                key: "p32p05"
            }
        ]
    ],
    aliases: [
        "alert-triangle"
    ]
};
$f66de94054a4f331$export$a2387ed3b5d536eb.node;
const $f66de94054a4f331$export$2e2bcd8739ae039 = (0, $9QBug.default)($f66de94054a4f331$export$a2387ed3b5d536eb);

});


parcelRegister("2tqZa", function(module, exports) {

$parcel$export(module.exports, "default", () => $46e1ac2ff7a7c6a8$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $aJ1FU = parcelRequire("aJ1FU");

var $jTCZr = parcelRequire("jTCZr");
'use client';
// ─────────────────────────────────────────────────────────────────────────────
// The one shell every whole-page system state renders through: 404, 403, the
// crash recovery page, maintenance, the cold offline boot, session expiry.
//
// Why one component rather than six designs: these screens are, by definition,
// the moments a user is already unsure whether the app is working. Six
// different layouts for six different faults reads as six different kinds of
// broken. One recognisable shape — icon, one-line verdict, one-line advice, a
// primary action — makes an unexpected page legible as "the app is telling me
// something", which is exactly the reassurance the situation needs.
//
// The shape is deliberately NOT the framework's `EmptyState`. An empty state
// says «there is nothing here yet» inside a working screen and must stay quiet;
// a system state says «something is wrong» and owns the viewport. Collapsing
// them is how a failed load ends up looking like a successful load of nothing.
//
// DESIGN COMPLIANCE — this page is not a special case:
//   • sizes and weights are the documented type roles (hero / metric / body /
//     caption). The kit cannot import an app's `type` module, so the values are
//     inlined with the role named beside them — never a size chosen for this
//     component alone,
//   • radius and elevation from RADIUS/SHADOW, so the card matches every other
//     card rather than being 2px rounder,
//   • actions are the kit `Button` — the app has seven button variants and a
//     hand-rolled one here would be an eighth,
//   • colours from `C`, never literal hex, so an accent preset reaches this
//     page too.
// ─────────────────────────────────────────────────────────────────────────────
/**
 * Tone drives the icon disc only, never the page. A red wash behind a 404 would
 * make a mistyped URL look like a clinical incident.
 */ const $46e1ac2ff7a7c6a8$var$TONES = {
    neutral: ()=>({
            fg: (0, $jTCZr.C).textMuted,
            bg: (0, $jTCZr.soft)((0, $jTCZr.C).textMuted, 0.1)
        }),
    info: ()=>({
            fg: (0, $jTCZr.C).navy,
            bg: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.1)
        }),
    warning: ()=>({
            fg: (0, $jTCZr.C).amber,
            bg: (0, $jTCZr.C).amberLight
        }),
    danger: ()=>({
            fg: (0, $jTCZr.C).red,
            bg: (0, $jTCZr.C).redLight
        })
};
// The disc matches ErrorState's, so the inline and full-page failures read as
// one family seen at two sizes.
const $46e1ac2ff7a7c6a8$var$DISC = 56;
// The documented type roles, at their default-setting values. The kit cannot
// import an app's `constants/typography`, so the scale is restated here rather
// than sizes being invented per component — spread it exactly as an app spreads
// `type.*`, and the two surfaces stay identical.
const $46e1ac2ff7a7c6a8$var$TYPE = {
    hero: {
        fontSize: '2.25rem',
        fontWeight: 800,
        lineHeight: 1.05
    },
    metric: {
        fontSize: '1.1875rem',
        fontWeight: 800,
        lineHeight: 1.2
    },
    body: {
        fontSize: '0.8125rem',
        fontWeight: 500,
        lineHeight: 1.85
    },
    caption: {
        fontSize: '0.6875rem',
        fontWeight: 600,
        lineHeight: 1.4
    }
};
function $46e1ac2ff7a7c6a8$export$2e2bcd8739ae039({ tone: tone = 'neutral', icon: icon, code: code, title: title, body: body, detail: detail, actions: actions = [], children: children, footer: footer, fullscreen: fullscreen = false, testId: testId = 'system-page' }) {
    const palette = ($46e1ac2ff7a7c6a8$var$TONES[tone] || $46e1ac2ff7a7c6a8$var$TONES.neutral)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId,
        "data-system-state": tone,
        role: "alert",
        // `polite`, not `assertive`: the page has already replaced everything the
        // user was looking at, so the screen reader does not also need to
        // interrupt itself mid-sentence to say so.
        "aria-live": "polite",
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flex: fullscreen ? undefined : 1,
            width: fullscreen ? '100vw' : '100%',
            height: fullscreen ? '100vh' : '100%',
            minHeight: fullscreen ? undefined : '20rem',
            padding: '2rem 1.25rem',
            background: (0, $jTCZr.C).bg,
            boxSizing: 'border-box'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: (0, $jTCZr.C).card,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: (0, $jTCZr.RADIUS).card,
            padding: '2.5rem 2rem 2rem',
            maxWidth: '28.75rem',
            width: '100%',
            textAlign: 'center',
            position: 'relative',
            overflow: 'hidden',
            boxShadow: (0, $jTCZr.SHADOW).card
        }
    }, code && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            ...$46e1ac2ff7a7c6a8$var$TYPE.hero,
            position: 'absolute',
            top: '-0.5rem',
            insetInlineStart: '0.875rem',
            color: (0, $jTCZr.soft)((0, $jTCZr.C).textMuted, 0.09),
            userSelect: 'none',
            direction: 'ltr',
            pointerEvents: 'none'
        }
    }, code), icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: $46e1ac2ff7a7c6a8$var$DISC,
            height: $46e1ac2ff7a7c6a8$var$DISC,
            borderRadius: (0, $jTCZr.RADIUS).pill,
            background: palette.bg,
            color: palette.fg,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 1rem',
            position: 'relative'
        }
    }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            ...$46e1ac2ff7a7c6a8$var$TYPE.metric,
            color: (0, $jTCZr.C).textPrimary,
            marginBottom: '0.5rem'
        }
    }, title), body && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            ...$46e1ac2ff7a7c6a8$var$TYPE.body,
            color: (0, $jTCZr.C).textSecondary,
            marginBottom: '1.25rem'
        }
    }, body), children, detail && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${testId}-detail`,
        style: {
            ...$46e1ac2ff7a7c6a8$var$TYPE.caption,
            color: (0, $jTCZr.C).textMuted,
            direction: 'ltr',
            textAlign: 'left',
            fontFamily: 'monospace',
            wordBreak: 'break-word',
            background: (0, $jTCZr.C).bg,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: (0, $jTCZr.RADIUS).chip,
            padding: '0.5rem 0.625rem',
            margin: '0 0 1.25rem',
            maxHeight: '7.5rem',
            overflow: 'auto'
        }
    }, detail), actions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: actions.length > 2 ? 'column' : 'row',
            gap: '0.625rem',
            justifyContent: 'center'
        }
    }, actions.map((action, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($46e1ac2ff7a7c6a8$var$SystemAction, {
            key: action.key || action.label || i,
            ...action,
            // The first action is the recommended one unless a caller says
            // otherwise — a system page with two equally-weighted buttons
            // makes the user decide something they have no basis to decide.
            variant: action.variant || (i === 0 ? 'primary' : 'secondary')
        }))), footer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            ...$46e1ac2ff7a7c6a8$var$TYPE.caption,
            color: (0, $jTCZr.C).textMuted,
            marginTop: '1.25rem',
            lineHeight: 1.8
        }
    }, footer)));
}
// The two roles a system page offers map onto kit variants: `default` (the
// navy fill) for the recommended action, `outline` for the alternative. The
// prop names stay primary/secondary because that is what the CALLER is
// choosing — an intent, not a paint job — and it keeps the call sites readable.
const $46e1ac2ff7a7c6a8$var$VARIANT_MAP = {
    primary: 'default',
    secondary: 'outline',
    ghost: 'ghost'
};
function $46e1ac2ff7a7c6a8$var$SystemAction({ label: label, onClick: onClick, href: href, variant: variant, testId: testId }) {
    const kitVariant = $46e1ac2ff7a7c6a8$var$VARIANT_MAP[variant] || 'outline';
    // `asChild` renders the anchor with the button's styling, so a link action is
    // visually identical to a button one instead of being a hand-styled <a>.
    if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        asChild: true,
        variant: kitVariant,
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
        href: href
    }, label));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        type: "button",
        variant: kitVariant,
        onClick: onClick,
        "data-testid": testId
    }, label);
}

});

parcelRegister("coDoE", function(module, exports) {

var $acw62 = parcelRequire("acw62");

var $dfuoR = parcelRequire("dfuoR");

var $2tqZa = parcelRequire("2tqZa");

var $j9AxR = parcelRequire("j9AxR");
'use client';
class $10231e94a06472aa$export$7583e06808a373a5 extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, info) {
        // Keep the component stack. `error.stack` points at the component that
        // threw, not the tree that rendered it — and for a shared primitive
        // (Button, Card) the latter is the only part identifying WHICH screen is
        // broken.
        // eslint-disable-next-line no-console
        console.error('[ErrorBoundary]', error, info?.componentStack);
        this.props.onError?.(error, info);
    }
    componentDidUpdate(prevProps) {
        if (this.state.error && prevProps.resetKey !== this.props.resetKey) this.setState({
            error: null
        });
    }
    reset = ()=>this.setState({
            error: null
        });
    render() {
        if (!this.state.error) return this.props.children;
        return this.props.renderFallback(this.state.error, this.reset);
    }
}
function $10231e94a06472aa$export$2e2bcd8739ae039({ children: children, resetKey: resetKey, title: title, body: body, retryLabel: retryLabel, showRetry: showRetry = true, actions: actions = [], footer: footer, fullscreen: fullscreen = false, onError: onError, testId: testId = 'error-boundary' }) {
    if (title === undefined) title = (0, $j9AxR.kitCopy)().errorBoundary.title;
    if (body === undefined) body = (0, $j9AxR.kitCopy)().errorBoundary.body;
    if (retryLabel === undefined) retryLabel = (0, $j9AxR.kitCopy)().errorBoundary.retry;
    const renderFallback = (error, reset)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2tqZa.default), {
            testId: testId,
            tone: "danger",
            fullscreen: fullscreen,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dfuoR.default), {
                size: 30,
                strokeWidth: 2,
                "aria-hidden": true
            }),
            title: title,
            body: body,
            // The message, not the stack: a user cannot read a stack, and the message
            // is the part that lets support reproduce it. The stack is in the console
            // for whoever goes looking.
            detail: error?.message || String(error),
            actions: [
                ...showRetry ? [
                    {
                        key: 'retry',
                        label: retryLabel,
                        onClick: reset,
                        variant: 'primary',
                        testId: `${testId}-retry`
                    }
                ] : [],
                ...actions
            ],
            footer: footer
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($10231e94a06472aa$export$7583e06808a373a5, {
        resetKey: resetKey,
        renderFallback: renderFallback,
        onError: onError
    }, children);
}

});
parcelRegister("dfuoR", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5539f6bdf6973c1$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $b5539f6bdf6973c1$export$a2387ed3b5d536eb = {
    name: "octagon-alert",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M12 16h.01",
                key: "1drbdi"
            }
        ],
        [
            "path",
            {
                d: "M12 8v4",
                key: "1got3b"
            }
        ],
        [
            "path",
            {
                d: "M15.312 2a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586l-4.688-4.688A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2z",
                key: "1fd625"
            }
        ]
    ],
    aliases: [
        "alert-octagon"
    ]
};
$b5539f6bdf6973c1$export$a2387ed3b5d536eb.node;
const $b5539f6bdf6973c1$export$2e2bcd8739ae039 = (0, $9QBug.default)($b5539f6bdf6973c1$export$a2387ed3b5d536eb);

});


parcelRegister("fx6O8", function(module, exports) {

$parcel$export(module.exports, "default", () => $0790d8ae08647dfa$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $dcn2F = parcelRequire("dcn2F");
var $aks7U = parcelRequire("aks7U");
var $5kK4h = parcelRequire("5kK4h");
var $6JkDX = parcelRequire("6JkDX");

var $aJ1FU = parcelRequire("aJ1FU");

var $jTCZr = parcelRequire("jTCZr");

var $3EHig = parcelRequire("3EHig");

var $j9AxR = parcelRequire("j9AxR");
'use client';
// ─────────────────────────────────────────────────────────────────────────────
// The one place the app says «you are not connected».
//
// Without one, a dropped connection produces N independent error cards, one per
// panel, each blaming itself, none of them explaining the others — and no signal
// at all when it comes back, so the user's only strategy is to refresh and see.
//
// Deliberate choices:
//
//   It is a BAR, not a modal or a toast. A modal would block a doctor from
//   reading the notes already on screen, which are still perfectly good and are
//   the most valuable thing in the room during an outage. A toast would vanish
//   while the condition persisted. A bar states an ongoing fact and lets work
//   continue around it.
//
//   It sits at the top and pushes content down rather than floating over it.
//   Overlaying would cover the page header on every screen — which in a
//   clinical app is often the patient's name, not something to hide.
//
//   Recovery is announced ONCE and then disappears on its own. A permanent
//   «متصل» is chrome nobody reads; the useful signal is the transition, and
//   specifically the moment a user can stop wondering whether their last save
//   went through.
// ─────────────────────────────────────────────────────────────────────────────
const $0790d8ae08647dfa$var$RECOVERY_VISIBLE_MS = 4000;
const $0790d8ae08647dfa$var$VARIANTS = {
    [(0, $3EHig.ConnectionState).OFFLINE]: {
        Icon: (0, $6JkDX.default),
        bg: (0, $jTCZr.C).red,
        fg: '#fff',
        testId: 'connectivity-offline'
    },
    [(0, $3EHig.ConnectionState).DEGRADED]: {
        Icon: (0, $dcn2F.default),
        bg: (0, $jTCZr.C).amber,
        // Amber is a light hue; white on it fails contrast. `CT.warnInk` is the
        // ink the kit already pairs with a warning surface — a hand-mixed brown
        // here is how a second, slightly-off warning colour enters a design system.
        fg: (0, $jTCZr.CT).warnInk,
        testId: 'connectivity-degraded'
    }
};
function $0790d8ae08647dfa$export$2e2bcd8739ae039({ state: state, recovered: recovered, onAcknowledgeRecovery: onAcknowledgeRecovery, onRetry: onRetry, busy: busy, offlineLabel: offlineLabel, degradedLabel: degradedLabel, restoredLabel: restoredLabel, retryLabel: retryLabel, busyLabel: busyLabel }) {
    if (offlineLabel === undefined) offlineLabel = (0, $j9AxR.kitCopy)().connectivity.offline;
    if (degradedLabel === undefined) degradedLabel = (0, $j9AxR.kitCopy)().connectivity.degraded;
    if (restoredLabel === undefined) restoredLabel = (0, $j9AxR.kitCopy)().connectivity.restored;
    if (retryLabel === undefined) retryLabel = (0, $j9AxR.kitCopy)().connectivity.retry;
    if (busyLabel === undefined) busyLabel = (0, $j9AxR.kitCopy)().connectivity.busy;
    const disconnected = state !== (0, $3EHig.ConnectionState).ONLINE;
    const LABELS = {
        [(0, $3EHig.ConnectionState).OFFLINE]: offlineLabel,
        [(0, $3EHig.ConnectionState).DEGRADED]: degradedLabel
    };
    // The recovery bar retires itself. The timer is keyed on the flag so a second
    // outage inside the window restarts it rather than inheriting a stale
    // countdown that would hide the confirmation early.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!recovered || disconnected) return undefined;
        const timer = setTimeout(()=>onAcknowledgeRecovery?.(), $0790d8ae08647dfa$var$RECOVERY_VISIBLE_MS);
        return ()=>clearTimeout(timer);
    }, [
        recovered,
        disconnected,
        onAcknowledgeRecovery
    ]);
    if (disconnected) {
        const variant = $0790d8ae08647dfa$var$VARIANTS[state];
        if (!variant) return null;
        const { Icon: Icon, bg: bg, fg: fg, testId: testId } = variant;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0790d8ae08647dfa$var$Bar, {
            bg: bg,
            fg: fg,
            testId: testId,
            state: state
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
            size: 15,
            strokeWidth: 2.2,
            "aria-hidden": true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, LABELS[state]), onRetry && // The kit Button at `sm`, not a hand-rolled pill. It sits on a
        // coloured bar rather than the page, so `currentColor` carries the
        // bar's ink through — the only thing the variants cannot know — and
        // height, radius, type, focus ring and disabled state all come from
        // the kit like every other button.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            type: "button",
            size: "sm",
            variant: "ghost",
            onClick: onRetry,
            disabled: busy,
            "data-testid": "connectivity-retry",
            style: {
                marginInlineStart: 'auto',
                color: fg,
                border: '1px solid currentColor',
                background: 'transparent',
                gap: '0.3125rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aks7U.default), {
            size: 12,
            "aria-hidden": true,
            style: busy ? {
                animation: 'connectivity-spin 0.9s linear infinite'
            } : undefined
        }), busy ? busyLabel : retryLabel));
    }
    if (recovered) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0790d8ae08647dfa$var$Bar, {
        bg: (0, $jTCZr.C).green,
        fg: "#fff",
        testId: "connectivity-restored",
        state: "restored"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5kK4h.default), {
        size: 15,
        strokeWidth: 2.2,
        "aria-hidden": true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, restoredLabel));
    return null;
}
function $0790d8ae08647dfa$var$Bar({ bg: bg, fg: fg, testId: testId, state: state, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId,
        "data-connection-state": state,
        role: "status",
        // `polite`, not `assertive`. A user mid-sentence must not have their
        // screen reader interrupted by an infrastructure notice — the connection
        // dropping is not more urgent than what they are writing.
        "aria-live": "polite",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0.4375rem 1rem',
            background: bg,
            color: fg,
            fontSize: '0.75rem',
            fontWeight: 600,
            flexShrink: 0,
            zIndex: 40
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", null, '@keyframes connectivity-spin { to { transform: rotate(360deg) } }'), children);
}

});
parcelRegister("dcn2F", function(module, exports) {

$parcel$export(module.exports, "default", () => $07c0fad7e9511576$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $07c0fad7e9511576$export$a2387ed3b5d536eb = {
    name: "cloud-off",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M10.94 5.274A7 7 0 0 1 15.71 10h1.79a4.5 4.5 0 0 1 4.222 6.057",
                key: "1uxyv8"
            }
        ],
        [
            "path",
            {
                d: "M18.796 18.81A4.5 4.5 0 0 1 17.5 19H9A7 7 0 0 1 5.79 5.78",
                key: "99tcn7"
            }
        ],
        [
            "path",
            {
                d: "m2 2 20 20",
                key: "1ooewy"
            }
        ]
    ]
};
$07c0fad7e9511576$export$a2387ed3b5d536eb.node;
const $07c0fad7e9511576$export$2e2bcd8739ae039 = (0, $9QBug.default)($07c0fad7e9511576$export$a2387ed3b5d536eb);

});

parcelRegister("aks7U", function(module, exports) {

$parcel$export(module.exports, "default", () => $96b330d9ae0cfa5e$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $96b330d9ae0cfa5e$export$a2387ed3b5d536eb = {
    name: "refresh-cw",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8",
                key: "v9h5vc"
            }
        ],
        [
            "path",
            {
                d: "M21 3v5h-5",
                key: "1q7to0"
            }
        ],
        [
            "path",
            {
                d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16",
                key: "3uifl3"
            }
        ],
        [
            "path",
            {
                d: "M8 16H3v5",
                key: "1cv678"
            }
        ]
    ]
};
$96b330d9ae0cfa5e$export$a2387ed3b5d536eb.node;
const $96b330d9ae0cfa5e$export$2e2bcd8739ae039 = (0, $9QBug.default)($96b330d9ae0cfa5e$export$a2387ed3b5d536eb);

});

parcelRegister("5kK4h", function(module, exports) {

$parcel$export(module.exports, "default", () => $f44aa7a4ced52702$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $f44aa7a4ced52702$export$a2387ed3b5d536eb = {
    name: "wifi",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M12 20h.01",
                key: "zekei9"
            }
        ],
        [
            "path",
            {
                d: "M2 8.82a15 15 0 0 1 20 0",
                key: "dnpr2z"
            }
        ],
        [
            "path",
            {
                d: "M5 12.859a10 10 0 0 1 14 0",
                key: "1x1e6c"
            }
        ],
        [
            "path",
            {
                d: "M8.5 16.429a5 5 0 0 1 7 0",
                key: "1bycff"
            }
        ]
    ]
};
$f44aa7a4ced52702$export$a2387ed3b5d536eb.node;
const $f44aa7a4ced52702$export$2e2bcd8739ae039 = (0, $9QBug.default)($f44aa7a4ced52702$export$a2387ed3b5d536eb);

});

parcelRegister("6JkDX", function(module, exports) {

$parcel$export(module.exports, "default", () => $34b17daf5c0ea500$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $34b17daf5c0ea500$export$a2387ed3b5d536eb = {
    name: "wifi-off",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M12 20h.01",
                key: "zekei9"
            }
        ],
        [
            "path",
            {
                d: "M8.5 16.429a5 5 0 0 1 7 0",
                key: "1bycff"
            }
        ],
        [
            "path",
            {
                d: "M5 12.859a10 10 0 0 1 5.17-2.69",
                key: "1dl1wf"
            }
        ],
        [
            "path",
            {
                d: "M19 12.859a10 10 0 0 0-2.007-1.523",
                key: "4k23kn"
            }
        ],
        [
            "path",
            {
                d: "M2 8.82a15 15 0 0 1 4.177-2.643",
                key: "1grhjp"
            }
        ],
        [
            "path",
            {
                d: "M22 8.82a15 15 0 0 0-11.288-3.764",
                key: "z3jwby"
            }
        ],
        [
            "path",
            {
                d: "m2 2 20 20",
                key: "1ooewy"
            }
        ]
    ]
};
$34b17daf5c0ea500$export$a2387ed3b5d536eb.node;
const $34b17daf5c0ea500$export$2e2bcd8739ae039 = (0, $9QBug.default)($34b17daf5c0ea500$export$a2387ed3b5d536eb);

});

parcelRegister("3EHig", function(module, exports) {

$parcel$export(module.exports, "ConnectionState", () => $2a96b0bae45a4311$export$cd9c3c6bf535afc9);
$parcel$export(module.exports, "useOnlineStatus", () => $2a96b0bae45a4311$export$a32c5b7f472865fb);

var $acw62 = parcelRequire("acw62");

var $2sptB = parcelRequire("2sptB");
// ─────────────────────────────────────────────────────────────────────────────
// Is the app actually able to reach its backend?
//
// The app had no answer to this at all. A doctor whose Wi-Fi dropped mid-clinic
// saw each screen fail on its own schedule, each with its own error card, none
// of them saying the one thing that explained all of them — and nothing told
// them when it came back, so the habit became "refresh and hope".
//
// `navigator.onLine` alone is not the answer, and the direction of its error
// matters. It is RELIABLE when false (the OS says there is no route to
// anywhere) and near-worthless when true (it means "an interface is up", which
// a captive portal, an expired hotel Wi-Fi login, a VPN drop and a firewall all
// satisfy while dropping every packet to the BFF). So:
//
//   offline  — the browser says so. Trusted immediately, no probe needed.
//   degraded — the browser says we are online but the BFF is not answering.
//              Only entered from real evidence: a request that actually failed,
//              confirmed by a probe. This is the state that catches the captive
//              portal, and it is why a bare `navigator.onLine` hook was not
//              enough.
//   online   — reachable.
//
// The probe is deliberately cheap and deliberately rare: it only runs while
// something is known to be wrong, or once when the browser says the network
// came back. It never polls a healthy connection — a heartbeat that fires all
// day to detect a condition that lasts seconds is a battery cost paid by every
// doctor to benefit none of them.
// ─────────────────────────────────────────────────────────────────────────────
/** The browser's own verdict. Reliable when true, worthless when false — see above. */ const $2a96b0bae45a4311$var$isBrowserOffline = ()=>typeof navigator !== 'undefined' && navigator.onLine === false;
const $2a96b0bae45a4311$export$cd9c3c6bf535afc9 = {
    ONLINE: 'online',
    DEGRADED: 'degraded',
    OFFLINE: 'offline'
};
// Backoff for the recovery probe while disconnected. Starts brisk — most
// outages are a few seconds of a lift or a dead spot, and the doctor should not
// wait a minute to be told they are back — then eases off so a genuinely long
// outage is not a request every two seconds for twenty minutes.
const $2a96b0bae45a4311$var$PROBE_MIN_MS = 3000;
const $2a96b0bae45a4311$var$PROBE_MAX_MS = 30000;
// The probe budget. Much shorter than a real query's: this asks one question
// ("is anything there?") and a slow answer is a no for our purposes.
const $2a96b0bae45a4311$var$PROBE_TIMEOUT_MS = 5000;
/**
 * Ask the BFF whether it is reachable.
 *
 * Sends the smallest legal GraphQL request rather than hitting a health path:
 * the BFF has no unauthenticated health endpoint, and this way the probe
 * traverses exactly the path real queries do — same origin, same proxy, same
 * TLS. Any HTTP response at all counts as reachable, INCLUDING 400 and 401: the
 * question is whether packets arrive, not whether we are welcome. Treating a
 * 401 as "offline" would put a network banner in front of a user whose session
 * simply expired, which is a different problem with different copy.
 */ async function $2a96b0bae45a4311$var$probeBff(url, signal) {
    try {
        const res = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                query: '{__typename}'
            }),
            signal: signal,
            cache: 'no-store'
        });
        return Boolean(res);
    } catch  {
        return false;
    }
}
function $2a96b0bae45a4311$export$a32c5b7f472865fb({ url: url } = {}) {
    const [state, setState] = (0, $acw62.useState)(()=>$2a96b0bae45a4311$var$isBrowserOffline() ? $2a96b0bae45a4311$export$cd9c3c6bf535afc9.OFFLINE : $2a96b0bae45a4311$export$cd9c3c6bf535afc9.ONLINE);
    // Was the connection ever lost in this session? Drives the transient «اتصال
    // برقرار شد» confirmation — without it, the banner would announce a recovery
    // to every doctor who simply opened the app.
    const [recovered, setRecovered] = (0, $acw62.useState)(false);
    const timerRef = (0, $acw62.useRef)(null);
    const backoffRef = (0, $acw62.useRef)($2a96b0bae45a4311$var$PROBE_MIN_MS);
    const abortRef = (0, $acw62.useRef)(null);
    const stateRef = (0, $acw62.useRef)(state);
    stateRef.current = state;
    const clearTimer = ()=>{
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
    };
    const goOnline = (0, $acw62.useCallback)(()=>{
        backoffRef.current = $2a96b0bae45a4311$var$PROBE_MIN_MS;
        clearTimer();
        setState((prev)=>{
            if (prev !== $2a96b0bae45a4311$export$cd9c3c6bf535afc9.ONLINE) setRecovered(true);
            return $2a96b0bae45a4311$export$cd9c3c6bf535afc9.ONLINE;
        });
    }, []);
    /**
   * Run one probe now and schedule the next if it fails.
   *
   * Exposed as `check` so a failed real request can hand its evidence over
   * rather than making the hook discover the same outage independently.
   */ const check = (0, $acw62.useCallback)(async ()=>{
        if ($2a96b0bae45a4311$var$isBrowserOffline()) {
            setState($2a96b0bae45a4311$export$cd9c3c6bf535afc9.OFFLINE);
            return false;
        }
        abortRef.current?.abort();
        const controller = new AbortController();
        abortRef.current = controller;
        const timeout = setTimeout(()=>controller.abort(), $2a96b0bae45a4311$var$PROBE_TIMEOUT_MS);
        const reachable = url ? await $2a96b0bae45a4311$var$probeBff(url, controller.signal) : true;
        clearTimeout(timeout);
        if (reachable) {
            goOnline();
            return true;
        }
        // Re-read the authoritative signal at the moment of the verdict rather than
        // trusting the state we entered with: a probe can outlive the condition that
        // started it, and an in-flight request that resolves after the interface
        // genuinely dropped must not downgrade a true OFFLINE to DEGRADED.
        //
        // The reverse matters more, and is the case the test pins: once the browser
        // reports online again, a failing probe means DEGRADED — there IS a network,
        // the BFF is just not on the other end of it. Keeping OFFLINE sticky here
        // would have described a captive portal as "no internet", which sends the
        // doctor to look at a router that is working perfectly.
        setState($2a96b0bae45a4311$var$isBrowserOffline() ? $2a96b0bae45a4311$export$cd9c3c6bf535afc9.OFFLINE : $2a96b0bae45a4311$export$cd9c3c6bf535afc9.DEGRADED);
        clearTimer();
        timerRef.current = setTimeout(check, backoffRef.current);
        backoffRef.current = Math.min(backoffRef.current * 2, $2a96b0bae45a4311$var$PROBE_MAX_MS);
        return false;
    }, [
        goOnline,
        url
    ]);
    /**
   * Report a request that just failed for transport reasons.
   *
   * The distinction that makes this hook trustworthy: we do NOT go straight to
   * `degraded` on one failed request. A single 502 from one flaky upstream is
   * not a connectivity problem, and telling the doctor their connection is down
   * when one panel failed would train them to ignore the banner — which is the
   * whole asset here. The probe is what turns a suspicion into a claim.
   */ const reportFailure = (0, $acw62.useCallback)(()=>{
        if (stateRef.current === $2a96b0bae45a4311$export$cd9c3c6bf535afc9.ONLINE) check();
    }, [
        check
    ]);
    (0, $acw62.useEffect)(()=>{
        const handleOffline = ()=>{
            // No probe: the browser is authoritative in this direction, and firing a
            // request at a machine with no route just burns a timeout.
            clearTimer();
            abortRef.current?.abort();
            setState($2a96b0bae45a4311$export$cd9c3c6bf535afc9.OFFLINE);
        };
        // …and NOT authoritative in the other. 'online' means an interface came up,
        // which a captive portal satisfies. Confirm before claiming recovery.
        const handleOnline = ()=>{
            backoffRef.current = $2a96b0bae45a4311$var$PROBE_MIN_MS;
            check();
        };
        // Coming back to a backgrounded tab is the other moment worth checking: a
        // laptop that slept through a network change reports nothing, and the first
        // thing the doctor does is read a screen full of stale data.
        const handleVisibility = ()=>{
            if (document.visibilityState === 'visible' && stateRef.current !== $2a96b0bae45a4311$export$cd9c3c6bf535afc9.ONLINE) check();
        };
        window.addEventListener('offline', handleOffline);
        window.addEventListener('online', handleOnline);
        document.addEventListener('visibilitychange', handleVisibility);
        // The evidence `navigator.onLine` cannot give us: a real request that just
        // failed at the transport layer.
        const unsubscribe = (0, $2sptB.onTransportFailure)(reportFailure);
        // A tab that BOOTS offline never fires an event — it was already in that
        // state — so the initial value has to stand on its own, and it does.
        if ($2a96b0bae45a4311$var$isBrowserOffline()) setState($2a96b0bae45a4311$export$cd9c3c6bf535afc9.OFFLINE);
        return ()=>{
            window.removeEventListener('offline', handleOffline);
            window.removeEventListener('online', handleOnline);
            document.removeEventListener('visibilitychange', handleVisibility);
            unsubscribe();
            clearTimer();
            abortRef.current?.abort();
        };
    }, [
        check,
        reportFailure
    ]);
    return {
        state: state,
        isOnline: state === $2a96b0bae45a4311$export$cd9c3c6bf535afc9.ONLINE,
        isOffline: state === $2a96b0bae45a4311$export$cd9c3c6bf535afc9.OFFLINE,
        isDegraded: state === $2a96b0bae45a4311$export$cd9c3c6bf535afc9.DEGRADED,
        recovered: recovered,
        acknowledgeRecovery: (0, $acw62.useCallback)(()=>setRecovered(false), []),
        check: check,
        reportFailure: reportFailure
    };
}
var $2a96b0bae45a4311$export$2e2bcd8739ae039 = $2a96b0bae45a4311$export$a32c5b7f472865fb;

});
parcelRegister("2sptB", function(module, exports) {

$parcel$export(module.exports, "onTransportFailure", () => $1ca1f567c505cbd8$export$288ba6b4215d30f3);
// ─────────────────────────────────────────────────────────────────────────────
// The one-way channel from "a request just failed for transport reasons" to
// "the connectivity detector should go and check".
//
// It exists because the two halves cannot import each other. `bffClient` is a
// leaf module with no React in it — deliberately, so it can be used from
// anywhere, including outside a component — while `useOnlineStatus` is a hook.
// Without this the detector would only ever learn about an outage from
// `navigator.onLine`, which is exactly the signal that lies: it reports online
// for a captive portal, a dead VPN, and a firewall that black-holes the BFF.
// Those are the cases the doctor most needs named, because in every one of them
// the laptop insists everything is fine.
//
// Kept as a plain subscriber list rather than an event emitter or a context: it
// carries no payload, has at most one listener (the shell's hook), and must be
// safe to call from a `catch` block during module teardown. There is nothing
// here to configure and nothing to get wrong.
// ─────────────────────────────────────────────────────────────────────────────
const $1ca1f567c505cbd8$var$listeners = new Set();
function $1ca1f567c505cbd8$export$288ba6b4215d30f3(listener) {
    $1ca1f567c505cbd8$var$listeners.add(listener);
    return ()=>$1ca1f567c505cbd8$var$listeners.delete(listener);
}
function $1ca1f567c505cbd8$export$87a8bdb1d0a966cf() {
    for (const listener of $1ca1f567c505cbd8$var$listeners)try {
        listener();
    } catch  {}
}
function $1ca1f567c505cbd8$export$d433e139d37a5376() {
    $1ca1f567c505cbd8$var$listeners.clear();
}

});



parcelRegister("hsrVQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b6fb81a56105b0d$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $8g4t5 = parcelRequire("8g4t5");

var $jTCZr = parcelRequire("jTCZr");
'use client';
function $9b6fb81a56105b0d$export$2e2bcd8739ae039({ label: label, icon: icon, onClick: onClick, minHeight: minHeight = 118, style: style }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onClick,
        style: {
            width: '100%',
            minHeight: minHeight,
            padding: 16,
            background: 'transparent',
            border: `1.5px dashed ${(0, $jTCZr.C).border}`,
            borderRadius: 16,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 6,
            cursor: 'pointer',
            color: (0, $jTCZr.C).navy,
            fontFamily: 'inherit',
            fontWeight: 700,
            fontSize: '0.875rem',
            ...style
        }
    }, icon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8g4t5.default), {
        size: 22
    }), label);
}

});

parcelRegister("cT2Zr", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d47a2201c3cd6a9$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
'use client';
function $0d47a2201c3cd6a9$export$2e2bcd8739ae039({ checked: checked, onChange: onChange, disabled: disabled = false, label: label, style: style }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "switch",
        "aria-checked": checked,
        "aria-disabled": disabled,
        "aria-label": label,
        onClick: ()=>{
            if (!disabled) onChange?.(!checked);
        },
        style: {
            width: 44,
            height: 24,
            borderRadius: 4,
            flexShrink: 0,
            position: 'relative',
            cursor: disabled ? 'not-allowed' : 'pointer',
            background: checked ? (0, $jTCZr.C).navy : '#d1d5db',
            opacity: disabled ? 0.5 : 1,
            transition: 'background .25s',
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'absolute',
            top: 3,
            width: 18,
            height: 18,
            borderRadius: '50%',
            background: '#fff',
            boxShadow: '0 1px 4px rgba(0,0,0,0.2)',
            right: checked ? 3 : 23,
            transition: 'right .25s'
        }
    }));
}

});

parcelRegister("lxEfx", function(module, exports) {

$parcel$export(module.exports, "default", () => $2358e3acbc4a7e55$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $2WFPf = parcelRequire("2WFPf");

var $jTCZr = parcelRequire("jTCZr");
'use client';
function $2358e3acbc4a7e55$export$2e2bcd8739ae039({ title: title, badge: badge, defaultOpen: defaultOpen = false, open: controlledOpen, onOpenChange: onOpenChange, children: children, style: style }) {
    const [uncontrolled, setUncontrolled] = (0, $acw62.useState)(defaultOpen);
    const open = controlledOpen !== undefined ? controlledOpen : uncontrolled;
    const toggle = ()=>{
        const next = !open;
        if (onOpenChange) onOpenChange(next);
        if (controlledOpen === undefined) setUncontrolled(next);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: toggle,
        "aria-expanded": open,
        style: {
            width: '100%',
            minHeight: 44,
            padding: '14px 4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 8,
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            fontFamily: 'inherit'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontWeight: 700,
            fontSize: '0.90625rem',
            color: (0, $jTCZr.C).textPrimary,
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6
        }
    }, title, badge != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: (0, $jTCZr.C).teal,
            fontSize: '0.75rem'
        }
    }, badge)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2WFPf.default), {
        size: 18,
        color: (0, $jTCZr.C).textMuted,
        style: {
            transform: open ? 'rotate(180deg)' : 'none',
            transition: 'transform .15s'
        }
    })), open && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            paddingBottom: 8
        }
    }, children));
}

});

parcelRegister("fW63i", function(module, exports) {

$parcel$export(module.exports, "default", () => $c173fca63c358943$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $5JYPc = parcelRequire("5JYPc");

var $j9AxR = parcelRequire("j9AxR");
'use client';
// ─────────────────────────────────────────────────────────────────────────────
// PrizeWheel — a wheel of fortune: N equal slices that spin and stop on one.
//
// Domain-free on purpose. The kit draws a circle and turns it; it knows nothing
// about prizes, wallets, campaigns or Parseh. The caller hands it the slices it
// should print and the slice it should land on, and is told when the wheel has
// stopped.
//
//   segments     [{ index, label }] in index order — position i IS slice i.
//                Labels arrive FORMATTED: Persian digits go through the app's
//                own digit seam (rule 7), never through the kit.
//   targetIndex  the winning slice, or null while nobody knows it yet. The
//                SERVER picks it; the wheel only animates to it.
//   spinning     whether the wheel should be turning. With a target but no
//                spin the wheel sits AT the result — that is how an already
//                spun draw is re-shown without replaying the animation.
//   onSettled    fired once, when the spin has stopped.
//   size         pixel diameter (it still shrinks to its container).
//
// ── Geometry ────────────────────────────────────────────────────────────────
// One 400×400 viewBox, so every number below is a user unit and the whole wheel
// scales with `size` — including the label type, which is why the labels do not
// need a second size prop. Slice i runs from `i·step − 90°` (SVG angles start
// at 3 o'clock and grow clockwise, so −90° is 12 o'clock) clockwise by one
// step. A label is rotated onto its slice's mid-angle and flipped 180° through
// the bottom half of the wheel, because a label that is merely rotated is
// upside down for half the circle.
//
// ── Motion ──────────────────────────────────────────────────────────────────
// ONE CSS transition on the slice group: θ = 5 full turns + (360 − the centre
// angle of the winning slice), so the slice's middle finishes under the pointer
// at 12 o'clock. The turns accumulate, so a wheel that is spun twice keeps
// turning the same way instead of unwinding.
//
// **Clockwise whatever the document's direction is.** Rule 8 is about layout
// and about content that carries direction; a wheel has neither. What the eye
// tracks is the pointer, and an RTL page that spun the other way would read as
// a different mechanism, not as a mirrored one.
//
// `prefers-reduced-motion: reduce` removes the transition (the BottomSheet /
// Dialog / Skeleton pattern: a media query in the kit's own stylesheet), so the
// wheel JUMPS to its result. `transitionend` then never fires — hence the
// timer, which is the real settle signal and the transition's is the early one.
// Whichever arrives first wins; `onSettled` is called exactly once per spin.
//
// ── Colour ──────────────────────────────────────────────────────────────────
// Four brand tones, cycled, with the label ink flipped against them so both
// pass contrast. The inks are `C.card` on the two filled tones and
// `var(--panel-ink)` on the two tints — the panel's deep ink rather than
// `CT.accentInk`, because an accent preset may NOT re-tint `--panel-ink`
// (tokens.css) while it does re-tint `--p-navy-dark`: under the فیروزه‌ای preset
// `accentInk` on a tint falls to ~3.9:1, and `--panel-ink` holds above 11:1
// under every preset and every panel.
// ─────────────────────────────────────────────────────────────────────────────
const $c173fca63c358943$var$CX = 200;
const $c173fca63c358943$var$CY = 200;
const $c173fca63c358943$var$R_SLICE = 190; // the coloured slices
const $c173fca63c358943$var$R_RIM = 196; // the white rim they sit on
const $c173fca63c358943$var$R_LABEL = 128; // where a slice prints its label
const $c173fca63c358943$var$R_HUB = 34; // the white hub cap
const $c173fca63c358943$var$R_HUB_INNER = 22;
const $c173fca63c358943$var$R_PIP = 9;
const $c173fca63c358943$var$TURNS = 5;
const $c173fca63c358943$var$SPIN_MS = 4000;
const $c173fca63c358943$var$SPIN_EASE = 'cubic-bezier(0.17, 0.67, 0.12, 1)';
// The transition's own `transitionend` is the early signal; this is the one
// that is always sent. The grace covers the frame between committing the
// rotation and the browser starting to paint it.
const $c173fca63c358943$var$SETTLE_GRACE_MS = 200;
const $c173fca63c358943$var$REDUCED_SETTLE_MS = 50;
const $c173fca63c358943$var$FILLS = [
    (0, $jTCZr.C).navy,
    (0, $jTCZr.C).tealLight,
    (0, $jTCZr.C).navyDark,
    (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.1)
];
const $c173fca63c358943$var$INKS = [
    (0, $jTCZr.C).card,
    'var(--panel-ink)',
    (0, $jTCZr.C).card,
    'var(--panel-ink)'
];
const $c173fca63c358943$var$DISC_CSS = `
  [data-prize-disc] { transform-origin: ${$c173fca63c358943$var$CX}px ${$c173fca63c358943$var$CY}px; }
  [data-prize-disc][data-spinning="true"] { transition: transform ${$c173fca63c358943$var$SPIN_MS}ms ${$c173fca63c358943$var$SPIN_EASE}; }
  @media (prefers-reduced-motion: reduce) {
    [data-prize-disc][data-spinning="true"] { transition: none !important; }
  }
`;
// One stylesheet for every wheel on the page: React 19 hoists a <style> with
// `href` + `precedence` into <head> once (the Skeleton family does the same).
const $c173fca63c358943$var$Styles = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", {
        href: "parsina-prize-wheel",
        precedence: "default"
    }, $c173fca63c358943$var$DISC_CSS);
// Reduced motion, read in JS — only to choose how long to wait for a spin that
// the media query above has already cancelled. Defensive like the clinical
// module's `prefersInstant()`: with no window and no `matchMedia` there is no
// animation to wait for either, so "reduced" is the safe answer.
function $c173fca63c358943$var$prefersReducedMotion() {
    if (typeof window === 'undefined') return true;
    if (typeof window.matchMedia !== 'function') return true;
    try {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch  {
        return true;
    }
}
const $c173fca63c358943$var$pol = (deg, r)=>{
    const t = deg * Math.PI / 180;
    return [
        $c173fca63c358943$var$CX + r * Math.cos(t),
        $c173fca63c358943$var$CY + r * Math.sin(t)
    ];
};
// The angle the disc must come to rest at, from zero, for slice `index` of
// `count` to face the pointer: whole turns for the show, then back to the
// slice's own middle.
function $c173fca63c358943$var$angleFor(index, count) {
    const step = 360 / count;
    return $c173fca63c358943$var$TURNS * 360 + (360 - (index * step + step / 2));
}
function $c173fca63c358943$export$2e2bcd8739ae039({ segments: segments = [], targetIndex: targetIndex = null, spinning: spinning = false, onSettled: onSettled, size: size = 320, label: // Rule 7: the app passes its own; unset, the kit's word in `<html lang>`.
label, className: className, style: style, ...rest }) {
    if (label === undefined) label = (0, $j9AxR.kitCopy)().prizeWheel.label;
    const slices = Array.isArray(segments) ? segments : [];
    const count = slices.length;
    const step = count > 0 ? 360 / count : 0;
    const target = Number.isInteger(targetIndex) && targetIndex >= 0 && targetIndex < count ? targetIndex : null;
    const spin = Boolean(spinning) && target != null;
    const [rotation, setRotation] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    // The live callback, so a caller that passes a fresh closure every render
    // does not re-arm the timer mid-spin.
    const onSettledRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(onSettled);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        onSettledRef.current = onSettled;
    });
    // The armed settle, shared with `transitionend`; null when no spin is running.
    const settleRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (target == null) {
            setRotation(0);
            return;
        }
        // Drop the fraction of a turn the disc is already at, then add whole turns:
        // the rotation only ever grows, so the wheel never runs backwards.
        setRotation((prev)=>prev - prev % 360 + $c173fca63c358943$var$angleFor(target, count));
    }, [
        target,
        count
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!spin) return undefined;
        let fired = false;
        const fire = ()=>{
            if (fired) return;
            fired = true;
            onSettledRef.current?.();
        };
        settleRef.current = fire;
        const timer = setTimeout(fire, $c173fca63c358943$var$prefersReducedMotion() ? $c173fca63c358943$var$REDUCED_SETTLE_MS : $c173fca63c358943$var$SPIN_MS + $c173fca63c358943$var$SETTLE_GRACE_MS);
        return ()=>{
            clearTimeout(timer);
            settleRef.current = null;
        };
    }, [
        spin,
        target
    ]);
    // Under two slices there is no wheel to draw — the arc flag below describes a
    // minor arc, and a single slice has no arc at all. Nothing is drawn rather
    // than something misleading, as `Sparkline` does with a single point.
    if (count < 2) return null;
    const paths = [];
    const labels = [];
    for(let i = 0; i < count; i += 1){
        const from = i * step - 90;
        const to = from + step;
        const mid = from + step / 2;
        const [x0, y0] = $c173fca63c358943$var$pol(from, $c173fca63c358943$var$R_SLICE);
        const [x1, y1] = $c173fca63c358943$var$pol(to, $c173fca63c358943$var$R_SLICE);
        const [lx, ly] = $c173fca63c358943$var$pol(mid, $c173fca63c358943$var$R_LABEL);
        // Through the bottom half of the wheel a label rotated onto its slice reads
        // upside down; turning it over keeps every label the right way up.
        const upright = mid > 90 && mid < 270 ? mid + 180 : mid;
        paths.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            key: `slice-${i}`,
            d: `M${$c173fca63c358943$var$CX},${$c173fca63c358943$var$CY} L${x0.toFixed(2)},${y0.toFixed(2)} A${$c173fca63c358943$var$R_SLICE},${$c173fca63c358943$var$R_SLICE} 0 0 1 ${x1.toFixed(2)},${y1.toFixed(2)} Z`,
            fill: $c173fca63c358943$var$FILLS[i % $c173fca63c358943$var$FILLS.length],
            stroke: (0, $jTCZr.C).card,
            strokeWidth: 3
        }));
        labels.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
            key: `label-${i}`,
            transform: `translate(${lx.toFixed(2)} ${ly.toFixed(2)}) rotate(${upright.toFixed(2)})`,
            fill: $c173fca63c358943$var$INKS[i % $c173fca63c358943$var$INKS.length],
            fontSize: 17,
            fontWeight: 700,
            textAnchor: "middle",
            dominantBaseline: "middle"
        }, slices[i]?.label));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c173fca63c358943$var$Styles, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 400 400",
        // The pointer sits above the disc, outside the box.
        style: {
            display: 'block',
            overflow: 'visible',
            maxWidth: '100%',
            height: 'auto',
            ...style
        },
        className: (0, $5JYPc.cn)(className),
        role: "img",
        "aria-label": label,
        focusable: "false",
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: $c173fca63c358943$var$CX,
        cy: $c173fca63c358943$var$CY,
        r: $c173fca63c358943$var$R_RIM,
        fill: (0, $jTCZr.C).card,
        stroke: (0, $jTCZr.C).border,
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        "data-prize-disc": "",
        "data-spinning": spin ? 'true' : 'false',
        style: {
            transform: `rotate(${rotation}deg)`
        },
        onTransitionEnd: (e)=>{
            if (e.propertyName === 'transform') settleRef.current?.();
        }
    }, paths, labels), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: $c173fca63c358943$var$CX,
        cy: $c173fca63c358943$var$CY,
        r: $c173fca63c358943$var$R_HUB,
        fill: (0, $jTCZr.C).card,
        stroke: (0, $jTCZr.C).border,
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: $c173fca63c358943$var$CX,
        cy: $c173fca63c358943$var$CY,
        r: $c173fca63c358943$var$R_HUB_INNER,
        fill: (0, $jTCZr.C).teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: $c173fca63c358943$var$CX,
        cy: $c173fca63c358943$var$CY,
        r: $c173fca63c358943$var$R_PIP,
        fill: (0, $jTCZr.C).card
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M182,-2 L218,-2 L200,34 Z",
        fill: (0, $jTCZr.C).navy,
        stroke: (0, $jTCZr.C).card,
        strokeWidth: 3,
        strokeLinejoin: "round"
    })));
}

});

parcelRegister("jM6yW", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad7c85561d054b68$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $fzlbJ = parcelRequire("fzlbJ");
var $huNwV = parcelRequire("huNwV");
var $3FyOw = parcelRequire("3FyOw");
var $8jE1c = parcelRequire("8jE1c");
var $he6AI = parcelRequire("he6AI");
var $6TdpC = parcelRequire("6TdpC");

var $aJ1FU = parcelRequire("aJ1FU");

var $5MbI8 = parcelRequire("5MbI8");

var $7phmx = parcelRequire("7phmx");

var $hZDga = parcelRequire("hZDga");

var $jTCZr = parcelRequire("jTCZr");

var $5JYPc = parcelRequire("5JYPc");

var $j9AxR = parcelRequire("j9AxR");
'use client';
const $ad7c85561d054b68$export$d8640b1e4d69af25 = [
    'queued',
    'preparing',
    'sending',
    'done',
    'failed'
];
// ≥ 2.75rem on a coarse pointer (MOBILE_WEB_PWA §5); a mouse keeps `sm`.
const $ad7c85561d054b68$var$TOUCH_TARGET = '[@media(pointer:coarse)]:min-h-[2.75rem]';
const $ad7c85561d054b68$var$SIZES = {
    regular: {
        padBlock: '1.75rem',
        icon: 28
    },
    compact: {
        padBlock: '1rem',
        icon: 20
    }
};
// ── accept matching ─────────────────────────────────────────────────────────
function $ad7c85561d054b68$var$acceptTokens(accept) {
    if (!accept) return [];
    const list = Array.isArray(accept) ? accept : String(accept).split(',');
    return list.map((t)=>String(t).trim().toLowerCase()).filter(Boolean);
}
function $ad7c85561d054b68$export$b4699969e89702eb(file, accept) {
    const tokens = $ad7c85561d054b68$var$acceptTokens(accept);
    if (tokens.length === 0) return true;
    const name = String(file?.name || '').toLowerCase();
    const type = String(file?.type || '').toLowerCase();
    return tokens.some((token)=>{
        if (token.startsWith('.')) return name.endsWith(token);
        if (token.endsWith('/*')) return type.startsWith(token.slice(0, -1));
        return type === token;
    });
}
// `null`, '' and [] mean "no filter" — and no `accept` attribute on the input.
function $ad7c85561d054b68$var$acceptAttr(accept) {
    const tokens = $ad7c85561d054b68$var$acceptTokens(accept);
    return tokens.length ? tokens.join(',') : undefined;
}
function $ad7c85561d054b68$var$isImage(file) {
    return !!file && typeof file.type === 'string' && file.type.toLowerCase().startsWith('image/');
}
function $ad7c85561d054b68$export$8c95ef2c56e9a241({ name: name, meta: meta, phase: phase = 'queued', progress: progress, progressLabel: progressLabel, error: error, file: file, previewUrl: previewUrl, badge: badge, removable: removable, replaceable: replaceable = false, trailing: trailing, busy: busy = false, disabled: disabled = false, onRemove: onRemove, onRetry: onRetry, onReplace: onReplace, phaseLabels: phaseLabels, removeLabel: removeLabel, retryLabel: retryLabel, replaceLabel: replaceLabel, as: Tag = 'li', className: className, 'data-testid': testId, ...rest }) {
    if (removeLabel === undefined) removeLabel = (0, $j9AxR.kitCopy)().files.remove;
    if (retryLabel === undefined) retryLabel = (0, $j9AxR.kitCopy)().files.retry;
    if (replaceLabel === undefined) replaceLabel = (0, $j9AxR.kitCopy)().files.replace;
    const labels = {
        ...(0, $j9AxR.kitCopy)().files.phases,
        ...phaseLabels
    };
    const phaseLabel = labels[phase] ?? phase;
    // A thumbnail for an image File, created here and revoked when the row
    // leaves or the file changes — a leaked object URL holds the whole blob.
    const [objectUrl, setObjectUrl] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const wantsObjectUrl = !previewUrl && !badge && $ad7c85561d054b68$var$isImage(file);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!wantsObjectUrl || typeof URL === 'undefined' || typeof URL.createObjectURL !== 'function') {
            setObjectUrl(null);
            return undefined;
        }
        const url = URL.createObjectURL(file);
        setObjectUrl(url);
        return ()=>{
            if (typeof URL.revokeObjectURL === 'function') URL.revokeObjectURL(url);
        };
    }, [
        file,
        wantsObjectUrl
    ]);
    const thumbSrc = previewUrl || (wantsObjectUrl ? objectUrl : null);
    const canRemove = (removable ?? phase !== 'done') && !busy && typeof onRemove === 'function';
    const canRetry = phase === 'failed' && !!file && !busy && typeof onRetry === 'function';
    const canReplace = replaceable && !busy && typeof onReplace === 'function';
    const hasBar = typeof progress === 'number' && Number.isFinite(progress);
    const pct = hasBar ? Math.max(0, Math.min(100, progress)) : 0;
    const phaseColor = phase === 'failed' ? (0, $jTCZr.CT).dangerInk : phase === 'done' ? (0, $jTCZr.CT).goodInk : (0, $jTCZr.C).textMuted;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, {
        "data-testid": testId,
        "data-state": phase,
        "aria-live": "polite",
        className: (0, $5JYPc.cn)('flex items-center', className),
        style: {
            gap: '0.625rem',
            paddingBlock: '0.5rem',
            paddingInline: '0.625rem',
            minHeight: '2.75rem',
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: (0, $jTCZr.RADIUS).control,
            background: (0, $jTCZr.C).card,
            minWidth: 0,
            opacity: disabled ? 0.6 : 1
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true,
        className: "flex items-center justify-center overflow-hidden",
        style: {
            flexShrink: 0,
            width: '2.25rem',
            height: '2.25rem',
            borderRadius: (0, $jTCZr.RADIUS).chip,
            background: (0, $jTCZr.C).bg,
            color: (0, $jTCZr.C).textMuted,
            fontSize: '0.625rem',
            fontWeight: 800
        }
    }, badge ? badge : thumbSrc ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: thumbSrc,
        alt: "",
        "data-testid": testId ? `${testId}-thumb` : undefined,
        style: {
            width: '100%',
            height: '100%',
            objectFit: 'cover'
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3FyOw.default), {
        size: 18,
        strokeWidth: 1.5
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "flex flex-col",
        style: {
            flex: 1,
            minWidth: 0,
            gap: '0.125rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        className: "text-start",
        style: {
            unicodeBidi: 'isolate',
            fontSize: '0.8125rem',
            fontWeight: 600,
            color: (0, $jTCZr.C).textPrimary,
            lineHeight: 1.4,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        }
    }, name), error ? // Keyed on the text: a CHANGED error remounts and is announced once;
    // an unchanged one re-rendering stays quiet.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        key: String(error),
        role: "alert",
        style: {
            fontSize: '0.6875rem',
            color: (0, $jTCZr.CT).dangerInk,
            lineHeight: 1.5
        }
    }, error) : meta ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.6875rem',
            color: (0, $jTCZr.C).textMuted,
            lineHeight: 1.5
        }
    }, meta) : null, hasBar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "flex items-center",
        style: {
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        role: "progressbar",
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-valuenow": pct,
        "aria-label": progressLabel || phaseLabel,
        className: "flex",
        style: {
            flex: 1,
            height: '0.25rem',
            borderRadius: (0, $jTCZr.RADIUS).pill,
            background: (0, $jTCZr.C).border,
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "transition-[width] duration-200 motion-reduce:transition-none",
        style: {
            width: `${pct}%`,
            height: '100%',
            background: (0, $jTCZr.CT).accent,
            borderRadius: (0, $jTCZr.RADIUS).pill
        }
    })), progressLabel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "tabular-nums",
        style: {
            fontSize: '0.6875rem',
            color: (0, $jTCZr.C).textMuted
        }
    }, progressLabel) : null) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "flex items-center",
        style: {
            flexShrink: 0,
            gap: '0.375rem'
        }
    }, trailing, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "flex items-center",
        style: {
            gap: '0.25rem',
            fontSize: '0.6875rem',
            fontWeight: 600,
            color: phaseColor
        }
    }, phase === 'sending' || phase === 'preparing' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true,
        className: "inline-flex"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 14,
        thickness: 2,
        label: ""
    })) : null, phase === 'done' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
        "aria-hidden": true,
        size: 14,
        strokeWidth: 2,
        color: (0, $jTCZr.CT).good
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, phaseLabel)), canReplace ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        type: "button",
        variant: "ghost",
        size: "sm",
        className: $ad7c85561d054b68$var$TOUCH_TARGET,
        onClick: onReplace,
        disabled: disabled,
        "data-testid": testId ? `${testId}-replace` : undefined
    }, replaceLabel) : null, canRetry ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        type: "button",
        variant: "outline",
        size: "sm",
        className: $ad7c85561d054b68$var$TOUCH_TARGET,
        onClick: onRetry,
        disabled: disabled,
        "data-testid": testId ? `${testId}-retry` : undefined
    }, retryLabel) : null, canRemove ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5MbI8.default), {
        variant: "ghost",
        size: 40,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
            size: 16,
            "aria-hidden": true
        }),
        label: removeLabel,
        onClick: onRemove,
        disabled: disabled,
        "data-testid": testId ? `${testId}-remove` : undefined
    }) : null));
}
const $ad7c85561d054b68$export$731398005976572f = $ad7c85561d054b68$export$8c95ef2c56e9a241;
// ─────────────────────────────────────────────────────────────────────────────
// FileDropzone
// ─────────────────────────────────────────────────────────────────────────────
// Every row the zone counts: the flat `files`, or the rows of every group.
function $ad7c85561d054b68$var$rowsOf(groups, files) {
    if (Array.isArray(groups)) return groups.flatMap((g)=>Array.isArray(g?.files) ? g.files : []);
    return Array.isArray(files) ? files : [];
}
function $ad7c85561d054b68$export$2e2bcd8739ae039({ files: filesProp, groups: groups, onFiles: onFiles, onRemove: onRemove, onRetry: onRetry, onReplace: onReplace, accept: accept, multiple: multiple = true, maxFiles: maxFiles, maxBytes: maxBytes, capture: capture, directory: directory = false, extraActions: extraActions, disabled: disabled = false, busy: busy = false, error: error, size: size = 'regular', label: label, required: required, helperText: helperText, dropLabel: dropLabel, pickLabel: pickLabel, cameraLabel: cameraLabel, directoryLabel: directoryLabel, removeLabel: removeLabel, retryLabel: retryLabel, replaceLabel: replaceLabel, phaseLabels: phaseLabels, draggingLabel: draggingLabel, emptyHint: emptyHint, listLabel: listLabel, className: className, style: style, 'data-testid': testId, ...rest }) {
    if (dropLabel === undefined) dropLabel = (0, $j9AxR.kitCopy)().files.drop;
    if (pickLabel === undefined) pickLabel = (0, $j9AxR.kitCopy)().files.pick;
    if (cameraLabel === undefined) cameraLabel = (0, $j9AxR.kitCopy)().files.camera;
    if (directoryLabel === undefined) directoryLabel = (0, $j9AxR.kitCopy)().files.directory;
    if (removeLabel === undefined) removeLabel = (0, $j9AxR.kitCopy)().files.remove;
    if (retryLabel === undefined) retryLabel = (0, $j9AxR.kitCopy)().files.retry;
    if (replaceLabel === undefined) replaceLabel = (0, $j9AxR.kitCopy)().files.replace;
    if (draggingLabel === undefined) draggingLabel = (0, $j9AxR.kitCopy)().files.dragging;
    const S = $ad7c85561d054b68$var$SIZES[size] || $ad7c85561d054b68$var$SIZES.regular;
    const baseId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const zoneId = `${baseId}-zone`;
    const helperId = helperText ? `${baseId}-helper` : undefined;
    const errorId = error ? `${baseId}-error` : undefined;
    const mainRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const cameraRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const directoryRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const replaceRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const replaceTarget = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const dragDepth = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(0);
    const [dragging, setDragging] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const files = $ad7c85561d054b68$var$rowsOf(groups, filesProp);
    const warnedBoth = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    const inert = disabled || busy;
    const tid = (suffix)=>testId ? `${testId}-${suffix}` : undefined;
    // `webkitdirectory` is not a React prop; it has to be an attribute.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const el = directoryRef.current;
        if (!el) return;
        el.setAttribute('webkitdirectory', '');
        el.setAttribute('directory', '');
    }, [
        directory
    ]);
    // Never lingers in `dragging` if the zone is disabled mid-drag.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (inert) {
            dragDepth.current = 0;
            setDragging(false);
        }
    }, [
        inert
    ]);
    const report = (picked, source)=>{
        const list = Array.from(picked || []);
        // Nothing picked (a cancelled dialog, a drop of text) is not a batch.
        if (list.length === 0) return;
        let room = Infinity;
        if (typeof maxFiles === 'number') room = Math.max(0, maxFiles - files.length);
        if (!multiple) room = Math.min(room, 1);
        const accepted = [];
        const rejected = [];
        for (const f of list){
            if (!$ad7c85561d054b68$export$b4699969e89702eb(f, accept)) rejected.push({
                file: f,
                reason: 'type'
            });
            else if (typeof maxBytes === 'number' && typeof f.size === 'number' && f.size > maxBytes) rejected.push({
                file: f,
                reason: 'size'
            });
            else if (accepted.length >= room) rejected.push({
                file: f,
                reason: 'count'
            });
            else accepted.push(f);
        }
        onFiles?.(accepted, rejected, source);
    };
    const onInputChange = (source)=>(e)=>{
            const picked = e.target.files;
            try {
                report(picked, source);
            } finally{
                // Reset, so picking the same file twice still fires `change`.
                e.target.value = '';
            }
        };
    const onReplaceChange = (e)=>{
        const f = e.target.files?.[0];
        const id = replaceTarget.current;
        e.target.value = '';
        replaceTarget.current = null;
        if (!f || id == null) return;
        // A refused replacement is reported like any refused pick, so the caller
        // has one place that writes the sentence.
        if (!$ad7c85561d054b68$export$b4699969e89702eb(f, accept)) {
            onFiles?.([], [
                {
                    file: f,
                    reason: 'type'
                }
            ], 'picker');
            return;
        }
        if (typeof maxBytes === 'number' && f.size > maxBytes) {
            onFiles?.([], [
                {
                    file: f,
                    reason: 'size'
                }
            ], 'picker');
            return;
        }
        onReplace?.(id, f);
    };
    const open = (ref)=>()=>{
            if (inert) return;
            ref.current?.click();
        };
    const hasDragFiles = (e)=>{
        const types = e.dataTransfer?.types;
        if (!types) return true;
        return Array.from(types).includes('Files');
    };
    const onDragEnter = (e)=>{
        if (!hasDragFiles(e)) return;
        e.preventDefault();
        if (inert) return;
        dragDepth.current += 1;
        setDragging(true);
    };
    const onDragOver = (e)=>{
        if (!hasDragFiles(e)) return;
        e.preventDefault();
        if (e.dataTransfer) e.dataTransfer.dropEffect = inert ? 'none' : 'copy';
    };
    const onDragLeave = ()=>{
        if (inert) return;
        // `dragleave` fires on every child boundary; only the last one leaves.
        dragDepth.current = Math.max(0, dragDepth.current - 1);
        if (dragDepth.current === 0) setDragging(false);
    };
    const onDrop = (e)=>{
        e.preventDefault();
        dragDepth.current = 0;
        setDragging(false);
        if (inert) return;
        report(e.dataTransfer?.files, 'drop');
    };
    const state = disabled ? 'disabled' : dragging ? 'dragging' : files.length ? 'has-files' : 'idle';
    const accentOn = dragging && !inert;
    const describedBy = [
        helperId,
        errorId
    ].filter(Boolean).join(' ') || undefined;
    const pickerProps = {
        type: 'button',
        variant: 'outline',
        size: 'sm',
        className: $ad7c85561d054b68$var$TOUCH_TARGET,
        disabled: disabled,
        'aria-disabled': busy || undefined
    };
    const renderRow = (f)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad7c85561d054b68$export$8c95ef2c56e9a241, {
            key: f.id,
            name: f.name,
            meta: f.meta,
            phase: f.phase,
            progress: f.progress,
            progressLabel: f.progressLabel,
            error: f.error,
            file: f.file,
            previewUrl: f.previewUrl,
            badge: f.badge,
            removable: f.removable,
            replaceable: f.replaceable,
            trailing: f.trailing,
            busy: busy,
            disabled: disabled,
            phaseLabels: phaseLabels,
            removeLabel: removeLabel,
            retryLabel: retryLabel,
            replaceLabel: replaceLabel,
            onRemove: onRemove ? ()=>onRemove(f.id) : undefined,
            onRetry: onRetry ? ()=>onRetry(f.id) : undefined,
            onReplace: onReplace ? ()=>{
                if (inert) return;
                replaceTarget.current = f.id;
                replaceRef.current?.click();
            } : undefined,
            "data-testid": testId ? `${testId}-row-${f.id}` : undefined
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId,
        "data-state": state,
        "data-busy": busy || undefined,
        className: className,
        style: style,
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        label: label,
        required: required,
        htmlFor: zoneId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "flex flex-col",
        style: {
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('frame'),
        onDragEnter: onDragEnter,
        onDragOver: onDragOver,
        onDragLeave: onDragLeave,
        onDrop: onDrop,
        className: "flex flex-col items-center",
        style: {
            gap: '0.625rem',
            paddingBlock: S.padBlock,
            paddingInline: '1rem',
            borderRadius: (0, $jTCZr.RADIUS).control,
            border: `1.5px dashed ${accentOn ? (0, $jTCZr.CT).accent : (0, $jTCZr.C).border}`,
            background: accentOn ? (0, $jTCZr.soft)((0, $jTCZr.CT).accent, 0.06) : (0, $jTCZr.CT).surface2,
            opacity: disabled ? 0.55 : 1,
            cursor: disabled ? 'not-allowed' : undefined,
            transition: 'border-color 0.15s, background 0.15s'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        id: zoneId,
        type: "button",
        "data-testid": tid('zone'),
        onClick: open(mainRef),
        disabled: disabled,
        "aria-disabled": busy || undefined,
        "aria-describedby": describedBy,
        className: "flex w-full flex-col items-center text-center outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-md",
        style: {
            gap: '0.375rem',
            background: 'transparent',
            border: 'none',
            padding: '0.25rem',
            cursor: inert ? disabled ? 'not-allowed' : 'default' : 'pointer',
            font: 'inherit',
            color: (0, $jTCZr.C).textSecondary
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $he6AI.default), {
        "aria-hidden": true,
        size: S.icon,
        strokeWidth: 1.5,
        color: accentOn ? (0, $jTCZr.CT).accent : (0, $jTCZr.C).textMuted
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.8125rem',
            fontWeight: 600
        }
    }, accentOn ? draggingLabel : dropLabel), emptyHint && files.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.75rem',
            color: (0, $jTCZr.C).textMuted
        }
    }, emptyHint) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "flex flex-wrap items-center justify-center",
        style: {
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        ...pickerProps,
        onClick: open(mainRef),
        "data-testid": tid('pick')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $he6AI.default), {
        "aria-hidden": true,
        size: 14
    }), pickLabel), capture ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        ...pickerProps,
        onClick: open(cameraRef),
        "data-testid": tid('camera-button')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fzlbJ.default), {
        "aria-hidden": true,
        size: 14
    }), cameraLabel) : null, directory ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        ...pickerProps,
        onClick: open(directoryRef),
        "data-testid": tid('directory-button')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8jE1c.default), {
        "aria-hidden": true,
        size: 14
    }), directoryLabel) : null, typeof extraActions === 'function' ? extraActions({
        openPicker: open(mainRef),
        openCamera: capture ? open(cameraRef) : undefined,
        openDirectory: directory ? open(directoryRef) : undefined,
        labels: {
            pick: pickLabel,
            camera: cameraLabel,
            directory: directoryLabel
        },
        disabled: inert
    }) : extraActions), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ref: mainRef,
        type: "file",
        className: "sr-only",
        tabIndex: -1,
        "aria-label": pickLabel,
        accept: $ad7c85561d054b68$var$acceptAttr(accept),
        multiple: multiple,
        disabled: disabled,
        onChange: onInputChange('picker'),
        "data-testid": tid('input')
    }), capture ? // A SEPARATE input: `capture` on the main one makes iOS skip the
    // gallery entirely.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ref: cameraRef,
        type: "file",
        className: "sr-only",
        tabIndex: -1,
        "aria-label": cameraLabel,
        accept: "image/*",
        capture: capture,
        disabled: disabled,
        onChange: onInputChange('camera'),
        "data-testid": tid('camera')
    }) : null, directory ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ref: directoryRef,
        type: "file",
        className: "sr-only",
        tabIndex: -1,
        "aria-label": directoryLabel,
        multiple: true,
        disabled: disabled,
        onChange: onInputChange('directory'),
        "data-testid": tid('directory')
    }) : null, typeof onReplace === 'function' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ref: replaceRef,
        type: "file",
        className: "sr-only",
        tabIndex: -1,
        "aria-label": replaceLabel,
        accept: $ad7c85561d054b68$var$acceptAttr(accept),
        disabled: disabled,
        onChange: onReplaceChange,
        "data-testid": tid('replace-input')
    }) : null), helperText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        id: helperId,
        className: "m-0",
        style: {
            fontSize: '0.71875rem',
            color: (0, $jTCZr.C).textMuted,
            lineHeight: 1.5
        }
    }, helperText) : null, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        id: errorId,
        key: String(error),
        role: "alert",
        className: "m-0",
        style: {
            fontSize: '0.71875rem',
            color: (0, $jTCZr.CT).dangerInk,
            fontWeight: 500,
            lineHeight: 1.5
        }
    }, error) : null, Array.isArray(groups) ? groups.map((g)=>{
        const rows = Array.isArray(g.files) ? g.files : [];
        const headingId = `${baseId}-group-${g.id}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
            key: g.id,
            "aria-labelledby": headingId,
            "data-testid": tid(`group-${g.id}`),
            "data-state": rows.length ? 'has-files' : 'empty',
            className: "flex flex-col",
            style: {
                gap: '0.375rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "flex items-baseline",
            style: {
                gap: '0.5rem',
                minWidth: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            id: headingId,
            style: {
                fontSize: '0.75rem',
                fontWeight: 700,
                color: (0, $jTCZr.C).textSecondary,
                lineHeight: 1.5
            }
        }, g.title), g.meta ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.6875rem',
                color: (0, $jTCZr.C).textMuted,
                lineHeight: 1.5
            }
        }, g.meta) : null), rows.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
            "aria-labelledby": headingId,
            className: "m-0 flex list-none flex-col p-0",
            style: {
                gap: '0.375rem'
            }
        }, rows.map(renderRow)) : g.emptyText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
            className: "m-0",
            style: {
                fontSize: '0.71875rem',
                color: (0, $jTCZr.C).textMuted,
                lineHeight: 1.5
            }
        }, g.emptyText) : null);
    }) : files.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        "aria-label": listLabel || (typeof label === 'string' ? label : undefined),
        className: "m-0 flex list-none flex-col p-0",
        style: {
            gap: '0.375rem'
        }
    }, files.map(renderRow)) : null)));
}

});
parcelRegister("fzlbJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5401c97ba566f60e$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $5401c97ba566f60e$export$a2387ed3b5d536eb = {
    name: "camera",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M13.997 4a2 2 0 0 1 1.76 1.05l.486.9A2 2 0 0 0 18.003 7H20a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h1.997a2 2 0 0 0 1.759-1.048l.489-.904A2 2 0 0 1 10.004 4z",
                key: "18u6gg"
            }
        ],
        [
            "circle",
            {
                cx: "12",
                cy: "13",
                r: "3",
                key: "1vg3eu"
            }
        ]
    ]
};
$5401c97ba566f60e$export$a2387ed3b5d536eb.node;
const $5401c97ba566f60e$export$2e2bcd8739ae039 = (0, $9QBug.default)($5401c97ba566f60e$export$a2387ed3b5d536eb);

});

parcelRegister("3FyOw", function(module, exports) {

$parcel$export(module.exports, "default", () => $df9771111904a5d5$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $df9771111904a5d5$export$a2387ed3b5d536eb = {
    name: "file-text",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
                key: "1oefj6"
            }
        ],
        [
            "path",
            {
                d: "M14 2v5a1 1 0 0 0 1 1h5",
                key: "wfsgrz"
            }
        ],
        [
            "path",
            {
                d: "M10 9H8",
                key: "b1mrlr"
            }
        ],
        [
            "path",
            {
                d: "M16 13H8",
                key: "t4e002"
            }
        ],
        [
            "path",
            {
                d: "M16 17H8",
                key: "z1uh3a"
            }
        ]
    ]
};
$df9771111904a5d5$export$a2387ed3b5d536eb.node;
const $df9771111904a5d5$export$2e2bcd8739ae039 = (0, $9QBug.default)($df9771111904a5d5$export$a2387ed3b5d536eb);

});

parcelRegister("8jE1c", function(module, exports) {

$parcel$export(module.exports, "default", () => $8745eaf007923a88$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $8745eaf007923a88$export$a2387ed3b5d536eb = {
    name: "folder-open",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2",
                key: "usdka0"
            }
        ]
    ]
};
$8745eaf007923a88$export$a2387ed3b5d536eb.node;
const $8745eaf007923a88$export$2e2bcd8739ae039 = (0, $9QBug.default)($8745eaf007923a88$export$a2387ed3b5d536eb);

});

parcelRegister("he6AI", function(module, exports) {

$parcel$export(module.exports, "default", () => $557120626e51c22d$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $557120626e51c22d$export$a2387ed3b5d536eb = {
    name: "upload",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M12 3v12",
                key: "1x0j5s"
            }
        ],
        [
            "path",
            {
                d: "m17 8-5-5-5 5",
                key: "7q97r8"
            }
        ],
        [
            "path",
            {
                d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4",
                key: "ih7n3h"
            }
        ]
    ]
};
$557120626e51c22d$export$a2387ed3b5d536eb.node;
const $557120626e51c22d$export$2e2bcd8739ae039 = (0, $9QBug.default)($557120626e51c22d$export$a2387ed3b5d536eb);

});


parcelRegister("bhQd4", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb5da664f84994ea$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $2WFPf = parcelRequire("2WFPf");
var $azOWV = parcelRequire("azOWV");
var $6ivsH = parcelRequire("6ivsH");
var $47abO = parcelRequire("47abO");
var $bU80g = parcelRequire("bU80g");

var $aJ1FU = parcelRequire("aJ1FU");

var $5MbI8 = parcelRequire("5MbI8");

var $fYgeo = parcelRequire("fYgeo");

var $7gSBD = parcelRequire("7gSBD");

var $2vXUl = parcelRequire("2vXUl");

var $hZDga = parcelRequire("hZDga");

var $66joL = parcelRequire("66joL");

var $jTCZr = parcelRequire("jTCZr");

var $5JYPc = parcelRequire("5JYPc");

var $j9AxR = parcelRequire("j9AxR");

var $IZwml = parcelRequire("IZwml");
'use client';
function $cb5da664f84994ea$export$bb0048c9149cbdb(locale) {
    const copy = (0, $j9AxR.kitCopy)(locale).imageStack;
    const { digits: digits } = (0, $IZwml.datePickerLocale)(locale);
    return {
        ...copy,
        frame: (i, n)=>copy.frame((0, $IZwml.withDigits)(i, digits), (0, $IZwml.withDigits)(n, digits))
    };
}
const $cb5da664f84994ea$export$eb119caddc05b7a2 = $cb5da664f84994ea$export$bb0048c9149cbdb('fa');
const $cb5da664f84994ea$var$MIN_ZOOM = 1;
const $cb5da664f84994ea$var$MAX_ZOOM = 8;
const $cb5da664f84994ea$var$ZOOM_STEP = 1.25;
// Pixels of wheel delta / finger travel per frame. Interaction thresholds,
// not layout — they never reach a style.
const $cb5da664f84994ea$var$WHEEL_PER_FRAME = 60;
const $cb5da664f84994ea$var$SWIPE_PER_FRAME = 24;
const $cb5da664f84994ea$var$DOUBLE_TAP_MS = 300;
// ≥ 2.75rem on a coarse pointer (MOBILE_WEB_PWA §5).
const $cb5da664f84994ea$var$TOUCH_TARGET = '[@media(pointer:coarse)]:min-h-[2.75rem]';
const $cb5da664f84994ea$var$clamp = (v, lo, hi)=>Math.max(lo, Math.min(hi, v));
function $cb5da664f84994ea$export$2e2bcd8739ae039({ frameCount: frameCount = 0, index: indexProp, defaultIndex: defaultIndex = 0, onIndexChange: onIndexChange, loadFrame: loadFrame, revokeFrame: revokeFrame, preloadRadius: preloadRadius = 5, sourceKey: sourceKey, series: series, activeSeriesId: activeSeriesId, onSeriesChange: onSeriesChange, presets: presets, activePresetId: activePresetId, onPresetChange: onPresetChange, caption: caption, banner: banner, loading: loading = false, error: error, onRetry: onRetry, labels: labelsProp, className: className, style: style, 'data-testid': testId, ...rest }) {
    const labels = {
        ...$cb5da664f84994ea$export$bb0048c9149cbdb(),
        ...labelsProp
    };
    const tid = (suffix)=>testId ? `${testId}-${suffix}` : undefined;
    const n = Math.max(0, Math.floor(Number(frameCount) || 0));
    // ── index: controlled when `index` is given, otherwise internal ───────────
    const [innerIndex, setInnerIndex] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(defaultIndex);
    const controlled = indexProp !== undefined && indexProp !== null;
    const index = n ? $cb5da664f84994ea$var$clamp(Math.floor(controlled ? indexProp : innerIndex) || 0, 0, n - 1) : 0;
    const indexRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(index);
    indexRef.current = index;
    const go = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((next)=>{
        if (!n) return;
        const target = $cb5da664f84994ea$var$clamp(Math.round(next), 0, n - 1);
        if (target === indexRef.current) return;
        if (!controlled) setInnerIndex(target);
        onIndexChange?.(target);
    }, [
        n,
        controlled,
        onIndexChange
    ]);
    // ── frame cache ───────────────────────────────────────────────────────────
    const loadRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(loadFrame);
    loadRef.current = loadFrame;
    const revokeRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(revokeFrame);
    revokeRef.current = revokeFrame;
    const cache = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Map()); // i → url
    const pending = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Map()); // i → AbortController
    const failed = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Set()); // i
    const shownRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null); // url on screen
    const [, bump] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useReducer((x)=>x + 1, 0);
    const [shownUrl, setShownUrl] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [, setRetryTick] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    const release = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((url)=>{
        if (!url || url === shownRef.current) return;
        revokeRef.current?.(url);
    }, []);
    const source = `${activeSeriesId ?? ''}|${activePresetId ?? ''}|${n}|${sourceKey ?? ''}`;
    const sourceRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(source);
    // A new source: cancel everything in flight and forget every frame. The
    // shown image stays up (under a spinner) until its replacement arrives.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (sourceRef.current === source) return;
        sourceRef.current = source;
        for (const ctrl of pending.current.values())ctrl.abort();
        pending.current.clear();
        for (const url of cache.current.values())release(url);
        cache.current.clear();
        failed.current.clear();
        bump();
    }, [
        source,
        release
    ]);
    // Load the current frame and its neighbours; evict what fell out.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!n || typeof loadRef.current !== 'function' || loading || error) return;
        const lo = Math.max(0, index - preloadRadius);
        const hi = Math.min(n - 1, index + preloadRadius);
        for (const [i, ctrl] of pending.current)if (i < lo || i > hi) {
            ctrl.abort();
            pending.current.delete(i);
        }
        for (const [i, url] of cache.current)if (i < lo || i > hi) {
            cache.current.delete(i);
            release(url);
        }
        for (const i of failed.current)if (i < lo || i > hi) failed.current.delete(i);
        // Current frame first, then outward: ±1, ±2, …
        const order = [
            index
        ];
        for(let d = 1; d <= preloadRadius; d += 1){
            if (index + d <= hi) order.push(index + d);
            if (index - d >= lo) order.push(index - d);
        }
        const mySource = sourceRef.current;
        for (const i of order){
            if (cache.current.has(i) || pending.current.has(i) || failed.current.has(i)) continue;
            const ctrl = typeof AbortController !== 'undefined' ? new AbortController() : {
                abort () {},
                signal: undefined
            };
            pending.current.set(i, ctrl);
            let p;
            try {
                p = Promise.resolve(loadRef.current(i, {
                    signal: ctrl.signal
                }));
            } catch (e) {
                p = Promise.reject(e);
            }
            p.then((url)=>{
                const stale = ctrl.signal?.aborted || sourceRef.current !== mySource || pending.current.get(i) !== ctrl;
                if (stale) {
                    if (url) revokeRef.current?.(url);
                    return;
                }
                pending.current.delete(i);
                cache.current.set(i, url);
                bump();
            }, ()=>{
                const stale = ctrl.signal?.aborted || sourceRef.current !== mySource || pending.current.get(i) !== ctrl;
                if (stale) return;
                pending.current.delete(i);
                failed.current.add(i);
                bump();
            });
        }
    });
    // Show the current frame as soon as it is cached; revoke what it replaced.
    const currentUrl = cache.current.get(index) ?? null;
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!currentUrl || currentUrl === shownRef.current) return;
        const previous = shownRef.current;
        shownRef.current = currentUrl;
        setShownUrl(currentUrl);
        if (previous && ![
            ...cache.current.values()
        ].includes(previous)) revokeRef.current?.(previous);
    }, [
        currentUrl
    ]);
    // Unmount: cancel, and hand back every URL still held.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>()=>{
            for (const ctrl of pending.current.values())ctrl.abort();
            pending.current.clear();
            const urls = new Set([
                ...cache.current.values(),
                shownRef.current
            ].filter(Boolean));
            cache.current.clear();
            shownRef.current = null;
            for (const url of urls)revokeRef.current?.(url);
        }, []);
    const retryFrame = ()=>{
        failed.current.delete(index);
        setRetryTick((t)=>t + 1);
    };
    const frameState = failed.current.has(index) ? 'error' : currentUrl ? 'ready' : 'loading';
    // ── zoom & pan ────────────────────────────────────────────────────────────
    const [zoom, setZoom] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(1);
    const [pan, setPan] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        x: 0,
        y: 0
    });
    const stageRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const clampPan = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((p, z)=>{
        const rect = stageRef.current?.getBoundingClientRect?.();
        if (!rect || !rect.width || !rect.height) return z <= 1 ? {
            x: 0,
            y: 0
        } : p;
        const mx = (z - 1) * rect.width / 2;
        const my = (z - 1) * rect.height / 2;
        return {
            x: $cb5da664f84994ea$var$clamp(p.x, -mx, mx),
            y: $cb5da664f84994ea$var$clamp(p.y, -my, my)
        };
    }, []);
    const zoomTo = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((z)=>{
        const next = $cb5da664f84994ea$var$clamp(z, $cb5da664f84994ea$var$MIN_ZOOM, $cb5da664f84994ea$var$MAX_ZOOM);
        setZoom(next);
        setPan((p)=>next <= 1 ? {
                x: 0,
                y: 0
            } : clampPan(p, next));
    }, [
        clampPan
    ]);
    const resetView = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        setZoom(1);
        setPan({
            x: 0,
            y: 0
        });
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        resetView();
    }, [
        activeSeriesId,
        resetView
    ]);
    // Latest values for the native listeners below.
    const live = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef({});
    live.current = {
        zoom: zoom,
        go: go,
        index: index,
        zoomTo: zoomTo
    };
    // Wheel needs a non-passive listener to keep the page from scrolling.
    const wheelAcc = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(0);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const el = stageRef.current;
        if (!el) return undefined;
        const onWheel = (e)=>{
            e.preventDefault();
            const L = live.current;
            if (e.ctrlKey || e.metaKey) {
                L.zoomTo(L.zoom * (e.deltaY < 0 ? $cb5da664f84994ea$var$ZOOM_STEP : 1 / $cb5da664f84994ea$var$ZOOM_STEP));
                return;
            }
            // Line/page deltas (a notched mouse on some platforms) step one frame
            // per event; pixel deltas (trackpads) accumulate.
            if (e.deltaMode !== 0) {
                wheelAcc.current = 0;
                if (e.deltaY) L.go(L.index + Math.sign(e.deltaY));
                return;
            }
            wheelAcc.current += e.deltaY;
            const steps = Math.trunc(wheelAcc.current / $cb5da664f84994ea$var$WHEEL_PER_FRAME);
            if (steps) {
                wheelAcc.current -= steps * $cb5da664f84994ea$var$WHEEL_PER_FRAME;
                L.go(L.index + steps);
            }
        };
        el.addEventListener('wheel', onWheel, {
            passive: false
        });
        return ()=>el.removeEventListener('wheel', onWheel);
    });
    // Pointers: one finger pans (zoomed) or swipes frames (not zoomed); two pinch.
    const pointers = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Map());
    const gesture = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const lastTap = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(0);
    const onPointerDown = (e)=>{
        pointers.current.set(e.pointerId, {
            x: e.clientX,
            y: e.clientY
        });
        try {
            e.currentTarget.setPointerCapture?.(e.pointerId);
        } catch  {}
        const pts = [
            ...pointers.current.values()
        ];
        if (pts.length === 2) gesture.current = {
            kind: 'pinch',
            dist: Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y) || 1,
            zoom: zoom
        };
        else if (pts.length === 1) gesture.current = zoom > 1 ? {
            kind: 'pan',
            x: e.clientX,
            y: e.clientY,
            pan: pan
        } : {
            kind: 'swipe',
            y: e.clientY,
            index: index
        };
    };
    const onPointerMove = (e)=>{
        if (!pointers.current.has(e.pointerId)) return;
        pointers.current.set(e.pointerId, {
            x: e.clientX,
            y: e.clientY
        });
        const g = gesture.current;
        if (!g) return;
        if (g.kind === 'pinch') {
            const pts = [
                ...pointers.current.values()
            ];
            if (pts.length < 2) return;
            const dist = Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y);
            zoomTo(g.zoom * (dist / g.dist));
        } else if (g.kind === 'pan') setPan(clampPan({
            x: g.pan.x + (e.clientX - g.x),
            y: g.pan.y + (e.clientY - g.y)
        }, zoom));
        else if (g.kind === 'swipe') {
            // Finger up = next frame, like scrolling a page of film.
            const steps = Math.trunc((g.y - e.clientY) / $cb5da664f84994ea$var$SWIPE_PER_FRAME);
            go(g.index + steps);
        }
    };
    const onPointerUp = (e)=>{
        pointers.current.delete(e.pointerId);
        if (pointers.current.size === 0) {
            if (e.pointerType === 'touch') {
                const now = Date.now();
                if (now - lastTap.current < $cb5da664f84994ea$var$DOUBLE_TAP_MS) {
                    resetView();
                    lastTap.current = 0;
                } else lastTap.current = now;
            }
            gesture.current = null;
        } else if (pointers.current.size === 1) {
            const [pt] = [
                ...pointers.current.values()
            ];
            gesture.current = zoom > 1 ? {
                kind: 'pan',
                x: pt.x,
                y: pt.y,
                pan: pan
            } : null;
        }
    };
    const onKeyDown = (e)=>{
        switch(e.key){
            case 'ArrowUp':
            case 'PageUp':
                go(index - 1);
                break;
            case 'ArrowDown':
            case 'PageDown':
                go(index + 1);
                break;
            case 'Home':
                go(0);
                break;
            case 'End':
                go(n - 1);
                break;
            case '+':
            case '=':
                zoomTo(zoom * $cb5da664f84994ea$var$ZOOM_STEP);
                break;
            case '-':
            case '_':
                zoomTo(zoom / $cb5da664f84994ea$var$ZOOM_STEP);
                break;
            case '0':
                resetView();
                break;
            default:
                return;
        }
        e.preventDefault();
    };
    // ── states ────────────────────────────────────────────────────────────────
    const state = loading ? 'loading' : error ? 'error' : n === 0 ? 'empty' : 'content';
    const frameText = n ? labels.frame(index + 1, n) : '';
    const canvasStyle = {
        position: 'relative',
        width: '100%',
        aspectRatio: '1 / 1',
        maxHeight: '70dvh',
        maxWidth: '100%',
        borderRadius: (0, $jTCZr.RADIUS).card,
        background: (0, $jTCZr.CT).ink,
        overflow: 'hidden'
    };
    const seriesStrip = Array.isArray(series) && series.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "group",
        "aria-label": labels.series,
        "data-testid": tid('series'),
        className: "flex",
        style: {
            gap: '0.5rem',
            overflowX: 'auto',
            paddingBlock: '0.125rem',
            scrollbarWidth: 'thin'
        }
    }, series.map((s)=>{
        const active = s.id === activeSeriesId;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: s.id,
            type: "button",
            "aria-pressed": active,
            "data-state": active ? 'active' : 'inactive',
            "data-testid": tid(`series-${s.id}`),
            onClick: ()=>{
                if (!active) onSeriesChange?.(s.id);
            },
            className: (0, $5JYPc.cn)('inline-flex items-center outline-none focus-visible:ring-2 focus-visible:ring-ring', $cb5da664f84994ea$var$TOUCH_TARGET),
            style: {
                flexShrink: 0,
                gap: '0.375rem',
                minHeight: '2.25rem',
                paddingInline: '0.75rem',
                paddingBlock: '0.25rem',
                borderRadius: (0, $jTCZr.RADIUS).control,
                border: `1px solid ${active ? (0, $jTCZr.CT).accent : (0, $jTCZr.C).border}`,
                background: active ? (0, $jTCZr.soft)((0, $jTCZr.CT).accent, 0.1) : (0, $jTCZr.C).card,
                color: active ? (0, $jTCZr.CT).accentInk : (0, $jTCZr.C).textSecondary,
                font: 'inherit',
                fontSize: '0.75rem',
                fontWeight: 600,
                cursor: 'pointer',
                whiteSpace: 'nowrap'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "auto",
            style: {
                unicodeBidi: 'isolate'
            }
        }, s.label), s.badge != null && s.badge !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.625rem',
                fontWeight: 700,
                color: (0, $jTCZr.C).textMuted,
                background: (0, $jTCZr.C).bg,
                borderRadius: (0, $jTCZr.RADIUS).chip,
                paddingInline: '0.3125rem'
            }
        }, s.badge) : null);
    })) : null;
    const presetControl = Array.isArray(presets) && presets.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('presets'),
        style: {
            maxWidth: '100%',
            overflowX: 'auto'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fYgeo.default), {
        semantics: "filter",
        size: "lg",
        ariaLabel: labels.presets,
        options: presets.map((p)=>({
                value: p.id,
                label: p.label
            })),
        value: activePresetId,
        onChange: (id)=>{
            if (id !== activePresetId) onPresetChange?.(id);
        }
    })) : null;
    let body;
    if (state === 'loading') body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonRegion), {
        label: labels.loading,
        "data-testid": tid('loading'),
        className: "flex flex-col",
        style: {
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.Skeleton), {
        height: "auto",
        radius: (0, $jTCZr.RADIUS).card,
        style: {
            ...canvasStyle,
            background: undefined
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.Skeleton), {
        height: "2.75rem",
        radius: (0, $jTCZr.RADIUS).control
    }));
    else if (state === 'error') body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2vXUl.default), {
        "data-testid": tid('error'),
        title: typeof error === 'string' ? error : labels.error,
        onRetry: onRetry,
        retryLabel: labels.retry
    });
    else if (state === 'empty') body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        "data-testid": tid('empty'),
        title: labels.empty
    });
    else {
        const transform = `translate(${pan.x}px, ${pan.y}px) scale(${zoom})`;
        body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            ref: stageRef,
            role: "img",
            "aria-roledescription": labels.viewport,
            "aria-label": frameText,
            tabIndex: 0,
            "data-testid": tid('stage'),
            "data-frame-state": frameState,
            "data-zoom": String(Math.round(zoom * 100) / 100),
            onKeyDown: onKeyDown,
            onPointerDown: onPointerDown,
            onPointerMove: onPointerMove,
            onPointerUp: onPointerUp,
            onPointerCancel: onPointerUp,
            onDoubleClick: resetView,
            className: "outline-none focus-visible:ring-2 focus-visible:ring-ring",
            style: {
                ...canvasStyle,
                touchAction: 'none',
                userSelect: 'none',
                cursor: zoom > 1 ? 'grab' : 'ns-resize'
            }
        }, shownUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
            src: shownUrl,
            alt: "",
            draggable: false,
            "data-testid": tid('image'),
            style: {
                position: 'absolute',
                insetBlock: 0,
                insetInline: 0,
                width: '100%',
                height: '100%',
                objectFit: 'contain',
                transform: transform,
                transformOrigin: 'center',
                opacity: frameState === 'ready' ? 1 : 0.6,
                pointerEvents: 'none'
            }
        }) : frameState === 'loading' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.Skeleton), {
            tone: "onDark",
            width: "100%",
            height: "100%",
            radius: 0,
            style: {
                position: 'absolute',
                insetBlock: 0,
                insetInline: 0
            }
        }) : null, frameState === 'loading' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "data-testid": tid('frame-loading'),
            className: "flex items-center justify-center",
            style: {
                position: 'absolute',
                insetBlock: 0,
                insetInline: 0,
                pointerEvents: 'none'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
            size: 28,
            color: (0, $jTCZr.C).card,
            label: labels.loading
        })) : null, frameState === 'error' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": tid('frame-error'),
            className: "flex flex-col items-center justify-center text-center",
            style: {
                position: 'absolute',
                insetBlock: 0,
                insetInline: 0,
                gap: '0.75rem',
                paddingInline: '1rem',
                background: (0, $jTCZr.soft)((0, $jTCZr.CT).ink, 0.7),
                color: (0, $jTCZr.C).card
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            role: "alert",
            style: {
                fontSize: '0.8125rem',
                fontWeight: 600
            }
        }, labels.error), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            type: "button",
            variant: "outline",
            size: "sm",
            className: $cb5da664f84994ea$var$TOUCH_TARGET,
            onClick: retryFrame,
            "data-testid": tid('frame-retry')
        }, labels.retry)) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "flex flex-wrap items-center",
            style: {
                gap: '0.5rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5MbI8.default), {
            variant: "outline",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $azOWV.default), {
                size: 18,
                "aria-hidden": true
            }),
            label: labels.prev,
            onClick: ()=>go(index - 1),
            disabled: index <= 0,
            "data-testid": tid('prev')
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
            type: "range",
            min: 0,
            max: Math.max(0, n - 1),
            step: 1,
            value: index,
            "aria-label": labels.slider,
            "aria-valuetext": frameText,
            onChange: (e)=>go(Number(e.target.value)),
            disabled: n <= 1,
            "data-testid": tid('slider'),
            className: (0, $5JYPc.cn)('outline-none focus-visible:ring-2 focus-visible:ring-ring', $cb5da664f84994ea$var$TOUCH_TARGET),
            style: {
                flex: '1 1 8rem',
                minWidth: 0,
                minHeight: '2.25rem',
                accentColor: (0, $jTCZr.CT).accent
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5MbI8.default), {
            variant: "outline",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2WFPf.default), {
                size: 18,
                "aria-hidden": true
            }),
            label: labels.next,
            onClick: ()=>go(index + 1),
            disabled: index >= n - 1,
            "data-testid": tid('next')
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "aria-live": "polite",
            "aria-atomic": "true",
            "data-testid": tid('counter'),
            className: "tabular-nums",
            style: {
                fontSize: '0.75rem',
                fontWeight: 600,
                color: (0, $jTCZr.C).textSecondary,
                whiteSpace: 'nowrap'
            }
        }, frameText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "flex items-center",
            style: {
                gap: '0.25rem',
                marginInlineStart: 'auto'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5MbI8.default), {
            variant: "ghost",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bU80g.default), {
                size: 18,
                "aria-hidden": true
            }),
            label: labels.zoomOut,
            onClick: ()=>zoomTo(zoom / $cb5da664f84994ea$var$ZOOM_STEP),
            disabled: zoom <= $cb5da664f84994ea$var$MIN_ZOOM,
            "data-testid": tid('zoom-out')
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5MbI8.default), {
            variant: "ghost",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $47abO.default), {
                size: 18,
                "aria-hidden": true
            }),
            label: labels.zoomIn,
            onClick: ()=>zoomTo(zoom * $cb5da664f84994ea$var$ZOOM_STEP),
            disabled: zoom >= $cb5da664f84994ea$var$MAX_ZOOM,
            "data-testid": tid('zoom-in')
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5MbI8.default), {
            variant: "ghost",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6ivsH.default), {
                size: 18,
                "aria-hidden": true
            }),
            label: labels.reset,
            onClick: resetView,
            disabled: zoom === 1 && pan.x === 0 && pan.y === 0,
            "data-testid": tid('reset')
        }))));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId,
        "data-state": state,
        className: (0, $5JYPc.cn)('flex flex-col', className),
        style: {
            gap: '0.625rem',
            minWidth: 0,
            ...style
        },
        ...rest
    }, banner, state !== 'loading' ? seriesStrip : null, state !== 'loading' ? presetControl : null, body, caption ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        className: "m-0",
        style: {
            fontSize: '0.71875rem',
            color: (0, $jTCZr.C).textMuted,
            lineHeight: 1.5
        }
    }, caption) : null);
}

});
parcelRegister("6ivsH", function(module, exports) {

$parcel$export(module.exports, "default", () => $c96e72789512f0bb$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $c96e72789512f0bb$export$a2387ed3b5d536eb = {
    name: "maximize",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M8 3H5a2 2 0 0 0-2 2v3",
                key: "1dcmit"
            }
        ],
        [
            "path",
            {
                d: "M21 8V5a2 2 0 0 0-2-2h-3",
                key: "1e4gt3"
            }
        ],
        [
            "path",
            {
                d: "M3 16v3a2 2 0 0 0 2 2h3",
                key: "wsl5sc"
            }
        ],
        [
            "path",
            {
                d: "M16 21h3a2 2 0 0 0 2-2v-3",
                key: "18trek"
            }
        ]
    ]
};
$c96e72789512f0bb$export$a2387ed3b5d536eb.node;
const $c96e72789512f0bb$export$2e2bcd8739ae039 = (0, $9QBug.default)($c96e72789512f0bb$export$a2387ed3b5d536eb);

});

parcelRegister("47abO", function(module, exports) {

$parcel$export(module.exports, "default", () => $191016e022d4d457$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $191016e022d4d457$export$a2387ed3b5d536eb = {
    name: "zoom-in",
    size: 24,
    node: [
        [
            "circle",
            {
                cx: "11",
                cy: "11",
                r: "8",
                key: "4ej97u"
            }
        ],
        [
            "line",
            {
                x1: "21",
                x2: "16.65",
                y1: "21",
                y2: "16.65",
                key: "13gj7c"
            }
        ],
        [
            "line",
            {
                x1: "11",
                x2: "11",
                y1: "8",
                y2: "14",
                key: "1vmskp"
            }
        ],
        [
            "line",
            {
                x1: "8",
                x2: "14",
                y1: "11",
                y2: "11",
                key: "durymu"
            }
        ]
    ]
};
$191016e022d4d457$export$a2387ed3b5d536eb.node;
const $191016e022d4d457$export$2e2bcd8739ae039 = (0, $9QBug.default)($191016e022d4d457$export$a2387ed3b5d536eb);

});

parcelRegister("bU80g", function(module, exports) {

$parcel$export(module.exports, "default", () => $a481aded68921702$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $a481aded68921702$export$a2387ed3b5d536eb = {
    name: "zoom-out",
    size: 24,
    node: [
        [
            "circle",
            {
                cx: "11",
                cy: "11",
                r: "8",
                key: "4ej97u"
            }
        ],
        [
            "line",
            {
                x1: "21",
                x2: "16.65",
                y1: "21",
                y2: "16.65",
                key: "13gj7c"
            }
        ],
        [
            "line",
            {
                x1: "8",
                x2: "14",
                y1: "11",
                y2: "11",
                key: "durymu"
            }
        ]
    ]
};
$a481aded68921702$export$a2387ed3b5d536eb.node;
const $a481aded68921702$export$2e2bcd8739ae039 = (0, $9QBug.default)($a481aded68921702$export$a2387ed3b5d536eb);

});


parcelRegister("h4ZeB", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f5f0e3d96e18162$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $aJ1FU = parcelRequire("aJ1FU");

var $5JYPc = parcelRequire("5JYPc");
'use client';
// ─────────────────────────────────────────────────────────────────────────────
// FilterChip — one toggleable filter in a chip row (category, type, status).
//
// Distinct from `ChipSelector`, which is a *form field* (label, validation,
// helper text, a value the user submits). This is a **view filter**: it narrows
// what a list shows, lives in a toolbar rather than a form, and reports its
// state through `aria-pressed` — the correct semantics for a toggle button, and
// the reason the two are not one component.
//
// Sized for touch by default (`min-h-11` = 2.75rem), because the phone is where
// chip rows are used most and a sub-44px target is a defect there. `count` is a
// node, not a number, so the caller formats digits in its own locale.
// ─────────────────────────────────────────────────────────────────────────────
const $4f5f0e3d96e18162$var$FilterChip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ label: label, count: count, active: active = false, onClick: onClick, disabled: disabled, className: className, children: children, ...rest }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        ref: ref,
        type: "button",
        variant: active ? 'subtle' : 'outline',
        size: "sm",
        "aria-pressed": active,
        disabled: disabled,
        onClick: onClick,
        "data-state": active ? 'active' : 'inactive',
        className: (0, $5JYPc.cn)('min-h-11 shrink-0 rounded-full gap-1', className),
        ...rest
    }, label ?? children, count != null && count !== '' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "text-[0.625rem] opacity-70"
    }, "(", count, ")")));
$4f5f0e3d96e18162$var$FilterChip.displayName = 'FilterChip';
var $4f5f0e3d96e18162$export$2e2bcd8739ae039 = $4f5f0e3d96e18162$var$FilterChip;

});

parcelRegister("cRmgx", function(module, exports) {

var $acw62 = parcelRequire("acw62");

var $6Md3F = parcelRequire("6Md3F");
var $3SiwN = parcelRequire("3SiwN");
var $2rN5o = parcelRequire("2rN5o");

var $jTCZr = parcelRequire("jTCZr");

var $aJ1FU = parcelRequire("aJ1FU");

var $cZOyb = parcelRequire("cZOyb");

var $awevB = parcelRequire("awevB");

var $4Qco3 = parcelRequire("4Qco3");

var $dlbmi = parcelRequire("dlbmi");

var $j9AxR = parcelRequire("j9AxR");

var $IZwml = parcelRequire("IZwml");

var $k27hS = parcelRequire("k27hS");
'use client';
// ─────────────────────────────────────────────────────────────────────────────
// FilterBar — toolbar zone ④, the ONE shape a filtered list wears (PM-0494;
// DESIGN_CONCEPT §2.2 zone ④, §9.2 "Filtering — one pattern").
//
//   <FilterBar
//     label={t('encounters.filters')}
//     inline={<>                       // the two most-used controls
//       <SearchInput … />
//       <SegmentedControl semantics="filter" … />
//     </>}
//     range={{ presets, preset, custom, onPreset, onCustom }}   // optional
//     more={<>                         // the rest
//       <FilterField label=…><Select … /></FilterField>
//     </>}
//     activeCount={filters.activeCount}
//     onReset={filters.reset}
//     action={<Button>…</Button>}      // the screen's primary action, inline-end
//   />
//
// Desktop (`row`): one white card row — inline · range · more · «حذف فیلترها»
// (only when ≥ 1 filter is active) · … · action. Phone (`stack`): the inline
// controls stay in view; the range opens a BottomSheet (presets + a custom
// range applied only when both ends exist); `more` lives behind a «فیلترها»
// button badged with the active count; the clear button shows under the bar.
// `layout="auto"` (default) picks by `useResponsive()`; a `.web.jsx` /
// `.mobile.jsx` pair passes `row` / `stack` explicitly. `collapse` puts the
// row's `more` controls behind a «فیلترها» `FilterPopover` (badged) instead of
// inline — for a toolbar that would otherwise wrap to a second row (the
// clinic's «بیماران», PM-0471); `activeCount` badges it, so pass the SAME number.
//
// What the bar does NOT do: own state. Values and handlers come from the screen
// (`useFilterState`), so the same controls are wired the same whichever shell
// renders them, and `activeCount` is ONE number — the bar's badge, its clear
// button and the empty state's «حذف فیلترها» never disagree about whether a
// filter is on. Filters APPLY IMMEDIATELY (§9.2); the sheet's «نمایش نتایج»
// only closes it.
//
// Promoted from the doctor app's `MobileFilterBar` (itself generalised from
// `MobileAccountingFilters`) and the desktop toolbar row every list screen
// hand-built; the inventory under PM-0494 found eleven of them.
// ─────────────────────────────────────────────────────────────────────────────
const $ca8a96c982c5edc9$var$pageNum = (n)=>(0, $IZwml.withDigits)(String(Math.trunc(Number(n))), (0, $IZwml.datePickerLocale)().digits);
const $ca8a96c982c5edc9$var$Badge = ({ n: n })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true,
        style: {
            marginInlineStart: 'auto',
            minWidth: '1.25rem',
            height: '1.25rem',
            borderRadius: '0.75rem',
            background: (0, $jTCZr.C).navy,
            color: '#fff',
            fontSize: '0.6875rem',
            fontWeight: 800,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '0 0.375rem',
            fontVariantNumeric: 'tabular-nums'
        }
    }, $ca8a96c982c5edc9$var$pageNum(n));
function $ca8a96c982c5edc9$var$ClearButton({ onReset: onReset, label: label, testId: testId, className: className }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        type: "button",
        variant: "ghost",
        size: "sm",
        onClick: onReset,
        "data-testid": testId,
        className: `min-h-9 gap-1.5 text-muted-foreground ${className || ''}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3SiwN.default), {
        size: 15,
        "aria-hidden": true
    }), label);
}
function $ca8a96c982c5edc9$export$394dd4e110d1ef89({ label: label, children: children, style: style, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        style: {
            display: 'block',
            ...style
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.75rem',
            fontWeight: 700,
            color: (0, $jTCZr.C).textMuted,
            display: 'block',
            marginBottom: '0.375rem'
        }
    }, label), children);
}
function $ca8a96c982c5edc9$var$RangeSheet({ range: range, open: open, onClose: onClose, copy: copy, testId: testId }) {
    const { presets: presets = [], preset: preset, custom: custom = {}, onPreset: onPreset, onCustom: onCustom } = range;
    const [draft, setDraft] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        from: custom.from || '',
        to: custom.to || ''
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (open) setDraft({
            from: custom.from || '',
            to: custom.to || ''
        });
    }, [
        open,
        custom.from,
        custom.to
    ]);
    const dr = (0, $j9AxR.kitCopy)().dateRange;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: open,
        onClose: onClose,
        title: dr.title,
        "data-testid": `${testId}-range-sheet`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "radiogroup",
        "aria-label": dr.title,
        style: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: '0.5rem'
        }
    }, presets.map((p)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            key: p.id,
            type: "button",
            role: "radio",
            "aria-checked": preset === p.id,
            variant: preset === p.id ? 'default' : 'outline',
            size: "sm",
            className: "min-h-11",
            onClick: ()=>{
                onPreset?.(p.id);
                onClose();
            }
        }, p.label))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: '1rem',
            paddingTop: '1rem',
            borderTop: `1px solid ${(0, $jTCZr.C).border}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.75rem',
            fontWeight: 700,
            color: (0, $jTCZr.C).textMuted,
            marginBottom: '0.5rem'
        }
    }, dr.custom), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4Qco3.default), {
        value: draft.from,
        onChange: (v)=>setDraft((d)=>({
                    ...d,
                    from: v
                })),
        placeholder: dr.from,
        disableFuture: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4Qco3.default), {
        value: draft.to,
        onChange: (v)=>setDraft((d)=>({
                    ...d,
                    to: v
                })),
        placeholder: dr.to,
        disableFuture: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        type: "button",
        className: "mt-3 w-full min-h-11",
        disabled: !draft.from || !draft.to,
        onClick: ()=>{
            onCustom?.(draft.from, draft.to);
            onClose();
        }
    }, copy.applyRange)));
}
function $ca8a96c982c5edc9$export$2e2bcd8739ae039({ inline: inline, range: range, more: more, action: action, activeCount: activeCount = 0, onReset: onReset, label: label, resetLabel: resetLabel, moreLabel: moreLabel, sheetTitle: sheetTitle, layout: layout = 'auto', collapse: collapse = false, sticky: sticky = false, className: className, style: style, 'data-testid': testId = 'filters', ...rest }) {
    const copy = (0, $j9AxR.kitCopy)().filters;
    const { isMobile: isMobile } = (0, $k27hS.default)();
    const stacked = layout === 'stack' || layout === 'auto' && isMobile;
    const [rangeOpen, setRangeOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [moreOpen, setMoreOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const clearText = resetLabel ?? copy.clear;
    const showClear = activeCount > 0 && typeof onReset === 'function';
    const hasRange = range && Array.isArray(range.presets) && range.presets.length > 0;
    const stickyStyle = sticky ? {
        position: 'sticky',
        top: 0,
        zIndex: 5
    } : null;
    if (!stacked) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "group",
        "aria-label": label ?? copy.title,
        "data-testid": testId,
        "data-layout": "row",
        "data-active": activeCount,
        className: className,
        style: {
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: '0.75rem',
            background: (0, $jTCZr.C).card,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: 14,
            padding: '0.625rem 0.875rem',
            ...stickyStyle,
            ...style
        },
        ...rest
    }, inline, hasRange && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $awevB.default), {
        presets: range.presets,
        preset: range.preset,
        custom: range.custom || {
            from: '',
            to: ''
        },
        onPreset: range.onPreset,
        onCustom: range.onCustom
    }), more && (collapse ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dlbmi.default), {
        label: moreLabel ?? copy.title,
        count: activeCount,
        onClear: showClear ? onReset : undefined,
        clearLabel: clearText,
        "data-testid": `${testId}-more`
    }, more) : more), showClear && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ca8a96c982c5edc9$var$ClearButton, {
        onReset: onReset,
        label: clearText,
        testId: `${testId}-clear`
    }), action && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginInlineStart: 'auto',
            display: 'flex',
            gap: '0.5rem'
        }
    }, action));
    const rangeText = hasRange ? (0, $awevB.rangeLabelFor)(range.preset, range.custom?.from, range.custom?.to, range.presets) : '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "group",
        "aria-label": label ?? copy.title,
        "data-testid": testId,
        "data-layout": "stack",
        "data-active": activeCount,
        className: className,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.625rem',
            ...stickyStyle,
            ...style
        },
        ...rest
    }, inline, (hasRange || more) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: '0.5rem'
        }
    }, hasRange && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        type: "button",
        variant: "outline",
        size: "sm",
        onClick: ()=>setRangeOpen(true),
        "data-testid": `${testId}-range`,
        className: "flex-1 min-h-11 justify-start gap-1.5",
        "aria-haspopup": "dialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6Md3F.default), {
        size: 15,
        "aria-hidden": true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        }
    }, rangeText)), more && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        type: "button",
        variant: "outline",
        size: "sm",
        onClick: ()=>setMoreOpen(true),
        "data-testid": `${testId}-more`,
        className: "flex-1 min-h-11 justify-start gap-1.5",
        "aria-haspopup": "dialog",
        "aria-label": activeCount > 0 ? copy.activeCount($ca8a96c982c5edc9$var$pageNum(activeCount)) : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2rN5o.default), {
        size: 15,
        "aria-hidden": true
    }), moreLabel ?? copy.title, activeCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ca8a96c982c5edc9$var$Badge, {
        n: activeCount
    }))), action && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: '0.5rem'
        }
    }, action), showClear && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ca8a96c982c5edc9$var$ClearButton, {
        onReset: onReset,
        label: clearText,
        testId: `${testId}-clear`,
        className: "self-start min-h-11"
    }), hasRange && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ca8a96c982c5edc9$var$RangeSheet, {
        range: range,
        open: rangeOpen,
        onClose: ()=>setRangeOpen(false),
        copy: copy,
        testId: testId
    }), more && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: moreOpen,
        onClose: ()=>setMoreOpen(false),
        title: sheetTitle ?? moreLabel ?? copy.title,
        "data-testid": `${testId}-more-sheet`,
        footer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: '0.5rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            type: "button",
            className: "w-full min-h-11",
            onClick: ()=>setMoreOpen(false)
        }, copy.showResults), showClear && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            type: "button",
            variant: "ghost",
            className: "w-full min-h-11 gap-1.5 text-muted-foreground",
            onClick: ()=>{
                onReset();
                setMoreOpen(false);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3SiwN.default), {
            size: 15,
            "aria-hidden": true
        }), clearText))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.875rem'
        }
    }, more)));
}

});
parcelRegister("3SiwN", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e976e543b929c4c$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $8e976e543b929c4c$export$a2387ed3b5d536eb = {
    name: "funnel-x",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M12.531 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14v6a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341l.427-.473",
                key: "ol2ft2"
            }
        ],
        [
            "path",
            {
                d: "m16.5 3.5 5 5",
                key: "15e6fa"
            }
        ],
        [
            "path",
            {
                d: "m21.5 3.5-5 5",
                key: "m0lwru"
            }
        ]
    ],
    aliases: [
        "filter-x"
    ]
};
$8e976e543b929c4c$export$a2387ed3b5d536eb.node;
const $8e976e543b929c4c$export$2e2bcd8739ae039 = (0, $9QBug.default)($8e976e543b929c4c$export$a2387ed3b5d536eb);

});

parcelRegister("2rN5o", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cf9022b4ea6e252$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $2cf9022b4ea6e252$export$a2387ed3b5d536eb = {
    name: "sliders-horizontal",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M10 5H3",
                key: "1qgfaw"
            }
        ],
        [
            "path",
            {
                d: "M12 19H3",
                key: "yhmn1j"
            }
        ],
        [
            "path",
            {
                d: "M14 3v4",
                key: "1sua03"
            }
        ],
        [
            "path",
            {
                d: "M16 17v4",
                key: "1q0r14"
            }
        ],
        [
            "path",
            {
                d: "M21 12h-9",
                key: "1o4lsq"
            }
        ],
        [
            "path",
            {
                d: "M21 19h-5",
                key: "1rlt1p"
            }
        ],
        [
            "path",
            {
                d: "M21 5h-7",
                key: "1oszz2"
            }
        ],
        [
            "path",
            {
                d: "M8 10v4",
                key: "tgpxqk"
            }
        ],
        [
            "path",
            {
                d: "M8 12H3",
                key: "a7s4jb"
            }
        ]
    ]
};
$2cf9022b4ea6e252$export$a2387ed3b5d536eb.node;
const $2cf9022b4ea6e252$export$2e2bcd8739ae039 = (0, $9QBug.default)($2cf9022b4ea6e252$export$a2387ed3b5d536eb);

});

parcelRegister("awevB", function(module, exports) {

$parcel$export(module.exports, "rangeLabelFor", () => $751677fd0a80fd7a$export$94bb145bb1ee00a2);
$parcel$export(module.exports, "default", () => $751677fd0a80fd7a$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $4UJrq = parcelRequire("4UJrq");

var $j9AxR = parcelRequire("j9AxR");

var $IZwml = parcelRequire("IZwml");

var $hlTfq = parcelRequire("hlTfq");

var $4Qco3 = parcelRequire("4Qco3");
'use client';
/**
 * Date-range filter as a single dropdown.
 *
 * The trigger always reads out the *applied* range ("امروز", "۱۲–۱۸ تیر", "Sep 12–18"), so the
 * active filter is never ambiguous — the older layout left the two date inputs
 * visible next to the preset chips, and a custom range highlighted no chip at all.
 *
 * Props:
 *   presets   — [{ id, label }]; the ids are opaque, the parent maps them to a window
 *   preset    — active preset id, or 'custom'
 *   custom    — { from, to } applied custom range, Gregorian 'YYYY-MM-DD' (picker format)
 *   onPreset  — (id) => void
 *   onCustom  — (from, to) => void; only fired once BOTH ends are picked
 */ // Gregorian 'YYYY-MM-DD' (what JalaliDatePicker emits) → { y, m, d } in the
// calendar the page reads: Jalali for Persian and Arabic, Gregorian for English,
// French and German — the same choice the picker itself makes (lib/datePickerLocale.js).
const $751677fd0a80fd7a$var$partsOf = (s, calendar)=>{
    if (!s || s.length < 10) return null;
    const [y, m, d] = s.split('-').map(Number);
    if (!y || !m || !d) return null;
    return calendar === 'jalali' ? (0, $4UJrq.msToJalali)(Date.UTC(y, m - 1, d)) : {
        y: y,
        m: m,
        d: d
    };
};
const $751677fd0a80fd7a$var$dayKey = (p)=>p.y * 10000 + p.m * 100 + p.d;
// Month first or day first. Persian, English and Arabic keep the order this label
// has always had, the CALENDAR's: month first on a Gregorian page ("September
// 12–18", «سبتمبر ١٢–١٨» under a Gregorian brand), day first on a Jalali one —
// a live Gregorian brand (Proxia, en + ar) must read exactly as before (PM-0185
// D15). A language added since (French, German) reads its own date template
// instead: «12–18 septembre», «12.–18. September», «12–18 Tir», day first
// whichever calendar the page reads.
const $751677fd0a80fd7a$var$CALENDAR_ORDER = new Set([
    'fa',
    'en',
    'ar'
]);
const $751677fd0a80fd7a$var$monthFirst = (L, locale)=>{
    const base = String(locale || (0, $hlTfq.documentLocale)()).toLowerCase().split(/[-_]/)[0];
    if ($751677fd0a80fd7a$var$CALENDAR_ORDER.has(base) || !(0, $IZwml.DATE_PICKER_LOCALES)[base]) return L.calendar === 'gregorian';
    return L.date.indexOf('{month}') < L.date.indexOf('{d}');
};
// What a day-first language writes right after the day number, read off the same
// template: German's ordinal dot («{d}. {month} {y}» → «12.–18. September»,
// «30. August – 2. September»); nothing for French. fa/en/ar keep their old label.
const $751677fd0a80fd7a$var$dayMark = (L, locale)=>{
    const base = String(locale || (0, $hlTfq.documentLocale)()).toLowerCase().split(/[-_]/)[0];
    if ($751677fd0a80fd7a$var$CALENDAR_ORDER.has(base) || !(0, $IZwml.DATE_PICKER_LOCALES)[base]) return '';
    const m = /\{d\}(\S*)\s+\{month\}/.exec(L.date);
    return m ? m[1] : '';
};
function $751677fd0a80fd7a$export$a0d62bcaf969e834(fromStr, toStr, locale) {
    const L = (0, $IZwml.datePickerLocale)(locale);
    let a = $751677fd0a80fd7a$var$partsOf(fromStr, L.calendar);
    let b = $751677fd0a80fd7a$var$partsOf(toStr, L.calendar);
    if (!a || !b) return (0, $j9AxR.kitCopy)(locale).dateRange.custom;
    if ($751677fd0a80fd7a$var$dayKey(a) > $751677fd0a80fd7a$var$dayKey(b)) [a, b] = [
        b,
        a
    ];
    const num = (x)=>(0, $IZwml.withDigits)(x, L.digits);
    const month = (p)=>L.months[L.calendar][p.m - 1];
    if ($751677fd0a80fd7a$var$monthFirst(L, locale)) {
        const md = (p)=>`${month(p)} ${num(p.d)}`;
        if ($751677fd0a80fd7a$var$dayKey(a) === $751677fd0a80fd7a$var$dayKey(b)) return `${md(a)}, ${num(a.y)}`;
        if (a.y === b.y && a.m === b.m) return `${month(a)} ${num(a.d)}\u{2013}${num(b.d)}`;
        if (a.y === b.y) return `${md(a)} \u{2013} ${md(b)}`;
        return `${md(a)}, ${num(a.y)} \u{2013} ${md(b)}, ${num(b.y)}`;
    }
    const mark = $751677fd0a80fd7a$var$dayMark(L, locale);
    const day = (p)=>`${num(p.d)}${mark}`;
    const dm = (p)=>`${day(p)} ${month(p)}`;
    if ($751677fd0a80fd7a$var$dayKey(a) === $751677fd0a80fd7a$var$dayKey(b)) return `${dm(a)} ${num(a.y)}`;
    if (a.y === b.y && a.m === b.m) return `${day(a)}\u{2013}${day(b)} ${month(a)}`;
    if (a.y === b.y) return `${dm(a)} \u{2013} ${dm(b)}`;
    return `${dm(a)} ${num(a.y)} \u{2013} ${dm(b)} ${num(b.y)}`;
}
function $751677fd0a80fd7a$export$94bb145bb1ee00a2(preset, fromStr, toStr, presets, locale) {
    if (preset === 'custom') return $751677fd0a80fd7a$export$a0d62bcaf969e834(fromStr, toStr, locale);
    return (presets.find((p)=>p.id === preset) || {}).label || '';
}
const $751677fd0a80fd7a$var$CalendarIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "15",
        height: "15",
        fill: "currentColor",
        style: {
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M20 3h-1V1h-2v2H7V1H5v2H4C2.9 3 2 3.9 2 5v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V8h16v13zM7 10h5v5H7z"
    }));
const $751677fd0a80fd7a$var$ChevronIcon = ({ open: open })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "14",
        height: "14",
        fill: "currentColor",
        style: {
            flexShrink: 0,
            transform: open ? 'rotate(180deg)' : 'none',
            transition: 'transform 0.15s'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M7 10l5 5 5-5z"
    }));
const $751677fd0a80fd7a$var$CheckIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "15",
        height: "15",
        fill: "currentColor",
        style: {
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
    }));
const $751677fd0a80fd7a$var$PresetRow = ({ label: label, active: active, onClick: onClick })=>{
    const [hov, setHov] = (0, $acw62.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: onClick,
        onMouseEnter: ()=>setHov(true),
        onMouseLeave: ()=>setHov(false),
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
            padding: '8px 10px',
            borderRadius: 8,
            border: 'none',
            background: active ? (0, $jTCZr.C).tealLight : hov ? (0, $jTCZr.C).bg : 'transparent',
            color: active ? (0, $jTCZr.C).teal : (0, $jTCZr.C).textSecondary,
            fontSize: '0.8125rem',
            fontWeight: active ? 700 : 500,
            fontFamily: 'inherit',
            cursor: 'pointer',
            textAlign: 'start',
            transition: 'background 0.12s'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, label), active && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($751677fd0a80fd7a$var$CheckIcon, null));
};
function $751677fd0a80fd7a$export$2e2bcd8739ae039({ presets: presets, preset: preset, custom: custom, onPreset: onPreset, onCustom: onCustom }) {
    const [open, setOpen] = (0, $acw62.useState)(false);
    const ref = (0, $acw62.useRef)(null);
    // Draft dates live here, not in the parent: a range is only *applied* once both
    // ends exist, so a half-picked range can never desync the trigger label from the
    // window the list is actually showing.
    const [dFrom, setDFrom] = (0, $acw62.useState)(custom.from);
    const [dTo, setDTo] = (0, $acw62.useState)(custom.to);
    (0, $acw62.useEffect)(()=>{
        if (open) {
            setDFrom(custom.from);
            setDTo(custom.to);
        }
    }, [
        open,
        custom.from,
        custom.to
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!open) return;
        const h = (e)=>{
            if (!ref.current) return;
            if (ref.current.contains(e.target)) return;
            // The two custom-range fields are `JalaliDatePicker`s, and their calendar
            // is PORTALED to <body> so a clipping ancestor cannot slice it. That puts
            // it outside `ref`, so picking a day counted as an outside click and shut
            // the dropdown before the date could register — which made the custom
            // range unreachable by calendar in every screen that uses this filter.
            if (e.target.closest?.('[data-jalali-popup]')) return;
            setOpen(false);
        };
        document.addEventListener('mousedown', h);
        return ()=>document.removeEventListener('mousedown', h);
    }, [
        open
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!open) return;
        const h = (e)=>{
            if (e.key === 'Escape') setOpen(false);
        };
        document.addEventListener('keydown', h);
        return ()=>document.removeEventListener('keydown', h);
    }, [
        open
    ]);
    const copy = (0, $j9AxR.kitCopy)().dateRange;
    const isCustom = preset === 'custom';
    const label = $751677fd0a80fd7a$export$94bb145bb1ee00a2(preset, custom.from, custom.to, presets);
    const halfDone = !!dFrom !== !!dTo;
    const pickPreset = (id)=>{
        onPreset(id);
        setOpen(false);
    };
    const pickFrom = (v)=>{
        setDFrom(v);
        if (v && dTo) {
            onCustom(v, dTo);
            setOpen(false);
        }
    };
    const pickTo = (v)=>{
        setDTo(v);
        if (v && dFrom) {
            onCustom(dFrom, v);
            setOpen(false);
        }
    };
    const highlighted = open || isCustom;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: ref,
        style: {
            position: 'relative',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: ()=>setOpen((o)=>!o),
        title: copy.title,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 7,
            height: 36,
            padding: '0 12px',
            borderRadius: 8,
            border: `1px solid ${highlighted ? (0, $jTCZr.C).navy : (0, $jTCZr.C).border}`,
            background: highlighted ? '#fff' : (0, $jTCZr.C).bg,
            color: highlighted ? (0, $jTCZr.C).navy : (0, $jTCZr.C).textPrimary,
            fontSize: '0.8125rem',
            fontWeight: 700,
            fontFamily: 'inherit',
            cursor: 'pointer',
            whiteSpace: 'nowrap',
            transition: 'all 0.12s'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($751677fd0a80fd7a$var$CalendarIcon, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($751677fd0a80fd7a$var$ChevronIcon, {
        open: open
    })), open && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'absolute',
            top: 'calc(100% + 6px)',
            insetInlineStart: 0,
            zIndex: 60,
            width: 260,
            background: '#fff',
            borderRadius: 12,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            boxShadow: '0 12px 36px rgba(0,0,0,0.14)',
            padding: 8
        }
    }, presets.map((p)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($751677fd0a80fd7a$var$PresetRow, {
            key: p.id,
            label: p.label,
            active: preset === p.id,
            onClick: ()=>pickPreset(p.id)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            height: 1,
            background: (0, $jTCZr.C).border,
            margin: '8px 4px'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.6875rem',
            fontWeight: 700,
            color: isCustom ? (0, $jTCZr.C).teal : (0, $jTCZr.C).textMuted,
            padding: '2px 10px 8px'
        }
    }, copy.custom), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'grid',
            gap: 8,
            padding: '0 4px 4px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4Qco3.default), {
        value: dFrom,
        onChange: pickFrom,
        placeholder: copy.from,
        height: 38,
        fontSize: 13,
        disableFuture: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4Qco3.default), {
        value: dTo,
        onChange: pickTo,
        placeholder: copy.to,
        height: 38,
        fontSize: 13,
        disableFuture: true
    }), halfDone && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.6875rem',
            color: (0, $jTCZr.C).amber,
            fontWeight: 600,
            padding: '0 2px'
        }
    }, copy.needBoth))));
}

});
parcelRegister("4UJrq", function(module, exports) {

$parcel$export(module.exports, "IRAN_OFFSET_MS", () => $393fa4133562fea6$export$c7153f4b19854938);
$parcel$export(module.exports, "msToJalali", () => $393fa4133562fea6$export$129955be4a159fb3);
$parcel$export(module.exports, "jalaliToMs", () => $393fa4133562fea6$export$998538909dbe3791);
$parcel$export(module.exports, "jDaysInMonth", () => $393fa4133562fea6$export$33c90dd38a62167e);
const $393fa4133562fea6$export$6c2d0d964670e2e3 = [
    "\u0641\u0631\u0648\u0631\u062F\u06CC\u0646",
    "\u0627\u0631\u062F\u06CC\u0628\u0647\u0634\u062A",
    "\u062E\u0631\u062F\u0627\u062F",
    "\u062A\u06CC\u0631",
    "\u0645\u0631\u062F\u0627\u062F",
    "\u0634\u0647\u0631\u06CC\u0648\u0631",
    "\u0645\u0647\u0631",
    "\u0622\u0628\u0627\u0646",
    "\u0622\u0630\u0631",
    "\u062F\u06CC",
    "\u0628\u0647\u0645\u0646",
    "\u0627\u0633\u0641\u0646\u062F"
];
const $393fa4133562fea6$export$fb4a539c21dc93d2 = [
    "\u0634",
    "\u06CC",
    "\u062F",
    "\u0633",
    "\u0686",
    "\u067E",
    "\u062C"
];
const $393fa4133562fea6$export$961e0c326b64dc98 = (n)=>String(n).replace(/\d/g, (d)=>"\u06F0\u06F1\u06F2\u06F3\u06F4\u06F5\u06F6\u06F7\u06F8\u06F9"[+d]);
const $393fa4133562fea6$export$c7153f4b19854938 = 12600000;
const $393fa4133562fea6$export$710ba58c9cc5d7e7 = ()=>new Date(Date.now() + $393fa4133562fea6$export$c7153f4b19854938);
function $393fa4133562fea6$var$jIsLeap(y) {
    return (y * 8 + 29) % 33 < 8;
}
function $393fa4133562fea6$export$129955be4a159fb3(ms) {
    const anchor = Date.UTC(2021, 2, 21); // 1400/01/01
    let days = Math.floor((ms - anchor) / 86400000);
    if (!Number.isFinite(days)) return null;
    // Nothing in a medical record predates the Jalali era, so a timestamp that
    // far back is corrupt input. Reject it rather than walk ~270,000 iterations
    // and hand the caller a confident negative year.
    if (days < -520000) return null; // ≈ year 1
    let y = 1400;
    // Before the anchor: step back a year at a time until the day index lands
    // inside one, mirroring the forward walk below.
    while(days < 0){
        y--;
        days += $393fa4133562fea6$var$jIsLeap(y) ? 366 : 365;
    }
    while(true){
        const diy = $393fa4133562fea6$var$jIsLeap(y) ? 366 : 365;
        if (days < diy) break;
        days -= diy;
        y++;
    }
    const md = [
        31,
        31,
        31,
        31,
        31,
        31,
        30,
        30,
        30,
        30,
        30,
        $393fa4133562fea6$var$jIsLeap(y) ? 30 : 29
    ];
    let m = 0;
    while(days >= md[m]){
        days -= md[m];
        m++;
    }
    return {
        y: y,
        m: m + 1,
        d: days + 1
    };
}
function $393fa4133562fea6$export$998538909dbe3791(jy, jm, jd) {
    const anchor = Date.UTC(2021, 2, 21); // 1400/01/01
    let days = 0;
    if (jy >= 1400) for(let y = 1400; y < jy; y++)days += $393fa4133562fea6$var$jIsLeap(y) ? 366 : 365;
    else for(let y = jy; y < 1400; y++)days -= $393fa4133562fea6$var$jIsLeap(y) ? 366 : 365;
    const md = [
        31,
        31,
        31,
        31,
        31,
        31,
        30,
        30,
        30,
        30,
        30,
        $393fa4133562fea6$var$jIsLeap(jy) ? 30 : 29
    ];
    for(let m = 0; m < jm - 1; m++)days += md[m];
    days += jd - 1;
    return anchor + days * 86400000;
}
function $393fa4133562fea6$export$33c90dd38a62167e(jy, jm) {
    if (jm <= 6) return 31;
    if (jm <= 11) return 30;
    return $393fa4133562fea6$var$jIsLeap(jy) ? 30 : 29;
}
function $393fa4133562fea6$export$748262491e74cb62() {
    const now = $393fa4133562fea6$export$710ba58c9cc5d7e7();
    // Day-of-week in Iran time: getUTCDay() because we manually shifted the clock
    const jsDay = now.getUTCDay(); // 0=Sun … 6=Sat
    const irWeekday = (jsDay + 1) % 7; // 0=ش … 6=ج
    const nowMs = now.getTime(); // already shifted UTC+3:30
    return Array.from({
        length: 7
    }, (_, i)=>{
        const dayMs = nowMs + (i - irWeekday) * 86400000;
        return {
            ...$393fa4133562fea6$export$129955be4a159fb3(dayMs),
            shortName: $393fa4133562fea6$export$fb4a539c21dc93d2[i],
            isToday: i === irWeekday
        };
    });
}

});


parcelRegister("dlbmi", function(module, exports) {

$parcel$export(module.exports, "default", () => $96db923581058009$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $2rN5o = parcelRequire("2rN5o");
var $6TdpC = parcelRequire("6TdpC");

var $bHjRG = parcelRequire("bHjRG");

var $aJ1FU = parcelRequire("aJ1FU");

var $jTCZr = parcelRequire("jTCZr");

var $j9AxR = parcelRequire("j9AxR");

var $IZwml = parcelRequire("IZwml");
'use client';
/**
 * «فیلترها» — a toolbar button and the anchored panel the secondary filters live in.
 *
 * The desktop half of DESIGN_CONCEPT §9.2's filter pattern as the phone already has
 * it: the two most-used controls stay in the toolbar (the search box and the segment
 * chips), everything else moves behind ONE button badged with how many of them are
 * non-default. On «بیماران» that turned a toolbar of two rows — five chips over a
 * search box and four selects — into one row, and gave the rows back to the list
 * (PM-0471).
 *
 * Why this is not the kit's `Menu`: a menu is `role="menu"` and walks its rows with
 * the arrow keys, which is exactly the key a `<select>` inside it needs for itself.
 * This is `role="dialog"` — a small non-modal panel of form controls — so the
 * controls keep their keyboard and the panel only owns `Esc`, the outside press and
 * where focus goes. Why it is not a `Dialog`: a centred modal to pick an insurer is
 * a trip, and a filter applies immediately, so there is nothing to confirm.
 *
 * Positioning is the kit `Menu`'s: portaled to `<body>` so the page's scroll
 * container cannot clip it, anchored to the trigger's INLINE-START edge in both
 * directions, re-measured on scroll and resize, flipped above the trigger when the
 * room below runs out. Changes apply as they are made — the panel never holds a
 * draft — so closing it is never a decision.
 *
 * Promoted from the clinic client's `components/common/FilterPopover.jsx` (PM-0471,
 * promotion filed under PM-0474, done under PM-0494). `FilterBar collapse` renders
 * its `more` controls through this on a workstation; the clinic's copy goes when
 * the clinic pins the tag that carries this.
 *
 * Copy defaults (rule 7): `label` «فیلترها», `clearLabel` «حذف فیلترها»,
 * `closeLabel` «بستن», `countLabel` «فیلترها — n فعال», digits in the page's
 * numerals — all from `kitCopy().filters`, each overridable by its prop.
 *
 * Props:
 *   label        — the button's text («فیلترها»); also the panel's accessible name
 *   count        — how many controls inside are non-default; > 0 badges the button
 *   countLabel   — accessible text for the badge («{n} فیلتر فعال»)
 *   onClear      — when given and `count > 0`, a «پاک کردن» button in the panel head
 *   clearLabel   — its text
 *   closeLabel   — the ✕'s accessible name
 *   width        — px (default 340)
 *   children     — the controls (kit `Select`s with labels, stacked)
 *   data-testid  — on the trigger; the panel is `${testid}-panel`
 */ const $96db923581058009$var$Z = 900; // the kit's anchored-overlay rung: above app chrome, below sheets/dialogs
const $96db923581058009$var$GAP = 6;
const $96db923581058009$var$EDGE = 8;
const $96db923581058009$var$MIN_BELOW = 220;
const $96db923581058009$var$FOCUSABLE = 'select, input, button:not([data-popover-close]), [tabindex]:not([tabindex="-1"])';
function $96db923581058009$export$2e2bcd8739ae039({ label: label, count: count = 0, countLabel: countLabel, format: /** The badge's digits — default: the page language's numerals. */ format, onClear: onClear, clearLabel: clearLabel, closeLabel: closeLabel, width: width = 340, children: children, 'data-testid': testId = 'filter-popover' }) {
    const copy = (0, $j9AxR.kitCopy)();
    if (label === undefined) label = copy.filters.title;
    if (clearLabel === undefined) clearLabel = copy.filters.clear;
    if (closeLabel === undefined) closeLabel = copy.close;
    if (!format) format = (n)=>(0, $IZwml.withDigits)(String(Math.trunc(Number(n))), (0, $IZwml.datePickerLocale)().digits);
    if (countLabel === undefined && count > 0) countLabel = copy.filters.activeCount(format(count));
    const [open, setOpen] = (0, $acw62.useState)(false);
    const [pos, setPos] = (0, $acw62.useState)(null);
    const triggerRef = (0, $acw62.useRef)(null);
    const panelRef = (0, $acw62.useRef)(null);
    const panelId = (0, $acw62.useId)();
    const close = ()=>setOpen(false);
    (0, $acw62.useLayoutEffect)(()=>{
        if (!open) {
            setPos(null);
            return undefined;
        }
        const place = ()=>{
            const el = triggerRef.current;
            if (!el) return;
            const r = el.getBoundingClientRect();
            const isRtl = typeof document !== 'undefined' && document.documentElement.dir === 'rtl';
            const left = isRtl ? Math.max($96db923581058009$var$EDGE, r.right - width) : Math.min(r.left, window.innerWidth - width - $96db923581058009$var$EDGE);
            const roomBelow = window.innerHeight - r.bottom - $96db923581058009$var$EDGE * 2;
            const roomAbove = r.top - $96db923581058009$var$EDGE * 2;
            const up = roomBelow < $96db923581058009$var$MIN_BELOW && roomAbove > roomBelow;
            const maxHeight = Math.min(Math.max(200, up ? roomAbove : roomBelow), Math.round(window.innerHeight * 0.7));
            setPos(up ? {
                bottom: Math.max($96db923581058009$var$EDGE, window.innerHeight - r.top + $96db923581058009$var$GAP),
                left: left,
                maxHeight: maxHeight
            } : {
                top: r.bottom + $96db923581058009$var$GAP,
                left: left,
                maxHeight: maxHeight
            });
        };
        place();
        window.addEventListener('resize', place);
        window.addEventListener('scroll', place, true);
        return ()=>{
            window.removeEventListener('resize', place);
            window.removeEventListener('scroll', place, true);
        };
    }, [
        open,
        width
    ]);
    // Outside press closes. `mousedown`, so a drag that starts inside a select's
    // native list (which the browser renders outside our DOM) cannot close us.
    (0, $acw62.useEffect)(()=>{
        if (!open) return undefined;
        const onDown = (e)=>{
            if (panelRef.current?.contains(e.target)) return;
            if (triggerRef.current?.contains(e.target)) return;
            close();
        };
        const onKey = (e)=>{
            if (e.key !== 'Escape') return;
            // Only when the key reached us from inside the panel or from the trigger:
            // a global Esc belongs to whatever overlay is on top, not to a closed-looking
            // panel somewhere behind it.
            if (!panelRef.current?.contains(e.target) && !triggerRef.current?.contains(e.target)) return;
            e.stopPropagation();
            close();
        };
        document.addEventListener('mousedown', onDown);
        document.addEventListener('keydown', onKey, true);
        return ()=>{
            document.removeEventListener('mousedown', onDown);
            document.removeEventListener('keydown', onKey, true);
        };
    }, [
        open
    ]);
    // Focus lands on the first control and goes back to the button on close.
    (0, $acw62.useEffect)(()=>{
        if (!open) return undefined;
        const t = window.setTimeout(()=>{
            panelRef.current?.querySelector($96db923581058009$var$FOCUSABLE)?.focus?.();
        }, 0);
        const trigger = triggerRef.current;
        return ()=>{
            window.clearTimeout(t);
            if (trigger && document.contains(trigger)) trigger.focus?.();
        };
    }, [
        open
    ]);
    const active = count > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        ref: triggerRef,
        type: "button",
        variant: active ? 'subtle' : 'outline',
        size: "sm",
        "aria-haspopup": "dialog",
        "aria-expanded": open,
        "aria-controls": open ? panelId : undefined,
        onClick: ()=>setOpen((v)=>!v),
        "data-testid": testId,
        "data-state": open ? 'open' : 'closed',
        style: {
            minHeight: '2.75rem',
            gap: '0.375rem',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2rN5o.default), {
        size: 14,
        "aria-hidden": "true"
    }), label, active && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bHjRG.default), {
        variant: "count",
        "aria-label": countLabel,
        "data-testid": `${testId}-count`
    }, countLabel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": "true"
    }, format(count)) : format(count))), open && pos && typeof document !== 'undefined' && /*#__PURE__*/ (0, $1u0KT.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: panelRef,
        id: panelId,
        role: "dialog",
        "aria-label": label,
        "data-testid": `${testId}-panel`,
        style: {
            position: 'fixed',
            top: pos.top,
            bottom: pos.bottom,
            left: pos.left,
            width: width,
            maxWidth: `calc(100vw - ${$96db923581058009$var$EDGE * 2}px)`,
            maxHeight: pos.maxHeight,
            overflowY: 'auto',
            background: (0, $jTCZr.C).card,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: (0, $jTCZr.RADIUS).card,
            boxShadow: (0, $jTCZr.SHADOW).floating,
            zIndex: $96db923581058009$var$Z,
            padding: '0.75rem 1rem 1rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.875rem',
            fontWeight: 800,
            color: (0, $jTCZr.C).textPrimary,
            flex: 1
        }
    }, label), onClear && active && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        onClick: onClear,
        "data-testid": `${testId}-clear`
    }, clearLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        onClick: close,
        "aria-label": closeLabel,
        "data-popover-close": "true",
        style: {
            paddingInline: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
        size: 15,
        "aria-hidden": "true"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.625rem'
        }
    }, children)), document.body));
}

});


parcelRegister("11M2E", function(module, exports) {

var $acw62 = parcelRequire("acw62");

var $3SiwN = parcelRequire("3SiwN");
var $2VplL = parcelRequire("2VplL");

var $7gSBD = parcelRequire("7gSBD");

var $aJ1FU = parcelRequire("aJ1FU");

var $j9AxR = parcelRequire("j9AxR");
'use client';
function $f5260ec37eaed3bc$export$2e2bcd8739ae039({ onReset: onReset, title: title, description: description, resetLabel: resetLabel, fill: fill, ...rest }) {
    const copy = (0, $j9AxR.kitCopy)().filters;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2VplL.default), {
            size: 44,
            strokeWidth: 1.5,
            "aria-hidden": true
        }),
        title: title ?? copy.emptyTitle,
        description: description ?? copy.emptyHint,
        fill: fill,
        "data-state": "filtered-empty",
        action: typeof onReset === 'function' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            type: "button",
            variant: "outline",
            size: "sm",
            className: "min-h-11 gap-1.5",
            onClick: onReset
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3SiwN.default), {
            size: 15,
            "aria-hidden": true
        }), resetLabel ?? copy.clear) : null,
        ...rest
    });
}

});
parcelRegister("2VplL", function(module, exports) {

$parcel$export(module.exports, "default", () => $6117d2af5e6ea38b$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $6117d2af5e6ea38b$export$a2387ed3b5d536eb = {
    name: "search-x",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m13.5 8.5-5 5",
                key: "1cs55j"
            }
        ],
        [
            "path",
            {
                d: "m8.5 8.5 5 5",
                key: "a8mexj"
            }
        ],
        [
            "circle",
            {
                cx: "11",
                cy: "11",
                r: "8",
                key: "4ej97u"
            }
        ],
        [
            "path",
            {
                d: "m21 21-4.3-4.3",
                key: "1qie3q"
            }
        ]
    ]
};
$6117d2af5e6ea38b$export$a2387ed3b5d536eb.node;
const $6117d2af5e6ea38b$export$2e2bcd8739ae039 = (0, $9QBug.default)($6117d2af5e6ea38b$export$a2387ed3b5d536eb);

});


parcelRegister("3IEEe", function(module, exports) {

$parcel$export(module.exports, "parseFilters", () => $2b550301dde49920$export$2f387f690230eab4);
$parcel$export(module.exports, "isDefault", () => $2b550301dde49920$export$75abdbb028a7ab06);
$parcel$export(module.exports, "serializeFilters", () => $2b550301dde49920$export$d56dfa49cae8373);
$parcel$export(module.exports, "activeFilters", () => $2b550301dde49920$export$47803c945b5cd5ce);
$parcel$export(module.exports, "resetFilters", () => $2b550301dde49920$export$8da0d8f55c4b51d0);
$parcel$export(module.exports, "applyChange", () => $2b550301dde49920$export$6fbe08f3dbfbccb2);
// ─────────────────────────────────────────────────────────────────────────────
// filterState — the ONE way a list screen's filters are declared, read from and
// written to the URL (PM-0494; DESIGN_CONCEPT §3.2 "URL is state", §9.2
// "Filtering — one pattern").
//
// Pure functions, no React and no router: a screen DECLARES its filters once
// (`defineFilters`), and everything else — what the URL means, what the URL
// should say, which filters are "active", what «حذف فیلترها» resets — is derived
// from that declaration. Before this, every list screen answered those questions
// on its own: some kept filters in `useState` (lost on refresh and on the way
// back from a record), some in `useSearchParams` with a hand-written parser,
// some counted "active" differently for the chip badge and for the clear button,
// and three screens serialised the same date range three ways.
//
// A field spec:
//   type     'text' | 'enum' | 'multi' | 'bool' | 'dateRange' | 'sort' | 'page'
//   default  the value that means "no filter" (every type has a built-in one;
//            an enum with `options` defaults to its FIRST option — «همه»)
//   options  enum/multi/sort/dateRange: the allowed values — an unknown URL value
//            reads as the default, so a stale link never selects a status that
//            no longer exists
//   param    the URL parameter (default: the key)
//   url      false = NEVER serialised (component state only). Free text that may
//            carry PHI — a patient's name — stays out of the URL by the concept
//            (§3.2); `text` therefore defaults to url:false and must opt IN.
//   counts   whether a non-default value is an "active filter" for the badge,
//            the clear button and the filtered-empty state. Default true, except
//            `sort` and `page`, which are navigation, not filtering.
//   resetsPage  changing this filter sends the pager back to page 1 (default
//            true for every type but `page` and `sort`)
//   debounce text only: ms before a typed value reaches `query` (default 300)
//
// A dateRange value is `{ preset, from, to }` — `preset` an opaque id the page
// maps to a window (the `DateRangeFilter` contract), or `'custom'` with
// Gregorian 'YYYY-MM-DD' bounds. On the URL: `range=week` or
// `range=custom&from=2026-01-01&to=2026-01-31` (`fromParam`/`toParam` rename).
// A sort value is `{ key, dir }`, on the URL as `sort=createdAt:desc`.
// ─────────────────────────────────────────────────────────────────────────────
const $2b550301dde49920$var$TYPES = new Set([
    'text',
    'enum',
    'multi',
    'bool',
    'dateRange',
    'sort',
    'page'
]);
const $2b550301dde49920$var$BUILT_IN_DEFAULT = {
    text: '',
    enum: '',
    multi: [],
    bool: false,
    dateRange: {
        preset: 'all',
        from: '',
        to: ''
    },
    sort: {
        key: '',
        dir: 'desc'
    },
    page: 1
};
const $2b550301dde49920$var$optionValue = (o)=>o && typeof o === 'object' ? o.value : o;
const $2b550301dde49920$var$allowedValues = (f)=>Array.isArray(f.options) ? f.options.map($2b550301dde49920$var$optionValue) : null;
function $2b550301dde49920$export$bb8d0ce7dce2628e(spec) {
    const out = {};
    for (const [key, raw] of Object.entries(spec || {})){
        const f = typeof raw === 'string' ? {
            type: raw
        } : {
            ...raw
        };
        if (!$2b550301dde49920$var$TYPES.has(f.type)) throw new Error(`defineFilters: "${key}" has unknown type ${JSON.stringify(f.type)}`);
        if (f.type === 'enum' && f.default === undefined) {
            const allowed = $2b550301dde49920$var$allowedValues(f);
            if (allowed && allowed.length) f.default = allowed[0];
        }
        if (f.default === undefined) f.default = $2b550301dde49920$var$BUILT_IN_DEFAULT[f.type];
        if (f.param === undefined) f.param = key;
        if (f.url === undefined) f.url = f.type !== 'text';
        if (f.counts === undefined) f.counts = f.type !== 'sort' && f.type !== 'page';
        if (f.resetsPage === undefined) f.resetsPage = f.type !== 'page' && f.type !== 'sort';
        if (f.type === 'text' && f.debounce === undefined) f.debounce = 300;
        if (f.type === 'dateRange') {
            if (f.fromParam === undefined) f.fromParam = 'from';
            if (f.toParam === undefined) f.toParam = 'to';
        }
        out[key] = Object.freeze(f);
    }
    return Object.freeze(out);
}
const $2b550301dde49920$var$toParams = (search)=>{
    if (search instanceof URLSearchParams) return new URLSearchParams(search);
    const s = String(search || '');
    return new URLSearchParams(s.startsWith('?') ? s.slice(1) : s);
};
const $2b550301dde49920$var$DATE = /^\d{4}-\d{2}-\d{2}$/;
function $2b550301dde49920$var$parseOne(f, params) {
    const raw = params.get(f.param);
    switch(f.type){
        case 'text':
            return raw == null ? f.default : raw;
        case 'enum':
            {
                if (raw == null) return f.default;
                const allowed = $2b550301dde49920$var$allowedValues(f);
                return allowed && !allowed.includes(raw) ? f.default : raw;
            }
        case 'multi':
            {
                if (raw == null) return f.default;
                const allowed = $2b550301dde49920$var$allowedValues(f);
                const vals = raw.split(',').map((s)=>s.trim()).filter(Boolean);
                const kept = allowed ? vals.filter((v)=>allowed.includes(v)) : vals;
                return [
                    ...new Set(kept)
                ];
            }
        case 'bool':
            if (raw == null) return f.default;
            return raw === '1' || raw === 'true';
        case 'page':
            {
                const n = parseInt(raw, 10);
                return Number.isFinite(n) && n >= 1 ? n : f.default;
            }
        case 'sort':
            {
                if (!raw) return f.default;
                const [key, dir] = raw.split(':');
                if (!key) return f.default;
                const allowed = $2b550301dde49920$var$allowedValues(f);
                if (allowed && !allowed.includes(key)) return f.default;
                return {
                    key: key,
                    dir: dir === 'asc' ? 'asc' : 'desc'
                };
            }
        case 'dateRange':
            {
                if (raw == null) return f.default;
                if (raw === 'custom') {
                    const from = params.get(f.fromParam) || '';
                    const to = params.get(f.toParam) || '';
                    // A half range is not a range: the filter's own rule (`DateRangeFilter`
                    // applies only when BOTH ends exist) holds for a pasted link too.
                    if (!$2b550301dde49920$var$DATE.test(from) || !$2b550301dde49920$var$DATE.test(to)) return f.default;
                    return from <= to ? {
                        preset: 'custom',
                        from: from,
                        to: to
                    } : {
                        preset: 'custom',
                        from: to,
                        to: from
                    };
                }
                const allowed = $2b550301dde49920$var$allowedValues(f);
                if (allowed && !allowed.includes(raw)) return f.default;
                return {
                    preset: raw,
                    from: '',
                    to: ''
                };
            }
        default:
            return f.default;
    }
}
function $2b550301dde49920$export$2f387f690230eab4(spec, search) {
    const params = $2b550301dde49920$var$toParams(search);
    const out = {};
    for (const [key, f] of Object.entries(spec))out[key] = f.url ? $2b550301dde49920$var$parseOne(f, params) : f.default;
    return out;
}
const $2b550301dde49920$var$sameSet = (a, b)=>{
    const A = new Set(a || []);
    const B = new Set(b || []);
    return A.size === B.size && [
        ...A
    ].every((x)=>B.has(x));
};
function $2b550301dde49920$export$75abdbb028a7ab06(f, value) {
    const d = f.default;
    switch(f.type){
        case 'multi':
            return $2b550301dde49920$var$sameSet(value, d);
        case 'dateRange':
            {
                const preset = value?.preset ?? d.preset;
                if (preset !== d.preset) return false;
                return preset !== 'custom' || value.from === d.from && value.to === d.to;
            }
        case 'sort':
            return (value?.key || '') === (d.key || '') && (value?.dir || 'desc') === (d.dir || 'desc');
        case 'text':
            return String(value ?? '').trim() === String(d ?? '').trim();
        default:
            return value === d;
    }
}
function $2b550301dde49920$export$d56dfa49cae8373(spec, values, base) {
    const params = $2b550301dde49920$var$toParams(base);
    for (const f of Object.values(spec)){
        params.delete(f.param);
        if (f.type === 'dateRange') {
            params.delete(f.fromParam);
            params.delete(f.toParam);
        }
    }
    for (const [key, f] of Object.entries(spec)){
        if (!f.url) continue;
        const v = values[key];
        if (v === undefined || $2b550301dde49920$export$75abdbb028a7ab06(f, v)) continue;
        switch(f.type){
            case 'multi':
                params.set(f.param, v.join(','));
                break;
            case 'bool':
                params.set(f.param, v ? '1' : '0');
                break;
            case 'page':
                params.set(f.param, String(v));
                break;
            case 'sort':
                params.set(f.param, `${v.key}:${v.dir === 'asc' ? 'asc' : 'desc'}`);
                break;
            case 'dateRange':
                params.set(f.param, v.preset);
                if (v.preset === 'custom') {
                    params.set(f.fromParam, v.from);
                    params.set(f.toParam, v.to);
                }
                break;
            default:
                params.set(f.param, String(v));
        }
    }
    return params;
}
function $2b550301dde49920$export$47803c945b5cd5ce(spec, values) {
    return Object.entries(spec).filter(([key, f])=>f.counts && !$2b550301dde49920$export$75abdbb028a7ab06(f, values[key])).map(([key])=>key);
}
function $2b550301dde49920$export$8da0d8f55c4b51d0(spec, values) {
    const out = {
        ...values
    };
    for (const [key, f] of Object.entries(spec))if (f.counts || f.type === 'page') out[key] = f.default;
    return out;
}
function $2b550301dde49920$export$6fbe08f3dbfbccb2(spec, values, patch) {
    const out = {
        ...values,
        ...patch
    };
    const moved = Object.keys(patch).some((k)=>{
        const f = spec[k];
        if (!f || !f.resetsPage) return false;
        return !$2b550301dde49920$var$sameValue(f, values[k], patch[k]);
    });
    if (moved) {
        for (const [key, f] of Object.entries(spec))if (f.type === 'page' && !(key in patch)) out[key] = f.default;
    }
    return out;
}
const $2b550301dde49920$var$sameValue = (f, a, b)=>{
    switch(f.type){
        case 'multi':
            return $2b550301dde49920$var$sameSet(a, b);
        case 'dateRange':
            return (a?.preset ?? '') === (b?.preset ?? '') && (a?.from ?? '') === (b?.from ?? '') && (a?.to ?? '') === (b?.to ?? '');
        case 'sort':
            return (a?.key ?? '') === (b?.key ?? '') && (a?.dir ?? 'desc') === (b?.dir ?? 'desc');
        default:
            return a === b;
    }
};
const $2b550301dde49920$export$ae181b443cecf120 = (spec)=>Object.fromEntries(Object.entries(spec).map(([k, f])=>[
            k,
            f.default
        ]));

});

parcelRegister("21L1d", function(module, exports) {

var $acw62 = parcelRequire("acw62");

var $3IEEe = parcelRequire("3IEEe");
'use client';
function $17a025b06c6aab33$export$8ecdac7d5a13ae74([params, setParams]) {
    return {
        search: params.toString(),
        setSearch: (next, { replace: replace = true } = {})=>setParams(new URLSearchParams(next), {
                replace: replace
            })
    };
}
function $17a025b06c6aab33$export$1be14eb46ff31f76({ searchParams: searchParams, router: router, pathname: pathname }) {
    return {
        search: searchParams?.toString() || '',
        setSearch: (next, { replace: replace = true } = {})=>{
            const s = String(next);
            const url = s ? `${pathname}?${s}` : pathname;
            (replace ? router.replace : router.push).call(router, url, {
                scroll: false
            });
        }
    };
}
// No router: the document's own location. `popstate` keeps Back honest.
function $17a025b06c6aab33$var$useWindowSearch() {
    const read = ()=>typeof window === 'undefined' ? '' : window.location.search.replace(/^\?/, '');
    const [search, setState] = (0, $acw62.useState)(read);
    (0, $acw62.useEffect)(()=>{
        if (typeof window === 'undefined') return undefined;
        const on = ()=>setState(read());
        window.addEventListener('popstate', on);
        return ()=>window.removeEventListener('popstate', on);
    }, []);
    const setSearch = (0, $acw62.useCallback)((next, { replace: replace = true } = {})=>{
        const s = String(next);
        if (typeof window !== 'undefined') {
            const url = `${window.location.pathname}${s ? `?${s}` : ''}${window.location.hash}`;
            window.history[replace ? 'replaceState' : 'pushState'](window.history.state, '', url);
        }
        setState(s);
    }, []);
    return {
        search: search,
        setSearch: setSearch
    };
}
function $17a025b06c6aab33$export$5ab4fa7caa249e6e(value, ms = 300) {
    const [settled, setSettled] = (0, $acw62.useState)(value);
    (0, $acw62.useEffect)(()=>{
        if (!ms) {
            setSettled(value);
            return undefined;
        }
        const t = setTimeout(()=>setSettled(value), ms);
        return ()=>clearTimeout(t);
    }, [
        value,
        ms
    ]);
    return ms ? settled : value;
}
const $17a025b06c6aab33$export$d667710b4d5c9496 = 'parsina:filters:';
const $17a025b06c6aab33$var$storageKeyOf = (storageKey, k)=>`${$17a025b06c6aab33$export$d667710b4d5c9496}${storageKey}:${k}`;
const $17a025b06c6aab33$var$readStored = (storageKey, k)=>{
    try {
        return typeof sessionStorage === 'undefined' ? null : sessionStorage.getItem($17a025b06c6aab33$var$storageKeyOf(storageKey, k));
    } catch  {
        return null;
    }
};
const $17a025b06c6aab33$var$writeStored = (storageKey, k, v)=>{
    try {
        if (typeof sessionStorage === 'undefined') return;
        if (v == null || v === '') sessionStorage.removeItem($17a025b06c6aab33$var$storageKeyOf(storageKey, k));
        else sessionStorage.setItem($17a025b06c6aab33$var$storageKeyOf(storageKey, k), String(v));
    } catch  {}
};
function $17a025b06c6aab33$export$7d5414d63527682c() {
    try {
        if (typeof sessionStorage === 'undefined') return;
        for (const k of Object.keys(sessionStorage))if (k.startsWith($17a025b06c6aab33$export$d667710b4d5c9496)) sessionStorage.removeItem(k);
    } catch  {}
}
function $17a025b06c6aab33$export$2e2bcd8739ae039(spec, adapter, { storageKey: storageKey } = {}) {
    const fallback = $17a025b06c6aab33$var$useWindowSearch();
    const { search: search, setSearch: setSearch } = adapter || fallback;
    const urlValues = (0, $acw62.useMemo)(()=>(0, $3IEEe.parseFilters)(spec, search), [
        spec,
        search
    ]);
    // Fields the URL never carries.
    const localKeys = (0, $acw62.useMemo)(()=>Object.keys(spec).filter((k)=>!spec[k].url), [
        spec
    ]);
    const [local, setLocal] = (0, $acw62.useState)(()=>{
        const params = new URLSearchParams(search);
        return Object.fromEntries(localKeys.map((k)=>{
            const f = spec[k];
            // A link made before the field left the URL may still carry it: read it
            // once; the strip below removes it from the address (replace, so Back
            // never returns to the URL that held a name).
            const legacy = f.type === 'text' ? params.get(f.param) : null;
            if (legacy) return [
                k,
                legacy
            ];
            const stored = storageKey && f.type === 'text' ? $17a025b06c6aab33$var$readStored(storageKey, k) : null;
            return [
                k,
                stored != null ? stored : f.default
            ];
        }));
    });
    (0, $acw62.useEffect)(()=>{
        const params = new URLSearchParams(search);
        const leaked = localKeys.filter((k)=>params.has(spec[k].param));
        if (!leaked.length) return;
        for (const k of leaked){
            if (storageKey) $17a025b06c6aab33$var$writeStored(storageKey, k, params.get(spec[k].param));
            params.delete(spec[k].param);
        }
        setSearch(params.toString(), {
            replace: true
        });
    // Only the FIRST search matters here: a later one cannot contain these
    // params unless something outside this hook writes them.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const values = (0, $acw62.useMemo)(()=>({
            ...urlValues,
            ...local
        }), [
        urlValues,
        local
    ]);
    // Debounce: the typed text settles before the query reads it. One timer per
    // text field, keyed by its own `debounce`.
    const textKeys = (0, $acw62.useMemo)(()=>Object.keys(spec).filter((k)=>spec[k].type === 'text'), [
        spec
    ]);
    const [settledText, setSettledText] = (0, $acw62.useState)(()=>Object.fromEntries(textKeys.map((k)=>[
                k,
                values[k]
            ])));
    const timers = (0, $acw62.useRef)({});
    (0, $acw62.useEffect)(()=>{
        for (const k of textKeys){
            const v = values[k];
            if (settledText[k] === v) continue;
            clearTimeout(timers.current[k]);
            const ms = spec[k].debounce;
            // Clearing a field is not typing: an empty value lands at once, so «پاک
            // کردن» shows the full list without the wait meant for keystrokes.
            if (!ms || (0, $3IEEe.isDefault)(spec[k], v)) {
                setSettledText((s)=>({
                        ...s,
                        [k]: v
                    }));
                continue;
            }
            timers.current[k] = setTimeout(()=>setSettledText((s)=>({
                        ...s,
                        [k]: v
                    })), ms);
        }
        return ()=>{
            for (const t of Object.values(timers.current))clearTimeout(t);
        };
    }, [
        values,
        textKeys,
        spec,
        settledText
    ]);
    const query = (0, $acw62.useMemo)(()=>({
            ...values,
            ...settledText
        }), [
        values,
        settledText
    ]);
    // The latest values, for a `set` called twice in one tick.
    const latest = (0, $acw62.useRef)(values);
    latest.current = values;
    const commit = (0, $acw62.useCallback)((next, { push: push = false } = {})=>{
        const nextLocal = {};
        for (const k of localKeys){
            nextLocal[k] = next[k];
            if (storageKey && spec[k].type === 'text') $17a025b06c6aab33$var$writeStored(storageKey, k, next[k]);
        }
        setLocal(nextLocal);
        const nextSearch = (0, $3IEEe.serializeFilters)(spec, next, search).toString();
        if (nextSearch !== search) setSearch(nextSearch, {
            replace: !push
        });
        latest.current = next;
    }, [
        spec,
        localKeys,
        search,
        setSearch,
        storageKey
    ]);
    const set = (0, $acw62.useCallback)((keyOrPatch, valueOrOpts, maybeOpts)=>{
        const patch = typeof keyOrPatch === 'string' ? {
            [keyOrPatch]: valueOrOpts
        } : keyOrPatch;
        const opts = typeof keyOrPatch === 'string' ? maybeOpts : valueOrOpts;
        for (const k of Object.keys(patch))spec[k];
        commit((0, $3IEEe.applyChange)(spec, latest.current, patch), opts);
    }, [
        spec,
        commit
    ]);
    const reset = (0, $acw62.useCallback)(()=>commit((0, $3IEEe.resetFilters)(spec, latest.current)), [
        spec,
        commit
    ]);
    const active = (0, $acw62.useMemo)(()=>(0, $3IEEe.activeFilters)(spec, values), [
        spec,
        values
    ]);
    return {
        values: values,
        query: query,
        set: set,
        reset: reset,
        active: active,
        activeCount: active.length,
        isFiltered: active.length > 0,
        search: (0, $acw62.useMemo)(()=>(0, $3IEEe.serializeFilters)(spec, values, search).toString(), [
            spec,
            values,
            search
        ])
    };
}

});

parcelRegister("3Amwd", function(module, exports) {

$parcel$export(module.exports, "default", () => $91c948f90369c6a3$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $5JYPc = parcelRequire("5JYPc");
'use client';
// ─────────────────────────────────────────────────────────────────────────────
// Sparkline — an inline, axis-less trend glyph for a short numeric series.
//
// The smallest data-viz unit in the system: it rides inside a row or a tile to
// answer «is this going up or down?» without spending a chart's worth of space.
// It is deliberately unlabelled — the row already carries the name, the value
// and the unit, and the glyph only has to show shape.
//
// Tones resolve from the token set, so a sparkline never invents a colour:
// `accent` for an in-range series, `danger`/`warn` when the caller has already
// judged the latest reading out of range.
//
// Empty appearance (by design): fewer than two numeric points cannot describe a
// trend, so the glyph renders nothing at all rather than a misleading flat line.
// ─────────────────────────────────────────────────────────────────────────────
const $91c948f90369c6a3$var$TONES = {
    accent: (0, $jTCZr.CT).accent,
    danger: (0, $jTCZr.CT).danger,
    warn: (0, $jTCZr.CT).warn,
    good: (0, $jTCZr.CT).good,
    mute: (0, $jTCZr.CT).mute
};
const $91c948f90369c6a3$var$Sparkline = ({ points: points = [], width: width = 72, height: height = 26, tone: tone = 'accent', strokeWidth: strokeWidth = 1.5, showLast: showLast = true, className: className, style: style, ...rest })=>{
    const vals = (points || []).map((p)=>typeof p === 'number' ? p : parseFloat(p)).filter((v)=>!Number.isNaN(v));
    if (vals.length < 2) return null;
    const min = Math.min(...vals);
    const max = Math.max(...vals);
    // A flat series would divide by zero; pad it so the line sits mid-height.
    const pad = (max - min) * 0.15 || 1;
    const lo = min - pad;
    const hi = max + pad;
    const xOf = (i)=>i / (vals.length - 1) * width;
    const yOf = (v)=>height - (v - lo) / (hi - lo) * height;
    const path = vals.map((v, i)=>`${xOf(i).toFixed(1)},${yOf(v).toFixed(1)}`).join(' ');
    const stroke = $91c948f90369c6a3$var$TONES[tone] || $91c948f90369c6a3$var$TONES.accent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: width,
        height: height,
        viewBox: `0 0 ${width} ${height}`,
        // Time always reads left→right, including on an RTL page.
        style: {
            direction: 'ltr',
            overflow: 'visible',
            display: 'block',
            flexShrink: 0,
            ...style
        },
        className: (0, $5JYPc.cn)(className),
        "aria-hidden": true,
        focusable: "false",
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polyline", {
        points: path,
        fill: "none",
        stroke: stroke,
        strokeWidth: strokeWidth,
        strokeLinejoin: "round",
        strokeLinecap: "round"
    }), showLast && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: xOf(vals.length - 1),
        cy: yOf(vals[vals.length - 1]),
        r: "2.5",
        fill: stroke
    }));
};
var $91c948f90369c6a3$export$2e2bcd8739ae039 = $91c948f90369c6a3$var$Sparkline;

});

parcelRegister("ePaaC", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7b57ad44712e2b0$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $5JYPc = parcelRequire("5JYPc");
'use client';
// ─────────────────────────────────────────────────────────────────────────────
// TrendChart — the full-size counterpart to `Sparkline`: one numeric series over
// time, with an optional reference band and per-point status.
//
// It is the system's answer to «show me this measurement's history» — a lab
// analyte, a vital sign, a wallet balance, a clinic's daily revenue. It stays
// presentational: the caller normalises its data to `readings` and decides what
// «abnormal» means; the chart only draws.
//
//   readings   [{ value, date?, status? }]  — chronological, oldest first
//   refLow/refHigh                          — optional reference band + guides
//   formatX(reading, index)                 — axis label; the caller owns the
//                                             locale (Jalali dates, digits…)
//   formatValue(v)                          — value-axis label; same reason —
//                                             digits follow the UI locale, and
//                                             only the app knows what that is
//   emptyLabel                              — copy for the not-enough-data state;
//                                             omitted ⇒ silent blank of the same
//                                             height, so layout never jumps
//
// Status → colour uses the semantic tokens and accepts either casing, because
// clinical back-ends disagree about it (`ABNORMAL` vs `abnormal`).
// ─────────────────────────────────────────────────────────────────────────────
const $b7b57ad44712e2b0$var$STATUS_TONE = {
    abnormal: (0, $jTCZr.CT).warn,
    ABNORMAL: (0, $jTCZr.CT).warn,
    critical: (0, $jTCZr.CT).danger,
    CRITICAL: (0, $jTCZr.CT).danger
};
const $b7b57ad44712e2b0$var$VIEWBOX_W = 520;
const $b7b57ad44712e2b0$var$PAD = {
    t: 12,
    r: 16,
    b: 36,
    l: 46
};
const $b7b57ad44712e2b0$var$TrendChart = ({ readings: readings = [], color: color = (0, $jTCZr.CT).accent, refLow: refLow, refHigh: refHigh, height: height = 160, gridLines: gridLines = 4, formatX: formatX, formatValue: formatValue = (v)=>v.toFixed(1), emptyLabel: emptyLabel, className: className, style: style, ...rest })=>{
    const numeric = (readings || []).map((r)=>({
            ...r,
            num: typeof r?.value === 'number' ? r.value : parseFloat(r?.value)
        }));
    const plottable = numeric.filter((r)=>!Number.isNaN(r.num));
    if (plottable.length < 2) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $5JYPc.cn)(className),
        "data-state": "empty",
        style: {
            height: height,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).mute,
            ...style
        },
        ...rest
    }, emptyLabel || null);
    const nums = plottable.map((r)=>r.num);
    const dataMin = Math.min(...nums);
    const dataMax = Math.max(...nums);
    const span = dataMax - dataMin;
    // Include the reference band in the visible window, then breathe by 15% (or a
    // flat ±2 when every reading is identical and the span is 0).
    const lo = Math.min(dataMin, refLow ?? dataMin) - (span * 0.15 || 2);
    const hi = Math.max(dataMax, refHigh ?? dataMax) + (span * 0.15 || 2);
    const range = hi - lo || 1;
    const H = height;
    const cw = $b7b57ad44712e2b0$var$VIEWBOX_W - $b7b57ad44712e2b0$var$PAD.l - $b7b57ad44712e2b0$var$PAD.r;
    const ch = H - $b7b57ad44712e2b0$var$PAD.t - $b7b57ad44712e2b0$var$PAD.b;
    const xOf = (i)=>$b7b57ad44712e2b0$var$PAD.l + i / (plottable.length - 1) * cw;
    const yOf = (v)=>$b7b57ad44712e2b0$var$PAD.t + ch - (v - lo) / range * ch;
    const path = plottable.map((r, i)=>`${xOf(i).toFixed(1)},${yOf(r.num).toFixed(1)}`).join(' ');
    const xStep = Math.max(1, Math.floor(plottable.length / 5));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: `0 0 ${$b7b57ad44712e2b0$var$VIEWBOX_W} ${H}`,
        // Decorative by contract: every screen that plots a series also lists the
        // readings, and the list is the accessible equivalent (§12).
        "aria-hidden": true,
        focusable: "false",
        className: (0, $5JYPc.cn)(className),
        "data-state": "content",
        // A time axis reads left→right regardless of the page's direction.
        style: {
            width: '100%',
            height: H,
            display: 'block',
            overflow: 'visible',
            direction: 'ltr',
            ...style
        },
        ...rest
    }, refLow != null && refHigh != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: $b7b57ad44712e2b0$var$PAD.l,
        y: yOf(refHigh),
        width: cw,
        height: Math.abs(yOf(refLow) - yOf(refHigh)),
        fill: (0, $jTCZr.soft)(color, 0.08),
        rx: "2"
    }), Array.from({
        length: gridLines + 1
    }, (_, i)=>{
        const v = lo + range / gridLines * i;
        const y = yOf(v);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
            key: i
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
            x1: $b7b57ad44712e2b0$var$PAD.l,
            x2: $b7b57ad44712e2b0$var$PAD.l + cw,
            y1: y,
            y2: y,
            stroke: (0, $jTCZr.CT).border,
            strokeWidth: "1"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
            x: $b7b57ad44712e2b0$var$PAD.l - 5,
            y: y + 4,
            textAnchor: "end",
            fontSize: "10",
            fill: (0, $jTCZr.CT).mute
        }, formatValue(v)));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polyline", {
        points: path,
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinejoin: "round",
        strokeLinecap: "round"
    }), plottable.map((r, i)=>{
        const cx = xOf(i);
        const cy = yOf(r.num);
        const dot = $b7b57ad44712e2b0$var$STATUS_TONE[r.status] || color;
        const label = i % xStep === 0 && formatX ? formatX(r, i) : null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
            key: r.id ?? i
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
            cx: cx,
            cy: cy,
            r: "4",
            fill: (0, $jTCZr.CT).surface,
            stroke: dot,
            strokeWidth: "2"
        }), label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
            x: cx,
            y: H - 6,
            textAnchor: "middle",
            fontSize: "9",
            fill: (0, $jTCZr.CT).mute
        }, label));
    }), refHigh != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
        x: $b7b57ad44712e2b0$var$PAD.l + cw + 4,
        y: yOf(refHigh) + 4,
        fontSize: "9",
        fill: (0, $jTCZr.CT).mute
    }, formatValue(refHigh)), refLow != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
        x: $b7b57ad44712e2b0$var$PAD.l + cw + 4,
        y: yOf(refLow) + 4,
        fontSize: "9",
        fill: (0, $jTCZr.CT).mute
    }, formatValue(refLow)));
};
var $b7b57ad44712e2b0$export$2e2bcd8739ae039 = $b7b57ad44712e2b0$var$TrendChart;

});

parcelRegister("cPdQE", function(module, exports) {

$parcel$export(module.exports, "default", () => $88ed18dfb45d0422$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $5JYPc = parcelRequire("5JYPc");

var $cRX9v = parcelRequire("cRX9v");

var $b9CYW = parcelRequire("b9CYW");
'use client';
// ─────────────────────────────────────────────────────────────────────────────
// TimeRuler — the clock a stack of timeline lanes shares.
//
// It draws the tick labels once, at the top of the stack, so the lanes beneath
// stay pure plot. The caller owns the calendar: it supplies the tick
// timestamps and `formatTick`, exactly as `TrendChart.formatX` already does —
// the kit never decides that a boundary is a Jalali month rather than a week.
//
// Time reads left→right even on an RTL page (`direction: ltr`), the convention
// `Sparkline` and `TrendChart` already set; the surrounding labels stay RTL.
//
//   scale     — from createTimeScale, or pass xMin/xMax/width and let it build
//   ticks     — timestamps (ms) to label
//   formatTick(t, i) → node
//   nowAt     — timestamp of «now», drawn as the accent boundary
//   cursorAt  — synced crosshair position
//   markers   — optional [{ t, tone, shape, label }] event dots riding the axis
// ─────────────────────────────────────────────────────────────────────────────
const $88ed18dfb45d0422$var$TimeRuler = ({ xMin: xMin, xMax: xMax, width: width = 640, scale: scaleProp, ticks: ticks = [], formatTick: formatTick, nowAt: nowAt, cursorAt: cursorAt, markers: markers, height: height = 52, labelGap: labelGap = 56, className: className, style: style, ...rest })=>{
    const scale = scaleProp || (0, $cRX9v.createTimeScale)({
        min: xMin,
        max: xMax,
        width: width,
        padStart: (0, $b9CYW.LANE_PAD).start,
        padEnd: (0, $b9CYW.LANE_PAD).end
    });
    const axisY = height - 18;
    // Labels thin out rather than collide: a tick keeps its gridline always, but
    // only prints its label when it clears the previous printed one. The newest
    // boundary is the anchor a reader looks for, so labelling walks from the end.
    const labelled = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const keep = new Set();
        let lastX = Infinity;
        for(let i = ticks.length - 1; i >= 0; i -= 1){
            const t = ticks[i];
            if (!scale.inWindow(t)) continue;
            const x = scale.x(t);
            if (lastX - x >= labelGap) {
                keep.add(i);
                lastX = x;
            }
        }
        return keep;
    }, [
        ticks,
        scale,
        labelGap
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: `0 0 ${Math.max(1, width)} ${height}`,
        width: width,
        height: height,
        preserveAspectRatio: "xMinYMid meet",
        // Decorative by contract (DESIGN.md data-viz rule): the readout and the
        // table view carry the same information for assistive tech.
        "aria-hidden": true,
        focusable: "false",
        className: (0, $5JYPc.cn)(className),
        style: {
            display: 'block',
            direction: 'ltr',
            ...style
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b9CYW.LaneGrid), {
        scale: scale,
        ticks: ticks,
        top: 0,
        bottom: axisY
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b9CYW.NowLine), {
        scale: scale,
        at: nowAt,
        top: 0,
        bottom: axisY
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b9CYW.CursorLine), {
        scale: scale,
        at: cursorAt,
        top: 0,
        bottom: axisY
    }), (markers || []).map((m, i)=>{
        if (!scale.inWindow(m.t)) return null;
        const cx = scale.x(m.t);
        const cy = axisY - 20;
        if (m.shape === 'cross') {
            const r = 4;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
                key: m.id ?? i,
                stroke: m.tone || (0, $jTCZr.CT).mute,
                strokeWidth: "1.6",
                strokeLinecap: "round"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
                x1: cx - r,
                y1: cy - r,
                x2: cx + r,
                y2: cy + r
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
                x1: cx - r,
                y1: cy + r,
                x2: cx + r,
                y2: cy - r
            }));
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
            key: m.id ?? i,
            cx: cx,
            cy: cy,
            r: "4.5",
            fill: m.filled ? m.tone || (0, $jTCZr.CT).accent : (0, $jTCZr.CT).surface,
            stroke: m.tone || (0, $jTCZr.CT).mute,
            strokeWidth: "2"
        });
    }), formatTick && ticks.map((t, i)=>{
        if (!labelled.has(i)) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
            key: i,
            x: scale.x(t),
            y: height - 5,
            textAnchor: "middle",
            fill: (0, $jTCZr.CT).mute,
            style: {
                fontSize: '0.625rem'
            }
        }, formatTick(t, i));
    }));
};
var $88ed18dfb45d0422$export$2e2bcd8739ae039 = $88ed18dfb45d0422$var$TimeRuler;

});
parcelRegister("cRX9v", function(module, exports) {

$parcel$export(module.exports, "createTimeScale", () => $95e851aef96b9382$export$27d74465d4d4bf01);
$parcel$export(module.exports, "thinPoints", () => $95e851aef96b9382$export$849b7cb2b6ea39a7);
// ─────────────────────────────────────────────────────────────────────────────
// timeScale — the shared time→pixel mapping behind the kit's timeline charts.
//
// A timeline is only useful when every lane agrees on the clock: the whole
// point of stacking a measurement strip over an interval bar is that a vertical
// line means «the same moment». So the scale is computed ONCE by the caller and
// handed to every lane, instead of each chart deriving its own domain from its
// own data (which would silently misalign lanes with different date coverage).
//
// Domain-free by contract: milliseconds in, viewBox units out. The kit never
// decides what a date *means* — locale, calendar and label text stay with the
// app (the same division `TrendChart.formatX` already draws).
// ─────────────────────────────────────────────────────────────────────────────
// A linear scale over [min,max] → [padStart, width-padEnd].
//
//   scale.x(t)        → viewBox x for a timestamp (ms)
//   scale.invert(px)  → timestamp for a viewBox x
//   scale.clampX(t)   → x, clamped into the plot area (bars that start before
//                       the window still render, flush to the edge)
//   scale.inWindow(t) → is this timestamp inside the visible domain
function $95e851aef96b9382$export$27d74465d4d4bf01({ min: min, max: max, width: width, padStart: padStart = 0, padEnd: padEnd = 0 }) {
    const span = max - min || 1;
    const x0 = padStart;
    const x1 = Math.max(padStart + 1, width - padEnd);
    const w = x1 - x0;
    const x = (t)=>x0 + (t - min) / span * w;
    return {
        min: min,
        max: max,
        x0: x0,
        x1: x1,
        width: w,
        x: x,
        clampX: (t)=>Math.min(x1, Math.max(x0, x(t))),
        invert: (px)=>min + (px - x0) / w * span,
        inWindow: (t)=>t >= min && t <= max
    };
}
function $95e851aef96b9382$export$b9a1c56e49c8e590(min, max, count = 6) {
    const step = (max - min) / Math.max(1, count);
    return Array.from({
        length: count + 1
    }, (_, i)=>min + step * i);
}
function $95e851aef96b9382$export$849b7cb2b6ea39a7(points, scale, minGapPx = 8, isSignificant) {
    if (!points || points.length < 3) return points || [];
    const out = [];
    let lastX = -Infinity;
    points.forEach((p, i)=>{
        const px = scale.x(p.x);
        const keep = i === 0 || i === points.length - 1 || (isSignificant ? isSignificant(p) : false) || px - lastX >= minGapPx;
        if (keep) {
            out.push(p);
            lastX = px;
        }
    });
    return out;
}

});

parcelRegister("b9CYW", function(module, exports) {

$parcel$export(module.exports, "LaneGrid", () => $33096ab4a7258714$export$52ff61eca6e84e5a);
$parcel$export(module.exports, "NowLine", () => $33096ab4a7258714$export$cb94255ec4be9f06);
$parcel$export(module.exports, "CursorLine", () => $33096ab4a7258714$export$5c09e766dd7f9830);
$parcel$export(module.exports, "statusTone", () => $33096ab4a7258714$export$348dc3495f07d294);
$parcel$export(module.exports, "LANE_PAD", () => $33096ab4a7258714$export$3b8c55d8340f8b88);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
'use client';
const $33096ab4a7258714$export$52ff61eca6e84e5a = ({ scale: scale, ticks: ticks, top: top = 0, bottom: bottom })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        "aria-hidden": true
    }, (ticks || []).map((t, i)=>{
        if (!scale.inWindow(t)) return null;
        const x = Math.round(scale.x(t)) + 0.5; // crisp hairline
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
            key: i,
            "data-chrome": "grid",
            x1: x,
            x2: x,
            y1: top,
            y2: bottom,
            stroke: (0, $jTCZr.CT).border,
            strokeWidth: "1"
        });
    }));
const $33096ab4a7258714$export$cb94255ec4be9f06 = ({ scale: scale, at: at, top: top = 0, bottom: bottom })=>{
    if (at == null || !scale.inWindow(at)) return null;
    const x = Math.round(scale.x(at)) + 0.5;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
        "data-chrome": "now",
        x1: x,
        x2: x,
        y1: top,
        y2: bottom,
        stroke: (0, $jTCZr.CT).accent,
        strokeWidth: "1",
        opacity: "0.9",
        "aria-hidden": true
    });
};
const $33096ab4a7258714$export$5c09e766dd7f9830 = ({ scale: scale, at: at, top: top = 0, bottom: bottom })=>{
    if (at == null || !scale.inWindow(at)) return null;
    const x = Math.round(scale.x(at)) + 0.5;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
        "data-chrome": "cursor",
        x1: x,
        x2: x,
        y1: top,
        y2: bottom,
        stroke: (0, $jTCZr.CT).mute,
        strokeWidth: "1",
        opacity: "0.75",
        "aria-hidden": true
    });
};
const $33096ab4a7258714$export$348dc3495f07d294 = (status, fallback)=>{
    const s = String(status || '').toLowerCase();
    if (s === 'critical') return (0, $jTCZr.CT).danger;
    if (s === 'abnormal' || s === 'high' || s === 'low' || s === 'h' || s === 'l') return (0, $jTCZr.CT).warn;
    return fallback;
};
const $33096ab4a7258714$export$3b8c55d8340f8b88 = {
    start: 44,
    end: 12
};

});


parcelRegister("kCQwN", function(module, exports) {

$parcel$export(module.exports, "default", () => $db32618d5eb876e6$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $5JYPc = parcelRequire("5JYPc");

var $cRX9v = parcelRequire("cRX9v");

var $b9CYW = parcelRequire("b9CYW");
'use client';
// ─────────────────────────────────────────────────────────────────────────────
// SeriesLane — one measurement plotted against a SHARED time axis.
//
// The time-domain sibling of `TrendChart`. The two are deliberately different
// components rather than one with a mode, because they answer different
// questions and their x-axes are not the same kind of thing:
//
//   TrendChart  — one series, standalone, points spaced by INDEX. «How has this
//                 analyte moved?» Even spacing is a feature there: it spends
//                 every pixel on shape, and a lone chart has nothing to align to.
//   SeriesLane  — points sit at their real TIMESTAMPS on a domain the caller
//                 owns, so several lanes stack into one timeline and a vertical
//                 line means «the same moment» in all of them.
//
// Multiple series per lane are for the components of ONE measurement (systolic
// and diastolic), never for unrelated metrics: those get their own lane with
// their own value scale. Two unrelated measures sharing one y-axis is the
// dual-axis mistake, and it invents correlations that are not in the data.
//
//   series      — [{ points:[{x,y,status?,id?}], color?, label? }] (x = ms, sorted)
//   refLow/High — reference band + the window it must stay inside
//   ticks       — the shared gridline timestamps
//   formatValue — value-axis labels; the caller owns the locale/digits
// ─────────────────────────────────────────────────────────────────────────────
const $db32618d5eb876e6$var$PAD_TOP = 10;
const $db32618d5eb876e6$var$PAD_BOTTOM = 8;
const $db32618d5eb876e6$var$SeriesLane = ({ xMin: xMin, xMax: xMax, width: width = 640, scale: scaleProp, series: series = [], refLow: refLow, refHigh: refHigh, height: height = 88, ticks: ticks = [], nowAt: nowAt, cursorAt: cursorAt, gridLines: gridLines = 2, formatValue: formatValue = (v)=>String(Math.round(v * 10) / 10), emptyLabel: emptyLabel, className: className, style: style, ...rest })=>{
    const scale = scaleProp || (0, $cRX9v.createTimeScale)({
        min: xMin,
        max: xMax,
        width: width,
        padStart: (0, $b9CYW.LANE_PAD).start,
        padEnd: (0, $b9CYW.LANE_PAD).end
    });
    const lanes = (series || []).map((s)=>({
            ...s,
            points: (s.points || []).filter((p)=>p && Number.isFinite(p.y))
        })).filter((s)=>s.points.length);
    const all = lanes.flatMap((s)=>s.points.map((p)=>p.y));
    if (!all.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $5JYPc.cn)(className),
        "data-state": "empty",
        style: {
            height: height,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '0.6875rem',
            color: (0, $jTCZr.CT).mute,
            ...style
        },
        ...rest
    }, emptyLabel || null);
    // The value window always contains the reference band: a result is read
    // against its range, so a band pushed off-canvas would hide the very thing
    // that makes the number mean something.
    const dataMin = Math.min(...all, refLow ?? Infinity);
    const dataMax = Math.max(...all, refHigh ?? -Infinity);
    const span = dataMax - dataMin;
    const lo = dataMin - (span * 0.18 || Math.abs(dataMin * 0.1) || 1);
    const hi = dataMax + (span * 0.18 || Math.abs(dataMax * 0.1) || 1);
    const range = hi - lo || 1;
    const plotTop = $db32618d5eb876e6$var$PAD_TOP;
    const plotBottom = height - $db32618d5eb876e6$var$PAD_BOTTOM;
    const yOf = (v)=>plotTop + (plotBottom - plotTop) - (v - lo) / range * (plotBottom - plotTop);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: `0 0 ${Math.max(1, width)} ${height}`,
        width: width,
        height: height,
        preserveAspectRatio: "xMinYMid meet",
        "aria-hidden": true,
        focusable: "false",
        "data-state": "content",
        className: (0, $5JYPc.cn)(className),
        style: {
            display: 'block',
            direction: 'ltr',
            ...style
        },
        ...rest
    }, refLow != null && refHigh != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: scale.x0,
        y: yOf(refHigh),
        width: scale.x1 - scale.x0,
        height: Math.max(1, Math.abs(yOf(refLow) - yOf(refHigh))),
        fill: (0, $jTCZr.soft)((0, $jTCZr.CT).accent, 0.09)
    }), Array.from({
        length: gridLines + 1
    }, (_, i)=>{
        const v = lo + range / gridLines * i;
        const y = Math.round(yOf(v)) + 0.5;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
            key: `g${i}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
            x1: scale.x0,
            x2: scale.x1,
            y1: y,
            y2: y,
            stroke: (0, $jTCZr.CT).border,
            strokeWidth: "1"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
            x: scale.x0 - 6,
            y: y + 3,
            textAnchor: "end",
            fill: (0, $jTCZr.CT).mute,
            style: {
                fontSize: '0.5625rem'
            }
        }, formatValue(v)));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b9CYW.LaneGrid), {
        scale: scale,
        ticks: ticks,
        top: plotTop,
        bottom: plotBottom
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b9CYW.NowLine), {
        scale: scale,
        at: nowAt,
        top: plotTop,
        bottom: plotBottom
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b9CYW.CursorLine), {
        scale: scale,
        at: cursorAt,
        top: plotTop,
        bottom: plotBottom
    }), lanes.map((s, si)=>{
        const color = s.color || (0, $jTCZr.CT).accent;
        const inWin = s.points.filter((p)=>p.x >= scale.min && p.x <= scale.max);
        if (!inWin.length) return null;
        const path = inWin.map((p)=>`${scale.x(p.x).toFixed(1)},${yOf(p.y).toFixed(1)}`).join(' ');
        // Dots thin when dense, but an out-of-range reading is never thinned
        // away — the abnormal point is the one the doctor came for.
        const dots = (0, $cRX9v.thinPoints)(inWin, scale, 9, (p)=>!!p.status && p.status !== 'normal');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
            key: s.id ?? si
        }, inWin.length > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polyline", {
            points: path,
            fill: "none",
            stroke: color,
            strokeWidth: "2",
            strokeLinejoin: "round",
            strokeLinecap: "round"
        }), dots.map((p, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
                key: p.id ?? i,
                cx: scale.x(p.x),
                cy: yOf(p.y),
                r: "3.5",
                fill: (0, $jTCZr.CT).surface,
                stroke: (0, $b9CYW.statusTone)(p.status, color),
                strokeWidth: "2"
            })));
    }));
};
var $db32618d5eb876e6$export$2e2bcd8739ae039 = $db32618d5eb876e6$var$SeriesLane;

});

parcelRegister("ctU9L", function(module, exports) {

$parcel$export(module.exports, "default", () => $c413dd52a563653b$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $5JYPc = parcelRequire("5JYPc");

var $cRX9v = parcelRequire("cRX9v");

var $b9CYW = parcelRequire("b9CYW");
'use client';
// ─────────────────────────────────────────────────────────────────────────────
// IntervalBars — spans of time as bars on a shared axis (a Gantt lane).
//
// Some facts are not points: a prescription is an exposure window, a shift is a
// span of coverage. Plotted as intervals against the same clock as the
// measurement lanes, they answer the question a dot never can — «was this
// running while that changed?».
//
//   rows  — [{ id, label, segments: [{ from, to, label?, tone?, open? }] }]
//           `to == null` (or open) ⇒ still running: the bar reaches `nowAt`
//           and takes an arrow cap instead of a flat end.
//
// Adjacent segments of one row are separated by a 2px gap in the surface
// colour — never a stroke around the bar: the gap is the separator, a border
// would add ink that is not data. That gap is also how a dosage change reads
// as a change rather than one long uninterrupted bar.
// ─────────────────────────────────────────────────────────────────────────────
const $c413dd52a563653b$var$SEG_GAP = 2;
// SVG has no text-overflow, and slicing a string is the wrong tool for a label
// that may be RTL: cutting Persian text and appending «…» puts the ellipsis on
// the visually *leading* edge, so the label reads as though its beginning were
// missing. So a label is drawn only when it fits whole (measure-free estimate at
// the label's font size, ~6.2px/char for the mixed fa/Latin names this carries);
// otherwise it is dropped and the value lives in the row header and the table.
// «A label that won't fit doesn't get clipped.»
const $c413dd52a563653b$var$CHAR_W = 6.2;
const $c413dd52a563653b$var$labelFits = (label, room)=>String(label).length * $c413dd52a563653b$var$CHAR_W <= room;
const $c413dd52a563653b$var$IntervalBars = ({ xMin: xMin, xMax: xMax, width: width = 640, scale: scaleProp, rows: rows = [], rowHeight: rowHeight = 26, barThickness: barThickness = 15, height: height, ticks: ticks = [], nowAt: nowAt, cursorAt: cursorAt, formatLabel: formatLabel, className: className, style: style, ...rest })=>{
    const scale = scaleProp || (0, $cRX9v.createTimeScale)({
        min: xMin,
        max: xMax,
        width: width,
        padStart: (0, $b9CYW.LANE_PAD).start,
        padEnd: (0, $b9CYW.LANE_PAD).end
    });
    const h = height || Math.max(rowHeight, rows.length * rowHeight + 8);
    const r = barThickness / 2;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: `0 0 ${Math.max(1, width)} ${h}`,
        width: width,
        height: h,
        preserveAspectRatio: "xMinYMid meet",
        "aria-hidden": true,
        focusable: "false",
        "data-state": rows.length ? 'content' : 'empty',
        className: (0, $5JYPc.cn)(className),
        style: {
            display: 'block',
            direction: 'ltr',
            ...style
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b9CYW.LaneGrid), {
        scale: scale,
        ticks: ticks,
        top: 0,
        bottom: h
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b9CYW.NowLine), {
        scale: scale,
        at: nowAt,
        top: 0,
        bottom: h
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b9CYW.CursorLine), {
        scale: scale,
        at: cursorAt,
        top: 0,
        bottom: h
    }), rows.map((row, ri)=>{
        const cy = 4 + ri * rowHeight + rowHeight / 2;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
            key: row.id ?? ri
        }, (row.segments || []).map((seg, si)=>{
            const open = seg.open || seg.to == null;
            const rawTo = open ? nowAt ?? scale.max : seg.to;
            if (seg.from > scale.max || rawTo < scale.min) return null;
            const x1 = scale.clampX(seg.from);
            // The gap belongs to every segment but the row's last one.
            const isLast = si === row.segments.length - 1;
            const x2 = Math.max(x1 + 2, scale.clampX(rawTo) - (isLast ? 0 : $c413dd52a563653b$var$SEG_GAP));
            const w = Math.max(2, x2 - x1);
            const tone = seg.tone || (0, $jTCZr.CT).navy;
            const label = formatLabel ? formatLabel(seg, row) : seg.label;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
                key: seg.id ?? si
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
                x: x1,
                y: cy - r,
                width: w,
                height: barThickness,
                rx: Math.min(4, r),
                fill: tone
            }), open && scale.inWindow(rawTo) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: `M${x2 - 1},${cy - r} L${x2 + 6},${cy} L${x2 - 1},${cy + r} Z`,
                fill: tone
            }), label && w > 52 && $c413dd52a563653b$var$labelFits(label, w - 14) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
                x: x1 + w / 2,
                y: cy + 3.5,
                textAnchor: "middle",
                fill: "#ffffff",
                style: {
                    fontSize: '0.625rem',
                    fontWeight: 700,
                    direction: 'rtl'
                }
            }, label));
        }));
    }));
};
var $c413dd52a563653b$export$2e2bcd8739ae039 = $c413dd52a563653b$var$IntervalBars;

});

parcelRegister("cLQXb", function(module, exports) {

$parcel$export(module.exports, "default", () => $b578d6619b9c2e00$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $5JYPc = parcelRequire("5JYPc");

var $cRX9v = parcelRequire("cRX9v");

var $b9CYW = parcelRequire("b9CYW");
'use client';
// ─────────────────────────────────────────────────────────────────────────────
// EventMarkers — discrete moments on a shared time axis.
//
// The lane for things that happen rather than things that are measured: a
// diagnosis recorded, an order placed, a document filed. Each mark carries its
// identity in its SHAPE and its row as well as its tone, so the lane still
// reads under colour-blindness, in monochrome print, and — the case that
// actually bites — under an accent preset where two brand hues sit close
// together. Colour reinforces identity here; it never carries it alone.
//
//   events — [{ id, t, row, label, tone, shape }]
//            shape: 'triangle' | 'diamond' | 'circle' | 'square'
//            row:   0-based lane row (events of a kind share a row)
//
// Labels are placed left→right and only when they clear the previous label on
// the same row; the rest stay reachable through the crosshair readout and the
// table view. A dense month is normal for a sick patient, and overlapping
// labels would make exactly those months unreadable.
// ─────────────────────────────────────────────────────────────────────────────
const $b578d6619b9c2e00$var$SHAPES = {
    triangle: (cx, cy, s)=>`M${cx},${cy - s} L${cx + s},${cy + s * 0.8} L${cx - s},${cy + s * 0.8} Z`,
    diamond: (cx, cy, s)=>`M${cx},${cy - s} L${cx + s},${cy} L${cx},${cy + s} L${cx - s},${cy} Z`,
    square: (cx, cy, s)=>`M${cx - s},${cy - s} L${cx + s},${cy - s} L${cx + s},${cy + s} L${cx - s},${cy + s} Z`
};
const $b578d6619b9c2e00$var$CHAR_W = 5.6;
const $b578d6619b9c2e00$var$EventMarkers = ({ xMin: xMin, xMax: xMax, width: width = 640, scale: scaleProp, events: events = [], rows: rows = 1, rowHeight: rowHeight = 22, height: height, size: size = 5, ticks: ticks = [], nowAt: nowAt, cursorAt: cursorAt, showLabels: showLabels = true, className: className, style: style, ...rest })=>{
    const scale = scaleProp || (0, $cRX9v.createTimeScale)({
        min: xMin,
        max: xMax,
        width: width,
        padStart: (0, $b9CYW.LANE_PAD).start,
        padEnd: (0, $b9CYW.LANE_PAD).end
    });
    const h = height || rows * rowHeight + 10;
    // Declutter per row, walking forward; `labelEnd` tracks where the last
    // printed label finished so the next one only prints if it clears it.
    const placed = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const rowEnd = {};
        return [
            ...events
        ].filter((e)=>scale.inWindow(e.t)).sort((a, b)=>a.t - b.t).map((e)=>{
            const x = scale.x(e.t);
            const row = e.row || 0;
            const textW = String(e.label || '').length * $b578d6619b9c2e00$var$CHAR_W;
            const start = x + 9;
            const show = showLabels && !!e.label && start >= (rowEnd[row] ?? -Infinity) + 8;
            if (show) rowEnd[row] = start + textW;
            return {
                ...e,
                x: x,
                row: row,
                showLabel: show
            };
        });
    }, [
        events,
        scale,
        showLabels
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: `0 0 ${Math.max(1, width)} ${h}`,
        width: width,
        height: h,
        preserveAspectRatio: "xMinYMid meet",
        "aria-hidden": true,
        focusable: "false",
        "data-state": events.length ? 'content' : 'empty',
        className: (0, $5JYPc.cn)(className),
        style: {
            display: 'block',
            direction: 'ltr',
            ...style
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b9CYW.LaneGrid), {
        scale: scale,
        ticks: ticks,
        top: 0,
        bottom: h
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b9CYW.NowLine), {
        scale: scale,
        at: nowAt,
        top: 0,
        bottom: h
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b9CYW.CursorLine), {
        scale: scale,
        at: cursorAt,
        top: 0,
        bottom: h
    }), placed.map((e, i)=>{
        const cy = 6 + e.row * rowHeight + rowHeight / 2;
        const tone = e.tone || (0, $jTCZr.CT).accent;
        const path = $b578d6619b9c2e00$var$SHAPES[e.shape];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
            key: e.id ?? i
        }, path ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: path(e.x, cy, size + 1),
            fill: tone,
            stroke: (0, $jTCZr.CT).surface,
            strokeWidth: "1.5"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
            cx: e.x,
            cy: cy,
            r: size,
            fill: tone,
            stroke: (0, $jTCZr.CT).surface,
            strokeWidth: "1.5"
        }), e.showLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
            x: e.x + 9,
            y: cy + 3.5,
            fill: (0, $jTCZr.CT).ink2,
            style: {
                fontSize: '0.625rem'
            }
        }, e.label));
    }));
};
var $b578d6619b9c2e00$export$2e2bcd8739ae039 = $b578d6619b9c2e00$var$EventMarkers;

});

parcelRegister("3uzzV", function(module, exports) {

$parcel$export(module.exports, "default", () => $28afc58f3cd2c6a9$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
function $28afc58f3cd2c6a9$export$7266b1e659c4866f(initial = 640) {
    const [width, setWidth] = (0, $acw62.useState)(initial);
    const observerRef = (0, $acw62.useRef)(null);
    const ref = (0, $acw62.useCallback)((node)=>{
        if (observerRef.current) {
            observerRef.current.disconnect();
            observerRef.current = null;
        }
        // Expose the node on the callback ref itself.
        ref.current = node;
        if (!node) return;
        const read = ()=>{
            const w = node.clientWidth || node.getBoundingClientRect?.().width || 0;
            // Sub-pixel jitter would re-render every lane on every scroll.
            if (w > 0) setWidth((prev)=>Math.abs(prev - w) >= 0.5 ? w : prev);
        };
        read();
        if (typeof ResizeObserver !== 'undefined') {
            const ro = new ResizeObserver(read);
            ro.observe(node);
            observerRef.current = ro;
        }
    }, []);
    return [
        ref,
        width
    ];
}
var $28afc58f3cd2c6a9$export$2e2bcd8739ae039 = $28afc58f3cd2c6a9$export$7266b1e659c4866f;

});

parcelRegister("kLmaN", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1d9659251ef0350$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
function $f1d9659251ef0350$export$2e2bcd8739ae039(ref, varName = '--app-bottom-dock', enabled = true) {
    (0, $acw62.useEffect)(()=>{
        const el = ref?.current;
        if (!enabled || !el || !varName || typeof document === 'undefined') return undefined;
        const root = document.documentElement;
        const publish = ()=>root.style.setProperty(varName, `${Math.round(el.offsetHeight)}px`);
        publish();
        // Absent in jsdom and older webviews; the one-shot measurement stands in.
        const ro = typeof ResizeObserver === 'function' ? new ResizeObserver(publish) : null;
        if (ro) ro.observe(el);
        return ()=>{
            if (ro) ro.disconnect();
            root.style.removeProperty(varName);
        };
    }, [
        ref,
        varName,
        enabled
    ]);
}

});

parcelRegister("2u27R", function(module, exports) {

var $acw62 = parcelRequire("acw62");
function $1cf0083ab82acba7$export$8f772b88f40431ca({ pairingUrl: pairingUrl, getToken: getToken, headers: headers, loadSession: loadSession, unlinkSession: unlinkSession, pollWhileDisconnected: pollWhileDisconnected = false } = {}) {
    const [session, setSession] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    // The live pairing attempt: { kind, code, expiresAt, message } or null.
    const [pairing, setPairing] = (0, $acw62.useState)(null);
    const controller = (0, $acw62.useRef)(null);
    // The callers are re-created on every render by most call sites, and a
    // dependency on them would restart the effects below forever. The ref is read
    // at call time, so the newest one is always the one used.
    const io = (0, $acw62.useRef)({
        getToken: getToken,
        headers: headers,
        loadSession: loadSession,
        unlinkSession: unlinkSession
    });
    (0, $acw62.useEffect)(()=>{
        io.current = {
            getToken: getToken,
            headers: headers,
            loadSession: loadSession,
            unlinkSession: unlinkSession
        };
    });
    const refetch = (0, $acw62.useCallback)(async ()=>{
        try {
            const next = await io.current.loadSession?.() || null;
            setSession(next);
            setError(null);
            return next;
        } catch (err) {
            setError(err);
            return null;
        } finally{
            setLoading(false);
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        refetch();
    }, [
        refetch
    ]);
    const stopPairing = (0, $acw62.useCallback)(()=>{
        // Aborting closes the HTTP response, which the BFF turns into a gRPC cancel.
        // Without it the gateway holds a fresh, half-linked device open for the full
        // three-minute window and the phone accumulates abandoned entries in its
        // «linked devices» list.
        controller.current?.abort();
        controller.current = null;
        setPairing(null);
    }, []);
    // Whatever happens — a tab closed, a route change, a component unmounted — the
    // stream must not outlive the screen that opened it.
    (0, $acw62.useEffect)(()=>()=>{
            controller.current?.abort();
        }, []);
    // DISCONNECTED is transient and recovers on its own, which is why a screen that
    // gates an action on the link may ask to watch it: somebody who fixes the link
    // in another tab must see the action become available without reopening
    // anything. Opt-in, because a settings page has no such need and a poll nobody
    // is watching is a request nobody wanted. PAIRING is NOT polled — the stream
    // delivers it.
    (0, $acw62.useEffect)(()=>{
        if (!pollWhileDisconnected || session?.state !== 'DISCONNECTED') return undefined;
        const timer = setInterval(refetch, 2500);
        return ()=>clearInterval(timer);
    }, [
        pollWhileDisconnected,
        session?.state,
        refetch
    ]);
    const startLink = (0, $acw62.useCallback)(async (method, phone)=>{
        stopPairing();
        // A new attempt clears the last one's failure. Without this the screen keeps
        // reporting a gateway that was down two minutes ago while a code is on the way.
        setError(null);
        const token = await io.current.getToken?.();
        if (!token) throw new Error('Not authenticated');
        const url = new URL(pairingUrl, typeof window === 'undefined' ? undefined : window.location.origin);
        url.searchParams.set('method', method === 'PAIRING_CODE' ? 'PAIRING_CODE' : 'QR');
        if (phone) url.searchParams.set('phone', phone);
        const ctrl = new AbortController();
        controller.current = ctrl;
        const extra = typeof io.current.headers === 'function' ? io.current.headers() || {} : io.current.headers || {};
        let res;
        try {
            res = await fetch(url.toString(), {
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: 'text/event-stream',
                    ...extra
                },
                signal: ctrl.signal
            });
        } catch (err) {
            // AN ABORT IS NOT A FAILURE, and reporting it as one is a bug users meet
            // constantly: while a code is slow to arrive the screen looks dead, so
            // people press the button again — or switch from QR to the typed code —
            // and THAT aborts this request. Rethrowing put the browser's own
            // «signal is aborted without reason» on a Persian screen, as the reason
            // the attempt they had just started had failed.
            //
            // `readStream` has always swallowed its own aborts for this reason; this
            // is the same rule on the half of the request that happens before the
            // stream exists.
            if (err?.name === 'AbortError') return false;
            throw err;
        }
        if (!res.ok || !res.body) {
            const body = await res.json().catch(()=>null);
            controller.current = null;
            // The BFF's own sentence when it has one — it knows whether this was a
            // missing permission, a missing account or an unreachable gateway, and the
            // screen does not. It travels as `serverMessage` rather than as the
            // Error's own message, so a caller that renders it cannot accidentally
            // render a DOMException's English text the same way. Absent on purpose
            // when the BFF said nothing: copy belongs in the caller's catalogue.
            const refusal = new Error(body?.error || 'pairing refused');
            refusal.serverMessage = body?.error || '';
            throw refusal;
        }
        setPairing({
            kind: 'CONNECTING',
            code: '',
            expiresAt: null,
            message: ''
        });
        // Deliberately not awaited: the stream lives for as long as the pairing does,
        // and the caller needs its button back the moment the first code can arrive.
        $1cf0083ab82acba7$var$readStream(res.body, ctrl, controller, {
            setPairing: setPairing,
            refetch: refetch,
            setError: setError
        });
        return true;
    }, [
        pairingUrl,
        refetch,
        stopPairing
    ]);
    const unlink = (0, $acw62.useCallback)(async ()=>{
        stopPairing();
        await io.current.unlinkSession?.();
        await refetch();
    }, [
        refetch,
        stopPairing
    ]);
    return {
        session: session,
        loading: loading,
        error: error,
        pairing: pairing,
        refetch: refetch,
        startLink: startLink,
        stopPairing: stopPairing,
        unlink: unlink,
        /** The one state where a message can actually leave the building. */ canSend: session?.state === 'CONNECTED'
    };
}
/**
 * Reads SSE frames off the response body.
 *
 * Frames are separated by a blank line and a frame's `data:` is one JSON object.
 * Lines beginning `:` are the server's keep-alive comments and carry nothing —
 * they exist so an intermediary does not close a connection that is idle between
 * two QR codes.
 */ async function $1cf0083ab82acba7$var$readStream(body, ctrl, controller, { setPairing: setPairing, refetch: refetch, setError: setError }) {
    const reader = body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';
    try {
        for(;;){
            const { value: value, done: done } = await reader.read();
            if (done) break;
            buffer += decoder.decode(value, {
                stream: true
            });
            let split;
            while((split = buffer.indexOf('\n\n')) >= 0){
                const frame = buffer.slice(0, split);
                buffer = buffer.slice(split + 2);
                const parsed = $1cf0083ab82acba7$export$9616b51a1be2e082(frame);
                if (!parsed) continue;
                if (parsed.event === 'error') {
                    // Server copy, or nothing — see the comment on the failed-response branch.
                    setError(new Error(parsed.data?.message || ''));
                    setPairing(null);
                    continue;
                }
                const { kind: kind, code: code, expiresInSeconds: expiresInSeconds, message: message } = parsed.data || {};
                if (kind === 'SUCCESS') {
                    setPairing(null);
                    await refetch();
                    continue;
                }
                if (kind === 'TIMEOUT' || kind === 'ERROR') {
                    setPairing({
                        kind: kind,
                        code: '',
                        expiresAt: null,
                        message: message || ''
                    });
                    continue;
                }
                setPairing({
                    kind: kind || 'QR',
                    code: code || '',
                    // An absolute instant, not a countdown: a component that re-renders for
                    // its own reasons must not restart the clock.
                    expiresAt: expiresInSeconds > 0 ? new Date(Date.now() + expiresInSeconds * 1000).toISOString() : null,
                    message: message || ''
                });
            }
        }
    } catch (err) {
        // An abort is this hook's own doing — the operator navigated away — and is
        // not a failure to report.
        if (err?.name !== 'AbortError') setError(err);
    } finally{
        // The stream that just finished may not be the one now in flight: pressing
        // «اتصال» twice aborts the first, and its cleanup must not wipe the second
        // one's code off the screen.
        if (controller.current === ctrl) {
            controller.current = null;
            setPairing(null);
        }
    }
}
function $1cf0083ab82acba7$export$9616b51a1be2e082(frame) {
    let event = 'message';
    const data = [];
    for (const line of String(frame).split('\n')){
        if (!line || line.startsWith(':')) continue;
        if (line.startsWith('event:')) event = line.slice(6).trim();
        else if (line.startsWith('data:')) data.push(line.slice(5).trim());
    }
    if (!data.length) return null;
    try {
        return {
            event: event,
            data: JSON.parse(data.join('\n'))
        };
    } catch  {
        return null;
    }
}
var $1cf0083ab82acba7$export$2e2bcd8739ae039 = $1cf0083ab82acba7$export$8f772b88f40431ca;

});

parcelRegister("fOdIP", function(module, exports) {

var $acw62 = parcelRequire("acw62");

var $huNwV = parcelRequire("huNwV");
var $kMJsW = parcelRequire("kMJsW");
var $QG9Z3 = parcelRequire("QG9Z3");

var $jTCZr = parcelRequire("jTCZr");

var $aJ1FU = parcelRequire("aJ1FU");
'use client';
/**
 * ChatBubble — one message in a conversation (kit-grade per DESIGN-CONCEPT
 * §17.2: tokens only, logical properties only, language-free, presentational).
 *
 * The chat-spec decisions this component encodes so no app re-derives them:
 *
 *  - **Alignment is `alignSelf`, never a margin hack.** `flex-end` for my
 *    messages, `flex-start` for the other party — logical values, so the whole
 *    conversation mirrors correctly under `dir="ltr"` with no direction prop.
 *  - **Radius 14px card scale (`0.875rem`) with a 10px "tail" corner**
 *    (`var(--radius, 0.625rem)`): the reduced corner sits on the block-end,
 *    *inline-start-or-end* edge nearest the sender — `borderEndEndRadius` on
 *    mine, `borderEndStartRadius` on theirs. Logical corners: the tail flips
 *    with the document direction by itself.
 *  - **No `•` separator ever** — the meta row (time + status) is a space-gap
 *    flex layout.
 *  - **A failed write must look failed**: `failed` restyles the surface from
 *    the `CT.danger*` family and renders a retry affordance; the caller decides
 *    when to actually re-send (`onRetry`).
 *  - **Delivery state is never colour-only.** Pass `status` and the bubble
 *    draws the glyph itself — `Clock` / `Check` / `TriangleAlert` — so the
 *    difference between "sending", "sent" and "failed" survives a colour-blind
 *    reader and a greyscale screen (DESIGN-CONCEPT §12 "colour is never the
 *    only carrier of meaning"). Apps do not ship their own dot.
 *
 * States (always stamped on the root as `data-state`): `sent` | `pending`
 * (60% opacity — visibly in flight) | `failed`.
 *
 * The root stays a plain div forwarding `...rest`; `role="listitem"` and any
 * grouping semantics are the caller's business.
 *
 * Props:
 *   body        — message text (rendered `dir="auto"`, pre-wrap, wraps anywhere)
 *   timeLabel   — pre-formatted time string; the calendar/locale stays with the app
 *   mine        — true for the authenticated user's own messages
 *   pending     — in-flight local echo (awaiting the server)
 *   failed      — the send failed; renders the retry affordance when `onRetry` given
 *   status      — 'pending' | 'sent' | 'failed': draws the delivery glyph. This
 *                 is the supported way to show delivery state; `statusLabel`
 *                 names it for screen readers.
 *   statusIcon  — escape hatch: a caller-supplied status node, used INSTEAD of
 *                 the built-in glyph
 *   statusLabel — screen-reader text for the status glyph (an icon alone says
 *                 nothing). NOTE: `statusLabel` on its own draws nothing
 *                 visible — it is the accessible name of a glyph, so it needs
 *                 `status` (or `statusIcon`) beside it. Dev builds warn.
 *   onRetry     — re-send handler; button rendered only when `failed`
 *   retryLabel  — label for the retry affordance
 *   style       — MERGED over the component's own layout, never replacing it
 *   className / data-testid — forwarded to the root (§15.1)
 */ // The delivery vocabulary the kit draws. Three states, three shapes — the
// glyph, not the hue, is what distinguishes them.
const $a6342f4e7688b45e$var$STATUS_GLYPH = {
    pending: (0, $kMJsW.default),
    sent: (0, $huNwV.default),
    failed: (0, $QG9Z3.default)
};
function $a6342f4e7688b45e$export$2e2bcd8739ae039({ body: body, timeLabel: timeLabel, mine: mine = false, pending: pending = false, failed: failed = false, status: status, statusIcon: statusIcon, statusLabel: statusLabel, onRetry: onRetry, retryLabel: retryLabel, className: className, style: style, 'data-testid': testId = 'chat-bubble', ...rest }) {
    const state = failed ? 'failed' : pending ? 'pending' : 'sent';
    // Surface per party; `failed` overrides both — an undelivered message is a
    // problem to act on, not a normal bubble at lower opacity.
    const surface = failed ? {
        background: (0, $jTCZr.CT).dangerSoft,
        color: (0, $jTCZr.CT).dangerInk,
        border: `1px solid ${(0, $jTCZr.soft)((0, $jTCZr.CT).danger, 0.4)}`
    } : mine ? {
        background: (0, $jTCZr.C).navy,
        color: '#ffffff',
        border: 'none'
    } : {
        background: (0, $jTCZr.C).card,
        color: (0, $jTCZr.C).textPrimary,
        border: `1px solid ${(0, $jTCZr.C).border}`
    };
    // Meta ink follows the surface. On navy the safe soft ink is literal white at
    // reduced opacity (colour arithmetic on a var() token is banned — soft() would
    // work, but #fff is the one sanctioned literal on navy).
    const metaStyle = failed ? {
        color: (0, $jTCZr.CT).dangerInk,
        opacity: 0.8
    } : mine ? {
        color: '#ffffff',
        opacity: 0.75
    } : {
        color: (0, $jTCZr.C).textMuted
    };
    const Glyph = status ? $a6342f4e7688b45e$var$STATUS_GLYPH[status] : null;
    // Tint: the muted ink for the two quiet states, the danger ink for a failed
    // write. The one exception is the navy `mine` surface, where a fixed grey is
    // simply unreadable — there the glyph inherits the meta row's ink, which is
    // already the muted value FOR that surface. Same intent, legible result.
    const glyphColor = mine && !failed ? 'currentColor' : status === 'failed' ? (0, $jTCZr.CT).danger : (0, $jTCZr.CT).mute;
    const glyph = statusIcon || (Glyph ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Glyph, {
        size: 13,
        strokeWidth: 2.25,
        "aria-hidden": true,
        style: {
            color: glyphColor
        }
    }) : null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        "data-testid": testId,
        style: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: mine ? 'flex-end' : 'flex-start',
            // Alignment via alignSelf ONLY — never marginInline hacks, never textAlign.
            alignSelf: mine ? 'flex-end' : 'flex-start',
            maxWidth: 'min(85%, 42rem)',
            gap: '0.25rem',
            // Caller style MERGES over the computed layout (the `Card` precedent) —
            // spreading it after `...rest` used to silently drop `alignSelf` and
            // take mine/theirs alignment with it.
            ...style
        },
        ...rest,
        // AFTER ...rest: the delivery state is derived, not caller-supplied.
        "data-state": state
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            ...surface,
            borderRadius: '0.875rem',
            // The "tail": the corner nearest the sender drops to the base radius.
            ...mine ? {
                borderEndEndRadius: 'var(--radius, 0.625rem)'
            } : {
                borderEndStartRadius: 'var(--radius, 0.625rem)'
            },
            padding: '0.5rem 0.875rem',
            ...pending && {
                opacity: 0.6
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: "auto",
        style: {
            fontSize: '0.875rem',
            lineHeight: 1.8,
            whiteSpace: 'pre-wrap',
            overflowWrap: 'anywhere'
        }
    }, body), (timeLabel || glyph || statusLabel) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            gap: '0.375rem',
            marginTop: '0.125rem',
            fontSize: '0.75rem',
            ...metaStyle
        }
    }, timeLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, timeLabel), glyph && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        role: "img",
        "aria-label": statusLabel,
        style: {
            display: 'inline-flex',
            alignItems: 'center'
        }
    }, glyph), !glyph && statusLabel && // Misuse (warned above), but the fact is not thrown away: assistive
    // tech still gets the delivery state.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            position: 'absolute',
            width: 1,
            height: 1,
            margin: -1,
            padding: 0,
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            clip: 'rect(0 0 0 0)',
            clipPath: 'inset(50%)',
            border: 0
        }
    }, statusLabel))), failed && onRetry && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        onClick: onRetry,
        "data-testid": `${testId}-retry`,
        // size="sm" is 2.25rem; this renders on both apps' phone threads,
        // where the floor is 2.75rem (DESIGN-CONCEPT-MOBILE §368).
        className: "min-h-11",
        style: {
            color: (0, $jTCZr.CT).danger
        }
    }, retryLabel));
}

});
parcelRegister("kMJsW", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b71f7c0d2454a8e$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $2b71f7c0d2454a8e$export$a2387ed3b5d536eb = {
    name: "clock",
    size: 24,
    node: [
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                r: "10",
                key: "1mglay"
            }
        ],
        [
            "path",
            {
                d: "M12 6v6l4 2",
                key: "mmk7yg"
            }
        ]
    ]
};
$2b71f7c0d2454a8e$export$a2387ed3b5d536eb.node;
const $2b71f7c0d2454a8e$export$2e2bcd8739ae039 = (0, $9QBug.default)($2b71f7c0d2454a8e$export$a2387ed3b5d536eb);

});


parcelRegister("l0ks6", function(module, exports) {

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
'use client';
function $01fd1e3fa9bffaa8$export$2e2bcd8739ae039({ label: label, className: className, style: style, 'data-testid': testId = 'chat-day-divider', ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        "data-testid": testId,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            paddingBlock: '0.5rem',
            // Caller style MERGES over the computed layout (the `Card` precedent):
            // arriving inside `...rest` it used to replace `display: flex` outright
            // and collapse the two hairlines.
            ...style
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true,
        style: {
            flex: 1,
            height: '1px',
            background: (0, $jTCZr.C).border
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.75rem',
            color: (0, $jTCZr.C).textMuted,
            background: (0, $jTCZr.C).bg,
            paddingInline: '0.625rem',
            borderRadius: 'var(--radius, 0.625rem)',
            whiteSpace: 'nowrap'
        }
    }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true,
        style: {
            flex: 1,
            height: '1px',
            background: (0, $jTCZr.C).border
        }
    }));
}

});

parcelRegister("jeN3v", function(module, exports) {

var $acw62 = parcelRequire("acw62");

var $6OGKD = parcelRequire("6OGKD");

var $jTCZr = parcelRequire("jTCZr");

var $5JYPc = parcelRequire("5JYPc");

var $5MbI8 = parcelRequire("5MbI8");

var $dOauK = parcelRequire("dOauK");
'use client';
function $27c9e9585cb6c9b4$export$2e2bcd8739ae039({ value: value, onChange: onChange, onSend: onSend, disabled: disabled = false, sending: sending = false, placeholder: placeholder, sendLabel: sendLabel, sendIcon: sendIcon, readOnlyNotice: readOnlyNotice, maxLength: maxLength = 4000, autoGrowMaxRem: autoGrowMaxRem = 7.5, className: className, style: style, 'data-testid': testId = 'chat-composer', inputProps: inputProps, ...rest }) {
    const fieldRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // Auto-grow: collapse, then take the content's scrollHeight. The rem clamp
    // lives in CSS (`maxHeight`), so the px assignment here never exceeds it and
    // the field starts scrolling instead of growing.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const el = fieldRef.current;
        if (!el) return;
        el.style.height = 'auto';
        el.style.height = `${el.scrollHeight}px`;
    }, [
        value,
        readOnlyNotice
    ]);
    if (readOnlyNotice) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        "data-testid": testId,
        style: {
            padding: '0.5rem 1rem',
            background: (0, $jTCZr.C).card,
            borderTop: `1px solid ${(0, $jTCZr.C).border}`,
            ...style
        },
        ...rest,
        "data-state": "readonly"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "info",
        "data-testid": `${testId}-notice`
    }, readOnlyNotice));
    const canSend = !disabled && !sending && Boolean(value && value.trim());
    const handleKeyDown = (e)=>{
        if (e.key !== 'Enter' || e.shiftKey) return;
        // Committing IME composition ends with Enter too — that one is not a send.
        if (e.nativeEvent && e.nativeEvent.isComposing) return;
        e.preventDefault();
        if (canSend) onSend();
    };
    const { className: fieldClassName, style: fieldStyle, ...fieldRest } = inputProps || {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        "data-testid": testId,
        style: {
            display: 'flex',
            alignItems: 'flex-end',
            gap: '0.5rem',
            padding: '0.5rem 1rem',
            background: (0, $jTCZr.C).card,
            borderTop: `1px solid ${(0, $jTCZr.C).border}`,
            // Caller style MERGES over the computed layout (the `Card` precedent).
            ...style
        },
        ...rest,
        // AFTER ...rest: the send lifecycle is the composer's own state.
        "data-state": sending ? 'sending' : 'ready'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("textarea", {
        ref: fieldRef,
        value: value,
        onChange: onChange,
        onKeyDown: handleKeyDown,
        placeholder: placeholder,
        "aria-label": placeholder,
        disabled: disabled || sending,
        rows: 1,
        maxLength: maxLength,
        dir: "auto",
        "data-testid": `${testId}-field`,
        className: (0, $5JYPc.cn)(// The replacement for the outline we suppress — keyboard focus on the
        // feature's primary input has to be visible (§12.2).
        'outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1', 'transition-shadow duration-150', fieldClassName),
        style: {
            flex: 1,
            minWidth: 0,
            // ≥1rem or iOS zooms the page on focus — the composer's iron rule.
            fontSize: '1rem',
            lineHeight: 1.6,
            fontFamily: 'inherit',
            color: (0, $jTCZr.C).textPrimary,
            background: (0, $jTCZr.C).card,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: 'var(--radius, 0.625rem)',
            padding: '0.625rem 0.875rem',
            resize: 'none',
            maxHeight: `${autoGrowMaxRem}rem`,
            overflowY: 'auto',
            ...disabled || sending ? {
                opacity: 0.6
            } : null,
            ...fieldStyle
        },
        ...fieldRest
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5MbI8.default), {
        icon: sendIcon || // RTL-first flip — see the header note; LTR apps override via sendIcon.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6OGKD.default), {
            size: 18,
            "aria-hidden": true,
            style: {
                transform: 'scaleX(-1)'
            }
        }),
        label: sendLabel,
        onClick: ()=>{
            if (canSend) onSend();
        },
        disabled: !canSend,
        "data-testid": `${testId}-send`
    }));
}

});
parcelRegister("6OGKD", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c49d7be4abd1b80$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $6c49d7be4abd1b80$export$a2387ed3b5d536eb = {
    name: "send",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z",
                key: "1ffxy3"
            }
        ],
        [
            "path",
            {
                d: "m21.854 2.147-10.94 10.939",
                key: "12cjpa"
            }
        ]
    ]
};
$6c49d7be4abd1b80$export$a2387ed3b5d536eb.node;
const $6c49d7be4abd1b80$export$2e2bcd8739ae039 = (0, $9QBug.default)($6c49d7be4abd1b80$export$a2387ed3b5d536eb);

});


parcelRegister("kaN2E", function(module, exports) {

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $aJ1FU = parcelRequire("aJ1FU");

var $hZDga = parcelRequire("hZDga");
'use client';
/**
 * ChatThread — the message column of a conversation (kit-grade per
 * DESIGN-CONCEPT §17.2). A flex column of `ChatBubble`/`ChatDayDivider`
 * children with the two behaviours every thread needs and no app should
 * re-derive:
 *
 *  - **Backwards pagination is a button, never a scroll trigger** (the
 *    pagination-not-infinite-scroll rule): when `hasOlder`, a ghost expander
 *    sits at the top of the thread; `loadingOlder` disables it and shows the
 *    kit spinner.
 *  - **Containment-safe autoscroll**: when the children count grows and the
 *    user was at/near the bottom (within ~4rem), the thread follows — by
 *    assigning `scrollTop` on the **resolved scroll container**, NEVER
 *    `scrollIntoView`, which walks every ancestor scroller and yanks the whole
 *    page in an embedded pane. A reader scrolled up into history is never
 *    yanked down, and a prepended older page never triggers it.
 *
 * Two containment modes via `fill`:
 *   true  — the thread IS the scroll container (`flex: 1; minHeight: 0;
 *           overflowY: auto`) for a desktop pane (the doctor app's P4 column);
 *   false — the thread sits in page flow and something ABOVE it scrolls.
 *
 * **Resolving the scroller (why this is not `document.scrollingElement`).**
 * In `fill={false}` mode the scroller is whatever ancestor actually scrolls,
 * and on a phone that is almost never the document: both mobile shells are
 * `inset: 0; overflow: hidden` with a single inner `overflow-y: auto` region.
 * Writing `document.scrollingElement.scrollTop` there lands on an element that
 * cannot scroll, and listening on `window` never fires, so the sampled gap
 * stays at its seed and autoscroll is silently dead. So the component walks
 * `containerRef.current.parentElement` upward for a computed `overflowY` of
 * `auto`/`scroll` and uses the first hit — falling back to
 * `document.scrollingElement` for a genuinely page-scrolled surface. The result
 * is cached per mount and re-resolved if the container node itself changes.
 * Callers may name the scroller explicitly with `scrollParentRef` instead.
 *
 * `role="log"` + `aria-live="polite"`: new messages are announced without
 * interrupting, and assistive tech knows earliest-first ordering applies.
 *
 * Exposes `scrollToBottom()` via ref for the caller's "jump to latest"
 * affordances.
 *
 * Props:
 *   children       — the message column (bubbles, day dividers)
 *   fill           — scroll-container mode (see above; default false)
 *   padBlockRem    — block padding in rem. Pass this instead of
 *                    `style={{ paddingBlock }}`: `style` is merged now, but a
 *                    named prop keeps the caller out of the layout entirely.
 *   hasOlder       — render the load-older expander
 *   onLoadOlder    — expander handler
 *   loadingOlder   — expander busy state (disabled + spinner)
 *   loadOlderLabel — expander label
 *   autoScroll     — follow new messages when near the bottom (default true)
 *   scrollParentRef— optional ref to the scroll container, skipping resolution
 *   style          — MERGED over the component's own layout, never replacing it
 *   className / data-testid — forwarded to the root (§15.1)
 */ // "Near the bottom" — ~4rem at the default type scale. Close enough that the
// reader is clearly following the conversation, not studying history.
const $af5a908f2b99a71b$var$NEAR_BOTTOM_PX = 64;
const $af5a908f2b99a71b$var$SCROLLY = new Set([
    'auto',
    'scroll',
    'overlay'
]);
const $af5a908f2b99a71b$var$ChatThread = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function ChatThread({ children: children, fill: fill = false, padBlockRem: padBlockRem, hasOlder: hasOlder = false, onLoadOlder: onLoadOlder, loadingOlder: loadingOlder = false, loadOlderLabel: loadOlderLabel, autoScroll: autoScroll = true, scrollParentRef: scrollParentRef, className: className, style: style, 'data-testid': testId = 'chat-thread', ...rest }, ref) {
    const containerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // Distance from the bottom edge, sampled on every scroll — read (not
    // recomputed) when children arrive, so the decision reflects where the user
    // WAS before the DOM grew. Starts at 0: opening a thread lands on the latest
    // message.
    const bottomGapRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(0);
    const prevCountRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(0);
    // The resolved scroller, cached per mount, plus the container node it was
    // resolved FROM — a `key` swap gives us a new node and must re-resolve.
    const scrollerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const scrollerForRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // Set while a backwards page is being prepended, so the growth it causes is
    // not mistaken for a new message. Without it a short thread — one that never
    // scrolled, so the sampled gap is still its 0 seed — passes the near-bottom
    // guard and yanks the reader away from the «older» button they just pressed.
    const prependingRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    const childCount = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.count(children);
    const resolveScroller = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        const el = containerRef.current;
        if (!el) return null;
        // `fill` — the thread IS the scroller; nothing to walk.
        if (fill) return el;
        if (scrollParentRef && scrollParentRef.current) return scrollParentRef.current;
        if (scrollerForRef.current === el && scrollerRef.current) return scrollerRef.current;
        let found = null;
        if (typeof window !== 'undefined' && typeof window.getComputedStyle === 'function') for(let node = el.parentElement; node; node = node.parentElement){
            const overflowY = window.getComputedStyle(node).overflowY;
            if ($af5a908f2b99a71b$var$SCROLLY.has(overflowY)) {
                found = node;
                break;
            }
        }
        // Nothing between here and the root scrolls → the page really does.
        if (!found && typeof document !== 'undefined') found = document.scrollingElement;
        scrollerRef.current = found;
        scrollerForRef.current = el;
        return found;
    }, [
        fill,
        scrollParentRef
    ]);
    const sampleGap = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        const el = resolveScroller();
        if (el) bottomGapRef.current = el.scrollHeight - el.scrollTop - el.clientHeight;
    }, [
        resolveScroller
    ]);
    const scrollToBottom = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        const el = resolveScroller();
        if (el) el.scrollTop = el.scrollHeight; // the scroller itself — containment-safe
        bottomGapRef.current = 0;
    }, [
        resolveScroller
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useImperativeHandle(ref, ()=>({
            scrollToBottom: scrollToBottom
        }), [
        scrollToBottom
    ]);
    // Sample the gap from whatever actually scrolls.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (typeof window === 'undefined') return undefined;
        const el = resolveScroller();
        if (!el) return undefined;
        // The viewport's scroll event is dispatched at the Document, not at <html>,
        // so a document-level scroller has to be listened to on `window`.
        const isDocScroller = typeof document !== 'undefined' && (el === document.scrollingElement || el === document.documentElement || el === document.body);
        const target = isDocScroller ? window : el;
        const onScroll = ()=>sampleGap();
        target.addEventListener('scroll', onScroll, {
            passive: true
        });
        return ()=>target.removeEventListener('scroll', onScroll);
    }, [
        resolveScroller,
        sampleGap
    ]);
    // Follow growth only when the reader was already at the bottom.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const prev = prevCountRef.current;
        prevCountRef.current = childCount;
        if (!autoScroll || childCount <= prev) return;
        // Backwards page: the growth is above the reader, never below.
        if (prependingRef.current) {
            prependingRef.current = false;
            return;
        }
        if (bottomGapRef.current <= $af5a908f2b99a71b$var$NEAR_BOTTOM_PX) scrollToBottom();
    }, [
        childCount,
        autoScroll,
        scrollToBottom
    ]);
    // Declared AFTER the growth effect on purpose: when a load-older resolves,
    // both run in the same commit and the growth effect must still see the flag.
    // This one only clears a flag the fetch never spent — an empty or failed page
    // produces no growth, and a stale flag would swallow the next real message.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!loadingOlder) prependingRef.current = false;
    }, [
        loadingOlder
    ]);
    const handleLoadOlder = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((e)=>{
        prependingRef.current = true;
        onLoadOlder?.(e);
    }, [
        onLoadOlder
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        "data-testid": testId,
        role: "log",
        "aria-live": "polite",
        ref: containerRef,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem',
            paddingInline: '1rem',
            ...padBlockRem != null && {
                paddingBlock: `${padBlockRem}rem`
            },
            ...fill && {
                flex: 1,
                minHeight: 0,
                overflowY: 'auto'
            },
            // Caller style MERGES over the computed layout — it never replaces it.
            // (Same precedent as `Card`.) Anything a caller genuinely needs to own,
            // like block padding, has a named prop.
            ...style
        },
        ...rest,
        // AFTER ...rest: the thread's own busy state is not the caller's to
        // overwrite — a caller-side data-state would hide `loading` forever.
        "data-state": loadingOlder ? 'loading' : 'ready'
    }, hasOlder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            justifyContent: 'center',
            paddingBlock: '0.25rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        onClick: handleLoadOlder,
        disabled: loadingOlder,
        "data-testid": `${testId}-load-older`,
        // size="sm" is 2.25rem; this control renders on both apps' phone
        // threads, where the floor is 2.75rem (DESIGN-CONCEPT-MOBILE §368).
        className: "min-h-11",
        style: {
            color: (0, $jTCZr.C).textSecondary
        }
    }, loadingOlder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 14,
        thickness: 2
    }), loadOlderLabel)), children);
});
var $af5a908f2b99a71b$export$2e2bcd8739ae039 = $af5a908f2b99a71b$var$ChatThread;

});

parcelRegister("1Ssl4", function(module, exports) {

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
'use client';
/**
 * Applies the doctor's accent preset and type scale to <html>.
 *
 * Where the value comes from, in order:
 *   1. localStorage, read synchronously during the first render, so a reload
 *      paints the chosen accent immediately instead of flashing the default
 *      while the `me` query is still in flight.
 *   2. The server copy, pushed in via `appearance` once settings load. That is
 *      the real record and wins whenever it differs — it is how the preference
 *      follows the doctor to another device.
 *
 * Themed values are CSS custom properties (see tokens.css), so switching the
 * preset re-themes every screen without re-rendering anything: this provider
 * only sets two attributes on the root element.
 */ const $54fc473ae52026aa$var$ThemeContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
function $54fc473ae52026aa$export$d8964aec282183a3({ appearance: appearance, children: children }) {
    // Lazy initialiser — runs before first paint, not in an effect.
    const [local, setLocal] = (0, $acw62.useState)(()=>{
        const stored = (0, $jTCZr.readStoredAppearance)();
        (0, $jTCZr.applyAppearance)(stored);
        return stored;
    });
    const serverTheme = appearance?.theme;
    const serverFontSize = appearance?.fontSize;
    // Adopt the server's copy when it arrives or changes (e.g. the doctor changed
    // the accent on another device). Nulls mean "not loaded yet" — not "reset".
    (0, $acw62.useEffect)(()=>{
        if (!serverTheme && !serverFontSize) return;
        setLocal((prev)=>{
            const next = {
                theme: serverTheme || prev.theme,
                fontSize: serverFontSize || prev.fontSize
            };
            if (next.theme === prev.theme && next.fontSize === prev.fontSize) return prev;
            const resolved = (0, $jTCZr.applyAppearance)(next);
            (0, $jTCZr.storeAppearance)(resolved);
            return resolved;
        });
    }, [
        serverTheme,
        serverFontSize
    ]);
    const value = (0, $acw62.useMemo)(()=>({
            theme: local.theme,
            fontSize: local.fontSize,
            // Apply a choice locally and cache it. Two callers:
            //   - the settings picker, so the accent switches under the doctor's cursor
            //     instead of after a server round trip;
            //   - app boot, to adopt the server's copy once `me` resolves.
            // Persisting to the BFF is the caller's job — this only paints and caches.
            setAppearance: (patch)=>{
                setLocal((prev)=>{
                    const resolved = (0, $jTCZr.applyAppearance)({
                        ...prev,
                        ...patch
                    });
                    (0, $jTCZr.storeAppearance)(resolved);
                    return resolved;
                });
            }
        }), [
        local
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($54fc473ae52026aa$var$ThemeContext.Provider, {
        value: value
    }, children);
}
function $54fc473ae52026aa$export$93d4e7f90805808f() {
    return (0, $acw62.useContext)($54fc473ae52026aa$var$ThemeContext) ?? {
        theme: (0, $jTCZr.DEFAULT_THEME),
        fontSize: (0, $jTCZr.DEFAULT_FONT_SIZE),
        setAppearance: ()=>{}
    };
}
var $54fc473ae52026aa$export$2e2bcd8739ae039 = $54fc473ae52026aa$export$d8964aec282183a3;

});

parcelRegister("ev4PJ", function(module, exports) {

var $acw62 = parcelRequire("acw62");
'use client';
const $02b96a2843192315$export$df49a36517896dd5 = {
    // ── The Jalali date picker ────────────────────────────────────────────────
    'common.datePicker.placeholder': "\u0627\u0646\u062A\u062E\u0627\u0628 \u062A\u0627\u0631\u06CC\u062E",
    'common.datePicker.clear': "\u067E\u0627\u06A9 \u06A9\u0631\u062F\u0646 \u062A\u0627\u0631\u06CC\u062E",
    'common.datePicker.openCalendar': "\u0646\u0645\u0627\u06CC\u0634 \u062A\u0642\u0648\u06CC\u0645",
    'common.datePicker.today': "\u0627\u0645\u0631\u0648\u0632",
    'common.datePicker.goToToday': "\u0628\u0631\u0648 \u0628\u0647 \u0627\u0645\u0631\u0648\u0632",
    'common.datePicker.now': "\u0627\u06A9\u0646\u0648\u0646",
    'common.datePicker.hour': "\u0633\u0627\u0639\u062A",
    'common.datePicker.minute': "\u062F\u0642\u06CC\u0642\u0647",
    // `{{unit}}` is one of the two above — a stepper's two arrows are named
    // "hour more" / "hour less" for a screen reader.
    'common.datePicker.increase': "{{unit}} \u0628\u06CC\u0634\u062A\u0631",
    'common.datePicker.decrease': "{{unit}} \u06A9\u0645\u062A\u0631",
    'common.datePicker.previousMonth': "\u0645\u0627\u0647 \u0642\u0628\u0644",
    'common.datePicker.nextMonth': "\u0645\u0627\u0647 \u0628\u0639\u062F",
    'common.datePicker.errors.format': "\u0642\u0627\u0644\u0628 \u062A\u0627\u0631\u06CC\u062E: \u06F1\u06F4\u06F0\u06F4/\u06F0\u06F5/\u06F1\u06F2",
    'common.datePicker.errors.range': "\u062A\u0627\u0631\u06CC\u062E \u0646\u0627\u0645\u0639\u062A\u0628\u0631 \u0627\u0633\u062A",
    'common.datePicker.errors.time': "\u0633\u0627\u0639\u062A \u0646\u0627\u0645\u0639\u062A\u0628\u0631 \u0627\u0633\u062A",
    'common.datePicker.errors.noTime': "\u0627\u06CC\u0646 \u0641\u06CC\u0644\u062F \u0633\u0627\u0639\u062A \u0646\u0645\u06CC\u200C\u067E\u0630\u06CC\u0631\u062F",
    'common.datePicker.errors.future': "\u062A\u0627\u0631\u06CC\u062E \u0622\u06CC\u0646\u062F\u0647 \u0645\u062C\u0627\u0632 \u0646\u06CC\u0633\u062A",
    // ── The mobile shell ──────────────────────────────────────────────────────
    // Not visible copy — the bottom bar's accessible name. It is here for the
    // same reason the rest is: a screen reader in an English panel should not
    // announce the navigation in Persian.
    'common.a11y.primaryNav': "\u0646\u0627\u0648\u0628\u0631\u06CC \u0627\u0635\u0644\u06CC",
    // ── The date-range filter ─────────────────────────────────────────────────
    'common.dateRange.label': "\u0628\u0627\u0632\u0647\u0654 \u0632\u0645\u0627\u0646\u06CC",
    'common.dateRange.custom': "\u0628\u0627\u0632\u0647\u0654 \u062F\u0644\u062E\u0648\u0627\u0647",
    'common.dateRange.from': "\u0627\u0632 \u062A\u0627\u0631\u06CC\u062E",
    'common.dateRange.to': "\u062A\u0627 \u062A\u0627\u0631\u06CC\u062E",
    'common.dateRange.pickBoth': "\u0628\u0631\u0627\u06CC \u0627\u0639\u0645\u0627\u0644\u060C \u0647\u0631 \u062F\u0648 \u062A\u0627\u0631\u06CC\u062E \u0631\u0627 \u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F"
};
const $02b96a2843192315$export$cdafc612aa9b582a = {
    'common.calendar.months': [
        "\u0641\u0631\u0648\u0631\u062F\u06CC\u0646",
        "\u0627\u0631\u062F\u06CC\u0628\u0647\u0634\u062A",
        "\u062E\u0631\u062F\u0627\u062F",
        "\u062A\u06CC\u0631",
        "\u0645\u0631\u062F\u0627\u062F",
        "\u0634\u0647\u0631\u06CC\u0648\u0631",
        "\u0645\u0647\u0631",
        "\u0622\u0628\u0627\u0646",
        "\u0622\u0630\u0631",
        "\u062F\u06CC",
        "\u0628\u0647\u0645\u0646",
        "\u0627\u0633\u0641\u0646\u062F"
    ],
    // Saturday-first, one glyph each — the calendar header.
    'common.calendar.weekdaysNarrow': [
        "\u0634",
        "\u06CC",
        "\u062F",
        "\u0633",
        "\u0686",
        "\u067E",
        "\u062C"
    ]
};
/** Persian digits — what the kit has always rendered. */ const $02b96a2843192315$var$toPersianDigits = (n)=>String(n).replace(/\d/g, (d)=>"\u06F0\u06F1\u06F2\u06F3\u06F4\u06F5\u06F6\u06F7\u06F8\u06F9"[d]);
// ── The registry ────────────────────────────────────────────────────────────
//
// Module state rather than context, because it has to be readable from plain
// functions (the date parser's error messages) and not only from components.
// `version` is what makes it REACTIVE: a panel that switches language at
// runtime bumps it, and every mounted kit component re-reads.
let $02b96a2843192315$var$table = null;
let $02b96a2843192315$var$version = 0;
const $02b96a2843192315$var$listeners = new Set();
function $02b96a2843192315$export$bf11b40754c929ae(next) {
    $02b96a2843192315$var$table = next || null;
    $02b96a2843192315$var$version += 1;
    $02b96a2843192315$var$listeners.forEach((notify)=>notify());
}
function $02b96a2843192315$var$subscribe(notify) {
    $02b96a2843192315$var$listeners.add(notify);
    return ()=>$02b96a2843192315$var$listeners.delete(notify);
}
const $02b96a2843192315$var$snapshot = ()=>$02b96a2843192315$var$version;
/** `{{unit}}` → vars.unit. The kit needs no more interpolation than this. */ function $02b96a2843192315$var$interpolate(text, vars) {
    if (!vars) return text;
    return text.replace(/\{\{\s*(\w+)\s*\}\}/g, (match, name)=>vars[name] === undefined ? match : String(vars[name]));
}
function $02b96a2843192315$export$44bc4c060d9b3ece(key, vars) {
    const override = $02b96a2843192315$var$table?.string?.(key);
    const text = override === undefined || override === null ? $02b96a2843192315$export$df49a36517896dd5[key] : override;
    // A key with no default is a bug in the kit, not in the app — surfacing the
    // key beats rendering `undefined` into the DOM.
    return $02b96a2843192315$var$interpolate(text === undefined ? key : text, vars);
}
function $02b96a2843192315$export$d041a4afca2888c(key) {
    const override = $02b96a2843192315$var$table?.list?.(key);
    return Array.isArray(override) ? override : $02b96a2843192315$export$cdafc612aa9b582a[key] || [];
}
function $02b96a2843192315$export$aa5144520a3863d7(value) {
    const override = $02b96a2843192315$var$table?.number?.(value);
    return override === undefined || override === null ? $02b96a2843192315$var$toPersianDigits(value) : String(override);
}
function $02b96a2843192315$export$ee19af4091ffbbfc() {
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useSyncExternalStore($02b96a2843192315$var$subscribe, $02b96a2843192315$var$snapshot, $02b96a2843192315$var$snapshot);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
            t: $02b96a2843192315$export$44bc4c060d9b3ece,
            list: $02b96a2843192315$export$d041a4afca2888c,
            num: $02b96a2843192315$export$aa5144520a3863d7
        }), // `version` is read through the store above; naming it here is what ties
    // the memo to a catalogue swap.
    [
        $02b96a2843192315$var$version
    ]);
}

});

parcelRegister("iIuoh", function(module, exports) {

$parcel$export(module.exports, "countryDefaults", () => $da03e9046daf41f2$export$6ad9cfbbc7eddb2d);
// The defaults a clinic's COUNTRY sets where nothing else has (PM-0218, country
// configuration §5 «locale»): the rule a NEW national id is judged by, the
// country an EMPTY phone field starts on, where a map with no pin opens, and
// whether an address is picked from Iran's provinces or typed.
//
// Each answer is a DEFAULT and nothing more. What the person picked (the national
// id's country chip, the phone's country picker) and what the record already holds
// (a stored E.164 number, a saved pin) win, exactly as they do without this.
//
// `caps` is the `Capabilities` object a host's BFF answers (`myClinic.capabilities`,
// `myCapabilities`; the clinical module reads it through `useCapability`). Every
// answer is `undefined` — "do what you did before" to every caller — when the
// capabilities are not known, when the country leaves a field empty, and for an
// `IR` country:
//
//   * Iran's profile states exactly what every screen already does, and
//   * a clinic that never set its country reads as IR — an Iraqi clinic on IQD
//     among them, whose forms already start on +964 and the generic id. It keeps
//     that until its country is set; on a deployment outside the Iranian market it
//     is no Iranian clinic at all.
//
// So an Iranian clinic, and every clinic whose country nobody could read, sees no
// change; a clinic in another country gets that country's defaults.

var $5AX1S = parcelRequire("5AX1S");

var $3tGMU = parcelRequire("3tGMU");
const $da03e9046daf41f2$export$3d69f8b1cafd2d03 = 'ZZ';
const $da03e9046daf41f2$var$ISO2 = /^[A-Z]{2}$/;
function $da03e9046daf41f2$export$8c23214a20fd00f5(caps) {
    if (!caps || typeof caps !== 'object') return null;
    if (typeof caps.country !== 'string' || !$da03e9046daf41f2$var$ISO2.test(caps.country) || caps.country === 'IR') return null;
    return caps;
}
function $da03e9046daf41f2$export$6c3f3a03d56800ae(caps) {
    const c = $da03e9046daf41f2$export$8c23214a20fd00f5(caps);
    if (!c?.nationalIdRule) return undefined;
    if (c.nationalIdRule === 'IR') return 'IR';
    return (0, $3tGMU.NATIONAL_ID_RULES)[c.country] ? $da03e9046daf41f2$export$3d69f8b1cafd2d03 : c.country;
}
function $da03e9046daf41f2$export$99c041a5caf796a6(caps) {
    const country = $da03e9046daf41f2$export$8c23214a20fd00f5(caps)?.country;
    return country && (0, $5AX1S.findByIso2)(country) ? country : undefined;
}
function $da03e9046daf41f2$export$7647f78674ba6234(caps) {
    const view = $da03e9046daf41f2$export$8c23214a20fd00f5(caps)?.mapView;
    if (!view || typeof view !== 'object') return undefined;
    const lat = Number(view.lat);
    const lon = Number(view.lon);
    const zoom = Number(view.zoom);
    if (![
        lat,
        lon,
        zoom
    ].every(Number.isFinite)) return undefined;
    return [
        lat,
        lon,
        Math.trunc(zoom)
    ];
}
function $da03e9046daf41f2$export$e07b841fc5d2792c(caps) {
    const model = $da03e9046daf41f2$export$8c23214a20fd00f5(caps)?.addressModel;
    if (!model) return undefined;
    return model === 'iran_provinces' ? undefined : false;
}
function $da03e9046daf41f2$export$6ad9cfbbc7eddb2d(caps) {
    return {
        nationalIdCountry: $da03e9046daf41f2$export$6c3f3a03d56800ae(caps),
        phoneCountry: $da03e9046daf41f2$export$99c041a5caf796a6(caps),
        mapOpenAt: $da03e9046daf41f2$export$7647f78674ba6234(caps),
        iranianProvinces: $da03e9046daf41f2$export$e07b841fc5d2792c(caps)
    };
}

});


parcelRegister("ciRrJ", function(module, exports) {

$parcel$export(module.exports, "ShortcutProvider", () => $a2acbbdcdb6ac534$export$87dd7790e69558a9);
$parcel$export(module.exports, "useShortcut", () => $a2acbbdcdb6ac534$export$b0ebbe7904d8d94a);
$parcel$export(module.exports, "useShortcutHelp", () => $a2acbbdcdb6ac534$export$a11896fcfbddc990);
$parcel$export(module.exports, "Kbd", () => $a2acbbdcdb6ac534$export$5e66ad77b1eb2956);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $4fYdd = parcelRequire("4fYdd");
/**
 * Keyboard shortcuts — the clinic app's central registry.
 *
 * The clinic app is keyboard-focused by doctrine (clinic-app/CLAUDE.md §4.2): the
 * پذیرش desk and the حسابداری desk are wide monitors running the same few flows hundreds of
 * times a day, and the benchmark is invoice entry in under 30 seconds. That is only
 * reachable if the high-frequency actions have keys.
 *
 * Everything registers HERE. Screens never attach their own `window.addEventListener`
 * for a shortcut, because two screens binding the same key independently is invisible
 * until they are mounted together, and because a key nobody can enumerate is a key
 * nobody discovers — the `?` overlay can only list what the registry knows.
 *
 *   useShortcut('f3', () => inputRef.current?.focus(), { label: 'جست‌وجوی بیمار' })
 *
 * Precedence is last-registered-wins, so a modal that registers `esc` shadows the
 * screen underneath it for as long as it is mounted, then hands the key back.
 */ /**
 * Two contexts, deliberately.
 *
 * `RegistryCtx` must keep a STABLE identity for the life of the provider, because
 * `useShortcut` lists it as an effect dependency. A single context carrying both the
 * registry and the overlay state would change identity on every registration, which
 * would re-run every consumer's effect, which registers, which bumps again — an
 * infinite loop that only shows up once something actually binds a key.
 */ const $a2acbbdcdb6ac534$var$RegistryCtx = /*#__PURE__*/ (0, $acw62.createContext)(null);
const $a2acbbdcdb6ac534$var$HelpCtx = /*#__PURE__*/ (0, $acw62.createContext)(null);
/** Monotonic registration counter — higher wins when several handlers share a combo. */ let $a2acbbdcdb6ac534$var$SEQ = 0;
const $a2acbbdcdb6ac534$var$FKEY = /^f([1-9]|1[0-2])$/;
const $a2acbbdcdb6ac534$export$491029574d911e8 = (raw)=>{
    const parts = String(raw || '').toLowerCase().split('+').map((s)=>s.trim()).filter(Boolean);
    let key = '';
    const mods = new Set();
    for (const p of parts){
        if (p === 'ctrl' || p === 'cmd' || p === 'meta') mods.add('ctrl');
        else if (p === 'alt' || p === 'option') mods.add('alt');
        else if (p === 'shift') mods.add('shift');
        else key = p === 'escape' ? 'esc' : p;
    }
    if (!key) return '';
    const out = [];
    if (mods.has('ctrl')) out.push('ctrl');
    if (mods.has('alt')) out.push('alt');
    if (mods.has('shift')) out.push('shift');
    out.push(key);
    return out.join('+');
};
/**
 * A digit is a digit on any layout. The Persian keyboard's 1 key types «۱» (and an
 * Arabic one «١»), so without this a key bound to '1' — «منشی هوشمند»'s «کدام‌یک؟» —
 * would answer only a receptionist who had switched to English first.
 */ const $a2acbbdcdb6ac534$var$foldDigit = (key)=>{
    if (key.length !== 1) return key;
    const code = key.charCodeAt(0);
    if (code >= 0x06F0 && code <= 0x06F9) return String(code - 0x06F0);
    if (code >= 0x0660 && code <= 0x0669) return String(code - 0x0660);
    return key;
};
const $a2acbbdcdb6ac534$export$fec7a04f3f2b43c1 = (e)=>{
    let key = e?.key;
    if (!key) return '';
    key = key === 'Escape' ? 'esc' : key === ' ' ? 'space' : $a2acbbdcdb6ac534$var$foldDigit(key.toLowerCase());
    const out = [];
    if (e.ctrlKey || e.metaKey) out.push('ctrl');
    if (e.altKey) out.push('alt');
    if (e.shiftKey && key.length > 1) out.push('shift');
    out.push(key);
    return out.join('+');
};
const $a2acbbdcdb6ac534$export$763c4b15adcf804b = (el)=>{
    if (!el || !el.tagName) return false;
    const tag = el.tagName.toUpperCase();
    return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || el.isContentEditable === true;
};
const $a2acbbdcdb6ac534$export$570b40aed3a24e82 = (combo)=>{
    const key = combo.split('+').pop();
    return combo.includes('ctrl+') || combo.includes('alt+') || key === 'esc' || $a2acbbdcdb6ac534$var$FKEY.test(key);
};
/** Human-readable key caps for the help overlay, right-to-left friendly. */ const $a2acbbdcdb6ac534$var$CAP = {
    ctrl: 'Ctrl',
    alt: 'Alt',
    shift: 'Shift',
    esc: 'Esc',
    space: 'Space'
};
const $a2acbbdcdb6ac534$export$f5026c738b75de96 = (combo)=>combo.split('+').map((p)=>$a2acbbdcdb6ac534$var$CAP[p] || ($a2acbbdcdb6ac534$var$FKEY.test(p) ? p.toUpperCase() : p.toUpperCase())).join(' + ');
const $a2acbbdcdb6ac534$export$87dd7790e69558a9 = ({ children: children })=>{
    // A ref, not state: registering must not re-render the tree that is registering.
    const regs = (0, $acw62.useRef)(new Map());
    const [revision, bump] = (0, $acw62.useState)(0);
    const [helpOpen, setHelpOpen] = (0, $acw62.useState)(false);
    const register = (0, $acw62.useCallback)((id, def)=>{
        regs.current.set(id, def);
        bump((v)=>v + 1);
        return ()=>{
            regs.current.delete(id);
            bump((v)=>v + 1);
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        const onKey = (e)=>{
            const combo = $a2acbbdcdb6ac534$export$fec7a04f3f2b43c1(e);
            if (!combo) return;
            const editable = $a2acbbdcdb6ac534$export$763c4b15adcf804b(e.target);
            let best = null;
            for (const def of regs.current.values()){
                if (def.combo !== combo) continue;
                const fires = def.firesInInput ?? $a2acbbdcdb6ac534$export$570b40aed3a24e82(def.combo);
                if (editable && !fires) continue;
                if (!best || def.seq > best.seq) best = def; // last registered wins
            }
            if (!best) return;
            // Claim the key only once we know something handles it, so an unbound F5 still
            // reloads and Ctrl+S in a field the app does not own still belongs to the browser.
            e.preventDefault();
            e.stopPropagation();
            best.run(e);
        };
        window.addEventListener('keydown', onKey);
        return ()=>window.removeEventListener('keydown', onKey);
    }, []);
    // Stable for the provider's lifetime: `register` is a useCallback with no deps and
    // `regs` is a ref. Nothing here may depend on `revision`.
    const registry = (0, $acw62.useMemo)(()=>({
            register: register,
            regs: regs
        }), [
        register
    ]);
    const help = (0, $acw62.useMemo)(()=>({
            revision: revision,
            helpOpen: helpOpen,
            setHelpOpen: setHelpOpen
        }), [
        revision,
        helpOpen
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a2acbbdcdb6ac534$var$RegistryCtx.Provider, {
        value: registry,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($a2acbbdcdb6ac534$var$HelpCtx.Provider, {
            value: help,
            children: [
                children,
                /*#__PURE__*/ (0, $ayMG0.jsx)($a2acbbdcdb6ac534$var$ShortcutHelp, {})
            ]
        })
    });
};
const $a2acbbdcdb6ac534$export$b0ebbe7904d8d94a = (combo, handler, opts = {})=>{
    const { label: label, group: groupOpt, enabled: enabled = true, firesInInput: firesInInput } = opts;
    const { t: t } = (0, $e1LEq.default)();
    // Resolved here rather than as a default parameter: a default is evaluated
    // before the hook body, where `t` does not exist yet. Both `label` and
    // `group` arrive ALREADY TRANSLATED from the call site — they are copy the
    // caller owns — and `t`'s identity changes on a language switch, so the
    // effect below re-registers and the `?` overlay is never left in the
    // previous language.
    const group = groupOpt || t('shortcuts.groups.general');
    const registry = (0, $acw62.useContext)($a2acbbdcdb6ac534$var$RegistryCtx);
    // The handler is read through a ref so a fresh closure every render does not
    // re-register — re-registering on every render would bump the provider, re-render
    // the child, and register again, forever.
    const handlerRef = (0, $acw62.useRef)(handler);
    handlerRef.current = handler;
    const idRef = (0, $acw62.useRef)(null);
    if (idRef.current === null) idRef.current = Symbol('shortcut');
    (0, $acw62.useEffect)(()=>{
        if (!registry || !enabled) return undefined;
        const normalized = $a2acbbdcdb6ac534$export$491029574d911e8(combo);
        if (!normalized) return undefined;
        return registry.register(idRef.current, {
            combo: normalized,
            label: label,
            group: group,
            firesInInput: firesInInput,
            seq: ++$a2acbbdcdb6ac534$var$SEQ,
            run: (e)=>handlerRef.current?.(e)
        });
    }, [
        registry,
        combo,
        label,
        group,
        enabled,
        firesInInput
    ]);
};
const $a2acbbdcdb6ac534$export$8dc9f6f80a84c72b = ()=>{
    const registry = (0, $acw62.useContext)($a2acbbdcdb6ac534$var$RegistryCtx);
    const help = (0, $acw62.useContext)($a2acbbdcdb6ac534$var$HelpCtx);
    const revision = help?.revision;
    return (0, $acw62.useMemo)(()=>{
        if (!registry) return [];
        const groups = new Map();
        for (const def of registry.regs.current.values()){
            if (!def.label) continue;
            if (!groups.has(def.group)) groups.set(def.group, new Map());
            // Same combo registered twice (screen + modal): the overlay shows the one that
            // would actually fire, not both.
            const byCombo = groups.get(def.group);
            const prev = byCombo.get(def.combo);
            if (!prev || def.seq > prev.seq) byCombo.set(def.combo, def);
        }
        return [
            ...groups.entries()
        ].map(([group, byCombo])=>({
                group: group,
                items: [
                    ...byCombo.values()
                ].sort((a, b)=>a.combo.localeCompare(b.combo))
            }));
    // `revision` is the signal that `regs` (a ref) changed — it is a dependency even
    // though the body never reads it.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        registry,
        revision
    ]);
};
const $a2acbbdcdb6ac534$export$a11896fcfbddc990 = ()=>{
    const help = (0, $acw62.useContext)($a2acbbdcdb6ac534$var$HelpCtx);
    return {
        open: Boolean(help?.helpOpen),
        toggle: (0, $acw62.useCallback)(()=>help?.setHelpOpen((v)=>!v), [
            help
        ])
    };
};
const $a2acbbdcdb6ac534$export$5e66ad77b1eb2956 = ({ combo: combo, style: style })=>/*#__PURE__*/ (0, $ayMG0.jsx)("kbd", {
        "aria-hidden": "true",
        style: {
            fontFamily: 'inherit',
            fontSize: '0.625rem',
            fontWeight: 700,
            lineHeight: 1,
            padding: '2px 5px',
            borderRadius: 4,
            whiteSpace: 'nowrap',
            background: 'rgba(255,255,255,0.22)',
            color: 'inherit',
            border: '1px solid rgba(255,255,255,0.28)',
            ...style
        },
        children: $a2acbbdcdb6ac534$export$f5026c738b75de96($a2acbbdcdb6ac534$export$491029574d911e8(combo))
    });
/**
 * The `?` overlay. Mounted once by the provider — it is the only discovery surface a
 * shortcut has, so a shortcut worth binding is a shortcut worth labelling.
 */ const $a2acbbdcdb6ac534$var$ShortcutHelp = ()=>{
    const { t: t } = (0, $e1LEq.default)();
    const help = (0, $acw62.useContext)($a2acbbdcdb6ac534$var$HelpCtx);
    const groups = $a2acbbdcdb6ac534$export$8dc9f6f80a84c72b();
    $a2acbbdcdb6ac534$export$b0ebbe7904d8d94a('?', ()=>help?.setHelpOpen((v)=>!v), {
        label: t('shortcuts.overlay.title'),
        group: t('shortcuts.groups.general')
    });
    if (!help) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fYdd.Dialog), {
        open: help.helpOpen,
        onOpenChange: help.setHelpOpen,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4fYdd.DialogContent), {
            className: "max-w-lg",
            dir: "rtl",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fYdd.DialogHeader), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fYdd.DialogTitle), {
                        children: t('shortcuts.overlay.heading')
                    })
                }),
                groups.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    style: {
                        fontSize: '0.8125rem',
                        opacity: 0.7
                    },
                    children: t('shortcuts.overlay.empty')
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 16,
                        marginTop: 4
                    },
                    children: groups.map(({ group: group, items: items })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    style: {
                                        margin: '0 0 6px',
                                        fontSize: '0.75rem',
                                        fontWeight: 800,
                                        opacity: 0.55
                                    },
                                    children: group
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                    style: {
                                        margin: 0,
                                        padding: 0,
                                        listStyle: 'none',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: 2
                                    },
                                    children: items.map((it)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                            style: {
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                gap: 12,
                                                padding: '5px 0',
                                                fontSize: '0.8125rem'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    children: it.label
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("kbd", {
                                                    dir: "ltr",
                                                    style: {
                                                        fontFamily: 'inherit',
                                                        fontSize: '0.6875rem',
                                                        fontWeight: 700,
                                                        padding: '3px 7px',
                                                        borderRadius: 5,
                                                        unicodeBidi: 'isolate',
                                                        background: 'rgba(0,0,0,0.06)',
                                                        border: '1px solid rgba(0,0,0,0.1)'
                                                    },
                                                    children: $a2acbbdcdb6ac534$export$f5026c738b75de96(it.combo)
                                                })
                                            ]
                                        }, it.combo))
                                })
                            ]
                        }, group))
                })
            ]
        })
    });
};
var $a2acbbdcdb6ac534$export$2e2bcd8739ae039 = $a2acbbdcdb6ac534$export$b0ebbe7904d8d94a;

});
parcelRegister("7c6z4", function(module, exports) {

$parcel$export(module.exports, "I18nProvider", () => (parcelRequire("kJBdz")).default);
$parcel$export(module.exports, "useTranslation", () => (parcelRequire("e1LEq")).default);
$parcel$export(module.exports, "CurrencyProvider", () => (parcelRequire("aBaxB")).default);
$parcel$export(module.exports, "useMoneyOf", () => (parcelRequire("aBaxB")).useMoneyOf);
$parcel$export(module.exports, "inDocumentCurrency", () => (parcelRequire("aBaxB")).inDocumentCurrency);
$parcel$export(module.exports, "clinicCurrencyOf", () => (parcelRequire("k7W79")).clinicCurrencyOf);
$parcel$export(module.exports, "LOCALES", () => (parcelRequire("cMRsf")).LOCALES);
$parcel$export(module.exports, "localeDescriptor", () => (parcelRequire("cMRsf")).localeDescriptor);
$parcel$export(module.exports, "LTR_TEXT", () => (parcelRequire("gVWNP")).LTR_TEXT);
$parcel$export(module.exports, "MIRROR_ICON", () => (parcelRequire("gVWNP")).MIRROR_ICON);
$parcel$export(module.exports, "toAsciiDigits", () => (parcelRequire("gVWNP")).toAsciiDigits);
// ─────────────────────────────────────────────────────────────────────────────
// The i18n barrel — import from '../i18n', never from a file inside it.
//
//   import { useTranslation } from '../../i18n';
//
// Keeping the surface here means the internals (loader strategy, translator
// implementation, which Intl objects get memoised) can change without a sweep
// through the app.
//
// Full guide: docs/I18N.md
// ─────────────────────────────────────────────────────────────────────────────

var $kJBdz = parcelRequire("kJBdz");

var $e1LEq = parcelRequire("e1LEq");

var $aBaxB = parcelRequire("aBaxB");

var $k7W79 = parcelRequire("k7W79");

var $cMRsf = parcelRequire("cMRsf");

var $gVWNP = parcelRequire("gVWNP");

var $7rPjk = parcelRequire("7rPjk");

var $iwuD4 = parcelRequire("iwuD4");

});
parcelRegister("kJBdz", function(module, exports) {

$parcel$export(module.exports, "I18nContext", () => $a278322405d51c25$export$5603ab5ced17ce64);
$parcel$export(module.exports, "default", () => $a278322405d51c25$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $cMRsf = parcelRequire("cMRsf");

var $iwuD4 = parcelRequire("iwuD4");

var $7rPjk = parcelRequire("7rPjk");

var $gVWNP = parcelRequire("gVWNP");

var $k7W79 = parcelRequire("k7W79");
var $lHVFz = parcelRequire("lHVFz");
// ─────────────────────────────────────────────────────────────────────────────
// The one i18n context. Everything a screen needs — `t`, the formatters, the
// direction, the way to change language — comes from here and nowhere else.
//
// It is deliberately shaped like the design system's ThemeProvider, because it
// solves the same problem and should be read the same way:
//
//   1. localStorage, read synchronously during the first render, so a reload
//      paints the right language AND the right direction immediately instead of
//      flashing Persian at an English-speaking user.
//   2. The server copy (the user's `locale` attribute in Keycloak), pushed in
//      once `me` resolves. That is the real record and wins whenever it differs
//      — it is how the choice follows a staff member to the second desk.
//
// Switching language NEVER unmounts anything. The new catalogue is loaded, then
// swapped in one state update, so the router, every open dialog and every
// half-filled form survive the switch — requirement 7, and the reason this is a
// context value rather than a remount with a `key`.
// ─────────────────────────────────────────────────────────────────────────────
const $a278322405d51c25$export$5603ab5ced17ce64 = /*#__PURE__*/ (0, $acw62.createContext)(null);
function $a278322405d51c25$export$a54013f0d02a8f82({ language: language, children: children, fallback: fallback = null }) {
    // Lazy initialiser — runs before first paint, not in an effect, so <html dir>
    // is correct for the very first frame.
    const [locale, setLocale] = (0, $acw62.useState)(()=>(0, $cMRsf.applyDocumentLocale)((0, $cMRsf.resolveInitialLocale)()));
    // The catalogues currently being rendered. `null` until the first load lands;
    // on a LATER switch the previous catalogue keeps rendering until the new one
    // is ready, so there is no flash of untranslated keys.
    const [catalogs, setCatalogs] = (0, $acw62.useState)(()=>{
        const active = (0, $iwuD4.peekCatalog)(locale);
        if (!active) return null;
        const fb = locale === (0, $cMRsf.FALLBACK_LOCALE) ? active : (0, $iwuD4.peekCatalog)((0, $cMRsf.FALLBACK_LOCALE));
        return fb ? {
            locale: locale,
            active: active,
            fallback: fb
        } : null;
    });
    // Guards against an out-of-order resolution when the user switches twice
    // quickly: only the most recently requested locale may commit.
    const requested = (0, $acw62.useRef)(locale);
    (0, $acw62.useEffect)(()=>{
        requested.current = locale;
        let live = true;
        // The fallback catalogue is loaded alongside the active one so a key
        // missing from a translation can resolve to English synchronously, inside
        // `t`, rather than triggering a load mid-render.
        Promise.all([
            (0, $iwuD4.loadCatalog)(locale),
            locale === (0, $cMRsf.FALLBACK_LOCALE) ? null : (0, $iwuD4.loadCatalog)((0, $cMRsf.FALLBACK_LOCALE))
        ]).then(([active, fb])=>{
            if (!live || requested.current !== locale) return;
            setCatalogs({
                locale: locale,
                active: active,
                fallback: fb || active
            });
        });
        return ()=>{
            live = false;
        };
    }, [
        locale
    ]);
    // Adopt the server's copy when it arrives or changes (e.g. the user changed
    // language on another device). `null`/`undefined` means "not loaded yet" —
    // NOT "reset to default" — so an in-flight `me` query never clobbers a choice
    // the user just made. An unrecognised tag is ignored rather than applied:
    // a language this build does not ship must not blank the UI. Nor is one the
    // brand does not offer applied — the account's own default («fa») included.
    const serverLanguage = (0, $cMRsf.normalizeLocale)(language);
    (0, $acw62.useEffect)(()=>{
        if (!serverLanguage) return;
        setLocale((prev)=>{
            if (prev === serverLanguage) return prev;
            (0, $cMRsf.storeLocale)(serverLanguage);
            return (0, $cMRsf.applyDocumentLocale)(serverLanguage);
        });
    }, [
        serverLanguage
    ]);
    /**
   * Apply a language locally and cache it. Two callers:
   *   - the settings picker, so the UI switches under the user's cursor
   *     instead of after a server round trip;
   *   - app boot, to adopt the server's copy once `myProfile` resolves.
   * Persisting to the BFF is the caller's job — this only paints and caches.
   */ const changeLocale = (0, $acw62.useCallback)((next)=>{
        const id = (0, $cMRsf.normalizeLocale)(next);
        if (!id) return;
        setLocale((prev)=>{
            if (prev === id) return prev;
            (0, $cMRsf.storeLocale)(id);
            return (0, $cMRsf.applyDocumentLocale)(id);
        });
    }, []);
    const value = (0, $acw62.useMemo)(()=>{
        const descriptor = (0, $cMRsf.localeDescriptor)(locale);
        const formatters = (0, $gVWNP.createFormatters)(locale);
        // Catalogues for a DIFFERENT locale than `locale` means a switch is in
        // flight: keep translating with what we have. `t` still resolves — it just
        // resolves in the outgoing language for the frame or two it takes the new
        // catalogue to arrive from cache or network.
        const active = catalogs?.active || {};
        const fb = catalogs?.fallback || {};
        const renderedLocale = catalogs?.locale || locale;
        const pluralRules = typeof Intl.PluralRules === 'function' ? new Intl.PluralRules((0, $cMRsf.localeDescriptor)(renderedLocale).intl) : null;
        const { t: t, tList: tList, has: has } = (0, $7rPjk.createTranslator)({
            locale: renderedLocale,
            catalog: active,
            fallbackCatalog: fb,
            pluralRules: pluralRules,
            joinList: formatters.formatList,
            formatNumber: formatters.formatNumber
        });
        // Clinic money, bound to IRR here: this provider sits ABOVE the clinic
        // context (the sign-in and onboarding screens need copy before any clinic is
        // known), so it cannot know the clinic's currency. <CurrencyProvider>,
        // rendered by ClinicContextProvider, re-binds all of this to the clinic's.
        const money = (0, $k7W79.bindMoney)({
            t: t,
            tList: tList,
            formatMoney: formatters.formatMoney,
            locale: locale
        }, (0, $lHVFz.DEFAULT_CURRENCY));
        return {
            locale: // identity
            locale,
            dir: descriptor.dir,
            isRTL: descriptor.dir === 'rtl',
            // Whether this reader can read the Persian clinical reference data. NOT
            // implied by `isRTL` — Arabic shares the direction and not the language.
            readsPersianData: descriptor.readsPersianData === true,
            // What a language picker lists: every shipped language, or only the
            // ones the brand offers.
            locales: (0, $cMRsf.offeredLocales)(),
            t: // translation
            t,
            tList: tList,
            has: has,
            // formatting
            ...formatters,
            // money: currency, formatMoney, moneyUnit, moneyAmount, toDisplayAmount,
            // fromDisplayAmount, parseMoney — and `t`/`tList` whose {{unit}} and
            // {{unitShort}} default to the bound currency's word (money.js)
            ...money,
            // The unbound pieces, for <CurrencyProvider> to re-bind from.
            moneyBase: {
                t: t,
                tList: tList,
                formatMoney: formatters.formatMoney,
                locale: locale
            },
            // control
            setLocale: changeLocale,
            preloadLocale: (0, $iwuD4.preloadCatalog),
            // true once the active locale's catalogue is the one being rendered
            ready: catalogs?.locale === locale
        };
    }, [
        locale,
        catalogs,
        changeLocale
    ]);
    // Only the FIRST load blocks — after that `catalogs` is never null again, so
    // a language switch re-renders in place and the navigation state survives.
    if (!catalogs) return fallback;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a278322405d51c25$export$5603ab5ced17ce64.Provider, {
        value: value,
        children: children
    });
}
var $a278322405d51c25$export$2e2bcd8739ae039 = $a278322405d51c25$export$a54013f0d02a8f82;

});
parcelRegister("cMRsf", function(module, exports) {

$parcel$export(module.exports, "LOCALES", () => $94f36eaf2deb686d$export$e49c1078bc46f17);
$parcel$export(module.exports, "FALLBACK_LOCALE", () => $94f36eaf2deb686d$export$95b7602913551865);
$parcel$export(module.exports, "NAMESPACES", () => $94f36eaf2deb686d$export$4d2fb7344096e022);
$parcel$export(module.exports, "isSupportedLocale", () => $94f36eaf2deb686d$export$17a6a815985c8621);
$parcel$export(module.exports, "offeredLocales", () => $94f36eaf2deb686d$export$171765a6a37c37cd);
$parcel$export(module.exports, "productDefaultLocale", () => $94f36eaf2deb686d$export$1ad85a23f306da6d);
$parcel$export(module.exports, "localeDescriptor", () => $94f36eaf2deb686d$export$57270fb1f2649979);
$parcel$export(module.exports, "normalizeLocale", () => $94f36eaf2deb686d$export$dca0327c9b9c6498);
$parcel$export(module.exports, "storeLocale", () => $94f36eaf2deb686d$export$e8146f0b19c81b97);
$parcel$export(module.exports, "resolveInitialLocale", () => $94f36eaf2deb686d$export$831a5617a2963db1);
$parcel$export(module.exports, "applyDocumentLocale", () => $94f36eaf2deb686d$export$fff0f9a021c4ca38);
// ─────────────────────────────────────────────────────────────────────────────
// The locale registry — the one place that knows which languages exist.
//
// Adding a language is meant to be a data change, not a code change: append an
// entry here, drop a folder under `translations/`, register its loaders in
// loader.js, and every picker, formatter and direction switch picks it up. No
// component, screen or service is allowed to branch on a locale id — if a
// behaviour differs per language it belongs in the descriptor below.
//
// Ported from the doctor app. The clinic panel ships fa, en, ar, fr and de. The
// OPTIONAL descriptor fields below are what make a language a data change
// rather than a refactor — `ar` declares four of them, because ICU's data for
// Arabic on the JALALI calendar is wrong in four separate ways and every one of
// them looks like plausible Arabic in review; `fr` declares one more,
// `clinicMonthNames`, because ICU's French Jalali months («mordâd») are a
// scholarly transliteration that differs between ICU builds (PM-0185, D8);
// `de` reuses it for the same reason («Mordād», PM-0212). See docs/I18N.md, and
// the doctor app's §"When CLDR is wrong", before adding a sixth language.
//
// THE BRAND (@parsina/framework/ui/lib/brand, configured at boot by
// src/lib/brandBoot.js) narrows this list and moves its defaults, never the
// descriptors' data: `locales` decides which of these languages are OFFERED
// (`isOfferedLocale` — every resolver below asks it, so a language the brand
// does not offer is never started in, cached or adopted from the server), and
// `defaultLocale` is the first-visit language. `calendar` swaps each
// descriptor's calendar through the descriptor's own `calendars` data. With no
// brand all three are exactly what they were. Same rules as the framework's
// clinical/src/i18n/config.js, which the visit room reads.
// ─────────────────────────────────────────────────────────────────────────────

var $eLeza = parcelRequire("eLeza");
// The twelve Jalali months as the English UI spells them, index 0 = Farvardin.
// French and German (PM-0212) use this list wherever it shows a Jalali month (PM-0185, D8) instead
// of ICU's French data («ordibehešt», «khordâd»), which reads as scholarly
// transliteration and is spelled differently by different ICU builds — the
// kit's date picker and the server's text use the same twelve words.
const $94f36eaf2deb686d$var$JALALI_MONTHS_LATIN = [
    'Farvardin',
    'Ordibehesht',
    'Khordad',
    'Tir',
    'Mordad',
    'Shahrivar',
    'Mehr',
    'Aban',
    'Azar',
    'Dey',
    'Bahman',
    'Esfand'
];
const $94f36eaf2deb686d$export$e49c1078bc46f17 = {
    // i18n-exempt: a locale's `label` is its ENDONYM — the name the language
    // gives itself — so it is deliberately not translated. «فارسی» stays «فارسی»
    // in the English UI, the same way «English» stays «English» in the Persian
    // one; that is what makes a language switcher usable to someone who cannot
    // read the current language. `weekdaySeparator` is likewise locale data.
    fa: {
        id: 'fa',
        label: "\u0641\u0627\u0631\u0633\u06CC",
        englishLabel: 'Persian',
        dir: 'rtl',
        // -u-ca-persian → Jalali (Shamsi) calendar; -u-nu-arabext → Persian digits.
        intl: 'fa-IR-u-ca-persian-nu-arabext',
        calendar: 'jalali',
        calendars: {
            gregory: {
                intl: 'fa-IR-u-ca-gregory-nu-arabext'
            }
        },
        // The DEFAULT only — before a clinic is known. Under the clinic context every
        // date is formatted on the CLINIC's zone (Membership.timezone, PM-0088).
        timeZone: 'Asia/Tehran',
        // What goes between the weekday and the rest of a long date. See the
        // `full` style in format.js for why this is spelled out here rather than
        // left to `dateStyle: 'full'`.
        weekdaySeparator: "\u060C ",
        // Persian is the only language that reads the clinic's own stored names.
        readsPersianData: true
    },
    en: {
        id: 'en',
        label: 'English',
        englishLabel: 'English',
        dir: 'ltr',
        intl: 'en-US',
        calendar: 'gregory',
        calendars: {
            // A brand on the Jalali calendar everywhere. ICU appends the era ("AP")
            // to a calendar that is not the language's own.
            jalali: {
                intl: 'en-US-u-ca-persian',
                stripEra: true
            },
            // A brand on the Gregorian calendar keeps no Jalali books: the surfaces
            // below that are Jalali in every language read Gregorian months there.
            gregory: {
                clinicCalendarIntl: undefined
            }
        },
        // The DEFAULT only — before a clinic is known. Under the clinic context every
        // date is formatted on the CLINIC's zone (Membership.timezone, PM-0088).
        timeZone: 'Asia/Tehran',
        weekdaySeparator: ', ',
        // English dates are Gregorian, but a few surfaces are Jalali in EVERY
        // language because the clinic itself is — an accounting period and a shift
        // report are bounded by Jalali months, so labelling those «August» would
        // name a month the period does not start in. ICU renders the Jalali months
        // in Latin for this tag: «Farvardin», «Mordad».
        clinicCalendarIntl: 'en-US-u-ca-persian'
    },
    // i18n-exempt: endonym and locale data, exactly as for `fa` above — «العربية»
    // is the name Arabic gives itself and stays «العربية» in every UI language.
    // A second marker is needed because the first one's exemption ends with the
    // `fa` descriptor it introduces, and the audit cannot tell Arabic script from
    // Persian: both live in U+0600–U+06FF.
    ar: {
        id: 'ar',
        label: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
        englishLabel: 'Arabic',
        dir: 'rtl',
        // JALALI, not Gregorian. An Iranian clinic runs on the Jalali calendar —
        // the day sheet, the appointment book and the accounting period are all
        // Jalali — and the date PICKER (@parsina/framework JalaliDatePicker, which
        // follows <html lang> since v0.19.0) draws Arabic on the Jalali calendar
        // too, to match this tag. Handing Arabic `ar-EG` here would
        // mean a receptionist picks ۱۴۰۴/۰۵/۱۲ and reads back «٣ أغسطس ٢٠٢٥»: the
        // same class of transcription error the 24-hour clock rule in format.js
        // exists to prevent. -u-nu-arab → Arabic-Indic digits (٠١٢…), which is what an
        // Arabic reader expects and is a DIFFERENT set from Persian's arabext.
        intl: 'ar-u-ca-persian-nu-arab',
        calendar: 'jalali',
        calendars: {
            // On the Gregorian calendar two corrections below are Jalali-only: the
            // month names are Jalali names, and day-first is how Arabic writes a
            // Gregorian date.
            gregory: {
                intl: 'ar-u-ca-gregory-nu-arab',
                monthNames: undefined,
                numericDateOrder: undefined
            }
        },
        // The DEFAULT only — before a clinic is known. Under the clinic context every
        // date is formatted on the CLINIC's zone (Membership.timezone, PM-0088).
        timeZone: 'Asia/Tehran',
        weekdaySeparator: "\u060C ",
        // ICU's Arabic patterns for the Persian calendar disagree with the clinic's
        // conventions in three ways. Correcting them here, as data, is what keeps
        // format.js free of locale ids — see the descriptor notes above.
        dateStyles: {
            // ICU gives Arabic an ALL-NUMERIC medium («١٢‏/٠٥‏/١٤٠٤») where both other
            // locales give a month name («۱۲ مرداد ۱۴۰۴», «Aug 3, 2025»). `medium` is
            // the default shape, on nearly every row in the app, so it is the one
            // that has to stay readable.
            medium: {
                day: 'numeric',
                month: 'long',
                year: 'numeric'
            }
        },
        // ICU appends «ه‍.ش» (with a ZWJ) to every Arabic-on-Persian-calendar shape
        // but `dayMonth`. It is noise next to a Persian date that never carries it,
        // and `era: undefined` does not suppress it.
        stripEra: true,
        // ICU orders the numeric Arabic date day-first («١٢/٥/١٤٠٤») where Persian
        // writes it year-first («۱۴۰۴/۵/۱۲»). Two RTL languages disagreeing about
        // the same calendar on the same screen is how a date gets transcribed wrong.
        numericDateOrder: [
            'year',
            'month',
            'day'
        ],
        // CLDR's ARABIC month names for the Persian calendar are corrupted: six of
        // the twelve are not words in any language. Verified against ICU 78, and
        // identical for every ar-* region (ar, ar-EG, ar-IQ, ar-SA):
        //
        //   ICU says   فرفردن · أذربيهشت · تار · شهرفار · آيان · اسفندار
        //   should be  فروردين · ارديبهشت · تير · شهريور · آبان · اسفند
        //
        // A month name sits on every visit row, every day sheet and every printed
        // prescription, so this cannot be left to upstream. Index 0 = فروردين.
        monthNames: [
            "\u0641\u0631\u0648\u0631\u062F\u064A\u0646",
            "\u0627\u0631\u062F\u064A\u0628\u0647\u0634\u062A",
            "\u062E\u0631\u062F\u0627\u062F",
            "\u062A\u064A\u0631",
            "\u0645\u0631\u062F\u0627\u062F",
            "\u0634\u0647\u0631\u064A\u0648\u0631",
            "\u0645\u0647\u0631",
            "\u0622\u0628\u0627\u0646",
            "\u0622\u0630\u0631",
            "\u062F\u064A",
            "\u0628\u0647\u0645\u0646",
            "\u0627\u0633\u0641\u0646\u062F"
        ]
    },
    // French mirrors English (PM-0185, D3): Gregorian, with the clinic's Jalali
    // surfaces on `clinicCalendarIntl`. No `monthNames` on the descriptor itself
    // — on `fr-FR` they would rename the GREGORIAN months — and no
    // `readsPersianData`: a French reader cannot read the clinic's stored names.
    fr: {
        id: 'fr',
        label: "Fran\xe7ais",
        englishLabel: 'French',
        dir: 'ltr',
        intl: 'fr-FR',
        calendar: 'gregory',
        calendars: {
            // A brand on the Jalali calendar everywhere: drop the era ICU appends
            // («A. P.»), name the months as the English UI does, and keep the month
            // a word on `medium` — ICU abbreviates it («mor.»).
            jalali: {
                intl: 'fr-FR-u-ca-persian',
                stripEra: true,
                monthNames: $94f36eaf2deb686d$var$JALALI_MONTHS_LATIN,
                dateStyles: {
                    medium: {
                        day: 'numeric',
                        month: 'long',
                        year: 'numeric'
                    }
                }
            },
            gregory: {
                clinicCalendarIntl: undefined,
                clinicMonthNames: undefined
            }
        },
        // The DEFAULT only — before a clinic is known. Under the clinic context every
        // date is formatted on the CLINIC's zone (Membership.timezone, PM-0088).
        timeZone: 'Asia/Tehran',
        // «dimanche 3 août 2025» — French joins the weekday without a comma.
        weekdaySeparator: ' ',
        // The accounting period, the shift report and the payroll month are Jalali
        // in every language, as in English — named from the fixed list below
        // rather than ICU's French («mordâd»), so they read «Mordad».
        clinicCalendarIntl: 'fr-FR-u-ca-persian',
        clinicMonthNames: $94f36eaf2deb686d$var$JALALI_MONTHS_LATIN
    },
    // German mirrors English exactly as French does (PM-0212): Gregorian, the
    // clinic's Jalali surfaces on `clinicCalendarIntl` with the fixed month list
    // (ICU's German says «Mordād»), no `monthNames` on the descriptor — on
    // `de-DE` they would rename the GREGORIAN months — and no `readsPersianData`.
    de: {
        id: 'de',
        label: 'Deutsch',
        englishLabel: 'German',
        dir: 'ltr',
        intl: 'de-DE',
        calendar: 'gregory',
        calendars: {
            // A brand on the Jalali calendar everywhere: drop the era ICU appends
            // («AP»), name the months as the English UI does, keep the month a word
            // on `medium` — ICU's German `medium` is all-numeric («12.05.1404») — and
            // keep a four-digit year on `short`, where ICU writes «12.05.04».
            jalali: {
                intl: 'de-DE-u-ca-persian',
                stripEra: true,
                monthNames: $94f36eaf2deb686d$var$JALALI_MONTHS_LATIN,
                dateStyles: {
                    short: {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric'
                    },
                    medium: {
                        day: 'numeric',
                        month: 'long',
                        year: 'numeric'
                    }
                }
            },
            gregory: {
                clinicCalendarIntl: undefined,
                clinicMonthNames: undefined
            }
        },
        // The DEFAULT only — before a clinic is known. Under the clinic context every
        // date is formatted on the CLINIC's zone (Membership.timezone, PM-0088).
        timeZone: 'Asia/Tehran',
        // «Sonntag, 3. August 2025» — German joins the weekday with a comma.
        weekdaySeparator: ', ',
        // The accounting period, the shift report and the payroll month are Jalali
        // in every language, as in English — named from the fixed list rather than
        // ICU's German («Mordād»), so they read «Mordad».
        clinicCalendarIntl: 'de-DE-u-ca-persian',
        clinicMonthNames: $94f36eaf2deb686d$var$JALALI_MONTHS_LATIN
    }
};
const $94f36eaf2deb686d$export$d953adbca2df8efa = Object.keys($94f36eaf2deb686d$export$e49c1078bc46f17);
const $94f36eaf2deb686d$export$1af4c7e47ad72f44 = 'fa';
const $94f36eaf2deb686d$export$95b7602913551865 = 'en';
const $94f36eaf2deb686d$export$4d2fb7344096e022 = [
    'common',
    'nav',
    'validation',
    'errors',
    'auth',
    'shortcuts',
    'settings',
    'reception',
    'patients',
    'calendar',
    'doctors',
    'people',
    'payroll',
    'cashier',
    //   line-item validation. Named for «صندوق», which was removed
    //   as a page on 2026-09-12; the keys outlived it because the
    //   settle flow did (پذیرش opens the same drawer)
    'payments',
    'accounting',
    'insurance',
    'operations',
    //   taxonomies, stock states and status vocabularies BOTH it and
    //   «کالاها و خدمات» render, which is why the namespace kept
    //   its name through the 2026-09-12 split
    'goods',
    'store',
    //   Marketplace vocabulary
    'reports',
    'subscription',
    'clinic',
    'secretary'
];
const $94f36eaf2deb686d$export$17a6a815985c8621 = (id)=>Object.prototype.hasOwnProperty.call($94f36eaf2deb686d$export$e49c1078bc46f17, id);
const $94f36eaf2deb686d$export$60d894e7aa1bc86e = ()=>(0, $eLeza.brandLocales)($94f36eaf2deb686d$export$d953adbca2df8efa);
const $94f36eaf2deb686d$export$d14eda3de108abc4 = (id)=>$94f36eaf2deb686d$export$17a6a815985c8621(id) && $94f36eaf2deb686d$export$60d894e7aa1bc86e().includes(id);
function $94f36eaf2deb686d$export$171765a6a37c37cd() {
    const ids = $94f36eaf2deb686d$export$60d894e7aa1bc86e();
    if (ids.length === $94f36eaf2deb686d$export$d953adbca2df8efa.length) return $94f36eaf2deb686d$export$e49c1078bc46f17;
    return Object.fromEntries(ids.map((id)=>[
            id,
            $94f36eaf2deb686d$export$e49c1078bc46f17[id]
        ]));
}
const $94f36eaf2deb686d$export$1ad85a23f306da6d = ()=>(0, $eLeza.brandDefaultLocale)($94f36eaf2deb686d$export$1af4c7e47ad72f44, $94f36eaf2deb686d$export$d953adbca2df8efa);
const $94f36eaf2deb686d$export$57270fb1f2649979 = (id)=>{
    const descriptor = $94f36eaf2deb686d$export$e49c1078bc46f17[id] || $94f36eaf2deb686d$export$e49c1078bc46f17[$94f36eaf2deb686d$export$1ad85a23f306da6d()];
    const calendar = (0, $eLeza.calendarSystem)(null);
    if (!calendar) return descriptor;
    // Applied even on the locale's own calendar: a Gregorian brand has no Jalali
    // clinic months, in English too (`en`'s `calendars.gregory`).
    const override = descriptor.calendars?.[calendar];
    if (!override && calendar === descriptor.calendar) return descriptor;
    return {
        ...descriptor,
        ...override,
        calendar: calendar
    };
};
function $94f36eaf2deb686d$export$dca0327c9b9c6498(tag) {
    if (!tag) return null;
    const raw = String(tag).trim();
    const base = raw.toLowerCase().split(/[-_]/)[0];
    const id = $94f36eaf2deb686d$export$17a6a815985c8621(raw) ? raw : $94f36eaf2deb686d$export$17a6a815985c8621(base) ? base : null;
    return id && $94f36eaf2deb686d$export$d14eda3de108abc4(id) ? id : null;
}
const $94f36eaf2deb686d$export$86880b4b2e1a2384 = 'parsina.locale';
function $94f36eaf2deb686d$export$9e89f130e918dc2a() {
    try {
        return $94f36eaf2deb686d$export$dca0327c9b9c6498(window.localStorage.getItem($94f36eaf2deb686d$export$86880b4b2e1a2384));
    } catch  {
        // Private mode, disabled storage, or no window at all (tests, SSR).
        return null;
    }
}
function $94f36eaf2deb686d$export$e8146f0b19c81b97(id) {
    try {
        if ($94f36eaf2deb686d$export$d14eda3de108abc4(id)) window.localStorage.setItem($94f36eaf2deb686d$export$86880b4b2e1a2384, id);
    } catch  {
    /* A locale we cannot cache still works — it just re-resolves next launch. */ }
}
function $94f36eaf2deb686d$export$831a5617a2963db1() {
    return $94f36eaf2deb686d$export$9e89f130e918dc2a() || $94f36eaf2deb686d$export$1ad85a23f306da6d();
}
function $94f36eaf2deb686d$export$fff0f9a021c4ca38(id) {
    const locale = $94f36eaf2deb686d$export$d14eda3de108abc4(id) ? id : $94f36eaf2deb686d$export$1ad85a23f306da6d();
    const root = typeof document !== 'undefined' ? document.documentElement : null;
    if (root) {
        root.setAttribute('lang', locale);
        root.setAttribute('dir', $94f36eaf2deb686d$export$e49c1078bc46f17[locale].dir);
    }
    return locale;
}

});

parcelRegister("iwuD4", function(module, exports) {

$parcel$export(module.exports, "loadCatalog", () => $d7c2f9731adebacb$export$5bd1a830868d1d11);
$parcel$export(module.exports, "peekCatalog", () => $d7c2f9731adebacb$export$d2d95d0a2b5fab1e);
$parcel$export(module.exports, "preloadCatalog", () => $d7c2f9731adebacb$export$f2675afc1de9f02e);
// ─────────────────────────────────────────────────────────────────────────────
// Translation loading + cache.
//
// Every namespace is its own `import()`, so Parcel code-splits each feature's
// strings into its own asset and a locale is only ever downloaded once someone
// actually selects it. English is not on the wire for a receptionist who never
// leaves Persian.
//
// Two caches, both process-lifetime:
//   `cache`    locale/namespace → the parsed bundle. A second switch back to a
//              language is synchronous — nothing is re-fetched or re-parsed.
//   `inflight` locale/namespace → the in-progress promise, so N simultaneous
//              requests for the same file share one network round trip.
//
// The map below is written out by hand rather than built from a template
// literal because Parcel resolves `import()` statically: a computed specifier
// would silently produce a bundle with no translations in it.
// ─────────────────────────────────────────────────────────────────────────────

var $cMRsf = parcelRequire("cMRsf");
























































































































const $d7c2f9731adebacb$var$IMPORTERS = {
    fa: {
        common: ()=>(parcelRequire("7LWfy")),
        nav: ()=>(parcelRequire("1gqde")),
        validation: ()=>(parcelRequire("hL0DY")),
        errors: ()=>(parcelRequire("eymjQ")),
        auth: ()=>(parcelRequire("8FGNB")),
        shortcuts: ()=>(parcelRequire("1Ifet")),
        settings: ()=>(parcelRequire("b44Ko")),
        reception: ()=>(parcelRequire("b5flZ")),
        patients: ()=>(parcelRequire("5C8DD")),
        calendar: ()=>(parcelRequire("8ppGR")),
        doctors: ()=>(parcelRequire("aH2bf")),
        people: ()=>(parcelRequire("eP9WE")),
        payroll: ()=>(parcelRequire("lo2FG")),
        cashier: ()=>(parcelRequire("oMWei")),
        payments: ()=>(parcelRequire("ktY7K")),
        accounting: ()=>(parcelRequire("eEH69")),
        insurance: ()=>(parcelRequire("lf9G0")),
        operations: ()=>(parcelRequire("lW6AP")),
        goods: ()=>(parcelRequire("geT5I")),
        store: ()=>(parcelRequire("cUnR4")),
        reports: ()=>(parcelRequire("fPWQJ")),
        subscription: ()=>(parcelRequire("dlzvX")),
        clinic: ()=>(parcelRequire("ivKQf")),
        secretary: ()=>(parcelRequire("kniaH"))
    },
    en: {
        common: ()=>(parcelRequire("iQ83R")),
        nav: ()=>(parcelRequire("3RraV")),
        validation: ()=>(parcelRequire("cLLOU")),
        errors: ()=>(parcelRequire("6GiKw")),
        auth: ()=>(parcelRequire("bGFwJ")),
        shortcuts: ()=>(parcelRequire("e7dcB")),
        settings: ()=>(parcelRequire("lvDHn")),
        reception: ()=>(parcelRequire("gkCkL")),
        patients: ()=>(parcelRequire("sdGfK")),
        calendar: ()=>(parcelRequire("lLGkt")),
        doctors: ()=>(parcelRequire("3FVqN")),
        people: ()=>(parcelRequire("kLVw8")),
        payroll: ()=>(parcelRequire("i2lqP")),
        cashier: ()=>(parcelRequire("eEZfq")),
        payments: ()=>(parcelRequire("dpBkT")),
        accounting: ()=>(parcelRequire("3g9Za")),
        insurance: ()=>(parcelRequire("5oWbs")),
        operations: ()=>(parcelRequire("fbkpV")),
        goods: ()=>(parcelRequire("4bHxy")),
        store: ()=>(parcelRequire("j235B")),
        reports: ()=>(parcelRequire("bXsXt")),
        subscription: ()=>(parcelRequire("2YnIR")),
        clinic: ()=>(parcelRequire("eeVSd")),
        secretary: ()=>(parcelRequire("1Rjh6"))
    },
    ar: {
        common: ()=>(parcelRequire("3xb5X")),
        nav: ()=>(parcelRequire("fTRUR")),
        validation: ()=>(parcelRequire("3YBZs")),
        errors: ()=>(parcelRequire("d5Kl0")),
        auth: ()=>(parcelRequire("bhBq9")),
        shortcuts: ()=>(parcelRequire("58DjS")),
        settings: ()=>(parcelRequire("ip70C")),
        reception: ()=>(parcelRequire("5vyCX")),
        patients: ()=>(parcelRequire("dE69g")),
        calendar: ()=>(parcelRequire("jBNoO")),
        doctors: ()=>(parcelRequire("hapKK")),
        people: ()=>(parcelRequire("e6617")),
        payroll: ()=>(parcelRequire("hYZCB")),
        cashier: ()=>(parcelRequire("133qw")),
        payments: ()=>(parcelRequire("c1lCw")),
        accounting: ()=>(parcelRequire("cbn56")),
        insurance: ()=>(parcelRequire("2diSi")),
        operations: ()=>(parcelRequire("85cou")),
        goods: ()=>(parcelRequire("7SnPR")),
        store: ()=>(parcelRequire("3ed9W")),
        reports: ()=>(parcelRequire("6tjUi")),
        subscription: ()=>(parcelRequire("cr4y3")),
        clinic: ()=>(parcelRequire("5WdUk")),
        secretary: ()=>(parcelRequire("kds3T"))
    },
    fr: {
        common: ()=>(parcelRequire("c47kc")),
        nav: ()=>(parcelRequire("1vT2h")),
        validation: ()=>(parcelRequire("9fHuQ")),
        errors: ()=>(parcelRequire("9TYzn")),
        auth: ()=>(parcelRequire("ckRCV")),
        shortcuts: ()=>(parcelRequire("328k9")),
        settings: ()=>(parcelRequire("kV3Yr")),
        reception: ()=>(parcelRequire("ecvKk")),
        patients: ()=>(parcelRequire("dcOJj")),
        calendar: ()=>(parcelRequire("7w75a")),
        doctors: ()=>(parcelRequire("bkJpH")),
        people: ()=>(parcelRequire("12vaw")),
        payroll: ()=>(parcelRequire("lXGYo")),
        cashier: ()=>(parcelRequire("gsehe")),
        payments: ()=>(parcelRequire("brzZM")),
        accounting: ()=>(parcelRequire("jC6j2")),
        insurance: ()=>(parcelRequire("almcU")),
        operations: ()=>(parcelRequire("ksjJf")),
        goods: ()=>(parcelRequire("g3I65")),
        store: ()=>(parcelRequire("fnIDi")),
        reports: ()=>(parcelRequire("ahkqC")),
        subscription: ()=>(parcelRequire("6uOUS")),
        clinic: ()=>(parcelRequire("5ZB0W")),
        secretary: ()=>(parcelRequire("2ChVw"))
    },
    de: {
        common: ()=>(parcelRequire("hRRnt")),
        nav: ()=>(parcelRequire("3NuPr")),
        validation: ()=>(parcelRequire("cPRzy")),
        errors: ()=>(parcelRequire("aV0LW")),
        auth: ()=>(parcelRequire("25GWJ")),
        shortcuts: ()=>(parcelRequire("iBVsX")),
        settings: ()=>(parcelRequire("kDB4k")),
        reception: ()=>(parcelRequire("iUw84")),
        patients: ()=>(parcelRequire("7Sbda")),
        calendar: ()=>(parcelRequire("22v1H")),
        doctors: ()=>(parcelRequire("lKTKH")),
        people: ()=>(parcelRequire("02PwZ")),
        payroll: ()=>(parcelRequire("6TxWW")),
        cashier: ()=>(parcelRequire("kI3bX")),
        payments: ()=>(parcelRequire("9g9Bd")),
        accounting: ()=>(parcelRequire("lOmU0")),
        insurance: ()=>(parcelRequire("eQvTq")),
        operations: ()=>(parcelRequire("25pYK")),
        goods: ()=>(parcelRequire("3qhqa")),
        store: ()=>(parcelRequire("5WQ1R")),
        reports: ()=>(parcelRequire("3gAyq")),
        subscription: ()=>(parcelRequire("2Sj4Z")),
        clinic: ()=>(parcelRequire("ac6PO")),
        secretary: ()=>(parcelRequire("7uCtB"))
    }
};
const $d7c2f9731adebacb$var$cache = new Map();
const $d7c2f9731adebacb$var$inflight = new Map();
const $d7c2f9731adebacb$var$cacheKey = (locale, namespace)=>`${locale}/${namespace}`;
// Parcel hands back a module namespace object; the JSON is on `default` for a
// JSON asset, but a plain object comes through untouched under Vitest's transform.
const $d7c2f9731adebacb$var$unwrap = (mod)=>mod && mod.default || mod || {};
function $d7c2f9731adebacb$export$3c148aa2c2f6601d(locale, namespace) {
    const key = $d7c2f9731adebacb$var$cacheKey(locale, namespace);
    if ($d7c2f9731adebacb$var$cache.has(key)) return Promise.resolve($d7c2f9731adebacb$var$cache.get(key));
    if ($d7c2f9731adebacb$var$inflight.has(key)) return $d7c2f9731adebacb$var$inflight.get(key);
    const importer = $d7c2f9731adebacb$var$IMPORTERS[locale]?.[namespace];
    if (!importer) {
        $d7c2f9731adebacb$var$cache.set(key, {});
        return Promise.resolve({});
    }
    const promise = importer().then((mod)=>$d7c2f9731adebacb$var$unwrap(mod)).catch((err)=>{
        return {};
    }).then((bundle)=>{
        $d7c2f9731adebacb$var$cache.set(key, bundle);
        $d7c2f9731adebacb$var$inflight.delete(key);
        return bundle;
    });
    $d7c2f9731adebacb$var$inflight.set(key, promise);
    return promise;
}
function $d7c2f9731adebacb$export$5bd1a830868d1d11(locale) {
    if (!(0, $cMRsf.isSupportedLocale)(locale)) return Promise.resolve({});
    return Promise.all((0, $cMRsf.NAMESPACES).map((ns)=>$d7c2f9731adebacb$export$3c148aa2c2f6601d(locale, ns).then((bundle)=>[
                ns,
                bundle
            ]))).then(Object.fromEntries);
}
function $d7c2f9731adebacb$export$d2d95d0a2b5fab1e(locale) {
    const entries = (0, $cMRsf.NAMESPACES).map((ns)=>[
            ns,
            $d7c2f9731adebacb$var$cache.get($d7c2f9731adebacb$var$cacheKey(locale, ns))
        ]);
    return entries.every(([, bundle])=>bundle !== undefined) ? Object.fromEntries(entries) : null;
}
function $d7c2f9731adebacb$export$f2675afc1de9f02e(locale) {
    $d7c2f9731adebacb$export$5bd1a830868d1d11(locale).catch(()=>{});
}

});
parcelRegister("7LWfy", function(module, exports) {
module.exports = import("274bg").then(()=>parcelRequire('7N2f3'));

});

parcelRegister("1gqde", function(module, exports) {
module.exports = import("1onzB").then(()=>parcelRequire('duPOu'));

});

parcelRegister("hL0DY", function(module, exports) {
module.exports = import("VZrzj").then(()=>parcelRequire('bggdo'));

});

parcelRegister("eymjQ", function(module, exports) {
module.exports = import("972Jr").then(()=>parcelRequire('l3c81'));

});

parcelRegister("8FGNB", function(module, exports) {
module.exports = import("cmbQR").then(()=>parcelRequire('kcsbJ'));

});

parcelRegister("1Ifet", function(module, exports) {
module.exports = import("kCZPw").then(()=>parcelRequire('4GQxG'));

});

parcelRegister("b44Ko", function(module, exports) {
module.exports = import("dQrRX").then(()=>parcelRequire('j2u46'));

});

parcelRegister("b5flZ", function(module, exports) {
module.exports = import("lR4lN").then(()=>parcelRequire('4cUdA'));

});

parcelRegister("5C8DD", function(module, exports) {
module.exports = import("9CPN9").then(()=>parcelRequire('1UhJ7'));

});

parcelRegister("8ppGR", function(module, exports) {
module.exports = import("6g2eD").then(()=>parcelRequire('gB930'));

});

parcelRegister("aH2bf", function(module, exports) {
module.exports = import("cCYm9").then(()=>parcelRequire('2WTXd'));

});

parcelRegister("eP9WE", function(module, exports) {
module.exports = import("51uy5").then(()=>parcelRequire('f1ImP'));

});

parcelRegister("lo2FG", function(module, exports) {
module.exports = import("gaZnW").then(()=>parcelRequire('aYI6t'));

});

parcelRegister("oMWei", function(module, exports) {
module.exports = import("5mVz1").then(()=>parcelRequire('iIaBb'));

});

parcelRegister("ktY7K", function(module, exports) {
module.exports = import("boDRT").then(()=>parcelRequire('lGXqH'));

});

parcelRegister("eEH69", function(module, exports) {
module.exports = import("8mpMd").then(()=>parcelRequire('0RwE2'));

});

parcelRegister("lf9G0", function(module, exports) {
module.exports = import("1qFNn").then(()=>parcelRequire('bIcJY'));

});

parcelRegister("lW6AP", function(module, exports) {
module.exports = import("g7B1l").then(()=>parcelRequire('3EAjD'));

});

parcelRegister("geT5I", function(module, exports) {
module.exports = import("8K5KC").then(()=>parcelRequire('cG9CY'));

});

parcelRegister("cUnR4", function(module, exports) {
module.exports = import("8COGQ").then(()=>parcelRequire('3mO6i'));

});

parcelRegister("fPWQJ", function(module, exports) {
module.exports = import("x161m").then(()=>parcelRequire('8j3dX'));

});

parcelRegister("dlzvX", function(module, exports) {
module.exports = import("flTT3").then(()=>parcelRequire('hDlYa'));

});

parcelRegister("ivKQf", function(module, exports) {
module.exports = import("5EKe2").then(()=>parcelRequire('6cOvF'));

});

parcelRegister("kniaH", function(module, exports) {
module.exports = import("hjVyU").then(()=>parcelRequire('8jfay'));

});

parcelRegister("iQ83R", function(module, exports) {
module.exports = import("9syHU").then(()=>parcelRequire('cLAoC'));

});

parcelRegister("3RraV", function(module, exports) {
module.exports = import("j1vnt").then(()=>parcelRequire('5ZKEH'));

});

parcelRegister("cLLOU", function(module, exports) {
module.exports = import("1ULq8").then(()=>parcelRequire('2alwl'));

});

parcelRegister("6GiKw", function(module, exports) {
module.exports = import("6QFwk").then(()=>parcelRequire('86zPb'));

});

parcelRegister("bGFwJ", function(module, exports) {
module.exports = import("7WKFa").then(()=>parcelRequire('b58dq'));

});

parcelRegister("e7dcB", function(module, exports) {
module.exports = import("iubcx").then(()=>parcelRequire('l03Ya'));

});

parcelRegister("lvDHn", function(module, exports) {
module.exports = import("6qHJ5").then(()=>parcelRequire('jBEkR'));

});

parcelRegister("gkCkL", function(module, exports) {
module.exports = import("dv1Jq").then(()=>parcelRequire('1DQAr'));

});

parcelRegister("sdGfK", function(module, exports) {
module.exports = import("5rhvO").then(()=>parcelRequire('hGYyl'));

});

parcelRegister("lLGkt", function(module, exports) {
module.exports = import("lmbRb").then(()=>parcelRequire('2ghdd'));

});

parcelRegister("3FVqN", function(module, exports) {
module.exports = import("eu1aC").then(()=>parcelRequire('6pep8'));

});

parcelRegister("kLVw8", function(module, exports) {
module.exports = import("gFnpw").then(()=>parcelRequire('hrsLd'));

});

parcelRegister("i2lqP", function(module, exports) {
module.exports = import("lJVk7").then(()=>parcelRequire('KirAg'));

});

parcelRegister("eEZfq", function(module, exports) {
module.exports = import("10GQj").then(()=>parcelRequire('9RVoC'));

});

parcelRegister("dpBkT", function(module, exports) {
module.exports = import("hZ4vN").then(()=>parcelRequire('3GRJF'));

});

parcelRegister("3g9Za", function(module, exports) {
module.exports = import("f6Shq").then(()=>parcelRequire('2C5fg'));

});

parcelRegister("5oWbs", function(module, exports) {
module.exports = import("jDrtr").then(()=>parcelRequire('ceqc8'));

});

parcelRegister("fbkpV", function(module, exports) {
module.exports = import("evimt").then(()=>parcelRequire('JhPGz'));

});

parcelRegister("4bHxy", function(module, exports) {
module.exports = import("d5Fl5").then(()=>parcelRequire('aq7f0'));

});

parcelRegister("j235B", function(module, exports) {
module.exports = import("5S6wI").then(()=>parcelRequire('fHgjL'));

});

parcelRegister("bXsXt", function(module, exports) {
module.exports = import("CVIsr").then(()=>parcelRequire('cSYOz'));

});

parcelRegister("2YnIR", function(module, exports) {
module.exports = import("015yg").then(()=>parcelRequire('fCqB3'));

});

parcelRegister("eeVSd", function(module, exports) {
module.exports = import("b1CeP").then(()=>parcelRequire('7S1i2'));

});

parcelRegister("1Rjh6", function(module, exports) {
module.exports = import("efsHd").then(()=>parcelRequire('4Peiy'));

});

parcelRegister("3xb5X", function(module, exports) {
module.exports = import("fCJBO").then(()=>parcelRequire('kZkTr'));

});

parcelRegister("fTRUR", function(module, exports) {
module.exports = import("bPPuh").then(()=>parcelRequire('lKuKJ'));

});

parcelRegister("3YBZs", function(module, exports) {
module.exports = import("4KA8M").then(()=>parcelRequire('gyvIn'));

});

parcelRegister("d5Kl0", function(module, exports) {
module.exports = import("h2X7b").then(()=>parcelRequire('dlR66'));

});

parcelRegister("bhBq9", function(module, exports) {
module.exports = import("4ToWR").then(()=>parcelRequire('8ZK5C'));

});

parcelRegister("58DjS", function(module, exports) {
module.exports = import("gnjVL").then(()=>parcelRequire('59aj7'));

});

parcelRegister("ip70C", function(module, exports) {
module.exports = import("jtRUc").then(()=>parcelRequire('kVcA0'));

});

parcelRegister("5vyCX", function(module, exports) {
module.exports = import("50pFp").then(()=>parcelRequire('5rmev'));

});

parcelRegister("dE69g", function(module, exports) {
module.exports = import("erwUR").then(()=>parcelRequire('drmjy'));

});

parcelRegister("jBNoO", function(module, exports) {
module.exports = import("ixs7y").then(()=>parcelRequire('2CEv4'));

});

parcelRegister("hapKK", function(module, exports) {
module.exports = import("lcoGf").then(()=>parcelRequire('jkYxr'));

});

parcelRegister("e6617", function(module, exports) {
module.exports = import("klcgT").then(()=>parcelRequire('kXvZK'));

});

parcelRegister("hYZCB", function(module, exports) {
module.exports = import("l67M9").then(()=>parcelRequire('2BmsV'));

});

parcelRegister("133qw", function(module, exports) {
module.exports = import("c9wz8").then(()=>parcelRequire('iTSgy'));

});

parcelRegister("c1lCw", function(module, exports) {
module.exports = import("3iMiK").then(()=>parcelRequire('ccWTQ'));

});

parcelRegister("cbn56", function(module, exports) {
module.exports = import("4n0JG").then(()=>parcelRequire('k79pT'));

});

parcelRegister("2diSi", function(module, exports) {
module.exports = import("2Hti9").then(()=>parcelRequire('gFQq7'));

});

parcelRegister("85cou", function(module, exports) {
module.exports = import("9541J").then(()=>parcelRequire('8xF2o'));

});

parcelRegister("7SnPR", function(module, exports) {
module.exports = import("39uk6").then(()=>parcelRequire('4QtMt'));

});

parcelRegister("3ed9W", function(module, exports) {
module.exports = import("Ykc2o").then(()=>parcelRequire('gMQ18'));

});

parcelRegister("6tjUi", function(module, exports) {
module.exports = import("bW02u").then(()=>parcelRequire('9nS9l'));

});

parcelRegister("cr4y3", function(module, exports) {
module.exports = import("ltJAW").then(()=>parcelRequire('f6I1J'));

});

parcelRegister("5WdUk", function(module, exports) {
module.exports = import("lMarD").then(()=>parcelRequire('aF61t'));

});

parcelRegister("kds3T", function(module, exports) {
module.exports = import("kY6aF").then(()=>parcelRequire('9at68'));

});

parcelRegister("c47kc", function(module, exports) {
module.exports = import("02PyZ").then(()=>parcelRequire('4ivhy'));

});

parcelRegister("1vT2h", function(module, exports) {
module.exports = import("7x1oO").then(()=>parcelRequire('aInZK'));

});

parcelRegister("9fHuQ", function(module, exports) {
module.exports = import("3R3nk").then(()=>parcelRequire('c3BgJ'));

});

parcelRegister("9TYzn", function(module, exports) {
module.exports = import("5wwPo").then(()=>parcelRequire('6UbTO'));

});

parcelRegister("ckRCV", function(module, exports) {
module.exports = import("1z7un").then(()=>parcelRequire('kLJ2y'));

});

parcelRegister("328k9", function(module, exports) {
module.exports = import("kywW1").then(()=>parcelRequire('dnB2i'));

});

parcelRegister("kV3Yr", function(module, exports) {
module.exports = import("b7hvI").then(()=>parcelRequire('lgvFE'));

});

parcelRegister("ecvKk", function(module, exports) {
module.exports = import("6C91X").then(()=>parcelRequire('3asDk'));

});

parcelRegister("dcOJj", function(module, exports) {
module.exports = import("h6wga").then(()=>parcelRequire('eicgm'));

});

parcelRegister("7w75a", function(module, exports) {
module.exports = import("aY8n1").then(()=>parcelRequire('aLh44'));

});

parcelRegister("bkJpH", function(module, exports) {
module.exports = import("cf1ew").then(()=>parcelRequire('ku8iM'));

});

parcelRegister("12vaw", function(module, exports) {
module.exports = import("10Dv4").then(()=>parcelRequire('abtlO'));

});

parcelRegister("lXGYo", function(module, exports) {
module.exports = import("1aej0").then(()=>parcelRequire('hylM5'));

});

parcelRegister("gsehe", function(module, exports) {
module.exports = import("aeyHZ").then(()=>parcelRequire('8UO0P'));

});

parcelRegister("brzZM", function(module, exports) {
module.exports = import("a7GUf").then(()=>parcelRequire('fTB5I'));

});

parcelRegister("jC6j2", function(module, exports) {
module.exports = import("fJnHX").then(()=>parcelRequire('5ex5m'));

});

parcelRegister("almcU", function(module, exports) {
module.exports = import("fzdKN").then(()=>parcelRequire('5QNBc'));

});

parcelRegister("ksjJf", function(module, exports) {
module.exports = import("kmeuk").then(()=>parcelRequire('gOE8r'));

});

parcelRegister("g3I65", function(module, exports) {
module.exports = import("4ULb8").then(()=>parcelRequire('aqZEJ'));

});

parcelRegister("fnIDi", function(module, exports) {
module.exports = import("1579O").then(()=>parcelRequire('f4f33'));

});

parcelRegister("ahkqC", function(module, exports) {
module.exports = import("dzlon").then(()=>parcelRequire('9LikG'));

});

parcelRegister("6uOUS", function(module, exports) {
module.exports = import("7fAmC").then(()=>parcelRequire('7Ca5I'));

});

parcelRegister("5ZB0W", function(module, exports) {
module.exports = import("jDcWY").then(()=>parcelRequire('icbbj'));

});

parcelRegister("2ChVw", function(module, exports) {
module.exports = import("kagMV").then(()=>parcelRequire('kcj7t'));

});

parcelRegister("hRRnt", function(module, exports) {
module.exports = import("fVBMv").then(()=>parcelRequire('cMj1t'));

});

parcelRegister("3NuPr", function(module, exports) {
module.exports = import("loMqQ").then(()=>parcelRequire('f1K69'));

});

parcelRegister("cPRzy", function(module, exports) {
module.exports = import("kHP41").then(()=>parcelRequire('a6uYI'));

});

parcelRegister("aV0LW", function(module, exports) {
module.exports = import("8LIid").then(()=>parcelRequire('ctGQD'));

});

parcelRegister("25GWJ", function(module, exports) {
module.exports = import("kCkoV").then(()=>parcelRequire('agS4j'));

});

parcelRegister("iBVsX", function(module, exports) {
module.exports = import("iOowM").then(()=>parcelRequire('fvV61'));

});

parcelRegister("kDB4k", function(module, exports) {
module.exports = import("6DVAy").then(()=>parcelRequire('cgW8I'));

});

parcelRegister("iUw84", function(module, exports) {
module.exports = import("7a6F6").then(()=>parcelRequire('e24MF'));

});

parcelRegister("7Sbda", function(module, exports) {
module.exports = import("03S8m").then(()=>parcelRequire('4qDFz'));

});

parcelRegister("22v1H", function(module, exports) {
module.exports = import("fxcB3").then(()=>parcelRequire('9WaMZ'));

});

parcelRegister("lKTKH", function(module, exports) {
module.exports = import("js9xT").then(()=>parcelRequire('lC0Oh'));

});

parcelRegister("02PwZ", function(module, exports) {
module.exports = import("6mOTp").then(()=>parcelRequire('iwNKq'));

});

parcelRegister("6TxWW", function(module, exports) {
module.exports = import("t1sy2").then(()=>parcelRequire('aNGi1'));

});

parcelRegister("kI3bX", function(module, exports) {
module.exports = import("paqEF").then(()=>parcelRequire('gALri'));

});

parcelRegister("9g9Bd", function(module, exports) {
module.exports = import("jEtI7").then(()=>parcelRequire('ihEwn'));

});

parcelRegister("lOmU0", function(module, exports) {
module.exports = import("hYYDU").then(()=>parcelRequire('8D0DY'));

});

parcelRegister("eQvTq", function(module, exports) {
module.exports = import("5eSpR").then(()=>parcelRequire('fDrjO'));

});

parcelRegister("25pYK", function(module, exports) {
module.exports = import("ffSA2").then(()=>parcelRequire('3XDxI'));

});

parcelRegister("3qhqa", function(module, exports) {
module.exports = import("gxTiL").then(()=>parcelRequire('2Cj2z'));

});

parcelRegister("5WQ1R", function(module, exports) {
module.exports = import("8XNyP").then(()=>parcelRequire('jFvX1'));

});

parcelRegister("3gAyq", function(module, exports) {
module.exports = import("lj7M8").then(()=>parcelRequire('47Tjn'));

});

parcelRegister("2Sj4Z", function(module, exports) {
module.exports = import("djvSz").then(()=>parcelRequire('4RJLO'));

});

parcelRegister("ac6PO", function(module, exports) {
module.exports = import("5oa4j").then(()=>parcelRequire('3TUFG'));

});

parcelRegister("7uCtB", function(module, exports) {
module.exports = import("4ocVW").then(()=>parcelRequire('eab07'));

});


parcelRegister("7rPjk", function(module, exports) {

$parcel$export(module.exports, "MONEY_UNIT_KEYS", () => $56c2db411f2e97f5$export$fd87a46e15eed96b);
$parcel$export(module.exports, "createTranslator", () => $56c2db411f2e97f5$export$6f3122ee6dbd9f46);
// ─────────────────────────────────────────────────────────────────────────────
// The translator — key → string. Pure, synchronous, and it never throws.
//
// A key is FULLY QUALIFIED and its first segment is the namespace:
//
//     t('settings.language.title')   → translations/<locale>/settings.json
//                                      → { language: { title: … } }
//
// One rule, no per-call configuration, and a key is enough to find the string
// on disk. That matters more than the keystrokes a scoped `t` would save: the
// question asked in front of a screen is always "where does this text live".
//
// Resolution order for every lookup:
//   1. the active locale — the brand's `strings` overlay, then the catalogue
//   2. FALLBACK_LOCALE (English — the source catalogue, where every key exists),
//      overlay first in the same way
//   3. the key's last segment, humanised
//
// Step 3 exists so a missing key degrades to something a receptionist can read
// rather than to a crash or an empty button. Steps 2 and 3 log once per key in
// development and stay silent in production.
//
// THE BRAND (@parsina/framework/ui/lib/brand). A catalogue value names the
// product as `{{brand}}`, its credit as `{{coin}}` / `{{coinEz}}` and its
// tagline as `{{tagline}}`; those resolve here, in the language of the catalogue
// the text came from, with no value passed by the caller. With no brand
// configured they resolve to the words the catalogue used to spell out, so the
// output is what it always was (src/i18n/brandParity.test.js).
// ─────────────────────────────────────────────────────────────────────────────

var $eLeza = parcelRequire("eLeza");

var $cMRsf = parcelRequire("cMRsf");
const $56c2db411f2e97f5$var$isDev = false;
// One warning per key per session. A missing key inside a list that renders on
// every keystroke would otherwise bury the console it is trying to inform.
const $56c2db411f2e97f5$var$warned = new Set();
function $56c2db411f2e97f5$var$warnOnce(message) {
    if (!$56c2db411f2e97f5$var$isDev) return;
    if ($56c2db411f2e97f5$var$warned.has(message)) return;
    $56c2db411f2e97f5$var$warned.add(message);
    console.warn(`[i18n] ${message}`);
}
/**
 * `settings.language.title` → `catalog.settings.language.title`, or undefined.
 * Dotted segments only; a value that is not a string or array is treated as a
 * miss, so pointing a key at a whole subtree reports as missing instead of
 * rendering `[object Object]`.
 */ function $56c2db411f2e97f5$var$lookup(catalog, key) {
    if (!catalog || !key) return undefined;
    let node = catalog;
    for (const segment of key.split('.')){
        if (node == null || typeof node !== 'object') return undefined;
        node = node[segment];
    }
    return typeof node === 'string' || Array.isArray(node) ? node : undefined;
}
/**
 * `lookup`, with the brand's own text for `key` in `locale` asked first — the
 * `strings` overlay a deployment uses for wording a token cannot express.
 */ function $56c2db411f2e97f5$var$find(catalog, locale, key) {
    const own = (0, $eLeza.brandString)(locale, key);
    if (typeof own === 'string' || Array.isArray(own)) return own;
    return $56c2db411f2e97f5$var$lookup(catalog, key);
}
const $56c2db411f2e97f5$export$fd87a46e15eed96b = Object.freeze({
    long: 'common.units.toman',
    inline: 'common.units.tomanInline',
    short: 'common.units.tomanShort'
});
/**
 * `{{name}}` → the matching value. An unknown placeholder is left verbatim so
 * the gap is visible in review rather than silently swallowed.
 *
 * A NUMBER is interpolated through the locale's number formatter, not
 * `String()`. «۳ مورد» is the Persian for "3 items"; «3 مورد» is a half-
 * translated string, and it is the single easiest way for Latin digits to leak
 * into an otherwise Persian screen — every count, total and threshold in the
 * app arrives through this function.
 *
 * Pass a STRING when a number must not be grouped or localised — a year, a
 * version, an ICD code. That is the escape hatch, and it is explicit at the
 * call site rather than inferred from magnitude.
 *
 * Values are inserted as text: this returns a string for React to render as a
 * text node, so there is no HTML parsing and nothing to escape. Interpolating
 * markup is deliberately impossible — a string that needs a bold span is two
 * keys and a component, not a template.
 *
 * `defaults` fill a placeholder the caller did not name (see `defaultValues`).
 *
 * A placeholder the caller did not name may also be a BRAND token (`{{brand}}`,
 * `{{coin}}`, `{{coinEz}}`, `{{tagline}}`, optionally with an inline default:
 * `{{brand|بارسينا}}`) — resolved for `locale`, the language of the template.
 * One pass, so a caller's value that happens to contain `{{brand}}` is inserted
 * as written and never resolved.
 */ function $56c2db411f2e97f5$var$interpolate(template, values, formatNumber, defaults, locale) {
    if (template.indexOf('{{') === -1) return template;
    return template.replace((0, $eLeza.PLACEHOLDER), (match, name, inline)=>{
        // A caller's own value wins whenever the caller NAMED it — even as null, which
        // keeps today's "leave the gap visible" behaviour for a stock `{{unit}}` whose
        // value is missing. Only a name the caller never passed falls to the brand,
        // then to a default.
        const named = values != null && Object.prototype.hasOwnProperty.call(values, name);
        if (!named) {
            const token = (0, $eLeza.brandToken)(name, locale, inline);
            if (token !== undefined) return token;
        }
        const value = named ? values[name] : defaults?.[name];
        if (value == null) return match;
        if (typeof value === 'number' && Number.isFinite(value)) return formatNumber(value);
        return String(value);
    });
}
/**
 * Plural suffix for `count`, using the locale's own CLDR rules — Persian has
 * `one`/`other`, English has `one`/`other`, and a language added later with six
 * forms works without touching this file.
 *
 * `key_zero` is honoured ahead of the CLDR category when it exists, because
 * "no appointments" is usually a different sentence rather than a different
 * number, in every language.
 */ function $56c2db411f2e97f5$var$pluralKey(get, key, count, pluralRules) {
    if (count === 0 && get(`${key}_zero`) !== undefined) return `${key}_zero`;
    const category = pluralRules ? pluralRules.select(count) : 'other';
    if (get(`${key}_${category}`) !== undefined) return `${key}_${category}`;
    if (get(`${key}_other`) !== undefined) return `${key}_other`;
    return key;
}
/** `settings.language.title` → `Title`. The last-resort rendering. */ function $56c2db411f2e97f5$var$humanise(key) {
    const last = String(key).split('.').pop() || String(key);
    return last.replace(/[_-]+/g, ' ').replace(/([a-z0-9])([A-Z])/g, '$1 $2').replace(/^./, (c)=>c.toUpperCase());
}
function $56c2db411f2e97f5$export$6f3122ee6dbd9f46({ locale: locale, catalog: catalog, fallbackCatalog: fallbackCatalog, pluralRules: pluralRules, joinList: joinList, formatNumber: formatNumber, defaultValues: defaultValues, fallbackLocale: fallbackLocale = (0, $cMRsf.FALLBACK_LOCALE) }) {
    const join = joinList || ((items)=>items.join(', '));
    const num = formatNumber || ((n)=>String(n));
    const active = (key)=>$56c2db411f2e97f5$var$find(catalog, locale, key);
    const fallback = (key)=>$56c2db411f2e97f5$var$find(fallbackCatalog, fallbackLocale, key);
    // Values every string may use without the caller passing them. Today that is
    // the money unit: a catalogue string says «مبلغ ({{unit}})» / «{{amount}}
    // {{unitShort}}» / «{{amount}} {{unitInline}} of …» instead of baking
    // «تومان»/«ت» in, and the unit is the clinic's currency (the clinic's
    // CurrencyProvider re-binds these). Left to itself the translator answers with
    // the catalogue's own IRR words (MONEY_UNIT_KEYS), so an IRR string renders
    // exactly as it did when the word was literal, in every language, with or
    // without a provider.
    // Resolved lazily and once: most strings never ask.
    let defaults = null;
    const defaultsOf = ()=>{
        if (defaults) return defaults;
        if (defaultValues) defaults = typeof defaultValues === 'function' ? defaultValues() : defaultValues;
        else {
            const word = (key)=>active(key) ?? fallback(key);
            defaults = {
                unit: word($56c2db411f2e97f5$export$fd87a46e15eed96b.long),
                unitInline: word($56c2db411f2e97f5$export$fd87a46e15eed96b.inline),
                unitShort: word($56c2db411f2e97f5$export$fd87a46e15eed96b.short)
            };
        }
        return defaults;
    };
    /**
   * @param {string} key    fully-qualified, e.g. 'common.actions.save'
   * @param {object} [vars] interpolation values; `count` also selects the plural
   * @returns {string}      always a string, even when everything is missing
   */ function t(key, vars) {
        if (typeof key !== 'string' || !key) {
            $56c2db411f2e97f5$var$warnOnce(`t() called with a non-string key: ${JSON.stringify(key)}`);
            return '';
        }
        const hasCount = vars != null && typeof vars.count === 'number';
        // Active locale.
        let resolved = hasCount ? $56c2db411f2e97f5$var$pluralKey(active, key, vars.count, pluralRules) : key;
        let value = active(resolved);
        let from = locale;
        // Fallback locale.
        if (value === undefined && fallbackCatalog && fallbackCatalog !== catalog) {
            const fallbackResolved = hasCount ? $56c2db411f2e97f5$var$pluralKey(fallback, key, vars.count, pluralRules) : key;
            value = fallback(fallbackResolved);
            from = fallbackLocale;
            if (value !== undefined) $56c2db411f2e97f5$var$warnOnce(`missing key "${key}" in "${locale}" \u{2014} fell back to English`);
        }
        // Nothing anywhere.
        if (value === undefined) {
            $56c2db411f2e97f5$var$warnOnce(`missing key "${key}" in every locale \u{2014} showing the key`);
            return $56c2db411f2e97f5$var$humanise(key);
        }
        // A key whose value is an array joined for `t`; `tList` returns the array.
        if (Array.isArray(value)) return join(value.map((item)=>$56c2db411f2e97f5$var$interpolate(String(item), vars, num, defaultsOf(), from)));
        return $56c2db411f2e97f5$var$interpolate(value, vars, num, defaultsOf(), from);
    }
    /**
   * A key whose value is a JSON array, as an array — for bullet lists and
   * option sets, so a translator can add or drop an item without a code change.
   * Always an array, empty when the key is missing.
   */ function tList(key, vars) {
        let value = active(key);
        let from = locale;
        if (value === undefined) {
            value = fallback(key);
            from = fallbackLocale;
        }
        if (!Array.isArray(value)) {
            if (value === undefined) $56c2db411f2e97f5$var$warnOnce(`missing list key "${key}"`);
            return [];
        }
        return value.map((item)=>$56c2db411f2e97f5$var$interpolate(String(item), vars, num, defaultsOf(), from));
    }
    /** Whether a key resolves anywhere — for conditionally-rendered optional copy. */ function has(key) {
        return active(key) !== undefined || fallback(key) !== undefined;
    }
    return {
        t: t,
        tList: tList,
        has: has
    };
}

});

parcelRegister("gVWNP", function(module, exports) {

$parcel$export(module.exports, "createFormatters", () => $c53f9539af19d960$export$c3f4cd5551df13fd);
$parcel$export(module.exports, "toAsciiDigits", () => $c53f9539af19d960$export$e53ee9755c8a3679);
$parcel$export(module.exports, "LTR_TEXT", () => $c53f9539af19d960$export$3433559efc22d110);
$parcel$export(module.exports, "MIRROR_ICON", () => $c53f9539af19d960$export$ddb338179359cccc);
// ─────────────────────────────────────────────────────────────────────────────
// Locale-aware formatting: dates, times, numbers, money, relative time.
//
// Everything here is driven by the locale descriptor's `intl` tag, which
// carries the calendar and numbering system as Unicode extensions
// (`fa-IR-u-ca-persian-nu-arabext`). That is what makes "add a language" a
// data change: no formatter in this file branches on a locale id, and the
// Jalali↔Gregorian switch is a consequence of the tag, not an `if`.
//
// Where ICU's own data for a locale disagrees with how an Iranian clinic writes
// a date — or is simply wrong — the correction is declared on the DESCRIPTOR
// (`dateStyles`, `stripEra`, `numericDateOrder`, `monthNames`) and applied
// generically below. That is the escape hatch that keeps the rule above true:
// the knowledge that Arabic on the Persian calendar needs an era stripped and
// six of CLDR's twelve month names replaced lives with the locale, not in here.
//
// Two rules that are not negotiable:
//
//   • MONEY. Every service, gRPC message and GraphQL field in Parsina carries
//     an integer number of MINOR UNITS of the document's currency — WHOLE RIALS
//     for IRR, which is also what a blank currency means. Humans read TOMAN for
//     IRR: `formatMoney` takes rials and renders toman, exactly like
//     @parsina/framework's `fmtToman` — it only adds the locale. Passing a toman
//     figure to it bills a tenth of what was meant. Another currency is passed
//     as `{ currency }` and read through the kit's `currency` table; two
//     currencies are never added or compared. (A copy of the framework's
//     clinical `format.js` rule; screens reach it through `useTranslation()`,
//     whose `formatMoney` already defaults to the clinic's currency — money.js.)
//
//   • TIME ZONE. A clinic runs on Iran local time whatever language the UI is
//     in: an appointment at 14:30 is 14:30 in Tehran, not in the browser's
//     zone. Every date formatter pins `timeZone` from the descriptor.
//
// Instances are memoised per (locale, shape) because constructing an
// Intl.DateTimeFormat is expensive relative to using one, and these run inside
// list rows that re-render on every keystroke.
// ─────────────────────────────────────────────────────────────────────────────

var $eLeza = parcelRequire("eLeza");

var $cMRsf = parcelRequire("cMRsf");

var $1O6TO = parcelRequire("1O6TO");
var $lHVFz = parcelRequire("lHVFz");
const $c53f9539af19d960$var$memo = new Map();
function $c53f9539af19d960$var$intl(Ctor, name, locale, options) {
    const key = `${name}|${locale}|${JSON.stringify(options)}`;
    let instance = $c53f9539af19d960$var$memo.get(key);
    if (!instance) {
        instance = new Ctor(locale, options);
        $c53f9539af19d960$var$memo.set(key, instance);
    }
    return instance;
}
/** Anything date-ish → Date, or null when it is not a usable instant. */ function $c53f9539af19d960$var$toDate(value) {
    if (value == null || value === '') return null;
    const date = value instanceof Date ? value : new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
}
// One instant inside each Jalali month, used only to ASK ICU for that month's
// name. The 15th at noon UTC: far enough from either boundary that no time zone
// — including the Asia/Tehran the formatters pin to — can push it into a
// neighbouring month. 1404 is an ordinary (non-leap) Jalali year, so every
// month has a 15th.
const $c53f9539af19d960$var$MONTH_ANCHORS = [
    Date.UTC(2025, 3, 4),
    Date.UTC(2025, 4, 5),
    Date.UTC(2025, 5, 5),
    Date.UTC(2025, 6, 6),
    Date.UTC(2025, 7, 6),
    Date.UTC(2025, 8, 6),
    Date.UTC(2025, 9, 7),
    Date.UTC(2025, 10, 6),
    Date.UTC(2025, 11, 6),
    Date.UTC(2026, 0, 5),
    Date.UTC(2026, 1, 4),
    Date.UTC(2026, 2, 6)
].map((ms)=>ms + 43200000);
// The same for the GREGORIAN months, January first — the clinic's calendar under a
// brand on the Gregorian calendar (`calendar: 'gregory'`). The 15th at noon UTC, for
// the reason above.
const $c53f9539af19d960$var$GREGORIAN_MONTH_ANCHORS = Array.from({
    length: 12
}, (_, i)=>Date.UTC(2025, i, 15, 12));
// One instant on each weekday, Saturday first — used only to ASK ICU for that
// day's name. 2025-08-02 is a Saturday; noon UTC keeps every one of them on the
// same calendar day in Asia/Tehran (UTC+3:30), which is the zone the formatters
// pin to.
const $c53f9539af19d960$var$WEEKDAY_ANCHORS = Array.from({
    length: 7
}, (_, i)=>Date.UTC(2025, 7, 2 + i) + 43200000);
// What an empty/unparseable value renders as. An em dash reads as "no value"
// in both scripts and never looks like a zero.
const $c53f9539af19d960$var$EMPTY = "\u2014";
// Named date shapes, so screens ask for a meaning rather than a field list and
// every «visit date» in the app looks the same.
//
//   short    ۱۴۰۴/۵/۱۲            8/3/25          dense tables
//   medium   ۱۲ مرداد ۱۴۰۴        Aug 3, 2025     the default
//   long     ۱۲ مرداد ۱۴۰۴        August 3, 2025  headers
//   full     یکشنبه، ۱۲ مرداد ۱۴۰۴ Sunday, …      day views
//   dayMonth ۱۲ مرداد            Aug 3           calendar chrome
//   weekdayDayMonth  یکشنبه، ۱۲ مرداد   Sunday, Aug 3   day navigator
//
// A descriptor may override individual shapes through its `dateStyles` field
// when ICU's pattern for that locale disagrees with how an Iranian clinic
// writes the date. The override is data, not a branch: a locale declares
// `numericDateOrder` and format.js applies it without knowing which locale it is.
const $c53f9539af19d960$var$DATE_STYLES = {
    short: {
        dateStyle: 'short'
    },
    medium: {
        dateStyle: 'medium'
    },
    long: {
        dateStyle: 'long'
    },
    dayMonth: {
        day: 'numeric',
        month: 'long'
    },
    monthYear: {
        month: 'long',
        year: 'numeric'
    },
    // The month alone — for a chart's month gridline, where the year is carried
    // by the one tick that crosses it rather than repeated on all twelve.
    month: {
        month: 'long'
    }
};
/**
 * Drop the era designator ICU appends when a locale is asked for a calendar
 * that is not its own default: Arabic on the Persian calendar renders
 * «١٢ مرداد ١٤٠٤ ه‍.ش», and `era: undefined` does not suppress it. The literal
 * that only ever joined the era to the date goes with it, so nothing is left
 * dangling at either end.
 */ function $c53f9539af19d960$var$dropEra(parts) {
    if (!parts.some((part)=>part.type === 'era')) return parts;
    return parts.filter((part, i)=>{
        if (part.type === 'era') return false;
        if (part.type !== 'literal') return true;
        return parts[i - 1]?.type !== 'era' && parts[i + 1]?.type !== 'era';
    });
}
// Any Unicode decimal digit — Arabic-Indic ٠-٩ and Persian ۰-۹ included. Used
// to tell a numeric month («٥») from a month NAME («مرداد») without knowing
// which numbering system is in play.
const $c53f9539af19d960$var$DIGITS_ONLY = /^\p{Nd}+$/u;
const $c53f9539af19d960$var$DATE_FIELDS = [
    'year',
    'month',
    'day'
];
/** A month rendered as a NAME rather than as digits. */ const $c53f9539af19d960$var$isNamedMonth = (part)=>part.type === 'month' && !$c53f9539af19d960$var$DIGITS_ONLY.test(part.value);
/**
 * Substitute the descriptor's own month names for ICU's, for the locales where
 * CLDR's data for this language/calendar pairing is wrong. Only a month
 * rendered as a name is touched — a numeric month is already correct, and
 * replacing it would turn «٥» into a word.
 */ function $c53f9539af19d960$var$withMonthNames(parts, names, monthNumber) {
    const replacement = names[monthNumber - 1];
    if (!replacement) return parts;
    return parts.map((part)=>$c53f9539af19d960$var$isNamedMonth(part) ? {
            ...part,
            value: replacement
        } : part);
}
/**
 * Re-order an ALL-NUMERIC date into the descriptor's field order, keeping the
 * separator the locale itself chose. ICU writes the numeric Arabic date
 * day-first while Persian writes it year-first, and two RTL languages
 * disagreeing about the same calendar on the same screen is how a date gets
 * transcribed wrong.
 *
 * Returns null — meaning "leave this one alone" — for any shape that is not
 * exactly three numeric fields and their separators, so a month name, a
 * weekday or a time is never reordered.
 */ function $c53f9539af19d960$var$reorderNumericDate(parts, order) {
    const fields = parts.filter((part)=>$c53f9539af19d960$var$DATE_FIELDS.includes(part.type));
    if (fields.length !== 3) return null;
    if (!fields.every((part)=>$c53f9539af19d960$var$DIGITS_ONLY.test(part.value))) return null;
    if (parts.some((part)=>part.type !== 'literal' && !$c53f9539af19d960$var$DATE_FIELDS.includes(part.type))) return null;
    const value = Object.fromEntries(fields.map((part)=>[
            part.type,
            part.value
        ]));
    const separator = parts.find((part)=>part.type === 'literal')?.value ?? '/';
    return order.map((type)=>value[type]).join(separator);
}
function $c53f9539af19d960$export$c3f4cd5551df13fd(localeId, { timeZone: clinicZone } = {}) {
    const { intl: tag, timeZone: localeZone, weekdaySeparator: weekdaySeparator = ', ', dateStyles: styleOverrides, stripEra: stripEra, numericDateOrder: numericDateOrder, monthNames: monthNames, clinicCalendarIntl: clinicCalendarIntl, clinicMonthNames: clinicMonthList } = (0, $cMRsf.localeDescriptor)(localeId);
    // The CLINIC's zone when one is known (PM-0088) — <CurrencyProvider timeZone>
    // under the clinic context passes it; before a clinic is known, the
    // descriptor's default.
    const timeZone = clinicZone || localeZone;
    // Surfaces that are Jalali in every language fall back to the locale's own
    // tag, which is already Jalali for `fa`.
    const clinicTag = clinicCalendarIntl || tag;
    const dateTime = (options)=>$c53f9539af19d960$var$intl(Intl.DateTimeFormat, 'dt', tag, {
            timeZone: timeZone,
            ...options
        });
    const number = (options)=>$c53f9539af19d960$var$intl(Intl.NumberFormat, 'n', tag, options);
    /** The options for a named shape, with the locale's override applied. */ const styleOptions = (style)=>{
        const name = $c53f9539af19d960$var$DATE_STYLES[style] || styleOverrides?.[style] ? style : 'medium';
        return styleOverrides?.[name] || $c53f9539af19d960$var$DATE_STYLES[name];
    };
    /**
   * The month's number (1-12) in this locale's own calendar. Forced to Latin
   * digits so it is an index rather than a glyph run — the tag's `-nu-` would
   * otherwise hand back «٥».
   */ const monthNumber = (date, calendarTag = tag)=>Number($c53f9539af19d960$var$intl(Intl.DateTimeFormat, 'dt', calendarTag, {
            timeZone: timeZone,
            month: 'numeric',
            numberingSystem: 'latn'
        }).format(date));
    /**
   * One date shape, with the descriptor's corrections applied. A locale that
   * declares none of them goes straight through ICU untouched, which is every
   * locale but `ar`.
   */ const renderDate = (date, style)=>{
        const formatter = dateTime(styleOptions(style));
        if (!stripEra && !numericDateOrder && !monthNames) return formatter.format(date);
        let parts = formatter.formatToParts(date);
        if (stripEra) parts = $c53f9539af19d960$var$dropEra(parts);
        if (monthNames && parts.some($c53f9539af19d960$var$isNamedMonth)) parts = $c53f9539af19d960$var$withMonthNames(parts, monthNames, monthNumber(date));
        if (numericDateOrder) {
            const reordered = $c53f9539af19d960$var$reorderNumericDate(parts, numericDateOrder);
            if (reordered !== null) return reordered;
        }
        return parts.map((part)=>part.value).join('').trim();
    };
    /**
   * The month of the CLINIC's calendar — Jalali — in the reading locale's
   * language and digits, whatever calendar that locale otherwise uses.
   *
   * The analysis timeline grids its axis on Jalali month boundaries, because
   * «this month» to an Iranian clinic means the Jalali month on the wall. A
   * gridline standing at 1 Mordad must therefore be labelled «مرداد» /
   * «Mordad», not «August» — the Gregorian month that line does not start.
   *
   * Composed from parts rather than asked for as a pattern, for two reasons ICU
   * forces: every locale puts the year on a different side of the month (Persian
   * emits «۱۴۰۴ مرداد», English «Mordad 1404»), and a non-default calendar drags
   * an era along with it («1404 AP», «١٤٠٤ ه‍.ش»). An axis label has to be the
   * same shape in all three languages and has no room for an era.
   */ const formatClinicMonth = (value, { withYear: withYear = false } = {})=>{
        const date = $c53f9539af19d960$var$toDate(value);
        if (!date) return $c53f9539af19d960$var$EMPTY;
        const options = {
            month: 'long',
            ...withYear ? {
                year: 'numeric'
            } : {}
        };
        let parts = $c53f9539af19d960$var$intl(Intl.DateTimeFormat, 'dt', clinicTag, {
            timeZone: timeZone,
            ...options
        }).formatToParts(date);
        parts = $c53f9539af19d960$var$dropEra(parts);
        // A locale whose clinic surfaces are on a calendar of their own names those
        // months from `clinicMonthNames` (French: «Mordad», not ICU's «mordâd»);
        // its own `monthNames` belong to the other calendar. Counted on the clinic
        // calendar, which for `fa`/`ar` is the locale's own.
        const names = clinicCalendarIntl ? clinicMonthList : monthNames;
        if (names && parts.some($c53f9539af19d960$var$isNamedMonth)) parts = $c53f9539af19d960$var$withMonthNames(parts, names, monthNumber(date, clinicTag));
        const month = parts.find((part)=>part.type === 'month')?.value ?? '';
        const year = parts.find((part)=>part.type === 'year')?.value ?? '';
        return withYear && year ? `${month} ${year}` : month;
    };
    /**
   * The twelve JALALI month names, index 0 = فروردین, in the reader's language.
   *
   * For a Jalali date PICKER — a month dropdown beside a year and a day. The
   * picker is Jalali in every language (`@parsina/framework`'s is Jalali-only,
   * and a clinic's day sheet, accounting period and shift report are all Jalali
   * whatever the panel is set to), so its month list is the clinic's calendar
   * rendered in the reader's words: «مرداد» / «Mordad», never «August».
   *
   * This replaced a hardcoded `J_MONTHS` array that every picker imported, and
   * which therefore showed Persian month names inside an otherwise-English
   * form. Built from a real date in each month rather than from a table so it
   * follows the same ICU data — and the same `monthNames` override — as every
   * other date on the screen.
   */ //
    // A brand on the Gregorian calendar keeps Gregorian books, so there these are
    // the Gregorian months, index 0 = January (`formatClinicMonth` already reads the
    // Gregorian calendar through the descriptor's `calendars.gregory`).
    const clinicMonthNames = ()=>((0, $eLeza.calendarSystem)('jalali') === 'gregory' ? $c53f9539af19d960$var$GREGORIAN_MONTH_ANCHORS : $c53f9539af19d960$var$MONTH_ANCHORS).map((ms)=>formatClinicMonth(ms));
    /**
   * The seven weekday names, index 0 = SATURDAY, in the reader's language.
   *
   * Saturday-first because that is the Iranian week: a clinic's working-days
   * selector, its weekly rota and its shift board all start on شنبه, and reordering
   * them for an English reader would move every doctor's Tuesday.
   *
   * `width` is passed through to `formatWeekday`, where 'short' is a trap: it
   * is NOT short in Persian — «یکشنبه» is the full word — and only English
   * abbreviates. A one-letter chip needs 'narrow'.
   *
   * This replaced hardcoded `['شنبه', 'یکشنبه', …]` arrays copied into four
   * screens, which rendered Persian weekdays in the English UI.
   */ const weekdayNames = (width = 'long')=>$c53f9539af19d960$var$WEEKDAY_ANCHORS.map((ms)=>formatWeekday(ms, width));
    /**
   * A date in one of the named shapes above.
   *
   * `full` is composed rather than delegated to `dateStyle: 'full'`. Node's
   * bundled ICU emits the Persian full pattern as year–month–day–weekday
   * («۱۴۰۴ مرداد ۱۲، یکشنبه»), which is both wrong for Persian and the reverse
   * of what the same ICU gives for `long`. Browsers disagree with it and with
   * each other. Composing weekday + long date makes the one date shape a
   * doctor reads at the top of a day sheet identical everywhere, which matters
   * more here than deferring to CLDR.
   */ const formatDate = (value, style = 'medium')=>{
        const date = $c53f9539af19d960$var$toDate(value);
        if (!date) return $c53f9539af19d960$var$EMPTY;
        // `full` and `weekdayDayMonth` are the two composed shapes.
        if (style === 'full' || style === 'weekdayDayMonth') {
            const weekday = dateTime({
                weekday: 'long'
            }).format(date);
            const rest = renderDate(date, style === 'full' ? 'long' : 'dayMonth');
            return `${weekday}${weekdaySeparator}${rest}`;
        }
        return renderDate(date, style);
    };
    /**
   * Clock time, 24-hour in every locale. Iranian clinical scheduling is written
   * and spoken in 24-hour time, and an English UI for an Iranian clinic that
   * suddenly says "2:30 PM" while the printed day sheet says 14:30 is a
   * transcription error waiting to happen.
   */ const formatTime = (value)=>{
        const date = $c53f9539af19d960$var$toDate(value);
        if (!date) return $c53f9539af19d960$var$EMPTY;
        return dateTime({
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        }).format(date);
    };
    const formatDateTime = (value, style = 'medium')=>{
        const date = $c53f9539af19d960$var$toDate(value);
        if (!date) return $c53f9539af19d960$var$EMPTY;
        return `${formatDate(date, style)} ${formatTime(date)}`;
    };
    /**
   * Weekday name. The three widths are NOT what the names suggest in Persian,
   * so pick by looking at the output rather than by analogy with English:
   *
   *   long    یکشنبه   Sunday   الأحد
   *   short   یکشنبه   Sun      الأحد     ← Persian/Arabic `short` is the FULL word
   *   narrow  ی        S        ح
   *
   * A one-letter chip — the reception week strip — needs `narrow`; anything that
   * reads as a word needs `long`. `short` only differs from `long` in English.
   */ const formatWeekday = (value, width = 'long')=>{
        const date = $c53f9539af19d960$var$toDate(value);
        if (!date) return $c53f9539af19d960$var$EMPTY;
        return dateTime({
            weekday: width
        }).format(date);
    };
    /**
   * A plain count — NOT money, so no toman conversion. Persian digits in `fa`,
   * Latin in `en`, grouped in both.
   */ const formatNumber = (value, options)=>{
        if (value == null || value === '' || !Number.isFinite(Number(value))) return $c53f9539af19d960$var$EMPTY;
        return number(options).format(Number(value));
    };
    const formatPercent = (value, options)=>{
        if (value == null || !Number.isFinite(Number(value))) return $c53f9539af19d960$var$EMPTY;
        return number({
            style: 'percent',
            maximumFractionDigits: 0,
            ...options
        }).format(Number(value) / 100);
    };
    /**
   * Clinic money: MINOR UNITS of `currency` in → the figure a human reads out.
   *
   * No currency — or '' or 'IRR' — is the contract this always had: WHOLE RIALS
   * in, a toman figure out, and `withUnit` appends the caller's `unitLabel` (the
   * app's own «تومان»/«Toman» catalogue word), or nothing when there is none.
   *
   * Any other currency is divided by its own divisor and shown with its own
   * fraction digits (USD 2, KWD 3) in this locale's digits. With `withUnit` its
   * unit is the currency table's word — `unitStyle` 'long' («US dollar»,
   * default) or 'short' («USD») — and a caller's `unitLabel` is IGNORED: at every
   * call site written before currencies existed it is a toman word, and a
   * non-IRR figure must never read «تومان».
   *
   * A code outside the table (a server ahead of this build) is NOT guessed at and
   * NOT folded to IRR: it renders its RAW integer minor units, ungrouped, and — with
   * `withUnit` — its code: «12345 XYZ» (lib/currency.js). The framework's copy of
   * this function throws there instead; a reception desk must not go blank.
   *
   * Otherwise the same function as @parsina/framework's clinical `formatMoney`
   * (v0.21.0); this app keeps its own copy of the formatters.
   */ const formatMoney = (amountMinor, { currency: currency, withUnit: withUnit = false, unitLabel: unitLabel = '', unitStyle: unitStyle = 'long' } = {})=>{
        const info = (0, $1O6TO.currencyInfo)(currency);
        if (info.code !== (0, $lHVFz.DEFAULT_CURRENCY)) {
            const value = (0, $1O6TO.toDisplay)(amountMinor, info.code);
            if (value == null) return $c53f9539af19d960$var$EMPTY;
            const text = number(info.unknown ? {
                useGrouping: false,
                maximumFractionDigits: 0
            } : {
                minimumFractionDigits: info.minDisplayDecimals,
                maximumFractionDigits: info.maxDisplayDecimals
            }).format(value);
            return withUnit ? `${text} ${(0, $1O6TO.unitLabel)(info.code, localeId, unitStyle)}` : text;
        }
        if (amountMinor == null || amountMinor === '' || !Number.isFinite(Number(amountMinor))) return $c53f9539af19d960$var$EMPTY;
        const toman = Number(amountMinor) / 10; // IRR: whole rials → toman
        // Prices are entered in toman so sub-toman precision cannot exist, but a
        // percentage discount can land on a half-toman: show it rather than
        // silently rounding money away.
        const text = number({
            maximumFractionDigits: 1
        }).format(toman);
        return withUnit && unitLabel ? `${text} ${unitLabel}` : text;
    };
    /**
   * «۳ روز پیش» / «3 days ago». Picks the largest unit that fits, so a two-hour
   * gap reads in hours and a two-month gap in months.
   */ const formatRelativeTime = (value, now = Date.now())=>{
        const date = $c53f9539af19d960$var$toDate(value);
        if (!date) return $c53f9539af19d960$var$EMPTY;
        const rtf = $c53f9539af19d960$var$intl(Intl.RelativeTimeFormat, 'rt', tag, {
            numeric: 'auto'
        });
        const deltaSeconds = (date.getTime() - now) / 1000;
        const units = [
            [
                'year',
                31536000
            ],
            [
                'month',
                2592000
            ],
            [
                'week',
                604800
            ],
            [
                'day',
                86400
            ],
            [
                'hour',
                3600
            ],
            [
                'minute',
                60
            ]
        ];
        for (const [unit, seconds] of units){
            if (Math.abs(deltaSeconds) >= seconds) return rtf.format(Math.round(deltaSeconds / seconds), unit);
        }
        return rtf.format(Math.round(deltaSeconds), 'second');
    };
    /** «الف، ب و ج» / «a, b, and c» — grammatically correct list joining. */ const formatList = (items, type = 'conjunction')=>{
        const list = (items || []).filter((item)=>item != null && item !== '').map(String);
        if (!list.length) return '';
        if (typeof Intl.ListFormat !== 'function') return list.join(', ');
        return $c53f9539af19d960$var$intl(Intl.ListFormat, 'lf', tag, {
            style: 'long',
            type: type
        }).format(list);
    };
    /**
   * Digits only, in the locale's numbering system, with NO grouping — for
   * things that are digit strings rather than quantities: a national id, a
   * medical-council code, a file number. Grouping one of those would read as a
   * different identifier.
   */ // '0'…'9' in this locale's numbering system, resolved once.
    const digitMap = Array.from({
        length: 10
    }, (_, d)=>number({
            useGrouping: false
        }).format(d));
    const formatDigits = (value)=>{
        if (value == null || value === '') return '';
        return String(value).replace(/\d/g, (d)=>digitMap[Number(d)]);
    };
    return {
        timeZone: timeZone,
        formatDate: formatDate,
        formatTime: formatTime,
        formatDateTime: formatDateTime,
        formatWeekday: formatWeekday,
        formatClinicMonth: formatClinicMonth,
        clinicMonthNames: clinicMonthNames,
        weekdayNames: weekdayNames,
        formatNumber: formatNumber,
        formatPercent: formatPercent,
        formatMoney: formatMoney,
        formatRelativeTime: formatRelativeTime,
        formatList: formatList,
        formatDigits: formatDigits
    };
}
/**
 * Phone numbers, emails and URLs are never localised — they are LTR digit/ASCII
 * runs that must read left-to-right even inside an RTL paragraph. Spread this
 * onto the element that holds one; it is the direction equivalent of not
 * translating a proper noun.
 *
 *   <span {...LTR_TEXT}>{doctor.phone}</span>
 *
 * `unicode-bidi: isolate` is what stops a trailing «:» or a following Persian
 * word from being dragged to the wrong end of the number.
 */ /**
 * Any shipped locale's digits IN, ASCII out.
 *
 * The inverse of `formatDigits`, and a PARSER rather than a renderer: a
 * national id, a phone or a file number typed on a Persian or an Arabic
 * keyboard has to reach the server as ASCII whatever the panel is set to. It
 * deliberately does not follow the active locale — someone reading the panel in
 * English may still be typing on a Persian keyboard.
 *
 * Built from the REGISTRY, not from a hand-written list of digit ranges, so a
 * fourth language stays a data change: `Intl.NumberFormat` is asked for each
 * locale's 0–9 and the mapping is inverted. Enumerating ranges by hand is how
 * this came to fold Persian «۰۱۲» and not Arabic-Indic «٠١٢» — two different
 * blocks that look alike at a glance, and the exact trap the doctor app hit
 * when it added Arabic.
 */ const $c53f9539af19d960$var$ASCII_BY_DIGIT = (()=>{
    const map = new Map();
    for (const descriptor of Object.values((0, $cMRsf.LOCALES))){
        let format;
        try {
            format = new Intl.NumberFormat(descriptor.intl, {
                useGrouping: false
            });
        } catch  {
            continue; // an unsupported tag must not break input
        }
        for(let value = 0; value <= 9; value += 1)map.set(format.format(value), String(value));
    }
    return map;
})();
function $c53f9539af19d960$export$e53ee9755c8a3679(value) {
    if (value == null || value === '') return '';
    return String(value).replace(/./gu, (ch)=>$c53f9539af19d960$var$ASCII_BY_DIGIT.get(ch) ?? ch);
}
const $c53f9539af19d960$export$3433559efc22d110 = {
    dir: 'ltr',
    style: {
        unicodeBidi: 'isolate'
    }
};
const $c53f9539af19d960$export$ddb338179359cccc = {
    transform: 'scaleX(var(--dir-flip, 1))'
};

});
parcelRegister("1O6TO", function(module, exports) {

$parcel$export(module.exports, "isUnknownCurrency", () => $150fd000128f1a1b$export$a5690f326f81368d);
$parcel$export(module.exports, "reportUnknownCurrency", () => $150fd000128f1a1b$export$c53d24351025309c);
$parcel$export(module.exports, "currencyInfo", () => $150fd000128f1a1b$export$272b829bb65f9e96);
$parcel$export(module.exports, "toDisplay", () => $150fd000128f1a1b$export$57a9131fd362a631);
$parcel$export(module.exports, "fromDisplay", () => $150fd000128f1a1b$export$22f3da351f420435);
$parcel$export(module.exports, "parseAmount", () => $150fd000128f1a1b$export$b94f7550e5b92f9c);
$parcel$export(module.exports, "unitLabel", () => $150fd000128f1a1b$export$846d8329e0c3da65);
$parcel$export(module.exports, "DEFAULT_CURRENCY", () => (parcelRequire("lHVFz")).DEFAULT_CURRENCY);
$parcel$export(module.exports, "CURRENCY_CODES", () => (parcelRequire("lHVFz")).CURRENCY_CODES);
// ─────────────────────────────────────────────────────────────────────────────
// The currency table, as this app reads it — the framework's
// (`@parsina/framework/ui/lib/currency`, docs/clinic-currency/CONTRACTS.md §1),
// plus one thing the framework rightly refuses to decide for an app: what a screen
// does with a code that is NOT in the table.
//
// The framework throws for such a code, everywhere. That is right for a library
// and wrong for a reception desk: the BFF passes an unknown code on unchanged
// (a server can learn a currency before this build does), and a throw in a
// formatter blanks the panel. Folding it to IRR is FORBIDDEN (CONTRACTS §0): it
// would print a tenth of an unknown amount under «تومان».
//
// So an unknown code is KEPT and read as exactly what is known about it — an
// integer number of its minor units and its code:
//
//   • display divisor 1, no decimals: a figure is its RAW minor units, «12345 XYZ»;
//   • its unit word is the code itself, never «تومان»;
//   • parsing what a human typed is refused (NaN) — there is no scale to parse
//     against — and every money field of such a clinic is disabled with a note that
//     the app must be updated (components/common/MoneyInput.jsx);
//   • `fromDisplay` is the identity, so a figure pre-filled from the wire goes back
//     unchanged rather than rescaled;
//   • the first sight of each such code is reported once with console.error.
//
// Every app module reads the table through here, never the framework directly, so
// no call site can reach the throw.
// ─────────────────────────────────────────────────────────────────────────────

var $lHVFz = parcelRequire("lHVFz");
const $150fd000128f1a1b$export$a5690f326f81368d = (code)=>code != null && code !== '' && !(0, $lHVFz.isClinicCurrency)(code);
const $150fd000128f1a1b$var$reported = new Set();
function $150fd000128f1a1b$export$c53d24351025309c(code) {
    const key = String(code);
    if ($150fd000128f1a1b$var$reported.has(key)) return;
    $150fd000128f1a1b$var$reported.add(key);
    console.error(`[currency] ${JSON.stringify(key)} is not a currency this version of the app knows: ` + 'its amounts are shown as raw minor units with the code, and money entry is disabled, ' + 'until the app is updated.');
}
function $150fd000128f1a1b$var$unknownInfo(code) {
    $150fd000128f1a1b$export$c53d24351025309c(code);
    const label = {
        long: String(code),
        short: String(code)
    };
    return {
        code: String(code),
        exponent: 0,
        displayDivisor: 1,
        minDisplayDecimals: 0,
        maxDisplayDecimals: 0,
        unknown: true,
        labels: {
            fa: label,
            en: label,
            ar: label,
            fr: label,
            de: label
        }
    };
}
function $150fd000128f1a1b$export$272b829bb65f9e96(code) {
    return $150fd000128f1a1b$export$a5690f326f81368d(code) ? $150fd000128f1a1b$var$unknownInfo(code) : (0, $lHVFz.currencyInfo)(code);
}
function $150fd000128f1a1b$export$57a9131fd362a631(amountMinor, code) {
    if (!$150fd000128f1a1b$export$a5690f326f81368d(code)) return (0, $lHVFz.toDisplay)(amountMinor, code);
    $150fd000128f1a1b$export$c53d24351025309c(code);
    if (amountMinor == null || amountMinor === '' || !Number.isFinite(Number(amountMinor))) return null;
    return Number(amountMinor);
}
function $150fd000128f1a1b$export$22f3da351f420435(displayValue, code) {
    if (!$150fd000128f1a1b$export$a5690f326f81368d(code)) return (0, $lHVFz.fromDisplay)(displayValue, code);
    $150fd000128f1a1b$export$c53d24351025309c(code);
    // i18n-exempt: a PARSER's grouping marks (Latin «,» and Persian «٬»), stripped, never rendered.
    const n = Number(String(displayValue ?? '').replace(/[,٬\s]/g, ''));
    return Number.isFinite(n) ? Math.round(n) : NaN;
}
function $150fd000128f1a1b$export$b94f7550e5b92f9c(input, code) {
    if (!$150fd000128f1a1b$export$a5690f326f81368d(code)) return (0, $lHVFz.parseAmount)(input, code);
    $150fd000128f1a1b$export$c53d24351025309c(code);
    return NaN;
}
function $150fd000128f1a1b$export$846d8329e0c3da65(code, locale, style) {
    if (!$150fd000128f1a1b$export$a5690f326f81368d(code)) return (0, $lHVFz.unitLabel)(code, locale, style);
    $150fd000128f1a1b$export$c53d24351025309c(code);
    return String(code);
}

});


parcelRegister("k7W79", function(module, exports) {

$parcel$export(module.exports, "clinicCurrencyOf", () => $ea718a676a07f861$export$f068c00208eaf8c6);
$parcel$export(module.exports, "bindMoney", () => $ea718a676a07f861$export$b36e0dc525096a4f);
$parcel$export(module.exports, "DEFAULT_CURRENCY", () => (parcelRequire("lHVFz")).DEFAULT_CURRENCY);
// ─────────────────────────────────────────────────────────────────────────────
// Clinic money, bound to a currency.
//
// A clinic keeps its books in ONE currency (docs/clinic-currency/CONTRACTS.md):
// IRR for every clinic that existed before the choice did, and whatever an owner
// picked for a clinic created since. Every amount on the wire is an integer
// number of MINOR UNITS of its document's currency — whole rials for IRR.
//
// `bindMoney` takes the plain i18n value (`t`, `formatMoney`, …) and returns the
// money half of it bound to one currency, so a screen never has to ask which
// currency it is in:
//
//   const { formatMoney, moneyUnit, t } = useTranslation();
//   formatMoney(invoice.totalRial)                          // the clinic's currency
//   formatMoney(invoice.totalRial, { currency: invoice.currency })  // the document's
//   moneyUnit()            // «تومان» / «US dollar»
//   moneyUnit('short')     // «ت» / «USD»
//   t('cashier.deposit.amount')  // «مبلغ ({{unit}})» → «مبلغ (تومان)» / «مبلغ (US dollar)»
//   t(key, { amount, ...moneyUnits(doc.currency) })  // a document's own unit words
//
// The rules it keeps:
//
//   • IRR is byte-identical to before currencies existed. Its unit word comes from
//     the app's OWN catalogue (`common.units.toman` / `tomanShort`), never from the
//     currency table, so English still says «Toman» and «T».
//   • A blank `currency` option means THE BOUND currency (the clinic's), not IRR:
//     a document whose query did not select `currency` is, in practice, in the
//     clinic's currency — a clinic cannot change currency once money exists. The
//     BFF already turned a blank wire currency into 'IRR' before it got here.
//   • No conversion anywhere. Two currencies are never added or compared.
//   • Platform money — the subscription, پارسه, SMS/WhatsApp prices — is not
//     clinic money: it keeps its literal toman words and never passes through here.
// ─────────────────────────────────────────────────────────────────────────────
parcelRequire("1O6TO");
var $lHVFz = parcelRequire("lHVFz");
var $1O6TO = parcelRequire("1O6TO");

var $7rPjk = parcelRequire("7rPjk");
function $ea718a676a07f861$export$f068c00208eaf8c6(code) {
    if (code == null || code === '') return 0, $lHVFz.DEFAULT_CURRENCY;
    if ((0, $1O6TO.isUnknownCurrency)(code)) (0, $1O6TO.reportUnknownCurrency)(code);
    return code;
}
/**
 * `vars` with each default added only where the caller did not name it — a
 * caller's own value always wins, even an explicit null.
 */ function $ea718a676a07f861$var$withDefaults(vars, defaults) {
    if (vars == null) return {
        ...defaults
    };
    let out = null;
    for (const key of Object.keys(defaults))if (!Object.prototype.hasOwnProperty.call(vars, key)) {
        if (!out) out = {
            ...vars
        };
        out[key] = defaults[key];
    }
    return out || vars;
}
function $ea718a676a07f861$export$b36e0dc525096a4f(base, currency = (0, $lHVFz.DEFAULT_CURRENCY)) {
    // Never normalised into a throw: an unknown code is kept, and every helper
    // below reads it through lib/currency.js as raw minor units and its code.
    const bound = currency == null || currency === '' ? (0, $lHVFz.DEFAULT_CURRENCY) : currency;
    const resolve = (code)=>code == null || code === '' ? bound : code;
    /**
   * The unit word beside a figure: `moneyUnit()` long, `moneyUnit('short')`,
   * `moneyUnit('short', doc.currency)` for a document in its own currency.
   * `'inline'` is the long word as English writes it mid-sentence («toman»);
   * every other currency's long word is already that. `'field'` is the chip on a
   * MoneyInput: the long catalogue word for IRR, as every such chip has always
   * read, and the ISO code otherwise — what the kit's own chip shows for them.
   */ const moneyUnit = (style = 'long', code)=>{
        const c = resolve(code);
        if (c === (0, $lHVFz.DEFAULT_CURRENCY)) return base.t((0, $7rPjk.MONEY_UNIT_KEYS)[style] || (0, $7rPjk.MONEY_UNIT_KEYS).long);
        return (0, $1O6TO.unitLabel)(c, base.locale, style === 'short' || style === 'field' ? 'short' : 'long');
    };
    /** The `t` defaults for a document in `code` — `t(key, { ...unitsOf(doc.currency) })`. */ const unitsOf = (code)=>({
            unit: moneyUnit('long', code),
            unitInline: moneyUnit('inline', code),
            unitShort: moneyUnit('short', code)
        });
    const unitDefaults = unitsOf();
    const t = (key, vars)=>base.t(key, $ea718a676a07f861$var$withDefaults(vars, unitDefaults));
    const tList = (key, vars)=>base.tList(key, $ea718a676a07f861$var$withDefaults(vars, unitDefaults));
    /** Minor units → the figure; `{ currency }` for a document in its own. */ const formatMoney = (amountMinor, options = {})=>base.formatMoney(amountMinor, {
            ...options,
            currency: resolve(options?.currency)
        });
    /**
   * «۵۰۰٬۰۰۰ ت» / «12.50 USD» — a figure and its short unit, through the one
   * catalogue string that has always joined them (`common.money.tomanAmount`,
   * whose name predates currencies).
   */ const moneyAmount = (amountMinor, { currency: code } = {})=>base.t('common.money.tomanAmount', {
            amount: formatMoney(amountMinor, {
                currency: code
            }),
            unitShort: moneyUnit('short', code)
        });
    return {
        currency: bound,
        t: t,
        tList: tList,
        formatMoney: formatMoney,
        moneyUnit: moneyUnit,
        moneyUnits: unitsOf,
        moneyAmount: moneyAmount,
        /** Minor units → display units (IRR: rials → toman); null when blank. */ toDisplayAmount: (amountMinor, code)=>(0, $1O6TO.toDisplay)(amountMinor, resolve(code)),
        /** A display figure or a MoneyInput's bare string → minor units (blank → 0). */ fromDisplayAmount: (displayValue, code)=>(0, $1O6TO.fromDisplay)(displayValue, resolve(code)),
        /** What a human typed → minor units, NaN when it is not an amount (blank too). */ parseMoney: (text, code)=>(0, $1O6TO.parseAmount)(text, resolve(code))
    };
}

});


parcelRegister("e1LEq", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3661f2c9a55da7f$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $eLeza = parcelRequire("eLeza");

var $kJBdz = parcelRequire("kJBdz");

var $cMRsf = parcelRequire("cMRsf");

var $gVWNP = parcelRequire("gVWNP");

var $7rPjk = parcelRequire("7rPjk");

var $k7W79 = parcelRequire("k7W79");
var $lHVFz = parcelRequire("lHVFz");
// ─────────────────────────────────────────────────────────────────────────────
// The only way a component reads a string.
//
//   const { t, formatDate, isRTL } = useTranslation();
//   <button>{t('common.actions.save')}</button>
//
// Keys are always fully qualified — the first segment names the file the string
// lives in (see translator.js). There is no scoped/`useTranslation('visit')`
// form on purpose: one rule means a key you see in a screen is a key you can
// grep for, and a string cannot be reached by two different names.
// ─────────────────────────────────────────────────────────────────────────────
// Rendered outside a provider — a component under test, or an error boundary
// that caught the provider itself. It reports the product's default locale (the
// brand's, when it names one) and translates to the humanised key rather than
// throwing, because "no translations" must never be the reason a clinical
// screen fails to render. Rebuilt if the brand changes after the first build.
let $a3661f2c9a55da7f$var$orphan = null;
let $a3661f2c9a55da7f$var$orphanRevision = -1;
function $a3661f2c9a55da7f$var$orphanValue() {
    if (!$a3661f2c9a55da7f$var$orphan || $a3661f2c9a55da7f$var$orphanRevision !== (0, $eLeza.brandRevision)()) {
        $a3661f2c9a55da7f$var$orphanRevision = (0, $eLeza.brandRevision)();
        const locale = (0, $cMRsf.productDefaultLocale)();
        const descriptor = (0, $cMRsf.localeDescriptor)(locale);
        const formatters = (0, $gVWNP.createFormatters)(locale);
        const { t: t, tList: tList, has: has } = (0, $7rPjk.createTranslator)({
            locale: locale,
            catalog: {},
            fallbackCatalog: {},
            joinList: formatters.formatList,
            formatNumber: formatters.formatNumber
        });
        // IRR, like the provider before a clinic is known: no clinic, no currency.
        const moneyBase = {
            t: t,
            tList: tList,
            formatMoney: formatters.formatMoney,
            locale: locale
        };
        $a3661f2c9a55da7f$var$orphan = {
            locale: locale,
            dir: descriptor.dir,
            isRTL: descriptor.dir === 'rtl',
            readsPersianData: descriptor.readsPersianData === true,
            locales: {},
            t: t,
            tList: tList,
            has: has,
            ...formatters,
            ...(0, $k7W79.bindMoney)(moneyBase, (0, $lHVFz.DEFAULT_CURRENCY)),
            moneyBase: moneyBase,
            setLocale: ()=>{},
            preloadLocale: ()=>{},
            ready: false
        };
    }
    return $a3661f2c9a55da7f$var$orphan;
}
function $a3661f2c9a55da7f$export$9fc83ad70ead8663() {
    return (0, $acw62.useContext)((0, $kJBdz.I18nContext)) ?? $a3661f2c9a55da7f$var$orphanValue();
}
var $a3661f2c9a55da7f$export$2e2bcd8739ae039 = $a3661f2c9a55da7f$export$9fc83ad70ead8663;

});

parcelRegister("aBaxB", function(module, exports) {

$parcel$export(module.exports, "useMoneyOf", () => $1825bb2b59c038ea$export$fb2a059c74893d97);
$parcel$export(module.exports, "inDocumentCurrency", () => $1825bb2b59c038ea$export$4b967ffcbba19bc3);
$parcel$export(module.exports, "default", () => $1825bb2b59c038ea$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $kJBdz = parcelRequire("kJBdz");

var $e1LEq = parcelRequire("e1LEq");

var $k7W79 = parcelRequire("k7W79");

var $gVWNP = parcelRequire("gVWNP");
// The formatters that depend on the clock — re-built for a clinic's zone.
const $1825bb2b59c038ea$var$DATE_FORMATTERS = [
    'timeZone',
    'formatDate',
    'formatTime',
    'formatDateTime',
    'formatWeekday',
    'formatClinicMonth',
    'clinicMonthNames',
    'weekdayNames'
];
function $1825bb2b59c038ea$var$dateFormattersFor(locale, timeZone) {
    const all = (0, $gVWNP.createFormatters)(locale, {
        timeZone: timeZone
    });
    return Object.fromEntries($1825bb2b59c038ea$var$DATE_FORMATTERS.map((k)=>[
            k,
            all[k]
        ]));
}
function $1825bb2b59c038ea$export$b0b7cc13e21e7a2b({ currency: currency, timeZone: timeZone, children: children }) {
    // Outside an <I18nProvider> (a component test) this is the orphan value, which
    // carries the same `moneyBase`; the re-bind still works.
    const parent = (0, $e1LEq.default)();
    const code = currency || parent.currency;
    const zone = timeZone || parent.timeZone;
    const value = (0, $acw62.useMemo)(()=>{
        if (code === parent.currency && zone === parent.timeZone) return parent;
        return {
            ...parent,
            ...zone !== parent.timeZone ? $1825bb2b59c038ea$var$dateFormattersFor(parent.locale, zone) : {},
            ...code !== parent.currency ? (0, $k7W79.bindMoney)(parent.moneyBase, code) : {}
        };
    }, [
        parent,
        code,
        zone
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kJBdz.I18nContext).Provider, {
        value: value,
        children: children
    });
}
function $1825bb2b59c038ea$export$fb2a059c74893d97(currency) {
    const ctx = (0, $e1LEq.default)();
    return (0, $acw62.useMemo)(()=>!currency || currency === ctx.currency ? ctx : {
            ...ctx,
            ...(0, $k7W79.bindMoney)(ctx.moneyBase, currency)
        }, [
        ctx,
        currency
    ]);
}
function $1825bb2b59c038ea$export$4b967ffcbba19bc3(Component, documentOf) {
    function InDocumentCurrency(props) {
        return /*#__PURE__*/ (0, $ayMG0.jsx)($1825bb2b59c038ea$export$b0b7cc13e21e7a2b, {
            currency: documentOf(props)?.currency,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
                ...props
            })
        });
    }
    InDocumentCurrency.displayName = `InDocumentCurrency(${Component.displayName || Component.name || 'Component'})`;
    return InDocumentCurrency;
}
var $1825bb2b59c038ea$export$2e2bcd8739ae039 = $1825bb2b59c038ea$export$b0b7cc13e21e7a2b;

});



parcelRegister("goZUH", function(module, exports) {

$parcel$export(module.exports, "useMyProfile", () => $bf0ee9fdb770e642$export$554f457658cf7273);

var $acw62 = parcelRequire("acw62");

var $2Mst8 = parcelRequire("2Mst8");
/**
 * The signed-in clinic user's own account, as held in Keycloak.
 *
 * The clinic BFF has no doctor profile (`me`/`updateDoctorProfile` are the doctor
 * BFF's — see src/graphql/typeDefs/profile.js in parsina.bff.clinic). This hook
 * only covers what genuinely exists server-side: the profile picture and the UI
 * language.
 *
 * `language` is the RECORD for which language the panel runs in — Keycloak's own
 * `locale` attribute on the user, so the sign-in page follows it too. The
 * localStorage copy I18nProvider keeps is only a cache; see src/i18n/config.js.
 */ const $bf0ee9fdb770e642$var$PROFILE_FIELDS = 'id name email avatar language';
const $bf0ee9fdb770e642$var$MY_PROFILE_QUERY = `
  query {
    myProfile { ${$bf0ee9fdb770e642$var$PROFILE_FIELDS} }
  }
`;
// `image` is a JPEG/PNG data URI, or null to remove the current picture.
const $bf0ee9fdb770e642$var$UPDATE_MY_AVATAR = `
  mutation($image: String) {
    updateMyAvatar(image: $image) { ${$bf0ee9fdb770e642$var$PROFILE_FIELDS} }
  }
`;
// A BCP-47 tag the client ships a catalogue for. The BFF rejects anything else
// rather than storing it, because this writes the attribute the sign-in page
// reads as well.
const $bf0ee9fdb770e642$var$UPDATE_MY_PREFERENCES = `
  mutation($language: String) {
    updateMyPreferences(language: $language) { ${$bf0ee9fdb770e642$var$PROFILE_FIELDS} }
  }
`;
function $bf0ee9fdb770e642$export$554f457658cf7273() {
    const [profile, setProfile] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [saving, setSaving] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    const fetchProfile = (0, $acw62.useCallback)(async ()=>{
        const res = await (0, $2Mst8.bffQuery)($bf0ee9fdb770e642$var$MY_PROFILE_QUERY);
        setProfile(res?.myProfile ?? null);
        setError(null);
    }, []);
    (0, $acw62.useEffect)(()=>{
        let active = true;
        (0, $2Mst8.bffQuery)($bf0ee9fdb770e642$var$MY_PROFILE_QUERY).then((res)=>{
            if (active) {
                setProfile(res?.myProfile ?? null);
                setError(null);
            }
        }).catch((err)=>{
            if (active) setError(err);
        }).finally(()=>{
            if (active) setLoading(false);
        });
        return ()=>{
            active = false;
        };
    }, []);
    // Upload (data URI) or remove (null) the picture. The server response already
    // carries the authoritative URL, so patch state rather than refetching.
    const updateAvatar = (0, $acw62.useCallback)((image)=>{
        setSaving(true);
        return (0, $2Mst8.bffMutation)($bf0ee9fdb770e642$var$UPDATE_MY_AVATAR, {
            image: image ?? null
        }).then((res)=>{
            const next = res?.updateMyAvatar ?? null;
            if (next) setProfile(next);
            return next?.avatar ?? null;
        }).finally(()=>setSaving(false));
    }, []);
    /**
   * Persist the UI language. The caller has already repainted — I18nProvider's
   * `setLocale` is local and instant — so this only makes the choice durable,
   * and it deliberately does NOT swallow its error: the picker rolls back to
   * the previous language when this rejects, because a language that will be
   * gone at the next sign-in must not look like it was saved.
   */ const updateLanguage = (0, $acw62.useCallback)((language)=>{
        setSaving(true);
        return (0, $2Mst8.bffMutation)($bf0ee9fdb770e642$var$UPDATE_MY_PREFERENCES, {
            language: language ?? null
        }).then((res)=>{
            const next = res?.updateMyPreferences ?? null;
            if (next) setProfile(next);
            return next?.language ?? null;
        }).finally(()=>setSaving(false));
    }, []);
    return {
        profile: profile,
        loading: loading,
        saving: saving,
        error: error,
        updateAvatar: updateAvatar,
        updateLanguage: updateLanguage,
        refetch: fetchProfile
    };
}

});
parcelRegister("2Mst8", function(module, exports) {

$parcel$export(module.exports, "bffQuery", () => $206625c7d33bd390$export$7fb4864174f056c);
$parcel$export(module.exports, "bffMutation", () => $206625c7d33bd390$export$8395d0fc0d822a81);

var $58BYB = parcelRequire("58BYB");

var $iAkVL = parcelRequire("iAkVL");

var $jG8cU = parcelRequire("jG8cU");

var $1k2zw = parcelRequire("1k2zw");
function $206625c7d33bd390$var$currentLocale() {
    return typeof document !== 'undefined' && document.documentElement.getAttribute('lang') || 'fa';
}
async function $206625c7d33bd390$var$executeRequest(token, operationName, query, variables) {
    // The active clinic travels on EVERY request, derived from the `/c/:ref/…` route
    // (docs/CLINIC_MULTI_CLINIC_UX_REV2.md §A1). A header rather than a GraphQL
    // argument because it applies uniformly and cannot be forgotten on one field —
    // and read at call time from the module signal rather than captured, so a switch
    // takes effect on the very next request without re-threading every hook.
    //
    // Empty before the context provider has resolved (the bootstrap query itself, and
    // the whole pre-membership flow). The BFF treats an absent header as "infer, as
    // you always did", so that case is exactly today's behaviour.
    const clinicRef = (0, $1k2zw.getActiveClinicRef)();
    return fetch((0, $iAkVL.BFF_URL), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            ...clinicRef ? {
                'x-active-clinic-id': clinicRef
            } : {},
            // The panel's language, so the BFF can answer in it: catalogue names, the
            // sentences it composes and its error messages. `<html lang>` is set by
            // `applyDocumentLocale` on every switch, so this is read per request.
            'x-parsina-locale': $206625c7d33bd390$var$currentLocale()
        },
        body: JSON.stringify({
            ...operationName ? {
                operationName: operationName
            } : {},
            query: query,
            variables: variables
        })
    });
}
/**
 * Raise the app-wide paywall dialog for an entitlement failure.
 *
 * The BFF answers a blocked write with `SUBSCRIPTION_REQUIRED` rather than
 * `FORBIDDEN` precisely so the client can offer a renew button instead of
 * telling a clinic owner they lack access to their own clinic — but nothing was
 * reading the distinction, so every blocked booking surfaced as a generic toast
 * with nowhere to go. Reported from here because the fetch layer is the only
 * place every mutation passes through.
 *
 * The error still throws: the calling screen keeps its own failure handling
 * (leave the form filled, re-enable the button). This only adds the explanation.
 */ function $206625c7d33bd390$var$notePaywall(err) {
    if (err?.extensions?.code !== 'SUBSCRIPTION_REQUIRED') return;
    (0, $jG8cU.reportPaywall)({
        ...err.extensions,
        message: err.message
    });
}
async function $206625c7d33bd390$var$bffRequest(query, variables = {}, operationName = '') {
    const token = await (0, $58BYB.getValidToken)();
    if (!token) {
        await (0, $58BYB.redirectToLogin)();
        throw new Error('Not authenticated');
    }
    let res = await $206625c7d33bd390$var$executeRequest(token, operationName, query, variables);
    // On 401, try to refresh once and retry — handles server-side expiry / clock skew
    if (res.status === 401) {
        const refreshed = await (0, $58BYB.refreshAccessToken)();
        if (!refreshed) {
            await (0, $58BYB.redirectToLogin)();
            throw new Error('Session expired');
        }
        const newToken = (0, $58BYB.getToken)();
        res = await $206625c7d33bd390$var$executeRequest(newToken, operationName, query, variables);
    }
    if (!res.ok) {
        // Read the body before giving up. Apollo sends a perfectly normal GraphQL error
        // payload alongside a non-2xx status, and throwing on the status alone dropped
        // `extensions` — which is the only thing callers can branch on. App.jsx's
        // `err.extensions?.code === 'UNAUTHENTICATED'` check could therefore never
        // match, so a rejected token surfaced as a generic failure and the app decided
        // the user simply had no clinic, showing the onboarding wizard to clinic owners
        // whose only problem was a stale token.
        const body = await res.json().catch(()=>null);
        const gqlError = body?.errors?.[0];
        const err = new Error(gqlError?.message || `BFF error: ${res.status}`);
        err.status = res.status;
        if (gqlError?.extensions) err.extensions = gqlError.extensions;
        $206625c7d33bd390$var$notePaywall(err);
        throw err;
    }
    const { data: data, errors: errors } = await res.json();
    // A single-field call (the common case) that errors still comes back with `data`
    // present but every field null — treat that the same as no data at all.
    const allFieldsNull = data && Object.values(data).every((v)=>v == null);
    if (errors?.length && (!data || allFieldsNull)) {
        const err = new Error(errors[0].message);
        err.extensions = errors[0].extensions;
        $206625c7d33bd390$var$notePaywall(err);
        throw err;
    }
    if (errors?.length) errors.forEach((e)=>console.warn('BFF partial error:', e.message));
    // A response that carried the caller's own access stamp is the cheapest possible
    // way to notice a role change mid-session: no polling, no websocket, no token
    // introspection. The provider compares it and offers «بازخوانی» when it moves.
    if (data?.myAccess?.version) (0, $1k2zw.reportAccessVersion)(data.myAccess.version);
    return data;
}
const $206625c7d33bd390$export$7fb4864174f056c = $206625c7d33bd390$var$bffRequest;
const $206625c7d33bd390$export$8395d0fc0d822a81 = $206625c7d33bd390$var$bffRequest;

});
parcelRegister("jG8cU", function(module, exports) {

$parcel$export(module.exports, "onPaywall", () => $e5384e55cc62a03c$export$4d57dfac51ca22f5);
$parcel$export(module.exports, "reportPaywall", () => $e5384e55cc62a03c$export$c97d652f2c92d82e);
$parcel$export(module.exports, "onPaywallReset", () => $e5384e55cc62a03c$export$5654269ca78fbcf5);
$parcel$export(module.exports, "resetPaywall", () => $e5384e55cc62a03c$export$c4e616534f399fe5);
/**
 * Paywall signal — how a `SUBSCRIPTION_REQUIRED` failure anywhere in the app
 * reaches the one dialog that can explain it.
 *
 * The clinic BFF answers a blocked write with TWO different error codes on
 * purpose (`entitlementMap.js`): `FORBIDDEN` means *this person* may not, and
 * `SUBSCRIPTION_REQUIRED` means *this clinic* may not right now. The second one
 * has a fix — renew — and until this module existed no client code branched on
 * it at all, so a receptionist blocked from booking got a generic red toast and
 * a dead end.
 *
 * Shaped exactly like the framework's `connectivitySignal`: a module-level
 * subscriber set, because the producer is the fetch layer (`bffClient`, not a
 * component) and the consumer is one dialog mounted in the shell. Threading a
 * React context between them would mean every call site that can fail had to be
 * inside a provider AND hold a hook — and `bffClient` is a plain module.
 *
 * The payload is the error's `extensions`, verbatim:
 *   { code, operation, clinicId, status, currentPeriodEnd, renewUrl }
 * The dialog reads `status`/`currentPeriodEnd` for its countdown and IGNORES
 * `renewUrl` — a server-supplied string must never drive client navigation.
 */ const $e5384e55cc62a03c$var$listeners = new Set();
function $e5384e55cc62a03c$export$4d57dfac51ca22f5(handler) {
    if (typeof handler !== 'function') return ()=>{};
    $e5384e55cc62a03c$var$listeners.add(handler);
    return ()=>$e5384e55cc62a03c$var$listeners.delete(handler);
}
function $e5384e55cc62a03c$export$c97d652f2c92d82e(extensions) {
    for (const handler of Array.from($e5384e55cc62a03c$var$listeners))try {
        handler(extensions || {});
    } catch (err) {
        console.error('paywall listener failed:', err);
    }
}
// ── Dismissal ────────────────────────────────────────────────────────────────
// A second, separate channel, because the dialog must be able to be CLOSED by
// something other than the person clicking it.
//
// The case that needs it is the clinic switch. This module is a singleton and the
// dialog's open-state lives in it, so an admin who hits the paywall at a lapsed
// clinic and then switches to a paid one carried the dialog across with them —
// an entitled clinic showing a renewal wall for a subscription that is not its
// own (design §A13/E11). The subscription itself is already clinic-scoped on the
// server (`entitlementCache` is keyed by clinic); only this client-side echo was
// not.
const $e5384e55cc62a03c$var$resetListeners = new Set();
function $e5384e55cc62a03c$export$5654269ca78fbcf5(handler) {
    if (typeof handler !== 'function') return ()=>{};
    $e5384e55cc62a03c$var$resetListeners.add(handler);
    return ()=>$e5384e55cc62a03c$var$resetListeners.delete(handler);
}
function $e5384e55cc62a03c$export$c4e616534f399fe5() {
    for (const handler of Array.from($e5384e55cc62a03c$var$resetListeners))try {
        handler();
    } catch (err) {
        console.error('paywall reset listener failed:', err);
    }
}
function $e5384e55cc62a03c$export$48ea9e1571f6e90b() {
    $e5384e55cc62a03c$var$listeners.clear();
    $e5384e55cc62a03c$var$resetListeners.clear();
}

});

parcelRegister("1k2zw", function(module, exports) {

$parcel$export(module.exports, "getActiveClinicRef", () => $0f69a76a5d137ac0$export$200608dd1953640d);
$parcel$export(module.exports, "setActiveClinicRef", () => $0f69a76a5d137ac0$export$51b984de748197f4);
$parcel$export(module.exports, "readLastClinic", () => $0f69a76a5d137ac0$export$298ebb48c3691393);
$parcel$export(module.exports, "rememberLastClinic", () => $0f69a76a5d137ac0$export$e27548a695f8a84a);
$parcel$export(module.exports, "reportAccessVersion", () => $0f69a76a5d137ac0$export$9c4b056c5699c635);
$parcel$export(module.exports, "resetAccessVersion", () => $0f69a76a5d137ac0$export$fe6ac48d09f86fd8);
$parcel$export(module.exports, "onAccessVersionChange", () => $0f69a76a5d137ac0$export$ae5e594a604de1bb);
$parcel$export(module.exports, "guardedSwitch", () => $0f69a76a5d137ac0$export$6930a33882c9002c);
/**
 * The active clinic, as the transport layer sees it — plus the access-change signal.
 *
 * Two module-level values, and both exist for the same reason `paywallSignal.js`
 * does: the fetch wrapper is not inside React, so it cannot read context, and
 * threading the clinic through every one of the ~40 hooks that call `bffQuery`
 * would mean every future hook could forget to.
 *
 * WHY A MODULE SINGLETON IS SAFE HERE, when §A1 spent a page arguing against
 * storing the tenant: this is not storage, it is a mirror. The AUTHORITY is the
 * `/c/:ref/…` route; `ClinicContextProvider` writes this on every route change and
 * nothing else may. Two tabs each have their own module instance, so they hold two
 * different clinics with no coordination — which is the whole point of putting the
 * tenant in the URL (v1's E3 needed a rule to achieve this; the route gets it free).
 *
 * `localStorage` appears exactly once, and only to answer "where should a bare `/`
 * go?" — a preference, never an authority.
 */ const $0f69a76a5d137ac0$var$LAST_CLINIC_KEY = 'clinic.lastId.v1';
// ── The active clinic ref (slug or id), mirrored from the route ──────────────
let $0f69a76a5d137ac0$var$activeRef = '';
function $0f69a76a5d137ac0$export$200608dd1953640d() {
    return $0f69a76a5d137ac0$var$activeRef;
}
function $0f69a76a5d137ac0$export$51b984de748197f4(ref) {
    $0f69a76a5d137ac0$var$activeRef = ref || '';
}
function $0f69a76a5d137ac0$export$298ebb48c3691393() {
    try {
        return window.localStorage.getItem($0f69a76a5d137ac0$var$LAST_CLINIC_KEY) || '';
    } catch  {
        // Private mode, blocked site data, or a browser that throws on access. A
        // person with no remembered clinic simply lands on their most recent one, so
        // there is nothing to recover from.
        return '';
    }
}
function $0f69a76a5d137ac0$export$e27548a695f8a84a(ref) {
    try {
        if (ref) window.localStorage.setItem($0f69a76a5d137ac0$var$LAST_CLINIC_KEY, ref);
    } catch  {}
}
/**
 * Deliberately NOT cleared when a clinic becomes unreachable.
 *
 * A stored ref that no longer resolves is ignored on the next boot (E1) at no
 * cost, whereas clearing it on a failed request would silently demote a returning
 * owner to "pick a clinic" after a single network blip (E2).
 */ // ── The access-change signal ─────────────────────────────────────────────────
let $0f69a76a5d137ac0$var$currentVersion = '';
const $0f69a76a5d137ac0$var$versionListeners = new Set();
function $0f69a76a5d137ac0$export$9c4b056c5699c635(version) {
    if (!version) return;
    if (!$0f69a76a5d137ac0$var$currentVersion) {
        $0f69a76a5d137ac0$var$currentVersion = version;
        return;
    }
    if (version === $0f69a76a5d137ac0$var$currentVersion) return;
    $0f69a76a5d137ac0$var$currentVersion = version;
    $0f69a76a5d137ac0$var$versionListeners.forEach((fn)=>{
        try {
            fn(version);
        } catch  {}
    });
}
function $0f69a76a5d137ac0$export$fe6ac48d09f86fd8(version = '') {
    $0f69a76a5d137ac0$var$currentVersion = version;
}
function $0f69a76a5d137ac0$export$ae5e594a604de1bb(fn) {
    $0f69a76a5d137ac0$var$versionListeners.add(fn);
    return ()=>$0f69a76a5d137ac0$var$versionListeners.delete(fn);
}
// ── The unsaved-work guard ───────────────────────────────────────────────────
//
// Switching clinics throws the whole routed tree away (that is what makes "no
// stale row survives a switch" structural rather than a checklist). Throwing away
// DATA is the point; throwing away someone's half-typed patient without asking is
// not, and the two are the same keystroke.
//
// So a screen with unsaved work registers a guard, and the switcher asks before it
// navigates. Deliberately the same shape as the doctor app's
// `window.__parsina_visit_guard`: one registration point, so a screen cannot half
// participate, and the switcher never has to know what kind of work is open.
//
// A guard that throws is IGNORED rather than allowed to block the switch — a
// broken confirm must not be able to trap someone in a clinic.
let $0f69a76a5d137ac0$var$switchGuard = null;
function $0f69a76a5d137ac0$export$4595987cdc11c877(guard) {
    $0f69a76a5d137ac0$var$switchGuard = typeof guard === 'function' ? guard : null;
    return ()=>{
        if ($0f69a76a5d137ac0$var$switchGuard === guard) $0f69a76a5d137ac0$var$switchGuard = null;
    };
}
function $0f69a76a5d137ac0$export$6930a33882c9002c(proceed) {
    if (!$0f69a76a5d137ac0$var$switchGuard) {
        proceed();
        return;
    }
    try {
        $0f69a76a5d137ac0$var$switchGuard(proceed);
    } catch (err) {
        // A guard that throws must not be able to trap someone in a clinic.
        console.error('[clinicSignal] switch guard failed, allowing the switch:', err);
        proceed();
    }
}
function $0f69a76a5d137ac0$export$b5293e54b08f13ae() {
    $0f69a76a5d137ac0$var$switchGuard = null;
}

});



parcelRegister("52bn2", function(module, exports) {

$parcel$export(module.exports, "C", () => (parcelRequire("jTCZr")).C);

var $jTCZr = parcelRequire("jTCZr");

});

parcelRegister("7buzq", function(module, exports) {

$parcel$export(module.exports, "withClinic", () => $53b14620f65a31c3$export$b17f3a965f9f2242);
$parcel$export(module.exports, "clinicRefOfPath", () => $53b14620f65a31c3$export$f00d295fe6ce126b);
$parcel$export(module.exports, "stripClinic", () => $53b14620f65a31c3$export$d80aea7b5cf46860);
$parcel$export(module.exports, "useAppNavigate", () => $53b14620f65a31c3$export$5b61ff3425c1c197);
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $1k2zw = parcelRequire("1k2zw");
// Maps old screen-name strings to URL paths.
// Preserves the existing navigate(screenName, data) call-site API so no
// .web.jsx / .mobile.jsx files need to change.
//
// A name missing here makes navigate() a silent no-op (see the `if (!path) return`
// below), so a sidebar item whose id is absent simply does nothing when clicked —
// no error, no route change. Exported so a test can assert every nav item resolves.
//
// ── CLINIC PREFIXING ────────────────────────────────────────────────────────────
// Every clinic-scoped path is served under `/c/:clinicRef/…`, because the active
// clinic is the URL and not a stored value (docs/CLINIC_MULTI_CLINIC_UX_REV2.md
// §A1). That is what makes two tabs on two clinics work with no coordination, and
// what makes a «پرداخت‌ها» bookmark saved at the Isfahan branch open the Isfahan
// branch.
//
// The prefix is applied HERE, in the one place paths are built, rather than at
// ~200 call sites. `ROUTES` therefore keeps returning bare paths and every existing
// `navigate('reception')` keeps working unchanged.
/**
 * Append a query string to a bare route path.
 *
 * Every builder below that takes one is answering the same need: a link from a
 * REPORT has to arrive somewhere already narrowed. «۳ ادعای ارسال‌نشده» that lands on
 * the whole claims ledger has made the reader start the search again, which is the
 * difference between a link that answers a question and one that merely changes
 * page. Undefined and empty values are dropped so a caller can pass a partial
 * object without producing `?insurer=undefined`.
 *
 * `params` is defaulted with `|| {}` rather than a parameter default, because
 * `useAppNavigate` passes `data = null` — and a parameter default only fires for
 * `undefined`. So every no-argument `navigate('reception')` arrived here as an
 * explicit null and threw on `Object.entries(null)`. Tests call the builders as
 * `resolve()`, which DOES trigger the parameter default, so the crash was
 * invisible to them.
 */ const $53b14620f65a31c3$var$withQuery = (path, params)=>{
    const q = new URLSearchParams();
    for (const [k, v] of Object.entries(params || {}))if (v !== undefined && v !== null && v !== '') q.set(k, String(v));
    const s = q.toString();
    return s ? `${path}?${s}` : path;
};
const $53b14620f65a31c3$export$cd891b82501bb412 = {
    'reception': ()=>'/reception',
    'patients': ()=>'/patients',
    // Prefill: «ثبت بیمار جدید با این کد ملی» from the no-match state, and the
    // placeholder label a «ثبت سریع» row was held on (redesign §10.1/§10.2). Nothing
    // is reserved by prefilling — the mobile lookup on the form, and `addPatient`'s own
    // PHONE_HAS_PATIENTS check, are what stop a second record for the same person.
    'add-patient': (data)=>{
        const q = new URLSearchParams();
        if (data?.nid) q.set('nid', data.nid);
        if (data?.phone) q.set('phone', data.phone);
        if (data?.name) q.set('name', data.name);
        const search = q.toString();
        return search ? `/patients/new?${search}` : '/patients/new';
    },
    // The deep link INTO a patient's record. Reception and «حسابداری» both know
    // a patient and need somewhere to send the operator; before this the only way in
    // was to find the row by hand (redesign finding F4, §16.4).
    'patient': (data)=>{
        const q = new URLSearchParams();
        if (data?.id) q.set('patient', data.id);
        if (data?.tab) q.set('tab', data.tab);
        if (data?.compose) q.set('compose', data.compose);
        if (data?.appointment) q.set('appointment', data.appointment);
        const search = q.toString();
        return search ? `/patients?${search}` : '/patients';
    },
    // The patient's CLINICAL record — «سوابق بیمار» — and the visit room: the shared
    // clinical module, rendered inside this panel for a practitioner of the clinic
    // (docs/CLINICAL_KIT_DESIGN.md). Not the same thing as 'patient' above, which
    // is this panel's own record drawer (identity, money, contact).
    'patient-record': (data)=>{
        const id = data?.id || data?.patientId;
        // No patient, no record to open: the registry is the honest landing.
        if (!id) return '/patients';
        const tab = data?.tab && data.tab !== 'overview' ? `/${encodeURIComponent(data.tab)}` : '';
        return `/patients/${encodeURIComponent(id)}/record${tab}`;
    },
    'visit': (data)=>{
        const id = data?.id || data?.patientId;
        // No patient, no visit: پذیرش is where one is started from.
        return id ? `/visit/${encodeURIComponent(id)}` : '/reception';
    },
    // «تقویم» was removed from the panel on 2026-09-13. The name stays mapped at
    // پذیرش — the desk's screen — so no existing navigate('calendar') call site
    // becomes a silent no-op.
    'calendar': ()=>'/reception',
    // A deep link names the report it wants. Callers pass `{ view: 'receivables' }`
    // and land on that report rather than on the overview, which is the difference
    // between a link that answers a question and one that starts a search.
    'reports': (data)=>data?.view ? `/reports?view=${encodeURIComponent(data.view)}` : '/reports',
    // ── The two halves of the old «عملیات و هزینه» ────────────────────────────
    //
    // «مدیریت هزینه‌ها» kept `/operations`; «کالاها و خدمات» is `/goods`. Every old
    // NAME stays mapped and now points at whichever page absorbed it, so no
    // existing `navigate('inventory')` call site becomes a silent no-op and none
    // of them had to learn the new path — which is the whole reason paths are
    // built here and not at ~200 call sites.
    'operations': (data)=>$53b14620f65a31c3$var$withQuery('/operations', data),
    'goods': (data)=>$53b14620f65a31c3$var$withQuery('/goods', data),
    'inventory': (data)=>$53b14620f65a31c3$var$withQuery('/goods', {
            view: 'items',
            ...data || {}
        }),
    // The equipment register — the dashboard's alert tile lands on it.
    'equipment': (data)=>$53b14620f65a31c3$var$withQuery('/goods', {
            view: 'equipment',
            ...data || {}
        }),
    'credits': ()=>'/credits',
    // «پزشکان» merged into «همکاران» — the old name stays mapped and lands
    // on the practitioner half, so no call site becomes a silent no-op.
    'doctors': ()=>'/people?kind=practitioner',
    'register-doctor': ()=>'/register-doctor',
    'login': ()=>'/login',
    // «حسابداری» — the Financial Operations hub.
    'accounting': (data)=>$53b14620f65a31c3$var$withQuery('/accounting', data),
    // «فروشگاه» — the clinic store. `{ view, listing, order, kind, tab }` narrow
    // it: the goods page's «در فروشگاه» chip lands on the listing it named.
    'store': (data)=>$53b14620f65a31c3$var$withQuery('/store', data),
    // The old «پرداخت‌ها» NAME stays mapped and now builds the hub path, so every
    // existing `navigate('payments', { patient, range })` call site — the patient
    // drawer's «دفتر پرداخت» and two report drill-downs — follows the move without
    // being edited. `view=claims`, the one value that named the OTHER
    // ledger on that route, lands on the tab that ledger became; everything else is
    // the receipts view, with the caller's narrowing carried through verbatim.
    'payments': (data)=>{
        const { view: view, ...rest } = data || {};
        if (view === 'claims') return $53b14620f65a31c3$var$withQuery('/accounting', {
            view: 'receivables',
            tab: 'insurers',
            ...rest
        });
        return $53b14620f65a31c3$var$withQuery('/accounting', {
            view: 'receipts',
            ...rest
        });
    },
    'claims': (data)=>$53b14620f65a31c3$var$withQuery('/accounting', {
            view: 'receivables',
            tab: 'insurers',
            ...data || {}
        }),
    // Both take `data`, so a report's drill-down can carry its narrowing into the
    // URL instead of dropping it on the floor: `ROUTES.expenses` used to take no
    // argument at all, which is why «هزینه‌های عملیاتی، مرکز پذیرش» landed on the
    // unfiltered ledger. Whether each view READS its parameters is a separate,
    // smaller gap (split design §12 D9) — this is the half that belongs here.
    'expenses': (data)=>$53b14620f65a31c3$var$withQuery('/operations', {
            view: 'expenses',
            ...data || {}
        }),
    'services': (data)=>$53b14620f65a31c3$var$withQuery('/goods', {
            view: 'services',
            ...data || {}
        }),
    'people': ()=>'/people',
    // «حقوق و دستمزد» — split in two on 2026-09-13, and both halves keep a NAME
    // here so no existing call site becomes a silent no-op. The bare `payroll`
    // still means «take me to the payroll», which is now the OPERATION: the tab of
    // «همکاران» where a month is calculated, corrected, finalized and paid — and it
    // is what «بدهی‌ها → حقوق» and the employee counterparty drawer have always
    // meant by it. `payroll-report` is the accountant's reading of the same month
    // in «حسابداری». Both carry `{ y, m }` when the caller knows the month, so a
    // link opens the one the reader was looking at rather than today's.
    'payroll': (data)=>$53b14620f65a31c3$var$withQuery('/people', {
            tab: 'payroll',
            ...data || {}
        }),
    'payroll-report': (data)=>$53b14620f65a31c3$var$withQuery('/accounting', {
            view: 'payroll',
            ...data || {}
        }),
    // The two objects «همکاران» holds. The roles tab is a real destination — the
    // role editor's back affordance points at it, and landing that reader on a
    // table of people is a step they then have to undo.
    'people-roles': ()=>'/people?tab=roles',
    // «who holds this role» — the crossing from a role to the people who have it,
    // which is the question a role is usually opened to ask.
    'people-by-role': (roleId)=>`/people?kind=staff&role=${encodeURIComponent(roleId || '')}`,
    // «اشتراک کلینیک» and «معرفی کلینیک» merged into «کلینیک من». Both old names
    // stay mapped and land on the view that absorbed them, so every existing
    // navigate('subscription') call site — the shell's paywall banner among them —
    // keeps working instead of becoming a silent no-op.
    // `view` lands the caller on a tab. Without it the «+» beside the قالب picker in
    // «ارسال پیام» opened «کلینیک من» on مشخصات — the page's default — instead of
    // «قالب‌های پیام», which is the only reason anyone presses it.
    'clinic': (data)=>data?.view ? `/clinic?view=${encodeURIComponent(data.view)}` : '/clinic',
    'about': ()=>'/clinic?view=connect',
    'subscription': ()=>'/clinic?view=billing',
    // The WhatsApp link lives here, and messaging cannot work until a clinic has
    // paired its number — so the compose dialog and the «اتصال قطع شده» alert both
    // need a real destination to send the operator to.
    'settings': (data)=>data?.section ? `/settings?section=${data.section}` : '/settings'
};
const $53b14620f65a31c3$export$f6b6e3d22eca7915 = {
    'start': ()=>'/start',
    'invitations': ()=>'/invitations',
    'onboarding': ()=>'/onboarding'
};
function $53b14620f65a31c3$export$b17f3a965f9f2242(path, ref = (0, $1k2zw.getActiveClinicRef)()) {
    if (!path || !ref) return path;
    if (path.startsWith('/c/')) return path;
    return `/c/${ref}${path}`;
}
function $53b14620f65a31c3$export$f00d295fe6ce126b(pathname = '') {
    const m = /^\/c\/([^/]+)/.exec(pathname || '');
    if (!m) return '';
    try {
        return decodeURIComponent(m[1]);
    } catch  {
        // A ref that is not valid percent-encoding is not a ref we could match anyway.
        return m[1];
    }
}
function $53b14620f65a31c3$export$d80aea7b5cf46860(pathname = '') {
    const m = /^\/c\/[^/]+(\/.*)?$/.exec(pathname);
    if (!m) return pathname || '/';
    return m[1] || '/';
}
function $53b14620f65a31c3$export$5b61ff3425c1c197() {
    const rrNavigate = (0, $aphAM.useNavigate)();
    return (to, data = null, opts = null)=>{
        const nav = {
            ...data ? {
                state: data
            } : {},
            ...opts?.replace ? {
                replace: true
            } : {}
        };
        const options = Object.keys(nav).length ? nav : undefined;
        const personPath = $53b14620f65a31c3$export$f6b6e3d22eca7915[to]?.();
        if (personPath) {
            rrNavigate(personPath, options);
            window.scrollTo(0, 0);
            return;
        }
        const path = $53b14620f65a31c3$export$cd891b82501bb412[to]?.(data);
        if (!path) return;
        rrNavigate($53b14620f65a31c3$export$b17f3a965f9f2242(path), options);
        window.scrollTo(0, 0);
    };
}

});

parcelRegister("exu0F", function(module, exports) {

$parcel$export(module.exports, "useClinicCapabilities", () => $a95b6d0cf72e53b0$export$6245109895419f6d);
$parcel$export(module.exports, "isBlocked", () => $a95b6d0cf72e53b0$export$548f076b7581caed);
$parcel$export(module.exports, "useSubscription", () => $a95b6d0cf72e53b0$export$368b4214baeb914c);

var $acw62 = parcelRequire("acw62");

var $eLeza = parcelRequire("eLeza");

var $2Mst8 = parcelRequire("2Mst8");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");
/**
 * Clinic subscription & entitlement data.
 *
 * `capabilities` is the UI-gating source: it drives disabled buttons and the
 * paywall banner. It is NEVER the enforcement boundary — the BFF re-checks every
 * gated operation server-side, so a tampered client gains nothing.
 *
 * Deliberately tolerant of failure. If the subscription service is unreachable
 * the hook reports an entitled clinic rather than an error, mirroring the BFF's
 * fail-open policy: a billing outage must not blank the clinic panel or make the
 * app look broken to a clinic that has paid.
 */ const $a95b6d0cf72e53b0$var$CAPABILITIES_QUERY = `
  query MyClinicCapabilities {
    myClinicCapabilities {
      entitled
      status
      currentPeriodEnd
      trialEndsAt
      graceEndsAt
      daysRemaining
      inTrial
      inGracePeriod
      blockedOperations
      paywallMessageFa
      readOnly
      trialEnded
      capabilitySet
      tierNameFa
      planCode
      limits { maxPatients maxDoctors maxStaff }
      billing { checkout }
    }
  }
`;
const $a95b6d0cf72e53b0$var$SUBSCRIPTION_QUERY = `
  query MyClinicSubscription {
    myClinicSubscription {
      id
      status
      planCode
      currentPeriodStart
      currentPeriodEnd
      trialEndsAt
      graceEndsAt
      origin
      notRenewing
      notRenewingReason
      periods {
        id
        planCode
        periodStart
        periodEnd
        priceRial
        currency
        source
        activatedAt
        note
      }
    }
  }
`;
const $a95b6d0cf72e53b0$var$PLANS_QUERY = `
  query SubscriptionPlans {
    subscriptionPlans {
      code
      nameFa
      priceRial
      priceToman
      compareAtPriceToman
      currency
      priceMinor
      compareAtPriceMinor
      promotionCode
      periodMonths
      capabilitySet
      sortOrder
    }
  }
`;
const $a95b6d0cf72e53b0$var$CHECKOUT_MUTATION = `
  mutation StartSubscriptionCheckout($planCode: String!, $returnUrl: String) {
    startSubscriptionCheckout(planCode: $planCode, returnUrl: $returnUrl) {
      paymentId
      gateway
      authority
      paymentUrl
      amountRial
      amountToman
      currency
      amountMinor
    }
  }
`;
const $a95b6d0cf72e53b0$var$CONFIRM_MUTATION = `
  mutation ConfirmSubscriptionPayment($authority: String!, $gateway: String) {
    confirmSubscriptionPayment(authority: $authority, gateway: $gateway) {
      success
      status
      refId
      messageFa
      subscription { id status currentPeriodEnd planCode }
    }
  }
`;
const $a95b6d0cf72e53b0$var$NOT_RENEWING_MUTATION = `
  mutation SetNotRenewing($notRenewing: Boolean!, $reason: String) {
    setNotRenewing(notRenewing: $notRenewing, reason: $reason) { id notRenewing notRenewingReason }
  }
`;
/**
 * Treated as entitled AND as the top tier — matches the BFF's fail-open
 * contract on both axes. Reporting a lower tier, or a read-only panel, here
 * would grey out every screen during a billing outage, which is a worse lie
 * than reporting nothing.
 */ const $a95b6d0cf72e53b0$var$OPEN_CAPABILITIES = {
    entitled: true,
    status: 'ACTIVE',
    currentPeriodEnd: null,
    trialEndsAt: null,
    graceEndsAt: null,
    daysRemaining: null,
    inTrial: false,
    inGracePeriod: false,
    blockedOperations: [],
    paywallMessageFa: null,
    readOnly: false,
    trialEnded: false,
    capabilitySet: 'CLINIC_GOLD',
    tierNameFa: '',
    planCode: null,
    limits: {
        maxPatients: null,
        maxDoctors: null,
        maxStaff: null
    },
    // Unknown while the BFF is unreachable: today's behaviour. The BFF still
    // refuses checkout itself where there is no way to pay (CHECKOUT_UNAVAILABLE).
    billing: {
        checkout: 'ON'
    },
    unavailable: true
};
function $a95b6d0cf72e53b0$export$6245109895419f6d() {
    const [capabilities, setCapabilities] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const refetch = (0, $acw62.useCallback)(()=>{
        setLoading(true);
        return (0, $2Mst8.bffQuery)($a95b6d0cf72e53b0$var$CAPABILITIES_QUERY).then((data)=>setCapabilities(data?.myClinicCapabilities || $a95b6d0cf72e53b0$var$OPEN_CAPABILITIES)).catch(()=>setCapabilities($a95b6d0cf72e53b0$var$OPEN_CAPABILITIES)).finally(()=>setLoading(false));
    }, []);
    (0, $acw62.useEffect)(()=>{
        refetch();
    }, [
        refetch
    ]);
    // A clinic that pays in another tab should not have to reload to see the
    // paywall disappear.
    (0, $acw62.useEffect)(()=>{
        const onVisible = ()=>{
            if (document.visibilityState === 'visible') refetch();
        };
        document.addEventListener('visibilitychange', onVisible);
        return ()=>document.removeEventListener('visibilitychange', onVisible);
    }, [
        refetch
    ]);
    return {
        capabilities: capabilities,
        loading: loading,
        refetch: refetch
    };
}
function $a95b6d0cf72e53b0$export$548f076b7581caed(capabilities, operation) {
    if (!capabilities) return false;
    return (capabilities.blockedOperations || []).includes(operation);
}
/** Full billing screen data: subscription, plans, and the mutations. */ /**
 * The plans as this market shows them. A promotion is an Iranian campaign (the
 * congress offer, CONGRESS_RESPIRATORY_1405): a brand outside the Iranian market
 * (`market: 'intl'`, docs/rebranding/CONTRACT.md) names none, so a code that
 * reaches it anyway is dropped here — no banner, no «تخفیف ویژه» tag.
 */ function $a95b6d0cf72e53b0$var$offeredPlans(plans) {
    const list = Array.isArray(plans) ? plans : [];
    return (0, $eLeza.isIranMarket)() ? list : list.map((plan)=>({
            ...plan,
            promotionCode: null
        }));
}
function $a95b6d0cf72e53b0$export$368b4214baeb914c() {
    const { t: t } = (0, $e1LEq.default)();
    const [subscription, setSubscription] = (0, $acw62.useState)(null);
    const [plans, setPlans] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    const [busy, setBusy] = (0, $acw62.useState)('');
    const refetch = (0, $acw62.useCallback)(async ()=>{
        setLoading(true);
        setError(null);
        try {
            // Plans and subscription are fetched together but fail independently: a
            // clinic with no subscription row yet must still see what it can buy.
            const [subData, planData] = await Promise.all([
                (0, $2Mst8.bffQuery)($a95b6d0cf72e53b0$var$SUBSCRIPTION_QUERY).catch(()=>null),
                (0, $2Mst8.bffQuery)($a95b6d0cf72e53b0$var$PLANS_QUERY)
            ]);
            setSubscription(subData?.myClinicSubscription || null);
            setPlans($a95b6d0cf72e53b0$var$offeredPlans(planData?.subscriptionPlans));
        } catch (err) {
            setError(err?.message || t('errors.load.subscription'));
        } finally{
            setLoading(false);
        }
    }, [
        t
    ]);
    (0, $acw62.useEffect)(()=>{
        refetch();
    }, [
        refetch
    ]);
    /**
   * Start checkout and hand back the gateway URL.
   *
   * Returns the session rather than redirecting, so the caller decides when to
   * leave the page — a redirect buried in a hook is impossible to test and
   * surprises the user mid-render.
   */ const startCheckout = (0, $acw62.useCallback)(async (planCode)=>{
        setBusy(planCode);
        try {
            // Where the BROWSER comes back to. Where the GATEWAY posts its result is
            // decided by the server: it must be an endpoint that can parse a bank's
            // POST and settle, and this app is static files — sending Shaparak here
            // returned 405, so the payment never settled and the bank reversed it.
            // Where the BROWSER comes back to — «کلینیک من», billing view. The
            // payment BFF appends `payment=…` to this with `&` when a query is already
            // present, so the `?view=` survives the round trip.
            const returnUrl = `${window.location.origin}/clinic?view=billing`;
            const data = await (0, $2Mst8.bffQuery)($a95b6d0cf72e53b0$var$CHECKOUT_MUTATION, {
                planCode: planCode,
                returnUrl: returnUrl
            });
            return data?.startSubscriptionCheckout || null;
        } finally{
            setBusy('');
        }
    }, []);
    const confirmPayment = (0, $acw62.useCallback)(async (authority, gateway)=>{
        const data = await (0, $2Mst8.bffQuery)($a95b6d0cf72e53b0$var$CONFIRM_MUTATION, {
            authority: authority,
            gateway: gateway || 'zarinpal'
        });
        await refetch();
        return data?.confirmSubscriptionPayment || null;
    }, [
        refetch
    ]);
    const setNotRenewing = (0, $acw62.useCallback)(async (notRenewing, reason)=>{
        const data = await (0, $2Mst8.bffQuery)($a95b6d0cf72e53b0$var$NOT_RENEWING_MUTATION, {
            notRenewing: notRenewing,
            reason: reason || ''
        });
        await refetch();
        return data?.setNotRenewing || null;
    }, [
        refetch
    ]);
    return {
        subscription: subscription,
        plans: plans,
        loading: loading,
        error: error,
        busy: busy,
        refetch: refetch,
        startCheckout: startCheckout,
        confirmPayment: confirmPayment,
        setNotRenewing: setNotRenewing
    };
}

});

parcelRegister("5bPPa", function(module, exports) {

$parcel$export(module.exports, "useCredits", () => $3c762e0fe7df1045$export$794eb6d8e9a18529);

var $acw62 = parcelRequire("acw62");

var $2Mst8 = parcelRequire("2Mst8");

var $jTCZr = parcelRequire("jTCZr");
/**
 * اعتبار پارسینا («پارسه») — the SIGNED-IN PERSON's balance and the price list.
 *
 * ── WHOSE BALANCE ───────────────────────────────────────────────────────────
 * Your own. Every Parsina wallet belongs to one person
 * (docs/wallet-person-billing/CONTRACTS.md §0), and whoever performs a billable
 * action pays for it: the receptionist who dictates a walk-in, the staff member
 * who sends a WhatsApp. The clinic has no shared pool any more, so there is ONE
 * balance on this screen, and every surface says «اعتبار شما».
 *
 * `balance` is what a new charge can take — the wallet's `available`, which
 * already subtracts holds for sends still in flight — because that is the number
 * a «کافی است؟» check has to use. It is null, never 0, when the wallet could not
 * be read.
 *
 * The BFF resolves the owner from the verified token, so this hook sends no owner
 * and cannot ask about anyone else's.
 *
 * ── WHY THE PRICES COME FROM THE SERVER ─────────────────────────────────────
 * `clinicCreditPrices` mirrors the schedule that actually debits. A price
 * hardcoded here would eventually disagree with the ledger. That is why `cost`
 * is null until the query answers, and why the caller says «نامشخص» rather than
 * «۰» in the meantime.
 */ const $3c762e0fe7df1045$var$CREDITS_QUERY = `
  query MyCredits {
    myPersonalCreditBalance {
      balance
      available
      currency
      lastUpdated
    }
    clinicCreditPrices {
      action
      cost
      per
    }
  }
`;
function $3c762e0fe7df1045$export$2e1a2382662bd4ea(balance) {
    return (0, $jTCZr.creditLevel)(balance) ?? 'unknown';
}
function $3c762e0fe7df1045$export$794eb6d8e9a18529() {
    const [balance, setBalance] = (0, $acw62.useState)(null);
    const [prices, setPrices] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const load = (0, $acw62.useCallback)(()=>{
        setLoading(true);
        return (0, $2Mst8.bffQuery)($3c762e0fe7df1045$var$CREDITS_QUERY).then((data)=>{
            // null, never 0, when the answer did not arrive: a zero balance and an
            // unknown one look identical on screen and mean opposite things — one
            // says «شارژ کنید», the other says «دوباره تلاش کنید».
            const mine = data?.myPersonalCreditBalance;
            setBalance(mine ? mine.available ?? mine.balance ?? null : null);
            setPrices(data?.clinicCreditPrices ?? null);
        }).catch(()=>{
            setBalance(null);
            setPrices(null);
        }).finally(()=>setLoading(false));
    }, []);
    (0, $acw62.useEffect)(()=>{
        load();
    }, [
        load
    ]);
    // Come back to the tab and the balance may have moved — the same wallet is
    // spent from every Parsina panel this person uses.
    (0, $acw62.useEffect)(()=>{
        const onVisible = ()=>{
            if (document.visibilityState === 'visible') load();
        };
        document.addEventListener('visibilitychange', onVisible);
        return ()=>document.removeEventListener('visibilitychange', onVisible);
    }, [
        load
    ]);
    /** What one action costs, or null while unknown. */ const priceOf = (0, $acw62.useCallback)((action)=>prices?.find((p)=>p.action === action)?.cost ?? null, [
        prices
    ]);
    return {
        balance: balance,
        prices: prices,
        priceOf: priceOf,
        loading: loading,
        level: $3c762e0fe7df1045$export$2e1a2382662bd4ea(balance),
        refresh: load
    };
}
var $3c762e0fe7df1045$export$2e2bcd8739ae039 = $3c762e0fe7df1045$export$794eb6d8e9a18529;

});

parcelRegister("3drWo", function(module, exports) {

$parcel$export(module.exports, "planCurrency", () => $25784271a01804e6$export$64b83ebdf1c327f0);
$parcel$export(module.exports, "planPrice", () => $25784271a01804e6$export$8b8ced673e040b72);
$parcel$export(module.exports, "planCompareAt", () => $25784271a01804e6$export$fdc457abd2fbc349);
$parcel$export(module.exports, "formatPlatformAmount", () => $25784271a01804e6$export$cdee57a196f3ed68);
$parcel$export(module.exports, "platformUnit", () => $25784271a01804e6$export$f8a7a4f633e6900);
$parcel$export(module.exports, "isContactCheckout", () => $25784271a01804e6$export$5b65f042ab8b36ad);
$parcel$export(module.exports, "statusMeta", () => $25784271a01804e6$export$7b9ba302287e5be1);
$parcel$export(module.exports, "TONE_VARIANT", () => $25784271a01804e6$export$880178773fe1995c);
$parcel$export(module.exports, "RETAINED_CAPABILITIES", () => $25784271a01804e6$export$6fcb6965dd45b515);
$parcel$export(module.exports, "BLOCKED_CAPABILITIES", () => $25784271a01804e6$export$88ddf7998934dfcf);
$parcel$export(module.exports, "formatJalaliDate", () => $25784271a01804e6$export$4e5d928a7a72aa4);
$parcel$export(module.exports, "periodAnchor", () => $25784271a01804e6$export$9c4804b3bd5b629);
$parcel$export(module.exports, "remainingLabel", () => $25784271a01804e6$export$2fb6509c5aa3558d);
$parcel$export(module.exports, "savingPercent", () => $25784271a01804e6$export$3728eb8fedc27846);
$parcel$export(module.exports, "groupPlansByTier", () => $25784271a01804e6$export$cac268531c93c0cf);
$parcel$export(module.exports, "promotionCopy", () => $25784271a01804e6$export$f9a50ad10adb4f55);
$parcel$export(module.exports, "savingToman", () => $25784271a01804e6$export$c1d7d1741412b5b);
$parcel$export(module.exports, "breakEvenYear", () => $25784271a01804e6$export$c6c2edc6385ad917);
$parcel$export(module.exports, "shouldWarn", () => $25784271a01804e6$export$22962a64812bd1ac);
/**
 * Presentation metadata for the subscription screens.
 *
 * Shared by the web and mobile views so the two can never disagree about what a
 * status means — the copy, the tone and the call to action live here once.
 */ 
var $eLeza = parcelRequire("eLeza");

var $lHVFz = parcelRequire("lHVFz");

var $1O6TO = parcelRequire("1O6TO");
const $25784271a01804e6$export$64b83ebdf1c327f0 = (row)=>row?.currency || 'IRR';
const $25784271a01804e6$var$isIrr = (row)=>$25784271a01804e6$export$64b83ebdf1c327f0(row) === 'IRR';
const $25784271a01804e6$export$8b8ced673e040b72 = (plan)=>Number(($25784271a01804e6$var$isIrr(plan) ? plan?.priceToman : plan?.priceMinor) || 0);
const $25784271a01804e6$export$fdc457abd2fbc349 = (plan)=>Number(($25784271a01804e6$var$isIrr(plan) ? plan?.compareAtPriceToman : plan?.compareAtPriceMinor) || 0);
function $25784271a01804e6$export$cdee57a196f3ed68(minor, currency, { locale: locale = 'fa', unit: unit = 'none' } = {}) {
    if ((0, $1O6TO.isUnknownCurrency)(currency)) {
        const figure = String(Number(minor));
        return unit === 'none' ? figure : `${figure} ${(0, $1O6TO.unitLabel)(currency, locale, unit)}`;
    }
    return (0, $lHVFz.formatAmount)(minor, currency, {
        locale: locale,
        unit: unit
    });
}
const $25784271a01804e6$export$f8a7a4f633e6900 = (currency, locale)=>(0, $1O6TO.unitLabel)(currency, locale, 'short');
const $25784271a01804e6$export$5b65f042ab8b36ad = (capabilities)=>capabilities?.billing?.checkout === 'CONTACT';
const $25784271a01804e6$export$8f9292f3e50b1f73 = (t)=>({
        TRIALING: {
            label: t('subscription.status.trial'),
            tone: 'info',
            urgent: false,
            description: t('subscription.status.trialHint')
        },
        ACTIVE: {
            label: t('common.state.active'),
            tone: 'success',
            urgent: false,
            description: t('subscription.status.activeHint')
        },
        PAST_DUE: {
            label: t('subscription.status.grace'),
            tone: 'warning',
            urgent: true,
            description: t('subscription.status.graceHint')
        },
        EXPIRED: {
            label: t('subscription.status.expired'),
            tone: 'danger',
            urgent: true,
            description: t('subscription.status.expiredHint')
        },
        SUSPENDED: {
            label: t('people.status.suspended'),
            tone: 'danger',
            urgent: true,
            description: t('subscription.status.suspendedHint')
        }
    });
const $25784271a01804e6$export$7b9ba302287e5be1 = (status, t, checkout)=>{
    const meta = $25784271a01804e6$export$8f9292f3e50b1f73(t)[status] || $25784271a01804e6$export$8f9292f3e50b1f73(t).ACTIVE;
    if (checkout !== 'CONTACT') return meta;
    if (status === 'TRIALING') return {
        ...meta,
        description: t('subscription.contact.trialHint')
    };
    if (status === 'EXPIRED') return {
        ...meta,
        description: t('subscription.contact.expiredHint')
    };
    return meta;
};
const $25784271a01804e6$export$2a13079631527844 = new Set(Object.entries($25784271a01804e6$export$8f9292f3e50b1f73((key)=>key)).filter(([, meta])=>meta.urgent).map(([status])=>status));
const $25784271a01804e6$export$880178773fe1995c = {
    info: 'outline',
    success: 'success',
    warning: 'warning',
    danger: 'destructive'
};
const $25784271a01804e6$export$6fcb6965dd45b515 = (t)=>[
        t('subscription.retained.records'),
        t('subscription.retained.history'),
        t('subscription.retained.invoices'),
        t('subscription.retained.messages'),
        t('subscription.lost.staffAccess')
    ];
const $25784271a01804e6$export$88ddf7998934dfcf = (t)=>[
        t('subscription.lost.newBooking'),
        t('subscription.lost.reception'),
        t('subscription.lost.billing'),
        t('subscription.lost.messaging'),
        t('subscription.lost.anyEdit')
    ];
function $25784271a01804e6$export$4e5d928a7a72aa4(iso, formatDate) {
    // Empty string, not the formatters' em dash: an absent period end means "no
    // end", which the KPI strip renders as «نامحدود» — a dash there would read as
    // a subscription that ended on a date nobody recorded.
    if (!iso || Number.isNaN(new Date(iso).getTime())) return '';
    return formatDate(iso, 'long');
}
function $25784271a01804e6$export$9c4804b3bd5b629(capabilities, subscription) {
    if (!capabilities) {
        const iso = subscription?.currentPeriodEnd || null;
        if (iso) return {
            kind: 'period',
            iso: iso
        };
        return {
            kind: [
                'EXPIRED',
                'SUSPENDED'
            ].includes(subscription?.status) ? 'none' : 'unlimited',
            iso: null
        };
    }
    if (capabilities.inTrial || capabilities.trialEnded) return {
        kind: 'trial',
        iso: capabilities.trialEndsAt || null
    };
    if (capabilities.inGracePeriod) return {
        kind: 'grace',
        iso: capabilities.graceEndsAt || null
    };
    if (capabilities.currentPeriodEnd) return {
        kind: 'period',
        iso: capabilities.currentPeriodEnd
    };
    return {
        kind: capabilities.readOnly || capabilities.entitled === false ? 'none' : 'unlimited',
        iso: null
    };
}
function $25784271a01804e6$export$2fb6509c5aa3558d(days, t) {
    if (days == null) return '';
    if (days < 0) return t('subscription.remaining.ended');
    if (days === 0) return t('subscription.remaining.endsToday');
    // `count` is passed as a NUMBER so the plural rules select and the figure is
    // rendered by the locale's own number formatter. Persian resolves every
    // count to `_other`; English needs `_one` for the "1 day left" case that
    // used to be a separate hardcoded sentence here.
    return t('subscription.remaining.days', {
        count: days
    });
}
function $25784271a01804e6$export$3728eb8fedc27846(plan) {
    const price = $25784271a01804e6$export$8b8ced673e040b72(plan);
    const compareAt = $25784271a01804e6$export$fdc457abd2fbc349(plan);
    if (!price || !compareAt || compareAt <= price) return null;
    return Math.round((compareAt - price) / compareAt * 100);
}
const $25784271a01804e6$export$8e7ccd021abcbfdf = (t)=>[
        {
            key: 'CLINIC_GOLD',
            nameFa: t('subscription.tiers.gold.name'),
            pitch: t('subscription.tiers.gold.pitch'),
            features: [
                t('subscription.features.scheduling'),
                t('subscription.features.patientBook'),
                t('subscription.features.cashier'),
                t('subscription.features.payments'),
                t('subscription.features.services'),
                t('subscription.features.contracts'),
                t('subscription.features.reports'),
                t('subscription.features.expenses'),
                t('subscription.features.inventory'),
                t('subscription.features.customRoles'),
                t('subscription.features.voice')
            ],
            limits: {
                maxPatients: null,
                maxDoctors: null,
                maxStaff: null
            }
        }
    ];
function $25784271a01804e6$export$cac268531c93c0cf(plans, t) {
    return $25784271a01804e6$export$8e7ccd021abcbfdf(t).map((tier)=>{
        const own = (plans || []).filter((p)=>p.capabilitySet === tier.key);
        return {
            ...tier,
            monthly: own.find((p)=>p.periodMonths === 1) || null,
            annual: own.find((p)=>p.periodMonths === 12) || null,
            oneTime: own.filter((p)=>p.periodMonths === 0 && $25784271a01804e6$export$8b8ced673e040b72(p) > 0)
        };
    });
}
const $25784271a01804e6$export$31db738a3c14a747 = {
    CONGRESS_RESPIRATORY_1405: {
        label: 'subscription.promotions.congressRespiratory1405.label',
        title: 'subscription.promotions.congressRespiratory1405.title',
        lead: 'subscription.promotions.congressRespiratory1405.lead'
    }
};
const $25784271a01804e6$var$GENERIC_PROMOTION = {
    label: 'subscription.promotions.generic.label',
    title: null,
    lead: null
};
function $25784271a01804e6$export$f9a50ad10adb4f55(code) {
    if (!code || !(0, $eLeza.isIranMarket)()) return null;
    return $25784271a01804e6$export$31db738a3c14a747[code] || $25784271a01804e6$var$GENERIC_PROMOTION;
}
function $25784271a01804e6$export$c1d7d1741412b5b(plan) {
    const price = $25784271a01804e6$export$8b8ced673e040b72(plan);
    const compareAt = $25784271a01804e6$export$fdc457abd2fbc349(plan);
    if (!price || !compareAt || compareAt <= price) return null;
    return compareAt - price;
}
function $25784271a01804e6$export$c6c2edc6385ad917(perpetual, annual) {
    const once = $25784271a01804e6$export$8b8ced673e040b72(perpetual);
    const yearly = $25784271a01804e6$export$8b8ced673e040b72(annual);
    if (!once || !yearly) return null;
    const year = Math.floor(once / yearly) + 1;
    return year >= 2 && year <= 6 ? year : null;
}
function $25784271a01804e6$export$22962a64812bd1ac(capabilities) {
    if (!capabilities || capabilities.unavailable) return false;
    // No way to pay: every banner but a suspension's would promise a read-only
    // panel or ask for a payment nobody can make.
    if ($25784271a01804e6$export$5b65f042ab8b36ad(capabilities)) return capabilities.status === 'SUSPENDED';
    if ($25784271a01804e6$export$2a13079631527844.has(capabilities.status)) return true;
    // Nudge during a trial that is nearly over, so the clinic is not surprised.
    return !!capabilities.inTrial && capabilities.daysRemaining != null && capabilities.daysRemaining <= 3;
}

});

parcelRegister("1iGMR", function(module, exports) {

$parcel$export(module.exports, "useAccess", () => $0f28a9809c2c2eac$export$56a3f0a6e4790146);

var $acw62 = parcelRequire("acw62");

var $ett75 = parcelRequire("ett75");
function $0f28a9809c2c2eac$export$56a3f0a6e4790146() {
    const { access: access, activeMembership: activeMembership, state: state } = (0, $ett75.useClinicContext)();
    return (0, $acw62.useMemo)(()=>{
        const tier = access?.tier || activeMembership?.tier || null;
        const isOwner = tier === 'OWNER';
        const isAdmin = isOwner || tier === 'ADMIN';
        const list = access?.permissions || [];
        const all = list.includes('ALL');
        const perms = new Set(all ? [] : list);
        // Who this person is AS A PRACTITIONER at this clinic, or null. Resolved by the
        // server from an ACTIVE clinic_doctors row — `activeMembership.kinds` cannot
        // answer it, because a pending join still carries the PRACTITIONER kind.
        const practitionerId = access?.practitionerId || null;
        return {
            isOwner: isOwner,
            isAdmin: isAdmin,
            practitionerId: practitionerId,
            /** A doctor who also works this panel — the manager who sees patients. */ isPractitioner: Boolean(practitionerId),
            /** `ALL` is a token in the list, not a magic role name. */ can: (key)=>all || perms.has(key),
            /** True for any one of several keys — «عملیات» needs three. */ canAny: (...keys)=>all || keys.flat().some((k)=>perms.has(k)),
            perms: perms,
            /**
       * Enterable, but holding nothing. A real state (§5.9.2), distinct from
       * "still loading", which must never render as a permission verdict.
       */ noPermissions: Boolean(access?.noPermissions),
            ready: state === 'ready' && Boolean(access),
            roles: access?.roles || activeMembership?.roles || [],
            tier: tier
        };
    }, [
        access,
        activeMembership,
        state
    ]);
}
var $0f28a9809c2c2eac$export$2e2bcd8739ae039 = $0f28a9809c2c2eac$export$56a3f0a6e4790146;

});
parcelRegister("ett75", function(module, exports) {

$parcel$export(module.exports, "isPendingInvitation", () => $ceaf0727c9907991$export$e934de5998b52b20);
$parcel$export(module.exports, "BOOT", () => $ceaf0727c9907991$export$eab765f73d387158);
$parcel$export(module.exports, "useOptionalClinicContext", () => $ceaf0727c9907991$export$d09afb0d578c99c);
$parcel$export(module.exports, "useClinicContext", () => $ceaf0727c9907991$export$c705fd12b0d4cddb);
$parcel$export(module.exports, "refOf", () => $ceaf0727c9907991$export$4d480254ae72c2a9);
$parcel$export(module.exports, "ClinicContextProvider", () => $ceaf0727c9907991$export$ed5bcf87c5db8fb3);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $2Mst8 = parcelRequire("2Mst8");

var $58BYB = parcelRequire("58BYB");

var $1k2zw = parcelRequire("1k2zw");

var $jG8cU = parcelRequire("jG8cU");

var $7buzq = parcelRequire("7buzq");
parcelRequire("7c6z4");
var $k7W79 = parcelRequire("k7W79");
var $aBaxB = parcelRequire("aBaxB");

var $5qKOB = parcelRequire("5qKOB");
/**
 * The active clinic, the person's memberships, and their access in that clinic.
 *
 * docs/CLINIC_MULTI_CLINIC_UX_REV2.md. Three ideas hold this together:
 *
 * 1. THE ROUTE IS THE TENANT. `/c/:clinicRef/…`. This provider does not own the
 *    active clinic — it reads it from the route and mirrors it into the transport.
 *    Nothing stores it, so two tabs are two clinics for free and a bookmark is
 *    always right.
 * 2. PERMISSIONS COME FROM THE SERVER, per clinic. `myAccess` is resolved by the
 *    BFF for the clinic in the header, so the sidebar and the boundary cannot
 *    disagree, and a switch changes both together.
 * 3. FIVE BOOT OUTCOMES, NOT TWO. «the query failed» and «this person genuinely
 *    belongs nowhere» must never collapse — the existing App.jsx comment records
 *    what that cost the last time (a database blip told a three-year clinic owner
 *    to go create their clinic), and the same reasoning extends to «waiting on an
 *    invitation», which is a third thing again.
 */ const $ceaf0727c9907991$var$BOOTSTRAP = `
  query ClinicBootstrap {
    platformCapabilities { multiFounder }
    myMemberships {
      clinicId slug clinicName city currency timezone
      kinds status staffStatus tier
      roles { id nameFa color }
      enterable blockedReason isFounder repairNeeded
      joinedAt invitedBy invitedAt lastActiveAt
    }
    myAccess {
      clinicId tier permissions version noPermissions practitionerId
      roles { id nameFa color }
    }
  }
`;
const $ceaf0727c9907991$var$REPAIR = `
  mutation RepairClinicSetup($clinicId: ID!) {
    repairClinicSetup(clinicId: $clinicId) { clinicId repairNeeded enterable }
  }
`;
const $ceaf0727c9907991$export$e934de5998b52b20 = (m)=>m?.status === 'INVITED' || m?.staffStatus === 'INVITED';
const $ceaf0727c9907991$export$eab765f73d387158 = {
    LOADING: 'loading',
    READY: 'ready',
    NONE: 'none',
    PENDING_ONLY: 'pending-only',
    ERROR: 'error'
};
async function $ceaf0727c9907991$export$578e157f63c54b59(run) {
    const named = (0, $1k2zw.getActiveClinicRef)();
    (0, $1k2zw.setActiveClinicRef)('');
    try {
        return await run();
    } finally{
        (0, $1k2zw.setActiveClinicRef)(named);
    }
}
const $ceaf0727c9907991$var$ClinicCtx = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
function $ceaf0727c9907991$export$d09afb0d578c99c() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($ceaf0727c9907991$var$ClinicCtx);
}
function $ceaf0727c9907991$export$c705fd12b0d4cddb() {
    const ctx = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($ceaf0727c9907991$var$ClinicCtx);
    if (!ctx) throw new Error('useClinicContext must be used inside <ClinicContextProvider>');
    return ctx;
}
const $ceaf0727c9907991$export$22dfc04513b3ff1c = (memberships, ref)=>(memberships || []).find((m)=>m.slug === ref || m.clinicId === ref) || null;
const $ceaf0727c9907991$export$4d480254ae72c2a9 = (m)=>m ? m.slug || m.clinicId : '';
function $ceaf0727c9907991$export$ed5bcf87c5db8fb3({ children: children }) {
    const navigate = (0, $aphAM.useNavigate)();
    const location = (0, $aphAM.useLocation)();
    // FROM THE PATH, not from `useParams()`.
    //
    // This provider is mounted above the `Routes` — it has to be, because `/start`
    // and `/onboarding` need it too — and `useParams()` reports only the params of
    // routes matched at or ABOVE the calling component. So `params.clinicRef` was
    // always `undefined` here however specific the URL was, which made `routeRef`
    // permanently '', `activeMembership` permanently null, and ClinicGate refuse
    // every clinic screen to every person with «این کلینیک در دسترس شما نیست» —
    // including a clinic's own founder. It also meant `x-active-clinic-id` was never
    // sent, so the BFF silently fell back to its inference ladder and none of the
    // multi-clinic validation this design turns on was actually reached.
    const routeRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $7buzq.clinicRefOfPath)(location.pathname), [
        location.pathname
    ]);
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState($ceaf0727c9907991$export$eab765f73d387158.LOADING);
    const [memberships, setMemberships] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    // What the PLATFORM can do, as opposed to what this person may do. Read in
    // the same document as the memberships because the registration wizard needs
    // it before it can decide whether to offer a form at all, and a second round
    // trip at that moment would be a form that flickers.
    const [capabilities, setCapabilities] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        multiFounder: false
    });
    const [access, setAccess] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [switching, setSwitching] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [accessChanged, setAccessChanged] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // The transport must know the clinic BEFORE the first request of a route goes
    // out, so this is a layout effect rather than an effect: an ordinary effect
    // runs after paint, and a child's mount-time query would already have been
    // sent with the previous clinic's header.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(()=>{
        (0, $1k2zw.setActiveClinicRef)(routeRef);
    }, [
        routeRef
    ]);
    const load = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ({ silent: silent = false } = {})=>{
        if (!silent) setState($ceaf0727c9907991$export$eab765f73d387158.LOADING);
        try {
            let data;
            try {
                data = await (0, $2Mst8.bffQuery)($ceaf0727c9907991$var$BOOTSTRAP, {}, 'ClinicBootstrap');
            } catch (err) {
                if (err.extensions?.code !== 'CLINIC_FORBIDDEN') throw err;
                // ASK AGAIN WITHOUT NAMING A CLINIC.
                //
                // The BFF refuses a clinic the caller does not belong to in its `context`,
                // BEFORE any resolver runs — so the refusal lands on every operation in the
                // request, this bootstrap included. That is the right call for clinic-scoped
                // data and the wrong outcome here: the one query that could tell this person
                // which clinics they DO belong to is the query being refused, leaving an
                // empty list, a «not a member» wall, and no clinic to offer as a way out.
                //
                // The answer is person-scoped, so asking for it without a clinic is always
                // safe and never widens what is served. The gate then renders the SAME named
                // 403 — but with a working button to a clinic they really do have.
                data = await $ceaf0727c9907991$export$578e157f63c54b59(()=>(0, $2Mst8.bffQuery)($ceaf0727c9907991$var$BOOTSTRAP, {}, 'ClinicBootstrap'));
            }
            const list = data?.myMemberships || [];
            setMemberships(list);
            // Absent (an older BFF) reads as false, which is the safe direction: the
            // wizard refuses a second clinic with an explanation rather than walking
            // a founder into a `clinics_pkey` collision.
            setCapabilities({
                multiFounder: data?.platformCapabilities?.multiFounder === true
            });
            setAccess(data?.myAccess || null);
            (0, $1k2zw.resetAccessVersion)(data?.myAccess?.version || '');
            setAccessChanged(false);
            setError('');
            if (!list.length) {
                setState($ceaf0727c9907991$export$eab765f73d387158.NONE);
                return list;
            }
            if (!list.some((m)=>m.enterable)) {
                setState($ceaf0727c9907991$export$eab765f73d387158.PENDING_ONLY);
                return list;
            }
            setState($ceaf0727c9907991$export$eab765f73d387158.READY);
            return list;
        } catch (err) {
            if (err.extensions?.code === 'UNAUTHENTICATED' || err.status === 401) {
                (0, $58BYB.redirectToLogin)();
                return [];
            }
            // A clinic the caller does not belong to is NOT a boot failure — the panel
            // is fine, this URL is not. Reached only when the retry above ALSO failed.
            if (err.extensions?.code === 'CLINIC_FORBIDDEN') {
                setError('');
                setState($ceaf0727c9907991$export$eab765f73d387158.READY);
                return memberships;
            }
            console.warn('[ClinicContext] bootstrap failed:', err.message);
            setError(err.message || '');
            setState($ceaf0727c9907991$export$eab765f73d387158.ERROR);
            return [];
        }
    }, [
        memberships
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        load(); /* once */ 
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    // Re-resolve access when the route names a different clinic. The membership list
    // is person-scoped and does not change; `myAccess` is clinic-scoped and does.
    const lastResolved = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef('');
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (state !== $ceaf0727c9907991$export$eab765f73d387158.READY || !routeRef) return;
        if (lastResolved.current === routeRef) return;
        lastResolved.current = routeRef;
        if (access?.clinicId && $ceaf0727c9907991$export$22dfc04513b3ff1c(memberships, routeRef)?.clinicId === access.clinicId) return;
        load({
            silent: true
        });
    }, [
        routeRef,
        state,
        memberships,
        access,
        load
    ]);
    // A role change reaches an already-open session here (§5.10, §A8). Non-blocking
    // on purpose: a receptionist halfway through an invoice decides when the ground
    // moves, and a silent re-render under their hands is the wrong answer.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>(0, $1k2zw.onAccessVersionChange)(()=>setAccessChanged(true)), []);
    const activeMembership = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>$ceaf0727c9907991$export$22dfc04513b3ff1c(memberships, routeRef), [
        memberships,
        routeRef
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (activeMembership?.enterable) (0, $1k2zw.rememberLastClinic)($ceaf0727c9907991$export$4d480254ae72c2a9(activeMembership));
    }, [
        activeMembership
    ]);
    const enterable = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>memberships.filter((m)=>m.enterable), [
        memberships
    ]);
    // The currency the active clinic keeps its books in (docs/clinic-currency/
    // CONTRACTS.md §10). Every clinic-money figure on every screen is formatted,
    // labelled and parsed in it — <CurrencyProvider> below hands it to
    // `useTranslation()`. No clinic in the route (the switcher, onboarding) and an
    // older BFF without the field both read IRR, which is what every clinic was.
    const currency = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $k7W79.clinicCurrencyOf)(activeMembership?.currency), [
        activeMembership
    ]);
    // …and the wall clock it works by (PM-0088). Every date, time and «امروز» of
    // this clinic is on it — the formatters through <CurrencyProvider timeZone>,
    // the date arithmetic (dateRange.js, the booking grid) through the clinicZone
    // mirror. Mirrored DURING render, not in an effect: a child computing «امروز»
    // on its first render must already see this clinic's clock. Idempotent.
    const timeZone = activeMembership?.timezone || (0, $5qKOB.DEFAULT_TIMEZONE);
    (0, $5qKOB.setClinicZone)(timeZone);
    /**
   * Where should a bare `/` go? (§A3 — and note what is NOT here: the switcher
   * never auto-opens. `myMemberships` is ordered most-recently-active first by the
   * server, so even a fresh browser lands somewhere sensible.)
   */ const defaultRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const remembered = $ceaf0727c9907991$export$22dfc04513b3ff1c(enterable, (0, $1k2zw.readLastClinic)());
        return $ceaf0727c9907991$export$4d480254ae72c2a9(remembered || enterable[0] || null);
    }, [
        enterable
    ]);
    /**
   * Switch clinics.
   *
   * Revert-on-failure is the property that matters: validation happens BEFORE the
   * URL moves, so a switch that cannot proceed leaves the person exactly where they
   * were rather than stranded on a route that will not resolve.
   */ const switchClinic = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (ref)=>{
        const target = $ceaf0727c9907991$export$22dfc04513b3ff1c(memberships, ref);
        if (!target || !target.enterable) return false;
        if ($ceaf0727c9907991$export$4d480254ae72c2a9(target) === routeRef) return true;
        setSwitching($ceaf0727c9907991$export$4d480254ae72c2a9(target));
        // Asks the open screen first. A switch discards the tree by design, but
        // discarding a half-typed patient without a word is not the same thing as
        // discarding stale data — and it is the same keystroke, so the screen with the
        // work open is the only thing that can tell them apart (§A11).
        (0, $1k2zw.guardedSwitch)(()=>{
            // Clinic-scoped module state that the tree remount cannot reach on its own.
            // The paywall is the sharp one: it is a module singleton, so switching from
            // a lapsed clinic to a paid one would carry the dialog across (E11).
            (0, $jG8cU.resetPaywall)();
            (0, $1k2zw.resetAccessVersion)('');
            (0, $1k2zw.rememberLastClinic)($ceaf0727c9907991$export$4d480254ae72c2a9(target));
            navigate(`/c/${$ceaf0727c9907991$export$4d480254ae72c2a9(target)}/`, {
                replace: false
            });
        });
        setSwitching('');
        return true;
    }, [
        memberships,
        routeRef,
        navigate
    ]);
    /**
   * Finish a half-applied createClinic saga (§A9), then refresh the token.
   *
   * The refresh is not optional: the repair grants a Keycloak role, and the
   * session is holding a token issued before that grant existed. Without it the
   * very next request is FORBIDDEN and the repair looks like it failed.
   */ const repairSetup = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (clinicId)=>{
        await (0, $2Mst8.bffMutation)($ceaf0727c9907991$var$REPAIR, {
            clinicId: clinicId
        }, 'RepairClinicSetup');
        await (0, $58BYB.refreshAccessToken)();
        return load({
            silent: true
        });
    }, [
        load
    ]);
    /** Adopt new grants after accepting an invitation or creating a clinic (§A8). */ const refreshGrants = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        await (0, $58BYB.refreshAccessToken)();
        return load({
            silent: true
        });
    }, [
        load
    ]);
    const value = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
            state: state,
            memberships: memberships,
            capabilities: capabilities,
            enterable: enterable,
            activeMembership: activeMembership,
            currency: currency,
            timeZone: timeZone,
            activeRef: routeRef,
            defaultRef: defaultRef,
            access: access,
            error: error,
            switching: switching,
            accessChanged: accessChanged,
            dismissAccessChange: ()=>setAccessChanged(false),
            canSwitch: enterable.length > 1,
            pendingInvitations: memberships.filter($ceaf0727c9907991$export$e934de5998b52b20),
            switchClinic: switchClinic,
            repairSetup: repairSetup,
            refreshGrants: refreshGrants,
            reload: load
        }), [
        state,
        memberships,
        capabilities,
        enterable,
        activeMembership,
        currency,
        timeZone,
        routeRef,
        defaultRef,
        access,
        error,
        switching,
        accessChanged,
        switchClinic,
        repairSetup,
        refreshGrants,
        load
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ceaf0727c9907991$var$ClinicCtx.Provider, {
        value: value,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aBaxB.default), {
            currency: currency,
            timeZone: timeZone,
            children: children
        })
    });
}
var $ceaf0727c9907991$export$2e2bcd8739ae039 = $ceaf0727c9907991$export$ed5bcf87c5db8fb3;

});


parcelRegister("d7OV8", function(module, exports) {

$parcel$export(module.exports, "onAppointmentsChanged", () => $98e36d8cc4344909$export$e3c2c15ecf8b4ad4);
$parcel$export(module.exports, "reportAppointmentsChanged", () => $98e36d8cc4344909$export$bbf6ac4f8a6a861c);
/**
 * Appointments signal — how a booking or a check-in made OUTSIDE the پذیرش screen
 * reaches the day list that is showing those rows.
 *
 * The «منشی هوشمند» overlay is mounted in the shell and can mark a patient arrived
 * or book an appointment while پذیرش is the screen underneath. پذیرش polls every
 * 20 seconds, so without this the desk would press «ثبت حضور», watch the overlay
 * close, and see the row unchanged — which reads as «it did not work».
 *
 * Shaped like `paywallSignal.js`: a module-level subscriber set, because the
 * producer and the consumer share no React parent worth threading a context
 * through. It carries no payload on purpose — the listener re-reads from the
 * server, which is the only copy of the truth.
 */ const $98e36d8cc4344909$var$listeners = new Set();
function $98e36d8cc4344909$export$e3c2c15ecf8b4ad4(handler) {
    if (typeof handler !== 'function') return ()=>{};
    $98e36d8cc4344909$var$listeners.add(handler);
    return ()=>$98e36d8cc4344909$var$listeners.delete(handler);
}
function $98e36d8cc4344909$export$bbf6ac4f8a6a861c() {
    for (const handler of Array.from($98e36d8cc4344909$var$listeners))try {
        handler();
    } catch (err) {
        console.error('appointments listener failed:', err);
    }
}

});

parcelRegister("b3FwQ", function(module, exports) {

$parcel$export(module.exports, "isOnlineSource", () => $80d03049006240fe$export$36137b2984e9f015);
$parcel$export(module.exports, "onlineSourceHintKey", () => $80d03049006240fe$export$ae6c88aab8ccde06);
/**
 * Where an appointment came from — `Appointment.source`, scheduling's word, carried
 * as-is by the clinic BFF and on the realtime frame.
 *
 *   desk | phone | api | store | doctor_app      — the clinic or a practitioner booked it
 *   patient_app | doctor_page                    — the PATIENT booked it themselves
 *
 * The second pair is «آنلاین» on the reception row and the «نوبت آنلاین جدید» toast
 * (PM-0382, docs/DOCTOR_PAGE_INSTANT_BOOKING_PLAN.md §4.8). Since 2026-10-19 such a
 * booking is always confirmed, so this is the desk's only cue that nobody at the
 * clinic made it. One set, here, for both — a second copy is how the chip and the
 * toast would come to disagree about one row.
 *
 * The LABELS are not here (the panel is multilingual): `reception.online.*`.
 */ const $80d03049006240fe$export$2443637c15bbc4e1 = Object.freeze([
    'patient_app',
    'doctor_page'
]);
function $80d03049006240fe$export$36137b2984e9f015(source) {
    return $80d03049006240fe$export$2443637c15bbc4e1.includes(String(source || '').trim().toLowerCase());
}
function $80d03049006240fe$export$ae6c88aab8ccde06(source) {
    const s = String(source || '').trim().toLowerCase();
    if (s === 'doctor_page') return 'reception.online.fromDoctorPage';
    if (s === 'patient_app') return 'reception.online.fromPatientApp';
    return null;
}

});

parcelRegister("bDP1h", function(module, exports) {

$parcel$export(module.exports, "useClinicEvents", () => $879ae9a678429f97$export$b97cef3b55b15a21);

var $acw62 = parcelRequire("acw62");

var $iAkVL = parcelRequire("iAkVL");

var $1k2zw = parcelRequire("1k2zw");

var $58BYB = parcelRequire("58BYB");
function $879ae9a678429f97$export$b97cef3b55b15a21(types, onEvent, { enabled: enabled = true } = {}) {
    const [connected, setConnected] = (0, $acw62.useState)(false);
    // The handler is read through a ref so a fresh closure every render does not
    // tear the socket down and build another one.
    const handlerRef = (0, $acw62.useRef)(onEvent);
    handlerRef.current = onEvent;
    const typesRef = (0, $acw62.useRef)(types);
    typesRef.current = types;
    (0, $acw62.useEffect)(()=>{
        if (!enabled) return undefined;
        const token = (0, $58BYB.getToken)();
        if (!token) return undefined;
        let socket = null;
        let closed = false;
        let retry = null;
        let backoff = 2000;
        const open = ()=>{
            if (closed) return;
            const clinic = (0, $1k2zw.getActiveClinicRef)() || '';
            const url = `${(0, $iAkVL.BFF_WS_BASE)}/ws/events?token=${encodeURIComponent(token)}` + `&clinic=${encodeURIComponent(clinic)}`;
            try {
                socket = new WebSocket(url);
            } catch  {
                // A URL the browser refuses outright is not worth a retry loop.
                return;
            }
            socket.onopen = ()=>{
                backoff = 2000;
                setConnected(true);
            };
            socket.onmessage = (evt)=>{
                let payload;
                try {
                    payload = JSON.parse(evt.data);
                } catch  {
                    return;
                }
                const type = payload?.type;
                if (!type || type === 'connected') return;
                const wanted = typesRef.current;
                if (wanted && wanted.length && !wanted.includes(type)) return;
                handlerRef.current?.(payload);
            };
            socket.onclose = (e)=>{
                setConnected(false);
                socket = null;
                // 4003 is «this person has no clinic here» — a refresh cannot fix it, so
                // reconnecting in a loop would only hammer the BFF with the same answer.
                if (closed || e?.code === 4003 || e?.code === 4001) return;
                retry = setTimeout(open, backoff);
                backoff = Math.min(backoff * 2, 30000);
            };
            socket.onerror = ()=>{};
        };
        open();
        return ()=>{
            closed = true;
            clearTimeout(retry);
            try {
                socket?.close();
            } catch  {}
        };
    }, [
        enabled
    ]);
    return {
        connected: connected
    };
}
var $879ae9a678429f97$export$2e2bcd8739ae039 = $879ae9a678429f97$export$b97cef3b55b15a21;

});

parcelRegister("2XwcZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fa705b4b24684ba$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $6fa705b4b24684ba$export$a2387ed3b5d536eb = {
    name: "download",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M12 15V3",
                key: "m9g1x1"
            }
        ],
        [
            "path",
            {
                d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4",
                key: "ih7n3h"
            }
        ],
        [
            "path",
            {
                d: "m7 10 5 5 5-5",
                key: "brsn70"
            }
        ]
    ]
};
$6fa705b4b24684ba$export$a2387ed3b5d536eb.node;
const $6fa705b4b24684ba$export$2e2bcd8739ae039 = (0, $9QBug.default)($6fa705b4b24684ba$export$a2387ed3b5d536eb);

});

parcelRegister("2xQve", function(module, exports) {

$parcel$export(module.exports, "ROW_PAD", () => $1da763d02f84081e$export$8a48986b879a7651);
$parcel$export(module.exports, "STACK", () => $1da763d02f84081e$export$eb2d9c399334e95b);
$parcel$export(module.exports, "PANEL_PAD", () => $1da763d02f84081e$export$2295e056c5b8b159);
/**
 * Compact density scale — the clinic app's third UI commitment
 * (clinic-app/CLAUDE.md §4.3: نمایش حداکثر داده‌ها در یک صفحه).
 *
 * The clinic app runs tighter than the doctor app and much tighter than the patient
 * app, on purpose: a پذیرش desk works a list of forty rows all day on a wide fixed
 * monitor, and every row that falls below the fold is a scroll the operator pays for
 * dozens of times a shift.
 *
 * The rule this file exists to enforce is "density comes from a scale, not from
 * hand-picked pixels". Before this, every table wrote its own `padding: '11px 14px'`
 * and no two agreed, so tightening a screen meant hunting magic numbers and the
 * result drifted apart again on the next change.
 *
 * Sourcing: `@parsina/framework` has no density scale yet, so this lives at layer 2
 * (app-shared) per the DESIGN.md hierarchy. Promote it to the framework — do not
 * copy it — the moment the doctor or patient app needs the same scale.
 */ /** Table/list row padding, block × inline. */ const $1da763d02f84081e$export$8a48986b879a7651 = {
    /** Operational lists — the day panel, the cash desk queue. The default here. */ compact: '8px 12px',
    /** Lists whose rows carry two lines of text or an avatar. */ regular: '11px 14px'
};
const $1da763d02f84081e$export$eb2d9c399334e95b = {
    tight: 8,
    regular: 12
};
const $1da763d02f84081e$export$2295e056c5b8b159 = {
    compact: '10px 16px',
    regular: '14px 24px',
    /**
   * The pre-membership card body — «شروع», the registration wizard, the
   * invitation landing.
   *
   * The only place in this app that is deliberately LESS dense than the rest,
   * and the reason is that it is not an operational screen: it is seen once,
   * by someone who has never used the product, and it holds a form rather than
   * a list of forty rows. Density there buys nothing (there is no second
   * screenful to fit) and costs the one impression the product gets. It is
   * still a step on the scale rather than a hand-picked pixel pair, which is
   * the rule this file exists to keep.
   */ roomy: '20px 28px'
};

});

parcelRegister("ca2To", function(module, exports) {

$parcel$export(module.exports, "moduleLabel", () => $8da8a99c6549b82b$export$74d856422401865d);
$parcel$export(module.exports, "permissionLabel", () => $8da8a99c6549b82b$export$f4806cd10d1d7d3a);
$parcel$export(module.exports, "permissionDescription", () => $8da8a99c6549b82b$export$7ac26f5df793f583);
$parcel$export(module.exports, "roleTemplateLabel", () => $8da8a99c6549b82b$export$c7116465c16889dc);
/**
 * The permission catalog's copy, in the reader's language.
 *
 * `permissionCatalog` arrives from the BFF with `moduleFa`, `labelFa` and
 * `descriptionFa` — Persian, from `parsina.bff.clinic/src/auth/permissionCatalog.js`.
 * That was the whole story while the panel was Persian-only; with a second
 * language it means the RBAC screen reads Persian in the middle of an English
 * one, and the string audit cannot see it because there is no Persian in this
 * app's source.
 *
 * The catalog already carries a stable `key` and `module`, so the fix is here
 * rather than on the wire: translate from the key, and **fall back to the
 * server's own label** for anything this catalogue has not got.
 *
 * The fallback is not defensive padding. Permission keys are platform-owned
 * (clinic-app/CLAUDE.md §6.3): adding one is a release, and a client deployed
 * against a NEWER BFF will legitimately see a key it has no copy for. Showing
 * the server's Persian is right there — a permission a person cannot read at all
 * is a permission they cannot grant, and «مشاهدهٔ گزارش‌ها» on an English screen
 * is a smaller problem than a blank row in a role editor.
 *
 * When a key IS added: mirror it into `people.permissions.<key>.{label,description}`
 * in every locale. `i18nCoverage.test.js` catches the second half of that (a key
 * in one catalogue and not the other); nothing can catch the first half, because
 * the source of truth is a different repository.
 */ /**
 * The module heading a group of permissions sits under.
 * `people.modules.<module>`, falling back to the server's `moduleFa`.
 */ const $8da8a99c6549b82b$export$74d856422401865d = (perm, t, has)=>has(`people.modules.${perm.module}`) ? t(`people.modules.${perm.module}`) : perm.moduleFa;
const $8da8a99c6549b82b$export$f4806cd10d1d7d3a = (perm, t, has)=>has(`people.permissions.${perm.key}.label`) ? t(`people.permissions.${perm.key}.label`) : perm.labelFa;
const $8da8a99c6549b82b$export$7ac26f5df793f583 = (perm, t, has)=>has(`people.permissions.${perm.key}.description`) ? t(`people.permissions.${perm.key}.description`) : perm.descriptionFa;
const $8da8a99c6549b82b$export$c7116465c16889dc = (template, t, has)=>has(`people.roleTemplates.${template.key}`) ? t(`people.roleTemplates.${template.key}`) : template.nameFa;

});

parcelRegister("9SI14", function(module, exports) {

$parcel$export(module.exports, "useCreditPurchase", () => $731b4ceb5faa7ddf$export$2f04c8775b039db);

var $acw62 = parcelRequire("acw62");

var $eLeza = parcelRequire("eLeza");

var $2Mst8 = parcelRequire("2Mst8");
const $731b4ceb5faa7ddf$export$915351dbbb5c0821 = `
  query CreditPurchase {
    creditPrices {
      purchaseAvailable
      creditPrice { amountMinor currency }
    }
  }
`;
let $731b4ceb5faa7ddf$var$answer = null; // { purchaseAvailable, currency } once the BFF has said
let $731b4ceb5faa7ddf$var$inflight = null;
const $731b4ceb5faa7ddf$var$listeners = new Set();
const $731b4ceb5faa7ddf$var$emit = ()=>{
    for (const fn of $731b4ceb5faa7ddf$var$listeners)fn();
};
function $731b4ceb5faa7ddf$export$34eacae788ce613f(list) {
    if (!list || typeof list.purchaseAvailable !== 'boolean') return null;
    const currency = typeof list.creditPrice?.currency === 'string' ? list.creditPrice.currency.trim() : '';
    return {
        purchaseAvailable: list.purchaseAvailable,
        currency: currency
    };
}
function $731b4ceb5faa7ddf$export$78f6d7cf90cacc26() {
    if (!$731b4ceb5faa7ddf$var$answer) return (0, $eLeza.isIranMarket)();
    return $731b4ceb5faa7ddf$var$answer.purchaseAvailable && (!$731b4ceb5faa7ddf$var$answer.currency || $731b4ceb5faa7ddf$var$answer.currency === 'IRT');
}
function $731b4ceb5faa7ddf$export$2df444f87362e5a5() {
    if ($731b4ceb5faa7ddf$var$answer) return Promise.resolve($731b4ceb5faa7ddf$var$answer);
    if ($731b4ceb5faa7ddf$var$inflight) return $731b4ceb5faa7ddf$var$inflight;
    $731b4ceb5faa7ddf$var$inflight = Promise.resolve().then(()=>(0, $2Mst8.bffQuery)($731b4ceb5faa7ddf$export$915351dbbb5c0821)).then((data)=>{
        const said = $731b4ceb5faa7ddf$export$34eacae788ce613f(data?.creditPrices);
        if (said) {
            $731b4ceb5faa7ddf$var$answer = said;
            $731b4ceb5faa7ddf$var$emit();
        }
    }).catch(()=>{}).finally(()=>{
        $731b4ceb5faa7ddf$var$inflight = null;
    }).then(()=>$731b4ceb5faa7ddf$var$answer);
    return $731b4ceb5faa7ddf$var$inflight;
}
function $731b4ceb5faa7ddf$export$d51d6df99f007850() {
    $731b4ceb5faa7ddf$var$answer = null;
    $731b4ceb5faa7ddf$var$inflight = null;
    $731b4ceb5faa7ddf$var$emit();
}
const $731b4ceb5faa7ddf$var$subscribe = (fn)=>{
    $731b4ceb5faa7ddf$var$listeners.add(fn);
    return ()=>$731b4ceb5faa7ddf$var$listeners.delete(fn);
};
const $731b4ceb5faa7ddf$var$snapshot = ()=>$731b4ceb5faa7ddf$var$answer;
function $731b4ceb5faa7ddf$export$2f04c8775b039db(load = true) {
    (0, $acw62.useSyncExternalStore)($731b4ceb5faa7ddf$var$subscribe, $731b4ceb5faa7ddf$var$snapshot, $731b4ceb5faa7ddf$var$snapshot);
    (0, $acw62.useEffect)(()=>{
        if (load) $731b4ceb5faa7ddf$export$2df444f87362e5a5();
    }, [
        load
    ]);
    return $731b4ceb5faa7ddf$export$78f6d7cf90cacc26();
}
var $731b4ceb5faa7ddf$export$2e2bcd8739ae039 = $731b4ceb5faa7ddf$export$2f04c8775b039db;

});

parcelRegister("9h2jQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c07801531f3f7c9$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useResponsive", () => (parcelRequire("k27hS")).default);
/**
 * The ≤768px switch every `X.mobile.jsx` fork is chosen by.
 *
 * This used to be a local implementation — `window.innerWidth` read at hook
 * init plus a `resize` listener — sitting beside a byte-identical copy in
 * `@parsina/framework`. Two implementations of "is this a phone" is one more
 * than a product can have: the framework's own components (`AccountCard`'s
 * `overlay="auto"`, `AuthShell`) switch on the KIT's answer, so a divergence
 * of even one pixel renders a screen half in each mode.
 *
 * The kit's version is also the better one: it listens on `matchMedia` rather
 * than `resize` (no layout read per resize frame, and it fires on an
 * orientation change that does not alter `innerWidth`), and it guards for a
 * missing `window` instead of throwing at import time.
 *
 * 768 is the ONLY mobile boundary in this app — `styles.css`'s media block and
 * the shell fork in `ClinicLayout.jsx` key off the same number.
 * See docs/MOBILE-REDESIGN.md §3.1.
 */ parcelRequire("5N0ZI");
var $k27hS = parcelRequire("k27hS");
var $6c07801531f3f7c9$export$2e2bcd8739ae039 = (0, $k27hS.default);

});

parcelRegister("a0Xuh", function(module, exports) {

$parcel$export(module.exports, "default", () => $33d381b447744a2f$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $acw62 = parcelRequire("acw62");
parcelRequire("52bn2");
var $jTCZr = parcelRequire("jTCZr");

var $bDmHD = parcelRequire("bDmHD");

var $2Mst8 = parcelRequire("2Mst8");

var $c2icR = parcelRequire("c2icR");

var $2MpEq = parcelRequire("2MpEq");

var $6P09x = parcelRequire("6P09x");

var $lM08I = parcelRequire("lM08I");

var $PQAaX = parcelRequire("PQAaX");

var $7GAiB = parcelRequire("7GAiB");

var $ciRrJ = parcelRequire("ciRrJ");

var $gnVfo = parcelRequire("gnVfo");

var $94n92 = parcelRequire("94n92");

var $338ed = parcelRequire("338ed");

var $jssTS = parcelRequire("jssTS");

var $gXHpd = parcelRequire("gXHpd");

var $58VTS = parcelRequire("58VTS");

var $5qKOB = parcelRequire("5qKOB");
parcelRequire("5N0ZI");
var $4fYdd = parcelRequire("4fYdd");

var $eatxv = parcelRequire("eatxv");

var $j5293 = parcelRequire("j5293");

var $3fdwV = parcelRequire("3fdwV");
// «تأیید با زمان دیگر» commits the EXISTING row rather than creating a second one
// beside the request the patient is still waiting on.
const $33d381b447744a2f$var$CONFIRM_REQUEST = `
  mutation ConfirmAppointmentRequest($appointmentId: ID!, $newDateTime: String) {
    confirmAppointmentRequest(appointmentId: $appointmentId, newDateTime: $newDateTime) { id status dateTime }
  }
`;
// «ویرایش نوبت» (PM-0102). Two documents for the same reason booking has two: only
// a move that asked for a notice selects what each channel did.
const $33d381b447744a2f$var$RESCHEDULE_APPOINTMENT = `
  mutation RescheduleAppointment($appointmentId: ID!, $newDateTime: String!) {
    rescheduleAppointment(appointmentId: $appointmentId, newDateTime: $newDateTime) { id status dateTime }
  }
`;
const $33d381b447744a2f$var$RESCHEDULE_APPOINTMENT_NOTIFYING = `
  mutation RescheduleAppointmentNotifying($appointmentId: ID!, $newDateTime: String!, $notifyChannels: [String!], $notifyBody: String) {
    rescheduleAppointment(appointmentId: $appointmentId, newDateTime: $newDateTime, notifyChannels: $notifyChannels, notifyBody: $notifyBody) {
      id status dateTime
      notifications { channel status reason detail cost }
    }
  }
`;
const $33d381b447744a2f$var$SET_APPOINTMENT_NOTE = `
  mutation SetAppointmentNote($appointmentId: ID!, $note: String!) {
    setAppointmentNote(appointmentId: $appointmentId, note: $note) { id reminderNote }
  }
`;
function $33d381b447744a2f$export$2e2bcd8739ae039({ presetDoctorId: presetDoctorId, initialDate: initialDate, onClose: onClose, onBooked: onBooked, confirmRequest: // An AppointmentRequest row (from `appointmentRequests`). Present ⇒ this modal
// is «تأیید با زمان دیگر»: the practitioner and the patient are already
// decided, only the time is open, and committing CONFIRMS the request.
confirmRequest = null, presetPatient: // ── Opened PREFILLED by «منشی هوشمند» (src/secretary/SecretaryHost.jsx) ──────
// `presetPatient` ({ id, name, phone }) is a patient already decided, shown as
// the same identity line a confirmation shows; `initialSlotLabel` ("HH:MM" on
// the clinic's clock) pre-selects a time on `initialDate`; `notice` is rendered
// above the form — it is where the «پیشنهاد هوش مصنوعی» statement lives. This is
// still an ordinary booking: the desk can change anything, and submit is the
// same createAppointment as always.
presetPatient = null, presetNewPatient: // `presetNewPatient` ({ name }) is a patient the clinic has NO record of — the
// secretary heard a name nobody here has. The form opens on «بیمار جدید» with the
// name filled in and the mobile next; its own submit registers them, as always.
presetNewPatient = null, initialSlotLabel: initialSlotLabel = null, notice: notice = null, reschedule: // ── «ویرایش نوبت» (PM-0102) ────────────────────────────────────────────────
// `{ appointment: { id, doctorId, doctorName, dateTime, time, note }, patient:
// { id, name, phone } }` — a row of the day list. Present ⇒ this modal EDITS
// that appointment: the practitioner and the patient are the row's, the time
// and the note are open, and committing moves the existing row
// (`rescheduleAppointment`) and/or rewrites its note — never a second نوبت.
reschedule = null, onNeedsShift: // (retry) => void — a CASH «پیش‌پرداخت» refused with NO_OPEN_SHIFT (PM-0657
// §6.2): the caller opens a drawer and runs `retry`, which records the SAME
// deposit (same request id) for the نوبت already booked.
onNeedsShift = null }) {
    const { formatDate: formatDate, formatTime: formatTime } = (0, $e1LEq.default)();
    const { formatDigits: formatDigits, t: t } = (0, $e1LEq.default)();
    const { doctors: doctors, loading: loading, acceptDoctor: acceptDoctor } = (0, $bDmHD.useClinicDoctors)();
    // Same eligibility rule as the Doctors screen: only accepted, active links are bookable.
    const bookable = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(doctors || []).filter((d)=>d.status === 'accepted' && d.active !== false), [
        doctors
    ]);
    // Links still waiting for the clinic's approval: the «اتصال پزشک» modal offers
    // to accept them in place, and `bookable` picks the doctor up on the next render.
    const pending = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(doctors || []).filter((d)=>d.status && d.status !== 'accepted'), [
        doctors
    ]);
    // ── The services the clinic books, and who performs them (PM-0468, PM-0600) ──
    // A fresh booking reads the same `bookableServices` the service-first dialog did,
    // so the picker below lists every PERFORMER — a coworker who performs a service
    // as well as a doctor — and the form under it offers that person's services on
    // the slot engine. A confirmation and an edit stay on the row's own practitioner
    // and the old grid. A read that fails costs only the engine: the doctors are
    // still bookable as before.
    const fresh = !reschedule && !confirmRequest;
    const svc = (0, $jssTS.useBookableServices)({
        enabled: fresh
    });
    const groups = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $gXHpd.groupBookableServices)(svc.services), [
        svc.services
    ]);
    const entries = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>[
            ...groups.visits,
            ...groups.services
        ], [
        groups
    ]);
    const people = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (!fresh) return [];
        const out = new Map();
        for (const d of bookable)out.set(`DOCTOR:${d.doctorId}`, {
            key: `DOCTOR:${d.doctorId}`,
            type: 'DOCTOR',
            id: d.doctorId,
            name: d.doctorName || '',
            role: ''
        });
        for (const e of entries)for (const p of e.performers){
            // A doctor whose clinic link is not accepted is not bookable, whatever a service says.
            if (p.type === 'DOCTOR' && !out.has(p.key)) continue;
            if (!out.has(p.key)) out.set(p.key, {
                ...p,
                isDefault: false
            });
        }
        return [
            ...out.values()
        ];
    }, [
        fresh,
        bookable,
        entries
    ]);
    const entriesFor = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((p)=>p ? entries.filter((e)=>e.performers.some((q)=>q.key === p.key)) : [], [
        entries
    ]);
    // Each person's first free time today, on their first service — the chip line of
    // the service-first dialog, here under the name in the picker.
    const probeEntry = (p)=>{
        const mine = entriesFor(p);
        return mine.find((e)=>e.orderType === 'consultation') || mine[0] || null;
    };
    const perfFirst = (0, $58VTS.usePerformersFirstFree)(people.filter((p)=>probeEntry(p)), {
        enabled: fresh && svc.loaded && people.length > 1,
        catalogId: null,
        today: (0, $5qKOB.clinicTodayIso)(),
        minutesFor: (p)=>{
            const e = probeEntry(p);
            const doc = p.type === 'DOCTOR' ? bookable.find((d)=>d.doctorId === p.id) : null;
            return (0, $gXHpd.resolveDuration)(e, p, doc).minutes || (e?.schedulingMode === 'QUEUE' ? 15 : 30);
        }
    });
    const [docId, setDocId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(presetDoctorId || reschedule?.appointment?.doctorId || null);
    const [personKey, setPersonKey] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(presetDoctorId ? `DOCTOR:${presetDoctorId}` : null);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    // «پیش‌پرداخت» refused after the نوبت was booked: `{ id, said, wire, reason }`.
    // The booking STANDS; only the deposit is retried (PM-0657 §6.2).
    const [depositPending, setDepositPending] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [depositRetrying, setDepositRetrying] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // An `addPatient` refusal because the mobile carries records — handed back to the
    // modal, which owns the «بیمار جدید» form and shows the candidates inline.
    const [phoneConflict, setPhoneConflict] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // ── Slots a patient REQUEST is holding (E8) ────────────────────────────────
    //
    // A `requested` row occupies its slot exactly as a booked one does — that is
    // what «holds its slot» means in §7.1 — so booking over it would be refused by
    // the scheduling service's own overlap check. Read once when the modal opens
    // and handed to BookingModal as a warning rather than a filter: a slot that
    // silently disappears from the grid is a request the desk never learns about.
    const [heldSlots, setHeldSlots] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        let live = true;
        (0, $2Mst8.bffQuery)((0, $338ed.REQUESTS_QUERY), {
            state: 'open',
            limit: 200
        }).then((data)=>{
            if (!live) return;
            const held = new Map();
            for (const row of data?.appointmentRequests || []){
                const appt = row?.appointment;
                if (!appt?.dateTime) continue;
                const provider = appt.providerId || appt.doctorId || '';
                if (!held.has(provider)) held.set(provider, new Set());
                held.get(provider).add(String(appt.dateTime));
            }
            setHeldSlots(held);
        })// A read we could not make is not «no requests»: it simply means no
        // warning this time. The service still refuses the clash.
        .catch(()=>{
            if (live) setHeldSlots(null);
        });
        return ()=>{
            live = false;
        };
    }, []);
    // Registered here rather than on a local keydown so it takes precedence over the
    // پذیرش screen's own keys for exactly as long as this modal is mounted.
    // After a booking whose deposit failed, leaving is «بستن بدون پیش‌پرداخت»: the
    // نوبت exists, so the caller still hears that it was booked.
    (0, $ciRrJ.useShortcut)('esc', ()=>{
        if (depositPending) {
            const said = depositPending.said;
            setDepositPending(null);
            onBooked?.(said);
        }
        onClose();
    }, {
        label: t('common.actions.close'),
        group: t('reception.actions.book')
    });
    // An edit is on the row's OWN practitioner, whoever else is bookable — and still
    // on them when their link is no longer active: the نوبت exists, and the service
    // is what decides whether it may move. The picker is never a step of an edit.
    const editedDoctor = reschedule?.appointment?.doctorId ? (doctors || []).find((d)=>d.doctorId === reschedule.appointment.doctorId) || (loading ? null : {
        doctorId: reschedule.appointment.doctorId,
        doctorName: reschedule.appointment.doctorName || '',
        presences: []
    }) : null;
    // A fresh booking is for a PERSON of `people`; the doctor row (when they are one)
    // still carries the presences and the visit length the form reads.
    const person = fresh && !svc.loading ? people.find((p)=>p.key === personKey) || (people.length === 1 ? people[0] : null) : null;
    const personDoctor = person?.type === 'DOCTOR' ? bookable.find((d)=>d.doctorId === person.id) || null : null;
    const selected = reschedule ? editedDoctor : fresh ? person ? personDoctor || {
        doctorId: person.id,
        doctorName: person.name,
        presences: []
    } : null : bookable.find((d)=>d.doctorId === docId) || (bookable.length === 1 ? bookable[0] : null);
    const performer = fresh && person ? {
        type: person.type,
        id: person.id
    } : null;
    const personEntries = fresh ? entriesFor(person) : [];
    // The two writes of an edit, each only when its answer changed. The move goes
    // first: it is the one that can be refused, and a refused edit must not have
    // already rewritten the note.
    async function commitEdit({ dateTimeMs: dateTimeMs, notes: notes, notifyChannels: notifyChannels, notifyBody: notifyBody }) {
        const appt = reschedule.appointment;
        const who = reschedule.patient?.name || t('common.entity.patient');
        // A «خارج از نوبت» row's dateTime is its day's noon, not an hour: any hour the
        // desk picks is a change, 12:00 included (PM-0558).
        const moving = dateTimeMs != null && (appt.untimed || String(dateTimeMs) !== String(appt.dateTime));
        const note = String(notes || '').trim();
        const noteChanged = note !== String(appt.note || '').trim();
        const said = [];
        if (moving) {
            const notify = reschedule.patient?.id && notifyChannels?.length ? notifyChannels : null;
            const res = await (0, $2Mst8.bffMutation)(notify ? $33d381b447744a2f$var$RESCHEDULE_APPOINTMENT_NOTIFYING : $33d381b447744a2f$var$RESCHEDULE_APPOINTMENT, {
                appointmentId: appt.id,
                newDateTime: String(dateTimeMs),
                // The desk's own text (PM-0556) only when it wrote one: a BFF older than the
                // argument would refuse it, and an untouched editor has nothing to say.
                ...notify ? {
                    notifyChannels: notify,
                    ...notifyBody ? {
                        notifyBody: notifyBody
                    } : {}
                } : {}
            });
            const moved = res?.rescheduleAppointment;
            if (!moved?.id) throw new Error(t('reception.edit.failed'));
            said.push(t(appt.untimed ? 'reception.edit.timeSetTo' : 'reception.edit.movedTo', {
                who: who,
                when: (0, $7GAiB.fmtSlotLabel)(moved.dateTime || String(dateTimeMs), t, formatDate, formatTime)
            }));
            const notified = (0, $2MpEq.notificationSummary)(moved.notifications, t);
            if (notified) said.push(notified);
        }
        if (noteChanged) try {
            await (0, $2Mst8.bffMutation)($33d381b447744a2f$var$SET_APPOINTMENT_NOTE, {
                appointmentId: appt.id,
                note: note
            });
            if (!moving) said.push(t('reception.edit.noteSaved', {
                who: who
            }));
        } catch (e) {
            // The move, if there was one, is done and stays done; say which half failed.
            if (!moving) throw e;
            said.push(t('reception.edit.noteFailed'));
        }
        // Nothing changed: close without claiming anything was saved.
        onBooked?.(said.length ? said.join(" \xb7 ") : null);
        onClose();
    }
    async function handleSubmit({ patientInfo: patientInfo, placeholderLabel: placeholderLabel, dateTimeMs: dateTimeMs, notes: notes, type: type, firstAvailable: firstAvailable, services: services, notifyChannels: notifyChannels, notifyBody: notifyBody, untimed: untimed, serviceDeclarationId: serviceDeclarationId, insuranceChoice: insuranceChoice, serviceCatalogId: serviceCatalogId, allowOutsideServiceWindow: allowOutsideServiceWindow, deposit: deposit = null }) {
        setError('');
        try {
            if (reschedule?.appointment?.id) {
                await commitEdit({
                    dateTimeMs: dateTimeMs,
                    notes: notes,
                    notifyChannels: notifyChannels,
                    notifyBody: notifyBody
                });
                return;
            }
            // «تأیید با زمان دیگر»: one call, and it is a CONFIRMATION. The row already
            // exists, the patient is already on it, and the service re-validates
            // presence and overlap at the new instant exactly as it did at the first.
            if (confirmRequest?.appointment?.id) {
                const res = await (0, $2Mst8.bffMutation)($33d381b447744a2f$var$CONFIRM_REQUEST, {
                    appointmentId: confirmRequest.appointment.id,
                    newDateTime: String(dateTimeMs)
                });
                const confirmed = res?.confirmAppointmentRequest;
                if (!confirmed?.id) throw new Error(t('reception.requests.confirmFailed'));
                onBooked?.(t('reception.requests.confirmedAt', {
                    who: confirmRequest.patient?.name || t('common.entity.patient'),
                    when: (0, $7GAiB.fmtSlotLabel)(confirmed.dateTime || String(dateTimeMs), t, formatDate, formatTime)
                }));
                onClose();
                return;
            }
            // «ثبت سریع»: no patient is created — the appointment holds its slot on the label
            // alone, and the file is completed later from the day panel. Otherwise resolve a
            // real patient id, registering the بیمار جدید form if it has no id yet.
            let patientId, labelInput;
            if (placeholderLabel) labelInput = placeholderLabel;
            else {
                patientId = patientInfo.id;
                if (!patientId) {
                    const created = await (0, $2Mst8.bffMutation)((0, $c2icR.ADD_PATIENT), {
                        input: {
                            name: patientInfo.name,
                            phone: patientInfo.phone || undefined,
                            nationalId: patientInfo.nationalId || undefined,
                            fileNumber: patientInfo.fileNumber || undefined,
                            ...(0, $6P09x.phoneFlags)(patientInfo)
                        }
                    });
                    patientId = created?.addPatient?.id;
                    // The insurer is a POLICY, written against the id the creation just
                    // returned — `patients.insurance` is derived from it. Best-effort: the
                    // patient exists and the slot is about to be held, so a policy that
                    // fails to attach must not cost the booking. The proforma the booking
                    // raises will price uninsured, and check-in re-prices it.
                    if (patientId && patientInfo.insurerId) try {
                        await (0, $2Mst8.bffMutation)((0, $c2icR.SET_PATIENT_POLICY), {
                            input: {
                                patientId: patientId,
                                insurerId: patientInfo.insurerId,
                                kind: 'basic',
                                isPrimary: true
                            }
                        });
                    } catch (e) {
                        console.warn('[insurance] policy not attached at booking:', e?.message);
                    }
                }
                if (!patientId) throw new Error(t('errors.patients.createFailed'));
            }
            // With `firstAvailable` the dateTime is only an anchor — the server resolves
            // the real slot and returns it, so the toast reports what was actually booked.
            // Only a booking that names a patient AND asked for a notice selects what each
            // channel did — see CREATE_APPOINTMENT_NOTIFYING for why that is a second document.
            const notify = patientId && notifyChannels?.length ? notifyChannels : null;
            const res = await (0, $2Mst8.bffMutation)(notify ? (0, $c2icR.CREATE_APPOINTMENT_NOTIFYING) : (0, $c2icR.CREATE_APPOINTMENT), {
                input: {
                    patientId: patientId,
                    placeholderLabel: labelInput,
                    // A coworker performs a service on their own row: `performer` names them
                    // and doctorId stays empty; a doctor is both (PM-0468 §3.4).
                    ...performer?.type === 'STAFF' ? {} : {
                        doctorId: selected.doctorId
                    },
                    performer: performer || undefined,
                    // «خدمت نوبت» by its catalogue id: the booking is held to the shift rows
                    // that admit this service, and the desk's «ثبت شود» lets one hour past it.
                    serviceCatalogId: serviceCatalogId || undefined,
                    allowOutsideServiceWindow: allowOutsideServiceWindow || undefined,
                    dateTime: String(dateTimeMs),
                    type: type || 'in_person',
                    reminderNote: notes || undefined,
                    firstAvailable: firstAvailable || undefined,
                    // «خارج از نوبت» — DAY or NOW. Never sent alongside firstAvailable: the BFF
                    // refuses the pair, because one searches for a free hour and this is the
                    // booking that has none.
                    untimed: untimed || undefined,
                    // «خدمت نوبت» — stored ON the appointment and used to price the
                    // proforma's primary line, so the invoice bills what was booked
                    // (docs/CLINIC_RECEPTION_SERVICE_INVOICE_DESIGN.md §D1). Omitted, the
                    // BFF resolves the practitioner's own.
                    serviceDeclarationId: serviceDeclarationId || undefined,
                    // Priced onto the proforma the booking raises (target flow §1–§2).
                    services: services && services.length ? services : undefined,
                    // This visit's own insurance decisions — which بیمهٔ تکمیلی to skip and
                    // which معرفی‌نامه each pays under. Was collected by the modal and then
                    // dropped here, so a desk's choice never reached the proforma.
                    insuranceChoice: insuranceChoice || undefined,
                    notifyChannels: notify || undefined,
                    notifyBody: notify && notifyBody || undefined
                }
            });
            const booked = res?.createAppointment;
            if (!booked?.id) throw new Error(t('errors.reception.bookFailed'));
            const who = placeholderLabel || patientInfo.name || t('common.entity.patient');
            const bookedMsg = booked.dateTime ? t('reception.booking.bookedAt', {
                who: who,
                when: (0, $7GAiB.fmtSlotLabel)(booked.dateTime, t, formatDate, formatTime)
            }) : t('reception.booking.booked', {
                who: who
            });
            // What each channel did rides on the same toast: the desk reads one line, and a
            // notice that did not go is something they can still phone about.
            const notified = (0, $2MpEq.notificationSummary)(booked.notifications, t);
            const said = notified ? `${bookedMsg} \xb7 ${notified}` : bookedMsg;
            if (deposit && patientId) {
                await takeDeposit({
                    id: booked.id,
                    said: said,
                    wire: deposit
                });
                return;
            }
            onBooked?.(said);
            onClose();
        } catch (e) {
            const code = e?.extensions?.code;
            const phoneErr = (0, $6P09x.phoneRegistrationError)(e);
            if (phoneErr?.code === 'PHONE_HAS_PATIENTS') {
                // Nothing was created. The records go back to the form, which asks the desk.
                setPhoneConflict({
                    phone: patientInfo?.phone,
                    candidates: phoneErr.candidates
                });
                setError(t('patients.phoneCandidates.conflictOnSubmit'));
            } else if (phoneErr?.code === 'PHONE_REQUIRED') setError(t('validation.phone.requiredOrNone'));
            else if (code === 'NO_SLOT_AVAILABLE') setError(firstAvailable === 'ANY' ? t('reception.booking.noSlotIn30Days') : t('reception.booking.noSlotToday'));
            else if (code === 'APPOINTMENT_CONFLICT') setError(firstAvailable ? t('reception.booking.slotJustTaken') : t('reception.booking.doctorBusy'));
            else setError(e?.message || t(reschedule ? 'reception.edit.failed' : 'errors.reception.bookFailed'));
        }
    }
    // The deposit alone, for a نوبت already booked. Success closes with both said;
    // a refusal keeps the modal on «نوبت ثبت شد؛ پیش‌پرداخت ثبت نشد».
    async function takeDeposit(target) {
        try {
            await (0, $eatxv.recordAppointmentDeposit)({
                appointmentId: target.id,
                amountRial: target.wire.amountRial,
                paymentMethod: target.wire.paymentMethod,
                referenceNumber: target.wire.referenceNumber,
                requestId: target.wire.requestId
            });
            setDepositPending(null);
            onBooked?.(`${target.said} \xb7 ${t('reception.deposit.done.taken')}`);
            onClose();
        } catch (e) {
            setDepositPending({
                ...target,
                reason: (0, $3fdwV.moneyErrorText)(e, t) || t('errors.generic')
            });
            if (e?.extensions?.code === 'NO_OPEN_SHIFT' && onNeedsShift) onNeedsShift(()=>retryDeposit(target));
        }
    }
    async function retryDeposit(target = depositPending) {
        if (!target) return;
        setDepositRetrying(true);
        try {
            await takeDeposit(target);
        } finally{
            setDepositRetrying(false);
        }
    }
    const closeWithoutDeposit = ()=>{
        const said = depositPending?.said || null;
        setDepositPending(null);
        onBooked?.(said);
        onClose();
    };
    if (depositPending) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fYdd.Dialog), {
        open: true,
        onOpenChange: (o)=>{
            if (!o) closeWithoutDeposit();
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4fYdd.DialogContent), {
            size: "sm",
            "data-testid": "booking-deposit-failed-dialog",
            "data-booked-id": depositPending.id,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fYdd.DialogHeader), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fYdd.DialogTitle), {
                        children: t('reception.booking.deposit.title')
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fYdd.DialogBody), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $j5293.DepositAfterBookingFailed), {
                        reason: depositPending.reason,
                        retrying: depositRetrying,
                        onRetry: ()=>retryDeposit(),
                        onCloseWithout: closeWithoutDeposit
                    })
                })
            ]
        })
    });
    // ── Doctor chosen → the shared booking modal, anchored on today ──────────────
    if (selected) {
        const slotMin = selected.visitDurationMinutes || 30;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $PQAaX.default), {
                    doctor: {
                        id: selected.doctorId,
                        name: selected.doctorName || t('doctors.placeholder.unnamed', {
                            id: (selected.doctorId || '').slice(0, 6)
                        }),
                        color: (0, $lM08I.doctorColor)(selected.doctorId),
                        specialty: performer?.type === 'STAFF' ? (0, $gXHpd.performerKind)(person, t) : t('doctors.visitDuration', {
                            minutes: formatDigits(slotMin)
                        }),
                        presences: selected.presences || []
                    },
                    /* The slot ENGINE (PM-0600): this person's services, each on its own
             length and window. Absent — nothing the clinic declared names them —
             the form books on the doctor's shift as it always did. */ engine: performer && personEntries.length ? {
                        performer: performer,
                        entries: personEntries,
                        doctorRow: personDoctor
                    } : null,
                    initialDate: reschedule ? new Date(Number(reschedule.appointment.dateTime) || Date.now()) : initialDate ? new Date(initialDate) : new Date(),
                    initialSlotLabel: confirmRequest ? null : reschedule ? reschedule.appointment.untimed ? null : reschedule.appointment.time || null : initialSlotLabel,
                    notice: reschedule?.appointment?.untimed ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        "data-testid": "edit-appointment-current",
                        style: {
                            padding: '9px 12px',
                            borderRadius: 10,
                            fontSize: '0.78125rem',
                            lineHeight: 1.8,
                            background: (0, $jTCZr.C).bg,
                            color: (0, $jTCZr.C).textSecondary,
                            border: `1px solid ${(0, $jTCZr.C).border}`
                        },
                        children: t('reception.edit.setTimeHint')
                    }) : reschedule ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        "data-testid": "edit-appointment-current",
                        style: {
                            padding: '9px 12px',
                            borderRadius: 10,
                            fontSize: '0.78125rem',
                            lineHeight: 1.8,
                            background: (0, $jTCZr.C).bg,
                            color: (0, $jTCZr.C).textSecondary,
                            border: `1px solid ${(0, $jTCZr.C).border}`
                        },
                        children: [
                            t('reception.edit.currentTime', {
                                when: (0, $7GAiB.fmtSlotLabel)(reschedule.appointment.dateTime, t, formatDate, formatTime)
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            t('reception.edit.hint')
                        ]
                    }) : notice,
                    timeSlots: (0, $lM08I.buildDoctorSlots)(slotMin),
                    /* Auto-pick contradicts a confirmation: the patient asked for a time
             and the desk is choosing another one deliberately, not letting the
             server pick. An edit is the same deliberate choice. */ allowFirstAvailable: !confirmRequest && !reschedule,
                    lockedPatient: reschedule ? {
                        id: reschedule.patient?.id || null,
                        name: reschedule.patient?.name || '',
                        phone: reschedule.patient?.phone || ''
                    } : confirmRequest ? {
                        id: confirmRequest.patient?.id || confirmRequest.appointment?.patientId,
                        name: confirmRequest.patient?.name || '',
                        phone: confirmRequest.patient?.phone || ''
                    } : presetPatient?.id ? presetPatient : null,
                    presetNewPatient: !reschedule && !confirmRequest ? presetNewPatient : null,
                    editing: reschedule ? {
                        appointmentId: reschedule.appointment.id,
                        note: reschedule.appointment.note || '',
                        // «تعیین ساعت»: the form is for the hour, so it cannot be saved without one.
                        needsTime: !!reschedule.appointment.untimed,
                        title: reschedule.appointment.untimed ? t('reception.actions.setTime') : null
                    } : null,
                    submitLabel: reschedule ? t(reschedule.appointment.untimed ? 'reception.edit.setTimeSave' : 'reception.edit.save') : confirmRequest ? t('reception.requests.confirm') : null,
                    /* A «ثبت سریع» row has nobody to tell that its hour moved, and a
             «خارج از نوبت» row given its hour tells nobody (PM-0558). */ offerNotification: reschedule ? !!reschedule.patient?.id && !reschedule.appointment.untimed : !confirmRequest,
                    /* The request being confirmed holds its OWN slot; warning the desk
             about it would be warning them about the row they are moving. */ heldSlots: heldSlots ? new Set([
                        ...heldSlots.get(selected.doctorId) || []
                    ].filter((ms)=>ms !== String(confirmRequest?.appointment?.dateTime || ''))) : null,
                    phoneConflict: phoneConflict,
                    offerDeposit: fresh,
                    onClose: onClose,
                    onSubmit: handleSubmit
                }),
                error && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        position: 'fixed',
                        bottom: 24,
                        left: '50%',
                        transform: 'translateX(-50%)',
                        zIndex: 9000,
                        background: (0, $jTCZr.C).red,
                        color: '#fff',
                        borderRadius: 12,
                        padding: '11px 18px',
                        fontSize: '0.8125rem',
                        fontWeight: 700,
                        fontFamily: 'Meshkat, sans-serif',
                        boxShadow: '0 12px 34px rgba(0,0,0,.3)'
                    },
                    children: error
                })
            ]
        });
    }
    // An edit whose roster is still loading: nothing to pick, so nothing to show yet.
    if (reschedule) return null;
    // ── No one to book for → connect a doctor, instead of a dead-end sentence ────
    const listed = fresh ? people : bookable.map((d)=>({
            key: d.doctorId,
            type: 'DOCTOR',
            id: d.doctorId,
            name: d.doctorName
        }));
    const busy = loading || fresh && svc.loading;
    if (!busy && listed.length === 0) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $94n92.default), {
        pending: pending,
        onAccept: acceptDoctor,
        onClose: onClose
    });
    // What a person's row says under the name: a doctor's visit length, a
    // coworker's role, and — where the engine answered — their first free time today.
    const metaOf = (p)=>{
        const doc = p.type === 'DOCTOR' ? bookable.find((d)=>d.doctorId === p.id) : null;
        const base = doc ? `${t('common.entity.visit')} ${formatDigits(doc.visitDurationMinutes || 30)} ${t('common.units.minuteLong')}` : (0, $gXHpd.performerKind)(p, t);
        const ff = perfFirst[p.key];
        const free = !ff || ff.loading || ff.failed ? null : ff.noShift && p.type === 'STAFF' ? t('reception.booking.noHours') : ff.firstMs ? t('reception.booking.firstFreeAt', {
            when: formatTime(ff.firstMs)
        }) : t('reception.booking.noFreeToday');
        return free ? `${base} \xb7 ${free}` : base;
    };
    // ── Who is this appointment with ─────────────────────────────────────────────
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gnVfo.default), {
        title: t('reception.actions.book'),
        subtitle: listed.some((p)=>p.type === 'STAFF') ? t('reception.booking.performerRequired') : t('reception.booking.pickDoctorFirst'),
        loading: busy,
        loadingLabel: t('reception.booking.loadingDoctors'),
        people: listed.map((p)=>({
                key: p.key,
                id: p.id,
                name: p.name || t('doctors.placeholder.unnamed', {
                    id: (p.id || '').slice(0, 6)
                }),
                meta: metaOf(p)
            })),
        onPick: (p)=>{
            setDocId(p.id);
            setPersonKey(p.key);
        },
        onClose: onClose
    });
}

});
parcelRegister("bDmHD", function(module, exports) {

$parcel$export(module.exports, "useClinicDoctors", () => $8784f2848be8e05a$export$91439d860f75240b);

var $acw62 = parcelRequire("acw62");

var $2Mst8 = parcelRequire("2Mst8");
const $8784f2848be8e05a$var$LIST_DOCTORS_QUERY = `
  query ListClinicDoctors($clinicId: ID!) {
    listClinicDoctors(clinicId: $clinicId) {
      id clinicId doctorId doctorName active joinedAt
      status registeredVia
      serviceCount visitDurationMinutes siamId bookingRequiresApproval
      presences { dayOfWeek startTime endTime serviceCatalogIds }
    }
  }
`;
const $8784f2848be8e05a$var$ACCEPT_DOCTOR_MUTATION = `
  mutation AcceptDoctorLink($id: ID!) {
    acceptDoctorLink(id: $id) {
      id status
    }
  }
`;
const $8784f2848be8e05a$var$UPDATE_DOCTOR_LINK_MUTATION = `
  mutation UpdateDoctorLink($id: ID!, $input: UpdateDoctorLinkInput!) {
    updateDoctorLink(id: $id, input: $input) {
      id visitDurationMinutes siamId bookingRequiresApproval
      presences { dayOfWeek startTime endTime serviceCatalogIds }
    }
  }
`;
// The whole week of ONE provider — doctor or staff — written atomically
// (PM-0468 §2.2, replaceProviderPresences). `updateDoctorLink.presences` is kept
// one release by the BFF, but this client no longer sends it.
const $8784f2848be8e05a$var$REPLACE_PRESENCES_MUTATION = `
  mutation ReplaceProviderPresences($providerType: String!, $providerId: ID!, $presences: [PresenceSlotInput!]!) {
    replaceProviderPresences(providerType: $providerType, providerId: $providerId, presences: $presences) {
      dayOfWeek startTime endTime serviceCatalogIds
    }
  }
`;
const $8784f2848be8e05a$var$REMOVE_DOCTOR_MUTATION = `
  mutation RemoveDoctorFromClinic($id: ID!) {
    removeDoctorFromClinic(id: $id)
  }
`;
// `keycloakUserId` is the clinic FOUNDER's Keycloak sub. It is the only
// reliable way to identify the owner: the BFF stores the founder as
// `clinic_admin` and never assigns a `clinic_owner` tier, so a tier check alone
// would let the personnel page offer to demote the person who owns the clinic.
// `myClinic` is un-gated (SETUP_OPERATIONS), so asking for it costs no grant.
const $8784f2848be8e05a$var$MY_CLINIC_QUERY = `query MyClinic { myClinic { id keycloakUserId } }`;
const $8784f2848be8e05a$var$DOCTOR_INFO_QUERY = `
  query DoctorInfo($doctorId: String!) {
    doctorInfo(doctorId: $doctorId) {
      doctorId name specialty medicalCode bio
      phone nationalId birthDate gender username email source
    }
  }
`;
function $8784f2848be8e05a$export$91439d860f75240b() {
    const [clinicId, setClinicId] = (0, $acw62.useState)(null);
    const [founderSub, setFounder] = (0, $acw62.useState)('');
    const [doctors, setDoctors] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    const fetchClinic = (0, $acw62.useCallback)(async ()=>{
        const data = await (0, $2Mst8.bffQuery)($8784f2848be8e05a$var$MY_CLINIC_QUERY, {}, 'MyClinic');
        return data?.myClinic || null;
    }, []);
    // Fetch one doctor's read-only info (doctorpreference profile + Keycloak) by
    // their doctorId. Returns the info object or null; never throws.
    const fetchDoctorInfo = (0, $acw62.useCallback)(async (doctorId)=>{
        try {
            const data = await (0, $2Mst8.bffQuery)($8784f2848be8e05a$var$DOCTOR_INFO_QUERY, {
                doctorId: doctorId
            }, 'DoctorInfo');
            return data?.doctorInfo || null;
        } catch  {
            return null;
        }
    }, []);
    const load = (0, $acw62.useCallback)(async (cid)=>{
        setLoading(true);
        setError(null);
        try {
            const data = await (0, $2Mst8.bffQuery)($8784f2848be8e05a$var$LIST_DOCTORS_QUERY, {
                clinicId: cid
            }, 'ListClinicDoctors');
            const list = data?.listClinicDoctors || [];
            setDoctors(list);
            // Auto-enrich each row with the doctor's real info so the name shows by
            // default (in place of the raw id). Runs in the background per row.
            list.forEach((d)=>{
                if (!d.doctorId) return;
                fetchDoctorInfo(d.doctorId).then((info)=>{
                    if (info) setDoctors((prev)=>prev.map((x)=>x.id === d.id ? {
                                ...x,
                                info: info
                            } : x));
                });
            });
        } catch (e) {
            setError(e.message);
        } finally{
            setLoading(false);
        }
    }, [
        fetchDoctorInfo
    ]);
    (0, $acw62.useEffect)(()=>{
        fetchClinic().then((clinic)=>{
            const cid = clinic?.id || null;
            setClinicId(cid);
            setFounder(clinic?.keycloakUserId || '');
            if (cid) load(cid);
            else setLoading(false);
        }).catch(()=>setLoading(false));
    }, [
        fetchClinic,
        load
    ]);
    const acceptDoctor = (0, $acw62.useCallback)(async (linkId)=>{
        await (0, $2Mst8.bffMutation)($8784f2848be8e05a$var$ACCEPT_DOCTOR_MUTATION, {
            id: linkId
        }, 'AcceptDoctorLink');
        setDoctors((prev)=>prev.map((d)=>d.id === linkId ? {
                    ...d,
                    status: 'accepted'
                } : d));
    }, []);
    const updateDoctor = (0, $acw62.useCallback)(async (linkId, input)=>{
        const data = await (0, $2Mst8.bffMutation)($8784f2848be8e05a$var$UPDATE_DOCTOR_LINK_MUTATION, {
            id: linkId,
            input: input
        }, 'UpdateDoctorLink');
        const updated = data?.updateDoctorLink;
        if (updated) setDoctors((prev)=>prev.map((d)=>d.id === linkId ? {
                    ...d,
                    ...updated
                } : d));
        return updated;
    }, []);
    /**
   * Replace one provider's weekly roster. A DOCTOR row in this list is updated
   * in place; a STAFF member's week lives on the people list, which the caller
   * re-reads. Returns the new week as the server stored it.
   */ const replacePresences = (0, $acw62.useCallback)(async (providerType, providerId, presences)=>{
        const type = String(providerType || 'DOCTOR').toLowerCase();
        const data = await (0, $2Mst8.bffMutation)($8784f2848be8e05a$var$REPLACE_PRESENCES_MUTATION, {
            providerType: type,
            providerId: providerId,
            presences: presences
        }, 'ReplaceProviderPresences');
        const week = data?.replaceProviderPresences || presences;
        if (type === 'doctor') setDoctors((prev)=>prev.map((d)=>d.doctorId === providerId ? {
                    ...d,
                    presences: week
                } : d));
        return week;
    }, []);
    const removeDoctor = (0, $acw62.useCallback)(async (linkId)=>{
        await (0, $2Mst8.bffMutation)($8784f2848be8e05a$var$REMOVE_DOCTOR_MUTATION, {
            id: linkId
        }, 'RemoveDoctorFromClinic');
        setDoctors((prev)=>prev.filter((d)=>d.id !== linkId));
    }, []);
    // Read-only: (re)load one doctor's full info by their doctorId and stash it on
    // that row under `info`. Used when opening the details modal. No DB writes.
    const loadDoctorInfo = (0, $acw62.useCallback)(async (linkId, doctorId)=>{
        const info = await fetchDoctorInfo(doctorId);
        setDoctors((prev)=>prev.map((d)=>d.id === linkId ? {
                    ...d,
                    info: info
                } : d));
        return info;
    }, [
        fetchDoctorInfo
    ]);
    return {
        doctors: doctors,
        loading: loading,
        error: error,
        clinicId: clinicId,
        founderSub: founderSub,
        acceptDoctor: acceptDoctor,
        updateDoctor: updateDoctor,
        removeDoctor: removeDoctor,
        loadDoctorInfo: loadDoctorInfo,
        replacePresences: replacePresences,
        reload: ()=>clinicId && load(clinicId)
    };
}

});

parcelRegister("c2icR", function(module, exports) {

$parcel$export(module.exports, "ADD_PATIENT", () => $8c33cb597b1d1b53$export$e4ae074d2ff5c58f);
$parcel$export(module.exports, "SET_PATIENT_POLICY", () => $8c33cb597b1d1b53$export$e78ae66c6817b3a2);
$parcel$export(module.exports, "CREATE_APPOINTMENT", () => $8c33cb597b1d1b53$export$75416556d41968c5);
$parcel$export(module.exports, "CREATE_APPOINTMENT_NOTIFYING", () => $8c33cb597b1d1b53$export$e7d7febc6062ad52);
$parcel$export(module.exports, "DURATION_OPTIONS", () => $8c33cb597b1d1b53$export$5753839b913e414f);
$parcel$export(module.exports, "DURATION_MIN", () => $8c33cb597b1d1b53$export$dab2410ac21e580e);
$parcel$export(module.exports, "DURATION_MAX", () => $8c33cb597b1d1b53$export$1cf42f7d8581237b);
$parcel$export(module.exports, "START_HOUR", () => $8c33cb597b1d1b53$export$e06c122c700fe0f2);
$parcel$export(module.exports, "DAY_MIN", () => $8c33cb597b1d1b53$export$f0d374539487f66);
$parcel$export(module.exports, "TIME_SLOTS", () => $8c33cb597b1d1b53$export$9d3bab48dce3fd11);
$parcel$export(module.exports, "DOC_COLORS", () => $8c33cb597b1d1b53$export$6caf776671738550);
// ── GraphQL ───────────────────────────────────────────────────────────────────
const $8c33cb597b1d1b53$export$e4ae074d2ff5c58f = `
  mutation AddPatient($input: CreatePatientInput!) {
    addPatient(input: $input) { id name phone }
  }
`;
const $8c33cb597b1d1b53$export$e78ae66c6817b3a2 = `
  mutation SetPatientPolicy($input: PatientPolicyInput!) {
    setPatientPolicy(input: $input) { id insurerId }
  }
`;
const $8c33cb597b1d1b53$export$75416556d41968c5 = `
  mutation CreateAppointment($input: AppointmentInput!) {
    createAppointment(input: $input) {
      id patientId doctorId dateTime status
      service { currency declarationId label unitPriceRial }
    }
  }
`;
const $8c33cb597b1d1b53$export$e7d7febc6062ad52 = `
  mutation CreateAppointmentNotifying($input: AppointmentInput!) {
    createAppointment(input: $input) {
      id patientId doctorId dateTime status
      service { currency declarationId label unitPriceRial }
      notifications { channel status reason detail }
    }
  }
`;
const $8c33cb597b1d1b53$export$5753839b913e414f = [
    10,
    15,
    20,
    30
];
const $8c33cb597b1d1b53$export$dab2410ac21e580e = 5;
const $8c33cb597b1d1b53$export$1cf42f7d8581237b = 120;
const $8c33cb597b1d1b53$export$e06c122c700fe0f2 = 8;
const $8c33cb597b1d1b53$export$49388c47a6ec02b1 = 20;
const $8c33cb597b1d1b53$export$f0d374539487f66 = 1440;
const $8c33cb597b1d1b53$export$9d3bab48dce3fd11 = [];
for(let h = 0; h < 24; h++){
    $8c33cb597b1d1b53$export$9d3bab48dce3fd11.push({
        h: h,
        m: 0,
        label: `${String(h).padStart(2, '0')}:00`
    });
    $8c33cb597b1d1b53$export$9d3bab48dce3fd11.push({
        h: h,
        m: 30,
        label: `${String(h).padStart(2, '0')}:30`
    });
}
const $8c33cb597b1d1b53$export$6caf776671738550 = [
    '#0173BE',
    '#00BEB2',
    '#7C3AED',
    '#D97706',
    '#059669',
    '#DC2626',
    '#0284C7'
];

});

parcelRegister("2MpEq", function(module, exports) {

$parcel$export(module.exports, "NOTIFY_CHANNEL_ORDER", () => $2063f6336143c4ad$export$bd90fde78b9fc3b2);
$parcel$export(module.exports, "orderChannels", () => $2063f6336143c4ad$export$faedfa801ab68af6);
$parcel$export(module.exports, "withChannel", () => $2063f6336143c4ad$export$fbef48ef97632709);
$parcel$export(module.exports, "sameChannels", () => $2063f6336143c4ad$export$abc0badd37f64766);
$parcel$export(module.exports, "whatsappBlocked", () => $2063f6336143c4ad$export$23baa8521bfaafc8);
$parcel$export(module.exports, "notificationSummary", () => $2063f6336143c4ad$export$fcc920f77488788b);
$parcel$export(module.exports, "NOTIFY_BODY_MAX", () => $2063f6336143c4ad$export$17ef7ef578fefaaa);
$parcel$export(module.exports, "noticeBody", () => $2063f6336143c4ad$export$2b8fdcf800b26cf1);
$parcel$export(module.exports, "notifyBodyToSend", () => $2063f6336143c4ad$export$418ee06b87d7a79);
/**
 * «ارسال اعلان به بیمار» — the client's half of the booking notification.
 *
 * The BFF sends (parsina.bff.clinic src/lib/appointmentNotifier.js) and answers one row
 * per channel: `{ channel, status, reason, detail, cost }`. This module owns the three
 * things the screens need around that and nothing else: the channel ORDER every surface
 * lists them in, the few WhatsApp states in which a tick would be a promise nobody can
 * keep, and turning the BFF's rows into the sentence the booking toast ends with.
 *
 * Pure on purpose — no React, no network — so each rule is testable on its own.
 */ 
var $hSpRf = parcelRequire("hSpRf");
const $2063f6336143c4ad$export$bd90fde78b9fc3b2 = (0, $hSpRf.CHANNEL_ORDER);
function $2063f6336143c4ad$export$faedfa801ab68af6(list) {
    const chosen = new Set((list || []).map((k)=>String(k).toLowerCase()));
    return (0, $hSpRf.CHANNEL_ORDER).filter((k)=>chosen.has(k));
}
function $2063f6336143c4ad$export$fbef48ef97632709(list, key, on) {
    const next = new Set($2063f6336143c4ad$export$faedfa801ab68af6(list));
    if (on) next.add(key);
    else next.delete(key);
    return $2063f6336143c4ad$export$faedfa801ab68af6([
        ...next
    ]);
}
const $2063f6336143c4ad$export$abc0badd37f64766 = (a, b)=>$2063f6336143c4ad$export$faedfa801ab68af6(a).join(',') === $2063f6336143c4ad$export$faedfa801ab68af6(b).join(',');
/**
 * The WhatsApp states in which nothing can leave the building. DISCONNECTED and PAIRING
 * are not here: the gateway recovers the first on its own and the BFF still tries, so
 * a tick there is honest.
 */ const $2063f6336143c4ad$var$WHATSAPP_BLOCKED = new Set([
    'UNLINKED',
    'LOGGED_OUT'
]);
const $2063f6336143c4ad$export$23baa8521bfaafc8 = (session)=>!!session && $2063f6336143c4ad$var$WHATSAPP_BLOCKED.has(session.state);
const $2063f6336143c4ad$export$e8e18b20e913c254 = Object.freeze([
    'no_patient',
    'not_linked',
    'no_phone',
    'do_not_contact',
    'crm_unavailable',
    'bad_phone',
    'not_on_whatsapp',
    'opted_out',
    'whatsapp_not_linked',
    'insufficient_credit',
    'rejected',
    'timeout',
    'unavailable'
]);
function $2063f6336143c4ad$export$b9b54b77c8ed39d(row, t) {
    if (!row) return '';
    if (row.status === 'sent') return t('reception.notify.status.sent');
    if (row.status === 'pending') return t('reception.notify.status.pending');
    if (row.reason && $2063f6336143c4ad$export$e8e18b20e913c254.includes(row.reason)) return t(`reception.notify.reasons.${row.reason}`);
    // A reason from a newer BFF still says something true: its own words, or «ارسال نشد».
    return row.detail || t('reception.notify.status.failed');
}
const $2063f6336143c4ad$export$883e971b1cf6280a = (rows)=>(rows || []).some((r)=>r && (r.status === 'failed' || r.status === 'skipped'));
function $2063f6336143c4ad$export$fcc920f77488788b(rows, t) {
    const list = (rows || []).filter(Boolean);
    if (!list.length) return '';
    const items = list.map((row)=>t('reception.notify.item', {
            channel: (0, $hSpRf.CHANNELS)[row.channel] ? t((0, $hSpRf.CHANNELS)[row.channel].labelKey) : row.channel,
            outcome: $2063f6336143c4ad$export$b9b54b77c8ed39d(row, t)
        })).join(" \xb7 ");
    return t('reception.notify.summary', {
        items: items
    });
}
const $2063f6336143c4ad$export$17ef7ef578fefaaa = 670;
function $2063f6336143c4ad$export$2b8fdcf800b26cf1(settings, event = 'booked') {
    if (!settings) return '';
    return event === 'rescheduled' ? settings.rescheduleTemplate?.body || settings.defaultRescheduleBody || '' : settings.template?.body || settings.defaultBody || '';
}
function $2063f6336143c4ad$export$418ee06b87d7a79(edited, template) {
    const text = String(edited ?? '').trim();
    if (!text || text === String(template ?? '').trim()) return null;
    return text;
}

});
parcelRegister("hSpRf", function(module, exports) {

$parcel$export(module.exports, "smsSegments", () => $d03b89aaa33fe371$export$f1cfda5a362d6852);
$parcel$export(module.exports, "MESSAGE_VARS", () => $d03b89aaa33fe371$export$cb7986d4ce26d632);
$parcel$export(module.exports, "varsForContext", () => $d03b89aaa33fe371$export$e3cbcdaf5b105e4f);
$parcel$export(module.exports, "usesAppointmentVars", () => $d03b89aaa33fe371$export$fd0dd175838be5ca);
$parcel$export(module.exports, "renderMessage", () => $d03b89aaa33fe371$export$7b9c635b0dc56d38);
$parcel$export(module.exports, "usedVars", () => $d03b89aaa33fe371$export$1a76b7cdaade8883);
$parcel$export(module.exports, "CHANNELS", () => $d03b89aaa33fe371$export$6ed507336478440d);
$parcel$export(module.exports, "CHANNEL_ORDER", () => $d03b89aaa33fe371$export$7f784c129273c0f6);
$parcel$export(module.exports, "channelOffered", () => $d03b89aaa33fe371$export$29525ebcf3244928);
$parcel$export(module.exports, "estimateSegments", () => $d03b89aaa33fe371$export$7bcda6913de6ff9c);
/**
 * Patient messaging — templates, variable substitution and SMS segment arithmetic.
 *
 * BOTH CHANNELS SEND, and they no longer send through the same place. SMS goes to
 * parsina.sms.microservice (Kavenegar); WhatsApp goes to MeshHub's shared gateway.
 * From here that split is invisible on purpose — both are `sendPatientMessage` /
 * `startPatientBroadcast` on the clinic BFF (see `hooks/usePatientMessaging.js`), and
 * the compose surface picks a channel, not a transport. BALE is a third channel on the SMS
 * path: the same Kavenegar account and the same service, with Parsina's Bale bot as the
 * sender instead of an SMS line.
 *
 * The «به‌زودی» that used to sit on SMS is GONE, because the provider landed. It was
 * never a hidden channel — PATIENTS_PAGE_REDESIGN.md §8.2 (D5) argued that a declared
 * but unselectable channel keeps the roadmap legible where an absent one does not —
 * and the promise made there was that it would become selectable behind the same
 * GraphQL shape, with nothing in the compose surface changing. That is what happened.
 *
 * WHAT THIS MODULE DOES *NOT* DECIDE IS THE PRICE. The پارسه cost of an SMS comes from
 * the service that will make the debit (`smsQuote` → `useSmsQuote`), because a figure
 * printed here that disagrees with the ledger is worse than no figure at all. The
 * SEGMENT count below stays local: it is what the operator edits against, keystroke by
 * keystroke, and `internal/sms/segments.go` in the service is its deliberate mirror —
 * change one and change the other, or the two stop agreeing about what a message costs.
 *
 * Audience arithmetic — who can actually be reached, and who is excluded and why —
 * lives in `screens/Patients/patientsView.js`, because reachability is a property of
 * the patient's clinic relationship rather than of the message. This module owns the
 * MESSAGE: its templates, its variables and what it will cost to send.
 *
 * Two numbers decide whether the desk trusts this feature, and both are computed here
 * rather than in the view:
 *
 *  1. **Segments, not characters.** An Iranian gateway bills per SMS *segment*. Persian
 *     text is UCS-2, where a segment is 70 characters — 67 once the message spills into
 *     a second one, because concatenation spends 3 characters per part on the UDH that
 *     reassembles them. A 71-character Persian message is two segments, not one, and a
 *     counter that shows only «۷۱ کاراکتر» understates the bill by 100%.
 *
 *  2. **Segments AFTER substitution.** `{نام بیمار}` is 11 characters in the box and
 *     «محمدرضا حسینی‌نژاد» is 18 on the wire. Estimating from the template is what makes
 *     a broadcast cost more than the number the operator approved, so the estimate here
 *     resolves the template per recipient and adds up the real segment counts.
 */ parcelRequire("5N0ZI");
var $5AX1S = parcelRequire("5AX1S");
// ── SMS encoding ─────────────────────────────────────────────────────────────────
// GSM 03.38 basic set — one septet each. Anything outside it (any Persian letter, and
// the Persian digits ۰-۹) forces the whole message to UCS-2, which is why a single
// stray Persian character in an otherwise-Latin message more than halves its capacity.
const $d03b89aaa33fe371$var$GSM7 = new Set("@\xa3$\xa5\xe8\xe9\xf9\xec\xf2\xc7\n\xd8\xf8\r\xc5\xe5\u0394_\u03A6\u0393\u039B\u03A9\u03A0\u03A8\u03A3\u0398\u039E\xc6\xe6\xdf\xc9 !\"#\xa4%&'()*+,-./0123456789:;<=>?\xa1ABCDEFGHIJKLMNOPQRSTUVWXYZ\xc4\xd6\xd1\xdc\xa7\xbfabcdefghijklmnopqrstuvwxyz\xe4\xf6\xf1\xfc\xe0");
// Escaped in GSM-7: two septets each.
const $d03b89aaa33fe371$var$GSM7_EXT = new Set("^{}\\[~]|\u20AC");
const $d03b89aaa33fe371$export$b8708938dca6ca83 = {
    gsm7: {
        single: 160,
        concatenated: 153
    },
    ucs2: {
        single: 70,
        concatenated: 67
    }
};
function $d03b89aaa33fe371$export$f1cfda5a362d6852(text) {
    const s = String(text ?? '');
    if (!s) return {
        encoding: 'gsm7',
        chars: 0,
        units: 0,
        segments: 0,
        capacity: $d03b89aaa33fe371$export$b8708938dca6ca83.gsm7.single
    };
    let septets = 0;
    let gsm = true;
    for (const ch of s){
        if ($d03b89aaa33fe371$var$GSM7.has(ch)) septets += 1;
        else if ($d03b89aaa33fe371$var$GSM7_EXT.has(ch)) septets += 2;
        else {
            gsm = false;
            break;
        }
    }
    const cap = gsm ? $d03b89aaa33fe371$export$b8708938dca6ca83.gsm7 : $d03b89aaa33fe371$export$b8708938dca6ca83.ucs2;
    // UCS-2 bills UTF-16 code units, so a surrogate pair (emoji) legitimately costs two.
    const units = gsm ? septets : s.length;
    const segments = units <= cap.single ? 1 : Math.ceil(units / cap.concatenated);
    return {
        encoding: gsm ? 'gsm7' : 'ucs2',
        chars: [
            ...s
        ].length,
        units: units,
        segments: segments,
        capacity: segments > 1 ? cap.concatenated : cap.single
    };
}
const $d03b89aaa33fe371$export$cb7986d4ce26d632 = [
    {
        token: "{\u0646\u0627\u0645 \u0628\u06CC\u0645\u0627\u0631}",
        labelKey: 'patients.messaging.vars.patientName',
        resolve: (ctx)=>ctx.patient?.name || ctx.fallbackName || ''
    },
    {
        token: "{\u0634\u0645\u0627\u0631\u0647 \u067E\u0631\u0648\u0646\u062F\u0647}",
        labelKey: 'patients.messaging.vars.fileNumber',
        resolve: (ctx)=>ctx.patient?.fileNumber || ''
    },
    {
        token: "{\u0646\u0627\u0645 \u06A9\u0644\u06CC\u0646\u06CC\u06A9}",
        labelKey: 'patients.messaging.vars.clinicName',
        resolve: (ctx)=>ctx.clinicName || ''
    }
];
const $d03b89aaa33fe371$export$64e9e1a17f80bd7c = [
    {
        token: "{\u062A\u0627\u0631\u06CC\u062E \u0646\u0648\u0628\u062A}",
        labelKey: 'patients.compose.vars.appointmentDate',
        resolve: (ctx)=>ctx.appointmentDate || ''
    },
    {
        token: "{\u0633\u0627\u0639\u062A \u0646\u0648\u0628\u062A}",
        labelKey: 'patients.compose.vars.appointmentTime',
        resolve: (ctx)=>ctx.appointmentTime || ''
    },
    {
        token: "{\u0646\u0627\u0645 \u067E\u0632\u0634\u06A9}",
        labelKey: 'patients.compose.vars.doctorName',
        resolve: (ctx)=>ctx.doctorName || ''
    }
];
const $d03b89aaa33fe371$export$a94e1fe53e5e8eed = [
    ...$d03b89aaa33fe371$export$cb7986d4ce26d632,
    ...$d03b89aaa33fe371$export$64e9e1a17f80bd7c
];
const $d03b89aaa33fe371$export$e3cbcdaf5b105e4f = ({ hasAppointmentContext: hasAppointmentContext = false } = {})=>hasAppointmentContext ? $d03b89aaa33fe371$export$a94e1fe53e5e8eed : $d03b89aaa33fe371$export$cb7986d4ce26d632;
const $d03b89aaa33fe371$export$fd0dd175838be5ca = (body)=>{
    const s = String(body ?? '');
    return $d03b89aaa33fe371$export$64e9e1a17f80bd7c.some((v)=>s.includes(v.token));
};
function $d03b89aaa33fe371$export$7b9c635b0dc56d38(body, ctx = {}) {
    return $d03b89aaa33fe371$export$a94e1fe53e5e8eed.reduce((out, v)=>out.split(v.token).join(v.resolve(ctx)), String(body ?? ''));
}
function $d03b89aaa33fe371$export$1a76b7cdaade8883(body) {
    const s = String(body ?? '');
    return $d03b89aaa33fe371$export$a94e1fe53e5e8eed.filter((v)=>s.includes(v.token));
}
const $d03b89aaa33fe371$export$6ed507336478440d = {
    whatsapp: {
        key: 'whatsapp',
        order: 0,
        labelKey: 'patients.messaging.channels.whatsapp.label',
        hintKey: 'patients.messaging.channels.whatsapp.hint',
        segmented: false,
        /** Whether a provider exists at all; the LINK state is asked of the session. */ provider: true,
        /**
     * Billed per MESSAGE (0.1 پارسه by default) from the SENDER's own wallet, by the
     * clinic BFF — reserved before the send, charged on accept. Quoted by
     * `whatsappQuote` from the recipient count alone: no segments, no tariff.
     */ billed: true
    },
    sms: {
        key: 'sms',
        order: 1,
        labelKey: 'patients.messaging.channels.sms.label',
        hintKey: 'patients.messaging.channels.sms.hint',
        /** Billed per segment; the counter shows segments and the estimate shows a total. */ segmented: true,
        provider: true,
        /** Priced by the SMS service, which the compose surface asks for a quote. */ billed: true,
        soonHintKey: 'patients.compose.channel.smsSoonHint'
    },
    /**
   * Parsina's Bale bot, sent through the same Kavenegar account and the same SMS
   * service as SMS — the sender is the only difference on the wire. Billed per MESSAGE
   * and quoted by that service like SMS; not segmented, because Bale delivers a long
   * body whole. There is no fallback to SMS: a patient without Bale is a failed,
   * unbilled row the desk can resend by SMS.
   */ bale: {
        key: 'bale',
        order: 2,
        labelKey: 'patients.messaging.channels.bale.label',
        hintKey: 'patients.messaging.channels.bale.hint',
        segmented: false,
        provider: true,
        billed: true
    }
};
const $d03b89aaa33fe371$export$7f784c129273c0f6 = Object.values($d03b89aaa33fe371$export$6ed507336478440d).sort((a, b)=>a.order - b.order).map((c)=>c.key);
// SMS and Bale leave through Kavenegar, so they need the country's SMS provider too.
const $d03b89aaa33fe371$var$SMS_SERVICE_CHANNELS = new Set([
    'sms',
    'bale'
]);
function $d03b89aaa33fe371$export$29525ebcf3244928(capabilities, key) {
    if (!capabilities) return true;
    const listed = (capabilities.messagingChannels || []).includes(key);
    return $d03b89aaa33fe371$var$SMS_SERVICE_CHANNELS.has(key) ? listed && Boolean(capabilities.smsProvider) : listed;
}
const $d03b89aaa33fe371$export$1e1174df1dab15eb = (capabilities)=>$d03b89aaa33fe371$export$7f784c129273c0f6.filter((key)=>$d03b89aaa33fe371$export$29525ebcf3244928(capabilities, key));
function $d03b89aaa33fe371$export$4e681de1af87da9a(patient) {
    const raw = String(patient?.phone ?? '').trim();
    return !raw || raw === "\u2014" ? '' : raw;
}
const $d03b89aaa33fe371$export$3bfa3241bda03ec1 = (patient)=>$d03b89aaa33fe371$export$4e681de1af87da9a(patient) !== '';
function $d03b89aaa33fe371$export$852e3f93fc5ba49e(raw) {
    const e164 = (0, $5AX1S).normalizePhone(raw);
    return e164.startsWith('+98') ? e164.slice(1) : '';
}
const $d03b89aaa33fe371$export$ffe4997b1ffdb551 = 25;
function $d03b89aaa33fe371$export$7bcda6913de6ff9c(body, recipients = [], { clinicName: clinicName = '', unknownCount: unknownCount = 0 } = {}) {
    const perRecipient = recipients.map((p)=>({
            id: p.id,
            segments: $d03b89aaa33fe371$export$f1cfda5a362d6852($d03b89aaa33fe371$export$7b9c635b0dc56d38(body, {
                patient: p,
                clinicName: clinicName
            })).segments
        }));
    const known = perRecipient.reduce((sum, r)=>sum + r.segments, 0);
    const worst = perRecipient.reduce((max, r)=>Math.max(max, r.segments), 0) || $d03b89aaa33fe371$export$f1cfda5a362d6852($d03b89aaa33fe371$export$7b9c635b0dc56d38(body, {
        clinicName: clinicName
    })).segments;
    return {
        perRecipient: perRecipient,
        totalSegments: known + worst * unknownCount,
        maxSegments: worst,
        approximate: unknownCount > 0
    };
}
var $d03b89aaa33fe371$export$2e2bcd8739ae039 = {
    smsSegments: $d03b89aaa33fe371$export$f1cfda5a362d6852,
    renderMessage: $d03b89aaa33fe371$export$7b9c635b0dc56d38,
    usedVars: $d03b89aaa33fe371$export$1a76b7cdaade8883,
    estimateSegments: $d03b89aaa33fe371$export$7bcda6913de6ff9c,
    recipientPhone: $d03b89aaa33fe371$export$4e681de1af87da9a,
    isReachable: $d03b89aaa33fe371$export$3bfa3241bda03ec1,
    toE164Iran: $d03b89aaa33fe371$export$852e3f93fc5ba49e,
    varsForContext: $d03b89aaa33fe371$export$e3cbcdaf5b105e4f,
    usesAppointmentVars: $d03b89aaa33fe371$export$fd0dd175838be5ca,
    MESSAGE_VARS: $d03b89aaa33fe371$export$cb7986d4ce26d632,
    APPOINTMENT_VARS: $d03b89aaa33fe371$export$64e9e1a17f80bd7c,
    ALL_VARS: $d03b89aaa33fe371$export$a94e1fe53e5e8eed,
    CHANNELS: $d03b89aaa33fe371$export$6ed507336478440d,
    CHANNEL_ORDER: $d03b89aaa33fe371$export$7f784c129273c0f6,
    SMS_CAPACITY: $d03b89aaa33fe371$export$b8708938dca6ca83,
    BULK_CONFIRM_THRESHOLD: $d03b89aaa33fe371$export$ffe4997b1ffdb551,
    channelOffered: $d03b89aaa33fe371$export$29525ebcf3244928,
    offeredChannelOrder: $d03b89aaa33fe371$export$1e1174df1dab15eb
};

});


parcelRegister("6P09x", function(module, exports) {

$parcel$export(module.exports, "insurerIdFromLegacy", () => $4f779fde861874c1$export$a9e7f4854e0c5e6a);
$parcel$export(module.exports, "validateNid", () => $4f779fde861874c1$export$6d90ed41f2adef94);
$parcel$export(module.exports, "nidProblem", () => $4f779fde861874c1$export$bacd3574bd412d87);
$parcel$export(module.exports, "nidForWire", () => $4f779fde861874c1$export$a3fdbbd972842505);
$parcel$export(module.exports, "nidCountryFor", () => $4f779fde861874c1$export$7cacc4eb9f333bbb);
$parcel$export(module.exports, "digitsOnly", () => $4f779fde861874c1$export$3360a57ef2ab91fb);
$parcel$export(module.exports, "ageInYears", () => $4f779fde861874c1$export$ca39126d47b10720);
$parcel$export(module.exports, "exceedsMaxAge", () => $4f779fde861874c1$export$30cd20517a9dee21);
$parcel$export(module.exports, "birthDateFromAge", () => $4f779fde861874c1$export$f601cb907b78ee95);
$parcel$export(module.exports, "parseMeasure", () => $4f779fde861874c1$export$ac34b32aa682b258);
$parcel$export(module.exports, "heightProblem", () => $4f779fde861874c1$export$6f2d2dc993660aa2);
$parcel$export(module.exports, "weightProblem", () => $4f779fde861874c1$export$4d5c2d453646fa6e);
$parcel$export(module.exports, "heightForBox", () => $4f779fde861874c1$export$c0a7f4d570149495);
$parcel$export(module.exports, "normalizeFileNumber", () => $4f779fde861874c1$export$cfeea60f2801ff6a);
$parcel$export(module.exports, "fileNumberProblem", () => $4f779fde861874c1$export$265ef2ed1048f1a2);
$parcel$export(module.exports, "fileNumberRefusal", () => $4f779fde861874c1$export$5a5b07013d22848d);
$parcel$export(module.exports, "ADDRESS_MAX", () => $4f779fde861874c1$export$91b9cc237b07f595);
$parcel$export(module.exports, "REFERRER_MAX", () => $4f779fde861874c1$export$84939d693f3865c);
$parcel$export(module.exports, "isRegisterable", () => $4f779fde861874c1$export$da29d5a12117c06e);
$parcel$export(module.exports, "LOOKUP_PATIENTS_BY_PHONE", () => $4f779fde861874c1$export$110f656b8e2d18c5);
$parcel$export(module.exports, "LINK_EXISTING_PATIENT", () => $4f779fde861874c1$export$f704742371d3b375);
$parcel$export(module.exports, "phoneRegistrationError", () => $4f779fde861874c1$export$8d2fe71e41cebd66);
$parcel$export(module.exports, "phoneFlags", () => $4f779fde861874c1$export$2b8e20d1ad7be49);
parcelRequire("5N0ZI");
var $3tGMU = parcelRequire("3tGMU");
var $5AX1S = parcelRequire("5AX1S");
parcelRequire("dNNpt");
var $4UJrq = parcelRequire("4UJrq");

var $5qKOB = parcelRequire("5qKOB");
parcelRequire("bLQhC");
var $5JYPc = parcelRequire("5JYPc");

var $jSTkY = parcelRequire("jSTkY");
// What the clinic considers a registerable patient. Registration happens in two
// places — the ثبت بیمار جدید screen and the «بیمار جدید» tab of the booking modal —
// and a patient created from a booking must be the same first-class record as one
// created from the screen. These rules live here so the two cannot drift apart.
// The insurer as it is STORED. `patient.insurance` is a free-text column, so
// this exact string is what goes on the wire, what comes back, and what a read
// is matched against (AddPatient.web.jsx maps a patient back onto a radio by
// comparing to it). It is therefore DATA and never follows the UI language: an
// English panel that stored "Social Security" would write a value no Persian
// panel — and no report — could ever match again.
//
// i18n-exempt: stored value, not UI copy. The label a person READS is `fa`
// below, which does follow the language.
// The four labels this client used to WRITE into `patients.insurance` before the
// insurer catalog existed, mapped onto the catalog ids they became.
//
// Read-only history. Nothing writes these any more — a patient's insurer is now a
// row in `patient_insurance_policies` keyed by catalog id, and the legacy column
// is DERIVED from it by patientmanagement. This map exists solely so an existing
// record still lights up the right option when the desk opens it.
//
// Both hamza spellings of تامین are here on purpose: the two were written by
// different versions of this file, and to any query they were different insurers —
// which is precisely why an unjoinable display string stopped being the model.
const $4f779fde861874c1$var$LEGACY_INSURANCE_TO_ID = {
    "\u062A\u0627\u0645\u06CC\u0646 \u0627\u062C\u062A\u0645\u0627\u0639\u06CC": 'tamin',
    "\u062A\u0623\u0645\u06CC\u0646 \u0627\u062C\u062A\u0645\u0627\u0639\u06CC": 'tamin',
    "\u0628\u06CC\u0645\u0647 \u0633\u0644\u0627\u0645\u062A": 'salamat',
    "\u0628\u06CC\u0645\u0647\u0654 \u0633\u0644\u0627\u0645\u062A": 'salamat',
    "\u0646\u06CC\u0631\u0648\u0647\u0627\u06CC \u0645\u0633\u0644\u062D": 'armed',
    "\u0633\u0627\u06CC\u0631 / \u0622\u0632\u0627\u062F": 'azad',
    "\u0633\u0627\u06CC\u0631/\u0622\u0632\u0627\u062F": 'azad',
    "\u0622\u0632\u0627\u062F": 'azad'
};
const $4f779fde861874c1$export$a9e7f4854e0c5e6a = (label)=>{
    const key = (label || '').trim().replace(/\s+/g, ' ');
    return $4f779fde861874c1$var$LEGACY_INSURANCE_TO_ID[key] || null;
};
const $4f779fde861874c1$export$6d90ed41f2adef94 = (nid, country)=>(0, $3tGMU).isValidNationalId(nid, country);
const $4f779fde861874c1$export$bacd3574bd412d87 = (nid, country)=>(0, $3tGMU).nationalIdProblem(nid, {
        country: country
    });
const $4f779fde861874c1$export$a3fdbbd972842505 = (nid, country)=>(0, $3tGMU).normalizeNationalId(nid, country) || null;
const $4f779fde861874c1$export$eb769507512ee7fa = 'ZZ';
function $4f779fde861874c1$export$7cacc4eb9f333bbb(picked, region, countryDefault) {
    if (picked) return picked;
    if (countryDefault) return countryDefault;
    if (!region || region.iran) return null;
    return region.country || $4f779fde861874c1$export$eb769507512ee7fa;
}
const $4f779fde861874c1$export$3360a57ef2ab91fb = (s)=>(s || '').replace(/\D/g, '');
function $4f779fde861874c1$export$1792fce17fc182d7(nid, { iranian: iranian = true } = {}) {
    if (!iranian) return true;
    const digits = $4f779fde861874c1$export$3360a57ef2ab91fb(nid);
    return digits.length === 0 || $4f779fde861874c1$export$6d90ed41f2adef94(digits);
}
function $4f779fde861874c1$export$3a6b53fb5e27dede(nid, { iranian: iranian = true } = {}) {
    return iranian ? $4f779fde861874c1$export$3360a57ef2ab91fb(nid) : (0, $5JYPc.toEnDigits)(String(nid ?? '')).trim();
}
const $4f779fde861874c1$export$fa24d54129de63c4 = 100;
// `YYYY-MM-DD` and `YYYY/MM/DD`. The picker writes the first (its value contract is
// Gregorian, it only DISPLAYS Jalali); the second is how the doctor mobile app writes
// the same column, and how a dictated date can come back.
const $4f779fde861874c1$var$BIRTH_DATE = /^(\d{4})[-/](\d{1,2})[-/](\d{1,2})$/;
function $4f779fde861874c1$export$d021be1cf3e55c92(value) {
    const match = $4f779fde861874c1$var$BIRTH_DATE.exec((0, $5JYPc.toEnDigits)(value ?? '').trim());
    if (!match) return null;
    const [y, m, d] = match.slice(1).map(Number);
    if (y >= 1200 && y <= 1500) {
        if (m < 1 || m > 12 || d < 1 || d > (0, $4UJrq.jDaysInMonth)(y, m)) return null;
        const g = new Date((0, $4UJrq.jalaliToMs)(y, m, d));
        return {
            y: g.getUTCFullYear(),
            m: g.getUTCMonth() + 1,
            d: g.getUTCDate()
        };
    }
    if (y < 1800) return null;
    // Date NORMALISES an impossible date rather than rejecting it — 1977-02-30 becomes
    // 2 March — so surviving the round trip is the check.
    const probe = new Date(Date.UTC(y, m - 1, d));
    const survives = probe.getUTCFullYear() === y && probe.getUTCMonth() === m - 1 && probe.getUTCDate() === d;
    return survives ? {
        y: y,
        m: m,
        d: d
    } : null;
}
function $4f779fde861874c1$export$ca39126d47b10720(value, now = (0, $5qKOB.clinicNow)()) {
    const born = $4f779fde861874c1$export$d021be1cf3e55c92(value);
    if (!born) return null;
    const [ty, tm, td] = [
        now.getUTCFullYear(),
        now.getUTCMonth() + 1,
        now.getUTCDate()
    ];
    const hadBirthday = tm > born.m || tm === born.m && td >= born.d;
    return ty - born.y - (hadBirthday ? 0 : 1);
}
function $4f779fde861874c1$export$30cd20517a9dee21(value, now) {
    const age = $4f779fde861874c1$export$ca39126d47b10720(value, now);
    return age !== null && age > $4f779fde861874c1$export$fa24d54129de63c4;
}
function $4f779fde861874c1$export$f601cb907b78ee95(age, now = (0, $5qKOB.clinicNow)()) {
    const years = $4f779fde861874c1$export$ac34b32aa682b258(age);
    // 999 is only the box's three digits: any age it can hold gets a date (see above).
    if (years === null || !Number.isInteger(years) || years < 0 || years > 999) return '';
    const today = (0, $4UJrq.msToJalali)(now.getTime());
    if (!today) return '';
    const born = new Date((0, $4UJrq.jalaliToMs)(today.y - years, 1, 1));
    const pad = (n)=>String(n).padStart(2, '0');
    return `${born.getUTCFullYear()}-${pad(born.getUTCMonth() + 1)}-${pad(born.getUTCDate())}`;
}
const $4f779fde861874c1$export$d3398a097863a8eb = Object.freeze({
    min: 20,
    max: 250
});
const $4f779fde861874c1$export$1be4c5b5faaddc82 = Object.freeze({
    min: 0.5,
    max: 400
});
function $4f779fde861874c1$export$ac34b32aa682b258(value) {
    // U+066B is «٫», the Persian/Arabic decimal separator.
    const text = (0, $5JYPc.toEnDigits)(String(value ?? '')).replace(/[\u066B,]/g, '.').trim();
    if (!text) return null;
    const n = Number(text);
    return Number.isFinite(n) ? n : Number.NaN;
}
const $4f779fde861874c1$var$outside = (value, { min: min, max: max })=>{
    const n = $4f779fde861874c1$export$ac34b32aa682b258(value);
    return n !== null && !(n >= min && n <= max);
};
const $4f779fde861874c1$export$6f2d2dc993660aa2 = (value)=>$4f779fde861874c1$var$outside(value, $4f779fde861874c1$export$d3398a097863a8eb);
const $4f779fde861874c1$export$4d5c2d453646fa6e = (value)=>$4f779fde861874c1$var$outside(value, $4f779fde861874c1$export$1be4c5b5faaddc82);
const $4f779fde861874c1$export$c0a7f4d570149495 = (height)=>Number(height) > 0 ? String(height) : '';
const $4f779fde861874c1$export$295fb5f7e8797739 = 20;
const $4f779fde861874c1$var$FILE_NUMBER_SHAPE = /^[\p{L}\p{N}/._-]+$/u;
const $4f779fde861874c1$export$cfeea60f2801ff6a = (value)=>(0, $5JYPc.toEnDigits)(String(value ?? '')).trim();
function $4f779fde861874c1$export$265ef2ed1048f1a2(value) {
    const number = $4f779fde861874c1$export$cfeea60f2801ff6a(value);
    if (!number) return '';
    if (number.length > $4f779fde861874c1$export$295fb5f7e8797739) return 'tooLong';
    if (!$4f779fde861874c1$var$FILE_NUMBER_SHAPE.test(number)) return 'invalid';
    return '';
}
function $4f779fde861874c1$export$5a5b07013d22848d(err) {
    const code = err?.extensions?.code;
    if (code === 'FILE_NUMBER_TAKEN') return 'taken';
    if (code === 'FILE_NUMBER_INVALID') return err.extensions.reason === 'tooLong' ? 'tooLong' : 'invalid';
    return '';
}
const $4f779fde861874c1$export$91b9cc237b07f595 = 300;
const $4f779fde861874c1$export$84939d693f3865c = 100;
function $4f779fde861874c1$export$da29d5a12117c06e({ name: name, nid: nid, nidCountry: nidCountry, phone: phone, noPhone: noPhone, landline: landline = false, birth: birth, iranianNid: iranianNid = true }) {
    const typed = String(phone || '').trim();
    const phoneOk = !!noPhone || (landline ? !!typed : (0, $5AX1S).isValidPhone(typed));
    return (name || '').trim().length >= 2 && !$4f779fde861874c1$export$bacd3574bd412d87(nid, nidCountry || (iranianNid ? null : $4f779fde861874c1$export$eb769507512ee7fa)) && phoneOk && !$4f779fde861874c1$export$30cd20517a9dee21(birth);
}
const $4f779fde861874c1$export$110f656b8e2d18c5 = `
  query LookupPatientsByPhone($phone: String!) {
    lookupPatientsByPhone(phone: $phone) {
      phoneNormalized
      candidates {
        patientId displayName isLinkedToThisClinic fileNumber birthYear gender hasAppAccount
        # Whose number it is on that record, and whether it is its primary (PM-0536) \u{2014}
        # null on a record this clinic does not hold.
        matchedRelation matchedIsPrimary
        patient {
          id name phone birthDate nationalId gender
          bloodType insurance maritalStatus linkageStatus
        }
      }
    }
  }
`;
const $4f779fde861874c1$export$f704742371d3b375 = `
  mutation LinkExistingPatient($patientId: ID!) {
    linkExistingPatient(patientId: $patientId) {
      id name phone nationalId
    }
  }
`;
function $4f779fde861874c1$export$8d2fe71e41cebd66(err) {
    const code = err?.extensions?.code;
    if (code === 'PHONE_HAS_PATIENTS') return {
        code: code,
        candidates: Array.isArray(err.extensions.candidates) ? err.extensions.candidates : [],
        conflicts: (0, $jSTkY.phoneConflicts)(err)
    };
    if (code === 'PHONE_REQUIRED') return {
        code: code,
        candidates: [],
        conflicts: []
    };
    return null;
}
function $4f779fde861874c1$export$2b8e20d1ad7be49({ noPhone: noPhone, allowSharedPhone: allowSharedPhone }) {
    return {
        ...noPhone ? {
            noPhone: true
        } : {},
        ...allowSharedPhone && !noPhone ? {
            allowSharedPhone: true
        } : {}
    };
}

});
parcelRegister("dNNpt", function(module, exports) {
$parcel$export(module.exports, "jalaliToMs", () => (parcelRequire("4UJrq")).jalaliToMs);
$parcel$export(module.exports, "jDaysInMonth", () => (parcelRequire("4UJrq")).jDaysInMonth);
$parcel$export(module.exports, "msToJalali", () => (parcelRequire("4UJrq")).msToJalali);
parcelRequire("4UJrq");

});

parcelRegister("bLQhC", function(module, exports) {
$parcel$export(module.exports, "toEnDigits", () => (parcelRequire("5JYPc")).toEnDigits);
parcelRequire("5JYPc");

});

parcelRegister("jSTkY", function(module, exports) {

$parcel$export(module.exports, "MAX_PHONES", () => $e79dfc4fafbb8b7d$export$82be57fd9bce7d58);
$parcel$export(module.exports, "PATIENT_PHONES_FIELDS", () => $e79dfc4fafbb8b7d$export$cf37a82f19684aac);
$parcel$export(module.exports, "PATIENT_PHONES_LIST_FIELDS", () => $e79dfc4fafbb8b7d$export$59413cf3d1976f01);
$parcel$export(module.exports, "phoneKey", () => $e79dfc4fafbb8b7d$export$a50a7ecd1b89c066);
$parcel$export(module.exports, "wireNumber", () => $e79dfc4fafbb8b7d$export$c05e1a8608e51069);
$parcel$export(module.exports, "rowBlocks", () => $e79dfc4fafbb8b7d$export$e0002ee309e15f3b);
$parcel$export(module.exports, "phonesPayload", () => $e79dfc4fafbb8b7d$export$aa889ccaf0250b26);
$parcel$export(module.exports, "phonesEditable", () => $e79dfc4fafbb8b7d$export$adbcfe214c612f59);
$parcel$export(module.exports, "patientPhoneRows", () => $e79dfc4fafbb8b7d$export$f7a38c078473fdcb);
$parcel$export(module.exports, "phonesOf", () => $e79dfc4fafbb8b7d$export$a487b6ce726ba33a);
$parcel$export(module.exports, "phonesPatch", () => $e79dfc4fafbb8b7d$export$4fe327701f9709d0);
$parcel$export(module.exports, "carryRows", () => $e79dfc4fafbb8b7d$export$a00f5196c88e489f);
$parcel$export(module.exports, "otherPhones", () => $e79dfc4fafbb8b7d$export$32995f7f943f794d);
$parcel$export(module.exports, "storedNumber", () => $e79dfc4fafbb8b7d$export$c24576983605bfc4);
$parcel$export(module.exports, "otherPhonesTitle", () => $e79dfc4fafbb8b7d$export$b9515c0624812164);
$parcel$export(module.exports, "matchedOtherPhone", () => $e79dfc4fafbb8b7d$export$4c7ed4ffbca0595a);
$parcel$export(module.exports, "phoneText", () => $e79dfc4fafbb8b7d$export$8048ec2e23fc9eab);
$parcel$export(module.exports, "searchPhoneText", () => $e79dfc4fafbb8b7d$export$605b9a4b19d7331b);
$parcel$export(module.exports, "PHONE_OPT_OUT_REASONS", () => $e79dfc4fafbb8b7d$export$7dfbe58c2b40d749);
$parcel$export(module.exports, "PHONE_OPT_OUT_LABEL_KEY", () => $e79dfc4fafbb8b7d$export$49762b9644aae445);
$parcel$export(module.exports, "numbersRead", () => $e79dfc4fafbb8b7d$export$d97aa66f3793d5d0);
$parcel$export(module.exports, "numberBlocker", () => $e79dfc4fafbb8b7d$export$5599f828351a42ac);
$parcel$export(module.exports, "messageNumber", () => $e79dfc4fafbb8b7d$export$18a4de44164e9c37);
$parcel$export(module.exports, "routedKey", () => $e79dfc4fafbb8b7d$export$78db9fe188cc1a9a);
$parcel$export(module.exports, "phonesRefusal", () => $e79dfc4fafbb8b7d$export$43560479763ed953);
$parcel$export(module.exports, "phoneConflicts", () => $e79dfc4fafbb8b7d$export$c6eb469b5d4a9e67);
$parcel$export(module.exports, "conflictRowIndex", () => $e79dfc4fafbb8b7d$export$a208eaf9893a0938);
parcelRequire("5N0ZI");
var $5AX1S = parcelRequire("5AX1S");
var $6SCJ6 = parcelRequire("6SCJ6");
var $9Bif4 = parcelRequire("9Bif4");
parcelRequire("bLQhC");
var $5JYPc = parcelRequire("5JYPc");
const $e79dfc4fafbb8b7d$export$82be57fd9bce7d58 = 5;
const $e79dfc4fafbb8b7d$export$cf37a82f19684aac = `
  phones {
    id number raw relation label isPrimary verified locked landline source addedHere sharedCount
    optedOut whatsappKnown
  }
  phonesEtag
`;
const $e79dfc4fafbb8b7d$export$59413cf3d1976f01 = `
  phones { id number raw relation isPrimary verified landline addedHere optedOut whatsappKnown }
`;
// The relations that make a number the record's own — the ones that claim it.
const $e79dfc4fafbb8b7d$var$OWN_RELATIONS = new Set([
    'self',
    (0, $9Bif4.UNKNOWN_RELATION)
]);
const $e79dfc4fafbb8b7d$export$e4dddeae01de7abb = (relation)=>$e79dfc4fafbb8b7d$var$OWN_RELATIONS.has(relation);
const $e79dfc4fafbb8b7d$export$a50a7ecd1b89c066 = (number)=>number ? (0, $5AX1S).normalizePhone(String(number).trim()) || '' : '';
const $e79dfc4fafbb8b7d$export$c05e1a8608e51069 = (row)=>row.landline ? (0, $5JYPc.toEnDigits)(String(row.number || '')).trim() : $e79dfc4fafbb8b7d$export$a50a7ecd1b89c066(row.number) || (0, $5JYPc.toEnDigits)(String(row.number || '')).trim();
const $e79dfc4fafbb8b7d$export$e0002ee309e15f3b = (row)=>Boolean(row?.isPrimary) || $e79dfc4fafbb8b7d$export$e4dddeae01de7abb(row?.relation);
const $e79dfc4fafbb8b7d$export$aa889ccaf0250b26 = (rows)=>(0, $6SCJ6.phoneListPayload)(rows).map((row, i)=>({
            ...row,
            number: $e79dfc4fafbb8b7d$export$c05e1a8608e51069({
                ...rows?.[i],
                number: row.number
            })
        }));
const $e79dfc4fafbb8b7d$export$adbcfe214c612f59 = (patient)=>Array.isArray(patient?.phones) && Boolean(patient?.phonesEtag);
const $e79dfc4fafbb8b7d$export$e6a49ed11cf0dc54 = (phones)=>(0, $6SCJ6.phoneListRows)(phones);
const $e79dfc4fafbb8b7d$export$f7a38c078473fdcb = (patient)=>$e79dfc4fafbb8b7d$export$e6a49ed11cf0dc54($e79dfc4fafbb8b7d$export$a487b6ce726ba33a(patient));
function $e79dfc4fafbb8b7d$export$4fe327701f9709d0(rows, patient) {
    const next = $e79dfc4fafbb8b7d$export$aa889ccaf0250b26(rows);
    const before = $e79dfc4fafbb8b7d$export$aa889ccaf0250b26($e79dfc4fafbb8b7d$export$f7a38c078473fdcb(patient));
    return JSON.stringify(next) === JSON.stringify(before) ? null : next;
}
function $e79dfc4fafbb8b7d$export$a00f5196c88e489f(rows, patient) {
    const stored = $e79dfc4fafbb8b7d$export$a487b6ce726ba33a(patient);
    const ids = new Set(stored.map((p)=>p.id).filter(Boolean));
    const kept = rows.filter((row)=>!row.id || ids.has(row.id));
    if (!kept.length) return $e79dfc4fafbb8b7d$export$f7a38c078473fdcb(patient);
    if (kept.some((row)=>row.isPrimary)) return kept;
    const primaryId = stored.find((p)=>p.isPrimary)?.id;
    const next = kept.map((row)=>({
            ...row,
            isPrimary: Boolean(primaryId) && row.id === primaryId
        }));
    if (!next.some((row)=>row.isPrimary)) next[0] = {
        ...next[0],
        isPrimary: true
    };
    return next;
}
function $e79dfc4fafbb8b7d$export$a487b6ce726ba33a(patient) {
    if (Array.isArray(patient?.phones) && patient.phones.length) return patient.phones;
    if (!patient?.phone) return [];
    return [
        {
            id: '',
            number: (0, $5AX1S).normalizePhone(patient.phone) || null,
            raw: patient.phone,
            relation: (0, $9Bif4.UNKNOWN_RELATION),
            label: '',
            isPrimary: true,
            verified: false,
            locked: false,
            landline: false,
            source: 'legacy',
            addedHere: false,
            sharedCount: null,
            optedOut: false,
            whatsappKnown: 'unknown'
        }
    ];
}
const $e79dfc4fafbb8b7d$export$32995f7f943f794d = (patient)=>$e79dfc4fafbb8b7d$export$a487b6ce726ba33a(patient).filter((p)=>!p.isPrimary);
const $e79dfc4fafbb8b7d$export$c24576983605bfc4 = (p)=>p?.number || p?.raw || '';
function $e79dfc4fafbb8b7d$export$b9515c0624812164(patient, { locale: locale, formatDigits: formatDigits }) {
    return $e79dfc4fafbb8b7d$export$32995f7f943f794d(patient).map((p)=>{
        const number = formatDigits((0, $5AX1S).forDisplay($e79dfc4fafbb8b7d$export$c24576983605bfc4(p)));
        const relation = p.relation !== (0, $9Bif4.UNKNOWN_RELATION) ? (0, $9Bif4.phoneRelationLabel)(p.relation, locale) : '';
        return relation ? `${number} (${relation})` : number;
    }).join('\n');
}
function $e79dfc4fafbb8b7d$export$4c7ed4ffbca0595a(patient, query) {
    const digits = (0, $5JYPc.toEnDigits)(String(query || '')).replace(/\D/g, '');
    if (digits.length < 4) return null;
    const hit = (p)=>{
        const all = (0, $5JYPc.toEnDigits)($e79dfc4fafbb8b7d$export$c24576983605bfc4(p)).replace(/\D/g, '');
        const national = (0, $5JYPc.toEnDigits)((0, $5AX1S).forDisplay($e79dfc4fafbb8b7d$export$c24576983605bfc4(p))).replace(/\D/g, '');
        return all.includes(digits) || national.includes(digits);
    };
    const primary = $e79dfc4fafbb8b7d$export$a487b6ce726ba33a(patient).find((p)=>p.isPrimary);
    if (primary && hit(primary)) return null;
    if (!primary && patient?.phone && hit({
        raw: patient.phone
    })) return null;
    return $e79dfc4fafbb8b7d$export$32995f7f943f794d(patient).find(hit) || null;
}
// An ASCII number inside a sentence keeps its own direction (U+2068 FSI … U+2069 PDI).
const $e79dfc4fafbb8b7d$var$isolate = (s)=>`\u2068${s}\u2069`;
const $e79dfc4fafbb8b7d$export$8048ec2e23fc9eab = (p, { formatDigits: formatDigits })=>$e79dfc4fafbb8b7d$var$isolate(formatDigits((0, $5AX1S).forDisplay($e79dfc4fafbb8b7d$export$c24576983605bfc4(p))));
function $e79dfc4fafbb8b7d$export$605b9a4b19d7331b(patient, query, { t: t, locale: locale, formatDigits: formatDigits }) {
    const matched = $e79dfc4fafbb8b7d$export$4c7ed4ffbca0595a(patient, query);
    if (!matched) return patient?.phone ? formatDigits((0, $5AX1S).forDisplay(patient.phone)) : '';
    const phone = $e79dfc4fafbb8b7d$export$8048ec2e23fc9eab(matched, {
        formatDigits: formatDigits
    });
    const relation = matched.relation !== (0, $9Bif4.UNKNOWN_RELATION) ? (0, $9Bif4.phoneRelationLabel)(matched.relation, locale) : '';
    return relation ? t('patients.phones.matchedOnRelation', {
        phone: phone,
        relation: relation
    }) : t('patients.phones.matchedOn', {
        phone: phone
    });
}
const $e79dfc4fafbb8b7d$export$7dfbe58c2b40d749 = [
    'patient_request',
    'wrong_number',
    'not_theirs',
    'other'
];
const $e79dfc4fafbb8b7d$export$49762b9644aae445 = {
    patient_request: 'patients.phones.optOut.reason.patientRequest',
    wrong_number: 'patients.phones.optOut.reason.wrongNumber',
    not_theirs: 'patients.phones.optOut.reason.notTheirs',
    other: 'patients.phones.optOut.reason.other'
};
const $e79dfc4fafbb8b7d$var$IRAN_PREFIX = '+98';
const $e79dfc4fafbb8b7d$var$isIranian = (p)=>String(p?.number || '').startsWith($e79dfc4fafbb8b7d$var$IRAN_PREFIX);
// Ten digits starting with 9 after the plus: the SMS service reads them as an Iranian
// mobile that lost its zero, so no SMS goes to such a number (the BFF's READ_AS_IRANIAN).
const $e79dfc4fafbb8b7d$var$READ_AS_IRANIAN = /^\+9\d{9}$/;
const $e79dfc4fafbb8b7d$export$d97aa66f3793d5d0 = (patient)=>Array.isArray(patient?.phones) && patient.phones.every((p)=>Boolean(p.id));
function $e79dfc4fafbb8b7d$export$5599f828351a42ac(phone, channel, { foreign: foreign = false } = {}) {
    if (!phone) return 'channel';
    if (phone.optedOut) return 'optedOut';
    if (phone.landline) return 'landline';
    if (!phone.number && !foreign) return 'channel';
    if (channel === 'bale' && !$e79dfc4fafbb8b7d$var$isIranian(phone)) return 'channel';
    if (channel === 'sms' && $e79dfc4fafbb8b7d$var$READ_AS_IRANIAN.test(phone.number || '')) return 'channel';
    if (channel === 'whatsapp' && phone.whatsappKnown === 'no') return 'notOnWhatsapp';
    return null;
}
// The fallback order: the patient's own number before a relative's; on WhatsApp one the
// gateway said «yes» for before one never asked; a proven number first; then the order
// the record lists them in (primary, then oldest) — Array#sort keeps it.
const $e79dfc4fafbb8b7d$var$healthier = (channel)=>(a, b)=>Number($e79dfc4fafbb8b7d$export$e4dddeae01de7abb(b.relation || (0, $9Bif4.UNKNOWN_RELATION))) - Number($e79dfc4fafbb8b7d$export$e4dddeae01de7abb(a.relation || (0, $9Bif4.UNKNOWN_RELATION))) || (channel === 'whatsapp' ? Number(b.whatsappKnown === 'yes') - Number(a.whatsappKnown === 'yes') : 0) || Number(Boolean(b.verified)) - Number(Boolean(a.verified));
function $e79dfc4fafbb8b7d$export$18a4de44164e9c37(patient, channel, { phoneId: phoneId = '', foreign: foreign = false } = {}) {
    const refused = (reason)=>({
            phone: null,
            reason: reason
        });
    if (!$e79dfc4fafbb8b7d$export$d97aa66f3793d5d0(patient)) {
        if (!patient?.phone) return refused('noPhone');
        if (phoneId) return refused('changed');
        const whatsappKnown = patient.whatsappKnown || patient.contact?.whatsappKnown;
        if (channel === 'whatsapp' && whatsappKnown === 'no') return refused('notOnWhatsapp');
        return {
            phone: $e79dfc4fafbb8b7d$export$a487b6ce726ba33a({
                phone: patient.phone
            })[0],
            reason: null
        };
    }
    const route = {
        foreign: foreign
    };
    const phones = patient.phones;
    const blocked = (p)=>$e79dfc4fafbb8b7d$export$5599f828351a42ac(p, channel, route);
    // A number no channel here can use reads as no number for that channel.
    const asReason = (why)=>why === 'optedOut' || why === 'notOnWhatsapp' ? why : 'noPhone';
    if (phoneId) {
        const picked = phones.find((p)=>p.id === phoneId);
        if (!picked) return refused('changed');
        return blocked(picked) ? refused(asReason(blocked(picked))) : {
            phone: picked,
            reason: null
        };
    }
    if (!phones.length) return refused('noPhone');
    const primary = phones.find((p)=>p.isPrimary) || null;
    const usable = phones.filter((p)=>!blocked(p));
    const fallbacks = usable.filter((p)=>p !== primary && (p.verified || p.addedHere)).sort($e79dfc4fafbb8b7d$var$healthier(channel));
    let eligible = usable.includes(primary) ? [
        primary,
        ...fallbacks
    ] : fallbacks;
    if (channel === 'sms') eligible = [
        ...eligible.filter($e79dfc4fafbb8b7d$var$isIranian),
        ...eligible.filter((p)=>!$e79dfc4fafbb8b7d$var$isIranian(p))
    ];
    if (eligible.length) return {
        phone: eligible[0],
        reason: null
    };
    return refused(asReason(blocked(primary || phones[0])));
}
const $e79dfc4fafbb8b7d$export$78db9fe188cc1a9a = (phone)=>$e79dfc4fafbb8b7d$export$a50a7ecd1b89c066($e79dfc4fafbb8b7d$export$c24576983605bfc4(phone)) || $e79dfc4fafbb8b7d$export$c24576983605bfc4(phone) || null;
function $e79dfc4fafbb8b7d$export$43560479763ed953(err, rows, t) {
    const ext = err?.extensions || {};
    const code = ext.code;
    const keyAt = (index)=>Number.isInteger(index) && rows?.[index] ? rows[index].key : null;
    const onRow = (message)=>{
        const key = keyAt(ext.index);
        return key ? {
            rowErrors: {
                [key]: message
            },
            alert: ''
        } : {
            rowErrors: {},
            alert: message
        };
    };
    const out = (body)=>({
            code: code,
            conflicts: [],
            reload: false,
            rowErrors: {},
            alert: '',
            ...body
        });
    switch(code){
        case 'PHONE_HAS_PATIENTS':
            return out({
                conflicts: $e79dfc4fafbb8b7d$export$c6eb469b5d4a9e67(err)
            });
        case 'PHONE_INVALID':
            return out(onRow(t(ext.reason === 'primary' ? 'patients.phones.errors.onePrimary' : 'validation.phone.invalid')));
        case 'PHONE_DUPLICATE':
            return out(onRow(t('patients.phones.errors.duplicate')));
        case 'PHONE_RELATION_INVALID':
            return out(onRow(t('patients.phones.errors.relationRequired')));
        case 'PHONE_LIMIT':
            return out({
                alert: t('patients.phones.errors.limit', {
                    count: ext.max || $e79dfc4fafbb8b7d$export$82be57fd9bce7d58
                })
            });
        case 'PHONE_LOCKED':
            return out({
                alert: t(ext.reason === 'signin' ? 'patients.phones.errors.lockedSignin' : 'patients.phones.errors.locked')
            });
        case 'PHONE_LAST':
            return out({
                alert: t('patients.phones.errors.cannotRemoveLast')
            });
        case 'PHONES_CHANGED':
            return out({
                alert: t('patients.phones.errors.changed'),
                reload: true
            });
        case 'PHONE_LOOKUP_FAILED':
            return out({
                alert: t('patients.phones.errors.lookupFailed')
            });
        case 'PATIENT_MERGED':
            return out({
                alert: t('patients.phones.errors.merged')
            });
        case 'NOT_LINKED':
            return out({
                alert: t('patients.phones.errors.notLinked')
            });
        case 'TEXT_TOO_LONG':
            return ext.field === 'label' ? out(onRow(t('patients.phones.errors.labelTooLong', {
                max: ext.max || 40
            }))) : null;
        default:
            return null;
    }
}
function $e79dfc4fafbb8b7d$export$c6eb469b5d4a9e67(err) {
    const ext = err?.extensions || {};
    if (Array.isArray(ext.conflicts) && ext.conflicts.length) return ext.conflicts.map((c)=>({
            phone: c.phone || '',
            index: Number.isInteger(c.index) ? c.index : null,
            candidates: Array.isArray(c.candidates) ? c.candidates : []
        }));
    return [
        {
            phone: ext.phone || '',
            index: 0,
            candidates: Array.isArray(ext.candidates) ? ext.candidates : []
        }
    ];
}
function $e79dfc4fafbb8b7d$export$a208eaf9893a0938(conflict, rows) {
    const key = $e79dfc4fafbb8b7d$export$a50a7ecd1b89c066(conflict.phone);
    const byNumber = key ? rows.findIndex((row)=>$e79dfc4fafbb8b7d$export$a50a7ecd1b89c066(row.number) === key) : -1;
    if (byNumber >= 0) return byNumber;
    return Number.isInteger(conflict.index) && rows[conflict.index] ? conflict.index : -1;
}

});


parcelRegister("lM08I", function(module, exports) {

$parcel$export(module.exports, "getInitials", () => $fd9e30688f6b0704$export$de9bdbce6502b027);
$parcel$export(module.exports, "dayIsoOf", () => $fd9e30688f6b0704$export$8c029be8718dff8c);
$parcel$export(module.exports, "dayDateOf", () => $fd9e30688f6b0704$export$298c1b8d44d41d8b);
$parcel$export(module.exports, "slotInstant", () => $fd9e30688f6b0704$export$d98402ce8207e239);
$parcel$export(module.exports, "calendarDow", () => $fd9e30688f6b0704$export$ce24624bc849367);
$parcel$export(module.exports, "isClinicToday", () => $fd9e30688f6b0704$export$d4e360a7be208ef7);
$parcel$export(module.exports, "clinicDayWindow", () => $fd9e30688f6b0704$export$53fef2fc607424f9);
$parcel$export(module.exports, "dateToJalali", () => $fd9e30688f6b0704$export$6c7117de311dea57);
$parcel$export(module.exports, "jalaliToDate", () => $fd9e30688f6b0704$export$b5b735e3ea4c63f9);
$parcel$export(module.exports, "fmtJalaliLong", () => $fd9e30688f6b0704$export$df8c4cb1997dd4d1);
$parcel$export(module.exports, "doctorColor", () => $fd9e30688f6b0704$export$d006f9ca94139263);
$parcel$export(module.exports, "buildDoctorSlots", () => $fd9e30688f6b0704$export$fc853cd49ec9b081);
$parcel$export(module.exports, "jsToIrDow", () => $fd9e30688f6b0704$export$b4effe7a2c0cd716);
$parcel$export(module.exports, "doctorHasNoShift", () => $fd9e30688f6b0704$export$4b7b978749fcaf7b);
$parcel$export(module.exports, "doctorAbsentOn", () => $fd9e30688f6b0704$export$cfa32198737d018b);
$parcel$export(module.exports, "presenceSlots", () => $fd9e30688f6b0704$export$a20671c404e49c67);
$parcel$export(module.exports, "freeSlots", () => $fd9e30688f6b0704$export$7820b05a2f60d3d9);
$parcel$export(module.exports, "fmtJalaliShort", () => $fd9e30688f6b0704$export$44702b5df12fcab);
$parcel$export(module.exports, "serviceLabelOf", () => $fd9e30688f6b0704$export$87ed3a9f4cf37d01);
$parcel$export(module.exports, "plannableServices", () => $fd9e30688f6b0704$export$764ea1b83dc3a4e9);
parcelRequire("dNNpt");
var $4UJrq = parcelRequire("4UJrq");

var $5qKOB = parcelRequire("5qKOB");

var $c2icR = parcelRequire("c2icR");
function $fd9e30688f6b0704$export$de9bdbce6502b027(name = '') {
    const w = name.trim().split(/\s+/);
    return w.length >= 2 ? (w[0][0] || '') + (w[w.length - 1][0] || '') : (w[0] || '?')[0];
}
// ── The booking grid's day and hour, on the CLINIC's clock (PM-0088) ──────────
//
// A grid day travels as a Date in one of two shapes: a CALENDAR date (UTC midnight
// of that Gregorian day — what `jalaliToDate` returns) or an INSTANT («now», a
// slot's own dateTime). `dayIsoOf` reads either as the clinic's calendar day, and
// every slot instant is built from that day and the slot's wall time with
// `slotInstant` — never with `setHours`, which used the BROWSER's zone: a desk
// whose computer was not on Tehran time booked every slot off by its offset.
const $fd9e30688f6b0704$var$isUtcMidnight = (d)=>d.getUTCHours() === 0 && d.getUTCMinutes() === 0 && d.getUTCSeconds() === 0 && d.getUTCMilliseconds() === 0;
function $fd9e30688f6b0704$export$8c029be8718dff8c(day) {
    const d = day instanceof Date ? day : new Date(Number(day));
    if (Number.isNaN(d.getTime())) return '';
    return $fd9e30688f6b0704$var$isUtcMidnight(d) ? d.toISOString().slice(0, 10) : (0, $5qKOB.isoDayOf)(d.getTime());
}
function $fd9e30688f6b0704$export$298c1b8d44d41d8b(iso) {
    return new Date(`${iso}T00:00:00Z`);
}
function $fd9e30688f6b0704$export$d98402ce8207e239(day, h, m = 0) {
    return (0, $5qKOB.wallToMs)($fd9e30688f6b0704$export$8c029be8718dff8c(day), h * 60 + m);
}
function $fd9e30688f6b0704$export$ce24624bc849367(day) {
    return new Date(`${$fd9e30688f6b0704$export$8c029be8718dff8c(day)}T12:00:00Z`).getUTCDay();
}
function $fd9e30688f6b0704$export$d4e360a7be208ef7(day, nowMs = Date.now()) {
    return $fd9e30688f6b0704$export$8c029be8718dff8c(day) === (0, $5qKOB.clinicTodayIso)(nowMs);
}
function $fd9e30688f6b0704$export$53fef2fc607424f9(day) {
    const iso = $fd9e30688f6b0704$export$8c029be8718dff8c(day);
    return {
        startTime: String((0, $5qKOB.wallToMs)(iso, 0)),
        endTime: String((0, $5qKOB.wallToMs)((0, $5qKOB.addDaysIso)(iso, 1), 0) - 1)
    };
}
function $fd9e30688f6b0704$export$6c7117de311dea57(date) {
    const iso = $fd9e30688f6b0704$export$8c029be8718dff8c(date);
    return iso && (0, $4UJrq.msToJalali)(Date.parse(`${iso}T00:00:00Z`)) || {
        y: 1404,
        m: 1,
        d: 1
    };
}
function $fd9e30688f6b0704$export$b5b735e3ea4c63f9(jy, jm, jd) {
    return new Date((0, $4UJrq.jalaliToMs)(jy, jm, jd));
}
function $fd9e30688f6b0704$export$df8c4cb1997dd4d1(date, formatDate) {
    return formatDate(date, 'full');
}
function $fd9e30688f6b0704$export$d006f9ca94139263(doctorId = '') {
    let hash = 0;
    for (const ch of doctorId)hash = hash * 31 + ch.charCodeAt(0) >>> 0;
    return (0, $c2icR.DOC_COLORS)[hash % (0, $c2icR.DOC_COLORS).length];
}
// The first grid point of the day: START_HOUR stepped back by whole visits until one
// more step would cross midnight. 0 for 10/15/20/30/60; 00:30 for 45; 00:05 for 19.
function $fd9e30688f6b0704$var$gridStartMin(step) {
    return (0, $c2icR.START_HOUR) * 60 % step;
}
function $fd9e30688f6b0704$export$fc853cd49ec9b081(intervalMin = 30, fromMin = 0, toMin = (0, $c2icR.DAY_MIN)) {
    const step = Math.max(1, Math.floor(intervalMin) || 30);
    const slots = [];
    for(let abs = $fd9e30688f6b0704$var$gridStartMin(step); abs < toMin; abs += step){
        if (abs < fromMin) continue;
        const h = Math.floor(abs / 60);
        const m = abs % 60;
        slots.push({
            h: h,
            m: m,
            label: `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`
        });
    }
    return slots;
}
function $fd9e30688f6b0704$export$b4effe7a2c0cd716(jsDay) {
    return (jsDay + 1) % 7;
}
// The doctor's presence windows on an Iranian dow as [start, end) minutes, with
// touching or overlapping ones merged: a shift entered as 09:00–12:00 + 12:00–15:00 is
// one continuous morning, not two that end and begin at noon. Same rule as
// _merge_windows in the scheduling service.
function $fd9e30688f6b0704$var$presenceWindowsOn(presences = [], irDow) {
    const windows = presences.filter((p)=>p.dayOfWeek === irDow).map((p)=>{
        const [sh, sm] = p.startTime.split(':').map(Number);
        const [eh, em] = p.endTime.split(':').map(Number);
        return [
            sh * 60 + sm,
            eh * 60 + em
        ];
    }).sort((a, b)=>a[0] - b[0]);
    const merged = [];
    for (const [start, end] of windows){
        const last = merged[merged.length - 1];
        if (last && start <= last[1]) last[1] = Math.max(last[1], end);
        else merged.push([
            start,
            end
        ]);
    }
    return merged;
}
function $fd9e30688f6b0704$export$55744ce5424bbe42(h, m, presences = [], irDow) {
    const start = h * 60 + m;
    return $fd9e30688f6b0704$var$presenceWindowsOn(presences, irDow).some(([ws, we])=>ws <= start && start < we);
}
function $fd9e30688f6b0704$export$4b7b978749fcaf7b(presences) {
    return !Array.isArray(presences) || presences.length === 0;
}
function $fd9e30688f6b0704$export$cfa32198737d018b(presences, irDow) {
    if ($fd9e30688f6b0704$export$4b7b978749fcaf7b(presences)) return true;
    return !presences.some((p)=>p.dayOfWeek === irDow);
}
function $fd9e30688f6b0704$export$a20671c404e49c67(slots, presences, irDow) {
    if ($fd9e30688f6b0704$export$4b7b978749fcaf7b(presences)) return [];
    return slots.filter((s)=>$fd9e30688f6b0704$export$55744ce5424bbe42(s.h, s.m, presences, irDow));
}
function $fd9e30688f6b0704$export$7820b05a2f60d3d9(slots, dayBaseDate, slotMin, booked) {
    if (!booked || booked.length === 0) return slots;
    const slotMs = slotMin * 60000;
    return slots.filter((s)=>{
        const startMs = $fd9e30688f6b0704$export$d98402ce8207e239(dayBaseDate, s.h, s.m);
        const endMs = startMs + slotMs;
        return !booked.some((b)=>{
            const bEnd = b.startMs + (b.durMin || slotMin) * 60000;
            return startMs < bEnd && endMs > b.startMs;
        });
    });
}
function $fd9e30688f6b0704$export$a392a4d505a30a2a(timeStr, intervalMin = 30) {
    if (!timeStr) return null;
    const [h, m] = timeStr.split(':').map(Number);
    if (!Number.isFinite(h) || !Number.isFinite(m)) return null;
    const step = Math.max(1, Math.floor(intervalMin) || 30);
    const first = $fd9e30688f6b0704$var$gridStartMin(step);
    const abs = h * 60 + m;
    // Before the day's first grid point there is no slot to snap to; report the
    // time unchanged rather than inventing one above it.
    if (abs < first) return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
    const rounded = first + Math.floor((abs - first) / step) * step;
    const rh = Math.floor(rounded / 60);
    const rm = rounded % 60;
    if (rh >= 24) return null;
    return `${String(rh).padStart(2, '0')}:${String(rm).padStart(2, '0')}`;
}
function $fd9e30688f6b0704$export$44702b5df12fcab(date, formatDate) {
    return formatDate(date, 'dayMonth');
}
function $fd9e30688f6b0704$export$87ed3a9f4cf37d01(svc, t, formatMoney) {
    if (!svc) return '';
    const name = svc.description || '';
    if (!(svc.unitPrice > 0)) return `${name} \u{2014} ${t('calendar.booking.serviceNoPrice')}`;
    const price = t('calendar.booking.servicePrice', {
        amount: formatMoney(svc.unitPrice, {
            currency: svc?.currency
        })
    });
    return svc.priceIsPersonal ? `${name} \u{2014} ${price} (${t('calendar.booking.personalPrice')})` : `${name} \u{2014} ${price}`;
}
function $fd9e30688f6b0704$export$764ea1b83dc3a4e9(declared, doctorId) {
    const byCatalog = new Map();
    for (const svc of declared || []){
        if (!svc?.catalogId || svc.isActive === false || !(svc.unitPrice > 0)) continue;
        if (svc.orderType === 'consultation') continue;
        const personal = !!svc.doctorId;
        if (personal && svc.doctorId !== doctorId) continue;
        const cur = byCatalog.get(svc.catalogId);
        // A personal row replaces a clinic-wide one; the first of two equals stays.
        if (!cur || personal && !cur.doctorId) byCatalog.set(svc.catalogId, svc);
    }
    return [
        ...byCatalog.values()
    ];
}

});

parcelRegister("PQAaX", function(module, exports) {

$parcel$export(module.exports, "default", () => $5902d1369013fea3$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("7c6z4");
var $cMRsf = parcelRequire("cMRsf");
var $e1LEq = parcelRequire("e1LEq");

var $acw62 = parcelRequire("acw62");
parcelRequire("52bn2");
var $jTCZr = parcelRequire("jTCZr");
parcelRequire("9RYGc");
var $jTCZr = parcelRequire("jTCZr");

var $c2icR = parcelRequire("c2icR");

var $e6t5J = parcelRequire("e6t5J");

var $lM08I = parcelRequire("lM08I");

var $2Mst8 = parcelRequire("2Mst8");
parcelRequire("dNNpt");
var $4UJrq = parcelRequire("4UJrq");
parcelRequire("5N0ZI");
var $cjPik = parcelRequire("cjPik");
var $7phmx = parcelRequire("7phmx");
var $4Qco3 = parcelRequire("4Qco3");
var $Ydgp5 = parcelRequire("Ydgp5");
var $5AX1S = parcelRequire("5AX1S");
var $66joL = parcelRequire("66joL");

var $eLeza = parcelRequire("eLeza");

var $iRTrY = parcelRequire("iRTrY");
parcelRequire("bLQhC");
var $5JYPc = parcelRequire("5JYPc");

var $7GAiB = parcelRequire("7GAiB");

var $228nw = parcelRequire("228nw");

var $hGTfp = parcelRequire("hGTfp");

var $k7Ymn = parcelRequire("k7Ymn");
parcelRequire("9h2jQ");
var $k27hS = parcelRequire("k27hS");

var $1DJld = parcelRequire("1DJld");

var $dgZRs = parcelRequire("dgZRs");

var $1zLkf = parcelRequire("1zLkf");

var $9qvnH = parcelRequire("9qvnH");

var $fk1mD = parcelRequire("fk1mD");

var $kZuTn = parcelRequire("kZuTn");

var $2YFrP = parcelRequire("2YFrP");

var $5JA6O = parcelRequire("5JA6O");

var $iNs7v = parcelRequire("iNs7v");

var $2MpEq = parcelRequire("2MpEq");

var $6P09x = parcelRequire("6P09x");

var $jVdQx = parcelRequire("jVdQx");

var $jmIrn = parcelRequire("jmIrn");

var $7guRV = parcelRequire("7guRV");

var $2xQve = parcelRequire("2xQve");

var $dNtjz = parcelRequire("dNtjz");

var $gXHpd = parcelRequire("gXHpd");

var $wuSZs = parcelRequire("wuSZs");

var $j5293 = parcelRequire("j5293");

var $5qKOB = parcelRequire("5qKOB");
// The clinic's next شماره پرونده — same suggestion endpoint AddPatient/CompleteFileModal
// use. A SUGGESTION only: nothing is reserved until the patient is actually saved.
const $5902d1369013fea3$var$NEXT_FILE_NUMBER = `
  query NextFileNumber {
    nextFileNumber
  }
`;
const $5902d1369013fea3$var$PATIENTS_SEARCH = `
  query SearchPatients($search: String) {
    patients(search: $search) { id name phone nationalId fileNumber }
  }
`;
const $5902d1369013fea3$var$ChevronDown = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: (0, $jTCZr.C).textMuted,
        width: "13",
        height: "13",
        style: {
            position: 'absolute',
            left: 8,
            top: '50%',
            transform: 'translateY(-50%)',
            pointerEvents: 'none'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M7 10l5 5 5-5z"
        })
    });
// Patient identification, two ways. «ثبت سریع» (a slot booked on a marker, with no
// patient record) was removed from this modal at K1's request (2026-10-06); rows booked
// that way before still exist and are completed through «تکمیل پرونده».
const $5902d1369013fea3$var$PATIENT_MODES = (t)=>[
        {
            key: 'existing',
            label: t('calendar.tabs.existingPatient')
        },
        {
            key: 'new',
            label: t('patients.actions.newPatient')
        }
    ];
function $5902d1369013fea3$export$2e2bcd8739ae039({ doctor: doctor, initialDate: initialDate, initialSlotLabel: initialSlotLabel, timeSlots: timeSlots, allowFirstAvailable: allowFirstAvailable = false, onClose: onClose, onSubmit: onSubmitProp, lockedPatient: // ── «تأیید با زمان دیگر» (PATIENT_CLINIC_CARE_CONTEXT §9.1) ──────────────
// A patient the caller has already decided on: the three patient modes
// collapse to an identity line, because the question this modal is being
// opened to answer is only WHEN. Its shape is the one `patientInfo` takes on
// submit — { id, name, phone } — so nothing downstream has to know the modal
// was preset.
lockedPatient = null, heldSlots: // Epoch-ms instants (as strings) this practitioner already holds for a
// patient REQUEST. Not a filter: a held slot stays selectable and the modal
// warns instead (E8), because the desk may legitimately mean to take it —
// and «silently unavailable» is how a request becomes invisible work.
heldSlots = null, submitLabel: // What the primary button says when this is a confirmation rather than a
// fresh booking. Persian lives in the caller's catalogue, never here.
submitLabel = null, offerNotification: // «ارسال اعلان به بیمار». Off for «تأیید با زمان دیگر»: that patient asked from the
// app, and the app is how they hear the answer.
offerNotification = true, phoneConflict: // `{ phone, candidates }` from the caller's `addPatient` refusal (PHONE_HAS_PATIENTS):
// the number gained records the desk never answered for. A new object each time,
// so a second refusal re-opens the question.
phoneConflict = null, service: // ── A SESSION of a service a doctor ordered («اقدام‌های درمانی» › «نوبت بده») ──
// `{ label, meta }`. The service is decided — the order names it — so it is shown
// as a fact, not picked, and everything that belongs to a VISIT goes: visit type,
// «خدمت نوبت», planned services, the insurance quote (the BFF prices the session
// from its own declaration), «خارج از نوبت» and the notice (bookServiceSession
// carries neither). `doctor` is then the PERFORMER, who may be a coworker rather
// than a doctor — `doctor.shiftless` says they are held to no shift.
// `service.notice` is a refusal the booking already met and must be read before
// another try — «مرحلهٔ قبلی این پروسه هنوز انجام نشده است» for a step of a
// treatment process that is not ready (ORDER_NOT_READY). Shown under the service.
service = null, notice: // A node the caller wants read BEFORE the form — «منشی هوشمند» uses it to say the
// form was prefilled by AI (DESIGN_CONCEPT §13.3). Rendered above the time step.
notice = null, offerDeposit: // «پیش‌پرداخت» (PM-0657 §6.2): offer the deposit block. Only a fresh desk
// booking asks for it (never an edit, a confirmation or a session); the answer
// travels to `onSubmit` as `deposit: { amountRial, paymentMethod,
// referenceNumber, requestId } | null` and the CALLER records it after the
// booking, because a refused deposit must not cost the نوبت.
offerDeposit = false, presetNewPatient: // `{ name, phone, nationalId, insurerId }` — a patient with no record yet, as
// «منشی هوشمند» heard them. The patient step opens on «بیمار جدید» with what was said
// in place; the desk checks it and fills the rest, and the submit is unchanged.
presetNewPatient = null, editing: // ── «ویرایش نوبت» (PM-0102) ─────────────────────────────────────────────────
// `{ appointmentId, note }` — an appointment that already EXISTS. The patient
// and the practitioner are facts of that row (`lockedPatient`, `doctor`), so
// the form is the two things the desk may change on it: WHEN, and the note.
// What the visit is FOR, its type and its insurance are not asked again — the
// service has its own op («تغییر خدمت») and its own money rules. The time is
// sent only when the desk touched it: `onSubmit({ dateTimeMs: null, … })`
// means «the hour stays», so correcting a note never moves a نوبت that sits
// off this grid.
editing = null, engine: // ── The slot ENGINE (PM-0600: the service-first dialog's features, in this form) ──
// `{ performer: { type, id }, entries, doctorRow }` — the person being booked and
// the services they perform (`bookingEngine.groupBookableServices`). Present, the
// «خدمت نوبت» field lists THOSE services, each on its own length; the hours come
// from `bookableSlots` (the shift's own anchors, the service's window, every live
// booking); an hour the shift admits but the service does not is offered marked
// and asked about; a QUEUE service takes a same-day turn instead of an hour.
engine = null }) {
    const { t: t, formatMoney: formatMoney, formatDigits: formatDigits } = (0, $e1LEq.default)();
    const serviceMode = !!service;
    const editMode = !!editing;
    const engineMode = !!engine && !serviceMode && !editMode;
    const notifyOn = offerNotification && !serviceMode;
    // «خدمت نوبت» on the engine: the person's visit first — the 90 % — else their first service.
    const engineEntries = engineMode ? engine.entries : [];
    const [entryId, setEntryId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const entry = engineMode ? engineEntries.find((e)=>e.catalogId === entryId) || engineEntries.find((e)=>e.orderType === 'consultation') || engineEntries[0] || null : null;
    const engineDuration = engineMode ? (0, $gXHpd.resolveDuration)(entry, engine.performer, engine.doctorRow) : null;
    // The engine never guesses a length; a declaration written before lengths existed
    // reads as the 30 minutes it was written with (bookingEngine.entryFromOrder does the same).
    const engineMinutes = engineMode ? engineDuration.minutes || 30 : null;
    const queue = engineMode && entry?.schedulingMode === 'QUEUE';
    const engineRow = engineMode ? (0, $gXHpd.performerRow)(entry, engine.performer) : null;
    const [engineKey, setEngineKey] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    // An hour outside the service's window: asked about once (`outsideAsk`), then held.
    const [outsideAsk, setOutsideAsk] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [allowOutside, setAllowOutside] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    timeSlots = timeSlots || (0, $c2icR.TIME_SLOTS);
    const slotMin = timeSlots[1] ? timeSlots[1].h * 60 + timeSlots[1].m - (timeSlots[0].h * 60 + timeSlots[0].m) : 30;
    const initJ = (0, $lM08I.dateToJalali)(initialDate);
    const todayJ = (0, $lM08I.dateToJalali)(new Date());
    const years = [
        todayJ.y,
        todayJ.y + 1
    ];
    const [jYear, setJYear] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(initJ.y);
    const [jMonth, setJMonth] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(initJ.m);
    const [jDay, setJDay] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(initJ.d);
    const maxDay = (0, $4UJrq.jDaysInMonth)(jYear, jMonth);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (jDay > maxDay) setJDay(maxDay);
    }, [
        jYear,
        jMonth,
        maxDay
    ]);
    const selectedGDate = (0, $lM08I.jalaliToDate)(jYear, jMonth, jDay);
    // 'manual' = pick a time from the grid; 'firstOfDay'/'firstAny' = «اولین نوبت» auto-pick.
    // Auto-pick is the default when allowed and no slot was pre-clicked — booking the day's
    // first free slot is the common case. Opening the modal *on* a slot means one was chosen.
    const [slotMode, setSlotMode] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(allowFirstAvailable && !initialSlotLabel ? 'firstOfDay' : 'manual');
    const isAuto = allowFirstAvailable && slotMode !== 'manual';
    // The booking opens on «اولین نوبت امروز» with everything else folded away, on
    // the desk exactly as on the phone (PM-0030): the mode row, the day and «خارج از
    // نوبت» sit behind one disclosure, and the optional extras (planned services,
    // notification, note) behind another. A modal that opens in «انتخاب دستی» (a
    // pre-clicked slot) opens its time options, since the desk came here to pick a time.
    const foldTime = allowFirstAvailable;
    const [timeOptionsOpen, setTimeOptionsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(slotMode !== 'firstOfDay');
    // An edit opens its extras: the note is one of the two things it is for.
    const [moreOpen, setMoreOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(editMode);
    // «ویرایش نوبت»: has the desk asked for another time? Until it has, the grid
    // only SHOWS where the نوبت is and nothing about the time is sent.
    const [timeTouched, setTimeTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const touching = (set)=>(v)=>{
            setTimeTouched(true);
            set(v);
        };
    // «خارج از نوبت» — the same row in every tab, meaning what that tab can mean: a
    // DAY with no hour in «انتخاب دستی», and «همین الان» in the auto tabs, where the
    // patient is at the desk (PM-0056: it sits outside the folded time options, so it
    // is one tap away whichever tab is open). A service session has no such answer.
    const untimedMode = slotMode === 'manual' ? (0, $k7Ymn.UNTIMED_DAY) : (0, $k7Ymn.UNTIMED_NOW);
    const untimed = (0, $k7Ymn.useUntimed)(untimedMode);
    // …and neither has an edit: «خارج از نوبت» is a way of BOOKING, not a time to move to.
    const offerUntimed = !serviceMode && !editMode;
    const isUntimed = offerUntimed && untimed.on;
    // A booking that came back "nothing free today" — the walk-in is now the suggestion.
    const [todayFull, setTodayFull] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const { isMobile: isMobile } = (0, $k27hS.default)();
    // Another doctor is another diary.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setTodayFull(false);
    }, [
        doctor.id
    ]);
    // The honest, selectable grid: presence-filtered and with booked slots removed. Skipped
    // (doctorId null) while auto-picking, since the grid isn't shown then.
    // Skipped (doctorId null) while auto-picking OR while «خارج از نوبت» is on: neither
    // shows the grid, and the day's booked list is only read to thin it out.
    const legacyGrid = (0, $228nw.useSelectableSlots)({
        doctorId: isAuto || isUntimed || engineMode ? null : doctor.id,
        presences: doctor.presences,
        shiftless: !!doctor.shiftless,
        timeSlots: timeSlots,
        selectedDate: selectedGDate,
        slotMin: slotMin,
        excludeAppointmentId: editing?.appointmentId || null
    });
    // ── The engine's day (PM-0600) ─────────────────────────────────────────────
    // One read of the chosen day serves the grid AND «اولین نوبت امروز»: the first
    // free cell of that day is the auto-pick, so the two cannot disagree. Cells keep
    // the shape the grid already draws ({ label, h, m }) plus their instant: the
    // instant is the engine's, never rebuilt from the label.
    const engineDayIso = (0, $lM08I.dayIsoOf)(selectedGDate);
    const dayRead = (0, $dNtjz.useBookableSlots)({
        enabled: engineMode && !queue && !isUntimed,
        serviceCatalogId: entry?.catalogId || null,
        performer: engineMode ? engine.performer : null,
        fromDate: engineDayIso,
        days: 1,
        durationMinutes: engineMinutes,
        refreshKey: engineKey
    });
    const engineCells = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (!engineMode) return [];
        const nowMs = Date.now();
        const day = (dayRead.days || []).find((d)=>d.date === engineDayIso);
        return (day?.slots || []).filter((x)=>Number(x.startMs) > nowMs && (x.free || x.reason === 'OUTSIDE_SERVICE_WINDOW')).map((x)=>{
            const ms = Number(x.startMs);
            const min = (0, $5qKOB.clinicMinuteOfDay)(ms);
            const h = Math.floor(min / 60), m = min % 60;
            return {
                label: `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`,
                h: h,
                m: m,
                ms: ms,
                held: !x.free
            };
        });
    }, [
        engineMode,
        dayRead.days,
        engineDayIso
    ]);
    const engineDayHasShift = engineMode && ((dayRead.days || []).find((d)=>d.date === engineDayIso)?.slots || []).length > 0;
    const engineDayReady = engineMode && dayRead.ready && !dayRead.loading;
    // The grid's four answers, from whichever source this booking reads.
    const availSlots = engineMode ? engineCells : legacyGrid.slots;
    const slotsLoading = engineMode ? dayRead.loading : legacyGrid.loading;
    const noShift = engineMode ? false : legacyGrid.noShift;
    const absent = engineMode ? engineDayReady && !dayRead.error && !engineDayHasShift : legacyGrid.absent;
    const allBooked = engineMode ? engineDayReady && engineDayHasShift && engineCells.length === 0 : legacyGrid.allBooked;
    const [selTime, setSelTime] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(initialSlotLabel || null);
    // Once an hour is CHOSEN, it is all the grid shows — fifty buttons around a decided
    // hour are noise on a form that should read in a glance (clinic CLAUDE.md §4.3).
    // Chosen: the hour the form was opened on («منشی هوشمند»'s proposal), or one the
    // desk picked from the grid. The grid opens again on «ساعت‌های دیگر», on another
    // day and on «انتخاب دستی» — each is the desk going looking — and whenever the
    // chosen hour is no longer free. An edit opens on its grid: moving the hour is
    // what it is for; it closes on the new hour like any other pick.
    const [gridClosed, setGridClosed] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(!!initialSlotLabel && !editMode);
    const slotsCollapsed = gridClosed && !!selTime && availSlots.some((s)=>s.label === selTime);
    const lookingAgain = (set)=>(v)=>{
            setGridClosed(false);
            set(v);
        };
    // Keep the manual selection valid as the day (and therefore the free slots) change: keep
    // the current pick if it survived, else fall to the first free slot, else nothing.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (isAuto) return;
        // An edit nobody has re-timed marks the hour the نوبت HAS, when the grid can
        // show it, and otherwise marks nothing — never the first free slot, which
        // would be a move the desk did not ask for.
        if (editMode && !timeTouched) {
            setSelTime(availSlots.find((s)=>s.label === initialSlotLabel) ? initialSlotLabel : null);
            return;
        }
        if (availSlots.length === 0) {
            setSelTime(null);
            return;
        }
        // An hour outside the service's window is never chosen FOR the desk — it is asked about.
        const firstPlain = availSlots.find((s)=>!s.held);
        if (!availSlots.find((s)=>s.label === selTime)) setSelTime(firstPlain ? firstPlain.label : null);
    }, [
        availSlots,
        isAuto,
        timeTouched
    ]);
    // DAY anchor is noon of the selected day ON THE CLINIC'S CLOCK (PM-0088), so the
    // service resolves the same calendar day whatever the browser's zone; ANY anchors
    // at "now".
    const fromDateTime = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (slotMode === 'firstOfDay') return String((0, $lM08I.slotInstant)((0, $lM08I.jalaliToDate)(jYear, jMonth, jDay), 12, 0));
        return String(Date.now());
    }, [
        slotMode,
        jYear,
        jMonth,
        jDay
    ]);
    // A visit's «اولین نوبت» is the server's (the doctor's shift, at his visit length);
    // a service session's is searched here, on the performer, at the service's length
    // (FirstSlotPicker: useFirstPerformerSlot). Both hooks mount; one is enabled.
    const wantPreview = isAuto && !isUntimed && !!doctor.id && !engineMode;
    const doctorPreview = (0, $7GAiB.useFirstAvailableSlot)(wantPreview && !serviceMode, doctor.id, fromDateTime, (0, $7GAiB.slotModeScope)(slotMode));
    const performerOpts = {
        providerId: doctor.id,
        presences: doctor.presences,
        shiftless: !!doctor.shiftless,
        timeSlots: timeSlots,
        slotMin: slotMin
    };
    const performerPreview = (0, $7GAiB.useFirstPerformerSlot)({
        ...performerOpts,
        enabled: wantPreview && serviceMode,
        fromDateTime: fromDateTime,
        scope: (0, $7GAiB.slotModeScope)(slotMode)
    });
    const enginePreview = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const hit = engineCells.find((c)=>!c.held);
        return {
            slot: hit ? {
                dateTime: String(hit.ms)
            } : null,
            loading: dayRead.loading || !dayRead.ready,
            error: !!dayRead.error
        };
    }, [
        engineCells,
        dayRead.loading,
        dayRead.ready,
        dayRead.error
    ]);
    const preview = engineMode ? enginePreview : serviceMode ? performerPreview : doctorPreview;
    const previewEmpty = isAuto && !isUntimed && !preview.loading && !preview.error && !preview.slot;
    // The date picker sits on today until the desk moves it — which is what «اولین نوبت
    // امروز» is named after, and what makes "the day is over" the right thing to say.
    const dayIsToday = jYear === todayJ.y && jMonth === todayJ.m && jDay === todayJ.d;
    // «خارج از نوبت» LEADS when the doctor has nothing free where this would land.
    const untimedLeads = offerUntimed && (0, $k7Ymn.untimedSuggested)({
        mode: untimedMode,
        slotMode: slotMode,
        dayIsToday: dayIsToday,
        previewEmpty: previewEmpty,
        allBooked: slotMode === 'manual' && !slotsLoading && allBooked,
        todayFull: todayFull
    });
    // Only when the day itself came back empty: where the doctor's next real slot is.
    const wantNext = slotMode === 'firstOfDay' && previewEmpty && !isUntimed && !!doctor.id;
    const doctorNext = (0, $7GAiB.useNextAvailableSlot)(wantNext && !serviceMode && !engineMode, doctor.id);
    const performerNext = (0, $7GAiB.useNextPerformerSlot)(wantNext && serviceMode, performerOpts);
    const nextRead = (0, $dNtjz.useBookableSlots)({
        enabled: engineMode && wantNext && !queue,
        serviceCatalogId: entry?.catalogId || null,
        performer: engineMode ? engine.performer : null,
        fromDate: (0, $5qKOB.addDaysIso)(engineDayIso, 1),
        days: 14,
        durationMinutes: engineMinutes,
        refreshKey: engineKey
    });
    const engineNext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const hit = (0, $gXHpd.firstFree)(nextRead.days, Date.now());
        return {
            loading: nextRead.loading,
            error: !!nextRead.error,
            slot: hit ? {
                dateTime: String(hit.startMs)
            } : null
        };
    }, [
        nextRead.days,
        nextRead.loading,
        nextRead.error
    ]);
    const nextAvailable = engineMode ? engineNext : serviceMode ? performerNext : doctorNext;
    // «رزرو همین نوبت» on the empty-day card moves the day to the slot's own day —
    // the day-scoped search there finds that same first free slot.
    const takeNextSlot = (slot)=>{
        if (!slot?.dateTime) return;
        const j = (0, $lM08I.dateToJalali)(new Date(Number(slot.dateTime)));
        setJYear(j.y);
        setJMonth(j.m);
        setJDay(j.d);
    };
    // Visit type
    const [visitType, setVisitType] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('in_person');
    // ── Patient (step 2) ─────────────────────────────────────────────────────────
    const [mode, setMode] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(presetNewPatient ? 'new' : 'existing'); // 'existing' | 'new'
    // A preset patient is not a third mode: it REMOVES the question. The two
    // tabs, the search and the registration form all describe "which patient",
    // and here that is already answered.
    // An edit is locked the same way even on a «ثبت سریع» row, whose subject is a
    // label and not a patient id.
    const patientLocked = !!lockedPatient?.id || editMode && !!lockedPatient;
    // Existing patient search
    const [searchQ, setSearchQ] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [searchRes, setSearchRes] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [searching, setSearching] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [selPatient, setSelPatient] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (searchQ.length < 2) {
            setSearchRes([]);
            return;
        }
        const t = setTimeout(async ()=>{
            setSearching(true);
            try {
                // A شماره پرونده is typed on a Persian keyboard and stored in ASCII.
                const data = await (0, $2Mst8.bffQuery)($5902d1369013fea3$var$PATIENTS_SEARCH, {
                    search: (0, $5JYPc.toEnDigits)(searchQ.trim())
                });
                setSearchRes(data?.patients || []);
            } finally{
                setSearching(false);
            }
        }, 350);
        return ()=>clearTimeout(t);
    }, [
        searchQ
    ]);
    // New patient — same required fields as the ثبت بیمار جدید screen, so a patient registered
    // from a booking is a first-class record.
    const [newName, setNewName] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(presetNewPatient?.name || '');
    const [newPhone, setNewPhone] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [newNid, setNewNid] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(presetNewPatient?.nationalId || '');
    // The issuing country — the clinic's unless the desk picked another (PM-0076).
    const [newNidCountry, setNewNidCountry] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [newInsurer, setNewInsurer] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(presetNewPatient?.insurerId || '');
    const [newFileNumber, setNewFileNumber] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [fnBusy, setFnBusy] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // The number the desk said they are registering someone NEW on, despite its records.
    const [sharedPhone, setSharedPhone] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    // Set when an unlinked record was just added to this clinic from the phone lookup,
    // so the existing-patient view can say where the patient came from.
    const [linkedFrom, setLinkedFrom] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const suggestFileNumber = async ()=>{
        setFnBusy(true);
        try {
            const data = await (0, $2Mst8.bffQuery)($5902d1369013fea3$var$NEXT_FILE_NUMBER);
            if (data?.nextFileNumber) setNewFileNumber(data.nextFileNumber);
        } catch  {
        // A suggestion we could not fetch is not a failure to register — the desk
        // types their own number, or leaves it blank.
        } finally{
            setFnBusy(false);
        }
    };
    // Where the clinic is. Abroad, «بیمار جدید» drops Iran: the mobile starts on
    // the clinic's country and the insurers are self-pay alone
    // (hooks/useClinicRegion.js).
    const region = (0, $9qvnH.useClinicRegion)();
    // The kit's rule (PM-0076). Persian digits are read, not dropped — the old
    // `digitsOnly` deleted them and the code never reached the server (PM-0077).
    // The country: the desk's pick on the field's chip, else the clinic's — its
    // country's rule where the profile states one (PM-0218), else its region's.
    const countryDefaults = (0, $fk1mD.useCountryDefaults)();
    const nidCountry = (0, $6P09x.nidCountryFor)(newNidCountry, region, countryDefaults.nationalIdCountry);
    const nidInvalid = (0, $6P09x.nidProblem)(newNid, nidCountry) === 'invalid';
    // The country the new mobile starts on, and a dictated national number is read in.
    const phoneCountry = countryDefaults.phoneCountry || region.country || null;
    // Self-pay is the ONE insurer offered abroad, so it is the answer until the
    // desk gives another — derived rather than written into state, so a clinic
    // whose office line turns out to be Iranian goes back to asking.
    const insurerChoice = newInsurer || (region.iran ? '' : (0, $kZuTn.SELF_PAY_INSURER_ID));
    // The mobile «منشی هوشمند» heard, read in the clinic's country once it is known —
    // «۰۷۷۰…» at a clinic in Baghdad is an Iraqi number, not a broken Iranian one. Never
    // over what the desk has typed meanwhile.
    const presetPhone = presetNewPatient?.phone || '';
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!presetPhone) return;
        const e164 = (0, $5AX1S).normalizePhone(presetPhone, phoneCountry ? {
            country: phoneCountry
        } : undefined);
        if (e164) setNewPhone((typed)=>typed || e164);
    }, [
        presetPhone,
        phoneCountry
    ]);
    // ── The records already on the new patient's mobile ──────────────────────────
    // A mobile is a household, so a number that carries records is a question, not a
    // match: the person at the desk is one of them (book for that record) or someone new
    // on the same number. Asked inline, and the submit waits for the answer.
    const phoneLookup = (0, $jVdQx.usePhoneCandidates)(mode === 'new' ? newPhone : '');
    const sharedPhoneOk = !!phoneLookup.number && sharedPhone === phoneLookup.number;
    const candidatesPending = phoneLookup.candidates.length > 0 && !sharedPhoneOk;
    function bookForRecord(patient, justLinked) {
        setSelPatient(patient);
        setLinkedFrom(justLinked ? patient : null);
        setSearchQ('');
        setSearchRes([]);
        setMode('existing');
    }
    // Already the clinic's: nothing to create, just book for it.
    const pickLinkedCandidate = (c)=>bookForRecord(c.patient || {
            id: c.patientId,
            name: c.displayName,
            phone: phoneLookup.number
        }, false);
    // Another clinic's record: attach it here first, then book for it. Throws on
    // failure — the candidate row says so and stays actionable.
    const linkCandidate = async (c)=>{
        const data = await (0, $2Mst8.bffMutation)((0, $6P09x.LINK_EXISTING_PATIENT), {
            patientId: c.patientId
        });
        const linked = data?.linkExistingPatient;
        if (!linked?.id) throw new Error('linkExistingPatient returned no patient');
        bookForRecord(linked, true);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!phoneConflict) return;
        phoneLookup.seed(phoneConflict.phone, phoneConflict.candidates);
        setSharedPhone('');
    }, [
        phoneConflict
    ]);
    const [notes, setNotes] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(editing?.note || '');
    const [submitting, setSubmitting] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // «ارسال اعلان به بیمار». `null` means untouched, which follows the clinic's defaults
    // as they arrive; the first tick the desk changes makes the choice theirs for THIS
    // booking. A defaults read that fails is simply «nothing ticked».
    const { settings: notifyDefaults } = (0, $iNs7v.useAppointmentNotificationSettings)({
        enabled: notifyOn
    });
    const [notifyPick, setNotifyPick] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const notifyChannels = notifyPick ?? (0, $2MpEq.orderChannels)(notifyDefaults?.channels);
    // The desk's own words for THIS notice (PM-0556); null = the clinic's template. A
    // move («ویرایش نوبت») starts from the reschedule template, never the booking one.
    const [notifyText, setNotifyText] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const notifyTemplate = (0, $2MpEq.noticeBody)(notifyDefaults, editMode ? 'rescheduled' : 'booked');
    const notifyBody = (0, $2MpEq.notifyBodyToSend)(notifyText, notifyTemplate);
    // What the desk PLANS to perform (target flow §1). Each pick is priced from the
    // clinic's declaration onto the proforma the booking raises; the visit fee itself
    // is always quoted from the doctor's contract and is not a pick here.
    const declared = (0, $1DJld.useMedicalServiceTariffs)();
    // One row per catalog service, priced for THIS doctor (helpers.plannableServices).
    // Keyed by catalogId below, so it must never carry the same catalog id twice —
    // per-doctor consultation declarations all share `consult-visit`.
    const plannable = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $lM08I.plannableServices)(declared, doctor?.id || null), [
        declared,
        doctor?.id
    ]);
    const [planned, setPlanned] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]); // [{ catalogId, quantity }]
    // A pick the new doctor has no price for (or a consultation) is not theirs to plan.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setPlanned((prev)=>prev.filter((ps)=>plannable.some((svc)=>svc.catalogId === ps.catalogId)));
    }, [
        plannable
    ]);
    // ── «خدمت نوبت» — the ONE service this appointment is for ──────────────────
    //
    // docs/CLINIC_RECEPTION_SERVICE_INVOICE_DESIGN.md §D2. Chosen here and nowhere
    // else: the proforma is priced from it, check-in re-prices the same row, and
    // the settle drawer shows it locked. Before this the visit named no service at
    // all and accounting guessed one from the clinic's consultation list.
    //
    // Pre-filled with the practitioner's own default, so the common booking takes
    // no extra keystroke. `serviceTouched` keeps a desk's deliberate choice from
    // being overwritten when the default arrives late or the doctor changes.
    const bookable = (0, $dgZRs.useBookableServices)(isAuto || serviceMode || editMode || engineMode ? null : doctor?.id || null);
    const [serviceId, setServiceId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [serviceTouched, setServiceTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!serviceTouched) setServiceId(bookable.defaultId);
    }, [
        bookable.defaultId,
        serviceTouched
    ]);
    // The doctor changed: the previous person's service is not this one's.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setServiceTouched(false);
    }, [
        doctor?.id
    ]);
    const chosenService = bookable.services.find((sv)=>sv.declarationId === serviceId) || null;
    // What the desk decided about insurance for THIS visit: which بیمهٔ تکمیلی to
    // skip, and which معرفی‌نامه each should pay under. Never a change to the
    // patient's policies — those are edited on the patient, not on a booking.
    const [insuranceChoice, setInsuranceChoice] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // ── «پیش‌پرداخت» (PM-0657 §6.2) — prefilled from the booked service's tariff ──
    const { policy: prepaymentPolicy } = (0, $wuSZs.usePrepaymentPolicy)();
    const deposit = (0, $j5293.useBookingDeposit)({
        policy: prepaymentPolicy,
        priceRial: (engineMode ? engineRow?.unitPrice : chosenService?.unitPrice) ?? null,
        applies: offerDeposit && !editMode && !serviceMode
    });
    const [depositError, setDepositError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [requiredAsk, setRequiredAsk] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const skipRequired = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    const plannedQuote = planned.reduce((sum, ps)=>{
        const d = plannable.find((svc)=>svc.catalogId === ps.catalogId);
        return sum + (d?.unitPrice || 0) * (ps.quantity || 1);
    }, 0);
    const togglePlanned = (catalogId)=>setPlanned((prev)=>prev.some((ps)=>ps.catalogId === catalogId) ? prev.filter((ps)=>ps.catalogId !== catalogId) : [
                ...prev,
                {
                    catalogId: catalogId,
                    quantity: 1
                }
            ]);
    function switchMode(m) {
        setMode(m);
        setSelPatient(null);
        setLinkedFrom(null);
        setSearchQ('');
        setSearchRes([]);
    }
    const patientReady = patientLocked ? true : mode === 'existing' ? !!selPatient : (0, $6P09x.isRegisterable)({
        name: newName,
        nid: newNid,
        nidCountry: nidCountry,
        insurer: insurerChoice,
        phone: newPhone,
        noPhone: false
    }) && !(0, $6P09x.fileNumberProblem)(newFileNumber) && !candidatesPending;
    // Step 1 is bookable when there is a concrete slot: a manual pick that survived
    // filtering, or a non-empty auto-pick preview. «خارج از نوبت» is bookable with
    // neither — having no hour is the whole point, so there is nothing left to wait for.
    // A session's auto-pick is resolved HERE, so it is ready only once the search
    // has a slot; a visit's is resolved by the server on submit.
    const timeReady = isUntimed || queue ? true : isAuto ? serviceMode || engineMode ? !!preview.slot : !previewEmpty : !!selTime;
    // An edit that leaves the time alone has nothing to wait for; one that asked for
    // another day waits for an hour on it.
    const canSubmit = editMode ? editing.needsTime ? timeTouched && !!selTime : !timeTouched || !!selTime : patientReady && timeReady;
    async function submit() {
        if (!canSubmit || submitting) return;
        const depositError = (0, $j5293.depositFieldError)(t, deposit);
        if (depositError) {
            setDepositError(depositError);
            return;
        }
        // «الزامی» is a question, never a refusal (C9).
        if (deposit.needsConfirm && !skipRequired.current) {
            setRequiredAsk(true);
            return;
        }
        skipRequired.current = false;
        // Every booking answer carries the desk's deposit decision; an edit never does.
        const onSubmit = (args)=>onSubmitProp({
                ...args,
                deposit: deposit.wire
            });
        setSubmitting(true);
        try {
            // The modal hands the caller ONE subject, patientInfo. The caller registers the
            // patient for the `new` case.
            const subject = patientLocked ? {
                patientInfo: {
                    id: lockedPatient.id,
                    name: lockedPatient.name || '',
                    phone: lockedPatient.phone || ''
                }
            } : mode === 'existing' ? {
                patientInfo: {
                    id: selPatient.id,
                    name: selPatient.name,
                    phone: selPatient.phone || ''
                }
            } : {
                patientInfo: {
                    id: null,
                    name: newName.trim(),
                    phone: newPhone,
                    nationalId: (0, $6P09x.nidForWire)(newNid, nidCountry),
                    ...(0, $6P09x.phoneFlags)({
                        noPhone: false,
                        allowSharedPhone: sharedPhoneOk
                    }),
                    // The catalog id, not a display label: `patients.insurance` is
                    // DERIVED from the policy now, so the insurer travels as an id and
                    // the caller writes it as a policy against the new patient.
                    insurerId: insurerChoice,
                    // Empty is a valid answer — same as ثبت بیمار جدید, nothing is reserved
                    // until this save; ASCII whatever keyboard typed it.
                    fileNumber: (0, $5JYPc.toEnDigits)(newFileNumber).trim() || null
                }
            };
            const services = planned.map(({ catalogId: catalogId, quantity: quantity })=>({
                    catalogId: catalogId,
                    quantity: quantity
                }));
            // The service travels WITH the booking so the appointment stores it; the
            // BFF resolves one itself when this is null (a practitioner with nothing
            // declared, or an «اولین نوبت» booking whose doctor is not known yet).
            // On the engine it is the row that prices THIS performer, and the catalogue
            // id rides with it so the booking is held to that service's window.
            const serviceDeclarationId = engineMode ? engineRow?.declarationId || null : serviceId || null;
            const engineExtras = engineMode ? {
                serviceCatalogId: entry?.catalogId || null
            } : {};
            // This visit's own insurance decisions travel with the booking, so the
            // proforma is priced under them. They land on the invoice's legs and never
            // on the patient's policies.
            const insurance = mode === 'existing' ? insuranceChoice : null;
            const notify = notifyOn ? notifyChannels : [];
            // «ویرایش نوبت»: the instant only when the desk chose one, and none of the
            // booking's other answers — they were given when the نوبت was booked.
            if (editMode) {
                const picked = timeTouched ? availSlots.find((s)=>s.label === selTime) : null;
                await onSubmit({
                    ...subject,
                    dateTimeMs: picked ? (0, $lM08I.slotInstant)((0, $lM08I.jalaliToDate)(jYear, jMonth, jDay), picked.h, picked.m) : null,
                    slotLabel: picked ? selTime : null,
                    notes: notes,
                    notifyChannels: notify,
                    notifyBody: notify.length ? notifyBody : null
                });
                return;
            }
            // A QUEUE service holds no hour: a turn for today, ordered at the desk.
            if (engineMode && queue) {
                await onSubmit({
                    ...subject,
                    dateTimeMs: (0, $lM08I.slotInstant)((0, $lM08I.dayDateOf)((0, $5qKOB.clinicTodayIso)()), 12, 0),
                    slotLabel: null,
                    notes: notes,
                    type: visitType,
                    services: services,
                    serviceDeclarationId: serviceDeclarationId,
                    ...engineExtras,
                    insuranceChoice: insurance,
                    notifyChannels: notify,
                    notifyBody: notify.length ? notifyBody : null,
                    untimed: (0, $k7Ymn.UNTIMED_DAY)
                });
                return;
            }
            // «خارج از نوبت»: no hour to send and no slot to search for. The day still
            // travels for UNTIMED_DAY — the service reads it for its DAY and ignores the
            // hour — and is ignored outright for «همین الان», which is today by definition.
            // `firstAvailable` is deliberately absent: the BFF refuses the two together,
            // because one searches for a free hour and this is the booking that has none.
            if (isUntimed) {
                // Noon of the picked day on the clinic's clock: the service reads its DAY.
                const dayMs = (0, $lM08I.slotInstant)((0, $lM08I.jalaliToDate)(jYear, jMonth, jDay), 12, 0);
                await onSubmit({
                    ...subject,
                    dateTimeMs: untimedMode === (0, $k7Ymn.UNTIMED_NOW) ? Date.now() : dayMs,
                    slotLabel: null,
                    notes: notes,
                    type: visitType,
                    services: services,
                    serviceDeclarationId: serviceDeclarationId,
                    ...engineExtras,
                    insuranceChoice: insurance,
                    notifyChannels: notify,
                    notifyBody: notify.length ? notifyBody : null,
                    untimed: untimedMode
                });
                return;
            }
            if (isAuto) {
                // bookServiceSession has no `firstAvailable`: the session takes the slot
                // the search found, and the server re-checks it for a collision. The
                // engine's first free hour is booked the same way — the instant it named.
                if (serviceMode || engineMode) {
                    if (!preview.slot?.dateTime) return;
                    await onSubmit({
                        ...subject,
                        dateTimeMs: Number(preview.slot.dateTime),
                        slotLabel: null,
                        notes: notes,
                        type: visitType,
                        services: services,
                        serviceDeclarationId: serviceDeclarationId,
                        ...engineExtras,
                        insuranceChoice: insurance,
                        notifyChannels: notify,
                        notifyBody: notify.length ? notifyBody : null
                    });
                    return;
                }
                await onSubmit({
                    ...subject,
                    dateTimeMs: Number(fromDateTime),
                    slotLabel: null,
                    notes: notes,
                    type: visitType,
                    firstAvailable: (0, $7GAiB.slotModeScope)(slotMode),
                    services: services,
                    serviceDeclarationId: serviceDeclarationId,
                    insuranceChoice: insurance,
                    notifyChannels: notify,
                    notifyBody: notify.length ? notifyBody : null
                });
                return;
            }
            const slot = availSlots.find((s)=>s.label === selTime) || availSlots[0];
            await onSubmit({
                ...subject,
                dateTimeMs: slot.ms != null ? slot.ms : (0, $lM08I.slotInstant)((0, $lM08I.jalaliToDate)(jYear, jMonth, jDay), slot.h, slot.m),
                slotLabel: selTime,
                notes: notes,
                type: visitType,
                services: services,
                serviceDeclarationId: serviceDeclarationId,
                ...engineExtras,
                ...engineMode && slot.held && allowOutside ? {
                    allowOutsideServiceWindow: true
                } : {},
                insuranceChoice: insurance,
                notifyChannels: notify,
                notifyBody: notify.length ? notifyBody : null
            });
        } catch (err) {
            // Today just ran out under the desk: the patient standing there is now a
            // walk-in. The caller still owns the error and how it is said.
            const code = err?.extensions?.code;
            if ((code === 'NO_SLOT_AVAILABLE' || code === 'SLOT_TAKEN' || code === 'APPOINTMENT_CONFLICT') && dayIsToday) setTodayFull(true);
            // The engine answered before somebody else booked: read the day again.
            if (engineMode) setEngineKey((k)=>k + 1);
            throw err;
        } finally{
            setSubmitting(false);
        }
    }
    const days = Array.from({
        length: maxDay
    }, (_, i)=>i + 1);
    // The instant the desk currently has selected, derived the same way `submit`
    // derives it — a second derivation would eventually warn about a moment other
    // than the one being booked. Null under auto-pick: the server chooses there,
    // and it already refuses a slot a request is holding.
    const selectedMs = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (isAuto || isUntimed || !selTime) return null;
        const slot = availSlots.find((x)=>x.label === selTime);
        if (!slot) return null;
        if (slot.ms != null) return slot.ms;
        return (0, $lM08I.slotInstant)((0, $lM08I.jalaliToDate)(jYear, jMonth, jDay), slot.h, slot.m);
    }, [
        isAuto,
        selTime,
        availSlots,
        jYear,
        jMonth,
        jDay
    ]);
    // E8: the slot is already held by a patient's request. The request holds it —
    // the scheduling service's overlap check counts `requested` rows — so booking
    // over it would be refused anyway; saying so here turns a refusal into a
    // decision, with the two ways out named.
    const heldByRequest = !!(heldSlots && selectedMs && heldSlots.has(String(selectedMs)));
    // One entry as the select names it: the service and THIS performer's price.
    const engineEntryLabel = (e)=>{
        const row = (0, $gXHpd.performerRow)(e, engine?.performer);
        return (0, $lM08I.serviceLabelOf)(row ? {
            ...row,
            description: e.name
        } : {
            description: e.name
        }, t, formatMoney);
    };
    const VISIT_TYPES = [
        {
            key: 'in_person',
            label: t('reception.filters.inPerson'),
            icon: "\uD83C\uDFE5"
        },
        {
            key: 'online',
            label: t('calendar.type.remote'),
            icon: "\uD83D\uDCBB"
        }
    ];
    // Both anatomies need these keyframes — `modalIn` for the desktop card and
    // `spin` for the submit button's spinner — so they travel with the modal
    // rather than with the card that used to own them.
    const keyframes = /*#__PURE__*/ (0, $ayMG0.jsx)("style", {
        children: `
      @keyframes modalIn { from { opacity:0; transform:scale(0.95) translateY(14px) } to { opacity:1; transform:scale(1) translateY(0) } }
      @keyframes spin     { to   { transform:rotate(360deg) } }
    `
    });
    // Who is being booked, and how. The desk reads it in the header; the phone
    // gets it at the top of the sheet, whose header is one line of title.
    const chips = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 10,
                marginBottom: 14
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: 8,
                        background: (0, $jTCZr.C).bg,
                        borderRadius: 20,
                        padding: '5px 12px 5px 6px',
                        minWidth: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                width: 28,
                                height: 28,
                                borderRadius: '50%',
                                background: doctor.color,
                                color: 'white',
                                fontSize: '0.6875rem',
                                fontWeight: 800,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0
                            },
                            children: (0, $lM08I.getInitials)(doctor.name)
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                minWidth: 0
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    style: {
                                        fontSize: '0.8125rem',
                                        fontWeight: 700,
                                        color: (0, $jTCZr.C).textPrimary,
                                        lineHeight: 1.2
                                    },
                                    children: doctor.name
                                }),
                                engineMode && !queue ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    "data-testid": "booking-length",
                                    style: {
                                        fontSize: '0.625rem',
                                        color: (0, $jTCZr.C).textMuted
                                    },
                                    children: t(engineDuration.source === 'DOCTOR' ? 'reception.booking.lengthFromDoctor' : 'reception.booking.lengthFromService', {
                                        minutes: formatDigits(engineMinutes)
                                    })
                                }) : doctor.specialty && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    style: {
                                        fontSize: '0.625rem',
                                        color: (0, $jTCZr.C).textMuted
                                    },
                                    children: doctor.specialty
                                })
                            ]
                        })
                    ]
                }),
                serviceMode || editMode ? null : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        display: 'flex',
                        border: `1.5px solid ${(0, $jTCZr.C).border}`,
                        borderRadius: 10,
                        overflow: 'hidden',
                        flexShrink: 0
                    },
                    children: VISIT_TYPES.map(({ key: key, label: label, icon: icon })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                            onClick: ()=>setVisitType(key),
                            style: {
                                padding: '6px 12px',
                                border: 'none',
                                cursor: 'pointer',
                                fontFamily: 'Meshkat, sans-serif',
                                fontSize: '0.75rem',
                                fontWeight: 700,
                                background: visitType === key ? (0, $jTCZr.C).navy : 'white',
                                color: visitType === key ? 'white' : (0, $jTCZr.C).textSecondary,
                                display: 'flex',
                                alignItems: 'center',
                                gap: 4,
                                transition: 'background 0.15s, color 0.15s'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        fontSize: '0.8125rem'
                                    },
                                    children: icon
                                }),
                                label
                            ]
                        }, key))
                })
            ]
        })
    });
    // The booking's optional extras, folded behind «گزینه‌های بیشتر» (the clinic's
    // notification defaults still apply while folded).
    const newPatientExtras = !patientLocked && mode === 'new';
    const extrasPlanned = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: !serviceMode && !editMode && plannable.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7phmx.default), {
            label: t('calendar.booking.plannedServices'),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 6
                    },
                    children: plannable.map((svc)=>{
                        const on = planned.some((ps)=>ps.catalogId === svc.catalogId);
                        return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            type: "button",
                            onClick: ()=>togglePlanned(svc.catalogId),
                            title: t('calendar.booking.servicePrice', {
                                amount: formatMoney(svc.unitPrice, {
                                    currency: svc?.currency
                                })
                            }),
                            style: {
                                padding: '5px 10px',
                                borderRadius: 20,
                                fontSize: '0.75rem',
                                fontFamily: 'inherit',
                                cursor: 'pointer',
                                border: `1px solid ${on ? (0, $jTCZr.C).navy : (0, $jTCZr.C).border}`,
                                background: on ? (0, $jTCZr.C).navy : '#fff',
                                color: on ? '#fff' : (0, $jTCZr.C).textSecondary
                            },
                            children: svc.description
                        }, svc.catalogId);
                    })
                }),
                plannedQuote > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        fontSize: '0.71875rem',
                        color: (0, $jTCZr.C).textMuted,
                        marginTop: 6
                    },
                    children: t('calendar.booking.plannedTotal', {
                        amount: formatMoney(plannedQuote)
                    })
                })
            ]
        })
    });
    const extrasTail = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            notifyOn ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5JA6O.default), {
                value: notifyChannels,
                onChange: setNotifyPick,
                template: notifyTemplate,
                text: notifyText,
                onTextChange: setNotifyText
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7phmx.default), {
                label: serviceMode ? t('calendar.fields.note') : t('calendar.fields.noteForDoctor'),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                    value: notes,
                    onChange: (e)=>setNotes(e.target.value),
                    placeholder: t('calendar.fields.notePlaceholder'),
                    rows: 3,
                    style: {
                        ...(0, $e6t5J.bookInputStyle),
                        height: 'auto',
                        padding: '10px 14px',
                        resize: 'vertical',
                        lineHeight: 1.7
                    },
                    onFocus: (e)=>e.target.style.borderColor = (0, $jTCZr.C).navy,
                    onBlur: (e)=>e.target.style.borderColor = (0, $jTCZr.C).border
                })
            })
        ]
    });
    const insuranceQuote = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: !serviceMode && mode === 'existing' && selPatient?.id ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2YFrP.default), {
            patientId: selPatient.id,
            doctorId: isAuto && !engineMode ? null : engineMode && engine.performer.type === 'STAFF' ? null : doctor?.id,
            services: planned.map(({ catalogId: catalogId, quantity: quantity })=>({
                    catalogId: catalogId,
                    quantity: quantity
                })),
            serviceDeclarationId: engineMode ? engineRow?.declarationId || null : serviceId,
            choice: insuranceChoice,
            onChoiceChange: setInsuranceChoice
        }) : null
    });
    const form = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            notice,
            queue ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                "data-testid": "booking-queue-mode",
                style: {
                    padding: '11px 14px',
                    borderRadius: 12,
                    background: (0, $jTCZr.C).bg,
                    fontSize: '0.78125rem',
                    lineHeight: 1.7,
                    color: (0, $jTCZr.C).textSecondary
                },
                children: t('reception.booking.queueMode')
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)($5902d1369013fea3$var$TimeStep, {
                onHeldPick: engineMode ? (slot)=>setOutsideAsk(slot) : null,
                onPlainPick: ()=>setAllowOutside(false),
                allowFirstAvailable: allowFirstAvailable,
                slotMode: slotMode,
                setSlotMode: lookingAgain(setSlotMode),
                modes: (0, $7GAiB.BOOKING_SLOT_MODES),
                onUseNext: takeNextSlot,
                fold: foldTime,
                optionsOpen: timeOptionsOpen,
                onToggleOptions: ()=>setTimeOptionsOpen((o)=>!o),
                isAuto: isAuto,
                preview: preview,
                dayIsToday: dayIsToday,
                nextAvailable: nextAvailable,
                years: years,
                jYear: jYear,
                setJYear: lookingAgain(touching(setJYear)),
                jMonth: jMonth,
                setJMonth: lookingAgain(touching(setJMonth)),
                jDay: jDay,
                setJDay: lookingAgain(touching(setJDay)),
                days: days,
                availSlots: availSlots,
                slotsLoading: slotsLoading,
                noShift: noShift,
                absent: absent,
                allBooked: allBooked,
                offerUntimed: offerUntimed,
                untimed: untimed,
                untimedMode: untimedMode,
                isUntimed: isUntimed,
                selectedGDate: selectedGDate,
                untimedLeads: untimedLeads,
                compact: isMobile,
                selTime: selTime,
                setSelTime: touching(setSelTime),
                slotsCollapsed: slotsCollapsed,
                onShowAllSlots: ()=>setGridClosed(false),
                onSlotPicked: ()=>setGridClosed(true)
            }),
            patientLocked ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7phmx.default), {
                label: t('common.entity.patient'),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    "data-testid": "booking-locked-patient",
                    style: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: 10,
                        padding: '10px 14px',
                        borderRadius: 12,
                        border: `1.5px solid ${(0, $jTCZr.C).border}`,
                        background: (0, $jTCZr.C).bg
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                width: 30,
                                height: 30,
                                borderRadius: '50%',
                                background: (0, $jTCZr.C).navy,
                                color: '#fff',
                                fontSize: '0.6875rem',
                                fontWeight: 800,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            },
                            children: (0, $lM08I.getInitials)(lockedPatient.name || '')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                minWidth: 0
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    style: {
                                        fontSize: '0.84375rem',
                                        fontWeight: 700,
                                        color: (0, $jTCZr.C).textPrimary
                                    },
                                    children: lockedPatient.name
                                }),
                                lockedPatient.phone ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    dir: "ltr",
                                    style: {
                                        fontSize: '0.6875rem',
                                        color: (0, $jTCZr.C).textMuted,
                                        unicodeBidi: 'isolate',
                                        textAlign: 'end'
                                    },
                                    children: lockedPatient.phone
                                }) : null
                            ]
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)($5902d1369013fea3$var$PatientStep, {
                mode: mode,
                switchMode: switchMode,
                searchQ: searchQ,
                setSearchQ: setSearchQ,
                searchRes: searchRes,
                searching: searching,
                selPatient: selPatient,
                setSelPatient: setSelPatient,
                linkedFrom: linkedFrom,
                setLinkedFrom: setLinkedFrom,
                newName: newName,
                setNewName: setNewName,
                newPhone: newPhone,
                setNewPhone: setNewPhone,
                phoneCandidates: candidatesPending ? phoneLookup.candidates : [],
                sharedPhoneCount: sharedPhoneOk ? phoneLookup.candidates.length : 0,
                onNewOnSameNumber: ()=>setSharedPhone(phoneLookup.number),
                pickLinkedCandidate: pickLinkedCandidate,
                linkCandidate: linkCandidate,
                newInsurer: insurerChoice,
                setNewInsurer: setNewInsurer,
                region: region,
                phoneCountry: phoneCountry
            }),
            serviceMode ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7phmx.default), {
                label: t('calendar.booking.service'),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    "data-testid": "booking-locked-service",
                    style: {
                        padding: '10px 14px',
                        borderRadius: 12,
                        border: `1.5px solid ${(0, $jTCZr.C).border}`,
                        background: (0, $jTCZr.C).bg
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                fontSize: '0.84375rem',
                                fontWeight: 700,
                                color: (0, $jTCZr.C).textPrimary
                            },
                            children: service.label
                        }),
                        service.meta ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                fontSize: '0.71875rem',
                                color: (0, $jTCZr.C).textMuted,
                                marginTop: 2
                            },
                            children: service.meta
                        }) : null,
                        service.notice ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            role: "alert",
                            "data-testid": "booking-service-notice",
                            style: {
                                fontSize: '0.75rem',
                                lineHeight: 1.7,
                                color: (0, $jTCZr.CT).warnInk,
                                marginTop: 6,
                                background: (0, $jTCZr.CT).amberLight,
                                border: '1px solid rgba(245,158,11,0.30)',
                                borderRadius: 8,
                                padding: '6px 10px'
                            },
                            children: service.notice
                        }) : null
                    ]
                })
            }) : null,
            engineMode ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7phmx.default), {
                label: t('calendar.booking.service'),
                children: engineEntries.length === 1 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    "data-testid": "booking-service-single",
                    style: {
                        fontSize: '0.8125rem',
                        color: (0, $jTCZr.C).textPrimary,
                        padding: '7px 2px'
                    },
                    children: engineEntryLabel(engineEntries[0])
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("select", {
                    value: entry?.catalogId || '',
                    onChange: (e)=>{
                        setEntryId(e.target.value || null);
                        setAllowOutside(false);
                    },
                    style: (0, $e6t5J.bookInputStyle),
                    "data-testid": "booking-service",
                    children: engineEntries.map((e)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                            value: e.catalogId,
                            children: engineEntryLabel(e)
                        }, e.catalogId))
                })
            }) : null,
            !serviceMode && !editMode && !isAuto && !engineMode && doctor?.id ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7phmx.default), {
                label: t('calendar.booking.service'),
                children: [
                    bookable.loading ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        height: 34
                    }) : bookable.services.length === 0 ? /* Nothing priced this person's visit. Said as a fact with the way to
               fix it, and the booking is NOT blocked: a price is not a gate on
               giving somebody an appointment (§S2). */ /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: '0.75rem',
                            lineHeight: 1.7,
                            color: (0, $jTCZr.CT).warnInk,
                            background: (0, $jTCZr.CT).amberLight,
                            border: '1px solid rgba(245,158,11,0.30)',
                            borderRadius: 8,
                            padding: '8px 10px'
                        },
                        children: t('calendar.booking.serviceNone')
                    }) : bookable.services.length === 1 ? /* One applicable service is a FACT, not a choice: rendering a select
               with a single option asks a question that has no second answer. */ /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: '0.8125rem',
                            color: (0, $jTCZr.C).textPrimary,
                            padding: '7px 2px'
                        },
                        children: (0, $lM08I.serviceLabelOf)(bookable.services[0], t, formatMoney)
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("select", {
                        value: serviceId || '',
                        onChange: (e)=>{
                            setServiceTouched(true);
                            setServiceId(e.target.value || null);
                        },
                        style: (0, $e6t5J.bookInputStyle),
                        "data-testid": "booking-service",
                        children: bookable.services.map((sv)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                value: sv.declarationId,
                                children: (0, $lM08I.serviceLabelOf)(sv, t, formatMoney)
                            }, sv.declarationId))
                    }),
                    chosenService && !(chosenService.unitPrice > 0) ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: '0.71875rem',
                            color: (0, $jTCZr.CT).warnInk,
                            marginTop: 6
                        },
                        children: t('calendar.booking.serviceUnpriced')
                    }) : null
                ]
            }) : null,
            insuranceQuote,
            deposit.shown ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $j5293.BookingDepositBlock), {
                deposit: deposit,
                error: depositError,
                onTouch: ()=>setDepositError('')
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7GAiB.OptionsDisclosure), {
                // An invalid کد ملی blocks the submit, so it is never left folded out of sight.
                open: moreOpen || newPatientExtras && nidInvalid,
                onToggle: ()=>setMoreOpen((o)=>!o),
                showLabel: t(newPatientExtras ? 'calendar.booking.moreOptionsNewPatient' : 'calendar.booking.moreOptions'),
                hideLabel: t('calendar.booking.lessOptions'),
                testId: "booking-more-options",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 18
                    },
                    children: [
                        newPatientExtras ? /*#__PURE__*/ (0, $ayMG0.jsx)($5902d1369013fea3$var$NewPatientExtras, {
                            newNid: newNid,
                            setNewNid: setNewNid,
                            nidInvalid: nidInvalid,
                            newNidCountry: newNidCountry,
                            setNewNidCountry: setNewNidCountry,
                            nidCountry: nidCountry,
                            newFileNumber: newFileNumber,
                            setNewFileNumber: setNewFileNumber,
                            fnBusy: fnBusy,
                            suggestFileNumber: suggestFileNumber
                        }) : null,
                        extrasPlanned,
                        extrasTail
                    ]
                })
            }),
            deposit.required ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjPik.default), {
                open: requiredAsk,
                onOpenChange: (o)=>{
                    if (!o) setRequiredAsk(false);
                },
                title: t('reception.booking.deposit.requiredTitle'),
                description: t('reception.booking.deposit.requiredConfirm'),
                confirmLabel: t('reception.booking.deposit.requiredConfirmAction'),
                cancelLabel: t('reception.booking.deposit.back'),
                "data-testid": "booking-deposit-required-confirm",
                onConfirm: ()=>{
                    setRequiredAsk(false);
                    skipRequired.current = true;
                    submit();
                }
            }) : null,
            engineMode ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjPik.default), {
                open: !!outsideAsk,
                onOpenChange: (o)=>{
                    if (!o) setOutsideAsk(null);
                },
                title: t('reception.booking.outsideWindow'),
                description: t('reception.booking.outsideWindowConfirm', {
                    service: entry?.name || ''
                }),
                confirmLabel: t('reception.booking.outsideWindowYes'),
                cancelLabel: t('common.actions.cancel'),
                "data-testid": "booking-outside-window",
                onConfirm: ()=>{
                    setAllowOutside(true);
                    setSelTime(outsideAsk.label);
                    setGridClosed(true);
                    setOutsideAsk(null);
                }
            }) : null
        ]
    });
    // Carries no outer margin of its own: the desk insets it to the card's
    // gutter, the sheet's footer already has one.
    const heldNotice = heldByRequest ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        "data-testid": "slot-held-by-request",
        style: {
            padding: '9px 12px',
            borderRadius: 10,
            fontSize: '0.75rem',
            lineHeight: 1.7,
            background: (0, $jTCZr.C).amberLight,
            color: (0, $jTCZr.C).amber,
            border: `1px solid ${(0, $jTCZr.C).border}`
        },
        children: t('reception.requests.slotHeldWarning')
    }) : null;
    const actions = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                onClick: onClose,
                style: {
                    flex: 1,
                    height: 46,
                    borderRadius: 12,
                    border: `1.5px solid ${(0, $jTCZr.C).border}`,
                    background: 'white',
                    color: (0, $jTCZr.C).textSecondary,
                    fontSize: '0.875rem',
                    fontFamily: 'Meshkat, sans-serif',
                    cursor: 'pointer',
                    fontWeight: 600
                },
                children: t('common.actions.cancel')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                onClick: submit,
                disabled: !canSubmit || submitting,
                style: {
                    flex: 2,
                    height: 46,
                    borderRadius: 12,
                    border: 'none',
                    background: canSubmit ? `linear-gradient(135deg, ${(0, $jTCZr.C).navyDark}, ${(0, $jTCZr.C).navy})` : (0, $jTCZr.C).border,
                    color: canSubmit ? 'white' : (0, $jTCZr.C).textMuted,
                    fontSize: '0.875rem',
                    fontFamily: 'Meshkat, sans-serif',
                    cursor: canSubmit && !submitting ? 'pointer' : 'not-allowed',
                    fontWeight: 700,
                    transition: 'background 0.2s, color 0.2s',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 8
                },
                children: submitting ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                width: 16,
                                height: 16,
                                border: '2px solid rgba(255,255,255,0.35)',
                                borderTopColor: 'white',
                                borderRadius: '50%',
                                animation: 'spin 0.8s linear infinite'
                            }
                        }),
                        t('common.state.saving')
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                            viewBox: "0 0 24 24",
                            fill: "currentColor",
                            width: "16",
                            height: "16",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
                            })
                        }),
                        submitLabel || (queue ? t('reception.booking.ticketSubmit') : isAuto ? t('calendar.actions.bookFirst') : t('reception.actions.book'))
                    ]
                })
            })
        ]
    });
    const title = editMode ? editing.title || t('reception.edit.title') : t('reception.actions.book');
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7guRV.default), {
        onClose: onClose,
        title: title,
        // Booking is the longest task the phone carries — date, slot, patient,
        // insurance, notes — so it takes the whole viewport and docks its commit
        // row above the keyboard instead of letting it scroll away.
        snap: 1,
        footer: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            style: {
                display: 'grid',
                gap: 10
            },
            children: [
                heldNotice,
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        display: 'flex',
                        gap: 10
                    },
                    children: actions
                })
            ]
        }),
        desktop: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            style: {
                position: 'fixed',
                inset: 0,
                zIndex: 8000,
                background: 'rgba(15,28,46,0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 20
            },
            onClick: (e)=>{
                if (e.target === e.currentTarget) onClose();
            },
            children: [
                keyframes,
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        background: 'white',
                        borderRadius: 20,
                        width: '100%',
                        maxWidth: 540,
                        maxHeight: '92vh',
                        display: 'flex',
                        flexDirection: 'column',
                        boxShadow: '0 32px 80px rgba(0,0,0,0.26)',
                        fontFamily: 'Meshkat, sans-serif',
                        animation: 'modalIn 0.28s cubic-bezier(.22,1,.36,1) both',
                        overflow: 'hidden'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                padding: '18px 22px 14px',
                                borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
                                flexShrink: 0
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        marginBottom: 12
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                fontSize: '1.0625rem',
                                                fontWeight: 800,
                                                color: (0, $jTCZr.C).textPrimary
                                            },
                                            children: title
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            onClick: onClose,
                                            style: {
                                                background: (0, $jTCZr.C).bg,
                                                border: 'none',
                                                cursor: 'pointer',
                                                color: (0, $jTCZr.C).textMuted,
                                                width: 32,
                                                height: 32,
                                                borderRadius: 8,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                viewBox: "0 0 24 24",
                                                fill: "currentColor",
                                                width: "16",
                                                height: "16",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                chips
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                flex: 1,
                                overflowY: 'auto',
                                padding: '18px 22px',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 18
                            },
                            children: form
                        }),
                        heldNotice ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                margin: '0 22px 12px'
                            },
                            children: heldNotice
                        }) : null,
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                padding: '14px 22px',
                                borderTop: `1px solid ${(0, $jTCZr.C).border}`,
                                flexShrink: 0,
                                display: 'flex',
                                gap: 10
                            },
                            children: actions
                        })
                    ]
                })
            ]
        }),
        children: [
            keyframes,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 18
                },
                children: [
                    chips,
                    form
                ]
            })
        ]
    });
}
// ── Step 2: patient ────────────────────────────────────────────────────────────
function $5902d1369013fea3$var$PatientStep(p) {
    const { t: t } = (0, $e1LEq.default)();
    const { mode: mode, switchMode: switchMode } = p;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        fontSize: '0.75rem',
                        fontWeight: 700,
                        color: (0, $jTCZr.C).textSecondary,
                        marginBottom: 10
                    },
                    children: [
                        t('common.entity.patient'),
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            style: {
                                color: (0, $jTCZr.C).red
                            },
                            children: "*"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        display: 'flex',
                        border: `1.5px solid ${(0, $jTCZr.C).border}`,
                        borderRadius: 10,
                        overflow: 'hidden',
                        marginBottom: 12
                    },
                    children: $5902d1369013fea3$var$PATIENT_MODES(t).map(({ key: key, label: label })=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: ()=>switchMode(key),
                            style: {
                                flex: 1,
                                padding: '9px 0',
                                border: 'none',
                                cursor: 'pointer',
                                fontFamily: 'Meshkat, sans-serif',
                                fontSize: '0.78125rem',
                                fontWeight: 700,
                                background: mode === key ? (0, $jTCZr.C).navy : 'white',
                                color: mode === key ? 'white' : (0, $jTCZr.C).textSecondary,
                                transition: 'background 0.18s, color 0.18s'
                            },
                            children: label
                        }, key))
                }),
                mode === 'existing' && /*#__PURE__*/ (0, $ayMG0.jsx)($5902d1369013fea3$var$ExistingPatient, {
                    ...p
                }),
                mode === 'new' && /*#__PURE__*/ (0, $ayMG0.jsx)($5902d1369013fea3$var$NewPatient, {
                    ...p
                })
            ]
        })
    });
}
// What a hit is told apart by: موبایل, شماره پرونده, کد ملی (PM-0470). The search
// matches all three, so a hit on the file number has to SHOW the file number — a
// row of name + phone gives the desk no way to see why it came up.
function $5902d1369013fea3$var$PatientIds({ pt: pt }) {
    const { t: t, formatDigits: formatDigits } = (0, $e1LEq.default)();
    const parts = [
        pt.fileNumber && t('reception.day.fileNumberChip', {
            number: formatDigits(pt.fileNumber)
        }),
        pt.nationalId && t('reception.search.nationalIdChip', {
            id: formatDigits(pt.nationalId)
        })
    ].filter(Boolean);
    if (!pt.phone && !parts.length) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            fontSize: '0.75rem',
            color: (0, $jTCZr.C).textMuted,
            marginTop: 2,
            display: 'flex',
            gap: 8,
            flexWrap: 'wrap'
        },
        children: [
            pt.phone && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                dir: "ltr",
                style: {
                    unicodeBidi: 'isolate'
                },
                children: (0, $5AX1S).forDisplay(pt.phone)
            }),
            parts.map((x)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    children: x
                }, x))
        ]
    });
}
function $5902d1369013fea3$var$ExistingPatient({ searchQ: searchQ, setSearchQ: setSearchQ, searchRes: searchRes, searching: searching, selPatient: selPatient, setSelPatient: setSelPatient, linkedFrom: linkedFrom, setLinkedFrom: setLinkedFrom }) {
    const { t: t } = (0, $e1LEq.default)();
    // The field the desk starts on: opening ثبت نوبت means typing a name, a کد ملی or
    // a موبایل straight away. Disabled while a patient is chosen — that branch has no
    // input to focus, and the ref would sit on a node that never mounts.
    const searchRef = (0, $hGTfp.useAutoFocus)(!selPatient);
    if (selPatient) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            linkedFrom && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    marginBottom: 8,
                    padding: '10px 13px',
                    background: 'color-mix(in srgb, var(--p-navy) 8%, transparent)',
                    border: '1px solid color-mix(in srgb, var(--p-navy) 22%, transparent)',
                    borderRadius: 10,
                    fontSize: '0.75rem',
                    color: (0, $jTCZr.C).navyDark,
                    fontWeight: 600,
                    lineHeight: 1.6
                },
                children: t('reception.booking.linkedFromPhoneNotice')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    background: 'color-mix(in srgb, var(--p-navy) 8%, transparent)',
                    borderRadius: 10,
                    padding: '11px 14px'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    fontSize: '0.875rem',
                                    fontWeight: 700,
                                    color: (0, $jTCZr.C).textPrimary
                                },
                                children: selPatient.name
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($5902d1369013fea3$var$PatientIds, {
                                pt: selPatient
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: ()=>{
                            setSelPatient(null);
                            setLinkedFrom(null);
                        },
                        style: {
                            background: 'white',
                            border: `1px solid ${(0, $jTCZr.C).border}`,
                            borderRadius: 8,
                            padding: '5px 12px',
                            fontSize: '0.75rem',
                            color: (0, $jTCZr.C).textSecondary,
                            cursor: 'pointer',
                            fontFamily: 'Meshkat, sans-serif'
                        },
                        children: t('operations.fields.change')
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    position: 'relative'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        ref: searchRef,
                        value: searchQ,
                        onChange: (e)=>setSearchQ(e.target.value),
                        placeholder: t('calendar.search.placeholderIds'),
                        "aria-label": t('calendar.search.label'),
                        style: (0, $e6t5J.bookInputStyle),
                        onFocus: (e)=>e.target.style.borderColor = (0, $jTCZr.C).navy,
                        onBlur: (e)=>e.target.style.borderColor = (0, $jTCZr.C).border
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            position: 'absolute',
                            left: 12,
                            top: '50%',
                            transform: 'translateY(-50%)',
                            pointerEvents: 'none',
                            color: (0, $jTCZr.C).textMuted,
                            display: 'flex'
                        },
                        children: searching ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                width: 14,
                                height: 14,
                                border: `2px solid ${(0, $jTCZr.C).border}`,
                                borderTopColor: (0, $jTCZr.C).navy,
                                borderRadius: '50%',
                                animation: 'spin 0.8s linear infinite'
                            }
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                            viewBox: "0 0 24 24",
                            fill: "currentColor",
                            width: "15",
                            height: "15",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
                            })
                        })
                    })
                ]
            }),
            searchRes.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    border: `1.5px solid ${(0, $jTCZr.C).border}`,
                    borderRadius: 10,
                    overflow: 'hidden',
                    marginTop: 6
                },
                children: searchRes.map((pt, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        onClick: ()=>setSelPatient(pt),
                        style: {
                            padding: '11px 14px',
                            cursor: 'pointer',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            borderTop: i > 0 ? `1px solid ${(0, $jTCZr.C).border}` : 'none',
                            transition: 'background 0.14s'
                        },
                        onMouseEnter: (e)=>e.currentTarget.style.background = 'color-mix(in srgb, var(--p-navy) 6%, transparent)',
                        onMouseLeave: (e)=>e.currentTarget.style.background = 'white',
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            fontSize: '0.875rem',
                                            fontWeight: 600,
                                            color: (0, $jTCZr.C).textPrimary
                                        },
                                        children: pt.name
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($5902d1369013fea3$var$PatientIds, {
                                        pt: pt
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                viewBox: "0 0 24 24",
                                fill: (0, $jTCZr.C).textMuted,
                                width: "14",
                                height: "14",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
                                })
                            })
                        ]
                    }, pt.id))
            }),
            searchQ.length >= 2 && !searching && searchRes.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    marginTop: 8,
                    fontSize: '0.8125rem',
                    color: (0, $jTCZr.C).textMuted,
                    textAlign: 'center',
                    padding: '10px 0'
                },
                children: t('reception.booking.noneUseOtherTabs')
            })
        ]
    });
}
function $5902d1369013fea3$var$NewPatient({ newName: newName, setNewName: setNewName, newPhone: newPhone, setNewPhone: setNewPhone, newInsurer: newInsurer, setNewInsurer: setNewInsurer, phoneCandidates: phoneCandidates, sharedPhoneCount: sharedPhoneCount, onNewOnSameNumber: onNewOnSameNumber, pickLinkedCandidate: pickLinkedCandidate, linkCandidate: linkCandidate, region: region = {
    iran: true,
    country: null
}, phoneCountry: // The country the mobile starts on (PM-0218): the clinic country's, else its
// region's. Absent — a caller that names none — is the region's, as before.
phoneCountry = region.country }) {
    const { t: t, locale: locale, formatDigits: formatDigits } = (0, $e1LEq.default)();
    // Options come from the platform catalog, not from a list this client keeps —
    // «تامین اجتماعی» and «تأمین اجتماعی» were two different insurers to any query
    // for exactly as long as the label was the model.
    // Only بیمهٔ پایه: the caller writes this pick as the patient's ONE basic policy
    // (`kind: 'basic'`), so a تکمیلی here would be recorded as the wrong kind. A
    // supplementary is added on the patient's record. «آزاد» is a basic row and stays
    // — and abroad it is the only row (lib/insurance.js `registrationInsurers`).
    const { insurers: allInsurers } = (0, $1zLkf.useInsurers)();
    const insurers = (0, $kZuTn.registrationInsurers)(allInsurers.filter((0, $kZuTn.isBasic)), region);
    // «بیمار جدید» starts on the mobile, as «بیمار قبلی» starts on its search.
    const phoneRef = (0, $hGTfp.useAutoFocus)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 12
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: (0, $2xQve.STACK).tight
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iRTrY.default), {
                        ref: phoneRef,
                        defaultCountry: phoneCountry || undefined,
                        label: t('common.fields.mobile'),
                        required: true,
                        value: newPhone,
                        onChange: (e164)=>setNewPhone(e164),
                        "data-testid": "booking-new-phone"
                    }, phoneCountry || ''),
                    phoneCandidates.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    fontSize: '0.75rem',
                                    fontWeight: 700,
                                    color: (0, $jTCZr.C).textSecondary
                                },
                                children: t('reception.booking.phoneCandidatesHint')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jmIrn.default), {
                                candidates: phoneCandidates,
                                onChooseLinked: pickLinkedCandidate,
                                chooseLabel: t('patients.phoneCandidates.choose'),
                                onLink: linkCandidate,
                                linkLabel: t('patients.phoneCandidates.addAndChoose'),
                                onNewPatient: onNewOnSameNumber
                            })
                        ]
                    }),
                    sharedPhoneCount > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        "data-testid": "shared-phone-note",
                        style: {
                            fontSize: '0.71875rem',
                            color: (0, $jTCZr.C).textMuted
                        },
                        children: t('patients.form.sharedPhoneNote', {
                            n: formatDigits(sharedPhoneCount)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7phmx.default), {
                label: t('common.fields.fullName'),
                required: true,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                    value: newName,
                    onChange: (e)=>setNewName(e.target.value),
                    placeholder: t('patients.form.fullNamePlaceholder'),
                    style: (0, $e6t5J.bookInputStyle),
                    onFocus: (e)=>e.target.style.borderColor = (0, $jTCZr.C).navy,
                    onBlur: (e)=>e.target.style.borderColor = (0, $jTCZr.C).border
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7phmx.default), {
                label: t('patients.fields.insurance'),
                helperText: t('common.form.optional'),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 6
                    },
                    children: insurers.map((ins)=>{
                        const on = newInsurer === ins.id;
                        return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            type: "button",
                            "aria-pressed": on,
                            onClick: ()=>setNewInsurer(on ? '' : ins.id),
                            style: {
                                padding: '7px 13px',
                                borderRadius: 9,
                                fontSize: '0.78125rem',
                                fontWeight: 700,
                                fontFamily: 'Meshkat, sans-serif',
                                cursor: 'pointer',
                                border: on ? `2px solid ${(0, $jTCZr.C).navy}` : `1.5px solid ${(0, $jTCZr.C).border}`,
                                background: on ? (0, $jTCZr.C).navy : 'white',
                                color: on ? 'white' : (0, $jTCZr.C).textPrimary,
                                transition: 'all 0.14s'
                            },
                            children: (0, $kZuTn.insurerLabel)(ins, locale)
                        }, ins.id);
                    })
                })
            })
        ]
    });
}
// «بیمار جدید»'s optional identity — کد ملی and شماره پرونده. Neither is needed to
// book, so they live in «گزینه‌های بیشتر» rather than between the desk and the submit.
function $5902d1369013fea3$var$NewPatientExtras({ newNid: newNid, setNewNid: setNewNid, nidInvalid: nidInvalid, newNidCountry: newNidCountry, setNewNidCountry: setNewNidCountry, nidCountry: nidCountry = null, newFileNumber: newFileNumber, setNewFileNumber: setNewFileNumber, fnBusy: fnBusy, suggestFileNumber: suggestFileNumber }) {
    const { t: t } = (0, $e1LEq.default)();
    const fileNumberIssue = (0, $6P09x.fileNumberProblem)(newFileNumber);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 12
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $Ydgp5.default), {
                label: t('common.fields.nationalId'),
                helperText: t('common.form.optional'),
                error: nidInvalid ? t('validation.nationalId.invalid') : undefined,
                value: newNid,
                onChange: (e)=>setNewNid(e.target.value),
                allowOtherCountries: true,
                country: newNidCountry || undefined,
                defaultCountry: nidCountry || undefined,
                onCountryChange: setNewNidCountry,
                "data-testid": "booking-new-nid"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7phmx.default), {
                label: t('patients.fields.fileNumber'),
                error: fileNumberIssue ? t(`validation.fileNumber.${fileNumberIssue}`) : undefined,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        display: 'flex',
                        gap: 8,
                        alignItems: 'center'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                flex: 1
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                value: newFileNumber,
                                onChange: (e)=>setNewFileNumber(e.target.value),
                                "data-testid": "booking-new-file-number",
                                placeholder: t('patients.form.fileNumberHint'),
                                dir: "ltr",
                                style: {
                                    ...(0, $e6t5J.bookInputStyle),
                                    unicodeBidi: 'isolate',
                                    textAlign: 'start'
                                },
                                onFocus: (e)=>e.target.style.borderColor = (0, $jTCZr.C).navy,
                                onBlur: (e)=>e.target.style.borderColor = (0, $jTCZr.C).border
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            type: "button",
                            onClick: suggestFileNumber,
                            disabled: fnBusy,
                            title: t('patients.form.suggestNextFileNumber'),
                            style: {
                                height: 42,
                                padding: '0 14px',
                                borderRadius: 10,
                                whiteSpace: 'nowrap',
                                border: `1.5px solid ${(0, $jTCZr.C).border}`,
                                background: '#fff',
                                color: fnBusy ? (0, $jTCZr.C).textMuted : (0, $jTCZr.C).navy,
                                fontSize: '0.78125rem',
                                fontWeight: 700,
                                fontFamily: 'Meshkat, sans-serif',
                                cursor: fnBusy ? 'not-allowed' : 'pointer'
                            },
                            children: fnBusy ? '...' : t('patients.form.autoAssign')
                        })
                    ]
                })
            })
        ]
    });
}
// ── Step 1: time ───────────────────────────────────────────────────────────────
function $5902d1369013fea3$var$TimeStep({ allowFirstAvailable: allowFirstAvailable, slotMode: slotMode, setSlotMode: setSlotMode, isAuto: isAuto, preview: preview, dayIsToday: dayIsToday, nextAvailable: nextAvailable, modes: modes, onUseNext: onUseNext, fold: fold, optionsOpen: optionsOpen, onToggleOptions: onToggleOptions, years: years, jYear: jYear, setJYear: setJYear, jMonth: jMonth, setJMonth: setJMonth, jDay: jDay, setJDay: setJDay, days: days, availSlots: availSlots, slotsLoading: slotsLoading, noShift: noShift, absent: absent, allBooked: allBooked, selTime: selTime, setSelTime: setSelTime, offerUntimed: offerUntimed, untimed: untimed, untimedMode: untimedMode, isUntimed: isUntimed, selectedGDate: selectedGDate, untimedLeads: untimedLeads, compact: compact, slotsCollapsed: slotsCollapsed = false, onShowAllSlots: onShowAllSlots, onSlotPicked: onSlotPicked, onHeldPick: // The engine's MARK: an hour outside the service's window is drawn amber and,
// pressed, asks (`onHeldPick`) instead of being taken; any other hour clears that.
onHeldPick = null, onPlainPick: onPlainPick = null }) {
    const { clinicMonthNames: clinicMonthNames, locale: locale } = (0, $e1LEq.default)();
    const { t: t } = (0, $e1LEq.default)();
    const { formatDigits: formatDigits } = (0, $e1LEq.default)();
    const untimedIsNow = untimedMode === (0, $k7Ymn.UNTIMED_NOW);
    // The day is kept as Jalali parts, and a Persian or Arabic desk picks it with the
    // three Jalali selects. An English, French or German desk reads Gregorian everywhere
    // else on the screen («Saturday, September 26, 2026» in the header), so it picks the
    // same day with the kit's date picker, which is Gregorian in those languages
    // (v0.19.0). The locale's OWN calendar decides, from its descriptor — never its id
    // (PM-0185). So does every desk of a brand on the Gregorian calendar: the kit's
    // picker follows the brand, and the three selects below are Jalali by construction.
    const gregorianPanel = (0, $cMRsf.LOCALES)[locale]?.calendar === 'gregory' || (0, $eLeza.calendarSystem)('jalali') === 'gregory';
    const isoOf = (d)=>(0, $lM08I.dayIsoOf)(d);
    const pickIso = (v)=>{
        if (!v) return;
        const j = (0, $lM08I.dateToJalali)((0, $lM08I.dayDateOf)(v));
        setJYear(j.y);
        setJMonth(j.m);
        setJDay(j.d);
    };
    // The questions that change WHEN: the mode and the day. Folded, because the
    // day-scoped default already answers them. «خارج از نوبت» is NOT in here — it
    // is asked before an hour is (PM-0056), so it stays one tap away.
    const controls = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            allowFirstAvailable && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7GAiB.SlotModeSelector), {
                mode: slotMode,
                onChange: setSlotMode,
                dayIsToday: dayIsToday,
                modes: modes
            }),
            slotMode !== 'firstAny' && !(isUntimed && untimedIsNow) && gregorianPanel && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    marginBottom: 12
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Qco3.default), {
                    value: isoOf(selectedGDate),
                    onChange: pickIso
                })
            }),
            slotMode !== 'firstAny' && !(isUntimed && untimedIsNow) && !gregorianPanel && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    gap: 8,
                    marginBottom: 12
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: (0, $e6t5J.dropdownWrap),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("select", {
                                value: jYear,
                                onChange: (e)=>setJYear(Number(e.target.value)),
                                style: {
                                    ...(0, $e6t5J.dropdownStyle),
                                    minWidth: 88
                                },
                                children: years.map((y)=>{
                                    return /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: y,
                                        children: formatDigits(y)
                                    }, y);
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($5902d1369013fea3$var$ChevronDown, {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            ...(0, $e6t5J.dropdownWrap),
                            flex: 1
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("select", {
                                value: jMonth,
                                onChange: (e)=>setJMonth(Number(e.target.value)),
                                style: {
                                    ...(0, $e6t5J.dropdownStyle),
                                    width: '100%'
                                },
                                children: clinicMonthNames().map((name, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: i + 1,
                                        children: name
                                    }, i + 1))
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($5902d1369013fea3$var$ChevronDown, {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: (0, $e6t5J.dropdownWrap),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("select", {
                                value: jDay,
                                onChange: (e)=>setJDay(Number(e.target.value)),
                                style: {
                                    ...(0, $e6t5J.dropdownStyle),
                                    minWidth: 68
                                },
                                children: days.map((d)=>{
                                    return /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: d,
                                        children: formatDigits(d)
                                    }, d);
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($5902d1369013fea3$var$ChevronDown, {})
                        ]
                    })
                ]
            })
        ]
    });
    const untimedRow = (separated)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $k7Ymn.UntimedRow), {
            untimed: untimed,
            mode: untimedMode,
            suggested: untimedLeads,
            separated: separated,
            compact: compact,
            selectedGDate: selectedGDate
        });
    // «همین الان» on leaves nothing to choose: no mode, no day, no hour.
    const showControls = !(isUntimed && untimedIsNow);
    const leads = offerUntimed && untimedLeads && !isUntimed;
    const timeOptions = !showControls ? null : fold ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7GAiB.OptionsDisclosure), {
        open: optionsOpen,
        onToggle: onToggleOptions,
        showLabel: t('doctors.slotModes.showOptions'),
        hideLabel: t('doctors.slotModes.hideOptions'),
        testId: "booking-time-options",
        closedGap: 12,
        children: controls
    }) : controls;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            background: (0, $jTCZr.C).bg,
            borderRadius: 14,
            padding: 14
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    fontSize: '0.75rem',
                    fontWeight: 700,
                    color: (0, $jTCZr.C).textSecondary,
                    marginBottom: 10
                },
                children: t('calendar.fields.dateAndTime')
            }),
            leads && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    marginBottom: 12
                },
                children: untimedRow(false)
            }),
            !(leads && untimedIsNow) && timeOptions,
            isUntimed ? null : isAuto ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7GAiB.FirstSlotPreview), {
                mode: slotMode,
                loading: preview.loading,
                error: preview.error,
                slot: preview.slot,
                dayIsToday: dayIsToday,
                next: nextAvailable,
                onUseNext: onUseNext
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: '0.6875rem',
                            fontWeight: 700,
                            color: (0, $jTCZr.C).textMuted,
                            marginBottom: 7
                        },
                        children: t('calendar.fields.appointmentTime')
                    }),
                    slotsLoading ? // The slot grid in placeholder: cells at a slot button's size, so the
                    // free times land where the reader's eye already is.
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonRegion), {
                        label: t('calendar.slots.checking'),
                        "data-testid": "booking-slots-skeleton",
                        style: {
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: 6
                        },
                        children: Array.from({
                            length: 12
                        }, (_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                width: 58,
                                height: 32,
                                radius: 8
                            }, i))
                    }) : noShift ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            padding: '11px 14px',
                            background: (0, $jTCZr.CT).amberLight,
                            border: '1px solid rgba(245,158,11,0.30)',
                            borderRadius: 10,
                            fontSize: '0.78125rem',
                            color: (0, $jTCZr.CT).warnInk,
                            fontWeight: 600,
                            lineHeight: 1.6
                        },
                        children: t('calendar.slots.noShift')
                    }) : absent ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            padding: '11px 14px',
                            background: (0, $jTCZr.CT).amberLight,
                            border: '1px solid rgba(245,158,11,0.30)',
                            borderRadius: 10,
                            fontSize: '0.78125rem',
                            color: (0, $jTCZr.CT).warnInk,
                            fontWeight: 600,
                            lineHeight: 1.6
                        },
                        children: t('calendar.slots.doctorAbsent')
                    }) : allBooked ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            padding: '11px 14px',
                            background: (0, $jTCZr.CT).redLight,
                            border: '1px solid rgba(217,48,37,0.25)',
                            borderRadius: 10,
                            fontSize: '0.78125rem',
                            color: (0, $jTCZr.C).red,
                            fontWeight: 600,
                            lineHeight: 1.6
                        },
                        children: t('calendar.slots.dayFull')
                    }) : slotsCollapsed ? // The chosen hour alone, drawn exactly as the grid draws a selected slot,
                    // and the way back to every other free one.
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            gap: 8
                        },
                        "data-testid": "booking-slot-chosen",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                "aria-label": t('calendar.slots.chosenTime'),
                                style: {
                                    padding: '6px 11px',
                                    borderRadius: 8,
                                    fontSize: '0.8125rem',
                                    fontWeight: 600,
                                    fontFamily: 'Meshkat, sans-serif',
                                    border: `2px solid ${(0, $jTCZr.C).navy}`,
                                    background: (0, $jTCZr.C).navy,
                                    color: 'white'
                                },
                                children: selTime
                            }),
                            availSlots.length > 1 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                type: "button",
                                onClick: onShowAllSlots,
                                "data-testid": "booking-slots-more",
                                style: {
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: 4,
                                    padding: '6px 10px',
                                    borderRadius: 8,
                                    fontSize: '0.78125rem',
                                    fontWeight: 700,
                                    fontFamily: 'Meshkat, sans-serif',
                                    cursor: 'pointer',
                                    border: `1.5px dashed ${(0, $jTCZr.C).border}`,
                                    background: 'white',
                                    color: (0, $jTCZr.C).navy
                                },
                                children: [
                                    t('calendar.slots.otherTimes', {
                                        count: formatDigits(availSlots.length - 1)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        "aria-hidden": "true",
                                        viewBox: "0 0 24 24",
                                        fill: "currentColor",
                                        width: "13",
                                        height: "13",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M7 10l5 5 5-5z"
                                        })
                                    })
                                ]
                            }) : null
                        ]
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: 6
                        },
                        children: availSlots.map((slot)=>{
                            const selected = selTime === slot.label;
                            const held = !!slot.held && !selected;
                            return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                "data-held": slot.held || undefined,
                                title: slot.held ? t('reception.booking.outsideWindow') : undefined,
                                onClick: ()=>{
                                    if (slot.held && onHeldPick && !selected) {
                                        onHeldPick(slot);
                                        return;
                                    }
                                    if (!slot.held) onPlainPick?.();
                                    setSelTime(slot.label);
                                    onSlotPicked?.();
                                },
                                style: {
                                    padding: '6px 11px',
                                    borderRadius: 8,
                                    fontSize: '0.8125rem',
                                    fontWeight: 600,
                                    fontFamily: 'Meshkat, sans-serif',
                                    cursor: 'pointer',
                                    border: selected ? `2px solid ${(0, $jTCZr.C).navy}` : held ? `1.5px dashed ${(0, $jTCZr.CT).warn}` : `1.5px solid ${(0, $jTCZr.C).border}`,
                                    background: selected ? (0, $jTCZr.C).navy : held ? (0, $jTCZr.CT).amberLight : 'white',
                                    color: selected ? 'white' : held ? (0, $jTCZr.CT).warnInk : (0, $jTCZr.C).textPrimary,
                                    transition: 'all 0.14s'
                                },
                                children: slot.label
                            }, slot.label);
                        })
                    })
                ]
            }),
            leads && untimedIsNow && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    marginTop: 12
                },
                children: timeOptions
            }),
            offerUntimed && !leads && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    marginTop: 12
                },
                children: untimedRow(true)
            })
        ]
    });
}

});
parcelRegister("9RYGc", function(module, exports) {

$parcel$export(module.exports, "CT", () => (parcelRequire("jTCZr")).CT);

var $jTCZr = parcelRequire("jTCZr");

});

parcelRegister("e6t5J", function(module, exports) {

$parcel$export(module.exports, "bookInputStyle", () => $a44831344c02d9d2$export$9bc1a98ea9a9499e);
$parcel$export(module.exports, "dropdownWrap", () => $a44831344c02d9d2$export$7a63104ea1eaaf3e);
$parcel$export(module.exports, "dropdownStyle", () => $a44831344c02d9d2$export$81fc3b5dbb590b20);
parcelRequire("52bn2");
var $jTCZr = parcelRequire("jTCZr");
const $a44831344c02d9d2$export$9bc1a98ea9a9499e = {
    width: '100%',
    height: 44,
    border: `1.5px solid ${(0, $jTCZr.C).border}`,
    borderRadius: 10,
    padding: '0 14px',
    fontSize: '0.875rem',
    fontFamily: 'Meshkat, sans-serif',
    color: (0, $jTCZr.C).textPrimary,
    outline: 'none',
    boxSizing: 'border-box',
    transition: 'border-color 0.18s',
    display: 'block',
    background: 'white'
};
const $a44831344c02d9d2$export$7a63104ea1eaaf3e = {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center'
};
const $a44831344c02d9d2$export$81fc3b5dbb590b20 = {
    height: 40,
    border: `1.5px solid ${(0, $jTCZr.C).border}`,
    borderRadius: 10,
    paddingInlineEnd: 12,
    paddingInlineStart: 30,
    fontSize: '0.875rem',
    fontFamily: 'Meshkat, sans-serif',
    color: (0, $jTCZr.C).textPrimary,
    outline: 'none',
    background: 'white',
    cursor: 'pointer',
    appearance: 'none',
    WebkitAppearance: 'none'
};

});

parcelRegister("iRTrY", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6b085a388ebc567$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $lffTJ = parcelRequire("lffTJ");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");
// The example number inside a sentence is isolated (U+2068 FSI … U+2069 PDI) so an
// ASCII number in a Persian or Arabic message keeps its own direction — the kit
// does the same to its own defaults.
const $a6b085a388ebc567$var$isolate = (s)=>`\u{2068}${s}\u{2069}`;
/**
 * The kit's `PhoneInput`, speaking this panel's language.
 *
 * The kit carries no translation catalogue (packages/DESIGN.md rule 7): its field
 * label, its «کشور» country picker and its five validation messages are Persian
 * defaults a caller is expected to replace. No screen here replaced them, so an
 * English panel showed «کشور» beside every number and answered a short one in
 * Persian. Every screen imports this instead of the kit's, and anything a caller
 * does pass still wins.
 */ function $a6b085a388ebc567$var$PhoneInputWithCopy({ label: label, countryLabel: countryLabel, messages: messages, ...props }, ref) {
    const { t: t } = (0, $e1LEq.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lffTJ.default), {
        ref: ref,
        label: label === undefined ? t('common.fields.mobileNumber') : label,
        countryLabel: countryLabel ?? t('validation.phone.country'),
        messages: {
            required: t('validation.phone.required'),
            invalid: t('validation.phone.invalid'),
            tooShort: (ctx)=>t('validation.phone.tooShort', {
                    country: ctx.countryName,
                    example: $a6b085a388ebc567$var$isolate(ctx.example)
                }),
            tooLong: (ctx)=>t('validation.phone.tooLong', {
                    country: ctx.countryName,
                    example: $a6b085a388ebc567$var$isolate(ctx.example)
                }),
            notMobile: (ctx)=>t('validation.phone.notMobile', {
                    example: $a6b085a388ebc567$var$isolate(ctx.example)
                }),
            ...messages
        },
        ...props
    });
}
const $a6b085a388ebc567$var$PhoneInput = /*#__PURE__*/ (0, $acw62.forwardRef)($a6b085a388ebc567$var$PhoneInputWithCopy);
var $a6b085a388ebc567$export$2e2bcd8739ae039 = $a6b085a388ebc567$var$PhoneInput;

});

parcelRegister("7GAiB", function(module, exports) {

$parcel$export(module.exports, "BOOKING_SLOT_MODES", () => $3626d9ae39205653$export$bf8d57c1eafd4aaa);
$parcel$export(module.exports, "slotModeScope", () => $3626d9ae39205653$export$1ca76d25711d1b99);
$parcel$export(module.exports, "fmtSlotLabel", () => $3626d9ae39205653$export$f3763a6680e639b4);
$parcel$export(module.exports, "useFirstAvailableSlot", () => $3626d9ae39205653$export$ae9279a873a3f07c);
$parcel$export(module.exports, "useFirstPerformerSlot", () => $3626d9ae39205653$export$89ba1360ee285e3f);
$parcel$export(module.exports, "useNextPerformerSlot", () => $3626d9ae39205653$export$17d430a6aa78b362);
$parcel$export(module.exports, "useNextAvailableSlot", () => $3626d9ae39205653$export$a6496ebb2ca355e2);
$parcel$export(module.exports, "SlotModeSelector", () => $3626d9ae39205653$export$cd29f2e0ba32cdb3);
$parcel$export(module.exports, "OptionsDisclosure", () => $3626d9ae39205653$export$4d2d55494d0645d8);
$parcel$export(module.exports, "FirstSlotPreview", () => $3626d9ae39205653$export$acdee896e333e50e);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $66joL = parcelRequire("66joL");
parcelRequire("52bn2");
var $jTCZr = parcelRequire("jTCZr");
parcelRequire("9RYGc");
var $jTCZr = parcelRequire("jTCZr");

var $2Mst8 = parcelRequire("2Mst8");

var $lM08I = parcelRequire("lM08I");

var $5qKOB = parcelRequire("5qKOB");

var $228nw = parcelRequire("228nw");
// "اولین نوبت" (first available slot) picker, shared by the booking modals.
// The preview is advisory only — the BFF re-resolves the slot when the booking
// is submitted, so a slot shown here can still be taken by someone else first.
const $3626d9ae39205653$var$FIRST_AVAILABLE_SLOT = `
  query FirstAvailableSlot($doctorId: String!, $fromDateTime: String!, $scope: FirstSlotScope!) {
    firstAvailableSlot(doctorId: $doctorId, fromDateTime: $fromDateTime, scope: $scope) {
      dateTime
      isAvailable
    }
  }
`;
const $3626d9ae39205653$var$HandIcon = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "13",
        height: "13",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M13 1.07V9h7c0-4.08-3.05-7.44-7-7.93zM4 15c0 4.42 3.58 8 8 8s8-3.58 8-8v-4H4v4zM11 1.07C7.05 1.56 4 4.92 4 9h7V1.07z"
        })
    });
const $3626d9ae39205653$var$BoltIcon = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "13",
        height: "13",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M7 2v11h3v9l7-12h-4l4-8z"
        })
    });
const $3626d9ae39205653$var$RocketIcon = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "13",
        height: "13",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M12 2.5s4.5 2 4.5 8c0 2.2-.7 4-1.5 5.2V18h-6v-2.3C8.2 14.5 7.5 12.7 7.5 10.5c0-6 4.5-8 4.5-8zm0 4a1.75 1.75 0 100 3.5 1.75 1.75 0 000-3.5zM9 19h6v1.2c0 .5-.4.8-.8.8h-4.4c-.4 0-.8-.3-.8-.8V19z"
        })
    });
const $3626d9ae39205653$var$ClockIcon = ({ size: size = 18, color: color = 'white' })=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: color,
        width: size,
        height: size,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"
        })
    });
const $3626d9ae39205653$export$dff00cb43c38c878 = (t)=>[
        {
            key: 'firstOfDay',
            label: t('doctors.slotModes.firstOfDay'),
            todayLabel: t('doctors.slotModes.firstToday'),
            Icon: $3626d9ae39205653$var$BoltIcon
        },
        {
            key: 'firstAny',
            label: t('doctors.slotModes.firstAny'),
            Icon: $3626d9ae39205653$var$RocketIcon
        },
        {
            key: 'manual',
            label: t('doctors.slotModes.manual'),
            Icon: $3626d9ae39205653$var$HandIcon
        }
    ];
const $3626d9ae39205653$export$bf8d57c1eafd4aaa = [
    'firstOfDay',
    'manual'
];
function $3626d9ae39205653$export$1ca76d25711d1b99(mode) {
    return mode === 'firstAny' ? 'ANY' : 'DAY';
}
function $3626d9ae39205653$export$ada0bb5f21bca8b8(dateTimeMs, formatTime) {
    return formatTime(Number(dateTimeMs));
}
function $3626d9ae39205653$export$f3763a6680e639b4(dateTimeMs, t, formatDate, formatTime) {
    const d = new Date(Number(dateTimeMs));
    if (isNaN(d.getTime())) return '';
    return t('doctors.slot.dateAtTime', {
        date: (0, $lM08I.fmtJalaliLong)(d, formatDate),
        time: $3626d9ae39205653$export$ada0bb5f21bca8b8(dateTimeMs, formatTime)
    });
}
// "امروز ساعت ۰۹:۳۰" / "سه‌شنبه، ۲۳ تیر ۱۴۰۵، ساعت ۰۹:۳۰"
function $3626d9ae39205653$var$fmtSlotWhen(dateTimeMs, t, formatDate, formatTime) {
    const d = new Date(Number(dateTimeMs));
    if (isNaN(d.getTime())) return '';
    const now = new Date();
    const sameDay = d.toDateString() === now.toDateString();
    const tomorrow = new Date(now);
    tomorrow.setDate(tomorrow.getDate() + 1);
    const prefix = sameDay ? t('common.dates.today') : d.toDateString() === tomorrow.toDateString() ? t('common.dates.tomorrow') : (0, $lM08I.fmtJalaliLong)(d, formatDate);
    return t('doctors.slot.dateAtTime', {
        date: prefix,
        time: $3626d9ae39205653$export$ada0bb5f21bca8b8(dateTimeMs, formatTime)
    });
}
function $3626d9ae39205653$export$ae9279a873a3f07c(enabled, doctorId, fromDateTime, scope) {
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        slot: null,
        loading: false,
        error: false
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!enabled || !doctorId) {
            setState({
                slot: null,
                loading: false,
                error: false
            });
            return;
        }
        let cancelled = false;
        setState({
            slot: null,
            loading: true,
            error: false
        });
        const t = setTimeout(async ()=>{
            try {
                const data = await (0, $2Mst8.bffQuery)($3626d9ae39205653$var$FIRST_AVAILABLE_SLOT, {
                    doctorId: doctorId,
                    fromDateTime: fromDateTime,
                    scope: scope
                });
                if (!cancelled) setState({
                    slot: data?.firstAvailableSlot || null,
                    loading: false,
                    error: false
                });
            } catch  {
                if (!cancelled) setState({
                    slot: null,
                    loading: false,
                    error: true
                });
            }
        }, 300);
        return ()=>{
            cancelled = true;
            clearTimeout(t);
        };
    }, [
        enabled,
        doctorId,
        fromDateTime,
        scope
    ]);
    return state;
}
// ── «اولین نوبت» for a PERFORMER — a service session's first free slot ────────
//
// `firstAvailableSlot` is a doctor's: the scheduling service walks his shift at his
// VISIT length. A service session is a slot of the DECLARATION's length, and its
// performer may be a coworker with no shift at all — so the search is made here,
// from the same three rules the manual grid draws with (`selectableSlots`): the
// shift (or opening hours), the performer's own diary, and the clock. Advisory,
// like the doctor's: the server still refuses the slot if somebody took it first.
//
// DAY looks at one day. ANY walks forward from now, a day per request, and stops
// at the first day with something free — usually the first or second request.
const $3626d9ae39205653$var$FIRST_ANY_HORIZON_DAYS = 30;
async function $3626d9ae39205653$var$firstFreeOn(day, { providerId: providerId, presences: presences, shiftless: shiftless, timeSlots: timeSlots, slotMin: slotMin, nowMs: nowMs }) {
    const { startTime: startTime, endTime: endTime } = (0, $228nw.localDayRange)(day);
    const data = await (0, $2Mst8.bffQuery)((0, $228nw.SCHEDULED_FOR_DAY), {
        startTime: startTime,
        endTime: endTime
    });
    const booked = (0, $228nw.providerBookings)(data?.scheduledAppointments, providerId, slotMin);
    const [first] = (0, $228nw.selectableSlots)({
        timeSlots: timeSlots,
        presences: presences,
        shiftless: shiftless,
        selectedDate: day,
        slotMin: slotMin,
        booked: booked,
        nowMs: nowMs
    });
    if (!first) return null;
    return {
        dateTime: String((0, $lM08I.slotInstant)(day, first.h, first.m)),
        isAvailable: true
    };
}
function $3626d9ae39205653$export$89ba1360ee285e3f({ enabled: enabled, providerId: providerId, presences: presences, shiftless: shiftless, timeSlots: timeSlots, slotMin: slotMin, fromDateTime: fromDateTime, scope: scope }) {
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        slot: null,
        loading: false,
        error: false
    });
    // Presence rows and the grid are arrays a parent may rebuild each render; the
    // search re-runs on what they SAY, not on their identity.
    const presenceKey = JSON.stringify(presences || []);
    const gridKey = `${timeSlots?.[0]?.label || ''}-${timeSlots?.length || 0}-${slotMin}`;
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!enabled || !providerId) {
            setState({
                slot: null,
                loading: false,
                error: false
            });
            return;
        }
        let cancelled = false;
        setState({
            slot: null,
            loading: true,
            error: false
        });
        const t = setTimeout(async ()=>{
            try {
                const nowMs = Date.now();
                const opts = {
                    providerId: providerId,
                    presences: presences,
                    shiftless: shiftless,
                    timeSlots: timeSlots,
                    slotMin: slotMin,
                    nowMs: nowMs
                };
                let slot = null;
                if (scope === 'DAY') slot = await $3626d9ae39205653$var$firstFreeOn(new Date(Number(fromDateTime)), opts);
                else {
                    // Day by day on the CLINIC's calendar (PM-0088), from its «امروز».
                    const today = (0, $5qKOB.clinicTodayIso)(nowMs);
                    for(let i = 0; i < $3626d9ae39205653$var$FIRST_ANY_HORIZON_DAYS && !slot && !cancelled; i += 1)slot = await $3626d9ae39205653$var$firstFreeOn((0, $lM08I.dayDateOf)((0, $5qKOB.addDaysIso)(today, i)), opts);
                }
                if (!cancelled) setState({
                    slot: slot,
                    loading: false,
                    error: false
                });
            } catch  {
                if (!cancelled) setState({
                    slot: null,
                    loading: false,
                    error: true
                });
            }
        }, 300);
        return ()=>{
            cancelled = true;
            clearTimeout(t);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        enabled,
        providerId,
        presenceKey,
        shiftless,
        gridKey,
        fromDateTime,
        scope
    ]);
    return state;
}
function $3626d9ae39205653$export$17d430a6aa78b362(enabled, opts) {
    const anchor = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>String(Date.now()), [
        enabled,
        opts.providerId
    ]);
    return $3626d9ae39205653$export$89ba1360ee285e3f({
        ...opts,
        enabled: enabled,
        fromDateTime: anchor,
        scope: 'ANY'
    });
}
function $3626d9ae39205653$export$a6496ebb2ca355e2(enabled, doctorId) {
    const anchor = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>String(Date.now()), [
        enabled,
        doctorId
    ]);
    return $3626d9ae39205653$export$ae9279a873a3f07c(enabled, doctorId, anchor, 'ANY');
}
const $3626d9ae39205653$var$styles = `
  @keyframes fsIn      { from { opacity:0; transform:translateY(-4px) } to { opacity:1; transform:none } }
  .fs-mode {
    flex:1; display:flex; align-items:center; justify-content:center; gap:5px;
    padding:9px 4px; border:none; cursor:pointer;
    font-family:Meshkat, sans-serif; font-size:0.75rem; font-weight:700;
    background:white; color:${(0, $jTCZr.C).textSecondary};
    transition:background .16s, color .16s;
  }
  .fs-mode:not(.is-on):hover { background:#f1f5f9; color:${(0, $jTCZr.C).textPrimary}; }
  .fs-mode.is-on { background:${(0, $jTCZr.C).navy}; color:white; }
  .fs-card { animation:fsIn .2s ease-out both; }
`;
function $3626d9ae39205653$export$cd29f2e0ba32cdb3({ mode: mode, onChange: onChange, dayIsToday: dayIsToday = false, modes: modes = null, labels: labels = null }) {
    const { t: t } = (0, $e1LEq.default)();
    const shown = $3626d9ae39205653$export$dff00cb43c38c878(t).filter((m)=>!modes || modes.includes(m.key)).map((m)=>labels?.[m.key] ? {
            ...m,
            label: labels[m.key],
            todayLabel: undefined
        } : m);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("style", {
                children: $3626d9ae39205653$var$styles
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    display: 'flex',
                    border: `1.5px solid ${(0, $jTCZr.C).border}`,
                    borderRadius: 10,
                    overflow: 'hidden',
                    marginBottom: 12
                },
                children: shown.map(({ key: key, label: label, todayLabel: todayLabel, Icon: Icon })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        type: "button",
                        onClick: ()=>onChange(key),
                        "aria-pressed": mode === key,
                        className: `fs-mode${mode === key ? ' is-on' : ''}`,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, {}),
                            dayIsToday && todayLabel ? todayLabel : label
                        ]
                    }, key))
            })
        ]
    });
}
function $3626d9ae39205653$export$4d2d55494d0645d8({ open: open, onToggle: onToggle, showLabel: showLabel, hideLabel: hideLabel, testId: testId, closedGap: closedGap = 0, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            marginBottom: open ? 0 : closedGap
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                type: "button",
                onClick: onToggle,
                "aria-expanded": open,
                "data-testid": testId,
                style: {
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 8,
                    minHeight: 40,
                    padding: '8px 12px',
                    borderRadius: 10,
                    border: `1.5px dashed ${(0, $jTCZr.C).border}`,
                    background: 'white',
                    cursor: 'pointer',
                    fontFamily: 'Meshkat, sans-serif',
                    fontSize: '0.78125rem',
                    fontWeight: 700,
                    color: (0, $jTCZr.C).navy,
                    textAlign: 'start'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        children: open ? hideLabel : showLabel
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                        viewBox: "0 0 24 24",
                        fill: "currentColor",
                        width: "16",
                        height: "16",
                        "aria-hidden": "true",
                        style: {
                            flexShrink: 0,
                            transform: open ? 'rotate(180deg)' : 'none',
                            transition: 'transform .16s'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M7 10l5 5 5-5z"
                        })
                    })
                ]
            }),
            open ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    marginTop: 12
                },
                children: children
            }) : null
        ]
    });
}
function $3626d9ae39205653$var$Box({ tone: tone, children: children }) {
    const tones = {
        amber: {
            bg: (0, $jTCZr.CT).amberLight,
            border: 'rgba(245,158,11,0.30)',
            color: (0, $jTCZr.CT).warnInk
        },
        red: {
            bg: (0, $jTCZr.C).redLight,
            border: 'rgba(217,48,37,0.25)',
            color: (0, $jTCZr.C).red
        }
    }[tone];
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "fs-card",
        style: {
            padding: '11px 14px',
            background: tones.bg,
            border: `1px solid ${tones.border}`,
            borderRadius: 12,
            fontSize: '0.78125rem',
            color: tones.color,
            fontWeight: 600,
            lineHeight: 1.6
        },
        children: children
    });
}
// What the desk sees when the chosen day has nothing left: the reason, and — for a
// day-scoped search — the next slot the doctor actually has, with a button that takes
// it. Telling a receptionist «روز دیگری انتخاب کنید» and leaving them to hunt for that
// day one dropdown at a time is the step this removes.
function $3626d9ae39205653$var$EmptyDay({ dayIsToday: dayIsToday, next: next, onUseNext: onUseNext }) {
    const { t: t, formatDate: formatDate, formatTime: formatTime } = (0, $e1LEq.default)();
    const why = dayIsToday ? t('doctors.slots.noneLeftToday') : t('doctors.slots.noneThisDay');
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($3626d9ae39205653$var$Box, {
        tone: "amber",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    "\u26A0\uFE0F ",
                    why
                ]
            }),
            next.loading && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    marginTop: 7,
                    fontWeight: 600,
                    opacity: 0.85
                },
                children: t('doctors.slots.finding')
            }),
            !next.loading && next.slot && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    marginTop: 9,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10,
                    flexWrap: 'wrap'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        children: [
                            t('doctors.slots.nextIs'),
                            " ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                children: $3626d9ae39205653$var$fmtSlotWhen(next.slot.dateTime, t, formatDate, formatTime)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        type: "button",
                        onClick: ()=>onUseNext?.(next.slot),
                        style: {
                            padding: '5px 12px',
                            borderRadius: 8,
                            border: `1.5px solid ${(0, $jTCZr.C).navy}`,
                            background: 'white',
                            color: (0, $jTCZr.C).navy,
                            fontSize: '0.75rem',
                            fontWeight: 700,
                            fontFamily: 'Meshkat, sans-serif',
                            cursor: 'pointer'
                        },
                        children: t('doctors.slots.bookThisOne')
                    })
                ]
            }),
            !next.loading && !next.slot && !next.error && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    marginTop: 7
                },
                children: t('doctors.slots.noneIn30Days')
            })
        ]
    });
}
function $3626d9ae39205653$export$acdee896e333e50e({ mode: mode, loading: loading, error: error, slot: slot, dayIsToday: dayIsToday, next: next, onUseNext: onUseNext }) {
    const { t: t } = (0, $e1LEq.default)();
    const { formatDate: formatDate, formatTime: formatTime } = (0, $e1LEq.default)();
    if (loading) // The slot card's own shape (38px disc, a when-line and a sub-line), so the
    // found slot lands in the same box.
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $66joL.SkeletonRegion), {
        label: t('common.state.loading'),
        className: "fs-card",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 11,
            background: 'white',
            border: `1.5px solid ${(0, $jTCZr.C).border}`,
            borderRadius: 12,
            padding: 12
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonAvatar), {
                size: 38
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 7
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: "58%",
                        height: 13,
                        radius: 6
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: "38%",
                        height: 10,
                        radius: 6
                    })
                ]
            })
        ]
    });
    if (error) return /*#__PURE__*/ (0, $ayMG0.jsx)($3626d9ae39205653$var$Box, {
        tone: "red",
        children: t('errors.doctors.firstSlotFailed')
    });
    if (!slot) {
        if (mode !== 'firstOfDay') return /*#__PURE__*/ (0, $ayMG0.jsx)($3626d9ae39205653$var$Box, {
            tone: "amber",
            children: t('doctors.slots.noneIn30DaysWarning')
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)($3626d9ae39205653$var$EmptyDay, {
            dayIsToday: dayIsToday,
            next: next || {
                loading: false,
                slot: null,
                error: false
            },
            onUseNext: onUseNext
        });
    }
    const d = new Date(Number(slot.dateTime));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "fs-card",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            background: 'linear-gradient(135deg, color-mix(in srgb, var(--p-navy) 8%, transparent), color-mix(in srgb, var(--p-navy) 2%, transparent))',
            border: `1.5px solid ${(0, $jTCZr.C).navy}`,
            borderRadius: 12,
            padding: '12px 14px'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    width: 38,
                    height: 38,
                    borderRadius: '50%',
                    flexShrink: 0,
                    background: `linear-gradient(135deg, ${(0, $jTCZr.C).navyDark}, ${(0, $jTCZr.C).navy})`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($3626d9ae39205653$var$ClockIcon, {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    minWidth: 0,
                    flex: 1
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: '0.65625rem',
                            fontWeight: 700,
                            color: (0, $jTCZr.C).textMuted,
                            marginBottom: 3
                        },
                        children: t('doctors.slots.firstFree')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'baseline',
                            gap: 7,
                            flexWrap: 'wrap'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    fontSize: '1.125rem',
                                    fontWeight: 800,
                                    color: (0, $jTCZr.C).navy,
                                    letterSpacing: 0.3
                                },
                                children: $3626d9ae39205653$export$ada0bb5f21bca8b8(slot.dateTime, formatTime)
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    fontSize: '0.78125rem',
                                    fontWeight: 600,
                                    color: (0, $jTCZr.C).textSecondary
                                },
                                children: (0, $lM08I.fmtJalaliLong)(d, formatDate)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: '0.65625rem',
                            color: (0, $jTCZr.C).textMuted,
                            marginTop: 4
                        },
                        children: t('doctors.slots.exactAtBooking')
                    })
                ]
            })
        ]
    });
}

});
parcelRegister("228nw", function(module, exports) {

$parcel$export(module.exports, "SCHEDULED_FOR_DAY", () => $17b2446e7893392a$export$8b83e75b276975a2);
$parcel$export(module.exports, "localDayRange", () => $17b2446e7893392a$export$4b3f895b5fc36b08);
$parcel$export(module.exports, "providerBookings", () => $17b2446e7893392a$export$95b577c0c5b7809);
$parcel$export(module.exports, "selectableSlots", () => $17b2446e7893392a$export$b62e5808e4ef8ef3);
$parcel$export(module.exports, "useSelectableSlots", () => $17b2446e7893392a$export$9be94c055586cb9);

var $acw62 = parcelRequire("acw62");

var $2Mst8 = parcelRequire("2Mst8");

var $lM08I = parcelRequire("lM08I");

var $gcdH8 = parcelRequire("gcdH8");
const $17b2446e7893392a$export$8b83e75b276975a2 = `
  query ScheduledForDay($startTime: String, $endTime: String) {
    scheduledAppointments(startTime: $startTime, endTime: $endTime) {
      id doctorId providerId dateTime status requestExpiresAt
    }
  }
`;
function $17b2446e7893392a$export$4b3f895b5fc36b08(base) {
    return (0, $lM08I.clinicDayWindow)(base);
}
function $17b2446e7893392a$export$95b577c0c5b7809(appointments, providerId, slotMin, excludeAppointmentId = null) {
    // `holdsSlot`, not `status !== 'cancelled'`: a REJECTED request releases its
    // hour exactly as a cancellation does, and the desk that just answered «رد»
    // is usually the one about to give that hour to somebody else. Filtering on
    // `cancelled` alone left a refused request hiding a slot the scheduling
    // service would happily have booked.
    return (appointments || []).filter((a)=>(a.providerId || a.doctorId) === providerId && (0, $gcdH8.holdsSlot)(a))// «ویرایش نوبت»: the appointment being moved holds the hour it is leaving, and
    // must not hide that hour — or the ones its visit overlaps — from its own grid.
    // The service makes the same exception (`exclude_appointment_id`).
    .filter((a)=>!excludeAppointmentId || a.id !== excludeAppointmentId).map((a)=>({
            startMs: Number(a.dateTime),
            durMin: slotMin
        }));
}
function $17b2446e7893392a$export$b62e5808e4ef8ef3({ timeSlots: timeSlots, presences: presences, shiftless: shiftless = false, selectedDate: selectedDate, slotMin: slotMin, booked: booked, nowMs: nowMs = Date.now() }) {
    const irDow = (0, $lM08I.jsToIrDow)((0, $lM08I.calendarDow)(selectedDate));
    const absent = !shiftless && (0, $lM08I.doctorAbsentOn)(presences, irDow);
    if (absent) return [];
    const inPresence = shiftless ? timeSlots : (0, $lM08I.presenceSlots)(timeSlots, presences, irDow);
    const free = (0, $lM08I.freeSlots)(inPresence, selectedDate, slotMin, booked);
    if (!(0, $lM08I.isClinicToday)(selectedDate, nowMs)) return free;
    return free.filter((s)=>(0, $lM08I.slotInstant)(selectedDate, s.h, s.m) >= nowMs);
}
function $17b2446e7893392a$export$9be94c055586cb9({ doctorId: doctorId, presences: presences, timeSlots: timeSlots, selectedDate: selectedDate, slotMin: slotMin, shiftless: shiftless = false, excludeAppointmentId: excludeAppointmentId = null }) {
    const [booked, setBooked] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // Re-fetch when the doctor or the day changes. dateKey collapses the Date to the day so a
    // new Date object for the same day does not re-trigger.
    const dayKey = (0, $lM08I.dayIsoOf)(selectedDate);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!doctorId) {
            setBooked([]);
            return;
        }
        let cancelled = false;
        setLoading(true);
        const { startTime: startTime, endTime: endTime } = $17b2446e7893392a$export$4b3f895b5fc36b08(selectedDate);
        (0, $2Mst8.bffQuery)($17b2446e7893392a$export$8b83e75b276975a2, {
            startTime: startTime,
            endTime: endTime
        }).then((data)=>{
            if (cancelled) return;
            setBooked($17b2446e7893392a$export$95b577c0c5b7809(data?.scheduledAppointments, doctorId, slotMin, excludeAppointmentId));
        }).catch(()=>{
            if (!cancelled) setBooked([]);
        }).finally(()=>{
            if (!cancelled) setLoading(false);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        doctorId,
        dayKey,
        slotMin,
        excludeAppointmentId
    ]);
    const irDow = (0, $lM08I.jsToIrDow)((0, $lM08I.calendarDow)(selectedDate));
    const noShift = !shiftless && (0, $lM08I.doctorHasNoShift)(presences);
    const absent = !shiftless && (0, $lM08I.doctorAbsentOn)(presences, irDow);
    // The minute, not the millisecond, so a re-render does not recompute the grid
    // for nothing; and only on today, where the past exists.
    const isToday = (0, $lM08I.isClinicToday)(selectedDate);
    const nowMinute = isToday ? Math.floor(Date.now() / 60000) : 0;
    const slots = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>$17b2446e7893392a$export$b62e5808e4ef8ef3({
            timeSlots: timeSlots,
            presences: presences,
            shiftless: shiftless,
            selectedDate: selectedDate,
            slotMin: slotMin,
            booked: booked,
            nowMs: isToday ? nowMinute * 60000 : 0
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        shiftless,
        timeSlots,
        presences,
        irDow,
        dayKey,
        slotMin,
        booked,
        isToday,
        nowMinute
    ]);
    return {
        slots: slots,
        loading: loading,
        noShift: // Reported separately because they are fixed in different places: an empty schedule
        // is corrected once in «پرسنل», a day off by picking another day. `absent` stays true
        // for both so callers that only care "can we book today" keep working.
        noShift,
        absent: absent,
        allBooked: !absent && slots.length === 0
    };
}

});
parcelRegister("gcdH8", function(module, exports) {

$parcel$export(module.exports, "appointmentStatusColors", () => $bca863ce25d766b8$export$bf466165607cc710);
$parcel$export(module.exports, "REJECTION_REASONS", () => $bca863ce25d766b8$export$eb1c2eeea55ae423);
$parcel$export(module.exports, "holdsSlot", () => $bca863ce25d766b8$export$bef32a491b2ca1c4);

var $jTCZr = parcelRequire("jTCZr");
/**
 * Appointment statuses as the DESK sees them — the framework's map, plus the two
 * patient-request states, and a bridge over the gap between them.
 *
 * `requested` and `rejected` belong in `@parsina/framework/tokens` and are there
 * in `packages/tokens/index.js`. But the framework reaches an app as a git tag
 * installed into `node_modules` (the installed one here is v0.13.2), so a token
 * added to the package is not a token the app HAS until someone cuts a release
 * and every client bumps its ref. In between, a chip reading the framework map
 * directly renders «نامشخص» over a perfectly well-defined status.
 *
 * So the two keys are defined here as a FALLBACK, applied only where the
 * installed framework has nothing. Spread order is what makes that true:
 * `statusColors` goes last, so the moment the tag lands its values win and these
 * become dead weight. Delete the `FALLBACK` block then; the rest of the module
 * stays.
 *
 * The patient app carries the same bridge, derived the same way
 * (`patient-app/parsina.patient.app/src/constants/appointmentStatus.js`).
 *
 * The LABELS are deliberately absent from this module. The clinic app is
 * trilingual and every label it renders comes from `useTranslation()`; a Persian
 * string baked into a constants file is precisely what the i18n ratchet exists to
 * keep out. What the framework map carries as `label` is ignored here — callers
 * ask `t('reception.requests.status.<key>')`.
 */ // Derived from swatches the installed framework ALREADY has, never spelled as
// hex. `packages/tokens` defines the two new statuses with exactly these
// colours — `requested` is `waiting`'s amber, `rejected` is `no_show`'s grey —
// so reusing them is not an approximation, it is the same values reached
// without copying them. That keeps this file inside the no-raw-hex rule (it
// needs no exemption) and makes a drift impossible: if the palette moves, the
// bridge moves with it.
const $bca863ce25d766b8$var$FALLBACK = {
    requested: {
        ...(0, $jTCZr.statusColors).waiting
    },
    rejected: {
        ...(0, $jTCZr.statusColors).no_show
    }
};
const $bca863ce25d766b8$export$991f3ee37398e50 = {
    ...$bca863ce25d766b8$var$FALLBACK,
    ...(0, $jTCZr.statusColors)
};
function $bca863ce25d766b8$var$normalize(status) {
    return String(status || '').toLowerCase().replace(/-/g, '_');
}
function $bca863ce25d766b8$export$bf466165607cc710(status) {
    const key = $bca863ce25d766b8$var$normalize(status);
    return $bca863ce25d766b8$export$991f3ee37398e50[key] || null;
}
const $bca863ce25d766b8$export$eb1c2eeea55ae423 = [
    'no_capacity',
    'practitioner_unavailable',
    'patient_not_eligible',
    'other'
];
const $bca863ce25d766b8$export$3d6fe0ea7756fb68 = [
    'cancelled',
    'rejected'
];
function $bca863ce25d766b8$export$bef32a491b2ca1c4(appointment, nowMs = Date.now()) {
    const status = $bca863ce25d766b8$var$normalize(appointment?.status);
    if ($bca863ce25d766b8$export$3d6fe0ea7756fb68.includes(status)) return false;
    if (status === 'requested') {
        const expires = Number(appointment?.requestExpiresAt);
        if (Number.isFinite(expires) && expires > 0 && expires <= nowMs) return false;
    }
    return true;
}

});



parcelRegister("hGTfp", function(module, exports) {

$parcel$export(module.exports, "useAutoFocus", () => $ce1136e8ec8fcbb4$export$33f6e33e382f8800);

var $acw62 = parcelRequire("acw62");
function $ce1136e8ec8fcbb4$export$33f6e33e382f8800(enabled = true) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!enabled) return undefined;
        // A frame later, not synchronously: modals here mount mid-animation, and the
        // caret is more reliable once the tree the field lives in has painted once.
        const id = requestAnimationFrame(()=>{
            const el = ref.current;
            if (!el) return;
            el.focus();
            // Whatever was typed before is replaced by the next keystroke rather than
            // appended to — returning to the field means starting a new search.
            el.select?.();
        });
        return ()=>cancelAnimationFrame(id);
    }, [
        enabled
    ]);
    return ref;
}
var $ce1136e8ec8fcbb4$export$2e2bcd8739ae039 = $ce1136e8ec8fcbb4$export$33f6e33e382f8800;

});

parcelRegister("k7Ymn", function(module, exports) {

$parcel$export(module.exports, "UNTIMED_DAY", () => $06e9c0f0a2de67e0$export$8b6bf0b313a3a434);
$parcel$export(module.exports, "UNTIMED_NOW", () => $06e9c0f0a2de67e0$export$fc603bcba1a8b30);
$parcel$export(module.exports, "useUntimed", () => $06e9c0f0a2de67e0$export$70547ba80439da42);
$parcel$export(module.exports, "untimedSuggested", () => $06e9c0f0a2de67e0$export$e8a6f8c4418f0490);
$parcel$export(module.exports, "UntimedRow", () => $06e9c0f0a2de67e0$export$86358d8b1395b103);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $dyHsi = parcelRequire("dyHsi");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $lM08I = parcelRequire("lM08I");
const $06e9c0f0a2de67e0$export$8b6bf0b313a3a434 = 'DAY';
const $06e9c0f0a2de67e0$export$fc603bcba1a8b30 = 'NOW';
function $06e9c0f0a2de67e0$export$70547ba80439da42(mode) {
    const [on, setOn] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    return {
        on: on,
        setOn: setOn,
        /** What `createAppointment` should carry, or null for an ordinary booking. */ value: on ? mode : null
    };
}
function $06e9c0f0a2de67e0$export$e8a6f8c4418f0490({ mode: mode, slotMode: slotMode, dayIsToday: dayIsToday, previewEmpty: previewEmpty, allBooked: allBooked, todayFull: todayFull }) {
    if (mode === $06e9c0f0a2de67e0$export$fc603bcba1a8b30) return !!todayFull || slotMode === 'firstOfDay' && dayIsToday && !!previewEmpty;
    return !!allBooked;
}
function $06e9c0f0a2de67e0$export$86358d8b1395b103({ untimed: untimed, mode: mode, suggested: suggested = false, separated: separated = false, compact: compact = false, selectedGDate: selectedGDate }) {
    const { t: t, formatDate: formatDate, locale: locale } = (0, $e1LEq.default)();
    const now = mode === $06e9c0f0a2de67e0$export$fc603bcba1a8b30;
    const on = untimed.on;
    let hint;
    if (on) hint = now ? t(compact ? 'calendar.slots.untimedNowNoticeShort' : 'calendar.slots.untimedNowNotice') : t(compact ? 'calendar.slots.untimedNoticeShort' : 'calendar.slots.untimedNotice');
    else if (suggested) hint = now ? t(compact ? 'calendar.slots.untimedLeadShort' : 'calendar.slots.untimedLead') : t(compact ? 'calendar.slots.untimedLeadDayShort' : 'calendar.slots.untimedLeadDay');
    else if (!compact) hint = now ? t('calendar.slots.untimedNowHint') : t('calendar.slots.untimedHint', {
        date: (0, $lM08I.fmtJalaliShort)(selectedGDate, formatDate)
    });
    else hint = null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dyHsi.default), {
        checked: on,
        onChange: untimed.setOn,
        suggested: suggested,
        separated: separated && !on,
        compact: compact,
        title: now ? t('calendar.slots.untimedNow') : t('calendar.slots.untimed'),
        hint: hint,
        locale: locale,
        testId: "untimed-toggle"
    });
}

});

parcelRegister("1DJld", function(module, exports) {

$parcel$export(module.exports, "useCashier", () => $131c9ac36c348551$export$9d54a30ee22acf0b);
$parcel$export(module.exports, "usePatientAccount", () => $131c9ac36c348551$export$b1d292c2263a5e8c);
$parcel$export(module.exports, "useClinicPayments", () => $131c9ac36c348551$export$8b7e220ffc15bbd1);
$parcel$export(module.exports, "useMedicalServiceTariffs", () => $131c9ac36c348551$export$5faf71f3306d6c70);
$parcel$export(module.exports, "useClinicDoctorOptions", () => $131c9ac36c348551$export$f2079c4a1f029a5f);

var $acw62 = parcelRequire("acw62");

var $2Mst8 = parcelRequire("2Mst8");

var $5pHac = parcelRequire("5pHac");
// ── Fragments ─────────────────────────────────────────────────────────────────
const $131c9ac36c348551$var$LINE_ITEM_FIELDS = `
  currency id invoiceId itemType sourceId description quantity
  # WHICH service the line bills, on whose terms, by whose hand, and what KIND
  # of line it is (docs/CLINIC_RECEPTION_SERVICE_INVOICE_DESIGN.md \xa77.1). The
  # role is what locks the PRIMARY line \u{2014} the encounter's own service, changed
  # by re-pointing the APPOINTMENT and never by editing the invoice.
  catalogId serviceDeclarationId priceSource role serviceLabel
  unitTariff discountType discountValue
  totalAmount discount insuranceShare patientPayable settlementStatus
  insurerId patientSharePct insuranceSource insuranceOverrideReason computedInsuranceShare
`;
// paidAmount/outstanding are derived by the service from the payments themselves.
// Before they existed the UI guessed "paid" from the lines' settlement flags, which
// settle all-or-nothing — so a partly-paid invoice showed ۰ collected.
const $131c9ac36c348551$var$INVOICE_FIELDS = `
  currency id patientId doctorId clinicId appointmentId createdAt updatedAt
  discountType discountValue
  totalAmount invoiceDiscount discountTotal insuranceShare patientPayable status shiftId
  paidAmount outstanding
  kind issuedAt invoiceNumber appointmentTime isIssued
  # Derived by the service from its own lines: which declaration priced the
  # encounter's service, and whether anything priced it at all.
  primaryServiceDeclarationId priceResolution
  patientName patientPhone doctorName
  lineItems { ${$131c9ac36c348551$var$LINE_ITEM_FIELDS} }
`;
const $131c9ac36c348551$var$PAYMENT_FIELDS = `currency id invoiceId patientId amount paymentMethod referenceNumber createdAt shiftId status kind refundOf refundedAmount`;
// ── Queries ───────────────────────────────────────────────────────────────────
// doctorId omitted/empty = every doctor in the clinic.
const $131c9ac36c348551$var$LIST_INVOICES = `
  query AccountingInvoices($status: String, $patientId: String, $from: String, $to: String, $doctorId: String) {
    accountingInvoices(status: $status, patientId: $patientId, from: $from, to: $to, doctorId: $doctorId) { ${$131c9ac36c348551$var$INVOICE_FIELDS} }
  }
`;
// Server-PAGED cashier list. status picks the tab (queue = OPEN, partial, settled = PAID);
// items is that tab's page; total is the tab's whole size (its badge); outstandingTotal /
// collectedTotal are aggregates over the whole tab, so «مجموع بدهی» / «دریافتی» count rows
// off the visible page. search matches patient name/phone, resolved to ids server-side.
const $131c9ac36c348551$var$LIST_INVOICES_PAGE = `
  query AccountingInvoicesPage($status: String, $doctorId: String, $search: String, $from: String, $to: String, $limit: Int, $offset: Int) {
    accountingInvoicesPage(status: $status, doctorId: $doctorId, search: $search, from: $from, to: $to, limit: $limit, offset: $offset) {
      currency
      items { ${$131c9ac36c348551$var$INVOICE_FIELDS} }
      total outstandingTotal collectedTotal
    }
  }
`;
const $131c9ac36c348551$var$GET_INVOICE = `
  query AccountingInvoice($invoiceId: ID!) {
    accountingInvoice(invoiceId: $invoiceId) { ${$131c9ac36c348551$var$INVOICE_FIELDS} }
  }
`;
const $131c9ac36c348551$var$DAILY_SUMMARY = `
  query AccountingDailySummary($doctorId: String) {
    accountingDailySummary(doctorId: $doctorId) {
      currency
      clinicId doctorId date visitRevenue medicalServiceRevenue productRevenue totalRevenue
      totalCash totalCard totalOnline totalInsurance totalPatientDebt activeShiftId
    }
  }
`;
const $131c9ac36c348551$var$SHIFT_SUMMARY = `
  query AccountingShiftSummary($shiftId: ID!) {
    accountingShiftSummary(shiftId: $shiftId) {
      currency
      shift { currency id doctorId clinicId openedAt closedAt status totalCash totalCard totalOnline totalInsurance notes }
      totalInvoices paidInvoices totalCollected
    }
  }
`;
const $131c9ac36c348551$var$CLINIC_SERVICE_DECLARATIONS = `
  query ClinicServiceDeclarations {
    clinicServiceDeclarations { currency id catalogId description unitPrice isActive doctorId orderType }
  }
`;
// Just the id/name pairs the doctor filter needs. useClinicDoctors() would also do
// a doctorInfo round-trip per doctor to enrich rows the dropdown never shows.
const $131c9ac36c348551$var$CLINIC_DOCTOR_OPTIONS = `
  query MyClinicDoctors($clinicId: ID!) {
    listClinicDoctors(clinicId: $clinicId) { doctorId doctorName active }
  }
`;
const $131c9ac36c348551$var$MY_CLINIC = `query MyClinic { myClinic { id } }`;
const $131c9ac36c348551$var$LIST_PAYMENTS = `
  query AccountingPayments($invoiceId: ID) {
    accountingPayments(invoiceId: $invoiceId) { ${$131c9ac36c348551$var$PAYMENT_FIELDS} }
  }
`;
// Every payment taken in one cashier shift — the drawer's cash log, which the totals
// on the shift panel are the sum of.
const $131c9ac36c348551$var$SHIFT_PAYMENTS = `
  query ShiftPayments($shiftId: ID!) {
    accountingPayments(shiftId: $shiftId) { ${$131c9ac36c348551$var$PAYMENT_FIELDS} }
  }
`;
// ── Mutations ─────────────────────────────────────────────────────────────────
const $131c9ac36c348551$var$CREATE_INVOICE = `
  mutation AccountingCreateInvoice($patientId: String!, $doctorId: String!, $appointmentId: String, $shiftId: String) {
    accountingCreateInvoice(patientId: $patientId, doctorId: $doctorId, appointmentId: $appointmentId, shiftId: $shiftId) { ${$131c9ac36c348551$var$INVOICE_FIELDS} }
  }
`;
const $131c9ac36c348551$var$ADD_LINE_ITEM = `
  mutation AccountingAddLineItem($input: AddLineItemInput!) {
    accountingAddLineItem(input: $input) { ${$131c9ac36c348551$var$LINE_ITEM_FIELDS} }
  }
`;
const $131c9ac36c348551$var$UPDATE_LINE_ITEM = `
  mutation AccountingUpdateLineItem($input: UpdateLineItemInput!) {
    accountingUpdateLineItem(input: $input) { ${$131c9ac36c348551$var$LINE_ITEM_FIELDS} }
  }
`;
// Replacing a COMPUTED insurer share with a human's number. Deliberately not part
// of updateLineItem: an override is a different act with a different permission
// (`payments.manage`) and a mandatory reason, and the service keeps the computed
// figure beside it so the invoice still shows what the rules said.
const $131c9ac36c348551$var$OVERRIDE_LINE_INSURANCE = `
  mutation OverrideLineInsurance($lineItemId: ID!, $insuranceShare: Float!, $reason: String!) {
    overrideLineInsurance(
      lineItemId: $lineItemId, insuranceShare: $insuranceShare, reason: $reason
    ) { ${$131c9ac36c348551$var$LINE_ITEM_FIELDS} }
  }
`;
const $131c9ac36c348551$var$REMOVE_LINE_ITEM = `
  mutation AccountingRemoveLineItem($lineItemId: ID!) {
    accountingRemoveLineItem(lineItemId: $lineItemId)
  }
`;
// `reason` is MANDATORY for a non-zero discount: the service refuses one without
// it (REASON_REQUIRED), because reducing a price is a judgement and a ledger that
// records the judgement without its justification can be read but not audited.
const $131c9ac36c348551$var$SET_INVOICE_DISCOUNT = `
  mutation AccountingSetInvoiceDiscount($invoiceId: ID!, $discountType: String!, $discountValue: Float!, $reason: String) {
    accountingSetInvoiceDiscount(invoiceId: $invoiceId, discountType: $discountType, discountValue: $discountValue, reason: $reason) { ${$131c9ac36c348551$var$INVOICE_FIELDS} }
  }
`;
const $131c9ac36c348551$var$RECORD_PAYMENT = `
  mutation AccountingRecordPayment($input: RecordPaymentInput!) {
    accountingRecordPayment(input: $input) { ${$131c9ac36c348551$var$PAYMENT_FIELDS} }
  }
`;
// `reason` is required by the schema now — a reversal with no account of itself
// is exactly what the journal exists to prevent.
// «در انتظار تأیید» — a POS or online payment counts for nothing until the
// terminal answers. Resolving it is what turns it into money (or removes it).
const $131c9ac36c348551$var$RESOLVE_PAYMENT = `
  mutation AccountingResolvePayment($paymentId: ID!, $outcome: String!, $referenceNumber: String) {
    accountingResolvePayment(paymentId: $paymentId, outcome: $outcome, referenceNumber: $referenceNumber) {
      ${$131c9ac36c348551$var$PAYMENT_FIELDS}
    }
  }
`;
const $131c9ac36c348551$var$VOID_INVOICE = `
  mutation AccountingVoidInvoice($invoiceId: ID!, $reason: String!) {
    accountingVoidInvoice(invoiceId: $invoiceId, reason: $reason) { ${$131c9ac36c348551$var$INVOICE_FIELDS} }
  }
`;
// The proforma becomes the numbered FINAL invoice; every prepayment on it stays.
const $131c9ac36c348551$var$ISSUE_INVOICE = `
  mutation AccountingIssueInvoice($invoiceId: ID!) {
    accountingIssueInvoice(invoiceId: $invoiceId) { ${$131c9ac36c348551$var$INVOICE_FIELDS} }
  }
`;
// «علی‌الحساب» — what the clinic holds on account for a patient, and spending it.
const $131c9ac36c348551$var$PATIENT_CREDIT_BALANCE = `
  query PatientCreditBalance($patientId: ID!) {
    patientCreditBalance(patientId: $patientId) { currency balanceRial depositedRial appliedRial refundedRial }
  }
`;
const $131c9ac36c348551$var$APPLY_CREDIT = `
  mutation ApplyCreditToInvoice($invoiceId: ID!, $amountRial: Float!, $note: String) {
    applyCreditToInvoice(invoiceId: $invoiceId, amountRial: $amountRial, note: $note) {
      currency
      balanceRial
      payment { ${$131c9ac36c348551$var$PAYMENT_FIELDS} }
      invoice { ${$131c9ac36c348551$var$INVOICE_FIELDS} }
    }
  }
`;
const $131c9ac36c348551$var$RECORD_PATIENT_CREDIT = `
  mutation RecordPatientCredit($patientId: ID!, $amountRial: Float!, $paymentMethod: String, $planRef: String, $note: String, $requestId: ID) {
    recordPatientCredit(patientId: $patientId, amountRial: $amountRial, paymentMethod: $paymentMethod, planRef: $planRef, note: $note, requestId: $requestId) {
      currency
      balanceRial
      credit { currency id amountRial source paymentMethod createdAt }
    }
  }
`;
const $131c9ac36c348551$var$OPEN_SHIFT = `
  mutation AccountingOpenShift {
    accountingOpenShift { currency id status openedAt totalCash totalCard totalOnline totalInsurance }
  }
`;
const $131c9ac36c348551$var$CLOSE_SHIFT = `
  mutation AccountingCloseShift($shiftId: ID!, $notes: String) {
    accountingCloseShift(shiftId: $shiftId, notes: $notes) { currency id status closedAt totalCash totalCard totalOnline totalInsurance }
  }
`;
function $131c9ac36c348551$export$9d54a30ee22acf0b(doctorId = '', range = null, opts = {}) {
    // Pagination is OPT-IN (the cashier list passes pageSize). Callers that don't — the
    // Reception panel, which matches EVERY appointment to its invoice and must not miss one to a
    // page boundary — keep the legacy behaviour: every invoice, unpaginated. (Its own
    // scoping keeps that bounded; this hook does not change how much it asks for.)
    const paginated = opts.pageSize != null;
    const { tab: tab = 'queue', page: page = 1, pageSize: pageSize = 50, search: search = '' } = opts;
    // The badge counts, the KPI aggregates and the day summary are the LIST
    // screen's furniture. Reception wants one thing from this hook — the invoice
    // behind each appointment — and asking for the rest cost it four extra round
    // trips on every day change, for figures «مالی امروز» now answers properly
    // (docs/CLINIC_RECEPTION_FINANCIAL_EVENTS_DESIGN.md §11).
    const badges = opts.badges !== false;
    // `list: false` — the MUTATIONS only, for a host that was handed the one invoice
    // it settles (components/billing/SettleHost.jsx). Without it that host would fire
    // an invoice query nothing on screen reads, on mount and again after every
    // payment, purely to obtain `recordPayment`.
    const wantsList = opts.list !== false;
    // The tab IS a status filter now: 'all' = no status (every invoice in the range),
    // the others map to one status. Only the active tab's rows are fetched; the three
    // real statuses come back as a count + aggregate (limit 1) for the badges and KPIs.
    const STATUS_FOR = {
        all: '',
        queue: 'OPEN',
        partial: 'INVOICE_PARTIALLY_PAID',
        settled: 'PAID'
    };
    const activeStatus = tab in STATUS_FOR ? STATUS_FOR[tab] : 'OPEN';
    const [invoices, setInvoices] = (0, $acw62.useState)([]); // the active tab's page only
    const [meta, setMeta] = (0, $acw62.useState)({
        total: 0,
        counts: {
            queue: 0,
            partial: 0,
            settled: 0
        },
        dueQueue: 0,
        collected: 0
    });
    const [dailySummary, setDailySummary] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(wantsList);
    const [error, setError] = (0, $acw62.useState)(null);
    // Identity, not reference: the caller rebuilds `range` on every render, and depending
    // on the object itself would refetch forever.
    const fromTs = range?.fromTs ?? null;
    const toTs = range?.toTs ?? null;
    // Guards against an out-of-order response. Switching doctor/window/tab/page fires a new
    // fetch while the previous one is still in flight, and the loser must not land on top.
    const reqId = (0, $acw62.useRef)(0);
    const loadAll = (0, $acw62.useCallback)(async ()=>{
        if (!wantsList) return;
        const req = ++reqId.current;
        setLoading(true);
        // Clear the previous failure BEFORE the fetch. It used to be set on catch and
        // never unset, so one blip left the mobile surface's ErrorState on screen for
        // the rest of the session — including after a retry that succeeded.
        setError(null);
        const win = fromTs != null && toTs != null ? {
            from: String(fromTs),
            to: String(toTs)
        } : {};
        const common = {
            doctorId: doctorId,
            search: search || null,
            ...win
        };
        const EMPTY = {
            items: [],
            total: 0,
            outstandingTotal: 0,
            collectedTotal: 0
        };
        try {
            if (!paginated) {
                // Legacy path (Reception): every invoice across the three live statuses, merged,
                // so an appointment can be matched to its invoice whatever its state or position.
                const [dash, openData, partialData, paidData] = await Promise.all([
                    (0, $2Mst8.bffQuery)($131c9ac36c348551$var$DAILY_SUMMARY, {
                        doctorId: doctorId
                    }),
                    (0, $2Mst8.bffQuery)($131c9ac36c348551$var$LIST_INVOICES, {
                        status: 'OPEN',
                        doctorId: doctorId,
                        ...win
                    }),
                    (0, $2Mst8.bffQuery)($131c9ac36c348551$var$LIST_INVOICES, {
                        status: 'INVOICE_PARTIALLY_PAID',
                        doctorId: doctorId,
                        ...win
                    }),
                    (0, $2Mst8.bffQuery)($131c9ac36c348551$var$LIST_INVOICES, {
                        status: 'PAID',
                        doctorId: doctorId,
                        ...win
                    })
                ]);
                if (req !== reqId.current) return;
                const open = openData.accountingInvoices || [];
                const partial = partialData.accountingInvoices || [];
                const paid = paidData.accountingInvoices || [];
                setInvoices([
                    ...open,
                    ...partial,
                    ...paid
                ]);
                setMeta({
                    total: open.length + partial.length + paid.length,
                    counts: {
                        queue: open.length,
                        partial: partial.length,
                        settled: paid.length
                    },
                    dueQueue: 0,
                    collected: 0
                });
                setDailySummary(dash.accountingDailySummary || null);
                return;
            }
            // The active tab's page (status may be '' for «همه»), plus one bounded row per real
            // status for the badges + KPI aggregates, plus the daily summary. All bounded — no query
            // can pull the whole (post-migration) invoice set into one response.
            const activePage = (0, $2Mst8.bffQuery)($131c9ac36c348551$var$LIST_INVOICES_PAGE, {
                ...common,
                status: activeStatus,
                limit: pageSize,
                offset: (Math.max(1, page) - 1) * pageSize
            });
            const [dash, activeRes, openRes, partialRes, settledRes] = badges ? await Promise.all([
                (0, $2Mst8.bffQuery)($131c9ac36c348551$var$DAILY_SUMMARY, {
                    doctorId: doctorId
                }),
                activePage,
                (0, $2Mst8.bffQuery)($131c9ac36c348551$var$LIST_INVOICES_PAGE, {
                    ...common,
                    status: 'OPEN',
                    limit: 1,
                    offset: 0
                }),
                (0, $2Mst8.bffQuery)($131c9ac36c348551$var$LIST_INVOICES_PAGE, {
                    ...common,
                    status: 'INVOICE_PARTIALLY_PAID',
                    limit: 1,
                    offset: 0
                }),
                (0, $2Mst8.bffQuery)($131c9ac36c348551$var$LIST_INVOICES_PAGE, {
                    ...common,
                    status: 'PAID',
                    limit: 1,
                    offset: 0
                })
            ]) : [
                null,
                await activePage,
                null,
                null,
                null
            ];
            if (req !== reqId.current) return; // superseded — drop it
            const active = activeRes?.accountingInvoicesPage || EMPTY;
            const open = openRes?.accountingInvoicesPage || EMPTY;
            const partial = partialRes?.accountingInvoicesPage || EMPTY;
            const settled = settledRes?.accountingInvoicesPage || EMPTY;
            const byStatus = {
                OPEN: open,
                'INVOICE_PARTIALLY_PAID': partial,
                PAID: settled
            };
            setInvoices(active.items || []);
            setMeta({
                total: active.total || 0,
                counts: {
                    queue: byStatus['OPEN'].total || 0,
                    partial: byStatus['INVOICE_PARTIALLY_PAID'].total || 0,
                    settled: byStatus['PAID'].total || 0
                },
                // «مجموع بدهی» is the unsettled money: OPEN + PARTIAL outstanding across the range.
                dueQueue: (byStatus['OPEN'].outstandingTotal || 0) + (byStatus['INVOICE_PARTIALLY_PAID'].outstandingTotal || 0),
                // «دریافتی» is everything collected in the range, whatever the invoice's status.
                collected: (byStatus['OPEN'].collectedTotal || 0) + (byStatus['INVOICE_PARTIALLY_PAID'].collectedTotal || 0) + (byStatus['PAID'].collectedTotal || 0)
            });
            // Null, not zero: a caller that did not ask for the summary has no figure,
            // and a stale one left standing would be read as this range's.
            setDailySummary(dash ? dash.accountingDailySummary || null : null);
        } catch (e) {
            if (req !== reqId.current) return;
            setError(e);
        } finally{
            if (req === reqId.current) setLoading(false);
        }
    }, [
        fromTs,
        toTs,
        doctorId,
        tab,
        page,
        pageSize,
        search,
        paginated,
        badges,
        wantsList
    ]);
    (0, $acw62.useEffect)(()=>{
        loadAll();
    }, [
        loadAll
    ]);
    const getInvoice = (0, $acw62.useCallback)(async (invoiceId)=>{
        const data = await (0, $2Mst8.bffQuery)($131c9ac36c348551$var$GET_INVOICE, {
            invoiceId: invoiceId
        });
        return data.accountingInvoice;
    }, []);
    const getPayments = (0, $acw62.useCallback)(async (invoiceId)=>{
        const data = await (0, $2Mst8.bffQuery)($131c9ac36c348551$var$LIST_PAYMENTS, {
            invoiceId: invoiceId
        });
        return data.accountingPayments || [];
    }, []);
    const getShiftPayments = (0, $acw62.useCallback)(async (shiftId)=>{
        const data = await (0, $2Mst8.bffQuery)($131c9ac36c348551$var$SHIFT_PAYMENTS, {
            shiftId: shiftId
        }, 'ShiftPayments');
        return data.accountingPayments || [];
    }, []);
    const createInvoice = (0, $acw62.useCallback)(async ({ patientId: patientId, doctorId: forDoctorId, appointmentId: appointmentId, shiftId: shiftId })=>{
        const data = await (0, $2Mst8.bffMutation)($131c9ac36c348551$var$CREATE_INVOICE, {
            patientId: patientId,
            doctorId: forDoctorId,
            appointmentId: appointmentId,
            shiftId: shiftId
        });
        const inv = data.accountingCreateInvoice;
        setInvoices((prev)=>[
                inv,
                ...prev
            ]);
        return inv;
    }, []);
    const addLineItem = (0, $acw62.useCallback)(async (input)=>{
        const data = await (0, $2Mst8.bffMutation)($131c9ac36c348551$var$ADD_LINE_ITEM, {
            input: input
        });
        const item = data.accountingAddLineItem;
        setInvoices((prev)=>prev.map((inv)=>inv.id === input.invoiceId ? {
                    ...inv,
                    lineItems: [
                        ...inv.lineItems,
                        item
                    ],
                    totalAmount: inv.totalAmount + item.totalAmount,
                    patientPayable: inv.patientPayable + item.patientPayable,
                    // The service reopens a settled invoice when a new item lands on it
                    // (payments no longer cover the payable). Mirror that here so the
                    // cashier list and the reception row stop showing «تسویه‌شده».
                    status: inv.status === 'PAID' ? 'INVOICE_PARTIALLY_PAID' : inv.status
                } : inv));
        return item;
    }, []);
    const updateLineItem = (0, $acw62.useCallback)(async (input)=>{
        const data = await (0, $2Mst8.bffMutation)($131c9ac36c348551$var$UPDATE_LINE_ITEM, {
            input: input
        });
        // An edit re-derives the invoice's totals AND its status server-side: repricing
        // a line up reopens a settled invoice, repricing it down can settle one. Status
        // depends on the paid total, which the list doesn't carry — refetch, don't guess.
        await loadAll();
        return data.accountingUpdateLineItem;
    }, [
        loadAll
    ]);
    const overrideLineInsurance = (0, $acw62.useCallback)(async (lineItemId, insuranceShare, reason)=>{
        const data = await (0, $2Mst8.bffMutation)($131c9ac36c348551$var$OVERRIDE_LINE_INSURANCE, {
            lineItemId: lineItemId,
            insuranceShare: insuranceShare,
            reason: reason
        });
        // Same reason updateLineItem refetches: the share moves what the patient owes,
        // which can settle or reopen the invoice.
        await loadAll();
        return data.overrideLineInsurance;
    }, [
        loadAll
    ]);
    const setInvoiceDiscount = (0, $acw62.useCallback)(async (invoiceId, discountType, discountValue, reason)=>{
        const data = await (0, $2Mst8.bffMutation)($131c9ac36c348551$var$SET_INVOICE_DISCOUNT, {
            invoiceId: invoiceId,
            discountType: discountType,
            discountValue: discountValue,
            reason: reason || ''
        });
        const updated = data.accountingSetInvoiceDiscount;
        // Like an edit, a discount can settle or reopen the invoice — the server returns the
        // whole re-derived invoice, so take it wholesale rather than patching a delta.
        setInvoices((prev)=>prev.map((inv)=>inv.id === invoiceId ? {
                    ...inv,
                    ...updated
                } : inv));
        return updated;
    }, []);
    const removeLineItem = (0, $acw62.useCallback)(async (invoiceId, lineItemId)=>{
        await (0, $2Mst8.bffMutation)($131c9ac36c348551$var$REMOVE_LINE_ITEM, {
            lineItemId: lineItemId
        });
        setInvoices((prev)=>prev.map((inv)=>inv.id === invoiceId ? {
                    ...inv,
                    lineItems: inv.lineItems.filter((li)=>li.id !== lineItemId)
                } : inv));
    }, []);
    const recordPayment = (0, $acw62.useCallback)(async (input)=>{
        const data = await (0, $2Mst8.bffMutation)($131c9ac36c348551$var$RECORD_PAYMENT, {
            input: input
        });
        await loadAll();
        return data.accountingRecordPayment;
    }, [
        loadAll
    ]);
    /**
   * Hand money back FROM THE DESK.
   *
   * The same act as the ledger page's refund and deliberately the same shape: a
   * new signed row against a real payment, banked into the drawer open NOW, so a
   * closed shift is never rewritten and both facts stay in the ledger. It lives
   * here as well because reception is where money is taken, and until now the
   * desk could take it and could not give it back
   * (docs/CLINIC_RECEPTION_FINANCIAL_EVENTS_DESIGN.md §8.3).
   */ const refundPayment = (0, $acw62.useCallback)(async ({ paymentId: paymentId, amount: amount, paymentMethod: paymentMethod, referenceNumber: referenceNumber, reason: reason, requestId: requestId })=>{
        const data = await (0, $2Mst8.bffMutation)($131c9ac36c348551$var$REFUND_PAYMENT, {
            paymentId: paymentId,
            amount: amount,
            paymentMethod: paymentMethod || null,
            referenceNumber: referenceNumber || null,
            reason: reason || '',
            requestId: requestId || null
        }, 'AccountingRefundPayment');
        await loadAll();
        return data.accountingRefundPayment;
    }, [
        loadAll
    ]);
    /**
   * Settle a pending POS / online payment (§R18).
   *
   * `outcome` is SUCCESS | FAILED | CANCELLED. A pending row is money the clinic
   * has NOT got: until the terminal answers it is in no total, no drawer and no
   * day position, which is why the rail lists one older than fifteen minutes as
   * work rather than as takings.
   */ const resolvePayment = (0, $acw62.useCallback)(async (paymentId, outcome, referenceNumber)=>{
        const data = await (0, $2Mst8.bffMutation)($131c9ac36c348551$var$RESOLVE_PAYMENT, {
            paymentId: paymentId,
            outcome: outcome,
            referenceNumber: referenceNumber || null
        }, 'AccountingResolvePayment');
        await loadAll();
        return data.accountingResolvePayment;
    }, [
        loadAll
    ]);
    const voidInvoice = (0, $acw62.useCallback)(async (invoiceId, reason)=>{
        const data = await (0, $2Mst8.bffMutation)($131c9ac36c348551$var$VOID_INVOICE, {
            invoiceId: invoiceId,
            reason: reason || null
        });
        const updated = data.accountingVoidInvoice;
        setInvoices((prev)=>prev.map((inv)=>inv.id === invoiceId ? updated : inv));
        return updated;
    }, []);
    /**
   * «برگشت وجه و ابطال فاکتور» — the whole resolution, in the order it has to
   * happen (docs/CLINIC_RECEPTION_FINANCIAL_EVENTS_DESIGN.md §R11).
   *
   * A cancel refused because money was taken is resolved by giving the money
   * back FIRST and voiding after: an invoice whose payment sits in a CLOSED
   * shift cannot be voided at all (accounting core §10.2), and refunding into
   * today's open drawer is what physically happens anyway.
   *
   * Not atomic, and it cannot be — three services, three writes. So it is
   * ORDERED instead: every refund lands before the void is attempted, and a
   * refund that fails stops the sequence with the earlier ones already in the
   * journal. That is the recoverable failure. The other order (void first)
   * would leave a voided invoice with live payments against it.
   *
   * @returns {{refunded: number}} how many payments went back
   */ const refundAllAndVoid = (0, $acw62.useCallback)(async (invoiceId, { reason: reason, referenceNumber: referenceNumber } = {})=>{
        if (!String(reason || '').trim()) throw new Error('reason is required');
        const rows = await getPayments(invoiceId);
        const going = rows.filter((row)=>(0, $5pHac.canRefund)(row));
        for (const row of going){
            const method = row.paymentMethod || 'CASH';
            await refundPayment({
                paymentId: row.id,
                amount: (0, $5pHac.refundableOf)(row),
                paymentMethod: method,
                // A transfer or terminal refund needs its reference; cash does not, and
                // sending an empty one would be a made-up fact about a bank movement.
                referenceNumber: (0, $5pHac.refundNeedsReference)(method) ? referenceNumber || undefined : undefined,
                reason: reason,
                requestId: `refund-void-${invoiceId}-${row.id}`
            });
        }
        await voidInvoice(invoiceId, reason);
        return {
            refunded: going.length
        };
    }, [
        getPayments,
        refundPayment,
        voidInvoice
    ]);
    // Issuance freezes the lines and stamps the number; the row itself does not move,
    // so the list is patched in place.
    const issueInvoice = (0, $acw62.useCallback)(async (invoiceId)=>{
        const data = await (0, $2Mst8.bffMutation)($131c9ac36c348551$var$ISSUE_INVOICE, {
            invoiceId: invoiceId
        });
        const updated = data.accountingIssueInvoice;
        setInvoices((prev)=>prev.map((inv)=>inv.id === invoiceId ? {
                    ...inv,
                    ...updated
                } : inv));
        return updated;
    }, []);
    const getCreditBalance = (0, $acw62.useCallback)(async (patientId)=>{
        const data = await (0, $2Mst8.bffQuery)($131c9ac36c348551$var$PATIENT_CREDIT_BALANCE, {
            patientId: patientId
        }, 'PatientCreditBalance');
        return data.patientCreditBalance;
    }, []);
    // Settles part of the invoice out of the patient's on-account balance. Reloads:
    // like a payment, it moves the invoice's status and the KPIs.
    const applyCredit = (0, $acw62.useCallback)(async (invoiceId, amountRial, note)=>{
        const data = await (0, $2Mst8.bffMutation)($131c9ac36c348551$var$APPLY_CREDIT, {
            invoiceId: invoiceId,
            amountRial: amountRial,
            note: note || null
        }, 'ApplyCreditToInvoice');
        await loadAll();
        return data.applyCreditToInvoice;
    }, [
        loadAll
    ]);
    // «پیش‌دریافت». `requestId` is the desk's own idempotency key: a deposit
    // refused for want of an open drawer is retried with the SAME id once one is
    // open, and the service records one credit rather than two (§7.3).
    const recordCredit = (0, $acw62.useCallback)(async ({ patientId: patientId, amountRial: amountRial, paymentMethod: paymentMethod, planRef: planRef, note: note, requestId: requestId })=>{
        const data = await (0, $2Mst8.bffMutation)($131c9ac36c348551$var$RECORD_PATIENT_CREDIT, {
            patientId: patientId,
            amountRial: amountRial,
            paymentMethod: paymentMethod || null,
            planRef: planRef || null,
            note: note || null,
            requestId: requestId || null
        }, 'RecordPatientCredit');
        return data.recordPatientCredit;
    }, []);
    const openShift = (0, $acw62.useCallback)(async ()=>{
        const data = await (0, $2Mst8.bffMutation)($131c9ac36c348551$var$OPEN_SHIFT, {});
        return data.accountingOpenShift;
    }, []);
    const closeShift = (0, $acw62.useCallback)(async (shiftId, notes)=>{
        const data = await (0, $2Mst8.bffMutation)($131c9ac36c348551$var$CLOSE_SHIFT, {
            shiftId: shiftId,
            notes: notes
        });
        return data.accountingCloseShift;
    }, []);
    const getShiftSummary = (0, $acw62.useCallback)(async (shiftId)=>{
        const data = await (0, $2Mst8.bffQuery)($131c9ac36c348551$var$SHIFT_SUMMARY, {
            shiftId: shiftId
        });
        return data.accountingShiftSummary;
    }, []);
    return {
        invoices: invoices,
        total: meta.total,
        counts: meta.counts,
        dueQueue: meta.dueQueue,
        collected: meta.collected,
        dailySummary: dailySummary,
        loading: loading,
        error: error,
        reload: loadAll,
        getInvoice: getInvoice,
        getPayments: getPayments,
        getShiftPayments: getShiftPayments,
        createInvoice: createInvoice,
        addLineItem: addLineItem,
        updateLineItem: updateLineItem,
        overrideLineInsurance: overrideLineInsurance,
        removeLineItem: removeLineItem,
        setInvoiceDiscount: setInvoiceDiscount,
        recordPayment: recordPayment,
        voidInvoice: voidInvoice,
        refundPayment: refundPayment,
        refundAllAndVoid: refundAllAndVoid,
        resolvePayment: resolvePayment,
        issueInvoice: issueInvoice,
        getCreditBalance: getCreditBalance,
        applyCredit: applyCredit,
        recordCredit: recordCredit,
        openShift: openShift,
        closeShift: closeShift,
        getShiftSummary: getShiftSummary
    };
}
// ── One patient's financial record ────────────────────────────────────────────
const $131c9ac36c348551$var$PATIENT_ACCOUNT = `
  query PatientAccount($patientId: ID!) {
    patientAccount(patientId: $patientId) {
      patientId
      balance { currency patientId outstanding totalBilled totalPaid openInvoices }
      invoices { ${$131c9ac36c348551$var$INVOICE_FIELDS} }
      payments { ${$131c9ac36c348551$var$PAYMENT_FIELDS} }
    }
  }
`;
function $131c9ac36c348551$export$b1d292c2263a5e8c(patientId) {
    const [account, setAccount] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    const load = (0, $acw62.useCallback)(async ()=>{
        if (!patientId) {
            setAccount(null);
            return;
        }
        setLoading(true);
        setError(null);
        try {
            const data = await (0, $2Mst8.bffQuery)($131c9ac36c348551$var$PATIENT_ACCOUNT, {
                patientId: patientId
            }, 'PatientAccount');
            setAccount(data.patientAccount || null);
        } catch (e) {
            setError(e);
        } finally{
            setLoading(false);
        }
    }, [
        patientId
    ]);
    (0, $acw62.useEffect)(()=>{
        load();
    }, [
        load
    ]);
    return {
        account: account,
        loading: loading,
        error: error,
        reload: load
    };
}
// ── The clinic's payments ledger ──────────────────────────────────────────────
// Deliberately NOT PAYMENT_FIELDS: the joined fields cost the BFF a patient and an
// invoice lookup, and the shift log and the record-payment mutation must not pay for
// columns only the ledger renders.
const $131c9ac36c348551$var$PAYMENT_ROW_FIELDS = `
  currency id invoiceId patientId amount paymentMethod referenceNumber createdAt shiftId
  patientName patientPhone doctorId doctorName invoiceStatus
  status voidedAt voidedBy voidReason shiftStatus
  kind refundOf refundedAmount
`;
// includeVoided: this is the ONE view that shows a reversal. Everywhere else a voided
// payment is money that never arrived, and the BFF hides it by default.
//
// Server-PAGED and server-FILTERED: doctor, method and the name search are all applied
// by the service now, so the page, the total and the KPI aggregates all describe the
// same filtered set — and «همه» never pulls a clinic's every receipt into one response
// (the RESOURCE_EXHAUSTED a year of migrated payments triggered). total/collected/… are
// over the WHOLE filtered set; items is just the requested page.
const $131c9ac36c348551$var$CLINIC_PAYMENTS_PAGE = `
  query ClinicPaymentsPage($patientId: ID, $from: String, $to: String, $doctorId: String, $method: String, $search: String, $limit: Int, $offset: Int) {
    accountingPaymentsPage(patientId: $patientId, from: $from, to: $to, doctorId: $doctorId, method: $method, search: $search, includeVoided: true, limit: $limit, offset: $offset) {
      currency
      items { ${$131c9ac36c348551$var$PAYMENT_ROW_FIELDS} }
      total collectedTotal cashTotal nonCashTotal voidedCount
    }
  }
`;
const $131c9ac36c348551$var$EMPTY_PAGE = {
    items: [],
    total: 0,
    collectedTotal: 0,
    cashTotal: 0,
    nonCashTotal: 0,
    voidedCount: 0
};
// `$reason` is String! because the schema's argument is String! — a nullable
// variable in a non-null position is refused by GraphQL's VariablesInAllowedPosition
// rule at VALIDATION, before any resolver runs, so declaring it `String` failed
// every «ابطال» regardless of what the operator typed. Same declaration as the
// refund below, and as voidBillPayment in useBills.js.
const $131c9ac36c348551$var$VOID_PAYMENT = `
  mutation AccountingVoidPayment($paymentId: ID!, $reason: String!) {
    accountingVoidPayment(paymentId: $paymentId, reason: $reason) { ${$131c9ac36c348551$var$PAYMENT_ROW_FIELDS} }
  }
`;
// Money back: a signed refund row against the payment, into today's drawer.
// `reason` is MANDATORY — money going back out is a judgement, and the ledger
// records it with its justification or not at all. `requestId` is the retry
// guard: a refund the operator could not see the outcome of must not be given
// twice (docs/CLINIC_RECEPTION_FINANCIAL_EVENTS_DESIGN.md §7.3).
const $131c9ac36c348551$var$REFUND_PAYMENT = `
  mutation AccountingRefundPayment($paymentId: ID!, $amount: Float!, $paymentMethod: String, $referenceNumber: String, $reason: String!, $requestId: ID) {
    accountingRefundPayment(paymentId: $paymentId, amount: $amount, paymentMethod: $paymentMethod, referenceNumber: $referenceNumber, reason: $reason, requestId: $requestId) { ${$131c9ac36c348551$var$PAYMENT_ROW_FIELDS} }
  }
`;
function $131c9ac36c348551$export$8b7e220ffc15bbd1(range = null, patientId = '', opts = {}) {
    const { page: page = 1, pageSize: pageSize = 50, doctorId: doctorId = '', method: method = '', search: search = '' } = opts;
    const [data, setData] = (0, $acw62.useState)($131c9ac36c348551$var$EMPTY_PAGE);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    const fromTs = range?.fromTs ?? null;
    const toTs = range?.toTs ?? null;
    // Widening the window or changing the page fires a query while another is still in
    // flight; the loser must not land on top of the winner.
    const reqId = (0, $acw62.useRef)(0);
    // The window/patient/doctor/method/search vars go to the server; changing any of them
    // is a new filtered set and refetches. The page/pageSize drive the offset.
    const load = (0, $acw62.useCallback)(async ()=>{
        const req = ++reqId.current;
        setLoading(true);
        setError(null);
        const win = fromTs != null && toTs != null ? {
            from: String(fromTs),
            to: String(toTs)
        } : {};
        try {
            const d = await (0, $2Mst8.bffQuery)($131c9ac36c348551$var$CLINIC_PAYMENTS_PAGE, {
                patientId: patientId || null,
                doctorId: doctorId || null,
                method: method || null,
                search: search || null,
                limit: pageSize,
                offset: (Math.max(1, page) - 1) * pageSize,
                ...win
            }, 'ClinicPaymentsPage');
            if (req !== reqId.current) return; // superseded — drop it
            setData(d.accountingPaymentsPage || $131c9ac36c348551$var$EMPTY_PAGE);
        } catch (e) {
            if (req !== reqId.current) return;
            setError(e);
        } finally{
            if (req === reqId.current) setLoading(false);
        }
    }, [
        fromTs,
        toTs,
        patientId,
        page,
        pageSize,
        doctorId,
        method,
        search
    ]);
    (0, $acw62.useEffect)(()=>{
        load();
    }, [
        load
    ]);
    /**
   * Reverse a payment taken in error. There is no delete: the row survives, marked,
   * and every total stops counting it — so the invoice it settled reopens and the cash
   * drawer un-counts it, server-side. Re-fetch the current page: the void changes the
   * KPI aggregates (which are now the server's, not summed from the rows on screen), and
   * refetching with the same page param keeps the user exactly where they were.
   */ const voidPayment = (0, $acw62.useCallback)(async (paymentId, reason)=>{
        // Never null: the argument is non-null, and an unexplained void is an empty
        // reason, not an absent one.
        const d = await (0, $2Mst8.bffMutation)($131c9ac36c348551$var$VOID_PAYMENT, {
            paymentId: paymentId,
            reason: reason || ''
        }, 'AccountingVoidPayment');
        await load();
        return d.accountingVoidPayment;
    }, [
        load
    ]);
    /**
   * Hand money back. Unlike a void — which says the payment should never have been
   * taken — a refund is a NEW signed row against a real payment, banked into today's
   * drawer, so a closed shift is never rewritten and both facts stay in the ledger.
   */ const refundPayment = (0, $acw62.useCallback)(async (paymentId, { amount: amount, paymentMethod: paymentMethod, referenceNumber: referenceNumber, reason: reason, requestId: requestId } = {})=>{
        const d = await (0, $2Mst8.bffMutation)($131c9ac36c348551$var$REFUND_PAYMENT, {
            paymentId: paymentId,
            amount: amount,
            paymentMethod: paymentMethod || null,
            referenceNumber: referenceNumber || null,
            reason: reason || '',
            requestId: requestId || null
        }, 'AccountingRefundPayment');
        await load();
        return d.accountingRefundPayment;
    }, [
        load
    ]);
    // CSV export of the filtered set — one bounded fetch (a generous cap, NOT the whole
    // table), so a huge ledger degrades to "export is capped" rather than exhausting.
    const fetchForExport = (0, $acw62.useCallback)(async ()=>{
        const win = fromTs != null && toTs != null ? {
            from: String(fromTs),
            to: String(toTs)
        } : {};
        const d = await (0, $2Mst8.bffQuery)($131c9ac36c348551$var$CLINIC_PAYMENTS_PAGE, {
            patientId: patientId || null,
            doctorId: doctorId || null,
            method: method || null,
            search: search || null,
            limit: 5000,
            offset: 0,
            ...win
        }, 'ClinicPaymentsPage');
        return d.accountingPaymentsPage?.items || [];
    }, [
        fromTs,
        toTs,
        patientId,
        doctorId,
        method,
        search
    ]);
    // KPI figures over the WHOLE filtered set, from the server. count is the LIVE payment
    // count: total_count includes the voided rows the ledger shows, so subtract them.
    const totals = {
        collected: data.collectedTotal,
        cash: data.cashTotal,
        nonCash: data.nonCashTotal,
        count: Math.max(0, (data.total || 0) - (data.voidedCount || 0)),
        voided: data.voidedCount || 0
    };
    return {
        payments: data.items,
        total: data.total || 0,
        totals: totals,
        loading: loading,
        error: error,
        reload: load,
        voidPayment: voidPayment,
        refundPayment: refundPayment,
        fetchForExport: fetchForExport
    };
}
function $131c9ac36c348551$export$5faf71f3306d6c70() {
    const [tariffs, setTariffs] = (0, $acw62.useState)([]);
    (0, $acw62.useEffect)(()=>{
        (0, $2Mst8.bffQuery)($131c9ac36c348551$var$CLINIC_SERVICE_DECLARATIONS).then((d)=>setTariffs(d.clinicServiceDeclarations || [])).catch(()=>{});
    }, []);
    return tariffs;
}
function $131c9ac36c348551$export$f2079c4a1f029a5f() {
    const [doctors, setDoctors] = (0, $acw62.useState)([]);
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        (async ()=>{
            try {
                const clinic = await (0, $2Mst8.bffQuery)($131c9ac36c348551$var$MY_CLINIC, {}, 'MyClinic');
                const clinicId = clinic?.myClinic?.id;
                if (!clinicId) return;
                const data = await (0, $2Mst8.bffQuery)($131c9ac36c348551$var$CLINIC_DOCTOR_OPTIONS, {
                    clinicId: clinicId
                }, 'MyClinicDoctors');
                if (cancelled) return;
                setDoctors((data?.listClinicDoctors || []).filter((d)=>d.active && d.doctorId));
            } catch  {
            // The filter is a refinement, not a gate — an empty list just means no dropdown.
            }
        })();
        return ()=>{
            cancelled = true;
        };
    }, []);
    return doctors;
}

});
parcelRegister("5pHac", function(module, exports) {

$parcel$export(module.exports, "PAYMENT_METHODS", () => $3f10c4f04d197c9b$export$e49d9539d833c310);
$parcel$export(module.exports, "DEFAULT_PAYMENT_METHOD", () => $3f10c4f04d197c9b$export$801a3ed214053514);
$parcel$export(module.exports, "STATUS_META", () => $3f10c4f04d197c9b$export$8f9292f3e50b1f73);
$parcel$export(module.exports, "ITEM_TYPE_META", () => $3f10c4f04d197c9b$export$1468859f0798d24);
$parcel$export(module.exports, "resolveDiscount", () => $3f10c4f04d197c9b$export$f09496d07843c6b8);
$parcel$export(module.exports, "discountLabel", () => $3f10c4f04d197c9b$export$53da86b187af1136);
$parcel$export(module.exports, "withLineItems", () => $3f10c4f04d197c9b$export$ee42ffe45b597cc7);
$parcel$export(module.exports, "settleState", () => $3f10c4f04d197c9b$export$7f4461d4a31e2714);
$parcel$export(module.exports, "canRemoveLine", () => $3f10c4f04d197c9b$export$25b70159491bf0f3);
$parcel$export(module.exports, "isLockedLine", () => $3f10c4f04d197c9b$export$a9da435eb65e3a87);
$parcel$export(module.exports, "validatePayment", () => $3f10c4f04d197c9b$export$807c1c07e6487d32);
$parcel$export(module.exports, "canSubmitPayment", () => $3f10c4f04d197c9b$export$e3a6d2e74945ab91);
$parcel$export(module.exports, "journeySteps", () => $3f10c4f04d197c9b$export$55c7a3effce898fc);
$parcel$export(module.exports, "issuanceBadge", () => $3f10c4f04d197c9b$export$d1bd7783d37a4550);
$parcel$export(module.exports, "lineEditPreview", () => $3f10c4f04d197c9b$export$dec57be4a96d4283);
$parcel$export(module.exports, "validateLineEdit", () => $3f10c4f04d197c9b$export$cd9a0afbe4ec7d71);
$parcel$export(module.exports, "validateInsuranceOverride", () => $3f10c4f04d197c9b$export$5b36c18f3ab7ea21);
$parcel$export(module.exports, "validateInvoiceDiscount", () => $3f10c4f04d197c9b$export$802b3bfcb702f53d);
$parcel$export(module.exports, "fmtDate", () => $3f10c4f04d197c9b$export$d570a62256bab7b8);
$parcel$export(module.exports, "patientInitials", () => $3f10c4f04d197c9b$export$32c7819449f6d01);
$parcel$export(module.exports, "isVoid", () => $3f10c4f04d197c9b$export$fd43196114105ff7);
$parcel$export(module.exports, "isRefundRow", () => $3f10c4f04d197c9b$export$ba914d210dedd469);
$parcel$export(module.exports, "refundableOf", () => $3f10c4f04d197c9b$export$577fc5508eef300a);
$parcel$export(module.exports, "canVoid", () => $3f10c4f04d197c9b$export$b020a97155fc5e1c);
$parcel$export(module.exports, "canRefund", () => $3f10c4f04d197c9b$export$c68486b76dbb6988);
$parcel$export(module.exports, "REFUND_METHODS", () => $3f10c4f04d197c9b$export$70992dbdb11b4d7a);
$parcel$export(module.exports, "refundNeedsReference", () => $3f10c4f04d197c9b$export$d9d88e43c1096764);

var $1O6TO = parcelRequire("1O6TO");
parcelRequire("52bn2");
var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
const $3f10c4f04d197c9b$export$e49d9539d833c310 = (t)=>({
        CASH: {
            label: t('accounting.method.cash'),
            short: t('accounting.method.cash'),
            desc: t('cashier.methods.cash'),
            color: (0, $jTCZr.C).green,
            bg: (0, $jTCZr.C).greenLight,
            enabled: true
        },
        CARD: {
            label: t('cashier.methods.pos'),
            short: t('accounting.method.card'),
            desc: t('cashier.methods.posDesc'),
            color: (0, $jTCZr.C).navy,
            bg: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.1),
            enabled: true,
            needsRef: true,
            refLabel: t('cashier.methods.posRef')
        },
        BANK_TRANSFER: {
            label: t('cashier.methods.bankTransfer'),
            short: t('cashier.methods.bankTransferShort'),
            desc: t('cashier.methods.bankTransferDesc'),
            color: (0, $jTCZr.C).teal,
            bg: (0, $jTCZr.C).tealLight,
            enabled: true,
            needsRef: true,
            refLabel: t('cashier.methods.bankTransferRef')
        },
        THIRD_PARTY: {
            label: t('cashier.methods.thirdParty'),
            short: t('cashier.methods.thirdPartyShort'),
            desc: t('cashier.methods.thirdPartyDesc'),
            color: (0, $jTCZr.C).amber,
            bg: (0, $jTCZr.C).amberLight,
            enabled: true,
            needsRef: true,
            refLabel: t('cashier.methods.thirdPartyRef')
        },
        ONLINE: {
            label: t('cashier.methods.patientApp'),
            short: t('reception.filters.online'),
            desc: t('common.state.comingSoon'),
            color: (0, $jTCZr.C).teal,
            bg: (0, $jTCZr.C).tealLight,
            enabled: false
        }
    });
const $3f10c4f04d197c9b$export$801a3ed214053514 = 'CASH';
const $3f10c4f04d197c9b$export$8f9292f3e50b1f73 = (t)=>({
        OPEN: {
            label: t('accounting.status.unpaid'),
            bg: '#FEF3C7',
            text: '#92400E'
        },
        INVOICE_PARTIALLY_PAID: {
            label: t('accounting.status.partiallyPaid'),
            bg: (0, $jTCZr.statusColors).inprogress.bg,
            text: (0, $jTCZr.statusColors).inprogress.text
        },
        PAID: {
            label: t('accounting.status.settled'),
            bg: '#D1FAE5',
            text: '#065F46'
        },
        VOID: {
            label: t('accounting.status.voidInvoice'),
            bg: '#FEE2E2',
            text: '#991B1B'
        },
        DRAFT: {
            label: t('accounting.status.draft'),
            bg: (0, $jTCZr.C).border,
            text: (0, $jTCZr.C).textMuted
        }
    });
const $3f10c4f04d197c9b$export$1468859f0798d24 = (t)=>({
        VISIT: {
            label: t('common.entity.visit'),
            icon: "\uD83E\uDE7A"
        },
        MEDICAL_SERVICE: {
            label: t('cashier.itemTypes.paraclinical'),
            icon: "\uD83D\uDD2C"
        },
        PRODUCT: {
            label: t('cashier.itemTypes.goods'),
            icon: "\uD83D\uDCE6"
        },
        // «هزینهٔ لغو/عدم حضور» (PM-0657 C5): the no-show fee's own FINAL invoice line.
        FEE: {
            label: t('cashier.itemTypes.fee'),
            icon: "\u23F1"
        }
    });
function $3f10c4f04d197c9b$export$f09496d07843c6b8(type, value, base) {
    if (!Number.isFinite(value) || !Number.isFinite(base) || value <= 0 || base <= 0) return 0;
    const raw = type === 'PERCENT' ? base * value / 100 : value;
    return Math.round(raw);
}
function $3f10c4f04d197c9b$export$53da86b187af1136({ discountType: discountType, discountValue: discountValue, discount: discount }, t, formatNumber, formatMoney) {
    return discountType === 'PERCENT' ? t('cashier.discount.percentWithAmount', {
        percent: formatNumber(discountValue),
        amount: formatMoney(discount)
    }) : t('cashier.discount.amount', {
        amount: formatMoney(discount)
    });
}
function $3f10c4f04d197c9b$export$ee42ffe45b597cc7(invoice, lineItems) {
    const sum = (field)=>lineItems.reduce((s, li)=>s + (li[field] || 0), 0);
    return {
        ...invoice,
        lineItems: lineItems,
        totalAmount: sum('totalAmount'),
        insuranceShare: sum('insuranceShare')
    };
}
function $3f10c4f04d197c9b$export$7f4461d4a31e2714(invoice, paid, paidLoaded, heldDeposit = 0) {
    const lineItems = invoice?.lineItems || [];
    const lineDiscount = lineItems.reduce((s, li)=>s + (li.discount || 0), 0);
    // Built exactly the way the service's `_apply_settlement` builds it: sum the
    // lines' patient share (already net of each line's own discount and the
    // insurer's cut), then take the invoice-wide discount off THAT.
    const subtotal = lineItems.reduce((s, li)=>s + (li.patientPayable || 0), 0);
    // Clamped like `_apply_settlement`: a fixed discount can outlive the lines it
    // was sized against, and the patient's bill floors at zero rather than going
    // negative.
    const invDiscount = Math.min($3f10c4f04d197c9b$export$f09496d07843c6b8(invoice?.discountType, invoice?.discountValue, subtotal), subtotal);
    const payable = Math.max(0, subtotal - invDiscount);
    const outstanding = Math.max(0, payable - paid);
    const isVoid = invoice?.status === 'VOID';
    const isSettled = lineItems.length > 0 && outstanding <= 0;
    // An ISSUED invoice is a confirmed obligation: its lines are never edited or
    // removed. A correction is a negative line, or void-and-reissue.
    const frozen = !!invoice?.isIssued;
    const canRemove = paid <= 0 && !isSettled && !frozen;
    // PM-0699 — the DISCOUNT belongs to the مراجعه and stays editable until the
    // مراجعه is SETTLED, even once the invoice is issued: ending the visit issues it,
    // and the doctor's page has no discount control, so freezing it with the lines left
    // the desk no way to give one. The lines stay frozen. An unissued invoice keeps its
    // old rule (editable at any time, even settled). For an ISSUED one the paid total
    // must have landed first — before it, `outstanding` reads the whole payable and
    // would offer an edit the service is about to refuse (DISCOUNT_ON_SETTLED).
    const canEditDiscount = !isVoid && (!frozen || paidLoaded && !isSettled);
    // Editing a line down can drop the payable below what the patient already paid.
    // Accounting has no refund or credit-note concept to book the surplus against,
    // so it would otherwise disappear behind a tidy zero balance. Name it instead.
    const overpaid = Math.max(0, paid - payable);
    // Mirrors the service's `_apply_settlement` (status = payments vs. payable), so
    // it stays right as lines are added, edited or removed. Before the paid total
    // lands `paid` is 0 and the derivation would wrongly read OPEN, so trust the
    // server's status for that first beat — and always for a frozen voided invoice.
    const shownStatus = !paidLoaded || isVoid ? invoice?.status : paid <= 0 ? 'OPEN' : paid + 0.5 >= payable ? 'PAID' : 'INVOICE_PARTIALLY_PAID';
    // An invoice with no line items (created straight from a reception appointment)
    // has no priced fee yet: the cashier types the appointment's price and it is
    // added as the VISIT line at pay time.
    const isEmptyInvoice = lineItems.length === 0 && paid <= 0;
    // The held deposit counts only against a priced, unissued invoice: an issued
    // one already has it in `paid`, and an empty one has no price to net it from.
    const held = !frozen && !isEmptyInvoice ? Math.max(0, Number(heldDeposit) || 0) : 0;
    // What the desk may still take NOW — the balance less the held deposit.
    const dueNow = Math.max(0, outstanding - held);
    // Cap the amount at the outstanding balance only when there IS a balance; for an
    // empty invoice any positive amount is the appointment fee.
    const maxChargeable = isEmptyInvoice ? Infinity : dueNow;
    return {
        lineDiscount: lineDiscount,
        subtotal: subtotal,
        invDiscount: invDiscount,
        payable: payable,
        outstanding: outstanding,
        isVoid: isVoid,
        isSettled: isSettled,
        frozen: frozen,
        canRemove: canRemove,
        canEditDiscount: canEditDiscount,
        overpaid: overpaid,
        shownStatus: shownStatus,
        isEmptyInvoice: isEmptyInvoice,
        maxChargeable: maxChargeable,
        heldDeposit: held,
        dueNow: dueNow
    };
}
const $3f10c4f04d197c9b$export$25b70159491bf0f3 = (item, canRemove)=>canRemove && item?.itemType !== 'VISIT' && item?.itemType !== 'FEE';
const $3f10c4f04d197c9b$export$a9da435eb65e3a87 = (item)=>item?.role === 'PRIMARY' || item?.role === 'FEE' || item?.itemType === 'FEE';
function $3f10c4f04d197c9b$export$807c1c07e6487d32({ t: t, method: method, reference: reference, amountRial: amountRial, maxChargeable: maxChargeable }) {
    const m = $3f10c4f04d197c9b$export$e49d9539d833c310(t)[method];
    if (!m || !m.enabled) return t('validation.payment.methodRequired');
    if (m.needsRef && !String(reference ?? '').trim()) return t('validation.payment.referenceRequired', {
        label: m.refLabel
    });
    if (!(amountRial > 0)) return t('validation.payment.amountInvalid');
    if (amountRial > maxChargeable + 0.5) return t('validation.payment.exceedsRemaining');
    return '';
}
function $3f10c4f04d197c9b$export$e3a6d2e74945ab91({ t: t, method: method, amountRial: amountRial, maxChargeable: maxChargeable }) {
    const m = $3f10c4f04d197c9b$export$e49d9539d833c310(t)[method];
    return Boolean(m?.enabled) && amountRial > 0 && amountRial <= maxChargeable + 0.5;
}
function $3f10c4f04d197c9b$export$55c7a3effce898fc(t, { hasLines: hasLines, frozen: frozen, isSettled: isSettled }) {
    return [
        {
            id: 'booked',
            icon: "\uD83D\uDCC5",
            label: t('cashier.itemTypes.appointment'),
            done: true
        },
        {
            id: 'visit',
            icon: "\uD83E\uDE7A",
            label: t('common.entity.visit'),
            done: hasLines
        },
        {
            id: 'issued',
            icon: "\uD83E\uDDFE",
            label: t('cashier.invoice.issue'),
            done: frozen
        },
        {
            id: 'settled',
            icon: "\uD83D\uDCB3",
            label: t('accounting.actions.settle'),
            done: isSettled
        }
    ];
}
function $3f10c4f04d197c9b$export$d1bd7783d37a4550(t, invoice) {
    const frozen = !!invoice?.isIssued;
    if (!frozen) return {
        frozen: frozen,
        label: t('cashier.invoice.proforma'),
        hint: t('cashier.invoice.proformaHint')
    };
    return {
        frozen: frozen,
        label: invoice?.invoiceNumber ? t('cashier.invoice.invoiceNumbered', {
            number: invoice.invoiceNumber
        }) : t('cashier.invoice.invoiceFinal'),
        hint: t('cashier.invoice.frozenHint')
    };
}
// ── Editing a line, and the rules the service will apply to it ───────────────
/** '' → NaN rather than 0, so a cleared field reads as invalid instead of as zero. */ const $3f10c4f04d197c9b$var$num = (v)=>v === '' || v == null ? NaN : Number(v);
function $3f10c4f04d197c9b$export$dec57be4a96d4283(form, currency) {
    const isPct = form.discountType === 'PERCENT';
    const qty = $3f10c4f04d197c9b$var$num(form.quantity);
    const unitT = $3f10c4f04d197c9b$var$num(form.unitTariff); // toman, as typed
    const dval = $3f10c4f04d197c9b$var$num(form.discountValue); // percent when isPct, else toman
    const insT = $3f10c4f04d197c9b$var$num(form.insuranceShare); // toman, as typed
    const unit = (0, $1O6TO.fromDisplay)(form.unitTariff, currency);
    const ins = (0, $1O6TO.fromDisplay)(form.insuranceShare, currency);
    const total = qty * unit;
    // A line discount is a percentage of that line's own gross — the base the
    // service uses.
    const disc = isPct ? $3f10c4f04d197c9b$export$f09496d07843c6b8('PERCENT', dval, total) : (0, $1O6TO.fromDisplay)(form.discountValue, currency);
    const payable = Math.max(0, total - disc - ins);
    return {
        isPct: isPct,
        qty: qty,
        unitT: unitT,
        dval: dval,
        insT: insT,
        unit: unit,
        ins: ins,
        total: total,
        disc: disc,
        payable: payable
    };
}
function $3f10c4f04d197c9b$export$cd9a0afbe4ec7d71(t, form, currency) {
    const { isPct: isPct, qty: qty, unitT: unitT, dval: dval, insT: insT, total: total, disc: disc, ins: ins } = $3f10c4f04d197c9b$export$dec57be4a96d4283(form, currency);
    if (!String(form.description ?? '').trim()) return t('validation.lineItem.descriptionRequired');
    if (!Number.isInteger(qty) || qty <= 0) return t('validation.lineItem.quantityPositiveInteger');
    if (!Number.isFinite(unitT) || unitT < 0) return t('validation.lineItem.unitPriceNotNegative');
    if (!Number.isFinite(dval) || dval < 0) return t('validation.lineItem.discountNotNegative');
    if (isPct && dval > 100) return t('validation.lineItem.discountPercentMax');
    if (!Number.isFinite(insT) || insT < 0) return t('validation.lineItem.insuranceNotNegative');
    if (disc + ins > total + 0.5) return t('validation.lineItem.discountPlusInsuranceTooHigh');
    return '';
}
function $3f10c4f04d197c9b$export$5b36c18f3ab7ea21(t, { amountToman: amountToman, reason: reason, gross: gross, currency: currency }) {
    const rial = (0, $1O6TO.fromDisplay)(amountToman, currency);
    if (!Number.isFinite(rial) || rial < 0) return t('validation.lineItem.insuranceNotNegative');
    if (rial > gross + 0.5) return t('validation.insurance.overrideRange');
    if (!String(reason ?? '').trim()) return t('validation.insurance.overrideReason');
    return '';
}
function $3f10c4f04d197c9b$export$802b3bfcb702f53d(t, { type: type, value: value }) {
    const v = $3f10c4f04d197c9b$var$num(value);
    if (!Number.isFinite(v) || v < 0) return t('validation.lineItem.discountNotNegative');
    if (type === 'PERCENT' && v > 100) return t('validation.lineItem.discountPercentMax');
    return '';
}
function $3f10c4f04d197c9b$export$d570a62256bab7b8(ts, formatDateTime) {
    if (!ts) return "\u2014";
    const n = typeof ts === 'string' ? Number(ts) : ts;
    const d = n > 1e10 ? new Date(n) : new Date(n * 1000);
    return formatDateTime(d, 'short');
}
function $3f10c4f04d197c9b$export$32c7819449f6d01(name, t) {
    if (!name) return t('common.placeholder.unknownInitial');
    return name.trim().split(/\s+/).map((w)=>w[0]).slice(0, 2).join('');
}
const $3f10c4f04d197c9b$export$fd43196114105ff7 = (p)=>p?.status === 'VOID';
const $3f10c4f04d197c9b$export$ba914d210dedd469 = (p)=>p?.kind === 'REFUND';
const $3f10c4f04d197c9b$export$577fc5508eef300a = (p)=>(p?.amount || 0) - (p?.refundedAmount || 0);
const $3f10c4f04d197c9b$export$b020a97155fc5e1c = (p)=>!$3f10c4f04d197c9b$export$fd43196114105ff7(p) && p?.shiftStatus !== 'CLOSED';
const $3f10c4f04d197c9b$export$c68486b76dbb6988 = (p)=>!$3f10c4f04d197c9b$export$fd43196114105ff7(p) && !$3f10c4f04d197c9b$export$ba914d210dedd469(p) && p?.status !== 'PENDING' && p?.status !== 'FAILED' && p?.status !== 'CANCELLED' && p?.paymentMethod !== 'CREDIT' && $3f10c4f04d197c9b$export$577fc5508eef300a(p) > 0.5;
const $3f10c4f04d197c9b$export$70992dbdb11b4d7a = [
    'CASH',
    'CARD',
    'BANK_TRANSFER',
    'THIRD_PARTY'
];
const $3f10c4f04d197c9b$export$d9d88e43c1096764 = (method)=>method === 'CARD' || method === 'BANK_TRANSFER' || method === 'THIRD_PARTY';

});


parcelRegister("dgZRs", function(module, exports) {

$parcel$export(module.exports, "usePractitionerServiceTerms", () => $9a9cc15ae0669044$export$3f0707a71c4b140d);
$parcel$export(module.exports, "useBookableServices", () => $9a9cc15ae0669044$export$d0af05e0762a2f2e);

var $acw62 = parcelRequire("acw62");

var $2Mst8 = parcelRequire("2Mst8");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $caGR6 = parcelRequire("caGR6");

var $407sw = parcelRequire("407sw");
// What one practitioner provides at this clinic and how each service is
// delivered here (docs/CLINIC_PRACTITIONER_ENGAGEMENT_DESIGN.md §۴). The BFF
// joins the declaration, the performer set, the rule that actually applies and
// the service's cost facts, so the drawer asks once per person.
const $9a9cc15ae0669044$var$FIELDS = `
  doctorId providesVisit currency
  services {
    declarationId currency catalogId description orderType category unitPrice priceIsPersonal clinicUnitPrice isActive
    schedulingMode durationMinutes prepInstructions
    isDefault isDefaultPerformer
    otherPerformers { type id label isDefault }
    commission { mode value basis } commissionIsPersonal
    generalCommission { mode value basis } generalCommissionKnown
    insuranceCoverageMode consumableCount sideCostTotalRial
  }
  available { currency declarationId description category orderType unitPrice isActive schedulingMode durationMinutes }
`;
const $9a9cc15ae0669044$var$PRACTITIONER_SERVICES = `
  query PractitionerServices($doctorId: ID!) {
    practitionerServices(doctorId: $doctorId) { ${$9a9cc15ae0669044$var$FIELDS} }
  }
`;
// Replace-all for THIS practitioner only — the BFF carries every other
// performer and every other rule on each service across.
const $9a9cc15ae0669044$var$SET_TERMS = `
  mutation SetPractitionerServiceTerms($doctorId: ID!, $services: [PractitionerServiceTermsInput!]!) {
    setPractitionerServiceTerms(doctorId: $doctorId, services: $services) { ${$9a9cc15ae0669044$var$FIELDS} }
  }
`;
function $9a9cc15ae0669044$export$3f0707a71c4b140d(doctorId) {
    const { t: t } = (0, $e1LEq.default)();
    const [data, setData] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(!!doctorId);
    const [error, setError] = (0, $acw62.useState)(null);
    const [rows, setRows] = (0, $acw62.useState)([]);
    const load = (0, $acw62.useCallback)(async ()=>{
        if (!doctorId) {
            setData(null);
            setRows([]);
            setLoading(false);
            return;
        }
        setLoading(true);
        try {
            const d = await (0, $2Mst8.bffQuery)($9a9cc15ae0669044$var$PRACTITIONER_SERVICES, {
                doctorId: doctorId
            }, 'PractitionerServices');
            const next = d?.practitionerServices || null;
            setData(next);
            setRows((0, $caGR6.rowsFromServices)(next));
            setError(null);
        } catch (e) {
            setData(null);
            setRows([]);
            setError(e?.message || t('people.services.loadFailed'));
        } finally{
            setLoading(false);
        }
    }, [
        doctorId,
        t
    ]);
    (0, $acw62.useEffect)(()=>{
        load();
    }, [
        load
    ]);
    const dirty = !!data && (0, $caGR6.rowsDirty)(rows, data);
    const problems = (0, $acw62.useMemo)(()=>dirty ? (0, $caGR6.rowProblems)(rows, (0, $caGR6.serviceMeta)(data)) : [], [
        dirty,
        rows,
        data
    ]);
    const reset = (0, $acw62.useCallback)(()=>setRows((0, $caGR6.rowsFromServices)(data)), [
        data
    ]);
    const save = (0, $acw62.useCallback)(async ()=>{
        try {
            const d = await (0, $2Mst8.bffMutation)($9a9cc15ae0669044$var$SET_TERMS, {
                doctorId: doctorId,
                services: (0, $caGR6.toTermsInput)(rows, data?.currency)
            }, 'SetPractitionerServiceTerms');
            const next = d?.setPractitionerServiceTerms || null;
            setData(next);
            setRows((0, $caGR6.rowsFromServices)(next));
            return next;
        } catch (e) {
            // A PARTIAL failure saved some services: re-read so the buffer shows what
            // is really stored, then let the caller say which ones did not land. Any
            // other refusal wrote nothing, and the reader's edits stay on screen.
            if (e?.extensions?.code === 'PARTIAL_PRACTITIONER_SERVICES') await load();
            throw e;
        }
    }, [
        doctorId,
        rows,
        data,
        load
    ]);
    /**
   * «تعریف خدمت همین‌جا» (PM-0350): invent a clinic service from the
   * practitioner's own tab, with THEM as its default performer, and have it
   * appear in their list without a trip to «کالاها و خدمات».
   *
   * One write for the service; a second, for the terms, only when this is the
   * practitioner's FIRST service and nothing unsaved was on screen — so their
   * first service becomes their default in the same act, while a later one
   * never displaces a visit, and an in-progress edit of another row is never
   * overwritten under the reader.
   * The re-read keeps every unsaved row edit; only the new service is added.
   */ const createService = (0, $acw62.useCallback)(async (input)=>{
        const d = await (0, $2Mst8.bffMutation)((0, $407sw.CREATE_CUSTOM_SERVICE), {
            input: {
                ...input,
                performers: [
                    {
                        type: 'DOCTOR',
                        id: doctorId,
                        isDefault: true
                    }
                ],
                defaultPerformerId: doctorId
            }
        }, 'CreateCustomService');
        const created = d?.createCustomService || null;
        const fresh = await (0, $2Mst8.bffQuery)($9a9cc15ae0669044$var$PRACTITIONER_SERVICES, {
            doctorId: doctorId
        }, 'PractitionerServices');
        const next = fresh?.practitionerServices || null;
        const seeded = (0, $caGR6.rowsFromServices)(next);
        const kept = new Map(rows.map((r)=>[
                r.declarationId,
                r
            ]));
        let merged = seeded.map((r)=>kept.get(r.declarationId) || r);
        for (const r of rows)if (!merged.some((m)=>m.declarationId === r.declarationId)) merged.push(r);
        if (created?.id) merged = (0, $caGR6.addRow)(merged, created.id);
        const first = rows.length === 0;
        const wasDirty = !!data && (0, $caGR6.rowsDirty)(rows, data);
        if (created?.id && first && !wasDirty) {
            merged = merged.map((r)=>({
                    ...r,
                    isDefault: r.declarationId === created.id
                }));
            const saved = await (0, $2Mst8.bffMutation)($9a9cc15ae0669044$var$SET_TERMS, {
                doctorId: doctorId,
                services: (0, $caGR6.toTermsInput)(merged, next?.currency)
            }, 'SetPractitionerServiceTerms');
            const settled = saved?.setPractitionerServiceTerms || next;
            setData(settled);
            setRows((0, $caGR6.rowsFromServices)(settled));
            return created;
        }
        setData(next);
        setRows(merged);
        return created;
    }, [
        doctorId,
        rows,
        data
    ]);
    return {
        data: data,
        loading: loading,
        error: error,
        reload: load,
        rows: rows,
        setRows: setRows,
        dirty: dirty,
        problems: problems,
        invalid: problems.length > 0,
        reset: reset,
        save: save,
        createService: createService
    };
}
var $9a9cc15ae0669044$export$2e2bcd8739ae039 = $9a9cc15ae0669044$export$3f0707a71c4b140d;
// ── «خدمت نوبت» — what the booking modal picks from ──────────────────────────
const $9a9cc15ae0669044$var$BOOKABLE_SERVICES = `
  query BookableServices($doctorId: ID!) {
    practitionerServices(doctorId: $doctorId) {
      doctorId
      providesVisit
      services {
        currency
        declarationId description orderType unitPrice priceIsPersonal clinicUnitPrice
        isActive isDefault durationMinutes
      }
    }
  }
`;
function $9a9cc15ae0669044$export$d0af05e0762a2f2e(doctorId) {
    const [data, setData] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(!!doctorId);
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        if (!doctorId) {
            setData(null);
            setLoading(false);
            return undefined;
        }
        setLoading(true);
        (0, $2Mst8.bffQuery)($9a9cc15ae0669044$var$BOOKABLE_SERVICES, {
            doctorId: doctorId
        }, 'BookableServices').then((d)=>{
            if (!cancelled) setData(d?.practitionerServices || null);
        })// An unreachable price list costs the pre-selection, never the booking:
        // the modal falls back to no service and the BFF resolves one server-side.
        .catch(()=>{
            if (!cancelled) setData(null);
        }).finally(()=>{
            if (!cancelled) setLoading(false);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        doctorId
    ]);
    const services = (0, $acw62.useMemo)(()=>(data?.services || []).filter((s)=>s.isActive !== false), [
        data
    ]);
    // Their own default, else their visit, else nothing — and never a service the
    // clinic has not priced, which would quote the patient a figure of nothing.
    const defaultId = (0, $acw62.useMemo)(()=>{
        const priced = services.filter((s)=>(s.unitPrice || 0) > 0);
        const own = priced.find((s)=>s.isDefault);
        if (own) return own.declarationId;
        const visit = priced.find((s)=>s.orderType === 'consultation');
        return visit ? visit.declarationId : null;
    }, [
        services
    ]);
    return {
        services: services,
        defaultId: defaultId,
        providesVisit: data ? !!data.providesVisit : true,
        loading: loading
    };
}

});
parcelRegister("caGR6", function(module, exports) {

$parcel$export(module.exports, "MODE", () => $8dc7a964b58b1d95$export$e48589d9e4824227);
$parcel$export(module.exports, "BASES", () => $8dc7a964b58b1d95$export$ec7500743509fdab);
$parcel$export(module.exports, "CONSULTATION", () => $8dc7a964b58b1d95$export$b56d19c9ec777a27);
$parcel$export(module.exports, "serviceMeta", () => $8dc7a964b58b1d95$export$3d5432cc855bdfb1);
$parcel$export(module.exports, "isVisitService", () => $8dc7a964b58b1d95$export$c3a428b3879797ca);
$parcel$export(module.exports, "rowsFromServices", () => $8dc7a964b58b1d95$export$2ec2a9aa9706bf9e);
$parcel$export(module.exports, "rowsDirty", () => $8dc7a964b58b1d95$export$602c8ecc56d15cd);
$parcel$export(module.exports, "rowProblems", () => $8dc7a964b58b1d95$export$39728246abe48dbf);
$parcel$export(module.exports, "toTermsInput", () => $8dc7a964b58b1d95$export$681dac6b43c60831);
$parcel$export(module.exports, "addRow", () => $8dc7a964b58b1d95$export$40ed00dbc18f8b2f);
$parcel$export(module.exports, "removeRow", () => $8dc7a964b58b1d95$export$21ded818dbd27b97);
$parcel$export(module.exports, "setDefault", () => $8dc7a964b58b1d95$export$d590af038dd015bd);
$parcel$export(module.exports, "patchRow", () => $8dc7a964b58b1d95$export$c38143e3689c1f78);
$parcel$export(module.exports, "clinicSharePct", () => $8dc7a964b58b1d95$export$cb5390d08eb35d2);

var $1O6TO = parcelRequire("1O6TO");
const $8dc7a964b58b1d95$export$e48589d9e4824227 = {
    GENERAL: '',
    PERCENT: 'percent',
    FIXED: 'fixed'
};
const $8dc7a964b58b1d95$export$ec7500743509fdab = [
    'gross',
    'net_patient',
    'collected'
];
const $8dc7a964b58b1d95$export$b56d19c9ec777a27 = 'consultation';
const $8dc7a964b58b1d95$export$b07f100d2a15022a = {
    NO_DEFAULT: 'noDefault',
    VALUE_REQUIRED: 'valueRequired',
    PERCENT_RANGE: 'percentRange',
    FIXED_POSITIVE: 'fixedPositive',
    VISIT_PRICE_REQUIRED: 'visitPriceRequired'
};
function $8dc7a964b58b1d95$export$3d5432cc855bdfb1(data) {
    const m = new Map();
    for (const o of data?.available || [])m.set(o.declarationId, {
        ...o,
        pending: true
    });
    for (const s of data?.services || [])m.set(s.declarationId, s);
    return m;
}
const $8dc7a964b58b1d95$export$c3a428b3879797ca = (s)=>s?.orderType === $8dc7a964b58b1d95$export$b56d19c9ec777a27;
/**
 * Whether a visit row may leave its price empty: only when it charges the
 * clinic's own visit price and the clinic row actually has one.
 */ const $8dc7a964b58b1d95$var$clinicPriceApplies = (s)=>!!s && !s.priceIsPersonal && s.isActive !== false && Number(s.unitPrice) > 0;
function $8dc7a964b58b1d95$export$2ec2a9aa9706bf9e(data) {
    return (data?.services || []).map((s)=>{
        const own = s.commissionIsPersonal ? s.commission : null;
        const currency = s.currency || data?.currency;
        return {
            declarationId: s.declarationId,
            isDefault: !!s.isDefault,
            mode: own ? own.mode : $8dc7a964b58b1d95$export$e48589d9e4824227.GENERAL,
            value: !own ? '' : String(own.mode === $8dc7a964b58b1d95$export$e48589d9e4824227.FIXED ? (0, $1O6TO.toDisplay)(own.value, currency) : own.value),
            basis: own?.basis || 'gross',
            priceToman: $8dc7a964b58b1d95$export$c3a428b3879797ca(s) && s.priceIsPersonal ? String((0, $1O6TO.toDisplay)(s.unitPrice, currency)) : ''
        };
    });
}
const $8dc7a964b58b1d95$var$canonical = (rows)=>JSON.stringify(rows.map((r)=>({
            id: r.declarationId,
            d: !!r.isDefault,
            m: r.mode || '',
            v: r.mode ? String(r.value).trim() : '',
            b: r.mode === $8dc7a964b58b1d95$export$e48589d9e4824227.PERCENT ? r.basis || 'gross' : '',
            p: String(r.priceToman ?? '').trim()
        })).sort((a, b)=>a.id.localeCompare(b.id)));
const $8dc7a964b58b1d95$export$602c8ecc56d15cd = (rows, data)=>$8dc7a964b58b1d95$var$canonical(rows) !== $8dc7a964b58b1d95$var$canonical($8dc7a964b58b1d95$export$2ec2a9aa9706bf9e(data));
function $8dc7a964b58b1d95$export$39728246abe48dbf(rows, meta = new Map()) {
    const out = [];
    if (rows.length > 0 && !rows.some((r)=>r.isDefault)) out.push({
        declarationId: null,
        problem: $8dc7a964b58b1d95$export$b07f100d2a15022a.NO_DEFAULT
    });
    for (const r of rows){
        const s = meta.get(r.declarationId);
        if ($8dc7a964b58b1d95$export$c3a428b3879797ca(s)) {
            const price = String(r.priceToman ?? '').trim();
            if (price === '' ? !$8dc7a964b58b1d95$var$clinicPriceApplies(s) : !(Number(price) > 0)) out.push({
                declarationId: r.declarationId,
                problem: $8dc7a964b58b1d95$export$b07f100d2a15022a.VISIT_PRICE_REQUIRED
            });
        }
        if (!r.mode) continue;
        const raw = String(r.value ?? '').trim();
        const n = Number(raw);
        if (raw === '' || !Number.isFinite(n)) out.push({
            declarationId: r.declarationId,
            problem: $8dc7a964b58b1d95$export$b07f100d2a15022a.VALUE_REQUIRED
        });
        else if (r.mode === $8dc7a964b58b1d95$export$e48589d9e4824227.PERCENT && (n < 0 || n > 100)) out.push({
            declarationId: r.declarationId,
            problem: $8dc7a964b58b1d95$export$b07f100d2a15022a.PERCENT_RANGE
        });
        else if (r.mode === $8dc7a964b58b1d95$export$e48589d9e4824227.FIXED && n <= 0) out.push({
            declarationId: r.declarationId,
            problem: $8dc7a964b58b1d95$export$b07f100d2a15022a.FIXED_POSITIVE
        });
    }
    return out;
}
function $8dc7a964b58b1d95$export$681dac6b43c60831(rows, currency) {
    return rows.map((r)=>{
        const price = String(r.priceToman ?? '').trim();
        return {
            declarationId: r.declarationId,
            isDefault: !!r.isDefault,
            ...r.mode ? {
                mode: r.mode,
                value: r.mode === $8dc7a964b58b1d95$export$e48589d9e4824227.FIXED ? (0, $1O6TO.fromDisplay)(r.value, currency) : Number(r.value),
                basis: r.basis || 'gross'
            } : {},
            ...price !== '' ? {
                priceRial: (0, $1O6TO.fromDisplay)(price, currency)
            } : {}
        };
    });
}
const $8dc7a964b58b1d95$export$40ed00dbc18f8b2f = (rows, declarationId)=>rows.some((r)=>r.declarationId === declarationId) ? rows : [
        ...rows,
        {
            declarationId: declarationId,
            isDefault: !rows.some((r)=>r.isDefault),
            mode: $8dc7a964b58b1d95$export$e48589d9e4824227.GENERAL,
            value: '',
            basis: 'gross',
            priceToman: ''
        }
    ];
function $8dc7a964b58b1d95$export$21ded818dbd27b97(rows, declarationId) {
    const removed = rows.find((r)=>r.declarationId === declarationId);
    const next = rows.filter((r)=>r.declarationId !== declarationId);
    if (removed?.isDefault && next.length && !next.some((r)=>r.isDefault)) return next.map((r, i)=>i === 0 ? {
            ...r,
            isDefault: true
        } : r);
    return next;
}
const $8dc7a964b58b1d95$export$d590af038dd015bd = (rows, declarationId)=>rows.map((r)=>({
            ...r,
            isDefault: r.declarationId === declarationId
        }));
const $8dc7a964b58b1d95$export$c38143e3689c1f78 = (rows, declarationId, patch)=>rows.map((r)=>r.declarationId === declarationId ? {
            ...r,
            ...patch
        } : r);
function $8dc7a964b58b1d95$export$cb5390d08eb35d2(mode, value) {
    if (mode !== $8dc7a964b58b1d95$export$e48589d9e4824227.PERCENT) return null;
    const n = Number(value);
    if (String(value ?? '').trim() === '' || !Number.isFinite(n) || n < 0 || n > 100) return null;
    return Math.round((100 - n) * 100) / 100;
}

});

parcelRegister("407sw", function(module, exports) {

$parcel$export(module.exports, "CREATE_CUSTOM_SERVICE", () => $2e9cf2bdedb8600e$export$a2dd4c7f04f5bb19);
$parcel$export(module.exports, "useMedicalServices", () => $2e9cf2bdedb8600e$export$49a455c46e738f4b);
$parcel$export(module.exports, "useServiceCostModel", () => $2e9cf2bdedb8600e$export$ae659dc87b0d79a3);
$parcel$export(module.exports, "useMedicalServiceOrders", () => $2e9cf2bdedb8600e$export$50b2eb6c5c9193ee);
$parcel$export(module.exports, "usePatientInHouseOrders", () => $2e9cf2bdedb8600e$export$ad80fd49f69bb85);
$parcel$export(module.exports, "usePerformerCandidates", () => $2e9cf2bdedb8600e$export$3a7c7d501f7afa59);
$parcel$export(module.exports, "bookServiceSession", () => $2e9cf2bdedb8600e$export$ed28957d9f406869);
$parcel$export(module.exports, "enqueueServiceTicket", () => $2e9cf2bdedb8600e$export$d48046067da5bfff);
$parcel$export(module.exports, "useOrderCatalog", () => $2e9cf2bdedb8600e$export$880f50a7fe863674);

var $acw62 = parcelRequire("acw62");

var $2Mst8 = parcelRequire("2Mst8");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $92gF5 = parcelRequire("92gF5");

var $bS3QC = parcelRequire("bS3QC");
// The clinic's medical services — the ones it performs IN-HOUSE, by a staff
// member or by a doctor at a time of their own. Declaring a service here is what
// makes an order for it medical service (docs/medical-service-design.md §1): schedulable,
// assignable to a performer, and billable. A service the clinic does not declare
// stays an ordinary order the patient takes elsewhere — which is why labs never
// appear here.
const $2e9cf2bdedb8600e$var$PERFORMER_FIELDS = `
  type id label isDefault members { type id name active }
`;
const $2e9cf2bdedb8600e$var$DECLARATION_FIELDS = `
  currency id catalogId clinicId doctorId description unitPrice isActive
  category orderType isCustom catalogRetired durationMinutes performerRole defaultPerformerId
  requiresAppointment prepInstructions
  # What part of the mouth the service treats. Read from the catalogue row, so a
  # standard service answers the same for every clinic; null for everyone but a
  # dental clinic. The dentist app's plan form is the reader.
  defaultApplicability
  # And what it DOES to that tooth \u{2014} what \xab\u{62B}\u{628}\u{62A} \u{627}\u{646}\u{62C}\u{627}\u{645}\xbb proposes charting. Same
  # story: read from the catalogue row, null for everyone but a dental clinic.
  defaultChartEffect
  # \xab\u{642}\u{627}\u{628}\u{644} \u{627}\u{631}\u{627}\u{626}\u{647} \u{62F}\u{631}\xbb \u{2014} the catalogue row's clinic types. The drawer shows and
  # edits them for a row this clinic invented; null when unreadable.
  clinicTypes
  schedulingMode performers { ${$2e9cf2bdedb8600e$var$PERFORMER_FIELDS} }
  # \xab\u{642}\u{627}\u{628}\u{644} \u{646}\u{648}\u{628}\u{62A}\u{200C}\u{6AF}\u{6CC}\u{631}\u{6CC} \u{62A}\u{648}\u{633}\u{637} \u{628}\u{6CC}\u{645}\u{627}\u{631}\xbb \u{2014} the clinic's intent, stored on the declaration
  # (PM-0464). Whether a request is actually possible also needs a time and a
  # performer; the table says all three (serviceDefaults.bookabilityState).
  patientBookable
  # \xab\u{646}\u{645}\u{627}\u{6CC}\u{634} \u{639}\u{645}\u{648}\u{645}\u{6CC}\xbb (PM-0468 \xa72.1) \u{2014} display, where patientBookable is permission.
  publicVisible
  hasConsumables hasCommission
  # How insurance treats the service \u{2014} part of the definition, so it travels
  # with it rather than being fetched again per drawer.
  insurance {
    currency
    id catalogId itemType coverageMode
    acceptedBasicInsurerIds allowSupplementary acceptedSupplementaryInsurerIds
    calcMode patientSharePct insurerAmountRial insurerCeilingRial
    maxQuantityPerVisit minDaysBetween requiresDoctorOrder conditionsFa
    referralRequiredDirect indirectDocument multiInsurerRule
  }
`;
// Who at this clinic may be named as a performer — what the drawer's chips and
// the bulk grid's batch picker are populated from.
const $2e9cf2bdedb8600e$var$PERFORMER_CANDIDATES = `
  query PerformerCandidates {
    performerCandidates {
      staff { type id name active }
      doctors { type id name active }
      roles { ${$2e9cf2bdedb8600e$var$PERFORMER_FIELDS} }
    }
  }
`;
const $2e9cf2bdedb8600e$var$BOOK_SERVICE_SESSION = `
  mutation BookServiceSession($input: BookServiceSessionInput!) {
    bookServiceSession(input: $input) { id dateTime providerId ticketNo schedulingMode }
  }
`;
const $2e9cf2bdedb8600e$var$ENQUEUE_SERVICE_TICKET = `
  mutation EnqueueServiceTicket($input: EnqueueServiceTicketInput!) {
    enqueueServiceTicket(input: $input) {
      providerId
      entries { id patientId placeholderLabel patientName: name ticketNo queuePosition status schedulingMode }
    }
  }
`;
// The full cost picture — the stored model joined against LIVE warehousing unit
// costs. Read only when a service is opened: the list needs the two boolean
// indicators above, not a warehousing round-trip per row.
const $2e9cf2bdedb8600e$var$COST_MODEL_FIELDS = `
  currency declarationId
  consumables { id itemId itemName unit quantity unitCost currentStock lineCostRial }
  sideCosts { id label amountRial }
  commissionRules { id doctorId mode value basis }
  consumableCostRial sideCostTotalRial commissionRial
  totalCostRial marginRial marginPct
`;
const $2e9cf2bdedb8600e$var$SERVICE_COST_MODEL = `
  query ServiceCostModel($declarationId: ID!) {
    serviceCostModel(declarationId: $declarationId) { ${$2e9cf2bdedb8600e$var$COST_MODEL_FIELDS} }
  }
`;
// REPLACE-ALL per list: an omitted list is treated as empty, which is how the last
// consumable or the only commission rule is removed.
const $2e9cf2bdedb8600e$var$SET_COST_MODEL = `
  mutation SetServiceCostModel($declarationId: ID!, $input: ServiceCostModelInput!) {
    setServiceCostModel(declarationId: $declarationId, input: $input) { ${$2e9cf2bdedb8600e$var$COST_MODEL_FIELDS} }
  }
`;
const $2e9cf2bdedb8600e$var$MEDICAL_SERVICES = `
  query ClinicServiceDeclarations {
    clinicServiceDeclarations { ${$2e9cf2bdedb8600e$var$DECLARATION_FIELDS} }
  }
`;
const $2e9cf2bdedb8600e$var$ORDER_CATALOG = `
  query OrderCatalog($orderType: String, $clinicType: String, $includeOtherTypes: Boolean) {
    orderCatalog(
      orderType: $orderType
      clinicType: $clinicType
      includeOtherTypes: $includeOtherTypes
    ) {
      id orderType name nameEn category code modality bodyPart ownerType
      clinicTypes appliesToClinic declared
      defaultDurationMinutes defaultPerformerRole defaultRequiresAppointment
      defaultPatientBookable
      defaultApplicability defaultChartEffect
      # A BUNDLE's fixed parts (docs/TREATMENT_PROCESS_AND_SERVICE_BUNDLES_PLAN.md
      # D13) \u{2014} one level, never optional. The drawer shows them, and edits them
      # on a service this clinic invented.
      isBundle components { childId quantity position childName childOrderType }
    }
  }
`;
const $2e9cf2bdedb8600e$var$SET_SERVICE = `
  mutation SetClinicServiceDeclaration($input: ClinicServiceDeclarationInput!) {
    setClinicServiceDeclaration(input: $input) { ${$2e9cf2bdedb8600e$var$DECLARATION_FIELDS} }
  }
`;
const $2e9cf2bdedb8600e$export$a2dd4c7f04f5bb19 = `
  mutation CreateCustomService($input: CustomServiceInput!) {
    createCustomService(input: $input) { ${$2e9cf2bdedb8600e$var$DECLARATION_FIELDS} }
  }
`;
// Editing a service the clinic invented: its name, its group, and the clinic
// types it may be offered to. A GLOBAL service has no equivalent — the clinic
// re-prices it and re-titles its invoice line through the declaration instead.
const $2e9cf2bdedb8600e$var$UPDATE_CUSTOM_SERVICE = `
  mutation UpdateCustomService($catalogId: ID!, $input: CustomServiceInput!) {
    updateCustomService(catalogId: $catalogId, input: $input) { ${$2e9cf2bdedb8600e$var$DECLARATION_FIELDS} }
  }
`;
// The bulk flow: twenty services picked off the standard list and priced in one
// grid become one mutation, one refetch and one toast.
const $2e9cf2bdedb8600e$var$DECLARE_SERVICES = `
  mutation DeclareClinicServices($input: [ClinicServiceDeclarationInput!]!) {
    declareClinicServices(input: $input) { ${$2e9cf2bdedb8600e$var$DECLARATION_FIELDS} }
  }
`;
const $2e9cf2bdedb8600e$var$DELETE_SERVICE = `
  mutation DeleteClinicServiceDeclaration($declarationId: ID!, $catalogId: String) {
    deleteClinicServiceDeclaration(declarationId: $declarationId, catalogId: $catalogId)
  }
`;
const $2e9cf2bdedb8600e$var$MEDICAL_SERVICE_ORDERS = `
  query MedicalServiceOrders($status: [OrderStatus!]) {
    medicalServiceOrders(status: $status) {
      currency
      id appointmentId patientId patientName patientPhone doctorId
      description catalogId urgency status createdAt notes sessionCount
      unitPrice durationMinutes performerRole requiresAppointment prepInstructions
      schedulingMode declarationId performers { ${$2e9cf2bdedb8600e$var$PERFORMER_FIELDS} }
      # Where the order stands with the till (billed = on an invoice, paid = nothing
      # owed). invoiceAppointmentId is the appointment of the invoice \xab\u{641}\u{627}\u{6A9}\u{62A}\u{648}\u{631}\xbb
      # opens \u{2014} where the money is due, which is not always the order's own visit.
      billed paid invoiceId invoiceAppointmentId
      # Its place in a treatment process, when it has one. An order with a
      # processId is shown INSIDE its process on the treatments tab; ready and
      # blockedReasonFa are the service's verdict, never worked out here.
      processId sequenceNo parentOrderId approvedAt
      ready blockedReason blockedReasonFa completedSessions
      # Where it stands (PM-0634): \xab\u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{627}\u{646}\u{62C}\u{627}\u{645}\xbb, and the BFF's stage with the
      # soonest booking \u{2014} what tells the desk it is already booked.
      ${(0, $92gF5.ORDER_STAGE_FIELDS)}
      # One appointment, one invoice (PM-0618): every session row with the
      # \u{645}\u{631}\u{627}\u{62C}\u{639}\u{647} it sits in and its charge there, the next one waiting, the
      # \xab\u{627}\u{642}\u{62F}\u{627}\u{645}\u{200C}\u{647}\u{627}\u{6CC} \u{62F}\u{631}\u{645}\u{627}\u{646}\u{6CC}\xbb filter it falls in, and a package prepaid on a bill.
      sessions { ${(0, $bS3QC.SESSION_FIELDS)} }
      nextSessionNo overdue due prepaidSessions prepaidInvoiceNumber
      # The patient's open \u{645}\u{631}\u{627}\u{62C}\u{639}\u{647} a session of it can join now (null = unread):
      # where \xab\u{627}\u{641}\u{632}\u{648}\u{62F}\u{646} \u{628}\u{647} \u{627}\u{6CC}\u{646} \u{645}\u{631}\u{627}\u{62C}\u{639}\u{647}\xbb goes, and \u{2014} not empty \u{2014} why a QUEUE turn is
      # refused (ORDER_USE_THIS_VISIT), so \xab\u{646}\u{648}\u{628}\u{62A} \u{628}\u{62F}\u{647}\xbb is not offered.
      attachableVisits { ${(0, $bS3QC.OPEN_VISIT_FIELDS)} }
      # What \xab\u{627}\u{641}\u{632}\u{648}\u{62F}\u{646} \u{628}\u{647} \u{641}\u{627}\u{6A9}\u{62A}\u{648}\u{631}\xbb may still prepay (R7): the sessions less those on a
      # bill at their own price and the units a package holds. null = unread.
      prepayableSessions
    }
  }
`;
const $2e9cf2bdedb8600e$var$PATIENT_IN_HOUSE_ORDERS = `
  query PatientInHouseOrders($patientId: ID!) {
    patientInHouseOrders(patientId: $patientId) {
      currency
      id appointmentId patientId patientName patientPhone doctorId
      description catalogId urgency status notes createdAt sessionCount
      unitPrice durationMinutes performerRole requiresAppointment prepInstructions billed
      declarationId prepayableSessions
      ${(0, $92gF5.ORDER_STAGE_FIELDS)}
    }
  }
`;
const $2e9cf2bdedb8600e$export$2f7aede420a3ff50 = (t)=>[
        {
            value: 'doctor',
            label: t('common.roles.doctor')
        },
        {
            value: 'nurse',
            label: t('common.roles.nurse')
        },
        {
            value: 'physiotherapist',
            label: t('common.roles.physiotherapist')
        },
        {
            value: 'technician',
            label: t('common.roles.technician')
        },
        {
            value: 'radiologist',
            label: t('common.roles.radiologist')
        }
    ];
const $2e9cf2bdedb8600e$export$d78add5f80ae1487 = (role, t)=>$2e9cf2bdedb8600e$export$2f7aede420a3ff50(t).find((r)=>r.value === role)?.label || "\u2014";
function $2e9cf2bdedb8600e$export$49a455c46e738f4b() {
    const { t: t } = (0, $e1LEq.default)();
    const [services, setServices] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    const refresh = (0, $acw62.useCallback)(async ()=>{
        setLoading(true);
        try {
            const d = await (0, $2Mst8.bffQuery)($2e9cf2bdedb8600e$var$MEDICAL_SERVICES);
            setServices(d.clinicServiceDeclarations || []);
            setError(null);
        } catch (e) {
            setError(e.message || t('errors.load.services'));
        } finally{
            setLoading(false);
        }
    }, [
        t
    ]);
    (0, $acw62.useEffect)(()=>{
        refresh();
    }, [
        refresh
    ]);
    // A catalog-backed service (picked from the dictionary, or an existing clinic-owned
    // one being edited). The upsert is keyed on (catalogId, doctorId), so re-saving an
    // existing service re-prices it rather than duplicating it.
    const saveService = (0, $acw62.useCallback)(async (input)=>{
        const saved = await (0, $2Mst8.bffMutation)($2e9cf2bdedb8600e$var$SET_SERVICE, {
            input: input
        });
        await refresh();
        return saved.setClinicServiceDeclaration;
    }, [
        refresh
    ]);
    // A service the dictionary has no entry for — the BFF creates the clinic-owned
    // catalog entry and its declaration together.
    const createCustom = (0, $acw62.useCallback)(async (input)=>{
        const saved = await (0, $2Mst8.bffMutation)($2e9cf2bdedb8600e$export$a2dd4c7f04f5bb19, {
            input: input
        });
        await refresh();
        return saved.createCustomService;
    }, [
        refresh
    ]);
    // Edit a clinic-invented service. Owner-guarded server-side: a global catalogId
    // comes back as CATALOG_SERVICE_NOT_EDITABLE rather than rewriting the shared
    // dictionary, which is exactly what the drawer's read-only name field prevents
    // anyone from trying in the first place.
    const updateCustom = (0, $acw62.useCallback)(async (catalogId, input)=>{
        const saved = await (0, $2Mst8.bffMutation)($2e9cf2bdedb8600e$var$UPDATE_CUSTOM_SERVICE, {
            catalogId: catalogId,
            input: input
        });
        await refresh();
        return saved.updateCustomService;
    }, [
        refresh
    ]);
    // Declare many at once. A PARTIAL failure still throws — the rows that saved
    // are saved, and `err.extensions.failed` names the ones that did not so the
    // grid can keep exactly those and clear the rest.
    const declareMany = (0, $acw62.useCallback)(async (rows)=>{
        const saved = await (0, $2Mst8.bffMutation)($2e9cf2bdedb8600e$var$DECLARE_SERVICES, {
            input: rows
        });
        await refresh();
        return saved.declareClinicServices || [];
    }, [
        refresh
    ]);
    // Pass the whole service: a clinic-invented one also retires its catalog entry, which
    // needs the catalogId (a global catalogId is ignored by the BFF).
    const removeService = (0, $acw62.useCallback)(async (service)=>{
        await (0, $2Mst8.bffMutation)($2e9cf2bdedb8600e$var$DELETE_SERVICE, {
            declarationId: service.id,
            catalogId: service.catalogId || null
        });
        await refresh();
    }, [
        refresh
    ]);
    return {
        services: services,
        loading: loading,
        error: error,
        refresh: refresh,
        saveService: saveService,
        createCustom: createCustom,
        updateCustom: updateCustom,
        declareMany: declareMany,
        removeService: removeService
    };
}
function $2e9cf2bdedb8600e$export$ae659dc87b0d79a3(declarationId) {
    const { t: t } = (0, $e1LEq.default)();
    const [costModel, setCostModel] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    const refresh = (0, $acw62.useCallback)(async ()=>{
        if (!declarationId) {
            setCostModel(null);
            setLoading(false);
            return;
        }
        setLoading(true);
        try {
            const d = await (0, $2Mst8.bffQuery)($2e9cf2bdedb8600e$var$SERVICE_COST_MODEL, {
                declarationId: declarationId
            });
            setCostModel(d.serviceCostModel || null);
            setError(null);
        } catch (e) {
            setError(e.message || t('errors.load.servicePrice'));
            setCostModel(null);
        } finally{
            setLoading(false);
        }
    }, [
        declarationId,
        t
    ]);
    (0, $acw62.useEffect)(()=>{
        refresh();
    }, [
        refresh
    ]);
    // Returns the COMPOSED model the server just computed, so the drawer shows the
    // margin its save produced instead of flashing the old number first.
    // `targetId` exists for the one caller the closed-over id cannot serve: a
    // BRAND-NEW service, whose declaration id only comes into being in the save
    // above this one. Without it the mutation goes out with declarationId: null and
    // the server rejects the variable outright.
    const save = (0, $acw62.useCallback)(async ({ consumables: consumables, sideCosts: sideCosts, commissionRules: commissionRules }, targetId)=>{
        const id = targetId || declarationId;
        if (!id) throw new Error(t('errors.services.notSavedYet'));
        const d = await (0, $2Mst8.bffMutation)($2e9cf2bdedb8600e$var$SET_COST_MODEL, {
            declarationId: id,
            input: {
                consumables: (consumables || []).map((c)=>({
                        itemId: c.itemId,
                        itemName: c.itemName,
                        unit: c.unit,
                        quantity: Number(c.quantity) || 0
                    })),
                sideCosts: (sideCosts || []).map((s)=>({
                        label: s.label,
                        amountRial: Math.round(Number(s.amountRial) || 0)
                    })),
                // `basis` travels both ways: this write is replace-all, so a rule read
                // without it would be saved back as `gross`.
                commissionRules: (commissionRules || []).map((r)=>({
                        doctorId: r.doctorId || null,
                        mode: r.mode,
                        value: Number(r.value) || 0,
                        basis: r.basis || null
                    }))
            }
        });
        const saved = d.setServiceCostModel || null;
        // Only adopt it as THIS hook's state when it is this hook's service — a
        // new service's model belongs to a drawer that is about to close.
        if (id === declarationId) setCostModel(saved);
        return saved;
    }, [
        declarationId,
        t
    ]);
    return {
        costModel: costModel,
        loading: loading,
        error: error,
        refresh: refresh,
        save: save
    };
}
function $2e9cf2bdedb8600e$export$50b2eb6c5c9193ee(statuses) {
    const [orders, setOrders] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const key = statuses ? statuses.join(',') : '';
    const refresh = (0, $acw62.useCallback)(async ()=>{
        try {
            const d = await (0, $2Mst8.bffQuery)($2e9cf2bdedb8600e$var$MEDICAL_SERVICE_ORDERS, {
                status: key ? key.split(',') : null
            });
            setOrders(d.medicalServiceOrders || []);
        } catch  {
            setOrders([]);
        } finally{
            setLoading(false);
        }
    }, [
        key
    ]);
    (0, $acw62.useEffect)(()=>{
        refresh();
    }, [
        refresh
    ]);
    return {
        orders: orders,
        loading: loading,
        refresh: refresh
    };
}
function $2e9cf2bdedb8600e$export$ad80fd49f69bb85(patientId) {
    const [orders, setOrders] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const refresh = (0, $acw62.useCallback)(async ()=>{
        if (!patientId) {
            setOrders([]);
            setLoading(false);
            return;
        }
        try {
            const d = await (0, $2Mst8.bffQuery)($2e9cf2bdedb8600e$var$PATIENT_IN_HOUSE_ORDERS, {
                patientId: patientId
            });
            setOrders(d.patientInHouseOrders || []);
        } catch  {
            setOrders([]);
        } finally{
            setLoading(false);
        }
    }, [
        patientId
    ]);
    (0, $acw62.useEffect)(()=>{
        refresh();
    }, [
        refresh
    ]);
    return {
        orders: orders,
        loading: loading,
        refresh: refresh
    };
}
function $2e9cf2bdedb8600e$export$3a7c7d501f7afa59(enabled = true) {
    const [candidates, setCandidates] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(!!enabled);
    (0, $acw62.useEffect)(()=>{
        if (!enabled) {
            setLoading(false);
            return undefined;
        }
        let cancelled = false;
        setLoading(true);
        (0, $2Mst8.bffQuery)($2e9cf2bdedb8600e$var$PERFORMER_CANDIDATES, {}, 'PerformerCandidates').then((d)=>{
            if (!cancelled) setCandidates(d?.performerCandidates || {
                staff: [],
                doctors: [],
                roles: []
            });
        }).catch(()=>{
            if (!cancelled) setCandidates({
                staff: [],
                doctors: [],
                roles: []
            });
        }).finally(()=>{
            if (!cancelled) setLoading(false);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        enabled
    ]);
    return {
        candidates: candidates,
        loading: loading
    };
}
async function $2e9cf2bdedb8600e$export$ed28957d9f406869({ orderId: orderId, patientId: patientId, declarationId: declarationId, performer: performer, dateTimeMs: dateTimeMs, reminderNote: reminderNote, sessionId: sessionId }) {
    const d = await (0, $2Mst8.bffMutation)($2e9cf2bdedb8600e$var$BOOK_SERVICE_SESSION, {
        input: {
            orderId: orderId,
            patientId: patientId,
            declarationId: declarationId,
            performer: performer,
            dateTime: String(dateTimeMs),
            reminderNote: reminderNote || undefined,
            // «جلسهٔ بعدی» (PM-0618): the session row the booking is attached to;
            // omitted, the BFF attaches the next waiting one.
            sessionId: sessionId || undefined
        }
    });
    return d?.bookServiceSession;
}
async function $2e9cf2bdedb8600e$export$d48046067da5bfff({ orderId: orderId, patientId: patientId, declarationId: declarationId, performer: performer }) {
    const d = await (0, $2Mst8.bffMutation)($2e9cf2bdedb8600e$var$ENQUEUE_SERVICE_TICKET, {
        input: {
            orderId: orderId,
            patientId: patientId,
            declarationId: declarationId,
            performer: performer
        }
    });
    return d?.enqueueServiceTicket;
}
function $2e9cf2bdedb8600e$export$880f50a7fe863674({ orderType: orderType = null, clinicType: clinicType = null, includeOtherTypes: includeOtherTypes = false, enabled: enabled = true } = {}) {
    const { t: t } = (0, $e1LEq.default)();
    const [entries, setEntries] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(!!enabled);
    const [error, setError] = (0, $acw62.useState)(null);
    // Bumped to force a refetch after a declaration lands, so `declared` — which
    // the BFF joins on per request — stops being stale the moment it matters.
    const [nonce, setNonce] = (0, $acw62.useState)(0);
    const reload = (0, $acw62.useCallback)(()=>setNonce((n)=>n + 1), []);
    (0, $acw62.useEffect)(()=>{
        if (!enabled) {
            setEntries([]);
            setLoading(false);
            return undefined;
        }
        let cancelled = false;
        setLoading(true);
        (0, $2Mst8.bffQuery)($2e9cf2bdedb8600e$var$ORDER_CATALOG, {
            orderType: orderType || null,
            clinicType: clinicType || null,
            includeOtherTypes: !!includeOtherTypes
        }).then((d)=>{
            if (!cancelled) {
                setEntries(d.orderCatalog || []);
                setError(null);
            }
        }).catch((e)=>{
            if (cancelled) return;
            setEntries([]);
            // Surfaced, not swallowed. An empty picker and an unreachable picker look
            // identical, and the second one is not the clinic's fault to fix.
            setError(e.message || t('errors.operations.catalogUnavailable'));
        }).finally(()=>{
            if (!cancelled) setLoading(false);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        orderType,
        clinicType,
        includeOtherTypes,
        enabled,
        nonce,
        t
    ]);
    /**
   * `[[groupLabel, entries], …]`, applicable groups first.
   *
   * Rows for other clinic types are grouped SEPARATELY — «سایر انواع · ارتوپدی» —
   * rather than mixed into the same category heading. Two services under one
   * heading where one of them is greyed out reads as a rendering bug; two
   * headings reads as two lists, which is what it is.
   */ const byCategory = (0, $acw62.useMemo)(()=>{
        const groups = new Map();
        for (const e of entries){
            const category = e.category || t('common.state.other');
            const key = e.appliesToClinic === false ? t('operations.catalog.otherTypesGroup', {
                group: category
            }) : category;
            if (!groups.has(key)) groups.set(key, {
                applies: e.appliesToClinic !== false,
                rows: []
            });
            groups.get(key).rows.push(e);
        }
        return [
            ...groups.entries()
        ].sort((a, b)=>Number(b[1].applies) - Number(a[1].applies)).map(([label, group])=>[
                label,
                group.rows
            ]);
    }, [
        entries,
        t
    ]);
    return {
        entries: entries,
        byCategory: byCategory,
        loading: loading,
        error: error,
        reload: reload
    };
}

});
parcelRegister("92gF5", function(module, exports) {

$parcel$export(module.exports, "ORDER_STAGE_FIELDS", () => $694139a0a87fa3db$export$721891ecd6a32d59);
$parcel$export(module.exports, "ORDER_STAGE_META", () => $694139a0a87fa3db$export$62d640d5383fb54d);
$parcel$export(module.exports, "orderStageOf", () => $694139a0a87fa3db$export$e60d2818e9814d49);
$parcel$export(module.exports, "orderBookingOf", () => $694139a0a87fa3db$export$934f2a2a1e13fc35);
$parcel$export(module.exports, "orderDayOf", () => $694139a0a87fa3db$export$1d9b4a1d3a894455);
$parcel$export(module.exports, "orderDayInstant", () => $694139a0a87fa3db$export$f8e620a21b3b0d7e);
$parcel$export(module.exports, "SESSION_STATUS_META", () => $694139a0a87fa3db$export$1f1db1b14a200b29);
$parcel$export(module.exports, "sessionStatusOf", () => $694139a0a87fa3db$export$fb2b654199c02c7a);
$parcel$export(module.exports, "isLiveSession", () => $694139a0a87fa3db$export$e93015d0694bd9b6);
$parcel$export(module.exports, "isOpenSession", () => $694139a0a87fa3db$export$98bcb199475cdb8b);
$parcel$export(module.exports, "sortedSessions", () => $694139a0a87fa3db$export$1adc76ae247b8d29);
$parcel$export(module.exports, "nextRequestedSession", () => $694139a0a87fa3db$export$52c72c72afb233b0);
$parcel$export(module.exports, "isAnswerableSession", () => $694139a0a87fa3db$export$539666f892164dbb);
$parcel$export(module.exports, "sessionToRecord", () => $694139a0a87fa3db$export$a627b0396d678593);
$parcel$export(module.exports, "holdsSessionIn", () => $694139a0a87fa3db$export$e38cf1844ad7f990);
$parcel$export(module.exports, "orderDueOf", () => $694139a0a87fa3db$export$ab769165999cdf56);

var $jTCZr = parcelRequire("jTCZr");

var $5qKOB = parcelRequire("5qKOB");
const $694139a0a87fa3db$export$721891ecd6a32d59 = 'performedDate performedHere stage nextBookingAt';
const $694139a0a87fa3db$export$be09ebc684415570 = [
    'REQUESTED',
    'SCHEDULED',
    'IN_PROGRESS',
    'DONE',
    'CANCELLED'
];
const $694139a0a87fa3db$var$swatch = (s)=>({
        bg: s.bg,
        text: s.text
    });
const $694139a0a87fa3db$export$62d640d5383fb54d = {
    REQUESTED: {
        key: 'requested',
        variant: 'warning',
        ...$694139a0a87fa3db$var$swatch((0, $jTCZr.statusColors).waiting)
    },
    SCHEDULED: {
        key: 'scheduled',
        variant: 'outline',
        ...$694139a0a87fa3db$var$swatch((0, $jTCZr.statusColors).scheduled)
    },
    IN_PROGRESS: {
        key: 'inProgress',
        variant: 'default',
        ...$694139a0a87fa3db$var$swatch((0, $jTCZr.statusColors).in_visit)
    },
    DONE: {
        key: 'done',
        variant: 'success',
        ...$694139a0a87fa3db$var$swatch((0, $jTCZr.statusColors).completed)
    },
    CANCELLED: {
        key: 'cancelled',
        variant: 'destructive',
        ...$694139a0a87fa3db$var$swatch((0, $jTCZr.statusColors).cancelled)
    }
};
const $694139a0a87fa3db$var$STAGE_OF_STATUS = {
    pending: 'REQUESTED',
    in_progress: 'IN_PROGRESS',
    completed: 'DONE',
    cancelled: 'CANCELLED'
};
function $694139a0a87fa3db$export$e60d2818e9814d49(order) {
    const stage = order?.stage;
    if (stage && Object.prototype.hasOwnProperty.call($694139a0a87fa3db$export$62d640d5383fb54d, stage)) return stage;
    return $694139a0a87fa3db$var$STAGE_OF_STATUS[order?.status] || null;
}
function $694139a0a87fa3db$export$934f2a2a1e13fc35(order) {
    const stage = $694139a0a87fa3db$export$e60d2818e9814d49(order);
    return (stage === 'SCHEDULED' || stage === 'IN_PROGRESS') && order?.nextBookingAt ? order.nextBookingAt : null;
}
const $694139a0a87fa3db$var$ISO_DAY = /^(\d{4})-(\d{2})-(\d{2})$/;
/** A real 'YYYY-MM-DD' — 2026-02-30 is not one. */ function $694139a0a87fa3db$var$isIsoDay(value) {
    const m = $694139a0a87fa3db$var$ISO_DAY.exec(String(value ?? ''));
    if (!m) return false;
    const d = new Date(Date.UTC(+m[1], +m[2] - 1, +m[3]));
    return d.getUTCFullYear() === +m[1] && d.getUTCMonth() === +m[2] - 1 && d.getUTCDate() === +m[3];
}
// The clinical service writes `created_at` as UTC wall time with no designator
// («2026-10-25T08:00:00.123456»), which `Date.parse` would read on the browser's
// clock. Anything without one is therefore read as UTC.
function $694139a0a87fa3db$var$instantMs(value) {
    if (value == null || value === '') return NaN;
    const s = String(value).trim();
    if (/^\d+$/.test(s)) return Number(s);
    const zoned = /([zZ]|[+-]\d{2}:?\d{2})$/.test(s);
    return Date.parse(zoned ? s : `${s.replace(' ', 'T')}Z`);
}
function $694139a0a87fa3db$export$1d9b4a1d3a894455(order) {
    if ($694139a0a87fa3db$var$isIsoDay(order?.performedDate)) return order.performedDate;
    const ms = $694139a0a87fa3db$var$instantMs(order?.createdAt);
    return Number.isFinite(ms) ? (0, $5qKOB.isoDayOf)(ms) : '';
}
function $694139a0a87fa3db$export$f8e620a21b3b0d7e(isoDay) {
    return $694139a0a87fa3db$var$isIsoDay(isoDay) ? (0, $5qKOB.wallToMs)(isoDay, 720) : null;
}
const $694139a0a87fa3db$export$4989ed2695133897 = [
    'REQUESTED',
    'SCHEDULED',
    'IN_PROGRESS',
    'DONE',
    'NOT_DONE',
    'CANCELLED',
    'VOIDED'
];
const $694139a0a87fa3db$export$1f1db1b14a200b29 = {
    REQUESTED: {
        key: 'requested',
        variant: 'warning',
        history: false,
        ...$694139a0a87fa3db$var$swatch((0, $jTCZr.statusColors).waiting)
    },
    SCHEDULED: {
        key: 'scheduled',
        variant: 'outline',
        history: false,
        ...$694139a0a87fa3db$var$swatch((0, $jTCZr.statusColors).scheduled)
    },
    IN_PROGRESS: {
        key: 'inProgress',
        variant: 'default',
        history: false,
        ...$694139a0a87fa3db$var$swatch((0, $jTCZr.statusColors).in_visit)
    },
    DONE: {
        key: 'done',
        variant: 'success',
        history: false,
        ...$694139a0a87fa3db$var$swatch((0, $jTCZr.statusColors).completed)
    },
    NOT_DONE: {
        key: 'notDone',
        variant: 'destructive',
        history: true,
        ...$694139a0a87fa3db$var$swatch((0, $jTCZr.statusColors).cancelled)
    },
    CANCELLED: {
        key: 'cancelled',
        variant: 'destructive',
        history: true,
        ...$694139a0a87fa3db$var$swatch((0, $jTCZr.statusColors).cancelled)
    },
    VOIDED: {
        key: 'voided',
        variant: 'destructive',
        history: true,
        ...$694139a0a87fa3db$var$swatch((0, $jTCZr.statusColors).cancelled)
    }
};
function $694139a0a87fa3db$export$fb2b654199c02c7a(s) {
    if (!s) return null;
    const st = String(s.status || '').toUpperCase();
    if ($694139a0a87fa3db$export$1f1db1b14a200b29[st]) return st;
    if (s.voidedAt) return 'VOIDED';
    const o = String(s.outcome || '').toUpperCase();
    if (o === 'COMPLETED') return 'DONE';
    if (o === 'IN_PROGRESS') return 'IN_PROGRESS';
    return 'REQUESTED';
}
const $694139a0a87fa3db$export$e93015d0694bd9b6 = (s)=>{
    const st = $694139a0a87fa3db$export$fb2b654199c02c7a(s);
    return !!st && !$694139a0a87fa3db$export$1f1db1b14a200b29[st].history;
};
const $694139a0a87fa3db$export$98bcb199475cdb8b = (s)=>{
    const st = $694139a0a87fa3db$export$fb2b654199c02c7a(s);
    return st === 'SCHEDULED' || st === 'IN_PROGRESS';
};
function $694139a0a87fa3db$export$1adc76ae247b8d29(sessions) {
    const ms = (v)=>{
        const n = Date.parse(v || '');
        return Number.isFinite(n) ? n : 0;
    };
    return [
        ...sessions || []
    ].sort((a, b)=>(a.sessionNo || 0) - (b.sessionNo || 0) || ms(a.createdAt) - ms(b.createdAt));
}
function $694139a0a87fa3db$export$52c72c72afb233b0(sessions) {
    return $694139a0a87fa3db$export$1adc76ae247b8d29(sessions).find((s)=>$694139a0a87fa3db$export$fb2b654199c02c7a(s) === 'REQUESTED') || null;
}
function $694139a0a87fa3db$export$539666f892164dbb(session, openVisitIds = []) {
    return $694139a0a87fa3db$export$98bcb199475cdb8b(session) && !!session.appointmentId && (openVisitIds instanceof Set ? openVisitIds : new Set(openVisitIds || [])).has(session.appointmentId);
}
function $694139a0a87fa3db$export$a627b0396d678593(sessions, { openVisitIds: openVisitIds = [] } = {}) {
    const here = new Set(openVisitIds || []);
    const open = $694139a0a87fa3db$export$1adc76ae247b8d29(sessions).filter((s)=>$694139a0a87fa3db$export$539666f892164dbb(s, here));
    return open.find((s)=>$694139a0a87fa3db$export$fb2b654199c02c7a(s) === 'IN_PROGRESS') || open[0] || null;
}
const $694139a0a87fa3db$export$e38cf1844ad7f990 = (sessions, appointmentId)=>!!appointmentId && (sessions || []).some((s)=>$694139a0a87fa3db$export$e93015d0694bd9b6(s) && $694139a0a87fa3db$export$fb2b654199c02c7a(s) !== 'REQUESTED' && s.appointmentId === appointmentId);
const $694139a0a87fa3db$export$a941b878062aaf80 = [
    'TODAY',
    'FUTURE',
    'OVERDUE'
];
function $694139a0a87fa3db$export$ab769165999cdf56(order, todayIso) {
    if (order && $694139a0a87fa3db$export$a941b878062aaf80.includes(order.due)) return order.due;
    if (order && order.due === null && 'due' in order) return null;
    if ($694139a0a87fa3db$export$e60d2818e9814d49(order) !== 'REQUESTED' || !todayIso) return null;
    const day = $694139a0a87fa3db$export$1d9b4a1d3a894455(order);
    if (!day || day === todayIso) return 'TODAY';
    return day < todayIso ? 'OVERDUE' : 'FUTURE';
}

});

parcelRegister("bS3QC", function(module, exports) {

$parcel$export(module.exports, "SESSION_FIELDS", () => $8a47b8f0c4c1e28f$export$e1c09b2d9660ec55);
$parcel$export(module.exports, "OPEN_VISIT_FIELDS", () => $8a47b8f0c4c1e28f$export$16b4540d46ecb63d);
$parcel$export(module.exports, "addOrderToVisit", () => $8a47b8f0c4c1e28f$export$984412324deb90fe);
$parcel$export(module.exports, "markSessionNotDone", () => $8a47b8f0c4c1e28f$export$1095063b21189207);
$parcel$export(module.exports, "answerOpenServices", () => $8a47b8f0c4c1e28f$export$b5a15889bfddc3f7);
$parcel$export(module.exports, "planAllSessions", () => $8a47b8f0c4c1e28f$export$cd32428e3393c8b0);
$parcel$export(module.exports, "bookAllSessions", () => $8a47b8f0c4c1e28f$export$d2e4849f3eb3b49c);
$parcel$export(module.exports, "resyncSessionCharge", () => $8a47b8f0c4c1e28f$export$8c6d425c3927f282);
$parcel$export(module.exports, "usePatientOpenVisits", () => $8a47b8f0c4c1e28f$export$e4b451fdb3d082d7);
$parcel$export(module.exports, "useAppointmentServices", () => $8a47b8f0c4c1e28f$export$af303b24ff3183d);
$parcel$export(module.exports, "useDayVisitServices", () => $8a47b8f0c4c1e28f$export$7ce3a370ff17ed67);

var $acw62 = parcelRequire("acw62");

var $2Mst8 = parcelRequire("2Mst8");
// «یک مراجعه، یک فاکتور» — PM-0618 (docs/ONE_APPOINTMENT_ONE_INVOICE_PLAN.md,
// build contract §6.1 / §7.1).
//
// A مراجعه (appointment) carries ITEMS: the sessions of the doctors' orders that
// sit in it. Each item is billed on that مراجعه's one invoice, by accounting, off
// clinicalencounter's session events — the desk never writes a line itself. What
// the desk does is say WHICH مراجعه a session sits in («افزودن به این مراجعه»,
// «جلسهٔ بعدی», «رزرو همهٔ جلسات») and how it ended («انجام شد», «انجام نشد»,
// «تاریخ دیگر»). Every status and every charge here is the BFF's.
const $8a47b8f0c4c1e28f$var$PERFORMER_FIELDS = 'type id label isDefault members { type id name active }';
const $8a47b8f0c4c1e28f$export$e1c09b2d9660ec55 = `
  id sessionNo appointmentId performerId performerType performerName
  recordedBy performedAt outcome billed voidedAt voidReason
  status plannedDate notDoneReason createdAt appointmentAt
  charge invoiceId invoiceNumber invoicePaid
`;
/** What a day row's chip and the checkout need of the item's order. */ const $8a47b8f0c4c1e28f$var$ITEM_ORDER_FIELDS = `
  id patientId description catalogId sessionCount schedulingMode declarationId
  durationMinutes performers { ${$8a47b8f0c4c1e28f$var$PERFORMER_FIELDS} }
`;
const $8a47b8f0c4c1e28f$var$ITEM_FIELDS = `session { ${$8a47b8f0c4c1e28f$export$e1c09b2d9660ec55} } order { ${$8a47b8f0c4c1e28f$var$ITEM_ORDER_FIELDS} }`;
// The day row's chip needs a session's status and who did it — not its charge:
// `charge` / `appointmentAt` cost the BFF an invoice and an appointment read per
// مراجعه, which a whole day's list should not pay on every re-read. The checkout
// reads the full session (APPOINTMENT_SERVICES) when the money matters.
const $8a47b8f0c4c1e28f$var$DAY_SESSION_FIELDS = `
  id sessionNo appointmentId performerId performerType performerName
  performedAt outcome voidedAt status plannedDate notDoneReason createdAt
`;
// A read of its own, beside the day's appointments rather than inside them: a
// clinicalencounter that cannot answer must not take the day list down with it,
// and a BFF from before PM-0618 refuses the field — then only the chips go.
const $8a47b8f0c4c1e28f$var$DAY_VISIT_SERVICES = `
  query DayVisitServices($date: String) {
    appointments(date: $date) {
      id openServices services { session { ${$8a47b8f0c4c1e28f$var$DAY_SESSION_FIELDS} } order { ${$8a47b8f0c4c1e28f$var$ITEM_ORDER_FIELDS} } }
    }
  }
`;
const $8a47b8f0c4c1e28f$var$APPOINTMENT_SERVICES = `
  query AppointmentServices($appointmentId: ID!) {
    appointmentServices(appointmentId: $appointmentId) { ${$8a47b8f0c4c1e28f$var$ITEM_FIELDS} }
  }
`;
const $8a47b8f0c4c1e28f$export$16b4540d46ecb63d = 'appointmentId dateTime status invoiceIssued providerName';
const $8a47b8f0c4c1e28f$var$PATIENT_OPEN_VISITS = `
  query PatientOpenVisits($patientId: ID!) {
    patientOpenVisits(patientId: $patientId) { ${$8a47b8f0c4c1e28f$export$16b4540d46ecb63d} }
  }
`;
const $8a47b8f0c4c1e28f$var$PLAN_ALL_SESSIONS = `
  query PlanAllSessions($orderId: ID!, $firstAt: String!, $intervalDays: Int!, $performer: PerformerRefInput!) {
    planAllSessions(orderId: $orderId, firstAt: $firstAt, intervalDays: $intervalDays, performer: $performer) {
      sessionNo at conflict reason
    }
  }
`;
// The writes answer with the order; every caller re-reads its list anyway,
// because a write moves the order's stage, its due and its neighbour's counts.
const $8a47b8f0c4c1e28f$var$ADD_ORDER_TO_VISIT = `
  mutation AddOrderToVisit($orderId: ID!, $appointmentId: ID!) {
    addOrderToVisit(orderId: $orderId, appointmentId: $appointmentId) { id stage nextSessionNo }
  }
`;
const $8a47b8f0c4c1e28f$var$MARK_SESSION_NOT_DONE = `
  mutation MarkSessionNotDone($orderId: ID!, $sessionId: ID, $appointmentId: ID!, $reason: String) {
    markSessionNotDone(orderId: $orderId, sessionId: $sessionId, appointmentId: $appointmentId, reason: $reason) { id stage nextSessionNo }
  }
`;
const $8a47b8f0c4c1e28f$var$ANSWER_OPEN_SERVICES = `
  mutation AnswerOpenServices($appointmentId: ID!, $answers: [OpenServiceAnswerInput!]!, $issue: Boolean) {
    answerOpenServices(appointmentId: $appointmentId, answers: $answers, issue: $issue) {
      appointmentId remaining issued issuePending failures { sessionId code message }
    }
  }
`;
const $8a47b8f0c4c1e28f$var$BOOK_ALL_SESSIONS = `
  mutation BookAllSessions($orderId: ID!, $slots: [SessionSlotInput!]!) {
    bookAllSessions(orderId: $orderId, slots: $slots) { id stage nextSessionNo }
  }
`;
const $8a47b8f0c4c1e28f$var$RESYNC_SESSION_CHARGE = `
  mutation ResyncSessionCharge($sessionId: ID!) {
    resyncSessionCharge(sessionId: $sessionId) { id status charge }
  }
`;
const $8a47b8f0c4c1e28f$var$ref = (p)=>p ? {
        type: p.type,
        id: p.id
    } : undefined;
async function $8a47b8f0c4c1e28f$export$984412324deb90fe({ orderId: orderId, appointmentId: appointmentId }) {
    const d = await (0, $2Mst8.bffMutation)($8a47b8f0c4c1e28f$var$ADD_ORDER_TO_VISIT, {
        orderId: orderId,
        appointmentId: appointmentId
    });
    return d?.addOrderToVisit;
}
async function $8a47b8f0c4c1e28f$export$1095063b21189207({ orderId: orderId, sessionId: sessionId, appointmentId: appointmentId, reason: reason }) {
    const d = await (0, $2Mst8.bffMutation)($8a47b8f0c4c1e28f$var$MARK_SESSION_NOT_DONE, {
        orderId: orderId,
        sessionId: sessionId || null,
        appointmentId: appointmentId,
        reason: reason || null
    });
    return d?.markSessionNotDone;
}
async function $8a47b8f0c4c1e28f$export$b5a15889bfddc3f7({ appointmentId: appointmentId, answers: answers, issue: issue = true }) {
    const d = await (0, $2Mst8.bffMutation)($8a47b8f0c4c1e28f$var$ANSWER_OPEN_SERVICES, {
        appointmentId: appointmentId,
        issue: issue,
        answers: answers.map((a)=>({
                sessionId: a.sessionId,
                orderId: a.orderId,
                answer: a.answer,
                performer: a.answer === 'DONE' ? $8a47b8f0c4c1e28f$var$ref(a.performer) : undefined,
                laterDate: a.answer === 'LATER' ? a.laterDate : undefined,
                reason: a.answer === 'NOT_DONE' ? a.reason || undefined : undefined
            }))
    });
    return d?.answerOpenServices;
}
async function $8a47b8f0c4c1e28f$export$cd32428e3393c8b0({ orderId: orderId, firstAt: firstAt, intervalDays: intervalDays, performer: performer }) {
    const d = await (0, $2Mst8.bffQuery)($8a47b8f0c4c1e28f$var$PLAN_ALL_SESSIONS, {
        orderId: orderId,
        firstAt: String(firstAt),
        intervalDays: Number(intervalDays),
        performer: $8a47b8f0c4c1e28f$var$ref(performer)
    });
    return d?.planAllSessions || [];
}
async function $8a47b8f0c4c1e28f$export$d2e4849f3eb3b49c({ orderId: orderId, slots: slots }) {
    const d = await (0, $2Mst8.bffMutation)($8a47b8f0c4c1e28f$var$BOOK_ALL_SESSIONS, {
        orderId: orderId,
        slots: slots.map((s)=>({
                sessionNo: s.sessionNo,
                at: String(s.at),
                performer: $8a47b8f0c4c1e28f$var$ref(s.performer)
            }))
    });
    return d?.bookAllSessions;
}
async function $8a47b8f0c4c1e28f$export$8c6d425c3927f282(sessionId) {
    const d = await (0, $2Mst8.bffMutation)($8a47b8f0c4c1e28f$var$RESYNC_SESSION_CHARGE, {
        sessionId: sessionId
    });
    return d?.resyncSessionCharge;
}
async function $8a47b8f0c4c1e28f$export$63b1ec2d23187144(patientId) {
    const d = await (0, $2Mst8.bffQuery)($8a47b8f0c4c1e28f$var$PATIENT_OPEN_VISITS, {
        patientId: patientId
    });
    return d?.patientOpenVisits || [];
}
function $8a47b8f0c4c1e28f$export$e4b451fdb3d082d7(patientIds, { enabled: enabled = true, refreshKey: refreshKey = 0 } = {}) {
    const ids = (0, $acw62.useMemo)(()=>[
            ...new Set((patientIds || []).filter(Boolean))
        ].sort(), [
        patientIds
    ]);
    const key = ids.join(',');
    const [byPatient, setByPatient] = (0, $acw62.useState)(()=>new Map());
    const [loaded, setLoaded] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (!enabled || !ids.length) {
            setByPatient((prev)=>prev.size ? new Map() : prev);
            setLoaded(true);
            return undefined;
        }
        let live = true;
        Promise.all(ids.map((pid)=>$8a47b8f0c4c1e28f$export$63b1ec2d23187144(pid).then((v)=>[
                    pid,
                    v
                ]).catch(()=>[
                    pid,
                    []
                ]))).then((pairs)=>{
            if (!live) return;
            setByPatient(new Map(pairs));
            setLoaded(true);
        });
        return ()=>{
            live = false;
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        key,
        enabled,
        refreshKey
    ]);
    return {
        byPatient: byPatient,
        loaded: loaded
    };
}
function $8a47b8f0c4c1e28f$export$af303b24ff3183d(appointmentId, { enabled: enabled = true } = {}) {
    const [items, setItems] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(!!(enabled && appointmentId));
    const [error, setError] = (0, $acw62.useState)(null);
    const reload = (0, $acw62.useCallback)(async ()=>{
        if (!enabled || !appointmentId) {
            setItems([]);
            setError(null);
            setLoading(false);
            return [];
        }
        setLoading(true);
        try {
            const d = await (0, $2Mst8.bffQuery)($8a47b8f0c4c1e28f$var$APPOINTMENT_SERVICES, {
                appointmentId: appointmentId
            });
            const rows = d?.appointmentServices || [];
            setItems(rows);
            setError(null);
            return rows;
        } catch (e) {
            setItems([]);
            setError(e?.message || 'appointmentServices');
            return null;
        } finally{
            setLoading(false);
        }
    }, [
        appointmentId,
        enabled
    ]);
    (0, $acw62.useEffect)(()=>{
        reload();
    }, [
        reload
    ]);
    return {
        items: items,
        loading: loading,
        error: error,
        reload: reload
    };
}
function $8a47b8f0c4c1e28f$export$7ce3a370ff17ed67(dateAnchor, rowsKey, { enabled: enabled = true } = {}) {
    const [byAppointment, setByAppointment] = (0, $acw62.useState)(()=>new Map());
    const [loading, setLoading] = (0, $acw62.useState)(!!enabled);
    const [error, setError] = (0, $acw62.useState)(null);
    const [tick, setTick] = (0, $acw62.useState)(0);
    (0, $acw62.useEffect)(()=>{
        if (!enabled) {
            setLoading(false);
            return undefined;
        }
        let live = true;
        (0, $2Mst8.bffQuery)($8a47b8f0c4c1e28f$var$DAY_VISIT_SERVICES, {
            date: dateAnchor != null ? String(dateAnchor) : null
        }).then((d)=>{
            if (!live) return;
            const m = new Map();
            for (const a of d?.appointments || [])if (a?.id) m.set(a.id, {
                services: a.services || [],
                openServices: a.openServices || 0
            });
            setByAppointment(m);
            setError(null);
        }).catch((e)=>{
            if (live) setError(e?.message || 'appointments.services');
        }).finally(()=>{
            if (live) setLoading(false);
        });
        return ()=>{
            live = false;
        };
    }, [
        dateAnchor,
        rowsKey,
        enabled,
        tick
    ]);
    const reload = (0, $acw62.useCallback)(()=>setTick((n)=>n + 1), []);
    return {
        byAppointment: byAppointment,
        loading: loading,
        error: error,
        reload: reload
    };
}

});



parcelRegister("1zLkf", function(module, exports) {

$parcel$export(module.exports, "useInsurers", () => $125dc531eea7359a$export$9d52bee92035082a);
$parcel$export(module.exports, "useInsurerName", () => $125dc531eea7359a$export$a06c3bc07cbec11);
$parcel$export(module.exports, "usePatientPolicies", () => $125dc531eea7359a$export$4c6ddae039e8b836);
$parcel$export(module.exports, "useReferralLetters", () => $125dc531eea7359a$export$51de25f43e9d49c8);
$parcel$export(module.exports, "useInsuranceContracts", () => $125dc531eea7359a$export$5f5c77cffe4ac3f7);
$parcel$export(module.exports, "useInsuranceQuote", () => $125dc531eea7359a$export$b0880ce745e20921);

var $acw62 = parcelRequire("acw62");

var $2Mst8 = parcelRequire("2Mst8");

var $1k2zw = parcelRequire("1k2zw");

var $kZuTn = parcelRequire("kZuTn");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");
/**
 * بیمه — the insurer catalog, this clinic's contracts and coverage rules, one
 * patient's policies, and the booking quote.
 *
 * The catalog is platform-owned and effectively static (a dozen rows), so it is
 * fetched once per session and shared: the registration form, the booking modal
 * and the settle drawer all need it, and three round trips for the same nine rows
 * is exactly the latency the desk cannot afford (design §NFR-3).
 *
 * Since PM-0218 the BFF answers each clinic its OWN country's catalogue and
 * «آزاد», so "once per session" is once per session per CLINIC: a user who works
 * at an Iranian and an Iraqi clinic must not be offered one's insurers at the other.
 */ const $125dc531eea7359a$var$INSURERS = `
  query Insurers {
    insurers { id nameFa nameEn kind taminCode isActive sortOrder }
  }
`;
const $125dc531eea7359a$var$PATIENT_POLICIES = `
  query PatientPolicies($patientId: ID!, $activeOnly: Boolean) {
    patientPolicies(patientId: $patientId, activeOnly: $activeOnly) {
      id patientId insurerId insurerName kind policyNumber branchCode
      validFrom validTo isPrimary verification verifiedAt verifiedSource priority
    }
  }
`;
const $125dc531eea7359a$var$SET_POLICY = `
  mutation SetPatientPolicy($input: PatientPolicyInput!) {
    setPatientPolicy(input: $input) {
      id patientId insurerId kind policyNumber branchCode isPrimary verification priority
    }
  }
`;
const $125dc531eea7359a$var$DELETE_POLICY = `
  mutation DeletePatientPolicy($policyId: ID!) {
    deletePatientPolicy(policyId: $policyId)
  }
`;
const $125dc531eea7359a$var$CONTRACTS = `
  query InsuranceContracts($currentOnly: Boolean) {
    insuranceContracts(currentOnly: $currentOnly) {
      id clinicId insurerId insurerName defaultPatientSharePct
      contractNumber effectiveFrom effectiveTo isCurrent createdAt
    }
  }
`;
const $125dc531eea7359a$var$SET_CONTRACT = `
  mutation SetInsuranceContract($insurerId: ID!, $pct: Float!, $number: String, $from: Float) {
    setInsuranceContract(
      insurerId: $insurerId, defaultPatientSharePct: $pct,
      contractNumber: $number, effectiveFrom: $from
    ) { id insurerId insurerName defaultPatientSharePct contractNumber isCurrent }
  }
`;
const $125dc531eea7359a$var$END_CONTRACT = `
  mutation EndInsuranceContract($insurerId: ID!) {
    endInsuranceContract(insurerId: $insurerId) { id insurerId effectiveTo isCurrent }
  }
`;
const $125dc531eea7359a$var$COVERAGE_RULES = `
  query CoverageRules($contractId: ID!) {
    coverageRules(contractId: $contractId) {
      currency
      id contractId catalogId itemType patientSharePct insurerCeilingRial requiresReferral
    }
  }
`;
const $125dc531eea7359a$var$SET_RULES = `
  mutation SetCoverageRules($contractId: ID!, $rules: [CoverageRuleInput!]!) {
    setCoverageRules(contractId: $contractId, rules: $rules) {
      currency
      id catalogId itemType patientSharePct insurerCeilingRial requiresReferral
    }
  }
`;
const $125dc531eea7359a$var$REORDER_POLICIES = `
  mutation ReorderPatientPolicies($patientId: ID!, $policyIds: [ID!]!) {
    reorderPatientPolicies(patientId: $patientId, policyIds: $policyIds) {
      id insurerId kind priority
    }
  }
`;
// One insurer's part of one line. Requested wherever a share is shown, because a
// bare number the operator has to take on trust is what legs exist to replace.
const $125dc531eea7359a$var$LEG_FIELDS = `
  legIndex kind insurerId insurerName policyId contractId
  patientSharePct ceilingAppliedRial referralLetterId referralLetterNumber
  shareRial computedShareRial indirectEstimateRial source
`;
const $125dc531eea7359a$var$QUOTE = `
  query InsuranceQuote(
    $patientId: ID!, $doctorId: ID, $services: [PlannedServiceInput!],
    $atTs: Float, $appointmentId: ID, $choice: VisitInsuranceChoiceInput,
    $serviceDeclarationId: ID
  ) {
    insuranceQuote(
      patientId: $patientId, doctorId: $doctorId, services: $services,
      atTs: $atTs, appointmentId: $appointmentId, choice: $choice,
      serviceDeclarationId: $serviceDeclarationId
    ) {
      currency
      totalRial insuranceShareRial patientShareRial
      insurerId insurerName supplementaryInsurerId isContracted source
      needsReferralInsurerIds
      lines {
        catalogId description quantity unitTariffRial totalRial
        insuranceShareRial patientShareRial patientSharePct covered
        coverageMode configVerdictFa indirectEstimateRial
        legs { ${$125dc531eea7359a$var$LEG_FIELDS} }
      }
    }
  }
`;
const $125dc531eea7359a$var$LETTER_FIELDS = `
  currency id clinicId patientId policyId insurerId insurerName letterNumber
  issuedAt validFrom validTo scopeCatalogIds scopeItemType
  approvedCeilingRial remainingRial patientSharePctOverride singleUse
  fileId status appointmentId consumedByInvoiceId note createdAt
`;
const $125dc531eea7359a$var$REFERRAL_LETTERS = `
  query ReferralLetters($patientId: ID, $insurerId: ID, $status: String, $appointmentId: ID) {
    referralLetters(
      patientId: $patientId, insurerId: $insurerId,
      status: $status, appointmentId: $appointmentId
    ) {
      letters { ${$125dc531eea7359a$var$LETTER_FIELDS} }
      total
    }
  }
`;
const $125dc531eea7359a$var$CREATE_LETTER = `
  mutation CreateReferralLetter($input: ReferralLetterInput!) {
    createReferralLetter(input: $input) { ${$125dc531eea7359a$var$LETTER_FIELDS} }
  }
`;
const $125dc531eea7359a$var$CANCEL_LETTER = `
  mutation CancelReferralLetter($letterId: ID!, $reason: String!) {
    cancelReferralLetter(letterId: $letterId, reason: $reason) { id status }
  }
`;
const $125dc531eea7359a$var$ATTACH_LETTER = `
  mutation AttachReferralLetter($letterId: ID!, $invoiceId: ID!) {
    attachReferralLetter(letterId: $letterId, invoiceId: $invoiceId) {
      currency
      id insuranceShare patientPayable
      lineItems { currency id insuranceShare patientPayable insuranceSource legs: insuranceLegs { ${$125dc531eea7359a$var$LEG_FIELDS} } }
    }
  }
`;
// One in-flight promise per clinic serves every caller in the session. A FAILURE
// is never cached — the next mount tries again rather than showing an empty
// select for the rest of the session.
const $125dc531eea7359a$var$insurersByClinic = new Map();
function $125dc531eea7359a$export$49ab964cf1d484ea() {
    const clinic = (0, $1k2zw.getActiveClinicRef)();
    if (!$125dc531eea7359a$var$insurersByClinic.has(clinic)) $125dc531eea7359a$var$insurersByClinic.set(clinic, (0, $2Mst8.bffQuery)($125dc531eea7359a$var$INSURERS).then((d)=>d?.insurers || []).catch((err)=>{
        $125dc531eea7359a$var$insurersByClinic.delete(clinic);
        throw err;
    }));
    return $125dc531eea7359a$var$insurersByClinic.get(clinic);
}
function $125dc531eea7359a$export$1f09299741d30a9a() {
    $125dc531eea7359a$var$insurersByClinic.clear();
}
function $125dc531eea7359a$export$9d52bee92035082a() {
    const [insurers, setInsurers] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)('');
    (0, $acw62.useEffect)(()=>{
        let alive = true;
        $125dc531eea7359a$export$49ab964cf1d484ea().then((rows)=>{
            if (alive) {
                setInsurers(rows);
                setError('');
            }
        }).catch((e)=>{
            if (alive) setError(e?.message || 'insurers');
        }).finally(()=>{
            if (alive) setLoading(false);
        });
        return ()=>{
            alive = false;
        };
    }, []);
    const byId = (0, $acw62.useCallback)((id)=>insurers.find((i)=>i.id === id) || null, [
        insurers
    ]);
    return {
        insurers: insurers,
        byId: byId,
        loading: loading,
        error: error
    };
}
function $125dc531eea7359a$export$a06c3bc07cbec11() {
    const { locale: locale } = (0, $e1LEq.default)();
    const { byId: byId } = $125dc531eea7359a$export$9d52bee92035082a();
    return (0, $acw62.useCallback)((insurerId, fallback)=>(0, $kZuTn.insurerLabel)(byId(insurerId), locale) || fallback || insurerId || '', [
        byId,
        locale
    ]);
}
function $125dc531eea7359a$export$4c6ddae039e8b836(patientId, { activeOnly: activeOnly = false } = {}) {
    const [policies, setPolicies] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(!!patientId);
    const [error, setError] = (0, $acw62.useState)('');
    const reqId = (0, $acw62.useRef)(0);
    const reload = (0, $acw62.useCallback)(async ()=>{
        if (!patientId) {
            setPolicies([]);
            setLoading(false);
            return;
        }
        const mine = ++reqId.current;
        setLoading(true);
        try {
            const d = await (0, $2Mst8.bffQuery)($125dc531eea7359a$var$PATIENT_POLICIES, {
                patientId: patientId,
                activeOnly: activeOnly
            });
            // A slower earlier request must not overwrite a newer answer.
            if (mine === reqId.current) {
                setPolicies(d?.patientPolicies || []);
                setError('');
            }
        } catch (e) {
            if (mine === reqId.current) setError(e?.message || 'policies');
        } finally{
            if (mine === reqId.current) setLoading(false);
        }
    }, [
        patientId,
        activeOnly
    ]);
    (0, $acw62.useEffect)(()=>{
        reload();
    }, [
        reload
    ]);
    const savePolicy = (0, $acw62.useCallback)(async (input)=>{
        const d = await (0, $2Mst8.bffMutation)($125dc531eea7359a$var$SET_POLICY, {
            input: {
                ...input,
                patientId: patientId
            }
        });
        await reload();
        return d?.setPatientPolicy || null;
    }, [
        patientId,
        reload
    ]);
    const removePolicy = (0, $acw62.useCallback)(async (policyId)=>{
        await (0, $2Mst8.bffMutation)($125dc531eea7359a$var$DELETE_POLICY, {
            policyId: policyId
        });
        await reload();
    }, [
        reload
    ]);
    const reorder = (0, $acw62.useCallback)(async (policyIds)=>{
        await (0, $2Mst8.bffMutation)($125dc531eea7359a$var$REORDER_POLICIES, {
            patientId: patientId,
            policyIds: policyIds
        });
        await reload();
    }, [
        patientId,
        reload
    ]);
    const basic = policies.find((p)=>p.kind === 'basic' && p.isPrimary) || null;
    // EVERY supplementary, in the order they are applied. They pay in sequence,
    // each on what the previous one left, so a screen that reads only the first
    // silently shows the patient fewer insurers than they hold.
    const supplementaries = policies.filter((p)=>p.kind === 'supplementary').sort((a, b)=>(a.priority || 0) - (b.priority || 0));
    return {
        policies: policies,
        basic: basic,
        supplementaries: supplementaries,
        // DEPRECATED — the first supplementary, for a caller that predates the list.
        supplementary: supplementaries[0] || null,
        loading: loading,
        error: error,
        reload: reload,
        savePolicy: savePolicy,
        removePolicy: removePolicy,
        reorder: reorder
    };
}
function $125dc531eea7359a$export$51de25f43e9d49c8(patientId, { status: status, appointmentId: appointmentId, enabled: enabled = true } = {}) {
    const [letters, setLetters] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)('');
    const reqId = (0, $acw62.useRef)(0);
    const reload = (0, $acw62.useCallback)(async ()=>{
        if (!enabled || !patientId) {
            setLetters([]);
            setLoading(false);
            return;
        }
        const mine = ++reqId.current;
        setLoading(true);
        try {
            const d = await (0, $2Mst8.bffQuery)($125dc531eea7359a$var$REFERRAL_LETTERS, {
                patientId: patientId,
                status: status || null,
                appointmentId: appointmentId || null
            });
            if (mine === reqId.current) {
                setLetters(d?.referralLetters?.letters || []);
                setError('');
            }
        } catch (e) {
            if (mine === reqId.current) setError(e?.message || 'letters');
        } finally{
            if (mine === reqId.current) setLoading(false);
        }
    }, [
        patientId,
        status,
        appointmentId,
        enabled
    ]);
    (0, $acw62.useEffect)(()=>{
        reload();
    }, [
        reload
    ]);
    const create = (0, $acw62.useCallback)(async (input)=>{
        const d = await (0, $2Mst8.bffMutation)($125dc531eea7359a$var$CREATE_LETTER, {
            input: {
                ...input,
                patientId: patientId
            }
        });
        await reload();
        return d?.createReferralLetter || null;
    }, [
        patientId,
        reload
    ]);
    const cancel = (0, $acw62.useCallback)(async (letterId, reason)=>{
        await (0, $2Mst8.bffMutation)($125dc531eea7359a$var$CANCEL_LETTER, {
            letterId: letterId,
            reason: reason
        });
        await reload();
    }, [
        reload
    ]);
    // Returns the RE-PRICED invoice: the letter only matters through the numbers
    // it changes, and the screen that attached it is waiting to show them.
    const attach = (0, $acw62.useCallback)(async (letterId, invoiceId)=>{
        const d = await (0, $2Mst8.bffMutation)($125dc531eea7359a$var$ATTACH_LETTER, {
            letterId: letterId,
            invoiceId: invoiceId
        });
        await reload();
        return d?.attachReferralLetter || null;
    }, [
        reload
    ]);
    return {
        letters: letters,
        loading: loading,
        error: error,
        reload: reload,
        create: create,
        cancel: cancel,
        attach: attach
    };
}
function $125dc531eea7359a$export$5f5c77cffe4ac3f7({ currentOnly: currentOnly = false } = {}) {
    const [contracts, setContracts] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)('');
    const reload = (0, $acw62.useCallback)(async ()=>{
        setLoading(true);
        try {
            const d = await (0, $2Mst8.bffQuery)($125dc531eea7359a$var$CONTRACTS, {
                currentOnly: currentOnly
            });
            setContracts(d?.insuranceContracts || []);
            setError('');
        } catch (e) {
            setError(e?.message || 'contracts');
        } finally{
            setLoading(false);
        }
    }, [
        currentOnly
    ]);
    (0, $acw62.useEffect)(()=>{
        reload();
    }, [
        reload
    ]);
    const saveContract = (0, $acw62.useCallback)(async ({ insurerId: insurerId, pct: pct, number: number, from: from })=>{
        const d = await (0, $2Mst8.bffMutation)($125dc531eea7359a$var$SET_CONTRACT, {
            insurerId: insurerId,
            pct: Number(pct),
            number: number || null,
            from: from || null
        });
        await reload();
        return d?.setInsuranceContract || null;
    }, [
        reload
    ]);
    const endContract = (0, $acw62.useCallback)(async (insurerId)=>{
        await (0, $2Mst8.bffMutation)($125dc531eea7359a$var$END_CONTRACT, {
            insurerId: insurerId
        });
        await reload();
    }, [
        reload
    ]);
    const loadRules = (0, $acw62.useCallback)(async (contractId)=>{
        const d = await (0, $2Mst8.bffQuery)($125dc531eea7359a$var$COVERAGE_RULES, {
            contractId: contractId
        });
        return d?.coverageRules || [];
    }, []);
    const saveRules = (0, $acw62.useCallback)(async (contractId, rules)=>{
        const d = await (0, $2Mst8.bffMutation)($125dc531eea7359a$var$SET_RULES, {
            contractId: contractId,
            rules: (rules || []).map((r)=>({
                    id: r.id || null,
                    catalogId: r.catalogId || null,
                    itemType: r.itemType || null,
                    patientSharePct: Number(r.patientSharePct) || 0,
                    insurerCeilingRial: r.insurerCeilingRial ? Number(r.insurerCeilingRial) : null,
                    requiresReferral: !!r.requiresReferral
                }))
        });
        return d?.setCoverageRules || [];
    }, []);
    return {
        contracts: contracts,
        loading: loading,
        error: error,
        reload: reload,
        saveContract: saveContract,
        endContract: endContract,
        loadRules: loadRules,
        saveRules: saveRules
    };
}
function $125dc531eea7359a$export$b0880ce745e20921({ patientId: patientId, doctorId: doctorId, services: services, atTs: atTs, appointmentId: appointmentId, choice: choice, serviceDeclarationId: serviceDeclarationId = null, enabled: enabled = true }) {
    const [quote, setQuote] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const reqId = (0, $acw62.useRef)(0);
    const key = JSON.stringify({
        patientId: patientId,
        doctorId: doctorId,
        services: services,
        atTs: atTs,
        appointmentId: appointmentId,
        choice: choice,
        serviceDeclarationId: serviceDeclarationId
    });
    (0, $acw62.useEffect)(()=>{
        if (!enabled || !patientId) {
            setQuote(null);
            return undefined;
        }
        const mine = ++reqId.current;
        setLoading(true);
        const timer = setTimeout(()=>{
            (0, $2Mst8.bffQuery)($125dc531eea7359a$var$QUOTE, {
                patientId: patientId,
                doctorId: doctorId,
                services: services,
                atTs: atTs,
                appointmentId: appointmentId,
                choice: choice || null,
                // The PRIMARY service, so the preview is the whole bill and not only the
                // extras beside it (§S1).
                serviceDeclarationId: serviceDeclarationId || null
            }).then((d)=>{
                if (mine === reqId.current) setQuote(d?.insuranceQuote || null);
            })// A quote is advisory: its failure must never block a booking, so the
            // chip and the split simply do not appear.
            .catch(()=>{
                if (mine === reqId.current) setQuote(null);
            }).finally(()=>{
                if (mine === reqId.current) setLoading(false);
            });
        }, 250);
        return ()=>{
            clearTimeout(timer);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        key,
        enabled
    ]);
    return {
        quote: quote,
        loading: loading
    };
}

});
parcelRegister("kZuTn", function(module, exports) {

$parcel$export(module.exports, "SOURCE", () => $f48177b73abb9149$export$83c8d7110915321e);
$parcel$export(module.exports, "COVERAGE", () => $f48177b73abb9149$export$7087ea2fab3dc6a9);
$parcel$export(module.exports, "CALC_MODE", () => $f48177b73abb9149$export$dc9a5db8b923588a);
$parcel$export(module.exports, "INDIRECT_DOC", () => $f48177b73abb9149$export$62cc5a33f616bd18);
$parcel$export(module.exports, "MULTI_RULE", () => $f48177b73abb9149$export$9de2f971ca5001c9);
$parcel$export(module.exports, "DEFAULT_SERVICE_INSURANCE", () => $f48177b73abb9149$export$28571ca881c6f03c);
$parcel$export(module.exports, "SELF_PAY_INSURER_ID", () => $f48177b73abb9149$export$695f4d9e03f36210);
$parcel$export(module.exports, "isBasic", () => $f48177b73abb9149$export$6ceb43c43b4a929b);
$parcel$export(module.exports, "registrationInsurers", () => $f48177b73abb9149$export$1ccfab540f8b88b0);
$parcel$export(module.exports, "insurerFromSpeech", () => $f48177b73abb9149$export$e3e2f1f4dbac5dec);
$parcel$export(module.exports, "lineInsuranceState", () => $f48177b73abb9149$export$5e20eda0ace6694a);
$parcel$export(module.exports, "legsOf", () => $f48177b73abb9149$export$350b0877c689e2df);
$parcel$export(module.exports, "needsReferral", () => $f48177b73abb9149$export$e5460c937b20f7e9);
$parcel$export(module.exports, "indirectEstimateOf", () => $f48177b73abb9149$export$ea0f55131786533f);
$parcel$export(module.exports, "explainLegs", () => $f48177b73abb9149$export$8f0aebfa1283b7bd);
$parcel$export(module.exports, "LETTER_STATUS", () => $f48177b73abb9149$export$9181fc2289820525);
$parcel$export(module.exports, "letterValidity", () => $f48177b73abb9149$export$d6916ea2489cbb75);
$parcel$export(module.exports, "validateReferralLetter", () => $f48177b73abb9149$export$649a00931f2bd448);
$parcel$export(module.exports, "toServiceInsuranceInput", () => $f48177b73abb9149$export$bd977af047d90a93);
$parcel$export(module.exports, "validateServiceInsurance", () => $f48177b73abb9149$export$82a47dfef227ef23);
$parcel$export(module.exports, "previewSplit", () => $f48177b73abb9149$export$98dd064067230373);
$parcel$export(module.exports, "CLAIM_STATUSES", () => $f48177b73abb9149$export$a324fc46a09d7f77);
$parcel$export(module.exports, "isSubmittable", () => $f48177b73abb9149$export$dad0fdafee36dcd);
$parcel$export(module.exports, "shortfallOf", () => $f48177b73abb9149$export$8f4ba25b775db7ff);
$parcel$export(module.exports, "needsDisposition", () => $f48177b73abb9149$export$54f77af4b69a6a9e);
$parcel$export(module.exports, "insurerLabel", () => $f48177b73abb9149$export$89f0136091c5d164);
$parcel$export(module.exports, "resolveInsurer", () => $f48177b73abb9149$export$77f3f6b697dd296d);

var $6P09x = parcelRequire("6P09x");
parcelRequire("7c6z4");
var $cMRsf = parcelRequire("cMRsf");

var $h10NT = parcelRequire("h10NT");
const $f48177b73abb9149$export$83c8d7110915321e = {
    NONE: 'NONE',
    COMPUTED: 'COMPUTED',
    MANUAL: 'MANUAL',
    UNAVAILABLE: 'UNAVAILABLE',
    // Three ANSWERS, each with a different thing for the desk to do: register the
    // letter, hand the patient a reimbursement document, or stop asking.
    NEEDS_REFERRAL: 'NEEDS_REFERRAL',
    INDIRECT: 'INDIRECT',
    NOT_COVERED: 'NOT_COVERED'
};
const $f48177b73abb9149$export$7087ea2fab3dc6a9 = {
    NOT_COVERED: 'NOT_COVERED',
    DIRECT: 'DIRECT',
    INDIRECT: 'INDIRECT'
};
const $f48177b73abb9149$export$dc9a5db8b923588a = {
    CONTRACT: 'CONTRACT',
    FIXED_PATIENT_PCT: 'FIXED_PATIENT_PCT',
    FIXED_INSURER_AMOUNT: 'FIXED_INSURER_AMOUNT'
};
const $f48177b73abb9149$export$62cc5a33f616bd18 = {
    NONE: 'NONE',
    RECEIPT: 'RECEIPT',
    CLINIC_LETTER: 'CLINIC_LETTER'
};
const $f48177b73abb9149$export$9de2f971ca5001c9 = {
    CHAIN: 'CHAIN',
    BASIC_ONLY: 'BASIC_ONLY',
    SUPPLEMENTARY_ONLY: 'SUPPLEMENTARY_ONLY',
    FIRST_COVERING: 'FIRST_COVERING'
};
const $f48177b73abb9149$export$28571ca881c6f03c = {
    coverageMode: $f48177b73abb9149$export$7087ea2fab3dc6a9.DIRECT,
    acceptedBasicInsurerIds: [],
    allowSupplementary: true,
    acceptedSupplementaryInsurerIds: [],
    calcMode: $f48177b73abb9149$export$dc9a5db8b923588a.CONTRACT,
    patientSharePct: null,
    insurerAmountRial: null,
    insurerCeilingRial: 0,
    maxQuantityPerVisit: 0,
    minDaysBetween: 0,
    requiresDoctorOrder: false,
    conditionsFa: '',
    referralRequiredDirect: false,
    indirectDocument: $f48177b73abb9149$export$62cc5a33f616bd18.RECEIPT,
    multiInsurerRule: $f48177b73abb9149$export$9de2f971ca5001c9.CHAIN
};
const $f48177b73abb9149$export$695f4d9e03f36210 = 'azad';
const $f48177b73abb9149$export$6ceb43c43b4a929b = (insurer)=>(insurer?.kind || 'BASIC') === 'BASIC';
const $f48177b73abb9149$export$cae76ed7a992e16a = (insurer)=>insurer?.kind === 'SUPPLEMENTARY';
const $f48177b73abb9149$export$733e10a8abd8dce5 = (insurer)=>!!insurer?.isSelfPay || insurer?.id === $f48177b73abb9149$export$695f4d9e03f36210;
// The insurance catalogue that is Iran's (accounting `insurers.country`, PM-0218).
const $f48177b73abb9149$var$IRAN_CATALOGUE = 'IR';
const $f48177b73abb9149$export$1ccfab540f8b88b0 = (insurers, { iran: iran = true, insuranceCatalog: insuranceCatalog } = {})=>{
    const list = insurers || [];
    if (insuranceCatalog === undefined || insuranceCatalog === $f48177b73abb9149$var$IRAN_CATALOGUE) return iran ? list : list.filter($f48177b73abb9149$export$733e10a8abd8dce5);
    return insuranceCatalog ? list : list.filter($f48177b73abb9149$export$733e10a8abd8dce5);
};
/**
 * The catalog id a DICTATED insurer means, or '' when it names none this clinic
 * offers (PM-0129).
 *
 * The voice service answers in its own vocabulary — social | health | military |
 * other — which the doctor's kit reads as-is, so it stays. The clinic's insurer is
 * a catalog id, and the two never met: a dictated «تأمین اجتماعی» set
 * `insurer = 'social'`, no card lit up, and the policy write after registration was
 * refused for an insurer id that does not exist — the patient was registered with
 * no insurance, and nobody was told. A model that answers with the Persian name
 * instead of the word it was asked for is read the same way.
 *
 * `offered` (optional) is the list the form shows — registrationInsurers() — so a
 * clinic abroad, which offers self-pay alone, never gets a تأمین card filled in.
 */ const $f48177b73abb9149$var$VOICE_INSURER_WORD = {
    social: 'tamin',
    health: 'salamat',
    military: 'armed',
    other: $f48177b73abb9149$export$695f4d9e03f36210,
    // The catalog's own ids, should the model answer with one.
    tamin: 'tamin',
    salamat: 'salamat',
    armed: 'armed',
    [$f48177b73abb9149$export$695f4d9e03f36210]: $f48177b73abb9149$export$695f4d9e03f36210
};
// Matched on foldInsurerName's spelling: أ/إ/آ → ا, ي → ی, ك → ک.
// i18n-exempt: the words a dictation is matched against, never rendered.
const $f48177b73abb9149$var$SPOKEN_INSURER_NAME = [
    [
        /تامین/,
        'tamin'
    ],
    [
        /سلامت/,
        'salamat'
    ],
    [
        /نیروهای مسلح|ارتش|سپاه/,
        'armed'
    ],
    [
        /ازاد|خصوصی/,
        $f48177b73abb9149$export$695f4d9e03f36210
    ]
];
function $f48177b73abb9149$export$e3e2f1f4dbac5dec(word, offered = null) {
    const said = $f48177b73abb9149$var$foldInsurerName(word);
    if (!said) return '';
    const id = $f48177b73abb9149$var$VOICE_INSURER_WORD[said] || $f48177b73abb9149$var$SPOKEN_INSURER_NAME.find(([re])=>re.test(said))?.[1] || '';
    if (!id) return '';
    if (offered && offered.length && !offered.some((ins)=>ins.id === id)) return '';
    return id;
}
function $f48177b73abb9149$export$4c9fbcca9958b515(insurers, t) {
    const list = (insurers || []).filter((i)=>i.isActive !== false);
    return [
        {
            label: t('insurance.groups.basic'),
            options: list.filter($f48177b73abb9149$export$6ceb43c43b4a929b)
        },
        {
            label: t('insurance.groups.supplementary'),
            options: list.filter($f48177b73abb9149$export$cae76ed7a992e16a)
        }
    ].filter((g)=>g.options.length);
}
const $f48177b73abb9149$export$21f330750a4ba9e0 = (insurer)=>!!insurer?.taminCode;
function $f48177b73abb9149$export$5e20eda0ace6694a(line) {
    if (!line) return $f48177b73abb9149$export$83c8d7110915321e.NONE;
    const src = line.insuranceSource || $f48177b73abb9149$export$83c8d7110915321e.NONE;
    if (src === $f48177b73abb9149$export$83c8d7110915321e.MANUAL) return $f48177b73abb9149$export$83c8d7110915321e.MANUAL;
    if (src === $f48177b73abb9149$export$83c8d7110915321e.UNAVAILABLE) return $f48177b73abb9149$export$83c8d7110915321e.UNAVAILABLE;
    if ((line.insuranceShare || 0) > 0) return $f48177b73abb9149$export$83c8d7110915321e.COMPUTED;
    // Nothing was deducted — but WHY differs, and each answer sends the desk
    // somewhere different. Ordered by what can still be fixed today.
    for (const answer of [
        $f48177b73abb9149$export$83c8d7110915321e.INDIRECT,
        $f48177b73abb9149$export$83c8d7110915321e.NEEDS_REFERRAL,
        $f48177b73abb9149$export$83c8d7110915321e.NOT_COVERED
    ]){
        if (src === answer) return answer;
        if ((line.insuranceLegs || []).some((leg)=>leg.source === answer)) return answer;
    }
    return $f48177b73abb9149$export$83c8d7110915321e.NONE;
}
const $f48177b73abb9149$export$350b0877c689e2df = (line)=>[
        ...line?.insuranceLegs || []
    ].sort((a, b)=>(a.legIndex || 0) - (b.legIndex || 0));
const $f48177b73abb9149$export$b4ee72269f78a18f = (line)=>$f48177b73abb9149$export$350b0877c689e2df(line).filter((leg)=>(leg.shareRial || 0) > 0);
const $f48177b73abb9149$export$e5460c937b20f7e9 = (line)=>$f48177b73abb9149$export$350b0877c689e2df(line).some((leg)=>leg.source === $f48177b73abb9149$export$83c8d7110915321e.NEEDS_REFERRAL);
const $f48177b73abb9149$export$ea0f55131786533f = (line)=>Number(line?.indirectEstimateRial || 0) || $f48177b73abb9149$export$350b0877c689e2df(line).reduce((sum, leg)=>sum + (leg.indirectEstimateRial || 0), 0);
function $f48177b73abb9149$export$9858a201f7dadf6d(line, { insurerName: insurerName, t: t }) {
    const lines = $f48177b73abb9149$export$8f0aebfa1283b7bd(line, {
        insurerName: insurerName,
        t: t
    });
    return lines.length ? lines.join(" \xb7 ") : null;
}
function $f48177b73abb9149$export$8f0aebfa1283b7bd(line, { insurerName: insurerName, t: t, fmtMoney: fmtMoney, nameOf: nameOf } = {}) {
    if (!line || !t) return [];
    const name = nameOf || ((id, fallback)=>fallback || id);
    const state = $f48177b73abb9149$export$5e20eda0ace6694a(line);
    if (state === $f48177b73abb9149$export$83c8d7110915321e.MANUAL) return [
        t('insurance.explain.manual', {
            reason: line.insuranceOverrideReason || t('insurance.explain.noReason')
        })
    ];
    if (state === $f48177b73abb9149$export$83c8d7110915321e.UNAVAILABLE) return [
        t('insurance.explain.unavailable')
    ];
    if (state === $f48177b73abb9149$export$83c8d7110915321e.NOT_COVERED) return [
        t('insurance.explain.notCovered')
    ];
    const legs = $f48177b73abb9149$export$350b0877c689e2df(line);
    if (!legs.length) {
        // A line billed before legs existed, or by the legacy desk path: the scalar
        // snapshot is all there is, and it describes one insurer.
        if (state === $f48177b73abb9149$export$83c8d7110915321e.NONE) return [];
        const parts = [
            name(line.insurerId, insurerName)
        ];
        if (line.patientSharePct != null && line.patientSharePct > 0) parts.push(t('insurance.explain.franchise', {
            pct: line.patientSharePct
        }));
        return [
            parts.filter(Boolean).join(" \xb7 ")
        ];
    }
    return legs.map((leg)=>{
        const parts = [
            name(leg.insurerId, leg.insurerName)
        ];
        if (leg.source === $f48177b73abb9149$export$83c8d7110915321e.NEEDS_REFERRAL) {
            parts.push(t('insurance.explain.needsReferral'));
            return parts.join(" \xb7 ");
        }
        if (!leg.contractId) {
            parts.push(t('insurance.explain.notContracted'));
            return parts.join(" \xb7 ");
        }
        if (leg.patientSharePct != null && leg.patientSharePct > 0) parts.push(t('insurance.explain.franchise', {
            pct: leg.patientSharePct
        }));
        if (leg.referralLetterNumber) parts.push(t('insurance.explain.letter', {
            number: leg.referralLetterNumber
        }));
        if (leg.ceilingAppliedRial > 0) parts.push(t('insurance.explain.ceiling'));
        if (leg.source === $f48177b73abb9149$export$83c8d7110915321e.INDIRECT) {
            parts.push(t('insurance.explain.indirect'));
            if (fmtMoney && leg.indirectEstimateRial > 0) parts.push(fmtMoney(leg.indirectEstimateRial));
            return parts.join(" \xb7 ");
        }
        if (fmtMoney && (leg.shareRial || 0) > 0) parts.push(fmtMoney(leg.shareRial));
        if ((leg.shareRial || 0) === 0) parts.push(t('insurance.explain.paidNothing'));
        return parts.join(" \xb7 ");
    });
}
const $f48177b73abb9149$export$9181fc2289820525 = {
    ACTIVE: 'active',
    CONSUMED: 'consumed',
    EXPIRED: 'expired',
    CANCELLED: 'cancelled'
};
function $f48177b73abb9149$export$d6916ea2489cbb75(letter, atMs = Date.now()) {
    if (!letter) return $f48177b73abb9149$export$9181fc2289820525.CANCELLED;
    if (letter.status && letter.status !== $f48177b73abb9149$export$9181fc2289820525.ACTIVE) return letter.status;
    if (letter.validTo && atMs > letter.validTo) return $f48177b73abb9149$export$9181fc2289820525.EXPIRED;
    if (letter.validFrom && atMs < letter.validFrom) return 'notYet';
    // A capped letter with nothing left cannot authorise anything more.
    if (letter.approvedCeilingRial > 0 && !(letter.remainingRial > 0)) return $f48177b73abb9149$export$9181fc2289820525.CONSUMED;
    return $f48177b73abb9149$export$9181fc2289820525.ACTIVE;
}
const $f48177b73abb9149$export$1093ba62cf5ead5d = (letter, atMs)=>$f48177b73abb9149$export$d6916ea2489cbb75(letter, atMs) === $f48177b73abb9149$export$9181fc2289820525.ACTIVE;
function $f48177b73abb9149$export$649a00931f2bd448(t, input = {}) {
    if (!input.policyId) return t('insurance.letter.errors.policy');
    if (!String(input.letterNumber || '').trim()) return t('insurance.letter.errors.number');
    if (String(input.letterNumber).trim().length > 64) return t('insurance.letter.errors.numberLong');
    if (!input.validFrom || !input.validTo) return t('insurance.letter.errors.window');
    if (Number(input.validFrom) > Number(input.validTo)) return t('insurance.letter.errors.window');
    if (Number(input.approvedCeilingRial || 0) < 0) return t('insurance.letter.errors.ceiling');
    const pct = input.patientSharePctOverride;
    if (pct != null && pct !== '' && (Number(pct) < 0 || Number(pct) > 100)) return t('insurance.letter.errors.pct');
    // Either a list of services or one item type — a letter cannot be scoped both
    // ways, and the service refuses it.
    if ((input.scopeCatalogIds || []).length && input.scopeItemType) return t('insurance.letter.errors.scope');
    return null;
}
function $f48177b73abb9149$export$bd977af047d90a93(cfg) {
    const c = {
        ...$f48177b73abb9149$export$28571ca881c6f03c,
        ...cfg || {}
    };
    return {
        coverageMode: c.coverageMode,
        acceptedBasicInsurerIds: c.acceptedBasicInsurerIds || [],
        allowSupplementary: c.allowSupplementary !== false,
        acceptedSupplementaryInsurerIds: c.acceptedSupplementaryInsurerIds || [],
        calcMode: c.calcMode,
        // Only meaningful to the mode that uses it, and the server refuses a mode
        // without its value — so an unused one is sent as null rather than as 0,
        // which would read as a real «فرانشیز ۰٪».
        patientSharePct: c.calcMode === $f48177b73abb9149$export$dc9a5db8b923588a.FIXED_PATIENT_PCT && c.patientSharePct != null ? Number(c.patientSharePct) : null,
        insurerAmountRial: c.calcMode === $f48177b73abb9149$export$dc9a5db8b923588a.FIXED_INSURER_AMOUNT && c.insurerAmountRial != null ? Number(c.insurerAmountRial) : null,
        insurerCeilingRial: Number(c.insurerCeilingRial || 0),
        maxQuantityPerVisit: Number(c.maxQuantityPerVisit || 0),
        minDaysBetween: Number(c.minDaysBetween || 0),
        requiresDoctorOrder: !!c.requiresDoctorOrder,
        conditionsFa: c.conditionsFa || null,
        referralRequiredDirect: !!c.referralRequiredDirect,
        indirectDocument: c.indirectDocument,
        multiInsurerRule: c.multiInsurerRule
    };
}
function $f48177b73abb9149$export$82a47dfef227ef23(t, cfg = {}) {
    if (!Object.values($f48177b73abb9149$export$7087ea2fab3dc6a9).includes(cfg.coverageMode)) return t('insurance.config.errors.coverageMode');
    if (cfg.coverageMode === $f48177b73abb9149$export$7087ea2fab3dc6a9.NOT_COVERED) return null;
    if (cfg.calcMode === $f48177b73abb9149$export$dc9a5db8b923588a.FIXED_PATIENT_PCT) {
        const pct = Number(cfg.patientSharePct);
        if (cfg.patientSharePct == null || cfg.patientSharePct === '' || Number.isNaN(pct)) return t('insurance.config.errors.pctRequired');
        if (pct < 0 || pct > 100) return t('insurance.config.errors.pctRange');
    }
    if (cfg.calcMode === $f48177b73abb9149$export$dc9a5db8b923588a.FIXED_INSURER_AMOUNT) {
        const amount = Number(cfg.insurerAmountRial);
        if (cfg.insurerAmountRial == null || cfg.insurerAmountRial === '' || Number.isNaN(amount)) return t('insurance.config.errors.amountRequired');
        if (amount < 0) return t('insurance.config.errors.amountNegative');
    }
    if (Number(cfg.insurerCeilingRial || 0) < 0) return t('insurance.config.errors.ceiling');
    if (Number(cfg.maxQuantityPerVisit || 0) < 0) return t('insurance.config.errors.quantity');
    if (Number(cfg.minDaysBetween || 0) < 0) return t('insurance.config.errors.days');
    return null;
}
function $f48177b73abb9149$export$98dd064067230373(cfg, { legs: legs = [], unitRial: unitRial = 0, quantity: quantity = 1 } = {}) {
    const config = {
        ...$f48177b73abb9149$export$28571ca881c6f03c,
        ...cfg || {}
    };
    const qty = Math.max(1, Number(quantity) || 1);
    const base = Math.max(0, Math.round(Number(unitRial) || 0) * qty);
    const out = {
        total: base,
        insurance: 0,
        patient: base,
        indirect: 0,
        legs: []
    };
    if (!base || config.coverageMode === $f48177b73abb9149$export$7087ea2fab3dc6a9.NOT_COVERED) return out;
    const coveredQty = config.maxQuantityPerVisit > 0 ? Math.min(qty, config.maxQuantityPerVisit) : qty;
    let remainder = coveredQty >= qty ? base : Math.round(base * coveredQty / qty);
    for (const leg of legs){
        const isBasic = leg.kind !== 'SUPPLEMENTARY';
        const allowed = isBasic ? config.multiInsurerRule !== $f48177b73abb9149$export$9de2f971ca5001c9.SUPPLEMENTARY_ONLY && (!config.acceptedBasicInsurerIds.length || config.acceptedBasicInsurerIds.includes(leg.insurerId)) : config.allowSupplementary && config.multiInsurerRule !== $f48177b73abb9149$export$9de2f971ca5001c9.BASIC_ONLY && (!config.acceptedSupplementaryInsurerIds.length || config.acceptedSupplementaryInsurerIds.includes(leg.insurerId));
        if (!allowed) {
            out.legs.push({
                ...leg,
                share: 0,
                reason: 'excluded'
            });
            continue;
        }
        if (!isBasic && config.referralRequiredDirect) {
            out.legs.push({
                ...leg,
                share: 0,
                reason: 'needsReferral'
            });
            continue;
        }
        const pct = config.calcMode === $f48177b73abb9149$export$dc9a5db8b923588a.FIXED_PATIENT_PCT ? Number(config.patientSharePct || 0) : Number(leg.patientSharePct || 0);
        let share = config.calcMode === $f48177b73abb9149$export$dc9a5db8b923588a.FIXED_INSURER_AMOUNT ? Math.round(Number(config.insurerAmountRial || 0)) * coveredQty : Math.round(remainder * (100 - pct) / 100);
        if (config.insurerCeilingRial > 0) share = Math.min(share, config.insurerCeilingRial * coveredQty);
        share = Math.max(0, Math.min(share, remainder));
        if (config.coverageMode === $f48177b73abb9149$export$7087ea2fab3dc6a9.INDIRECT) {
            out.indirect += share;
            out.legs.push({
                ...leg,
                share: 0,
                estimate: share,
                reason: 'indirect'
            });
            remainder -= share;
            continue;
        }
        remainder -= share;
        out.insurance += share;
        out.legs.push({
            ...leg,
            share: share
        });
        if (config.multiInsurerRule === $f48177b73abb9149$export$9de2f971ca5001c9.FIRST_COVERING && share > 0) break;
    }
    out.patient = base - out.insurance;
    return out;
}
const $f48177b73abb9149$export$75d20f37d69e6663 = (line)=>Math.max(0, (line?.totalAmount || 0) - (line?.discount || 0) - (line?.insuranceShare || 0));
const $f48177b73abb9149$export$5a8e4abdda49ec8d = (invoice)=>(invoice?.lineItems || []).reduce((sum, li)=>sum + (li.insuranceShare || 0), 0);
function $f48177b73abb9149$export$7ae99ef19ff0279(quote) {
    if (!quote) return 'none';
    if (quote.source === $f48177b73abb9149$export$83c8d7110915321e.UNAVAILABLE) return 'unavailable';
    if (!quote.insurerId) return 'none';
    return quote.isContracted ? 'contracted' : 'uncontracted';
}
const $f48177b73abb9149$export$a324fc46a09d7f77 = [
    'DRAFT',
    'SUBMITTED',
    'ACCEPTED',
    'PARTIALLY_PAID',
    'PAID',
    'REJECTED',
    'WRITTEN_OFF',
    'CANCELLED'
];
const $f48177b73abb9149$export$dad0fdafee36dcd = (claim)=>claim?.status === 'DRAFT';
const $f48177b73abb9149$export$33c4fe634ab6b049 = (claim)=>[
        'PAID',
        'WRITTEN_OFF',
        'CANCELLED'
    ].includes(claim?.status);
const $f48177b73abb9149$export$8f4ba25b775db7ff = (claim)=>Math.max(0, (claim?.claimedRial || 0) - (claim?.paidRial || 0));
const $f48177b73abb9149$export$54f77af4b69a6a9e = (claim)=>$f48177b73abb9149$export$8f4ba25b775db7ff(claim) > 0 && [
        'PARTIALLY_PAID',
        'REJECTED'
    ].includes(claim?.status) && !claim?.shortfallDisposition;
function $f48177b73abb9149$export$89f0136091c5d164(insurer, locale) {
    if (!insurer) return '';
    const persian = (0, $cMRsf.localeDescriptor)(locale).readsPersianData === true;
    const lang = String(locale || '').split('-')[0];
    const own = persian ? insurer.nameFa : (0, (/*@__PURE__*/$parcel$interopDefault($h10NT)))[lang]?.[insurer.id] || insurer.nameEn;
    return own || insurer.nameFa || insurer.nameEn || insurer.id || '';
}
function $f48177b73abb9149$export$77f3f6b697dd296d(value, insurers) {
    const key = $f48177b73abb9149$var$foldInsurerName(value);
    if (!key) return null;
    const list = insurers || [];
    const hit = list.find((i)=>$f48177b73abb9149$var$foldInsurerName(i.id) === key) || list.find((i)=>$f48177b73abb9149$var$foldInsurerName(i.nameFa) === key) || list.find((i)=>$f48177b73abb9149$var$foldInsurerName(i.nameEn) === key);
    if (hit) return hit;
    const legacyId = (0, $6P09x.insurerIdFromLegacy)(value);
    return legacyId ? list.find((i)=>i.id === legacyId) || null : null;
}
// Fold a name to something comparable: case, the Arabic/Persian letter pairs that
// look identical and compare differently, the zero-width marks, and every separator.
//
// i18n-exempt: a PARSER. These letters are folded, never rendered.
function $f48177b73abb9149$var$foldInsurerName(value) {
    return String(value ?? '').toLowerCase().replace(/[\u200b-\u200f]/g, '').replace(/[أإآ]/g, "\u0627").replace(/ي/g, "\u06CC").replace(/ك/g, "\u06A9").replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
}

});
parcelRegister("h10NT", function(module, exports) {
module.exports = JSON.parse('{"ar":{"tamin":"\u0627\u0644\u062A\u0623\u0645\u064A\u0646 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639\u064A","salamat":"\u0627\u0644\u062A\u0623\u0645\u064A\u0646 \u0627\u0644\u0635\u062D\u064A (\u0633\u0644\u0627\u0645\u062A)","armed":"\u062A\u0623\u0645\u064A\u0646 \u0627\u0644\u0642\u0648\u0627\u062A \u0627\u0644\u0645\u0633\u0644\u062D\u0629","azad":"\u062F\u0641\u0639 \u0630\u0627\u062A\u064A","dana":"\u062A\u0623\u0645\u064A\u0646 \u062F\u0627\u0646\u0627","asia":"\u062A\u0623\u0645\u064A\u0646 \u0622\u0633\u064A\u0627","alborz":"\u062A\u0623\u0645\u064A\u0646 \u0627\u0644\u0628\u0631\u0632","parsian":"\u062A\u0623\u0645\u064A\u0646 \u0628\u0627\u0631\u0633\u064A\u0627\u0646","moalem":"\u062A\u0623\u0645\u064A\u0646 \u0627\u0644\u0645\u0639\u0644\u0645","kowsar":"\u062A\u0623\u0645\u064A\u0646 \u0643\u0648\u062B\u0631","ma":"\u062A\u0623\u0645\u064A\u0646 \u0645\u0627","sina":"\u062A\u0623\u0645\u064A\u0646 \u0633\u064A\u0646\u0627","razi":"\u062A\u0623\u0645\u064A\u0646 \u0631\u0627\u0632\u064A"},"fr":{"tamin":"S\xe9curit\xe9 sociale (Tamin)","salamat":"Salamat (assurance sant\xe9)","armed":"Forces arm\xe9es","azad":"Sans assurance","dana":"Assurance Dana","asia":"Assurance Asia","alborz":"Assurance Alborz","parsian":"Assurance Parsian","moalem":"Assurance Moallem","kowsar":"Assurance Kowsar","ma":"Assurance Ma","sina":"Assurance Sina","razi":"Assurance Razi"},"de":{"tamin":"Tamin (Sozialversicherung)","salamat":"Salamat (Krankenversicherung)","armed":"Streitkr\xe4fte","azad":"Selbstzahler","dana":"Dana-Versicherung","asia":"Asia-Versicherung","alborz":"Alborz-Versicherung","parsian":"Parsian-Versicherung","moalem":"Moallem-Versicherung","kowsar":"Kowsar-Versicherung","ma":"Ma-Versicherung","sina":"Sina-Versicherung","razi":"Razi-Versicherung"}}');

});



parcelRegister("9qvnH", function(module, exports) {

$parcel$export(module.exports, "useClinicRegion", () => $6dcee2702b15fb68$export$88cfbb9124a0950e);

var $acw62 = parcelRequire("acw62");

var $eLeza = parcelRequire("eLeza");

var $2Mst8 = parcelRequire("2Mst8");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $ett75 = parcelRequire("ett75");

var $e3sfE = parcelRequire("e3sfE");

var $aOzet = parcelRequire("aOzet");

var $drMDV = parcelRequire("drMDV");
/**
 * Where the ACTIVE CLINIC is — so registering a patient at a clinic abroad does
 * not start the mobile on Iran's +98, offer Iran's insurers, or hold a national
 * id to Iran's ten-digit کد ملی (PM-0061).
 *
 * The onboarding wizard asks where the FOUNDER's number is from
 * (accountRegion.js). A registration form needs the clinic's own answer — a
 * receptionist is not the founder — so it is read off what the clinic said about
 * itself, strongest first:
 *
 *   0. the COUNTRY it stored (PM-0082 / PM-0218), when that is not Iran. `IR` is
 *      also what every clinic that predates the field reads — Iraqi ones that
 *      never set theirs included — so it does not overrule 1–3 below: an `IR`
 *      clinic is answered exactly as before, and an Iraqi one that never set its
 *      country keeps today's answer until it does.
 *   1. its currency, when that names one country. IRR is Iran — every clinic
 *      before the choice existed, and a founder from abroad is never offered it
 *      — and IQD is Iraq. Answered at once, with no request: it rides on the
 *      membership the panel booted with.
 *   2. otherwise (USD, EUR, CHF — currencies many countries keep) its office
 *      line, E.164 since «مشخصات کلینیک» started writing it;
 *   3. otherwise the signed-in account's own number, as the onboarding reads it.
 *
 * `iran` is true only for an Iranian answer from 1 or 2. The account's number
 * may pick the country a mobile STARTS on, but it never puts a non-IRR clinic
 * back on Iran's rules: an Iranian receptionist at a clinic abroad still
 * registers that clinic's patients. While 2 and 3 are on their way a non-IRR
 * clinic reads `{ iran: false, country: null }` — no Iranian defaults to flash
 * and then take back.
 *
 * Under a brand outside the Iranian market (`market: 'intl'`) no clinic is in
 * Iran: `iran` is always false, and an answer that would have been Iran — an IRR
 * currency, a +98 office line — is "country unknown" instead.
 *
 * `insuranceCatalog` is the clinic's insurer catalogue from its capabilities —
 * the country whose insurers it is offered, null for «آزاد» alone, and
 * `undefined` while the capabilities are not known (lib/insurance.js
 * `registrationInsurers` reads it).
 */ const $6dcee2702b15fb68$var$CLINIC_LINE = `
  query ClinicOfficeLine {
    myClinic { id officePhone }
  }
`;
// One answer per clinic and one per account, for the session: the booking modal
// opens on every F4 and none of this changes between two bookings. A failed read
// is forgotten rather than cached, so the next form asks again.
const $6dcee2702b15fb68$var$lines = new Map();
let $6dcee2702b15fb68$var$account = null;
function $6dcee2702b15fb68$var$officeLineCountry(clinicId) {
    if (!$6dcee2702b15fb68$var$lines.has(clinicId)) $6dcee2702b15fb68$var$lines.set(clinicId, (0, $2Mst8.bffQuery)($6dcee2702b15fb68$var$CLINIC_LINE, {}, 'ClinicOfficeLine').then((data)=>(0, $aOzet.countryForPhone)(data?.myClinic?.officePhone)?.iso2 || null).catch(()=>{
        $6dcee2702b15fb68$var$lines.delete(clinicId);
        return null;
    }));
    return $6dcee2702b15fb68$var$lines.get(clinicId);
}
function $6dcee2702b15fb68$var$accountCountry() {
    if (!$6dcee2702b15fb68$var$account) $6dcee2702b15fb68$var$account = (0, $drMDV.fetchAccountRegion)()// Never Iran, whatever the number: see the header for why the account
    // only ever picks a starting country, and only a foreign one.
    .then((answer)=>answer.foreign && answer.country !== 'IR' ? answer.country : null).catch(()=>{
        $6dcee2702b15fb68$var$account = null;
        return null;
    });
    return $6dcee2702b15fb68$var$account;
}
function $6dcee2702b15fb68$export$f97c4c845342c923() {
    $6dcee2702b15fb68$var$lines.clear();
    $6dcee2702b15fb68$var$account = null;
}
// A stored country that says something 1–3 cannot: an assigned code other than Iran's.
const $6dcee2702b15fb68$var$storedForeignCountry = (caps)=>{
    const code = caps?.country;
    return typeof code === 'string' && /^[A-Z]{2}$/.test(code) && code !== 'IR' ? code : null;
};
function $6dcee2702b15fb68$export$88cfbb9124a0950e() {
    const clinic = (0, $ett75.useOptionalClinicContext)();
    const caps = (0, $e3sfE.useClinicCapabilities)();
    // The clinic's currency from its context; outside one (a component under test)
    // the currency the i18n layer is bound to, which ClinicContext sets from the
    // same membership in the app.
    const { currency: bound } = (0, $e1LEq.default)();
    const currency = clinic?.currency || bound || 'IRR';
    const clinicId = clinic?.activeMembership?.clinicId || '';
    const iranMarket = (0, $eLeza.isIranMarket)();
    const fromCurrency = (0, $drMDV.countryForCurrency)(currency);
    const named = $6dcee2702b15fb68$var$storedForeignCountry(caps) || (!iranMarket && fromCurrency === 'IR' ? null : fromCurrency);
    const insuranceCatalog = caps ? caps.insuranceCatalog ?? null : undefined;
    const key = `${clinicId}|${currency}`;
    const [looked, setLooked] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (named) return undefined;
        let live = true;
        (async ()=>{
            const country = await $6dcee2702b15fb68$var$officeLineCountry(clinicId) || await $6dcee2702b15fb68$var$accountCountry();
            if (live) setLooked({
                key: key,
                country: country
            });
        })();
        return ()=>{
            live = false;
        };
    }, [
        named,
        clinicId,
        key
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const found = named || (looked?.key === key ? looked.country : null);
        // 'IR' can only have come from the currency or the office line — the
        // account's answer is never Iran (`accountCountry`).
        const country = !iranMarket && found === 'IR' ? null : found;
        return {
            iran: country === 'IR',
            country: country,
            insuranceCatalog: insuranceCatalog
        };
    }, [
        named,
        looked,
        key,
        iranMarket,
        insuranceCatalog
    ]);
}
var $6dcee2702b15fb68$export$2e2bcd8739ae039 = $6dcee2702b15fb68$export$88cfbb9124a0950e;

});
parcelRegister("e3sfE", function(module, exports) {

$parcel$export(module.exports, "useClinicCapabilities", () => $a3b742a8f6e8a7f5$export$6245109895419f6d);

var $acw62 = parcelRequire("acw62");

var $2Mst8 = parcelRequire("2Mst8");

var $ett75 = parcelRequire("ett75");
const $a3b742a8f6e8a7f5$export$8284259b3c7bc2a1 = `
  query ClinicCapabilities {
    myClinic {
      id
      country
      capabilities {
        country erx councilRegistry smsProvider messagingChannels paymentRails billServices
        payrollProfile insuranceCatalog defaultLanguage calendar weekStart weekendDays
        defaultCurrency defaultTimezone nationalIdRule nationalDialCode addressModel
        mapView { lat lon zoom }
        printCalendar printLanguage
      }
    }
  }
`;
const $a3b742a8f6e8a7f5$var$TTL_MS = 300000;
// clinicId → { promise, value, at } — `value` once answered.
const $a3b742a8f6e8a7f5$var$answers = new Map();
function $a3b742a8f6e8a7f5$var$load(clinicId) {
    const hit = $a3b742a8f6e8a7f5$var$answers.get(clinicId);
    if (hit && (!('value' in hit) || Date.now() - hit.at < $a3b742a8f6e8a7f5$var$TTL_MS)) return hit.promise;
    const entry = {};
    entry.promise = (0, $2Mst8.bffQuery)($a3b742a8f6e8a7f5$export$8284259b3c7bc2a1, {}, 'ClinicCapabilities').then((data)=>{
        const clinic = data?.myClinic;
        // The answer must be for the clinic it was asked for: a switch while it was
        // in flight is not this clinic's.
        const value = clinic?.id === clinicId && clinic.capabilities && typeof clinic.capabilities === 'object' ? clinic.capabilities : null;
        entry.value = value;
        entry.at = Date.now();
        if (!value) $a3b742a8f6e8a7f5$var$answers.delete(clinicId);
        return value;
    }).catch(()=>{
        $a3b742a8f6e8a7f5$var$answers.delete(clinicId);
        return null;
    });
    $a3b742a8f6e8a7f5$var$answers.set(clinicId, entry);
    return entry.promise;
}
function $a3b742a8f6e8a7f5$export$c82abba1b1df7a45() {
    $a3b742a8f6e8a7f5$var$answers.clear();
}
// What is already known about a clinic, synchronously — so a screen mounted after
// the first answer, or a switch back to a clinic already asked about, starts on
// the answer rather than on null.
function $a3b742a8f6e8a7f5$var$known(clinicId) {
    const hit = clinicId ? $a3b742a8f6e8a7f5$var$answers.get(clinicId) : null;
    return hit && 'value' in hit ? hit.value : null;
}
function $a3b742a8f6e8a7f5$export$6245109895419f6d() {
    const clinic = (0, $ett75.useOptionalClinicContext)();
    const clinicId = clinic?.activeMembership?.clinicId || '';
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>({
            clinicId: clinicId,
            value: $a3b742a8f6e8a7f5$var$known(clinicId)
        }));
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!clinicId) return undefined;
        let live = true;
        $a3b742a8f6e8a7f5$var$load(clinicId).then((value)=>{
            if (live) setState((prev)=>prev.clinicId === clinicId && prev.value === value ? prev : {
                    clinicId: clinicId,
                    value: value
                });
        });
        return ()=>{
            live = false;
        };
    }, [
        clinicId
    ]);
    return state.clinicId === clinicId ? state.value : $a3b742a8f6e8a7f5$var$known(clinicId);
}
var $a3b742a8f6e8a7f5$export$2e2bcd8739ae039 = $a3b742a8f6e8a7f5$export$6245109895419f6d;

});

parcelRegister("aOzet", function(module, exports) {

$parcel$export(module.exports, "COUNTRIES", () => $7df9e74cb8affcc9$export$4d78c43b7fa734a7);
$parcel$export(module.exports, "countryName", () => $7df9e74cb8affcc9$export$3162e773cd568eb);
$parcel$export(module.exports, "countryForPhone", () => $7df9e74cb8affcc9$export$b88373ccfbcd4924);
// ─────────────────────────────────────────────────────────────────────────────
// Countries — for the foreign onboarding form (PM-0061).
//
// The SAME rows as the sign-in page's catalogue
// (sso/parsina.keycloakify/src/login/lib/countries.ts) and of the doctor
// panel (doctor-app/parsina.client.web/src/constants/countries.js), reduced to what a
// country PICKER needs: the ISO code that is stored, the calling code that
// preselects the country of the number the doctor signed in with, and the name
// in each language the panel ships. Add a country there first, then here.
//
// `iso2` is what goes on the wire and into the practitioner record; a name is
// only ever display. The rows are data, so they live in countries.json.
// ─────────────────────────────────────────────────────────────────────────────

var $azHJm = parcelRequire("azHJm");
const $7df9e74cb8affcc9$export$4d78c43b7fa734a7 = (0, (/*@__PURE__*/$parcel$interopDefault($azHJm)));
const $7df9e74cb8affcc9$export$3162e773cd568eb = (country, locale)=>country?.[String(locale || '').split('-')[0]] || country?.en || '';
const $7df9e74cb8affcc9$var$toLatinDigits = (value)=>String(value ?? '').replace(/[۰-۹٠-٩]/g, (ch)=>{
        const code = ch.charCodeAt(0);
        return String(code >= 0x06f0 ? code - 0x06f0 : code - 0x0660);
    });
function $7df9e74cb8affcc9$export$b88373ccfbcd4924(phone) {
    const compact = $7df9e74cb8affcc9$var$toLatinDigits(phone).replace(/[\s\-().]/g, '');
    const match = /^(?:\+|00)(\d{6,15})$/.exec(compact);
    if (!match) return null;
    return $7df9e74cb8affcc9$export$4d78c43b7fa734a7.find((c)=>match[1].startsWith(c.dial)) || null;
}

});
parcelRegister("azHJm", function(module, exports) {
module.exports = JSON.parse('[{"iso2":"IR","dial":"98","en":"Iran","fa":"\u0627\u06CC\u0631\u0627\u0646","ar":"\u0625\u064A\u0631\u0627\u0646","fr":"Iran","de":"Iran"},{"iso2":"AF","dial":"93","en":"Afghanistan","fa":"\u0627\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646","ar":"\u0623\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646","fr":"Afghanistan","de":"Afghanistan"},{"iso2":"DZ","dial":"213","en":"Algeria","fa":"\u0627\u0644\u062C\u0632\u0627\u06CC\u0631","ar":"\u0627\u0644\u062C\u0632\u0627\u0626\u0631","fr":"Alg\xe9rie","de":"Algerien"},{"iso2":"AM","dial":"374","en":"Armenia","fa":"\u0627\u0631\u0645\u0646\u0633\u062A\u0627\u0646","ar":"\u0623\u0631\u0645\u064A\u0646\u064A\u0627","fr":"Arm\xe9nie","de":"Armenien"},{"iso2":"AU","dial":"61","en":"Australia","fa":"\u0627\u0633\u062A\u0631\u0627\u0644\u06CC\u0627","ar":"\u0623\u0633\u062A\u0631\u0627\u0644\u064A\u0627","fr":"Australie","de":"Australien"},{"iso2":"AT","dial":"43","en":"Austria","fa":"\u0627\u062A\u0631\u06CC\u0634","ar":"\u0627\u0644\u0646\u0645\u0633\u0627","fr":"Autriche","de":"\xd6sterreich"},{"iso2":"AZ","dial":"994","en":"Azerbaijan","fa":"\u0622\u0630\u0631\u0628\u0627\u06CC\u062C\u0627\u0646","ar":"\u0623\u0630\u0631\u0628\u064A\u062C\u0627\u0646","fr":"Azerba\xefdjan","de":"Aserbaidschan"},{"iso2":"BH","dial":"973","en":"Bahrain","fa":"\u0628\u062D\u0631\u06CC\u0646","ar":"\u0627\u0644\u0628\u062D\u0631\u064A\u0646","fr":"Bahre\xefn","de":"Bahrain"},{"iso2":"BE","dial":"32","en":"Belgium","fa":"\u0628\u0644\u0698\u06CC\u06A9","ar":"\u0628\u0644\u062C\u064A\u0643\u0627","fr":"Belgique","de":"Belgien"},{"iso2":"BR","dial":"55","en":"Brazil","fa":"\u0628\u0631\u0632\u06CC\u0644","ar":"\u0627\u0644\u0628\u0631\u0627\u0632\u064A\u0644","fr":"Br\xe9sil","de":"Brasilien"},{"iso2":"CA","dial":"1","en":"Canada","fa":"\u06A9\u0627\u0646\u0627\u062F\u0627","ar":"\u0643\u0646\u062F\u0627","fr":"Canada","de":"Kanada"},{"iso2":"CN","dial":"86","en":"China","fa":"\u0686\u06CC\u0646","ar":"\u0627\u0644\u0635\u064A\u0646","fr":"Chine","de":"China"},{"iso2":"CY","dial":"357","en":"Cyprus","fa":"\u0642\u0628\u0631\u0633","ar":"\u0642\u0628\u0631\u0635","fr":"Chypre","de":"Zypern"},{"iso2":"DK","dial":"45","en":"Denmark","fa":"\u062F\u0627\u0646\u0645\u0627\u0631\u06A9","ar":"\u0627\u0644\u062F\u0646\u0645\u0627\u0631\u0643","fr":"Danemark","de":"D\xe4nemark"},{"iso2":"EG","dial":"20","en":"Egypt","fa":"\u0645\u0635\u0631","ar":"\u0645\u0635\u0631","fr":"\xc9gypte","de":"\xc4gypten"},{"iso2":"FI","dial":"358","en":"Finland","fa":"\u0641\u0646\u0644\u0627\u0646\u062F","ar":"\u0641\u0646\u0644\u0646\u062F\u0627","fr":"Finlande","de":"Finnland"},{"iso2":"FR","dial":"33","en":"France","fa":"\u0641\u0631\u0627\u0646\u0633\u0647","ar":"\u0641\u0631\u0646\u0633\u0627","fr":"France","de":"Frankreich"},{"iso2":"GE","dial":"995","en":"Georgia","fa":"\u06AF\u0631\u062C\u0633\u062A\u0627\u0646","ar":"\u062C\u0648\u0631\u062C\u064A\u0627","fr":"G\xe9orgie","de":"Georgien"},{"iso2":"DE","dial":"49","en":"Germany","fa":"\u0622\u0644\u0645\u0627\u0646","ar":"\u0623\u0644\u0645\u0627\u0646\u064A\u0627","fr":"Allemagne","de":"Deutschland"},{"iso2":"GR","dial":"30","en":"Greece","fa":"\u06CC\u0648\u0646\u0627\u0646","ar":"\u0627\u0644\u064A\u0648\u0646\u0627\u0646","fr":"Gr\xe8ce","de":"Griechenland"},{"iso2":"HU","dial":"36","en":"Hungary","fa":"\u0645\u062C\u0627\u0631\u0633\u062A\u0627\u0646","ar":"\u0627\u0644\u0645\u062C\u0631","fr":"Hongrie","de":"Ungarn"},{"iso2":"IN","dial":"91","en":"India","fa":"\u0647\u0646\u062F","ar":"\u0627\u0644\u0647\u0646\u062F","fr":"Inde","de":"Indien"},{"iso2":"ID","dial":"62","en":"Indonesia","fa":"\u0627\u0646\u062F\u0648\u0646\u0632\u06CC","ar":"\u0625\u0646\u062F\u0648\u0646\u064A\u0633\u064A\u0627","fr":"Indon\xe9sie","de":"Indonesien"},{"iso2":"IQ","dial":"964","en":"Iraq","fa":"\u0639\u0631\u0627\u0642","ar":"\u0627\u0644\u0639\u0631\u0627\u0642","fr":"Irak","de":"Irak"},{"iso2":"IT","dial":"39","en":"Italy","fa":"\u0627\u06CC\u062A\u0627\u0644\u06CC\u0627","ar":"\u0625\u064A\u0637\u0627\u0644\u064A\u0627","fr":"Italie","de":"Italien"},{"iso2":"JP","dial":"81","en":"Japan","fa":"\u0698\u0627\u067E\u0646","ar":"\u0627\u0644\u064A\u0627\u0628\u0627\u0646","fr":"Japon","de":"Japan"},{"iso2":"JO","dial":"962","en":"Jordan","fa":"\u0627\u0631\u062F\u0646","ar":"\u0627\u0644\u0623\u0631\u062F\u0646","fr":"Jordanie","de":"Jordanien"},{"iso2":"KZ","dial":"7","en":"Kazakhstan","fa":"\u0642\u0632\u0627\u0642\u0633\u062A\u0627\u0646","ar":"\u0643\u0627\u0632\u0627\u062E\u0633\u062A\u0627\u0646","fr":"Kazakhstan","de":"Kasachstan"},{"iso2":"KW","dial":"965","en":"Kuwait","fa":"\u06A9\u0648\u06CC\u062A","ar":"\u0627\u0644\u0643\u0648\u064A\u062A","fr":"Kowe\xeft","de":"Kuwait"},{"iso2":"LB","dial":"961","en":"Lebanon","fa":"\u0644\u0628\u0646\u0627\u0646","ar":"\u0644\u0628\u0646\u0627\u0646","fr":"Liban","de":"Libanon"},{"iso2":"LY","dial":"218","en":"Libya","fa":"\u0644\u06CC\u0628\u06CC","ar":"\u0644\u064A\u0628\u064A\u0627","fr":"Libye","de":"Libyen"},{"iso2":"MY","dial":"60","en":"Malaysia","fa":"\u0645\u0627\u0644\u0632\u06CC","ar":"\u0645\u0627\u0644\u064A\u0632\u064A\u0627","fr":"Malaisie","de":"Malaysia"},{"iso2":"MR","dial":"222","en":"Mauritania","fa":"\u0645\u0648\u0631\u06CC\u062A\u0627\u0646\u06CC","ar":"\u0645\u0648\u0631\u064A\u062A\u0627\u0646\u064A\u0627","fr":"Mauritanie","de":"Mauretanien"},{"iso2":"MA","dial":"212","en":"Morocco","fa":"\u0645\u0631\u0627\u06A9\u0634","ar":"\u0627\u0644\u0645\u063A\u0631\u0628","fr":"Maroc","de":"Marokko"},{"iso2":"NL","dial":"31","en":"Netherlands","fa":"\u0647\u0644\u0646\u062F","ar":"\u0647\u0648\u0644\u0646\u062F\u0627","fr":"Pays-Bas","de":"Niederlande"},{"iso2":"NZ","dial":"64","en":"New Zealand","fa":"\u0646\u06CC\u0648\u0632\u06CC\u0644\u0646\u062F","ar":"\u0646\u064A\u0648\u0632\u064A\u0644\u0646\u062F\u0627","fr":"Nouvelle-Z\xe9lande","de":"Neuseeland"},{"iso2":"NO","dial":"47","en":"Norway","fa":"\u0646\u0631\u0648\u0698","ar":"\u0627\u0644\u0646\u0631\u0648\u064A\u062C","fr":"Norv\xe8ge","de":"Norwegen"},{"iso2":"OM","dial":"968","en":"Oman","fa":"\u0639\u0645\u0627\u0646","ar":"\u0639\u064F\u0645\u0627\u0646","fr":"Oman","de":"Oman"},{"iso2":"PK","dial":"92","en":"Pakistan","fa":"\u067E\u0627\u06A9\u0633\u062A\u0627\u0646","ar":"\u0628\u0627\u0643\u0633\u062A\u0627\u0646","fr":"Pakistan","de":"Pakistan"},{"iso2":"PS","dial":"970","en":"Palestine","fa":"\u0641\u0644\u0633\u0637\u06CC\u0646","ar":"\u0641\u0644\u0633\u0637\u064A\u0646","fr":"Palestine","de":"Pal\xe4stina"},{"iso2":"PL","dial":"48","en":"Poland","fa":"\u0644\u0647\u0633\u062A\u0627\u0646","ar":"\u0628\u0648\u0644\u0646\u062F\u0627","fr":"Pologne","de":"Polen"},{"iso2":"QA","dial":"974","en":"Qatar","fa":"\u0642\u0637\u0631","ar":"\u0642\u0637\u0631","fr":"Qatar","de":"Katar"},{"iso2":"RU","dial":"7","en":"Russia","fa":"\u0631\u0648\u0633\u06CC\u0647","ar":"\u0631\u0648\u0633\u064A\u0627","fr":"Russie","de":"Russland"},{"iso2":"SA","dial":"966","en":"Saudi Arabia","fa":"\u0639\u0631\u0628\u0633\u062A\u0627\u0646 \u0633\u0639\u0648\u062F\u06CC","ar":"\u0627\u0644\u0633\u0639\u0648\u062F\u064A\u0629","fr":"Arabie saoudite","de":"Saudi-Arabien"},{"iso2":"SG","dial":"65","en":"Singapore","fa":"\u0633\u0646\u06AF\u0627\u067E\u0648\u0631","ar":"\u0633\u0646\u063A\u0627\u0641\u0648\u0631\u0629","fr":"Singapour","de":"Singapur"},{"iso2":"ZA","dial":"27","en":"South Africa","fa":"\u0622\u0641\u0631\u06CC\u0642\u0627\u06CC \u062C\u0646\u0648\u0628\u06CC","ar":"\u062C\u0646\u0648\u0628 \u0623\u0641\u0631\u064A\u0642\u064A\u0627","fr":"Afrique du Sud","de":"S\xfcdafrika"},{"iso2":"ES","dial":"34","en":"Spain","fa":"\u0627\u0633\u067E\u0627\u0646\u06CC\u0627","ar":"\u0625\u0633\u0628\u0627\u0646\u064A\u0627","fr":"Espagne","de":"Spanien"},{"iso2":"SD","dial":"249","en":"Sudan","fa":"\u0633\u0648\u062F\u0627\u0646","ar":"\u0627\u0644\u0633\u0648\u062F\u0627\u0646","fr":"Soudan","de":"Sudan"},{"iso2":"SE","dial":"46","en":"Sweden","fa":"\u0633\u0648\u0626\u062F","ar":"\u0627\u0644\u0633\u0648\u064A\u062F","fr":"Su\xe8de","de":"Schweden"},{"iso2":"CH","dial":"41","en":"Switzerland","fa":"\u0633\u0648\u0626\u06CC\u0633","ar":"\u0633\u0648\u064A\u0633\u0631\u0627","fr":"Suisse","de":"Schweiz"},{"iso2":"SY","dial":"963","en":"Syria","fa":"\u0633\u0648\u0631\u06CC\u0647","ar":"\u0633\u0648\u0631\u064A\u0627","fr":"Syrie","de":"Syrien"},{"iso2":"TJ","dial":"992","en":"Tajikistan","fa":"\u062A\u0627\u062C\u06CC\u06A9\u0633\u062A\u0627\u0646","ar":"\u0637\u0627\u062C\u064A\u0643\u0633\u062A\u0627\u0646","fr":"Tadjikistan","de":"Tadschikistan"},{"iso2":"TH","dial":"66","en":"Thailand","fa":"\u062A\u0627\u06CC\u0644\u0646\u062F","ar":"\u062A\u0627\u064A\u0644\u0627\u0646\u062F","fr":"Tha\xeflande","de":"Thailand"},{"iso2":"TN","dial":"216","en":"Tunisia","fa":"\u062A\u0648\u0646\u0633","ar":"\u062A\u0648\u0646\u0633","fr":"Tunisie","de":"Tunesien"},{"iso2":"TR","dial":"90","en":"T\xfcrkiye","fa":"\u062A\u0631\u06A9\u06CC\u0647","ar":"\u062A\u0631\u0643\u064A\u0627","fr":"Turquie","de":"T\xfcrkei"},{"iso2":"TM","dial":"993","en":"Turkmenistan","fa":"\u062A\u0631\u06A9\u0645\u0646\u0633\u062A\u0627\u0646","ar":"\u062A\u0631\u0643\u0645\u0627\u0646\u0633\u062A\u0627\u0646","fr":"Turkm\xe9nistan","de":"Turkmenistan"},{"iso2":"UA","dial":"380","en":"Ukraine","fa":"\u0627\u0648\u06A9\u0631\u0627\u06CC\u0646","ar":"\u0623\u0648\u0643\u0631\u0627\u0646\u064A\u0627","fr":"Ukraine","de":"Ukraine"},{"iso2":"AE","dial":"971","en":"United Arab Emirates","fa":"\u0627\u0645\u0627\u0631\u0627\u062A \u0645\u062A\u062D\u062F\u0647\u0654 \u0639\u0631\u0628\u06CC","ar":"\u0627\u0644\u0625\u0645\u0627\u0631\u0627\u062A \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0645\u062A\u062D\u062F\u0629","fr":"\xc9mirats arabes unis","de":"Vereinigte Arabische Emirate"},{"iso2":"GB","dial":"44","en":"United Kingdom","fa":"\u0628\u0631\u06CC\u062A\u0627\u0646\u06CC\u0627","ar":"\u0627\u0644\u0645\u0645\u0644\u0643\u0629 \u0627\u0644\u0645\u062A\u062D\u062F\u0629","fr":"Royaume-Uni","de":"Vereinigtes K\xf6nigreich"},{"iso2":"US","dial":"1","en":"United States","fa":"\u0627\u06CC\u0627\u0644\u0627\u062A \u0645\u062A\u062D\u062F\u0647","ar":"\u0627\u0644\u0648\u0644\u0627\u064A\u0627\u062A \u0627\u0644\u0645\u062A\u062D\u062F\u0629","fr":"\xc9tats-Unis","de":"Vereinigte Staaten"},{"iso2":"UZ","dial":"998","en":"Uzbekistan","fa":"\u0627\u0632\u0628\u06A9\u0633\u062A\u0627\u0646","ar":"\u0623\u0648\u0632\u0628\u0643\u0633\u062A\u0627\u0646","fr":"Ouzb\xe9kistan","de":"Usbekistan"},{"iso2":"YE","dial":"967","en":"Yemen","fa":"\u06CC\u0645\u0646","ar":"\u0627\u0644\u064A\u0645\u0646","fr":"Y\xe9men","de":"Jemen"}]');

});


parcelRegister("drMDV", function(module, exports) {

$parcel$export(module.exports, "fetchAccountRegion", () => $9ca3877256dc5541$export$8adea571b39186f1);
$parcel$export(module.exports, "useAccountRegion", () => $9ca3877256dc5541$export$44997b076c920295);
$parcel$export(module.exports, "useResolvedAccountRegion", () => $9ca3877256dc5541$export$2ed5d984450556e8);
$parcel$export(module.exports, "currencyForCountry", () => $9ca3877256dc5541$export$10bb3cc54ee85f4c);
$parcel$export(module.exports, "countryForCurrency", () => $9ca3877256dc5541$export$ceb84180823586a7);
$parcel$export(module.exports, "isOfferedAbroad", () => $9ca3877256dc5541$export$840cad40ac2eff38);
$parcel$export(module.exports, "mapViewForCountry", () => $9ca3877256dc5541$export$e9930222cb431db7);

var $acw62 = parcelRequire("acw62");
parcelRequire("bnX6X");
var $eVM84 = parcelRequire("eVM84");

var $eLeza = parcelRequire("eLeza");

var $aOzet = parcelRequire("aOzet");
parcelRequire("1O6TO");
var $lHVFz = parcelRequire("lHVFz");
/**
 * Where the account's number is from — so a founder who signed in from abroad
 * registers a clinic without a word of Iran in the wizard (PM-0061).
 *
 * The answer is the doctor BFF's `onboardingContext`, the same one the doctor
 * track already asks (DoctorTrack.jsx): ONE rule for "foreign", decided
 * server-side from the number the account signed in with. Anything short of a
 * positive answer — an older BFF, a network error, a number in national form —
 * is "not foreign", which is exactly how the wizard behaved before.
 *
 * A BRAND outside the Iranian market (`market: 'intl'`, docs/rebranding/
 * CONTRACT.md) has no Iranian side at all: EVERY account onboards as from abroad
 * — no کد نظام پزشکی, no IRR, no +98, no Iranian provinces — whatever its number,
 * and a +98 number does not make the country Iran. A failed lookup is then
 * "abroad, country unknown", never "Iran".
 */ const $9ca3877256dc5541$var$ONBOARDING_CONTEXT = `
  query OnboardingContext {
    onboardingContext { foreign phone }
  }
`;
const $9ca3877256dc5541$var$HOME = Object.freeze({
    foreign: false,
    country: null
});
const $9ca3877256dc5541$var$ABROAD = Object.freeze({
    foreign: true,
    country: null
});
/** What "nobody knows yet" (or "the BFF could not say") means for this market. */ const $9ca3877256dc5541$var$unknownRegion = ()=>(0, $eLeza.isIranMarket)() ? $9ca3877256dc5541$var$HOME : $9ca3877256dc5541$var$ABROAD;
function $9ca3877256dc5541$export$8adea571b39186f1() {
    const iranMarket = (0, $eLeza.isIranMarket)();
    const asked = Promise.resolve().then(()=>(0, $eVM84.bffQuery)($9ca3877256dc5541$var$ONBOARDING_CONTEXT)).then((data)=>{
        const ctx = data?.onboardingContext;
        if (iranMarket && !ctx?.foreign) return $9ca3877256dc5541$var$HOME;
        const country = (0, $aOzet.countryForPhone)(ctx?.phone)?.iso2 || null;
        return {
            foreign: true,
            country: iranMarket || country !== 'IR' ? country : null
        };
    });
    return iranMarket ? asked : asked.catch(()=>$9ca3877256dc5541$var$ABROAD);
}
function $9ca3877256dc5541$export$44997b076c920295() {
    const [region, setRegion] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState($9ca3877256dc5541$var$unknownRegion);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        let live = true;
        $9ca3877256dc5541$export$8adea571b39186f1().then((answer)=>{
            if (live && answer.foreign) setRegion(answer);
        }).catch(()=>{});
        return ()=>{
            live = false;
        };
    }, []);
    return region;
}
function $9ca3877256dc5541$export$2ed5d984450556e8() {
    const [region, setRegion] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        let live = true;
        $9ca3877256dc5541$export$8adea571b39186f1().then((answer)=>{
            if (live) setRegion(answer);
        }).catch(()=>{
            if (live) setRegion($9ca3877256dc5541$var$unknownRegion());
        });
        return ()=>{
            live = false;
        };
    }, []);
    return region;
}
// Euro members and the microstates that use the euro as their own.
const $9ca3877256dc5541$var$EURO = new Set([
    'AT',
    'BE',
    'HR',
    'CY',
    'EE',
    'FI',
    'FR',
    'DE',
    'GR',
    'IE',
    'IT',
    'LV',
    'LT',
    'LU',
    'MT',
    'NL',
    'PT',
    'SK',
    'SI',
    'ES',
    'AD',
    'MC',
    'SM',
    'VA',
    'ME',
    'XK'
]);
const $9ca3877256dc5541$var$OWN_CURRENCY = {
    AE: 'AED',
    SA: 'SAR',
    QA: 'QAR',
    TR: 'TRY',
    KW: 'KWD',
    BH: 'BHD',
    OM: 'OMR',
    IQ: 'IQD',
    US: 'USD',
    GB: 'GBP',
    CH: 'CHF',
    LI: 'CHF'
};
function $9ca3877256dc5541$export$10bb3cc54ee85f4c(country) {
    const code = $9ca3877256dc5541$var$EURO.has(country) ? 'EUR' : $9ca3877256dc5541$var$OWN_CURRENCY[country];
    return code && (0, $lHVFz.CURRENCY_CODES).includes(code) ? code : 'USD';
}
function $9ca3877256dc5541$export$ceb84180823586a7(code) {
    if (code === (0, $lHVFz.DEFAULT_CURRENCY)) return 'IR';
    if (code === 'USD') return null;
    const named = Object.keys($9ca3877256dc5541$var$OWN_CURRENCY).filter((country)=>$9ca3877256dc5541$var$OWN_CURRENCY[country] === code);
    return named.length === 1 ? named[0] : null;
}
const $9ca3877256dc5541$export$840cad40ac2eff38 = (code)=>code !== (0, $lHVFz.DEFAULT_CURRENCY);
/**
 * Where the map opens for a founder from abroad who has not placed a pin yet:
 * the middle of their country, at a zoom that shows it whole. Only a starting
 * view — the pin is theirs to place — so a country missing here opens on a
 * world view rather than on somebody else's capital.
 */ const $9ca3877256dc5541$var$COUNTRY_VIEW = {
    IQ: [
        33.2,
        43.7,
        6
    ],
    SA: [
        24.0,
        45.0,
        5
    ],
    AE: [
        24.2,
        54.4,
        7
    ],
    KW: [
        29.3,
        47.7,
        8
    ],
    QA: [
        25.3,
        51.2,
        9
    ],
    BH: [
        26.0,
        50.55,
        10
    ],
    OM: [
        21.5,
        57.0,
        6
    ],
    JO: [
        31.2,
        36.5,
        7
    ],
    LB: [
        33.9,
        35.9,
        8
    ],
    SY: [
        35.0,
        38.5,
        7
    ],
    PS: [
        31.9,
        35.2,
        8
    ],
    YE: [
        15.6,
        48.0,
        6
    ],
    EG: [
        26.8,
        30.8,
        6
    ],
    LY: [
        27.0,
        17.0,
        5
    ],
    TN: [
        34.0,
        9.5,
        6
    ],
    DZ: [
        28.0,
        2.6,
        5
    ],
    MA: [
        31.8,
        -7.1,
        6
    ],
    SD: [
        15.5,
        30.2,
        5
    ],
    MR: [
        20.3,
        -10.9,
        5
    ],
    SO: [
        5.2,
        46.2,
        5
    ],
    DJ: [
        11.8,
        42.6,
        8
    ],
    KM: [
        -11.9,
        43.9,
        8
    ],
    TR: [
        39.0,
        35.2,
        6
    ],
    AF: [
        33.9,
        67.7,
        6
    ]
};
const $9ca3877256dc5541$var$WORLD_VIEW = [
    20,
    0,
    2
];
const $9ca3877256dc5541$export$e9930222cb431db7 = (country)=>$9ca3877256dc5541$var$COUNTRY_VIEW[country] || $9ca3877256dc5541$var$WORLD_VIEW;

});
parcelRegister("bnX6X", function(module, exports) {

$parcel$export(module.exports, "ClinicalHostProvider", () => (parcelRequire("e317r")).ClinicalHostProvider);
$parcel$export(module.exports, "VisitScreen", () => (parcelRequire("18P7h")).default);
$parcel$export(module.exports, "PatientDetailScreen", () => (parcelRequire("f61oO")).default);
$parcel$export(module.exports, "VisitSkeleton", () => (parcelRequire("fWbIA")).VisitSkeleton);
$parcel$export(module.exports, "VisitMobileSkeleton", () => (parcelRequire("fWbIA")).VisitMobileSkeleton);
$parcel$export(module.exports, "PatientDetailSkeleton", () => (parcelRequire("aX9TZ")).default);
$parcel$export(module.exports, "PatientDetailMobileSkeleton", () => (parcelRequire("asVAE")).default);
$parcel$export(module.exports, "ClinicalI18n", () => (parcelRequire("4rEI6")).default);
$parcel$export(module.exports, "useClinicalTranslation", () => (parcelRequire("LNQP4")).default);
$parcel$export(module.exports, "bffQuery", () => (parcelRequire("eVM84")).bffQuery);
$parcel$export(module.exports, "bffMutation", () => (parcelRequire("eVM84")).bffMutation);
/**
 * @parsina/framework/clinical — the Visit and Patient Details experience, shared
 * by the doctor panel and the clinic panel.
 *
 * A host does three things (docs/CLINICAL_KIT_DESIGN.md):
 *
 *   1. configureClinical({ bffUrl, auth, activeClinicId })   once, at boot
 *   2. <ClinicalHostProvider navigate back pathname           around its routes
 *        clinicCurrency capabilities>                         (optional: the visit's
 *      clinic's ISO 4217 code — a non-IRR one hides the Iranian insurer rails —
 *      and what its country allows, PM-0218; absent or null = as before)
 *   3. <ClinicalI18n language>                               around the screens,
 *      then render <VisitScreen patient> / <PatientDetailScreen patient tab …>
 *
 * The doctor panel does all three at its root and so renders every clinical
 * component anywhere; the clinic panel does them only around its two clinical
 * routes. Neither may fork what is exported here — a behaviour that belongs to
 * one panel is a host intent, never a copy.
 */ 
var $e317r = parcelRequire("e317r");

var $2zs2d = parcelRequire("2zs2d");

var $5UCQz = parcelRequire("5UCQz");

var $18P7h = parcelRequire("18P7h");

var $f61oO = parcelRequire("f61oO");

var $fWbIA = parcelRequire("fWbIA");

var $aX9TZ = parcelRequire("aX9TZ");

var $asVAE = parcelRequire("asVAE");
parcelRequire("dSPMK");
var $4rEI6 = parcelRequire("4rEI6");
var $LNQP4 = parcelRequire("LNQP4");

var $eVM84 = parcelRequire("eVM84");

var $b9X92 = parcelRequire("b9X92");

});
parcelRegister("2zs2d", function(module, exports) {
/**
 * Every navigation INTENT the clinical screens raise on their host.
 *
 * A host (ClinicalHostProvider's `navigate`) must give each one a destination —
 * or deliberately none — and each host's own test says so. The kit's test
 * (clinical/__tests__/intents.test.js) scans these sources and fails when a
 * screen raises an intent that is not listed here, so a new one can never reach
 * a host as a silent dead button.
 *
 *   reception       the host's home: the visit closed, or the record is gone
 *                   (doctor → its day sheet; clinic → پذیرش)
 *   patient-detail  { id, tab? } — the patient's record, from inside a visit
 *   credits         top up پارسه — the balance ran out mid-visit
 *   profile         { tab: 'visit' } — the visit-layout editor
 *   visit           { id } — the visit room of that patient, from the record's
 *                   «ویزیت همین الان» (PM-0535; the doctor panel only opts in)
 *
 * «Back» is not an intent; it is the host's `back()`.
 */ const $1df498c4a77aa468$export$102fd40a9fb0f382 = Object.freeze([
    'reception',
    'patient-detail',
    'credits',
    'profile',
    'visit'
]);

});

parcelRegister("5UCQz", function(module, exports) {

$parcel$export(module.exports, "default", () => $634ecb49bbeee735$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $fX0JO = parcelRequire("fX0JO");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $aJ1FU = parcelRequire("aJ1FU");
var $hZDga = parcelRequire("hZDga");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $ifPys = parcelRequire("ifPys");
/**
 * «ویزیت همین الان» (PM-0535) — see useVisitNow. Rendered on the patient's visit
 * history (desktop tab, phone list), where the doctor has just read what happened
 * and the patient is standing there.
 *
 * The four states: loading (present, disabled — no jump when it settles), idle,
 * busy (disabled, spinner, `aria-busy`) and error (an inline alert; pressing again
 * is the retry). Absent altogether when the host did not opt in or the doctor
 * books at no clinic. A clinic that does not take the doctor's bookings directly,
 * or whose panel is read-only, leaves it visible and disabled WITH the reason —
 * hiding it would leave the doctor guessing why a colleague has it.
 *
 * `compact` (the record's header, a row of «سوابق ویزیت» — PM-0565/0566): the reason
 * rides on the button's tooltip and is read to a screen reader, instead of a line of
 * text under the button that would make a header or a table row grow.
 */ const $634ecb49bbeee735$var$VISUALLY_HIDDEN = {
    position: 'absolute',
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: 'hidden',
    clip: 'rect(0 0 0 0)',
    whiteSpace: 'nowrap',
    border: 0
};
function $634ecb49bbeee735$export$2e2bcd8739ae039({ patient: patient, fullWidth: fullWidth = false, size: size = 'sm', testId: testId = 'visit-now', style: style, compact: compact = false }) {
    const { t: t } = (0, $LNQP4.default)();
    const v = (0, $ifPys.useVisitNow)(patient, t('patient.visitNow.failed'));
    if (v.hidden) return null;
    const blockedText = v.blockedBy === 'grant' ? t('patient.visitNow.needsGrant') : v.blockedBy === 'readOnly' ? t('patient.visitNow.readOnly') : '';
    const disabled = v.loading || v.busy || v.unavailable || !!v.blockedBy;
    const reason = v.unavailable ? t('patient.visitNow.unavailable') : blockedText;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${testId}-root`,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 8,
            ...fullWidth ? {
                width: '100%'
            } : null,
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        type: "button",
        size: size,
        className: fullWidth ? 'w-full' : undefined,
        disabled: disabled,
        "aria-busy": v.busy || undefined,
        "aria-describedby": reason ? `${testId}-reason` : undefined,
        title: reason || t('patient.visitNow.hint'),
        "data-testid": testId,
        onClick: v.press
    }, v.busy ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 16,
        color: "currentColor"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fX0JO.default), {
        size: 16,
        "aria-hidden": "true"
    }), t('patient.visitNow.action')), reason && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: `${testId}-reason`,
        "data-testid": `${testId}-reason`,
        style: compact ? $634ecb49bbeee735$var$VISUALLY_HIDDEN : {
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).ink2
        }
    }, reason), v.picking && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "group",
        "aria-label": t('patient.visitNow.which'),
        "data-testid": `${testId}-picker`,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.75rem',
            fontWeight: 600,
            color: (0, $jTCZr.CT).ink2
        }
    }, t('patient.visitNow.which')), v.eligible.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            key: c.clinicId,
            type: "button",
            size: "sm",
            variant: "outline",
            "data-testid": `${testId}-clinic-${c.clinicId}`,
            onClick: ()=>v.book(c.clinicId)
        }, c.name || c.clinicId))), v.error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "error",
        role: "alert",
        "data-testid": `${testId}-error`
    }, v.error));
}

});
parcelRegister("fX0JO", function(module, exports) {

$parcel$export(module.exports, "default", () => $02839c5704f38745$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $02839c5704f38745$export$a2387ed3b5d536eb = {
    name: "stethoscope",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M11 2v2",
                key: "1539x4"
            }
        ],
        [
            "path",
            {
                d: "M5 2v2",
                key: "1yf1q8"
            }
        ],
        [
            "path",
            {
                d: "M5 3H4a2 2 0 0 0-2 2v4a6 6 0 0 0 12 0V5a2 2 0 0 0-2-2h-1",
                key: "rb5t3r"
            }
        ],
        [
            "path",
            {
                d: "M8 15a6 6 0 0 0 12 0v-3",
                key: "x18d4x"
            }
        ],
        [
            "circle",
            {
                cx: "20",
                cy: "10",
                r: "2",
                key: "ts1r5v"
            }
        ]
    ]
};
$02839c5704f38745$export$a2387ed3b5d536eb.node;
const $02839c5704f38745$export$2e2bcd8739ae039 = (0, $9QBug.default)($02839c5704f38745$export$a2387ed3b5d536eb);

});

parcelRegister("dSPMK", function(module, exports) {

$parcel$export(module.exports, "I18nProvider", () => (parcelRequire("4rEI6")).default);
$parcel$export(module.exports, "useTranslation", () => (parcelRequire("LNQP4")).default);
$parcel$export(module.exports, "DEFAULT_LOCALE", () => (parcelRequire("Hy6Lb")).DEFAULT_LOCALE);
$parcel$export(module.exports, "MIRROR_ICON", () => (parcelRequire("asXy3")).MIRROR_ICON);
// ─────────────────────────────────────────────────────────────────────────────
// The i18n barrel — import from '../i18n', never from a file inside it.
//
//   import { useTranslation } from '../../i18n';
//
// Keeping the surface here means the internals (loader strategy, translator
// implementation, which Intl objects get memoised) can change without a sweep
// through the app.
//
// Full guide: docs/I18N.md
// ─────────────────────────────────────────────────────────────────────────────

var $4rEI6 = parcelRequire("4rEI6");

var $LNQP4 = parcelRequire("LNQP4");

var $Hy6Lb = parcelRequire("Hy6Lb");

var $asXy3 = parcelRequire("asXy3");

var $4xMUZ = parcelRequire("4xMUZ");

var $dHfod = parcelRequire("dHfod");

});
parcelRegister("4rEI6", function(module, exports) {

$parcel$export(module.exports, "I18nContext", () => $464ca197ae32cd72$export$5603ab5ced17ce64);
$parcel$export(module.exports, "default", () => $464ca197ae32cd72$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $Hy6Lb = parcelRequire("Hy6Lb");

var $dHfod = parcelRequire("dHfod");

var $4xMUZ = parcelRequire("4xMUZ");

var $asXy3 = parcelRequire("asXy3");
// ─────────────────────────────────────────────────────────────────────────────
// The one i18n context. Everything a screen needs — `t`, the formatters, the
// direction, the way to change language — comes from here and nowhere else.
//
// It is deliberately shaped like the design system's ThemeProvider, because it
// solves the same problem and should be read the same way:
//
//   1. localStorage, read synchronously during the first render, so a reload
//      paints the right language AND the right direction immediately instead of
//      flashing Persian at an English-speaking doctor.
//   2. The server copy (`appearance.language` in doctor-preference), pushed in
//      once `me` resolves. That is the real record and wins whenever it differs
//      — it is how the choice follows the doctor to another device.
//
// Switching language NEVER unmounts anything. The new catalogue is loaded, then
// swapped in one state update, so the router, every open dialog and every
// half-filled form survive the switch — requirement 7, and the reason this is a
// context value rather than a remount with a `key`.
// ─────────────────────────────────────────────────────────────────────────────
const $464ca197ae32cd72$export$5603ab5ced17ce64 = /*#__PURE__*/ (0, $acw62.createContext)(null);
function $464ca197ae32cd72$export$a54013f0d02a8f82({ language: language, children: children, fallback: fallback = null }) {
    // Lazy initialiser — runs before first paint, not in an effect, so <html dir>
    // is correct for the very first frame.
    const [locale, setLocale] = (0, $acw62.useState)(()=>(0, $Hy6Lb.applyDocumentLocale)((0, $Hy6Lb.resolveInitialLocale)()));
    // The catalogues currently being rendered. `null` until the first load lands;
    // on a LATER switch the previous catalogue keeps rendering until the new one
    // is ready, so there is no flash of untranslated keys.
    const [catalogs, setCatalogs] = (0, $acw62.useState)(()=>{
        const active = (0, $dHfod.peekCatalog)(locale);
        if (!active) return null;
        const fb = locale === (0, $Hy6Lb.FALLBACK_LOCALE) ? active : (0, $dHfod.peekCatalog)((0, $Hy6Lb.FALLBACK_LOCALE));
        return fb ? {
            locale: locale,
            active: active,
            fallback: fb
        } : null;
    });
    // Guards against an out-of-order resolution when the doctor switches twice
    // quickly: only the most recently requested locale may commit.
    const requested = (0, $acw62.useRef)(locale);
    (0, $acw62.useEffect)(()=>{
        requested.current = locale;
        let live = true;
        // The fallback catalogue is loaded alongside the active one so a key
        // missing from a translation can resolve to English synchronously, inside
        // `t`, rather than triggering a load mid-render.
        Promise.all([
            (0, $dHfod.loadCatalog)(locale),
            locale === (0, $Hy6Lb.FALLBACK_LOCALE) ? null : (0, $dHfod.loadCatalog)((0, $Hy6Lb.FALLBACK_LOCALE))
        ]).then(([active, fb])=>{
            if (!live || requested.current !== locale) return;
            setCatalogs({
                locale: locale,
                active: active,
                fallback: fb || active
            });
        });
        return ()=>{
            live = false;
        };
    }, [
        locale
    ]);
    // Adopt the server's copy when it arrives or changes (e.g. the doctor changed
    // language on another device). `null`/`undefined` means "not loaded yet" —
    // NOT "reset to default" — so an in-flight `me` query never clobbers a choice
    // the doctor just made. An unrecognised tag is ignored rather than applied:
    // a language this build does not ship must not blank the UI. Nor is one the
    // brand does not offer applied — the service's own default («fa») included.
    const serverLanguage = (0, $Hy6Lb.normalizeLocale)(language);
    (0, $acw62.useEffect)(()=>{
        if (!serverLanguage) return;
        setLocale((prev)=>{
            if (prev === serverLanguage) return prev;
            (0, $Hy6Lb.storeLocale)(serverLanguage);
            return (0, $Hy6Lb.applyDocumentLocale)(serverLanguage);
        });
    }, [
        serverLanguage
    ]);
    /**
   * Apply a language locally and cache it. Two callers:
   *   - the settings picker, so the UI switches under the doctor's cursor
   *     instead of after a server round trip;
   *   - app boot, to adopt the server's copy once `me` resolves.
   * Persisting to the BFF is the caller's job — this only paints and caches.
   */ const changeLocale = (0, $acw62.useCallback)((next)=>{
        const id = (0, $Hy6Lb.normalizeLocale)(next);
        if (!id) return;
        setLocale((prev)=>{
            if (prev === id) return prev;
            (0, $Hy6Lb.storeLocale)(id);
            return (0, $Hy6Lb.applyDocumentLocale)(id);
        });
    }, []);
    const value = (0, $acw62.useMemo)(()=>{
        const descriptor = (0, $Hy6Lb.localeDescriptor)(locale);
        const formatters = (0, $asXy3.createFormatters)(locale);
        // Catalogues for a DIFFERENT locale than `locale` means a switch is in
        // flight: keep translating with what we have. `t` still resolves — it just
        // resolves in the outgoing language for the frame or two it takes the new
        // catalogue to arrive from cache or network.
        const active = catalogs?.active || {};
        const fb = catalogs?.fallback || {};
        const renderedLocale = catalogs?.locale || locale;
        const pluralRules = typeof Intl.PluralRules === 'function' ? new Intl.PluralRules((0, $Hy6Lb.localeDescriptor)(renderedLocale).intl) : null;
        const { t: t, tList: tList, has: has } = (0, $4xMUZ.createTranslator)({
            locale: renderedLocale,
            catalog: active,
            fallbackCatalog: fb,
            pluralRules: pluralRules,
            joinList: formatters.formatList,
            formatNumber: formatters.formatNumber
        });
        return {
            locale: // identity
            locale,
            dir: descriptor.dir,
            isRTL: descriptor.dir === 'rtl',
            // Whether this reader can read the Persian clinical reference data. NOT
            // implied by `isRTL` — Arabic shares the direction and not the language.
            readsPersianData: descriptor.readsPersianData === true,
            // What a language picker lists: every shipped language, or only the
            // ones the brand offers.
            locales: (0, $Hy6Lb.offeredLocales)(),
            t: // translation
            t,
            tList: tList,
            has: has,
            // formatting
            ...formatters,
            // the unit word beside a `formatMoney` figure: moneyUnit(currency, 'short')
            moneyUnit: (0, $asXy3.createMoneyUnit)(t, locale),
            // control
            setLocale: changeLocale,
            preloadLocale: (0, $dHfod.preloadCatalog),
            // true once the active locale's catalogue is the one being rendered
            ready: catalogs?.locale === locale
        };
    }, [
        locale,
        catalogs,
        changeLocale
    ]);
    // Only the FIRST load blocks — after that `catalogs` is never null again, so
    // a language switch re-renders in place and the navigation state survives.
    if (!catalogs) return fallback;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($464ca197ae32cd72$export$5603ab5ced17ce64.Provider, {
        value: value
    }, children);
}
var $464ca197ae32cd72$export$2e2bcd8739ae039 = $464ca197ae32cd72$export$a54013f0d02a8f82;

});
parcelRegister("Hy6Lb", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LOCALE", () => $082e79695298041e$export$1af4c7e47ad72f44);
$parcel$export(module.exports, "FALLBACK_LOCALE", () => $082e79695298041e$export$95b7602913551865);
$parcel$export(module.exports, "NAMESPACES", () => $082e79695298041e$export$4d2fb7344096e022);
$parcel$export(module.exports, "isSupportedLocale", () => $082e79695298041e$export$17a6a815985c8621);
$parcel$export(module.exports, "offeredLocales", () => $082e79695298041e$export$171765a6a37c37cd);
$parcel$export(module.exports, "productDefaultLocale", () => $082e79695298041e$export$1ad85a23f306da6d);
$parcel$export(module.exports, "localeDescriptor", () => $082e79695298041e$export$57270fb1f2649979);
$parcel$export(module.exports, "normalizeLocale", () => $082e79695298041e$export$dca0327c9b9c6498);
$parcel$export(module.exports, "storeLocale", () => $082e79695298041e$export$e8146f0b19c81b97);
$parcel$export(module.exports, "resolveInitialLocale", () => $082e79695298041e$export$831a5617a2963db1);
$parcel$export(module.exports, "applyDocumentLocale", () => $082e79695298041e$export$fff0f9a021c4ca38);
// ─────────────────────────────────────────────────────────────────────────────
// The locale registry — the one place that knows which languages exist.
//
// Adding a language is meant to be a data change, not a code change: append an
// entry here, drop a folder under `translations/`, register its loaders in
// loader.js, and every picker, formatter and direction switch picks it up. No
// component, screen or service is allowed to branch on a locale id — if a
// behaviour differs per language it belongs in the descriptor below.
//
// See docs/I18N.md for the full walkthrough.
//
// THE BRAND (ui/lib/brand.js) narrows this list and moves its defaults, never
// the descriptors' data: `locales` decides which of these languages are OFFERED
// (`isOfferedLocale` — every resolver below asks it, so a language the brand does
// not offer is never started in, cached or adopted from the server), and
// `defaultLocale` is the first-visit language. `calendar` swaps each descriptor's
// calendar through the descriptor's own `calendars` data. With no brand all three
// are exactly what they were.
// ─────────────────────────────────────────────────────────────────────────────

var $eLeza = parcelRequire("eLeza");
// The wall clock every descriptor below formats on. ONE constant rather than a
// literal per language, so that putting the panel on the CLINIC's zone
// (PM-0088, `clinics.timezone`) is a change to one line, not to every locale.
const $082e79695298041e$var$CLINIC_TIME_ZONE = 'Asia/Tehran';
// The twelve Jalali months as the English UI spells them, index 0 = Farvardin.
// French uses this list wherever it shows a Jalali month (PM-0185, D8) instead
// of ICU's French data («ordibehešt», «khordâd»), which reads as scholarly
// transliteration and is spelled differently by different ICU builds — the
// kit's date picker and the server's text use the same twelve words. German
// (PM-0212) uses the same list rather than ICU's «Ordibehescht», «Mordād».
const $082e79695298041e$var$JALALI_MONTHS_LATIN = [
    'Farvardin',
    'Ordibehesht',
    'Khordad',
    'Tir',
    'Mordad',
    'Shahrivar',
    'Mehr',
    'Aban',
    'Azar',
    'Dey',
    'Bahman',
    'Esfand'
];
const $082e79695298041e$export$e49c1078bc46f17 = {
    // i18n-exempt: a locale's `label` is its ENDONYM — the name the language
    // gives itself — so it is deliberately not translated. «فارسی» stays «فارسی»
    // in the English UI, the same way «English» stays «English» in the Persian
    // one; that is what makes a language switcher usable to someone who cannot
    // read the current language. `weekdaySeparator` is likewise locale data.
    fa: {
        id: 'fa',
        label: "\u0641\u0627\u0631\u0633\u06CC",
        englishLabel: 'Persian',
        dir: 'rtl',
        // -u-ca-persian → Jalali (Shamsi) calendar; -u-nu-arabext → Persian digits.
        intl: 'fa-IR-u-ca-persian-nu-arabext',
        calendar: 'jalali',
        calendars: {
            gregory: {
                intl: 'fa-IR-u-ca-gregory-nu-arabext'
            }
        },
        timeZone: $082e79695298041e$var$CLINIC_TIME_ZONE,
        // What goes between the weekday and the rest of a long date. See the
        // `full` style in format.js for why this is spelled out here rather than
        // left to `dateStyle: 'full'`.
        weekdaySeparator: "\u060C ",
        // Persian is the only language that reads the drug registry's own names.
        readsPersianData: true
    },
    en: {
        id: 'en',
        label: 'English',
        englishLabel: 'English',
        dir: 'ltr',
        intl: 'en-US',
        calendar: 'gregory',
        calendars: {
            // A brand on the Jalali calendar everywhere. ICU appends the era ("AP")
            // to a calendar that is not the language's own.
            jalali: {
                intl: 'en-US-u-ca-persian',
                stripEra: true
            },
            // A brand on the Gregorian calendar has no Jalali clinic months: the
            // analysis timeline grids on Gregorian months there (lib/analysisTimeline).
            gregory: {
                clinicCalendarIntl: undefined
            }
        },
        timeZone: $082e79695298041e$var$CLINIC_TIME_ZONE,
        weekdaySeparator: ', ',
        // English dates are Gregorian, but a few surfaces are Jalali in EVERY
        // language because the clinic itself is — the analysis timeline's month
        // axis is gridded on Jalali month boundaries, so labelling those lines
        // «August» would name a month that does not start there. ICU renders the
        // Jalali months in Latin for this tag: «Farvardin», «Mordad».
        clinicCalendarIntl: 'en-US-u-ca-persian'
    },
    // i18n-exempt: endonym and locale data, exactly as for `fa` above — «العربية»
    // is the name Arabic gives itself and stays «العربية» in every UI language.
    // A second marker is needed because the first one's exemption ends with the
    // `fa` descriptor it introduces, and the audit cannot tell Arabic script from
    // Persian: both live in U+0600–U+06FF.
    ar: {
        id: 'ar',
        label: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
        englishLabel: 'Arabic',
        dir: 'rtl',
        // JALALI, not Gregorian. An Iranian clinic runs on the Jalali calendar —
        // the day sheet, the appointment book and the accounting period are all
        // Jalali — and the date PICKER (@parsina/framework JalaliDatePicker, which
        // follows <html lang> since v0.19.0) draws Arabic on the Jalali calendar
        // too, to match this tag. Handing Arabic `ar-EG` here would
        // mean a doctor picks ۱۴۰۴/۰۵/۱۲ and reads back «٣ أغسطس ٢٠٢٥»: the same
        // class of transcription error the 24-hour clock rule in format.js exists
        // to prevent. -u-nu-arab → Arabic-Indic digits (٠١٢…), which is what an
        // Arabic reader expects and is a DIFFERENT set from Persian's arabext.
        intl: 'ar-u-ca-persian-nu-arab',
        calendar: 'jalali',
        calendars: {
            // On the Gregorian calendar two corrections below are Jalali-only: the
            // month names are Jalali names, and day-first is how Arabic writes a
            // Gregorian date.
            gregory: {
                intl: 'ar-u-ca-gregory-nu-arab',
                monthNames: undefined,
                numericDateOrder: undefined
            }
        },
        timeZone: $082e79695298041e$var$CLINIC_TIME_ZONE,
        weekdaySeparator: "\u060C ",
        // ICU's Arabic patterns for the Persian calendar disagree with the clinic's
        // conventions in three ways. Correcting them here, as data, is what keeps
        // format.js free of locale ids — see the descriptor notes above.
        dateStyles: {
            // ICU gives Arabic an ALL-NUMERIC medium («١٢‏/٠٥‏/١٤٠٤») where both other
            // locales give a month name («۱۲ مرداد ۱۴۰۴», «Aug 3, 2025»). `medium` is
            // the default shape, on nearly every row in the app, so it is the one
            // that has to stay readable.
            medium: {
                day: 'numeric',
                month: 'long',
                year: 'numeric'
            }
        },
        // ICU appends «ه‍.ش» (with a ZWJ) to every Arabic-on-Persian-calendar shape
        // but `dayMonth`. It is noise next to a Persian date that never carries it,
        // and `era: undefined` does not suppress it.
        stripEra: true,
        // ICU orders the numeric Arabic date day-first («١٢/٥/١٤٠٤») where Persian
        // writes it year-first («۱۴۰۴/۵/۱۲»). Two RTL languages disagreeing about
        // the same calendar on the same screen is how a date gets transcribed wrong.
        numericDateOrder: [
            'year',
            'month',
            'day'
        ],
        // CLDR's ARABIC month names for the Persian calendar are corrupted: six of
        // the twelve are not words in any language. Verified against ICU 78, and
        // identical for every ar-* region (ar, ar-EG, ar-IQ, ar-SA):
        //
        //   ICU says   فرفردن · أذربيهشت · تار · شهرفار · آيان · اسفندار
        //   should be  فروردين · ارديبهشت · تير · شهريور · آبان · اسفند
        //
        // A month name sits on every visit row, every day sheet and every printed
        // prescription, so this cannot be left to upstream. Index 0 = فروردين.
        monthNames: [
            "\u0641\u0631\u0648\u0631\u062F\u064A\u0646",
            "\u0627\u0631\u062F\u064A\u0628\u0647\u0634\u062A",
            "\u062E\u0631\u062F\u0627\u062F",
            "\u062A\u064A\u0631",
            "\u0645\u0631\u062F\u0627\u062F",
            "\u0634\u0647\u0631\u064A\u0648\u0631",
            "\u0645\u0647\u0631",
            "\u0622\u0628\u0627\u0646",
            "\u0622\u0630\u0631",
            "\u062F\u064A",
            "\u0628\u0647\u0645\u0646",
            "\u0627\u0633\u0641\u0646\u062F"
        ]
    },
    // French mirrors English (PM-0185, D3): Gregorian, with the clinic's Jalali
    // surfaces on `clinicCalendarIntl`. No `monthNames` on the descriptor itself
    // — on `fr-FR` they would rename the GREGORIAN months — and no
    // `readsPersianData`: a French reader reads the drug registry's Latin name.
    fr: {
        id: 'fr',
        label: "Fran\xe7ais",
        englishLabel: 'French',
        dir: 'ltr',
        intl: 'fr-FR',
        calendar: 'gregory',
        calendars: {
            // A brand on the Jalali calendar everywhere: drop the era ICU appends
            // («A. P.») and name the months as the English UI does.
            jalali: {
                intl: 'fr-FR-u-ca-persian',
                stripEra: true,
                monthNames: $082e79695298041e$var$JALALI_MONTHS_LATIN
            },
            gregory: {
                clinicCalendarIntl: undefined,
                clinicMonthNames: undefined
            }
        },
        timeZone: $082e79695298041e$var$CLINIC_TIME_ZONE,
        // «dimanche 3 août 2025» — French joins the weekday without a comma.
        weekdaySeparator: ' ',
        clinicCalendarIntl: 'fr-FR-u-ca-persian',
        clinicMonthNames: $082e79695298041e$var$JALALI_MONTHS_LATIN
    },
    // German mirrors English exactly as French does (PM-0212): Gregorian, the
    // clinic's Jalali surfaces on `clinicCalendarIntl` with the fixed month list,
    // no `monthNames` on the descriptor (on `de-DE` they would rename the
    // GREGORIAN months) and no `readsPersianData`.
    de: {
        id: 'de',
        label: 'Deutsch',
        englishLabel: 'German',
        dir: 'ltr',
        intl: 'de-DE',
        calendar: 'gregory',
        calendars: {
            // A brand on the Jalali calendar everywhere: drop the era ICU appends
            // («AP») and name the months as the English UI does.
            jalali: {
                intl: 'de-DE-u-ca-persian',
                stripEra: true,
                monthNames: $082e79695298041e$var$JALALI_MONTHS_LATIN
            },
            gregory: {
                clinicCalendarIntl: undefined,
                clinicMonthNames: undefined
            }
        },
        timeZone: $082e79695298041e$var$CLINIC_TIME_ZONE,
        // «Sonntag, 3. August 2025» — German joins the weekday with a comma.
        weekdaySeparator: ', ',
        clinicCalendarIntl: 'de-DE-u-ca-persian',
        clinicMonthNames: $082e79695298041e$var$JALALI_MONTHS_LATIN
    }
};
const $082e79695298041e$export$d953adbca2df8efa = Object.keys($082e79695298041e$export$e49c1078bc46f17);
const $082e79695298041e$export$1af4c7e47ad72f44 = 'fa';
const $082e79695298041e$export$95b7602913551865 = 'en';
const $082e79695298041e$export$4d2fb7344096e022 = [
    'common',
    'nav',
    'validation',
    'errors',
    'auth',
    'settings',
    'dashboard',
    'patient',
    'visit',
    'prescription',
    'encounters',
    'accounting',
    'credits',
    'clinic',
    'messages'
];
const $082e79695298041e$export$17a6a815985c8621 = (id)=>Object.prototype.hasOwnProperty.call($082e79695298041e$export$e49c1078bc46f17, id);
const $082e79695298041e$export$60d894e7aa1bc86e = ()=>(0, $eLeza.brandLocales)($082e79695298041e$export$d953adbca2df8efa);
const $082e79695298041e$export$d14eda3de108abc4 = (id)=>$082e79695298041e$export$17a6a815985c8621(id) && $082e79695298041e$export$60d894e7aa1bc86e().includes(id);
function $082e79695298041e$export$171765a6a37c37cd() {
    const ids = $082e79695298041e$export$60d894e7aa1bc86e();
    if (ids.length === $082e79695298041e$export$d953adbca2df8efa.length) return $082e79695298041e$export$e49c1078bc46f17;
    return Object.fromEntries(ids.map((id)=>[
            id,
            $082e79695298041e$export$e49c1078bc46f17[id]
        ]));
}
const $082e79695298041e$export$1ad85a23f306da6d = ()=>(0, $eLeza.brandDefaultLocale)($082e79695298041e$export$1af4c7e47ad72f44, $082e79695298041e$export$d953adbca2df8efa);
const $082e79695298041e$export$57270fb1f2649979 = (id)=>{
    const descriptor = $082e79695298041e$export$e49c1078bc46f17[id] || $082e79695298041e$export$e49c1078bc46f17[$082e79695298041e$export$1ad85a23f306da6d()];
    const calendar = (0, $eLeza.calendarSystem)(null);
    if (!calendar) return descriptor;
    // Applied even on the locale's own calendar: a Gregorian brand has no Jalali
    // clinic months, in English too (`en`'s `calendars.gregory`).
    const override = descriptor.calendars?.[calendar];
    if (!override && calendar === descriptor.calendar) return descriptor;
    return {
        ...descriptor,
        ...override,
        calendar: calendar
    };
};
function $082e79695298041e$export$dca0327c9b9c6498(tag) {
    if (!tag) return null;
    const raw = String(tag).trim();
    const base = raw.toLowerCase().split(/[-_]/)[0];
    const id = $082e79695298041e$export$17a6a815985c8621(raw) ? raw : $082e79695298041e$export$17a6a815985c8621(base) ? base : null;
    return id && $082e79695298041e$export$d14eda3de108abc4(id) ? id : null;
}
const $082e79695298041e$export$86880b4b2e1a2384 = 'parsina.locale';
function $082e79695298041e$export$9e89f130e918dc2a() {
    try {
        return $082e79695298041e$export$dca0327c9b9c6498(window.localStorage.getItem($082e79695298041e$export$86880b4b2e1a2384));
    } catch  {
        // Private mode, disabled storage, or no window at all (tests, SSR).
        return null;
    }
}
function $082e79695298041e$export$e8146f0b19c81b97(id) {
    try {
        if ($082e79695298041e$export$d14eda3de108abc4(id)) window.localStorage.setItem($082e79695298041e$export$86880b4b2e1a2384, id);
    } catch  {
    /* A locale we cannot cache still works — it just re-resolves next launch. */ }
}
function $082e79695298041e$export$25ddc0816bb523ad() {
    if (typeof navigator === 'undefined') return null;
    const candidates = navigator.languages?.length ? navigator.languages : [
        navigator.language
    ];
    for (const tag of candidates){
        const match = $082e79695298041e$export$dca0327c9b9c6498(tag);
        if (match) return match;
    }
    return null;
}
function $082e79695298041e$export$831a5617a2963db1() {
    return $082e79695298041e$export$9e89f130e918dc2a() || $082e79695298041e$export$25ddc0816bb523ad() || (0, $eLeza.brandDefaultLocale)($082e79695298041e$export$95b7602913551865, $082e79695298041e$export$d953adbca2df8efa);
}
function $082e79695298041e$export$fff0f9a021c4ca38(id) {
    const locale = $082e79695298041e$export$d14eda3de108abc4(id) ? id : $082e79695298041e$export$1ad85a23f306da6d();
    const root = typeof document !== 'undefined' ? document.documentElement : null;
    if (root) {
        root.setAttribute('lang', locale);
        root.setAttribute('dir', $082e79695298041e$export$e49c1078bc46f17[locale].dir);
    }
    // The landscape notice (J-17) is drawn by CSS, because a rotated phone must
    // be told something even before React has mounted — but its COPY is UI text
    // like any other and has to follow the panel language. `attr()` is how a
    // stylesheet reads a translated string, so the attribute is stamped here,
    // beside the two that already mirror the locale onto the document.
    if (typeof document !== 'undefined' && document.body) document.body.setAttribute('data-rotate-notice', $082e79695298041e$var$ROTATE_NOTICE[locale] || $082e79695298041e$var$ROTATE_NOTICE[$082e79695298041e$export$1af4c7e47ad72f44]);
    return locale;
}
// Deliberately NOT in the JSON catalogues: this string is read by a stylesheet
// before the catalogues are loaded, so it has to exist at module scope. Five
// short sentences are a smaller cost than a landscape phone showing nothing.
// i18n-exempt: read by CSS `attr()` before the catalogues resolve.
const $082e79695298041e$var$ROTATE_NOTICE = {
    fa: "\u0628\u0631\u0627\u06CC \u0627\u0633\u062A\u0641\u0627\u062F\u0647\u060C \u06AF\u0648\u0634\u06CC \u0631\u0627 \u0639\u0645\u0648\u062F\u06CC \u0628\u06AF\u06CC\u0631\u06CC\u062F.",
    en: 'Turn your phone upright to continue.',
    ar: "\u0623\u062F\u0650\u0631 \u0647\u0627\u062A\u0641\u0643 \u0639\u0645\u0648\u062F\u064A\u064B\u0627 \u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629.",
    fr: "Tournez votre t\xe9l\xe9phone en position verticale pour continuer.",
    de: 'Drehen Sie Ihr Telefon ins Hochformat, um fortzufahren.'
};

});

parcelRegister("dHfod", function(module, exports) {

$parcel$export(module.exports, "loadCatalog", () => $9f8b3a8c6854f9d7$export$5bd1a830868d1d11);
$parcel$export(module.exports, "peekCatalog", () => $9f8b3a8c6854f9d7$export$d2d95d0a2b5fab1e);
$parcel$export(module.exports, "preloadCatalog", () => $9f8b3a8c6854f9d7$export$f2675afc1de9f02e);
// ─────────────────────────────────────────────────────────────────────────────
// Translation loading + cache.
//
// Every namespace is its own `import()`, so Parcel code-splits each feature's
// strings into its own asset and a locale is only ever downloaded once someone
// actually selects it. English is not on the wire for a doctor who never leaves
// Persian.
//
// Two caches, both process-lifetime:
//   `cache`    locale/namespace → the parsed bundle. A second switch back to a
//              language is synchronous — nothing is re-fetched or re-parsed.
//   `inflight` locale/namespace → the in-progress promise, so N simultaneous
//              requests for the same file share one network round trip.
//
// The map below is written out by hand rather than built from a template
// literal because Parcel resolves `import()` statically: a computed specifier
// would silently produce a bundle with no translations in it.
// ─────────────────────────────────────────────────────────────────────────────

var $Hy6Lb = parcelRequire("Hy6Lb");











































































const $9f8b3a8c6854f9d7$var$IMPORTERS = {
    fa: {
        common: ()=>(parcelRequire("iCILN")),
        nav: ()=>(parcelRequire("2Efq0")),
        validation: ()=>(parcelRequire("ckeeW")),
        errors: ()=>(parcelRequire("8lVvN")),
        auth: ()=>(parcelRequire("CQy1v")),
        settings: ()=>(parcelRequire("NflAS")),
        dashboard: ()=>(parcelRequire("kdVQU")),
        patient: ()=>(parcelRequire("ame9z")),
        visit: ()=>(parcelRequire("iD84Q")),
        prescription: ()=>(parcelRequire("a7Q3E")),
        encounters: ()=>(parcelRequire("cJvos")),
        accounting: ()=>(parcelRequire("9R5PW")),
        credits: ()=>(parcelRequire("78DTD")),
        clinic: ()=>(parcelRequire("iT2YQ")),
        messages: ()=>(parcelRequire("5mY5e"))
    },
    en: {
        common: ()=>(parcelRequire("lNvL9")),
        nav: ()=>(parcelRequire("gBrPR")),
        validation: ()=>(parcelRequire("bDYv5")),
        errors: ()=>(parcelRequire("gWxY7")),
        auth: ()=>(parcelRequire("hIn0O")),
        settings: ()=>(parcelRequire("5J2T0")),
        dashboard: ()=>(parcelRequire("cV51U")),
        patient: ()=>(parcelRequire("gQg8c")),
        visit: ()=>(parcelRequire("b8aGV")),
        prescription: ()=>(parcelRequire("3P1Wb")),
        encounters: ()=>(parcelRequire("lfTfn")),
        accounting: ()=>(parcelRequire("h3grK")),
        credits: ()=>(parcelRequire("4T5MT")),
        clinic: ()=>(parcelRequire("bfJWC")),
        messages: ()=>(parcelRequire("bHiRm"))
    },
    ar: {
        common: ()=>(parcelRequire("6BP30")),
        nav: ()=>(parcelRequire("a9o8l")),
        validation: ()=>(parcelRequire("jghYY")),
        errors: ()=>(parcelRequire("91Cv7")),
        auth: ()=>(parcelRequire("glFDs")),
        settings: ()=>(parcelRequire("jtK7w")),
        dashboard: ()=>(parcelRequire("hjY7S")),
        patient: ()=>(parcelRequire("h6fJE")),
        visit: ()=>(parcelRequire("7WHIK")),
        prescription: ()=>(parcelRequire("a4xAw")),
        encounters: ()=>(parcelRequire("5Cez0")),
        accounting: ()=>(parcelRequire("fX9Li")),
        credits: ()=>(parcelRequire("3nPy4")),
        clinic: ()=>(parcelRequire("1hO0Y")),
        messages: ()=>(parcelRequire("lcJSW"))
    },
    fr: {
        common: ()=>(parcelRequire("76xjv")),
        nav: ()=>(parcelRequire("g1Ye1")),
        validation: ()=>(parcelRequire("2N6cP")),
        errors: ()=>(parcelRequire("25s6v")),
        auth: ()=>(parcelRequire("eUNXO")),
        settings: ()=>(parcelRequire("bxnQo")),
        dashboard: ()=>(parcelRequire("lWaBS")),
        patient: ()=>(parcelRequire("aPptq")),
        visit: ()=>(parcelRequire("2OSR6")),
        prescription: ()=>(parcelRequire("9nPf3")),
        encounters: ()=>(parcelRequire("4mFT6")),
        accounting: ()=>(parcelRequire("j6A54")),
        credits: ()=>(parcelRequire("eqoOz")),
        clinic: ()=>(parcelRequire("3qrxk")),
        messages: ()=>(parcelRequire("dbiKS"))
    },
    de: {
        common: ()=>(parcelRequire("jSif7")),
        nav: ()=>(parcelRequire("kjU67")),
        validation: ()=>(parcelRequire("gpDcS")),
        errors: ()=>(parcelRequire("g3bis")),
        auth: ()=>(parcelRequire("91uqt")),
        settings: ()=>(parcelRequire("g3GTC")),
        dashboard: ()=>(parcelRequire("iq9fy")),
        patient: ()=>(parcelRequire("kPTBp")),
        visit: ()=>(parcelRequire("4LWwp")),
        prescription: ()=>(parcelRequire("lYG2J")),
        encounters: ()=>(parcelRequire("jrkZp")),
        accounting: ()=>(parcelRequire("juJew")),
        credits: ()=>(parcelRequire("jfBqp")),
        clinic: ()=>(parcelRequire("cGELz")),
        messages: ()=>(parcelRequire("eBXc9"))
    }
};
const $9f8b3a8c6854f9d7$var$cache = new Map();
const $9f8b3a8c6854f9d7$var$inflight = new Map();
const $9f8b3a8c6854f9d7$var$cacheKey = (locale, namespace)=>`${locale}/${namespace}`;
// Parcel hands back a module namespace object; the JSON is on `default` for a
// JSON asset, but a plain object comes through untouched under Jest's transform.
const $9f8b3a8c6854f9d7$var$unwrap = (mod)=>mod && mod.default || mod || {};
function $9f8b3a8c6854f9d7$export$3c148aa2c2f6601d(locale, namespace) {
    const key = $9f8b3a8c6854f9d7$var$cacheKey(locale, namespace);
    if ($9f8b3a8c6854f9d7$var$cache.has(key)) return Promise.resolve($9f8b3a8c6854f9d7$var$cache.get(key));
    if ($9f8b3a8c6854f9d7$var$inflight.has(key)) return $9f8b3a8c6854f9d7$var$inflight.get(key);
    const importer = $9f8b3a8c6854f9d7$var$IMPORTERS[locale]?.[namespace];
    if (!importer) {
        $9f8b3a8c6854f9d7$var$cache.set(key, {});
        return Promise.resolve({});
    }
    const promise = importer().then((mod)=>$9f8b3a8c6854f9d7$var$unwrap(mod)).catch((err)=>{
        return {};
    }).then((bundle)=>{
        $9f8b3a8c6854f9d7$var$cache.set(key, bundle);
        $9f8b3a8c6854f9d7$var$inflight.delete(key);
        return bundle;
    });
    $9f8b3a8c6854f9d7$var$inflight.set(key, promise);
    return promise;
}
function $9f8b3a8c6854f9d7$export$5bd1a830868d1d11(locale) {
    if (!(0, $Hy6Lb.isSupportedLocale)(locale)) return Promise.resolve({});
    return Promise.all((0, $Hy6Lb.NAMESPACES).map((ns)=>$9f8b3a8c6854f9d7$export$3c148aa2c2f6601d(locale, ns).then((bundle)=>[
                ns,
                bundle
            ]))).then(Object.fromEntries);
}
function $9f8b3a8c6854f9d7$export$d2d95d0a2b5fab1e(locale) {
    const entries = (0, $Hy6Lb.NAMESPACES).map((ns)=>[
            ns,
            $9f8b3a8c6854f9d7$var$cache.get($9f8b3a8c6854f9d7$var$cacheKey(locale, ns))
        ]);
    return entries.every(([, bundle])=>bundle !== undefined) ? Object.fromEntries(entries) : null;
}
function $9f8b3a8c6854f9d7$export$f2675afc1de9f02e(locale) {
    $9f8b3a8c6854f9d7$export$5bd1a830868d1d11(locale).catch(()=>{});
}
function $9f8b3a8c6854f9d7$export$ff2d99e7c0f75ee6() {
    $9f8b3a8c6854f9d7$var$cache.clear();
    $9f8b3a8c6854f9d7$var$inflight.clear();
}

});
parcelRegister("iCILN", function(module, exports) {
module.exports = import("6gmlX").then(()=>parcelRequire('3fFOk'));

});

parcelRegister("2Efq0", function(module, exports) {
module.exports = import("8nunk").then(()=>parcelRequire('8bT9F'));

});

parcelRegister("ckeeW", function(module, exports) {
module.exports = import("3aK9q").then(()=>parcelRequire('9fo9N'));

});

parcelRegister("8lVvN", function(module, exports) {
module.exports = import("e8b6w").then(()=>parcelRequire('ccETr'));

});

parcelRegister("CQy1v", function(module, exports) {
module.exports = import("801bc").then(()=>parcelRequire('ewg5Z'));

});

parcelRegister("NflAS", function(module, exports) {
module.exports = import("91XV7").then(()=>parcelRequire('hRPKf'));

});

parcelRegister("kdVQU", function(module, exports) {
module.exports = import("4BKEJ").then(()=>parcelRequire('12sAr'));

});

parcelRegister("ame9z", function(module, exports) {
module.exports = import("9Dfw0").then(()=>parcelRequire('fjV3a'));

});

parcelRegister("iD84Q", function(module, exports) {
module.exports = import("c49La").then(()=>parcelRequire('863mN'));

});

parcelRegister("a7Q3E", function(module, exports) {
module.exports = import("iRekQ").then(()=>parcelRequire('bfb2V'));

});

parcelRegister("cJvos", function(module, exports) {
module.exports = import("lKx08").then(()=>parcelRequire('7eTsj'));

});

parcelRegister("9R5PW", function(module, exports) {
module.exports = import("90ArL").then(()=>parcelRequire('clHbB'));

});

parcelRegister("78DTD", function(module, exports) {
module.exports = import("21tfh").then(()=>parcelRequire('5mEfs'));

});

parcelRegister("iT2YQ", function(module, exports) {
module.exports = import("7yAhl").then(()=>parcelRequire('bUn2j'));

});

parcelRegister("5mY5e", function(module, exports) {
module.exports = import("hr8kB").then(()=>parcelRequire('7M9Vd'));

});

parcelRegister("lNvL9", function(module, exports) {
module.exports = import("84Zxf").then(()=>parcelRequire('iZxX2'));

});

parcelRegister("gBrPR", function(module, exports) {
module.exports = import("9Q3ZC").then(()=>parcelRequire('wHk8H'));

});

parcelRegister("bDYv5", function(module, exports) {
module.exports = import("bI2YL").then(()=>parcelRequire('1zImr'));

});

parcelRegister("gWxY7", function(module, exports) {
module.exports = import("5y0GB").then(()=>parcelRequire('aQQ2a'));

});

parcelRegister("hIn0O", function(module, exports) {
module.exports = import("27oK8").then(()=>parcelRequire('ckTj6'));

});

parcelRegister("5J2T0", function(module, exports) {
module.exports = import("2Ty8Y").then(()=>parcelRequire('esECq'));

});

parcelRegister("cV51U", function(module, exports) {
module.exports = import("27bjU").then(()=>parcelRequire('fghHP'));

});

parcelRegister("gQg8c", function(module, exports) {
module.exports = import("k7VTP").then(()=>parcelRequire('6c0qc'));

});

parcelRegister("b8aGV", function(module, exports) {
module.exports = import("73B2k").then(()=>parcelRequire('dttTe'));

});

parcelRegister("3P1Wb", function(module, exports) {
module.exports = import("yX7Kv").then(()=>parcelRequire('lSGr9'));

});

parcelRegister("lfTfn", function(module, exports) {
module.exports = import("f3dA3").then(()=>parcelRequire('Gefsl'));

});

parcelRegister("h3grK", function(module, exports) {
module.exports = import("iVfcT").then(()=>parcelRequire('9vzcX'));

});

parcelRegister("4T5MT", function(module, exports) {
module.exports = import("c1En5").then(()=>parcelRequire('55Xcr'));

});

parcelRegister("bfJWC", function(module, exports) {
module.exports = import("fBH5M").then(()=>parcelRequire('epYjV'));

});

parcelRegister("bHiRm", function(module, exports) {
module.exports = import("fTYrC").then(()=>parcelRequire('3Hm0p'));

});

parcelRegister("6BP30", function(module, exports) {
module.exports = import("iPcmV").then(()=>parcelRequire('clsvA'));

});

parcelRegister("a9o8l", function(module, exports) {
module.exports = import("id1zk").then(()=>parcelRequire('4R55T'));

});

parcelRegister("jghYY", function(module, exports) {
module.exports = import("e8wKv").then(()=>parcelRequire('2hPzL'));

});

parcelRegister("91Cv7", function(module, exports) {
module.exports = import("7YJuj").then(()=>parcelRequire('fANYT'));

});

parcelRegister("glFDs", function(module, exports) {
module.exports = import("cgLMV").then(()=>parcelRequire('9Gxgv'));

});

parcelRegister("jtK7w", function(module, exports) {
module.exports = import("gP4Nf").then(()=>parcelRequire('14oyD'));

});

parcelRegister("hjY7S", function(module, exports) {
module.exports = import("lCUkw").then(()=>parcelRequire('a6rxM'));

});

parcelRegister("h6fJE", function(module, exports) {
module.exports = import("4K60i").then(()=>parcelRequire('gUIvD'));

});

parcelRegister("7WHIK", function(module, exports) {
module.exports = import("izKRn").then(()=>parcelRequire('6RdJM'));

});

parcelRegister("a4xAw", function(module, exports) {
module.exports = import("5ec4v").then(()=>parcelRequire('igzTm'));

});

parcelRegister("5Cez0", function(module, exports) {
module.exports = import("s0FnF").then(()=>parcelRequire('7vc1I'));

});

parcelRegister("fX9Li", function(module, exports) {
module.exports = import("5a1Kt").then(()=>parcelRequire('aT9dd'));

});

parcelRegister("3nPy4", function(module, exports) {
module.exports = import("e0FVI").then(()=>parcelRequire('lR7By'));

});

parcelRegister("1hO0Y", function(module, exports) {
module.exports = import("fLTZ1").then(()=>parcelRequire('8514w'));

});

parcelRegister("lcJSW", function(module, exports) {
module.exports = import("5eqER").then(()=>parcelRequire('idKo5'));

});

parcelRegister("76xjv", function(module, exports) {
module.exports = import("7VEW7").then(()=>parcelRequire('9Pkgf'));

});

parcelRegister("g1Ye1", function(module, exports) {
module.exports = import("8Re5F").then(()=>parcelRequire('5YJDf'));

});

parcelRegister("2N6cP", function(module, exports) {
module.exports = import("fVkd5").then(()=>parcelRequire('f5YoQ'));

});

parcelRegister("25s6v", function(module, exports) {
module.exports = import("e8FSN").then(()=>parcelRequire('2ANeL'));

});

parcelRegister("eUNXO", function(module, exports) {
module.exports = import("da3Rs").then(()=>parcelRequire('gFeZn'));

});

parcelRegister("bxnQo", function(module, exports) {
module.exports = import("h0NGL").then(()=>parcelRequire('fLIiE'));

});

parcelRegister("lWaBS", function(module, exports) {
module.exports = import("7Mxqq").then(()=>parcelRequire('cOcEw'));

});

parcelRegister("aPptq", function(module, exports) {
module.exports = import("aP44P").then(()=>parcelRequire('eIQWC'));

});

parcelRegister("2OSR6", function(module, exports) {
module.exports = import("cNCKG").then(()=>parcelRequire('lnimO'));

});

parcelRegister("9nPf3", function(module, exports) {
module.exports = import("3ejjY").then(()=>parcelRequire('25KTX'));

});

parcelRegister("4mFT6", function(module, exports) {
module.exports = import("beHlc").then(()=>parcelRequire('92sKj'));

});

parcelRegister("j6A54", function(module, exports) {
module.exports = import("9nZoC").then(()=>parcelRequire('5cng4'));

});

parcelRegister("eqoOz", function(module, exports) {
module.exports = import("iqq6C").then(()=>parcelRequire('lktHt'));

});

parcelRegister("3qrxk", function(module, exports) {
module.exports = import("i6FTm").then(()=>parcelRequire('akhwZ'));

});

parcelRegister("dbiKS", function(module, exports) {
module.exports = import("lHfPH").then(()=>parcelRequire('fCkfa'));

});

parcelRegister("jSif7", function(module, exports) {
module.exports = import("kg8tD").then(()=>parcelRequire('7urM6'));

});

parcelRegister("kjU67", function(module, exports) {
module.exports = import("28ioZ").then(()=>parcelRequire('kl609'));

});

parcelRegister("gpDcS", function(module, exports) {
module.exports = import("dQxyG").then(()=>parcelRequire('3SE3Y'));

});

parcelRegister("g3bis", function(module, exports) {
module.exports = import("iE3IZ").then(()=>parcelRequire('28dHZ'));

});

parcelRegister("91uqt", function(module, exports) {
module.exports = import("hFseJ").then(()=>parcelRequire('cXTPw'));

});

parcelRegister("g3GTC", function(module, exports) {
module.exports = import("24UOY").then(()=>parcelRequire('4aA4k'));

});

parcelRegister("iq9fy", function(module, exports) {
module.exports = import("aswky").then(()=>parcelRequire('78ItA'));

});

parcelRegister("kPTBp", function(module, exports) {
module.exports = import("cfF0b").then(()=>parcelRequire('6NcVH'));

});

parcelRegister("4LWwp", function(module, exports) {
module.exports = import("chjGM").then(()=>parcelRequire('9MxQf'));

});

parcelRegister("lYG2J", function(module, exports) {
module.exports = import("cv94K").then(()=>parcelRequire('gnli1'));

});

parcelRegister("jrkZp", function(module, exports) {
module.exports = import("j5Q7l").then(()=>parcelRequire('f0g5h'));

});

parcelRegister("juJew", function(module, exports) {
module.exports = import("2brEZ").then(()=>parcelRequire('95Bwp'));

});

parcelRegister("jfBqp", function(module, exports) {
module.exports = import("1laMH").then(()=>parcelRequire('fv7kO'));

});

parcelRegister("cGELz", function(module, exports) {
module.exports = import("fnRY4").then(()=>parcelRequire('lYwvd'));

});

parcelRegister("eBXc9", function(module, exports) {
module.exports = import("eBbUt").then(()=>parcelRequire('fukMS'));

});


parcelRegister("4xMUZ", function(module, exports) {

$parcel$export(module.exports, "createTranslator", () => $34f030a12b1d4a12$export$6f3122ee6dbd9f46);
// ─────────────────────────────────────────────────────────────────────────────
// The translator — key → string. Pure, synchronous, and it never throws.
//
// A key is FULLY QUALIFIED and its first segment is the namespace:
//
//     t('settings.language.title')   → translations/<locale>/settings.json
//                                      → { language: { title: … } }
//
// One rule, no per-call configuration, and a key is enough to find the string
// on disk. That matters more than the keystrokes a scoped `t` would save: the
// question asked in front of a screen is always "where does this text live".
//
// Resolution order for every lookup:
//   1. the active locale — the brand's `strings` overlay, then the catalogue
//   2. FALLBACK_LOCALE (English — the source catalogue, where every key exists),
//      overlay first in the same way
//   3. the key's last segment, humanised
//
// Step 3 exists so a missing key degrades to something a doctor can still read
// rather than to a crash or an empty button. Steps 2 and 3 log once per key in
// development and stay silent in production.
//
// THE BRAND (ui/lib/brand.js). A catalogue value names the product as
// `{{brand}}`, its credit as `{{coin}}` / `{{coinEz}}` and its tagline as
// `{{tagline}}`; those resolve here, in the language of the catalogue the text
// came from, with no value passed by the caller. With no brand configured they
// resolve to the words the catalogue used to spell out, so the output is what it
// always was (clinical/__tests__/brandParity.test.js).
// ─────────────────────────────────────────────────────────────────────────────

var $Hy6Lb = parcelRequire("Hy6Lb");

var $eLeza = parcelRequire("eLeza");
const $34f030a12b1d4a12$var$isDev = false;
// One warning per key per session. A missing key inside a list that renders on
// every keystroke would otherwise bury the console it is trying to inform.
const $34f030a12b1d4a12$var$warned = new Set();
function $34f030a12b1d4a12$var$warnOnce(message) {
    if (!$34f030a12b1d4a12$var$isDev) return;
    if ($34f030a12b1d4a12$var$warned.has(message)) return;
    $34f030a12b1d4a12$var$warned.add(message);
    console.warn(`[i18n] ${message}`);
}
function $34f030a12b1d4a12$export$d141035fe52f4cd7() {
    $34f030a12b1d4a12$var$warned.clear();
}
/**
 * `settings.language.title` → `catalog.settings.language.title`, or undefined.
 * Dotted segments only; a value that is not a string or array is treated as a
 * miss, so pointing a key at a whole subtree reports as missing instead of
 * rendering `[object Object]`.
 */ function $34f030a12b1d4a12$var$lookup(catalog, key) {
    if (!catalog || !key) return undefined;
    let node = catalog;
    for (const segment of key.split('.')){
        if (node == null || typeof node !== 'object') return undefined;
        node = node[segment];
    }
    return typeof node === 'string' || Array.isArray(node) ? node : undefined;
}
/**
 * `lookup`, with the brand's own text for `key` in `locale` asked first — the
 * `strings` overlay a deployment uses for wording a token cannot express.
 */ function $34f030a12b1d4a12$var$find(catalog, locale, key) {
    const own = (0, $eLeza.brandString)(locale, key);
    if (typeof own === 'string' || Array.isArray(own)) return own;
    return $34f030a12b1d4a12$var$lookup(catalog, key);
}
/**
 * `{{name}}` → the matching value. An unknown placeholder is left verbatim so
 * the gap is visible in review rather than silently swallowed.
 *
 * A NUMBER is interpolated through the locale's number formatter, not
 * `String()`. «۳ مورد» is the Persian for "3 items"; «3 مورد» is a half-
 * translated string, and it is the single easiest way for Latin digits to leak
 * into an otherwise Persian screen — every count, total and threshold in the
 * app arrives through this function.
 *
 * Pass a STRING when a number must not be grouped or localised — a year, a
 * version, an ICD code. That is the escape hatch, and it is explicit at the
 * call site rather than inferred from magnitude.
 *
 * Values are inserted as text: this returns a string for React to render as a
 * text node, so there is no HTML parsing and nothing to escape. Interpolating
 * markup is deliberately impossible — a string that needs a bold span is two
 * keys and a component, not a template.
 *
 * A placeholder the caller did not name may be a BRAND token (`{{brand}}`,
 * `{{coin}}`, `{{coinEz}}`, `{{tagline}}`, optionally with an inline default:
 * `{{brand|بارسينا}}`) — resolved for `locale`, the language of the template.
 * One pass, so a caller's value that happens to contain `{{brand}}` is inserted
 * as written and never resolved.
 */ function $34f030a12b1d4a12$var$interpolate(template, values, formatNumber, locale) {
    if (template.indexOf('{{') === -1) return template;
    return template.replace((0, $eLeza.PLACEHOLDER), (match, name, inline)=>{
        const named = values != null && Object.prototype.hasOwnProperty.call(values, name);
        if (!named) {
            const token = (0, $eLeza.brandToken)(name, locale, inline);
            if (token !== undefined) return token;
        }
        const value = values?.[name];
        if (value == null) return match;
        if (typeof value === 'number' && Number.isFinite(value)) return formatNumber(value);
        return String(value);
    });
}
/**
 * Plural suffix for `count`, using the locale's own CLDR rules — Persian has
 * `one`/`other`, English has `one`/`other`, and a language added later with six
 * forms works without touching this file.
 *
 * `key_zero` is honoured ahead of the CLDR category when it exists, because
 * "no appointments" is usually a different sentence rather than a different
 * number, in every language.
 */ function $34f030a12b1d4a12$var$pluralKey(get, key, count, pluralRules) {
    if (count === 0 && get(`${key}_zero`) !== undefined) return `${key}_zero`;
    const category = pluralRules ? pluralRules.select(count) : 'other';
    if (get(`${key}_${category}`) !== undefined) return `${key}_${category}`;
    if (get(`${key}_other`) !== undefined) return `${key}_other`;
    return key;
}
/** `settings.language.title` → `Title`. The last-resort rendering. */ function $34f030a12b1d4a12$var$humanise(key) {
    const last = String(key).split('.').pop() || String(key);
    return last.replace(/[_-]+/g, ' ').replace(/([a-z0-9])([A-Z])/g, '$1 $2').replace(/^./, (c)=>c.toUpperCase());
}
function $34f030a12b1d4a12$export$6f3122ee6dbd9f46({ locale: locale, catalog: catalog, fallbackCatalog: fallbackCatalog, pluralRules: pluralRules, joinList: joinList, formatNumber: formatNumber, fallbackLocale: fallbackLocale = (0, $Hy6Lb.FALLBACK_LOCALE) }) {
    const join = joinList || ((items)=>items.join(', '));
    const num = formatNumber || ((n)=>String(n));
    const active = (key)=>$34f030a12b1d4a12$var$find(catalog, locale, key);
    const fallback = (key)=>$34f030a12b1d4a12$var$find(fallbackCatalog, fallbackLocale, key);
    /**
   * @param {string} key    fully-qualified, e.g. 'common.actions.save'
   * @param {object} [vars] interpolation values; `count` also selects the plural
   * @returns {string}      always a string, even when everything is missing
   */ function t(key, vars) {
        if (typeof key !== 'string' || !key) {
            $34f030a12b1d4a12$var$warnOnce(`t() called with a non-string key: ${JSON.stringify(key)}`);
            return '';
        }
        const hasCount = vars != null && typeof vars.count === 'number';
        // Active locale.
        let resolved = hasCount ? $34f030a12b1d4a12$var$pluralKey(active, key, vars.count, pluralRules) : key;
        let value = active(resolved);
        let from = locale;
        // Fallback locale.
        if (value === undefined && fallbackCatalog && fallbackCatalog !== catalog) {
            const fallbackResolved = hasCount ? $34f030a12b1d4a12$var$pluralKey(fallback, key, vars.count, pluralRules) : key;
            value = fallback(fallbackResolved);
            from = fallbackLocale;
            if (value !== undefined) $34f030a12b1d4a12$var$warnOnce(`missing key "${key}" in "${locale}" \u{2014} fell back to English`);
        }
        // Nothing anywhere.
        if (value === undefined) {
            $34f030a12b1d4a12$var$warnOnce(`missing key "${key}" in every locale \u{2014} showing the key`);
            return $34f030a12b1d4a12$var$humanise(key);
        }
        // A key whose value is an array joined for `t`; `tList` returns the array.
        if (Array.isArray(value)) return join(value.map((item)=>$34f030a12b1d4a12$var$interpolate(String(item), vars, num, from)));
        return $34f030a12b1d4a12$var$interpolate(value, vars, num, from);
    }
    /**
   * A key whose value is a JSON array, as an array — for bullet lists and
   * option sets, so a translator can add or drop an item without a code change.
   * Always an array, empty when the key is missing.
   */ function tList(key, vars) {
        let value = active(key);
        let from = locale;
        if (value === undefined) {
            value = fallback(key);
            from = fallbackLocale;
        }
        if (!Array.isArray(value)) {
            if (value === undefined) $34f030a12b1d4a12$var$warnOnce(`missing list key "${key}"`);
            return [];
        }
        return value.map((item)=>$34f030a12b1d4a12$var$interpolate(String(item), vars, num, from));
    }
    /** Whether a key resolves anywhere — for conditionally-rendered optional copy. */ function has(key) {
        return active(key) !== undefined || fallback(key) !== undefined;
    }
    return {
        t: t,
        tList: tList,
        has: has
    };
}

});

parcelRegister("asXy3", function(module, exports) {

$parcel$export(module.exports, "createFormatters", () => $79eab5f6e33897ad$export$c3f4cd5551df13fd);
$parcel$export(module.exports, "createMoneyUnit", () => $79eab5f6e33897ad$export$9b6501e8a1c6bef1);
$parcel$export(module.exports, "MIRROR_ICON", () => $79eab5f6e33897ad$export$ddb338179359cccc);
// ─────────────────────────────────────────────────────────────────────────────
// Locale-aware formatting: dates, times, numbers, money, relative time.
//
// Everything here is driven by the locale descriptor's `intl` tag, which
// carries the calendar and numbering system as Unicode extensions
// (`fa-IR-u-ca-persian-nu-arabext`). That is what makes "add a language" a
// data change: no formatter in this file branches on a locale id, and the
// Jalali↔Gregorian switch is a consequence of the tag, not an `if`.
//
// Where ICU's own data for a locale disagrees with how an Iranian clinic writes
// a date — or is simply wrong — the correction is declared on the DESCRIPTOR
// (`dateStyles`, `stripEra`, `numericDateOrder`, `monthNames`) and applied
// generically below. That is the escape hatch that keeps the rule above true:
// the knowledge that Arabic on the Persian calendar needs an era stripped and
// six of CLDR's twelve month names replaced lives with the locale, not in here.
//
// Two rules that are not negotiable:
//
//   • MONEY. Every service, gRPC message and GraphQL field in Parsina carries
//     an integer number of MINOR UNITS of the document's currency — WHOLE RIALS
//     for IRR, which is also what a blank currency means. Humans read TOMAN for
//     IRR: `formatMoney` takes rials and renders toman, exactly like
//     @parsina/framework's `fmtToman` — it only adds the locale. Passing a toman
//     figure to it bills a tenth of what was meant. Another currency is passed
//     as `{ currency }` and read through the kit's `currency` table; two
//     currencies are never added or compared.
//
//   • TIME ZONE. A clinic runs on Iran local time whatever language the UI is
//     in: an appointment at 14:30 is 14:30 in Tehran, not in the browser's
//     zone. Every date formatter pins `timeZone` from the descriptor.
//
// Instances are memoised per (locale, shape) because constructing an
// Intl.DateTimeFormat is expensive relative to using one, and these run inside
// list rows that re-render on every keystroke.
// ─────────────────────────────────────────────────────────────────────────────

var $Hy6Lb = parcelRequire("Hy6Lb");

var $lHVFz = parcelRequire("lHVFz");
const $79eab5f6e33897ad$var$memo = new Map();
function $79eab5f6e33897ad$var$intl(Ctor, name, locale, options) {
    const key = `${name}|${locale}|${JSON.stringify(options)}`;
    let instance = $79eab5f6e33897ad$var$memo.get(key);
    if (!instance) {
        instance = new Ctor(locale, options);
        $79eab5f6e33897ad$var$memo.set(key, instance);
    }
    return instance;
}
/** Anything date-ish → Date, or null when it is not a usable instant. */ function $79eab5f6e33897ad$var$toDate(value) {
    if (value == null || value === '') return null;
    const date = value instanceof Date ? value : new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
}
// What an empty/unparseable value renders as. An em dash reads as "no value"
// in both scripts and never looks like a zero.
const $79eab5f6e33897ad$var$EMPTY = "\u2014";
// Named date shapes, so screens ask for a meaning rather than a field list and
// every «visit date» in the app looks the same.
//
//   short    ۱۴۰۴/۵/۱۲            8/3/25          dense tables
//   medium   ۱۲ مرداد ۱۴۰۴        Aug 3, 2025     the default
//   long     ۱۲ مرداد ۱۴۰۴        August 3, 2025  headers
//   full     یکشنبه، ۱۲ مرداد ۱۴۰۴ Sunday, …      day views
//   dayMonth ۱۲ مرداد            Aug 3           calendar chrome
//   weekdayDayMonth  یکشنبه، ۱۲ مرداد   Sunday, Aug 3   day navigator
//
// A descriptor may override individual shapes through its `dateStyles` field
// when ICU's pattern for that locale disagrees with how an Iranian clinic
// writes the date — see `ar` in config.js. The override is data, not a branch.
const $79eab5f6e33897ad$var$DATE_STYLES = {
    short: {
        dateStyle: 'short'
    },
    medium: {
        dateStyle: 'medium'
    },
    long: {
        dateStyle: 'long'
    },
    dayMonth: {
        day: 'numeric',
        month: 'long'
    },
    monthYear: {
        month: 'long',
        year: 'numeric'
    },
    // The month alone — for a chart's month gridline, where the year is carried
    // by the one tick that crosses it rather than repeated on all twelve.
    month: {
        month: 'long'
    }
};
/**
 * Drop the era designator ICU appends when a locale is asked for a calendar
 * that is not its own default: Arabic on the Persian calendar renders
 * «١٢ مرداد ١٤٠٤ ه‍.ش», and `era: undefined` does not suppress it. The literal
 * that only ever joined the era to the date goes with it, so nothing is left
 * dangling at either end.
 */ function $79eab5f6e33897ad$var$dropEra(parts) {
    if (!parts.some((part)=>part.type === 'era')) return parts;
    return parts.filter((part, i)=>{
        if (part.type === 'era') return false;
        if (part.type !== 'literal') return true;
        return parts[i - 1]?.type !== 'era' && parts[i + 1]?.type !== 'era';
    });
}
// Any Unicode decimal digit — Arabic-Indic ٠-٩ and Persian ۰-۹ included. Used
// to tell a numeric month («٥») from a month NAME («مرداد») without knowing
// which numbering system is in play.
const $79eab5f6e33897ad$var$DIGITS_ONLY = /^\p{Nd}+$/u;
const $79eab5f6e33897ad$var$DATE_FIELDS = [
    'year',
    'month',
    'day'
];
/** A month rendered as a NAME rather than as digits. */ const $79eab5f6e33897ad$var$isNamedMonth = (part)=>part.type === 'month' && !$79eab5f6e33897ad$var$DIGITS_ONLY.test(part.value);
/**
 * Substitute the descriptor's own month names for ICU's, for the locales where
 * CLDR's data for this language/calendar pairing is wrong. Only a month
 * rendered as a name is touched — a numeric month is already correct, and
 * replacing it would turn «٥» into a word.
 */ function $79eab5f6e33897ad$var$withMonthNames(parts, names, monthNumber) {
    const replacement = names[monthNumber - 1];
    if (!replacement) return parts;
    return parts.map((part)=>$79eab5f6e33897ad$var$isNamedMonth(part) ? {
            ...part,
            value: replacement
        } : part);
}
/**
 * Re-order an ALL-NUMERIC date into the descriptor's field order, keeping the
 * separator the locale itself chose. ICU writes the numeric Arabic date
 * day-first while Persian writes it year-first, and two RTL languages
 * disagreeing about the same calendar on the same screen is how a date gets
 * transcribed wrong.
 *
 * Returns null — meaning "leave this one alone" — for any shape that is not
 * exactly three numeric fields and their separators, so a month name, a
 * weekday or a time is never reordered.
 */ function $79eab5f6e33897ad$var$reorderNumericDate(parts, order) {
    const fields = parts.filter((part)=>$79eab5f6e33897ad$var$DATE_FIELDS.includes(part.type));
    if (fields.length !== 3) return null;
    if (!fields.every((part)=>$79eab5f6e33897ad$var$DIGITS_ONLY.test(part.value))) return null;
    if (parts.some((part)=>part.type !== 'literal' && !$79eab5f6e33897ad$var$DATE_FIELDS.includes(part.type))) return null;
    const value = Object.fromEntries(fields.map((part)=>[
            part.type,
            part.value
        ]));
    const separator = parts.find((part)=>part.type === 'literal')?.value ?? '/';
    return order.map((type)=>value[type]).join(separator);
}
function $79eab5f6e33897ad$export$c3f4cd5551df13fd(localeId) {
    const { intl: tag, timeZone: timeZone, weekdaySeparator: weekdaySeparator = ', ', dateStyles: styleOverrides, stripEra: stripEra, numericDateOrder: numericDateOrder, monthNames: monthNames, clinicCalendarIntl: clinicCalendarIntl, clinicMonthNames: clinicMonthNames } = (0, $Hy6Lb.localeDescriptor)(localeId);
    // Surfaces that are Jalali in every language fall back to the locale's own
    // tag, which is already Jalali for `fa` and `ar`.
    const clinicTag = clinicCalendarIntl || tag;
    const dateTime = (options)=>$79eab5f6e33897ad$var$intl(Intl.DateTimeFormat, 'dt', tag, {
            timeZone: timeZone,
            ...options
        });
    const number = (options)=>$79eab5f6e33897ad$var$intl(Intl.NumberFormat, 'n', tag, options);
    /** The options for a named shape, with the locale's override applied. */ const styleOptions = (style)=>{
        const name = $79eab5f6e33897ad$var$DATE_STYLES[style] || styleOverrides?.[style] ? style : 'medium';
        return styleOverrides?.[name] || $79eab5f6e33897ad$var$DATE_STYLES[name];
    };
    /**
   * The month's number (1-12) in this locale's own calendar. Forced to Latin
   * digits so it is an index rather than a glyph run — the tag's `-nu-` would
   * otherwise hand back «٥».
   */ const monthNumber = (date, calendarTag = tag)=>Number($79eab5f6e33897ad$var$intl(Intl.DateTimeFormat, 'dt', calendarTag, {
            timeZone: timeZone,
            month: 'numeric',
            numberingSystem: 'latn'
        }).format(date));
    /**
   * One date shape, with the descriptor's corrections applied. A locale that
   * declares none of them goes straight through ICU untouched, which is every
   * locale but `ar`.
   */ const renderDate = (date, style)=>{
        const formatter = dateTime(styleOptions(style));
        if (!stripEra && !numericDateOrder && !monthNames) return formatter.format(date);
        let parts = formatter.formatToParts(date);
        if (stripEra) parts = $79eab5f6e33897ad$var$dropEra(parts);
        if (monthNames && parts.some($79eab5f6e33897ad$var$isNamedMonth)) parts = $79eab5f6e33897ad$var$withMonthNames(parts, monthNames, monthNumber(date));
        if (numericDateOrder) {
            const reordered = $79eab5f6e33897ad$var$reorderNumericDate(parts, numericDateOrder);
            if (reordered !== null) return reordered;
        }
        return parts.map((part)=>part.value).join('').trim();
    };
    /**
   * The month of the CLINIC's calendar — Jalali — in the reading locale's
   * language and digits, whatever calendar that locale otherwise uses.
   *
   * The analysis timeline grids its axis on Jalali month boundaries, because
   * «this month» to an Iranian clinic means the Jalali month on the wall. A
   * gridline standing at 1 Mordad must therefore be labelled «مرداد» /
   * «Mordad», not «August» — the Gregorian month that line does not start.
   *
   * Composed from parts rather than asked for as a pattern, for two reasons ICU
   * forces: every locale puts the year on a different side of the month (Persian
   * emits «۱۴۰۴ مرداد», English «Mordad 1404»), and a non-default calendar drags
   * an era along with it («1404 AP», «١٤٠٤ ه‍.ش»). An axis label has to be the
   * same shape in all three languages and has no room for an era.
   */ const formatClinicMonth = (value, { withYear: withYear = false } = {})=>{
        const date = $79eab5f6e33897ad$var$toDate(value);
        if (!date) return $79eab5f6e33897ad$var$EMPTY;
        const options = {
            month: 'long',
            ...withYear ? {
                year: 'numeric'
            } : {}
        };
        let parts = $79eab5f6e33897ad$var$intl(Intl.DateTimeFormat, 'dt', clinicTag, {
            timeZone: timeZone,
            ...options
        }).formatToParts(date);
        parts = $79eab5f6e33897ad$var$dropEra(parts);
        // A locale whose clinic surfaces are on a calendar of their own names those
        // months from `clinicMonthNames` (French: «Mordad», not ICU's «mordâd»);
        // its own `monthNames` belong to the other calendar. Counted on the clinic
        // calendar, which for `fa`/`ar` is the locale's own.
        const names = clinicCalendarIntl ? clinicMonthNames : monthNames;
        if (names && parts.some($79eab5f6e33897ad$var$isNamedMonth)) parts = $79eab5f6e33897ad$var$withMonthNames(parts, names, monthNumber(date, clinicTag));
        const month = parts.find((part)=>part.type === 'month')?.value ?? '';
        const year = parts.find((part)=>part.type === 'year')?.value ?? '';
        return withYear && year ? `${month} ${year}` : month;
    };
    /**
   * A date in one of the named shapes above.
   *
   * `full` is composed rather than delegated to `dateStyle: 'full'`. Node's
   * bundled ICU emits the Persian full pattern as year–month–day–weekday
   * («۱۴۰۴ مرداد ۱۲، یکشنبه»), which is both wrong for Persian and the reverse
   * of what the same ICU gives for `long`. Browsers disagree with it and with
   * each other. Composing weekday + long date makes the one date shape a
   * doctor reads at the top of a day sheet identical everywhere, which matters
   * more here than deferring to CLDR.
   */ const formatDate = (value, style = 'medium')=>{
        const date = $79eab5f6e33897ad$var$toDate(value);
        if (!date) return $79eab5f6e33897ad$var$EMPTY;
        // `full` and `weekdayDayMonth` are the two composed shapes.
        if (style === 'full' || style === 'weekdayDayMonth') {
            const weekday = dateTime({
                weekday: 'long'
            }).format(date);
            const rest = renderDate(date, style === 'full' ? 'long' : 'dayMonth');
            return `${weekday}${weekdaySeparator}${rest}`;
        }
        return renderDate(date, style);
    };
    /**
   * Clock time, 24-hour in every locale. Iranian clinical scheduling is written
   * and spoken in 24-hour time, and an English UI for an Iranian clinic that
   * suddenly says "2:30 PM" while the printed day sheet says 14:30 is a
   * transcription error waiting to happen.
   */ const formatTime = (value)=>{
        const date = $79eab5f6e33897ad$var$toDate(value);
        if (!date) return $79eab5f6e33897ad$var$EMPTY;
        return dateTime({
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        }).format(date);
    };
    const formatDateTime = (value, style = 'medium')=>{
        const date = $79eab5f6e33897ad$var$toDate(value);
        if (!date) return $79eab5f6e33897ad$var$EMPTY;
        return `${formatDate(date, style)} ${formatTime(date)}`;
    };
    /**
   * Weekday name. The three widths are NOT what the names suggest in Persian,
   * so pick by looking at the output rather than by analogy with English:
   *
   *   long    یکشنبه   Sunday   الأحد
   *   short   یکشنبه   Sun      الأحد     ← Persian/Arabic `short` is the FULL word
   *   narrow  ی        S        ح
   *
   * A one-letter chip — the reception week strip — needs `narrow`; anything that
   * reads as a word needs `long`. `short` only differs from `long` in English.
   */ const formatWeekday = (value, width = 'long')=>{
        const date = $79eab5f6e33897ad$var$toDate(value);
        if (!date) return $79eab5f6e33897ad$var$EMPTY;
        return dateTime({
            weekday: width
        }).format(date);
    };
    /**
   * A plain count — NOT money, so no toman conversion. Persian digits in `fa`,
   * Latin in `en`, grouped in both.
   */ const formatNumber = (value, options)=>{
        if (value == null || value === '' || !Number.isFinite(Number(value))) return $79eab5f6e33897ad$var$EMPTY;
        return number(options).format(Number(value));
    };
    const formatPercent = (value, options)=>{
        if (value == null || !Number.isFinite(Number(value))) return $79eab5f6e33897ad$var$EMPTY;
        return number({
            style: 'percent',
            maximumFractionDigits: 0,
            ...options
        }).format(Number(value) / 100);
    };
    /**
   * Clinic money: MINOR UNITS of `currency` in → the figure a human reads out.
   *
   * No currency — or '' or 'IRR' — is the contract this always had: WHOLE RIALS
   * in, a toman figure out, and `withUnit` appends the caller's `unitLabel` (the
   * app's own «تومان»/«toman» catalogue word), or nothing when there is none.
   *
   * Any other currency is divided by its own divisor and shown with its own
   * fraction digits (USD 2, KWD 3) in this locale's digits. With `withUnit` its
   * unit is the currency table's word — `unitStyle` 'long' («US dollar»,
   * default) or 'short' («USD») — and a caller's `unitLabel` is IGNORED: at every
   * call site written before currencies existed it is a toman word, and a
   * non-IRR figure must never read «تومان». A code outside the table throws.
   */ const formatMoney = (amountMinor, { currency: currency, withUnit: withUnit = false, unitLabel: unitLabel = '', unitStyle: unitStyle = 'long' } = {})=>{
        const info = (0, $lHVFz.currencyInfo)(currency);
        if (info.code !== (0, $lHVFz.DEFAULT_CURRENCY)) {
            const value = (0, $lHVFz.toDisplay)(amountMinor, info.code);
            if (value == null) return $79eab5f6e33897ad$var$EMPTY;
            const text = number({
                minimumFractionDigits: info.minDisplayDecimals,
                maximumFractionDigits: info.maxDisplayDecimals
            }).format(value);
            return withUnit ? `${text} ${(0, $lHVFz.unitLabel)(info.code, localeId, unitStyle)}` : text;
        }
        if (amountMinor == null || amountMinor === '' || !Number.isFinite(Number(amountMinor))) return $79eab5f6e33897ad$var$EMPTY;
        const toman = Number(amountMinor) / 10; // IRR: whole rials → toman
        // Prices are entered in toman so sub-toman precision cannot exist, but a
        // percentage discount can land on a half-toman: show it rather than
        // silently rounding money away.
        const text = number({
            maximumFractionDigits: 1
        }).format(toman);
        return withUnit && unitLabel ? `${text} ${unitLabel}` : text;
    };
    /**
   * «۳ روز پیش» / «3 days ago». Picks the largest unit that fits, so a two-hour
   * gap reads in hours and a two-month gap in months.
   */ const formatRelativeTime = (value, now = Date.now())=>{
        const date = $79eab5f6e33897ad$var$toDate(value);
        if (!date) return $79eab5f6e33897ad$var$EMPTY;
        const rtf = $79eab5f6e33897ad$var$intl(Intl.RelativeTimeFormat, 'rt', tag, {
            numeric: 'auto'
        });
        const deltaSeconds = (date.getTime() - now) / 1000;
        const units = [
            [
                'year',
                31536000
            ],
            [
                'month',
                2592000
            ],
            [
                'week',
                604800
            ],
            [
                'day',
                86400
            ],
            [
                'hour',
                3600
            ],
            [
                'minute',
                60
            ]
        ];
        for (const [unit, seconds] of units){
            if (Math.abs(deltaSeconds) >= seconds) return rtf.format(Math.round(deltaSeconds / seconds), unit);
        }
        return rtf.format(Math.round(deltaSeconds), 'second');
    };
    /** «الف، ب و ج» / «a, b, and c» — grammatically correct list joining. */ const formatList = (items, type = 'conjunction')=>{
        const list = (items || []).filter((item)=>item != null && item !== '').map(String);
        if (!list.length) return '';
        if (typeof Intl.ListFormat !== 'function') return list.join(', ');
        return $79eab5f6e33897ad$var$intl(Intl.ListFormat, 'lf', tag, {
            style: 'long',
            type: type
        }).format(list);
    };
    /**
   * Digits only, in the locale's numbering system, with NO grouping — for
   * things that are digit strings rather than quantities: a national id, a
   * medical-council code, a file number. Grouping one of those would read as a
   * different identifier.
   */ // '0'…'9' in this locale's numbering system, resolved once.
    const digitMap = Array.from({
        length: 10
    }, (_, d)=>number({
            useGrouping: false
        }).format(d));
    const formatDigits = (value)=>{
        if (value == null || value === '') return '';
        return String(value).replace(/\d/g, (d)=>digitMap[Number(d)]);
    };
    return {
        formatDate: formatDate,
        formatTime: formatTime,
        formatDateTime: formatDateTime,
        formatWeekday: formatWeekday,
        formatClinicMonth: formatClinicMonth,
        formatNumber: formatNumber,
        formatPercent: formatPercent,
        formatMoney: formatMoney,
        formatRelativeTime: formatRelativeTime,
        formatList: formatList,
        formatDigits: formatDigits
    };
}
function $79eab5f6e33897ad$export$9b6501e8a1c6bef1(t, localeId) {
    return (currency, style = 'long')=>{
        const info = (0, $lHVFz.currencyInfo)(currency);
        if (info.code === (0, $lHVFz.DEFAULT_CURRENCY)) return t(style === 'short' ? 'common.units.tomanShort' : 'common.units.toman');
        return (0, $lHVFz.unitLabel)(info.code, localeId, style);
    };
}
const $79eab5f6e33897ad$export$3433559efc22d110 = {
    dir: 'ltr',
    style: {
        unicodeBidi: 'isolate'
    }
};
const $79eab5f6e33897ad$export$ddb338179359cccc = {
    transform: 'scaleX(var(--dir-flip, 1))'
};

});


parcelRegister("LNQP4", function(module, exports) {

$parcel$export(module.exports, "default", () => $08fb0f44759e108b$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $eLeza = parcelRequire("eLeza");

var $4rEI6 = parcelRequire("4rEI6");

var $Hy6Lb = parcelRequire("Hy6Lb");

var $asXy3 = parcelRequire("asXy3");

var $4xMUZ = parcelRequire("4xMUZ");
// ─────────────────────────────────────────────────────────────────────────────
// The only way a component reads a string.
//
//   const { t, formatDate, isRTL } = useTranslation();
//   <button>{t('common.actions.save')}</button>
//
// Keys are always fully qualified — the first segment names the file the string
// lives in (see translator.js). There is no scoped/`useTranslation('visit')`
// form on purpose: one rule means a key you see in a screen is a key you can
// grep for, and a string cannot be reached by two different names.
// ─────────────────────────────────────────────────────────────────────────────
// Rendered outside a provider — a component under test, or an error boundary
// that caught the provider itself. It reports the product's default locale (the
// brand's, when it names one) and translates to the humanised key rather than
// throwing, because "no translations" must never be the reason a clinical
// screen fails to render. Rebuilt if the brand changes after the first build.
let $08fb0f44759e108b$var$orphan = null;
let $08fb0f44759e108b$var$orphanRevision = -1;
function $08fb0f44759e108b$var$orphanValue() {
    if (!$08fb0f44759e108b$var$orphan || $08fb0f44759e108b$var$orphanRevision !== (0, $eLeza.brandRevision)()) {
        $08fb0f44759e108b$var$orphanRevision = (0, $eLeza.brandRevision)();
        const locale = (0, $Hy6Lb.productDefaultLocale)();
        const descriptor = (0, $Hy6Lb.localeDescriptor)(locale);
        const formatters = (0, $asXy3.createFormatters)(locale);
        const { t: t, tList: tList, has: has } = (0, $4xMUZ.createTranslator)({
            locale: locale,
            catalog: {},
            fallbackCatalog: {},
            joinList: formatters.formatList,
            formatNumber: formatters.formatNumber
        });
        $08fb0f44759e108b$var$orphan = {
            locale: locale,
            dir: descriptor.dir,
            isRTL: descriptor.dir === 'rtl',
            readsPersianData: descriptor.readsPersianData === true,
            locales: {},
            t: t,
            tList: tList,
            has: has,
            ...formatters,
            moneyUnit: (0, $asXy3.createMoneyUnit)(t, locale),
            setLocale: ()=>{},
            preloadLocale: ()=>{},
            ready: false
        };
    }
    return $08fb0f44759e108b$var$orphan;
}
function $08fb0f44759e108b$export$9fc83ad70ead8663() {
    return (0, $acw62.useContext)((0, $4rEI6.I18nContext)) ?? $08fb0f44759e108b$var$orphanValue();
}
var $08fb0f44759e108b$export$2e2bcd8739ae039 = $08fb0f44759e108b$export$9fc83ad70ead8663;

});


parcelRegister("ifPys", function(module, exports) {

$parcel$export(module.exports, "useVisitNow", () => $d4a19e66fd774091$export$c65c97d5e4ce4848);

var $acw62 = parcelRequire("acw62");

var $eVM84 = parcelRequire("eVM84");

var $lMO3H = parcelRequire("lMO3H");

var $e317r = parcelRequire("e317r");

var $eBrFc = parcelRequire("eBrFc");
// ─────────────────────────────────────────────────────────────────────────────
// «ویزیت همین الان» — the patient is in front of the doctor and has no نوبت today
// (PM-0535, docs/PATIENT_RECORD_VISIT_NOW_PLAN.md).
//
// One press: the doctor BFF's `visitPatientNow` either finds the row the patient
// already has today at the chosen clinic or books «خارج از نوبت همین الان» (no hour,
// `arrived`, a ticket number), and the doctor lands in the ordinary visit room,
// whose own «شروع ویزیت» starts it. This hook never books anything itself and never
// decides who may — the BFF re-reads the membership, the clinic's grant, its
// subscription and the doctor's shift at write time; what is read here only lets
// the button SAY why it is off before it is pressed.
// ─────────────────────────────────────────────────────────────────────────────
const $d4a19e66fd774091$var$BOOKING_CLINICS = `query VisitNowClinics { myBookingClinics { clinicId name isOwner canBookDirectly readOnly } }`;
const $d4a19e66fd774091$var$VISIT_NOW = `mutation VisitPatientNow($patientId: ID!, $clinicId: ID!) {
  visitPatientNow(patientId: $patientId, clinicId: $clinicId) { created appointment { id status clinicId } }
}`;
// One read of the doctor's booking clinics serves every button on screen:
// «سوابق ویزیت» puts one on each row (PM-0566), and twenty rows must not be twenty
// identical requests. Short-lived, so a grant the clinic changes is seen on the next
// screen; a refusal that says the list went stale reads it again at once.
const $d4a19e66fd774091$var$CLINICS_TTL_MS = 30000;
let $d4a19e66fd774091$var$clinicsCache = null; // { at, promise }
function $d4a19e66fd774091$var$loadBookingClinics(force) {
    const now = Date.now();
    if (!force && $d4a19e66fd774091$var$clinicsCache && now - $d4a19e66fd774091$var$clinicsCache.at < $d4a19e66fd774091$var$CLINICS_TTL_MS) return $d4a19e66fd774091$var$clinicsCache.promise;
    const promise = (0, $eVM84.bffQuery)($d4a19e66fd774091$var$BOOKING_CLINICS).then((data)=>data?.myBookingClinics || []);
    $d4a19e66fd774091$var$clinicsCache = {
        at: now,
        promise: promise
    };
    // A failed read is not remembered: the next button asks again.
    promise.catch(()=>{
        if ($d4a19e66fd774091$var$clinicsCache?.promise === promise) $d4a19e66fd774091$var$clinicsCache = null;
    });
    return promise;
}
function $d4a19e66fd774091$export$d81abf8e7b0e0e54() {
    $d4a19e66fd774091$var$clinicsCache = null;
}
// A refusal that means the list this hook holds has gone stale (the clinic withdrew
// the grant, ended the membership or lapsed since the page loaded).
const $d4a19e66fd774091$var$STALE_CODES = new Set([
    'UNTIMED_NEEDS_GRANT',
    'BOOKING_NOT_ALLOWED',
    'SUBSCRIPTION_REQUIRED'
]);
function $d4a19e66fd774091$export$e93f5a6a644b4a52(clinics, { activeClinicId: activeClinicId = '', latestVisitClinicId: latestVisitClinicId = '' } = {}) {
    const all = clinics || [];
    const eligible = all.filter((c)=>c.canBookDirectly && !c.readOnly);
    if (eligible.length === 0) {
        const blockedBy = all.length === 0 ? null : all.some((c)=>!c.readOnly) ? 'grant' : 'readOnly';
        return {
            eligible: eligible,
            clinicId: null,
            blockedBy: blockedBy
        };
    }
    const has = (id)=>!!id && id !== (0, $lMO3H.ALL_CLINICS) && eligible.some((c)=>c.clinicId === id);
    let clinicId = null;
    if (has(activeClinicId)) clinicId = activeClinicId;
    else if (has(latestVisitClinicId)) clinicId = latestVisitClinicId;
    else if (eligible.length === 1) clinicId = eligible[0].clinicId;
    return {
        eligible: eligible,
        clinicId: clinicId,
        blockedBy: null
    };
}
function $d4a19e66fd774091$export$a74c2d1d27476c8f(err, fallback) {
    return err?.extensions?.messageKey && err?.message ? String(err.message) : fallback;
}
function $d4a19e66fd774091$export$c65c97d5e4ce4848(patient, fallbackError) {
    const enabled = (0, $e317r.hostVisitNow)();
    const navigate = (0, $eBrFc.useAppNavigate)();
    const patientId = patient?.id || '';
    // null = not answered yet; [] = the doctor books at no clinic (the button is absent).
    const [clinics, setClinics] = (0, $acw62.useState)(null);
    const [clinicsFailed, setClinicsFailed] = (0, $acw62.useState)(false);
    const [nonce, setNonce] = (0, $acw62.useState)(0);
    const [picking, setPicking] = (0, $acw62.useState)(false);
    const [busy, setBusy] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)('');
    const busyRef = (0, $acw62.useRef)(false);
    const aliveRef = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(()=>{
        aliveRef.current = true;
        return ()=>{
            aliveRef.current = false;
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!enabled) return undefined;
        let alive = true;
        setClinicsFailed(false);
        $d4a19e66fd774091$var$loadBookingClinics(nonce > 0).then((list)=>{
            if (alive) setClinics(list);
        }).catch((err)=>{
            if (!alive) return;
            console.warn('[visitNow] booking clinics unavailable:', err?.message);
            setClinicsFailed(true);
            setClinics((prev)=>prev || []);
        });
        return ()=>{
            alive = false;
        };
    }, [
        enabled,
        nonce
    ]);
    const latestVisitClinicId = [
        ...patient?.encounters || []
    ].sort((a, b)=>(b.scheduledDate || b.createdAt || '').localeCompare(a.scheduledDate || a.createdAt || '')).find((e)=>e.clinicId)?.clinicId || '';
    const choice = $d4a19e66fd774091$export$e93f5a6a644b4a52(clinics, {
        activeClinicId: (0, $lMO3H.readActiveClinicId)(),
        latestVisitClinicId: latestVisitClinicId
    });
    const book = (0, $acw62.useCallback)(async (clinicId)=>{
        if (busyRef.current || !patientId || !clinicId) return;
        busyRef.current = true;
        setBusy(true);
        setError('');
        setPicking(false);
        try {
            await (0, $eVM84.bffMutation)($d4a19e66fd774091$var$VISIT_NOW, {
                patientId: patientId,
                clinicId: clinicId
            });
            // The visit room is the feedback: it opens on the row just found or booked.
            navigate('visit', {
                id: patientId,
                patientId: patientId
            });
        } catch (err) {
            const code = err?.extensions?.code || err?.graphQLErrors?.[0]?.extensions?.code;
            if (aliveRef.current) {
                setError($d4a19e66fd774091$export$a74c2d1d27476c8f(err, fallbackError));
                if ($d4a19e66fd774091$var$STALE_CODES.has(code)) setNonce((n)=>n + 1);
            }
        } finally{
            busyRef.current = false;
            if (aliveRef.current) setBusy(false);
        }
    }, [
        patientId,
        navigate,
        fallbackError
    ]);
    // The button: straight through with a preferred clinic, else ask which one.
    const press = (0, $acw62.useCallback)(()=>{
        if (busyRef.current) return;
        if (choice.clinicId) book(choice.clinicId);
        else if (choice.eligible.length > 1) setPicking((v)=>!v);
    }, [
        choice.clinicId,
        choice.eligible.length,
        book
    ]);
    return {
        enabled: enabled,
        loading: enabled && clinics === null,
        unavailable: clinicsFailed && (clinics || []).length === 0,
        hidden: !enabled || clinics !== null && clinics.length === 0 && !clinicsFailed,
        blockedBy: choice.blockedBy,
        eligible: choice.eligible,
        picking: picking,
        busy: busy,
        error: error,
        press: press,
        book: book,
        dismissError: ()=>setError('')
    };
}
var $d4a19e66fd774091$export$2e2bcd8739ae039 = $d4a19e66fd774091$export$c65c97d5e4ce4848;

});
parcelRegister("eVM84", function(module, exports) {

$parcel$export(module.exports, "LONG_REQUEST_TIMEOUT_MS", () => $adebb901af88e18b$export$5c63bf3ded5aa229);
$parcel$export(module.exports, "panelLanguage", () => $adebb901af88e18b$export$7f5d9d25e625ad97);
$parcel$export(module.exports, "bffQuery", () => $adebb901af88e18b$export$7fb4864174f056c);
$parcel$export(module.exports, "bffMutation", () => $adebb901af88e18b$export$8395d0fc0d822a81);

var $a83Oj = parcelRequire("a83Oj");

var $k9wwH = parcelRequire("k9wwH");

var $cwVZP = parcelRequire("cwVZP");

var $jX9up = parcelRequire("jX9up");

var $b9X92 = parcelRequire("b9X92");
// How long a single GraphQL round trip may take before we stop waiting.
//
// Without this a request on a dead connection hangs until the browser's own
// timeout — minutes, on mobile networks — and the screen sits on its skeleton
// the whole time, which reads as "the app is broken" rather than "this is
// slow". 30s is well past the slowest real query (the AI ones) and well short
// of a doctor's patience.
const $adebb901af88e18b$var$REQUEST_TIMEOUT_MS = 30000;
const $adebb901af88e18b$export$5c63bf3ded5aa229 = 120000;
function $adebb901af88e18b$export$7f5d9d25e625ad97() {
    try {
        return (document.documentElement.getAttribute('lang') || '').toLowerCase().split('-')[0];
    } catch  {
        return ''; // no document (tests, SSR) → let the BFF default
    }
}
async function $adebb901af88e18b$var$executeRequest(token, query, variables, timeoutMs) {
    // AbortController rather than a Promise.race: racing leaves the real request
    // running in the background, so a screen that "timed out" would still be
    // holding a socket and could still fire its .then() later.
    const controller = new AbortController();
    const timer = setTimeout(()=>controller.abort(), timeoutMs);
    try {
        return await fetch((0, $k9wwH.bffUrl)(), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-parsina-language': $adebb901af88e18b$export$7f5d9d25e625ad97()
            },
            body: JSON.stringify({
                query: query,
                variables: variables
            }),
            signal: controller.signal
        });
    } finally{
        clearTimeout(timer);
    }
}
async function $adebb901af88e18b$var$bffRequest(query, variables = {}, { timeoutMs: timeoutMs = $adebb901af88e18b$var$REQUEST_TIMEOUT_MS } = {}) {
    const token = await (0, $a83Oj.getValidToken)();
    if (!token) {
        // Raise, do not navigate. `redirectToLogin()` here was a full-document
        // navigation, which unmounts React and destroys everything unsaved — a
        // half-written SOAP note, a prescription mid-assembly — without warning and
        // without returning the doctor to the page they were on. The shell listens
        // for this and raises a dialog over the still-intact screen instead.
        (0, $b9X92.emitSession)((0, $b9X92.SessionEvent).EXPIRED);
        throw (0, $cwVZP.stampError)(new Error('Not authenticated'), {
            kind: (0, $cwVZP.ErrorKind).UNAUTHENTICATED
        }); // i18n-exempt: developer-facing throw; the UI renders errors.kind.* by `kind`
    }
    let res;
    try {
        res = await $adebb901af88e18b$var$executeRequest(token, query, variables, timeoutMs);
    } catch (err) {
        // Transport-level: never reached the BFF, so there is no status and no body
        // to read. classifyError separates "the device is offline" from "the request
        // was aborted on our timeout" from "the connection failed" — three different
        // things to tell the doctor, and previously all three were «خطای سرور».
        //
        // Tell the connectivity detector, which cannot see this from its own
        // vantage point: `navigator.onLine` reports online for a captive portal, a
        // dead VPN and a firewall black-holing the BFF, and those are precisely the
        // outages worth naming — the laptop insists everything is fine in all of
        // them. One report does not itself raise the banner; it prompts a probe.
        (0, $jX9up.reportTransportFailure)();
        throw (0, $cwVZP.stampError)(err);
    }
    // On 401, try to refresh once and retry — handles server-side expiry / clock skew
    if (res.status === 401) {
        const refreshed = await (0, $a83Oj.refreshAccessToken)();
        if (!refreshed) {
            (0, $b9X92.emitSession)((0, $b9X92.SessionEvent).EXPIRED);
            throw (0, $cwVZP.stampError)(new Error('Session expired'), {
                kind: (0, $cwVZP.ErrorKind).UNAUTHENTICATED
            }); // i18n-exempt: developer-facing throw; the UI renders errors.kind.* by `kind`
        }
        const newToken = (0, $a83Oj.getToken)();
        try {
            res = await $adebb901af88e18b$var$executeRequest(newToken, query, variables, timeoutMs);
        } catch (err) {
            throw (0, $cwVZP.stampError)(err);
        }
    }
    // The BFF's correlation id, when it sends one. Carried onto the error so the
    // detail line under a server failure is something support can actually look
    // up, instead of a message that appears identically in a thousand logs.
    const requestId = res.headers?.get?.('x-request-id') || null;
    if (!res.ok) {
        // Read the body before giving up. Apollo sends a perfectly normal GraphQL error
        // payload alongside a non-2xx status, and throwing on the status alone dropped
        // `extensions` — leaving callers unable to tell "your token was rejected" from
        // "the server fell over". App.jsx's boot check treats any failure as
        // not-onboarded, so that gap put the onboarding wizard in front of doctors who
        // were merely holding a stale token.
        const body = await res.json().catch(()=>null);
        const gqlError = body?.errors?.[0];
        const err = new Error(gqlError?.message || `BFF error: ${res.status}`); // i18n-exempt: fallback for a server error with no message; shown only in the monospace detail line
        err.status = res.status;
        if (gqlError?.extensions) err.extensions = gqlError.extensions;
        if (body?.errors) err.graphQLErrors = body.errors;
        throw (0, $cwVZP.stampError)(err, {
            requestId: requestId
        });
    }
    const { data: data, errors: errors } = await res.json();
    if (errors?.length) {
        const err = new Error(errors[0].message);
        err.extensions = errors[0].extensions;
        err.graphQLErrors = errors;
        throw (0, $cwVZP.stampError)(err, {
            requestId: requestId
        });
    }
    return data;
}
const $adebb901af88e18b$export$7fb4864174f056c = $adebb901af88e18b$var$bffRequest;
const $adebb901af88e18b$export$8395d0fc0d822a81 = $adebb901af88e18b$var$bffRequest;

});
parcelRegister("a83Oj", function(module, exports) {

$parcel$export(module.exports, "getToken", () => $75fd9b66ad1c343c$export$257b2d10b709d8ef);
$parcel$export(module.exports, "getValidToken", () => $75fd9b66ad1c343c$export$51699064a8fe557f);
$parcel$export(module.exports, "refreshAccessToken", () => $75fd9b66ad1c343c$export$f8f36faf9a051362);
$parcel$export(module.exports, "parseJwt", () => $75fd9b66ad1c343c$export$83cd1f1503eb19c0);
$parcel$export(module.exports, "isTokenExpired", () => $75fd9b66ad1c343c$export$b007d77a962aa175);
// The clinical module's view of authentication — an ADAPTER, not a flow.
//
// In the doctor panel this file was the whole OIDC/PKCE client. The clinical
// screens only ever needed five things from it: the current token, a valid one,
// a refresh, the refresh token's claims (for the expiry banner) and a sign-out.
// Every panel that renders them already has its own sign-in, so they come from
// the host (../host.jsx) and the flow itself stays with the panel that owns it.

var $e317r = parcelRequire("e317r");
function $75fd9b66ad1c343c$export$257b2d10b709d8ef() {
    return (0, $e317r.hostAuth)().getToken?.() ?? null;
}
function $75fd9b66ad1c343c$export$c8736e6c4fef498e() {
    return (0, $e317r.hostAuth)().getRefresh?.() ?? null;
}
async function $75fd9b66ad1c343c$export$51699064a8fe557f() {
    return await (0, $e317r.hostAuth)().getValidToken?.() ?? null;
}
async function $75fd9b66ad1c343c$export$f8f36faf9a051362() {
    return await (0, $e317r.hostAuth)().refreshAccessToken?.() ?? false;
}
function $75fd9b66ad1c343c$export$a0973bcfe11b05c9() {
    return (0, $e317r.hostAuth)().logout?.();
}
function $75fd9b66ad1c343c$export$83cd1f1503eb19c0(token) {
    const own = (0, $e317r.hostAuth)().parseJwt;
    if (typeof own === 'function') {
        const claims = own(token);
        if (claims !== undefined) return claims;
    }
    return $75fd9b66ad1c343c$var$decodeJwt(token);
}
function $75fd9b66ad1c343c$var$decodeJwt(token) {
    try {
        const b64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
        const bytes = Uint8Array.from(atob(b64), (c)=>c.charCodeAt(0));
        return JSON.parse(new TextDecoder().decode(bytes));
    } catch  {
        return null;
    }
}
function $75fd9b66ad1c343c$export$b007d77a962aa175(token) {
    const own = (0, $e317r.hostAuth)().isTokenExpired;
    if (typeof own === 'function') {
        const expired = own(token);
        if (expired !== undefined) return expired;
    }
    const p = $75fd9b66ad1c343c$export$83cd1f1503eb19c0(token);
    if (!p) return true;
    return Date.now() >= p.exp * 1000 - 30000; // 30 s buffer
}

});

parcelRegister("k9wwH", function(module, exports) {

$parcel$export(module.exports, "bffUrl", () => $eabde0fc143396e8$export$dd8e552c8e6ae595);
$parcel$export(module.exports, "bffWsBase", () => $eabde0fc143396e8$export$8742212cdac9d01);
// The clinical module's view of the runtime environment.
//
// In the doctor panel this file read `window.__ENV__` directly. Inside the kit
// it cannot: the clinic panel has its OWN BFF (capi.…) and must reach the
// DOCTOR BFF (api.…) for clinical data, so the address is the host's to give
// (see ../host.jsx). Getters rather than constants because the host is
// configured at boot, after this module has been evaluated.

var $e317r = parcelRequire("e317r");
const $eabde0fc143396e8$export$dd8e552c8e6ae595 = ()=>(0, $e317r.hostBffUrl)();
const $eabde0fc143396e8$export$8742212cdac9d01 = ()=>(0, $e317r.hostWsBase)();

});

parcelRegister("cwVZP", function(module, exports) {

$parcel$export(module.exports, "ErrorKind", () => $91f57610161f2da8$export$896afd8541959ee5);
$parcel$export(module.exports, "classifyError", () => $91f57610161f2da8$export$1b8dff08c06e2cb8);
$parcel$export(module.exports, "isRetryable", () => $91f57610161f2da8$export$f146c102d7613638);
$parcel$export(module.exports, "kindKey", () => $91f57610161f2da8$export$78353e7f4dfe1b54);
$parcel$export(module.exports, "stampError", () => $91f57610161f2da8$export$ec1c1ab7432e3493);
$parcel$export(module.exports, "errorDetail", () => $91f57610161f2da8$export$b08d804d6ffdb3ed);
// ─────────────────────────────────────────────────────────────────────────────
// The error taxonomy.
//
// Before this module every failure in the app was the same failure: a screen
// rendered «اطلاعات در دسترس نیست» and printed `err.message` in monospace. That
// is the correct answer to exactly one of the things that actually go wrong,
// and the wrong answer to all the others — a doctor whose Wi-Fi dropped, a
// doctor whose shift ran past token expiry, a doctor opening a colleague's
// patient, and a doctor hitting a service that is genuinely down all need
// DIFFERENT next actions, and only one of those four is "press retry".
//
// So: every error that crosses the network boundary is classified exactly once,
// here, into a `kind`. The kind decides the copy, the icon, whether a retry
// button appears at all, and whether the failure is worth reporting. Screens
// never re-sniff `err.message` — that is what produced the inconsistency this
// replaces.
//
// The classification order is deliberate and NOT rearrangeable:
//   offline first, because a dropped connection makes every other signal a lie
//   (a fetch that never left the machine has no status to read);
//   then transport, because a `TypeError: Failed to fetch` carries no status;
//   then explicit GraphQL `extensions.code`, the server saying what it meant;
//   then HTTP status;
//   then message sniffing, which is the last resort and only for gRPC codes
//   that reach us as prose because no layer in between structured them.
// ─────────────────────────────────────────────────────────────────────────────
/**
 * The complete set of failure kinds the UI knows how to talk about.
 *
 * Adding one means adding its copy in `errors.kind.*` (both locales) and
 * deciding its row in RETRYABLE below — the i18n ratchet enforces the first
 * half of that automatically.
 */ const $91f57610161f2da8$export$896afd8541959ee5 = {
    /** The device has no network at all. Nothing left the machine. */ OFFLINE: 'offline',
    /** The request left but never landed — DNS, TLS, connection reset, CORS. */ NETWORK: 'network',
    /** The request landed but we gave up waiting. */ TIMEOUT: 'timeout',
    /** No valid session. The token is missing, expired, or was rejected. */ UNAUTHENTICATED: 'unauthenticated',
    /** Authenticated, but not allowed to do this. Retrying cannot help. */ FORBIDDEN: 'forbidden',
    /** The thing addressed does not exist (or is not visible to this doctor). */ NOT_FOUND: 'notFound',
    /** The submission was rejected on its contents. The user must change it. */ VALIDATION: 'validation',
    /** Someone else changed it first; the write would clobber them. */ CONFLICT: 'conflict',
    /** Too many requests — retry is correct, but only after a wait. */ RATE_LIMITED: 'rateLimited',
    /** A dependency is down or deploying. Retry later, not now. */ MAINTENANCE: 'maintenance',
    /** The server broke while handling a well-formed request. */ SERVER: 'server',
    /** Out of Parsina credits — a business state, not a fault. */ INSUFFICIENT_CREDITS: 'insufficientCredits',
    /** Classified as nothing else. Treated as retryable and reported. */ UNKNOWN: 'unknown'
};
/**
 * Whether the SAME request, sent again unchanged, could plausibly succeed.
 *
 * This is what decides whether a retry button is rendered — and a retry button
 * on an unretryable failure is worse than no button, because it invites the
 * doctor to keep pressing something that will never work. FORBIDDEN, NOT_FOUND
 * and VALIDATION need a different action, not the same one again.
 */ const $91f57610161f2da8$var$RETRYABLE = new Set([
    $91f57610161f2da8$export$896afd8541959ee5.OFFLINE,
    $91f57610161f2da8$export$896afd8541959ee5.NETWORK,
    $91f57610161f2da8$export$896afd8541959ee5.TIMEOUT,
    $91f57610161f2da8$export$896afd8541959ee5.RATE_LIMITED,
    $91f57610161f2da8$export$896afd8541959ee5.MAINTENANCE,
    $91f57610161f2da8$export$896afd8541959ee5.SERVER,
    $91f57610161f2da8$export$896afd8541959ee5.CONFLICT,
    $91f57610161f2da8$export$896afd8541959ee5.UNKNOWN
]);
/**
 * Kinds that mean "this session is over". The session layer watches for these
 * and raises the re-authentication dialog rather than letting each screen
 * render its own dead-end error card.
 */ const $91f57610161f2da8$var$SESSION_ENDING = new Set([
    $91f57610161f2da8$export$896afd8541959ee5.UNAUTHENTICATED
]);
/**
 * Kinds worth reporting to a human. A doctor on a train going through a tunnel
 * is not a defect, and neither is a 403 on a link someone shared; drowning the
 * console in those is how the real INTERNAL_SERVER_ERROR gets missed.
 */ const $91f57610161f2da8$var$REPORTABLE = new Set([
    $91f57610161f2da8$export$896afd8541959ee5.SERVER,
    $91f57610161f2da8$export$896afd8541959ee5.UNKNOWN
]);
// GraphQL `extensions.code` → kind. Apollo's own codes plus the ones the BFF
// mints (see parsina.bff.web resolvers). A code that is not here falls through
// to the HTTP status, which is the right default: the BFF sends 200 with an
// errors array for domain failures and a real status for transport ones.
const $91f57610161f2da8$var$CODE_KINDS = {
    UNAUTHENTICATED: $91f57610161f2da8$export$896afd8541959ee5.UNAUTHENTICATED,
    FORBIDDEN: $91f57610161f2da8$export$896afd8541959ee5.FORBIDDEN,
    NOT_FOUND: $91f57610161f2da8$export$896afd8541959ee5.NOT_FOUND,
    BAD_USER_INPUT: $91f57610161f2da8$export$896afd8541959ee5.VALIDATION,
    GRAPHQL_VALIDATION_FAILED: $91f57610161f2da8$export$896afd8541959ee5.VALIDATION,
    BAD_REQUEST: $91f57610161f2da8$export$896afd8541959ee5.VALIDATION,
    DUPLICATE_DOCTOR: $91f57610161f2da8$export$896afd8541959ee5.CONFLICT,
    CONFLICT: $91f57610161f2da8$export$896afd8541959ee5.CONFLICT,
    INSUFFICIENT_CREDITS: $91f57610161f2da8$export$896afd8541959ee5.INSUFFICIENT_CREDITS,
    // The BFF's «…_UNAVAILABLE» family means a downstream microservice did not
    // answer — from the doctor's side that is indistinguishable from maintenance,
    // and the advice is the same: it is not you, try again shortly.
    ACCOUNTING_UNAVAILABLE: $91f57610161f2da8$export$896afd8541959ee5.MAINTENANCE,
    CHAT_UNAVAILABLE: $91f57610161f2da8$export$896afd8541959ee5.MAINTENANCE,
    SERVICE_UNAVAILABLE: $91f57610161f2da8$export$896afd8541959ee5.MAINTENANCE,
    INTERNAL_SERVER_ERROR: $91f57610161f2da8$export$896afd8541959ee5.SERVER
};
const $91f57610161f2da8$var$STATUS_KINDS = {
    400: $91f57610161f2da8$export$896afd8541959ee5.VALIDATION,
    401: $91f57610161f2da8$export$896afd8541959ee5.UNAUTHENTICATED,
    403: $91f57610161f2da8$export$896afd8541959ee5.FORBIDDEN,
    404: $91f57610161f2da8$export$896afd8541959ee5.NOT_FOUND,
    408: $91f57610161f2da8$export$896afd8541959ee5.TIMEOUT,
    409: $91f57610161f2da8$export$896afd8541959ee5.CONFLICT,
    422: $91f57610161f2da8$export$896afd8541959ee5.VALIDATION,
    429: $91f57610161f2da8$export$896afd8541959ee5.RATE_LIMITED,
    502: $91f57610161f2da8$export$896afd8541959ee5.MAINTENANCE,
    503: $91f57610161f2da8$export$896afd8541959ee5.MAINTENANCE,
    504: $91f57610161f2da8$export$896afd8541959ee5.TIMEOUT
};
// gRPC status names that reach the client inside a message string because no
// layer between the microservice and here turned them into an extension code.
// `UNAVAILABLE` is by far the common one — it is what every stopped Python
// service produces, and reading it as a generic server error told doctors the
// system was broken when it was merely restarting.
//
// i18n-exempt: gRPC status names — wire values matched against, never displayed.
const $91f57610161f2da8$var$GRPC_MESSAGE_KINDS = [
    [
        /\bUNAVAILABLE\b|No connection established|ECONNREFUSED/i,
        $91f57610161f2da8$export$896afd8541959ee5.MAINTENANCE
    ],
    [
        /\bDEADLINE_EXCEEDED\b|\bETIMEDOUT\b/i,
        $91f57610161f2da8$export$896afd8541959ee5.TIMEOUT
    ],
    [
        /\bPERMISSION_DENIED\b/i,
        $91f57610161f2da8$export$896afd8541959ee5.FORBIDDEN
    ],
    [
        /\bUNAUTHENTICATED\b/i,
        $91f57610161f2da8$export$896afd8541959ee5.UNAUTHENTICATED
    ],
    [
        /\bNOT_FOUND\b/i,
        $91f57610161f2da8$export$896afd8541959ee5.NOT_FOUND
    ],
    [
        /\bALREADY_EXISTS\b|\bABORTED\b/i,
        $91f57610161f2da8$export$896afd8541959ee5.CONFLICT
    ],
    [
        /\bRESOURCE_EXHAUSTED\b/i,
        $91f57610161f2da8$export$896afd8541959ee5.RATE_LIMITED
    ],
    [
        /\bINVALID_ARGUMENT\b/i,
        $91f57610161f2da8$export$896afd8541959ee5.VALIDATION
    ]
];
// A fetch that never reached a server. The browsers disagree on the wording, and
// deliberately so — the spec forbids exposing why, to avoid leaking network
// topology to script. So this matches the shapes rather than one string.
//
// i18n-exempt: browser-generated network error text, matched against, never displayed.
const $91f57610161f2da8$var$TRANSPORT_MESSAGE = /Failed to fetch|NetworkError|Network request failed|Load failed|ERR_NETWORK|ERR_INTERNET_DISCONNECTED/i;
function $91f57610161f2da8$export$a81aa9769d155ec5() {
    return typeof navigator !== 'undefined' && navigator.onLine === false;
}
function $91f57610161f2da8$export$1b8dff08c06e2cb8(err) {
    // A kind already decided upstream (bffClient stamps one on) is authoritative:
    // re-deriving it from a message that has since been wrapped loses information.
    if (err && typeof err === 'object' && err.kind && Object.values($91f57610161f2da8$export$896afd8541959ee5).includes(err.kind)) return err.kind;
    // Offline first. With no network there is no status and no server opinion to
    // read, so every later signal would be noise — and «اینترنت قطع است» is a far
    // more actionable thing to say than «خطای شبکه».
    if ($91f57610161f2da8$export$a81aa9769d155ec5()) return $91f57610161f2da8$export$896afd8541959ee5.OFFLINE;
    if (err && typeof err === 'object' && err.name === 'AbortError') return $91f57610161f2da8$export$896afd8541959ee5.TIMEOUT;
    const message = String(err?.message ?? err ?? '');
    // A TypeError with no status is the browser's way of saying the request never
    // completed — the one case where the class of the object is the evidence.
    if (err instanceof TypeError && !err.status) return $91f57610161f2da8$export$896afd8541959ee5.NETWORK;
    if (!err?.status && !err?.extensions && $91f57610161f2da8$var$TRANSPORT_MESSAGE.test(message)) return $91f57610161f2da8$export$896afd8541959ee5.NETWORK;
    const code = err?.extensions?.code;
    if (code && $91f57610161f2da8$var$CODE_KINDS[code]) return $91f57610161f2da8$var$CODE_KINDS[code];
    // `extensions.http.status` is how Apollo carries a status on an error that
    // travelled inside a 200 response body.
    const status = err?.status ?? err?.extensions?.http?.status;
    if (status && $91f57610161f2da8$var$STATUS_KINDS[status]) return $91f57610161f2da8$var$STATUS_KINDS[status];
    if (status >= 500) return $91f57610161f2da8$export$896afd8541959ee5.SERVER;
    if (status >= 400) return $91f57610161f2da8$export$896afd8541959ee5.VALIDATION;
    for (const [pattern, kind] of $91f57610161f2da8$var$GRPC_MESSAGE_KINDS){
        if (pattern.test(message)) return kind;
    }
    return $91f57610161f2da8$export$896afd8541959ee5.UNKNOWN;
}
const $91f57610161f2da8$export$f146c102d7613638 = (kind)=>$91f57610161f2da8$var$RETRYABLE.has(kind);
const $91f57610161f2da8$export$a5ddc661666022ae = (kind)=>$91f57610161f2da8$var$SESSION_ENDING.has(kind);
const $91f57610161f2da8$export$ee13084f38878c77 = (kind)=>$91f57610161f2da8$var$REPORTABLE.has(kind);
const $91f57610161f2da8$export$78353e7f4dfe1b54 = (kind)=>`errors.kind.${kind}`;
function $91f57610161f2da8$export$ec1c1ab7432e3493(err, extra = {}) {
    if (!err || typeof err !== 'object') return err;
    err.kind = $91f57610161f2da8$export$1b8dff08c06e2cb8(err);
    err.retryable = $91f57610161f2da8$export$f146c102d7613638(err.kind);
    Object.assign(err, extra);
    return err;
}
/**
 * The technical detail line shown under an error, or null when there is nothing
 * a human could act on.
 *
 * Suppressed for the kinds whose message is pure noise: the doctor gains
 * nothing from «Failed to fetch» beneath «اینترنت قطع است», and a raw stack
 * fragment under a permission error reads as a malfunction rather than a rule.
 * It is kept for SERVER and UNKNOWN, where it is the only thing that will let
 * support identify the failure.
 */ const $91f57610161f2da8$var$DETAIL_SUPPRESSED = new Set([
    $91f57610161f2da8$export$896afd8541959ee5.OFFLINE,
    $91f57610161f2da8$export$896afd8541959ee5.NETWORK,
    $91f57610161f2da8$export$896afd8541959ee5.TIMEOUT,
    $91f57610161f2da8$export$896afd8541959ee5.UNAUTHENTICATED,
    $91f57610161f2da8$export$896afd8541959ee5.FORBIDDEN,
    $91f57610161f2da8$export$896afd8541959ee5.NOT_FOUND,
    $91f57610161f2da8$export$896afd8541959ee5.MAINTENANCE
]);
function $91f57610161f2da8$export$b08d804d6ffdb3ed(err) {
    const kind = $91f57610161f2da8$export$1b8dff08c06e2cb8(err);
    if ($91f57610161f2da8$var$DETAIL_SUPPRESSED.has(kind)) return null;
    const message = err?.message ? String(err.message) : null;
    if (!message) return null;
    // A request id, when the BFF sent one, is the single most useful thing a
    // doctor can read out to support — so it leads the line.
    return err?.requestId ? `${err.requestId} \u{2014} ${message}` : message;
}

});

parcelRegister("jX9up", function(module, exports) {

$parcel$export(module.exports, "reportTransportFailure", () => $e86ae3699bc75753$export$87a8bdb1d0a966cf);
// ─────────────────────────────────────────────────────────────────────────────
// The one-way channel from "a request just failed for transport reasons" to
// "the connectivity detector should go and check".
//
// It exists because the two halves cannot import each other. `bffClient` is a
// leaf module with no React in it — deliberately, so it can be used from
// anywhere, including outside a component — while `useOnlineStatus` is a hook.
// Without this the detector would only ever learn about an outage from
// `navigator.onLine`, which is exactly the signal that lies: it reports online
// for a captive portal, a dead VPN, and a firewall that black-holes the BFF.
// Those are the cases the doctor most needs named, because in every one of them
// the laptop insists everything is fine.
//
// Kept as a plain subscriber list rather than an event emitter or a context: it
// carries no payload, has at most one listener (the shell's hook), and must be
// safe to call from a `catch` block during module teardown. There is nothing
// here to configure and nothing to get wrong.
// ─────────────────────────────────────────────────────────────────────────────
const $e86ae3699bc75753$var$listeners = new Set();
function $e86ae3699bc75753$export$288ba6b4215d30f3(listener) {
    $e86ae3699bc75753$var$listeners.add(listener);
    return ()=>$e86ae3699bc75753$var$listeners.delete(listener);
}
function $e86ae3699bc75753$export$87a8bdb1d0a966cf() {
    for (const listener of $e86ae3699bc75753$var$listeners)try {
        listener();
    } catch  {}
}
function $e86ae3699bc75753$export$d433e139d37a5376() {
    $e86ae3699bc75753$var$listeners.clear();
}

});


parcelRegister("lMO3H", function(module, exports) {

$parcel$export(module.exports, "ALL_CLINICS", () => $fdc4e943ddc88ca2$export$c5abb0256123e62d);
$parcel$export(module.exports, "readActiveClinicId", () => $fdc4e943ddc88ca2$export$712e97de44ae5c43);

var $e317r = parcelRequire("e317r");
// Which clinic the doctor is receiving at right now.
//
// A doctor can be a member of several clinics at once, and پذیرش used to render
// every one of their appointments in one undifferentiated day sheet — so a
// doctor who works Saturdays at one clinic and Sundays at another could not
// tell, from the screen, whose desk had booked the patient in front of them.
//
// This module owns the ANSWER, not the UI: one stored id, read and written from
// a single place, so the header chip, the day filter and the row tags can never
// disagree about where the doctor is.
//
// A leaf module with no React dependency, like `auth.js` — the value is read at
// module scope by whoever needs it, and the hook layers React state on top.
const $fdc4e943ddc88ca2$var$KEY = 'parsina_active_clinic_v1';
const $fdc4e943ddc88ca2$export$c5abb0256123e62d = 'ALL';
function $fdc4e943ddc88ca2$export$712e97de44ae5c43() {
    const fromHost = (0, $e317r.hostActiveClinicId)();
    if (fromHost != null) return fromHost;
    try {
        return localStorage.getItem($fdc4e943ddc88ca2$var$KEY) || '';
    } catch  {
        // A private window, or storage blocked entirely. Not an error worth telling
        // anyone about: the doctor simply starts each session unfiltered.
        return '';
    }
}
function $fdc4e943ddc88ca2$export$31ee8104798ff02e(id) {
    try {
        if (id) localStorage.setItem($fdc4e943ddc88ca2$var$KEY, id);
        else localStorage.removeItem($fdc4e943ddc88ca2$var$KEY);
    } catch  {
    // Ignore — the in-memory state still holds for this session.
    }
}

});

parcelRegister("eBrFc", function(module, exports) {

$parcel$export(module.exports, "useAppNavigate", () => $aa19facd75e3670a$export$5b61ff3425c1c197);
$parcel$export(module.exports, "useAppBack", () => $aa19facd75e3670a$export$2225579b56f43845);

var $e317r = parcelRequire("e317r");
function $aa19facd75e3670a$export$5b61ff3425c1c197() {
    return (0, $e317r.useClinicalHost)().navigate;
}
function $aa19facd75e3670a$export$2225579b56f43845() {
    return (0, $e317r.useClinicalHost)().back;
}

});



parcelRegister("18P7h", function(module, exports) {

$parcel$export(module.exports, "default", () => $5847361e5dafb1ed$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $fkEOT = parcelRequire("fkEOT");

var $eBrFc = parcelRequire("eBrFc");

var $zEEXy = parcelRequire("zEEXy");

var $1GWj2 = parcelRequire("1GWj2");
function $5847361e5dafb1ed$export$2e2bcd8739ae039({ patient: patient, mobile: mobile }) {
    const navigate = (0, $eBrFc.useAppNavigate)();
    const { isMobile: isMobile } = (0, $fkEOT.default)();
    const phone = typeof mobile === 'boolean' ? mobile : isMobile;
    if (!patient?.id) return null;
    return phone ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $zEEXy.default), {
        navigate: navigate,
        patient: patient
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1GWj2.default), {
        navigate: navigate,
        patient: patient
    });
}

});
parcelRegister("fkEOT", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2986342a4eb23f5$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useResponsive", () => (parcelRequire("k27hS")).default);
// The app's ONE mobile breakpoint: ≤ 768px, inclusive (DESIGN-CONCEPT-MOBILE
// preamble). Every `X.mobile.jsx` fork, the bottom-nav shell in App.jsx, the
// `IOSDevice` frame and the `@media` block in styles.css all key off this one
// number — a rule that only became true after a viewport between 501 and 768px
// was found getting the mobile shell from JS and the desktop viewport rules
// from CSS, which is how the bottom nav ended up below the fold.
//
// The implementation moved into @parsina/framework (a byte-identical copy
// already existed in the clinic client). This file stays as the app's import
// path so the ten screens and the /docs pages that quote it keep working, and
// so there remains one obvious place to look for "what counts as mobile here".
//
// What the kit version fixes over the local copy it replaces:
//   • `matchMedia` instead of a `resize` listener — one state change at the
//     boundary rather than a re-render on every frame of a rotation;
//   • a `typeof window` guard, so a node-environment test can import a screen.
parcelRequire("5N0ZI");
var $k27hS = parcelRequire("k27hS");
var $b2986342a4eb23f5$export$2e2bcd8739ae039 = (0, $k27hS.default);

});

parcelRegister("zEEXy", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1fb04c8016deb8f$export$2e2bcd8739ae039);
// ── Visit.mobile.jsx ─────────────────────────────────────────────────────────
// The mobile clinical-visit workspace — a platform fork of the desktop Visit
// screen (DESIGN-CONCEPT-MOBILE v2 §1.1). A render-only composition of the
// dedicated MobileVisit* library over brand tokens + kit primitives; every
// clinical derivation and mutation below is the same behaviour the desktop
// screen runs, kept here as wiring rather than re-implemented. The warm-beige
// sub-theme, the raw button tags, px units and custom icon set are gone — the
// Visit page now lives on the one design system (freeze lifted 2026-07-18).
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");

var $eBrFc = parcelRequire("eBrFc");
parcelRequire("7sS0P");
var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $cZOyb = parcelRequire("cZOyb");
var $aJ1FU = parcelRequire("aJ1FU");
var $3tGMU = parcelRequire("3tGMU");
var $6SCJ6 = parcelRequire("6SCJ6");
var $66joL = parcelRequire("66joL");
var $iK5Lj = parcelRequire("iK5Lj");
var $kLmaN = parcelRequire("kLmaN");

var $fWbIA = parcelRequire("fWbIA");

var $QG9Z3 = parcelRequire("QG9Z3");
var $i5dmF = parcelRequire("i5dmF");
var $7VXKQ = parcelRequire("7VXKQ");
var $bawlA = parcelRequire("bawlA");
var $6TdpC = parcelRequire("6TdpC");

var $k5DdK = parcelRequire("k5DdK");

var $9ycDe = parcelRequire("9ycDe");

var $7LBYc = parcelRequire("7LBYc");

var $kyxc1 = parcelRequire("kyxc1");

var $cvBw3 = parcelRequire("cvBw3");

var $U8Lvw = parcelRequire("U8Lvw");

var $16oOu = parcelRequire("16oOu");

var $fiHxp = parcelRequire("fiHxp");

var $85jFj = parcelRequire("85jFj");

var $3wi2X = parcelRequire("3wi2X");

var $3EzBq = parcelRequire("3EzBq");

var $1yr2B = parcelRequire("1yr2B");

var $eQiuG = parcelRequire("eQiuG");

var $5VYuu = parcelRequire("5VYuu");

var $4s6k1 = parcelRequire("4s6k1");
parcelRequire("epeHA");
var $jTCZr = parcelRequire("jTCZr");

var $eVM84 = parcelRequire("eVM84");

var $dL6zl = parcelRequire("dL6zl");

var $fOM5k = parcelRequire("fOM5k");

var $fBZG6 = parcelRequire("fBZG6");

var $682u6 = parcelRequire("682u6");
parcelRequire("dsmcB");

var $3OnFU = parcelRequire("3OnFU");

var $5qFC5 = parcelRequire("5qFC5");

var $jCgjY = parcelRequire("jCgjY");

var $5kzaL = parcelRequire("5kzaL");

var $bwSot = parcelRequire("bwSot");

var $4SCt2 = parcelRequire("4SCt2");

var $dXWAH = parcelRequire("dXWAH");

var $fIKok = parcelRequire("fIKok");

var $icdDW = parcelRequire("icdDW");

var $b4nOl = parcelRequire("b4nOl");

var $cEPPo = parcelRequire("cEPPo");

var $ajYTu = parcelRequire("ajYTu");

var $l7onJ = parcelRequire("l7onJ");

var $k6Haa = parcelRequire("k6Haa");

var $5qIQm = parcelRequire("5qIQm");

var $dLdf9 = parcelRequire("dLdf9");

var $cwVZP = parcelRequire("cwVZP");

var $64nJX = parcelRequire("64nJX");

var $dBAbF = parcelRequire("dBAbF");

var $c6MXC = parcelRequire("c6MXC");

var $aQc6m = parcelRequire("aQc6m");

var $1g70w = parcelRequire("1g70w");

var $B8sWX = parcelRequire("B8sWX");

var $fKtaR = parcelRequire("fKtaR");

var $1eCd1 = parcelRequire("1eCd1");

var $dlUcE = parcelRequire("dlUcE");

var $6miYn = parcelRequire("6miYn");

var $3HnvL = parcelRequire("3HnvL");

var $gLLxa = parcelRequire("gLLxa");

var $io25J = parcelRequire("io25J");

var $2WSjX = parcelRequire("2WSjX");

var $9BB3T = parcelRequire("9BB3T");

var $99eLi = parcelRequire("99eLi");

var $2BAqO = parcelRequire("2BAqO");

var $t47X1 = parcelRequire("t47X1");

var $9Akci = parcelRequire("9Akci");

var $4UqGT = parcelRequire("4UqGT");

var $15ERh = parcelRequire("15ERh");

var $7ZSin = parcelRequire("7ZSin");

var $3O5pt = parcelRequire("3O5pt");

var $e317r = parcelRequire("e317r");

var $gRy9t = parcelRequire("gRy9t");

var $0xK7i = parcelRequire("0xK7i");

var $8qEaX = parcelRequire("8qEaX");

var $gdEay = parcelRequire("gdEay");

var $3Tnyk = parcelRequire("3Tnyk");

var $aoLHg = parcelRequire("aoLHg");

var $6xvbB = parcelRequire("6xvbB");

var $90sfp = parcelRequire("90sfp");

var $6ojK3 = parcelRequire("6ojK3");

var $lqfll = parcelRequire("lqfll");

var $g6gAc = parcelRequire("g6gAc");

var $bkBaq = parcelRequire("bkBaq");

var $fijM5 = parcelRequire("fijM5");

var $glimY = parcelRequire("glimY");

var $7TTuK = parcelRequire("7TTuK");

var $hScMH = parcelRequire("hScMH");

var $jzVrj = parcelRequire("jzVrj");
function $e1fb04c8016deb8f$export$2e2bcd8739ae039({ navigate: navProp, patient: routePatient }) {
    const { t: t, has: has, formatNumber: formatNumber, formatList: formatList, formatDigits: formatDigits } = (0, $LNQP4.default)();
    const goBack = (0, $eBrFc.useAppBack)();
    const { patient: patient, loading: pLoading, error: pError, refresh: refreshPatient } = (0, $k5DdK.usePatient)(routePatient?.id);
    // `loading` matters: until the doctor's settings have arrived, `ai` is {}
    // and every `!== false` gate reads as ENABLED. Deciding an auto-run in that
    // window means the setting is honoured only when the doctor query happens to
    // win the race against the patient query.
    const { doctor: doctor, loading: doctorLoading, error: doctorError, update: updateDoctorSettings } = (0, $9ycDe.useDoctor)();
    // The doctor's layout (Settings → «صفحه ویزیت»), reduced to what this surface
    // has: which of note/rx/ord/diff exist and which opens first, which record
    // sections the sheet shows and in what order, and which copilot tabs remain.
    const storedVisitLayout = doctor?.settings?.visitLayout ?? null;
    const visitLayout = (0, $acw62.useMemo)(()=>(0, $aoLHg.resolveVisitLayout)(storedVisitLayout), [
        storedVisitLayout
    ]);
    const recordSections = (0, $acw62.useMemo)(()=>(0, $aoLHg.visibleRecordSections)(visitLayout), [
        visitLayout
    ]);
    // Open/closed per record section — the same hook, the same persistence and
    // the same localStorage cache the desktop rail uses (Visit.shared.js).
    const { recordOpen: recordOpen, toggleRecordSection: toggleRecordSection } = (0, $6xvbB.useRecordSections)(visitLayout, storedVisitLayout, doctorLoading, updateDoctorSettings);
    const toast = (0, $7LBYc.useOptionalToast)();
    const walletBalance = (0, $3wi2X.useWalletBalance)(doctor?.id);
    // The per-visit «پارسه» tally lives with the visit — see the coin ledger
    // below, declared once the encounter id it is keyed by exists.
    const ai = doctor?.settings?.aiAgent || {};
    // «نکات بالینی» is always available — the doctor only chooses whether it
    // arrives unprompted. Off ONLY on an explicit `false`, so an absent key never
    // reads as an opt-out. See Settings.shared.js. An empty `ai` is a different
    // case entirely, and the predicate below is what tells the two apart.
    // Whether the doctor's choice is KNOWN. `loading` was the only guard here,
    // which made every gate below fail OPEN on a failed query: `me` fetches
    // `settings` through a second gRPC call inside the same request, so one
    // unavailable doctor-preference call throws the whole query, leaves `doctor`
    // null and `ai` empty — and an empty `ai` reads as ENABLED, because an absent
    // key is not an opt-out. A doctor who switched all three automations off then
    // got the differential, the polling loop and the insight pass anyway, and was
    // billed for them. An error is not a choice, so it reads as "don't run
    // anything by yourself"; every manual button stays live.
    const aiSettingsUnknown = doctorLoading || !!doctorError;
    // Auto-run only when we know the doctor left it on. This also decides
    // whether the RECORDING produces «نکات بالینی»: the AI service runs a hint
    // agent on its own timer for the whole visit, a second producer of the same
    // feed that this switch did not use to reach.
    const suggestionsAutoRun = !aiSettingsUnknown && (0, $3Tnyk.clinicalSuggestionsAutoRun)(ai);
    // The other automatic runs, each on its own switch now. «بازبینی پس از
    // ویرایش یادداشت» has no gate here because this surface has no such path:
    // the phone's SOAP editor saves on blur and never re-assesses.
    //
    // They used to ride on the two above — honest about the billing, dishonest
    // about the naming — or, in the sweep's case, on nothing at all. Each reads as
    // OFF while the doctor's choice is unknown: see the predicate above, and
    // Settings.shared.js for what each switch actually stops.
    const liveHintsOn = !aiSettingsUnknown && (0, $3Tnyk.liveHintsActive)(ai);
    // «موتور تبدیل گفتار به متن». Unlike the switches above this is NOT held off
    // while the choice is unknown: the default is Parsina STT, and the AI service
    // serves the assistant engine whenever Parsina STT cannot answer — so the
    // worst an unknown choice costs is the default, never a dead microphone.
    const speechPref = (0, $4s6k1.speechEnginePreference)(ai);
    const ambientSpeechEngine = (0, $4s6k1.ambientEngine)(speechPref);
    const autoAssistOn = !aiSettingsUnknown && (0, $3Tnyk.autoPrescriptionAssistActive)(ai);
    // «تکمیل خودکار پس از پایش بالینی» — the top bar's «تکمیل» once the doctor stops.
    const autoCompleteOn = !aiSettingsUnknown && (0, $3Tnyk.autoCompleteOnStopActive)(ai);
    // The sweep is the exception to "unknown reads as off": it is a SAFETY
    // backstop, and a settings query that failed is no reason to stop checking a
    // prescription for a high-severity interaction. Only an explicit «off» from a
    // doctor who says they check by hand stops it.
    const endVisitSweepOn = (0, $3Tnyk.endVisitSweepActive)(ai);
    const [visitId, setVisitId] = (0, $acw62.useState)(null);
    const [visitStatus, setVisitStatus] = (0, $acw62.useState)(null);
    const [leaveConfirm, setLeaveConfirm] = (0, $acw62.useState)(false);
    const [pendingEnd, setPendingEnd] = (0, $acw62.useState)(false);
    // «پیش از پایان ویزیت» (PM-0618): shown INSTEAD of the plain confirm when an
    // in-house service of this visit is still open in it.
    const [endServicesOpen, setEndServicesOpen] = (0, $acw62.useState)(false);
    // Bumped after a «انجام شد», so «خدمات این مراجعه» reads again.
    const [visitServicesKey, setVisitServicesKey] = (0, $acw62.useState)(0);
    const pendingNavRef = (0, $acw62.useRef)(null);
    const [tab, setTab] = (0, $acw62.useState)('notes');
    // Prescription
    const [rxItems, setRxItems] = (0, $acw62.useState)([]);
    // Drug lines offered to this visit from outside — a document review («افزودن به
    // نسخه ویزیت», §23.3 A13) or an approved AI proposal: prefilled forms on the
    // نسخه tab, one at a time, not نسخه lines until confirmed.
    const [docRxDrafts, setDocRxDrafts] = (0, $acw62.useState)([]);
    const [rxInteractions, setRxInteractions] = (0, $acw62.useState)(null);
    const [interactionLoading, setIxLoading] = (0, $acw62.useState)(false);
    const [ixError, setIxError] = (0, $acw62.useState)(null);
    const [aiResult, setAiResult] = (0, $acw62.useState)(null);
    const [aiLoading, setAiLoading] = (0, $acw62.useState)(false);
    const [diagnosis, setDiagnosis] = (0, $acw62.useState)('');
    // AI Recommendations. `recsRan` records that the pass completed at least once,
    // so an empty sheet can say "nothing to suggest" instead of "not run yet".
    const [recommendations, setRecommendations] = (0, $acw62.useState)(null);
    const [recsLoading, setRecsLoading] = (0, $acw62.useState)(false);
    const [recsError, setRecsError] = (0, $acw62.useState)(null);
    const [recsRan, setRecsRan] = (0, $acw62.useState)(false);
    const recsAutoFired = (0, $acw62.useRef)(false);
    const assistAutoFired = (0, $acw62.useRef)('');
    // Notes & visit
    const [notes, setNotes] = (0, $acw62.useState)('');
    const [aiInput, setAiInput] = (0, $acw62.useState)('');
    const [aiMessages, setAiMessages] = (0, $acw62.useState)([]);
    const [aiChatLoading, setAiChatLoading] = (0, $acw62.useState)(false);
    const [labOpen, setLabOpen] = (0, $acw62.useState)(false);
    const [showClosureFlow, setShowClosureFlow] = (0, $acw62.useState)(false);
    // What did NOT save when the visit ended — see Visit.web.jsx.
    const [saveFailures, setSaveFailures] = (0, $acw62.useState)([]);
    const [endingVisit, setEndingVisit] = (0, $acw62.useState)(false);
    const [pmEncounterId, setPmEncounterId] = (0, $acw62.useState)(null);
    // ── Per-visit «پارسه» tally ────────────────────────────────────────────────
    // Same record as the desktop surface reads (useVisitCoinLedger): a visit
    // started here and reopened there — or simply refreshed — shows the same
    // figure, because both read it from the encounter rather than from memory.
    const { total: visitCoins, entries: coinEntries, charge: recordCoinCharge, refetch: refetchCoins } = (0, $6xvbB.useVisitCoinLedger)(pmEncounterId || visitId || null);
    // «مدارک بیمار» — the same documents host the desktop record column uses.
    const visitFileList = (0, $acw62.useMemo)(()=>(0, $gdEay.sortByDocumentDate)(patient?.clinicalFiles || []), [
        patient?.clinicalFiles
    ]);
    // The review's «افزودن به نسخه ویزیت» — reached through a ref because the drug
    // handlers are declared further down.
    const docRxCapability = (0, $acw62.useRef)(null);
    const addToVisitPrescription = (0, $acw62.useCallback)((draft)=>docRxCapability.current?.(draft), []);
    const clinicalFiles = (0, $0xK7i.useClinicalFiles)({
        patient: patient,
        files: visitFileList,
        appointmentId: pmEncounterId || visitId || null,
        onChanged: refreshPatient,
        onAddToVisitPrescription: addToVisitPrescription
    });
    const chargeDepsRef = (0, $acw62.useRef)({
        toast: toast,
        t: t,
        formatNumber: formatNumber
    });
    chargeDepsRef.current = {
        toast: toast,
        t: t,
        formatNumber: formatNumber
    };
    const chargeVisit = (0, $acw62.useCallback)((coins, itemId, label)=>{
        if (!coins) return;
        recordCoinCharge(coins, itemId);
        const { toast: tst, t: tr, formatNumber: fn } = chargeDepsRef.current;
        if (label) tst.success(tr('visit.credits.chargedToast', {
            label: label,
            coins: (0, $3EzBq.fmtCoins)(coins, fn)
        }));
    }, [
        recordCoinCharge
    ]);
    const [differential, setDifferential] = (0, $acw62.useState)(null);
    const [diffLoading, setDiffLoading] = (0, $acw62.useState)(false);
    const [sessionReady, setSessionReady] = (0, $acw62.useState)(false);
    const [resumedVisit, setResumedVisit] = (0, $acw62.useState)(false); // true when visit was recovered on page reload
    const [soapDiffConfirm, setSoapDiffConfirm] = (0, $acw62.useState)(null); // { description, diagnosisCode }
    // diagnosisCode whose «نوع تشخیص» is being chosen — see Visit.web.jsx.
    const [diffTypePick, setDiffTypePick] = (0, $acw62.useState)(null);
    const [diffTypeBusy, setDiffTypeBusy] = (0, $acw62.useState)(false);
    const [addedSugTests, setAddedSugTests] = (0, $acw62.useState)(new Set());
    const [chartMetric, setChartMetric] = (0, $acw62.useState)(null);
    const [vitals, setVitals] = (0, $acw62.useState)((0, $6xvbB.emptyVitals));
    const [vitalsMode, setVitalsMode] = (0, $acw62.useState)('form'); // 'form' | 'saved'
    const [demoOpen, setDemoOpen] = (0, $acw62.useState)(true);
    const [vitalsOpen, setVitalsOpen] = (0, $acw62.useState)(true);
    const [vitalsLoading, setVitalsLoading] = (0, $acw62.useState)(false);
    const [vitalsAlert, setVitalsAlert] = (0, $acw62.useState)(null);
    const [vitalsError, setVitalsError] = (0, $acw62.useState)(null); // validation errors (array of strings)
    const [showVitalsModal, setShowVitalsModal] = (0, $acw62.useState)(false);
    const savedVitalIds = (0, $acw62.useRef)([]); // IDs of this encounter's vital observations
    const vitalsSeeded = (0, $acw62.useRef)(null); // encounter whose recorded vitals we already adopted
    const [creditError, setCreditError] = (0, $acw62.useState)(null);
    // «خرید پارسه» / «شارژ اعتبار» only where this deployment sells credit
    // (PM-0211, lib/useCreditPrices.js); the warnings themselves always show.
    const canBuyCredits = (0, $1yr2B.usePurchaseAvailable)(Boolean(creditError) || walletBalance !== null && (0, $jTCZr.creditLevel)(walletBalance) === 'low');
    const [prescriptionTemplates, setPrescriptionTemplates] = (0, $acw62.useState)([]);
    // Visit timer
    const [elapsed, setElapsed] = (0, $acw62.useState)(0);
    const [recElapsed, setRecElapsed] = (0, $acw62.useState)(0); // recording-specific counter
    // How many pixels the software keyboard is covering. 0 on a desktop and
    // wherever `visualViewport` is missing, so every use below is unconditional.
    const keyboardInset = (0, $iK5Lj.default)();
    // The docked footer tells floating chrome (the toast stack) how tall it is,
    // so a toast lands above «پایان ویزیت» and not on it (PM-0022).
    const footerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, $kLmaN.default)(footerRef);
    // New SOAP + copilot/work tab state
    const [soap, setSoap] = (0, $acw62.useState)({
        s: '',
        o: '',
        a: '',
        p: ''
    });
    const [copilotTab, setCopilotTab] = (0, $acw62.useState)('sugg');
    const [diagAIQuestions, setDiagAIQuestions] = (0, $acw62.useState)({}); // { [diagCode]: [{id,question,hint}] }
    const [diagAIAnswers, setDiagAIAnswers] = (0, $acw62.useState)({}); // { [diagCode]: { [qId]: {answer:'yes'|'no', followUp:''} } }
    const [diagAILoading, setDiagAILoading] = (0, $acw62.useState)({}); // { [diagCode]: boolean }
    // An answer is committed the moment it is picked, so the in-flight and failed
    // states are per QUESTION, not per diagnosis: `${diagCode}:${questionId}`.
    const [diagQSubmitting, setDiagQSubmitting] = (0, $acw62.useState)({}); // { [diagCode:qId]: 'yes'|'no' }
    const [diagQError, setDiagQError] = (0, $acw62.useState)({}); // { [diagCode:qId]: string }
    const [openAIDiag, setOpenAIDiag] = (0, $acw62.useState)(null); // diagCode | null
    const [workTab, setWorkTab] = (0, $acw62.useState)('soap');
    const [soapNoteId, setSoapNoteId] = (0, $acw62.useState)(null); // ID of the in-progress ClinicalNote for this visit
    // Clinical orders (from clinicalencounter microservice)
    const [clinicalOrders, setClinicalOrders] = (0, $acw62.useState)([]);
    const [ordersLoading, setOrdersLoading] = (0, $acw62.useState)(false);
    // Whether the list above is the server's answer rather than "not asked yet" —
    // see the reconciler: an empty list is a claim, and only the fetch may make it.
    const [ordersLoaded, setOrdersLoaded] = (0, $acw62.useState)(false);
    const [orderTransitioning, setOrderTransitioning] = (0, $acw62.useState)(null); // orderId being transitioned
    const [orderError, setOrderError] = (0, $acw62.useState)(null);
    const [newOrder, setNewOrder] = (0, $acw62.useState)({
        orderType: 'lab',
        description: '',
        urgency: 'routine',
        notes: ''
    });
    const [orderSaving, setOrderSaving] = (0, $acw62.useState)(false);
    const [cancellingVisit, setCancellingVisit] = (0, $acw62.useState)(false);
    // The order catalogue is SEARCHED, never held — see Visit.web.jsx for why
    // (~20,000 national rows are not a payload). `catalogPage` is the picker's
    // current page; `catalogResolved` is what the orders already on this chart need
    // from the catalogue: their English name for the plan block, whether this
    // clinic performs them, and their code.
    const [catalogPage, setCatalogPage] = (0, $acw62.useState)({
        entries: [],
        total: 0,
        loading: false,
        error: null
    });
    const [catalogResolved, setCatalogResolved] = (0, $acw62.useState)(()=>new Map());
    // AI-assisted treatment plan — generated from the SOAP «برنامه» section, not a
    // tab of its own. The plan composes meds + labs + imaging + procedures in one
    // call, grounded in the whole SOAP note + reviewed differentials + history;
    // its prose becomes the «P» text, and the review panel under P governs which
    // structured items get persisted.
    const [planSuggestion, setPlanSuggestion] = (0, $acw62.useState)(null);
    const [planLoading, setPlanLoading] = (0, $acw62.useState)(false);
    const [selectedPlanItems, setSelectedPlanItems] = (0, $acw62.useState)(new Set()); // "med:name" | "lab:name" | ...
    const [planSaving, setPlanSaving] = (0, $acw62.useState)(false);
    const [planStatus, setPlanStatus] = (0, $acw62.useState)(null); // null | 'draft' | 'confirmed'
    const [planError, setPlanError] = (0, $acw62.useState)(null);
    const [planPanelOpen, setPlanPanelOpen] = (0, $acw62.useState)(false);
    const [planReplacedP, setPlanReplacedP] = (0, $acw62.useState)(null); // undo for an overwritten «P»
    // ── Parity surfaces (docs/mobile-visit-redesign.md §3) ─────────────────────
    // `mobileSheet` carries the record/copilot sheets; these are the ones that can
    // stack over them (labs, print) or replace the desktop topbar (overflow).
    const [labsSheetOpen, setLabsSheetOpen] = (0, $acw62.useState)(false);
    const [printSheetOpen, setPrintSheetOpen] = (0, $acw62.useState)(false);
    const [overflowOpen, setOverflowOpen] = (0, $acw62.useState)(false);
    const [pendingCancelVisit, setPendingCancelVisit] = (0, $acw62.useState)(false);
    // Per-visit record detail behind «مراجعات اخیر», keyed by appointment id:
    // { [encId]: { state: 'loading'|'ready'|'error', data } }. Requests are
    // de-duped by ref so a row re-expanded during a fetch does not fire a second.
    const [visitContexts, setVisitContexts] = (0, $acw62.useState)({});
    const visitCtxRequested = (0, $acw62.useRef)(new Set());
    // «نوع تشخیص» being rewritten on a chart condition (record sheet).
    const [dxTypeBusyId, setDxTypeBusyId] = (0, $acw62.useState)(null);
    // The order the doctor asked to cancel — the sheet asks, the screen confirms.
    const [orderToCancel, setOrderToCancel] = (0, $acw62.useState)(null);
    // Refs for contentEditable SOAP editors
    const soapEditorRefs = (0, $acw62.useRef)({
        s: null,
        o: null,
        a: null,
        p: null
    });
    // Keep contentEditable DOM in sync with soap state (draft restore, AI appends, tab remount, etc.)
    // useLayoutEffect fires synchronously after refs are attached but before browser paint,
    // so adding workTab as a dep ensures fields repopulate immediately when SOAP tab remounts.
    // Skip update if the element is currently focused (user is actively typing).
    (0, $acw62.useLayoutEffect)(()=>{
        [
            's',
            'o',
            'a',
            'p'
        ].forEach((key)=>{
            const el = soapEditorRefs.current[key];
            if (el && document.activeElement !== el && el.textContent !== (soap[key] || '')) el.textContent = soap[key] || '';
        });
    }, [
        soap.s,
        soap.o,
        soap.a,
        soap.p,
        workTab
    ]);
    // Load saved SOAP note from server on visit resume/reload
    (0, $acw62.useEffect)(()=>{
        const encId = pmEncounterId || visitId;
        if (!encId || !patient?.id || visitStatus !== 'inprogress' || soapNoteId) return;
        (0, $eVM84.bffQuery)((0, $6xvbB.LIST_CLINICAL_NOTES), {
            patientId: patient.id,
            appointmentId: encId
        }).then((data)=>{
            // The note is matched with the SHARED reader, not on a literal noteType.
            // When encounters merged into appointments the service dropped
            // `note_type` and kept only `format`, which it refuses to store as
            // anything but "SOAP" — so the BFF now reports every note as
            // noteType 'SOAP'. The old `=== 'SOAP_NOTE'` filter could therefore
            // never match: the editors came up empty on reload AND `soapNoteId`
            // stayed null, so the next autosave took the CREATE branch and left the
            // appointment with two SOAP rows that disagree.
            const note = (0, $dL6zl.primarySoapNote)(data?.listClinicalNotes || []);
            if (!note) return;
            // The id FIRST and unconditionally — the next save must UPDATE this row
            // even if it is currently empty, or the duplicate comes back.
            setSoapNoteId(note.id);
            const draft = (0, $dL6zl.readSoapDraft)([
                note
            ]);
            const next = {
                s: draft.S || '',
                o: draft.O || '',
                a: draft.A || '',
                p: draft.P || ''
            };
            if (!(next.s || next.o || next.a || next.p)) return;
            // A localStorage draft restored moments ago is FRESHER than the server
            // copy (it holds keystrokes made after the last autosave), so it wins.
            setSoap((prev)=>prev.s || prev.o || prev.a || prev.p ? prev : next);
        }).catch(()=>{});
    }, [
        pmEncounterId,
        visitId,
        patient?.id,
        visitStatus
    ]);
    const [mobileSheet, setMobileSheet] = (0, $acw62.useState)(null); // null | 'ai' | 'vitals'
    const [mobileTab, setMobileTab] = (0, $acw62.useState)('note'); // note | rx | ord
    // Items ticked in «درخواست» but not added yet (PM-0121): «پایان ویزیت»
    // waits for them instead of ending without them.
    const [ordersPending, setOrdersPending] = (0, $acw62.useState)(0);
    // Open on the doctor's default tab until they pick one in this visit; a tab
    // hidden while active falls back to the default.
    const mobileTabTouched = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        setMobileTab((prev)=>!mobileTabTouched.current || !(0, $aoLHg.isMobileVisitTabVisible)(visitLayout, prev) ? (0, $aoLHg.mobileDefaultVisitTab)(visitLayout) : prev);
    }, [
        visitLayout
    ]);
    const pickMobileTab = (0, $acw62.useCallback)((id)=>{
        mobileTabTouched.current = true;
        setMobileTab(id);
    }, []);
    const mobileTabShown = (0, $acw62.useCallback)((id)=>(0, $aoLHg.isMobileVisitTabVisible)(visitLayout, id) || mobileTab === id, [
        visitLayout,
        mobileTab
    ]);
    const [mobileAiTab, setMobileAiTab] = (0, $acw62.useState)('hints');
    // Same rule as the nav: the doctor's default until they pick a tab in this
    // visit, and a tab hidden while active falls back.
    const aiTabTouched = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        setMobileAiTab((prev)=>!aiTabTouched.current || !(0, $aoLHg.isMobileCopilotSheetTabVisible)(visitLayout, prev) ? (0, $aoLHg.mobileDefaultCopilotSheetTab)(visitLayout) : prev);
    }, [
        visitLayout
    ]);
    const pickAiTab = (0, $acw62.useCallback)((id)=>{
        aiTabTouched.current = true;
        setMobileAiTab(id);
    }, []);
    const [mobileSoapOpen, setMobileSoapOpen] = (0, $acw62.useState)({
        S: true,
        O: false,
        A: false,
        P: false
    });
    const [mobileDiffPrimary, setMobileDiffPrimary] = (0, $acw62.useState)(null);
    const [mobileDiffState, setMobileDiffState] = (0, $acw62.useState)({});
    const [dismissedSuggs, setDismissedSuggs] = (0, $acw62.useState)(new Set());
    // Past visit history panel
    const [pastVisitSummaries, setPastVisitSummaries] = (0, $acw62.useState)(null);
    const [expandedEncId, setExpandedEncId] = (0, $acw62.useState)(null);
    const [expandedLabDate, setExpandedLabDate] = (0, $acw62.useState)(null);
    const [showAllLabDates, setShowAllLabDates] = (0, $acw62.useState)(false);
    // Accepted suggestions tracking
    const [pendingTests, setPendingTests] = (0, $acw62.useState)([]);
    // Doctor order suggestions (AI)
    const [orderSuggestions, setOrderSuggestions] = (0, $acw62.useState)(null); // { labTests, imagingStudies, procedureOrders }
    const [orderSuggestionsLoading, setOrderSuggestionsLoading] = (0, $acw62.useState)(false);
    const [selectedOrders, setSelectedOrders] = (0, $acw62.useState)(new Set()); // Set of "<type>:<name>"
    const [savingOrders, setSavingOrders] = (0, $acw62.useState)(false);
    const [savedOrdersCount, setSavedOrdersCount] = (0, $acw62.useState)(0);
    // Current-meds panel: delete via mutation, undo re-adds locally (optimistic)
    const [removedMedNames, setRemovedMedNames] = (0, $acw62.useState)(new Set());
    const [undoMed, setUndoMed] = (0, $acw62.useState)(null);
    const undoTimerRef = (0, $acw62.useRef)(null);
    const [removedCondIds, setRemovedCondIds] = (0, $acw62.useState)(new Set());
    const [undoCond, setUndoCond] = (0, $acw62.useState)(null);
    const undoCondTimerRef = (0, $acw62.useRef)(null);
    const [activeVisitConflict, setActiveVisitConflict] = (0, $acw62.useState)(null); // { visitId } | null
    // Everything else that can stop a visit being created. Without it the failure
    // is a console.warn and a screen whose controls silently do not render — see
    // the matching note in Visit.web.jsx.
    const [startError, setStartError] = (0, $acw62.useState)(null);
    const medKey = (med)=>(med.display || '').trim().toLowerCase();
    const removeMed = async (med)=>{
        setRemovedMedNames((prev)=>new Set([
                ...prev,
                medKey(med)
            ]));
        setUndoMed(med);
        clearTimeout(undoTimerRef.current);
        undoTimerRef.current = setTimeout(()=>setUndoMed(null), 8000);
        const duplicates = (patient?.clinicalMedications || []).filter((m)=>medKey(m) === medKey(med));
        for (const m of duplicates)try {
            await (0, $eVM84.bffMutation)((0, $6xvbB.UPDATE_MEDICATION), {
                id: m.id,
                input: {
                    status: 'stopped'
                }
            });
        } catch  {}
        refreshPatient();
    };
    const restoreMed = async ()=>{
        if (!undoMed) return;
        clearTimeout(undoTimerRef.current);
        const key = medKey(undoMed);
        setRemovedMedNames((prev)=>{
            const s = new Set(prev);
            s.delete(key);
            return s;
        });
        setUndoMed(null);
        const stopped = (patient?.clinicalMedications || []).filter((m)=>medKey(m) === key && m.status === 'stopped');
        for (const m of stopped)try {
            await (0, $eVM84.bffMutation)((0, $6xvbB.UPDATE_MEDICATION), {
                id: m.id,
                input: {
                    status: 'active'
                }
            });
        } catch  {}
        refreshPatient();
    };
    const removeCondition = async (cond)=>{
        setRemovedCondIds((prev)=>new Set([
                ...prev,
                cond.id
            ]));
        setUndoCond(cond);
        clearTimeout(undoCondTimerRef.current);
        undoCondTimerRef.current = setTimeout(()=>setUndoCond(null), 8000);
        try {
            await (0, $eVM84.bffMutation)((0, $6xvbB.DELETE_CONDITION), {
                id: cond.id
            });
        } catch  {}
        refreshPatient();
    };
    const restoreCondition = async ()=>{
        if (!undoCond) return;
        clearTimeout(undoCondTimerRef.current);
        setRemovedCondIds((prev)=>{
            const s = new Set(prev);
            s.delete(undoCond.id);
            return s;
        });
        setUndoCond(null);
        // Restoring must carry the type the row had — see Visit.web.jsx.
        try {
            await (0, $eVM84.bffMutation)((0, $6xvbB.ADD_CONDITION), {
                patientId: patient.id,
                input: {
                    code: undoCond.code,
                    display: undoCond.display,
                    clinicalStatus: 'active',
                    verificationStatus: (0, $6ojK3.diagnosisTypeOf)(undoCond)
                }
            });
        } catch  {}
        refreshPatient();
    };
    // ── Demographics edit ──────────────────────────────────────────────────────
    // Same contract as the desktop «ویرایش» dialog: seed from the loaded patient,
    // send only the changed fields, refresh on success.
    const [showEditPatient, setShowEditPatient] = (0, $acw62.useState)(false);
    const [editPatientForm, setEditPatientForm] = (0, $acw62.useState)({});
    const [editPatientSaving, setEditPatientSaving] = (0, $acw62.useState)(false);
    const [editPatientError, setEditPatientError] = (0, $acw62.useState)('');
    // The refusal that names one number, under that number's row (PM-0536).
    const [editPatientPhoneErrors, setEditPatientPhoneErrors] = (0, $acw62.useState)(null);
    // The numbers and etag the sheet's list was seeded from. A save compares against and
    // sends THESE, never the live record's: after PHONES_CHANGED the record is read again,
    // and the fresh etag under the stale list would overwrite what changed meanwhile.
    const editPhonesFrom = (0, $acw62.useRef)(null);
    // The clinic country's national-id rule (PM-0218) — the sheet starts its field on
    // it too; `undefined` (no capabilities, an Iranian clinic) is Iran's, as before.
    const { nationalIdCountry: nidDefault } = (0, $kyxc1.useCountryDefaults)();
    const openEditPatient = ()=>{
        setEditPatientError('');
        setEditPatientPhoneErrors(null);
        setEditPatientForm({
            name: patient?.name || '',
            phone: patient?.phone || '',
            nationalId: patient?.nationalId || '',
            birthDate: patient?.birthDate || '',
            bloodType: patient?.bloodType || '',
            job: patient?.job || '',
            insurance: patient?.insurance || '',
            height: patient?.height != null ? String(patient.height) : '',
            // Every number as one list when the BFF sent them with their etag; else the
            // single field above, which sets the main number (PM-0536).
            ...(0, $bkBaq.phonesEditable)(patient) ? {
                phones: (0, $6SCJ6.phoneListRows)(patient.phones)
            } : {}
        });
        editPhonesFrom.current = (0, $bkBaq.phonesEditable)(patient) ? {
            phones: patient.phones,
            phonesEtag: patient.phonesEtag
        } : null;
        setShowEditPatient(true);
    };
    const saveEditPatient = async ()=>{
        if (editPatientSaving) return;
        // Parity with the desktop dialog: a changed code must pass its country's rule.
        if (editPatientForm.nationalId !== (patient?.nationalId || '') && (0, $3tGMU).nationalIdProblem(editPatientForm.nationalId, {
            country: editPatientForm.nationalIdCountry || nidDefault
        })) {
            setEditPatientError(t('validation.nationalId'));
            return;
        }
        setEditPatientSaving(true);
        setEditPatientError('');
        setEditPatientPhoneErrors(null);
        // The list goes whole, with the etag it was loaded under, and only when it
        // changed; `keys` places a refusal that names an index on its row.
        const listPatch = editPatientForm.phones && editPhonesFrom.current ? (0, $bkBaq.phonesPatch)(editPatientForm.phones, editPhonesFrom.current) : null;
        try {
            const u = {};
            if (editPatientForm.name !== (patient?.name || '')) u.name = editPatientForm.name;
            if (editPatientForm.phones) {
                if (listPatch) {
                    u.phones = listPatch.phones;
                    u.phonesEtag = listPatch.phonesEtag;
                }
            } else if (editPatientForm.phone !== (patient?.phone || '')) u.phone = editPatientForm.phone;
            if (editPatientForm.nationalId !== (patient?.nationalId || '')) u.nationalId = editPatientForm.nationalId;
            if (editPatientForm.birthDate !== (patient?.birthDate || '')) u.birthDate = editPatientForm.birthDate;
            if (editPatientForm.bloodType !== (patient?.bloodType || '')) u.bloodType = editPatientForm.bloodType;
            if (editPatientForm.job !== (patient?.job || '')) u.job = editPatientForm.job;
            if (editPatientForm.insurance !== (patient?.insurance || '')) u.insurance = editPatientForm.insurance;
            const nh = parseFloat(editPatientForm.height);
            if (!Number.isNaN(nh) && nh !== patient?.height) u.height = nh;
            if (Object.keys(u).length) {
                await (0, $eVM84.bffMutation)((0, $6xvbB.UPDATE_PATIENT), {
                    id: patient.id,
                    input: u
                });
                await refreshPatient();
            }
            setShowEditPatient(false);
        } catch (e) {
            // In the doctor's language (the BFF's messageKey): a claimed patient's identity,
            // a number the patient proved, the list changed meanwhile… A refusal that names
            // a number goes under its row; PHONES_CHANGED reads the record again, so the
            // sheet opened afresh starts from the numbers as they now are — until then this
            // sheet keeps the old etag, and saving it again is refused again.
            const text = (0, $bkBaq.patientEditErrorText)(t, has, e, 'errors.save.patientEdit');
            const row = (0, $bkBaq.refusedPhoneRow)(e, listPatch?.keys);
            if (row) setEditPatientPhoneErrors({
                [row]: text
            });
            else setEditPatientError(text);
            if ((0, $bkBaq.phonesChanged)(e)) refreshPatient();
        } finally{
            setEditPatientSaving(false);
        }
    };
    const visitStartTime = (0, $acw62.useRef)(null);
    // Vitals belong to the visit, so the recorder opens EMPTY — never seeded with
    // the patient's older readings (see vitalsForEncounter in Visit.shared).
    (0, $acw62.useEffect)(()=>{
        setVitalsMode('form');
        setVitals((0, $6xvbB.emptyVitals)());
        savedVitalIds.current = [];
        vitalsSeeded.current = null;
    }, [
        visitId
    ]);
    // …and fills in only from vitals actually recorded against THIS encounter, so
    // a reload mid-visit shows what was measured today. Runs on every patient
    // refetch but adopts once per encounter, so it can never wipe a form the
    // doctor is filling in.
    (0, $acw62.useEffect)(()=>{
        const encId = pmEncounterId || visitId || null;
        if (!encId || !patient) return;
        const key = String(encId);
        if (vitalsSeeded.current === key) return;
        const { values: values, ids: ids, recorded: recorded } = (0, $6xvbB.vitalsForEncounter)(patient.clinicalObservations, encId);
        if (!recorded) return;
        vitalsSeeded.current = key;
        setVitals(values);
        savedVitalIds.current = ids;
        setVitalsMode('saved');
    }, [
        patient,
        pmEncounterId,
        visitId
    ]);
    // Fetch doctor's prescription templates once on mount
    (0, $acw62.useEffect)(()=>{
        (0, $eVM84.bffQuery)((0, $6xvbB.GET_PRESCRIPTION_TEMPLATES)).then((r)=>{
            if (r?.prescriptionTemplates) setPrescriptionTemplates(r.prescriptionTemplates);
        }).catch(()=>{});
    }, []);
    // Declared BEFORE useTranscription, and that ordering is load-bearing:
    // the transcription hook reads `call.audioSource` to decide whether the
    // visit's audio comes from the conference or from the microphone.
    // ── ویزیت تصویری ───────────────────────────────────────────────────────────
    // A reduction of the web panel: same hook, same one-node rule, but
    // «بزرگ‌نمایی» grows the video in place rather than floating a fixed panel —
    // a fixed child would escape the IOSDevice frame's rounded clip.
    const ensureVisitStarted = (0, $acw62.useCallback)(async ()=>{
        const existing = pmEncounterId || visitId;
        if (existing) return existing;
        const id = await handleStart();
        if (!id) throw new Error('unavailable');
        return id;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pmEncounterId,
        visitId,
        patient?.id
    ]);
    const call = (0, $fiHxp.useVideoVisit)({
        patientId: patient?.id,
        appointmentId: pmEncounterId || visitId || null,
        ensureVisitStarted: ensureVisitStarted,
        // The brand the CALL shows (window title, join/leave toasts). Passed from
        // here because jitsiEmbed.js is React-free and has no i18n of its own.
        providerName: t('visit.call.providerName')
    });
    const { probe: probeCall } = call;
    (0, $acw62.useEffect)(()=>{
        probeCall();
    }, [
        probeCall
    ]);
    // «تبدیل به ویزیت آنلاین» — the in-person visit's secondary path. The control
    // is one 44px button at the end of the tab strip; the decision is this sheet.
    const [convertSheetOpen, setConvertSheetOpen] = (0, $acw62.useState)(false);
    const canConvertVisit = call.canConvert && !call.available && !call.live && !call.busy;
    const handleConvertVisit = (0, $acw62.useCallback)(async ()=>{
        // Close first when it lands: the call band mounts in the page behind the
        // sheet, and the call opens into it.
        const ok = await call.convert({
            andCall: false
        });
        if (!ok) return;
        setConvertSheetOpen(false);
        call.start();
    }, [
        call
    ]);
    // The OS is about to freeze this page mid-recording. Everything still only in
    // memory has to reach the draft inside this call — the hook runs it from the
    // `visibilitychange` handler, which is the last moment JS is guaranteed to run.
    const systemPauseRef = (0, $acw62.useRef)(null);
    const onSystemPause = (0, $acw62.useCallback)((snapshot)=>{
        systemPauseRef.current?.(snapshot);
    }, []);
    const { recState: recState, recError: recError, hints: hints, liveTranscript: liveTranscript, startRec: startRec, stopRec: stopRec, resumeRec: resumeRec, dismissPause: dismissPause, dismissError: dismissError } = (0, $fBZG6.useTranscription)({
        patientId: patient?.id,
        visitId: visitId,
        patientHistory: (0, $6xvbB.buildPatientHistory)(patient) + '\n' + (0, $6xvbB.buildVisitContext)(soap, diagnosis, pendingTests),
        // During a video visit the audio comes from the CALL, not from a second
        // microphone — the mic cannot hear the patient (echo cancellation removes
        // them) and on iOS it would steal the call's own audio session. Null when
        // no call is live, which leaves the in-person path exactly as it was.
        callAudio: call.audioSource,
        onSystemPause: onSystemPause,
        // The switch reaches the STREAM, so the hint agent is never RUN for a
        // doctor who turned «نکات بالینی زنده هنگام ضبط» off — rather than run,
        // billed for in tokens, and then hidden on arrival.
        hintsEnabled: liveHintsOn,
        engine: ambientSpeechEngine
    });
    const isRecording = recState === 'recording';
    const isStopping = recState === 'stopping';
    // Pressed, not yet recording — held so a second tap cannot start a second
    // recording (useTranscription, `connecting`).
    const isConnecting = recState === 'connecting';
    const isRecError = recState === 'error';
    const isRecPaused = recState === 'paused-by-system';
    // ── The visit's «پارسه» line is not the client's to write ─────────────────
    // It used to be `chargeVisit(ceil(recElapsed / 60) * 5)` right here, from a
    // `setInterval` counter — which kept counting while a suspended page recorded
    // nothing, so a backgrounded visit was billed for dead air, and a visit whose
    // page died before «توقف» was billed for nothing at all.
    //
    // The line is written server-side now, by the BFF, from the audio that
    // actually reached it. All this has to do is stop; the badge reads the ledger
    // back below.
    const stopRecCharged = stopRec;
    const hint = hints[0] ? typeof hints[0] === 'string' ? hints[0] : hints[0].text || '' : '';
    // ── Visit lifecycle ────────────────────────────────────────────────────────
    // Returns the started visit's id (= the scheduling appointment id) so that
    // «تماس با بیمار» can start the visit and open the room in one press. Null on
    // every failure it already handles — the conflict dialog and the error banner
    // still surface those.
    const handleStart = async ()=>{
        if (!patient?.id) return null;
        setStartError(null);
        try {
            const now = new Date().toISOString();
            visitStartTime.current = now;
            const cv = await (0, $eVM84.bffMutation)((0, $6xvbB.CREATE_VISIT), {
                patientId: patient.id,
                type: 'OUTPATIENT'
            });
            const id = cv.createVisit.id;
            await (0, $eVM84.bffMutation)((0, $6xvbB.START_VISIT), {
                id: id
            });
            setVisitId(id);
            setPmEncounterId(id);
            setVisitStatus('inprogress');
            setSoapNoteId(null);
            setSessionReady(false);
            (0, $eVM84.bffMutation)((0, $6xvbB.INITIALIZE_VISIT_SESSION), {
                visitId: id,
                patientId: patient.id
            }).then(()=>setSessionReady(true)).catch(()=>setSessionReady(true));
            return id;
        } catch (e) {
            const code = e?.extensions?.code || e?.graphQLErrors?.[0]?.extensions?.code;
            if (code === 'ACTIVE_VISIT_EXISTS') {
                const activeId = e?.extensions?.activeVisitId || e?.graphQLErrors?.[0]?.extensions?.activeVisitId;
                setActiveVisitConflict({
                    visitId: activeId || null
                });
                return null;
            }
            console.warn('handleStart error:', e);
            setStartError(e);
            return null;
        }
    };
    const handleResumeConflictVisit = ()=>{
        setStartError(null);
        const activeId = activeVisitConflict?.visitId;
        setActiveVisitConflict(null);
        if (!activeId) return;
        setVisitId(activeId);
        setPmEncounterId(activeId);
        setVisitStatus('inprogress');
        setSoapNoteId(null);
        setSessionReady(false);
        (0, $eVM84.bffMutation)((0, $6xvbB.INITIALIZE_VISIT_SESSION), {
            visitId: activeId,
            patientId: patient.id
        }).then(()=>setSessionReady(true)).catch(()=>setSessionReady(true));
    };
    const handleCloseConflictVisit = async ()=>{
        const activeId = activeVisitConflict?.visitId;
        setActiveVisitConflict(null);
        if (activeId) try {
            await (0, $eVM84.bffMutation)((0, $6xvbB.END_VISIT), {
                id: activeId
            });
        } catch  {}
        handleStart();
    };
    // Resolves to whether the note is now persisted. Most callers are fire-and-
    // forget autosaves that ignore it; the confirmation-question flow does not —
    // it may only close its panel once the write it just made has landed.
    //
    // Saves can race for a note not created yet — a confirmed proposal, the
    // plan's debounced save, an answered confirmation question. useSoapNoteRow
    // keeps that to ONE CREATE: a save behind it waits and updates the row it made.
    const writeSoapNoteRow = (0, $6xvbB.useSoapNoteRow)(soapNoteId, setSoapNoteId, visitId);
    const handleSaveSoapNote = async (currentSoap)=>{
        const s = currentSoap || soap;
        if (!patient?.id) return false;
        if (!(s.s || s.o || s.a || s.p)) return true;
        const resolvedEncId = pmEncounterId || visitId || null;
        const content = {
            s: s.s || '',
            o: s.o || '',
            a: s.a || '',
            p: s.p || ''
        };
        try {
            await writeSoapNoteRow({
                update: (id)=>(0, $eVM84.bffMutation)((0, $6xvbB.UPDATE_CLINICAL_NOTE), {
                        id: id,
                        input: {
                            content: content
                        }
                    }),
                create: async ()=>{
                    const res = await (0, $eVM84.bffMutation)((0, $6xvbB.CREATE_CLINICAL_NOTE), {
                        patientId: patient.id,
                        input: {
                            noteType: 'SOAP_NOTE',
                            content: content,
                            authorRole: 'doctor',
                            appointmentId: resolvedEncId
                        }
                    });
                    return res?.createClinicalNote?.id;
                }
            });
            return true;
        } catch (e) {
            console.warn('handleSaveSoapNote error:', e);
            return false;
        }
    };
    // ── Plan ⇄ نسخه/دستورات reconciliation ────────────────────────────────────
    //
    // Same loop as the desktop fork: «P» carries a managed block listing every
    // prescribed drug and live order, recomputed from the lists and rewritten only
    // when it has drifted. Derived, never accumulated — so add / edit / delete all
    // converge, and a re-run on correct text is a no-op, which is what makes the
    // effect safe to fire on every render that could have changed anything.
    //
    // English, like the desktop fork — the block is a clinical document, so an
    // order is named from the catalogue's `nameEn`, found by catalogId or by the
    // Persian description for orders that carry no id.
    // Catalog ids the clinic has an ACTIVE service declaration for (the `inHouse`
    // flag from getClinicalOrderCatalog). Only these can be performed — and billed
    // — here, so only they get the «انجام» button; everything else is fulfilled
    // elsewhere and merely waits.
    const inHouseCatalogIds = (0, $acw62.useMemo)(()=>{
        const ids = new Set();
        for (const [key, row] of catalogResolved)if (row?.inHouse && key === row.id) ids.add(row.id);
        return ids;
    }, [
        catalogResolved
    ]);
    // In the clinic: the BFF's `performedHere`, or the catalogue's `inHouse` above.
    const isOrderInHouse = (0, $acw62.useCallback)((o)=>o?.performedHere === true || !!o?.catalogId && inHouseCatalogIds.has(o.catalogId), [
        inHouseCatalogIds
    ]);
    const catalogNameEn = (0, $acw62.useMemo)(()=>{
        const m = new Map();
        for (const [key, row] of catalogResolved)if (row?.nameEn) m.set(key, row.nameEn);
        return m;
    }, [
        catalogResolved
    ]);
    const orderNameEn = (0, $acw62.useCallback)((o)=>catalogNameEn.get(o?.catalogId) || catalogNameEn.get((o?.description || '').trim()) || '', [
        catalogNameEn
    ]);
    const planBlock = (0, $acw62.useMemo)(()=>(0, $6xvbB.buildPlanBlock)({
            rxItems: rxItems,
            orders: clinicalOrders,
            orderNameEn: orderNameEn
        }), [
        rxItems,
        clinicalOrders,
        orderNameEn
    ]);
    // Live views for handleApplyPlan, which creates items and then has to file a
    // plan note listing them within the same async run.
    const rxItemsRef = (0, $acw62.useRef)(rxItems);
    rxItemsRef.current = rxItems;
    const clinicalOrdersRef = (0, $acw62.useRef)(clinicalOrders);
    clinicalOrdersRef.current = clinicalOrders;
    // Same reason, for the note: a confirmation answer appends to «S» and awaits
    // the save, so it must append to the latest text rather than to whatever the
    // closure captured before the previous answer landed.
    const soapRef = (0, $acw62.useRef)(soap);
    soapRef.current = soap;
    // ── تکمیل یادداشت — merge-aware SOAP completion (same hook as desktop) ────
    // handleSaveSoapNote is recreated each render, so the stable apply callback
    // below reads it through a ref — otherwise it would save with the FIRST
    // render's patient/soapNoteId closure and file a duplicate note.
    const saveSoapNoteRef = (0, $acw62.useRef)(null);
    saveSoapNoteRef.current = handleSaveSoapNote;
    const applyRefinedSections = (0, $acw62.useCallback)((entries)=>{
        setSoap((prev)=>{
            const next = {
                ...prev
            };
            Object.entries(entries).forEach(([k, text])=>{
                // The merge worked on the «P» NARRATIVE only; the block the note
                // already carries is preserved verbatim and re-spliced.
                if (k === 'p') next.p = (0, $6xvbB.splicePlanBlock)(text, (0, $6xvbB.planBlockText)(prev.p));
                else next[k] = text;
            });
            saveSoapNoteRef.current?.(next);
            return next;
        });
    }, []);
    // «تایید خودکار» (PM-0573, DESIGN_CONCEPT §13.3) — the doctor's own switch, and
    // never into a visit being closed; read by the two hooks when a proposal lands.
    const autoConfirmOn = !aiSettingsUnknown && (0, $3Tnyk.autoConfirmActive)(ai) && visitStatus === 'inprogress' && !endingVisit && !showClosureFlow;
    // What it confirmed in this visit: the strip's chip, each item's undo and the
    // record of both. An undo writes back through «تأیید»'s own writers and puts
    // the proposal on screen again, to be read like any other.
    const vitalsRef = (0, $acw62.useRef)(vitals);
    vitalsRef.current = vitals;
    const autoConfirm = (0, $cEPPo.useAutoConfirm)({
        visitId: visitId,
        appointmentId: pmEncounterId || visitId,
        read: (kind, key)=>{
            if (kind === 'soap') return (0, $6xvbB.soapSectionText)(soap, key);
            if (kind === 'vitals') return (0, $b4nOl.vitalsFormValue)(vitals, key);
            // PM-0586: a نسخه line by its product — its directions as added; an order by its id.
            if (kind === 'rx') {
                const line = rxItems.find((r)=>r.drug?.id === key);
                return line ? (0, $bwSot.autoRxSummary)(line) : '';
            }
            const order = clinicalOrders.find((o)=>o.id === key);
            return order && order.status !== 'cancelled' ? order.description || '' : '';
        },
        undoers: {
            soap: (item)=>{
                applyRefinedSections({
                    [item.key]: item.before
                });
                soapRefine.restore(item.key, item.payload.entry);
            },
            vitals: (item)=>{
                setVitals((prev)=>({
                        ...prev,
                        ...(0, $b4nOl.vitalsFormClear)(item.key)
                    }));
                monitoringExtract.restore('VITALS', [
                    item.payload.row
                ]);
            },
            // As on the desk: the نسخه's own removal, the order list's own cancel, and the
            // row waits in its review again.
            rx: (item)=>{
                const line = rxItemsRef.current.find((r)=>r.drug?.id === item.key);
                if (line) removeDrug(line.id);
                rxAssist.restore(item.payload.source, item.payload.row);
            },
            order: (item)=>{
                handleOrderTransition(item.key, 'cancel');
                monitoringExtract.restore('ORDERS', [
                    item.payload.row
                ]);
            }
        },
        labelOf: (kind, key)=>kind === 'soap' ? t({
                s: 'visit.soap.historyShort',
                o: 'visit.soap.objective',
                a: 'patient.soap.assessment',
                p: 'patient.soap.plan'
            }[key]) : t(`visit.monitoringExtract.vital.${key}`),
        toast: toast,
        t: t,
        joinList: formatList
    });
    const soapRefine = (0, $6xvbB.useSoapRefine)({
        visitId: visitId,
        patientId: patient?.id || null,
        soapRef: soapRef,
        liveTranscript: liveTranscript,
        chargeVisit: chargeVisit,
        onApply: applyRefinedSections,
        onCreditError: setCreditError,
        t: t,
        autoConfirm: autoConfirmOn,
        isEditing: (0, $6xvbB.soapEditorFocused),
        onAutoConfirm: (records)=>autoConfirm.add('soap', records)
    });
    // The «برنامه» textarea is controlled, so rewriting its value under the
    // doctor's fingers would move their caret. Defer while it holds focus; blur is
    // a dependency here, so releasing it reconciles at once.
    const [planEditorFocused, setPlanEditorFocused] = (0, $acw62.useState)(false);
    const planSaveTimer = (0, $acw62.useRef)(null);
    const schedulePlanNoteSave = (0, $acw62.useCallback)((nextSoap)=>{
        clearTimeout(planSaveTimer.current);
        planSaveTimer.current = setTimeout(()=>{
            handleSaveSoapNote(nextSoap);
        }, 700);
    }, [
        handleSaveSoapNote
    ]);
    (0, $acw62.useEffect)(()=>()=>clearTimeout(planSaveTimer.current), []);
    // Same guard as the desktop fork: a resumed visit restores «P» from the server
    // note, which already lists this encounter's orders. Reconciling before the
    // order fetch returns would read "not loaded yet" as "nothing ordered" and
    // strip those lines out of the plan.
    const ordersAuthoritative = ordersLoaded || !(pmEncounterId || visitId);
    (0, $acw62.useEffect)(()=>{
        if (planEditorFocused) return;
        if (!ordersAuthoritative) return;
        const nextP = (0, $6xvbB.splicePlanBlock)(soap.p, planBlock);
        if (nextP === (soap.p || '')) return;
        setSoap((prev)=>prev.p === soap.p ? {
                ...prev,
                p: nextP
            } : prev);
        schedulePlanNoteSave({
            ...soap,
            p: nextP
        });
    }, [
        planBlock,
        planEditorFocused,
        ordersAuthoritative,
        soap,
        schedulePlanNoteSave
    ]);
    // Returns whether the list is now authoritative — a failed fetch leaves the
    // previous list standing rather than reporting an empty visit, because the
    // reconciler would take that literally and delete the doctor's orders from «P».
    const loadClinicalOrders = async (encId)=>{
        if (!encId) return false;
        setOrdersLoading(true);
        try {
            const data = await (0, $eVM84.bffQuery)((0, $6xvbB.LIST_CLINICAL_ORDERS), {
                appointmentId: encId
            });
            setClinicalOrders(data?.listOrders || []);
            setOrdersLoaded(true);
            return true;
        } catch  {
            return false;
        } finally{
            setOrdersLoading(false);
        }
    };
    const handleCreateOrder = async ()=>{
        const encId = pmEncounterId || visitId;
        if (!encId || !patient?.id || !newOrder.description.trim()) return;
        setOrderSaving(true);
        try {
            const data = await (0, $eVM84.bffMutation)((0, $6xvbB.CREATE_CLINICAL_ORDER), {
                appointmentId: encId,
                patientId: patient.id,
                orderType: newOrder.orderType,
                description: newOrder.description,
                urgency: newOrder.urgency,
                notes: newOrder.notes
            });
            setClinicalOrders((prev)=>[
                    data.createOrder,
                    ...prev
                ]);
            setNewOrder({
                orderType: 'lab',
                description: '',
                urgency: 'routine',
                notes: ''
            });
        } catch  {} finally{
            setOrderSaving(false);
        }
    };
    // Returns whether the transition landed: «انجام» chains start→complete, and
    // chaining past a failed start would report a completed order the server never
    // completed. A failure surfaces in the orders tab's error strip.
    const handleOrderTransition = async (orderId, action)=>{
        setOrderTransitioning(orderId);
        const mutMap = {
            start: (0, $6xvbB.START_ORDER_MUT),
            complete: (0, $6xvbB.COMPLETE_ORDER_MUT),
            cancel: (0, $6xvbB.CANCEL_ORDER_MUT)
        };
        const fieldMap = {
            start: 'startOrder',
            complete: 'completeOrder',
            cancel: 'cancelOrder'
        };
        try {
            const data = await (0, $eVM84.bffMutation)(mutMap[action], {
                orderId: orderId
            });
            const updated = data[fieldMap[action]];
            // The stage the BFF read is the old status's: dropped, so the row reads
            // the new one from its status (constants/statuses `orderStageOf`).
            setClinicalOrders((prev)=>prev.map((o)=>o.id === orderId ? {
                        ...o,
                        status: updated.status,
                        stage: null
                    } : o));
            setOrderError(null);
            return true;
        } catch (e) {
            setOrderError(e?.message || t('errors.save.orderStatus'));
            return false;
        } finally{
            setOrderTransitioning(null);
        }
    };
    // The «انجام» rail: completion is the billing event, and clinicalencounter only
    // accepts it from in_progress — so a pending order is started first. Both
    // steps ride the one transition handler so the row's busy state covers both.
    //
    // In the clinic (PM-0618) «انجام شد» records ONE session in THIS visit instead —
    // performer = the doctor, on this visit's invoice — and the list is read again,
    // because the answer is a TreatmentStep, not the row (visitSessions.js). The
    // start→complete chain below is the older rail; an order done elsewhere no
    // longer reaches it — it has no «انجام شد» at all (PM-0680).
    const handleOrderDone = async (orderId)=>{
        const order = clinicalOrders.find((o)=>o.id === orderId);
        if (!order) return;
        if (isOrderInHouse(order) && !order.processId) {
            setOrderTransitioning(orderId);
            setOrderError(null);
            try {
                const done = await (0, $7TTuK.markOrderDoneHere)({
                    order: order,
                    visitId: pmEncounterId || visitId
                });
                if (done.orders) setClinicalOrders(done.orders);
                setVisitServicesKey((k)=>k + 1);
            } catch (e) {
                setOrderError(e?.message || t('errors.save.orderDone'));
            } finally{
                setOrderTransitioning(null);
            }
            return;
        }
        if (order.status === 'pending') {
            const started = await handleOrderTransition(orderId, 'start');
            if (!started) return;
        }
        await handleOrderTransition(orderId, 'complete');
    };
    // A saved row's «تاریخ انجام» changed (PM-0634) — the desktop's handler: null
    // once it landed, else the sentence (the service's own when it refused).
    const handleOrderDateChange = async (orderId, performedDate)=>{
        try {
            const data = await (0, $eVM84.bffMutation)((0, $6xvbB.UPDATE_ORDER_DATE), {
                orderId: orderId,
                performedDate: performedDate
            });
            const updated = data?.updateOrderDate;
            if (!updated) return t('visit.orders.date.saveFailed');
            setClinicalOrders((prev)=>prev.map((o)=>o.id === orderId ? {
                        ...o,
                        ...updated
                    } : o));
            return null;
        } catch (e) {
            return e?.message || t('visit.orders.date.saveFailed');
        }
    };
    const handleCancelEncounter = async ()=>{
        if (!visitId || cancellingVisit) return;
        setCancellingVisit(true);
        try {
            await (0, $eVM84.bffMutation)((0, $6xvbB.CANCEL_ENCOUNTER), {
                id: visitId
            });
            if (isRecording) stopRec();
            setVisitId(null);
            setVisitStatus(null);
            setPmEncounterId(null);
            // Cancelled visit leaves nothing behind: drop the recovery draft and leave
            // the visit screen. navProp (not the wrapped navigate) — this closure still
            // sees visitStatus 'inprogress', which would re-arm the leave guard.
            try {
                localStorage.removeItem(`visit_draft_${patient?.id}`);
            } catch  {}
            navProp('patient-detail', {
                id: patient?.id
            });
        } catch (e) {
            console.error('[cancelEncounter]', e);
        } finally{
            setCancellingVisit(false);
        }
    };
    // High findings an earlier stop of the sweep below already showed, under the
    // signature of the نسخه they were found in — the desktop hook keeps the same.
    const sweepShownRef = (0, $acw62.useRef)(null);
    // «پیش از پایان ویزیت» (PM-0618, useEndVisit.js): the in-house services of this
    // visit still open in it are answered first — in a sheet that is itself the
    // confirmation — else the plain confirm, as before.
    const endServices = (0, $glimY.useEndVisitServices)({
        orders: clinicalOrders,
        visitId: pmEncounterId || visitId || null,
        isInHouse: isOrderInHouse
    });
    const requestEnd = async ()=>{
        const items = await endServices.prepare();
        if (items.length > 0) setEndServicesOpen(true);
        else setPendingEnd(true);
    };
    const handleEnd = async ()=>{
        if (!visitId) return;
        setEndingVisit(true);
        try {
            if (isRecording) stopRec();
            // Encounter ID for clinicalencounter — set to visitId at start; fallback to visitId.
            const resolvedPmEncId = pmEncounterId || visitId || null;
            // Final safety sweep — the one interaction check the doctor does not ask
            // for, and the backstop for a prescription that was never checked by hand.
            // Severity-gated on purpose: ONLY a high-severity finding holds the visit
            // open; متوسط and خفیف wait in the نسخه tab.
            // «بررسی تداخل دارویی در پایان ویزیت» — the only automation switch here
            // that is about safety rather than spend, which is why it is read
            // directly and not through `aiSettingsUnknown`: a settings query that
            // failed is no reason to stop checking a prescription.
            if (endVisitSweepOn && rxItems.length > 0 && patient?.id) try {
                const sweepConditions = [
                    ...(patient.clinicalConditions || []).map((c)=>c.display),
                    ...(differential || []).filter((0, $6xvbB.isDifferentialAccepted)).map((d)=>d.description),
                    ...(0, $6xvbB.inferConditionsFromObservations)(patient.clinicalObservations)
                ];
                const sweepAllergies = (patient.clinicalAllergies || []).map((a)=>a.allergen).filter(Boolean);
                const sweepResult = await (0, $eVM84.bffQuery)((0, $6xvbB.CHECK_DRUG_INTERACTION), {
                    // Names, not formulary ids — see interactionDrugName.
                    medicationIds: (0, $g6gAc.interactionDrugNames)(rxItems),
                    patientId: patient.id,
                    patientConditions: sweepConditions,
                    patientAllergies: sweepAllergies
                });
                // The sweep is an AI call like any other and the service debits for
                // it (3 پارسه), so it belongs in the visit's own tally. Without this
                // the debit showed up in the account panel and NOWHERE on the visit —
                // a doctor closing a visit watched credits leave for something they
                // never pressed a button for and the page never mentioned.
                chargeVisit((0, $1yr2B.costOf)('INTERACTION_CHECK'), 'interaction');
                const sweepWarnings = sweepResult.checkDrugInteraction?.warnings || [];
                // Same gate as the desktop (useEndVisit): every high finding not yet
                // shown for THIS نسخه holds the visit, matched by its drugs. «Any
                // earlier high» let a new A + C close on an A + B seen before C was
                // added (interactionSeen.js).
                if ((0, $k6Haa.sweepHolds)(sweepWarnings, {
                    shown: rxInteractions,
                    signature: rxSignature,
                    memo: sweepShownRef
                })) {
                    setRxInteractions({
                        hasInteractions: true,
                        warnings: sweepWarnings,
                        signature: rxSignature
                    });
                    setMobileTab('rx');
                    setEndingVisit(false);
                    return;
                }
            } catch  {}
            await (0, $eVM84.bffMutation)((0, $6xvbB.END_VISIT), {
                id: visitId
            });
            // Captured BEFORE the reset below — same duplicate-note fix as
            // Visit.web.jsx: closure must UPDATE the autosaved row, not add a second.
            const endNoteId = soapNoteId;
            // Mark finished immediately so all reactive AI effects (SOAP refine, differential regen)
            // see visitStatus !== 'inprogress' and stop firing — their cleanup functions also run here.
            setVisitStatus('finished');
            setSoapNoteId(null);
            // Ending a visit costs nothing and calls no AI — same contract as the
            // desktop surface. See the note in Visit.web.jsx's handleEndVisit.
            // Same accumulator, same reason, as Visit.web.jsx: every write below used
            // to swallow its failure and fall through to a closure screen that says
            // the visit is done, so a network blip meant a doctor closed a visit
            // believing the prescription was in the record when it was not.
            const failures = [];
            const today = new Date().toISOString().split('T')[0];
            const endTime = new Date().toISOString();
            // Update encounter in patient management
            if (resolvedPmEncId) try {
                await (0, $eVM84.bffMutation)((0, $6xvbB.UPDATE_ENCOUNTER), {
                    id: resolvedPmEncId,
                    input: {
                        status: 'finished',
                        periodEnd: endTime,
                        reason: soap.a || diagnosis || ''
                    }
                });
            } catch (e) {
                console.warn('updateEncounter failed:', e.message);
                failures.push(t('visit.end.partEncounter'));
            }
            // Save structured SOAP note (always, if any SOAP content exists). The
            // autosave already owns a row (endNoteId) — update it; only a visit whose
            // SOAP was never autosaved creates one here. Plain update, not an
            // amendment: ending a visit records no edit history.
            if (patient?.id && (soap.s || soap.o || soap.a || soap.p)) {
                const content = {
                    s: soap.s || '',
                    o: soap.o || '',
                    a: soap.a || '',
                    p: soap.p || ''
                };
                try {
                    if (endNoteId) await (0, $eVM84.bffMutation)((0, $6xvbB.UPDATE_CLINICAL_NOTE), {
                        id: endNoteId,
                        input: {
                            content: content
                        }
                    });
                    else await (0, $eVM84.bffMutation)((0, $6xvbB.CREATE_CLINICAL_NOTE), {
                        patientId: patient.id,
                        input: {
                            noteType: 'SOAP_NOTE',
                            content: content,
                            authorRole: 'doctor',
                            appointmentId: resolvedPmEncId || visitId
                        }
                    });
                } catch (e) {
                    console.warn('saveSoapNote failed:', e.message);
                    failures.push(t('visit.end.partSoap'));
                }
            }
            // No VISIT_SUMMARY note is written any more — see Visit.web.jsx.
            // Save prescribed drugs to patient medication list.
            // Rows carrying a `medicationId` already exist in the record — a template
            // put them there and every edit since went to that same row — so writing
            // them again would give the patient two rows for one drug. Same rule as
            // Visit.web.jsx; see useVisitRxPersistence.
            if (patient?.id && rxItems.length > 0) for (const item of rxItems){
                if (item.medicationId) continue;
                try {
                    await (0, $eVM84.bffMutation)((0, $6xvbB.CREATE_MEDICATION), {
                        patientId: patient.id,
                        input: {
                            code: item.drug.genericName || item.drug.name,
                            display: item.drug.name,
                            status: 'active',
                            authoredOn: today,
                            // The SAME structured payload the desktop writes (useEndVisit):
                            // dose, frequency, route and quantity as fields, not one sentence.
                            // A phone-written drug used to keep only the sentence, so it could
                            // never be sent to an insurer — no route, no quantity.
                            dosageInstruction: (0, $85jFj.dosageInstructionFromRxItem)(item),
                            quantity: (0, $eQiuG.quantityNumber)(item.quantity),
                            meta: (0, $85jFj.medicationMetaFromDrug)(item.drug),
                            appointmentId: resolvedPmEncId || visitId
                        }
                    });
                } catch (e) {
                    console.warn('save medication failed:', e.message);
                    failures.push(`${t('visit.end.partDrug')} \u{2014} ${(0, $g6gAc.drugDisplayName)(item.drug)}`);
                }
            }
            // Save diagnosis as active condition.
            // Note: accepted differential items are already persisted server-side by
            // ai.js's updateDifferentialItem resolver (action 'accept') the moment the
            // doctor accepts them — do NOT re-save those here, or every accepted
            // diagnosis ends up with two duplicate Condition rows.
            if (patient?.id) {
                const primaryDisplay = soap.a || diagnosis || '';
                if (primaryDisplay) try {
                    await (0, $eVM84.bffMutation)((0, $6xvbB.ADD_CONDITION), {
                        patientId: patient.id,
                        input: {
                            code: '',
                            display: primaryDisplay,
                            status: 'active',
                            // Free assessment prose nobody was asked to type — a working
                            // diagnosis until the doctor says otherwise. See Visit.web.jsx.
                            verificationStatus: (0, $6ojK3.DX_PROVISIONAL),
                            onsetDate: today,
                            appointmentId: resolvedPmEncId || visitId
                        }
                    });
                } catch (e) {
                    console.warn('save condition failed:', e.message);
                    failures.push(t('visit.end.partDiagnosis'));
                }
            }
            // Save any pending orders that weren't saved yet via the panel button —
            // one write per order, as the desktop does (visitOrders.saveDoctorOrder):
            // the batch's answer was never read, and it said success even when every
            // order in it failed, so the closure showed none of them as «ثبت نشد».
            const unsavedAtEnd = pendingTests.filter((test)=>!test.savedToBackend);
            if (patient?.id && unsavedAtEnd.length > 0) {
                for (const item of unsavedAtEnd)try {
                    await (0, $5qIQm.saveDoctorOrder)({
                        patientId: patient.id,
                        appointmentId: resolvedPmEncId || visitId
                    }, (0, $5qIQm.doctorOrderInput)(item));
                } catch (e) {
                    console.warn('save pendingTests at end failed:', e.message);
                    failures.push(`${t('visit.end.partOrders')} \u{2014} ${item.name || item.testName || item}`);
                }
            }
            // Only a clean end drops the draft — when a write failed it is the sole
            // surviving copy of what the doctor typed.
            if (failures.length === 0) try {
                localStorage.removeItem(`visit_draft_${patient?.id}`);
            } catch  {}
            setSaveFailures(failures);
            if (failures.length > 0) toast?.error?.(t('visit.end.partialSaveToast'));
            setEndingVisit(false);
            setShowClosureFlow(true);
        } catch (e) {
            console.error('[handleEndVisit]', e);
            toast?.error?.(t('visit.end.failedToast'));
            setEndingVisit(false);
        }
    };
    // Back to پذیرش when the closure is done — see Visit.web.jsx.
    const goToReception = ()=>{
        setShowClosureFlow(false);
        navigate('reception');
    };
    // ── Load last 3 visit summaries for the context panel ────────────────────
    (0, $acw62.useEffect)(()=>{
        if (!patient?.id || pastVisitSummaries !== null) return;
        (0, $eVM84.bffQuery)((0, $6xvbB.PATIENT_VISIT_HISTORY), {
            patientId: patient.id,
            limit: 4
        }).then((data)=>setPastVisitSummaries(data.patientVisitHistory?.visits || [])).catch(()=>setPastVisitSummaries([]));
    }, [
        patient?.id
    ]);
    // ── Elapsed timer (ticks only while visit is in progress) ─────────────────
    (0, $acw62.useEffect)(()=>{
        if (visitStatus !== 'inprogress') return;
        const timer = setInterval(()=>setElapsed((e)=>e + 1), 1000);
        return ()=>clearInterval(timer);
    }, [
        visitStatus
    ]);
    // ── Recording timer (resets to 0 each time recording starts) ──────────────
    (0, $acw62.useEffect)(()=>{
        // A system pause FREEZES the count rather than resetting it: the doctor
        // should see how long the interrupted segment ran, and the number is no
        // longer what anything is billed from.
        if (isRecPaused) return undefined;
        if (!isRecording) {
            setRecElapsed(0);
            return undefined;
        }
        const timer = setInterval(()=>setRecElapsed((e)=>e + 1), 1000);
        return ()=>clearInterval(timer);
    }, [
        isRecording,
        isRecPaused
    ]);
    // ── The transcription line, read back rather than written ────────────────
    // Asking when the recording LEAVES `recording` covers every ending: a
    // deliberate stop, a final pass that resolved, and the system pause — which
    // still bills, because the audio still arrived.
    const wasRecordingRef = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        const was = wasRecordingRef.current;
        wasRecordingRef.current = isRecording;
        if (!was || isRecording) return undefined;
        // After the socket's own write, which happens the moment `done` reaches
        // the BFF. One retry covers a slow write without polling.
        const first = setTimeout(refetchCoins, 1200);
        const second = setTimeout(refetchCoins, 6000);
        return ()=>{
            clearTimeout(first);
            clearTimeout(second);
        };
    }, [
        isRecording,
        refetchCoins
    ]);
    // ── Auto-start or resume encounter when patient loads ────────────────────
    // Checks for an active in-progress encounter on the server first.
    // If found for this patient, restores visitId/status and pulls SOAP draft
    // from localStorage instead of creating a duplicate encounter.
    const autoStarted = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        if (!patient?.id || visitId || autoStarted.current) return;
        autoStarted.current = true;
        (0, $eVM84.bffQuery)((0, $6xvbB.GET_ACTIVE_ENCOUNTER)).then((data)=>{
            const enc = data?.getActiveEncounter;
            if (enc?.id && enc.patientId === patient.id && enc.status === 'in_progress') {
                setVisitId(enc.id);
                setPmEncounterId(enc.id);
                setVisitStatus('inprogress');
                setResumedVisit(true);
                // Restore draft from localStorage — it's the only recovery path now;
                // enc.notes/enc.diagnosis no longer exist on Encounter, so there is no
                // server-side fallback anymore.
                try {
                    const raw = localStorage.getItem(`visit_draft_${patient.id}`);
                    if (raw) {
                        const draft = JSON.parse(raw);
                        if (draft.visitId === enc.id && Date.now() - draft.ts < 3600000) {
                            if (draft.soap) setSoap(draft.soap);
                            if (draft.rxItems?.length) setRxItems(draft.rxItems);
                            if (draft.diagnosis) setDiagnosis(draft.diagnosis);
                        }
                    }
                } catch  {}
                // Re-initialize AI session and differential for the resumed encounter
                setSessionReady(false);
                (0, $eVM84.bffMutation)((0, $6xvbB.INITIALIZE_VISIT_SESSION), {
                    visitId: enc.id,
                    patientId: patient.id
                }).then(()=>setSessionReady(true)).catch(()=>setSessionReady(true));
            } else handleStart();
        }).catch(()=>handleStart());
    }, [
        patient?.id
    ]);
    // ── Leave-guard ───────────────────────────────────────────────────────────
    // window.__parsina_visit_guard: called by WebLayout/AppShell before navigating.
    (0, $acw62.useEffect)(()=>{
        if (visitStatus === 'inprogress') window.__parsina_visit_guard = (proceedFn)=>{
            pendingNavRef.current = {
                callback: proceedFn
            };
            setLeaveConfirm(true);
        };
        else window.__parsina_visit_guard = null;
        return ()=>{
            window.__parsina_visit_guard = null;
        };
    }, [
        visitStatus
    ]);
    // ── The leave-guard's history anchor (§C.3 rule 2) ───────────────────────
    // A browser/platform back asks «خروج از ویزیت؟» through the anchor; a leave the
    // doctor has confirmed goes through `leaveVisit`, so it is not asked twice
    // (PM-0135). The anchor, the overlay rules and the unwind depth live in the hook.
    const leaveVisit = (0, $lqfll.useVisitLeaveAnchor)({
        active: visitStatus === 'inprogress',
        visitKey: patient?.id,
        onRequest: (proceed)=>{
            pendingNavRef.current = {
                callback: proceed
            };
            setLeaveConfirm(true);
        },
        back: goBack
    });
    // Wrap the prop-based navigate so it also goes through the guard
    const navigate = (...args)=>{
        if (visitStatus === 'inprogress') {
            pendingNavRef.current = args;
            setLeaveConfirm(true);
        } else navProp(...args);
    };
    // ── Layer 1: Warn before accidental page close ────────────────────────────
    // beforeunload works on desktop Chrome/Firefox/Edge but is suppressed by
    // iOS Safari. Layers 1b handles iOS via visibilitychange + pagehide.
    (0, $acw62.useEffect)(()=>{
        if (visitStatus !== 'inprogress') return;
        const onUnload = (e)=>{
            e.preventDefault();
            e.returnValue = '';
        };
        window.addEventListener('beforeunload', onUnload);
        return ()=>window.removeEventListener('beforeunload', onUnload);
    }, [
        visitStatus
    ]);
    // ── Layer 1b: iOS / Android — immediate flush on page hide ───────────────
    // iOS Safari never fires beforeunload. visibilitychange (hidden) + pagehide
    // are the reliable signals that the page is about to die. When fired we
    // immediately write localStorage AND attempt a server save so no work is
    // lost between 30-second auto-save ticks.
    // Use a ref so the handlers always see the latest state without re-registering
    // on every keystroke.
    const draftFlushRef = (0, $acw62.useRef)(null);
    draftFlushRef.current = (recording = null)=>{
        if (!visitId || visitStatus !== 'inprogress') return;
        try {
            localStorage.setItem(`visit_draft_${patient?.id}`, JSON.stringify({
                visitId: visitId,
                soap: soap,
                rxItems: rxItems,
                diagnosis: diagnosis,
                ts: Date.now(),
                // The transcript and the elapsed count exist only in the
                // transcription hook's memory, and the OS is about to freeze this
                // page. They ride into the draft so a doctor who comes back to a
                // reloaded tab still has what was said before the interruption —
                // independently of the server-side copy.
                ...recording ? {
                    recording: recording
                } : null
            }));
        } catch  {}
    };
    // Called INSIDE the `visibilitychange` handler — the last moment JS is
    // guaranteed to run — so it must stay synchronous.
    systemPauseRef.current = (snapshot)=>draftFlushRef.current(snapshot);
    (0, $acw62.useEffect)(()=>{
        if (visitStatus !== 'inprogress' || !visitId) return;
        const onVis = ()=>{
            if (document.visibilityState === 'hidden') draftFlushRef.current();
        };
        const onHide = ()=>draftFlushRef.current();
        document.addEventListener('visibilitychange', onVis);
        window.addEventListener('pagehide', onHide);
        return ()=>{
            document.removeEventListener('visibilitychange', onVis);
            window.removeEventListener('pagehide', onHide);
        };
    }, [
        visitStatus,
        visitId
    ]);
    // ── Layer 2: Save draft to localStorage on every SOAP / rx / diagnosis change
    // Keyed by patientId so recovery can find it even if the component remounts.
    (0, $acw62.useEffect)(()=>{
        if (!visitId || visitStatus !== 'inprogress') return;
        try {
            localStorage.setItem(`visit_draft_${patient?.id}`, JSON.stringify({
                visitId: visitId,
                soap: soap,
                rxItems: rxItems,
                diagnosis: diagnosis,
                ts: Date.now()
            }));
        } catch  {}
    }, [
        soap,
        rxItems,
        diagnosis,
        visitId,
        visitStatus
    ]);
    // Layer 3 (server auto-save every 30s) removed — VisitInput no longer accepts
    // notes/diagnosis/prescription; the Layer 2 localStorage draft above is the
    // only persistence for in-progress drafts now.
    // ── Fetch/refresh differential diagnosis ─────────────────────────────────
    //
    // Nothing below runs — not the visit-open call, not the loop, not a manual
    // refresh — until «S» carries a chief complaint and the history behind it. The
    // panel says so rather than sitting empty. Clinical monitoring is NOT part of
    // this: it is one way of filling «S», not a licence to reason from it.
    const diffGate = (0, $6xvbB.differentialReadiness)({
        soap: soap
    });
    const diffReady = diffGate.ready;
    const diffReadyRef = (0, $acw62.useRef)(false);
    diffReadyRef.current = diffReady;
    // One in-flight request at a time. Every call re-runs the assessment against
    // whatever the visit knows at that moment, so two overlapping calls answer the
    // same question twice — and a poll that ticks while the previous one is still
    // out would stack requests without ever showing a newer answer.
    const diffInFlightRef = (0, $acw62.useRef)(false);
    // Moves whenever a confirm/dismiss leaves or settles — see
    // trackDifferentialDecision. A poll whose answer comes back with it moved
    // must not undo that decision on screen.
    const diffDecisionSeqRef = (0, $acw62.useRef)(0);
    const fetchDifferential = (0, $acw62.useCallback)(()=>{
        if (!visitId || visitStatus !== 'inprogress') return;
        if (!diffReadyRef.current) return;
        if (diffInFlightRef.current) return;
        diffInFlightRef.current = true;
        setDiffLoading(true);
        const decisionSeq = diffDecisionSeqRef.current;
        (0, $eVM84.bffQuery)((0, $6xvbB.GET_DIFFERENTIAL), {
            visitId: visitId
        }).then((data)=>{
            const newItems = data.getDifferentialDiagnosis?.items || [];
            // Record the visit-ledger charge only when the AI service actually
            // re-ran (and billed) the assessment — free cache reads stay free.
            if (data.getDifferentialDiagnosis?.regenerated) chargeVisit((0, $1yr2B.costOf)('DIFFERENTIAL'), 'differential');
            const stale = diffDecisionSeqRef.current !== decisionSeq;
            setDifferential((prev)=>(0, $6xvbB.mergeDifferentialPoll)(prev, newItems, {
                    stale: stale
                }));
        }).catch(()=>{}).finally(()=>{
            diffInFlightRef.current = false;
            setDiffLoading(false);
        });
    }, [
        visitId,
        visitStatus,
        chargeVisit
    ]);
    // Settings → دستیار هوشمند → «اجرای خودکار تشخیص افتراقی». Gates the two
    // AUTOMATIC paths below only; an explicit refresh still calls
    // fetchDifferential directly. Undefined reads as on.
    const autoDifferential = !aiSettingsUnknown && ai.autoDifferentialOnStart !== false;
    // Only fetch differential after session init is done — avoids race condition
    // where AI service has no session data and returns the empty fallback.
    // diffReady is a real dependency, not just the ref read inside
    // fetchDifferential: on a page reload the saved SOAP note is still in flight
    // when sessionReady flips, so the fetch used to be skipped by the readiness
    // guard and never retried (nothing else fetches unless recording) — the list
    // then only showed up after a remount, where the localStorage draft restores
    // SOAP first. It now also carries clinical monitoring, so the first automatic
    // run happens when the visit is genuinely under way.
    // Latched per visit so this stays ONE automatic call (each one bills credits).
    const autoDiffVisitRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (!sessionReady || !autoDifferential || !diffReady) return;
        if (autoDiffVisitRef.current === visitId) return;
        autoDiffVisitRef.current = visitId;
        fetchDifferential();
    }, [
        sessionReady,
        autoDifferential,
        diffReady,
        visitId,
        fetchDifferential
    ]);
    // ── Re-assessment while the visit is live ────────────────────────────────
    //
    // Each tick is a full re-evaluation, not a cache read: the AI service rebuilds
    // the list from the transcript as it has grown, SOAP notes saved since, and
    // vitals recorded since, and returns the stored list untouched when none of
    // those moved. The cadence is the doctor's, from Settings → دستیار هوشمند
    // (which also honours the master automatic-differential switch, because
    // polling is a kind of automatic run); the on/off can be taken back for this
    // visit alone from the switch above the list.
    const { active: pollingActive, pollMs: pollMs, seconds: pollSeconds, overridden: pollOverridden, toggle: togglePolling } = (0, $6xvbB.useDifferentialPolling)(ai, aiSettingsUnknown, visitId);
    (0, $acw62.useEffect)(()=>{
        if (!pollingActive) return;
        // Recording is this LOOP's own prerequisite, not the differential's: each
        // tick exists to re-ask as the conversation grows, and with nothing being
        // transcribed there is nothing new to re-ask about. A doctor who writes the
        // history by hand still gets the differential, just not on a timer.
        if (!diffReady || recState !== 'recording') return;
        if (!visitId || visitStatus !== 'inprogress') return;
        // A backgrounded phone is nobody reading the list. The visit keeps
        // recording — this only defers the re-assessment, which the next visible
        // tick picks up with MORE context than it would have had, not less.
        const tick = ()=>{
            if (typeof document !== 'undefined' && document.visibilityState === 'hidden') return;
            fetchDifferential();
        };
        const initial = setTimeout(tick, Math.min((0, $6xvbB.DIFFERENTIAL_POLL_LEAD_MS), pollMs));
        const interval = setInterval(tick, pollMs);
        return ()=>{
            clearTimeout(initial);
            clearInterval(interval);
        };
    }, [
        diffReady,
        recState,
        visitId,
        visitStatus,
        fetchDifferential,
        pollingActive,
        pollMs
    ]);
    // Reset confirmation state only when the actual set of active diagnosis codes changes,
    // not on every poll (differential is a new array reference each fetch even with same data).
    // A refresh REVISES the list — a diagnosis that survives the reassessment keeps
    // its questions and the answers already recorded against it.
    const prevDiffCodesRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        const active = (differential || []).filter((d)=>d.status !== 'rejected').map((d)=>d.diagnosisCode);
        const codes = [
            ...active
        ].sort().join(',');
        if (prevDiffCodesRef.current !== null && prevDiffCodesRef.current !== codes) {
            setDiagAIQuestions((prev)=>(0, $6xvbB.pruneDiagnosisKeyed)(prev, active));
            setDiagAIAnswers((prev)=>(0, $6xvbB.pruneDiagnosisKeyed)(prev, active));
            setDiagQSubmitting((prev)=>(0, $6xvbB.pruneDiagnosisKeyed)(prev, active));
            setDiagQError((prev)=>(0, $6xvbB.pruneDiagnosisKeyed)(prev, active));
            setOpenAIDiag((prev)=>prev && active.includes(prev) ? prev : null);
        }
        prevDiffCodesRef.current = codes;
    }, [
        differential
    ]);
    // Loaded as soon as the encounter is known, NOT when the دستورات tab opens: the
    // plan block lists these orders, so they must be there for a doctor who goes
    // straight to «برنامه». The tab remains a retry point for a failed fetch.
    const ordersLoadedFor = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        const encId = pmEncounterId || visitId;
        if (!encId || ordersLoadedFor.current === encId) return;
        ordersLoadedFor.current = encId;
        loadClinicalOrders(encId).then((ok)=>{
            if (!ok) ordersLoadedFor.current = null;
        });
    }, [
        workTab,
        pmEncounterId,
        visitId
    ]);
    // What the orders already on this chart need from the catalogue — a lookup by
    // id, not a reason to fetch a dictionary. Orders written before catalogIds
    // existed resolve by name; an ambiguous name resolves to nothing.
    const resolveKey = (0, $acw62.useMemo)(()=>clinicalOrders.map((o)=>o?.catalogId || (o?.description || '').trim()).filter(Boolean).sort().join('\u0000'), [
        clinicalOrders
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!resolveKey) {
            setCatalogResolved(new Map());
            return undefined;
        }
        let live = true;
        const current = clinicalOrders;
        (0, $6xvbB.resolveOrderCatalog)({
            ids: current.map((o)=>o?.catalogId).filter(Boolean),
            names: current.filter((o)=>!o?.catalogId).map((o)=>(o?.description || '').trim()).filter(Boolean),
            appointmentId: pmEncounterId || visitId
        }).then((rows)=>{
            if (!live) return;
            const m = new Map();
            for (const r of rows){
                m.set(r.id, r);
                if (r.matchedName) m.set(r.matchedName, r);
            }
            setCatalogResolved(m);
        }).catch((err)=>console.error('order catalogue resolve failed:', err));
        return ()=>{
            live = false;
        };
    }, [
        resolveKey,
        pmEncounterId,
        visitId
    ]);
    // The picker's own query and type live in MobileVisitOrders, so the search goes
    // with them; the parent hands down the call, scoped to this visit's clinic.
    const searchCatalog = (0, $acw62.useCallback)(({ query: query, orderType: orderType })=>(0, $6xvbB.searchOrderCatalog)({
            query: query,
            orderType: orderType,
            appointmentId: pmEncounterId || visitId
        }), [
        pmEncounterId,
        visitId
    ]);
    // Load an already-saved treatment plan once the visit is known, so a resumed
    // visit shows «تأییدشده» on the «برنامه» section instead of offering to
    // generate a second plan. The SOAP note is the authority for the P text; the
    // stored plan note is only a fallback for a note that was lost.
    const planTabLoaded = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        const appointmentId = pmEncounterId || visitId;
        if (planTabLoaded.current || !appointmentId || !patient?.id) return;
        planTabLoaded.current = true;
        (0, $eVM84.bffQuery)((0, $6xvbB.GET_TREATMENT_PLAN), {
            appointmentId: appointmentId,
            patientId: patient.id
        }).then((data)=>{
            const plan = data?.treatmentPlan;
            if (!plan?.exists) return;
            setPlanStatus(plan.status || 'draft');
            if (plan.planNote) setSoap((s)=>(s.p || '').trim() ? s : {
                    ...s,
                    p: plan.planNote
                });
        }).catch((e)=>console.warn('treatmentPlan load failed:', e.message));
    }, [
        pmEncounterId,
        visitId,
        patient?.id
    ]);
    // ── Clinical insight pass ──────────────────────────────────────────────────
    // The one pass, callable from two places: the automatic effect below and the
    // «دریافت نکات بالینی» button in the copilot sheet. Only the response's
    // `clinicalRationale` reaches the feed — its test/medication halves are
    // orders, and they belong to «دستورات» and «نسخه». Failures are kept rather
    // than swallowed — a silently empty sheet is indistinguishable from "the AI
    // had nothing to say", which is the one thing it must never be confused with.
    const runRecommendations = (0, $acw62.useCallback)(()=>{
        if (!patient?.id) return;
        const conditions = (patient.clinicalConditions || []).map((c)=>c.code || c.display).filter(Boolean);
        setRecsError(null);
        setRecsLoading(true);
        return (0, $eVM84.bffQuery)((0, $6xvbB.RECOMMEND_TESTS), {
            input: {
                patientId: patient.id,
                icdCodes: conditions.slice(0, 5),
                age: (0, $6xvbB.aiPatientAge)(patient),
                gender: '',
                existingMedications: (patient.clinicalMedications || []).filter((m)=>m.status === 'active').map((m)=>m.display),
                existingTests: []
            }
        }).then((data)=>{
            setRecommendations(data.recommendTestsAndMedications);
            setRecsRan(true);
            chargeVisit((0, $1yr2B.costOf)('RECOMMENDATIONS'), 'recs');
        }).catch((err)=>{
            console.error('[recommendations]', err);
            setRecsError(err?.message || t('errors.ai.suggestionsFailed'));
        }).finally(()=>setRecsLoading(false));
    }, [
        patient,
        chargeVisit,
        t
    ]);
    // Auto-fire it when the patient loads — but only if the doctor has left the
    // automation on. `suggestionsAutoRun` is in the deps on purpose: turning the
    // setting on mid-visit must start the pass, not wait for a remount.
    (0, $acw62.useEffect)(()=>{
        // Nothing is decided while the settings are still loading — otherwise the
        // default-on fallback fires the pass and latches recsAutoFired before the
        // doctor's actual choice is known.
        if (aiSettingsUnknown) return;
        if (!patient?.id || recsAutoFired.current) return;
        if (!suggestionsAutoRun) return;
        recsAutoFired.current = true;
        runRecommendations();
    }, [
        patient,
        aiSettingsUnknown,
        suggestionsAutoRun,
        runRecommendations
    ]);
    // ── Drug management ────────────────────────────────────────────────────────
    // None of these touch the SOAP «P» text. They used to: addDrug appended a line
    // to «P» from inside the setRxItems updater — an impure updater, and a one-way
    // append that no later edit or delete could take back. The plan block is
    // derived from rxItems instead (see the reconciler below).
    // «داروهای پرتکرار من» on the phone (PM-0516): read once, when the نسخه tab is
    // first opened — the picker's one-click list and the add form's starting sig,
    // as on the desktop. A drug added in THIS visit joins the list at once.
    const [frequentDrugs, setFrequentDrugs] = (0, $acw62.useState)([]);
    const frequentDrugsFetched = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        if (mobileTab !== 'rx' || frequentDrugsFetched.current) return;
        frequentDrugsFetched.current = true;
        (0, $6xvbB.fetchFrequentDrugs)(30).then(setFrequentDrugs).catch((err)=>console.error('[rx] myFrequentDrugs failed:', err));
    }, [
        mobileTab
    ]);
    const rxLists = (0, $acw62.useMemo)(()=>({
            routes: (0, $6xvbB.RX_ROUTES)(),
            durations: (0, $6xvbB.DURATIONS)(t)
        }), [
        t
    ]);
    // The doctor's last directions by product — the frequent list, `myLastDrugSigs`
    // for whatever the picker offers, a line added in this visit; the newest wins
    // (PM-0574, useRxMemory), as on the desktop.
    const rxMemory = (0, $5VYuu.useRxMemory)({
        frequentDrugs: frequentDrugs,
        lists: rxLists,
        defaultDuration: t('visit.duration.d7')
    });
    const { usualRx: usualRx, rxDefaultsFor: rxDefaultsFor, remember: rememberRx } = rxMemory;
    // A drug reaches the نسخه through the add form (RxDrugSearch → RxAddForm), which
    // hands over the sig the doctor confirmed: every required field on its closed
    // list (PM-0059) — or, for a frequent drug, the sig saved the first time, by one
    // tap on its row (PM-0516). The line's shape is newRxLine's, as on the desktop,
    // and so is its persistence (useVisitRxPersistence) — one door for both.
    const addDrug = (0, $acw62.useCallback)((drug, sig)=>{
        setRxItems((prev)=>{
            if (prev.find((r)=>r.drug.id === drug.id)) return prev;
            return [
                ...prev,
                (0, $eQiuG.newRxLine)(drug, sig || {
                    route: (0, $eQiuG.autoRouteFor)(drug)
                }, prev.length, {
                    durations: (0, $6xvbB.DURATIONS)(t)
                })
            ];
        });
        // Saved once: from now on, this visit included, the drug is one tap (PM-0516),
        // and these are its latest directions (PM-0574).
        setFrequentDrugs((prev)=>(0, $eQiuG.withFrequentDrug)(prev, drug, sig));
        rememberRx(drug, sig);
    }, [
        t,
        rememberRx
    ]);
    const frequentRx = (0, $acw62.useMemo)(()=>(0, $eQiuG.frequentRxEntries)(frequentDrugs, usualRx), [
        frequentDrugs,
        usualRx
    ]);
    // Null when the doctor hid «داروهای پرتکرار من» (PM-0631) — as on the desktop.
    const showFrequentRx = (0, $aoLHg.isWorkPartVisible)(visitLayout, 'rx.frequent');
    const rxFrequent = (0, $acw62.useMemo)(()=>showFrequentRx ? {
            entries: frequentRx,
            onAddUsual: addDrug
        } : null, [
        showFrequentRx,
        frequentRx,
        addDrug
    ]);
    // «افزودن به نسخه ویزیت» from a document review (§23.3 A13). It opens a prefilled
    // draft on the نسخه tab — the record sheet steps aside so the tab is what is
    // behind the review — and the line is added only by the draft's own «افزودن به نسخه».
    const offerDocumentRx = (0, $acw62.useCallback)((draft)=>{
        if ((0, $8qEaX.isAlreadyPrescribed)(rxItems, draft.drug)) return 'alreadyPrescribed';
        setDocRxDrafts((prev)=>prev.some((d)=>d.drug.id === draft.drug.id) ? prev : [
                ...prev,
                draft
            ]);
        setMobileSheet(null);
        setMobileTab('rx');
        return 'prefilled';
    }, [
        rxItems
    ]);
    docRxCapability.current = offerDocumentRx;
    // `chosen` — the product the form ended on: the doctor may have changed its
    // شکل or قدرت there, and the line is that product, not the one offered.
    const confirmDocRxDraft = (0, $acw62.useCallback)((draft, values, chosen)=>{
        const uniq = (v, list)=>[
                ...new Set([
                    v,
                    ...list || []
                ].filter(Boolean))
            ];
        const drug = chosen?.id ? chosen : draft.drug;
        setRxItems((prev)=>(0, $8qEaX.isAlreadyPrescribed)(prev, drug) ? prev : [
                ...prev,
                {
                    id: Date.now(),
                    // The row's selects offer the drug's common values; the confirmed sig is one.
                    drug: {
                        ...drug,
                        commonDosages: uniq(values.dosage, drug.commonDosages),
                        commonFrequencies: uniq(values.frequency, drug.commonFrequencies)
                    },
                    dosage: values.dosage || '',
                    frequency: values.frequency || '',
                    route: values.route || '',
                    duration: values.duration || '',
                    quantity: values.quantity || '',
                    instructions: values.instructions || ''
                }
            ]);
        setFrequentDrugs((prev)=>(0, $eQiuG.withFrequentDrug)(prev, drug, values)); // saved once (PM-0516)
        rememberRx(drug, values); // the latest (PM-0574)
        setDocRxDrafts((prev)=>prev.filter((d)=>d.key !== draft.key));
    }, [
        rememberRx
    ]);
    const discardDocRxDraft = (0, $acw62.useCallback)((draft)=>{
        setDocRxDrafts((prev)=>prev.filter((d)=>d.key !== draft.key));
    }, []);
    // ── تجویز مجدد — refill from the record sheet or a past visit ──────────────
    // One entry point for both refill doors (a current medication, and a drug
    // prescribed in a previous visit), exactly as on desktop. The previous dosing
    // rides along as the new row's defaults so the doctor lands on an editable
    // نسخه row instead of re-typing the drug. The product is the one the line was
    // written from, looked up by its id (refillDrugFor) — matched by name, it was
    // another strength or product (K1, 2026-10-03); only a line with no id is
    // matched by name.
    const represcribeMed = (0, $acw62.useCallback)(async (med)=>{
        const src = (0, $85jFj.refillSourceFromMedication)(med);
        if (!src) return;
        const nameKey = src.name.toLowerCase();
        const drug = await (0, $6xvbB.refillDrugFor)(src);
        let added = false;
        setRxItems((prev)=>{
            if (prev.some((r)=>r.drug.id === drug.id || (r.drug.name || '').trim().toLowerCase() === nameKey)) return prev;
            added = true;
            return [
                ...prev,
                (0, $eQiuG.withAutoQuantity)({
                    id: Date.now(),
                    drug: drug,
                    dosage: src.dosage || (0, $eQiuG.defaultDoseFor)(drug),
                    frequency: src.frequency || (0, $eQiuG.defaultFrequencyFor)(drug),
                    // A route stored under an older translated label («Oral») is written
                    // again as the route's value — the one the insurer codes.
                    route: (0, $eQiuG.toRouteOption)(src.route) || src.route,
                    duration: src.duration || '',
                    quantity: src.quantity,
                    instructions: src.instructions
                }, {
                    durations: (0, $6xvbB.DURATIONS)(t)
                })
            ];
        });
        // The phone cannot show the نسخه tab behind an open sheet, and yanking the
        // doctor out of the record mid-review is worse than a line they can find:
        // the row flips to «در نسخه» and the toast offers the trip.
        if (added) {
            toast.success(t('visit.rx.represcribedToast', {
                name: src.name
            }));
            setRxInteractions(null);
            setIxError(null);
        }
    }, [
        toast,
        t
    ]);
    // Refill sources are keyed by NAME, not id: a record row and a formulary entry
    // never share ids, and the same drug must read «در نسخه» through either door.
    const prescribedMedNames = (0, $acw62.useMemo)(()=>new Set(rxItems.map((r)=>(r.drug?.name || '').trim().toLowerCase()).filter(Boolean)), [
        rxItems
    ]);
    // ── Past-visit detail ──────────────────────────────────────────────────────
    // Fetched when a «مراجعات اخیر» row is expanded, cached per encounter. The
    // ref de-dupes in-flight requests; the state carries the row's own three
    // states so one failed visit does not blank the others.
    const loadVisitContext = (0, $acw62.useCallback)(async (encId)=>{
        if (!encId) return;
        if (visitCtxRequested.current.has(encId) && visitContexts[encId]?.state !== 'error') return;
        visitCtxRequested.current.add(encId);
        setVisitContexts((prev)=>({
                ...prev,
                [encId]: {
                    state: 'loading'
                }
            }));
        try {
            const data = await (0, $eVM84.bffQuery)((0, $6xvbB.GET_ENCOUNTER_CONTEXT), {
                appointmentId: encId
            });
            setVisitContexts((prev)=>({
                    ...prev,
                    [encId]: {
                        state: 'ready',
                        data: data?.getEncounterContext || {}
                    }
                }));
        } catch  {
            visitCtxRequested.current.delete(encId);
            setVisitContexts((prev)=>({
                    ...prev,
                    [encId]: {
                        state: 'error'
                    }
                }));
        }
    }, [
        visitContexts
    ]);
    // «نوع تشخیص» on a chart condition — the only edit path for a diagnosis typed
    // into SOAP «A», which is never promoted from a differential.
    const changeCondType = (0, $acw62.useCallback)(async (cond, verificationStatus)=>{
        if (!cond?.id) return;
        setDxTypeBusyId(cond.id);
        try {
            await (0, $eVM84.bffMutation)((0, $6xvbB.UPDATE_CONDITION), {
                id: cond.id,
                input: {
                    verificationStatus: verificationStatus
                }
            });
            refreshPatient();
        } catch (e) {
            console.warn('[dx] retype failed:', e.message);
        } finally{
            setDxTypeBusyId(null);
        }
    }, [
        refreshPatient
    ]);
    // Rows that already exist server-side — everything a template put here, and
    // everything read back when this visit was reopened — are edited and deleted
    // through the record, not only in local state. Shared with the desktop
    // surface so the two cannot disagree about when a نسخه line becomes a record.
    const rxPersistence = (0, $U8Lvw.useVisitRxPersistence)({
        appointmentId: pmEncounterId || visitId,
        patientId: patient?.id,
        setRxItems: setRxItems,
        rxItems: rxItems
    });
    // ── «ارسال به بیمه» while the visit is open (PM-0097) ─────────────────────
    // The phone had the e-prescription card in the closure flow only: a doctor
    // could not send, or see that a registered نسخه had changed, before «پایان
    // ویزیت». The chip in the pinned strip carries the status on every tab and
    // opens the desktop panel's card in a sheet. Same rules as the desktop: never
    // in a clinic outside Iran, never while the visit is being closed, and the
    // status is read behind the نسخه's queued saves — the server reads the record.
    const iranianRails = (0, $e317r.useIranianRails)();
    const [erxSheetOpen, setErxSheetOpen] = (0, $acw62.useState)(false);
    const [erxBusy, setErxBusy] = (0, $acw62.useState)(false);
    const [erxLeaveOpen, setErxLeaveOpen] = (0, $acw62.useState)(false);
    const erxAvailable = iranianRails && !!patient?.id && !!(pmEncounterId || visitId) && !endingVisit && !showClosureFlow;
    const { status: erxStatus, reload: reloadErxStatus } = (0, $7ZSin.useErxStatus)({
        appointmentId: pmEncounterId || visitId,
        patientId: patient?.id,
        prepare: rxPersistence.flush,
        active: erxAvailable
    });
    // Read again once an edit to the نسخه or the دستورات has settled — the chip's
    // status, and the open card through its refreshKey.
    const erxContent = (0, $acw62.useMemo)(()=>JSON.stringify([
            rxItems.map((r)=>[
                    r.id,
                    r.medicationId || null,
                    r.dosage,
                    r.frequency,
                    r.route,
                    r.duration,
                    r.quantity
                ]),
            // An order's «تاریخ انجام» decides which prescription it goes in (PM-0634).
            clinicalOrders.map((o)=>[
                    o.id,
                    o.status,
                    o.performedDate || null
                ])
        ]), [
        rxItems,
        clinicalOrders
    ]);
    const [erxRefreshKey, setErxRefreshKey] = (0, $acw62.useState)(erxContent);
    const erxReadFor = (0, $acw62.useRef)(erxContent);
    (0, $acw62.useEffect)(()=>{
        if (!erxAvailable || erxReadFor.current === erxContent) return undefined;
        const h = setTimeout(()=>{
            erxReadFor.current = erxContent;
            setErxRefreshKey(erxContent);
            reloadErxStatus();
        }, 900);
        return ()=>clearTimeout(h);
    }, [
        erxContent,
        erxAvailable,
        reloadErxStatus
    ]);
    // Where each saved order stands with the insurer — a registered one keeps its date.
    const erxIndex = (0, $acw62.useMemo)(()=>(0, $3O5pt.indexErxStatus)(erxStatus), [
        erxStatus
    ]);
    const erxChip = (0, $acw62.useMemo)(()=>(0, $3O5pt.erxChipState)(erxStatus, {
            incomplete: rxItems.filter((r)=>(0, $eQiuG.missingRxFields)(r).length > 0).length,
            empty: rxItems.length === 0 && clinicalOrders.length === 0
        }), [
        erxStatus,
        rxItems,
        clinicalOrders
    ]);
    // A login waiting for its code, or a send in flight, is unsaved work: the
    // sheet asks before it closes over one.
    const closeErxSheet = (0, $acw62.useCallback)(()=>{
        if (erxBusy) {
            setErxLeaveOpen(true);
            return;
        }
        setErxSheetOpen(false);
    }, [
        erxBusy
    ]);
    const updateDrug = (0, $acw62.useCallback)((id, key, val)=>{
        // applyRxEdit: a دوز/تناوب/مدت change carries a worked-out quantity along.
        // An edit to a line whose removal failed keeps it: the «حذف نشد» mark goes.
        // Any two of مقدار تحویلی / تناوب / مدت settle an empty third (applyRxEdit).
        setRxItems((prev)=>prev.map((r)=>r.id === id ? {
                    ...(0, $eQiuG.applyRxEdit)(r, key, val, {
                        durations: (0, $6xvbB.DURATIONS)(t)
                    }),
                    removeFailed: undefined
                } : r));
        rxPersistence.scheduleSave(id);
    }, [
        rxPersistence,
        t
    ]);
    const removeDrug = (0, $acw62.useCallback)((id)=>{
        // Delete FIRST: the hook reads the row out of the list it last saw.
        rxPersistence.deleteRow(id);
        setRxItems((prev)=>prev.filter((r)=>r.id !== id));
        // A result naming a drug that is no longer on the list is worse than no
        // result, so a removal clears it outright rather than marking it stale.
        setRxInteractions(null);
        setIxError(null);
    }, [
        rxPersistence
    ]);
    // ── Applying a template ─────────────────────────────────────────────────────
    // The server has already created the rows; these only show them. Same rail as
    // the desktop surface — the items arrive as ordinary نسخه/دستورات rows.
    const handleMedicationTemplateApplied = (0, $acw62.useCallback)((result, outcome)=>{
        setRxItems((prev)=>(0, $85jFj.mergeRxItems)(prev, (result?.medications || []).map((0, $85jFj.rxItemFromMedication))));
        if (outcome.applied) {
            setRxInteractions(null);
            setIxError(null);
        }
        const message = (0, $cvBw3.applyMessage)('medication', result, outcome, t, formatList);
        if (outcome.kind === 'partial') toast.error(message);
        else toast.success(message);
    }, [
        t,
        formatList,
        toast
    ]);
    const handleOrderTemplateApplied = (0, $acw62.useCallback)((result, outcome)=>{
        const orders = result?.orders || [];
        setClinicalOrders((prev)=>(0, $85jFj.mergeOrders)(prev, orders));
        setPendingTests((prev)=>{
            const have = new Set(prev.map((x)=>x.name));
            const fresh = orders.filter((o)=>[
                    'lab',
                    'imaging',
                    'procedure'
                ].includes(o.orderType) && !have.has(o.description)).map((o)=>({
                    id: `${o.id}`,
                    name: o.description,
                    type: o.orderType,
                    urgency: o.urgency || 'routine',
                    reason: o.notes || '',
                    loincCode: o.code || '',
                    savedToBackend: true
                }));
            return fresh.length ? [
                ...prev,
                ...fresh
            ] : prev;
        });
        const message = (0, $cvBw3.applyMessage)('order', result, outcome, t, formatList);
        if (outcome.kind === 'partial') toast.error(message);
        else toast.success(message);
    }, [
        t,
        formatList,
        toast
    ]);
    // Only diagnoses the doctor has ACCEPTED reach the rule engine, so a reshuffle
    // of the suggestions below them does not change the clinical picture a check
    // was run against.
    const acceptedDiagnoses = (0, $acw62.useMemo)(()=>(differential || []).filter((0, $6xvbB.isDifferentialAccepted)).map((d)=>d.description), [
        differential
    ]);
    const acceptedDiagnosesKey = acceptedDiagnoses.join(' ');
    // Doctor-requested only — mirrors the desktop. The former 800ms auto-sweep
    // interrupted the doctor mid-prescription; the sole check that still runs
    // unasked is the high-severity sweep in handleEnd.
    const rxSignature = (0, $acw62.useMemo)(()=>(0, $6xvbB.rxCheckSignature)(rxItems, acceptedDiagnosesKey), [
        rxItems,
        acceptedDiagnosesKey
    ]);
    const ixStale = !!rxInteractions && rxInteractions.signature !== rxSignature;
    // Two drugs, or one with an allergy or a condition to read it against
    // (Visit.shared canRunInteractionCheck — the same rule on both surfaces).
    const interactionCheckReady = (0, $6xvbB.canRunInteractionCheck)(rxItems, patient, acceptedDiagnoses);
    const canCheckInteractions = interactionCheckReady && !interactionLoading;
    const runInteractionCheck = (0, $acw62.useCallback)(async ()=>{
        if (!(0, $6xvbB.canRunInteractionCheck)(rxItems, patient, acceptedDiagnoses) || interactionLoading) return;
        setIxLoading(true);
        setIxError(null);
        try {
            const { conditions: conditions, allergies: allergies } = (0, $6xvbB.interactionContext)(patient, acceptedDiagnoses);
            const result = await (0, $eVM84.bffQuery)((0, $6xvbB.CHECK_DRUG_INTERACTION), {
                // Names, not formulary ids — see interactionDrugName.
                medicationIds: (0, $g6gAc.interactionDrugNames)(rxItems),
                patientId: patient.id,
                patientConditions: conditions,
                patientAllergies: allergies
            });
            // Ours is the only answer. An empty result used to fall back to NLM RxNav's
            // interaction API from the browser — shut down in January 2024, so it
            // could never add a finding; it only added latency and sent the drug
            // names to a third party.
            const warnings = result.checkDrugInteraction?.warnings || [];
            setRxInteractions({
                hasInteractions: warnings.length > 0,
                warnings: warnings,
                signature: rxSignature
            });
            // The service debits every check, so the visit's own tally records it —
            // as the desktop and the end-of-visit sweep already did. Without it the
            // phone's «پارسه» figure ran one check short for every press.
            chargeVisit((0, $1yr2B.costOf)('INTERACTION_CHECK'), 'interaction');
        } catch (e) {
            setIxError(e?.message || t('errors.load.interactions'));
        } finally{
            setIxLoading(false);
        }
    }, [
        patient,
        rxItems,
        acceptedDiagnoses,
        interactionLoading,
        rxSignature,
        chargeVisit,
        t
    ]);
    // ── AI Assist ──────────────────────────────────────────────────────────────
    // Grounds the prescription assist in the full clinical picture of the current
    // visit: recorded conditions + accepted differentials + lab-inferred conditions
    // + the SOAP subjective/assessment + the working diagnosis, plus allergies.
    const buildAssistPrescriptionInput = ()=>{
        const recordedConditions = (patient.clinicalConditions || []).map((c)=>c.display).filter(Boolean);
        const diffConditions = (differential || []).filter((0, $6xvbB.isDifferentialAccepted)).map((d)=>d.description);
        const labConditions = (0, $6xvbB.inferConditionsFromObservations)(patient.clinicalObservations);
        const soapConditions = [
            soap.s,
            soap.a
        ].filter(Boolean);
        const allergies = (patient.clinicalAllergies || []).map((a)=>a.allergen).filter(Boolean);
        return {
            visitId: visitId || '',
            patientId: patient.id,
            // Checked by the same rule engine as the interaction check, so the same names.
            medications: (0, $g6gAc.interactionDrugNames)(rxItems),
            conditions: [
                ...recordedConditions,
                ...diffConditions,
                ...labConditions,
                ...soapConditions
            ],
            diagnosis: soap.a || diagnosis || '',
            age: (0, $6xvbB.aiPatientAge)(patient),
            gender: '',
            existingTests: [],
            patientAllergies: allergies
        };
    };
    const handleAssistPrescription = async ()=>{
        if (!patient?.id) return;
        setAiLoading(true);
        try {
            const data = await (0, $eVM84.bffMutation)((0, $6xvbB.ASSIST_PRESCRIPTION), {
                input: buildAssistPrescriptionInput()
            });
            setAiResult(data.assistPrescription);
            // The service debits for this exactly as it does for the نسخه tab's
            // button, so it goes on the visit ledger exactly as that one does. It used
            // to be the quietest spend on the page: unasked, and invisible everywhere
            // except the account panel.
            // `costOf`, not the constant. A Parseh price is a ROW served by the
            // active pricing policy (docs/AI_COST_AND_PARSEH_PRICING_MANAGEMENT_
            // DESIGN.md); the shipped constant in creditPricing.js is the OFFLINE FALLBACK the PriceBook uses
            // before its first load. Reading the constant here put a stale figure on
            // the visit ledger while the wallet was debited the real one — the same
            // call one panel over already did this correctly.
            chargeVisit((0, $1yr2B.costOf)('ASSIST_PRESCRIPTION'), 'rx');
        } catch (e) {
            // A spent wallet is the one failure the doctor has to be told about —
            // otherwise the panel simply never fills and nothing says why.
            if (e?.extensions?.code === 'INSUFFICIENT_CREDITS') setCreditError(e.message);
            else console.warn(e);
        } finally{
            setAiLoading(false);
        }
    };
    // ── The نسخه's AI helpers: dictation · «پایش بالینی» · شرح حال ──────────────
    // docs/VISIT_RX_AI_ASSIST.md — the same hook and review as the desktop. The
    // approved lines open the add form a searched drug opens, one after another,
    // prefilled with the proposal's sig (proposalFormRequests, K1 2026-10-05) — in
    // the queue a document review's drugs wait in. They used to become lines
    // directly and arrive «ناقص» where the model left a required field out. The old
    // one-tap «پیشنهاد دارو» list added the model's free-text name as a synthetic
    // `sugg-med-` drug and is gone.
    const rxHistoryCtx = {
        soap: soap,
        diagnoses: [
            ...acceptedDiagnoses,
            diagnosis
        ].filter(Boolean)
    };
    const rxAssist = (0, $5kzaL.useMedicationProposals)({
        getContext: ()=>({
                appointmentId: visitId || '',
                patient: patient,
                soap: soap,
                diagnoses: rxHistoryCtx.diagnoses,
                rxItems: rxItemsRef.current,
                transcript: liveTranscript
            }),
        chargeVisit: chargeVisit,
        chargeLabel: (source)=>t(`visit.rxAssist.charged.${source.toLowerCase()}`),
        onCreditError: setCreditError,
        // «تایید خودکار» (PM-0586), as on the desk: the voice's values, then the doctor's own
        // last directions (PM-0574), and only a line that needs no guess (autoRxSig).
        autoConfirm: autoConfirmOn,
        onAutoConfirm: async (source, rows)=>{
            await rxMemory.request(rows.map((r)=>r.proposal.autoDrug.id));
            const added = [];
            const records = [];
            rows.forEach((row)=>{
                const drug = row.proposal.autoDrug;
                if (rxItemsRef.current.some((r)=>r.drug?.id === drug.id)) return;
                const line = (0, $bwSot.autoRxSig)(row.proposal, drug, rxMemory.usualOf(drug.id), {
                    durations: rxLists.durations,
                    makeLine: (d, sig)=>(0, $eQiuG.newRxLine)(d, {
                            ...sig,
                            route: sig.route || (0, $eQiuG.autoRouteFor)(d)
                        }, 0, {
                            durations: (0, $6xvbB.DURATIONS)(t)
                        })
                });
                if (!line) return;
                const { dosage: dosage, frequency: frequency, route: route, duration: duration, quantity: quantity, instructions: instructions } = line;
                addDrug(drug, {
                    dosage: dosage,
                    frequency: frequency,
                    route: route,
                    duration: duration,
                    quantity: quantity,
                    instructions: instructions
                });
                added.push(row.key);
                records.push({
                    key: drug.id,
                    label: drug.name || (0, $g6gAc.drugDisplayName)(drug),
                    before: '',
                    after: (0, $bwSot.autoRxSummary)(line),
                    row: row,
                    source: source
                });
            });
            if (records.length) autoConfirm.add('rx', records);
            return added;
        },
        onApply: (lines, source)=>{
            const have = new Set(rxItemsRef.current.map((r)=>r.drug?.id));
            const requests = (0, $bwSot.proposalFormRequests)(lines.filter((l)=>!have.has(l.drug.id)), {
                source: source,
                durations: (0, $6xvbB.DURATIONS)(t),
                label: (n, total)=>total > 1 ? t('visit.rxAssist.formSourceN', {
                        n: formatNumber(n),
                        total: formatNumber(total)
                    }) : t('visit.rxAssist.formSource')
            });
            setDocRxDrafts((prev)=>[
                    ...prev,
                    ...requests.filter((r)=>!prev.some((d)=>d.drug.id === r.drug.id))
                ]);
        }
    });
    // ── «تکمیل از پایش بالینی» beyond the note and the نسخه (PM-0029, PM-0038) ──
    // علائم حیاتی, دستورات and اطلاعات پرونده read from the same transcript, each
    // from the «تکمیل» button of its own section. Findings are proposals; what the
    // doctor ticks is written through the path a hand-entered value takes
    // (monitoringApply.js): vitals land in the vitals FORM for the doctor to «ثبت»,
    // orders join the order list, a follow-up becomes a line of «P».
    const monitoringExtract = (0, $fIKok.useMonitoringExtraction)({
        // The visit's orders and encounter id say what it already holds: a second
        // «تکمیل» shows those findings as already on the visit, never writes them again.
        getContext: ()=>({
                appointmentId: visitId || '',
                encounterId: pmEncounterId || visitId || '',
                patient: patient,
                transcript: liveTranscript,
                orders: clinicalOrdersRef.current,
                vitals: vitalsRef.current
            }),
        chargeVisit: chargeVisit,
        chargeLabel: (group)=>t(`visit.monitoringExtract.charged.${group}`),
        onCreditError: setCreditError,
        // A heard lab / imaging / procedure is matched to its catalogue entry with the
        // picker's own search, so it is saved with its code like a hand-picked one.
        searchCatalog: (0, $6xvbB.searchOrderCatalog),
        // «تایید خودکار»: the علائم حیاتی rows the form takes without overwriting
        // anything go where «تأیید» puts them — the form, for the doctor's «ثبت».
        autoConfirm: autoConfirmOn,
        onAutoConfirm: async (group, rows)=>{
            // PM-0586: each marked order created as its catalogue row, as «تأیید» creates one.
            if (group === 'ORDERS') {
                const made = [];
                const records = [];
                for (const row of rows){
                    const res = await (0, $l7onJ.applyMonitoringFindings)({
                        picked: {
                            vitals: [],
                            orders: [
                                row.finding
                            ],
                            record: []
                        },
                        patientId: patient.id,
                        appointmentId: pmEncounterId || visitId,
                        t: t
                    });
                    if (res.creditError) setCreditError(res.creditError);
                    const o = res.orders[0];
                    if (!o?.created?.id) continue;
                    setClinicalOrders((prev)=>[
                            o.created,
                            ...prev
                        ]);
                    if ([
                        'lab',
                        'imaging',
                        'procedure'
                    ].includes(o.item.orderType)) setPendingTests((prev)=>[
                            ...prev,
                            {
                                id: `${Date.now()}-${o.item.name}`,
                                name: o.item.name,
                                type: o.item.orderType,
                                urgency: o.item.urgency,
                                reason: o.item.reason,
                                loincCode: o.item.loincCode || o.item.code || '',
                                savedToBackend: true
                            }
                        ]);
                    made.push(row.key);
                    records.push({
                        key: o.created.id,
                        label: o.item.name,
                        before: '',
                        after: o.created.description || o.item.name,
                        row: row
                    });
                }
                if (records.length) autoConfirm.add('order', records);
                return made;
            }
            const filled = (0, $b4nOl.vitalsFormPatch)(rows.map((r)=>r.finding));
            setVitals((prev)=>({
                    ...prev,
                    ...filled
                }));
            setVitalsMode('form');
            autoConfirm.add('vitals', rows.map((row)=>({
                    key: row.finding.kind,
                    before: '',
                    after: (0, $b4nOl.vitalsFormValue)(filled, row.finding.kind),
                    row: row
                })));
        },
        onApply: async (picked)=>{
            const res = await (0, $l7onJ.applyMonitoringFindings)({
                picked: picked,
                patientId: patient.id,
                appointmentId: pmEncounterId || visitId,
                t: t
            });
            if (res.creditError) setCreditError(res.creditError);
            if (Object.keys(res.vitalsPatch).length) {
                setVitals((prev)=>({
                        ...prev,
                        ...res.vitalsPatch
                    }));
                setVitalsMode('form');
            }
            if (res.orders.length) {
                setClinicalOrders((prev)=>[
                        ...res.orders.map((o)=>o.created),
                        ...prev
                    ]);
                setPendingTests((prev)=>[
                        ...prev,
                        ...res.orders.filter((o)=>[
                                'lab',
                                'imaging',
                                'procedure'
                            ].includes(o.item.orderType)).map((o)=>({
                                id: `${Date.now()}-${o.item.name}`,
                                name: o.item.name,
                                type: o.item.orderType,
                                urgency: o.item.urgency,
                                reason: o.item.reason,
                                loincCode: o.item.loincCode || o.item.code || '',
                                savedToBackend: true
                            }))
                    ]);
            }
            if (res.followUps.length) applyRefinedSections({
                p: (0, $b4nOl.appendFollowUps)((0, $6xvbB.planNarrative)(soapRef.current?.p || ''), res.followUps)
            });
            if (res.saved) refreshPatient();
            // Nothing landed at all: keep the review open so the ticks are not lost.
            const landed = res.saved + res.followUps.length + Object.keys(res.vitalsPatch).length;
            if (!landed && res.failed) throw new Error('monitoring findings were not saved');
            if (res.failed) toast.error(t('visit.monitoringExtract.partlyApplied', {
                failed: res.failed
            }));
            else toast.success(t(Object.keys(res.vitalsPatch).length ? 'visit.monitoringExtract.appliedVitals' : 'visit.monitoringExtract.applied'));
        }
    });
    // ── «تکمیل» as one flow (PM-0038) ─────────────────────────────────────────
    // The same button in every section, the visit-wide one beside «پایش بالینی»,
    // and the guide that walks from one section's proposals to the next.
    const completion = (0, $icdDW.useVisitCompletion)({
        t: t,
        formatNumber: formatNumber,
        toast: toast,
        costOf: $1yr2B.costOf,
        soapRefine: soapRefine,
        rxAssist: rxAssist,
        monitoringExtract: monitoringExtract,
        disabled: !visitId || !patient?.id,
        recState: // «تکمیل خودکار پس از پایش بالینی»: never into a visit being closed.
        recState,
        autoRunOnStop: autoCompleteOn && visitStatus === 'inprogress' && !endingVisit && !showClosureFlow
    });
    // The stop control's own press — the one stop that may run «تکمیل» after it.
    const stopMonitoring = ()=>{
        completion.armAutoRun();
        stopRecCharged();
    };
    // Where a section lives on the phone: three of them are tabs, the vitals and
    // the record are the record sheet.
    const completeSectionShown = mobileSheet === 'vitals' ? 'vitals' : ({
        note: 'soap',
        rx: 'rx',
        ord: 'orders'
    })[mobileTab];
    const goCompleteSection = (id)=>{
        if (id === 'vitals' || id === 'record') {
            setMobileSheet('vitals');
            return;
        }
        setMobileSheet(null);
        pickMobileTab({
            soap: 'note',
            rx: 'rx',
            orders: 'ord'
        }[id]);
    };
    const findingsCard = (group)=>monitoringExtract.reviews[group].open ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4SCt2.default), {
            variant: "mobile",
            group: group,
            review: monitoringExtract.reviews[group],
            onToggle: (key)=>monitoringExtract.toggle(group, key),
            onSetAll: (checked)=>monitoringExtract.setAll(group, checked),
            onApply: ()=>monitoringExtract.apply(group),
            onClose: ()=>monitoringExtract.close(group),
            onRetry: ()=>monitoringExtract.run([
                    group
                ]),
            onCatalog: (key, choice)=>monitoringExtract.chooseCatalog(group, key, choice)
        }) : null;
    // Auto-fire prescription assist when SOAP assessment is filled.
    //
    // Gated by the «نکات بالینی» switch, because that is where this answer LANDS:
    // the interaction warnings and the follow-up line it returns are cards in that
    // feed, beside the ones the insight pass produces. It is also an automatic
    // spend — 3 پارسه for every DISTINCT assessment text, so refining «A» three
    // times pays three times — which is precisely what a doctor turning the
    // automation off is asking to stop. The «پیشنهاد دارو» button in the نسخه tab
    // is untouched: that one they asked for.
    (0, $acw62.useEffect)(()=>{
        if (!autoAssistOn) return;
        const assessment = soap.a?.trim();
        if (!assessment || !patient?.id) return;
        if (assistAutoFired.current === assessment) return;
        const timer = setTimeout(()=>{
            assistAutoFired.current = assessment;
            handleAssistPrescription();
        }, 2500);
        return ()=>clearTimeout(timer);
    }, [
        soap.a,
        patient?.id,
        autoAssistOn
    ]);
    // ── AI Chat ────────────────────────────────────────────────────────────────
    const handleAsk = async (q)=>{
        const question = q || aiInput;
        if (!question.trim()) return;
        setAiMessages((prev)=>[
                ...prev,
                {
                    role: 'user',
                    text: question
                }
            ]);
        setAiInput('');
        setAiChatLoading(true);
        try {
            const history = (0, $6xvbB.buildPatientHistory)(patient);
            const visitCtx = (0, $6xvbB.buildVisitContext)(soap, diagnosis, pendingTests);
            const conditionNames = (patient?.clinicalConditions || []).map((c)=>c.display).filter(Boolean);
            const [bffResult, citations] = await Promise.allSettled([
                (0, $eVM84.bffQuery)((0, $6xvbB.ASK_DOCTOR_QUESTION), {
                    visitId: visitId || '',
                    question: question,
                    transcriptionContext: visitCtx,
                    patientHistory: history,
                    patientId: patient?.id
                }),
                (0, $fOM5k.searchPubMed)(question, conditionNames)
            ]);
            if (bffResult.status === 'rejected') throw bffResult.reason;
            setAiMessages((prev)=>[
                    ...prev,
                    {
                        role: 'ai',
                        text: bffResult.value.askDoctorQuestion.answer,
                        confidence: bffResult.value.askDoctorQuestion.confidence,
                        suggestions: bffResult.value.askDoctorQuestion.followUpSuggestions,
                        citations: citations.status === 'fulfilled' ? citations.value : []
                    }
                ]);
        } catch (e) {
            if (e?.extensions?.code === 'INSUFFICIENT_CREDITS') setCreditError(e.message);
            setAiMessages((prev)=>[
                    ...prev,
                    {
                        role: 'ai',
                        text: t('errors.ai.responseFailed'),
                        suggestions: [],
                        citations: []
                    }
                ]);
        } finally{
            setAiChatLoading(false);
        }
    };
    // ── Confirmation questions ────────────────────────────────────────────────
    const handleLoadDiagAIQuestions = async (diag)=>{
        if (diagAILoading[diag.diagnosisCode]) return;
        setDiagAILoading((prev)=>({
                ...prev,
                [diag.diagnosisCode]: true
            }));
        try {
            const history = (0, $6xvbB.buildPatientHistory)(patient);
            const visitCtx = (0, $6xvbB.buildVisitContext)(soap, diagnosis, pendingTests);
            const result = await (0, $eVM84.bffQuery)((0, $6xvbB.GENERATE_CONFIRM_Q), {
                visitId: visitId,
                patientId: patient?.id,
                differentials: [
                    {
                        diagnosisCode: diag.diagnosisCode,
                        description: diag.description
                    }
                ],
                transcriptionContext: visitCtx,
                patientHistory: history
            });
            const items = result?.generateConfirmationQuestions?.items || [];
            const qs = items[0]?.questions || [];
            setDiagAIQuestions((prev)=>({
                    ...prev,
                    [diag.diagnosisCode]: qs
                }));
        } catch (e) {
            if (e?.extensions?.code === 'INSUFFICIENT_CREDITS') setCreditError(e.message);
        } finally{
            setDiagAILoading((prev)=>({
                    ...prev,
                    [diag.diagnosisCode]: false
                }));
        }
    };
    // One question, one commit — the desktop fork's flow, unchanged: picking
    // بله/خیر writes that finding into «S», saves the note, and only then closes
    // THAT question, collapsing it to the finding it recorded while the panel
    // stays open on the rest. Nothing is keyed to the first question, so every
    // question in the set behaves the same; a committed one is inert on re-click.
    const handleAnswerDiagQuestion = async (diag, q, value)=>{
        const code = diag.diagnosisCode;
        const key = `${code}:${q.id}`;
        if (diagQSubmitting[key]) return; // in flight
        if (diagAIAnswers[code]?.[q.id]?.answer) return; // already recorded
        setDiagQSubmitting((prev)=>({
                ...prev,
                [key]: value
            }));
        setDiagQError((prev)=>{
            const next = {
                ...prev
            };
            delete next[key];
            return next;
        });
        const updated = {
            ...soapRef.current,
            s: (0, $6xvbB.appendSubjectiveFinding)(soapRef.current.s, (0, $6xvbB.questionFinding)(q, value, t))
        };
        const saved = await handleSaveSoapNote(updated);
        setDiagQSubmitting((prev)=>{
            const next = {
                ...prev
            };
            delete next[key];
            return next;
        });
        if (!saved) {
            // «S» is left untouched, the answer unrecorded, and the panel open, so the
            // doctor can retry the same question rather than lose the finding.
            setDiagQError((prev)=>({
                    ...prev,
                    [key]: t('errors.save.answer')
                }));
            return;
        }
        soapRef.current = updated;
        setSoap(updated);
        // Recording the answer is what closes this question: the panel renders an
        // answered one as the single line it wrote, with no choices left to make.
        setDiagAIAnswers((prev)=>({
                ...prev,
                [code]: {
                    ...prev[code],
                    [q.id]: {
                        answer: value
                    }
                }
            }));
    };
    // Open/close a diagnosis's AI confirmation-question panel; fetch on first open.
    const toggleDiagAI = (d)=>{
        const next = openAIDiag === d.diagnosisCode ? null : d.diagnosisCode;
        setOpenAIDiag(next);
        if (next && !diagAIQuestions[d.diagnosisCode] && !diagAILoading[d.diagnosisCode]) handleLoadDiagAIQuestions(d);
    };
    const reloadDiagQuestions = (d)=>{
        // The findings already committed stay in «S» — this only drops the questions
        // they came from.
        setDiagAIQuestions((prev)=>({
                ...prev,
                [d.diagnosisCode]: []
            }));
        setDiagAIAnswers((prev)=>({
                ...prev,
                [d.diagnosisCode]: {}
            }));
        setDiagQError((prev)=>Object.fromEntries(Object.entries(prev).filter(([k])=>!k.startsWith(`${d.diagnosisCode}:`))));
        handleLoadDiagAIQuestions(d);
    };
    // ── Add suggested med/test from summary modal ─────────────────────────────
    // handleAddSuggestedMed is gone, as on the desktop: nothing called it, and it
    // wrote the drug as an uncoded prose record no insurer could be sent (K1,
    // 2026-10-03). Suggested drugs reach the نسخه as structured lines.
    const handleAddSuggestedTest = (idx)=>{
        setAddedSugTests((prev)=>new Set([
                ...prev,
                idx
            ]));
    };
    // ── Doctor Order Suggestions ───────────────────────────────────────────────
    const handleFetchOrderSuggestions = async ()=>{
        if (!patient?.id) return;
        setOrderSuggestionsLoading(true);
        setOrderSuggestions(null);
        setSelectedOrders(new Set());
        try {
            const icdCodes = (patient.clinicalConditions || []).map((c)=>c.code).filter(Boolean);
            const diagnoses = (patient.clinicalConditions || []).map((c)=>c.display).filter(Boolean);
            const existingTests = (patient.clinicalObservations || []).map((o)=>o.display).filter(Boolean);
            const data = await (0, $eVM84.bffQuery)((0, $6xvbB.SUGGEST_DOCTOR_ORDERS), {
                appointmentId: visitId || undefined,
                patientId: patient.id,
                icdCodes: icdCodes.slice(0, 8),
                diagnoses: diagnoses.slice(0, 8),
                age: (0, $6xvbB.aiPatientAge)(patient),
                gender: '',
                existingTests: existingTests.slice(0, 10)
            });
            setOrderSuggestions(data.suggestDoctorOrders);
        } catch (e) {
            if (e?.extensions?.code === 'INSUFFICIENT_CREDITS') setCreditError(e.message);
            else console.warn('suggestDoctorOrders failed:', e);
        } finally{
            setOrderSuggestionsLoading(false);
        }
    };
    const toggleOrder = (key)=>{
        setSelectedOrders((prev)=>{
            const next = new Set(prev);
            if (next.has(key)) next.delete(key);
            else next.add(key);
            return next;
        });
    };
    const handleSaveSelectedOrders = async ()=>{
        const unsavedManual = pendingTests.filter((test)=>!test.savedToBackend);
        if (!patient?.id || selectedOrders.size === 0 && unsavedManual.length === 0) return;
        setSavingOrders(true);
        const ordersToSave = [];
        // AI-suggested items the doctor checked
        if (orderSuggestions?.labTests) orderSuggestions.labTests.forEach((test)=>{
            if (selectedOrders.has(`lab:${test.testName}`)) ordersToSave.push({
                orderType: 'lab',
                name: test.testName,
                code: test.loincCode || '',
                description: test.reason || '',
                urgency: test.urgency || 'routine'
            });
        });
        if (orderSuggestions?.imagingStudies) orderSuggestions.imagingStudies.forEach((s)=>{
            if (selectedOrders.has(`imaging:${s.studyType}`)) ordersToSave.push({
                orderType: 'imaging',
                name: s.studyType,
                code: '',
                description: [
                    s.bodyPart,
                    s.reason
                ].filter(Boolean).join(" \u2014 "),
                urgency: s.urgency || 'routine'
            });
        });
        if (orderSuggestions?.procedureOrders) orderSuggestions.procedureOrders.forEach((p)=>{
            if (selectedOrders.has(`procedure:${p.name}`)) ordersToSave.push({
                orderType: 'procedure',
                name: p.name,
                code: p.code || '',
                description: p.reason || '',
                urgency: p.urgency || 'routine'
            });
        });
        // Manual orders added by the doctor that haven't been saved yet — with their
        // catalogue row and session count (visitOrders.doctorOrderInput).
        const firstManual = ordersToSave.length;
        unsavedManual.forEach((item)=>{
            ordersToSave.push((0, $5qIQm.doctorOrderInput)(item));
        });
        if (ordersToSave.length === 0) {
            setSavingOrders(false);
            return;
        }
        // One write per order (visitOrders.saveDoctorOrder). This marked EVERY
        // unsaved row saved on the batch's `success`, which the BFF reported even
        // when all of the orders failed — and the end-of-visit flush sends only
        // unsaved rows, so an order that never reached the record was never sent
        // again. Now only an order that landed is marked; the rest stay unsaved
        // (and their AI ticks stay on) for the next «ثبت» or the end of the visit.
        const savedAi = [];
        const savedManual = [];
        try {
            for(let n = 0; n < ordersToSave.length; n++){
                const o = ordersToSave[n];
                try {
                    await (0, $5qIQm.saveDoctorOrder)({
                        appointmentId: pmEncounterId || visitId || undefined,
                        patientId: patient.id
                    }, o);
                    if (n >= firstManual) savedManual.push(unsavedManual[n - firstManual]);
                    else savedAi.push(o);
                } catch (e) {
                    console.warn('saveDoctorOrders failed:', o.name, e?.message);
                }
            }
            const allSaved = savedAi.length + savedManual.length === ordersToSave.length;
            if (!allSaved) toast?.error?.(t('visit.orders.saveRetry'));
            if (savedAi.length + savedManual.length > 0) {
                setSavedOrdersCount((c)=>c + savedAi.length + savedManual.length);
                // Mark the manual rows that landed as saved and add the AI orders that
                // landed (lab, imaging, procedure) to pendingTests. A row is matched by
                // its id, so one edited while the save ran is still found.
                const landed = (test)=>savedManual.some((r)=>r === test || r.id != null && r.id === test.id);
                setPendingTests((prev)=>{
                    let updated = prev.map((test)=>!test.savedToBackend && landed(test) ? {
                            ...test,
                            savedToBackend: true
                        } : test);
                    savedAi.forEach((o)=>{
                        if (!updated.find((item)=>item.name === o.name)) updated = [
                            ...updated,
                            {
                                id: Date.now() + Math.random(),
                                name: o.name,
                                type: o.orderType,
                                reason: o.description,
                                urgency: o.urgency,
                                savedToBackend: true
                            }
                        ];
                    });
                    return updated;
                });
                // Selection keys are `${orderType}:${name}` (toggleOrder's callers).
                setSelectedOrders((prev)=>{
                    if (allSaved) return new Set();
                    const next = new Set(prev);
                    savedAi.forEach((o)=>next.delete(`${o.orderType}:${o.name}`));
                    return next;
                });
            }
        } finally{
            setSavingOrders(false);
        }
    };
    // ── Structured catalog orders ─────────────────────────────────────────────
    // The درخواست tab's structured picker hands back one or more pending entries
    // (carrying the catalog linkage: code / loincCode / sessionCount / catalogId). We keep the
    // mobile persistence model — orders live in pendingTests and are saved at
    // «پایان ویزیت» via SAVE_DOCTOR_ORDERS — and just enrich what goes in.
    const handleAddOrders = (entries)=>{
        if (!entries?.length) return;
        setPendingTests((prev)=>{
            let updated = [
                ...prev
            ];
            entries.forEach((e)=>{
                if (!updated.find((test)=>test.name === e.name && test.type === e.type)) updated = [
                    ...updated,
                    {
                        id: `${Date.now()}-${e.name}`,
                        name: e.name,
                        type: e.type,
                        urgency: e.urgency || 'routine',
                        reason: e.reason || '',
                        code: e.code || '',
                        loincCode: e.loincCode || e.code || '',
                        sessionCount: e.sessionCount || 1,
                        catalogId: e.catalogId || null,
                        savedToBackend: false,
                        // «تاریخ انجام» (PM-0634); none = today, written by the service.
                        performedDate: e.performedDate || null
                    }
                ];
            });
            return updated;
        });
    };
    // ── AI-assisted treatment plan (SOAP «برنامه» section) ─────────────────────
    const planKey = (type, name)=>`${type}:${name}`;
    const togglePlanItem = (key)=>{
        setSelectedPlanItems((prev)=>{
            const next = new Set(prev);
            if (next.has(key)) next.delete(key);
            else next.add(key);
            return next;
        });
    };
    const handleSuggestPlan = async ()=>{
        if (!patient?.id) return;
        setPlanLoading(true);
        setPlanError(null);
        try {
            const appointmentId = pmEncounterId || visitId || undefined;
            const reviewedDiffs = differential || [];
            const data = await (0, $eVM84.bffQuery)((0, $6xvbB.SUGGEST_TREATMENT_PLAN), {
                input: {
                    appointmentId: appointmentId,
                    patientId: patient.id,
                    diagnosis: soap.a || '',
                    icdCodes: (patient.clinicalConditions || []).filter((c)=>c.code).slice(0, 8).map((c)=>({
                            code: c.code,
                            description: c.display || ''
                        })),
                    age: (0, $6xvbB.aiPatientAge)(patient),
                    gender: patient.gender || '',
                    patientAllergies: (patient.clinicalAllergies || []).map((a)=>a.allergen).filter(Boolean),
                    existingMedications: rxItems.map((r)=>r.drug.name).filter(Boolean),
                    existingTests: (patient.clinicalObservations || []).map((o)=>o.display).filter(Boolean).slice(0, 10),
                    existingImaging: clinicalOrders.filter((o)=>o.orderType === 'imaging').map((o)=>o.description).filter(Boolean),
                    soapSubjective: soap.s || '',
                    soapObjective: soap.o || '',
                    soapAssessment: soap.a || '',
                    soapPlan: soap.p || '',
                    differentials: reviewedDiffs.map((d)=>({
                            diagnosisCode: d.diagnosisCode || '',
                            diagnosisName: d.description || '',
                            confidence: d.confidence || '',
                            status: d.status || 'active',
                            supportingEvidence: d.supportingEvidence || [],
                            contradictingEvidence: d.contradictingEvidence || []
                        }))
                }
            });
            const plan = data.suggestTreatmentPlan;
            if (!plan) return;
            setPlanSuggestion(plan);
            chargeVisit((0, $1yr2B.costOf)('TREATMENT_PLAN'), 'plan', t('visit.plan.ready'));
            // Preselect everything: the doctor reviews by unchecking, which is faster.
            const preselected = new Set([
                ...(plan.medications || []).map((m)=>planKey('med', m.name)),
                ...(plan.labTests || []).map((test)=>planKey('lab', test.testName)),
                ...(plan.imagingStudies || []).map((s)=>planKey('imaging', s.studyType)),
                ...(plan.procedureOrders || []).map((p)=>planKey('procedure', p.name))
            ]);
            setSelectedPlanItems(preselected);
            // The note IS the «P» section — write it there and autosave. It replaces
            // the NARRATIVE only: the managed drug/order block belongs to the
            // reconciler and is spliced back on, so generating never drops the list of
            // what is already prescribed.
            const note = (plan.planNote || '').trim();
            if (note) {
                const prevNarrative = (0, $6xvbB.planNarrative)(soap.p);
                setPlanReplacedP(prevNarrative && prevNarrative !== note ? prevNarrative : null);
                const nextP = (0, $6xvbB.splicePlanBlock)(note, planBlock);
                setSoap((s)=>({
                        ...s,
                        p: nextP
                    }));
                await handleSaveSoapNote({
                    ...soap,
                    p: nextP
                });
            }
        } catch (e) {
            if (e?.extensions?.code === 'INSUFFICIENT_CREDITS') setCreditError(e.message);
            else {
                console.warn('suggestTreatmentPlan failed:', e);
                setPlanError(e.message || t('errors.ai.treatmentPlan'));
            }
        } finally{
            setPlanLoading(false);
        }
    };
    // Open the panel and generate on first use; afterwards the button just toggles
    // the panel so the doctor is never charged twice by a stray tap. Opening on a
    // visit that is not in progress still shows the panel — it explains why the
    // generate button is disabled, which a dead AI button would not.
    const handleOpenPlanPanel = ()=>{
        if (planPanelOpen) {
            setPlanPanelOpen(false);
            return;
        }
        setPlanPanelOpen(true);
        if (!planSuggestion && !planLoading && patient?.id && visitStatus === 'inprogress') handleSuggestPlan();
    };
    // Undo a generation that overwrote the doctor's own «P» narrative. The managed
    // block rides along untouched — it describes what is prescribed, which the undo
    // has no business changing.
    const handleRestorePlanText = async ()=>{
        if (planReplacedP == null) return;
        const restored = (0, $6xvbB.splicePlanBlock)(planReplacedP, planBlock);
        setPlanReplacedP(null);
        setSoap((s)=>({
                ...s,
                p: restored
            }));
        await handleSaveSoapNote({
            ...soap,
            p: restored
        });
    };
    // Persist the checked items, then the note, then flip the plan to confirmed.
    const handleApplyPlan = async ()=>{
        const appointmentId = pmEncounterId || visitId;
        if (!patient?.id || !appointmentId || !planSuggestion) return;
        setPlanSaving(true);
        setPlanError(null);
        let planFresh = [];
        try {
            // 1) Medications → the نسخه, ONE structured line each, as on the desktop
            // (K1, 2026-10-03). The phone wrote each as a prose record — a name and
            // `{ text }`, which no insurer can be sent — and never put it on the نسخه.
            // Now: the drug-list product the name stands for (matchFormularyDrug), the
            // plan's sig held to the closed lists, one line, written to the record with
            // the rest of the نسخه (writeNow).
            const meds = (planSuggestion.medications || []).filter((m)=>selectedPlanItems.has(planKey('med', m.name)));
            const lists = {
                routes: (0, $6xvbB.RX_ROUTES)(),
                durations: (0, $6xvbB.DURATIONS)(t)
            };
            const matched = [];
            const unmatched = [];
            for (const m of meds){
                let drug = null;
                try {
                    drug = await (0, $6xvbB.matchFormularyDrug)(m.name);
                } catch (e) {
                    console.warn('plan: drug-list lookup failed:', e.message);
                }
                if (!drug) {
                    // No product the list settles: on the نسخه under the plan's name, and
                    // the doctor is told to choose the product.
                    unmatched.push(m.name);
                    drug = {
                        id: `plan-med-${m.name}`,
                        name: m.name,
                        genericName: '',
                        category: '',
                        commonDosages: [],
                        commonFrequencies: []
                    };
                }
                matched.push({
                    m: m,
                    drug: drug
                });
            }
            // What the plan leaves empty: the doctor's last directions for the product,
            // before the product's own defaults (PM-0574).
            await rxMemory.request(matched.filter((x)=>!String(x.drug.id).startsWith('plan-med-')).map((x)=>x.drug.id));
            const planLines = matched.map(({ m: m, drug: drug }, i)=>{
                const sig = (0, $eQiuG.fillFromMemory)((0, $eQiuG.closedListDefaults)(drug, {
                    dosage: m.dosage,
                    frequency: m.frequency,
                    duration: m.duration,
                    instructions: m.notes
                }, lists), rxMemory.usualOf(drug.id));
                return (0, $eQiuG.newRxLine)(drug, {
                    ...sig,
                    route: sig.route || (0, $eQiuG.autoRouteFor)(drug)
                }, i, {
                    durations: (0, $6xvbB.DURATIONS)(t)
                });
            });
            planFresh = planLines.filter((l, i)=>!(0, $8qEaX.isAlreadyPrescribed)(rxItemsRef.current, l.drug) && !planLines.slice(0, i).some((p)=>p.drug.id === l.drug.id));
            if (planFresh.length) {
                setRxItems((prev)=>[
                        ...prev,
                        ...planFresh
                    ]);
                await rxPersistence.writeNow(planFresh);
            }
            if (unmatched.length) toast.warn(t('visit.rx.planUnmatched', {
                names: formatList(unmatched)
            }));
            // 2) Lab / imaging / procedure → doctor orders, in one call.
            const orders = [];
            (planSuggestion.labTests || []).forEach((test)=>{
                if (selectedPlanItems.has(planKey('lab', test.testName))) orders.push({
                    orderType: 'lab',
                    name: test.testName,
                    code: test.loincCode || '',
                    description: test.reason || '',
                    urgency: test.urgency || 'routine'
                });
            });
            (planSuggestion.imagingStudies || []).forEach((s)=>{
                if (selectedPlanItems.has(planKey('imaging', s.studyType))) orders.push({
                    orderType: 'imaging',
                    name: s.studyType,
                    code: '',
                    description: [
                        s.bodyPart,
                        s.reason
                    ].filter(Boolean).join(" \u2014 "),
                    urgency: s.urgency || 'routine'
                });
            });
            (planSuggestion.procedureOrders || []).forEach((p)=>{
                if (selectedPlanItems.has(planKey('procedure', p.name))) orders.push({
                    orderType: 'procedure',
                    name: p.name,
                    code: p.code || '',
                    description: p.reason || '',
                    urgency: p.urgency || 'routine'
                });
            });
            // One write each (visitOrders.saveDoctorOrder), so the درخواست tab below
            // knows WHICH landed: this was one batch whose failure — or its
            // `success: false` — was swallowed, and every order was then listed as
            // saved regardless.
            const savedPlanOrders = new Set();
            for (const o of orders)try {
                await (0, $5qIQm.saveDoctorOrder)({
                    appointmentId: appointmentId,
                    patientId: patient.id
                }, o);
                savedPlanOrders.add(o);
            } catch (e) {
                console.warn('plan: saveDoctorOrders failed:', o.name, e.message);
            }
            // 3) The plan text is the SOAP «P» the doctor just reviewed — narrative
            // plus the managed block. Reconcile once more so the block reflects what
            // this confirm just created, drop any debounced write so it cannot land
            // after (and overwrite) this one, and save synchronously. `aiGenerated`
            // compares the NARRATIVE; the block is always machine-written.
            const rxForBlock = [
                ...rxItemsRef.current.filter((r)=>!planFresh.some((l)=>l.id === r.id)),
                ...planFresh
            ];
            const freshBlock = (0, $6xvbB.buildPlanBlock)({
                rxItems: rxForBlock,
                orders: clinicalOrdersRef.current,
                orderNameEn: orderNameEn
            });
            const planNote = (0, $6xvbB.splicePlanBlock)(soap.p, freshBlock).trim();
            if (planNote) {
                clearTimeout(planSaveTimer.current);
                const nextSoap = {
                    ...soap,
                    p: planNote
                };
                setSoap(nextSoap);
                await handleSaveSoapNote(nextSoap);
                await (0, $eVM84.bffMutation)((0, $6xvbB.SAVE_TREATMENT_PLAN_NOTE), {
                    appointmentId: appointmentId,
                    patientId: patient.id,
                    planNote: planNote,
                    aiGenerated: (0, $6xvbB.planNarrative)(planNote) === (planSuggestion.planNote || '').trim()
                });
            }
            const res = await (0, $eVM84.bffMutation)((0, $6xvbB.CONFIRM_TREATMENT_PLAN), {
                appointmentId: appointmentId
            });
            setPlanStatus(res.confirmTreatmentPlan?.status || 'confirmed');
            setPlanReplacedP(null);
            // Reflect the saved orders in the درخواست tab without a refetch. One whose
            // write did not land is listed UNSAVED, with its code, so the end-of-visit
            // flush sends it again instead of the tab claiming it is in the record.
            if (orders.length) setPendingTests((prev)=>{
                let updated = [
                    ...prev
                ];
                orders.forEach((o)=>{
                    if (!updated.find((test)=>test.name === o.name)) updated = [
                        ...updated,
                        {
                            id: `${Date.now()}-${o.name}`,
                            name: o.name,
                            type: o.orderType,
                            reason: o.description,
                            urgency: o.urgency,
                            code: o.code || '',
                            savedToBackend: savedPlanOrders.has(o)
                        }
                    ];
                });
                return updated;
            });
        } catch (e) {
            console.warn('plan: confirm failed:', e);
            setPlanError(e.message || t('errors.save.treatmentPlan'));
        } finally{
            setPlanSaving(false);
        }
    };
    // ── Mid-visit SOAP save ───────────────────────────────────────────────────
    // ── Vitals ────────────────────────────────────────────────────────────────
    const handleSaveVitals = async ()=>{
        if (!patient?.id) return;
        // ── Validation: plausible physiological ranges; reject nonsensical input ──
        const RANGES = {
            bpSys: {
                min: 40,
                max: 300,
                label: t('patient.vitals.systolic')
            },
            bpDia: {
                min: 20,
                max: 200,
                label: t('patient.vitals.diastolic')
            },
            pulse: {
                min: 20,
                max: 300,
                label: t('patient.vitals.hr')
            },
            spo2: {
                min: 50,
                max: 100,
                label: t('patient.vitals.spo2')
            },
            temp: {
                min: 30,
                max: 45,
                label: t('patient.vitals.bodyTemp')
            },
            weight: {
                min: 1,
                max: 500,
                label: t('patient.vitals.wt')
            }
        };
        const errors = [];
        for (const [key, r] of Object.entries(RANGES)){
            const raw = vitals[key];
            if (raw === '' || raw == null) continue;
            const n = Number(raw);
            if (!Number.isFinite(n)) {
                errors.push(t('visit.vitals.invalidNumber', {
                    label: r.label
                }));
                continue;
            }
            if (n < r.min || n > r.max) errors.push(t('visit.vitals.outOfRange', {
                label: r.label,
                min: r.min,
                max: r.max
            }));
        }
        // Cross-field: systolic must exceed diastolic when both are entered
        if (vitals.bpSys && vitals.bpDia && Number.isFinite(Number(vitals.bpSys)) && Number.isFinite(Number(vitals.bpDia)) && Number(vitals.bpSys) <= Number(vitals.bpDia)) errors.push(t('visit.vitals.bpOrder'));
        if (errors.length) {
            setVitalsError(errors);
            return;
        }
        const today = new Date().toISOString().split('T')[0];
        const entries = [
            vitals.bpSys && {
                code: '8480-6',
                display: t('patient.vitals.systolic'),
                value: vitals.bpSys,
                unit: 'mmHg'
            },
            vitals.bpDia && {
                code: '8462-4',
                display: t('patient.vitals.diastolic'),
                value: vitals.bpDia,
                unit: 'mmHg'
            },
            vitals.pulse && {
                code: '8867-4',
                display: t('patient.vitals.hr'),
                value: vitals.pulse,
                unit: 'bpm'
            },
            vitals.spo2 && {
                code: '59408-5',
                display: t('patient.vitals.spo2'),
                value: vitals.spo2,
                unit: '%'
            },
            vitals.temp && {
                code: '8310-5',
                display: t('patient.vitals.bodyTemp'),
                value: vitals.temp,
                unit: "\xb0C"
            },
            vitals.weight && {
                code: '29463-7',
                display: t('patient.vitals.wt'),
                value: vitals.weight,
                unit: 'kg'
            }
        ].filter(Boolean);
        if (!entries.length) {
            setVitalsError([
                t('validation.atLeastOneValue')
            ]);
            return;
        }
        setVitalsError(null);
        setVitalsLoading(true);
        try {
            // On edit: delete this encounter's existing vitals first to avoid duplicates
            if (savedVitalIds.current.length) {
                await Promise.allSettled(savedVitalIds.current.map((id)=>(0, $eVM84.bffMutation)((0, $6xvbB.DELETE_OBSERVATION), {
                        id: id
                    })));
                savedVitalIds.current = [];
            }
            const results = await Promise.all(entries.map((e)=>(0, $eVM84.bffMutation)((0, $6xvbB.ADD_OBSERVATION), {
                    patientId: patient.id,
                    input: {
                        code: e.code,
                        display: e.display,
                        value: e.value,
                        unit: e.unit,
                        status: 'NORMAL',
                        effectiveDate: today,
                        appointmentId: pmEncounterId || visitId || undefined
                    }
                })));
            // Store the new IDs so editing again can delete them
            savedVitalIds.current = results.map((r)=>r?.addObservation?.id).filter(Boolean);
            // What's on screen is now the encounter's record: no re-adoption on refetch.
            vitalsSeeded.current = String(pmEncounterId || visitId || '');
            setVitalsMode('saved');
            const spo2Limit = ai.spo2Threshold ?? 95;
            const bpLimit = ai.bpSystolicThreshold ?? 140;
            const alerts = [];
            if (vitals.spo2 && Number(vitals.spo2) < spo2Limit) alerts.push(t('visit.vitals.spo2Alert', {
                value: vitals.spo2,
                limit: spo2Limit
            }));
            if (vitals.bpSys && Number(vitals.bpSys) > bpLimit) alerts.push(t('visit.vitals.bpAlert', {
                value: vitals.bpSys,
                limit: bpLimit
            }));
            if (alerts.length) {
                const isCritical = vitals.spo2 && Number(vitals.spo2) < spo2Limit - 5 || vitals.bpSys && Number(vitals.bpSys) > bpLimit + 20;
                if (isCritical ? ai.interruptOnCritical !== false : ai.interruptOnWarning !== false) setVitalsAlert({
                    level: isCritical ? 'critical' : 'warning',
                    messages: alerts
                });
            }
            refreshPatient();
        } catch (e) {
            console.warn('saveVitals error:', e);
        } finally{
            setVitalsLoading(false);
        }
    };
    // ── Helpers ────────────────────────────────────────────────────────────────
    const patientConditions = (patient?.clinicalConditions || []).map((c)=>c.display);
    // Active diagnoses for the record sheet — same filter the desktop context
    // panel applies (active, minus the ones removed this session).
    const activeDiagnoses = (patient?.clinicalConditions || []).filter((c)=>c.clinicalStatus === 'active' && !removedCondIds.has(c.id));
    const rxText = rxItems.length > 0 ? rxItems.map((r)=>`\u{2022} ${(0, $g6gAc.drugDisplayName)(r.drug)}${r.dosage ? ' ' + r.dosage : ''}${r.frequency ? ' - ' + r.frequency : ''}${r.duration ? ' ' + t('visit.rx.forDuration', {
            duration: r.duration
        }) : ''}`).join('\n') : '';
    if (pError && !patient) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-content",
        "data-state": "error",
        style: {
            position: 'absolute',
            inset: 0,
            display: 'flex',
            flexDirection: 'column',
            background: (0, $jTCZr.C).bg
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            height: '7rem',
            background: (0, $jTCZr.GRADIENT_BRAND_DARK),
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '1rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dLdf9.default), {
        title: t('errors.load.patientRecord'),
        detail: pError?.message || String(pError),
        onRetry: refreshPatient
    })));
    // The phone's own shape — brand band, section pills, SOAP cards, CTA bar —
    // never a bare spinner (§2.4 / mobile §7).
    if (pLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fWbIA.VisitMobileSkeleton), null);
    const p = patient || routePatient;
    // ── Timer display ─────────────────────────────────────────────────────────
    const mm = String(Math.floor(elapsed / 60)).padStart(2, '0');
    const ss = String(elapsed % 60).padStart(2, '0');
    // ── «نکات بالینی» derived from live data ──────────────────────────────────
    // Insight only. Nothing orderable is built here — see Visit.shared.js for the
    // policy and filterClinicalInsights below for the backstop.
    const rawSuggestions = [];
    if (hints.length > 0) hints.forEach((h, i)=>{
        const text = typeof h === 'string' ? h : h.text || '';
        const hintType = typeof h === 'string' ? 'clinical_note' : h.hint_type || 'clinical_note';
        // A live hint that is really an order («CBC بده») is dropped rather than
        // shown: the doctor places tests in «دستورات» and drugs in «نسخه», and the
        // AI is prompted to reason instead of ordering.
        if (hintType === 'lab_test' || hintType === 'medication') return;
        const kind = t('visit.copilot.clinicalNote');
        // Skip if an existing card of the same kind already covers this hint
        // (Visit.shared `insightSimilarity`: Persian-folded words, not raw text).
        const isDup = rawSuggestions.some((s)=>s.kind === kind && (0, $6xvbB.insightSimilarity)(s.title, text) > (0, $6xvbB.INSIGHT_REPEAT_THRESHOLD));
        if (!isDup && text) rawSuggestions.push({
            id: `hint-${i}`,
            kind: kind,
            type: 'note',
            level: 'ok',
            conf: null,
            title: text,
            body: '',
            evidence: ''
        });
    });
    if (rxInteractions?.hasInteractions) rxInteractions.warnings.forEach((w, i)=>{
        const kindMap = {
            contraindication: t('visit.rx.contraindication'),
            allergy: t('visit.patient.allergyAlert'),
            black_box: 'Black Box FDA',
            interaction: t('visit.rx.interaction')
        };
        const kind = kindMap[w.warningType] || t('visit.rx.interaction');
        // A خفیف interaction is information: it joins the feed at note volume, so
        // only شدید/متوسط render as a warning card.
        const mild = (0, $6xvbB.normalizeSeverity)(w.severity) === 'low';
        rawSuggestions.push({
            id: `ix-${i}`,
            kind: kind,
            type: mild ? 'note' : 'safety',
            level: mild ? 'ok' : 'warn',
            conf: null,
            title: w.description,
            body: w.drug ? t('visit.interactions.drugLine', {
                drug: w.drug
            }) + (w.condition ? t('visit.interactions.conditionSuffix', {
                condition: w.condition
            }) : '') : '',
            evidence: w.drugPair || w.drug || '',
            _source: w.source || null
        });
    });
    // The insight pass answers with three things at once: recommended tests,
    // recommended medications, and the clinical rationale. Only the rationale is
    // read — the other two are orders, and they reach the doctor through
    // «دستورات» and «نسخه», which is where they can actually be placed.
    if (recommendations?.clinicalRationale) rawSuggestions.push({
        id: 'rationale',
        kind: t('visit.copilot.clinicalAnalysis'),
        type: 'rationale',
        level: 'ok',
        conf: null,
        title: t('visit.copilot.patientAssessment'),
        body: recommendations.clinicalRationale,
        evidence: ''
    });
    if (aiResult) {
        if (aiResult.hasInteractions && aiResult.interactionWarnings?.length) {
            // A warning naming a drug no longer on the نسخه is not shown — see the
            // desktop. Skipped by index so a dismissed `aiix-` card stays dismissed.
            const rxNames = (0, $g6gAc.interactionDrugNames)(rxItems);
            // «بررسی تداخل» runs the same rule engine over the same drugs; a finding
            // its card already shows is not shown a second time (interactionAlreadyShown).
            const checkedIx = rxInteractions?.hasInteractions ? rxInteractions.warnings : [];
            aiResult.interactionWarnings.forEach((w, i)=>{
                if (!(0, $g6gAc.warningOnRx)(w, rxNames)) return;
                if ((0, $6xvbB.interactionAlreadyShown)(w, checkedIx)) return;
                const kindMap = {
                    contraindication: t('visit.rx.contraindication'),
                    allergy: t('visit.patient.allergyAlert'),
                    black_box: 'Black Box FDA',
                    interaction: t('visit.rx.interaction')
                };
                const mild = (0, $6xvbB.normalizeSeverity)(w.severity) === 'low';
                rawSuggestions.push({
                    id: `aiix-${i}`,
                    kind: kindMap[w.warningType] || t('visit.rx.interaction'),
                    type: mild ? 'note' : 'safety',
                    level: mild ? 'ok' : 'warn',
                    conf: null,
                    title: w.description,
                    body: w.drug ? t('visit.interactions.drugLine', {
                        drug: w.drug
                    }) + (w.condition ? t('visit.interactions.conditionSuffix', {
                        condition: w.condition
                    }) : '') : '',
                    evidence: w.drugPair || w.drug || '',
                    _source: w.source || null
                });
            });
        }
        // `suggestedMedications` / `recommendedTests` from the same response are
        // deliberately not read here — they are the نسخه tab's AI panel and the
        // دستورات tab's suggest button respectively.
        if (aiResult.followUpTimeline) rawSuggestions.push({
            id: 'followup',
            kind: t('patient.encType.followUp'),
            type: 'followup',
            level: 'ok',
            conf: null,
            title: aiResult.followUpTimeline,
            body: '',
            evidence: ''
        });
    }
    // The backstop: no producer above builds an orderable card, and this makes
    // sure a new AI response field cannot reintroduce one. See Visit.shared.js.
    // Note completion no longer injects a card here — the note's own section
    // owns the completion flow (per-section previews in MobileVisitSoap).
    const copilotSuggestions = (0, $6xvbB.filterClinicalInsights)(rawSuggestions.filter((s)=>!dismissedSuggs.has(s.id)));
    // ── Transcript lines ───────────────────────────────────────────────────────
    const transcriptLines = liveTranscript ? liveTranscript.split('\n').filter(Boolean).map((l)=>{
        const isDr = l.startsWith(t('visit.print.doctorPrefix')) || l.startsWith('Doctor:');
        // i18n-exempt: speaker prefixes as the transcriber emits them, in both
        // languages it can produce. A matcher, not a label.
        return {
            role: isDr ? 'dr' : 'pt',
            spk: isDr ? t('visit.print.doctorTitle') : t('common.labels.patient'),
            text: l.replace(/^(دکتر:|Doctor:|بیمار:|Patient:)\s*/, '')
        };
    }) : [];
    const activeDiffs = (differential || []).filter((d)=>d.status !== 'rejected');
    const diffQuickQ = activeDiffs.length > 0 ? [
        ...activeDiffs.slice(0, 3).map((d)=>t('visit.copilot.confirmQuestion', {
                diagnosis: d.description
            })),
        t('visit.plan.prompt')
    ] : (0, $6xvbB.QUICK_Q)(t);
    const allergies = p?.allergies || p?.clinicalAllergies || [];
    // ── Composition-layer wiring (regular handlers, defined after the loading
    //    early-return; these lift the render's intents onto the logic above) ──
    const handleBack = ()=>{
        if (visitStatus === 'inprogress') {
            pendingNavRef.current = [
                '__back__'
            ];
            setLeaveConfirm(true);
        } else goBack();
    };
    const handleLeaveConfirm = ()=>{
        const pending = pendingNavRef.current;
        setLeaveConfirm(false);
        pendingNavRef.current = null;
        if (!pending) return;
        leaveVisit(()=>{
            if (pending.callback) {
                pending.callback();
                return;
            }
            if (Array.isArray(pending)) {
                if (pending[0] === '__back__') goBack();
                else navProp(...pending);
            }
        });
    };
    // Accepting takes the «نوع تشخیص» the doctor picked — same shared call the
    // desktop rail makes, so the two surfaces cannot ask for it differently.
    // `d` alone is never enough: without a type there is nothing to record.
    const handleDiffAccept = async (d, diagnosisType)=>{
        const isAccepted = (0, $6xvbB.isDifferentialAccepted)(d);
        setDiffTypeBusy(true);
        try {
            await (0, $6xvbB.trackDifferentialDecision)(diffDecisionSeqRef, ()=>(0, $6xvbB.confirmDifferentialType)({
                    bffMutation: $eVM84.bffMutation,
                    visitId: visitId,
                    diagnosisCode: d.diagnosisCode,
                    diagnosisType: diagnosisType,
                    isAccepted: isAccepted,
                    setDifferential: setDifferential
                }));
            setDiffTypePick(null);
            refreshPatient();
            if (!isAccepted) setSoapDiffConfirm({
                description: d.description,
                diagnosisCode: d.diagnosisCode
            });
        } catch  {}
        setDiffTypeBusy(false);
    };
    const handleDiffReject = async (d)=>{
        try {
            await (0, $6xvbB.trackDifferentialDecision)(diffDecisionSeqRef, async ()=>{
                const res = await (0, $eVM84.bffMutation)((0, $6xvbB.UPDATE_DIFFERENTIAL), {
                    appointmentId: visitId,
                    diagnosisCode: d.diagnosisCode,
                    action: 'reject'
                });
                setDifferential(res.updateDifferentialItem?.items || differential);
            });
        } catch  {}
    };
    const handleDiffConfirmToA = (yes)=>{
        if (yes && soapDiffConfirm) setSoap((prev)=>{
            const updated = {
                ...prev,
                a: [
                    prev.a,
                    soapDiffConfirm.description
                ].filter(Boolean).join('\n')
            };
            handleSaveSoapNote(updated);
            return updated;
        });
        setSoapDiffConfirm(null);
    };
    // Current active meds, de-duplicated by id then display, minus any stopped
    // this session — the record sheet's «داروهای جاری» list.
    const seenMedIds = new Set();
    const seenMedNames = new Set();
    const uniqMeds = (patient?.clinicalMedications || []).filter((m)=>{
        if (m.status !== 'active') return false;
        if (removedMedNames.has(medKey(m))) return false;
        if (seenMedIds.has(m.id)) return false;
        const nm = (m.display || '').trim().toLowerCase();
        if (nm && seenMedNames.has(nm)) return false;
        seenMedIds.add(m.id);
        if (nm) seenMedNames.add(nm);
        return true;
    });
    // One header action: everything that has no home on a phone's single CTA —
    // print, upload, and لغو ویزیت. The cancel deliberately does NOT sit beside
    // «پایان ویزیت» in the footer: adjacent terminal actions with opposite
    // meaning are an error trap. The record has its own labelled button beside
    // it, in the header's `action` slot (MobileVisitRecordButton, PM-0033).
    const headerActions = [
        {
            key: 'more',
            Icon: (0, $7VXKQ.default),
            label: t('common.actions.more'),
            onClick: ()=>setOverflowOpen(true)
        }
    ];
    // رویدادها — what used to be a three-line banner under the tabs («ویزیت
    // ناتمام بازیابی شد») and a strip above the header (low credit) is now the
    // bell in the header's top corner: announced once, then one 44px control.
    // The strips that remain are the ones the doctor must act on NOW.
    const visitEvents = [
        resumedVisit && visitStatus === 'inprogress' && {
            id: 'resumed',
            Icon: (0, $i5dmF.default),
            title: t('visit.resume.recovered'),
            body: t('visit.resume.recoveredBody')
        },
        !creditError && walletBalance !== null && (0, $jTCZr.creditLevel)(walletBalance) === 'low' && {
            id: 'lowCredit',
            tone: 'warn',
            Icon: (0, $QG9Z3.default),
            // The condition, not an occurrence: it stays listed while it holds.
            sticky: true,
            title: `${t('visit.header.lowCreditPrefix')}${(0, $3EzBq.fmtCoins)(walletBalance, formatNumber)} ${t('visit.header.lowCreditSuffix')}`,
            action: canBuyCredits ? {
                label: t('credits.topUp'),
                onClick: ()=>navProp('credits')
            } : undefined
        }
    ].filter(Boolean);
    const handleEventsSeen = (ids)=>{
        if (ids.includes('resumed')) setResumedVisit(false);
    };
    // The header row is the patient: the name is the title, and under it the
    // visit clock (while it runs) and the facts that tell two namesakes apart.
    const pad2 = (n)=>String(n).padStart(2, '0');
    const headerSubtitle = [
        visitStatus === 'inprogress' && formatDigits(`${pad2(Math.floor(elapsed / 60))}:${pad2(elapsed % 60)}`),
        ...(0, $1g70w.visitPatientFacts)(p, t, formatDigits)
    ].filter(Boolean).join(" \xb7 ") || undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", null, (0, $6xvbB.KF)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'absolute',
            inset: 0,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            background: (0, $jTCZr.C).bg
        }
    }, isRecPaused && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $682u6.default), {
        onResume: resumeRec,
        onDismiss: dismissPause
    }), creditError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-credit-error",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0.5rem 0.875rem',
            background: (0, $jTCZr.CT).dangerSoft,
            borderBottom: `1px solid ${(0, $jTCZr.C).redLight}`,
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            fontSize: '0.75rem',
            fontWeight: 600,
            color: (0, $jTCZr.CT).dangerInk
        }
    }, t('errors.kind.insufficientCredits.title'), walletBalance !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            opacity: 0.8
        }
    }, " \xb7 ", t('visit.header.balanceLabel'), " ", (0, $3EzBq.fmtCoins)(walletBalance, formatNumber), " ", t('common.units.coin'))), canBuyCredits && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "default",
        size: "sm",
        className: "shrink-0",
        "data-testid": "visit-credit-topup",
        onClick: ()=>navProp('credits')
    }, t('credits.buyCoins')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "icon",
        className: "h-9 w-9 shrink-0",
        "aria-label": t('common.actions.close'),
        onClick: ()=>setCreditError(null),
        style: {
            color: (0, $jTCZr.CT).dangerInk
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
        size: 16,
        "aria-hidden": true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minHeight: 0,
            overflowY: 'auto',
            WebkitOverflowScrolling: 'touch'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $64nJX.default), {
        compact: true,
        title: p?.name || t('patient.visit'),
        subtitle: headerSubtitle,
        onBack: handleBack,
        backLabel: t('common.actions.back'),
        leading: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $B8sWX.default), {
            events: visitEvents,
            onSeen: handleEventsSeen
        }),
        action: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1g70w.default), {
            patientName: p?.name,
            proposals: completion.pending.vitals + completion.pending.record,
            onOpen: ()=>setMobileSheet('vitals')
        }),
        actions: headerActions
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $16oOu.default), {
        call: call,
        patientName: p?.name,
        variant: "mobile"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'sticky',
            top: 0,
            zIndex: 20,
            background: (0, $jTCZr.C).card
        }
    }, allergies.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dBAbF.default), {
        allergies: allergies
    }), visitStatus === 'inprogress' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-monitoring-control",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0.5rem 0.875rem',
            borderBottom: `1px solid ${(0, $jTCZr.C).border}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c6MXC.default), {
        recState: recState,
        recElapsed: recElapsed,
        disabled: isStopping || isConnecting,
        onToggle: isRecording ? stopMonitoring : isRecPaused ? resumeRec : startRec
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dXWAH.CompleteButton), {
        variant: "mobile",
        tone: "solid",
        testid: "visit-complete-all",
        ...completion.allButton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ajYTu.AutoConfirmChip), {
        variant: "mobile",
        items: autoConfirm.items,
        onUndo: autoConfirm.undo,
        onAcknowledge: autoConfirm.acknowledge
    }), erxAvailable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $15ERh.MobileErxStatusChip), {
        state: erxChip,
        onClick: ()=>setErxSheetOpen(true)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dXWAH.CompletionGuide), {
        variant: "mobile",
        steps: completion.flow.steps,
        current: completeSectionShown,
        next: completion.flow.nextFrom(completeSectionShown),
        onGo: goCompleteSection
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fKtaR.default), {
        active: mobileTab,
        onChange: pickMobileTab,
        isVisible: mobileTabShown,
        counts: {
            rx: rxItems.length,
            ord: pendingTests.length
        },
        proposals: {
            note: completion.pending.soap,
            rx: completion.pending.rx,
            ord: completion.pending.orders
        },
        trailing: canConvertVisit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            size: "icon",
            onClick: ()=>{
                call.clearConvertError();
                setConvertSheetOpen(true);
            },
            "aria-label": t('visit.call.convert'),
            title: t('visit.call.convert'),
            "data-testid": "visit-convert-online",
            className: "min-w-11 min-h-11 shrink-0"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                display: 'grid',
                placeItems: 'center',
                width: '2.125rem',
                height: '2.125rem',
                borderRadius: '0.625rem',
                border: `1px solid ${(0, $jTCZr.C).border}`,
                background: (0, $jTCZr.CT).accentSoft,
                color: (0, $jTCZr.CT).accentInk
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bawlA.default), {
            size: 17,
            "aria-hidden": true
        }))) : null
    })), startError && visitStatus !== 'inprogress' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-start-failed",
        role: "alert",
        style: {
            padding: '0.625rem 0.875rem',
            background: (0, $jTCZr.C).redLight,
            borderBottom: `1px solid ${(0, $jTCZr.CT).danger}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            fontSize: '0.8125rem',
            fontWeight: 700,
            color: (0, $jTCZr.CT).dangerInk
        }
    }, t('visit.start.failed')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "sm",
        className: "h-9 shrink-0",
        "data-testid": "visit-start-retry",
        onClick: handleStart
    }, t('visit.start.retry'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.6875rem',
            color: (0, $jTCZr.C).textMuted,
            marginTop: '0.3125rem',
            lineHeight: 1.7
        }
    }, t(`${(0, $cwVZP.kindKey)((0, $cwVZP.classifyError)(startError))}.body`)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.6875rem',
            color: (0, $jTCZr.C).textMuted,
            marginTop: '0.1875rem',
            lineHeight: 1.7
        }
    }, t('visit.start.failedHint'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '0.875rem 0.875rem 1rem'
        },
        "data-testid": "visit-content",
        "data-state": visitStatus === 'inprogress' ? 'content' : 'empty'
    }, mobileTab === 'note' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1eCd1.default), {
        soap: soap,
        onChange: (key, val)=>setSoap((prev)=>({
                    ...prev,
                    [key]: val
                })),
        /* «برنامه» is where the treatment plan is produced: its AI
                     button generates the plan, whose prose lands in this very
                     field, and the review panel opens underneath it. */ onPlanAi: handleOpenPlanPanel,
        planAiDisabled: planLoading || planSaving || !visitId,
        planAiLoading: planLoading,
        planPanelOpen: planPanelOpen,
        onPlanFocusChange: setPlanEditorFocused,
        /* تکمیل یادداشت — merge-aware completion, same hook as
                     desktop: previews per section, apply/dismiss, charge only
                     when the server says it charged. Asked for from the top
                     strip's visit-wide «تکمیل»; the note has no button of its
                     own (PM-0046). */ refine: soapRefine,
        autoConfirmed: (key)=>autoConfirm.live('soap', key),
        planBlockHint: planBlock ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": "visit-plan-block-hint",
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.3125rem',
                marginTop: '0.375rem',
                fontSize: '0.625rem',
                color: (0, $jTCZr.C).textMuted,
                lineHeight: 1.6
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                width: '0.3125rem',
                height: '0.3125rem',
                borderRadius: '50%',
                background: (0, $jTCZr.CT).good,
                flexShrink: 0
            }
        }), t('visit.plan.blockHint')) : null,
        planPanel: planPanelOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $90sfp.default), {
            suggestion: planSuggestion,
            loading: planLoading,
            saving: planSaving,
            status: planStatus,
            error: planError,
            selected: selectedPlanItems,
            onToggle: togglePlanItem,
            onGenerate: handleSuggestPlan,
            onConfirm: handleApplyPlan,
            onClose: ()=>setPlanPanelOpen(false),
            onRestore: handleRestorePlanText,
            canRestore: planReplacedP != null,
            inprogress: visitStatus === 'inprogress',
            canGenerate: !!patient?.id && visitStatus === 'inprogress'
        }) : null
    }), mobileTab === 'rx' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6miYn.default), {
        rxItems: rxItems,
        templateButton: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cvBw3.default), {
            kind: "medication",
            compact: true,
            allergies: (patient?.clinicalAllergies || []).map((a)=>a.allergen).filter(Boolean),
            existingDrugIds: rxItems.map((r)=>r.drug?.id).filter(Boolean),
            appointmentId: pmEncounterId || visitId,
            patientId: patient?.id,
            onApplied: handleMedicationTemplateApplied
        }),
        onAdd: addDrug,
        defaultsFor: rxDefaultsFor,
        memory: rxMemory.memory,
        frequent: rxFrequent,
        insurer: (0, $eQiuG.insurerKeyOf)(patient?.insurance),
        documentDrafts: docRxDrafts,
        onConfirmDocumentDraft: confirmDocRxDraft,
        onDiscardDocumentDraft: discardDocRxDraft,
        onRemove: removeDrug,
        onUpdate: updateDrug,
        interactions: rxInteractions,
        interactionLoading: interactionLoading,
        interactionError: ixError,
        interactionStale: ixStale,
        onCheckInteractions: runInteractionCheck,
        canCheckInteractions: canCheckInteractions,
        assist: {
            busySource: rxAssist.review.phase === 'loading' ? rxAssist.review.source : null,
            onHistory: ()=>rxAssist.run((0, $bwSot.PROPOSAL_SOURCES).HISTORY),
            canHistory: !!visitId && (0, $bwSot.sourceReady)((0, $bwSot.PROPOSAL_SOURCES).HISTORY, rxHistoryCtx)
        },
        /* The proposal sits in the tab it would fill, like every other. */ proposal: rxAssist.review.open ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $jCgjY.default), {
            variant: "mobile",
            review: rxAssist.review,
            rxItems: rxItems,
            allergies: (patient?.clinicalAllergies || []).map((a)=>a.allergen).filter(Boolean),
            onToggle: rxAssist.toggle,
            onChoose: rxAssist.choose,
            onSetAll: rxAssist.setAll,
            onApply: rxAssist.apply,
            onClose: rxAssist.close,
            onRetry: ()=>rxAssist.run(rxAssist.review.source)
        }) : null
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        hidden: mobileTab !== 'ord',
        "data-testid": "visit-tab-ord"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginBottom: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cvBw3.default), {
        kind: "order",
        compact: true,
        appointmentId: pmEncounterId || visitId,
        patientId: patient?.id,
        onApplied: handleOrderTemplateApplied
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3HnvL.default), {
        onFetchSuggestions: handleFetchOrderSuggestions,
        suggestions: orderSuggestions,
        suggestionsLoading: orderSuggestionsLoading,
        canSuggest: !!visitId,
        searchCatalog: searchCatalog,
        pendingTests: pendingTests,
        onAddOrders: handleAddOrders,
        onAddPending: (item)=>setPendingTests((prev)=>prev.find((test)=>test.name === item.name) ? prev : [
                    ...prev,
                    item
                ]),
        onRemovePending: (id)=>setPendingTests((prev)=>prev.filter((x)=>x.id !== id)),
        /* Saved orders and their lifecycle. Until now the phone
                     fetched these and showed none of them: an order created on
                     either surface was invisible here, and «انجام» — the event
                     accounting bills on — had no button at all. */ orders: clinicalOrders,
        ordersLoading: ordersLoading,
        ordersLoaded: ordersLoaded,
        transitioningId: orderTransitioning,
        inHouseCatalogIds: inHouseCatalogIds,
        insurer: (0, $eQiuG.insurerKeyOf)(patient?.insurance),
        catalogResolved: catalogResolved,
        onCompleteOrder: handleOrderDone,
        onCancelOrder: setOrderToCancel,
        onChangeOrderDate: handleOrderDateChange,
        erxIndex: erxIndex,
        visitId: pmEncounterId || visitId || null,
        visitOnline: call.available === true,
        orderError: orderError,
        onDismissOrderError: ()=>setOrderError(null),
        /* No section «تکمیل»: the pinned strip's visit-wide one reads
                     the دستورات too, as it does the نسخه (PM-0110 item 2 — one
                     «تکمیل», the same in every section). */ proposal: findingsCard('ORDERS'),
        onPendingChange: setOrdersPending
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $jzVrj.default), {
        compact: true,
        appointmentId: pmEncounterId || visitId || null,
        refreshKey: visitServicesKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fijM5.default), {
        compact: true,
        className: "mt-3",
        appointmentId: pmEncounterId || visitId || null,
        patientId: patient?.id,
        doctorId: doctor?.id
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: footerRef,
        style: {
            flexShrink: 0,
            padding: `0.5rem 0.875rem calc(0.5rem + env(safe-area-inset-bottom, 0px) + ${keyboardInset}px)`,
            // ONE row (PM-0044, design §۱۲). The three actions of a visit are
            // three different kinds of thing, and their weight follows how often
            // they are used: «پایش بالینی» — the running process — is the solid
            // control in the top strip; down here «دستیار» is a quiet way in and
            // «پایان ویزیت», done once, is an outline at the far end. Nothing in
            // this row is filled except «شروع ویزیت» before the visit exists.
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: '0.5rem',
            background: (0, $jTCZr.C).bg,
            borderTop: `1px solid ${(0, $jTCZr.C).border}`
        },
        "data-testid": "visit-footer"
    }, !visitStatus ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "teal",
        size: "lg",
        onClick: handleStart,
        "data-testid": "visit-cta-start",
        className: "w-full min-h-11"
    }, t('dashboard.hero.startVisit')) : visitStatus === 'inprogress' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, keyboardInset === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gLLxa.default), {
        count: copilotSuggestions.length + activeDiffs.length,
        onOpen: ()=>setMobileSheet('ai')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aQc6m.default), {
        onEnd: ()=>{
            if (ordersPending > 0) {
                setMobileTab('ord');
                toast?.warn?.(t('visit.orders.pendingOnEnd', {
                    count: formatDigits(ordersPending)
                }));
                return;
            }
            requestEnd();
        },
        ending: endingVisit,
        style: {
            marginInlineStart: keyboardInset === 0 ? '0.5rem' : 'auto'
        }
    })) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $io25J.default), {
        open: mobileSheet === 'ai',
        onClose: ()=>setMobileSheet(null),
        tab: mobileAiTab,
        onTab: pickAiTab,
        isTabVisible: (id)=>(0, $aoLHg.isMobileCopilotSheetTabVisible)(visitLayout, id),
        // The differential lives HERE and nowhere else on the phone: it is AI
        // output, so it sits with the assistant, and the nav keeps the three
        // things the doctor writes (note, prescription, orders).
        diffCount: activeDiffs.length,
        differentialPanel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dlUcE.default), {
            items: differential,
            loading: diffLoading,
            visitStatus: visitStatus,
            primaryCode: mobileDiffPrimary,
            confirmToA: soapDiffConfirm,
            onSetPrimary: setMobileDiffPrimary,
            onAccept: handleDiffAccept,
            onReject: handleDiffReject,
            typePick: diffTypePick,
            onPickType: setDiffTypePick,
            typeBusy: diffTypeBusy,
            conditions: activeDiagnoses,
            onConfirmToA: handleDiffConfirmToA,
            onAddIcd: ()=>{},
            openAIDiag: openAIDiag,
            onToggleAIDiag: toggleDiagAI,
            aiQuestions: diagAIQuestions,
            aiAnswers: diagAIAnswers,
            aiLoading: diagAILoading,
            aiSubmitting: diagQSubmitting,
            aiErrors: diagQError,
            onAnswer: handleAnswerDiagQuestion,
            onReloadQuestions: reloadDiagQuestions,
            gate: diffGate,
            pollingActive: pollingActive,
            pollSeconds: pollSeconds,
            pollLabel: (0, $3Tnyk.differentialPollLabel)(pollSeconds, t, formatNumber),
            pollOverridden: pollOverridden,
            onTogglePolling: togglePolling
        }),
        suggestions: copilotSuggestions,
        transcriptLines: transcriptLines,
        messages: aiMessages,
        chatLoading: aiChatLoading,
        recsLoading: recsLoading,
        recsError: recsError,
        recsRan: recsRan,
        onRunRecs: runRecommendations,
        visitCoins: visitCoins,
        /* The total alone cannot answer «چه چیزی این را خرج کرد؟» — the
               itemised ledger the desktop popover shows, folded into the one
               place the phone talks about money. */ coinEntries: coinEntries,
        quickQs: diffQuickQ,
        aiInput: aiInput,
        onAiInput: setAiInput,
        onAsk: handleAsk
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2WSjX.default), {
        open: mobileSheet === 'vitals',
        onClose: ()=>setMobileSheet(null),
        patient: p,
        vitals: vitals,
        onVitalChange: (k, v)=>setVitals((prev)=>({
                    ...prev,
                    [k]: (0, $6xvbB.vitalDigits)(v)
                })),
        vitalsMode: vitalsMode,
        onVitalsSave: handleSaveVitals,
        vitalsLoading: vitalsLoading,
        vitalsError: vitalsError,
        vitalsAlert: vitalsAlert,
        onDismissVitalsAlert: ()=>setVitalsAlert(null),
        onEditVitals: ()=>setVitalsMode('form'),
        onVitalsHistory: ()=>setShowVitalsModal(true),
        vitalsComplete: visitStatus === 'inprogress' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dXWAH.CompleteButton), {
            variant: "mobile",
            testid: "visit-vitals-complete",
            ...completion.button('vitals')
        }) : null,
        vitalsProposal: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, findingsCard('VITALS'), autoConfirm.items.some((i)=>i.kind === 'vitals' && i.state === 'live') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": "visit-vitals-auto",
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.375rem',
                flexWrap: 'wrap',
                fontSize: '0.75rem',
                lineHeight: 1.6,
                color: (0, $jTCZr.C).textSecondary
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ajYTu.AutoConfirmBadge), {
            variant: "mobile"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, t('visit.autoConfirm.vitalsHint')))),
        recordComplete: visitStatus === 'inprogress' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dXWAH.CompleteButton), {
            variant: "mobile",
            testid: "visit-record-complete",
            ...completion.button('record')
        })), findingsCard('RECORD')) : null,
        meds: uniqMeds,
        onStopMed: removeMed,
        undoMed: undoMed,
        onUndoMed: restoreMed,
        diagnoses: activeDiagnoses,
        onRemoveDiagnosis: removeCondition,
        undoCondition: undoCond,
        onUndoCondition: restoreCondition,
        conditions: patientConditions,
        labResults: patient?.clinicalObservations || [],
        pastVisits: pastVisitSummaries,
        encounters: patient?.encounters || [],
        clinicalNotes: patient?.clinicalNotes || [],
        onUploadLab: ()=>clinicalFiles.openUpload(),
        files: visitFileList,
        currentVisitId: pmEncounterId || visitId || null,
        onOpenFile: clinicalFiles.openDetail,
        onPreviewFile: (f, list)=>clinicalFiles.openGallery(f, list),
        onViewFile: clinicalFiles.openViewer,
        onExtractFile: (f)=>clinicalFiles.openExtract(f),
        onEditFile: (f)=>clinicalFiles.openDetail(f, {
                edit: true
            }),
        onDownloadFile: clinicalFiles.download,
        onDeleteFile: clinicalFiles.requestDelete,
        onEditPatient: openEditPatient,
        onRepresribeMed: represcribeMed,
        prescribedNames: prescribedMedNames,
        onChangeDxType: changeCondType,
        dxTypeBusyId: dxTypeBusyId,
        visitContexts: visitContexts,
        onOpenVisit: loadVisitContext,
        onViewAllLabs: ()=>setLabsSheetOpen(true),
        /* The arrangement: which sections, in what order, open or closed —
               and the way to change it from where it is noticed. */ sections: recordSections,
        recordOpen: recordOpen,
        onToggleSection: toggleRecordSection,
        onEditLayout: ()=>navProp('profile', {
                tab: 'visit'
            })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $99eLi.default), {
        open: labsSheetOpen,
        onClose: ()=>setLabsSheetOpen(false),
        labResults: patient?.clinicalObservations || []
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9BB3T.MobileVisitVitalsHistorySheet), {
        open: showVitalsModal,
        onClose: ()=>setShowVitalsModal(false),
        observations: patient?.clinicalObservations || []
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9BB3T.MobileVisitEditPatientSheet), {
        open: showEditPatient,
        onClose: ()=>setShowEditPatient(false),
        form: editPatientForm,
        onChange: (k, v)=>{
            setEditPatientForm((f)=>({
                    ...f,
                    [k]: v
                }));
            if (k === 'phones') setEditPatientPhoneErrors(null);
        },
        saving: editPatientSaving,
        error: editPatientError,
        phoneErrors: editPatientPhoneErrors,
        onSave: saveEditPatient
    }), clinicalFiles.overlays, patient?.id && true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gRy9t.default), {
        patientId: patient.id,
        onChange: refreshPatient
    }), showClosureFlow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9Akci.default), {
        onClose: goToReception,
        soap: soap,
        rxItems: rxItems,
        pendingTests: pendingTests,
        patient: patient,
        doctor: doctor,
        diagnosis: diagnosis,
        prescriptionTemplates: prescriptionTemplates,
        appointmentId: visitId,
        saveFailures: saveFailures
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2BAqO.default), {
        open: printSheetOpen,
        onClose: ()=>setPrintSheetOpen(false),
        templates: prescriptionTemplates,
        rxItems: rxItems,
        pendingTests: pendingTests,
        diagnosis: soap.a || diagnosis,
        soap: soap,
        doctor: doctor,
        patient: patient
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $t47X1.default), {
        open: overflowOpen,
        onClose: ()=>setOverflowOpen(false),
        canPrint: rxItems.length > 0,
        canCancel: visitStatus === 'inprogress',
        cancelling: cancellingVisit,
        onPrint: ()=>{
            setOverflowOpen(false);
            setPrintSheetOpen(true);
        },
        onUploadLab: ()=>{
            setOverflowOpen(false);
            clinicalFiles.openUpload();
        },
        onCancelVisit: ()=>{
            setOverflowOpen(false);
            setPendingCancelVisit(true);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5qFC5.default), {
        error: recError,
        onRetry: startRec,
        onClose: dismissError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3OnFU.default), {
        open: pendingCancelVisit,
        onOpenChange: (o)=>{
            if (!o) setPendingCancelVisit(false);
        },
        title: t('visit.confirm.cancelTitle'),
        message: t('visit.confirm.cancelBody'),
        confirmLabel: t('visit.confirm.cancelConfirm'),
        cancelLabel: t('common.actions.back'),
        destructive: true,
        onConfirm: handleCancelEncounter
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3OnFU.default), {
        open: !!orderToCancel,
        onOpenChange: (o)=>{
            if (!o) setOrderToCancel(null);
        },
        title: orderToCancel?.description ? t('visit.orders.cancelNamed', {
            name: orderToCancel.description
        }) : t('visit.orders.cancelTitle'),
        message: t('visit.orders.cancelBody'),
        confirmLabel: t('visit.orders.cancelAction'),
        cancelLabel: t('common.actions.back'),
        destructive: true,
        onConfirm: ()=>{
            if (orderToCancel) handleOrderTransition(orderToCancel.id, 'cancel');
            setOrderToCancel(null);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: erxAvailable && erxSheetOpen,
        onClose: closeErxSheet,
        title: t('visit.erx.panel.title'),
        closeLabel: t('common.actions.close')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-erx-panel"
    }, erxStatus?.enabled === false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        "data-testid": "visit-erx-panel-not-offered",
        style: {
            fontSize: '0.8125rem',
            color: (0, $jTCZr.C).textSecondary,
            lineHeight: 1.8
        }
    }, t('visit.erx.inVisit.notOffered')) : erxAvailable && erxSheetOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4UqGT.default), {
        flow: "panel",
        testIdPrefix: "visit-erx",
        appointmentId: pmEncounterId || visitId,
        patientId: patient.id,
        prepare: rxPersistence.writeNow,
        refreshKey: erxRefreshKey,
        onSubmitted: reloadErxStatus,
        onBusyChange: setErxBusy
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3OnFU.default), {
        open: erxLeaveOpen,
        onOpenChange: (o)=>{
            if (!o) setErxLeaveOpen(false);
        },
        title: t('visit.erx.leaveTitle'),
        description: t('visit.erx.leaveBody'),
        confirmLabel: t('common.actions.leave'),
        cancelLabel: t('visit.erx.stayLabel'),
        confirmTestId: "visit-erx-leave-ok",
        cancelTestId: "visit-erx-leave-cancel",
        onConfirm: ()=>{
            setErxLeaveOpen(false);
            setErxBusy(false);
            setErxSheetOpen(false);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: convertSheetOpen,
        onClose: ()=>{
            if (!call.converting) setConvertSheetOpen(false);
        },
        title: t('visit.call.convert'),
        closeLabel: t('common.actions.close')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-convert-sheet"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        style: {
            fontSize: '0.8125rem',
            color: (0, $jTCZr.C).textSecondary,
            lineHeight: 1.8,
            marginBottom: '0.875rem'
        }
    }, t('visit.call.convertBody')), call.convertError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginBottom: '0.875rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "error",
        "data-testid": "visit-convert-error"
    }, t('visit.call.convertError'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "default",
        size: "lg",
        onClick: handleConvertVisit,
        disabled: call.converting,
        "data-testid": "visit-convert-confirm",
        className: "w-full min-h-11 mb-2"
    }, call.converting ? t('visit.call.converting') : t('visit.call.convertAndCall')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "lg",
        onClick: ()=>setConvertSheetOpen(false),
        disabled: call.converting,
        className: "w-full min-h-11"
    }, t('common.actions.cancel')))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: !!activeVisitConflict,
        onClose: ()=>setActiveVisitConflict(null),
        title: t('visit.resume.activeTitle'),
        closeLabel: t('common.actions.close')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-conflict-sheet"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        style: {
            fontSize: '0.8125rem',
            color: (0, $jTCZr.C).textSecondary,
            lineHeight: 1.8,
            marginBottom: '0.875rem'
        }
    }, t('visit.resume.activeBody')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "default",
        size: "lg",
        onClick: handleResumeConflictVisit,
        "data-testid": "visit-conflict-resume",
        className: "w-full min-h-11 mb-2"
    }, t('visit.resume.continuePrevious')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "lg",
        onClick: handleCloseConflictVisit,
        "data-testid": "visit-conflict-restart",
        className: "w-full min-h-11"
    }, t('visit.resume.closeAndStart')))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hScMH.default), {
        compact: true,
        open: endServicesOpen,
        onOpenChange: (o)=>{
            if (!o && !endServices.running) {
                setEndServicesOpen(false);
                endServices.close();
            }
        },
        items: endServices.items,
        answers: endServices.answers,
        failures: endServices.failures,
        running: endServices.running,
        onAnswer: endServices.setAnswer,
        onConfirm: ()=>endServices.run(async ()=>{
                setEndServicesOpen(false);
                endServices.close();
                await handleEnd();
                return 'done';
            })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3OnFU.default), {
        open: pendingEnd,
        onOpenChange: (o)=>{
            if (!o) setPendingEnd(false);
        },
        title: t('dashboard.hero.endVisit'),
        message: t('visit.confirm.endBody'),
        confirmLabel: t('visit.confirm.endConfirm'),
        cancelLabel: t('visit.confirm.endCancel'),
        destructive: true,
        onConfirm: handleEnd
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3OnFU.default), {
        open: leaveConfirm,
        onOpenChange: (o)=>{
            if (!o) {
                setLeaveConfirm(false);
                pendingNavRef.current = null;
            }
        },
        title: t('visit.confirm.leaveTitleShort'),
        message: t('visit.confirm.leaveDraftBody'),
        confirmLabel: t('nav.sidebar.logout'),
        cancelLabel: t('visit.confirm.endCancel'),
        onConfirm: handleLeaveConfirm
    }), endingVisit && !showClosureFlow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'absolute',
            inset: 0,
            zIndex: 50,
            background: 'rgba(26,35,50,0.72)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '1.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.875rem',
            width: '100%',
            maxWidth: '20rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonCard), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.875rem',
            fontWeight: 700,
            color: 'white',
            textAlign: 'center'
        }
    }, t('visit.header.ending'))))));
}

});
parcelRegister("7sS0P", function(module, exports) {

$parcel$export(module.exports, "RADIUS", () => $56f50ba2a6b5ae3c$export$2d2c9be8b5b863f);
$parcel$export(module.exports, "SHADOW", () => $56f50ba2a6b5ae3c$export$98b6069deb71e13e);
$parcel$export(module.exports, "C", () => (parcelRequire("jTCZr")).C);
$parcel$export(module.exports, "CT", () => (parcelRequire("jTCZr")).CT);
$parcel$export(module.exports, "soft", () => (parcelRequire("jTCZr")).soft);

var $jTCZr = parcelRequire("jTCZr");
const $56f50ba2a6b5ae3c$export$2d2c9be8b5b863f = {
    chip: 6,
    control: 10,
    card: 14,
    hero: 20,
    pill: 999
};
const $56f50ba2a6b5ae3c$export$98b6069deb71e13e = {
    card: '0 1px 4px rgba(0,0,0,0.06)',
    floating: '0 8px 24px rgba(0,0,0,0.10)',
    modal: '0 25px 60px rgba(0,0,0,0.20)'
};

});

parcelRegister("fWbIA", function(module, exports) {

$parcel$export(module.exports, "visitPanelsOpenByDefault", () => $84e131569ade80e0$export$e6a645360361d3ad);
$parcel$export(module.exports, "visitGridColumns", () => $84e131569ade80e0$export$88c3a43a7eaf51eb);
$parcel$export(module.exports, "VisitSkeleton", () => $84e131569ade80e0$export$39c20a58c12966ae);
$parcel$export(module.exports, "VisitMobileSkeleton", () => $84e131569ade80e0$export$2ed6987820fcbbfe);
$parcel$export(module.exports, "OrdersListSkeleton", () => $84e131569ade80e0$export$ab93a3750a1b92b6);
$parcel$export(module.exports, "CatalogListSkeleton", () => $84e131569ade80e0$export$217179f0f838b1dd);
$parcel$export(module.exports, "VisitDetailSkeleton", () => $84e131569ade80e0$export$785af5d3304b5931);
$parcel$export(module.exports, "VisitHistoryRailSkeleton", () => $84e131569ade80e0$export$562f3f75696de122);

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $66joL = parcelRequire("66joL");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
// ─────────────────────────────────────────────────────────────────────────────
// The visit workspace's loading shapes (DESIGN.md §"Loading & skeleton").
//
// Desktop (`VisitSkeleton`) is the three-column cockpit at its real grid —
// 54px top bar, 340px record rail, the SOAP centre with its tab strip, the
// 360px copilot rail — so the workspace lands in place when the patient
// arrives. Mobile (`VisitMobileSkeleton`) is the phone's own shape: the 7rem
// brand band, the section pills, SOAP cards, the pinned CTA bar.
//
// The region pieces below stand in for ONE pending region inside a live
// workspace: the orders list, a catalogue picker, a past visit's detail.
// ─────────────────────────────────────────────────────────────────────────────
const $84e131569ade80e0$var$RailSection = ({ lines: lines = 2 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            background: (0, $jTCZr.C).card,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: (0, $jTCZr.RADIUS).control,
            padding: '12px 14px',
            display: 'flex',
            flexDirection: 'column',
            gap: 10
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 110,
        height: 13
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 14,
        height: 14,
        radius: 4
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonText), {
        lines: lines,
        height: 11,
        lastWidth: "55%"
    }));
const $84e131569ade80e0$export$9bd146003e37d24c = 56;
const $84e131569ade80e0$export$f5b59ff325509bf0 = 1440;
const $84e131569ade80e0$export$e6a645360361d3ad = ()=>{
    try {
        if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return true;
        return window.matchMedia(`(min-width: ${$84e131569ade80e0$export$f5b59ff325509bf0}px)`).matches !== false;
    } catch  {
        return true;
    }
};
const $84e131569ade80e0$export$88c3a43a7eaf51eb = ({ contextExpanded: contextExpanded = false, copilotExpanded: copilotExpanded = false, recordOpen: recordOpen = true, copilotOpen: copilotOpen = true } = {})=>[
        `${$84e131569ade80e0$export$9bd146003e37d24c}px`,
        !recordOpen ? '0px' : contextExpanded ? 'min(560px, 38%)' : 'clamp(220px, calc(30% - 92px), 340px)',
        'minmax(0,1fr)',
        !copilotOpen ? '0px' : copilotExpanded ? 'min(600px, 40%)' : 'clamp(240px, calc(30% - 72px), 360px)'
    ].join(' ');
const $84e131569ade80e0$var$SOAP_LABELS = [
    64,
    80,
    72,
    56
];
const $84e131569ade80e0$export$39c20a58c12966ae = ({ label: label })=>{
    const { t: t } = (0, $LNQP4.default)();
    // The skeleton lands on the grid the page will open with on this screen.
    const open = $84e131569ade80e0$export$e6a645360361d3ad();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonRegion), {
        label: label ?? t('common.state.loading'),
        "data-testid": "visit-loading",
        style: {
            display: 'grid',
            gridTemplateColumns: $84e131569ade80e0$export$88c3a43a7eaf51eb({
                recordOpen: open,
                copilotOpen: open
            }),
            gridTemplateRows: '54px 1fr',
            height: '100vh',
            background: (0, $jTCZr.C).bg,
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            gridColumn: '1 / -1',
            background: (0, $jTCZr.C).card,
            borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            padding: '0 16px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 36,
        height: 36,
        radius: (0, $jTCZr.RADIUS).control
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonAvatar), {
        size: 34
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 5,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 150,
        height: 14
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 200,
        height: 11
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginInlineStart: 'auto',
            display: 'flex',
            alignItems: 'center',
            gap: 8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 72,
        height: 28,
        radius: (0, $jTCZr.RADIUS).pill
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonButton), {
        size: "sm",
        width: 104
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonButton), {
        size: "sm",
        width: 120
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            gridColumn: 1,
            gridRow: 2,
            padding: '12px 0',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 8,
            background: (0, $jTCZr.C).card,
            borderInlineEnd: `1px solid ${(0, $jTCZr.C).border}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 44,
        height: 48,
        radius: (0, $jTCZr.RADIUS).control
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 44,
        height: 48,
        radius: (0, $jTCZr.RADIUS).control
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            gridColumn: 2,
            gridRow: 2,
            padding: 16,
            display: open ? 'flex' : 'none',
            flexDirection: 'column',
            gap: 10,
            borderInlineStart: `1px solid ${(0, $jTCZr.C).border}`,
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($84e131569ade80e0$var$RailSection, {
        lines: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($84e131569ade80e0$var$RailSection, {
        lines: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($84e131569ade80e0$var$RailSection, {
        lines: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($84e131569ade80e0$var$RailSection, {
        lines: 1
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            gridColumn: 3,
            gridRow: 2,
            padding: 16,
            display: 'flex',
            flexDirection: 'column',
            gap: 14,
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonTabs), {
        widths: [
            72,
            60,
            96,
            84
        ],
        padding: "11px 16px"
    }), $84e131569ade80e0$var$SOAP_LABELS.map((w, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonInput), {
            key: i,
            labelWidth: w,
            multiline: true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 8,
            justifyContent: 'flex-end'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonButton), {
        size: "sm",
        width: 96
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonButton), {
        size: "sm",
        width: 128
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            gridColumn: 4,
            gridRow: 2,
            padding: 16,
            display: open ? 'flex' : 'none',
            flexDirection: 'column',
            gap: 12,
            borderInlineEnd: `1px solid ${(0, $jTCZr.C).border}`,
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 22,
        height: 22,
        radius: 6
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 120,
        height: 13
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($84e131569ade80e0$var$RailSection, {
        lines: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($84e131569ade80e0$var$RailSection, {
        lines: 2
    })));
};
const $84e131569ade80e0$var$MobileSoapCard = ({ lines: lines })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            background: (0, $jTCZr.C).card,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: (0, $jTCZr.RADIUS).card,
            padding: '0.875rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 26,
        height: 26,
        radius: 8
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 96,
        height: 13
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 28,
        height: 28,
        radius: (0, $jTCZr.RADIUS).control,
        style: {
            marginInlineStart: 'auto'
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonText), {
        lines: lines,
        height: 12,
        lastWidth: "60%"
    }));
const $84e131569ade80e0$export$2ed6987820fcbbfe = ({ label: label })=>{
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonRegion), {
        label: label ?? t('common.state.loading'),
        "data-testid": "visit-content",
        style: {
            position: 'absolute',
            inset: 0,
            display: 'flex',
            flexDirection: 'column',
            background: (0, $jTCZr.C).bg,
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            height: '7rem',
            background: (0, $jTCZr.GRADIENT_BRAND_DARK),
            flexShrink: 0,
            padding: 'calc(1rem + env(safe-area-inset-top, 0px)) 1rem 0',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 36,
        height: 36,
        radius: (0, $jTCZr.RADIUS).control,
        tone: "onDark"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: "55%",
        height: 15,
        tone: "onDark"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: "40%",
        height: 11,
        tone: "onDark"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 64,
        height: 28,
        radius: (0, $jTCZr.RADIUS).pill,
        tone: "onDark"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            display: 'flex',
            gap: '0.5rem',
            padding: '0.75rem 0.875rem 0',
            overflow: 'hidden',
            flexShrink: 0
        }
    }, [
        72,
        60,
        84,
        68
    ].map((w, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
            key: i,
            width: w,
            height: 36,
            radius: (0, $jTCZr.RADIUS).pill
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            padding: '0.875rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem',
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($84e131569ade80e0$var$MobileSoapCard, {
        lines: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($84e131569ade80e0$var$MobileSoapCard, {
        lines: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($84e131569ade80e0$var$MobileSoapCard, {
        lines: 2
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            padding: '0.75rem 0.875rem calc(0.75rem + env(safe-area-inset-bottom, 0px))',
            background: (0, $jTCZr.C).card,
            borderTop: `1px solid ${(0, $jTCZr.C).border}`,
            display: 'flex',
            gap: '0.5rem',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonButton), {
        style: {
            flex: 1,
            width: 'auto'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonButton), {
        size: "icon"
    })));
};
/** One clinical order row: type glyph · title + meta · status chip. Desktop and mobile alike. */ const $84e131569ade80e0$var$OrderRowSkeleton = ({ i: i, dense: dense })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            padding: dense ? '0.625rem 0.75rem' : '10px 12px',
            background: (0, $jTCZr.C).card,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: (0, $jTCZr.RADIUS).control
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 36,
        height: 36,
        radius: (0, $jTCZr.RADIUS).control
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: `${46 + i * 17 % 30}%`,
        height: 13
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: `${28 + i * 11 % 22}%`,
        height: 11
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 64,
        height: 22,
        radius: (0, $jTCZr.RADIUS).pill
    }));
const $84e131569ade80e0$export$ab93a3750a1b92b6 = ({ count: count = 3, dense: dense = false, testId: testId = 'visit-orders-loading', label: label })=>{
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonRegion), {
        label: label ?? t('common.state.loading'),
        "data-testid": testId,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: dense ? '0.5rem' : 8
        }
    }, Array.from({
        length: count
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($84e131569ade80e0$var$OrderRowSkeleton, {
            key: i,
            i: i,
            dense: dense
        })));
};
const $84e131569ade80e0$export$217179f0f838b1dd = ({ count: count = 5, testId: testId, label: label })=>{
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonList), {
        count: count,
        avatar: false,
        trailing: 48,
        "data-testid": testId,
        label: label ?? t('common.state.loading')
    });
};
const $84e131569ade80e0$export$785af5d3304b5931 = ({ label: label })=>{
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonRegion), {
        label: label ?? t('common.state.loading'),
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
            padding: '6px 0'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 96,
        height: 12
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            display: 'flex',
            gap: 5
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 84,
        height: 22,
        radius: (0, $jTCZr.RADIUS).pill
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 64,
        height: 22,
        radius: (0, $jTCZr.RADIUS).pill
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 80,
        height: 12
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonText), {
        lines: 2,
        height: 11,
        lastWidth: "50%"
    }));
};
const $84e131569ade80e0$export$562f3f75696de122 = ({ count: count = 3, label: label })=>{
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonRegion), {
        label: label ?? t('common.state.loading'),
        "data-testid": "visit-history-rail-loading",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 6
        }
    }, Array.from({
        length: count
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            "aria-hidden": true,
            style: {
                padding: '8px 10px',
                border: `1px solid ${(0, $jTCZr.C).border}`,
                borderRadius: (0, $jTCZr.RADIUS).control,
                background: (0, $jTCZr.CT).surface2,
                display: 'flex',
                flexDirection: 'column',
                gap: 6
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                justifyContent: 'space-between'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
            width: 90,
            height: 11
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
            width: 48,
            height: 11
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
            width: `${40 + i * 13 % 30}%`,
            height: 11
        }))));
};
var $84e131569ade80e0$export$2e2bcd8739ae039 = $84e131569ade80e0$export$39c20a58c12966ae;

});

parcelRegister("i5dmF", function(module, exports) {

$parcel$export(module.exports, "default", () => $53cde9011dd49799$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $53cde9011dd49799$export$a2387ed3b5d536eb = {
    name: "rotate-ccw-clock",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8",
                key: "1357e3"
            }
        ],
        [
            "path",
            {
                d: "M3 3v5h5",
                key: "1xhq8a"
            }
        ],
        [
            "path",
            {
                d: "M12 7v5l4 2",
                key: "1fdv2h"
            }
        ]
    ],
    aliases: [
        "history"
    ]
};
$53cde9011dd49799$export$a2387ed3b5d536eb.node;
const $53cde9011dd49799$export$2e2bcd8739ae039 = (0, $9QBug.default)($53cde9011dd49799$export$a2387ed3b5d536eb);

});

parcelRegister("7VXKQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $24a488cfd7efdee5$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $24a488cfd7efdee5$export$a2387ed3b5d536eb = {
    name: "ellipsis",
    size: 24,
    node: [
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                r: "1",
                key: "41hilf"
            }
        ],
        [
            "circle",
            {
                cx: "19",
                cy: "12",
                r: "1",
                key: "1wjl8i"
            }
        ],
        [
            "circle",
            {
                cx: "5",
                cy: "12",
                r: "1",
                key: "1pcz8c"
            }
        ]
    ],
    aliases: [
        "more-horizontal"
    ]
};
$24a488cfd7efdee5$export$a2387ed3b5d536eb.node;
const $24a488cfd7efdee5$export$2e2bcd8739ae039 = (0, $9QBug.default)($24a488cfd7efdee5$export$a2387ed3b5d536eb);

});

parcelRegister("bawlA", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d97ad00fbef0d0b$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $0d97ad00fbef0d0b$export$a2387ed3b5d536eb = {
    name: "video",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5",
                key: "ftymec"
            }
        ],
        [
            "rect",
            {
                x: "2",
                y: "6",
                width: "14",
                height: "12",
                rx: "2",
                key: "158x01"
            }
        ]
    ]
};
$0d97ad00fbef0d0b$export$a2387ed3b5d536eb.node;
const $0d97ad00fbef0d0b$export$2e2bcd8739ae039 = (0, $9QBug.default)($0d97ad00fbef0d0b$export$a2387ed3b5d536eb);

});

parcelRegister("k5DdK", function(module, exports) {

$parcel$export(module.exports, "usePatient", () => $ea02b2b734b36651$export$9b570c45914f833c);

var $acw62 = parcelRequire("acw62");

var $eVM84 = parcelRequire("eVM84");

var $bkBaq = parcelRequire("bkBaq");
// `phones` + `phonesEtag` (PM-0536); a doctor BFF that predates them is asked
// once without (PATIENT_QUERY_PRE_PHONES, derived below), and from then on
// (`phonesUnknown`). PATIENT_QUERY stays one literal: the doctor client's
// field-contract test reads it from this file.
const $ea02b2b734b36651$var$PATIENT_QUERY = `
  query GetPatient($id: ID!) {
    patient(id: $id) {
      id
      name
      phone
      ${(0, $bkBaq.PATIENT_PHONE_FIELDS)}
      birthDate
      age
      gender
      bloodType
      nationalId
      job
      insurance
      status
      lastWeight
      height
      bmi
      lastVisit
      visitsCount
      createdAt

      clinicalAllergies {
        id
        allergen
        reaction
        severity
        status
      }

      clinicalObservations {
        id
        appointmentId
        code
        display
        value
        unit
        status
        category
        effectiveDate
        createdAt
      }
      encounters {
        id
        type
        status
        scheduledDate
        dischargeInstructions
        followUpSuggestion
        duration
        consentId
        createdAt
        doctorId
      }
      clinicalFiles {
        id
        appointmentId
        orderId
        fileName
        fileType
        ocrContent
        createdAt
        # Who put it there. Not derivable from doctorId, which names the ORDERING
        # doctor even on a patient's own upload so that doctor-side scoping still
        # finds it \u{2014} so without this a patient upload is indistinguishable from
        # one the clinic scanned in.
        uploadedBy
        # Short "storage:labfile:<id>" reference for uploads whose bytes live in
        # MinIO \u{2014} used to recognise a clinical file and a storage lab file as one
        # document. Inline legacy payloads are stripped from list responses, so
        # this never carries a base64 blob.
        fileUrl
        # The care context. Only rendered when the doctor works at more than one
        # clinic \u{2014} on a single-clinic doctor's screen the chip would say the same
        # thing on every row and mean nothing.
        clinicId
        # LAB | IMAGING | MEDICAL_REPORT | PRESCRIPTION | TREATMENT_DOCUMENT | OTHER
        kind
        fileSize
        # What the analysis pipeline has done with it. The analysis ITSELF is
        # deliberately not selected here: it is one more round trip per file and
        # only the drawer needs it.
        processingStatus
        processingError
        processedAt
        # Patient documents: the document's own date and note, what the CALLER may do
        # with it (evaluated server-side), whether values or a report from it are in
        # the record, and the request it answers.
        doctorId
        documentDate
        description
        canEdit
        editScope
        canDelete
        extractable
        promotedAt
        resolvedOrder { id description orderType status }
      }

      history {
        id
        date
        specialty
      }
    }
  }
`;
const $ea02b2b734b36651$var$PATIENT_QUERY_PRE_PHONES = $ea02b2b734b36651$var$PATIENT_QUERY.replace((0, $bkBaq.PATIENT_PHONE_FIELDS), '');
let $ea02b2b734b36651$var$phonesUnknown = false;
// The record without its numbers is still the record: a schema gap on them is
// not an outage of the whole screen.
const $ea02b2b734b36651$var$isPhonesGap = (e)=>/phones/.test(String(e?.message || '')) && (e?.extensions?.code === 'GRAPHQL_VALIDATION_FAILED' || /Cannot query field/.test(String(e?.message || '')));
function $ea02b2b734b36651$var$fetchPatient(id) {
    if ($ea02b2b734b36651$var$phonesUnknown) return (0, $eVM84.bffQuery)($ea02b2b734b36651$var$PATIENT_QUERY_PRE_PHONES, {
        id: id
    });
    return (0, $eVM84.bffQuery)($ea02b2b734b36651$var$PATIENT_QUERY, {
        id: id
    }).catch((e)=>{
        if (!$ea02b2b734b36651$var$isPhonesGap(e)) throw e;
        $ea02b2b734b36651$var$phonesUnknown = true;
        return (0, $eVM84.bffQuery)($ea02b2b734b36651$var$PATIENT_QUERY_PRE_PHONES, {
            id: id
        });
    });
}
const $ea02b2b734b36651$var$LIST_CONDITIONS = `
  query ListConditions($patientId: ID!) {
    listConditions(patientId: $patientId) {
      id
      appointmentId
      code
      display
      clinicalStatus
      verificationStatus
      onsetDate
      createdAt
    }
  }
`;
// `meta` carries the drug-list product a medication was prescribed from
// (`drugId`): «تجویز مجدد» on the record rail prescribes THAT product again,
// looked up by id rather than re-matched by name (K1, 2026-10-03).
const $ea02b2b734b36651$var$LIST_MEDICATIONS = `
  query ListMedications($patientId: ID!) {
    listMedications(patientId: $patientId) {
      id
      appointmentId
      code
      display
      status
      authoredOn
      dosageInstruction
      endDate
      meta
      createdAt
    }
  }
`;
const $ea02b2b734b36651$var$LIST_CLINICAL_NOTES = `
  query ListClinicalNotes($patientId: ID!) {
    listClinicalNotes(patientId: $patientId) {
      id
      appointmentId
      noteType
      format
      content
      authorRole
      createdAt
      updatedAt
    }
  }
`;
function $ea02b2b734b36651$var$fetchClinicalData(id) {
    return Promise.all([
        $ea02b2b734b36651$var$fetchPatient(id),
        (0, $eVM84.bffQuery)($ea02b2b734b36651$var$LIST_CONDITIONS, {
            patientId: id
        }),
        (0, $eVM84.bffQuery)($ea02b2b734b36651$var$LIST_MEDICATIONS, {
            patientId: id
        }),
        (0, $eVM84.bffQuery)($ea02b2b734b36651$var$LIST_CLINICAL_NOTES, {
            patientId: id
        })
    ]).then(([patientData, conditionsData, medicationsData, notesData])=>{
        if (!patientData.patient) return patientData.patient;
        return {
            ...patientData.patient,
            clinicalConditions: conditionsData.listConditions || [],
            clinicalMedications: medicationsData.listMedications || [],
            clinicalNotes: notesData.listClinicalNotes || []
        };
    });
}
function $ea02b2b734b36651$export$9b570c45914f833c(id) {
    const [patient, setPatient] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    const load = (silent = false)=>{
        if (!id) return;
        if (!silent) setLoading(true);
        $ea02b2b734b36651$var$fetchClinicalData(id).then(setPatient).catch(setError).finally(()=>{
            if (!silent) setLoading(false);
        });
    };
    (0, $acw62.useEffect)(()=>{
        load();
    }, [
        id
    ]);
    const refresh = ()=>{
        return $ea02b2b734b36651$var$fetchClinicalData(id).then(setPatient).catch(setError);
    };
    return {
        patient: patient,
        loading: loading,
        error: error,
        refresh: refresh
    };
}

});
parcelRegister("bkBaq", function(module, exports) {

$parcel$export(module.exports, "PATIENT_PHONE_FIELDS", () => $83fe649a23c9288b$export$48fe3dcbe9322d5a);
$parcel$export(module.exports, "patientPhoneParts", () => $83fe649a23c9288b$export$4cfd3bc12d6b5917);
$parcel$export(module.exports, "phonesEditable", () => $83fe649a23c9288b$export$adbcfe214c612f59);
$parcel$export(module.exports, "phonesPatch", () => $83fe649a23c9288b$export$4fe327701f9709d0);
$parcel$export(module.exports, "patientEditErrorText", () => $83fe649a23c9288b$export$16994904a8dc04fb);
$parcel$export(module.exports, "refusedPhoneRow", () => $83fe649a23c9288b$export$4549b89e6821541a);
$parcel$export(module.exports, "phonesChanged", () => $83fe649a23c9288b$export$f047f3a0cf7d9a90);
parcelRequire("5N0ZI");
var $6SCJ6 = parcelRequire("6SCJ6");
const $83fe649a23c9288b$export$48fe3dcbe9322d5a = 'phones { id number raw relation label isPrimary verified locked source addedHere } phonesEtag';
function $83fe649a23c9288b$export$4cfd3bc12d6b5917(patient) {
    const list = Array.isArray(patient?.phones) ? patient.phones : [];
    const main = list.find((p)=>p.isPrimary) || null;
    return {
        primary: main ? main.number || main.raw || '' : patient?.phone || '',
        others: list.filter((p)=>p !== main)
    };
}
const $83fe649a23c9288b$export$adbcfe214c612f59 = (patient)=>Array.isArray(patient?.phones) && Boolean(patient?.phonesEtag);
// The list a save would send, beside the editor's row key of each entry. A blank
// row 1 is left out — the record then has one number fewer, as clearing the old
// single field did; any other blank row is refused before saving
// (phoneListProblems).
function $83fe649a23c9288b$var$sendable(rows) {
    const phones = [];
    const keys = [];
    (0, $6SCJ6.phoneListPayload)(rows).forEach((p, i)=>{
        if (!p.number) return;
        phones.push(p);
        keys.push(rows?.[i]?.key ?? `i${i}`);
    });
    return {
        phones: phones,
        keys: keys
    };
}
function $83fe649a23c9288b$export$4fe327701f9709d0(rows, patient) {
    const next = $83fe649a23c9288b$var$sendable(rows);
    const was = $83fe649a23c9288b$var$sendable((0, $6SCJ6.phoneListRows)(patient?.phones));
    if (JSON.stringify(next.phones) === JSON.stringify(was.phones)) return null;
    return {
        phones: next.phones,
        phonesEtag: patient.phonesEtag,
        keys: next.keys
    };
}
function $83fe649a23c9288b$export$16994904a8dc04fb(t, has, err, fallbackKey) {
    const key = err?.extensions?.messageKey;
    if (key && typeof has === 'function' && has(key)) return t(key);
    const message = String(err?.message || '');
    return message || t(fallbackKey);
}
function $83fe649a23c9288b$export$4549b89e6821541a(err, keys) {
    const index = err?.extensions?.index;
    return Number.isInteger(index) && keys?.[index] != null ? keys[index] : null;
}
const $83fe649a23c9288b$export$f047f3a0cf7d9a90 = (err)=>err?.extensions?.code === 'PHONES_CHANGED';

});


parcelRegister("9ycDe", function(module, exports) {

$parcel$export(module.exports, "useDoctor", () => $6f41166a3447eed0$export$c33fab67557a8508);

var $acw62 = parcelRequire("acw62");

var $eVM84 = parcelRequire("eVM84");
// One query, not two. `Doctor.settings` used to be null and the AI section was
// fetched separately (and tolerated failing); it is a single field resolver over
// doctor-preference now, so every section arrives together or the query fails
// together — which is what the error state is for.
//
// `scheduling` and `insurance` are deliberately absent: neither is persisted
// (scheduling settings belong to the scheduling service) and neither is
// surfaced by the settings screen, so querying them only invited the UI to
// render values that no save could ever change.
const $6f41166a3447eed0$var$ME_QUERY = `
  query {
    me {
      id
      name
      firstName
      lastName
      nationalId
      gender
      birthDate
      medicalCode
      specialty
      phone
      email
      bio
      avatar
      settings {
        appearance {
          theme
          fontSize
          language
          fontFamily
        }
        visitLayout {
          recordSectionOrder
          recordSectionsHidden
          recordSectionsCollapsed
          workTabsHidden
          defaultWorkTab
          copilotTabsHidden
          defaultCopilotTab
        }
        notifications {
          smsNew
          smsReminder
          smsCancel
          emailSummary
          emailReport
          appNew
          appReminder
          appUrgent
        }
        security {
          otpEnabled
          biometricEnabled
        }
        aiAgent {
          interruptOnCritical
          interruptOnWarning
          spo2Threshold
          bpSystolicThreshold
          recommendationLogsEnabled
          autoDifferentialOnStart
          differentialPollingEnabled
          differentialPollIntervalSec
          liveHintsEnabled
          autoPrescriptionAssist
          reassessOnNoteEdit
          endVisitInteractionSweep
          speechEngine
          autoCompleteOnMonitoringStop
          autoConfirmProposals
          orderPickerShowClinic
          orderPickerShowFrequent
          orderPickerFrequentFirst
        }
      }
    }
  }
`;
const $6f41166a3447eed0$var$CHANGE_PASSWORD = `
  mutation($currentPassword: String!, $newPassword: String!) {
    changePassword(currentPassword: $currentPassword, newPassword: $newPassword)
  }
`;
// `image` is a JPEG/PNG data URI, or null to remove the current picture. The BFF
// stores the bytes and returns the URL it recorded in Keycloak.
const $6f41166a3447eed0$var$UPDATE_AVATAR = `
  mutation($image: String) {
    updateDoctorAvatar(image: $image) { id avatar }
  }
`;
const $6f41166a3447eed0$var$mutations = {
    profile: `
    mutation($input: DoctorProfileInput!) {
      updateDoctorProfile(input: $input) {
        id firstName lastName name nationalId gender birthDate medicalCode specialty phone email bio
      }
    }
  `,
    notifications: `
    mutation($input: NotificationSettingsInput!) {
      updateNotificationSettings(input: $input) { id }
    }
  `,
    appearance: `
    mutation($input: AppearanceSettingsInput!) {
      updateAppearanceSettings(input: $input) { id }
    }
  `,
    security: `
    mutation($input: SecuritySettingsInput!) {
      updateSecuritySettings(input: $input) { id }
    }
  `,
    aiAgent: `
    mutation($input: AIAgentSettingsInput!) {
      updateAIAgentSettings(input: $input) { id }
    }
  `,
    visitLayout: `
    mutation($input: VisitLayoutSettingsInput!) {
      updateVisitLayoutSettings(input: $input) { id }
    }
  `
};
function $6f41166a3447eed0$export$c33fab67557a8508() {
    const [doctor, setDoctor] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [saving, setSaving] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    const fetchDoctor = (0, $acw62.useCallback)(async ()=>{
        try {
            const data = await (0, $eVM84.bffQuery)($6f41166a3447eed0$var$ME_QUERY);
            setDoctor(data?.me ?? null);
            setError(null);
        } catch (err) {
            setError(err);
        }
    }, []);
    // Manual reload for a failed initial load — drives the ErrorState «تلاش مجدد».
    const refetch = (0, $acw62.useCallback)(()=>{
        setLoading(true);
        return fetchDoctor().finally(()=>setLoading(false));
    }, [
        fetchDoctor
    ]);
    (0, $acw62.useEffect)(()=>{
        let active = true;
        (0, $eVM84.bffQuery)($6f41166a3447eed0$var$ME_QUERY).then((data)=>{
            if (active) {
                setDoctor(data?.me ?? null);
                setError(null);
            }
        }).catch((err)=>{
            if (active) setError(err);
        }).finally(()=>{
            if (active) setLoading(false);
        });
        return ()=>{
            active = false;
        };
    }, []);
    const update = (0, $acw62.useCallback)((section, input)=>{
        setSaving(true);
        return (0, $eVM84.bffMutation)($6f41166a3447eed0$var$mutations[section], {
            input: input
        }).then(fetchDoctor).catch((err)=>{
            setError(err);
            throw err;
        }).finally(()=>setSaving(false));
    }, [
        fetchDoctor
    ]);
    // Note: does NOT toggle the shared `saving` flag (that drives the profile-save
    // button). The password form tracks its own local saving state.
    const changePassword = (0, $acw62.useCallback)((currentPassword, newPassword)=>{
        return (0, $eVM84.bffMutation)($6f41166a3447eed0$var$CHANGE_PASSWORD, {
            currentPassword: currentPassword,
            newPassword: newPassword
        }).then((res)=>res?.changePassword === true);
    }, []);
    // Upload (data URI) or remove (null) the profile picture. Patches the local
    // doctor rather than refetching: the server's response already carries the
    // authoritative URL, and a full refetch would flicker the whole form.
    //
    // Like changePassword, this keeps its own saving state out of `saving` so the
    // profile SaveBar doesn't react to an avatar upload.
    const updateAvatar = (0, $acw62.useCallback)((image)=>{
        return (0, $eVM84.bffMutation)($6f41166a3447eed0$var$UPDATE_AVATAR, {
            image: image ?? null
        }).then((res)=>{
            const next = res?.updateDoctorAvatar?.avatar ?? null;
            setDoctor((d)=>d ? {
                    ...d,
                    avatar: next
                } : d);
            return next;
        });
    }, []);
    return {
        doctor: doctor,
        loading: loading,
        saving: saving,
        error: error,
        update: update,
        changePassword: changePassword,
        updateAvatar: updateAvatar,
        refetch: refetch
    };
}

});

parcelRegister("7LBYc", function(module, exports) {

$parcel$export(module.exports, "useOptionalToast", () => $5a7a6039daa594b4$export$5476e2845fb28531);
parcelRequire("5N0ZI");
var $6usBW = parcelRequire("6usBW");
const $5a7a6039daa594b4$var$NOOP = {
    show () {},
    success () {},
    error () {},
    warn () {},
    info () {},
    dismiss () {}
};
function $5a7a6039daa594b4$export$5476e2845fb28531() {
    try {
        return (0, $6usBW.useToast)();
    } catch  {
        return $5a7a6039daa594b4$var$NOOP;
    }
}

});

parcelRegister("kyxc1", function(module, exports) {

$parcel$export(module.exports, "useCountryDefaults", () => $ef70bb10a45d7537$export$80c17785b45f4556);

var $acw62 = parcelRequire("acw62");

var $iIuoh = parcelRequire("iIuoh");

var $e317r = parcelRequire("e317r");
function $ef70bb10a45d7537$export$80c17785b45f4556() {
    const country = (0, $e317r.useCapability)('country');
    const nationalIdRule = (0, $e317r.useCapability)('nationalIdRule');
    const mapView = (0, $e317r.useCapability)('mapView');
    const addressModel = (0, $e317r.useCapability)('addressModel');
    return (0, $acw62.useMemo)(()=>(0, $iIuoh.countryDefaults)(country === undefined ? null : {
            country: country,
            nationalIdRule: nationalIdRule,
            mapView: mapView,
            addressModel: addressModel
        }), [
        country,
        nationalIdRule,
        mapView,
        addressModel
    ]);
}
var $ef70bb10a45d7537$export$2e2bcd8739ae039 = $ef70bb10a45d7537$export$80c17785b45f4556;

});

parcelRegister("cvBw3", function(module, exports) {

$parcel$export(module.exports, "allergyHit", () => $737671bfbc703ec9$export$7ec7358ec49034c8);
$parcel$export(module.exports, "default", () => $737671bfbc703ec9$export$2e2bcd8739ae039);
$parcel$export(module.exports, "applyMessage", () => $737671bfbc703ec9$export$9694ceada819b6a5);
// ─────────────────────────────────────────────────────────────────────────────
// «اعمال قالب» — the control that puts a template into the visit in front of
// the doctor.
//
// One component for both kinds and both surfaces. It is a button that opens a
// list of the doctor's templates for that kind; picking one shows its items
// with a tick beside each, and «افزودن» applies the ticked ones.
//
// The second step exists for one reason: the patient in the chair is not the
// patient the template was written for. A respiratory template holds the
// antihistamine this patient is allergic to, or the antibiotic they are already
// on, and the doctor needs to leave that line out BEFORE it is written, not
// delete it afterwards. Everything is ticked by default, so the common case is
// still two clicks; a recorded allergy starts unticked and says why.
//
// What it deliberately does NOT do is decide what applying MEANS: it calls the
// apply mutation and hands the created visit rows to its parent. The rule that
// applying copies — that the visit gets its own editable rows — lives in the
// BFF, where it holds for every surface, not in whichever screen mounted this.
//
// The picker also states, every time it is open, that applied items stay
// editable and never write back to the template. That sentence is the whole
// mental model, and it belongs where the decision is being made.
//
// ── Two surfaces, two overlays ───────────────────────────────────────────────
// DESKTOP is a popover, rendered through a portal and fixed to the viewport
// rather than absolutely inside the card. The visit page's work column is
// `overflow: hidden` and sits between two side panels, so anything positioned
// inside it is cut off at the column edge — which on screen reads as the
// popover sliding under «پروندهٔ بیمار». A portal escapes the column; the
// position is recomputed from the trigger on scroll and resize so it stays
// attached.
//
// PHONE is a `BottomSheet` — the kit's default overlay for every mobile filter,
// form and picker (DESIGN-CONCEPT-MOBILE §6). It used to get the desktop
// popover, and that was wrong twice over: a 380px-tall list anchored under a
// button two thirds of the way down a scrolling tab has ~160px left to render
// into, and the panel had no colour at all — see the palette note below. The
// sheet also brings the things a phone overlay owes the doctor and a popover
// cannot: a scrim, `dvh` sizing, a focus trap, a body scroll lock, the keyboard
// inset, and hardware-back closing the picker instead of leaving the visit.
//
// ── Why it reads tokens and not the workspace's CSS variables ────────────────
// `Visit.web.jsx` injects the `:root` block that defines `--panel-2`, `--ink`
// and friends; `Visit.mobile.jsx` deliberately injects none of it (its screens
// speak the unified design language rather than the workspace's warm-beige
// sub-theme). An unresolved custom property is not a fallback to something
// sensible — `background: var(--panel-2)` is simply dropped — so the picker
// rendered as transparent text floating over the نسخه list.
//
// A var() fallback is NOT the fix, and finding out why is the reason this note
// exists: `--accent` is already defined globally by the framework's token
// sheet, as the shadcn HSL triple `207 66% 95%`. `var(--accent, …)` therefore
// resolves — to a value that is not a colour, which computes to transparent.
// The fallback would have looked right in review and shipped an invisible
// «افزودن» button.
//
// So every value comes straight from the framework token module. The `:root`
// block derives ITS values from those same tokens, so the desktop surface is
// unchanged, and the component is now correct anywhere it is mounted — inside
// the workspace, on the phone, or portaled out of both. `closure/tokens.js`
// records the same lesson for the closure screens.
// ─────────────────────────────────────────────────────────────────────────────

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
parcelRequire("5N0ZI");
var $cZOyb = parcelRequire("cZOyb");
var $66joL = parcelRequire("66joL");
var $k27hS = parcelRequire("k27hS");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $eVM84 = parcelRequire("eVM84");

var $c9qmv = parcelRequire("c9qmv");

var $lb6CL = parcelRequire("lb6CL");

var $85jFj = parcelRequire("85jFj");

var $lfHhF = parcelRequire("lfHhF");

var $gq4TR = parcelRequire("gq4TR");
// An applied template's lines come back with their «در فهرست تأمین»
// (taminListed) — asked without it of a BFF that predates it.
const $737671bfbc703ec9$var$applyTemplate = (0, $c9qmv.askWithoutTaminWhenRefused)((0, $eVM84.bffMutation));
const $737671bfbc703ec9$var$norm = (s)=>(s || '').toString().trim().toLowerCase();
// The same values the `:root` block computes to, read from their source.
const $737671bfbc703ec9$var$PAL = {
    panel: (0, $jTCZr.CT).surface,
    panel2: (0, $jTCZr.CT).surface,
    line: (0, $jTCZr.CT).border,
    line2: (0, $jTCZr.CT).border2,
    ink: (0, $jTCZr.CT).ink,
    ink2: (0, $jTCZr.CT).ink2,
    mute: (0, $jTCZr.CT).mute,
    mute2: (0, $jTCZr.CT).mute2,
    accent: (0, $jTCZr.CT).accent,
    accentInk: (0, $jTCZr.CT).accentInk,
    dangerSoft: (0, $jTCZr.CT).dangerSoft,
    dangerInk: (0, $jTCZr.CT).dangerInk,
    shadowPop: '0 8px 28px rgba(15,23,42,.10), 0 2px 6px rgba(15,23,42,.06)'
};
// One vocabulary of sizes per surface. The desktop numbers are the ones this
// popover has always used; the phone column is `rem` and sized for a thumb —
// §6 puts the floor for a tap target at 2.75rem and forbids px type.
const $737671bfbc703ec9$var$SIZES = {
    web: {
        title: '0.78125rem',
        body: '0.78125rem',
        meta: '0.65625rem',
        note: '0.65625rem',
        hint: '0.6875rem',
        action: '0.71875rem',
        chevron: '14px',
        cardPad: '8px 9px',
        itemPad: '6px 6px',
        itemGap: '2px',
        radius: 8,
        checkbox: undefined,
        minTap: undefined
    },
    mobile: {
        title: '0.9375rem',
        body: '0.875rem',
        meta: '0.75rem',
        note: '0.75rem',
        hint: '0.8125rem',
        action: '0.875rem',
        chevron: '1.25rem',
        cardPad: '0.75rem 0.875rem',
        itemPad: '0.625rem 0.5rem',
        itemGap: '0.25rem',
        radius: 10,
        checkbox: '1.125rem',
        minTap: '2.75rem'
    }
};
// Popover geometry (desktop only). z-index sits above the page's sticky headers
// (2) and the side panels, and below its modals (1100+), so a confirm dialog
// opened from elsewhere still covers it.
const $737671bfbc703ec9$var$POP_WIDTH = 340;
const $737671bfbc703ec9$var$POP_MAX_HEIGHT = 380;
const $737671bfbc703ec9$var$POP_GAP = 8;
const $737671bfbc703ec9$var$POP_Z = 1000;
function $737671bfbc703ec9$export$7ec7358ec49034c8(item, allergies) {
    const names = [
        $737671bfbc703ec9$var$norm(item?.name),
        $737671bfbc703ec9$var$norm(item?.genericName)
    ].filter(Boolean);
    for (const a of allergies || []){
        const al = $737671bfbc703ec9$var$norm(a);
        if (al.length < 3) continue;
        if (names.some((n)=>n.includes(al) || al.includes(n))) return a;
    }
    return null;
}
const $737671bfbc703ec9$var$itemSummary = (kind, item, t)=>{
    if (kind === 'order') return [
        item.orderType && (0, $gq4TR.ORDER_TYPE_KEYS)[item.orderType] && t((0, $gq4TR.ORDER_TYPE_KEYS)[item.orderType]),
        item.code
    ].filter(Boolean).join(" \xb7 ");
    return [
        item.dosage,
        item.frequency && (0, $lfHhF.drugFrequencyLabel)(item.frequency, t),
        item.duration
    ].filter(Boolean).join(" \xb7 ");
};
function $737671bfbc703ec9$export$2e2bcd8739ae039({ kind: kind, appointmentId: appointmentId, patientId: patientId, onApplied: onApplied, compact: compact = false, disabled: disabled = false, allergies: allergies = [], existingDrugIds: existingDrugIds = [] }) {
    const { t: t, formatNumber: formatNumber, isRTL: isRTL } = (0, $LNQP4.default)();
    const { isMobile: isMobile } = (0, $k27hS.default)();
    const S = isMobile ? $737671bfbc703ec9$var$SIZES.mobile : $737671bfbc703ec9$var$SIZES.web;
    const meta = (0, $85jFj.TEMPLATE_KIND_META)[kind];
    const ready = Boolean(appointmentId && patientId) && !disabled;
    const [open, setOpen] = (0, $acw62.useState)(false);
    const [picked, setPicked] = (0, $acw62.useState)(null); // the template being previewed
    const [selected, setSelected] = (0, $acw62.useState)(new Set());
    const [applying, setApplying] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    const rootRef = (0, $acw62.useRef)(null); // the trigger
    const popRef = (0, $acw62.useRef)(null); // the portalled list
    const [pos, setPos] = (0, $acw62.useState)(null);
    // Templates are fetched only once the doctor asks for them: this control sits
    // on a screen that is already making a dozen calls at open, and a list nobody
    // opened is a call nobody needed.
    const store = (0, $lb6CL.useVisitTemplates)(kind, {
        enabled: open
    });
    const close = (0, $acw62.useCallback)(()=>{
        setOpen(false);
        setPicked(null);
        setError(null);
    }, []);
    // Where the list goes: under the trigger, its inline-end edge on the
    // trigger's inline-end edge, kept inside the viewport. Measured on open and
    // again whenever anything scrolls or the window resizes, because a fixed
    // element does not move with the card it belongs to.
    //
    // Desktop only — the sheet is laid out by the viewport, not by the trigger.
    (0, $acw62.useLayoutEffect)(()=>{
        if (!open || isMobile) {
            setPos(null);
            return undefined;
        }
        const measure = ()=>{
            const r = rootRef.current?.getBoundingClientRect();
            if (!r) return;
            const vw = window.innerWidth || 0;
            const vh = window.innerHeight || 0;
            const width = compact ? Math.max(r.width, 240) : $737671bfbc703ec9$var$POP_WIDTH;
            let left = isRTL ? r.left : r.right - width;
            if (vw) left = Math.max($737671bfbc703ec9$var$POP_GAP, Math.min(left, vw - width - $737671bfbc703ec9$var$POP_GAP));
            const top = r.bottom + 6;
            const maxHeight = vh ? Math.max(160, Math.min($737671bfbc703ec9$var$POP_MAX_HEIGHT, vh - top - $737671bfbc703ec9$var$POP_GAP)) : $737671bfbc703ec9$var$POP_MAX_HEIGHT;
            setPos({
                top: top,
                left: left,
                width: width,
                maxHeight: maxHeight
            });
        };
        measure();
        window.addEventListener('resize', measure);
        document.addEventListener('scroll', measure, true);
        return ()=>{
            window.removeEventListener('resize', measure);
            document.removeEventListener('scroll', measure, true);
        };
    }, [
        open,
        isMobile,
        compact,
        isRTL
    ]);
    // Clicking away closes the list, the way every other popover on this screen
    // behaves. Esc steps back before it closes. Bound only while open. The list
    // lives outside the trigger's subtree (portal), so both are checked.
    //
    // Desktop only. The sheet owns Esc, the scrim tap and the back button itself,
    // and everything inside it is outside both refs — this listener would close
    // the sheet on the first tap on a template.
    (0, $acw62.useEffect)(()=>{
        if (!open || isMobile) return undefined;
        const onDocDown = (e)=>{
            const inTrigger = rootRef.current?.contains(e.target);
            const inPop = popRef.current?.contains(e.target);
            if (!inTrigger && !inPop) close();
        };
        const onEsc = (e)=>{
            if (e.key !== 'Escape') return;
            if (picked) setPicked(null);
            else close();
        };
        document.addEventListener('mousedown', onDocDown);
        document.addEventListener('keydown', onEsc);
        return ()=>{
            document.removeEventListener('mousedown', onDocDown);
            document.removeEventListener('keydown', onEsc);
        };
    }, [
        open,
        isMobile,
        picked,
        close
    ]);
    const existing = (0, $acw62.useMemo)(()=>new Set((existingDrugIds || []).filter(Boolean)), [
        existingDrugIds
    ]);
    const apply = (0, $acw62.useCallback)(async (template, indexes)=>{
        if (!ready) return;
        setApplying(true);
        setError(null);
        try {
            const variables = {
                templateId: template.id,
                appointmentId: appointmentId,
                patientId: patientId
            };
            // Sent only when the doctor left something out: a full apply is the
            // same request it always was.
            if (indexes) variables.itemIndexes = indexes;
            const data = await $737671bfbc703ec9$var$applyTemplate(meta.applyMutation, variables);
            const result = data?.[meta.applyField];
            if (!result) throw new Error(t('visit.templates.failed'));
            onApplied?.(result, (0, $85jFj.applyOutcome)(result));
            close();
        } catch (err) {
            // Kept ON the picker rather than raised as a toast: the doctor is still
            // looking at the list and the next thing they want is to try again or
            // pick another one.
            setError(err?.message || t('visit.templates.failed'));
        } finally{
            setApplying(false);
        }
    }, [
        ready,
        meta.applyMutation,
        meta.applyField,
        appointmentId,
        patientId,
        onApplied,
        t,
        close
    ]);
    // Picking a template opens its items for review. An empty template has
    // nothing to review and applies straight away — a defined no-op that the
    // toast reports as such.
    const pick = (0, $acw62.useCallback)((template)=>{
        const items = template.items || [];
        if (items.length === 0) {
            apply(template, null);
            return;
        }
        const ticked = new Set();
        items.forEach((item, i)=>{
            if (kind === 'medication' && $737671bfbc703ec9$export$7ec7358ec49034c8(item, allergies)) return;
            ticked.add(i);
        });
        setSelected(ticked);
        setPicked(template);
        setError(null);
    }, [
        apply,
        kind,
        allergies
    ]);
    const toggle = (i)=>setSelected((prev)=>{
            const next = new Set(prev);
            if (next.has(i)) next.delete(i);
            else next.add(i);
            return next;
        });
    const confirm = ()=>{
        if (!picked) return;
        const items = picked.items || [];
        const all = selected.size === items.length;
        apply(picked, all ? null : [
            ...selected
        ].sort((a, b)=>a - b));
    };
    const label = kind === 'order' ? t('visit.templates.applyOrders') : t('visit.templates.applyRx');
    const triggerStyle = compact ? {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '0.375rem',
        width: '100%',
        minHeight: isMobile ? '2.75rem' : undefined,
        padding: isMobile ? '0.625rem 0.75rem' : '10px 12px',
        borderRadius: 10,
        border: `1px dashed ${$737671bfbc703ec9$var$PAL.line}`,
        background: isMobile ? $737671bfbc703ec9$var$PAL.panel : 'transparent',
        color: $737671bfbc703ec9$var$PAL.ink2,
        fontSize: isMobile ? '0.8125rem' : '0.78125rem',
        fontWeight: 600,
        fontFamily: 'inherit',
        cursor: ready ? 'pointer' : 'not-allowed',
        opacity: ready ? 1 : 0.55
    } : {
        display: 'flex',
        alignItems: 'center',
        gap: 5,
        padding: '5px 11px',
        borderRadius: 7,
        border: `1px solid ${$737671bfbc703ec9$var$PAL.line}`,
        background: $737671bfbc703ec9$var$PAL.panel2,
        color: $737671bfbc703ec9$var$PAL.ink2,
        fontSize: '0.71875rem',
        fontWeight: 600,
        fontFamily: 'inherit',
        cursor: ready ? 'pointer' : 'not-allowed',
        opacity: ready ? 1 : 0.55
    };
    const smallLink = {
        background: 'none',
        border: 0,
        padding: 0,
        fontFamily: 'inherit',
        fontSize: S.hint,
        fontWeight: 700,
        color: $737671bfbc703ec9$var$PAL.accentInk,
        cursor: 'pointer'
    };
    // The one sentence that carries the whole mental model. Rendered above
    // whichever step is showing, on both surfaces.
    const renderNote = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: S.note,
                color: $737671bfbc703ec9$var$PAL.mute,
                lineHeight: 1.7,
                padding: isMobile ? '0 0 0.625rem' : '2px 4px 6px',
                borderBottom: `1px solid ${$737671bfbc703ec9$var$PAL.line2}`,
                marginBottom: isMobile ? '0.625rem' : 6
            }
        }, t('visit.templates.editable'));
    const renderError = ()=>error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            role: "alert",
            "data-testid": `visit-template-error-${kind}`,
            style: {
                marginTop: isMobile ? '0.625rem' : 6,
                padding: isMobile ? '0.625rem 0.75rem' : '6px 8px',
                borderRadius: 7,
                background: $737671bfbc703ec9$var$PAL.dangerSoft,
                color: $737671bfbc703ec9$var$PAL.dangerInk,
                fontSize: S.action,
                fontWeight: 600
            }
        }, error) : null;
    const renderList = ()=>store.loading && !store.loaded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                padding: isMobile ? '0.75rem 0' : '4px 0'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonList), {
            count: 2,
            avatar: false,
            trailing: 0,
            label: t('common.state.loading')
        })) : store.templates.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": `visit-template-empty-${kind}`,
            style: {
                padding: isMobile ? '0.75rem 0' : '10px 6px',
                fontSize: S.body,
                color: $737671bfbc703ec9$var$PAL.mute,
                lineHeight: 1.8
            }
        }, t('visit.templates.none'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: S.meta,
                color: $737671bfbc703ec9$var$PAL.mute2,
                marginTop: 2
            }
        }, t('visit.templates.manage'))) : store.templates.map((template)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                key: template.id,
                type: "button",
                role: "option",
                "aria-selected": false,
                disabled: applying,
                onClick: ()=>pick(template),
                "data-testid": `visit-template-pick-${kind}`,
                "data-template-id": template.id,
                style: {
                    display: 'block',
                    width: '100%',
                    textAlign: 'start',
                    minHeight: S.minTap,
                    padding: S.cardPad,
                    marginBottom: isMobile ? '0.5rem' : 4,
                    borderRadius: S.radius,
                    border: `1px solid ${$737671bfbc703ec9$var$PAL.line}`,
                    background: $737671bfbc703ec9$var$PAL.panel,
                    cursor: applying ? 'wait' : 'pointer',
                    fontFamily: 'inherit'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    fontSize: S.title,
                    fontWeight: 700,
                    color: $737671bfbc703ec9$var$PAL.ink
                }
            }, template.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    fontSize: S.meta,
                    color: $737671bfbc703ec9$var$PAL.mute,
                    marginTop: 2
                }
            }, (0, $85jFj.templateItemCount)(template) ? t('settings.templates.itemCount', {
                count: (0, $85jFj.templateItemCount)(template)
            }) : t('settings.templates.noItems'), template.description ? ` \xb7 ${template.description}` : '')));
    // The commit row. Docked in the sheet's footer on a phone — §6 says a submit
    // docks to the bottom edge, and the body here is a scroll region, so a button
    // placed in it scrolls away exactly when the doctor reaches for it.
    const renderCommit = ()=>{
        const count = selected.size;
        const applyLabel = kind === 'order' ? t('visit.templates.applySelectedOrders', {
            count: count
        }) : t('visit.templates.applySelected', {
            count: count
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.375rem',
                paddingTop: isMobile ? 0 : 6,
                borderTop: isMobile ? 'none' : `1px solid ${$737671bfbc703ec9$var$PAL.line2}`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            type: "button",
            onClick: close,
            style: {
                ...smallLink,
                color: $737671bfbc703ec9$var$PAL.ink2,
                fontSize: S.action,
                minHeight: S.minTap,
                padding: isMobile ? '0 0.875rem' : '6px 8px'
            }
        }, t('common.actions.cancel')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                flex: 1
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            type: "button",
            onClick: confirm,
            disabled: applying || count === 0,
            "data-testid": `visit-template-apply-${kind}`,
            style: {
                minHeight: S.minTap,
                padding: isMobile ? '0 1.25rem' : '6px 12px',
                borderRadius: isMobile ? 10 : 7,
                border: 0,
                fontFamily: 'inherit',
                background: $737671bfbc703ec9$var$PAL.accent,
                color: '#fff',
                fontSize: S.action,
                fontWeight: 700,
                cursor: applying || count === 0 ? 'not-allowed' : 'pointer',
                opacity: applying || count === 0 ? 0.55 : 1
            }
        }, applying ? t('visit.templates.applying') : applyLabel));
    };
    const renderPreview = ({ commit: commit })=>{
        const items = picked.items || [];
        const count = selected.size;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": `visit-template-preview-${kind}`,
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: 6
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 6
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            type: "button",
            onClick: ()=>setPicked(null),
            "aria-label": t('visit.templates.back'),
            "data-testid": `visit-template-back-${kind}`,
            style: {
                ...smallLink,
                color: $737671bfbc703ec9$var$PAL.ink2,
                fontSize: S.chevron,
                lineHeight: 1,
                minWidth: S.minTap,
                minHeight: S.minTap,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: isMobile ? 0 : '0 4px',
                // The chevron points back along the reading direction, so it is
                // one of the few glyphs that must mirror with the layout.
                transform: 'scaleX(var(--dir-flip, 1))'
            }
        }, "\u2039"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: S.title,
                fontWeight: 700,
                color: $737671bfbc703ec9$var$PAL.ink,
                flex: 1,
                minWidth: 0
            }
        }, picked.title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                fontSize: S.hint,
                color: $737671bfbc703ec9$var$PAL.mute,
                padding: isMobile ? '0 0 0.5rem' : '4px 4px 6px',
                borderBottom: `1px solid ${$737671bfbc703ec9$var$PAL.line2}`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            type: "button",
            style: smallLink,
            onClick: ()=>setSelected(new Set(items.map((_, i)=>i))),
            "data-testid": `visit-template-select-all-${kind}`
        }, t('visit.templates.selectAll')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, "\xb7"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            type: "button",
            style: smallLink,
            onClick: ()=>setSelected(new Set()),
            "data-testid": `visit-template-select-none-${kind}`
        }, t('visit.templates.selectNone')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                flex: 1
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, t('visit.templates.selectedOf', {
            selected: formatNumber(count),
            total: formatNumber(items.length)
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            role: "group",
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: S.itemGap
            }
        }, items.map((item, i)=>{
            const checked = selected.has(i);
            const allergy = kind === 'medication' ? $737671bfbc703ec9$export$7ec7358ec49034c8(item, allergies) : null;
            const already = kind === 'medication' && item.drugId && existing.has(item.drugId);
            const summary = $737671bfbc703ec9$var$itemSummary(kind, item, t);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
                key: i,
                "data-testid": "visit-template-item",
                "data-index": i,
                "data-checked": checked ? 'true' : 'false',
                style: {
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: 8,
                    padding: S.itemPad,
                    minHeight: S.minTap,
                    borderRadius: 7,
                    cursor: 'pointer',
                    background: allergy && !checked ? $737671bfbc703ec9$var$PAL.dangerSoft : 'transparent'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
                type: "checkbox",
                checked: checked,
                onChange: ()=>toggle(i),
                style: {
                    marginTop: 3,
                    accentColor: $737671bfbc703ec9$var$PAL.accent,
                    width: S.checkbox,
                    height: S.checkbox,
                    flexShrink: 0
                }
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    flex: 1,
                    minWidth: 0
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'flex',
                    alignItems: 'baseline',
                    gap: 6,
                    flexWrap: 'wrap'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    fontSize: S.body,
                    fontWeight: 600,
                    color: checked ? $737671bfbc703ec9$var$PAL.ink : $737671bfbc703ec9$var$PAL.mute
                }
            }, item.name), summary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    fontSize: S.meta,
                    color: $737671bfbc703ec9$var$PAL.mute
                }
            }, summary)), allergy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                "data-testid": "visit-template-allergy-hit",
                style: {
                    fontSize: S.meta,
                    fontWeight: 700,
                    color: $737671bfbc703ec9$var$PAL.dangerInk,
                    marginTop: 2
                }
            }, t('visit.templates.allergyHit', {
                substance: allergy
            })), already && !allergy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                "data-testid": "visit-template-already-in-rx",
                style: {
                    fontSize: S.meta,
                    color: $737671bfbc703ec9$var$PAL.accentInk,
                    marginTop: 2
                }
            }, t('visit.templates.alreadyInRx'))));
        })), commit ? renderCommit() : null);
    };
    const body = (commit)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, renderNote(), picked ? renderPreview({
            commit: commit
        }) : renderList(), renderError());
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: rootRef,
        style: {
            position: 'relative',
            ...compact ? {
                width: '100%'
            } : null
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: ()=>open ? close() : setOpen(true),
        disabled: !ready,
        title: ready ? undefined : t('visit.templates.needsVisit'),
        "data-testid": `visit-template-open-${kind}`,
        "aria-haspopup": isMobile ? 'dialog' : 'listbox',
        "aria-expanded": open,
        style: triggerStyle
    }, label), isMobile ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: open,
        onClose: close,
        title: label,
        closeLabel: t('common.actions.close'),
        // Deliberately NOT `fullHeight`: the sheet hugs what it holds and the
        // cap does the rest, so three drugs are a short sheet and fifteen are
        // a scroll region — either way the commit row is docked at the bottom
        // edge. `fullHeight` would put a screen of white space under a
        // three-item template.
        snap: 0.9,
        "data-testid": `visit-template-sheet-${kind}`,
        footer: picked ? renderCommit() : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `visit-template-list-${kind}`
    }, body(false))) : open && pos && /*#__PURE__*/ (0, $1u0KT.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: popRef,
        role: "listbox",
        dir: isRTL ? 'rtl' : 'ltr',
        "data-testid": `visit-template-list-${kind}`,
        style: {
            position: 'fixed',
            top: pos.top,
            left: pos.left,
            width: pos.width,
            maxHeight: pos.maxHeight,
            overflowY: 'auto',
            zIndex: $737671bfbc703ec9$var$POP_Z,
            background: $737671bfbc703ec9$var$PAL.panel2,
            border: `1px solid ${$737671bfbc703ec9$var$PAL.line}`,
            borderRadius: 10,
            boxShadow: $737671bfbc703ec9$var$PAL.shadowPop,
            padding: 8,
            // Portaled to document.body, so `inherit` would miss the app face.
            fontFamily: 'var(--app-font)'
        }
    }, body(true)), document.body));
}
function $737671bfbc703ec9$export$9694ceada819b6a5(kind, result, outcome, t, formatList) {
    const title = result?.templateTitle || '';
    if (outcome.kind === 'none') return t('visit.templates.appliedNone', {
        title: title
    });
    const countKey = kind === 'order' ? 'visit.templates.appliedOrders' : 'visit.templates.appliedRx';
    const main = t(countKey, {
        count: outcome.applied,
        title: title
    });
    if (outcome.kind === 'partial') return `${main} \u{2014} ${t('visit.templates.partial', {
        items: formatList(outcome.failed)
    })}`;
    return main;
}

});
parcelRegister("c9qmv", function(module, exports) {

$parcel$export(module.exports, "schemaGap", () => $8d8ac6402cc7b03c$export$1bc1491196b005d5);
$parcel$export(module.exports, "askWithoutTaminWhenRefused", () => $8d8ac6402cc7b03c$export$405a623d7e907e9d);
$parcel$export(module.exports, "askWithoutWhenRefused", () => $8d8ac6402cc7b03c$export$860b5f02479b2639);

var $eVM84 = parcelRequire("eVM84");
const $8d8ac6402cc7b03c$export$1bc1491196b005d5 = (e)=>e?.extensions?.code === 'GRAPHQL_VALIDATION_FAILED' || /Cannot query field|Unknown argument|Unknown type/.test(String(e?.message || ''));
const $8d8ac6402cc7b03c$export$c6116461efe42e05 = (q)=>q.replace(/\s+taminListed\b/g, '');
function $8d8ac6402cc7b03c$export$405a623d7e907e9d(send = (0, $eVM84.bffQuery)) {
    return $8d8ac6402cc7b03c$export$860b5f02479b2639(send, $8d8ac6402cc7b03c$export$c6116461efe42e05);
}
function $8d8ac6402cc7b03c$export$860b5f02479b2639(send, strip) {
    let refused = false;
    return async (full, vars, ...rest)=>{
        const old = strip(full);
        if (old === full) return send(full, vars, ...rest);
        if (refused) return send(old, vars, ...rest);
        try {
            return await send(full, vars, ...rest);
        } catch (e) {
            if (!$8d8ac6402cc7b03c$export$1bc1491196b005d5(e)) throw e;
            refused = true;
            return send(old, vars, ...rest);
        }
    };
}

});

parcelRegister("lb6CL", function(module, exports) {

$parcel$export(module.exports, "useVisitTemplates", () => $f6afc37e3d3310be$export$a282db6c512184e6);

var $acw62 = parcelRequire("acw62");

var $eVM84 = parcelRequire("eVM84");

var $85jFj = parcelRequire("85jFj");
function $f6afc37e3d3310be$export$a282db6c512184e6(kind, { enabled: enabled = true } = {}) {
    const meta = (0, $85jFj.TEMPLATE_KIND_META)[kind];
    if (!meta) throw new Error(`unknown template kind: ${kind}`);
    const [templates, setTemplates] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(enabled);
    const [error, setError] = (0, $acw62.useState)(null);
    // Distinguishes "no templates yet" from "we have not looked" — an empty list
    // is a real answer and the empty state may only be shown once it is one.
    const [loaded, setLoaded] = (0, $acw62.useState)(false);
    const reload = (0, $acw62.useCallback)(async ()=>{
        if (!enabled) return [];
        setLoading(true);
        try {
            const data = await (0, $eVM84.bffQuery)(meta.listQuery);
            const rows = data?.[meta.listField] || [];
            setTemplates(rows);
            setError(null);
            setLoaded(true);
            return rows;
        } catch (err) {
            // The previous list is left standing: a failed refetch is not evidence
            // that the doctor's templates are gone.
            setError(err);
            return null;
        } finally{
            setLoading(false);
        }
    }, [
        enabled,
        meta.listQuery,
        meta.listField
    ]);
    (0, $acw62.useEffect)(()=>{
        reload();
    }, [
        reload
    ]);
    // Writes deliberately do NOT swallow their errors — the editor shows what
    // went wrong beside the form, which it can only do if it is told.
    const create = (0, $acw62.useCallback)(async (draft)=>{
        const data = await (0, $eVM84.bffMutation)(meta.addMutation, {
            input: (0, $85jFj.draftToInput)(kind, draft)
        });
        await reload();
        return data?.[meta.addField] || null;
    }, [
        kind,
        meta.addMutation,
        meta.addField,
        reload
    ]);
    const update = (0, $acw62.useCallback)(async (id, draft)=>{
        const data = await (0, $eVM84.bffMutation)(meta.updateMutation, {
            id: id,
            input: (0, $85jFj.draftToInput)(kind, draft)
        });
        await reload();
        return data?.[meta.updateField] || null;
    }, [
        kind,
        meta.updateMutation,
        meta.updateField,
        reload
    ]);
    const duplicate = (0, $acw62.useCallback)(async (id)=>{
        const data = await (0, $eVM84.bffMutation)(meta.duplicateMutation, {
            id: id
        });
        await reload();
        return data?.[meta.duplicateField] || null;
    }, [
        meta.duplicateMutation,
        meta.duplicateField,
        reload
    ]);
    const remove = (0, $acw62.useCallback)(async (id)=>{
        const data = await (0, $eVM84.bffMutation)(meta.deleteMutation, {
            id: id
        });
        await reload();
        return Boolean(data?.[meta.deleteField]);
    }, [
        meta.deleteMutation,
        meta.deleteField,
        reload
    ]);
    return {
        kind: kind,
        meta: meta,
        templates: templates,
        loading: loading,
        loaded: loaded,
        error: error,
        reload: reload,
        create: create,
        update: update,
        duplicate: duplicate,
        remove: remove
    };
}

});
parcelRegister("85jFj", function(module, exports) {

$parcel$export(module.exports, "LIST_VISIT_MEDICATIONS", () => $5e2e0b7ea22d1ff2$export$46ab2989285eb791);
$parcel$export(module.exports, "TEMPLATE_KIND_META", () => $5e2e0b7ea22d1ff2$export$a2d52108c6de7f27);
$parcel$export(module.exports, "draftToInput", () => $5e2e0b7ea22d1ff2$export$d2a97effe7dc2dbb);
$parcel$export(module.exports, "templateItemCount", () => $5e2e0b7ea22d1ff2$export$888087f3fb9d1ec2);
$parcel$export(module.exports, "erxGroupOf", () => $5e2e0b7ea22d1ff2$export$1f6fcfebcbb7f81d);
$parcel$export(module.exports, "rxItemFromMedication", () => $5e2e0b7ea22d1ff2$export$e3d3f4d836a186b1);
$parcel$export(module.exports, "refillSourceFromMedication", () => $5e2e0b7ea22d1ff2$export$aac88d3c48aba92);
$parcel$export(module.exports, "medicationMetaFromDrug", () => $5e2e0b7ea22d1ff2$export$2fe3f622dc680493);
$parcel$export(module.exports, "dosageInstructionFromRxItem", () => $5e2e0b7ea22d1ff2$export$1ed13c90275604ad);
$parcel$export(module.exports, "mergeRxItems", () => $5e2e0b7ea22d1ff2$export$801d163b2e9340ef);
$parcel$export(module.exports, "mergeOrders", () => $5e2e0b7ea22d1ff2$export$3c2b35db6130bf21);
$parcel$export(module.exports, "applyOutcome", () => $5e2e0b7ea22d1ff2$export$89fd35b67bcc0da1);
// ─────────────────────────────────────────────────────────────────────────────
// Visit templates — the one place the client agrees with itself about what a
// template is.
//
// Two doctor-owned, named, ORDERED sets, assembled once in «تنظیمات ← قالب‌ها»
// and applied during a visit:
//
//   medication  «قالب نسخه»     — a set of drugs with their dosing
//   order       «قالب دستورات»  — a set of labs / imaging / procedures
//
// Four surfaces touch them (Settings desktop, Settings mobile, Visit desktop,
// Visit mobile) and none of them may disagree about the item shape, the
// validation rules, or what applying one does. All of that non-visual truth is
// here; markup belongs to whichever surface renders it.
//
// It holds no TEXT either. Every user-facing string is a translation KEY,
// resolved by the renderer — a literal here would be one language, and a plain
// module cannot call a hook.
//
// The rules below MIRROR app/domain/models.py in the doctorpreference service.
// They exist so the editor can tell the doctor what is wrong before a round
// trip, never so the client can decide policy: the service validates again and
// its answer is the one that counts.
// ─────────────────────────────────────────────────────────────────────────────

var $g6gAc = parcelRequire("g6gAc");

var $eQiuG = parcelRequire("eQiuG");
const $5e2e0b7ea22d1ff2$export$dc458b2904e4b01a = 50;
const $5e2e0b7ea22d1ff2$export$14e010b4b1ab287e = 120;
const $5e2e0b7ea22d1ff2$export$fb3297c0e60769da = 500;
const $5e2e0b7ea22d1ff2$export$5f711b58035cee0 = 200;
const $5e2e0b7ea22d1ff2$export$b835574315bb6fe = [
    'medication',
    'order'
];
const $5e2e0b7ea22d1ff2$export$7fe249ad93dcc233 = [
    'lab',
    'imaging',
    'procedure',
    'other'
];
const $5e2e0b7ea22d1ff2$export$c9b31a4acc93d37d = [
    'routine',
    'urgent',
    'stat'
];
// ── GraphQL ──────────────────────────────────────────────────────────────────
const $5e2e0b7ea22d1ff2$var$MED_ITEM_FIELDS = 'drugId name genericName dosage frequency route duration quantity instructions';
const $5e2e0b7ea22d1ff2$var$ORD_ITEM_FIELDS = 'orderType name catalogId code urgency notes sessionCount';
const $5e2e0b7ea22d1ff2$var$MED_FIELDS = `id title description updatedAt items { ${$5e2e0b7ea22d1ff2$var$MED_ITEM_FIELDS} }`;
const $5e2e0b7ea22d1ff2$var$ORD_FIELDS = `id title description updatedAt items { ${$5e2e0b7ea22d1ff2$var$ORD_ITEM_FIELDS} }`;
const $5e2e0b7ea22d1ff2$export$ec65b30d180d4ef = `query MedicationTemplates{medicationTemplates{${$5e2e0b7ea22d1ff2$var$MED_FIELDS}}}`;
const $5e2e0b7ea22d1ff2$export$95d049bf5f64bb7d = `query OrderTemplates{orderTemplates{${$5e2e0b7ea22d1ff2$var$ORD_FIELDS}}}`;
const $5e2e0b7ea22d1ff2$export$e16fea1a0a21b540 = `mutation AddMedicationTemplate($input:MedicationTemplateInput!){addMedicationTemplate(input:$input){${$5e2e0b7ea22d1ff2$var$MED_FIELDS}}}`;
const $5e2e0b7ea22d1ff2$export$863f702bf73a955d = `mutation UpdateMedicationTemplate($id:ID!,$input:MedicationTemplateInput!){updateMedicationTemplate(id:$id,input:$input){${$5e2e0b7ea22d1ff2$var$MED_FIELDS}}}`;
const $5e2e0b7ea22d1ff2$export$c4e9fb414738a0b0 = `mutation DuplicateMedicationTemplate($id:ID!){duplicateMedicationTemplate(id:$id){${$5e2e0b7ea22d1ff2$var$MED_FIELDS}}}`;
const $5e2e0b7ea22d1ff2$export$6228a01070183d6d = `mutation DeleteMedicationTemplate($id:ID!){deleteMedicationTemplate(id:$id)}`;
const $5e2e0b7ea22d1ff2$export$75fee887852c226f = `mutation AddOrderTemplate($input:OrderTemplateInput!){addOrderTemplate(input:$input){${$5e2e0b7ea22d1ff2$var$ORD_FIELDS}}}`;
const $5e2e0b7ea22d1ff2$export$a6f87369be8a4720 = `mutation UpdateOrderTemplate($id:ID!,$input:OrderTemplateInput!){updateOrderTemplate(id:$id,input:$input){${$5e2e0b7ea22d1ff2$var$ORD_FIELDS}}}`;
const $5e2e0b7ea22d1ff2$export$d4954dee18c11fa4 = `mutation DuplicateOrderTemplate($id:ID!){duplicateOrderTemplate(id:$id){${$5e2e0b7ea22d1ff2$var$ORD_FIELDS}}}`;
const $5e2e0b7ea22d1ff2$export$ccad65d57167dba = `mutation DeleteOrderTemplate($id:ID!){deleteOrderTemplate(id:$id)}`;
const $5e2e0b7ea22d1ff2$export$77f43b7c8f6b1caf = `mutation ApplyMedicationTemplate($templateId:ID!,$appointmentId:ID!,$patientId:ID!,$itemIndexes:[Int!]){applyMedicationTemplate(templateId:$templateId,appointmentId:$appointmentId,patientId:$patientId,itemIndexes:$itemIndexes){templateId templateTitle appliedCount failures{name reason} medications{id code display status dosageInstruction meta taminListed}}}`;
const $5e2e0b7ea22d1ff2$export$d0abd4e5a22ebbe = `mutation ApplyOrderTemplate($templateId:ID!,$appointmentId:ID!,$patientId:ID!,$itemIndexes:[Int!]){applyOrderTemplate(templateId:$templateId,appointmentId:$appointmentId,patientId:$patientId,itemIndexes:$itemIndexes){templateId templateTitle appliedCount failures{name reason} orders{id orderType description urgency status notes createdAt performedDate code catalogId performedHere stage nextBookingAt}}}`;
const $5e2e0b7ea22d1ff2$export$46ab2989285eb791 = `query ListMedications($patientId:ID!,$appointmentId:ID){listMedications(patientId:$patientId,appointmentId:$appointmentId){id code display status dosageInstruction meta taminListed}}`;
const $5e2e0b7ea22d1ff2$export$a2d52108c6de7f27 = {
    medication: {
        kind: 'medication',
        listQuery: $5e2e0b7ea22d1ff2$export$ec65b30d180d4ef,
        listField: 'medicationTemplates',
        addMutation: $5e2e0b7ea22d1ff2$export$e16fea1a0a21b540,
        addField: 'addMedicationTemplate',
        updateMutation: $5e2e0b7ea22d1ff2$export$863f702bf73a955d,
        updateField: 'updateMedicationTemplate',
        duplicateMutation: $5e2e0b7ea22d1ff2$export$c4e9fb414738a0b0,
        duplicateField: 'duplicateMedicationTemplate',
        deleteMutation: $5e2e0b7ea22d1ff2$export$6228a01070183d6d,
        deleteField: 'deleteMedicationTemplate',
        applyMutation: $5e2e0b7ea22d1ff2$export$77f43b7c8f6b1caf,
        applyField: 'applyMedicationTemplate',
        // The kind's NAME lives with the editor that owns it, so the Visit picker
        // and the Settings tab cannot end up calling the same thing two things.
        labelKey: 'settings.templates.medication.label',
        hintKey: 'settings.templates.medication.hint',
        emptyKey: 'settings.templates.medication.empty',
        explainKey: 'settings.templates.medication.explain',
        newKey: 'settings.templates.medication.new'
    },
    order: {
        kind: 'order',
        listQuery: $5e2e0b7ea22d1ff2$export$95d049bf5f64bb7d,
        listField: 'orderTemplates',
        addMutation: $5e2e0b7ea22d1ff2$export$75fee887852c226f,
        addField: 'addOrderTemplate',
        updateMutation: $5e2e0b7ea22d1ff2$export$a6f87369be8a4720,
        updateField: 'updateOrderTemplate',
        duplicateMutation: $5e2e0b7ea22d1ff2$export$d4954dee18c11fa4,
        duplicateField: 'duplicateOrderTemplate',
        deleteMutation: $5e2e0b7ea22d1ff2$export$ccad65d57167dba,
        deleteField: 'deleteOrderTemplate',
        applyMutation: $5e2e0b7ea22d1ff2$export$d0abd4e5a22ebbe,
        applyField: 'applyOrderTemplate',
        labelKey: 'settings.templates.order.label',
        hintKey: 'settings.templates.order.hint',
        emptyKey: 'settings.templates.order.empty',
        explainKey: 'settings.templates.order.explain',
        newKey: 'settings.templates.order.new'
    }
};
const $5e2e0b7ea22d1ff2$export$47a272116a5ed65b = ()=>({
        drugId: '',
        name: '',
        genericName: '',
        dosage: '',
        frequency: '',
        route: '',
        duration: '',
        quantity: '',
        instructions: ''
    });
const $5e2e0b7ea22d1ff2$export$9b75ebcf168938fe = (drug, defaults = {})=>({
        drugId: drug?.id || '',
        name: drug?.name || '',
        genericName: drug?.genericName || '',
        dosage: defaults.dosage ?? (0, $eQiuG.defaultDoseFor)(drug),
        frequency: defaults.frequency ?? (0, $eQiuG.defaultFrequencyFor)(drug),
        route: defaults.route || '',
        duration: defaults.duration || '',
        quantity: defaults.quantity || '',
        instructions: defaults.instructions || '',
        commonDosages: drug?.commonDosages || [],
        commonFrequencies: drug?.commonFrequencies || []
    });
const $5e2e0b7ea22d1ff2$export$5f07940018c62174 = (draft)=>new Set((draft?.items || []).map((item)=>item.drugId).filter(Boolean));
const $5e2e0b7ea22d1ff2$export$604beaf67ef18d4d = ()=>({
        orderType: 'lab',
        name: '',
        catalogId: null,
        code: '',
        urgency: 'routine',
        notes: '',
        sessionCount: 0
    });
const $5e2e0b7ea22d1ff2$export$f533e11413e84a55 = (kind)=>kind === 'order' ? $5e2e0b7ea22d1ff2$export$604beaf67ef18d4d() : $5e2e0b7ea22d1ff2$export$47a272116a5ed65b();
const $5e2e0b7ea22d1ff2$export$41368fcaa4adc5d3 = ()=>({
        title: '',
        description: '',
        items: []
    });
const $5e2e0b7ea22d1ff2$export$6db8446c3a030733 = (kind, template)=>{
    if (!template) return $5e2e0b7ea22d1ff2$export$41368fcaa4adc5d3();
    const blank = $5e2e0b7ea22d1ff2$export$f533e11413e84a55(kind);
    return {
        title: template.title || '',
        description: template.description || '',
        items: (template.items || []).map((item)=>({
                ...blank,
                ...item
            }))
    };
};
const $5e2e0b7ea22d1ff2$export$d2a97effe7dc2dbb = (kind, draft)=>{
    const trim = (v)=>typeof v === 'string' ? v.trim() : v;
    const items = (draft.items || []).map((item)=>{
        if (kind === 'order') return {
            orderType: item.orderType || 'lab',
            name: trim(item.name) || '',
            catalogId: item.catalogId || null,
            code: trim(item.code) || '',
            urgency: item.urgency || 'routine',
            notes: trim(item.notes) || '',
            sessionCount: Number(item.sessionCount) || 0
        };
        return {
            drugId: trim(item.drugId) || '',
            name: trim(item.name) || '',
            genericName: trim(item.genericName) || '',
            dosage: trim(item.dosage) || '',
            frequency: trim(item.frequency) || '',
            route: trim(item.route) || '',
            duration: trim(item.duration) || '',
            quantity: trim(item.quantity) || '',
            instructions: trim(item.instructions) || ''
        };
    });
    return {
        title: trim(draft.title) || '',
        description: trim(draft.description) || '',
        items: items
    };
};
function $5e2e0b7ea22d1ff2$export$2a244ffb744b0c05(kind, draft) {
    const errors = {
        items: {}
    };
    const title = (draft?.title || '').trim();
    if (!title) errors.title = 'validation.template.title';
    else if (title.length > $5e2e0b7ea22d1ff2$export$14e010b4b1ab287e) errors.title = 'validation.template.titleTooLong';
    if ((draft?.description || '').trim().length > $5e2e0b7ea22d1ff2$export$fb3297c0e60769da) errors.description = 'validation.template.descriptionTooLong';
    const items = draft?.items || [];
    if (items.length > $5e2e0b7ea22d1ff2$export$dc458b2904e4b01a) errors.itemCount = 'validation.template.tooManyItems';
    items.forEach((item, index)=>{
        const itemErrors = {};
        if (!(item?.name || '').trim()) itemErrors.name = 'validation.template.itemName';
        else if ((item.name || '').trim().length > $5e2e0b7ea22d1ff2$export$5f711b58035cee0) itemErrors.name = 'validation.template.itemNameTooLong';
        if (kind === 'order') {
            if (!$5e2e0b7ea22d1ff2$export$7fe249ad93dcc233.includes(item?.orderType)) itemErrors.orderType = 'validation.template.orderType';
            if (item?.urgency && !$5e2e0b7ea22d1ff2$export$c9b31a4acc93d37d.includes(item.urgency)) itemErrors.urgency = 'validation.template.urgency';
            const sessions = Number(item?.sessionCount ?? 0);
            if (!Number.isFinite(sessions) || sessions < 0 || sessions > 100) itemErrors.sessionCount = 'validation.template.sessionCount';
        }
        if (Object.keys(itemErrors).length) errors.items[index] = itemErrors;
    });
    return errors;
}
const $5e2e0b7ea22d1ff2$export$b26b94f22deb9fbf = (errors)=>Boolean(errors && (errors.title || errors.description || errors.itemCount || Object.keys(errors.items || {}).length));
function $5e2e0b7ea22d1ff2$export$5d7b2ba43c325442(items, from, to) {
    const list = [
        ...items || []
    ];
    if (from < 0 || from >= list.length || to < 0 || to >= list.length || from === to) return list;
    const [moved] = list.splice(from, 1);
    list.splice(to, 0, moved);
    return list;
}
const $5e2e0b7ea22d1ff2$export$57c9a27f259f5c39 = (item)=>[
        item?.dosage,
        item?.frequency,
        item?.route,
        item?.duration,
        item?.quantity
    ].map((v)=>(v || '').trim()).filter(Boolean).join(" \xb7 ");
const $5e2e0b7ea22d1ff2$export$888087f3fb9d1ec2 = (template)=>(template?.items || []).length;
function $5e2e0b7ea22d1ff2$export$1f6fcfebcbb7f81d(group) {
    if (!group || typeof group !== 'object') return null;
    const code = typeof group.code === 'string' ? group.code.trim() : '';
    const name = typeof group.name === 'string' ? group.name.trim() : '';
    return code && name ? {
        code: code,
        name: name
    } : null;
}
function $5e2e0b7ea22d1ff2$export$e3d3f4d836a186b1(med) {
    if (!med) return null;
    const dosage = med.dosageInstruction && typeof med.dosageInstruction === 'object' ? med.dosageInstruction : {};
    const meta = med.meta && typeof med.meta === 'object' ? med.meta : {};
    // Rows written before structured dosing have only `text`. Showing it in the
    // dose column is closer to right than showing nothing, and the doctor can
    // still edit it.
    const legacyText = typeof med.dosageInstruction === 'string' ? med.dosageInstruction : dosage.text || '';
    const hasStructured = Boolean(dosage.dosage || dosage.frequency || dosage.duration);
    const erxGroup = $5e2e0b7ea22d1ff2$export$1f6fcfebcbb7f81d(meta.erxGroup);
    return {
        id: `med-${med.id}`,
        medicationId: med.id,
        drug: {
            id: meta.drugId || med.code || med.display,
            name: med.display || '',
            // Nothing writes `meta.genericName` today, so without the fallback every
            // row of a RESUMED visit would come back with no Latin name and be shown
            // under its Persian one — the one place the rule would break hardest.
            // `code` is where the Latin generic actually lands (see useEndVisit), and
            // `medGenericName` ignores it when it holds an identifier instead.
            genericName: meta.genericName || (0, $g6gAc.medGenericName)(med),
            category: '',
            commonDosages: [],
            commonFrequencies: [],
            // «در فهرست تأمین» as the BFF says it of the line (Medication.taminListed):
            // the row carries only the drug's id, which no longer tells (rxOptions
            // inInsurerList). Absent from an older BFF — then nothing is said.
            ...typeof med.taminListed === 'boolean' ? {
                taminListed: med.taminListed
            } : {},
            // The generic group the line was prescribed as (PM-0508): the row's «ژنریک»
            // chip, and what a refill of it writes again (medicationMetaFromDrug).
            ...erxGroup ? {
                erxGroup: erxGroup
            } : {}
        },
        dosage: hasStructured ? dosage.dosage || '' : legacyText,
        frequency: hasStructured ? dosage.frequency || '' : '',
        duration: hasStructured ? dosage.duration || '' : '',
        route: dosage.route || '',
        quantity: dosage.quantity || '',
        instructions: dosage.instructions || '',
        templateTitle: meta.templateTitle || ''
    };
}
function $5e2e0b7ea22d1ff2$export$aac88d3c48aba92(med) {
    if (!med) return null;
    const name = (med.display || med.code || '').trim();
    if (!name) return null;
    // Carried so a refilled row can still be shown under its Latin name when the
    // formulary lookup misses.
    const genericName = (0, $g6gAc.medGenericName)(med);
    // The product the line was prescribed from — the refill looks it up by THIS,
    // never by name: matched again by its Persian name, atropine 1% came back as
    // 0.5% and adapalene + benzoyl peroxide as plain adapalene, because one name
    // covers several strengths and combinations (K1, 2026-10-03). Empty for a line
    // written before the id was kept, or one that never named a product.
    const meta = med.meta && typeof med.meta === 'object' ? med.meta : {};
    const drugId = $5e2e0b7ea22d1ff2$var$productIdOf(meta.drugId);
    // The generic group it was prescribed as (PM-0508). refillDrugFor keeps it only
    // on the product the line named — a name match is another product.
    const erxGroup = $5e2e0b7ea22d1ff2$export$1f6fcfebcbb7f81d(meta.erxGroup);
    const di = med.dosageInstruction;
    const dosage = di && typeof di === 'object' ? di : {};
    const legacyText = typeof di === 'string' ? di : dosage.text || '';
    const hasStructured = Boolean(dosage.dosage || dosage.frequency || dosage.duration || dosage.route || dosage.quantity || dosage.instructions);
    return {
        name: name,
        genericName: genericName,
        ...drugId ? {
            drugId: drugId
        } : {},
        ...erxGroup ? {
            erxGroup: erxGroup
        } : {},
        dosage: hasStructured ? dosage.dosage || '' : legacyText,
        frequency: dosage.frequency || '',
        route: dosage.route || '',
        duration: dosage.duration || '',
        quantity: dosage.quantity || '',
        instructions: dosage.instructions || ''
    };
}
// Ids the Visit screen makes up for rows that did not come from the drug list —
// an AI suggestion, a treatment-plan line, a refill or a document line the drug
// list did not answer for. They name no product, so they are never written as
// one, nor read back as one by a refill (K1, 2026-10-03).
const $5e2e0b7ea22d1ff2$var$SYNTHETIC_DRUG_ID = /^(sugg-med-|plan-med-|refill-med-|doc-med-)/;
/** A drug id that names a product of the drug list, or '' for a made-up one. */ function $5e2e0b7ea22d1ff2$var$productIdOf(id) {
    const s = String(id || '').trim();
    return s && !$5e2e0b7ea22d1ff2$var$SYNTHETIC_DRUG_ID.test(s) ? s : '';
}
const $5e2e0b7ea22d1ff2$export$2fe3f622dc680493 = (drug)=>{
    const id = String(drug?.id || '').trim();
    if (!id || $5e2e0b7ea22d1ff2$var$SYNTHETIC_DRUG_ID.test(id) || id === drug?.name) return undefined;
    const erxGroup = $5e2e0b7ea22d1ff2$export$1f6fcfebcbb7f81d(drug?.erxGroup);
    return erxGroup ? {
        drugId: id,
        erxGroup: erxGroup
    } : {
        drugId: id
    };
};
const $5e2e0b7ea22d1ff2$export$1ed13c90275604ad = (item)=>({
        text: [
            item?.dosage,
            item?.frequency,
            item?.route,
            item?.duration,
            item?.quantity,
            item?.instructions
        ].map((v)=>(v || '').trim()).filter(Boolean).join(" \xb7 "),
        dosage: item?.dosage || '',
        frequency: item?.frequency || '',
        route: item?.route || '',
        duration: item?.duration || '',
        quantity: item?.quantity || '',
        instructions: item?.instructions || ''
    });
function $5e2e0b7ea22d1ff2$export$801d163b2e9340ef(existing, incoming) {
    const seen = new Set((existing || []).map((r)=>r.medicationId).filter(Boolean));
    const additions = (incoming || []).filter((r)=>r && !seen.has(r.medicationId));
    return additions.length ? [
        ...existing || [],
        ...additions
    ] : existing || [];
}
function $5e2e0b7ea22d1ff2$export$3c2b35db6130bf21(existing, incoming) {
    const seen = new Set((existing || []).map((o)=>o.id).filter(Boolean));
    const additions = (incoming || []).filter((o)=>o && !seen.has(o.id));
    return additions.length ? [
        ...additions.slice().reverse(),
        ...existing || []
    ] : existing || [];
}
function $5e2e0b7ea22d1ff2$export$89fd35b67bcc0da1(result) {
    const applied = result?.appliedCount || 0;
    const failures = result?.failures || [];
    if (failures.length) return {
        kind: 'partial',
        applied: applied,
        failed: failures.map((f)=>f.name)
    };
    if (!applied) return {
        kind: 'none',
        applied: 0,
        failed: []
    };
    return {
        kind: 'ok',
        applied: applied,
        failed: []
    };
}

});
parcelRegister("g6gAc", function(module, exports) {

$parcel$export(module.exports, "drugDisplayName", () => $bb8a11e7c1131df5$export$128ec9ce691e4cfc);
$parcel$export(module.exports, "planDrugName", () => $bb8a11e7c1131df5$export$3c5ec0a5e65ceb27);
$parcel$export(module.exports, "medGenericName", () => $bb8a11e7c1131df5$export$f7cd022e8c4a05fd);
$parcel$export(module.exports, "medNameLines", () => $bb8a11e7c1131df5$export$74649666e1751bea);
$parcel$export(module.exports, "drugNameLines", () => $bb8a11e7c1131df5$export$590163154e34e5bd);
$parcel$export(module.exports, "medDisplayName", () => $bb8a11e7c1131df5$export$74f59380a530b722);
$parcel$export(module.exports, "interactionDrugNames", () => $bb8a11e7c1131df5$export$868d19c379622928);
$parcel$export(module.exports, "warningOnRx", () => $bb8a11e7c1131df5$export$e960330bae0466a4);
$parcel$export(module.exports, "sameInteraction", () => $bb8a11e7c1131df5$export$3641abf9efdf7316);
$parcel$export(module.exports, "foldClinicalText", () => $bb8a11e7c1131df5$export$57fe41c96b1d272c);
// ── Drug names ───────────────────────────────────────────────────────────────
// ONE rule, for every surface that shows a drug: the Latin generic name leads.
//
// It lives in its own module rather than in Visit.shared.js because the screens
// that need it are not all visit screens — the patient record's medication list,
// the templates panel in تنظیمات and the analysis timeline each show a drug name
// too, and none of them should have to pull in the visit module to ask what to
// call it.
/**
 * THE name of a drug, anywhere one name is shown: its Latin generic name, which
 * is what a pharmacy, a referral letter and every other clinician reads without
 * ambiguity. `drug.name` is the Persian product string and is only the fallback,
 * for a formulary row (or a plan-suggested drug) that carries no generic.
 *
 * This is the whole rule for single-name surfaces — the نسخه print sheet, the
 * closure card, the export text, the plan block. Never read `drug.name` directly
 * to display it; the Persian is the STORED identity, not the shown one.
 */ const $bb8a11e7c1131df5$export$128ec9ce691e4cfc = (drug)=>(drug?.genericName || '').trim() || (drug?.name || '').trim();
const $bb8a11e7c1131df5$export$3c5ec0a5e65ceb27 = $bb8a11e7c1131df5$export$128ec9ce691e4cfc;
const $bb8a11e7c1131df5$export$f7cd022e8c4a05fd = (med)=>{
    const code = (med?.code || '').trim();
    return $bb8a11e7c1131df5$var$nameLike(code) ? code : '';
};
const $bb8a11e7c1131df5$export$74649666e1751bea = (med)=>$bb8a11e7c1131df5$export$590163154e34e5bd({
        name: med?.display,
        genericName: $bb8a11e7c1131df5$export$f7cd022e8c4a05fd(med)
    });
/**
 * Whether a `code` is a drug NAME rather than an identifier.
 *
 * A name has letters; an RxNorm code is all digits. The awkward case is a code
 * that mixes the two — ATC's «A10BA02» — which is told apart by being short,
 * unspaced and alphanumeric. Every real generic name this has to keep is either
 * unspaced letters («Metformin») or a registry product string carrying its
 * strength and form («RIZATRIPTAN (AS BENZOATE) 5 mg TABLET ORAL»), and the
 * second always has spaces.
 */ const $bb8a11e7c1131df5$var$nameLike = (v)=>{
    if (!v || !/[A-Za-z\u0600-\u06FF]/.test(v)) return false;
    const identifierShaped = /\d/.test(v) && !/\s/.test(v) && v.length <= 12 && /^[A-Za-z0-9.-]+$/.test(v);
    return !identifierShaped;
};
const $bb8a11e7c1131df5$export$74f59380a530b722 = (med)=>$bb8a11e7c1131df5$export$74649666e1751bea(med).primary;
// ── The name a drug is CHECKED under ─────────────────────────────────────────
//
// The interaction check and the prescription assist hand the AI service a list
// of drugs, and the service reads that list two ways: the model is prompted with
// it verbatim («Medications: [...]»), and a deterministic rule engine matches
// each entry, lower-cased, against tables keyed on bare generic names
// («warfarin», «ibuprofen»), then asks openFDA about the same strings.
//
// The list used to be the formulary ids. Those were the generic names once — the
// retired curated rows were keyed «amoxicillin» — but every drug a doctor can pick
// now is `tamin-<srvId>` or `erx-<code>`. An id says nothing about the drug, so
// the rule engine matched nothing and the model, asked about «tamin-70521», made
// a finding up: «warfarin + aspirin, severe» for amoxicillin and ibuprofen on a
// live visit. The Persian product string is no better for the rule engine.
//
// What goes instead is the SUBSTANCE, in Latin: the generic name with the
// registry's product dressing taken off. A تأمین row's `genericName` is the whole
// product («AMOXICILLIN 500 mg CAPSULE ORAL», «RIZATRIPTAN (AS BENZOATE) 5 mg
// TABLET ORAL»), an eRx row's is already the molecule («ACETAMINOPHEN / CAFFEINE /
// CODEINE PHOSPHATE»). Strength, salt note, brand, dose form and route are cut, so
// both read «AMOXICILLIN» — the string a table, a label search and a model all
// know. Nothing is cut that would leave the name empty: a row whose name IS its
// dressing keeps the whole Latin string.
//
// Never the id and never the Persian when a Latin name exists. The Persian name is
// sent only for a row that has nothing else (a plan-suggested or refilled drug the
// formulary did not match) — the model can still read it, which an id never was.
// The registry's trailing dose-form and route words. Only ever stripped from the
// END, so a substance that merely contains one («ORAL REHYDRATION SALTS») keeps it.
const $bb8a11e7c1131df5$var$FORM_OR_ROUTE_WORDS = new Set([
    'TABLET',
    'TABLETS',
    'CAPSULE',
    'CAPSULES',
    'SOLUTION',
    'SUSPENSION',
    'SYRUP',
    'ELIXIR',
    'EMULSION',
    'INJECTION',
    'INJECTABLE',
    'DROPS',
    'DROP',
    'CREAM',
    'OINTMENT',
    'GEL',
    'LOTION',
    'SPRAY',
    'AEROSOL',
    'INHALER',
    'INHALATION',
    'POWDER',
    'GRANULES',
    'SACHET',
    'SUPPOSITORY',
    'SUPPOSITORIES',
    'PATCH',
    'LOZENGE',
    'FILM',
    'COATED',
    'EXTENDED',
    'DELAYED',
    'MODIFIED',
    'RELEASE',
    'CHEWABLE',
    'EFFERVESCENT',
    'ORAL',
    'TOPICAL',
    'PARENTERAL',
    'OPHTHALMIC',
    'OTIC',
    'NASAL',
    'VAGINAL',
    'RECTAL',
    'SUBLINGUAL',
    'CUTANEOUS',
    'TRANSDERMAL',
    'RESPIRATORY',
    'INTRAVENOUS',
    'INTRAMUSCULAR',
    'SUBCUTANEOUS',
    'FOR'
]);
const $bb8a11e7c1131df5$var$PERSIAN_LETTER = /[؀-ۿ]/;
const $bb8a11e7c1131df5$export$25a9d8c7e2474bfd = (latin)=>{
    const whole = String(latin || '').replace(/\s+/g, ' ').trim();
    if (!whole) return '';
    const tokens = whole.replace(/\[[^\]]*\]/g, ' ') // the bracketed brand
    .replace(/\([^)]*\)/g, ' ') // a salt note, «(AS BENZOATE)»
    .split(/\s+/).filter(Boolean);
    // The strength starts the product's dressing. Not the FIRST token, though: a
    // name may begin with a digit («5-FLUOROURACIL»).
    const strength = tokens.findIndex((tok, i)=>i > 0 && /^[\d.]/.test(tok));
    const head = strength === -1 ? tokens : tokens.slice(0, strength);
    while(head.length > 1 && $bb8a11e7c1131df5$var$FORM_OR_ROUTE_WORDS.has(head[head.length - 1].replace(/[,;]+$/, '').toUpperCase()))head.pop();
    return head.join(' ').replace(/[,;]+$/, '').trim() || whole;
};
const $bb8a11e7c1131df5$export$5ad2c5daad3b8af = (drug)=>{
    const latin = (drug?.genericName || '').trim();
    if (latin) return $bb8a11e7c1131df5$export$25a9d8c7e2474bfd(latin);
    const name = (drug?.name || '').trim();
    // An eRx row's own name is the Latin product string; a Persian one goes as is.
    return name && !$bb8a11e7c1131df5$var$PERSIAN_LETTER.test(name) ? $bb8a11e7c1131df5$export$25a9d8c7e2474bfd(name) : name;
};
const $bb8a11e7c1131df5$export$868d19c379622928 = (rxItems)=>(rxItems || []).map((r)=>$bb8a11e7c1131df5$export$5ad2c5daad3b8af(r?.drug)).filter(Boolean);
// ── Whether a warning still describes the نسخه ─────────────────────────────
//
// The prescription assist runs once per assessment, and its warnings are cards
// in «نکات بالینی» that outlive the list they were computed for. Removing a drug
// cleared the نسخه tab's own interaction result but not these, so a safety card
// went on naming a drug that was no longer prescribed. A warning is therefore
// shown only while every drug it names is still on the نسخه.
//
// The test is the AI service's own (medication_names.py `filter_interaction_
// warnings`), which already holds the model's warnings to the names it was sent:
// the same split of a pair, the same folding of case, ZWNJ, Arabic letterforms
// and punctuation, the same whole-word containment. Applied to the current list,
// a drug still on it matches exactly as it did on the server, so nothing that
// still applies is hidden. A warning that names no drug cannot be made stale by
// a removal and is kept.
// How a model writes a pair. Not "/" or "-": both occur inside drug names.
const $bb8a11e7c1131df5$var$PAIR_SPLIT = /\s*\+\s*|\s*[,،;&]\s*|\s+(?:and|with|vs\.?|و|مع)\s+/i;
const $bb8a11e7c1131df5$var$ARABIC_TO_PERSIAN = {
    "\u064A": "\u06CC",
    "\u0649": "\u06CC",
    "\u0643": "\u06A9",
    "\u0629": "\u0647",
    "\u06C0": "\u0647",
    "\u0623": "\u0627",
    "\u0625": "\u0627",
    "\u0622": "\u0627"
};
const $bb8a11e7c1131df5$var$INVISIBLE = /[\u200B-\u200F\u202A-\u202E\u2066-\u2069\uFEFF]/g;
const $bb8a11e7c1131df5$var$DIACRITICS = /[\u064B-\u0670]/g;
const $bb8a11e7c1131df5$var$foldDrugName = (text)=>String(text ?? '').normalize('NFKC').toLowerCase().replace($bb8a11e7c1131df5$var$INVISIBLE, '').replace($bb8a11e7c1131df5$var$DIACRITICS, '').replace(/[يىكةۀأإآ]/g, (ch)=>$bb8a11e7c1131df5$var$ARABIC_TO_PERSIAN[ch]).replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
const $bb8a11e7c1131df5$var$warningDrugNames = (warning)=>{
    const pair = String(warning?.drugPair || '').trim();
    if (pair) return pair.split($bb8a11e7c1131df5$var$PAIR_SPLIT).filter((p)=>p && p.trim());
    const drug = String(warning?.drug || '').trim();
    return drug ? [
        drug
    ] : [];
};
// Equal once folded (spaces ignored too), or one contains the other as whole
// words — «amoxicillin» in «amoxicillin clavulanate». Never a bare substring:
// «pril» is not «enalapril».
const $bb8a11e7c1131df5$var$isListed = (name, listed)=>{
    const key = $bb8a11e7c1131df5$var$foldDrugName(name);
    if (key.length < 3) return false;
    return listed.some((item)=>{
        if (key === item || key.replace(/ /g, '') === item.replace(/ /g, '')) return true;
        const [short, long] = key.length <= item.length ? [
            key,
            item
        ] : [
            item,
            key
        ];
        return short.length >= 4 && ` ${long} `.includes(` ${short} `);
    });
};
const $bb8a11e7c1131df5$export$e960330bae0466a4 = (warning, rxNames)=>{
    const named = $bb8a11e7c1131df5$var$warningDrugNames(warning);
    if (!named.length) return true;
    const listed = (rxNames || []).map($bb8a11e7c1131df5$var$foldDrugName).filter(Boolean);
    return named.every((n)=>$bb8a11e7c1131df5$var$isListed(n, listed));
};
const $bb8a11e7c1131df5$export$3641abf9efdf7316 = (a, b)=>{
    if (!a || !b) return false;
    if ((a.warningType || 'interaction') !== (b.warningType || 'interaction')) return false;
    if ($bb8a11e7c1131df5$var$foldDrugName(a.condition) !== $bb8a11e7c1131df5$var$foldDrugName(b.condition)) return false;
    const na = $bb8a11e7c1131df5$var$warningDrugNames(a);
    const nb = $bb8a11e7c1131df5$var$warningDrugNames(b);
    if (!na.length || !nb.length) {
        const desc = $bb8a11e7c1131df5$var$foldDrugName(a.description);
        return !na.length && !nb.length && desc !== '' && desc === $bb8a11e7c1131df5$var$foldDrugName(b.description);
    }
    if (na.length !== nb.length) return false;
    const fa = na.map($bb8a11e7c1131df5$var$foldDrugName);
    const fb = nb.map($bb8a11e7c1131df5$var$foldDrugName);
    return na.every((n)=>$bb8a11e7c1131df5$var$isListed(n, fb)) && nb.every((n)=>$bb8a11e7c1131df5$var$isListed(n, fa));
};
const $bb8a11e7c1131df5$export$57fe41c96b1d272c = $bb8a11e7c1131df5$var$foldDrugName;
/**
 * Whether the page's reader reads Persian — the `readsPersianData` of the
 * locale descriptor, read from `<html lang>` (which I18nProvider owns) for the
 * callers that are not components. Only Persian does: an English or Arabic
 * reader cannot read the registry's Persian product string.
 */ const $bb8a11e7c1131df5$var$pageReadsPersian = ()=>{
    if (typeof document === 'undefined') return true;
    const lang = (document.documentElement.getAttribute('lang') || 'fa').toLowerCase();
    return lang.startsWith('fa');
};
const $bb8a11e7c1131df5$export$590163154e34e5bd = (drug, readsPersianData = $bb8a11e7c1131df5$var$pageReadsPersian())=>{
    const persian = (drug?.name || '').trim();
    const latin = (drug?.genericName || '').trim();
    if (!readsPersianData) {
        // `name` is not Persian on every row. An eRx row's is the registry's LATIN
        // product string («AMOXICILLIN 500 mg CAPSULE ORAL [AFAMOX]») under a
        // molecule-only `genericName` («AMOXICILLIN»), and it is the line that tells
        // two products of one molecule apart — dropping it left an Arabic reader a
        // product chooser of identical names. Only a Persian `name` is the noise.
        const readable = latin && persian && persian !== latin && !$bb8a11e7c1131df5$var$PERSIAN_LETTER.test(persian);
        return {
            primary: latin || persian,
            secondary: readable ? persian : ''
        };
    }
    // A row missing one of the two — a plan-suggested drug carries no generic —
    // shows the one it has, never an empty primary line. A row whose two names are
    // the SAME string is one name, not two: showing it twice reads as a bug.
    if (!persian || !latin || persian === latin) return {
        primary: persian || latin,
        secondary: ''
    };
    return {
        primary: latin,
        secondary: persian
    };
};

});

parcelRegister("eQiuG", function(module, exports) {

$parcel$export(module.exports, "doseOptionsFor", () => $ace44487380106d3$export$23fceca71987facd);
$parcel$export(module.exports, "defaultDoseFor", () => $ace44487380106d3$export$f3c4ec3c63ab1d60);
$parcel$export(module.exports, "FREQUENCY_OPTIONS", () => $ace44487380106d3$export$93a11165d6a55361);
$parcel$export(module.exports, "frequencyOptionsFor", () => $ace44487380106d3$export$ac4b3f6873c02e40);
$parcel$export(module.exports, "RX_ROUTE_VALUES", () => $ace44487380106d3$export$4e844baf4fb2f82b);
$parcel$export(module.exports, "toRouteOption", () => $ace44487380106d3$export$1aea987f77fa496a);
$parcel$export(module.exports, "routeLabel", () => $ace44487380106d3$export$80ace2b99405d272);
$parcel$export(module.exports, "doseLabel", () => $ace44487380106d3$export$6742958aefab4338);
$parcel$export(module.exports, "durationLabel", () => $ace44487380106d3$export$6983ec1528bb4f57);
$parcel$export(module.exports, "autoRouteFor", () => $ace44487380106d3$export$ae410c87a5d0011f);
$parcel$export(module.exports, "defaultFrequencyFor", () => $ace44487380106d3$export$84160816d8079a95);
$parcel$export(module.exports, "quantityNumber", () => $ace44487380106d3$export$48f972f5effb9c);
$parcel$export(module.exports, "missingRxFields", () => $ace44487380106d3$export$e9b4e5de48a21156);
$parcel$export(module.exports, "rxFieldNames", () => $ace44487380106d3$export$a1043144d576f6b6);
$parcel$export(module.exports, "rxIncompleteLabel", () => $ace44487380106d3$export$ab36a14ecd73702e);
$parcel$export(module.exports, "quantityFor", () => $ace44487380106d3$export$d2b1f8f4188143eb);
$parcel$export(module.exports, "withAutoQuantity", () => $ace44487380106d3$export$8dbcc67e0ab5a150);
$parcel$export(module.exports, "applyRxEdit", () => $ace44487380106d3$export$b0f426f8468d8007);
$parcel$export(module.exports, "toDoseOption", () => $ace44487380106d3$export$af120d81d82db54b);
$parcel$export(module.exports, "toFrequencyOption", () => $ace44487380106d3$export$698a3d49e661c86e);
$parcel$export(module.exports, "closedListDefaults", () => $ace44487380106d3$export$e8df75bdc9e038c6);
$parcel$export(module.exports, "listValuesWhereNamed", () => $ace44487380106d3$export$2e037991db2fc726);
$parcel$export(module.exports, "newRxLine", () => $ace44487380106d3$export$5352dbb17a06665d);
$parcel$export(module.exports, "fillRxDirections", () => $ace44487380106d3$export$c1d8ac96a7e23c6f);
$parcel$export(module.exports, "rxAddDefaults", () => $ace44487380106d3$export$87bc9af39161d883);
$parcel$export(module.exports, "fillFromMemory", () => $ace44487380106d3$export$72a40f6da1cd88d8);
$parcel$export(module.exports, "splitInstructions", () => $ace44487380106d3$export$71de4099086ae7ae);
$parcel$export(module.exports, "joinInstructions", () => $ace44487380106d3$export$5abd89ce1bdd9342);
$parcel$export(module.exports, "insurerKeyOf", () => $ace44487380106d3$export$e4f91298b6c5a0f0);
$parcel$export(module.exports, "inInsurerList", () => $ace44487380106d3$export$60f8cb686aa6701e);
$parcel$export(module.exports, "inInsurerListAny", () => $ace44487380106d3$export$6c8fe862de8e39ae);
$parcel$export(module.exports, "usualRxDefaults", () => $ace44487380106d3$export$fd52a5511e853f43);
$parcel$export(module.exports, "withFrequentDrug", () => $ace44487380106d3$export$7fc1a2f08e2a58c0);
$parcel$export(module.exports, "frequentRxEntries", () => $ace44487380106d3$export$c19989f0228742e1);
// What a doctor may pick for a prescribed drug's دوز, تناوب and نحوه مصرف.
//
// Closed lists, because the e-prescription sends these fields as codes and refuses a
// line it cannot code (doctor BFF lib/opnaji/parsinaRx.js). The formulary's own
// suggestions were the trap: a تأمین row offered its STRENGTH as the dose («5 MG»),
// some rows offered English frequencies («daily»), and every such line came back
// «مقدار هر نوبت باید «عدد + واحد» باشد» (K1, 2026-09-30). The dose is the AMOUNT PER
// TAKE in units of the product's own form — «۱ قرص» of a 5 mg tablet, not «5 mg».
//
// Every dose here is «<number> <form noun>», a noun parseDoseField reads (RX_DOSE_UNITS),
// and every frequency is a phrase resolveDosageText maps to an appendix-11 code.
const $ace44487380106d3$var$faDigits = (n)=>String(n).replace(/\d/g, (d)=>"\u06F0\u06F1\u06F2\u06F3\u06F4\u06F5\u06F6\u06F7\u06F8\u06F9"[d]);
// Insulin is taken in UNITS dialled from a pen, a cartridge or a vial that holds
// many doses. As an «آمپول» the only doses of an INSULIN ASPART 100 [iU]/mL 3 mL
// pen were «۱/۲ آمپول» — one whole pen a dose — and روزی سه بار × ۱ ماه worked
// out to 90 pens (K1, 2026-10-03). The amounts are the usual insulin doses. There
// is no default: no number of units is a safe guess, so a new line says «ناقص:
// دوز» until the doctor picks one.
const $ace44487380106d3$var$INSULIN_UNITS = Array.from({
    length: 60
}, (_, i)=>$ace44487380106d3$var$faDigits(i + 1));
// The product's form, read from its names: the eRx / تأمین name ends in the form and
// the route («… 5 mg TABLET ORAL»), the Persian name says it too («… قرص خوراکی»).
// Order matters: a DROPS line is also a SOLUTION, an injection is also a SOLUTION,
// an effervescent TABLET is still a tablet, and an insulin is also an INJECTION.
//
// `unit` names the noun in the catalogue (`visit.rx.doseUnit.*`) for a reader who
// does not read Persian — see doseLabel.
const $ace44487380106d3$var$FORMS = [
    {
        noun: "\u0648\u0627\u062D\u062F",
        unit: 'unit',
        re: /INSULIN|انسولین/i,
        amounts: $ace44487380106d3$var$INSULIN_UNITS,
        noDefault: true
    },
    {
        noun: "\u0634\u06CC\u0627\u0641",
        unit: 'suppository',
        re: /SUPPOSITOR|شیاف/i,
        amounts: [
            "\u06F1",
            "\u06F2"
        ]
    },
    {
        noun: "\u067E\u0627\u0641",
        unit: 'puff',
        re: /INHAL|AEROSOL|SPRAY|اسپری|افشانه|استنشاقی/i,
        amounts: [
            "\u06F1",
            "\u06F2",
            "\u06F3",
            "\u06F4"
        ]
    },
    {
        noun: "\u0642\u0637\u0631\u0647",
        unit: 'drop',
        re: /DROPS?\b|قطره/i,
        amounts: [
            "\u06F1",
            "\u06F2",
            "\u06F3",
            "\u06F4",
            "\u06F5",
            "\u06F1\u06F0"
        ]
    },
    {
        noun: "\u0648\u06CC\u0627\u0644",
        unit: 'vial',
        re: /VIAL|ویال/i,
        amounts: [
            "\u06F1",
            "\u06F2"
        ]
    },
    {
        noun: "\u0622\u0645\u067E\u0648\u0644",
        unit: 'ampoule',
        re: /INJECT|AMPOULE|AMPULE|PARENTERAL|آمپول|تزریقی/i,
        amounts: [
            "\u06F1",
            "\u06F2"
        ]
    },
    {
        noun: "\u0642\u0631\u0635",
        unit: 'tablet',
        re: /TABLET|\bTAB\b|قرص/i,
        amounts: [
            "\u06F0\u066B\u06F2\u06F5",
            "\u06F0\u066B\u06F5",
            "\u06F1",
            "\u06F1\u066B\u06F5",
            "\u06F2",
            "\u06F3"
        ]
    },
    {
        noun: "\u06A9\u067E\u0633\u0648\u0644",
        unit: 'capsule',
        re: /CAPSULE|\bCAP\b|کپسول|پرل/i,
        amounts: [
            "\u06F1",
            "\u06F2",
            "\u06F3"
        ]
    },
    {
        noun: "\u0633\u06CC \u0633\u06CC",
        unit: 'ml',
        re: /SYRUP|SUSPENSION|ELIXIR|SOLUTION.*ORAL|ORAL.*SOLUTION|شربت|سوسپانسیون|محلول خوراکی/i,
        amounts: [
            "\u06F2\u066B\u06F5",
            "\u06F5",
            "\u06F7\u066B\u06F5",
            "\u06F1\u06F0",
            "\u06F1\u06F5"
        ],
        start: "\u06F5"
    },
    {
        noun: "\u0633\u0627\u0634\u0647",
        unit: 'sachet',
        re: /SACHET|GRANULE|ساشه|گرانول/i,
        amounts: [
            "\u06F1",
            "\u06F2"
        ]
    }
];
// A form the names do not state (a cream, a device): a count, sent with the eRx code.
const $ace44487380106d3$var$FALLBACK = {
    noun: "\u0639\u062F\u062F",
    unit: 'count',
    amounts: [
        "\u06F1",
        "\u06F2"
    ]
};
const $ace44487380106d3$var$namesOf = (drug)=>`${drug?.genericName || ''} ${drug?.name || ''}`;
function $ace44487380106d3$export$3e83362a56784c9(drug) {
    const text = $ace44487380106d3$var$namesOf(drug);
    return $ace44487380106d3$var$FORMS.find((f)=>f.re.test(text)) || $ace44487380106d3$var$FALLBACK;
}
// A container that holds MANY doses: an insulin, a pen or a cartridge, a vial
// marked multi-dose, or an injectable whose strength is in units («[iU]», «IU»,
// «۱۰۰ واحد»: heparin, insulin vials). دوز × doses a day × days counts DOSES, and
// a month of one of these is a pen or two, not 90 — so its مقدار تحویلی is never
// worked out: the doctor types the number of pens or vials (K1, 2026-10-03).
const $ace44487380106d3$var$INJECTABLE = /INJECT|PARENTERAL|AMPOULE|AMPULE|VIAL|CARTRIDGE|PENFILL|\bPEN\b|PEN\]|آمپول|ویال|تزریقی|قلم|کارتریج/i;
const $ace44487380106d3$var$MANY_DOSES = /INSULIN|انسولین|\[I\.?U\]|\bI\.?U\b|[\d۰-۹]\s*واحد|CARTRIDGE|PENFILL|\bPEN\b|PEN\]|KWIKPEN|FLEXPEN|FLEXTOUCH|SOLOSTAR|MULTI-?\s?DOSE|قلم|کارتریج|چند\s*دوز/i;
function $ace44487380106d3$export$df367f6eb2d011ee(drug) {
    const text = $ace44487380106d3$var$namesOf(drug);
    return $ace44487380106d3$var$INJECTABLE.test(text) && $ace44487380106d3$var$MANY_DOSES.test(text);
}
function $ace44487380106d3$export$23fceca71987facd(drug, current = '') {
    const f = $ace44487380106d3$export$3e83362a56784c9(drug);
    const list = f.amounts.map((a)=>`${a} ${f.noun}`);
    const cur = String(current || '').trim();
    return cur && !list.includes(cur) ? [
        cur,
        ...list
    ] : list;
}
function $ace44487380106d3$export$f3c4ec3c63ab1d60(drug) {
    const f = $ace44487380106d3$export$3e83362a56784c9(drug);
    if (f.noDefault) return '';
    return `${f.start || (f.amounts.includes("\u06F1") ? "\u06F1" : f.amounts[0])} ${f.noun}`;
}
const $ace44487380106d3$export$93a11165d6a55361 = [
    "\u0631\u0648\u0632\u06CC \u06CC\u06A9 \u0628\u0627\u0631",
    "\u0631\u0648\u0632\u06CC \u062F\u0648 \u0628\u0627\u0631",
    "\u0631\u0648\u0632\u06CC \u0633\u0647 \u0628\u0627\u0631",
    "\u0631\u0648\u0632\u06CC \u0686\u0647\u0627\u0631 \u0628\u0627\u0631",
    "\u0647\u0631 \u06F4 \u0633\u0627\u0639\u062A",
    "\u0647\u0631 \u06F6 \u0633\u0627\u0639\u062A",
    "\u0647\u0631 \u06F8 \u0633\u0627\u0639\u062A",
    "\u0647\u0631 \u06F1\u06F2 \u0633\u0627\u0639\u062A",
    "\u0634\u0628\u0627\u0646\u0647 \u06CC\u06A9 \u0628\u0627\u0631",
    "\u0631\u0648\u0632\u06CC \u06CC\u06A9 \u0628\u0627\u0631 \u0646\u0627\u0634\u062A\u0627",
    "\u06CC\u06A9 \u0631\u0648\u0632 \u062F\u0631 \u0645\u06CC\u0627\u0646",
    "\u0647\u0641\u062A\u0647\u200C\u0627\u06CC \u06CC\u06A9 \u0628\u0627\u0631",
    "\u0647\u0641\u062A\u0647\u200C\u0627\u06CC \u062F\u0648 \u0628\u0627\u0631",
    "\u0647\u0631 \u06F2 \u0647\u0641\u062A\u0647 \u06CC\u06A9 \u0628\u0627\u0631",
    "\u0645\u0627\u0647\u06CC \u06CC\u06A9 \u0628\u0627\u0631",
    "\u062F\u0631 \u0635\u0648\u0631\u062A \u0646\u06CC\u0627\u0632",
    "\u0642\u0628\u0644 \u0627\u0632 \u0648\u0639\u062F\u0647 \u063A\u0630\u0627\u06CC\u06CC",
    "\u0647\u0645\u0631\u0627\u0647 \u0628\u0627 \u0648\u0639\u062F\u0647 \u063A\u0630\u0627\u06CC\u06CC"
];
function $ace44487380106d3$export$ac4b3f6873c02e40(current = '') {
    const cur = String(current || '').trim();
    return cur && !$ace44487380106d3$export$93a11165d6a55361.includes(cur) ? [
        cur,
        ...$ace44487380106d3$export$93a11165d6a55361
    ] : $ace44487380106d3$export$93a11165d6a55361;
}
// ── Is a stored value one of its closed list? ───────────────────────────────
//
// Asked the way the doctor BFF asks it (normalizeFa, lib/opnaji/terminology.js):
// Persian and Arabic-Indic digits read as ASCII, Arabic ي/ك as Persian, a ZWNJ as
// a space, a run of spaces as one. NOTHING else is folded — the BFF does not read
// «روزی ۲ بار» as «روزی دو بار», so a line holding it is not complete here either.
// A line used to count as complete as soon as each field held anything, and
// «Daily», «BID», «روزی ۲ بار» or a hand-typed route were then refused by the
// insurer after the visit (K1, 2026-10-03).
const $ace44487380106d3$var$listKey = (s)=>String(s ?? '').replace(/[۰-۹]/g, (d)=>String(d.charCodeAt(0) - 0x06f0)).replace(/[٠-٩]/g, (d)=>String(d.charCodeAt(0) - 0x0660)).replace(/ي/g, "\u06CC").replace(/ك/g, "\u06A9").replace(/\u200c/g, ' ').replace(/\s+/g, ' ').trim();
const $ace44487380106d3$var$FREQUENCY_KEYS = new Set($ace44487380106d3$export$93a11165d6a55361.map($ace44487380106d3$var$listKey));
const $ace44487380106d3$export$bad71ce44b13580d = (value)=>$ace44487380106d3$var$FREQUENCY_KEYS.has($ace44487380106d3$var$listKey(value));
// ── نحوه مصرف: one VALUE per route, whatever the UI language ────────────────
//
// The e-prescription codes a route from its STORED value (doctor BFF parsinaRx.js
// RX_ROUTE_CODES), keyed by the Persian names. The route list used to store its
// TRANSLATED label, so a route picked in the English or Arabic UI («Oral»,
// «فموي») was refused by the insurer (K1, 2026-10-03). The value is now the
// Persian name in every language; only the label the doctor reads is translated
// (`routeLabel`, from `visit.rx.routes.<key>`).
// i18n-exempt: wire values the doctor BFF matches — shown only through routeLabel
const $ace44487380106d3$var$ROUTE_VALUES = {
    oral: "\u062E\u0648\u0631\u0627\u06A9\u06CC",
    sublingual: "\u0632\u06CC\u0631\u0632\u0628\u0627\u0646\u06CC",
    iv: "\u062A\u0632\u0631\u06CC\u0642 \u0648\u0631\u06CC\u062F\u06CC",
    im: "\u062A\u0632\u0631\u06CC\u0642 \u0639\u0636\u0644\u0627\u0646\u06CC",
    sc: "\u062A\u0632\u0631\u06CC\u0642 \u0632\u06CC\u0631\u062C\u0644\u062F\u06CC",
    topical: "\u0645\u0648\u0636\u0639\u06CC (\u067E\u0648\u0633\u062A\u06CC)",
    inhaled: "\u0627\u0633\u062A\u0646\u0634\u0627\u0642\u06CC",
    ophthalmic: "\u0642\u0637\u0631\u0647 \u0686\u0634\u0645\u06CC",
    otic: "\u0642\u0637\u0631\u0647 \u06AF\u0648\u0634\u06CC",
    nasal: "\u0628\u06CC\u0646\u06CC",
    rectal: "\u0645\u0642\u0639\u062F\u06CC",
    vaginal: "\u0648\u0627\u0698\u06CC\u0646\u0627\u0644"
};
const $ace44487380106d3$export$d74359aba7d2c55a = Object.keys($ace44487380106d3$var$ROUTE_VALUES);
const $ace44487380106d3$export$4e844baf4fb2f82b = $ace44487380106d3$export$d74359aba7d2c55a.map((k)=>$ace44487380106d3$var$ROUTE_VALUES[k]);
// What else a stored route may say and still name its route: the English and
// Arabic labels the list stored before its values were fixed — lines written then
// are in the record, and must still read, and count, as their route — the French
// labels (`fr/visit.json` `visit.rx.routes.*`, exactly as written there), so a
// route read back in the French UI's words names its route too, the German ones
// (`de/visit.json`, likewise; «Oral», «Sublingual», «Vaginal» are the English
// words and already listed), and the abbreviations the doctor BFF codes as well
// (RX_ROUTE_CODES_EN).
// i18n-exempt: matched against stored values — never displayed
const $ace44487380106d3$var$ROUTE_ALIASES = {
    oral: [
        'Oral',
        "\u0641\u0645\u0648\u064A",
        'Orale',
        'PO'
    ],
    sublingual: [
        'Sublingual',
        "\u062A\u062D\u062A \u0627\u0644\u0644\u0633\u0627\u0646",
        'Sublinguale',
        'SL'
    ],
    iv: [
        'Intravenous',
        "\u0648\u0631\u064A\u062F\u064A",
        'Intraveineuse',
        "Intraven\xf6s",
        'IV'
    ],
    im: [
        'Intramuscular',
        "\u0639\u0636\u0644\u064A",
        'Intramusculaire',
        "Intramuskul\xe4r",
        'IM'
    ],
    sc: [
        'Subcutaneous',
        "\u062A\u062D\u062A \u0627\u0644\u062C\u0644\u062F",
        "Sous-cutan\xe9e",
        'Subkutan',
        'SC'
    ],
    topical: [
        'Topical',
        "\u0645\u0648\u0636\u0639\u064A",
        "Cutan\xe9e (locale)",
        'Topisch'
    ],
    inhaled: [
        'Inhaled',
        "\u0627\u0633\u062A\u0646\u0634\u0627\u0642\u064A",
        "Inhal\xe9e",
        'Inhalativ'
    ],
    ophthalmic: [
        'Eye drops',
        "\u0642\u0637\u0631\u0629 \u0639\u064A\u0646\u064A\u0629",
        'Collyre',
        'Augentropfen',
        'ophthalmic'
    ],
    otic: [
        'Ear drops',
        "\u0642\u0637\u0631\u0629 \u0623\u0630\u0646\u064A\u0629",
        'Gouttes auriculaires',
        'Ohrentropfen',
        'otic'
    ],
    nasal: [
        'Intranasal',
        "\u0623\u0646\u0641\u064A",
        'Nasale',
        'Nasal'
    ],
    rectal: [
        'Rectal',
        "\u0634\u0631\u062C\u064A",
        'Rectale',
        'Rektal',
        'PR'
    ],
    vaginal: [
        'Vaginal',
        "\u0645\u0647\u0628\u0644\u064A",
        'Vaginale',
        'PV'
    ]
};
const $ace44487380106d3$var$ROUTE_KEY_BY_TEXT = new Map($ace44487380106d3$export$d74359aba7d2c55a.flatMap((k)=>[
        $ace44487380106d3$var$ROUTE_VALUES[k],
        ...$ace44487380106d3$var$ROUTE_ALIASES[k]
    ].map((v)=>[
            $ace44487380106d3$var$listKey(v).toLowerCase(),
            k
        ])));
function $ace44487380106d3$export$ee4bfde455f56776(value) {
    const k = $ace44487380106d3$var$listKey(value).toLowerCase();
    return k && $ace44487380106d3$var$ROUTE_KEY_BY_TEXT.get(k) || null;
}
const $ace44487380106d3$export$333786c46079a63a = (key)=>$ace44487380106d3$var$ROUTE_VALUES[key] || '';
const $ace44487380106d3$export$242a279056f60471 = (value)=>$ace44487380106d3$export$ee4bfde455f56776(value) !== null;
const $ace44487380106d3$export$1aea987f77fa496a = (value)=>$ace44487380106d3$export$333786c46079a63a($ace44487380106d3$export$ee4bfde455f56776(value));
const $ace44487380106d3$var$ROUTE_KEY_BY_VALUE = new Map($ace44487380106d3$export$d74359aba7d2c55a.map((k)=>[
        $ace44487380106d3$var$listKey($ace44487380106d3$var$ROUTE_VALUES[k]),
        k
    ]));
function $ace44487380106d3$export$80ace2b99405d272(value, t) {
    const k = $ace44487380106d3$var$ROUTE_KEY_BY_VALUE.get($ace44487380106d3$var$listKey(value));
    return k ? t(`visit.rx.routes.${k}`) : String(value ?? '');
}
// ── A دوز, read in another language ────────────────────────────────────────
//
// The دوز is stored as the closed list writes it — «۱ کپسول» — because that is
// what the e-prescription parses, and it does not move. A reader who does not
// read Persian sees it through the catalogue instead: the amount as a NUMBER the
// locale formats and pluralises («1 capsule», «2 capsules», «١ كبسولة», «٣
// كبسولات»), the noun from `visit.rx.doseUnit.*`. It used to go through the
// English plan translator for every such reader, so an Arabic نسخه read
// «1 capsule كل ٨ ساعات» — English in the middle of an Arabic line.
const $ace44487380106d3$var$DOSE_UNIT_BY_NOUN = new Map([
    ...$ace44487380106d3$var$FORMS,
    $ace44487380106d3$var$FALLBACK
].map((f)=>[
        $ace44487380106d3$var$listKey(f.noun),
        f.unit
    ]));
function $ace44487380106d3$export$6742958aefab4338(value, t) {
    const m = $ace44487380106d3$var$listKey(value).replace(/[٫,]/g, '.').match(/^(\d+(?:\.\d+)?)\s+(.+)$/);
    const unit = m && $ace44487380106d3$var$DOSE_UNIT_BY_NOUN.get(m[2]);
    if (!unit || typeof t !== 'function') return '';
    return t(`visit.rx.doseUnit.${unit}`, {
        count: Number(m[1])
    });
}
// ── A مدت, read in another language ─────────────────────────────────────────
//
// The مدت field offers `visit.duration.*` in the reader's language (DURATIONS in
// Visit.shared). A value that arrives from elsewhere — the model's «10 روز», a
// line stored under a Persian UI — is read through the same keys, by the days it
// covers. A span that is not one of the listed ones is shown as written.
const $ace44487380106d3$var$DURATION_KEY_BY_DAYS = new Map([
    [
        3,
        'd3'
    ],
    [
        5,
        'd5'
    ],
    [
        7,
        'd7'
    ],
    [
        10,
        'd10'
    ],
    [
        14,
        'd14'
    ],
    [
        30,
        'm1'
    ],
    [
        60,
        'm2'
    ],
    [
        90,
        'm3'
    ],
    [
        180,
        'm6'
    ]
]);
function $ace44487380106d3$export$6983ec1528bb4f57(value, t) {
    const raw = String(value ?? '').trim();
    if (!raw || typeof t !== 'function') return raw;
    const key = $ace44487380106d3$var$DURATION_KEY_BY_DAYS.get($ace44487380106d3$var$durationDays(raw));
    return key ? t(`visit.duration.${key}`) : raw;
}
// The route the product's name states — the key of RX_ROUTES' `visit.rx.routes.*`.
// An injection names no route («PARENTERAL»): IV, IM and SC stay the doctor's call.
const $ace44487380106d3$var$ROUTES = [
    [
        'sublingual',
        /SUBLINGUAL|زیرزبانی/i
    ],
    [
        'ophthalmic',
        /OPHTHALMIC|چشمی/i
    ],
    [
        'otic',
        /\bOTIC|AURICULAR|گوشی/i
    ],
    [
        'nasal',
        /NASAL|بینی/i
    ],
    [
        'inhaled',
        /INHALATION|RESPIRATORY|استنشاقی/i
    ],
    [
        'rectal',
        /RECTAL|مقعدی/i
    ],
    [
        'vaginal',
        /VAGINAL|واژینال/i
    ],
    [
        'iv',
        /INTRAVENOUS|وریدی/i
    ],
    [
        'im',
        /INTRAMUSCULAR|عضلانی/i
    ],
    [
        'sc',
        /SUBCUTANEOUS|زیرجلدی/i
    ],
    [
        'topical',
        /TOPICAL|CUTANEOUS|TRANSDERMAL|موضعی|پوستی/i
    ],
    [
        'oral',
        /\bORAL\b|خوراکی/i
    ]
];
function $ace44487380106d3$export$973512cfacf8eb2c(drug) {
    const text = $ace44487380106d3$var$namesOf(drug);
    const hit = $ace44487380106d3$var$ROUTES.find(([, re])=>re.test(text));
    return hit ? hit[0] : null;
}
const $ace44487380106d3$export$ae410c87a5d0011f = (drug)=>$ace44487380106d3$export$333786c46079a63a($ace44487380106d3$export$973512cfacf8eb2c(drug));
// «روزی ۳ بار» and «روزی سه بار» are one frequency: the formulary writes either.
// This maps a value ONTO the list (a default, an AI's answer); whether a stored
// value already IS on it is isFrequencyOption's question, asked more strictly.
const $ace44487380106d3$var$COUNT_WORDS = {
    1: "\u06CC\u06A9",
    2: "\u062F\u0648",
    3: "\u0633\u0647",
    4: "\u0686\u0647\u0627\u0631"
};
const $ace44487380106d3$var$freqKey = (s)=>String(s ?? '').replace(/[۰-۹]/g, (d)=>String(d.charCodeAt(0) - 0x06f0)).replace(/[٠-٩]/g, (d)=>String(d.charCodeAt(0) - 0x0660)).replace(/\b[1-4]\b/g, (m)=>$ace44487380106d3$var$COUNT_WORDS[m]).replace(/[\u200c\u00a0]/g, ' ').replace(/\s+/g, ' ').trim();
function $ace44487380106d3$export$84160816d8079a95(drug) {
    const key = $ace44487380106d3$var$freqKey(drug?.commonFrequencies?.[0]);
    return key && $ace44487380106d3$export$93a11165d6a55361.find((o)=>$ace44487380106d3$var$freqKey(o) === key) || '';
}
function $ace44487380106d3$export$48f972f5effb9c(q) {
    const ascii = String(q ?? '').replace(/[۰-۹]/g, (d)=>String(d.charCodeAt(0) - 0x06f0)).replace(/[٠-٩]/g, (d)=>String(d.charCodeAt(0) - 0x0660)).replace(/[^\d]/g, '');
    return ascii ? Number(ascii) : null;
}
const $ace44487380106d3$export$b30a5604adc93160 = [
    'dosage',
    'frequency',
    'route',
    'quantity'
];
function $ace44487380106d3$export$e9b4e5de48a21156(row = {}) {
    return $ace44487380106d3$export$b30a5604adc93160.filter((k)=>{
        if (k === 'quantity') return !($ace44487380106d3$export$48f972f5effb9c(row.quantity) > 0);
        if (k === 'frequency') return !$ace44487380106d3$export$bad71ce44b13580d(row.frequency);
        if (k === 'route') return !$ace44487380106d3$export$242a279056f60471(row.route);
        return !String(row[k] ?? '').trim();
    });
}
// «ناقص: تناوب، مقدار تحویلی» — the missing fields by their form labels.
const $ace44487380106d3$var$RX_FIELD_LABEL_KEYS = {
    dosage: 'visit.rx.dose',
    frequency: 'visit.rx.frequency',
    route: 'visit.rx.route',
    quantity: 'visit.rx.quantity'
};
const $ace44487380106d3$export$a1043144d576f6b6 = (missing, t)=>missing.map((k)=>t($ace44487380106d3$var$RX_FIELD_LABEL_KEYS[k])).join(t('visit.rx.incompleteSep'));
function $ace44487380106d3$export$ab36a14ecd73702e(missing, t) {
    return t('visit.rx.incomplete', {
        fields: $ace44487380106d3$export$a1043144d576f6b6(missing, t)
    });
}
// ── مقدار تحویلی, worked out ────────────────────────────────────────────────
//
// دوز × doses a day × days of the course, for a form that is dispensed by the
// unit it is taken in: a tablet, a capsule, a suppository, a sachet, an ampoule,
// a vial. A syrup's dose is in سی سی and drops or puffs come from a bottle — how
// many BOTTLES that is depends on the pack, so those stay the doctor's to type.
// So do insulin's units («واحد» is not counted here) and every container that
// holds many doses (isMultiDoseInjectable): a pen is not used up by one dose.
const $ace44487380106d3$var$COUNTED_IN_DOSE_UNITS = new Set([
    "\u0642\u0631\u0635",
    "\u06A9\u067E\u0633\u0648\u0644",
    "\u0634\u06CC\u0627\u0641",
    "\u0633\u0627\u0634\u0647",
    "\u0622\u0645\u067E\u0648\u0644",
    "\u0648\u06CC\u0627\u0644"
]);
// Doses a day for each frequency choice. «در صورت نیاز» and the meal-bound ones
// are absent on purpose: they say when, not how often.
const $ace44487380106d3$var$PER_DAY = new Map([
    [
        "\u0631\u0648\u0632\u06CC \u06CC\u06A9 \u0628\u0627\u0631",
        1
    ],
    [
        "\u0631\u0648\u0632\u06CC \u062F\u0648 \u0628\u0627\u0631",
        2
    ],
    [
        "\u0631\u0648\u0632\u06CC \u0633\u0647 \u0628\u0627\u0631",
        3
    ],
    [
        "\u0631\u0648\u0632\u06CC \u0686\u0647\u0627\u0631 \u0628\u0627\u0631",
        4
    ],
    [
        "\u0647\u0631 \u06F4 \u0633\u0627\u0639\u062A",
        6
    ],
    [
        "\u0647\u0631 \u06F6 \u0633\u0627\u0639\u062A",
        4
    ],
    [
        "\u0647\u0631 \u06F8 \u0633\u0627\u0639\u062A",
        3
    ],
    [
        "\u0647\u0631 \u06F1\u06F2 \u0633\u0627\u0639\u062A",
        2
    ],
    [
        "\u0634\u0628\u0627\u0646\u0647 \u06CC\u06A9 \u0628\u0627\u0631",
        1
    ],
    [
        "\u0631\u0648\u0632\u06CC \u06CC\u06A9 \u0628\u0627\u0631 \u0646\u0627\u0634\u062A\u0627",
        1
    ],
    [
        "\u06CC\u06A9 \u0631\u0648\u0632 \u062F\u0631 \u0645\u06CC\u0627\u0646",
        0.5
    ],
    [
        "\u0647\u0641\u062A\u0647\u200C\u0627\u06CC \u06CC\u06A9 \u0628\u0627\u0631",
        1 / 7
    ],
    [
        "\u0647\u0641\u062A\u0647\u200C\u0627\u06CC \u062F\u0648 \u0628\u0627\u0631",
        2 / 7
    ],
    [
        "\u0647\u0631 \u06F2 \u0647\u0641\u062A\u0647 \u06CC\u06A9 \u0628\u0627\u0631",
        1 / 14
    ],
    [
        "\u0645\u0627\u0647\u06CC \u06CC\u06A9 \u0628\u0627\u0631",
        1 / 30
    ]
].map(([k, v])=>[
        $ace44487380106d3$var$freqKey(k),
        v
    ]));
const $ace44487380106d3$var$asciiDigits = (s)=>String(s ?? '').replace(/[۰-۹]/g, (d)=>String(d.charCodeAt(0) - 0x06f0)).replace(/[٠-٩]/g, (d)=>String(d.charCodeAt(0) - 0x0660)).replace(/[٫,]/g, '.');
function $ace44487380106d3$var$doseAmount(dosage) {
    const m = $ace44487380106d3$var$asciiDigits(dosage).trim().match(/^(\d+(?:\.\d+)?)\s+(.+)$/);
    if (!m || !$ace44487380106d3$var$COUNTED_IN_DOSE_UNITS.has(m[2].trim())) return null;
    const n = Number(m[1]);
    return n > 0 ? n : null;
}
// The course length, in days, from the stored duration in whichever language it
// was written («5 روز», «1 month», «3 أشهر», «7 jours», «2 mois», «7 Tage»,
// «2 Monate» — and Arabic's «شهر» / «شهران», which carry no digit). «تا اطلاع
// ثانوی» (and its «Until further notice» / «Jusqu’à nouvel ordre» / «Bis auf
// Weiteres») has no end, so no quantity follows from it.
function $ace44487380106d3$var$durationDays(duration) {
    const s = $ace44487380106d3$var$asciiDigits(duration).trim().toLowerCase();
    if (s === "\u0634\u0647\u0631") return 30;
    if (s === "\u0634\u0647\u0631\u0627\u0646") return 60;
    const m = s.match(/(\d+)\s*(روز|days?|يوم|أيام|jours?|tag(?:en|e)?|هفته|weeks?|أسبوع|أسابيع|semaines?|wochen?|ماه|months?|شهر|أشهر|mois|monat(?:en|e)?)/);
    if (!m) return null;
    const n = Number(m[1]);
    const unit = m[2];
    const per = /هفته|week|أسبوع|أسابيع|semaine|woche/.test(unit) ? 7 : /ماه|month|شهر|أشهر|mois|monat/.test(unit) ? 30 : 1;
    return n > 0 ? n * per : null;
}
function $ace44487380106d3$export$d2b1f8f4188143eb({ drug: drug, dosage: dosage, frequency: frequency, duration: duration } = {}) {
    if (drug && $ace44487380106d3$export$df367f6eb2d011ee(drug)) return null;
    const amount = $ace44487380106d3$var$doseAmount(dosage);
    const perDay = $ace44487380106d3$var$PER_DAY.get($ace44487380106d3$var$freqKey(frequency));
    const days = $ace44487380106d3$var$durationDays(duration);
    if (!amount || !perDay || !days) return null;
    // The epsilon keeps 1/7 × 7 = 1.0000000000000002 from rounding up to 2.
    return Math.max(1, Math.ceil(amount * perDay * days - 1e-9));
}
// ── Any two of مقدار تحویلی, تناوب and مدت settle the third ───────────────────
//
// quantity = دوز × doses a day × days, so a doctor who writes «۳۰ قرص، روزی سه
// بار» has said «۱۰ روز» (K1, 2026-10-03). Whichever two are set, an EMPTY third
// is worked out — as one of its own field's options, since both are closed lists:
//   • مدت: the listed duration whose count is exactly this one, else the nearest
//     listed duration within a quarter of the days the count covers (20 tablets
//     at three a day is «7 روز»); nothing when no listed duration is that close;
//   • تناوب: the option whose doses a day give exactly this count over the course,
//     «روزی N بار» before «هر X ساعت»; nothing when none does — a frequency is
//     the instruction itself, never rounded;
//   • مقدار تحویلی: as above (quantityFor).
// Counted forms only, like the quantity: a syrup's bottles say nothing of days.
// A value the doctor chose is never replaced. The field the app filled is marked
// on the line (`derivedField`, never saved) so it keeps following the other two —
// and is cleared, not left stale, once they no longer settle it.
const $ace44487380106d3$var$DURATION_TOLERANCE = 0.25;
function $ace44487380106d3$export$714272fa680980ea(row = {}, durations = []) {
    const { drug: drug, dosage: dosage, frequency: frequency } = row;
    if (drug && $ace44487380106d3$export$df367f6eb2d011ee(drug)) return '';
    const amount = $ace44487380106d3$var$doseAmount(dosage);
    const perDay = $ace44487380106d3$var$PER_DAY.get($ace44487380106d3$var$freqKey(frequency));
    const q = $ace44487380106d3$export$48f972f5effb9c(row.quantity);
    if (!amount || !perDay || !(q > 0) || !durations?.length) return '';
    const exact = durations.find((d)=>$ace44487380106d3$export$d2b1f8f4188143eb({
            drug: drug,
            dosage: dosage,
            frequency: frequency,
            duration: d
        }) === q);
    if (exact) return exact;
    const days = q / (amount * perDay);
    let best = '';
    let err = Infinity;
    for (const d of durations){
        const n = $ace44487380106d3$var$durationDays(d);
        if (!n) continue;
        const e = Math.abs(n - days) / days;
        if (e < err) {
            best = d;
            err = e;
        }
    }
    return err <= $ace44487380106d3$var$DURATION_TOLERANCE ? best : '';
}
function $ace44487380106d3$export$2992050be156a590(row = {}) {
    const { drug: drug, dosage: dosage, duration: duration } = row;
    if (drug && $ace44487380106d3$export$df367f6eb2d011ee(drug)) return '';
    const q = $ace44487380106d3$export$48f972f5effb9c(row.quantity);
    if (!$ace44487380106d3$var$doseAmount(dosage) || !$ace44487380106d3$var$durationDays(duration) || !(q > 0)) return '';
    return $ace44487380106d3$export$93a11165d6a55361.find((f)=>$ace44487380106d3$var$PER_DAY.has($ace44487380106d3$var$freqKey(f)) && $ace44487380106d3$export$d2b1f8f4188143eb({
            drug: drug,
            dosage: dosage,
            frequency: f,
            duration: duration
        }) === q) || '';
}
// The order an empty one of the three is filled in.
const $ace44487380106d3$var$RX_TRIPLE = [
    'quantity',
    'duration',
    'frequency'
];
const $ace44487380106d3$var$isEmpty = (v)=>!String(v ?? '').trim();
function $ace44487380106d3$var$deriveField(key, row, durations) {
    if (key === 'quantity') {
        const q = $ace44487380106d3$export$d2b1f8f4188143eb(row);
        return q ? String(q) : '';
    }
    return key === 'duration' ? $ace44487380106d3$export$714272fa680980ea(row, durations) : $ace44487380106d3$export$2992050be156a590(row);
}
function $ace44487380106d3$export$8dbcc67e0ab5a150(row, { durations: durations = [] } = {}) {
    if (!row) return row;
    if (!($ace44487380106d3$export$48f972f5effb9c(row.quantity) > 0)) {
        const q = $ace44487380106d3$export$d2b1f8f4188143eb(row);
        return q ? {
            ...row,
            quantity: String(q)
        } : row;
    }
    for (const key of [
        'duration',
        'frequency'
    ]){
        if (!$ace44487380106d3$var$isEmpty(row[key])) continue;
        const v = $ace44487380106d3$var$deriveField(key, row, durations);
        if (v) return {
            ...row,
            [key]: v,
            derivedField: key
        };
    }
    return row;
}
function $ace44487380106d3$export$b0f426f8468d8007(row, key, val, { durations: durations = [], targets: targets = $ace44487380106d3$var$RX_TRIPLE } = {}) {
    const next = {
        ...row,
        [key]: val
    };
    if (key !== 'dosage' && !$ace44487380106d3$var$RX_TRIPLE.includes(key)) return next;
    if (row.derivedField === key) next.derivedField = undefined; // the doctor took it over
    const open = (k)=>k !== key && targets.includes(k);
    const had = $ace44487380106d3$export$48f972f5effb9c(row.quantity);
    const target = (row.derivedField && open(row.derivedField) ? row.derivedField : null) || $ace44487380106d3$var$RX_TRIPLE.find((k)=>open(k) && $ace44487380106d3$var$isEmpty(row[k])) || (!row.derivedField && open('quantity') && had > 0 && had === $ace44487380106d3$export$d2b1f8f4188143eb(row) ? 'quantity' : null);
    if (!target) return next;
    const value = $ace44487380106d3$var$deriveField(target, next, durations);
    if (!value && $ace44487380106d3$var$isEmpty(row[target])) return next; // nothing to fill, nothing of ours to clear
    next[target] = value;
    if (target !== 'quantity') next.derivedField = value ? target : undefined;
    return next;
}
// ── An AI's answer, held to the closed lists ────────────────────────────────
//
// The «نسخه»'s AI helpers propose a whole line — and models write a dose as a
// strength («500mg»), a frequency in last year's words («شب‌ها قبل از خواب»), a
// quantity as packs («1 بسته»). Each such value would land outside the field's
// closed list and the e-prescription would refuse the line (K1, 2026-10-03). So a
// proposal's values are mapped onto the options here: the same option in other
// digits or words becomes that option; anything else is dropped, and the line
// starts from the app's own default for that field instead.
const $ace44487380106d3$var$NUMBER_WORDS = {
    "\u0646\u06CC\u0645": '0.5',
    "\u06CC\u06A9": '1',
    "\u062F\u0648": '2',
    "\u0633\u0647": '3',
    "\u0686\u0647\u0627\u0631": '4'
};
const $ace44487380106d3$var$plainKey = (s)=>String(s ?? '').replace(/[۰-۹]/g, (d)=>String(d.charCodeAt(0) - 0x06f0)).replace(/[٠-٩]/g, (d)=>String(d.charCodeAt(0) - 0x0660)).replace(/[٫,]/g, '.').replace(/[‌ ]/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase();
const $ace44487380106d3$var$doseKey = (s)=>$ace44487380106d3$var$plainKey(s).replace(/^(نیم|یک|دو|سه|چهار)(?=\s)/, (w)=>$ace44487380106d3$var$NUMBER_WORDS[w]);
function $ace44487380106d3$export$af120d81d82db54b(drug, value) {
    const k = $ace44487380106d3$var$doseKey(value);
    return k && $ace44487380106d3$export$23fceca71987facd(drug).find((o)=>$ace44487380106d3$var$doseKey(o) === k) || '';
}
function $ace44487380106d3$export$698a3d49e661c86e(value) {
    const k = $ace44487380106d3$var$freqKey(value);
    return k && $ace44487380106d3$export$93a11165d6a55361.find((o)=>$ace44487380106d3$var$freqKey(o) === k) || '';
}
function $ace44487380106d3$export$ab1f7fee793c0c30(value, options = []) {
    const k = $ace44487380106d3$var$plainKey(value);
    return k && options.find((o)=>$ace44487380106d3$var$plainKey(o) === k) || '';
}
// A مدت from outside — the model answers «7 روز» whatever language the UI reads —
// as the listed duration that covers the same days («7 jours», «7 days», «7 أيام»).
// Exact days only: a span the list does not hold is not rounded onto one.
function $ace44487380106d3$var$toDurationOption(value, durations = []) {
    const exact = $ace44487380106d3$export$ab1f7fee793c0c30(value, durations);
    if (exact) return exact;
    const days = $ace44487380106d3$var$durationDays(value);
    return days && durations.find((d)=>$ace44487380106d3$var$durationDays(d) === days) || '';
}
function $ace44487380106d3$export$e8df75bdc9e038c6(drug, defaults = {}, { durations: durations = [] } = {}) {
    const q = String(defaults.quantity ?? '').trim();
    return {
        ...defaults,
        dosage: $ace44487380106d3$export$af120d81d82db54b(drug, defaults.dosage) || undefined,
        frequency: $ace44487380106d3$export$698a3d49e661c86e(defaults.frequency) || undefined,
        route: $ace44487380106d3$export$1aea987f77fa496a(defaults.route),
        duration: $ace44487380106d3$var$toDurationOption(defaults.duration, durations),
        quantity: /^[\d۰-۹٠-٩]+$/.test(q) && $ace44487380106d3$export$48f972f5effb9c(q) > 0 ? String($ace44487380106d3$export$48f972f5effb9c(q)) : ''
    };
}
function $ace44487380106d3$export$2e037991db2fc726(drug, defaults = {}, { durations: durations = [] } = {}) {
    const out = {};
    const put = (key, value)=>{
        const v = String(value ?? '').trim();
        if (v) out[key] = v;
    };
    put('dosage', $ace44487380106d3$export$af120d81d82db54b(drug, defaults.dosage) || defaults.dosage);
    put('frequency', $ace44487380106d3$export$698a3d49e661c86e(defaults.frequency) || defaults.frequency);
    put('route', $ace44487380106d3$export$1aea987f77fa496a(defaults.route) || defaults.route);
    put('duration', $ace44487380106d3$export$ab1f7fee793c0c30(defaults.duration, durations) || defaults.duration);
    const q = String(defaults.quantity ?? '').trim();
    if (/^[\d۰-۹٠-٩]+$/.test(q) && $ace44487380106d3$export$48f972f5effb9c(q) > 0) out.quantity = String($ace44487380106d3$export$48f972f5effb9c(q));
    put('instructions', defaults.instructions);
    return out;
}
function $ace44487380106d3$export$5352dbb17a06665d(drug, defaults = {}, seq = 0, { durations: durations = [] } = {}) {
    return $ace44487380106d3$export$8dbcc67e0ab5a150({
        // Date.now() alone collides when a batch is added in the same millisecond,
        // and a duplicated React key silently drops rows from the list.
        id: `${Date.now()}-${seq}-${drug.id}`,
        drug: drug,
        dosage: defaults.dosage ?? $ace44487380106d3$export$f3c4ec3c63ab1d60(drug),
        frequency: defaults.frequency ?? $ace44487380106d3$export$84160816d8079a95(drug),
        route: defaults.route || '',
        duration: defaults.duration || '',
        quantity: defaults.quantity || '',
        instructions: defaults.instructions || ''
    }, {
        durations: durations
    });
}
function $ace44487380106d3$export$c1d8ac96a7e23c6f(row, answer, { durations: durations = [] } = {}) {
    if (!row || !answer) return row;
    let next = row;
    const fill = (key, value, open)=>{
        if (value && open) next = $ace44487380106d3$export$b0f426f8468d8007(next, key, value, {
            durations: durations
        });
    };
    fill('dosage', answer.dosage, !String(row.dosage ?? '').trim() || row.dosage === $ace44487380106d3$export$f3c4ec3c63ab1d60(row.drug));
    fill('frequency', $ace44487380106d3$export$698a3d49e661c86e(answer.frequency), !$ace44487380106d3$export$bad71ce44b13580d(row.frequency));
    fill('route', $ace44487380106d3$export$1aea987f77fa496a(answer.route), !$ace44487380106d3$export$242a279056f60471(row.route) || row.route === $ace44487380106d3$export$ae410c87a5d0011f(row.drug));
    fill('duration', answer.duration, !String(row.duration ?? '').trim());
    if (!($ace44487380106d3$export$48f972f5effb9c(next.quantity) > 0) && answer.quantity) next = {
        ...next,
        quantity: answer.quantity
    };
    return next === row ? row : {
        ...next,
        aiNote: answer.note || ''
    };
}
const $ace44487380106d3$export$eeb7c46608d96e19 = $ace44487380106d3$export$93a11165d6a55361[0];
function $ace44487380106d3$export$87bc9af39161d883(drug, usual, { defaultDuration: defaultDuration = '' } = {}) {
    const u = usual || {};
    const sig = {
        dosage: u.dosage || $ace44487380106d3$export$f3c4ec3c63ab1d60(drug),
        frequency: u.frequency || $ace44487380106d3$export$84160816d8079a95(drug) || $ace44487380106d3$export$eeb7c46608d96e19,
        route: u.route || $ace44487380106d3$export$ae410c87a5d0011f(drug),
        duration: u.duration || defaultDuration,
        instructions: u.instructions || ''
    };
    const sameSig = u.quantity && [
        'dosage',
        'frequency',
        'duration'
    ].every((k)=>sig[k] === u[k]);
    return {
        ...sig,
        quantity: sameSig ? u.quantity : ''
    };
}
function $ace44487380106d3$export$72a40f6da1cd88d8(sig = {}, usual = null) {
    const u = usual || {};
    const pick = (k)=>String(sig[k] ?? '').trim() ? sig[k] : String(u[k] ?? '').trim() ? u[k] : undefined;
    const out = {
        ...sig,
        dosage: pick('dosage'),
        frequency: pick('frequency'),
        route: pick('route') || '',
        duration: pick('duration') || '',
        instructions: pick('instructions') || ''
    };
    const given = String(sig.quantity ?? '').trim();
    const counted = u.quantity && [
        'dosage',
        'frequency',
        'duration'
    ].every((k)=>(out[k] || '') === (u[k] || ''));
    return {
        ...out,
        quantity: given ? sig.quantity : counted ? u.quantity : ''
    };
}
// ── زمان مصرف and توضیحات: one stored text, two fields (PM-0574) ──────────────
//
// A line keeps ONE `instructions` text — what the record, the printed نسخه and
// the e-prescription carry. The add form offers it as two fields, a زمان مصرف
// chip and a free توضیحات, which used to write the same text: a chip replaced
// what was typed and typing replaced the chip. They are now held apart and
// joined on the way out; a text read back that begins with a chip is split.
// Anything that may stand between the chip and the rest of the text.
const $ace44487380106d3$var$INSTRUCTION_SEP = /^[\s،,؛;·\-–—]+/;
function $ace44487380106d3$export$71de4099086ae7ae(text, whenOptions = []) {
    const s = String(text ?? '').trim();
    for (const w of whenOptions){
        if (!w || !s.startsWith(w)) continue;
        const rest = s.slice(w.length);
        if (rest && !$ace44487380106d3$var$INSTRUCTION_SEP.test(rest)) continue; // «بعد از غذای…» is not the chip
        return {
            when: w,
            note: rest.replace($ace44487380106d3$var$INSTRUCTION_SEP, '').trim()
        };
    }
    return {
        when: '',
        note: s
    };
}
function $ace44487380106d3$export$5abd89ce1bdd9342(when, note) {
    const w = String(when ?? '').trim();
    const n = String(note ?? '').trim();
    if (!w || !n) return w || n;
    return `${w}${/[\u0600-\u06FF]/.test(w) ? "\u060C" : ','} ${n}`;
}
function $ace44487380106d3$export$e4f91298b6c5a0f0(label) {
    const s = String(label || '').replace(/[أإآ]/g, "\u0627").replace(/\s+/g, ' ').trim().toLowerCase();
    if (!s) return null;
    if (s.includes("\u062A\u0627\u0645\u06CC\u0646") || s === 'social' || s.includes('tamin')) return 'tamin';
    return null;
}
function $ace44487380106d3$export$60f8cb686aa6701e(drug, insurer) {
    if (insurer !== 'tamin' || !drug?.id) return null;
    return typeof drug.taminListed === 'boolean' ? drug.taminListed : null;
}
function $ace44487380106d3$export$6c8fe862de8e39ae(drugs, insurer) {
    const states = (drugs || []).map((d)=>$ace44487380106d3$export$60f8cb686aa6701e(d, insurer));
    if (states.some((s)=>s === true)) return true;
    return states.length && states.every((s)=>s === false) ? false : null;
}
function $ace44487380106d3$export$fd52a5511e853f43(entry, lists) {
    if (!entry?.drug?.id) return null;
    const sig = {
        dosage: entry.dosage,
        frequency: entry.frequency,
        route: entry.route,
        duration: entry.duration,
        quantity: entry.quantity
    };
    const mapped = $ace44487380106d3$export$e8df75bdc9e038c6(entry.drug, sig, lists);
    const intact = [
        'dosage',
        'frequency',
        'duration'
    ].every((k)=>mapped[k]);
    return {
        dosage: mapped.dosage,
        frequency: mapped.frequency,
        route: mapped.route,
        duration: mapped.duration,
        quantity: intact ? mapped.quantity : '',
        instructions: String(entry.instructions || '').trim()
    };
}
function $ace44487380106d3$export$7fc1a2f08e2a58c0(entries, drug, sig) {
    const list = Array.isArray(entries) ? entries : [];
    if (!drug?.id) return list;
    const s = (k)=>String(sig?.[k] ?? '').trim();
    const values = {
        dosage: s('dosage'),
        frequency: s('frequency'),
        route: s('route'),
        duration: s('duration'),
        quantity: s('quantity'),
        instructions: s('instructions')
    };
    if (list.some((e)=>e?.drug?.id === drug.id)) return list.map((e)=>e?.drug?.id === drug.id ? {
            ...e,
            ...values
        } : e);
    return [
        {
            times: 1,
            name: drug.name || drug.genericName || '',
            search: '',
            ...values,
            drug: drug
        },
        ...list
    ];
}
function $ace44487380106d3$export$c19989f0228742e1(entries, usualRx) {
    return (entries || []).filter((e)=>e?.drug?.id && usualRx?.get?.(e.drug.id)).map((e)=>({
            drug: e.drug,
            sig: usualRx.get(e.drug.id),
            times: Number(e.times) || 0
        }));
}

});



parcelRegister("lfHhF", function(module, exports) {

$parcel$export(module.exports, "drugFrequencyLabel", () => $f78c92fb84c2d04c$export$d93ed016efabc5b);
$parcel$export(module.exports, "orderCategoryLabel", () => $f78c92fb84c2d04c$export$79313fed3d273b1f);
// ─────────────────────────────────────────────────────────────────────────────
// The drug formulary's own vocabulary, in the reading language.
//
// The formulary is the Iranian IRC registry: 37,120 rows whose `category` and
// `common_frequencies` are Persian. Those two fields are NOT free text — they
// are closed vocabularies of 56 and 42 values respectively, repeated across the
// whole table. So they are translated here, at the display edge, rather than by
// adding a column: 98 strings instead of 37,120 rows, and it covers every row
// including the ~36,500 that live only in the database and not in any seed file.
//
// `category` is ALSO A FILTER KEY — `listDrugs(category:)` and `drugCategories`
// query it — so the stored Persian value is never replaced, only displayed
// differently. Everything here maps value → key and leaves the value alone.
//
// A value with no mapping renders AS ITSELF. That is deliberate and not a gap:
// a clinic's own custom entry, or a formulary value added after this file, must
// still show the doctor something true rather than a blank or a humanised key.
// ─────────────────────────────────────────────────────────────────────────────
/**
 * Fold the spelling variants that render identically.
 *
 * Persian text arrives with and without ZWNJ («آنتی‌بیوتیک» / «آنتیبیوتیک»),
 * and rows keyed by hand carry Arabic yeh (U+064A) and kaf (U+0643) where
 * Persian uses yeh (U+06CC) and keh (U+06A9) — indistinguishable on screen and
 * different bytes. The AI service's `specialty.py` documents the same trap for
 * specialty names. An `===` against one spelling silently misses the others.
 */ const $f78c92fb84c2d04c$export$c7eebf90714d5a8a = (value)=>String(value || '').replace(/\u200c/g, '') // ZWNJ
    .replace(/\u064a/g, '\u06cc') // Arabic yeh → Persian yeh
    .replace(/\u0643/g, '\u06a9') // Arabic kaf → Persian keh
    .replace(/\s+/g, ' ').trim();
/**
 * Category → key. Several Persian spellings deliberately share one key: the
 * table holds two overlapping taxonomies (16 imported IRC/ATC groups over
 * ~36,600 rows, 40 curated ones over ~520) and «قلب و عروق» and «قلبی - عروقی»
 * are the same category written twice. Mapping both to one key merges them for
 * the reader WITHOUT touching the stored values or the filter.
 */ // i18n-exempt: these are MATCHERS against the formulary's own stored values,
// not UI copy. The Persian on the left is what the database holds; the
// translation is the key on the right. Written as the data appears so the
// table stays reviewable against a `SELECT DISTINCT category FROM drugs`.
const $f78c92fb84c2d04c$var$CATEGORY_KEYS = {
    "\u0628\u06CC\u0647\u0648\u0634\u06CC / \u0627\u0648\u0631\u0698\u0627\u0646\u0633": 'anaesthesiaEmergency',
    "\u0645\u0633\u06A9\u0646 / \u0636\u062F\u0627\u0644\u062A\u0647\u0627\u0628": 'analgesicAntiInflammatory',
    "\u0645\u0633\u06A9\u0646": 'analgesics',
    "\u0636\u062F\u0622\u0644\u0631\u0698\u06CC": 'antiallergics',
    "\u0622\u0646\u062A\u06CC\u200C\u0628\u06CC\u0648\u062A\u06CC\u06A9": 'antibiotics',
    "\u0636\u062F \u062F\u06CC\u0627\u0628\u062A": 'antidiabetics',
    "\u0636\u062F\u0642\u0627\u0631\u0686": 'antifungals',
    "\u0636\u062F \u0645\u0627\u0644\u0627\u0631\u06CC\u0627": 'antimalarials',
    "\u0636\u062F\u0633\u0631\u0637\u0627\u0646 \u0648 \u062A\u0639\u062F\u06CC\u0644 \u0627\u06CC\u0645\u0646\u06CC": 'antineoplastic',
    "\u0636\u062F\u0627\u0646\u06AF\u0644": 'antiparasitic',
    "\u0636\u062F \u0633\u0644": 'antituberculars',
    "\u0636\u062F\u0648\u06CC\u0631\u0648\u0633": 'antivirals',
    "\u062E\u0648\u0646 / \u0627\u0646\u0639\u0642\u0627\u062F": 'bloodCoagulation',
    "\u062E\u0648\u0646 \u0648 \u062E\u0648\u0646\u200C\u0633\u0627\u0632\u06CC": 'bloodForming',
    "\u0642\u0644\u0628 \u0648 \u0639\u0631\u0648\u0642": 'cardiovascular',
    "\u06A9\u0648\u0631\u062A\u06CC\u06A9\u0648\u0627\u0633\u062A\u0631\u0648\u0626\u06CC\u062F": 'corticosteroids',
    "\u067E\u0648\u0633\u062A": 'dermatologicals',
    "\u063A\u062F\u062F \u062F\u0631\u0648\u0646\u200C\u0631\u06CC\u0632": 'endocrine',
    "\u06AF\u0648\u0634 \u0648 \u062D\u0644\u0642 \u0648 \u0628\u06CC\u0646\u06CC": 'ent',
    "\u0635\u0631\u0639": 'epilepsy',
    "\u0635\u0631\u0639 / \u062F\u0631\u062F \u0639\u0635\u0628\u06CC": 'epilepsyNeuropathic',
    "\u06AF\u0648\u0627\u0631\u0634\u06CC": 'gastrointestinal',
    "\u0627\u062F\u0631\u0627\u0631\u06CC\u200C\u062A\u0646\u0627\u0633\u0644\u06CC \u0648 \u0647\u0648\u0631\u0645\u0648\u0646 \u062C\u0646\u0633\u06CC": 'genitourinary',
    "\u06AF\u0648\u0627\u0631\u0634 \u0648 \u0645\u062A\u0627\u0628\u0648\u0644\u06CC\u0633\u0645": 'giMetabolism',
    "\u0646\u0642\u0631\u0633": 'gout',
    "\u0647\u0648\u0631\u0645\u0648\u0646\u06CC / \u0628\u0627\u0631\u0648\u0631\u06CC": 'hormonalFertility',
    "\u062E\u0648\u0627\u0628\u200C\u0622\u0648\u0631": 'hypnotics',
    "\u0633\u0631\u0645 / \u0627\u0644\u06A9\u062A\u0631\u0648\u0644\u06CC\u062A": 'ivFluids',
    "\u0645\u06CC\u06AF\u0631\u0646": 'migraine',
    "\u0645\u06CC\u06AF\u0631\u0646 / \u0635\u0631\u0639": 'migraineEpilepsy',
    "\u0627\u0633\u06A9\u0644\u062A\u06CC\u200C\u0639\u0636\u0644\u0627\u0646\u06CC": 'musculoskeletal',
    "\u0646\u0641\u0631\u0648\u0644\u0648\u0698\u06CC": 'nephrology',
    "\u0633\u06CC\u0633\u062A\u0645 \u0639\u0635\u0628\u06CC": 'nervousSystem',
    "\u0646\u0648\u0631\u0648\u0644\u0648\u0698\u06CC": 'neurology',
    "\u062F\u0631\u062F \u0639\u0635\u0628\u06CC": 'neuropathicPain',
    "\u0632\u0646\u0627\u0646 \u0648 \u0632\u0627\u06CC\u0645\u0627\u0646": 'obgyn',
    "\u0627\u0646\u06A9\u0648\u0644\u0648\u0698\u06CC": 'oncology',
    "\u0686\u0634\u0645\u200C\u067E\u0632\u0634\u06A9\u06CC": 'ophthalmology',
    "\u0645\u0633\u06A9\u0646 \u0627\u0648\u067E\u06CC\u0648\u0626\u06CC\u062F\u06CC": 'opioidAnalgesics',
    "\u067E\u0648\u06A9\u06CC \u0627\u0633\u062A\u062E\u0648\u0627\u0646": 'osteoporosis',
    "\u0633\u0627\u06CC\u0631": 'other',
    "\u0631\u0648\u0627\u0646\u200C\u067E\u0632\u0634\u06A9\u06CC": 'psychiatry',
    "\u0631\u0648\u0627\u0646\u200C\u067E\u0632\u0634\u06A9\u06CC / \u0635\u0631\u0639": 'psychiatryEpilepsy',
    "\u062F\u0633\u062A\u06AF\u0627\u0647 \u062A\u0646\u0641\u0633": 'respiratory',
    "\u0631\u0648\u0645\u0627\u062A\u0648\u0644\u0648\u0698\u06CC / \u0627\u06CC\u0645\u0648\u0646\u0648\u0644\u0648\u0698\u06CC": 'rheumImmunology',
    "\u0686\u0634\u0645 \u0648 \u06AF\u0648\u0634": 'sensoryOrgans',
    "\u0645\u06A9\u0645\u0644 \u0648 \u0633\u0627\u06CC\u0631": 'supplementsOther',
    "\u0636\u062F\u0639\u0641\u0648\u0646\u062A \u0633\u06CC\u0633\u062A\u0645\u06CC\u06A9": 'systemicAntiInfective',
    "\u0647\u0648\u0631\u0645\u0648\u0646\u200C\u0647\u0627\u06CC \u0633\u06CC\u0633\u062A\u0645\u06CC\u06A9": 'systemicHormonal',
    "\u062F\u0627\u0631\u0648\u06CC\u06CC - \u0637\u0628\u0642\u0647\u200C\u0628\u0646\u062F\u06CC\u200C\u0646\u0634\u062F\u0647": 'unclassified',
    "\u0627\u0648\u0631\u0648\u0644\u0648\u0698\u06CC": 'urology',
    "\u0648\u06CC\u062A\u0627\u0645\u06CC\u0646 / \u0645\u06A9\u0645\u0644": 'vitaminsSupplements',
    "\u062A\u0646\u0641\u0633\u06CC": 'respiratory',
    "\u0636\u062F \u0627\u0646\u06AF\u0644": 'antiparasitic',
    "\u0639\u0636\u0644\u0647\u200C\u0627\u06CC - \u0627\u0633\u06A9\u0644\u062A\u06CC": 'musculoskeletal',
    "\u0642\u0644\u0628\u06CC - \u0639\u0631\u0648\u0642\u06CC": 'cardiovascular'
};
/** Dosing frequency → key. Present on 616 rows; the imported rows carry none. */ // i18n-exempt: matchers against stored formulary values, as above.
const $f78c92fb84c2d04c$var$FREQUENCY_KEYS = {
    "\u0628\u0639\u062F \u0627\u0632 \u0647\u0631 \u0627\u0633\u0647\u0627\u0644": 'afterEachStool',
    "\u062F\u0631 \u0635\u0648\u0631\u062A \u0646\u06CC\u0627\u0632": 'asNeeded',
    "\u062F\u0631 \u0635\u0648\u0631\u062A \u0646\u06CC\u0627\u0632 (\u062D\u062F\u0627\u06A9\u062B\u0631 \u0631\u0648\u0632\u06CC \u062F\u0648 \u0628\u0627\u0631)": 'asNeededMaxTwiceDaily',
    "\u062F\u0631 \u0635\u0648\u0631\u062A \u0646\u06CC\u0627\u0632 (\u06CC\u06A9 \u0633\u0627\u0639\u062A \u0642\u0628\u0644)": 'asNeededOneHourBefore',
    "\u0642\u0628\u0644 \u0627\u0632 \u0648\u0639\u062F\u0647 \u063A\u0630\u0627\u06CC\u06CC": 'beforeMeals',
    "\u0647\u0631 \u06F1\u06F2 \u0647\u0641\u062A\u0647 \u06CC\u06A9 \u0628\u0627\u0631": 'every12WeeksOnce',
    "\u0647\u0631 \u06F1\u06F2 \u0633\u0627\u0639\u062A": 'every12h',
    "\u0647\u0631 \u06F2 \u0647\u0641\u062A\u0647": 'every2Weeks',
    "\u0647\u0631 \u06F2 \u0647\u0641\u062A\u0647 \u06CC\u06A9 \u0628\u0627\u0631": 'every2WeeksOnce',
    "\u0647\u0631 \u06F3 \u0647\u0641\u062A\u0647 \u06CC\u06A9 \u0628\u0627\u0631": 'every3Weeks',
    "\u0647\u0631 \u06F4 \u0647\u0641\u062A\u0647": 'every4Weeks',
    "\u0647\u0631 \u06F4 \u0647\u0641\u062A\u0647 \u06CC\u06A9 \u0628\u0627\u0631": 'every4WeeksOnce',
    "\u0647\u0631 \u06F4 \u0633\u0627\u0639\u062A": 'every4h',
    "\u0647\u0631 \u06F4 \u062A\u0627 \u06F6 \u0633\u0627\u0639\u062A": 'every4to6h',
    "\u0647\u0631 \u06F6 \u0645\u0627\u0647": 'every6Months',
    "\u0647\u0631 \u06F6 \u0645\u0627\u0647 \u06CC\u06A9 \u0628\u0627\u0631": 'every6MonthsOnce',
    "\u0647\u0631 \u06F6 \u0633\u0627\u0639\u062A": 'every6h',
    "\u0647\u0631 \u06F6 \u062A\u0627 \u06F8 \u0633\u0627\u0639\u062A": 'every6to8h',
    "\u0647\u0631 \u06F8 \u0647\u0641\u062A\u0647 \u06CC\u06A9 \u0628\u0627\u0631": 'every8WeeksOnce',
    "\u0647\u0631 \u06F8 \u0633\u0627\u0639\u062A": 'every8h',
    "\u06CC\u06A9 \u0631\u0648\u0632 \u062F\u0631 \u0645\u06CC\u0627\u0646": 'everyOtherDay',
    "\u0647\u0631 \u062F\u0648 \u0647\u0641\u062A\u0647 \u06CC\u06A9 \u0628\u0627\u0631": 'everyTwoWeeks',
    "\u0631\u0648\u0632\u06CC \u067E\u0646\u062C \u0628\u0627\u0631": 'fiveTimesDaily',
    "\u0631\u0648\u0632\u06CC \u0686\u0647\u0627\u0631 \u0628\u0627\u0631": 'fourTimesDaily',
    "\u062D\u062F\u0627\u06A9\u062B\u0631 \u06F8mg \u062F\u0631 \u0631\u0648\u0632": 'max8mgPerDay',
    "\u06CC\u06A9 \u0628\u0627\u0631 (\u06F8 \u062A\u0627 \u06F1\u06F4 \u0633\u0627\u0639\u062A)": 'once8to14h',
    "\u0634\u0628\u0627\u0646\u0647 \u06CC\u06A9 \u0628\u0627\u0631": 'onceAtNight',
    "\u0631\u0648\u0632\u06CC \u06CC\u06A9 \u0628\u0627\u0631": 'onceDaily',
    "\u0631\u0648\u0632\u06CC \u06CC\u06A9 \u0628\u0627\u0631 (10mg)": 'onceDaily10mg',
    "\u0631\u0648\u0632\u06CC \u06CC\u06A9 \u0628\u0627\u0631 \u0646\u0627\u0634\u062A\u0627": 'onceDailyFasting',
    "\u0631\u0648\u0632\u06CC \u06CC\u06A9 \u0628\u0627\u0631 (SR)": 'onceDailySR',
    "\u0645\u0627\u0647\u06CC \u06CC\u06A9 \u0628\u0627\u0631": 'onceMonthly',
    "\u0647\u0641\u062A\u0647\u200C\u0627\u06CC \u06CC\u06A9 \u0628\u0627\u0631": 'onceWeekly',
    "\u0647\u0641\u062A\u0647\u200C\u0627\u06CC \u06CC\u06A9 \u0628\u0627\u0631 (70mg)": 'onceWeekly70mg',
    "\u0633\u0627\u0644\u06CC \u06CC\u06A9 \u0628\u0627\u0631": 'onceYearly',
    "\u062F\u0648\u0632 \u0648\u0627\u062D\u062F": 'singleDose',
    "\u06CC\u06A9 \u0628\u0627\u0631 (\u062F\u0648\u0632)": 'singleDoseParen',
    "\u0631\u0648\u0632\u06CC \u0633\u0647 \u0628\u0627\u0631": 'threeTimesDaily',
    "\u0647\u0641\u062A\u0647\u200C\u0627\u06CC \u0633\u0647 \u0628\u0627\u0631": 'threeTimesWeekly',
    "\u0631\u0648\u0632\u06CC \u062F\u0648 \u0628\u0627\u0631": 'twiceDaily',
    "\u0647\u0641\u062A\u0647\u200C\u0627\u06CC \u062F\u0648 \u0628\u0627\u0631": 'twiceWeekly',
    "\u0647\u0645\u0631\u0627\u0647 \u0628\u0627 \u0648\u0639\u062F\u0647 \u063A\u0630\u0627\u06CC\u06CC": 'withMeals'
};
// The tables above are written with the values as they appear in the database,
// which is what makes them reviewable against a `SELECT DISTINCT`. They are
// re-keyed through the SAME normaliser the lookup uses, once at module load, so
// a key containing a ZWNJ («آنتی‌بیوتیک») cannot fail to match its own value.
// Writing the table pre-normalised instead would have made every entry
// unrecognisable next to the data it describes.
const $f78c92fb84c2d04c$var$normalizedTable = (table)=>Object.fromEntries(Object.entries(table).map(([value, slug])=>[
            $f78c92fb84c2d04c$export$c7eebf90714d5a8a(value),
            slug
        ]));
const $f78c92fb84c2d04c$export$c8fcf34a4f7c8505 = (table, prefix)=>{
    const byNormalized = $f78c92fb84c2d04c$var$normalizedTable(table);
    return (value, t)=>{
        const raw = String(value || '').trim();
        if (!raw) return '';
        const slug = byNormalized[$f78c92fb84c2d04c$export$c7eebf90714d5a8a(raw)];
        return slug ? t(`${prefix}.${slug}`) : raw;
    };
};
const $f78c92fb84c2d04c$var$lookup = $f78c92fb84c2d04c$export$c8fcf34a4f7c8505;
const $f78c92fb84c2d04c$export$6ff5af8a69b07db4 = $f78c92fb84c2d04c$var$lookup($f78c92fb84c2d04c$var$CATEGORY_KEYS, 'visit.rx.drugCategory');
const $f78c92fb84c2d04c$export$d93ed016efabc5b = $f78c92fb84c2d04c$var$lookup($f78c92fb84c2d04c$var$FREQUENCY_KEYS, 'visit.rx.frequencyValue');
// The ORDER catalogue has its own category vocabulary — 38 values — and it is
// NOT the drug one. Only six strings appear in both, so one shared table would
// have silently mistranslated the rest.
//
// i18n-exempt: matchers against stored catalogue values, as above.
const $f78c92fb84c2d04c$var$ORDER_CATEGORY_KEYS = {
    "\u0628\u06CC\u0648\u0634\u06CC\u0645\u06CC": 'biochemistry',
    "\u0642\u0644\u0628": 'cardiac',
    "\u0642\u0644\u0628 \u0648 \u0639\u0631\u0648\u0642": 'cardiovascular',
    "CT Scan": 'ctScan',
    "\u067E\u0648\u0633\u062A": 'dermatology',
    "\u062A\u0634\u062E\u06CC\u0635\u06CC": 'diagnostic',
    "\u0645\u0633\u062A\u0646\u062F\u0633\u0627\u0632\u06CC": 'documentation',
    "\u062E\u0627\u0631\u062C\u200C\u062F\u0647\u0627\u0646\u06CC": 'extraoral',
    "\u062B\u0627\u0628\u062A": 'fixed',
    "\u06AF\u0648\u0627\u0631\u0634\u06CC": 'gastrointestinal',
    "\u0632\u0646\u0627\u0646": 'gynaecology',
    "\u0647\u0645\u0627\u062A\u0648\u0644\u0648\u0698\u06CC": 'haematology',
    "\u0647\u0648\u0631\u0645\u0648\u0646": 'hormone',
    "\u0627\u06CC\u0645\u067E\u0644\u0646\u062A": 'implant',
    "\u0627\u0644\u062A\u0647\u0627\u0628": 'inflammation',
    "\u062F\u0627\u062E\u0644\u200C\u062F\u0647\u0627\u0646\u06CC": 'intraoral',
    "\u0686\u0631\u0628\u06CC\u200C\u0647\u0627": 'lipids',
    "\u0639\u0645\u0644\u06A9\u0631\u062F \u06A9\u0628\u062F": 'liverFunction',
    "\u0645\u06CC\u06A9\u0631\u0648\u0628\u06CC\u0648\u0644\u0648\u0698\u06CC": 'microbiology',
    "MRI": 'mri',
    "\u0646\u0648\u0631\u0648\u0644\u0648\u0698\u06CC": 'neurology',
    "\u0627\u0631\u062A\u0648\u062F\u0646\u0633\u06CC": 'orthodontics',
    "\u0627\u0631\u062A\u0648\u067E\u062F\u06CC": 'orthopaedics',
    "\u0633\u0627\u06CC\u0631": 'other',
    "\u0641\u06CC\u0632\u06CC\u0648\u062A\u0631\u0627\u067E\u06CC": 'physiotherapy',
    "\u0631\u06CC\u0648\u06CC": 'pulmonary',
    "\u0631\u0627\u062F\u06CC\u0648\u06AF\u0631\u0627\u0641\u06CC": 'radiography',
    "\u0645\u062A\u062D\u0631\u06A9": 'removable',
    "\u0631\u0648\u0645\u0627\u062A\u0648\u0644\u0648\u0698\u06CC": 'rheumatology',
    "\u0633\u0631\u0648\u0644\u0648\u0698\u06CC": 'serology',
    "\u0627\u0633\u067E\u0644\u06CC\u0646\u062A": 'splint',
    "\u0633\u0647\u200C\u0628\u0639\u062F\u06CC": 'threeD',
    "\u062A\u06CC\u0631\u0648\u0626\u06CC\u062F": 'thyroid',
    "\u0627\u062A\u0627\u0642 \u062F\u0631\u0645\u0627\u0646": 'treatmentRoom',
    "\u062A\u0648\u0645\u0648\u0631\u0645\u0627\u0631\u06A9\u0631": 'tumourMarkers',
    "\u0633\u0648\u0646\u0648\u06AF\u0631\u0627\u0641\u06CC": 'ultrasound',
    "\u0627\u062F\u0631\u0627\u0631": 'urine',
    "\u0627\u0648\u0631\u0648\u0644\u0648\u0698\u06CC": 'urology',
    "\u0622\u0632\u0645\u0627\u06CC\u0634": 'laboratory',
    "\u0627\u0646\u062F\u0648\u062F\u0627\u0646\u062A\u06CC\u06A9\u0633": 'endodontics',
    "\u062A\u0631\u0645\u06CC\u0645\u06CC": 'restorative',
    "\u062C\u0631\u0627\u062D\u06CC": 'surgery',
    "\u0632\u06CC\u0628\u0627\u06CC\u06CC": 'cosmetic',
    "\u0648\u06CC\u0632\u06CC\u062A": 'visit',
    "\u067E\u0631\u0648\u062A\u0632 \u062B\u0627\u0628\u062A": 'fixedProsthesis',
    "\u067E\u0631\u0648\u062A\u0632 \u0645\u062A\u062D\u0631\u06A9": 'removableProsthesis',
    "\u067E\u0631\u06CC\u0648\u062F\u0646\u062A\u06CC\u06A9\u0633": 'periodontics',
    "\u067E\u06CC\u0634\u06AF\u06CC\u0631\u06CC": 'prevention',
    "\u06A9\u0648\u062F\u06A9\u0627\u0646": 'paediatrics'
};
const $f78c92fb84c2d04c$export$79313fed3d273b1f = $f78c92fb84c2d04c$var$lookup($f78c92fb84c2d04c$var$ORDER_CATEGORY_KEYS, 'visit.orders.category');

});

parcelRegister("gq4TR", function(module, exports) {

$parcel$export(module.exports, "INSURANCE_LABEL_KEYS", () => $bf42e0131d395ab7$export$a69e980913efc937);
$parcel$export(module.exports, "NOTE_TYPE_LABEL_KEYS", () => $bf42e0131d395ab7$export$fe67f05a766290fd);
$parcel$export(module.exports, "STATUS_MED_KEYS", () => $bf42e0131d395ab7$export$8bd836c94e04bf93);
$parcel$export(module.exports, "STATUS_COND_KEYS", () => $bf42e0131d395ab7$export$eb40f3474cc5e6d5);
$parcel$export(module.exports, "ENC_TYPE_KEYS", () => $bf42e0131d395ab7$export$e06a38df942076e8);
$parcel$export(module.exports, "ENC_STATUS_KEYS", () => $bf42e0131d395ab7$export$74eff50fc31aba23);
$parcel$export(module.exports, "SOAP_SECTIONS", () => $bf42e0131d395ab7$export$f3254cc21757d13e);
$parcel$export(module.exports, "ORDER_TYPE_KEYS", () => $bf42e0131d395ab7$export$a7724bba2d8d6794);
$parcel$export(module.exports, "VITAL_LOINC_SET", () => $bf42e0131d395ab7$export$520152d4ddd823c6);
$parcel$export(module.exports, "VITAL_DEFS", () => $bf42e0131d395ab7$export$92cbb70125dbdf80);
$parcel$export(module.exports, "LAB_CATEGORIES", () => $bf42e0131d395ab7$export$5a8441d057c1b67f);
$parcel$export(module.exports, "obsLabCategory", () => $bf42e0131d395ab7$export$88ddf826312c2ac7);
$parcel$export(module.exports, "FILE_CATEGORIES", () => $bf42e0131d395ab7$export$db667ec233a83b);
$parcel$export(module.exports, "resolveFileCat", () => $bf42e0131d395ab7$export$3d3bfe33466ff5e);
$parcel$export(module.exports, "mergeClinicalAndStorageFiles", () => $bf42e0131d395ab7$export$f0dc803487bda7d5);

var $1Qo7B = parcelRequire("1Qo7B");
const $bf42e0131d395ab7$export$a69e980913efc937 = {
    social: 'patient.insurance.social',
    military: 'patient.insurance.military',
    health: 'patient.insurance.health',
    other: 'patient.insurance.other',
    // patientmanagement now derives `patients.insurance` from the patient's policy
    // row and writes the insurer's PERSIAN name, and older rows hold whatever a
    // panel typed. Each spelling reads through the same key, so an English doctor
    // sees «Social Security», not «تامین اجتماعی».
    // i18n-exempt: stored values matched here, not UI copy.
    "\u062A\u0627\u0645\u06CC\u0646 \u0627\u062C\u062A\u0645\u0627\u0639\u06CC": 'patient.insurance.social',
    "\u062A\u0623\u0645\u06CC\u0646 \u0627\u062C\u062A\u0645\u0627\u0639\u06CC": 'patient.insurance.social',
    "\u0628\u06CC\u0645\u0647 \u062A\u0627\u0645\u06CC\u0646 \u0627\u062C\u062A\u0645\u0627\u0639\u06CC": 'patient.insurance.social',
    "\u0646\u06CC\u0631\u0648\u0647\u0627\u06CC \u0645\u0633\u0644\u062D": 'patient.insurance.military',
    "\u0628\u06CC\u0645\u0647 \u0633\u0644\u0627\u0645\u062A": 'patient.insurance.health',
    "\u0628\u06CC\u0645\u0647\u0654 \u0633\u0644\u0627\u0645\u062A": 'patient.insurance.health',
    "\u0622\u0632\u0627\u062F": 'patient.insurance.other',
    "\u0633\u0627\u06CC\u0631 / \u0622\u0632\u0627\u062F": 'patient.insurance.other',
    "\u0633\u0627\u06CC\u0631/\u0622\u0632\u0627\u062F": 'patient.insurance.other'
};
const $bf42e0131d395ab7$export$8b0ae89b0b488ed9 = [
    'SOAP',
    'consultation',
    'discharge',
    'referral',
    'other'
];
const $bf42e0131d395ab7$export$fe67f05a766290fd = {
    SOAP_NOTE: 'patient.noteType.SOAP_NOTE',
    VISIT_SUMMARY: 'patient.noteType.VISIT_SUMMARY',
    PROCEDURE_NOTE: 'patient.noteType.PROCEDURE_NOTE'
};
const $bf42e0131d395ab7$export$8bd836c94e04bf93 = {
    active: 'patient.medStatus.active',
    'on-hold': 'patient.medStatus.onHold',
    stopped: 'patient.medStatus.stopped',
    completed: 'patient.medStatus.completed'
};
const $bf42e0131d395ab7$export$eb40f3474cc5e6d5 = {
    active: 'patient.condStatus.active',
    resolved: 'patient.condStatus.resolved',
    inactive: 'patient.condStatus.inactive',
    recurrence: 'patient.condStatus.recurrence'
};
const $bf42e0131d395ab7$export$e06a38df942076e8 = {
    OUTPATIENT: 'patient.encType.outpatient',
    outpatient: 'patient.encType.outpatient',
    INPATIENT: 'patient.encType.inpatient',
    inpatient: 'patient.encType.inpatient',
    EMERGENCY: 'patient.encType.emergency',
    emergency: 'patient.encType.emergency',
    FOLLOW_UP: 'patient.encType.followUp',
    follow_up: 'patient.encType.followUp',
    ambulatory: 'patient.encType.outpatient'
};
const $bf42e0131d395ab7$export$74eff50fc31aba23 = {
    'in-progress': 'patient.encStatus.inProgress',
    active: 'patient.encStatus.inProgress',
    completed: 'patient.encStatus.finished',
    finished: 'patient.encStatus.finished',
    cancelled: 'patient.encStatus.cancelled'
};
const $bf42e0131d395ab7$export$f3254cc21757d13e = [
    {
        k: 'S',
        nameKey: 'patient.soap.subjective',
        types: [
            'SOAP_S',
            'subjective',
            'chief_complaint',
            'history'
        ]
    },
    {
        k: 'O',
        nameKey: 'patient.soap.objective',
        types: [
            'SOAP_O',
            'objective',
            'examination',
            'findings'
        ]
    },
    {
        k: 'A',
        nameKey: 'patient.soap.assessment',
        types: [
            'SOAP_A',
            'assessment',
            'evaluation'
        ]
    },
    {
        k: 'P',
        nameKey: 'patient.soap.plan',
        types: [
            'SOAP_P',
            'plan',
            'treatment_plan'
        ]
    }
];
const $bf42e0131d395ab7$export$a7724bba2d8d6794 = {
    lab: 'patient.orderType.lab',
    imaging: 'patient.orderType.imaging',
    procedure: 'patient.orderType.procedure',
    other: 'patient.orderType.other'
};
const $bf42e0131d395ab7$export$4a1cfa27d42d8e0c = {
    requested: 'patient.orderStat.requested',
    completed: 'patient.orderStat.completed',
    cancelled: 'patient.orderStat.cancelled'
};
const $bf42e0131d395ab7$export$4db6aab28b3b7a99 = {
    requested: 'amber',
    completed: 'good',
    cancelled: 'muted'
};
const $bf42e0131d395ab7$export$520152d4ddd823c6 = new Set([
    '8480-6',
    '8462-4',
    '8867-4',
    '59408-5',
    '2708-6',
    '8310-5',
    '29463-7',
    '55284-4',
    '9279-1'
]);
const $bf42e0131d395ab7$export$92cbb70125dbdf80 = [
    {
        id: 'bp',
        labelKey: 'patient.vitals.bp',
        loinc: '55284-4',
        unit: 'mmHg',
        icon: 'HeartPulse',
        refLow: 90,
        refHigh: 140
    },
    {
        id: 'hr',
        labelKey: 'patient.vitals.hr',
        loinc: '8867-4',
        unit: 'bpm',
        icon: 'Activity',
        refLow: 60,
        refHigh: 100
    },
    {
        id: 'temp',
        labelKey: 'patient.vitals.temp',
        loinc: '8310-5',
        unit: "\xb0C",
        icon: 'Thermometer',
        refLow: 36.1,
        refHigh: 37.2
    },
    {
        id: 'spo2',
        labelKey: 'patient.vitals.spo2',
        loinc: '59408-5',
        unit: '%',
        icon: 'Wind',
        refLow: 95,
        refHigh: 100
    },
    {
        id: 'wt',
        labelKey: 'patient.vitals.wt',
        loinc: '29463-7',
        unit: 'kg',
        icon: 'Scale',
        refLow: null,
        refHigh: null
    }
];
const $bf42e0131d395ab7$export$5a8441d057c1b67f = [
    {
        id: 'vitals',
        labelKey: 'patient.labCategory.vitals',
        color: '#ef4444',
        tests: [
            "\u0641\u0634\u0627\u0631 \u0633\u06CC\u0633\u062A\u0648\u0644\u06CC\u06A9",
            "\u0641\u0634\u0627\u0631 \u062F\u06CC\u0627\u0633\u062A\u0648\u0644\u06CC\u06A9",
            "\u0636\u0631\u0628\u0627\u0646 \u0642\u0644\u0628",
            "\u0627\u0634\u0628\u0627\u0639 \u0627\u06A9\u0633\u06CC\u0698\u0646",
            "\u062F\u0645\u0627\u06CC \u0628\u062F\u0646",
            "\u0648\u0632\u0646",
            'blood pressure',
            'heart rate',
            'spo2',
            'temperature',
            'weight',
            'respiratory rate'
        ]
    },
    {
        id: 'biochemistry',
        labelKey: 'patient.labCategory.biochemistry',
        color: '#3b82f6',
        tests: [
            'glucose',
            'fasting glucose',
            'blood sugar',
            'bun',
            'urea',
            'blood urea',
            'creatinine',
            'sodium',
            'potassium',
            'chloride',
            'bicarbonate',
            'co2',
            'calcium',
            'phosphorus',
            'magnesium',
            'uric acid',
            'total protein',
            'albumin',
            'globulin',
            'a/g ratio'
        ]
    },
    {
        id: 'endocrine',
        labelKey: 'patient.labCategory.endocrine',
        color: '#8b5cf6',
        tests: [
            'cortisol',
            'acth',
            'growth hormone',
            'prolactin',
            'lh',
            'fsh',
            'estradiol',
            'testosterone',
            'progesterone',
            'dheas',
            'insulin',
            'c-peptide',
            'pth',
            'aldosterone',
            'renin',
            'igf-1',
            'free testosterone',
            'shbg',
            'amh'
        ]
    },
    {
        id: 'immunology',
        labelKey: 'patient.labCategory.immunology',
        color: '#ec4899',
        tests: [
            'crp',
            'c-reactive protein',
            'esr',
            'ana',
            'anti-dsdna',
            'rf',
            'rheumatoid factor',
            'anti-ccp',
            'complement c3',
            'complement c4',
            'anca',
            'igg',
            'igm',
            'iga',
            'ige',
            'hiv',
            'hbsag',
            'hbs ag',
            'hcv',
            'vdrl',
            'rpr',
            'cmv',
            'ebv',
            'toxoplasma',
            'anti-hbs',
            'anti-hbc',
            'hbeag'
        ]
    },
    {
        id: 'hematology',
        labelKey: 'patient.labCategory.hematology',
        color: '#ef4444',
        tests: [
            'wbc',
            'rbc',
            'hemoglobin',
            'hematocrit',
            'mcv',
            'mch',
            'mchc',
            'platelets',
            'rdw',
            'neutrophils',
            'lymphocytes',
            'monocytes',
            'eosinophils',
            'basophils',
            'reticulocytes',
            'esr',
            'hematology',
            's.g.o.t (ast)',
            's.g.p.t (alt)'
        ]
    },
    {
        id: 'urinalysis',
        labelKey: 'patient.labCategory.urinalysis',
        color: '#06b6d4',
        tests: [
            'urine ph',
            'urine specific gravity',
            'urine glucose',
            'urine protein',
            'urine ketones',
            'urine blood',
            'urine bilirubin',
            'urine nitrites',
            'urine wbc',
            'urine rbc',
            'urine casts',
            'urine bacteria',
            'specific gravity',
            'urinalysis'
        ]
    },
    {
        id: 'tumor',
        labelKey: 'patient.labCategory.tumor',
        color: '#f59e0b',
        tests: [
            'psa',
            'ca 125',
            'ca125',
            'ca 19-9',
            'ca19-9',
            'ca 15-3',
            'ca15-3',
            'cea',
            'afp',
            'beta hcg',
            'bhcg',
            'nse',
            'chromogranin',
            'ca 72-4',
            'he4',
            'cyfra 21-1',
            's100',
            'lca'
        ]
    },
    {
        id: 'vitamins',
        labelKey: 'patient.labCategory.vitamins',
        color: '#10b981',
        tests: [
            'vitamin d',
            'vitamin d3 (25-oh)',
            '25-oh vitamin d',
            'vitamin b12',
            'folate',
            'folic acid',
            'vitamin a',
            'vitamin e',
            'zinc',
            'copper',
            'selenium',
            'iron',
            'ferritin',
            'tibc',
            'serum iron',
            'vitamin c',
            'vitamin k',
            'manganese'
        ]
    },
    {
        id: 'microbiology',
        labelKey: 'patient.labCategory.microbiology',
        color: '#6366f1',
        tests: [
            'blood culture',
            'urine culture',
            'sputum culture',
            'wound culture',
            'stool culture',
            'csf culture',
            'throat culture',
            'nasal culture',
            'ear culture',
            'h.pylori',
            'helicobacter pylori',
            'tb',
            'afb',
            'fungal culture',
            'mrsa'
        ]
    },
    {
        id: 'diabetes',
        labelKey: 'patient.labCategory.diabetes',
        color: '#f97316',
        tests: [
            'hba1c',
            'hgba1c',
            'glycated hemoglobin',
            'fasting blood sugar',
            'fasting glucose',
            'fbs',
            'ogtt',
            'insulin',
            'c-peptide',
            'fructosamine',
            'gad antibodies',
            'glucose (biochemistry)'
        ]
    },
    {
        id: 'coagulation',
        labelKey: 'patient.labCategory.coagulation',
        color: '#dc2626',
        tests: [
            'pt',
            'inr',
            'ptt',
            'aptt',
            'fibrinogen',
            'd-dimer',
            'anti-thrombin iii',
            'factor viii',
            'platelet function',
            'bleeding time',
            'clotting time',
            'vwf'
        ]
    },
    {
        id: 'lft',
        labelKey: 'patient.labCategory.lft',
        color: '#92400e',
        tests: [
            'alt',
            'sgpt',
            's.g.p.t (alt)',
            'ast',
            'sgot',
            's.g.o.t (ast)',
            'alkaline phosphatase',
            'alkaline p (alp)',
            'alp',
            'ggt',
            'total bilirubin',
            'direct bilirubin',
            'indirect bilirubin',
            'albumin',
            'total protein',
            'ldh',
            'ammonia'
        ]
    },
    {
        id: 'lipid',
        labelKey: 'patient.labCategory.lipid',
        color: '#d97706',
        tests: [
            'total cholesterol',
            'cholesterol',
            'ldl',
            'hdl',
            'triglycerides',
            'vldl',
            'non-hdl',
            'apolipoprotein a',
            'apolipoprotein b',
            'lp(a)',
            'apo a1',
            'apo b'
        ]
    },
    {
        id: 'thyroid',
        labelKey: 'patient.labCategory.thyroid',
        color: '#059669',
        tests: [
            'tsh',
            't.s.h',
            't4',
            'free t4',
            'ft4',
            't3',
            'free t3',
            'ft3',
            'thyroglobulin',
            'anti-tpo',
            'anti-thyroglobulin',
            'reverse t3'
        ]
    },
    {
        id: 'csf',
        labelKey: 'patient.labCategory.csf',
        color: '#7c3aed',
        tests: [
            'csf glucose',
            'csf protein',
            'csf wbc',
            'csf rbc',
            'csf appearance',
            'csf pressure',
            'csf lactate',
            'oligoclonal bands',
            'csf culture',
            'csf opening pressure'
        ]
    },
    {
        id: 'renal',
        labelKey: 'patient.labCategory.renal',
        color: '#0284c7',
        tests: [
            'creatinine',
            'serum creatinine',
            'bun',
            'egfr',
            'cystatin c',
            'uric acid',
            'urine albumin',
            'urine creatinine',
            'acr',
            'albumin creatinine ratio',
            'crcl',
            '24h creatinine'
        ]
    },
    {
        id: 'abg',
        labelKey: 'patient.labCategory.abg',
        color: '#0891b2',
        tests: [
            'ph',
            'pao2',
            'paco2',
            'hco3',
            'o2 saturation',
            'sao2',
            'base excess',
            'lactate',
            'fio2',
            'papo2',
            'arterial ph',
            'bicarbonate'
        ]
    },
    {
        id: 'cardiac',
        labelKey: 'patient.labCategory.cardiac',
        color: '#b91c1c',
        tests: [
            'troponin i',
            'troponin t',
            'troponin',
            'ck',
            'creatine kinase',
            'ck-mb',
            'myoglobin',
            'bnp',
            'nt-probnp',
            'ldh',
            'homocysteine',
            'hs-crp',
            'cardiac troponin'
        ]
    }
];
const $bf42e0131d395ab7$var$_OBS_CAT_CACHE = {};
function $bf42e0131d395ab7$export$88ddf826312c2ac7(display) {
    const k = (display || '').toLowerCase().trim();
    if ($bf42e0131d395ab7$var$_OBS_CAT_CACHE[k] !== undefined) return $bf42e0131d395ab7$var$_OBS_CAT_CACHE[k];
    const cat = $bf42e0131d395ab7$export$5a8441d057c1b67f.find((c)=>c.tests.some((item)=>k === item || k.includes(item) || item.includes(k)));
    $bf42e0131d395ab7$var$_OBS_CAT_CACHE[k] = cat?.id || 'other';
    return $bf42e0131d395ab7$var$_OBS_CAT_CACHE[k];
}
const $bf42e0131d395ab7$export$db667ec233a83b = [
    {
        id: 'all',
        labelKey: 'common.state.all',
        emoji: "\uD83D\uDCC1"
    },
    {
        id: 'lab_report',
        labelKey: 'visit.orders.lab',
        emoji: "\uD83E\uDDEA"
    },
    {
        id: 'imaging',
        labelKey: 'patient.orderType.imaging',
        emoji: "\uD83E\uDE7B"
    },
    {
        id: 'ecg',
        labelKey: 'patient.files.ecg',
        emoji: "\uD83D\uDC93"
    },
    {
        id: 'pathology',
        labelKey: 'patient.files.pathology',
        emoji: "\uD83D\uDD2C"
    },
    {
        id: 'general',
        labelKey: 'patient.files.documents',
        emoji: "\uD83D\uDCC4"
    }
];
const $bf42e0131d395ab7$export$5bd526b8cddb0bce = 'storage:labfile:';
function $bf42e0131d395ab7$export$3d3bfe33466ff5e(f) {
    // What the document IS decides first (docs/PATIENT_MEDICAL_DOCUMENT_UPLOAD_DESIGN.md
    // §8.1). Only the two kinds that ARE a bucket answer outright: a MEDICAL_REPORT may
    // still be an ECG or a pathology sheet, which the legacy fileType can still tell.
    const kind = (0, $1Qo7B.canonicalKind)(f?.kind);
    if (kind === 'LAB') return 'lab_report';
    if (kind === 'IMAGING') return 'imaging';
    const value = (f?.fileType || '').toLowerCase();
    if (value === 'lab_report' || value === 'lab') return 'lab_report';
    if ([
        'imaging',
        'xray',
        'mri',
        'ct',
        'ultrasound'
    ].includes(value)) return 'imaging';
    if (value === 'ecg') return 'ecg';
    if (value === 'pathology') return 'pathology';
    return 'general';
}
function $bf42e0131d395ab7$export$f0dc803487bda7d5(clinicalFiles, storageFiles) {
    const seen = new Set();
    const clinical = (clinicalFiles || []).filter((f)=>{
        if (seen.has(f.id)) return false;
        seen.add(f.id);
        return true;
    }).map((f)=>({
            ...f,
            _source: 'clinical'
        }));
    const linked = new Set(clinical.map((f)=>(f.fileUrl || '').startsWith($bf42e0131d395ab7$export$5bd526b8cddb0bce) ? f.fileUrl.slice($bf42e0131d395ab7$export$5bd526b8cddb0bce.length) : null).filter(Boolean));
    const storageSeen = new Set();
    const storage = (storageFiles || []).filter((f)=>!linked.has(f.id)).filter((f)=>{
        if (storageSeen.has(f.id)) return false;
        storageSeen.add(f.id);
        return true;
    }).map((f)=>({
            ...f,
            _source: 'storage'
        }));
    // Newest DOCUMENT first: a lab sheet dated last month and uploaded today belongs
    // under last month. Without a stated date the upload day stands in; the upload
    // time breaks ties.
    const effective = (f)=>f.documentDate || (f.createdAt || '').slice(0, 10);
    return [
        ...clinical,
        ...storage
    ].sort((a, b)=>effective(b).localeCompare(effective(a)) || (b.createdAt || '').localeCompare(a.createdAt || ''));
}

});
parcelRegister("1Qo7B", function(module, exports) {

$parcel$export(module.exports, "canonicalKind", () => $157d5bd48cfffbad$export$ffe1b0e1a3bc5981);
$parcel$export(module.exports, "DOCUMENT_KIND_LABEL_KEYS", () => $157d5bd48cfffbad$export$e9b52c65a7ff27b6);
$parcel$export(module.exports, "documentKindLabelKey", () => $157d5bd48cfffbad$export$d2ebff77a9864278);
$parcel$export(module.exports, "DOCUMENT_KIND_OPTIONS", () => $157d5bd48cfffbad$export$4f5645f323f84265);
$parcel$export(module.exports, "REPORT_SECTION_KEYS", () => $157d5bd48cfffbad$export$4c32b942640c490c);
$parcel$export(module.exports, "REPORT_MODALITIES", () => $157d5bd48cfffbad$export$918e760d3bce1cbe);
$parcel$export(module.exports, "OVERRIDE_CLASSES", () => $157d5bd48cfffbad$export$6638e927deac1763);
$parcel$export(module.exports, "documentClassLabelKey", () => $157d5bd48cfffbad$export$f6b40a7b264b3557);
$parcel$export(module.exports, "NOTE_SECTION_KEYS", () => $157d5bd48cfffbad$export$48ad29fa49c5e125);
$parcel$export(module.exports, "REVIEW_CONFIDENCE", () => $157d5bd48cfffbad$export$8e824c3a51e639a1);
$parcel$export(module.exports, "confidenceBucket", () => $157d5bd48cfffbad$export$e0b123b1c38f1e9c);
$parcel$export(module.exports, "flagsFor", () => $157d5bd48cfffbad$export$ce70ae537f7b403c);
$parcel$export(module.exports, "documentFlags", () => $157d5bd48cfffbad$export$c58f98e613dc3eb2);
$parcel$export(module.exports, "hasIllegibleMark", () => $157d5bd48cfffbad$export$d66c76d9d0c49c6f);
$parcel$export(module.exports, "processingStatusMeta", () => $157d5bd48cfffbad$export$47893326198c9a54);
$parcel$export(module.exports, "isProcessing", () => $157d5bd48cfffbad$export$96ba48b359c8edfb);
$parcel$export(module.exports, "hasAnalysis", () => $157d5bd48cfffbad$export$2c31f9f3ffd05797);
$parcel$export(module.exports, "isWorthShowing", () => $157d5bd48cfffbad$export$ca16185462233788);
$parcel$export(module.exports, "failureCopyKey", () => $157d5bd48cfffbad$export$70f239c59f207d0);

var $jTCZr = parcelRequire("jTCZr");
const $157d5bd48cfffbad$export$10a6273ddaa5498e = Object.freeze([
    'LAB',
    'IMAGING',
    'MEDICAL_REPORT',
    'PRESCRIPTION',
    'TREATMENT_DOCUMENT',
    'OTHER'
]);
const $157d5bd48cfffbad$export$764f121a336c64b7 = Object.freeze({
    LAB_IMAGE: 'LAB',
    LAB_PDF: 'LAB',
    IMAGING_REPORT: 'IMAGING',
    MEDICAL_DOCUMENT: 'MEDICAL_REPORT'
});
function $157d5bd48cfffbad$export$ffe1b0e1a3bc5981(kind) {
    const upper = String(kind || '').trim().toUpperCase();
    if (!upper) return null;
    const value = $157d5bd48cfffbad$export$764f121a336c64b7[upper] || upper;
    return $157d5bd48cfffbad$export$10a6273ddaa5498e.includes(value) ? value : null;
}
const $157d5bd48cfffbad$export$e9b52c65a7ff27b6 = Object.freeze({
    LAB: 'patient.files.kind.lab',
    IMAGING: 'patient.files.kind.imaging',
    MEDICAL_REPORT: 'patient.files.kind.medicalReport',
    PRESCRIPTION: 'patient.files.kind.prescription',
    TREATMENT_DOCUMENT: 'patient.files.kind.treatmentDocument',
    OTHER: 'patient.files.kind.other'
});
function $157d5bd48cfffbad$export$d2ebff77a9864278(kind) {
    const value = $157d5bd48cfffbad$export$ffe1b0e1a3bc5981(kind);
    return value ? $157d5bd48cfffbad$export$e9b52c65a7ff27b6[value] : null;
}
const $157d5bd48cfffbad$export$4f5645f323f84265 = Object.freeze($157d5bd48cfffbad$export$10a6273ddaa5498e.map((value)=>({
        value: value,
        labelKey: $157d5bd48cfffbad$export$e9b52c65a7ff27b6[value]
    })));
function $157d5bd48cfffbad$export$5838ca9a34e7c8(kind) {
    return $157d5bd48cfffbad$export$ffe1b0e1a3bc5981(kind) === 'LAB' ? 'LAB_RESULTS' : 'REPORT';
}
const $157d5bd48cfffbad$export$4c32b942640c490c = Object.freeze([
    'clinical_info',
    'technique',
    'comparison',
    'findings',
    'impression',
    'recommendation',
    'other'
]);
const $157d5bd48cfffbad$export$918e760d3bce1cbe = Object.freeze([
    'US',
    'CT',
    'MRI',
    'XR',
    'MG',
    'NM',
    'ECG',
    'PATH',
    'OTHER'
]);
const $157d5bd48cfffbad$export$2420ba89f9c47be8 = Object.freeze([
    'LAB_RESULT',
    'IMAGING_REPORT',
    'MEDICAL_REPORT',
    'PRESCRIPTION',
    'HANDWRITTEN_NOTE',
    'MEDICAL_RECORD',
    'OTHER'
]);
const $157d5bd48cfffbad$export$2c244d895de88ead = Object.freeze({
    LAB_RESULT: 'LAB_RESULTS',
    IMAGING_REPORT: 'REPORT',
    MEDICAL_REPORT: 'REPORT',
    PRESCRIPTION: 'PRESCRIPTION',
    HANDWRITTEN_NOTE: 'NOTE',
    MEDICAL_RECORD: 'RECORD'
});
const $157d5bd48cfffbad$export$6638e927deac1763 = Object.freeze($157d5bd48cfffbad$export$2420ba89f9c47be8.filter((c)=>c !== 'OTHER'));
const $157d5bd48cfffbad$export$f6b40a7b264b3557 = (cls)=>$157d5bd48cfffbad$export$2420ba89f9c47be8.includes(cls) ? `patient.files.extract.class.${cls}` : null;
const $157d5bd48cfffbad$export$48ad29fa49c5e125 = Object.freeze([
    'history',
    'exam',
    'assessment',
    'plan',
    'other'
]);
const $157d5bd48cfffbad$export$8e824c3a51e639a1 = 0.8;
function $157d5bd48cfffbad$export$e0b123b1c38f1e9c(confidence) {
    const c = Number(confidence);
    if (!Number.isFinite(c)) return null;
    if (c >= 0.9) return 'high';
    if (c >= 0.75) return 'medium';
    return 'low';
}
function $157d5bd48cfffbad$export$ce70ae537f7b403c(flags, prefix) {
    return (flags || []).filter((f)=>String(f?.path || '').startsWith(prefix));
}
function $157d5bd48cfffbad$export$c58f98e613dc3eb2(flags) {
    return (flags || []).filter((f)=>!/\[\d+\]/.test(String(f?.path || '')));
}
const $157d5bd48cfffbad$export$d66c76d9d0c49c6f = (text)=>/\[\?\]|\[ناخوانا\]/.test(String(text || '')); // i18n-exempt: matcher against model output
const $157d5bd48cfffbad$export$7a368dd5ea360393 = {
    // Stored, and that is all the clinic asked for. This is the DEFAULT and, for a
    // clinic that does not analyse uploads, the only state its files will ever be
    // in. It must never read as a failure.
    none: {
        ...(0, $jTCZr.statusColors).completed,
        labelKey: 'patient.files.processing.none'
    },
    queued: {
        ...(0, $jTCZr.statusColors).waiting,
        labelKey: 'patient.files.processing.queued'
    },
    processing: {
        ...(0, $jTCZr.statusColors).in_visit,
        labelKey: 'patient.files.processing.processing'
    },
    // A model read it and produced text.
    analyzed: {
        ...(0, $jTCZr.statusColors).completed,
        labelKey: 'patient.files.processing.analyzed'
    },
    // …and structured values came out of it.
    extracted: {
        ...(0, $jTCZr.statusColors).completed,
        labelKey: 'patient.files.processing.extracted'
    },
    // The analysis did not happen. Deliberately NOT the red `cancelled` swatch: the
    // document itself is safely stored and the doctor can still open and read it,
    // so this is a missing convenience, not a lost file.
    failed: {
        ...(0, $jTCZr.statusColors).no_show,
        labelKey: 'patient.files.processing.failed'
    }
};
const $157d5bd48cfffbad$export$753f4d39807a1a61 = [
    'queued',
    'processing'
];
const $157d5bd48cfffbad$export$16f32956b0e27d9f = [
    'analyzed',
    'extracted'
];
function $157d5bd48cfffbad$var$normalize(status) {
    return String(status || '').toLowerCase().replace(/-/g, '_');
}
function $157d5bd48cfffbad$export$47893326198c9a54(status) {
    return $157d5bd48cfffbad$export$7a368dd5ea360393[$157d5bd48cfffbad$var$normalize(status)] || null;
}
function $157d5bd48cfffbad$export$96ba48b359c8edfb(status) {
    return $157d5bd48cfffbad$export$753f4d39807a1a61.includes($157d5bd48cfffbad$var$normalize(status));
}
function $157d5bd48cfffbad$export$2c31f9f3ffd05797(status) {
    return $157d5bd48cfffbad$export$16f32956b0e27d9f.includes($157d5bd48cfffbad$var$normalize(status));
}
function $157d5bd48cfffbad$export$f771ebfc53d8840d(file) {
    if (!file) return false;
    if ($157d5bd48cfffbad$export$2c31f9f3ffd05797(file.processingStatus)) return true;
    return Boolean(file.clinicId) && Boolean($157d5bd48cfffbad$export$7a368dd5ea360393[$157d5bd48cfffbad$var$normalize(file.processingStatus)]);
}
function $157d5bd48cfffbad$export$ca16185462233788(status) {
    const key = $157d5bd48cfffbad$var$normalize(status);
    return Boolean($157d5bd48cfffbad$export$7a368dd5ea360393[key]) && key !== 'none';
}
function $157d5bd48cfffbad$export$70f239c59f207d0(processingError) {
    return $157d5bd48cfffbad$var$normalize(processingError) === 'credit' ? 'patient.files.processing.failedCredit' : 'patient.files.processing.failedOther';
}

});



parcelRegister("U8Lvw", function(module, exports) {

$parcel$export(module.exports, "useVisitRxPersistence", () => $0a8c07ac6d7bacfd$export$b8bc8558f6e5b5c3);

var $acw62 = parcelRequire("acw62");

var $eVM84 = parcelRequire("eVM84");

var $c9qmv = parcelRequire("c9qmv");

var $6xvbB = parcelRequire("6xvbB");

var $85jFj = parcelRequire("85jFj");

var $eQiuG = parcelRequire("eQiuG");
// A re-opened visit's lines, each with its «در فهرست تأمین» (taminListed).
const $0a8c07ac6d7bacfd$var$askMedications = (0, $c9qmv.askWithoutTaminWhenRefused)((0, $eVM84.bffQuery));
// An edit writes the medication's `quantity` COLUMN along with its dosage: the
// تأمین submission reads srvQty from the column, and op-naji falls back to it when
// the dosage holds none — so a column left at its first value sent the old count,
// and one the doctor had CLEARED sent a count they had taken back (K1,
// 2026-10-03). `UpdateMedicationInput.quantity` is newer than this hook, and a BFF
// that predates it refuses the WHOLE input; an edit must not be lost to that, so
// the save is sent again without the column.
const $0a8c07ac6d7bacfd$var$quantityRefused = (e)=>/\bquantity\b/.test(e?.message || '') && /UpdateMedicationInput/.test(e?.message || '');
async function $0a8c07ac6d7bacfd$var$updateMedication(id, input) {
    try {
        return await (0, $eVM84.bffMutation)((0, $6xvbB.UPDATE_MEDICATION), {
            id: id,
            input: input
        });
    } catch (e) {
        if (!$0a8c07ac6d7bacfd$var$quantityRefused(e)) throw e;
        const withoutColumn = {
            ...input
        };
        delete withoutColumn.quantity;
        return (0, $eVM84.bffMutation)((0, $6xvbB.UPDATE_MEDICATION), {
            id: id,
            input: withoutColumn
        });
    }
}
function $0a8c07ac6d7bacfd$export$b8bc8558f6e5b5c3({ appointmentId: appointmentId, patientId: patientId, setRxItems: setRxItems, rxItems: rxItems }) {
    // Writes are debounced per ROW: a dosage is typed a character at a time and
    // each keystroke must not become a mutation, while the text on screen updates
    // immediately either way.
    const timers = (0, $acw62.useRef)(new Map());
    const byId = (0, $acw62.useRef)(new Map());
    // Rows this hook wrote itself (writeNow), by row id → medication id. The row's
    // own `medicationId` arrives through state a render later; this is what a save,
    // a delete or a second writeNow in that gap reads instead, so nothing is
    // written twice and nothing is orphaned.
    const written = (0, $acw62.useRef)(new Map());
    // Rows the doctor removed. Gone from the screen at once; their record is deleted
    // on the queue below, after any write of them still in flight — so a draft in
    // this set is never created, and an edit to it is never saved.
    const removed = (0, $acw62.useRef)(new Set());
    const medicationIdOf = (row, rowId)=>row?.medicationId || written.current.get(rowId) || null;
    (0, $acw62.useEffect)(()=>{
        byId.current = new Map((rxItems || []).map((r)=>[
                r.id,
                r
            ]));
    }, [
        rxItems
    ]);
    (0, $acw62.useEffect)(()=>()=>{
            timers.current.forEach(clearTimeout);
            timers.current.clear();
        }, []);
    // ── ONE queue for every write to the record ─────────────────────────────────
    //
    // An edit's save, a removal's delete and writeNow all run on it, one at a time,
    // in the order they were asked for. writeNow used to wait only for the saves
    // still on their timers: a save already out, a delete (fired and forgotten), and
    // a draft being created while its line was removed all raced the e-prescription
    // that writeNow is called before — which then sent a line the doctor had just
    // removed, an orphan of one, or the dose from before an edit (K1, 2026-10-03).
    const queue = (0, $acw62.useRef)(Promise.resolve());
    const enqueue = (0, $acw62.useCallback)((op)=>{
        const done = queue.current.then(op);
        queue.current = done.catch(()=>{});
        return done;
    }, []);
    // Settled once NOTHING is queued — not only what was queued when it was asked:
    // a delete or a save that joins while a write is out is waited for as well.
    const settled = (0, $acw62.useCallback)(async ()=>{
        let tail;
        do {
            tail = queue.current;
            await tail;
        }while (tail !== queue.current);
    }, []);
    // Read the row at WRITE time, not at schedule time: the whole point of the
    // delay is that more edits arrive during it, and the last one is the one the
    // doctor means. Runs ON the queue (or inside a writeNow that is).
    const saveRow = (0, $acw62.useCallback)(async (rowId)=>{
        if (removed.current.has(rowId)) return;
        const row = byId.current.get(rowId);
        const id = medicationIdOf(row, rowId);
        if (!row || !id) return;
        try {
            await $0a8c07ac6d7bacfd$var$updateMedication(id, {
                display: row.drug?.name || '',
                dosageInstruction: (0, $85jFj.dosageInstructionFromRxItem)(row),
                // 0 is «not stated» on the wire — what a cleared quantity must say.
                quantity: (0, $eQiuG.quantityNumber)(row.quantity) || 0
            });
        } catch (e) {
            console.warn('[rx] persist medication edit failed:', e.message);
        }
    }, []);
    const scheduleSave = (0, $acw62.useCallback)((rowId)=>{
        clearTimeout(timers.current.get(rowId));
        timers.current.set(rowId, setTimeout(()=>{
            timers.current.delete(rowId);
            enqueue(()=>saveRow(rowId));
        }, 700));
    }, [
        saveRow,
        enqueue
    ]);
    /** Forget a row's pending write — it is being deleted, or the visit is over. */ const cancelSave = (0, $acw62.useCallback)((rowId)=>{
        clearTimeout(timers.current.get(rowId));
        timers.current.delete(rowId);
    }, []);
    /**
   * Delete the record behind a row, if it has one. Local removal is the caller's.
   *
   * Queued, so it waits for a create of the same row that is still out, and the
   * id it deletes is read when it RUNS. A failed delete is not only logged: the
   * record still holds the line, so the line goes back on the نسخه, where it was,
   * marked `removeFailed` — what the doctor sees is what would be sent, and
   * removing it again retries.
   */ const deleteRow = (0, $acw62.useCallback)((rowId)=>{
        const row = byId.current.get(rowId);
        const at = [
            ...byId.current.keys()
        ].indexOf(rowId);
        cancelSave(rowId);
        removed.current.add(rowId);
        enqueue(async ()=>{
            const id = medicationIdOf(row, rowId);
            if (!id) return;
            try {
                await (0, $eVM84.bffMutation)((0, $6xvbB.DELETE_MEDICATION), {
                    id: id
                });
                written.current.delete(rowId);
            } catch (e) {
                console.warn('[rx] delete medication failed:', e.message);
                removed.current.delete(rowId);
                if (!row) return;
                const back = {
                    ...row,
                    medicationId: id,
                    removeFailed: true
                };
                setRxItems((prev)=>{
                    if (prev.some((r)=>r.id === rowId)) return prev;
                    const next = [
                        ...prev
                    ];
                    next.splice(at < 0 ? next.length : Math.min(at, next.length), 0, back);
                    return next;
                });
            }
        });
    }, [
        cancelSave,
        enqueue,
        setRxItems
    ]);
    /**
   * Write the نسخه to the record NOW, as it is on screen: every pending edit, and
   * every draft line — exactly as closing the visit would write it (useEndVisit),
   * so a reader of the record sees what the doctor sees. The e-prescription card
   * in the visit's نسخه/دستورات section calls this before each read and send,
   * because the server builds the prescription from the record (K1, 2026-10-03).
   * A draft written here gets its `medicationId`, which is what keeps closing the
   * visit from writing it a second time. Calls are queued, never overlapped, and
   * the returned promise settles only when every write queued before or during
   * it — a save, a delete — has reached the record.
   *
   * `fresh` names lines just put on the نسخه in the same handler, which this hook
   * has not seen yet: it reads the list a render late (an applied treatment plan).
   */ const writeNow = (0, $acw62.useCallback)((fresh)=>{
        const extra = Array.isArray(fresh) ? fresh : [];
        enqueue(async ()=>{
            const pending = [
                ...timers.current.keys()
            ];
            pending.forEach((rowId)=>clearTimeout(timers.current.get(rowId)));
            timers.current.clear();
            await Promise.all(pending.map(saveRow));
            if (!appointmentId || !patientId) return;
            const rows = new Map(byId.current);
            extra.forEach((r)=>{
                if (r?.id != null && !rows.has(r.id)) rows.set(r.id, r);
            });
            const drafts = [
                ...rows.entries()
            ].filter(([rowId, row])=>row?.drug && !medicationIdOf(row, rowId) && !removed.current.has(rowId));
            for (const [rowId, row] of drafts){
                // Removed while an earlier draft was being written: never created.
                if (removed.current.has(rowId)) continue;
                try {
                    const res = await (0, $eVM84.bffMutation)((0, $6xvbB.CREATE_MEDICATION), {
                        patientId: patientId,
                        input: {
                            code: row.drug.genericName || row.drug.name,
                            display: row.drug.name,
                            status: 'active',
                            authoredOn: new Date().toISOString().split('T')[0],
                            dosageInstruction: (0, $85jFj.dosageInstructionFromRxItem)(row),
                            quantity: (0, $eQiuG.quantityNumber)(row.quantity),
                            meta: (0, $85jFj.medicationMetaFromDrug)(row.drug),
                            appointmentId: appointmentId
                        }
                    });
                    const id = res?.createMedication?.id;
                    if (!id) continue;
                    written.current.set(rowId, id);
                    setRxItems((prev)=>prev.map((r)=>r.id === rowId ? {
                                ...r,
                                medicationId: id
                            } : r));
                    // An edit made while this write was in flight landed on a row with no
                    // id yet and was not written — write the row as it is now. (A row
                    // removed meanwhile is not saved; its delete is queued behind this.)
                    const now = byId.current.get(rowId);
                    if (now && now !== row) await saveRow(rowId);
                } catch (e) {
                    console.warn('[rx] write draft line failed:', e.message);
                }
            }
        });
        return settled();
    }, [
        appointmentId,
        patientId,
        saveRow,
        setRxItems,
        enqueue,
        settled
    ]);
    /**
   * Let every edit and delete already asked for reach the record — the saves
   * still waiting on their delay included — WITHOUT writing the draft lines.
   * What the e-prescription status is read behind (useErxStatus, K1
   * 2026-10-04): it must see the edit the doctor just made, but a line still
   * being composed is not the record's yet.
   */ const flush = (0, $acw62.useCallback)(()=>{
        enqueue(async ()=>{
            const pending = [
                ...timers.current.keys()
            ];
            pending.forEach((rowId)=>clearTimeout(timers.current.get(rowId)));
            timers.current.clear();
            await Promise.all(pending.map(saveRow));
        });
        return settled();
    }, [
        saveRow,
        enqueue,
        settled
    ]);
    // ── Re-opening a visit ──────────────────────────────────────────────────────
    //
    // MERGED, never assigned: the doctor may already have typed rows that are not
    // saved yet, and `mergeRxItems` keys on the server id so nothing is dropped
    // and nothing is listed twice.
    //
    // `hydration` says how that read went ('idle' | 'loading' | 'ready' | 'error')
    // and `rehydrate` asks again — for a surface that opens ON a visit's نسخه, the
    // past-visit «اصلاح نسخه» sheet (K1, 2026-10-04), where an empty list must not
    // be mistaken for one that failed to load.
    const hydratedFor = (0, $acw62.useRef)(null);
    const [hydration, setHydration] = (0, $acw62.useState)('idle');
    const [attempt, setAttempt] = (0, $acw62.useState)(0);
    (0, $acw62.useEffect)(()=>{
        const key = `${appointmentId}\u0000${attempt}`;
        if (!appointmentId || !patientId || hydratedFor.current === key) return;
        hydratedFor.current = key;
        setHydration('loading');
        $0a8c07ac6d7bacfd$var$askMedications((0, $85jFj.LIST_VISIT_MEDICATIONS), {
            patientId: patientId,
            appointmentId: appointmentId
        }).then((data)=>{
            const rows = (data?.listMedications || []).map((0, $85jFj.rxItemFromMedication)).filter(Boolean);
            if (rows.length) setRxItems((prev)=>(0, $85jFj.mergeRxItems)(prev, rows));
            setHydration('ready');
        })// A failed read leaves the tab as it was, and does NOT retry on the next
        // render: that would be a loop. Nothing is lost — the rows are in the
        // record, and the doctor can still prescribe.
        .catch((e)=>{
            console.warn('[rx] could not load this visit\'s medications:', e.message);
            setHydration('error');
        });
    }, [
        appointmentId,
        patientId,
        setRxItems,
        attempt
    ]);
    const rehydrate = (0, $acw62.useCallback)(()=>setAttempt((n)=>n + 1), []);
    return {
        scheduleSave: scheduleSave,
        cancelSave: cancelSave,
        deleteRow: deleteRow,
        writeNow: writeNow,
        flush: flush,
        hydration: hydration,
        rehydrate: rehydrate
    };
}

});
parcelRegister("6xvbB", function(module, exports) {

$parcel$export(module.exports, "CREATE_VISIT", () => $375f8776645d5aee$export$610b800a6c6defa5);
$parcel$export(module.exports, "START_VISIT", () => $375f8776645d5aee$export$cdc0bbb5663f787c);
$parcel$export(module.exports, "END_VISIT", () => $375f8776645d5aee$export$33b114336c19593d);
$parcel$export(module.exports, "ASK_DOCTOR_QUESTION", () => $375f8776645d5aee$export$d877ca4a83c64a39);
$parcel$export(module.exports, "GENERATE_CONFIRM_Q", () => $375f8776645d5aee$export$15324fc83c054605);
$parcel$export(module.exports, "CHECK_DRUG_INTERACTION", () => $375f8776645d5aee$export$9812972017b718e1);
$parcel$export(module.exports, "INITIALIZE_VISIT_SESSION", () => $375f8776645d5aee$export$781b4a03507fea1f);
$parcel$export(module.exports, "GET_DIFFERENTIAL", () => $375f8776645d5aee$export$bc9f2df565557d4f);
$parcel$export(module.exports, "UPDATE_DIFFERENTIAL", () => $375f8776645d5aee$export$477e67f6b97e7e38);
$parcel$export(module.exports, "DIFFERENTIAL_POLL_LEAD_MS", () => $375f8776645d5aee$export$d3a7b2340b0c9d48);
$parcel$export(module.exports, "ASSIST_PRESCRIPTION", () => $375f8776645d5aee$export$82d8fcb090733ceb);
$parcel$export(module.exports, "UPDATE_PATIENT", () => $375f8776645d5aee$export$f6cdc6e4a4a3c80a);
$parcel$export(module.exports, "RECOMMEND_TESTS", () => $375f8776645d5aee$export$19b465740ee91bc);
$parcel$export(module.exports, "ADD_MEDICATION", () => $375f8776645d5aee$export$59a0707dfedfe8a6);
$parcel$export(module.exports, "ADD_CONDITION", () => $375f8776645d5aee$export$52e699bb9024b09d);
$parcel$export(module.exports, "DELETE_CONDITION", () => $375f8776645d5aee$export$ea4d931135e95fd1);
$parcel$export(module.exports, "UPDATE_CONDITION", () => $375f8776645d5aee$export$b8ec51b731e55222);
$parcel$export(module.exports, "UPDATE_ENCOUNTER", () => $375f8776645d5aee$export$6762df89b8e36811);
$parcel$export(module.exports, "CREATE_CLINICAL_NOTE", () => $375f8776645d5aee$export$1d32d39b70c8b52e);
$parcel$export(module.exports, "UPDATE_CLINICAL_NOTE", () => $375f8776645d5aee$export$6e7c5d8b5a28479a);
$parcel$export(module.exports, "CREATE_MEDICATION", () => $375f8776645d5aee$export$5fcaf1729c987f4d);
$parcel$export(module.exports, "ADD_OBSERVATION", () => $375f8776645d5aee$export$5d20d1065b54c736);
$parcel$export(module.exports, "PATIENT_VISIT_HISTORY", () => $375f8776645d5aee$export$815cd81bee1aa526);
$parcel$export(module.exports, "SUGGEST_DOCTOR_ORDERS", () => $375f8776645d5aee$export$c3637e87e40dab8f);
$parcel$export(module.exports, "SAVE_DOCTOR_ORDERS", () => $375f8776645d5aee$export$bed6819e031e8e35);
$parcel$export(module.exports, "GET_ENCOUNTER_CONTEXT", () => $375f8776645d5aee$export$e8c7fd9774d91e48);
$parcel$export(module.exports, "differentialReadiness", () => $375f8776645d5aee$export$8b03bbb666cde734);
$parcel$export(module.exports, "VIDEO_VISIT_AVAILABILITY", () => $375f8776645d5aee$export$eaa2f90824feaabb);
$parcel$export(module.exports, "SET_VISIT_MODE", () => $375f8776645d5aee$export$16ac3aeec5aaa168);
$parcel$export(module.exports, "VIDEO_VISIT_SESSION", () => $375f8776645d5aee$export$6651891395397547);
$parcel$export(module.exports, "useVisitCoinLedger", () => $375f8776645d5aee$export$18ea943e404e01dd);
$parcel$export(module.exports, "soapSectionText", () => $375f8776645d5aee$export$507352e36a49c92e);
$parcel$export(module.exports, "planNarrative", () => $375f8776645d5aee$export$35974e4f6db92b0);
$parcel$export(module.exports, "soapEditorFocused", () => $375f8776645d5aee$export$1737c681d4b4a856);
$parcel$export(module.exports, "useSoapNoteRow", () => $375f8776645d5aee$export$3c5b8ac9cc0f8a4);
$parcel$export(module.exports, "useSoapRefine", () => $375f8776645d5aee$export$79f39042065fbd7d);
$parcel$export(module.exports, "useDifferentialPolling", () => $375f8776645d5aee$export$3f0d5a0b11f5b929);
$parcel$export(module.exports, "isDifferentialAccepted", () => $375f8776645d5aee$export$d20c1dcfc45ad42b);
$parcel$export(module.exports, "trackDifferentialDecision", () => $375f8776645d5aee$export$a11a26367843ed4f);
$parcel$export(module.exports, "mergeDifferentialPoll", () => $375f8776645d5aee$export$24f67d3076448bf7);
$parcel$export(module.exports, "confirmDifferentialType", () => $375f8776645d5aee$export$5cadc197239e50ce);
$parcel$export(module.exports, "diagnosisTypeForCode", () => $375f8776645d5aee$export$5b3196b6580e75eb);
$parcel$export(module.exports, "pastFinishedVisits", () => $375f8776645d5aee$export$89161e2370097cc4);
$parcel$export(module.exports, "summariesByVisit", () => $375f8776645d5aee$export$22c958772a7f76e1);
$parcel$export(module.exports, "visitDiagnosisLabels", () => $375f8776645d5aee$export$33b3781481f6ac85);
$parcel$export(module.exports, "SUGGEST_TREATMENT_PLAN", () => $375f8776645d5aee$export$f34a41ed9a6da313);
$parcel$export(module.exports, "GET_TREATMENT_PLAN", () => $375f8776645d5aee$export$9c8ef21e5ce2027);
$parcel$export(module.exports, "SAVE_TREATMENT_PLAN_NOTE", () => $375f8776645d5aee$export$97c305a43bb466fa);
$parcel$export(module.exports, "CONFIRM_TREATMENT_PLAN", () => $375f8776645d5aee$export$11e9f559a2c034d2);
$parcel$export(module.exports, "DELETE_OBSERVATION", () => $375f8776645d5aee$export$725e3ec3814f10de);
$parcel$export(module.exports, "DELETE_MEDICATION", () => $375f8776645d5aee$export$608c51c2a533f155);
$parcel$export(module.exports, "UPDATE_MEDICATION", () => $375f8776645d5aee$export$b41f928ed45f8779);
$parcel$export(module.exports, "GET_PRESCRIPTION_TEMPLATES", () => $375f8776645d5aee$export$cd39121473ec6a95);
$parcel$export(module.exports, "GET_ACTIVE_ENCOUNTER", () => $375f8776645d5aee$export$13ca7cd8c39f4461);
$parcel$export(module.exports, "LIST_CLINICAL_NOTES", () => $375f8776645d5aee$export$5b71fce46c6ed6a3);
$parcel$export(module.exports, "CANCEL_ENCOUNTER", () => $375f8776645d5aee$export$337c36ab78c979c4);
$parcel$export(module.exports, "CLINICAL_ORDER_FIELDS", () => $375f8776645d5aee$export$a335d939e8294daf);
$parcel$export(module.exports, "LIST_CLINICAL_ORDERS", () => $375f8776645d5aee$export$1d5821a442552a84);
$parcel$export(module.exports, "PAST_VISIT_ORDERS", () => $375f8776645d5aee$export$7a496824567602ee);
$parcel$export(module.exports, "CREATE_CLINICAL_ORDER", () => $375f8776645d5aee$export$81ebae6b21d102e1);
$parcel$export(module.exports, "UPDATE_ORDER_DATE", () => $375f8776645d5aee$export$5d3bfd5c1289b2ab);
$parcel$export(module.exports, "COMPLETE_RX_DIRECTIONS", () => $375f8776645d5aee$export$fa16d22e4f643897);
$parcel$export(module.exports, "ERX_PREVIEW", () => $375f8776645d5aee$export$4d6ef37e3b3fc364);
$parcel$export(module.exports, "ERX_PREVIEW_PRE_CORRECTION", () => $375f8776645d5aee$export$2fedc374da938b3c);
$parcel$export(module.exports, "ERX_START_LOGIN", () => $375f8776645d5aee$export$a95f04fc131305cf);
$parcel$export(module.exports, "ERX_ANSWER_CHALLENGE", () => $375f8776645d5aee$export$d688676352e6afeb);
$parcel$export(module.exports, "ERX_LOGOUT", () => $375f8776645d5aee$export$d48ea6856e66736d);
$parcel$export(module.exports, "ERX_SET_SIAM", () => $375f8776645d5aee$export$3713d209ae047851);
$parcel$export(module.exports, "ERX_SEND", () => $375f8776645d5aee$export$cdbeae1ac264703e);
$parcel$export(module.exports, "ERX_PREVIEW_SCOPED", () => $375f8776645d5aee$export$e76d3b0c177e8362);
$parcel$export(module.exports, "ERX_PREVIEW_SCOPED_PRE_CORRECTION", () => $375f8776645d5aee$export$5ddaa93868d3670f);
$parcel$export(module.exports, "ERX_ELIGIBILITY", () => $375f8776645d5aee$export$876fbc5c8db40344);
$parcel$export(module.exports, "ERX_SEND_SCOPED", () => $375f8776645d5aee$export$4b366d0c9745cd96);
$parcel$export(module.exports, "ERX_SEND_SAVING_INSURER", () => $375f8776645d5aee$export$45a656a5891fd4c1);
$parcel$export(module.exports, "ERX_SEND_SAVING_INSURER_SCOPED", () => $375f8776645d5aee$export$f4844156b4b46778);
$parcel$export(module.exports, "withErxPatient", () => $375f8776645d5aee$export$3dbec13a22a52d5f);
$parcel$export(module.exports, "withErxExclusions", () => $375f8776645d5aee$export$aebcdf6f5e0d5e2c);
$parcel$export(module.exports, "ERX_STATUS", () => $375f8776645d5aee$export$e436a36803f66c6f);
$parcel$export(module.exports, "ERX_SEND_CORRECTION", () => $375f8776645d5aee$export$998c87dffbd5dcdb);
$parcel$export(module.exports, "ERX_CODES", () => $375f8776645d5aee$export$883a58dcaa1f2c7e);
$parcel$export(module.exports, "START_ORDER_MUT", () => $375f8776645d5aee$export$a829ddd2566c75b7);
$parcel$export(module.exports, "COMPLETE_ORDER_MUT", () => $375f8776645d5aee$export$b0b354e2ddeac24b);
$parcel$export(module.exports, "CANCEL_ORDER_MUT", () => $375f8776645d5aee$export$494a03338ebc3893);
$parcel$export(module.exports, "KF", () => $375f8776645d5aee$export$1f71eb225ba1e723);
$parcel$export(module.exports, "CSS_VARS", () => $375f8776645d5aee$export$220f2e5d84ced4cb);
$parcel$export(module.exports, "QUICK_Q", () => $375f8776645d5aee$export$8b6317f87e032c1);
$parcel$export(module.exports, "DURATIONS", () => $375f8776645d5aee$export$74f6a832d246e098);
$parcel$export(module.exports, "RX_ROUTES", () => $375f8776645d5aee$export$e730a0734bbb1219);
$parcel$export(module.exports, "MOBILE_CSS", () => $375f8776645d5aee$export$b9d67b8f1f51ac8d);
$parcel$export(module.exports, "SEVERITY_CLR", () => $375f8776645d5aee$export$ee258ff23bc0049f);
$parcel$export(module.exports, "SEVERITY_LBL", () => $375f8776645d5aee$export$236de8c7b98b7ff0);
$parcel$export(module.exports, "normalizeSeverity", () => $375f8776645d5aee$export$a20f1db6dc818677);
$parcel$export(module.exports, "bucketWarnings", () => $375f8776645d5aee$export$2ba0e4a723757c09);
$parcel$export(module.exports, "topSeverity", () => $375f8776645d5aee$export$9ad745a931ba51ed);
$parcel$export(module.exports, "rxCheckSignature", () => $375f8776645d5aee$export$73a34cab37d00ce4);
$parcel$export(module.exports, "interactionContext", () => $375f8776645d5aee$export$ead65992cf57cabf);
$parcel$export(module.exports, "inferConditionsFromObservations", () => $375f8776645d5aee$export$5176433c16ff5a4);
$parcel$export(module.exports, "canRunInteractionCheck", () => $375f8776645d5aee$export$1e5ddc066f5dd4da);
$parcel$export(module.exports, "I", () => $375f8776645d5aee$export$9bb611d729802a56);
$parcel$export(module.exports, "DRUG_PAGE_SIZE", () => $375f8776645d5aee$export$68595c7f7403ce8d);
$parcel$export(module.exports, "DRUG_MIN_QUERY", () => $375f8776645d5aee$export$e72eedeb22c02c24);
$parcel$export(module.exports, "searchDrugs", () => $375f8776645d5aee$export$66192a3e729ccb0d);
$parcel$export(module.exports, "fetchFrequentDrugs", () => $375f8776645d5aee$export$9b2f95caa9aaf04d);
$parcel$export(module.exports, "newLastDrugSigsCache", () => $375f8776645d5aee$export$c69c4ad931cc4390);
$parcel$export(module.exports, "fetchLastDrugSigs", () => $375f8776645d5aee$export$ccc209bdcc9e4ec4);
$parcel$export(module.exports, "matchFormularyDrug", () => $375f8776645d5aee$export$3f253215194ac0f3);
$parcel$export(module.exports, "refillDrugFor", () => $375f8776645d5aee$export$dcced24b144b6c10);
$parcel$export(module.exports, "drugDosageLabel", () => $375f8776645d5aee$export$a6616cb9d478340f);
$parcel$export(module.exports, "InsurerListChip", () => $375f8776645d5aee$export$cbaf757fd313ab43);
$parcel$export(module.exports, "GenericGroupChip", () => $375f8776645d5aee$export$e901e237ac90bbca);
$parcel$export(module.exports, "taminFlagOf", () => $375f8776645d5aee$export$ff0b3160d2d98f35);
$parcel$export(module.exports, "orderTaminListed", () => $375f8776645d5aee$export$467168533c33d9ca);
$parcel$export(module.exports, "rxItemSummary", () => $375f8776645d5aee$export$41198ed546152d40);
$parcel$export(module.exports, "RxItemCard", () => $375f8776645d5aee$export$564a716e7cf1f53f);
$parcel$export(module.exports, "SEC_LABEL", () => $375f8776645d5aee$export$6897efa034860c56);
$parcel$export(module.exports, "SEC_FIELD", () => $375f8776645d5aee$export$d4e2cf4ef3f8061);
$parcel$export(module.exports, "SEC_SELECT", () => $375f8776645d5aee$export$775ae08e7b0fd486);
$parcel$export(module.exports, "VitalCard", () => $375f8776645d5aee$export$fed3aff69bf06eb1);
$parcel$export(module.exports, "emptyVitals", () => $375f8776645d5aee$export$ccc2c13eb48542b9);
$parcel$export(module.exports, "vitalDigits", () => $375f8776645d5aee$export$8c63808338caf15c);
$parcel$export(module.exports, "vitalsForEncounter", () => $375f8776645d5aee$export$1e5a39e00c998387);
$parcel$export(module.exports, "ORDER_TYPE_FA", () => $375f8776645d5aee$export$e867161a6e6ed178);
$parcel$export(module.exports, "ORDER_TYPE_ICON", () => $375f8776645d5aee$export$ba9a3a2cefb281d);
$parcel$export(module.exports, "SEC_CARD", () => $375f8776645d5aee$export$97da64870f5585b8);
$parcel$export(module.exports, "SEC_HEAD", () => $375f8776645d5aee$export$10c499a234e299a6);
$parcel$export(module.exports, "SEC_TITLE", () => $375f8776645d5aee$export$a931407aa8dfff78);
$parcel$export(module.exports, "SEC_ICON", () => $375f8776645d5aee$export$7b8c3b54c8233354);
$parcel$export(module.exports, "SEC_BADGE", () => $375f8776645d5aee$export$8fe483d880a02f5f);
$parcel$export(module.exports, "SEC_SUBCARD", () => $375f8776645d5aee$export$4e02c9f6bbae01b0);
$parcel$export(module.exports, "vitalEffectMeta", () => $375f8776645d5aee$export$739e6a3f924c37ce);
$parcel$export(module.exports, "ORDER_MIN_QUERY", () => $375f8776645d5aee$export$6770277ab0ca292e);
$parcel$export(module.exports, "askWithoutNameFrWhenRefused", () => $375f8776645d5aee$export$eda06ee722141e6e);
$parcel$export(module.exports, "askWithoutNameDeWhenRefused", () => $375f8776645d5aee$export$937f713ec248269b);
$parcel$export(module.exports, "searchOrderCatalog", () => $375f8776645d5aee$export$14e053085c2b7017);
$parcel$export(module.exports, "fetchFrequentOrders", () => $375f8776645d5aee$export$8844835d216cf19c);
$parcel$export(module.exports, "fetchClinicOrders", () => $375f8776645d5aee$export$7fb4b3e6d0f53ffa);
$parcel$export(module.exports, "rememberCatalogNamesEn", () => $375f8776645d5aee$export$69d0d94972917188);
$parcel$export(module.exports, "primeCatalogNamesEn", () => $375f8776645d5aee$export$d1f71c951f3a3ccc);
$parcel$export(module.exports, "resolveOrderCatalog", () => $375f8776645d5aee$export$ff3759fdd9615d20);
$parcel$export(module.exports, "useCatalogNamesEn", () => $375f8776645d5aee$export$891bfbeed44ddfce);
$parcel$export(module.exports, "doseLineLabel", () => $375f8776645d5aee$export$f1536cfec6e3f4b8);
$parcel$export(module.exports, "UrgencyBadge", () => $375f8776645d5aee$export$30e9b064e10043f9);
$parcel$export(module.exports, "OrderCheckItem", () => $375f8776645d5aee$export$a36149ed7c50a677);
$parcel$export(module.exports, "orderNameLines", () => $375f8776645d5aee$export$adea16e688375bbf);
$parcel$export(module.exports, "ownCatalogName", () => $375f8776645d5aee$export$239a3e8cf23f2d47);
$parcel$export(module.exports, "aiPatientAge", () => $375f8776645d5aee$export$9c5829f0850e67fe);
$parcel$export(module.exports, "buildPatientHistory", () => $375f8776645d5aee$export$bf8ea0179266f66d);
$parcel$export(module.exports, "buildVisitContext", () => $375f8776645d5aee$export$282a2c8a3d030b1);
$parcel$export(module.exports, "questionStatement", () => $375f8776645d5aee$export$afbcfcdadda1b1bf);
$parcel$export(module.exports, "questionFinding", () => $375f8776645d5aee$export$9c2ce4aa2a7d6fc6);
$parcel$export(module.exports, "pruneDiagnosisKeyed", () => $375f8776645d5aee$export$7904c2b41f6b4e23);
$parcel$export(module.exports, "appendSubjectiveFinding", () => $375f8776645d5aee$export$5a4e1c8ddaeead64);
$parcel$export(module.exports, "buildPlanBlock", () => $375f8776645d5aee$export$d3332d0820799abb);
$parcel$export(module.exports, "splicePlanBlock", () => $375f8776645d5aee$export$a3aead4a50abe781);
$parcel$export(module.exports, "planBlockText", () => $375f8776645d5aee$export$69cdf1bc97231e5);
$parcel$export(module.exports, "filterClinicalInsights", () => $375f8776645d5aee$export$b2355ec0f81e9680);
$parcel$export(module.exports, "INSIGHT_REPEAT_THRESHOLD", () => $375f8776645d5aee$export$769e1e6a71b6cabc);
$parcel$export(module.exports, "insightSimilarity", () => $375f8776645d5aee$export$6a1145afc4baa12e);
$parcel$export(module.exports, "interactionAlreadyShown", () => $375f8776645d5aee$export$bd5821baf0a03519);
$parcel$export(module.exports, "fillPrescriptionTemplate", () => $375f8776645d5aee$export$1512fb0c882aac98);
$parcel$export(module.exports, "PRINT_SHEET", () => $375f8776645d5aee$export$abc13ae812b14a42);
$parcel$export(module.exports, "useRecordSections", () => $375f8776645d5aee$export$6523efd640f02d3b);
$parcel$export(module.exports, "printPrescription", () => $375f8776645d5aee$export$e57f8733307287ae);
$parcel$export(module.exports, "drugDisplayName", () => (parcelRequire("g6gAc")).drugDisplayName);
$parcel$export(module.exports, "drugNameLines", () => (parcelRequire("g6gAc")).drugNameLines);
// ── Visit.shared.js ──────────────────────────────────────────────────────────
// Shared GraphQL operations, CSS, primitives, and helper components used by both
// Visit.web.jsx (desktop) and Visit.mobile.jsx (mobile). Extracted verbatim from
// the former unified Visit.web.jsx so desktop's behavior/output is unchanged.
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $lfHhF = parcelRequire("lfHhF");

var $eQiuG = parcelRequire("eQiuG");

var $g6gAc = parcelRequire("g6gAc");

var $acw62 = parcelRequire("acw62");
parcelRequire("7sS0P");
var $jTCZr = parcelRequire("jTCZr");

var $eVM84 = parcelRequire("eVM84");

var $c9qmv = parcelRequire("c9qmv");

var $dsmcB = parcelRequire("dsmcB");

var $aSWLO = parcelRequire("aSWLO");

var $4s6k1 = parcelRequire("4s6k1");
parcelRequire("5N0ZI");
var $5AX1S = parcelRequire("5AX1S");
var $5JYPc = parcelRequire("5JYPc");

var $eLeza = parcelRequire("eLeza");

var $3Tnyk = parcelRequire("3Tnyk");

var $aoLHg = parcelRequire("aoLHg");

var $lnUwI = parcelRequire("lnUwI");

var $1yr2B = parcelRequire("1yr2B");

var $6ojK3 = parcelRequire("6ojK3");

var $gq4TR = parcelRequire("gq4TR");
parcelRequire("2tKqm");
var $9BgRG = parcelRequire("9BgRG");

var $bOPUe = parcelRequire("bOPUe");

var $85jFj = parcelRequire("85jFj");

var $QG9Z3 = parcelRequire("QG9Z3");
var $d8YVq = parcelRequire("d8YVq");
var $5JVBe = parcelRequire("5JVBe");
var $jis86 = parcelRequire("jis86");
var $dDvfT = parcelRequire("dDvfT");
var $huNwV = parcelRequire("huNwV");
var $gKFEi = parcelRequire("gKFEi");
var $kzPvP = parcelRequire("kzPvP");
var $ggYuf = parcelRequire("ggYuf");
var $kMJsW = parcelRequire("kMJsW");
var $3FyOw = parcelRequire("3FyOw");
var $4CVxl = parcelRequire("4CVxl");
var $i5dmF = parcelRequire("i5dmF");
var $97xXr = parcelRequire("97xXr");
var $cAg7Z = parcelRequire("cAg7Z");
var $2UQ3h = parcelRequire("2UQ3h");
var $hSPBf = parcelRequire("hSPBf");
var $022jy = parcelRequire("022jy");
var $aGlWN = parcelRequire("aGlWN");
var $aVx4q = parcelRequire("aVx4q");
var $8g4t5 = parcelRequire("8g4t5");
var $bF8pu = parcelRequire("bF8pu");
var $aWpbN = parcelRequire("aWpbN");
var $03cDl = parcelRequire("03cDl");
var $e5Ore = parcelRequire("e5Ore");
var $6OGKD = parcelRequire("6OGKD");
var $53qqr = parcelRequire("53qqr");
var $bo0GS = parcelRequire("bo0GS");
var $chm1L = parcelRequire("chm1L");
var $7udIf = parcelRequire("7udIf");
var $fX0JO = parcelRequire("fX0JO");
var $lUsTt = parcelRequire("lUsTt");
var $4KmG0 = parcelRequire("4KmG0");
var $jdP8o = parcelRequire("jdP8o");
var $6imzq = parcelRequire("6imzq");
var $6TdpC = parcelRequire("6TdpC");
var $iS1Sb = parcelRequire("iS1Sb");
const $375f8776645d5aee$export$610b800a6c6defa5 = `mutation CreateVisit($patientId:ID!,$type:String!){createVisit(patientId:$patientId,type:$type){id}}`;
const $375f8776645d5aee$export$cdc0bbb5663f787c = `mutation StartVisit($id:ID!){startVisit(id:$id){id status}}`;
const $375f8776645d5aee$export$15aef7fbfc49de29 = `mutation UpdateVisit($id:ID!,$input:VisitInput!){updateVisit(id:$id,input:$input){id}}`;
const $375f8776645d5aee$export$33b114336c19593d = `mutation EndVisit($id:ID!){endVisit(id:$id){id status}}`;
const $375f8776645d5aee$export$d877ca4a83c64a39 = `query AskDoctorQuestion($visitId:ID!,$question:String!,$transcriptionContext:String,$patientHistory:String,$patientId:ID){askDoctorQuestion(visitId:$visitId,question:$question,transcriptionContext:$transcriptionContext,patientHistory:$patientHistory,patientId:$patientId){answer confidence followUpSuggestions}}`;
const $375f8776645d5aee$export$15324fc83c054605 = `query GenerateConfirmationQuestions($visitId:ID,$patientId:ID,$differentials:[ConfirmationDiagnosisInput!]!,$transcriptionContext:String,$patientHistory:String){generateConfirmationQuestions(visitId:$visitId,patientId:$patientId,differentials:$differentials,transcriptionContext:$transcriptionContext,patientHistory:$patientHistory){items{diagnosisCode description questions{id question hint positiveStatement negativeStatement}}fallback}}`;
const $375f8776645d5aee$export$9812972017b718e1 = `query CheckDrugInteraction($medicationIds:[String!]!,$patientId:ID!,$patientConditions:[String!],$patientAllergies:[String!]){checkDrugInteraction(medicationIds:$medicationIds,patientId:$patientId,patientConditions:$patientConditions,patientAllergies:$patientAllergies){hasInteractions warnings{severity description drugPair source warningType drug condition}}}`;
const $375f8776645d5aee$export$781b4a03507fea1f = `mutation InitializeVisitSession($visitId:ID!,$patientId:ID!){initializeVisitSession(visitId:$visitId,patientId:$patientId){sessionId status}}`;
const $375f8776645d5aee$export$bc9f2df565557d4f = `query GetDifferentialDiagnosis($visitId:ID!){getDifferentialDiagnosis(visitId:$visitId){regenerated items{diagnosisCode description confidence status supportingEvidence contradictingEvidence vitalSignImpact{vital value status effect explanation} citations{pmid title journal year url}confidenceScore{level score factors}}}}`;
const $375f8776645d5aee$export$477e67f6b97e7e38 = `mutation UpdateDifferentialItem($appointmentId:ID!,$diagnosisCode:String!,$action:String!,$diagnosisType:DiagnosisType){updateDifferentialItem(appointmentId:$appointmentId,diagnosisCode:$diagnosisCode,action:$action,diagnosisType:$diagnosisType){items{diagnosisCode description confidence status supportingEvidence contradictingEvidence vitalSignImpact{vital value status effect explanation} citations{pmid title journal year url}confidenceScore{level score factors}}}}`;
const $375f8776645d5aee$export$d3a7b2340b0c9d48 = 8000;
const $375f8776645d5aee$export$7ae855654c1494b5 = `mutation RefineSoapNote($visitId:ID!,$patientId:ID,$input:RefineSoapNoteInput!){refineSoapNote(visitId:$visitId,patientId:$patientId,input:$input){sections{section text changed additions}changed charged status}}`;
const $375f8776645d5aee$export$82d8fcb090733ceb = `mutation AssistPrescription($input:AssistPrescriptionInput!){assistPrescription(input:$input){hasInteractions interactionWarnings{severity description drugPair source warningType drug condition}suggestedMedications{name dosage frequency duration notes citations{pmid title journal year url}}alternativeMedications recommendedTests{testName reason urgency}missingTests followUpTimeline}}`;
const $375f8776645d5aee$export$e94eea18383a4188 = `query ListDrugs($query:String,$category:String,$limit:Int,$offset:Int){listDrugs(query:$query,category:$category,limit:$limit,offset:$offset){drugs{id name genericName category commonDosages commonFrequencies taminListed}total}}`;
const $375f8776645d5aee$export$b3499ea44c0870d9 = `query DrugsById($ids:[ID!],$limit:Int){listDrugs(ids:$ids,limit:$limit){drugs{id name genericName category commonDosages commonFrequencies taminListed}}}`;
const $375f8776645d5aee$export$64bb5ba76d2f107b = `query MyFrequentDrugs($limit:Int){myFrequentDrugs(limit:$limit){times name search dosage frequency route duration quantity instructions drug{id name genericName category commonDosages commonFrequencies taminListed}}}`;
const $375f8776645d5aee$export$8f8d9d75fce10d3d = `query MyLastDrugSigs($drugIds:[ID!]!){myLastDrugSigs(drugIds:$drugIds){times name search dosage frequency route duration quantity instructions lastAt drug{id name genericName category commonDosages commonFrequencies taminListed}}}`;
const $375f8776645d5aee$export$f6cdc6e4a4a3c80a = `mutation UpdatePatient($id:ID!,$input:UpdatePatientInput!){updatePatient(id:$id,input:$input){id name phone birthDate bloodType nationalId job insurance height}}`;
const $375f8776645d5aee$export$19b465740ee91bc = `query RecommendTestsAndMedications($input:RecommendationInput!){recommendTestsAndMedications(input:$input){recommendedTests{testName reason urgency}recommendedMedications{name dosage frequency duration notes}clinicalRationale}}`;
const $375f8776645d5aee$export$59a0707dfedfe8a6 = `mutation AddMedication($patientId:ID!,$input:CreateMedicationInput!){addMedication(patientId:$patientId,input:$input){id}}`;
const $375f8776645d5aee$export$52e699bb9024b09d = `mutation AddCondition($patientId:ID!,$input:CreateConditionInput!){addCondition(patientId:$patientId,input:$input){id}}`;
const $375f8776645d5aee$export$ea4d931135e95fd1 = `mutation DeleteCondition($id:ID!){deleteCondition(id:$id)}`;
const $375f8776645d5aee$export$b8ec51b731e55222 = `mutation UpdateCondition($id:ID!,$input:UpdateConditionInput!){updateCondition(id:$id,input:$input){id verificationStatus}}`;
const $375f8776645d5aee$export$6762df89b8e36811 = `mutation UpdateEncounter($id:ID!,$input:UpdateEncounterInput!){updateEncounter(id:$id,input:$input){id}}`;
const $375f8776645d5aee$export$32eb09bac36a8a3b = `mutation AddClinicalNote($patientId:ID!,$input:CreateClinicalNoteInput!){addClinicalNote(patientId:$patientId,input:$input){id}}`;
const $375f8776645d5aee$export$1d32d39b70c8b52e = `mutation CreateClinicalNote($patientId:ID!,$input:ClinicalNoteInput!){createClinicalNote(patientId:$patientId,input:$input){id}}`;
const $375f8776645d5aee$export$6e7c5d8b5a28479a = `mutation UpdateClinicalNote($id:ID!,$input:UpdateClinicalNoteInput!){updateClinicalNote(id:$id,input:$input){id}}`;
const $375f8776645d5aee$export$5fcaf1729c987f4d = `mutation CreateMedication($patientId:ID!,$input:MedicationInput!){createMedication(patientId:$patientId,input:$input){id}}`;
const $375f8776645d5aee$export$5d20d1065b54c736 = `mutation AddObservation($patientId:ID!,$input:CreateObservationInput!){addObservation(patientId:$patientId,input:$input){id}}`;
const $375f8776645d5aee$export$815cd81bee1aa526 = `query PatientVisitHistory($patientId:ID!,$limit:Int){patientVisitHistory(patientId:$patientId,limit:$limit){visits{appointmentId visitId summary suggestedDiagnosis icdCodes{code description}}}}`;
const $375f8776645d5aee$export$c3637e87e40dab8f = `query SuggestDoctorOrders($appointmentId:ID,$patientId:ID!,$icdCodes:[String!],$diagnoses:[String!],$age:Int,$gender:String,$existingTests:[String!]){suggestDoctorOrders(appointmentId:$appointmentId,patientId:$patientId,icdCodes:$icdCodes,diagnoses:$diagnoses,age:$age,gender:$gender,existingTests:$existingTests){labTests{testName reason urgency category loincCode}imagingStudies{studyType modality bodyPart reason urgency}procedureOrders{name code reason urgency category}clinicalRationale}}`;
const $375f8776645d5aee$export$bed6819e031e8e35 = `mutation SaveDoctorOrders($input:SaveDoctorOrdersInput!){saveDoctorOrders(input:$input){success savedCount error}}`;
const $375f8776645d5aee$export$e8c7fd9774d91e48 = `query EncounterContext($appointmentId:ID!){getEncounterContext(appointmentId:$appointmentId){conditions{id code display clinicalStatus}medications{id code display status dosageInstruction meta}orders{id orderType description status createdAt performedDate performedHere stage nextBookingAt}notes{id format content}}}`;
const $375f8776645d5aee$export$a03187f2f2e2a95d = 3;
const $375f8776645d5aee$export$47d6b1214c1fc978 = 6;
function $375f8776645d5aee$export$8b03bbb666cde734({ soap: soap } = {}) {
    const history = (soap?.s || '').trim();
    const words = history.split(/\s+/).filter(Boolean);
    const chars = history.replace(/\s+/g, '').length;
    const historyOk = words.length >= $375f8776645d5aee$export$a03187f2f2e2a95d && chars >= $375f8776645d5aee$export$47d6b1214c1fc978;
    // An empty «S» and a one-line «S» are different problems, and the doctor is
    // told which one they have: one asks them to write, the other to say more.
    const missing = historyOk ? [] : [
        history ? 'historyThin' : 'history'
    ];
    return {
        ready: historyOk,
        missing: missing,
        historyOk: historyOk
    };
}
const $375f8776645d5aee$export$eaa2f90824feaabb = `query VideoVisitAvailability($patientId:ID!,$appointmentId:ID){videoVisitAvailability(patientId:$patientId,appointmentId:$appointmentId){appointmentId canJoin canConvert reason}}`;
const $375f8776645d5aee$export$16ac3aeec5aaa168 = `mutation SetVisitMode($patientId:ID!,$appointmentId:ID,$online:Boolean!){setVisitMode(patientId:$patientId,appointmentId:$appointmentId,online:$online){appointmentId canJoin canConvert reason}}`;
const $375f8776645d5aee$export$6651891395397547 = `query VideoVisitSession($patientId:ID!,$appointmentId:ID){videoVisitSession(patientId:$patientId,appointmentId:$appointmentId){domain roomName token expiresAt displayName moderator appointmentId}}`;
const $375f8776645d5aee$export$a921a07aefa7f54c = `query VisitCoinUsage($appointmentId:ID!){visitCoinUsage(appointmentId:$appointmentId){total entries{id coins count}}}`;
const $375f8776645d5aee$export$f6b16ee713a6ec9e = `mutation RecordVisitCoinCharge($appointmentId:ID!,$itemId:String!,$coins:Float!){recordVisitCoinCharge(appointmentId:$appointmentId,itemId:$itemId,coins:$coins){total entries{id coins count}}}`;
function $375f8776645d5aee$export$68c00840ed3a0f40(stored, pending) {
    const byId = new Map((stored || []).map((e)=>[
            e.id,
            {
                ...e
            }
        ]));
    for (const c of pending || []){
        const row = byId.get(c.itemId);
        if (row) {
            row.coins += c.coins;
            row.count += 1;
        } else byId.set(c.itemId, {
            id: c.itemId,
            coins: c.coins,
            count: 1
        });
    }
    // Biggest spender first — the breakdown is read to find where the Parseh went.
    return [
        ...byId.values()
    ].sort((a, b)=>b.coins - a.coins);
}
const $375f8776645d5aee$var$toCoinEntries = (usage)=>(usage?.entries || []).map((e)=>({
            id: e.id,
            coins: Number(e.coins) || 0,
            count: Number(e.count) || 0
        }));
function $375f8776645d5aee$export$18ea943e404e01dd(appointmentId) {
    // `stored` is what the visit says it has spent; `pending` is what this page
    // has spent and not yet seen confirmed. What the badge shows is the two folded
    // together, so a charge is visible the instant the action returns and the
    // record still wins the moment it answers.
    const [ledger, setLedger] = (0, $acw62.useState)({
        stored: [],
        pending: []
    });
    const entries = (0, $acw62.useMemo)(()=>$375f8776645d5aee$export$68c00840ed3a0f40(ledger.stored, ledger.pending), [
        ledger
    ]);
    const total = (0, $acw62.useMemo)(()=>entries.reduce((sum, e)=>sum + (e.coins || 0), 0), [
        entries
    ]);
    // The appointment is read through a ref so `charge` can be created ONCE and
    // stay stable for the whole visit. The effects that bill — the debounced
    // interaction sweep — take it as a dependency, and an identity that changed
    // every render would re-trigger the very charge it exists to record.
    const apptRef = (0, $acw62.useRef)(appointmentId);
    apptRef.current = appointmentId;
    // Every charge below is priced by `costOf()`, which answers the shipped
    // constant until the price list has been read. The doctor panel's layout reads
    // it; the clinic panel, which hosts this same room, never did — so its visits
    // tallied «پیشنهاد آزمایش و دارو» at 10 while the wallet charged 1.6
    // (PM-0512). The room reads the list itself; the store makes it one request.
    (0, $acw62.useEffect)(()=>{
        (0, $1yr2B.loadCreditPrices)();
    }, []);
    const pendingRef = (0, $acw62.useRef)(ledger.pending);
    pendingRef.current = ledger.pending;
    const tokenRef = (0, $acw62.useRef)(0);
    const sentRef = (0, $acw62.useRef)(new Set());
    const prevApptRef = (0, $acw62.useRef)(null);
    // Write one charge and reconcile against the aggregate that comes back. The
    // reply is read AFTER the write commits, so it already contains this charge —
    // which is why the pending copy is dropped at the same moment the stored one
    // replaces it, never before and never twice.
    const sendRef = (0, $acw62.useRef)(null);
    sendRef.current = (charge)=>{
        const appt = apptRef.current;
        if (!appt) return;
        (0, $eVM84.bffMutation)($375f8776645d5aee$export$f6b16ee713a6ec9e, {
            appointmentId: appt,
            itemId: charge.itemId,
            coins: charge.coins
        }).then((d)=>{
            const usage = d?.recordVisitCoinCharge;
            // No aggregate in the reply means nothing to reconcile against. The
            // local copy stays: the doctor keeps seeing what the action cost.
            if (!usage) return;
            setLedger((l)=>({
                    stored: $375f8776645d5aee$var$toCoinEntries(usage),
                    pending: l.pending.filter((p)=>p.token !== charge.token)
                }));
        })// Left pending on purpose. What was spent was spent; only the record of
        // it is missing, and the badge must not pretend otherwise.
        .catch((err)=>console.warn('visit coin charge not recorded:', err?.message || err));
    };
    // Entering a visit — including re-entering one, and including the reload that
    // follows a refresh — reads the stored usage. This is the whole feature: the
    // badge is recovered from the visit rather than remembered from the session.
    (0, $acw62.useEffect)(()=>{
        const prev = prevApptRef.current;
        prevApptRef.current = appointmentId;
        // Moving to a DIFFERENT visit starts from nothing. Arriving at one from "no
        // visit yet" does not — that is the same visit finishing opening, and the
        // charges it made while its id was in flight are written below.
        if (prev && prev !== appointmentId) {
            sentRef.current.clear();
            setLedger({
                stored: [],
                pending: []
            });
        }
        if (!appointmentId) return undefined;
        let alive = true;
        // The page can bill before getActiveEncounter answers — the automatic
        // «نکات بالینی» pass on mount. Those coins belong to the visit that is
        // opening, so they are written now rather than dropped.
        for (const c of pendingRef.current){
            if (sentRef.current.has(c.token)) continue;
            sentRef.current.add(c.token);
            sendRef.current(c);
        }
        (0, $eVM84.bffQuery)($375f8776645d5aee$export$a921a07aefa7f54c, {
            appointmentId: appointmentId
        }).then((d)=>{
            if (alive && d?.visitCoinUsage) setLedger((l)=>({
                    ...l,
                    stored: $375f8776645d5aee$var$toCoinEntries(d.visitCoinUsage)
                }));
        })// A readout that cannot be read keeps whatever it has. Failing to fetch
        // the tally is not a reason to tell the doctor the visit was free.
        .catch((err)=>console.warn('visit coin usage load failed:', err?.message || err));
        return ()=>{
            alive = false;
        };
    }, [
        appointmentId
    ]);
    // Read the stored tally again, for the charges this page did NOT make.
    //
    // Transcription is the one priced component the client no longer bills
    // (spec §3.1 A5): the line is written by the BFF, from the audio it actually
    // received, so the browser's counter can no longer bill a suspended page for
    // dead air. The consequence is that the badge learns about it only by asking,
    // which is what a stopped recording does.
    const refetch = (0, $acw62.useCallback)(()=>{
        const appt = apptRef.current;
        if (!appt) return;
        (0, $eVM84.bffQuery)($375f8776645d5aee$export$a921a07aefa7f54c, {
            appointmentId: appt
        }).then((d)=>{
            if (d?.visitCoinUsage) setLedger((l)=>({
                    ...l,
                    stored: $375f8776645d5aee$var$toCoinEntries(d.visitCoinUsage)
                }));
        }).catch((err)=>console.warn('visit coin usage refetch failed:', err?.message || err));
    }, []);
    const charge = (0, $acw62.useCallback)((coins, itemId)=>{
        if (!coins || !itemId) return;
        const entry = {
            token: ++tokenRef.current,
            coins: coins,
            itemId: itemId
        };
        setLedger((l)=>({
                ...l,
                pending: [
                    ...l.pending,
                    entry
                ]
            }));
        // No encounter id yet means the visit is still opening; the effect above
        // writes it as soon as there is a visit to attach it to.
        if (!apptRef.current) return;
        sentRef.current.add(entry.token);
        sendRef.current(entry);
    }, []);
    return {
        entries: entries,
        total: total,
        charge: charge,
        refetch: refetch
    };
}
const $375f8776645d5aee$export$8b5e11eca8d53d1 = 30;
function $375f8776645d5aee$export$507352e36a49c92e(soap, key) {
    return key === 'p' ? $375f8776645d5aee$export$35974e4f6db92b0(soap?.p || '') : soap?.[key] || '';
}
function $375f8776645d5aee$export$2bf69ab1543620b6(merged, base, current) {
    const was = String(base || '').trimEnd();
    const now = String(current || '').trimEnd();
    if (now === was) return merged;
    if (!now.startsWith(was)) return null;
    const tail = now.slice(was.length);
    if (was && !/^\s/.test(tail)) return null;
    const head = String(merged || '').trimEnd();
    return was ? `${head}${tail}` : `${head}\n${tail.trimStart()}`;
}
function $375f8776645d5aee$export$1737c681d4b4a856(key) {
    const el = typeof document === 'undefined' ? null : document.activeElement;
    return !!el && el.getAttribute?.('data-soap-key') === key;
}
function $375f8776645d5aee$export$3c5b8ac9cc0f8a4(soapNoteId, setSoapNoteId, visitKey) {
    const idRef = (0, $acw62.useRef)(soapNoteId);
    const keyRef = (0, $acw62.useRef)(visitKey);
    const creatingRef = (0, $acw62.useRef)(null); // null | { key, settled }
    // Layout, not passive: a save from the very next event must already see a new
    // visit's null (or a resumed note's id), never the previous visit's row.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(()=>{
        idRef.current = soapNoteId;
    }, [
        soapNoteId
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(()=>{
        keyRef.current = visitKey;
    }, [
        visitKey
    ]);
    // write({ create: () => Promise<id>, update: (id) => Promise }) → the row's id
    return (0, $acw62.useCallback)(async ({ create: create, update: update })=>{
        const key = keyRef.current;
        let id = idRef.current;
        const pending = creatingRef.current;
        if (!id && pending && pending.key === key) id = await pending.settled;
        if (id) {
            await update(id);
            return id;
        }
        const creating = Promise.resolve().then(create);
        const entry = {
            key: key,
            settled: creating.then((x)=>x || null, ()=>null)
        };
        creatingRef.current = entry;
        try {
            const created = await creating;
            if (created && keyRef.current === key) {
                idRef.current = created;
                setSoapNoteId(created);
            }
            return created || null;
        } finally{
            if (creatingRef.current === entry) creatingRef.current = null;
        }
    }, [
        setSoapNoteId
    ]);
}
function $375f8776645d5aee$export$79f39042065fbd7d({ visitId: visitId, patientId: patientId, soapRef: soapRef, liveTranscript: liveTranscript, chargeVisit: chargeVisit, onApply: onApply, onCreditError: onCreditError, t: t, autoConfirm: autoConfirm = false, isEditing: isEditing, onAutoConfirm: onAutoConfirm }) {
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [loadingSections, setLoadingSections] = (0, $acw62.useState)(null); // null | string[]
    // {key: {text, additions, base, stale?}} — `base` is the section the proposal
    // was made from (soapSectionText at request time); `stale` marks one whose
    // section the doctor changed before confirming it (rebaseSoapProposal).
    const [preview, setPreview] = (0, $acw62.useState)(null);
    const [status, setStatus] = (0, $acw62.useState)(null); // null|'ok'|'no_new_content'|'no_transcript'|'error'
    const [lastRefineLen, setLastRefineLen] = (0, $acw62.useState)(null);
    const inFlightRef = (0, $acw62.useRef)(false);
    // Render-assigned, like soapRef: «تأیید» decides from the proposals on screen,
    // outside the state updater, so the write happens once and only once.
    const previewRef = (0, $acw62.useRef)(preview);
    previewRef.current = preview;
    const liveRef = (0, $acw62.useRef)('');
    liveRef.current = liveTranscript || '';
    // Read when an answer lands, not when it was asked for: the switch, the caret
    // and the screen's writers as they are THEN.
    const autoRef = (0, $acw62.useRef)({});
    autoRef.current = {
        on: autoConfirm,
        isEditing: isEditing,
        onApply: onApply,
        onAutoConfirm: onAutoConfirm
    };
    // The screen stays mounted when the doctor moves to another visit, so an answer
    // can land in a different patient's note than the one it read.
    const visitRef = (0, $acw62.useRef)(visitId);
    visitRef.current = visitId;
    // A new visit is a clean slate — previews from the last patient's note must
    // never survive into this one.
    (0, $acw62.useEffect)(()=>{
        setPreview(null);
        setStatus(null);
        setLastRefineLen(null);
    }, [
        visitId
    ]);
    const liveLen = (liveTranscript || '').length;
    const hasNewContent = (liveTranscript || '').trim().length >= $375f8776645d5aee$export$8b5e11eca8d53d1 && (lastRefineLen === null || liveLen >= lastRefineLen + $375f8776645d5aee$export$8b5e11eca8d53d1);
    // «محتوای جدیدی یافت نشد» stops being true the moment new speech lands —
    // clear it so the doctor is not reading a stale verdict.
    (0, $acw62.useEffect)(()=>{
        if (hasNewContent) setStatus((s)=>s === 'no_new_content' || s === 'no_transcript' ? null : s);
    }, [
        hasNewContent
    ]);
    // Resolves to the outcome: 'found' (proposals are on screen), 'none' (read,
    // nothing new) or 'error' (not read — including a merge the SERVER reports it
    // could not do, which the visit-wide «تکمیل» must report as failed, never as
    // «nothing new»).
    const refine = (0, $acw62.useCallback)(async (sections)=>{
        if (inFlightRef.current || !visitId) return 'error';
        inFlightRef.current = true;
        setLoading(true);
        setLoadingSections(sections && sections.length ? sections : null);
        setStatus(null);
        try {
            const soap = soapRef.current || {};
            const data = await (0, $eVM84.bffMutation)($375f8776645d5aee$export$7ae855654c1494b5, {
                visitId: visitId,
                patientId: patientId || null,
                input: {
                    s: soap.s || '',
                    o: soap.o || '',
                    a: soap.a || '',
                    // Only the narrative travels: the managed drug/order block is derived
                    // client-side and re-spliced on apply (see planBlockText).
                    p: $375f8776645d5aee$export$35974e4f6db92b0(soap.p || ''),
                    sections: sections && sections.length ? sections : null,
                    transcriptTail: liveRef.current.slice(-3000)
                }
            }, {
                timeoutMs: (0, $eVM84.LONG_REQUEST_TIMEOUT_MS)
            });
            const res = data?.refineSoapNote;
            if (!res) {
                setStatus('error');
                return 'error';
            }
            // The server, not the click, decides whether this cost anything.
            if (res.charged) chargeVisit?.((0, $1yr2B.costOf)('SOAP_REFINE'), 'ask', t?.('visit.soap.completed'));
            setLastRefineLen(liveRef.current.length);
            const changedSections = (res.sections || []).filter((x)=>x.changed && (x.text || '').trim());
            const found = !!(res.changed && changedSections.length);
            // «تایید خودکار»: the write «تأیید» makes, against the note as it is NOW.
            const auto = {};
            const autoOn = typeof autoRef.current.on === 'function' ? autoRef.current.on() : !!autoRef.current.on;
            // Never into another visit than the one this was read for.
            if (found && autoOn && visitRef.current === visitId) {
                const now = soapRef.current || {};
                changedSections.forEach((x)=>{
                    if (autoRef.current.isEditing?.(x.section)) return;
                    const base = $375f8776645d5aee$export$507352e36a49c92e(soap, x.section);
                    const before = $375f8776645d5aee$export$507352e36a49c92e(now, x.section);
                    const after = $375f8776645d5aee$export$2bf69ab1543620b6(x.text, base, before);
                    if (after != null) auto[x.section] = {
                        key: x.section,
                        before: before,
                        after: after,
                        entry: {
                            text: x.text,
                            additions: x.additions || [],
                            base: base
                        }
                    };
                });
            }
            const autoKeys = Object.keys(auto);
            // A stale proposal in a part that was just read again has been answered:
            // replaced below if the reading found something, gone if it did not.
            const read = sections && sections.length ? sections : [
                's',
                'o',
                'a',
                'p'
            ];
            if (found || res.status !== 'error') setPreview((prev)=>{
                if (!found && !read.some((k)=>prev?.[k]?.stale)) return prev;
                const next = {
                    ...prev || {}
                };
                read.forEach((k)=>{
                    if (next[k]?.stale) delete next[k];
                });
                changedSections.forEach((x)=>{
                    // Confirmed by itself: written, so an older proposal for it is answered too.
                    if (auto[x.section]) {
                        delete next[x.section];
                        return;
                    }
                    next[x.section] = {
                        text: x.text,
                        additions: x.additions || [],
                        base: $375f8776645d5aee$export$507352e36a49c92e(soap, x.section)
                    };
                });
                return Object.keys(next).length ? next : null;
            });
            if (autoKeys.length) {
                autoRef.current.onApply?.(Object.fromEntries(autoKeys.map((k)=>[
                        k,
                        auto[k].after
                    ])));
                autoRef.current.onAutoConfirm?.(autoKeys.map((k)=>auto[k]));
            }
            if (found) setStatus('ok');
            else // 'error' is the server saying the merge itself failed — a timeout or
            // an unparseable answer. Folding it into «محتوای جدیدی یافت نشد» told
            // the doctor their visit had nothing new in it, which is the one thing
            // that was certainly untrue.
            setStatus(res.status === 'no_transcript' ? 'no_transcript' : res.status === 'error' ? 'error' : 'no_new_content');
            // 'auto': everything it found was confirmed by itself — nothing waits on screen.
            if (found) return autoKeys.length === changedSections.length ? 'auto' : 'found';
            return res.status === 'error' ? 'error' : 'none';
        } catch (e) {
            if (e?.extensions?.code === 'INSUFFICIENT_CREDITS') onCreditError?.(e.message);
            else {
                console.error('[SOAP refine]', e);
                setStatus('error');
            }
            return 'error';
        } finally{
            inFlightRef.current = false;
            setLoading(false);
            setLoadingSections(null);
        }
    }, [
        visitId,
        patientId,
        chargeVisit,
        onCreditError,
        t,
        soapRef
    ]);
    // «تأیید» for the proposals of `keys`, in ONE onApply. Each is written against
    // the section as it is NOW: as merged when untouched, with the doctor's
    // appended text kept when they only added to it, and not at all when they
    // changed it otherwise — that proposal turns stale and waits to be read again,
    // because writing it would silently delete what they wrote.
    const applyKeys = (0, $acw62.useCallback)((keys)=>{
        const prev = previewRef.current;
        if (!prev) return;
        const soap = soapRef.current || {};
        const entries = {};
        const stale = [];
        keys.forEach((key)=>{
            const entry = prev[key];
            if (!entry || entry.stale) return;
            const text = $375f8776645d5aee$export$2bf69ab1543620b6(entry.text, entry.base, $375f8776645d5aee$export$507352e36a49c92e(soap, key));
            if (text == null) stale.push(key);
            else entries[key] = text;
        });
        const applied = Object.keys(entries);
        if (!applied.length && !stale.length) return;
        // Settle exactly the entries decided on here — a proposal that arrived since
        // is a different object and stays.
        const settle = (cur)=>{
            if (!cur) return cur;
            const next = {
                ...cur
            };
            applied.forEach((k)=>{
                if (next[k] === prev[k]) delete next[k];
            });
            stale.forEach((k)=>{
                if (next[k] === prev[k]) next[k] = {
                    ...prev[k],
                    stale: true
                };
            });
            return Object.keys(next).length ? next : null;
        };
        previewRef.current = settle(prev);
        if (applied.length) onApply?.(entries);
        setPreview(settle);
        setStatus(null);
    }, [
        onApply,
        soapRef
    ]);
    const apply = (0, $acw62.useCallback)((key)=>applyKeys([
            key
        ]), [
        applyKeys
    ]);
    // `keys`: the sections whose proposals are ON SCREEN. The desktop's S/O/A tab
    // does not show «P» (it has a tab of its own), and «اعمال همه» there wrote a
    // proposal the doctor never saw. No list (or a click event) means every one.
    const applyAll = (0, $acw62.useCallback)((keys)=>{
        applyKeys(Array.isArray(keys) ? keys : Object.keys(previewRef.current || {}));
    }, [
        applyKeys
    ]);
    const dismiss = (0, $acw62.useCallback)((key)=>{
        setPreview((prev)=>{
            if (!prev?.[key]) return prev;
            const next = {
                ...prev
            };
            delete next[key];
            return Object.keys(next).length ? next : null;
        });
    }, []);
    const dismissAll = (0, $acw62.useCallback)(()=>{
        setPreview(null);
        setStatus(null);
    }, []);
    // «تایید خودکار» undone (PM-0573): the proposal waits on screen again as it came —
    // its `base` too, so «تأیید» rebases it on the section the undo left. A newer
    // proposal for that section already on screen is the one to read, and stays.
    const restore = (0, $acw62.useCallback)((key, entry)=>{
        if (!entry) return;
        setPreview((prev)=>prev?.[key] ? prev : {
                ...prev || {},
                [key]: entry
            });
    }, []);
    return {
        refine: refine,
        loading: loading,
        loadingSections: loadingSections,
        preview: preview,
        status: status,
        hasNewContent: hasNewContent,
        apply: apply,
        applyAll: applyAll,
        dismiss: dismiss,
        dismissAll: dismissAll,
        restore: restore
    };
}
function $375f8776645d5aee$export$3f0d5a0b11f5b929(ai, settingsUnknown, visitId) {
    const [override, setOverride] = (0, $acw62.useState)(null);
    // A new or resumed encounter is a different visit — the previous one's
    // exception must not follow the doctor into it.
    (0, $acw62.useEffect)(()=>{
        setOverride(null);
    }, [
        visitId
    ]);
    // While the doctor's choice is unknown — the settings are still in flight, or
    // the query that carries them FAILED — nothing has been decided yet, so the
    // loop stays parked rather than guessing with the defaults. Guessing costs
    // real credits here: every tick that re-assesses is billed.
    const fromSettings = !settingsUnknown && (0, $3Tnyk.differentialPollingActive)(ai);
    const active = override == null ? fromSettings : override;
    const toggle = (0, $acw62.useCallback)(()=>setOverride(!active), [
        active
    ]);
    return {
        active: active,
        pollMs: (0, $3Tnyk.differentialPollMs)(ai),
        seconds: (0, $3Tnyk.differentialPollSeconds)(ai),
        // True once the doctor has departed from Settings for this visit, so the
        // surfaces can say so instead of leaving them to wonder why the switch in
        // Settings no longer matches what the page is doing.
        overridden: override != null,
        toggle: toggle
    };
}
const $375f8776645d5aee$export$d20c1dcfc45ad42b = (d)=>d?.status === 'accepted' || d?.status === 'modified';
const $375f8776645d5aee$var$isDifferentialDecided = (d)=>$375f8776645d5aee$export$d20c1dcfc45ad42b(d) || d?.status === 'rejected';
async function $375f8776645d5aee$export$a11a26367843ed4f(seqRef, run) {
    seqRef.current += 1;
    try {
        return await run();
    } finally{
        seqRef.current += 1;
    }
}
function $375f8776645d5aee$export$24f67d3076448bf7(prev, items, { stale: stale = false } = {}) {
    const prevMap = Object.fromEntries((prev || []).map((d)=>[
            d.diagnosisCode,
            d
        ]));
    const merged = (items || []).map((item)=>{
        const shown = prevMap[item.diagnosisCode];
        const next = {
            ...item,
            confidenceScore: item.confidenceScore ?? shown?.confidenceScore
        };
        if (stale && $375f8776645d5aee$var$isDifferentialDecided(shown)) next.status = shown.status;
        return next;
    });
    if (!stale) return merged;
    const present = new Set(merged.map((d)=>d.diagnosisCode));
    return merged.concat((prev || []).filter((d)=>$375f8776645d5aee$export$d20c1dcfc45ad42b(d) && !present.has(d.diagnosisCode)));
}
async function $375f8776645d5aee$export$5cadc197239e50ce({ bffMutation: bffMutation, visitId: visitId, diagnosisCode: diagnosisCode, diagnosisType: diagnosisType, isAccepted: isAccepted, setDifferential: setDifferential }) {
    const res = await bffMutation($375f8776645d5aee$export$477e67f6b97e7e38, {
        appointmentId: visitId,
        diagnosisCode: diagnosisCode,
        action: isAccepted ? 'modify' : 'accept',
        diagnosisType: (0, $6ojK3.DIAGNOSIS_TYPE_ARG)[diagnosisType]
    });
    const updated = res.updateDifferentialItem?.items;
    if (updated) setDifferential((prev)=>{
        const prevMap = Object.fromEntries((prev || []).map((x)=>[
                x.diagnosisCode,
                x
            ]));
        return updated.map((item)=>({
                ...item,
                confidenceScore: item.confidenceScore ?? prevMap[item.diagnosisCode]?.confidenceScore
            }));
    });
    return updated;
}
function $375f8776645d5aee$export$5b3196b6580e75eb(conditions, diagnosisCode) {
    if (!diagnosisCode) return null;
    const hit = (conditions || []).find((c)=>c.code === diagnosisCode);
    return hit ? (0, $6ojK3.diagnosisTypeOf)(hit) : null;
}
function $375f8776645d5aee$export$89161e2370097cc4(encounters, { limit: limit, excludeId: excludeId } = {}) {
    const rows = (encounters || []).filter((e)=>e && e.status === 'finished' && (!excludeId || e.id !== excludeId)).sort((a, b)=>new Date(b.scheduledDate || 0) - new Date(a.scheduledDate || 0));
    return limit ? rows.slice(0, limit) : rows;
}
function $375f8776645d5aee$export$22c958772a7f76e1(summaries) {
    const map = new Map();
    for (const s of summaries || []){
        const key = s?.appointmentId || s?.visitId;
        if (key) map.set(String(key), s);
    }
    return map;
}
function $375f8776645d5aee$export$33b3781481f6ac85(context, summary) {
    const coded = (context?.conditions || []).map((c)=>c.display || c.code).filter(Boolean);
    if (coded.length) return coded;
    return summary?.suggestedDiagnosis ? [
        summary.suggestedDiagnosis
    ] : [];
}
const $375f8776645d5aee$export$f34a41ed9a6da313 = `query SuggestTreatmentPlan($input:SuggestTreatmentPlanInput!){suggestTreatmentPlan(input:$input){medications{name dosage frequency duration notes}labTests{testName reason urgency category loincCode}imagingStudies{studyType modality bodyPart reason urgency}procedureOrders{name code reason urgency category}planNote clinicalRationale interactionWarnings{severity description drugPair source warningType drug condition}}}`;
const $375f8776645d5aee$export$9c8ef21e5ce2027 = `query TreatmentPlan($appointmentId:ID!,$patientId:ID){treatmentPlan(appointmentId:$appointmentId,patientId:$patientId){id status planNote aiGenerated confirmedAt exists}}`;
const $375f8776645d5aee$export$97c305a43bb466fa = `mutation SaveTreatmentPlanNote($appointmentId:ID!,$patientId:ID,$planNote:String!,$aiGenerated:Boolean){saveTreatmentPlanNote(appointmentId:$appointmentId,patientId:$patientId,planNote:$planNote,aiGenerated:$aiGenerated){id status planNote aiGenerated exists}}`;
const $375f8776645d5aee$export$11e9f559a2c034d2 = `mutation ConfirmTreatmentPlan($appointmentId:ID!){confirmTreatmentPlan(appointmentId:$appointmentId){id status confirmedAt exists}}`;
const $375f8776645d5aee$export$725e3ec3814f10de = `mutation DeleteObservation($id:ID!){deleteObservation(id:$id)}`;
const $375f8776645d5aee$export$608c51c2a533f155 = `mutation DeleteMedication($id:ID!){deleteMedication(id:$id)}`;
const $375f8776645d5aee$export$b41f928ed45f8779 = `mutation UpdateMedication($id:ID!,$input:UpdateMedicationInput!){updateMedication(id:$id,input:$input){id status}}`;
const $375f8776645d5aee$export$cd39121473ec6a95 = `query PrescriptionTemplates{prescriptionTemplates{id title content scope}}`;
const $375f8776645d5aee$export$13ca7cd8c39f4461 = `query{getActiveEncounter{id patientId status}}`;
const $375f8776645d5aee$export$a98b585598d708d2 = `mutation ParseSoapVoiceField($transcript:String!,$field:String!){parseSoapVoiceField(transcript:$transcript,field:$field)}`;
const $375f8776645d5aee$export$5b71fce46c6ed6a3 = `query ListClinicalNotes($patientId:ID!,$appointmentId:ID){listClinicalNotes(patientId:$patientId,appointmentId:$appointmentId){id noteType content}}`;
const $375f8776645d5aee$export$337c36ab78c979c4 = `mutation CancelEncounter($id:ID!){cancelEncounter(id:$id){id status}}`;
const $375f8776645d5aee$export$2b09888e1f831a01 = 'id sessionNo appointmentId status plannedDate notDoneReason performedAt';
const $375f8776645d5aee$export$a335d939e8294daf = `id appointmentId orderType description urgency status notes createdAt performedDate code catalogId performedHere stage nextBookingAt processId sessionCount completedSessions openSessions sameVisit sessions{${$375f8776645d5aee$export$2b09888e1f831a01}}`;
const $375f8776645d5aee$export$1d5821a442552a84 = `query ListOrders($appointmentId:ID!){listOrders(appointmentId:$appointmentId){${$375f8776645d5aee$export$a335d939e8294daf}}}`;
const $375f8776645d5aee$export$7a496824567602ee = `query PastVisitOrders($appointmentId:ID!){listOrders(appointmentId:$appointmentId){id orderType description urgency notes code catalogId sessionCount}}`;
const $375f8776645d5aee$export$81ebae6b21d102e1 = `mutation CreateOrder($appointmentId:ID!,$patientId:ID!,$orderType:String!,$description:String!,$urgency:OrderUrgency,$notes:String,$code:String,$catalogId:ID,$sessionCount:Int,$performedDate:String){createOrder(appointmentId:$appointmentId,patientId:$patientId,orderType:$orderType,description:$description,urgency:$urgency,notes:$notes,code:$code,catalogId:$catalogId,sessionCount:$sessionCount,performedDate:$performedDate){${$375f8776645d5aee$export$a335d939e8294daf}}}`;
const $375f8776645d5aee$export$5d3bfd5c1289b2ab = `mutation UpdateOrderDate($orderId:ID!,$performedDate:String!){updateOrderDate(orderId:$orderId,performedDate:$performedDate){${$375f8776645d5aee$export$a335d939e8294daf}}}`;
// ثبت ویزیت در تأمین اجتماعی — the inline card in the closure modal. All three
// select the same fields because every step returns the same envelope; the card
// re-renders from `state` alone and never merges two shapes.
const $375f8776645d5aee$var$TAMIN_FIELDS = `state sessionId otpSentTo trackingCode message registeredCount missingFields skipped{name reason}`;
const $375f8776645d5aee$export$7bbd1b1f2e567778 = `query TaminPreview($appointmentId:ID!,$patientId:ID!){taminRegistrationPreview(appointmentId:$appointmentId,patientId:$patientId){available unavailableReason missingFields hasLiveSession registrableCount skipped{name reason}}}`;
const $375f8776645d5aee$export$b7f69c13f88802ea = `mutation BeginTamin($appointmentId:ID!,$patientId:ID!,$credentials:TaminCredentialsInput){beginTaminRegistration(appointmentId:$appointmentId,patientId:$patientId,credentials:$credentials){${$375f8776645d5aee$var$TAMIN_FIELDS}}}`;
const $375f8776645d5aee$export$905c6cb0f2f2e234 = `mutation SubmitTaminOtp($appointmentId:ID!,$patientId:ID!,$sessionId:ID!,$code:String!){submitTaminOtp(appointmentId:$appointmentId,patientId:$patientId,sessionId:$sessionId,code:$code){${$375f8776645d5aee$var$TAMIN_FIELDS}}}`;
// نسخه‌نویسی الکترونیک (op-naji) — the card beside the تأمین one in the closure.
// The server gathers the visit and holds the insurer session; the card renders
// what comes back (components/visit/EPrescriptionCard.jsx).
const $375f8776645d5aee$var$ERX_SESSION_FIELDS = 'insurer insurerLabel state expiresAt otpSentTo captchaImage redirectUrl messageCode message';
const $375f8776645d5aee$var$ERX_SUBMISSION_FIELDS = 'state insurer localId lifecycle trackingCode prescriptionCode ditasStatus gatewayStatus messageCode message fieldErrors{field message} retryable attempts updatedAt blockers{code message fixIn}';
const $375f8776645d5aee$export$fa16d22e4f643897 = `mutation CompleteRxDirections($input:RxDirectionsInput!){completeRxDirections(input:$input){status charged lines{lineId dosage frequency route duration quantity note}}}`;
// The preview, as the card reads it. «اصلاح نسخهٔ ثبت‌شده» (K1, 2026-10-04;
// docs/eprescription/CORRECTION.md) added what a registered part now holds: each
// line's part and the record row behind it, what the insurer has of a changed or
// removed line (`sentSummary`), and whether a correction can go (`correction`).
const $375f8776645d5aee$var$erxPreviewOp = (name, lineExtra, extra)=>`query ${name}($appointmentId:ID!,$patientId:ID!,$insurer:EPrescriptionInsurer,$patientNationalCode:String){ePrescriptionPreview(appointmentId:$appointmentId,patientId:$patientId,insurer:$insurer,patientNationalCode:$patientNationalCode){enabled insurer insurerLabel offeredInsurers patientInsurer ready sendableCount draftOnly serviceIssue serviceMessage siamId patientNationalCode sentNationalCode blockers{code message fixIn} lines{name sendable reasonCode reason erxCode serviceCode${lineExtra}}${extra} session{${$375f8776645d5aee$var$ERX_SESSION_FIELDS}} submission{${$375f8776645d5aee$var$ERX_SUBMISSION_FIELDS}}}}`;
const $375f8776645d5aee$export$4d6ef37e3b3fc364 = $375f8776645d5aee$var$erxPreviewOp('ErxPreview', ' part medicationId orderId performedDate validUntil sentSummary sentAs heldTrackingCode', ' correction{available pendingCount parts until unavailableReason}');
const $375f8776645d5aee$export$2fedc374da938b3c = $375f8776645d5aee$var$erxPreviewOp('ErxPreviewPreCorrection', '', '');
const $375f8776645d5aee$export$a95f04fc131305cf = `mutation ErxStartLogin($insurer:EPrescriptionInsurer!,$username:String,$password:String,$nationalCode:String,$mobile:String){startInsurerLogin(insurer:$insurer,username:$username,password:$password,nationalCode:$nationalCode,mobile:$mobile){${$375f8776645d5aee$var$ERX_SESSION_FIELDS}}}`;
const $375f8776645d5aee$export$d688676352e6afeb = `mutation ErxAnswer($insurer:EPrescriptionInsurer!,$otp:String,$captcha:String){answerInsurerChallenge(insurer:$insurer,otp:$otp,captcha:$captcha){${$375f8776645d5aee$var$ERX_SESSION_FIELDS}}}`;
const $375f8776645d5aee$export$d48ea6856e66736d = `mutation ErxLogout($insurer:EPrescriptionInsurer!){logoutInsurer(insurer:$insurer){${$375f8776645d5aee$var$ERX_SESSION_FIELDS}}}`;
const $375f8776645d5aee$export$3713d209ae047851 = `mutation ErxSetSiam($siamId:String!){setMySiamId(siamId:$siamId)}`;
const $375f8776645d5aee$export$cdbeae1ac264703e = `mutation ErxSend($appointmentId:ID!,$patientId:ID!,$insurer:EPrescriptionInsurer!,$patientNationalCode:String,$savePatientNationalCode:Boolean){sendEPrescription(appointmentId:$appointmentId,patientId:$patientId,insurer:$insurer,patientNationalCode:$patientNationalCode,savePatientNationalCode:$savePatientNationalCode){${$375f8776645d5aee$var$ERX_SUBMISSION_FIELDS} patientNationalCodeSaved}}`;
// The same two operations scoped to the نسخه or the دستورات (K1, 2026-10-03). Kept
// apart so an unscoped card still asks exactly what an older BFF understands.
const $375f8776645d5aee$var$withErxScope = (op, field)=>op.replace(/^(query|mutation) (\w+)\(/, '$1 $2Scoped($scope:EPrescriptionScope,').replace(`${field}(`, `${field}(scope:$scope,`);
const $375f8776645d5aee$export$e76d3b0c177e8362 = $375f8776645d5aee$var$withErxScope($375f8776645d5aee$export$4d6ef37e3b3fc364, 'ePrescriptionPreview');
const $375f8776645d5aee$export$5ddaa93868d3670f = $375f8776645d5aee$var$withErxScope($375f8776645d5aee$export$2fedc374da938b3c, 'ePrescriptionPreview');
const $375f8776645d5aee$export$876fbc5c8db40344 = 'query ErxEligibility($appointmentId:ID!,$patientId:ID!,$insurer:EPrescriptionInsurer!,$patientNationalCode:String){ePrescriptionEligibility(appointmentId:$appointmentId,patientId:$patientId,insurer:$insurer,patientNationalCode:$patientNationalCode){state reason blocks message coverageStatus checkedAt cached}}';
const $375f8776645d5aee$export$4b366d0c9745cd96 = $375f8776645d5aee$var$withErxScope($375f8776645d5aee$export$cdbeae1ac264703e, 'sendEPrescription');
const $375f8776645d5aee$export$45a656a5891fd4c1 = $375f8776645d5aee$export$cdbeae1ac264703e.replace('mutation ErxSend(', 'mutation ErxSendSavingInsurer($savePatientInsurer:Boolean,').replace('sendEPrescription(', 'sendEPrescription(savePatientInsurer:$savePatientInsurer,').replace(' patientNationalCodeSaved}}', ' patientNationalCodeSaved patientInsurerSaved}}');
const $375f8776645d5aee$export$f4844156b4b46778 = $375f8776645d5aee$var$withErxScope($375f8776645d5aee$export$45a656a5891fd4c1, 'sendEPrescription');
const $375f8776645d5aee$export$3dbec13a22a52d5f = (op)=>{
    const field = (op.match(/\b(ePrescriptionPreview|sendEPrescriptionCorrection|sendEPrescription)\(/) || [])[1];
    if (!field) return op;
    const out = op.replace(/^(query|mutation) (\w+)\(/, '$1 $2WithPatient($patientGender:String,$patientMobile:String,').replace(`${field}(`, `${field}(patientGender:$patientGender,patientMobile:$patientMobile,`);
    return field === 'sendEPrescription' ? out.replace(' patientNationalCodeSaved', ' patientNationalCodeSaved patientDetailsSaved') : out;
};
const $375f8776645d5aee$export$aebcdf6f5e0d5e2c = (op)=>op.replace(/^mutation (\w+)\(/, 'mutation $1Excluding($excludedMedicationIds:[ID!],$excludedOrderIds:[ID!],').replace('sendEPrescription(', 'sendEPrescription(excludedMedicationIds:$excludedMedicationIds,excludedOrderIds:$excludedOrderIds,');
const $375f8776645d5aee$export$e436a36803f66c6f = `query ErxStatus($appointmentId:ID!,$patientId:ID!){ePrescriptionStatus(appointmentId:$appointmentId,patientId:$patientId){enabled registered insurer final until expired pendingCount parts{part registered pendingCount trackingCode} lines{part medicationId orderId name state sentSummary performedDate validUntil}}}`;
const $375f8776645d5aee$export$998c87dffbd5dcdb = `mutation ErxSendCorrection($appointmentId:ID!,$patientId:ID!,$insurer:EPrescriptionInsurer!,$scope:EPrescriptionScope,$patientNationalCode:String){sendEPrescriptionCorrection(appointmentId:$appointmentId,patientId:$patientId,insurer:$insurer,scope:$scope,patientNationalCode:$patientNationalCode){${$375f8776645d5aee$var$ERX_SUBMISSION_FIELDS} correctsLocalId}}`;
const $375f8776645d5aee$export$883a58dcaa1f2c7e = `query ErxCodes($ids:[ID!]!){ePrescriptionCodes(appointmentIds:$ids){appointmentId codes{insurer insurerLabel scope code lifecycle registeredAt}}}`;
const $375f8776645d5aee$export$a829ddd2566c75b7 = `mutation StartOrder($orderId:ID!){startOrder(orderId:$orderId){id status}}`;
const $375f8776645d5aee$export$b0b354e2ddeac24b = `mutation CompleteOrder($orderId:ID!){completeOrder(orderId:$orderId){id status}}`;
const $375f8776645d5aee$export$494a03338ebc3893 = `mutation CancelOrder($orderId:ID!){cancelOrder(orderId:$orderId){id status}}`;
const $375f8776645d5aee$export$1f71eb225ba1e723 = `
  @keyframes spin    { to{transform:rotate(360deg)} }
  @keyframes pulse   { 0%,100%{opacity:.35;transform:scale(1)} 50%{opacity:.9;transform:scale(1.1)} }
  @keyframes fadeUp  { from{opacity:0;transform:translateY(8px)} to{opacity:1;transform:translateY(0)} }
  @keyframes slideDown { from{opacity:0;transform:translateY(-6px)} to{opacity:1;transform:translateY(0)} }
  @keyframes waveAnim0 { from{transform:scaleY(.40)} to{transform:scaleY(1.00)} }
  @keyframes waveAnim1 { from{transform:scaleY(.55)} to{transform:scaleY(1.00)} }
  @keyframes waveAnim2 { from{transform:scaleY(.30)} to{transform:scaleY(.95)} }
  @keyframes waveAnim3 { from{transform:scaleY(.60)} to{transform:scaleY(1.00)} }
  @keyframes waveAnim4 { from{transform:scaleY(.45)} to{transform:scaleY(.85)} }
  @keyframes blink   { 0%,100%{opacity:1} 50%{opacity:0} }
  @keyframes draw    { to{stroke-dashoffset:0} }
  @keyframes rgFade  { from{opacity:0} to{opacity:1} }
  @keyframes rgPop   { from{opacity:0;transform:scale(.92)} to{opacity:1;transform:scale(1)} }
  @keyframes rgRing  { 0%{opacity:.6;transform:scale(1)} 100%{opacity:0;transform:scale(1.7)} }
  @keyframes rgWave  { 0%,100%{transform:scaleY(.4)} 50%{transform:scaleY(1)} }
`;
const $375f8776645d5aee$export$220f2e5d84ced4cb = `
  :root {
    --bg:           ${(0, $jTCZr.CT).bg};
    --panel:        ${(0, $jTCZr.CT).surface};
    --panel-2:      ${(0, $jTCZr.CT).surface};
    --panel-inset:  ${(0, $jTCZr.CT).surface2};
    --line:         ${(0, $jTCZr.CT).border};
    --line-2:       ${(0, $jTCZr.CT).border2};
    --ink:          ${(0, $jTCZr.CT).ink};
    --ink-2:        ${(0, $jTCZr.CT).ink2};
    --mute:         ${(0, $jTCZr.CT).mute};
    --mute-2:       ${(0, $jTCZr.CT).mute2};
    --primary:      ${(0, $jTCZr.CT).navy};
    --primary-ink:  ${(0, $jTCZr.C).navyDark};
    --accent:       ${(0, $jTCZr.CT).accent};
    --accent-soft:  ${(0, $jTCZr.CT).accentSoft};
    --accent-ink:   ${(0, $jTCZr.CT).accentInk};
    --warn:         ${(0, $jTCZr.CT).warn};
    --warn-soft:    ${(0, $jTCZr.CT).warnSoft};
    --warn-ink:     ${(0, $jTCZr.CT).warnInk};
    --danger:       ${(0, $jTCZr.CT).danger};
    --danger-soft:  ${(0, $jTCZr.CT).dangerSoft};
    --danger-ink:   ${(0, $jTCZr.CT).dangerInk};
    --good:         ${(0, $jTCZr.CT).good};
    --good-soft:    ${(0, $jTCZr.CT).goodSoft};
    --good-ink:     ${(0, $jTCZr.CT).goodInk};
    --field:        #faf8f5;   /* warm-beige field/section-head \u{2014} the Visit "focus mode" literal (design-doc \xa7scope-exception) */
    --radius:       10px;
    --radius-lg:    14px;
    --shadow:       0 1px 0 rgba(15,23,42,.04), 0 1px 2px rgba(15,23,42,.05);
    --shadow-pop:   0 8px 28px rgba(15,23,42,.10), 0 2px 6px rgba(15,23,42,.06);
  }
`;
const $375f8776645d5aee$export$8b6317f87e032c1 = (t)=>[
        t('visit.copilot.likelyDifferentials'),
        t('visit.suggest.tests'),
        t('visit.quick.dosingForComorbidities'),
        t('visit.quick.checkInteractions'),
        t('visit.quick.cvRisk'),
        t('visit.quick.followUpForVisit')
    ];
const $375f8776645d5aee$export$74f6a832d246e098 = (t)=>[
        t('visit.duration.d3'),
        t('visit.duration.d5'),
        t('visit.duration.d7'),
        t('visit.duration.d10'),
        t('visit.duration.d14'),
        t('visit.duration.m1'),
        t('visit.duration.m2'),
        t('visit.duration.m3'),
        t('visit.duration.m6'),
        t('visit.duration.untilFurtherNotice')
    ];
const $375f8776645d5aee$export$e730a0734bbb1219 = ()=>(0, $eQiuG.RX_ROUTE_VALUES);
const $375f8776645d5aee$export$7be9a8bfe9895054 = (t)=>[
        t('visit.rx.instructionPresets.afterMeal'),
        t('visit.rx.instructionPresets.beforeMeal'),
        t('visit.rx.instructionPresets.withFood'),
        t('visit.rx.instructionPresets.emptyStomach'),
        t('visit.rx.instructionPresets.bedtime'),
        t('visit.rx.instructionPresets.asNeeded'),
        t('visit.rx.instructionPresets.finishCourse')
    ];
const $375f8776645d5aee$export$b9d67b8f1f51ac8d = `
.m-app{display:flex;flex-direction:column;height:100%;background:var(--bg);overflow:hidden;position:relative;font-family:var(--app-font);direction:rtl}
.m-topbar{display:flex;align-items:center;gap:8px;padding:8px 12px;background:var(--panel);border-bottom:1px solid var(--line)}
.m-icon-btn{width:36px;height:36px;border-radius:9px;display:grid;place-items:center;color:var(--ink-2);background:transparent;border:none;cursor:pointer}
.m-icon-btn:active{background:var(--line)}
.m-icon-btn svg{width:17px;height:17px}
.m-icon-btn.small{width:30px;height:30px}
.m-title{flex:1;min-width:0}
.m-title-1{font-weight:700;font-size:0.9375rem;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.m-title-2{display:flex;align-items:center;gap:6px;font-size:0.6875rem;color:var(--mute);margin-top:1px}
.m-dot{width:3px;height:3px;border-radius:50%;background:var(--mute-2)}
.m-rec{width:6px;height:6px;border-radius:50%;background:var(--danger);margin-inline-start:2px;animation:pulse 1.6s infinite}
.m-rec.off{background:var(--mute-2);animation:none}
.m-allergy{display:flex;align-items:center;gap:8px;padding:7px 12px;background:var(--danger-soft);border-bottom:1px solid oklch(0.85 0.08 25);font-size:0.71875rem}
.m-allergy svg{width:13px;height:13px;color:var(--danger);flex-shrink:0}
.m-allergy-chips{display:flex;gap:4px;overflow:auto;-webkit-overflow-scrolling:touch}
.m-allergy-pill{padding:2px 7px;border-radius:999px;background:#fff;border:1px solid oklch(0.82 0.08 25);color:var(--danger-ink);font-size:0.65625rem;font-weight:500;white-space:nowrap}
.m-vital-strip{display:flex;gap:8px;padding:10px 12px;overflow-x:auto;background:var(--panel);border-bottom:1px solid var(--line);scrollbar-width:none}
.m-vital-strip::-webkit-scrollbar{display:none}
.m-vital{flex-shrink:0;width:100px;padding:9px 11px;border-radius:10px;background:var(--panel-2);border:1px solid var(--line);text-align:start;cursor:pointer}
.m-vital.alert{background:var(--warn-soft);border-color:oklch(0.85 0.07 60)}
.m-vital-k{font-size:0.59375rem;color:var(--mute);text-transform:uppercase;letter-spacing:.05em;font-weight:600}
.m-vital-v{font-family:'JetBrains Mono',ui-monospace,monospace;font-weight:700;font-size:1rem;color:var(--ink);display:flex;align-items:baseline;gap:3px;margin:2px 0 4px}
.m-vital-u{font-size:0.5625rem;color:var(--mute);font-weight:500}
.m-vital-add{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:4px;border:1px dashed var(--line);background:transparent;color:var(--mute);font-size:0.6875rem;width:80px}
.m-vital-add svg{width:14px;height:14px}
.m-tabs{display:flex;gap:0;background:var(--panel);border-bottom:1px solid var(--line);padding:0 4px;position:sticky;top:0;z-index:5}
.m-tab{flex:1;padding:11px 6px;font-size:0.75rem;font-weight:500;color:var(--mute);border-bottom:2px solid transparent;margin-bottom:-1px;display:flex;align-items:center;justify-content:center;gap:5px;background:transparent;border-top:none;border-left:none;border-right:none;cursor:pointer;font-family:inherit}
.m-tab svg{width:13px;height:13px}
.m-tab.on{color:var(--ink);border-bottom-color:var(--ink);font-weight:600}
.m-tab-b{font-size:0.59375rem;background:var(--line);color:var(--ink-2);padding:1px 5px;border-radius:999px;font-weight:600}
.m-tab.on .m-tab-b{background:var(--accent-soft);color:var(--accent-ink)}
.m-content{flex:1;overflow-y:auto;padding:12px 12px 160px;background:var(--bg)}
.m-card-head{display:flex;align-items:center;gap:8px;margin-bottom:10px;flex-wrap:wrap}
.m-soap{background:var(--panel-2);border:1px solid var(--line);border-radius:10px;margin-bottom:8px;overflow:hidden}
.m-soap-head{display:flex;align-items:center;gap:10px;padding:11px 13px;width:100%;text-align:start;background:transparent;border:none;cursor:pointer;font-family:inherit}
.m-soap-letter{width:24px;height:24px;border-radius:6px;background:var(--accent-soft);color:var(--accent-ink);font-family:'JetBrains Mono',monospace;font-size:0.6875rem;font-weight:700;display:grid;place-items:center;flex-shrink:0}
.m-soap-name{flex:1;font-weight:600;font-size:0.84375rem}
.m-soap-chev{color:var(--mute);display:grid;place-items:center;transition:transform .15s}
.m-soap-chev svg{width:11px;height:11px;transform:rotate(90deg)}
.m-soap-chev.open svg{transform:rotate(-90deg)}
.m-soap-body{padding:0 13px 13px}
.m-soap-ta{width:100%;border:1px solid var(--line);border-radius:8px;padding:10px 12px;font-size:0.8125rem;line-height:1.75;resize:vertical;outline:none;font-family:inherit;color:var(--ink);background:#faf8f5;direction:rtl;box-sizing:border-box}
.m-soap-ta:focus{background:#fff;border-color:var(--accent)}
.m-block-btn{margin-top:6px;display:flex;align-items:center;justify-content:center;gap:6px;padding:11px;border-radius:10px;border:1px dashed var(--line);color:var(--mute);font-size:0.78125rem;width:100%;background:transparent;cursor:pointer;font-family:inherit}
.m-diff{background:var(--panel-2);border:1px solid var(--line);border-radius:10px;padding:11px 13px;margin-bottom:8px}
.m-diff.primary{background:linear-gradient(180deg,var(--accent-soft),var(--panel-2) 80%);border-color:var(--accent)}
.m-diff.rejected{opacity:.5}
.m-diff-top{display:flex;align-items:center;gap:8px;margin-bottom:3px}
.m-diff-title{flex:1;font-weight:600;font-size:0.8125rem;display:flex;align-items:center;gap:6px}
.m-diff-conf{font-size:0.75rem;color:var(--ink);font-weight:600;font-family:monospace}
.m-diff-code{font-size:0.65625rem;color:var(--mute);margin-bottom:6px;font-family:monospace}
.m-diff-bar{height:5px;background:var(--line);border-radius:3px;overflow:hidden;margin-bottom:8px}
.m-diff-fill{height:100%;background:var(--accent);border-radius:3px}
.m-diff-actions{display:flex;gap:6px}
.m-diff-btn{padding:7px 10px;border-radius:8px;font-size:0.75rem;font-weight:500;background:var(--panel);border:1px solid var(--line);color:var(--ink-2);display:inline-flex;align-items:center;justify-content:center;gap:5px;cursor:pointer;font-family:inherit}
.m-diff-btn.pin{flex:1}
.m-diff-btn.ok,.m-diff-btn.no{width:38px}
.m-diff-btn svg{width:12px;height:12px}
.m-diff-btn.pin.on{background:var(--accent);color:#fff;border-color:var(--accent)}
.m-diff-btn.ok.on{background:var(--ink);color:#fbfaf6;border-color:var(--ink)}
.m-diff-btn.no.on{background:var(--danger-soft);color:var(--danger-ink);border-color:transparent}
.m-rx{display:flex;gap:11px;background:var(--panel-2);border:1px solid var(--line);border-radius:10px;padding:11px 12px;margin-bottom:8px}
.m-rx-pill{width:32px;height:20px;border-radius:10px;background:linear-gradient(90deg,#e8a86a 0 50%,#fff 50% 100%);border:1px solid var(--line);flex-shrink:0;margin-top:2px}
.m-rx-info{flex:1;min-width:0}
.m-rx-name{font-weight:700;font-size:0.8125rem}
.m-rx-gen{font-size:0.65625rem;color:var(--mute);margin-bottom:5px}
.m-rx-meta{display:flex;gap:10px;font-size:0.71875rem;color:var(--ink-2);flex-wrap:wrap}
.m-rx-k{font-size:0.59375rem;color:var(--mute);text-transform:uppercase;letter-spacing:.05em;font-weight:600}
.m-ord{display:flex;align-items:center;gap:10px;padding:11px 12px;background:var(--panel-2);border:1px solid var(--line);border-radius:10px;margin-bottom:6px}
.m-ord-name{font-size:0.8125rem;font-weight:500}
.m-ord-meta{font-size:0.65625rem;color:var(--mute);margin-top:1px}
.m-empty{padding:24px;text-align:center;color:var(--mute-2);font-size:0.71875rem;background:var(--panel-2);border:1px dashed var(--line);border-radius:10px}
.m-aibar{position:absolute;left:12px;right:12px;bottom:64px;display:flex;align-items:center;gap:10px;padding:9px 11px 9px 9px;background:var(--ink);color:#fbfaf6;border-radius:14px;box-shadow:0 8px 24px rgba(28,29,26,0.18);z-index:10;cursor:pointer}
.m-aibar-dot{width:8px;height:8px;border-radius:50%;background:var(--good);box-shadow:0 0 0 3px rgba(127,205,158,.25);animation:pulse 1.6s infinite;flex-shrink:0}
.m-aibar-text{flex:1;min-width:0}
.m-aibar-l{font-size:0.65625rem;color:oklch(0.85 0.04 175);font-weight:600;margin-bottom:1px}
.m-aibar-s{font-size:0.75rem;font-weight:500;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.m-aibar-mic{width:34px;height:34px;border-radius:10px;background:var(--accent);color:#fff;display:grid;place-items:center;flex-shrink:0;border:none;cursor:pointer}
.m-aibar-mic svg{width:14px;height:14px}
.m-end-fab{position:absolute;bottom:8px;left:12px;right:12px;padding:13px;border-radius:12px;background:var(--danger);color:#fff;font-weight:600;font-size:0.875rem;z-index:9;box-shadow:0 6px 20px rgba(217,87,69,.3);border:none;cursor:pointer;font-family:inherit}
.m-sheet-backdrop{position:absolute;inset:0;background:rgba(28,29,26,.45);z-index:40;display:flex;align-items:flex-end;animation:fadeIn .2s ease}
@keyframes fadeIn{from{opacity:0}to{opacity:1}}
.m-sheet{width:100%;background:var(--panel-2);border-radius:18px 18px 0 0;max-height:80%;display:flex;flex-direction:column;box-shadow:0 -8px 24px rgba(0,0,0,.15);animation:slideUp .25s cubic-bezier(.2,.8,.2,1)}
@keyframes slideUp{from{transform:translateY(100%)}to{transform:translateY(0)}}
.m-sheet-grab{width:42px;height:4px;border-radius:2px;background:var(--line);margin:8px auto 0}
.m-sheet-head{display:flex;align-items:center;gap:8px;padding:8px 12px 6px}
.m-sheet-title{flex:1;font-weight:700;font-size:0.9375rem}
.m-sheet-body{flex:1;overflow-y:auto;padding:8px 14px 20px}
.m-aitabs{display:flex;gap:6px;padding:4px;background:var(--bg);border-radius:10px;margin-bottom:12px}
.m-aitab{flex:1;padding:8px;font-size:0.78125rem;color:var(--mute);font-weight:500;border-radius:7px;border:none;cursor:pointer;font-family:inherit;background:transparent}
.m-aitab.on{background:var(--panel-2);color:var(--ink);font-weight:600;box-shadow:0 1px 2px rgba(28,29,26,.06)}
.m-aitab-b{margin-inline-start:4px;font-size:0.625rem;padding:1px 5px;border-radius:999px;background:var(--line);color:var(--ink-2);font-weight:600}
.m-aitab.on .m-aitab-b{background:var(--accent-soft);color:var(--accent-ink)}
.m-transcript{background:var(--bg);border:1px solid var(--line);border-radius:10px;padding:10px 12px;margin-bottom:12px;font-size:0.75rem;line-height:1.7}
.m-transcript-head{display:flex;align-items:center;gap:8px;padding-bottom:8px;border-bottom:1px solid var(--line);margin-bottom:8px}
.m-composer{margin-top:12px;display:flex;align-items:center;gap:8px;padding:8px 12px;background:var(--bg);border:1px solid var(--line);border-radius:12px;position:sticky;bottom:0}
.m-composer input{flex:1;border:0;background:transparent;outline:none;font-size:0.8125rem;font-family:inherit;direction:rtl}
.m-composer-send{width:32px;height:32px;border-radius:10px;background:var(--ink);color:#fbfaf6;display:grid;place-items:center;border:none;cursor:pointer}
.m-composer-send svg{width:13px;height:13px}
.sugg{background:var(--panel-2);border:1px solid var(--line);border-radius:var(--radius);padding:12px 13px;margin-bottom:10px}
.sugg.priority.warn{border-color:oklch(0.85 0.06 60);background:linear-gradient(180deg,var(--warn-soft),var(--panel-2) 60%)}
.sugg-head{display:flex;align-items:center;gap:8px;margin-bottom:6px}
.sugg-kind{font-size:0.625rem;font-weight:600;letter-spacing:.04em;padding:2px 7px;border-radius:4px;background:var(--accent-soft);color:var(--accent-ink);text-transform:uppercase}
.sugg-kind.warn{background:var(--warn-soft);color:var(--warn-ink)}
.sugg-kind.soap{background:oklch(0.95 0.04 290);color:oklch(0.38 0.14 290)}
.sugg-conf{margin-inline-start:auto;font-size:0.6875rem;color:var(--mute);font-family:monospace}
.sugg-title{font-weight:600;font-size:0.8125rem;color:var(--ink);margin-bottom:4px;line-height:1.4}
.sugg-body{font-size:0.78125rem;color:var(--ink-2);line-height:1.65}
.sugg-evidence{margin-top:8px;padding:7px 9px;border-radius:6px;background:rgba(0,0,0,.025);border:1px dashed var(--line);font-size:0.71875rem;color:var(--mute);line-height:1.55}
.sugg-evidence b{color:var(--ink-2);font-weight:600}
.evidence-citations{display:flex;flex-wrap:wrap;gap:5px;margin-top:6px}
.citation-badge{display:inline-flex;align-items:center;gap:3px;padding:2px 7px;border-radius:999px;background:var(--accent-soft);color:var(--accent-ink);font-size:0.65625rem;font-weight:500;text-decoration:none;border:1px solid rgba(0,0,0,.06);cursor:pointer}
.citation-badge:hover{background:var(--accent-ink);color:#fff}
.warning-source-tag{display:inline-flex;align-items:center;gap:3px;padding:1px 6px;border-radius:4px;font-size:0.59375rem;font-weight:600;letter-spacing:.03em;margin-inline-start:6px;vertical-align:middle}
.warning-source-tag.rule_engine_static{background:#fff3cd;color:#7d5a00}
.warning-source-tag.rule_engine_rxnorm{background:#d1ecf1;color:#0c5460}
.warning-source-tag.rule_engine_contraindication{background:#f8d7da;color:#721c24}
.warning-source-tag.rule_engine_allergy{background:#f5c6cb;color:#721c24}
.warning-source-tag.rule_engine_openfda{background:#e2d9f3;color:#432874}
.warning-source-tag.llm{background:var(--panel-2);color:var(--mute)}
.conf-bar{display:flex;align-items:center;gap:6px;margin-top:5px}
.conf-bar-track{flex:1;height:5px;border-radius:3px;background:var(--line);overflow:hidden}
.conf-bar-fill{height:100%;border-radius:3px;transition:width .3s}
.conf-bar-label{font-size:0.625rem;color:var(--mute);min-width:28px;text-align:start}
.sugg-actions{display:flex;gap:6px;margin-top:10px;padding-top:10px;border-top:1px solid var(--line)}
.sugg-btn{flex:1;padding:6px 10px;border-radius:6px;font-size:0.75rem;font-weight:500;background:transparent;border:1px solid var(--line);color:var(--ink-2);display:inline-flex;align-items:center;justify-content:center;gap:5px;cursor:pointer;font-family:inherit}
.sugg-btn.accept{background:var(--ink);color:#fbfaf6;border-color:var(--ink)}
.sugg-btn svg{width:12px;height:12px}
.ts-line{margin-bottom:6px;display:flex;gap:8px;align-items:flex-start}
.ts-spk{font-size:0.59375rem;font-weight:700;text-transform:uppercase;letter-spacing:.05em;padding:1px 6px;border-radius:3px;height:fit-content;line-height:1.6;flex-shrink:0;margin-top:2px}
.ts-spk.dr{background:var(--accent-soft);color:var(--accent-ink)}
.ts-spk.pt{background:#f0ebdc;color:var(--ink-2)}
.ts-text{color:var(--ink-2);flex:1;min-width:0}
.rec-dot{width:8px;height:8px;border-radius:50%;background:var(--danger);animation:pulse 1.6s infinite}
.section-h{display:flex;align-items:center;gap:8px;margin:16px 0 10px;color:var(--mute);font-size:0.65625rem;text-transform:uppercase;letter-spacing:.06em;font-weight:600}
.section-h::after{content:'';flex:1;height:1px;background:var(--line)}
.demo-grid{display:grid;grid-template-columns:1fr 1fr;gap:8px 14px}
.demo-item .k{font-size:0.65625rem;color:var(--mute-2);text-transform:uppercase;letter-spacing:.05em;font-weight:600;margin-bottom:1px}
.demo-item .v{font-size:0.8125rem;color:var(--ink);font-weight:500}
.med-row{display:flex;align-items:center;gap:10px;padding:9px 0;border-top:1px solid var(--line-2)}
.med-row:first-child{border-top:0;padding-top:0}
.med-pill{width:30px;height:18px;border-radius:9px;background:linear-gradient(90deg,#e8a86a 0 50%,#fff 50% 100%);border:1px solid var(--line);flex-shrink:0}
.med-info{flex:1;min-width:0}
.med-info .n{font-size:0.78125rem;font-weight:600}
.med-info .d{font-size:0.65625rem;color:var(--mute);font-family:monospace}
.cond-list{display:flex;flex-wrap:wrap;gap:5px}
.cond-chip{font-size:0.71875rem;padding:4px 10px;border-radius:6px;background:var(--panel-2);border:1px solid var(--line);color:var(--ink-2);display:inline-flex;align-items:center;gap:6px}
.history-list{display:flex;flex-direction:column;gap:10px}
.hist-item{display:grid;grid-template-columns:auto 1fr;gap:10px}
.hist-marker{width:8px;height:8px;border-radius:50%;background:var(--accent);margin-top:7px;flex-shrink:0}
.hist-title{font-size:0.78125rem;font-weight:600;color:var(--ink)}
.hist-meta{font-size:0.6875rem;color:var(--mute);margin-top:1px}
.hist-desc{font-size:0.75rem;color:var(--ink-2);line-height:1.55;margin-top:3px}
.prompt-btn{display:block;width:100%;text-align:start;padding:9px 11px;margin-bottom:5px;background:var(--panel-2);border:1px solid var(--line);border-radius:8px;font-size:0.75rem;color:var(--ink-2);cursor:pointer;font-family:inherit}
.iconbtn{width:28px;height:28px;border-radius:6px;display:grid;place-items:center;color:var(--mute);background:transparent;border:0;cursor:pointer;flex-shrink:0}
.iconbtn:hover{background:var(--line-2);color:var(--ink)}
.iconbtn.danger:hover{background:var(--danger-soft);color:var(--danger-ink)}
.iconbtn svg{width:14px;height:14px}
.med-card{display:flex;align-items:center;gap:10px;padding:11px 12px;background:var(--panel);border:1px solid var(--line-2);border-radius:10px;margin-bottom:7px}
.med-card:last-child{margin-bottom:0}
.med-card-info{flex:1;min-width:0;text-align:start}
.med-card-name{font-size:0.84375rem;font-weight:700;color:var(--ink)}
.med-card-dose{font-size:0.71875rem;color:var(--mute);margin-top:1px}
.med-warn-badge{display:inline-flex;align-items:center;gap:4px;padding:2px 7px;border-radius:999px;background:var(--warn-soft);color:var(--warn-ink);font-size:0.65625rem;font-weight:600;margin-top:4px}
.med-warn-badge svg{width:10px;height:10px}
.med-toggle-wrap{position:relative;cursor:pointer;flex-shrink:0}
.med-toggle-wrap input{position:absolute;opacity:0;width:0;height:0}
.med-track{width:36px;height:20px;border-radius:999px;background:var(--line-2);transition:background .2s;display:flex;align-items:center;padding:2px}
.med-toggle-wrap input:checked ~ .med-track{background:var(--good)}
.med-thumb{width:16px;height:16px;border-radius:50%;background:#fff;box-shadow:0 1px 3px rgba(0,0,0,.2);transition:transform .2s;flex-shrink:0}
.med-toggle-wrap input:checked ~ .med-track .med-thumb{transform:translateX(16px)}
.med-undo-banner{display:flex;align-items:center;justify-content:space-between;padding:9px 12px;background:oklch(0.95 0.06 75);border:1px solid oklch(0.85 0.1 75);border-radius:10px;margin-bottom:8px;gap:8px;animation:fadeUp .2s ease}
.med-undo-text{font-size:0.75rem;color:oklch(0.38 0.1 60);flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
.med-undo-btn{font-size:0.75rem;font-weight:700;color:oklch(0.38 0.1 60);background:transparent;border:none;cursor:pointer;white-space:nowrap;padding:0;font-family:inherit;flex-shrink:0}
.med-undo-btn:hover{text-decoration:underline}
.rx-row{display:grid;grid-template-columns:minmax(0,2fr) 90px 110px 100px auto;align-items:center;gap:12px;padding:11px 0;border-top:1px solid var(--line-2)}
.rx-row:first-child,.rx-row.header{border-top:0;padding-top:0}
.rx-row.header{padding-bottom:6px;border-bottom:1px solid var(--line-2);margin-bottom:6px}
.rx-name{font-weight:600;font-size:0.8125rem;display:flex;align-items:center;gap:8px;flex-wrap:wrap}
.rx-gen{font-size:0.6875rem;color:var(--mute);margin-top:1px}
.rx-cell{font-size:0.75rem;color:var(--ink-2);font-family:monospace}
.rx-cell.label{font-size:0.65625rem;color:var(--mute-2);text-transform:uppercase;letter-spacing:.06em;font-family:inherit;font-weight:600}
.rx-warn{display:inline-flex;align-items:center;gap:5px;padding:3px 8px;border-radius:999px;background:var(--warn-soft);color:var(--warn-ink);font-size:0.65625rem;font-weight:600}
.rx-warn svg{width:10px;height:10px}
.rx-add{margin-top:10px;display:flex;align-items:center;gap:8px;padding:11px 13px;border-radius:8px;border:1px dashed var(--line);color:var(--mute);font-size:0.78125rem;width:100%;justify-content:center;transition:all .12s;background:transparent;cursor:pointer;font-family:inherit}
.rx-add:hover{border-color:var(--accent);color:var(--accent-ink);background:var(--accent-soft)}
.v-micbtn{display:inline-flex;align-items:center;gap:3px;font-size:0.625rem;font-weight:600;color:var(--mute);background:var(--panel-2);border:1px solid var(--line);border-radius:20px;padding:2px 8px;cursor:pointer;font-family:inherit;transition:.13s;flex-shrink:0}
.v-micbtn:hover{color:var(--danger-ink);background:var(--danger-soft);border-color:oklch(0.85 0.08 25)}
.v-micbtn.active{color:#fff;background:var(--danger);border-color:var(--danger)}
[data-soap-key]:empty:before{content:attr(data-placeholder);color:var(--mute);pointer-events:none}
`;
const $375f8776645d5aee$export$5d26717df14e8026 = `
.v-voice-scrim{
  --bg:${(0, $jTCZr.CT).bg};--panel:${(0, $jTCZr.CT).surface};--panel-2:${(0, $jTCZr.CT).surface};--line:${(0, $jTCZr.CT).border};
  --line-2:${(0, $jTCZr.CT).border2};--ink:${(0, $jTCZr.CT).ink};--ink-2:${(0, $jTCZr.CT).ink2};--mute:${(0, $jTCZr.CT).mute};
  --mute-2:${(0, $jTCZr.CT).mute2};--accent:${(0, $jTCZr.CT).accent};--accent-soft:${(0, $jTCZr.CT).accentSoft};
  --accent-ink:${(0, $jTCZr.CT).accentInk};--danger:${(0, $jTCZr.CT).danger};--danger-soft:${(0, $jTCZr.CT).dangerSoft};
}
.v-voice-scrim{position:fixed;inset:0;background:rgba(28,29,26,.5);backdrop-filter:blur(3px);z-index:400;display:grid;place-items:center;padding:20px;animation:rgFade .2s ease}
.v-fvoice{position:relative;width:440px;max-width:94vw;background:var(--panel);border-radius:20px;box-shadow:0 30px 80px rgba(28,29,26,.35);padding:30px 26px 22px;text-align:center;animation:rgPop .24s ease;border:1px solid var(--line)}
.v-fvoice-close{position:absolute;top:14px;inset-inline-end:14px;width:30px;height:30px;border-radius:8px;display:grid;place-items:center;color:var(--mute);border:none;background:none;cursor:pointer}
.v-fvoice-close:hover{background:var(--line-2)}
.v-mic-wrap{position:relative;width:80px;height:80px;margin:0 auto 14px;display:grid;place-items:center}
.v-mic{position:relative;z-index:2;width:60px;height:60px;border-radius:50%;display:grid;place-items:center;color:#fff;background:var(--danger);box-shadow:0 8px 22px rgba(217,87,69,.35)}
.v-mic-ring{position:absolute;inset:0;border-radius:50%;border:2px solid var(--danger);opacity:0}
.v-mic-ring.r1{animation:rgRing 2s ease-out infinite}
.v-mic-ring.r2{animation:rgRing 2s ease-out .66s infinite}
.v-wave{display:flex;align-items:center;justify-content:center;gap:4px;height:36px;margin:10px 0 8px}
.v-wave span{width:4px;height:12px;border-radius:2px;background:var(--accent);animation:rgWave .9s ease-in-out infinite}
.v-transcript{margin:4px auto 0;max-width:380px;font-size:0.8125rem;line-height:1.9;color:var(--ink);min-height:44px;text-align:start;background:var(--bg);border:1px solid var(--line);border-radius:10px;padding:8px 12px}
.v-confirm-btn{display:inline-flex;align-items:center;gap:6px;margin-top:14px;padding:9px 20px;border-radius:10px;background:var(--ink);color:#faf7f4;font-weight:600;font-size:0.8125rem;border:none;cursor:pointer;font-family:inherit}
.v-confirm-btn:hover{background:var(--ink-2)}
.v-confirm-btn:disabled{opacity:0.45;cursor:not-allowed}
.v-wavebars{display:flex;align-items:center;justify-content:center;gap:3px;height:32px;margin:8px 0}
.v-wavebars span{width:3px;border-radius:2px;transition:.15s}
`;
const $375f8776645d5aee$export$ee258ff23bc0049f = {
    high: (0, $jTCZr.C).red,
    medium: (0, $jTCZr.C).amber,
    low: (0, $jTCZr.C).green
};
const $375f8776645d5aee$export$236de8c7b98b7ff0 = (t)=>({
        high: t('visit.severity.high'),
        medium: t('visit.severity.medium'),
        low: t('visit.severity.low')
    });
const $375f8776645d5aee$export$60d82a5be99a0a11 = {
    high: 3,
    medium: 2,
    low: 1
};
const $375f8776645d5aee$export$a20f1db6dc818677 = (s)=>{
    const v = typeof s === 'string' ? s.trim().toLowerCase() : '';
    return Object.prototype.hasOwnProperty.call($375f8776645d5aee$export$60d82a5be99a0a11, v) ? v : 'medium';
};
const $375f8776645d5aee$export$2ba0e4a723757c09 = (warnings = [])=>{
    const out = {
        high: [],
        medium: [],
        low: []
    };
    warnings.forEach((w)=>out[$375f8776645d5aee$export$a20f1db6dc818677(w?.severity)].push(w));
    return out;
};
const $375f8776645d5aee$export$9ad745a931ba51ed = (warnings = [])=>{
    let best = null;
    warnings.forEach((w)=>{
        const s = $375f8776645d5aee$export$a20f1db6dc818677(w?.severity);
        if (!best || $375f8776645d5aee$export$60d82a5be99a0a11[s] > $375f8776645d5aee$export$60d82a5be99a0a11[best]) best = s;
    });
    return best;
};
const $375f8776645d5aee$export$73a34cab37d00ce4 = (rxItems = [], conditionsKey = '')=>`${rxItems.map((r)=>r?.drug?.id).join('|')}#${conditionsKey}`;
const $375f8776645d5aee$export$ead65992cf57cabf = (patient, acceptedDiagnoses = [])=>({
        conditions: [
            ...(patient?.clinicalConditions || []).map((c)=>c?.display),
            ...acceptedDiagnoses || [],
            ...$375f8776645d5aee$export$5176433c16ff5a4(patient?.clinicalObservations)
        ].filter(Boolean),
        allergies: (patient?.clinicalAllergies || []).map((a)=>a?.allergen).filter(Boolean)
    });
const $375f8776645d5aee$export$1e5ddc066f5dd4da = (rxItems, patient, acceptedDiagnoses = [])=>{
    const count = (rxItems || []).length;
    if (!patient?.id || count === 0) return false;
    if (count >= 2) return true;
    const { conditions: conditions, allergies: allergies } = $375f8776645d5aee$export$ead65992cf57cabf(patient, acceptedDiagnoses);
    return conditions.length > 0 || allergies.length > 0;
};
// ── Icon set — lucide-react (§1.1). `mk` preserves the legacy `<I.x width={n}
// height={n} />` call-site API by mapping width/height onto lucide's `size`, so
// the ~30 icon references across Visit.web.jsx keep working unchanged. ───────────
const $375f8776645d5aee$var$mk = (Lucide)=>{
    const Wrapped = ({ width: width, height: height, size: size, strokeWidth: strokeWidth, ...p })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Lucide, {
            size: size ?? width ?? height ?? 16,
            strokeWidth: strokeWidth ?? 1.75,
            "aria-hidden": true,
            ...p
        });
    return Wrapped;
};
const $375f8776645d5aee$export$9bb611d729802a56 = {
    dash: $375f8776645d5aee$var$mk((0, $cAg7Z.default)),
    users: $375f8776645d5aee$var$mk((0, $6imzq.default)),
    cal: $375f8776645d5aee$var$mk((0, $dDvfT.default)),
    chart: $375f8776645d5aee$var$mk((0, $5JVBe.default)),
    cog: $375f8776645d5aee$var$mk((0, $53qqr.default)),
    doc: $375f8776645d5aee$var$mk((0, $3FyOw.default)),
    sparkle: $375f8776645d5aee$var$mk((0, $chm1L.default)),
    ai: $375f8776645d5aee$var$mk((0, $chm1L.default)),
    stop: $375f8776645d5aee$var$mk((0, $7udIf.default)),
    mic: $375f8776645d5aee$var$mk((0, $hSPBf.default)),
    send: $375f8776645d5aee$var$mk((0, $6OGKD.default)),
    check: $375f8776645d5aee$var$mk((0, $huNwV.default)),
    x: $375f8776645d5aee$var$mk((0, $6TdpC.default)),
    plus: $375f8776645d5aee$var$mk((0, $8g4t5.default)),
    edit: $375f8776645d5aee$var$mk((0, $aGlWN.default)),
    bolt: $375f8776645d5aee$var$mk((0, $iS1Sb.default)),
    trend: $375f8776645d5aee$var$mk((0, $4KmG0.default)),
    flask: $375f8776645d5aee$var$mk((0, $4CVxl.default)),
    pill: $375f8776645d5aee$var$mk((0, $aVx4q.default)),
    arrow: $375f8776645d5aee$var$mk((0, $kzPvP.default)),
    alert: $375f8776645d5aee$var$mk((0, $QG9Z3.default)),
    history: $375f8776645d5aee$var$mk((0, $i5dmF.default)),
    notes: $375f8776645d5aee$var$mk((0, $ggYuf.default)),
    link: $375f8776645d5aee$var$mk((0, $2UQ3h.default)),
    ref: $375f8776645d5aee$var$mk((0, $d8YVq.default)),
    more: $375f8776645d5aee$var$mk((0, $022jy.default)),
    trash: $375f8776645d5aee$var$mk((0, $lUsTt.default)),
    search: $375f8776645d5aee$var$mk((0, $e5Ore.default)),
    back: $375f8776645d5aee$var$mk((0, $gKFEi.default)),
    close: $375f8776645d5aee$var$mk((0, $6TdpC.default)),
    save: $375f8776645d5aee$var$mk((0, $aWpbN.default)),
    reload: $375f8776645d5aee$var$mk((0, $bF8pu.default)),
    scan: $375f8776645d5aee$var$mk((0, $03cDl.default)),
    steth: $375f8776645d5aee$var$mk((0, $fX0JO.default)),
    clock: $375f8776645d5aee$var$mk((0, $kMJsW.default)),
    clinic: $375f8776645d5aee$var$mk((0, $jis86.default)),
    upload: $375f8776645d5aee$var$mk((0, $jdP8o.default)),
    shield: $375f8776645d5aee$var$mk((0, $bo0GS.default)),
    info: $375f8776645d5aee$var$mk((0, $97xXr.default))
};
const $375f8776645d5aee$export$c63347898143db2f = ({ data: data, alert: alert })=>{
    const w = 32, h = 10;
    const max = Math.max(...data, 1);
    const min = Math.min(...data, 0);
    const pts = data.map((d, i)=>{
        const x = i / (data.length - 1) * w;
        const y = h - (d - min) / (max - min || 1) * h;
        return `${x.toFixed(1)},${y.toFixed(1)}`;
    }).join(' ');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: `0 0 ${w} ${h}`,
        width: w,
        height: h
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polyline", {
        points: pts,
        fill: "none",
        stroke: alert ? (0, $jTCZr.C).red : (0, $jTCZr.C).teal,
        strokeWidth: "1.2"
    }));
};
const $375f8776645d5aee$export$b04be29aa201d4f5 = ({ children: children, style: style })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.625rem',
            fontWeight: 700,
            color: (0, $jTCZr.C).textMuted,
            letterSpacing: '0.8px',
            textTransform: 'uppercase',
            marginBottom: 6,
            ...style
        }
    }, children);
const $375f8776645d5aee$export$60332b2344f7fe41 = ({ children: children, style: style })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: (0, $jTCZr.C).card,
            borderRadius: 12,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            ...style
        }
    }, children);
const $375f8776645d5aee$export$37f54d0b7407611f = ({ children: children, onClick: onClick, color: color, disabled: disabled, style: style, size: size = 'md' })=>{
    const pad = size === 'sm' ? '5px 12px' : size === 'lg' ? '11px 24px' : '8px 18px';
    const fs = size === 'sm' ? '0.75rem' : size === 'lg' ? '0.9375rem' : '0.8125rem';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: onClick,
        disabled: disabled,
        style: {
            background: color || (0, $jTCZr.C).navy,
            color: '#fff',
            border: 'none',
            borderRadius: 8,
            padding: pad,
            fontSize: fs,
            fontWeight: 600,
            cursor: disabled ? 'not-allowed' : 'pointer',
            opacity: disabled ? .55 : 1,
            transition: 'all .15s',
            fontFamily: 'inherit',
            ...style
        }
    }, children);
};
const $375f8776645d5aee$export$3288d34c523a1192 = ({ children: children, color: color, bg: bg })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            background: bg || (0, $jTCZr.C).tealLight,
            color: color || (0, $jTCZr.C).teal,
            fontSize: '0.6875rem',
            fontWeight: 600,
            padding: '2px 8px',
            borderRadius: 20
        }
    }, children);
const $375f8776645d5aee$export$7f7cbe89f1eacd2 = ({ size: size = 16 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: size,
            height: size,
            border: '2px solid rgba(255,255,255,.3)',
            borderTopColor: '#fff',
            borderRadius: '50%',
            animation: 'spin .7s linear infinite',
            display: 'inline-block'
        }
    });
const $375f8776645d5aee$export$68595c7f7403ce8d = 30;
const $375f8776645d5aee$export$e72eedeb22c02c24 = 2;
// Pages survive the component. The Rx panel is `{workTab === 'rx' && …}`, so
// glancing at «دستورات» unmounts the picker; without this, coming back re-runs
// a fetch the doctor already waited for. Bounded, because it is a session-long
// module global rather than a per-request cache.
const $375f8776645d5aee$var$DRUG_CACHE_LIMIT = 60;
const $375f8776645d5aee$var$drugCache = new Map();
const $375f8776645d5aee$var$cacheGet = (key)=>{
    const hit = $375f8776645d5aee$var$drugCache.get(key);
    if (!hit) return null;
    $375f8776645d5aee$var$drugCache.delete(key); // re-insert: Map iterates in insertion order, so
    $375f8776645d5aee$var$drugCache.set(key, hit); // the oldest key is the first one evicted.
    return hit;
};
const $375f8776645d5aee$var$cachePut = (key, value)=>{
    $375f8776645d5aee$var$drugCache.set(key, value);
    if ($375f8776645d5aee$var$drugCache.size > $375f8776645d5aee$var$DRUG_CACHE_LIMIT) $375f8776645d5aee$var$drugCache.delete($375f8776645d5aee$var$drugCache.keys().next().value);
};
const $375f8776645d5aee$export$2d42b44329a671d = ()=>$375f8776645d5aee$var$drugCache.clear();
// Asked for `taminListed`, and without it of a BFF that predates the field.
const $375f8776645d5aee$var$askDrugs = (0, $c9qmv.askWithoutTaminWhenRefused)((0, $eVM84.bffQuery));
async function $375f8776645d5aee$export$66192a3e729ccb0d({ query: query = '', category: category = '', offset: offset = 0 } = {}) {
    const q = query.trim();
    if (q && q.length < $375f8776645d5aee$export$e72eedeb22c02c24) return {
        drugs: [],
        total: 0
    };
    const key = `${q}\u0000${category}\u0000${offset}`;
    const hit = $375f8776645d5aee$var$cacheGet(key);
    if (hit) return hit;
    const data = await $375f8776645d5aee$var$askDrugs($375f8776645d5aee$export$e94eea18383a4188, {
        query: q || null,
        category: category || null,
        limit: $375f8776645d5aee$export$68595c7f7403ce8d,
        offset: offset
    });
    const page = {
        drugs: data.listDrugs?.drugs || [],
        total: data.listDrugs?.total || 0
    };
    $375f8776645d5aee$var$cachePut(key, page);
    return page;
}
async function $375f8776645d5aee$export$9b2f95caa9aaf04d(limit = 12) {
    const data = await $375f8776645d5aee$var$askDrugs($375f8776645d5aee$export$64bb5ba76d2f107b, {
        limit: limit
    });
    return (data.myFrequentDrugs || []).filter((f)=>f?.drug?.id || f?.search);
}
const $375f8776645d5aee$export$8612601bbd913c0b = 100;
const $375f8776645d5aee$export$c69c4ad931cc4390 = ()=>({
        known: new Map(),
        pending: new Map(),
        off: false
    });
// Asked as is, never through the taminListed fallback: a BFF that knows
// `myLastDrugSigs` knows `taminListed` (older), and one that refuses the query
// must not switch the drug LIST over to the question without `taminListed`.
const $375f8776645d5aee$var$askLastSigs = (q, vars)=>(0, $eVM84.bffQuery)(q, vars);
async function $375f8776645d5aee$export$ccc209bdcc9e4ec4(ids, cache = $375f8776645d5aee$export$c69c4ad931cc4390()) {
    const wanted = [
        ...new Set((ids || []).map((id)=>String(id ?? '').trim()).filter(Boolean))
    ];
    const fresh = cache.off ? [] : wanted.filter((id)=>!cache.known.has(id) && !cache.pending.has(id));
    for(let i = 0; i < fresh.length; i += $375f8776645d5aee$export$8612601bbd913c0b){
        const chunk = fresh.slice(i, i + $375f8776645d5aee$export$8612601bbd913c0b);
        const asked = Promise.resolve().then(()=>$375f8776645d5aee$var$askLastSigs($375f8776645d5aee$export$8f8d9d75fce10d3d, {
                drugIds: chunk
            })).then((data)=>{
            const byId = new Map();
            for (const e of data?.myLastDrugSigs || [])if (e?.drug?.id) byId.set(String(e.drug.id), e);
            chunk.forEach((id)=>cache.known.set(id, byId.get(id) || null));
        }).catch((err)=>{
            if ((0, $c9qmv.schemaGap)(err)) cache.off = true;
            console.warn('[rx] myLastDrugSigs failed:', err?.message);
        }).finally(()=>chunk.forEach((id)=>{
                if (cache.pending.get(id) === asked) cache.pending.delete(id);
            }));
        chunk.forEach((id)=>cache.pending.set(id, asked));
    }
    await Promise.all([
        ...new Set(wanted.map((id)=>cache.pending.get(id)).filter(Boolean))
    ]);
    return wanted.map((id)=>cache.known.get(id)).filter(Boolean);
}
async function $375f8776645d5aee$export$668a72b79cec9ed7(ids) {
    const wanted = [
        ...new Set((ids || []).map((id)=>String(id || '').trim()).filter(Boolean))
    ];
    if (!wanted.length) return [];
    const data = await $375f8776645d5aee$var$askDrugs($375f8776645d5aee$export$b3499ea44c0870d9, {
        ids: wanted,
        limit: wanted.length
    });
    return (data?.listDrugs?.drugs || []).filter((d)=>wanted.includes(d?.id));
}
// A name as the drug list matches it: one letterform for ي/ك, digits as ASCII,
// no spaces or ZWNJ («آموکسی‌سیلین» and «آموکسی سیلین» are one name), no case.
const $375f8776645d5aee$var$drugNameKey = (s)=>String(s ?? '').replace(/[۰-۹]/g, (d)=>String(d.charCodeAt(0) - 0x06f0)).replace(/[٠-٩]/g, (d)=>String(d.charCodeAt(0) - 0x0660)).replace(/ي/g, "\u06CC").replace(/ك/g, "\u06A9").replace(/[\s\u200c]+/g, '').toLowerCase();
function $375f8776645d5aee$export$efbb2ae4be65bc0a(drugs, ...names) {
    const keys = new Set(names.map($375f8776645d5aee$var$drugNameKey).filter(Boolean));
    if (!keys.size) return null;
    const hits = new Map();
    for (const d of drugs || [])if (d?.id && (keys.has($375f8776645d5aee$var$drugNameKey(d.name)) || keys.has($375f8776645d5aee$var$drugNameKey(d.genericName)))) hits.set(d.id, d);
    return hits.size === 1 ? [
        ...hits.values()
    ][0] : null;
}
async function $375f8776645d5aee$export$3f253215194ac0f3(name) {
    const q = String(name || '').trim();
    if (q.length < $375f8776645d5aee$export$e72eedeb22c02c24) return null;
    const { drugs: drugs, total: total } = await $375f8776645d5aee$export$66192a3e729ccb0d({
        query: q
    });
    return $375f8776645d5aee$export$efbb2ae4be65bc0a(drugs, q) || (total === 1 && drugs.length === 1 ? drugs[0] : null);
}
async function $375f8776645d5aee$export$dcced24b144b6c10(src) {
    const own = {
        name: src.name,
        genericName: src.genericName || '',
        category: '',
        commonDosages: src.dosage ? [
            src.dosage
        ] : [],
        commonFrequencies: src.frequency ? [
            src.frequency
        ] : []
    };
    if (src.drugId) {
        // The generic group the line was prescribed as (PM-0508) stays with the
        // product the line named, and with no other: a refill that drops it sends
        // the insurer no «ژنریک» note.
        const erxGroup = (0, $85jFj.erxGroupOf)(src.erxGroup);
        const withGroup = (drug)=>erxGroup && drug.id === src.drugId ? {
                ...drug,
                erxGroup: erxGroup
            } : drug;
        try {
            const [hit] = await $375f8776645d5aee$export$668a72b79cec9ed7([
                src.drugId
            ]);
            if (hit) return withGroup(hit);
        } catch (e) {
            console.warn('[rx] refill lookup by id failed:', e.message);
        }
        return withGroup({
            id: src.drugId,
            ...own
        });
    }
    try {
        const { drugs: drugs } = await $375f8776645d5aee$export$66192a3e729ccb0d({
            query: src.name
        });
        const match = $375f8776645d5aee$export$efbb2ae4be65bc0a(drugs, src.name, src.genericName);
        if (match) return match;
    } catch (e) {
        // A lookup failure is a refill that keeps the doctor's own text, not a
        // refill that fails.
        console.warn('[rx] refill lookup failed:', e.message);
    }
    return {
        id: `refill-med-${src.name}`,
        ...own
    };
}
const $375f8776645d5aee$export$a6616cb9d478340f = (value, readsPersianData, t)=>readsPersianData ? value : (0, $eQiuG.doseLabel)(value, t) || (0, $lnUwI.dosageEn)(value);
function $375f8776645d5aee$export$cbaf757fd313ab43({ drug: drug, insurer: insurer, both: both = false, listed: given, testid: testid, size: size = 9.5, hint: hint }) {
    const { t: t } = (0, $LNQP4.default)();
    const listed = given !== undefined ? given : (0, $eQiuG.inInsurerList)(drug, insurer);
    if (listed === null || listed && !both) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": testid || `visit-rx-coverage-${drug.id}`,
        "data-listed": listed ? 'true' : 'false',
        title: listed ? undefined : hint || t('visit.rx.coverage.outTaminHint'),
        style: {
            fontSize: typeof size === 'number' ? `${size / 16}rem` : size,
            padding: '1px 6px',
            borderRadius: 4,
            fontWeight: 700,
            whiteSpace: 'nowrap',
            flexShrink: 0,
            background: listed ? (0, $jTCZr.CT).goodSoft : (0, $jTCZr.CT).warnSoft,
            color: listed ? (0, $jTCZr.CT).goodInk : (0, $jTCZr.CT).warnInk
        }
    }, listed ? t('visit.rx.coverage.inTamin') : t('visit.rx.coverage.outTamin'));
}
function $375f8776645d5aee$export$e901e237ac90bbca({ drug: drug, testid: testid, size: size = 10.5 }) {
    const { t: t } = (0, $LNQP4.default)();
    const name = (0, $85jFj.erxGroupOf)(drug?.erxGroup)?.name;
    if (!name) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": testid || `visit-rx-generic-${drug.id}`,
        title: t('visit.rx.genericGroup.hint', {
            name: name
        }),
        style: {
            fontSize: typeof size === 'number' ? `${size / 16}rem` : size,
            padding: '1px 6px',
            borderRadius: 4,
            fontWeight: 700,
            whiteSpace: 'nowrap',
            flexShrink: 0,
            background: (0, $jTCZr.CT).surface2,
            color: (0, $jTCZr.CT).ink2
        }
    }, t('visit.rx.genericGroup.badge'));
}
// «در فهرست تأمین» for an ORDER (K1, 2026-10-07). The catalogue says it per row
// (taminListed — the BFF applies the e-prescription send's own rule); like a
// drug's, it means something only for a تأمین patient.
const $375f8776645d5aee$var$TAMIN_ORDER_TYPES = new Set([
    'lab',
    'imaging',
    'dental_lab'
]);
const $375f8776645d5aee$export$ff0b3160d2d98f35 = (row, insurer)=>insurer === 'tamin' && typeof row?.taminListed === 'boolean' ? row.taminListed : null;
function $375f8776645d5aee$export$467168533c33d9ca(order, resolved, insurer) {
    if (insurer !== 'tamin' || !$375f8776645d5aee$var$TAMIN_ORDER_TYPES.has(order?.orderType) || order?.status === 'cancelled') return null;
    if (!order.catalogId) return false;
    return $375f8776645d5aee$export$ff0b3160d2d98f35(resolved?.get?.(order.catalogId), insurer);
}
function $375f8776645d5aee$export$41198ed546152d40(item, t, readsPersianData) {
    if (!item) return '';
    return [
        item.dosage && $375f8776645d5aee$export$a6616cb9d478340f(item.dosage, readsPersianData, t),
        item.frequency && (0, $lfHhF.drugFrequencyLabel)(item.frequency, t),
        item.route && (0, $eQiuG.routeLabel)(item.route, t),
        item.duration && t('visit.rx.forDuration', {
            duration: item.duration
        }),
        item.quantity
    ].filter(Boolean).join(" \xb7 ");
}
function $375f8776645d5aee$export$564a716e7cf1f53f({ item: item, onChange: onChange, onRemove: onRemove, insurer: insurer, erxLine: erxLine }) {
    const { t: t, readsPersianData: readsPersianData } = (0, $LNQP4.default)();
    const { drug: drug, dosage: dosage, frequency: frequency, route: route, duration: duration, quantity: quantity, instructions: instructions, templateTitle: templateTitle } = item;
    const names = (0, $g6gAc.drugNameLines)(drug);
    const [editing, setEditing] = (0, $acw62.useState)(false);
    // دوز and تناوب are CLOSED lists (lib/rxOptions.js): the e-prescription sends
    // them as codes, and the formulary's own suggestions («5 MG», «daily») were
    // refused on every line (K1, 2026-09-30). The same controls as the picker's add
    // bar, so a line is written the same way wherever it is written.
    const listId = `rx-opts-${item.id}`;
    // `labelFor` translates what the reader SEES without touching what is stored.
    // The input still receives the option's `value`, so a frequency picked from
    // the list is written to the record in Persian exactly as before — which is
    // what the pharmacy reads and what every stored prescription already holds.
    // Omitted for a Persian reader, so their markup is unchanged.
    const field = (key, val, opts, placeholder, width, labelFor)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: 4,
                minWidth: 0,
                ...width ? {
                    width: width
                } : {
                    flex: 1
                }
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
            style: $375f8776645d5aee$export$6897efa034860c56,
            htmlFor: `${listId}-${key}`
        }, placeholder), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
            id: `${listId}-${key}`,
            list: opts?.length ? `${listId}-${key}-list` : undefined,
            value: val || '',
            onChange: (e)=>onChange(key, e.target.value),
            placeholder: placeholder,
            "data-testid": `visit-rx-field-${key}`,
            style: {
                ...$375f8776645d5aee$export$d4e2cf4ef3f8061,
                padding: '6px 9px',
                fontSize: '0.75rem'
            }
        }), opts?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("datalist", {
            id: `${listId}-${key}-list`
        }, opts.map((o)=>{
            const shown = labelFor ? labelFor(o) : o;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
                key: o,
                value: o,
                ...shown !== o ? {
                    label: shown
                } : {}
            });
        })));
    const withCurrent = (opts, cur)=>cur && !opts.includes(cur) ? [
            cur,
            ...opts
        ] : opts;
    const shownRoute = (0, $eQiuG.toRouteOption)(route) || route;
    const choice = (key, val, opts, placeholder, width, labelFor)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: 4,
                minWidth: 0,
                ...width ? {
                    width: width
                } : {
                    flex: 1
                }
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
            style: $375f8776645d5aee$export$6897efa034860c56,
            htmlFor: `${listId}-${key}`
        }, placeholder), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("select", {
            id: `${listId}-${key}`,
            value: val || '',
            onChange: (e)=>onChange(key, e.target.value),
            "data-testid": `visit-rx-field-${key}`,
            style: {
                ...$375f8776645d5aee$export$775ae08e7b0fd486,
                padding: '6px 9px',
                fontSize: '0.75rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
            value: ""
        }, placeholder), opts.map((o)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
                key: o,
                value: o
            }, labelFor ? labelFor(o) : o))));
    // A line's details — دوز، تناوب، نحوه مصرف، مدت، تعداد — in the page's own
    // typeface at a size that reads at arm's length. They used to be 10px in a
    // monospace face, which has no Persian glyphs of its own: the browser spaced
    // a fallback font's letters apart and the words came out as «ر و ز ی   ی ک».
    // `strong` is the count: the one number a pharmacy dispenses by.
    const chip = (text, key, strong = false)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            key: key,
            "data-rx-detail": key,
            style: {
                fontSize: '0.75rem',
                fontWeight: strong ? 700 : 500,
                lineHeight: '22px',
                padding: '0 9px',
                borderRadius: 6,
                color: strong ? 'var(--accent-ink)' : 'var(--ink)',
                background: strong ? 'var(--accent-soft)' : 'var(--panel-2)',
                whiteSpace: 'nowrap',
                flexShrink: 0
            }
        }, text);
    if (editing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `visit-rx-card-${item.id}`,
        "data-editing": "true",
        style: {
            background: 'var(--panel)',
            border: '1.5px solid var(--accent)',
            borderRadius: 10,
            padding: '10px 12px',
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
            animation: 'fadeUp .15s ease'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 10
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: 28,
            height: 28,
            borderRadius: 8,
            flexShrink: 0,
            display: 'grid',
            placeItems: 'center',
            background: 'var(--accent-soft)',
            color: 'var(--accent-ink)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($375f8776645d5aee$export$9bb611d729802a56.pill, {
        width: 14,
        height: 14
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: "auto",
        style: {
            fontSize: '0.78125rem',
            fontWeight: 600,
            color: 'var(--ink)'
        }
    }, names.primary), names.secondary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: "auto",
        style: {
            fontSize: '0.65625rem',
            color: 'var(--mute-2)'
        }
    }, names.secondary)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: "iconbtn",
        onClick: ()=>setEditing(false),
        title: t('common.actions.confirm'),
        "data-testid": `visit-rx-confirm-${item.id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($375f8776645d5aee$export$9bb611d729802a56.check, {
        width: 14,
        height: 14
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: "iconbtn danger",
        onClick: onRemove,
        title: t('common.actions.delete'),
        "aria-label": t('visit.rx.removeAria', {
            name: (0, $g6gAc.drugDisplayName)(drug)
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($375f8776645d5aee$export$9bb611d729802a56.x, {
        width: 14,
        height: 14
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 8,
            flexWrap: 'wrap',
            alignItems: 'flex-end'
        }
    }, choice('dosage', dosage, (0, $eQiuG.doseOptionsFor)(drug, dosage), t('visit.rx.dose'), 130, (v)=>$375f8776645d5aee$export$a6616cb9d478340f(v, readsPersianData, t)), choice('frequency', frequency, (0, $eQiuG.frequencyOptionsFor)(frequency), t('visit.rx.frequency'), 150, (v)=>(0, $lfHhF.drugFrequencyLabel)(v, t)), choice('route', shownRoute, withCurrent($375f8776645d5aee$export$e730a0734bbb1219(), shownRoute), t('visit.rx.route'), 130, (v)=>(0, $eQiuG.routeLabel)(v, t)), choice('duration', duration, withCurrent($375f8776645d5aee$export$74f6a832d246e098(t), duration), t('visit.rx.duration'), 120), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 4,
            minWidth: 0,
            width: 110
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        style: $375f8776645d5aee$export$6897efa034860c56,
        htmlFor: `${listId}-quantity`
    }, t('visit.rx.quantity')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        id: `${listId}-quantity`,
        inputMode: "numeric",
        value: quantity || '',
        onChange: (e)=>onChange('quantity', (0, $5JYPc.toEnDigits)(e.target.value).replace(/[^\d]/g, '')),
        placeholder: t('visit.rx.quantity'),
        "data-testid": "visit-rx-field-quantity",
        style: {
            ...$375f8776645d5aee$export$d4e2cf4ef3f8061,
            padding: '6px 9px',
            fontSize: '0.75rem'
        }
    }))), field('instructions', instructions, $375f8776645d5aee$export$7be9a8bfe9895054(t), t('visit.rx.instructions')));
    const missing = (0, $eQiuG.missingRxFields)(item);
    const chips = [
        dosage && chip($375f8776645d5aee$export$a6616cb9d478340f(dosage, readsPersianData, t), 'd'),
        frequency && chip((0, $lfHhF.drugFrequencyLabel)(frequency, t), 'f'),
        route && chip((0, $eQiuG.routeLabel)(route, t), 'r'),
        duration && chip(t('visit.rx.forDuration', {
            duration: duration
        }), 'u'),
        // A bare «7» at the end of a line says nothing; «تعداد 7» is the count. A
        // count written with its own unit («۲۱ عدد», a refilled older line) already
        // says what it is and is shown as written.
        quantity && chip(/^[\d۰-۹٠-٩]+$/.test(String(quantity).trim()) ? t('visit.rx.quantityCount', {
            n: quantity
        }) : quantity, 'q', true)
    ].filter(Boolean);
    // Two lines: the drug's name, then its details. On one line the details were
    // squeezed to 10px to fit beside a long product name, and clipped when they
    // still did not; on their own line they wrap instead.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `visit-rx-card-${item.id}`,
        style: {
            background: 'var(--panel)',
            border: '1px solid var(--line)',
            borderRadius: 10,
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            padding: '9px 10px',
            animation: 'fadeUp .2s ease'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: 30,
            height: 30,
            borderRadius: 8,
            flexShrink: 0,
            display: 'grid',
            placeItems: 'center',
            background: 'var(--accent-soft)',
            color: 'var(--accent-ink)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($375f8776645d5aee$export$9bb611d729802a56.pill, {
        width: 15,
        height: 15
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: 5
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'baseline',
            gap: 8,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            fontSize: '0.8125rem',
            fontWeight: 700,
            color: 'var(--ink)',
            lineHeight: 1.5,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            flex: '0 1 auto',
            minWidth: 0
        }
    }, names.primary), names.secondary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            fontSize: '0.71875rem',
            color: 'var(--ink-2)',
            lineHeight: 1.5,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            flex: '0 2 auto',
            minWidth: 0
        }
    }, names.secondary), templateTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        title: templateTitle,
        style: {
            fontSize: '0.65625rem',
            fontWeight: 600,
            color: 'var(--ink-2)',
            background: 'var(--panel-2)',
            border: '1px solid var(--line)',
            padding: '0 6px',
            borderRadius: 4,
            lineHeight: '18px',
            flexShrink: 0,
            whiteSpace: 'nowrap',
            maxWidth: 140,
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    }, templateTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `visit-rx-details-${item.id}`,
        style: {
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: 6,
            minWidth: 0
        }
    }, chips, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($375f8776645d5aee$export$e901e237ac90bbca, {
        drug: drug
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($375f8776645d5aee$export$cbaf757fd313ab43, {
        drug: drug,
        insurer: insurer
    }), item.aiNote !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": `visit-rx-ai-mark-${item.id}`,
        title: item.aiNote || undefined,
        style: {
            fontSize: '0.6875rem',
            fontWeight: 700,
            color: 'oklch(0.38 0.14 290)',
            background: 'oklch(0.97 0.02 290)',
            border: '1px solid oklch(0.87 0.06 290)',
            padding: '0 8px',
            borderRadius: 6,
            lineHeight: '22px',
            flexShrink: 0,
            whiteSpace: 'nowrap'
        }
    }, t('visit.rx.directions.badge')), missing.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": `visit-rx-incomplete-${item.id}`,
        "data-missing": missing.join(' '),
        title: t('visit.rx.incompleteHint'),
        style: {
            fontSize: '0.6875rem',
            fontWeight: 700,
            color: 'var(--warn-ink)',
            background: 'var(--warn-soft)',
            padding: '0 8px',
            borderRadius: 6,
            lineHeight: '22px',
            flexShrink: 0,
            whiteSpace: 'nowrap'
        }
    }, (0, $eQiuG.rxIncompleteLabel)(missing, t)), item.removeFailed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": `visit-rx-remove-failed-${item.id}`,
        title: t('visit.rx.removeFailedHint'),
        style: {
            fontSize: '0.6875rem',
            fontWeight: 700,
            color: 'var(--danger-ink)',
            background: 'var(--danger-soft)',
            padding: '0 8px',
            borderRadius: 6,
            lineHeight: '22px',
            flexShrink: 0,
            whiteSpace: 'nowrap'
        }
    }, t('visit.rx.removeFailed')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bOPUe.ErxLineChip), {
        line: erxLine,
        testid: `visit-rx-erx-state-${item.id}`
    }), instructions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            fontSize: '0.75rem',
            color: 'var(--ink-2)',
            lineHeight: '22px',
            overflowWrap: 'anywhere',
            minWidth: 0
        }
    }, instructions))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: "iconbtn",
        onClick: ()=>setEditing(true),
        title: t('common.actions.edit'),
        "data-testid": `visit-rx-edit-${item.id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($375f8776645d5aee$export$9bb611d729802a56.edit, {
        width: 14,
        height: 14
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: "iconbtn danger",
        onClick: onRemove,
        title: t('common.actions.delete'),
        "aria-label": t('visit.rx.removeAria', {
            name: (0, $g6gAc.drugDisplayName)(drug)
        }),
        "data-testid": `visit-rx-remove-${item.id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($375f8776645d5aee$export$9bb611d729802a56.x, {
        width: 14,
        height: 14
    })));
}
function $375f8776645d5aee$export$fed3aff69bf06eb1({ m: m, clr: clr, bg: bg, last: last, prev: prev, sorted: sorted }) {
    const { formatDate: formatDate } = (0, $LNQP4.default)();
    const [hovIdx, setHovIdx] = (0, $acw62.useState)(null);
    const delta = prev != null ? +(last.value - prev.value).toFixed(1) : null;
    const arrow = delta === null ? null : delta > 0 ? "\u2191" : delta < 0 ? "\u2193" : "\u2192";
    const W = 90, H = 38;
    let sparkEl = null;
    if (sorted.length >= 2) {
        const vals = sorted.map((p)=>p.value);
        const minV = Math.min(...vals), maxV = Math.max(...vals);
        const vR = maxV - minV || 1;
        const n = sorted.length - 1;
        const xOf = (i)=>4 + i / n * (W - 8);
        const yOf = (v)=>4 + (H - 8) - (v - minV) / vR * (H - 8);
        const pts = sorted.map((p, i)=>`${xOf(i).toFixed(1)},${yOf(p.value).toFixed(1)}`).join(' ');
        const hov = hovIdx !== null ? sorted[hovIdx] : null;
        const tipW = 60, tipH = 26;
        const tipX = hov ? Math.min(Math.max(xOf(hovIdx) - tipW / 2, 0), W - tipW) : 0;
        const rawTipY = hov ? yOf(hov.value) - tipH - 5 : 0;
        const tipY = rawTipY < -10 ? hov ? yOf(hov.value) + 5 : 0 : rawTipY;
        const dateStr = hov ? formatDate(hov.date, 'dayMonth') : '';
        sparkEl = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
            viewBox: `0 0 ${W} ${H}`,
            width: W,
            height: H,
            style: {
                display: 'block',
                overflow: 'visible'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polyline", {
            points: pts,
            fill: "none",
            stroke: clr,
            strokeWidth: 1.5,
            strokeLinejoin: "round",
            strokeOpacity: 0.7
        }), sorted.map((p, i)=>{
            const isl = i === sorted.length - 1;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
                key: i,
                cx: xOf(i),
                cy: yOf(p.value),
                r: hovIdx === i ? 4 : isl ? 3 : 1.8,
                fill: hovIdx === i || isl ? clr : 'var(--panel-2)',
                stroke: clr,
                strokeWidth: 1.2,
                style: {
                    cursor: 'crosshair'
                },
                onMouseEnter: ()=>setHovIdx(i),
                onMouseLeave: ()=>setHovIdx(null)
            });
        }), hov && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
            style: {
                pointerEvents: 'none'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
            x: tipX,
            y: tipY,
            width: tipW,
            height: tipH,
            rx: 5,
            fill: "var(--ink)",
            opacity: 0.9
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
            x: tipX + tipW / 2,
            y: tipY + 10,
            textAnchor: "middle",
            fill: "white",
            fontSize: 9,
            fontWeight: 700,
            fontFamily: "inherit"
        }, hov.value, " ", m.unit), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
            x: tipX + tipW / 2,
            y: tipY + 20,
            textAnchor: "middle",
            fill: "rgba(255,255,255,.65)",
            fontSize: 8,
            fontFamily: "inherit"
        }, dateStr)));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: bg,
            border: `1px solid ${clr}22`,
            borderRadius: 10,
            padding: '10px 11px',
            display: 'flex',
            flexDirection: 'column',
            gap: 4
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.65625rem',
            fontWeight: 700,
            color: clr,
            letterSpacing: '.02em'
        }
    }, m.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.5625rem',
            color: clr,
            opacity: .7,
            fontWeight: 600
        }
    }, m.unit)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'baseline',
            gap: 5
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '1.375rem',
            fontWeight: 800,
            color: clr,
            lineHeight: 1,
            fontVariantNumeric: 'tabular-nums'
        }
    }, last.value), arrow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.6875rem',
            fontWeight: 700,
            color: clr,
            opacity: .8
        }
    }, arrow, Math.abs(delta))), sparkEl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: 4
        }
    }, sparkEl));
}
const $375f8776645d5aee$export$f5b2122ece54afe9 = new Set([
    '8480-6',
    '8462-4',
    '8867-4',
    '59408-5',
    '8310-5',
    '29463-7'
]);
const $375f8776645d5aee$export$e7c7d59bbcc29ee1 = {
    bpSys: '8480-6',
    bpDia: '8462-4',
    pulse: '8867-4',
    spo2: '59408-5',
    temp: '8310-5',
    weight: '29463-7'
};
const $375f8776645d5aee$export$ccc2c13eb48542b9 = ()=>({
        bpSys: '',
        bpDia: '',
        pulse: '',
        spo2: '',
        temp: '',
        weight: ''
    });
const $375f8776645d5aee$export$8c63808338caf15c = (raw)=>{
    const v = (0, $5JYPc.toEnDigits)(raw ?? '').replace(/[٫,]/g, '.').replace(/[^\d.]/g, '');
    const i = v.indexOf('.');
    return i < 0 ? v : v.slice(0, i + 1) + v.slice(i + 1).replace(/\./g, '');
};
function $375f8776645d5aee$export$1e5a39e00c998387(observations, encounterId) {
    const values = $375f8776645d5aee$export$ccc2c13eb48542b9();
    const ids = [];
    if (!encounterId) return {
        values: values,
        ids: ids,
        recorded: false
    };
    const key = String(encounterId);
    const mine = (observations || []).filter((o)=>o.appointmentId && String(o.appointmentId) === key);
    for (const [field, code] of Object.entries($375f8776645d5aee$export$e7c7d59bbcc29ee1)){
        const matches = mine.filter((o)=>o.code === code).sort((a, b)=>(b.effectiveDate || b.createdAt || '').localeCompare(a.effectiveDate || a.createdAt || ''));
        if (!matches.length) continue;
        values[field] = matches[0].value ?? '';
        for (const m of matches)if (m.id) ids.push(m.id);
    }
    return {
        values: values,
        ids: ids,
        recorded: Object.values(values).some((v)=>v !== '' && v != null)
    };
}
const $375f8776645d5aee$export$c6702e128b41d3a7 = {
    'X-Ray': '#6b7280',
    'US': '#0891b2',
    'CT': '#7c3aed',
    'MRI': '#be185d',
    'Echo': '#0f766e',
    'Doppler': '#0369a1',
    'DEXA': '#92400e',
    'Nuclear': '#9f1239',
    'Mammography': '#6d28d9',
    'Angio': '#b45309'
};
const $375f8776645d5aee$export$792cf12450c08f12 = (t)=>({
        stat: {
            label: t('common.urgency.stat'),
            bg: 'var(--danger-soft)',
            color: 'var(--danger-ink)'
        },
        urgent: {
            label: t('common.urgency.urgent'),
            bg: 'var(--warn-soft)',
            color: 'oklch(0.42 0.12 50)'
        },
        routine: {
            label: t('common.urgency.routine'),
            bg: 'var(--accent-soft)',
            color: 'var(--accent-ink)'
        }
    });
const $375f8776645d5aee$export$e867161a6e6ed178 = (t)=>({
        lab: t('visit.orders.lab'),
        imaging: t('patient.orderType.imaging'),
        procedure: t('visit.orders.therapeutic'),
        referral: t('visit.orders.referral'),
        other: t('common.state.other')
    });
const $375f8776645d5aee$export$ba9a3a2cefb281d = {
    lab: 'flask',
    imaging: 'scan',
    procedure: 'steth',
    referral: 'ref',
    other: 'doc'
};
const $375f8776645d5aee$export$937baa5a2896e852 = new Set([
    'lab',
    'imaging'
]);
const $375f8776645d5aee$export$a4db75a9928d8ae7 = (orderType)=>$375f8776645d5aee$export$937baa5a2896e852.has(orderType);
const $375f8776645d5aee$export$97da64870f5585b8 = {
    background: 'var(--panel-2)',
    border: '1px solid var(--line)',
    borderRadius: 'var(--radius-lg)',
    boxShadow: 'var(--shadow)',
    overflow: 'hidden'
};
const $375f8776645d5aee$export$10c499a234e299a6 = {
    padding: '12px 16px',
    borderBottom: '1px solid var(--line-2)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 10,
    background: 'var(--field)'
};
const $375f8776645d5aee$export$a931407aa8dfff78 = {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    fontWeight: 600,
    fontSize: '0.8125rem',
    color: 'var(--ink)'
};
const $375f8776645d5aee$export$7b8c3b54c8233354 = {
    width: 22,
    height: 22,
    borderRadius: 6,
    background: 'var(--accent-soft)',
    color: 'var(--accent-ink)',
    display: 'grid',
    placeItems: 'center',
    flexShrink: 0
};
const $375f8776645d5aee$export$8fe483d880a02f5f = {
    fontSize: '0.625rem',
    background: 'var(--line)',
    color: 'var(--ink-2)',
    padding: '1px 6px',
    borderRadius: 4,
    fontWeight: 600
};
const $375f8776645d5aee$export$4e02c9f6bbae01b0 = {
    background: 'var(--panel)',
    border: '1px solid var(--line)',
    borderRadius: 10,
    padding: 14,
    display: 'flex',
    flexDirection: 'column',
    gap: 10
};
const $375f8776645d5aee$export$6897efa034860c56 = {
    fontSize: '0.6875rem',
    color: 'var(--mute)',
    fontWeight: 500
};
const $375f8776645d5aee$export$d4e2cf4ef3f8061 = {
    border: '1px solid var(--line)',
    borderRadius: 7,
    padding: '8px 11px',
    fontSize: '0.8125rem',
    fontFamily: 'inherit',
    outline: 'none',
    color: 'var(--ink)',
    background: 'var(--field)',
    boxSizing: 'border-box',
    width: '100%'
};
const $375f8776645d5aee$export$775ae08e7b0fd486 = {
    ...$375f8776645d5aee$export$d4e2cf4ef3f8061,
    padding: '7px 10px',
    fontSize: '0.78125rem',
    cursor: 'pointer'
};
const $375f8776645d5aee$export$739e6a3f924c37ce = (effect, t)=>({
        supports: {
            label: t('visit.copilot.vitalImpact.supports'),
            tone: 'good'
        },
        contradicts: {
            label: t('visit.copilot.vitalImpact.contradicts'),
            tone: 'danger'
        },
        neutral: {
            label: t('visit.copilot.vitalImpact.neutral'),
            tone: 'mute'
        }
    })[effect] || {
        label: t('visit.copilot.vitalImpact.neutral'),
        tone: 'mute'
    };
const $375f8776645d5aee$export$4a255e08a08267a2 = `query($appointmentId:ID){getClinicalOrderCatalog(appointmentId:$appointmentId){labTests{id name nameEn nameAr nameFr nameDe loincCode category inHouse}imagingStudies{id name nameEn nameAr nameFr nameDe modality bodyPart category inHouse}procedures{id name nameEn nameAr nameFr nameDe code category inHouse}}}`;
const $375f8776645d5aee$export$bfb5df55ff94459 = 30;
const $375f8776645d5aee$export$6770277ab0ca292e = 2;
const $375f8776645d5aee$var$ORDER_CACHE_LIMIT = 60;
const $375f8776645d5aee$var$orderCatalogCache = new Map();
const $375f8776645d5aee$var$orderCacheGet = (key)=>{
    const hit = $375f8776645d5aee$var$orderCatalogCache.get(key);
    if (!hit) return null;
    $375f8776645d5aee$var$orderCatalogCache.delete(key); // re-insert so the oldest key evicts first
    $375f8776645d5aee$var$orderCatalogCache.set(key, hit);
    return hit;
};
const $375f8776645d5aee$var$orderCachePut = (key, value)=>{
    $375f8776645d5aee$var$orderCatalogCache.set(key, value);
    if ($375f8776645d5aee$var$orderCatalogCache.size > $375f8776645d5aee$var$ORDER_CACHE_LIMIT) $375f8776645d5aee$var$orderCatalogCache.delete($375f8776645d5aee$var$orderCatalogCache.keys().next().value);
};
const $375f8776645d5aee$export$e06d85e1fea83f6b = ()=>$375f8776645d5aee$var$orderCatalogCache.clear();
const $375f8776645d5aee$export$14a88ef3dbc10c6b = `query($query:String,$orderType:String,$appointmentId:ID,$limit:Int,$offset:Int){searchClinicalOrderCatalog(query:$query,orderType:$orderType,appointmentId:$appointmentId,limit:$limit,offset:$offset){total entries{id orderType name nameEn nameAr nameFr nameDe category code codeSystem modality bodyPart inHouse isClinicOwned taminListed}}}`;
const $375f8776645d5aee$export$5b0044a5c8c756be = `query($ids:[ID!],$names:[String!],$orderType:String,$appointmentId:ID){resolveClinicalCatalogEntries(ids:$ids,names:$names,orderType:$orderType,appointmentId:$appointmentId){id matchedName orderType name nameEn category code codeSystem inHouse taminListed}}`;
const $375f8776645d5aee$export$7ea42cd960260702 = (q)=>q.replace(/\s+nameFr\b/g, '');
// GraphQL validates before it executes: a refused shape ran nothing.
const $375f8776645d5aee$var$refusedShape = (e)=>e?.extensions?.code === 'GRAPHQL_VALIDATION_FAILED' || /Cannot query field|Unknown argument|Unknown type/.test(String(e?.message || ''));
function $375f8776645d5aee$export$eda06ee722141e6e(send = (0, $eVM84.bffQuery)) {
    let preFr = false;
    return async (full, vars, ...rest)=>{
        const old = $375f8776645d5aee$export$7ea42cd960260702(full);
        if (old === full) return send(full, vars, ...rest);
        if (preFr) return send(old, vars, ...rest);
        try {
            return await send(full, vars, ...rest);
        } catch (e) {
            if (!$375f8776645d5aee$var$refusedShape(e)) throw e;
            const answer = await send(old, vars, ...rest);
            preFr = true;
            return answer;
        }
    };
}
const $375f8776645d5aee$export$ccf519d675cb28b5 = (q)=>q.replace(/\s+nameDe\b/g, '');
function $375f8776645d5aee$export$937f713ec248269b(send = (0, $eVM84.bffQuery)) {
    let preDe = false;
    return async (full, vars, ...rest)=>{
        const old = $375f8776645d5aee$export$ccf519d675cb28b5(full);
        if (old === full) return send(full, vars, ...rest);
        if (preDe) return send(old, vars, ...rest);
        try {
            return await send(full, vars, ...rest);
        } catch (e) {
            if (!$375f8776645d5aee$var$refusedShape(e)) throw e;
            const answer = await send(old, vars, ...rest);
            preDe = true;
            return answer;
        }
    };
}
// A BFF that predates `taminListed` (K1, 2026-10-07) is asked the same two
// questions without it: an environment whose BFF lags its client keeps a
// working picker, without the flag. `nameFr` is shed the same way, and first:
// it is the newer field, so a BFF that knows `taminListed` keeps answering it.
// `nameDe` wraps OUTSIDE `nameFr`, so a BFF that predates both is still found
// out by the `nameFr` step exactly as before German; a BFF that knows `nameFr`
// but not `nameDe` costs one more refused question, once, and keeps `nameFr`.
const $375f8776645d5aee$var$askCatalog = (0, $c9qmv.askWithoutTaminWhenRefused)($375f8776645d5aee$export$937f713ec248269b($375f8776645d5aee$export$eda06ee722141e6e((0, $eVM84.bffQuery))));
async function $375f8776645d5aee$export$14e053085c2b7017({ query: query = '', orderType: orderType = '', appointmentId: appointmentId = null, offset: offset = 0 } = {}) {
    const q = (query || '').trim();
    if (q && q.length < $375f8776645d5aee$export$6770277ab0ca292e) return {
        entries: [],
        total: 0
    };
    const key = `${q}\u0000${orderType}\u0000${appointmentId || ''}\u0000${offset}`;
    const hit = $375f8776645d5aee$var$orderCacheGet(key);
    if (hit) return hit;
    const data = await $375f8776645d5aee$var$askCatalog($375f8776645d5aee$export$14a88ef3dbc10c6b, {
        query: q || null,
        orderType: orderType || null,
        appointmentId: appointmentId,
        limit: $375f8776645d5aee$export$bfb5df55ff94459,
        offset: offset
    });
    const page = {
        entries: data?.searchClinicalOrderCatalog?.entries || [],
        total: data?.searchClinicalOrderCatalog?.total || 0
    };
    $375f8776645d5aee$var$orderCachePut(key, page);
    return page;
}
const $375f8776645d5aee$export$ba503e14bb3d1803 = `query($appointmentId:ID,$limit:Int){myFrequentOrders(appointmentId:$appointmentId,limit:$limit){times lastAt entry{id orderType name nameEn nameAr nameFr nameDe category code codeSystem modality bodyPart inHouse isClinicOwned taminListed}}}`;
const $375f8776645d5aee$export$ceb249b94191b54e = `query($appointmentId:ID!,$limit:Int){clinicOrderCatalog(appointmentId:$appointmentId,limit:$limit){total entries{id orderType name nameEn nameAr nameFr nameDe category code codeSystem modality bodyPart inHouse isClinicOwned taminListed}}}`;
async function $375f8776645d5aee$export$8844835d216cf19c({ appointmentId: appointmentId = null, limit: limit = 12 } = {}) {
    try {
        const data = await $375f8776645d5aee$var$askCatalog($375f8776645d5aee$export$ba503e14bb3d1803, {
            appointmentId: appointmentId,
            limit: limit
        });
        return (data?.myFrequentOrders || []).filter((f)=>f?.entry?.id);
    } catch (err) {
        console.warn('[orders] myFrequentOrders failed:', err?.message || err);
        return [];
    }
}
async function $375f8776645d5aee$export$7fb4b3e6d0f53ffa({ appointmentId: appointmentId, limit: limit = 60 } = {}) {
    if (!appointmentId) return {
        entries: [],
        total: 0
    };
    try {
        const data = await $375f8776645d5aee$var$askCatalog($375f8776645d5aee$export$ceb249b94191b54e, {
            appointmentId: appointmentId,
            limit: limit
        });
        return {
            entries: data?.clinicOrderCatalog?.entries || [],
            total: data?.clinicOrderCatalog?.total || 0
        };
    } catch (err) {
        console.warn('[orders] clinicOrderCatalog failed:', err?.message || err);
        return {
            entries: [],
            total: 0
        };
    }
}
/**
 * What ALREADY-SAVED orders need from the catalogue: the English name the SOAP
 * plan block prints, whether this clinic performs the service, and its code.
 *
 * `names` is for the two shapes that carry no catalogId — orders written before
 * the catalogue did, and the AI treatment plan, which proposes a service as free
 * text and must be matched back to a row before it can be billed. An ambiguous
 * name resolves to NOTHING rather than to a guess; narrow it with orderType.
 *
 * Not cached: it is one call per visit, and a stale «انجام» button is a stale
 * billing affordance.
 */ // English catalogue names for orders that identify themselves by their Persian
// name — an AI suggestion, an order it created, an order on a past visit. Looked
// up once per name (cached for the page), and only for a reader who does not read
// Persian. The Persian is what is stored and matched; this changes what is SHOWN.
const $375f8776645d5aee$var$catalogNameEnCache = new Map();
function $375f8776645d5aee$export$69d0d94972917188(rows) {
    for (const r of rows || []){
        // A row found BY name carries the name it matched; one found by id carries
        // its own Persian name, which is what an order's description says.
        for (const n of [
            r?.matchedName,
            r?.name
        ])if (n) $375f8776645d5aee$var$catalogNameEnCache.set(n.trim(), r.nameEn || '');
    }
}
async function $375f8776645d5aee$export$d1f71c951f3a3ccc(names) {
    const want = [
        ...new Set((names || []).map((n)=>(n || '').trim()).filter(Boolean))
    ].filter((n)=>!$375f8776645d5aee$var$catalogNameEnCache.has(n));
    if (!want.length) return;
    const rows = await $375f8776645d5aee$export$ff3759fdd9615d20({
        names: want
    });
    for (const n of want)$375f8776645d5aee$var$catalogNameEnCache.set(n, '');
    $375f8776645d5aee$export$69d0d94972917188(rows);
}
function $375f8776645d5aee$export$891bfbeed44ddfce(names) {
    const { readsPersianData: readsPersianData } = (0, $LNQP4.default)();
    const key = readsPersianData ? '' : [
        ...new Set((names || []).map((n)=>(n || '').trim()).filter(Boolean))
    ].sort().join('\u0000');
    const [, bump] = (0, $acw62.useState)(0);
    (0, $acw62.useEffect)(()=>{
        if (!key) return undefined;
        const want = key.split('\u0000').filter((n)=>!$375f8776645d5aee$var$catalogNameEnCache.has(n));
        if (!want.length) return undefined;
        let live = true;
        $375f8776645d5aee$export$d1f71c951f3a3ccc(want).then(()=>{
            if (live) bump((x)=>x + 1);
        }).catch((err)=>console.warn('catalogue English names unavailable:', err));
        return ()=>{
            live = false;
        };
    }, [
        key
    ]);
    return (name)=>readsPersianData ? name : $375f8776645d5aee$var$catalogNameEnCache.get((name || '').trim()) || name;
}
function $375f8776645d5aee$export$f1536cfec6e3f4b8(text, t, readsPersianData) {
    if (readsPersianData || !text) return text;
    return String(text).split(" \xb7 ").map((raw)=>{
        const part = raw.trim();
        const freq = (0, $lfHhF.drugFrequencyLabel)(part, t);
        if (freq !== part) return freq;
        const dur = (0, $lnUwI.durationEn)(part);
        if (dur && dur !== part) return dur;
        return $375f8776645d5aee$export$a6616cb9d478340f(part, false, t);
    }).join(" \xb7 ");
}
async function $375f8776645d5aee$export$ff3759fdd9615d20({ ids: ids = [], names: names = [], orderType: orderType = '', appointmentId: appointmentId = null } = {}) {
    const wantIds = [
        ...new Set(ids.filter(Boolean))
    ];
    const wantNames = [
        ...new Set(names.filter(Boolean))
    ];
    if (!wantIds.length && !wantNames.length) return [];
    const data = await $375f8776645d5aee$var$askCatalog($375f8776645d5aee$export$5b0044a5c8c756be, {
        ids: wantIds.length ? wantIds : null,
        names: wantNames.length ? wantNames : null,
        orderType: orderType || null,
        appointmentId: appointmentId
    });
    return data?.resolveClinicalCatalogEntries || [];
}
function $375f8776645d5aee$export$30e9b064e10043f9({ urgency: urgency }) {
    const { t: t } = (0, $LNQP4.default)();
    if (!urgency || urgency === 'routine') return null;
    const cfg = $375f8776645d5aee$export$792cf12450c08f12(t)[urgency] || $375f8776645d5aee$export$792cf12450c08f12(t).routine;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.625rem',
            padding: '2px 7px',
            borderRadius: 4,
            background: cfg.bg,
            color: cfg.color,
            fontWeight: 700,
            flexShrink: 0,
            whiteSpace: 'nowrap'
        }
    }, cfg.label);
}
function $375f8776645d5aee$export$a36149ed7c50a677({ item: item, selected: selected, onToggle: onToggle, showLoinc: showLoinc }) {
    const { t: t, readsPersianData: readsPersianData, locale: locale } = (0, $LNQP4.default)();
    const names = $375f8776645d5aee$export$adea16e688375bbf(item, readsPersianData, $375f8776645d5aee$export$239a3e8cf23f2d47(item, locale));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: ()=>onToggle(item.key),
        style: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: 9,
            padding: '9px 12px',
            borderRadius: 10,
            border: `1.5px solid ${selected ? 'var(--accent)' : 'var(--line)'}`,
            background: selected ? 'var(--accent-soft)' : 'var(--panel-2)',
            cursor: 'pointer',
            fontFamily: 'inherit',
            textAlign: 'start',
            transition: 'all .12s',
            width: '100%'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 17,
            height: 17,
            borderRadius: 5,
            border: `1.5px solid ${selected ? 'var(--accent)' : 'var(--line-2)'}`,
            background: selected ? 'var(--accent)' : 'transparent',
            display: 'grid',
            placeItems: 'center',
            flexShrink: 0,
            marginTop: 1,
            transition: 'all .12s'
        }
    }, selected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($375f8776645d5aee$export$9bb611d729802a56.check, {
        width: 9,
        height: 9,
        style: {
            color: '#fff'
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.78125rem',
            fontWeight: 600,
            color: selected ? 'var(--accent-ink)' : 'var(--ink)',
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            flexWrap: 'wrap'
        }
    }, names.primary, item.times > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": `visit-order-times-${item.catalogId || item.key}`,
        style: {
            fontSize: '0.59375rem',
            padding: '1px 7px',
            borderRadius: 999,
            background: 'var(--accent-soft)',
            color: 'var(--accent-ink)',
            fontWeight: 700,
            whiteSpace: 'nowrap'
        }
    }, t('visit.orders.frequentTimes', {
        count: item.times
    })), item.inHouse && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        title: t('visit.orders.doneHere'),
        style: {
            fontSize: '0.59375rem',
            padding: '1px 6px',
            borderRadius: 4,
            background: 'var(--ok-soft, #0f766e22)',
            color: 'var(--ok-ink, #0f766e)',
            fontWeight: 700,
            border: '1px solid #0f766e33',
            whiteSpace: 'nowrap'
        }
    }, t('visit.orders.thisClinic')), item.modality && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.59375rem',
            padding: '1px 6px',
            borderRadius: 4,
            background: $375f8776645d5aee$export$c6702e128b41d3a7[item.modality] ? $375f8776645d5aee$export$c6702e128b41d3a7[item.modality] + '22' : 'var(--line)',
            color: $375f8776645d5aee$export$c6702e128b41d3a7[item.modality] || 'var(--mute)',
            fontWeight: 700,
            border: `1px solid ${$375f8776645d5aee$export$c6702e128b41d3a7[item.modality] || 'var(--line)'}33`
        }
    }, item.modality), showLoinc && item.loincCode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.5625rem',
            color: 'var(--mute)',
            fontFamily: 'monospace'
        }
    }, "LOINC ", item.loincCode), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($375f8776645d5aee$export$cbaf757fd313ab43, {
        drug: {
            id: item.catalogId || item.key
        },
        listed: item.taminListed ?? null,
        both: true,
        testid: `visit-order-coverage-${item.catalogId || item.key}`,
        hint: t('visit.orders.outTaminHint')
    })), names.secondary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.65625rem',
            color: 'var(--mute-2)',
            marginTop: 1
        }
    }, names.secondary), item.reason && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.6875rem',
            color: 'var(--mute)',
            marginTop: 2,
            lineHeight: 1.5
        }
    }, item.reason), item.sub && !item.reason && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.65625rem',
            color: 'var(--mute-2)',
            marginTop: 1
        }
    }, item.sub)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($375f8776645d5aee$export$30e9b064e10043f9, {
        urgency: item.urgency
    }));
}
const $375f8776645d5aee$export$9c5829f0850e67fe = (patient)=>patient?.age ?? null;
function $375f8776645d5aee$export$bf8ea0179266f66d(patient) {
    if (!patient) return '';
    const parts = [];
    const demo = [
        patient.age != null ? `age=${patient.age}` : null,
        patient.gender ? `gender=${patient.gender}` : null
    ].filter(Boolean);
    if (demo.length) parts.push('DEMOGRAPHICS: ' + demo.join(', '));
    const conds = (patient.clinicalConditions || []).filter((c)=>c.clinicalStatus === 'active');
    if (conds.length) parts.push('CONDITIONS: ' + conds.map((c)=>c.display).join(', '));
    const meds = (patient.clinicalMedications || []).filter((m)=>m.status === 'active');
    if (meds.length) parts.push('MEDICATIONS: ' + meds.map((m)=>`${m.display}${m.dosageInstruction?.text ? ' ' + m.dosageInstruction.text : ''}`).join(', '));
    // Only last 10 abnormal/noteworthy observations to keep token count low.
    //
    // Vitals are excluded, and that exclusion is the point of the filter rather
    // than a token-budget nicety. `clinicalObservations` spans the patient's whole
    // record, so the ten most recent numbers here are drawn from whichever visits
    // happened to be busy — and this block is sent verbatim as the `patientHistory`
    // argument of askDoctorQuestion and generateConfirmationQuestions. A blood
    // pressure from last month arriving under a heading the model reads as the
    // patient's current state is exactly the confusion the AI-side scoping exists
    // to prevent. This visit's vitals reach the service by the appointment id and
    // are attached there; nothing this block could add would belong to this visit.
    // Labs stay: a creatinine from two months ago is history, and reads as history.
    const ABNORMAL_THRESHOLD = {};
    const obs = (patient.clinicalObservations || []).filter((o)=>o.value && !isNaN(parseFloat(o.value))).filter((o)=>!(0, $gq4TR.VITAL_LOINC_SET).has(o.code)).sort((a, b)=>(b.effectiveDate || b.createdAt || '').localeCompare(a.effectiveDate || a.createdAt || '')).slice(0, 10);
    if (obs.length) {
        const obsLines = obs.map((o)=>{
            const date = o.effectiveDate || o.createdAt || '';
            return `${o.display || o.code}=${o.value}${o.unit ? ' ' + o.unit : ''}${date ? ' [' + date.slice(0, 10) + ']' : ''}`;
        });
        parts.push('LAB_HISTORY:\n' + obsLines.join('\n'));
    }
    const visits = (patient.history || []).slice(0, 3);
    if (visits.length) {
        const visitLines = visits.map((v)=>`[${v.date || ''}] ${v.diagnosis || ''}`).filter((l)=>l.trim() !== '[]');
        if (visitLines.length) parts.push('VISIT_HISTORY: ' + visitLines.join(' | '));
    }
    return parts.join('\n');
}
function $375f8776645d5aee$export$282a2c8a3d030b1(soap, diagnosis, pendingTests) {
    const parts = [];
    const hasSoap = soap && (soap.s || soap.o || soap.a || soap.p);
    if (hasSoap) {
        parts.push('CURRENT_VISIT_SOAP:');
        if (soap.s) parts.push(`S: ${soap.s}`);
        if (soap.o) parts.push(`O: ${soap.o}`);
        if (soap.a) parts.push(`A: ${soap.a}`);
        if (soap.p) parts.push(`P: ${soap.p}`);
    }
    if (diagnosis && diagnosis.length) {
        const dxText = Array.isArray(diagnosis) ? diagnosis.map((d)=>d.display || d.name || d).filter(Boolean).join(', ') : String(diagnosis);
        if (dxText) parts.push(`CURRENT_DIAGNOSIS: ${dxText}`);
    }
    if (pendingTests && pendingTests.length) {
        const orderLines = pendingTests.map((test)=>`- ${test.name} [${test.type || 'order'}, ${test.urgency || 'routine'}]`);
        parts.push('CURRENT_ORDERS:\n' + orderLines.join('\n'));
    }
    return parts.join('\n');
}
function $375f8776645d5aee$export$afbcfcdadda1b1bf(q, answer, t) {
    const stem = String(q?.question || '').replace(/^آیا\s+/, '').replace(/[؟?]+$/, '');
    return answer === 'yes' ? q?.positiveStatement || stem : q?.negativeStatement || t('visit.text.without', {
        text: stem
    });
}
function $375f8776645d5aee$export$9c2ce4aa2a7d6fc6(q, answer, t, followUp) {
    const base = $375f8776645d5aee$export$afbcfcdadda1b1bf(q, answer, t);
    const note = (followUp || '').trim();
    return note ? `${base} (${note})` : base;
}
function $375f8776645d5aee$export$7904c2b41f6b4e23(state, activeCodes) {
    if (!state) return {};
    const keep = new Set(activeCodes || []);
    const next = {};
    let dropped = false;
    for (const [key, value] of Object.entries(state)){
        const sep = key.indexOf(':'); // ICD codes contain no ':'
        if (keep.has(sep === -1 ? key : key.slice(0, sep))) next[key] = value;
        else dropped = true;
    }
    return dropped ? next : state;
}
function $375f8776645d5aee$export$5a4e1c8ddaeead64(s, finding) {
    const bullet = `\u{2022} ${finding}`;
    return s ? `${s}\n${bullet}` : bullet;
}
const $375f8776645d5aee$export$d1f269d7e988a6d = "\u2500\u2500\u2500 Treatment plan (auto-updated) \u2500\u2500\u2500"; // i18n-exempt: structural marker parsed back out of stored notes — see above
const $375f8776645d5aee$export$4d844df10945fd3f = "\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500"; // i18n-exempt: structural marker, nothing to translate
const $375f8776645d5aee$export$155046b7971ebae7 = [
    "\u2500\u2500\u2500 \u0628\u0631\u0646\u0627\u0645\u0647 \u062F\u0631\u0645\u0627\u0646 (\u0628\u0647\u200C\u0631\u0648\u0632\u0631\u0633\u0627\u0646\u06CC \u062E\u0648\u062F\u06A9\u0627\u0631) \u2500\u2500\u2500"
]; // i18n-exempt: recognises notes written before the plan block became English
// Section headings and order kinds, English by the same rule. // i18n-exempt: clinical document, deliberately locale-independent
const $375f8776645d5aee$var$PLAN_MEDS_HEADING = 'Medications:';
const $375f8776645d5aee$var$PLAN_ORDERS_HEADING = 'Orders and procedures:';
// The catalogue's column for each language it is translated into, beyond `name`
// (Persian) and `nameEn`. Which column holds whose name is a fact about the
// CATALOGUE — order_catalog's columns and the BFF fields in front of them,
// selected by the documents above — not about the language, so it is kept here
// rather than in the locale registry. English has no entry: `nameEn` is already
// the cascade's next step for every reader who does not read Persian.
const $375f8776645d5aee$var$CATALOG_NAME_FIELD = Object.freeze({
    ar: 'nameAr',
    fr: 'nameFr',
    de: 'nameDe'
});
const $375f8776645d5aee$export$239a3e8cf23f2d47 = (item, locale)=>{
    const field = $375f8776645d5aee$var$CATALOG_NAME_FIELD[String(locale || '').toLowerCase().split(/[-_]/)[0]];
    return field && item?.[field] || '';
};
const $375f8776645d5aee$export$adea16e688375bbf = (item, readsPersianData, preferred)=>{
    const persian = (item?.name || '').trim();
    // `preferred` is this reader's own language if the row carries it — Arabic
    // for an Arabic reader, French for a French one (ownCatalogName) — and
    // English is the second best, not the first: a lab test has a settled Arabic
    // name and «تعداد الدم الكامل» reads better to that doctor than "CBC with
    // differential" does. Both are nullable, and a clinic's own custom service
    // usually has neither, so this is a cascade and not a choice:
    // name_ar / name_fr / name_de → name_en → name.
    const translated = (preferred || '').trim() || (item?.nameEn || '').trim();
    // A reader who does not read Persian gets their own line alone; the Persian
    // name is shown only when it is the only one the row has.
    if (readsPersianData) return {
        primary: persian || translated,
        secondary: ''
    };
    return {
        primary: translated || persian,
        secondary: ''
    };
};
/**
 * One display line per prescribed drug, in prescription order, in English:
 *
 *     • Metformin — 500mg tablet twice daily for 7 days
 *
 * The strength is never paraphrased — only the Persian dose form and dosing
 * frequency around it are translated, and anything unrecognised is passed
 * through as the doctor entered it (see planEnglish.js).
 */ function $375f8776645d5aee$var$planMedLines(rxItems) {
    return (rxItems || []).map((r)=>{
        const name = (0, $g6gAc.planDrugName)(r?.drug);
        if (!name) return null;
        const detail = [
            (0, $lnUwI.dosageEn)(r.dosage),
            (0, $lnUwI.routeEn)(r.route),
            (0, $lnUwI.frequencyEn)(r.frequency),
            r.duration ? `for ${(0, $lnUwI.durationEn)(r.duration)}` : ''
        ].map((x)=>(x || '').trim()).filter(Boolean).join(' ');
        // The instruction is the doctor's own sentence — passed through verbatim
        // (rule 1 in planEnglish.js) and parenthesised so it reads as an aside
        // rather than as part of the dosing.
        const note = (r.instructions || '').trim();
        const line = detail ? `${name} \u{2014} ${detail}` : name;
        return `\u{2022} ${note ? `${line} (${note})` : line}`;
    }).filter(Boolean);
}
// Cancelled orders are deliberately dropped: a plan that still lists a request
// the doctor withdrew is exactly the divergence this whole mechanism exists to
// prevent. Everything else — pending, in progress, completed — is part of the
// plan for this visit and stays listed.
const $375f8776645d5aee$var$PLAN_ORDER_LABELS = {
    lab: 'Lab',
    imaging: 'Imaging',
    procedure: 'Procedure'
}; // i18n-exempt: English clinical document
const $375f8776645d5aee$var$PLAN_ORDER_FALLBACK_LABEL = 'Order'; // i18n-exempt: English clinical document
// Grouped by kind rather than by insertion time. The live order list is built by
// PREPENDING new orders, so following it would print the plan newest-first and
// reshuffle every line each time the doctor adds one. Grouping makes the block a
// function of WHAT is ordered, not of the sequence it was entered in — which is
// what lets `planBlockInSync` treat "same items" as "no change".
const $375f8776645d5aee$var$PLAN_ORDER_KINDS = [
    'lab',
    'imaging',
    'procedure'
];
/**
 * One display line per live clinical order, grouped lab → imaging → procedure,
 * in English:
 *
 *     • Lab: CBC with differential
 *     • Imaging: Chest X-ray PA
 *
 * The order stores the Persian catalogue name as its description, so the English
 * name is resolved through `orderNameEn` — the catalogue's own `nameEn`, looked
 * up by the catalogId the order was created with. An order the catalogue cannot
 * answer for (free text the doctor typed) keeps their words: inventing an
 * English name for a request nobody standardised would be worse than showing it.
 */ function $375f8776645d5aee$var$planOrderLines(orders, orderNameEn) {
    const live = (orders || []).filter((o)=>o && o.status !== 'cancelled' && (o.description || '').trim());
    const kindRank = (o)=>{
        const i = $375f8776645d5aee$var$PLAN_ORDER_KINDS.indexOf(o.orderType);
        return i === -1 ? $375f8776645d5aee$var$PLAN_ORDER_KINDS.length : i;
    };
    return live.map((o, i)=>({
            o: o,
            i: i
        })).sort((a, b)=>kindRank(a.o) - kindRank(b.o) || a.i - b.i).map(({ o: o })=>{
        const kind = $375f8776645d5aee$var$PLAN_ORDER_LABELS[o.orderType] || $375f8776645d5aee$var$PLAN_ORDER_FALLBACK_LABEL;
        const english = (orderNameEn && orderNameEn(o) || '').trim();
        return `\u{2022} ${kind}: ${english || o.description.trim()}`;
    });
}
function $375f8776645d5aee$export$d3332d0820799abb({ rxItems: rxItems, orders: orders, orderNameEn: orderNameEn }) {
    const meds = $375f8776645d5aee$var$planMedLines(rxItems);
    const ords = $375f8776645d5aee$var$planOrderLines(orders, orderNameEn);
    if (!meds.length && !ords.length) return '';
    const body = [];
    if (meds.length) body.push($375f8776645d5aee$var$PLAN_MEDS_HEADING, ...meds);
    if (ords.length) body.push($375f8776645d5aee$var$PLAN_ORDERS_HEADING, ...ords);
    return [
        $375f8776645d5aee$export$d1f269d7e988a6d,
        ...body,
        $375f8776645d5aee$export$4d844df10945fd3f
    ].join('\n');
}
// Matches the block wherever it sits, including a trailing END marker the doctor
// may have orphaned by deleting lines. The START marker is the anchor; if END is
// missing we take the rest of the text, because a half-deleted block must still
// be replaceable rather than accumulate a second one below it.
function $375f8776645d5aee$var$findPlanBlock(text) {
    const src = text || '';
    // Earliest marker wins, current or legacy: a note stored before the block
    // became English still has to be FOUND, or reconciliation would leave the old
    // Persian block in place and write an English one underneath it.
    let start = -1, marker = $375f8776645d5aee$export$d1f269d7e988a6d;
    for (const candidate of [
        $375f8776645d5aee$export$d1f269d7e988a6d,
        ...$375f8776645d5aee$export$155046b7971ebae7
    ]){
        const at = src.indexOf(candidate);
        if (at !== -1 && (start === -1 || at < start)) {
            start = at;
            marker = candidate;
        }
    }
    if (start === -1) return null;
    const endIdx = src.indexOf($375f8776645d5aee$export$4d844df10945fd3f, start + marker.length);
    const end = endIdx === -1 ? src.length : endIdx + $375f8776645d5aee$export$4d844df10945fd3f.length;
    return {
        start: start,
        end: end
    };
}
function $375f8776645d5aee$export$35974e4f6db92b0(text) {
    let src = text || '';
    for(let at = $375f8776645d5aee$var$findPlanBlock(src); at; at = $375f8776645d5aee$var$findPlanBlock(src)){
        const before = src.slice(0, at.start).trim();
        const after = src.slice(at.end).trim();
        src = before && after ? `${before}\n\n${after}` : before || after;
    }
    return src.trim();
}
function $375f8776645d5aee$export$a3aead4a50abe781(text, block) {
    const narrative = $375f8776645d5aee$export$35974e4f6db92b0(text);
    if (!block) return narrative;
    return narrative ? `${narrative}\n\n${block}` : block;
}
function $375f8776645d5aee$export$46cdec4733783b45(text, block) {
    return $375f8776645d5aee$export$a3aead4a50abe781(text, block) === (text || '');
}
function $375f8776645d5aee$export$69cdf1bc97231e5(text) {
    const src = text || '';
    const at = $375f8776645d5aee$var$findPlanBlock(src);
    return at ? src.slice(at.start, at.end) : '';
}
const $375f8776645d5aee$export$1d07db446c57b398 = {
    note: 'note',
    rationale: 'rationale',
    safety: 'safety',
    followup: 'followup',
    soap: 'soap'
};
const $375f8776645d5aee$export$528d025f14f74fd4 = [
    'lab',
    'imaging',
    'drug'
];
const $375f8776645d5aee$export$bd515ef4f7b2f032 = (s)=>!$375f8776645d5aee$export$528d025f14f74fd4.includes(s?.type);
const $375f8776645d5aee$export$b2355ec0f81e9680 = (list)=>(list || []).filter($375f8776645d5aee$export$bd515ef4f7b2f032);
const $375f8776645d5aee$export$769e1e6a71b6cabc = 0.5;
const $375f8776645d5aee$var$insightWords = (text)=>new Set((0, $g6gAc.foldClinicalText)(text).split(' ').filter((w)=>w.length > 1));
const $375f8776645d5aee$export$6a1145afc4baa12e = (a, b)=>{
    const wa = $375f8776645d5aee$var$insightWords(a);
    const wb = $375f8776645d5aee$var$insightWords(b);
    if (!wa.size || !wb.size) return 0;
    let overlap = 0;
    wa.forEach((w)=>{
        if (wb.has(w)) overlap++;
    });
    return overlap / (wa.size + wb.size - overlap);
};
const $375f8776645d5aee$export$bd5821baf0a03519 = (warning, shown = [])=>{
    const rank = $375f8776645d5aee$export$60d82a5be99a0a11[$375f8776645d5aee$export$a20f1db6dc818677(warning?.severity)];
    return (shown || []).some((s)=>(0, $g6gAc.sameInteraction)(s, warning) && $375f8776645d5aee$export$60d82a5be99a0a11[$375f8776645d5aee$export$a20f1db6dc818677(s?.severity)] >= rank);
};
// Maps abnormal clinical observations to rule engine condition strings.
//
// What comes out of here is sent with every interaction check as a condition
// the patient HAS, so a false one is not harmless: «liver_disease» turns a
// statin into a شدید contraindication and holds the visit at its end. Three
// ways this used to invent one:
//
//   1. Bare substrings. «f-AST-ing glucose» is AST, so a fasting glucose of 96
//      (> 45) became liver disease; «alt» hid in words the same way. Latin
//      names are matched as whole tokens now.
//   2. The wrong specimen or quantity. Urine creatinine (~100), creatinine
//      clearance (~90 mL/min) and the albumin/creatinine ratio all read as
//      «creatinine > 1.5»; urine potassium (20–100 mmol/L) as hyperkalaemia;
//      urine WBC per HPF as infection. Only a blood level is compared now. A
//      creatinine clearance is a filtration rate, so it is read as one (< 30).
//   3. Units. The thresholds are in mg/dL, % and ×10³/µL. A result reported in
//      µmol/L, mmol/L, mmol/mol or cells/µL is converted first: a creatinine of
//      80 µmol/L is a normal 0.9 mg/dL.
//
// Left as it was: a urine result whose name and unit both look like a blood
// test's (a bare «Glucose» row in mg/dL under a urinalysis heading) cannot be
// told apart here — observations carry no specimen field.
//
// i18n-exempt: the Persian names below are MATCHED against the display name an
// observation arrives with — wire data, not copy. Translating them would stop
// a Persian-reported creatinine or potassium from ever being recognised, and
// the rule engine would silently miss the condition. That is a clinical bug
// with no visible symptom, which is exactly why the marker is here.
// A Latin name as a whole token: not preceded or followed by a letter or digit.
// No lookbehind — older Safari cannot parse it, and the parse error would take
// the whole visit screen down with it.
const $375f8776645d5aee$var$labTerm = (...terms)=>new RegExp(`(?:^|[^a-z0-9])(?:${terms.join('|')})(?![a-z0-9])`);
// Persian has no case and no word-boundary class; its names are distinct enough
// to be matched as they are.
const $375f8776645d5aee$var$LAB_NAMES = {
    creatinine: [
        $375f8776645d5aee$var$labTerm('creatinine'),
        "\u06A9\u0631\u0627\u062A\u06CC\u0646\u06CC\u0646"
    ],
    gfr: [
        $375f8776645d5aee$var$labTerm('e?gfr', 'glomerular filtration')
    ],
    alt: [
        $375f8776645d5aee$var$labTerm('alt', 'sgpt', 'alanine aminotransferase', 'alanine transaminase')
    ],
    ast: [
        $375f8776645d5aee$var$labTerm('ast', 'sgot', 'aspartate aminotransferase', 'aspartate transaminase')
    ],
    glucose: [
        $375f8776645d5aee$var$labTerm('glucose', 'fbs'),
        "\u0642\u0646\u062F",
        "\u06AF\u0644\u0648\u06A9\u0632"
    ],
    a1c: [
        $375f8776645d5aee$var$labTerm('hba1c', 'a1c')
    ],
    potassium: [
        $375f8776645d5aee$var$labTerm('potassium'),
        "\u067E\u062A\u0627\u0633\u06CC\u0645"
    ],
    wbc: [
        $375f8776645d5aee$var$labTerm('wbc'),
        "\u06AF\u0644\u0628\u0648\u0644 \u0633\u0641\u06CC\u062F"
    ],
    qtc: [
        $375f8776645d5aee$var$labTerm('qtc', 'qt interval')
    ]
};
const $375f8776645d5aee$var$isLab = (name, key)=>$375f8776645d5aee$var$LAB_NAMES[key].some((p)=>typeof p === 'string' ? name.includes(p) : p.test(name));
// Not a blood level: another specimen, or a ratio of two analytes.
const $375f8776645d5aee$var$NOT_BLOOD_NAME = $375f8776645d5aee$var$labTerm('urin[a-z]*', 'u/a', 'csf', 'cerebrospinal', 'cerebral spinal', 'body fluid', 'pleural', 'peritoneal', 'ascitic', 'synovial', 'dialysate', 'stool', 'feces', 'faeces', 'ratio');
const $375f8776645d5aee$var$NOT_BLOOD_NAME_FA = [
    "\u0627\u062F\u0631\u0627\u0631",
    "\u0645\u0627\u06CC\u0639",
    "\u0646\u0633\u0628\u062A"
];
// «albumin/creatinine», «BUN/Cr…»: a ratio even when the word is not written.
const $375f8776645d5aee$var$CREATININE_RATIO = /\/\s*(?:creatinine|کراتینین)|(?:creatinine|کراتینین)\s*\//;
const $375f8776645d5aee$var$CLEARANCE = /clearance|کلیرانس/;
// Per microscope field (urine sediment) or per timed collection (24-h urine).
const $375f8776645d5aee$var$NOT_BLOOD_UNIT = /hpf|lpf|24h|\/24|\/day|\/d(?![a-z])/;
const $375f8776645d5aee$var$MICROMOL_PER_L = /(?:µ|μ|u|micro)mol\/l/;
const $375f8776645d5aee$var$MMOL_PER_L = /mmol\/l(?![a-z])/;
const $375f8776645d5aee$var$MMOL_PER_MOL = /mmol\/mol/;
function $375f8776645d5aee$export$5176433c16ff5a4(observations) {
    const inferred = new Set();
    for (const obs of observations || []){
        const name = String(obs?.display || obs?.code || '').toLowerCase();
        let val = parseFloat(obs?.value);
        if (!name || isNaN(val)) continue;
        const unit = String(obs?.unit || '').toLowerCase().replace(/\s+/g, '');
        const is = (key)=>$375f8776645d5aee$var$isLab(name, key);
        // A filtration rate, however it was derived — «eGFR … by Creatinine-based
        // formula» names creatinine but is not a creatinine level.
        if (is('gfr') || is('creatinine') && $375f8776645d5aee$var$CLEARANCE.test(name)) {
            if (val < 30) inferred.add('renal_failure');
            continue;
        }
        if ($375f8776645d5aee$var$CLEARANCE.test(name) || $375f8776645d5aee$var$NOT_BLOOD_NAME.test(name) || $375f8776645d5aee$var$NOT_BLOOD_NAME_FA.some((w)=>name.includes(w)) || $375f8776645d5aee$var$NOT_BLOOD_UNIT.test(unit)) continue;
        if (is('creatinine') && !$375f8776645d5aee$var$CREATININE_RATIO.test(name) && !/ml\/min/.test(unit)) {
            const mgPerDl = $375f8776645d5aee$var$MICROMOL_PER_L.test(unit) ? val / 88.4 : val;
            if (mgPerDl > 1.5) inferred.add('renal_failure');
        }
        if (is('alt') && val > 55) inferred.add('liver_disease');
        if (is('ast') && val > 45) inferred.add('liver_disease');
        if (is('glucose')) {
            const mgPerDl = $375f8776645d5aee$var$MMOL_PER_L.test(unit) ? val * 18 : val;
            if (mgPerDl > 200) inferred.add('diabetes');
        }
        if (is('a1c')) {
            // IFCC mmol/mol → NGSP %.
            const pct = $375f8776645d5aee$var$MMOL_PER_MOL.test(unit) ? val * 0.0915 + 2.15 : val;
            if (pct > 7.5) inferred.add('diabetes');
        }
        if (is('potassium') && val > 5.5) inferred.add('hyperkalemia');
        if (is('wbc')) {
            // A count in cells/µL (7500) rather than ×10³/µL (7.5). No count in
            // thousands per µL reaches 1000, so the size alone tells them apart.
            if (val >= 1000) val /= 1000;
            if (val > 12) inferred.add('systemic_infection');
        }
        if (is('qtc') && val > 450) inferred.add('qt_prolongation');
    }
    return [
        ...inferred
    ];
}
const $375f8776645d5aee$export$cb3932e7be74e021 = 3000;
function $375f8776645d5aee$export$ce13baf245686a19(transcript, consumedLen, overlap = 400) {
    const text = transcript || '';
    const marker = Number(consumedLen) || 0;
    const usable = marker > 0 && marker <= text.length;
    const start = usable ? Math.max(0, marker - overlap) : 0;
    return {
        window: text.slice(start).slice(-$375f8776645d5aee$export$cb3932e7be74e021),
        nextConsumed: text.length
    };
}
// ── Voice capture state, shared by both field-voice modals ───────────────────
// One hook so the two modals cannot drift on the part that is easy to get
// wrong: the recorder is started exactly once on open, the browser's own
// silence timeout is resumed by the hook (never by a status-watching effect
// here — that is what used to race the mount-time start and kill recording),
// and stop() is idempotent so confirm/close/unmount can all call it.
//
// `engine` is the doctor's «موتور تبدیل گفتار به متن» as resolved for dictation
// (lib/speechEngine.js `dictationEngine`): 'browser' drives the Web Speech API,
// 'parsina' / 'assistant' stream to the AI service. Both hooks are always
// CALLED — hooks may not be conditional — and only the chosen one is started.
// A server engine returns its words after the audio stops, which is why
// `finish()` is a promise and the sheets await it before committing.
function $375f8776645d5aee$var$useFieldVoiceCapture(engine = (0, $4s6k1.SPEECH_ENGINE_BROWSER)) {
    const server = (0, $4s6k1.isServerEngine)(engine);
    const browserVoice = (0, $dsmcB.useVoiceInput)({
        continuous: true,
        autoRestart: true
    });
    const serverVoice = (0, $aSWLO.useServerDictation)({
        engine: server ? engine : 'parsina'
    });
    const v = server ? serverVoice : browserVoice;
    const { status: status, transcript: transcript, errorDetail: errorDetail, start: start, stop: stop, reset: reset } = v;
    (0, $acw62.useEffect)(()=>{
        reset();
        start();
        // Closing the sheet abandons a server stream rather than waiting on it.
        return ()=>server ? serverVoice.cancel() : browserVoice.stop();
    }, []);
    return {
        engine: engine,
        isServer: server,
        servedEngine: server ? serverVoice.servedEngine : null,
        transcript: transcript,
        errorDetail: errorDetail,
        stop: stop,
        // The whole transcript, once there is no more to come.
        finish: server ? serverVoice.finish : async ()=>{
            stop();
            return transcript || '';
        },
        retry: ()=>{
            reset();
            start();
        },
        resume: start,
        isListening: status === 'listening',
        isTranscribing: status === 'transcribing',
        isDenied: status === 'denied',
        isUnsup: status === 'unsupported',
        // 'error' used to fall through to the listening UI, so a missing mic or a
        // dropped network looked exactly like a doctor who had not spoken yet.
        isError: status === 'denied' || status === 'unsupported' || status === 'error'
    };
}
// Which engine is listening, under the microphone. Says so plainly when the
// doctor asked for Parsina STT and the service answered with the assistant.
function $375f8776645d5aee$var$VoiceEngineNote({ v: v }) {
    const { t: t } = (0, $LNQP4.default)();
    const fellBack = v.isServer && v.servedEngine && v.servedEngine !== v.engine;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "voice-engine",
        "data-engine": v.servedEngine || v.engine,
        style: {
            fontSize: '0.65625rem',
            color: fellBack ? 'var(--warn-ink, #8a5a00)' : 'var(--mute)',
            textAlign: 'center',
            marginBottom: 8,
            lineHeight: 1.6
        }
    }, t('visit.voice.engineLabel', {
        engine: t(`visit.voice.engines.${v.servedEngine || v.engine}`)
    }), fellBack && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, " \u2014 ", t('visit.voice.engineFellBack')), v.isServer && !fellBack && !v.isError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, t('visit.voice.serverHint')));
}
// The recording indicator + stop/resume control, identical in both modals.
function $375f8776645d5aee$var$VoiceRecordingControl({ isListening: isListening, onStop: onStop, onResume: onResume, isTranscribing: isTranscribing = false }) {
    const { t: t } = (0, $LNQP4.default)();
    if (isTranscribing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "voice-transcribing",
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 6,
            marginBottom: 8,
            fontSize: '0.6875rem',
            color: 'var(--mute)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: 11,
            height: 11,
            border: '2px solid var(--accent)',
            borderTopColor: 'transparent',
            borderRadius: '50%',
            animation: 'spin .7s linear infinite'
        }
    }), t('visit.voice.transcribing'));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 8,
            marginBottom: 8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 5,
            fontSize: '0.6875rem',
            color: isListening ? 'var(--danger)' : 'var(--mute)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: 7,
            height: 7,
            borderRadius: '50%',
            background: isListening ? 'var(--danger)' : 'var(--mute-2)',
            animation: isListening ? 'pulse 1.6s infinite' : 'none'
        }
    }), isListening ? t('visit.voice.recording') : t('visit.voice.paused')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        "data-testid": "voice-toggle",
        onClick: ()=>isListening ? onStop() : onResume(),
        style: {
            padding: '4px 10px',
            borderRadius: 999,
            fontSize: '0.6875rem',
            fontWeight: 600,
            border: '1px solid var(--line)',
            background: 'var(--panel-2)',
            color: 'var(--ink-2)',
            cursor: 'pointer',
            fontFamily: 'inherit'
        }
    }, isListening ? t('visit.voice.stop') : t('visit.voice.resume')));
}
function $375f8776645d5aee$export$82f3f43056418bdf({ fieldLabel: fieldLabel, onClose: onClose, onResult: onResult, engine: engine = (0, $4s6k1.SPEECH_ENGINE_BROWSER) }) {
    const { t: t } = (0, $LNQP4.default)();
    const v = $375f8776645d5aee$var$useFieldVoiceCapture(engine);
    const { transcript: transcript, errorDetail: errorDetail, isListening: isListening, isDenied: isDenied, isUnsup: isUnsup, isError: isError } = v;
    (0, $acw62.useEffect)(()=>{
        const h = (e)=>{
            if (e.key === 'Escape') onClose();
        };
        document.addEventListener('keydown', h);
        return ()=>document.removeEventListener('keydown', h);
    }, []);
    const commit = (text)=>{
        const value = (text || '').trim();
        if (value) onResult(value);
        else onClose();
    };
    // The browser engine already holds its words; a server engine sends them
    // after the audio stops, so «تأیید» waits for the final pass.
    const handleConfirm = ()=>{
        if (v.isServer) {
            v.finish().then(commit);
            return;
        }
        v.stop();
        commit(transcript);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "v-voice-scrim",
        onClick: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", null, $375f8776645d5aee$export$5d26717df14e8026), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "v-fvoice",
        onClick: (e)=>e.stopPropagation()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: "v-fvoice-close",
        onClick: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($375f8776645d5aee$export$9bb611d729802a56.x, {
        width: 14,
        height: 14
    })), isError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 56,
            height: 56,
            borderRadius: '50%',
            margin: '4px auto 14px',
            display: 'grid',
            placeItems: 'center',
            background: 'var(--danger-soft)',
            color: 'var(--danger)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($375f8776645d5aee$export$9bb611d729802a56.mic, {
        width: 24,
        height: 24
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.8125rem',
            fontWeight: 700,
            color: 'var(--ink)',
            marginBottom: 6
        }
    }, isDenied ? t('visit.voice.denied') : isUnsup ? t('visit.voice.unsupported') : t('visit.voice.failed')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($375f8776645d5aee$var$VoiceEngineNote, {
        v: v
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.75rem',
            color: 'var(--mute)',
            lineHeight: 1.7,
            marginBottom: 14
        }
    }, isDenied ? t('visit.voice.deniedHint') : isUnsup ? t(v.isServer ? 'visit.voice.recordingUnsupported' : 'visit.voice.unsupportedHint') : errorDetail || t('visit.voice.micError')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 8,
            justifyContent: 'center'
        }
    }, !isUnsup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: v.retry,
        style: {
            padding: '7px 14px',
            borderRadius: 8,
            border: 'none',
            background: 'var(--accent)',
            color: '#fff',
            fontWeight: 600,
            fontSize: '0.75rem',
            cursor: 'pointer',
            fontFamily: 'inherit'
        },
        "data-testid": "voice-retry"
    }, t('common.actions.retry')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: onClose,
        style: {
            padding: '7px 14px',
            borderRadius: 8,
            border: '1px solid var(--line)',
            background: 'var(--panel-2)',
            color: 'var(--mute)',
            fontWeight: 600,
            fontSize: '0.75rem',
            cursor: 'pointer',
            fontFamily: 'inherit'
        },
        "data-testid": "voice-close"
    }, t('common.actions.close')))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "v-mic-wrap"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "v-mic-ring r1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "v-mic-ring r2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "v-mic"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($375f8776645d5aee$export$9bb611d729802a56.mic, {
        width: 22,
        height: 22
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.8125rem',
            fontWeight: 700,
            color: 'var(--ink)',
            marginBottom: 2
        }
    }, t('visit.voice.sayField', {
        field: fieldLabel
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($375f8776645d5aee$var$VoiceEngineNote, {
        v: v
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($375f8776645d5aee$var$VoiceRecordingControl, {
        isListening: isListening,
        isTranscribing: v.isTranscribing,
        onStop: v.stop,
        onResume: v.resume
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "v-wave"
    }, Array.from({
        length: 9
    }).map((_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            key: i,
            style: {
                animationDelay: i * 0.09 + 's',
                height: isListening ? undefined : 8,
                background: isListening ? 'var(--danger)' : 'var(--line)',
                animation: isListening ? undefined : 'none'
            }
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "v-transcript",
        dir: "auto"
    }, transcript || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: 'var(--mute-2)'
        }
    }, t('visit.voice.listening'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: "v-confirm-btn",
        "data-testid": "voice-confirm",
        onClick: handleConfirm
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($375f8776645d5aee$export$9bb611d729802a56.check, {
        width: 14,
        height: 14
    }), " ", t('visit.voice.confirmAdd')))));
}
function $375f8776645d5aee$export$50bc53bed8a43ae3({ fieldKey: fieldKey, fieldLabel: fieldLabel, onClose: onClose, onResult: onResult, engine: engine = (0, $4s6k1.SPEECH_ENGINE_BROWSER), submit: submit, hint: hint, testid: testid }) {
    const { t: t } = (0, $LNQP4.default)();
    const v = $375f8776645d5aee$var$useFieldVoiceCapture(engine);
    const { transcript: transcript, errorDetail: errorDetail, isListening: isListening, isDenied: isDenied, isUnsup: isUnsup, isError: isError } = v;
    const [processing, setProcessing] = (0, $acw62.useState)(false);
    const [manualInput, setManualInput] = (0, $acw62.useState)('');
    // Whether the doctor TYPED in the box. A server engine's words arrive after
    // «تأیید»; they are what gets committed unless the doctor wrote their own.
    const editedRef = (0, $acw62.useRef)(false);
    // §C.3 rule 1 — a full-screen overlay joins the history stack, so the
    // platform back closes the dictation instead of leaving the visit with a
    // microphone open over another screen. Dismissing loses only an
    // un-confirmed transcript, which is what Escape and the ✕ already do.
    (0, $9BgRG.default)(true, onClose, {
        id: 'soap-field-voice'
    });
    (0, $acw62.useEffect)(()=>{
        const h = (e)=>{
            if (e.key === 'Escape') onClose();
        };
        document.addEventListener('keydown', h);
        return ()=>document.removeEventListener('keydown', h);
    }, []);
    // Sync voice transcript into the editable area (only if user hasn't cleared it)
    (0, $acw62.useEffect)(()=>{
        if (transcript) setManualInput(transcript);
    }, [
        transcript
    ]);
    const handleConfirm = async ()=>{
        let raw = manualInput.trim();
        if (v.isServer) {
            // Nothing may be in the box yet: a server engine's words arrive after
            // the audio stops. What it heard is committed unless the doctor typed.
            setProcessing(true);
            const heard = (await v.finish() || '').trim();
            if (!editedRef.current && heard) raw = heard;
        } else v.stop();
        if (!raw) {
            onClose();
            return;
        }
        setProcessing(true);
        if (submit) {
            try {
                await submit(raw);
            } finally{
                onResult(raw);
            }
            return;
        }
        try {
            const data = await (0, $eVM84.bffMutation)($375f8776645d5aee$export$a98b585598d708d2, {
                transcript: raw,
                field: fieldKey
            });
            onResult(data?.parseSoapVoiceField || raw);
        } catch  {
            onResult(raw);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "v-voice-scrim",
        onClick: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", null, $375f8776645d5aee$export$5d26717df14e8026), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "v-fvoice",
        "data-testid": testid,
        onClick: (e)=>e.stopPropagation()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: "v-fvoice-close",
        onClick: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($375f8776645d5aee$export$9bb611d729802a56.x, {
        width: 14,
        height: 14
    })), isError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 56,
            height: 56,
            borderRadius: '50%',
            margin: '4px auto 14px',
            display: 'grid',
            placeItems: 'center',
            background: 'var(--danger-soft)',
            color: 'var(--danger)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($375f8776645d5aee$export$9bb611d729802a56.mic, {
        width: 24,
        height: 24
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.8125rem',
            fontWeight: 700,
            color: 'var(--ink)',
            marginBottom: 6
        }
    }, isUnsup ? t('visit.voice.unsupported') : isDenied ? t('visit.voice.permissionNeeded') : t('visit.voice.failed')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($375f8776645d5aee$var$VoiceEngineNote, {
        v: v
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.6875rem',
            color: 'var(--mute)',
            textAlign: 'center',
            marginBottom: 14
        }
    }, isUnsup ? t(v.isServer ? 'visit.voice.recordingUnsupported' : 'visit.voice.useChrome') : isDenied ? t('visit.voice.enableInSettings') : errorDetail || t('visit.voice.micError')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("textarea", {
        "data-testid": "voice-input",
        placeholder: t('visit.voice.typeInstead'),
        value: manualInput,
        onChange: (e)=>{
            editedRef.current = true;
            setManualInput(e.target.value);
        },
        rows: 3,
        style: {
            width: '100%',
            padding: '8px 12px',
            borderRadius: 10,
            border: '1px solid var(--line)',
            background: '#fff',
            fontSize: '0.8125rem',
            lineHeight: 1.7,
            fontFamily: 'inherit',
            resize: 'none',
            outline: 'none',
            color: 'var(--ink)',
            boxSizing: 'border-box'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 8,
            justifyContent: 'center',
            marginTop: 10
        }
    }, !isUnsup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: v.retry,
        style: {
            padding: '7px 14px',
            borderRadius: 8,
            border: 'none',
            background: 'var(--accent)',
            color: '#fff',
            fontWeight: 600,
            fontSize: '0.75rem',
            cursor: 'pointer',
            fontFamily: 'inherit'
        },
        "data-testid": "voice-retry"
    }, t('common.actions.retry')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: "v-confirm-btn",
        "data-testid": "voice-confirm",
        style: {
            margin: 0
        },
        onClick: handleConfirm,
        disabled: !manualInput.trim()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($375f8776645d5aee$export$9bb611d729802a56.check, {
        width: 14,
        height: 14
    }), " ", t('visit.voice.confirmAdd')))) : processing ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 56,
            height: 56,
            borderRadius: '50%',
            margin: '4px auto 14px',
            display: 'grid',
            placeItems: 'center',
            background: 'var(--accent-soft)',
            color: 'var(--accent)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 22,
            height: 22,
            border: '3px solid var(--accent)',
            borderTopColor: 'transparent',
            borderRadius: '50%',
            animation: 'spin .7s linear infinite'
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.75rem',
            color: 'var(--mute)',
            textAlign: 'center'
        }
    }, t('visit.voice.processing'))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.6875rem',
            color: 'var(--mute)',
            textAlign: 'center',
            marginBottom: hint ? 4 : 10
        }
    }, fieldLabel), hint && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.6875rem',
            color: 'var(--mute-2)',
            textAlign: 'center',
            lineHeight: 1.7,
            marginBottom: 10
        }
    }, hint), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 56,
            height: 56,
            borderRadius: '50%',
            margin: '0 auto 14px',
            display: 'grid',
            placeItems: 'center',
            background: isListening ? 'var(--danger-soft)' : 'var(--accent-soft)',
            color: isListening ? 'var(--danger)' : 'var(--accent)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($375f8776645d5aee$export$9bb611d729802a56.mic, {
        width: 24,
        height: 24
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($375f8776645d5aee$var$VoiceEngineNote, {
        v: v
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($375f8776645d5aee$var$VoiceRecordingControl, {
        isListening: isListening,
        isTranscribing: v.isTranscribing,
        onStop: v.stop,
        onResume: v.resume
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "v-wavebars",
        style: {
            marginBottom: 12
        }
    }, Array.from({
        length: 9
    }).map((_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            key: i,
            style: {
                animationDelay: i * 0.09 + 's',
                height: isListening ? undefined : 8,
                background: isListening ? 'var(--danger)' : 'var(--line)',
                animation: isListening ? undefined : 'none'
            }
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "v-transcript",
        dir: "auto"
    }, transcript || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: 'var(--mute-2)'
        }
    }, t('visit.voice.listening'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("textarea", {
        "data-testid": "voice-input",
        placeholder: t('visit.voice.editOrType'),
        value: manualInput,
        onChange: (e)=>{
            editedRef.current = true;
            setManualInput(e.target.value);
        },
        rows: 3,
        style: {
            width: '100%',
            marginTop: 8,
            padding: '8px 12px',
            borderRadius: 10,
            border: '1px solid var(--line)',
            background: '#fff',
            fontSize: '0.8125rem',
            lineHeight: 1.7,
            fontFamily: 'inherit',
            resize: 'none',
            outline: 'none',
            color: 'var(--ink)',
            boxSizing: 'border-box',
            transition: 'border-color .12s'
        },
        onFocus: (e)=>{
            e.target.style.borderColor = 'var(--accent)';
        },
        onBlur: (e)=>{
            e.target.style.borderColor = 'var(--line)';
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: "v-confirm-btn",
        "data-testid": "voice-confirm",
        onClick: handleConfirm,
        disabled: !manualInput.trim() && !v.isServer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($375f8776645d5aee$export$9bb611d729802a56.check, {
        width: 14,
        height: 14
    }), " ", t('visit.voice.confirmAdd')))));
}
// ─────────────────────────────────────────────────────────────────────────────
// Printed prescription — ONE document for both surfaces
// ─────────────────────────────────────────────────────────────────────────────
// These builders used to live inside Visit.web.jsx, which meant the phone had
// no way to print at all. They are the legal Persian sheet a pharmacy, insurer
// and the medical council read, so there must be exactly one of them: desktop
// (PrescriptionPrintModal) and the mobile closure flow both render from here.
// ── Prescription template helpers ────────────────────────────────────────────
// ── The printed prescription is a Persian legal document ────────────────────
// Everything from here to `buildRxHTML` builds paper, not UI. Two reasons it
// stays Persian whatever language the doctor's panel is in:
//
//   • The `.replace(/نام بیمار:…/)` matchers run against template CONTENT that
//     templatemanagement stores in Persian. Translating a matcher would stop it
//     matching, and the printed sheet would silently keep the blank dot-lines
//     instead of the patient's details — the same failure class as translating
//     a lab-name matcher.
//   • An Iranian pharmacy, insurer and the medical council all read this sheet.
//     A prescription rendered in English is not a document anyone downstream
//     can act on.
//
// This warning was written BEFORE the i18n migration and the migration ignored
// it: every matcher below was rewritten to `t('visit.print.…')`, so on an
// English or Arabic panel `tr.startsWith('Patient:')` never matched the stored
// Persian «نام بیمار:» line and the whole sheet printed as unfilled dot-lines —
// no name, age, sex, phone, date, file number, diagnosis, follow-up or council
// number. They are back to Persian literals and must stay that way. A `t` is
// still threaded in from the callers (the signatures are shared with the UI
// side) but nothing below may use it: this is paper, not panel.
//
// i18n-exempt: printed-document builders — see above.
// Persian digits, fixed — NOT the panel's. `formatDigits` follows the doctor's UI
// language and would put Latin or Arabic-Indic digits on the paper; this is the same
// rule, and the same reason, as the `today` stamp in `printPrescription` below.
// Written as a code-point offset rather than a literal `'۰۱۲۳۴۵۶۷۸۹'` so a later editor
// cannot break it invisibly.
// i18n-exempt: printed-document digits — see the note above.
const $375f8776645d5aee$var$faDigits = (value)=>String(value ?? '').replace(/[0-9]/g, (d)=>String.fromCharCode(0x06f0 + Number(d)));
function $375f8776645d5aee$export$d0669af8f70abe11(raw) {
    return $375f8776645d5aee$var$faDigits((0, $5AX1S).forDisplay(raw));
}
function $375f8776645d5aee$export$4cf11838cdc2a8a8(s) {
    return (s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
// The sheet's footer — Persian in every panel language like everything else on
// the paper, and the BRAND's (ui/lib/brand.js): its Persian name, or its own
// Persian wording for `visit.rx.generatedBy` — the key the on-screen preview of
// this sheet reads — so paper and preview never name two products. With no
// brand configured this is the sentence the sheet always printed.
// i18n-exempt: printed-document builder — see the note above `escapeHtml`.
const $375f8776645d5aee$var$PRINT_FOOTER_FA = "\u0646\u0633\u062E\u0647 \u062A\u0648\u0644\u06CC\u062F\u0634\u062F\u0647 \u062A\u0648\u0633\u0637 \u062F\u0633\u062A\u06CC\u0627\u0631 \u0647\u0648\u0634\u0645\u0646\u062F {{brand}}";
function $375f8776645d5aee$export$49f892522e84db92() {
    const own = (0, $eLeza.brandString)('fa', 'visit.rx.generatedBy');
    return $375f8776645d5aee$export$4cf11838cdc2a8a8((0, $eLeza.applyBrandTokens)(typeof own === 'string' ? own : $375f8776645d5aee$var$PRINT_FOOTER_FA, 'fa'));
}
function $375f8776645d5aee$export$1512fb0c882aac98(content, { rxItems: rxItems, pendingTests: pendingTests, diagnosis: diagnosis, soap: soap, doctor: doctor, patient: patient, today: today, t: t }) {
    const lines = (content || '').split('\n');
    const result = [];
    let i = 0;
    while(i < lines.length){
        const line = lines[i];
        const tr = line.trim();
        // Patient name / age / gender row
        if (tr.startsWith("\u0646\u0627\u0645 \u0628\u06CC\u0645\u0627\u0631:")) {
            result.push(line.replace(/نام بیمار:\s*\.{2,}/, `\u{646}\u{627}\u{645} \u{628}\u{6CC}\u{645}\u{627}\u{631}: ${patient?.name || ''}`).replace(/سن:\s*\.{2,}/, "\u0633\u0646: ").replace(/جنس:\s*\.{2,}/, "\u062C\u0646\u0633: "));
            i++;
            continue;
        }
        // Phone / date / file-number row
        if (tr.startsWith("\u0634\u0645\u0627\u0631\u0647 \u062A\u0645\u0627\u0633:")) {
            result.push(line.replace(/شماره تماس:\s*\.{2,}/, `\u{634}\u{645}\u{627}\u{631}\u{647} \u{62A}\u{645}\u{627}\u{633}: ${$375f8776645d5aee$export$d0669af8f70abe11(patient?.phone)}`).replace(/تاریخ:\s*\.{2,}/, `\u{62A}\u{627}\u{631}\u{6CC}\u{62E}: ${today}`).replace(/شماره پرونده:\s*\.{2,}/, "\u0634\u0645\u0627\u0631\u0647 \u067E\u0631\u0648\u0646\u062F\u0647: "));
            i++;
            continue;
        }
        // Diagnosis header — fill blank dot-lines that follow
        if (tr === "\u062A\u0634\u062E\u06CC\u0635:") {
            result.push(line);
            i++;
            while(i < lines.length && lines[i].trim().match(/^\.+$/))i++;
            result.push(soap?.a || diagnosis || '');
            result.push('');
            continue;
        }
        // Rx header — replace all numbered drug slots with actual rxItems
        if (tr === 'Rx:') {
            result.push(line);
            result.push('');
            (rxItems || []).forEach((item, idx)=>{
                const name = (0, $g6gAc.drugDisplayName)(item.drug) || item.name || '';
                result.push(`${idx + 1}. ${name}`);
                result.push(`   \u{62F}\u{648}\u{632} \u{648} \u{634}\u{6A9}\u{644} \u{62F}\u{627}\u{631}\u{648}\u{6CC}\u{6CC}: ${item.dosage || ''}`);
                // «نحوه مصرف» used to be filled with the FREQUENCY, which is a different
                // thing and left the real route off the paper entirely. Now that the item
                // carries a route, each label gets its own field.
                result.push(`   \u{62A}\u{646}\u{627}\u{648}\u{628} \u{645}\u{635}\u{631}\u{641}: ${item.frequency || ''}`);
                result.push(`   \u{646}\u{62D}\u{648}\u{647} \u{645}\u{635}\u{631}\u{641}: ${item.route || ''}`);
                result.push(`   \u{645}\u{62F}\u{62A} \u{645}\u{635}\u{631}\u{641}: ${item.duration || ''}`);
                if (item.quantity) result.push(`   \u{645}\u{642}\u{62F}\u{627}\u{631} \u{62A}\u{62D}\u{648}\u{6CC}\u{644}\u{6CC}: ${item.quantity}`);
                if (item.instructions) result.push(`   \u{62F}\u{633}\u{62A}\u{648}\u{631} \u{645}\u{635}\u{631}\u{641}: ${item.instructions}`);
                result.push('');
            });
            // Skip template drug-slot lines (numbered items, their sub-lines, and blank separators)
            i++;
            while(i < lines.length){
                const nl = lines[i].trim();
                if (nl.match(/^[۱۲۳۴۵۶۷۸۹0-9]\./) || nl.startsWith("\u062F\u0648\u0632") || nl.startsWith("\u0646\u062D\u0648\u0647 \u0645\u0635\u0631\u0641") || nl.startsWith("\u062A\u0639\u062F\u0627\u062F:") || nl.startsWith("\u0645\u062F\u062A \u0645\u0635\u0631\u0641:") || nl === '') i++;
                else break;
            }
            continue;
        }
        // Non-drug instructions — replace bullet dot-lines with actual soap.p
        if (tr === "\u062A\u0648\u0635\u06CC\u0647\u200C\u0647\u0627\u06CC \u063A\u06CC\u0631 \u062F\u0627\u0631\u0648\u06CC\u06CC:") {
            result.push(line);
            const instr = soap?.p || '';
            i++;
            while(i < lines.length && lines[i].trim().startsWith("\u2022"))i++;
            if (instr) result.push(instr);
            else result.push("\u2022 ");
            continue;
        }
        // Follow-up line
        if (tr.startsWith("\u067E\u06CC\u06AF\u06CC\u0631\u06CC:")) {
            result.push(line.replace(/پیگیری:\s*\.{5,}/, "\u067E\u06CC\u06AF\u06CC\u0631\u06CC: "));
            i++;
            continue;
        }
        // Doctor info lines
        if (tr.startsWith("\u0646\u0627\u0645 \u067E\u0632\u0634\u06A9:")) {
            result.push(line.replace(/نام پزشک:\s*\.{5,}/, `\u{646}\u{627}\u{645} \u{67E}\u{632}\u{634}\u{6A9}: \u{62F}\u{6A9}\u{62A}\u{631} ${doctor?.name || ''}`));
            i++;
            continue;
        }
        if (tr.startsWith("\u062A\u062E\u0635\u0635:")) {
            result.push(line.replace(/تخصص:\s*\.{5,}/, `\u{62A}\u{62E}\u{635}\u{635}: ${doctor?.specialty || ''}`));
            i++;
            continue;
        }
        if (tr.startsWith("\u0634\u0645\u0627\u0631\u0647 \u0646\u0638\u0627\u0645:")) {
            result.push(line.replace(/شماره نظام:\s*\.{5,}/, `\u{634}\u{645}\u{627}\u{631}\u{647} \u{646}\u{638}\u{627}\u{645}: ${doctor?.medicalCode || ''}`));
            i++;
            continue;
        }
        result.push(line);
        i++;
    }
    // Append test/imaging orders if not already covered by the template
    const labOrders = (pendingTests || []).filter((test)=>!test.type || test.type === 'lab');
    const imgOrders = (pendingTests || []).filter((test)=>test.type === 'imaging');
    if (labOrders.length + imgOrders.length > 0) {
        result.push('');
        result.push("\u062F\u0631\u062E\u0648\u0627\u0633\u062A\u200C\u0647\u0627\u06CC \u0628\u0627\u0644\u06CC\u0646\u06CC:");
        labOrders.forEach((order)=>{
            const urg = order.urgency === 'urgent' || order.urgency === 'stat' ? " [\u0627\u0648\u0631\u0698\u0627\u0646\u0633\u06CC]" : '';
            result.push(`\u{2022} \u{622}\u{632}\u{645}\u{627}\u{6CC}\u{634}: ${order.name || order.testName || ''}${urg}`);
        });
        imgOrders.forEach((order)=>{
            const urg = order.urgency === 'urgent' || order.urgency === 'stat' ? " [\u0627\u0648\u0631\u0698\u0627\u0646\u0633\u06CC]" : '';
            result.push(`\u{2022} \u{62A}\u{635}\u{648}\u{6CC}\u{631}\u{628}\u{631}\u{62F}\u{627}\u{631}\u{6CC}: ${order.name || order.testName || ''}${urg}`);
        });
    }
    return result.join('\n');
}
function $375f8776645d5aee$export$fd7ee5a010036e9e({ template: template, rxItems: rxItems, pendingTests: pendingTests, diagnosis: diagnosis, soap: soap, doctor: doctor, patient: patient, today: today, t: t }) {
    const filled = $375f8776645d5aee$export$1512fb0c882aac98(template.content, {
        t: t,
        rxItems: rxItems,
        pendingTests: pendingTests,
        diagnosis: diagnosis,
        soap: soap,
        doctor: doctor,
        patient: patient,
        today: today
    });
    return `<!DOCTYPE html><html dir="rtl" lang="fa"><head><meta charset="UTF-8">
<title>\u{646}\u{633}\u{62E}\u{647} \u{67E}\u{632}\u{634}\u{6A9}\u{6CC} - ${$375f8776645d5aee$export$4cf11838cdc2a8a8(patient?.name || '')}</title>
<style>
*{box-sizing:border-box;margin:0;padding:0}
body{font-family:Tahoma,Arial,sans-serif;direction:rtl;background:#fff;color:#222}
.page{width:148mm;min-height:210mm;margin:0 auto;padding:10mm 12mm;border:1px solid #ccc}
@media print{body{margin:0}.page{border:none;width:100%;padding:8mm}@page{size:A5;margin:5mm}}
pre{white-space:pre-wrap;font-family:Tahoma,Arial,sans-serif;font-size:0.78125rem;line-height:1.9;color:#222}
.foot{font-size:0.5625rem;color:#ccc;text-align:center;margin-top:20px;padding-top:8px;border-top:1px solid #eee}
</style></head><body>
<div class="page">
<pre>${$375f8776645d5aee$export$4cf11838cdc2a8a8(filled)}</pre>
<div class="foot">${$375f8776645d5aee$export$49f892522e84db92()}</div>
</div></body></html>`;
}
function $375f8776645d5aee$export$2429942a486a55fe({ rxItems: rxItems, pendingTests: pendingTests, diagnosis: diagnosis, soap: soap, doctor: doctor, patient: patient, today: today, t: t }) {
    const dxText = soap?.a || diagnosis || '';
    const instructions = soap?.p || '';
    const labOrders = (pendingTests || []).filter((test)=>!test.type || test.type === 'lab');
    const imgOrders = (pendingTests || []).filter((test)=>test.type === 'imaging');
    const drugRows = (rxItems || []).map((item, idx)=>`
    <div class="drug-item">
      <div class="drug-num">${idx + 1}</div>
      <div>
        <div class="drug-name" dir="auto">${$375f8776645d5aee$export$4cf11838cdc2a8a8((0, $g6gAc.drugDisplayName)(item.drug) || item.name || '')}</div>
        <div class="drug-detail">${[
            item.dosage,
            item.route,
            item.frequency,
            item.duration ? `\u{628}\u{647} \u{645}\u{62F}\u{62A} ${item.duration}` : '',
            item.quantity
        ].filter(Boolean).join(" \xb7 ")}</div>
        ${item.instructions ? `<div class="drug-detail">${item.instructions}</div>` : ''}
      </div>
    </div>`).join('');
    const labRows = labOrders.map((order)=>`
    <div class="order-item">
      <span class="order-badge lab">\u{622}\u{632}\u{645}\u{627}\u{6CC}\u{634}\u{6AF}\u{627}\u{647}</span>
      ${order.urgency === 'urgent' || order.urgency === 'stat' ? '<span class="order-badge urgent">\u0627\u0648\u0631\u0698\u0627\u0646\u0633\u06CC</span>' : ''}
      <span class="order-name">${order.name || order.testName || ''}</span>
    </div>`).join('');
    const imgRows = imgOrders.map((order)=>`
    <div class="order-item">
      <span class="order-badge imaging">\u{62A}\u{635}\u{648}\u{6CC}\u{631}\u{628}\u{631}\u{62F}\u{627}\u{631}\u{6CC}</span>
      ${order.urgency === 'urgent' || order.urgency === 'stat' ? '<span class="order-badge urgent">\u0627\u0648\u0631\u0698\u0627\u0646\u0633\u06CC</span>' : ''}
      <span class="order-name">${order.name || order.testName || ''}</span>
    </div>`).join('');
    return `<!DOCTYPE html>
<html dir="rtl" lang="fa">
<head>
<meta charset="UTF-8">
<title>\u{646}\u{633}\u{62E}\u{647} \u{67E}\u{632}\u{634}\u{6A9}\u{6CC} - ${patient?.name || ''}</title>
<style>
*{box-sizing:border-box;margin:0;padding:0}
body{font-family:Tahoma,Arial,sans-serif;direction:rtl;background:#fff;color:#222;font-size:0.75rem}
.page{width:148mm;min-height:210mm;margin:0 auto;padding:8mm 10mm;border:1px solid #ccc}
@media print{body{margin:0}.page{border:none;width:100%;padding:8mm}@page{size:A5;margin:5mm}}
.hdr{border-bottom:2.5px solid #1B4E6B;padding-bottom:10px;margin-bottom:12px;display:flex;justify-content:space-between;align-items:flex-start}
.dr-name{font-size:1.125rem;font-weight:900;color:#1B4E6B}
.dr-meta{font-size:0.6875rem;color:#555;margin-top:3px}
.date-box{font-size:0.6875rem;color:#555;text-align:center;border:1px solid #ddd;padding:5px 10px;border-radius:4px}
.date-val{font-weight:700;color:#333;margin-bottom:2px}
.date-lbl{font-size:0.625rem;color:#aaa}
.patient-row{background:#f0f6fb;border-radius:0px;padding:7px 12px;margin-bottom:12px;display:flex;gap:24px}
.pt-label{font-size:0.625rem;color:#888;margin-bottom:1px}
.pt-val{font-weight:700;color:#1B4E6B}
.sec-title{display:flex;align-items:center;gap:8px;margin:10px 0 6px;font-size:0.6875rem;font-weight:700;color:#1B4E6B}
.sec-line{flex:1;height:1px;background:#e5e7eb}
.dx-box{background:#fff8e7;border-right:3px solid #F59E0B;padding:7px 12px;border-radius:4px;font-size:0.78125rem;margin-bottom:10px}
.drug-item{display:flex;gap:10px;margin-bottom:10px;padding-bottom:10px;border-bottom:1px dashed #eee;align-items:flex-start}
.drug-num{width:22px;height:22px;border-radius:50%;background:#1B4E6B;color:#fff;font-size:0.6875rem;font-weight:700;text-align:center;line-height:22px;flex-shrink:0;margin-top:1px}
.drug-name{font-weight:700;font-size:0.8125rem;color:#111}
.drug-detail{font-size:0.6875rem;color:#666;margin-top:2px}
.order-item{display:flex;gap:6px;margin-bottom:5px;align-items:center}
.order-badge{font-size:0.625rem;padding:1px 7px;border-radius:0px;font-weight:600}
.lab{background:#dbeafe;color:#1d4ed8}
.imaging{background:#fce7f3;color:#9d174d}
.urgent{background:#fee2e2;color:#991b1b}
.order-name{font-size:0.75rem;color:#333}
.instr-box{border:1px dashed #ccc;border-radius:0px;padding:8px 12px;font-size:0.71875rem;color:#333;line-height:1.8;white-space:pre-wrap;min-height:48px;margin-bottom:10px}
.sig-area{display:flex;justify-content:space-between;align-items:flex-end;padding-top:12px;border-top:1px solid #e5e7eb;margin-top:20px}
.sig-block{text-align:center}
.sig-line{width:90px;border-bottom:1px solid #999;margin-bottom:4px;height:32px}
.sig-lbl{font-size:0.625rem;color:#888}
.footer-note{font-size:0.5625rem;color:#ccc}
</style>
</head>
<body>
<div class="page">
  <div class="hdr">
    <div>
      <div class="dr-name">\u{62F}\u{6A9}\u{62A}\u{631} ${doctor?.name || "\u2014"}</div>
      ${doctor?.specialty ? `<div class="dr-meta">\u{645}\u{62A}\u{62E}\u{635}\u{635} ${doctor.specialty}</div>` : ''}
      ${doctor?.medicalCode ? `<div class="dr-meta">\u{6A9}\u{62F} \u{646}\u{638}\u{627}\u{645} \u{67E}\u{632}\u{634}\u{6A9}\u{6CC}: ${doctor.medicalCode}</div>` : ''}
    </div>
    <div class="date-box">
      <div class="date-val">${today}</div>
      <div class="date-lbl">\u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{646}\u{633}\u{62E}\u{647}</div>
    </div>
  </div>
  <div class="patient-row">
    <div><div class="pt-label">\u{646}\u{627}\u{645} \u{628}\u{6CC}\u{645}\u{627}\u{631}</div><div class="pt-val">${patient?.name || "\u2014"}</div></div>
    ${patient?.nationalId ? `<div><div class="pt-label">\u{6A9}\u{62F} \u{645}\u{644}\u{6CC}</div><div class="pt-val" style="color:#333">${patient.nationalId}</div></div>` : ''}
  </div>
  ${dxText ? `<div class="sec-title">\u{62A}\u{634}\u{62E}\u{6CC}\u{635} <div class="sec-line"></div></div><div class="dx-box">${dxText}</div>` : ''}
  ${(rxItems || []).length > 0 ? `<div class="sec-title">\u{62F}\u{627}\u{631}\u{648}\u{647}\u{627} <div class="sec-line"></div></div>${drugRows}` : ''}
  ${labOrders.length > 0 ? `<div class="sec-title">\u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A} \u{622}\u{632}\u{645}\u{627}\u{6CC}\u{634} <div class="sec-line"></div></div>${labRows}` : ''}
  ${imgOrders.length > 0 ? `<div class="sec-title">\u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A} \u{62A}\u{635}\u{648}\u{6CC}\u{631}\u{628}\u{631}\u{62F}\u{627}\u{631}\u{6CC} <div class="sec-line"></div></div>${imgRows}` : ''}
  <div class="sec-title">\u{62F}\u{633}\u{62A}\u{648}\u{631}\u{627}\u{62A} \u{67E}\u{632}\u{634}\u{6A9} <div class="sec-line"></div></div>
  <div class="instr-box">${instructions}</div>
  <div class="sig-area">
    <div class="footer-note">${$375f8776645d5aee$export$49f892522e84db92()}</div>
    <div class="sig-block"><div class="sig-line"></div><div class="sig-lbl">\u{627}\u{645}\u{636}\u{627} \u{648} \u{645}\u{647}\u{631} \u{67E}\u{632}\u{634}\u{6A9}</div></div>
  </div>
</div>
</body>
</html>`;
}
const $375f8776645d5aee$export$abc13ae812b14a42 = {
    paper: '#ffffff',
    ink: '#111111',
    inkSoft: '#333333',
    inkMuted: '#666666',
    inkFaint: '#888888',
    hairline: '#eeeeee',
    rule: '#e5e7eb',
    brand: '#1B4E6B',
    patientBg: '#f0f6fb',
    dxBg: '#fff8e7',
    dxRule: '#F59E0B',
    labBg: '#dbeafe',
    labInk: '#1d4ed8',
    imgBg: '#fce7f3',
    imgInk: '#9d174d',
    statBg: '#fee2e2',
    statInk: '#991b1b',
    watermark: '#cccccc',
    dashed: '#cccccc',
    font: '"Tahoma","Arial",sans-serif'
};
const $375f8776645d5aee$export$2d0aef78bb90a46a = 'visit_record_sections_v1';
const $375f8776645d5aee$export$bd00c9f029ebc508 = Object.fromEntries((0, $aoLHg.VISIT_RECORD_SECTIONS).map((section)=>[
        section.id,
        true
    ]));
function $375f8776645d5aee$export$e5c711a17013eb66(storage) {
    const store = storage ?? (typeof localStorage !== 'undefined' ? localStorage : null);
    try {
        return {
            ...$375f8776645d5aee$export$bd00c9f029ebc508,
            ...JSON.parse(store?.getItem($375f8776645d5aee$export$2d0aef78bb90a46a) || '{}')
        };
    } catch  {
        // Private mode, quota, or a corrupt value — the shipped page, not a throw.
        return {
            ...$375f8776645d5aee$export$bd00c9f029ebc508
        };
    }
}
function $375f8776645d5aee$export$6523efd640f02d3b(layout, storedVisitLayout, doctorLoading, updateSettings) {
    const [recordOpen, setRecordOpen] = (0, $acw62.useState)($375f8776645d5aee$export$e5c711a17013eb66);
    // The server copy wins over the cache, ONCE, when it lands. Re-adopting on
    // every settings refetch would slam a section the doctor just opened shut
    // again mid-visit.
    const adopted = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        if (adopted.current || doctorLoading || !storedVisitLayout) return;
        adopted.current = true;
        setRecordOpen((prev)=>{
            const next = {
                ...prev,
                ...(0, $aoLHg.initialRecordOpen)(layout)
            };
            try {
                localStorage.setItem($375f8776645d5aee$export$2d0aef78bb90a46a, JSON.stringify(next));
            } catch  {}
            return next;
        });
    }, [
        doctorLoading,
        storedVisitLayout,
        layout
    ]);
    const toggleRecordSection = (0, $acw62.useCallback)((id)=>{
        setRecordOpen((prev)=>{
            const next = {
                ...prev,
                [id]: !prev[id]
            };
            try {
                localStorage.setItem($375f8776645d5aee$export$2d0aef78bb90a46a, JSON.stringify(next));
            } catch  {}
            // Persist best-effort: the panel and the cache have already moved, and a
            // failed write must not interrupt a visit over a collapsed section.
            const recordSectionsCollapsed = Object.keys(next).filter((key)=>next[key] === false);
            Promise.resolve(updateSettings?.('visitLayout', {
                recordSectionsCollapsed: recordSectionsCollapsed
            })).catch(()=>{});
            return next;
        });
    }, [
        updateSettings
    ]);
    return {
        recordOpen: recordOpen,
        toggleRecordSection: toggleRecordSection
    };
}
function $375f8776645d5aee$export$e57f8733307287ae({ template: template, rxItems: rxItems, pendingTests: pendingTests, diagnosis: diagnosis, soap: soap, doctor: doctor, patient: patient, t: t }) {
    // i18n-exempt: printed-document date. The sheet this stamps is read by an
    // Iranian pharmacy, so it is Persian whatever the panel's UI language is —
    // the same reason the document itself is built as `<html dir="rtl" lang="fa">`.
    // Do NOT route this through `formatDate`: that would follow the doctor's UI
    // language and put Arabic-Indic or Latin digits on the paper.
    const today = new Date().toLocaleDateString('fa-IR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
    const html = template ? $375f8776645d5aee$export$fd7ee5a010036e9e({
        template: template,
        rxItems: rxItems,
        pendingTests: pendingTests,
        diagnosis: diagnosis,
        soap: soap,
        doctor: doctor,
        patient: patient,
        today: today,
        t: t
    }) : $375f8776645d5aee$export$2429942a486a55fe({
        rxItems: rxItems,
        pendingTests: pendingTests,
        diagnosis: diagnosis,
        soap: soap,
        doctor: doctor,
        patient: patient,
        today: today,
        t: t
    });
    const win = window.open('', '_blank', 'width=640,height=900,menubar=yes');
    if (!win) return false;
    win.document.write(html);
    win.document.close();
    win.focus();
    setTimeout(()=>win.print(), 500);
    return true;
}

});
parcelRegister("dsmcB", function(module, exports) {

$parcel$export(module.exports, "useVoiceInput", () => $9cbf1cd12683ca1b$export$1b636b4aaaa4a081);
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");
function $9cbf1cd12683ca1b$export$1b636b4aaaa4a081({ continuous: continuous = false, autoRestart: autoRestart = false, onFinalSegment: onFinalSegment } = {}) {
    // A hook may call a hook: the messages this sets land in the UI, so they
    // follow the selected language like any other copy.
    const { t: t } = (0, $LNQP4.default)();
    const [status, setStatus] = (0, $acw62.useState)('idle');
    const [transcript, setTranscript] = (0, $acw62.useState)('');
    const [errorDetail, setErrorDetail] = (0, $acw62.useState)('');
    const recRef = (0, $acw62.useRef)(null);
    const accRef = (0, $acw62.useRef)('');
    const permOkRef = (0, $acw62.useRef)(false); // skip getUserMedia re-check after first grant
    // wantRef  — the caller asked to listen and has not asked to stop.
    // busyRef  — a start() is between "asked" and "recognizer running"; a second
    //            call in that window must not spawn a rival recognizer.
    // sessionRef — monotonic id of the newest recogniser. A superseded one still
    //            fires its own onend (abort is asynchronous in the browser), and
    //            that stale end must not restart anything on top of its successor.
    // timerRef — the pending auto-restart, cancelled by stop()/unmount.
    const wantRef = (0, $acw62.useRef)(false);
    const busyRef = (0, $acw62.useRef)(false);
    const sessionRef = (0, $acw62.useRef)(0);
    const timerRef = (0, $acw62.useRef)(null);
    const mountedRef = (0, $acw62.useRef)(true);
    const startRef = (0, $acw62.useRef)(null); // latest start(), for the restart timer
    const getSR = ()=>{
        try {
            return window.SpeechRecognition || window.webkitSpeechRecognition || null;
        } catch  {
            return null;
        }
    };
    const clearRestart = ()=>{
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
    };
    const stop = (0, $acw62.useCallback)(()=>{
        wantRef.current = false;
        clearRestart();
        try {
            recRef.current?.stop();
        } catch  {}
    }, []);
    const reset = (0, $acw62.useCallback)(()=>{
        accRef.current = '';
        setTranscript('');
        setStatus('idle');
        setErrorDetail('');
    }, []);
    const start = (0, $acw62.useCallback)(async ()=>{
        wantRef.current = true;
        // One recognizer at a time. Without this the permission await below is a
        // window in which every extra start() call creates another instance.
        if (busyRef.current) return;
        const SR = getSR();
        if (!SR) {
            wantRef.current = false;
            setStatus('unsupported');
            return;
        }
        busyRef.current = true;
        try {
            // Claim the session BEFORE aborting the previous recogniser. The abort
            // makes that one fire its own end/error, and it must already look stale
            // when it does — otherwise it schedules a restart of its own and the two
            // take turns aborting each other forever.
            const session = ++sessionRef.current;
            clearRestart();
            // Abort any in-flight recognition before starting a new one
            try {
                recRef.current?.abort();
            } catch  {}
            recRef.current = null;
            setErrorDetail('');
            // First call: force OS-level mic permission dialog via getUserMedia.
            // Subsequent re-starts skip this — permission is already cached by the browser.
            if (!permOkRef.current && navigator.mediaDevices?.getUserMedia) try {
                const stream = await navigator.mediaDevices.getUserMedia({
                    audio: true
                });
                stream.getTracks().forEach((track)=>track.stop());
                permOkRef.current = true;
            } catch (err) {
                const name = err?.name || '';
                wantRef.current = false;
                if (name === 'NotAllowedError' || name === 'PermissionDeniedError') setStatus('denied');
                else if (name === 'NotFoundError' || name === 'DevicesNotFoundError') {
                    setStatus('error');
                    setErrorDetail(t('errors.mic.notFound'));
                } else {
                    setStatus('error');
                    setErrorDetail(err?.message || t('errors.mic.access'));
                }
                return;
            }
            // The caller may have stopped (or unmounted) while the permission dialog
            // was open — starting now would leave a recognizer nobody owns.
            if (!wantRef.current || !mountedRef.current) return;
            let rec;
            try {
                rec = new SR();
            } catch  {
                wantRef.current = false;
                setStatus('unsupported');
                return;
            }
            rec.lang = 'fa-IR';
            rec.continuous = continuous;
            rec.interimResults = true;
            rec.maxAlternatives = 1;
            recRef.current = rec;
            // Every callback below is session-guarded: a recogniser that has been
            // superseded still fires events, and none of them are this hook's state.
            rec.onstart = ()=>{
                if (session === sessionRef.current) setStatus('listening');
            };
            rec.onerror = (e)=>{
                if (session !== sessionRef.current) return; // superseded — not our state
                const err = e.error;
                if (err === 'not-allowed' || err === 'permission-denied') {
                    wantRef.current = false;
                    setStatus('denied');
                } else if (err === 'audio-capture') {
                    wantRef.current = false;
                    setStatus('error');
                    setErrorDetail(t('errors.mic.notFound'));
                } else if (err === 'network') {
                    wantRef.current = false;
                    setStatus('error');
                    setErrorDetail(t('errors.networkHint'));
                } else if (err === 'no-speech' || err === 'aborted') // Silence timeout or manual abort — onend decides whether to resume
                setStatus('idle');
                else {
                    console.warn('[useVoiceInput] error:', err);
                    setStatus('idle');
                }
            };
            rec.onend = ()=>{
                if (recRef.current === rec) recRef.current = null;
                if (session !== sessionRef.current) return; // superseded — not our state
                setStatus((prev)=>prev === 'listening' ? 'idle' : prev);
                // A browser-initiated end while the caller still wants to listen: resume.
                if (autoRestart && wantRef.current && mountedRef.current) {
                    clearRestart();
                    timerRef.current = setTimeout(()=>{
                        timerRef.current = null;
                        if (wantRef.current && mountedRef.current) startRef.current?.();
                    }, 250);
                }
            };
            rec.onresult = (e)=>{
                if (session !== sessionRef.current) return; // superseded — not our transcript
                let interim = '';
                for(let i = e.resultIndex; i < e.results.length; i++){
                    const text = e.results[i][0].transcript;
                    if (e.results[i].isFinal) {
                        accRef.current += text + ' ';
                        onFinalSegment?.(text);
                    } else interim = text;
                }
                setTranscript((accRef.current + interim).trim());
            };
            try {
                rec.start();
            } catch (err) {
                console.warn('[useVoiceInput] start failed:', err);
                setStatus('idle');
            }
        } finally{
            busyRef.current = false;
        }
    }, [
        continuous,
        autoRestart,
        onFinalSegment,
        t
    ]);
    // The restart timer fires outside render, so it needs the current closure.
    (0, $acw62.useEffect)(()=>{
        startRef.current = start;
    });
    (0, $acw62.useEffect)(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
            wantRef.current = false;
            clearRestart();
            try {
                recRef.current?.abort();
            } catch  {}
        };
    }, []);
    return {
        status: status,
        transcript: transcript,
        errorDetail: errorDetail,
        start: start,
        stop: stop,
        reset: reset,
        isSupported: !!getSR()
    };
}

});

parcelRegister("aSWLO", function(module, exports) {

$parcel$export(module.exports, "useServerDictation", () => $7ecc8909c8058bf5$export$db41ba3bc0cf8f1c);

var $acw62 = parcelRequire("acw62");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $a83Oj = parcelRequire("a83Oj");

var $eVM84 = parcelRequire("eVM84");

var $k9wwH = parcelRequire("k9wwH");
const $7ecc8909c8058bf5$export$806b28ef46e23f03 = 30000;
function $7ecc8909c8058bf5$var$pickMime() {
    const types = [
        'audio/webm;codecs=opus',
        'audio/webm',
        'audio/ogg;codecs=opus',
        'audio/mp4'
    ];
    try {
        return types.find((type)=>window.MediaRecorder?.isTypeSupported?.(type)) || '';
    } catch  {
        return '';
    }
}
const $7ecc8909c8058bf5$var$supported = ()=>{
    try {
        return typeof window !== 'undefined' && typeof window.MediaRecorder !== 'undefined' && Boolean(navigator?.mediaDevices?.getUserMedia) && typeof window.WebSocket !== 'undefined';
    } catch  {
        return false;
    }
};
const $7ecc8909c8058bf5$var$join = (a, b)=>[
        a,
        b
    ].map((x)=>(x || '').trim()).filter(Boolean).join(' ');
function $7ecc8909c8058bf5$export$db41ba3bc0cf8f1c({ engine: engine = 'parsina' } = {}) {
    const { t: t } = (0, $LNQP4.default)();
    const [status, setStatus] = (0, $acw62.useState)('idle'); // idle | listening | transcribing | denied | unsupported | error
    const [transcript, setTranscript] = (0, $acw62.useState)('');
    const [errorDetail, setErrorDetail] = (0, $acw62.useState)('');
    const [servedEngine, setServedEngine] = (0, $acw62.useState)(null);
    const mountedRef = (0, $acw62.useRef)(true);
    const wsRef = (0, $acw62.useRef)(null);
    const mrRef = (0, $acw62.useRef)(null);
    const streamRef = (0, $acw62.useRef)(null);
    const prefixRef = (0, $acw62.useRef)(''); // text of earlier streams (stop → resume)
    const currentRef = (0, $acw62.useRef)(''); // this stream's text so far
    const doneSentRef = (0, $acw62.useRef)(false);
    const startingRef = (0, $acw62.useRef)(false);
    const finalWaitersRef = (0, $acw62.useRef)([]);
    const timeoutRef = (0, $acw62.useRef)(null);
    const full = ()=>$7ecc8909c8058bf5$var$join(prefixRef.current, currentRef.current);
    const publish = ()=>{
        if (mountedRef.current) setTranscript(full());
    };
    const set = (fn, v)=>{
        if (mountedRef.current) fn(v);
    };
    const settle = ()=>{
        const text = full();
        const waiters = finalWaitersRef.current;
        finalWaitersRef.current = [];
        waiters.forEach((resolve)=>resolve(text));
    };
    // Every exit — final frame, server error, socket close, timeout, cancel,
    // unmount — passes through here, so an awaiting finish() never hangs.
    const teardown = (0, $acw62.useCallback)(()=>{
        startingRef.current = false;
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        try {
            if (mrRef.current && mrRef.current.state !== 'inactive') mrRef.current.stop();
        } catch  {}
        try {
            streamRef.current?.getTracks().forEach((track)=>track.stop());
        } catch  {}
        mrRef.current = null;
        streamRef.current = null;
        const ws = wsRef.current;
        wsRef.current = null;
        if (ws) {
            try {
                ws.onmessage = ws.onerror = ws.onclose = null;
            } catch  {}
            try {
                ws.close(1000, 'client done');
            } catch  {}
        }
        // The finished stream's words become the prefix of the next one.
        prefixRef.current = full();
        currentRef.current = '';
        settle();
    }, []);
    const fail = (0, $acw62.useCallback)((kind, detail)=>{
        teardown();
        set(setErrorDetail, detail || '');
        set(setStatus, kind);
    }, [
        teardown
    ]);
    const start = (0, $acw62.useCallback)(async ()=>{
        if (startingRef.current || wsRef.current) return;
        if (!$7ecc8909c8058bf5$var$supported()) {
            set(setStatus, 'unsupported');
            return;
        }
        startingRef.current = true;
        setErrorDetail('');
        let token = (0, $a83Oj.getToken)();
        if (!token || (0, $a83Oj.isTokenExpired)(token)) {
            const ok = await (0, $a83Oj.refreshAccessToken)();
            token = ok ? (0, $a83Oj.getToken)() : null;
        }
        if (!token) {
            startingRef.current = false;
            fail('error', t('visit.voice.sessionExpired'));
            return;
        }
        let stream;
        try {
            stream = await navigator.mediaDevices.getUserMedia({
                audio: true
            });
        } catch (err) {
            startingRef.current = false;
            const denied = err?.name === 'NotAllowedError' || err?.name === 'SecurityError';
            set(setStatus, denied ? 'denied' : 'error');
            set(setErrorDetail, denied ? '' : t('visit.voice.micError'));
            return;
        }
        if (!mountedRef.current || !startingRef.current) {
            stream.getTracks().forEach((track)=>track.stop());
            return;
        }
        streamRef.current = stream;
        doneSentRef.current = false;
        currentRef.current = '';
        const url = `${(0, $k9wwH.bffWsBase)()}/ws/transcribe?token=${encodeURIComponent(token)}` + `&language=${encodeURIComponent((0, $eVM84.panelLanguage)())}&hints=off&engine=${encodeURIComponent(engine)}`;
        const ws = new WebSocket(url);
        wsRef.current = ws;
        ws.onopen = ()=>{
            const mime = $7ecc8909c8058bf5$var$pickMime();
            let mr;
            try {
                mr = new MediaRecorder(stream, mime ? {
                    mimeType: mime
                } : {});
            } catch  {
                fail('error', t('visit.voice.micError'));
                return;
            }
            mrRef.current = mr;
            mr.ondataavailable = (e)=>{
                if (e.data && e.data.size > 0 && ws.readyState === WebSocket.OPEN) ws.send(e.data);
            };
            // `done` goes out only once the recorder has flushed its LAST chunk —
            // MediaRecorder.stop() emits it asynchronously, and a chunk that lands
            // after `done` is dropped by the BFF.
            mr.onstop = ()=>{
                if (ws.readyState === WebSocket.OPEN && !doneSentRef.current) {
                    doneSentRef.current = true;
                    ws.send(JSON.stringify({
                        done: true
                    }));
                }
            };
            mr.start(250);
            startingRef.current = false;
            set(setStatus, 'listening');
        };
        ws.onmessage = (e)=>{
            let msg;
            try {
                msg = JSON.parse(e.data);
            } catch  {
                return;
            }
            if (msg.engine) set(setServedEngine, msg.engine);
            if (msg.error) {
                fail('error', t('visit.voice.serverError'));
                return;
            }
            if (msg.is_final) {
                // The final pass covers THIS stream's whole buffer, so it replaces.
                if (msg.text) currentRef.current = msg.text;
                publish();
                teardown();
                set(setStatus, 'idle');
                return;
            }
            if (msg.text) {
                currentRef.current = msg.replace ? msg.text : $7ecc8909c8058bf5$var$join(currentRef.current, msg.text);
                publish();
            }
        };
        ws.onerror = ()=>{};
        ws.onclose = ()=>{
            if (wsRef.current !== ws) return;
            // Closed before the final frame: keep whatever arrived, and say so only
            // when nothing did.
            const heard = full();
            teardown();
            if (heard) set(setStatus, 'idle');
            else fail('error', t('visit.voice.serverError'));
        };
    }, [
        engine,
        fail,
        teardown,
        t
    ]);
    // Ask for the final pass. Resolves with the full transcript either way.
    const finish = (0, $acw62.useCallback)(()=>{
        const ws = wsRef.current;
        if (!ws) {
            startingRef.current = false;
            return Promise.resolve(full());
        }
        const promise = new Promise((resolve)=>{
            finalWaitersRef.current.push(resolve);
        });
        set(setStatus, 'transcribing');
        const mr = mrRef.current;
        if (mr && mr.state !== 'inactive') try {
            mr.stop();
        } catch  {}
        else if (ws.readyState === WebSocket.OPEN && !doneSentRef.current) {
            doneSentRef.current = true;
            ws.send(JSON.stringify({
                done: true
            }));
        }
        try {
            streamRef.current?.getTracks().forEach((track)=>track.stop());
        } catch  {}
        if (!timeoutRef.current) timeoutRef.current = setTimeout(()=>{
            timeoutRef.current = null;
            teardown();
            set(setStatus, 'idle');
        }, $7ecc8909c8058bf5$export$806b28ef46e23f03);
        return promise;
    }, [
        teardown
    ]);
    // Abandon: close without waiting. The BFF cancels an unfinished stream.
    const cancel = (0, $acw62.useCallback)(()=>{
        teardown();
        set(setStatus, 'idle');
    }, [
        teardown
    ]);
    const reset = (0, $acw62.useCallback)(()=>{
        teardown();
        prefixRef.current = '';
        currentRef.current = '';
        setTranscript('');
        setErrorDetail('');
        setServedEngine(null);
        setStatus('idle');
    }, [
        teardown
    ]);
    (0, $acw62.useEffect)(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
            teardown();
        };
    }, [
        teardown
    ]);
    return {
        status: status,
        transcript: transcript,
        errorDetail: errorDetail,
        servedEngine: servedEngine,
        start: start,
        stop: finish,
        finish: finish,
        cancel: cancel,
        reset: reset,
        isSupported: $7ecc8909c8058bf5$var$supported()
    };
}

});

parcelRegister("4s6k1", function(module, exports) {

$parcel$export(module.exports, "SPEECH_ENGINE_BROWSER", () => $33deae5c7ec89d7f$export$14e406b759a48fe6);
$parcel$export(module.exports, "isServerEngine", () => $33deae5c7ec89d7f$export$8636e31299dc73ad);
$parcel$export(module.exports, "speechEnginePreference", () => $33deae5c7ec89d7f$export$e976735e46efaec2);
$parcel$export(module.exports, "ambientEngine", () => $33deae5c7ec89d7f$export$a597380b597b4b46);
// «موتور تبدیل گفتار به متن» — which engine turns the doctor's voice into text.
//
// The doctor picks one in Settings → دستیار هوشمند; the value is stored on the
// practitioner's AI settings (`speechEngine`) and read here. Three engines:
//
//   parsina    «گفتار به متن پارسینا» — the AI service's dedicated speech model
//              (speech_engines.py). The product default.
//   assistant  «دستیار هوشمند» — the AI service's general transcription.
//   browser    «مرورگر (Chrome)» — the browser's own Web Speech API. Free, but
//              absent on Safari and every browser on iOS, and it sends the audio
//              to the browser vendor rather than to Parsina.
//
// Two surfaces use an engine and they do not have the same options:
//
//   • per-section dictation («ثبت صوتی») may use all three;
//   • the ambient visit recording may use only the two SERVER engines — the
//     browser recogniser cannot hear a video call's audio and feeds no clinical
//     hints — so a doctor who chose `browser` records the visit on Parsina STT.
//
// "PARSINA IS THE DEFAULT, WITH FALLBACK" is enforced by the AI service, not
// here: a stream that asks for Parsina STT while it cannot answer is served —
// and billed — by the assistant engine, and the stream's first frame says which
// engine served (`engine` on the socket). So nothing here waits on a readiness
// check before starting a microphone.
const $33deae5c7ec89d7f$export$303b337dd3fdcd5e = 'parsina';
const $33deae5c7ec89d7f$export$c61f8b0aeda2c58e = 'assistant';
const $33deae5c7ec89d7f$export$14e406b759a48fe6 = 'browser';
const $33deae5c7ec89d7f$export$b9da910a30b0dc48 = Object.freeze([
    $33deae5c7ec89d7f$export$303b337dd3fdcd5e,
    $33deae5c7ec89d7f$export$c61f8b0aeda2c58e,
    $33deae5c7ec89d7f$export$14e406b759a48fe6
]);
const $33deae5c7ec89d7f$export$a94ba151bfc9b67a = $33deae5c7ec89d7f$export$303b337dd3fdcd5e;
const $33deae5c7ec89d7f$export$e46fd2bfabfad0c8 = Object.freeze({
    [$33deae5c7ec89d7f$export$303b337dd3fdcd5e]: 'TranscribeAudioParsina',
    [$33deae5c7ec89d7f$export$c61f8b0aeda2c58e]: 'TranscribeAudio'
});
const $33deae5c7ec89d7f$export$8636e31299dc73ad = (engine)=>engine === $33deae5c7ec89d7f$export$303b337dd3fdcd5e || engine === $33deae5c7ec89d7f$export$c61f8b0aeda2c58e;
function $33deae5c7ec89d7f$export$e976735e46efaec2(ai) {
    const value = ai?.speechEngine;
    return $33deae5c7ec89d7f$export$b9da910a30b0dc48.includes(value) ? value : $33deae5c7ec89d7f$export$a94ba151bfc9b67a;
}
function $33deae5c7ec89d7f$export$27c418303ede0f96() {
    try {
        return typeof window !== 'undefined' && Boolean(window.SpeechRecognition || window.webkitSpeechRecognition);
    } catch  {
        return false;
    }
}
function $33deae5c7ec89d7f$export$6d89c0f0f7f89c2d(preference, { browserSupported: browserSupported = $33deae5c7ec89d7f$export$27c418303ede0f96() } = {}) {
    if (preference === $33deae5c7ec89d7f$export$14e406b759a48fe6) return browserSupported ? $33deae5c7ec89d7f$export$14e406b759a48fe6 : $33deae5c7ec89d7f$export$303b337dd3fdcd5e;
    return $33deae5c7ec89d7f$export$8636e31299dc73ad(preference) ? preference : $33deae5c7ec89d7f$export$a94ba151bfc9b67a;
}
function $33deae5c7ec89d7f$export$a597380b597b4b46(preference) {
    return preference === $33deae5c7ec89d7f$export$c61f8b0aeda2c58e ? $33deae5c7ec89d7f$export$c61f8b0aeda2c58e : $33deae5c7ec89d7f$export$303b337dd3fdcd5e;
}

});

parcelRegister("3Tnyk", function(module, exports) {

$parcel$export(module.exports, "autoConfirmActive", () => $2d58c73a38525204$export$726a3b8c7102fb29);
$parcel$export(module.exports, "clinicalSuggestionsAutoRun", () => $2d58c73a38525204$export$ced99d35363868d3);
$parcel$export(module.exports, "liveHintsActive", () => $2d58c73a38525204$export$77b83820a545461a);
$parcel$export(module.exports, "autoPrescriptionAssistActive", () => $2d58c73a38525204$export$2b2bb51f62de8576);
$parcel$export(module.exports, "autoCompleteOnStopActive", () => $2d58c73a38525204$export$c41b9e42cb7b861);
$parcel$export(module.exports, "orderPickerPrefs", () => $2d58c73a38525204$export$53268c287cc00697);
$parcel$export(module.exports, "reassessOnNoteEditActive", () => $2d58c73a38525204$export$211159940a78ce44);
$parcel$export(module.exports, "endVisitSweepActive", () => $2d58c73a38525204$export$6bc5afae02a61f49);
$parcel$export(module.exports, "differentialPollingActive", () => $2d58c73a38525204$export$8c8aa4bf9ee20a73);
$parcel$export(module.exports, "differentialPollSeconds", () => $2d58c73a38525204$export$291b76ac275aac62);
$parcel$export(module.exports, "differentialPollMs", () => $2d58c73a38525204$export$8929775566921897);
$parcel$export(module.exports, "differentialPollLabel", () => $2d58c73a38525204$export$934efb048138efd3);
// ─────────────────────────────────────────────────────────────────────────────
// Settings — shared logic (DESIGN-CONCEPT-MOBILE v2 §1.1).
//
// `Settings.web.jsx` and `Settings.mobile.jsx` are two independent render trees
// that must never *disagree* about what a setting means, what its default is,
// which section owns it, or when the form is dirty. All of that non-visual truth
// lives here.
//
// Markup is NOT here — a component belongs to exactly one surface. This module
// holds the section registry, defaults, validation and pure derivations only.
//
// It also holds no TEXT. Every user-facing string in this file is a translation
// KEY, resolved by whichever surface renders it. That is what keeps «what a
// setting is called» a single fact while still letting it be called it in two
// languages — a literal here would be a Persian string neither surface could
// translate, because a plain module cannot call a hook.
// ─────────────────────────────────────────────────────────────────────────────

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $Hy6Lb = parcelRequire("Hy6Lb");

var $3HwYZ = parcelRequire("3HwYZ");

var $aoLHg = parcelRequire("aoLHg");
const $2d58c73a38525204$export$5ff47a1a5df62032 = [
    // «قالب‌ها» sits next to «دستیار هوشمند» because both are about what the
    // Visit page does for the doctor — one automatically, one on request.
    // «صفحه ویزیت» sits between them: it is about what the Visit page SHOWS.
    // «نسخه» follows the templates: what the doctor's prescriptions are billed as
    // (the RVU3 visit code — PrescriptionSettings.jsx).
    'profile',
    'ai',
    'visit',
    'templates',
    'prescription',
    'credits',
    'language',
    'appearance',
    'clinics',
    'security'
].map((id)=>({
        id: id,
        labelKey: `settings.sections.${id}.label`,
        hintKey: `settings.sections.${id}.hint`
    }));
const $2d58c73a38525204$export$d0fe0b0df5d61021 = $2d58c73a38525204$export$5ff47a1a5df62032.map((s)=>s.id);
const $2d58c73a38525204$export$d5df8095c82b1b1a = (id)=>$2d58c73a38525204$export$d0fe0b0df5d61021.includes(id);
const $2d58c73a38525204$export$b22bf82651bf4640 = 'profile';
const $2d58c73a38525204$export$40990cfbf62fff64 = [
    'firstName',
    'lastName',
    'phone',
    'nationalId',
    'gender',
    'birthDate',
    'medicalCode',
    'specialty',
    'bio'
];
const $2d58c73a38525204$export$e8bf9d673f0f461f = {
    firstName: 'common.labels.firstName',
    lastName: 'common.labels.lastName',
    phone: 'common.labels.phone',
    nationalId: 'common.labels.nationalId',
    gender: 'common.labels.gender',
    birthDate: 'common.labels.birthDate',
    medicalCode: 'common.labels.medicalCode',
    specialty: 'common.labels.specialty',
    bio: 'common.labels.bio'
};
const $2d58c73a38525204$export$1429510cfa0d4432 = (form)=>$2d58c73a38525204$export$40990cfbf62fff64.map((key)=>({
            key: key,
            labelKey: $2d58c73a38525204$export$e8bf9d673f0f461f[key],
            filled: Boolean((form?.[key] ?? '').toString().trim())
        }));
const $2d58c73a38525204$export$b0c3bc556f31ebe8 = (saved)=>Boolean((saved?.medicalCode || '').trim());
function $2d58c73a38525204$export$a07b599d4f364c08(form, saved) {
    const errors = {};
    if (!form.firstName?.trim()) errors.firstName = 'validation.firstName';
    if (!form.lastName?.trim()) errors.lastName = 'validation.lastName';
    if (saved?.medicalCode && !form.medicalCode?.trim()) errors.medicalCode = 'validation.medicalCode';
    return errors;
}
function $2d58c73a38525204$export$4d2a7159fda5dc93(pw) {
    const errors = {};
    if (!pw.current) errors.current = 'validation.password.current';
    if ((pw.next || '').trim().length < 6) errors.next = 'validation.password.minLength';
    if (pw.next !== pw.confirm) errors.confirm = 'validation.password.mismatch';
    return errors;
}
const $2d58c73a38525204$export$b76bdd93b2cd1293 = (doctor)=>Object.fromEntries($2d58c73a38525204$export$40990cfbf62fff64.map((k)=>[
            k,
            doctor?.[k] ?? ''
        ]));
const $2d58c73a38525204$export$6751d1764e58e2a1 = (form, saved)=>$2d58c73a38525204$export$40990cfbf62fff64.some((k)=>(form[k] || '').trim() !== (saved[k] || '').trim());
const $2d58c73a38525204$export$46e28ca63030741b = (form, saved)=>Object.fromEntries($2d58c73a38525204$export$40990cfbf62fff64.filter((k)=>!(k === 'medicalCode' && $2d58c73a38525204$export$b0c3bc556f31ebe8(saved))).map((k)=>[
            k,
            typeof form[k] === 'string' ? form[k].trim() : form[k]
        ]).filter(([k, v])=>v !== (saved[k] || '')));
const $2d58c73a38525204$export$98245d8165151e62 = (form)=>{
    const filled = $2d58c73a38525204$export$40990cfbf62fff64.filter((f)=>(form[f] || '').toString().trim()).length;
    return Math.round(filled / $2d58c73a38525204$export$40990cfbf62fff64.length * 100);
};
const $2d58c73a38525204$export$cc12720b27678a68 = {
    interruptOnCritical: true,
    interruptOnWarning: true,
    spo2Threshold: 95,
    bpSystolicThreshold: 140,
    recommendationLogsEnabled: true,
    autoDifferentialOnStart: true,
    differentialPollingEnabled: true,
    differentialPollIntervalSec: 15,
    liveHintsEnabled: true,
    autoPrescriptionAssist: true,
    reassessOnNoteEdit: true,
    endVisitInteractionSweep: true,
    // «تکمیل خودکار پس از پایش بالینی» — on for everyone (K1, 2026-10-06).
    autoCompleteOnMonitoringStop: true,
    // «تایید خودکار» (PM-0573) — the one switch here that is OFF until the doctor
    // turns it on: it writes without asking (DESIGN_CONCEPT §13.3).
    autoConfirmProposals: false,
    // The visit's «افزودن دستور» picker (PM-0701): the clinic's own services and the
    // doctor's frequent orders are listed before anything is typed, the clinic's
    // first. Display preferences, so they are on for everyone — nothing about what
    // may be ordered changes.
    orderPickerShowClinic: true,
    orderPickerShowFrequent: true,
    orderPickerFrequentFirst: false,
    // «موتور تبدیل گفتار به متن» — lib/speechEngine.js. Parsina STT by default;
    // the AI service falls back to the assistant engine whenever it cannot answer.
    speechEngine: 'parsina'
};
const $2d58c73a38525204$export$e5402420929f4067 = {
    theme: (0, $jTCZr.DEFAULT_THEME),
    fontSize: (0, $jTCZr.DEFAULT_FONT_SIZE),
    language: (0, $Hy6Lb.DEFAULT_LOCALE),
    fontFamily: (0, $3HwYZ.DEFAULT_FONT_FAMILY)
};
const $2d58c73a38525204$export$eceb5de8d7df09f9 = {
    otpEnabled: false,
    biometricEnabled: false
};
const $2d58c73a38525204$export$4df9c0969a9e0160 = (section, defaults)=>({
        ...defaults,
        ...Object.fromEntries(Object.entries(section || {}).filter(([, v])=>v != null))
    });
const $2d58c73a38525204$export$12678b5895b9b663 = (doctor)=>$2d58c73a38525204$export$4df9c0969a9e0160(doctor?.settings?.aiAgent, $2d58c73a38525204$export$cc12720b27678a68);
const $2d58c73a38525204$export$109495996d5012e4 = (doctor)=>$2d58c73a38525204$export$4df9c0969a9e0160(doctor?.settings?.appearance, $2d58c73a38525204$export$e5402420929f4067);
const $2d58c73a38525204$export$74c8f641b046dabd = (doctor)=>$2d58c73a38525204$export$4df9c0969a9e0160(doctor?.settings?.security, $2d58c73a38525204$export$eceb5de8d7df09f9);
const $2d58c73a38525204$export$dc4d894629379c14 = (doctor)=>$2d58c73a38525204$export$4df9c0969a9e0160(doctor?.settings?.visitLayout, (0, $aoLHg.VISIT_LAYOUT_DEFAULTS));
// ── Visit-page AI controls ────────────────────────────────────────────────────
//
// The two settings this screen exists to expose, described once so the desktop
// card, the mobile sheet and the tests all read the same words. `key` matches
// AIAgentSettingsInput; `impactKey` names the copy shown under the toggle so
// the doctor knows what turning it off actually stops.
//
// Only KEYS live here — the words are in settings.json, under a path derived
// from `key`, so a toggle's name and its translation cannot drift apart.
//
// These are AUTOMATION switches, and now the ONLY AI switches: they decide
// whether a pass runs by itself, never whether a capability exists. Nothing
// here can take a feature away from the doctor — turning a toggle off just
// means running the same thing by hand from the Visit page.
// Every toggle's copy lives at `settings.ai.toggles.<key>.*`, so this helper is
// the only place that spelling appears.
const $2d58c73a38525204$var$aiToggleKey = (key, part)=>`settings.ai.toggles.${key}.${part}`;
const $2d58c73a38525204$var$aiToggle = (key)=>({
        key: key,
        labelKey: $2d58c73a38525204$var$aiToggleKey(key, 'label'),
        impactKey: $2d58c73a38525204$var$aiToggleKey(key, 'impact')
    });
const $2d58c73a38525204$export$8035bf38917cdb6e = [
    // The order picker's three display preferences lead the list (PM-0701): they are
    // what a doctor touches most, and they are not an automatic run — see
    // `orderPickerPrefs`.
    $2d58c73a38525204$var$aiToggle('orderPickerShowClinic'),
    $2d58c73a38525204$var$aiToggle('orderPickerShowFrequent'),
    $2d58c73a38525204$var$aiToggle('orderPickerFrequentFirst'),
    $2d58c73a38525204$var$aiToggle('recommendationLogsEnabled'),
    $2d58c73a38525204$var$aiToggle('liveHintsEnabled'),
    $2d58c73a38525204$var$aiToggle('autoCompleteOnMonitoringStop'),
    $2d58c73a38525204$var$aiToggle('autoConfirmProposals'),
    $2d58c73a38525204$var$aiToggle('autoPrescriptionAssist'),
    $2d58c73a38525204$var$aiToggle('autoDifferentialOnStart'),
    $2d58c73a38525204$var$aiToggle('endVisitInteractionSweep')
];
const $2d58c73a38525204$export$a0fdd5a9e7747195 = (item, ai)=>item?.key === 'autoCompleteOnMonitoringStop' && $2d58c73a38525204$export$726a3b8c7102fb29(ai) ? $2d58c73a38525204$var$aiToggleKey(item.key, 'impactAutoConfirm') : item?.impactKey;
const $2d58c73a38525204$export$d84b29c60bbbdc31 = [
    $2d58c73a38525204$var$aiToggle('differentialPollingEnabled'),
    $2d58c73a38525204$var$aiToggle('reassessOnNoteEdit')
];
const $2d58c73a38525204$export$fdba03209e26fe6d = [
    {
        key: 'interruptOnCritical',
        labelKey: $2d58c73a38525204$var$aiToggleKey('interruptOnCritical', 'label')
    },
    {
        key: 'interruptOnWarning',
        labelKey: $2d58c73a38525204$var$aiToggleKey('interruptOnWarning', 'label')
    }
];
const $2d58c73a38525204$export$b18cfe9ad6d2d648 = (ai)=>$2d58c73a38525204$export$fdba03209e26fe6d.some((item)=>ai?.[item.key] !== false);
const $2d58c73a38525204$export$ced99d35363868d3 = (ai)=>ai?.recommendationLogsEnabled !== false;
const $2d58c73a38525204$export$77b83820a545461a = (ai)=>ai?.liveHintsEnabled !== false;
const $2d58c73a38525204$export$2b2bb51f62de8576 = (ai)=>ai?.autoPrescriptionAssist !== false;
const $2d58c73a38525204$export$c41b9e42cb7b861 = (ai)=>ai?.autoCompleteOnMonitoringStop !== false;
const $2d58c73a38525204$export$726a3b8c7102fb29 = (ai)=>ai?.autoConfirmProposals === true;
const $2d58c73a38525204$export$53268c287cc00697 = (ai)=>({
        showClinic: ai?.orderPickerShowClinic !== false,
        showFrequent: ai?.orderPickerShowFrequent !== false,
        frequentFirst: ai?.orderPickerFrequentFirst === true
    });
const $2d58c73a38525204$export$211159940a78ce44 = (ai)=>ai?.autoDifferentialOnStart !== false && ai?.reassessOnNoteEdit !== false;
const $2d58c73a38525204$export$6bc5afae02a61f49 = (ai)=>ai?.endVisitInteractionSweep !== false;
const $2d58c73a38525204$export$7c8e7f6b23543e69 = [
    15,
    30,
    60,
    120,
    300
];
const $2d58c73a38525204$export$7d379a2ec9a8613b = 15;
const $2d58c73a38525204$export$8c8aa4bf9ee20a73 = (ai)=>ai?.autoDifferentialOnStart !== false && ai?.differentialPollingEnabled !== false;
const $2d58c73a38525204$export$291b76ac275aac62 = (ai)=>{
    const n = Number(ai?.differentialPollIntervalSec);
    if (!Number.isFinite(n) || n < 5 || n > 600) return $2d58c73a38525204$export$7d379a2ec9a8613b;
    return Math.round(n);
};
const $2d58c73a38525204$export$8929775566921897 = (ai)=>$2d58c73a38525204$export$291b76ac275aac62(ai) * 1000;
const $2d58c73a38525204$export$934efb048138efd3 = (sec, t, formatNumber = (n)=>String(n))=>sec < 60 ? t('settings.ai.pollEverySeconds', {
        count: formatNumber(sec)
    }) : t('settings.ai.pollEveryMinutes', {
        count: formatNumber(sec / 60)
    });
// Only the keys that actually changed go to the server — the mutation merges,
// so sending the whole object would rewrite settings the doctor never touched.
// Lists (the layout sections) compare by CONTENT: a fresh array with the same
// ids is not a change, and sending it would be a pointless write.
const $2d58c73a38525204$var$sameValue = (a, b)=>Array.isArray(a) || Array.isArray(b) ? JSON.stringify(a) === JSON.stringify(b) : a === b;
const $2d58c73a38525204$export$59230889ac977c02 = (next, saved)=>Object.fromEntries(Object.entries(next).filter(([k, v])=>!$2d58c73a38525204$var$sameValue(v, saved?.[k])));
const $2d58c73a38525204$export$b9d28ecb694e8fb5 = 12582912;
function $2d58c73a38525204$export$37e4fcb024c1e74e(file) {
    return new Promise((resolve)=>{
        if (!file) {
            resolve({
                ok: false,
                messageKey: 'settings.avatar.notAnImage'
            });
            return;
        }
        if (!file.type?.startsWith('image/')) {
            resolve({
                ok: false,
                messageKey: 'settings.avatar.notAnImage'
            });
            return;
        }
        if (file.size > $2d58c73a38525204$export$b9d28ecb694e8fb5) {
            resolve({
                ok: false,
                messageKey: 'settings.avatar.tooLarge'
            });
            return;
        }
        const reader = new FileReader();
        reader.onload = (ev)=>resolve({
                ok: true,
                dataUri: ev.target.result
            });
        reader.onerror = ()=>resolve({
                ok: false,
                messageKey: 'errors.avatar.read'
            });
        reader.readAsDataURL(file);
    });
}

});
parcelRegister("3HwYZ", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_FONT_FAMILY", () => $2b1ef8e92b4fa1dc$export$2653e0d5dd45b294);
// ─────────────────────────────────────────────────────────────────────────────
// Font family — the doctor's choice of typeface, applied app-wide.
//
// The accent preset and the type SCALE are painted by the design system's
// ThemeProvider (`data-theme` / `data-font-size` on <html>, consumed by
// tokens.css). The typeFACE is the app's own: the framework declares no font,
// each client ships its own faces (see styles.css), so the catalogue of ids
// lives here and the painting works the same way — one attribute on the root,
// `data-font-family`, and every screen follows through `var(--app-font)`.
//
// The ids are what the server stores (`appearance.fontFamily` — a free-form
// string, like `theme`). Adding a face is a client-only change: a @font-face
// block and a `--font-<id>` variable in styles.css, one entry here, one label
// in settings.json. Nothing else knows the list.
//
// Why the CSS variable rather than setting `font-family` on <html>: form
// controls do NOT inherit the document font, so styles.css pins them to the
// same variable; and the picker previews each option in its own face through
// `fontFamilyVar(id)` without duplicating the stack in JavaScript.
// ─────────────────────────────────────────────────────────────────────────────
const $2b1ef8e92b4fa1dc$export$5e0101b7a2e9ac78 = [
    // The brand face — Vazirmatn, served as «Meshkat». Default for every doctor
    // who never opens the picker, so shipping this changes nothing for them.
    {
        id: 'meshkat',
        labelKey: 'settings.appearance.fonts.meshkat',
        hintKey: 'settings.appearance.fonts.meshkatHint'
    },
    {
        id: 'sahel',
        labelKey: 'settings.appearance.fonts.sahel',
        hintKey: 'settings.appearance.fonts.sahelHint'
    },
    {
        id: 'shabnam',
        labelKey: 'settings.appearance.fonts.shabnam',
        hintKey: 'settings.appearance.fonts.shabnamHint'
    },
    {
        id: 'samim',
        labelKey: 'settings.appearance.fonts.samim',
        hintKey: 'settings.appearance.fonts.samimHint'
    },
    // The operating system's own UI face (Segoe UI / Tahoma on the Windows
    // workstations most clinics run) — for a doctor who wants the panel to look
    // like the rest of their desktop, or whose eyes are used to Tahoma from the
    // older HIS software.
    {
        id: 'system',
        labelKey: 'settings.appearance.fonts.system',
        hintKey: 'settings.appearance.fonts.systemHint'
    }
];
const $2b1ef8e92b4fa1dc$export$2653e0d5dd45b294 = 'meshkat';
const $2b1ef8e92b4fa1dc$export$92cbd8c7c9218fc7 = 'data-font-family';
const $2b1ef8e92b4fa1dc$export$5dabf7ed9be4d0e2 = 'parsina.fontFamily';
const $2b1ef8e92b4fa1dc$export$bb2277cfe1c4131d = (id)=>$2b1ef8e92b4fa1dc$export$5e0101b7a2e9ac78.some((f)=>f.id === id);
const $2b1ef8e92b4fa1dc$export$b2f634c57ce36bba = (id)=>`var(--font-${$2b1ef8e92b4fa1dc$export$bb2277cfe1c4131d(id) ? id : $2b1ef8e92b4fa1dc$export$2653e0d5dd45b294})`;
const $2b1ef8e92b4fa1dc$var$rootOf = (doc)=>(doc ?? (typeof document !== 'undefined' ? document : null))?.documentElement;
const $2b1ef8e92b4fa1dc$var$storageOf = (storage)=>storage ?? (typeof localStorage !== 'undefined' ? localStorage : null);
function $2b1ef8e92b4fa1dc$export$858b2319de02e404(storage) {
    try {
        const raw = $2b1ef8e92b4fa1dc$var$storageOf(storage)?.getItem($2b1ef8e92b4fa1dc$export$5dabf7ed9be4d0e2);
        return $2b1ef8e92b4fa1dc$export$bb2277cfe1c4131d(raw) ? raw : $2b1ef8e92b4fa1dc$export$2653e0d5dd45b294;
    } catch  {
        return $2b1ef8e92b4fa1dc$export$2653e0d5dd45b294;
    }
}
function $2b1ef8e92b4fa1dc$export$cdb625a815e5766e(id, storage) {
    try {
        $2b1ef8e92b4fa1dc$var$storageOf(storage)?.setItem($2b1ef8e92b4fa1dc$export$5dabf7ed9be4d0e2, id);
    } catch  {
    // Best-effort cache; the server copy is the record.
    }
}
function $2b1ef8e92b4fa1dc$export$a9095290f9c44563(id, doc) {
    const resolved = $2b1ef8e92b4fa1dc$export$bb2277cfe1c4131d(id) ? id : $2b1ef8e92b4fa1dc$export$2653e0d5dd45b294;
    const root = $2b1ef8e92b4fa1dc$var$rootOf(doc);
    if (root) root.setAttribute($2b1ef8e92b4fa1dc$export$92cbd8c7c9218fc7, resolved);
    return resolved;
}
function $2b1ef8e92b4fa1dc$export$1e5f589b69a6bdc(doc) {
    const value = $2b1ef8e92b4fa1dc$var$rootOf(doc)?.getAttribute($2b1ef8e92b4fa1dc$export$92cbd8c7c9218fc7);
    return $2b1ef8e92b4fa1dc$export$bb2277cfe1c4131d(value) ? value : $2b1ef8e92b4fa1dc$export$2653e0d5dd45b294;
}
function $2b1ef8e92b4fa1dc$export$17d5115a21e3d7f9(id, { doc: doc, storage: storage } = {}) {
    const resolved = $2b1ef8e92b4fa1dc$export$a9095290f9c44563(id, doc);
    $2b1ef8e92b4fa1dc$export$cdb625a815e5766e(resolved, storage);
    return resolved;
}

});

parcelRegister("aoLHg", function(module, exports) {

$parcel$export(module.exports, "VISIT_RECORD_SECTIONS", () => $792124e2f7de719a$export$286013f25f0f7b72);
$parcel$export(module.exports, "VISIT_LAYOUT_DEFAULTS", () => $792124e2f7de719a$export$df312747b9dc7053);
$parcel$export(module.exports, "resolveVisitLayout", () => $792124e2f7de719a$export$e88ad8319f3008b2);
$parcel$export(module.exports, "visibleRecordSections", () => $792124e2f7de719a$export$e111fe7e8e6c2d5d);
$parcel$export(module.exports, "isWorkPartVisible", () => $792124e2f7de719a$export$b53be2f13fbaae05);
$parcel$export(module.exports, "initialRecordOpen", () => $792124e2f7de719a$export$f9d63a319ff0f5db);
$parcel$export(module.exports, "isMobileVisitTabVisible", () => $792124e2f7de719a$export$6fd5b56eddd00f9b);
$parcel$export(module.exports, "mobileDefaultVisitTab", () => $792124e2f7de719a$export$dde3a1a6c2d91941);
$parcel$export(module.exports, "isMobileCopilotSheetTabVisible", () => $792124e2f7de719a$export$ec23aec8c07c3d8a);
$parcel$export(module.exports, "mobileDefaultCopilotSheetTab", () => $792124e2f7de719a$export$c5c16556be0d657b);
// ─────────────────────────────────────────────────────────────────────────────
// Visit page layout — the vocabulary the doctor can customise, and the pure
// resolution from "what the server stored" to "what the page renders".
//
// Both Visit surfaces (Visit.web.jsx, Visit.mobile.jsx) and the Settings
// editor read THIS module, so the three can never disagree about which
// sections exist, what they are called, which may be hidden, or what the
// untouched page looks like. No markup, no text — labels are translation keys.
//
// The stored shape (`doctor.settings.visitLayout`, see VISIT_LAYOUT_DEFAULTS)
// is deliberately sparse: a doctor who never opened the editor has empty lists,
// which resolves to the page exactly as it shipped. The service stores ids
// verbatim and validates nothing, so every rule about unknown ids, locked
// sections and "at least one tab" lives here — the client is the only thing
// that knows the catalogue.
//
// Adding a customisable thing to the visit page: add its id to the matching
// catalogue below (with a `labelKey`), render it from the resolved layout, and
// the editor, the persistence and the tests pick it up. Adding a NEW screen's
// layout: a sibling module like this one plus a new settings section — see
// docs/UI-CUSTOMIZATION.md.
// ─────────────────────────────────────────────────────────────────────────────
// «پرونده بیمار» — the record column, in the order the page shipped with.
// `locked` sections can be reordered and collapsed but never hidden: the
// allergy banner is a safety signal, not a preference.
const $792124e2f7de719a$export$286013f25f0f7b72 = [
    {
        id: 'allergy',
        labelKey: 'visit.patient.allergyAlert',
        locked: true
    },
    {
        id: 'demo',
        labelKey: 'visit.patient.details'
    },
    // «سوابق ویزیت‌های قبلی» sits right under «مشخصات» (PM-0023): what happened last
    // time is the first thing a doctor looks for, and it used to be the last
    // section of the app's longest scroll. A doctor who arranged their own order
    // keeps it — this is only the untouched page.
    {
        id: 'history',
        labelKey: 'visit.history.title'
    },
    {
        id: 'vitals',
        labelKey: 'visit.vitals.title'
    },
    {
        id: 'meds',
        labelKey: 'patient.meds.current'
    },
    {
        id: 'dx',
        labelKey: 'patient.conditions.active'
    },
    {
        id: 'conds',
        labelKey: 'visit.patient.conditionHistory'
    },
    {
        id: 'labs',
        labelKey: 'visit.patient.labResults'
    },
    // «مدارک بیمار» (docs/DOCTOR_PATIENT_FILES_AND_AI_EXTRACTION_DESIGN.md §7.1). A doctor
    // whose stored order predates it gets it appended at the end (orderByPreference).
    {
        id: 'files',
        labelKey: 'visit.patient.files'
    }
];
const $792124e2f7de719a$export$b42ce7b9554c2388 = [
    {
        id: 'soap',
        labelKey: 'visit.tabs.soap',
        locked: true
    },
    {
        id: 'rx',
        labelKey: 'visit.tabs.rx'
    },
    {
        id: 'orders',
        labelKey: 'visit.tabs.orders'
    },
    {
        id: 'plan',
        labelKey: 'visit.tabs.plan',
        locked: true
    }
];
const $792124e2f7de719a$export$a532ffe01c3d7cc7 = [
    // «داروهای پرتکرار من» in the نسخه's «افزودن دارو» (PM-0516). Hidden, the
    // picker is search-only; the doctor's last directions still fill its form.
    {
        id: 'rx.frequent',
        tab: 'rx',
        labelKey: 'visit.rx.frequent.title'
    }
];
const $792124e2f7de719a$export$cf705f4052b87526 = [
    {
        id: 'sugg',
        labelKey: 'visit.copilot.clinicalNotes'
    },
    {
        id: 'diff',
        labelKey: 'visit.copilot.differential'
    },
    {
        id: 'ask',
        labelKey: 'visit.copilot.ask'
    }
];
const $792124e2f7de719a$export$df312747b9dc7053 = {
    recordSectionOrder: [],
    recordSectionsHidden: [],
    recordSectionsCollapsed: [],
    workTabsHidden: [],
    defaultWorkTab: 'soap',
    copilotTabsHidden: [],
    defaultCopilotTab: 'sugg'
};
const $792124e2f7de719a$var$asList = (v)=>Array.isArray(v) ? v.filter((x)=>typeof x === 'string') : [];
function $792124e2f7de719a$export$3847309b37cec074(catalog, storedOrder) {
    const known = new Set(catalog.map((c)=>c.id));
    const seen = new Set();
    const ids = [];
    for (const id of $792124e2f7de719a$var$asList(storedOrder))if (known.has(id) && !seen.has(id)) {
        seen.add(id);
        ids.push(id);
    }
    for (const c of catalog)if (!seen.has(c.id)) ids.push(c.id);
    const byId = Object.fromEntries(catalog.map((c)=>[
            c.id,
            c
        ]));
    return ids.map((id)=>byId[id]);
}
// A tab set with its default: hidden ids drop out (never a locked one), and if
// the stored default is hidden or unknown the first visible tab stands in, so
// the page always opens on something that exists.
function $792124e2f7de719a$var$resolveTabs(catalog, hidden, storedDefault, fallbackId) {
    const hiddenSet = new Set($792124e2f7de719a$var$asList(hidden));
    let tabs = catalog.map((tab)=>({
            ...tab,
            visible: Boolean(tab.locked) || !hiddenSet.has(tab.id)
        }));
    if (!tabs.some((tab)=>tab.visible)) tabs = tabs.map((tab)=>({
            ...tab,
            visible: true
        }));
    const visible = tabs.filter((tab)=>tab.visible);
    const preferred = visible.find((tab)=>tab.id === storedDefault) || visible.find((tab)=>tab.id === fallbackId) || visible[0];
    return {
        tabs: tabs,
        defaultTab: preferred.id
    };
}
function $792124e2f7de719a$export$e88ad8319f3008b2(settings) {
    const s = {
        ...$792124e2f7de719a$export$df312747b9dc7053,
        ...settings || {}
    };
    const hidden = new Set($792124e2f7de719a$var$asList(s.recordSectionsHidden));
    const collapsed = new Set($792124e2f7de719a$var$asList(s.recordSectionsCollapsed));
    const recordSections = $792124e2f7de719a$export$3847309b37cec074($792124e2f7de719a$export$286013f25f0f7b72, s.recordSectionOrder).map((sec)=>({
            ...sec,
            visible: Boolean(sec.locked) || !hidden.has(sec.id),
            collapsed: collapsed.has(sec.id)
        }));
    const work = $792124e2f7de719a$var$resolveTabs($792124e2f7de719a$export$b42ce7b9554c2388, s.workTabsHidden, s.defaultWorkTab, $792124e2f7de719a$export$df312747b9dc7053.defaultWorkTab);
    const hiddenWork = new Set($792124e2f7de719a$var$asList(s.workTabsHidden));
    const copilot = $792124e2f7de719a$var$resolveTabs($792124e2f7de719a$export$cf705f4052b87526, s.copilotTabsHidden, s.defaultCopilotTab, $792124e2f7de719a$export$df312747b9dc7053.defaultCopilotTab);
    return {
        recordSections: recordSections,
        workTabs: work.tabs,
        defaultWorkTab: work.defaultTab,
        workParts: $792124e2f7de719a$export$a532ffe01c3d7cc7.map((part)=>({
                ...part,
                visible: !hiddenWork.has(part.id)
            })),
        copilotTabs: copilot.tabs,
        defaultCopilotTab: copilot.defaultTab
    };
}
const $792124e2f7de719a$export$e111fe7e8e6c2d5d = (layout)=>layout.recordSections.filter((s)=>s.visible);
const $792124e2f7de719a$export$6a56c49bd01f6de1 = (layout)=>layout.workTabs.filter((t)=>t.visible);
const $792124e2f7de719a$export$8ea4bfdcdcef566 = (layout)=>layout.copilotTabs.filter((t)=>t.visible);
const $792124e2f7de719a$export$172b3bca5806e964 = (layout, id)=>layout.recordSections.some((s)=>s.id === id && s.visible);
const $792124e2f7de719a$export$b53be2f13fbaae05 = (layout, id)=>!(layout.workParts || []).some((p)=>p.id === id && !p.visible);
const $792124e2f7de719a$export$f9d63a319ff0f5db = (layout)=>Object.fromEntries(layout.recordSections.map((s)=>[
            s.id,
            !s.collapsed
        ]));
// ── Editor operations — pure, return the PATCH to persist ────────────────────
//
// Each takes the stored settings (sparse) and returns only the keys that
// change, in the stored shape, so the caller can hand the result straight to
// the partial-update mutation.
const $792124e2f7de719a$var$without = (list, id)=>$792124e2f7de719a$var$asList(list).filter((x)=>x !== id);
const $792124e2f7de719a$var$withId = (list, id)=>$792124e2f7de719a$var$asList(list).includes(id) ? $792124e2f7de719a$var$asList(list) : [
        ...$792124e2f7de719a$var$asList(list),
        id
    ];
function $792124e2f7de719a$export$740573c0382b46de(settings, id, toIndex) {
    const order = $792124e2f7de719a$export$3847309b37cec074($792124e2f7de719a$export$286013f25f0f7b72, settings?.recordSectionOrder).map((s)=>s.id);
    const from = order.indexOf(id);
    const to = Math.max(0, Math.min(order.length - 1, Math.trunc(toIndex)));
    if (from === -1 || from === to || !Number.isFinite(toIndex)) return {};
    const next = [
        ...order
    ];
    next.splice(from, 1);
    next.splice(to, 0, id);
    return {
        recordSectionOrder: next
    };
}
function $792124e2f7de719a$export$64d504ab69df77b0(settings, id, delta) {
    const order = $792124e2f7de719a$export$3847309b37cec074($792124e2f7de719a$export$286013f25f0f7b72, settings?.recordSectionOrder).map((s)=>s.id);
    const from = order.indexOf(id);
    if (from === -1) return {};
    const to = from + delta;
    if (to < 0 || to >= order.length) return {};
    return $792124e2f7de719a$export$740573c0382b46de(settings, id, to);
}
function $792124e2f7de719a$export$276da83ac94a32f6(settings, id, visible) {
    const section = $792124e2f7de719a$export$286013f25f0f7b72.find((s)=>s.id === id);
    if (!section || section.locked) return {};
    return {
        recordSectionsHidden: visible ? $792124e2f7de719a$var$without(settings?.recordSectionsHidden, id) : $792124e2f7de719a$var$withId(settings?.recordSectionsHidden, id)
    };
}
function $792124e2f7de719a$export$38f0593b6bfb6420(settings, id, collapsed) {
    return {
        recordSectionsCollapsed: collapsed ? $792124e2f7de719a$var$withId(settings?.recordSectionsCollapsed, id) : $792124e2f7de719a$var$without(settings?.recordSectionsCollapsed, id)
    };
}
function $792124e2f7de719a$export$7eeed700e5288c3(settings, id, visible) {
    const tab = $792124e2f7de719a$export$b42ce7b9554c2388.find((t)=>t.id === id);
    if (!tab || tab.locked) return {};
    return {
        workTabsHidden: visible ? $792124e2f7de719a$var$without(settings?.workTabsHidden, id) : $792124e2f7de719a$var$withId(settings?.workTabsHidden, id)
    };
}
function $792124e2f7de719a$export$e52c1bcf705c8293(settings, id, visible) {
    if (!$792124e2f7de719a$export$a532ffe01c3d7cc7.some((p)=>p.id === id)) return {};
    return {
        workTabsHidden: visible ? $792124e2f7de719a$var$without(settings?.workTabsHidden, id) : $792124e2f7de719a$var$withId(settings?.workTabsHidden, id)
    };
}
function $792124e2f7de719a$export$fa98c16fa5ba5172(settings, id, visible) {
    if (!$792124e2f7de719a$export$cf705f4052b87526.some((t)=>t.id === id)) return {};
    const hidden = visible ? $792124e2f7de719a$var$without(settings?.copilotTabsHidden, id) : $792124e2f7de719a$var$withId(settings?.copilotTabsHidden, id);
    // The last visible tab cannot be hidden — the resolver would un-hide
    // everything, which is not what the click meant.
    if ($792124e2f7de719a$export$cf705f4052b87526.every((t)=>hidden.includes(t.id))) return {};
    return {
        copilotTabsHidden: hidden
    };
}
const $792124e2f7de719a$export$aeba1cec85888be3 = (settings, id)=>$792124e2f7de719a$export$b42ce7b9554c2388.some((t)=>t.id === id) ? {
        defaultWorkTab: id
    } : {};
const $792124e2f7de719a$export$ceb766f504646314 = (settings, id)=>$792124e2f7de719a$export$cf705f4052b87526.some((t)=>t.id === id) ? {
        defaultCopilotTab: id
    } : {};
function $792124e2f7de719a$export$4deb366eab2f1d1a(settings) {
    const s = {
        ...$792124e2f7de719a$export$df312747b9dc7053,
        ...settings || {}
    };
    const untouchedOrder = $792124e2f7de719a$export$3847309b37cec074($792124e2f7de719a$export$286013f25f0f7b72, s.recordSectionOrder).every((sec, i)=>sec.id === $792124e2f7de719a$export$286013f25f0f7b72[i].id);
    return untouchedOrder && $792124e2f7de719a$var$asList(s.recordSectionsHidden).length === 0 && $792124e2f7de719a$var$asList(s.recordSectionsCollapsed).length === 0 && $792124e2f7de719a$var$asList(s.workTabsHidden).length === 0 && s.defaultWorkTab === $792124e2f7de719a$export$df312747b9dc7053.defaultWorkTab && $792124e2f7de719a$var$asList(s.copilotTabsHidden).length === 0 && s.defaultCopilotTab === $792124e2f7de719a$export$df312747b9dc7053.defaultCopilotTab;
}
// ── Mobile ───────────────────────────────────────────────────────────────────
//
// Visit.mobile.jsx is a reduction of the desktop page and names its tabs
// differently (note / diff / rx / ord). The same preference applies through
// this mapping: hiding «نسخه» on the desktop hides it on the phone too. There
// is no differential nav tab — on the phone it lives in the copilot sheet.
const $792124e2f7de719a$var$MOBILE_TAB_SOURCE = {
    note: {
        kind: 'work',
        id: 'soap'
    },
    rx: {
        kind: 'work',
        id: 'rx'
    },
    ord: {
        kind: 'work',
        id: 'orders'
    }
};
function $792124e2f7de719a$export$6fd5b56eddd00f9b(layout, mobileId) {
    const src = $792124e2f7de719a$var$MOBILE_TAB_SOURCE[mobileId];
    if (!src) return true;
    const pool = src.kind === 'work' ? layout.workTabs : layout.copilotTabs;
    return pool.some((t)=>t.id === src.id && t.visible);
}
function $792124e2f7de719a$export$dde3a1a6c2d91941(layout) {
    const wanted = Object.entries($792124e2f7de719a$var$MOBILE_TAB_SOURCE).find(([, src])=>src.kind === 'work' && src.id === layout.defaultWorkTab);
    return wanted ? wanted[0] : 'note';
}
// The phone's copilot SHEET is a third surface for the same preference, and it
// carries exactly the desktop copilot's three tabs — the differential included,
// as a real panel. It is the differential's ONE home on the phone: a «تشخیص»
// nav tab used to show the same list as well, and was removed. «گفتگو» (the
// full transcript) was removed earlier; its live lines remain at the top of
// «نکات بالینی».
const $792124e2f7de719a$var$MOBILE_COPILOT_SHEET_SOURCE = {
    hints: 'sugg',
    diff: 'diff',
    ask: 'ask'
};
function $792124e2f7de719a$export$ec23aec8c07c3d8a(layout, sheetTabId) {
    const id = $792124e2f7de719a$var$MOBILE_COPILOT_SHEET_SOURCE[sheetTabId];
    if (!id) return true;
    return layout.copilotTabs.some((t)=>t.id === id && t.visible);
}
function $792124e2f7de719a$export$c5c16556be0d657b(layout, order = [
    'hints',
    'diff',
    'ask'
]) {
    const preferred = Object.entries($792124e2f7de719a$var$MOBILE_COPILOT_SHEET_SOURCE).find(([, id])=>id === layout.defaultCopilotTab);
    if (preferred && $792124e2f7de719a$export$ec23aec8c07c3d8a(layout, preferred[0])) return preferred[0];
    return order.find((id)=>$792124e2f7de719a$export$ec23aec8c07c3d8a(layout, id)) ?? order[0];
}

});


parcelRegister("lnUwI", function(module, exports) {

$parcel$export(module.exports, "frequencyEn", () => $f91797fd10151718$export$7a6106170485de57);
$parcel$export(module.exports, "dosageEn", () => $f91797fd10151718$export$faf0542505380f3e);
$parcel$export(module.exports, "routeEn", () => $f91797fd10151718$export$cfcbced31e5dd385);
$parcel$export(module.exports, "durationEn", () => $f91797fd10151718$export$d579c09ab10cbff4);
// ─────────────────────────────────────────────────────────────────────────────
// The treatment plan speaks English.
//
// «برنامه درمان» is not UI chrome — it is a clinical document. It is read at the
// pharmacy counter, pasted into a referral, and handed to whoever sees the
// patient next, and those readers do not share the doctor's UI language. So the
// managed plan block is written in standard English regardless of the locale the
// app is running in: drug name, dose, dose form, frequency, duration, and the
// kind of every order.
//
// That is a translation problem, because the data underneath is Persian. The
// formulary stores `generic_name` in Latin (usable as-is) but `common_dosages`
// carries Persian dose-form words («ویال 500mg») and `common_frequencies` is
// entirely Persian («روزی دو بار»). This module is the one place that maps them.
//
// Two rules for everything here:
//
//   1. A value we cannot map is passed through UNCHANGED, never dropped and
//      never guessed at. A doctor seeing their own words is recoverable; a
//      silently altered dose is not.
//   2. Mapping is done on a NORMALISED string (Persian digits folded to ASCII,
//      ZWNJ removed, whitespace collapsed) so that «هر ۸ ساعت» and «هر 8 ساعت»
//      are the same input. The normalisation is for LOOKUP only — anything
//      passed through keeps the doctor's original spelling.
//
// The tables below were built from the actual seed data (616 drugs,
// clinicalencounter `drug_formulary_data.py`), not from imagination: every distinct
// `common_frequencies` value and every dose-form token in `common_dosages` is
// covered, with a compositional fallback for the numeric patterns so a value
// added to the formulary later («هر ۱۰ ساعت») still comes out English.
// ─────────────────────────────────────────────────────────────────────────────
/* eslint-disable */ // Character classes, not per-glyph tables: the invisible members (ZWNJ, ZWJ,
// bidi marks, NBSP) cannot be reviewed by eye, and one silently lost from a
// literal table would stop the whole thing matching.
const $f91797fd10151718$var$FA_DIGIT = /[۰-۹٠-٩]/g; // Persian and Arabic-Indic digits
const $f91797fd10151718$var$INVISIBLE = /[​-‏ ]/g; // ZWNJ, ZWJ, bidi marks, NBSP
const $f91797fd10151718$var$PERSIAN_LETTER = /[؀-ۿ]/;
function $f91797fd10151718$export$a7f0d01bd35ee833(text) {
    return String(text ?? '').replace($f91797fd10151718$var$FA_DIGIT, (d)=>String(d.codePointAt(0) & 0xf)).replace($f91797fd10151718$var$INVISIBLE, ' ').replace(/\s+/g, ' ').trim();
}
function $f91797fd10151718$export$7c06148ed8936def(text) {
    return $f91797fd10151718$var$PERSIAN_LETTER.test(String(text ?? ''));
}
// Persian number words, for the frequency patterns that spell the count out
// («هر دو هفته یک بار») rather than using a digit.
// i18n-exempt: lookup keys, matched against stored formulary values — never displayed
const $f91797fd10151718$var$FA_NUMBER_WORDS = {
    "\u06CC\u06A9": 1,
    "\u062F\u0648": 2,
    "\u0633\u0647": 3,
    "\u0686\u0647\u0627\u0631": 4,
    "\u067E\u0646\u062C": 5,
    "\u0634\u0634": 6,
    "\u0647\u0641\u062A": 7,
    "\u0647\u0634\u062A": 8,
    "\u0646\u0647": 9,
    "\u062F\u0647": 10,
    "\u062F\u0648\u0627\u0632\u062F\u0647": 12,
    "\u0628\u06CC\u0633\u062A": 20,
    "\u0628\u06CC\u0633\u062A \u0648 \u0686\u0647\u0627\u0631": 24
};
const $f91797fd10151718$var$faCount = (token)=>{
    const t = (token || '').trim();
    if (/^\d+$/.test(t)) return Number(t);
    return $f91797fd10151718$var$FA_NUMBER_WORDS[t] ?? null;
};
// "once / twice / three times", the way a prescription is written in English.
const $f91797fd10151718$var$TIMES = [
    '',
    'once',
    'twice',
    'three times',
    'four times',
    'five times',
    'six times'
];
const $f91797fd10151718$var$timesWord = (n)=>$f91797fd10151718$var$TIMES[n] || `${n} times`;
// i18n-exempt: lookup keys, matched against stored formulary values — never displayed
const $f91797fd10151718$var$UNIT_EN = {
    "\u0633\u0627\u0639\u062A": 'hour',
    "\u0631\u0648\u0632": 'day',
    "\u0647\u0641\u062A\u0647": 'week',
    "\u0645\u0627\u0647": 'month',
    "\u0633\u0627\u0644": 'year'
};
const $f91797fd10151718$var$plural = (unit, n)=>n === 1 ? unit : `${unit}s`;
// ── Frequency ────────────────────────────────────────────────────────────────
//
// Idioms first: phrases whose English is not a function of their parts. The
// numeric families («روزی N بار», «هر N ساعت») are handled by pattern below, so
// they are deliberately NOT enumerated here.
// i18n-exempt: lookup keys, matched against stored formulary values — never displayed
const $f91797fd10151718$var$FREQUENCY_IDIOMS = {
    "\u062F\u0631 \u0635\u0648\u0631\u062A \u0646\u06CC\u0627\u0632": 'as needed (PRN)',
    "\u0634\u0628\u0627\u0646\u0647 \u06CC\u06A9 \u0628\u0627\u0631": 'once nightly',
    "\u0642\u0628\u0644 \u0627\u0632 \u0648\u0639\u062F\u0647 \u063A\u0630\u0627\u06CC\u06CC": 'before meals',
    "\u0647\u0645\u0631\u0627\u0647 \u0628\u0627 \u0648\u0639\u062F\u0647 \u063A\u0630\u0627\u06CC\u06CC": 'with meals',
    "\u0631\u0648\u0632\u06CC \u06CC\u06A9 \u0628\u0627\u0631 \u0646\u0627\u0634\u062A\u0627": 'once daily on an empty stomach',
    "\u0645\u0627\u0647\u06CC \u06CC\u06A9 \u0628\u0627\u0631": 'once monthly',
    "\u0633\u0627\u0644\u06CC \u06CC\u06A9 \u0628\u0627\u0631": 'once yearly',
    "\u06CC\u06A9 \u0631\u0648\u0632 \u062F\u0631 \u0645\u06CC\u0627\u0646": 'every other day',
    "\u062F\u0648\u0632 \u0648\u0627\u062D\u062F": 'single dose',
    "\u06CC\u06A9 \u0628\u0627\u0631 (\u062F\u0648\u0632)": 'single dose',
    "\u06CC\u06A9 \u0628\u0627\u0631": 'single dose',
    "\u0628\u0639\u062F \u0627\u0632 \u0647\u0631 \u0627\u0633\u0647\u0627\u0644": 'after each loose stool',
    "\u06CC\u06A9 \u0633\u0627\u0639\u062A \u0642\u0628\u0644": 'one hour before',
    "\u062D\u062F\u0627\u06A9\u062B\u0631 \u0631\u0648\u0632\u06CC \u062F\u0648 \u0628\u0627\u0631": 'max twice daily',
    "\u0646\u0627\u0634\u062A\u0627": 'on an empty stomach',
    "\u0642\u0628\u0644 \u0627\u0632 \u062E\u0648\u0627\u0628": 'at bedtime',
    "\u0635\u0628\u062D": 'in the morning',
    "\u0634\u0628": 'at night'
};
/**
 * The numeric frequency families:
 *   روزی N بار / هفته‌ای N بار  → N times daily / weekly
 *   هر N [تا M] <unit> [یک بار] → every N [to M] <unit>s
 *   حداکثر Nmg در روز           → max Nmg per day
 * Returns null when nothing matches, so the caller can fall through.
 */ function $f91797fd10151718$var$frequencyByPattern(s) {
    let m;
    if (m = s.match(/^روزی\s+(\S+)\s+بار$/)) {
        const n = $f91797fd10151718$var$faCount(m[1]);
        if (n) return `${$f91797fd10151718$var$timesWord(n)} daily`;
    }
    if (m = s.match(/^هفته\s*ای\s+(\S+)\s+بار$/)) {
        const n = $f91797fd10151718$var$faCount(m[1]);
        if (n) return `${$f91797fd10151718$var$timesWord(n)} weekly`;
    }
    if (m = s.match(/^ماهی\s+(\S+)\s+بار$/)) {
        const n = $f91797fd10151718$var$faCount(m[1]);
        if (n) return `${$f91797fd10151718$var$timesWord(n)} monthly`;
    }
    // «هر ۸ ساعت», «هر ۴ تا ۶ ساعت», «هر ۳ هفته یک بار», «هر دو هفته یک بار»
    if (m = s.match(/^هر\s+(\S+)(?:\s+تا\s+(\S+))?\s+(ساعت|روز|هفته|ماه|سال)(?:\s+یک\s+بار)?$/)) {
        const from = $f91797fd10151718$var$faCount(m[1]);
        const to = m[2] ? $f91797fd10151718$var$faCount(m[2]) : null;
        const unit = $f91797fd10151718$var$UNIT_EN[m[3]];
        if (from && unit) return to ? `every ${from} to ${to} ${$f91797fd10151718$var$plural(unit, to)}` : `every ${from} ${$f91797fd10151718$var$plural(unit, from)}`;
    }
    if (m = s.match(/^حداکثر\s+(.+?)\s+در\s+روز$/)) return `max ${m[1]} per day`;
    return null;
}
function $f91797fd10151718$export$7a6106170485de57(raw) {
    const original = String(raw ?? '').trim();
    if (!original) return '';
    const s = $f91797fd10151718$export$a7f0d01bd35ee833(original);
    const paren = s.match(/^(.*?)\s*\((.+)\)$/);
    if (paren) {
        const head = $f91797fd10151718$export$7a6106170485de57(paren[1]);
        const inner = paren[2].trim();
        const innerEn = $f91797fd10151718$export$7c06148ed8936def(inner) ? $f91797fd10151718$export$7a6106170485de57(inner) : inner;
        return `${head} (${innerEn})`;
    }
    if ($f91797fd10151718$var$FREQUENCY_IDIOMS[s]) return $f91797fd10151718$var$FREQUENCY_IDIOMS[s];
    return $f91797fd10151718$var$frequencyByPattern(s) || original;
}
// ── Dose forms ───────────────────────────────────────────────────────────────
//
// `common_dosages` mixes a Latin strength with a Persian dose form, in either
// order: «ویال 500mg», «250mg/5ml شربت», «0.4mg زیرزبانی». Only the Persian
// tokens are translated; the strength is left exactly as stored, because it is
// the one part of a prescription that must never be paraphrased.
//
// Longest match first — «قطره چشمی» must not be read as «قطره» + «چشمی».
// i18n-exempt: lookup keys, matched against stored formulary values — never displayed
const $f91797fd10151718$var$DOSE_FORM_EN = {
    "\u0633\u0631\u0646\u06AF \u0622\u0645\u0627\u062F\u0647": 'prefilled syringe',
    "\u0622\u0645\u0627\u062F\u0647 \u062A\u0632\u0631\u06CC\u0642": 'ready-to-inject',
    "\u0642\u0637\u0631\u0647 \u0686\u0634\u0645\u06CC": 'eye drops',
    "\u0642\u0637\u0631\u0647 \u0628\u06CC\u0646\u06CC": 'nasal drops',
    "\u0642\u0637\u0631\u0647 \u06AF\u0648\u0634": 'ear drops',
    "\u0642\u0637\u0631\u0647 \u062E\u0648\u0631\u0627\u06A9\u06CC": 'oral drops',
    "\u0627\u0633\u067E\u0631\u06CC \u0628\u06CC\u0646\u06CC": 'nasal spray',
    "\u0627\u0633\u067E\u0631\u06CC \u0627\u0633\u062A\u0646\u0634\u0627\u0642\u06CC": 'inhaler',
    "\u0698\u0644 \u062F\u0647\u0627\u0646\u06CC": 'oral gel',
    "\u0622\u0647\u0633\u062A\u0647 \u0631\u0647\u0634": 'extended release',
    "\u0633\u0648\u0633\u067E\u0627\u0646\u0633\u06CC\u0648\u0646": 'suspension',
    "\u062F\u0647\u0627\u0646\u0634\u0648\u06CC\u0647": 'mouthwash',
    "\u0627\u06CC\u0645\u067E\u0644\u0646\u062A": 'implant',
    "\u06A9\u0627\u0631\u062A\u0631\u06CC\u062C": 'cartridge',
    "\u0627\u0646\u0641\u0648\u0632\u06CC\u0648\u0646": 'infusion',
    "\u0627\u0633\u067E\u0627\u06CC\u0646\u0627\u0644": 'spinal',
    "\u062F\u06A9\u0627\u0646\u0648\u0627\u062A": 'decanoate',
    "\u0645\u06CC\u0644\u06CC \u0644\u06CC\u062A\u0631": 'ml',
    // The dose units of the closed دوز list (lib/rxOptions.js).
    "\u0633\u06CC \u0633\u06CC": 'ml',
    "\u067E\u0627\u0641": 'puff',
    "\u0639\u062F\u062F": 'unit',
    "\u0632\u06CC\u0631\u0632\u0628\u0627\u0646\u06CC": 'sublingual',
    "\u062C\u0648\u06CC\u062F\u0646\u06CC": 'chewable',
    "\u0648\u0627\u0698\u06CC\u0646\u0627\u0644": 'vaginal',
    "\u0644\u0648\u0633\u06CC\u0648\u0646": 'lotion',
    "\u0645\u062D\u0644\u0648\u0644": 'solution',
    "\u0622\u0645\u067E\u0648\u0644": 'ampoule',
    "\u06A9\u067E\u0633\u0648\u0644": 'capsule',
    "\u0648\u06CC\u0627\u0644": 'vial',
    "\u0627\u0633\u06A9\u0631\u0627\u0628": 'scrub',
    "\u0634\u0627\u0645\u067E\u0648": 'shampoo',
    "\u062F\u0647\u0627\u0646\u06CC": 'oral',
    "\u0634\u0631\u0628\u062A": 'syrup',
    "\u0634\u06CC\u0627\u0641": 'suppository',
    "\u0633\u0627\u0634\u0647": 'sachet',
    "\u067E\u0645\u0627\u062F": 'ointment',
    "\u0642\u0637\u0631\u0647": 'drops',
    "\u0648\u0627\u062D\u062F": 'units',
    "\u0627\u0646\u0645\u0627": 'enema',
    "\u06A9\u0631\u0645": 'cream',
    "\u067E\u0648\u062F\u0631": 'powder',
    "\u0642\u0631\u0635": 'tablet',
    "\u0627\u0633\u067E\u0631\u06CC": 'spray',
    "\u0633\u0631\u0645": 'infusion',
    "\u0642\u0644\u0645": 'pen',
    "\u067E\u0686": 'patch',
    "\u0698\u0644": 'gel'
};
const $f91797fd10151718$var$DOSE_FORM_KEYS = Object.keys($f91797fd10151718$var$DOSE_FORM_EN).sort((a, b)=>b.length - a.length);
function $f91797fd10151718$export$faf0542505380f3e(raw) {
    const original = String(raw ?? '').trim();
    if (!original || !$f91797fd10151718$export$7c06148ed8936def(original)) return original;
    // «۰٫۵ قرص»: the Persian decimal separator, which normalizeFa leaves alone.
    let rest = $f91797fd10151718$export$a7f0d01bd35ee833(original).replace(/٫/g, '.');
    const forms = [];
    for (const key of $f91797fd10151718$var$DOSE_FORM_KEYS){
        const at = rest.indexOf(key);
        if (at === -1) continue;
        forms.push($f91797fd10151718$var$DOSE_FORM_EN[key]);
        rest = `${rest.slice(0, at)} ${rest.slice(at + key.length)}`.replace(/\s+/g, ' ').trim();
    }
    if (!forms.length) return original;
    return [
        rest,
        forms.join(' ')
    ].map((x)=>x.trim()).filter(Boolean).join(' ');
}
// ── Route of administration ──────────────────────────────────────────────────
//
// Unlike dose and frequency, the route comes from a CLOSED list this app renders
// itself (`RX_ROUTES` in Visit.shared.js), so the mapping is exact rather than
// best-effort. Both spellings have to be covered: under a Persian UI the stored
// value is «خوراکی», under an English one it is already "Oral".
// i18n-exempt: lookup keys, matched against stored route values — never displayed
const $f91797fd10151718$var$ROUTE_EN = {
    "\u062E\u0648\u0631\u0627\u06A9\u06CC": 'PO',
    "\u0632\u06CC\u0631\u0632\u0628\u0627\u0646\u06CC": 'SL',
    "\u062A\u0632\u0631\u06CC\u0642 \u0648\u0631\u06CC\u062F\u06CC": 'IV',
    "\u062A\u0632\u0631\u06CC\u0642 \u0639\u0636\u0644\u0627\u0646\u06CC": 'IM',
    "\u062A\u0632\u0631\u06CC\u0642 \u0632\u06CC\u0631\u062C\u0644\u062F\u06CC": 'SC',
    "\u0645\u0648\u0636\u0639\u06CC (\u067E\u0648\u0633\u062A\u06CC)": 'topical',
    "\u0627\u0633\u062A\u0646\u0634\u0627\u0642\u06CC": 'inhaled',
    "\u0642\u0637\u0631\u0647 \u0686\u0634\u0645\u06CC": 'ophthalmic',
    "\u0642\u0637\u0631\u0647 \u06AF\u0648\u0634\u06CC": 'otic',
    "\u0628\u06CC\u0646\u06CC": 'intranasal',
    "\u0645\u0642\u0639\u062F\u06CC": 'PR',
    "\u0648\u0627\u0698\u06CC\u0646\u0627\u0644": 'PV'
};
function $f91797fd10151718$export$cfcbced31e5dd385(raw) {
    const original = String(raw ?? '').trim();
    if (!original) return '';
    const s = $f91797fd10151718$export$a7f0d01bd35ee833(original);
    if ($f91797fd10151718$var$ROUTE_EN[s]) return $f91797fd10151718$var$ROUTE_EN[s];
    // Already-English values (English UI) pass straight through; so does anything
    // unrecognised, per rule 1 at the top of this file.
    return original;
}
// ── Duration ─────────────────────────────────────────────────────────────────
//
// Durations come from a closed list the UI renders through i18n, so the stored
// value is «7 روز» under a Persian UI, "7 days" under an English one, «7 أيام» /
// «شهران» under an Arabic one, «7 jours» / «2 mois» under a French one and
// «7 Tage» / «2 Monate» under a German one. All of them must print as English
// here — never «for 7 jours» or «for 7 Tage» in the English plan.
// i18n-exempt: lookup keys, matched against stored formulary values — never displayed
const $f91797fd10151718$var$DURATION_IDIOMS = {
    "\u062A\u0627 \u0627\u0637\u0644\u0627\u0639 \u062B\u0627\u0646\u0648\u06CC": 'until further notice',
    "\u062A\u0627 \u0627\u0637\u0644\u0627\u0639 \u0628\u0639\u062F\u06CC": 'until further notice',
    "\u062D\u062A\u0649 \u0625\u0634\u0639\u0627\u0631 \u0622\u062E\u0631": 'until further notice',
    "jusqu\u2019\xe0 nouvel ordre": 'until further notice',
    'bis auf weiteres': 'until further notice',
    // Arabic counts one and two in the noun itself, with no digit.
    "\u064A\u0648\u0645": '1 day',
    "\u064A\u0648\u0645\u0627\u0646": '2 days',
    "\u0623\u0633\u0628\u0648\u0639": '1 week',
    "\u0623\u0633\u0628\u0648\u0639\u0627\u0646": '2 weeks',
    "\u0634\u0647\u0631": '1 month',
    "\u0634\u0647\u0631\u0627\u0646": '2 months'
};
// The units a duration is written in, in the Persian, Arabic, French and German lists
// (`visit.duration.*`); matched lower-cased. English passes through as written.
// i18n-exempt: lookup keys, matched against stored duration values — never displayed
const $f91797fd10151718$var$DURATION_UNIT_EN = {
    "\u0633\u0627\u0639\u062A": 'hour',
    "\u0631\u0648\u0632": 'day',
    "\u0647\u0641\u062A\u0647": 'week',
    "\u0645\u0627\u0647": 'month',
    "\u0633\u0627\u0644": 'year',
    "\u0633\u0627\u0639\u0629": 'hour',
    "\u0633\u0627\u0639\u0627\u062A": 'hour',
    "\u064A\u0648\u0645": 'day',
    "\u064A\u0648\u0645\u064B\u0627": 'day',
    "\u064A\u0648\u0645\u0627": 'day',
    "\u0623\u064A\u0627\u0645": 'day',
    "\u0623\u0633\u0628\u0648\u0639": 'week',
    "\u0623\u0633\u0627\u0628\u064A\u0639": 'week',
    "\u0623\u0633\u0628\u0648\u0639\u064B\u0627": 'week',
    "\u0623\u0633\u0628\u0648\u0639\u0627": 'week',
    "\u0634\u0647\u0631": 'month',
    "\u0634\u0647\u0631\u064B\u0627": 'month',
    "\u0634\u0647\u0631\u0627": 'month',
    "\u0623\u0634\u0647\u0631": 'month',
    "\u0634\u0647\u0648\u0631": 'month',
    'heure': 'hour',
    'heures': 'hour',
    'jour': 'day',
    'jours': 'day',
    'semaine': 'week',
    'semaines': 'week',
    'mois': 'month',
    'an': 'year',
    'ans': 'year',
    'stunde': 'hour',
    'stunden': 'hour',
    'tag': 'day',
    'tage': 'day',
    'tagen': 'day',
    'woche': 'week',
    'wochen': 'week',
    'monat': 'month',
    'monate': 'month',
    'monaten': 'month',
    'jahr': 'year',
    'jahre': 'year',
    'jahren': 'year'
};
function $f91797fd10151718$export$d579c09ab10cbff4(raw) {
    const original = String(raw ?? '').trim();
    if (!original) return '';
    // Lower-cased, with the apostrophe folded to the typographic one the French
    // catalogue writes («Jusqu’à nouvel ordre»): for LOOKUP only, like normalizeFa.
    const s = $f91797fd10151718$export$a7f0d01bd35ee833(original).toLowerCase().replace(/'/g, "\u2019");
    if ($f91797fd10151718$var$DURATION_IDIOMS[s]) return $f91797fd10151718$var$DURATION_IDIOMS[s];
    const m = s.match(/^(\d+)\s*(\S+)$/);
    const unit = m && $f91797fd10151718$var$DURATION_UNIT_EN[m[2]];
    if (unit) {
        const n = Number(m[1]);
        return `${n} ${$f91797fd10151718$var$plural(unit, n)}`;
    }
    return original;
}

});

parcelRegister("1yr2B", function(module, exports) {

$parcel$export(module.exports, "loadCreditPrices", () => $121df138798ec781$export$84016827a72d6537);
$parcel$export(module.exports, "costOf", () => $121df138798ec781$export$c932aceb7c67d0f4);
$parcel$export(module.exports, "usePurchaseAvailable", () => $121df138798ec781$export$34ab9a07791a6651);
$parcel$export(module.exports, "useCreditPrices", () => $121df138798ec781$export$204bd72286fdb787);
// The پارسه price list, resolved — ONE server-side list instead of the
// hardcoded constants (docs/AI_COST_AND_PARSEH_PRICING_MANAGEMENT_DESIGN.md
// §9.2, phase 3).
//
// Every price this app prints or charges to the visit ledger goes through
// `costOf(actionId)` below. The action ids are the ones the app already used
// (`COIN_COSTS.ASK_QUESTION`, …); `SERVICE_KEY_BY_ACTION` is the ONE table that
// maps them onto the AI RPC names the service prices — change a mapping here,
// nowhere else.
//
// ── The constants are the fallback and the first paint ──────────────────────
// `constants/creditPricing.js` is what renders before the list has arrived and
// what renders when it never does (offline, BFF down, the AI service down and
// the BFF serving its own frozen copy). A price chip therefore NEVER spins and
// never goes blank: it shows the shipped number, then the policy's number the
// moment it is known. `source` says which one is on screen.
//
// ── Fetched once per page load, remembered for the session ──────────────────
// The list is read through the app's own GraphQL client the first time any
// surface asks for it and shared by every component after that (a module-level
// store read through `useSyncExternalStore`). The last answer is also kept in
// sessionStorage so a reload paints the policy price first, not the constant.
// A FAILED read is not remembered: the next surface to mount tries again.
//
// ── Buying credit, and what one costs in money (PM-0211) ────────────────────
// The same answer carries the wallet's side (docs/platform-money/CONTRACT.md §5):
// `creditPrice { amountMinor currency }`, `packages` and `purchaseAvailable`.
// They do not depend on the AI price list, so they are kept whatever `source`
// says. Every «خرید پارسه» / «شارژ اعتبار» entry point asks `purchaseAvailable()`;
// until the BFF has said, the brand's market answers (Iran: yes — today; any
// other market: no), so neither deployment flashes a button it then takes away.
// A BFF that predates the fields refuses the whole query; it is then asked the
// old one, so the price chips never fall back to the constants because of it.

var $acw62 = parcelRequire("acw62");

var $eVM84 = parcelRequire("eVM84");

var $eLeza = parcelRequire("eLeza");

var $3EzBq = parcelRequire("3EzBq");
const $121df138798ec781$export$c3ecc18ec062bc34 = Object.freeze({
    TRANSCRIPTION_PER_MIN: 'TranscribeAudio',
    TRANSCRIPTION_PARSINA_PER_MIN: 'TranscribeAudioParsina',
    ASK_QUESTION: 'AskDoctorQuestion',
    SOAP_REFINE: 'RefineSoapNote',
    RECOMMENDATIONS: 'RecommendTestsAndMedications',
    DIFFERENTIAL: 'GetDifferentialDiagnosis',
    CONFIRM_QUESTIONS: 'GenerateConfirmationQuestions',
    TREATMENT_PLAN: 'SuggestTreatmentPlan',
    DOCTOR_ORDERS: 'SuggestDoctorOrders',
    OCR: 'ProcessDocumentOCR',
    ANALYZE_FILE: 'AnalyzeClinicalFile',
    INTERACTION_CHECK: 'CheckDrugInteraction',
    ASSIST_PRESCRIPTION: 'AssistPrescription',
    RX_VOICE: 'ParseMedicationVoice',
    RX_MONITORING: 'ExtractMonitoringMedications',
    RX_HISTORY: 'SuggestMedicationsFromHistory',
    RX_DIRECTIONS: 'CompleteRxDirections',
    MONITORING_VITALS: 'ExtractMonitoringVitals',
    MONITORING_ORDERS: 'ExtractMonitoringOrders',
    MONITORING_RECORD: 'ExtractMonitoringRecord'
});
const $121df138798ec781$export$f5e24740e23fe4a0 = `
  query CreditPrices {
    creditPrices {
      source
      policyId
      parsehToman
      generatedAt
      items { serviceKey unit parseh priceSource }
      creditPrice { amountMinor currency }
      packages
      purchaseAvailable
    }
  }
`;
const $121df138798ec781$export$fc2d6e3af2c81503 = `
  query CreditPrices {
    creditPrices {
      source
      policyId
      parsehToman
      generatedAt
      items { serviceKey unit parseh priceSource }
    }
  }
`;
const $121df138798ec781$var$STORAGE_KEY = 'parsina:creditPrices:v1';
const $121df138798ec781$var$FALLBACK_STATE = Object.freeze({
    byService: null,
    parsehToman: null,
    policyId: null,
    source: 'fallback',
    loaded: false,
    // The wallet's side — null until the BFF has said (purchaseFromAnswer).
    creditPrice: null,
    packages: null,
    purchaseAvailable: null
});
let $121df138798ec781$var$state = $121df138798ec781$var$FALLBACK_STATE;
const $121df138798ec781$var$listeners = new Set();
let $121df138798ec781$var$inflight = null;
let $121df138798ec781$var$answered = false; // a SERVICE answer landed this page load — read once
function $121df138798ec781$var$emit(next) {
    $121df138798ec781$var$state = next;
    for (const fn of $121df138798ec781$var$listeners)fn();
}
function $121df138798ec781$export$34eacae788ce613f(list) {
    const price = list?.creditPrice;
    const amount = Number(price?.amountMinor);
    const currency = typeof price?.currency === 'string' ? price.currency.trim() : '';
    const creditPrice = currency && currency !== (0, $3EzBq.CREDIT_TOMAN) && Number.isFinite(amount) && amount > 0 ? {
        amountMinor: amount,
        currency: currency
    } : null;
    const packages = Array.isArray(list?.packages) ? list.packages.map(Number).filter((n)=>Number.isInteger(n) && n > 0) : [];
    return {
        creditPrice: creditPrice,
        // Empty = the deployment names none: each surface keeps its own list.
        packages: packages.length ? packages : null,
        purchaseAvailable: typeof list?.purchaseAvailable === 'boolean' ? list.purchaseAvailable : null
    };
}
function $121df138798ec781$export$34ef7267354f580f(list) {
    const purchase = $121df138798ec781$export$34eacae788ce613f(list);
    if (!list || list.source !== 'service' || !Array.isArray(list.items)) // The BFF's own fallback is still the constants — say so, and keep them.
    return {
        ...$121df138798ec781$var$FALLBACK_STATE,
        ...purchase,
        loaded: true
    };
    const byService = new Map();
    for (const item of list.items){
        // An unpriced row (null) leaves the constant in place: a chip must never
        // go blank for a service the AI still charges under its code default.
        // Checked for null BEFORE Number(): Number(null) is 0, and 0 is a price.
        if (!item?.serviceKey || item.parseh === null || item.parseh === undefined) continue;
        const n = Number(item.parseh);
        if (Number.isFinite(n) && n >= 0) byService.set(item.serviceKey, n);
    }
    const toman = Number(list.parsehToman);
    return {
        byService: byService,
        parsehToman: Number.isFinite(toman) && toman > 0 ? Math.round(toman) : null,
        policyId: list.policyId || null,
        source: 'service',
        loaded: true,
        ...purchase
    };
}
function $121df138798ec781$export$477e957045ea2243(list) {
    const next = $121df138798ec781$export$34ef7267354f580f(list);
    if (next.source === 'service') {
        $121df138798ec781$var$answered = true;
        try {
            sessionStorage.setItem($121df138798ec781$var$STORAGE_KEY, JSON.stringify(list));
        } catch  {}
    }
    $121df138798ec781$var$emit(next);
}
function $121df138798ec781$export$230b85c65d633100() {
    $121df138798ec781$var$state = $121df138798ec781$var$FALLBACK_STATE;
    $121df138798ec781$var$inflight = null;
    $121df138798ec781$var$answered = false;
    try {
        sessionStorage.removeItem($121df138798ec781$var$STORAGE_KEY);
    } catch  {}
    for (const fn of $121df138798ec781$var$listeners)fn();
}
// A reload paints the last policy price first, not the constant.
try {
    const cached = sessionStorage.getItem($121df138798ec781$var$STORAGE_KEY);
    if (cached) {
        const restored = $121df138798ec781$export$34ef7267354f580f(JSON.parse(cached));
        if (restored.source === 'service') $121df138798ec781$var$state = {
            ...restored,
            loaded: false
        };
    }
} catch  {}
/** Apollo's answer to a field the schema does not have (an older BFF). */ function $121df138798ec781$var$isSchemaRefusal(err) {
    const errors = err?.graphQLErrors || [];
    return err?.extensions?.code === 'GRAPHQL_VALIDATION_FAILED' || errors.some((e)=>e?.extensions?.code === 'GRAPHQL_VALIDATION_FAILED') || /Cannot query field/.test(String(err?.message || ''));
}
/** The wallet fields of a non-service answer, over what is held: unsaid keeps the held value. */ function $121df138798ec781$var$wallet(list) {
    const said = $121df138798ec781$export$34eacae788ce613f(list);
    return {
        creditPrice: said.creditPrice ?? $121df138798ec781$var$state.creditPrice,
        packages: said.packages ?? $121df138798ec781$var$state.packages,
        purchaseAvailable: said.purchaseAvailable ?? $121df138798ec781$var$state.purchaseAvailable
    };
}
function $121df138798ec781$export$84016827a72d6537() {
    if ($121df138798ec781$var$answered) return Promise.resolve($121df138798ec781$var$state);
    if ($121df138798ec781$var$inflight) return $121df138798ec781$var$inflight;
    $121df138798ec781$var$inflight = Promise.resolve().then(()=>(0, $eVM84.bffQuery)($121df138798ec781$export$f5e24740e23fe4a0).catch((err)=>{
            // A BFF older than the wallet fields refuses the whole document; ask it
            // the old question. Any other failure is a failure.
            if (!$121df138798ec781$var$isSchemaRefusal(err)) throw err;
            return (0, $eVM84.bffQuery)($121df138798ec781$export$fc2d6e3af2c81503);
        })).then((data)=>{
        const list = data?.creditPrices;
        if (list && list.source === 'service') $121df138798ec781$export$477e957045ea2243(list);
        else $121df138798ec781$var$emit({
            ...$121df138798ec781$var$state,
            ...$121df138798ec781$var$wallet(list),
            loaded: true
        });
    }).catch(()=>{
        // Offline, signed out, the BFF down: the constants stay on screen.
        $121df138798ec781$var$emit({
            ...$121df138798ec781$var$state,
            loaded: true
        });
    }).finally(()=>{
        $121df138798ec781$var$inflight = null;
    }).then(()=>$121df138798ec781$var$state);
    return $121df138798ec781$var$inflight;
}
function $121df138798ec781$export$c932aceb7c67d0f4(actionId) {
    const key = $121df138798ec781$export$c3ecc18ec062bc34[actionId];
    if (key && $121df138798ec781$var$state.byService && $121df138798ec781$var$state.byService.has(key)) return $121df138798ec781$var$state.byService.get(key);
    return (0, $3EzBq.COIN_COSTS)[actionId] ?? null;
}
function $121df138798ec781$export$ca9b35f04336e4e5() {
    return $121df138798ec781$var$state.parsehToman ?? (0, $3EzBq.COIN_PRICE_TOMAN);
}
function $121df138798ec781$export$a1d28c3cec9e428f() {
    return $121df138798ec781$var$state.creditPrice ?? {
        amountMinor: $121df138798ec781$export$ca9b35f04336e4e5(),
        currency: (0, $3EzBq.CREDIT_TOMAN)
    };
}
function $121df138798ec781$export$869601a36456db2d() {
    return $121df138798ec781$var$state.purchaseAvailable ?? (0, $eLeza.isIranMarket)();
}
function $121df138798ec781$export$3a224a8d5e40047a() {
    return $121df138798ec781$var$state.packages;
}
function $121df138798ec781$export$685f009c83717b79() {
    return (0, $3EzBq.PRICE_LIST).map((row)=>({
            ...row,
            cost: $121df138798ec781$export$c932aceb7c67d0f4(row.action)
        }));
}
const $121df138798ec781$var$subscribe = (fn)=>{
    $121df138798ec781$var$listeners.add(fn);
    return ()=>$121df138798ec781$var$listeners.delete(fn);
};
const $121df138798ec781$var$getSnapshot = ()=>$121df138798ec781$var$state;
function $121df138798ec781$export$34ab9a07791a6651(load = true) {
    const snapshot = (0, $acw62.useSyncExternalStore)($121df138798ec781$var$subscribe, $121df138798ec781$var$getSnapshot, $121df138798ec781$var$getSnapshot);
    (0, $acw62.useEffect)(()=>{
        if (load) $121df138798ec781$export$84016827a72d6537();
    }, [
        load
    ]);
    return snapshot.purchaseAvailable ?? (0, $eLeza.isIranMarket)();
}
function $121df138798ec781$export$204bd72286fdb787() {
    const snapshot = (0, $acw62.useSyncExternalStore)($121df138798ec781$var$subscribe, $121df138798ec781$var$getSnapshot, $121df138798ec781$var$getSnapshot);
    (0, $acw62.useEffect)(()=>{
        $121df138798ec781$export$84016827a72d6537();
    }, []);
    return {
        costOf: $121df138798ec781$export$c932aceb7c67d0f4,
        coinPriceToman: snapshot.parsehToman ?? (0, $3EzBq.COIN_PRICE_TOMAN),
        creditPrice: snapshot.creditPrice ?? {
            amountMinor: snapshot.parsehToman ?? (0, $3EzBq.COIN_PRICE_TOMAN),
            currency: (0, $3EzBq.CREDIT_TOMAN)
        },
        packages: snapshot.packages,
        purchaseAvailable: snapshot.purchaseAvailable ?? (0, $eLeza.isIranMarket)(),
        priceList: $121df138798ec781$export$685f009c83717b79(),
        source: snapshot.source,
        policyId: snapshot.policyId,
        loaded: snapshot.loaded
    };
}

});
parcelRegister("3EzBq", function(module, exports) {

$parcel$export(module.exports, "COIN_PRICE_TOMAN", () => $2a90b979c3d41f86$export$603323bf3f7bd8d9);
$parcel$export(module.exports, "CREDIT_TOMAN", () => $2a90b979c3d41f86$export$ae8383984baa5079);
$parcel$export(module.exports, "COIN_COSTS", () => $2a90b979c3d41f86$export$e6d8c7e3d913b530);
$parcel$export(module.exports, "PRICE_LIST", () => $2a90b979c3d41f86$export$52690e1136e04e64);
$parcel$export(module.exports, "fmtCoins", () => $2a90b979c3d41f86$export$b634cc5d06849b0a);
// Parseh («پارسه») price list — the OFFLINE FALLBACK and the first-paint value.
//
// Since 2026-09-12 the price of every AI action comes from ONE server-side
// list: the AI service's active pricing policy, served by the BFF as
// `creditPrices` and read here through `src/lib/useCreditPrices.js`
// (docs/AI_COST_AND_PARSEH_PRICING_MANAGEMENT_DESIGN.md §9.2, phase 3). Every
// price chip, the Credits price list and the visit ledger's `chargeVisit` go
// through `costOf(actionId)` / `useCreditPrices()` there, so what is advertised
// follows the policy the service actually debits from.
//
// THIS FILE is what renders before that list has arrived and what renders when
// it never does (offline, BFF down). It mirrors the flat-rate schedule the AI
// service shipped with (usage_context.py / credits_policy.md):
//   transcription 5 پارسه/دقیقه · LLM actions 10 پارسه · prescription checks 3 پارسه.
// It is NOT where a price is changed — the design doc is the reference, and the
// admin panel's pricing policy is the instrument.
//
// Unit language: the unit is «پارسه» / "Parseh" — واحد اعتبار هوشمند پارسینا —
// everywhere in the UI, in both locales; never «سکه», never "coin", never the
// Latin "PC". Toman appears only at purchase and in the hero equivalence line.
// The COIN_* identifiers below keep their names on purpose: they are internal,
// and the wallet/GraphQL contract still spells the unit "coin".
//
// The MONEY price of one credit has a currency since PM-0211
// (docs/platform-money/CONTRACT.md): the wallet says `IRT` (toman) for Parsina,
// which is everything below, and e.g. `USD` for a deployment that sells credit
// in dollars. A credit stays a unit either way — only `formatCreditMoney` /
// `coinsToMoneyLabel` at the bottom of this file know about the money side.

var $lHVFz = parcelRequire("lHVFz");
const $2a90b979c3d41f86$export$603323bf3f7bd8d9 = 1000;
const $2a90b979c3d41f86$export$ae8383984baa5079 = 'IRT';
const $2a90b979c3d41f86$export$e6d8c7e3d913b530 = {
    TRANSCRIPTION_PER_MIN: 5,
    // The same minute decoded by «گفتار به متن پارسینا» (its own price row,
    // TranscribeAudioParsina). Offline fallback only, like every entry here.
    TRANSCRIPTION_PARSINA_PER_MIN: 5,
    ASK_QUESTION: 10,
    SOAP_REFINE: 10,
    // when the merge produced new content; the server's
    // `charged` flag is the signal, never the click
    RECOMMENDATIONS: 10,
    DIFFERENTIAL: 10,
    CONFIRM_QUESTIONS: 10,
    TREATMENT_PLAN: 10,
    DOCTOR_ORDERS: 10,
    OCR: 10,
    ANALYZE_FILE: 10,
    // one price per run whatever the class; not charged for
    // NOT_MEDICAL / ILLEGIBLE / a failure (§24.1 R-A3)
    INTERACTION_CHECK: 3,
    ASSIST_PRESCRIPTION: 3,
    // The نسخه's AI helpers (docs/VISIT_RX_AI_ASSIST.md). Charged ONLY when the run
    // proposed a drug — the server's `charged` flag, never the click.
    RX_VOICE: 1,
    RX_MONITORING: 3,
    RX_HISTORY: 3,
    RX_DIRECTIONS: 3,
    // «پایش بالینی» beyond the نسخه (PM-0029): three readings, one equal price each,
    // charged only when the reading found something.
    MONITORING_VITALS: 3,
    MONITORING_ORDERS: 3,
    MONITORING_RECORD: 3
};
const $2a90b979c3d41f86$export$52690e1136e04e64 = [
    {
        id: 'transcription',
        action: 'TRANSCRIPTION_PER_MIN',
        labelKey: 'credits.price.transcription',
        cost: $2a90b979c3d41f86$export$e6d8c7e3d913b530.TRANSCRIPTION_PER_MIN,
        perKey: 'common.units.minute'
    },
    {
        id: 'ask',
        action: 'ASK_QUESTION',
        labelKey: 'credits.price.ask',
        cost: $2a90b979c3d41f86$export$e6d8c7e3d913b530.ASK_QUESTION
    },
    {
        id: 'differential',
        action: 'DIFFERENTIAL',
        labelKey: 'credits.price.differential',
        cost: $2a90b979c3d41f86$export$e6d8c7e3d913b530.DIFFERENTIAL
    },
    {
        id: 'confirmq',
        action: 'CONFIRM_QUESTIONS',
        labelKey: 'credits.price.confirmq',
        cost: $2a90b979c3d41f86$export$e6d8c7e3d913b530.CONFIRM_QUESTIONS
    },
    {
        id: 'recs',
        action: 'RECOMMENDATIONS',
        labelKey: 'credits.price.recs',
        cost: $2a90b979c3d41f86$export$e6d8c7e3d913b530.RECOMMENDATIONS
    },
    {
        id: 'plan',
        action: 'TREATMENT_PLAN',
        labelKey: 'credits.price.plan',
        cost: $2a90b979c3d41f86$export$e6d8c7e3d913b530.TREATMENT_PLAN
    },
    {
        id: 'orders',
        action: 'DOCTOR_ORDERS',
        labelKey: 'credits.price.orders',
        cost: $2a90b979c3d41f86$export$e6d8c7e3d913b530.DOCTOR_ORDERS
    },
    // Reading an uploaded document is the extraction (AnalyzeClinicalFile) — the
    // one the wallet charges; neither panel calls ProcessDocumentOCR (PM-0521).
    {
        id: 'ocr',
        action: 'ANALYZE_FILE',
        labelKey: 'credits.price.ocr',
        cost: $2a90b979c3d41f86$export$e6d8c7e3d913b530.ANALYZE_FILE
    },
    {
        id: 'interaction',
        action: 'INTERACTION_CHECK',
        labelKey: 'credits.price.interaction',
        cost: $2a90b979c3d41f86$export$e6d8c7e3d913b530.INTERACTION_CHECK
    },
    {
        id: 'rx',
        action: 'ASSIST_PRESCRIPTION',
        labelKey: 'credits.price.rx',
        cost: $2a90b979c3d41f86$export$e6d8c7e3d913b530.ASSIST_PRESCRIPTION
    },
    {
        id: 'rxMonitoring',
        action: 'RX_MONITORING',
        labelKey: 'credits.price.rxMonitoring',
        cost: $2a90b979c3d41f86$export$e6d8c7e3d913b530.RX_MONITORING
    },
    {
        id: 'rxHistory',
        action: 'RX_HISTORY',
        labelKey: 'credits.price.rxHistory',
        cost: $2a90b979c3d41f86$export$e6d8c7e3d913b530.RX_HISTORY
    },
    {
        id: 'rxDirections',
        action: 'RX_DIRECTIONS',
        labelKey: 'credits.price.rxDirections',
        cost: $2a90b979c3d41f86$export$e6d8c7e3d913b530.RX_DIRECTIONS
    },
    {
        id: 'rxVoice',
        action: 'RX_VOICE',
        labelKey: 'credits.price.rxVoice',
        cost: $2a90b979c3d41f86$export$e6d8c7e3d913b530.RX_VOICE
    },
    {
        id: 'monitoringVitals',
        action: 'MONITORING_VITALS',
        labelKey: 'credits.price.monitoringVitals',
        cost: $2a90b979c3d41f86$export$e6d8c7e3d913b530.MONITORING_VITALS
    },
    {
        id: 'monitoringOrders',
        action: 'MONITORING_ORDERS',
        labelKey: 'credits.price.monitoringOrders',
        cost: $2a90b979c3d41f86$export$e6d8c7e3d913b530.MONITORING_ORDERS
    },
    {
        id: 'monitoringRecord',
        action: 'MONITORING_RECORD',
        labelKey: 'credits.price.monitoringRecord',
        cost: $2a90b979c3d41f86$export$e6d8c7e3d913b530.MONITORING_RECORD
    }
];
function $2a90b979c3d41f86$export$b634cc5d06849b0a(n, formatNumber) {
    if (n == null || !Number.isFinite(Number(n))) return "\u2014";
    const rounded = Math.round(Number(n) * 10) / 10;
    return formatNumber ? formatNumber(rounded) : String(rounded);
}
function $2a90b979c3d41f86$export$3c73313758e13369(coins, { formatNumber: formatNumber, tomanLabel: tomanLabel, tomanPerCoin: tomanPerCoin = $2a90b979c3d41f86$export$603323bf3f7bd8d9 } = {}) {
    if (coins == null || !Number.isFinite(Number(coins))) return '';
    // Multiplied first: 2.4 پارسه is 2,400 toman, not 2,000.
    const toman = Math.round(Number(coins) * tomanPerCoin);
    const text = formatNumber ? formatNumber(toman) : String(toman);
    return `\u{2248} ${text} ${tomanLabel || ''}`.trim();
}
function $2a90b979c3d41f86$export$5452ee5bf8a4b337(price) {
    const currency = price?.currency;
    return !currency || currency === $2a90b979c3d41f86$export$ae8383984baa5079;
}
function $2a90b979c3d41f86$export$af3bb5d0c1d26c33(minor, currency, { formatNumber: formatNumber, tomanLabel: tomanLabel, locale: locale } = {}) {
    if (minor == null || minor === '' || !Number.isFinite(Number(minor))) return '';
    if (!currency || currency === $2a90b979c3d41f86$export$ae8383984baa5079) {
        const toman = Math.round(Number(minor));
        const text = formatNumber ? formatNumber(toman) : String(toman);
        return `${text} ${tomanLabel || ''}`.trim();
    }
    try {
        return (0, $lHVFz.formatAmount)(Number(minor), currency, {
            locale: locale,
            unit: 'short',
            fallback: ''
        });
    } catch  {
        return '';
    }
}
function $2a90b979c3d41f86$export$e610461cba74a0c9(coins, { creditPrice: creditPrice, formatNumber: formatNumber, tomanLabel: tomanLabel, locale: locale } = {}) {
    if ($2a90b979c3d41f86$export$5452ee5bf8a4b337(creditPrice)) return $2a90b979c3d41f86$export$3c73313758e13369(coins, {
        formatNumber: formatNumber,
        tomanLabel: tomanLabel,
        tomanPerCoin: creditPrice?.amountMinor ?? $2a90b979c3d41f86$export$603323bf3f7bd8d9
    });
    if (coins == null || !Number.isFinite(Number(coins))) return '';
    const money = $2a90b979c3d41f86$export$af3bb5d0c1d26c33(Math.round(Number(coins) * Number(creditPrice.amountMinor)), creditPrice.currency, {
        locale: locale
    });
    return money ? `\u{2248} ${money}` : '';
}

});


parcelRegister("6ojK3", function(module, exports) {

$parcel$export(module.exports, "DX_PROVISIONAL", () => $4a744c4def3d338a$export$effbc4db6100f5f7);
$parcel$export(module.exports, "DX_CONFIRMED", () => $4a744c4def3d338a$export$283afbef2b868970);
$parcel$export(module.exports, "DIAGNOSIS_TYPES", () => $4a744c4def3d338a$export$a2b1cf9e15bc836);
$parcel$export(module.exports, "DIAGNOSIS_TYPE_ARG", () => $4a744c4def3d338a$export$96cc294a492899cc);
$parcel$export(module.exports, "DIAGNOSIS_TYPE_LABEL_KEYS", () => $4a744c4def3d338a$export$fbea400e1bd2969e);
$parcel$export(module.exports, "diagnosisTypeOf", () => $4a744c4def3d338a$export$5d68a431913dd40b);
// «نوع تشخیص» — how certain a diagnosis is.
//
// Values mirror ALLOWED_VERIFICATION_STATUSES in clinicalencounter's
// app/domain/models.py — that's the canonical source, and they travel as
// `Condition.verificationStatus`. The GraphQL argument that WRITES one is the
// `DiagnosisType` enum (SCREAMING_CASE), so `DIAGNOSIS_TYPE_ARG` maps between
// the two; nothing else in the app should spell either vocabulary by hand.
//
// Colours are NOT defined here — they come from `diagnosisTypeColors` in
// ./statuses.js so `<StatusChip status={cond.verificationStatus} />` renders the
// same badge on every surface (visit record rail, record sheet, mobile sheet,
// patient file). One badge, one source, no screen inventing its own.
const $4a744c4def3d338a$export$effbc4db6100f5f7 = 'provisional';
const $4a744c4def3d338a$export$283afbef2b868970 = 'confirmed';
const $4a744c4def3d338a$export$a2b1cf9e15bc836 = [
    $4a744c4def3d338a$export$effbc4db6100f5f7,
    $4a744c4def3d338a$export$283afbef2b868970
];
const $4a744c4def3d338a$export$96cc294a492899cc = {
    [$4a744c4def3d338a$export$effbc4db6100f5f7]: 'PROVISIONAL',
    [$4a744c4def3d338a$export$283afbef2b868970]: 'CONFIRMED'
};
const $4a744c4def3d338a$export$fbea400e1bd2969e = {
    [$4a744c4def3d338a$export$effbc4db6100f5f7]: 'visit.dx.type.provisional',
    [$4a744c4def3d338a$export$283afbef2b868970]: 'visit.dx.type.confirmed'
};
const $4a744c4def3d338a$export$5d68a431913dd40b = (cond)=>$4a744c4def3d338a$export$a2b1cf9e15bc836.includes(cond?.verificationStatus) ? cond.verificationStatus : $4a744c4def3d338a$export$effbc4db6100f5f7;
const $4a744c4def3d338a$export$354ec45a177e3da7 = (v)=>$4a744c4def3d338a$export$a2b1cf9e15bc836.includes(v);

});

parcelRegister("2tKqm", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("9BgRG")).default);
$parcel$export(module.exports, "overlayHistoryDepth", () => (parcelRequire("9BgRG")).overlayHistoryDepth);
$parcel$export(module.exports, "overlayOwnsPop", () => (parcelRequire("9BgRG")).overlayOwnsPop);
// ─────────────────────────────────────────────────────────────────────────────
// The overlay-history law (spec §C.3 rule 1), re-exported from the kit.
//
// An overlay that owns the screen JOINS THE HISTORY STACK, so the platform back
// button — Android's hardware key, the iOS edge-swipe, the browser's own arrow
// — closes IT and not the route behind it. Before this, back with a sheet open
// navigated the route *underneath* the sheet: the sheet stayed on screen over a
// different screen, or a half-finished form was abandoned without being asked.
//
// `BottomSheet` does this itself from @parsina/framework v0.10.0, so most
// overlays in this app get it for free. This module is for the ones that are
// NOT kit sheets — the visit's closure receipt, the per-field voice modal — and
// it exists as an app-local file for the same reason `useResponsive` does: one
// import path, and one file for a convention guard to name.
//
// `overlayHistoryDepth()` is what a route-level leave-guard unwinds past. The
// visit guard used to hardcode `history.go(-2)`, which is correct only while
// exactly one anchor exists and wrong the moment a sheet sits on top of it.
//
// `overlayOwnsPop()` is what a leave-guard asks FIRST on every `popstate`.
// Closing a sheet from inside the app pops the sheet's own entry, and a guard
// that cannot tell that pop from a real back asks «خروج از ویزیت؟» over a
// screen nobody tried to leave — which is what every sheet on the phone's
// visit did until kit v0.11.5.
// ─────────────────────────────────────────────────────────────────────────────

var $9BgRG = parcelRequire("9BgRG");

});

parcelRegister("bOPUe", function(module, exports) {

$parcel$export(module.exports, "ErxLineChip", () => $960c956cfd0a23df$export$a8584f59cd36e423);
$parcel$export(module.exports, "ErxRemovedLines", () => $960c956cfd0a23df$export$3e7bfa10fb8d8624);

var $acw62 = parcelRequire("acw62");

var $4CVxl = parcelRequire("4CVxl");
var $aVx4q = parcelRequire("aVx4q");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
// ─────────────────────────────────────────────────────────────────────────────
// Where a line stands with the insurer, once its part of the visit is registered
// (K1, 2026-10-04; docs/eprescription/CORRECTION.md). One chip per نسخه line and
// دستورات row, read from `ePrescriptionStatus` (lib/erxCorrection.js):
//
//   «ثبت در بیمه»             REGISTERED — at the insurer as it is now. Quiet:
//                              it is the normal state, not news.
//   «تغییر کرده — ارسال نشده»  CHANGED — the insurer holds an older form; its
//                              tooltip says which.
//   «ارسال نشده»               ADDED — not in the registration: written after
//                              it, or left unticked on «ثبت نسخه در بیمه»
//                              (PM-0187), which the server cannot tell apart.
//   «حذف، ارسال نشده»          REMOVED — the insurer still holds it.
//
// Same grammar as the line's other inline chips (RxItemCard's «تکمیل», «از پرونده
// حذف نشد»): 9.5px, 16px tall, never wrapping. Colours from the token module,
// never the visit's CSS variables, which a panel theme can override.
// ─────────────────────────────────────────────────────────────────────────────
const $960c956cfd0a23df$var$TONE = {
    REGISTERED: {
        background: (0, $jTCZr.CT).goodSoft,
        color: (0, $jTCZr.CT).goodInk,
        fontWeight: 600
    },
    CHANGED: {
        background: (0, $jTCZr.CT).warnSoft,
        color: (0, $jTCZr.CT).warnInk,
        fontWeight: 700
    },
    ADDED: {
        background: (0, $jTCZr.CT).warnSoft,
        color: (0, $jTCZr.CT).warnInk,
        fontWeight: 700
    },
    REMOVED: {
        background: (0, $jTCZr.CT).warnSoft,
        color: (0, $jTCZr.CT).warnInk,
        fontWeight: 700
    }
};
function $960c956cfd0a23df$export$a8584f59cd36e423({ line: line, testid: testid }) {
    const { t: t } = (0, $LNQP4.default)();
    const state = line?.state;
    if (!$960c956cfd0a23df$var$TONE[state]) return null;
    // What the insurer holds, for a line that differs from it.
    const title = line.sentSummary && (state === 'CHANGED' || state === 'REMOVED') ? t('visit.erx.correction.atInsurer', {
        summary: line.sentSummary
    }) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": testid,
        "data-state": state,
        title: title,
        style: {
            fontSize: '0.59375rem',
            padding: '0 6px',
            borderRadius: 4,
            lineHeight: '16px',
            flexShrink: 0,
            whiteSpace: 'nowrap',
            ...$960c956cfd0a23df$var$TONE[state]
        }
    }, t(`visit.erx.lineState.${state === 'ADDED' ? 'NOT_SENT' : state}`));
}
function $960c956cfd0a23df$export$3e7bfa10fb8d8624({ lines: lines, part: part = 'DRUGS', testid: testid = 'visit-rx-erx-removed' }) {
    const { t: t } = (0, $LNQP4.default)();
    if (!lines?.length) return null;
    const Icon = part === 'SERVICES' ? (0, $4CVxl.default) : (0, $aVx4q.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        "data-testid": testid,
        "aria-label": t('visit.erx.lineState.removedList'),
        style: {
            listStyle: 'none',
            margin: 0,
            padding: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: 6
        }
    }, lines.map((line, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: `${line.medicationId || line.orderId || line.name}-${i}`,
            "data-testid": `${testid}-line`,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                padding: '6px 10px',
                borderRadius: 10,
                border: `1px dashed ${(0, $jTCZr.CT).border2}`,
                background: (0, $jTCZr.CT).surface2
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "aria-hidden": "true",
            style: {
                width: 22,
                height: 22,
                borderRadius: 6,
                flexShrink: 0,
                display: 'grid',
                placeItems: 'center',
                color: (0, $jTCZr.CT).mute
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
            size: 12,
            strokeWidth: 1.75
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                flex: 1,
                minWidth: 0,
                display: 'flex',
                alignItems: 'center',
                gap: 6,
                overflow: 'hidden'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("del", {
            dir: "auto",
            style: {
                fontSize: '0.75rem',
                fontWeight: 600,
                color: (0, $jTCZr.CT).mute,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                minWidth: 0
            }
        }, line.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "aria-hidden": "true",
            style: {
                color: (0, $jTCZr.CT).mute,
                flexShrink: 0
            }
        }, "\u2014"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($960c956cfd0a23df$export$a8584f59cd36e423, {
            line: line,
            testid: `${testid}-state`
        }), line.sentSummary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "auto",
            style: {
                fontSize: '0.65625rem',
                color: (0, $jTCZr.CT).mute,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                minWidth: 0
            }
        }, t('visit.erx.correction.atInsurer', {
            summary: line.sentSummary
        }))))));
}

});
parcelRegister("4CVxl", function(module, exports) {

$parcel$export(module.exports, "default", () => $241691b67a43640c$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $241691b67a43640c$export$a2387ed3b5d536eb = {
    name: "flask-conical",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M14 2v6a2 2 0 0 0 .245.96l5.51 10.08A2 2 0 0 1 18 22H6a2 2 0 0 1-1.755-2.96l5.51-10.08A2 2 0 0 0 10 8V2",
                key: "18mbvz"
            }
        ],
        [
            "path",
            {
                d: "M6.453 15h11.094",
                key: "3shlmq"
            }
        ],
        [
            "path",
            {
                d: "M8.5 2h7",
                key: "csnxdl"
            }
        ]
    ]
};
$241691b67a43640c$export$a2387ed3b5d536eb.node;
const $241691b67a43640c$export$2e2bcd8739ae039 = (0, $9QBug.default)($241691b67a43640c$export$a2387ed3b5d536eb);

});

parcelRegister("aVx4q", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ffe798f65d504e7$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $5ffe798f65d504e7$export$a2387ed3b5d536eb = {
    name: "pill",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m10.5 20.5 10-10a4.95 4.95 0 1 0-7-7l-10 10a4.95 4.95 0 1 0 7 7Z",
                key: "wa1lgi"
            }
        ],
        [
            "path",
            {
                d: "m8.5 8.5 7 7",
                key: "rvfmvr"
            }
        ]
    ]
};
$5ffe798f65d504e7$export$a2387ed3b5d536eb.node;
const $5ffe798f65d504e7$export$2e2bcd8739ae039 = (0, $9QBug.default)($5ffe798f65d504e7$export$a2387ed3b5d536eb);

});


parcelRegister("5JVBe", function(module, exports) {

$parcel$export(module.exports, "default", () => $828bf11fc38b9d89$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $828bf11fc38b9d89$export$a2387ed3b5d536eb = {
    name: "chart-column",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M3 3v16a2 2 0 0 0 2 2h16",
                key: "c24i48"
            }
        ],
        [
            "path",
            {
                d: "M18 17V9",
                key: "2bz60n"
            }
        ],
        [
            "path",
            {
                d: "M13 17V5",
                key: "1frdt8"
            }
        ],
        [
            "path",
            {
                d: "M8 17v-3",
                key: "17ska0"
            }
        ]
    ],
    aliases: [
        "bar-chart-3"
    ]
};
$828bf11fc38b9d89$export$a2387ed3b5d536eb.node;
const $828bf11fc38b9d89$export$2e2bcd8739ae039 = (0, $9QBug.default)($828bf11fc38b9d89$export$a2387ed3b5d536eb);

});

parcelRegister("jis86", function(module, exports) {

$parcel$export(module.exports, "default", () => $6219358252a45071$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $6219358252a45071$export$a2387ed3b5d536eb = {
    name: "building-complex",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M10 12h4",
                key: "a56b0p"
            }
        ],
        [
            "path",
            {
                d: "M10 8h4",
                key: "1sr2af"
            }
        ],
        [
            "path",
            {
                d: "M14 21v-3a2 2 0 0 0-4 0v3",
                key: "1rgiei"
            }
        ],
        [
            "path",
            {
                d: "M6 10H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2",
                key: "secmi2"
            }
        ],
        [
            "path",
            {
                d: "M6 21V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v16",
                key: "16ra0t"
            }
        ]
    ],
    aliases: [
        "building-2"
    ]
};
$6219358252a45071$export$a2387ed3b5d536eb.node;
const $6219358252a45071$export$2e2bcd8739ae039 = (0, $9QBug.default)($6219358252a45071$export$a2387ed3b5d536eb);

});

parcelRegister("dDvfT", function(module, exports) {

$parcel$export(module.exports, "default", () => $4980c56854bb97ce$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $4980c56854bb97ce$export$a2387ed3b5d536eb = {
    name: "calendar",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M8 2v3",
                key: "1ioesn"
            }
        ],
        [
            "path",
            {
                d: "M16 2v3",
                key: "otl347"
            }
        ],
        [
            "rect",
            {
                x: "3",
                y: "3",
                width: "18",
                height: "18",
                rx: "2",
                key: "h1oib"
            }
        ],
        [
            "path",
            {
                d: "M3 9h18",
                key: "1pudct"
            }
        ]
    ]
};
$4980c56854bb97ce$export$a2387ed3b5d536eb.node;
const $4980c56854bb97ce$export$2e2bcd8739ae039 = (0, $9QBug.default)($4980c56854bb97ce$export$a2387ed3b5d536eb);

});

parcelRegister("ggYuf", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f35c50d66e81764$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $3f35c50d66e81764$export$a2387ed3b5d536eb = {
    name: "clipboard-list",
    size: 24,
    node: [
        [
            "rect",
            {
                width: "8",
                height: "4",
                x: "8",
                y: "2",
                rx: "1",
                ry: "1",
                key: "tgr4d6"
            }
        ],
        [
            "path",
            {
                d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
                key: "116196"
            }
        ],
        [
            "path",
            {
                d: "M12 11h4",
                key: "1jrz19"
            }
        ],
        [
            "path",
            {
                d: "M12 16h4",
                key: "n85exb"
            }
        ],
        [
            "path",
            {
                d: "M8 11h.01",
                key: "1dfujw"
            }
        ],
        [
            "path",
            {
                d: "M8 16h.01",
                key: "18s6g9"
            }
        ]
    ]
};
$3f35c50d66e81764$export$a2387ed3b5d536eb.node;
const $3f35c50d66e81764$export$2e2bcd8739ae039 = (0, $9QBug.default)($3f35c50d66e81764$export$a2387ed3b5d536eb);

});

parcelRegister("97xXr", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba16dd414953e5a4$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $ba16dd414953e5a4$export$a2387ed3b5d536eb = {
    name: "info",
    size: 24,
    node: [
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                r: "10",
                key: "1mglay"
            }
        ],
        [
            "path",
            {
                d: "M12 16v-4",
                key: "1dtifu"
            }
        ],
        [
            "path",
            {
                d: "M12 8h.01",
                key: "e9boi3"
            }
        ]
    ]
};
$ba16dd414953e5a4$export$a2387ed3b5d536eb.node;
const $ba16dd414953e5a4$export$2e2bcd8739ae039 = (0, $9QBug.default)($ba16dd414953e5a4$export$a2387ed3b5d536eb);

});

parcelRegister("cAg7Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8deaef2bfa57b80$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $b8deaef2bfa57b80$export$a2387ed3b5d536eb = {
    name: "layout-grid",
    size: 24,
    node: [
        [
            "rect",
            {
                width: "7",
                height: "7",
                x: "3",
                y: "3",
                rx: "1",
                key: "1g98yp"
            }
        ],
        [
            "rect",
            {
                width: "7",
                height: "7",
                x: "14",
                y: "3",
                rx: "1",
                key: "6d4xhi"
            }
        ],
        [
            "rect",
            {
                width: "7",
                height: "7",
                x: "14",
                y: "14",
                rx: "1",
                key: "nxv5o0"
            }
        ],
        [
            "rect",
            {
                width: "7",
                height: "7",
                x: "3",
                y: "14",
                rx: "1",
                key: "1bb6yr"
            }
        ]
    ]
};
$b8deaef2bfa57b80$export$a2387ed3b5d536eb.node;
const $b8deaef2bfa57b80$export$2e2bcd8739ae039 = (0, $9QBug.default)($b8deaef2bfa57b80$export$a2387ed3b5d536eb);

});

parcelRegister("2UQ3h", function(module, exports) {

$parcel$export(module.exports, "default", () => $899acbe55afec07f$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $899acbe55afec07f$export$a2387ed3b5d536eb = {
    name: "link-2",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M9 17H7A5 5 0 0 1 7 7h2",
                key: "8i5ue5"
            }
        ],
        [
            "path",
            {
                d: "M15 7h2a5 5 0 1 1 0 10h-2",
                key: "1b9ql8"
            }
        ],
        [
            "line",
            {
                x1: "8",
                x2: "16",
                y1: "12",
                y2: "12",
                key: "1jonct"
            }
        ]
    ]
};
$899acbe55afec07f$export$a2387ed3b5d536eb.node;
const $899acbe55afec07f$export$2e2bcd8739ae039 = (0, $9QBug.default)($899acbe55afec07f$export$a2387ed3b5d536eb);

});

parcelRegister("hSPBf", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9f4b1e9a7f47143$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $f9f4b1e9a7f47143$export$a2387ed3b5d536eb = {
    name: "mic",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M12 19v3",
                key: "npa21l"
            }
        ],
        [
            "path",
            {
                d: "M19 10v2a7 7 0 0 1-14 0v-2",
                key: "1vc78b"
            }
        ],
        [
            "rect",
            {
                x: "9",
                y: "2",
                width: "6",
                height: "13",
                rx: "3",
                key: "s6n7sd"
            }
        ]
    ]
};
$f9f4b1e9a7f47143$export$a2387ed3b5d536eb.node;
const $f9f4b1e9a7f47143$export$2e2bcd8739ae039 = (0, $9QBug.default)($f9f4b1e9a7f47143$export$a2387ed3b5d536eb);

});

parcelRegister("022jy", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c47b6817ea26fcd$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $7c47b6817ea26fcd$export$a2387ed3b5d536eb = {
    name: "ellipsis-vertical",
    size: 24,
    node: [
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                r: "1",
                key: "41hilf"
            }
        ],
        [
            "circle",
            {
                cx: "12",
                cy: "5",
                r: "1",
                key: "gxeob9"
            }
        ],
        [
            "circle",
            {
                cx: "12",
                cy: "19",
                r: "1",
                key: "lyex9k"
            }
        ]
    ],
    aliases: [
        "more-vertical"
    ]
};
$7c47b6817ea26fcd$export$a2387ed3b5d536eb.node;
const $7c47b6817ea26fcd$export$2e2bcd8739ae039 = (0, $9QBug.default)($7c47b6817ea26fcd$export$a2387ed3b5d536eb);

});

parcelRegister("aGlWN", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f9f3418dec68a42$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $1f9f3418dec68a42$export$a2387ed3b5d536eb = {
    name: "pencil",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
                key: "1a8usu"
            }
        ],
        [
            "path",
            {
                d: "m15 5 4 4",
                key: "1mk7zo"
            }
        ]
    ]
};
$1f9f3418dec68a42$export$a2387ed3b5d536eb.node;
const $1f9f3418dec68a42$export$2e2bcd8739ae039 = (0, $9QBug.default)($1f9f3418dec68a42$export$a2387ed3b5d536eb);

});

parcelRegister("bF8pu", function(module, exports) {

$parcel$export(module.exports, "default", () => $a234a87c35ebe3af$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $a234a87c35ebe3af$export$a2387ed3b5d536eb = {
    name: "rotate-cw",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8",
                key: "1p45f6"
            }
        ],
        [
            "path",
            {
                d: "M21 3v5h-5",
                key: "1q7to0"
            }
        ]
    ]
};
$a234a87c35ebe3af$export$a2387ed3b5d536eb.node;
const $a234a87c35ebe3af$export$2e2bcd8739ae039 = (0, $9QBug.default)($a234a87c35ebe3af$export$a2387ed3b5d536eb);

});

parcelRegister("aWpbN", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fbfeb4276877a84$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $2fbfeb4276877a84$export$a2387ed3b5d536eb = {
    name: "save",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z",
                key: "1c8476"
            }
        ],
        [
            "path",
            {
                d: "M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7",
                key: "1ydtos"
            }
        ],
        [
            "path",
            {
                d: "M7 3v4a1 1 0 0 0 1 1h7",
                key: "t51u73"
            }
        ]
    ]
};
$2fbfeb4276877a84$export$a2387ed3b5d536eb.node;
const $2fbfeb4276877a84$export$2e2bcd8739ae039 = (0, $9QBug.default)($2fbfeb4276877a84$export$a2387ed3b5d536eb);

});

parcelRegister("03cDl", function(module, exports) {

$parcel$export(module.exports, "default", () => $6828da86e4d4e8df$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $6828da86e4d4e8df$export$a2387ed3b5d536eb = {
    name: "scan",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M3 7V5a2 2 0 0 1 2-2h2",
                key: "aa7l1z"
            }
        ],
        [
            "path",
            {
                d: "M17 3h2a2 2 0 0 1 2 2v2",
                key: "4qcy5o"
            }
        ],
        [
            "path",
            {
                d: "M21 17v2a2 2 0 0 1-2 2h-2",
                key: "6vwrx8"
            }
        ],
        [
            "path",
            {
                d: "M7 21H5a2 2 0 0 1-2-2v-2",
                key: "ioqczr"
            }
        ]
    ]
};
$6828da86e4d4e8df$export$a2387ed3b5d536eb.node;
const $6828da86e4d4e8df$export$2e2bcd8739ae039 = (0, $9QBug.default)($6828da86e4d4e8df$export$a2387ed3b5d536eb);

});

parcelRegister("53qqr", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd8e7ce95b64d1ad$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $dd8e7ce95b64d1ad$export$a2387ed3b5d536eb = {
    name: "settings",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915",
                key: "1i5ecw"
            }
        ],
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                r: "3",
                key: "1v7zrd"
            }
        ]
    ]
};
$dd8e7ce95b64d1ad$export$a2387ed3b5d536eb.node;
const $dd8e7ce95b64d1ad$export$2e2bcd8739ae039 = (0, $9QBug.default)($dd8e7ce95b64d1ad$export$a2387ed3b5d536eb);

});

parcelRegister("bo0GS", function(module, exports) {

$parcel$export(module.exports, "default", () => $273768d0abd0c569$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $273768d0abd0c569$export$a2387ed3b5d536eb = {
    name: "shield-check",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
                key: "oel41y"
            }
        ],
        [
            "path",
            {
                d: "m9 12 2 2 4-4",
                key: "dzmm74"
            }
        ]
    ]
};
$273768d0abd0c569$export$a2387ed3b5d536eb.node;
const $273768d0abd0c569$export$2e2bcd8739ae039 = (0, $9QBug.default)($273768d0abd0c569$export$a2387ed3b5d536eb);

});

parcelRegister("chm1L", function(module, exports) {

$parcel$export(module.exports, "default", () => $53b0597d7da6e50a$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $53b0597d7da6e50a$export$a2387ed3b5d536eb = {
    name: "sparkles",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z",
                key: "1s2grr"
            }
        ],
        [
            "path",
            {
                d: "M20 2v4",
                key: "1rf3ol"
            }
        ],
        [
            "path",
            {
                d: "M22 4h-4",
                key: "gwowj6"
            }
        ],
        [
            "circle",
            {
                cx: "4",
                cy: "20",
                r: "2",
                key: "6kqj1y"
            }
        ]
    ],
    aliases: [
        "stars"
    ]
};
$53b0597d7da6e50a$export$a2387ed3b5d536eb.node;
const $53b0597d7da6e50a$export$2e2bcd8739ae039 = (0, $9QBug.default)($53b0597d7da6e50a$export$a2387ed3b5d536eb);

});

parcelRegister("7udIf", function(module, exports) {

$parcel$export(module.exports, "default", () => $5340d072e86ce769$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $5340d072e86ce769$export$a2387ed3b5d536eb = {
    name: "square",
    size: 24,
    node: [
        [
            "rect",
            {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2",
                key: "afitv7"
            }
        ]
    ]
};
$5340d072e86ce769$export$a2387ed3b5d536eb.node;
const $5340d072e86ce769$export$2e2bcd8739ae039 = (0, $9QBug.default)($5340d072e86ce769$export$a2387ed3b5d536eb);

});

parcelRegister("4KmG0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4aa5203766da4495$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $4aa5203766da4495$export$a2387ed3b5d536eb = {
    name: "trending-up",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M16 7h6v6",
                key: "box55l"
            }
        ],
        [
            "path",
            {
                d: "m22 7-8.5 8.5-5-5L2 17",
                key: "1t1m79"
            }
        ]
    ]
};
$4aa5203766da4495$export$a2387ed3b5d536eb.node;
const $4aa5203766da4495$export$2e2bcd8739ae039 = (0, $9QBug.default)($4aa5203766da4495$export$a2387ed3b5d536eb);

});

parcelRegister("jdP8o", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3ac79315652b37f$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $f3ac79315652b37f$export$a2387ed3b5d536eb = {
    name: "cloud-upload",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M12 13v8",
                key: "1l5pq0"
            }
        ],
        [
            "path",
            {
                d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242",
                key: "1pljnt"
            }
        ],
        [
            "path",
            {
                d: "m8 17 4-4 4 4",
                key: "1quai1"
            }
        ]
    ],
    aliases: [
        "upload-cloud"
    ]
};
$f3ac79315652b37f$export$a2387ed3b5d536eb.node;
const $f3ac79315652b37f$export$2e2bcd8739ae039 = (0, $9QBug.default)($f3ac79315652b37f$export$a2387ed3b5d536eb);

});

parcelRegister("6imzq", function(module, exports) {

$parcel$export(module.exports, "default", () => $df82e729d4b50e19$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $df82e729d4b50e19$export$a2387ed3b5d536eb = {
    name: "users",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2",
                key: "1yyitq"
            }
        ],
        [
            "path",
            {
                d: "M16 3.128a4 4 0 0 1 0 7.744",
                key: "16gr8j"
            }
        ],
        [
            "path",
            {
                d: "M22 21v-2a4 4 0 0 0-3-3.87",
                key: "kshegd"
            }
        ],
        [
            "circle",
            {
                cx: "9",
                cy: "7",
                r: "4",
                key: "nufk8"
            }
        ]
    ]
};
$df82e729d4b50e19$export$a2387ed3b5d536eb.node;
const $df82e729d4b50e19$export$2e2bcd8739ae039 = (0, $9QBug.default)($df82e729d4b50e19$export$a2387ed3b5d536eb);

});

parcelRegister("iS1Sb", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b055447143d8b14$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $4b055447143d8b14$export$a2387ed3b5d536eb = {
    name: "zap",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M15.914 4a1.5 1.5 0 00-2.474-1.561l-9 9A1.5 1.5 0 005.5 14h4.002a.5.5 0 01.471.666L8.086 20a1.5 1.5 0 002.475 1.56l9-9A1.5 1.5 0 0018.5 10h-3.997a.5.5 0 01-.472-.667z",
                key: "1v7up4"
            }
        ]
    ]
};
$4b055447143d8b14$export$a2387ed3b5d536eb.node;
const $4b055447143d8b14$export$2e2bcd8739ae039 = (0, $9QBug.default)($4b055447143d8b14$export$a2387ed3b5d536eb);

});



parcelRegister("16oOu", function(module, exports) {

$parcel$export(module.exports, "default", () => $013436dd88cfa3ff$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $fiHxp = parcelRequire("fiHxp");
// ویزیت تصویری — the call, in پرونده بیمار: pinned to the foot of the desktop rail
// (`dock="bottom"`, PM-0023), at the top of the phone's record.
//
// ── Why this is NOT literally a `RecordSection` ─────────────────────────────
// It speaks that component's header grammar — icon, title, status chip, a
// one-line gist while collapsed, inline actions, chevron — and sits in the same
// rail as the record sections. But `RecordSection` renders its body as
// `{open && <div>{children}</div>}`, and an UNMOUNT is exactly what must never
// happen here: the body holds the Jitsi iframe, so collapsing the section would
// drop the call. Collapsing hides the video by HEIGHT instead; the conference
// keeps running and the audio keeps flowing, which is also the honest behaviour
// — a doctor who folds the section away has not hung up.
//
// ── THE ONE-NODE RULE (do not refactor this away) ───────────────────────────
// `containerRef` is where Jitsi attaches its iframe. Re-parenting an iframe in
// the DOM RELOADS it, and React unmounts and remounts a subtree whenever it
// renders in a different position in the tree. So:
//
//   · the container div is rendered in EXACTLY ONE place, unconditionally, for
//     the whole life of the call;
//   · docked vs enlarged is nothing but a different `style` object on the
//     WRAPPER around it — the container's own position in the tree never moves;
//   · the header is one component in both states (same type, different props),
//     so the container is always the same child index and React never has cause
//     to recreate it;
//   · the container has NO React children, ever. React owns the chrome around
//     it; Jitsi owns everything inside it.
//
// Written any other way — a portal, a `key` on the enlarged flag, a
// `{enlarged ? <Modal>…</Modal> : <Rail>…</Rail>}` — the call drops every time
// the doctor zooms, which is the one interaction this panel exists for.
//
// ── An in-person visit: the band offers a CONVERSION, not a call ─────────────
// A call belongs to an online visit (PM-0019). On an in-person one the hook
// reports `canConvert`, and the same band — same header, same one node — holds
// «تبدیل به ویزیت آنلاین» where the connect button would be: the visit's type
// changes (its price does not), and the call follows in the same press. On the
// PHONE the band does not render in that state at all: the conversion is a
// 44px control at the end of the tab strip and a sheet (Visit.mobile.jsx), so
// an in-person visit — nearly every visit — gives the call no height.
// An online visit that has no call running can be turned back the same way.
//
// ── The enlarged view has no scrim, deliberately ────────────────────────────
// A scrim would put the chart, the copilot and the prescription behind glass,
// and a doctor on a video visit is still charting. The panel floats over the
// work area instead: bigger patient, everything still readable and typeable
// underneath. Esc (owned by the hook) returns to docked.
/**
 * THE PALETTE. Framework tokens, not the Visit workspace's private `--…` set.
 *
 * This panel is SHARED by the desktop workspace and the phone, and only
 * `Visit.web.jsx` ever injected `CSS_VARS`. On mobile every one of those custom
 * properties resolved to nothing — and a browser DROPS an invalid declaration
 * while keeping a valid one, so `background: var(--primary)` vanished and the
 * literal `color: '#fff'` beside it stayed: «تماس با بیمار» was white text on a
 * white card, and the panel had no surface and no borders either.
 *
 * Injecting the private palette into the mobile tree would have fixed the
 * symptom and broken the rule — §2.2 retired that sub-theme on the phone, and
 * `uiUnification` asserts it. Reading the tokens directly is what makes one
 * component legal in both trees.
 *
 * The values are the ones `CSS_VARS` already assigned, so the desktop is
 * pixel-identical; `CT.navy`/`CT.accent` are framework globals, which is a gain
 * — the call button now follows the theme preset the doctor picked, where
 * `--primary` was frozen at whatever the Visit page happened to define.
 */ /**
 * The Visit workspace's warm «focus mode» band — a raw literal because that is
 * what it is on the desktop: a documented exception to the token palette owned
 * by that page (`CSS_VARS` → `--field`), not a colour role. It never reaches
 * the phone; see the wrapper below.
 */ const $013436dd88cfa3ff$var$FIELD = '#faf8f5';
const $013436dd88cfa3ff$var$S = {
    primary: (0, $jTCZr.CT).navy,
    panel: (0, $jTCZr.CT).surface,
    line: (0, $jTCZr.CT).border,
    line2: (0, $jTCZr.CT).border2,
    ink: (0, $jTCZr.CT).ink,
    ink2: (0, $jTCZr.CT).ink2,
    mute: (0, $jTCZr.CT).mute,
    accent: (0, $jTCZr.CT).accent,
    danger: (0, $jTCZr.CT).danger,
    dangerSoft: (0, $jTCZr.CT).dangerSoft,
    dangerInk: (0, $jTCZr.CT).dangerInk,
    good: (0, $jTCZr.CT).good,
    goodSoft: (0, $jTCZr.CT).goodSoft,
    goodInk: (0, $jTCZr.CT).goodInk,
    radius: '10px',
    radiusLg: '14px',
    shadowPop: '0 8px 28px rgba(15,23,42,.10), 0 2px 6px rgba(15,23,42,.06)'
};
/** Docked video width is the rail's, minus its padding. 4:3 — one face, not a meeting. */ const $013436dd88cfa3ff$var$DOCKED_ASPECT = 0.75;
/** The enlarged panel. Wide enough to actually examine someone; not the screen. */ const $013436dd88cfa3ff$var$ENLARGED_WIDTH = 720;
function $013436dd88cfa3ff$var$VideoIcon({ size: size = 13, color: color = $013436dd88cfa3ff$var$S.accent }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": true,
        style: {
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M22 8l-6 4 6 4V8z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: "2",
        y: "6",
        width: "14",
        height: "12",
        rx: "2"
    }));
}
function $013436dd88cfa3ff$var$HangUpIcon({ size: size = 13, color: color = '#fff' }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": true,
        style: {
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.42 19.42 0 0 1-3.33-2.67m-2.67-3.34a19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
        x1: "23",
        y1: "1",
        x2: "1",
        y2: "23"
    }));
}
function $013436dd88cfa3ff$var$ResizeIcon({ enlarged: enlarged, size: size = 13, color: color = $013436dd88cfa3ff$var$S.ink2 }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": true,
        style: {
            flexShrink: 0
        }
    }, enlarged ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polyline", {
        points: "4 14 10 14 10 20"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polyline", {
        points: "20 10 14 10 14 4"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polyline", {
        points: "15 3 21 3 21 9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polyline", {
        points: "9 21 3 21 3 15"
    })));
}
function $013436dd88cfa3ff$var$ChevronIcon({ open: open, size: size = 13, color: color = $013436dd88cfa3ff$var$S.mute }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": true,
        style: {
            flexShrink: 0,
            transform: open ? 'rotate(180deg)' : 'none',
            transition: 'transform .18s'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polyline", {
        points: "6 9 12 15 18 9"
    }));
}
function $013436dd88cfa3ff$var$ShieldIcon({ size: size = 12 }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: $013436dd88cfa3ff$var$S.mute,
        strokeWidth: "1.8",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": true,
        style: {
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"
    }));
}
/**
 * The header row — ONE component in every state, so the video container beneath
 * it keeps a stable position among its siblings and is never recreated.
 */ function $013436dd88cfa3ff$var$CallHeader({ t: t, live: live, busy: busy, enlarged: enlarged, patientName: patientName, open: open, onToggle: onToggle, onResize: onResize, onHangUp: onHangUp }) {
    const showChip = live || busy;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            // Folded and idle, the section is a single slim row.
            padding: enlarged ? '9px 14px' : open || showChip ? '11px 16px' : '7px 16px',
            background: enlarged ? $013436dd88cfa3ff$var$S.primary : 'transparent',
            color: enlarged ? '#fff' : $013436dd88cfa3ff$var$S.ink
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onToggle,
        "aria-expanded": open,
        "data-testid": "visit-call-toggle",
        title: open ? t('visit.panel.collapse') : t('visit.panel.expand'),
        style: {
            flex: 1,
            minWidth: 0,
            display: 'flex',
            alignItems: 'center',
            gap: 7,
            background: 'none',
            border: 'none',
            padding: 0,
            cursor: 'pointer',
            fontFamily: 'inherit',
            textAlign: 'start',
            color: 'inherit'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($013436dd88cfa3ff$var$VideoIcon, {
        color: enlarged ? '#fff' : $013436dd88cfa3ff$var$S.accent
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontWeight: 600,
            fontSize: '0.8125rem',
            whiteSpace: 'nowrap'
        }
    }, enlarged ? patientName || t('visit.call.section') : t('visit.call.section')), showChip && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "visit-call-chip",
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 5,
            padding: '3px 9px',
            borderRadius: $013436dd88cfa3ff$var$S.radius,
            flexShrink: 0,
            fontSize: '0.6875rem',
            fontWeight: 700,
            background: enlarged ? 'rgba(255,255,255,.16)' : $013436dd88cfa3ff$var$S.goodSoft,
            color: enlarged ? '#fff' : $013436dd88cfa3ff$var$S.goodInk
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: 5,
            height: 5,
            borderRadius: '50%',
            display: 'inline-block',
            background: enlarged ? '#fff' : $013436dd88cfa3ff$var$S.good,
            animation: 'pulse 1.6s infinite'
        }
    }), live ? t('visit.call.live') : t('visit.call.connecting')), !enlarged && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            marginInlineStart: 'auto',
            display: 'inline-flex'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($013436dd88cfa3ff$var$ChevronIcon, {
        open: open
    }))), showChip && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onResize,
        "data-testid": "visit-call-resize",
        "aria-pressed": enlarged,
        "aria-label": enlarged ? t('visit.call.shrink') : t('visit.call.enlarge'),
        title: enlarged ? t('visit.call.shrink') : t('visit.call.enlarge'),
        style: {
            width: 26,
            height: 26,
            borderRadius: 7,
            flexShrink: 0,
            cursor: 'pointer',
            display: 'grid',
            placeItems: 'center',
            fontFamily: 'inherit',
            border: enlarged ? 'none' : `1px solid ${$013436dd88cfa3ff$var$S.line2}`,
            background: enlarged ? 'rgba(255,255,255,.16)' : $013436dd88cfa3ff$var$S.panel
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($013436dd88cfa3ff$var$ResizeIcon, {
        enlarged: enlarged,
        color: enlarged ? '#fff' : $013436dd88cfa3ff$var$S.ink2
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onHangUp,
        "data-testid": "visit-call-hangup",
        "aria-label": t('visit.call.hangUp'),
        title: t('visit.call.hangUp'),
        style: {
            height: 26,
            minWidth: 26,
            borderRadius: 7,
            flexShrink: 0,
            cursor: 'pointer',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 5,
            padding: enlarged ? '0 12px' : 0,
            border: 'none',
            background: $013436dd88cfa3ff$var$S.danger,
            color: '#fff',
            fontFamily: 'inherit',
            fontSize: '0.75rem',
            fontWeight: 700
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($013436dd88cfa3ff$var$HangUpIcon, null), enlarged && t('visit.call.hangUp'))));
}
function $013436dd88cfa3ff$export$2e2bcd8739ae039({ call: call, patientName: patientName, variant: variant = 'web', dock: dock = 'top' }) {
    const { t: t } = (0, $LNQP4.default)();
    const { state: state, error: error, available: available, reason: reason, live: live, busy: busy, enlarged: enlarged, containerRef: containerRef, start: start, stop: stop, toggleEnlarged: toggleEnlarged, canConvert: canConvert, converting: converting, convertError: convertError, convert: convert, revert: revert } = call;
    // FOLDED by default. An online visit is under 5% of visits; the other 95% the
    // doctor is charting a patient who is in the room, and a camera panel above
    // the allergies is space taken from that work. Folded, the section is one
    // slim row — the doctor opens it when they mean to call.
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    /** Connecting or connected — the only states in which the video has height. */ const inCall = live || busy;
    const errored = state === (0, $fiHxp.CALL_ERROR);
    // A call that starts while the section is folded away would run invisibly,
    // and a call that just dropped must show why — both open it.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (inCall || errored) setOpen(true);
    }, [
        inCall,
        errored
    ]);
    // Nothing to draw at all when this deployment has no media server, when there
    // is no open appointment to call about, or when the visit is over. A button
    // that always fails is worse than no button — it reads as a broken feature
    // rather than an absent one.
    //
    // An error is the one case that still renders while `available` is false: a
    // call that just dropped must leave the doctor a way back, not vanish.
    /** An open in-person visit: the band offers the conversion instead of a call. */ const convertible = !available && Boolean(canConvert) && !inCall && !errored;
    if (!inCall && !errored && !available && !convertible) return null;
    // The phone's conversion lives in the tab strip + a sheet, not in the flow.
    if (convertible && variant === 'mobile') return null;
    const gist = live ? t('visit.call.gistLive') : reason === 'visit_over' ? t('visit.call.gistOver') : reason === 'no_appointment' ? t('visit.call.gistNoAppointment') : reason === 'in_person' ? t('visit.call.gistInPerson') : t('visit.call.gistReady');
    // The whole panel moves; the video container inside it does not. Docked, this
    // is an ordinary block in the rail. Enlarged, it is fixed to the viewport —
    // which is safe here because no ancestor of the Visit grid carries a
    // `transform`, `filter` or `will-change`. If one is ever added, the enlarged
    // panel would be trapped inside the 340px column instead.
    const isMobile = variant === 'mobile';
    const wrapperStyle = enlarged && !isMobile ? {
        position: 'fixed',
        top: 78,
        insetInlineStart: 24,
        width: $013436dd88cfa3ff$var$ENLARGED_WIDTH,
        maxWidth: 'calc(100vw - 48px)',
        background: $013436dd88cfa3ff$var$S.panel,
        border: `1px solid ${$013436dd88cfa3ff$var$S.line2}`,
        borderRadius: $013436dd88cfa3ff$var$S.radiusLg,
        boxShadow: $013436dd88cfa3ff$var$S.shadowPop,
        overflow: 'hidden',
        // Above the workspace, below the record sheets (1200) and the print modal
        // (1100): a ConfirmDialog for «پایان ویزیت» must still cover this.
        zIndex: 60
    } : {
        // The docked band's own surface. On the desktop that is the Visit
        // workspace's warm «focus mode» tint — a documented scope exception that
        // belongs to that page. §2.2 retired the warm-beige sub-theme on the
        // phone, so there the band is the neutral token surface instead: the same
        // job (separate the call from the chart below it), in each surface's own
        // palette.
        background: isMobile ? (0, $jTCZr.CT).surface2 : $013436dd88cfa3ff$var$FIELD,
        ...dock === 'bottom' ? {
            // `marginTop: auto` keeps it on the floor of a short record too; the
            // z-index is the rail header's, so sections scroll UNDER the band.
            position: 'sticky',
            bottom: 0,
            zIndex: 2,
            marginTop: 'auto',
            flexShrink: 0,
            borderTop: `1px solid ${$013436dd88cfa3ff$var$S.line}`,
            boxShadow: '0 -4px 12px rgba(15,23,42,.05)'
        } : {
            borderBottom: `1px solid ${$013436dd88cfa3ff$var$S.line}`
        }
    };
    const videoHeight = !open ? 0 : isMobile ? enlarged ? 380 : 206 : enlarged ? Math.round(($013436dd88cfa3ff$var$ENLARGED_WIDTH - 32) * $013436dd88cfa3ff$var$DOCKED_ASPECT) : 231;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("aside", {
        "data-testid": "visit-call",
        "data-state": state,
        "data-enlarged": enlarged ? 'true' : 'false',
        "aria-label": t('visit.call.panelLabel'),
        style: wrapperStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($013436dd88cfa3ff$var$CallHeader, {
        t: t,
        live: live,
        busy: busy,
        enlarged: enlarged && !isMobile,
        patientName: patientName,
        open: open,
        onToggle: ()=>setOpen((v)=>!v),
        onResize: toggleEnlarged,
        onHangUp: stop
    }), !open && !enlarged && !live && reason && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '0 16px 11px',
            fontSize: '0.6875rem',
            color: $013436dd88cfa3ff$var$S.mute,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    }, gist), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: open ? '0 16px' : 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: containerRef,
        "data-testid": "visit-call-video",
        role: "presentation",
        style: {
            height: inCall ? videoHeight : 0,
            borderRadius: $013436dd88cfa3ff$var$S.radius,
            background: inCall ? $013436dd88cfa3ff$var$S.ink : 'transparent',
            overflow: 'hidden',
            position: 'relative',
            transition: 'height .18s ease'
        }
    })), busy && open && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '8px 16px 0',
            fontSize: '0.71875rem',
            color: $013436dd88cfa3ff$var$S.mute,
            display: 'flex',
            alignItems: 'center',
            gap: 6
        }
    }, t('visit.call.connecting')), error && open && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '10px 16px 0'
        },
        role: "alert",
        "data-testid": "visit-call-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 8,
            padding: '10px 12px',
            background: $013436dd88cfa3ff$var$S.dangerSoft,
            border: `1px solid ${$013436dd88cfa3ff$var$S.danger}`,
            borderRadius: $013436dd88cfa3ff$var$S.radius,
            fontSize: '0.75rem',
            color: $013436dd88cfa3ff$var$S.dangerInk,
            lineHeight: 1.8
        }
    }, t(`visit.call.error.${error}`))), convertible && open && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '0 16px 14px'
        },
        "data-testid": "visit-call-convert-panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.75rem',
            color: $013436dd88cfa3ff$var$S.ink2,
            lineHeight: 1.8,
            marginBottom: 10
        }
    }, t('visit.call.convertBody')), convertError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "alert",
        "data-testid": "visit-call-convert-error",
        style: {
            padding: '8px 12px',
            marginBottom: 10,
            borderRadius: $013436dd88cfa3ff$var$S.radius,
            background: $013436dd88cfa3ff$var$S.dangerSoft,
            border: `1px solid ${$013436dd88cfa3ff$var$S.danger}`,
            fontSize: '0.75rem',
            color: $013436dd88cfa3ff$var$S.dangerInk,
            lineHeight: 1.8
        }
    }, t('visit.call.convertError')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: ()=>convert({
                andCall: true
            }),
        disabled: converting,
        "data-testid": "visit-call-convert",
        style: {
            width: '100%',
            minHeight: 40,
            borderRadius: $013436dd88cfa3ff$var$S.radius,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 7,
            border: 'none',
            fontFamily: 'inherit',
            fontSize: '0.8125rem',
            fontWeight: 600,
            cursor: converting ? 'progress' : 'pointer',
            opacity: converting ? 0.7 : 1,
            background: $013436dd88cfa3ff$var$S.primary,
            color: '#fff'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($013436dd88cfa3ff$var$VideoIcon, {
        size: 15,
        color: "#fff"
    }), converting ? t('visit.call.converting') : t('visit.call.convertAndCall'))), !inCall && !convertible && open && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '0 16px 14px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: start,
        disabled: !available,
        "data-testid": "visit-call-connect",
        style: {
            width: '100%',
            minHeight: 40,
            borderRadius: $013436dd88cfa3ff$var$S.radius,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 7,
            border: 'none',
            fontFamily: 'inherit',
            fontSize: '0.8125rem',
            fontWeight: 600,
            cursor: available ? 'pointer' : 'not-allowed',
            opacity: available ? 1 : 0.55,
            background: $013436dd88cfa3ff$var$S.primary,
            color: '#fff'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($013436dd88cfa3ff$var$VideoIcon, {
        size: 15,
        color: "#fff"
    }), state === (0, $fiHxp.CALL_ERROR) ? t('visit.call.redial') : t('visit.call.connect')), available && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: 8,
            fontSize: '0.6875rem',
            color: $013436dd88cfa3ff$var$S.mute
        }
    }, t('visit.call.connectHint')), available && revert && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: revert,
        disabled: converting,
        "data-testid": "visit-call-revert",
        style: {
            marginTop: 6,
            minHeight: isMobile ? 44 : 28,
            padding: 0,
            background: 'none',
            border: 'none',
            fontFamily: 'inherit',
            fontSize: '0.75rem',
            fontWeight: 600,
            color: $013436dd88cfa3ff$var$S.ink2,
            textDecoration: 'underline',
            cursor: converting ? 'progress' : 'pointer'
        }
    }, t('visit.call.revert'))), inCall && open && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-call-not-recorded",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            padding: '8px 16px 12px',
            fontSize: '0.65625rem',
            color: $013436dd88cfa3ff$var$S.mute
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($013436dd88cfa3ff$var$ShieldIcon, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, t('visit.call.notRecorded'))));
}

});
parcelRegister("fiHxp", function(module, exports) {

$parcel$export(module.exports, "CALL_ERROR", () => $b23a4f29e1a7fc1a$export$93578a4f81d1df7e);
$parcel$export(module.exports, "useVideoVisit", () => $b23a4f29e1a7fc1a$export$fd58d87a1fa8fc0d);

var $acw62 = parcelRequire("acw62");

var $eVM84 = parcelRequire("eVM84");

var $4nQEn = parcelRequire("4nQEn");

var $aEedC = parcelRequire("aEedC");

var $6xvbB = parcelRequire("6xvbB");
const $b23a4f29e1a7fc1a$export$985b4499d05c66a6 = 'idle';
const $b23a4f29e1a7fc1a$export$3c482fb33388beb2 = 'starting';
const $b23a4f29e1a7fc1a$export$1617cb1ce4943d48 = 'live';
const $b23a4f29e1a7fc1a$export$93578a4f81d1df7e = 'error';
/** Read a GraphQL error code off whichever shape bffClient produced. */ function $b23a4f29e1a7fc1a$var$errorCode(err) {
    return err?.extensions?.code || err?.graphQLErrors?.[0]?.extensions?.code || null;
}
function $b23a4f29e1a7fc1a$export$fd58d87a1fa8fc0d({ patientId: patientId, appointmentId: appointmentId, ensureVisitStarted: ensureVisitStarted, providerName: providerName }) {
    const [state, setState] = (0, $acw62.useState)($b23a4f29e1a7fc1a$export$985b4499d05c66a6);
    const [error, setError] = (0, $acw62.useState)(null);
    const [available, setAvailable] = (0, $acw62.useState)(null);
    const [reason, setReason] = (0, $acw62.useState)(null);
    const [canConvert, setCanConvert] = (0, $acw62.useState)(false);
    const [converting, setConverting] = (0, $acw62.useState)(false);
    const [convertError, setConvertError] = (0, $acw62.useState)(false);
    const [enlarged, setEnlarged] = (0, $acw62.useState)(false);
    const apiRef = (0, $acw62.useRef)(null);
    const openingRef = (0, $acw62.useRef)(false);
    const containerRef = (0, $acw62.useRef)(null);
    // The conference frame and its origin, for «پایش بالینی» — during a call the
    // audio must come from the CALL, not from a second microphone that cannot
    // hear the patient. Null whenever no call is live, which is what makes the
    // in-person path fall through to the microphone unchanged.
    const [audioSource, setAudioSource] = (0, $acw62.useState)(null);
    /**
   * Take the conference down.
   *
   * Handlers are removed BEFORE `dispose()`: disposing fires
   * `readyToClose`/`videoConferenceLeft`, and a handler still attached would run
   * against state a later session may already own.
   */ const teardown = (0, $acw62.useCallback)(()=>{
        const api = apiRef.current;
        apiRef.current = null;
        openingRef.current = false;
        if (!api) return;
        try {
            api.removeAllListeners?.();
            api.dispose?.();
        } catch  {
        // A conference that is already gone is the state we wanted.
        }
    }, []);
    /**
   * Can this deployment open a call for this patient, right now?
   *
   * Cheap: `videoVisitAvailability` mints nothing and writes nothing, so it is
   * safe on mount and safe to repeat. It answers `not_configured` rather than
   * failing when the deployment has no media server.
   */ const probe = (0, $acw62.useCallback)(async ()=>{
        if (!patientId) {
            setAvailable(false);
            setCanConvert(false);
            setReason(null);
            return;
        }
        try {
            const data = await (0, $eVM84.bffQuery)((0, $6xvbB.VIDEO_VISIT_AVAILABILITY), {
                patientId: patientId,
                appointmentId: appointmentId || null
            });
            const a = data?.videoVisitAvailability;
            setAvailable(Boolean(a?.canJoin));
            setCanConvert(Boolean(a?.canConvert));
            setReason(a?.reason || null);
        } catch  {
            // A probe that failed is not a feature that is off, but for the purpose of
            // drawing a button the two are the same: do not offer what we could not
            // confirm.
            setAvailable(false);
            setCanConvert(false);
            setReason(null);
        }
    }, [
        patientId,
        appointmentId
    ]);
    const start = (0, $acw62.useCallback)(async ()=>{
        if (openingRef.current || apiRef.current) return;
        openingRef.current = true;
        setError(null);
        setState($b23a4f29e1a7fc1a$export$3c482fb33388beb2);
        try {
            // Pressing connect starts the visit. Done FIRST and through the screen's
            // own path, so a doctor answering a waiting patient never has to press
            // «شروع ویزیت» separately — and so there is still only one place that
            // marks an appointment in_visit.
            let apptId = appointmentId || null;
            if (!apptId && ensureVisitStarted) apptId = await ensureVisitStarted();
            // A fresh session BEFORE anything else. The token is short-lived by
            // design, so the query is re-run rather than its answer cached — and
            // re-running it is also what re-checks that this visit is still open.
            const data = await (0, $eVM84.bffQuery)((0, $6xvbB.VIDEO_VISIT_SESSION), {
                patientId: patientId,
                appointmentId: apptId || null
            });
            const session = data?.videoVisitSession;
            if (!session) {
                setAvailable(false);
                throw new Error('unavailable');
            }
            // The panel mounts its container in the same render that flips state to
            // STARTING, so the node exists by the time the await above resolves. If it
            // does not, the panel was closed mid-open — stop rather than attach a
            // conference to nothing.
            const parentNode = containerRef.current;
            if (!parentNode) {
                openingRef.current = false;
                setState($b23a4f29e1a7fc1a$export$985b4499d05c66a6);
                return;
            }
            const api = await (0, $4nQEn.startConference)({
                domain: session.domain,
                roomName: session.roomName,
                token: session.token,
                displayName: session.displayName,
                parentNode: parentNode,
                providerName: providerName,
                // The doctor is already inside the visit; a device-check screen here is
                // a second confirmation of a decision already made.
                prejoin: false
            });
            // Closed while the script was loading.
            if (!containerRef.current) {
                try {
                    api.dispose?.();
                } catch  {}
                openingRef.current = false;
                setState($b23a4f29e1a7fc1a$export$985b4499d05c66a6);
                return;
            }
            apiRef.current = api;
            openingRef.current = false;
            setState($b23a4f29e1a7fc1a$export$1617cb1ce4943d48);
            // Published only once the conference is actually up, so «پایش بالینی»
            // can never attach to a frame that is still negotiating.
            const frame = (0, $aEedC.conferenceFrame)(api, parentNode);
            setAudioSource(frame ? {
                frame: frame,
                origin: `https://${session.domain}`
            } : null);
            // «قطع تماس» inside the Jitsi UI, and any other end the iframe decides on.
            // Without this the panel would keep showing a dead conference.
            api.addListener('readyToClose', ()=>{
                teardown();
                setState($b23a4f29e1a7fc1a$export$985b4499d05c66a6);
                setEnlarged(false);
                setAudioSource(null);
            });
            api.addListener('errorOccurred', (event)=>{
                // Only a fatal error takes the call down; Jitsi reports recoverable ones
                // (a brief reconnect) through the same channel.
                if (event?.error?.isFatal) {
                    teardown();
                    setError('connection');
                    setState($b23a4f29e1a7fc1a$export$93578a4f81d1df7e);
                    setEnlarged(false);
                    setAudioSource(null);
                }
            });
        } catch (err) {
            teardown();
            const code = $b23a4f29e1a7fc1a$var$errorCode(err);
            setError(code === 'VISIT_NOT_EDITABLE' ? 'visitOver' : code === 'NO_OPEN_APPOINTMENT' ? 'noAppointment' : code === 'NOT_ONLINE' || err?.message === 'unavailable' ? 'unavailable' : 'connection');
            setState($b23a4f29e1a7fc1a$export$93578a4f81d1df7e);
            setEnlarged(false);
        }
    }, [
        patientId,
        appointmentId,
        ensureVisitStarted,
        providerName,
        teardown
    ]);
    /**
   * Change the visit's mode and take the BFF's fresh answer as the new state.
   * Returns true when the write landed.
   */ const setMode = (0, $acw62.useCallback)(async (online)=>{
        if (!patientId || converting) return false;
        setConverting(true);
        setConvertError(false);
        try {
            const data = await (0, $eVM84.bffMutation)((0, $6xvbB.SET_VISIT_MODE), {
                patientId: patientId,
                appointmentId: appointmentId || null,
                online: online
            });
            const a = data?.setVisitMode;
            setAvailable(Boolean(a?.canJoin));
            setCanConvert(Boolean(a?.canConvert));
            setReason(a?.reason || null);
            return true;
        } catch  {
            setConvertError(true);
            return false;
        } finally{
            setConverting(false);
        }
    }, [
        patientId,
        appointmentId,
        converting
    ]);
    /**
   * «تبدیل به ویزیت آنلاین». With `andCall`, the same press goes on to open the
   * call — the doctor asked for an online visit, not for a second button.
   */ const convert = (0, $acw62.useCallback)(async ({ andCall: andCall = false } = {})=>{
        const ok = await setMode(true);
        if (ok && andCall) await start();
        return ok;
    }, [
        setMode,
        start
    ]);
    /** «برگرداندن به ویزیت حضوری» — never under a running call. */ const revert = (0, $acw62.useCallback)(async ()=>{
        if (apiRef.current || openingRef.current) return false;
        return setMode(false);
    }, [
        setMode
    ]);
    const clearConvertError = (0, $acw62.useCallback)(()=>setConvertError(false), []);
    /** «پایان تماس» from OUR chrome, as opposed to Jitsi's own hangup. */ const stop = (0, $acw62.useCallback)(()=>{
        const api = apiRef.current;
        // Ask the conference to leave properly first so the other side sees a
        // departure rather than a silence; teardown then disposes regardless.
        try {
            api?.executeCommand?.('hangup');
        } catch  {}
        teardown();
        setState($b23a4f29e1a7fc1a$export$985b4499d05c66a6);
        setError(null);
        setEnlarged(false);
        setAudioSource(null);
    }, [
        teardown
    ]);
    /** «بزرگ‌نمایی» / «کوچک‌نمایی» — a CSS size change on ONE node. See VisitCall.jsx. */ const toggleEnlarged = (0, $acw62.useCallback)(()=>setEnlarged((v)=>!v), []);
    // Esc returns from the enlarged view. Attached only WHILE enlarged, so this
    // screen's sheets and dialogs keep their own Esc the rest of the time.
    (0, $acw62.useEffect)(()=>{
        if (!enlarged) return undefined;
        const onKey = (e)=>{
            if (e.key === 'Escape') setEnlarged(false);
        };
        window.addEventListener('keydown', onKey);
        return ()=>window.removeEventListener('keydown', onKey);
    }, [
        enlarged
    ]);
    // A conference outlives the screen unless something ends it. This is the
    // camera indicator staying lit after the doctor navigated away.
    (0, $acw62.useEffect)(()=>teardown, [
        teardown
    ]);
    // Moving to another visit must not leave the previous visit's call running in
    // a container that now belongs to a different patient.
    (0, $acw62.useEffect)(()=>{
        teardown();
        setState($b23a4f29e1a7fc1a$export$985b4499d05c66a6);
        setError(null);
        setEnlarged(false);
        setAudioSource(null);
        setConvertError(false);
    }, [
        patientId,
        teardown
    ]);
    return {
        state: state,
        error: error,
        available: available,
        reason: reason,
        containerRef: containerRef,
        enlarged: enlarged,
        audioSource: audioSource,
        canConvert: canConvert,
        converting: converting,
        convertError: convertError,
        live: state === $b23a4f29e1a7fc1a$export$1617cb1ce4943d48,
        busy: state === $b23a4f29e1a7fc1a$export$3c482fb33388beb2,
        probe: probe,
        start: start,
        stop: stop,
        toggleEnlarged: toggleEnlarged,
        convert: convert,
        revert: revert,
        clearConvertError: clearConvertError
    };
}

});
parcelRegister("4nQEn", function(module, exports) {

$parcel$export(module.exports, "startConference", () => $331226a77f852a09$export$323cdae55ed0200);
// ویزیت تصویری — loading and driving the Jitsi IFrame API.
//
// React-free on purpose, like the rest of src/lib: this module knows about a
// script tag and an external API object, and nothing about the screen it is
// drawn on. The hook (src/hooks/useVideoVisit.js) owns the React side.
//
// ── Why the script is loaded at RUN TIME from the server's answer ────────────
// `external_api.js` must come from the SAME host that serves the conference,
// and which host that is arrives in `videoVisitSession.domain` — from the BFF,
// per environment. Bundling it, or configuring the URL in the client, would put
// a second copy of "which environment am I in" in the client, and a staging
// client pointed at a production media server is exactly the kind of mismatch
// runtimeEnv.js's BFF_WS_BASE derivation exists to prevent.

var $eLeza = parcelRequire("eLeza");

var $hlTfq = parcelRequire("hlTfq");
/** Resolved script loads, keyed by domain — the tag is added at most once. */ const $331226a77f852a09$var$loaded = new Map();
/**
 * The call's own interface language when the caller names none: Persian, as it
 * has always been — unless the brand does not offer Persian (ui/lib/brand.js),
 * where it is the panel's language, the one the person is reading.
 */ const $331226a77f852a09$var$defaultCallLanguage = ()=>{
    const offered = (0, $eLeza.brand)().locales;
    return !offered || offered.includes('fa') ? 'fa' : (0, $hlTfq.documentLocale)();
};
function $331226a77f852a09$export$e5f23e1a6d5d1e7b(domain) {
    if (!domain) return Promise.reject(new Error('jitsi: no domain'));
    const existing = $331226a77f852a09$var$loaded.get(domain);
    if (existing) return existing;
    const promise = new Promise((resolve, reject)=>{
        // Already there — a previous load in this session, or a remount after the
        // map was cleared. The global is what matters, not our bookkeeping.
        if (typeof window !== 'undefined' && window.JitsiMeetExternalAPI) {
            resolve(window.JitsiMeetExternalAPI);
            return;
        }
        const script = document.createElement('script');
        script.src = `https://${domain}/external_api.js`;
        script.async = true;
        script.onload = ()=>{
            if (window.JitsiMeetExternalAPI) resolve(window.JitsiMeetExternalAPI);
            else reject(new Error('jitsi: script loaded but API is missing'));
        };
        script.onerror = ()=>{
            // The tag is dropped so a later attempt can retry: a failed load that
            // leaves its tag behind makes every retry a no-op.
            $331226a77f852a09$var$loaded.delete(domain);
            script.remove();
            reject(new Error('jitsi: script failed to load'));
        };
        document.head.appendChild(script);
    });
    $331226a77f852a09$var$loaded.set(domain, promise);
    return promise;
}
function $331226a77f852a09$export$dcaa598e6bc560df({ roomName: roomName, token: token, displayName: displayName, parentNode: parentNode, prejoin: prejoin = false, lang: lang = $331226a77f852a09$var$defaultCallLanguage(), providerName: // The brand as the CALL shows it — window title, join/leave notifications.
// An argument rather than a literal because it is user-facing and therefore
// translatable: the doctor app passes it through t(), and this module has no
// i18n of its own (it is React-free by design). The Latin default is the
// brand's name (ui/lib/brand.js), safe in any locale, and keeps this file
// free of UI strings.
providerName = (0, $eLeza.brandName)('en') }) {
    return {
        roomName: roomName,
        jwt: token,
        parentNode: parentNode,
        width: '100%',
        height: '100%',
        userInfo: {
            displayName: displayName
        },
        configOverwrite: {
            // The doctor joins from inside the visit workspace and the patient from
            // a card they already tapped; a prejoin screen is a second confirmation
            // of a decision already made. The patient app turns it back on, where
            // checking your own camera before a doctor sees you is worth the tap.
            //
            // `prejoinConfig` and nothing else: the older `prejoinPageEnabled` is not
            // on the config whitelist — see «Branding» below — so it was doing
            // nothing, and this is the key the device-check screen actually obeys.
            prejoinConfig: {
                enabled: prejoin
            },
            startWithAudioMuted: false,
            startWithVideoMuted: false,
            disableDeepLinking: true,
            // 1:1. Nobody is invited, so nothing offers to invite.
            disableInviteFunctions: true,
            doNotStoreRoom: true,
            // ── Branding: the ONE key that reaches the conference ────────────────
            // An empty logo URL means the watermark renders nothing at all. It is not
            // a preference — it is the only lever the client has:
            //
            //   • Jitsi filters EVERY override we send. `configOverwrite` and
            //     `interfaceConfigOverwrite` both travel as URL-hash params that
            //     external_api.js appends, and the app picks them through a whitelist
            //     before merging. Whatever is not on the list is dropped in silence;
            //     the console logs only the survivors, as «Extending config with: …».
            //   • The interfaceConfig whitelist — 44 keys in jitsi/web:stable-11031 —
            //     contains NO logo or watermark key. SHOW_JITSI_WATERMARK,
            //     DEFAULT_LOGO_URL and their neighbours were set here for months and
            //     never once took effect: that is how the Jitsi logo outlived the
            //     commit that "removed" it.
            //   • The logo url moved to config.defaultLogoUrl. Left unset, a legacy
            //     shim in the bundle falls back to the hardcoded images/watermark.svg
            //     — the Jitsi logo — because the server's interface_config.js has
            //     DEFAULT_LOGO_URL commented out. Setting it is the whole fix.
            //   • This key is whitelisted only while the app runs in an IFRAME
            //     (`window.self !== window.top`), which every Parsina client does. If
            //     a future jitsi/web image drops that gate the logo comes back, and
            //     this line is the first place to look; the escape hatch is then
            //     server-side — see parsina.k8s.deployments/jitsi/README.md.
            //
            // To show پارسینا in the call rather than nothing, this is the one line
            // to change: 'images/parsina-logo.png' is already served by the media
            // server (parsina.k8s.deployments/jitsi/branding.yaml). Relative on
            // purpose — it resolves against the conference host, so the image is
            // same-origin, carries no build hash and names no environment.
            defaultLogoUrl: '',
            // Jitsi's OWN transcriber, refused. It is NOT «پایش بالینی», which is
            // Parsina's own AI reading the conversation live to draft the note and
            // writing nothing to disk. Do not turn this on to enable that — they are
            // unrelated systems. See docs/online-visit-audio-capture.md.
            transcribingEnabled: false,
            liveStreamingEnabled: false,
            hideConferenceSubject: true,
            hideConferenceTimer: false,
            disableThirdPartyRequests: true
        },
        interfaceConfigOverwrite: {
            // Only whitelisted keys reach the conference (see «Branding» above), and
            // these are the ones the list actually honours. Anything about the
            // watermark or the logo belongs in configOverwrite.defaultLogoUrl —
            // adding a SHOW_*_WATERMARK key back here changes nothing at all.
            TOOLBAR_BUTTONS: [
                'microphone',
                'camera',
                'desktop',
                'fullscreen',
                'settings',
                'videoquality',
                'tileview',
                'hangup'
            ],
            // Nothing is KEPT. Recording is not offered because it is absent from
            // TOOLBAR_BUTTONS, the minted token refuses it, and there is no jibri
            // container that could honour it — those three facts are the guarantee.
            // The fileRecordingsEnabled flag that used to sit in configOverwrite read
            // like a fourth one and was discarded by the whitelist unread.
            PROVIDER_NAME: providerName,
            NATIVE_APP_NAME: providerName,
            SHOW_POWERED_BY: false,
            // No DEFAULT_BACKGROUND. It would have to be a literal colour — the
            // design tokens are CSS `var()` references and mean nothing inside
            // Jitsi's iframe — and a raw hex is exactly what the conformance tests
            // in both clients refuse. The branding is on OUR chrome around the frame;
            // the video area is the video.
            DISABLE_JOIN_LEAVE_NOTIFICATIONS: false
        },
        lang: lang
    };
}
async function $331226a77f852a09$export$323cdae55ed0200(options) {
    const JitsiMeetExternalAPI = await $331226a77f852a09$export$e5f23e1a6d5d1e7b(options.domain);
    const { domain: domain, ...rest } = options;
    return new JitsiMeetExternalAPI(domain, $331226a77f852a09$export$dcaa598e6bc560df(rest));
}

});

parcelRegister("aEedC", function(module, exports) {

$parcel$export(module.exports, "startCallAudio", () => $7c08ab51fde905a5$export$e24590596d9795fc);
$parcel$export(module.exports, "conferenceFrame", () => $7c08ab51fde905a5$export$6e2ba4bd9a522bbc);
// «پایش بالینی» — taking the visit's audio from the CALL instead of the mic.
//
// The parent half of parsina.k8s.deployments/jitsi/bridge/parsina-audio-bridge.js.
// React-free, like the rest of src/lib: it knows about an iframe and a message
// channel, and nothing about the screen it is used on.
//
// ── Why this exists ─────────────────────────────────────────────────────────
// During a video visit the microphone is the wrong source, and not by a little:
//
//   · The patient is INAUDIBLE on it. Their voice reaches the doctor through
//     the speakers, and echo cancellation exists precisely to remove that — so
//     «پایش بالینی» captured one half of a dialogue and the AI, whose prompt
//     assumes "a raw mixed recording" of both people, wrote a confident note
//     from it. A half-transcript that looks whole is worse than none.
//   · On iOS Safari a second `getUserMedia` steals the audio session, so
//     starting monitoring could break the call's own microphone.
//
// The conference already holds both tracks. It just lives on another origin, so
// a script inside it hands them over here.
//
// ── What this module does NOT decide ────────────────────────────────────────
// Whether to monitor at all. It is a source, nothing more: it starts when asked
// and stops when asked, exactly like the microphone it replaces.
/** Message names, byte-identical to the in-iframe half. */ const $7c08ab51fde905a5$export$78d8c50e853acd10 = {
    START: 'parsina:audio:start',
    STOP: 'parsina:audio:stop',
    READY: 'parsina:audio:ready',
    CHUNK: 'parsina:audio:chunk',
    STATE: 'parsina:audio:state',
    ERROR: 'parsina:audio:error'
};
/** How long to wait for the bridge to answer before falling back. */ const $7c08ab51fde905a5$var$READY_TIMEOUT_MS = 4000;
function $7c08ab51fde905a5$export$e24590596d9795fc(iframe, origin, onChunk) {
    return new Promise((resolve, reject)=>{
        const target = iframe?.contentWindow;
        if (!target || !origin) {
            reject(new Error('bridge: no conference frame'));
            return;
        }
        let settled = false;
        let timer = null;
        const onMessage = (event)=>{
            // Both checks matter: the origin proves it is the conference, and the
            // source window proves it is OUR conference and not another frame on the
            // same host.
            if (event.origin !== origin || event.source !== target) return;
            const data = event.data;
            if (!data || typeof data.type !== 'string') return;
            if (data.type === $7c08ab51fde905a5$export$78d8c50e853acd10.CHUNK && data.chunk) {
                // Arrives as an ArrayBuffer; the socket wants something sendable.
                onChunk(new Blob([
                    data.chunk
                ], {
                    type: 'audio/webm'
                }));
                return;
            }
            if (data.type === $7c08ab51fde905a5$export$78d8c50e853acd10.READY && !settled) {
                settled = true;
                clearTimeout(timer);
                resolve({
                    sources: Number(data.sources) || 0,
                    stop () {
                        window.removeEventListener('message', onMessage);
                        try {
                            target.postMessage({
                                type: $7c08ab51fde905a5$export$78d8c50e853acd10.STOP
                            }, origin);
                        } catch  {
                        // The frame is already gone; nothing to stop.
                        }
                    }
                });
                return;
            }
            if (data.type === $7c08ab51fde905a5$export$78d8c50e853acd10.ERROR && !settled) {
                settled = true;
                clearTimeout(timer);
                window.removeEventListener('message', onMessage);
                reject(new Error(`bridge: ${data.reason || 'failed'}`));
            }
        };
        window.addEventListener('message', onMessage);
        try {
            target.postMessage({
                type: $7c08ab51fde905a5$export$78d8c50e853acd10.START
            }, origin);
        } catch (err) {
            window.removeEventListener('message', onMessage);
            reject(err);
            return;
        }
        timer = setTimeout(()=>{
            if (settled) return;
            settled = true;
            window.removeEventListener('message', onMessage);
            // Silence here means an older media server with no bridge script. Say so
            // plainly rather than waiting forever with the meter running.
            reject(new Error('bridge: no response'));
        }, $7c08ab51fde905a5$var$READY_TIMEOUT_MS);
    });
}
function $7c08ab51fde905a5$export$6e2ba4bd9a522bbc(api, container) {
    try {
        const fromApi = api?.getIFrame?.();
        if (fromApi) return fromApi;
    } catch  {
    // Not available on this version.
    }
    return container?.querySelector?.('iframe') || null;
}

});



parcelRegister("3wi2X", function(module, exports) {

$parcel$export(module.exports, "useWalletBalance", () => $29025bf29a861ca6$export$512f6b8a30d065e1);

var $acw62 = parcelRequire("acw62");

var $e317r = parcelRequire("e317r");

var $eVM84 = parcelRequire("eVM84");
const $29025bf29a861ca6$var$WALLET_QUERY = `
  query GetWalletBalance($ownerId: String!, $ownerType: String!) {
    walletBalance(ownerId: $ownerId, ownerType: $ownerType) {
      balance
      currency
    }
  }
`;
const $29025bf29a861ca6$export$86382edbd39ea53 = 'parsina:wallet-changed';
function $29025bf29a861ca6$export$70e96f88d72639c() {
    if (typeof window !== 'undefined') window.dispatchEvent(new Event($29025bf29a861ca6$export$86382edbd39ea53));
}
function $29025bf29a861ca6$export$512f6b8a30d065e1(doctorId) {
    const [balance, setBalance] = (0, $acw62.useState)(null);
    // The HOST's path, not a router's: the clinical module has no router of its own.
    const { pathname: pathname = '' } = (0, $e317r.useClinicalHost)();
    const prevPathRef = (0, $acw62.useRef)(pathname);
    const fetch = (0, $acw62.useCallback)(()=>{
        if (!doctorId) return;
        (0, $eVM84.bffQuery)($29025bf29a861ca6$var$WALLET_QUERY, {
            ownerId: doctorId,
            ownerType: 'doctor'
        }).then((data)=>setBalance(data?.walletBalance?.balance ?? null)).catch(()=>{});
    }, [
        doctorId
    ]);
    // Fetch on mount and whenever doctorId changes
    (0, $acw62.useEffect)(()=>{
        fetch();
    }, [
        fetch
    ]);
    // Refetch when navigating back to any non-visit screen (e.g. returning from visit)
    (0, $acw62.useEffect)(()=>{
        const prev = prevPathRef.current;
        const curr = pathname;
        prevPathRef.current = curr;
        // Only refetch if we navigated away from a visit screen
        if (prev.includes('/visit') && !curr.includes('/visit')) fetch();
    }, [
        pathname,
        fetch
    ]);
    // Refetch when something in this tab moved the balance.
    (0, $acw62.useEffect)(()=>{
        window.addEventListener($29025bf29a861ca6$export$86382edbd39ea53, fetch);
        return ()=>window.removeEventListener($29025bf29a861ca6$export$86382edbd39ea53, fetch);
    }, [
        fetch
    ]);
    // Refetch when the tab becomes visible again (user switches back)
    (0, $acw62.useEffect)(()=>{
        const onVisible = ()=>{
            if (document.visibilityState === 'visible') fetch();
        };
        document.addEventListener('visibilitychange', onVisible);
        return ()=>document.removeEventListener('visibilitychange', onVisible);
    }, [
        fetch
    ]);
    return balance;
}

});

parcelRegister("5VYuu", function(module, exports) {

$parcel$export(module.exports, "useRxMemory", () => $452132d912e4065c$export$d3fd5ad9fcb9d267);

var $acw62 = parcelRequire("acw62");

var $6xvbB = parcelRequire("6xvbB");

var $eQiuG = parcelRequire("eQiuG");
// ─────────────────────────────────────────────────────────────────────────────
// «آخرین تنظیم شما» — what the doctor last set for a drug opens its add form
// (PM-0574, owner 2026-10-24: "for next time, we know the values he set for that
// drug so he doesn't need to complete it again, and it is always the most
// recent one").
//
// Three sources, each newer than the one before it:
//   1. «داروهای پرتکرار من» (`frequentDrugs`, the host's list) — the top
//      products, each with its latest directions; no date.
//   2. `myLastDrugSigs` — the latest directions of ANY product the doctor ever
//      prescribed, with `lastAt`; asked for the products a screen is about to
//      offer (`request`), once per visit (fetchLastDrugSigs).
//   3. A line added in THIS visit (`remember`) — the newest of all, so a
//      late answer from the server never replaces it.
// The newest wins per product. Everything here is on today's closed lists
// (usualRxDefaults) and only ever a DEFAULT: an explicit source — an AI or voice
// proposal, a document — still wins over it in the form, a template is applied
// whole and a refill keeps the patient's own past values.
//
// One hook for the desktop visit, the phone visit and the past-visit correction
// sheet; `memory` is what RxDrugSearch takes.
// ─────────────────────────────────────────────────────────────────────────────
const $452132d912e4065c$var$NONE = [];
const $452132d912e4065c$var$stamp = (e)=>e?.lastAt ? Date.parse(e.lastAt) || 0 : 0;
const $452132d912e4065c$var$str = (v)=>String(v ?? '').trim();
function $452132d912e4065c$export$d3fd5ad9fcb9d267({ frequentDrugs: frequentDrugs = $452132d912e4065c$var$NONE, lists: lists, defaultDuration: defaultDuration = '' } = {}) {
    const cache = (0, $acw62.useRef)(null);
    if (!cache.current) cache.current = (0, $6xvbB.newLastDrugSigsCache)();
    // product id → its latest entry, from the server or from this visit.
    const [sigs, setSigs] = (0, $acw62.useState)(()=>new Map());
    const sigsRef = (0, $acw62.useRef)(sigs);
    const keep = (0, $acw62.useCallback)((entries)=>{
        let next = null;
        for (const e of entries || []){
            const id = $452132d912e4065c$var$str(e?.drug?.id);
            if (!id) continue;
            const had = (next || sigsRef.current).get(id);
            if (had === e || had && $452132d912e4065c$var$stamp(had) > $452132d912e4065c$var$stamp(e)) continue; // a newer one is known
            if (!next) next = new Map(sigsRef.current);
            next.set(id, e);
        }
        if (!next) return;
        sigsRef.current = next;
        setSigs(next);
    }, []);
    /** Ask for these products' last directions (deduplicated, batched, never throws). */ const request = (0, $acw62.useCallback)(async (ids)=>{
        const found = await (0, $6xvbB.fetchLastDrugSigs)(ids, cache.current);
        keep(found);
        return found;
    }, [
        keep
    ]);
    /** A line just added in this visit: its directions are now the latest. */ const remember = (0, $acw62.useCallback)((drug, sig)=>{
        if (!drug?.id) return;
        const s = (k)=>$452132d912e4065c$var$str(sig?.[k]);
        keep([
            {
                drug: drug,
                name: drug.name || drug.genericName || '',
                search: '',
                times: 0,
                dosage: s('dosage'),
                frequency: s('frequency'),
                route: s('route'),
                duration: s('duration'),
                quantity: s('quantity'),
                instructions: s('instructions'),
                lastAt: new Date().toISOString(),
                local: true
            }
        ]);
    }, [
        keep
    ]);
    // The frequent list's products are worth a date too — the form says when.
    const frequentIds = (0, $acw62.useMemo)(()=>(frequentDrugs || []).map((f)=>$452132d912e4065c$var$str(f?.drug?.id)).filter(Boolean).join('\u0000'), [
        frequentDrugs
    ]);
    (0, $acw62.useEffect)(()=>{
        if (frequentIds) request(frequentIds.split('\u0000'));
    }, [
        frequentIds,
        request
    ]);
    const build = (frequent, known, rxLists)=>{
        const m = new Map();
        for (const f of frequent || []){
            const u = f?.drug?.id ? (0, $eQiuG.usualRxDefaults)(f, rxLists) : null;
            if (u) m.set($452132d912e4065c$var$str(f.drug.id), u);
        }
        for (const [id, e] of known){
            const u = (0, $eQiuG.usualRxDefaults)(e, rxLists);
            if (u) m.set(id, u);
        }
        return m;
    };
    /** product id → the directions a new line of it starts from. */ const usualRx = (0, $acw62.useMemo)(()=>build(frequentDrugs, sigs, lists), [
        frequentDrugs,
        sigs,
        lists
    ]);
    // For a caller that awaited something (a treatment plan being applied): the
    // memory as it is NOW, not as the render that started it saw it.
    const latest = (0, $acw62.useRef)({
        frequentDrugs: frequentDrugs,
        lists: lists
    });
    latest.current = {
        frequentDrugs: frequentDrugs,
        lists: lists
    };
    const usualOf = (0, $acw62.useCallback)((id)=>{
        const key = $452132d912e4065c$var$str(id);
        const own = sigsRef.current.get(key);
        if (own) return (0, $eQiuG.usualRxDefaults)(own, latest.current.lists);
        const f = (latest.current.frequentDrugs || []).find((e)=>$452132d912e4065c$var$str(e?.drug?.id) === key);
        return f ? (0, $eQiuG.usualRxDefaults)(f, latest.current.lists) : null;
    }, []);
    const rxDefaultsFor = (0, $acw62.useCallback)((drug)=>(0, $eQiuG.rxAddDefaults)(drug, usualRx.get($452132d912e4065c$var$str(drug?.id)), {
            defaultDuration: defaultDuration
        }), [
        usualRx,
        defaultDuration
    ]);
    /** { lastAt } when the doctor's own directions open this product, else null. */ const rememberedFor = (0, $acw62.useCallback)((drug)=>{
        const id = $452132d912e4065c$var$str(drug?.id);
        if (!usualRx.has(id)) return null;
        return {
            lastAt: sigs.get(id)?.lastAt || null
        };
    }, [
        usualRx,
        sigs
    ]);
    const lastAtOf = (0, $acw62.useCallback)((id)=>sigs.get($452132d912e4065c$var$str(id))?.lastAt || null, [
        sigs
    ]);
    const memory = (0, $acw62.useMemo)(()=>({
            request: request,
            lastAtOf: lastAtOf,
            rememberedFor: rememberedFor
        }), [
        request,
        lastAtOf,
        rememberedFor
    ]);
    return {
        usualRx: usualRx,
        rxDefaultsFor: rxDefaultsFor,
        rememberedFor: rememberedFor,
        lastAtOf: lastAtOf,
        request: request,
        remember: remember,
        usualOf: usualOf,
        memory: memory
    };
}

});

parcelRegister("epeHA", function(module, exports) {

$parcel$export(module.exports, "creditLevel", () => (parcelRequire("jTCZr")).creditLevel);
// Parsina-Credit («پارسه») balance thresholds.
//
// THE DEFINITION MOVED. It lives in `@parsina/framework/tokens` as of framework
// v0.10.0 and this file is now a re-export, so the ~15 call sites that know it by
// this path keep working while there is exactly ONE copy in the monorepo.
//
// It moved because there were three: this file, the dentist client's
// `constants/credit.js` and the clinic client's `hooks/useClinicCredits.js`, each
// carrying the same two numbers and the same three levels, and each commented
// "deliberately identical to the other panel's" — three files kept in sync by
// comment, which is not a mechanism. One person has ONE wallet: a dentist who
// also uses this panel is looking at the same balance in both, so «اعتبار کم»
// cannot mean 50 پارسه here and something else there.
//
// Add nothing to this file. A new rule about how a balance is painted belongs in
// the framework, where every panel gets it.

var $jTCZr = parcelRequire("jTCZr");

});

parcelRegister("dL6zl", function(module, exports) {

$parcel$export(module.exports, "parseNoteContent", () => $a044c29e4a6b3520$export$90858b03e74b9658);
$parcel$export(module.exports, "noteText", () => $a044c29e4a6b3520$export$9329abe70f8a78fc);
$parcel$export(module.exports, "isSummaryNote", () => $a044c29e4a6b3520$export$7be7553f2fdf281);
$parcel$export(module.exports, "soapKey", () => $a044c29e4a6b3520$export$4c2eaf911d9f840f);
$parcel$export(module.exports, "primarySoapNote", () => $a044c29e4a6b3520$export$b26efe9e640f95c2);
$parcel$export(module.exports, "readSoapSection", () => $a044c29e4a6b3520$export$e6f6e37795c24083);
$parcel$export(module.exports, "readSoapDraft", () => $a044c29e4a6b3520$export$41de64d84beb8926);
$parcel$export(module.exports, "hasSoapContent", () => $a044c29e4a6b3520$export$be3e5596841df79);
$parcel$export(module.exports, "visitSoapSections", () => $a044c29e4a6b3520$export$4d9d7c6db1edc419);
$parcel$export(module.exports, "otherNotes", () => $a044c29e4a6b3520$export$3389fc0b000be7e3);
$parcel$export(module.exports, "soapEditStamp", () => $a044c29e4a6b3520$export$8f3b6b15bd4ed240);
$parcel$export(module.exports, "isLiveEncounter", () => $a044c29e4a6b3520$export$9cbdfdc6daea18e2);
// Reading a visit's SOAP note — one implementation for every surface.
//
// THREE shapes are live in the data, and a reader that knows one of them shows
// an empty — or worse, mislabelled — note for the other two:
//
//   1. one row, noteType SOAP_NOTE, content {s, o, a, p}   ← what this app writes
//   2. one row per section, noteType SOAP_S / subjective / …, text in content
//   3. one row, noteType SOAP, content a flat "S: …\n\nO: …" string
//      ← what the Flutter doctor app writes
//
// This module is that reader. It was the desktop record's private logic; the
// phone had its own, narrower version and could not display a normal SOAP note
// at all, which is exactly the class of divergence a shared module prevents.
// Shape 3 matters for the same reason in the other direction: a visit charted on
// the Flutter app is read here, and would otherwise show as one unsplit block.
const $a044c29e4a6b3520$export$7c327048bd66c9d9 = [
    'S',
    'O',
    'A',
    'P'
];
const $a044c29e4a6b3520$var$SOAP_TYPES = {
    S: [
        'SOAP_S',
        'subjective',
        'chief_complaint',
        'history'
    ],
    O: [
        'SOAP_O',
        'objective',
        'examination',
        'findings'
    ],
    A: [
        'SOAP_A',
        'assessment',
        'evaluation'
    ],
    P: [
        'SOAP_P',
        'plan',
        'treatment_plan'
    ]
};
function $a044c29e4a6b3520$export$90858b03e74b9658(c) {
    if (typeof c === 'string') try {
        return JSON.parse(c);
    } catch  {
        return {
            text: c
        };
    }
    if (c && typeof c === 'object') return c;
    return {};
}
function $a044c29e4a6b3520$export$9329abe70f8a78fc(n) {
    if (!n) return '';
    const c = n.content;
    if (typeof c === 'string') return c;
    if (c && typeof c === 'object') {
        if (typeof c.text === 'string') return c.text;
        return Object.values(c).filter((v)=>typeof v === 'string' && v.trim()).join('\n\n');
    }
    return '';
}
const $a044c29e4a6b3520$export$c9bd16384a2ab405 = (n)=>[
        'SOAP_NOTE',
        'SOAP'
    ].includes((n?.noteType || '').toUpperCase());
const $a044c29e4a6b3520$export$7be7553f2fdf281 = (n)=>(n?.noteType || '').toUpperCase() === 'VISIT_SUMMARY';
function $a044c29e4a6b3520$export$4c2eaf911d9f840f(n, k) {
    const c = $a044c29e4a6b3520$export$90858b03e74b9658(n?.content);
    const lower = k.toLowerCase();
    if (typeof c[lower] === 'string' && c[lower].trim()) return c[lower];
    return typeof c[k] === 'string' ? c[k] : '';
}
function $a044c29e4a6b3520$export$621a2712ace849e5(text) {
    const out = {};
    if (typeof text !== 'string' || !text.trim()) return out;
    const re = /(^|\n)\s*([SOAP])\s*:\s*/g;
    const marks = [];
    let m;
    while((m = re.exec(text)) !== null)marks.push({
        key: m[2],
        from: m.index + m[0].length
    });
    if (!marks.length) return out;
    marks.forEach((mark, i)=>{
        const end = i + 1 < marks.length ? text.lastIndexOf('\n', marks[i + 1].from) : text.length;
        out[mark.key] = text.slice(mark.from, end < mark.from ? text.length : end).trim();
    });
    return out;
}
function $a044c29e4a6b3520$export$b26efe9e640f95c2(notes) {
    const soaps = (notes || []).filter($a044c29e4a6b3520$export$c9bd16384a2ab405);
    return soaps.find((n)=>$a044c29e4a6b3520$export$7c327048bd66c9d9.some((k)=>$a044c29e4a6b3520$export$4c2eaf911d9f840f(n, k).trim())) || soaps[0] || null;
}
function $a044c29e4a6b3520$export$e6f6e37795c24083(notes, k) {
    const list = notes || [];
    for (const n of list){
        if (!$a044c29e4a6b3520$export$c9bd16384a2ab405(n)) continue;
        const v = $a044c29e4a6b3520$export$4c2eaf911d9f840f(n, k);
        if (v.trim()) return v;
        // A note written by the Flutter app is one flat string, not four keys.
        const c = $a044c29e4a6b3520$export$90858b03e74b9658(n.content);
        const flat = typeof n.content === 'string' ? n.content : typeof c.text === 'string' ? c.text : '';
        const split = $a044c29e4a6b3520$export$621a2712ace849e5(flat)[k];
        if (split) return split;
    }
    const types = $a044c29e4a6b3520$var$SOAP_TYPES[k] || [];
    return list.filter((n)=>types.some((item)=>(n.noteType || '').toLowerCase().includes(item.toLowerCase()))).map($a044c29e4a6b3520$export$9329abe70f8a78fc).filter(Boolean).join('\n\n');
}
const $a044c29e4a6b3520$export$41de64d84beb8926 = (notes)=>$a044c29e4a6b3520$export$7c327048bd66c9d9.reduce((acc, k)=>{
        acc[k] = $a044c29e4a6b3520$export$e6f6e37795c24083(notes, k);
        return acc;
    }, {});
const $a044c29e4a6b3520$export$be3e5596841df79 = (notes)=>$a044c29e4a6b3520$export$7c327048bd66c9d9.some((k)=>$a044c29e4a6b3520$export$e6f6e37795c24083(notes, k).trim());
const $a044c29e4a6b3520$export$4d9d7c6db1edc419 = (notes)=>{
    const soap = (notes || []).map((n)=>$a044c29e4a6b3520$export$c9bd16384a2ab405(n) ? n : {
            ...n,
            noteType: 'SOAP'
        });
    return $a044c29e4a6b3520$export$7c327048bd66c9d9.map((key)=>({
            key: key,
            text: String($a044c29e4a6b3520$export$e6f6e37795c24083(soap, key) || '').trim()
        })).filter((section)=>section.text);
};
const $a044c29e4a6b3520$export$3389fc0b000be7e3 = (notes)=>(notes || []).filter((n)=>!$a044c29e4a6b3520$export$7be7553f2fdf281(n) && !$a044c29e4a6b3520$export$c9bd16384a2ab405(n) && !$a044c29e4a6b3520$export$a4eacf66670598b3(n));
function $a044c29e4a6b3520$export$a4eacf66670598b3(n) {
    const nt = (n?.noteType || '').toLowerCase();
    return Object.values($a044c29e4a6b3520$var$SOAP_TYPES).some((types)=>types.some((item)=>nt.includes(item.toLowerCase())));
}
function $a044c29e4a6b3520$export$8f3b6b15bd4ed240(iso, formatDateTime) {
    if (!iso) return '';
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return '';
    return formatDateTime(d, 'short');
}
const $a044c29e4a6b3520$export$9cbdfdc6daea18e2 = (enc)=>[
        'in_progress',
        'in-progress',
        'active'
    ].includes((enc?.status || '').toLowerCase());

});

parcelRegister("fOM5k", function(module, exports) {

$parcel$export(module.exports, "searchPubMed", () => $b840d32ddf66046b$export$afaf1496218aac9a);
const $b840d32ddf66046b$var$PUBMED_BASE = 'https://eutils.ncbi.nlm.nih.gov/entrez/eutils';
async function $b840d32ddf66046b$export$afaf1496218aac9a(query, conditions = [], maxResults = 3) {
    try {
        // Build a focused query: condition terms + question keywords
        const condTerms = conditions.slice(0, 3).join(' OR ');
        const combined = condTerms ? `(${condTerms}) AND (${query})` : query;
        const encoded = encodeURIComponent(combined);
        const searchRes = await fetch(`${$b840d32ddf66046b$var$PUBMED_BASE}/esearch.fcgi?db=pubmed&term=${encoded}&retmax=${maxResults}&retmode=json&sort=relevance`, {
            signal: AbortSignal.timeout(6000)
        });
        const searchData = await searchRes.json();
        const ids = searchData.esearchresult?.idlist || [];
        if (!ids.length) return [];
        const summaryRes = await fetch(`${$b840d32ddf66046b$var$PUBMED_BASE}/esummary.fcgi?db=pubmed&id=${ids.join(',')}&retmode=json`, {
            signal: AbortSignal.timeout(6000)
        });
        const summaryData = await summaryRes.json();
        return ids.map((id)=>{
            const doc = summaryData.result?.[id];
            if (!doc) return null;
            return {
                pmid: id,
                title: doc.title || '',
                journal: doc.fulljournalname || doc.source || '',
                year: doc.pubdate?.split(' ')[0] || '',
                url: `https://pubmed.ncbi.nlm.nih.gov/${id}/`
            };
        }).filter(Boolean);
    } catch  {
        return [];
    }
}

});

parcelRegister("fBZG6", function(module, exports) {

$parcel$export(module.exports, "useTranscription", () => $b5da27b488005ec5$export$e2373706461b5244);

var $acw62 = parcelRequire("acw62");

var $a83Oj = parcelRequire("a83Oj");

var $eVM84 = parcelRequire("eVM84");

var $k9wwH = parcelRequire("k9wwH");

var $aEedC = parcelRequire("aEedC");

var $lKjvZ = parcelRequire("lKjvZ");
// How long to wait for the final transcript after «توقف پایش بالینی» before
// giving up and closing the socket.
//
// This was 5s, which is shorter than the work it waits on. On stop the AI
// service re-transcribes the ENTIRE visit buffer in one provider call, so the
// wait grows with the length of the recording: measured against the real
// service, a 25s recording answered in 3.3s but a 2-minute one took 8.5s — and
// that was direct egress, without the cluster's LLM proxy in the path. Every
// visit longer than about a minute therefore lost its transcript, because
// closing the socket makes the BFF cancel the gRPC stream (`call.cancel()` in
// transcribeHandler.js) and the finished text is discarded server-side.
//
// A ceiling is still wanted so a genuinely dead stream cannot hang «در حال
// پردازش» forever; it just has to be longer than a long visit's final pass
// rather than shorter than a short one's. The UI shows `stopping` throughout.
const $b5da27b488005ec5$var$FINAL_TRANSCRIPT_TIMEOUT_MS = 120000;
const $b5da27b488005ec5$export$a82430915e8eaf8e = {
    IDLE: 'idle',
    CONNECTING: 'connecting',
    RECORDING: 'recording',
    STOPPING: 'stopping',
    PAUSED_BY_SYSTEM: 'paused-by-system',
    ERROR: 'error'
};
// The DOMException names getUserMedia rejects with, per the spec and the
// legacy Chrome/Firefox spellings still seen on older builds.
const $b5da27b488005ec5$var$MIC_ERROR_KINDS = {
    NotAllowedError: (0, $lKjvZ.RecErrorKind).MIC_DENIED,
    PermissionDeniedError: (0, $lKjvZ.RecErrorKind).MIC_DENIED,
    SecurityError: (0, $lKjvZ.RecErrorKind).MIC_DENIED,
    NotFoundError: (0, $lKjvZ.RecErrorKind).MIC_NOT_FOUND,
    DevicesNotFoundError: (0, $lKjvZ.RecErrorKind).MIC_NOT_FOUND,
    OverconstrainedError: (0, $lKjvZ.RecErrorKind).MIC_NOT_FOUND,
    NotReadableError: (0, $lKjvZ.RecErrorKind).MIC_BUSY,
    TrackStartError: (0, $lKjvZ.RecErrorKind).MIC_BUSY,
    AbortError: (0, $lKjvZ.RecErrorKind).MIC_BUSY
};
function $b5da27b488005ec5$export$7361891803c21a19(err) {
    return $b5da27b488005ec5$var$MIC_ERROR_KINDS[err?.name] || (0, $lKjvZ.RecErrorKind).UNSUPPORTED;
}
// A server-side `{ error }` frame carries the gRPC message verbatim
// ("8 RESOURCE_EXHAUSTED: اعتبار پارسه شما کافی نیست").
function $b5da27b488005ec5$var$serviceErrorKind(message) {
    return /RESOURCE_EXHAUSTED/.test(String(message || '')) ? (0, $lKjvZ.RecErrorKind).CREDIT : (0, $lKjvZ.RecErrorKind).SERVICE;
}
// The BFF's close codes (transcribeHandler.js): 4001 for a missing/invalid
// token, 1011 when the gRPC stream could not be opened or failed.
const $b5da27b488005ec5$var$WS_CLOSE_AUTH = 4001;
const $b5da27b488005ec5$var$WS_CLOSE_SERVICE = 1011;
function $b5da27b488005ec5$var$getSupportedMimeType() {
    const types = [
        'audio/webm;codecs=opus',
        'audio/webm',
        'audio/ogg;codecs=opus',
        'audio/mp4'
    ];
    return types.find((item)=>MediaRecorder.isTypeSupported(item)) || '';
}
function $b5da27b488005ec5$export$e2373706461b5244({ visitId: visitId, patientHistory: patientHistory = '', patientId: patientId = '', callAudio: callAudio = null, hintsEnabled: hintsEnabled = true, engine: // The server engine that decodes the recording — 'parsina' or 'assistant'
// (lib/speechEngine.js `ambientEngine`). The browser engine cannot hear a
// conference and feeds no hints, so it never reaches here. Null sends no
// parameter, which an older BFF and AI service read as the assistant engine.
engine = null, onSystemPause: onSystemPause = null }) {
    const [recState, setRecState] = (0, $acw62.useState)($b5da27b488005ec5$export$a82430915e8eaf8e.IDLE);
    const [elapsed, setElapsed] = (0, $acw62.useState)(0);
    const [hints, setHints] = (0, $acw62.useState)([]);
    const [liveTranscript, setLiveTranscript] = (0, $acw62.useState)('');
    const [report, setReport] = (0, $acw62.useState)(null);
    // `{ kind, detail }` while `recState` is `error`, else null. `kind` is one of
    // RecErrorKind; `detail` is the raw browser/server text, for support only.
    const [recError, setRecError] = (0, $acw62.useState)(null);
    const wsRef = (0, $acw62.useRef)(null);
    const bridgeRef = (0, $acw62.useRef)(null);
    const mediaRecorderRef = (0, $acw62.useRef)(null);
    const streamRef = (0, $acw62.useRef)(null);
    const transcriptRef = (0, $acw62.useRef)('');
    const timerRef = (0, $acw62.useRef)(null);
    const stopTimeoutRef = (0, $acw62.useRef)(null);
    const wakeLockRef = (0, $acw62.useRef)(null);
    const elapsedRef = (0, $acw62.useRef)(0);
    // The hook's own view of the state, readable from the DOM listeners below
    // without re-registering them on every tick.
    const recStateRef = (0, $acw62.useRef)($b5da27b488005ec5$export$a82430915e8eaf8e.IDLE);
    const onSystemPauseRef = (0, $acw62.useRef)(onSystemPause);
    onSystemPauseRef.current = onSystemPause;
    const applyState = (0, $acw62.useCallback)((next)=>{
        recStateRef.current = next;
        setRecState(next);
    }, []);
    /** The one way into `error`: the state and its reason always move together. */ const fail = (0, $acw62.useCallback)((kind, detail = '')=>{
        setRecError({
            kind: kind,
            detail: String(detail || '')
        });
        applyState($b5da27b488005ec5$export$a82430915e8eaf8e.ERROR);
    }, [
        applyState
    ]);
    const stopTimer = (0, $acw62.useCallback)(()=>{
        clearInterval(timerRef.current);
        timerRef.current = null;
    }, []);
    // ── Screen Wake Lock ───────────────────────────────────────────────────────
    // The commonest way a recording dies is the least dramatic: the phone is on
    // the desk between the doctor and the patient, and the auto-lock timer runs
    // out. A screen wake lock removes that case entirely — no permission prompt,
    // no UI, supported on iOS Safari ≥16.4 and Android Chrome, and a silent no-op
    // everywhere else. It makes the honest-stop path below the RARE one instead
    // of the normal one.
    const acquireWakeLock = (0, $acw62.useCallback)(async ()=>{
        try {
            if (!navigator.wakeLock || wakeLockRef.current) return;
            const sentinel = await navigator.wakeLock.request('screen');
            // The OS drops it on its own when the page is hidden; forget the dead
            // sentinel so a re-acquire on resume is not skipped as redundant.
            sentinel.addEventListener?.('release', ()=>{
                if (wakeLockRef.current === sentinel) wakeLockRef.current = null;
            });
            wakeLockRef.current = sentinel;
        } catch  {}
    }, []);
    const releaseWakeLock = (0, $acw62.useCallback)(()=>{
        const sentinel = wakeLockRef.current;
        wakeLockRef.current = null;
        try {
            sentinel?.release?.();
        } catch  {}
    }, []);
    /** Everything that produces audio, torn down. Never touches `recState`. */ const teardownCapture = (0, $acw62.useCallback)(()=>{
        if (mediaRecorderRef.current && mediaRecorderRef.current.state !== 'inactive') try {
            mediaRecorderRef.current.stop();
        } catch  {}
        try {
            bridgeRef.current?.stop();
        } catch  {}
        bridgeRef.current = null;
        streamRef.current?.getTracks().forEach((track)=>track.stop());
        streamRef.current = null;
    }, []);
    // Read inside the socket's `onmessage`, which closes over the value it was
    // created with — a ref so turning the switch off mid-visit takes effect on
    // the next frame instead of at the next recording.
    const hintsEnabledRef = (0, $acw62.useRef)(hintsEnabled);
    hintsEnabledRef.current = hintsEnabled;
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            clearInterval(timerRef.current);
            clearTimeout(stopTimeoutRef.current);
            wsRef.current?.close();
            try {
                bridgeRef.current?.stop();
            } catch  {}
            streamRef.current?.getTracks().forEach((track)=>track.stop());
            const sentinel = wakeLockRef.current;
            wakeLockRef.current = null;
            try {
                sentinel?.release?.();
            } catch  {}
        };
    }, []);
    const startRec = (0, $acw62.useCallback)(async ()=>{
        // One start at a time. A second press while the first is still setting up
        // (or already recording, or finishing) used to open a second socket and a
        // second recorder alongside the first.
        const prior = recStateRef.current;
        if (prior === $b5da27b488005ec5$export$a82430915e8eaf8e.CONNECTING || prior === $b5da27b488005ec5$export$a82430915e8eaf8e.RECORDING || prior === $b5da27b488005ec5$export$a82430915e8eaf8e.STOPPING) return;
        setHints([]);
        setLiveTranscript('');
        setElapsed(0);
        elapsedRef.current = 0;
        transcriptRef.current = '';
        // A retry starts from a clean slate; `error` is left only by a new attempt
        // or by `dismissError`.
        setRecError(null);
        applyState($b5da27b488005ec5$export$a82430915e8eaf8e.CONNECTING);
        // The previous socket (a paused recording's, left open on purpose so the
        // server can finish its final pass) is no longer this hook's to report on:
        // its close must not read as THIS attempt failing.
        wsRef.current = null;
        // Stopped, dismissed or unmounted while a step below was awaited.
        const abandoned = ()=>recStateRef.current !== $b5da27b488005ec5$export$a82430915e8eaf8e.CONNECTING;
        let token = (0, $a83Oj.getToken)();
        if (!token || (0, $a83Oj.isTokenExpired)(token)) {
            const ok = await (0, $a83Oj.refreshAccessToken)();
            if (abandoned()) return;
            if (!ok) {
                fail((0, $lKjvZ.RecErrorKind).SESSION);
                return;
            }
            token = (0, $a83Oj.getToken)();
        }
        // The conference is the source whenever there is one. Only reach for the
        // microphone when this is an in-person visit.
        const useCallAudio = Boolean(callAudio?.frame && callAudio?.origin);
        let stream = null;
        if (!useCallAudio) {
            // Checked up front rather than left to throw: on a non-HTTPS page
            // `navigator.mediaDevices` does not exist at all, and the TypeError that
            // produced said nothing a doctor could use.
            if (!navigator.mediaDevices?.getUserMedia || typeof MediaRecorder === 'undefined') {
                fail((0, $lKjvZ.RecErrorKind).UNSUPPORTED, window.isSecureContext === false ? 'insecure-context' : 'no-media-api');
                return;
            }
            try {
                stream = await navigator.mediaDevices.getUserMedia({
                    audio: true
                });
            } catch (err) {
                if (abandoned()) return;
                console.error('Mic access denied:', err);
                fail($b5da27b488005ec5$export$7361891803c21a19(err), `${err?.name || 'Error'}: ${err?.message || ''}`);
                return;
            }
            // The permission prompt can sit open for as long as the doctor ignores
            // it; a start given up on meanwhile must not leave the microphone live.
            if (abandoned()) {
                stream.getTracks().forEach((track)=>track.stop());
                return;
            }
            streamRef.current = stream;
        }
        // `language` is the doctor's panel language. It decides two things on the
        // far side: which language the live «نکات بالینی» hints come back in, and
        // which source language speech recognition is told to expect. Without it
        // both defaulted to Persian, so an Arabic-reading doctor got Persian hints
        // about a dictation that had been decoded by a Persian-locked recogniser.
        // A query parameter and not a header because a browser cannot set headers
        // on a WebSocket handshake — the token travels the same way for the same
        // reason.
        // `hints=off` only when the doctor turned them off — the parameter is
        // absent otherwise, so an older BFF that does not read it keeps doing
        // exactly what it did.
        const wsUrl = `${(0, $k9wwH.bffWsBase)()}/ws/transcribe?token=${encodeURIComponent(token)}&visit_id=${encodeURIComponent(visitId || '')}&patient_id=${encodeURIComponent(patientId || '')}&language=${encodeURIComponent((0, $eVM84.panelLanguage)())}${hintsEnabled ? '' : '&hints=off'}${engine ? `&engine=${encodeURIComponent(engine)}` : ''}`;
        const ws = new WebSocket(wsUrl);
        wsRef.current = ws;
        ws.onopen = async ()=>{
            // Given up on while the handshake was in flight: let this socket go.
            if (wsRef.current !== ws || abandoned()) {
                stream?.getTracks().forEach((track)=>track.stop());
                if (streamRef.current === stream) streamRef.current = null;
                try {
                    ws.close();
                } catch  {}
                return;
            }
            const send = (data)=>{
                if (data && data.size > 0 && ws.readyState === WebSocket.OPEN) ws.send(data);
            };
            if (useCallAudio) {
                try {
                    bridgeRef.current = await (0, $aEedC.startCallAudio)(callAudio.frame, callAudio.origin, send);
                } catch (err) {
                    // No fallback to the microphone, on purpose. A media server without
                    // the bridge script would otherwise hand the AI the doctor's half of
                    // the conversation and nothing would look wrong.
                    console.error('Call-audio bridge unavailable:', err?.message);
                    fail((0, $lKjvZ.RecErrorKind).CALL_AUDIO, err?.message);
                    try {
                        ws.close();
                    } catch  {}
                    return;
                }
                // The socket can be refused (4001) while the bridge was starting; the
                // close already reported why, and «recording» must not overwrite it.
                if (ws.readyState !== WebSocket.OPEN || abandoned()) {
                    try {
                        bridgeRef.current?.stop();
                    } catch  {}
                    bridgeRef.current = null;
                    if (ws.readyState === WebSocket.OPEN) try {
                        ws.close();
                    } catch  {}
                    return;
                }
            } else // A browser can have getUserMedia and still refuse to record it (an
            // older Safari, a codec it will not encode). This used to throw out of
            // `onopen` unhandled, leaving the socket open, the microphone live and
            // the button idle.
            try {
                const mimeType = $b5da27b488005ec5$var$getSupportedMimeType();
                const mr = new MediaRecorder(stream, mimeType ? {
                    mimeType: mimeType
                } : {});
                mediaRecorderRef.current = mr;
                mr.ondataavailable = (e)=>send(e.data);
                mr.start(250);
            } catch (err) {
                console.error('MediaRecorder unavailable:', err);
                fail((0, $lKjvZ.RecErrorKind).UNSUPPORTED, `${err?.name || 'Error'}: ${err?.message || ''}`);
                try {
                    ws.close();
                } catch  {}
                return;
            }
            applyState($b5da27b488005ec5$export$a82430915e8eaf8e.RECORDING);
            acquireWakeLock();
            stopTimer();
            timerRef.current = setInterval(()=>{
                elapsedRef.current += 1;
                setElapsed(elapsedRef.current);
            }, 1000);
        };
        ws.onmessage = async (e)=>{
            try {
                const msg = JSON.parse(e.data);
                // A superseded socket — a paused recording's, still finishing its final
                // pass when «ادامه» opened the next one — speaks for a segment this hook
                // no longer shows. Read as current, its `is_final` dropped the NEW
                // recording to `idle` while audio was still flowing (and wrote the old
                // segment over the new transcript); its `error` failed it. The server has
                // already saved what it says, so it is only let go.
                if (wsRef.current !== ws) {
                    if (msg.is_final) try {
                        ws.close();
                    } catch  {}
                    return;
                }
                if (msg.error) {
                    console.error('Transcription error:', msg.error);
                    stopTimer();
                    fail($b5da27b488005ec5$var$serviceErrorKind(msg.error), msg.error);
                    ws.close();
                    return;
                }
                if (msg.text && !msg.is_final) {
                    // `replace` means the service re-transcribed the whole recording and
                    // reworded something it had already sent, so `text` is the corrected
                    // transcript IN FULL rather than the newest words. Appending it would
                    // show the doctor the first minutes of the visit a second time, which
                    // is what used to happen on every re-wording.
                    transcriptRef.current = msg.replace ? msg.text + ' ' : transcriptRef.current + msg.text + ' ';
                    setLiveTranscript(transcriptRef.current.trim());
                }
                // The far side is asked not to produce these at all; this is the
                // backstop for a BFF or an AI service that has not been deployed yet,
                // so the switch is honoured by the surface the doctor is looking at
                // even while the two halves are out of step.
                if (msg.real_time_hint && hintsEnabledRef.current) setHints((prev)=>[
                        {
                            text: msg.real_time_hint,
                            hint_type: msg.hint_type || 'clinical_note',
                            soap_suggestions: msg.soap_suggestions || {}
                        },
                        ...prev
                    ]);
                if (msg.is_final) {
                    clearTimeout(stopTimeoutRef.current);
                    ws.close();
                    const finalText = msg.text || transcriptRef.current.trim();
                    if (finalText) {
                        transcriptRef.current = finalText;
                        setLiveTranscript(finalText);
                    }
                    // A hidden tab ends here too: `onHidden` sent `done` and said
                    // `paused-by-system` at once, and this is the final pass landing after
                    // it. It keeps the transcript and NOT the state — moving to `idle`
                    // took the interrupted strip down while the doctor was away, so they
                    // came back to a plain «پایش بالینی» with nothing saying the recording
                    // had stopped. The strip stays until they resume or dismiss it, and
                    // «ادامه» opens a new socket, so this one closing costs it nothing.
                    if (recStateRef.current !== $b5da27b488005ec5$export$a82430915e8eaf8e.PAUSED_BY_SYSTEM) applyState($b5da27b488005ec5$export$a82430915e8eaf8e.IDLE);
                    releaseWakeLock();
                }
            } catch  {}
        };
        ws.onerror = ()=>console.error('WebSocket connection failed');
        // ── The socket closing is never silent ────────────────────────────────────
        // This used to stop the tracks and return, leaving `recState` wherever it
        // was — which on an OS-killed socket meant `'recording'`, and the UI went
        // on claiming to record for as long as the doctor left it open.
        //
        // Three closes are possible and only one of them is a surprise:
        //   • after `is_final` — the handler above already moved to `idle`, or
        //     left a hidden tab's `paused-by-system` standing;
        //   • after the doctor pressed stop and the wait timed out — `stopping`
        //     resolves to `idle`, because the audio is on the server and the final
        //     pass will land there with or without this tab;
        //   • out of nowhere — the OS suspended the page. That is
        //     `paused-by-system`: an honest state the strip can offer to resume.
        //
        // …unless the close says otherwise. The BFF upgrades the socket BEFORE it
        // verifies the token, so a refused token opens, flips to «recording» and is
        // closed 4001 a moment later; read as an OS pause, «ادامه» then failed the
        // same way forever. And a socket that closes while still `connecting` is a
        // network that will not carry it (a proxy, a VPN, antivirus stripping the
        // upgrade), which used to leave the button idle with nothing said.
        ws.onclose = (event)=>{
            // A superseded socket — a paused recording's, closing after «ادامه»
            // started a new one — owns none of the capture, timer or state any more;
            // tearing those down would kill the recording that replaced it.
            if (wsRef.current !== ws) return;
            stopTimer();
            teardownCapture();
            releaseWakeLock();
            clearTimeout(stopTimeoutRef.current);
            const current = recStateRef.current;
            const code = event?.code;
            const inFlight = current === $b5da27b488005ec5$export$a82430915e8eaf8e.CONNECTING || current === $b5da27b488005ec5$export$a82430915e8eaf8e.RECORDING;
            if (inFlight && code === $b5da27b488005ec5$var$WS_CLOSE_AUTH) fail((0, $lKjvZ.RecErrorKind).AUTH, event?.reason);
            else if (inFlight && code === $b5da27b488005ec5$var$WS_CLOSE_SERVICE) fail((0, $lKjvZ.RecErrorKind).SERVICE, event?.reason);
            else if (current === $b5da27b488005ec5$export$a82430915e8eaf8e.CONNECTING) fail((0, $lKjvZ.RecErrorKind).CONNECTION, code ? `close ${code}` : '');
            else if (current === $b5da27b488005ec5$export$a82430915e8eaf8e.RECORDING) applyState($b5da27b488005ec5$export$a82430915e8eaf8e.PAUSED_BY_SYSTEM);
            else if (current === $b5da27b488005ec5$export$a82430915e8eaf8e.STOPPING) applyState($b5da27b488005ec5$export$a82430915e8eaf8e.IDLE);
        // `idle` and `error` are already terminal and stay put.
        };
    }, [
        visitId,
        patientId,
        callAudio,
        hintsEnabled,
        engine,
        applyState,
        fail,
        acquireWakeLock,
        releaseWakeLock,
        stopTimer,
        teardownCapture
    ]);
    /** The error dialog was closed: back to a plain «پایش بالینی» button. */ const dismissError = (0, $acw62.useCallback)(()=>{
        if (recStateRef.current !== $b5da27b488005ec5$export$a82430915e8eaf8e.ERROR) return;
        setRecError(null);
        applyState($b5da27b488005ec5$export$a82430915e8eaf8e.IDLE);
    }, [
        applyState
    ]);
    const stopRec = (0, $acw62.useCallback)(()=>{
        stopTimer();
        clearTimeout(stopTimeoutRef.current);
        teardownCapture();
        releaseWakeLock();
        if (wsRef.current?.readyState === WebSocket.OPEN) {
            try {
                wsRef.current.send(JSON.stringify({
                    done: true
                }));
            } catch  {}
            applyState($b5da27b488005ec5$export$a82430915e8eaf8e.STOPPING);
            stopTimeoutRef.current = setTimeout(()=>{
                wsRef.current?.close();
                applyState($b5da27b488005ec5$export$a82430915e8eaf8e.IDLE);
            }, $b5da27b488005ec5$var$FINAL_TRANSCRIPT_TIMEOUT_MS);
        } else applyState($b5da27b488005ec5$export$a82430915e8eaf8e.IDLE);
    }, [
        applyState,
        releaseWakeLock,
        stopTimer,
        teardownCapture
    ]);
    // ── The page leaving, and coming back ─────────────────────────────────────
    (0, $acw62.useEffect)(()=>{
        // The OS gives a short, unspecified window between «this page is hidden»
        // and «this page's JS is frozen». What fits in it is a small frame on an
        // already-open socket, so that is exactly what this does:
        //
        //   stop the recorder      no more audio can be produced anyway
        //   send { done: true }    tells the BFF the client FINISHED. That is the
        //                          difference between the AI service running its
        //                          final pass, saving the transcript and charging
        //                          the wallet — and `call.cancel()` throwing all
        //                          three away.
        //   say so immediately     `paused-by-system` is set here, NOT after
        //                          `is_final`. The final pass takes 3–9s and the
        //                          page will not be alive for it.
        //
        // What it must NOT do is close the socket. Closing is precisely what makes
        // the BFF cancel the stream; the socket is left to die on its own, by which
        // time the server has what it needs.
        const onHidden = ()=>{
            if (recStateRef.current !== $b5da27b488005ec5$export$a82430915e8eaf8e.RECORDING) return;
            teardownCapture();
            try {
                if (wsRef.current?.readyState === WebSocket.OPEN) wsRef.current.send(JSON.stringify({
                    done: true
                }));
            } catch  {}
            stopTimer();
            releaseWakeLock();
            applyState($b5da27b488005ec5$export$a82430915e8eaf8e.PAUSED_BY_SYSTEM);
            // Hand the screen everything it needs for the draft while JS still runs.
            try {
                onSystemPauseRef.current?.({
                    elapsed: elapsedRef.current,
                    transcript: transcriptRef.current.trim()
                });
            } catch  {}
        };
        const onVisible = ()=>{
            const current = recStateRef.current;
            // The OS releases a wake lock when the page hides. Take it back.
            if (current === $b5da27b488005ec5$export$a82430915e8eaf8e.RECORDING) {
                acquireWakeLock();
                return;
            }
            // A stop that was waiting for the final pass when the page went away is
            // not still waiting — the socket is gone and the 120s timer was frozen
            // with everything else. Resolve it now rather than showing «در حال
            // پردازش» for two more minutes over nothing.
            if (current === $b5da27b488005ec5$export$a82430915e8eaf8e.STOPPING && wsRef.current?.readyState !== WebSocket.OPEN) {
                clearTimeout(stopTimeoutRef.current);
                applyState($b5da27b488005ec5$export$a82430915e8eaf8e.IDLE);
            }
        // `paused-by-system` is deliberately left alone. Resuming needs a user
        // gesture for the microphone on iOS, and silently reopening a stream the
        // doctor did not ask for is how a private conversation gets recorded. The
        // screen renders `RecordingInterruptedStrip` and waits.
        };
        const onVisibility = ()=>{
            if (document.visibilityState === 'hidden') onHidden();
            else onVisible();
        };
        // `pagehide` as well as `visibilitychange`: iOS fires `pagehide` on a
        // back-forward-cache eviction where `visibilitychange` may not arrive.
        document.addEventListener('visibilitychange', onVisibility);
        window.addEventListener('pagehide', onHidden);
        return ()=>{
            document.removeEventListener('visibilitychange', onVisibility);
            window.removeEventListener('pagehide', onHidden);
        };
    }, [
        applyState,
        acquireWakeLock,
        releaseWakeLock,
        stopTimer,
        teardownCapture
    ]);
    /** «ادامه» on the interrupted strip — a NEW socket and a new gRPC stream. */ const resumeRec = (0, $acw62.useCallback)(()=>{
        if (recStateRef.current !== $b5da27b488005ec5$export$a82430915e8eaf8e.PAUSED_BY_SYSTEM) return;
        // The stored transcript is seeded server-side: a second stream for the same
        // encounter reads what the first one saved and appends to it, so this does
        // not overwrite the first segment.
        startRec();
    }, [
        startRec
    ]);
    /** «رد کردن» — the doctor does not want to carry on recording. */ const dismissPause = (0, $acw62.useCallback)(()=>{
        if (recStateRef.current !== $b5da27b488005ec5$export$a82430915e8eaf8e.PAUSED_BY_SYSTEM) return;
        applyState($b5da27b488005ec5$export$a82430915e8eaf8e.IDLE);
    }, [
        applyState
    ]);
    return {
        recState: recState,
        elapsed: elapsed,
        hints: hints,
        liveTranscript: liveTranscript,
        report: report,
        recError: recError,
        startRec: startRec,
        stopRec: stopRec,
        resumeRec: resumeRec,
        dismissPause: dismissPause,
        dismissError: dismissError
    };
}

});
parcelRegister("lKjvZ", function(module, exports) {

$parcel$export(module.exports, "RecErrorKind", () => $fd4d0818319d4b44$export$5b7e21fbf8c676ba);
// WHY «پایش بالینی» could not start (or died) — `recError.kind` from
// useTranscription, and the key under `visit.monitoringError.*` that explains it.
//
// Every one of these used to be a `console.error` and a `return` with the state
// left on `idle` — so the doctor pressed the button, it looked exactly as it did
// before, and the only record of why was a console nobody opens. Each kind is
// something the doctor can act on differently, which is the test for splitting
// it out: «allow the microphone» and «plug one in» are not the same instruction.
//
// Its own module rather than an export of the hook alone, because the visit
// screens' tests replace the hook module wholesale; the dialog must still be able
// to read the vocabulary when they do.
const $fd4d0818319d4b44$export$5b7e21fbf8c676ba = {
    MIC_DENIED: 'micDenied',
    MIC_NOT_FOUND: 'micNotFound',
    MIC_BUSY: 'micBusy',
    UNSUPPORTED: 'unsupported',
    SESSION: 'session',
    AUTH: 'auth',
    CONNECTION: 'connection',
    CREDIT: 'credit',
    SERVICE: 'service',
    CALL_AUDIO: 'callAudio'
};

});


parcelRegister("682u6", function(module, exports) {

$parcel$export(module.exports, "default", () => $685ede922aaeb8a3$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");

var $3HcoA = parcelRequire("3HcoA");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
// ─────────────────────────────────────────────────────────────────────────────
// «ضبط به‌دلیل خروج از برنامه متوقف شد» — the honest end of a recording the
// phone took away.
//
// A Safari tab or an installed PWA that leaves the foreground — screen lock, an
// app switch, an incoming call — has its timers frozen, its WebSocket closed by
// the OS and its microphone capture paused. There is no background-audio
// entitlement for web content, so the recording DOES stop. What was wrong was
// that nothing said so: `recState` stayed on `'recording'`, the header chip and
// the docked bar both went on claiming «در حال ضبط», and the visit was billed
// for the dead air by a browser timer that never stopped counting.
//
// This strip is what replaces the lie. Three rules it exists to keep:
//
//   NEVER AUTO-RESUME. iOS requires a user gesture to reopen the microphone,
//   so a silent restart would fail — and where it did not, a page that starts
//   recording a consultation on its own is a page nobody should trust.
//
//   THE OFFER IS SAFE TO ACCEPT. «ادامه» opens a NEW socket and a new gRPC
//   stream, and the AI service seeds that stream from what the first one stored
//   before appending. Without that seeding, resuming would silently delete the
//   first half of the visit — which is why the resume affordance could not ship
//   until the service change landed.
//
//   THE FIRST SEGMENT IS ALREADY SAFE. Whatever was transcribed before the
//   interruption was persisted per hint tick and again by the final pass the
//   BFF now lets complete, so declining costs nothing that was said.
//
// Rendered above the fold on both mobile visit surfaces, not in a dialog: it is
// information about something that already happened, and a modal would demand a
// decision at the moment the doctor is putting the phone down.
// ─────────────────────────────────────────────────────────────────────────────
const $685ede922aaeb8a3$var$RecordingInterruptedStrip = ({ onResume: onResume, onDismiss: onDismiss, busy: busy = false })=>{
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-recording-interrupted",
        role: "status",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0.5rem 0.875rem',
            background: (0, $jTCZr.CT).warnSoft,
            borderBottom: `1px solid ${(0, $jTCZr.CT).warn}`,
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3HcoA.default), {
        size: 14,
        "aria-hidden": true,
        style: {
            color: (0, $jTCZr.CT).warnInk,
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            minWidth: 0,
            fontSize: '0.6875rem',
            fontWeight: 600,
            color: (0, $jTCZr.CT).warnInk
        }
    }, t('visit.record.interrupted')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "default",
        size: "sm",
        className: "shrink-0 min-h-11",
        "data-testid": "visit-recording-resume",
        onClick: onResume,
        disabled: busy
    }, t('visit.record.resume')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        className: "shrink-0 min-h-11",
        "data-testid": "visit-recording-dismiss",
        onClick: onDismiss,
        style: {
            color: (0, $jTCZr.CT).warnInk
        }
    }, t('common.actions.dismiss')));
};
var $685ede922aaeb8a3$export$2e2bcd8739ae039 = $685ede922aaeb8a3$var$RecordingInterruptedStrip;

});
parcelRegister("3HcoA", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a6e4961dcb5cc3f$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $5a6e4961dcb5cc3f$export$a2387ed3b5d536eb = {
    name: "mic-off",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M12 19v3",
                key: "npa21l"
            }
        ],
        [
            "path",
            {
                d: "M15 9.34V5a3 3 0 0 0-5.68-1.33",
                key: "1gzdoj"
            }
        ],
        [
            "path",
            {
                d: "M16.95 16.95A7 7 0 0 1 5 12v-2",
                key: "cqa7eg"
            }
        ],
        [
            "path",
            {
                d: "M18.89 13.23A7 7 0 0 0 19 12v-2",
                key: "16hl24"
            }
        ],
        [
            "path",
            {
                d: "m2 2 20 20",
                key: "1ooewy"
            }
        ],
        [
            "path",
            {
                d: "M9 9v3a3 3 0 0 0 5.12 2.12",
                key: "r2i35w"
            }
        ]
    ]
};
$5a6e4961dcb5cc3f$export$a2387ed3b5d536eb.node;
const $5a6e4961dcb5cc3f$export$2e2bcd8739ae039 = (0, $9QBug.default)($5a6e4961dcb5cc3f$export$a2387ed3b5d536eb);

});


parcelRegister("3OnFU", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac5f41923e150410$export$2e2bcd8739ae039);
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $cjPik = parcelRequire("cjPik");
function $ac5f41923e150410$export$2e2bcd8739ae039({ open: open, onOpenChange: onOpenChange, title: title, description: description, message: message, confirmLabel: confirmLabel, cancelLabel: cancelLabel, destructive: destructive = false, loading: loading = false, onConfirm: onConfirm, ...rest }) {
    const { t: t } = (0, $LNQP4.default)();
    // Defaults live HERE, not in the parameter list. Written as
    // `title = t('common.actions.confirmAction')` this threw ReferenceError the
    // moment a caller omitted `title` — default parameters are evaluated in their
    // own scope, which cannot see the `const t` below.
    const titleText = title ?? t('common.actions.confirmAction');
    const confirmLabelText = confirmLabel ?? t('common.actions.confirm');
    const cancelLabelText = cancelLabel ?? t('common.actions.cancel');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cjPik.default), {
        ...rest,
        open: open,
        onOpenChange: onOpenChange,
        title: titleText,
        description: description ?? message,
        confirmLabel: confirmLabelText,
        cancelLabel: cancelLabelText,
        destructive: destructive,
        loading: loading,
        // The kit closes on the caller's say-so, not its own: a confirm whose
        // action can fail must stay open long enough to report it. This wrapper's
        // predecessor closed unconditionally, so a failed delete looked done.
        onConfirm: ()=>{
            onConfirm?.();
            onOpenChange?.(false);
        }
    });
}

});

parcelRegister("5qFC5", function(module, exports) {

$parcel$export(module.exports, "default", () => $4314c1a6ed955567$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $cjPik = parcelRequire("cjPik");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $lKjvZ = parcelRequire("lKjvZ");
// «پایش بالینی» could not start, or died — and WHY.
//
// Before this, every one of these failures was a console line: the doctor
// pressed the button, it looked exactly as it had a second earlier, and the
// report that reached support was «the button does nothing». Each kind names
// what happened in the doctor's terms and the one thing they can do about it;
// the raw browser/server text sits underneath for whoever they forward it to.
//
// The confirm is «تلاش دوباره» for every kind, including the ones a retry will
// not fix on its own: the fix text asks the doctor to change something (a
// permission, a cable, a VPN) and then retry, and that retry must be one press
// away rather than a trip back to the panel.
//
// Not `destructive`: nothing is being removed; red is spent on delete.
const $4314c1a6ed955567$var$KNOWN = new Set(Object.values((0, $lKjvZ.RecErrorKind)));
function $4314c1a6ed955567$export$2e2bcd8739ae039({ error: error, onRetry: onRetry, onClose: onClose }) {
    const { t: t } = (0, $LNQP4.default)();
    const kind = error && $4314c1a6ed955567$var$KNOWN.has(error.kind) ? error.kind : (0, $lKjvZ.RecErrorKind).SERVICE;
    const base = `visit.monitoringError.${kind}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cjPik.default), {
        open: Boolean(error),
        onOpenChange: (open)=>{
            if (!open) onClose?.();
        },
        "data-testid": "visit-monitoring-error",
        confirmTestId: "visit-monitoring-error-retry",
        cancelTestId: "visit-monitoring-error-close",
        title: t(`${base}.title`),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "space-y-3 text-sm leading-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
            className: "text-muted-foreground",
            "data-testid": "visit-monitoring-error-body"
        }, t(`${base}.body`)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
            className: "font-medium text-foreground",
            "data-testid": "visit-monitoring-error-fix"
        }, t(`${base}.fix`)), error?.detail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
            className: "text-xs text-muted-foreground"
        }, t('visit.monitoringError.detail'), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("bdi", {
            dir: "ltr",
            className: "font-mono",
            "data-testid": "visit-monitoring-error-detail"
        }, error.detail)) : null),
        confirmLabel: t('visit.monitoringError.retry'),
        cancelLabel: t('visit.monitoringError.close'),
        // Retry replaces the error rather than closing on top of it: the hook
        // clears `recError` as the new attempt starts, which closes the dialog,
        // and a failed retry reopens it with the new reason.
        onConfirm: onRetry
    });
}

});

parcelRegister("jCgjY", function(module, exports) {

$parcel$export(module.exports, "default", () => $2366d82badfc6b73$export$2e2bcd8739ae039);
// The review step of the «نسخه»'s three AI helpers (docs/VISIT_RX_AI_ASSIST.md):
// dictation, «پایش بالینی», شرح حال. One list for all three and both surfaces —
// the visit's proposal card (PM-0038), inline in the نسخه tab, so a proposal for
// the نسخه reads and is confirmed exactly like one for the note or the دستورات.
//
// Nothing here writes. Each row is a proposal the doctor ticks, resolves (an
// ambiguous drug is chosen from the formulary candidates the server scored) or
// leaves; «تأیید» hands the ticked rows to the screen, which adds them as it adds
// a drug picked by hand.
//
// A row says WHY it is not ticked: already on the نسخه, a recorded allergy, a drug
// the formulary does not carry, several formulary drugs that fit. The last two are
// the ones the model cannot settle, and the list never settles them for it.

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $lfHhF = parcelRequire("lfHhF");

var $g6gAc = parcelRequire("g6gAc");

var $eQiuG = parcelRequire("eQiuG");

var $bwSot = parcelRequire("bwSot");

var $dXWAH = parcelRequire("dXWAH");
const $2366d82badfc6b73$var$SIZES = {
    web: {
        title: '0.75rem',
        body: '0.78125rem',
        meta: '0.65625rem',
        pad: '8px 10px',
        gap: 6,
        radius: 8,
        checkbox: undefined,
        action: '0.71875rem'
    },
    mobile: {
        title: '0.9375rem',
        body: '0.875rem',
        meta: '0.75rem',
        pad: '0.625rem 0.75rem',
        gap: 8,
        radius: 10,
        checkbox: '1.125rem',
        action: '0.875rem'
    }
};
const $2366d82badfc6b73$var$TITLE_KEY = {
    VOICE: 'visit.rxAssist.voiceTitle',
    MONITORING: 'visit.rxAssist.monitoringTitle',
    HISTORY: 'visit.rxAssist.historyTitle'
};
const $2366d82badfc6b73$var$LOADING_KEY = {
    VOICE: 'visit.rxAssist.loading.voice',
    MONITORING: 'visit.rxAssist.loading.monitoring',
    HISTORY: 'visit.rxAssist.loading.history'
};
// Why a finished run has no rows — each status says what to do next.
const $2366d82badfc6b73$var$EMPTY_KEY = {
    none_found: {
        VOICE: 'visit.rxAssist.empty.voice',
        MONITORING: 'visit.rxAssist.empty.monitoring',
        HISTORY: 'visit.rxAssist.empty.history'
    },
    no_input: 'visit.rxAssist.empty.noInput',
    no_transcript: 'visit.rxAssist.empty.noTranscript',
    no_history: 'visit.rxAssist.empty.noHistory'
};
const $2366d82badfc6b73$var$emptyKey = (status, source)=>{
    const entry = $2366d82badfc6b73$var$EMPTY_KEY[status] || $2366d82badfc6b73$var$EMPTY_KEY.none_found;
    return typeof entry === 'string' ? entry : entry[source];
};
const $2366d82badfc6b73$var$same = (a, b)=>String(a || '').replace(/[\s‌]+/g, '').toLowerCase() === String(b || '').replace(/[\s‌]+/g, '').toLowerCase();
function $2366d82badfc6b73$var$Badge({ tone: tone, children: children, testid: testid }) {
    const tones = {
        danger: [
            (0, $jTCZr.CT).dangerSoft,
            (0, $jTCZr.CT).dangerInk
        ],
        warn: [
            (0, $jTCZr.CT).warnSoft,
            (0, $jTCZr.CT).warnInk
        ],
        good: [
            (0, $jTCZr.CT).goodSoft,
            (0, $jTCZr.CT).goodInk
        ],
        mute: [
            (0, $jTCZr.CT).surface2,
            (0, $jTCZr.CT).ink2
        ],
        accent: [
            (0, $jTCZr.CT).accentSoft,
            (0, $jTCZr.CT).accentInk
        ]
    };
    const [bg, fg] = tones[tone] || tones.mute;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": testid,
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 4,
            padding: '1px 7px',
            borderRadius: 999,
            fontSize: '0.92em',
            fontWeight: 600,
            background: bg,
            color: fg,
            whiteSpace: 'nowrap'
        }
    }, children);
}
// A formulary product's name(s) by the one rule every drug surface follows
// (lib/drugNames drugNameLines): the Latin leads, and the registry's Persian
// product string follows it only for a reader who reads Persian. It used to be
// «Persian — LATIN» for everyone, so an Arabic doctor chose between strings like
// «آموکسی‌سیلین 500 میلی‌گرم کپسول خوراکی — AMOXICILLIN 500 mg CAPSULE ORAL».
const $2366d82badfc6b73$var$productLabel = (drug, readsPersianData)=>{
    const { primary: primary, secondary: secondary } = (0, $g6gAc.drugNameLines)(drug, readsPersianData);
    return secondary ? `${primary} \u{2014} ${secondary}` : primary;
};
// The line under a row's name for a reader who does not read Persian. A
// proposal carries the model's raw values — the closed lists' Persian, often with
// ASCII digits — and only the frequency went through a label, which then missed
// «هر 8 ساعت» for its digit: an Arabic doctor read «1 کپسول · هر 8 ساعت · خوراکی ·
// 10 روز». It now reads in the words the نسخه's own line uses once it is added:
// the dose by its units, the frequency by its option, route and duration by their
// keys. Anything outside those lists is shown as the model wrote it.
const $2366d82badfc6b73$var$readerSig = (p, t)=>[
        (0, $eQiuG.doseLabel)(p?.dosage, t) || String(p?.dosage || p?.strength || '').trim(),
        p?.frequency && (0, $lfHhF.drugFrequencyLabel)((0, $eQiuG.toFrequencyOption)(p.frequency) || p.frequency, t),
        p?.route && (0, $eQiuG.routeLabel)(p.route, t),
        p?.duration && (0, $eQiuG.durationLabel)(p.duration, t)
    ].map((x)=>String(x || '').trim()).filter(Boolean).join(" \xb7 ");
function $2366d82badfc6b73$var$ProposalRow({ row: row, ctx: ctx, S: S, source: source, onToggle: onToggle, onChoose: onChoose, onSearch: onSearch, testid: testid }) {
    const { t: t, readsPersianData: readsPersianData } = (0, $LNQP4.default)();
    const p = row.proposal;
    const state = (0, $bwSot.rowState)(row, ctx);
    const drug = (0, $bwSot.rowDrug)(row);
    const allergy = state === (0, $bwSot.ROW_STATES).ALLERGY ? (0, $bwSot.rowAllergy)(row, ctx.allergies) : null;
    const addable = state === (0, $bwSot.ROW_STATES).READY || state === (0, $bwSot.ROW_STATES).ALLERGY;
    const names = drug ? (0, $g6gAc.drugNameLines)(drug, readsPersianData) : null;
    const name = names?.primary || p.drugText || p.genericName;
    // A Persian reader reads the values as written.
    const sig = readsPersianData ? (0, $bwSot.proposalSig)(p, (f)=>(0, $lfHhF.drugFrequencyLabel)(f, t)) : $2366d82badfc6b73$var$readerSig(p, t);
    const candidates = (p.candidates || []).filter((c)=>c.drug?.id);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${testid}-row-${row.key}`,
        "data-state": state,
        "data-checked": row.checked ? 'true' : 'false',
        style: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: S.gap,
            padding: S.pad,
            borderRadius: S.radius,
            border: `1px solid ${allergy ? (0, $jTCZr.CT).danger : (0, $jTCZr.CT).border}`,
            background: (0, $jTCZr.CT).surface,
            opacity: state === (0, $bwSot.ROW_STATES).IN_RX ? 0.7 : 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        type: "checkbox",
        "aria-label": name,
        checked: row.checked,
        disabled: !addable,
        onChange: ()=>onToggle(row.key),
        "data-testid": `${testid}-check-${row.key}`,
        style: {
            marginTop: 3,
            accentColor: (0, $jTCZr.CT).accent,
            width: S.checkbox,
            height: S.checkbox,
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: 3
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            flexWrap: 'wrap'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("bdi", {
        style: {
            fontSize: S.body,
            fontWeight: 700,
            color: (0, $jTCZr.CT).ink
        }
    }, name), names?.secondary && !$2366d82badfc6b73$var$same(names.secondary, name) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            fontSize: S.meta,
            color: (0, $jTCZr.CT).mute
        }
    }, names.secondary), p.kind === 'prescribed' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2366d82badfc6b73$var$Badge, {
        tone: "accent"
    }, t('visit.rxAssist.kind.prescribed')), p.kind === 'mentioned' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2366d82badfc6b73$var$Badge, {
        tone: "mute"
    }, t('visit.rxAssist.kind.mentioned'))), sig && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: S.meta,
            color: (0, $jTCZr.CT).ink2
        }
    }, sig), p.instructions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: S.meta,
            color: (0, $jTCZr.CT).ink2
        }
    }, p.instructions), drug && source !== 'HISTORY' && p.drugText && !$2366d82badfc6b73$var$same(p.drugText, drug.name) && !$2366d82badfc6b73$var$same(p.drugText, drug.genericName) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: S.meta,
            color: (0, $jTCZr.CT).mute
        }
    }, t('visit.rxAssist.heard', {
        text: p.drugText
    })), source === 'HISTORY' && p.rationale && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: S.meta,
            color: (0, $jTCZr.CT).ink2,
            lineHeight: 1.6
        }
    }, p.rationale), source === 'MONITORING' && p.evidence && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: S.meta,
            color: (0, $jTCZr.CT).mute,
            lineHeight: 1.6
        }
    }, "\xab", p.evidence, "\xbb"), state === (0, $bwSot.ROW_STATES).IN_RX && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2366d82badfc6b73$var$Badge, {
        tone: "good"
    }, t('visit.rxAssist.state.inRx'))), allergy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2366d82badfc6b73$var$Badge, {
        tone: "danger",
        testid: `${testid}-allergy-${row.key}`
    }, t('visit.rxAssist.state.allergy', {
        allergen: allergy
    }))), (state === (0, $bwSot.ROW_STATES).CHOOSE || drug && candidates.length > 1) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            flexWrap: 'wrap',
            fontSize: S.meta,
            color: (0, $jTCZr.CT).warnInk
        }
    }, state === (0, $bwSot.ROW_STATES).CHOOSE && t('visit.rxAssist.state.choose'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("select", {
        value: row.drugId,
        onChange: (e)=>onChoose(row.key, e.target.value),
        "data-testid": `${testid}-choose-${row.key}`,
        style: {
            fontSize: S.meta,
            fontFamily: 'inherit',
            padding: '3px 6px',
            borderRadius: 6,
            border: `1px solid ${state === (0, $bwSot.ROW_STATES).CHOOSE ? (0, $jTCZr.CT).warn : (0, $jTCZr.CT).border}`,
            background: (0, $jTCZr.CT).surface,
            color: (0, $jTCZr.CT).ink,
            maxWidth: '100%'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
        value: ""
    }, t('visit.rxAssist.chooseDrug')), candidates.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
            key: c.drug.id,
            value: c.drug.id
        }, $2366d82badfc6b73$var$productLabel(c.drug, readsPersianData))))), (state === (0, $bwSot.ROW_STATES).UNMATCHED || state === (0, $bwSot.ROW_STATES).UNAVAILABLE) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            flexWrap: 'wrap'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2366d82badfc6b73$var$Badge, {
        tone: "mute"
    }, t(state === (0, $bwSot.ROW_STATES).UNMATCHED ? 'visit.rxAssist.state.unmatched' : 'visit.rxAssist.state.unavailable')), onSearch && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: ()=>onSearch(p.genericName || p.drugText),
        "data-testid": `${testid}-search-${row.key}`,
        style: {
            background: 'none',
            border: 'none',
            padding: 0,
            cursor: 'pointer',
            fontFamily: 'inherit',
            fontSize: S.meta,
            fontWeight: 600,
            color: (0, $jTCZr.CT).accentInk,
            textDecoration: 'underline'
        }
    }, t('visit.rxAssist.search')))));
}
// A proposal the نسخه already holds is left out of the list (K1, 2026-10-06):
// every «تکمیل» re-reads the whole transcript and hears again each drug the
// doctor already added, and a list of drugs nobody can add hides the one that
// is new. One line says how many were left out, so none looks lost.
const $2366d82badfc6b73$var$shownRows = (rows, ctx)=>(rows || []).filter((r)=>!r.known && (0, $bwSot.rowState)(r, ctx) !== (0, $bwSot.ROW_STATES).IN_RX);
function $2366d82badfc6b73$var$Body({ review: review, ctx: ctx, S: S, onToggle: onToggle, onChoose: onChoose, onSearch: onSearch, onRetry: onRetry, testid: testid }) {
    const { t: t, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const { phase: phase, source: source, status: status, error: error } = review;
    const rows = $2366d82badfc6b73$var$shownRows(review.rows, ctx);
    const onRx = (review.rows || []).length - rows.length;
    const note = {
        fontSize: S.meta,
        color: (0, $jTCZr.CT).mute,
        lineHeight: 1.7
    };
    if (phase === 'loading') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${testid}-loading`,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '6px 2px',
            fontSize: S.meta,
            color: (0, $jTCZr.CT).ink2
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: 11,
            height: 11,
            border: `1.5px solid ${(0, $jTCZr.CT).border}`,
            borderTopColor: (0, $jTCZr.CT).accent,
            borderRadius: '50%',
            animation: 'spin .7s linear infinite',
            flexShrink: 0
        }
    }), t($2366d82badfc6b73$var$LOADING_KEY[source]));
    if (phase === 'error') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${testid}-error`,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            flexWrap: 'wrap',
            fontSize: S.meta,
            color: (0, $jTCZr.CT).dangerInk
        }
    }, t(error === 'credit' ? 'visit.rxAssist.error.credit' : 'visit.rxAssist.error.failed'), error !== 'credit' && onRetry && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onRetry,
        "data-testid": `${testid}-retry`,
        style: {
            background: 'none',
            border: 'none',
            padding: 0,
            cursor: 'pointer',
            fontFamily: 'inherit',
            fontSize: S.meta,
            fontWeight: 600,
            color: (0, $jTCZr.CT).accentInk,
            textDecoration: 'underline'
        }
    }, t('common.actions.retry')));
    if (!rows.length) return onRx ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${testid}-empty`,
        "data-status": "inRx",
        style: note
    }, t('visit.rxAssist.empty.allInRx')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${testid}-empty`,
        "data-status": status,
        style: note
    }, t($2366d82badfc6b73$var$emptyKey(status, source)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${testid}-list`,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: S.gap
        }
    }, rows.map((row)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2366d82badfc6b73$var$ProposalRow, {
            key: row.key,
            row: row,
            ctx: ctx,
            S: S,
            source: source,
            onToggle: onToggle,
            onChoose: onChoose,
            onSearch: onSearch,
            testid: testid
        })), onRx > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${testid}-in-rx`,
        "data-count": onRx,
        style: note
    }, t('visit.rxAssist.inRxHidden', {
        count: onRx,
        n: formatNumber ? formatNumber(onRx) : String(onRx)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: note
    }, t('visit.rxAssist.reviewHint')));
}
function $2366d82badfc6b73$var$Commit({ review: review, ctx: ctx, S: S, variant: variant, onSetAll: onSetAll, onApply: onApply, onClose: onClose, testid: testid }) {
    const { t: t, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const rows = $2366d82badfc6b73$var$shownRows(review.rows, ctx);
    const picked = rows.filter((r)=>r.checked).length;
    const fmt = (n)=>formatNumber ? formatNumber(n) : String(n);
    const link = {
        background: 'none',
        border: 'none',
        padding: 0,
        cursor: 'pointer',
        fontFamily: 'inherit',
        fontSize: S.meta,
        fontWeight: 600,
        color: (0, $jTCZr.CT).accentInk
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dXWAH.ProposalActions), {
        variant: variant,
        testid: testid,
        onAccept: onApply,
        acceptDisabled: !picked,
        acceptLabel: t('visit.complete.acceptN', {
            n: fmt(picked)
        }),
        onDismiss: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: S.meta,
            color: (0, $jTCZr.CT).ink2
        },
        "data-testid": `${testid}-count`
    }, t('visit.rxAssist.selectedOf', {
        n: fmt(picked),
        total: fmt(rows.length)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        style: link,
        onClick: ()=>onSetAll(true),
        "data-testid": `${testid}-all`
    }, t('visit.rxAssist.selectAll')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        style: link,
        onClick: ()=>onSetAll(false),
        "data-testid": `${testid}-none`
    }, t('visit.rxAssist.selectNone')));
}
function $2366d82badfc6b73$export$2e2bcd8739ae039({ review: review, rxItems: rxItems, allergies: allergies, variant: variant = 'web', onToggle: onToggle, onChoose: onChoose, onSetAll: onSetAll, onApply: onApply, onClose: onClose, onRetry: onRetry, onSearch: onSearch, testid: testid = 'visit-rx-assist' }) {
    const { t: t } = (0, $LNQP4.default)();
    if (!review?.open) return null;
    const S = $2366d82badfc6b73$var$SIZES[variant] || $2366d82badfc6b73$var$SIZES.web;
    const ctx = {
        rxItems: rxItems || [],
        allergies: allergies || []
    };
    const monitoring = review.source === 'MONITORING';
    const showCommit = review.phase === 'ready' && $2366d82badfc6b73$var$shownRows(review.rows, ctx).length > 0;
    const body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2366d82badfc6b73$var$Body, {
        review: review,
        ctx: ctx,
        S: S,
        onToggle: onToggle,
        onChoose: onChoose,
        onSearch: onSearch,
        onRetry: onRetry,
        testid: testid
    });
    const commit = showCommit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2366d82badfc6b73$var$Commit, {
        review: review,
        ctx: ctx,
        S: S,
        variant: variant,
        onSetAll: onSetAll,
        onApply: onApply,
        onClose: onClose,
        testid: testid
    }) : null;
    // A reading of «پایش بالینی» is the section's «تکمیل» proposal; the other
    // sources keep their own title in the same card.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dXWAH.ProposalCard), {
        variant: variant,
        testid: testid,
        "data-source": review.source,
        "data-phase": review.phase,
        title: monitoring ? t('visit.tabs.rx') : undefined,
        heading: monitoring ? undefined : t($2366d82badfc6b73$var$TITLE_KEY[review.source]),
        onClose: onClose,
        footer: commit
    }, body);
}

});
parcelRegister("bwSot", function(module, exports) {

$parcel$export(module.exports, "PROPOSE_MEDICATIONS", () => $864ce04f6c433567$export$89249b52d57a6841);
$parcel$export(module.exports, "withoutAutoConfirmFields", () => $864ce04f6c433567$export$5c78d3e8e094880e);
$parcel$export(module.exports, "PROPOSAL_SOURCES", () => $864ce04f6c433567$export$594476081fc43e05);
$parcel$export(module.exports, "PROPOSAL_PRICING", () => $864ce04f6c433567$export$8f37739954cc7f1c);
$parcel$export(module.exports, "buildProposalInput", () => $864ce04f6c433567$export$afd37530d39fcdf4);
$parcel$export(module.exports, "sourceReady", () => $864ce04f6c433567$export$9ff2a43ac3d586f);
$parcel$export(module.exports, "ROW_STATES", () => $864ce04f6c433567$export$d17c451ccb229dcb);
$parcel$export(module.exports, "rowDrug", () => $864ce04f6c433567$export$dfbc9b6ad0d6c589);
$parcel$export(module.exports, "rowState", () => $864ce04f6c433567$export$38b57db04f34575e);
$parcel$export(module.exports, "rowAllergy", () => $864ce04f6c433567$export$63b3df14443601d9);
$parcel$export(module.exports, "buildReviewRows", () => $864ce04f6c433567$export$b06f6f1f87b469fc);
$parcel$export(module.exports, "markInRxRows", () => $864ce04f6c433567$export$2eabf1eeeee79bc3);
$parcel$export(module.exports, "chooseCandidate", () => $864ce04f6c433567$export$c3f458c6c3133171);
$parcel$export(module.exports, "toggleRow", () => $864ce04f6c433567$export$93f90af192fa87b);
$parcel$export(module.exports, "setAllRows", () => $864ce04f6c433567$export$b1b58b633f75984f);
$parcel$export(module.exports, "rowsToApply", () => $864ce04f6c433567$export$231c4e06e639a88f);
$parcel$export(module.exports, "proposalFormRequests", () => $864ce04f6c433567$export$cb741851902ee7c4);
$parcel$export(module.exports, "autoConfirmableRows", () => $864ce04f6c433567$export$1ca0954329d5523a);
$parcel$export(module.exports, "autoRxSig", () => $864ce04f6c433567$export$5848f5e6dfb5b7e7);
$parcel$export(module.exports, "autoRxSummary", () => $864ce04f6c433567$export$20e812f59b1c550);
$parcel$export(module.exports, "proposalSig", () => $864ce04f6c433567$export$38da4481450f6e5c);
// The «نسخه»'s three AI helpers — docs/VISIT_RX_AI_ASSIST.md.
//
//   VOICE       the doctor dictates «آموکسی‌سیلین ۵۰۰ هر هشت ساعت یک هفته»
//   MONITORING  the drugs in the visit's «پایش بالینی» transcript
//   HISTORY     drugs the current شرح حال / assessment / diagnoses call for
//
// All three come back as PROPOSALS. Nothing reaches the نسخه until the doctor has
// looked at the list, resolved every ambiguous drug and pressed «افزودن به نسخه» —
// except, for a doctor who switched «تایید خودکار» on, the one product the AI service's
// score marked (PM-0586, «تایید خودکار» below; DESIGN_CONCEPT §13.3);
// the lines are then added exactly as a drug ticked in the picker is (makeRxItem),
// so autosave, the «P» block and the closing write treat them the same.
//
// The formulary row is decided on the server, in code, with a visible score — the
// model only reads what was said. A proposal the formulary does not carry is shown
// as such and can only be searched for by hand: it is never turned into a synthetic
// drug that looks like a formulary one.
//
// This module is pure (no React): the rules for which rows start ticked live here
// so both surfaces and the tests read one copy.

var $cvBw3 = parcelRequire("cvBw3");

var $8qEaX = parcelRequire("8qEaX");

var $eQiuG = parcelRequire("eQiuG");

var $2aPS0 = parcelRequire("2aPS0");
const $864ce04f6c433567$export$3458412b6cbca5fa = `
        reason autoScore autoConfirm
        autoDrug { id name genericName category commonDosages commonFrequencies taminListed }`;
const $864ce04f6c433567$export$89249b52d57a6841 = `
  mutation ProposeMedications($input: MedicationProposalInput!) {
    proposeMedications(input: $input) {
      status charged
      proposals {
        kind drugText genericName strength form dosage frequency route duration quantity
        instructions rationale evidence confidence matchStatus selectedDrugId
        candidates {
          score strengthMatch
          drug { id name genericName category commonDosages commonFrequencies taminListed }
        }${$864ce04f6c433567$export$3458412b6cbca5fa}
      }
    }
  }
`;
const $864ce04f6c433567$export$5c78d3e8e094880e = (q)=>q.replace($864ce04f6c433567$export$3458412b6cbca5fa, '');
const $864ce04f6c433567$export$594476081fc43e05 = Object.freeze({
    VOICE: 'VOICE',
    MONITORING: 'MONITORING',
    HISTORY: 'HISTORY'
});
const $864ce04f6c433567$export$8f37739954cc7f1c = Object.freeze({
    VOICE: {
        action: 'RX_VOICE',
        ledgerId: 'rxVoice'
    },
    MONITORING: {
        action: 'RX_MONITORING',
        ledgerId: 'rxMonitoring'
    },
    HISTORY: {
        action: 'RX_HISTORY',
        ledgerId: 'rxHistory'
    }
});
const $864ce04f6c433567$export$154a8f47e4320513 = 12000;
const $864ce04f6c433567$var$text = (v)=>(v == null ? '' : String(v)).trim();
function $864ce04f6c433567$export$afd37530d39fcdf4(source, ctx = {}) {
    const patient = ctx.patient || {};
    const allergies = (patient.clinicalAllergies || []).map((a)=>a?.allergen).filter(Boolean);
    const input = {
        source: source,
        appointmentId: ctx.appointmentId || '',
        patientId: patient.id || null,
        currentMedications: (ctx.rxItems || []).map((r)=>r?.drug?.name).filter(Boolean),
        patientAllergies: allergies,
        // null = unknown — never 0, which the model reads as a newborn.
        age: patient.age ?? null,
        gender: ''
    };
    if (source === $864ce04f6c433567$export$594476081fc43e05.VOICE) input.utterance = $864ce04f6c433567$var$text(ctx.utterance);
    if (source === $864ce04f6c433567$export$594476081fc43e05.MONITORING) input.utterance = $864ce04f6c433567$var$text(ctx.transcript).slice(-$864ce04f6c433567$export$154a8f47e4320513);
    if (source === $864ce04f6c433567$export$594476081fc43e05.HISTORY) {
        const soap = ctx.soap || {};
        Object.assign(input, {
            soapS: $864ce04f6c433567$var$text(soap.s),
            soapO: $864ce04f6c433567$var$text(soap.o),
            soapA: $864ce04f6c433567$var$text(soap.a),
            soapP: $864ce04f6c433567$var$text(soap.p),
            diagnoses: (ctx.diagnoses || []).map($864ce04f6c433567$var$text).filter(Boolean)
        });
    }
    return input;
}
function $864ce04f6c433567$export$9ff2a43ac3d586f(source, ctx = {}) {
    if (source === $864ce04f6c433567$export$594476081fc43e05.HISTORY) {
        const soap = ctx.soap || {};
        return !!($864ce04f6c433567$var$text(soap.s) || $864ce04f6c433567$var$text(soap.a) || (ctx.diagnoses || []).some((d)=>$864ce04f6c433567$var$text(d)));
    }
    if (source === $864ce04f6c433567$export$594476081fc43e05.MONITORING) return !!(ctx.hasTranscript || $864ce04f6c433567$var$text(ctx.transcript));
    return true;
}
const $864ce04f6c433567$export$d17c451ccb229dcb = Object.freeze({
    READY: 'ready',
    ALLERGY: 'allergy',
    IN_RX: 'inRx',
    CHOOSE: 'choose',
    UNMATCHED: 'unmatched',
    UNAVAILABLE: 'unavailable'
});
// The products a proposal could be: its candidates, and the one «تایید خودکار»'s score
// picked (PM-0586), which need not be among the few candidates shown — so a drug the
// نسخه holds as that product is «در نسخه», and an undone row stands for it again.
const $864ce04f6c433567$var$candidateDrugs = (p)=>{
    const drugs = (p?.candidates || []).map((c)=>c.drug).filter((d)=>d?.id);
    return p?.autoDrug?.id && !drugs.some((d)=>d.id === p.autoDrug.id) ? [
        ...drugs,
        p.autoDrug
    ] : drugs;
};
function $864ce04f6c433567$export$dfbc9b6ad0d6c589(row) {
    if (!row?.drugId) return null;
    return $864ce04f6c433567$var$candidateDrugs(row.proposal).find((d)=>d.id === row.drugId) || null;
}
function $864ce04f6c433567$export$cb853f6c272ac55f(row, rxItems = []) {
    if (!rxItems?.length || !row?.proposal) return false;
    const drugs = [
        $864ce04f6c433567$export$dfbc9b6ad0d6c589(row),
        ...$864ce04f6c433567$var$candidateDrugs(row.proposal)
    ].filter(Boolean);
    if (drugs.some((d)=>(0, $8qEaX.isAlreadyPrescribed)(rxItems, d))) return true;
    const lines = rxItems.map((r)=>r?.drug).filter(Boolean);
    if (drugs.length) {
        const held = new Set(lines.map((0, $2aPS0.drugFormKey)).filter(Boolean));
        return drugs.some((d)=>{
            const k = (0, $2aPS0.drugFormKey)(d);
            return !!k && held.has(k);
        });
    }
    const named = (0, $2aPS0.ingredientNameKey)(row.proposal.genericName);
    return !!named && lines.some((d)=>{
        const p = (0, $2aPS0.parseProduct)(d);
        return p.structured && (0, $2aPS0.ingredientNameKey)(p.ingredient) === named;
    });
}
function $864ce04f6c433567$export$38b57db04f34575e(row, { rxItems: rxItems = [], allergies: allergies = [] } = {}) {
    if ($864ce04f6c433567$export$cb853f6c272ac55f(row, rxItems)) return $864ce04f6c433567$export$d17c451ccb229dcb.IN_RX;
    const drug = $864ce04f6c433567$export$dfbc9b6ad0d6c589(row);
    if (!drug) {
        if (row.proposal?.matchStatus === 'unavailable') return $864ce04f6c433567$export$d17c451ccb229dcb.UNAVAILABLE;
        return $864ce04f6c433567$var$candidateDrugs(row.proposal).length ? $864ce04f6c433567$export$d17c451ccb229dcb.CHOOSE : $864ce04f6c433567$export$d17c451ccb229dcb.UNMATCHED;
    }
    if ((0, $cvBw3.allergyHit)(drug, allergies) || (0, $cvBw3.allergyHit)({
        name: row.proposal?.drugText,
        genericName: row.proposal?.genericName
    }, allergies)) return $864ce04f6c433567$export$d17c451ccb229dcb.ALLERGY;
    return $864ce04f6c433567$export$d17c451ccb229dcb.READY;
}
function $864ce04f6c433567$export$63b3df14443601d9(row, allergies = []) {
    const drug = $864ce04f6c433567$export$dfbc9b6ad0d6c589(row);
    return drug && (0, $cvBw3.allergyHit)(drug, allergies) || (0, $cvBw3.allergyHit)({
        name: row.proposal?.drugText,
        genericName: row.proposal?.genericName
    }, allergies);
}
// A dictated line and a drug the doctor prescribed aloud are the doctor's own
// decisions; a drug merely mentioned in the conversation and a model suggestion
// are not, and wait for a tick.
const $864ce04f6c433567$var$DECIDED_KINDS = new Set([
    'dictated',
    'prescribed'
]);
function $864ce04f6c433567$export$b06f6f1f87b469fc(proposals, ctx = {}) {
    return (proposals || []).map((proposal, i)=>{
        const row = {
            key: `p${i}`,
            proposal: proposal,
            drugId: proposal.selectedDrugId || '',
            checked: false
        };
        row.checked = $864ce04f6c433567$export$38b57db04f34575e(row, ctx) === $864ce04f6c433567$export$d17c451ccb229dcb.READY && proposal.matchStatus === 'matched' && $864ce04f6c433567$var$DECIDED_KINDS.has(proposal.kind);
        return row;
    });
}
function $864ce04f6c433567$export$2eabf1eeeee79bc3(rows, ctx = {}) {
    let changed = false;
    const next = (rows || []).map((row)=>{
        const known = $864ce04f6c433567$export$38b57db04f34575e(row, ctx) === $864ce04f6c433567$export$d17c451ccb229dcb.IN_RX;
        if (known === !!row.known) return row;
        changed = true;
        return {
            ...row,
            known: known,
            checked: row.checked && !known
        };
    });
    return changed ? next : rows;
}
function $864ce04f6c433567$export$c3f458c6c3133171(rows, key, drugId, ctx = {}) {
    return rows.map((row)=>{
        if (row.key !== key) return row;
        const next = {
            ...row,
            drugId: drugId || ''
        };
        // Choosing IS the decision — unless the choice is unsafe or a duplicate.
        next.checked = !!drugId && $864ce04f6c433567$export$38b57db04f34575e(next, ctx) === $864ce04f6c433567$export$d17c451ccb229dcb.READY;
        return next;
    });
}
function $864ce04f6c433567$export$93f90af192fa87b(rows, key, ctx = {}) {
    return rows.map((row)=>{
        if (row.key !== key) return row;
        const state = $864ce04f6c433567$export$38b57db04f34575e(row, ctx);
        // A row with no formulary drug, or one already prescribed, has nothing to add.
        if (![
            $864ce04f6c433567$export$d17c451ccb229dcb.READY,
            $864ce04f6c433567$export$d17c451ccb229dcb.ALLERGY
        ].includes(state)) return row;
        return {
            ...row,
            checked: !row.checked
        };
    });
}
function $864ce04f6c433567$export$b1b58b633f75984f(rows, checked, ctx = {}) {
    return (rows || []).map((row)=>{
        if (!checked) return row.checked ? {
            ...row,
            checked: false
        } : row;
        return !row.checked && $864ce04f6c433567$export$38b57db04f34575e(row, ctx) === $864ce04f6c433567$export$d17c451ccb229dcb.READY ? {
            ...row,
            checked: true
        } : row;
    });
}
function $864ce04f6c433567$export$987de25ed0ca3e20(p) {
    const out = {};
    const dosage = $864ce04f6c433567$var$text(p?.dosage) || $864ce04f6c433567$var$text(p?.strength);
    if (dosage) out.dosage = dosage;
    for (const k of [
        'frequency',
        'route',
        'duration',
        'quantity',
        'instructions'
    ])if ($864ce04f6c433567$var$text(p?.[k])) out[k] = $864ce04f6c433567$var$text(p[k]);
    return out;
}
function $864ce04f6c433567$export$231c4e06e639a88f(rows, ctx = {}) {
    return (rows || []).filter((row)=>row.checked).filter((row)=>[
            $864ce04f6c433567$export$d17c451ccb229dcb.READY,
            $864ce04f6c433567$export$d17c451ccb229dcb.ALLERGY
        ].includes($864ce04f6c433567$export$38b57db04f34575e(row, ctx))).map((row)=>({
            drug: $864ce04f6c433567$export$dfbc9b6ad0d6c589(row),
            defaults: $864ce04f6c433567$export$987de25ed0ca3e20(row.proposal)
        }));
}
function $864ce04f6c433567$export$cb741851902ee7c4(lines, { source: source = '', durations: durations = [], label: label = ()=>'' } = {}) {
    const fresh = [];
    for (const line of lines || [])if (line?.drug?.id && !fresh.some((l)=>l.drug.id === line.drug.id)) fresh.push(line);
    const stamp = Date.now();
    return fresh.map(({ drug: drug, defaults: defaults }, i)=>{
        const values = (0, $eQiuG.listValuesWhereNamed)(drug, defaults, {
            durations: durations
        });
        const dose = (0, $eQiuG.toDoseOption)(drug, defaults?.dosage);
        if (dose) values.dosage = dose;
        else delete values.dosage;
        return {
            key: `ai:${source}:${stamp}:${i}:${drug.id}`,
            drug: drug,
            defaults: values,
            sourceLabel: label(i + 1, fresh.length),
            sourceKind: 'ai'
        };
    });
}
// ── «تایید خودکار» for the نسخه (PM-0586, DESIGN_CONCEPT §13.3) ────────────────
//
// The AI service scores every product a heard drug could be and marks ONE —
// `autoConfirm`, with the product in `autoDrug` — only when it clears the bar and
// leads the next different product (auto_confirm.py, measured on the voice-test set).
// For a doctor who switched «تایید خودکار» on, such a row is added without the
// review — and still only when, here and now:
//   · it was said as a decision: dictated, prescribed (a renewal included), or a
//     drug the patient TAKES (`reason` taking — the owner's rule: scored too);
//   · it is not on the نسخه already, in any strength or brand of the same شکل;
//   · it matches no recorded allergy, by the product or by what was said;
//   · its line is complete without a guess (autoRxSig).
// Anything else waits in the review, exactly as before.
const $864ce04f6c433567$var$AUTO_KINDS = new Set([
    'dictated',
    'prescribed'
]);
function $864ce04f6c433567$export$1ca0954329d5523a(rows, ctx = {}) {
    return (rows || []).filter((row)=>{
        const p = row?.proposal;
        if (!p?.autoConfirm || !p.autoDrug?.id || row.known) return false;
        if (!$864ce04f6c433567$var$AUTO_KINDS.has(p.kind) && !(p.kind === 'mentioned' && p.reason === 'taking')) return false;
        const asPicked = {
            ...row,
            drugId: p.autoDrug.id
        };
        if ($864ce04f6c433567$export$cb853f6c272ac55f(asPicked, ctx.rxItems || [])) return false;
        if ((0, $cvBw3.allergyHit)(p.autoDrug, ctx.allergies || []) || (0, $cvBw3.allergyHit)({
            name: p.drugText,
            genericName: p.genericName
        }, ctx.allergies || [])) return false;
        return true;
    }).map((row)=>({
            ...row,
            drugId: row.proposal.autoDrug.id
        }));
}
function $864ce04f6c433567$export$5848f5e6dfb5b7e7(proposal, drug, usual, { durations: durations = [], makeLine: makeLine } = {}) {
    const said = $864ce04f6c433567$export$987de25ed0ca3e20(proposal);
    const heard = (0, $eQiuG.listValuesWhereNamed)(drug, said, {
        durations: durations
    });
    const dose = (0, $eQiuG.toDoseOption)(drug, said.dosage);
    if (dose) heard.dosage = dose;
    else delete heard.dosage;
    const sig = (0, $eQiuG.fillFromMemory)(heard, usual);
    if (!String(sig.frequency || '').trim() || !String(sig.duration || '').trim()) return null;
    if (!String(sig.dosage || '').trim()) {
        if (!$864ce04f6c433567$var$namesStrength(drug, proposal?.strength)) return null;
        delete sig.dosage; // newRxLine: one unit of the product's form
    }
    const line = makeLine ? makeLine(drug, sig) : sig;
    return (0, $eQiuG.missingRxFields)(line).length ? null : line;
}
// Whether the product's name carries the strength said, as a whole number: «500» is
// in «… 500 میلی‌گرم …» but not in «… 2500 …» — nor «5» in «2.5».
const $864ce04f6c433567$var$PERSIAN_DIGITS = "\u06F0\u06F1\u06F2\u06F3\u06F4\u06F5\u06F6\u06F7\u06F8\u06F9";
function $864ce04f6c433567$var$namesStrength(drug, strength) {
    const said = String(strength || '').match(/\d+(?:\.\d+)?/);
    if (!said) return false;
    const name = String(drug?.name || '').replace(/[۰-۹]/g, (c)=>String($864ce04f6c433567$var$PERSIAN_DIGITS.indexOf(c)));
    return (name.match(/\d+(?:\.\d+)?/g) || []).includes(said[0]);
}
const $864ce04f6c433567$export$20e812f59b1c550 = (line)=>[
        'dosage',
        'frequency',
        'duration',
        'quantity'
    ].map((k)=>String(line?.[k] ?? '').trim()).filter(Boolean).join(" \xb7 ");
function $864ce04f6c433567$export$38da4481450f6e5c(p, frequencyLabel = (f)=>f) {
    return [
        $864ce04f6c433567$var$text(p?.dosage) || $864ce04f6c433567$var$text(p?.strength),
        p?.frequency && frequencyLabel(p.frequency),
        $864ce04f6c433567$var$text(p?.route),
        $864ce04f6c433567$var$text(p?.duration)
    ].filter(Boolean).join(" \xb7 ");
}

});
parcelRegister("8qEaX", function(module, exports) {

$parcel$export(module.exports, "documentRxNeedsConfirm", () => $622fea85856450c1$export$af2260c3b4941e91);
$parcel$export(module.exports, "documentRxRowProblem", () => $622fea85856450c1$export$f9bb0cd25dab9659);
$parcel$export(module.exports, "visitRxDraftFromRow", () => $622fea85856450c1$export$304c866dced88570);
$parcel$export(module.exports, "isAlreadyPrescribed", () => $622fea85856450c1$export$26bd9984be9bfd1c);

var $1Qo7B = parcelRequire("1Qo7B");
// «افزودن به نسخه ویزیت» — a drug line read off a document, offered to THIS visit's
// نسخه. DICOM_COMPRESSION_LIMITS_AND_DOCUMENT_OCR_DESIGN.md §23.3 A13, §9.5;
// MEDICAL_FILE_INGESTION_DICOM_COMPRESSION_OCR_DESIGN.md §6.8.
//
// An extracted item NEVER enters the visit's prescription by itself. This module
// only turns a reviewed row into the shape the Visit's own drug form starts from —
// a drug plus the per-drug defaults `makeRxItem` takes — and the Visit puts it in
// the form's add state. The row becomes a نسخه line when the doctor presses the
// form's own «افزودن», through the same path a drug they picked by hand takes, so
// the SOAP «P» plan block (derived from the نسخه) follows it like any other line.
const $622fea85856450c1$var$text = (v)=>v == null ? '' : String(v).trim();
const $622fea85856450c1$export$af2260c3b4941e91 = (row)=>row?.verified === false || row?.confidence !== null && row?.confidence !== undefined && Number.isFinite(Number(row.confidence)) && Number(row.confidence) < (0, $1Qo7B.REVIEW_CONFIDENCE);
function $622fea85856450c1$export$f9bb0cd25dab9659(row) {
    if (!row) return 'patient.files.extract.rx.needsDrug';
    if (!$622fea85856450c1$var$text(row.drugText) && !row.drugId) return 'patient.files.extract.rx.needsDrug';
    if ((0, $1Qo7B.hasIllegibleMark)(row.drugText) && !row.drugId) return 'patient.files.extract.rx.illegibleDrug';
    return null;
}
// «Amoxicillin» + «500mg» reads «Amoxicillin 500mg»; a name that already says its
// strength is not told twice.
const $622fea85856450c1$var$withQualifiers = (name, ...parts)=>parts.map($622fea85856450c1$var$text).filter((p)=>p && !name.toLowerCase().includes(p.toLowerCase())).reduce((acc, p)=>`${acc} ${p}`, name);
function $622fea85856450c1$export$304c866dced88570(row) {
    const drugId = $622fea85856450c1$var$text(row?.drugId);
    const candidate = drugId ? (row.candidates || []).find((c)=>c.drugId === drugId) : null;
    const strength = $622fea85856450c1$var$text(candidate?.strength) || $622fea85856450c1$var$text(row?.strength);
    const form = $622fea85856450c1$var$text(candidate?.form) || $622fea85856450c1$var$text(row?.form);
    const dose = $622fea85856450c1$var$text(row?.dose);
    const frequency = $622fea85856450c1$var$text(row?.frequency) || $622fea85856450c1$var$text(row?.frequencyCode);
    const baseName = $622fea85856450c1$var$text(candidate?.name) || $622fea85856450c1$var$text(row?.drugText);
    const name = $622fea85856450c1$var$withQualifiers(baseName, strength, form);
    const drug = {
        id: drugId || `doc-med-${$622fea85856450c1$var$text(row?.drugText).toLowerCase()}`,
        name: name,
        genericName: $622fea85856450c1$var$text(candidate?.genericName),
        strength: strength,
        form: form,
        category: '',
        commonDosages: dose ? [
            dose
        ] : [],
        commonFrequencies: frequency ? [
            frequency
        ] : [],
        fromFormulary: Boolean(drugId)
    };
    return {
        key: row?.key || drug.id,
        drug: drug,
        defaults: {
            dosage: dose,
            frequency: frequency,
            frequencyCode: $622fea85856450c1$var$text(row?.frequencyCode),
            route: $622fea85856450c1$var$text(row?.route),
            duration: $622fea85856450c1$var$text(row?.duration),
            quantity: $622fea85856450c1$var$text(row?.quantity),
            instructions: $622fea85856450c1$var$text(row?.instructions)
        }
    };
}
function $622fea85856450c1$export$4a6823332c424d49(defaults) {
    const out = {};
    for (const k of [
        'dosage',
        'frequency',
        'route',
        'duration',
        'quantity',
        'instructions'
    ])if ($622fea85856450c1$var$text(defaults?.[k])) out[k] = $622fea85856450c1$var$text(defaults[k]);
    return out;
}
const $622fea85856450c1$export$5883510ef829fa69 = (batch, documentDefaults)=>({
        ...batch || {},
        ...$622fea85856450c1$export$4a6823332c424d49(documentDefaults)
    });
const $622fea85856450c1$export$41eca2609e16adbf = (defaults)=>Object.values($622fea85856450c1$export$4a6823332c424d49(defaults)).join(" \xb7 ");
function $622fea85856450c1$export$26bd9984be9bfd1c(rxItems, drug) {
    const nameKey = $622fea85856450c1$var$text(drug?.name).toLowerCase();
    return (rxItems || []).some((r)=>r.drug?.id && r.drug.id === drug?.id || nameKey && $622fea85856450c1$var$text(r.drug?.name).toLowerCase() === nameKey);
}

});

parcelRegister("2aPS0", function(module, exports) {

$parcel$export(module.exports, "parseProduct", () => $1954c03f878fe45b$export$118f73129e96440a);
$parcel$export(module.exports, "formKeyOf", () => $1954c03f878fe45b$export$49bc12753c4ae83);
$parcel$export(module.exports, "ingredientNameKey", () => $1954c03f878fe45b$export$6bd67e54caba8b84);
$parcel$export(module.exports, "drugFormKey", () => $1954c03f878fe45b$export$1d5b418d03549c72);
$parcel$export(module.exports, "groupProducts", () => $1954c03f878fe45b$export$cbf1162dc7529312);
$parcel$export(module.exports, "mergeIntoGroup", () => $1954c03f878fe45b$export$9148a864884cb04b);
$parcel$export(module.exports, "formsOf", () => $1954c03f878fe45b$export$c4e7c4d3b2f5c593);
$parcel$export(module.exports, "strengthsOf", () => $1954c03f878fe45b$export$266cf92cac578c66);
$parcel$export(module.exports, "productsOf", () => $1954c03f878fe45b$export$b9c0747ef7361846);
$parcel$export(module.exports, "variantLabel", () => $1954c03f878fe45b$export$c877a6c4e166c3c6);
$parcel$export(module.exports, "productIn", () => $1954c03f878fe45b$export$269cca928fe29b43);
$parcel$export(module.exports, "groupSummary", () => $1954c03f878fe45b$export$421cf268395c9223);
$parcel$export(module.exports, "formLabelParts", () => $1954c03f878fe45b$export$2eb6d07f42ee42be);
// A drug-list row, read as what it is: one PRODUCT of an ingredient — a strength,
// a form, a route, sometimes a pack size and a brand.
//
// The picker used to show every product as its own card, so «پردنی» filled its
// first page with seven brands of one 5 mg tablet. The doctor now searches for the
// DRUG and picks its شکل and قدرت in the add form (PM-0059), and this module is
// what tells one from the other.
//
// Nothing here is guessed from Persian. The imported rows carry the official eRx
// product string, and that string has a fixed order:
//
//     INGREDIENT  strength  [pack]  FORM[, qualifier …]  ROUTE  [pack]  [BRAND]
//     PREDNISOLONE 5 mg TABLET ORAL [NISOPRED]
//     AMOXICILLIN 125 mg/5mL 100 mL POWDER, FOR SUSPENSION ORAL
//
// It is read from the END — brand, pack, route, form, strength — and what is left
// is the ingredient, so an ingredient written in several words needs no list of
// its own. A row whose name is not such a string (a curated row: «Prednisolone»)
// is one product of its own name: no form, no strength, never folded into another.
const $1954c03f878fe45b$var$ROUTE_WORDS = new Set([
    'ORAL',
    'PARENTERAL',
    'TOPICAL',
    'INTRAVENOUS',
    'INTRAMUSCULAR',
    'SUBCUTANEOUS',
    'OPHTHALMIC',
    'OTIC',
    'NASAL',
    'RESPIRATORY',
    'INHALATION',
    'VAGINAL',
    'RECTAL',
    'SUBLINGUAL',
    'BUCCAL',
    'TRANSDERMAL',
    'CUTANEOUS',
    'DENTAL',
    'INTRAPERITONEAL',
    'ENDOTRACHEAL',
    'IRRIGATION',
    'HEMODIALYSIS',
    'TRANSTRACHEAL',
    'INTRASPINAL',
    'INTRATHECAL',
    'EPIDURAL',
    'INTRAVITREAL',
    'INTRAOCULAR',
    'INTRAARTICULAR',
    'INTRADERMAL',
    'INTRAUTERINE',
    'URETHRAL',
    'INTRAVESICAL',
    'AURICULAR',
    'OROMUCOSAL'
]);
// The words a dose form is written with: the form itself and its qualifiers.
const $1954c03f878fe45b$var$FORM_HEADS = new Set([
    'TABLET',
    'CAPSULE',
    'SOFTGEL',
    'SOLUTION',
    'SUSPENSION',
    'SYRUP',
    'ELIXIR',
    'INJECTION',
    'INJECTABLE',
    'POWDER',
    'DROPS',
    'DROP',
    'CREAM',
    'OINTMENT',
    'GEL',
    'LOTION',
    'SPRAY',
    'AEROSOL',
    'INHALER',
    'INHALANT',
    'SUPPOSITORY',
    'PATCH',
    'SHAMPOO',
    'EMULSION',
    'GRANULE',
    'GRANULES',
    'PELLET',
    'PELLETS',
    'LOZENGE',
    'PASTE',
    'FOAM',
    'IMPLANT',
    'KIT',
    'GAS',
    'LIQUID',
    'PESSARY',
    'OVULE',
    'ENEMA',
    'TINCTURE',
    'MOUTHWASH',
    'JELLY',
    'FILM',
    'GUM',
    'SACHET',
    'PILL',
    'TROCHE',
    'INSERT',
    'RING',
    'SUPPOSITORIES',
    'CONCENTRATE',
    'SOLID',
    'BAR',
    'OIL',
    'SOAP',
    'STICK',
    'WAFER'
]);
const $1954c03f878fe45b$var$FORM_QUALIFIERS = new Set([
    'FOR',
    'EXTENDED',
    'DELAYED',
    'RELEASE',
    'CHEWABLE',
    'COATED',
    'ORALLY',
    'DISINTEGRATING',
    'EFFERVESCENT',
    'SOLUBLE',
    'DISPERSIBLE',
    'METERED',
    'FILLED',
    'LYOPHILIZED',
    'LIPOSOMAL',
    'ENTERIC',
    'SUSTAINED',
    'MODIFIED',
    'PROLONGED',
    'GELATIN',
    'LIQUID',
    'PREFILLED',
    'SYRINGE',
    'RECONSTITUTION',
    'INFUSION',
    'AUGMENTED',
    'SUBLINGUAL',
    'VAGINAL',
    'RECTAL',
    'NASAL',
    'WITH',
    'DILUENT'
]);
const $1954c03f878fe45b$var$UNIT_WORDS = new Set([
    'IU',
    'L',
    'U',
    'G',
    'MILLILITER',
    'GRAM',
    'MG',
    'ML',
    'KG',
    'MCG'
]);
const $1954c03f878fe45b$var$bare = (tok)=>tok.replace(/^[(]+|[),]+$/g, '');
// «500», «2.5», «0.05%», «125mg», «(2» — where a strength or a pack begins.
const $1954c03f878fe45b$var$startsWithNumber = (tok)=>/^\(?[\d.]*\d/.test(tok);
// «mg», «mL», «mg/5mL», «[iU]/mL», «{Puff}», «g)» — a unit standing alone after its number.
const $1954c03f878fe45b$var$isUnit = (tok)=>{
    const b = $1954c03f878fe45b$var$bare(tok);
    if (!b) return false;
    if ($1954c03f878fe45b$var$UNIT_WORDS.has(b.toUpperCase()) && b.length <= 10) return true;
    return b.length <= 14 && /[a-zµ%]/.test(b) && /^[\[\]{}A-Za-zµ%/\d.]+$/.test(b);
};
const $1954c03f878fe45b$var$isMeasure = (tok)=>$1954c03f878fe45b$var$startsWithNumber(tok) || $1954c03f878fe45b$var$isUnit(tok);
// One «number unit[/number unit]» at the head of a measure string.
const $1954c03f878fe45b$var$MEASURE = /^\(?[\d.,]+\s*(?:[\[{]?[A-Za-zµ]+[\]}]?|%)?(?:\s*[/+]\s*[\d.,]*\s*(?:[\[{]?[A-Za-zµ]+[\]}]?|%)?)*\)?/;
function $1954c03f878fe45b$var$splitMeasures(text) {
    const parts = [];
    let rest = text.trim();
    while(rest){
        const m = rest.match($1954c03f878fe45b$var$MEASURE);
        if (!m || !m[0]) {
            parts.push(rest);
            break;
        }
        parts.push(m[0].trim());
        rest = rest.slice(m[0].length).trim();
    }
    return parts;
}
const $1954c03f878fe45b$export$7ff7ad4866bf0f48 = (drug)=>{
    const id = String(drug?.id || '');
    return String((id.startsWith('erx-') ? drug?.name : drug?.genericName) || '').trim();
};
const $1954c03f878fe45b$var$isImported = (drug)=>/^(tamin|erx)-/.test(String(drug?.id || ''));
function $1954c03f878fe45b$export$118f73129e96440a(drug) {
    const plain = {
        ingredient: String(drug?.genericName || drug?.name || '').trim(),
        strength: '',
        form: '',
        route: '',
        pack: '',
        brand: '',
        structured: false
    };
    if (!$1954c03f878fe45b$var$isImported(drug)) return plain;
    let text = $1954c03f878fe45b$export$7ff7ad4866bf0f48(drug);
    if (!text) return plain;
    let brand = '';
    const b = text.match(/\s*\[([^\]]+)\]\s*$/);
    // «100 [iU]/mL» ends in a bracket too — a brand is a bracket standing alone.
    if (b && !/[\d/]\s*$/.test(text.slice(0, b.index)) && !/^i?u$/i.test(b[1].trim())) {
        brand = b[1].trim();
        text = text.slice(0, b.index).trim();
    }
    const toks = text.split(/\s+/).filter(Boolean);
    const popWhile = (test)=>{
        const out = [];
        while(toks.length > 1 && test(toks[toks.length - 1]))out.unshift(toks.pop());
        return out;
    };
    const tailPack = popWhile($1954c03f878fe45b$var$isMeasure);
    let route = '';
    if (toks.length > 1 && $1954c03f878fe45b$var$ROUTE_WORDS.has($1954c03f878fe45b$var$bare(toks[toks.length - 1]).toUpperCase())) route = $1954c03f878fe45b$var$bare(toks.pop()).toUpperCase();
    const formToks = popWhile((tok)=>{
        const w = tok.replace(/,$/, '').toUpperCase();
        return w.split('/').every((p)=>$1954c03f878fe45b$var$FORM_HEADS.has(p) || $1954c03f878fe45b$var$FORM_QUALIFIERS.has(p));
    });
    // A qualifier alone is not a form («… WITH»): it belongs to the name.
    if (formToks.length && !formToks.some((tok)=>tok.replace(/,$/, '').toUpperCase().split('/').some((p)=>$1954c03f878fe45b$var$FORM_HEADS.has(p)))) toks.push(...formToks.splice(0));
    const measures = popWhile($1954c03f878fe45b$var$isMeasure);
    if (!formToks.length && !route) return {
        ...plain,
        brand: brand
    };
    const [strength = '', ...packs] = $1954c03f878fe45b$var$splitMeasures(measures.join(' '));
    // The molecule head an eRx row carries beside its product string is the
    // ingredient as the registry cut it; a تأمین row has only what is left here.
    const head = String(drug?.id || '').startsWith('erx-') ? String(drug?.genericName || '').trim() : '';
    const ingredient = (head && text.toUpperCase().startsWith(head.toUpperCase()) ? head : toks.join(' ')).replace(/[,\s]+$/, '');
    if (!ingredient) return {
        ...plain,
        brand: brand
    };
    return {
        ingredient: ingredient,
        strength: strength,
        form: formToks.join(' ').toUpperCase(),
        route: route,
        pack: [
            ...packs,
            ...$1954c03f878fe45b$var$splitMeasures(tailPack.join(' '))
        ].join(' '),
        brand: brand,
        structured: true
    };
}
// One ingredient, whatever salt it is written as and however it is spaced:
// «DAPOXETINE (AS HYDROCHLORIDE)» is dapoxetine.
const $1954c03f878fe45b$var$ingredientKey = (name)=>String(name || '').replace(/\(\s*AS\s+[^)]*\)/gi, ' ').toLowerCase().replace(/[^a-z0-9؀-ۿ]+/g, ' ').trim();
const $1954c03f878fe45b$export$49bc12753c4ae83 = (p)=>p.form || p.route ? `${p.form}|${p.route}` : '';
const $1954c03f878fe45b$export$6bd67e54caba8b84 = (name)=>$1954c03f878fe45b$var$ingredientKey(name);
function $1954c03f878fe45b$export$1d5b418d03549c72(drug) {
    const p = $1954c03f878fe45b$export$118f73129e96440a(drug);
    return p.structured ? `${$1954c03f878fe45b$var$ingredientKey(p.ingredient)}#${$1954c03f878fe45b$export$49bc12753c4ae83(p)}` : null;
}
function $1954c03f878fe45b$export$cbf1162dc7529312(drugs) {
    const groups = new Map();
    for (const drug of drugs || []){
        if (!drug?.id) continue;
        const p = $1954c03f878fe45b$export$118f73129e96440a(drug);
        const key = p.structured ? `i:${$1954c03f878fe45b$var$ingredientKey(p.ingredient)}` : `id:${drug.id}`;
        if (!groups.has(key)) groups.set(key, {
            key: key,
            ingredient: p.ingredient,
            structured: p.structured,
            products: []
        });
        const g = groups.get(key);
        if (!g.products.some((x)=>x.drug.id === drug.id)) g.products.push({
            drug: drug,
            ...p
        });
    }
    return [
        ...groups.values()
    ];
}
function $1954c03f878fe45b$export$9148a864884cb04b(group, drugs) {
    if (!group?.structured) return group;
    const seen = new Set(group.products.map((p)=>p.drug.id));
    const extra = [];
    for (const drug of drugs || []){
        if (!drug?.id || seen.has(drug.id)) continue;
        const p = $1954c03f878fe45b$export$118f73129e96440a(drug);
        if (!p.structured || `i:${$1954c03f878fe45b$var$ingredientKey(p.ingredient)}` !== group.key) continue;
        seen.add(drug.id);
        extra.push({
            drug: drug,
            ...p
        });
    }
    return extra.length ? {
        ...group,
        products: [
            ...group.products,
            ...extra
        ]
    } : group;
}
const $1954c03f878fe45b$var$strengthNumber = (s)=>{
    const m = String(s || '').match(/[\d.]+/);
    return m ? Number(m[0]) : Infinity;
};
const $1954c03f878fe45b$var$byStrength = (a, b)=>$1954c03f878fe45b$var$strengthNumber(a) - $1954c03f878fe45b$var$strengthNumber(b) || String(a).localeCompare(String(b));
function $1954c03f878fe45b$export$c4e7c4d3b2f5c593(group) {
    const out = new Map();
    for (const p of group?.products || []){
        const key = $1954c03f878fe45b$export$49bc12753c4ae83(p);
        if (!out.has(key)) out.set(key, {
            key: key,
            form: p.form,
            route: p.route
        });
    }
    return [
        ...out.values()
    ];
}
function $1954c03f878fe45b$export$266cf92cac578c66(group, formKey) {
    const set = new Set();
    for (const p of group?.products || [])if ($1954c03f878fe45b$export$49bc12753c4ae83(p) === formKey) set.add(p.strength);
    return [
        ...set
    ].sort($1954c03f878fe45b$var$byStrength);
}
function $1954c03f878fe45b$export$b9c0747ef7361846(group, formKey, strength) {
    return (group?.products || []).filter((p)=>$1954c03f878fe45b$export$49bc12753c4ae83(p) === formKey && p.strength === strength).sort((a, b)=>(a.brand ? 1 : 0) - (b.brand ? 1 : 0));
}
const $1954c03f878fe45b$export$c877a6c4e166c3c6 = (p)=>[
        p.pack,
        p.brand
    ].filter(Boolean).join(" \xb7 ");
function $1954c03f878fe45b$export$269cca928fe29b43(group, drugId) {
    const list = group?.products || [];
    return list.find((p)=>p.drug.id === drugId) || list[0] || null;
}
function $1954c03f878fe45b$export$421cf268395c9223(group, formLabel) {
    return $1954c03f878fe45b$export$c4e7c4d3b2f5c593(group).map((f)=>{
        const strengths = $1954c03f878fe45b$export$266cf92cac578c66(group, f.key).filter(Boolean);
        // The strengths are Latin and read left to right as ONE run, whatever the
        // direction of the line they sit in: unisolated, «5 mg, 50 mg» after a
        // Persian form word came out as «mg، 50 mg 5».
        const run = strengths.length ? `\u{2066}${strengths.join(', ')}\u{2069}` : '';
        return [
            formLabel(f.form, f.route),
            run
        ].filter(Boolean).join(' ');
    }).filter(Boolean).join(" \xb7 ");
}
// The form word a doctor reads, by the registry's head word. Keys of
// `visit.rx.forms.*`; a head with no key is shown as the registry writes it.
const $1954c03f878fe45b$var$FORM_LABEL_KEYS = {
    TABLET: 'tablet',
    CAPSULE: 'capsule',
    SOFTGEL: 'softgel',
    SOLUTION: 'solution',
    SUSPENSION: 'suspension',
    SYRUP: 'syrup',
    ELIXIR: 'elixir',
    INJECTION: 'injection',
    INJECTABLE: 'injection',
    POWDER: 'powder',
    DROPS: 'drops',
    DROP: 'drops',
    CREAM: 'cream',
    OINTMENT: 'ointment',
    GEL: 'gel',
    LOTION: 'lotion',
    SPRAY: 'spray',
    AEROSOL: 'spray',
    INHALER: 'inhaler',
    INHALANT: 'inhaler',
    SUPPOSITORY: 'suppository',
    SUPPOSITORIES: 'suppository',
    PATCH: 'patch',
    SHAMPOO: 'shampoo',
    EMULSION: 'emulsion',
    GRANULE: 'granule',
    GRANULES: 'granule',
    LOZENGE: 'lozenge',
    PASTE: 'paste',
    FOAM: 'foam',
    SACHET: 'sachet',
    PESSARY: 'pessary',
    OVULE: 'pessary',
    ENEMA: 'enema',
    MOUTHWASH: 'mouthwash'
};
const $1954c03f878fe45b$var$QUALIFIER_LABEL_KEYS = [
    [
        /EXTENDED RELEASE|SUSTAINED RELEASE|PROLONGED RELEASE|MODIFIED RELEASE/,
        'extendedRelease'
    ],
    [
        /DELAYED RELEASE|ENTERIC COATED/,
        'delayedRelease'
    ],
    [
        /CHEWABLE/,
        'chewable'
    ],
    [
        /EFFERVESCENT/,
        'effervescent'
    ],
    [
        /ORALLY DISINTEGRATING|DISPERSIBLE/,
        'dispersible'
    ],
    [
        /FOR SUSPENSION/,
        'forSuspension'
    ],
    [
        /FOR SOLUTION/,
        'forSolution'
    ],
    [
        /METERED/,
        'metered'
    ]
];
const $1954c03f878fe45b$var$ROUTE_LABEL_KEYS = {
    ORAL: 'oral',
    SUBLINGUAL: 'sublingual',
    INTRAVENOUS: 'iv',
    INTRAMUSCULAR: 'im',
    SUBCUTANEOUS: 'sc',
    TOPICAL: 'topical',
    CUTANEOUS: 'topical',
    TRANSDERMAL: 'topical',
    RESPIRATORY: 'inhaled',
    INHALATION: 'inhaled',
    OPHTHALMIC: 'ophthalmic',
    OTIC: 'otic',
    AURICULAR: 'otic',
    NASAL: 'nasal',
    RECTAL: 'rectal',
    VAGINAL: 'vaginal'
};
// A qualifier that ENDS in «-» is a compound prefix, not a word: German writes an
// effervescent tablet «Brausetablette», never «Tablette brausend» (PM-0212). The
// prefix is fused to the form word — lower-cased, since a German noun loses its
// capital inside a compound — or, for a form the registry spells raw, joined by
// the hyphen («Brause-WAFER»). Every other qualifier follows the form, as before;
// no other language ends a qualifier in «-», so their labels do not change.
function $1954c03f878fe45b$var$joinFormLabel(base, qualifiers, translated) {
    const prefixes = qualifiers.filter((q)=>q && q.endsWith('-'));
    const words = qualifiers.filter((q)=>q && !q.endsWith('-'));
    let head = base;
    if (head && prefixes.length) {
        const stems = prefixes.map((p, i)=>i === 0 ? p.slice(0, -1) : $1954c03f878fe45b$var$lowerFirst(p.slice(0, -1)));
        head = translated ? stems.join('') + $1954c03f878fe45b$var$lowerFirst(head) : `${stems.join('')}-${head}`;
    }
    return [
        head,
        ...words
    ].filter(Boolean).join(' ');
}
const $1954c03f878fe45b$var$lowerFirst = (w)=>w ? w.charAt(0).toLocaleLowerCase() + w.slice(1) : w;
function $1954c03f878fe45b$export$2eb6d07f42ee42be(form, route, t, fallback = '') {
    const words = String(form || '').toUpperCase().replace(/,/g, ' ').split(/\s+/).filter(Boolean);
    // «SOLUTION, DROPS» is drops to a doctor: the way it is taken leads.
    const parts = words.flatMap((w)=>w.split('/'));
    const headKey = parts.some((p)=>p === 'DROPS' || p === 'DROP') ? 'drops' : $1954c03f878fe45b$var$FORM_LABEL_KEYS[parts.find((p)=>$1954c03f878fe45b$var$FORM_LABEL_KEYS[p])];
    const phrase = words.join(' ');
    const qualifiers = $1954c03f878fe45b$var$QUALIFIER_LABEL_KEYS.filter(([re])=>re.test(phrase)).map(([, k])=>t(`visit.rx.forms.qualifier.${k}`));
    const base = headKey ? t(`visit.rx.forms.${headKey}`) : form || fallback;
    const routeKey = $1954c03f878fe45b$var$ROUTE_LABEL_KEYS[String(route || '').toUpperCase()];
    return {
        label: $1954c03f878fe45b$var$joinFormLabel(base, qualifiers, Boolean(headKey)),
        detail: routeKey ? t(`visit.rx.routes.${routeKey}`) : route && route !== 'PARENTERAL' ? route : ''
    };
}

});


parcelRegister("dXWAH", function(module, exports) {

$parcel$export(module.exports, "ProposalBadge", () => $6b8cec43441c5f15$export$75b49caa06e7c59e);
$parcel$export(module.exports, "CompleteButton", () => $6b8cec43441c5f15$export$5a0ca1724712239e);
$parcel$export(module.exports, "ProposalCard", () => $6b8cec43441c5f15$export$c77d4a7df286b4a9);
$parcel$export(module.exports, "ProposalActions", () => $6b8cec43441c5f15$export$8f3e57e0bb4fa42c);
$parcel$export(module.exports, "CompletionGuide", () => $6b8cec43441c5f15$export$f8baeb9beb7439e1);
$parcel$export(module.exports, "MonitoringControl", () => $6b8cec43441c5f15$export$45fe3bada8fd7008);
// «تکمیل از پایش بالینی» (PM-0038) — the ONE vocabulary for everything the visit's
// transcript can fill in: the control that makes the transcript, the button that
// reads it, the card a reading comes back as, and the guide that walks the doctor
// from one section's proposals to the next.
//
//   MonitoringControl   «پایش بالینی» itself + the visit-wide «تکمیل», in the desk's top
//                       bar. (The phone composes MobileVisitMonitorButton + the
//                       same CompleteButton in its pinned top strip.)
//   CompleteButton      the same button in every section: press it and the recorded
//                       «پایش بالینی» is read for THAT section.
//   ProposalCard        what a reading returns — a proposal, labelled as AI output,
//   ProposalActions     sitting in the section it would fill until the doctor
//                       confirms or rejects it. Nothing here writes.
//   CompletionGuide     the sections that still hold proposals, in order, and the
//                       way to the next one.
//   ProposalBadge       the count a tab or a section header wears while it waits.
//
// Both surfaces render these (`variant`): px on the desk, rem and 44px targets on
// the phone. Colour is the accent family only, so a preset re-themes all of it.

var $acw62 = parcelRequire("acw62");

var $huNwV = parcelRequire("huNwV");
var $gKFEi = parcelRequire("gKFEi");
var $kzPvP = parcelRequire("kzPvP");
var $hAUh5 = parcelRequire("hAUh5");
var $hSPBf = parcelRequire("hSPBf");
var $4gxLI = parcelRequire("4gxLI");
var $bF8pu = parcelRequire("bF8pu");
var $chm1L = parcelRequire("chm1L");
var $7udIf = parcelRequire("7udIf");
var $6TdpC = parcelRequire("6TdpC");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
const $6b8cec43441c5f15$var$K = 'visit.complete';
const $6b8cec43441c5f15$var$SIZES = {
    web: {
        font: '0.71875rem',
        small: '0.65625rem',
        icon: 12,
        padY: 5,
        padX: 11,
        gap: 5,
        radius: 8,
        minH: undefined
    },
    mobile: {
        font: '0.8125rem',
        small: '0.75rem',
        icon: 15,
        padY: '0.375rem',
        padX: '0.875rem',
        gap: '0.375rem',
        radius: 10,
        minH: '2.75rem'
    }
};
const $6b8cec43441c5f15$var$pad = (n)=>String(n).padStart(2, '0');
const $6b8cec43441c5f15$var$spinner = (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hAUh5.default), {
        size: size,
        "aria-hidden": true,
        className: "animate-spin motion-reduce:animate-none",
        style: {
            flexShrink: 0
        }
    });
// The look of «تکمیل» (PM-0045). Two tones of one family, both built from the
// accent tokens so a panel or an accent preset re-themes them:
//   solid — the brand gradient with a passing sheen: the visit-wide button;
//   soft  — a surface pill inside a slowly turning gradient ring: every section.
// While it reads, the waveform of the mark moves instead of a spinner: the button
// is listening to the transcript. Keyframes cannot live in an inline style, so the
// rules ship as one <style> the first button on the page renders.
const $6b8cec43441c5f15$var$COMPLETE_CSS = `
@property --pc-a { syntax: '<angle>'; initial-value: 0deg; inherits: false; }
@keyframes pc-spin { to { --pc-a: 360deg } }
@keyframes pc-sheen { 0%,70% { transform: translateX(130%) } 100% { transform: translateX(-130%) } }
@keyframes pc-wave { 0%,100% { transform: scaleY(.45) } 50% { transform: scaleY(1.25) } }
.pc-complete { position: relative; transition: transform .15s, box-shadow .2s; }
.pc-complete:not([aria-disabled="true"]):not(:disabled):active { transform: scale(.97); }
.pc-complete:focus-visible { outline: 2px solid var(--p-navy); outline-offset: 2px; }
.pc-complete .pc-bar { transform-origin: center; transform-box: fill-box; }
.pc-complete[aria-busy="true"] .pc-bar { animation: pc-wave .9s ease-in-out infinite; }
.pc-complete[aria-busy="true"] .pc-bar:nth-of-type(2) { animation-delay: .15s }
.pc-complete[aria-busy="true"] .pc-bar:nth-of-type(3) { animation-delay: .3s }
.pc-complete[aria-busy="true"] .pc-bar:nth-of-type(4) { animation-delay: .45s }
.pc-complete--solid { overflow: hidden; border: 1px solid transparent;
  background: linear-gradient(120deg, var(--p-teal), var(--p-navy));
  box-shadow: 0 3px 12px color-mix(in srgb, var(--p-navy) 30%, transparent); }
.pc-complete--solid::after { content: ''; position: absolute; inset: 0; pointer-events: none;
  background: linear-gradient(105deg, transparent 35%, rgba(255,255,255,.45) 50%, transparent 65%);
  animation: pc-sheen 4s ease-in-out infinite; }
.pc-complete--solid:not(:disabled):hover { box-shadow: 0 5px 20px color-mix(in srgb, var(--p-teal) 50%, transparent); }
.pc-complete--soft { border: 1.5px solid transparent;
  background: linear-gradient(${(0, $jTCZr.CT).surface}, ${(0, $jTCZr.CT).surface}) padding-box,
    conic-gradient(from var(--pc-a), var(--p-teal), var(--p-navy), var(--p-teal-light), var(--p-teal)) border-box;
  animation: pc-spin 5s linear infinite;
  box-shadow: 0 2px 10px color-mix(in srgb, var(--p-navy) 14%, transparent); }
.pc-complete--soft:not(:disabled):not([aria-disabled="true"]):hover { animation-duration: 1.6s;
  box-shadow: 0 4px 18px color-mix(in srgb, var(--p-teal) 35%, transparent); }
.pc-complete--soft[aria-busy="true"] { animation-duration: 1.2s; }
.pc-complete--soft .pc-spark { fill: var(--p-teal); }
@media (prefers-reduced-motion: reduce) {
  .pc-complete, .pc-complete::after, .pc-complete .pc-bar { animation: none !important; transition: none !important; }
}
`;
function $6b8cec43441c5f15$export$70c07385940452eb({ size: size = 12, style: style }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        "aria-hidden": true,
        viewBox: "0 0 26 20",
        fill: "currentColor",
        width: Math.round(size * 1.3),
        height: size,
        style: {
            flexShrink: 0,
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        className: "pc-bar",
        x: "1",
        y: "7",
        width: "2.4",
        height: "6",
        rx: "1.2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        className: "pc-bar",
        x: "5.6",
        y: "3",
        width: "2.4",
        height: "14",
        rx: "1.2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        className: "pc-bar",
        x: "10.2",
        y: "6",
        width: "2.4",
        height: "8",
        rx: "1.2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        className: "pc-bar",
        x: "14.8",
        y: "8",
        width: "2.4",
        height: "4",
        rx: "1.2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        className: "pc-spark",
        d: "M21.5 1.5l1 2.6 2.6 1-2.6 1-1 2.6-1-2.6-2.6-1 2.6-1z"
    }));
}
function $6b8cec43441c5f15$export$75b49caa06e7c59e({ count: count, variant: variant = 'web', testid: testid }) {
    const { t: t, formatNumber: formatNumber } = (0, $LNQP4.default)();
    if (!(count > 0)) return null;
    const mobile = variant === 'mobile';
    const n = formatNumber ? formatNumber(count) : String(count);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": testid,
        title: t(`${$6b8cec43441c5f15$var$K}.badge`, {
            n: n
        }),
        "aria-label": t(`${$6b8cec43441c5f15$var$K}.badge`, {
            n: n
        }),
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 2,
            flexShrink: 0,
            padding: mobile ? '0.0625rem 0.3125rem' : '1px 6px',
            borderRadius: 999,
            fontSize: mobile ? '0.625rem' : '0.625rem',
            fontWeight: 700,
            lineHeight: 1.5,
            background: (0, $jTCZr.CT).accent,
            color: (0, $jTCZr.CT).surface,
            whiteSpace: 'nowrap'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $chm1L.default), {
        size: mobile ? 10 : 9,
        "aria-hidden": true
    }), " ", n);
}
function $6b8cec43441c5f15$export$5a0ca1724712239e({ onClick: onClick, busy: busy = false, disabled: disabled = false, title: title, label: label, count: count = 0, variant: variant = 'web', tone: tone = 'soft', compact: compact = false, nested: nested = false, testid: testid = 'visit-complete' }) {
    const { t: t, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const S = $6b8cec43441c5f15$var$SIZES[variant] || $6b8cec43441c5f15$var$SIZES.web;
    const off = disabled || busy;
    const solid = tone === 'solid';
    const press = (e)=>{
        e.stopPropagation();
        if (!off) onClick?.(e);
    };
    // `nested`: the button sits inside another button (a section header that
    // toggles), where a real <button> would be invalid markup — same control, as
    // a focusable role="button".
    const Tag = nested ? 'span' : 'button';
    const own = nested ? {
        role: 'button',
        tabIndex: off ? -1 : 0,
        'aria-disabled': off || undefined,
        onKeyDown: (e)=>{
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                press(e);
            }
        }
    } : {
        type: 'button',
        disabled: off
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, {
        ...own,
        onClick: press,
        title: title || t(`${$6b8cec43441c5f15$var$K}.hint`),
        "aria-busy": busy || undefined,
        "data-testid": testid,
        "data-tone": tone,
        className: `pc-complete pc-complete--${solid ? 'solid' : 'soft'}`,
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: S.gap,
            flexShrink: 0,
            padding: compact && variant !== 'mobile' ? '3px 9px' : `${typeof S.padY === 'number' ? `${S.padY}px` : S.padY} ${typeof S.padX === 'number' ? `${S.padX}px` : S.padX}`,
            minHeight: S.minH,
            borderRadius: 999,
            whiteSpace: 'nowrap',
            color: solid ? (0, $jTCZr.CT).surface : (0, $jTCZr.CT).accentInk,
            fontSize: compact && variant !== 'mobile' ? S.small : S.font,
            fontWeight: 700,
            fontFamily: 'inherit',
            // Busy keeps its full colour — the moving waveform is the state.
            cursor: off ? 'not-allowed' : 'pointer',
            opacity: disabled ? 0.55 : 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", null, $6b8cec43441c5f15$var$COMPLETE_CSS), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($6b8cec43441c5f15$export$70c07385940452eb, {
        size: S.icon
    }), label || t(`${$6b8cec43441c5f15$var$K}.button`), count > 0 && !busy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": `${testid}-count`,
        style: {
            minWidth: '1.25em',
            padding: '0 0.3em',
            borderRadius: 999,
            textAlign: 'center',
            fontSize: '0.85em',
            lineHeight: 1.5,
            background: solid ? (0, $jTCZr.CT).surface : (0, $jTCZr.CT).navy,
            color: solid ? (0, $jTCZr.CT).navy : (0, $jTCZr.CT).surface
        }
    }, formatNumber ? formatNumber(count) : count));
}
function $6b8cec43441c5f15$export$c77d4a7df286b4a9({ title: title, heading: heading, onClose: onClose, children: children, footer: footer, variant: variant = 'web', testid: testid, style: style, ...rest }) {
    const { t: t } = (0, $LNQP4.default)();
    const mobile = variant === 'mobile';
    const S = $6b8cec43441c5f15$var$SIZES[variant] || $6b8cec43441c5f15$var$SIZES.web;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testid,
        "data-proposal-card": "",
        ...rest,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: mobile ? '0.625rem' : 9,
            flexShrink: 0,
            padding: mobile ? '0.75rem' : '10px 12px',
            borderRadius: S.radius,
            border: `1px solid ${(0, $jTCZr.CT).accent}`,
            borderInlineStart: `3px solid ${(0, $jTCZr.CT).accent}`,
            background: (0, $jTCZr.CT).accentSoft,
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: 0,
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            flexWrap: 'wrap'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($6b8cec43441c5f15$export$70c07385940452eb, {
        size: S.icon,
        style: {
            color: (0, $jTCZr.CT).accentInk
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: S.font,
            fontWeight: 700,
            color: (0, $jTCZr.CT).ink
        }
    }, heading || (title ? t(`${$6b8cec43441c5f15$var$K}.proposalFor`, {
        section: title
    }) : t(`${$6b8cec43441c5f15$var$K}.proposal`))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            padding: '1px 7px',
            borderRadius: 999,
            fontSize: S.small,
            fontWeight: 600,
            background: (0, $jTCZr.CT).surface,
            color: (0, $jTCZr.CT).accentInk,
            whiteSpace: 'nowrap'
        }
    }, t('visit.suggest.ai'))), onClose && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onClose,
        "aria-label": t('common.actions.close'),
        "data-testid": `${testid}-close`,
        style: {
            display: 'grid',
            placeItems: 'center',
            flexShrink: 0,
            width: mobile ? '2.75rem' : 22,
            height: mobile ? '2.75rem' : 22,
            // The 44px target reaches into the card's own padding, so the row
            // stays one line tall.
            marginBlock: mobile ? '-0.625rem' : undefined,
            marginInlineEnd: mobile ? '-0.5rem' : undefined,
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            color: (0, $jTCZr.CT).ink2
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
        size: mobile ? 16 : 13,
        "aria-hidden": true
    }))), children, footer);
}
function $6b8cec43441c5f15$export$8f3e57e0bb4fa42c({ onAccept: onAccept, acceptLabel: acceptLabel, acceptDisabled: acceptDisabled = false, busy: busy = false, onDismiss: onDismiss, dismissLabel: dismissLabel, children: children, variant: variant = 'web', testid: testid, acceptTestid: acceptTestid = `${testid}-apply`, dismissTestid: dismissTestid = `${testid}-cancel` }) {
    const { t: t } = (0, $LNQP4.default)();
    const mobile = variant === 'mobile';
    const S = $6b8cec43441c5f15$var$SIZES[variant] || $6b8cec43441c5f15$var$SIZES.web;
    const off = acceptDisabled || busy;
    const base = {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: S.gap,
        minHeight: S.minH,
        borderRadius: mobile ? 10 : 7,
        fontSize: S.font,
        fontFamily: 'inherit',
        padding: mobile ? '0.375rem 0.875rem' : '5px 12px',
        whiteSpace: 'nowrap'
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: mobile ? '0.5rem' : 8,
            flexWrap: 'wrap',
            paddingTop: mobile ? '0.625rem' : 9,
            borderTop: `1px solid ${(0, $jTCZr.CT).border}`
        }
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1
        }
    }), onDismiss && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onDismiss,
        "data-testid": dismissTestid,
        style: {
            ...base,
            fontWeight: 600,
            border: `1px solid ${(0, $jTCZr.CT).border}`,
            background: (0, $jTCZr.CT).surface,
            color: (0, $jTCZr.CT).ink2,
            cursor: 'pointer'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
        size: S.icon,
        "aria-hidden": true
    }), " ", dismissLabel || t(`${$6b8cec43441c5f15$var$K}.reject`)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onAccept,
        disabled: off,
        "data-testid": acceptTestid,
        style: {
            ...base,
            fontWeight: 700,
            border: `1px solid ${(0, $jTCZr.CT).accent}`,
            background: (0, $jTCZr.CT).accent,
            color: (0, $jTCZr.CT).surface,
            cursor: off ? 'not-allowed' : 'pointer',
            opacity: off ? 0.5 : 1
        }
    }, busy ? $6b8cec43441c5f15$var$spinner(S.icon) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
        size: S.icon,
        "aria-hidden": true
    }), " ", acceptLabel || t(`${$6b8cec43441c5f15$var$K}.accept`)));
}
function $6b8cec43441c5f15$export$f8baeb9beb7439e1({ steps: steps, current: current, next: next, onGo: onGo, variant: variant = 'web', testid: testid = 'visit-complete-guide' }) {
    const { t: t, formatNumber: formatNumber, isRTL: isRTL } = (0, $LNQP4.default)();
    if (!steps?.length) return null;
    const Forward = isRTL ? (0, $gKFEi.default) : (0, $kzPvP.default);
    const mobile = variant === 'mobile';
    const S = $6b8cec43441c5f15$var$SIZES[variant] || $6b8cec43441c5f15$var$SIZES.web;
    const fmt = (n)=>formatNumber ? formatNumber(n) : String(n);
    const waiting = steps.filter((s)=>!s.done).length;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testid,
        role: "status",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: mobile ? '0.5rem' : 8,
            flexShrink: 0,
            padding: mobile ? '0.375rem 0.875rem' : '6px 16px',
            background: (0, $jTCZr.CT).accentSoft,
            borderBottom: `1px solid ${(0, $jTCZr.CT).border}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        title: t(`${$6b8cec43441c5f15$var$K}.guide.title`, {
            n: fmt(waiting)
        }),
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 5,
            flexShrink: 0,
            fontSize: S.small,
            fontWeight: 700,
            color: (0, $jTCZr.CT).accentInk,
            whiteSpace: 'nowrap'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($6b8cec43441c5f15$export$70c07385940452eb, {
        size: S.icon
    }), !mobile && t(`${$6b8cec43441c5f15$var$K}.guide.title`, {
        n: fmt(waiting)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: 0,
            display: 'flex',
            alignItems: 'center',
            gap: mobile ? '0.375rem' : 6,
            overflowX: 'auto'
        }
    }, steps.map((s)=>{
        const on = s.id === current;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: s.id,
            type: "button",
            onClick: ()=>onGo?.(s.id),
            "data-testid": `${testid}-step-${s.id}`,
            "data-state": s.done ? 'done' : 'waiting',
            "aria-current": on ? 'step' : undefined,
            style: {
                display: 'inline-flex',
                alignItems: 'center',
                gap: 4,
                flexShrink: 0,
                whiteSpace: 'nowrap',
                minHeight: mobile ? '2.25rem' : undefined,
                padding: mobile ? '0.25rem 0.625rem' : '3px 9px',
                borderRadius: 999,
                border: `1px solid ${on ? (0, $jTCZr.CT).accent : (0, $jTCZr.CT).border}`,
                background: (0, $jTCZr.CT).surface,
                color: s.done ? (0, $jTCZr.CT).mute : (0, $jTCZr.CT).ink,
                fontSize: S.small,
                fontWeight: on ? 700 : 600,
                fontFamily: 'inherit',
                cursor: 'pointer'
            }
        }, s.done ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
            size: S.icon,
            "aria-hidden": true,
            style: {
                color: (0, $jTCZr.CT).good
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                minWidth: '1.3em',
                padding: '0 0.3em',
                borderRadius: 999,
                textAlign: 'center',
                background: (0, $jTCZr.CT).accent,
                color: (0, $jTCZr.CT).surface,
                fontSize: '0.9em'
            }
        }, fmt(s.count)), s.label);
    })), next && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: ()=>onGo?.(next.id),
        "data-testid": `${testid}-next`,
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 3,
            flexShrink: 0,
            whiteSpace: 'nowrap',
            minHeight: mobile ? '2.25rem' : undefined,
            padding: mobile ? '0.25rem 0.75rem' : '4px 11px',
            borderRadius: 999,
            border: `1px solid ${(0, $jTCZr.CT).accent}`,
            background: (0, $jTCZr.CT).accent,
            color: (0, $jTCZr.CT).surface,
            fontSize: S.small,
            fontWeight: 700,
            fontFamily: 'inherit',
            cursor: 'pointer'
        }
    }, t(`${$6b8cec43441c5f15$var$K}.guide.next`, {
        section: next.label
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Forward, {
        size: S.icon,
        "aria-hidden": true
    })));
}
function $6b8cec43441c5f15$export$45fe3bada8fd7008({ recState: recState = 'idle', recElapsed: recElapsed = 0, onToggle: onToggle, disabled: disabled = false, complete: complete = null, variant: variant = 'web', testid: testid = variant === 'mobile' ? 'visit-rec-toggle' : 'visit-monitoring-toggle' }) {
    const { t: t, formatDigits: formatDigits } = (0, $LNQP4.default)();
    const mobile = variant === 'mobile';
    const S = $6b8cec43441c5f15$var$SIZES[variant] || $6b8cec43441c5f15$var$SIZES.web;
    const digits = (s)=>formatDigits ? formatDigits(s) : s;
    const clock = digits(`${$6b8cec43441c5f15$var$pad(Math.floor(recElapsed / 60))}:${$6b8cec43441c5f15$var$pad(recElapsed % 60)}`);
    const recording = recState === 'recording';
    const stopping = recState === 'stopping';
    const connecting = recState === 'connecting';
    const paused = recState === 'paused-by-system';
    const error = recState === 'error';
    const off = disabled || stopping || connecting;
    let label = t('visit.listen.start');
    let Icon = (0, $hSPBf.default);
    // Idle is the invitation: the accent, soft. The two waiting states are neutral.
    let colors = {
        background: (0, $jTCZr.CT).accentSoft,
        color: (0, $jTCZr.CT).accentInk,
        borderColor: (0, $jTCZr.CT).accent
    };
    const neutral = {
        background: (0, $jTCZr.CT).surface,
        color: (0, $jTCZr.CT).ink2,
        borderColor: (0, $jTCZr.CT).border
    };
    if (recording) {
        label = t('visit.listen.stop');
        Icon = (0, $7udIf.default);
        colors = {
            background: (0, $jTCZr.CT).dangerSoft,
            color: (0, $jTCZr.CT).dangerInk,
            borderColor: (0, $jTCZr.CT).danger
        };
    } else if (connecting) {
        label = t('visit.record.connecting');
        Icon = (0, $hAUh5.default);
        colors = neutral;
    } else if (stopping) {
        label = t('visit.listen.stopping');
        Icon = (0, $7udIf.default);
        colors = neutral;
    } else if (paused) {
        label = t('visit.listen.resume');
        Icon = (0, $4gxLI.default);
        colors = {
            background: (0, $jTCZr.CT).warnSoft,
            color: (0, $jTCZr.CT).warnInk,
            borderColor: (0, $jTCZr.CT).warn
        };
    } else if (error) {
        label = t(mobile ? 'errors.connection.lostTap' : 'errors.connection.lostClick');
        Icon = (0, $bF8pu.default);
        colors = {
            background: (0, $jTCZr.CT).warnSoft,
            color: (0, $jTCZr.CT).warnInk,
            borderColor: (0, $jTCZr.CT).warn
        };
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "group",
        "aria-label": t('visit.copilot.monitoring'),
        "data-testid": "visit-monitoring-control",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: mobile ? '0.5rem' : 6,
            ...mobile ? {
                padding: '0.5rem 0.875rem',
                background: (0, $jTCZr.CT).surface,
                borderBottom: `1px solid ${(0, $jTCZr.CT).border}`
            } : {
                flexShrink: 0
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onToggle,
        disabled: off,
        "data-testid": testid,
        "data-state": recState,
        "aria-label": recording ? `${label} \u{2014} ${clock}` : label,
        title: label,
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: S.gap,
            flex: mobile ? 1 : undefined,
            minWidth: 0,
            minHeight: S.minH,
            padding: mobile ? '0.375rem 0.875rem' : '5px 11px',
            borderRadius: 999,
            border: `1px solid ${colors.borderColor}`,
            background: colors.background,
            color: colors.color,
            fontSize: mobile ? '0.875rem' : '0.75rem',
            fontWeight: 700,
            fontFamily: 'inherit',
            whiteSpace: 'nowrap',
            cursor: off ? 'default' : 'pointer',
            opacity: off ? 0.6 : 1
        }
    }, recording && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true,
        style: {
            width: 7,
            height: 7,
            borderRadius: '50%',
            background: (0, $jTCZr.CT).danger,
            flexShrink: 0,
            animation: 'pulse 1.6s infinite'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        size: mobile ? 16 : 13,
        "aria-hidden": true,
        className: connecting ? 'animate-spin motion-reduce:animate-none' : undefined,
        style: {
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    }, label), recording && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": mobile ? 'visit-rec-clock' : 'visit-monitoring-clock',
        style: {
            fontVariantNumeric: 'tabular-nums'
        }
    }, clock)), complete && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($6b8cec43441c5f15$export$5a0ca1724712239e, {
        tone: "solid",
        variant: variant,
        testid: "visit-complete-all",
        ...complete
    }));
}

});
parcelRegister("hAUh5", function(module, exports) {

$parcel$export(module.exports, "default", () => $3365fede8cd1121a$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $3365fede8cd1121a$export$a2387ed3b5d536eb = {
    name: "loader-circle",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M21 12a9 9 0 1 1-6.219-8.56",
                key: "13zald"
            }
        ]
    ],
    aliases: [
        "loader-2"
    ]
};
$3365fede8cd1121a$export$a2387ed3b5d536eb.node;
const $3365fede8cd1121a$export$2e2bcd8739ae039 = (0, $9QBug.default)($3365fede8cd1121a$export$a2387ed3b5d536eb);

});

parcelRegister("4gxLI", function(module, exports) {

$parcel$export(module.exports, "default", () => $b32d8b6368f72037$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $b32d8b6368f72037$export$a2387ed3b5d536eb = {
    name: "play",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z",
                key: "10ikf1"
            }
        ]
    ]
};
$b32d8b6368f72037$export$a2387ed3b5d536eb.node;
const $b32d8b6368f72037$export$2e2bcd8739ae039 = (0, $9QBug.default)($b32d8b6368f72037$export$a2387ed3b5d536eb);

});



parcelRegister("5kzaL", function(module, exports) {

$parcel$export(module.exports, "useMedicationProposals", () => $3e1a1a8acf34d11a$export$c779192d33323523);
// The «نسخه»'s three AI helpers, as one piece of state both Visit surfaces share
// (docs/VISIT_RX_AI_ASSIST.md). The screen supplies what the visit knows through
// `getContext()` — read at call time, so a run always sends the SOAP and نسخه as
// they are now — and receives the approved lines through `onApply`.
//
// One review at a time: starting a second source replaces the first list. The
// list is proposals only; closing it adds nothing.

var $acw62 = parcelRequire("acw62");

var $eVM84 = parcelRequire("eVM84");

var $c9qmv = parcelRequire("c9qmv");

var $1yr2B = parcelRequire("1yr2B");

var $bwSot = parcelRequire("bwSot");
// A proposal's candidates come back with their «در فهرست تأمین» (taminListed),
// which a line made from one keeps. Asked without it of a BFF that predates it:
// a validation error runs nothing, so the run is neither lost nor charged twice.
// The same for «تایید خودکار»'s fields (PM-0586): a BFF that predates them answers
// without, and nothing is confirmed by itself there.
const $3e1a1a8acf34d11a$var$askProposals = (0, $c9qmv.askWithoutTaminWhenRefused)((0, $c9qmv.askWithoutWhenRefused)((0, $eVM84.bffMutation), (0, $bwSot.withoutAutoConfirmFields)));
const $3e1a1a8acf34d11a$var$IDLE = {
    open: false,
    source: null,
    phase: 'idle',
    status: null,
    rows: [],
    error: null
};
function $3e1a1a8acf34d11a$export$c779192d33323523({ getContext: getContext, chargeVisit: chargeVisit, chargeLabel: chargeLabel, onCreditError: onCreditError, onApply: onApply, autoConfirm: autoConfirm = false, onAutoConfirm: onAutoConfirm }) {
    const [review, setReview] = (0, $acw62.useState)($3e1a1a8acf34d11a$var$IDLE);
    // A slow answer to a run the doctor already replaced or closed must not reopen it.
    const runRef = (0, $acw62.useRef)(0);
    const deps = (0, $acw62.useRef)({});
    deps.current = {
        getContext: getContext,
        chargeVisit: chargeVisit,
        chargeLabel: chargeLabel,
        onCreditError: onCreditError,
        onApply: onApply,
        autoConfirm: autoConfirm,
        onAutoConfirm: onAutoConfirm
    };
    // What a row is checked against: the نسخه and allergies as they are NOW.
    const reviewCtx = ()=>{
        const ctx = deps.current.getContext?.() || {};
        const allergies = (ctx.patient?.clinicalAllergies || []).map((a)=>a?.allergen).filter(Boolean);
        return {
            rxItems: ctx.rxItems || [],
            allergies: allergies
        };
    };
    /**
   * → 'found' | 'none' | 'known' | 'auto' | 'error' (undefined when a newer run
   * replaced this one). 'known': every row is already on the نسخه and the run was
   * still charged — nothing to add, but not «nothing found, no charge» either.
   * 'auto': everything new was added by «تایید خودکار», nothing waits.
   */ const run = (0, $acw62.useCallback)(async (source, extra = {})=>{
        const runId = ++runRef.current;
        const ctx = {
            ...deps.current.getContext?.() || {},
            ...extra
        };
        setReview({
            ...$3e1a1a8acf34d11a$var$IDLE,
            open: true,
            source: source,
            phase: 'loading'
        });
        try {
            // Long budget (PM-0069): the server re-reads the whole visit transcript, so
            // a long visit outlives the 30 s default and the client gave up on a run
            // the server was still finishing (and might still charge for).
            const data = await $3e1a1a8acf34d11a$var$askProposals((0, $bwSot.PROPOSE_MEDICATIONS), {
                input: (0, $bwSot.buildProposalInput)(source, ctx)
            }, {
                timeoutMs: (0, $eVM84.LONG_REQUEST_TIMEOUT_MS)
            });
            if (runRef.current !== runId) return undefined;
            const result = data?.proposeMedications || {
                status: 'none_found',
                charged: false,
                proposals: []
            };
            const { action: action, ledgerId: ledgerId } = (0, $bwSot.PROPOSAL_PRICING)[source];
            // The server's `charged` is the signal, never the click: an empty run is free.
            if (result.charged) deps.current.chargeVisit?.((0, $1yr2B.costOf)(action), ledgerId, deps.current.chargeLabel?.(source));
            const ctxNow = reviewCtx();
            let rows = (0, $bwSot.markInRxRows)((0, $bwSot.buildReviewRows)(result.proposals, ctxNow), ctxNow);
            // «تایید خودکار» (PM-0586): what the service marked goes on the نسخه by itself —
            // read now, against this visit only.
            const a = deps.current.autoConfirm;
            const now = deps.current.getContext?.() || {};
            let added = [];
            if (source !== (0, $bwSot.PROPOSAL_SOURCES).HISTORY && (typeof a === 'function' ? a() : !!a) && String(now.appointmentId || '') === String(ctx.appointmentId || '')) {
                const auto = (0, $bwSot.autoConfirmableRows)(rows, ctxNow);
                if (auto.length) {
                    try {
                        added = await deps.current.onAutoConfirm?.(source, auto) || [];
                    } catch (err) {
                        console.warn('[rxAssist] auto-confirm failed:', err);
                    }
                    if (runRef.current !== runId) return undefined;
                }
            }
            rows = rows.filter((r)=>!added.includes(r.key));
            if (added.length && !rows.some((r)=>!r.known)) {
                setReview($3e1a1a8acf34d11a$var$IDLE);
                return 'auto';
            }
            setReview({
                open: true,
                source: source,
                phase: 'ready',
                status: result.status,
                error: null,
                rows: rows
            });
            if (rows.some((r)=>!r.known)) return 'found';
            return rows.length && result.charged ? 'known' : 'none';
        } catch (e) {
            if (runRef.current !== runId) return undefined;
            const credit = e?.extensions?.code === 'INSUFFICIENT_CREDITS';
            if (credit) deps.current.onCreditError?.(e.message);
            setReview({
                ...$3e1a1a8acf34d11a$var$IDLE,
                open: true,
                source: source,
                phase: 'error',
                error: credit ? 'credit' : 'failed'
            });
            return 'error';
        }
    }, []);
    const close = (0, $acw62.useCallback)(()=>{
        runRef.current += 1;
        setReview($3e1a1a8acf34d11a$var$IDLE);
    }, []);
    // «تایید خودکار» undone (PM-0586): the row waits in the review again, ticked as a
    // decided drug is, for «تأیید» — never added by itself a second time.
    const restore = (0, $acw62.useCallback)((source, row)=>{
        if (!row) return;
        setReview((r)=>{
            const open = r.phase === 'ready' && r.source === source;
            const rows = open ? r.rows.filter((x)=>x.key !== row.key) : [];
            return {
                open: true,
                source: source,
                phase: 'ready',
                status: 'ok',
                error: null,
                rows: [
                    {
                        ...row,
                        key: `${row.key}-undo-${Date.now()}`,
                        checked: true,
                        restored: true
                    },
                    ...rows
                ]
            };
        });
    }, []);
    const toggle = (0, $acw62.useCallback)((key)=>{
        setReview((r)=>({
                ...r,
                rows: (0, $bwSot.toggleRow)(r.rows, key, reviewCtx())
            }));
    }, []);
    const choose = (0, $acw62.useCallback)((key, drugId)=>{
        setReview((r)=>({
                ...r,
                rows: (0, $bwSot.chooseCandidate)(r.rows, key, drugId, reviewCtx())
            }));
    }, []);
    const setAll = (0, $acw62.useCallback)((checked)=>{
        setReview((r)=>({
                ...r,
                rows: (0, $bwSot.setAllRows)(r.rows, checked, reviewCtx())
            }));
    }, []);
    const apply = (0, $acw62.useCallback)(()=>{
        const lines = (0, $bwSot.rowsToApply)(review.rows, reviewCtx());
        if (!lines.length) return 0;
        deps.current.onApply?.(lines, review.source);
        close();
        return lines.length;
    }, [
        review,
        close
    ]);
    // Shown against the نسخه as it is now: a drug added by hand while the review is
    // open turns «در نسخه» and stops waiting.
    const rows = (0, $bwSot.markInRxRows)(review.rows, reviewCtx());
    return {
        review: rows === review.rows ? review : {
            ...review,
            rows: rows
        },
        run: run,
        close: close,
        toggle: toggle,
        choose: choose,
        setAll: setAll,
        apply: apply,
        restore: restore
    };
}

});

parcelRegister("4SCt2", function(module, exports) {

$parcel$export(module.exports, "default", () => $a77297e82307ffaa$export$2e2bcd8739ae039);
// What «تکمیل» read from «پایش بالینی» for ONE group — علائم حیاتی, دستورات or
// اطلاعات پرونده — as the proposal card of the section it fills (PM-0029, PM-0038).
// The same card on both surfaces; `variant` only sizes it.
//
// Nothing here writes. Each row is a finding with the words it was read from; the
// doctor ticks, and «تأیید» hands the ticked ones to the screen, which writes each
// through the path a hand-entered value takes. A finding the visit already holds
// (`row.known` — an order already placed, a vital sign already recorded) reads
// «در این ویزیت ثبت شده», like the نسخه's «در نسخه», and cannot be ticked.
//
// A heard lab, imaging study or procedure also says which catalogue entry it will
// be saved as (`row.catalog`, lib/monitoringExtraction): the one entry named
// exactly like it, or a short list from the picker's search for the doctor to
// pick from — or their explicit «ثبت بدون کد». «تأیید» waits for that choice.

var $acw62 = parcelRequire("acw62");

var $huNwV = parcelRequire("huNwV");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $b4nOl = parcelRequire("b4nOl");

var $dXWAH = parcelRequire("dXWAH");
const $a77297e82307ffaa$var$SIZES = {
    web: {
        body: '0.78125rem',
        meta: '0.65625rem',
        pad: '8px 10px',
        gap: 6,
        radius: 8,
        checkbox: undefined
    },
    mobile: {
        body: '0.875rem',
        meta: '0.75rem',
        pad: '0.625rem 0.75rem',
        gap: 8,
        radius: 10,
        checkbox: '1.125rem'
    }
};
const $a77297e82307ffaa$var$K = 'visit.monitoringExtract';
function $a77297e82307ffaa$var$Badge({ tone: tone = 'mute', children: children }) {
    const tones = {
        warn: [
            (0, $jTCZr.CT).warnSoft,
            (0, $jTCZr.CT).warnInk
        ],
        mute: [
            (0, $jTCZr.CT).surface2,
            (0, $jTCZr.CT).ink2
        ],
        accent: [
            (0, $jTCZr.CT).accentSoft,
            (0, $jTCZr.CT).accentInk
        ],
        danger: [
            (0, $jTCZr.CT).dangerSoft,
            (0, $jTCZr.CT).dangerInk
        ],
        good: [
            (0, $jTCZr.CT).goodSoft,
            (0, $jTCZr.CT).goodInk
        ]
    };
    const [bg, fg] = tones[tone] || tones.mute;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            padding: '1px 7px',
            borderRadius: 999,
            fontSize: '0.92em',
            fontWeight: 600,
            background: bg,
            color: fg,
            whiteSpace: 'nowrap'
        }
    }, children);
}
/** What a finding is, as the row's first line. */ function $a77297e82307ffaa$var$findingTitle(f, t) {
    if (f.group === 'vitals') return `${t(`${$a77297e82307ffaa$var$K}.vital.${f.kind}`)}: ${(0, $b4nOl.vitalValue)(f)}`;
    return f.text;
}
const $a77297e82307ffaa$var$linkStyle = (S)=>({
        background: 'none',
        border: 'none',
        padding: 0,
        cursor: 'pointer',
        fontFamily: 'inherit',
        fontSize: S.meta,
        fontWeight: 600,
        color: (0, $jTCZr.CT).accentInk
    });
const $a77297e82307ffaa$var$codeOf = (e)=>e?.code ? `${e.codeSystem || ''} ${e.code}`.trim() : '';
/** Which catalogue entry a heard order will be saved as — and the choice when it is not settled. */ function $a77297e82307ffaa$var$CatalogChoice({ row: row, S: S, onCatalog: onCatalog, testid: testid }) {
    const { t: t } = (0, $LNQP4.default)();
    const c = row.catalog;
    if (!c || row.known) return null;
    const id = `${testid}-catalog-${row.key}`;
    const note = {
        fontSize: S.meta,
        color: (0, $jTCZr.CT).ink2,
        lineHeight: 1.7
    };
    const line = {
        ...note,
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        flexWrap: 'wrap'
    };
    if (c.state === 'pending') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": id,
        "data-state": "pending",
        style: note
    }, t(`${$a77297e82307ffaa$var$K}.catalog.finding`));
    if (c.state === 'linked') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": id,
        "data-state": "linked",
        style: line
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
        size: 12,
        "aria-hidden": true,
        style: {
            color: (0, $jTCZr.CT).goodInk,
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, t(`${$a77297e82307ffaa$var$K}.catalog.linked`)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            color: (0, $jTCZr.CT).ink,
            fontWeight: 600
        }
    }, c.entry?.name), $a77297e82307ffaa$var$codeOf(c.entry) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "ltr"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a77297e82307ffaa$var$Badge, {
        tone: "good"
    }, $a77297e82307ffaa$var$codeOf(c.entry))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        style: $a77297e82307ffaa$var$linkStyle(S),
        onClick: ()=>onCatalog?.(row.key, null),
        "data-testid": `${id}-change`
    }, t(`${$a77297e82307ffaa$var$K}.catalog.change`)));
    if (c.state === 'free') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": id,
        "data-state": "free",
        style: line
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, t(`${$a77297e82307ffaa$var$K}.catalog.freeChosen`)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        style: $a77297e82307ffaa$var$linkStyle(S),
        onClick: ()=>onCatalog?.(row.key, null),
        "data-testid": `${id}-pick`
    }, t(`${$a77297e82307ffaa$var$K}.catalog.pick`)));
    const waiting = (0, $b4nOl.awaitingCatalogChoice)(row);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": id,
        "data-state": "choose",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 4
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            ...note,
            color: waiting ? (0, $jTCZr.CT).warnInk : (0, $jTCZr.CT).ink2
        }
    }, c.candidates.length ? t(`${$a77297e82307ffaa$var$K}.catalog.choose`) : t(c.failed ? `${$a77297e82307ffaa$var$K}.catalog.searchFailed` : `${$a77297e82307ffaa$var$K}.catalog.notFound`)), c.candidates.map((e, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: e.id || e.name,
            type: "button",
            onClick: ()=>onCatalog?.(row.key, e),
            "data-testid": `${id}-option-${i}`,
            style: {
                display: 'flex',
                alignItems: 'baseline',
                gap: 8,
                flexWrap: 'wrap',
                textAlign: 'start',
                padding: '4px 8px',
                borderRadius: 6,
                border: `1px solid ${(0, $jTCZr.CT).border}`,
                background: (0, $jTCZr.CT).surface2,
                cursor: 'pointer',
                fontFamily: 'inherit',
                fontSize: S.meta,
                color: (0, $jTCZr.CT).ink
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "auto",
            style: {
                fontWeight: 600
            }
        }, e.name), e.nameEn && e.nameEn !== e.name && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "ltr",
            style: {
                color: (0, $jTCZr.CT).ink2
            }
        }, e.nameEn), $a77297e82307ffaa$var$codeOf(e) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "ltr",
            style: {
                color: (0, $jTCZr.CT).ink2
            }
        }, $a77297e82307ffaa$var$codeOf(e)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        style: $a77297e82307ffaa$var$linkStyle(S),
        onClick: ()=>onCatalog?.(row.key, 'free'),
        "data-testid": `${id}-free`
    }, t(`${$a77297e82307ffaa$var$K}.catalog.free`))));
}
function $a77297e82307ffaa$var$FindingRow({ row: row, S: S, onToggle: onToggle, onCatalog: onCatalog, testid: testid }) {
    const { t: t } = (0, $LNQP4.default)();
    const f = row.finding;
    const urgent = f.group === 'orders' && f.urgency && f.urgency !== 'routine';
    const known = !!row.known;
    // The catalogue choice sits under the row, outside its label: pressing a
    // candidate must never tick or untick the finding.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 6,
            padding: S.pad,
            borderRadius: S.radius,
            border: `1px solid ${row.checked ? (0, $jTCZr.CT).accent : (0, $jTCZr.CT).border}`,
            background: (0, $jTCZr.CT).surface,
            opacity: known ? 0.7 : 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        "data-testid": `${testid}-row-${row.key}`,
        "data-kind": f.kind,
        "data-known": known ? 'true' : 'false',
        style: {
            display: 'flex',
            gap: 8,
            alignItems: 'flex-start',
            cursor: known ? 'default' : 'pointer'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        type: "checkbox",
        checked: row.checked && !known,
        disabled: known,
        onChange: ()=>onToggle(row.key),
        "data-testid": `${testid}-check-${row.key}`,
        style: {
            marginTop: 3,
            width: S.checkbox,
            height: S.checkbox,
            accentColor: (0, $jTCZr.CT).accent,
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 3,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            flexWrap: 'wrap',
            fontSize: S.body,
            fontWeight: 600,
            color: (0, $jTCZr.CT).ink
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto"
    }, $a77297e82307ffaa$var$findingTitle(f, t)), f.group !== 'vitals' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a77297e82307ffaa$var$Badge, null, t(`${$a77297e82307ffaa$var$K}.kind.${f.kind}`)), urgent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a77297e82307ffaa$var$Badge, {
        tone: "warn"
    }, t(`${$a77297e82307ffaa$var$K}.urgency.${f.urgency}`)), f.kind === 'follow_up' && f.value && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a77297e82307ffaa$var$Badge, {
        tone: "accent"
    }, t(`${$a77297e82307ffaa$var$K}.inDays`, {
        n: f.value
    })), known && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a77297e82307ffaa$var$Badge, {
        tone: "good"
    }, t(`${$a77297e82307ffaa$var$K}.onVisit`))), f.detail && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: "auto",
        style: {
            fontSize: S.meta,
            color: (0, $jTCZr.CT).ink2,
            lineHeight: 1.7
        }
    }, f.detail), f.evidence && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: "auto",
        style: {
            fontSize: S.meta,
            color: (0, $jTCZr.CT).ink2,
            lineHeight: 1.7
        }
    }, t(`${$a77297e82307ffaa$var$K}.heard`, {
        text: f.evidence
    })))), row.catalog && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            paddingInlineStart: 22
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a77297e82307ffaa$var$CatalogChoice, {
        row: row,
        S: S,
        onCatalog: onCatalog,
        testid: testid
    })));
}
function $a77297e82307ffaa$var$Body({ group: group, review: review, S: S, onToggle: onToggle, onCatalog: onCatalog, onRetry: onRetry, testid: testid }) {
    const { t: t } = (0, $LNQP4.default)();
    const { phase: phase, rows: rows, status: status, error: error } = review;
    const note = {
        fontSize: S.meta,
        color: (0, $jTCZr.CT).ink2,
        lineHeight: 1.7
    };
    if (phase === 'loading') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${testid}-loading`,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            fontSize: S.meta,
            color: (0, $jTCZr.CT).ink2
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: 11,
            height: 11,
            border: `1.5px solid ${(0, $jTCZr.CT).border}`,
            borderTopColor: (0, $jTCZr.CT).accent,
            borderRadius: '50%',
            animation: 'spin .7s linear infinite',
            flexShrink: 0
        }
    }), t(`${$a77297e82307ffaa$var$K}.loading`));
    if (phase === 'error') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${testid}-error`,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            flexWrap: 'wrap',
            fontSize: S.meta,
            color: (0, $jTCZr.CT).dangerInk
        }
    }, t(error === 'credit' ? `${$a77297e82307ffaa$var$K}.error.credit` : `${$a77297e82307ffaa$var$K}.error.failed`), error !== 'credit' && onRetry && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onRetry,
        "data-testid": `${testid}-retry`,
        style: {
            background: 'none',
            border: 'none',
            padding: 0,
            cursor: 'pointer',
            fontFamily: 'inherit',
            fontSize: S.meta,
            fontWeight: 600,
            color: (0, $jTCZr.CT).accentInk,
            textDecoration: 'underline'
        }
    }, t('common.actions.retry')));
    if (!rows.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${testid}-empty`,
        "data-status": status,
        style: note
    }, t(status === 'no_transcript' ? `${$a77297e82307ffaa$var$K}.empty.noTranscript` : `${$a77297e82307ffaa$var$K}.empty.${group}`));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${testid}-list`,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: S.gap
        }
    }, rows.map((row)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a77297e82307ffaa$var$FindingRow, {
            key: row.key,
            row: row,
            S: S,
            onToggle: onToggle,
            onCatalog: onCatalog,
            testid: testid
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: note
    }, t(`${$a77297e82307ffaa$var$K}.hint.${group}`)), error === 'apply' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${testid}-apply-error`,
        style: {
            ...note,
            color: (0, $jTCZr.CT).dangerInk
        }
    }, t(`${$a77297e82307ffaa$var$K}.error.apply`)));
}
function $a77297e82307ffaa$export$2e2bcd8739ae039({ group: group, review: review, variant: variant = 'web', onToggle: onToggle, onSetAll: onSetAll, onApply: onApply, onClose: onClose, onRetry: onRetry, onCatalog: onCatalog, style: style, testid: testid = `visit-complete-${String(group).toLowerCase()}` }) {
    const { t: t, formatNumber: formatNumber } = (0, $LNQP4.default)();
    if (!review?.open) return null;
    const S = $a77297e82307ffaa$var$SIZES[variant] || $a77297e82307ffaa$var$SIZES.web;
    const fmt = (n)=>formatNumber ? formatNumber(n) : String(n);
    const picked = review.rows.filter((r)=>r.checked && !r.known).length;
    // Ticked orders still waiting for their catalogue entry: «تأیید» waits with them.
    const waiting = review.rows.filter((0, $b4nOl.awaitingCatalogChoice)).length;
    const link = $a77297e82307ffaa$var$linkStyle(S);
    const footer = review.phase === 'ready' && review.rows.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dXWAH.ProposalActions), {
        variant: variant,
        testid: testid,
        onAccept: onApply,
        acceptDisabled: !picked || waiting > 0,
        busy: review.applying,
        acceptLabel: t('visit.complete.acceptN', {
            n: fmt(picked)
        }),
        onDismiss: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: S.meta,
            color: (0, $jTCZr.CT).ink2
        },
        "data-testid": `${testid}-count`
    }, t('visit.rxAssist.selectedOf', {
        n: fmt(picked),
        total: fmt(review.rows.length)
    })), waiting > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: S.meta,
            color: (0, $jTCZr.CT).warnInk
        },
        "data-testid": `${testid}-waiting`
    }, t(`${$a77297e82307ffaa$var$K}.catalog.waiting`, {
        n: fmt(waiting)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        style: link,
        onClick: ()=>onSetAll(true),
        "data-testid": `${testid}-all`
    }, t('visit.rxAssist.selectAll')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        style: link,
        onClick: ()=>onSetAll(false),
        "data-testid": `${testid}-none`
    }, t('visit.rxAssist.selectNone'))) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dXWAH.ProposalCard), {
        variant: variant,
        testid: testid,
        "data-group": group,
        "data-status": review.status || review.phase,
        title: t(`${$a77297e82307ffaa$var$K}.group.${group}`),
        onClose: onClose,
        footer: footer,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a77297e82307ffaa$var$Body, {
        group: group,
        review: review,
        S: S,
        onToggle: onToggle,
        onCatalog: onCatalog,
        onRetry: onRetry,
        testid: testid
    }));
}

});
parcelRegister("b4nOl", function(module, exports) {

$parcel$export(module.exports, "EXTRACT_MONITORING", () => $80f289cb339918db$export$1047922e50d45b96);
$parcel$export(module.exports, "withoutAutoConfirmFindingFields", () => $80f289cb339918db$export$7e256835b64f2cf3);
$parcel$export(module.exports, "EXTRACTION_GROUPS", () => $80f289cb339918db$export$16054fa089fae9a7);
$parcel$export(module.exports, "EXTRACTION_PRICING", () => $80f289cb339918db$export$a7f2f1cb3a3e0344);
$parcel$export(module.exports, "buildExtractionInput", () => $80f289cb339918db$export$a60a48c0701dddbf);
$parcel$export(module.exports, "visitHoldings", () => $80f289cb339918db$export$7ae37be9d0ec5cca);
$parcel$export(module.exports, "heldByVisit", () => $80f289cb339918db$export$94302b4dd2f2e4e7);
$parcel$export(module.exports, "buildFindingRows", () => $80f289cb339918db$export$860f2bf2c98c63a4);
$parcel$export(module.exports, "markHeldRows", () => $80f289cb339918db$export$d41f702336c09e8f);
$parcel$export(module.exports, "toggleFindingRow", () => $80f289cb339918db$export$2164ecbb0f5578b7);
$parcel$export(module.exports, "setAllFindingRows", () => $80f289cb339918db$export$c4c19acf0e1cd628);
$parcel$export(module.exports, "findingsToApply", () => $80f289cb339918db$export$4c5f4dc82f210788);
$parcel$export(module.exports, "needsCatalogLookup", () => $80f289cb339918db$export$f0279dbb8aaf3182);
$parcel$export(module.exports, "catalogStateOf", () => $80f289cb339918db$export$c8e0648bbd3956bd);
$parcel$export(module.exports, "awaitingCatalogChoice", () => $80f289cb339918db$export$65c4d13db359029b);
$parcel$export(module.exports, "chooseCatalogRow", () => $80f289cb339918db$export$998c598c6be6e5b2);
$parcel$export(module.exports, "vitalsFormPatch", () => $80f289cb339918db$export$40b6415e2650a54e);
$parcel$export(module.exports, "vitalObservations", () => $80f289cb339918db$export$9987edde8f07e80c);
$parcel$export(module.exports, "autoConfirmableOrders", () => $80f289cb339918db$export$3c008fd1874e1122);
$parcel$export(module.exports, "autoConfirmableVitals", () => $80f289cb339918db$export$feaf66f5ef89d875);
$parcel$export(module.exports, "vitalsFormValue", () => $80f289cb339918db$export$c9fb3d547efbe8a9);
$parcel$export(module.exports, "vitalsFormClear", () => $80f289cb339918db$export$361af805d18cfd90);
$parcel$export(module.exports, "vitalValue", () => $80f289cb339918db$export$2e0352eb98b59734);
$parcel$export(module.exports, "orderItemOf", () => $80f289cb339918db$export$33ef048cffb1af5d);
$parcel$export(module.exports, "followUpLines", () => $80f289cb339918db$export$3e993be304a3ed8f);
$parcel$export(module.exports, "appendFollowUps", () => $80f289cb339918db$export$6a1840833052c978);
// «پایش بالینی» beyond the نسخه (PM-0029): the visit's transcript read three more
// ways — علائم حیاتی, دستورات, اطلاعات پرونده — each its own AI service and price.
// The drugs prescribed in the conversation are the fourth reading and live in
// lib/medicationProposals.js.
//
// Everything comes back as FINDINGS the doctor ticks. Nothing reaches the record
// until «ثبت موارد انتخاب‌شده»; each kind is then written through the path a
// hand-entered value takes — the vitals form, the order list, the record's own
// mutations, the «P» of the note.
//
// The AI service has already dropped what is implausible (a vital sign outside the
// physical range) and what the record already holds (allergies, current drugs,
// conditions); what THIS VISIT already holds — its orders and recorded vitals — is
// marked here (visitHoldings). This module is pure (no
// React): which rows start ticked and how a finding becomes a form value live here,
// so both surfaces and the tests read one copy.
// «تایید خودکار» (PM-0586): an order's status and search terms, the AI service's score
// and the catalogue row it picked. A BFF that predates them is asked without.
const $80f289cb339918db$export$147ada609668aaaa = `
        status standardName searchTerms autoScore autoConfirm autoEntry { id name orderType code }`;
const $80f289cb339918db$export$1047922e50d45b96 = `
  mutation ExtractMonitoring($input: MonitoringExtractionInput!) {
    extractMonitoring(input: $input) {
      status charged
      findings { group kind text value value2 unit detail urgency evidence confidence${$80f289cb339918db$export$147ada609668aaaa}
      }
    }
  }
`;
const $80f289cb339918db$export$7e256835b64f2cf3 = (q)=>q.replace($80f289cb339918db$export$147ada609668aaaa, '');
const $80f289cb339918db$export$16054fa089fae9a7 = Object.freeze([
    'VITALS',
    'ORDERS',
    'RECORD'
]);
const $80f289cb339918db$export$a7f2f1cb3a3e0344 = Object.freeze({
    VITALS: {
        action: 'MONITORING_VITALS',
        ledgerId: 'monitoringVitals'
    },
    ORDERS: {
        action: 'MONITORING_ORDERS',
        ledgerId: 'monitoringOrders'
    },
    RECORD: {
        action: 'MONITORING_RECORD',
        ledgerId: 'monitoringRecord'
    }
});
// The newest part of a long visit is where the decisions are; the server reads its
// own copy first and this is only the fallback.
const $80f289cb339918db$var$TRANSCRIPT_TAIL = 12000;
// Below this the model was not sure the transcript says it: shown, not ticked.
const $80f289cb339918db$var$TICK_MIN_CONFIDENCE = 0.6;
const $80f289cb339918db$var$text = (v)=>String(v ?? '').trim();
const $80f289cb339918db$var$names = (list, pick)=>(list || []).map(pick).map($80f289cb339918db$var$text).filter(Boolean);
function $80f289cb339918db$export$a60a48c0701dddbf(group, ctx = {}) {
    const patient = ctx.patient || {};
    return {
        group: group,
        appointmentId: ctx.appointmentId || '',
        patientId: patient.id || null,
        utterance: $80f289cb339918db$var$text(ctx.transcript).slice(-$80f289cb339918db$var$TRANSCRIPT_TAIL),
        // null = unknown — never 0, which the model reads as a newborn.
        age: patient.age ?? null,
        gender: patient.gender || '',
        knownAllergies: $80f289cb339918db$var$names(patient.clinicalAllergies, (a)=>a?.allergen),
        currentMedications: $80f289cb339918db$var$names((patient.clinicalMedications || []).filter((m)=>m?.status === 'active'), (m)=>m?.display),
        knownConditions: $80f289cb339918db$var$names(patient.clinicalConditions, (c)=>c?.display)
    };
}
// ── what the visit already holds ────────────────────────────────────────────
//
// Every «تکمیل» re-reads the WHOLE transcript, so a second run hears the CBC the
// first one already ordered and the respiratory rate already recorded, and offered
// them again, ticked: «تأیید» then wrote a second order and a second observation.
// A finding the visit already holds is now a row like the نسخه's «در نسخه» —
// shown, never ticked, never written, never counted as waiting. The service cannot
// leave it out itself: its request carries no orders and no vitals.
// Spellings that render alike: Persian/Arabic digits, Arabic yeh and kaf, ZWNJ and
// spacing, letter case — «CBC» and «cbc», «سونوگرافی‌شکم» and «سونوگرافی شکم».
const $80f289cb339918db$var$foldKey = (v)=>$80f289cb339918db$var$text(v).replace(/[۰-۹]/g, (d)=>String(d.charCodeAt(0) - 0x06f0)).replace(/[٠-٩]/g, (d)=>String(d.charCodeAt(0) - 0x0660)).replace(/[يى]/g, "\u06CC").replace(/ك/g, "\u06A9").replace(/[\s‌‍]+/g, '').toLowerCase();
// «36.5» and «36.50» are one reading.
const $80f289cb339918db$var$valueKey = (v)=>{
    const key = $80f289cb339918db$var$foldKey(v).replace(/٫/g, '.');
    return key && Number.isFinite(Number(key)) ? String(Number(key)) : key;
};
// The code each vital sign is recorded under: the vitals form's (Visit.shared
// VITAL_FIELD_CODES) and OBSERVATION's below. A blood pressure is two rows.
const $80f289cb339918db$var$VITAL_CODES = {
    bp: [
        '8480-6',
        '8462-4'
    ],
    pulse: [
        '8867-4'
    ],
    spo2: [
        '59408-5'
    ],
    temp: [
        '8310-5'
    ],
    weight: [
        '29463-7'
    ],
    resp: [
        '9279-1'
    ],
    height: [
        '8302-2'
    ],
    glucose: [
        '2339-0'
    ]
};
function $80f289cb339918db$export$7ae37be9d0ec5cca(ctx = {}) {
    const ids = new Set([
        ctx.encounterId,
        ctx.appointmentId
    ].filter(Boolean).map(String));
    return {
        orders: (ctx.orders || []).filter((o)=>o && o.status !== 'cancelled'),
        observations: (ctx.patient?.clinicalObservations || []).filter((o)=>o?.appointmentId && ids.has(String(o.appointmentId)))
    };
}
function $80f289cb339918db$export$94302b4dd2f2e4e7(f, holdings, group = f?.group) {
    if (!f || !holdings) return false;
    const g = String(group || '').toLowerCase();
    if (g === 'orders') {
        const names = [
            f.text,
            f.catalogName
        ].map($80f289cb339918db$var$foldKey).filter(Boolean);
        return (holdings.orders || []).some((o)=>{
            if (f.catalogId && o.catalogId && String(f.catalogId) === String(o.catalogId)) return true;
            if (f.code && o.code) return $80f289cb339918db$var$foldKey(f.code) === $80f289cb339918db$var$foldKey(o.code);
            return names.includes($80f289cb339918db$var$foldKey(o.description));
        });
    }
    if (g === 'vitals') {
        const codes = $80f289cb339918db$var$VITAL_CODES[f.kind];
        const values = f.kind === 'bp' ? [
            f.value,
            f.value2
        ] : [
            f.value
        ];
        return !!codes && codes.every((code, i)=>(holdings.observations || []).some((o)=>o.code === code && $80f289cb339918db$var$valueKey(o.value) === $80f289cb339918db$var$valueKey(values[i])));
    }
    return false;
}
function $80f289cb339918db$export$860f2bf2c98c63a4(group, findings, holdings) {
    return (findings || []).map((finding, i)=>{
        const known = $80f289cb339918db$export$94302b4dd2f2e4e7(finding, holdings, group);
        return {
            key: `${group}-${i}`,
            group: group,
            finding: finding,
            known: known,
            checked: !known && Number(finding?.confidence) >= $80f289cb339918db$var$TICK_MIN_CONFIDENCE
        };
    });
}
function $80f289cb339918db$export$d41f702336c09e8f(rows, holdings) {
    let changed = false;
    const next = (rows || []).map((r)=>{
        const known = $80f289cb339918db$export$94302b4dd2f2e4e7($80f289cb339918db$export$e8abafe383e20726(r), holdings, r.group);
        if (known === !!r.known) return r;
        changed = true;
        return {
            ...r,
            known: known,
            checked: r.checked && !known
        };
    });
    return changed ? next : rows;
}
const $80f289cb339918db$export$2164ecbb0f5578b7 = (rows, key)=>(rows || []).map((r)=>r.key === key && !r.known ? {
            ...r,
            checked: !r.checked
        } : r);
const $80f289cb339918db$export$c4c19acf0e1cd628 = (rows, checked)=>(rows || []).map((r)=>r.checked === checked || checked && r.known ? r : {
            ...r,
            checked: checked
        });
function $80f289cb339918db$export$4c5f4dc82f210788(rows) {
    const out = {
        vitals: [],
        orders: [],
        record: []
    };
    (rows || []).filter((r)=>r.checked && !r.known).forEach((r)=>{
        const bucket = out[String(r.finding?.group || r.group).toLowerCase()];
        if (bucket) bucket.push($80f289cb339918db$export$e8abafe383e20726(r));
    });
    return out;
}
const $80f289cb339918db$export$77d99fb6a2c44f1b = Object.freeze([
    'lab',
    'imaging',
    'procedure'
]);
const $80f289cb339918db$var$CATALOG_CANDIDATES = 5;
const $80f289cb339918db$export$f0279dbb8aaf3182 = (f)=>String(f?.group || '').toLowerCase() === 'orders' && $80f289cb339918db$export$77d99fb6a2c44f1b.includes(f?.kind);
// Every name a catalogue row carries — `name`, `nameEn` and the translations
// Visit.shared's CATALOG_NAME_FIELD lists: the AI names what it heard in the
// visit's language or the doctor's, and an Arabic, French or German name is as
// exact a match as the Persian one. Still one hit per ROW, so a row matched by
// two of its names is one entry, not an ambiguity.
const $80f289cb339918db$var$CATALOG_NAME_KEYS = Object.freeze([
    'name',
    'nameEn',
    'nameAr',
    'nameFr',
    'nameDe'
]);
function $80f289cb339918db$export$1f55bc41f83183ff(f, entries) {
    const want = $80f289cb339918db$var$foldKey(f?.text);
    if (!want) return null;
    const hits = new Map();
    (entries || []).forEach((e)=>{
        if (!e || e.orderType && e.orderType !== f.kind) return;
        if ($80f289cb339918db$var$CATALOG_NAME_KEYS.some((k)=>$80f289cb339918db$var$foldKey(e[k]) === want)) hits.set(e.id ?? e.name, e);
    });
    return hits.size === 1 ? [
        ...hits.values()
    ][0] : null;
}
function $80f289cb339918db$export$c8e0648bbd3956bd(f, entries) {
    const candidates = (entries || []).filter((e)=>e && (!e.orderType || e.orderType === f?.kind)).slice(0, $80f289cb339918db$var$CATALOG_CANDIDATES);
    const match = $80f289cb339918db$export$1f55bc41f83183ff(f, entries);
    return match ? {
        state: 'linked',
        entry: match,
        auto: true,
        candidates: candidates
    } : {
        state: 'choose',
        entry: null,
        auto: false,
        candidates: candidates
    };
}
function $80f289cb339918db$export$e8abafe383e20726(row) {
    const f = row?.finding;
    const e = row?.catalog?.state === 'linked' ? row.catalog.entry : null;
    if (!f || !e) return f;
    return {
        ...f,
        catalogId: e.id || null,
        code: e.code || '',
        codeSystem: e.codeSystem || '',
        catalogName: e.name || ''
    };
}
const $80f289cb339918db$export$65c4d13db359029b = (row)=>!!row?.checked && !row.known && !!row.catalog && row.catalog.state !== 'linked' && row.catalog.state !== 'free';
function $80f289cb339918db$export$998c598c6be6e5b2(row, choice) {
    if (!row?.catalog) return row;
    if (choice === 'free') return {
        ...row,
        catalog: {
            ...row.catalog,
            state: 'free',
            entry: null,
            auto: false
        }
    };
    if (choice && typeof choice === 'object') return {
        ...row,
        catalog: {
            ...row.catalog,
            state: 'linked',
            entry: choice,
            auto: false
        }
    };
    return {
        ...row,
        catalog: {
            ...row.catalog,
            state: 'choose',
            entry: null,
            auto: false
        }
    };
}
// ── علائم حیاتی ─────────────────────────────────────────────────────────────
// The vitals form's own fields (Visit.shared `emptyVitals`).
const $80f289cb339918db$var$FORM_FIELD = {
    pulse: 'pulse',
    spo2: 'spo2',
    temp: 'temp',
    weight: 'weight'
};
function $80f289cb339918db$export$40b6415e2650a54e(findings) {
    const patch = {};
    (findings || []).forEach((f)=>{
        if (f.kind === 'bp') {
            patch.bpSys = $80f289cb339918db$var$text(f.value);
            patch.bpDia = $80f289cb339918db$var$text(f.value2);
        } else if ($80f289cb339918db$var$FORM_FIELD[f.kind]) patch[$80f289cb339918db$var$FORM_FIELD[f.kind]] = $80f289cb339918db$var$text(f.value);
    });
    return patch;
}
// Vital signs the form has no field for are recorded as observations of their own.
const $80f289cb339918db$var$OBSERVATION = {
    resp: {
        code: '9279-1',
        labelKey: 'visit.monitoringExtract.vital.resp'
    },
    height: {
        code: '8302-2',
        labelKey: 'visit.monitoringExtract.vital.height'
    },
    glucose: {
        code: '2339-0',
        labelKey: 'visit.monitoringExtract.vital.glucose'
    }
};
function $80f289cb339918db$export$9987edde8f07e80c(findings, t) {
    return (findings || []).filter((f)=>$80f289cb339918db$var$OBSERVATION[f.kind]).map((f)=>({
            code: $80f289cb339918db$var$OBSERVATION[f.kind].code,
            display: t($80f289cb339918db$var$OBSERVATION[f.kind].labelKey),
            value: $80f289cb339918db$var$text(f.value),
            unit: f.unit || ''
        }));
}
function $80f289cb339918db$export$3c008fd1874e1122(rows) {
    return (rows || []).filter((r)=>r.checked && !r.known && r.finding?.autoConfirm && r.finding?.autoEntry?.id).map((r)=>({
            ...r,
            finding: $80f289cb339918db$export$5c45ae4a0435bba5(r.finding)
        }));
}
function $80f289cb339918db$export$5c45ae4a0435bba5(f) {
    const e = f.autoEntry;
    return {
        ...f,
        kind: e.orderType || f.kind,
        catalogId: e.id,
        catalogName: e.name || '',
        code: e.code || ''
    };
}
// ── «تایید خودکار» (PM-0573, DESIGN_CONCEPT §13.3) ─────────────────────────
// The form fields each vital sign fills — what «تأیید» writes into (vitalsFormPatch).
const $80f289cb339918db$var$FORM_KEYS = {
    bp: [
        'bpSys',
        'bpDia'
    ],
    pulse: [
        'pulse'
    ],
    spo2: [
        'spo2'
    ],
    temp: [
        'temp'
    ],
    weight: [
        'weight'
    ]
};
function $80f289cb339918db$export$feaf66f5ef89d875(rows, form) {
    const fits = (rows || []).filter((r)=>r.checked && !r.known && $80f289cb339918db$var$FORM_KEYS[r.finding?.kind] && $80f289cb339918db$var$FORM_KEYS[r.finding.kind].every((k)=>!$80f289cb339918db$var$text(form?.[k])));
    const kinds = fits.map((r)=>r.finding.kind);
    return fits.filter((r)=>kinds.indexOf(r.finding.kind) === kinds.lastIndexOf(r.finding.kind));
}
function $80f289cb339918db$export$c9fb3d547efbe8a9(form, kind) {
    const values = ($80f289cb339918db$var$FORM_KEYS[kind] || []).map((k)=>$80f289cb339918db$var$text(form?.[k]));
    return values.some(Boolean) ? values.join('/') : '';
}
function $80f289cb339918db$export$361af805d18cfd90(kind) {
    return Object.fromEntries(($80f289cb339918db$var$FORM_KEYS[kind] || []).map((k)=>[
            k,
            ''
        ]));
}
function $80f289cb339918db$export$2e0352eb98b59734(f) {
    const v = f.kind === 'bp' ? `${$80f289cb339918db$var$text(f.value)}/${$80f289cb339918db$var$text(f.value2)}` : $80f289cb339918db$var$text(f.value);
    return [
        v,
        f.unit
    ].filter(Boolean).join(' ');
}
// ── دستورات ─────────────────────────────────────────────────────────────────
// The encounter's order types (clinicalencounter ALLOWED_ORDER_TYPES). It has no
// «referral»: a referral is written as an order of type `other` that says so.
const $80f289cb339918db$var$ORDER_TYPE = {
    lab: 'lab',
    imaging: 'imaging',
    procedure: 'procedure',
    referral: 'other'
};
function $80f289cb339918db$export$33ef048cffb1af5d(f) {
    return {
        key: `monitoring:${f.kind}:${f.text}`,
        orderType: $80f289cb339918db$var$ORDER_TYPE[f.kind] || 'other',
        name: $80f289cb339918db$var$text(f.catalogName || f.text),
        reason: $80f289cb339918db$var$text(f.detail),
        urgency: [
            'routine',
            'urgent',
            'stat'
        ].includes(f.urgency) ? f.urgency : 'routine',
        catalogId: f.catalogId || null,
        code: $80f289cb339918db$var$text(f.code),
        // A LOINC badge is only honest when the code IS a LOINC (the picker's rule).
        loincCode: f.codeSystem === 'LOINC' ? $80f289cb339918db$var$text(f.code) : ''
    };
}
function $80f289cb339918db$export$3e993be304a3ed8f(findings, t) {
    return (findings || []).filter((f)=>f.kind === 'follow_up' && $80f289cb339918db$var$text(f.text)).map((f)=>t('visit.monitoringExtract.followUpLine', {
            text: $80f289cb339918db$var$text(f.text)
        }));
}
function $80f289cb339918db$export$6a1840833052c978(p, lines) {
    const have = String(p || '');
    const fresh = (lines || []).filter((l)=>l && !have.includes(l));
    if (!fresh.length) return have;
    return [
        have.trimEnd(),
        ...fresh
    ].filter(Boolean).join('\n');
}

});


parcelRegister("fIKok", function(module, exports) {

$parcel$export(module.exports, "useMonitoringExtraction", () => $b71ef3742639a482$export$ae55c3af901dcf33);
// State of «تکمیل از پایش بالینی» for علائم حیاتی, دستورات and اطلاعات پرونده
// (PM-0029, PM-0038): each group is read, reviewed and confirmed ON ITS OWN, in the
// section it fills — so each has its own review, and one group's answer never
// replaces another's list.
//
// `getContext()` is read at call time, so a run always sends the record as it is
// NOW. The screen owns everything that writes: this hook hands it the ticked
// findings and nothing else.

var $acw62 = parcelRequire("acw62");

var $eVM84 = parcelRequire("eVM84");

var $c9qmv = parcelRequire("c9qmv");

var $1yr2B = parcelRequire("1yr2B");

var $b4nOl = parcelRequire("b4nOl");
// A BFF that predates «تایید خودکار»'s fields (PM-0586) is asked without them.
const $b71ef3742639a482$var$askExtraction = (0, $c9qmv.askWithoutWhenRefused)((0, $eVM84.bffMutation), (0, $b4nOl.withoutAutoConfirmFindingFields));
const $b71ef3742639a482$var$IDLE = Object.freeze({
    open: false,
    phase: 'idle',
    rows: [],
    status: null,
    error: null,
    applying: false
});
const $b71ef3742639a482$var$ALL_IDLE = Object.freeze(Object.fromEntries((0, $b4nOl.EXTRACTION_GROUPS).map((g)=>[
        g,
        $b71ef3742639a482$var$IDLE
    ])));
// Each review's rows against what the visit holds now; the same object when no row changed.
function $b71ef3742639a482$var$withHoldings(reviews, holdings) {
    let changed = false;
    const next = {};
    (0, $b4nOl.EXTRACTION_GROUPS).forEach((g)=>{
        const r = reviews[g];
        const rows = (0, $b4nOl.markHeldRows)(r.rows, holdings);
        next[g] = rows === r.rows ? r : {
            ...r,
            rows: rows
        };
        if (next[g] !== r) changed = true;
    });
    return changed ? next : reviews;
}
function $b71ef3742639a482$export$ae55c3af901dcf33({ getContext: getContext, chargeVisit: chargeVisit, chargeLabel: chargeLabel, onCreditError: onCreditError, onApply: onApply, searchCatalog: searchCatalog, autoConfirm: autoConfirm = false, onAutoConfirm: onAutoConfirm }) {
    const [reviews, setReviews] = (0, $acw62.useState)($b71ef3742639a482$var$ALL_IDLE);
    // A slow answer to a run the doctor already replaced or closed must not reopen it.
    const runRef = (0, $acw62.useRef)({});
    const deps = (0, $acw62.useRef)({});
    deps.current = {
        getContext: getContext,
        chargeVisit: chargeVisit,
        chargeLabel: chargeLabel,
        onCreditError: onCreditError,
        onApply: onApply,
        searchCatalog: searchCatalog,
        autoConfirm: autoConfirm,
        onAutoConfirm: onAutoConfirm
    };
    const reviewsRef = (0, $acw62.useRef)(reviews);
    reviewsRef.current = reviews;
    // What the visit holds as it is NOW, read at call time like the rest of the context.
    const holdingsNow = ()=>(0, $b4nOl.visitHoldings)(deps.current.getContext?.() || {});
    const patch = (0, $acw62.useCallback)((group, next)=>setReviews((all)=>({
                ...all,
                [group]: typeof next === 'function' ? next(all[group]) : next
            })), []);
    const patchRow = (0, $acw62.useCallback)((group, key, change)=>patch(group, (r)=>({
                ...r,
                rows: r.rows.map((x)=>x.key === key ? change(x) : x)
            })), [
        patch
    ]);
    // Each heard order the catalogue should name is looked up with the picker's own
    // search, one row at a time, and never holds the reading's answer back. A reply
    // to a run the doctor already replaced or closed is dropped, like the run's own.
    const lookUpCatalog = (group, id, rows, ctx)=>{
        const search = deps.current.searchCatalog;
        if (!search) return rows;
        const marked = rows.map((r)=>(0, $b4nOl.needsCatalogLookup)(r.finding) ? {
                ...r,
                catalog: {
                    state: 'pending',
                    entry: null,
                    auto: false,
                    candidates: []
                }
            } : r);
        marked.filter((r)=>r.catalog).forEach((row)=>{
            Promise.resolve().then(()=>search({
                    query: row.finding.text,
                    orderType: row.finding.kind,
                    appointmentId: ctx.appointmentId || ctx.encounterId || null
                })).then((page)=>(0, $b4nOl.catalogStateOf)(row.finding, page?.entries))// A search that failed leaves the choice to the doctor, never a guess.
            .catch(()=>({
                    state: 'choose',
                    entry: null,
                    auto: false,
                    candidates: [],
                    failed: true
                })).then((catalog)=>{
                if (runRef.current[group] !== id) return;
                patchRow(group, row.key, (x)=>({
                        ...x,
                        catalog: catalog
                    }));
            });
        });
        return marked;
    };
    /** `groups`: one group, or several — each is its own service, charge and review. */ const run = (0, $acw62.useCallback)(async (groups = (0, $b4nOl.EXTRACTION_GROUPS))=>{
        const wanted = (Array.isArray(groups) ? groups : [
            groups
        ]).filter((g)=>(0, $b4nOl.EXTRACTION_GROUPS).includes(g));
        if (!wanted.length) return {};
        const ctx = deps.current.getContext?.() || {};
        const ids = {};
        wanted.forEach((group)=>{
            ids[group] = (runRef.current[group] || 0) + 1;
            runRef.current[group] = ids[group];
            patch(group, {
                ...$b71ef3742639a482$var$IDLE,
                open: true,
                phase: 'loading'
            });
        });
        // → { [group]: 'found' | 'none' | 'known' | 'auto' | 'error' } — what the caller may act
        // on. 'auto': everything new was confirmed by «تایید خودکار», nothing waits.
        const outcome = {};
        await Promise.all(wanted.map(async (group)=>{
            try {
                // Long budget, like the نسخه's reading (PM-0069).
                const data = await $b71ef3742639a482$var$askExtraction((0, $b4nOl.EXTRACT_MONITORING), {
                    input: (0, $b4nOl.buildExtractionInput)(group, ctx)
                }, {
                    timeoutMs: (0, $eVM84.LONG_REQUEST_TIMEOUT_MS)
                });
                if (runRef.current[group] !== ids[group]) return;
                const result = data?.extractMonitoring || {};
                let rows = lookUpCatalog(group, ids[group], (0, $b4nOl.buildFindingRows)(group, result.findings, holdingsNow()), ctx);
                // «تایید خودکار»: vitals only, and only what the form takes without
                // overwriting anything — read against the form as it is now, not at the call,
                // and never into another visit than the one this was read for (the screen
                // stays mounted when the doctor moves to the next patient).
                const a = deps.current.autoConfirm;
                const now = deps.current.getContext?.() || {};
                const sameVisit = String(now.appointmentId || '') === String(ctx.appointmentId || '');
                const on = sameVisit && (typeof a === 'function' ? a() : !!a);
                let auto = [];
                if (on && group === 'VITALS') {
                    auto = (0, $b4nOl.autoConfirmableVitals)(rows, now.vitals);
                    if (auto.length) deps.current.onAutoConfirm?.(group, auto);
                } else if (on && group === 'ORDERS') {
                    // PM-0586: the orders the service marked, created as their catalogue rows —
                    // never one the visit already holds, checked again as the row it would be.
                    const holdings = holdingsNow();
                    const marked = (0, $b4nOl.autoConfirmableOrders)(rows).filter((r)=>!(0, $b4nOl.heldByVisit)(r.finding, holdings, 'ORDERS'));
                    if (marked.length) {
                        let made = [];
                        try {
                            made = await deps.current.onAutoConfirm?.(group, marked) || [];
                        } catch (err) {
                            console.warn('[monitoringExtraction] auto-confirm failed:', err);
                        }
                        if (runRef.current[group] !== ids[group]) return;
                        auto = rows.filter((r)=>made.includes(r.key));
                    }
                }
                if (auto.length) {
                    const keys = new Set(auto.map((r)=>r.key));
                    rows = rows.filter((r)=>!keys.has(r.key));
                }
                // Found only what the visit already holds: nothing to confirm. 'known' when
                // that was still charged (the service cannot tell — it is sent no orders or
                // vitals), so the visit-wide run does not say «nothing found, no charge».
                if (rows.some((r)=>!r.known)) outcome[group] = 'found';
                else if (auto.length) outcome[group] = 'auto';
                else outcome[group] = rows.length && result.charged ? 'known' : 'none';
                // The server's `charged` is the signal, never the click: an empty run is free.
                if (result.charged) {
                    const { action: action, ledgerId: ledgerId } = (0, $b4nOl.EXTRACTION_PRICING)[group];
                    deps.current.chargeVisit?.((0, $1yr2B.costOf)(action), ledgerId, deps.current.chargeLabel?.(group));
                }
                // All of it confirmed by itself: no review is left to read. Rows an undo put
                // back while this was read (`restore`) stay in the review either way.
                patch(group, (prev)=>{
                    const restored = (prev.rows || []).filter((r)=>r.restored);
                    if (outcome[group] === 'auto' && !restored.length) return $b71ef3742639a482$var$IDLE;
                    return {
                        ...$b71ef3742639a482$var$IDLE,
                        open: true,
                        phase: 'ready',
                        status: result.status || 'none_found',
                        rows: [
                            ...restored,
                            ...outcome[group] === 'auto' ? [] : rows
                        ]
                    };
                });
            } catch (e) {
                if (runRef.current[group] !== ids[group]) return;
                const credit = e?.extensions?.code === 'INSUFFICIENT_CREDITS';
                if (credit) deps.current.onCreditError?.(e.message);
                outcome[group] = 'error';
                patch(group, {
                    ...$b71ef3742639a482$var$IDLE,
                    open: true,
                    phase: 'error',
                    status: 'error',
                    error: credit ? 'credit' : 'failed'
                });
            }
        }));
        return outcome;
    }, [
        patch
    ]);
    // «تایید خودکار» undone (PM-0573): the rows wait in the review again, ticked as
    // they were, ahead of anything a newer reading put there. Marked `restored` so a
    // reading that lands meanwhile keeps them — and never confirms them by itself again.
    const restore = (0, $acw62.useCallback)((group, rows)=>{
        if (!rows?.length) return;
        const back = rows.map((r, i)=>({
                ...r,
                key: `${r.key}-undo-${Date.now()}-${i}`,
                restored: true
            }));
        patch(group, (r)=>({
                ...r,
                open: true,
                phase: r.phase === 'loading' ? 'loading' : 'ready',
                status: r.status || 'ok',
                rows: [
                    ...back,
                    ...r.rows || []
                ]
            }));
    }, [
        patch
    ]);
    const close = (0, $acw62.useCallback)((group)=>{
        runRef.current[group] = (runRef.current[group] || 0) + 1;
        patch(group, $b71ef3742639a482$var$IDLE);
    }, [
        patch
    ]);
    const toggle = (0, $acw62.useCallback)((group, key)=>{
        const holdings = holdingsNow();
        patch(group, (r)=>({
                ...r,
                rows: (0, $b4nOl.toggleFindingRow)((0, $b4nOl.markHeldRows)(r.rows, holdings), key)
            }));
    }, [
        patch
    ]);
    const setAll = (0, $acw62.useCallback)((group, checked)=>{
        const holdings = holdingsNow();
        patch(group, (r)=>({
                ...r,
                rows: (0, $b4nOl.setAllFindingRows)((0, $b4nOl.markHeldRows)(r.rows, holdings), checked)
            }));
    }, [
        patch
    ]);
    /** A catalogue entry for an order row, 'free' to save it without one, or null to choose again. */ const chooseCatalog = (0, $acw62.useCallback)((group, key, choice)=>{
        patchRow(group, key, (x)=>(0, $b4nOl.chooseCatalogRow)(x, choice));
    }, [
        patchRow
    ]);
    const apply = (0, $acw62.useCallback)(async (group)=>{
        // Checked against the visit as it is at «تأیید»: an order placed by hand while
        // the review was open is not created a second time.
        const rows = (0, $b4nOl.markHeldRows)(reviewsRef.current[group]?.rows, holdingsNow());
        // A ticked order with no catalogue entry yet is not saved as free text by default.
        if ((rows || []).some((0, $b4nOl.awaitingCatalogChoice))) return;
        const picked = (0, $b4nOl.findingsToApply)(rows);
        if (!picked.vitals.length && !picked.orders.length && !picked.record.length) return;
        patch(group, (r)=>({
                ...r,
                applying: true,
                error: null
            }));
        try {
            await deps.current.onApply?.(picked);
            close(group);
        } catch (e) {
            console.warn('[monitoringExtraction] apply failed:', e);
            patch(group, (r)=>({
                    ...r,
                    applying: false,
                    error: 'apply'
                }));
        }
    }, [
        close,
        patch
    ]);
    // Shown against the visit as it is now (the screen re-renders on every transcript
    // chunk, so the holdings are only read while some review has rows).
    const shown = (0, $b4nOl.EXTRACTION_GROUPS).some((g)=>reviews[g].rows.length) ? $b71ef3742639a482$var$withHoldings(reviews, holdingsNow()) : reviews;
    return {
        reviews: shown,
        run: run,
        close: close,
        toggle: toggle,
        setAll: setAll,
        apply: apply,
        chooseCatalog: chooseCatalog,
        restore: restore
    };
}

});

parcelRegister("icdDW", function(module, exports) {

$parcel$export(module.exports, "useVisitCompletion", () => $d3f3ee41c97afb39$export$3bfa7c0c0c355160);
// The flow of «تکمیل از پایش بالینی» (PM-0038), for both Visit surfaces.
//
// The screen already owns three pieces of state that hold proposals — the note's
// merge preview, the نسخه's review and the per-group findings. This hook does not
// duplicate any of it: it is told how many proposals WAIT in each section
// (`pending`) and how to read each one (`runners`), and from that it gives
//
//   runAll()   the top bar's «تکمیل»: read every section that has nothing waiting;
//   steps      the sections that received proposals this round, reviewed or not;
//   nextFrom   where the doctor goes after the section they are in.
//
// A round starts with the first proposal and ends when none is left — confirmed
// or rejected, one by one. Then `onDone` fires and the guide goes away.

var $acw62 = parcelRequire("acw62");

var $aCwB5 = parcelRequire("aCwB5");
function $d3f3ee41c97afb39$export$9ef1799c38d9eb96({ pending: pending, runners: runners, labelOf: labelOf, onNothing: onNothing, onKnown: onKnown, onAllWaiting: onAllWaiting, onFailed: onFailed, onDone: onDone }) {
    const [seen, setSeen] = (0, $acw62.useState)([]);
    const [round, setRound] = (0, $acw62.useState)(null); // null | 'running' | { failed, known, auto: [section] }
    const deps = (0, $acw62.useRef)({});
    deps.current = {
        pending: pending,
        runners: runners,
        labelOf: labelOf,
        onNothing: onNothing,
        onKnown: onKnown,
        onAllWaiting: onAllWaiting,
        onFailed: onFailed,
        onDone: onDone
    };
    const seenRef = (0, $acw62.useRef)(seen);
    seenRef.current = seen;
    const counts = (0, $aCwB5.COMPLETE_SECTIONS).map((id)=>Number(pending?.[id]) || 0);
    const countsKey = counts.join(',');
    const waitingKey = (0, $aCwB5.COMPLETE_SECTIONS).filter((_, i)=>counts[i] > 0).join(',');
    // A section that just received proposals joins the round; a round whose
    // proposals are all gone is over.
    (0, $acw62.useEffect)(()=>{
        const waiting = waitingKey ? waitingKey.split(',') : [];
        const prev = seenRef.current;
        if (waiting.length) {
            const fresh = waiting.filter((id)=>!prev.includes(id));
            if (fresh.length) setSeen([
                ...prev,
                ...fresh
            ]);
        } else if (prev.length) {
            setSeen([]);
            deps.current.onDone?.(prev);
        }
    }, [
        waitingKey
    ]);
    // The visit-wide run is back. A button that answers with silence reads as
    // broken, so the two quiet outcomes are said: nothing found, or not read.
    (0, $acw62.useEffect)(()=>{
        if (!round || round === 'running') return;
        setRound(null);
        if (round.failed.length) deps.current.onFailed?.(round.failed);
        else if (!waitingKey && round.auto?.length) return;
        else if (!waitingKey && round.known?.length) deps.current.onKnown?.(round.known);
        else if (!waitingKey) deps.current.onNothing?.();
    }, [
        round,
        waitingKey
    ]);
    const runAll = (0, $acw62.useCallback)(async ()=>{
        const open = (0, $aCwB5.sectionsToRun)(deps.current.pending);
        // Silence here read as «تکمیل no longer works» in a long visit (PM-0069):
        // a section with a proposal on screen is never read again, so say why.
        if (!open.length) {
            deps.current.onAllWaiting?.();
            return;
        }
        const todo = open.filter((id)=>deps.current.runners?.[id]);
        if (!todo.length) return;
        setRound('running');
        const settled = await Promise.allSettled(todo.map((id)=>deps.current.runners[id]()));
        setRound({
            failed: todo.filter((_, i)=>settled[i].status === 'rejected' || settled[i].value === 'error'),
            known: todo.filter((_, i)=>settled[i].value === 'known'),
            auto: todo.filter((_, i)=>settled[i].value === 'auto')
        });
    }, []);
    const steps = (0, $acw62.useMemo)(()=>(0, $aCwB5.guideSteps)(seen, Object.fromEntries((0, $aCwB5.COMPLETE_SECTIONS).map((id, i)=>[
                id,
                Number(countsKey.split(',')[i])
            ])), (id)=>deps.current.labelOf?.(id) ?? id), [
        seen,
        countsKey
    ]);
    const nextFrom = (0, $acw62.useCallback)((current)=>(0, $aCwB5.nextStep)(steps, current), [
        steps
    ]);
    const total = steps.reduce((n, s)=>n + s.count, 0);
    return {
        runAll: runAll,
        busy: round === 'running',
        steps: steps,
        nextFrom: nextFrom,
        total: total
    };
}
const $d3f3ee41c97afb39$var$GROUP_OF = {
    orders: 'ORDERS',
    vitals: 'VITALS',
    record: 'RECORD'
};
function $d3f3ee41c97afb39$export$3bfa7c0c0c355160({ t: t, formatNumber: formatNumber, toast: toast, soapRefine: soapRefine, rxAssist: rxAssist, monitoringExtract: monitoringExtract, costOf: costOf, disabled: disabled = false, recState: recState = 'idle', autoRunOnStop: autoRunOnStop = false }) {
    const api = (0, $acw62.useRef)({});
    api.current = {
        soapRefine: soapRefine,
        rxAssist: rxAssist,
        monitoringExtract: monitoringExtract,
        t: t,
        toast: toast
    };
    const pending = (0, $aCwB5.pendingProposals)({
        soapPreview: soapRefine.preview,
        rxReview: rxAssist.review,
        reviews: monitoringExtract.reviews
    });
    // One section, from its own button: the answer stays in the section whatever it is.
    const runSection = (0, $acw62.useCallback)((id)=>{
        const a = api.current;
        if (id === 'soap') return a.soapRefine.refine();
        if (id === 'rx') return a.rxAssist.run('MONITORING');
        return a.monitoringExtract.run([
            $d3f3ee41c97afb39$var$GROUP_OF[id]
        ]);
    }, []);
    // The visit-wide run: a reading that found nothing leaves no empty card behind
    // in a tab the doctor is not looking at — the guide lists what DID come back.
    // The note is read for the parts with no proposal waiting; the new proposals
    // join the ones already on screen.
    const runners = (0, $acw62.useMemo)(()=>({
            soap: async ()=>{
                const open = (0, $aCwB5.noteSectionsToRun)(api.current.soapRefine.preview);
                const sections = open.length === (0, $aCwB5.NOTE_SECTIONS).length ? undefined : open;
                // refine answers 'found' | 'none' | 'error'. It used to answer true for any
                // reply, so a merge the SERVER said it could not do came out here as
                // «nothing new was found» — the one thing that was certainly not known.
                return api.current.soapRefine.refine(sections);
            },
            rx: async ()=>{
                const outcome = await api.current.rxAssist.run('MONITORING');
                if (outcome === 'none' || outcome === 'known') api.current.rxAssist.close();
                return outcome;
            },
            ...Object.fromEntries([
                'orders',
                'vitals'
            ].map((id)=>[
                    id,
                    async ()=>{
                        const group = $d3f3ee41c97afb39$var$GROUP_OF[id];
                        const outcome = (await api.current.monitoringExtract.run([
                            group
                        ]))[group];
                        if (outcome === 'none' || outcome === 'known') api.current.monitoringExtract.close(group);
                        return outcome;
                    }
                ]))
        }), []);
    const flow = $d3f3ee41c97afb39$export$9ef1799c38d9eb96({
        pending: pending,
        runners: runners,
        labelOf: (id)=>api.current.t(`visit.complete.section.${id}`),
        onNothing: ()=>api.current.toast?.info?.(api.current.t('visit.complete.nothing')),
        onKnown: ()=>api.current.toast?.info?.(api.current.t('visit.complete.known')),
        onAllWaiting: ()=>api.current.toast?.info?.(api.current.t('visit.complete.allWaiting')),
        onFailed: ()=>api.current.toast?.error?.(api.current.t('visit.complete.failed')),
        // One section confirmed says so itself; a round across sections is worth closing.
        onDone: (sections)=>{
            if (sections.length > 1) api.current.toast?.success?.(api.current.t('visit.complete.done'));
        }
    });
    // «تکمیل خودکار پس از پایش بالینی» (K1, 2026-10-06): the visit-wide run, by
    // itself, once the doctor stops the recording. Armed only by their own press of
    // the stop control (`armAutoRun`) — a stop that is part of ending or cancelling
    // the visit calls stopRec directly and reads nothing. Fired on the stopping →
    // idle step, which is the final transcript arriving: the AI service stores it
    // before it sends is_final, so every section is read against the whole
    // conversation. Anything else the recording does first — an error, a system
    // pause — disarms it, and so does a visit that can no longer take proposals.
    const armed = (0, $acw62.useRef)(false);
    const autoOn = (0, $acw62.useRef)(false);
    autoOn.current = !!autoRunOnStop && !disabled;
    const lastRecState = (0, $acw62.useRef)(recState);
    const runAll = flow.runAll;
    (0, $acw62.useEffect)(()=>{
        const was = lastRecState.current;
        lastRecState.current = recState;
        if (recState === 'stopping' || !armed.current) return;
        armed.current = false;
        if (was === 'stopping' && recState === 'idle' && autoOn.current) runAll();
    }, [
        recState,
        runAll
    ]);
    const armAutoRun = (0, $acw62.useCallback)(()=>{
        armed.current = autoOn.current;
    }, []);
    const fmt = (n)=>formatNumber ? formatNumber(n) : String(n);
    const busyOf = (id)=>{
        if (id === 'soap') return !!soapRefine.loading;
        if (id === 'rx') return rxAssist.review.phase === 'loading' && rxAssist.review.source === 'MONITORING';
        return monitoringExtract.reviews[$d3f3ee41c97afb39$var$GROUP_OF[id]]?.phase === 'loading';
    };
    /** The props of the section's CompleteButton. */ const button = (id)=>({
            onClick: ()=>runSection(id),
            busy: busyOf(id),
            disabled: disabled,
            count: pending[id],
            title: t('visit.complete.hintPrice', {
                section: t(`visit.complete.section.${id}`),
                coins: fmt(costOf((0, $aCwB5.SECTION_ACTION)[id]))
            })
        });
    /** The props of the top bar's visit-wide CompleteButton. */ const allButton = {
        onClick: flow.runAll,
        busy: flow.busy,
        disabled: disabled,
        count: flow.total,
        title: t('visit.complete.allHint', {
            coins: fmt((0, $aCwB5.maxCoins)(costOf))
        })
    };
    return {
        pending: pending,
        flow: flow,
        button: button,
        allButton: allButton,
        runSection: runSection,
        armAutoRun: armAutoRun
    };
}

});
parcelRegister("aCwB5", function(module, exports) {

$parcel$export(module.exports, "COMPLETE_SECTIONS", () => $7bb6bd2305b75ff2$export$a44880a6e20af2f8);
$parcel$export(module.exports, "SECTION_ACTION", () => $7bb6bd2305b75ff2$export$cfc0f0f1064d8989);
$parcel$export(module.exports, "NOTE_SECTIONS", () => $7bb6bd2305b75ff2$export$3a4845752d2bf748);
$parcel$export(module.exports, "sectionsToRun", () => $7bb6bd2305b75ff2$export$402cbbcda510e1bd);
$parcel$export(module.exports, "noteSectionsToRun", () => $7bb6bd2305b75ff2$export$698b53ef55a14015);
$parcel$export(module.exports, "maxCoins", () => $7bb6bd2305b75ff2$export$d028ecf95ff92290);
$parcel$export(module.exports, "guideSteps", () => $7bb6bd2305b75ff2$export$e6e7d400543bb13d);
$parcel$export(module.exports, "nextStep", () => $7bb6bd2305b75ff2$export$1740d07632cd7131);
$parcel$export(module.exports, "pendingProposals", () => $7bb6bd2305b75ff2$export$e7fce37d4c24e7e3);
// «تکمیل از پایش بالینی» as ONE flow (PM-0038). The visit's transcript fills five
// places — the note, the نسخه, the دستورات, the علائم حیاتی and the record — and each
// has its own «تکمیل» button and its own proposal. This module is what makes them
// one thing: which sections the top bar's «تکمیل» reads, what that may cost, and the
// order the doctor is walked through whatever came back.
//
// Pure (no React): both Visit surfaces and the tests read one copy.
/** Every section a reading can propose for — the order the guide walks them in. */ const $7bb6bd2305b75ff2$export$a44880a6e20af2f8 = Object.freeze([
    'soap',
    'rx',
    'orders',
    'vitals',
    'record'
]);
const $7bb6bd2305b75ff2$export$3e60d0866daba7e3 = Object.freeze([
    'soap',
    'rx',
    'orders',
    'vitals'
]);
const $7bb6bd2305b75ff2$export$cfc0f0f1064d8989 = Object.freeze({
    soap: 'SOAP_REFINE',
    rx: 'RX_MONITORING',
    orders: 'MONITORING_ORDERS',
    vitals: 'MONITORING_VITALS',
    record: 'MONITORING_RECORD'
});
const $7bb6bd2305b75ff2$export$e1f06a5f97075575 = Object.freeze({
    orders: 'ORDERS',
    vitals: 'VITALS',
    record: 'RECORD'
});
const $7bb6bd2305b75ff2$export$3a4845752d2bf748 = Object.freeze([
    's',
    'o',
    'a',
    'p'
]);
const $7bb6bd2305b75ff2$var$count = (pending, id)=>Number(pending?.[id]) || 0;
// How many proposals can wait in a section before nothing in it is left to read:
// one per part of the note, one card everywhere else.
const $7bb6bd2305b75ff2$var$capacity = (id)=>id === 'soap' ? $7bb6bd2305b75ff2$export$3a4845752d2bf748.length : 1;
function $7bb6bd2305b75ff2$export$402cbbcda510e1bd(pending, sections = $7bb6bd2305b75ff2$export$3e60d0866daba7e3) {
    return sections.filter((id)=>$7bb6bd2305b75ff2$var$count(pending, id) < $7bb6bd2305b75ff2$var$capacity(id));
}
// A note proposal is `stale` when the doctor changed its part before confirming
// it in a way the merge cannot carry (useSoapRefine). It can no longer be
// confirmed — only read again — so it is not a proposal waiting.
const $7bb6bd2305b75ff2$var$waitingNote = (entry)=>!!entry && !entry.stale;
function $7bb6bd2305b75ff2$export$698b53ef55a14015(soapPreview) {
    return $7bb6bd2305b75ff2$export$3a4845752d2bf748.filter((k)=>!$7bb6bd2305b75ff2$var$waitingNote(soapPreview?.[k]));
}
function $7bb6bd2305b75ff2$export$d028ecf95ff92290(costOf, sections = $7bb6bd2305b75ff2$export$3e60d0866daba7e3) {
    return sections.reduce((sum, id)=>sum + (Number(costOf($7bb6bd2305b75ff2$export$cfc0f0f1064d8989[id])) || 0), 0);
}
function $7bb6bd2305b75ff2$export$e6e7d400543bb13d(seen, pending, labelOf = (id)=>id) {
    return $7bb6bd2305b75ff2$export$a44880a6e20af2f8.filter((id)=>(seen || []).includes(id)).map((id)=>({
            id: id,
            label: labelOf(id),
            count: $7bb6bd2305b75ff2$var$count(pending, id),
            done: $7bb6bd2305b75ff2$var$count(pending, id) === 0
        }));
}
function $7bb6bd2305b75ff2$export$1740d07632cd7131(steps, current) {
    const waiting = (steps || []).filter((s)=>!s.done && s.id !== current);
    if (!waiting.length) return null;
    const at = $7bb6bd2305b75ff2$export$a44880a6e20af2f8.indexOf(current);
    return waiting.find((s)=>$7bb6bd2305b75ff2$export$a44880a6e20af2f8.indexOf(s.id) > at) || waiting[0];
}
// A row the visit already holds — an order already placed, a vital sign already
// recorded, a drug already on the نسخه — is shown as such but waits for nothing:
// counted, a second «تکمیل» that only re-heard them held the guide open on rows
// nobody can confirm.
const $7bb6bd2305b75ff2$var$readyRows = (review)=>review?.open && review.phase === 'ready' ? review.rows.filter((r)=>!r?.known).length : 0;
function $7bb6bd2305b75ff2$export$e7fce37d4c24e7e3({ soapPreview: soapPreview, rxReview: rxReview, reviews: reviews }) {
    return {
        soap: soapPreview ? Object.values(soapPreview).filter($7bb6bd2305b75ff2$var$waitingNote).length : 0,
        rx: $7bb6bd2305b75ff2$var$readyRows(rxReview),
        orders: $7bb6bd2305b75ff2$var$readyRows(reviews?.ORDERS),
        vitals: $7bb6bd2305b75ff2$var$readyRows(reviews?.VITALS),
        record: $7bb6bd2305b75ff2$var$readyRows(reviews?.RECORD)
    };
}

});


parcelRegister("cEPPo", function(module, exports) {

$parcel$export(module.exports, "useAutoConfirm", () => $93716c64561e7b22$export$24af072b6c8b6a9e);
// «تایید خودکار» (PM-0573, DESIGN_CONCEPT §13.3) — what the doctor's switch
// confirmed in THIS visit: the list the visit's chip shows, the undo of each item,
// and the server-side record of both.
//
// The screen owns every write. It hands over what it confirmed (`add`) and how to
// take one back (`undoers[kind]`). The hook keeps the list and asks the screen what
// each item's place holds NOW (`read`), so an item the doctor has since changed is
// theirs: its badge comes off and its undo goes, because an undo would delete what
// they wrote. Every confirm and every undo is recorded with the doctor BFF's
// `recordAutoConfirm`, fire-and-forget — a lost record must never hold back, or
// roll back, the doctor's visit.

var $acw62 = parcelRequire("acw62");

var $eVM84 = parcelRequire("eVM84");
const $93716c64561e7b22$export$e815fc2694be9771 = `mutation RecordAutoConfirm($appointmentId:ID!,$kind:String!,$section:String,$before:String,$after:String,$undone:Boolean){recordAutoConfirm(appointmentId:$appointmentId,kind:$kind,section:$section,before:$before,after:$after,undone:$undone)}`;
// Trailing whitespace is not text, as for a proposal (rebaseSoapProposal).
const $93716c64561e7b22$var$same = (a, b)=>String(a ?? '').trimEnd() === String(b ?? '').trimEnd();
function $93716c64561e7b22$export$24af072b6c8b6a9e({ visitId: visitId, appointmentId: appointmentId, read: read, undoers: undoers, labelOf: labelOf, toast: toast, t: t, joinList: joinList }) {
    const [list, setList] = (0, $acw62.useState)([]);
    const listRef = (0, $acw62.useRef)(list);
    listRef.current = list;
    const seq = (0, $acw62.useRef)(0);
    const deps = (0, $acw62.useRef)({});
    deps.current = {
        appointmentId: appointmentId,
        read: read,
        undoers: undoers,
        labelOf: labelOf,
        toast: toast,
        t: t,
        joinList: joinList
    };
    // Never carried into another patient's visit.
    (0, $acw62.useEffect)(()=>{
        setList([]);
    }, [
        visitId
    ]);
    const record = (item, undone)=>{
        const id = deps.current.appointmentId;
        if (!id) return;
        Promise.resolve().then(()=>(0, $eVM84.bffMutation)($93716c64561e7b22$export$e815fc2694be9771, {
                appointmentId: id,
                kind: item.kind,
                section: item.key,
                before: String(item.before ?? ''),
                after: String(item.after ?? ''),
                undone: !!undone
            })).catch((e)=>console.warn('[autoConfirm] not recorded:', e?.message || e));
    };
    const add = (0, $acw62.useCallback)((kind, records)=>{
        if (!records?.length) return;
        const d = deps.current;
        const items = records.map((r)=>({
                id: `ac-${++seq.current}`,
                kind: kind,
                key: r.key,
                label: r.label ?? d.labelOf?.(kind, r.key) ?? r.key,
                before: r.before ?? '',
                after: r.after ?? '',
                payload: r,
                undone: false
            }));
        items.forEach((item)=>record(item, false));
        // A place confirmed again is listed once, by its latest confirm: an undo takes
        // back one step — what this confirm replaced.
        setList((prev)=>[
                ...prev.filter((x)=>!items.some((i)=>i.kind === x.kind && i.key === x.key)),
                ...items
            ]);
        const labels = items.map((i)=>i.label);
        d.toast?.success?.(d.t?.('visit.autoConfirm.toast', {
            items: d.joinList ? d.joinList(labels) : labels.join(', ')
        }));
    }, []);
    const stateOf = (item)=>{
        if (item.undone) return 'undone';
        return $93716c64561e7b22$var$same(deps.current.read?.(item.kind, item.key), item.after) ? 'live' : 'edited';
    };
    const undo = (0, $acw62.useCallback)((id)=>{
        const item = listRef.current.find((x)=>x.id === id);
        if (!item || stateOf(item) !== 'live') return false;
        deps.current.undoers?.[item.kind]?.(item);
        record(item, true);
        setList((prev)=>prev.map((x)=>x.id === id ? {
                    ...x,
                    undone: true
                } : x));
        return true;
    }, []);
    const acknowledge = (0, $acw62.useCallback)(()=>setList([]), []);
    const items = list.map((item)=>({
            ...item,
            state: stateOf(item)
        }));
    const live = (kind, key)=>items.some((i)=>i.kind === kind && i.key === key && i.state === 'live');
    return {
        items: items,
        add: add,
        undo: undo,
        acknowledge: acknowledge,
        live: live
    };
}

});

parcelRegister("ajYTu", function(module, exports) {

$parcel$export(module.exports, "AutoConfirmBadge", () => $45d31e7f88e63e59$export$e0592dd1fb3ed14f);
$parcel$export(module.exports, "AutoConfirmChip", () => $45d31e7f88e63e59$export$5bcb9464994626a4);
// «تایید خودکار» on the visit (PM-0573, DESIGN_CONCEPT §13.3):
//
//   AutoConfirmBadge  what a note section or the vitals form wears while it holds
//                     what the switch wrote, unchanged — AI output stays labelled
//                     until the doctor owns it (edits it, or marks the list reviewed).
//   AutoConfirmChip   everything the switch confirmed in this visit, each with its
//                     undo. An anchored Menu on the desk; a BottomSheet on the phone,
//                     where a popover at the bottom edge is not a menu (DESIGN_SYSTEM §5).
//
// The list is useAutoConfirm().items. Colour is the accent family, as for every
// «تکمیل» surface, so a preset re-themes it.

var $acw62 = parcelRequire("acw62");

var $huNwV = parcelRequire("huNwV");
var $iDwyV = parcelRequire("iDwyV");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $cZOyb = parcelRequire("cZOyb");
var $bfs4Q = parcelRequire("bfs4Q");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
const $45d31e7f88e63e59$var$K = 'visit.autoConfirm';
function $45d31e7f88e63e59$export$e0592dd1fb3ed14f({ variant: variant = 'web', testid: testid, style: style }) {
    const { t: t } = (0, $LNQP4.default)();
    const mobile = variant === 'mobile';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": testid,
        title: t(`${$45d31e7f88e63e59$var$K}.badgeHint`),
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 3,
            flexShrink: 0,
            padding: mobile ? '0.0625rem 0.4375rem' : '1px 7px',
            borderRadius: 999,
            fontSize: mobile ? '0.6875rem' : '0.625rem',
            fontWeight: 700,
            lineHeight: 1.6,
            whiteSpace: 'nowrap',
            background: (0, $jTCZr.CT).accentSoft,
            color: (0, $jTCZr.CT).accentInk,
            border: `1px solid ${(0, $jTCZr.CT).accent}`,
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
        size: mobile ? 11 : 10,
        "aria-hidden": true
    }), " ", t(`${$45d31e7f88e63e59$var$K}.badge`));
}
function $45d31e7f88e63e59$var$ItemRow({ item: item, onUndo: onUndo, variant: variant, testid: testid }) {
    const { t: t } = (0, $LNQP4.default)();
    const mobile = variant === 'mobile';
    const rowId = `${testid}-item-${item.kind}-${item.key}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": rowId,
        "data-state": item.state,
        style: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: mobile ? '0.625rem' : 8,
            padding: mobile ? '0.625rem 0' : '7px 6px',
            borderBottom: `1px solid ${(0, $jTCZr.CT).border}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: mobile ? '0.8125rem' : '0.75rem',
            fontWeight: 700,
            color: (0, $jTCZr.CT).ink
        }
    }, item.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: "auto",
        style: {
            fontSize: mobile ? '0.75rem' : '0.6875rem',
            lineHeight: 1.6,
            color: (0, $jTCZr.CT).ink2,
            marginTop: 2,
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            overflowWrap: 'anywhere'
        }
    }, item.after)), item.state === 'live' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        role: "menuitem",
        onClick: ()=>onUndo(item.id),
        "data-testid": `${rowId}-undo`,
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 4,
            flexShrink: 0,
            minHeight: mobile ? '2.75rem' : undefined,
            padding: mobile ? '0.375rem 0.75rem' : '4px 9px',
            borderRadius: mobile ? 10 : 7,
            fontSize: mobile ? '0.8125rem' : '0.6875rem',
            fontWeight: 600,
            fontFamily: 'inherit',
            cursor: 'pointer',
            border: `1px solid ${(0, $jTCZr.CT).border}`,
            background: (0, $jTCZr.CT).surface,
            color: (0, $jTCZr.CT).ink2
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $iDwyV.default), {
        size: mobile ? 14 : 11,
        "aria-hidden": true
    }), " ", t(`${$45d31e7f88e63e59$var$K}.undo`)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flexShrink: 0,
            maxWidth: '45%',
            fontSize: mobile ? '0.75rem' : '0.65625rem',
            color: (0, $jTCZr.CT).ink2,
            lineHeight: 1.6
        }
    }, t(item.state === 'undone' ? `${$45d31e7f88e63e59$var$K}.undone` : `${$45d31e7f88e63e59$var$K}.edited`)));
}
function $45d31e7f88e63e59$export$5bcb9464994626a4({ items: items, onUndo: onUndo, onAcknowledge: onAcknowledge, variant: variant = 'web', testid: testid = 'visit-auto-confirm' }) {
    const { t: t, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const anchorRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const close = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>setOpen(false), []);
    if (!items?.length) return null;
    const mobile = variant === 'mobile';
    const n = formatNumber ? formatNumber(items.length) : String(items.length);
    const rows = items.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($45d31e7f88e63e59$var$ItemRow, {
            key: item.id,
            item: item,
            onUndo: onUndo,
            variant: variant,
            testid: testid
        }));
    const ack = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        role: mobile ? undefined : 'menuitem',
        "data-testid": `${testid}-ack`,
        onClick: ()=>{
            setOpen(false);
            onAcknowledge();
        },
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 5,
            width: '100%',
            minHeight: mobile ? '2.75rem' : undefined,
            padding: mobile ? '0.5rem 0.875rem' : '6px 12px',
            marginTop: mobile ? 0 : 6,
            borderRadius: mobile ? 10 : 7,
            fontSize: mobile ? '0.875rem' : '0.71875rem',
            fontWeight: 700,
            fontFamily: 'inherit',
            cursor: 'pointer',
            border: `1px solid ${(0, $jTCZr.CT).accent}`,
            background: (0, $jTCZr.CT).accent,
            color: (0, $jTCZr.CT).surface
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
        size: mobile ? 15 : 12,
        "aria-hidden": true
    }), " ", t(`${$45d31e7f88e63e59$var$K}.reviewed`));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        ref: anchorRef,
        type: "button",
        "data-testid": testid,
        title: t(`${$45d31e7f88e63e59$var$K}.chipHint`),
        "aria-label": t(`${$45d31e7f88e63e59$var$K}.chip`, {
            n: n
        }),
        "aria-haspopup": mobile ? 'dialog' : 'menu',
        "aria-expanded": open,
        onClick: ()=>setOpen((v)=>!v),
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 5,
            flexShrink: 0,
            whiteSpace: 'nowrap',
            minHeight: mobile ? '2.75rem' : undefined,
            padding: mobile ? '0.375rem 0.75rem' : '5px 11px',
            borderRadius: 999,
            fontSize: mobile ? '0.8125rem' : '0.75rem',
            fontWeight: 700,
            lineHeight: 1.6,
            fontFamily: 'inherit',
            cursor: 'pointer',
            background: (0, $jTCZr.CT).accentSoft,
            color: (0, $jTCZr.CT).accentInk,
            border: `1px solid ${(0, $jTCZr.CT).accent}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
        size: mobile ? 15 : 13,
        "aria-hidden": true
    }), " ", t(`${$45d31e7f88e63e59$var$K}.badge`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true,
        style: {
            minWidth: mobile ? '1.25rem' : 18,
            padding: '0 5px',
            borderRadius: 999,
            textAlign: 'center',
            fontSize: mobile ? '0.75rem' : '0.6875rem',
            lineHeight: mobile ? '1.25rem' : '18px',
            background: (0, $jTCZr.CT).accent,
            color: (0, $jTCZr.CT).surface
        }
    }, n)), mobile ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: open,
        onClose: close,
        title: t(`${$45d31e7f88e63e59$var$K}.title`),
        footer: ack,
        "data-testid": `${testid}-sheet`
    }, rows) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bfs4Q.default), {
        open: open,
        onClose: close,
        anchorRef: anchorRef,
        width: 340,
        placement: "auto",
        ariaLabel: t(`${$45d31e7f88e63e59$var$K}.title`),
        "data-testid": `${testid}-menu`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '4px 6px 6px',
            fontSize: '0.71875rem',
            fontWeight: 700,
            color: (0, $jTCZr.CT).ink
        }
    }, t(`${$45d31e7f88e63e59$var$K}.title`)), rows, ack));
}

});
parcelRegister("iDwyV", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6c970ba75b9f5ae$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $c6c970ba75b9f5ae$export$a2387ed3b5d536eb = {
    name: "rotate-ccw",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8",
                key: "1357e3"
            }
        ],
        [
            "path",
            {
                d: "M3 3v5h5",
                key: "1xhq8a"
            }
        ]
    ]
};
$c6c970ba75b9f5ae$export$a2387ed3b5d536eb.node;
const $c6c970ba75b9f5ae$export$2e2bcd8739ae039 = (0, $9QBug.default)($c6c970ba75b9f5ae$export$a2387ed3b5d536eb);

});


parcelRegister("l7onJ", function(module, exports) {

$parcel$export(module.exports, "applyMonitoringFindings", () => $f5fd2a1ce8ccb8d9$export$920e2c679038b5a0);
// «ثبت موارد انتخاب‌شده» of «استخراج از پایش بالینی» (PM-0029) — the writes, shared
// by the desktop and the phone Visit. Each finding goes through the path a
// hand-entered value takes:
//
//   علائم حیاتی   the form's own fields come back as a PATCH — the screen puts them in
//                the vitals form and the doctor presses «ثبت», so its range check,
//                its alerts and its replace-on-edit all still run. A vital sign the
//                form has no field for (تنفس, قد, قند خون) is recorded as an observation.
//   دستورات       createOrder, as an AI-suggested order is added — with the
//                catalogue entry it was matched to, so it carries its code.
//   حساسیت        addAllergy.
//   داروی جاری    addMedication with NO appointment — a record medication, not a line
//                of this visit's نسخه.
//   بیماری زمینه‌ای addCondition, active.
//   پیگیری        comes back as lines for the note's «P».
//
// One failed write does not undo the others: the result says how many of each
// landed and how many did not, and the screen says so.

var $eVM84 = parcelRequire("eVM84");

var $b4nOl = parcelRequire("b4nOl");

var $6xvbB = parcelRequire("6xvbB");
const $f5fd2a1ce8ccb8d9$export$b4ec7241301303fb = `mutation AddAllergy($patientId:ID!,$input:CreateAllergyInput!){addAllergy(patientId:$patientId,input:$input){id allergen reaction severity status}}`;
async function $f5fd2a1ce8ccb8d9$export$920e2c679038b5a0({ picked: picked, patientId: patientId, appointmentId: appointmentId, t: t }) {
    const today = new Date().toISOString().split('T')[0];
    const jobs = [];
    const orders = [];
    const add = (run)=>jobs.push(run());
    (0, $b4nOl.vitalObservations)(picked.vitals, t).forEach((e)=>add(()=>(0, $eVM84.bffMutation)((0, $6xvbB.ADD_OBSERVATION), {
                patientId: patientId,
                input: {
                    code: e.code,
                    display: e.display,
                    value: e.value,
                    unit: e.unit,
                    status: 'NORMAL',
                    effectiveDate: today,
                    appointmentId: appointmentId || undefined
                }
            })));
    picked.orders.map((0, $b4nOl.orderItemOf)).forEach((item)=>add(async ()=>{
            const data = await (0, $eVM84.bffMutation)((0, $6xvbB.CREATE_CLINICAL_ORDER), {
                appointmentId: appointmentId,
                patientId: patientId,
                orderType: item.orderType,
                description: item.name,
                urgency: item.urgency,
                notes: item.reason || '',
                // The catalogue entry the doctor confirmed (or that matched exactly): the
                // order is then the same row a hand-picked one is, code and all.
                ...item.catalogId ? {
                    catalogId: item.catalogId
                } : {},
                ...item.code ? {
                    code: item.code
                } : {}
            });
            if (!data?.createOrder) throw new Error('createOrder returned nothing');
            orders.push({
                item: item,
                created: data.createOrder
            });
        }));
    picked.record.forEach((f)=>{
        if (f.kind === 'allergy') add(()=>(0, $eVM84.bffMutation)($f5fd2a1ce8ccb8d9$export$b4ec7241301303fb, {
                patientId: patientId,
                input: {
                    allergen: f.text,
                    reaction: f.detail || '',
                    status: 'active'
                }
            }));
        else if (f.kind === 'current_medication') add(()=>(0, $eVM84.bffMutation)((0, $6xvbB.ADD_MEDICATION), {
                patientId: patientId,
                input: {
                    display: f.text,
                    status: 'active',
                    authoredOn: today,
                    dosageInstruction: f.detail ? {
                        text: f.detail
                    } : undefined,
                    meta: {
                        source: 'monitoring',
                        patientReported: true
                    }
                }
            }));
        else if (f.kind === 'condition') add(()=>(0, $eVM84.bffMutation)((0, $6xvbB.ADD_CONDITION), {
                patientId: patientId,
                input: {
                    display: f.text,
                    clinicalStatus: 'active',
                    meta: {
                        source: 'monitoring',
                        note: f.detail || undefined
                    }
                }
            }));
    });
    const settled = await Promise.allSettled(jobs);
    const failed = settled.filter((s)=>s.status === 'rejected');
    failed.forEach((s)=>console.warn('[monitoringApply] write failed:', s.reason));
    // A spent balance or a refused write must reach the doctor, not vanish in a count.
    const credit = failed.find((s)=>s.reason?.extensions?.code === 'INSUFFICIENT_CREDITS');
    const vitalsPatch = (0, $b4nOl.vitalsFormPatch)(picked.vitals);
    const followUps = (0, $b4nOl.followUpLines)(picked.record, t);
    return {
        vitalsPatch: vitalsPatch,
        orders: orders,
        followUps: followUps,
        saved: settled.length - failed.length,
        failed: failed.length,
        creditError: credit ? credit.reason.message : null
    };
}

});

parcelRegister("k6Haa", function(module, exports) {

$parcel$export(module.exports, "sweepHolds", () => $ea35d970f69d5497$export$9b1b472b8328535d);
// ── Which interaction findings the doctor has already been shown ─────────────
// The end-of-visit sweep is the one interaction check nobody asked for, and it
// holds a visit open only for a high-severity finding the doctor has NOT seen.
//
// "Seen" used to mean "some earlier result had some high finding". Adding a drug
// does not clear the result on the نسخه tab (only removing one does), so a check
// that flagged A + B, followed by adding C, let a NEW high A + C close the visit
// unstopped: the old A + B answered "already seen" for it. A finding is now known
// by the drugs it names, and an earlier result counts only when it was computed
// for THIS نسخه — its `signature` (rxCheckSignature) equals the current one.
//
// Used by both useEndVisit (desktop) and Visit.mobile.jsx's handleEnd, so the two
// cannot disagree about when a visit may close.
// How the service writes a pair: "<drug> + <drug>" is what it asks its model for,
// the rest is what models write anyway (aiassitant medication_names._PAIR_SPLIT).
// Not "/" or "-": both occur inside drug names.
const $ea35d970f69d5497$var$PAIR_SPLIT = /\s*\+\s*|\s*[,،;&]\s*|\s+(?:and|with|vs\.?|و|مع)\s+/i;
// Case, spacing, ZWNJ and the Arabic forms of ی / ک do not make a different drug.
const $ea35d970f69d5497$var$drugKey = (name)=>String(name || '').replace(/ي/g, "\u06CC").replace(/ك/g, "\u06A9").replace(/[\s\u200C]+/g, '').toLowerCase();
const $ea35d970f69d5497$export$d203c3f0dcf18f13 = (w)=>{
    const pair = String(w?.drugPair || '').trim();
    const named = pair ? pair.split($ea35d970f69d5497$var$PAIR_SPLIT) : [
        w?.drug
    ];
    const drugs = [
        ...new Set(named.map($ea35d970f69d5497$var$drugKey).filter(Boolean))
    ].sort();
    if (drugs.length > 0) return drugs.join('+');
    // A finding that names no drug has only its wording to be known by.
    return `?${$ea35d970f69d5497$var$drugKey(w?.description)}`;
};
// «High», «HIGH » and «high» are one severity — compared verbatim, a model that
// capitalised let a شدید finding close the visit unstopped. The server
// normalises too; the sweep does not rely on it (Visit.shared normalizeSeverity).
const $ea35d970f69d5497$var$isHigh = (w)=>typeof w?.severity === 'string' && w.severity.trim().toLowerCase() === 'high';
const $ea35d970f69d5497$export$f00407a316e4306b = (warnings)=>(warnings || []).filter($ea35d970f69d5497$var$isHigh).map($ea35d970f69d5497$export$d203c3f0dcf18f13);
function $ea35d970f69d5497$export$2f7a0c550c40d1e3(warnings, { shown: shown, signature: signature, seenKeys: seenKeys } = {}) {
    const seen = new Set(seenKeys || []);
    if (signature != null && shown?.signature === signature) $ea35d970f69d5497$export$f00407a316e4306b(shown.warnings).forEach((k)=>seen.add(k));
    return (warnings || []).filter((w)=>$ea35d970f69d5497$var$isHigh(w) && !seen.has($ea35d970f69d5497$export$d203c3f0dcf18f13(w)));
}
function $ea35d970f69d5497$export$9b1b472b8328535d(warnings, { shown: shown, signature: signature, memo: memo } = {}) {
    const earlier = signature != null && memo?.current?.signature === signature ? memo.current.keys : [];
    const unseen = $ea35d970f69d5497$export$2f7a0c550c40d1e3(warnings, {
        shown: shown,
        signature: signature,
        seenKeys: earlier
    });
    if (unseen.length === 0) return false;
    if (memo) memo.current = {
        signature: signature,
        keys: [
            ...earlier,
            ...$ea35d970f69d5497$export$f00407a316e4306b(warnings)
        ]
    };
    return true;
}

});

parcelRegister("5qIQm", function(module, exports) {

$parcel$export(module.exports, "doctorOrderInput", () => $3f422a714825191a$export$b7142a5aec62c528);
$parcel$export(module.exports, "saveDoctorOrder", () => $3f422a714825191a$export$12af1fa985734757);

var $eVM84 = parcelRequire("eVM84");

var $6xvbB = parcelRequire("6xvbB");

var $feEcD = parcelRequire("feEcD");
const $3f422a714825191a$export$b7142a5aec62c528 = (item)=>{
    const sessions = Number(item?.sessionCount);
    return {
        orderType: item.type || 'lab',
        name: item.name || item.testName || item,
        code: item.code || item.loincCode || '',
        urgency: item.urgency || 'routine',
        description: item.reason || '',
        ...item.catalogId ? {
            catalogId: item.catalogId
        } : {},
        ...Number.isInteger(sessions) && sessions > 0 ? {
            sessionCount: sessions
        } : {},
        ...(0, $feEcD.isIsoDay)(item?.performedDate) ? {
            performedDate: item.performedDate
        } : {}
    };
};
async function $3f422a714825191a$export$12af1fa985734757({ patientId: patientId, appointmentId: appointmentId }, order) {
    if (order?.performedDate) {
        const { orderType: orderType, name: name, code: code, urgency: urgency, description: description, catalogId: catalogId, sessionCount: sessionCount, performedDate: performedDate } = order;
        const res = await (0, $eVM84.bffMutation)((0, $6xvbB.CREATE_CLINICAL_ORDER), {
            appointmentId: appointmentId,
            patientId: patientId,
            orderType: orderType,
            description: name,
            urgency: urgency || 'routine',
            notes: description || '',
            code: code || null,
            catalogId: catalogId || null,
            sessionCount: sessionCount > 1 ? sessionCount : null,
            performedDate: performedDate
        });
        if (!res?.createOrder) throw new Error(`order not saved: ${name || ''}`);
        return {
            success: true,
            savedCount: 1,
            error: null
        };
    }
    const res = await (0, $eVM84.bffMutation)((0, $6xvbB.SAVE_DOCTOR_ORDERS), {
        input: {
            patientId: patientId,
            appointmentId: appointmentId,
            orders: [
                order
            ]
        }
    });
    const result = res?.saveDoctorOrders;
    if (!result?.success || !(result.savedCount >= 1)) throw new Error(result?.error || `order not saved: ${order?.name || ''}`);
    return result;
}

});
parcelRegister("feEcD", function(module, exports) {

$parcel$export(module.exports, "ORDER_DATE_PRESETS", () => $02dcc3811b738f85$export$9c11016e60757ddd);
$parcel$export(module.exports, "ORDER_DATE_MONTH_PRESETS", () => $02dcc3811b738f85$export$6bdc83423dc91e3a);
$parcel$export(module.exports, "presetDay", () => $02dcc3811b738f85$export$ed11e774b5e6b8c9);
$parcel$export(module.exports, "clinicTodayIso", () => $02dcc3811b738f85$export$c7a9ec666ee70e6a);
$parcel$export(module.exports, "isIsoDay", () => $02dcc3811b738f85$export$41e22fc80132ad8a);
$parcel$export(module.exports, "orderDateToSend", () => $02dcc3811b738f85$export$381e9fa50ae519d7);
$parcel$export(module.exports, "orderDateProblem", () => $02dcc3811b738f85$export$255167d6f6394add);
$parcel$export(module.exports, "orderDayOf", () => $02dcc3811b738f85$export$1d9b4a1d3a894455);
$parcel$export(module.exports, "dayInstant", () => $02dcc3811b738f85$export$d78ad2329e3ec4fb);
$parcel$export(module.exports, "orderDateLock", () => $02dcc3811b738f85$export$9c90cedebba92f38);
$parcel$export(module.exports, "orderWhenOf", () => $02dcc3811b738f85$export$6a7480206f5041d7);
// ─────────────────────────────────────────────────────────────────────────────
// «تاریخ انجام» — the day an order is to be done (PM-0634,
// docs/ORDER_DATE_AND_STAGE_PLAN.md §2.1).
//
// The clinical service stores it on the order as the clinic's calendar day,
// 'YYYY-MM-DD' (`performedDate`); an order written before the field has none and
// is read as the day it was written. The moment an order WAS done is a session's
// `performed_at`, never this.
//
// The doctor picks it like «فوریت», once for every item picked: امروز (the
// default), ۱ ماه, ۳ ماه, ۱ سال or a day of their own — never one already past,
// which the service refuses too. «امروز» is SENT AS NOTHING: the service's own
// default is the clinic's today on the clinic's clock, which a browser in another
// zone could disagree with around midnight.
//
// The clinic's zone: the host's, when it hands the kit one
// (`configureClinical({ clinicTimeZone })` = `Membership.timezone`, PM-0618 /
// PM-0635(2)); else the zone every other date of the kit is formatted on, the
// locale descriptors' `timeZone` (i18n/config.js). Each function takes the zone
// as an argument; `orderClinicZone` is the one place that picks it.
// ─────────────────────────────────────────────────────────────────────────────

var $eLeza = parcelRequire("eLeza");
parcelRequire("kQnM4");
var $4UJrq = parcelRequire("4UJrq");

var $Hy6Lb = parcelRequire("Hy6Lb");

var $e317r = parcelRequire("e317r");
const $02dcc3811b738f85$export$9c11016e60757ddd = [
    'TODAY',
    'ONE_MONTH',
    'TWO_MONTHS',
    'THREE_MONTHS',
    'SIX_MONTHS',
    'CUSTOM'
];
const $02dcc3811b738f85$var$PRESET_MONTHS = {
    ONE_MONTH: 1,
    TWO_MONTHS: 2,
    THREE_MONTHS: 3,
    SIX_MONTHS: 6,
    ONE_YEAR: 12
};
const $02dcc3811b738f85$export$6bdc83423dc91e3a = $02dcc3811b738f85$export$9c11016e60757ddd.filter((p)=>$02dcc3811b738f85$var$PRESET_MONTHS[p]);
const $02dcc3811b738f85$export$ed11e774b5e6b8c9 = (preset, today = $02dcc3811b738f85$export$c7a9ec666ee70e6a())=>$02dcc3811b738f85$var$PRESET_MONTHS[preset] ? $02dcc3811b738f85$export$c1dd2bb555c13349(today, $02dcc3811b738f85$var$PRESET_MONTHS[preset]) || null : null;
const $02dcc3811b738f85$var$ISO_DAY = /^(\d{4})-(\d{2})-(\d{2})$/;
const $02dcc3811b738f85$var$pad2 = (n)=>String(n).padStart(2, '0');
function $02dcc3811b738f85$export$41e22fc80132ad8a(value) {
    const m = $02dcc3811b738f85$var$ISO_DAY.exec(String(value ?? ''));
    if (!m) return false;
    const d = new Date(Date.UTC(+m[1], +m[2] - 1, +m[3]));
    return d.getUTCFullYear() === +m[1] && d.getUTCMonth() === +m[2] - 1 && d.getUTCDate() === +m[3];
}
const $02dcc3811b738f85$export$3fdad7c2856bd61 = ()=>(0, $e317r.hostClinicTimeZone)() || (0, $Hy6Lb.localeDescriptor)((0, $Hy6Lb.DEFAULT_LOCALE))?.timeZone || 'Asia/Tehran';
const $02dcc3811b738f85$var$dayFormatters = new Map();
function $02dcc3811b738f85$var$dayFormatter(zone) {
    let f = $02dcc3811b738f85$var$dayFormatters.get(zone);
    if (!f) {
        f = new Intl.DateTimeFormat('en-CA', {
            timeZone: zone,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        });
        $02dcc3811b738f85$var$dayFormatters.set(zone, f);
    }
    return f;
}
// The service writes `created_at` as a UTC wall time with no zone on it
// («2026-10-25T08:00:00.123456»), which `Date.parse` would read on the browser's
// clock. Anything without a designator is therefore read as UTC.
function $02dcc3811b738f85$var$instantMs(value) {
    if (value == null || value === '') return NaN;
    if (value instanceof Date) return value.getTime();
    if (typeof value === 'number') return value;
    const s = String(value).trim();
    if (/^\d+$/.test(s)) return Number(s);
    if ($02dcc3811b738f85$var$ISO_DAY.test(s)) return Date.parse(`${s}T12:00:00Z`);
    const zoned = /([zZ]|[+-]\d{2}:?\d{2})$/.test(s);
    return Date.parse(zoned ? s : `${s.replace(' ', 'T')}Z`);
}
function $02dcc3811b738f85$export$3645ad84ca71ae30(value, zone = $02dcc3811b738f85$export$3fdad7c2856bd61()) {
    const ms = $02dcc3811b738f85$var$instantMs(value);
    if (!Number.isFinite(ms)) return '';
    const o = {};
    for (const { type: type, value: v } of $02dcc3811b738f85$var$dayFormatter(zone).formatToParts(new Date(ms)))o[type] = v;
    return `${o.year}-${o.month}-${o.day}`;
}
const $02dcc3811b738f85$export$c7a9ec666ee70e6a = (now = Date.now(), zone = $02dcc3811b738f85$export$3fdad7c2856bd61())=>$02dcc3811b738f85$export$3645ad84ca71ae30(now, zone);
// Months are counted on the CLINIC's calendar — Jalali, unless the brand puts the
// product on the Gregorian one (`calendar: 'gregory'`, ui/lib/brand.js), as the
// analysis timeline counts them: ۱ ماه from ۳ آبان is ۳ آذر, and a day the target
// month lacks becomes its last (۳۱ شهریور → ۳۰ مهر).
const $02dcc3811b738f85$var$gregorianClinic = ()=>(0, $eLeza.calendarSystem)('jalali') === 'gregory';
function $02dcc3811b738f85$export$c1dd2bb555c13349(isoDay, months) {
    if (!$02dcc3811b738f85$export$41e22fc80132ad8a(isoDay)) return '';
    const [y0, m0, d0] = isoDay.split('-').map(Number);
    if ($02dcc3811b738f85$var$gregorianClinic()) {
        const index = y0 * 12 + (m0 - 1) + months;
        const y = Math.floor(index / 12);
        const m = index - y * 12 + 1;
        const last = new Date(Date.UTC(y, m, 0)).getUTCDate();
        return `${y}-${$02dcc3811b738f85$var$pad2(m)}-${$02dcc3811b738f85$var$pad2(Math.min(d0, last))}`;
    }
    const j = (0, $4UJrq.msToJalali)(Date.UTC(y0, m0 - 1, d0));
    if (!j) return '';
    const index = j.y * 12 + (j.m - 1) + months;
    const y = Math.floor(index / 12);
    const m = index - y * 12 + 1;
    return new Date((0, $4UJrq.jalaliToMs)(y, m, Math.min(j.d, (0, $4UJrq.jDaysInMonth)(y, m)))).toISOString().slice(0, 10);
}
function $02dcc3811b738f85$export$381e9fa50ae519d7(choice, today = $02dcc3811b738f85$export$c7a9ec666ee70e6a()) {
    const preset = choice?.preset || 'TODAY';
    if (preset === 'TODAY') return null;
    if (preset === 'CUSTOM') return $02dcc3811b738f85$export$41e22fc80132ad8a(choice.date) ? choice.date : null;
    const months = $02dcc3811b738f85$var$PRESET_MONTHS[preset];
    return months ? $02dcc3811b738f85$export$c1dd2bb555c13349(today, months) || null : null;
}
function $02dcc3811b738f85$export$255167d6f6394add(choice, today = $02dcc3811b738f85$export$c7a9ec666ee70e6a()) {
    if (choice?.preset !== 'CUSTOM') return null;
    if (!$02dcc3811b738f85$export$41e22fc80132ad8a(choice.date)) return 'pickDate';
    return choice.date < today ? 'pastDate' : null;
}
function $02dcc3811b738f85$export$1d9b4a1d3a894455(order, zone = $02dcc3811b738f85$export$3fdad7c2856bd61()) {
    if ($02dcc3811b738f85$export$41e22fc80132ad8a(order?.performedDate)) return order.performedDate;
    return $02dcc3811b738f85$export$3645ad84ca71ae30(order?.createdAt, zone);
}
const $02dcc3811b738f85$export$d78ad2329e3ec4fb = (isoDay)=>$02dcc3811b738f85$export$41e22fc80132ad8a(isoDay) ? new Date(`${isoDay}T12:00:00Z`) : null;
// The e-prescription line states that mean the insurer holds the order: as it is
// (REGISTERED) or in an older form (CHANGED). ADDED never reached it; REMOVED is
// no longer the visit's.
const $02dcc3811b738f85$var$AT_INSURER = new Set([
    'REGISTERED',
    'CHANGED'
]);
function $02dcc3811b738f85$export$9c90cedebba92f38(order, erxLine = null) {
    if (!order || ![
        'pending',
        'in_progress'
    ].includes(order.status)) return 'closed';
    if (erxLine && $02dcc3811b738f85$var$AT_INSURER.has(erxLine.state)) return 'registered';
    return null;
}
function $02dcc3811b738f85$export$6a7480206f5041d7(order, { inHouse: inHouse, visitOnline: visitOnline = false, today: today = $02dcc3811b738f85$export$c7a9ec666ee70e6a() } = {}) {
    if (!inHouse || !order || order.processId || ![
        'pending',
        'in_progress'
    ].includes(order.status)) return null;
    if (order.sameVisit === true) return {
        key: 'sameVisit'
    };
    const day = $02dcc3811b738f85$export$1d9b4a1d3a894455(order);
    if (day && day > today) return {
        key: 'later',
        date: day
    };
    if (visitOnline) return {
        key: 'todayOnline'
    };
    return null;
}

});
parcelRegister("kQnM4", function(module, exports) {
$parcel$export(module.exports, "IRAN_OFFSET_MS", () => (parcelRequire("4UJrq")).IRAN_OFFSET_MS);
$parcel$export(module.exports, "jalaliToMs", () => (parcelRequire("4UJrq")).jalaliToMs);
$parcel$export(module.exports, "jDaysInMonth", () => (parcelRequire("4UJrq")).jDaysInMonth);
$parcel$export(module.exports, "msToJalali", () => (parcelRequire("4UJrq")).msToJalali);
parcelRequire("4UJrq");

});



parcelRegister("dLdf9", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b153162db005cb6$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $bSvYG = parcelRequire("bSvYG");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
parcelRequire("7sS0P");
var $jTCZr = parcelRequire("jTCZr");
var $7sS0P = parcelRequire("7sS0P");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $1HT9m = parcelRequire("1HT9m");

var $cwVZP = parcelRequire("cwVZP");
function $4b153162db005cb6$export$2e2bcd8739ae039({ error: error, title: title, detail: detail, onRetry: onRetry, retryLabel: retryLabel, note: note }) {
    const { t: t } = (0, $LNQP4.default)();
    // NOTE: these defaults live in the body, not in the parameter list. Written as
    // `title = t('errors.unavailableInfo')` they threw ReferenceError — default
    // parameters are evaluated in their own scope, which cannot see the `const t`
    // below — so omitting `title` crashed the component whose entire job is to
    // render a crash. Every call site happened to pass one, which is the only
    // reason it went unnoticed.
    const kind = error ? (0, $cwVZP.classifyError)(error) : null;
    // The two halves of a useful error message answer different questions, and a
    // screen and the taxonomy each own one of them. The screen knows WHAT failed
    // («گزارش حسابداری در دسترس نیست»); only the classifier knows WHY («دستگاه
    // شما به اینترنت متصل نیست»). Showing just the first leaves the doctor
    // hunting for a fault in the accounting service when their Wi-Fi is off;
    // showing just the second loses which part of the screen is now unreliable.
    // So the caller's title heads the card and the kind's body explains it.
    const heading = title ?? (kind ? t(`${(0, $cwVZP.kindKey)(kind)}.title`) : t('errors.unavailableInfo'));
    const explanation = note ?? (kind ? t(`${(0, $cwVZP.kindKey)(kind)}.body`) : null);
    const technical = detail !== undefined ? detail : error ? (0, $cwVZP.errorDetail)(error) : null;
    const retryLabelText = retryLabel ?? t('common.actions.retry');
    // A retry button on a 403 or a 404 invites the doctor to keep pressing
    // something that cannot work. When we know the kind, it decides.
    const showRetry = Boolean(onRetry) && (kind ? (0, $cwVZP.isRetryable)(kind) : true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "error-state",
        "data-error-kind": kind || undefined,
        role: "alert",
        style: {
            background: (0, $jTCZr.C).card,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: (0, $7sS0P.RADIUS).card,
            boxShadow: (0, $7sS0P.SHADOW).card,
            padding: '2.5rem 1.75rem',
            textAlign: 'center',
            maxWidth: '30rem',
            margin: '1.5rem auto'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 56,
            height: 56,
            borderRadius: (0, $7sS0P.RADIUS).pill,
            background: (0, $jTCZr.C).redLight,
            color: (0, $jTCZr.C).red,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 1rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bSvYG.default), {
        size: 28,
        strokeWidth: 1.9,
        "aria-hidden": true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            ...(0, $1HT9m.type).metric,
            color: (0, $jTCZr.C).textPrimary,
            marginBottom: '0.5rem'
        }
    }, heading), explanation && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            ...(0, $1HT9m.type).body,
            fontWeight: 500,
            color: (0, $jTCZr.C).textSecondary,
            marginBottom: '0.75rem',
            lineHeight: 1.8
        }
    }, explanation), technical && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            ...(0, $1HT9m.type).caption,
            color: (0, $jTCZr.C).textMuted,
            direction: 'ltr',
            fontFamily: 'monospace',
            wordBreak: 'break-word',
            background: (0, $jTCZr.C).bg,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: (0, $7sS0P.RADIUS).chip,
            padding: '0.5rem 0.625rem',
            marginBottom: '1.25rem'
        }
    }, technical), showRetry && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        type: "button",
        onClick: onRetry,
        "data-testid": "error-state-retry"
    }, retryLabelText));
}

});
parcelRegister("bSvYG", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb1b2f70e9c265fc$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $cb1b2f70e9c265fc$export$a2387ed3b5d536eb = {
    name: "circle-alert",
    size: 24,
    node: [
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                r: "10",
                key: "1mglay"
            }
        ],
        [
            "line",
            {
                x1: "12",
                x2: "12",
                y1: "8",
                y2: "12",
                key: "1pkeuh"
            }
        ],
        [
            "line",
            {
                x1: "12",
                x2: "12.01",
                y1: "16",
                y2: "16",
                key: "4dfq90"
            }
        ]
    ],
    aliases: [
        "alert-circle"
    ]
};
$cb1b2f70e9c265fc$export$a2387ed3b5d536eb.node;
const $cb1b2f70e9c265fc$export$2e2bcd8739ae039 = (0, $9QBug.default)($cb1b2f70e9c265fc$export$a2387ed3b5d536eb);

});

parcelRegister("1HT9m", function(module, exports) {

$parcel$export(module.exports, "type", () => $13e4963cbb566500$export$bf9fb029d174d554);
// ─────────────────────────────────────────────────────────────────────────────
// Centralized typography scale for the Parsina doctor app.
//
// FONT FAMILY is global and inherited — never set it inline.
//   `styles.css` sets `font-family: var(--app-font)` on <body> + all form
//   controls, and `--app-font` follows the doctor's typeface choice
//   (Settings → ظاهر برنامه → قلم; catalogue in src/constants/fonts.js, default
//   «Meshkat» = Vazirmatn). Every element inherits it. These tokens deliberately
//   OMIT `fontFamily` so text always resolves to that single global face — the
//   moment a component hardcodes a family (or an outlier weight/letter-spacing)
//   it visually forks from the page AND stops following the doctor's choice.
//
// SIZES are in `rem`, not `px`, so they scale with the app's font-size preference
//   (Settings → ظاهر drives the root font-size; see tokens.css `data-font-size`).
//   1rem = 16px at the default "medium" setting, so each token matches the value
//   it replaced by default while now scaling for "small"/"large" too.
//
// USAGE — spread a role token, then layer only colour/margins on top:
//   <div style={{ ...type.title, color: C.textPrimary }}>عنوان</div>
//   <span style={{ ...type.hero }}>{fmtCoins(balance, formatNumber)}</span>
// One import, one scale — future components inherit the same typography.
// ─────────────────────────────────────────────────────────────────────────────
const $13e4963cbb566500$export$bf9fb029d174d554 = {
    // Headline number — the balance. Bold for hierarchy, but a scale weight (800),
    // not the ad-hoc 900+negative-tracking that read as a different font.
    hero: {
        fontSize: '2.25rem',
        fontWeight: 800,
        lineHeight: 1.05
    },
    // Large value — hero on compact/mobile surfaces.
    display: {
        fontSize: '1.625rem',
        fontWeight: 800,
        lineHeight: 1.1
    },
    // KPI / stat value.
    metric: {
        fontSize: '1.1875rem',
        fontWeight: 800,
        lineHeight: 1.2
    },
    // Card / section headings.
    title: {
        fontSize: '0.9375rem',
        fontWeight: 800,
        lineHeight: 1.3
    },
    // Numeric amounts (transaction rows, group totals).
    amount: {
        fontSize: '0.875rem',
        fontWeight: 800,
        lineHeight: 1.2
    },
    // Primary body / row text.
    body: {
        fontSize: '0.8125rem',
        fontWeight: 700,
        lineHeight: 1.4
    },
    // Field / stat labels.
    label: {
        fontSize: '0.75rem',
        fontWeight: 600,
        lineHeight: 1.4
    },
    // Secondary meta.
    caption: {
        fontSize: '0.6875rem',
        fontWeight: 600,
        lineHeight: 1.4
    },
    // Tiny meta / dot labels.
    micro: {
        fontSize: '0.625rem',
        fontWeight: 700,
        lineHeight: 1.4
    },
    // Unit suffix («پارسه»), sits beside a value in a lighter weight.
    unit: {
        fontSize: '0.75rem',
        fontWeight: 700
    }
};
var $13e4963cbb566500$export$2e2bcd8739ae039 = $13e4963cbb566500$export$bf9fb029d174d554;

});


parcelRegister("64nJX", function(module, exports) {

$parcel$export(module.exports, "default", () => $577e5af2575afc25$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $dSwFB = parcelRequire("dSwFB");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
// ─────────────────────────────────────────────────────────────────────────────
// The gradient screen header — now a thin wrapper over the kit's `MobileHeader`
// (@parsina/framework), not a fork of it.
//
// It WAS a fork. DESIGN.md names `MobileHeader` and `BottomNav` as the mobile
// chrome the kit ships "so no app hand-rolls them again", and the clinic and
// patient apps consume the kit versions — so this app's private copy was the
// third implementation of one component, and a third implementation is how the
// surfaces drift. Compared line by line, the app's copy differed by exactly two
// things — a `backTestId` escape hatch and the `Icon`-as-component action shape
// — and both survive here, in ~40 lines, on top of the kit.
//
// The app-facing API is unchanged on purpose, so no screen edits:
//   doctor      → the kit's `user` (cockpit greeting mode)
//   actions     → [{ key, Icon, label, onClick, badge }] with `Icon` as a
//                 COMPONENT; the kit takes a rendered node, so the size and the
//                 `aria-hidden` are applied once here rather than at every call
//                 site.
//   backTestId  → forwarded to the kit prop of the same name, added for exactly
//                 this: Messages' selector contract names
//                 'messages-header-back' and must not have to rename the header
//                 to keep it.
//   backLabel   → defaults to the translated «بازگشت». The kit's own default is
//                 a Persian literal, which is right for a kit and wrong for an
//                 app that also ships en/ar.
//
// Passed straight through: `sticky` (a filter bar in `children` stays reachable
// while the list scrolls under it) and `search` (the on-gradient search field a
// lookup screen opens into).
// ─────────────────────────────────────────────────────────────────────────────
const $577e5af2575afc25$var$MobileHeader = ({ doctor: doctor, title: title, subtitle: subtitle, onBack: onBack, backLabel: backLabel, backTestId: backTestId = 'mobile-header-back', actions: actions = [], action: action, compact: compact = false, avatar: avatar, leading: leading, onTitleClick: onTitleClick, titleActionLabel: titleActionLabel, sticky: sticky = false, search: search, children: children, // Everything else goes straight to the kit header — notably `figures*`
// (PM-0120). Naming each prop dropped the new ones silently: the record's
// figures row never appeared on beta1 although the BFF sent the visit count.
...rest })=>{
    const { t: t } = (0, $LNQP4.default)();
    const kitActions = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>actions.map(({ key: key, Icon: Icon, label: label, onClick: onClick, badge: badge })=>({
                key: key,
                label: label,
                onClick: onClick,
                badge: badge,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
                    size: 18,
                    "aria-hidden": true
                })
            })), [
        actions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dSwFB.default), {
        user: doctor,
        greeting: t('dashboard.welcome'),
        title: title,
        subtitle: subtitle,
        onBack: onBack,
        backLabel: backLabel || t('common.actions.back'),
        backTestId: backTestId,
        actions: kitActions,
        action: action,
        compact: compact,
        avatar: avatar,
        leading: leading,
        onTitleClick: onTitleClick,
        titleActionLabel: titleActionLabel,
        sticky: sticky,
        search: search,
        ...rest
    }, children);
};
var $577e5af2575afc25$export$2e2bcd8739ae039 = $577e5af2575afc25$var$MobileHeader;

});

parcelRegister("dBAbF", function(module, exports) {

$parcel$export(module.exports, "default", () => $40b242509fe3ec60$export$2e2bcd8739ae039);
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");
parcelRequire("7sS0P");
var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");

var $QG9Z3 = parcelRequire("QG9Z3");
parcelRequire("gcegg");
var $jTCZr = parcelRequire("jTCZr");
// The allergy safety band (patient-record chrome): a persistent danger-toned
// strip directly under the header so a critical allergy is never a tab away.
// Read-only, tokens-only, horizontally scroll-safe on a crowded list. Renders
// nothing when there is no allergy to warn about.
const $40b242509fe3ec60$var$MobilePatientAllergyStrip = ({ allergies: allergies = [] })=>{
    const { t: t } = (0, $LNQP4.default)();
    const items = allergies.map((a)=>typeof a === 'string' ? {
            allergen: a,
            severity: null
        } : a).filter((a)=>a && a.allergen);
    if (!items.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "patient-allergy-strip",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0.375rem 1rem',
            background: (0, $jTCZr.CT).dangerSoft,
            borderBottom: `1px solid ${(0, $jTCZr.soft)((0, $jTCZr.C).red, 0.15)}`,
            overflowX: 'auto',
            flexShrink: 0,
            scrollbarWidth: 'none'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.25rem',
            flexShrink: 0,
            color: (0, $jTCZr.CT).dangerInk
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $QG9Z3.default), {
        size: 13,
        strokeWidth: 2.4,
        "aria-hidden": true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.625rem',
            fontWeight: 800,
            letterSpacing: '0.06em'
        }
    }, t('patient.allergies.title'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: '0.3125rem',
            flexShrink: 0
        }
    }, items.map((a, i)=>{
        const high = a.severity === 'high' || a.severity === 'severe';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            key: i,
            style: {
                fontSize: '0.6875rem',
                fontWeight: 600,
                padding: '0.125rem 0.5rem',
                borderRadius: '0.75rem',
                whiteSpace: 'nowrap',
                background: high ? (0, $jTCZr.soft)((0, $jTCZr.C).red, 0.1) : (0, $jTCZr.C).amberLight,
                color: high ? (0, $jTCZr.CT).dangerInk : (0, $jTCZr.CT).warnInk
            }
        }, a.allergen);
    })));
};
var $40b242509fe3ec60$export$2e2bcd8739ae039 = $40b242509fe3ec60$var$MobilePatientAllergyStrip;

});
parcelRegister("gcegg", function(module, exports) {

$parcel$export(module.exports, "faDate", () => $652abbe9694ab398$export$372861cd7d55d715);
$parcel$export(module.exports, "Pill", () => $652abbe9694ab398$export$d2cf3038149dd1b5);
$parcel$export(module.exports, "SectionTitle", () => $652abbe9694ab398$export$69bc41ee738923ec);
$parcel$export(module.exports, "ObservationRow", () => $652abbe9694ab398$export$a344623fbba4b280);
$parcel$export(module.exports, "VitalsStrip", () => $652abbe9694ab398$export$a80c208d4b2a2828);
$parcel$export(module.exports, "soft", () => (parcelRequire("jTCZr")).soft);

var $acw62 = parcelRequire("acw62");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
parcelRequire("7sS0P");
var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $g6X9N = parcelRequire("g6X9N");
var $3Amwd = parcelRequire("3Amwd");

var $8g4t5 = parcelRequire("8g4t5");

var $01rTJ = parcelRequire("01rTJ");
const $652abbe9694ab398$export$372861cd7d55d715 = (v, formatDate)=>{
    if (!v) return '';
    return formatDate ? formatDate(v, 'short') : '';
};
// Semantic pill tones, all resolved from tokens (no raw hex, §2.2).
const $652abbe9694ab398$var$PILL_TONE = {
    navy: {
        bg: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.09),
        color: (0, $jTCZr.C).navy
    },
    teal: {
        bg: (0, $jTCZr.CT).accentSoft,
        color: (0, $jTCZr.CT).accentInk
    },
    amber: {
        bg: (0, $jTCZr.C).amberLight,
        color: (0, $jTCZr.CT).warnInk
    },
    danger: {
        bg: (0, $jTCZr.C).redLight,
        color: (0, $jTCZr.CT).dangerInk
    },
    good: {
        bg: (0, $jTCZr.C).greenLight,
        color: (0, $jTCZr.CT).goodInk
    },
    muted: {
        bg: (0, $jTCZr.CT).surface2,
        color: (0, $jTCZr.C).textSecondary
    }
};
const $652abbe9694ab398$export$d2cf3038149dd1b5 = ({ children: children, tone: tone = 'teal', style: style })=>{
    const palette = $652abbe9694ab398$var$PILL_TONE[tone] || $652abbe9694ab398$var$PILL_TONE.teal;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.625rem',
            fontWeight: 700,
            padding: '0.125rem 0.5rem',
            borderRadius: '0.75rem',
            background: palette.bg,
            color: palette.color,
            whiteSpace: 'nowrap',
            ...style
        }
    }, children);
};
const $652abbe9694ab398$export$69bc41ee738923ec = ({ children: children, action: action })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.6875rem',
            fontWeight: 700,
            color: (0, $jTCZr.C).textMuted,
            textTransform: 'uppercase',
            letterSpacing: '0.06em'
        }
    }, children), action);
const $652abbe9694ab398$export$6d88ebe453be59d7 = ({ onClick: onClick, label: label, testId: testId })=>{
    const { t: t } = (0, $LNQP4.default)();
    const labelText = label ?? t('common.actions.add');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "default",
        size: "sm",
        "data-testid": testId,
        onClick: onClick,
        className: "gap-1 min-h-11"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8g4t5.default), {
        size: 13,
        strokeWidth: 2.6,
        "aria-hidden": true
    }), labelText);
};
const $652abbe9694ab398$export$1d9ba1b0141b442f = ({ label: label, value: value })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            background: (0, $jTCZr.C).card,
            borderRadius: '0.625rem',
            padding: '0.8125rem 1rem',
            border: `1px solid ${(0, $jTCZr.C).border}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.75rem',
            color: (0, $jTCZr.C).textMuted
        }
    }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.8125rem',
            fontWeight: 600,
            color: (0, $jTCZr.C).textPrimary
        }
    }, value));
const $652abbe9694ab398$export$a344623fbba4b280 = ({ test: test, onOpen: onOpen, testId: testId })=>{
    const { t: t, formatDate: formatDate, formatDigits: formatDigits } = (0, $LNQP4.default)();
    const last = test.readings[test.readings.length - 1];
    const abn = (0, $01rTJ.isAbnormalStatus)(last?.status);
    const delta = (0, $01rTJ.lastDelta)(test.readings);
    const points = test.readings.slice(-6).map((r)=>r.value);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $g6X9N.default), {
        onClick: onOpen,
        "aria-label": t('patient.obs.showTrendAria', {
            name: test.display
        }),
        "data-testid": testId,
        style: {
            padding: '0.75rem 0.875rem',
            borderColor: abn ? (0, $jTCZr.CT).dangerSoft : (0, $jTCZr.C).border,
            borderRadius: '1rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'block',
            fontSize: '0.8125rem',
            fontWeight: 600,
            color: (0, $jTCZr.C).textPrimary,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        }
    }, test.display), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'flex',
            gap: '0.375rem',
            alignItems: 'center',
            marginTop: '0.1875rem',
            flexWrap: 'wrap'
        }
    }, last?.date && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.625rem',
            color: (0, $jTCZr.C).textMuted
        }
    }, $652abbe9694ab398$export$372861cd7d55d715(last.date, formatDate)), abn && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.625rem',
            fontWeight: 700,
            color: (0, $jTCZr.CT).danger,
            background: (0, $jTCZr.CT).dangerSoft,
            padding: '0.0625rem 0.375rem',
            borderRadius: '0.25rem'
        }
    }, t('visit.vitals.abnormal')), delta != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.625rem',
            fontWeight: 600,
            color: delta > 0 ? (0, $jTCZr.CT).danger : (0, $jTCZr.CT).good
        }
    }, delta > 0 ? "\u25B2" : "\u25BC", formatDigits((0, $01rTJ.formatDelta)(delta))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3Amwd.default), {
        points: points,
        width: 72,
        height: 26,
        tone: abn ? 'danger' : 'accent'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            textAlign: 'end',
            minWidth: '3.25rem',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'block',
            fontSize: '1.0625rem',
            fontWeight: 800,
            color: abn ? (0, $jTCZr.CT).danger : (0, $jTCZr.C).textPrimary,
            lineHeight: 1
        }
    }, last?.value != null ? formatDigits(last.value) : "\u2014"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'block',
            fontSize: '0.5625rem',
            color: (0, $jTCZr.C).textMuted,
            marginTop: '0.125rem'
        }
    }, test.unit || ''))));
};
const $652abbe9694ab398$export$a80c208d4b2a2828 = ({ vitals: vitals = [], testId: testId = 'vitals-strip' })=>{
    const { t: t, formatDigits: formatDigits } = (0, $LNQP4.default)();
    if (!vitals.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId,
        style: {
            overflowX: 'auto',
            display: 'flex',
            gap: '0.5rem',
            scrollbarWidth: 'none'
        }
    }, vitals.map((v)=>{
        const alert = v.alert;
        const deltaClr = v.delta == null ? null : v.delta > 0 ? (0, $jTCZr.CT).danger : (0, $jTCZr.CT).good;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: v.id,
            style: {
                flexShrink: 0,
                minWidth: '5.625rem',
                background: alert ? (0, $jTCZr.C).amberLight : (0, $jTCZr.CT).surface2,
                border: `1px solid ${alert ? (0, $jTCZr.C).amber : (0, $jTCZr.C).border}`,
                borderRadius: '0.625rem',
                padding: '0.5625rem 0.75rem',
                textAlign: 'center'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.5625rem',
                color: alert ? (0, $jTCZr.CT).warnInk : (0, $jTCZr.C).textMuted,
                fontWeight: 600,
                marginBottom: '0.1875rem'
            }
        }, t(v.labelKey)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '1.0625rem',
                fontWeight: 800,
                color: alert ? (0, $jTCZr.CT).warnInk : (0, $jTCZr.C).textPrimary,
                lineHeight: 1
            }
        }, formatDigits(v.value)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.5625rem',
                color: (0, $jTCZr.C).textMuted,
                marginTop: '0.125rem'
            }
        }, v.unit), v.delta != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.5625rem',
                color: deltaClr,
                marginTop: '0.125rem',
                fontWeight: 600
            }
        }, v.delta > 0 ? "\u25B2" : "\u25BC", " ", formatDigits((0, $01rTJ.formatDelta)(v.delta))));
    }));
};

});
parcelRegister("01rTJ", function(module, exports) {

$parcel$export(module.exports, "isAbnormalStatus", () => $00011fef9dd464cc$export$cb21c69c81e22f82);
$parcel$export(module.exports, "buildSeriesMap", () => $00011fef9dd464cc$export$1be0eaa0fb63147e);
$parcel$export(module.exports, "countByCategory", () => $00011fef9dd464cc$export$e4e463683289edb3);
$parcel$export(module.exports, "defaultCategory", () => $00011fef9dd464cc$export$dbdc2bb8017e2c29);
$parcel$export(module.exports, "testsInCategory", () => $00011fef9dd464cc$export$930962f873333845);
$parcel$export(module.exports, "categoriesWithData", () => $00011fef9dd464cc$export$8020253fe86b6056);
$parcel$export(module.exports, "flaggedInCategory", () => $00011fef9dd464cc$export$f9b3ea7266dcc489);
$parcel$export(module.exports, "formatDelta", () => $00011fef9dd464cc$export$5050dfaf8101b0e4);
$parcel$export(module.exports, "lastDelta", () => $00011fef9dd464cc$export$81571910c7bff4d5);
// ─────────────────────────────────────────────────────────────────────────────
// The observation model — ONE behavioural truth for the «مشاهدات» section of the
// patient record, shared by the desktop tab and the mobile section
// (DESIGN-CONCEPT-MOBILE §1.1: the two surfaces may look nothing alike, but they
// must never disagree on which panel a test belongs to, how many results a
// category holds, or which reading is the latest).
//
// Both surfaces used to carry their own copy of this derivation, which is
// exactly the drift the shared-logic rule exists to prevent.
//
// The lab taxonomy itself (`LAB_CATEGORIES`, `obsLabCategory`, `VITAL_LOINC_SET`)
// stays in `constants/patientRecord.js` — this module is the behaviour over it.
// ─────────────────────────────────────────────────────────────────────────────

var $gq4TR = parcelRequire("gq4TR");
const $00011fef9dd464cc$export$cb21c69c81e22f82 = (s)=>s === 'abnormal' || s === 'ABNORMAL' || s === 'critical' || s === 'CRITICAL';
function $00011fef9dd464cc$export$ac4947c400027274(observations) {
    const seen = new Set();
    return (observations || []).filter((o)=>{
        if (!o || seen.has(o.id)) return false;
        seen.add(o.id);
        return true;
    });
}
function $00011fef9dd464cc$export$1be0eaa0fb63147e(observations) {
    const map = {};
    $00011fef9dd464cc$export$ac4947c400027274(observations).forEach((o)=>{
        const key = o.display || o.code || '';
        if (!map[key]) map[key] = {
            display: key,
            code: o.code,
            unit: o.unit,
            readings: [],
            catId: (0, $gq4TR.VITAL_LOINC_SET).has(o.code) ? 'vitals' : (0, $gq4TR.obsLabCategory)(key)
        };
        const v = parseFloat(o.value);
        map[key].readings.push({
            id: o.id,
            date: o.effectiveDate || o.createdAt || '',
            value: Number.isNaN(v) ? o.value : v,
            numVal: v,
            status: o.status
        });
    });
    Object.values(map).forEach((s)=>{
        s.readings.sort((a, b)=>(a.date || '').localeCompare(b.date || ''));
    });
    return map;
}
function $00011fef9dd464cc$export$e4e463683289edb3(seriesMap) {
    const counts = {};
    Object.values(seriesMap).forEach((s)=>{
        counts[s.catId] = (counts[s.catId] || 0) + 1;
    });
    return counts;
}
function $00011fef9dd464cc$export$dbdc2bb8017e2c29(counts) {
    return Object.entries(counts).filter(([id])=>id !== 'vitals').sort((a, b)=>b[1] - a[1])[0]?.[0] || null;
}
function $00011fef9dd464cc$export$930962f873333845(seriesMap, catId) {
    if (!catId) return [];
    return Object.values(seriesMap).filter((s)=>s.catId === catId).sort((a, b)=>a.display.localeCompare(b.display));
}
function $00011fef9dd464cc$export$8020253fe86b6056(counts) {
    const cats = (0, $gq4TR.LAB_CATEGORIES).filter((c)=>c.id !== 'vitals' && counts[c.id]).map((c)=>({
            id: c.id,
            labelKey: c.labelKey,
            color: c.color,
            count: counts[c.id]
        }));
    if (counts.other) cats.push({
        id: 'other',
        labelKey: 'patient.labCategory.other',
        color: null,
        count: counts.other
    });
    return cats;
}
function $00011fef9dd464cc$export$f9b3ea7266dcc489(seriesMap, catId) {
    return Object.values(seriesMap).filter((s)=>s.catId === catId && s.readings.some((r)=>$00011fef9dd464cc$export$cb21c69c81e22f82(r.status))).length;
}
const $00011fef9dd464cc$export$ff3c197fd9303a2c = {
    '8480-6': {
        labelKey: 'patient.vitals.systolic',
        unit: 'mmHg',
        warn: (v)=>v > 140 || v < 90
    },
    '8462-4': {
        labelKey: 'patient.vitals.diastolic',
        unit: 'mmHg',
        warn: (v)=>v > 90 || v < 60
    },
    '8867-4': {
        labelKey: 'patient.vitals.hr',
        unit: 'bpm',
        warn: (v)=>v > 100 || v < 60
    },
    '59408-5': {
        labelKey: 'patient.vitals.spo2',
        unit: '%',
        warn: (v)=>v < 95
    },
    '8310-5': {
        labelKey: 'patient.vitals.temp',
        unit: "\xb0C",
        warn: (v)=>v > 37.5 || v < 36
    },
    '29463-7': {
        labelKey: 'patient.vitals.wt',
        unit: 'kg',
        warn: ()=>false
    }
};
function $00011fef9dd464cc$export$82bcdfaefbcbaa1e(observations) {
    return Object.entries($00011fef9dd464cc$export$ff3c197fd9303a2c).map(([code, meta])=>{
        const sorted = (observations || []).filter((o)=>o.code === code).sort((a, b)=>(b.effectiveDate || '').localeCompare(a.effectiveDate || ''));
        const latest = sorted[0];
        if (!latest) return null;
        const curr = parseFloat(latest.value);
        const prev = sorted[1] ? parseFloat(sorted[1].value) : null;
        const delta = prev != null && !Number.isNaN(prev) && !Number.isNaN(curr) ? curr - prev : null;
        return {
            id: code,
            labelKey: meta.labelKey,
            unit: meta.unit,
            value: latest.value,
            delta: delta,
            alert: !Number.isNaN(curr) && meta.warn(curr)
        };
    }).filter(Boolean);
}
const $00011fef9dd464cc$export$5050dfaf8101b0e4 = (delta)=>Math.abs(delta).toFixed(Math.abs(delta) < 10 ? 1 : 0);
function $00011fef9dd464cc$export$81571910c7bff4d5(readings) {
    const last = readings?.[readings.length - 1];
    const prev = readings?.[readings.length - 2];
    if (!last || !prev) return null;
    const a = parseFloat(last.value);
    const b = parseFloat(prev.value);
    return Number.isNaN(a) || Number.isNaN(b) ? null : a - b;
}

});



parcelRegister("c6MXC", function(module, exports) {

$parcel$export(module.exports, "default", () => $943b784cb4e4dd8b$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");

var $hAUh5 = parcelRequire("hAUh5");
var $hSPBf = parcelRequire("hSPBf");
var $4gxLI = parcelRequire("4gxLI");
var $bF8pu = parcelRequire("bF8pu");
var $7udIf = parcelRequire("7udIf");
// «پایش بالینی» — the phone's monitoring control. It sits in the visit's pinned
// top strip, beside the visit-wide «تکمیل» that reads what it records (PM-0038):
// the control that makes the transcript and the button that uses it, together,
// and on screen whichever tab the doctor is in. It takes the width «تکمیل»
// leaves, at the 44px touch height — the same as every other control in the
// visit's chrome (PM-0044), not the 48px of a page-level CTA.
//
// It is the state and the control at once. Idle it is the teal invitation (the
// same fill as «شروع ویزیت»); while listening it is an outline with a pulsing
// red dot, the running clock and «توقف»; paused or disconnected it is amber
// with the way back. §14.2 holds: recording / reconnecting / paused / stopped
// differ by fill, glyph AND words, never by colour alone. Listening is never
// solid red, so it cannot be mistaken for «پایان ویزیت».
const $943b784cb4e4dd8b$var$pad = (n)=>String(n).padStart(2, '0');
const $943b784cb4e4dd8b$var$MobileVisitMonitorButton = ({ recState: recState = 'idle', recElapsed: recElapsed = 0, onToggle: onToggle, disabled: disabled })=>{
    const { t: t, formatDigits: formatDigits } = (0, $LNQP4.default)();
    const clock = formatDigits(`${$943b784cb4e4dd8b$var$pad(Math.floor(recElapsed / 60))}:${$943b784cb4e4dd8b$var$pad(recElapsed % 60)}`);
    const recording = recState === 'recording';
    const stopping = recState === 'stopping';
    const connecting = recState === 'connecting';
    const paused = recState === 'paused-by-system';
    const error = recState === 'error';
    // `label` is what is SEEN, `fullLabel` what is announced (and the tooltip). The
    // button shares a 360–412px row with «تکمیل» and «بیمه», so once the pulsing
    // dot, the glyph and the clock are in, «توقف پایش بالینی» has no room: it wrapped
    // to three lines and spilled out of the pill. The states that carry extra
    // furniture therefore show the short word — the glyph and the fill still say
    // which control it is, and the screen reader hears all of it.
    let variant = 'teal';
    let style;
    let label = t('visit.listen.start');
    let fullLabel = label;
    let Icon = (0, $hSPBf.default);
    if (recording) {
        variant = 'outline';
        style = {
            borderColor: (0, $jTCZr.CT).danger,
            color: (0, $jTCZr.CT).dangerInk
        };
        label = t('visit.listen.stopShort');
        fullLabel = t('visit.listen.stop');
        Icon = (0, $7udIf.default);
    } else if (connecting) {
        variant = 'outline';
        label = fullLabel = t('visit.record.connecting');
        Icon = (0, $hAUh5.default);
    } else if (stopping) {
        variant = 'outline';
        label = fullLabel = t('visit.listen.stopping');
        Icon = (0, $7udIf.default);
    } else if (paused) {
        style = {
            background: (0, $jTCZr.CT).warn,
            color: (0, $jTCZr.CT).ink
        };
        label = t('visit.listen.resumeShort');
        fullLabel = t('visit.listen.resume');
        Icon = (0, $4gxLI.default);
    } else if (error) {
        style = {
            background: (0, $jTCZr.CT).warn,
            color: (0, $jTCZr.CT).ink
        };
        label = t('visit.listen.retryShort');
        fullLabel = t('errors.connection.lostTap');
        Icon = (0, $bF8pu.default);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: variant,
        size: "lg",
        onClick: onToggle,
        disabled: disabled || stopping || connecting,
        "data-testid": "visit-rec-toggle",
        "data-state": recState,
        "aria-label": recording ? `${fullLabel} \u{2014} ${clock}` : fullLabel,
        title: fullLabel,
        className: "flex-1 min-w-0 h-11 min-h-11 gap-1.5 px-3 text-[0.875rem] whitespace-nowrap overflow-hidden",
        style: style
    }, recording && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true,
        style: {
            width: '0.5rem',
            height: '0.5rem',
            borderRadius: '50%',
            background: (0, $jTCZr.CT).danger,
            flexShrink: 0,
            animation: 'pulse 1.6s infinite'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        size: 16,
        "aria-hidden": true,
        className: `shrink-0${connecting ? ' animate-spin motion-reduce:animate-none' : ''}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "min-w-0 truncate"
    }, label), recording && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "visit-rec-clock",
        style: {
            fontVariantNumeric: 'tabular-nums',
            fontWeight: 700,
            flexShrink: 0
        }
    }, clock));
};
var $943b784cb4e4dd8b$export$2e2bcd8739ae039 = $943b784cb4e4dd8b$var$MobileVisitMonitorButton;

});

parcelRegister("aQc6m", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f551dfec33029cb$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $k27hS = parcelRequire("k27hS");

var $hAUh5 = parcelRequire("hAUh5");
var $7udIf = parcelRequire("7udIf");
// «پایان ویزیت» on the phone (PM-0044, design §۱۲).
//
// It is the one thing on this screen that is done ONCE per visit, and it used
// to be the largest, loudest element on it: a full-width solid red bar, at
// rest, on every visit. Red is for a real problem, and width says frequency.
// So it is now:
//
//   · an OUTLINE in the danger ink — recognisably the terminal action, without
//     a red fill sitting under the doctor's thumb for the whole consultation;
//   · as wide as its words, at the inline END of the footer — the corner
//     farthest from the thumb, away from the control that is pressed often;
//   · still 44px tall, still behind the screen's ConfirmDialog. Nothing closes
//     on this press alone.
//
// Below 360px the label shortens to «پایان»; the full name stays in the
// accessible name. While the visit is closing it says so and cannot be pressed.
const $8f551dfec33029cb$var$MobileVisitEndButton = ({ onEnd: onEnd, ending: ending = false, style: style, testId: testId = 'visit-cta-end' })=>{
    const { t: t } = (0, $LNQP4.default)();
    const { isMobile: narrow } = (0, $k27hS.default)(359);
    const full = t('dashboard.hero.endVisit');
    const label = ending ? t('visit.header.ending') : narrow ? t('visit.footer.endShort') : full;
    const Icon = ending ? (0, $hAUh5.default) : (0, $7udIf.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        onClick: onEnd,
        disabled: ending,
        "data-testid": testId,
        "data-state": ending ? 'ending' : 'idle',
        "aria-label": ending ? label : full,
        className: "h-11 min-h-11 shrink-0 gap-1.5 px-3.5",
        style: {
            borderColor: (0, $jTCZr.CT).danger,
            color: (0, $jTCZr.CT).dangerInk,
            fontSize: '0.8125rem',
            fontWeight: 700,
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        size: 14,
        "aria-hidden": true,
        className: ending ? 'animate-spin motion-reduce:animate-none' : undefined
    }), label);
};
var $8f551dfec33029cb$export$2e2bcd8739ae039 = $8f551dfec33029cb$var$MobileVisitEndButton;

});

parcelRegister("1g70w", function(module, exports) {

$parcel$export(module.exports, "visitPatientFacts", () => $4426115d6c876762$export$a800c9151312278d);
$parcel$export(module.exports, "default", () => $4426115d6c876762$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");

var $2An5y = parcelRequire("2An5y");

var $dXWAH = parcelRequire("dXWAH");
// «پروندهٔ بیمار» — the way into the patient's record from the visit room, on
// the phone (PM-0033).
//
// It used to be a whole identity card under the header row: unmissable, and
// ~5.5rem of height before the first line of the note. Before that it was the
// patient's name itself, which cost nothing and which nobody found. This is
// the third shape and the reason for both lessons: a LABELLED button — icon
// and the word «پرونده» — in the header's own row, at the inline end beside
// «⋯». It has one fixed place, it says what it opens, and it adds no height.
//
// The patient's identity moved into the row with it: the name is the header's
// title and the facts that tell two namesakes apart are its subtitle
// (`visitPatientFacts`). The national id is not among them — it does not fit
// one line at 320px, and it is the first thing the record sheet shows.
const $4426115d6c876762$var$sexKey = (value)=>{
    const v = String(value || '').trim().toLowerCase();
    if ([
        'm',
        'male',
        'man',
        "\u0645\u0631\u062F"
    ].includes(v)) return 'male'; // i18n-exempt: wire values of patient.gender
    if ([
        'f',
        'female',
        'woman',
        "\u0632\u0646"
    ].includes(v)) return 'female'; // i18n-exempt: wire values of patient.gender
    return null;
};
const $4426115d6c876762$export$a800c9151312278d = (patient, t, formatDigits)=>{
    const p = patient || {};
    const sex = $4426115d6c876762$var$sexKey(p.gender);
    return [
        sex && t(`common.gender.${sex}`),
        p.age != null && p.age !== '' && t('patient.ageYears', {
            age: formatDigits(p.age),
            count: Number(p.age)
        }),
        p.bloodType && t('patient.bloodTypeLabel', {
            type: p.bloodType
        })
    ].filter(Boolean);
};
// `proposals`: «تکمیل» proposals waiting inside the record (علائم حیاتی, سوابق) — PM-0038.
const $4426115d6c876762$var$MobileVisitRecordButton = ({ onOpen: onOpen, patientName: patientName, proposals: proposals = 0, testId: testId = 'visit-record-button' })=>{
    const { t: t } = (0, $LNQP4.default)();
    const label = t('visit.patientCard.open');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        onClick: onOpen,
        "data-testid": testId,
        "aria-label": patientName ? `${t('visit.patient.record')} \u{2014} ${patientName}` : t('visit.patient.record'),
        className: "min-h-11 shrink-0 gap-1.5 px-3 bg-white/15 text-white hover:bg-white/25 hover:text-white",
        style: {
            fontSize: '0.8125rem',
            fontWeight: 700
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2An5y.default), {
        size: 18,
        "aria-hidden": true
    }), label, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dXWAH.ProposalBadge), {
        variant: "mobile",
        count: proposals,
        testid: `${testId}-proposals`
    }));
};
var $4426115d6c876762$export$2e2bcd8739ae039 = $4426115d6c876762$var$MobileVisitRecordButton;

});
parcelRegister("2An5y", function(module, exports) {

$parcel$export(module.exports, "default", () => $754dc1fb92ffe304$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $754dc1fb92ffe304$export$a2387ed3b5d536eb = {
    name: "file-heart",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M13 22h5a2 2 0 0 0 2-2V8a2.4 2.4 0 0 0-.706-1.706l-3.588-3.588A2.4 2.4 0 0 0 14 2H6a2 2 0 0 0-2 2v7",
                key: "oagw2b"
            }
        ],
        [
            "path",
            {
                d: "M14 2v5a1 1 0 0 0 1 1h5",
                key: "wfsgrz"
            }
        ],
        [
            "path",
            {
                d: "M3.62 18.8A2.25 2.25 0 1 1 7 15.836a2.25 2.25 0 1 1 3.38 2.966l-2.626 2.856a1 1 0 0 1-1.507 0z",
                key: "rg3psg"
            }
        ]
    ]
};
$754dc1fb92ffe304$export$a2387ed3b5d536eb.node;
const $754dc1fb92ffe304$export$2e2bcd8739ae039 = (0, $9QBug.default)($754dc1fb92ffe304$export$a2387ed3b5d536eb);

});


parcelRegister("B8sWX", function(module, exports) {

$parcel$export(module.exports, "default", () => $acb36492df172d8d$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
parcelRequire("7sS0P");
var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $cZOyb = parcelRequire("cZOyb");
var $aJ1FU = parcelRequire("aJ1FU");

var $iEydz = parcelRequire("iEydz");
const $acb36492df172d8d$export$c171d27cac495866 = 5000;
const $acb36492df172d8d$var$MobileVisitEvents = ({ events: events = [], onSeen: onSeen, testId: testId = 'visit-events' })=>{
    const { t: t, formatDigits: formatDigits } = (0, $LNQP4.default)();
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // Ids already announced / already read. Refs would do for the first; state
    // for the second, because the count is drawn from it.
    const announcedRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Set());
    const [readIds, setReadIds] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>new Set());
    const [announcing, setAnnouncing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // The screen rebuilds `events` on every render (the visit clock ticks once a
    // second), so the effects key on WHICH events exist, not on the array — a
    // timer torn down every second would never fire.
    const idsKey = events.map((e)=>e.id).join('|');
    const eventsRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(events);
    eventsRef.current = events;
    // Announce each event ONCE, the first time it appears.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const live = eventsRef.current;
        const fresh = live.find((e)=>!announcedRef.current.has(e.id));
        if (fresh) {
            announcedRef.current.add(fresh.id);
            setAnnouncing(fresh);
        } else // The event being announced went away under the announcement.
        setAnnouncing((cur)=>cur && !live.some((e)=>e.id === cur.id) ? null : cur);
    }, [
        idsKey
    ]);
    // …and fold it back into the bell by itself.
    const announcingId = announcing?.id;
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!announcingId) return undefined;
        const timer = setTimeout(()=>setAnnouncing(null), $acb36492df172d8d$export$c171d27cac495866);
        return ()=>clearTimeout(timer);
    }, [
        announcingId
    ]);
    // An event that went away (the condition cleared, the screen dismissed it)
    // may come back later as news.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const live = new Set(eventsRef.current.map((e)=>e.id));
        announcedRef.current.forEach((id)=>{
            if (!live.has(id)) announcedRef.current.delete(id);
        });
        setReadIds((prev)=>{
            const next = new Set([
                ...prev
            ].filter((id)=>live.has(id)));
            return next.size === prev.size ? prev : next;
        });
    }, [
        idsKey
    ]);
    if (!events.length) return null;
    const unread = events.filter((e)=>!readIds.has(e.id)).length;
    const openSheet = ()=>{
        setAnnouncing(null);
        setOpen(true);
    };
    const closeSheet = ()=>{
        setOpen(false);
        setReadIds(new Set(events.map((e)=>e.id)));
        const gone = events.filter((e)=>!e.sticky).map((e)=>e.id);
        if (gone.length && onSeen) onSeen(gone);
    };
    const bellLabel = unread > 0 ? t('visit.events.bellUnread', {
        count: formatDigits(unread)
    }) : t('visit.events.title');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'relative',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "icon",
        onClick: openSheet,
        "aria-label": bellLabel,
        title: bellLabel,
        "data-testid": testId,
        "data-unread": unread,
        className: "min-w-11 min-h-11 shrink-0 text-white/90 hover:bg-white/15 hover:text-white",
        style: {
            position: 'relative'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $iEydz.default), {
        size: 19,
        "aria-hidden": true
    }), unread > 0 && // White on the brand chrome, never red: unread is not an alarm.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true,
        "data-testid": `${testId}-count`,
        style: {
            position: 'absolute',
            top: '0.3125rem',
            insetInlineEnd: '0.3125rem',
            minWidth: '1rem',
            height: '1rem',
            padding: '0 0.25rem',
            borderRadius: '0.5rem',
            background: '#fff',
            color: (0, $jTCZr.CT).accentInk,
            fontSize: '0.625rem',
            fontWeight: 800,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            lineHeight: 1
        }
    }, formatDigits(unread))), announcing && !open && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: openSheet,
        role: "status",
        "data-testid": `${testId}-announce`,
        style: {
            position: 'absolute',
            top: 0,
            insetInlineStart: 0,
            zIndex: 2,
            height: '2.75rem',
            maxWidth: 'min(calc(100vw - 5rem), 20rem)',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0 0.875rem 0 0.75rem',
            border: 0,
            borderRadius: '1.375rem',
            background: (0, $jTCZr.CT).surface,
            color: (0, $jTCZr.CT).ink,
            font: 'inherit',
            cursor: 'pointer',
            boxShadow: '0 6px 16px rgba(0,0,0,0.18)',
            fontSize: '0.8125rem',
            fontWeight: 700,
            whiteSpace: 'nowrap'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(announcing.Icon || (0, $iEydz.default), {
        size: 16,
        'aria-hidden': true,
        style: {
            flexShrink: 0,
            color: announcing.tone === 'warn' ? (0, $jTCZr.CT).warnInk : (0, $jTCZr.CT).accentInk
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    }, announcing.title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: open,
        onClose: closeSheet,
        title: t('visit.events.title'),
        closeLabel: t('common.actions.close')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${testId}-sheet`,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem'
        }
    }, events.map((e)=>{
        const warn = e.tone === 'warn';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: e.id,
            "data-testid": `${testId}-item-${e.id}`,
            style: {
                display: 'flex',
                alignItems: 'flex-start',
                gap: '0.625rem',
                padding: '0.75rem 0.875rem',
                borderRadius: '0.875rem',
                background: warn ? (0, $jTCZr.CT).warnSoft : (0, $jTCZr.CT).surface2,
                border: `1px solid ${warn ? (0, $jTCZr.CT).warn : (0, $jTCZr.C).border}`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(e.Icon || (0, $iEydz.default), {
            size: 17,
            'aria-hidden': true,
            style: {
                flexShrink: 0,
                marginTop: '0.125rem',
                color: warn ? (0, $jTCZr.CT).warnInk : (0, $jTCZr.CT).accentInk
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1,
                minWidth: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.8125rem',
                fontWeight: 700,
                color: warn ? (0, $jTCZr.CT).warnInk : (0, $jTCZr.C).textPrimary,
                lineHeight: 1.7
            }
        }, e.title), e.body && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.75rem',
                color: (0, $jTCZr.C).textSecondary,
                lineHeight: 1.8,
                marginTop: '0.125rem'
            }
        }, e.body), e.action && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "outline",
            size: "sm",
            className: "min-h-11 mt-2",
            "data-testid": `${testId}-action-${e.id}`,
            onClick: ()=>{
                closeSheet();
                e.action.onClick();
            }
        }, e.action.label)));
    }))));
};
var $acb36492df172d8d$export$2e2bcd8739ae039 = $acb36492df172d8d$var$MobileVisitEvents;

});
parcelRegister("iEydz", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd16704c2a54ea93$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $cd16704c2a54ea93$export$a2387ed3b5d536eb = {
    name: "bell",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M10.268 21a2 2 0 0 0 3.464 0",
                key: "vwvbt9"
            }
        ],
        [
            "path",
            {
                d: "M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326",
                key: "11g9vi"
            }
        ]
    ]
};
$cd16704c2a54ea93$export$a2387ed3b5d536eb.node;
const $cd16704c2a54ea93$export$2e2bcd8739ae039 = (0, $9QBug.default)($cd16704c2a54ea93$export$a2387ed3b5d536eb);

});


parcelRegister("fKtaR", function(module, exports) {

$parcel$export(module.exports, "default", () => $82e479bcc1dba2a2$export$2e2bcd8739ae039);
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");
parcelRequire("7sS0P");
var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");

var $4CVxl = parcelRequire("4CVxl");
var $jhSl7 = parcelRequire("jhSl7");
var $aVx4q = parcelRequire("aVx4q");

var $dXWAH = parcelRequire("dXWAH");
// The visit section navigator — ویزیت / نسخه / درخواست: the three things the
// doctor WRITES. Sticky under the header so switching sections is always one
// thumb-tap. Kit Button tabs (≥44px).
//
// There is no تشخیص tab. The differential is AI output and lives in the
// assistant sheet («تشخیص افتراقی»); it used to be reachable from both, which
// read as two lists. Diagnoses the doctor records go in the note's «A».
//
// The note tab is labelled from `visit.tabs.soap` — the same key the desktop
// work tab uses — so the section is named «ویزیت» identically on both surfaces.
//
// There is no برنامه tab: the AI treatment plan is generated, reviewed and filed
// from the «برنامه» section of the note, inside ویزیت.
const $82e479bcc1dba2a2$var$TABS = (t)=>[
        {
            id: 'note',
            label: t('visit.tabs.soap'),
            Icon: (0, $jhSl7.default)
        },
        {
            id: 'rx',
            label: t('visit.tabs.rx'),
            Icon: (0, $aVx4q.default),
            countKey: 'rx'
        },
        {
            id: 'ord',
            label: t('visit.orders.request'),
            Icon: (0, $4CVxl.default),
            countKey: 'ord'
        }
    ];
// `isVisible(id)` is the doctor's layout preference (Settings → «صفحه ویزیت»),
// mapped onto this surface's tab ids by screens/Visit/visitLayout.js. Absent,
// every tab shows — the nav has no opinion of its own.
//
// `proposals` is how many «تکمیل» proposals wait in each tab (PM-0038): the tab
// wears the count until the doctor has confirmed or rejected them.
//
// `trailing` is one optional 44px control at the END of the strip — the phone's
// «تبدیل به ویزیت آنلاین» on an in-person visit. It rides the row the tabs
// already occupy, so the secondary path costs no height.
const $82e479bcc1dba2a2$var$MobileVisitNav = ({ active: active, onChange: onChange, counts: counts = {}, proposals: proposals = {}, isVisible: isVisible = ()=>true, trailing: trailing = null })=>{
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-nav",
        style: {
            display: 'flex',
            background: (0, $jTCZr.C).card,
            borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
            paddingInline: '0.25rem'
        }
    }, $82e479bcc1dba2a2$var$TABS(t).filter(({ id: id })=>isVisible(id)).map(({ id: id, label: label, Icon: Icon, countKey: countKey })=>{
        const on = active === id;
        const badge = countKey ? counts[countKey] : null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            key: id,
            variant: "ghost",
            onClick: ()=>onChange(id),
            "data-testid": `visit-nav-${id}`,
            "aria-pressed": on,
            className: "flex-1 min-h-11 h-auto flex-col gap-0.5 rounded-none px-1 py-2 hover:bg-transparent",
            style: {
                borderBottom: `2px solid ${on ? (0, $jTCZr.C).navy : 'transparent'}`,
                color: on ? (0, $jTCZr.C).textPrimary : (0, $jTCZr.C).textMuted
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.3125rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
            size: 14,
            "aria-hidden": true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.75rem',
                fontWeight: on ? 700 : 500
            }
        }, label), badge > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.625rem',
                fontWeight: 700,
                padding: '0.0625rem 0.3125rem',
                borderRadius: '0.75rem',
                background: on ? (0, $jTCZr.CT).accentSoft : (0, $jTCZr.CT).surface2,
                color: on ? (0, $jTCZr.CT).accentInk : (0, $jTCZr.C).textSecondary
            }
        }, badge), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dXWAH.ProposalBadge), {
            variant: "mobile",
            count: proposals[id],
            testid: `visit-nav-proposals-${id}`
        })));
    }), trailing && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            flexShrink: 0,
            gap: '0.25rem',
            paddingInlineStart: '0.25rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true,
        style: {
            width: 1,
            height: '1.5rem',
            background: (0, $jTCZr.C).border
        }
    }), trailing));
};
var $82e479bcc1dba2a2$export$2e2bcd8739ae039 = $82e479bcc1dba2a2$var$MobileVisitNav;

});
parcelRegister("jhSl7", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccc74fc270115805$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $ccc74fc270115805$export$a2387ed3b5d536eb = {
    name: "notebook-pen",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M13.4 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7.4",
                key: "re6nr2"
            }
        ],
        [
            "path",
            {
                d: "M2 6h4",
                key: "aawbzj"
            }
        ],
        [
            "path",
            {
                d: "M2 10h4",
                key: "l0bgd4"
            }
        ],
        [
            "path",
            {
                d: "M2 14h4",
                key: "1gsvsf"
            }
        ],
        [
            "path",
            {
                d: "M2 18h4",
                key: "1bu2t1"
            }
        ],
        [
            "path",
            {
                d: "M21.378 5.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
                key: "pqwjuv"
            }
        ]
    ]
};
$ccc74fc270115805$export$a2387ed3b5d536eb.node;
const $ccc74fc270115805$export$2e2bcd8739ae039 = (0, $9QBug.default)($ccc74fc270115805$export$a2387ed3b5d536eb);

});


parcelRegister("1eCd1", function(module, exports) {

$parcel$export(module.exports, "default", () => $58ef1df1f5757bce$export$2e2bcd8739ae039);
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");
parcelRequire("7sS0P");
var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $hZDga = parcelRequire("hZDga");

var $huNwV = parcelRequire("huNwV");
var $2WFPf = parcelRequire("2WFPf");
var $97xXr = parcelRequire("97xXr");
var $hSPBf = parcelRequire("hSPBf");
var $chm1L = parcelRequire("chm1L");
parcelRequire("gcegg");
var $jTCZr = parcelRequire("jTCZr");

var $7akOU = parcelRequire("7akOU");

var $ajYTu = parcelRequire("ajYTu");
// The SOAP note — «شرح حال» leading, then معاینه/ارزیابی/برنامه. Each part
// is a token-tinted letter badge + label + a full-width textarea; the doctor
// types, the screen owns the `soap` state and persistence. Accordion open/closed
// is local presentational state (no clinical meaning), so it stays here.
//
// Each part also carries its own dictation button. `onVoice(key, name)` hands
// the section's identity back to the screen, which is what keeps a dictation
// started under «ارزیابی» out of «شکایت اصلی» — the section is never inferred
// from whatever happens to be focused.
//
// «برنامه» additionally carries the AI treatment-plan action: `onPlanAi` asks
// the screen to generate the plan, and `planPanel` is the review panel the
// screen renders directly under this section's textarea. The plan's prose is
// written into this very field, so the doctor edits it like any other SOAP text.
//
// `refine` is the screen's useSoapRefine hook value — the merge-aware
// «تکمیل یادداشت» flow. The outcome strip and the per-section previews render
// HERE, in the note's own surface. The trigger does not (PM-0046): the note is
// read by the visit-wide «تکمیل» in the screen's pinned top strip, and a second
// "complete all" above the note was a duplicate of it.
//
// `autoConfirmed(key)`: the part holds, unchanged, what «تایید خودکار» wrote into
// it (PM-0573) — it wears the badge until the doctor edits it or marks the list
// reviewed. Each field is marked `data-soap-key`, which is how «تایید خودکار»
// knows not to write under the doctor's caret (Visit.shared soapEditorFocused).
// «شرح حال» LEADS the note. It is what the doctor writes first and most, and
// what the differential, the confirmation questions and the plan all read — so
// on the phone it is labelled by its clinical name, is always open, starts
// tall and grows with its text, and carries an accent edge the other three do
// not. The others stay a compact accordion below it.
const $58ef1df1f5757bce$var$LEAD = 's';
/** «شرح حال»'s field: tall enough to write a history in, capped so the other
 *  parts stay reachable; past the cap it scrolls inside itself. */ const $58ef1df1f5757bce$var$LEAD_MIN_H = '13rem';
const $58ef1df1f5757bce$var$LEAD_MAX_H = '60dvh';
const $58ef1df1f5757bce$var$PARTS = (t)=>[
        {
            k: 'S',
            key: 's',
            name: t('visit.soap.historyShort'),
            tone: (0, $jTCZr.CT).accentInk
        },
        {
            k: 'O',
            key: 'o',
            name: t('visit.soap.objective'),
            tone: (0, $jTCZr.CT).accentInk
        },
        {
            k: 'A',
            key: 'a',
            name: t('patient.soap.assessment'),
            tone: (0, $jTCZr.C).navy
        },
        {
            k: 'P',
            key: 'p',
            name: t('patient.soap.plan'),
            tone: (0, $jTCZr.CT).goodInk
        }
    ];
const $58ef1df1f5757bce$var$MobileVisitSoap = ({ soap: soap, onChange: onChange, onVoice: onVoice, voiceDisabled: voiceDisabled = false, onPlanAi: onPlanAi, planAiDisabled: planAiDisabled = false, planAiLoading: planAiLoading = false, planPanelOpen: planPanelOpen = false, planPanel: planPanel = null, onPlanFocusChange: // The screen's plan reconciler rewrites «برنامه» when the drug/order lists
// change. It must not do that under the doctor's fingers, so the field reports
// when it holds focus and the reconciler waits.
onPlanFocusChange, planBlockHint: planBlockHint = null, refine: refine = null, autoConfirmed: autoConfirmed = null })=>{
    const { t: t } = (0, $LNQP4.default)();
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        s: true,
        o: false,
        a: false,
        p: false
    });
    // Opening the plan panel from a collapsed «برنامه» would put the panel where
    // the doctor cannot see the text it just wrote, so the section follows it open.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (planPanelOpen) setOpen((o)=>o.p ? o : {
                ...o,
                p: true
            });
    }, [
        planPanelOpen
    ]);
    // A preview the doctor cannot see is a preview that never gets applied —
    // sections that received one follow it open.
    const previewKeys = refine?.preview ? Object.keys(refine.preview) : [];
    const previewSig = previewKeys.join(',');
    // What «تأیید همه» confirms: every part's proposal — all four are on this one
    // surface — except a stale one, which can only be read again.
    const applicableKeys = previewKeys.filter((k)=>!refine.preview[k]?.stale);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!previewSig) return;
        setOpen((o)=>{
            const next = {
                ...o
            };
            previewSig.split(',').forEach((k)=>{
                next[k] = true;
            });
            return next;
        });
    }, [
        previewSig
    ]);
    const refineStatus = refine?.status && refine.status !== 'ok' ? refine.status : null;
    const hasNewContent = !!refine?.hasNewContent && !refine.loading;
    // «شرح حال» grows with what is written in it (up to LEAD_MAX_H) instead of
    // making the doctor scroll a three-line box. Measured after every change,
    // collapsing first so deleted text shrinks it back.
    const leadRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(()=>{
        const el = leadRef.current;
        if (!el) return;
        el.style.height = 'auto';
        el.style.height = `${el.scrollHeight + 2}px`;
    }, [
        soap[$58ef1df1f5757bce$var$LEAD]
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-soap",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem'
        }
    }, (hasNewContent || applicableKeys.length > 1) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            flexWrap: 'wrap'
        }
    }, hasNewContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "visit-soap-refine-newdot",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.3125rem',
            fontSize: '0.6875rem',
            color: (0, $jTCZr.CT).accentInk
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: '0.375rem',
            height: '0.375rem',
            borderRadius: '50%',
            background: (0, $jTCZr.CT).accent,
            flexShrink: 0
        }
    }), t('visit.soap.refine.newContent')), applicableKeys.length > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        size: "sm",
        onClick: ()=>refine.applyAll(applicableKeys),
        "data-testid": "visit-soap-refine-apply-all",
        className: "min-h-11 gap-1.5 px-3 text-xs",
        style: {
            marginInlineStart: 'auto'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
        size: 13,
        "aria-hidden": true
    }), " ", t('visit.soap.refine.applyAll'))), refineStatus && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-soap-refine-status",
        "data-status": refineStatus,
        role: refineStatus === 'error' ? 'alert' : undefined,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0.5rem 0.6875rem',
            borderRadius: '0.5rem',
            fontSize: '0.71875rem',
            background: refineStatus === 'error' ? (0, $jTCZr.soft)((0, $jTCZr.CT).warnInk, 0.10) : (0, $jTCZr.CT).surface2,
            border: `1px solid ${refineStatus === 'error' ? (0, $jTCZr.soft)((0, $jTCZr.CT).warnInk, 0.35) : (0, $jTCZr.C).border}`,
            color: refineStatus === 'error' ? (0, $jTCZr.CT).warnInk : (0, $jTCZr.C).textSecondary
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $97xXr.default), {
        size: 13,
        "aria-hidden": true,
        style: {
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            lineHeight: 1.6
        }
    }, refineStatus === 'error' ? t('visit.soap.refine.error') : refineStatus === 'no_transcript' ? t('visit.soap.refine.noTranscript') : t('visit.soap.refine.noNew')), refineStatus === 'error' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "sm",
        onClick: ()=>refine.refine(),
        "data-testid": "visit-soap-refine-retry",
        className: "min-h-11 px-3 text-xs"
    }, t('common.actions.retry'))), $58ef1df1f5757bce$var$PARTS(t).map(({ k: k, key: key, name: name, tone: tone })=>{
        const lead = key === $58ef1df1f5757bce$var$LEAD;
        // The lead section cannot be folded away — it is the note.
        const isOpen = lead || open[key];
        const filled = !!soap[key]?.trim();
        const preview = refine?.preview?.[key] || null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: key,
            "data-lead": lead ? 'true' : undefined,
            style: {
                background: (0, $jTCZr.C).card,
                border: `1px solid ${lead ? (0, $jTCZr.soft)((0, $jTCZr.CT).accent, 0.55) : (0, $jTCZr.C).border}`,
                borderRadius: '0.75rem',
                overflow: 'hidden',
                ...lead ? {
                    borderInlineStart: `3px solid ${(0, $jTCZr.CT).accent}`,
                    boxShadow: `0 1px 0 ${(0, $jTCZr.soft)((0, $jTCZr.CT).accent, 0.10)}`
                } : null
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.375rem',
                paddingInlineEnd: '0.625rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            onClick: lead ? undefined : ()=>setOpen((o)=>({
                        ...o,
                        [key]: !o[key]
                    })),
            "data-testid": `visit-soap-toggle-${key}`,
            "aria-expanded": isOpen,
            "aria-disabled": lead || undefined,
            className: "flex-1 min-w-0 min-h-11 h-auto justify-start gap-2.5 px-3.5 py-3 rounded-none hover:bg-transparent"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                width: '1.5rem',
                height: '1.5rem',
                borderRadius: '0.375rem',
                flexShrink: 0,
                background: filled ? tone : (0, $jTCZr.soft)((0, $jTCZr.C).textMuted, 0.14),
                color: filled ? '#fff' : (0, $jTCZr.C).textMuted,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '0.6875rem',
                fontWeight: 800
            }
        }, k), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                flex: 1,
                minWidth: 0,
                textAlign: 'start',
                fontSize: lead ? '0.9375rem' : '0.8125rem',
                fontWeight: lead ? 700 : 600,
                color: (0, $jTCZr.C).textPrimary,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            }
        }, name), autoConfirmed?.(key) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ajYTu.AutoConfirmBadge), {
            variant: "mobile",
            testid: `visit-soap-auto-${key}`
        }), preview && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                width: '0.375rem',
                height: '0.375rem',
                borderRadius: '50%',
                background: (0, $jTCZr.CT).accent,
                flexShrink: 0
            },
            "aria-hidden": true
        }), !lead && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2WFPf.default), {
            size: 15,
            "aria-hidden": true,
            style: {
                color: (0, $jTCZr.C).textMuted,
                transition: 'transform .15s',
                transform: isOpen ? 'rotate(180deg)' : 'none'
            }
        })), onVoice && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "outline",
            size: "sm",
            disabled: voiceDisabled,
            // Dictating into a collapsed section would put the words
            // where the doctor cannot see them land — it opens first.
            onClick: ()=>{
                setOpen((o)=>o[key] ? o : {
                        ...o,
                        [key]: true
                    });
                onVoice(key, name);
            },
            "data-testid": `visit-soap-voice-${key}`,
            "aria-label": t('visit.voice.recordSection', {
                section: name
            }),
            className: "min-h-11 shrink-0 gap-1.5 px-3 text-xs"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hSPBf.default), {
            size: 13,
            "aria-hidden": true
        }), " ", t('visit.voice.record')), key === 'p' && onPlanAi && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "outline",
            size: "sm",
            disabled: planAiDisabled,
            onClick: onPlanAi,
            "data-testid": "visit-soap-plan-ai",
            "aria-expanded": planPanelOpen,
            "aria-label": t('visit.plan.aiForPlan'),
            className: "min-h-11 shrink-0 gap-1.5 px-3 text-xs",
            style: {
                color: (0, $jTCZr.CT).accentInk,
                borderColor: (0, $jTCZr.CT).accent
            }
        }, planAiLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
            size: 13,
            color: (0, $jTCZr.CT).accentInk,
            thickness: 2
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $chm1L.default), {
            size: 13,
            "aria-hidden": true
        }), ' ', "AI")), isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                padding: '0 0.875rem 0.875rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("textarea", {
            ref: lead ? leadRef : undefined,
            value: soap[key] || '',
            onChange: (e)=>onChange(key, e.target.value),
            onFocus: key === 'p' && onPlanFocusChange ? ()=>onPlanFocusChange(true) : undefined,
            onBlur: key === 'p' && onPlanFocusChange ? ()=>onPlanFocusChange(false) : undefined,
            placeholder: `${name}\u{2026}`,
            rows: lead ? 8 : 3,
            "data-testid": `visit-soap-input-${key}`,
            "data-soap-key": key,
            style: {
                width: '100%',
                boxSizing: 'border-box',
                resize: 'vertical',
                ...lead ? {
                    minHeight: $58ef1df1f5757bce$var$LEAD_MIN_H,
                    maxHeight: $58ef1df1f5757bce$var$LEAD_MAX_H,
                    overflowY: 'auto',
                    background: (0, $jTCZr.C).card
                } : null,
                border: `1px solid ${(0, $jTCZr.C).border}`,
                borderRadius: '0.5rem',
                padding: '0.625rem 0.75rem',
                fontSize: '1rem',
                lineHeight: 1.75,
                fontFamily: 'inherit',
                color: (0, $jTCZr.C).textPrimary,
                ...lead ? null : {
                    background: (0, $jTCZr.CT).surface2
                },
                outline: 'none'
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7akOU.default), {
            variant: "mobile",
            sectionKey: key,
            title: name,
            preview: preview,
            onAccept: ()=>refine.apply(key),
            onDismiss: ()=>refine.dismiss(key),
            onRerun: ()=>refine.refine([
                    key
                ]),
            busy: !!refine?.loading,
            style: {
                marginTop: '0.5rem'
            }
        }), key === 'p' && planBlockHint, key === 'p' && planPanel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                marginTop: '0.625rem'
            }
        }, planPanel)));
    }));
};
var $58ef1df1f5757bce$export$2e2bcd8739ae039 = $58ef1df1f5757bce$var$MobileVisitSoap;

});
parcelRegister("7akOU", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcdf6086c22a8d18$export$2e2bcd8739ae039);
// The note's proposal: what «تکمیل» would add to ONE section of the SOAP note,
// shown under that section until the doctor confirms or rejects it (§13.3 — AI
// output stays labelled and OUTSIDE the note). The same card as every other
// «تکمیل» proposal (PM-0038), on both surfaces.
//
// The body is the server-merged section, diffed against the section it was
// merged FROM (`base`): added words marked, any word the merge dropped struck
// through, long unchanged stretches elided. «تأیید» writes exactly that merged
// section (doctor text preserved by contract), plus anything the doctor
// appended since it was proposed — which is not the AI's to show.
//
// It is never the model's `additions` list. That is a summary the model writes
// ABOUT its merge, and it left facts out: the card showed a line or two while
// «تأیید» wrote a paragraph, so the doctor reviewed one text and accepted
// another.
//
// A STALE proposal is one whose section the doctor changed otherwise before
// confirming it: writing it would delete what they wrote, so it was not written.
// The card says so in place and offers to read the section again instead.

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $dXWAH = parcelRequire("dXWAH");

var $053Hn = parcelRequire("053Hn");
function $fcdf6086c22a8d18$export$2e2bcd8739ae039({ sectionKey: sectionKey, title: title, preview: preview, onAccept: onAccept, onDismiss: onDismiss, onRerun: onRerun, busy: busy = false, variant: variant = 'web', style: style }) {
    const { t: t } = (0, $LNQP4.default)();
    if (!preview) return null;
    const mobile = variant === 'mobile';
    const stale = !!preview.stale;
    const text = {
        fontSize: mobile ? '0.8125rem' : '0.75rem',
        color: (0, $jTCZr.CT).ink,
        lineHeight: 1.7
    };
    const testid = `visit-soap-refine-preview-${sectionKey}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dXWAH.ProposalCard), {
        variant: variant,
        testid: testid,
        title: title,
        style: style,
        "data-stale": stale ? 'true' : undefined,
        footer: stale ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dXWAH.ProposalActions), {
            variant: variant,
            testid: testid,
            onAccept: onRerun,
            acceptLabel: t('visit.soap.refine.rerun'),
            acceptDisabled: !onRerun,
            busy: busy,
            acceptTestid: `visit-soap-refine-rerun-${sectionKey}`,
            onDismiss: onDismiss,
            dismissTestid: `visit-soap-refine-dismiss-${sectionKey}`
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dXWAH.ProposalActions), {
            variant: variant,
            testid: testid,
            onAccept: onAccept,
            acceptTestid: `visit-soap-refine-apply-${sectionKey}`,
            onDismiss: onDismiss,
            dismissTestid: `visit-soap-refine-dismiss-${sectionKey}`
        })
    }, stale && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "status",
        "data-testid": `${testid}-stale`,
        dir: "auto",
        style: {
            fontSize: mobile ? '0.75rem' : '0.71875rem',
            lineHeight: 1.7,
            color: (0, $jTCZr.CT).warnInk,
            background: (0, $jTCZr.CT).warnSoft,
            borderRadius: mobile ? '0.5rem' : 6,
            padding: mobile ? '0.5rem 0.625rem' : '6px 9px'
        }
    }, t('visit.soap.refine.stale', {
        section: title
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $053Hn.default), {
        testId: `visit-soap-refine-diff-${sectionKey}`,
        current: preview.base || '',
        merged: preview.text,
        addStyle: {
            background: `color-mix(in srgb, ${(0, $jTCZr.CT).accent} 30%, transparent)`
        },
        delStyle: {
            color: (0, $jTCZr.CT).dangerInk
        },
        style: {
            ...text,
            maxHeight: mobile ? '12rem' : 220,
            overflowY: 'auto'
        }
    }));
}

});
parcelRegister("053Hn", function(module, exports) {

$parcel$export(module.exports, "default", () => $7be017aeba1bb501$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $eZL2V = parcelRequire("eZL2V");
function $7be017aeba1bb501$export$c50637ba86c566c2({ current: current, merged: merged, addStyle: addStyle, delStyle: delStyle, style: style, testId: testId }) {
    const segments = (0, $acw62.useMemo)(()=>(0, $eZL2V.soapMergeSegments)(current, merged), [
        current,
        merged
    ]);
    const hasChange = segments.some((s)=>s.kind === 'add' || s.kind === 'del');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId,
        dir: "auto",
        style: {
            whiteSpace: 'pre-wrap',
            overflowWrap: 'break-word',
            ...style
        }
    }, hasChange ? segments.map((s, i)=>{
        if (s.kind === 'add') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ins", {
            key: i,
            "data-diff": "add",
            style: {
                textDecoration: 'none',
                borderRadius: 3,
                ...addStyle
            }
        }, s.text);
        if (s.kind === 'del') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("del", {
            key: i,
            "data-diff": "del",
            style: {
                opacity: 0.75,
                ...delStyle
            }
        }, s.text);
        if (s.kind === 'gap') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            key: i,
            "data-diff": "gap",
            "aria-hidden": true,
            style: {
                opacity: 0.6
            }
        }, "\u2026 ");
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            key: i
        }, s.text);
    }) : merged);
}
var $7be017aeba1bb501$export$2e2bcd8739ae039 = $7be017aeba1bb501$export$c50637ba86c566c2;

});
parcelRegister("eZL2V", function(module, exports) {

$parcel$export(module.exports, "soapMergeSegments", () => $aeab41940996b2c6$export$5c9f5a0a5df5343e);
// What «اعمال در یادداشت» will actually do to a SOAP section, as a word diff.
//
// The refine service returns two things per section: `text`, the full merged
// section that apply writes, and `additions`, a short list the model writes
// ABOUT what it added. The preview used to show `additions` — a summary that
// routinely left facts out — so the doctor reviewed one thing and accepted
// another. The preview is now derived from `text` itself, diffed against what
// the section holds right now, so every word apply would add (or drop) is on
// screen before the click.
// Unchanged runs longer than this are trimmed to CONTEXT words either side of
// a change. The doctor's own text is already in the box above the preview;
// repeating all of it would bury the change it is there to show.
const $aeab41940996b2c6$export$1c0f41907b107ef3 = 8;
// Above this many DP cells the middle is shown as a whole replacement rather
// than diffed. Only reachable when a large note was rewritten throughout.
const $aeab41940996b2c6$var$MAX_LCS_CELLS = 2000000;
// A word with the whitespace after it; leading whitespace is a token of its
// own. Tokens compare by the word alone, so a reflowed line break is not a
// change. Punctuation at either edge of a word is split off: the merge
// typically continues a sentence the doctor ended, and «120/80» becoming
// «120/80،» is an added comma, not a deleted and re-added reading. Punctuation
// INSIDE a word (37.8, 120/80) stays put.
const $aeab41940996b2c6$var$EDGE_PUNCT = ".,\u060C;\u061B:!?\u061F\u2026()\xab\xbb\"'\\[\\]";
const $aeab41940996b2c6$var$LEAD_RE = new RegExp(`^([${$aeab41940996b2c6$var$EDGE_PUNCT}]+)(?=[^\\s${$aeab41940996b2c6$var$EDGE_PUNCT}])`);
const $aeab41940996b2c6$var$TRAIL_RE = new RegExp(`(?<=\\S)([${$aeab41940996b2c6$var$EDGE_PUNCT}]+\\s*)$`);
function $aeab41940996b2c6$var$tokenize(text) {
    const out = [];
    ((text || '').match(/\s+|\S+\s*/g) || []).forEach((tok)=>{
        let rest = tok;
        const lead = rest.match($aeab41940996b2c6$var$LEAD_RE);
        if (lead) {
            out.push(lead[1]);
            rest = rest.slice(lead[1].length);
        }
        const trail = rest.match($aeab41940996b2c6$var$TRAIL_RE);
        if (trail && trail.index > 0) {
            out.push(rest.slice(0, trail.index));
            out.push(trail[1]);
        } else out.push(rest);
    });
    return out;
}
const $aeab41940996b2c6$var$keyOf = (tok)=>tok.trim();
function $aeab41940996b2c6$var$pushSeg(out, kind, toks) {
    if (!toks.length) return;
    const last = out[out.length - 1];
    if (last && last.kind === kind) last.toks.push(...toks);
    else out.push({
        kind: kind,
        toks: [
            ...toks
        ]
    });
}
function $aeab41940996b2c6$var$lcsDiff(a, b, out) {
    const n = a.length, m = b.length;
    if (!n) {
        $aeab41940996b2c6$var$pushSeg(out, 'add', b);
        return;
    }
    if (!m) {
        $aeab41940996b2c6$var$pushSeg(out, 'del', a);
        return;
    }
    if (n * m > $aeab41940996b2c6$var$MAX_LCS_CELLS) {
        $aeab41940996b2c6$var$pushSeg(out, 'del', a);
        $aeab41940996b2c6$var$pushSeg(out, 'add', b);
        return;
    }
    const w = m + 1;
    const dp = new Uint32Array((n + 1) * w);
    for(let i = n - 1; i >= 0; i--)for(let j = m - 1; j >= 0; j--)dp[i * w + j] = $aeab41940996b2c6$var$keyOf(a[i]) === $aeab41940996b2c6$var$keyOf(b[j]) ? dp[(i + 1) * w + j + 1] + 1 : Math.max(dp[(i + 1) * w + j], dp[i * w + j + 1]);
    let i = 0, j = 0;
    while(i < n && j < m){
        if ($aeab41940996b2c6$var$keyOf(a[i]) === $aeab41940996b2c6$var$keyOf(b[j])) {
            $aeab41940996b2c6$var$pushSeg(out, 'same', [
                b[j]
            ]);
            i++;
            j++;
        } else if (dp[(i + 1) * w + j] >= dp[i * w + j + 1]) {
            $aeab41940996b2c6$var$pushSeg(out, 'del', [
                a[i]
            ]);
            i++;
        } else {
            $aeab41940996b2c6$var$pushSeg(out, 'add', [
                b[j]
            ]);
            j++;
        }
    }
    if (i < n) $aeab41940996b2c6$var$pushSeg(out, 'del', a.slice(i));
    if (j < m) $aeab41940996b2c6$var$pushSeg(out, 'add', b.slice(j));
}
// An insertion between equal tokens can sit in more than one place: adding
// «. تب ندارد.» after «دارد.» matches the doctor's final period to the NEW
// sentence's, and the highlight reads «. تب ندارد» + «.». Slide each change
// right while its first token equals the unchanged token after it — the text
// is identical, and the change now ends where its own sentence does.
function $aeab41940996b2c6$var$slideRight(segs) {
    for(let i = 0; i < segs.length; i++){
        const seg = segs[i];
        if (seg.kind === 'same') continue;
        for(let next = segs[i + 1]; next && next.kind === 'same' && seg.toks.length && next.toks.length && $aeab41940996b2c6$var$keyOf(seg.toks[0]) === $aeab41940996b2c6$var$keyOf(next.toks[0]); next = segs[i + 1]){
            const x0 = seg.toks.shift();
            const b0 = next.toks.shift();
            // `same` text is the merged side's; a deletion keeps the current side's.
            const keep = seg.kind === 'add' ? x0 : b0;
            seg.toks.push(seg.kind === 'add' ? b0 : x0);
            const prev = segs[i - 1];
            if (prev && prev.kind === 'same') prev.toks.push(keep);
            else {
                segs.splice(i, 0, {
                    kind: 'same',
                    toks: [
                        keep
                    ]
                });
                i++;
            }
            if (!next.toks.length) segs.splice(i + 1, 1);
        }
    }
    return segs;
}
function $aeab41940996b2c6$var$collapse(segs, context) {
    return segs.flatMap((seg, idx)=>{
        if (seg.kind !== 'same') return [
            seg
        ];
        const words = seg.toks.filter((t)=>$aeab41940996b2c6$var$keyOf(t));
        const first = idx === 0, last = idx === segs.length - 1;
        const keepHead = first ? 0 : context;
        const keepTail = last ? 0 : context;
        if (words.length <= keepHead + keepTail + 2) return [
            seg
        ];
        // Index the token positions of the words to keep on either side.
        const wordIdx = seg.toks.map((t, k)=>$aeab41940996b2c6$var$keyOf(t) ? k : -1).filter((k)=>k >= 0);
        const headEnd = keepHead ? wordIdx[keepHead - 1] + 1 : 0;
        const tailStart = keepTail ? wordIdx[wordIdx.length - keepTail] : seg.toks.length;
        const parts = [];
        if (headEnd) parts.push({
            kind: 'same',
            toks: seg.toks.slice(0, headEnd)
        });
        parts.push({
            kind: 'gap',
            toks: []
        });
        if (tailStart < seg.toks.length) parts.push({
            kind: 'same',
            toks: seg.toks.slice(tailStart)
        });
        return parts;
    });
}
function $aeab41940996b2c6$export$5c9f5a0a5df5343e(current, merged, opts = {}) {
    const context = opts.context ?? $aeab41940996b2c6$export$1c0f41907b107ef3;
    const a = $aeab41940996b2c6$var$tokenize(current);
    const b = $aeab41940996b2c6$var$tokenize(merged);
    // Common prefix and suffix first: the service appends to the end of a
    // section by preference, so this usually leaves only the addition to diff.
    let pre = 0;
    while(pre < a.length && pre < b.length && $aeab41940996b2c6$var$keyOf(a[pre]) === $aeab41940996b2c6$var$keyOf(b[pre]))pre++;
    let suf = 0;
    while(suf < a.length - pre && suf < b.length - pre && $aeab41940996b2c6$var$keyOf(a[a.length - 1 - suf]) === $aeab41940996b2c6$var$keyOf(b[b.length - 1 - suf]))suf++;
    const segs = [];
    $aeab41940996b2c6$var$pushSeg(segs, 'same', b.slice(0, pre));
    $aeab41940996b2c6$var$lcsDiff(a.slice(pre, a.length - suf), b.slice(pre, b.length - suf), segs);
    $aeab41940996b2c6$var$pushSeg(segs, 'same', b.slice(b.length - suf));
    // A whitespace-only token is a word boundary, not content: fold it into the
    // unchanged text so it never renders as a highlighted blank.
    const cleaned = [];
    $aeab41940996b2c6$var$slideRight(segs).forEach((s)=>{
        if (s.kind !== 'same' && !s.toks.some($aeab41940996b2c6$var$keyOf)) {
            if (s.kind === 'add') $aeab41940996b2c6$var$pushSeg(cleaned, 'same', s.toks);
            return;
        }
        $aeab41940996b2c6$var$pushSeg(cleaned, s.kind, s.toks);
    });
    return $aeab41940996b2c6$var$collapse(cleaned, context).map((s)=>({
            kind: s.kind,
            text: s.toks.join('')
        }));
}

});




parcelRegister("dlUcE", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7b4aced78aeee5a$export$2e2bcd8739ae039);
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");
parcelRequire("7sS0P");
var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $7gSBD = parcelRequire("7gSBD");

var $huNwV = parcelRequire("huNwV");
var $hygYX = parcelRequire("hygYX");
var $8g4t5 = parcelRequire("8g4t5");
var $bF8pu = parcelRequire("bF8pu");
var $chm1L = parcelRequire("chm1L");
var $6TdpC = parcelRequire("6TdpC");

var $lTG78 = parcelRequire("lTG78");
var $jTCZr = parcelRequire("jTCZr");

var $6xvbB = parcelRequire("6xvbB");

var $i9Cif = parcelRequire("i9Cif");
// The AI differential-diagnosis list (§13.3: AI-labelled until the doctor owns
// it). Each item can be pinned as the primary diagnosis, accepted (→ offer to
// add to SOAP A), rejected, or opened to a per-diagnosis AI confirmation-question
// panel (بله/خیر findings → یادداشت SOAP). All mutations live in the screen; this
// component is render-only and raises intent through callbacks.
const $e7b4aced78aeee5a$var$CONF = (t)=>({
        high: {
            label: t('visit.confidenceLevel.high'),
            color: (0, $jTCZr.CT).good
        },
        medium: {
            label: t('visit.confidenceLevel.medium'),
            color: (0, $jTCZr.CT).warn
        },
        low: {
            label: t('visit.confidenceLevel.low'),
            color: (0, $jTCZr.C).textMuted
        }
    });
// The inline AI confirmation-question panel for one diagnosis. Each question is
// answered once: tapping بله/خیر commits that finding to the SOAP «S» and — once
// the save lands — that question alone closes, collapsing to the line it wrote
// while the rest stay open to be worked through. A question whose save failed
// stays open with its choices live and says why.
const $e7b4aced78aeee5a$var$DiagAIPanel = ({ diag: diag, questions: questions, answers: answers, loading: loading, submitting: submitting = {}, errors: errors = {}, onAnswer: onAnswer, onReload: onReload })=>{
    const { t: t } = (0, $LNQP4.default)();
    const qs = questions || [];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `visit-diff-qbox-${diag.diagnosisCode}`,
        style: {
            marginTop: '0.5rem',
            padding: '0.75rem 0.8125rem',
            background: (0, $jTCZr.CT).surface2,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: '0.625rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.625rem'
        }
    }, loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lTG78.InlineLoading), {
        label: t('visit.copilot.preparingQuestions')
    }), !loading && qs.map((q)=>{
        const ans = answers?.[q.id];
        const yes = ans?.answer === 'yes';
        const no = ans?.answer === 'no';
        const answered = yes || no;
        const qKey = `${diag.diagnosisCode}:${q.id}`;
        const pending = submitting[qKey];
        const qError = errors[qKey];
        const locked = answered || !!pending;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: q.id,
            "data-testid": `visit-diff-q-${q.id}`,
            "data-state": answered ? 'answered' : 'open',
            style: {
                border: `1px solid ${answered ? yes ? (0, $jTCZr.soft)((0, $jTCZr.C).green, 0.6) : (0, $jTCZr.soft)((0, $jTCZr.C).amber, 0.6) : (0, $jTCZr.C).border}`,
                borderRadius: '0.5625rem',
                padding: '0.5625rem 0.6875rem',
                background: answered ? yes ? (0, $jTCZr.C).greenLight : (0, $jTCZr.C).amberLight : (0, $jTCZr.C).card
            }
        }, answered ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.375rem',
                fontSize: '0.75rem',
                fontWeight: 600,
                color: yes ? (0, $jTCZr.CT).goodInk : (0, $jTCZr.CT).warnInk
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
            size: 13,
            "aria-hidden": true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                flex: 1
            }
        }, (0, $6xvbB.questionStatement)(q, ans.answer, t)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.625rem',
                fontWeight: 700,
                color: (0, $jTCZr.C).textMuted
            }
        }, t('visit.state.recorded'))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.8125rem',
                color: (0, $jTCZr.C).textPrimary,
                lineHeight: 1.6,
                marginBottom: q.hint ? '0.1875rem' : '0.4375rem'
            }
        }, q.question), q.hint && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.6875rem',
                color: (0, $jTCZr.C).textMuted,
                lineHeight: 1.5,
                marginBottom: '0.4375rem'
            }
        }, q.hint), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: '0.375rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            size: "sm",
            variant: "outline",
            className: "min-h-11 gap-1.5",
            "data-testid": `visit-diff-q-yes-${q.id}`,
            disabled: locked,
            "aria-busy": pending === 'yes' || undefined,
            onClick: ()=>onAnswer(diag, q, 'yes')
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
            size: 13,
            "aria-hidden": true
        }), " ", pending === 'yes' ? t('common.state.saving') : t('common.actions.yes')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            size: "sm",
            variant: "outline",
            className: "min-h-11 gap-1.5",
            "data-testid": `visit-diff-q-no-${q.id}`,
            disabled: locked,
            "aria-busy": pending === 'no' || undefined,
            onClick: ()=>onAnswer(diag, q, 'no')
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
            size: 13,
            "aria-hidden": true
        }), " ", pending === 'no' ? t('common.state.saving') : t('common.actions.no')))), qError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            role: "alert",
            "data-testid": `visit-diff-q-error-${q.id}`,
            style: {
                marginTop: '0.4375rem',
                fontSize: '0.75rem',
                color: (0, $jTCZr.CT).danger,
                lineHeight: 1.5
            }
        }, qError));
    }), !loading && qs.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        className: "w-full min-h-11 gap-1.5",
        "data-testid": `visit-diff-q-reload-${diag.diagnosisCode}`,
        onClick: ()=>onReload(diag),
        style: {
            color: (0, $jTCZr.C).textMuted
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bF8pu.default), {
        size: 13,
        "aria-hidden": true
    }), " ", t('visit.copilot.regenerateQuestions')));
};
const $e7b4aced78aeee5a$var$MobileVisitDifferential = ({ items: items, loading: loading, primaryCode: primaryCode, onSetPrimary: onSetPrimary, onAccept: onAccept, onReject: onReject, typePick: // «نوع تشخیص»: `typePick` is the diagnosisCode whose type is being chosen,
// `conditions` the patient's chart rows the recorded type is read back from.
// onAccept is (diagnosis, diagnosisType) — never called without a type.
typePick, onPickType: onPickType, typeBusy: typeBusy, conditions: conditions, confirmToA: confirmToA, onConfirmToA: onConfirmToA, onAddIcd: onAddIcd, visitStatus: visitStatus, openAIDiag: openAIDiag, onToggleAIDiag: onToggleAIDiag, aiQuestions: aiQuestions = {}, aiAnswers: aiAnswers = {}, aiLoading: aiLoading = {}, aiSubmitting: aiSubmitting = {}, aiErrors: aiErrors = {}, onAnswer: onAnswer, onReloadQuestions: onReloadQuestions, gate: gate, pollingActive: pollingActive, pollLabel: pollLabel, pollSeconds: pollSeconds, pollOverridden: pollOverridden, onTogglePolling: onTogglePolling })=>{
    const { t: t } = (0, $LNQP4.default)();
    const list = items || [];
    // A gated differential is not an empty one — see the panel below.
    const blocked = !!gate && !gate.ready && visitStatus === 'inprogress';
    const state = loading && !list.length ? 'loading' : !list.length ? 'empty' : 'content';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-differential-content",
        "data-state": state,
        "aria-busy": loading || undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lTG78.VisitSectionHead), {
        badge: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lTG78.AiBadge), {
            label: t('visit.copilot.fromVisitEvidence')
        })
    }, t('credits.price.differential')), blocked && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-diff-gate",
        "data-missing": gate.missing.join(','),
        style: {
            margin: '0.5rem 0 0.625rem',
            padding: '0.75rem 0.8125rem',
            background: (0, $jTCZr.CT).surface2,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: '0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: '0.5rem',
            marginBottom: '0.5625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $chm1L.default), {
        size: 14,
        color: (0, $jTCZr.CT).accentInk,
        style: {
            flexShrink: 0,
            marginTop: '0.125rem'
        },
        "aria-hidden": true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            fontSize: '0.8125rem',
            fontWeight: 600,
            color: (0, $jTCZr.C).textPrimary,
            lineHeight: 1.65
        }
    }, t('visit.copilot.diffGate.title'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-diff-gate-history",
        "data-state": "todo",
        style: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: '0.4375rem',
            fontSize: '0.75rem',
            lineHeight: 1.7,
            color: (0, $jTCZr.C).textSecondary
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flexShrink: 0,
            marginTop: '0.4375rem',
            width: '0.375rem',
            height: '0.375rem',
            borderRadius: '50%',
            background: (0, $jTCZr.CT).accent
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1
        }
    }, t(`visit.copilot.diffGate.${gate.missing.includes('historyThin') ? 'historyThin' : 'history'}`))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-diff-gate-hint",
        style: {
            marginTop: '0.4375rem',
            paddingTop: '0.4375rem',
            borderTop: `1px dashed ${(0, $jTCZr.C).border}`,
            fontSize: '0.6875rem',
            lineHeight: 1.7,
            color: (0, $jTCZr.C).textMuted
        }
    }, t('visit.copilot.diffGate.monitoringHint'))), onTogglePolling && !blocked && visitStatus === 'inprogress' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            margin: '0.5rem 0 0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: pollingActive ? 'default' : 'outline',
        size: "sm",
        className: "w-full min-h-11 justify-between gap-1.5",
        "data-testid": "visit-diff-poll-toggle",
        "data-poll-state": pollingActive ? 'on' : 'off',
        "data-poll-seconds": pollingActive ? String(pollSeconds) : undefined,
        "aria-pressed": !!pollingActive,
        "aria-label": pollingActive ? t('visit.copilot.pollDisable') : t('visit.copilot.pollEnable'),
        onClick: onTogglePolling
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.375rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: '0.375rem',
            height: '0.375rem',
            borderRadius: '50%',
            background: pollingActive ? '#fff' : (0, $jTCZr.C).textMuted,
            flexShrink: 0
        }
    }), t('visit.copilot.pollLabel')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontWeight: 700
        },
        "data-testid": "visit-diff-poll-state"
    }, pollingActive ? pollLabel : t('visit.copilot.pollOff'))), pollOverridden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-diff-poll-note",
        style: {
            marginTop: '0.3125rem',
            fontSize: '0.6875rem',
            color: (0, $jTCZr.C).textMuted,
            lineHeight: 1.5
        }
    }, t('visit.copilot.pollVisitOnly'))), loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lTG78.InlineLoading), {
        label: t('visit.copilot.updatingDx')
    }), confirmToA && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            margin: '0.5rem 0 0.625rem',
            padding: '0.6875rem 0.875rem',
            background: (0, $jTCZr.CT).accentSoft,
            border: `1px solid ${(0, $jTCZr.CT).accent}`,
            borderRadius: '0.625rem',
            display: 'flex',
            alignItems: 'center',
            gap: '0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            fontSize: '0.8125rem',
            color: (0, $jTCZr.C).textPrimary
        }
    }, t('visit.soap.addToAssessment', {
        text: confirmToA.description
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        size: "sm",
        variant: "default",
        className: "min-h-11 shrink-0",
        "data-testid": "visit-diff-confirm-a-yes",
        onClick: ()=>onConfirmToA(true)
    }, t('common.actions.yes')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        size: "sm",
        variant: "outline",
        className: "min-h-11 shrink-0",
        "data-testid": "visit-diff-confirm-a-no",
        onClick: ()=>onConfirmToA(false)
    }, t('common.actions.no'))), state === 'empty' && !loading && !blocked && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $chm1L.default), {
            size: 44,
            color: (0, $jTCZr.C).textMuted,
            strokeWidth: 1.5,
            "aria-hidden": true
        }),
        title: visitStatus === 'inprogress' ? t('visit.copilot.processingDifferential') : t('visit.copilot.afterStart')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem'
        }
    }, list.map((d, i)=>{
        const isPrimary = primaryCode === d.diagnosisCode;
        const isAccepted = (0, $6xvbB.isDifferentialAccepted)(d);
        const isRejected = d.status === 'rejected';
        const conf = $e7b4aced78aeee5a$var$CONF(t)[d.confidence];
        const isAIOpen = openAIDiag === d.diagnosisCode;
        const isTypePicking = typePick === d.diagnosisCode;
        // Read back from the chart, not from the differential item — the same
        // source the record sheet's badge uses, so they cannot disagree.
        const acceptedType = (0, $6xvbB.diagnosisTypeForCode)(conditions, d.diagnosisCode);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: d.diagnosisCode || i,
            "data-testid": `visit-diff-row-${d.diagnosisCode || i}`,
            style: {
                borderRadius: '0.75rem',
                padding: '0.6875rem 0.8125rem',
                border: `1px solid ${isPrimary ? (0, $jTCZr.CT).accent : (0, $jTCZr.C).border}`,
                background: isPrimary ? `linear-gradient(180deg, ${(0, $jTCZr.CT).accentSoft}, ${(0, $jTCZr.C).card} 80%)` : (0, $jTCZr.C).card,
                opacity: isRejected ? 0.5 : 1
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                marginBottom: '0.1875rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1,
                minWidth: 0,
                display: 'flex',
                alignItems: 'center',
                gap: '0.375rem',
                flexWrap: 'wrap'
            }
        }, isPrimary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.5625rem',
                fontWeight: 700,
                padding: '0.125rem 0.4375rem',
                borderRadius: '0.25rem',
                background: (0, $jTCZr.CT).accent,
                color: '#fff'
            }
        }, t('visit.dx.primaryShort')), isAccepted && (acceptedType ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $i9Cif.DiagnosisTypeBadge), {
            cond: {
                verificationStatus: acceptedType
            },
            testid: `visit-diff-type-badge-${d.diagnosisCode || i}`
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.5625rem',
                fontWeight: 700,
                padding: '0.125rem 0.4375rem',
                borderRadius: '0.25rem',
                background: (0, $jTCZr.C).greenLight,
                color: (0, $jTCZr.CT).goodInk
            }
        }, t('common.actions.confirm'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.8125rem',
                fontWeight: 600,
                color: isAccepted ? (0, $jTCZr.CT).goodInk : (0, $jTCZr.C).textPrimary
            }
        }, d.description)), conf && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.75rem',
                fontWeight: 700,
                color: conf.color
            }
        }, conf.label)), d.diagnosisCode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.625rem',
                color: (0, $jTCZr.C).textMuted,
                marginBottom: '0.375rem',
                fontFamily: 'ui-monospace, monospace'
            }
        }, d.diagnosisCode), d.supportingEvidence?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                margin: '0.3125rem 0 0.125rem'
            }
        }, d.supportingEvidence.slice(0, 2).map((e, j)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                key: j,
                style: {
                    display: 'flex',
                    gap: '0.3125rem',
                    fontSize: '0.6875rem',
                    color: (0, $jTCZr.C).textSecondary,
                    lineHeight: 1.45,
                    marginBottom: '0.125rem'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    width: '0.3125rem',
                    height: '0.3125rem',
                    borderRadius: '50%',
                    background: (0, $jTCZr.CT).good,
                    flexShrink: 0,
                    marginTop: '0.25rem'
                }
            }), e))), d.contradictingEvidence?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                marginBottom: '0.125rem'
            }
        }, d.contradictingEvidence.slice(0, 1).map((e, j)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                key: j,
                style: {
                    display: 'flex',
                    gap: '0.3125rem',
                    fontSize: '0.6875rem',
                    color: (0, $jTCZr.C).textMuted,
                    lineHeight: 1.45,
                    marginBottom: '0.125rem'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    width: '0.3125rem',
                    height: '0.3125rem',
                    borderRadius: '50%',
                    background: (0, $jTCZr.CT).danger,
                    flexShrink: 0,
                    marginTop: '0.25rem'
                }
            }), e))), d.vitalSignImpact?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                marginTop: '0.375rem',
                paddingTop: '0.375rem',
                borderTop: `1px dashed ${(0, $jTCZr.C).border}`
            },
            "data-testid": `visit-diff-vital-impact-${d.diagnosisCode || i}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.625rem',
                color: (0, $jTCZr.C).textMuted,
                fontWeight: 600,
                marginBottom: '0.25rem'
            }
        }, t('visit.copilot.vitalImpact.title')), d.vitalSignImpact.map((v, j)=>{
            const meta = (0, $6xvbB.vitalEffectMeta)(v.effect, t);
            const tone = {
                good: (0, $jTCZr.CT).good,
                danger: (0, $jTCZr.CT).danger,
                mute: (0, $jTCZr.C).textMuted
            }[meta.tone];
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                key: j,
                style: {
                    display: 'flex',
                    gap: '0.3125rem',
                    fontSize: '0.6875rem',
                    color: (0, $jTCZr.C).textSecondary,
                    lineHeight: 1.45,
                    marginBottom: '0.125rem'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    width: '0.3125rem',
                    height: '0.3125rem',
                    borderRadius: '50%',
                    background: tone,
                    flexShrink: 0,
                    marginTop: '0.25rem'
                }
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    fontWeight: 600,
                    color: (0, $jTCZr.C).textPrimary
                }
            }, v.vital, v.value ? ` ${v.value}` : ''), v.status && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    color: tone,
                    fontWeight: 600
                }
            }, " \xb7 ", v.status), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    color: (0, $jTCZr.C).textMuted
                }
            }, " \xb7 ", meta.label), " \u2014 ", v.explanation));
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                gap: '0.375rem',
                marginTop: '0.5rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: isPrimary ? 'default' : 'outline',
            size: "sm",
            className: "flex-1 min-h-11 gap-1.5",
            "data-testid": `visit-diff-pin-${d.diagnosisCode || i}`,
            "aria-pressed": isPrimary,
            onClick: ()=>onSetPrimary(isPrimary ? null : d.diagnosisCode)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hygYX.default), {
            size: 13,
            "aria-hidden": true
        }), isPrimary ? t('visit.dx.primary') : t('visit.dx.mark')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: isAIOpen ? 'default' : 'outline',
            size: "icon",
            className: "min-h-11 w-11",
            "aria-label": t('visit.copilot.confirmQuestions'),
            "aria-pressed": isAIOpen,
            "data-testid": `visit-diff-ai-${d.diagnosisCode || i}`,
            onClick: ()=>onToggleAIDiag(d)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $chm1L.default), {
            size: 14,
            "aria-hidden": true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: isAccepted ? 'default' : 'outline',
            size: "icon",
            className: "min-h-11 w-11",
            "aria-label": isAccepted ? t('visit.dx.type.changeTitle') : t('visit.orders.approveAria', {
                name: d.description
            }),
            "aria-expanded": isTypePicking,
            "data-testid": `visit-diff-accept-${d.diagnosisCode || i}`,
            // Opens the «نوع تشخیص» choice — same gate as the desktop rail.
            onClick: ()=>onPickType(isTypePicking ? null : d.diagnosisCode)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
            size: 14,
            "aria-hidden": true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: isRejected ? 'destructive' : 'outline',
            size: "icon",
            className: "min-h-11 w-11",
            "aria-label": t('visit.orders.rejectAria', {
                name: d.description
            }),
            "data-testid": `visit-diff-reject-${d.diagnosisCode || i}`,
            onClick: ()=>onReject(d)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
            size: 14,
            "aria-hidden": true
        }))), isTypePicking && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $i9Cif.DiagnosisTypeChoice), {
            testidPrefix: `visit-diff-type-${d.diagnosisCode || i}`,
            current: acceptedType,
            busy: typeBusy,
            title: isAccepted ? t('visit.dx.type.changeTitle') : undefined,
            onCancel: ()=>onPickType(null),
            onPick: (type)=>onAccept(d, type)
        }), isAIOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e7b4aced78aeee5a$var$DiagAIPanel, {
            diag: d,
            questions: aiQuestions[d.diagnosisCode],
            answers: aiAnswers[d.diagnosisCode],
            loading: aiLoading[d.diagnosisCode],
            submitting: aiSubmitting,
            errors: aiErrors,
            onAnswer: onAnswer,
            onReload: onReloadQuestions
        }));
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "sm",
        onClick: onAddIcd,
        "data-testid": "visit-diff-add",
        className: "w-full min-h-11 mt-2 gap-1.5 border-dashed",
        style: {
            color: (0, $jTCZr.C).textMuted
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8g4t5.default), {
        size: 14,
        "aria-hidden": true
    }), " ", t('visit.dx.addIcd11')));
};
var $e7b4aced78aeee5a$export$2e2bcd8739ae039 = $e7b4aced78aeee5a$var$MobileVisitDifferential;

});
parcelRegister("hygYX", function(module, exports) {

$parcel$export(module.exports, "default", () => $67dd26035226e4d8$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $67dd26035226e4d8$export$a2387ed3b5d536eb = {
    name: "pin",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M12 17v5",
                key: "bb1du9"
            }
        ],
        [
            "path",
            {
                d: "M9 10.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H8a2 2 0 0 0 0 4 1 1 0 0 1 1 1z",
                key: "1nkz8b"
            }
        ]
    ]
};
$67dd26035226e4d8$export$a2387ed3b5d536eb.node;
const $67dd26035226e4d8$export$2e2bcd8739ae039 = (0, $9QBug.default)($67dd26035226e4d8$export$a2387ed3b5d536eb);

});

parcelRegister("lTG78", function(module, exports) {

$parcel$export(module.exports, "AiBadge", () => $e031888e2d726c18$export$c606e0dfdc515248);
$parcel$export(module.exports, "InlineLoading", () => $e031888e2d726c18$export$491ebe8eaed97507);
$parcel$export(module.exports, "VisitSectionHead", () => $e031888e2d726c18$export$b4c46f7bd56514c0);
$parcel$export(module.exports, "SEVERITY_TONE", () => $e031888e2d726c18$export$4ca721b91274208a);
$parcel$export(module.exports, "urgencyColor", () => $e031888e2d726c18$export$d5e749cf0acf0b49);
$parcel$export(module.exports, "soft", () => (parcelRequire("jTCZr")).soft);
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");
parcelRequire("7sS0P");
var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $hZDga = parcelRequire("hZDga");

var $chm1L = parcelRequire("chm1L");
parcelRequire("gcegg");
var $jTCZr = parcelRequire("jTCZr");
const $e031888e2d726c18$export$c606e0dfdc515248 = ({ label: label, style: style })=>{
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "ai-badge",
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.25rem',
            fontSize: '0.625rem',
            fontWeight: 700,
            padding: '0.125rem 0.5rem',
            borderRadius: '0.75rem',
            background: (0, $jTCZr.CT).accentSoft,
            color: (0, $jTCZr.CT).accentInk,
            whiteSpace: 'nowrap',
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $chm1L.default), {
        size: 11,
        strokeWidth: 2.2,
        "aria-hidden": true
    }), label ?? t('visit.suggest.ai'));
};
const $e031888e2d726c18$export$491ebe8eaed97507 = ({ label: label })=>{
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.375rem',
            fontSize: '0.6875rem',
            color: (0, $jTCZr.C).textMuted,
            padding: '0.375rem 0'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 12,
        color: (0, $jTCZr.CT).accent,
        thickness: 2
    }), label ?? t('common.state.loadingEllipsis'));
};
const $e031888e2d726c18$export$b4c46f7bd56514c0 = ({ children: children, badge: badge, action: action })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            marginBottom: '0.625rem',
            flexWrap: 'wrap'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.6875rem',
            fontWeight: 700,
            color: (0, $jTCZr.C).textMuted,
            textTransform: 'uppercase',
            letterSpacing: '0.06em'
        }
    }, children), badge, action && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginInlineStart: 'auto'
        }
    }, action));
const $e031888e2d726c18$export$4ca721b91274208a = (t)=>({
        high: {
            color: (0, $jTCZr.CT).dangerInk,
            bg: (0, $jTCZr.C).redLight,
            label: t('visit.severity.high')
        },
        medium: {
            color: (0, $jTCZr.CT).warnInk,
            bg: (0, $jTCZr.C).amberLight,
            label: t('visit.severity.medium')
        },
        low: {
            color: (0, $jTCZr.CT).goodInk,
            bg: (0, $jTCZr.C).greenLight,
            label: t('visit.severity.low')
        }
    });
const $e031888e2d726c18$export$d5e749cf0acf0b49 = (u)=>u === 'stat' ? (0, $jTCZr.CT).danger : u === 'urgent' ? (0, $jTCZr.CT).warn : (0, $jTCZr.CT).good;

});

parcelRegister("i9Cif", function(module, exports) {

$parcel$export(module.exports, "DiagnosisTypeBadge", () => $5311b30cb4607f8a$export$914997c98d3577e5);
$parcel$export(module.exports, "DiagnosisTypeChoice", () => $5311b30cb4607f8a$export$7085d532b18268b);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $fdoIv = parcelRequire("fdoIv");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $ltciA = parcelRequire("ltciA");

var $6ojK3 = parcelRequire("6ojK3");
function $5311b30cb4607f8a$export$914997c98d3577e5({ cond: cond, style: style, testid: testid }) {
    const type = (0, $6ojK3.diagnosisTypeOf)(cond);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": testid || `dx-type-${type}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fdoIv.default), {
        status: type,
        style: {
            fontSize: '0.59375rem',
            padding: '2px 7px',
            ...style
        }
    }));
}
// Framework tokens, not the Visit workspace's CSS variables.
//
// `Visit.web.jsx` injects the `:root` block that defines `--accent`, `--ink` and
// friends; `Visit.mobile.jsx` deliberately injects none of it. An unresolved
// custom property is not a fallback to something sensible — the declaration is
// dropped — so on the phone this gate rendered with no panel behind it at all,
// which is how a decision the doctor cannot skip ended up looking like body
// text. Nor is `var(--accent, …)` the fix: `--accent` also exists globally as
// the shadcn HSL triple, so the fallback never fires and the value that wins is
// not a colour. The `:root` block computes to these same token values, so the
// desktop surface is unchanged. See TemplateApplyButton.jsx for the long form.
const $5311b30cb4607f8a$var$PAL = {
    line: (0, $jTCZr.CT).border,
    ink: (0, $jTCZr.CT).ink,
    ink2: (0, $jTCZr.CT).ink2,
    accent: (0, $jTCZr.CT).accent,
    accentSoft: (0, $jTCZr.CT).accentSoft
};
function $5311b30cb4607f8a$export$7085d532b18268b({ current: current, onPick: onPick, onCancel: onCancel, busy: busy, title: title, testidPrefix: testidPrefix = 'dx-type-choice' }) {
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testidPrefix,
        style: {
            marginTop: 8,
            padding: 9,
            borderRadius: 8,
            border: `1px solid ${$5311b30cb4607f8a$var$PAL.accent}`,
            background: $5311b30cb4607f8a$var$PAL.accentSoft
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.71875rem',
            fontWeight: 600,
            color: $5311b30cb4607f8a$var$PAL.ink,
            marginBottom: 2
        }
    }, title || t('visit.dx.type.pickTitle')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.65625rem',
            color: $5311b30cb4607f8a$var$PAL.ink2,
            marginBottom: 8
        }
    }, t('visit.dx.type.pickHint')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 6,
            flexWrap: 'wrap'
        }
    }, (0, $6ojK3.DIAGNOSIS_TYPES).map((type)=>{
        const cfg = (0, $ltciA.STATUS)[type] || {};
        const isCurrent = current === type;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: type,
            type: "button",
            disabled: busy,
            "data-testid": `${testidPrefix}-${type}`,
            onClick: ()=>onPick(type),
            style: {
                flex: 1,
                minWidth: 96,
                padding: '6px 10px',
                borderRadius: 6,
                fontSize: '0.71875rem',
                fontWeight: 600,
                fontFamily: 'inherit',
                background: cfg.bg,
                color: cfg.text,
                border: `1px solid ${isCurrent ? cfg.text : 'transparent'}`,
                cursor: busy ? 'default' : 'pointer',
                opacity: busy ? 0.6 : 1
            }
        }, t((0, $6ojK3.DIAGNOSIS_TYPE_LABEL_KEYS)[type]));
    }), onCancel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        disabled: busy,
        "data-testid": `${testidPrefix}-cancel`,
        onClick: onCancel,
        style: {
            padding: '6px 10px',
            borderRadius: 6,
            fontSize: '0.71875rem',
            fontFamily: 'inherit',
            background: 'transparent',
            color: $5311b30cb4607f8a$var$PAL.ink2,
            border: `1px solid ${$5311b30cb4607f8a$var$PAL.line}`,
            cursor: busy ? 'default' : 'pointer'
        }
    }, t('common.actions.cancel'))));
}

});
parcelRegister("fdoIv", function(module, exports) {

$parcel$export(module.exports, "default", () => $547c752fb4c18299$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $ltciA = parcelRequire("ltciA");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
function $547c752fb4c18299$export$2e2bcd8739ae039({ status: status, style: style, label: label }) {
    const { t: t, has: has } = (0, $LNQP4.default)();
    const cfg = (0, $ltciA.STATUS)[status] || {
        label: status || "\u2014",
        bg: '#f1f5f9',
        text: '#64748b'
    };
    const key = cfg.labelKey || (0, $ltciA.STATUS_LABEL_KEYS)[status];
    const resolved = key && has(key) ? t(key) : cfg.label;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.6875rem',
            fontWeight: 700,
            padding: '3px 10px',
            borderRadius: 20,
            whiteSpace: 'nowrap',
            background: cfg.bg,
            color: cfg.text,
            ...style
        }
    }, label ?? resolved);
}

});
parcelRegister("ltciA", function(module, exports) {

$parcel$export(module.exports, "orderStageColors", () => $fa15d8b4a746e70c$export$81add3ee535ead28);
$parcel$export(module.exports, "orderStageOf", () => $fa15d8b4a746e70c$export$e60d2818e9814d49);
$parcel$export(module.exports, "sessionStatusColors", () => $fa15d8b4a746e70c$export$fdd2d729cc074507);
$parcel$export(module.exports, "sessionStatusOf", () => $fa15d8b4a746e70c$export$fb2b654199c02c7a);
$parcel$export(module.exports, "orderBookingOf", () => $fa15d8b4a746e70c$export$934f2a2a1e13fc35);
$parcel$export(module.exports, "OPEN_ORDER_STATUSES", () => $fa15d8b4a746e70c$export$dcac1cce4fca5347);
$parcel$export(module.exports, "STATUS_LABEL_KEYS", () => $fa15d8b4a746e70c$export$a1b41aa6b5adf2fe);
$parcel$export(module.exports, "STATUS", () => $fa15d8b4a746e70c$export$e50006273435e7d4);
// Single app-level status vocabulary.
//
// The framework token export (`statusColors`) owns the appointment-lifecycle and
// patient-record statuses. Three more vocabularies the doctor app needs — invoice
// *settlement*, order *urgency*, and order *lifecycle status* — are not in the
// framework yet, so they live here. Their colours are DERIVED from `statusColors`
// so there is exactly one hex source in the whole app; nothing re-hardcodes a
// status colour.
//
// When the framework adds these keys, delete the maps below and let everything
// fall through to `statusColors` — `StatusChip` will keep working.

var $jTCZr = parcelRequire("jTCZr");

var $6ojK3 = parcelRequire("6ojK3");
const $fa15d8b4a746e70c$export$6994ca3c75ca1caa = {
    SETTLED: {
        ...(0, $jTCZr.statusColors).completed,
        labelKey: 'common.settlement.SETTLED'
    },
    PARTIALLY_PAID: {
        ...(0, $jTCZr.statusColors).waiting,
        labelKey: 'common.settlement.PARTIALLY_PAID'
    },
    UNPAID: {
        ...(0, $jTCZr.statusColors).cancelled,
        labelKey: 'common.settlement.UNPAID'
    }
};
const $fa15d8b4a746e70c$export$7ae9bf836a83e0f0 = {
    routine: {
        ...(0, $jTCZr.statusColors).scheduled,
        labelKey: 'common.urgency.routine'
    },
    urgent: {
        ...(0, $jTCZr.statusColors).waiting,
        labelKey: 'common.urgency.urgent'
    },
    stat: {
        ...(0, $jTCZr.statusColors).cancelled,
        labelKey: 'common.urgency.stat'
    }
};
const $fa15d8b4a746e70c$export$5f296182ef21a05b = {
    pending: {
        ...(0, $jTCZr.statusColors).waiting,
        labelKey: 'common.orderStatus.pending'
    },
    in_progress: {
        ...(0, $jTCZr.statusColors).scheduled,
        labelKey: 'common.orderStatus.in_progress'
    },
    completed: {
        ...(0, $jTCZr.statusColors).completed,
        labelKey: 'common.orderStatus.completed'
    },
    cancelled: {
        ...(0, $jTCZr.statusColors).cancelled,
        labelKey: 'common.orderStatus.cancelled'
    }
};
const $fa15d8b4a746e70c$export$be09ebc684415570 = [
    'REQUESTED',
    'SCHEDULED',
    'IN_PROGRESS',
    'DONE',
    'CANCELLED'
];
const $fa15d8b4a746e70c$export$81add3ee535ead28 = {
    REQUESTED: {
        ...(0, $jTCZr.statusColors).waiting,
        pill: 'amber',
        labelKey: 'common.orderStage.REQUESTED'
    },
    SCHEDULED: {
        ...(0, $jTCZr.statusColors).scheduled,
        pill: 'navy',
        labelKey: 'common.orderStage.SCHEDULED'
    },
    IN_PROGRESS: {
        ...(0, $jTCZr.statusColors).in_visit,
        pill: 'teal',
        labelKey: 'common.orderStage.IN_PROGRESS'
    },
    DONE: {
        ...(0, $jTCZr.statusColors).completed,
        pill: 'good',
        labelKey: 'common.orderStage.DONE'
    },
    CANCELLED: {
        ...(0, $jTCZr.statusColors).cancelled,
        pill: 'muted',
        labelKey: 'common.orderStage.CANCELLED'
    }
};
const $fa15d8b4a746e70c$var$STAGE_OF_STATUS = {
    pending: 'REQUESTED',
    in_progress: 'IN_PROGRESS',
    completed: 'DONE',
    cancelled: 'CANCELLED'
};
const $fa15d8b4a746e70c$export$e60d2818e9814d49 = (order)=>{
    const stage = order?.stage;
    if (stage && Object.prototype.hasOwnProperty.call($fa15d8b4a746e70c$export$81add3ee535ead28, stage)) return stage;
    return $fa15d8b4a746e70c$var$STAGE_OF_STATUS[order?.status] || null;
};
const $fa15d8b4a746e70c$export$4989ed2695133897 = [
    'REQUESTED',
    'SCHEDULED',
    'IN_PROGRESS',
    'DONE',
    'NOT_DONE',
    'CANCELLED',
    'VOIDED'
];
const $fa15d8b4a746e70c$export$fdd2d729cc074507 = {
    REQUESTED: {
        ...$fa15d8b4a746e70c$export$81add3ee535ead28.REQUESTED,
        history: false,
        labelKey: 'common.sessionStatus.requested'
    },
    SCHEDULED: {
        ...$fa15d8b4a746e70c$export$81add3ee535ead28.SCHEDULED,
        history: false,
        labelKey: 'common.sessionStatus.scheduled'
    },
    IN_PROGRESS: {
        ...$fa15d8b4a746e70c$export$81add3ee535ead28.IN_PROGRESS,
        history: false,
        labelKey: 'common.sessionStatus.inProgress'
    },
    DONE: {
        ...$fa15d8b4a746e70c$export$81add3ee535ead28.DONE,
        history: false,
        labelKey: 'common.sessionStatus.done'
    },
    NOT_DONE: {
        ...$fa15d8b4a746e70c$export$81add3ee535ead28.CANCELLED,
        history: true,
        labelKey: 'common.sessionStatus.notDone'
    },
    CANCELLED: {
        ...$fa15d8b4a746e70c$export$81add3ee535ead28.CANCELLED,
        history: true,
        labelKey: 'common.sessionStatus.cancelled'
    },
    VOIDED: {
        ...$fa15d8b4a746e70c$export$81add3ee535ead28.CANCELLED,
        history: true,
        labelKey: 'common.sessionStatus.voided'
    }
};
function $fa15d8b4a746e70c$export$fb2b654199c02c7a(s) {
    if (!s) return null;
    if (s.status) return String(s.status).toUpperCase();
    if (s.voidedAt) return 'VOIDED';
    const o = String(s.outcome || '').toLowerCase();
    if (o === 'completed') return 'DONE';
    if (o === 'in_progress') return 'IN_PROGRESS';
    return 'REQUESTED';
}
const $fa15d8b4a746e70c$export$934f2a2a1e13fc35 = (order)=>{
    const stage = $fa15d8b4a746e70c$export$e60d2818e9814d49(order);
    return (stage === 'SCHEDULED' || stage === 'IN_PROGRESS') && order?.nextBookingAt ? order.nextBookingAt : null;
};
const $fa15d8b4a746e70c$export$72f0d53c30dd261e = {
    [(0, $6ojK3.DX_PROVISIONAL)]: {
        ...(0, $jTCZr.statusColors).waiting,
        labelKey: (0, $6ojK3.DIAGNOSIS_TYPE_LABEL_KEYS)[0, $6ojK3.DX_PROVISIONAL]
    },
    [(0, $6ojK3.DX_CONFIRMED)]: {
        ...(0, $jTCZr.statusColors).completed,
        labelKey: (0, $6ojK3.DIAGNOSIS_TYPE_LABEL_KEYS)[0, $6ojK3.DX_CONFIRMED]
    }
};
const $fa15d8b4a746e70c$export$dcac1cce4fca5347 = [
    'pending',
    'in_progress'
];
const $fa15d8b4a746e70c$export$a1b41aa6b5adf2fe = {
    scheduled: 'common.status.scheduled',
    arrived: 'common.status.arrived',
    in_visit: 'common.status.in_visit',
    completed: 'common.status.completed',
    cancelled: 'common.status.cancelled',
    // A booked patient who never arrived. scheduling's REOPENABLE_STATUSES sets
    // it, so the day list really can receive one; without a key it would fall
    // through to the framework's Persian «عدم حضور» in every language.
    no_show: 'common.status.no_show',
    // The patient asked; reception has not answered. Read-only on every doctor
    // surface — confirming a request is the desk's job, not the doctor's.
    requested: 'common.status.requested',
    rejected: 'common.status.rejected',
    waiting: 'common.status.waiting',
    visited: 'common.status.visited',
    inprogress: 'common.status.inprogress'
};
const $fa15d8b4a746e70c$export$e50006273435e7d4 = {
    ...(0, $jTCZr.statusColors),
    ...$fa15d8b4a746e70c$export$6994ca3c75ca1caa,
    ...$fa15d8b4a746e70c$export$7ae9bf836a83e0f0,
    ...$fa15d8b4a746e70c$export$72f0d53c30dd261e
};

});




parcelRegister("6miYn", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d5dc5a5bf298474$export$2e2bcd8739ae039);
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");
parcelRequire("7sS0P");
var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $7gSBD = parcelRequire("7gSBD");
var $hZDga = parcelRequire("hZDga");
var $5JYPc = parcelRequire("5JYPc");

var $QG9Z3 = parcelRequire("QG9Z3");
var $97xXr = parcelRequire("97xXr");
var $aVx4q = parcelRequire("aVx4q");
var $bo0GS = parcelRequire("bo0GS");
var $chm1L = parcelRequire("chm1L");
var $6TdpC = parcelRequire("6TdpC");

var $6xvbB = parcelRequire("6xvbB");
var $g6gAc = parcelRequire("g6gAc");

var $lfHhF = parcelRequire("lfHhF");

var $eQiuG = parcelRequire("eQiuG");

var $85jFj = parcelRequire("85jFj");
parcelRequire("lTG78");
var $jTCZr = parcelRequire("jTCZr");

var $9SQfR = parcelRequire("9SQfR");
// `labelFor` translates the option TEXT only; the option's value — and so what
// onChange writes to the record — stays the stored Persian. A frequency saved
// from this dropdown is byte-identical to one saved before, in every locale.
// The route choices: the fixed values, with a stored value that names none of
// them kept on top — it must still show what it says until the doctor replaces it.
const $3d5dc5a5bf298474$var$withRoute = (route)=>route && !(0, $eQiuG.toRouteOption)(route) ? [
        route,
        ...(0, $6xvbB.RX_ROUTES)()
    ] : (0, $6xvbB.RX_ROUTES)();
const $3d5dc5a5bf298474$var$Select = ({ value: value, onChange: onChange, options: options, placeholder: placeholder, testId: testId, labelFor: labelFor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("select", {
        value: value || '',
        onChange: onChange,
        "data-testid": testId,
        style: {
            minWidth: 0,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: '0.375rem',
            padding: '0.375rem 0.5rem',
            fontSize: '1rem',
            minHeight: '2.75rem',
            fontFamily: 'inherit',
            color: value ? (0, $jTCZr.C).textPrimary : (0, $jTCZr.C).textMuted,
            background: (0, $jTCZr.C).card,
            outline: 'none'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
        value: ""
    }, placeholder), (options || []).map((o)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
            key: o,
            value: o
        }, labelFor ? labelFor(o) : o)));
const $3d5dc5a5bf298474$var$MobileVisitRx = ({ rxItems: rxItems, onAdd: onAdd, onRemove: onRemove, onUpdate: onUpdate, interactions: interactions, interactionLoading: interactionLoading, interactionError: interactionError, interactionStale: interactionStale, onCheckInteractions: onCheckInteractions, canCheckInteractions: canCheckInteractions, assist: // The نسخه's AI helper (docs/VISIT_RX_AI_ASSIST.md): «پیشنهاد دارو» proposes
// from the note — { busySource, onHistory, canHistory }. Reading «پایش بالینی»
// is the visit-wide «تکمیل» in the pinned strip, which covers the نسخه like
// every other section; the section's own copy of that button is gone
// (PM-0110 item 2). «ثبت صوتی دارو» was removed (PM-0024).
assist, proposal: proposal = null, templateButton: // «قالب نسخه»: the screen's TemplateApplyButton, placed here beside «پیشنهاد
// دارو» in one row under the search (PM-0110 item 3) rather than as a
// full-width band above the tab.
templateButton = null, documentDrafts: // Drugs offered to this visit from outside — a document review («افزودن به
// نسخه ویزیت», DICOM_COMPRESSION_LIMITS_AND_DOCUMENT_OCR_DESIGN.md §23.3 A13) or
// an approved AI proposal (a draft carrying its own `sourceLabel`/`sourceKind`):
// each opens the add form prefilled with its sig, one at a time, and reaches the
// نسخه only by that form's «افزودن به نسخه» — as the product the form ended on.
// «انصراف» drops it.
documentDrafts = [], onConfirmDocumentDraft: onConfirmDocumentDraft, onDiscardDocumentDraft: onDiscardDocumentDraft, defaultsFor: // The sig a product opens the add form with; the product's own when not given.
defaultsFor, memory: // The doctor's last directions (useRxMemory `memory`, PM-0574) for the picker.
memory = null, frequent: // «داروهای پرتکرار من» for the picker (RxDrugSearch `frequent`, PM-0516):
// { entries: [{ drug, sig, times }], onAddUsual(drug, sig) }. One tap on a row
// adds the drug with its saved sig through the host's add path — no form.
frequent = null, insurer: // The patient's basic insurer (rxOptions insurerKeyOf): «در فهرست تأمین» on the
// search results and the add form, as on the desktop.
insurer = null })=>{
    const { t: t, readsPersianData: readsPersianData } = (0, $LNQP4.default)();
    const startWith = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>defaultsFor || ((drug)=>(0, $eQiuG.rxAddDefaults)(drug, null, {
                defaultDuration: t('visit.duration.d7')
            })), [
        defaultsFor,
        t
    ]);
    const prescribed = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>new Set(rxItems.map((r)=>r.drug?.id)), [
        rxItems
    ]);
    const draft = documentDrafts[0] || null;
    const draftRequest = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>draft ? {
            key: draft.key,
            drug: draft.drug,
            defaults: (0, $eQiuG.listValuesWhereNamed)(draft.drug, draft.defaults, {
                durations: (0, $6xvbB.DURATIONS)(t)
            }),
            sourceLabel: draft.sourceLabel || t('visit.rx.documentDraft.title'),
            sourceKind: draft.sourceKind,
            draft: draft
        } : null, [
        draft,
        t
    ]);
    const warnings = interactions?.warnings || [];
    const hasIx = !!interactions?.hasInteractions;
    const groups = (0, $6xvbB.bucketWarnings)(warnings);
    const top = (0, $6xvbB.topSeverity)(warnings);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-rx-content",
        "data-state": rxItems.length ? 'content' : 'empty'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginBottom: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9SQfR.default), {
        touch: true,
        defaultsFor: startWith,
        memory: memory,
        prescribedIds: prescribed,
        frequent: frequent,
        onAdd: (drug, sig, req)=>req?.draft ? onConfirmDocumentDraft?.(req.draft, sig, drug) : onAdd(drug, sig),
        request: draftRequest,
        onRequestDone: (req, added)=>{
            if (!added) onDiscardDocumentDraft?.(req.draft);
        },
        insurer: insurer
    })), (templateButton || assist || hasIx && !interactionStale && top !== 'low') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-rx-ai-actions",
        style: {
            display: 'flex',
            alignItems: 'stretch',
            gap: '0.375rem',
            marginBottom: '0.625rem'
        }
    }, templateButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: 0,
            display: 'flex'
        }
    }, templateButton), assist && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "lg",
        onClick: assist.onHistory,
        disabled: !assist.canHistory || assist.busySource === 'HISTORY',
        "data-testid": "visit-rx-ai-suggest",
        className: "min-h-11 flex-1 gap-1.5 px-2",
        style: {
            fontSize: '0.75rem'
        }
    }, assist.busySource === 'HISTORY' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 15,
        thickness: 2
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $chm1L.default), {
        size: 16,
        "aria-hidden": true
    }), t('visit.rxAssist.history')), hasIx && !interactionStale && top !== 'low' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "visit-rx-ix-chip",
        "data-severity": top,
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            alignSelf: 'center',
            gap: '0.25rem',
            fontSize: '0.625rem',
            fontWeight: 700,
            padding: '0.125rem 0.5rem',
            borderRadius: '0.75rem',
            background: top === 'high' ? (0, $jTCZr.C).redLight : (0, $jTCZr.C).amberLight,
            color: top === 'high' ? (0, $jTCZr.CT).dangerInk : (0, $jTCZr.CT).warnInk
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $QG9Z3.default), {
        size: 11,
        "aria-hidden": true
    }), top === 'high' ? t('visit.rx.ixHighChip') : t('visit.rx.ixMediumChip'))), proposal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginBottom: '0.625rem'
        }
    }, proposal), rxItems.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aVx4q.default), {
            size: 44,
            color: (0, $jTCZr.C).textMuted,
            strokeWidth: 1.5,
            "aria-hidden": true
        }),
        title: t('visit.rx.noneRecorded')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem'
        }
    }, rxItems.map((item)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: item.id,
            "data-testid": `visit-rx-row-${item.id}`,
            style: {
                background: (0, $jTCZr.C).card,
                border: `1px solid ${(0, $jTCZr.C).border}`,
                borderRadius: '0.75rem',
                padding: '0.6875rem 0.75rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'flex-start',
                gap: '0.625rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                width: '2.375rem',
                height: '2.375rem',
                borderRadius: '0.625rem',
                background: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.08),
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aVx4q.default), {
            size: 17,
            color: (0, $jTCZr.C).navy,
            "aria-hidden": true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1,
                minWidth: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            dir: "auto",
            style: {
                fontSize: '0.8125rem',
                fontWeight: 700,
                color: (0, $jTCZr.C).textPrimary
            }
        }, (0, $g6gAc.drugNameLines)(item.drug).primary), (0, $g6gAc.drugNameLines)(item.drug).secondary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            dir: "auto",
            style: {
                fontSize: '0.6875rem',
                color: (0, $jTCZr.C).textMuted
            }
        }, (0, $g6gAc.drugNameLines)(item.drug).secondary), (0, $85jFj.erxGroupOf)(item.drug?.erxGroup) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                marginTop: '0.25rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.GenericGroupChip), {
            drug: item.drug,
            size: "0.65625rem"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            size: "icon",
            className: "h-11 w-11 text-muted-foreground shrink-0",
            "aria-label": t('visit.rx.removeAria', {
                name: (0, $g6gAc.drugDisplayName)(item.drug)
            }),
            "data-testid": `visit-rx-remove-${item.id}`,
            onClick: ()=>onRemove(item.id)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
            size: 15,
            "aria-hidden": true
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'grid',
                gridTemplateColumns: '1fr 1fr 1fr',
                gap: '0.375rem',
                marginTop: '0.5rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3d5dc5a5bf298474$var$Select, {
            value: item.dosage,
            onChange: (e)=>onUpdate(item.id, 'dosage', e.target.value),
            options: (0, $eQiuG.doseOptionsFor)(item.drug, item.dosage),
            placeholder: t('visit.rx.dose'),
            testId: `visit-rx-dosage-${item.id}`,
            labelFor: (v)=>(0, $6xvbB.drugDosageLabel)(v, readsPersianData, t)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3d5dc5a5bf298474$var$Select, {
            value: item.frequency,
            onChange: (e)=>onUpdate(item.id, 'frequency', e.target.value),
            options: (0, $eQiuG.frequencyOptionsFor)(item.frequency),
            placeholder: t('visit.rx.timesPerDay'),
            testId: `visit-rx-freq-${item.id}`,
            labelFor: (v)=>(0, $lfHhF.drugFrequencyLabel)(v, t)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3d5dc5a5bf298474$var$Select, {
            value: item.duration,
            onChange: (e)=>onUpdate(item.id, 'duration', e.target.value),
            options: (0, $6xvbB.DURATIONS)(t),
            placeholder: t('visit.rx.duration'),
            testId: `visit-rx-dur-${item.id}`
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'grid',
                gridTemplateColumns: '2fr 1fr',
                gap: '0.375rem',
                marginTop: '0.375rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3d5dc5a5bf298474$var$Select, {
            value: (0, $eQiuG.toRouteOption)(item.route) || item.route,
            onChange: (e)=>onUpdate(item.id, 'route', e.target.value),
            options: $3d5dc5a5bf298474$var$withRoute(item.route),
            placeholder: t('visit.rx.route'),
            testId: `visit-rx-route-${item.id}`,
            labelFor: (v)=>(0, $eQiuG.routeLabel)(v, t)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
            inputMode: "numeric",
            value: item.quantity || '',
            onChange: (e)=>onUpdate(item.id, 'quantity', (0, $5JYPc.toEnDigits)(e.target.value).replace(/[^\d]/g, '')),
            placeholder: t('visit.rx.quantity'),
            "aria-label": t('visit.rx.quantity'),
            "data-testid": `visit-rx-qty-${item.id}`,
            style: {
                minWidth: 0,
                border: `1px solid ${(0, $jTCZr.C).border}`,
                borderRadius: '0.375rem',
                padding: '0.375rem 0.5rem',
                fontSize: '1rem',
                minHeight: '2.75rem',
                fontFamily: 'inherit',
                color: (0, $jTCZr.C).textPrimary,
                background: (0, $jTCZr.C).card,
                outline: 'none'
            }
        })), (0, $eQiuG.missingRxFields)(item).length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": `visit-rx-incomplete-${item.id}`,
            title: t('visit.rx.incompleteHint'),
            style: {
                marginTop: '0.375rem',
                fontSize: '0.6875rem',
                fontWeight: 700,
                color: (0, $jTCZr.CT).warnInk
            }
        }, (0, $eQiuG.rxIncompleteLabel)((0, $eQiuG.missingRxFields)(item), t)), item.removeFailed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": `visit-rx-remove-failed-${item.id}`,
            title: t('visit.rx.removeFailedHint'),
            style: {
                marginTop: '0.375rem',
                fontSize: '0.6875rem',
                fontWeight: 700,
                color: (0, $jTCZr.CT).dangerInk
            }
        }, t('visit.rx.removeFailed')));
    })), onCheckInteractions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "lg",
        onClick: onCheckInteractions,
        disabled: !canCheckInteractions,
        "data-testid": "visit-rx-check-interactions",
        className: "w-full min-h-11 mt-2 gap-1.5"
    }, interactionLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 14,
        color: (0, $jTCZr.CT).accent,
        thickness: 2
    }), " ", t('visit.rx.checkingInteractionsShort')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bo0GS.default), {
        size: 15,
        "aria-hidden": true
    }), " ", t('visit.rx.checkInteractions'))), onCheckInteractions && !interactionLoading && !canCheckInteractions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-rx-ix-needs-drugs",
        style: {
            fontSize: '0.6875rem',
            color: (0, $jTCZr.C).textMuted,
            padding: '0.375rem 0'
        }
    }, t('visit.rx.ixNeedsDrugs')), interactionError && !interactionLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-rx-ix-error",
        style: {
            marginTop: '0.5rem',
            background: (0, $jTCZr.CT).dangerSoft,
            border: `1px solid ${(0, $jTCZr.soft)((0, $jTCZr.C).red, 0.35)}`,
            borderRadius: '0.625rem',
            padding: '0.4375rem 0.75rem',
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).dangerInk,
            fontWeight: 600
        }
    }, t('errors.load.interactions')), interactions && !interactionLoading && !interactionError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: '0.5rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem'
        },
        "data-testid": "visit-rx-ix-report"
    }, interactionStale && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-rx-ix-stale",
        style: {
            background: (0, $jTCZr.CT).surface2,
            border: `1px dashed ${(0, $jTCZr.C).border}`,
            borderRadius: '0.625rem',
            padding: '0.4375rem 0.75rem',
            fontSize: '0.6875rem',
            color: (0, $jTCZr.C).textMuted
        }
    }, t('visit.rx.ixStale')), hasIx ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, groups.high.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-rx-ix-high",
        role: "alert",
        style: {
            background: (0, $jTCZr.CT).dangerSoft,
            border: `2px solid ${(0, $jTCZr.CT).danger}`,
            borderRadius: '0.625rem',
            padding: '0.625rem 0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.25rem',
            fontWeight: 800,
            fontSize: '0.8125rem',
            color: (0, $jTCZr.CT).dangerInk,
            marginBottom: '0.375rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $QG9Z3.default), {
        size: 14,
        "aria-hidden": true
    }), " ", t('visit.rx.ixHighTitle'), " (", groups.high.length, ")"), groups.high.map((w, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                fontSize: '0.8125rem',
                color: (0, $jTCZr.C).textPrimary,
                lineHeight: 1.65,
                padding: '0.1875rem 0',
                borderTop: i ? `1px solid ${(0, $jTCZr.soft)((0, $jTCZr.C).textMuted, 0.12)}` : 'none'
            }
        }, w.drugPair && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("strong", null, w.drugPair, ": "), w.description))), groups.medium.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-rx-ix-medium",
        style: {
            background: (0, $jTCZr.C).amberLight,
            border: `1px solid ${(0, $jTCZr.soft)((0, $jTCZr.C).amber, 0.4)}`,
            borderRadius: '0.625rem',
            padding: '0.5625rem 0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontWeight: 700,
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).warnInk,
            marginBottom: '0.3125rem'
        }
    }, t('visit.rx.ixMediumTitle'), " (", groups.medium.length, ")"), groups.medium.map((w, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                fontSize: '0.75rem',
                color: (0, $jTCZr.C).textPrimary,
                lineHeight: 1.6,
                padding: '0.1875rem 0',
                borderTop: i ? `1px solid ${(0, $jTCZr.soft)((0, $jTCZr.C).textMuted, 0.12)}` : 'none'
            }
        }, w.drugPair && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("strong", null, w.drugPair, ": "), w.description))), groups.low.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-rx-ix-low",
        style: {
            background: (0, $jTCZr.CT).surface2,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: '0.625rem',
            padding: '0.5rem 0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.25rem',
            fontWeight: 600,
            fontSize: '0.6875rem',
            color: (0, $jTCZr.C).textMuted,
            marginBottom: '0.25rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $97xXr.default), {
        size: 11,
        "aria-hidden": true
    }), " ", t('visit.rx.ixLowTitle'), " (", groups.low.length, ")"), groups.low.map((w, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                fontSize: '0.6875rem',
                color: (0, $jTCZr.C).textMuted,
                lineHeight: 1.6,
                padding: '0.125rem 0'
            }
        }, w.drugPair && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, w.drugPair, ": "), w.description)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: (0, $jTCZr.C).greenLight,
            border: `1px solid ${(0, $jTCZr.soft)((0, $jTCZr.C).green, 0.3)}`,
            borderRadius: '0.625rem',
            padding: '0.4375rem 0.75rem',
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).goodInk,
            fontWeight: 600
        }
    }, t('visit.rx.noInteractions'))));
};
var $3d5dc5a5bf298474$export$2e2bcd8739ae039 = $3d5dc5a5bf298474$var$MobileVisitRx;

});
parcelRegister("9SQfR", function(module, exports) {

$parcel$export(module.exports, "default", () => $fadae58d6c7ed04a$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $hZDga = parcelRequire("hZDga");

var $jTCZr = parcelRequire("jTCZr");

var $QG9Z3 = parcelRequire("QG9Z3");
var $e5Ore = parcelRequire("e5Ore");
var $6TdpC = parcelRequire("6TdpC");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $g6gAc = parcelRequire("g6gAc");

var $lfHhF = parcelRequire("lfHhF");

var $2aPS0 = parcelRequire("2aPS0");

var $6xvbB = parcelRequire("6xvbB");

var $eQiuG = parcelRequire("eQiuG");

var $3qea8 = parcelRequire("3qea8");
// ─────────────────────────────────────────────────────────────────────────────
// «افزودن دارو» — the one way a drug is found for the نسخه (PM-0043, PM-0059).
//
// A drug the doctor has never prescribed is found by search alone: the picker
// used to open on the first page of the formulary and a category rail, and both
// stay gone — such a drug appears only as a search result. Results are the
// DRUGS the matching products belong to (lib/drugProducts.js), one row each, and
// picking one opens the add form (RxAddForm) where its شکل، قدرت and sig are
// completed. A drug reaches the نسخه from a search only through that form's
// «افزودن به نسخه».
//
// The doctor's FREQUENT drugs are back, by the owner's direction of 2026-10-20
// (PM-0516): before anything is typed, «داروهای پرتکرار من» is listed under the
// search with the sig each was last prescribed with, and ONE click adds it with
// those values — no form, because they were saved the first time. While typing,
// the frequent drugs the query matches come first, the same one-click rows,
// above the search results. The host supplies them (`frequent`); without the
// prop the picker is search-only, as the correction sheet still is.
//
// «آخرین تنظیم شما» (PM-0574): with the host's `memory` (useRxMemory), the
// doctor's last directions are asked for every product a search page shows and
// every other product of a drug read behind its form, and a drug opens on the
// product they prescribed MOST RECENTLY — its form starting from what they set.
//
// One component for the desktop visit, the phone visit and the past-visit
// correction sheet. `testIdPrefix` keeps each surface's own ids.
// ─────────────────────────────────────────────────────────────────────────────
const $fadae58d6c7ed04a$var$DEBOUNCE_MS = 300;
// How far the other products of a drug are read when its form opens: the page
// that found it plus this many more of the same ingredient.
const $fadae58d6c7ed04a$var$SIBLING_PAGES = 5;
// The search that finds a drug's own products: its name without the salt.
const $fadae58d6c7ed04a$var$siblingQuery = (ingredient)=>String(ingredient || '').replace(/\([^)]*\)/g, ' ').replace(/\s+/g, ' ').trim();
const $fadae58d6c7ed04a$export$106e299a44067573 = (group, lastAtOf)=>{
    if (!lastAtOf) return null;
    let best = null;
    let bestAt = 0;
    for (const p of group?.products || []){
        const at = Date.parse(lastAtOf(p.drug.id) || '') || 0;
        if (at > bestAt) {
            best = p.drug.id;
            bestAt = at;
        }
    }
    return best;
};
// Which frequent drugs a query names (PM-0516): the Persian name or the Latin
// generic contains it, folded as the owner's mock folds — lowercase, trimmed.
const $fadae58d6c7ed04a$var$fold = (s)=>String(s || '').trim().toLowerCase();
const $fadae58d6c7ed04a$export$18fd9bdbf29f3629 = (entries, query)=>{
    const needle = $fadae58d6c7ed04a$var$fold(query);
    if (!needle) return entries;
    return entries.filter(({ drug: drug })=>[
            drug?.name,
            drug?.genericName
        ].some((s)=>$fadae58d6c7ed04a$var$fold(s).includes(needle)));
};
function $fadae58d6c7ed04a$export$2e2bcd8739ae039({ defaultsFor: defaultsFor, prescribedIds: prescribedIds, onAdd: onAdd, request: request = null, onRequestDone: onRequestDone, searchRequest: searchRequest = null, touch: touch = false, testIdPrefix: testIdPrefix = 'visit-rx', inputId: inputId, showKeys: showKeys = false, insurer: insurer, frequent: frequent = null, memory: memory = null }) {
    const { t: t, readsPersianData: readsPersianData, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const [query, setQuery] = (0, $acw62.useState)('');
    const [search, setSearch] = (0, $acw62.useState)({
        state: 'idle',
        drugs: [],
        total: 0
    });
    const [moreLoading, setMoreLoading] = (0, $acw62.useState)(false);
    const [attempt, setAttempt] = (0, $acw62.useState)(0);
    const [adding, setAdding] = (0, $acw62.useState)(null);
    const inputRef = (0, $acw62.useRef)(null);
    const live = (0, $acw62.useRef)(0);
    // ── the search: nothing until two letters, then a debounced server page ──
    (0, $acw62.useEffect)(()=>{
        const q = query.trim();
        const mine = ++live.current;
        if (q.length < (0, $6xvbB.DRUG_MIN_QUERY)) {
            setSearch({
                state: q ? 'short' : 'idle',
                drugs: [],
                total: 0
            });
            return undefined;
        }
        setSearch((s)=>({
                ...s,
                state: 'loading'
            }));
        const h = setTimeout(()=>{
            (0, $6xvbB.searchDrugs)({
                query: q
            }).then(({ drugs: drugs, total: total })=>{
                if (mine === live.current) setSearch({
                    state: 'ready',
                    drugs: drugs || [],
                    total: total || 0
                });
            }).catch((err)=>{
                if (mine !== live.current) return;
                console.error('[rx] listDrugs failed:', err);
                setSearch({
                    state: 'error',
                    drugs: [],
                    total: 0
                });
            });
        }, $fadae58d6c7ed04a$var$DEBOUNCE_MS);
        return ()=>clearTimeout(h);
    }, [
        query,
        attempt
    ]);
    const loadMore = (0, $acw62.useCallback)(()=>{
        const q = query.trim();
        const mine = live.current;
        setMoreLoading(true);
        (0, $6xvbB.searchDrugs)({
            query: q,
            offset: search.drugs.length
        }).then(({ drugs: drugs, total: total })=>{
            if (mine !== live.current) return;
            setSearch((s)=>({
                    ...s,
                    drugs: [
                        ...s.drugs,
                        ...drugs || []
                    ],
                    total: total || s.total
                }));
        }).catch((err)=>console.error('[rx] listDrugs (more) failed:', err)).finally(()=>setMoreLoading(false));
    }, [
        query,
        search.drugs.length
    ]);
    const groups = (0, $acw62.useMemo)(()=>(0, $2aPS0.groupProducts)(search.drugs), [
        search.drugs
    ]);
    // Every product on the page is asked for once, so a drug opens on the one the
    // doctor last prescribed and with what they set (PM-0574).
    const memoryRef = (0, $acw62.useRef)(memory);
    memoryRef.current = memory;
    const askMemory = (0, $acw62.useCallback)((drugs)=>{
        const ids = (drugs || []).map((d)=>d?.id).filter(Boolean);
        if (ids.length) memoryRef.current?.request?.(ids);
    }, []);
    (0, $acw62.useEffect)(()=>{
        askMemory(search.drugs);
    }, [
        search.drugs,
        askMemory
    ]);
    // ── opening a drug's form, and reading its other products behind it ──
    const openSeq = (0, $acw62.useRef)(0);
    const open = (0, $acw62.useCallback)((group, drugId, extra = {})=>{
        const mine = ++openSeq.current;
        const recent = drugId ? null : $fadae58d6c7ed04a$export$106e299a44067573(group, memoryRef.current?.lastAtOf);
        setAdding({
            group: group,
            drugId: drugId || recent || group.products[0].drug.id,
            byRecency: !drugId,
            loading: !!group.structured,
            ...extra
        });
        askMemory(group.products.map((p)=>p.drug));
        if (!group.structured) return;
        const q = $fadae58d6c7ed04a$var$siblingQuery(group.ingredient);
        if (q.length < (0, $6xvbB.DRUG_MIN_QUERY)) {
            setAdding((a)=>a ? {
                    ...a,
                    loading: false
                } : a);
            return;
        }
        (async ()=>{
            let merged = group;
            try {
                for(let page = 0; page < $fadae58d6c7ed04a$var$SIBLING_PAGES; page += 1){
                    // eslint-disable-next-line no-await-in-loop
                    const { drugs: drugs, total: total } = await (0, $6xvbB.searchDrugs)({
                        query: q,
                        offset: page * (0, $6xvbB.DRUG_PAGE_SIZE)
                    });
                    if (mine !== openSeq.current) return;
                    merged = (0, $2aPS0.mergeIntoGroup)(merged, drugs);
                    askMemory(merged.products.map((p)=>p.drug));
                    const next = merged;
                    setAdding((a)=>a && a.group.key === next.key ? {
                            ...a,
                            group: next
                        } : a);
                    if (!drugs?.length || (page + 1) * (0, $6xvbB.DRUG_PAGE_SIZE) >= (total || 0)) break;
                }
            } catch (err) {
                // The form still works on the products the search already found.
                console.warn('[rx] other products of the drug could not be read:', err?.message);
            }
            if (mine === openSeq.current) setAdding((a)=>a ? {
                    ...a,
                    loading: false
                } : a);
        })();
    }, [
        askMemory
    ]);
    const addingRef = (0, $acw62.useRef)(null);
    addingRef.current = adding;
    const close = (0, $acw62.useCallback)((added = false)=>{
        openSeq.current += 1;
        const was = addingRef.current;
        setAdding(null);
        if (was?.request) onRequestDone?.(was.request, added);
    }, [
        onRequestDone
    ]);
    // A drug offered from outside opens its form, prefilled with what came with it.
    const requestKey = request?.key ?? request?.drug?.id ?? null;
    (0, $acw62.useEffect)(()=>{
        if (!request?.drug?.id) return;
        const [group] = (0, $2aPS0.groupProducts)([
            request.drug
        ]);
        open(group, request.drug.id, {
            request: request,
            seed: {
                drugId: request.drug.id,
                defaults: request.defaults || {}
            },
            sourceLabel: request.sourceLabel,
            sourceKind: request.sourceKind
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        requestKey
    ]);
    // A search asked for from outside (an AI proposal the list did not settle).
    const searchNonce = searchRequest?.nonce;
    (0, $acw62.useEffect)(()=>{
        if (searchNonce === undefined) return;
        close();
        setQuery(searchRequest.query || '');
        inputRef.current?.focus?.({
            preventScroll: true
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        searchNonce
    ]);
    const submit = (drug, sig)=>{
        const req = adding?.request || null;
        onAdd(drug, sig, req);
        close(true);
        setQuery('');
        // Back to the search for the next drug — on a workstation. On a phone a
        // focused input RAISES THE KEYBOARD, which covered the line just added
        // and scrolled the list under the sticky strip (PM-0113); there the next
        // drug starts with a tap on the search, as every other field does.
        if (!touch) inputRef.current?.focus?.({
            preventScroll: true
        });
    };
    const onKeyDown = (e)=>{
        if (e.key === 'Enter') {
            if (search.state === 'ready' && groups.length) open(groups[0]);
            e.preventDefault();
        } else if (e.key === 'Escape' && query) {
            setQuery('');
            e.stopPropagation();
        }
    };
    // Once the drug's other products and their dates are in, the one prescribed
    // most recently — the form moves to it while the doctor has touched nothing.
    const preferDrugId = adding?.byRecency && !adding.request ? $fadae58d6c7ed04a$export$106e299a44067573(adding.group, memory?.lastAtOf) : null;
    const p = testIdPrefix;
    const formLabel = (form, route)=>{
        const parts = (0, $2aPS0.formLabelParts)(form, route, t, '');
        return [
            parts.label,
            parts.detail
        ].filter(Boolean).join(' ');
    };
    const fs = (desk, phone)=>touch ? phone : desk;
    // ── «داروهای پرتکرار من» (PM-0516) ──────────────────────────────────────────
    // The whole row is the add (owner, 2026-10-20): one click or tap anywhere on
    // it, Enter or Space on it focused, adds the drug — no form, no second control.
    // What it adds is exactly the line the form would have opened with
    // (`defaultsFor`: the doctor's saved sig, a gap filled from the product, the
    // quantity worked out), so the click and the form never disagree. The form's
    // rule still holds (PM-0059): a line missing a required field is not added by a
    // click — its row says what is missing, and the click opens the form on it, to
    // be completed once. A drug already on the نسخه is a disabled row that says so.
    const frequentEntries = frequent?.entries?.length ? frequent.entries : [];
    const usualLine = (drug, sig)=>(0, $eQiuG.withAutoQuantity)({
            instructions: '',
            ...defaultsFor ? defaultsFor(drug) : sig
        });
    const addUsual = (drug, line)=>{
        if ((0, $eQiuG.missingRxFields)(line).length > 0) {
            open((0, $2aPS0.groupProducts)([
                drug
            ])[0], drug.id);
            return;
        }
        const { dosage: dosage, frequency: frequency, route: route, duration: duration, quantity: quantity, instructions: instructions } = line;
        frequent.onAddUsual(drug, {
            dosage: dosage,
            frequency: frequency,
            route: route,
            duration: duration,
            quantity: quantity,
            instructions: instructions
        });
        setQuery('');
        if (!touch) inputRef.current?.focus?.({
            preventScroll: true
        }); // as `submit`
    };
    const chipOf = (label, value)=>value ? {
            label: label,
            value: value
        } : null;
    const countOf = (q)=>/^\d+$/.test(String(q || '')) ? formatNumber(Number(q)) : q;
    const frequentRows = (entries, testid)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": testid,
            "data-state": "content",
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: 4
            }
        }, entries.map(({ drug: drug, sig: saved, times: times })=>{
            const names = (0, $g6gAc.drugNameLines)(drug);
            const on = !!prescribedIds?.has?.(drug.id);
            const sig = usualLine(drug, saved);
            const missing = (0, $eQiuG.missingRxFields)(sig);
            const chips = [
                chipOf(t('visit.rx.dose'), sig.dosage && (0, $6xvbB.drugDosageLabel)(sig.dosage, readsPersianData, t)),
                chipOf(t('visit.rx.timesPerDay'), sig.frequency && (0, $lfHhF.drugFrequencyLabel)(sig.frequency, t)),
                chipOf(t('visit.rx.duration'), sig.duration),
                chipOf(t('visit.rx.quantity'), countOf(sig.quantity))
            ].filter(Boolean);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
                key: drug.id,
                type: "button",
                variant: "outline",
                onClick: ()=>{
                    if (!on) addUsual(drug, sig);
                },
                "aria-disabled": on || undefined,
                "aria-label": on ? `${names.primary} \u{2014} ${t('visit.rx.frequent.added')}` : missing.length ? `${names.primary} \u{2014} ${(0, $eQiuG.rxIncompleteLabel)(missing, t)}` : t('visit.rx.frequent.addAria', {
                    name: names.primary
                }),
                "data-incomplete": missing.length ? missing.join(' ') : undefined,
                "data-testid": `${p}-frequent-row-${drug.id}`,
                "data-on": on || undefined,
                className: `w-full h-auto justify-start text-start gap-2 ${touch ? 'min-h-11 px-3 py-2' : 'px-2.5 py-1.5'}`,
                style: on ? {
                    opacity: 0.6,
                    cursor: 'default'
                } : undefined
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    flex: 1,
                    minWidth: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                dir: "auto",
                style: {
                    fontSize: fs('0.8125rem', '0.875rem'),
                    fontWeight: 700,
                    color: (0, $jTCZr.CT).ink,
                    whiteSpace: 'normal',
                    overflowWrap: 'anywhere'
                }
            }, names.primary), names.secondary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                dir: "auto",
                style: {
                    fontSize: fs('0.6875rem', '0.6875rem'),
                    fontWeight: 400,
                    color: (0, $jTCZr.CT).ink2,
                    whiteSpace: 'normal',
                    overflowWrap: 'anywhere'
                }
            }, names.secondary), chips.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                "data-testid": `${p}-frequent-sig-${drug.id}`,
                style: {
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 4,
                    marginTop: 1
                }
            }, chips.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    key: c.label,
                    dir: "auto",
                    style: {
                        fontSize: fs('0.65625rem', '0.6875rem'),
                        fontWeight: 400,
                        padding: '1px 6px',
                        borderRadius: 4,
                        background: (0, $jTCZr.CT).surface2,
                        color: (0, $jTCZr.CT).ink,
                        whiteSpace: 'nowrap'
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        color: (0, $jTCZr.CT).ink2
                    }
                }, c.label, " "), c.value))), !on && missing.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                "data-testid": `${p}-frequent-incomplete-${drug.id}`,
                style: {
                    fontSize: fs('0.65625rem', '0.6875rem'),
                    fontWeight: 600,
                    color: (0, $jTCZr.CT).warnInk
                }
            }, (0, $eQiuG.rxIncompleteLabel)(missing, t))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.InsurerListChip), {
                drug: drug,
                insurer: insurer,
                both: true,
                size: fs(10.5, '0.6875rem'),
                testid: `${p}-frequent-coverage-${drug.id}`
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                "data-testid": `${p}-frequent-times-${drug.id}`,
                style: {
                    fontSize: fs('0.65625rem', '0.6875rem'),
                    fontWeight: 700,
                    padding: '1px 7px',
                    borderRadius: 999,
                    background: (0, $jTCZr.CT).accentSoft,
                    color: (0, $jTCZr.CT).accentInk,
                    whiteSpace: 'nowrap'
                }
            }, t('visit.rx.frequent.times', {
                count: times
            })), on && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                "data-testid": `${p}-frequent-added-${drug.id}`,
                style: {
                    fontSize: fs('0.65625rem', '0.6875rem'),
                    fontWeight: 700,
                    padding: '1px 6px',
                    borderRadius: 4,
                    background: (0, $jTCZr.CT).goodSoft,
                    color: (0, $jTCZr.CT).goodInk,
                    whiteSpace: 'nowrap'
                }
            }, t('visit.rx.frequent.added')));
        }));
    // While typing: the frequent drugs the query names, above the search results.
    const typedFrequent = query.trim().length >= (0, $6xvbB.DRUG_MIN_QUERY) ? $fadae58d6c7ed04a$export$18fd9bdbf29f3629(frequentEntries, query) : [];
    const frequentFirst = typedFrequent.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${p}-frequent-matches`,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 4
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: fs('0.6875rem', '0.6875rem'),
            fontWeight: 700,
            color: (0, $jTCZr.CT).ink2
        }
    }, t('visit.rx.frequent.matches')), frequentRows(typedFrequent, `${p}-frequent-matches-list`));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            background: (0, $jTCZr.CT).surface,
            border: `1px solid ${query || adding ? (0, $jTCZr.C).navy : (0, $jTCZr.CT).border}`,
            borderRadius: 10,
            padding: touch ? '0 0.75rem' : '0 10px',
            minHeight: touch ? '2.75rem' : 36
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e5Ore.default), {
        size: touch ? 16 : 14,
        color: (0, $jTCZr.CT).ink2,
        "aria-hidden": true,
        style: {
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ref: inputRef,
        id: inputId,
        value: query,
        onChange: (e)=>{
            if (adding && !adding.request) close();
            setQuery(e.target.value);
        },
        onKeyDown: onKeyDown,
        placeholder: t('visit.rx.searchDrug'),
        "aria-label": t('visit.rx.searchDrug'),
        autoComplete: "off",
        "data-testid": `${p}-search`,
        style: {
            flex: 1,
            minWidth: 0,
            border: 'none',
            outline: 'none',
            background: 'transparent',
            fontFamily: 'inherit',
            fontSize: fs('0.8125rem', '1rem'),
            color: (0, $jTCZr.CT).ink,
            minHeight: touch ? '2.625rem' : 34
        }
    }), search.state === 'loading' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 14,
        color: (0, $jTCZr.CT).accent,
        thickness: 2
    }), query && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        type: "button",
        variant: "ghost",
        size: "icon",
        onClick: ()=>{
            setQuery('');
            inputRef.current?.focus?.();
        },
        "aria-label": t('common.actions.clearSearch'),
        "data-testid": `${p}-search-clear`,
        className: touch ? 'h-11 w-11 shrink-0' : 'h-7 w-7 shrink-0'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
        size: 13,
        "aria-hidden": true
    }))), adding ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3qea8.default), {
        key: `${adding.group.key}:${adding.request?.key ?? ''}`,
        group: adding.group,
        initialDrugId: adding.drugId,
        preferDrugId: preferDrugId,
        loadingProducts: adding.loading,
        defaultsFor: defaultsFor,
        rememberedFor: memory?.rememberedFor || null,
        seed: adding.seed,
        sourceLabel: adding.sourceLabel,
        sourceKind: adding.sourceKind,
        prescribedIds: prescribedIds,
        insurer: insurer,
        onAdd: submit,
        onCancel: ()=>close(false),
        touch: touch
    }) : search.state === 'idle' && frequentEntries.length > 0 ? // «داروهای پرتکرار من» at hand before anything is typed (PM-0516): dense
    // rows, each one click; the search hint becomes the list's footer.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${p}-frequent`,
        "data-state": "content",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: fs('0.71875rem', '0.75rem'),
            fontWeight: 700,
            color: (0, $jTCZr.CT).ink
        }
    }, t('visit.rx.frequent.title')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            maxHeight: touch ? '20rem' : 320,
            overflowY: 'auto'
        }
    }, frequentRows(frequentEntries, `${p}-frequent-list`)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: fs('0.6875rem', '0.6875rem'),
            color: (0, $jTCZr.CT).ink2,
            lineHeight: 1.7
        }
    }, t('visit.rx.frequent.hint'))) : search.state === 'idle' ? // One quiet line, not an empty state of its own: the نسخه below already
    // has one («دارویی ثبت نشده»), and two pictures of a pill say nothing twice.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${p}-search-idle`,
        "data-state": "idle",
        style: {
            fontSize: fs('0.71875rem', '0.75rem'),
            color: (0, $jTCZr.CT).ink2,
            lineHeight: 1.7
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontWeight: 600,
            color: (0, $jTCZr.CT).ink
        }
    }, t('visit.rx.form.searchTitle')), " \u2014 ", t('visit.rx.form.searchBody')) : search.state === 'short' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${p}-search-short`,
        style: {
            fontSize: fs('0.71875rem', '0.75rem'),
            color: (0, $jTCZr.CT).ink2
        }
    }, t('visit.orders.keepTyping')) : search.state === 'error' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${p}-search-error`,
        "data-state": "error",
        role: "alert",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '8px 10px',
            borderRadius: 8,
            background: (0, $jTCZr.CT).dangerSoft
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $QG9Z3.default), {
        size: 15,
        color: (0, $jTCZr.CT).dangerInk,
        "aria-hidden": true,
        style: {
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            fontSize: fs('0.75rem', '0.8125rem'),
            fontWeight: 600,
            color: (0, $jTCZr.CT).dangerInk
        }
    }, t('errors.load.drugs')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        type: "button",
        variant: "subtle",
        size: "sm",
        onClick: ()=>setAttempt((n)=>n + 1),
        "data-testid": `${p}-search-retry`,
        className: touch ? 'min-h-11 shrink-0' : 'shrink-0'
    }, t('common.actions.retry'))) : search.state === 'ready' && groups.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, frequentFirst, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${p}-no-results`,
        "data-state": "no-results",
        style: {
            padding: touch ? '0.875rem' : 12,
            textAlign: 'center',
            fontSize: fs('0.75rem', '0.8125rem'),
            color: (0, $jTCZr.CT).ink2
        }
    }, t('errors.empty.drugs'))) : groups.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${p}-results`,
        "data-state": "content",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 6
        }
    }, frequentFirst, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: fs('0.6875rem', '0.6875rem'),
            color: (0, $jTCZr.CT).ink2
        }
    }, t('visit.rx.form.results', {
        count: groups.length,
        query: query.trim()
    })), groups.map((g, i)=>{
        const first = g.products[0].drug;
        const names = g.structured ? {
            primary: g.ingredient,
            secondary: (0, $2aPS0.groupSummary)(g, formLabel)
        } : (0, $g6gAc.drugNameLines)(first);
        const allOn = g.products.every((x)=>prescribedIds?.has?.(x.drug.id));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            key: g.key,
            type: "button",
            variant: "outline",
            onClick: ()=>open(g),
            "data-testid": `${p}-result-${first.id}`,
            "data-first": i === 0 || undefined,
            className: `w-full h-auto justify-start text-start gap-2 px-3 py-2 ${touch ? 'min-h-11' : ''}`,
            style: i === 0 ? {
                borderColor: (0, $jTCZr.C).navy
            } : undefined
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                flex: 1,
                minWidth: 0,
                display: 'flex',
                flexDirection: 'column',
                gap: 2
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "auto",
            style: {
                fontSize: fs('0.8125rem', '0.875rem'),
                fontWeight: 700,
                color: (0, $jTCZr.CT).ink,
                whiteSpace: 'normal',
                overflowWrap: 'anywhere'
            }
        }, names.primary), names.secondary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "auto",
            style: {
                fontSize: fs('0.71875rem', '0.75rem'),
                fontWeight: 400,
                color: (0, $jTCZr.CT).ink2,
                whiteSpace: 'normal',
                overflowWrap: 'anywhere'
            }
        }, names.secondary)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.InsurerListChip), {
            drug: first,
            insurer: insurer,
            both: true,
            size: fs(10.5, '0.6875rem'),
            listed: (0, $eQiuG.inInsurerListAny)(g.products.map((x)=>x.drug), insurer),
            testid: `${p}-result-coverage-${first.id}`
        }), allOn && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: fs('0.65625rem', '0.6875rem'),
                fontWeight: 700,
                padding: '1px 6px',
                borderRadius: 4,
                background: (0, $jTCZr.CT).goodSoft,
                color: (0, $jTCZr.CT).goodInk,
                whiteSpace: 'nowrap'
            }
        }, t('visit.rx.frequent.added')), g.products.length > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: fs('0.6875rem', '0.6875rem'),
                fontWeight: 400,
                color: (0, $jTCZr.CT).ink2,
                whiteSpace: 'nowrap'
            }
        }, t('visit.rx.form.productsCount', {
            count: g.products.length
        })));
    }), search.total > search.drugs.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${p}-more-results`,
        style: {
            display: 'flex',
            justifyContent: 'center'
        }
    }, moreLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 14,
        color: (0, $jTCZr.CT).accent,
        thickness: 2
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        type: "button",
        variant: "link",
        size: "sm",
        onClick: loadMore,
        className: touch ? 'min-h-11' : undefined
    }, t('visit.rx.moreResults', {
        shown: search.drugs.length,
        total: search.total
    }))), showKeys && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.6875rem',
            color: (0, $jTCZr.CT).ink2
        }
    }, t('visit.rx.form.keys'))) : null);
}

});
parcelRegister("3qea8", function(module, exports) {

$parcel$export(module.exports, "default", () => $876230c716e4c6d3$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $bkKUS = parcelRequire("bkKUS");
var $7phmx = parcelRequire("7phmx");
var $hZDga = parcelRequire("hZDga");
var $a7Rbr = parcelRequire("a7Rbr");
var $5JYPc = parcelRequire("5JYPc");

var $jTCZr = parcelRequire("jTCZr");

var $bSvYG = parcelRequire("bSvYG");
var $3FyOw = parcelRequire("3FyOw");
var $i5dmF = parcelRequire("i5dmF");
var $8g4t5 = parcelRequire("8g4t5");
var $iDwyV = parcelRequire("iDwyV");
var $chm1L = parcelRequire("chm1L");
var $6TdpC = parcelRequire("6TdpC");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $lfHhF = parcelRequire("lfHhF");

var $g6gAc = parcelRequire("g6gAc");

var $eQiuG = parcelRequire("eQiuG");

var $2aPS0 = parcelRequire("2aPS0");

var $6xvbB = parcelRequire("6xvbB");
// ─────────────────────────────────────────────────────────────────────────────
// The form a drug is added to the نسخه through (PM-0059).
//
// A drug used to land on the نسخه the moment it was picked, with whatever the
// product implied, and a line the e-prescription would refuse was only flagged
// «ناقص» afterwards. Now picking a search result opens this form: the doctor
// settles WHICH product (شکل دارویی، قدرت — and the pack or brand where several
// share both), then its دوز، تناوب، نحوه مصرف and مقدار تحویلی. Those are
// required — «افزودن به نسخه» stays off, naming what is missing, until each
// holds a value the e-prescription codes (missingRxFields, the same rule the
// نسخه's «ناقص» chip reads). زمان مصرف and مدت are optional.
//
// Every field opens filled (rxAddDefaults, through `defaultsFor`), so the common
// case is one confirmation. The values are the closed lists of lib/rxOptions.js,
// shown as chips: what is picked here is exactly what a line's own editor offers.
//
// One component for the visit's desktop picker, its phone tab and the past-visit
// correction sheet — `touch` sizes it for a finger.
//
// «آخرین تنظیم شما» (PM-0574): where the doctor prescribed this product before,
// the form opens on what they set LAST time (`defaultsFor` carries it; the host's
// useRxMemory), says so in one quiet line with the date, and offers «شروع از نو»
// for the product's own defaults. That memory may arrive after the form opened:
// it then fills only the fields the doctor has not touched. It follows the doctor
// to another strength or brand of the same شکل, as an offered sig does. Priority
// is always: an explicit source (`seed` — AI, voice, a document) > the memory >
// the product's defaults.
// ─────────────────────────────────────────────────────────────────────────────
// How many تناوب choices show before «بیشتر»: the ones written every day.
const $876230c716e4c6d3$var$COMMON_FREQUENCIES = 6;
// A دوز list longer than this is a dial (insulin's 60 units), not a row of chips.
const $876230c716e4c6d3$var$MAX_DOSE_CHIPS = 10;
const $876230c716e4c6d3$var$SIG_KEYS = [
    'dosage',
    'frequency',
    'route',
    'duration',
    'quantity',
    'instructions'
];
// The sig fields that are doubled by the counted quantity: a quantity counted for
// one of them does not belong to another.
const $876230c716e4c6d3$var$COUNTED_BY = [
    'dosage',
    'frequency',
    'duration'
];
function $876230c716e4c6d3$export$2e2bcd8739ae039({ group: group, initialDrugId: initialDrugId, preferDrugId: preferDrugId = null, loadingProducts: loadingProducts = false, defaultsFor: defaultsFor, rememberedFor: rememberedFor = null, seed: seed, sourceLabel: sourceLabel, sourceKind: sourceKind, prescribedIds: prescribedIds, insurer: insurer, onAdd: onAdd, onCancel: onCancel, touch: touch = false }) {
    const { t: t, readsPersianData: readsPersianData, formatNumber: formatNumber, formatDate: formatDate } = (0, $LNQP4.default)();
    const durations = (0, $acw62.useMemo)(()=>(0, $6xvbB.DURATIONS)(t), [
        t
    ]);
    const whenOptions = (0, $acw62.useMemo)(()=>[
            t('visit.rx.instructionPresets.beforeMeal'),
            t('visit.rx.instructionPresets.withFood'),
            t('visit.rx.instructionPresets.afterMeal')
        ], [
        t
    ]);
    // «شروع از نو»: the product's own defaults, the memory set aside.
    const [fromScratch, setFromScratch] = (0, $acw62.useState)(false);
    // Whose memory opens a product: its own, else — like an offered sig — that of
    // another product of the same شکل in this drug the doctor prescribed (the most
    // recent of them), so a change of قدرت or brand keeps what they last set.
    const memorySource = (0, $acw62.useCallback)((d)=>{
        if (!rememberedFor || !d) return null;
        if (rememberedFor(d)) return d;
        const now = (0, $2aPS0.productIn)(group, d.id);
        if (!now || now.drug.id !== d.id) return null;
        let best = null;
        let bestAt = -1;
        for (const p of group.products || []){
            if (p.drug.id === d.id || (0, $2aPS0.formKeyOf)(p) !== (0, $2aPS0.formKeyOf)(now)) continue;
            const r = rememberedFor(p.drug);
            if (!r) continue;
            const at = r.lastAt ? Date.parse(r.lastAt) || 0 : 0;
            if (at > bestAt) {
                best = p.drug;
                bestAt = at;
            }
        }
        return best;
    }, [
        rememberedFor,
        group
    ]);
    // What a product starts from before any explicit source: the memory (its own,
    // or a sibling's with the dose kept only where this product offers it), else
    // the product's defaults.
    const baseFor = (0, $acw62.useCallback)((d, scratch)=>{
        if (scratch) return (0, $eQiuG.rxAddDefaults)(d, null, {
            defaultDuration: t('visit.duration.d7')
        });
        const src = memorySource(d);
        if (!src || src.id === d.id) return defaultsFor(d);
        const mem = defaultsFor(src);
        const own = defaultsFor(d);
        const doseFits = (0, $eQiuG.doseOptionsFor)(d).includes(String(mem.dosage || ''));
        return {
            ...own,
            frequency: mem.frequency,
            route: mem.route,
            duration: mem.duration,
            instructions: mem.instructions,
            dosage: doseFits ? mem.dosage : own.dosage,
            quantity: doseFits ? mem.quantity : ''
        };
    }, [
        memorySource,
        defaultsFor,
        t
    ]);
    // The offered sig is about the drug as it is taken, so it follows the doctor
    // to another strength or brand of the same شکل — the AI's «هر ۸ ساعت» used to
    // turn back into the product's default the moment قدرت was corrected. A change
    // of شکل starts from that product, and a dose goes along only where the
    // product has it.
    const seedFits = (0, $acw62.useCallback)((drug)=>{
        if (!seed?.drugId) return false;
        if (seed.drugId === drug.id) return true;
        const offered = (0, $2aPS0.productIn)(group, seed.drugId);
        const now = (0, $2aPS0.productIn)(group, drug.id);
        return !!offered && !!now && offered.drug.id === seed.drugId && now.drug.id === drug.id && (0, $2aPS0.formKeyOf)(offered) === (0, $2aPS0.formKeyOf)(now);
    }, [
        seed,
        group
    ]);
    const seedRow = (0, $acw62.useCallback)((drug, { scratch: scratch = fromScratch } = {})=>{
        const fromSeed = seedFits(drug) ? Object.fromEntries($876230c716e4c6d3$var$SIG_KEYS.filter((k)=>seed.defaults?.[k]).filter((k)=>k !== 'dosage' || seed.drugId === drug.id || (0, $eQiuG.doseOptionsFor)(drug).includes(String(seed.defaults[k]))).map((k)=>[
                k,
                String(seed.defaults[k])
            ])) : {};
        const base = baseFor(drug, scratch);
        const merged = {
            drug: drug,
            instructions: '',
            ...base,
            ...fromSeed
        };
        // A remembered مقدار تحویلی was counted for the remembered sig, not the seed's.
        if (!fromSeed.quantity && $876230c716e4c6d3$var$COUNTED_BY.some((k)=>fromSeed[k] && fromSeed[k] !== base[k])) merged.quantity = '';
        const row = (0, $eQiuG.withAutoQuantity)(merged, {
            durations: durations
        });
        // زمان مصرف and توضیحات are two fields over one stored text.
        return {
            ...row,
            ...(0, $eQiuG.splitInstructions)(row.instructions, whenOptions)
        };
    }, [
        baseFor,
        fromScratch,
        seed,
        seedFits,
        durations,
        whenOptions
    ]);
    const [drugId, setDrugId] = (0, $acw62.useState)(()=>(0, $2aPS0.productIn)(group, initialDrugId)?.drug.id);
    const product = (0, $2aPS0.productIn)(group, drugId);
    const drug = product?.drug;
    const [row, setRow] = (0, $acw62.useState)(()=>drug ? seedRow(drug) : null);
    // What the doctor set by hand — kept when they move to another product of the
    // same drug; everything else re-seeds from that product.
    const touched = (0, $acw62.useRef)(new Set());
    // A product the doctor chose by hand is never moved away from (`preferDrugId`).
    const pickedByHand = (0, $acw62.useRef)(false);
    const [allFrequencies, setAllFrequencies] = (0, $acw62.useState)(false);
    const [allRoutes, setAllRoutes] = (0, $acw62.useState)(false);
    const submitRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        submitRef.current?.focus?.({
            preventScroll: true
        });
    }, []);
    const edit = (0, $acw62.useCallback)((key, val)=>{
        touched.current.add(key);
        setRow((r)=>{
            let next = (0, $eQiuG.applyRxEdit)(r, key, val, {
                durations: durations
            });
            // An emptied مقدار تحویلی goes back to the worked-out one.
            if (key === 'quantity' && !val) {
                const q = (0, $eQiuG.quantityFor)(next);
                if (q) next = {
                    ...next,
                    quantity: String(q)
                };
            }
            return next;
        });
    }, [
        durations
    ]);
    // A product's starting row with what the doctor set by hand carried over.
    const reseed = (0, $acw62.useCallback)((d, prev)=>{
        let r = seedRow(d);
        if (!prev) return r;
        for (const key of touched.current){
            if (key === 'dosage' && !(0, $eQiuG.doseOptionsFor)(d).includes(prev.dosage)) continue;
            r = (0, $eQiuG.applyRxEdit)(r, key, prev[key], {
                durations: durations
            });
        }
        return r;
    }, [
        seedRow,
        durations
    ]);
    const openProduct = (0, $acw62.useCallback)((next)=>{
        if (!next || next.drug.id === drug?.id) return;
        setDrugId(next.drug.id);
        setRow((prev)=>reseed(next.drug, prev));
    }, [
        drug,
        reseed
    ]);
    // The memory arrived (or changed) after the form opened: it fills what the
    // doctor has not touched, and nothing they have.
    const memoryKey = (0, $acw62.useRef)({
        defaultsFor: defaultsFor,
        rememberedFor: rememberedFor
    });
    (0, $acw62.useEffect)(()=>{
        const was = memoryKey.current;
        if (was.defaultsFor === defaultsFor && was.rememberedFor === rememberedFor) return;
        memoryKey.current = {
            defaultsFor: defaultsFor,
            rememberedFor: rememberedFor
        };
        if (drug) setRow((prev)=>reseed(drug, prev));
    }, [
        defaultsFor,
        rememberedFor,
        drug,
        reseed
    ]);
    // The product the doctor prescribed most recently, once it is known — read
    // with the drug's other products, after the form opened on the first one.
    (0, $acw62.useEffect)(()=>{
        if (!preferDrugId || preferDrugId === drugId || pickedByHand.current || touched.current.size) return;
        const next = (0, $2aPS0.productIn)(group, preferDrugId);
        if (!next || next.drug.id !== preferDrugId) return;
        setDrugId(next.drug.id);
        setRow(seedRow(next.drug));
    }, [
        preferDrugId,
        drugId,
        group,
        seedRow
    ]);
    const reset = (0, $acw62.useCallback)(()=>{
        touched.current = new Set();
        pickedByHand.current = true;
        setFromScratch(false);
        setRow(seedRow(drug, {
            scratch: false
        }));
    }, [
        drug,
        seedRow
    ]);
    const startOver = (0, $acw62.useCallback)(()=>{
        touched.current = new Set();
        pickedByHand.current = true;
        setFromScratch(true);
        setRow(seedRow(drug, {
            scratch: true
        }));
    }, [
        drug,
        seedRow
    ]);
    if (!product || !row) return null;
    // ── which product ──
    const formKey = (0, $2aPS0.formKeyOf)(product);
    const forms = group.structured ? (0, $2aPS0.formsOf)(group) : [];
    const strengths = group.structured ? (0, $2aPS0.strengthsOf)(group, formKey) : [];
    const variants = group.structured ? (0, $2aPS0.productsOf)(group, formKey, product.strength) : [];
    const formOptions = (()=>{
        const worded = forms.map((f)=>{
            const parts = (0, $2aPS0.formLabelParts)(f.form, f.route, t, t('visit.rx.form.unknownForm'));
            return {
                f: f,
                label: [
                    parts.label,
                    parts.detail
                ].filter(Boolean).join(" \xb7 ")
            };
        });
        // Two forms the reader's language words alike are told apart as the registry
        // writes them («INJECTION, SOLUTION» / «INJECTION, SUSPENSION»).
        const twice = new Set(worded.filter((a, i)=>worded.some((b, j)=>i !== j && a.label === b.label)).map((w)=>w.label));
        return worded.map(({ f: f, label: label })=>({
                value: f.key,
                label: twice.has(label) && f.form ? `${label} (${f.form.toLowerCase()})` : label,
                title: [
                    f.form,
                    f.route
                ].filter(Boolean).join(' ')
            }));
    })();
    const pickForm = (key)=>{
        if (!key) return;
        const own = (0, $2aPS0.strengthsOf)(group, key);
        const strength = own.includes(product.strength) ? product.strength : own[0];
        pickedByHand.current = true;
        openProduct((0, $2aPS0.productsOf)(group, key, strength)[0]);
    };
    const pickStrength = (s)=>{
        if (s === '' && !strengths.includes('')) return;
        pickedByHand.current = true;
        openProduct((0, $2aPS0.productsOf)(group, formKey, s)[0]);
    };
    const pickVariant = (id)=>{
        if (!id) return;
        pickedByHand.current = true;
        openProduct(variants.find((p)=>p.drug.id === id));
    };
    // ── its sig ──
    const doseOptions = (0, $eQiuG.doseOptionsFor)(drug, row.dosage);
    const frequencyOptions = (()=>{
        const all = (0, $eQiuG.FREQUENCY_OPTIONS).includes(row.frequency) || !row.frequency ? (0, $eQiuG.FREQUENCY_OPTIONS) : [
            row.frequency,
            ...(0, $eQiuG.FREQUENCY_OPTIONS)
        ];
        if (allFrequencies) return all;
        const common = all.slice(0, $876230c716e4c6d3$var$COMMON_FREQUENCIES);
        return row.frequency && !common.includes(row.frequency) ? [
            ...common,
            row.frequency
        ] : common;
    })();
    const routeOptions = allRoutes || !row.route ? row.route && !(0, $eQiuG.RX_ROUTE_VALUES).includes(row.route) ? [
        row.route,
        ...(0, $eQiuG.RX_ROUTE_VALUES)
    ] : (0, $eQiuG.RX_ROUTE_VALUES) : [
        row.route
    ];
    const auto = (0, $eQiuG.quantityFor)(row);
    const quantityIsAuto = !!auto && (0, $eQiuG.quantityNumber)(row.quantity) === auto;
    const missing = (0, $eQiuG.missingRxFields)(row);
    const already = !!prescribedIds?.has?.(drug.id);
    const blocked = missing.length > 0 || already;
    const instructions = (0, $eQiuG.joinInstructions)(row.when, row.note);
    const submit = ()=>{
        if (blocked) return;
        onAdd(drug, Object.fromEntries($876230c716e4c6d3$var$SIG_KEYS.map((k)=>[
                k,
                (k === 'instructions' ? instructions : row[k]) || ''
            ])));
    };
    // «آخرین تنظیم شما · {date}» — the doctor's own values, so no AI badge; an
    // explicit source's label, when there is one, is the one shown.
    const remembered = (()=>{
        const src = memorySource(drug);
        return src ? rememberedFor(src) : null;
    })();
    const showRemembered = !sourceLabel && !fromScratch && !!remembered?.lastAt;
    const names = (0, $g6gAc.drugNameLines)(drug);
    // The line as it will read on the نسخه — its count named, since a bare number
    // at the end of a sentence says nothing.
    const summary = [
        (0, $6xvbB.rxItemSummary)({
            ...row,
            quantity: ''
        }, t, readsPersianData),
        row.quantity && `${t('visit.rx.quantity')} ${formatNumber((0, $eQiuG.quantityNumber)(row.quantity))}`,
        instructions
    ].filter(Boolean).join(" \xb7 ");
    const toggle = (open, set, testid)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            type: "button",
            variant: "link",
            size: "sm",
            onClick: ()=>set(!open),
            "data-testid": testid,
            className: touch ? 'min-h-11 px-2' : 'h-[34px] px-2'
        }, open ? t('visit.rx.form.less') : t('visit.rx.form.more'));
    const optional = (label)=>`${label} (${t('visit.rx.form.optional')})`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "group",
        "aria-label": t('visit.rx.form.title'),
        "data-testid": "visit-rx-form",
        "data-drug-id": drug.id,
        "data-state": blocked ? 'incomplete' : 'ready',
        onKeyDown: (e)=>{
            if (e.key === 'Escape') {
                e.stopPropagation();
                onCancel?.();
            }
            if (e.key === 'Enter' && (e.ctrlKey || e.metaKey)) {
                e.preventDefault();
                submit();
            }
        },
        style: {
            border: `1.5px solid ${(0, $jTCZr.C).navy}`,
            borderRadius: 10,
            background: (0, $jTCZr.CT).surface,
            padding: touch ? '0.75rem' : 14,
            display: 'flex',
            flexDirection: 'column',
            gap: 12
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: 8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: "auto",
        "data-testid": "visit-rx-form-name",
        style: {
            fontSize: touch ? '0.9375rem' : '0.875rem',
            fontWeight: 700,
            color: (0, $jTCZr.CT).ink,
            overflowWrap: 'anywhere'
        }
    }, names.primary), names.secondary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: "auto",
        style: {
            fontSize: touch ? '0.75rem' : '0.71875rem',
            color: (0, $jTCZr.CT).ink2,
            overflowWrap: 'anywhere'
        }
    }, names.secondary), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: 4,
            display: 'flex'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.InsurerListChip), {
        drug: drug,
        insurer: insurer,
        both: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        type: "button",
        variant: "ghost",
        size: "sm",
        onClick: reset,
        "data-testid": "visit-rx-form-reset",
        className: touch ? 'min-h-11 gap-1 shrink-0' : 'gap-1 shrink-0'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $iDwyV.default), {
        size: 13,
        "aria-hidden": true
    }), " ", remembered ? t('visit.rx.form.resetToRemembered') : t('visit.rx.form.reset')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        type: "button",
        variant: "ghost",
        size: "icon",
        onClick: onCancel,
        "aria-label": t('common.actions.close'),
        "data-testid": "visit-rx-form-close",
        className: touch ? 'h-11 w-11 shrink-0' : 'h-8 w-8 shrink-0'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
        size: 15,
        "aria-hidden": true
    }))), sourceLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-rx-form-source",
        "data-kind": sourceKind || 'document',
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            fontSize: touch ? '0.75rem' : '0.71875rem',
            fontWeight: 600,
            color: (0, $jTCZr.CT).accentInk
        }
    }, sourceKind === 'ai' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $chm1L.default), {
        size: 13,
        "aria-hidden": true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3FyOw.default), {
        size: 13,
        "aria-hidden": true
    }), " ", sourceLabel), showRemembered && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-rx-form-remembered",
        "data-last-at": remembered.lastAt,
        style: {
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: 6,
            fontSize: touch ? '0.75rem' : '0.71875rem',
            fontWeight: 600,
            color: (0, $jTCZr.CT).accentInk
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $i5dmF.default), {
        size: 13,
        "aria-hidden": true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, t('visit.rx.form.remembered', {
        date: formatDate(remembered.lastAt)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        type: "button",
        variant: "ghost",
        size: "sm",
        onClick: startOver,
        "data-testid": "visit-rx-form-from-scratch",
        className: touch ? 'min-h-11 px-2' : 'h-7 px-2'
    }, t('visit.rx.form.fromScratch'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-rx-form-summary",
        style: {
            background: (0, $jTCZr.CT).surface2,
            borderRadius: 8,
            padding: '8px 10px',
            fontSize: touch ? '0.8125rem' : '0.78125rem',
            color: (0, $jTCZr.CT).ink,
            lineHeight: 1.7
        }
    }, summary || t('visit.rx.needsDosing')), group.structured && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bkKUS.default), {
        label: t('visit.rx.form.dosageForm'),
        required: true,
        touch: touch,
        value: formKey,
        onChange: pickForm,
        options: formOptions,
        testId: "visit-rx-form-dosageForm"
    }, loadingProducts && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "visit-rx-form-loading",
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6,
            fontSize: '0.71875rem',
            color: (0, $jTCZr.CT).ink2
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 12,
        color: (0, $jTCZr.CT).accent,
        thickness: 2
    }), " ", t('visit.rx.form.loadingProducts'))), strengths.some(Boolean) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bkKUS.default), {
        label: t('visit.rx.form.strength'),
        required: true,
        touch: touch,
        value: product.strength,
        onChange: pickStrength,
        options: strengths.map((s)=>({
                value: s,
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("bdi", {
                    dir: "ltr"
                }, s || "\u2014")
            })),
        testId: "visit-rx-form-strength"
    }), variants.length > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bkKUS.default), {
        label: t('visit.rx.form.product'),
        required: true,
        touch: touch,
        value: drug.id,
        onChange: pickVariant,
        options: variants.map((p)=>({
                value: p.drug.id,
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("bdi", {
                    dir: "ltr"
                }, (0, $2aPS0.variantLabel)(p) || t('visit.rx.form.generic')),
                title: (0, $g6gAc.drugNameLines)(p.drug).primary
            })),
        testId: "visit-rx-form-product"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            borderTop: `1px solid ${(0, $jTCZr.CT).border}`,
            paddingTop: 10,
            fontSize: touch ? '0.8125rem' : '0.78125rem',
            fontWeight: 700,
            color: (0, $jTCZr.CT).accentInk
        }
    }, t('visit.rx.form.sig')), doseOptions.length > $876230c716e4c6d3$var$MAX_DOSE_CHIPS ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        label: t('visit.rx.dose'),
        required: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("select", {
        value: row.dosage || '',
        onChange: (e)=>edit('dosage', e.target.value),
        "data-testid": "visit-rx-form-dosage",
        style: {
            minHeight: touch ? '2.75rem' : 34,
            maxWidth: 220,
            border: `1px solid ${(0, $jTCZr.CT).border}`,
            borderRadius: 8,
            padding: '0 10px',
            fontFamily: 'inherit',
            fontSize: touch ? '1rem' : '0.78125rem',
            color: (0, $jTCZr.CT).ink,
            background: (0, $jTCZr.CT).surface
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
        value: ""
    }, t('visit.rx.dose')), doseOptions.map((d)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
            key: d,
            value: d
        }, (0, $6xvbB.drugDosageLabel)(d, readsPersianData, t))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bkKUS.default), {
        label: t('visit.rx.dose'),
        required: true,
        touch: touch,
        value: row.dosage,
        onChange: (v)=>edit('dosage', v),
        options: doseOptions.map((d)=>({
                value: d,
                label: (0, $6xvbB.drugDosageLabel)(d, readsPersianData, t)
            })),
        testId: "visit-rx-form-dosage"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bkKUS.default), {
        label: t('visit.rx.frequency'),
        required: true,
        touch: touch,
        value: row.frequency,
        onChange: (v)=>edit('frequency', v),
        options: frequencyOptions.map((f)=>({
                value: f,
                label: (0, $lfHhF.drugFrequencyLabel)(f, t)
            })),
        testId: "visit-rx-form-frequency"
    }, toggle(allFrequencies, setAllFrequencies, 'visit-rx-form-frequency-more')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bkKUS.default), {
        label: t('visit.rx.route'),
        required: true,
        touch: touch,
        value: row.route,
        onChange: (v)=>edit('route', v),
        options: routeOptions.map((r)=>({
                value: r,
                label: (0, $eQiuG.routeLabel)(r, t)
            })),
        testId: "visit-rx-form-route"
    }, row.route ? toggle(allRoutes, setAllRoutes, 'visit-rx-form-route-more') : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bkKUS.default), {
        label: optional(t('visit.rx.form.when')),
        touch: touch,
        value: row.when || '',
        onChange: (v)=>edit('when', v || ''),
        options: whenOptions.map((w)=>({
                value: w,
                label: w
            })),
        testId: "visit-rx-form-when"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bkKUS.default), {
        label: optional(t('visit.rx.duration')),
        touch: touch,
        value: row.duration,
        onChange: (v)=>edit('duration', v),
        options: (row.duration && !durations.includes(row.duration) ? [
            row.duration,
            ...durations
        ] : durations).map((d)=>({
                value: d,
                label: d
            })),
        testId: "visit-rx-form-duration"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 10,
            flexWrap: 'wrap',
            alignItems: 'flex-start'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
        label: t('visit.rx.quantity'),
        required: true,
        value: row.quantity || '',
        onChange: (e)=>edit('quantity', (0, $5JYPc.toEnDigits)(e?.target ? e.target.value : String(e ?? '')).replace(/[^\d]/g, '')),
        inputMode: "numeric",
        dir: "ltr",
        helperText: quantityIsAuto ? t('visit.rx.form.auto') : undefined,
        "data-testid": "visit-rx-form-quantity",
        "data-auto": quantityIsAuto || undefined,
        style: {
            width: touch ? '100%' : 200
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
        label: t('visit.rx.instructionsOptional'),
        value: row.note || '',
        onChange: (e)=>edit('note', e?.target ? e.target.value : String(e ?? '')),
        placeholder: t('visit.rx.instructionsPlaceholder'),
        dir: "auto",
        "data-testid": "visit-rx-form-instructions",
        style: {
            flex: 1,
            minWidth: touch ? '100%' : 200
        }
    })), (missing.length > 0 || already) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "alert",
        "data-testid": "visit-rx-form-missing",
        "data-missing": missing.join(' '),
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '8px 10px',
            borderRadius: 8,
            background: (0, $jTCZr.CT).warnSoft,
            color: (0, $jTCZr.CT).warnInk,
            fontSize: touch ? '0.8125rem' : '0.75rem',
            fontWeight: 600,
            lineHeight: 1.6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bSvYG.default), {
        size: 15,
        "aria-hidden": true,
        style: {
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, already ? t('visit.rx.form.alreadyOn') : t('visit.rx.form.missing', {
        fields: (0, $eQiuG.rxFieldNames)(missing, t)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        ref: submitRef,
        type: "button",
        onClick: submit,
        disabled: blocked,
        "data-testid": "visit-rx-form-submit",
        className: touch ? 'flex-1 min-h-11 gap-1.5' : 'flex-1 gap-1.5'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8g4t5.default), {
        size: 14,
        "aria-hidden": true
    }), " ", t('visit.rx.form.submit')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        type: "button",
        variant: "outline",
        onClick: onCancel,
        "data-testid": "visit-rx-form-cancel",
        className: touch ? 'min-h-11' : undefined
    }, t('common.actions.cancel'))));
}

});



parcelRegister("3HnvL", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcedef1256f07607$export$2e2bcd8739ae039);
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");
parcelRequire("7sS0P");
var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $7gSBD = parcelRequire("7gSBD");
var $hZDga = parcelRequire("hZDga");

var $fWbIA = parcelRequire("fWbIA");

var $huNwV = parcelRequire("huNwV");
var $3FyOw = parcelRequire("3FyOw");
var $4CVxl = parcelRequire("4CVxl");
var $8g4t5 = parcelRequire("8g4t5");
var $03cDl = parcelRequire("03cDl");
var $e5Ore = parcelRequire("e5Ore");
var $9Fbsf = parcelRequire("9Fbsf");
var $chm1L = parcelRequire("chm1L");
var $fX0JO = parcelRequire("fX0JO");
var $6TdpC = parcelRequire("6TdpC");

var $lTG78 = parcelRequire("lTG78");
var $jTCZr = parcelRequire("jTCZr");

var $ltciA = parcelRequire("ltciA");

var $aQGDs = parcelRequire("aQGDs");

var $7TTuK = parcelRequire("7TTuK");

var $feEcD = parcelRequire("feEcD");

var $3O5pt = parcelRequire("3O5pt");

var $6xvbB = parcelRequire("6xvbB");

var $d2Zvn = parcelRequire("d2Zvn");
// Icons per order type — the phone's answer to the desktop ORDER_TYPE_ICON map,
// which indexes a desktop-only icon set.
const $dcedef1256f07607$var$TYPE_ICON = {
    lab: (0, $4CVxl.default),
    imaging: (0, $03cDl.default),
    procedure: (0, $fX0JO.default),
    referral: (0, $9Fbsf.default),
    other: (0, $3FyOw.default)
};
// The clinical-orders tab: an AI order-suggestion pass (labelled §13.3), a
// structured catalog picker (type → searchable, category-grouped checklist →
// urgency / «تاریخ انجام» / note / sessions — the mobile-native fork of the desktop add-order
// form), and the pending list. Orders live in pendingTests and are persisted by
// the screen at «پایان ویزیت»; this stays render-only.
const $dcedef1256f07607$var$ORDER_TYPES = (t)=>[
        {
            value: 'lab',
            label: t('visit.orders.lab')
        },
        {
            value: 'imaging',
            label: t('patient.orderType.imaging')
        },
        {
            value: 'procedure',
            label: t('visit.orders.procedureShort')
        },
        {
            value: 'other',
            label: t('common.state.other')
        }
    ];
const $dcedef1256f07607$var$URGENCIES = (t)=>[
        {
            value: 'routine',
            label: t('common.urgency.routine')
        },
        {
            value: 'urgent',
            label: t('common.urgency.urgent')
        },
        {
            value: 'stat',
            label: t('common.urgency.stat')
        }
    ];
const $dcedef1256f07607$var$TYPE_LBL = (t)=>({
        lab: t('patient.orderType.lab'),
        imaging: t('patient.orderType.imaging'),
        procedure: t('visit.orders.procedureShort'),
        other: t('common.state.other')
    });
// One search result, in the shape the checklist reads. The server has already
// filtered by query and type and ranked what this clinic performs first, so
// there is nothing left to filter here.
const $dcedef1256f07607$var$normalizeResults = (entries, t, insurer)=>(entries || []).map((e)=>({
            key: `${e.orderType}:${e.name}`,
            type: e.orderType,
            name: e.name,
            nameEn: e.nameEn || '',
            // What the reader's own-language name is read from (ownCatalogName).
            nameAr: e.nameAr || '',
            nameFr: e.nameFr || '',
            nameDe: e.nameDe || '',
            catalogId: e.id || null,
            code: e.code || '',
            // A «LOINC» badge is only honest when the code IS a LOINC — the same field now
            // also carries CPT, and soon LAB-ir and Radiology-ir numbers.
            loincCode: e.codeSystem === 'LOINC' ? e.code || '' : '',
            modality: e.modality || '',
            sub: e.orderType === 'imaging' ? e.bodyPart || '' : e.code ? `${e.codeSystem || ''} ${e.code}`.trim() : '',
            category: e.category || t('common.state.other'),
            inHouse: !!e.inHouse,
            // «در فهرست تأمین» — for a تأمین patient, as on the desktop (K1, 2026-10-07).
            taminListed: (0, $6xvbB.taminFlagOf)(e, insurer)
        }));
// 1rem and 2.75rem: anything smaller makes iOS zoom on focus and misses the
// touch floor (MOBILE_WEB_PWA §5; seen in the 2026-10-12 tour).
const $dcedef1256f07607$var$selectStyle = {
    border: `1px solid ${(0, $jTCZr.C).border}`,
    borderRadius: '0.5rem',
    padding: '0.5rem 0.625rem',
    fontSize: '1rem',
    minHeight: '2.75rem',
    fontFamily: 'inherit',
    color: (0, $jTCZr.C).textPrimary,
    background: (0, $jTCZr.CT).surface2,
    outline: 'none'
};
const $dcedef1256f07607$var$inputStyle = {
    border: `1px solid ${(0, $jTCZr.C).border}`,
    borderRadius: '0.5rem',
    padding: '0.625rem 0.75rem',
    fontSize: '1rem',
    fontFamily: 'inherit',
    color: (0, $jTCZr.C).textPrimary,
    background: (0, $jTCZr.CT).surface2,
    outline: 'none',
    width: '100%',
    boxSizing: 'border-box'
};
const $dcedef1256f07607$var$CheckRow = ({ item: item, checked: checked, onToggle: onToggle })=>{
    // A reader who does not read Persian sees the catalogue's name in their own
    // language, else its English one (orderNameLines, as on the desktop); the
    // Persian `name` is still what the order is created with.
    const { t: t, readsPersianData: readsPersianData, locale: locale } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        onClick: onToggle,
        "aria-pressed": checked,
        "data-testid": `visit-order-catalog-item-${item.key}`,
        className: "w-full min-h-11 h-auto justify-start rounded-lg px-2 py-2 gap-2 hover:bg-transparent font-normal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: '1.125rem',
            height: '1.125rem',
            borderRadius: '0.3125rem',
            flexShrink: 0,
            border: `1.5px solid ${checked ? (0, $jTCZr.CT).accent : (0, $jTCZr.C).border}`,
            background: checked ? (0, $jTCZr.CT).accent : 'transparent',
            display: 'grid',
            placeItems: 'center'
        }
    }, checked && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
        size: 12,
        color: "#fff",
        "aria-hidden": true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            minWidth: 0,
            textAlign: 'start'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.375rem',
            flexWrap: 'wrap',
            fontSize: '0.8125rem',
            fontWeight: 500,
            color: (0, $jTCZr.C).textPrimary
        }
    }, (0, $6xvbB.orderNameLines)(item, readsPersianData, (0, $6xvbB.ownCatalogName)(item, locale)).primary, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.InsurerListChip), {
        drug: {
            id: item.catalogId || item.key
        },
        listed: item.taminListed ?? null,
        both: true,
        size: "0.625rem",
        testid: `visit-order-coverage-${item.catalogId || item.key}`,
        hint: t('visit.orders.outTaminHint')
    })), (item.sub || item.modality) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'block',
            fontSize: '0.625rem',
            color: (0, $jTCZr.C).textMuted,
            marginTop: '0.0625rem'
        }
    }, [
        item.modality,
        item.sub
    ].filter(Boolean).join(" \xb7 "))));
};
const $dcedef1256f07607$var$MobileVisitOrders = ({ onFetchSuggestions: onFetchSuggestions, suggestions: suggestions, suggestionsLoading: suggestionsLoading, canSuggest: canSuggest, searchCatalog: searchCatalog, pendingTests: pendingTests, onAddOrders: onAddOrders, onAddPending: onAddPending, onRemovePending: onRemovePending, orders: // ── Saved orders and their lifecycle (§5.5) ───────────────────────────────
orders = [], ordersLoading: ordersLoading = false, ordersLoaded: ordersLoaded = false, transitioningId: transitioningId = null, inHouseCatalogIds: inHouseCatalogIds, insurer: // The patient's basic insurer and the chart's catalogue rows (id → row): what
// «در فهرست تأمین» on the picker and «خارج از فهرست تأمین» on a card read.
insurer = null, catalogResolved: catalogResolved = null, onCompleteOrder: onCompleteOrder, onCancelOrder: onCancelOrder, orderError: orderError, onDismissOrderError: onDismissOrderError, onChangeOrderDate: // «تاریخ انجام» on a saved row (PM-0634): `onChangeOrderDate(orderId, day)`
// answers null once written, else the sentence to show; `erxIndex` is the
// visit's ePrescriptionStatus (lib/erxCorrection) — an order at the insurer
// keeps its date.
onChangeOrderDate = null, erxIndex: erxIndex = null, visitId: // PM-0618: the visit the rows are read in, and whether it is online — «انجام شد»
// records a session IN this visit, and the caption says where it will be done.
visitId = null, visitOnline: visitOnline = false, completeAction: // «تکمیل از پایش بالینی» (PM-0038): the section's button and its proposal card,
// built by the screen from the visit's one vocabulary.
completeAction = null, proposal: proposal = null, onPendingChange: // How many picked items are not on the visit yet — ticked in the catalogue
// (or typed under «سایر») but «افزودن» not pressed. The screen holds
// «پایان ویزیت» on it: a CBC ticked and never added used to vanish when the
// visit ended (2026-10-12 tour, PM-0121).
onPendingChange })=>{
    const { t: t, formatDigits: formatDigits, formatNumber: formatNumber, readsPersianData: readsPersianData, locale: locale } = (0, $LNQP4.default)();
    // Orders this clinic performs float to the top; everything else keeps its
    // creation order. Stable via the paired index — the desktop ordering.
    const sortedOrders = (0, $acw62.useMemo)(()=>orders.map((o, i)=>[
                o,
                i
            ]).sort((a, b)=>{
            const ah = !!a[0]?.catalogId && !!inHouseCatalogIds?.has?.(a[0].catalogId);
            const bh = !!b[0]?.catalogId && !!inHouseCatalogIds?.has?.(b[0].catalogId);
            return bh - ah || a[1] - b[1];
        }).map(([o])=>o), [
        orders,
        inHouseCatalogIds
    ]);
    const [type, setType] = (0, $acw62.useState)('lab');
    const [search, setSearch] = (0, $acw62.useState)('');
    const [urgency, setUrgency] = (0, $acw62.useState)('routine');
    const [orderDate, setOrderDate] = (0, $acw62.useState)({
        preset: 'TODAY',
        date: ''
    });
    const [notes, setNotes] = (0, $acw62.useState)('');
    const [sessions, setSessions] = (0, $acw62.useState)(1);
    const [selected, setSelected] = (0, $acw62.useState)(()=>new Set());
    const [freeText, setFreeText] = (0, $acw62.useState)('');
    // One search per pause in typing. A reply to an older query never lands on top
    // of a newer one, and a checked item survives the next keystroke — the picker
    // no longer holds a catalogue to look a key up in later.
    const [page, setPage] = (0, $acw62.useState)({
        entries: [],
        total: 0,
        loading: false,
        error: null
    });
    const chosenRef = (0, $acw62.useRef)(new Map());
    (0, $acw62.useEffect)(()=>{
        if (type === 'other' || typeof searchCatalog !== 'function') return undefined;
        // Nothing is listed until the doctor searches (PM-0098, as on the نسخه).
        if (search.trim().length < (0, $6xvbB.ORDER_MIN_QUERY)) {
            setPage({
                entries: [],
                total: 0,
                loading: false,
                error: null
            });
            return undefined;
        }
        let live = true;
        setPage((prev)=>({
                ...prev,
                loading: true
            }));
        const timer = setTimeout(()=>{
            searchCatalog({
                query: search,
                orderType: type
            }).then((res)=>{
                if (live) setPage({
                    ...res,
                    loading: false,
                    error: null
                });
            }).catch((err)=>{
                if (!live) return;
                console.error('order catalog search failed:', err);
                setPage({
                    entries: [],
                    total: 0,
                    loading: false,
                    error: err?.message || 'error'
                });
            });
        }, 250);
        return ()=>{
            live = false;
            clearTimeout(timer);
        };
    }, [
        type,
        search,
        searchCatalog
    ]);
    const items = (0, $acw62.useMemo)(()=>$dcedef1256f07607$var$normalizeResults(page.entries, t, insurer), [
        page.entries,
        t,
        insurer
    ]);
    const grouped = (0, $acw62.useMemo)(()=>{
        if (type === 'other') return [];
        const byCat = new Map();
        for (const it of items){
            if (!byCat.has(it.category)) byCat.set(it.category, []);
            byCat.get(it.category).push(it);
        }
        // In-house services lead their category — the desktop ordering, which the
        // phone silently lacked while it filtered in memory.
        return Array.from(byCat, ([category, list])=>({
                category: category,
                list: list.map((it, i)=>[
                        it,
                        i
                    ]).sort((a, b)=>!!b[0].inHouse - !!a[0].inHouse || a[1] - b[1]).map(([it])=>it)
            }));
    }, [
        items,
        type
    ]);
    const itemByKey = (0, $acw62.useMemo)(()=>{
        const m = new Map();
        for (const it of items)m.set(it.key, it);
        return m;
    }, [
        items
    ]);
    const changeType = (item)=>{
        setType(item);
        setSearch('');
        setSelected(new Set());
        chosenRef.current.clear();
    };
    const toggleKey = (key)=>setSelected((prev)=>{
            const next = new Set(prev);
            if (next.has(key)) {
                next.delete(key);
                chosenRef.current.delete(key);
            } else {
                next.add(key);
                // Hold the ITEM, not just its key. The list changes with the next
                // keystroke, and there is no resident catalogue to resolve a key against
                // when «افزودن» is finally pressed.
                const it = itemByKey.get(key);
                if (it) chosenRef.current.set(key, it);
            }
            return next;
        });
    const dateHeld = !!(0, $feEcD.orderDateProblem)(orderDate, (0, $feEcD.clinicTodayIso)());
    const canAdd = !dateHeld && (type === 'other' ? !!freeText.trim() : selected.size > 0);
    const pendingCount = type === 'other' ? freeText.trim() ? 1 : 0 : selected.size;
    (0, $acw62.useEffect)(()=>{
        onPendingChange?.(pendingCount);
    }, [
        pendingCount,
        onPendingChange
    ]);
    (0, $acw62.useEffect)(()=>()=>onPendingChange?.(0), [
        onPendingChange
    ]);
    const submit = ()=>{
        if (dateHeld) return;
        // «تاریخ انجام» for every item picked, as «فوریت» — none for «امروز».
        const performedDate = (0, $feEcD.orderDateToSend)(orderDate, (0, $feEcD.clinicTodayIso)());
        if (type === 'other') {
            const name = freeText.trim();
            if (!name) return;
            onAddOrders([
                {
                    name: name,
                    type: 'other',
                    urgency: urgency,
                    reason: notes.trim(),
                    performedDate: performedDate
                }
            ]);
            setFreeText('');
            setNotes('');
            setOrderDate({
                preset: 'TODAY',
                date: ''
            });
            return;
        }
        const chosen = Array.from(selected).map((k)=>chosenRef.current.get(k) || itemByKey.get(k)).filter(Boolean);
        if (!chosen.length) return;
        const sc = type === 'procedure' ? Math.max(1, Number(sessions) || 1) : 1;
        // `catalogId` travels too, as the desktop's «افزودن» sends it: without it
        // the order reaches the record unlinked from the row it was picked from.
        onAddOrders(chosen.map((it)=>({
                name: it.name,
                type: it.type,
                urgency: urgency,
                reason: notes.trim(),
                code: it.code,
                loincCode: it.loincCode || it.code,
                sessionCount: sc,
                catalogId: it.catalogId || null,
                performedDate: performedDate
            })));
        setSelected(new Set());
        setNotes('');
        setSessions(1);
        setOrderDate({
            preset: 'TODAY',
            date: ''
        });
    };
    const suggItems = [
        ...suggestions?.labTests || [],
        ...suggestions?.imagingStudies || []
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-orders-content",
        "data-state": pendingTests.length ? 'content' : 'empty'
    }, completeAction && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            marginBottom: '0.5rem'
        }
    }, completeAction), proposal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginBottom: '0.625rem'
        }
    }, proposal), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "teal",
        size: "lg",
        onClick: onFetchSuggestions,
        disabled: suggestionsLoading || !canSuggest,
        "data-testid": "visit-orders-suggest",
        className: "w-full min-h-11 mb-2 gap-1.5"
    }, suggestionsLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 14,
        color: "#fff",
        thickness: 2
    }), " ", t('visit.copilot.analysing')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $chm1L.default), {
        size: 15,
        "aria-hidden": true
    }), " ", t('visit.suggest.smartTests'))), suggItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginBottom: '0.625rem',
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: '0.75rem',
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '0.5rem 0.75rem',
            background: (0, $jTCZr.CT).accentSoft,
            display: 'flex',
            alignItems: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lTG78.AiBadge), {
        label: t('visit.suggest.smart')
    })), suggItems.map((order, i)=>{
        const name = order.testName || order.studyType;
        const orderType = order.testName ? 'lab' : 'imaging';
        // Already on the visit counts as added: a saved order (from the
        // desktop, a template, or before a reload) is in `orders`, not in
        // `pendingTests`, and adding it again wrote a second row.
        const added = pendingTests.some((p)=>p.name === name) || (0, $d2Zvn.isAlreadyOrdered)(orders, orderType, name);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: `${i}:${name}`,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                padding: '0.5rem 0.75rem',
                borderTop: i ? `1px solid ${(0, $jTCZr.C).border}` : 'none'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1,
                minWidth: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.8125rem',
                fontWeight: 600,
                color: (0, $jTCZr.C).textPrimary
            }
        }, name), order.reason && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.6875rem',
                color: (0, $jTCZr.C).textMuted,
                marginTop: '0.0625rem'
            }
        }, order.reason)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: added ? 'subtle' : 'default',
            size: "sm",
            disabled: added,
            "data-testid": `visit-orders-add-sugg-${i}`,
            className: "min-h-11 shrink-0 gap-1",
            // The lab's catalogue LOINC rides along: «پایان ویزیت» saves
            // `code || loincCode`, and without it the order reached the
            // record and the insurer uncoded (lib/suggestedOrders).
            onClick: ()=>onAddPending({
                    id: Date.now() + i,
                    name: name,
                    type: orderType,
                    urgency: order.urgency || 'routine',
                    reason: order.reason || '',
                    code: order.loincCode || '',
                    loincCode: order.loincCode || ''
                })
        }, added ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
            size: 13,
            "aria-hidden": true
        }), " ", t('visit.orders.added')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8g4t5.default), {
            size: 13,
            "aria-hidden": true
        }), " ", t('visit.orders.add'))));
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-order-form",
        style: {
            background: (0, $jTCZr.C).card,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: '0.75rem',
            padding: '0.75rem',
            marginBottom: '0.75rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            fontSize: '0.8125rem',
            fontWeight: 700,
            color: (0, $jTCZr.C).textPrimary
        }
    }, t('visit.orders.add')), selected.size > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.625rem',
            fontWeight: 700,
            padding: '0.125rem 0.4375rem',
            borderRadius: '0.75rem',
            background: (0, $jTCZr.CT).accentSoft,
            color: (0, $jTCZr.CT).accentInk
        }
    }, selected.size, " ", t('visit.orders.selectedCount'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-order-type-tabs",
        style: {
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '0.375rem'
        }
    }, $dcedef1256f07607$var$ORDER_TYPES(t).map((o)=>{
        const on = type === o.value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            key: o.value,
            variant: on ? 'default' : 'outline',
            size: "sm",
            className: "min-h-11",
            "data-testid": `visit-order-type-${o.value}`,
            "aria-pressed": on,
            onClick: ()=>changeType(o.value)
        }, o.label);
    })), type === 'other' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        value: freeText,
        onChange: (e)=>setFreeText(e.target.value),
        onKeyDown: (e)=>{
            if (e.key === 'Enter') submit();
        },
        placeholder: t('visit.orders.freeText'),
        "data-testid": "visit-order-freetext-input",
        style: $dcedef1256f07607$var$inputStyle
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'relative'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e5Ore.default), {
        size: 15,
        "aria-hidden": true,
        style: {
            position: 'absolute',
            insetInlineStart: '0.625rem',
            top: '50%',
            transform: 'translateY(-50%)',
            color: (0, $jTCZr.C).textMuted,
            pointerEvents: 'none'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        value: search,
        onChange: (e)=>setSearch(e.target.value),
        placeholder: t('visit.orders.searchCatalog'),
        "data-testid": "visit-order-catalog-search",
        style: {
            ...$dcedef1256f07607$var$inputStyle,
            paddingInlineStart: '2rem'
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-order-catalog-list",
        style: {
            maxHeight: '15rem',
            overflowY: 'auto',
            WebkitOverflowScrolling: 'touch'
        }
    }, search.trim().length < (0, $6xvbB.ORDER_MIN_QUERY) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-order-search-idle",
        "data-state": "idle",
        style: {
            padding: '0.5rem 0.25rem',
            color: (0, $jTCZr.CT).ink2,
            fontSize: '0.75rem',
            lineHeight: 1.7
        }
    }, search.trim() ? t('visit.orders.keepTyping') : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontWeight: 600,
            color: (0, $jTCZr.CT).ink
        }
    }, t('visit.orders.searchTitle')), " \u2014 ", t('visit.orders.searchBody'))) : page.loading && !items.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.375rem',
            padding: '1rem 0',
            color: (0, $jTCZr.C).textMuted,
            fontSize: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 13,
        color: (0, $jTCZr.CT).accent,
        thickness: 2
    }), " ", t('visit.orders.loadingCatalog')) : page.error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-order-catalog-error",
        style: {
            textAlign: 'center',
            padding: '1rem 0',
            color: (0, $jTCZr.CT).danger,
            fontSize: '0.75rem'
        }
    }, t('visit.orders.catalogSearchFailed')) : grouped.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            textAlign: 'center',
            padding: '1rem 0',
            color: (0, $jTCZr.C).textMuted,
            fontSize: '0.75rem'
        }
    }, t('visit.orders.noCatalogMatch')) : grouped.map(({ category: category, list: list })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: category,
            style: {
                marginBottom: '0.375rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.625rem',
                fontWeight: 700,
                textTransform: 'uppercase',
                letterSpacing: '0.05em',
                color: (0, $jTCZr.C).textMuted,
                padding: '0.375rem 0.25rem 0.1875rem'
            }
        }, category), list.map((it)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($dcedef1256f07607$var$CheckRow, {
                key: it.key,
                item: it,
                checked: selected.has(it.key),
                onToggle: ()=>toggleKey(it.key)
            }))))), selected.size > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-order-selected-chips",
        style: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: '0.375rem',
            marginTop: '0.5rem'
        }
    }, Array.from(selected).map((key)=>{
        const it = chosenRef.current.get(key);
        if (!it) return null;
        // Named as its row names it — not the Persian `name` for everyone.
        const name = (0, $6xvbB.orderNameLines)(it, readsPersianData, (0, $6xvbB.ownCatalogName)(it, locale)).primary;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            key: key,
            variant: "subtle",
            size: "sm",
            className: "min-h-11 gap-1.5",
            onClick: ()=>toggleKey(key),
            "aria-label": t('visit.rx.removeAria', {
                name: name
            }),
            "data-testid": `visit-order-selected-${key}`
        }, name, " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
            size: 13,
            "aria-hidden": true
        }));
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: '0.375rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("select", {
        value: urgency,
        onChange: (e)=>setUrgency(e.target.value),
        "data-testid": "visit-order-urgency",
        style: {
            ...$dcedef1256f07607$var$selectStyle,
            flex: 1
        }
    }, $dcedef1256f07607$var$URGENCIES(t).map((o)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
            key: o.value,
            value: o.value
        }, o.label))), type === 'procedure' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        type: "number",
        min: 1,
        value: sessions,
        onChange: (e)=>setSessions(e.target.value),
        "aria-label": t('visit.rx.sessions'),
        "data-testid": "visit-order-sessions",
        style: {
            ...$dcedef1256f07607$var$selectStyle,
            width: '5rem',
            textAlign: 'center'
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.375rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.6875rem',
            fontWeight: 600,
            color: (0, $jTCZr.C).textMuted
        }
    }, t('visit.orders.date.label')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aQGDs.OrderDateChoice), {
        value: orderDate,
        onChange: setOrderDate,
        pickerHeight: 44
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        value: notes,
        onChange: (e)=>setNotes(e.target.value),
        placeholder: t('visit.orders.noteOptionalPlaceholder'),
        "data-testid": "visit-order-notes",
        style: $dcedef1256f07607$var$inputStyle
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: canAdd ? 'default' : 'outline',
        size: "sm",
        onClick: submit,
        disabled: !canAdd,
        "data-testid": "visit-order-create",
        "data-pending": pendingCount || undefined,
        className: `w-full min-h-11 gap-1.5${canAdd ? '' : ' border-dashed'}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8g4t5.default), {
        size: 14,
        "aria-hidden": true
    }), " ", pendingCount > 0 ? t('visit.orders.addPending', {
        count: formatDigits(pendingCount)
    }) : t('common.actions.add'))), pendingTests.length === 0 && !suggItems.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4CVxl.default), {
            size: 44,
            color: (0, $jTCZr.C).textMuted,
            strokeWidth: 1.5,
            "aria-hidden": true
        }),
        title: t('visit.orders.noneRecorded')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.375rem'
        }
    }, pendingTests.map((order)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: order.id,
            "data-testid": `visit-orders-row-${order.id}`,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.625rem',
                background: (0, $jTCZr.C).card,
                border: `1px solid ${(0, $jTCZr.C).border}`,
                borderRadius: '0.75rem',
                padding: '0.6875rem 0.75rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                width: '0.5rem',
                height: '0.5rem',
                borderRadius: '50%',
                background: (0, $lTG78.urgencyColor)(order.urgency),
                flexShrink: 0
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1,
                minWidth: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.8125rem',
                fontWeight: 500,
                color: (0, $jTCZr.C).textPrimary
            }
        }, order.name, order.sessionCount > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.625rem',
                color: (0, $jTCZr.C).textMuted,
                fontWeight: 400
            }
        }, " \xb7 ", formatDigits(order.sessionCount), " ", t('visit.rx.session'))), order.reason && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.6875rem',
                color: (0, $jTCZr.C).textMuted
            }
        }, order.reason), order.performedDate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aQGDs.OrderDateLine), {
            order: {
                id: order.id,
                performedDate: order.performedDate,
                status: 'pending'
            },
            compact: true,
            testid: `visit-orders-row-date-${order.id}`
        })), order.type && order.type !== 'lab' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.5625rem',
                fontWeight: 700,
                padding: '0.0625rem 0.375rem',
                borderRadius: '0.25rem',
                background: (0, $jTCZr.CT).surface2,
                color: (0, $jTCZr.C).textSecondary
            }
        }, $dcedef1256f07607$var$TYPE_LBL(t)[order.type] || order.type), order.urgency && order.urgency !== 'routine' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.625rem',
                fontWeight: 700,
                padding: '0.125rem 0.4375rem',
                borderRadius: '0.25rem',
                background: order.urgency === 'stat' ? (0, $jTCZr.C).redLight : (0, $jTCZr.C).amberLight,
                color: order.urgency === 'stat' ? (0, $jTCZr.CT).dangerInk : (0, $jTCZr.CT).warnInk
            }
        }, order.urgency === 'stat' ? t('common.urgency.stat') : t('common.urgency.urgent')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            size: "icon",
            className: "h-11 w-11 text-muted-foreground shrink-0",
            "aria-label": t('visit.orders.removeAria', {
                name: order.name
            }),
            "data-testid": `visit-orders-remove-${order.id}`,
            onClick: ()=>onRemovePending(order.id)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
            size: 15,
            "aria-hidden": true
        }))))), (ordersLoading || ordersLoaded || orders.length > 0) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: '0.875rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.375rem',
            marginBottom: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.6875rem',
            fontWeight: 700,
            color: (0, $jTCZr.C).textMuted,
            textTransform: 'uppercase',
            letterSpacing: '0.06em'
        }
    }, t('visit.orders.saved')), orders.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.625rem',
            fontWeight: 700,
            color: (0, $jTCZr.C).textSecondary,
            background: (0, $jTCZr.CT).surface2,
            borderRadius: '0.25rem',
            padding: '0.0625rem 0.375rem'
        }
    }, formatDigits(orders.length))), orderError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-order-error",
        role: "alert",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            borderRadius: '0.5rem',
            padding: '0.5rem 0.625rem',
            marginBottom: '0.5rem',
            background: (0, $jTCZr.CT).dangerSoft,
            border: `1px solid ${(0, $jTCZr.soft)((0, $jTCZr.C).red, 0.35)}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            fontSize: '0.6875rem',
            fontWeight: 600,
            color: (0, $jTCZr.CT).dangerInk
        }
    }, orderError), onDismissOrderError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "icon",
        className: "h-9 w-9 shrink-0",
        "aria-label": t('common.actions.close'),
        onClick: onDismissOrderError,
        style: {
            color: (0, $jTCZr.CT).dangerInk
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
        size: 14,
        "aria-hidden": true
    }))), ordersLoading && orders.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fWbIA.OrdersListSkeleton), {
        count: 2,
        dense: true
    }) : orders.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-orders-empty",
        "data-state": "empty"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        title: t('visit.orders.noneRecorded')
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.375rem'
        },
        "data-testid": "visit-orders-saved",
        "data-state": "content"
    }, sortedOrders.map((order)=>{
        const inHouse = !!order.catalogId && !!inHouseCatalogIds?.has?.(order.catalogId);
        const open = (0, $ltciA.OPEN_ORDER_STATUSES).includes(order.status);
        const busy = transitioningId === order.id;
        const TypeIcon = $dcedef1256f07607$var$TYPE_ICON[order.orderType] || (0, $3FyOw.default);
        // In the clinic: one session in THIS visit, never on a process
        // step (the process panel records those) — PM-0618.
        const doneHere = (0, $7TTuK.canMarkDoneHere)(order, {
            inHouse: inHouse,
            visitId: visitId,
            visitOnline: visitOnline
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: order.id,
            "data-testid": `visit-order-card-${order.id}`,
            "data-status": order.status,
            ...inHouse ? {
                'data-clinic-order': 'true'
            } : {},
            style: {
                background: (0, $jTCZr.C).card,
                border: `1px solid ${(0, $jTCZr.C).border}`,
                borderRadius: '0.75rem',
                padding: '0.6875rem 0.75rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(TypeIcon, {
            size: 14,
            color: (0, $jTCZr.C).textMuted,
            "aria-hidden": true,
            style: {
                flexShrink: 0
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1,
                minWidth: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.8125rem',
                fontWeight: 600,
                color: (0, $jTCZr.C).textPrimary,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            }
        }, order.description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.375rem',
                flexWrap: 'wrap',
                marginTop: '0.125rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.5625rem',
                color: (0, $jTCZr.C).textMuted
            }
        }, (0, $6xvbB.ORDER_TYPE_FA)(t)[order.orderType] || order.orderType), order.code && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "ltr",
            style: {
                fontSize: '0.5625rem',
                color: (0, $jTCZr.C).textMuted,
                fontFamily: 'ui-monospace, monospace'
            }
        }, order.code), inHouse && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.5625rem',
                fontWeight: 700,
                padding: '0.0625rem 0.3125rem',
                borderRadius: '0.25rem',
                background: (0, $jTCZr.CT).accentSoft,
                color: (0, $jTCZr.CT).accentInk
            }
        }, t('visit.orders.thisClinic')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.InsurerListChip), {
            drug: {
                id: order.id
            },
            size: "0.5625rem",
            listed: (0, $6xvbB.orderTaminListed)(order, catalogResolved, insurer),
            testid: `visit-order-coverage-${order.id}`,
            hint: t('visit.orders.outTaminHint')
        }), order.urgency && order.urgency !== 'routine' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.5625rem',
                fontWeight: 700,
                padding: '0.0625rem 0.3125rem',
                borderRadius: '0.25rem',
                background: order.urgency === 'stat' ? (0, $jTCZr.C).redLight : (0, $jTCZr.C).amberLight,
                color: order.urgency === 'stat' ? (0, $jTCZr.CT).dangerInk : (0, $jTCZr.CT).warnInk
            }
        }, order.urgency === 'stat' ? t('common.urgency.stat') : t('common.urgency.urgent')))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '0.125rem',
                flexShrink: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aQGDs.OrderStageChip), {
            order: order,
            compact: true,
            testid: `visit-order-stage-${order.id}`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aQGDs.OrderBookingLine), {
            order: order,
            compact: true,
            testid: `visit-order-booking-${order.id}`
        }))), order.notes && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.625rem',
                color: (0, $jTCZr.C).textMuted,
                marginTop: '0.25rem'
            }
        }, order.notes), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                marginTop: '0.25rem',
                display: 'flex',
                flexDirection: 'column',
                gap: '0.125rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aQGDs.OrderWhenCaption), {
            order: order,
            inHouse: inHouse || order.performedHere === true,
            visitOnline: visitOnline,
            compact: true,
            testid: `visit-order-when-${order.id}`
        }), (order.sessionCount || 0) > 1 && (0, $7TTuK.sessionInVisit)(order, visitId) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aQGDs.SessionStatusChip), {
            session: (0, $7TTuK.sessionInVisit)(order, visitId),
            compact: true,
            prefix: t('visit.services.session', {
                n: formatNumber((0, $7TTuK.sessionInVisit)(order, visitId).sessionNo)
            }),
            testid: `visit-order-session-${order.id}`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aQGDs.OrderDateLine), {
            order: order,
            compact: true,
            erxLine: (0, $3O5pt.erxStateForOrder)(order, erxIndex),
            onSave: onChangeOrderDate || undefined
        })), open && (doneHere || order.status === 'pending') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                gap: '0.375rem',
                marginTop: '0.5rem'
            }
        }, doneHere && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "subtle",
            size: "sm",
            className: "min-h-11 gap-1",
            "data-testid": `visit-order-done-${order.id}`,
            title: t('visit.orders.markDoneHint'),
            disabled: busy,
            onClick: ()=>onCompleteOrder?.(order.id)
        }, busy ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
            size: 12
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
            size: 13,
            "aria-hidden": true
        }), t('visit.orders.markDoneHere')), order.status === 'pending' && onCancelOrder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            size: "sm",
            className: "min-h-11",
            "data-testid": `visit-order-cancel-${order.id}`,
            disabled: busy,
            onClick: ()=>onCancelOrder(order),
            style: {
                color: (0, $jTCZr.CT).dangerInk
            }
        }, t('common.actions.cancel'))));
    }))));
};
var $dcedef1256f07607$export$2e2bcd8739ae039 = $dcedef1256f07607$var$MobileVisitOrders;

});
parcelRegister("9Fbsf", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1d8c0bbf580ccf5$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $d1d8c0bbf580ccf5$export$a2387ed3b5d536eb = {
    name: "share-2",
    size: 24,
    node: [
        [
            "circle",
            {
                cx: "18",
                cy: "5",
                r: "3",
                key: "gq8acd"
            }
        ],
        [
            "circle",
            {
                cx: "6",
                cy: "12",
                r: "3",
                key: "w7nqdw"
            }
        ],
        [
            "circle",
            {
                cx: "18",
                cy: "19",
                r: "3",
                key: "1xt0gg"
            }
        ],
        [
            "line",
            {
                x1: "8.59",
                x2: "15.42",
                y1: "13.51",
                y2: "17.49",
                key: "47mynk"
            }
        ],
        [
            "line",
            {
                x1: "15.41",
                x2: "8.59",
                y1: "6.51",
                y2: "10.49",
                key: "1n3mei"
            }
        ]
    ]
};
$d1d8c0bbf580ccf5$export$a2387ed3b5d536eb.node;
const $d1d8c0bbf580ccf5$export$2e2bcd8739ae039 = (0, $9QBug.default)($d1d8c0bbf580ccf5$export$a2387ed3b5d536eb);

});

parcelRegister("aQGDs", function(module, exports) {

$parcel$export(module.exports, "OrderDateChoice", () => $f0ff2da2585b9877$export$ad5426eabe3a3d3a);
$parcel$export(module.exports, "OrderDateLine", () => $f0ff2da2585b9877$export$750cfbeea572981d);
$parcel$export(module.exports, "OrderStageChip", () => $f0ff2da2585b9877$export$ff86f2c49a478e53);
$parcel$export(module.exports, "OrderBookingLine", () => $f0ff2da2585b9877$export$fac4bc3ea91c57a7);
$parcel$export(module.exports, "OrderWhenCaption", () => $f0ff2da2585b9877$export$d8767583bc386e7f);
$parcel$export(module.exports, "SessionStatusChip", () => $f0ff2da2585b9877$export$eaaf2b2fea64c90f);

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $4Qco3 = parcelRequire("4Qco3");
var $hZDga = parcelRequire("hZDga");

var $jTCZr = parcelRequire("jTCZr");

var $6lig1 = parcelRequire("6lig1");
var $aGlWN = parcelRequire("aGlWN");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $feEcD = parcelRequire("feEcD");

var $ltciA = parcelRequire("ltciA");
// ─────────────────────────────────────────────────────────────────────────────
// «تاریخ انجام» and «مرحلهٔ دستور» on screen (PM-0634, docs/ORDER_DATE_AND_STAGE_PLAN.md).
//
//   OrderDateChoice  the order form's choice, beside «فوریت» — applied to every
//                    item picked, as urgency is (lib/orderDate for the rules);
//   OrderDateLine    a row's «تاریخ انجام: …», with its change while the order is
//                    open and not at the insurer — and, locked, why;
//   OrderStageChip   the row's stage (constants/statuses `orderStageColors`);
//   OrderBookingLine «نوبت: …», the booking the stage is waiting on;
//   OrderWhenCaption where an in-house order will be done — this visit (and its
//                    invoice), a later one, or an in-person one (PM-0618);
//   SessionStatusChip one session's status (`sessionStatusColors`, PM-0618).
//
// Shared by the desktop visit room, the phone and the record so a row says the
// same thing on all of them. Colours from the token module, as ErxLineState's:
// never the visit's CSS variables, which a panel theme can override.
// ─────────────────────────────────────────────────────────────────────────────
/** One preset as a button: pressed when chosen. 36 px on the desktop form, 44 on a phone. */ function $f0ff2da2585b9877$var$PresetButton({ label: label, pressed: pressed, onClick: onClick, height: height, testid: testid }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        "aria-pressed": pressed,
        onClick: onClick,
        "data-testid": testid,
        style: {
            height: height,
            padding: '0 10px',
            borderRadius: 8,
            fontFamily: 'inherit',
            fontSize: '0.75rem',
            whiteSpace: 'nowrap',
            cursor: 'pointer',
            fontWeight: pressed ? 700 : 500,
            border: `1px solid ${pressed ? (0, $jTCZr.CT).accent : (0, $jTCZr.CT).border}`,
            background: pressed ? (0, $jTCZr.CT).accentSoft : (0, $jTCZr.CT).surface,
            color: pressed ? (0, $jTCZr.CT).accentInk : (0, $jTCZr.CT).ink2
        }
    }, label);
}
function $f0ff2da2585b9877$export$ad5426eabe3a3d3a({ value: value, onChange: onChange, pickerHeight: pickerHeight = 36, testid: testid = 'visit-order-date' }) {
    const { t: t } = (0, $LNQP4.default)();
    const choice = value || {
        preset: 'TODAY',
        date: ''
    };
    const problem = (0, $feEcD.orderDateProblem)(choice, (0, $feEcD.clinicTodayIso)());
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        role: "group",
        "aria-label": t('visit.orders.date.label'),
        "data-testid": testid,
        "data-value": choice.preset,
        style: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: 4
        }
    }, (0, $feEcD.ORDER_DATE_PRESETS).map((p)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f0ff2da2585b9877$var$PresetButton, {
            key: p,
            label: t(`visit.orders.date.${p}`),
            pressed: choice.preset === p,
            onClick: ()=>onChange({
                    ...choice,
                    preset: p
                }),
            height: pickerHeight,
            testid: `${testid}-${p}`
        }))), choice.preset === 'CUSTOM' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 4,
            minWidth: 0
        },
        "data-testid": `${testid}-custom`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4Qco3.default), {
        value: choice.date || '',
        onChange: (date)=>onChange({
                ...choice,
                date: date
            }),
        height: pickerHeight,
        placeholder: t('visit.orders.date.pick'),
        "aria-label": t('visit.orders.date.label'),
        "aria-invalid": problem === 'pastDate' || undefined,
        "data-testid": `${testid}-picker`
    }), problem === 'pastDate' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        role: "alert",
        "data-testid": `${testid}-past`,
        style: {
            fontSize: '0.6875rem',
            color: (0, $jTCZr.CT).dangerInk
        }
    }, t('visit.orders.date.past'))));
}
function $f0ff2da2585b9877$export$750cfbeea572981d({ order: order, erxLine: erxLine = null, onSave: onSave, compact: compact = false, testid: testid }) {
    const { t: t, formatDate: formatDate } = (0, $LNQP4.default)();
    const [editing, setEditing] = (0, $acw62.useState)(false);
    const [draft, setDraft] = (0, $acw62.useState)('');
    const [busy, setBusy] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    const day = (0, $feEcD.orderDayOf)(order);
    if (!order) return null;
    const tid = testid || `visit-order-date-${order.id}`;
    const lock = onSave ? (0, $feEcD.orderDateLock)(order, erxLine) : null;
    const lockText = lock ? t(`visit.orders.date.locked.${lock}`) : undefined;
    const shown = day ? formatDate((0, $feEcD.dayInstant)(day), 'medium') : "\u2014";
    const today = (0, $feEcD.clinicTodayIso)();
    const past = !!draft && draft < today;
    const save = async ()=>{
        if (!draft || past || busy) return;
        if (draft === order.performedDate) {
            setEditing(false);
            return;
        }
        setBusy(true);
        setError(null);
        const failed = await onSave(order.id, draft);
        setBusy(false);
        if (failed) setError(failed);
        else setEditing(false);
    };
    const text = {
        fontSize: compact ? '0.625rem' : '0.75rem',
        color: (0, $jTCZr.CT).ink2,
        lineHeight: compact ? 1.6 : '22px'
    };
    if (editing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": `${tid}-editor`,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            flexWrap: 'wrap',
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            ...text,
            fontWeight: 600
        }
    }, t('visit.orders.date.label')), (0, $feEcD.ORDER_DATE_MONTH_PRESETS).map((p)=>{
        const d = (0, $feEcD.presetDay)(p, today);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f0ff2da2585b9877$var$PresetButton, {
            key: p,
            label: t(`visit.orders.date.${p}`),
            pressed: !!d && draft === d,
            onClick: ()=>d && setDraft(d),
            height: compact ? 44 : 28,
            testid: `${tid}-${p}`
        });
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: compact ? '100%' : '11rem',
            maxWidth: '100%'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4Qco3.default), {
        value: draft,
        onChange: setDraft,
        height: compact ? 44 : 30,
        placeholder: t('visit.orders.date.pick'),
        "aria-label": t('visit.orders.date.label'),
        "aria-invalid": past || undefined,
        "data-testid": `${tid}-picker`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "subtle",
        size: "sm",
        className: compact ? 'min-h-11' : 'h-7 px-3',
        onClick: save,
        disabled: !draft || past || busy,
        "data-testid": `${tid}-save`
    }, busy ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 11,
        thickness: 2
    }) : t('common.actions.save')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        className: compact ? 'min-h-11' : 'h-7 px-3',
        onClick: ()=>{
            setEditing(false);
            setError(null);
        },
        disabled: busy,
        "data-testid": `${tid}-cancel`
    }, t('common.actions.cancel')), (past || error) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        role: "alert",
        "data-testid": `${tid}-error`,
        style: {
            ...text,
            color: (0, $jTCZr.CT).dangerInk,
            flexBasis: '100%'
        }
    }, past ? t('visit.orders.date.past') : error));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": tid,
        "data-day": day || undefined,
        "data-lock": lock || undefined,
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 4,
            flexWrap: 'wrap',
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: text,
        title: lockText
    }, t('visit.orders.date.row', {
        date: shown
    })), onSave && !lock && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        className: compact ? 'min-h-11 px-2 gap-1' : 'h-6 px-2 gap-1',
        onClick: ()=>{
            setDraft(day && day >= today ? day : today);
            setEditing(true);
        },
        "aria-label": t('visit.orders.date.edit', {
            name: order.description || ''
        }),
        "data-testid": `${tid}-edit`,
        style: {
            color: (0, $jTCZr.CT).accentInk
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aGlWN.default), {
        size: 11,
        "aria-hidden": true
    }), " ", t('visit.orders.date.change')), lock === 'registered' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": `${tid}-locked`,
        style: {
            ...text,
            color: (0, $jTCZr.CT).mute,
            display: 'inline-flex',
            alignItems: 'center',
            gap: 3
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6lig1.default), {
        size: 10,
        "aria-hidden": true
    }), " ", lockText));
}
function $f0ff2da2585b9877$export$ff86f2c49a478e53({ order: order, testid: testid, compact: compact = false, hide: hide = [], withIcon: withIcon = null }) {
    const { t: t } = (0, $LNQP4.default)();
    const stage = (0, $ltciA.orderStageOf)(order);
    const st = stage ? (0, $ltciA.orderStageColors)[stage] : null;
    if (!st || hide.includes(stage)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": testid,
        "data-stage": stage,
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 5,
            flexShrink: 0,
            whiteSpace: 'nowrap',
            fontWeight: 700,
            background: st.bg,
            color: st.text,
            ...compact ? {
                fontSize: '0.5625rem',
                padding: '0.125rem 0.4375rem',
                borderRadius: '0.25rem'
            } : {
                fontSize: '0.71875rem',
                padding: '0 10px',
                lineHeight: '24px',
                borderRadius: 20
            }
        }
    }, withIcon ? withIcon(stage) : null, t(st.labelKey));
}
function $f0ff2da2585b9877$export$fac4bc3ea91c57a7({ order: order, testid: testid, compact: compact = false }) {
    const { t: t, formatDateTime: formatDateTime } = (0, $LNQP4.default)();
    const at = (0, $ltciA.orderBookingOf)(order);
    if (!at) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": testid,
        style: {
            fontSize: compact ? '0.5625rem' : '0.6875rem',
            color: (0, $jTCZr.CT).ink2,
            whiteSpace: 'nowrap'
        }
    }, t('visit.orders.booking', {
        when: formatDateTime(at)
    }));
}
function $f0ff2da2585b9877$export$d8767583bc386e7f({ order: order, inHouse: inHouse, visitOnline: visitOnline = false, testid: testid, compact: compact = false }) {
    const { t: t, formatDate: formatDate } = (0, $LNQP4.default)();
    const when = (0, $feEcD.orderWhenOf)(order, {
        inHouse: inHouse,
        visitOnline: visitOnline,
        today: (0, $feEcD.clinicTodayIso)()
    });
    if (!when) return null;
    const date = when.date ? formatDate((0, $feEcD.dayInstant)(when.date), 'medium') : '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": testid,
        "data-when": when.key,
        style: {
            fontSize: compact ? '0.625rem' : '0.75rem',
            lineHeight: compact ? 1.6 : '20px',
            color: when.key === 'sameVisit' ? (0, $jTCZr.CT).accentInk : (0, $jTCZr.CT).ink2,
            minWidth: 0,
            overflowWrap: 'anywhere'
        }
    }, t(`common.orderWhen.${when.key}`, {
        date: date
    }));
}
function $f0ff2da2585b9877$export$eaaf2b2fea64c90f({ session: session, testid: testid, compact: compact = false, prefix: prefix = null }) {
    const { t: t } = (0, $LNQP4.default)();
    const status = (0, $ltciA.sessionStatusOf)(session);
    const st = status ? (0, $ltciA.sessionStatusColors)[status] : null;
    if (!st) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": testid,
        "data-status": status,
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 4,
            flexShrink: 0,
            whiteSpace: 'nowrap',
            fontWeight: 700,
            background: st.bg,
            color: st.text,
            opacity: st.history ? 0.75 : 1,
            textDecoration: status === 'VOIDED' ? 'line-through' : undefined,
            ...compact ? {
                fontSize: '0.5625rem',
                padding: '0.125rem 0.4375rem',
                borderRadius: '0.25rem'
            } : {
                fontSize: '0.6875rem',
                padding: '0 8px',
                lineHeight: '20px',
                borderRadius: 20
            }
        }
    }, prefix, prefix ? " \xb7 " : '', t(st.labelKey));
}

});

parcelRegister("7TTuK", function(module, exports) {

$parcel$export(module.exports, "RECORD_VISIT_SESSION", () => $5c08b794d83fd656$export$fc6100d6fd520a7b);
$parcel$export(module.exports, "VISIT_SERVICES", () => $5c08b794d83fd656$export$1a34967cb1421bc8);
$parcel$export(module.exports, "isProcessStep", () => $5c08b794d83fd656$export$98a3b6f4a9f3a404);
$parcel$export(module.exports, "sessionInVisit", () => $5c08b794d83fd656$export$eaf7a14d01db8b51);
$parcel$export(module.exports, "isOpenInVisit", () => $5c08b794d83fd656$export$1c41a53e60ade9);
$parcel$export(module.exports, "canMarkDoneHere", () => $5c08b794d83fd656$export$671ff15e6f4e49ba);
$parcel$export(module.exports, "markOrderDoneHere", () => $5c08b794d83fd656$export$2119b85eed139cf6);
// ─────────────────────────────────────────────────────────────────────────────
// «یک مراجعه، یک فاکتور» in the visit room (PM-0618,
// docs/ONE_APPOINTMENT_ONE_INVOICE_PLAN.md; build contract §7.2).
//
// Since PM-0618 an in-house order has one row per session from the moment it is
// placed, and a session is performed IN a مراجعه (an appointment). Placed for
// today in an in-person visit, its first session sits in that visit and goes on
// that visit's invoice; placed for a later day, it waits — nothing is booked.
// The server decides both (`sameVisit`, the session's `status`); this module only
// reads them, and holds the room's three writes:
//
//   «انجام شد»       recordOrderSession for ONE session in THIS visit
//                    (performer = the doctor) — never StartOrder + CompleteOrder,
//                    which closed every session of the order and billed it on a
//                    hub event into whatever invoice accounting found;
//   «پایان ویزیت»    the end-of-visit step's answers (useEndVisit.js);
//   «خدمات این مراجعه»  orders from earlier visits whose session sits here
//                    (components/visit/VisitServicesBlock.jsx).
//
// recordOrderSession answers a TreatmentStep, not the EncounterOrder a row is
// drawn from, so a success re-reads the visit's orders instead of merging it.
// ─────────────────────────────────────────────────────────────────────────────

var $eVM84 = parcelRequire("eVM84");

var $ltciA = parcelRequire("ltciA");

var $6xvbB = parcelRequire("6xvbB");

var $feEcD = parcelRequire("feEcD");
const $5c08b794d83fd656$export$fc6100d6fd520a7b = 'mutation RecordVisitSession($orderId:ID!,$appointmentId:ID,$sessionId:ID){recordOrderSession(orderId:$orderId,appointmentId:$appointmentId,sessionId:$sessionId){id status}}';
const $5c08b794d83fd656$export$1a34967cb1421bc8 = `query VisitServices($appointmentId:ID!){visitServices(appointmentId:$appointmentId){${(0, $6xvbB.CLINICAL_ORDER_FIELDS)}}}`;
const $5c08b794d83fd656$var$OPEN_ORDER = new Set([
    'pending',
    'in_progress'
]);
const $5c08b794d83fd656$var$IN_VISIT = new Set([
    'SCHEDULED',
    'IN_PROGRESS',
    'DONE'
]);
const $5c08b794d83fd656$var$OPEN_SESSION = new Set([
    'SCHEDULED',
    'IN_PROGRESS'
]);
const $5c08b794d83fd656$export$98a3b6f4a9f3a404 = (order)=>!!order?.processId;
function $5c08b794d83fd656$export$eaf7a14d01db8b51(order, visitId) {
    if (!order || !visitId) return null;
    return (order.sessions || []).find((s)=>s && String(s.appointmentId || '') === String(visitId) && $5c08b794d83fd656$var$IN_VISIT.has((0, $ltciA.sessionStatusOf)(s))) || null;
}
const $5c08b794d83fd656$export$1c41a53e60ade9 = (order, visitId)=>$5c08b794d83fd656$var$OPEN_SESSION.has((0, $ltciA.sessionStatusOf)($5c08b794d83fd656$export$eaf7a14d01db8b51(order, visitId)));
function $5c08b794d83fd656$export$671ff15e6f4e49ba(order, { inHouse: inHouse, visitId: visitId, visitOnline: visitOnline = false } = {}) {
    if (!inHouse || !order || visitOnline || $5c08b794d83fd656$export$98a3b6f4a9f3a404(order) || !$5c08b794d83fd656$var$OPEN_ORDER.has(order.status)) return false;
    const here = $5c08b794d83fd656$export$eaf7a14d01db8b51(order, visitId);
    if (here) return (0, $ltciA.sessionStatusOf)(here) !== 'DONE';
    const rows = order.sessions || [];
    return !rows.length || rows.some((s)=>(0, $ltciA.sessionStatusOf)(s) === 'REQUESTED');
}
async function $5c08b794d83fd656$export$2119b85eed139cf6({ order: order, visitId: visitId }) {
    const session = $5c08b794d83fd656$export$eaf7a14d01db8b51(order, visitId);
    await (0, $eVM84.bffMutation)($5c08b794d83fd656$export$fc6100d6fd520a7b, {
        orderId: order.id,
        appointmentId: visitId,
        sessionId: session?.id || null
    });
    try {
        const data = await (0, $eVM84.bffQuery)((0, $6xvbB.LIST_CLINICAL_ORDERS), {
            appointmentId: visitId
        });
        return {
            orders: data?.listOrders || []
        };
    } catch  {
        return {
            orders: null
        };
    }
}

});

parcelRegister("3O5pt", function(module, exports) {

$parcel$export(module.exports, "registeredStatus", () => $2c5a3cdef49d8209$export$2dd174cd9ab2c4b7);
$parcel$export(module.exports, "correctionPossible", () => $2c5a3cdef49d8209$export$f71c8410924ea136);
$parcel$export(module.exports, "pendingCorrections", () => $2c5a3cdef49d8209$export$5977fd636411c9b9);
$parcel$export(module.exports, "erxChipState", () => $2c5a3cdef49d8209$export$25dd885c960a3a43);
$parcel$export(module.exports, "indexErxStatus", () => $2c5a3cdef49d8209$export$7aaa1df6f77403de);
$parcel$export(module.exports, "erxStateForRx", () => $2c5a3cdef49d8209$export$98676285bdb35e36);
$parcel$export(module.exports, "erxStateForOrder", () => $2c5a3cdef49d8209$export$be2f84bce07e3ba5);
$parcel$export(module.exports, "erxRemovedLines", () => $2c5a3cdef49d8209$export$4ddbdca59aee3c1a);
// ─────────────────────────────────────────────────────────────────────────────
// «اصلاح نسخهٔ ثبت‌شده» — what the visit screen makes of `ePrescriptionStatus`
// (K1, 2026-10-04; docs/eprescription/CORRECTION.md).
//
// The status says, for a visit, whether anything of it is registered with an
// insurer, and per line whether that line is at the insurer as it is now
// (REGISTERED), at the insurer in an older form (CHANGED), written after the
// registration (ADDED), or gone from the record while the insurer still holds it
// (REMOVED). The screen turns that into a chip per line and a count on the
// «ارسال … به بیمه» buttons. Those decisions live here, as plain functions, so
// the visit's نسخه, its دستورات and the past-visit sheet cannot answer them
// differently.
// ─────────────────────────────────────────────────────────────────────────────
parcelRequire("kQnM4");
var $4UJrq = parcelRequire("4UJrq");
const $2c5a3cdef49d8209$export$bc7c25e7495df5a4 = [
    'REGISTERED',
    'CHANGED',
    'ADDED',
    'REMOVED'
];
const $2c5a3cdef49d8209$export$e932fff06946488f = [
    'DRUGS',
    'SERVICES'
];
function $2c5a3cdef49d8209$export$2dd174cd9ab2c4b7(status) {
    return status && status.enabled && status.registered ? status : null;
}
function $2c5a3cdef49d8209$export$f71c8410924ea136(status) {
    const s = $2c5a3cdef49d8209$export$2dd174cd9ab2c4b7(status);
    return !!s && !s.final && !s.expired;
}
const $2c5a3cdef49d8209$var$partOf = (line)=>line?.part || (line?.orderId ? 'SERVICES' : 'DRUGS');
const $2c5a3cdef49d8209$var$partStatus = (status, part)=>(status?.parts || []).find((p)=>p?.part === part) || null;
function $2c5a3cdef49d8209$export$5977fd636411c9b9(status) {
    const none = {
        ALL: 0,
        DRUGS: 0,
        SERVICES: 0
    };
    if (!$2c5a3cdef49d8209$export$f71c8410924ea136(status)) return none;
    const part = (p)=>{
        const s = $2c5a3cdef49d8209$var$partStatus(status, p);
        return s?.registered ? Math.max(0, s.pendingCount || 0) : 0;
    };
    return {
        ALL: Math.max(0, status.pendingCount || 0),
        DRUGS: part('DRUGS'),
        SERVICES: part('SERVICES')
    };
}
function $2c5a3cdef49d8209$export$25dd885c960a3a43(status, { incomplete: incomplete = 0, empty: empty = false } = {}) {
    const s = $2c5a3cdef49d8209$export$2dd174cd9ab2c4b7(status);
    if (!s) return {
        kind: 'send',
        tone: empty ? 'muted' : 'idle',
        pending: 0,
        part: null,
        incomplete: Math.max(0, incomplete || 0)
    };
    const pending = $2c5a3cdef49d8209$export$5977fd636411c9b9(status).ALL;
    const drugs = !!$2c5a3cdef49d8209$var$partStatus(s, 'DRUGS')?.registered;
    const services = !!$2c5a3cdef49d8209$var$partStatus(s, 'SERVICES')?.registered;
    const part = drugs && !services ? 'DRUGS' : services && !drugs ? 'SERVICES' : 'ALL';
    if (pending > 0) return {
        kind: 'pending',
        tone: 'warn',
        pending: pending,
        part: part,
        incomplete: 0
    };
    return {
        kind: 'registered',
        tone: 'good',
        pending: 0,
        part: part,
        incomplete: 0
    };
}
function $2c5a3cdef49d8209$export$7aaa1df6f77403de(status) {
    const s = $2c5a3cdef49d8209$export$2dd174cd9ab2c4b7(status);
    if (!s) return null;
    const byMedication = new Map();
    const byOrder = new Map();
    for (const line of s.lines || []){
        if (!line || !$2c5a3cdef49d8209$export$bc7c25e7495df5a4.includes(line.state)) continue;
        if (line.medicationId != null && line.medicationId !== '') byMedication.set(String(line.medicationId), line);
        if (line.orderId != null && line.orderId !== '') byOrder.set(String(line.orderId), line);
    }
    const registered = Object.fromEntries($2c5a3cdef49d8209$export$e932fff06946488f.map((p)=>[
            p,
            !!$2c5a3cdef49d8209$var$partStatus(s, p)?.registered
        ]));
    return {
        status: s,
        lines: (s.lines || []).filter(Boolean),
        byMedication: byMedication,
        byOrder: byOrder,
        registered: registered
    };
}
function $2c5a3cdef49d8209$export$98676285bdb35e36(item, index) {
    if (!index || !item) return null;
    if (item.medicationId) return index.byMedication.get(String(item.medicationId)) || null;
    return index.registered.DRUGS ? {
        part: 'DRUGS',
        state: 'ADDED',
        name: ''
    } : null;
}
function $2c5a3cdef49d8209$export$be2f84bce07e3ba5(order, index) {
    if (!index || !order?.id) return null;
    return index.byOrder.get(String(order.id)) || null;
}
function $2c5a3cdef49d8209$export$4ddbdca59aee3c1a(index, part, presentIds = []) {
    if (!index) return [];
    const present = new Set([
        ...presentIds
    ].filter((id)=>id != null).map(String));
    return index.lines.filter((l)=>{
        if (l.state !== 'REMOVED' || $2c5a3cdef49d8209$var$partOf(l) !== part) return false;
        const id = part === 'SERVICES' ? l.orderId : l.medicationId;
        return !(id != null && present.has(String(id)));
    });
}
// ── The month a prescription can be corrected in ────────────────────────────
//
// op-naji allows a correction for one month after the visit. The BFF decides it
// (CORRECTION.md Rules §3, EXPIRED: later than `until`); the screen only needs it
// to offer «اصلاح نسخه» on a past visit, and reads it the same way — the visit's
// time plus one JALAALI month, in Iran, at the visit's own hour: the same day of
// the next month, or that month's last day when it is shorter (31 شهریور → 30 مهر).
const $2c5a3cdef49d8209$var$DAY_MS = 86400000;
const $2c5a3cdef49d8209$var$toMs = (d)=>d instanceof Date ? d.getTime() : new Date(d ?? NaN).getTime();
function $2c5a3cdef49d8209$export$c160d8a2cdbe6390(visitDate) {
    const ms = $2c5a3cdef49d8209$var$toMs(visitDate);
    if (!Number.isFinite(ms)) return null;
    const j = (0, $4UJrq.msToJalali)(ms + (0, $4UJrq.IRAN_OFFSET_MS));
    if (!j) return null;
    const index = j.y * 12 + (j.m - 1) + 1;
    const y = Math.floor(index / 12);
    const m = index - y * 12 + 1;
    return {
        y: y,
        m: m,
        d: Math.min(j.d, (0, $4UJrq.jDaysInMonth)(y, m))
    };
}
function $2c5a3cdef49d8209$export$66408e4557608948(visitDate) {
    const ms = $2c5a3cdef49d8209$var$toMs(visitDate);
    const last = $2c5a3cdef49d8209$export$c160d8a2cdbe6390(visitDate);
    if (!last) return null;
    const local = ms + (0, $4UJrq.IRAN_OFFSET_MS);
    const timeOfDay = (local % $2c5a3cdef49d8209$var$DAY_MS + $2c5a3cdef49d8209$var$DAY_MS) % $2c5a3cdef49d8209$var$DAY_MS;
    return new Date((0, $4UJrq.jalaliToMs)(last.y, last.m, last.d) + timeOfDay - (0, $4UJrq.IRAN_OFFSET_MS));
}
function $2c5a3cdef49d8209$export$e0cd0eea0dc73912(visitDate, now = Date.now()) {
    const deadline = $2c5a3cdef49d8209$export$66408e4557608948(visitDate);
    const nowMs = now instanceof Date ? now.getTime() : now;
    return !!deadline && Number.isFinite(nowMs) && nowMs <= deadline.getTime();
}

});

parcelRegister("d2Zvn", function(module, exports) {

$parcel$export(module.exports, "suggestedOrderRows", () => $027388f7462935a9$export$1565dcb2999a6fb9);
$parcel$export(module.exports, "isAlreadyOrdered", () => $027388f7462935a9$export$ce329d894bbd1d2b);
// ── AI-suggested orders ──────────────────────────────────────────────────────
//
// «پیشنهاد درخواست» answers with catalogue rows: the AI service keeps only names
// it finds in the clinical order catalogue and hands back that row's own code —
// LOINC for a lab, CPT for a procedure (prescription_agent.py
// `suggest_doctor_orders`). The desktop built its rows without the code and
// created the order without it, so an AI-suggested lab reached the record and the
// insurer with no service code; the phone's live add path dropped it the same
// way. Both now carry it.
/**
 * The desktop «دستورات» suggestion rows, unranked, each carrying the code its
 * catalogue row gave it. `loincCode` is set only for a lab — the one code that
 * IS a LOINC — exactly as the catalogue picker sets it.
 */ const $027388f7462935a9$export$1565dcb2999a6fb9 = (s)=>[
        ...(s?.labTests || []).map((test)=>({
                key: `lab:${test.testName}`,
                orderType: 'lab',
                name: test.testName,
                reason: test.reason,
                urgency: test.urgency || 'routine',
                code: test.loincCode || '',
                loincCode: test.loincCode || ''
            })),
        ...(s?.imagingStudies || []).map((x)=>({
                key: `imaging:${x.studyType}`,
                orderType: 'imaging',
                name: x.studyType,
                reason: [
                    x.bodyPart,
                    x.reason
                ].filter(Boolean).join(" \u2014 "),
                urgency: x.urgency || 'routine',
                code: '',
                loincCode: ''
            })),
        ...(s?.procedureOrders || []).map((p)=>({
                key: `procedure:${p.name}`,
                orderType: 'procedure',
                name: p.name,
                reason: p.reason,
                urgency: p.urgency || 'routine',
                code: p.code || '',
                loincCode: ''
            }))
    ];
const $027388f7462935a9$export$ce329d894bbd1d2b = (orders, orderType, name)=>{
    const want = String(name || '').trim();
    if (!want) return false;
    return (orders || []).some((o)=>o && o.status !== 'cancelled' && (!orderType || !o.orderType || o.orderType === orderType) && String(o.description || '').trim() === want);
};

});


parcelRegister("gLLxa", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7965145b8773dba$export$2e2bcd8739ae039);
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");
parcelRequire("7sS0P");
var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");

var $chm1L = parcelRequire("chm1L");
// The clinical-copilot entry — one quiet row: «دستیار» with its count, and the
// dictation mic. It used to be a dark floating slab with a pulsing dot that
// streamed the top suggestion's title, which put AI output in the doctor's eye
// line on every screen of the visit. The assistant is opened, not broadcast:
// the count says there is something to read, the sheet is where it is read.
// The mic is not here: «پایش بالینی» is its own control in the visit's top
// strip (MobileVisitMonitorButton), and one control per action is the rule.
//
// It shares the footer's ONE row with «پایان ویزیت» (PM-0044): it takes the
// width that is left, and says how many suggestions are waiting in its
// accessible name as well as in the chip.
const $d7965145b8773dba$var$MobileVisitCopilotBar = ({ count: count = 0, onOpen: onOpen })=>{
    const { t: t, formatDigits: formatDigits } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-copilot-bar",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        onClick: onOpen,
        "data-testid": "visit-copilot-open",
        "aria-label": count > 0 ? `${t('visit.copilot.open')} \u{2014} ${formatDigits(count)}` : t('visit.copilot.open'),
        className: "flex-1 min-w-0 h-11 min-h-11 justify-start gap-2 rounded-lg px-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $chm1L.default), {
        size: 15,
        "aria-hidden": true,
        style: {
            color: (0, $jTCZr.CT).accentInk,
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.8125rem',
            fontWeight: 600,
            color: (0, $jTCZr.C).textPrimary
        }
    }, t('visit.copilot.assistant')), count > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "visit-copilot-count",
        style: {
            fontSize: '0.6875rem',
            fontWeight: 700,
            padding: '0.0625rem 0.4375rem',
            borderRadius: '0.75rem',
            background: (0, $jTCZr.CT).accentSoft,
            color: (0, $jTCZr.CT).accentInk
        }
    }, formatDigits(count))));
};
var $d7965145b8773dba$export$2e2bcd8739ae039 = $d7965145b8773dba$var$MobileVisitCopilotBar;

});

parcelRegister("io25J", function(module, exports) {

$parcel$export(module.exports, "default", () => $9331b3f7d9a9e1d6$export$2e2bcd8739ae039);
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");
parcelRequire("7sS0P");
var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $cZOyb = parcelRequire("cZOyb");
var $aJ1FU = parcelRequire("aJ1FU");
var $hZDga = parcelRequire("hZDga");

var $2WFPf = parcelRequire("2WFPf");
var $6OGKD = parcelRequire("6OGKD");

var $lTG78 = parcelRequire("lTG78");
var $jTCZr = parcelRequire("jTCZr");

var $eAIjx = parcelRequire("eAIjx");

var $3EzBq = parcelRequire("3EzBq");

var $1yr2B = parcelRequire("1yr2B");
// The clinical-copilot BottomSheet (§6 default overlay): three tabs — نکات بالینی
// (live hints + clinical-insight cards), تشخیص افتراقی (the differential) and
// پرسش (AI Q&A) — over a docked composer. All AI output is badged (§13.3); accept/reject
// and the ask handler live in the screen and arrive as callbacks.
//
// The insight feed is decision support, NOT an order pad: no test, imaging or
// drug card reaches it. Those are placed in «دستورات» and «نسخه». Note
// completion is not here either — it lives in the note's own section
// (MobileVisitSoap), so the feed is purely something to read.
const $9331b3f7d9a9e1d6$var$SOURCE_LBL = (t)=>({
        rule_engine_static: 'Rule Engine',
        rule_engine_rxnorm: 'RxNorm',
        rule_engine_contraindication: t('visit.rx.contraindication'),
        rule_engine_allergy: t('patient.allergies.title'),
        rule_engine_openfda: 'FDA',
        llm: 'AI'
    });
const $9331b3f7d9a9e1d6$var$TranscriptRow = ({ line: line })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: '0.5rem',
            alignItems: 'flex-start',
            marginBottom: '0.375rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.5625rem',
            fontWeight: 700,
            padding: '0.0625rem 0.375rem',
            borderRadius: '0.1875rem',
            background: line.role === 'dr' ? (0, $jTCZr.CT).accentSoft : (0, $jTCZr.CT).surface2,
            color: line.role === 'dr' ? (0, $jTCZr.CT).accentInk : (0, $jTCZr.C).textSecondary,
            flexShrink: 0,
            marginTop: '0.125rem'
        }
    }, line.spk), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: (0, $jTCZr.C).textSecondary,
            flex: 1,
            minWidth: 0,
            fontSize: '0.75rem',
            lineHeight: 1.6
        }
    }, line.text));
const $9331b3f7d9a9e1d6$var$SuggestionCard = ({ s: s })=>{
    const { t: t } = (0, $LNQP4.default)();
    const warn = s.level === 'warn';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: (0, $jTCZr.C).card,
            border: `1px solid ${warn ? (0, $jTCZr.soft)((0, $jTCZr.C).amber, 0.5) : (0, $jTCZr.C).border}`,
            borderRadius: '0.625rem',
            padding: '0.75rem 0.8125rem',
            marginBottom: '0.625rem',
            ...warn ? {
                background: `linear-gradient(180deg, ${(0, $jTCZr.C).amberLight}, ${(0, $jTCZr.C).card} 60%)`
            } : null
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            marginBottom: '0.375rem',
            flexWrap: 'wrap'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.5625rem',
            fontWeight: 700,
            letterSpacing: '0.03em',
            padding: '0.125rem 0.4375rem',
            borderRadius: '0.25rem',
            textTransform: 'uppercase',
            background: warn ? (0, $jTCZr.C).amberLight : (0, $jTCZr.CT).accentSoft,
            color: warn ? (0, $jTCZr.CT).warnInk : (0, $jTCZr.CT).accentInk
        }
    }, s.kind), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lTG78.AiBadge), {
        style: {
            padding: '0.0625rem 0.375rem'
        }
    }), s.conf != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            marginInlineStart: 'auto',
            fontSize: '0.6875rem',
            color: (0, $jTCZr.C).textMuted,
            fontFamily: 'ui-monospace, monospace'
        }
    }, Math.round(s.conf * 100), "%")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.8125rem',
            fontWeight: 600,
            color: (0, $jTCZr.C).textPrimary,
            marginBottom: '0.25rem',
            lineHeight: 1.4
        }
    }, s.title), s.body && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.75rem',
            color: (0, $jTCZr.C).textSecondary,
            lineHeight: 1.6,
            whiteSpace: 'pre-line'
        }
    }, s.body), s.evidence && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: '0.5rem',
            padding: '0.4375rem 0.5625rem',
            borderRadius: '0.375rem',
            background: (0, $jTCZr.CT).surface2,
            border: `1px dashed ${(0, $jTCZr.C).border}`,
            fontSize: '0.6875rem',
            color: (0, $jTCZr.C).textMuted,
            lineHeight: 1.55
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("b", {
        style: {
            color: (0, $jTCZr.C).textSecondary
        }
    }, t('visit.copilot.evidence'), " "), s.evidence, s._citations?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: '0.3125rem',
            marginTop: '0.375rem'
        }
    }, s._citations.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
            key: c.pmid,
            href: c.url,
            target: "_blank",
            rel: "noopener noreferrer",
            title: c.title,
            style: {
                fontSize: '0.625rem',
                fontWeight: 500,
                padding: '0.125rem 0.4375rem',
                borderRadius: '0.75rem',
                background: (0, $jTCZr.CT).accentSoft,
                color: (0, $jTCZr.CT).accentInk,
                textDecoration: 'none'
            }
        }, "PubMed ", c.pmid, " \xb7 ", c.journal, " ", c.year)))), s._source && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'inline-block',
            marginTop: '0.375rem',
            fontSize: '0.5625rem',
            fontWeight: 700,
            padding: '0.0625rem 0.375rem',
            borderRadius: '0.25rem',
            background: (0, $jTCZr.CT).surface2,
            color: (0, $jTCZr.C).textSecondary
        }
    }, $9331b3f7d9a9e1d6$var$SOURCE_LBL(t)[s._source] || s._source));
};
const $9331b3f7d9a9e1d6$var$MobileVisitCopilotSheet = ({ open: open, onClose: onClose, tab: tab, onTab: onTab, suggestions: suggestions, transcriptLines: transcriptLines, messages: messages, chatLoading: chatLoading, recsLoading: recsLoading, quickQs: quickQs, aiInput: aiInput, onAiInput: onAiInput, onAsk: onAsk, recsError: recsError, recsRan: recsRan, onRunRecs: onRunRecs, visitCoins: visitCoins = 0, coinEntries: coinEntries = [], differentialPanel: // «تشخیص افتراقی» — the differential's one home on the phone. The screen
// renders the panel (it owns ~28 handlers and the polling) and hands it in
// as an element, so this sheet only decides WHEN it shows.
differentialPanel = null, diffCount: diffCount = 0, isTabVisible: // The doctor's copilot preference, mapped onto this sheet's tab ids by
// screens/Visit/visitLayout.js. Absent, every tab shows — the sheet has no
// opinion of its own. The tabs are the desktop copilot's three, and nothing
// else: a «گفتگو» tab that showed the whole transcript used to sit between
// them and was removed. What it displayed is not lost — «نکات بالینی» still
// carries the live lines as they arrive, which is where a doctor reads them
// while the visit is running rather than scrolling a transcript.
isTabVisible = ()=>true })=>{
    const { t: t, formatDigits: formatDigits } = (0, $LNQP4.default)();
    const [ledgerOpen, setLedgerOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // Biggest spender first — the breakdown is read to find where the Parseh went.
    // Same rows the desktop popover shows, from the same ledger entries; only the
    // shape differs, because a hover popover has no meaning on a phone.
    const ledgerRows = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const labelKeyById = Object.fromEntries((0, $3EzBq.PRICE_LIST).map((p)=>[
                p.id,
                p.labelKey
            ]));
        return [
            ...coinEntries
        ].filter((e)=>e && e.coins > 0).sort((a, b)=>b.coins - a.coins).map((e)=>({
                ...e,
                label: labelKeyById[e.id] ? t(labelKeyById[e.id]) : e.id
            }));
    }, [
        coinEntries,
        t
    ]);
    // A hidden tab stays reachable while it is the ACTIVE one — a programmatic
    // jump into it must still show the doctor where they are.
    const TABS = [
        {
            id: 'hints',
            label: t('visit.copilot.clinicalNotes'),
            badge: suggestions.length
        },
        ...differentialPanel ? [
            {
                id: 'diff',
                label: t('visit.copilot.differential'),
                badge: diffCount
            }
        ] : [],
        {
            id: 'ask',
            label: t('visit.copilot.ask')
        }
    ].filter((item)=>isTabVisible(item.id) || tab === item.id);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: open,
        onClose: onClose,
        title: t('visit.copilot.title'),
        closeLabel: t('common.actions.close')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-copilot-sheet",
        style: {
            display: 'flex',
            flexDirection: 'column'
        }
    }, visitCoins > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginBottom: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            justifyContent: 'flex-end'
        }
    }, ledgerRows.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        className: "min-h-11 gap-1 px-1",
        "data-testid": "visit-coin-ledger-toggle",
        "aria-expanded": ledgerOpen,
        onClick: ()=>setLedgerOpen((o)=>!o)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eAIjx.default), {
        cost: visitCoins,
        prefix: t('visit.header.thisVisitPrefix'),
        title: t('visit.header.coinsSpent')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2WFPf.default), {
        size: 13,
        "aria-hidden": true,
        style: {
            color: (0, $jTCZr.C).textMuted,
            transform: ledgerOpen ? 'rotate(180deg)' : 'none',
            transition: 'transform .2s'
        }
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eAIjx.default), {
        cost: visitCoins,
        prefix: t('visit.header.thisVisitPrefix'),
        title: t('visit.header.coinsSpent')
    })), ledgerOpen && ledgerRows.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-coin-ledger",
        style: {
            marginTop: '0.375rem',
            background: (0, $jTCZr.CT).surface2,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: '0.625rem',
            padding: '0.5rem 0.625rem'
        }
    }, ledgerRows.map((row)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: row.id,
            "data-testid": `visit-coin-ledger-row-${row.id}`,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                padding: '0.25rem 0'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                flex: 1,
                minWidth: 0,
                fontSize: '0.71875rem',
                color: (0, $jTCZr.C).textSecondary
            }
        }, row.label), row.count > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.625rem',
                color: (0, $jTCZr.C).textMuted
            }
        }, "\xd7", formatDigits(row.count)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.75rem',
                fontWeight: 700,
                color: (0, $jTCZr.C).textPrimary
            }
        }, formatDigits(row.coins)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: '0.375rem',
            padding: '0.25rem',
            background: (0, $jTCZr.CT).surface2,
            borderRadius: '0.625rem',
            marginBottom: '0.75rem'
        }
    }, TABS.map((item)=>{
        const on = tab === item.id;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            key: item.id,
            variant: "ghost",
            onClick: ()=>onTab(item.id),
            "data-testid": `visit-copilot-tab-${item.id}`,
            "aria-pressed": on,
            className: "flex-1 min-h-11 rounded-md gap-1",
            style: {
                background: on ? (0, $jTCZr.C).card : 'transparent',
                color: on ? (0, $jTCZr.C).textPrimary : (0, $jTCZr.C).textMuted,
                fontWeight: on ? 700 : 500
            }
        }, item.label, item.badge > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.625rem',
                fontWeight: 700,
                padding: '0.0625rem 0.3125rem',
                borderRadius: '0.75rem',
                background: on ? (0, $jTCZr.CT).accentSoft : (0, $jTCZr.C).border,
                color: on ? (0, $jTCZr.CT).accentInk : (0, $jTCZr.C).textSecondary
            }
        }, item.badge));
    })), tab === 'hints' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, transcriptLines.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: (0, $jTCZr.CT).surface2,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: '0.625rem',
            padding: '0.625rem 0.75rem',
            marginBottom: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            paddingBottom: '0.5rem',
            borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
            marginBottom: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: '0.5rem',
            height: '0.5rem',
            borderRadius: '50%',
            background: (0, $jTCZr.CT).danger,
            animation: 'pulse 1.6s infinite'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            fontSize: '0.6875rem',
            fontWeight: 600,
            color: (0, $jTCZr.C).textPrimary
        }
    }, t('visit.copilot.liveTranscript'))), transcriptLines.slice(-3).map((l, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9331b3f7d9a9e1d6$var$TranscriptRow, {
            key: i,
            line: l
        }))), recsLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            color: (0, $jTCZr.C).textMuted,
            fontSize: '0.75rem',
            padding: '0.5rem 0'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 12,
        color: (0, $jTCZr.CT).accent,
        thickness: 2
    }), " ", t('visit.copilot.loadingNotes')), suggestions.length === 0 && !recsLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-sugg-empty",
        style: {
            textAlign: 'center',
            padding: '1.5rem 0',
            color: (0, $jTCZr.C).textMuted,
            fontSize: '0.8125rem'
        }
    }, recsError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            lineHeight: 1.8,
            color: (0, $jTCZr.CT).danger
        }
    }, recsError), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "sm",
        className: "min-h-11 mt-2",
        "data-testid": "visit-sugg-run",
        onClick: onRunRecs
    }, t('common.actions.retry'))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            lineHeight: 1.8
        }
    }, recsRan ? t('errors.empty.clinicalNotes') : t('visit.copilot.autoRunOff')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "sm",
        className: "min-h-11 mt-2 gap-1.5",
        "data-testid": "visit-sugg-run",
        onClick: onRunRecs
    }, t('visit.copilot.getClinicalNotes'), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eAIjx.default), {
        cost: (0, $1yr2B.costOf)('RECOMMENDATIONS')
    })))), suggestions.map((s, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9331b3f7d9a9e1d6$var$SuggestionCard, {
            key: (s.id || s.title) + '_' + i,
            s: s
        })), quickQs.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.625rem',
            fontWeight: 700,
            textTransform: 'uppercase',
            letterSpacing: '0.06em',
            color: (0, $jTCZr.C).textMuted,
            margin: '0.625rem 0 0.375rem'
        }
    }, t('visit.copilot.quickQuestions')), quickQs.slice(0, 4).map((q, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            key: i,
            variant: "outline",
            onClick: ()=>{
                onTab('ask');
                onAsk(q);
            },
            "data-testid": `visit-quickq-${i}`,
            className: "w-full min-h-11 h-auto justify-start rounded-lg mb-1 py-2 text-start font-normal"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.75rem',
                color: (0, $jTCZr.C).textSecondary,
                textAlign: 'start'
            }
        }, q))))), tab === 'diff' && differentialPanel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-copilot-diff"
    }, differentialPanel), tab === 'ask' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, messages.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            textAlign: 'center',
            padding: '1.25rem 0',
            color: (0, $jTCZr.C).textMuted,
            fontSize: '0.75rem'
        }
    }, t('visit.copilot.askOrQuick')), messages.map((m, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                marginBottom: '0.5rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                padding: '0.5625rem 0.75rem',
                borderRadius: '0.5625rem',
                fontSize: '0.8125rem',
                lineHeight: 1.7,
                background: m.role === 'user' ? (0, $jTCZr.C).textPrimary : (0, $jTCZr.C).card,
                color: m.role === 'user' ? '#fff' : (0, $jTCZr.C).textPrimary,
                border: m.role === 'ai' ? `1px solid ${(0, $jTCZr.C).border}` : 'none',
                marginInlineStart: m.role === 'user' ? '1.25rem' : 0,
                marginInlineEnd: m.role === 'ai' ? '1.25rem' : 0
            }
        }, m.text), m.role === 'ai' && m.citations?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                marginTop: '0.25rem',
                padding: '0.375rem 0.5625rem',
                background: (0, $jTCZr.CT).surface2,
                border: `1px dashed ${(0, $jTCZr.C).border}`,
                borderRadius: '0.4375rem',
                marginInlineEnd: '1rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.5625rem',
                fontWeight: 700,
                color: (0, $jTCZr.C).textMuted,
                letterSpacing: '0.05em',
                textTransform: 'uppercase',
                marginBottom: '0.25rem'
            }
        }, "PubMed"), m.citations.map((c, j)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
                key: j,
                href: c.url,
                target: "_blank",
                rel: "noreferrer",
                style: {
                    display: 'block',
                    fontSize: '0.625rem',
                    color: (0, $jTCZr.CT).accentInk,
                    lineHeight: 1.4,
                    marginBottom: '0.1875rem',
                    textDecoration: 'none'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    fontWeight: 600
                }
            }, c.title), c.year && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    color: (0, $jTCZr.C).textMuted
                }
            }, " (", c.year, ")")))))), chatLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: '0.25rem',
            padding: '0.5rem 0.75rem',
            background: (0, $jTCZr.C).card,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: '0.5625rem',
            width: 'fit-content',
            marginBottom: '0.5rem'
        }
    }, [
        0,
        1,
        2
    ].map((i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            key: i,
            style: {
                width: '0.3125rem',
                height: '0.3125rem',
                borderRadius: '50%',
                background: (0, $jTCZr.C).textMuted,
                animation: `pulse .9s ease ${i * 0.2}s infinite`
            }
        }))), quickQs.map((q, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            key: i,
            variant: "outline",
            onClick: ()=>onAsk(q),
            "data-testid": `visit-askq-${i}`,
            className: "w-full min-h-11 h-auto justify-start rounded-lg mb-1 py-2 text-start font-normal"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.75rem',
                color: (0, $jTCZr.C).textSecondary,
                textAlign: 'start'
            }
        }, q)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: '0.75rem',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0.5rem 0.75rem',
            background: (0, $jTCZr.CT).surface2,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: '0.75rem',
            position: 'sticky',
            bottom: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        value: aiInput,
        onChange: (e)=>onAiInput(e.target.value),
        onKeyDown: (e)=>{
            if (e.key === 'Enter') {
                onTab('ask');
                onAsk();
            }
        },
        placeholder: t('visit.copilot.askPlaceholder'),
        "data-testid": "visit-copilot-input",
        style: {
            flex: 1,
            minHeight: '2.75rem',
            border: 'none',
            background: 'transparent',
            outline: 'none',
            fontSize: '1rem',
            fontFamily: 'inherit',
            color: (0, $jTCZr.C).textPrimary
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "default",
        size: "icon",
        className: "min-h-11 min-w-11 shrink-0",
        "aria-label": t('visit.copilot.send'),
        "data-testid": "visit-copilot-send",
        onClick: ()=>{
            onTab('ask');
            onAsk();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6OGKD.default), {
        size: 15,
        "aria-hidden": true
    })))));
};
var $9331b3f7d9a9e1d6$export$2e2bcd8739ae039 = $9331b3f7d9a9e1d6$var$MobileVisitCopilotSheet;

});
parcelRegister("eAIjx", function(module, exports) {

$parcel$export(module.exports, "CoinGlyph", () => $2f6240fe22cbf69b$export$11c467f1ec2afb25);
$parcel$export(module.exports, "default", () => $2f6240fe22cbf69b$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $jTCZr = parcelRequire("jTCZr");

var $3EzBq = parcelRequire("3EzBq");

var $1HT9m = parcelRequire("1HT9m");
function $2f6240fe22cbf69b$export$11c467f1ec2afb25({ size: size = 12 }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: "none",
        "aria-hidden": "true",
        style: {
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "6.4",
        stroke: "currentColor",
        strokeWidth: "1.8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "2.1",
        fill: "currentColor"
    }));
}
function $2f6240fe22cbf69b$export$2e2bcd8739ae039({ cost: cost, per: per, prefix: prefix, tone: tone = 'accent', size: size = 'sm', title: title, style: style, testid: testid = 'coin-chip' }) {
    const { t: t, formatNumber: formatNumber } = (0, $LNQP4.default)();
    if (cost == null) return null;
    const tones = {
        accent: {
            bg: (0, $jTCZr.soft)((0, $jTCZr.C).teal, 0.14),
            fg: (0, $jTCZr.C).teal
        },
        onDark: {
            bg: 'rgba(255,255,255,0.18)',
            fg: '#fff'
        },
        warn: {
            bg: (0, $jTCZr.C).amberLight,
            fg: (0, $jTCZr.C).amber
        },
        danger: {
            bg: (0, $jTCZr.C).redLight,
            fg: (0, $jTCZr.C).red
        },
        mute: {
            bg: (0, $jTCZr.soft)((0, $jTCZr.C).textMuted, 0.12),
            fg: (0, $jTCZr.C).textSecondary
        }
    };
    const palette = tones[tone] || tones.accent;
    const isSm = size === 'sm';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        title: title,
        "data-testid": testid,
        style: {
            ...isSm ? (0, $1HT9m.type).caption : (0, $1HT9m.type).label,
            display: 'inline-flex',
            alignItems: 'center',
            gap: 4,
            background: palette.bg,
            color: palette.fg,
            borderRadius: 999,
            padding: isSm ? '1px 8px' : '3px 10px',
            fontWeight: 800,
            lineHeight: 1.6,
            whiteSpace: 'nowrap',
            flexShrink: 0,
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2f6240fe22cbf69b$export$11c467f1ec2afb25, {
        size: isSm ? 11 : 12
    }), prefix ? `${prefix} ` : '', (0, $3EzBq.fmtCoins)(cost, formatNumber), per ? ` / ${per}` : '');
}

});


parcelRegister("2WSjX", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0b3b7ef84bbae65$export$2e2bcd8739ae039);
parcelRequire("dSPMK");
var $asXy3 = parcelRequire("asXy3");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");
parcelRequire("7sS0P");
var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $cZOyb = parcelRequire("cZOyb");
var $aJ1FU = parcelRequire("aJ1FU");
var $66joL = parcelRequire("66joL");

var $QG9Z3 = parcelRequire("QG9Z3");
var $huNwV = parcelRequire("huNwV");
var $2WFPf = parcelRequire("2WFPf");
var $gKFEi = parcelRequire("gKFEi");
var $aGlWN = parcelRequire("aGlWN");
var $aVx4q = parcelRequire("aVx4q");
var $8g4t5 = parcelRequire("8g4t5");
var $iDwyV = parcelRequire("iDwyV");
var $2rN5o = parcelRequire("2rN5o");
var $chm1L = parcelRequire("chm1L");
var $lUsTt = parcelRequire("lUsTt");

var $3OnFU = parcelRequire("3OnFU");

var $6xvbB = parcelRequire("6xvbB");

var $i9Cif = parcelRequire("i9Cif");

var $6ojK3 = parcelRequire("6ojK3");
parcelRequire("gcegg");
var $jTCZr = parcelRequire("jTCZr");

var $aoLHg = parcelRequire("aoLHg");

var $gq4TR = parcelRequire("gq4TR");

var $g6gAc = parcelRequire("g6gAc");

var $dL6zl = parcelRequire("dL6zl");

var $jGozX = parcelRequire("jGozX");

var $1Qo7B = parcelRequire("1Qo7B");

var $jDxJA = parcelRequire("jDxJA");

var $5hFXE = parcelRequire("5hFXE");
// The in-visit patient record BottomSheet — the phone's rendering of the desktop
// Visit CONTEXT PANEL (Visit.web.jsx, gridColumn 1), which is the source of
// truth for what the record contains and in what order:
//
//   افزودن نتیجه → allergies → مشخصات (+ویرایش) → علائم حیاتی (+تاریخچه)
//   → داروهای جاری → تشخیص‌های فعال → سابقه بیماری → نتایج آزمایش → مراجعات اخیر
//
// Data + persistence live in the screen; this is render-only. Destructive
// actions (stop a med, remove a diagnosis) are confirm-gated (§6/§9) and both
// are undoable, exactly as on desktop.
const $e0b3b7ef84bbae65$var$VITAL_FIELDS = (t)=>[
        {
            key: 'bpSys',
            label: 'BP sys',
            unit: 'mmHg'
        },
        {
            key: 'bpDia',
            label: 'BP dia',
            unit: 'mmHg'
        },
        {
            key: 'pulse',
            label: t('visit.vitals.pulse'),
            unit: 'bpm'
        },
        {
            key: 'spo2',
            label: "SpO\u2082",
            unit: '%'
        },
        {
            key: 'temp',
            label: t('patient.vitals.temp'),
            unit: "\xb0C"
        },
        {
            key: 'weight',
            label: t('patient.vitals.wt'),
            unit: 'kg'
        }
    ];
// A past visit's SOAP sections, named as the closure names them.
const $e0b3b7ef84bbae65$var$SOAP_LABEL = {
    S: 'visit.soap.sLetter',
    O: 'visit.soap.oLetter',
    A: 'visit.soap.aLetter',
    P: 'visit.soap.pLetter'
};
// Non-vital observations are the "lab results" list; the same LOINC codes the
// desktop context panel filters out.
const $e0b3b7ef84bbae65$var$VITAL_CODES_CTX = new Set([
    '8480-6',
    '8462-4',
    '8867-4',
    '59408-5',
    '8310-5',
    '29463-7'
]);
// One record section, with the desktop rail's header grammar (Visit.web.jsx
// `RecordSection`): title + count pill + one-line gist SHOWN ONLY WHILE
// COLLAPSED + inline actions + chevron. Same `record-section-<id>` /
// `record-toggle-<id>` testids, because it is the same section.
//
// The chevron turns rather than pointing sideways: «down = open me, up = close
// me» needs no mirroring, and this sheet is read in both directions.
const $e0b3b7ef84bbae65$var$Section = ({ id: id, title: title, count: count, badge: badge, gist: gist, action: action, open: open, onToggle: onToggle, children: children })=>{
    const { t: t, formatDigits: formatDigits } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `record-section-${id}`,
        style: {
            borderBottom: `1px solid ${(0, $jTCZr.C).border}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.25rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        onClick: ()=>onToggle(id),
        "aria-expanded": open,
        "data-testid": `record-toggle-${id}`,
        "aria-label": open ? t('visit.recordPanel.collapseSection', {
            title: title
        }) : t('visit.recordPanel.expandSection', {
            title: title
        }),
        className: "flex-1 min-h-11 h-auto justify-start gap-1.5 px-0 py-2 hover:bg-transparent"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2WFPf.default), {
        size: 14,
        "aria-hidden": true,
        style: {
            color: (0, $jTCZr.C).textMuted,
            flexShrink: 0,
            transform: open ? 'rotate(180deg)' : 'none',
            transition: 'transform .18s'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            minWidth: 0,
            textAlign: 'start'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.375rem',
            flexWrap: 'wrap'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.8125rem',
            fontWeight: 700,
            color: (0, $jTCZr.C).textPrimary
        }
    }, title), count > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.625rem',
            fontWeight: 500,
            padding: '0.0625rem 0.375rem',
            borderRadius: '0.75rem',
            background: (0, $jTCZr.CT).surface2,
            color: (0, $jTCZr.C).textMuted
        }
    }, formatDigits(count)), badge), !open && gist && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'block',
            fontSize: '0.6875rem',
            color: (0, $jTCZr.C).textMuted,
            marginTop: '0.125rem',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        }
    }, gist))), action), open && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            paddingBottom: '0.75rem'
        }
    }, children));
};
const $e0b3b7ef84bbae65$var$UndoBanner = ({ text: text, onUndo: onUndo, testId: testId })=>{
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            marginBottom: '0.5rem',
            padding: '0.4375rem 0.625rem',
            borderRadius: '0.5rem',
            background: (0, $jTCZr.CT).surface2,
            border: `1px solid ${(0, $jTCZr.C).border}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            fontSize: '0.71875rem',
            color: (0, $jTCZr.C).textSecondary
        }
    }, text), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        className: "min-h-11 shrink-0",
        onClick: onUndo
    }, t('visit.orders.undo')));
};
// Two rows of three tiles at 360px and up (three rows of two at 320px) before «+N».
const $e0b3b7ef84bbae65$var$FILE_TILES_PREVIEW = 6;
const $e0b3b7ef84bbae65$var$MobileVisitRecordSheet = ({ open: open, onClose: onClose, patient: patient, vitals: vitals, onVitalChange: onVitalChange, vitalsMode: vitalsMode, onVitalsSave: onVitalsSave, vitalsLoading: vitalsLoading, vitalsError: vitalsError, vitalsAlert: vitalsAlert, onDismissVitalsAlert: onDismissVitalsAlert, onEditVitals: onEditVitals, onVitalsHistory: onVitalsHistory, vitalsComplete: vitalsComplete = null, vitalsProposal: vitalsProposal = null, recordComplete: recordComplete = null, meds: meds, onStopMed: onStopMed, undoMed: undoMed, onUndoMed: onUndoMed, diagnoses: diagnoses = [], onRemoveDiagnosis: onRemoveDiagnosis, undoCondition: undoCondition, onUndoCondition: onUndoCondition, conditions: conditions, labResults: labResults = [], pastVisits: pastVisits, encounters: encounters = [], clinicalNotes: clinicalNotes = [], onUploadLab: onUploadLab, onEditPatient: onEditPatient, onRepresribeMed: // ── Parity extensions (docs/mobile-visit-redesign.md §5.6) ─────────────────
// تجویز مجدد: a current medication and a drug from a past visit are the same
// refill door, keyed by NAME — a record row and a formulary entry never share
// an id, and the same drug must read «در نسخه» whichever door it came through.
onRepresribeMed, prescribedNames: prescribedNames, onChangeDxType: // «نوع تشخیص» in place: the only edit path for a diagnosis typed into SOAP «A».
onChangeDxType, dxTypeBusyId: dxTypeBusyId, visitContexts: // Past-visit detail is fetched on expand, not with the record: a visit the
// doctor never opens costs nothing.
visitContexts = {}, onOpenVisit: onOpenVisit, onViewAllLabs: // The labs preview truncates; this opens the full list rather than telling the
// doctor how many results they cannot see.
onViewAllLabs, sections: // ── The doctor's layout (Settings → «صفحه ویزیت») ──────────────────────────
// `sections` is the RESOLVED, ordered, visible list (visitLayout.js); the
// screen owns `recordOpen` and its persistence, exactly as the desktop rail
// does, so this stays render-only. Absent, every section renders open in
// catalogue order — the sheet has no opinion of its own.
sections, recordOpen: recordOpen = {}, onToggleSection: onToggleSection, onEditLayout: onEditLayout, files: // «مدارک بیمار»: the patient's documents (sorted by the screen) and the actions the
// screen's `useClinicalFiles` host performs. `onPreviewFile(file, list)` opens the
// gallery on `list` — the tiles' own order — starting at `file` (PM-0561); a host
// without it opens the file's detail, as before. The per-document actions (view,
// extract, edit, download, delete) are offered by the gallery and the detail it
// opens, so the sheet itself no longer draws them; the props stay accepted.
files = [], currentVisitId: currentVisitId = null, onOpenFile: onOpenFile, onPreviewFile: onPreviewFile, onViewFile: onViewFile, onExtractFile: onExtractFile, onEditFile: onEditFile, onDownloadFile: onDownloadFile, onDeleteFile: onDeleteFile })=>{
    const { t: t, formatDigits: formatDigits, formatDate: formatDate, formatList: formatList, formatRelativeTime: formatRelativeTime, readsPersianData: readsPersianData } = (0, $LNQP4.default)();
    const [pendingStop, setPendingStop] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [pendingDx, setPendingDx] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [openVisitId, setOpenVisitId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [dxTypePick, setDxTypePick] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // condition id being retyped
    const [showAllFiles, setShowAllFiles] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const p = patient || {};
    const isPrescribed = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((name)=>!!prescribedNames?.has?.((name || '').trim().toLowerCase()), [
        prescribedNames
    ]);
    // Same four facts the desktop demographics grid shows.
    const demo = [
        {
            k: t('common.labels.age'),
            v: p.age != null ? t('patient.ageYears', {
                age: formatDigits(p.age),
                count: Number(p.age)
            }) : "\u2014"
        },
        {
            k: t('visit.patient.bloodType'),
            v: p.bloodType || "\u2014"
        },
        {
            k: t('visit.patient.insurance'),
            v: (0, $gq4TR.INSURANCE_LABEL_KEYS)[p.insurance] ? t((0, $gq4TR.INSURANCE_LABEL_KEYS)[p.insurance]) : p.insurance || "\u2014"
        },
        {
            k: 'BMI',
            v: p.bmi ? formatDigits(p.bmi) : "\u2014"
        }
    ];
    // Abnormal/critical first, then newest — the desktop ordering.
    const labs = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(labResults || []).filter((o)=>!$e0b3b7ef84bbae65$var$VITAL_CODES_CTX.has(o.code)).slice().sort((a, b)=>{
            const sA = a.status === 'CRITICAL' ? 0 : a.status === 'ABNORMAL' ? 1 : 2;
            const sB = b.status === 'CRITICAL' ? 0 : b.status === 'ABNORMAL' ? 1 : 2;
            if (sA !== sB) return sA - sB;
            return (b.effectiveDate || '').localeCompare(a.effectiveDate || '');
        }).slice(0, 10), [
        labResults
    ]);
    const totalLabs = (labResults || []).filter((o)=>!$e0b3b7ef84bbae65$var$VITAL_CODES_CTX.has(o.code)).length;
    // Last three finished encounters, newest first (desktop «مراجعات اخیر»).
    const pastEncs = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(encounters || []).slice().sort((a, b)=>new Date(b.periodStart) - new Date(a.periodStart)).filter((e)=>e.status === 'finished').slice(0, 3), [
        encounters
    ]);
    const summaries = pastVisits || [];
    const visitRows = pastEncs.length ? pastEncs : summaries;
    // «کد رهگیری» of what the doctor sent to the insurer for these visits (PM-0686) —
    // read only while the sheet is open, one question for the rows it lists.
    const { codes: erxCodes } = (0, $5hFXE.useVisitErxCodes)(pastEncs.length ? pastEncs.map((e)=>e.id) : summaries.map((x)=>x.appointmentId || x.visitId), {
        active: open
    });
    // Rendered only while a section is COLLAPSED, so a closed section still tells
    // the doctor what it holds — the desktop rail's rule, on the phone.
    const demoGist = demo.filter((d)=>d.v && d.v !== "\u2014").map((d)=>d.v).slice(0, 3).join(" \xb7 ");
    const vitalsGist = [
        vitals?.bpSys || vitals?.bpDia ? `${vitals.bpSys || "\u2014"}/${vitals.bpDia || "\u2014"}` : null,
        vitals?.spo2 ? `${formatDigits(vitals.spo2)}% SpO\u{2082}` : null,
        vitals?.pulse ? `${formatDigits(vitals.pulse)} bpm` : null
    ].filter(Boolean).join(" \xb7 ");
    const medsGist = formatList((meds || []).slice(0, 3).map((m)=>m.display));
    const dxGist = formatList((diagnoses || []).slice(0, 3).map((c)=>c.display));
    const condsGist = formatList((conditions || []).slice(0, 3));
    const labsGist = formatList(labs.slice(0, 3).map((o)=>o.display).filter(Boolean));
    const historyGist = visitRows[0]?.periodStart ? formatRelativeTime(visitRows[0].periodStart) : null;
    const labCritical = labs.filter((o)=>o.status === 'CRITICAL').length;
    const labAbnormal = labs.filter((o)=>o.status === 'ABNORMAL').length;
    const labsBadge = labCritical > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.625rem',
            fontWeight: 700,
            padding: '0.0625rem 0.4375rem',
            borderRadius: '0.75rem',
            background: (0, $jTCZr.CT).danger,
            color: '#fff'
        }
    }, t('visit.recordPanel.criticalCount', {
        count: formatDigits(labCritical)
    })) : labAbnormal > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.625rem',
            fontWeight: 700,
            padding: '0.0625rem 0.4375rem',
            borderRadius: '0.75rem',
            background: (0, $jTCZr.C).amberLight,
            color: (0, $jTCZr.CT).warnInk
        }
    }, t('visit.recordPanel.abnormalCount', {
        count: formatDigits(labAbnormal)
    })) : null;
    // The doctor's order, or the catalogue's when the screen passes none.
    const sectionList = sections || (0, $aoLHg.visibleRecordSections)((0, $aoLHg.resolveVisitLayout)(null));
    const toggleSection = onToggleSection || (()=>{});
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: open,
        onClose: onClose,
        title: t('visit.patient.record'),
        closeLabel: t('common.actions.close')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-record-sheet"
    }, recordComplete && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginBottom: '0.75rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem'
        }
    }, recordComplete), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            marginBottom: '0.75rem'
        }
    }, onUploadLab && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "subtle",
        size: "sm",
        className: "flex-1 min-h-11 gap-1.5",
        "data-testid": "visit-record-upload",
        onClick: onUploadLab
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8g4t5.default), {
        size: 13,
        "aria-hidden": true
    }), " ", t('visit.patient.addFile')), onEditLayout && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        className: `min-h-11 gap-1.5 shrink-0${onUploadLab ? '' : ' flex-1'}`,
        "data-testid": "visit-record-edit-layout",
        onClick: onEditLayout
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2rN5o.default), {
        size: 13,
        "aria-hidden": true
    }), " ", t('visit.recordPanel.editLayout'))), (()=>{
        const blocks = {
            /* Demographics + ویرایش */ demo: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e0b3b7ef84bbae65$var$Section, {
                id: "demo",
                title: t('visit.patient.details'),
                gist: demoGist,
                action: onEditPatient ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
                    variant: "ghost",
                    size: "sm",
                    className: "min-h-11 gap-1",
                    "data-testid": "visit-demographics-edit",
                    onClick: onEditPatient
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aGlWN.default), {
                    size: 12,
                    "aria-hidden": true
                }), " ", t('common.actions.edit')) : null,
                open: recordOpen['demo'] !== false,
                onToggle: toggleSection
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gap: '0.5rem 0.875rem'
                }
            }, demo.map(({ k: k, v: v })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    key: k
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        fontSize: '0.625rem',
                        color: (0, $jTCZr.C).textMuted,
                        textTransform: 'uppercase',
                        letterSpacing: '0.05em',
                        fontWeight: 600
                    }
                }, k), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        fontSize: '0.8125rem',
                        color: (0, $jTCZr.C).textPrimary,
                        fontWeight: 500
                    }
                }, v))))),
            /* Vitals — alert, then the recorder (form ⇄ saved) */ vitals: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e0b3b7ef84bbae65$var$Section, {
                id: "vitals",
                title: vitalsMode === 'saved' ? t('visit.vitals.thisVisit') : t('visit.vitals.record'),
                gist: vitalsGist,
                action: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.25rem'
                    }
                }, vitalsComplete, onVitalsHistory && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
                    variant: "ghost",
                    size: "sm",
                    className: "min-h-11 gap-1",
                    "data-testid": "visit-vitals-history",
                    onClick: onVitalsHistory
                }, t('common.actions.viewDetails'), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gKFEi.default), {
                    size: 12,
                    "aria-hidden": true,
                    style: (0, $asXy3.MIRROR_ICON)
                })), vitalsMode === 'saved' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
                    variant: "subtle",
                    size: "sm",
                    className: "min-h-11 gap-1",
                    "data-testid": "visit-vitals-edit",
                    onClick: onEditVitals
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aGlWN.default), {
                    size: 12,
                    "aria-hidden": true
                }), " ", t('common.actions.edit'))),
                open: recordOpen['vitals'] !== false,
                onToggle: toggleSection
            }, vitalsProposal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    marginBottom: '0.625rem'
                }
            }, vitalsProposal), vitalsAlert && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                "data-testid": "visit-vitals-alert",
                style: {
                    borderRadius: '0.5rem',
                    padding: '0.5625rem 0.6875rem',
                    marginBottom: '0.625rem',
                    background: vitalsAlert.level === 'critical' ? (0, $jTCZr.CT).dangerSoft : (0, $jTCZr.C).amberLight,
                    border: `1.5px solid ${vitalsAlert.level === 'critical' ? (0, $jTCZr.soft)((0, $jTCZr.C).red, 0.45) : (0, $jTCZr.CT).warn}`
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.375rem',
                    marginBottom: '0.1875rem'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $QG9Z3.default), {
                size: 12,
                "aria-hidden": true,
                style: {
                    color: vitalsAlert.level === 'critical' ? (0, $jTCZr.CT).dangerInk : (0, $jTCZr.CT).warnInk
                }
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    fontWeight: 700,
                    fontSize: '0.75rem',
                    color: vitalsAlert.level === 'critical' ? (0, $jTCZr.CT).dangerInk : (0, $jTCZr.CT).warnInk
                }
            }, vitalsAlert.level === 'critical' ? t('visit.state.criticalWarning') : t('visit.state.warning'))), vitalsAlert.messages.map((m, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    key: i,
                    style: {
                        fontSize: '0.75rem',
                        color: (0, $jTCZr.C).textPrimary
                    }
                }, m)), onDismissVitalsAlert && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
                variant: "ghost",
                size: "sm",
                className: "min-h-11 mt-1",
                onClick: onDismissVitalsAlert
            }, t('common.actions.close'))), vitalsMode === 'saved' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gap: '0.5rem'
                }
            }, $e0b3b7ef84bbae65$var$VITAL_FIELDS(t).filter((f)=>vitals[f.key]).map(({ key: key, label: label, unit: unit })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    key: key,
                    style: {
                        background: (0, $jTCZr.C).greenLight,
                        border: `1px solid ${(0, $jTCZr.soft)((0, $jTCZr.C).green, 0.35)}`,
                        borderRadius: '0.5rem',
                        padding: '0.5rem 0.625rem'
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        fontSize: '0.5625rem',
                        fontWeight: 600,
                        color: (0, $jTCZr.C).textMuted,
                        textTransform: 'uppercase',
                        marginBottom: '0.1875rem'
                    }
                }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        display: 'flex',
                        alignItems: 'baseline',
                        gap: '0.1875rem'
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        fontSize: '1.125rem',
                        fontWeight: 700,
                        color: (0, $jTCZr.C).textPrimary
                    }
                }, formatDigits(vitals[key])), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        fontSize: '0.5625rem',
                        color: (0, $jTCZr.C).textMuted
                    }
                }, unit))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
                    gap: '0.5rem'
                }
            }, $e0b3b7ef84bbae65$var$VITAL_FIELDS(t).map(({ key: key, label: label, unit: unit })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    key: key,
                    style: {
                        minWidth: 0,
                        background: (0, $jTCZr.CT).surface2,
                        border: `1px solid ${(0, $jTCZr.C).border}`,
                        borderRadius: '0.5rem',
                        padding: '0.5rem 0.625rem'
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        fontSize: '0.6875rem',
                        fontWeight: 600,
                        color: (0, $jTCZr.C).textMuted,
                        textTransform: 'uppercase',
                        marginBottom: '0.125rem'
                    }
                }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.25rem'
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
                    type: "text",
                    inputMode: "decimal",
                    dir: "ltr",
                    value: vitals[key] || '',
                    onChange: (e)=>onVitalChange(key, e.target.value),
                    "data-testid": `visit-vital-${key}`,
                    style: {
                        flex: 1,
                        minWidth: 0,
                        minHeight: '2.75rem',
                        border: 'none',
                        outline: 'none',
                        fontSize: '1.125rem',
                        fontWeight: 700,
                        fontFamily: 'inherit',
                        background: 'transparent',
                        color: (0, $jTCZr.C).textPrimary
                    }
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        fontSize: '0.6875rem',
                        color: (0, $jTCZr.C).textMuted
                    }
                }, unit))))), vitalsError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                "data-testid": "visit-vitals-error",
                style: {
                    borderRadius: '0.5rem',
                    padding: '0.5rem 0.6875rem',
                    background: (0, $jTCZr.soft)((0, $jTCZr.C).red, 0.12),
                    border: `1.5px solid ${(0, $jTCZr.soft)((0, $jTCZr.C).red, 0.4)}`,
                    marginTop: '0.625rem'
                }
            }, vitalsError.map((m, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    key: i,
                    style: {
                        fontSize: '0.75rem',
                        color: (0, $jTCZr.C).red,
                        fontWeight: 600
                    }
                }, m))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
                variant: "default",
                size: "lg",
                onClick: onVitalsSave,
                disabled: vitalsLoading,
                "data-testid": "visit-vitals-save",
                className: "w-full min-h-11 mt-2.5"
            }, vitalsLoading ? t('visit.plan.saving') : t('visit.vitals.record')))),
            /* Current medications */ meds: (meds.length > 0 || undoMed) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e0b3b7ef84bbae65$var$Section, {
                id: "meds",
                title: t('patient.meds.current'),
                count: meds.length,
                gist: medsGist,
                open: recordOpen['meds'] !== false,
                onToggle: toggleSection
            }, undoMed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e0b3b7ef84bbae65$var$UndoBanner, {
                testId: "visit-med-undo",
                onUndo: onUndoMed,
                text: t('visit.rx.stoppedNotAdded', {
                    name: undoMed.display
                })
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '0.5rem'
                }
            }, meds.map((m, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    key: (m.id || m.display) + '_' + i,
                    style: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.625rem',
                        background: (0, $jTCZr.C).card,
                        border: `1px solid ${(0, $jTCZr.C).border}`,
                        borderRadius: '0.625rem',
                        padding: '0.625rem 0.75rem'
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
                    variant: "ghost",
                    size: "icon",
                    className: "h-11 w-11 text-muted-foreground shrink-0",
                    "aria-label": t('patient.meds.stopAria', {
                        name: m.display
                    }),
                    "data-testid": `visit-med-stop-${m.id}`,
                    onClick: ()=>setPendingStop(m)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lUsTt.default), {
                    size: 15,
                    "aria-hidden": true
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        flex: 1,
                        minWidth: 0,
                        textAlign: 'start'
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    dir: "auto",
                    style: {
                        fontSize: '0.8125rem',
                        fontWeight: 700,
                        color: (0, $jTCZr.C).textPrimary
                    }
                }, (0, $g6gAc.medDisplayName)(m)), m.warn && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '0.25rem',
                        marginTop: '0.125rem',
                        fontSize: '0.625rem',
                        fontWeight: 700,
                        color: (0, $jTCZr.CT).warnInk
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $QG9Z3.default), {
                    size: 10,
                    "aria-hidden": true
                }), m.warn), m.dosageInstruction?.text && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        fontSize: '0.6875rem',
                        color: (0, $jTCZr.C).textMuted
                    }
                }, (0, $6xvbB.doseLineLabel)(m.dosageInstruction.text, t, readsPersianData))), onRepresribeMed && (isPrescribed(m.display) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    "data-testid": `visit-med-represcribed-${m.id}`,
                    style: {
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '0.1875rem',
                        fontSize: '0.625rem',
                        fontWeight: 700,
                        color: (0, $jTCZr.CT).good,
                        flexShrink: 0
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
                    size: 12,
                    "aria-hidden": true
                }), t('visit.rx.represcribed')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
                    variant: "subtle",
                    size: "sm",
                    className: "min-h-11 gap-1 shrink-0",
                    "data-testid": `visit-med-represcribe-${m.id}`,
                    "aria-label": t('visit.rx.represcribeAria', {
                        name: m.display
                    }),
                    onClick: ()=>onRepresribeMed(m)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $iDwyV.default), {
                    size: 12,
                    "aria-hidden": true
                }), t('visit.rx.represcribe'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        width: '1.75rem',
                        height: '1.75rem',
                        borderRadius: '0.5rem',
                        background: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.08),
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aVx4q.default), {
                    size: 14,
                    color: (0, $jTCZr.C).navy,
                    "aria-hidden": true
                })))))),
            /* Active diagnoses */ dx: (diagnoses.length > 0 || undoCondition) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e0b3b7ef84bbae65$var$Section, {
                id: "dx",
                title: t('patient.conditions.active'),
                count: diagnoses.length,
                gist: dxGist,
                open: recordOpen['dx'] !== false,
                onToggle: toggleSection
            }, undoCondition && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e0b3b7ef84bbae65$var$UndoBanner, {
                testId: "visit-dx-undo",
                onUndo: onUndoCondition,
                text: t('visit.dx.removedNamed', {
                    name: undoCondition.display
                })
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '0.5rem'
                }
            }, diagnoses.map((c, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    key: (c.id || c.display) + '_' + i,
                    style: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.625rem',
                        background: (0, $jTCZr.C).card,
                        border: `1px solid ${(0, $jTCZr.C).border}`,
                        borderRadius: '0.625rem',
                        padding: '0.625rem 0.75rem'
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
                    variant: "ghost",
                    size: "icon",
                    className: "h-11 w-11 text-muted-foreground shrink-0",
                    "aria-label": t('patient.conditions.removeAria', {
                        name: c.display
                    }),
                    "data-testid": `visit-dx-remove-${c.id}`,
                    onClick: ()=>setPendingDx(c)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lUsTt.default), {
                    size: 15,
                    "aria-hidden": true
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        flex: 1,
                        minWidth: 0,
                        textAlign: 'start'
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        fontSize: '0.8125rem',
                        fontWeight: 700,
                        color: (0, $jTCZr.C).textPrimary,
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.375rem',
                        flexWrap: 'wrap'
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, c.display), onChangeDxType ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
                    variant: "ghost",
                    size: "sm",
                    className: "min-h-11 px-1",
                    "data-testid": `visit-dx-type-edit-${c.id}`,
                    "aria-label": `${t('visit.dx.type.change')} \u{2014} ${c.display}`,
                    disabled: dxTypeBusyId === c.id,
                    onClick: ()=>setDxTypePick(dxTypePick === c.id ? null : c.id)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $i9Cif.DiagnosisTypeBadge), {
                    cond: c
                })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $i9Cif.DiagnosisTypeBadge), {
                    cond: c
                })), c.code && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    dir: "ltr",
                    style: {
                        fontSize: '0.6875rem',
                        color: (0, $jTCZr.C).textMuted,
                        fontFamily: 'ui-monospace, monospace'
                    }
                }, c.code), dxTypePick === c.id && onChangeDxType && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        marginTop: '0.5rem'
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $i9Cif.DiagnosisTypeChoice), {
                    current: (0, $6ojK3.diagnosisTypeOf)(c),
                    busy: dxTypeBusyId === c.id,
                    testidPrefix: `visit-dx-type-choice-${c.id}`,
                    onCancel: ()=>setDxTypePick(null),
                    onPick: async (type)=>{
                        await onChangeDxType(c, type);
                        setDxTypePick(null);
                    }
                }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        width: '1.75rem',
                        height: '1.75rem',
                        borderRadius: '0.5rem',
                        background: (0, $jTCZr.CT).accentSoft,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $chm1L.default), {
                    size: 14,
                    color: (0, $jTCZr.CT).accentInk,
                    "aria-hidden": true
                })))))),
            /* Condition history */ conds: conditions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e0b3b7ef84bbae65$var$Section, {
                id: "conds",
                title: t('visit.patient.conditionHistory'),
                count: conditions.length,
                gist: condsGist,
                open: recordOpen['conds'] !== false,
                onToggle: toggleSection
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '0.3125rem'
                }
            }, conditions.slice(0, 8).map((c, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    key: i,
                    style: {
                        fontSize: '0.6875rem',
                        padding: '0.25rem 0.625rem',
                        borderRadius: '0.375rem',
                        background: (0, $jTCZr.C).card,
                        border: `1px solid ${(0, $jTCZr.C).border}`,
                        color: (0, $jTCZr.C).textSecondary
                    }
                }, c)))),
            /* Lab results */ labs: labs.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e0b3b7ef84bbae65$var$Section, {
                id: "labs",
                title: t('visit.patient.labResults'),
                count: totalLabs,
                badge: labsBadge,
                gist: labsGist,
                action: onViewAllLabs && totalLabs > labs.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
                    variant: "ghost",
                    size: "sm",
                    className: "min-h-11 gap-1",
                    "data-testid": "visit-record-labs-all",
                    onClick: onViewAllLabs
                }, t('common.actions.viewAll'), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gKFEi.default), {
                    size: 12,
                    "aria-hidden": true,
                    style: (0, $asXy3.MIRROR_ICON)
                })) : null,
                open: recordOpen['labs'] !== false,
                onToggle: toggleSection
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                "data-testid": "visit-record-labs",
                style: {
                    display: 'flex',
                    flexDirection: 'column'
                }
            }, labs.map((obs, i)=>{
                const isCritical = obs.status === 'CRITICAL';
                const isAbnormal = obs.status === 'ABNORMAL';
                const valColor = isCritical ? (0, $jTCZr.CT).danger : isAbnormal ? (0, $jTCZr.CT).warnInk : (0, $jTCZr.CT).good;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    key: (obs.id || '') + '_' + i,
                    style: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                        padding: '0.4375rem 0.5rem',
                        borderRadius: '0.5rem',
                        background: isCritical ? (0, $jTCZr.CT).dangerSoft : isAbnormal ? (0, $jTCZr.C).amberLight : 'transparent',
                        borderBottom: i < labs.length - 1 ? `1px solid ${(0, $jTCZr.C).border}` : 'none'
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        width: '0.4375rem',
                        height: '0.4375rem',
                        borderRadius: '50%',
                        background: valColor,
                        flexShrink: 0
                    }
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        flex: 1,
                        minWidth: 0
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        fontSize: '0.75rem',
                        color: (0, $jTCZr.C).textPrimary,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                    }
                }, obs.display), obs.referenceRange && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    dir: "ltr",
                    style: {
                        fontSize: '0.5625rem',
                        color: (0, $jTCZr.C).textMuted
                    }
                }, "ref: ", obs.referenceRange)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    dir: "ltr",
                    style: {
                        fontSize: '0.8125rem',
                        fontWeight: 700,
                        fontFamily: 'ui-monospace, monospace',
                        color: valColor,
                        flexShrink: 0
                    }
                }, formatDigits(obs.value), obs.unit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        fontSize: '0.5625rem',
                        fontWeight: 400,
                        color: (0, $jTCZr.C).textMuted
                    }
                }, " ", obs.unit) : ''), (isCritical || isAbnormal) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        fontSize: '0.5625rem',
                        fontWeight: 700,
                        padding: '0.0625rem 0.3125rem',
                        borderRadius: '0.25rem',
                        flexShrink: 0,
                        background: isCritical ? (0, $jTCZr.CT).danger : (0, $jTCZr.CT).warn,
                        color: isCritical ? '#fff' : (0, $jTCZr.CT).warnInk
                    }
                }, isCritical ? t('visit.vitals.critical') : t('visit.vitals.abnormal')));
            })), totalLabs > labs.length && (onViewAllLabs ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
                variant: "ghost",
                size: "sm",
                className: "w-full min-h-11 mt-1",
                "data-testid": "visit-record-labs-more",
                onClick: onViewAllLabs
            }, "+ ", formatDigits(totalLabs - labs.length), " ", t('patient.obs.result')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    fontSize: '0.6875rem',
                    color: (0, $jTCZr.C).textMuted,
                    textAlign: 'center',
                    paddingTop: '0.375rem'
                }
            }, "+ ", formatDigits(totalLabs - labs.length), " ", t('patient.obs.result')))),
            /* «مدارک بیمار» — this visit's documents first, as pictures: two rows of
             tiles, «+N» for the rest; a tile opens the gallery on all of them
             (PM-0561), so the doctor pages through instead of opening each. */ files: (()=>{
                const ordered = currentVisitId ? [
                    ...files.filter((f)=>f.appointmentId === currentVisitId),
                    ...files.filter((f)=>f.appointmentId !== currentVisitId)
                ] : files;
                const shown = showAllFiles ? ordered : ordered.slice(0, $e0b3b7ef84bbae65$var$FILE_TILES_PREVIEW);
                const preview = (f)=>onPreviewFile ? onPreviewFile(f, ordered) : onOpenFile?.(f);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e0b3b7ef84bbae65$var$Section, {
                    id: "files",
                    title: t('visit.patient.files'),
                    count: files.length,
                    gist: formatList([
                        ...new Set(ordered.slice(0, 3).map((f)=>(0, $1Qo7B.documentKindLabelKey)(f.kind)).filter(Boolean))
                    ].map((k)=>t(k))),
                    open: recordOpen['files'] !== false,
                    onToggle: toggleSection
                }, files.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    "data-testid": "visit-record-files-empty",
                    "data-state": "empty",
                    style: {
                        fontSize: '0.75rem',
                        color: (0, $jTCZr.C).textMuted
                    }
                }, t('patient.files.empty')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    "data-testid": "visit-record-files",
                    "data-state": "content"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $jGozX.FileTileGrid), {
                    files: shown,
                    onSelect: preview,
                    testid: "visit-record-file-tile",
                    badgeFor: currentVisitId ? (f)=>f.appointmentId === currentVisitId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                            className: "rounded-full bg-accent px-1.5 py-px text-[0.625rem] font-bold text-navy-dark"
                        }, t('patient.files.gallery.thisVisit')) : null : null
                }), ordered.length > $e0b3b7ef84bbae65$var$FILE_TILES_PREVIEW && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
                    variant: "ghost",
                    size: "sm",
                    className: "w-full min-h-11 mt-1",
                    "data-testid": "visit-record-files-more",
                    onClick: ()=>setShowAllFiles((v)=>!v)
                }, showAllFiles ? t('visit.files.showLess') : `+ ${formatDigits(ordered.length - $e0b3b7ef84bbae65$var$FILE_TILES_PREVIEW)} ${t('patient.files.file')}`)));
            })(),
            /* Recent visits — expandable, same detail as the desktop rail */ history: visitRows.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e0b3b7ef84bbae65$var$Section, {
                id: "history",
                title: t('visit.patient.recentVisits'),
                count: visitRows.length,
                gist: historyGist,
                open: recordOpen['history'] !== false,
                onToggle: toggleSection
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '0.5rem'
                }
            }, visitRows.map((item, idx)=>{
                const enc = pastEncs[idx];
                // Matched by visit, never by position: a visit with no summary must
                // not borrow the next visit's (PM-0599).
                const sum = enc ? summaries.find((s)=>String(s.appointmentId || s.visitId || '') === String(enc.id)) : summaries[idx];
                const encId = enc?.id || sum?.visitId || String(idx);
                const isOpen = openVisitId === encId;
                // The visit's note, every SOAP section with text (PM-0629) — it showed only «A».
                const soapParts = enc ? (0, $dL6zl.visitSoapSections)((clinicalNotes || []).filter((n)=>n.appointmentId === enc.id)) : [];
                const dateStr = enc?.periodStart ? formatDate(enc.periodStart, 'medium') : null;
                const reason = enc?.reason || sum?.suggestedDiagnosis || t('patient.visit');
                const visitErx = erxCodes.get(String(enc?.id || sum?.appointmentId || sum?.visitId || ''));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    key: encId,
                    style: {
                        borderRadius: '0.625rem',
                        border: `1px solid ${(0, $jTCZr.C).border}`,
                        overflow: 'hidden',
                        background: (0, $jTCZr.C).card
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
                    variant: "ghost",
                    onClick: ()=>{
                        const next = isOpen ? null : encId;
                        setOpenVisitId(next);
                        // Fetch on expand, not with the record: a visit the
                        // doctor never opens costs nothing. The screen caches,
                        // so re-expanding the same row does not re-ask.
                        if (next && enc?.id) onOpenVisit?.(enc.id);
                    },
                    "aria-expanded": isOpen,
                    "data-testid": `visit-past-${encId}`,
                    className: "w-full min-h-11 h-auto justify-start gap-2 rounded-none px-3 py-2.5 hover:bg-transparent"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        width: '0.4375rem',
                        height: '0.4375rem',
                        borderRadius: '50%',
                        background: (0, $jTCZr.CT).accent,
                        flexShrink: 0
                    }
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        flex: 1,
                        minWidth: 0,
                        textAlign: 'start'
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        display: 'block',
                        fontSize: '0.78125rem',
                        fontWeight: 600,
                        color: (0, $jTCZr.C).textPrimary,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                    }
                }, reason), dateStr && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        display: 'block',
                        fontSize: '0.65625rem',
                        color: (0, $jTCZr.C).textMuted,
                        fontWeight: 400
                    }
                }, dateStr)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gKFEi.default), {
                    size: 14,
                    "aria-hidden": true,
                    style: {
                        color: (0, $jTCZr.C).textMuted,
                        flexShrink: 0,
                        transform: `${(0, $asXy3.MIRROR_ICON).transform}${isOpen ? ' rotate(-90deg)' : ''}`,
                        transition: 'transform .2s'
                    }
                })), !isOpen && visitErx?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        padding: '0 0.75rem 0.625rem'
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $jDxJA.ErxCodeChips), {
                    codes: visitErx,
                    touch: true,
                    testid: `visit-past-erx-${encId}`
                })), isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        padding: '0 0.75rem 0.75rem',
                        borderTop: `1px solid ${(0, $jTCZr.C).border}`
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $jDxJA.ErxCodeGroup), {
                    codes: visitErx,
                    touch: true,
                    testid: `visit-past-erx-group-${encId}`,
                    style: {
                        marginTop: '0.625rem'
                    }
                }), sum?.summary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        marginTop: '0.625rem'
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        fontSize: '0.625rem',
                        fontWeight: 700,
                        color: (0, $jTCZr.C).textMuted,
                        letterSpacing: '0.06em',
                        marginBottom: '0.3125rem'
                    }
                }, t('visit.suggest.visitSummary')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        fontSize: '0.71875rem',
                        color: (0, $jTCZr.C).textSecondary,
                        lineHeight: 1.7
                    }
                }, sum.summary)), soapParts.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    "data-testid": `visit-past-soap-${encId}`,
                    style: {
                        marginTop: '0.625rem'
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        fontSize: '0.625rem',
                        fontWeight: 700,
                        color: (0, $jTCZr.C).textMuted,
                        letterSpacing: '0.06em',
                        marginBottom: '0.3125rem'
                    }
                }, t('visit.end.partSoap')), soapParts.map(({ key: key, text: text })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                        key: key,
                        "data-testid": `visit-past-soap-${encId}-${key}`,
                        style: {
                            marginBottom: '0.375rem'
                        }
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                        style: {
                            fontSize: '0.625rem',
                            fontWeight: 700,
                            color: (0, $jTCZr.C).textMuted
                        }
                    }, t($e0b3b7ef84bbae65$var$SOAP_LABEL[key])), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                        dir: "auto",
                        style: {
                            fontSize: '0.71875rem',
                            color: (0, $jTCZr.C).textSecondary,
                            lineHeight: 1.7,
                            whiteSpace: 'pre-wrap'
                        }
                    }, text)))), sum?.suggestedDiagnosis && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.375rem',
                        marginTop: '0.5rem'
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        fontSize: '0.625rem',
                        fontWeight: 700,
                        color: (0, $jTCZr.C).textMuted
                    }
                }, t('visit.print.diagnosis')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        fontSize: '0.6875rem',
                        fontWeight: 600,
                        padding: '0.125rem 0.5rem',
                        borderRadius: '0.25rem',
                        background: (0, $jTCZr.CT).accentSoft,
                        color: (0, $jTCZr.CT).accentInk
                    }
                }, sum.suggestedDiagnosis)), sum?.icdCodes?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '0.25rem',
                        marginTop: '0.5rem'
                    }
                }, sum.icdCodes.map((c, ci)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                        key: ci,
                        dir: "ltr",
                        style: {
                            fontSize: '0.625rem',
                            padding: '0.125rem 0.4375rem',
                            borderRadius: '0.3125rem',
                            background: (0, $jTCZr.CT).surface2,
                            border: `1px solid ${(0, $jTCZr.C).border}`,
                            color: (0, $jTCZr.C).textMuted,
                            fontFamily: 'ui-monospace, monospace'
                        }
                    }, c.code, c.description ? ` \xb7 ${c.description}` : ''))), (()=>{
                    const ctx = enc?.id ? visitContexts[enc.id] : null;
                    if (!enc?.id || !onOpenVisit) return null;
                    if (!ctx || ctx.state === 'loading') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                        "data-testid": `visit-past-detail-${encId}`,
                        "data-state": "loading",
                        "aria-busy": "true",
                        style: {
                            marginTop: '0.625rem'
                        }
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonText), {
                        lines: 2,
                        height: 11,
                        lastWidth: "50%"
                    }));
                    if (ctx.state === 'error') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                        "data-testid": `visit-past-detail-${encId}`,
                        "data-state": "error",
                        style: {
                            marginTop: '0.625rem'
                        }
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                        style: {
                            fontSize: '0.6875rem',
                            color: (0, $jTCZr.CT).dangerInk,
                            marginBottom: '0.25rem'
                        }
                    }, t('errors.load.record')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
                        variant: "ghost",
                        size: "sm",
                        className: "min-h-11",
                        "data-testid": `visit-past-retry-${encId}`,
                        onClick: ()=>onOpenVisit(enc.id)
                    }, t('common.actions.retry')));
                    const d = ctx.data || {};
                    const dxs = d.conditions || [];
                    const cmeds = d.medications || [];
                    const cords = d.orders || [];
                    if (!dxs.length && !cmeds.length && !cords.length) return null;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                        "data-testid": `visit-past-detail-${encId}`,
                        "data-state": "content"
                    }, dxs.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                        style: {
                            marginTop: '0.625rem'
                        }
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                        style: {
                            fontSize: '0.625rem',
                            fontWeight: 700,
                            color: (0, $jTCZr.C).textMuted,
                            letterSpacing: '0.06em',
                            marginBottom: '0.3125rem'
                        }
                    }, t('patient.tabs.conditions')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                        style: {
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: '0.25rem'
                        }
                    }, dxs.map((dx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                            key: dx.id,
                            style: {
                                fontSize: '0.65625rem',
                                padding: '0.125rem 0.4375rem',
                                borderRadius: '0.3125rem',
                                background: (0, $jTCZr.CT).accentSoft,
                                color: (0, $jTCZr.CT).accentInk,
                                fontWeight: 600
                            }
                        }, dx.display, dx.code ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                            dir: "ltr",
                            style: {
                                opacity: 0.7
                            }
                        }, " \xb7 ", dx.code) : null)))), cmeds.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                        style: {
                            marginTop: '0.625rem'
                        }
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                        style: {
                            fontSize: '0.625rem',
                            fontWeight: 700,
                            color: (0, $jTCZr.C).textMuted,
                            letterSpacing: '0.06em',
                            marginBottom: '0.3125rem'
                        }
                    }, t('patient.tabs.medications')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                        style: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '0.375rem'
                        }
                    }, cmeds.map((hm)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                            key: hm.id,
                            style: {
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.5rem'
                            }
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                            style: {
                                flex: 1,
                                minWidth: 0
                            }
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                            style: {
                                fontSize: '0.71875rem',
                                fontWeight: 600,
                                color: (0, $jTCZr.C).textPrimary
                            }
                        }, hm.display), (hm.dosageInstruction?.text || typeof hm.dosageInstruction === 'string') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                            style: {
                                fontSize: '0.625rem',
                                color: (0, $jTCZr.C).textMuted
                            }
                        }, (0, $6xvbB.doseLineLabel)(hm.dosageInstruction?.text || hm.dosageInstruction, t, readsPersianData))), onRepresribeMed && (isPrescribed(hm.display) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                            "data-testid": `visit-history-med-represcribed-${hm.id}`,
                            style: {
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '0.1875rem',
                                fontSize: '0.625rem',
                                fontWeight: 700,
                                color: (0, $jTCZr.CT).good,
                                flexShrink: 0
                            }
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
                            size: 12,
                            "aria-hidden": true
                        }), t('visit.rx.represcribed')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
                            variant: "subtle",
                            size: "sm",
                            className: "min-h-11 gap-1 shrink-0",
                            "data-testid": `visit-history-med-represcribe-${hm.id}`,
                            "aria-label": t('visit.rx.represcribeAria', {
                                name: hm.display
                            }),
                            onClick: ()=>onRepresribeMed(hm)
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $iDwyV.default), {
                            size: 12,
                            "aria-hidden": true
                        }), t('visit.rx.represcribe'))))))), cords.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                        style: {
                            marginTop: '0.625rem'
                        }
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                        style: {
                            fontSize: '0.625rem',
                            fontWeight: 700,
                            color: (0, $jTCZr.C).textMuted,
                            letterSpacing: '0.06em',
                            marginBottom: '0.3125rem'
                        }
                    }, t('visit.orders.request')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                        style: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '0.25rem'
                        }
                    }, cords.map((o)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                            key: o.id,
                            style: {
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.375rem',
                                fontSize: '0.6875rem',
                                color: (0, $jTCZr.C).textSecondary
                            }
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                            style: {
                                flex: 1,
                                minWidth: 0,
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                            }
                        }, o.description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                            style: {
                                fontSize: '0.625rem',
                                color: (0, $jTCZr.C).textMuted,
                                flexShrink: 0
                            }
                        }, o.status))))));
                })(), !sum?.summary && !soapParts.length && !sum?.suggestedDiagnosis && !enc?.id && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        marginTop: '0.625rem',
                        fontSize: '0.71875rem',
                        color: (0, $jTCZr.C).textMuted,
                        fontStyle: 'italic'
                    }
                }, t('visit.patient.noExtra'))));
            })))
        };
        return sectionList.filter(({ id: id })=>blocks[id]).map(({ id: id })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                key: id
            }, blocks[id]));
    })()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3OnFU.default), {
        open: !!pendingStop,
        onOpenChange: (o)=>{
            if (!o) setPendingStop(null);
        },
        title: t('visit.rx.stop'),
        message: t('patient.meds.stopConfirm', {
            name: pendingStop?.display || t('patient.meds.one')
        }),
        confirmLabel: t('visit.rx.stop'),
        cancelLabel: t('common.actions.cancel'),
        destructive: true,
        onConfirm: ()=>{
            if (pendingStop) onStopMed(pendingStop);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3OnFU.default), {
        open: !!pendingDx,
        onOpenChange: (o)=>{
            if (!o) setPendingDx(null);
        },
        title: t('visit.dx.remove'),
        message: t('patient.conditions.deleteConfirmNamed', {
            name: pendingDx?.display || t('patient.conditions.one')
        }),
        confirmLabel: t('common.actions.delete'),
        cancelLabel: t('common.actions.cancel'),
        destructive: true,
        onConfirm: ()=>{
            if (pendingDx) onRemoveDiagnosis?.(pendingDx);
        }
    }));
};
var $e0b3b7ef84bbae65$export$2e2bcd8739ae039 = $e0b3b7ef84bbae65$var$MobileVisitRecordSheet;

});
parcelRegister("jGozX", function(module, exports) {

$parcel$export(module.exports, "isImageFile", () => $d3568b8ed276ce8f$export$3ac008e2b18a7a91);
$parcel$export(module.exports, "default", () => $d3568b8ed276ce8f$export$2e2bcd8739ae039);
$parcel$export(module.exports, "FileTileGrid", () => $d3568b8ed276ce8f$export$1e3cca5896ff088c);

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $5JYPc = parcelRequire("5JYPc");

var $gXsFl = parcelRequire("gXsFl");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $1Qo7B = parcelRequire("1Qo7B");

var $gdEay = parcelRequire("gdEay");

var $eARX3 = parcelRequire("eARX3");

var $3t8yQ = parcelRequire("3t8yQ");

var $d6Clo = parcelRequire("d6Clo");

var $hRWhk = parcelRequire("hRWhk");
// «مدارک بیمار» — one document as a gallery tile (PM-0560, PM-0561).
//
// The row (`FileRow`) says everything about a document; the tile says enough to
// RECOGNISE it — the picture itself, its kind and its date — so the doctor can scan
// twelve lab sheets at once instead of opening each. Pressing a tile never opens an
// overlay of its own: it hands the file to the host, which shows it in the gallery
// viewer (beside the tiles on a wide workstation, a dialog or a full-height sheet
// elsewhere).
//
// A picture is read only once the tile scrolls into view, through the same shared
// read the viewer uses (`lib/fileBytesCache`), so a tile the doctor then opens is
// already there. A PDF, or any type a browser cannot draw small, shows its kind's
// mark and its extension; a DICOM study shows its rendered thumbnail.
//
// Kit `Button` and preset classes only (packages/DESIGN.md rule 1): the tile is a
// real control on every surface, the phone's included (MOBILE_WEB_PWA §8).
const $d3568b8ed276ce8f$var$IMAGE_EXT = /\.(jpe?g|png|webp|gif|bmp|avif)$/i;
function $d3568b8ed276ce8f$export$3ac008e2b18a7a91(file) {
    const type = String(file?.fileType || '').toLowerCase();
    if (type.includes('/')) return type.startsWith('image/');
    return $d3568b8ed276ce8f$var$IMAGE_EXT.test(String(file?.fileName || ''));
}
function $d3568b8ed276ce8f$var$extensionOf(file) {
    const type = String(file?.fileType || '').toLowerCase();
    if (type === 'application/pdf') return 'PDF';
    const m = /\.([a-z0-9]{2,5})$/i.exec(String(file?.fileName || ''));
    return m ? m[1].toUpperCase() : '';
}
// True once the element has come near the viewport. Without IntersectionObserver
// (a test DOM) nothing is read: a tile then shows its kind's mark, which is also
// what it shows while its picture is on the way.
function $d3568b8ed276ce8f$var$useNearViewport(ref) {
    const [near, setNear] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const el = ref.current;
        if (!el || near || typeof IntersectionObserver === 'undefined') return undefined;
        const io = new IntersectionObserver((list)=>{
            if (list.some((e)=>e.isIntersecting)) {
                setNear(true);
                io.disconnect();
            }
        }, {
            rootMargin: '200px'
        });
        io.observe(el);
        return ()=>io.disconnect();
    }, [
        ref,
        near
    ]);
    return near;
}
const $d3568b8ed276ce8f$var$PICTURE_HEIGHT = {
    md: 'h-28',
    sm: 'h-[4.5rem]'
};
function $d3568b8ed276ce8f$var$ThumbPicture({ file: file, size: size }) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const study = (0, $eARX3.isDicomFile)(file) ? file.dicom : null;
    const image = !study && $d3568b8ed276ce8f$export$3ac008e2b18a7a91(file);
    const near = $d3568b8ed276ce8f$var$useNearViewport(ref);
    const view = (0, $3t8yQ.default)(file, {
        enabled: image && near,
        priority: false
    });
    const Icon = (0, $hRWhk.KIND_ICON)[(0, $1Qo7B.canonicalKind)(file.kind)] || (0, $gXsFl.default);
    const ext = $d3568b8ed276ce8f$var$extensionOf(file);
    const ready = image && view.status === 'ready' && view.type.startsWith('image/');
    // Dark only behind a picture that is there; a study's tile paints its own.
    const box = (0, $5JYPc.cn)('relative flex w-full items-center justify-center overflow-hidden border-b border-border', $d3568b8ed276ce8f$var$PICTURE_HEIGHT[size] || $d3568b8ed276ce8f$var$PICTURE_HEIGHT.md, ready ? 'bg-foreground' : 'bg-muted');
    if (study) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        ref: ref,
        className: box,
        "aria-hidden": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d6Clo.default), {
        study: study,
        size: "100%",
        testid: `file-thumb-dicom-${file.id}`
    }));
    if (ready) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        ref: ref,
        className: box,
        "data-state": "content",
        "aria-hidden": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: view.url,
        alt: "",
        className: "block h-full w-full object-cover"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        ref: ref,
        className: box,
        "data-state": image && view.status === 'loading' ? 'loading' : 'fallback',
        "aria-hidden": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "flex flex-col items-center gap-1 text-navy-dark"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        size: 28,
        strokeWidth: 1.5
    }), ext && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "ltr",
        className: "text-[0.625rem] font-bold tracking-wide text-muted-foreground"
    }, ext)));
}
function $d3568b8ed276ce8f$export$2e2bcd8739ae039({ file: file, selected: selected = false, onSelect: onSelect, compact: compact = false, size: sizeProp, badge: badge = null, testid: testid = 'file-thumb', buttonRef: buttonRef }) {
    const { t: t, formatDate: formatDate } = (0, $LNQP4.default)();
    const size = sizeProp || (compact ? 'sm' : 'md');
    const kindKey = (0, $1Qo7B.documentKindLabelKey)(file.kind);
    const date = (0, $gdEay.documentDateOf)(file);
    const name = file.fileName || t('patient.files.unnamed');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        ref: buttonRef,
        type: "button",
        variant: "ghost",
        onClick: ()=>onSelect?.(file),
        "aria-pressed": selected,
        "aria-label": t('patient.files.gallery.open', {
            name: name
        }),
        title: name,
        "data-testid": `${testid}-${file.id}`,
        "data-selected": selected ? 'true' : 'false',
        className: (0, $5JYPc.cn)('flex h-auto w-full min-w-0 flex-col items-stretch justify-start gap-0 overflow-hidden whitespace-normal', 'rounded-lg border-2 p-0 text-start font-normal active:scale-100', selected ? 'border-navy bg-accent hover:bg-accent' : 'border-border bg-white shadow-card hover:bg-white')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "relative block w-full"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d3568b8ed276ce8f$var$ThumbPicture, {
        file: file,
        size: size
    }), badge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "absolute start-1.5 top-1.5"
    }, badge)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $5JYPc.cn)('flex w-full flex-col gap-0.5', size === 'sm' ? 'px-2 py-1.5' : 'px-2.5 pb-2.5 pt-2')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        className: (0, $5JYPc.cn)('truncate font-semibold text-foreground [unicode-bidi:isolate]', size === 'sm' ? 'text-[0.71875rem]' : 'text-[0.78125rem]')
    }, name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "flex min-w-0 flex-wrap items-center justify-between gap-x-1 gap-y-[0.1875rem] text-[0.6875rem] text-muted-foreground"
    }, date && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "whitespace-nowrap"
    }, (0, $hRWhk.formatDocDate)(date, formatDate)), size !== 'sm' && kindKey && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hRWhk.FileChip), {
        className: "max-w-full overflow-hidden text-ellipsis"
    }, t(kindKey)))));
}
function $d3568b8ed276ce8f$export$1e3cca5896ff088c({ files: files, onSelect: onSelect, currentKey: currentKey = null, keyOf: keyOf, badgeFor: badgeFor, size: size = 'md', testid: testid = 'file-thumb', className: className }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "group",
        className: (0, $5JYPc.cn)('grid grid-cols-[repeat(auto-fill,minmax(6rem,1fr))] gap-2', className)
    }, files.map((f)=>{
        const key = keyOf ? keyOf(f) : f.id;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d3568b8ed276ce8f$export$2e2bcd8739ae039, {
            key: key,
            file: f,
            size: size,
            selected: currentKey != null && key === currentKey,
            onSelect: onSelect,
            badge: badgeFor ? badgeFor(f) : null,
            testid: testid
        });
    }));
}

});
parcelRegister("gXsFl", function(module, exports) {

$parcel$export(module.exports, "default", () => $824b163d7442530e$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $824b163d7442530e$export$a2387ed3b5d536eb = {
    name: "paperclip",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m16 6-8.414 8.586a2 2 0 0 0 2.829 2.829l8.414-8.586a4 4 0 1 0-5.657-5.657l-8.379 8.551a6 6 0 1 0 8.485 8.485l8.379-8.551",
                key: "1miecu"
            }
        ]
    ]
};
$824b163d7442530e$export$a2387ed3b5d536eb.node;
const $824b163d7442530e$export$2e2bcd8739ae039 = (0, $9QBug.default)($824b163d7442530e$export$a2387ed3b5d536eb);

});

parcelRegister("gdEay", function(module, exports) {

$parcel$export(module.exports, "parseOcrRows", () => $bced050439dec003$export$ebcae889d05cbae5);
$parcel$export(module.exports, "abnormalRowCount", () => $bced050439dec003$export$6e0aae7ac52ee4b7);
$parcel$export(module.exports, "hasStructuredRows", () => $bced050439dec003$export$c2a61e046b7fd3b2);
$parcel$export(module.exports, "documentDateOf", () => $bced050439dec003$export$8be12e4e93c8dacd);
$parcel$export(module.exports, "uploadDayDiffers", () => $bced050439dec003$export$d791f2a3277ada5e);
$parcel$export(module.exports, "sortByDocumentDate", () => $bced050439dec003$export$a719a8ff130c98cb);
$parcel$export(module.exports, "splitByVisit", () => $bced050439dec003$export$dfcaeb32ab9590ba);
$parcel$export(module.exports, "countNewPatientUploads", () => $bced050439dec003$export$d15fc12d83f90a2c);
// Parsing shared by both «فایل‌ها» surfaces.
//
// The OCR payload is read on the desktop tab and in the phone's file-detail
// sheet. It lived in the desktop helpers, which put the phone one import away
// from a desktop-only module; it lives here so the two surfaces cannot disagree
// about which line is a result and which is unparsed text.
// Line format: "WBC: 6.8 10³/µL (ref: 4.0–10.0) [normal]"
function $bced050439dec003$export$ebcae889d05cbae5(ocrContent) {
    if (!ocrContent) return [];
    return ocrContent.split('\n').map((line)=>{
        const m = line.match(/^(.+?):\s*([\d.<>≤≥\-–]+)\s*([^\s([\]]+)?\s*(?:\(ref:\s*([^)]+)\))?\s*\[([^\]]+)\]$/);
        if (!m) return {
            raw: line
        };
        return {
            testName: m[1].trim(),
            value: m[2].trim(),
            unit: m[3]?.trim() || '',
            refRange: m[4]?.trim() || '',
            status: m[5]?.trim() || 'normal'
        };
    }).filter((r)=>r.testName || r.raw);
}
const $bced050439dec003$export$dff2f0d9dc32e832 = (r)=>!!r.status && r.status !== 'normal' && r.status !== 'unknown';
const $bced050439dec003$export$6e0aae7ac52ee4b7 = (rows)=>rows.filter($bced050439dec003$export$dff2f0d9dc32e832).length;
const $bced050439dec003$export$c2a61e046b7fd3b2 = (rows)=>rows.some((r)=>r.testName);
// ── Dates and grouping (docs/DOCTOR_PATIENT_FILES_AND_AI_EXTRACTION_DESIGN.md §7.1) ──
const $bced050439dec003$var$IRAN_DAY = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Tehran',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
});
function $bced050439dec003$export$bb0bcaf0a6a50714(iso) {
    const d = new Date(iso);
    if (!iso || Number.isNaN(d.getTime())) return '';
    const parts = {};
    for (const { type: type, value: value } of $bced050439dec003$var$IRAN_DAY.formatToParts(d))parts[type] = value;
    return `${parts.year}-${parts.month}-${parts.day}`;
}
function $bced050439dec003$export$8be12e4e93c8dacd(file) {
    return file?.documentDate || $bced050439dec003$export$bb0bcaf0a6a50714(file?.createdAt) || '';
}
function $bced050439dec003$export$d791f2a3277ada5e(file) {
    return Boolean(file?.documentDate && file?.createdAt && $bced050439dec003$export$bb0bcaf0a6a50714(file.createdAt) !== file.documentDate);
}
function $bced050439dec003$export$a719a8ff130c98cb(files) {
    return (files || []).slice().sort((a, b)=>$bced050439dec003$export$8be12e4e93c8dacd(b).localeCompare($bced050439dec003$export$8be12e4e93c8dacd(a)) || String(b.createdAt || '').localeCompare(String(a.createdAt || '')));
}
function $bced050439dec003$export$dfcaeb32ab9590ba(files, appointmentId) {
    const sorted = $bced050439dec003$export$a719a8ff130c98cb(files);
    if (!appointmentId) return {
        thisVisit: [],
        others: sorted
    };
    return {
        thisVisit: sorted.filter((f)=>f.appointmentId === appointmentId),
        others: sorted.filter((f)=>f.appointmentId !== appointmentId)
    };
}
function $bced050439dec003$export$d15fc12d83f90a2c(files, sinceIso) {
    if (!sinceIso) return 0;
    return (files || []).filter((f)=>f.uploadedBy === 'patient' && String(f.createdAt || '') > sinceIso).length;
}

});

parcelRegister("eARX3", function(module, exports) {

$parcel$export(module.exports, "dicomWebRoot", () => $a9fe471dd730c044$export$1b4f8208f28b4aed);
$parcel$export(module.exports, "thumbnailUrl", () => $a9fe471dd730c044$export$e382c1f734fd6fcc);
$parcel$export(module.exports, "renderedUrl", () => $a9fe471dd730c044$export$4c5664a761278db0);
$parcel$export(module.exports, "fetchObjectUrl", () => $a9fe471dd730c044$export$3a2589cc21066709);
$parcel$export(module.exports, "presetsForModality", () => $a9fe471dd730c044$export$5d687327647c3afb);
$parcel$export(module.exports, "presetWindow", () => $a9fe471dd730c044$export$8fc65bc1bd573695);
$parcel$export(module.exports, "representativeSeries", () => $a9fe471dd730c044$export$ccb65542726085d6);
$parcel$export(module.exports, "framesOf", () => $a9fe471dd730c044$export$3963a516697574a);
$parcel$export(module.exports, "hasDocumentObjects", () => $a9fe471dd730c044$export$5fe06db7379f90a6);
$parcel$export(module.exports, "isDicomFile", () => $a9fe471dd730c044$export$918b21086f1a685e);

var $a4gAe = parcelRequire("a4gAe");
const $a9fe471dd730c044$export$1b4f8208f28b4aed = ()=>`${(0, $a4gAe.bffOrigin)()}/dicom-web`;
const $a9fe471dd730c044$var$enc = encodeURIComponent;
function $a9fe471dd730c044$export$e382c1f734fd6fcc(studyUid, seriesUid) {
    return `${$a9fe471dd730c044$export$1b4f8208f28b4aed()}/studies/${$a9fe471dd730c044$var$enc(studyUid)}/series/${$a9fe471dd730c044$var$enc(seriesUid)}/thumbnail`;
}
function $a9fe471dd730c044$export$4c5664a761278db0(studyUid, seriesUid, sopUid, { frame: frame = 1, window: window = null, size: size = 1024 } = {}) {
    const q = new URLSearchParams({
        frame: String(frame),
        size: String(size)
    });
    if (window) q.set('window', window);
    return `${$a9fe471dd730c044$export$1b4f8208f28b4aed()}/studies/${$a9fe471dd730c044$var$enc(studyUid)}/series/${$a9fe471dd730c044$var$enc(seriesUid)}/instances/${$a9fe471dd730c044$var$enc(sopUid)}/rendered?${q}`;
}
async function $a9fe471dd730c044$export$3a2589cc21066709(url, { signal: signal } = {}) {
    const res = await fetch(url, {
        headers: {
            ...await (0, $a4gAe.authHeader)(),
            Accept: 'image/jpeg, image/*'
        },
        signal: signal
    });
    if (!res.ok) {
        const err = new Error(`image ${res.status}`);
        err.status = res.status;
        throw err;
    }
    const blob = await res.blob();
    return URL.createObjectURL(blob);
}
const $a9fe471dd730c044$export$225fbfbd424a214e = Object.freeze([
    {
        id: 'brain',
        center: 40,
        width: 80
    },
    {
        id: 'lung',
        center: -600,
        width: 1500
    },
    {
        id: 'bone',
        center: 300,
        width: 1500
    },
    {
        id: 'abdomen',
        center: 40,
        width: 400
    },
    {
        id: 'softTissue',
        center: 50,
        width: 350
    }
]);
const $a9fe471dd730c044$export$eaa947fb3d44a841 = Object.freeze({
    id: 'auto',
    center: null,
    width: null
});
function $a9fe471dd730c044$export$5d687327647c3afb(modality) {
    return String(modality || '').toUpperCase() === 'CT' ? [
        $a9fe471dd730c044$export$eaa947fb3d44a841,
        ...$a9fe471dd730c044$export$225fbfbd424a214e
    ] : [
        $a9fe471dd730c044$export$eaa947fb3d44a841
    ];
}
function $a9fe471dd730c044$export$8fc65bc1bd573695(presetId, modality) {
    const p = $a9fe471dd730c044$export$5d687327647c3afb(modality).find((x)=>x.id === presetId);
    return p && p.center != null ? `${p.center},${p.width}` : null;
}
function $a9fe471dd730c044$export$ccb65542726085d6(study) {
    const list = study?.series || [];
    return list.reduce((best, s)=>!best || (s.instances || 0) > (best.instances || 0) ? s : best, null);
}
function $a9fe471dd730c044$export$3963a516697574a(series) {
    const out = [];
    (series?.instances || []).slice().sort((a, b)=>(a.number ?? 0) - (b.number ?? 0)).forEach((inst)=>{
        const n = Math.max(1, inst.frames || 1);
        for(let f = 1; f <= n; f += 1)out.push({
            sopUid: inst.sopUid,
            frame: f
        });
    });
    return out;
}
function $a9fe471dd730c044$export$5fe06db7379f90a6(study) {
    const d = study?.documentObjects;
    return Boolean(d && (d.sr || 0) + (d.encapsulatedPdf || 0) + (d.secondaryCapture || 0) > 0);
}
const $a9fe471dd730c044$export$918b21086f1a685e = (file)=>String(file?.mediaClass || '').toLowerCase() === 'dicom';

});
parcelRegister("a4gAe", function(module, exports) {

$parcel$export(module.exports, "bffOrigin", () => $75472431f73f934f$export$a9b90d04cbeb257e);
$parcel$export(module.exports, "DicomSessionError", () => $75472431f73f934f$export$ed9681397fa5101a);
$parcel$export(module.exports, "authHeader", () => $75472431f73f934f$export$a3b7721557df7601);
$parcel$export(module.exports, "openSession", () => $75472431f73f934f$export$19459b3f81b4a899);
$parcel$export(module.exports, "commitSession", () => $75472431f73f934f$export$1215abca88606fce);
$parcel$export(module.exports, "abortSession", () => $75472431f73f934f$export$a19aba171dab428);
$parcel$export(module.exports, "sendBatch", () => $75472431f73f934f$export$f884bdf12a147dbe);
$parcel$export(module.exports, "isRetryable", () => $75472431f73f934f$export$f146c102d7613638);

var $a83Oj = parcelRequire("a83Oj");

var $k9wwH = parcelRequire("k9wwH");
const $75472431f73f934f$export$a9b90d04cbeb257e = ()=>(0, $k9wwH.bffUrl)().replace(/\/graphql\/?$/, '');
class $75472431f73f934f$export$ed9681397fa5101a extends Error {
    constructor(code, message, status = 0, body = null){
        super(message || code);
        this.name = 'DicomSessionError';
        this.code = code;
        this.status = status;
        this.body = body;
    }
}
async function $75472431f73f934f$export$a3b7721557df7601() {
    const token = await (0, $a83Oj.getValidToken)();
    if (!token) throw new $75472431f73f934f$export$ed9681397fa5101a('UNAUTHENTICATED', 'Not authenticated', 401);
    return {
        Authorization: `Bearer ${token}`
    };
}
const $75472431f73f934f$var$errorFrom = (status, body)=>new $75472431f73f934f$export$ed9681397fa5101a(body?.code || (status === 413 ? 'DICOM_INSTANCE_TOO_LARGE' : status === 404 ? 'FORBIDDEN' : `HTTP_${status}`), body?.message || '', status, body);
async function $75472431f73f934f$var$requestJson(method, path, body, { signal: signal } = {}) {
    let res;
    try {
        res = await fetch(`${$75472431f73f934f$export$a9b90d04cbeb257e()}${path}`, {
            method: method,
            headers: {
                ...await $75472431f73f934f$export$a3b7721557df7601(),
                ...body ? {
                    'Content-Type': 'application/json'
                } : {}
            },
            body: body ? JSON.stringify(body) : undefined,
            signal: signal
        });
    } catch (e) {
        if (e?.name === 'AbortError') throw new $75472431f73f934f$export$ed9681397fa5101a('ABORTED', 'aborted');
        if (e instanceof $75472431f73f934f$export$ed9681397fa5101a) throw e;
        throw new $75472431f73f934f$export$ed9681397fa5101a('NETWORK', e?.message || 'network');
    }
    let data = null;
    try {
        data = res.status === 204 ? null : await res.json();
    } catch  {}
    if (!res.ok) throw $75472431f73f934f$var$errorFrom(res.status, data);
    return data;
}
function $75472431f73f934f$export$19459b3f81b4a899(payload, opts) {
    return $75472431f73f934f$var$requestJson('POST', '/dicom/sessions', payload, opts);
}
function $75472431f73f934f$export$1215abca88606fce(sessionId, payload, opts) {
    return $75472431f73f934f$var$requestJson('POST', `/dicom/sessions/${encodeURIComponent(sessionId)}/commit`, payload || {}, opts);
}
async function $75472431f73f934f$export$a19aba171dab428(sessionId) {
    if (!sessionId) return;
    try {
        await $75472431f73f934f$var$requestJson('DELETE', `/dicom/sessions/${encodeURIComponent(sessionId)}`);
    } catch  {}
}
function $75472431f73f934f$export$f884bdf12a147dbe(sessionId, instances, { onProgress: onProgress, signal: signal } = {}) {
    return $75472431f73f934f$export$a3b7721557df7601().then((headers)=>new Promise((resolve, reject)=>{
            const form = new FormData();
            instances.forEach((it)=>form.append('files', it.file, it.name || it.file?.name || 'instance.dcm'));
            const xhr = new XMLHttpRequest();
            xhr.open('POST', `${$75472431f73f934f$export$a9b90d04cbeb257e()}/dicom/sessions/${encodeURIComponent(sessionId)}/batches`);
            Object.entries(headers).forEach(([k, v])=>xhr.setRequestHeader(k, v));
            const onAbort = ()=>xhr.abort();
            if (signal) {
                if (signal.aborted) {
                    reject(new $75472431f73f934f$export$ed9681397fa5101a('ABORTED', 'aborted'));
                    return;
                }
                signal.addEventListener('abort', onAbort, {
                    once: true
                });
            }
            const done = ()=>signal?.removeEventListener?.('abort', onAbort);
            xhr.upload.onprogress = (e)=>{
                if (e.lengthComputable) onProgress?.(e.loaded);
            };
            xhr.onload = ()=>{
                done();
                let body = null;
                try {
                    body = JSON.parse(xhr.responseText);
                } catch  {}
                if (xhr.status >= 200 && xhr.status < 300) resolve(body || {});
                else reject($75472431f73f934f$var$errorFrom(xhr.status, body));
            };
            xhr.onerror = ()=>{
                done();
                reject(new $75472431f73f934f$export$ed9681397fa5101a('NETWORK', 'network error during upload'));
            };
            xhr.onabort = ()=>{
                done();
                reject(new $75472431f73f934f$export$ed9681397fa5101a('ABORTED', 'aborted'));
            };
            xhr.send(form);
        }));
}
function $75472431f73f934f$export$f146c102d7613638(err) {
    if (!err || err.code === 'ABORTED') return false;
    if (err.code === 'NETWORK') return true;
    return err.status === 408 || err.status === 429 || err.status >= 500 && err.code !== 'DICOM_RECORD_PENDING';
}

});


parcelRegister("3t8yQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $286ab8933969f880$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $5WzF8 = parcelRequire("5WzF8");
function $286ab8933969f880$export$2e2bcd8739ae039(file, { enabled: enabled = true, priority: priority = true } = {}) {
    const [view, setView] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        status: 'loading',
        url: null,
        type: ''
    });
    const [attempt, setAttempt] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    const active = Boolean(file?.id && enabled);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!active) return undefined;
        let cancelled = false;
        let hold = null;
        // Started inside a promise so a client that throws synchronously becomes the
        // error state instead of an exception that unmounts the whole overlay.
        try {
            hold = (0, $5WzF8.acquireFileBytes)(file, {
                priority: priority
            });
        } catch  {
            setView({
                status: 'error',
                url: null,
                type: ''
            });
            return undefined;
        }
        if (hold.ready) setView({
            status: 'ready',
            ...hold.ready
        });
        else setView({
            status: 'loading',
            url: null,
            type: ''
        });
        hold.promise.then((v)=>{
            if (!cancelled) setView({
                status: 'ready',
                url: v.url,
                type: v.type
            });
        }, ()=>{
            if (!cancelled) setView({
                status: 'error',
                url: null,
                type: ''
            });
        });
        return ()=>{
            cancelled = true;
            hold.release();
        };
    }, [
        active,
        file?.id,
        file?._source,
        file?.fileType,
        attempt
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const retry = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>setAttempt((n)=>n + 1), []);
    if (!active) return {
        status: 'idle',
        url: null,
        type: '',
        retry: retry
    };
    return {
        ...view,
        retry: retry
    };
}

});
parcelRegister("5WzF8", function(module, exports) {

$parcel$export(module.exports, "fileBytesKey", () => $453e085cfa47644c$export$9f71412f7c958d98);
$parcel$export(module.exports, "acquireFileBytes", () => $453e085cfa47644c$export$fe9ba799a64e1920);
$parcel$export(module.exports, "prefetchFileBytes", () => $453e085cfa47644c$export$b59945cf955526ae);

var $eVM84 = parcelRequire("eVM84");

var $j7Lry = parcelRequire("j7Lry");

var $3VOBa = parcelRequire("3VOBa");
// The bytes of a stored document, read once per page and shared (PM-0560).
//
// The gallery shows a file three ways — its thumbnail, the large viewer, and the
// neighbour it prefetches so «بعدی» is instant. Each used to read the file through
// its own `useFileObjectUrl`, so flipping through twelve pictures cost twelve reads
// and every reopen read again. Here one read becomes one object URL, handed to
// every holder by reference count.
//
// Object URLs stay opaque (DESIGN_CONCEPT §13.2: the document never appears in a URL).
// A URL nobody holds is kept for a short while so a doctor paging back and forth does
// not re-read it, and the least recently used are revoked past KEEP_IDLE. A failed read
// is never cached: the next holder, or «تلاش دوباره», reads again.
//
// At most MAX_PARALLEL reads run at once, so a grid of thumbnails coming into view
// does not queue twenty base64 payloads ahead of the file the doctor just clicked —
// `priority` puts the viewer's read at the head of the queue.
const $453e085cfa47644c$var$KEEP_IDLE = 24;
const $453e085cfa47644c$var$MAX_PARALLEL = 3;
const $453e085cfa47644c$var$entries = new Map(); // key -> { promise, url, type, refs, lastUsed }
const $453e085cfa47644c$var$queue = [];
let $453e085cfa47644c$var$active = 0;
const $453e085cfa47644c$export$9f71412f7c958d98 = (file)=>`${file?._source === 'storage' ? 'storage' : 'clinical'}:${file?.id}`;
function $453e085cfa47644c$var$pump() {
    while($453e085cfa47644c$var$active < $453e085cfa47644c$var$MAX_PARALLEL && $453e085cfa47644c$var$queue.length){
        const job = $453e085cfa47644c$var$queue.shift();
        $453e085cfa47644c$var$active += 1;
        Promise.resolve().then(job.task).then(job.resolve, job.reject).finally(()=>{
            $453e085cfa47644c$var$active -= 1;
            $453e085cfa47644c$var$pump();
        });
    }
}
function $453e085cfa47644c$var$schedule(task, priority) {
    return new Promise((resolve, reject)=>{
        const job = {
            task: task,
            resolve: resolve,
            reject: reject
        };
        if (priority) $453e085cfa47644c$var$queue.unshift(job);
        else $453e085cfa47644c$var$queue.push(job);
        $453e085cfa47644c$var$pump();
    });
}
function $453e085cfa47644c$var$readBytes(file) {
    const read = file._source === 'storage' ? (0, $eVM84.bffQuery)((0, $j7Lry.STORAGE_LAB_FILE_URL), {
        id: file.id
    }).then((d)=>d?.storageLabFileUrl) : (0, $eVM84.bffQuery)((0, $j7Lry.GET_FILE_URL), {
        fileId: file.id
    }).then((d)=>d?.clinicalFileUrl);
    return read.then((uri)=>{
        const parts = (0, $3VOBa.splitDataUri)(uri);
        if (!parts) throw new Error('empty');
        // The row's own MIME when it has one; storage only infers a type from the name.
        const type = String(file.fileType || '').includes('/') ? file.fileType : parts.contentType;
        return {
            url: URL.createObjectURL((0, $3VOBa.base64ToBlob)(parts.data, type)),
            type: type
        };
    });
}
function $453e085cfa47644c$var$trim() {
    const idle = [
        ...$453e085cfa47644c$var$entries
    ].filter(([, e])=>e.refs <= 0 && e.url);
    if (idle.length <= $453e085cfa47644c$var$KEEP_IDLE) return;
    idle.sort((a, b)=>a[1].lastUsed - b[1].lastUsed);
    idle.slice(0, idle.length - $453e085cfa47644c$var$KEEP_IDLE).forEach(([key, e])=>{
        URL.revokeObjectURL(e.url);
        $453e085cfa47644c$var$entries.delete(key);
    });
}
function $453e085cfa47644c$export$fe9ba799a64e1920(file, { priority: priority = false } = {}) {
    const key = $453e085cfa47644c$export$9f71412f7c958d98(file);
    let entry = $453e085cfa47644c$var$entries.get(key);
    if (!entry) {
        entry = {
            refs: 0,
            url: null,
            type: '',
            lastUsed: Date.now()
        };
        entry.promise = $453e085cfa47644c$var$schedule(()=>$453e085cfa47644c$var$readBytes(file), priority).then((v)=>{
            entry.url = v.url;
            entry.type = v.type;
            return v;
        });
        entry.promise.catch(()=>{
            if ($453e085cfa47644c$var$entries.get(key) === entry) $453e085cfa47644c$var$entries.delete(key);
        });
        $453e085cfa47644c$var$entries.set(key, entry);
    }
    entry.refs += 1;
    entry.lastUsed = Date.now();
    let released = false;
    return {
        ready: entry.url ? {
            url: entry.url,
            type: entry.type
        } : null,
        promise: entry.promise,
        release: ()=>{
            if (released) return;
            released = true;
            entry.refs -= 1;
            entry.lastUsed = Date.now();
            $453e085cfa47644c$var$trim();
        }
    };
}
function $453e085cfa47644c$export$b59945cf955526ae(file) {
    if (!file?.id) return;
    const hold = $453e085cfa47644c$export$fe9ba799a64e1920(file);
    hold.promise.catch(()=>{}).finally(hold.release);
}
function $453e085cfa47644c$export$9ec88a93121b7cbd() {
    $453e085cfa47644c$var$entries.forEach((e)=>{
        if (e.url) URL.revokeObjectURL(e.url);
    });
    $453e085cfa47644c$var$entries.clear();
    $453e085cfa47644c$var$queue.length = 0;
    $453e085cfa47644c$var$active = 0;
}

});
parcelRegister("j7Lry", function(module, exports) {

$parcel$export(module.exports, "DELETE_MEDICATION", () => $dec379065a898322$export$608c51c2a533f155);
$parcel$export(module.exports, "DELETE_OBSERVATION", () => $dec379065a898322$export$725e3ec3814f10de);
$parcel$export(module.exports, "ASK_PATIENT_AI", () => $dec379065a898322$export$b57f2fa191d92b55);
$parcel$export(module.exports, "LIST_DOCTOR_ORDERS_ENC", () => $dec379065a898322$export$c49184db1de2de24);
$parcel$export(module.exports, "REVIEW_ORDER_RESULT", () => $dec379065a898322$export$a62561eb8157d4fe);
$parcel$export(module.exports, "LIST_DOCTOR_ORDERS", () => $dec379065a898322$export$25ba33c54a6be1ed);
$parcel$export(module.exports, "GET_FILE_URL", () => $dec379065a898322$export$2d0ba8abb4a3a0eb);
$parcel$export(module.exports, "STORAGE_LAB_FILES", () => $dec379065a898322$export$ef15c8f83a956e90);
$parcel$export(module.exports, "STORAGE_LAB_FILE_URL", () => $dec379065a898322$export$6b196bd9c5c0429b);
$parcel$export(module.exports, "DELETE_STORAGE_LAB_FILE", () => $dec379065a898322$export$9ae3a22786248a30);
$parcel$export(module.exports, "LIST_DOCTOR_ORDERS_VISITS", () => $dec379065a898322$export$c97661997f8a2b63);
$parcel$export(module.exports, "UPLOAD_CLINICAL_FILE", () => $dec379065a898322$export$81a8e54dcce2ae4a);
$parcel$export(module.exports, "UPDATE_CLINICAL_FILE", () => $dec379065a898322$export$ab95be7703af4e9d);
$parcel$export(module.exports, "DELETE_CLINICAL_FILE", () => $dec379065a898322$export$75adfe99f4855836);
$parcel$export(module.exports, "EXTRACT_CLINICAL_FILE", () => $dec379065a898322$export$8e0c20a74feb40eb);
$parcel$export(module.exports, "LAB_REVIEW", () => $dec379065a898322$export$dfd091d72822b70);
$parcel$export(module.exports, "SAVE_PRESCRIPTION_EXTRACTION", () => $dec379065a898322$export$929a9aed56e6870c);
$parcel$export(module.exports, "SAVE_MEDICAL_RECORD_EXTRACTION", () => $dec379065a898322$export$56698d1fe562d38e);
$parcel$export(module.exports, "UPLOAD_CAPABILITIES", () => $dec379065a898322$export$3dd1b73433915098);
$parcel$export(module.exports, "UPLOAD_POLICY", () => $dec379065a898322$export$4d54656f1bf91c28);
$parcel$export(module.exports, "DICOM_STUDY_VIEWER", () => $dec379065a898322$export$5ba246e021e79195);
$parcel$export(module.exports, "CONFIRM_DICOM_PATIENT_MATCH", () => $dec379065a898322$export$f6a06f00c2ea9339);
$parcel$export(module.exports, "CLINICAL_FILE_ANALYSES", () => $dec379065a898322$export$edb578819a2e86f4);
$parcel$export(module.exports, "SAVE_CLINICAL_REPORT", () => $dec379065a898322$export$12566aca247381aa);
$parcel$export(module.exports, "SAVE_LAB_RESULTS_FOR_FILE", () => $dec379065a898322$export$1541403edf337a0);
$parcel$export(module.exports, "CLINICAL_FILE_DOWNLOAD", () => $dec379065a898322$export$a7d989aaa610e68c);
$parcel$export(module.exports, "LIST_RESULT_ORDERS", () => $dec379065a898322$export$b25799d4be2e0e7b);
// Single source for the desktop Patient record's GraphQL contract.
// (Edit/delete of the patient itself is intentionally absent — the doctor app
// never mutates core demographics from this screen.)
// ── Clinical data ─────────────────────────────────────────────────────────────
const $dec379065a898322$export$5fcaf1729c987f4d = `mutation CreateMedication($patientId:ID!,$input:MedicationInput!){createMedication(patientId:$patientId,input:$input){id}}`;
const $dec379065a898322$export$608c51c2a533f155 = `mutation DeleteMedication($id: ID!) { deleteMedication(id: $id) }`;
const $dec379065a898322$export$725e3ec3814f10de = `mutation DeleteObservation($id: ID!) { deleteObservation(id: $id) }`;
const $dec379065a898322$export$810f8877c7c31725 = `query QueryVitalTimeSeries($patientId:ID!,$codes:[String!]){queryVitalTimeSeries(patientId:$patientId,codes:$codes){code display unit points{timestamp value}}}`;
const $dec379065a898322$export$b57f2fa191d92b55 = `
  query AskDoctorQuestion($question: String!, $patientId: ID, $conversationHistory: [ChatTurnInput!]) {
    askDoctorQuestion(question: $question, patientId: $patientId, conversationHistory: $conversationHistory) {
      answer confidence followUpSuggestions referencedVisitIds
    }
  }
`;
const $dec379065a898322$export$c49184db1de2de24 = `
  query ListDoctorOrdersEnc($patientId: ID!, $appointmentId: ID) {
    listDoctorOrders(patientId: $patientId, appointmentId: $appointmentId) {
      id appointmentId patientId orderType name code urgency status notes createdAt performedDate
      performedHere stage nextBookingAt
      reviewStatus lastResultAt reviewVerdict reviewNote reviewedAt reviewedResultAt
      resultFiles { id fileName fileType createdAt uploadedBy reportText }
    }
  }
`;
const $dec379065a898322$export$a62561eb8157d4fe = `
  mutation ReviewOrderResult($orderId: ID!, $verdict: ResultVerdict!, $note: String, $seenResultAt: String) {
    reviewOrderResult(orderId: $orderId, verdict: $verdict, note: $note, seenResultAt: $seenResultAt) {
      id status reviewStatus reviewVerdict reviewNote reviewedAt reviewedResultAt lastResultAt
    }
  }
`;
const $dec379065a898322$export$b621353cbd29d7b3 = `
  query PendingResultReviews($limit: Int) {
    pendingResultReviews(limit: $limit) {
      patientId patientName appointmentId submittedAt
      order { id name orderType code reviewStatus lastResultAt }
    }
  }
`;
const $dec379065a898322$export$25ba33c54a6be1ed = `query ListDoctorOrders($patientId:ID!){listDoctorOrders(patientId:$patientId){id appointmentId orderType name code urgency status notes createdAt performedDate performedHere stage nextBookingAt}}`;
const $dec379065a898322$export$718ae50ae5858c4c = `mutation UpdateDoctorOrder($orderId:ID!,$status:String,$notes:String){updateDoctorOrder(orderId:$orderId,status:$status,notes:$notes){id status}}`;
const $dec379065a898322$export$2d0ba8abb4a3a0eb = `query GetFileUrl($fileId: ID!) { clinicalFileUrl(fileId: $fileId) }`;
const $dec379065a898322$export$ef15c8f83a956e90 = `query StorageLabFiles($patientId: ID!) { storageLabFiles(patientId: $patientId) { id fileName fileType fileSize createdAt appointmentId } }`;
const $dec379065a898322$export$6b196bd9c5c0429b = `query StorageLabFileUrl($id: ID!) { storageLabFileUrl(id: $id) }`;
const $dec379065a898322$export$9ae3a22786248a30 = `mutation DeleteStorageLabFile($id: ID!) { deleteStorageLabFile(id: $id) }`;
const $dec379065a898322$export$2b5fa1bb7f71febd = `mutation DeleteLabFile($id: ID!) { deleteLabFile(id: $id) }`;
const $dec379065a898322$export$c97661997f8a2b63 = `query ListDoctorOrders($patientId:ID!){listDoctorOrders(patientId:$patientId){id appointmentId orderType name code urgency status notes createdAt performedDate performedHere stage nextBookingAt}}`;
const $dec379065a898322$export$34ea31500f2ab29c = `
  studyId studyUid modalities studyDate studyTime description bodyParts
  seriesCount instanceCount storedBytes lossySource transcoded identityCheck
  institutionName referringPhysician accessionNumber origin viewable rendered
  series { seriesId seriesUid number modality description instances frames lossy }
  documentObjects { sr encapsulatedPdf secondaryCapture }
  headerPatient { name birthDate sex }
`;
const $dec379065a898322$export$aa44142d485ff6ab = `
  id patientId doctorId appointmentId orderId fileName fileType fileUrl ocrContent createdAt
  uploadedBy clinicId kind fileSize documentDate description
  processingStatus processingError processedAt
  canEdit editScope canDelete extractable promotedAt
  resolvedOrder { id description orderType status }
  mediaClass originalSize
  optimization { profile outcome by originalBytes storedBytes }
  dicom { ${$dec379065a898322$export$34ea31500f2ab29c} }
`;
const $dec379065a898322$var$PRESCRIPTION_ITEM_FIELDS = `
  drugText strength form dose frequency frequencyCode route duration quantity instructions
  sourceText confidence verified selectedDrugId
  candidates { drugId name genericName strength form score }
`;
const $dec379065a898322$var$EXTRACTION_RUN_FIELDS = `
  id fileId status mode documentType summaryText clinicalNotes
  abnormalFlags recommendedActions diagnoses costParseh errorCode createdAt detectedDocumentDate
  labResults {
    testName value unit referenceRange status
    sourceText confidence verified panel specimen flagOnDocument referenceRangeText flag
    row testKey region { page x y width height }
  }
  medications { name dosage frequency }
  report { fullText modality bodyRegion reportDate sections { key title text } }
  documentClass classConfidence handwriting legibility promptVersion classSource truncatedPages
  kindSuggestion patientNameOnDocument charged
  flags { code path message }
  prescription {
    prescriberName prescriberSpecialty medicalCouncilNo prescribedOn prescribedOnIso
    diagnosesText notes transcript
    items { ${$dec379065a898322$var$PRESCRIPTION_ITEM_FIELDS} }
  }
  note {
    transcript diagnosesText medicationsText legibility
    lines { text confidence }
    sections { key title text }
  }
  record {
    recordType facility admissionDate dischargeDate followUp fullText
    sections { key title text }
    diagnoses { text icd10Hint sourceText verified }
    procedures { text date }
    medications { ${$dec379065a898322$var$PRESCRIPTION_ITEM_FIELDS} }
  }
`;
const $dec379065a898322$export$81a8e54dcce2ae4a = `mutation UploadClinicalFile($input: UploadClinicalFileInput!) { uploadClinicalFile(input: $input) { ${$dec379065a898322$export$aa44142d485ff6ab} } }`;
const $dec379065a898322$export$ab95be7703af4e9d = `mutation UpdateClinicalFile($fileId: ID!, $input: UpdateClinicalFileInput!) { updateClinicalFile(fileId: $fileId, input: $input) { ${$dec379065a898322$export$aa44142d485ff6ab} } }`;
const $dec379065a898322$export$75adfe99f4855836 = `mutation DeleteClinicalFile($fileId: ID!) { deleteClinicalFile(fileId: $fileId) }`;
const $dec379065a898322$export$8e0c20a74feb40eb = `mutation ExtractClinicalFile($fileId: ID!, $mode: ClinicalExtractionMode, $classOverride: ClinicalDocumentClass) { extractClinicalFile(fileId: $fileId, mode: $mode, classOverride: $classOverride) { ${$dec379065a898322$var$EXTRACTION_RUN_FIELDS} } }`;
// The lab review's database half (docs/lab_results_ocr_wireframe_ai_agent.md): the unit,
// reference range and status of each OCR row for THIS patient, the test catalogue an
// unmatched row picks from, and the OCR confidence bands. Free — no model runs.
const $dec379065a898322$var$LAB_REFERENCE_FIELDS = 'testKey matched displayName unit low high criticalLow criticalHigh referenceText referenceAvailable missingReason basis interpretation critical status';
const $dec379065a898322$export$dfd091d72822b70 = `query LabReview($patientId: ID!, $items: [LabReferenceQueryInput!]!) { labReview(patientId: $patientId, items: $items) { items { ${$dec379065a898322$var$LAB_REFERENCE_FIELDS} } catalog { ${$dec379065a898322$var$LAB_REFERENCE_FIELDS} } policy { acceptConfidence reviewConfidence } patientSex patientAgeYears } }`;
const $dec379065a898322$export$929a9aed56e6870c = `mutation SavePrescriptionExtraction($input: SavePrescriptionExtractionInput!) { savePrescriptionExtraction(input: $input) { saved failed file { ${$dec379065a898322$export$aa44142d485ff6ab} } } }`;
const $dec379065a898322$export$56698d1fe562d38e = `mutation SaveMedicalRecordExtraction($input: SaveMedicalRecordExtractionInput!) { saveMedicalRecordExtraction(input: $input) { saved failed file { ${$dec379065a898322$export$aa44142d485ff6ab} } } }`;
// ── Upload limits, capabilities and DICOM (DICOM_COMPRESSION_LIMITS… §24.8) ──
const $dec379065a898322$var$UPLOAD_CEILINGS_FIELDS = 'ceilings { documentBytes dicomInstanceBytes dicomBatchBytes dicomStudyBytes }';
const $dec379065a898322$var$PRACTITIONER_UPLOAD_SETTINGS_FIELDS = `
  sizeLimitEnabled maxFileBytes dicomEnabled ${$dec379065a898322$var$UPLOAD_CEILINGS_FIELDS}
  clinics { clinicId clinicName sizeLimitEnabled maxFileBytes locked sources { field source } }
`;
const $dec379065a898322$export$3dd1b73433915098 = `query UploadCapabilities { uploadCapabilities { dicom rendered optimizeMode maxInstanceBytes maxBatchBytes } }`;
const $dec379065a898322$export$4d54656f1bf91c28 = `query UploadPolicy($patientId: ID!, $clinicId: ID, $kind: ClinicalDocumentKind) { uploadPolicy(patientId: $patientId, clinicId: $clinicId, kind: $kind) { maxFileBytes sizeLimitEnabled sizeLimitLocked configuredMaxFileBytes allowedMime maxFilesPerUpload dicomEnabled maxDicomStudyBytes maxDicomStudyInstances ${$dec379065a898322$var$UPLOAD_CEILINGS_FIELDS} sources { field source } } }`;
const $dec379065a898322$export$76c7df4da1e249d1 = `query MyUploadSettings { myUploadSettings { ${$dec379065a898322$var$PRACTITIONER_UPLOAD_SETTINGS_FIELDS} } }`;
const $dec379065a898322$export$15b6bccfe535d9ba = `mutation UpdateMyUploadSettings($input: UploadSettingsInput!, $mask: [String!]!) { updateMyUploadSettings(input: $input, mask: $mask) { ${$dec379065a898322$var$PRACTITIONER_UPLOAD_SETTINGS_FIELDS} } }`;
const $dec379065a898322$export$5ba246e021e79195 = `query DicomStudyViewer($fileId: ID!) { dicomStudyViewer(fileId: $fileId) { studyUid rendered series { seriesId seriesUid number modality description lossy instances { instanceId sopUid number frames } } } }`;
const $dec379065a898322$export$f6a06f00c2ea9339 = `mutation ConfirmDicomPatientMatch($fileId: ID!) { confirmDicomPatientMatch(fileId: $fileId) { ${$dec379065a898322$export$aa44142d485ff6ab} } }`;
const $dec379065a898322$export$edb578819a2e86f4 = `query ClinicalFileAnalyses($patientId: ID!) { patient(id: $patientId) { id clinicalFiles { id processingStatus analysis { ${$dec379065a898322$var$EXTRACTION_RUN_FIELDS} } } } }`;
const $dec379065a898322$export$12566aca247381aa = `mutation SaveClinicalReport($input: SaveClinicalReportInput!) { saveClinicalReport(input: $input) { noteSaved file { ${$dec379065a898322$export$aa44142d485ff6ab} } } }`;
const $dec379065a898322$export$1541403edf337a0 = `mutation SaveLabResultsForFile($input: SaveLabResultsInput!) { saveLabResults(input: $input) { success savedObservations savedConditions savedMedications error errorCode } }`;
const $dec379065a898322$export$a7d989aaa610e68c = `query ClinicalFileDownload($fileId: ID!) { clinicalFileDownload(fileId: $fileId) { fileName contentType data size } }`;
const $dec379065a898322$export$b25799d4be2e0e7b = `query ListResultOrders($patientId: ID!) { listDoctorOrders(patientId: $patientId) { id appointmentId orderType name status createdAt } }`;

});

parcelRegister("3VOBa", function(module, exports) {

$parcel$export(module.exports, "MAX_FILES_PER_UPLOAD", () => $2dcdf1c1963f00da$export$7c6f6c38c781ae96);
$parcel$export(module.exports, "LARGE_DOWNLOAD_BYTES", () => $2dcdf1c1963f00da$export$48c908e1ec06ccc6);
$parcel$export(module.exports, "documentLimitBytes", () => $2dcdf1c1963f00da$export$f36c73f7356be416);
$parcel$export(module.exports, "DICOM_ERROR_KEYS", () => $2dcdf1c1963f00da$export$a9a070740fdaf1b0);
$parcel$export(module.exports, "contentTypeOf", () => $2dcdf1c1963f00da$export$516ffdc000f2cdae);
$parcel$export(module.exports, "megabytes", () => $2dcdf1c1963f00da$export$d56bb2ab6cd19776);
$parcel$export(module.exports, "sizeText", () => $2dcdf1c1963f00da$export$d16689d79378b0e4);
$parcel$export(module.exports, "fileToBase64", () => $2dcdf1c1963f00da$export$25df2e315be8e003);
$parcel$export(module.exports, "splitDataUri", () => $2dcdf1c1963f00da$export$64f75967084abe8e);
$parcel$export(module.exports, "base64ToBlob", () => $2dcdf1c1963f00da$export$b3fb17ae4345ac8f);
$parcel$export(module.exports, "saveBlob", () => $2dcdf1c1963f00da$export$9016c9576545678);
$parcel$export(module.exports, "fileErrorText", () => $2dcdf1c1963f00da$export$d4b677401f6be1f8);
// «مدارک بیمار» — the limits and byte handling of the doctor's own uploads and
// downloads. docs/DOCTOR_PATIENT_FILES_AND_AI_EXTRACTION_DESIGN.md §7.3, §7.6.
//
// One place for every number the upload flow enforces, so the dropzone's helper
// line, its refusals and the queue cannot quote three different limits.
// The BFF refuses a file larger than 0.7 × its JSON body limit (20 MB): base64
// inflates by 4/3, and a body past the limit is an opaque 413 before any resolver
// runs. The design's first draft said 15 MB, which base64 turns into exactly the
// limit plus the JSON around it — 14 is the largest size that always fits.
const $2dcdf1c1963f00da$export$b9158b9f13d80898 = 14680064;
const $2dcdf1c1963f00da$export$7c6f6c38c781ae96 = 5;
const $2dcdf1c1963f00da$export$48c908e1ec06ccc6 = 10485760;
const $2dcdf1c1963f00da$var$EXT_MIME = {
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    png: 'image/png',
    pdf: 'application/pdf',
    webp: 'image/webp',
    gif: 'image/gif',
    bmp: 'image/bmp'
};
function $2dcdf1c1963f00da$export$f36c73f7356be416(policy) {
    const ceiling = Number(policy?.ceilings?.documentBytes) || $2dcdf1c1963f00da$export$b9158b9f13d80898;
    const physical = Math.min(ceiling, $2dcdf1c1963f00da$export$b9158b9f13d80898);
    if (!policy) return physical;
    if (policy.sizeLimitEnabled && Number(policy.maxFileBytes) > 0) return Math.min(Number(policy.maxFileBytes), physical);
    return physical;
}
const $2dcdf1c1963f00da$export$a9a070740fdaf1b0 = Object.freeze({
    DICOM_DISABLED: 'patient.files.dicom.errors.DICOM_DISABLED',
    DICOM_UNAVAILABLE: 'patient.files.dicom.errors.DICOM_UNAVAILABLE',
    STUDY_UID_CONFLICT: 'patient.files.dicom.errors.STUDY_UID_CONFLICT',
    DICOM_LIMIT_STUDY: 'patient.files.dicom.errors.DICOM_LIMIT_STUDY',
    DICOM_LIMIT_INSTANCES: 'patient.files.dicom.errors.DICOM_LIMIT_INSTANCES',
    DICOM_QUOTA: 'patient.files.dicom.errors.DICOM_QUOTA',
    DICOM_SESSION_EXPIRED: 'patient.files.dicom.errors.DICOM_SESSION_EXPIRED',
    DICOM_INSTANCE_TOO_LARGE: 'patient.files.dicom.errors.DICOM_INSTANCE_TOO_LARGE',
    DICOM_NO_FILES: 'patient.files.dicom.errors.DICOM_NO_FILES',
    FORBIDDEN: 'patient.files.dicom.errors.FORBIDDEN',
    DICOM_RECORD_PENDING: 'patient.files.dicom.errors.DICOM_RECORD_PENDING',
    // The BFF's own transport refusals (not in §24.10's list, added by the BFF build).
    DICOM_BATCH_TOO_LARGE: 'patient.files.dicom.errors.DICOM_BATCH_TOO_LARGE',
    BAD_REQUEST: 'patient.files.dicom.errors.failed',
    UNAUTHENTICATED: 'patient.files.dicom.errors.UNAUTHENTICATED',
    OFFLINE: 'patient.files.upload.offline',
    NETWORK: 'patient.files.dicom.errors.NETWORK'
});
const $2dcdf1c1963f00da$var$extensionOf = (name)=>String(name || '').toLowerCase().split('.').pop();
function $2dcdf1c1963f00da$export$516ffdc000f2cdae(file) {
    return (file?.type || $2dcdf1c1963f00da$var$EXT_MIME[$2dcdf1c1963f00da$var$extensionOf(file?.name)] || '').toLowerCase();
}
function $2dcdf1c1963f00da$export$cf709db89eaa620b(file) {
    const type = String(file?.type || '').toLowerCase();
    return type === 'image/heic' || type === 'image/heif' || [
        'heic',
        'heif'
    ].includes($2dcdf1c1963f00da$var$extensionOf(file?.name));
}
const $2dcdf1c1963f00da$export$d56bb2ab6cd19776 = (bytes)=>Math.round((Number(bytes) || 0) / 1048576 * 10) / 10;
function $2dcdf1c1963f00da$export$d16689d79378b0e4(t, formatNumber, bytes) {
    const n = Number(bytes) || 0;
    if (n >= 1073741824) return t('patient.files.sizeGb', {
        value: formatNumber(Math.round(n / 1073741824 * 10) / 10)
    });
    return t('patient.files.upload.size', {
        mb: formatNumber($2dcdf1c1963f00da$export$d56bb2ab6cd19776(n))
    });
}
function $2dcdf1c1963f00da$export$25df2e315be8e003(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onload = ()=>resolve(String(reader.result || '').split(',')[1] || '');
        reader.onerror = ()=>reject(reader.error);
        reader.readAsDataURL(file);
    });
}
function $2dcdf1c1963f00da$export$64f75967084abe8e(uri) {
    const m = /^data:([^;,]*)(;base64)?,([\s\S]*)$/.exec(String(uri || ''));
    if (!m || !m[2]) return null;
    return {
        contentType: m[1] || 'application/octet-stream',
        data: m[3]
    };
}
function $2dcdf1c1963f00da$export$b3fb17ae4345ac8f(data, type) {
    const binary = atob(String(data || ''));
    const bytes = new Uint8Array(binary.length);
    for(let i = 0; i < binary.length; i += 1)bytes[i] = binary.charCodeAt(i);
    return new Blob([
        bytes
    ], {
        type: type || 'application/octet-stream'
    });
}
function $2dcdf1c1963f00da$export$9016c9576545678(blob, fileName) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName || 'document';
    a.rel = 'noopener';
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(()=>URL.revokeObjectURL(url), 1000);
}
function $2dcdf1c1963f00da$export$d4b677401f6be1f8(t, has, err, fallbackKey) {
    const key = err?.extensions?.messageKey;
    if (key && typeof has === 'function' && has(key)) return t(key);
    if (err?.extensions?.code === 'INSUFFICIENT_CREDITS') return t('patient.files.extract.credit');
    const message = String(err?.message || '');
    if (message && err?.extensions?.messageKey) return message;
    return t(fallbackKey);
}

});



parcelRegister("d6Clo", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fab7b93fa77b6d7$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $9he56 = parcelRequire("9he56");

var $7sS0P = parcelRequire("7sS0P");

var $eARX3 = parcelRequire("eARX3");
function $7fab7b93fa77b6d7$export$2e2bcd8739ae039({ study: study, seriesUid: seriesUid, modality: modality, size: size = '2rem', testid: testid = 'dicom-thumbnail' }) {
    const series = seriesUid ? null : (0, $eARX3.representativeSeries)(study);
    const studyUid = study?.studyUid;
    const targetSeries = seriesUid || series?.seriesUid;
    const canFetch = Boolean(studyUid && targetSeries && study?.rendered !== false);
    const [url, setUrl] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!canFetch) {
            setUrl(null);
            return undefined;
        }
        const controller = new AbortController();
        let objectUrl = null;
        (0, $eARX3.fetchObjectUrl)((0, $eARX3.thumbnailUrl)(studyUid, targetSeries), {
            signal: controller.signal
        }).then((u)=>{
            if (controller.signal.aborted) {
                URL.revokeObjectURL(u);
                return;
            }
            objectUrl = u;
            setUrl(u);
        }).catch(()=>{
            if (!controller.signal.aborted) setUrl(null);
        });
        return ()=>{
            controller.abort();
            if (objectUrl) URL.revokeObjectURL(objectUrl);
        };
    }, [
        canFetch,
        studyUid,
        targetSeries
    ]);
    const mark = modality || series?.modality || (study?.modalities || [])[0] || '';
    const box = {
        width: size,
        height: size,
        borderRadius: (0, $7sS0P.RADIUS).control,
        flexShrink: 0,
        overflow: 'hidden',
        background: url ? (0, $jTCZr.CT).ink : (0, $jTCZr.CT).surface2,
        color: (0, $jTCZr.CT).accentInk,
        display: 'grid',
        placeItems: 'center'
    };
    if (url) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: box,
        "data-testid": testid,
        "data-state": "content",
        "aria-hidden": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: url,
        alt: "",
        style: {
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            display: 'block'
        }
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: box,
        "data-testid": testid,
        "data-state": "fallback",
        "aria-hidden": true
    }, mark ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "ltr",
        style: {
            fontSize: '0.625rem',
            fontWeight: 700,
            letterSpacing: '0.02em'
        }
    }, mark) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9he56.default), {
        size: 16,
        strokeWidth: 1.75
    }));
}

});
parcelRegister("9he56", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccc00afea4040e64$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $ccc00afea4040e64$export$a2387ed3b5d536eb = {
    name: "scan-line",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M3 7V5a2 2 0 0 1 2-2h2",
                key: "aa7l1z"
            }
        ],
        [
            "path",
            {
                d: "M17 3h2a2 2 0 0 1 2 2v2",
                key: "4qcy5o"
            }
        ],
        [
            "path",
            {
                d: "M21 17v2a2 2 0 0 1-2 2h-2",
                key: "6vwrx8"
            }
        ],
        [
            "path",
            {
                d: "M7 21H5a2 2 0 0 1-2-2v-2",
                key: "ioqczr"
            }
        ],
        [
            "path",
            {
                d: "M7 12h10",
                key: "b7w52i"
            }
        ]
    ]
};
$ccc00afea4040e64$export$a2387ed3b5d536eb.node;
const $ccc00afea4040e64$export$2e2bcd8739ae039 = (0, $9QBug.default)($ccc00afea4040e64$export$a2387ed3b5d536eb);

});


parcelRegister("hRWhk", function(module, exports) {

$parcel$export(module.exports, "KIND_ICON", () => $b2efaf4152cb92eb$export$ea5d3f1bc51dbb0a);
$parcel$export(module.exports, "FileChip", () => $b2efaf4152cb92eb$export$ba419c27a5974bb1);
$parcel$export(module.exports, "formatDocDate", () => $b2efaf4152cb92eb$export$7dee33e761ba98a6);
$parcel$export(module.exports, "FileFacts", () => $b2efaf4152cb92eb$export$6047a074a83ec744);
$parcel$export(module.exports, "default", () => $b2efaf4152cb92eb$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $bfs4Q = parcelRequire("bfs4Q");

var $jTCZr = parcelRequire("jTCZr");

var $kBNa0 = parcelRequire("kBNa0");
var $ggYuf = parcelRequire("ggYuf");
var $2XwcZ = parcelRequire("2XwcZ");
var $gr49X = parcelRequire("gr49X");
var $3FyOw = parcelRequire("3FyOw");
var $4CVxl = parcelRequire("4CVxl");
var $7VXKQ = parcelRequire("7VXKQ");
var $gXsFl = parcelRequire("gXsFl");
var $aGlWN = parcelRequire("aGlWN");
var $aVx4q = parcelRequire("aVx4q");
var $9he56 = parcelRequire("9he56");
var $chm1L = parcelRequire("chm1L");
var $lUsTt = parcelRequire("lUsTt");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $7sS0P = parcelRequire("7sS0P");

var $1Qo7B = parcelRequire("1Qo7B");

var $gdEay = parcelRequire("gdEay");

var $eARX3 = parcelRequire("eARX3");

var $d6Clo = parcelRequire("d6Clo");

var $cmmZD = parcelRequire("cmmZD");
const $b2efaf4152cb92eb$export$ea5d3f1bc51dbb0a = {
    LAB: (0, $4CVxl.default),
    IMAGING: (0, $9he56.default),
    MEDICAL_REPORT: (0, $3FyOw.default),
    PRESCRIPTION: (0, $aVx4q.default),
    TREATMENT_DOCUMENT: (0, $ggYuf.default),
    OTHER: (0, $gXsFl.default)
};
const $b2efaf4152cb92eb$var$TONES = {
    neutral: {
        background: (0, $jTCZr.CT).surface2,
        color: (0, $jTCZr.CT).ink2,
        border: `1px solid ${(0, $jTCZr.CT).border}`
    },
    accent: {
        background: (0, $jTCZr.CT).accentSoft,
        color: (0, $jTCZr.CT).accentInk,
        border: '1px solid transparent'
    },
    good: {
        background: (0, $jTCZr.CT).goodSoft,
        color: (0, $jTCZr.CT).goodInk,
        border: '1px solid transparent'
    },
    warn: {
        background: (0, $jTCZr.CT).warnSoft,
        color: (0, $jTCZr.CT).warnInk,
        border: '1px solid transparent'
    }
};
function $b2efaf4152cb92eb$export$ba419c27a5974bb1({ tone: tone = 'neutral', children: children, style: style, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        ...rest,
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.25rem',
            padding: '0.0625rem 0.4375rem',
            borderRadius: (0, $7sS0P.RADIUS).chip,
            fontSize: '0.6875rem',
            fontWeight: 600,
            lineHeight: 1.6,
            whiteSpace: 'nowrap',
            ...$b2efaf4152cb92eb$var$TONES[tone],
            ...style
        }
    }, children);
}
function $b2efaf4152cb92eb$export$7dee33e761ba98a6(value, formatDate) {
    if (!value) return '';
    const iso = /^\d{4}-\d{2}-\d{2}$/.test(value) ? `${value}T12:00:00` : value;
    try {
        return formatDate(iso, 'medium');
    } catch  {
        return String(value);
    }
}
function $b2efaf4152cb92eb$export$6047a074a83ec744({ file: file, clinicName: clinicName }) {
    const { t: t } = (0, $LNQP4.default)();
    const kindKey = (0, $1Qo7B.documentKindLabelKey)(file.kind);
    const proc = (0, $1Qo7B.processingStatusMeta)(file.processingStatus);
    const study = (0, $eARX3.isDicomFile)(file) ? file.dicom : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, study ? (study.modalities || []).slice(0, 3).map((m)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cmmZD.ModalityChip), {
            key: m,
            modality: m,
            testid: `file-modality-${m}`
        })) : kindKey && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b2efaf4152cb92eb$export$ba419c27a5974bb1, {
        "data-testid": "file-kind"
    }, t(kindKey)), study && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cmmZD.IdentityChip), {
        verdict: study.identityCheck
    }), study && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cmmZD.LossyChip), {
        study: study
    }), file.uploadedBy === 'patient' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b2efaf4152cb92eb$export$ba419c27a5974bb1, {
        tone: "accent",
        "data-testid": "file-uploaded-by-patient"
    }, t('visit.orders.result.uploadedByPatient')), file.uploadedBy === 'modality' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b2efaf4152cb92eb$export$ba419c27a5974bb1, {
        "data-testid": "file-uploaded-by-modality"
    }, t('patient.files.dicom.fromModality')), file.promotedAt && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b2efaf4152cb92eb$export$ba419c27a5974bb1, {
        tone: "good",
        "data-testid": "file-promoted"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kBNa0.default), {
        size: 11,
        "aria-hidden": true
    }), " ", t('patient.files.promoted')), (0, $1Qo7B.isWorthShowing)(file.processingStatus) && proc && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b2efaf4152cb92eb$export$ba419c27a5974bb1, {
        "data-testid": "file-processing",
        style: {
            background: proc.bg,
            color: proc.text,
            border: '1px solid transparent'
        }
    }, t(proc.labelKey)), clinicName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b2efaf4152cb92eb$export$ba419c27a5974bb1, {
        "data-testid": "file-clinic",
        dir: "auto"
    }, clinicName));
}
function $b2efaf4152cb92eb$export$2e2bcd8739ae039({ file: file, onOpen: onOpen, onView: onView, onPreview: onPreview, onExtract: onExtract, onEdit: onEdit, onDownload: onDownload, onDelete: onDelete, clinicName: clinicName, dense: dense = false, touch: touch = false, testid: testid = 'file-row' }) {
    // A phone needs ≥ 2.75rem targets (MOBILE_WEB_PWA §5); a workstation row stays compact.
    const iconSize = touch ? 'h-11 w-11' : 'h-9 w-9';
    const { t: t, formatDate: formatDate, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const [menuOpen, setMenuOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const moreRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const kind = (0, $1Qo7B.canonicalKind)(file.kind);
    const Icon = $b2efaf4152cb92eb$export$ea5d3f1bc51dbb0a[kind] || (0, $gXsFl.default);
    const date = (0, $gdEay.documentDateOf)(file);
    const study = (0, $eARX3.isDicomFile)(file) ? file.dicom : null;
    const isStudy = (0, $eARX3.isDicomFile)(file);
    const canEdit = Boolean(file.canEdit && onEdit);
    const canDelete = Boolean(file.canDelete && onDelete);
    // A study is read by AI only through its document objects (SR, PDF, secondary
    // capture) — never the diagnostic images themselves (§9.9).
    const canExtract = Boolean(file.extractable && onExtract && (!isStudy || (0, $eARX3.hasDocumentObjects)(study)));
    // A study has no single file to download.
    const canDownload = Boolean(onDownload) && !isStudy;
    const hasMenu = canEdit || canDownload || canDelete;
    // «مشاهده»: a study's images; otherwise the gallery when the host offers one
    // (PM-0560 — the doctor pages on from here instead of closing and reopening),
    // else the detail drawer, as before.
    const view = isStudy && onView ? onView : onPreview || onOpen;
    const pick = (fn)=>()=>{
            setMenuOpen(false);
            fn(file);
        };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${testid}-${file.id}`,
        "data-kind": kind || 'unknown',
        style: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: '0.625rem',
            padding: dense ? '0.5rem 0' : '0.625rem 0.25rem',
            borderBottom: `1px solid ${(0, $jTCZr.CT).border}`
        }
    }, isStudy ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            marginTop: '0.125rem',
            display: 'inline-flex'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d6Clo.default), {
        study: study,
        testid: `${testid}-thumb-${file.id}`,
        size: "2rem"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true,
        style: {
            width: '2rem',
            height: '2rem',
            borderRadius: (0, $7sS0P.RADIUS).control,
            flexShrink: 0,
            background: (0, $jTCZr.CT).surface2,
            color: (0, $jTCZr.CT).accentInk,
            display: 'grid',
            placeItems: 'center',
            marginTop: '0.125rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        size: 16,
        strokeWidth: 1.75
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        onClick: ()=>onOpen?.(file),
        "aria-label": t('patient.files.openDetail', {
            name: file.fileName
        }),
        "data-testid": `${testid}-open-${file.id}`,
        className: "flex-1 min-w-0 h-auto min-h-11 justify-start px-0 py-0.5 font-normal hover:bg-transparent text-start",
        style: {
            display: 'block'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.375rem',
            flexWrap: 'wrap'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        title: file.fileName,
        style: {
            fontSize: '0.8125rem',
            fontWeight: 600,
            color: (0, $jTCZr.CT).ink,
            maxWidth: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            unicodeBidi: 'isolate'
        }
    }, file.fileName || t('patient.files.unnamed')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b2efaf4152cb92eb$export$6047a074a83ec744, {
        file: file,
        clinicName: clinicName
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.375rem',
            flexWrap: 'wrap',
            marginTop: '0.1875rem',
            fontSize: '0.6875rem',
            color: (0, $jTCZr.CT).mute
        }
    }, date && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "file-date"
    }, $b2efaf4152cb92eb$export$7dee33e761ba98a6(date, formatDate)), study && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "file-study-meta"
    }, "\xb7 ", (0, $cmmZD.studyMetaText)(t, formatNumber, study)), (0, $gdEay.uploadDayDiffers)(file) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "file-uploaded-at"
    }, "\xb7 ", t('patient.files.uploadedOn', {
        date: $b2efaf4152cb92eb$export$7dee33e761ba98a6(file.createdAt, formatDate)
    })), file.resolvedOrder?.description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "file-answers-order",
        dir: "auto"
    }, "\xb7 ", t('visit.orders.result.answersOrder'), ": ", file.resolvedOrder.description)), file.description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "file-description",
        dir: "auto",
        title: file.description,
        style: {
            display: 'block',
            marginTop: '0.1875rem',
            fontSize: '0.71875rem',
            color: (0, $jTCZr.CT).ink2,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        }
    }, file.description), file.processingStatus === 'failed' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "file-failure",
        "data-error-code": file.processingError || 'unknown',
        style: {
            display: 'block',
            marginTop: '0.1875rem',
            fontSize: '0.6875rem',
            color: (0, $jTCZr.CT).mute
        }
    }, t((0, $1Qo7B.failureCopyKey)(file.processingError)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.125rem',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "icon",
        className: iconSize,
        "aria-label": t(isStudy ? 'patient.files.dicom.viewImages' : 'patient.files.actions.view'),
        title: t(isStudy ? 'patient.files.dicom.viewImages' : 'patient.files.actions.view'),
        "data-testid": `${testid}-view-${file.id}`,
        onClick: ()=>view?.(file)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gr49X.default), {
        size: 16,
        "aria-hidden": true
    })), canExtract && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "icon",
        className: iconSize,
        "aria-label": t('patient.files.actions.extract'),
        title: t('patient.files.actions.extract'),
        "data-testid": `${testid}-extract-${file.id}`,
        onClick: ()=>onExtract(file),
        style: {
            color: (0, $jTCZr.CT).accentInk
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $chm1L.default), {
        size: 16,
        "aria-hidden": true
    })), hasMenu && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        ref: moreRef,
        variant: "ghost",
        size: "icon",
        className: iconSize,
        "aria-label": t('patient.files.actions.more'),
        title: t('patient.files.actions.more'),
        "aria-haspopup": "menu",
        "aria-expanded": menuOpen,
        "data-testid": `${testid}-more-${file.id}`,
        onClick: ()=>setMenuOpen((v)=>!v)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7VXKQ.default), {
        size: 16,
        "aria-hidden": true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bfs4Q.default), {
        open: menuOpen,
        onClose: ()=>setMenuOpen(false),
        anchorRef: moreRef,
        width: 200,
        placement: "auto",
        ariaLabel: t('patient.files.actions.more'),
        "data-testid": `${testid}-menu-${file.id}`
    }, canEdit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        role: "menuitem",
        className: "w-full justify-start gap-2 font-normal",
        onClick: pick(onEdit),
        "data-testid": `${testid}-edit-${file.id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aGlWN.default), {
        size: 14,
        "aria-hidden": true
    }), " ", t('patient.files.actions.edit')), canDownload && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        role: "menuitem",
        className: "w-full justify-start gap-2 font-normal",
        onClick: pick(onDownload),
        "data-testid": `${testid}-download-${file.id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2XwcZ.default), {
        size: 14,
        "aria-hidden": true
    }), " ", t('patient.files.actions.download')), canDelete && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        role: "menuitem",
        className: "w-full justify-start gap-2 font-normal",
        onClick: pick(onDelete),
        "data-testid": `${testid}-delete-${file.id}`,
        style: {
            color: (0, $jTCZr.CT).danger
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lUsTt.default), {
        size: 14,
        "aria-hidden": true
    }), " ", t('patient.files.actions.delete'))))));
}

});
parcelRegister("kBNa0", function(module, exports) {

$parcel$export(module.exports, "default", () => $8cb58a0e56c12463$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $8cb58a0e56c12463$export$a2387ed3b5d536eb = {
    name: "circle-check",
    size: 24,
    node: [
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                r: "10",
                key: "1mglay"
            }
        ],
        [
            "path",
            {
                d: "m16 9-5.5 5.5L8 12",
                key: "xofnsj"
            }
        ]
    ],
    aliases: [
        "check-circle-2"
    ]
};
$8cb58a0e56c12463$export$a2387ed3b5d536eb.node;
const $8cb58a0e56c12463$export$2e2bcd8739ae039 = (0, $9QBug.default)($8cb58a0e56c12463$export$a2387ed3b5d536eb);

});

parcelRegister("gr49X", function(module, exports) {

$parcel$export(module.exports, "default", () => $839cd39f53db0480$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $839cd39f53db0480$export$a2387ed3b5d536eb = {
    name: "eye",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
                key: "1nclc0"
            }
        ],
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                r: "3",
                key: "1v7zrd"
            }
        ]
    ]
};
$839cd39f53db0480$export$a2387ed3b5d536eb.node;
const $839cd39f53db0480$export$2e2bcd8739ae039 = (0, $9QBug.default)($839cd39f53db0480$export$a2387ed3b5d536eb);

});

parcelRegister("cmmZD", function(module, exports) {

$parcel$export(module.exports, "ModalityChip", () => $00e4129789459a85$export$8b4ef6368b96e1d9);
$parcel$export(module.exports, "studyMetaText", () => $00e4129789459a85$export$6a1ed6b8a13ed847);
$parcel$export(module.exports, "IdentityChip", () => $00e4129789459a85$export$de7977fb4fae854b);
$parcel$export(module.exports, "LossyChip", () => $00e4129789459a85$export$afd3e13bab74f45d);
$parcel$export(module.exports, "IdentityAlert", () => $00e4129789459a85$export$1090f771f7d0b229);
$parcel$export(module.exports, "LossyAlert", () => $00e4129789459a85$export$3a5c932de3a0f9c9);
$parcel$export(module.exports, "DicomMetadata", () => $00e4129789459a85$export$31a954d36640d797);

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $aJ1FU = parcelRequire("aJ1FU");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $hRWhk = parcelRequire("hRWhk");

var $3VOBa = parcelRequire("3VOBa");
function $00e4129789459a85$export$8b4ef6368b96e1d9({ modality: modality, testid: testid = 'file-modality' }) {
    if (!modality) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hRWhk.FileChip), {
        tone: "accent",
        "data-testid": testid,
        dir: "ltr",
        style: {
            unicodeBidi: 'isolate'
        }
    }, modality);
}
function $00e4129789459a85$export$6a1ed6b8a13ed847(t, formatNumber, study) {
    if (!study) return '';
    const parts = [
        t('patient.files.dicom.seriesCount', {
            count: formatNumber(study.seriesCount ?? (study.series || []).length)
        }),
        t('patient.files.dicom.imageCount', {
            count: formatNumber(study.instanceCount ?? 0)
        })
    ];
    const bytes = study.storedBytes ?? study.bytes;
    if (bytes) parts.push((0, $3VOBa.sizeText)(t, formatNumber, bytes));
    return parts.join(" \xb7 ");
}
function $00e4129789459a85$export$de7977fb4fae854b({ verdict: verdict, testid: testid = 'file-identity' }) {
    const { t: t } = (0, $LNQP4.default)();
    if (verdict !== 'mismatch' && verdict !== 'partial') return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hRWhk.FileChip), {
        tone: "warn",
        "data-testid": testid,
        "data-verdict": verdict
    }, t(verdict === 'mismatch' ? 'patient.files.dicom.identity.mismatchChip' : 'patient.files.dicom.identity.partialChip'));
}
function $00e4129789459a85$export$afd3e13bab74f45d({ study: study, testid: testid = 'file-lossy' }) {
    const { t: t } = (0, $LNQP4.default)();
    if (!study?.lossySource) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hRWhk.FileChip), {
        "data-testid": testid
    }, t('patient.files.dicom.lossyChip'));
}
const $00e4129789459a85$var$sexKey = (sex)=>{
    const s = String(sex || '').toUpperCase();
    if (s === 'M') return 'patient.files.dicom.sex.M';
    if (s === 'F') return 'patient.files.dicom.sex.F';
    return null;
};
function $00e4129789459a85$export$a1bc28ff57200918(t, formatDate, header) {
    if (!header) return '';
    const parts = [];
    if (header.name) parts.push(header.name);
    if (header.birthDate) parts.push((0, $hRWhk.formatDocDate)(header.birthDate, formatDate));
    const sk = $00e4129789459a85$var$sexKey(header.sex);
    if (sk) parts.push(t(sk));
    return parts.join(" \xb7 ");
}
function $00e4129789459a85$export$1090f771f7d0b229({ file: file, patient: patient, onConfirm: onConfirm, confirming: confirming = false, testid: testid = 'dicom-identity' }) {
    const { t: t, formatDate: formatDate } = (0, $LNQP4.default)();
    const study = file?.dicom;
    if (!study || study.identityCheck !== 'mismatch') return null;
    const onFile = $00e4129789459a85$export$a1bc28ff57200918(t, formatDate, study.headerPatient) || t('patient.files.dicom.identity.empty');
    const inRecord = patient ? [
        patient.name,
        patient.birthDate ? (0, $hRWhk.formatDocDate)(String(patient.birthDate).slice(0, 10), formatDate) : null
    ].filter(Boolean).join(" \xb7 ") : '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "error",
        "data-testid": testid,
        action: onConfirm ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "outline",
            size: "sm",
            onClick: onConfirm,
            disabled: confirming,
            "data-testid": `${testid}-confirm`
        }, confirming ? t('common.state.saving') : t('patient.files.dicom.identity.confirm')) : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.25rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, t('patient.files.dicom.identity.mismatch')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'grid',
            gridTemplateColumns: 'auto 1fr',
            gap: '0.125rem 0.5rem',
            fontSize: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: (0, $jTCZr.CT).ink2
        }
    }, t('patient.files.dicom.identity.onFile')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        "data-testid": `${testid}-on-file`
    }, onFile), inRecord && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: (0, $jTCZr.CT).ink2
        }
    }, t('patient.files.dicom.identity.inRecord')), inRecord && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        "data-testid": `${testid}-in-record`
    }, inRecord))));
}
function $00e4129789459a85$export$3a5c932de3a0f9c9({ study: study, testid: testid = 'dicom-lossy' }) {
    const { t: t } = (0, $LNQP4.default)();
    if (!study?.lossySource) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "info",
        "data-testid": testid
    }, t('patient.files.dicom.lossy'));
}
function $00e4129789459a85$export$31a954d36640d797({ study: study, testid: testid = 'dicom-metadata' }) {
    const { t: t, formatDate: formatDate, formatNumber: formatNumber, formatList: formatList } = (0, $LNQP4.default)();
    if (!study) return null;
    const rows = [
        [
            'modality',
            (study.modalities || []).join(', '),
            'ltr'
        ],
        [
            'studyDate',
            study.studyDate ? (0, $hRWhk.formatDocDate)(study.studyDate, formatDate) : ''
        ],
        [
            'studyTime',
            study.studyTime || '',
            'ltr'
        ],
        [
            'description',
            study.description || '',
            'auto'
        ],
        [
            'bodyParts',
            (study.bodyParts || []).length ? formatList(study.bodyParts) : '',
            'ltr'
        ],
        [
            'counts',
            $00e4129789459a85$export$6a1ed6b8a13ed847(t, formatNumber, study)
        ],
        [
            'institution',
            study.institutionName || '',
            'auto'
        ],
        [
            'referring',
            study.referringPhysician || '',
            'auto'
        ],
        [
            'accession',
            study.accessionNumber || '',
            'ltr'
        ],
        [
            'transcoded',
            study.transcoded ? t('patient.files.dicom.meta.transcodedLossless') : ''
        ]
    ].filter(([, value])=>value);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("dl", {
        "data-testid": testid,
        style: {
            margin: 0,
            display: 'grid',
            gridTemplateColumns: 'minmax(6rem, auto) 1fr',
            gap: '0.25rem 0.75rem',
            fontSize: '0.75rem'
        }
    }, rows.map(([key, value, dir])=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
            key: key
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("dt", {
            style: {
                color: (0, $jTCZr.CT).mute
            }
        }, t(`patient.files.dicom.meta.${key}`)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("dd", {
            "data-testid": `${testid}-${key}`,
            dir: dir,
            style: {
                margin: 0,
                color: (0, $jTCZr.CT).ink,
                unicodeBidi: dir ? 'isolate' : undefined,
                wordBreak: 'break-word'
            }
        }, value))));
}

});



parcelRegister("jDxJA", function(module, exports) {

$parcel$export(module.exports, "ErxCodeChips", () => $5571c3267d3defe1$export$d393b0e12bf3bfa1);
$parcel$export(module.exports, "ErxCodeGroup", () => $5571c3267d3defe1$export$5bca059d67344225);

var $acw62 = parcelRequire("acw62");

var $huNwV = parcelRequire("huNwV");
var $2uCMp = parcelRequire("2uCMp");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
// ─────────────────────────────────────────────────────────────────────────────
// «کد رهگیری» of a past visit's e-prescription, in the visit history (PM-0686).
//
// Two shapes of the same fact, both fed by useVisitErxCodes:
//   · ErxCodeChips — one chip per code on a visit's CARD: «داروها ۱۲۳۴», press to copy.
//   · ErxCodeGroup — the titled group in the OPENED visit: insurer, what the code
//     covers, the code, a «کپی» button per row.
//
// A visit can hold several codes — the drugs' and the دستورات' (and dated groups of
// those) are prescriptions of their own — so `scope` is said wherever it is known:
// DRUGS «داروها», SERVICES «دستورات», null = one prescription for the whole visit
// (سلامت / اسخاد), nothing to add. A draft (`lifecycle: 'incomplete'`) reads the
// same: the code is the insurer's either way.
//
// Colours come from the token module, not the visit's CSS variables, because the
// phone draws these too (see InsurerListChip). The code is an LTR island and keeps
// Latin digits (DESIGN_SYSTEM §6.4). A chip on a card that is itself a whole-row
// button is a `span role="button"` (`nested`) — a button inside a button is not
// valid HTML — exactly as ReprescribePicker does; everywhere else it is a button.
// ─────────────────────────────────────────────────────────────────────────────
const $5571c3267d3defe1$var$COPIED_MS = 1500;
const $5571c3267d3defe1$var$TOUCH_MIN = '2.75rem';
const $5571c3267d3defe1$var$FOCUS_RING = 'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring';
async function $5571c3267d3defe1$export$c8531afc97e1e0f8(text) {
    try {
        if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(text);
            return true;
        }
    } catch  {}
    const before = typeof document !== 'undefined' ? document.activeElement : null;
    try {
        const box = document.createElement('textarea');
        box.value = text;
        box.setAttribute('readonly', '');
        box.style.position = 'fixed';
        box.style.top = '0';
        box.style.insetInlineStart = '-9999px';
        box.style.opacity = '0';
        document.body.appendChild(box);
        box.select();
        const done = document.execCommand('copy');
        document.body.removeChild(box);
        before?.focus?.();
        return !!done;
    } catch  {
        return false;
    }
}
/** Which code was just copied (for ~1.5 s), and the way to copy one. */ function $5571c3267d3defe1$var$useCopied() {
    const [copied, setCopied] = (0, $acw62.useState)(null);
    const timer = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>()=>clearTimeout(timer.current), []);
    const copy = (0, $acw62.useCallback)(async (key, text)=>{
        if (!await $5571c3267d3defe1$export$c8531afc97e1e0f8(text)) return; // nothing was copied, so nothing says it was
        setCopied(key);
        clearTimeout(timer.current);
        timer.current = setTimeout(()=>setCopied(null), $5571c3267d3defe1$var$COPIED_MS);
    }, []);
    return {
        copied: copied,
        copy: copy
    };
}
/** «داروها» · «دستورات» · '' for a prescription that covers the whole visit. */ function $5571c3267d3defe1$var$useScopeLabel() {
    const { t: t } = (0, $LNQP4.default)();
    return (scope)=>scope === 'DRUGS' ? t('visit.erxCodes.drugs') : scope === 'SERVICES' ? t('visit.erxCodes.services') : '';
}
/**
 * «کد رهگیری تأمین اجتماعی داروها: 123؛ کپی» — what a screen reader and the tooltip say.
 * `{{scope}}` carries its own leading space (nothing when the code covers the whole
 * visit), so the sentence has no hole where the scope would have been.
 */ function $5571c3267d3defe1$var$useCodeSentence() {
    const { t: t } = (0, $LNQP4.default)();
    const scopeLabel = $5571c3267d3defe1$var$useScopeLabel();
    return (c)=>t('visit.erxCodes.aria', {
            insurer: c.insurerLabel || c.insurer || '',
            scope: scopeLabel(c.scope) ? ` ${scopeLabel(c.scope)}` : '',
            code: c.code
        });
}
const $5571c3267d3defe1$var$usable = (codes)=>Array.isArray(codes) ? codes.filter((c)=>c && c.code) : [];
const $5571c3267d3defe1$var$codeAttrs = (c)=>({
        'data-code': c.code,
        'data-insurer': c.insurer || undefined,
        'data-scope': c.scope || 'ALL',
        'data-lifecycle': c.lifecycle || undefined
    });
const $5571c3267d3defe1$var$CODE_TEXT = {
    unicodeBidi: 'isolate',
    fontVariantNumeric: 'tabular-nums',
    userSelect: 'all'
};
function $5571c3267d3defe1$export$d393b0e12bf3bfa1({ codes: codes, touch: touch = false, nested: nested = false, testid: testid = 'erx-codes' }) {
    const list = $5571c3267d3defe1$var$usable(codes);
    const { copied: copied, copy: copy } = $5571c3267d3defe1$var$useCopied();
    const { t: t } = (0, $LNQP4.default)();
    const scopeLabel = $5571c3267d3defe1$var$useScopeLabel();
    const sentence = $5571c3267d3defe1$var$useCodeSentence();
    if (!list.length) return null;
    const chipStyle = {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '0.25rem',
        maxWidth: '100%',
        minHeight: touch ? $5571c3267d3defe1$var$TOUCH_MIN : undefined,
        padding: touch ? '0 0.625rem' : '0.0625rem 0.4375rem',
        borderRadius: (0, $jTCZr.RADIUS).chip,
        border: '1px solid transparent',
        background: (0, $jTCZr.CT).goodSoft,
        color: (0, $jTCZr.CT).goodInk,
        fontFamily: 'inherit',
        fontSize: '0.6875rem',
        fontWeight: 700,
        lineHeight: 1.6,
        whiteSpace: 'nowrap',
        cursor: 'pointer'
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": testid,
        style: {
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            gap: touch ? '0.5rem' : '0.25rem'
        }
    }, list.map((c, i)=>{
        const key = `${i}:${c.code}`;
        const label = scopeLabel(c.scope);
        const press = (e)=>{
            e.stopPropagation();
            copy(key, c.code);
        };
        const shared = {
            ...$5571c3267d3defe1$var$codeAttrs(c),
            'data-testid': `${testid}-chip-${i}`,
            'data-state': copied === key ? 'copied' : 'idle',
            'aria-label': sentence(c),
            title: sentence(c),
            className: $5571c3267d3defe1$var$FOCUS_RING,
            style: chipStyle,
            onClick: press
        };
        const body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "ltr",
            "data-testid": `${testid}-code-${i}`,
            style: $5571c3267d3defe1$var$CODE_TEXT
        }, c.code), copied === key ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
            size: 11,
            "aria-hidden": "true"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2uCMp.default), {
            size: 11,
            "aria-hidden": "true"
        }));
        return nested ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            key: key,
            role: "button",
            tabIndex: 0,
            onKeyDown: (e)=>{
                if (e.key !== 'Enter' && e.key !== ' ') return;
                e.preventDefault();
                press(e);
            },
            ...shared
        }, body) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: key,
            type: "button",
            ...shared
        }, body);
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        role: "status",
        "aria-live": "polite",
        className: "sr-only"
    }, copied ? t('visit.erxCodes.copied') : ''));
}
function $5571c3267d3defe1$export$5bca059d67344225({ codes: codes, touch: touch = false, testid: testid = 'erx-code-group', style: style }) {
    const list = $5571c3267d3defe1$var$usable(codes);
    const { copied: copied, copy: copy } = $5571c3267d3defe1$var$useCopied();
    const { t: t } = (0, $LNQP4.default)();
    const scopeLabel = $5571c3267d3defe1$var$useScopeLabel();
    const sentence = $5571c3267d3defe1$var$useCodeSentence();
    if (!list.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testid,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.6875rem',
            fontWeight: 700,
            color: (0, $jTCZr.CT).ink2,
            marginBottom: '0.375rem'
        }
    }, t('visit.erxCodes.title')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        style: {
            listStyle: 'none',
            margin: 0,
            padding: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: touch ? '0.5rem' : '0.25rem'
        }
    }, list.map((c, i)=>{
        const key = `${i}:${c.code}`;
        const label = scopeLabel(c.scope);
        const done = copied === key;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: key,
            ...$5571c3267d3defe1$var$codeAttrs(c),
            "data-testid": `${testid}-row-${i}`,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                flexWrap: 'wrap',
                minHeight: touch ? $5571c3267d3defe1$var$TOUCH_MIN : undefined,
                padding: '0.3125rem 0.5rem',
                borderRadius: '0.4375rem',
                background: (0, $jTCZr.CT).surface2
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.75rem',
                fontWeight: 600,
                color: (0, $jTCZr.CT).ink
            }
        }, c.insurerLabel || c.insurer), label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.6875rem',
                color: (0, $jTCZr.CT).ink2
            }
        }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("b", {
            dir: "ltr",
            "data-testid": `${testid}-code-${i}`,
            style: {
                ...$5571c3267d3defe1$var$CODE_TEXT,
                marginInlineStart: 'auto',
                fontSize: '0.75rem',
                fontWeight: 700,
                color: (0, $jTCZr.CT).ink
            }
        }, c.code), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            type: "button",
            "data-testid": `${testid}-copy-${i}`,
            "data-state": done ? 'copied' : 'idle',
            "aria-label": sentence(c),
            onClick: (e)=>{
                e.stopPropagation();
                copy(key, c.code);
            },
            className: $5571c3267d3defe1$var$FOCUS_RING,
            style: {
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '0.25rem',
                flexShrink: 0,
                minHeight: touch ? $5571c3267d3defe1$var$TOUCH_MIN : undefined,
                minWidth: touch ? $5571c3267d3defe1$var$TOUCH_MIN : undefined,
                padding: touch ? '0 0.75rem' : '0.1875rem 0.5rem',
                borderRadius: (0, $jTCZr.RADIUS).chip,
                border: `1px solid ${(0, $jTCZr.CT).border}`,
                background: (0, $jTCZr.CT).surface,
                color: (0, $jTCZr.CT).accentInk,
                fontFamily: 'inherit',
                fontSize: '0.6875rem',
                fontWeight: 700,
                cursor: 'pointer'
            }
        }, done ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
            size: 12,
            "aria-hidden": "true"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2uCMp.default), {
            size: 12,
            "aria-hidden": "true"
        }), done ? t('visit.erxCodes.copied') : t('visit.erxCodes.copy')));
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        role: "status",
        "aria-live": "polite",
        className: "sr-only"
    }, copied ? t('visit.erxCodes.copied') : ''));
}
var $5571c3267d3defe1$export$2e2bcd8739ae039 = $5571c3267d3defe1$export$d393b0e12bf3bfa1;

});

parcelRegister("5hFXE", function(module, exports) {

$parcel$export(module.exports, "useVisitErxCodes", () => $3d8f16e04eed5491$export$4fb531a6c7226101);

var $acw62 = parcelRequire("acw62");

var $eVM84 = parcelRequire("eVM84");

var $6xvbB = parcelRequire("6xvbB");
const $3d8f16e04eed5491$export$154cd89215e18417 = 500;
const $3d8f16e04eed5491$var$NONE = new Map();
/** `ePrescriptionCodes` rows → Map<appointmentId, code[]>; a visit with no usable code is left out. */ function $3d8f16e04eed5491$var$codesByVisit(rows) {
    const map = new Map();
    for (const row of Array.isArray(rows) ? rows : []){
        const list = (Array.isArray(row?.codes) ? row.codes : []).filter((c)=>c && c.code);
        if (row?.appointmentId != null && list.length) map.set(String(row.appointmentId), list);
    }
    return map;
}
function $3d8f16e04eed5491$export$4fb531a6c7226101(appointmentIds, { active: active = true } = {}) {
    const [codes, setCodes] = (0, $acw62.useState)($3d8f16e04eed5491$var$NONE);
    const seq = (0, $acw62.useRef)(0);
    const readKey = (0, $acw62.useRef)(''); // the id set whose answer `codes` holds
    const activeRef = (0, $acw62.useRef)(active);
    activeRef.current = active;
    const key = (0, $acw62.useMemo)(()=>[
            ...new Set((appointmentIds || []).filter((id)=>id != null && id !== '').map(String))
        ].sort().slice(0, $3d8f16e04eed5491$export$154cd89215e18417).join('\n'), [
        appointmentIds
    ]);
    const keyRef = (0, $acw62.useRef)(key);
    keyRef.current = key;
    const read = (0, $acw62.useCallback)(async (forKey)=>{
        const mine = ++seq.current;
        try {
            const d = await (0, $eVM84.bffQuery)((0, $6xvbB.ERX_CODES), {
                ids: forKey.split('\n')
            });
            if (mine !== seq.current) return;
            readKey.current = forKey;
            setCodes($3d8f16e04eed5491$var$codesByVisit(d?.ePrescriptionCodes));
        } catch  {
        /* silence: the history shows what it showed before the feature existed */ }
    }, []);
    const reload = (0, $acw62.useCallback)(async ()=>{
        if (!activeRef.current || !keyRef.current) return;
        await read(keyRef.current);
    }, [
        read
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!key) {
            seq.current += 1; // an answer still on its way no longer applies
            readKey.current = '';
            setCodes($3d8f16e04eed5491$var$NONE);
            return;
        }
        if (!active) {
            seq.current += 1;
            return;
        }
        if (readKey.current === key) return;
        read(key);
    }, [
        active,
        key,
        read
    ]);
    (0, $acw62.useEffect)(()=>()=>{
            seq.current += 1;
        }, []);
    return {
        codes: codes,
        reload: reload
    };
}
var $3d8f16e04eed5491$export$2e2bcd8739ae039 = $3d8f16e04eed5491$export$4fb531a6c7226101;

});


parcelRegister("9BB3T", function(module, exports) {

$parcel$export(module.exports, "MobileVisitVitalsHistorySheet", () => $f91b9c2a59f5e411$export$4a9e58f0ce1db37f);
$parcel$export(module.exports, "MobileVisitEditPatientSheet", () => $f91b9c2a59f5e411$export$9a251dbf2f7b9965);
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");
parcelRequire("7sS0P");
var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $cZOyb = parcelRequire("cZOyb");
var $aJ1FU = parcelRequire("aJ1FU");
var $7gSBD = parcelRequire("7gSBD");
var $7phmx = parcelRequire("7phmx");
var $4Qco3 = parcelRequire("4Qco3");
var $Ydgp5 = parcelRequire("Ydgp5");
var $lffTJ = parcelRequire("lffTJ");
var $6SCJ6 = parcelRequire("6SCJ6");
var $fAR2n = parcelRequire("fAR2n");
var $3Amwd = parcelRequire("3Amwd");
var $a7Rbr = parcelRequire("a7Rbr");

var $k2reB = parcelRequire("k2reB");
parcelRequire("gcegg");
var $jTCZr = parcelRequire("jTCZr");

var $kyxc1 = parcelRequire("kyxc1");
// The two overlays the in-visit record opens: the vitals history and the
// demographics editor. Both are the phone rendering of a desktop Visit modal
// (Visit.web.jsx → «تاریخچه علائم حیاتی» and «ویرایش بیمار»); they carry the
// same data and the same write contract, in a BottomSheet instead of a Dialog.
// Same LOINC set + thresholds the desktop vitals-history modal uses.
const $f91b9c2a59f5e411$var$VITAL_META = (t)=>({
        '8480-6': {
            label: 'BP sys',
            unit: 'mmHg',
            status: (v)=>v > 140 || v < 90 ? 'crit' : v > 120 ? 'warn' : 'ok'
        },
        '8462-4': {
            label: 'BP dia',
            unit: 'mmHg',
            status: (v)=>v > 90 || v < 60 ? 'crit' : v > 80 ? 'warn' : 'ok'
        },
        '8867-4': {
            label: t('visit.vitals.pulse'),
            unit: 'bpm',
            status: (v)=>v > 110 || v < 50 ? 'crit' : v > 100 || v < 60 ? 'warn' : 'ok'
        },
        '59408-5': {
            label: "SpO\u2082",
            unit: '%',
            status: (v)=>v < 92 ? 'crit' : v < 95 ? 'warn' : 'ok'
        },
        '8310-5': {
            label: t('patient.vitals.temp'),
            unit: "\xb0C",
            status: (v)=>v > 38.5 || v < 36 ? 'crit' : v > 37.2 ? 'warn' : 'ok'
        },
        '29463-7': {
            label: t('patient.vitals.wt'),
            unit: 'kg',
            status: ()=>'ok'
        }
    });
const $f91b9c2a59f5e411$var$STATUS_COLOR = {
    ok: (0, $jTCZr.CT).good,
    warn: (0, $jTCZr.CT).warnInk,
    crit: (0, $jTCZr.CT).danger
};
const $f91b9c2a59f5e411$var$STATUS_BG = {
    ok: (0, $jTCZr.CT).goodSoft,
    warn: (0, $jTCZr.CT).warnSoft,
    crit: (0, $jTCZr.CT).dangerSoft
};
const $f91b9c2a59f5e411$export$4a9e58f0ce1db37f = ({ open: open, onClose: onClose, observations: observations = [] })=>{
    const { t: t, formatDigits: formatDigits } = (0, $LNQP4.default)();
    const meta = $f91b9c2a59f5e411$var$VITAL_META(t);
    const cards = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const groups = {};
        observations.forEach((obs)=>{
            const m = meta[obs.code];
            if (!m) return;
            const val = parseFloat(obs.value);
            if (isNaN(val)) return;
            if (!groups[obs.code]) groups[obs.code] = {
                ...m,
                code: obs.code,
                pts: []
            };
            groups[obs.code].pts.push({
                date: obs.effectiveDate,
                value: val
            });
        });
        return Object.values(groups);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        observations
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: open,
        onClose: onClose,
        title: t('visit.vitals.history'),
        closeLabel: t('common.actions.close')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-vitals-history-sheet"
    }, cards.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $k2reB.default), {
            size: 40,
            color: (0, $jTCZr.C).textMuted,
            strokeWidth: 1.5,
            "aria-hidden": true
        }),
        title: t('visit.patient.noHistory')
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '0.5rem'
        }
    }, cards.map((m)=>{
        const sorted = [
            ...m.pts
        ].sort((a, b)=>new Date(a.date) - new Date(b.date));
        const last = sorted[sorted.length - 1];
        const prev = sorted[sorted.length - 2];
        const st = m.status(last.value);
        const delta = prev ? last.value - prev.value : null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: m.code,
            "data-testid": `vitals-history-${m.code}`,
            style: {
                background: $f91b9c2a59f5e411$var$STATUS_BG[st],
                border: `1px solid ${(0, $jTCZr.soft)($f91b9c2a59f5e411$var$STATUS_COLOR[st], 0.35)}`,
                borderRadius: '0.625rem',
                padding: '0.625rem 0.75rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.625rem',
                fontWeight: 600,
                color: (0, $jTCZr.C).textMuted,
                textTransform: 'uppercase',
                marginBottom: '0.25rem'
            }
        }, m.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'baseline',
                gap: '0.25rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "ltr",
            style: {
                fontSize: '1.125rem',
                fontWeight: 700,
                color: $f91b9c2a59f5e411$var$STATUS_COLOR[st],
                fontFamily: 'ui-monospace, monospace'
            }
        }, formatDigits(last.value)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.5625rem',
                color: (0, $jTCZr.C).textMuted
            }
        }, m.unit)), delta != null && delta !== 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            dir: "ltr",
            style: {
                fontSize: '0.625rem',
                color: (0, $jTCZr.C).textMuted,
                marginTop: '0.125rem'
            }
        }, delta > 0 ? "\u25B2" : "\u25BC", " ", formatDigits(Math.abs(Math.round(delta * 10) / 10))), sorted.length > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                marginTop: '0.375rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3Amwd.default), {
            points: sorted.map((x)=>x.value),
            width: 72,
            height: 18,
            tone: st === 'crit' ? 'danger' : st === 'warn' ? 'warn' : undefined
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.5625rem',
                color: (0, $jTCZr.C).textMuted,
                marginTop: '0.25rem'
            }
        }, t('visit.vitals.readingCount', {
            count: sorted.length
        })));
    }))));
};
const $f91b9c2a59f5e411$var$BLOOD_TYPES = [
    'A+',
    'A-',
    'B+',
    'B-',
    'AB+',
    'AB-',
    'O+',
    'O-'
];
const $f91b9c2a59f5e411$export$9a251dbf2f7b9965 = ({ open: open, onClose: onClose, form: form = {}, onChange: onChange, saving: saving, error: error, phoneErrors: phoneErrors, onSave: onSave })=>{
    const { t: t, locale: locale } = (0, $LNQP4.default)();
    // The clinic country's defaults for an EMPTY phone and a NEW id (PM-0218) — the
    // same ones the screen's save judges by; `undefined` is Iran's, as before.
    const { nationalIdCountry: nidDefault, phoneCountry: phoneCountry } = (0, $kyxc1.useCountryDefaults)();
    const phoneList = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const [showPhoneErrors, setShowPhoneErrors] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (open) setShowPhoneErrors(false);
    }, [
        open
    ]);
    const rows = Array.isArray(form.phones) ? form.phones : null;
    // A row left without its number or «صاحب شماره», or a number typed twice, is
    // said under that row and the caret goes there — nothing is sent (DC §5.3).
    const save = ()=>{
        const first = rows ? (0, $6SCJ6.phoneListProblems)(rows, {
            locale: locale
        })[0] : null;
        if (first) {
            setShowPhoneErrors(true);
            phoneList.current?.focus(first.key, first.field);
            return;
        }
        onSave();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: open,
        onClose: onClose,
        title: t('visit.patient.edit'),
        closeLabel: t('common.actions.close')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-edit-patient-sheet",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
        label: t('common.labels.name'),
        value: form.name || '',
        onChange: (e)=>onChange('name', e.target.value),
        placeholder: t('visit.patient.fullName')
    }), rows ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6SCJ6.default), {
        ref: phoneList,
        value: rows,
        onChange: (next)=>onChange('phones', next),
        label: t('common.labels.phone'),
        errors: phoneErrors,
        showErrors: showPhoneErrors,
        defaultCountry: phoneCountry,
        locale: locale,
        isMobile: true,
        "data-testid": "visit-edit-patient-phones"
    }) : /* E.164 out, not an event — `onChange(e164, meta)`. `''` until the number parses,
             so what `onChange('phone', …)` stores is already the canonical form the
             desktop dialog stores. Parity with `Visit.web.jsx`'s edit-patient dialog. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lffTJ.default), {
        label: t('common.labels.phone'),
        value: form.phone || '',
        key: phoneCountry || '',
        defaultCountry: phoneCountry,
        onChange: (phone)=>onChange('phone', phone)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $Ydgp5.default), {
        label: t('common.labels.nationalId'),
        value: form.nationalId || '',
        allowOtherCountries: true,
        defaultCountry: nidDefault,
        onChange: (e)=>onChange('nationalId', e.target.value),
        onCountryChange: (c)=>onChange('nationalIdCountry', c),
        "data-testid": "visit-edit-patient-nid"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        label: t('common.labels.birthDate')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4Qco3.default), {
        value: form.birthDate || '',
        onChange: (v)=>onChange('birthDate', v),
        height: 44,
        placeholder: t('visit.patient.birthDatePlaceholder'),
        disableFuture: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
        label: t('visit.patient.occupation'),
        value: form.job || '',
        onChange: (e)=>onChange('job', e.target.value),
        placeholder: t('visit.patient.occupation')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
        label: t('visit.vitals.height'),
        type: "number",
        dir: "ltr",
        value: form.height || '',
        onChange: (e)=>onChange('height', e.target.value),
        placeholder: "175"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fAR2n.default), {
        label: t('visit.patient.bloodType'),
        value: form.bloodType || '',
        onChange: (e)=>onChange('bloodType', e.target.value),
        options: $f91b9c2a59f5e411$var$BLOOD_TYPES.map((bt)=>({
                value: bt,
                label: bt
            })),
        placeholder: t('common.actions.select')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fAR2n.default), {
        label: t('visit.patient.insurance'),
        value: form.insurance || '',
        onChange: (e)=>onChange('insurance', e.target.value),
        options: [
            {
                value: 'social',
                label: t('patient.insurance.social')
            },
            {
                value: 'health',
                label: t('patient.insurance.health')
            },
            {
                value: 'military',
                label: t('patient.insurance.military')
            },
            {
                value: 'other',
                label: t('patient.insurance.other')
            }
        ],
        placeholder: t('common.actions.select')
    }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-edit-patient-error",
        style: {
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).dangerInk,
            fontWeight: 600
        }
    }, error), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "lg",
        className: "flex-1 min-h-11",
        onClick: onClose
    }, t('common.actions.cancel')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "default",
        size: "lg",
        className: "flex-1 min-h-11",
        disabled: saving,
        "data-testid": "visit-edit-patient-save",
        onClick: save
    }, saving ? t('common.state.saving') : t('common.actions.save')))));
};

});
parcelRegister("k2reB", function(module, exports) {

$parcel$export(module.exports, "default", () => $340d4e1a05281a91$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $340d4e1a05281a91$export$a2387ed3b5d536eb = {
    name: "activity",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2",
                key: "169zse"
            }
        ]
    ]
};
$340d4e1a05281a91$export$a2387ed3b5d536eb.node;
const $340d4e1a05281a91$export$2e2bcd8739ae039 = (0, $9QBug.default)($340d4e1a05281a91$export$a2387ed3b5d536eb);

});


parcelRegister("99eLi", function(module, exports) {

$parcel$export(module.exports, "default", () => $8666d5605a00f2ea$export$2e2bcd8739ae039);
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");
parcelRequire("7sS0P");
var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $cZOyb = parcelRequire("cZOyb");
var $aJ1FU = parcelRequire("aJ1FU");
var $7gSBD = parcelRequire("7gSBD");
// The full lab list behind the record sheet's preview — the phone's answer to
// the desktop «مشاهدهٔ همه» RecordListSheet (Visit.web.jsx, `record-sheet-labs`).
//
// The record sheet shows ten and used to end with a dead «+N نتیجه» line: the
// count of results the doctor was being told they could not see. This is where
// that number now leads.
//
// Vital signs are not lab results. The record panel filters them out by LOINC
// and so does this — the same six codes, spelled here rather than imported from
// the record sheet, because a sheet that renders labs should not depend on the
// sheet that links to it.
const $8666d5605a00f2ea$var$VITAL_CODES = new Set([
    '8480-6',
    '8462-4',
    '8867-4',
    '59408-5',
    '8310-5',
    '29463-7'
]);
const $8666d5605a00f2ea$var$PAGE = 20;
const $8666d5605a00f2ea$var$FILTERS = (t)=>[
        {
            id: 'all',
            label: t('common.state.all')
        },
        {
            id: 'critical',
            label: t('visit.vitals.critical')
        },
        {
            id: 'abnormal',
            label: t('visit.vitals.abnormal')
        }
    ];
const $8666d5605a00f2ea$var$MobileVisitLabsSheet = ({ open: open, onClose: onClose, labResults: labResults = [] })=>{
    const { t: t, formatDigits: formatDigits } = (0, $LNQP4.default)();
    const [filter, setFilter] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('all');
    const [shown, setShown] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState($8666d5605a00f2ea$var$PAGE);
    // Reopening starts at the top of an unfiltered list: the previous visit's
    // scroll position is not a state the doctor asked to keep.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (open) {
            setFilter('all');
            setShown($8666d5605a00f2ea$var$PAGE);
        }
    }, [
        open
    ]);
    // Critical → abnormal → newest, the desktop ordering.
    const all = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(labResults || []).filter((o)=>!$8666d5605a00f2ea$var$VITAL_CODES.has(o.code)).slice().sort((a, b)=>{
            const sA = a.status === 'CRITICAL' ? 0 : a.status === 'ABNORMAL' ? 1 : 2;
            const sB = b.status === 'CRITICAL' ? 0 : b.status === 'ABNORMAL' ? 1 : 2;
            if (sA !== sB) return sA - sB;
            return (b.effectiveDate || '').localeCompare(a.effectiveDate || '');
        }), [
        labResults
    ]);
    const counts = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
            all: all.length,
            critical: all.filter((o)=>o.status === 'CRITICAL').length,
            abnormal: all.filter((o)=>o.status === 'ABNORMAL').length
        }), [
        all
    ]);
    const filtered = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>filter === 'all' ? all : all.filter((o)=>o.status === filter.toUpperCase()), [
        all,
        filter
    ]);
    const page = filtered.slice(0, shown);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: open,
        onClose: onClose,
        title: t('visit.patient.labResults')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-labs-sheet",
        "data-state": filtered.length ? 'content' : 'empty'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: '0.375rem',
            marginBottom: '0.75rem',
            flexWrap: 'wrap'
        }
    }, $8666d5605a00f2ea$var$FILTERS(t).map(({ id: id, label: label })=>{
        const on = filter === id;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            key: id,
            variant: on ? 'default' : 'outline',
            size: "sm",
            className: "min-h-11 gap-1",
            "aria-pressed": on,
            "data-testid": `visit-labs-filter-${id}`,
            onClick: ()=>{
                setFilter(id);
                setShown($8666d5605a00f2ea$var$PAGE);
            }
        }, label, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.625rem',
                opacity: 0.75
            }
        }, formatDigits(counts[id] || 0)));
    })), filtered.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-labs-empty"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        title: filter === 'all' ? t('patient.obs.noLabResults') : t('common.state.empty'),
        hint: filter === 'all' ? undefined : t('common.actions.clearFilters')
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column'
        }
    }, page.map((obs, i)=>{
        const isCritical = obs.status === 'CRITICAL';
        const isAbnormal = obs.status === 'ABNORMAL';
        const valColor = isCritical ? (0, $jTCZr.CT).danger : isAbnormal ? (0, $jTCZr.CT).warnInk : (0, $jTCZr.CT).good;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: (obs.id || '') + '_' + i,
            "data-testid": `visit-labs-row-${obs.id || i}`,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                padding: '0.5rem',
                borderRadius: '0.5rem',
                background: isCritical ? (0, $jTCZr.CT).dangerSoft : isAbnormal ? (0, $jTCZr.C).amberLight : 'transparent',
                borderBottom: i < page.length - 1 ? `1px solid ${(0, $jTCZr.C).border}` : 'none'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                width: '0.4375rem',
                height: '0.4375rem',
                borderRadius: '50%',
                background: valColor,
                flexShrink: 0
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1,
                minWidth: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.75rem',
                color: (0, $jTCZr.C).textPrimary,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            }
        }, obs.display), obs.referenceRange && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            dir: "ltr",
            style: {
                fontSize: '0.5625rem',
                color: (0, $jTCZr.C).textMuted
            }
        }, "ref: ", obs.referenceRange)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            dir: "ltr",
            style: {
                fontSize: '0.8125rem',
                fontWeight: 700,
                fontFamily: 'ui-monospace, monospace',
                color: valColor,
                flexShrink: 0
            }
        }, formatDigits(obs.value), obs.unit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.5625rem',
                fontWeight: 400,
                color: (0, $jTCZr.C).textMuted
            }
        }, " ", obs.unit) : ''), (isCritical || isAbnormal) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.5625rem',
                fontWeight: 700,
                padding: '0.0625rem 0.3125rem',
                borderRadius: '0.25rem',
                flexShrink: 0,
                background: isCritical ? (0, $jTCZr.CT).danger : (0, $jTCZr.CT).warn,
                color: isCritical ? '#fff' : (0, $jTCZr.CT).warnInk
            }
        }, isCritical ? t('visit.vitals.critical') : t('visit.vitals.abnormal')));
    })), filtered.length > page.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        className: "w-full min-h-11 mt-2",
        "data-testid": "visit-labs-more",
        onClick: ()=>setShown((s)=>s + $8666d5605a00f2ea$var$PAGE)
    }, t('common.actions.showMore'), " (", formatDigits(filtered.length - page.length), ")"))));
};
var $8666d5605a00f2ea$export$2e2bcd8739ae039 = $8666d5605a00f2ea$var$MobileVisitLabsSheet;

});

parcelRegister("2BAqO", function(module, exports) {

$parcel$export(module.exports, "default", () => $84b0860f5c9bbf22$export$2e2bcd8739ae039);
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");
parcelRequire("7sS0P");
var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $cZOyb = parcelRequire("cZOyb");
var $aJ1FU = parcelRequire("aJ1FU");
var $7gSBD = parcelRequire("7gSBD");

var $a0SXV = parcelRequire("a0SXV");

var $6xvbB = parcelRequire("6xvbB");

var $g6gAc = parcelRequire("g6gAc");
// چاپ نسخه, reachable while the visit is still open.
//
// The phone could only print THROUGH the closure — the نسخه a patient is handed
// mid-visit had no door, and the doctor had to end the visit to produce it. The
// document is unchanged: the same `printPrescription` builders the desktop and
// the closure use, so a نسخه printed here and one printed at closure are the
// same sheet.
//
// The desktop's side-by-side A5 preview pane has no place on a 360px viewport;
// the preview here is a single scrolling column, and only the print itself is
// paginated by the browser.
const $84b0860f5c9bbf22$var$Label = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.625rem',
            fontWeight: 700,
            color: (0, $jTCZr.C).textMuted,
            letterSpacing: '0.06em',
            marginBottom: '0.3125rem'
        }
    }, children);
const $84b0860f5c9bbf22$var$MobileVisitPrintSheet = ({ open: open, onClose: onClose, templates: templates = [], rxItems: rxItems = [], pendingTests: pendingTests = [], diagnosis: diagnosis, soap: soap, doctor: doctor, patient: patient })=>{
    const { t: t, formatDigits: formatDigits } = (0, $LNQP4.default)();
    const [tplId, setTplId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    // «قالب سیستم» is the default on every open: a template chosen for the last
    // نسخه is not a preference, and silently reusing it prints the wrong document.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (open) setTplId('');
    }, [
        open
    ]);
    const template = templates.find((x)=>x.id === tplId) || null;
    const canPrint = rxItems.length > 0;
    const handlePrint = ()=>(0, $6xvbB.printPrescription)({
            template: template,
            rxItems: rxItems,
            pendingTests: pendingTests,
            diagnosis: diagnosis,
            soap: soap,
            doctor: doctor,
            patient: patient,
            t: t
        });
    const labs = pendingTests.filter((x)=>x.type === 'lab');
    const imaging = pendingTests.filter((x)=>x.type === 'imaging');
    const templateText = template ? (0, $6xvbB.fillPrescriptionTemplate)(template.content, {
        rxItems: rxItems,
        pendingTests: pendingTests,
        diagnosis: diagnosis,
        soap: soap,
        doctor: doctor,
        patient: patient,
        t: t
    }) : '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: open,
        onClose: onClose,
        title: t('visit.rx.print'),
        footer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "default",
            size: "lg",
            className: "w-full min-h-11 gap-1.5",
            "data-testid": "visit-print-confirm",
            disabled: !canPrint,
            onClick: handlePrint
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a0SXV.default), {
            size: 15,
            "aria-hidden": true
        }), " ", t('visit.rx.print'))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-print-sheet",
        "data-state": canPrint ? 'content' : 'empty'
    }, !canPrint ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-print-empty"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        title: t('visit.rx.none'),
        hint: t('visit.rx.emptyHint')
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($84b0860f5c9bbf22$var$Label, null, t('visit.rx.template')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("select", {
        value: tplId,
        onChange: (e)=>setTplId(e.target.value),
        "data-testid": "visit-print-template",
        style: {
            width: '100%',
            boxSizing: 'border-box',
            minHeight: '2.75rem',
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: '0.5rem',
            padding: '0.5rem 0.625rem',
            background: (0, $jTCZr.CT).surface2,
            // 1rem or iOS zooms the page on focus (§6).
            fontSize: '1rem',
            fontFamily: 'inherit',
            color: (0, $jTCZr.C).textPrimary,
            marginBottom: '0.875rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
        value: ""
    }, t('visit.rx.systemFormat')), templates.map((x)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
            key: x.id,
            value: x.id
        }, x.name))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($84b0860f5c9bbf22$var$Label, null, t('visit.rx.preview')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-print-preview",
        style: {
            background: (0, $jTCZr.C).card,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: '0.625rem',
            padding: '0.75rem',
            maxHeight: '22rem',
            overflowY: 'auto'
        }
    }, template ? // A filled template is the author's own layout — shown verbatim,
    // and allowed to scroll sideways INSIDE its own box so the page
    // itself never does.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("pre", {
        style: {
            margin: 0,
            fontFamily: 'inherit',
            fontSize: '0.71875rem',
            color: (0, $jTCZr.C).textPrimary,
            lineHeight: 1.9,
            whiteSpace: 'pre-wrap',
            overflowX: 'auto'
        }
    }, templateText) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            textAlign: 'center',
            borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
            paddingBottom: '0.5rem',
            marginBottom: '0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.8125rem',
            fontWeight: 700,
            color: (0, $jTCZr.C).textPrimary
        }
    }, doctor?.name || ''), doctor?.specialty && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.625rem',
            color: (0, $jTCZr.C).textMuted
        }
    }, doctor.specialty), doctor?.medicalCode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: "ltr",
        style: {
            fontSize: '0.625rem',
            color: (0, $jTCZr.C).textMuted
        }
    }, t('visit.print.medicalCode'), ": ", formatDigits(doctor.medicalCode))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            justifyContent: 'space-between',
            gap: '0.5rem',
            fontSize: '0.6875rem',
            color: (0, $jTCZr.C).textSecondary,
            marginBottom: '0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, patient?.name || ''), patient?.nationalId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "ltr"
    }, formatDigits(patient.nationalId))), diagnosis && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginBottom: '0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($84b0860f5c9bbf22$var$Label, null, t('visit.print.diagnosis')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.71875rem',
            color: (0, $jTCZr.C).textPrimary,
            lineHeight: 1.8
        }
    }, diagnosis)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($84b0860f5c9bbf22$var$Label, null, t('patient.tabs.medications')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ol", {
        style: {
            margin: 0,
            paddingInlineStart: '1.125rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.375rem'
        }
    }, rxItems.map((r, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: r.id || i,
            style: {
                fontSize: '0.71875rem',
                color: (0, $jTCZr.C).textPrimary,
                lineHeight: 1.7
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "auto",
            style: {
                fontWeight: 700
            }
        }, (0, $g6gAc.drugDisplayName)(r.drug)), [
            r.dosage,
            r.route,
            r.frequency,
            r.duration
        ].filter(Boolean).length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                color: (0, $jTCZr.C).textSecondary
            }
        }, " \u2014 ", [
            r.dosage,
            r.route,
            r.frequency,
            r.duration
        ].filter(Boolean).join(" \xb7 ")), r.instructions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.65625rem',
                color: (0, $jTCZr.C).textMuted
            }
        }, r.instructions)))), labs.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: '0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($84b0860f5c9bbf22$var$Label, null, t('visit.orders.lab')), labs.map((x, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                fontSize: '0.6875rem',
                color: (0, $jTCZr.C).textSecondary
            }
        }, "\u2022 ", x.name))), imaging.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: '0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($84b0860f5c9bbf22$var$Label, null, t('patient.orderType.imaging')), imaging.map((x, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                fontSize: '0.6875rem',
                color: (0, $jTCZr.C).textSecondary
            }
        }, "\u2022 ", x.name))), soap?.p && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: '0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($84b0860f5c9bbf22$var$Label, null, t('visit.soap.pLetter')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.6875rem',
            color: (0, $jTCZr.C).textSecondary,
            lineHeight: 1.8,
            whiteSpace: 'pre-wrap'
        }
    }, soap.p)))))));
};
var $84b0860f5c9bbf22$export$2e2bcd8739ae039 = $84b0860f5c9bbf22$var$MobileVisitPrintSheet;

});
parcelRegister("a0SXV", function(module, exports) {

$parcel$export(module.exports, "default", () => $d27abdf05888854f$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $d27abdf05888854f$export$a2387ed3b5d536eb = {
    name: "printer",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2",
                key: "143wyd"
            }
        ],
        [
            "path",
            {
                d: "M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6",
                key: "1itne7"
            }
        ],
        [
            "rect",
            {
                x: "6",
                y: "14",
                width: "12",
                height: "8",
                rx: "1",
                key: "1ue0tg"
            }
        ]
    ]
};
$d27abdf05888854f$export$a2387ed3b5d536eb.node;
const $d27abdf05888854f$export$2e2bcd8739ae039 = (0, $9QBug.default)($d27abdf05888854f$export$a2387ed3b5d536eb);

});


parcelRegister("t47X1", function(module, exports) {

$parcel$export(module.exports, "default", () => $0225b93de05eb560$export$2e2bcd8739ae039);
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");
parcelRequire("7sS0P");
var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $cZOyb = parcelRequire("cZOyb");
var $aJ1FU = parcelRequire("aJ1FU");

var $bOJgt = parcelRequire("bOJgt");
var $gXsFl = parcelRequire("gXsFl");
var $a0SXV = parcelRequire("a0SXV");
parcelRequire("gcegg");
var $jTCZr = parcelRequire("jTCZr");
// The ⋯ header menu — what the desktop topbar carries and the phone's single
// docked CTA cannot.
//
// لغو ویزیت lives HERE, not in the footer, on purpose: the footer holds «پایان
// ویزیت», and two terminal actions with opposite meanings sitting side by side
// on a thumb-sized target is how a visit gets destroyed instead of closed.
// Burying it costs one tap and removes that class of mistake entirely.
//
// Nothing here confirms — the screen owns every ConfirmDialog, so the confirm
// copy and the mutation stay in one place.
const $0225b93de05eb560$var$Row = ({ Icon: Icon, label: label, onClick: onClick, disabled: disabled, danger: danger, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: danger ? 'ghost' : 'subtle',
        size: "lg",
        className: "w-full min-h-11 justify-start gap-2.5 mb-2",
        "data-testid": testId,
        disabled: disabled,
        onClick: onClick,
        style: danger ? {
            color: (0, $jTCZr.CT).dangerInk,
            background: (0, $jTCZr.soft)((0, $jTCZr.C).red, 0.08)
        } : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        size: 16,
        "aria-hidden": true
    }), label);
const $0225b93de05eb560$var$MobileVisitOverflowSheet = ({ open: open, onClose: onClose, onPrint: onPrint, onUploadLab: onUploadLab, onCancelVisit: onCancelVisit, canPrint: canPrint = false, canCancel: canCancel = false, cancelling: cancelling = false })=>{
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: open,
        onClose: onClose,
        title: t('common.actions.more')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-overflow-sheet"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0225b93de05eb560$var$Row, {
        Icon: (0, $a0SXV.default),
        label: t('visit.rx.print'),
        testId: "visit-overflow-print",
        disabled: !canPrint,
        onClick: onPrint
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0225b93de05eb560$var$Row, {
        Icon: (0, $gXsFl.default),
        label: t('visit.patient.uploadResult'),
        testId: "visit-overflow-upload",
        onClick: onUploadLab
    }), canCancel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0225b93de05eb560$var$Row, {
        Icon: (0, $bOJgt.default),
        danger: true,
        label: cancelling ? t('visit.header.cancelling') : t('visit.header.cancelVisit'),
        testId: "visit-overflow-cancel",
        disabled: cancelling,
        onClick: onCancelVisit
    })));
};
var $0225b93de05eb560$export$2e2bcd8739ae039 = $0225b93de05eb560$var$MobileVisitOverflowSheet;

});
parcelRegister("bOJgt", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bb373bd7e3948d8$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $6bb373bd7e3948d8$export$a2387ed3b5d536eb = {
    name: "ban",
    size: 24,
    node: [
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                r: "10",
                key: "1mglay"
            }
        ],
        [
            "path",
            {
                d: "M4.929 4.929 19.07 19.071",
                key: "196cmz"
            }
        ]
    ]
};
$6bb373bd7e3948d8$export$a2387ed3b5d536eb.node;
const $6bb373bd7e3948d8$export$2e2bcd8739ae039 = (0, $9QBug.default)($6bb373bd7e3948d8$export$a2387ed3b5d536eb);

});


parcelRegister("9Akci", function(module, exports) {

$parcel$export(module.exports, "default", () => $78bf9afd2f70d001$export$2e2bcd8739ae039);
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");
parcelRequire("7sS0P");
var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $cjPik = parcelRequire("cjPik");

var $QG9Z3 = parcelRequire("QG9Z3");
var $huNwV = parcelRequire("huNwV");
var $4CVxl = parcelRequire("4CVxl");
var $jhSl7 = parcelRequire("jhSl7");
var $aVx4q = parcelRequire("aVx4q");
var $a0SXV = parcelRequire("a0SXV");
var $chm1L = parcelRequire("chm1L");
parcelRequire("kQnM4");

var $4UqGT = parcelRequire("4UqGT");

var $7MmQM = parcelRequire("7MmQM");

var $e317r = parcelRequire("e317r");

var $6xvbB = parcelRequire("6xvbB");

var $g6gAc = parcelRequire("g6gAc");

var $lfHhF = parcelRequire("lfHhF");
parcelRequire("2tKqm");
var $9BgRG = parcelRequire("9BgRG");
const $78bf9afd2f70d001$var$SEEDED_RX_TEMPLATE_TITLE = "\u0646\u0633\u062E\u0647 \u067E\u0632\u0634\u06A9\u06CC";
// End-of-visit closure — the phone rendering of the desktop ClosureFlowWizard.
//
// SINGLE STEP, deliberately. The visit is already finalized in the backend
// before this opens (handleEndVisit), so this screen is a read-only review plus
// one final ثبت. There is no stepper, no discharge/outcome step, no consent
// gate and no انصراف: once پایان ویزیت is pressed the doctor cannot abort or
// leave the visit half-open. The phone used to run a four-step wizard
// (review → مرخصی → امضا → ثبت) whose outcome, follow-up and signature state
// was never sent anywhere — it was legacy UI the desktop had already dropped.
//
// The two real actions the desktop closure offers are both here: ثبت در تأمین
// اجتماعی (inline, because it is a decision about THIS visit) and چاپ نسخه,
// which renders the same Persian document via the shared printPrescription.
const $78bf9afd2f70d001$var$SOAP_LABEL = (t)=>({
        s: t('visit.soap.sLetter'),
        o: t('visit.soap.oLetter'),
        a: t('visit.soap.aLetter'),
        p: t('visit.soap.pLetter')
    });
const $78bf9afd2f70d001$var$ReviewCard = ({ Icon: Icon, title: title, sub: sub, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: (0, $jTCZr.C).card,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: '0.625rem',
            padding: '0.75rem 0.8125rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            marginBottom: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        size: 14,
        color: (0, $jTCZr.C).textMuted,
        "aria-hidden": true,
        style: {
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.78125rem',
            fontWeight: 700,
            color: (0, $jTCZr.C).textPrimary
        }
    }, title), sub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.625rem',
            color: (0, $jTCZr.C).textMuted
        }
    }, sub))), children);
const $78bf9afd2f70d001$var$Muted = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.75rem',
            color: (0, $jTCZr.C).textMuted
        }
    }, children);
const $78bf9afd2f70d001$var$MobileVisitClosureFlow = ({ onClose: onClose, soap: soap, rxItems: rxItems, pendingTests: pendingTests, patient: patient, doctor: doctor, diagnosis: diagnosis, prescriptionTemplates: prescriptionTemplates = [], appointmentId: appointmentId, saveFailures: saveFailures = [] })=>{
    // The e-prescription card's login or send in flight — the one piece of unsaved
    // work here. As on the desktop receipt (VisitClosureDialog), every exit — ثبت
    // and the platform back — asks before abandoning it. The phone mounted the card
    // without `onBusyChange`, so either left mid-OTP or mid-send unasked (K1,
    // 2026-10-03).
    const [erxBusy, setErxBusy] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [leaveConfirm, setLeaveConfirm] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // Both insurer cards are Iranian rails (host.jsx useIranianRails), as on desktop.
    const iranianRails = (0, $e317r.useIranianRails)();
    const guardedExit = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((run)=>{
        if (erxBusy) {
            setLeaveConfirm(()=>run);
            return;
        }
        run();
    }, [
        erxBusy
    ]);
    const exit = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>guardedExit(onClose), [
        guardedExit,
        onClose
    ]);
    // §C.3 rule 1 — the closure owns the screen, so back closes IT rather than
    // navigating the visit route out from under it. The receipt is safe to
    // re-enter: the encounter is already finalised when this opens, and every
    // action on it (چاپ, ثبت تأمین) is idempotent. A back refused at the leave
    // confirmation is re-claimed by the hook.
    (0, $9BgRG.default)(true, exit, {
        id: 'visit-closure'
    });
    const { t: t, readsPersianData: readsPersianData } = (0, $LNQP4.default)();
    // The نسخه's dose and frequency are stored as the Persian closed-list values.
    // A Persian reader is shown them as written; anyone else reads them through
    // the labels the desktop receipt uses (ClosureRxCard) — without them an Arabic
    // receipt read «۱ قرص · هر ۸ ساعت».
    const rxLine = (r)=>(readsPersianData ? [
            r.dosage,
            r.frequency
        ] : [
            r.dosage && (0, $6xvbB.drugDosageLabel)(r.dosage, false, t),
            r.frequency && (0, $lfHhF.drugFrequencyLabel)(r.frequency, t)
        ]).filter(Boolean).join(" \xb7 ");
    // doctorpreference seeds every doctor's first print template as «نسخه پزشکی».
    // The title is the doctor's own data and is never translated on the wire;
    // this is display only — the option's VALUE is the template id.
    const templateTitle = (tpl)=>!readsPersianData && tpl.title === $78bf9afd2f70d001$var$SEEDED_RX_TEMPLATE_TITLE ? t('visit.rx.seededTemplateTitle') : tpl.title;
    // What did not reach the record. The tick in the header is a claim about the
    // visit having been saved; when part of it was not, making that claim anyway
    // is how a doctor walks away from an unrecorded prescription.
    const partial = saveFailures.length > 0;
    // تشخیص shows what the doctor wrote — «A» of the SOAP note, else the diagnosis
    // field. There is no AI summary here any more; see Visit.web.jsx's CFStepReview.
    const dxText = (soap?.a || '').trim() || (diagnosis || '').trim();
    // The template picker is a plain select on the phone: the desktop's A5 preview
    // pane has no place on a 360px viewport, but the document it prints is the same.
    const [tplId, setTplId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(prescriptionTemplates[0]?.id || '');
    const template = prescriptionTemplates.find((x)=>x.id === tplId) || null;
    const handlePrint = ()=>(0, $6xvbB.printPrescription)({
            template: template,
            rxItems: rxItems,
            pendingTests: pendingTests,
            diagnosis: diagnosis,
            soap: soap,
            doctor: doctor,
            patient: patient,
            t: t
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'absolute',
            inset: 0,
            zIndex: 60,
            display: 'flex',
            flexDirection: 'column',
            background: (0, $jTCZr.CT).bg
        },
        "data-testid": "visit-closure"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: (0, $jTCZr.GRADIENT_BRAND_DARK),
            flexShrink: 0,
            padding: 'calc(0.75rem + env(safe-area-inset-top, 0px)) 0.875rem 0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: '1.875rem',
            height: '1.875rem',
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.15)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0
        }
    }, partial ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $QG9Z3.default), {
        size: 16,
        strokeWidth: 2.4,
        color: "white",
        "aria-hidden": true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
        size: 16,
        strokeWidth: 2.6,
        color: "white",
        "aria-hidden": true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.8125rem',
            fontWeight: 700,
            color: 'white',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        }
    }, t('visit.header.endVisitNamed', {
        name: patient?.name || ''
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.625rem',
            color: 'rgba(255,255,255,0.6)',
            marginTop: '0.0625rem'
        }
    }, t(partial ? 'visit.end.partialSaveSubtitle' : 'visit.closure.subtitleSaved'))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            overflowY: 'auto',
            padding: '1rem 0.875rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.875rem'
        }
    }, partial && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "closure-partial-save",
        role: "alert",
        style: {
            padding: '0.75rem 0.8125rem',
            borderRadius: '0.625rem',
            background: (0, $jTCZr.C).amberLight,
            border: `1px solid ${(0, $jTCZr.C).amber}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.78125rem',
            fontWeight: 800,
            color: (0, $jTCZr.C).textPrimary,
            marginBottom: '0.375rem'
        }
    }, t('visit.end.partialSaveTitle')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.71875rem',
            color: (0, $jTCZr.C).textSecondary,
            lineHeight: 1.85,
            marginBottom: '0.5rem'
        }
    }, t('visit.end.partialSaveBody')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        style: {
            margin: 0,
            paddingInlineStart: '1.125rem',
            fontSize: '0.71875rem',
            color: (0, $jTCZr.C).textPrimary,
            lineHeight: 1.9
        }
    }, saveFailures.map((item, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: i
        }, item)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h3", {
        style: {
            margin: 0,
            fontSize: '0.9375rem',
            fontWeight: 700,
            color: (0, $jTCZr.C).textPrimary
        }
    }, t('visit.closure.review'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($78bf9afd2f70d001$var$ReviewCard, {
        Icon: (0, $chm1L.default),
        title: t('visit.dx.title'),
        sub: "ICD"
    }, dxText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'inline-block',
            padding: '0.1875rem 0.625rem',
            borderRadius: '0.25rem',
            background: (0, $jTCZr.CT).accentSoft,
            color: (0, $jTCZr.CT).accentInk,
            fontSize: '0.71875rem',
            fontWeight: 600
        }
    }, dxText) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($78bf9afd2f70d001$var$Muted, null, "\u2014")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($78bf9afd2f70d001$var$ReviewCard, {
        Icon: (0, $aVx4q.default),
        title: t('visit.tabs.rx'),
        sub: t('visit.rx.count', {
            count: rxItems.length
        })
    }, rxItems.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.3125rem'
        }
    }, rxItems.slice(0, 3).map((r, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                fontSize: '0.71875rem',
                color: (0, $jTCZr.C).textSecondary,
                borderInlineStart: `2px solid ${(0, $jTCZr.CT).accent}`,
                paddingInlineStart: '0.5rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("b", {
            dir: "auto",
            style: {
                fontSize: '0.75rem',
                color: (0, $jTCZr.C).textPrimary
            }
        }, (0, $g6gAc.drugDisplayName)(r.drug)), (r.dosage || r.frequency) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                color: (0, $jTCZr.C).textMuted
            }
        }, " ", rxLine(r)))), rxItems.length > 3 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($78bf9afd2f70d001$var$Muted, null, t('visit.rx.more', {
        count: rxItems.length - 3
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($78bf9afd2f70d001$var$Muted, null, t('visit.rx.none'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($78bf9afd2f70d001$var$ReviewCard, {
        Icon: (0, $4CVxl.default),
        title: t('visit.orders.requests'),
        sub: t('visit.orders.count', {
            count: pendingTests.length
        })
    }, pendingTests.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.25rem'
        }
    }, pendingTests.slice(0, 3).map((test, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                fontSize: '0.71875rem',
                color: (0, $jTCZr.C).textSecondary
            }
        }, "\u2022 ", test.name || test.testName || String(test))), pendingTests.length > 3 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($78bf9afd2f70d001$var$Muted, null, t('visit.orders.more', {
        count: pendingTests.length - 3
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($78bf9afd2f70d001$var$Muted, null, t('visit.orders.noneRecordedShort'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($78bf9afd2f70d001$var$ReviewCard, {
        Icon: (0, $jhSl7.default),
        title: t('visit.end.partSoap'),
        sub: t('visit.closure.itemsCount', {
            count: [
                's',
                'o',
                'a',
                'p'
            ].filter((k)=>(soap?.[k] || '').trim()).length
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.375rem'
        }
    }, [
        's',
        'o',
        'a',
        'p'
    ].map((k)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: k,
            style: {
                background: (0, $jTCZr.CT).surface2,
                borderRadius: '0.375rem',
                padding: '0.375rem 0.5rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.5625rem',
                fontWeight: 800,
                color: (0, $jTCZr.C).textMuted,
                letterSpacing: '0.08em',
                display: 'block'
            }
        }, k.toUpperCase(), " \xb7 ", $78bf9afd2f70d001$var$SOAP_LABEL(t)[k]), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.71875rem',
                color: (0, $jTCZr.C).textSecondary,
                lineHeight: 1.6,
                whiteSpace: 'pre-wrap'
            }
        }, soap[k] || "\u2014"))))), iranianRails && appointmentId && patient?.id && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7MmQM.default), {
        appointmentId: appointmentId,
        patientId: patient.id
    }), iranianRails && appointmentId && patient?.id && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4UqGT.default), {
        appointmentId: appointmentId,
        patientId: patient.id,
        onBusyChange: setErxBusy,
        compactWhenSettled: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flexShrink: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem',
            padding: '0.75rem 0.875rem calc(0.75rem + env(safe-area-inset-bottom, 0px))',
            borderTop: `1px solid ${(0, $jTCZr.C).border}`,
            background: (0, $jTCZr.C).card
        }
    }, rxItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, prescriptionTemplates.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("select", {
        value: tplId,
        onChange: (e)=>setTplId(e.target.value),
        "aria-label": t('visit.rx.template'),
        "data-testid": "visit-closure-template",
        style: {
            width: '100%',
            minHeight: '2.75rem',
            padding: '0 0.6875rem',
            borderRadius: '0.5rem',
            border: `1px solid ${(0, $jTCZr.C).border}`,
            background: (0, $jTCZr.CT).surface2,
            color: (0, $jTCZr.C).textPrimary,
            fontSize: '0.8125rem',
            fontFamily: 'inherit'
        }
    }, prescriptionTemplates.map((tpl)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
            key: tpl.id,
            value: tpl.id
        }, templateTitle(tpl))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
        value: ""
    }, t('visit.rx.systemFormat'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "lg",
        onClick: handlePrint,
        "data-testid": "visit-closure-print",
        className: "w-full min-h-11 gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a0SXV.default), {
        size: 14,
        "aria-hidden": true
    }), " ", t('visit.rx.print'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "default",
        size: "lg",
        onClick: exit,
        "data-testid": "visit-closure-done",
        className: "w-full min-h-11 gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
        size: 14,
        "aria-hidden": true
    }), " ", t('visit.closure.backToReception'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cjPik.default), {
        open: !!leaveConfirm,
        onOpenChange: (open)=>{
            if (!open) setLeaveConfirm(null);
        },
        title: t('visit.erx.leaveTitle'),
        description: t('visit.erx.leaveBody'),
        confirmLabel: t('common.actions.leave'),
        cancelLabel: t('visit.erx.stayLabel'),
        confirmTestId: "visit-closure-leave-ok",
        cancelTestId: "visit-closure-leave-cancel",
        "data-testid": "visit-closure-leave-confirm",
        onConfirm: ()=>{
            const run = leaveConfirm;
            setLeaveConfirm(null);
            run?.();
        }
    }));
};
var $78bf9afd2f70d001$export$2e2bcd8739ae039 = $78bf9afd2f70d001$var$MobileVisitClosureFlow;

});
parcelRegister("4UqGT", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ccba15c4d511e83$export$2e2bcd8739ae039);
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $bHjRG = parcelRequire("bHjRG");
var $aJ1FU = parcelRequire("aJ1FU");
var $9gEOi = parcelRequire("9gEOi");
var $7phmx = parcelRequire("7phmx");
var $3tGMU = parcelRequire("3tGMU");
var $Ydgp5 = parcelRequire("Ydgp5");
var $5AX1S = parcelRequire("5AX1S");
var $lffTJ = parcelRequire("lffTJ");
var $fYgeo = parcelRequire("fYgeo");
var $66joL = parcelRequire("66joL");
var $hZDga = parcelRequire("hZDga");
var $gCvEY = parcelRequire("gCvEY");
var $a7Rbr = parcelRequire("a7Rbr");
var $5JYPc = parcelRequire("5JYPc");
var $k27hS = parcelRequire("k27hS");

var $42KYO = parcelRequire("42KYO");
var $d8YVq = parcelRequire("d8YVq");
var $huNwV = parcelRequire("huNwV");
var $kMJsW = parcelRequire("kMJsW");
var $cxlxT = parcelRequire("cxlxT");
var $6lig1 = parcelRequire("6lig1");
var $0hzSL = parcelRequire("0hzSL");
var $kx99t = parcelRequire("kx99t");
var $aGlWN = parcelRequire("aGlWN");
var $6OGKD = parcelRequire("6OGKD");
var $bo0GS = parcelRequire("bo0GS");
var $6TdpC = parcelRequire("6TdpC");

var $jTCZr = parcelRequire("jTCZr");

var $eVM84 = parcelRequire("eVM84");

var $ctEhH = parcelRequire("ctEhH");

var $feEcD = parcelRequire("feEcD");

var $3OnFU = parcelRequire("3OnFU");

var $6xvbB = parcelRequire("6xvbB");

var $eyy5H = parcelRequire("eyy5H");
// The card's segmented choices (insurer, gender) are 44 px on a phone
// — they were 32 px under a thumb (PM-0137 c); the desktop keeps the size asked.
function $1ccba15c4d511e83$var$ErxSegmented(props) {
    const { isMobile: isMobile } = (0, $k27hS.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fYgeo.default), {
        ...props,
        size: isMobile ? 'lg' : props.size
    });
}
// «نسخهٔ الکترونیک بیمه» — sends the visit's drugs to the patient's insurer through
// the op-naji gateway, from inside the visit-closure dialog, beside the تأمین card.
//
// Like that card it owns no protocol knowledge. The server gathers the visit and
// says, by name, what is missing (`blockers`) and which drugs cannot go and why
// (`lines`); the sending service holds the doctor's insurer session. This component
// renders those answers and asks the doctor for exactly three kinds of input: which
// insurer (when the record does not say), their login AT THE INSURER (once — it
// outlives this visit), and the SMS code or captcha the insurer asks for.
//
// One decision, like the تأمین checkbox: pressing «ارسال» is the decision to send.
// When the doctor is not logged in, the login appears in the card and, once it
// completes, the prescription goes without a second press.
//
// The password never outlives the form: it is cleared the moment it is submitted,
// and nothing here stores or logs it.
//
// «اصلاح نسخهٔ ثبت‌شده» (K1, 2026-10-04; docs/eprescription/CORRECTION.md): once a
// part is registered, the server compares what it would send now with what the
// insurer holds, line by line — added, changed (with what the insurer has) or
// removed — and says whether a correction can go (`preview.correction`). The card
// shows that diff, when it can still be corrected, and «ارسال اصلاحیه به بیمه»
// behind a confirmation — or, when it cannot, why. A correction resends the whole
// prescription, through the same login as a send; whatever happens to it, the
// registration stands.
//
// «ثبت نسخه در بیمه» — the visit's panel and the phone's sheet — is `flow="panel"`
// (K1, 2026-10-13, PM-0187). It opens on the login rather than on a button: a
// live insurer session goes straight to «اطلاعات بیمه» and the preview; تأمین
// opens its own login page; سلامت, نیروهای مسلح and a patient whose insurer is not
// on record get a login window. The preview is a checkbox per line, every one
// ticked to start with, and only the ticked lines go. Nothing is sent before the
// doctor presses «ثبت نسخه در …». The closure dialog keeps the card as it was —
// except that no card offers to change an insurer the patient's record names.
// The card's state as the selector contract sees it: one word per state, so a test
// asserts «waiting for a code» rather than looking for Persian copy.
const $1ccba15c4d511e83$var$DATA_STATE = {
    LOADING: 'loading',
    UNAVAILABLE: 'unavailable',
    BLOCKED: 'blocked',
    READY: 'ready',
    LOGIN: 'login',
    OTP: 'otp',
    CAPTCHA: 'captcha',
    REDIRECT: 'redirect',
    SENDING: 'sending',
    REGISTERED: 'registered',
    REJECTED: 'rejected',
    FAILED: 'failed',
    // The preview could not be read; the card says so and offers to read again.
    LOAD_FAILED: 'load-failed'
};
const $1ccba15c4d511e83$var$OTP_MIN = 4;
const $1ccba15c4d511e83$var$OTP_MAX = 8;
const $1ccba15c4d511e83$var$CHALLENGE = [
    'OTP_REQUIRED',
    'CAPTCHA_REQUIRED',
    'REDIRECT_REQUIRED'
];
// Blockers the card itself resolves, so they are not listed as problems: the
// insurer picker answers the first, the login form the next two, the SIAM form
// the last.
const $1ccba15c4d511e83$var$HANDLED_IN_CARD = new Set([
    'INSURER_NOT_SELECTED',
    'DOCTOR_NATIONAL_CODE_MISSING',
    'DOCTOR_MOBILE_MISSING',
    'SIAM_ID_MISSING',
    'PATIENT_GENDER_MISSING',
    'PATIENT_MOBILE_MISSING'
]);
// What the insurer requires of the patient and the record lacks: asked in the
// card (PatientDetailsField), sent, and written into the record by the send.
const $1ccba15c4d511e83$var$PATIENT_DETAIL_NEEDS = {
    gender: 'PATIENT_GENDER_MISSING',
    mobile: 'PATIENT_MOBILE_MISSING'
};
// The two the login form asks for, and saves to the doctor's profile in the same
// call. They must not hold «ارسال» shut: that form opens only FROM «ارسال», so a
// card that waited on `ready` for them sat «ready», silent, with a dead button —
// for good (K1, 2026-10-03).
const $1ccba15c4d511e83$var$LOGIN_NEEDS = new Set([
    'DOCTOR_NATIONAL_CODE_MISSING',
    'DOCTOR_MOBILE_MISSING'
]);
const $1ccba15c4d511e83$export$d7dc397751880ad8 = 4000;
const $1ccba15c4d511e83$export$1591506e3dd28b74 = 5;
// The BFF cannot answer the question at all — it predates the field, or an
// argument the card sends. Asking again never helps and the doctor never had the
// feature, so this is the one failed read the card answers with silence.
function $1ccba15c4d511e83$var$isSchemaGap(e) {
    if (e?.extensions?.code === 'GRAPHQL_VALIDATION_FAILED') return true;
    return /Cannot query field|Unknown argument|Unknown type/.test(String(e?.message || ''));
}
// Test ids. The closure dialog's card keeps «visit-closure-erx-*»; the card the
// visit's نسخه/دستورات section opens can be on screen beneath that dialog, so it
// takes its own prefix rather than duplicate every id.
const $1ccba15c4d511e83$var$ErxTestIdPrefix = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext('visit-closure-erx');
// What this card sends: ALL (the نسخه and the دستورات), DRUGS or SERVICES.
const $1ccba15c4d511e83$var$ErxScope = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext('ALL');
function $1ccba15c4d511e83$var$useErxTid() {
    const prefix = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($1ccba15c4d511e83$var$ErxTestIdPrefix);
    return (s)=>s ? `${prefix}-${s}` : prefix;
}
// ── shell ───────────────────────────────────────────────────────────────────
// `bare`: the panel's — the panel is the frame, so the card draws none of its own.
function $1ccba15c4d511e83$var$CardShell({ tone: tone = 'idle', state: state, compact: compact = false, bare: bare = false, children: children }) {
    const tid = $1ccba15c4d511e83$var$useErxTid();
    const border = {
        idle: (0, $jTCZr.C).border,
        busy: (0, $jTCZr.CT).accent,
        good: (0, $jTCZr.CT).good,
        bad: (0, $jTCZr.CT).danger
    }[tone];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
        "data-testid": tid(),
        "data-state": state,
        "data-compact": compact || undefined,
        "data-flow": bare ? 'panel' : undefined,
        style: bare ? {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.875rem',
            minWidth: 0,
            flex: '1 0 auto'
        } : {
            background: (0, $jTCZr.CT).surface,
            borderRadius: (0, $jTCZr.RADIUS).card,
            border: `1px solid ${border}`,
            padding: '0.8125rem 0.9375rem',
            boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
            transition: 'border-color .2s'
        }
    }, children);
}
function $1ccba15c4d511e83$var$CardHead({ subtitle: subtitle, badges: badges }) {
    const { t: t } = (0, $LNQP4.default)();
    const scope = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($1ccba15c4d511e83$var$ErxScope);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5625rem',
            marginBottom: '0.6875rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": "true",
        style: {
            width: '1.625rem',
            height: '1.625rem',
            borderRadius: (0, $jTCZr.RADIUS).chip,
            flexShrink: 0,
            background: (0, $jTCZr.CT).accentSoft,
            color: (0, $jTCZr.CT).accentInk,
            display: 'grid',
            placeItems: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6OGKD.default), {
        size: 13
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h3", {
        style: {
            margin: 0,
            fontSize: '0.78125rem',
            fontWeight: 700,
            color: (0, $jTCZr.CT).ink
        }
    }, t('visit.erx.title'), scope !== 'ALL' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "visit-erx-scope",
        "data-scope": scope,
        style: {
            marginInlineStart: 6,
            fontSize: '0.625rem',
            fontWeight: 700,
            color: (0, $jTCZr.CT).accentInk,
            background: (0, $jTCZr.CT).accentSoft,
            borderRadius: 4,
            padding: '1px 6px'
        }
    }, t(`visit.erx.scope.${scope}`))), subtitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.625rem',
            color: (0, $jTCZr.CT).mute2
        }
    }, subtitle)), badges);
}
function $1ccba15c4d511e83$var$Note({ tone: tone = 'mute', children: children, ...rest }) {
    const color = {
        mute: (0, $jTCZr.CT).mute,
        good: (0, $jTCZr.CT).good,
        bad: (0, $jTCZr.CT).danger,
        ink: (0, $jTCZr.CT).ink2
    }[tone];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.6875rem',
            color: color,
            lineHeight: 1.7
        },
        ...rest
    }, children);
}
// استحقاق‌سنجی (PM-0145): the insurer's answer on covering the patient, under the
// session line. Quiet when covered; the insurer's words when not — red only where
// that stops the send; a muted line when it could not be asked; nothing when it
// was not asked at all (no session, no national code, an insurer not asked).
function $1ccba15c4d511e83$var$EligibilityLine({ value: value, insurerName: insurerName }) {
    const { t: t } = (0, $LNQP4.default)();
    const tid = $1ccba15c4d511e83$var$useErxTid();
    if (!value) return null;
    if (value === 'loading') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('eligibility'),
        "data-state": "loading",
        style: {
            marginBottom: '0.5rem',
            maxWidth: '14rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonText), {
        lines: 1
    }));
    if (value.state === 'NOT_ASKED') return null;
    if (value.state === 'ELIGIBLE') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('eligibility'),
        "data-state": "ELIGIBLE",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            marginBottom: '0.5rem',
            fontSize: '0.65625rem',
            color: (0, $jTCZr.CT).good
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bo0GS.default), {
        size: 12,
        "aria-hidden": "true"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, t('visit.erx.eligibility.ELIGIBLE', {
        insurer: insurerName
    })));
    if (value.state === 'NOT_ELIGIBLE') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('eligibility'),
        "data-state": "NOT_ELIGIBLE",
        "data-blocks": value.blocks ? 'true' : 'false',
        style: {
            marginBottom: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, {
        tone: value.blocks ? 'bad' : 'ink'
    }, t(value.blocks ? 'visit.erx.eligibility.NOT_ELIGIBLE_BLOCKS' : 'visit.erx.eligibility.NOT_ELIGIBLE', {
        insurer: insurerName
    })), value.message && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, null, t('visit.erx.eligibility.insurerSaid', {
        message: value.message
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('eligibility'),
        "data-state": "UNAVAILABLE",
        style: {
            marginBottom: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, null, t('visit.erx.eligibility.UNAVAILABLE')));
}
// ── the drugs ───────────────────────────────────────────────────────────────
// Every drug of the visit, each saying whether it goes and — if not — why. A doctor
// told «sent» must also be told which lines were not part of it.
//
// Two reason codes say a line's PART is already at the insurer (K1, 2026-10-03):
// ALREADY_REGISTERED went with that registration; ADDED_AFTER_REGISTRATION was
// written after it, never reached the insurer, and cannot be added to it from
// Parsina yet.
const $1ccba15c4d511e83$var$ALREADY_REGISTERED = 'ALREADY_REGISTERED';
const $1ccba15c4d511e83$var$ADDED_AFTER_REGISTRATION = 'ADDED_AFTER_REGISTRATION';
// What a registered part now holds that the insurer does not (K1, 2026-10-04):
// a line changed since — the insurer has the older form, `sentSummary` — or one
// removed since, which the insurer still holds and the server lists on its own.
const $1ccba15c4d511e83$var$CHANGED_SINCE_REGISTRATION = 'CHANGED_SINCE_REGISTRATION';
const $1ccba15c4d511e83$var$REMOVED_SINCE_REGISTRATION = 'REMOVED_SINCE_REGISTRATION';
const $1ccba15c4d511e83$var$SINCE_REGISTRATION = new Set([
    $1ccba15c4d511e83$var$ADDED_AFTER_REGISTRATION,
    $1ccba15c4d511e83$var$CHANGED_SINCE_REGISTRATION,
    $1ccba15c4d511e83$var$REMOVED_SINCE_REGISTRATION
]);
const $1ccba15c4d511e83$export$7a9c4ec4ae364c2 = [
    'FINAL',
    'EXPIRED',
    'EMPTY_PART',
    'NOT_SENDABLE',
    'UNSUPPORTED'
];
/**
 * What one line IS, as the doctor must read it: 'sendable' (goes with «ارسال»),
 * 'registered' (at the insurer) or 'not-sent'. The registered card used to draw
 * the live lines as the pre-send list did, so a drug written AFTER the
 * registration came out as sent (K1, 2026-10-03). Now only the server's word
 * makes a line registered: ALREADY_REGISTERED, or — on the registered card — a
 * line it still calls sendable, which is one the send just carried (the preview
 * was read before it). Anything it does not call sendable did not go.
 *
 * Two more since corrections (K1, 2026-10-04): 'changed' — at the insurer in an
 * older form — and 'removed' — no longer on the نسخه, still at the insurer. A
 * line added after the registration never reached it, sendable or not.
 */ function $1ccba15c4d511e83$var$lineStanding(line, registeredView = false) {
    if (line?.reasonCode === $1ccba15c4d511e83$var$ALREADY_REGISTERED) return 'registered';
    if (line?.reasonCode === $1ccba15c4d511e83$var$CHANGED_SINCE_REGISTRATION) return 'changed';
    if (line?.reasonCode === $1ccba15c4d511e83$var$REMOVED_SINCE_REGISTRATION) return 'removed';
    if (line?.reasonCode === $1ccba15c4d511e83$var$ADDED_AFTER_REGISTRATION || !line?.sendable) return 'not-sent';
    return registeredView ? 'registered' : 'sendable';
}
// How each standing is marked: a tick for what is (or will be) at the insurer as
// it is, a cross for what is not, amber for what the insurer holds differently.
const $1ccba15c4d511e83$var$MARK = {
    registered: {
        mark: 'check',
        Icon: (0, $huNwV.default),
        color: (0, $jTCZr.CT).good
    },
    sendable: {
        mark: 'check',
        Icon: (0, $huNwV.default),
        color: (0, $jTCZr.CT).good
    },
    'not-sent': {
        mark: 'x',
        Icon: (0, $6TdpC.default),
        color: (0, $jTCZr.CT).danger
    },
    changed: {
        mark: 'changed',
        Icon: (0, $aGlWN.default),
        color: (0, $jTCZr.CT).warn
    },
    removed: {
        mark: 'removed',
        Icon: (0, $kx99t.default),
        color: (0, $jTCZr.CT).warn
    }
};
/**
 * A service line's «تاریخ انجام» and the day the prescription it goes in is valid
 * until (PM-0634). op-naji dates a whole prescription, so the BFF sends the visit's
 * orders as one prescription per validity, and a line names the one it is in. A
 * drug line has neither; a line that cannot go has no validity, only its day —
 * and its reason (DATE_NEXT_YEAR: a day in the next Jalali year).
 */ function $1ccba15c4d511e83$var$LineDates({ line: line, style: style }) {
    const tid = $1ccba15c4d511e83$var$useErxTid();
    const { t: t, formatDate: formatDate } = (0, $LNQP4.default)();
    const day = (iso)=>(0, $feEcD.isIsoDay)(iso) ? formatDate((0, $feEcD.dayInstant)(iso), 'medium') : null;
    const done = day(line?.performedDate);
    const until = day(line?.validUntil);
    if (!done && !until) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": tid('line-dates'),
        style: {
            color: (0, $jTCZr.CT).mute,
            display: 'block',
            ...style
        }
    }, [
        done && t('visit.erx.lineDate', {
            date: done
        }),
        until && t('visit.erx.lineValidUntil', {
            date: until
        })
    ].filter(Boolean).join(" \xb7 "));
}
/**
 * `correctionAware`: the server said what a correction can do (`preview.correction`),
 * so the old «cannot be changed from Parsina yet» note no longer holds — the
 * correction section speaks instead.
 */ function $1ccba15c4d511e83$var$Lines({ lines: lines, reasonText: reasonText, registered: registered = false, correctionAware: correctionAware = false }) {
    const tid = $1ccba15c4d511e83$var$useErxTid();
    const { t: t } = (0, $LNQP4.default)();
    if (!lines?.length) return null;
    const standing = lines.map((l)=>$1ccba15c4d511e83$var$lineStanding(l, registered));
    const count = (s)=>standing.filter((x)=>x === s).length;
    // A removed line is the insurer's, no longer the visit's: not one of its items.
    const total = lines.length - count('removed');
    const addedAfter = !correctionAware && lines.some((l)=>l.reasonCode === $1ccba15c4d511e83$var$ADDED_AFTER_REGISTRATION);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginBottom: '0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.65625rem',
            fontWeight: 700,
            color: (0, $jTCZr.CT).ink2,
            marginBottom: '0.25rem'
        }
    }, registered ? t('visit.erx.linesRegistered', {
        registered: count('registered'),
        total: total
    }) : t('visit.erx.linesSummary', {
        sendable: count('sendable'),
        total: total
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        style: {
            listStyle: 'none',
            margin: 0,
            padding: 0,
            display: 'grid',
            gap: '0.1875rem'
        }
    }, lines.map((l, i)=>{
        const s = standing[i];
        const goes = s === 'registered' || s === 'sendable';
        const { mark: mark, Icon: Icon, color: color } = $1ccba15c4d511e83$var$MARK[s];
        // Drug names are Latin: isolate them so a Persian line stays in order.
        const name = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("bdi", {
            dir: "auto",
            style: {
                color: s === 'removed' ? (0, $jTCZr.CT).mute : (0, $jTCZr.CT).ink,
                fontWeight: 600
            }
        }, l.name);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: `${l.name}-${i}`,
            "data-testid": tid('line'),
            "data-sendable": l.sendable ? 'true' : 'false',
            "data-standing": s,
            "data-reason": l.reasonCode || undefined,
            style: {
                display: 'flex',
                alignItems: 'flex-start',
                gap: '0.375rem',
                fontSize: '0.6875rem',
                lineHeight: 1.6
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "aria-hidden": "true",
            "data-mark": mark,
            style: {
                color: color,
                marginTop: '0.125rem',
                flexShrink: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
            size: 12
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                minWidth: 0
            }
        }, s === 'removed' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("del", null, name) : name, goes && l.erxCode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                color: (0, $jTCZr.CT).mute2,
                marginInlineStart: '0.375rem'
            }
        }, t('visit.erx.erxCoded'), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "ltr",
            style: {
                unicodeBidi: 'isolate'
            }
        }, l.erxCode)), goes && l.sentAs && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "data-testid": tid('line-sent-as'),
            style: {
                color: (0, $jTCZr.CT).mute,
                display: 'block'
            }
        }, t('visit.erx.sentAsGeneric'), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("bdi", {
            dir: "ltr"
        }, l.sentAs)), goes && l.serviceCode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                color: (0, $jTCZr.CT).mute2,
                marginInlineStart: '0.375rem'
            }
        }, t('visit.erx.serviceCoded'), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "ltr",
            style: {
                unicodeBidi: 'isolate'
            }
        }, l.serviceCode)), s !== 'removed' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$LineDates, {
            line: l
        }), s === 'registered' && !registered && l.reasonCode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                color: (0, $jTCZr.CT).mute,
                display: 'block'
            }
        }, reasonText(l)), s === 'not-sent' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                color: (0, $jTCZr.CT).mute,
                display: 'block'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "sr-only"
        }, t('visit.erx.lineNotSent'), ": "), reasonText(l)), (s === 'changed' || s === 'removed') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                color: (0, $jTCZr.CT).mute,
                display: 'block'
            }
        }, reasonText(l), l.sentSummary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "auto",
            style: {
                display: 'block'
            }
        }, t('visit.erx.correction.atInsurer', {
            summary: l.sentSummary
        })))));
    })), addedAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('added-after'),
        style: {
            marginTop: '0.375rem',
            padding: '0.375rem 0.625rem',
            borderRadius: (0, $jTCZr.RADIUS).control,
            background: (0, $jTCZr.CT).warnSoft,
            borderInlineStart: `2px solid ${(0, $jTCZr.CT).warn}`,
            fontSize: '0.65625rem',
            color: (0, $jTCZr.CT).ink2,
            lineHeight: 1.75
        }
    }, t('visit.erx.addedAfterRegistration')));
}
// ── what a correction would carry ───────────────────────────────────────────
// The registered part's changes, grouped the way a doctor checks them before
// resending: اضافه, تغییر (what the insurer holds → what the نسخه says now), حذف.
// `describeLine` is the visit's: it knows the line as it is now. Without it (the
// closure dialog) a change says only what the insurer holds.
const $1ccba15c4d511e83$var$DIFF_GROUPS = [
    [
        'added',
        $1ccba15c4d511e83$var$ADDED_AFTER_REGISTRATION
    ],
    [
        'changed',
        $1ccba15c4d511e83$var$CHANGED_SINCE_REGISTRATION
    ],
    [
        'removed',
        $1ccba15c4d511e83$var$REMOVED_SINCE_REGISTRATION
    ]
];
function $1ccba15c4d511e83$var$CorrectionDiff({ lines: lines, parts: parts, describeLine: describeLine }) {
    const tid = $1ccba15c4d511e83$var$useErxTid();
    const { t: t, isRTL: isRTL } = (0, $LNQP4.default)();
    const inParts = (l)=>!l.part || !parts?.length || parts.includes(l.part);
    const groups = $1ccba15c4d511e83$var$DIFF_GROUPS.map(([key, code])=>[
            key,
            (lines || []).filter((l)=>l.reasonCode === code && inParts(l))
        ]).filter(([, list])=>list.length > 0);
    if (!groups.length) return null;
    const Becomes = isRTL ? (0, $42KYO.default) : (0, $d8YVq.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('correction-diff'),
        style: {
            display: 'grid',
            gap: '0.375rem',
            marginBottom: '0.5rem'
        }
    }, groups.map(([key, list])=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: key,
            "data-testid": tid(`correction-${key}`),
            "data-count": list.length
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.625rem',
                fontWeight: 700,
                color: (0, $jTCZr.CT).ink2
            }
        }, t(`visit.erx.correction.${key}`)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
            style: {
                listStyle: 'none',
                margin: 0,
                padding: 0,
                display: 'grid',
                gap: '0.125rem'
            }
        }, list.map((l, i)=>{
            let now = null;
            if (key === 'changed' && describeLine && l.medicationId) try {
                now = describeLine(l) || null;
            } catch  {
                now = null;
            }
            const name = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("bdi", {
                dir: "auto",
                style: {
                    fontWeight: 600,
                    color: key === 'removed' ? (0, $jTCZr.CT).mute : (0, $jTCZr.CT).ink
                }
            }, l.name);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
                key: `${l.name}-${i}`,
                "data-testid": tid('correction-line'),
                "data-kind": key,
                style: {
                    fontSize: '0.6875rem',
                    lineHeight: 1.6,
                    color: (0, $jTCZr.CT).ink2
                }
            }, key === 'removed' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("del", null, name) : name, key !== 'added' && (l.sentSummary || now) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    gap: '0.25rem',
                    color: (0, $jTCZr.CT).mute
                }
            }, l.sentSummary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                dir: "auto"
            }, t('visit.erx.correction.atInsurer', {
                summary: l.sentSummary
            })), l.sentSummary && now && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Becomes, {
                size: 11,
                "aria-hidden": "true",
                style: {
                    flexShrink: 0
                }
            }), now && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                dir: "auto",
                style: {
                    color: (0, $jTCZr.CT).ink2
                }
            }, t('visit.erx.correction.now', {
                summary: now
            }))));
        })))));
}
// A send or a correction the insurer did not take: the insurer's words, verbatim,
// with the fields it named — or ours, when it said nothing.
function $1ccba15c4d511e83$var$SubmissionProblem({ result: result, msgText: msgText }) {
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "error",
        role: "alert",
        style: {
            alignItems: 'flex-start'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("bdi", null, msgText(result.messageCode, result.message) || (result.state === 'NOT_ACCEPTED' ? t('visit.erx.notAccepted', {
        status: result.gatewayStatus || "\u2014"
    }) : result.state === 'FAILED' ? t('visit.erx.failed') : t('visit.erx.rejected'))))), result.fieldErrors?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: '0.375rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.65625rem',
            fontWeight: 700,
            color: (0, $jTCZr.CT).ink2
        }
    }, t('visit.erx.fieldErrors')), result.fieldErrors.map((f, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            dir: "ltr",
            style: {
                fontSize: '0.625rem',
                color: (0, $jTCZr.CT).mute,
                unicodeBidi: 'isolate',
                lineHeight: 1.7
            }
        }, f.field, ": ", f.message))));
}
// ── when a service should be done ───────────────────────────────────────────
// No longer asked here (PM-0634): the day is each order's own «تاریخ انجام», set
// in the دستورات, and the BFF sends one prescription per validity those days give.
// Each service line says its day and the day it is valid until (LineDates).
// What must be fixed elsewhere before anything can go — each with where.
function $1ccba15c4d511e83$var$Blockers({ blockers: blockers, blockerText: blockerText }) {
    const tid = $1ccba15c4d511e83$var$useErxTid();
    const { t: t } = (0, $LNQP4.default)();
    const shown = (blockers || []).filter((b)=>!$1ccba15c4d511e83$var$HANDLED_IN_CARD.has(b.code));
    if (!shown.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('blockers'),
        style: {
            marginBottom: '0.625rem',
            padding: '0.5rem 0.625rem',
            borderRadius: (0, $jTCZr.RADIUS).control,
            background: (0, $jTCZr.CT).warnSoft,
            borderInlineStart: `2px solid ${(0, $jTCZr.CT).warn}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.65625rem',
            fontWeight: 700,
            color: (0, $jTCZr.CT).ink2,
            marginBottom: '0.25rem'
        }
    }, t('visit.erx.blockedTitle')), shown.map((b)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: b.code,
            "data-code": b.code,
            style: {
                fontSize: '0.65625rem',
                color: (0, $jTCZr.CT).ink2,
                lineHeight: 1.75
            }
        }, "\u2022 ", blockerText(b), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                color: (0, $jTCZr.CT).mute
            }
        }, "(", t(`visit.erx.fixIn.${b.fixIn}`), ")"))));
}
// ── تأمین's login tab ───────────────────────────────────────────────────────
// تأمین's login is a page of its own, and reaching it took three presses —
// «ارسال نسخه», «ورود به تأمین», «باز کردن صفحهٔ ورود» (K1, 2026-10-05). The tab
// is now opened IN the press that decides, while the browser still counts it as
// the doctor's own action: one opened after the login call has answered is a
// popup most browsers block. It shows «در حال اتصال…» until the call returns
// تأمین's address, and is pointed there; the return page (erxReturn.js) then
// carries the send on by itself. `noopener` cannot be passed — it hides the tab
// from us — so the link back is cut by hand before تأمین's page loads in it.
// null when the browser refused: the card's own «باز کردن» button stays.
function $1ccba15c4d511e83$var$openLoginTab(text) {
    let tab = null;
    try {
        tab = window.open('', '_blank');
    } catch  {
        return null;
    }
    if (!tab) return null;
    try {
        tab.opener = null;
    } catch  {}
    try {
        const doc = tab.document;
        doc.title = text;
        doc.documentElement.dir = document.documentElement.dir || 'rtl';
        doc.body.style.cssText = "margin:0;min-height:100vh;display:grid;place-items:center;font:14px system-ui,sans-serif;color:#475569;background:#f8fafc";
        doc.body.textContent = text;
    } catch  {}
    return tab;
}
// ── the insurer login ───────────────────────────────────────────────────────
// The doctor's own username and password AT THE INSURER, and — when their profile
// lacks them — the national code and mobile the insurer identifies them by. The
// password is cleared as soon as it is submitted.
function $1ccba15c4d511e83$var$LoginForm({ insurerName: insurerName, needs: needs, onSubmit: onSubmit, busy: busy, error: error, note: note, redirect: redirect = false }) {
    const tid = $1ccba15c4d511e83$var$useErxTid();
    // `redirect` = تأمین: the doctor logs in on تأمین's own page, so there is no
    // username or password here — only the national code and mobile when missing.
    const { t: t } = (0, $LNQP4.default)();
    const needsNid = needs.includes('DOCTOR_NATIONAL_CODE_MISSING');
    const needsMobile = needs.includes('DOCTOR_MOBILE_MISSING');
    const [username, setUsername] = (0, $acw62.useState)('');
    const [password, setPassword] = (0, $acw62.useState)('');
    const [nid, setNid] = (0, $acw62.useState)('');
    const [mobile, setMobile] = (0, $acw62.useState)('');
    const ready = (redirect || username.trim() && password) && (!needsNid || $1ccba15c4d511e83$var$isValidNationalCode(nid)) && (!needsMobile || mobile !== '');
    const submit = ()=>{
        if (!ready || busy) return;
        const payload = {
            ...redirect ? {} : {
                username: (0, $5JYPc.toEnDigits)(username.trim()),
                password: password
            },
            nationalCode: needsNid ? nid : undefined,
            mobile: needsMobile ? (0, $5AX1S).toNational(mobile) : undefined
        };
        setPassword('');
        onSubmit(payload);
    };
    const onEnter = (e)=>{
        if (e.key === 'Enter') submit();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('login')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.71875rem',
            fontWeight: 700,
            color: (0, $jTCZr.CT).ink,
            marginBottom: '0.1875rem'
        }
    }, t('visit.erx.login.title', {
        insurer: insurerName
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, null, note || t('visit.erx.login.hint')), redirect && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, {
        tone: "ink"
    }, t('visit.erx.login.redirectHint')), (needsNid || needsMobile) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, {
        tone: "ink"
    }, t('visit.erx.login.needsDetails')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'grid',
            gap: '0.5rem',
            marginTop: '0.5625rem',
            gridTemplateColumns: 'repeat(auto-fit, minmax(11rem, 1fr))'
        }
    }, needsNid && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $Ydgp5.default), {
        label: t('common.labels.nationalId'),
        value: nid,
        onChange: (e)=>setNid(e.target.value),
        onKeyDown: onEnter,
        disabled: busy,
        "data-testid": tid('nid')
    }), needsMobile && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lffTJ.default), {
        label: t('auth.login.phoneLabel'),
        value: mobile,
        onChange: setMobile,
        countries: [
            'IR'
        ],
        onKeyDown: onEnter,
        disabled: busy,
        "data-testid": tid('mobile')
    }), !redirect && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        label: t('visit.erx.login.username'),
        helperText: t('visit.erx.login.usernameHint')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
        id: "erx-username",
        value: username,
        onChange: (e)=>setUsername(e.target.value),
        onKeyDown: onEnter,
        disabled: busy,
        autoComplete: "username",
        dir: "ltr",
        "data-testid": tid('username')
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        label: t('visit.erx.login.password')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
        id: "erx-password",
        type: "password",
        value: password,
        onChange: (e)=>setPassword(e.target.value),
        onKeyDown: onEnter,
        disabled: busy,
        autoComplete: "current-password",
        dir: "ltr",
        "data-testid": tid('password')
    })))), !redirect && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.375rem',
            marginTop: '0.375rem',
            fontSize: '0.625rem',
            color: (0, $jTCZr.CT).mute2
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6lig1.default), {
        size: 11,
        "aria-hidden": "true"
    }), " ", t('visit.erx.login.passwordNote')), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "alert",
        dir: "auto",
        style: {
            fontSize: '0.65625rem',
            color: (0, $jTCZr.CT).danger,
            marginTop: '0.375rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("bdi", null, error)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "default",
        size: "sm",
        onClick: submit,
        disabled: !ready || busy,
        className: "gap-1.5 mt-2.5",
        "data-testid": tid('login-submit')
    }, busy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 13,
        color: "currentColor",
        label: ""
    }), redirect ? t('visit.erx.login.submitRedirect', {
        insurer: insurerName
    }) : t('visit.erx.login.submit')));
}
// ── تأمین's SIAM id ─────────────────────────────────────────────────────────
// Asked only when تأمین is the insurer and none is recorded for this doctor at
// this clinic. Saved on their membership here, so it is asked once per clinic;
// the clinic can also record it from its «پرسنل» screen.
function $1ccba15c4d511e83$var$SiamForm({ onSave: onSave, busy: busy, error: error }) {
    const tid = $1ccba15c4d511e83$var$useErxTid();
    const { t: t } = (0, $LNQP4.default)();
    const [value, setValue] = (0, $acw62.useState)('');
    const clean = (0, $5JYPc.toEnDigits)(value).trim();
    const submit = ()=>{
        if (clean && !busy) onSave(clean);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('siam'),
        style: {
            marginBottom: '0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'flex-end',
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        label: t('visit.erx.siam.label'),
        helperText: t('visit.erx.siam.hint'),
        error: error,
        style: {
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
        id: "erx-siam",
        value: value,
        onChange: (e)=>setValue(e.target.value),
        onKeyDown: (e)=>{
            if (e.key === 'Enter') submit();
        },
        disabled: busy,
        dir: "ltr",
        autoComplete: "off",
        spellCheck: false,
        maxLength: 64,
        "data-testid": tid('siam-input')
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "default",
        onClick: submit,
        disabled: !clean || busy,
        className: "gap-1.5",
        "data-testid": tid('siam-save')
    }, busy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 13,
        color: "currentColor",
        label: ""
    }), t('visit.erx.siam.save'))));
}
// ── the insurer's challenge: an SMS code, or a captcha ──────────────────────
// One field: a code is usually pasted or typed in one go. Persian digits are
// normalised on the way in. The length is the insurer's, not ours, so the button
// waits for a plausible code rather than an exact count.
function $1ccba15c4d511e83$var$ChallengeField({ kind: kind, captchaImage: captchaImage, sentTo: sentTo, onSubmit: onSubmit, busy: busy, error: error }) {
    const tid = $1ccba15c4d511e83$var$useErxTid();
    const { t: t } = (0, $LNQP4.default)();
    const [value, setValue] = (0, $acw62.useState)('');
    const inputRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        inputRef.current?.focus();
    }, [
        kind
    ]);
    const isOtp = kind === 'otp';
    const clean = isOtp ? (0, $5JYPc.toEnDigits)(value).replace(/\D/g, '').slice(0, $1ccba15c4d511e83$var$OTP_MAX) : (0, $5JYPc.toEnDigits)(value).trim();
    const complete = isOtp ? clean.length >= $1ccba15c4d511e83$var$OTP_MIN : clean.length > 0;
    const submit = ()=>{
        if (!complete || busy) return;
        onSubmit(isOtp ? {
            otp: clean
        } : {
            captcha: clean
        });
        setValue('');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, !isOtp && captchaImage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: captchaImage,
        alt: t('visit.erx.captcha.imageAlt'),
        style: {
            display: 'block',
            maxHeight: '3rem',
            borderRadius: (0, $jTCZr.RADIUS).control,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            marginBottom: '0.5rem'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'flex-end',
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        label: isOtp ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, t('visit.erx.otp.label'), sentTo && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                color: (0, $jTCZr.CT).mute
            }
        }, ' ', t('visit.erx.otp.sentTo'), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "ltr",
            style: {
                unicodeBidi: 'isolate',
                display: 'inline-block'
            }
        }, sentTo))) : t('visit.erx.captcha.label'),
        error: error,
        style: {
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
        ref: inputRef,
        id: isOtp ? 'erx-otp' : 'erx-captcha',
        value: isOtp ? clean : value,
        onChange: (e)=>setValue(e.target.value),
        onKeyDown: (e)=>{
            if (e.key === 'Enter') submit();
        },
        disabled: busy,
        inputMode: isOtp ? 'numeric' : 'text',
        autoComplete: isOtp ? 'one-time-code' : 'off',
        "aria-invalid": !!error,
        dir: "ltr",
        "data-testid": isOtp ? tid('otp') : tid('captcha'),
        inputStyle: isOtp ? {
            textAlign: 'center',
            letterSpacing: '.3em',
            fontWeight: 700
        } : undefined
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "default",
        onClick: submit,
        disabled: !complete || busy,
        className: "gap-1.5",
        "data-testid": isOtp ? tid('otp-submit') : tid('captcha-submit')
    }, busy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 13,
        color: "currentColor",
        label: ""
    }), isOtp ? t('visit.erx.otp.submit') : t('visit.erx.captcha.submit'))));
}
// ── card ────────────────────────────────────────────────────────────────────
// کد ملی بیمار. The record's, pre-filled; the doctor may send another one for
// THIS prescription (K1, 2026-10-03) — a wrong or missing code on file used to
// block the send until someone fixed the record screen. Writing it back to the
// record is a separate, explicit box, offered only for a valid code that differs.
// The rule is the kit's (PM-0076), and Iran's: this is an Iranian insurer's
// prescription, so the code it carries is an Iranian کد ملی.
const $1ccba15c4d511e83$var$isValidNationalCode = (code)=>(0, $3tGMU).isValidNationalId(code, 'IR');
function $1ccba15c4d511e83$var$NidSavedNote({ saved: saved }) {
    const { t: t } = (0, $LNQP4.default)();
    const tid = $1ccba15c4d511e83$var$useErxTid();
    if (saved == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('patient-nid-saved'),
        "data-saved": saved ? 'true' : 'false'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, {
        tone: saved ? 'good' : 'bad'
    }, saved ? t('visit.erx.patientNid.saved') : t('visit.erx.patientNid.notSaved')));
}
// ── the patient's gender and mobile (K1, 2026-10-06) ────────────────────────
// The insurer refuses a prescription without either — «جنسیت الزامی است» came
// back after the doctor had logged in and pressed send — and most records have
// no gender. Asked only for what the record lacks (and kept on screen once
// given); what the doctor gives goes with the prescription and is written into
// the patient's record by the send, with nothing to tick: the next visit is not
// asked again. Parsina keeps two genders.
function $1ccba15c4d511e83$var$PatientDetailsField({ askGender: askGender, askMobile: askMobile, value: value, onGender: onGender, onMobile: onMobile, disabled: disabled }) {
    const { t: t } = (0, $LNQP4.default)();
    const tid = $1ccba15c4d511e83$var$useErxTid();
    if (!askGender && !askMobile) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('patient-details'),
        style: {
            marginBottom: '0.625rem',
            maxWidth: '22rem'
        }
    }, askGender && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('patient-gender'),
        "data-value": value.gender || undefined,
        style: {
            marginBottom: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.71875rem',
            fontWeight: 700,
            color: (0, $jTCZr.CT).ink,
            marginBottom: '0.25rem'
        }
    }, t('visit.erx.patientDetails.gender')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$ErxSegmented, {
        semantics: "filter",
        ariaLabel: t('visit.erx.patientDetails.gender'),
        size: "sm",
        value: value.gender || '',
        onChange: onGender,
        options: [
            'male',
            'female'
        ].map((g)=>({
                value: g,
                label: t(`common.gender.${g}`),
                disabled: disabled
            }))
    })), askMobile && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginBottom: '0.375rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lffTJ.default), {
        label: t('visit.erx.patientDetails.mobile'),
        value: value.mobile,
        onChange: onMobile,
        countries: [
            'IR'
        ],
        disabled: disabled,
        "data-testid": tid('patient-mobile')
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, null, t('visit.erx.patientDetails.hint')));
}
function $1ccba15c4d511e83$var$DetailsSavedNote({ saved: saved }) {
    const { t: t } = (0, $LNQP4.default)();
    const tid = $1ccba15c4d511e83$var$useErxTid();
    if (saved == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('patient-details-saved'),
        "data-saved": saved ? 'true' : 'false'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, {
        tone: saved ? 'good' : 'bad'
    }, saved ? t('visit.erx.patientDetails.saved') : t('visit.erx.patientDetails.notSaved')));
}
// ── the insurer (PM-0101) ───────────────────────────────────────────────────
// The card opens on the patient's own basic insurer — the server reads it from
// their policy, else the record's «بیمه» field — and says so. The doctor may
// send to another: that holds for this prescription alone, and the card says
// that too. A patient whose record names NONE gets the insurer picked here, and
// — the box under it, ticked from the start — written to their record, so the
// next visit does not ask again. A record that already names one is never
// changed from a prescription.
function $1ccba15c4d511e83$var$InsurerSavedNote({ saved: saved }) {
    const { t: t } = (0, $LNQP4.default)();
    const tid = $1ccba15c4d511e83$var$useErxTid();
    if (saved == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('insurer-saved'),
        "data-saved": saved ? 'true' : 'false'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, {
        tone: saved ? 'good' : 'bad'
    }, saved ? t('visit.erx.patientInsurer.saved') : t('visit.erx.patientInsurer.notSaved')));
}
function $1ccba15c4d511e83$var$InsurerField({ insurer: insurer, record: record, offered: offered, insurerName: insurerName, onPick: onPick, save: save, onSaveChange: onSaveChange, disabled: disabled }) {
    const { t: t } = (0, $LNQP4.default)();
    const tid = $1ccba15c4d511e83$var$useErxTid();
    const recordOffered = !!record && offered.includes(record);
    // Where the selection stands against the record.
    const source = !record ? 'none' : !recordOffered ? 'unsupported' : !insurer ? 'unpicked' : insurer === record ? 'record' : 'differs';
    const note = source === 'none' ? insurer ? t('visit.erx.patientInsurer.noRecord') : t('visit.erx.patientHasNoInsurer') : source === 'unsupported' ? t('visit.erx.patientInsurer.unsupported', {
        insurer: insurerName(record)
    }) : source === 'record' ? t('visit.erx.patientInsurer.fromRecord') : source === 'differs' ? t('visit.erx.patientInsurer.differs', {
        insurer: insurerName(record)
    }) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('insurer-field'),
        "data-source": source,
        style: {
            marginBottom: '0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.6875rem',
            fontWeight: 700,
            color: (0, $jTCZr.CT).ink2,
            marginBottom: '0.3125rem'
        }
    }, t('visit.erx.patientInsurer.label')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('insurer')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$ErxSegmented, {
        semantics: "filter",
        ariaLabel: t('visit.erx.insurerLabel'),
        size: "sm",
        value: insurer || '',
        onChange: onPick,
        options: offered.map((v)=>({
                value: v,
                label: insurerName(v),
                disabled: disabled
            }))
    })), note && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('insurer-note'),
        style: {
            marginTop: '0.3125rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, {
        tone: source === 'record' ? 'mute' : 'ink'
    }, note)), source === 'none' && !!insurer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9gEOi.default), {
        checked: save,
        onChange: (v)=>onSaveChange(!!v),
        disabled: disabled,
        label: t('visit.erx.patientNid.save'),
        labelClassName: "text-[0.6875rem]",
        style: {
            marginTop: '0.375rem'
        },
        "data-testid": tid('insurer-save')
    }));
}
function $1ccba15c4d511e83$var$PatientNidField({ value: value, onChange: onChange, record: record, save: save, onSaveChange: onSaveChange, disabled: disabled }) {
    const { t: t } = (0, $LNQP4.default)();
    const tid = $1ccba15c4d511e83$var$useErxTid();
    const valid = $1ccba15c4d511e83$var$isValidNationalCode(value);
    const differs = !!value && value !== (record || '');
    const hint = differs ? t('visit.erx.patientNid.differs') : !record ? t('visit.erx.patientNid.noRecord') : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('patient-nid'),
        "data-differs": differs || undefined,
        style: {
            marginBottom: '0.625rem',
            maxWidth: '22rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $Ydgp5.default), {
        label: t('visit.erx.patientNid.label'),
        value: value,
        onChange: (e)=>onChange(e.target.value),
        helperText: hint,
        disabled: disabled,
        "data-testid": tid('patient-nid-input')
    }), differs && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9gEOi.default), {
        checked: save && valid,
        onChange: (v)=>onSaveChange(!!v),
        disabled: !valid || disabled,
        label: t('visit.erx.patientNid.save'),
        labelClassName: "text-[0.6875rem]",
        style: {
            marginTop: '0.375rem'
        },
        "data-testid": tid('patient-nid-save')
    }));
}
const $1ccba15c4d511e83$export$d0b86cebda39e386 = (l)=>l?.medicationId ? `m:${l.medicationId}` : l?.orderId ? `o:${l.orderId}` : null;
const $1ccba15c4d511e83$var$linePart = (l)=>l?.part || (l?.orderId ? 'SERVICES' : 'DRUGS');
const $1ccba15c4d511e83$var$PANEL_GROUPS = [
    [
        'DRUGS',
        'visit.erx.panel.drugs'
    ],
    [
        'SERVICES',
        'visit.erx.panel.orders'
    ]
];
// What the panel answers itself: the card's own fields, the patient's national
// code (asked above the preview) and the insurer (asked in the login window).
// Anything else stops the automatic login — there is something to fix first,
// and the login can wait for «ثبت نسخه در …».
const $1ccba15c4d511e83$var$PANEL_FIXES = new Set([
    ...$1ccba15c4d511e83$var$HANDLED_IN_CARD,
    'PATIENT_NATIONAL_CODE_MISSING',
    'PATIENT_NATIONAL_CODE_INVALID',
    'PATIENT_INSURER_UNKNOWN'
]);
// A line the panel's send carries: one that can go and is still ticked.
const $1ccba15c4d511e83$var$panelGoes = (l, unticked)=>$1ccba15c4d511e83$var$lineStanding(l) === 'sendable' && (!$1ccba15c4d511e83$export$d0b86cebda39e386(l) || !unticked.has($1ccba15c4d511e83$export$d0b86cebda39e386(l)));
// «وارد هستید تا …»: the hour, and within the hour the minutes left (a تأمین
// login lasts 15); «فردا» for one that outlives today. Days are compared as the
// kit's formatter writes them, so both are read in the one zone it pins.
function $1ccba15c4d511e83$var$sessionUntil(t, formatDate, formatTime, expiresAt, now = new Date()) {
    const end = expiresAt ? new Date(expiresAt) : null;
    if (!end || Number.isNaN(end.getTime())) return t('visit.erx.panel.signedIn');
    const time = formatTime(end);
    const minutes = Math.round((end.getTime() - now.getTime()) / 60000);
    if (minutes >= 0 && minutes < 60) return t('visit.erx.panel.untilSoon', {
        time: time,
        minutes: minutes
    });
    const day = (d)=>formatDate(d, 'medium');
    if (day(end) === day(now)) return t('visit.erx.panel.until', {
        time: time
    });
    if (day(end) === day(new Date(now.getTime() + 86400000))) return t('visit.erx.panel.untilTomorrow', {
        time: time
    });
    return t('visit.erx.panel.signedIn');
}
// «اطلاعات بیمه»: the insurer the prescription goes to and how long the login
// lasts — or, before one, how to log in (`children`).
function $1ccba15c4d511e83$var$InsuranceInfo({ name: name, session: session, onLogout: onLogout, locked: locked, children: children }) {
    const { t: t, formatDate: formatDate, formatTime: formatTime } = (0, $LNQP4.default)();
    const tid = $1ccba15c4d511e83$var$useErxTid();
    const active = session?.state === 'ACTIVE';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
        "data-testid": tid('insurance'),
        "data-session": session?.state || 'NONE',
        "aria-label": t('visit.erx.panel.infoTitle'),
        style: {
            background: (0, $jTCZr.CT).surface,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: (0, $jTCZr.RADIUS).card,
            padding: '0.75rem 0.875rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.375rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).mute
        }
    }, t('visit.erx.panel.infoTitle')), active && onLogout && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onLogout,
        disabled: locked,
        "data-testid": tid('logout'),
        style: {
            background: 'none',
            border: 0,
            padding: 0,
            cursor: 'pointer',
            color: (0, $jTCZr.CT).mute,
            fontSize: '0.6875rem',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.25rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0hzSL.default), {
        size: 11,
        "aria-hidden": "true"
    }), " ", t('visit.erx.logout'))), name ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('insurance-name'),
        style: {
            fontSize: '0.9375rem',
            fontWeight: 700,
            color: (0, $jTCZr.CT).ink
        }
    }, name) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.8125rem',
            color: (0, $jTCZr.CT).ink2
        }
    }, t('visit.erx.panel.noInsurer')), active && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('insurance-until'),
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.375rem',
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).good
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kMJsW.default), {
        size: 14,
        "aria-hidden": "true"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, $1ccba15c4d511e83$var$sessionUntil(t, formatDate, formatTime, session?.expiresAt))), children);
}
// One line of the preview: its checkbox, its name, the visit's words for it (a
// drug's dose, an order's kind) and — when it cannot go — why. Only a line that
// can go can be ticked.
function $1ccba15c4d511e83$var$PreviewLine({ line: l, on: on, onToggle: onToggle, reasonText: reasonText, describeLine: describeLine, disabled: disabled }) {
    const tid = $1ccba15c4d511e83$var$useErxTid();
    const { t: t } = (0, $LNQP4.default)();
    const s = $1ccba15c4d511e83$var$lineStanding(l);
    const goes = s === 'sendable';
    const key = $1ccba15c4d511e83$export$d0b86cebda39e386(l);
    let sub = null;
    if (describeLine) try {
        sub = describeLine(l) || null;
    } catch  {
        sub = null;
    }
    const label = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.125rem',
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("bdi", {
        dir: "auto",
        style: {
            fontSize: '0.84375rem',
            fontWeight: 600,
            color: goes ? (0, $jTCZr.CT).ink : (0, $jTCZr.CT).mute
        }
    }, s === 'removed' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("del", null, l.name) : l.name), sub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).mute
        }
    }, sub), s !== 'removed' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$LineDates, {
        line: l,
        style: {
            fontSize: '0.75rem'
        }
    }), goes && l.sentAs && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": tid('line-sent-as'),
        style: {
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).mute
        }
    }, t('visit.erx.sentAsGeneric'), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("bdi", {
        dir: "ltr"
    }, l.sentAs)), !goes && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.75rem',
            color: s === 'registered' ? (0, $jTCZr.CT).mute : (0, $jTCZr.CT).warnInk
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "sr-only"
    }, t('visit.erx.lineNotSent'), ": "), reasonText(l)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        "data-testid": tid('line'),
        "data-standing": s,
        "data-sendable": l.sendable ? 'true' : 'false',
        "data-reason": l.reasonCode || undefined,
        "data-selected": goes && on ? 'true' : 'false',
        style: {
            borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
            background: goes || s === 'registered' ? undefined : (0, $jTCZr.CT).warnSoft
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9gEOi.default), {
        checked: goes && on,
        onChange: ()=>onToggle(key),
        disabled: disabled || !goes || !key,
        label: label,
        className: "items-start",
        style: {
            padding: '0.625rem 0.875rem',
            minHeight: 52
        },
        "data-testid": tid('line-check')
    }));
}
// The preview: the نسخه's drugs and the دستورات, each a group whose own checkbox
// ticks or clears every line of it that can go — «some» is a dash.
function $1ccba15c4d511e83$var$SelectableLines({ lines: lines, unticked: unticked, onToggle: onToggle, onToggleGroup: onToggleGroup, reasonText: reasonText, describeLine: describeLine, disabled: disabled }) {
    const tid = $1ccba15c4d511e83$var$useErxTid();
    const { t: t } = (0, $LNQP4.default)();
    if (!lines?.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('preview'),
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.8125rem',
            fontWeight: 600,
            color: (0, $jTCZr.CT).ink2
        }
    }, t('visit.erx.panel.previewTitle')), $1ccba15c4d511e83$var$PANEL_GROUPS.map(([part, label])=>{
        const group = lines.filter((l)=>$1ccba15c4d511e83$var$linePart(l) === part);
        if (!group.length) return null;
        const canGo = group.filter((l)=>$1ccba15c4d511e83$var$lineStanding(l) === 'sendable');
        const choosable = canGo.filter((l)=>$1ccba15c4d511e83$export$d0b86cebda39e386(l));
        const going = canGo.filter((l)=>$1ccba15c4d511e83$var$panelGoes(l, unticked)).length;
        const ticked = choosable.filter((l)=>!unticked.has($1ccba15c4d511e83$export$d0b86cebda39e386(l))).length;
        const all = choosable.length > 0 && ticked === choosable.length;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
            key: part,
            "data-testid": tid(`group-${part}`),
            "data-selected": going,
            "data-total": canGo.length,
            "aria-label": t(label),
            style: {
                background: (0, $jTCZr.CT).surface,
                border: `1px solid ${(0, $jTCZr.C).border}`,
                borderRadius: (0, $jTCZr.RADIUS).card,
                overflow: 'hidden'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.625rem',
                minHeight: 48,
                padding: '0 0.875rem',
                background: (0, $jTCZr.CT).surface2,
                borderBottom: `1px solid ${(0, $jTCZr.C).border}`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9gEOi.default), {
            checked: all ? true : ticked > 0 ? 'indeterminate' : false,
            onChange: ()=>onToggleGroup(choosable.map($1ccba15c4d511e83$export$d0b86cebda39e386), !all),
            disabled: disabled || choosable.length === 0,
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    fontSize: '0.875rem',
                    fontWeight: 700,
                    color: (0, $jTCZr.CT).ink
                }
            }, t(label)),
            style: {
                flex: 1,
                minHeight: 44
            },
            "data-testid": tid(`group-${part}-toggle`)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.75rem',
                color: (0, $jTCZr.CT).mute
            }
        }, t('visit.erx.panel.groupCount', {
            selected: going,
            total: canGo.length
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
            style: {
                listStyle: 'none',
                margin: 0,
                padding: 0
            }
        }, group.map((l, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$PreviewLine, {
                key: $1ccba15c4d511e83$export$d0b86cebda39e386(l) || `${l.name}-${i}`,
                line: l,
                on: $1ccba15c4d511e83$var$panelGoes(l, unticked),
                onToggle: onToggle,
                reasonText: reasonText,
                describeLine: describeLine,
                disabled: disabled
            }))));
    }));
}
// The send's answer, line by line: registered, left unticked, or not sent and
// why. A line the doctor unticked reads so for as long as the panel knows it —
// after a fresh read the server can only say it is not in the registration.
function $1ccba15c4d511e83$var$resultStanding(l, unticked) {
    const s = $1ccba15c4d511e83$var$lineStanding(l, true);
    const left = unticked?.has($1ccba15c4d511e83$export$d0b86cebda39e386(l));
    if (left && (s === 'registered' ? l.reasonCode !== $1ccba15c4d511e83$var$ALREADY_REGISTERED : l.reasonCode === $1ccba15c4d511e83$var$ADDED_AFTER_REGISTRATION)) return 'not-selected';
    return s;
}
const $1ccba15c4d511e83$var$RESULT_TONE = {
    registered: [
        (0, $jTCZr.CT).goodSoft,
        (0, $jTCZr.CT).goodInk
    ],
    'not-selected': [
        (0, $jTCZr.CT).surface2,
        (0, $jTCZr.CT).ink2
    ],
    'not-sent': [
        (0, $jTCZr.CT).warnSoft,
        (0, $jTCZr.CT).warnInk
    ],
    changed: [
        (0, $jTCZr.CT).warnSoft,
        (0, $jTCZr.CT).warnInk
    ],
    removed: [
        (0, $jTCZr.CT).warnSoft,
        (0, $jTCZr.CT).warnInk
    ]
};
function $1ccba15c4d511e83$var$PanelResult({ lines: lines, unticked: unticked, reasonText: reasonText, name: name, trackingCode: trackingCode, fallback: fallback, notes: notes }) {
    const tid = $1ccba15c4d511e83$var$useErxTid();
    const { t: t } = (0, $LNQP4.default)();
    const rows = (lines || []).map((l)=>[
            l,
            $1ccba15c4d511e83$var$resultStanding(l, unticked)
        ]);
    // A removed line is the insurer's, no longer the visit's: not one of its items.
    const counted = rows.filter(([, s])=>s !== 'removed');
    const registered = counted.filter(([, s])=>s === 'registered').length;
    const notSent = counted.length - registered;
    const all = notSent === 0;
    const chip = (l, s)=>s === 'registered' ? t('visit.erx.panel.lineRegistered') : s === 'not-selected' ? t('visit.erx.panel.lineNotSelected') : s === 'not-sent' ? t('visit.erx.panel.lineNotSent', {
            reason: reasonText(l) || ''
        }) : reasonText(l);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('result-head'),
        "data-all": all ? 'true' : 'false',
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.25rem',
            padding: '0.75rem 0.875rem',
            borderRadius: (0, $jTCZr.RADIUS).card,
            background: all ? (0, $jTCZr.CT).goodSoft : (0, $jTCZr.CT).warnSoft,
            border: `1px solid ${all ? (0, $jTCZr.CT).good : (0, $jTCZr.CT).warn}`,
            color: all ? (0, $jTCZr.CT).goodInk : (0, $jTCZr.CT).warnInk
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.9375rem',
            fontWeight: 700
        }
    }, !counted.length ? fallback : all ? t('visit.erx.panel.resultAll', {
        count: registered
    }) : t('visit.erx.panel.resultSome', {
        registered: registered,
        notSent: notSent
    })), trackingCode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.75rem'
        }
    }, t('visit.erx.panel.trackingCode', {
        insurer: name
    }), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("b", {
        dir: "ltr",
        "data-testid": tid('tracking'),
        style: {
            unicodeBidi: 'isolate',
            display: 'inline-block',
            userSelect: 'all'
        }
    }, trackingCode)), notes), rows.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        "data-testid": tid('result-lines'),
        style: {
            listStyle: 'none',
            margin: 0,
            padding: 0,
            background: (0, $jTCZr.CT).surface,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: (0, $jTCZr.RADIUS).card,
            overflow: 'hidden'
        }
    }, rows.map(([l, s], i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: $1ccba15c4d511e83$export$d0b86cebda39e386(l) ? `${$1ccba15c4d511e83$export$d0b86cebda39e386(l)}-${s}` : `${l.name}-${i}`,
            "data-testid": tid('line'),
            "data-standing": s,
            "data-reason": l.reasonCode || undefined,
            style: {
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'space-between',
                gap: '0.625rem',
                minHeight: 48,
                padding: '0.625rem 0.875rem',
                borderBottom: `1px solid ${(0, $jTCZr.C).border}`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("bdi", {
            dir: "auto",
            style: {
                fontSize: '0.84375rem',
                fontWeight: 600,
                color: s === 'removed' ? (0, $jTCZr.CT).mute : (0, $jTCZr.CT).ink,
                minWidth: 0
            }
        }, s === 'removed' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("del", null, l.name) : l.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "data-testid": tid('line-result'),
            style: {
                flexShrink: 0,
                maxWidth: '55%',
                fontSize: '0.75rem',
                fontWeight: 600,
                lineHeight: 1.6,
                padding: '0.25rem 0.625rem',
                borderRadius: 999,
                background: $1ccba15c4d511e83$var$RESULT_TONE[s][0],
                color: $1ccba15c4d511e83$var$RESULT_TONE[s][1]
            }
        }, chip(l, s))))));
}
// The login window: the doctor's username and password AT the insurer — and,
// when their profile lacks them, their national code and mobile — then the code
// the insurer texts. تأمین has no password here: its own page is opened by the
// press. The insurer is CHOSEN here only for a patient whose record names none;
// a known one is a name in the title, never a choice (K1, 2026-10-13). The
// password is cleared the moment it is submitted.
const $1ccba15c4d511e83$var$SLOT = "\u2063";
function $1ccba15c4d511e83$var$ErxLoginDialog({ open: open, step: step, insurer: insurer, insurerName: insurerName, nameOf: nameOf, known: known, offered: offered, onPick: onPick, showSave: showSave, save: save, onSaveChange: onSaveChange, unsupportedRecord: unsupportedRecord, needs: needs, otpSentTo: otpSentTo, captchaImage: captchaImage, busy: busy, error: error, onLogin: onLogin, onAnswer: onAnswer, onCancel: onCancel, onRetry: onRetry }) {
    const { t: t } = (0, $LNQP4.default)();
    const tid = $1ccba15c4d511e83$var$useErxTid();
    const [username, setUsername] = (0, $acw62.useState)('');
    const [password, setPassword] = (0, $acw62.useState)('');
    const [nid, setNid] = (0, $acw62.useState)('');
    const [mobile, setMobile] = (0, $acw62.useState)('');
    const [code, setCode] = (0, $acw62.useState)('');
    (0, $acw62.useEffect)(()=>{
        if (!open) setPassword('');
    }, [
        open
    ]);
    (0, $acw62.useEffect)(()=>{
        setCode('');
    }, [
        step
    ]);
    const tamin = insurer === 'TAMIN';
    const needsNid = needs.includes('DOCTOR_NATIONAL_CODE_MISSING');
    const needsMobile = needs.includes('DOCTOR_MOBILE_MISSING');
    const isOtp = step === 'otp';
    const isCaptcha = step === 'captcha';
    const clean = isOtp ? (0, $5JYPc.toEnDigits)(code).replace(/\D/g, '').slice(0, $1ccba15c4d511e83$var$OTP_MAX) : (0, $5JYPc.toEnDigits)(code).trim();
    const ready = step === 'login' ? !!insurer && (tamin || !!username.trim() && !!password) && (!needsNid || $1ccba15c4d511e83$var$isValidNationalCode(nid)) && (!needsMobile || mobile !== '') : step === 'rateLimited' || (isOtp ? clean.length >= $1ccba15c4d511e83$var$OTP_MIN : clean.length > 0);
    const submit = ()=>{
        if (!ready || busy) return;
        if (step === 'rateLimited') {
            onRetry();
            return;
        }
        if (isOtp || isCaptcha) {
            onAnswer(isOtp ? {
                otp: clean
            } : {
                captcha: clean
            });
            setCode('');
            return;
        }
        const form = {
            ...tamin ? {} : {
                username: (0, $5JYPc.toEnDigits)(username.trim()),
                password: password
            },
            nationalCode: needsNid ? nid : undefined,
            mobile: needsMobile ? (0, $5AX1S).toNational(mobile) : undefined
        };
        setPassword('');
        onLogin(form);
    };
    const onEnter = (e)=>{
        if (e.key === 'Enter') submit();
    };
    const title = isOtp ? t('visit.erx.panel.otpTitle', {
        insurer: insurerName
    }) : isCaptcha ? t('visit.erx.panel.captchaTitle', {
        insurer: insurerName
    }) : known ? t('visit.erx.panel.loginTitle', {
        insurer: insurerName
    }) : t('visit.erx.panel.pickTitle');
    const primary = isOtp || isCaptcha ? t('visit.erx.panel.confirm') : step === 'rateLimited' ? t('common.actions.retry') : tamin ? t('visit.erx.panel.submitTamin') : t('visit.erx.panel.submit');
    // The masked number sits inside the sentence, isolated: its digits and dots
    // would otherwise be reordered by the Persian around them.
    const [otpBefore, otpAfter = ''] = t('visit.erx.panel.otpLabel', {
        to: $1ccba15c4d511e83$var$SLOT
    }).split($1ccba15c4d511e83$var$SLOT);
    const fieldStyle = {
        display: 'flex',
        flexDirection: 'column',
        gap: '0.875rem'
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gCvEY.default), {
        open: open,
        onClose: onCancel,
        title: title,
        size: "sm",
        busy: busy,
        "data-testid": tid('login-dialog'),
        footer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                flexWrap: 'wrap',
                gap: '0.5rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "default",
            onClick: submit,
            disabled: !ready || busy,
            className: "gap-1.5",
            "data-testid": tid(isOtp ? 'otp-submit' : isCaptcha ? 'captcha-submit' : 'login-submit')
        }, busy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
            size: 13,
            color: "currentColor",
            label: ""
        }), primary), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "outline",
            onClick: onCancel,
            disabled: busy,
            "data-testid": tid('login-cancel')
        }, t('common.actions.cancel')))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('login'),
        "data-step": step,
        style: fieldStyle
    }, step === 'login' && !known && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('insurer-field'),
        "data-source": unsupportedRecord ? 'unsupported' : 'none'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.8125rem',
            color: (0, $jTCZr.CT).ink2,
            lineHeight: 1.8,
            marginBottom: '0.5rem'
        }
    }, unsupportedRecord ? t('visit.erx.patientInsurer.unsupported', {
        insurer: unsupportedRecord
    }) : t('visit.erx.panel.pickLegend')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('insurer')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$ErxSegmented, {
        semantics: "filter",
        ariaLabel: t('visit.erx.insurerLabel'),
        size: "sm",
        value: insurer || '',
        onChange: onPick,
        options: offered.map((v)=>({
                value: v,
                label: nameOf(v),
                disabled: busy
            }))
    })), showSave && !!insurer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9gEOi.default), {
        checked: save,
        onChange: (v)=>onSaveChange(!!v),
        disabled: busy,
        label: t('visit.erx.patientNid.save'),
        labelClassName: "text-[0.8125rem]",
        style: {
            marginTop: '0.5rem',
            minHeight: 40
        },
        "data-testid": tid('insurer-save')
    })), step === 'login' && tamin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('tamin-note'),
        style: {
            fontSize: '0.8125rem',
            color: (0, $jTCZr.CT).ink2,
            lineHeight: 1.8,
            padding: '0.75rem',
            background: (0, $jTCZr.CT).accentSoft,
            borderRadius: (0, $jTCZr.RADIUS).control
        }
    }, t('visit.erx.panel.taminNote')), step === 'login' && (needsNid || needsMobile) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: fieldStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, {
        tone: "ink"
    }, t('visit.erx.login.needsDetails')), needsNid && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $Ydgp5.default), {
        label: t('common.labels.nationalId'),
        value: nid,
        onChange: (e)=>setNid(e.target.value),
        onKeyDown: onEnter,
        disabled: busy,
        "data-testid": tid('nid')
    }), needsMobile && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lffTJ.default), {
        label: t('auth.login.phoneLabel'),
        value: mobile,
        onChange: setMobile,
        countries: [
            'IR'
        ],
        onKeyDown: onEnter,
        disabled: busy,
        "data-testid": tid('mobile')
    })), step === 'login' && !!insurer && !tamin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: fieldStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        label: t('visit.erx.panel.username', {
            insurer: insurerName
        }),
        helperText: t('visit.erx.login.usernameHint')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
        id: "erx-username",
        value: username,
        onChange: (e)=>setUsername(e.target.value),
        onKeyDown: onEnter,
        disabled: busy,
        autoComplete: "username",
        dir: "ltr",
        "data-testid": tid('username')
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        label: t('visit.erx.panel.password')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
        id: "erx-password",
        type: "password",
        value: password,
        onChange: (e)=>setPassword(e.target.value),
        onKeyDown: onEnter,
        disabled: busy,
        autoComplete: "current-password",
        dir: "ltr",
        "data-testid": tid('password')
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.375rem',
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).mute
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6lig1.default), {
        size: 12,
        "aria-hidden": "true"
    }), " ", t('visit.erx.panel.passwordNote'))), (isOtp || isCaptcha) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, isCaptcha && captchaImage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: captchaImage,
        alt: t('visit.erx.captcha.imageAlt'),
        style: {
            display: 'block',
            maxHeight: '3rem',
            borderRadius: (0, $jTCZr.RADIUS).control,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            marginBottom: '0.5rem'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        label: isOtp ? otpSentTo ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, otpBefore, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("bdi", {
            dir: "ltr"
        }, otpSentTo), otpAfter) : t('visit.erx.panel.otpLabelPlain') : t('visit.erx.captcha.label')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
        id: isOtp ? 'erx-otp' : 'erx-captcha',
        value: isOtp ? clean : code,
        onChange: (e)=>setCode(e.target.value),
        onKeyDown: onEnter,
        disabled: busy,
        inputMode: isOtp ? 'numeric' : 'text',
        autoComplete: isOtp ? 'one-time-code' : 'off',
        autoFocus: true,
        "aria-invalid": !!error,
        dir: "ltr",
        "data-testid": tid(isOtp ? 'otp' : 'captcha'),
        inputStyle: isOtp ? {
            textAlign: 'center',
            letterSpacing: '.3em',
            fontWeight: 700
        } : undefined
    }))), step === 'rateLimited' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, null, t('visit.erx.rateLimited')), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "alert",
        dir: "auto",
        style: {
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).danger
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("bdi", null, error))));
}
function $1ccba15c4d511e83$export$2e2bcd8739ae039({ testIdPrefix: testIdPrefix = 'visit-closure-erx', scope: scope = 'ALL', ...props }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$ErxTestIdPrefix.Provider, {
        value: testIdPrefix
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$ErxScope.Provider, {
        value: scope || 'ALL'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$EPrescriptionCardBody, {
        ...props,
        scope: scope || 'ALL'
    })));
}
function $1ccba15c4d511e83$var$EPrescriptionCardBody({ appointmentId: appointmentId, patientId: patientId, onBusyChange: onBusyChange, prepare: prepare, refreshKey: refreshKey, scope: scope = 'ALL', onSubmitted: onSubmitted, describeLine: describeLine, compactWhenSettled: compactWhenSettled = false, flow: flow = 'card' }) {
    // A scoped card asks the scoped operations; an unscoped one the plain ones.
    const scoped = scope !== 'ALL';
    const panel = flow === 'panel';
    const tid = $1ccba15c4d511e83$var$useErxTid();
    const { t: t, has: has, formatTime: formatTime, formatDate: formatDate } = (0, $LNQP4.default)();
    const [preview, setPreview] = (0, $acw62.useState)(null);
    // Why the last read failed: null, 'absent' (isSchemaGap — silence) or 'failed'.
    // One failed read used to hide the card for the rest of the visit, read again
    // by nothing (K1, 2026-10-03); now it says so and offers to read again.
    const [loadError, setLoadError] = (0, $acw62.useState)(null);
    const [insurer, setInsurer] = (0, $acw62.useState)(null);
    const [session, setSession] = (0, $acw62.useState)(null);
    const [submission, setSubmission] = (0, $acw62.useState)(null);
    const [busy, setBusy] = (0, $acw62.useState)(null); // null | 'load' | 'login' | 'answer' | 'send' | 'correct' | 'logout' | 'siam'
    // What the doctor pressed and a login stands between: null, 'send' (the plain
    // send) or 'correct' (a correction they confirmed). Once the insurer session is
    // active it goes without a second press — the same one decision for both.
    const [wants, setWants] = (0, $acw62.useState)(null);
    // «اصلاح نسخه» (K1, 2026-10-04): the confirmation open; the last correction the
    // insurer did not take (the registration stands, so this is NOT `submission`);
    // the one it took, for «اصلاحیه … ثبت شد».
    const [confirmOpen, setConfirmOpen] = (0, $acw62.useState)(false);
    const [correctionResult, setCorrectionResult] = (0, $acw62.useState)(null);
    const [corrected, setCorrected] = (0, $acw62.useState)(null);
    // The settled registration's one line, opened into the whole card (PM-0097).
    const [detailsOpen, setDetailsOpen] = (0, $acw62.useState)(false);
    const [loginError, setLoginError] = (0, $acw62.useState)(null);
    const [challengeError, setChallengeError] = (0, $acw62.useState)(null);
    const [siamError, setSiamError] = (0, $acw62.useState)(null);
    // A login this card started reached the insurer. The server opens no session
    // without the doctor's national code and mobile, so from then on a preview
    // still naming them missing is stale, and the form must not ask again.
    const [needsMet, setNeedsMet] = (0, $acw62.useState)(false);
    // تأمین's login page was opened in a tab of its own by the press that sent.
    const [redirectOpened, setRedirectOpened] = (0, $acw62.useState)(false);
    // Completed reads, counted: the wait-and-read-again for a send still running
    // is scheduled after each one — not on a `busy` flip, which React may batch away.
    const [reads, setReads] = (0, $acw62.useState)(0);
    const inFlight = (0, $acw62.useRef)(false);
    // کد ملی بیمار: what the field shows, whether the doctor touched it, and the
    // last send's answer to «save it to the record».
    const [nid, setNid] = (0, $acw62.useState)('');
    const nidTouched = (0, $acw62.useRef)(false);
    // null = the doctor has not touched the box: it then starts ticked for a
    // record that holds NO code (nothing is overwritten), unticked for one that
    // holds another (PM-0101).
    const [saveNid, setSaveNid] = (0, $acw62.useState)(null);
    const [nidSaved, setNidSaved] = (0, $acw62.useState)(null);
    // The insurer picked for a patient whose record names none: saved to the
    // record unless the doctor unticks it (PM-0101), and the send's answer to that.
    const [saveInsurer, setSaveInsurer] = (0, $acw62.useState)(true);
    const [insurerSaved, setInsurerSaved] = (0, $acw62.useState)(null);
    // The code to send INSTEAD of the record's — null while the field holds the
    // record's own. A ref, so a read started by anything sends the current one.
    const nidOverride = (0, $acw62.useRef)(null);
    // The patient's gender and mobile the doctor gave for a record without them —
    // what the fields show, what every read and send carries (a ref, like the
    // national code), and the send's answer to writing them to the record.
    const [details, setDetails] = (0, $acw62.useState)({
        gender: '',
        mobile: ''
    });
    const detailsGiven = (0, $acw62.useRef)({
        gender: null,
        mobile: null
    });
    const [detailsSaved, setDetailsSaved] = (0, $acw62.useState)(null);
    // …and the doctor's own mobile typed on the login form, for a profile that holds
    // none (PM-0553): every read, send and correction carries it once typed.
    const withDetails = (op, vars)=>{
        const { gender: gender, mobile: mobile } = detailsGiven.current;
        return (0, $eyy5H.withErxDoctorMobile)(...gender || mobile ? [
            (0, $6xvbB.withErxPatient)(op),
            {
                ...vars,
                patientGender: gender,
                patientMobile: mobile
            }
        ] : [
            op,
            vars
        ]);
    };
    const prepareRef = (0, $acw62.useRef)(prepare);
    prepareRef.current = prepare;
    const runPrepare = (0, $acw62.useCallback)(async ()=>{
        if (!prepareRef.current) return;
        try {
            await prepareRef.current();
        } catch (e) {
            console.warn('[erx] could not write the visit first:', e?.message);
        }
    }, []);
    const onSubmittedRef = (0, $acw62.useRef)(onSubmitted);
    onSubmittedRef.current = onSubmitted;
    const told = (0, $acw62.useCallback)((r)=>{
        try {
            onSubmittedRef.current?.(r);
        } catch (e) {
            console.warn('[erx] onSubmitted failed:', e?.message);
        }
    }, []);
    // A BFF that predates corrections refuses the preview's new fields. Asked once
    // more without them, it answers the card it always did — and from then on this
    // card asks it the old question (K1, 2026-10-04).
    const preCorrection = (0, $acw62.useRef)(false);
    // ── the panel (PM-0187) ──
    // The lines the doctor unticked (erxLineKey), and the ones a registered send
    // left out — for its answer, line by line.
    const [unticked, setUnticked] = (0, $acw62.useState)(()=>new Set());
    const [sentUnticked, setSentUnticked] = (0, $acw62.useState)(null);
    // The doctor closed the login window without logging in.
    const [loginCancelled, setLoginCancelled] = (0, $acw62.useState)(false);
    // The panel checks the insurer session once, on its first read.
    const autoChecked = (0, $acw62.useRef)(false);
    // Our sentences arrive with a code and render in the doctor's language; the
    // insurer's arrive without one and are shown exactly as they came.
    const msgText = (0, $acw62.useCallback)((code, fallback)=>code && has(`visit.erx.msg.${code}`) ? t(`visit.erx.msg.${code}`) : fallback || null, [
        t,
        has
    ]);
    const blockerText = (0, $acw62.useCallback)((b)=>has(`visit.erx.blocker.${b.code}`) ? t(`visit.erx.blocker.${b.code}`) : b.message, [
        t,
        has
    ]);
    // A correction refused before anything was sent names the same reasons the
    // preview gives (Rules §3) — said in the same words as there.
    const correctionMsgText = (0, $acw62.useCallback)((code, fallback)=>code && has(`visit.erx.correction.unavailable.${code}`) ? t(`visit.erx.correction.unavailable.${code}`) : msgText(code, fallback), [
        t,
        has,
        msgText
    ]);
    // ALREADY_AT_INSURER names the prescription that holds the service: its
    // tracking code (heldTrackingCode, K1 2026-10-11).
    // ADDED_AFTER_REGISTRATION is any line the registration does not hold — one
    // written after it, or one the doctor left unticked (PM-0187): the server
    // cannot tell them apart, so the card says what both are.
    const reasonText = (0, $acw62.useCallback)((l)=>{
        const code = l.reasonCode === $1ccba15c4d511e83$var$ADDED_AFTER_REGISTRATION ? 'NOT_IN_REGISTRATION' : l.reasonCode;
        return code && has(`visit.erx.reason.${code}`) ? t(`visit.erx.reason.${code}`, {
            trackingCode: l.heldTrackingCode || ''
        }) : l.reason;
    }, [
        t,
        has
    ]);
    const insurerName = (0, $acw62.useCallback)((value)=>value && has(`visit.erx.insurer.${value}`) ? t(`visit.erx.insurer.${value}`) : preview?.insurerLabel || '', [
        t,
        has,
        preview
    ]);
    const load = (0, $acw62.useCallback)(async (chosen)=>{
        setBusy('load');
        try {
            await runPrepare();
            const vars = {
                appointmentId: appointmentId,
                patientId: patientId,
                insurer: chosen || null,
                patientNationalCode: nidOverride.current,
                ...scoped ? {
                    scope: scope
                } : {}
            };
            const ask = (old)=>(0, $eVM84.bffQuery)(...withDetails(scoped ? old ? (0, $6xvbB.ERX_PREVIEW_SCOPED_PRE_CORRECTION) : (0, $6xvbB.ERX_PREVIEW_SCOPED) : old ? (0, $6xvbB.ERX_PREVIEW_PRE_CORRECTION) : (0, $6xvbB.ERX_PREVIEW), vars));
            let d;
            try {
                d = await ask(preCorrection.current);
            } catch (e) {
                if (preCorrection.current || !$1ccba15c4d511e83$var$isSchemaGap(e)) throw e;
                preCorrection.current = true;
                d = await ask(true);
            }
            const p = d?.ePrescriptionPreview || null;
            setPreview(p);
            setSession(p?.session || null);
            setSubmission(p?.submission || null);
            setInsurer(p?.insurer || chosen || null);
            if (!nidTouched.current) setNid(p?.patientNationalCode || '');
            setLoadError(null);
        } catch (e) {
            // A BFF that cannot even ask is shown as nothing: the feature is not there
            // to fail. Any other failure is said, with a retry — silence there took the
            // card away from a doctor who had it, over one dropped request.
            setLoadError($1ccba15c4d511e83$var$isSchemaGap(e) ? 'absent' : 'failed');
        } finally{
            setBusy(null);
            setReads((n)=>n + 1);
        }
    }, [
        appointmentId,
        patientId,
        runPrepare,
        scoped,
        scope
    ]);
    (0, $acw62.useEffect)(()=>{
        if (appointmentId && patientId) load(null);
    }, [
        appointmentId,
        patientId,
        load
    ]);
    // What the visit holds changed (the in-visit section): read again — unless the
    // doctor is mid-login or mid-send, which a re-read must never interrupt.
    const insurerRef = (0, $acw62.useRef)(insurer);
    insurerRef.current = insurer;
    const sessionStateRef = (0, $acw62.useRef)(null);
    sessionStateRef.current = session?.state || null;
    const firstKey = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(()=>{
        if (firstKey.current) {
            firstKey.current = false;
            return;
        }
        if (inFlight.current || $1ccba15c4d511e83$var$CHALLENGE.includes(sessionStateRef.current)) return;
        load(insurerRef.current);
    }, [
        refreshKey,
        load
    ]);
    // A send the server says is still running, which this card did not start — a
    // send left in flight when پایان ویزیت unmounted the in-visit card, say (K1,
    // 2026-10-03). Read again after a short wait, a few times, until it settles;
    // «بررسی دوباره» asks at once and starts the count again. Never mid-login.
    const serverSending = submission?.state === 'SENDING';
    const challenged = $1ccba15c4d511e83$var$CHALLENGE.includes(session?.state);
    const rechecks = (0, $acw62.useRef)(0);
    (0, $acw62.useEffect)(()=>{
        if (!serverSending) {
            rechecks.current = 0;
            return undefined;
        }
        if (busy || challenged || rechecks.current >= $1ccba15c4d511e83$export$1591506e3dd28b74) return undefined;
        const timer = setTimeout(()=>{
            rechecks.current += 1;
            load(insurerRef.current);
        }, $1ccba15c4d511e83$export$d7dc397751880ad8);
        return ()=>clearTimeout(timer);
    }, [
        serverSending,
        busy,
        challenged,
        load,
        reads
    ]);
    const onRecheck = ()=>{
        rechecks.current = 0;
        load(insurerRef.current);
    };
    // استحقاق‌سنجی (PM-0145): once the card could send — the doctor signed in to the
    // insurer, nothing else in the way — ask whether the insurer covers the patient.
    // On its own, so the card is never held up by the insurer. A BFF without the
    // question, or an answer that fails, shows nothing: it decides no send.
    const [eligibility, setEligibility] = (0, $acw62.useState)(null);
    const eligibilityKey = preview?.ready && session?.state === 'ACTIVE' && preview?.insurer ? `${preview.insurer}|${preview.sentNationalCode || ''}` : null;
    (0, $acw62.useEffect)(()=>{
        if (!eligibilityKey || !appointmentId || !patientId) {
            setEligibility(null);
            return undefined;
        }
        let live = true;
        setEligibility('loading');
        const [insurerEnum, code] = eligibilityKey.split('|');
        (0, $eVM84.bffQuery)((0, $6xvbB.ERX_ELIGIBILITY), {
            appointmentId: appointmentId,
            patientId: patientId,
            insurer: insurerEnum,
            patientNationalCode: code || null
        }).then((d)=>{
            if (live) setEligibility(d?.ePrescriptionEligibility || null);
        }).catch(()=>{
            if (live) setEligibility(null);
        });
        return ()=>{
            live = false;
        };
    }, [
        eligibilityKey,
        appointmentId,
        patientId
    ]);
    const eligibilityBlocks = eligibility?.state === 'NOT_ELIGIBLE' && eligibility.blocks === true;
    // The doctor typed a national code: re-read once it is a whole one, so the
    // blockers and the سلامت number say what THIS code would do.
    const onNidChange = (value)=>{
        nidTouched.current = true;
        setNid(value);
        setNidSaved(null);
        const record = preview?.patientNationalCode || '';
        const next = value && value !== record ? value : null;
        if (value.length === 10 || value === record || value === '') {
            if (next !== nidOverride.current) {
                nidOverride.current = next;
                if (value.length === 10 || value === record) load(insurer);
            }
        }
    };
    // The doctor gave the patient's gender or mobile: re-read, so the card says
    // what the prescription would do with it — a mobile once it is a whole one.
    const onGenderChange = (gender)=>{
        setDetails((d)=>({
                ...d,
                gender: gender
            }));
        setDetailsSaved(null);
        if (gender !== detailsGiven.current.gender) {
            detailsGiven.current = {
                ...detailsGiven.current,
                gender: gender
            };
            load(insurer);
        }
    };
    const onMobileChange = (e164)=>{
        setDetails((d)=>({
                ...d,
                mobile: e164 || ''
            }));
        setDetailsSaved(null);
        const next = e164 && (0, $5AX1S).toNational(e164) || null;
        if (next !== detailsGiven.current.mobile) {
            detailsGiven.current = {
                ...detailsGiven.current,
                mobile: next
            };
            load(insurer);
        }
    };
    // A login waiting for a code, or a send in flight, is unsaved work: the closure
    // asks before any exit abandons it.
    const midFlight = busy === 'send' || busy === 'correct' || busy === 'login' || busy === 'answer' || $1ccba15c4d511e83$var$CHALLENGE.includes(session?.state);
    (0, $acw62.useEffect)(()=>{
        onBusyChange?.(midFlight);
    }, [
        midFlight,
        onBusyChange
    ]);
    (0, $acw62.useEffect)(()=>()=>onBusyChange?.(false), [
        onBusyChange
    ]);
    // In-flight guard: a double click must not send twice or log in twice. The
    // server would cope, but there is no reason to make it prove that.
    const guard = async (kind, fn)=>{
        if (inFlight.current) return;
        inFlight.current = true;
        setBusy(kind);
        try {
            await fn();
        } finally{
            inFlight.current = false;
            setBusy(null);
        }
    };
    // What the login form must ask for: the doctor's own national code and mobile,
    // when their profile lacks them — until a login has shown they are on file.
    const needs = needsMet ? [] : (preview?.blockers || []).filter((b)=>$1ccba15c4d511e83$var$LOGIN_NEEDS.has(b.code)).map((b)=>b.code);
    // Sends now. Only called when the session is known to be active — from the
    // button, or straight after a login completes.
    // The panel's unticked lines a send leaves out — only ones that could go at all,
    // so a line gone from the visit since it was unticked asks nothing.
    const exclusion = (0, $acw62.useMemo)(()=>{
        if (!panel || !unticked.size) return null;
        const keys = (preview?.lines || []).filter((l)=>$1ccba15c4d511e83$var$lineStanding(l) === 'sendable' && unticked.has($1ccba15c4d511e83$export$d0b86cebda39e386(l))).map($1ccba15c4d511e83$export$d0b86cebda39e386);
        if (!keys.length) return null;
        return {
            keys: new Set(keys),
            vars: {
                excludedMedicationIds: keys.filter((k)=>k.startsWith('m:')).map((k)=>k.slice(2)),
                excludedOrderIds: keys.filter((k)=>k.startsWith('o:')).map((k)=>k.slice(2))
            }
        };
    }, [
        panel,
        unticked,
        preview
    ]);
    // The national-code box as it stands: the doctor's own choice once they have
    // made one, else ticked only for a record with no code at all.
    const saveNidOn = saveNid ?? !preview?.patientNationalCode;
    // The insurer is written to the record only when the record names none.
    const insurerToRecord = !!insurer && !!preview && !preview.patientInsurer && saveInsurer;
    const sendNow = (0, $acw62.useCallback)(async ()=>{
        try {
            await runPrepare();
            const vars = {
                appointmentId: appointmentId,
                patientId: patientId,
                insurer: insurer,
                ...scoped ? {
                    scope: scope
                } : {},
                patientNationalCode: nidOverride.current,
                savePatientNationalCode: !!(saveNidOn && nidOverride.current),
                ...exclusion ? exclusion.vars : {}
            };
            // The lines the doctor unticked, asked only when there are some (PM-0187).
            const op = (base)=>exclusion ? (0, $6xvbB.withErxExclusions)(base) : base;
            // The insurer goes to the record only for a patient whose record names
            // none, and only through its own operation. A BFF that predates it refuses
            // the argument: the prescription then goes as it always did, and the card
            // says the record was not changed.
            let d;
            let insurerUnsaved = false;
            if (insurerToRecord) try {
                d = await (0, $eVM84.bffMutation)(...withDetails(op(scoped ? (0, $6xvbB.ERX_SEND_SAVING_INSURER_SCOPED) : (0, $6xvbB.ERX_SEND_SAVING_INSURER)), {
                    ...vars,
                    savePatientInsurer: true
                }));
            } catch (e) {
                if (!$1ccba15c4d511e83$var$isSchemaGap(e)) throw e;
                insurerUnsaved = true;
            }
            if (!d) d = await (0, $eVM84.bffMutation)(...withDetails(op(scoped ? (0, $6xvbB.ERX_SEND_SCOPED) : (0, $6xvbB.ERX_SEND)), vars));
            const r = d?.sendEPrescription || null;
            setSubmission(r);
            if (r?.state === 'REGISTERED') setSentUnticked(exclusion ? exclusion.keys : null);
            setNidSaved(r?.patientNationalCodeSaved ?? null);
            setDetailsSaved(r?.patientDetailsSaved ?? null);
            setInsurerSaved(insurerUnsaved ? false : r?.patientInsurerSaved ?? null);
            setWants(null);
            if (r?.state === 'SESSION_REQUIRED') {
                // The insurer stopped accepting the login: ask for it again, and send
                // once it is back — the doctor already decided to send.
                setSession((s)=>({
                        ...s || {},
                        state: 'EXPIRED'
                    }));
                setWants('send');
            }
            told(r);
        } catch (e) {
            setSubmission({
                state: 'FAILED',
                message: e.message,
                retryable: true,
                fieldErrors: [],
                blockers: []
            });
        }
    }, [
        appointmentId,
        patientId,
        insurer,
        saveNidOn,
        insurerToRecord,
        runPrepare,
        t,
        scoped,
        scope,
        told,
        exclusion
    ]);
    // تأمین, with nothing the login form would ask: there is no form to fill, so
    // the press that decides goes straight to تأمین's page (openLoginTab).
    const loginInOnePress = insurer === 'TAMIN' && needs.length === 0;
    const onSend = ()=>guard('send', async ()=>{
            setLoginError(null);
            // Not logged in — or the doctor's own national code or mobile is missing,
            // which only the login form asks for (and saves): the form, then the send.
            if (session?.state !== 'ACTIVE' || needs.length) {
                setWants('send');
                if (!loginInOnePress) return;
                const tab = $1ccba15c4d511e83$var$openLoginTab(t('visit.erx.redirect.tab'));
                setBusy('login');
                const s = await startLogin({}, tab);
                if (s?.state === 'ACTIVE') {
                    setBusy('send');
                    await sendNow();
                }
                return;
            }
            await sendNow();
        });
    // ── «اصلاح نسخه» (K1, 2026-10-04) ──────────────────────────────────────────
    // Sends the correction — the whole prescription of every registered part in
    // this scope, as the record now holds it — with the same insurer and national
    // code a send would carry; each service goes on its order's «تاریخ انجام»
    // (PM-0634). Only called with the session known to be active: from the confirmation, or
    // straight after a login completes.
    const submissionRef = (0, $acw62.useRef)(submission);
    submissionRef.current = submission;
    const correctNow = (0, $acw62.useCallback)(async ()=>{
        try {
            await runPrepare();
            const d = await (0, $eVM84.bffMutation)(...withDetails((0, $6xvbB.ERX_SEND_CORRECTION), {
                appointmentId: appointmentId,
                patientId: patientId,
                insurer: insurer,
                scope: scope,
                patientNationalCode: nidOverride.current
            }));
            const r = d?.sendEPrescriptionCorrection || null;
            setWants(null);
            told(r);
            if (r?.state === 'SESSION_REQUIRED') {
                // As a send: the login again, and the correction once it is back.
                setSession((s)=>({
                        ...s || {},
                        state: 'EXPIRED'
                    }));
                setWants('correct');
                return;
            }
            if (r?.state === 'REGISTERED' && r.correctsLocalId) {
                // The correction IS the registration now (Rules §5): its tracking code at
                // once, then the lines and what is left to correct as the insurer holds
                // them. A scope with a part still unsent stays on its send.
                setCorrectionResult(null);
                setCorrected(r);
                if (submissionRef.current?.state === 'REGISTERED') setSubmission(r);
                await load(insurerRef.current);
                return;
            }
            if (r && (r.state === 'REGISTERED' || r.state === 'NONE')) {
                // Refused before anything was sent — the registration as it stands, and
                // why (Rules §3; or it moved meanwhile, REGISTRATION_SUPERSEDED). Said,
                // and the card reads again: what it showed is no longer so.
                setCorrectionResult({
                    ...r,
                    state: 'REFUSED'
                });
                await load(insurerRef.current);
                return;
            }
            setCorrectionResult(r || {
                state: 'FAILED',
                message: null,
                retryable: true,
                fieldErrors: [],
                blockers: []
            });
        } catch (e) {
            setCorrectionResult({
                state: 'FAILED',
                message: e.message,
                retryable: true,
                fieldErrors: [],
                blockers: []
            });
        }
    }, [
        appointmentId,
        patientId,
        insurer,
        scope,
        runPrepare,
        load,
        told
    ]);
    const onCorrect = ()=>{
        setConfirmOpen(false);
        return guard('correct', async ()=>{
            setLoginError(null);
            setCorrectionResult(null);
            setCorrected(null);
            if (session?.state !== 'ACTIVE' || needs.length) {
                setWants('correct');
                if (!loginInOnePress) return;
                const tab = $1ccba15c4d511e83$var$openLoginTab(t('visit.erx.redirect.tab'));
                setBusy('login');
                const s = await startLogin({}, tab);
                if (s?.state === 'ACTIVE') {
                    setBusy('correct');
                    await correctNow();
                }
                return;
            }
            await correctNow();
        });
    };
    // What a login was for, once the insurer session is active.
    const proceed = ()=>wants === 'send' ? sendNow() : wants === 'correct' ? correctNow() : null;
    // Starts the insurer login and answers with the session it opened. `tab` — a
    // tab opened for تأمین's page by the press itself (openLoginTab): pointed at
    // the page when the insurer names it, closed when it does not.
    const startLogin = async (form, tab = null)=>{
        setLoginError(null);
        setChallengeError(null);
        setRedirectOpened(false);
        let handedOver = false;
        try {
            const d = await (0, $eVM84.bffMutation)((0, $6xvbB.ERX_START_LOGIN), {
                insurer: insurer,
                ...form
            });
            const s = d?.startInsurerLogin || null;
            setSession(s);
            // Any answer from the insurer itself proves the profile holds both.
            if (s?.state === 'ACTIVE' || $1ccba15c4d511e83$var$CHALLENGE.includes(s?.state)) setNeedsMet(true);
            // The login went ahead with the mobile the form asked for: the profile holds
            // none, so every later read and send takes it again (PM-0553) — kept in
            // memory only, never saved (lib/erxDoctorMobile.js).
            if (form.mobile && (s?.state === 'ACTIVE' || s?.state === 'REDIRECT_REQUIRED' || $1ccba15c4d511e83$var$CHALLENGE.includes(s?.state))) (0, $eyy5H.rememberErxDoctorMobile)(form.mobile);
            if (s?.state === 'REDIRECT_REQUIRED' && s.redirectUrl && tab && !tab.closed) try {
                tab.location.href = s.redirectUrl;
                handedOver = true;
                setRedirectOpened(true);
            } catch  {}
            if (s?.state !== 'ACTIVE' && !$1ccba15c4d511e83$var$CHALLENGE.includes(s?.state) && s?.state !== 'RATE_LIMITED') setLoginError(msgText(s?.messageCode, s?.message) || t('visit.erx.failed'));
            return s;
        } catch (e) {
            setLoginError(e.message);
            return null;
        } finally{
            // Never left behind blank.
            if (tab && !handedOver) try {
                tab.close();
            } catch  {}
        }
    };
    const onLogin = (form)=>guard('login', async ()=>{
            // تأمین's page opens from this press too, as from «ارسال».
            const tab = insurer === 'TAMIN' ? $1ccba15c4d511e83$var$openLoginTab(t('visit.erx.redirect.tab')) : null;
            const s = await startLogin(form, tab);
            if (s?.state === 'ACTIVE') await proceed();
        });
    const onAnswer = (answer)=>guard('answer', async ()=>{
            setChallengeError(null);
            try {
                const d = await (0, $eVM84.bffMutation)((0, $6xvbB.ERX_ANSWER_CHALLENGE), {
                    insurer: insurer,
                    ...answer
                });
                const s = d?.answerInsurerChallenge || null;
                // Still waiting for تأمین: op-naji's answer names no page, and the one
                // the login opened is the same session's — keep it (PM-0279).
                setSession((prev)=>s?.state === 'REDIRECT_REQUIRED' && !s.redirectUrl && prev?.redirectUrl ? {
                        ...s,
                        redirectUrl: prev.redirectUrl
                    } : s);
                if (s?.state === 'ACTIVE') await proceed();
                else if (s?.messageCode || s?.message) {
                    const text = msgText(s.messageCode, s.message);
                    if ($1ccba15c4d511e83$var$CHALLENGE.includes(s.state)) setChallengeError(text);
                    else setLoginError(text);
                }
            } catch (e) {
                setChallengeError(e.message);
            }
        });
    // تأمین: the return page (/erx/tamin-return) announces that the doctor is back
    // from تأمین's own login page, and the card re-checks the session — and sends,
    // if that was the decision — without the doctor finding it and pressing
    // anything. «ورود را انجام دادم» stays as the manual fallback.
    const onAnswerRef = (0, $acw62.useRef)(onAnswer);
    onAnswerRef.current = onAnswer;
    (0, $acw62.useEffect)(()=>{
        if (session?.state !== 'REDIRECT_REQUIRED') return undefined;
        return (0, $ctEhH.onTaminReturn)((detail)=>{
            if (detail.ok) onAnswerRef.current({});
            else setChallengeError(t('visit.erx.redirect.denied'));
        });
    }, [
        session?.state,
        t
    ]);
    const onSaveSiam = (siamId)=>guard('siam', async ()=>{
            setSiamError(null);
            try {
                await (0, $eVM84.bffMutation)((0, $6xvbB.ERX_SET_SIAM), {
                    siamId: siamId
                });
                await load(insurer);
            } catch (e) {
                setSiamError(e.message);
            }
        });
    const onLogout = ()=>guard('logout', async ()=>{
            try {
                const d = await (0, $eVM84.bffMutation)((0, $6xvbB.ERX_LOGOUT), {
                    insurer: insurer
                });
                setSession(d?.logoutInsurer || {
                    state: 'NONE'
                });
            } catch  {}
        });
    const onPickInsurer = (value)=>{
        if (value === insurer) return;
        setInsurer(value);
        // The panel picks in its login window, which stays open for the login.
        if (!panel) setWants(null);
        setLoginError(null);
        setChallengeError(null);
        setCorrectionResult(null);
        setInsurerSaved(null);
        load(value);
    };
    // ── the panel's login (PM-0187) ────────────────────────────────────────────
    // The patient's insurer is known when their record names one this deployment
    // sends to: then it is never offered as a choice, on any card.
    const recordKnown = !!preview?.patientInsurer && (preview?.offeredInsurers || []).includes(preview.patientInsurer);
    // تأمین, known, with nothing the window would ask: its own page, no window.
    const taminDirect = insurer === 'TAMIN' && recordKnown && needs.length === 0;
    // تأمین's page opened by the panel itself, on its first read. No press stands
    // behind it, so the browser may refuse the tab: the «باز کردن» button the
    // waiting note carries then opens it.
    const openTaminByItself = ()=>guard('login', async ()=>{
            const s = await startLogin({});
            if (s?.state !== 'REDIRECT_REQUIRED' || !s.redirectUrl) return;
            const tab = $1ccba15c4d511e83$var$openLoginTab(t('visit.erx.redirect.tab'));
            if (!tab) return;
            try {
                tab.location.href = s.redirectUrl;
                setRedirectOpened(true);
            } catch  {
                try {
                    tab.close();
                } catch  {}
            }
        });
    // The panel opens on the login, not on a button (K1, 2026-10-13): once, on the
    // first read — a live session goes straight to the preview; anything the
    // doctor must fix first, or nothing to send, leaves the login for later.
    (0, $acw62.useEffect)(()=>{
        if (!panel || autoChecked.current || !preview || busy) return;
        autoChecked.current = true;
        if (!preview.enabled || preview.serviceIssue) return;
        if ([
            'REGISTERED',
            'SENDING'
        ].includes(preview.submission?.state)) return;
        if ((preview.blockers || []).some((b)=>!$1ccba15c4d511e83$var$PANEL_FIXES.has(b.code))) return;
        if (!(preview.lines || []).some((l)=>$1ccba15c4d511e83$var$lineStanding(l) === 'sendable')) return;
        const state = preview.session?.state;
        if (state === 'ACTIVE' && !needs.length) return;
        setWants('login');
        if (taminDirect && ![
            'OTP_REQUIRED',
            'CAPTCHA_REQUIRED'
        ].includes(state)) openTaminByItself();
    }, [
        panel,
        preview,
        busy
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    // Logged in: nothing left for the login to do, and nothing to say it failed.
    (0, $acw62.useEffect)(()=>{
        if (session?.state !== 'ACTIVE') return;
        setLoginCancelled(false);
        if (wants === 'login' && !needs.length) setWants(null);
    }, [
        session?.state,
        wants,
        needs.length
    ]);
    // «ورود به بیمه» on the panel: the window — or, for تأمین, its page, opened by
    // this press. A send the doctor already pressed stays what the login is for.
    const onPanelLogin = ()=>{
        setLoginCancelled(false);
        setLoginError(null);
        setChallengeError(null);
        setWants((w)=>w === 'send' || w === 'correct' ? w : 'login');
        if (!taminDirect) return;
        guard('login', async ()=>{
            const tab = $1ccba15c4d511e83$var$openLoginTab(t('visit.erx.redirect.tab'));
            const s = await startLogin({}, tab);
            if (s?.state === 'ACTIVE') await proceed();
        });
    };
    // «باز کردن صفحهٔ ورود تأمین»: the page this session named — or, when it names
    // none (a login that was continued before the doctor finished, PM-0279), a
    // fresh login, its tab opened by this press. `window.open(null)` opened the
    // text «null» beside the visit: …/visit/null.
    const onOpenTaminPage = ()=>{
        if (session?.redirectUrl) {
            window.open(session.redirectUrl, '_blank', 'noopener');
            setRedirectOpened(true);
            return;
        }
        guard('login', async ()=>{
            const tab = $1ccba15c4d511e83$var$openLoginTab(t('visit.erx.redirect.tab'));
            const s = await startLogin({}, tab);
            if (s?.state === 'ACTIVE') await proceed();
        });
    };
    // «انصراف» in the window: no login, and the panel says what that means. A
    // challenge left half-answered is dropped here; the next login starts anew.
    const onLoginCancel = ()=>{
        setWants(null);
        setLoginCancelled(true);
        setLoginError(null);
        setChallengeError(null);
        if ($1ccba15c4d511e83$var$CHALLENGE.includes(session?.state) || session?.state === 'RATE_LIMITED') setSession((s)=>({
                ...s || {},
                state: 'NONE'
            }));
    };
    const toggleLine = (key)=>setUnticked((prev)=>{
            const next = new Set(prev);
            if (next.has(key)) next.delete(key);
            else next.add(key);
            return next;
        });
    const toggleGroup = (keys, tick)=>setUnticked((prev)=>{
            const next = new Set(prev);
            for (const key of keys)if (tick) next.delete(key);
            else next.add(key);
            return next;
        });
    // ── render ──────────────────────────────────────────────────────────────
    if (loadError === 'absent') return null;
    if (loadError === 'failed') {
        // Still silence for a doctor the feature is not offered to: a read that
        // failed after one that said so must not make them see it fail.
        if (preview && !preview.enabled) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$CardShell, {
            state: $1ccba15c4d511e83$var$DATA_STATE.LOAD_FAILED,
            bare: panel
        }, !panel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$CardHead, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: '0.5rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, {
            tone: "bad",
            role: "alert"
        }, t('visit.erx.loadFailed')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "outline",
            size: "sm",
            className: "gap-1.5",
            onClick: ()=>load(insurerRef.current),
            disabled: busy === 'load',
            "data-testid": tid('reload')
        }, busy === 'load' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
            size: 13,
            color: "currentColor",
            label: ""
        }), t('common.actions.retry'))));
    }
    if (!preview) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$CardShell, {
        state: $1ccba15c4d511e83$var$DATA_STATE.LOADING,
        bare: panel
    }, !panel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$CardHead, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonText), {
        width: "60%"
    }), panel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonText), {
        lines: 4
    }));
    if (!preview.enabled) return null;
    const name = insurerName(insurer);
    const subtitle = insurer ? t('visit.erx.subtitle', {
        insurer: name
    }) : t('visit.erx.subtitleNoInsurer');
    const draftBadge = preview.draftOnly ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bHjRG.default), {
        variant: "outline"
    }, t('visit.erx.draftBadge')) : null;
    // The sending service itself is unusable — nothing the doctor can do here.
    if (preview.serviceIssue) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$CardShell, {
        state: $1ccba15c4d511e83$var$DATA_STATE.UNAVAILABLE,
        bare: panel
    }, !panel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$CardHead, {
        subtitle: subtitle,
        badges: draftBadge
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: preview.serviceIssue === 'SERVICE_NOT_CONFIGURED' ? 'neutral' : 'error',
        style: {
            alignItems: 'flex-start'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("bdi", null, msgText(preview.serviceIssue, preview.serviceMessage)))), preview.serviceIssue !== 'SERVICE_NOT_CONFIGURED' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "sm",
        className: "mt-2.5",
        onClick: ()=>load(insurer),
        disabled: busy === 'load',
        "data-testid": tid('reload')
    }, t('common.actions.retry')));
    const sub = submission || {
        state: 'NONE'
    };
    const sessionState = session?.state || 'NONE';
    // ── «اصلاح نسخه»: what the server says a correction can do (K1, 2026-10-04) ──
    // `correction` is null from a BFF that predates corrections: the card is then
    // exactly what it was, «cannot be changed from Parsina yet» note and all.
    const correction = preview.correction || null;
    const correctionParts = correction?.parts || [];
    const changesSince = (preview.lines || []).some((l)=>$1ccba15c4d511e83$var$SINCE_REGISTRATION.has(l.reasonCode));
    const changesPending = !!correction && ((correction.pendingCount || 0) > 0 || changesSince);
    const correctionReason = correction && !correction.available && $1ccba15c4d511e83$export$7a9c4ec4ae364c2.includes(correction.unavailableReason) ? correction.unavailableReason : null;
    // The login, when it stands between the doctor and a confirmed correction.
    const correctLoginShown = !!insurer && wants === 'correct' && !$1ccba15c4d511e83$var$CHALLENGE.includes(sessionState) && sessionState !== 'RATE_LIMITED' && (sessionState !== 'ACTIVE' || needs.length > 0);
    // تأمین's login started by «ارسال» itself: no form to show meanwhile — it
    // returns, with the error, only when that login did not reach تأمین.
    const connectingInOnePress = busy === 'login' && loginInOnePress;
    // The insurer's challenges and the login form — under whichever decision
    // (the send, or the correction) the doctor is completing.
    const sessionSteps = (loginVisible)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, sessionState === 'OTP_REQUIRED' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$ChallengeField, {
            kind: "otp",
            sentTo: session?.otpSentTo,
            onSubmit: onAnswer,
            busy: busy === 'answer',
            error: challengeError
        }), sessionState === 'CAPTCHA_REQUIRED' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$ChallengeField, {
            kind: "captcha",
            captchaImage: session?.captchaImage,
            onSubmit: onAnswer,
            busy: busy === 'answer',
            error: challengeError
        }), sessionState === 'REDIRECT_REQUIRED' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": tid('redirect-note'),
            "data-opened": redirectOpened ? 'true' : 'false'
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, null, t(redirectOpened ? 'visit.erx.redirect.opened' : 'visit.erx.redirect.waiting'))), challengeError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, {
            tone: "bad",
            role: "alert"
        }, challengeError)), sessionState === 'REDIRECT_REQUIRED' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                flexWrap: 'wrap',
                gap: '0.5rem',
                marginTop: '0.375rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: redirectOpened ? 'outline' : 'default',
            size: "sm",
            className: "gap-1.5",
            onClick: onOpenTaminPage,
            disabled: busy === 'login',
            "data-testid": tid('redirect-open')
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cxlxT.default), {
            size: 13,
            "aria-hidden": "true"
        }), " ", t(redirectOpened ? 'visit.erx.redirect.reopen' : 'visit.erx.redirect.open')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "outline",
            size: "sm",
            onClick: ()=>onAnswer({}),
            disabled: busy === 'answer',
            "data-testid": tid('redirect-done')
        }, t('visit.erx.redirect.done'))), sessionState === 'RATE_LIMITED' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, null, t('visit.erx.rateLimited')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "outline",
            size: "sm",
            className: "mt-2",
            onClick: ()=>setSession({
                    state: 'NONE'
                })
        }, t('common.actions.retry'))), loginVisible && connectingInOnePress && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": tid('connecting'),
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
            size: 13,
            color: (0, $jTCZr.CT).accent,
            label: ""
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, null, t('visit.erx.connecting'))), loginVisible && !connectingInOnePress && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$LoginForm, {
            insurerName: name,
            needs: needs,
            onSubmit: onLogin,
            busy: busy === 'login',
            error: loginError,
            note: sessionState === 'EXPIRED' ? t('visit.erx.sessionRequired') : t('visit.erx.sendNeedsLogin', {
                insurer: name
            }),
            redirect: insurer === 'TAMIN'
        }));
    // The registered part's changes, and «ارسال اصلاحیه به بیمه» — or, when a
    // correction cannot go, why, in one line. `view` is the card it sits in:
    // 'registered', or 'send' when another part of the scope is still unsent.
    const correctionSection = (view)=>{
        if (!correction) return null;
        // The same amber band as the card's other «not yet at the insurer» notes.
        const holder = {
            marginTop: '0.625rem',
            padding: '0.5rem 0.625rem',
            borderRadius: (0, $jTCZr.RADIUS).control,
            background: (0, $jTCZr.CT).warnSoft,
            borderInlineStart: `2px solid ${(0, $jTCZr.CT).warn}`
        };
        if (correction.available) {
            const here = wants === 'correct';
            const challengedHere = here && ($1ccba15c4d511e83$var$CHALLENGE.includes(sessionState) || sessionState === 'RATE_LIMITED');
            const pendingElsewhere = correctionResult?.state === 'SENDING';
            const state = busy === 'correct' ? 'sending' : here && sessionState === 'OTP_REQUIRED' ? 'otp' : here && sessionState === 'CAPTCHA_REQUIRED' ? 'captcha' : here && sessionState === 'REDIRECT_REQUIRED' ? 'redirect' : correctLoginShown ? 'login' : correctionResult && !pendingElsewhere ? 'refused' : 'available';
            const locked = !!busy || view === 'send' && serverSending;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                "data-testid": tid('correction'),
                "data-state": state,
                style: holder
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    fontSize: '0.65625rem',
                    fontWeight: 700,
                    color: (0, $jTCZr.CT).ink2,
                    marginBottom: '0.25rem'
                }
            }, t('visit.erx.correction.title')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$CorrectionDiff, {
                lines: preview.lines,
                parts: correctionParts,
                describeLine: describeLine
            }), correction.until && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                "data-testid": tid('correction-until')
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, {
                tone: "ink"
            }, t('visit.erx.correction.until', {
                date: formatDate(correction.until, 'medium')
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, null, t('visit.erx.correction.limited')), correctionResult && !pendingElsewhere && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                "data-testid": tid('correction-result'),
                "data-result": correctionResult.state,
                "data-code": correctionResult.messageCode || undefined,
                style: {
                    marginTop: '0.5rem'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$SubmissionProblem, {
                result: correctionResult,
                msgText: correctionMsgText
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, null, t('visit.erx.correction.stands'))), pendingElsewhere && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, null, t('visit.erx.sendingElsewhere')), here && !panel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    marginTop: '0.5rem'
                }
            }, sessionSteps(correctLoginShown)), !correctLoginShown && !challengedHere && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
                variant: "default",
                size: "sm",
                onClick: ()=>setConfirmOpen(true),
                disabled: locked || !insurer,
                className: "gap-1.5 mt-2",
                "data-testid": tid('correct')
            }, busy === 'correct' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
                size: 13,
                color: "currentColor",
                label: ""
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6OGKD.default), {
                size: 13,
                "aria-hidden": "true"
            }), busy === 'correct' ? t('visit.erx.correction.sending') : t('visit.erx.correction.send')));
        }
        if (correctionReason && changesPending) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": tid('correction'),
            "data-state": "unavailable",
            "data-reason": correctionReason,
            style: holder
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, {
            tone: "ink"
        }, t(`visit.erx.correction.unavailable.${correctionReason}`)));
        return null;
    };
    // The one confirmation before a correction goes: it replaces what the insurer
    // holds, and the insurer allows only so many.
    const confirmDialog = correction?.available ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3OnFU.default), {
        open: confirmOpen,
        onOpenChange: (open)=>{
            if (!open) setConfirmOpen(false);
        },
        title: t('visit.erx.correction.confirmTitle', {
            insurer: name || t('visit.erx.insurerLabel')
        }),
        description: t('visit.erx.correction.confirmBody'),
        confirmLabel: t('visit.erx.correction.confirm'),
        onConfirm: onCorrect,
        confirmTestId: tid('correction-confirm'),
        cancelTestId: tid('correction-cancel'),
        "data-testid": tid('correction-dialog')
    }) : null;
    // ── registered: the doctor's proof — and, once it differs from the نسخه, the
    // correction ──
    if (sub.state === 'REGISTERED') {
        const registeredText = sub.lifecycle === 'incomplete' ? t('visit.erx.registeredDraft', {
            insurer: name
        }) : t('visit.erx.registered', {
            insurer: name
        });
        if (panel) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$CardShell, {
            bare: true,
            tone: "good",
            state: $1ccba15c4d511e83$var$DATA_STATE.REGISTERED
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "aria-live": "polite",
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: '0.875rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$PanelResult, {
            lines: preview.lines,
            unticked: sentUnticked,
            reasonText: reasonText,
            name: name,
            trackingCode: sub.trackingCode,
            fallback: registeredText,
            notes: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, sub.ditasStatus === 'queued' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, null, t('visit.erx.queued')), sub.lifecycle === 'incomplete' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, null, t('visit.erx.draftNote')))
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$NidSavedNote, {
            saved: nidSaved
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$InsurerSavedNote, {
            saved: insurerSaved
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$DetailsSavedNote, {
            saved: detailsSaved
        }), corrected && !correction?.available && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": tid('corrected')
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, {
            tone: "good"
        }, t('visit.erx.correction.done', {
            insurer: name
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "aria-live": "polite"
        }, correctionSection('registered')), confirmDialog);
        // Registered during the visit and unchanged since: nothing left to decide.
        const settled = compactWhenSettled && !detailsOpen && busy !== 'correct' && !changesPending && !corrected && !correctionResult && wants !== 'correct';
        if (settled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$CardShell, {
            tone: "good",
            state: $1ccba15c4d511e83$var$DATA_STATE.REGISTERED,
            compact: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "aria-live": "polite",
            style: {
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: '0.5rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
            size: 15,
            "aria-hidden": "true",
            style: {
                color: (0, $jTCZr.CT).good,
                flexShrink: 0
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                flex: '1 1 12rem',
                minWidth: 0,
                fontSize: '0.75rem',
                fontWeight: 700,
                color: (0, $jTCZr.CT).goodInk
            }
        }, registeredText), sub.trackingCode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.6875rem',
                color: (0, $jTCZr.CT).ink2
            }
        }, t('visit.erx.trackingCode'), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("b", {
            dir: "ltr",
            "data-testid": tid('tracking'),
            style: {
                unicodeBidi: 'isolate',
                display: 'inline-block',
                userSelect: 'all'
            }
        }, sub.trackingCode)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            size: "sm",
            onClick: ()=>setDetailsOpen(true),
            "data-testid": tid('details')
        }, t('visit.erx.chip.details'))));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$CardShell, {
            tone: "good",
            state: $1ccba15c4d511e83$var$DATA_STATE.REGISTERED
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$CardHead, {
            subtitle: subtitle,
            badges: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bHjRG.default), {
                variant: "success"
            }, t('common.state.registered'))
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "aria-live": "polite"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, {
            tone: "good"
        }, registeredText), sub.trackingCode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.6875rem',
                color: (0, $jTCZr.CT).ink2,
                marginTop: '0.3125rem'
            }
        }, t('visit.erx.trackingCode'), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("b", {
            dir: "ltr",
            "data-testid": tid('tracking'),
            style: {
                unicodeBidi: 'isolate',
                display: 'inline-block',
                userSelect: 'all'
            }
        }, sub.trackingCode)), sub.ditasStatus === 'queued' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, null, t('visit.erx.queued')), sub.lifecycle === 'incomplete' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, null, t('visit.erx.draftNote')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$NidSavedNote, {
            saved: nidSaved
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$InsurerSavedNote, {
            saved: insurerSaved
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$DetailsSavedNote, {
            saved: detailsSaved
        }), corrected && !correction?.available && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": tid('corrected')
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, {
            tone: "good"
        }, t('visit.erx.correction.done', {
            insurer: name
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                marginTop: '0.625rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Lines, {
            lines: preview.lines,
            reasonText: reasonText,
            registered: true,
            correctionAware: !!correction
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "aria-live": "polite"
        }, correctionSection('registered')), confirmDialog);
    }
    // ── everything before a registration ──
    const blockers = preview.blockers || [];
    const hardBlocked = blockers.some((b)=>!$1ccba15c4d511e83$var$HANDLED_IN_CARD.has(b.code));
    const needsInsurer = !insurer;
    const offered = preview.offeredInsurers || [];
    // The insurer row: only for a patient whose record names no insurer this
    // deployment sends to. A known one is never offered as a choice (K1,
    // 2026-10-13) — the prescription goes to the patient's own insurer.
    const showPicker = !recordKnown && offered.length > 0;
    // Ready to press: nothing blocks — or all that does is what the login form asks
    // for, and «ارسال» is the way to that form.
    const canSend = preview.ready || blockers.length > 0 && blockers.every((b)=>$1ccba15c4d511e83$var$LOGIN_NEEDS.has(b.code));
    // Running on the server, not started here: shown as running, never as ready —
    // «ارسال» over it would start a second send of the same prescription.
    const sendingElsewhere = serverSending && busy !== 'send';
    const sending = busy === 'send' || sendingElsewhere;
    const locked = !!busy || sendingElsewhere;
    // The login appears once the doctor has asked to send and is not logged in —
    // or is, but their profile lacks what only the login form asks for.
    const loginShown = !!insurer && !hardBlocked && wants === 'send' && !sendingElsewhere && !$1ccba15c4d511e83$var$CHALLENGE.includes(sessionState) && sessionState !== 'RATE_LIMITED' && (sessionState !== 'ACTIVE' || needs.length > 0);
    const result = [
        'REJECTED',
        'NOT_ACCEPTED',
        'FAILED',
        'BLOCKED'
    ].includes(sub.state) ? sub : null;
    // The panel's login window: open while a login is wanted and the insurer asks
    // for one here — never for تأمین's own page, which the waiting note stands for.
    const modalStep = sessionState === 'OTP_REQUIRED' ? 'otp' : sessionState === 'CAPTCHA_REQUIRED' ? 'captcha' : sessionState === 'RATE_LIMITED' ? 'rateLimited' : 'login';
    const modalOpen = panel && !!wants && !sendingElsewhere && sessionState !== 'REDIRECT_REQUIRED' && (modalStep !== 'login' || (sessionState !== 'ACTIVE' || needs.length > 0) && !taminDirect);
    const dataState = busy === 'send' ? $1ccba15c4d511e83$var$DATA_STATE.SENDING : sessionState === 'OTP_REQUIRED' ? $1ccba15c4d511e83$var$DATA_STATE.OTP : sessionState === 'CAPTCHA_REQUIRED' ? $1ccba15c4d511e83$var$DATA_STATE.CAPTCHA : sessionState === 'REDIRECT_REQUIRED' ? $1ccba15c4d511e83$var$DATA_STATE.REDIRECT : (panel ? modalOpen : loginShown) ? $1ccba15c4d511e83$var$DATA_STATE.LOGIN : sendingElsewhere ? $1ccba15c4d511e83$var$DATA_STATE.SENDING : result?.state === 'FAILED' ? $1ccba15c4d511e83$var$DATA_STATE.FAILED : result ? $1ccba15c4d511e83$var$DATA_STATE.REJECTED : hardBlocked || needsInsurer ? $1ccba15c4d511e83$var$DATA_STATE.BLOCKED : $1ccba15c4d511e83$var$DATA_STATE.READY;
    const tone = result ? 'bad' : busy || sendingElsewhere || $1ccba15c4d511e83$var$CHALLENGE.includes(sessionState) || loginShown ? 'busy' : 'idle';
    if (panel) {
        const lines = preview.lines || [];
        const selectedCount = lines.filter((l)=>$1ccba15c4d511e83$var$panelGoes(l, unticked)).length;
        const nidRecord = preview.patientNationalCode || '';
        // The patient's national code is asked only when the record holds no valid
        // one — or the doctor has started typing another.
        const nidAsked = !nidRecord || !$1ccba15c4d511e83$var$isValidNationalCode(nidRecord) || nidTouched.current;
        const signedOut = sessionState !== 'ACTIVE' && sessionState !== 'REDIRECT_REQUIRED';
        const sendDisabled = !canSend || !insurer || locked || selectedCount === 0 || nid.length > 0 && !$1ccba15c4d511e83$var$isValidNationalCode(nid) || eligibilityBlocks;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$CardShell, {
            bare: true,
            state: dataState
        }, modalOpen ? // Behind the login window: the panel's shape, nothing to read yet.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": tid('waiting'),
            "aria-hidden": "true",
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: '0.75rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonText), {
            lines: 3
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonText), {
            lines: 5
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$InsuranceInfo, {
            name: insurer ? name : null,
            session: session,
            onLogout: onLogout,
            locked: locked
        }, sessionState === 'ACTIVE' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$EligibilityLine, {
            value: eligibility,
            insurerName: name
        }), sessionState === 'REDIRECT_REQUIRED' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": tid('redirect-note'),
            "data-opened": redirectOpened ? 'true' : 'false',
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: '0.5rem',
                marginTop: '0.25rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, {
            tone: "ink"
        }, t(wants === 'send' ? redirectOpened ? 'visit.erx.redirect.opened' : 'visit.erx.redirect.waiting' : redirectOpened ? 'visit.erx.panel.taminOpened' : 'visit.erx.panel.taminWaiting')), challengeError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, {
            tone: "bad",
            role: "alert"
        }, challengeError), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                flexWrap: 'wrap',
                gap: '0.5rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: redirectOpened ? 'outline' : 'default',
            size: "sm",
            className: "gap-1.5",
            onClick: onOpenTaminPage,
            disabled: busy === 'login',
            "data-testid": tid('redirect-open')
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cxlxT.default), {
            size: 13,
            "aria-hidden": "true"
        }), " ", t(redirectOpened ? 'visit.erx.redirect.reopen' : 'visit.erx.redirect.open')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "outline",
            size: "sm",
            className: "gap-1.5",
            onClick: ()=>onAnswer({}),
            disabled: busy === 'answer',
            "data-testid": tid('redirect-done')
        }, busy === 'answer' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
            size: 13,
            color: "currentColor",
            label: ""
        }), t('visit.erx.redirect.done')))), signedOut && busy === 'login' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": tid('connecting'),
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
            size: 13,
            color: (0, $jTCZr.CT).accent,
            label: ""
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, null, t('visit.erx.connecting'))), signedOut && busy !== 'login' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": tid('signin'),
            "data-cancelled": loginCancelled ? 'true' : 'false',
            style: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                gap: '0.375rem',
                marginTop: '0.25rem'
            }
        }, (loginCancelled || !!insurer) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.8125rem',
                fontWeight: 600,
                color: (0, $jTCZr.CT).ink
            }
        }, loginCancelled ? t('visit.erx.panel.cancelledTitle') : t('visit.erx.panel.notSignedIn', {
            insurer: name
        })), loginCancelled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, null, t('visit.erx.panel.cancelledBody')), loginError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, {
            tone: "bad",
            role: "alert"
        }, loginError), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "outline",
            size: "sm",
            onClick: onPanelLogin,
            disabled: locked,
            "data-testid": tid('signin-button')
        }, t('visit.erx.panel.signIn')))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$InsurerSavedNote, {
            saved: insurerSaved
        }), nidAsked && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$PatientNidField, {
            value: nid,
            onChange: onNidChange,
            record: nidRecord,
            save: saveNidOn,
            onSaveChange: setSaveNid,
            // Not during the re-read the tenth digit itself triggers (PM-0114).
            disabled: locked && busy !== 'load'
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$NidSavedNote, {
            saved: nidSaved
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$PatientDetailsField, {
            askGender: blockers.some((b)=>b.code === $1ccba15c4d511e83$var$PATIENT_DETAIL_NEEDS.gender) || !!details.gender,
            askMobile: blockers.some((b)=>b.code === $1ccba15c4d511e83$var$PATIENT_DETAIL_NEEDS.mobile) || !!details.mobile,
            value: details,
            onGender: onGenderChange,
            onMobile: onMobileChange,
            disabled: locked
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$DetailsSavedNote, {
            saved: detailsSaved
        }), blockers.some((b)=>b.code === 'SIAM_ID_MISSING') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$SiamForm, {
            onSave: onSaveSiam,
            busy: busy === 'siam',
            error: siamError
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Blockers, {
            blockers: blockers,
            blockerText: blockerText
        }), needs.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": tid('needs')
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, {
            tone: "ink"
        }, blockers.filter((b)=>$1ccba15c4d511e83$var$LOGIN_NEEDS.has(b.code)).map((b)=>blockerText(b)).join(' '), ' ', t('visit.erx.askedAtLogin'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "aria-live": "polite"
        }, result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": tid('result'),
            "data-result": result.state
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$SubmissionProblem, {
            result: result,
            msgText: msgText
        })), sendingElsewhere && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": tid('sending-elsewhere'),
            style: {
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: '0.5rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, null, t('visit.erx.sendingElsewhere')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "outline",
            size: "sm",
            className: "gap-1.5",
            onClick: onRecheck,
            disabled: busy === 'load',
            "data-testid": tid('recheck')
        }, busy === 'load' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
            size: 13,
            color: "currentColor",
            label: ""
        }), t('visit.erx.recheck')))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$SelectableLines, {
            lines: lines,
            unticked: unticked,
            onToggle: toggleLine,
            onToggleGroup: toggleGroup,
            reasonText: reasonText,
            describeLine: describeLine,
            disabled: locked
        }), preview.draftOnly && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, null, t('visit.erx.draftNote')), correctionSection('send'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": tid('footer'),
            style: {
                position: 'sticky',
                bottom: 0,
                zIndex: 1,
                marginTop: 'auto',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
                gap: '0.75rem',
                padding: '0.75rem 0',
                background: (0, $jTCZr.CT).surface,
                borderTop: `1px solid ${(0, $jTCZr.C).border}`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "data-testid": tid('selected-count'),
            "data-count": selectedCount,
            style: {
                fontSize: '0.8125rem',
                color: (0, $jTCZr.CT).ink2
            }
        }, t('visit.erx.panel.selectedCount', {
            count: selectedCount
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "default",
            onClick: onSend,
            disabled: sendDisabled,
            className: "gap-1.5",
            "data-testid": tid('send')
        }, sending ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
            size: 13,
            color: "currentColor",
            label: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6OGKD.default), {
            size: 14,
            "aria-hidden": "true"
        }), sending ? t('visit.erx.sending') : t('visit.erx.panel.send', {
            insurer: name || t('visit.erx.insurerLabel')
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$ErxLoginDialog, {
            open: modalOpen,
            step: modalStep,
            insurer: insurer,
            insurerName: name,
            nameOf: insurerName,
            known: recordKnown,
            offered: offered,
            onPick: onPickInsurer,
            showSave: !preview.patientInsurer,
            save: saveInsurer,
            onSaveChange: setSaveInsurer,
            unsupportedRecord: preview.patientInsurer && !recordKnown ? insurerName(preview.patientInsurer) : null,
            needs: needs,
            otpSentTo: session?.otpSentTo,
            captchaImage: session?.captchaImage,
            busy: busy === 'login' || busy === 'answer',
            error: modalStep === 'login' ? loginError : challengeError,
            onLogin: onLogin,
            onAnswer: onAnswer,
            onCancel: onLoginCancel,
            onRetry: ()=>setSession({
                    state: 'NONE'
                })
        }), confirmDialog);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$CardShell, {
        tone: tone,
        state: dataState
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$CardHead, {
        subtitle: subtitle,
        badges: draftBadge
    }), showPicker && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$InsurerField, {
        insurer: insurer,
        record: preview.patientInsurer || null,
        offered: offered,
        insurerName: insurerName,
        onPick: onPickInsurer,
        save: saveInsurer,
        onSaveChange: setSaveInsurer,
        disabled: locked
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$InsurerSavedNote, {
        saved: insurerSaved
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$PatientNidField, {
        value: nid,
        onChange: onNidChange,
        record: preview.patientNationalCode || '',
        save: saveNidOn,
        onSaveChange: setSaveNid,
        // Not during the re-read the tenth digit itself triggers: disabling the
        // field the doctor is typing into drops its focus, and on a phone the
        // keyboard goes with it (PM-0114). A send still locks it.
        disabled: locked && busy !== 'load'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$NidSavedNote, {
        saved: nidSaved
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$PatientDetailsField, {
        askGender: blockers.some((b)=>b.code === $1ccba15c4d511e83$var$PATIENT_DETAIL_NEEDS.gender) || !!details.gender,
        askMobile: blockers.some((b)=>b.code === $1ccba15c4d511e83$var$PATIENT_DETAIL_NEEDS.mobile) || !!details.mobile,
        value: details,
        onGender: onGenderChange,
        onMobile: onMobileChange,
        disabled: locked
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$DetailsSavedNote, {
        saved: detailsSaved
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Lines, {
        lines: preview.lines,
        reasonText: reasonText,
        correctionAware: !!correction
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Blockers, {
        blockers: blockers,
        blockerText: blockerText
    }), needs.length > 0 && !loginShown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('needs'),
        style: {
            marginBottom: '0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, {
        tone: "ink"
    }, blockers.filter((b)=>$1ccba15c4d511e83$var$LOGIN_NEEDS.has(b.code)).map((b)=>blockerText(b)).join(' '), ' ', t('visit.erx.askedAtLogin'))), blockers.some((b)=>b.code === 'SIAM_ID_MISSING') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$SiamForm, {
        onSave: onSaveSiam,
        busy: busy === 'siam',
        error: siamError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-live": "polite"
    }, result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('result'),
        "data-result": result.state,
        style: {
            marginBottom: '0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$SubmissionProblem, {
        result: result,
        msgText: msgText
    })), wants !== 'correct' && sessionSteps(loginShown), !loginShown && !$1ccba15c4d511e83$var$CHALLENGE.includes(sessionState) && sessionState !== 'RATE_LIMITED' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, sessionState === 'ACTIVE' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            marginBottom: '0.5rem',
            fontSize: '0.65625rem',
            color: (0, $jTCZr.CT).good
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
        size: 12,
        "aria-hidden": "true"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, session?.expiresAt ? t('visit.erx.loggedInUntil', {
        insurer: name,
        time: formatTime(session.expiresAt)
    }) : t('visit.erx.loggedIn', {
        insurer: name
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onLogout,
        disabled: locked,
        "data-testid": tid('logout'),
        style: {
            marginInlineStart: 'auto',
            background: 'none',
            border: 0,
            padding: 0,
            cursor: 'pointer',
            color: (0, $jTCZr.CT).mute,
            fontSize: '0.625rem',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.25rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0hzSL.default), {
        size: 11,
        "aria-hidden": "true"
    }), " ", t('visit.erx.logout'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$EligibilityLine, {
        value: eligibility,
        insurerName: name
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "default",
        size: "sm",
        onClick: onSend,
        disabled: !canSend || !insurer || locked || nid.length > 0 && !$1ccba15c4d511e83$var$isValidNationalCode(nid) || eligibilityBlocks,
        className: "gap-1.5",
        "data-testid": tid('send')
    }, sending ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 13,
        color: "currentColor",
        label: ""
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6OGKD.default), {
        size: 13,
        "aria-hidden": "true"
    }), sending ? t('visit.erx.sending') : result ? t('visit.erx.sendAgain') : t('visit.erx.send', {
        insurer: name || t('visit.erx.insurerLabel')
    })), sendingElsewhere && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('sending-elsewhere'),
        style: {
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: '0.5rem',
            marginTop: '0.375rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, null, t('visit.erx.sendingElsewhere')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "sm",
        className: "gap-1.5",
        onClick: onRecheck,
        disabled: busy === 'load',
        "data-testid": tid('recheck')
    }, busy === 'load' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 13,
        color: "currentColor",
        label: ""
    }), t('visit.erx.recheck'))), preview.draftOnly && canSend && !sendingElsewhere && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ccba15c4d511e83$var$Note, null, t('visit.erx.draftNote')))), correctionSection('send'), confirmDialog);
}

});
parcelRegister("42KYO", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce8c437c319961cc$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $ce8c437c319961cc$export$a2387ed3b5d536eb = {
    name: "arrow-left",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m12 19-7-7 7-7",
                key: "1l729n"
            }
        ],
        [
            "path",
            {
                d: "M19 12H5",
                key: "x3x0zl"
            }
        ]
    ]
};
$ce8c437c319961cc$export$a2387ed3b5d536eb.node;
const $ce8c437c319961cc$export$2e2bcd8739ae039 = (0, $9QBug.default)($ce8c437c319961cc$export$a2387ed3b5d536eb);

});

parcelRegister("cxlxT", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc88d8cf02c9ed12$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $fc88d8cf02c9ed12$export$a2387ed3b5d536eb = {
    name: "external-link",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M15 3h6v6",
                key: "1q9fwt"
            }
        ],
        [
            "path",
            {
                d: "M10 14 21 3",
                key: "gplh6r"
            }
        ],
        [
            "path",
            {
                d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6",
                key: "a6xqqp"
            }
        ]
    ]
};
$fc88d8cf02c9ed12$export$a2387ed3b5d536eb.node;
const $fc88d8cf02c9ed12$export$2e2bcd8739ae039 = (0, $9QBug.default)($fc88d8cf02c9ed12$export$a2387ed3b5d536eb);

});

parcelRegister("0hzSL", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe506e7c2094458f$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $fe506e7c2094458f$export$a2387ed3b5d536eb = {
    name: "log-out",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m16 17 5-5-5-5",
                key: "1bji2h"
            }
        ],
        [
            "path",
            {
                d: "M21 12H9",
                key: "dn1m92"
            }
        ],
        [
            "path",
            {
                d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4",
                key: "1uf3rs"
            }
        ]
    ]
};
$fe506e7c2094458f$export$a2387ed3b5d536eb.node;
const $fe506e7c2094458f$export$2e2bcd8739ae039 = (0, $9QBug.default)($fe506e7c2094458f$export$a2387ed3b5d536eb);

});

parcelRegister("kx99t", function(module, exports) {

$parcel$export(module.exports, "default", () => $f12b90bce5d0156f$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $f12b90bce5d0156f$export$a2387ed3b5d536eb = {
    name: "minus",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M5 12h14",
                key: "1ays0h"
            }
        ]
    ]
};
$f12b90bce5d0156f$export$a2387ed3b5d536eb.node;
const $f12b90bce5d0156f$export$2e2bcd8739ae039 = (0, $9QBug.default)($f12b90bce5d0156f$export$a2387ed3b5d536eb);

});

parcelRegister("ctEhH", function(module, exports) {

$parcel$export(module.exports, "onTaminReturn", () => $9157711a0471cf88$export$28c940609d8f8ac7);
// تأمین's login happens on تأمین's own page, in a tab the e-prescription card
// opened. When it is done, تأمین sends that tab to the doctor app's return page
// (/erx/tamin-return), which uses this module to tell the tab still holding the
// card — so the card re-checks the session and carries on without the doctor
// having to find it and press anything.
//
// Two carriers, because either alone misses a browser: BroadcastChannel reaches
// every same-origin tab directly; a localStorage write fires a `storage` event in
// the OTHER tabs, which covers a browser without BroadcastChannel. Both are
// same-origin only, which is the point — nothing outside the doctor app can
// trigger it.
const $9157711a0471cf88$export$5b756be60bce09c4 = 'parsina-erx';
const $9157711a0471cf88$export$ca28998d10652f48 = 'parsina-erx-tamin-return';
function $9157711a0471cf88$export$f0148742d4f159a2({ ok: ok, error: error = null, state: state = null } = {}) {
    const detail = {
        type: 'tamin-return',
        ok: Boolean(ok),
        error: error,
        state: state,
        at: Date.now()
    };
    try {
        const ch = new BroadcastChannel($9157711a0471cf88$export$5b756be60bce09c4);
        ch.postMessage(detail);
        ch.close();
    } catch  {}
    try {
        localStorage.setItem($9157711a0471cf88$export$ca28998d10652f48, JSON.stringify(detail));
    } catch  {}
    return detail;
}
function $9157711a0471cf88$export$28c940609d8f8ac7(handler) {
    let ch = null;
    try {
        ch = new BroadcastChannel($9157711a0471cf88$export$5b756be60bce09c4);
        ch.onmessage = (e)=>{
            if (e?.data?.type === 'tamin-return') handler(e.data);
        };
    } catch  {
        ch = null;
    }
    const onStorage = (e)=>{
        if (e.key !== $9157711a0471cf88$export$ca28998d10652f48 || !e.newValue) return;
        try {
            const detail = JSON.parse(e.newValue);
            if (detail?.type === 'tamin-return') handler(detail);
        } catch  {}
    };
    window.addEventListener('storage', onStorage);
    return ()=>{
        window.removeEventListener('storage', onStorage);
        try {
            ch?.close();
        } catch  {}
    };
}

});

parcelRegister("eyy5H", function(module, exports) {

$parcel$export(module.exports, "rememberErxDoctorMobile", () => $a98eaf66c981176b$export$eaecd1541928a90f);
$parcel$export(module.exports, "withErxDoctorMobile", () => $a98eaf66c981176b$export$8bb7ef5c6b4bce2);

var $a83Oj = parcelRequire("a83Oj");
// ─────────────────────────────────────────────────────────────────────────────
// The doctor's OWN mobile as typed on an e-prescription login form (PM-0553).
//
// A doctor who signs in with a foreign number, or with a password, has no Iranian
// mobile on the profile, and the insurer identifies the prescriber by one. The
// login form asks for it (DOCTOR_MOBILE_MISSING), and it is never saved: the
// profile's mobile is the number the doctor signs in with (PM-0255). So the doctor
// BFF keeps nothing between calls, and every read and send that needs it —
// ePrescriptionPreview, sendEPrescription, sendEPrescriptionCorrection,
// registerVisitWithInsurer — takes it again as `doctorMobile` (doctor BFF
// 7169224). It stands in only while the profile holds none.
//
// Held HERE, in this page's memory and nowhere else — no storage of any kind — so
// the card in the visit, the one on the end-of-visit receipt and the receipt's
// «ثبت ویزیت در بیمه» all hand over what the doctor typed once, for as long as the
// insurer session they logged in to. It belongs to the account that typed it: once
// the token names someone else, it is not theirs to send.
// ─────────────────────────────────────────────────────────────────────────────
let $a98eaf66c981176b$var$typed = null;
const $a98eaf66c981176b$var$signedIn = ()=>(0, $a83Oj.parseJwt)((0, $a83Oj.getToken)() || '')?.sub || null;
function $a98eaf66c981176b$export$eaecd1541928a90f(mobile) {
    $a98eaf66c981176b$var$typed = mobile ? {
        sub: $a98eaf66c981176b$var$signedIn(),
        mobile: mobile
    } : null;
}
function $a98eaf66c981176b$export$f325cce5a7ccb4c8() {
    return $a98eaf66c981176b$var$typed && $a98eaf66c981176b$var$typed.sub === $a98eaf66c981176b$var$signedIn() ? $a98eaf66c981176b$var$typed.mobile : null;
}
const $a98eaf66c981176b$var$FIELDS = /\b(ePrescriptionPreview|sendEPrescriptionCorrection|sendEPrescription|registerVisitWithInsurer)\(/;
function $a98eaf66c981176b$export$8bb7ef5c6b4bce2(op, vars) {
    const mobile = $a98eaf66c981176b$export$f325cce5a7ccb4c8();
    const field = (op.match($a98eaf66c981176b$var$FIELDS) || [])[1];
    if (!mobile || !field) return [
        op,
        vars
    ];
    return [
        op.replace(/^(query|mutation) (\w+)\(/, '$1 $2WithDoctorMobile($doctorMobile:String,').replace(`${field}(`, `${field}(doctorMobile:$doctorMobile,`),
        {
            ...vars,
            doctorMobile: mobile
        }
    ];
}

});


parcelRegister("7MmQM", function(module, exports) {

$parcel$export(module.exports, "default", () => $f632729d4a10d2cf$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $hZDga = parcelRequire("hZDga");
parcelRequire("7sS0P");
var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $eVM84 = parcelRequire("eVM84");

var $53e47 = parcelRequire("53e47");

var $eyy5H = parcelRequire("eyy5H");
// «ثبت ویزیت در بیمه» on the end-of-visit receipt (K1, 2026-10-04). Asked once
// when the receipt opens — the visit has ended and its writes have landed — and
// again only when the doctor presses «ثبت دوباره». The BFF answers NONE for a
// doctor who has not turned it on, and then this renders nothing at all; asking
// is idempotent, so a receipt opened twice never registers a visit twice.
const $f632729d4a10d2cf$var$INK = {
    good: ()=>(0, $jTCZr.CT).goodInk,
    warn: ()=>(0, $jTCZr.CT).warnInk,
    bad: ()=>(0, $jTCZr.C).red,
    running: ()=>(0, $jTCZr.C).textSecondary
};
function $f632729d4a10d2cf$export$2e2bcd8739ae039({ appointmentId: appointmentId, patientId: patientId }) {
    const { t: t, has: has } = (0, $LNQP4.default)();
    const [answer, setAnswer] = (0, $acw62.useState)(null);
    const [failed, setFailed] = (0, $acw62.useState)(false);
    const [busy, setBusy] = (0, $acw62.useState)(false);
    const inFlight = (0, $acw62.useRef)(false);
    const alive = (0, $acw62.useRef)(true);
    const ask = (0, $acw62.useCallback)(async ()=>{
        if (inFlight.current) return;
        inFlight.current = true;
        setBusy(true);
        setFailed(false);
        setAnswer(null);
        try {
            // With the doctor's own mobile when they typed one on an e-prescription login
            // form for a profile that holds none (PM-0553) — else the visit is BLOCKED on it.
            const d = await (0, $eVM84.bffMutation)(...(0, $eyy5H.withErxDoctorMobile)((0, $53e47.REGISTER_VISIT_WITH_INSURER), {
                appointmentId: appointmentId,
                patientId: patientId
            }));
            if (!alive.current) return;
            if (d?.registerVisitWithInsurer) setAnswer(d.registerVisitWithInsurer);
            else setFailed(true);
        } catch (e) {
            if (!alive.current) return;
            // A BFF that predates the mutation: nobody can have turned the switch on
            // against it either (the «نسخه» panel reads the same schema), so there is
            // nothing to report — never «not known» on every visit of every doctor.
            if (e?.extensions?.code === 'GRAPHQL_VALIDATION_FAILED') setAnswer({
                submission: {
                    state: 'NONE'
                }
            });
            else setFailed(true);
        } finally{
            inFlight.current = false;
            if (alive.current) setBusy(false);
        }
    }, [
        appointmentId,
        patientId
    ]);
    (0, $acw62.useEffect)(()=>{
        alive.current = true;
        ask();
        return ()=>{
            alive.current = false;
        };
    }, [
        ask
    ]);
    const view = (0, $53e47.visitInsuranceView)(answer, {
        failed: failed
    });
    if (!view) return null;
    const blockerText = (b)=>has(`visit.erx.blocker.${b.code}`) ? t(`visit.erx.blocker.${b.code}`) : b.message;
    const vars = {
        insurer: view.insurer || t('visit.visitInsurance.theInsurer'),
        code: view.code || ''
    };
    let text;
    switch(view.kind){
        case 'running':
            text = t('visit.visitInsurance.running');
            break;
        case 'registered':
            text = t('visit.visitInsurance.registered', vars);
            break;
        case 'blocked':
            text = t('visit.visitInsurance.blocked', {
                reason: view.blocker ? blockerText(view.blocker) : view.message || ''
            });
            break;
        case 'session':
            text = t('visit.visitInsurance.session', vars);
            break;
        case 'rejected':
            text = t('visit.visitInsurance.rejected', {
                message: view.message || ''
            });
            break;
        case 'unknown':
            text = t('visit.visitInsurance.unknown');
            break;
        default:
            text = view.message ? t('visit.visitInsurance.failedWith', {
                message: view.message
            }) : t('visit.visitInsurance.failed');
    }
    const ink = $f632729d4a10d2cf$var$INK[view.tone]();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "status",
        "data-testid": "visit-closure-visit-insurance",
        "data-state": view.kind,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.625rem',
            flexWrap: 'wrap',
            padding: '0.5rem 0.75rem',
            borderRadius: '0.625rem',
            border: `1px solid ${(0, $jTCZr.soft)(ink, 0.25)}`,
            background: (0, $jTCZr.soft)(ink, 0.06)
        }
    }, view.kind === 'running' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 14,
        color: ink,
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: '12rem',
            fontSize: '0.8125rem',
            lineHeight: 1.7,
            color: (0, $jTCZr.CT).ink
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("b", {
        style: {
            color: ink
        }
    }, t('visit.visitInsurance.title')), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto"
    }, text), view.kind === 'registered' && view.tracking && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: (0, $jTCZr.CT).ink2
        }
    }, " \xb7 ", t('visit.erx.trackingCode'), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("b", {
        dir: "ltr",
        "data-testid": "visit-closure-visit-insurance-tracking",
        style: {
            unicodeBidi: 'isolate',
            userSelect: 'all'
        }
    }, view.tracking))), view.retry && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        size: "sm",
        variant: "outline",
        onClick: ask,
        disabled: busy,
        "data-testid": "visit-closure-visit-insurance-retry"
    }, busy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 12,
        color: "currentColor",
        label: ""
    }), t('visit.visitInsurance.retry')));
}

});
parcelRegister("53e47", function(module, exports) {

$parcel$export(module.exports, "REGISTER_VISIT_WITH_INSURER", () => $3ad824a6335eeb13$export$c3900a7eba896779);
$parcel$export(module.exports, "visitInsuranceView", () => $3ad824a6335eeb13$export$3b87c219506a389a);
// «ثبت ویزیت در بیمه» on the end-of-visit receipt (K1, 2026-10-04): the visit
// ITSELF registered with the patient's insurer once it has ended, when the doctor
// turned it on in تنظیمات → «نسخه». The doctor BFF decides everything — whether
// the switch is on, the visit's RVU3 code, the insurer, whether it is already
// registered (registerVisitWithInsurer); this file only says how each answer
// reads on the receipt.
const $3ad824a6335eeb13$export$c3900a7eba896779 = `mutation RegisterVisitWithInsurer($appointmentId:ID!,$patientId:ID!){
  registerVisitWithInsurer(appointmentId:$appointmentId,patientId:$patientId){
    visitCode{ageBand electronic code name}
    insurerLabel
    submission{state trackingCode messageCode message retryable blockers{code message fixIn}}
  }
}`;
function $3ad824a6335eeb13$export$3b87c219506a389a(answer, { failed: failed = false } = {}) {
    if (failed) return {
        tone: 'bad',
        kind: 'unknown',
        retry: true
    };
    if (!answer) return {
        tone: 'running',
        kind: 'running',
        retry: false
    };
    const s = answer.submission || {};
    const base = {
        code: answer.visitCode?.code || null,
        insurer: answer.insurerLabel || null
    };
    switch(s.state){
        case 'NONE':
            return null;
        case 'REGISTERED':
            return {
                ...base,
                tone: 'good',
                kind: 'registered',
                tracking: s.trackingCode || null,
                retry: false
            };
        case 'SENDING':
            return {
                ...base,
                tone: 'running',
                kind: 'running',
                retry: false
            };
        case 'BLOCKED':
            return {
                ...base,
                tone: 'warn',
                kind: 'blocked',
                blocker: s.blockers?.[0] || null,
                message: s.message || null,
                retry: false
            };
        case 'SESSION_REQUIRED':
            return {
                ...base,
                tone: 'warn',
                kind: 'session',
                retry: true
            };
        case 'NOT_ACCEPTED':
        case 'REJECTED':
            return {
                ...base,
                tone: 'bad',
                kind: 'rejected',
                message: s.message || null,
                retry: false
            };
        default:
            return {
                ...base,
                tone: 'bad',
                kind: 'failed',
                message: s.message || null,
                retry: s.retryable !== false
            };
    }
}

});



parcelRegister("15ERh", function(module, exports) {

$parcel$export(module.exports, "MobileErxStatusChip", () => $6f243566eab73828$export$9103f952c2bc2d33);

var $acw62 = parcelRequire("acw62");

var $huNwV = parcelRequire("huNwV");
var $6OGKD = parcelRequire("6OGKD");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
// «ارسال به بیمه» — the visit's one way into the e-prescription, and where it
// stands with the insurer, in the top bar on every tab (PM-0097).
//
// It used to be a button in the work-tab bar, on the نسخه and دستورات tabs only:
// a doctor writing the note could neither reach it nor see that a registered
// prescription had changed since. The chip is that button moved up and given
// the status to carry — erxCorrection.erxChipState decides what it says:
//
//   send        «ارسال به بیمه»            (+ «n ناقص» while lines are unfinished)
//   registered  «ارسال به بیمه · ثبت شد»   (a check, the good tone)
//   pending     «ارسال اصلاحیه (n)»        (the amber dot the old button had)
//
// The name of the control never changes — only what follows it — so the doctor
// finds the same button in every state. Open, it says how to close its panel.
// State is never colour alone: each has its own words and its own glyph.
const $6f243566eab73828$var$TONE = {
    idle: {
        border: (0, $jTCZr.CT).accent,
        background: (0, $jTCZr.CT).surface,
        color: (0, $jTCZr.CT).accentInk
    },
    muted: {
        border: (0, $jTCZr.C).border,
        background: (0, $jTCZr.CT).surface2,
        color: (0, $jTCZr.CT).ink2
    },
    good: {
        border: (0, $jTCZr.CT).good,
        background: (0, $jTCZr.CT).goodSoft,
        color: (0, $jTCZr.CT).goodInk
    },
    warn: {
        border: (0, $jTCZr.CT).warn,
        background: (0, $jTCZr.CT).warnSoft,
        color: (0, $jTCZr.CT).warnInk
    },
    open: {
        border: (0, $jTCZr.CT).accent,
        background: (0, $jTCZr.CT).accent,
        color: (0, $jTCZr.CT).surface
    }
};
function $6f243566eab73828$export$7ae4019f15d7dc12(state) {
    const { t: t } = (0, $LNQP4.default)();
    const kind = state?.kind || 'send';
    const label = kind === 'pending' ? t('visit.erx.correction.button', {
        count: state.pending
    }) : t('visit.erx.inVisit.open');
    let sub = null;
    if (kind === 'registered') sub = state.part && state.part !== 'ALL' ? t(`visit.erx.chip.registered${state.part}`) : t('visit.erx.chip.registered');
    else if (kind === 'send' && state?.incomplete > 0) sub = t('visit.erx.chip.incomplete', {
        count: state.incomplete
    });
    return {
        kind: kind,
        label: label,
        sub: sub
    };
}
const $6f243566eab73828$var$Glyph = ({ kind: kind, size: size })=>kind === 'registered' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
        size: size,
        "aria-hidden": "true"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6OGKD.default), {
        size: size,
        "aria-hidden": "true"
    });
const $6f243566eab73828$var$PendingDot = ({ testid: testid })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": "true",
        "data-testid": `${testid}-pending`,
        style: {
            width: 7,
            height: 7,
            borderRadius: '50%',
            background: (0, $jTCZr.CT).warn,
            flexShrink: 0
        }
    });
function $6f243566eab73828$export$2e2bcd8739ae039({ state: state, open: open = false, onClick: onClick, testid: testid = 'visit-erx-open' }) {
    const { t: t } = (0, $LNQP4.default)();
    const { kind: kind, label: label, sub: sub } = $6f243566eab73828$export$7ae4019f15d7dc12(state);
    const tone = $6f243566eab73828$var$TONE[open ? 'open' : state?.tone || 'idle'] || $6f243566eab73828$var$TONE.idle;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onClick,
        "aria-expanded": open,
        "data-testid": testid,
        "data-state": kind,
        "data-pending": state?.pending || undefined,
        title: t('visit.erx.inVisit.bothHint'),
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6,
            flexShrink: 0,
            padding: '5px 12px',
            borderRadius: 999,
            cursor: 'pointer',
            fontFamily: 'inherit',
            fontSize: '0.75rem',
            fontWeight: 700,
            lineHeight: 1.6,
            whiteSpace: 'nowrap',
            border: `1px solid ${tone.border}`,
            background: tone.background,
            color: tone.color
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($6f243566eab73828$var$Glyph, {
        kind: open ? 'send' : kind,
        size: 13
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, open ? t('visit.erx.inVisit.close') : label), !open && sub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": `${testid}-sub`,
        style: {
            fontWeight: 600
        }
    }, "\xb7 ", sub), kind === 'pending' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($6f243566eab73828$var$PendingDot, {
        testid: testid
    }));
}
function $6f243566eab73828$export$9103f952c2bc2d33({ state: state, onClick: onClick, testid: testid = 'visit-erx-open' }) {
    const { t: t } = (0, $LNQP4.default)();
    const { kind: kind, label: label, sub: sub } = $6f243566eab73828$export$7ae4019f15d7dc12(state);
    const tone = $6f243566eab73828$var$TONE[state?.tone || 'idle'] || $6f243566eab73828$var$TONE.idle;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "lg",
        onClick: onClick,
        "aria-haspopup": "dialog",
        "aria-label": sub ? `${label} \u{2014} ${sub}` : label,
        "data-testid": testid,
        "data-state": kind,
        "data-pending": state?.pending || undefined,
        className: "shrink-0 h-11 min-h-11 gap-1.5 px-3",
        style: {
            borderColor: tone.border,
            background: tone.background,
            color: tone.color
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($6f243566eab73828$var$Glyph, {
        kind: kind,
        size: 16
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, t('visit.erx.chip.short')), kind === 'pending' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($6f243566eab73828$var$PendingDot, {
        testid: testid
    }));
}

});

parcelRegister("7ZSin", function(module, exports) {

$parcel$export(module.exports, "useErxStatus", () => $5d2858db85b3973f$export$2eef96f829c6b514);

var $acw62 = parcelRequire("acw62");

var $eVM84 = parcelRequire("eVM84");

var $6xvbB = parcelRequire("6xvbB");
function $5d2858db85b3973f$export$2eef96f829c6b514({ appointmentId: appointmentId, patientId: patientId, prepare: prepare, active: active = true }) {
    const [status, setStatus] = (0, $acw62.useState)(null);
    const seq = (0, $acw62.useRef)(0);
    const prepareRef = (0, $acw62.useRef)(prepare);
    prepareRef.current = prepare;
    const reload = (0, $acw62.useCallback)(async ()=>{
        if (!appointmentId || !patientId) return;
        const mine = ++seq.current;
        try {
            if (prepareRef.current) try {
                await prepareRef.current();
            } catch (e) {
                console.warn('[erx-status] could not settle the record first:', e?.message);
            }
            const d = await (0, $eVM84.bffQuery)((0, $6xvbB.ERX_STATUS), {
                appointmentId: appointmentId,
                patientId: patientId
            });
            if (mine === seq.current) setStatus(d?.ePrescriptionStatus || null);
        } catch  {
            if (mine === seq.current) setStatus(null);
        }
    }, [
        appointmentId,
        patientId
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!active || !appointmentId || !patientId) {
            seq.current += 1; // an answer still on its way no longer applies
            setStatus(null);
            return;
        }
        reload();
    }, [
        active,
        appointmentId,
        patientId,
        reload
    ]);
    return {
        status: status,
        reload: reload
    };
}
var $5d2858db85b3973f$export$2e2bcd8739ae039 = $5d2858db85b3973f$export$2eef96f829c6b514;

});

parcelRegister("gRy9t", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a32a09d8f6c45ba$export$2e2bcd8739ae039);

var $7xg4g = parcelRequire("7xg4g");
function $3a32a09d8f6c45ba$export$2e2bcd8739ae039({ patientId: patientId, onChange: onChange }) {
    (0, $7xg4g.useRealtimeEvents)((evt)=>{
        const type = String(evt?.type || '');
        if (!type.startsWith('clinical_file.')) return;
        if (patientId && evt.patient_id && String(evt.patient_id) !== String(patientId)) return;
        onChange?.();
    });
    return null;
}

});
parcelRegister("7xg4g", function(module, exports) {

$parcel$export(module.exports, "useRealtimeEvents", () => $57c81437ed051aa9$export$30a0463a44a8ca67);

var $acw62 = parcelRequire("acw62");

var $a83Oj = parcelRequire("a83Oj");

var $k9wwH = parcelRequire("k9wwH");
// Subscribe to the doctor's realtime event stream (`/ws/events` on the BFF). Every
// scheduling change the desk makes off this screen — arrival, in-visit, reorder,
// complete/cancel — arrives here; the caller reacts by refetching. The payload only
// says *something changed*, so `onEvent` is a plain "refresh" trigger.
//
// Mirrors the transcription WS auth (token in query, refresh-if-expired) and adds
// what a long-lived socket needs the one-shot transcription socket doesn't:
// exponential-backoff reconnect and an immediate reconnect when the tab is refocused.
const $57c81437ed051aa9$var$RECONNECT_MIN_MS = 2000;
const $57c81437ed051aa9$var$RECONNECT_MAX_MS = 30000;
function $57c81437ed051aa9$export$30a0463a44a8ca67(onEvent) {
    const [connected, setConnected] = (0, $acw62.useState)(false);
    const onEventRef = (0, $acw62.useRef)(onEvent);
    onEventRef.current = onEvent;
    (0, $acw62.useEffect)(()=>{
        let stopped = false;
        let ws = null;
        let backoff = $57c81437ed051aa9$var$RECONNECT_MIN_MS;
        let reconnectTimer = null;
        const scheduleReconnect = ()=>{
            if (stopped) return;
            clearTimeout(reconnectTimer);
            const delay = backoff;
            backoff = Math.min(backoff * 2, $57c81437ed051aa9$var$RECONNECT_MAX_MS);
            reconnectTimer = setTimeout(connect, delay);
        };
        async function connect() {
            if (stopped) return;
            // Don't hold a socket open for a backgrounded tab — reconnect on refocus.
            if (typeof document !== 'undefined' && document.visibilityState === 'hidden') return;
            let token = (0, $a83Oj.getToken)();
            if (!token || (0, $a83Oj.isTokenExpired)(token)) {
                const ok = await (0, $a83Oj.refreshAccessToken)();
                if (!ok || stopped) {
                    if (!stopped) scheduleReconnect();
                    return;
                }
                token = (0, $a83Oj.getToken)();
            }
            if (!token) {
                scheduleReconnect();
                return;
            }
            try {
                ws = new WebSocket(`${(0, $k9wwH.bffWsBase)()}/ws/events?token=${encodeURIComponent(token)}`);
            } catch  {
                scheduleReconnect();
                return;
            }
            ws.onopen = ()=>{
                backoff = $57c81437ed051aa9$var$RECONNECT_MIN_MS;
                setConnected(true);
            };
            ws.onmessage = (e)=>{
                try {
                    const msg = JSON.parse(e.data);
                    if (msg?.type === 'connected') return; // handshake ack, not a change
                    onEventRef.current?.(msg);
                } catch  {}
            };
            ws.onclose = ()=>{
                setConnected(false);
                if (!stopped) scheduleReconnect();
            };
            ws.onerror = ()=>{
                try {
                    ws.close();
                } catch  {}
            };
        }
        const onVisibility = ()=>{
            if (document.visibilityState !== 'visible') return;
            // Back on the tab: if the socket died while hidden, reconnect now (not after
            // the current backoff), so پذیرش is fresh the instant it's looked at.
            if (!ws || ws.readyState > WebSocket.OPEN) {
                backoff = $57c81437ed051aa9$var$RECONNECT_MIN_MS;
                clearTimeout(reconnectTimer);
                connect();
            }
        };
        if (typeof document !== 'undefined') document.addEventListener('visibilitychange', onVisibility);
        connect();
        return ()=>{
            stopped = true;
            clearTimeout(reconnectTimer);
            if (typeof document !== 'undefined') document.removeEventListener('visibilitychange', onVisibility);
            try {
                ws?.close();
            } catch  {}
            ws = null;
        };
    }, []);
    return {
        connected: connected
    };
}

});


parcelRegister("0xK7i", function(module, exports) {

$parcel$export(module.exports, "useClinicalFiles", () => $489287129a199b1d$export$513d4933d99292ab);

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $cjPik = parcelRequire("cjPik");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
parcelRequire("fkEOT");
var $k27hS = parcelRequire("k27hS");

var $7LBYc = parcelRequire("7LBYc");

var $eVM84 = parcelRequire("eVM84");

var $j7Lry = parcelRequire("j7Lry");

var $3VOBa = parcelRequire("3VOBa");

var $kUfDD = parcelRequire("kUfDD");

var $aXEQq = parcelRequire("aXEQq");

var $a8TVX = parcelRequire("a8TVX");

var $gQlnS = parcelRequire("gQlnS");

var $cTsk0 = parcelRequire("cTsk0");

var $zi6VT = parcelRequire("zi6VT");

var $dJNjA = parcelRequire("dJNjA");
// «مدارک بیمار» — every overlay a document can open, owned in ONE place.
// docs/DOCTOR_PATIENT_FILES_AND_AI_EXTRACTION_DESIGN.md §7, §8.
//
// The Visit page's record section, its full-list sheet, the patient record's «فایل‌ها»
// tab and both phone reductions all call the same four verbs — open, upload, extract,
// download, delete — and render the same `overlays`. That is what keeps the flows
// identical wherever the doctor meets a document, and it is what enforces the overlay
// law structurally: only one of detail / upload / review is ever open, and the review
// hands back to the detail it came from (DESIGN_CONCEPT §5.2 — no stacking except a
// confirm).
// A document can answer any lab or imaging request that was PLACED at a visit —
// pending, in progress or already performed (the result often arrives after the
// service is marked done). A cancelled request collects nothing.
const $489287129a199b1d$var$RESULT_ORDER_TYPES = [
    'lab',
    'imaging',
    'radiology'
];
// What an overlay opened FROM the gallery or the detail drawer hands back to when it
// closes: the doctor returns to the document they were looking at, never to the page
// (PM-0560 — no open, close, open again). A drawer is handed back read-only.
const $489287129a199b1d$var$backTo = (current)=>current?.type === 'gallery' || current?.type === 'detail' ? {
        ...current,
        edit: false
    } : null;
const $489287129a199b1d$var$isResultOrder = (o)=>$489287129a199b1d$var$RESULT_ORDER_TYPES.some((k)=>String(o?.orderType || '').toLowerCase().includes(k)) && String(o?.status || '').toLowerCase() !== 'cancelled';
function $489287129a199b1d$export$513d4933d99292ab({ patient: patient, files: files = [], appointmentId: appointmentId = null, clinicNameOf: clinicNameOf, onChanged: onChanged, onAddToVisitPrescription: onAddToVisitPrescription = null }) {
    const { t: t, has: has, formatDigits: formatDigits } = (0, $LNQP4.default)();
    const { isMobile: isMobile } = (0, $k27hS.default)();
    const toast = (0, $7LBYc.useOptionalToast)();
    const patientId = patient?.id || null;
    const [overlay, setOverlay] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [confirm, setConfirm] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // { type: 'delete' | 'largeDownload', file }
    const [busy, setBusy] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [orders, setOrders] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [ordersLoading, setOrdersLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // The requests a result can answer — read when a surface that links to one opens.
    const loadOrders = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        if (!patientId) return;
        setOrdersLoading(true);
        (0, $eVM84.bffQuery)((0, $j7Lry.LIST_RESULT_ORDERS), {
            patientId: patientId
        }).then((d)=>setOrders((d?.listDoctorOrders || []).filter($489287129a199b1d$var$isResultOrder))).catch(()=>setOrders([])).finally(()=>setOrdersLoading(false));
    }, [
        patientId
    ]);
    const visits = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(patient?.encounters || []).filter((e)=>e?.id).slice().sort((a, b)=>String(b.scheduledDate || '').localeCompare(String(a.scheduledDate || ''))), [
        patient?.encounters
    ]);
    // The overlay holds the file it was opened on; the list is re-read after every
    // change, so the drawer always shows the row as it is now.
    const fresh = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((f)=>f ? files.find((x)=>x.id === f.id && (x._source || 'clinical') === (f._source || 'clinical')) || f : f, [
        files
    ]);
    const openDetail = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((file, { edit: edit = false } = {})=>{
        loadOrders();
        setOverlay((current)=>({
                type: 'detail',
                file: file,
                edit: edit,
                returnTo: current?.type === 'gallery' ? current : null
            }));
    }, [
        loadOrders
    ]);
    // «گالری مدارک» — every document of `list` (the host's order and filter; the whole
    // library when omitted) in one viewer, starting at `file`.
    const openGallery = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((file, list = null)=>{
        setOverlay({
            type: 'gallery',
            file: file,
            list: list ? list.map((0, $zi6VT.fileKey)) : null
        });
    }, []);
    const openUpload = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((preset = {})=>{
        loadOrders();
        setOverlay({
            type: 'upload',
            preset: {
                appointmentId: appointmentId || null,
                ...preset
            }
        });
    }, [
        loadOrders,
        appointmentId
    ]);
    const openExtract = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((file, { mode: mode, run: run } = {})=>{
        setOverlay((current)=>({
                type: 'extract',
                file: file,
                mode: mode,
                run: run,
                returnTo: $489287129a199b1d$var$backTo(current)
            }));
    }, []);
    // A DICOM study's images: the diagnostic viewer on a workstation, the server-rendered
    // preview on a phone (R-C6). Like the review, it replaces the drawer it came from.
    const openViewer = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((file)=>{
        setOverlay((current)=>({
                type: isMobile ? 'rendered' : 'viewer',
                file: file,
                returnTo: $489287129a199b1d$var$backTo(current)
            }));
    }, [
        isMobile
    ]);
    const [confirming, setConfirming] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // «تأیید تعلق به این بیمار» — the doctor read both identities and says the study is
    // this patient's; the warning clears for everyone who opens it after.
    const confirmIdentity = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (file)=>{
        setConfirming(true);
        try {
            await (0, $eVM84.bffMutation)((0, $j7Lry.CONFIRM_DICOM_PATIENT_MATCH), {
                fileId: file.id
            });
            toast.success?.(t('patient.files.dicom.identity.confirmed'));
            onChanged?.();
        } catch (e) {
            toast.error?.((0, $3VOBa.fileErrorText)(t, has, e, 'patient.files.dicom.identity.confirmFailed'));
        } finally{
            setConfirming(false);
        }
    }, [
        onChanged,
        toast,
        t,
        has
    ]);
    const doDownload = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (file)=>{
        setConfirm(null);
        try {
            if (file._source === 'storage') {
                const d = await (0, $eVM84.bffQuery)((0, $j7Lry.STORAGE_LAB_FILE_URL), {
                    id: file.id
                });
                const parts = (0, $3VOBa.splitDataUri)(d?.storageLabFileUrl);
                if (!parts) throw new Error('empty');
                (0, $3VOBa.saveBlob)((0, $3VOBa.base64ToBlob)(parts.data, parts.contentType), file.fileName);
            } else {
                const d = await (0, $eVM84.bffQuery)((0, $j7Lry.CLINICAL_FILE_DOWNLOAD), {
                    fileId: file.id
                });
                const x = d?.clinicalFileDownload;
                if (!x?.data) throw new Error('empty');
                (0, $3VOBa.saveBlob)((0, $3VOBa.base64ToBlob)(x.data, x.contentType), x.fileName);
            }
        } catch (e) {
            toast.error?.((0, $3VOBa.fileErrorText)(t, has, e, 'patient.files.download.failed'));
        }
    }, [
        toast,
        t,
        has
    ]);
    const download = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((file)=>{
        if ((file?.fileSize || 0) > (0, $3VOBa.LARGE_DOWNLOAD_BYTES)) setConfirm({
            type: 'largeDownload',
            file: file
        });
        else doDownload(file);
    }, [
        doDownload
    ]);
    const requestDelete = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((file)=>setConfirm({
            type: 'delete',
            file: file
        }), []);
    const doDelete = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (file)=>{
        setBusy(true);
        try {
            if (file._source === 'storage') await (0, $eVM84.bffMutation)((0, $j7Lry.DELETE_STORAGE_LAB_FILE), {
                id: file.id
            });
            else await (0, $eVM84.bffMutation)((0, $j7Lry.DELETE_CLINICAL_FILE), {
                fileId: file.id
            });
            setConfirm(null);
            // From the gallery the doctor stays in it, on the neighbouring document.
            setOverlay((current)=>{
                if (current?.type === 'gallery') return current;
                if (current?.returnTo?.type === 'gallery') return current.returnTo;
                return null;
            });
            // A deleted row leaves a list the doctor may have scrolled away from, so the
            // success is said out loud (DESIGN_CONCEPT §2.4).
            toast.success?.(t('patient.files.deletion.done'));
            onChanged?.();
        } catch (e) {
            setConfirm(null);
            toast.error?.((0, $3VOBa.fileErrorText)(t, has, e, 'patient.files.deletion.failed'));
        } finally{
            setBusy(false);
        }
    }, [
        onChanged,
        toast,
        t,
        has
    ]);
    const clinicName = (file)=>clinicNameOf && file?.clinicId ? clinicNameOf(file.clinicId) : null;
    // The gallery's list, re-read from `files` on every render so an edit, an
    // extraction or a delete shows at once; a file that left the list drops out.
    const galleryFiles = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (overlay?.type !== 'gallery') return [];
        if (!overlay.list) return files;
        const byKey = new Map(files.map((f)=>[
                (0, $zi6VT.fileKey)(f),
                f
            ]));
        return overlay.list.map((k)=>byKey.get(k)).filter(Boolean);
    }, [
        overlay,
        files
    ]);
    const overlays = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, overlay?.type === 'detail' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kUfDD.default), {
        open: true,
        file: fresh(overlay.file),
        startEditing: Boolean(overlay.edit),
        patientId: patientId,
        visits: visits,
        orders: orders,
        ordersLoading: ordersLoading,
        clinicName: clinicName(overlay.file),
        isMobile: isMobile,
        onClose: ()=>setOverlay(overlay.returnTo || null),
        onExtract: (f)=>openExtract(f),
        onReview: (f, run)=>openExtract(f, {
                run: run
            }),
        onView: openViewer,
        onConfirmIdentity: confirmIdentity,
        confirming: confirming,
        patient: patient,
        onDownload: download,
        onDelete: requestDelete,
        onSaved: ()=>onChanged?.()
    }), overlay?.type === 'gallery' && isMobile && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dJNjA.default), {
        open: true,
        files: galleryFiles,
        current: fresh(overlay.file),
        onSelect: (f)=>setOverlay((o)=>o?.type === 'gallery' ? {
                    ...o,
                    file: f
                } : o),
        onClose: ()=>setOverlay(null),
        onDetail: (f)=>openDetail(f),
        onView: openViewer,
        onExtract: (f)=>openExtract(f),
        onDownload: download,
        onDelete: requestDelete
    }), overlay?.type === 'gallery' && !isMobile && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $zi6VT.default), {
        open: true,
        files: galleryFiles,
        current: fresh(overlay.file),
        isMobile: isMobile,
        onSelect: (f)=>setOverlay((o)=>o?.type === 'gallery' ? {
                    ...o,
                    file: f
                } : o),
        onClose: ()=>setOverlay(null),
        onDetail: (f)=>openDetail(f),
        onView: openViewer,
        onExtract: (f)=>openExtract(f),
        onDownload: download,
        onDelete: requestDelete,
        clinicNameOf: clinicNameOf
    }), overlay?.type === 'viewer' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gQlnS.default), {
        open: true,
        file: fresh(overlay.file),
        patient: patient,
        onConfirmIdentity: ()=>confirmIdentity(fresh(overlay.file)),
        confirming: confirming,
        onClose: ()=>setOverlay(overlay.returnTo || null)
    }), overlay?.type === 'rendered' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cTsk0.default), {
        open: true,
        file: fresh(overlay.file),
        patient: patient,
        onClose: ()=>setOverlay(overlay.returnTo || null)
    }), overlay?.type === 'upload' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aXEQq.default), {
        open: true,
        patientId: patientId,
        patient: patient,
        preset: overlay.preset,
        visits: visits,
        orders: orders,
        ordersLoading: ordersLoading,
        onClose: ()=>setOverlay(null),
        onUploaded: (stored, { extract: extract, partial: partial } = {})=>{
            onChanged?.();
            if (partial) return;
            if (extract && stored[0]) setOverlay({
                type: 'extract',
                file: stored[0],
                returnTo: null
            });
            else setOverlay(null);
        }
    }), overlay?.type === 'extract' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a8TVX.default), {
        open: true,
        file: fresh(overlay.file),
        patientId: patientId,
        appointmentId: appointmentId,
        initialRun: overlay.run || null,
        initialMode: overlay.mode,
        // A run changed the file's processing status whether or not anything is saved.
        onRan: ()=>onChanged?.(),
        onSaved: ()=>onChanged?.(),
        onAddToVisitPrescription: onAddToVisitPrescription,
        // «رفتن به نسخه ویزیت» leaves for the page's drug form, so nothing is handed
        // back to — the drawer it came from would cover the form it is going to.
        onClose: (opts)=>setOverlay(opts?.toVisitPrescription ? null : overlay.returnTo || null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cjPik.default), {
        open: confirm?.type === 'delete',
        onOpenChange: (o)=>{
            if (!o && !busy) setConfirm(null);
        },
        title: t('patient.files.deletion.confirm', {
            name: confirm?.file?.fileName || ''
        }),
        description: t('patient.files.deletion.keeps'),
        confirmLabel: t('patient.files.deletion.confirmLabel'),
        cancelLabel: t('common.actions.cancel'),
        destructive: true,
        loading: busy,
        onConfirm: ()=>doDelete(confirm.file),
        confirmTestId: "file-delete-confirm"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cjPik.default), {
        open: confirm?.type === 'largeDownload',
        onOpenChange: (o)=>{
            if (!o) setConfirm(null);
        },
        title: t('patient.files.download.largeTitle'),
        description: t('patient.files.download.largeMessage', {
            mb: formatDigits((0, $3VOBa.megabytes)(confirm?.file?.fileSize))
        }),
        confirmLabel: t('patient.files.actions.download'),
        cancelLabel: t('common.actions.cancel'),
        onConfirm: ()=>doDownload(confirm.file)
    }));
    return {
        openDetail: openDetail,
        openGallery: openGallery,
        openUpload: openUpload,
        openExtract: openExtract,
        openViewer: openViewer,
        confirmIdentity: confirmIdentity,
        download: download,
        requestDelete: requestDelete,
        overlays: overlays,
        visits: visits
    };
}
var $489287129a199b1d$export$2e2bcd8739ae039 = $489287129a199b1d$export$513d4933d99292ab;

});
parcelRegister("kUfDD", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f567419dd4447b1$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $cZOyb = parcelRequire("cZOyb");
var $aJ1FU = parcelRequire("aJ1FU");
var $cjPik = parcelRequire("cjPik");
var $beZBx = parcelRequire("beZBx");
var $7phmx = parcelRequire("7phmx");
var $4Qco3 = parcelRequire("4Qco3");
var $fAR2n = parcelRequire("fAR2n");
var $66joL = parcelRequire("66joL");
var $iygI2 = parcelRequire("iygI2");
var $a7Rbr = parcelRequire("a7Rbr");

var $jTCZr = parcelRequire("jTCZr");

var $2XwcZ = parcelRequire("2XwcZ");
var $2UQ3h = parcelRequire("2UQ3h");
var $aGlWN = parcelRequire("aGlWN");
var $chm1L = parcelRequire("chm1L");
var $lUsTt = parcelRequire("lUsTt");
var $6TdpC = parcelRequire("6TdpC");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $eVM84 = parcelRequire("eVM84");

var $j7Lry = parcelRequire("j7Lry");

var $7sS0P = parcelRequire("7sS0P");

var $1yr2B = parcelRequire("1yr2B");

var $eAIjx = parcelRequire("eAIjx");

var $aMDcZ = parcelRequire("aMDcZ");

var $hRWhk = parcelRequire("hRWhk");

var $aXEQq = parcelRequire("aXEQq");

var $1Qo7B = parcelRequire("1Qo7B");

var $gdEay = parcelRequire("gdEay");

var $3VOBa = parcelRequire("3VOBa");

var $eARX3 = parcelRequire("eARX3");

var $d6Clo = parcelRequire("d6Clo");

var $cmmZD = parcelRequire("cmmZD");
/**
 * A study, in the drawer: its identity and quality warnings, a thumbnail that opens
 * the images, the §8.5 metadata and its series. What `FileViewer` is for a document.
 */ function $1f567419dd4447b1$var$StudyDetail({ file: file, patient: patient, isMobile: isMobile, onView: onView, onConfirmIdentity: onConfirmIdentity, confirming: confirming }) {
    const { t: t, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const study = file.dicom || {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "file-detail-study",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cmmZD.IdentityAlert), {
        file: file,
        patient: patient,
        onConfirm: onConfirmIdentity ? ()=>onConfirmIdentity(file) : undefined,
        confirming: confirming,
        testid: "file-detail-identity"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cmmZD.LossyAlert), {
        study: study,
        testid: "file-detail-lossy"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            borderRadius: (0, $7sS0P.RADIUS).card,
            border: `1px solid ${(0, $jTCZr.CT).border}`,
            padding: '0.625rem 0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d6Clo.default), {
        study: study,
        size: "4.5rem",
        testid: "file-detail-study-thumb"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: '0.375rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'flex',
            gap: '0.25rem',
            flexWrap: 'wrap'
        }
    }, (study.modalities || []).map((m)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cmmZD.ModalityChip), {
            key: m,
            modality: m,
            testid: `file-detail-modality-${m}`
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).ink2
        },
        "data-testid": "file-detail-study-meta"
    }, (0, $cmmZD.studyMetaText)(t, formatNumber, study)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        size: "sm",
        onClick: ()=>onView?.(file),
        disabled: !study.viewable && !(isMobile && study.rendered),
        "data-testid": "file-detail-view-images"
    }, t('patient.files.dicom.viewImages'))), !study.viewable && !(isMobile && study.rendered) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.6875rem',
            color: (0, $jTCZr.CT).mute
        },
        "data-testid": "file-detail-not-viewable"
    }, t('patient.files.dicom.notViewable')))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1f567419dd4447b1$var$Section, {
        title: t('patient.files.dicom.viewer.metadata'),
        testid: "file-detail-study-metadata"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cmmZD.DicomMetadata), {
        study: study,
        testid: "file-detail-dicom-metadata"
    })), (study.series || []).length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1f567419dd4447b1$var$Section, {
        title: t('patient.files.dicom.viewer.series'),
        testid: "file-detail-series"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        style: {
            margin: 0,
            padding: 0,
            listStyle: 'none',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.25rem'
        }
    }, study.series.map((s, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: s.seriesUid || i,
            "data-testid": `file-detail-series-${i}`,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                fontSize: '0.75rem',
                color: (0, $jTCZr.CT).ink2
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cmmZD.ModalityChip), {
            modality: s.modality,
            testid: `file-detail-series-modality-${i}`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "auto",
            style: {
                flex: 1,
                minWidth: 0,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            }
        }, s.description || t('patient.files.dicom.seriesNumber', {
            number: formatNumber(s.number ?? i + 1)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                color: (0, $jTCZr.CT).mute
            }
        }, t('patient.files.dicom.imageCount', {
            count: formatNumber(s.frames || s.instances || 0)
        })))))));
}
// «فایل» — one document: see it, read what was extracted from it, correct what it is,
// download or delete it, or have it read by AI.
// docs/DOCTOR_PATIENT_FILES_AND_AI_EXTRACTION_DESIGN.md §7.4–§7.6, §8.3.
//
// The kit `Drawer` at the inline-end on a workstation, a full-height `BottomSheet` on a
// phone (DESIGN_SYSTEM §8). It replaces the hand-rolled `AnalysisDrawer` (design F16).
//
// It is one of the overlays `useClinicalFiles` owns, and only one of those is ever
// open: the extraction review REPLACES this drawer and hands back to it on close, so
// nothing stacks except a confirm (DESIGN_CONCEPT §5.2).
const $1f567419dd4447b1$var$DRAWER_WIDTH = 560;
function $1f567419dd4447b1$var$Section({ title: title, children: children, testid: testid, action: action }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
        "data-testid": testid,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h3", {
        style: {
            margin: 0,
            fontSize: '0.75rem',
            fontWeight: 700,
            color: (0, $jTCZr.CT).mute,
            flex: 1
        }
    }, title), action), children);
}
/** The values or the report text the record already holds from this file. */ function $1f567419dd4447b1$var$RecordedContent({ file: file }) {
    const { t: t, formatDigits: formatDigits } = (0, $LNQP4.default)();
    const rows = (0, $gdEay.parseOcrRows)(file.ocrContent);
    if (!file.ocrContent) return null;
    if (!(0, $gdEay.hasStructuredRows)(rows)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: "auto",
        "data-testid": "file-detail-report-text",
        style: {
            borderRadius: (0, $7sS0P.RADIUS).control,
            border: `1px solid ${(0, $jTCZr.CT).border}`,
            background: (0, $jTCZr.CT).surface2,
            padding: '0.625rem 0.75rem',
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).ink2,
            lineHeight: 1.9,
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word'
        }
    }, file.ocrContent);
    const th = {
        padding: '0.375rem 0.5rem',
        textAlign: 'start',
        fontWeight: 600,
        color: (0, $jTCZr.CT).mute,
        borderBottom: `1px solid ${(0, $jTCZr.CT).border}`,
        background: (0, $jTCZr.CT).surface2
    };
    const td = {
        padding: '0.3125rem 0.5rem',
        borderBottom: `1px solid ${(0, $jTCZr.CT).border}`,
        color: (0, $jTCZr.CT).ink2
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            borderRadius: (0, $7sS0P.RADIUS).control,
            border: `1px solid ${(0, $jTCZr.CT).border}`,
            overflowX: 'auto'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("table", {
        "data-testid": "file-detail-values",
        style: {
            width: '100%',
            borderCollapse: 'collapse',
            fontSize: '0.71875rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        style: th,
        scope: "col"
    }, t('patient.files.extract.test')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        style: {
            ...th,
            textAlign: 'end'
        },
        scope: "col"
    }, t('patient.files.extract.value')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        style: th,
        scope: "col"
    }, t('patient.files.extract.range')))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tbody", null, rows.map((r, i)=>r.raw ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", {
            key: i
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            colSpan: 3,
            style: {
                ...td,
                color: (0, $jTCZr.CT).mute
            }
        }, r.raw)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", {
            key: i,
            style: {
                background: r.status === 'critical' ? (0, $jTCZr.CT).dangerSoft : r.status !== 'normal' && r.status !== 'unknown' ? (0, $jTCZr.CT).warnSoft : 'transparent'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: {
                ...td,
                color: (0, $jTCZr.CT).ink,
                fontWeight: 600
            },
            dir: "auto"
        }, r.testName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: {
                ...td,
                textAlign: 'end',
                fontVariantNumeric: 'tabular-nums'
            },
            dir: "ltr"
        }, formatDigits(r.value), " ", r.unit || ''), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: td,
            dir: "ltr"
        }, r.refRange || "\u2014"))))));
}
/** The newest analysis run, summarised, with the way back into its review. */ function $1f567419dd4447b1$var$LatestRun({ file: file, patientId: patientId, onReview: onReview }) {
    const { t: t, formatDate: formatDate, formatDigits: formatDigits } = (0, $LNQP4.default)();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        status: 'loading',
        run: null
    });
    const [attempt, setAttempt] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        let cancelled = false;
        setState({
            status: 'loading',
            run: null
        });
        (0, $eVM84.bffQuery)((0, $j7Lry.CLINICAL_FILE_ANALYSES), {
            patientId: patientId
        }).then((d)=>{
            if (cancelled) return;
            const row = (d?.patient?.clinicalFiles || []).find((f)=>f.id === file.id);
            setState({
                status: row?.analysis ? 'content' : 'empty',
                run: row?.analysis || null
            });
        }).catch(()=>{
            if (!cancelled) setState({
                status: 'error',
                run: null
            });
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        file.id,
        file.processedAt,
        patientId,
        attempt
    ]);
    if (state.status === 'loading') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonRegion), {
        label: t('common.state.loading'),
        "data-testid": "file-detail-run-loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonText), {
        lines: 2
    }));
    if (state.status === 'error') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "error",
        "data-testid": "file-detail-run-error",
        action: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "outline",
            size: "sm",
            onClick: ()=>setAttempt((n)=>n + 1)
        }, t('common.actions.retry'))
    }, t('patient.files.analysis.loadFailed'));
    if (!state.run) return null;
    const run = state.run;
    const isReport = run.mode === 'REPORT' || Boolean(run.report);
    const rows = run.labResults || [];
    const gist = isReport ? run.report?.sections?.find((s)=>s.key === 'impression')?.text || run.report?.fullText || run.summaryText || '' : rows.slice(0, 4).map((r)=>`${r.testName} ${r.value ?? ''}${r.unit ? ` ${r.unit}` : ''}`).join(" \xb7 ");
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "file-detail-run",
        style: {
            borderRadius: (0, $7sS0P.RADIUS).control,
            border: `1px solid ${(0, $jTCZr.CT).border}`,
            padding: '0.625rem 0.75rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.375rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            flexWrap: 'wrap',
            fontSize: '0.6875rem',
            color: (0, $jTCZr.CT).mute
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $chm1L.default), {
        size: 13,
        "aria-hidden": true,
        style: {
            color: (0, $jTCZr.CT).accentInk
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, t(isReport ? 'patient.files.extract.report' : 'patient.files.extract.lab')), run.createdAt && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, "\xb7 ", (0, $hRWhk.formatDocDate)(run.createdAt, formatDate)), run.costParseh > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, "\xb7 ", t('patient.files.extract.chargedAmount', {
        price: formatDigits(run.costParseh)
    })), !isReport && rows.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, "\xb7 ", t('patient.files.testCount', {
        count: formatDigits(rows.length)
    }))), gist && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: "auto",
        style: {
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).ink2,
            overflow: 'hidden',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical'
        }
    }, gist), run.status !== 'failed' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "sm",
        onClick: ()=>onReview(file, run),
        "data-testid": "file-detail-review"
    }, t('patient.files.extract.review'))));
}
function $1f567419dd4447b1$export$2e2bcd8739ae039({ open: open, file: file, patientId: patientId, visits: visits = [], orders: orders = [], ordersLoading: ordersLoading = false, clinicName: clinicName, isMobile: isMobile, startEditing: startEditing = false, patient: patient, onView: onView, onConfirmIdentity: onConfirmIdentity, confirming: confirming = false, onClose: onClose, onExtract: onExtract, onReview: onReview, onDownload: onDownload, onDelete: onDelete, onSaved: onSaved }) {
    const { t: t, has: has, formatDate: formatDate, formatDigits: formatDigits, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const { costOf: costOf } = (0, $1yr2B.useCreditPrices)();
    const [editing, setEditing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [draft, setDraft] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [saving, setSaving] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [saveError, setSaveError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [confirmDiscard, setConfirmDiscard] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const closeRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const initialDraft = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((f)=>({
            fileName: f?.fileName || '',
            kind: (0, $1Qo7B.canonicalKind)(f?.kind) || 'OTHER',
            documentDate: f?.documentDate || '',
            description: f?.description || '',
            appointmentId: f?.appointmentId || '',
            orderId: f?.orderId || ''
        }), []);
    // «ویرایش» from a row's menu opens the drawer already in its form.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setEditing(Boolean(startEditing && file?.canEdit));
        setDraft(initialDraft(file));
        setSaveError('');
    }, [
        file?.id,
        initialDraft,
        startEditing
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    // Focus lands inside the panel when it opens (DESIGN_CONCEPT §5.2).
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (open && !isMobile) closeRef.current?.focus?.();
    }, [
        open,
        isMobile,
        file?.id
    ]);
    const scope = file?.editScope || null;
    const curation = scope === 'curation';
    const storageOnly = file?._source === 'storage';
    const dirty = editing && draft && JSON.stringify(draft) !== JSON.stringify(initialDraft(file));
    const requestClose = ()=>{
        if (saving) return;
        if (dirty) {
            setConfirmDiscard(true);
            return;
        }
        onClose?.();
    };
    const save = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        if (!file || !draft || saving || !dirty) return;
        const before = initialDraft(file);
        const input = {};
        for (const key of Object.keys(draft)){
            if (draft[key] === before[key]) continue;
            if (curation && ![
                'kind',
                'documentDate',
                'description',
                'appointmentId'
            ].includes(key)) continue;
            input[key] = draft[key];
        }
        if (!Object.keys(input).length) {
            setEditing(false);
            return;
        }
        setSaving(true);
        setSaveError('');
        try {
            const d = await (0, $eVM84.bffMutation)((0, $j7Lry.UPDATE_CLINICAL_FILE), {
                fileId: file.id,
                input: input
            });
            setEditing(false);
            onSaved?.(d?.updateClinicalFile || null);
        } catch (e) {
            setSaveError((0, $3VOBa.fileErrorText)(t, has, e, 'patient.files.edit.failed'));
        } finally{
            setSaving(false);
        }
    }, [
        file,
        draft,
        saving,
        dirty,
        curation,
        initialDraft,
        onSaved,
        t,
        has
    ]);
    // Ctrl+S saves the open form (DESKTOP_WEB §5).
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open || !editing) return undefined;
        const onKey = (e)=>{
            if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 's') {
                e.preventDefault();
                save();
            }
        };
        window.addEventListener('keydown', onKey);
        return ()=>window.removeEventListener('keydown', onKey);
    }, [
        open,
        editing,
        save
    ]);
    if (!open || !file) return null;
    const kind = (0, $1Qo7B.canonicalKind)(file.kind);
    const Icon = (0, $hRWhk.KIND_ICON)[kind] || (0, $hRWhk.KIND_ICON).OTHER;
    const isStudy = (0, $eARX3.isDicomFile)(file);
    const studyExtractable = !isStudy || (0, $eARX3.hasDocumentObjects)(file.dicom);
    const optimized = !isStudy && file.optimization?.originalBytes > 0 && file.optimization?.storedBytes > 0 && file.optimization.storedBytes < file.optimization.originalBytes;
    const visit = visits.find((v)=>v.id === file.appointmentId);
    const docDate = (0, $gdEay.documentDateOf)(file);
    const inFlight = (0, $1Qo7B.isProcessing)(file.processingStatus);
    const price = costOf('ANALYZE_FILE');
    const set = (key)=>(value)=>setDraft((d)=>({
                    ...d,
                    [key]: value
                }));
    const kindOptions = (0, $1Qo7B.DOCUMENT_KIND_OPTIONS).map((k)=>({
            value: k.value,
            label: t(k.labelKey)
        }));
    const visitOptions = visits.map((v)=>({
            value: v.id,
            label: v.scheduledDate ? (0, $hRWhk.formatDocDate)(v.scheduledDate, formatDate) : t('patient.visit')
        }));
    const orderOptions = orders.filter((o)=>draft?.appointmentId && o.appointmentId === draft.appointmentId).map((o)=>({
            value: o.id,
            label: (0, $aXEQq.orderOptionLabel)(o, t)
        }));
    const visitLocked = curation && Boolean(file.orderId);
    const header = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.375rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: '0.625rem'
        }
    }, isStudy ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d6Clo.default), {
        study: file.dicom,
        size: "2.25rem",
        testid: "file-detail-thumb"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true,
        style: {
            width: '2.25rem',
            height: '2.25rem',
            borderRadius: (0, $7sS0P.RADIUS).control,
            background: (0, $jTCZr.CT).accentSoft,
            color: (0, $jTCZr.CT).accentInk,
            display: 'grid',
            placeItems: 'center',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        size: 18,
        strokeWidth: 1.75
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: "auto",
        "data-testid": "file-detail-name",
        style: {
            fontSize: '0.875rem',
            fontWeight: 700,
            color: (0, $jTCZr.CT).ink,
            wordBreak: 'break-word',
            unicodeBidi: 'isolate'
        }
    }, file.fileName || t('patient.files.unnamed')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: '0.25rem',
            marginTop: '0.25rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hRWhk.FileFacts), {
        file: file,
        clinicName: clinicName
    }))), !isMobile && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        ref: closeRef,
        variant: "ghost",
        size: "icon",
        className: "h-9 w-9 shrink-0",
        onClick: requestClose,
        "aria-label": t('common.actions.close'),
        "data-testid": "file-detail-close"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
        size: 16,
        "aria-hidden": true
    }))));
    const facts = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "file-detail-facts",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.25rem',
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).ink2
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, docDate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, t(file.documentDate ? 'patient.files.documentDateIs' : 'patient.files.uploadedOn', {
        date: (0, $hRWhk.formatDocDate)(docDate, formatDate)
    })), (0, $gdEay.uploadDayDiffers)(file) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: (0, $jTCZr.CT).mute
        }
    }, " \xb7 ", t('patient.files.uploadedOn', {
        date: (0, $hRWhk.formatDocDate)(file.createdAt, formatDate)
    })), !isStudy && !optimized && file.fileSize > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: (0, $jTCZr.CT).mute
        }
    }, " \xb7 ", t('patient.files.upload.size', {
        mb: formatDigits((0, $3VOBa.megabytes)(file.fileSize))
    })), optimized && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: (0, $jTCZr.CT).mute
        },
        "data-testid": "file-detail-optimized"
    }, " \xb7 ", t('patient.files.optimizedFromTo', {
        from: formatNumber((0, $3VOBa.megabytes)(file.optimization.originalBytes)),
        to: formatNumber((0, $3VOBa.megabytes)(file.optimization.storedBytes))
    })), isStudy && file.dicom?.storedBytes > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: (0, $jTCZr.CT).mute
        }
    }, " \xb7 ", (0, $3VOBa.sizeText)(t, formatNumber, file.dicom.storedBytes))), (visit || file.resolvedOrder) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.375rem',
            color: (0, $jTCZr.CT).accentInk
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2UQ3h.default), {
        size: 13,
        "aria-hidden": true
    }), visit?.scheduledDate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, t('patient.files.visitOn', {
        date: (0, $hRWhk.formatDocDate)(visit.scheduledDate, formatDate)
    })), file.resolvedOrder?.description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto"
    }, "\xb7 ", t('visit.orders.result.answersOrder'), ": ", file.resolvedOrder.description)), file.description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: "auto",
        "data-testid": "file-detail-description",
        style: {
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word'
        }
    }, file.description));
    const editForm = draft && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "file-detail-edit",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem'
        }
    }, curation && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "info"
    }, t('patient.files.edit.curationHint')), !curation && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
        label: t('patient.files.edit.fileName'),
        value: draft.fileName,
        onChange: (v)=>set('fileName')(typeof v === 'string' ? v : v?.target?.value ?? ''),
        dir: "auto",
        "data-testid": "file-edit-name"
    }), !isStudy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fAR2n.default), {
        label: t('patient.files.upload.kindLabel'),
        value: draft.kind,
        onChange: (e)=>set('kind')(e.target.value),
        options: kindOptions,
        placeholder: "",
        "data-testid": "file-edit-kind"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        label: t('patient.files.documentDate'),
        helperText: t('patient.files.upload.dateHint')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4Qco3.default), {
        value: draft.documentDate,
        onChange: set('documentDate'),
        disableFuture: true,
        placeholder: t('patient.files.upload.datePlaceholder')
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fAR2n.default), {
        label: t('patient.files.upload.linkVisit'),
        value: draft.appointmentId,
        onChange: (e)=>setDraft((d)=>({
                    ...d,
                    appointmentId: e.target.value,
                    orderId: orders.some((o)=>o.id === d.orderId && o.appointmentId === e.target.value) ? d.orderId : ''
                })),
        options: visitOptions,
        placeholder: t('patient.files.upload.noLink'),
        disabled: visitLocked,
        helperText: visitLocked ? t('patient.files.edit.visitLocked') : undefined,
        "data-testid": "file-edit-visit"
    }), !curation && draft.appointmentId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aXEQq.OrderField), {
        value: draft.orderId,
        onChange: set('orderId'),
        options: orderOptions,
        loading: ordersLoading,
        testid: "file-edit-order"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $iygI2.default), {
        label: t('patient.files.description'),
        value: draft.description,
        onChange: (e)=>set('description')(e.target.value),
        maxLength: 500,
        showCount: true,
        rows: 3,
        "data-testid": "file-edit-description"
    }), saveError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "error",
        "data-testid": "file-edit-error"
    }, saveError));
    const body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem'
        }
    }, !isMobile && header, isMobile && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, header), editing ? editForm : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, facts, isStudy ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1f567419dd4447b1$var$StudyDetail, {
        file: file,
        patient: patient,
        isMobile: isMobile,
        onView: onView,
        onConfirmIdentity: onConfirmIdentity,
        confirming: confirming
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aMDcZ.default), {
        file: file,
        height: isMobile ? '18rem' : '24rem'
    }), file.processingStatus === 'failed' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "warning",
        "data-testid": "file-detail-failure"
    }, t((0, $1Qo7B.failureCopyKey)(file.processingError))), inFlight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "info",
        "data-testid": "file-detail-in-flight"
    }, t('patient.files.extract.inFlight')), !storageOnly && (0, $1Qo7B.hasAnalysis)(file.processingStatus) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1f567419dd4447b1$var$Section, {
        title: t('patient.files.detail.lastRun'),
        testid: "file-detail-run-section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1f567419dd4447b1$var$LatestRun, {
        file: file,
        patientId: patientId,
        onReview: onReview
    })), file.ocrContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1f567419dd4447b1$var$Section, {
        title: t('patient.files.detail.inRecord'),
        testid: "file-detail-recorded"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1f567419dd4447b1$var$RecordedContent, {
        file: file
    }))));
    const footer = editing ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: '0.5rem',
            justifyContent: 'flex-end',
            flexWrap: 'wrap',
            width: '100%'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        onClick: ()=>{
            setEditing(false);
            setDraft(initialDraft(file));
            setSaveError('');
        },
        disabled: saving,
        "data-testid": "file-edit-cancel"
    }, t('common.actions.cancel')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        onClick: save,
        disabled: saving || !dirty,
        "data-testid": "file-edit-save"
    }, saving ? t('common.state.saving') : t('common.actions.save'))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: '0.5rem',
            flexWrap: 'wrap',
            width: '100%',
            alignItems: 'center'
        }
    }, !storageOnly && studyExtractable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "subtle",
        className: "gap-1.5",
        onClick: ()=>onExtract(file),
        disabled: !file.extractable,
        title: inFlight ? t('patient.files.extract.inFlight') : undefined,
        "data-testid": "file-detail-extract"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $chm1L.default), {
        size: 15,
        "aria-hidden": true
    }), " ", t('patient.files.actions.extract'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eAIjx.default), {
        cost: price,
        size: "sm",
        testid: "file-detail-extract-price"
    })), isStudy && !studyExtractable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "file-detail-no-extraction",
        style: {
            fontSize: '0.6875rem',
            color: (0, $jTCZr.CT).mute,
            flex: '1 1 14rem'
        }
    }, t('patient.files.dicom.noExtraction')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1
        }
    }), !isStudy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "sm",
        className: "gap-1.5",
        onClick: ()=>onDownload(file),
        "data-testid": "file-detail-download"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2XwcZ.default), {
        size: 14,
        "aria-hidden": true
    }), " ", t('patient.files.actions.download')), file.canEdit && !storageOnly && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "sm",
        className: "gap-1.5",
        onClick: ()=>setEditing(true),
        "data-testid": "file-detail-edit-open"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aGlWN.default), {
        size: 14,
        "aria-hidden": true
    }), " ", t('patient.files.actions.edit')), (file.canDelete || storageOnly) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "sm",
        className: "gap-1.5",
        onClick: ()=>onDelete(file),
        "data-testid": "file-detail-delete",
        style: {
            color: (0, $jTCZr.CT).danger
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lUsTt.default), {
        size: 14,
        "aria-hidden": true
    }), " ", t('patient.files.actions.delete')));
    const discard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cjPik.default), {
        open: confirmDiscard,
        onOpenChange: (o)=>{
            if (!o) setConfirmDiscard(false);
        },
        title: t('patient.files.upload.discardTitle'),
        description: t('patient.files.upload.discardMessage'),
        confirmLabel: t('patient.files.upload.discardConfirm'),
        cancelLabel: t('patient.files.upload.keepEditing'),
        destructive: true,
        onConfirm: ()=>{
            setConfirmDiscard(false);
            setEditing(false);
            onClose?.();
        }
    });
    if (isMobile) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: open,
        onClose: requestClose,
        title: t(editing ? 'patient.files.edit.title' : 'patient.files.detailTitle'),
        footer: footer,
        fullHeight: true,
        closeLabel: t('common.actions.close'),
        "data-testid": "file-detail-drawer"
    }, body), discard);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'fixed',
            inset: 0,
            zIndex: 1000
        },
        "data-testid": "file-detail-drawer",
        "data-editing": editing || undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $beZBx.default), {
        open: open,
        onClose: requestClose,
        width: $1f567419dd4447b1$var$DRAWER_WIDTH
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "dialog",
        "aria-modal": "true",
        "aria-label": file.fileName || t('patient.files.detailTitle'),
        style: {
            display: 'flex',
            flexDirection: 'column',
            height: '100%'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            overflowY: 'auto',
            padding: '1rem 1.125rem'
        }
    }, body), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            borderTop: `1px solid ${(0, $jTCZr.CT).border}`,
            padding: '0.75rem 1.125rem',
            background: (0, $jTCZr.CT).surface
        }
    }, footer)))), discard);
}

});
parcelRegister("aMDcZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a38d4c43e1d261e$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $66joL = parcelRequire("66joL");

var $jTCZr = parcelRequire("jTCZr");

var $iH4cM = parcelRequire("iH4cM");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $7sS0P = parcelRequire("7sS0P");

var $dLdf9 = parcelRequire("dLdf9");

var $3t8yQ = parcelRequire("3t8yQ");
function $9a38d4c43e1d261e$export$2e2bcd8739ae039({ file: file, height: height = '26rem', testid: testid = 'file-viewer' }) {
    const { t: t } = (0, $LNQP4.default)();
    const view = (0, $3t8yQ.default)(file);
    const frame = {
        height: height,
        borderRadius: (0, $7sS0P.RADIUS).card,
        border: `1px solid ${(0, $jTCZr.CT).border}`,
        background: (0, $jTCZr.CT).surface2,
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    };
    if (view.status === 'loading') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonRegion), {
        label: t('common.state.loading'),
        "data-testid": `${testid}-loading`,
        style: frame
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: "100%",
        height: "100%",
        radius: 0
    }));
    if (view.status === 'error') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${testid}-error`,
        "data-state": "error",
        style: {
            ...frame,
            height: 'auto',
            minHeight: '10rem',
            padding: '1rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dLdf9.default), {
        title: t('patient.files.unavailable'),
        onRetry: view.retry
    }));
    const isImage = view.type.startsWith('image/');
    const isPdf = view.type === 'application/pdf';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testid,
        "data-state": "content",
        "data-type": view.type,
        style: frame
    }, isImage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: view.url,
        alt: file.fileName || '',
        style: {
            maxWidth: '100%',
            maxHeight: '100%',
            objectFit: 'contain',
            display: 'block'
        }
    }), isPdf && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("iframe", {
        title: file.fileName || t('patient.files.unnamed'),
        src: view.url,
        style: {
            width: '100%',
            height: '100%',
            border: 'none'
        }
    }), !isImage && !isPdf && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '0.5rem',
            color: (0, $jTCZr.CT).mute,
            fontSize: '0.75rem',
            padding: '1rem',
            textAlign: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $iH4cM.default), {
        size: 32,
        strokeWidth: 1.5,
        "aria-hidden": true
    }), t('patient.files.detail.noPreview')));
}

});
parcelRegister("iH4cM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c17edf56d0b04896$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $c17edf56d0b04896$export$a2387ed3b5d536eb = {
    name: "file-question-mark",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
                key: "1oefj6"
            }
        ],
        [
            "path",
            {
                d: "M12 17h.01",
                key: "p32p05"
            }
        ],
        [
            "path",
            {
                d: "M9.1 9a3 3 0 0 1 5.82 1c0 2-3 3-3 3",
                key: "mhlwft"
            }
        ]
    ],
    aliases: [
        "file-question"
    ]
};
$c17edf56d0b04896$export$a2387ed3b5d536eb.node;
const $c17edf56d0b04896$export$2e2bcd8739ae039 = (0, $9QBug.default)($c17edf56d0b04896$export$a2387ed3b5d536eb);

});


parcelRegister("aXEQq", function(module, exports) {

$parcel$export(module.exports, "orderOptionLabel", () => $f959cceb164f70c8$export$b1b80d45b3914dd7);
$parcel$export(module.exports, "OrderField", () => $f959cceb164f70c8$export$6fb3676f9dc22f1b);
$parcel$export(module.exports, "default", () => $f959cceb164f70c8$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $aJ1FU = parcelRequire("aJ1FU");
var $cjPik = parcelRequire("cjPik");
var $jM6yW = parcelRequire("jM6yW");
var $7phmx = parcelRequire("7phmx");
var $4Qco3 = parcelRequire("4Qco3");
var $fAR2n = parcelRequire("fAR2n");
var $gCvEY = parcelRequire("gCvEY");
var $iygI2 = parcelRequire("iygI2");

var $jTCZr = parcelRequire("jTCZr");

var $2UQ3h = parcelRequire("2UQ3h");
var $chm1L = parcelRequire("chm1L");
var $6TdpC = parcelRequire("6TdpC");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
parcelRequire("fkEOT");
var $k27hS = parcelRequire("k27hS");

var $1yr2B = parcelRequire("1yr2B");

var $eAIjx = parcelRequire("eAIjx");

var $8iM4z = parcelRequire("8iM4z");

var $2WSRS = parcelRequire("2WSRS");

var $6kym7 = parcelRequire("6kym7");

var $1Qo7B = parcelRequire("1Qo7B");

var $e317r = parcelRequire("e317r");

var $lMO3H = parcelRequire("lMO3H");

var $3VOBa = parcelRequire("3VOBa");

var $fwngn = parcelRequire("fwngn");

var $gVhrm = parcelRequire("gVhrm");

var $hRWhk = parcelRequire("hRWhk");

var $cmmZD = parcelRequire("cmmZD");
// «افزودن فایل» — the doctor adds documents AND imaging studies to the patient's record.
// docs/DOCTOR_PATIENT_FILES_AND_AI_EXTRACTION_DESIGN.md §7.3, §8.4;
// docs/DICOM_COMPRESSION_LIMITS_AND_DOCUMENT_OCR_DESIGN.md §10.1, §11.1, §24.12.
//
// `TaskOverlay` (a framed Dialog on a workstation, a full-height sheet on a phone —
// DESIGN_CONCEPT §5.2) around the kit's `FileDropzone`. The zone accepts ANYTHING
// (`accept={null}`): files, a CD's folder (desktop), a ZIP. `lib/fileIntake` sorts the
// selection by its bytes into two groups —
//
//   «مدارک»          one row per PDF or photo, with its kind, optimised on arrival so
//                    the row can say what will be stored («۸٫۴ ← ۱٫۹ مگابایت»);
//   «مطالعات DICOM»  one row per study — modality, description, counts, its own date
//                    (from StudyDate), whether the file's patient looks like this one.
//
// Limits are the doctor's resolved policy: an image is judged on what will be STORED,
// a PDF on what is sent, a study on its bytes and instance count. DICOM is offered only
// where this environment ingests it and the policy allows it; otherwise a DICOM file
// is refused out loud, never dropped.
//
// Shared by the batch: the visit (pre-linked inside a visit), optionally one of its
// lab/imaging requests, a description, and — for documents — the document date.
//
// Two things this deliberately never does: run AI, and change an order. Storing a
// document is not an extraction (that is a separate, priced press — «بارگذاری و
// استخراج» is two explicit acts in one button, and the price is on it), and linking
// a result to a request does not complete the request (design §6.5).
const $f959cceb164f70c8$var$DEFAULT_KIND = 'LAB';
const $f959cceb164f70c8$export$b5b923b61a9d9eeb = ()=>{
    const k = (0, $e317r.hostDefaultUploadKind)();
    return (0, $1Qo7B.DOCUMENT_KIND_OPTIONS).some((o)=>o.value === k) ? k : $f959cceb164f70c8$var$DEFAULT_KIND;
};
function $f959cceb164f70c8$export$b1b80d45b3914dd7(order, t) {
    const type = String(order?.orderType || '').toLowerCase();
    const typeLabel = type.includes('imag') || type.includes('radiolog') ? t('patient.orderType.imaging') : t('patient.orderType.lab');
    return t('patient.files.upload.orderOption', {
        type: typeLabel,
        name: order?.name || order?.description || t('patient.files.upload.orderUntitled')
    });
}
function $f959cceb164f70c8$export$6fb3676f9dc22f1b({ value: value, onChange: onChange, options: options, loading: loading, disabled: disabled, testid: testid }) {
    const { t: t } = (0, $LNQP4.default)();
    if (!loading && !options.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        label: t('patient.files.upload.linkOrder')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${testid}-none`,
        style: {
            minHeight: '2.75rem',
            display: 'flex',
            alignItems: 'center',
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).mute
        }
    }, t('patient.files.upload.noOrdersForVisit')));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fAR2n.default), {
        label: t('patient.files.upload.linkOrder'),
        helperText: t('patient.files.upload.linkOrderHint'),
        value: value,
        onChange: (e)=>onChange(e.target.value),
        options: options,
        placeholder: loading ? t('common.state.loading') : t('patient.files.upload.noLink'),
        disabled: disabled || loading,
        "data-testid": testid
    });
}
/** Can this browser pick a folder? iOS Safari cannot (§10.6 E30). */ function $f959cceb164f70c8$var$supportsDirectoryPicker() {
    if (typeof document === 'undefined') return false;
    try {
        return 'webkitdirectory' in document.createElement('input');
    } catch  {
        return false;
    }
}
const $f959cceb164f70c8$var$isImageUpload = (item)=>Boolean(item.prepared?.measurement?.srcPx);
function $f959cceb164f70c8$export$2e2bcd8739ae039({ open: open, onClose: onClose, patientId: patientId, patient: patient, preset: preset = {}, visits: visits = [], orders: orders = [], ordersLoading: ordersLoading = false, onUploaded: onUploaded }) {
    const { t: t, has: has, formatDate: formatDate, formatDigits: formatDigits, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const { isMobile: isMobile } = (0, $k27hS.default)();
    const { costOf: costOf } = (0, $1yr2B.useCreditPrices)();
    const price = costOf('ANALYZE_FILE');
    const clinicId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (preset.clinicId) return preset.clinicId;
        const stored = (0, $lMO3H.readActiveClinicId)();
        return stored && stored !== (0, $lMO3H.ALL_CLINICS) ? stored : null;
    }, [
        preset.clinicId
    ]);
    const upload = (0, $8iM4z.useClinicalFileUpload)({
        patientId: patientId
    });
    const dicom = (0, $2WSRS.useDicomUpload)({
        patientId: patientId,
        clinicId: clinicId
    });
    const limits = (0, $6kym7.useUploadLimits)({
        open: open,
        patientId: patientId,
        clinicId: clinicId
    });
    const { reset: reset } = upload;
    const { reset: resetStudies } = dicom;
    const [documentDate, setDocumentDate] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [description, setDescription] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [appointmentId, setAppointmentId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [orderId, setOrderId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [zoneError, setZoneError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [notice, setNotice] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [skipped, setSkipped] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    const [intaking, setIntaking] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [failedCount, setFailedCount] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    const [confirmDiscard, setConfirmDiscard] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return;
        reset();
        resetStudies();
        setDocumentDate('');
        setDescription('');
        setAppointmentId(preset.appointmentId || '');
        setOrderId(preset.orderId || '');
        setZoneError('');
        setNotice('');
        setSkipped(0);
        setFailedCount(0);
        setConfirmDiscard(false);
    }, [
        open,
        reset,
        resetStudies,
        preset.appointmentId,
        preset.orderId
    ]);
    const items = upload.items;
    const studies = dicom.studies;
    const busy = upload.sending || dicom.sending;
    const allDone = items.length + studies.length > 0 && items.every((it)=>it.phase === 'done') && studies.every((s)=>s.phase === 'done');
    const dirty = !allDone && (items.length > 0 || studies.length > 0 || Boolean(description.trim()) || Boolean(documentDate));
    const caps = limits.capabilities;
    const base = limits.basePolicy;
    const dicomAllowed = Boolean(caps?.dicom && base?.dicomEnabled);
    const canPickFolder = !isMobile && $f959cceb164f70c8$var$supportsDirectoryPicker();
    const maxDocs = base?.maxFilesPerUpload || (0, $3VOBa.MAX_FILES_PER_UPLOAD);
    // A kind's own policy is read the first time a row of that kind exists.
    const kindsKey = [
        ...new Set(items.map((it)=>it.kind))
    ].join(',');
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        kindsKey.split(',').filter(Boolean).forEach(limits.ensureKind);
    }, [
        kindsKey,
        limits.ensureKind
    ]);
    const kindOptions = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $1Qo7B.DOCUMENT_KIND_OPTIONS).map((k)=>({
                value: k.value,
                label: t(k.labelKey)
            })), [
        t
    ]);
    const visitOptions = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>visits.map((v)=>({
                value: v.id,
                label: v.scheduledDate ? (0, $hRWhk.formatDocDate)(v.scheduledDate, formatDate) : t('patient.visit')
            })), [
        visits,
        formatDate,
        t
    ]);
    // A request belongs to exactly one visit, so the request picker exists only once a
    // visit is chosen, and lists that visit's lab and imaging requests — never a mixed
    // list of every visit's requests to pick from.
    const orderOptions = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>appointmentId ? orders.filter((o)=>o.appointmentId === appointmentId).map((o)=>({
                value: o.id,
                label: $f959cceb164f70c8$export$b1b80d45b3914dd7(o, t)
            })) : [], [
        orders,
        appointmentId,
        t
    ]);
    const presetVisit = preset.appointmentId && appointmentId === preset.appointmentId ? visits.find((v)=>v.id === preset.appointmentId) : null;
    // ── Limits, per row (§24.3) ───────────────────────────────────────────────
    const documentLimitError = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((it)=>{
        if (it.phase === 'preparing' || it.phase === 'done' || it.prepared?.refused) return null;
        const policy = limits.policyFor(it.kind);
        const image = $f959cceb164f70c8$var$isImageUpload(it);
        const bytes = image ? it.prepared?.file?.size ?? it.size : it.size;
        const physical = (0, $3VOBa.documentLimitBytes)(policy ? {
            ...policy,
            sizeLimitEnabled: false
        } : null);
        if (bytes > physical) return t('patient.files.upload.limitPlatform', {
            limit: (0, $3VOBa.sizeText)(t, formatNumber, physical)
        });
        const limit = (0, $3VOBa.documentLimitBytes)(policy);
        if (bytes > limit) return t(image ? 'patient.files.upload.limitFile' : 'patient.files.upload.limitFilePdf', {
            size: (0, $3VOBa.sizeText)(t, formatNumber, bytes),
            limit: (0, $3VOBa.sizeText)(t, formatNumber, limit)
        });
        return null;
    }, [
        limits,
        t,
        formatNumber
    ]);
    const studyLimitError = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((s)=>{
        if (s.phase === 'done' || !base) return null;
        if (base.maxDicomStudyBytes > 0 && s.bytes > base.maxDicomStudyBytes) return t((0, $3VOBa.DICOM_ERROR_KEYS).DICOM_LIMIT_STUDY, {
            size: (0, $3VOBa.sizeText)(t, formatNumber, s.bytes),
            limit: (0, $3VOBa.sizeText)(t, formatNumber, base.maxDicomStudyBytes)
        });
        if (base.maxDicomStudyInstances > 0 && s.instanceCount > base.maxDicomStudyInstances) return t((0, $3VOBa.DICOM_ERROR_KEYS).DICOM_LIMIT_INSTANCES, {
            count: formatNumber(s.instanceCount),
            limit: formatNumber(base.maxDicomStudyInstances)
        });
        return null;
    }, [
        base,
        t,
        formatNumber
    ]);
    const blockedDocs = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>new Set(items.filter((it)=>documentLimitError(it)).map((it)=>it.id)), [
        items,
        documentLimitError
    ]);
    const blockedStudies = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>new Set(studies.filter((s)=>studyLimitError(s)).map((s)=>s.id)), [
        studies,
        studyLimitError
    ]);
    const blockedKey = [
        ...blockedDocs
    ].join('|');
    const blockedStudyKey = [
        ...blockedStudies
    ].join('|');
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        upload.setBlocked(blockedDocs);
    }, [
        blockedKey
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        dicom.setBlocked(blockedStudies);
    }, [
        blockedStudyKey
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const blockedCount = blockedDocs.size + blockedStudies.size;
    // ── Intake ────────────────────────────────────────────────────────────────
    const onFiles = async (accepted, rejected)=>{
        const messages = [];
        const rejectedByZone = rejected || [];
        if (rejectedByZone.length) messages.push(...rejectedByZone.map(({ file: file })=>t('patient.files.upload.typeRejectedAny', {
                name: file.name
            })));
        if (!accepted?.length) {
            setZoneError([
                ...new Set(messages)
            ].join(' '));
            return;
        }
        setIntaking(true);
        try {
            const [{ capabilities: readCaps, policy: readPolicy }, out] = await Promise.all([
                limits.ready(),
                (0, $fwngn.intakeFiles)(accepted, {
                    known: dicom.knownSopUids
                })
            ]);
            const allowDicom = Boolean(readCaps?.dicom && readPolicy?.dicomEnabled);
            const room = Math.max(0, (readPolicy?.maxFilesPerUpload || (0, $3VOBa.MAX_FILES_PER_UPLOAD)) - items.filter((it)=>it.phase !== 'done').length);
            if (out.documents.length > room) messages.push(t('patient.files.upload.tooMany', {
                count: formatDigits(readPolicy?.maxFilesPerUpload || (0, $3VOBa.MAX_FILES_PER_UPLOAD))
            }));
            upload.add(out.documents.slice(0, room), $f959cceb164f70c8$export$b5b923b61a9d9eeb());
            if (out.studies.length) {
                if (allowDicom) dicom.addStudies(out.studies);
                else {
                    // Never silently dropped: the doctor is told why the images are not here.
                    const count = out.studies.reduce((n, s)=>n + s.instanceCount, 0);
                    messages.push(t(!readCaps?.dicom ? 'patient.files.dicom.refusedUnavailable' : 'patient.files.dicom.refusedDisabled', {
                        count: formatNumber(count)
                    }));
                }
            }
            out.rejected.forEach(({ file: file, reason: reason })=>{
                if (reason === 'type') messages.push(t('patient.files.upload.typeRejectedAny', {
                    name: file.name
                }));
                else if (reason === 'archive_entries') messages.push(t('patient.files.dicom.archiveEntries', {
                    name: file.name,
                    count: formatNumber(5000)
                }));
                else if (reason === 'archive_bytes') messages.push(t('patient.files.dicom.archiveBytes', {
                    name: file.name
                }));
                else messages.push(t('patient.files.dicom.archiveUnreadable', {
                    name: file.name
                }));
            });
            const skippedNow = (0, $fwngn.skippedTotal)(out.skipped);
            setSkipped((n)=>n + skippedNow);
            if (!out.documents.length && !out.studies.length && !out.rejected.length && skippedNow) messages.push(t((0, $3VOBa.DICOM_ERROR_KEYS).DICOM_NO_FILES));
            setNotice(out.studies.length && allowDicom && out.documents.length ? t('patient.files.dicom.mixedNotice') : '');
        } finally{
            setIntaking(false);
            setZoneError([
                ...new Set(messages)
            ].join(' '));
        }
    };
    const pickVisit = (id)=>{
        setAppointmentId(id);
        if (orderId && !orders.some((o)=>o.id === orderId && o.appointmentId === id)) setOrderId('');
    };
    const shared = {
        appointmentId: appointmentId,
        orderId: orderId,
        documentDate: documentDate,
        description: description
    };
    const dicomShared = {
        ...shared,
        maxBatchBytes: caps?.maxBatchBytes || undefined,
        maxInstanceBytes: caps?.maxInstanceBytes || base?.ceilings?.dicomInstanceBytes || undefined
    };
    const pendingDocs = items.some((it)=>it.phase !== 'done');
    const pendingStudies = studies.some((s)=>s.phase !== 'done');
    const canSubmit = !busy && !intaking && !upload.preparing && (pendingDocs || pendingStudies);
    const submit = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (extract)=>{
        if (!canSubmit) return;
        setFailedCount(0);
        // Documents first — they are quick — then the studies.
        const docs = pendingDocs || items.length ? await upload.send(shared) : {
            stored: [],
            failed: 0
        };
        const imaging = pendingStudies || studies.length ? await dicom.send(dicomShared) : {
            stored: [],
            failed: 0
        };
        const stored = [
            ...docs.stored,
            ...imaging.stored
        ];
        const failed = docs.failed + imaging.failed;
        if (failed || imaging.cancelled) {
            setFailedCount(failed);
            // What did land is in the record already; the list behind the overlay shows it.
            if (stored.length) onUploaded?.(stored, {
                partial: true
            });
            return;
        }
        // The extraction that «بارگذاری و استخراج» asks for is a document's, never a study's.
        onUploaded?.(docs.stored.length ? docs.stored : stored, {
            extract: Boolean(extract) && docs.stored.length > 0
        });
    }, [
        canSubmit,
        pendingDocs,
        pendingStudies,
        items.length,
        studies.length,
        upload,
        dicom,
        shared,
        dicomShared,
        onUploaded
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const requestClose = ()=>{
        if (busy) return;
        if (dirty) {
            setConfirmDiscard(true);
            return;
        }
        onClose?.();
    };
    // Ctrl+Enter submits the dialog's primary action (DESKTOP_WEB §5).
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open || isMobile) return undefined;
        const onKey = (e)=>{
            if ((e.ctrlKey || e.metaKey) && e.key === 'Enter') {
                e.preventDefault();
                submit(false);
            }
        };
        window.addEventListener('keydown', onKey);
        return ()=>window.removeEventListener('keydown', onKey);
    }, [
        open,
        isMobile,
        submit
    ]);
    // ── Rows ──────────────────────────────────────────────────────────────────
    const documentError = (it)=>{
        if (it.error?.code === 'HEIC') return t('patient.files.upload.heic');
        if (it.error?.offline) return t('patient.files.upload.offline');
        const ext = it.error?.extensions;
        if (ext?.code === 'UPLOAD_LIMIT_FILE' && (ext.size || ext.storedBytes) && (ext.limit || ext.limitBytes)) return t('patient.files.upload.limitFile', {
            size: (0, $3VOBa.sizeText)(t, formatNumber, ext.storedBytes ?? ext.size),
            limit: (0, $3VOBa.sizeText)(t, formatNumber, ext.limitBytes ?? ext.limit)
        });
        return (0, $3VOBa.fileErrorText)(t, has, it.error, 'patient.files.upload.failedOne');
    };
    const documentRows = items.map((it)=>{
        const limitError = documentLimitError(it);
        const measurement = it.prepared?.measurement;
        const meta = (0, $gVhrm.wasOptimized)(measurement) && it.prepared?.file !== it.file ? t('patient.files.optimizedFromTo', {
            from: formatNumber((0, $3VOBa.megabytes)(measurement.srcBytes)),
            to: formatNumber((0, $3VOBa.megabytes)(it.prepared.file.size))
        }) : t('patient.files.upload.size', {
            mb: formatDigits((0, $3VOBa.megabytes)(it.size))
        });
        return {
            id: it.id,
            name: it.name,
            file: it.file,
            phase: limitError && it.phase !== 'done' ? 'failed' : it.phase,
            meta: meta,
            error: limitError || (it.phase === 'failed' ? documentError(it) : undefined),
            removable: !busy && it.phase !== 'done',
            trailing: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fAR2n.default), {
                "aria-label": t('patient.files.upload.kindLabel'),
                value: it.kind,
                onChange: (e)=>upload.setKind(it.id, e.target.value),
                options: kindOptions,
                placeholder: "",
                disabled: busy || it.phase === 'done',
                "data-testid": `upload-kind-${it.id}`,
                style: {
                    minWidth: '9.5rem'
                }
            })
        };
    });
    const studyError = (s)=>{
        const code = s.error?.code;
        if (code === 'DICOM_LIMIT_STUDY') return t((0, $3VOBa.DICOM_ERROR_KEYS).DICOM_LIMIT_STUDY, {
            size: (0, $3VOBa.sizeText)(t, formatNumber, s.bytes),
            limit: (0, $3VOBa.sizeText)(t, formatNumber, base?.maxDicomStudyBytes || 0)
        });
        if (code === 'DICOM_LIMIT_INSTANCES') return t((0, $3VOBa.DICOM_ERROR_KEYS).DICOM_LIMIT_INSTANCES, {
            count: formatNumber(s.instanceCount),
            limit: formatNumber(base?.maxDicomStudyInstances || 0)
        });
        if (code === 'DICOM_INSTANCE_TOO_LARGE') return t((0, $3VOBa.DICOM_ERROR_KEYS).DICOM_INSTANCE_TOO_LARGE, {
            limit: (0, $3VOBa.sizeText)(t, formatNumber, s.error?.body?.maxInstanceBytes || caps?.maxInstanceBytes || 23068672)
        });
        if (code && (0, $3VOBa.DICOM_ERROR_KEYS)[code]) return t((0, $3VOBa.DICOM_ERROR_KEYS)[code]);
        return t('patient.files.dicom.errors.failed');
    };
    const studyRows = studies.map((s, index)=>{
        const limitError = studyLimitError(s);
        const verdict = (0, $fwngn.compareIdentity)(s.patient, patient);
        const counts = [];
        if (s.presentCount) counts.push(t('patient.files.dicom.presentCount', {
            count: formatNumber(s.presentCount)
        }));
        if (s.tooLargeCount) counts.push(t('patient.files.dicom.tooLargeCount', {
            count: formatNumber(s.tooLargeCount)
        }));
        if (s.rejectedCount) counts.push(t('patient.files.dicom.rejectedCount', {
            count: formatNumber(s.rejectedCount)
        }));
        const sendingPhase = s.phase === 'sending' || s.phase === 'committing';
        return {
            id: s.id,
            name: s.description || t('patient.files.dicom.untitled', {
                modality: s.modalities?.[0] || 'DICOM'
            }),
            phase: limitError && s.phase !== 'done' ? 'failed' : sendingPhase ? 'sending' : s.phase,
            progress: s.phase === 'sending' && s.progress != null ? Math.round(s.progress * 100) : undefined,
            progressLabel: s.phase === 'committing' ? t('patient.files.dicom.committing') : s.phase === 'sending' ? t('patient.files.dicom.sentOf', {
                sent: formatNumber(s.sentInstances || 0),
                total: formatNumber(s.instanceCount)
            }) : undefined,
            badge: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                "aria-hidden": true,
                "data-testid": `files-upload-study-${index}-modality`,
                style: {
                    width: '2.5rem',
                    height: '2.5rem',
                    borderRadius: '0.5rem',
                    background: (0, $jTCZr.CT).accentSoft,
                    color: (0, $jTCZr.CT).accentInk,
                    display: 'grid',
                    placeItems: 'center',
                    fontSize: '0.6875rem',
                    fontWeight: 700
                },
                dir: "ltr"
            }, (s.modalities || []).slice(0, 2).join('/') || 'DCM'),
            meta: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                "data-testid": `files-upload-study-${index}`,
                "data-state": s.phase,
                style: {
                    display: 'inline-flex',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    gap: '0.25rem 0.5rem'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, (0, $cmmZD.studyMetaText)(t, formatNumber, s)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cmmZD.IdentityChip), {
                verdict: verdict,
                testid: `files-upload-study-${index}-identity`
            }), counts.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    color: (0, $jTCZr.CT).mute
                }
            }, counts.join(" \xb7 "))),
            error: limitError || (s.phase === 'failed' ? studyError(s) : undefined),
            removable: !busy && s.phase !== 'done',
            trailing: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    minWidth: '9.5rem'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4Qco3.default), {
                value: s.documentDate,
                onChange: (v)=>dicom.setDocumentDate(s.id, v),
                disableFuture: true,
                disabled: busy || s.phase === 'done',
                placeholder: t('patient.files.dicom.studyDate'),
                "aria-label": t('patient.files.dicom.studyDate'),
                "data-testid": `files-upload-study-${index}-date`
            }))
        };
    });
    const groups = [];
    if (documentRows.length) groups.push({
        id: 'documents',
        title: t('patient.files.upload.groups.documents'),
        meta: formatNumber(documentRows.length),
        files: documentRows
    });
    if (studyRows.length) groups.push({
        id: 'dicom',
        title: t('patient.files.upload.groups.dicom'),
        meta: formatNumber(studyRows.length),
        files: studyRows
    });
    const phaseLabels = {
        queued: t('patient.files.upload.phase.queued'),
        preparing: t('patient.files.upload.phase.preparing'),
        sending: t('patient.files.upload.phase.sending'),
        done: t('patient.files.upload.phase.done'),
        failed: t('patient.files.upload.phase.failed')
    };
    const helper = [
        t('patient.files.upload.acceptAll', {
            mb: formatDigits((0, $3VOBa.megabytes)((0, $3VOBa.documentLimitBytes)(base))),
            count: formatDigits(maxDocs)
        }),
        dicomAllowed ? t(canPickFolder ? 'patient.files.dicom.hintFolder' : 'patient.files.dicom.hintZip') : null
    ].filter(Boolean).join(' ');
    const onRetry = (id)=>id.startsWith('study-') ? dicom.send(dicomShared, id) : upload.send(shared, id);
    const onRemove = (id)=>id.startsWith('study-') ? dicom.remove(id) : upload.remove(id);
    const footer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            flexWrap: 'wrap',
            width: '100%',
            justifyContent: 'flex-end'
        }
    }, dicom.sending ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        onClick: dicom.cancel,
        "data-testid": "upload-stop"
    }, t('patient.files.dicom.stop')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        onClick: requestClose,
        disabled: busy,
        "data-testid": "upload-cancel"
    }, t('common.actions.cancel')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "subtle",
        onClick: ()=>submit(true),
        disabled: !canSubmit || !pendingDocs,
        "data-testid": "upload-submit-extract",
        className: "gap-1.5"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $chm1L.default), {
        size: 15,
        "aria-hidden": true
    }), " ", t('patient.files.upload.submitAndExtract'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eAIjx.default), {
        cost: price,
        size: "sm",
        testid: "upload-extract-price"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        onClick: ()=>submit(false),
        disabled: !canSubmit,
        "data-testid": "upload-submit"
    }, busy ? t('patient.files.upload.sending') : t('patient.files.upload.submit')));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gCvEY.default), {
        open: open,
        onClose: requestClose,
        title: t('patient.files.upload.title'),
        description: isMobile ? undefined : t('patient.files.upload.subtitle'),
        footer: footer,
        busy: busy,
        size: "lg",
        isMobile: isMobile,
        closeLabel: t('common.actions.close'),
        "data-testid": "upload-file-overlay"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $jM6yW.default), {
        label: t('patient.files.upload.filesLabel'),
        required: true,
        helperText: helper,
        accept: null,
        capture: isMobile ? 'environment' : undefined,
        directory: canPickFolder,
        size: isMobile ? 'compact' : 'regular',
        groups: groups.length ? groups : undefined,
        files: groups.length ? undefined : [],
        onFiles: onFiles,
        onRemove: onRemove,
        onRetry: onRetry,
        busy: busy || intaking,
        error: zoneError || undefined,
        dropLabel: t('patient.files.upload.drop'),
        pickLabel: t('patient.files.upload.pick'),
        cameraLabel: t('patient.files.upload.camera'),
        directoryLabel: t('patient.files.upload.pickFolder'),
        draggingLabel: t('patient.files.upload.dragging'),
        removeLabel: t('common.actions.delete'),
        retryLabel: t('common.actions.retry'),
        listLabel: t('patient.files.upload.filesLabel'),
        phaseLabels: phaseLabels,
        "data-testid": "upload-dropzone"
    }), intaking && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "info",
        "data-testid": "upload-intaking"
    }, t('patient.files.dicom.reading')), notice && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "info",
        "data-testid": "upload-notice"
    }, notice), skipped > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        "data-testid": "upload-skipped",
        style: {
            margin: 0,
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).mute
        }
    }, t('patient.files.dicom.skipped', {
        count: formatNumber(skipped)
    })), blockedCount > 0 && !busy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "warning",
        "data-testid": "upload-blocked"
    }, t('patient.files.upload.blocked', {
        count: formatNumber(blockedCount)
    })), failedCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "error",
        "data-testid": "upload-partial"
    }, t('patient.files.upload.partial', {
        count: formatDigits(failedCount)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
            gap: '0.75rem 1rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        label: t('patient.files.upload.linkVisit')
    }, presetVisit || preset.appointmentId && appointmentId === preset.appointmentId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "upload-visit-linked",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            minHeight: '2.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.375rem',
            fontSize: '0.8125rem',
            color: (0, $jTCZr.CT).accentInk,
            fontWeight: 600
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2UQ3h.default), {
        size: 14,
        "aria-hidden": true
    }), presetVisit?.scheduledDate ? t('patient.files.upload.thisVisitOn', {
        date: (0, $hRWhk.formatDocDate)(presetVisit.scheduledDate, formatDate)
    }) : t('patient.files.upload.thisVisit')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        className: "gap-1",
        onClick: ()=>pickVisit(''),
        disabled: busy,
        "data-testid": "upload-visit-unlink"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
        size: 13,
        "aria-hidden": true
    }), " ", t('patient.files.upload.unlink'))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fAR2n.default), {
        value: appointmentId,
        onChange: (e)=>pickVisit(e.target.value),
        options: visitOptions,
        placeholder: t('patient.files.upload.noLink'),
        disabled: busy || !visitOptions.length,
        "data-testid": "upload-visit"
    })), appointmentId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f959cceb164f70c8$export$6fb3676f9dc22f1b, {
        value: orderId,
        onChange: setOrderId,
        options: orderOptions,
        loading: ordersLoading,
        disabled: busy,
        testid: "upload-order"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            maxWidth: isMobile ? 'none' : 'calc(50% - 0.5rem)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        label: t('patient.files.documentDate'),
        helperText: t(studies.length ? 'patient.files.dicom.dateHintMixed' : 'patient.files.upload.dateHint')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4Qco3.default), {
        value: documentDate,
        onChange: setDocumentDate,
        disableFuture: true,
        disabled: busy,
        placeholder: t('patient.files.upload.datePlaceholder'),
        "data-testid": "upload-document-date"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $iygI2.default), {
        label: t('patient.files.description'),
        value: description,
        onChange: (e)=>setDescription(e.target.value),
        placeholder: t('patient.files.upload.descriptionPlaceholder'),
        maxLength: 500,
        showCount: true,
        rows: 2,
        disabled: busy,
        "data-testid": "upload-description"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cjPik.default), {
        open: confirmDiscard,
        onOpenChange: (o)=>{
            if (!o) setConfirmDiscard(false);
        },
        title: t('patient.files.upload.discardTitle'),
        description: t('patient.files.upload.discardMessage'),
        confirmLabel: t('patient.files.upload.discardConfirm'),
        cancelLabel: t('patient.files.upload.keepEditing'),
        destructive: true,
        onConfirm: ()=>{
            setConfirmDiscard(false);
            onClose?.();
        },
        confirmTestId: "upload-discard-confirm"
    }));
}

});
parcelRegister("8iM4z", function(module, exports) {

$parcel$export(module.exports, "useClinicalFileUpload", () => $60b54b640883ab96$export$a04d2650265678af);

var $acw62 = parcelRequire("acw62");

var $eVM84 = parcelRequire("eVM84");

var $j7Lry = parcelRequire("j7Lry");

var $3VOBa = parcelRequire("3VOBa");

var $gVhrm = parcelRequire("gVhrm");
// The doctor's document queue — docs/DOCTOR_PATIENT_FILES_AND_AI_EXTRACTION_DESIGN.md §7.3,
// with the OCR-safe optimiser of DICOM_COMPRESSION_LIMITS_AND_DOCUMENT_OCR_DESIGN.md §24.4.
//
// One mutation PER FILE, SEQUENTIALLY: a batch of five photos in one request is five
// times the body limit, and a failure halfway would lose the four that worked. Each
// row carries its own phase in the kit's vocabulary (FILE_PHASES), so the dropzone
// draws exactly what the queue knows, and a failed row is retried on its own.
//
// A row is PREPARED when it is added, not when it is sent: the overlay needs the
// stored size before the doctor presses anything, because an image's limit is judged
// on what will be stored («۸٫۴ ← ۱٫۹ مگابایت»). A kind whose profile differs
// (a prescription reads at a larger size than a lab sheet) prepares it again.
//
// Nothing here runs AI or touches an order: an upload stores a document, and the
// extraction is a separate, priced press (design §6.5, D3).
let $60b54b640883ab96$var$sequence = 0;
function $60b54b640883ab96$export$a04d2650265678af({ patientId: patientId, optimize: optimize = (0, $gVhrm.optimizeForOcr) }) {
    const [items, setItems] = (0, $acw62.useState)([]);
    const [sending, setSending] = (0, $acw62.useState)(false);
    const itemsRef = (0, $acw62.useRef)(items);
    itemsRef.current = items;
    const patch = (0, $acw62.useCallback)((id, change)=>{
        setItems((list)=>list.map((it)=>it.id === id ? {
                    ...it,
                    ...change
                } : it));
    }, []);
    const prepare = (0, $acw62.useCallback)(async (id, file, kind)=>{
        let prepared;
        try {
            prepared = await optimize(file, {
                kind: kind
            });
        } catch  {
            prepared = {
                file: file,
                measurement: null
            };
        }
        setItems((list)=>list.map((it)=>{
                // The row was removed, or its kind changed again while this ran.
                if (it.id !== id || it.kind !== kind) return it;
                return {
                    ...it,
                    prepared: prepared,
                    phase: prepared.refused ? 'failed' : 'queued',
                    error: prepared.refused ? {
                        code: 'HEIC'
                    } : null
                };
            }));
    }, [
        optimize
    ]);
    const add = (0, $acw62.useCallback)((files, kind)=>{
        if (!files?.length) return;
        const fresh = files.map((file)=>{
            $60b54b640883ab96$var$sequence += 1;
            return {
                id: `upload-${$60b54b640883ab96$var$sequence}`,
                file: file,
                name: file.name,
                size: file.size,
                kind: kind,
                phase: 'preparing',
                error: null,
                result: null,
                prepared: null
            };
        });
        setItems((list)=>[
                ...list,
                ...fresh
            ]);
        fresh.forEach((it)=>{
            prepare(it.id, it.file, kind);
        });
    }, [
        prepare
    ]);
    const remove = (0, $acw62.useCallback)((id)=>setItems((list)=>list.filter((it)=>it.id !== id)), []);
    const setKind = (0, $acw62.useCallback)((id, kind)=>{
        const current = itemsRef.current.find((it)=>it.id === id);
        if (!current || current.kind === kind) return;
        const reprofile = (0, $gVhrm.profileForKind)(current.kind).id !== (0, $gVhrm.profileForKind)(kind).id && Boolean(current.prepared?.measurement?.srcPx);
        patch(id, reprofile ? {
            kind: kind,
            phase: 'preparing',
            prepared: null
        } : {
            kind: kind
        });
        if (reprofile) prepare(id, current.file, kind);
    }, [
        patch,
        prepare
    ]);
    const reset = (0, $acw62.useCallback)(()=>setItems([]), []);
    /** Rows the overlay's limits refuse; a send counts them out instead of trying. */ const setBlocked = (0, $acw62.useCallback)((blockedIds)=>{
        setItems((list)=>{
            let changed = false;
            const next = list.map((it)=>{
                const blocked = blockedIds.has(it.id);
                if (Boolean(it.blocked) === blocked) return it;
                changed = true;
                return {
                    ...it,
                    blocked: blocked
                };
            });
            return changed ? next : list;
        });
    }, []);
    // Leaving the page mid-send would abandon a file the doctor believes is on its way.
    (0, $acw62.useEffect)(()=>{
        if (!sending) return undefined;
        const guard = (e)=>{
            e.preventDefault();
            e.returnValue = '';
        };
        window.addEventListener('beforeunload', guard);
        return ()=>window.removeEventListener('beforeunload', guard);
    }, [
        sending
    ]);
    const sendOne = (0, $acw62.useCallback)(async (item, shared)=>{
        if (typeof navigator !== 'undefined' && navigator.onLine === false) {
            patch(item.id, {
                phase: 'failed',
                error: {
                    offline: true
                }
            });
            return null;
        }
        patch(item.id, {
            phase: 'sending',
            error: null
        });
        try {
            const upload = item.prepared?.file || item.file;
            const measurement = item.prepared?.measurement || null;
            const fileData = await (0, $3VOBa.fileToBase64)(upload);
            const d = await (0, $eVM84.bffMutation)((0, $j7Lry.UPLOAD_CLINICAL_FILE), {
                input: {
                    patientId: patientId,
                    fileName: upload.name || item.name,
                    contentType: (0, $3VOBa.contentTypeOf)(upload),
                    fileData: fileData,
                    kind: item.kind,
                    appointmentId: shared.appointmentId || null,
                    orderId: shared.orderId || null,
                    documentDate: shared.documentDate || null,
                    description: shared.description?.trim() ? shared.description.trim() : null,
                    // Only a decoded image was measured; a PDF travels without a measurement.
                    optimization: measurement?.srcPx ? (0, $gVhrm.optimizationInput)(measurement) : null
                }
            });
            const result = d?.uploadClinicalFile || null;
            patch(item.id, {
                phase: 'done',
                result: result
            });
            return result;
        } catch (error) {
            patch(item.id, {
                phase: 'failed',
                error: error
            });
            return null;
        }
    }, [
        patch,
        patientId
    ]);
    /**
   * Send every row that is not done yet (or only `onlyId`). Resolves with the rows
   * that are stored — including ones stored by an earlier pass — and how many failed.
   * A refused or limit-blocked row counts as failed without a request.
   */ const send = (0, $acw62.useCallback)(async (shared, onlyId)=>{
        setSending(true);
        const stored = [];
        let failed = 0;
        try {
            for (const item of itemsRef.current){
                if (item.phase === 'done') {
                    if (item.result) stored.push(item.result);
                    continue;
                }
                if (onlyId && item.id !== onlyId) continue;
                if (item.prepared?.refused || item.blocked || item.phase === 'preparing') {
                    failed += 1;
                    continue;
                }
                // eslint-disable-next-line no-await-in-loop
                const result = await sendOne(item, shared);
                if (result) stored.push(result);
                else failed += 1;
            }
        } finally{
            setSending(false);
        }
        return {
            stored: stored,
            failed: failed
        };
    }, [
        sendOne
    ]);
    const preparing = items.some((it)=>it.phase === 'preparing');
    return {
        items: items,
        sending: sending,
        preparing: preparing,
        add: add,
        remove: remove,
        setKind: setKind,
        reset: reset,
        send: send,
        setBlocked: setBlocked
    };
}
var $60b54b640883ab96$export$2e2bcd8739ae039 = $60b54b640883ab96$export$a04d2650265678af;

});
parcelRegister("gVhrm", function(module, exports) {

$parcel$export(module.exports, "profileForKind", () => $c51f7f79bb474588$export$b5390dc2a3033f19);
$parcel$export(module.exports, "optimizeForOcr", () => $c51f7f79bb474588$export$39f73a062db15148);
$parcel$export(module.exports, "optimizationInput", () => $c51f7f79bb474588$export$4778fb58f6bdd5c4);
$parcel$export(module.exports, "wasOptimized", () => $c51f7f79bb474588$export$3a09f495b2bef3af);
// OCR-safe image optimisation in the browser — the SAME rules storage applies.
// docs/DICOM_COMPRESSION_LIMITS_AND_DOCUMENT_OCR_DESIGN.md §24.4 (binding), §6.
//
// Why the client does it at all: bandwidth, and the size guard. A 6 MB phone photo of
// a lab sheet reads just as well at 2800 px, and the doctor's per-file limit is judged
// on the STORED bytes of an image — so the overlay has to know what will be stored
// before it sends anything («۸٫۴ ← ۱٫۹ مگابایت»). The server trusts a client result
// only when its long side is within the profile cap (outcome `client`), and otherwise
// optimises again, so a wrong client can cost quality never correctness.
//
// Two rules the whole module is built around: colour is never removed, and a
// re-encode that makes the text less legible is thrown away (the Laplacian guard).
// A failure anywhere keeps the source bytes — an optimiser must never be the reason
// a document is not stored.
//
// The canvas work goes through `env` so the decisions can be tested without a real
// canvas (jsdom has none).

var $fwngn = parcelRequire("fwngn");
const $c51f7f79bb474588$export$f3801eed144224d0 = 'ocr-safe-v1';
const $c51f7f79bb474588$var$MiB = 1048576;
const $c51f7f79bb474588$export$d206f45f4f829757 = 1.5 * $c51f7f79bb474588$var$MiB;
const $c51f7f79bb474588$export$278d586e51f9c9d0 = 0.10;
const $c51f7f79bb474588$export$30a9584fd9cfe3bf = 0.80;
const $c51f7f79bb474588$var$GUARD_SIDE = 1024;
const $c51f7f79bb474588$var$SCREENSHOT_SAMPLE = 256;
const $c51f7f79bb474588$var$SCREENSHOT_MAX_COLOURS = 256;
const $c51f7f79bb474588$var$SCREENSHOT_FLAT_TILES = 0.60;
const $c51f7f79bb474588$var$SCREENSHOT_CAP = 4000;
const $c51f7f79bb474588$export$a9e660cb533368c2 = Object.freeze({
    text: {
        id: 'text',
        cap: 2800,
        floor: 1800,
        quality: 90
    },
    handwriting: {
        id: 'handwriting',
        cap: 3400,
        floor: 2400,
        quality: 92
    },
    photo: {
        id: 'photo',
        cap: 3000,
        floor: 2000,
        quality: 88
    },
    screenshot: {
        id: 'screenshot',
        cap: $c51f7f79bb474588$var$SCREENSHOT_CAP,
        floor: null,
        quality: null
    }
});
function $c51f7f79bb474588$export$b5390dc2a3033f19(kind) {
    const k = String(kind || '').toUpperCase();
    if (k === 'PRESCRIPTION') return $c51f7f79bb474588$export$a9e660cb533368c2.handwriting;
    if (k === 'IMAGING') return $c51f7f79bb474588$export$a9e660cb533368c2.photo;
    return $c51f7f79bb474588$export$a9e660cb533368c2.text;
}
function $c51f7f79bb474588$export$34ca597b217cfe3c(width, height, profile, { atFloor: atFloor = false } = {}) {
    const long = Math.max(width, height);
    if (!long) return {
        width: width,
        height: height
    };
    let targetLong = Math.min(long, profile.cap);
    if (atFloor && profile.floor) targetLong = Math.min(long, profile.floor);
    const scale = Math.min(1, targetLong / long);
    return {
        width: Math.max(1, Math.round(width * scale)),
        height: Math.max(1, Math.round(height * scale))
    };
}
function $c51f7f79bb474588$export$d29e7856232087fe(gray, width, height) {
    if (width < 3 || height < 3) return 0;
    let sum = 0;
    let sumSq = 0;
    let n = 0;
    for(let y = 1; y < height - 1; y += 1){
        const row = y * width;
        for(let x = 1; x < width - 1; x += 1){
            const i = row + x;
            const v = gray[i - width] + gray[i + width] + gray[i - 1] + gray[i + 1] - 4 * gray[i];
            sum += v;
            sumSq += v * v;
            n += 1;
        }
    }
    const mean = sum / n;
    return sumSq / n - mean * mean;
}
function $c51f7f79bb474588$export$8ad175d0a4ef8db2(rgba, width, height) {
    const gray = new Float32Array(width * height);
    for(let i = 0, p = 0; i < gray.length; i += 1, p += 4)gray[i] = 0.299 * rgba[p] + 0.587 * rgba[p + 1] + 0.114 * rgba[p + 2];
    return gray;
}
function $c51f7f79bb474588$export$6a132d5382a1ff88(rgba, width, height) {
    const colours = new Set();
    for(let p = 0; p < rgba.length; p += 4){
        colours.add(rgba[p] << 16 | rgba[p + 1] << 8 | rgba[p + 2]);
        if (colours.size > $c51f7f79bb474588$var$SCREENSHOT_MAX_COLOURS) break;
    }
    if (colours.size <= $c51f7f79bb474588$var$SCREENSHOT_MAX_COLOURS) return true;
    let tiles = 0;
    let flat = 0;
    for(let ty = 0; ty + 16 <= height; ty += 16)for(let tx = 0; tx + 16 <= width; tx += 16){
        tiles += 1;
        const first = (ty * width + tx) * 4;
        let same = true;
        for(let y = ty; y < ty + 16 && same; y += 1)for(let x = tx; x < tx + 16; x += 1){
            const p = (y * width + x) * 4;
            if (rgba[p] !== rgba[first] || rgba[p + 1] !== rgba[first + 1] || rgba[p + 2] !== rgba[first + 2]) {
                same = false;
                break;
            }
        }
        if (same) flat += 1;
    }
    return tiles > 0 && flat / tiles >= $c51f7f79bb474588$var$SCREENSHOT_FLAT_TILES;
}
function $c51f7f79bb474588$export$f755ac40c153b09f(bytes) {
    const b = bytes;
    if (!(b[0] === 0xff && b[1] === 0xd8)) return 1;
    let off = 2;
    while(off + 4 < b.length){
        if (b[off] !== 0xff) return 1;
        const marker = b[off + 1];
        const len = b[off + 2] << 8 | b[off + 3];
        if (marker === 0xe1 && String.fromCharCode(b[off + 4], b[off + 5], b[off + 6], b[off + 7]) === 'Exif') {
            const tiff = off + 10;
            const little = b[tiff] === 0x49;
            const u16 = (o)=>little ? b[o] | b[o + 1] << 8 : b[o] << 8 | b[o + 1];
            const u32 = (o)=>(little ? b[o] | b[o + 1] << 8 | b[o + 2] << 16 | b[o + 3] << 24 : b[o] << 24 | b[o + 1] << 16 | b[o + 2] << 8 | b[o + 3]) >>> 0;
            const ifd = tiff + u32(tiff + 4);
            const count = u16(ifd);
            for(let i = 0; i < count; i += 1){
                const entry = ifd + 2 + i * 12;
                if (u16(entry) === 0x0112) return u16(entry + 8) || 1;
            }
            return 1;
        }
        if (marker === 0xda) return 1;
        off += 2 + len;
    }
    return 1;
}
function $c51f7f79bb474588$export$f8253e721f02caf2(bytes) {
    const b = bytes;
    if (!(b[0] === 0xff && b[1] === 0xd8)) return b;
    const out = [
        b.subarray(0, 2)
    ];
    let off = 2;
    while(off + 4 <= b.length){
        if (b[off] !== 0xff) return b;
        const marker = b[off + 1];
        if (marker === 0xda) {
            out.push(b.subarray(off));
            break;
        } // start of scan: the rest is image data
        const len = b[off + 2] << 8 | b[off + 3];
        const end = off + 2 + len;
        if (end > b.length) return b;
        const isApp = marker >= 0xe1 && marker <= 0xef;
        const isIcc = marker === 0xe2 && String.fromCharCode(...b.subarray(off + 4, off + 15)) === 'ICC_PROFILE';
        if (!(isApp && !isIcc || marker === 0xfe)) out.push(b.subarray(off, end));
        off = end;
    }
    const size = out.reduce((n, part)=>n + part.length, 0);
    const merged = new Uint8Array(size);
    let at = 0;
    out.forEach((part)=>{
        merged.set(part, at);
        at += part.length;
    });
    return merged;
}
const $c51f7f79bb474588$export$4bb03266d09e8616 = {
    canDecode: ()=>typeof createImageBitmap === 'function' && typeof document !== 'undefined',
    // `imageOrientation: 'from-image'` applies EXIF orientation to the pixels (§24.4 step 2).
    decode: (blob)=>createImageBitmap(blob, {
            imageOrientation: 'from-image'
        }),
    canvas: (width, height)=>{
        const c = document.createElement('canvas');
        c.width = width;
        c.height = height;
        return c;
    },
    encode: (canvas, type, quality)=>new Promise((resolve)=>canvas.toBlob(resolve, type, quality))
};
// Halve in steps, then finish at the exact size with high-quality smoothing (§24.4 step 5).
function $c51f7f79bb474588$var$resample(env, source, width, height) {
    let current = source;
    let cw = source.width;
    let ch = source.height;
    while(cw / 2 >= width && ch / 2 >= height){
        const nw = Math.round(cw / 2);
        const nh = Math.round(ch / 2);
        const step = env.canvas(nw, nh);
        const ctx = step.getContext('2d');
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';
        ctx.drawImage(current, 0, 0, nw, nh);
        current = step;
        cw = nw;
        ch = nh;
    }
    const out = env.canvas(width, height);
    const ctx = out.getContext('2d');
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(current, 0, 0, width, height);
    return out;
}
function $c51f7f79bb474588$var$sharpnessOf(env, drawable) {
    const long = Math.max(drawable.width, drawable.height);
    const scale = Math.min(1, $c51f7f79bb474588$var$GUARD_SIDE / long);
    const w = Math.max(3, Math.round(drawable.width * scale));
    const h = Math.max(3, Math.round(drawable.height * scale));
    const c = env.canvas(w, h);
    const ctx = c.getContext('2d');
    ctx.drawImage(drawable, 0, 0, w, h);
    const { data: data } = ctx.getImageData(0, 0, w, h);
    return $c51f7f79bb474588$export$d29e7856232087fe($c51f7f79bb474588$export$8ad175d0a4ef8db2(data, w, h), w, h);
}
function $c51f7f79bb474588$var$screenshotCandidate(env, bitmap, type, head) {
    if (!(type === 'png' || type === 'gif' || type === 'bmp' || type === 'webp' && (0, $fwngn.isLosslessWebp)(head))) return false;
    const c = env.canvas($c51f7f79bb474588$var$SCREENSHOT_SAMPLE, $c51f7f79bb474588$var$SCREENSHOT_SAMPLE);
    const ctx = c.getContext('2d');
    ctx.drawImage(bitmap, 0, 0, $c51f7f79bb474588$var$SCREENSHOT_SAMPLE, $c51f7f79bb474588$var$SCREENSHOT_SAMPLE);
    const { data: data } = ctx.getImageData(0, 0, $c51f7f79bb474588$var$SCREENSHOT_SAMPLE, $c51f7f79bb474588$var$SCREENSHOT_SAMPLE);
    return $c51f7f79bb474588$export$6a132d5382a1ff88(data, $c51f7f79bb474588$var$SCREENSHOT_SAMPLE, $c51f7f79bb474588$var$SCREENSHOT_SAMPLE);
}
const $c51f7f79bb474588$var$renamed = (name, ext)=>`${String(name || 'image').replace(/\.[a-z0-9]{2,5}$/i, '')}.${ext}`;
async function $c51f7f79bb474588$export$39f73a062db15148(file, { kind: kind, env: env = $c51f7f79bb474588$export$4bb03266d09e8616 } = {}) {
    const srcBytes = file?.size || 0;
    const base = {
        version: $c51f7f79bb474588$export$f3801eed144224d0,
        by: 'client',
        srcBytes: srcBytes,
        outBytes: srcBytes,
        srcPx: null,
        outPx: null,
        quality: null,
        sharpnessRatio: null
    };
    let head;
    try {
        head = await (0, $fwngn.blobBytes)(file, 0, Math.min(srcBytes, 65536));
    } catch  {
        return {
            file: file,
            measurement: {
                ...base,
                profile: $c51f7f79bb474588$export$b5390dc2a3033f19(kind).id,
                outcome: 'passthrough'
            }
        };
    }
    const type = (0, $fwngn.sniffBytes)(head);
    if (type === 'pdf' || ![
        'jpeg',
        'png',
        'webp',
        'heic',
        'gif',
        'bmp'
    ].includes(type)) return {
        file: file,
        measurement: {
            ...base,
            profile: $c51f7f79bb474588$export$b5390dc2a3033f19(kind).id,
            outcome: 'skipped'
        }
    };
    if (!env.canDecode()) {
        if (type === 'heic') return {
            file: file,
            measurement: {
                ...base,
                profile: $c51f7f79bb474588$export$b5390dc2a3033f19(kind).id,
                outcome: 'skipped'
            },
            refused: 'heic'
        };
        return {
            file: file,
            measurement: {
                ...base,
                profile: $c51f7f79bb474588$export$b5390dc2a3033f19(kind).id,
                outcome: 'skipped'
            }
        };
    }
    let bitmap;
    try {
        bitmap = await env.decode(file);
    } catch  {
        // An undecodable HEIC cannot be sent at all — the server does not accept HEIC.
        if (type === 'heic') return {
            file: file,
            measurement: {
                ...base,
                profile: $c51f7f79bb474588$export$b5390dc2a3033f19(kind).id,
                outcome: 'skipped'
            },
            refused: 'heic'
        };
        return {
            file: file,
            measurement: {
                ...base,
                profile: $c51f7f79bb474588$export$b5390dc2a3033f19(kind).id,
                outcome: 'passthrough'
            }
        };
    }
    try {
        const srcPx = [
            bitmap.width,
            bitmap.height
        ];
        const long = Math.max(bitmap.width, bitmap.height);
        const screenshot = type !== 'jpeg' && type !== 'heic' && $c51f7f79bb474588$var$screenshotCandidate(env, bitmap, type, head);
        const profile = screenshot ? $c51f7f79bb474588$export$a9e660cb533368c2.screenshot : $c51f7f79bb474588$export$b5390dc2a3033f19(kind);
        const measured = {
            ...base,
            profile: profile.id,
            srcPx: srcPx,
            outPx: srcPx
        };
        // Step 3 — small enough already. A JPEG still loses its metadata losslessly, but
        // only when it carries no rotation: stripping the EXIF of a rotated photo would
        // turn the page on its side, so that one is re-encoded upright instead.
        const orientation = type === 'jpeg' ? $c51f7f79bb474588$export$f755ac40c153b09f(head) : 1;
        if (type !== 'heic' && srcBytes <= $c51f7f79bb474588$export$d206f45f4f829757 && long <= profile.cap && orientation === 1) {
            if (type === 'jpeg') {
                const stripped = $c51f7f79bb474588$export$f8253e721f02caf2(await (0, $fwngn.blobBytes)(file));
                if (stripped.length < srcBytes) {
                    const out = new File([
                        stripped
                    ], file.name, {
                        type: (0, $fwngn.MIME_OF).jpeg,
                        lastModified: file.lastModified
                    });
                    return {
                        file: out,
                        measurement: {
                            ...measured,
                            outcome: 'skipped',
                            outBytes: out.size
                        }
                    };
                }
            }
            return {
                file: file,
                measurement: {
                    ...measured,
                    outcome: 'skipped'
                }
            };
        }
        const encodeAt = async ({ atFloor: atFloor, quality: quality })=>{
            const size = $c51f7f79bb474588$export$34ca597b217cfe3c(bitmap.width, bitmap.height, profile, {
                atFloor: atFloor
            });
            const canvas = $c51f7f79bb474588$var$resample(env, bitmap, size.width, size.height);
            const blob = screenshot ? await env.encode(canvas, (0, $fwngn.MIME_OF).png) : await env.encode(canvas, (0, $fwngn.MIME_OF).jpeg, quality / 100);
            return {
                canvas: canvas,
                blob: blob,
                size: size
            };
        };
        const sourceSharpness = $c51f7f79bb474588$var$sharpnessOf(env, bitmap);
        const ratioOf = (canvas)=>sourceSharpness > 0 ? $c51f7f79bb474588$var$sharpnessOf(env, canvas) / sourceSharpness : 1;
        let attempt = await encodeAt({
            atFloor: false,
            quality: profile.quality
        });
        let ratio = ratioOf(attempt.canvas);
        let quality = profile.quality;
        if (!screenshot && ratio < $c51f7f79bb474588$export$30a9584fd9cfe3bf) {
            quality = Math.min(100, profile.quality + 4);
            attempt = await encodeAt({
                atFloor: true,
                quality: quality
            });
            ratio = ratioOf(attempt.canvas);
        }
        const rounded = Math.round(ratio * 1000) / 1000;
        if (!attempt.blob || !screenshot && ratio < $c51f7f79bb474588$export$30a9584fd9cfe3bf) {
            // A HEIC has no source bytes the server would take: the upright JPEG goes anyway.
            if (type !== 'heic' || !attempt.blob) return {
                file: file,
                measurement: {
                    ...measured,
                    outcome: 'gate_failed',
                    quality: quality,
                    sharpnessRatio: rounded
                }
            };
        }
        const outPx = [
            attempt.size.width,
            attempt.size.height
        ];
        const smaller = attempt.blob.size <= srcBytes * (1 - $c51f7f79bb474588$export$278d586e51f9c9d0);
        if (!smaller && type !== 'heic' && orientation === 1) return {
            file: file,
            measurement: {
                ...measured,
                outcome: 'passthrough',
                quality: quality,
                sharpnessRatio: rounded
            }
        };
        const ext = screenshot ? 'png' : 'jpg';
        const out = new File([
            attempt.blob
        ], $c51f7f79bb474588$var$renamed(file.name, ext), {
            type: screenshot ? (0, $fwngn.MIME_OF).png : (0, $fwngn.MIME_OF).jpeg,
            lastModified: file.lastModified
        });
        return {
            file: out,
            measurement: {
                ...measured,
                outcome: 'optimized',
                outBytes: out.size,
                outPx: outPx,
                quality: screenshot ? null : quality,
                sharpnessRatio: rounded
            }
        };
    } finally{
        try {
            bitmap.close?.();
        } catch  {}
    }
}
function $c51f7f79bb474588$export$4778fb58f6bdd5c4(measurement) {
    if (!measurement) return null;
    const [srcWidth, srcHeight] = measurement.srcPx || [];
    const [width, height] = measurement.outPx || [];
    return {
        profile: measurement.profile || null,
        srcBytes: measurement.srcBytes ?? null,
        srcWidth: srcWidth ?? null,
        srcHeight: srcHeight ?? null,
        width: width ?? null,
        height: height ?? null,
        quality: measurement.quality ?? null,
        sharpnessRatio: measurement.sharpnessRatio ?? null
    };
}
const $c51f7f79bb474588$export$3a09f495b2bef3af = (measurement)=>Boolean(measurement && measurement.outBytes < measurement.srcBytes);

});
parcelRegister("fwngn", function(module, exports) {

$parcel$export(module.exports, "MIME_OF", () => $b4cbe3bcc0ad1160$export$8d94abc20542bccb);
$parcel$export(module.exports, "sniffBytes", () => $b4cbe3bcc0ad1160$export$9f4632b2eff2dc4a);
$parcel$export(module.exports, "isLosslessWebp", () => $b4cbe3bcc0ad1160$export$a069c676e7361cc6);
$parcel$export(module.exports, "blobBytes", () => $b4cbe3bcc0ad1160$export$8417eef9459ad88c);
$parcel$export(module.exports, "intakeFiles", () => $b4cbe3bcc0ad1160$export$4f9320e1e3a0d4ba);
$parcel$export(module.exports, "skippedTotal", () => $b4cbe3bcc0ad1160$export$45d8c05978783c00);
$parcel$export(module.exports, "compareIdentity", () => $b4cbe3bcc0ad1160$export$3de73ed166baf608);
// «افزودن فایل» — what a selection actually CONTAINS, decided from its bytes.
// docs/DICOM_COMPRESSION_LIMITS_AND_DOCUMENT_OCR_DESIGN.md §8.2, §23.3 A11, §24.12.
//
// The upload overlay accepts anything (`FileDropzone accept={null}`): files with
// any extension or none, a CD's folder, a ZIP. This module sorts it:
//
//   • documents — a PDF or a photo/scan (JPEG, PNG, WEBP, HEIC, GIF, BMP), by magic
//     bytes, never by the name or the browser's guessed MIME;
//   • DICOM instances — `DICM` at offset 128, their header read with `dicom-parser`
//     only up to the pixel data, grouped by StudyInstanceUID into study rows;
//   • everything else — counted, never silently dropped.
//
// A ZIP is streamed one entry at a time with fflate, under the §23 A11 limits.
// Inside a ZIP only DICOM is taken: a CD's viewer binaries, readme files and the
// odd JPEG screenshot of the viewer are counted as ignored.
//
// App-local, not kit: it reads files, and the kit never does.

var $61bLk = parcelRequire("61bLk");

var $cF21O = parcelRequire("cF21O");
// The UMD build is consumed as CommonJS by Parcel and jest alike; its API sits either
// on the namespace or on its `default`, depending on the interop in play.
const $b4cbe3bcc0ad1160$var$dicomParser = typeof $cF21O.parseDicom === 'function' ? $cF21O : $cF21O.default;
const $b4cbe3bcc0ad1160$var$MiB = 1048576;
const $b4cbe3bcc0ad1160$var$GiB = 1024 * $b4cbe3bcc0ad1160$var$MiB;
const $b4cbe3bcc0ad1160$export$44f404102543c3 = Object.freeze({
    maxEntries: 5000,
    maxUncompressedBytes: 2 * $b4cbe3bcc0ad1160$var$GiB,
    maxEntryBytes: 60 * $b4cbe3bcc0ad1160$var$MiB
});
const $b4cbe3bcc0ad1160$var$ZIP_READ_CHUNK = 1 * $b4cbe3bcc0ad1160$var$MiB;
const $b4cbe3bcc0ad1160$export$2d53d0a1222ec833 = '1.2.840.10008.1.3.10';
const $b4cbe3bcc0ad1160$export$90e6b981bc528c3a = Object.freeze([
    '1.2.840.10008.1.2.4.50',
    '1.2.840.10008.1.2.4.51',
    '1.2.840.10008.1.2.4.91',
    '1.2.840.10008.1.2.4.81',
    '1.2.840.10008.1.2.4.100',
    '1.2.840.10008.1.2.4.101',
    '1.2.840.10008.1.2.4.102',
    '1.2.840.10008.1.2.4.103',
    '1.2.840.10008.1.2.4.201'
]);
const $b4cbe3bcc0ad1160$export$ca410b253ced059c = Object.freeze([
    'pdf',
    'jpeg',
    'png',
    'webp',
    'heic',
    'gif',
    'bmp'
]);
const $b4cbe3bcc0ad1160$export$8d94abc20542bccb = Object.freeze({
    pdf: 'application/pdf',
    jpeg: 'image/jpeg',
    png: 'image/png',
    webp: 'image/webp',
    heic: 'image/heic',
    gif: 'image/gif',
    bmp: 'image/bmp',
    dicom: 'application/dicom',
    zip: 'application/zip'
});
const $b4cbe3bcc0ad1160$var$HEIC_BRANDS = [
    'heic',
    'heix',
    'hevc',
    'hevx',
    'heim',
    'heis',
    'mif1',
    'msf1'
];
const $b4cbe3bcc0ad1160$var$ascii = (bytes, from, length)=>{
    let s = '';
    for(let i = from; i < from + length && i < bytes.length; i += 1)s += String.fromCharCode(bytes[i]);
    return s;
};
function $b4cbe3bcc0ad1160$export$9f4632b2eff2dc4a(bytes) {
    const b = bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes || []);
    if (b.length >= 132 && $b4cbe3bcc0ad1160$var$ascii(b, 128, 4) === 'DICM') return 'dicom';
    if ($b4cbe3bcc0ad1160$var$ascii(b, 0, 4) === '%PDF') return 'pdf';
    if (b[0] === 0xff && b[1] === 0xd8 && b[2] === 0xff) return 'jpeg';
    if (b[0] === 0x89 && $b4cbe3bcc0ad1160$var$ascii(b, 1, 3) === 'PNG') return 'png';
    if ($b4cbe3bcc0ad1160$var$ascii(b, 0, 4) === 'RIFF' && $b4cbe3bcc0ad1160$var$ascii(b, 8, 4) === 'WEBP') return 'webp';
    if ($b4cbe3bcc0ad1160$var$ascii(b, 4, 4) === 'ftyp' && $b4cbe3bcc0ad1160$var$HEIC_BRANDS.includes($b4cbe3bcc0ad1160$var$ascii(b, 8, 4))) return 'heic';
    if ($b4cbe3bcc0ad1160$var$ascii(b, 0, 4) === 'GIF8') return 'gif';
    if (b[0] === 0x42 && b[1] === 0x4d) return 'bmp';
    if (b[0] === 0x50 && b[1] === 0x4b && (b[2] === 0x03 || b[2] === 0x05) && (b[3] === 0x04 || b[3] === 0x06)) return 'zip';
    return 'unknown';
}
function $b4cbe3bcc0ad1160$export$a069c676e7361cc6(bytes) {
    return $b4cbe3bcc0ad1160$export$9f4632b2eff2dc4a(bytes) === 'webp' && $b4cbe3bcc0ad1160$var$ascii(bytes, 12, 4) === 'VP8L';
}
function $b4cbe3bcc0ad1160$export$8417eef9459ad88c(blob, start = 0, end) {
    const part = end == null && start === 0 ? blob : blob.slice(start, end);
    if (typeof part.arrayBuffer === 'function') return part.arrayBuffer().then((buf)=>new Uint8Array(buf));
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onload = ()=>resolve(new Uint8Array(reader.result));
        reader.onerror = ()=>reject(reader.error);
        reader.readAsArrayBuffer(part);
    });
}
const $b4cbe3bcc0ad1160$export$54e431c725c56f5b = (path)=>String(path || '').split(/[\\/]/).pop();
const $b4cbe3bcc0ad1160$var$isHiddenPath = (path)=>String(path || '').split(/[\\/]/).some((seg)=>seg.startsWith('.') && seg !== '.' && seg !== '..');
const $b4cbe3bcc0ad1160$var$isMacResourcePath = (path)=>/(^|[\\/])__MACOSX([\\/]|$)/.test(String(path || ''));
const $b4cbe3bcc0ad1160$var$isDicomdirName = (path)=>$b4cbe3bcc0ad1160$export$54e431c725c56f5b(path).toUpperCase() === 'DICOMDIR';
function $b4cbe3bcc0ad1160$export$9e0323d9bfc03253(value) {
    const m = /^(\d{4})(\d{2})(\d{2})$/.exec(String(value || '').trim());
    if (!m) return '';
    const [, y, mo, d] = m;
    if (Number(mo) < 1 || Number(mo) > 12 || Number(d) < 1 || Number(d) > 31) return '';
    return `${y}-${mo}-${d}`;
}
const $b4cbe3bcc0ad1160$var$tag = (ds, t)=>{
    try {
        return (ds.string(t) || '').trim();
    } catch  {
        return '';
    }
};
function $b4cbe3bcc0ad1160$export$b185cf1351499cf1(bytes) {
    const ds = $b4cbe3bcc0ad1160$var$dicomParser.parseDicom(bytes, {
        untilTag: 'x7fe00010'
    });
    const frames = Number.parseInt($b4cbe3bcc0ad1160$var$tag(ds, 'x00280008'), 10);
    return {
        studyUid: $b4cbe3bcc0ad1160$var$tag(ds, 'x0020000d'),
        seriesUid: $b4cbe3bcc0ad1160$var$tag(ds, 'x0020000e'),
        sopUid: $b4cbe3bcc0ad1160$var$tag(ds, 'x00080018') || $b4cbe3bcc0ad1160$var$tag(ds, 'x00020003'),
        sopClassUid: $b4cbe3bcc0ad1160$var$tag(ds, 'x00020002') || $b4cbe3bcc0ad1160$var$tag(ds, 'x00080016'),
        modality: $b4cbe3bcc0ad1160$var$tag(ds, 'x00080060').toUpperCase(),
        studyDate: $b4cbe3bcc0ad1160$export$9e0323d9bfc03253($b4cbe3bcc0ad1160$var$tag(ds, 'x00080020')),
        studyDescription: $b4cbe3bcc0ad1160$var$tag(ds, 'x00081030'),
        seriesDescription: $b4cbe3bcc0ad1160$var$tag(ds, 'x0008103e'),
        seriesNumber: Number.parseInt($b4cbe3bcc0ad1160$var$tag(ds, 'x00200011'), 10) || null,
        bodyPart: $b4cbe3bcc0ad1160$var$tag(ds, 'x00180015').toUpperCase(),
        patientName: $b4cbe3bcc0ad1160$var$tag(ds, 'x00100010').replace(/\^+/g, ' ').replace(/\s+/g, ' ').trim(),
        patientBirthDate: $b4cbe3bcc0ad1160$export$9e0323d9bfc03253($b4cbe3bcc0ad1160$var$tag(ds, 'x00100030')),
        patientSex: $b4cbe3bcc0ad1160$var$tag(ds, 'x00100040').toUpperCase(),
        transferSyntax: $b4cbe3bcc0ad1160$var$tag(ds, 'x00020010'),
        numberOfFrames: Number.isFinite(frames) && frames > 0 ? frames : 1
    };
}
// Most headers fit in the first 64 KiB; a few carry large private tags. Read more
// only when the parser ran out of bytes.
const $b4cbe3bcc0ad1160$var$HEADER_READS = [
    65536,
    1048576
];
async function $b4cbe3bcc0ad1160$var$readDicomHeader(blob) {
    for (const size of $b4cbe3bcc0ad1160$var$HEADER_READS){
        if (size >= blob.size) break;
        // eslint-disable-next-line no-await-in-loop
        const bytes = await $b4cbe3bcc0ad1160$export$8417eef9459ad88c(blob, 0, size);
        try {
            return $b4cbe3bcc0ad1160$export$b185cf1351499cf1(bytes);
        } catch  {}
    }
    return $b4cbe3bcc0ad1160$export$b185cf1351499cf1(await $b4cbe3bcc0ad1160$export$8417eef9459ad88c(blob));
}
const $b4cbe3bcc0ad1160$var$emptySkipped = ()=>({
        dicomdir: 0,
        hidden: 0,
        nestedZip: 0,
        nonDicomInZip: 0,
        entryTooLarge: 0,
        unreadable: 0,
        duplicate: 0,
        noStudyUid: 0
    });
async function $b4cbe3bcc0ad1160$export$782034fc1c54f156(zipFile, { onEntry: onEntry, skipped: skipped, signal: signal, limits: limits = $b4cbe3bcc0ad1160$export$44f404102543c3 } = {}) {
    const kept = [];
    let entries = 0;
    let total = 0;
    let failure = null;
    const unzip = new (0, $61bLk.Unzip)((entry)=>{
        if (failure) return;
        const path = entry.name;
        if (path.endsWith('/')) return; // a directory record
        entries += 1;
        if (entries > limits.maxEntries) {
            failure = 'entries';
            return;
        }
        if ($b4cbe3bcc0ad1160$var$isMacResourcePath(path) || $b4cbe3bcc0ad1160$var$isHiddenPath(path)) {
            skipped.hidden += 1;
            return;
        }
        if ($b4cbe3bcc0ad1160$var$isDicomdirName(path)) {
            skipped.dicomdir += 1;
            return;
        }
        if (/\.zip$/i.test(path)) {
            skipped.nestedZip += 1;
            return;
        }
        if (entry.originalSize != null && entry.originalSize > limits.maxEntryBytes) {
            skipped.entryTooLarge += 1;
            return;
        }
        const chunks = [];
        let size = 0;
        let dropped = false;
        entry.ondata = (err, data, final)=>{
            if (failure || dropped) return;
            if (err) {
                failure = 'unreadable';
                return;
            }
            size += data.length;
            total += data.length;
            if (total > limits.maxUncompressedBytes) {
                failure = 'bytes';
                return;
            }
            if (size > limits.maxEntryBytes) {
                dropped = true;
                skipped.entryTooLarge += 1;
                try {
                    entry.terminate();
                } catch  {}
                return;
            }
            chunks.push(data);
            if (final) kept.push(new File(chunks, $b4cbe3bcc0ad1160$export$54e431c725c56f5b(path), {
                type: ''
            }));
        };
        try {
            entry.start();
        } catch  {
            skipped.unreadable += 1; // a compression method fflate cannot read
        }
    });
    unzip.register((0, $61bLk.UnzipInflate));
    try {
        for(let offset = 0; offset < zipFile.size; offset += $b4cbe3bcc0ad1160$var$ZIP_READ_CHUNK){
            if (signal?.aborted) return {
                ok: false,
                reason: 'aborted'
            };
            // eslint-disable-next-line no-await-in-loop
            const chunk = await $b4cbe3bcc0ad1160$export$8417eef9459ad88c(zipFile, offset, Math.min(zipFile.size, offset + $b4cbe3bcc0ad1160$var$ZIP_READ_CHUNK));
            unzip.push(chunk, offset + $b4cbe3bcc0ad1160$var$ZIP_READ_CHUNK >= zipFile.size);
            if (failure) break;
            // Hand over what completed in this chunk, so memory holds one chunk's worth of
            // parsing at a time rather than the whole archive's list.
            while(kept.length)// eslint-disable-next-line no-await-in-loop
            await onEntry(kept.shift());
        }
        if (zipFile.size === 0) unzip.push(new Uint8Array(0), true);
    } catch  {
        failure = failure || 'unreadable';
    }
    if (failure) return {
        ok: false,
        reason: failure
    };
    while(kept.length)// eslint-disable-next-line no-await-in-loop
    await onEntry(kept.shift());
    return {
        ok: true
    };
}
const $b4cbe3bcc0ad1160$var$summariseSeries = (instances)=>{
    const bySeries = new Map();
    instances.forEach((it)=>{
        const key = it.seriesUid || '';
        if (!bySeries.has(key)) bySeries.set(key, {
            seriesUid: key,
            number: it.seriesNumber,
            modality: it.modality,
            description: it.seriesDescription,
            instances: 0,
            frames: 0
        });
        const s = bySeries.get(key);
        s.instances += 1;
        s.frames += it.numberOfFrames || 1;
    });
    return [
        ...bySeries.values()
    ].sort((a, b)=>(a.number ?? 0) - (b.number ?? 0));
};
function $b4cbe3bcc0ad1160$export$acb516cc3fcaa054(instances) {
    const byStudy = new Map();
    instances.forEach((it)=>{
        if (!byStudy.has(it.studyUid)) byStudy.set(it.studyUid, []);
        byStudy.get(it.studyUid).push(it);
    });
    return [
        ...byStudy.entries()
    ].map(([studyUid, list])=>{
        const first = list.find((x)=>x.studyDescription) || list[0];
        const withPatient = list.find((x)=>x.patientName || x.patientBirthDate || x.patientSex) || list[0];
        const series = $b4cbe3bcc0ad1160$var$summariseSeries(list);
        const unique = (values)=>[
                ...new Set(values.filter(Boolean))
            ];
        const transferSyntaxes = unique(list.map((x)=>x.transferSyntax));
        return {
            studyUid: studyUid,
            instances: list,
            bytes: list.reduce((n, x)=>n + (x.size || 0), 0),
            instanceCount: list.length,
            frameCount: list.reduce((n, x)=>n + (x.numberOfFrames || 1), 0),
            series: series,
            seriesCount: series.length,
            modalities: unique(list.map((x)=>x.modality)),
            bodyParts: unique(list.map((x)=>x.bodyPart)),
            description: first.studyDescription || '',
            studyDate: list.find((x)=>x.studyDate)?.studyDate || '',
            transferSyntaxes: transferSyntaxes,
            lossySource: transferSyntaxes.some((ts)=>$b4cbe3bcc0ad1160$export$90e6b981bc528c3a.includes(ts)),
            patient: {
                name: withPatient.patientName || '',
                birthDate: withPatient.patientBirthDate || '',
                sex: withPatient.patientSex || ''
            }
        };
    });
}
async function $b4cbe3bcc0ad1160$export$4f9320e1e3a0d4ba(files, { known: known = new Set(), signal: signal, limits: limits = $b4cbe3bcc0ad1160$export$44f404102543c3 } = {}) {
    const documents = [];
    const instances = [];
    const rejected = [];
    const skipped = $b4cbe3bcc0ad1160$var$emptySkipped();
    const seen = new Set(known);
    const takeDicom = async (file, { fromZip: fromZip })=>{
        let header;
        try {
            header = await $b4cbe3bcc0ad1160$var$readDicomHeader(file);
        } catch  {
            skipped.unreadable += 1;
            return;
        }
        if (header.sopClassUid === $b4cbe3bcc0ad1160$export$2d53d0a1222ec833) {
            skipped.dicomdir += 1;
            return;
        }
        if (!header.studyUid || !header.sopUid) {
            skipped.noStudyUid += 1;
            return;
        }
        if (seen.has(header.sopUid)) {
            skipped.duplicate += 1;
            return;
        }
        seen.add(header.sopUid);
        instances.push({
            ...header,
            file: file,
            name: file.name,
            size: file.size,
            fromZip: fromZip
        });
    };
    for (const file of files || []){
        if (signal?.aborted) break;
        const path = file.webkitRelativePath || file.name;
        if (file.webkitRelativePath && ($b4cbe3bcc0ad1160$var$isMacResourcePath(path) || $b4cbe3bcc0ad1160$var$isHiddenPath(path))) {
            skipped.hidden += 1;
            continue;
        }
        if ($b4cbe3bcc0ad1160$var$isDicomdirName(path)) {
            skipped.dicomdir += 1;
            continue;
        }
        // eslint-disable-next-line no-await-in-loop
        const head = await $b4cbe3bcc0ad1160$export$8417eef9459ad88c(file, 0, Math.min(file.size, 132));
        const type = $b4cbe3bcc0ad1160$export$9f4632b2eff2dc4a(head);
        if (type === 'dicom') // eslint-disable-next-line no-await-in-loop
        await takeDicom(file, {
            fromZip: false
        });
        else if (type === 'zip') {
            // eslint-disable-next-line no-await-in-loop
            const result = await $b4cbe3bcc0ad1160$export$782034fc1c54f156(file, {
                skipped: skipped,
                signal: signal,
                limits: limits,
                onEntry: async (entry)=>{
                    const entryHead = await $b4cbe3bcc0ad1160$export$8417eef9459ad88c(entry, 0, Math.min(entry.size, 132));
                    const entryType = $b4cbe3bcc0ad1160$export$9f4632b2eff2dc4a(entryHead);
                    if (entryType === 'dicom') await takeDicom(entry, {
                        fromZip: true
                    });
                    else if (entryType === 'zip') skipped.nestedZip += 1;
                    else skipped.nonDicomInZip += 1;
                }
            });
            if (!result.ok && result.reason !== 'aborted') rejected.push({
                file: file,
                reason: `archive_${result.reason}`
            });
        } else if ($b4cbe3bcc0ad1160$export$ca410b253ced059c.includes(type)) documents.push(file);
        else if (file.webkitRelativePath) // A CD folder is full of viewer binaries and readme files: counted, not refused.
        skipped.nonDicomInZip += 1;
        else rejected.push({
            file: file,
            reason: 'type'
        });
    }
    return {
        documents: documents,
        studies: $b4cbe3bcc0ad1160$export$acb516cc3fcaa054(instances),
        rejected: rejected,
        skipped: skipped
    };
}
const $b4cbe3bcc0ad1160$export$45d8c05978783c00 = (skipped)=>Object.values(skipped || {}).reduce((n, v)=>n + (Number(v) || 0), 0);
// ── Identity (§8.7) — never blocks, always said ───────────────────────────────
const $b4cbe3bcc0ad1160$var$ARABIC_TO_PERSIAN = {
    "\u064A": "\u06CC",
    "\u0649": "\u06CC",
    "\u0643": "\u06A9",
    "\u0629": "\u0647",
    "\u0623": "\u0627",
    "\u0625": "\u0627",
    "\u0622": "\u0627",
    "\u0624": "\u0648"
}; // i18n-exempt: letter-variant normalisation table for name matching, not UI copy
function $b4cbe3bcc0ad1160$export$628e08be8fd033f7(name) {
    return String(name || '').replace(/[ً-ٰٟ]/g, '') // diacritics
    .replace(/[يىكةأإآؤ]/g, (ch)=>$b4cbe3bcc0ad1160$var$ARABIC_TO_PERSIAN[ch] || ch).replace(/‌/g, ' ').replace(/[\^,._\-]+/g, ' ').toLowerCase().split(/\s+/).filter((tok)=>tok.length > 1);
}
const $b4cbe3bcc0ad1160$var$scriptOf = (tokens)=>{
    const joined = tokens.join('');
    if (!joined) return 'none';
    if (/[؀-ۿ]/.test(joined)) return /[a-z]/.test(joined) ? 'mixed' : 'persian';
    return 'latin';
};
const $b4cbe3bcc0ad1160$var$sexOf = (value)=>{
    const v = String(value || '').trim().toLowerCase();
    if ([
        'm',
        'male',
        'man',
        "\u0645\u0631\u062F"
    ].includes(v)) return 'M'; // i18n-exempt: wire values of patient.gender
    if ([
        'f',
        'female',
        'woman',
        "\u0632\u0646"
    ].includes(v)) return 'F'; // i18n-exempt: wire values of patient.gender
    return '';
};
function $b4cbe3bcc0ad1160$export$3de73ed166baf608(header, patient) {
    const h = header || {};
    const p = patient || {};
    const facts = [];
    const hTokens = $b4cbe3bcc0ad1160$export$628e08be8fd033f7(h.name);
    const pTokens = $b4cbe3bcc0ad1160$export$628e08be8fd033f7(p.name);
    if (hTokens.length && pTokens.length && $b4cbe3bcc0ad1160$var$scriptOf(hTokens) === $b4cbe3bcc0ad1160$var$scriptOf(pTokens)) {
        const shared = hTokens.filter((tok)=>pTokens.includes(tok)).length;
        const ratio = shared / Math.min(hTokens.length, pTokens.length);
        facts.push(ratio >= 1 ? 'same' : ratio > 0 ? 'some' : 'differs');
    }
    const pBirth = String(p.birthDate || '').slice(0, 10);
    if (h.birthDate && /^\d{4}-\d{2}-\d{2}$/.test(pBirth)) facts.push(h.birthDate === pBirth ? 'same' : 'differs');
    const hs = $b4cbe3bcc0ad1160$var$sexOf(h.sex);
    const ps = $b4cbe3bcc0ad1160$var$sexOf(p.gender ?? p.sex);
    if (hs && ps) facts.push(hs === ps ? 'same' : 'differs');
    if (!facts.length) return 'unknown';
    if (facts.every((f)=>f === 'same')) return 'match';
    if (facts.some((f)=>f === 'differs') && !facts.some((f)=>f === 'same')) return 'mismatch';
    return 'partial';
}

});
parcelRegister("61bLk", function(module, exports) {

$parcel$export(module.exports, "decompressSync", () => $461bf5d8bd29e0d8$export$c4bdbbbc9a4faabe);
$parcel$export(module.exports, "UnzipInflate", () => $461bf5d8bd29e0d8$export$eb188945cc39e642);
$parcel$export(module.exports, "Unzip", () => $461bf5d8bd29e0d8$export$9b7485f84cbaaa56);
// DEFLATE is a complex format; to read this code, you should probably check the RFC first:
// https://tools.ietf.org/html/rfc1951
// You may also wish to take a look at the guide I made about this program:
// https://gist.github.com/101arrowz/253f31eb5abc3d9275ab943003ffecad
// Some of the following code is similar to that of UZIP.js:
// https://github.com/photopea/UZIP.js
// However, the vast majority of the codebase has diverged from UZIP.js to increase performance and reduce bundle size.
// Sometimes 0 will appear where -1 would be more appropriate. This is because using a uint
// is better for memory in most engines (I *think*).
var $461bf5d8bd29e0d8$var$ch2 = {};
var $461bf5d8bd29e0d8$var$wk = function(c, id, msg, transfer, cb) {
    var w = new Worker($461bf5d8bd29e0d8$var$ch2[id] || ($461bf5d8bd29e0d8$var$ch2[id] = URL.createObjectURL(new Blob([
        c + ';addEventListener("error",function(e){e=e.error;postMessage({$e$:[e.message,e.code,e.stack]})})'
    ], {
        type: 'text/javascript'
    }))));
    w.onmessage = function(e) {
        var d = e.data, ed = d.$e$;
        if (ed) {
            var err = new Error(ed[0]);
            err['code'] = ed[1];
            err.stack = ed[2];
            cb(err, null);
        } else cb(null, d);
    };
    w.postMessage(msg, transfer);
    return w;
};
// aliases for shorter compressed code (most minifers don't do this)
var $461bf5d8bd29e0d8$var$u8 = Uint8Array, $461bf5d8bd29e0d8$var$u16 = Uint16Array, $461bf5d8bd29e0d8$var$u32 = Uint32Array;
// fixed length extra bits
var $461bf5d8bd29e0d8$var$fleb = new $461bf5d8bd29e0d8$var$u8([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    /* unused */ 0,
    0,
    /* impossible */ 0
]);
// fixed distance extra bits
// see fleb note
var $461bf5d8bd29e0d8$var$fdeb = new $461bf5d8bd29e0d8$var$u8([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    /* unused */ 0,
    0
]);
// code length index map
var $461bf5d8bd29e0d8$var$clim = new $461bf5d8bd29e0d8$var$u8([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
// get base, reverse index map from extra bits
var $461bf5d8bd29e0d8$var$freb = function(eb, start) {
    var b = new $461bf5d8bd29e0d8$var$u16(31);
    for(var i = 0; i < 31; ++i)b[i] = start += 1 << eb[i - 1];
    // numbers here are at max 18 bits
    var r = new $461bf5d8bd29e0d8$var$u32(b[30]);
    for(var i = 1; i < 30; ++i)for(var j = b[i]; j < b[i + 1]; ++j)r[j] = j - b[i] << 5 | i;
    return [
        b,
        r
    ];
};
var $461bf5d8bd29e0d8$var$_a = $461bf5d8bd29e0d8$var$freb($461bf5d8bd29e0d8$var$fleb, 2), $461bf5d8bd29e0d8$var$fl = $461bf5d8bd29e0d8$var$_a[0], $461bf5d8bd29e0d8$var$revfl = $461bf5d8bd29e0d8$var$_a[1];
// we can ignore the fact that the other numbers are wrong; they never happen anyway
$461bf5d8bd29e0d8$var$fl[28] = 258, $461bf5d8bd29e0d8$var$revfl[258] = 28;
var $461bf5d8bd29e0d8$var$_b = $461bf5d8bd29e0d8$var$freb($461bf5d8bd29e0d8$var$fdeb, 0), $461bf5d8bd29e0d8$var$fd = $461bf5d8bd29e0d8$var$_b[0], $461bf5d8bd29e0d8$var$revfd = $461bf5d8bd29e0d8$var$_b[1];
// map of value to reverse (assuming 16 bits)
var $461bf5d8bd29e0d8$var$rev = new $461bf5d8bd29e0d8$var$u16(32768);
for(var $461bf5d8bd29e0d8$var$i = 0; $461bf5d8bd29e0d8$var$i < 32768; ++$461bf5d8bd29e0d8$var$i){
    // reverse table algorithm from SO
    var $461bf5d8bd29e0d8$var$x = ($461bf5d8bd29e0d8$var$i & 0xAAAA) >>> 1 | ($461bf5d8bd29e0d8$var$i & 0x5555) << 1;
    $461bf5d8bd29e0d8$var$x = ($461bf5d8bd29e0d8$var$x & 0xCCCC) >>> 2 | ($461bf5d8bd29e0d8$var$x & 0x3333) << 2;
    $461bf5d8bd29e0d8$var$x = ($461bf5d8bd29e0d8$var$x & 0xF0F0) >>> 4 | ($461bf5d8bd29e0d8$var$x & 0x0F0F) << 4;
    $461bf5d8bd29e0d8$var$rev[$461bf5d8bd29e0d8$var$i] = (($461bf5d8bd29e0d8$var$x & 0xFF00) >>> 8 | ($461bf5d8bd29e0d8$var$x & 0x00FF) << 8) >>> 1;
}
// create huffman tree from u8 "map": index -> code length for code index
// mb (max bits) must be at most 15
// TODO: optimize/split up?
var $461bf5d8bd29e0d8$var$hMap = function(cd, mb, r) {
    var s = cd.length;
    // index
    var i = 0;
    // u16 "map": index -> # of codes with bit length = index
    var l = new $461bf5d8bd29e0d8$var$u16(mb);
    // length of cd must be 288 (total # of codes)
    for(; i < s; ++i)if (cd[i]) ++l[cd[i] - 1];
    // u16 "map": index -> minimum code for bit length = index
    var le = new $461bf5d8bd29e0d8$var$u16(mb);
    for(i = 0; i < mb; ++i)le[i] = le[i - 1] + l[i - 1] << 1;
    var co;
    if (r) {
        // u16 "map": index -> number of actual bits, symbol for code
        co = new $461bf5d8bd29e0d8$var$u16(1 << mb);
        // bits to remove for reverser
        var rvb = 15 - mb;
        for(i = 0; i < s; ++i)// ignore 0 lengths
        if (cd[i]) {
            // num encoding both symbol and bits read
            var sv = i << 4 | cd[i];
            // free bits
            var r_1 = mb - cd[i];
            // start value
            var v = le[cd[i] - 1]++ << r_1;
            // m is end value
            for(var m = v | (1 << r_1) - 1; v <= m; ++v)// every 16 bit value starting with the code yields the same result
            co[$461bf5d8bd29e0d8$var$rev[v] >>> rvb] = sv;
        }
    } else {
        co = new $461bf5d8bd29e0d8$var$u16(s);
        for(i = 0; i < s; ++i)if (cd[i]) co[i] = $461bf5d8bd29e0d8$var$rev[le[cd[i] - 1]++] >>> 15 - cd[i];
    }
    return co;
};
// fixed length tree
var $461bf5d8bd29e0d8$var$flt = new $461bf5d8bd29e0d8$var$u8(288);
for(var $461bf5d8bd29e0d8$var$i = 0; $461bf5d8bd29e0d8$var$i < 144; ++$461bf5d8bd29e0d8$var$i)$461bf5d8bd29e0d8$var$flt[$461bf5d8bd29e0d8$var$i] = 8;
for(var $461bf5d8bd29e0d8$var$i = 144; $461bf5d8bd29e0d8$var$i < 256; ++$461bf5d8bd29e0d8$var$i)$461bf5d8bd29e0d8$var$flt[$461bf5d8bd29e0d8$var$i] = 9;
for(var $461bf5d8bd29e0d8$var$i = 256; $461bf5d8bd29e0d8$var$i < 280; ++$461bf5d8bd29e0d8$var$i)$461bf5d8bd29e0d8$var$flt[$461bf5d8bd29e0d8$var$i] = 7;
for(var $461bf5d8bd29e0d8$var$i = 280; $461bf5d8bd29e0d8$var$i < 288; ++$461bf5d8bd29e0d8$var$i)$461bf5d8bd29e0d8$var$flt[$461bf5d8bd29e0d8$var$i] = 8;
// fixed distance tree
var $461bf5d8bd29e0d8$var$fdt = new $461bf5d8bd29e0d8$var$u8(32);
for(var $461bf5d8bd29e0d8$var$i = 0; $461bf5d8bd29e0d8$var$i < 32; ++$461bf5d8bd29e0d8$var$i)$461bf5d8bd29e0d8$var$fdt[$461bf5d8bd29e0d8$var$i] = 5;
// fixed length map
var $461bf5d8bd29e0d8$var$flm = /*#__PURE__*/ $461bf5d8bd29e0d8$var$hMap($461bf5d8bd29e0d8$var$flt, 9, 0), $461bf5d8bd29e0d8$var$flrm = /*#__PURE__*/ $461bf5d8bd29e0d8$var$hMap($461bf5d8bd29e0d8$var$flt, 9, 1);
// fixed distance map
var $461bf5d8bd29e0d8$var$fdm = /*#__PURE__*/ $461bf5d8bd29e0d8$var$hMap($461bf5d8bd29e0d8$var$fdt, 5, 0), $461bf5d8bd29e0d8$var$fdrm = /*#__PURE__*/ $461bf5d8bd29e0d8$var$hMap($461bf5d8bd29e0d8$var$fdt, 5, 1);
// find max of array
var $461bf5d8bd29e0d8$var$max = function(a) {
    var m = a[0];
    for(var i = 1; i < a.length; ++i)if (a[i] > m) m = a[i];
    return m;
};
// read d, starting at bit p and mask with m
var $461bf5d8bd29e0d8$var$bits = function(d, p, m) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8) >> (p & 7) & m;
};
// read d, starting at bit p continuing for at least 16 bits
var $461bf5d8bd29e0d8$var$bits16 = function(d, p) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8 | d[o + 2] << 16) >> (p & 7);
};
// get end of byte
var $461bf5d8bd29e0d8$var$shft = function(p) {
    return (p + 7) / 8 | 0;
};
// typed array slice - allows garbage collector to free original reference,
// while being more compatible than .slice
var $461bf5d8bd29e0d8$var$slc = function(v, s, e) {
    if (s == null || s < 0) s = 0;
    if (e == null || e > v.length) e = v.length;
    // can't use .constructor in case user-supplied
    var n = new (v.BYTES_PER_ELEMENT == 2 ? $461bf5d8bd29e0d8$var$u16 : v.BYTES_PER_ELEMENT == 4 ? $461bf5d8bd29e0d8$var$u32 : $461bf5d8bd29e0d8$var$u8)(e - s);
    n.set(v.subarray(s, e));
    return n;
};
var $461bf5d8bd29e0d8$export$ae5516a5a74c19a8 = {
    UnexpectedEOF: 0,
    InvalidBlockType: 1,
    InvalidLengthLiteral: 2,
    InvalidDistance: 3,
    StreamFinished: 4,
    NoStreamHandler: 5,
    InvalidHeader: 6,
    NoCallback: 7,
    InvalidUTF8: 8,
    ExtraFieldTooLong: 9,
    InvalidDate: 10,
    FilenameTooLong: 11,
    StreamFinishing: 12,
    InvalidZipData: 13,
    UnknownCompressionMethod: 14
};
// error codes
var $461bf5d8bd29e0d8$var$ec = [
    'unexpected EOF',
    'invalid block type',
    'invalid length/literal',
    'invalid distance',
    'stream finished',
    'no stream handler',
    ,
    'no callback',
    'invalid UTF-8 data',
    'extra field too long',
    'date not in range 1980-2099',
    'filename too long',
    'stream finishing',
    'invalid zip data'
];
var $461bf5d8bd29e0d8$var$err = function(ind, msg, nt) {
    var e = new Error(msg || $461bf5d8bd29e0d8$var$ec[ind]);
    e.code = ind;
    if (Error.captureStackTrace) Error.captureStackTrace(e, $461bf5d8bd29e0d8$var$err);
    if (!nt) throw e;
    return e;
};
// expands raw DEFLATE data
var $461bf5d8bd29e0d8$var$inflt = function(dat, buf, st) {
    // source length
    var sl = dat.length;
    if (!sl || st && st.f && !st.l) return buf || new $461bf5d8bd29e0d8$var$u8(0);
    // have to estimate size
    var noBuf = !buf || st;
    // no state
    var noSt = !st || st.i;
    if (!st) st = {};
    // Assumes roughly 33% compression ratio average
    if (!buf) buf = new $461bf5d8bd29e0d8$var$u8(sl * 3);
    // ensure buffer can fit at least l elements
    var cbuf = function(l) {
        var bl = buf.length;
        // need to increase size to fit
        if (l > bl) {
            // Double or set to necessary, whichever is greater
            var nbuf = new $461bf5d8bd29e0d8$var$u8(Math.max(bl * 2, l));
            nbuf.set(buf);
            buf = nbuf;
        }
    };
    //  last chunk         bitpos           bytes
    var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
    // total bits
    var tbts = sl * 8;
    do {
        if (!lm) {
            // BFINAL - this is only 1 when last chunk is next
            final = $461bf5d8bd29e0d8$var$bits(dat, pos, 1);
            // type: 0 = no compression, 1 = fixed huffman, 2 = dynamic huffman
            var type = $461bf5d8bd29e0d8$var$bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                // go to end of byte boundary
                var s = $461bf5d8bd29e0d8$var$shft(pos) + 4, l = dat[s - 4] | dat[s - 3] << 8, t = s + l;
                if (t > sl) {
                    if (noSt) $461bf5d8bd29e0d8$var$err(0);
                    break;
                }
                // ensure size
                if (noBuf) cbuf(bt + l);
                // Copy over uncompressed data
                buf.set(dat.subarray(s, t), bt);
                // Get new bitpos, update byte count
                st.b = bt += l, st.p = pos = t * 8, st.f = final;
                continue;
            } else if (type == 1) lm = $461bf5d8bd29e0d8$var$flrm, dm = $461bf5d8bd29e0d8$var$fdrm, lbt = 9, dbt = 5;
            else if (type == 2) {
                //  literal                            lengths
                var hLit = $461bf5d8bd29e0d8$var$bits(dat, pos, 31) + 257, hcLen = $461bf5d8bd29e0d8$var$bits(dat, pos + 10, 15) + 4;
                var tl = hLit + $461bf5d8bd29e0d8$var$bits(dat, pos + 5, 31) + 1;
                pos += 14;
                // length+distance tree
                var ldt = new $461bf5d8bd29e0d8$var$u8(tl);
                // code length tree
                var clt = new $461bf5d8bd29e0d8$var$u8(19);
                for(var i = 0; i < hcLen; ++i)// use index map to get real code
                clt[$461bf5d8bd29e0d8$var$clim[i]] = $461bf5d8bd29e0d8$var$bits(dat, pos + i * 3, 7);
                pos += hcLen * 3;
                // code lengths bits
                var clb = $461bf5d8bd29e0d8$var$max(clt), clbmsk = (1 << clb) - 1;
                // code lengths map
                var clm = $461bf5d8bd29e0d8$var$hMap(clt, clb, 1);
                for(var i = 0; i < tl;){
                    var r = clm[$461bf5d8bd29e0d8$var$bits(dat, pos, clbmsk)];
                    // bits read
                    pos += r & 15;
                    // symbol
                    var s = r >>> 4;
                    // code length to copy
                    if (s < 16) ldt[i++] = s;
                    else {
                        //  copy   count
                        var c = 0, n = 0;
                        if (s == 16) n = 3 + $461bf5d8bd29e0d8$var$bits(dat, pos, 3), pos += 2, c = ldt[i - 1];
                        else if (s == 17) n = 3 + $461bf5d8bd29e0d8$var$bits(dat, pos, 7), pos += 3;
                        else if (s == 18) n = 11 + $461bf5d8bd29e0d8$var$bits(dat, pos, 127), pos += 7;
                        while(n--)ldt[i++] = c;
                    }
                }
                //    length tree                 distance tree
                var lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
                // max length bits
                lbt = $461bf5d8bd29e0d8$var$max(lt);
                // max dist bits
                dbt = $461bf5d8bd29e0d8$var$max(dt);
                lm = $461bf5d8bd29e0d8$var$hMap(lt, lbt, 1);
                dm = $461bf5d8bd29e0d8$var$hMap(dt, dbt, 1);
            } else $461bf5d8bd29e0d8$var$err(1);
            if (pos > tbts) {
                if (noSt) $461bf5d8bd29e0d8$var$err(0);
                break;
            }
        }
        // Make sure the buffer can hold this + the largest possible addition
        // Maximum chunk size (practically, theoretically infinite) is 2^17;
        if (noBuf) cbuf(bt + 131072);
        var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
        var lpos = pos;
        for(;; lpos = pos){
            // bits read, code
            var c = lm[$461bf5d8bd29e0d8$var$bits16(dat, pos) & lms], sym = c >>> 4;
            pos += c & 15;
            if (pos > tbts) {
                if (noSt) $461bf5d8bd29e0d8$var$err(0);
                break;
            }
            if (!c) $461bf5d8bd29e0d8$var$err(2);
            if (sym < 256) buf[bt++] = sym;
            else if (sym == 256) {
                lpos = pos, lm = null;
                break;
            } else {
                var add = sym - 254;
                // no extra bits needed if less
                if (sym > 264) {
                    // index
                    var i = sym - 257, b = $461bf5d8bd29e0d8$var$fleb[i];
                    add = $461bf5d8bd29e0d8$var$bits(dat, pos, (1 << b) - 1) + $461bf5d8bd29e0d8$var$fl[i];
                    pos += b;
                }
                // dist
                var d = dm[$461bf5d8bd29e0d8$var$bits16(dat, pos) & dms], dsym = d >>> 4;
                if (!d) $461bf5d8bd29e0d8$var$err(3);
                pos += d & 15;
                var dt = $461bf5d8bd29e0d8$var$fd[dsym];
                if (dsym > 3) {
                    var b = $461bf5d8bd29e0d8$var$fdeb[dsym];
                    dt += $461bf5d8bd29e0d8$var$bits16(dat, pos) & (1 << b) - 1, pos += b;
                }
                if (pos > tbts) {
                    if (noSt) $461bf5d8bd29e0d8$var$err(0);
                    break;
                }
                if (noBuf) cbuf(bt + 131072);
                var end = bt + add;
                for(; bt < end; bt += 4){
                    buf[bt] = buf[bt - dt];
                    buf[bt + 1] = buf[bt + 1 - dt];
                    buf[bt + 2] = buf[bt + 2 - dt];
                    buf[bt + 3] = buf[bt + 3 - dt];
                }
                bt = end;
            }
        }
        st.l = lm, st.p = lpos, st.b = bt, st.f = final;
        if (lm) final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    }while (!final);
    return bt == buf.length ? buf : $461bf5d8bd29e0d8$var$slc(buf, 0, bt);
};
// starting at p, write the minimum number of bits that can hold v to d
var $461bf5d8bd29e0d8$var$wbits = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >>> 8;
};
// starting at p, write the minimum number of bits (>8) that can hold v to d
var $461bf5d8bd29e0d8$var$wbits16 = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >>> 8;
    d[o + 2] |= v >>> 16;
};
// creates code lengths from a frequency table
var $461bf5d8bd29e0d8$var$hTree = function(d, mb) {
    // Need extra info to make a tree
    var t = [];
    for(var i = 0; i < d.length; ++i)if (d[i]) t.push({
        s: i,
        f: d[i]
    });
    var s = t.length;
    var t2 = t.slice();
    if (!s) return [
        $461bf5d8bd29e0d8$var$et,
        0
    ];
    if (s == 1) {
        var v = new $461bf5d8bd29e0d8$var$u8(t[0].s + 1);
        v[t[0].s] = 1;
        return [
            v,
            1
        ];
    }
    t.sort(function(a, b) {
        return a.f - b.f;
    });
    // after i2 reaches last ind, will be stopped
    // freq must be greater than largest possible number of symbols
    t.push({
        s: -1,
        f: 25001
    });
    var l = t[0], r = t[1], i0 = 0, i1 = 1, i2 = 2;
    t[0] = {
        s: -1,
        f: l.f + r.f,
        l: l,
        r: r
    };
    // efficient algorithm from UZIP.js
    // i0 is lookbehind, i2 is lookahead - after processing two low-freq
    // symbols that combined have high freq, will start processing i2 (high-freq,
    // non-composite) symbols instead
    // see https://reddit.com/r/photopea/comments/ikekht/uzipjs_questions/
    while(i1 != s - 1){
        l = t[t[i0].f < t[i2].f ? i0++ : i2++];
        r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
        t[i1++] = {
            s: -1,
            f: l.f + r.f,
            l: l,
            r: r
        };
    }
    var maxSym = t2[0].s;
    for(var i = 1; i < s; ++i)if (t2[i].s > maxSym) maxSym = t2[i].s;
    // code lengths
    var tr = new $461bf5d8bd29e0d8$var$u16(maxSym + 1);
    // max bits in tree
    var mbt = $461bf5d8bd29e0d8$var$ln(t[i1 - 1], tr, 0);
    if (mbt > mb) {
        // more algorithms from UZIP.js
        // TODO: find out how this code works (debt)
        //  ind    debt
        var i = 0, dt = 0;
        //    left            cost
        var lft = mbt - mb, cst = 1 << lft;
        t2.sort(function(a, b) {
            return tr[b.s] - tr[a.s] || a.f - b.f;
        });
        for(; i < s; ++i){
            var i2_1 = t2[i].s;
            if (tr[i2_1] > mb) {
                dt += cst - (1 << mbt - tr[i2_1]);
                tr[i2_1] = mb;
            } else break;
        }
        dt >>>= lft;
        while(dt > 0){
            var i2_2 = t2[i].s;
            if (tr[i2_2] < mb) dt -= 1 << mb - tr[i2_2]++ - 1;
            else ++i;
        }
        for(; i >= 0 && dt; --i){
            var i2_3 = t2[i].s;
            if (tr[i2_3] == mb) {
                --tr[i2_3];
                ++dt;
            }
        }
        mbt = mb;
    }
    return [
        new $461bf5d8bd29e0d8$var$u8(tr),
        mbt
    ];
};
// get the max length and assign length codes
var $461bf5d8bd29e0d8$var$ln = function(n, l, d) {
    return n.s == -1 ? Math.max($461bf5d8bd29e0d8$var$ln(n.l, l, d + 1), $461bf5d8bd29e0d8$var$ln(n.r, l, d + 1)) : l[n.s] = d;
};
// length codes generation
var $461bf5d8bd29e0d8$var$lc = function(c) {
    var s = c.length;
    // Note that the semicolon was intentional
    while(s && !c[--s]);
    var cl = new $461bf5d8bd29e0d8$var$u16(++s);
    //  ind      num         streak
    var cli = 0, cln = c[0], cls = 1;
    var w = function(v) {
        cl[cli++] = v;
    };
    for(var i = 1; i <= s; ++i)if (c[i] == cln && i != s) ++cls;
    else {
        if (!cln && cls > 2) {
            for(; cls > 138; cls -= 138)w(32754);
            if (cls > 2) {
                w(cls > 10 ? cls - 11 << 5 | 28690 : cls - 3 << 5 | 12305);
                cls = 0;
            }
        } else if (cls > 3) {
            w(cln), --cls;
            for(; cls > 6; cls -= 6)w(8304);
            if (cls > 2) w(cls - 3 << 5 | 8208), cls = 0;
        }
        while(cls--)w(cln);
        cls = 1;
        cln = c[i];
    }
    return [
        cl.subarray(0, cli),
        s
    ];
};
// calculate the length of output from tree, code lengths
var $461bf5d8bd29e0d8$var$clen = function(cf, cl) {
    var l = 0;
    for(var i = 0; i < cl.length; ++i)l += cf[i] * cl[i];
    return l;
};
// writes a fixed block
// returns the new bit pos
var $461bf5d8bd29e0d8$var$wfblk = function(out, pos, dat) {
    // no need to write 00 as type: TypedArray defaults to 0
    var s = dat.length;
    var o = $461bf5d8bd29e0d8$var$shft(pos + 2);
    out[o] = s & 255;
    out[o + 1] = s >>> 8;
    out[o + 2] = out[o] ^ 255;
    out[o + 3] = out[o + 1] ^ 255;
    for(var i = 0; i < s; ++i)out[o + i + 4] = dat[i];
    return (o + 4 + s) * 8;
};
// writes a block
var $461bf5d8bd29e0d8$var$wblk = function(dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
    $461bf5d8bd29e0d8$var$wbits(out, p++, final);
    ++lf[256];
    var _a = $461bf5d8bd29e0d8$var$hTree(lf, 15), dlt = _a[0], mlb = _a[1];
    var _b = $461bf5d8bd29e0d8$var$hTree(df, 15), ddt = _b[0], mdb = _b[1];
    var _c = $461bf5d8bd29e0d8$var$lc(dlt), lclt = _c[0], nlc = _c[1];
    var _d = $461bf5d8bd29e0d8$var$lc(ddt), lcdt = _d[0], ndc = _d[1];
    var lcfreq = new $461bf5d8bd29e0d8$var$u16(19);
    for(var i = 0; i < lclt.length; ++i)lcfreq[lclt[i] & 31]++;
    for(var i = 0; i < lcdt.length; ++i)lcfreq[lcdt[i] & 31]++;
    var _e = $461bf5d8bd29e0d8$var$hTree(lcfreq, 7), lct = _e[0], mlcb = _e[1];
    var nlcc = 19;
    for(; nlcc > 4 && !lct[$461bf5d8bd29e0d8$var$clim[nlcc - 1]]; --nlcc);
    var flen = bl + 5 << 3;
    var ftlen = $461bf5d8bd29e0d8$var$clen(lf, $461bf5d8bd29e0d8$var$flt) + $461bf5d8bd29e0d8$var$clen(df, $461bf5d8bd29e0d8$var$fdt) + eb;
    var dtlen = $461bf5d8bd29e0d8$var$clen(lf, dlt) + $461bf5d8bd29e0d8$var$clen(df, ddt) + eb + 14 + 3 * nlcc + $461bf5d8bd29e0d8$var$clen(lcfreq, lct) + (2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18]);
    if (flen <= ftlen && flen <= dtlen) return $461bf5d8bd29e0d8$var$wfblk(out, p, dat.subarray(bs, bs + bl));
    var lm, ll, dm, dl;
    $461bf5d8bd29e0d8$var$wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
    if (dtlen < ftlen) {
        lm = $461bf5d8bd29e0d8$var$hMap(dlt, mlb, 0), ll = dlt, dm = $461bf5d8bd29e0d8$var$hMap(ddt, mdb, 0), dl = ddt;
        var llm = $461bf5d8bd29e0d8$var$hMap(lct, mlcb, 0);
        $461bf5d8bd29e0d8$var$wbits(out, p, nlc - 257);
        $461bf5d8bd29e0d8$var$wbits(out, p + 5, ndc - 1);
        $461bf5d8bd29e0d8$var$wbits(out, p + 10, nlcc - 4);
        p += 14;
        for(var i = 0; i < nlcc; ++i)$461bf5d8bd29e0d8$var$wbits(out, p + 3 * i, lct[$461bf5d8bd29e0d8$var$clim[i]]);
        p += 3 * nlcc;
        var lcts = [
            lclt,
            lcdt
        ];
        for(var it = 0; it < 2; ++it){
            var clct = lcts[it];
            for(var i = 0; i < clct.length; ++i){
                var len = clct[i] & 31;
                $461bf5d8bd29e0d8$var$wbits(out, p, llm[len]), p += lct[len];
                if (len > 15) $461bf5d8bd29e0d8$var$wbits(out, p, clct[i] >>> 5 & 127), p += clct[i] >>> 12;
            }
        }
    } else lm = $461bf5d8bd29e0d8$var$flm, ll = $461bf5d8bd29e0d8$var$flt, dm = $461bf5d8bd29e0d8$var$fdm, dl = $461bf5d8bd29e0d8$var$fdt;
    for(var i = 0; i < li; ++i)if (syms[i] > 255) {
        var len = syms[i] >>> 18 & 31;
        $461bf5d8bd29e0d8$var$wbits16(out, p, lm[len + 257]), p += ll[len + 257];
        if (len > 7) $461bf5d8bd29e0d8$var$wbits(out, p, syms[i] >>> 23 & 31), p += $461bf5d8bd29e0d8$var$fleb[len];
        var dst = syms[i] & 31;
        $461bf5d8bd29e0d8$var$wbits16(out, p, dm[dst]), p += dl[dst];
        if (dst > 3) $461bf5d8bd29e0d8$var$wbits16(out, p, syms[i] >>> 5 & 8191), p += $461bf5d8bd29e0d8$var$fdeb[dst];
    } else $461bf5d8bd29e0d8$var$wbits16(out, p, lm[syms[i]]), p += ll[syms[i]];
    $461bf5d8bd29e0d8$var$wbits16(out, p, lm[256]);
    return p + ll[256];
};
// deflate options (nice << 13) | chain
var $461bf5d8bd29e0d8$var$deo = /*#__PURE__*/ new $461bf5d8bd29e0d8$var$u32([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]);
// empty
var $461bf5d8bd29e0d8$var$et = /*#__PURE__*/ new $461bf5d8bd29e0d8$var$u8(0);
// compresses data into a raw DEFLATE buffer
var $461bf5d8bd29e0d8$var$dflt = function(dat, lvl, plvl, pre, post, lst) {
    var s = dat.length;
    var o = new $461bf5d8bd29e0d8$var$u8(pre + s + 5 * (1 + Math.ceil(s / 7000)) + post);
    // writing to this writes to the output buffer
    var w = o.subarray(pre, o.length - post);
    var pos = 0;
    if (!lvl || s < 8) for(var i = 0; i <= s; i += 65535){
        // end
        var e = i + 65535;
        if (e >= s) // write final block
        w[pos >> 3] = lst;
        pos = $461bf5d8bd29e0d8$var$wfblk(w, pos + 1, dat.subarray(i, e));
    }
    else {
        var opt = $461bf5d8bd29e0d8$var$deo[lvl - 1];
        var n = opt >>> 13, c = opt & 8191;
        var msk_1 = (1 << plvl) - 1;
        //    prev 2-byte val map    curr 2-byte val map
        var prev = new $461bf5d8bd29e0d8$var$u16(32768), head = new $461bf5d8bd29e0d8$var$u16(msk_1 + 1);
        var bs1_1 = Math.ceil(plvl / 3), bs2_1 = 2 * bs1_1;
        var hsh = function(i) {
            return (dat[i] ^ dat[i + 1] << bs1_1 ^ dat[i + 2] << bs2_1) & msk_1;
        };
        // 24576 is an arbitrary number of maximum symbols per block
        // 424 buffer for last block
        var syms = new $461bf5d8bd29e0d8$var$u32(25000);
        // length/literal freq   distance freq
        var lf = new $461bf5d8bd29e0d8$var$u16(288), df = new $461bf5d8bd29e0d8$var$u16(32);
        //  l/lcnt  exbits  index  l/lind  waitdx  bitpos
        var lc_1 = 0, eb = 0, i = 0, li = 0, wi = 0, bs = 0;
        for(; i < s; ++i){
            // hash value
            // deopt when i > s - 3 - at end, deopt acceptable
            var hv = hsh(i);
            // index mod 32768    previous index mod
            var imod = i & 32767, pimod = head[hv];
            prev[imod] = pimod;
            head[hv] = imod;
            // We always should modify head and prev, but only add symbols if
            // this data is not yet processed ("wait" for wait index)
            if (wi <= i) {
                // bytes remaining
                var rem = s - i;
                if ((lc_1 > 7000 || li > 24576) && rem > 423) {
                    pos = $461bf5d8bd29e0d8$var$wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
                    li = lc_1 = eb = 0, bs = i;
                    for(var j = 0; j < 286; ++j)lf[j] = 0;
                    for(var j = 0; j < 30; ++j)df[j] = 0;
                }
                //  len    dist   chain
                var l = 2, d = 0, ch_1 = c, dif = imod - pimod & 32767;
                if (rem > 2 && hv == hsh(i - dif)) {
                    var maxn = Math.min(n, rem) - 1;
                    var maxd = Math.min(32767, i);
                    // max possible length
                    // not capped at dif because decompressors implement "rolling" index population
                    var ml = Math.min(258, rem);
                    while(dif <= maxd && --ch_1 && imod != pimod){
                        if (dat[i + l] == dat[i + l - dif]) {
                            var nl = 0;
                            for(; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl);
                            if (nl > l) {
                                l = nl, d = dif;
                                // break out early when we reach "nice" (we are satisfied enough)
                                if (nl > maxn) break;
                                // now, find the rarest 2-byte sequence within this
                                // length of literals and search for that instead.
                                // Much faster than just using the start
                                var mmd = Math.min(dif, nl - 2);
                                var md = 0;
                                for(var j = 0; j < mmd; ++j){
                                    var ti = i - dif + j + 32768 & 32767;
                                    var pti = prev[ti];
                                    var cd = ti - pti + 32768 & 32767;
                                    if (cd > md) md = cd, pimod = ti;
                                }
                            }
                        }
                        // check the previous match
                        imod = pimod, pimod = prev[imod];
                        dif += imod - pimod + 32768 & 32767;
                    }
                }
                // d will be nonzero only when a match was found
                if (d) {
                    // store both dist and len data in one Uint32
                    // Make sure this is recognized as a len/dist with 28th bit (2^28)
                    syms[li++] = 268435456 | $461bf5d8bd29e0d8$var$revfl[l] << 18 | $461bf5d8bd29e0d8$var$revfd[d];
                    var lin = $461bf5d8bd29e0d8$var$revfl[l] & 31, din = $461bf5d8bd29e0d8$var$revfd[d] & 31;
                    eb += $461bf5d8bd29e0d8$var$fleb[lin] + $461bf5d8bd29e0d8$var$fdeb[din];
                    ++lf[257 + lin];
                    ++df[din];
                    wi = i + l;
                    ++lc_1;
                } else {
                    syms[li++] = dat[i];
                    ++lf[dat[i]];
                }
            }
        }
        pos = $461bf5d8bd29e0d8$var$wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
        // this is the easiest way to avoid needing to maintain state
        if (!lst && pos & 7) pos = $461bf5d8bd29e0d8$var$wfblk(w, pos + 1, $461bf5d8bd29e0d8$var$et);
    }
    return $461bf5d8bd29e0d8$var$slc(o, 0, pre + $461bf5d8bd29e0d8$var$shft(pos) + post);
};
// CRC32 table
var $461bf5d8bd29e0d8$var$crct = /*#__PURE__*/ function() {
    var t = new Int32Array(256);
    for(var i = 0; i < 256; ++i){
        var c = i, k = 9;
        while(--k)c = (c & 1 && -306674912) ^ c >>> 1;
        t[i] = c;
    }
    return t;
}();
// CRC32
var $461bf5d8bd29e0d8$var$crc = function() {
    var c = -1;
    return {
        p: function(d) {
            // closures have awful performance
            var cr = c;
            for(var i = 0; i < d.length; ++i)cr = $461bf5d8bd29e0d8$var$crct[cr & 255 ^ d[i]] ^ cr >>> 8;
            c = cr;
        },
        d: function() {
            return ~c;
        }
    };
};
// Alder32
var $461bf5d8bd29e0d8$var$adler = function() {
    var a = 1, b = 0;
    return {
        p: function(d) {
            // closures have awful performance
            var n = a, m = b;
            var l = d.length | 0;
            for(var i = 0; i != l;){
                var e = Math.min(i + 2655, l);
                for(; i < e; ++i)m += n += d[i];
                n = (n & 65535) + 15 * (n >> 16), m = (m & 65535) + 15 * (m >> 16);
            }
            a = n, b = m;
        },
        d: function() {
            a %= 65521, b %= 65521;
            return (a & 255) << 24 | a >>> 8 << 16 | (b & 255) << 8 | b >>> 8;
        }
    };
};
// deflate with opts
var $461bf5d8bd29e0d8$var$dopt = function(dat, opt, pre, post, st) {
    return $461bf5d8bd29e0d8$var$dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : 12 + opt.mem, pre, post, !st);
};
// Walmart object spread
var $461bf5d8bd29e0d8$var$mrg = function(a, b) {
    var o = {};
    for(var k in a)o[k] = a[k];
    for(var k in b)o[k] = b[k];
    return o;
};
// worker clone
// This is possibly the craziest part of the entire codebase, despite how simple it may seem.
// The only parameter to this function is a closure that returns an array of variables outside of the function scope.
// We're going to try to figure out the variable names used in the closure as strings because that is crucial for workerization.
// We will return an object mapping of true variable name to value (basically, the current scope as a JS object).
// The reason we can't just use the original variable names is minifiers mangling the toplevel scope.
// This took me three weeks to figure out how to do.
var $461bf5d8bd29e0d8$var$wcln = function(fn, fnStr, td) {
    var dt = fn();
    var st = fn.toString();
    var ks = st.slice(st.indexOf('[') + 1, st.lastIndexOf(']')).replace(/\s+/g, '').split(',');
    for(var i = 0; i < dt.length; ++i){
        var v = dt[i], k = ks[i];
        if (typeof v == 'function') {
            fnStr += ';' + k + '=';
            var st_1 = v.toString();
            if (v.prototype) {
                // for global objects
                if (st_1.indexOf('[native code]') != -1) {
                    var spInd = st_1.indexOf(' ', 8) + 1;
                    fnStr += st_1.slice(spInd, st_1.indexOf('(', spInd));
                } else {
                    fnStr += st_1;
                    for(var t in v.prototype)fnStr += ';' + k + '.prototype.' + t + '=' + v.prototype[t].toString();
                }
            } else fnStr += st_1;
        } else td[k] = v;
    }
    return [
        fnStr,
        td
    ];
};
var $461bf5d8bd29e0d8$var$ch = [];
// clone bufs
var $461bf5d8bd29e0d8$var$cbfs = function(v) {
    var tl = [];
    for(var k in v)if (v[k].buffer) tl.push((v[k] = new v[k].constructor(v[k])).buffer);
    return tl;
};
// use a worker to execute code
var $461bf5d8bd29e0d8$var$wrkr = function(fns, init, id, cb) {
    var _a;
    if (!$461bf5d8bd29e0d8$var$ch[id]) {
        var fnStr = '', td_1 = {}, m = fns.length - 1;
        for(var i = 0; i < m; ++i)_a = $461bf5d8bd29e0d8$var$wcln(fns[i], fnStr, td_1), fnStr = _a[0], td_1 = _a[1];
        $461bf5d8bd29e0d8$var$ch[id] = $461bf5d8bd29e0d8$var$wcln(fns[m], fnStr, td_1);
    }
    var td = $461bf5d8bd29e0d8$var$mrg({}, $461bf5d8bd29e0d8$var$ch[id][1]);
    return $461bf5d8bd29e0d8$var$wk($461bf5d8bd29e0d8$var$ch[id][0] + ';onmessage=function(e){for(var k in e.data)self[k]=e.data[k];onmessage=' + init.toString() + '}', id, td, $461bf5d8bd29e0d8$var$cbfs(td), cb);
};
// base async inflate fn
var $461bf5d8bd29e0d8$var$bInflt = function() {
    return [
        $461bf5d8bd29e0d8$var$u8,
        $461bf5d8bd29e0d8$var$u16,
        $461bf5d8bd29e0d8$var$u32,
        $461bf5d8bd29e0d8$var$fleb,
        $461bf5d8bd29e0d8$var$fdeb,
        $461bf5d8bd29e0d8$var$clim,
        $461bf5d8bd29e0d8$var$fl,
        $461bf5d8bd29e0d8$var$fd,
        $461bf5d8bd29e0d8$var$flrm,
        $461bf5d8bd29e0d8$var$fdrm,
        $461bf5d8bd29e0d8$var$rev,
        $461bf5d8bd29e0d8$var$ec,
        $461bf5d8bd29e0d8$var$hMap,
        $461bf5d8bd29e0d8$var$max,
        $461bf5d8bd29e0d8$var$bits,
        $461bf5d8bd29e0d8$var$bits16,
        $461bf5d8bd29e0d8$var$shft,
        $461bf5d8bd29e0d8$var$slc,
        $461bf5d8bd29e0d8$var$err,
        $461bf5d8bd29e0d8$var$inflt,
        $461bf5d8bd29e0d8$export$90366d8b308ba94a,
        $461bf5d8bd29e0d8$var$pbf,
        $461bf5d8bd29e0d8$var$gu8
    ];
};
var $461bf5d8bd29e0d8$var$bDflt = function() {
    return [
        $461bf5d8bd29e0d8$var$u8,
        $461bf5d8bd29e0d8$var$u16,
        $461bf5d8bd29e0d8$var$u32,
        $461bf5d8bd29e0d8$var$fleb,
        $461bf5d8bd29e0d8$var$fdeb,
        $461bf5d8bd29e0d8$var$clim,
        $461bf5d8bd29e0d8$var$revfl,
        $461bf5d8bd29e0d8$var$revfd,
        $461bf5d8bd29e0d8$var$flm,
        $461bf5d8bd29e0d8$var$flt,
        $461bf5d8bd29e0d8$var$fdm,
        $461bf5d8bd29e0d8$var$fdt,
        $461bf5d8bd29e0d8$var$rev,
        $461bf5d8bd29e0d8$var$deo,
        $461bf5d8bd29e0d8$var$et,
        $461bf5d8bd29e0d8$var$hMap,
        $461bf5d8bd29e0d8$var$wbits,
        $461bf5d8bd29e0d8$var$wbits16,
        $461bf5d8bd29e0d8$var$hTree,
        $461bf5d8bd29e0d8$var$ln,
        $461bf5d8bd29e0d8$var$lc,
        $461bf5d8bd29e0d8$var$clen,
        $461bf5d8bd29e0d8$var$wfblk,
        $461bf5d8bd29e0d8$var$wblk,
        $461bf5d8bd29e0d8$var$shft,
        $461bf5d8bd29e0d8$var$slc,
        $461bf5d8bd29e0d8$var$dflt,
        $461bf5d8bd29e0d8$var$dopt,
        $461bf5d8bd29e0d8$export$21533ff51b8a0b4a,
        $461bf5d8bd29e0d8$var$pbf
    ];
};
// gzip extra
var $461bf5d8bd29e0d8$var$gze = function() {
    return [
        $461bf5d8bd29e0d8$var$gzh,
        $461bf5d8bd29e0d8$var$gzhl,
        $461bf5d8bd29e0d8$var$wbytes,
        $461bf5d8bd29e0d8$var$crc,
        $461bf5d8bd29e0d8$var$crct
    ];
};
// gunzip extra
var $461bf5d8bd29e0d8$var$guze = function() {
    return [
        $461bf5d8bd29e0d8$var$gzs,
        $461bf5d8bd29e0d8$var$gzl
    ];
};
// zlib extra
var $461bf5d8bd29e0d8$var$zle = function() {
    return [
        $461bf5d8bd29e0d8$var$zlh,
        $461bf5d8bd29e0d8$var$wbytes,
        $461bf5d8bd29e0d8$var$adler
    ];
};
// unzlib extra
var $461bf5d8bd29e0d8$var$zule = function() {
    return [
        $461bf5d8bd29e0d8$var$zlv
    ];
};
// post buf
var $461bf5d8bd29e0d8$var$pbf = function(msg) {
    return postMessage(msg, [
        msg.buffer
    ]);
};
// get u8
var $461bf5d8bd29e0d8$var$gu8 = function(o) {
    return o && o.size && new $461bf5d8bd29e0d8$var$u8(o.size);
};
// async helper
var $461bf5d8bd29e0d8$var$cbify = function(dat, opts, fns, init, id, cb) {
    var w = $461bf5d8bd29e0d8$var$wrkr(fns, init, id, function(err, dat) {
        w.terminate();
        cb(err, dat);
    });
    w.postMessage([
        dat,
        opts
    ], opts.consume ? [
        dat.buffer
    ] : []);
    return function() {
        w.terminate();
    };
};
// auto stream
var $461bf5d8bd29e0d8$var$astrm = function(strm) {
    strm.ondata = function(dat, final) {
        return postMessage([
            dat,
            final
        ], [
            dat.buffer
        ]);
    };
    return function(ev) {
        return strm.push(ev.data[0], ev.data[1]);
    };
};
// async stream attach
var $461bf5d8bd29e0d8$var$astrmify = function(fns, strm, opts, init, id) {
    var t;
    var w = $461bf5d8bd29e0d8$var$wrkr(fns, init, id, function(err, dat) {
        if (err) w.terminate(), strm.ondata.call(strm, err);
        else {
            if (dat[1]) w.terminate();
            strm.ondata.call(strm, err, dat[0], dat[1]);
        }
    });
    w.postMessage(opts);
    strm.push = function(d, f) {
        if (!strm.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (t) strm.ondata($461bf5d8bd29e0d8$var$err(4, 0, 1), null, !!f);
        w.postMessage([
            d,
            t = f
        ], [
            d.buffer
        ]);
    };
    strm.terminate = function() {
        w.terminate();
    };
};
// read 2 bytes
var $461bf5d8bd29e0d8$var$b2 = function(d, b) {
    return d[b] | d[b + 1] << 8;
};
// read 4 bytes
var $461bf5d8bd29e0d8$var$b4 = function(d, b) {
    return (d[b] | d[b + 1] << 8 | d[b + 2] << 16 | d[b + 3] << 24) >>> 0;
};
var $461bf5d8bd29e0d8$var$b8 = function(d, b) {
    return $461bf5d8bd29e0d8$var$b4(d, b) + $461bf5d8bd29e0d8$var$b4(d, b + 4) * 4294967296;
};
// write bytes
var $461bf5d8bd29e0d8$var$wbytes = function(d, b, v) {
    for(; v; ++b)d[b] = v, v >>>= 8;
};
// gzip header
var $461bf5d8bd29e0d8$var$gzh = function(c, o) {
    var fn = o.filename;
    c[0] = 31, c[1] = 139, c[2] = 8, c[8] = o.level < 2 ? 4 : o.level == 9 ? 2 : 0, c[9] = 3; // assume Unix
    if (o.mtime != 0) $461bf5d8bd29e0d8$var$wbytes(c, 4, Math.floor(new Date(o.mtime || Date.now()) / 1000));
    if (fn) {
        c[3] = 8;
        for(var i = 0; i <= fn.length; ++i)c[i + 10] = fn.charCodeAt(i);
    }
};
// gzip footer: -8 to -4 = CRC, -4 to -0 is length
// gzip start
var $461bf5d8bd29e0d8$var$gzs = function(d) {
    if (d[0] != 31 || d[1] != 139 || d[2] != 8) $461bf5d8bd29e0d8$var$err(6, 'invalid gzip data');
    var flg = d[3];
    var st = 10;
    if (flg & 4) st += d[10] | (d[11] << 8) + 2;
    for(var zs = (flg >> 3 & 1) + (flg >> 4 & 1); zs > 0; zs -= !d[st++]);
    return st + (flg & 2);
};
// gzip length
var $461bf5d8bd29e0d8$var$gzl = function(d) {
    var l = d.length;
    return (d[l - 4] | d[l - 3] << 8 | d[l - 2] << 16 | d[l - 1] << 24) >>> 0;
};
// gzip header length
var $461bf5d8bd29e0d8$var$gzhl = function(o) {
    return 10 + (o.filename && o.filename.length + 1 || 0);
};
// zlib header
var $461bf5d8bd29e0d8$var$zlh = function(c, o) {
    var lv = o.level, fl = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
    c[0] = 120, c[1] = fl << 6 | (fl ? 32 - 2 * fl : 1);
};
// zlib valid
var $461bf5d8bd29e0d8$var$zlv = function(d) {
    if ((d[0] & 15) != 8 || d[0] >>> 4 > 7 || (d[0] << 8 | d[1]) % 31) $461bf5d8bd29e0d8$var$err(6, 'invalid zlib data');
    if (d[1] & 32) $461bf5d8bd29e0d8$var$err(6, 'invalid zlib data: preset dictionaries not supported');
};
function $461bf5d8bd29e0d8$var$AsyncCmpStrm(opts, cb) {
    if (!cb && typeof opts == 'function') cb = opts, opts = {};
    this.ondata = cb;
    return opts;
}
// zlib footer: -4 to -0 is Adler32
/**
 * Streaming DEFLATE compression
 */ var $461bf5d8bd29e0d8$export$ae157b6234afe138 = /*#__PURE__*/ function() {
    function Deflate(opts, cb) {
        if (!cb && typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        this.o = opts || {};
    }
    Deflate.prototype.p = function(c, f) {
        this.ondata($461bf5d8bd29e0d8$var$dopt(c, this.o, 0, 0, !f), f);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Deflate.prototype.push = function(chunk, final) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (this.d) $461bf5d8bd29e0d8$var$err(4);
        this.d = final;
        this.p(chunk, final || false);
    };
    return Deflate;
}();
/**
 * Asynchronous streaming DEFLATE compression
 */ var $461bf5d8bd29e0d8$export$84e526fabcba03e3 = /*#__PURE__*/ function() {
    function AsyncDeflate(opts, cb) {
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bDflt,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$ae157b6234afe138
                ];
            }
        ], this, $461bf5d8bd29e0d8$var$AsyncCmpStrm.call(this, opts, cb), function(ev) {
            var strm = new $461bf5d8bd29e0d8$export$ae157b6234afe138(ev.data);
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 6);
    }
    return AsyncDeflate;
}();
function $461bf5d8bd29e0d8$export$2316623ecd1285ab(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bDflt
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$21533ff51b8a0b4a(ev.data[0], ev.data[1]));
    }, 0, cb);
}
function $461bf5d8bd29e0d8$export$21533ff51b8a0b4a(data, opts) {
    return $461bf5d8bd29e0d8$var$dopt(data, opts || {}, 0, 0);
}
/**
 * Streaming DEFLATE decompression
 */ var $461bf5d8bd29e0d8$export$d1de70a877d6e43c = /*#__PURE__*/ function() {
    /**
     * Creates an inflation stream
     * @param cb The callback to call whenever data is inflated
     */ function Inflate(cb) {
        this.s = {};
        this.p = new $461bf5d8bd29e0d8$var$u8(0);
        this.ondata = cb;
    }
    Inflate.prototype.e = function(c) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (this.d) $461bf5d8bd29e0d8$var$err(4);
        var l = this.p.length;
        var n = new $461bf5d8bd29e0d8$var$u8(l + c.length);
        n.set(this.p), n.set(c, l), this.p = n;
    };
    Inflate.prototype.c = function(final) {
        this.d = this.s.i = final || false;
        var bts = this.s.b;
        var dt = $461bf5d8bd29e0d8$var$inflt(this.p, this.o, this.s);
        this.ondata($461bf5d8bd29e0d8$var$slc(dt, bts, this.s.b), this.d);
        this.o = $461bf5d8bd29e0d8$var$slc(dt, this.s.b - 32768), this.s.b = this.o.length;
        this.p = $461bf5d8bd29e0d8$var$slc(this.p, this.s.p / 8 | 0), this.s.p &= 7;
    };
    /**
     * Pushes a chunk to be inflated
     * @param chunk The chunk to push
     * @param final Whether this is the final chunk
     */ Inflate.prototype.push = function(chunk, final) {
        this.e(chunk), this.c(final);
    };
    return Inflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression
 */ var $461bf5d8bd29e0d8$export$fff8358d6dbaa9cc = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous inflation stream
     * @param cb The callback to call whenever data is deflated
     */ function AsyncInflate(cb) {
        this.ondata = cb;
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bInflt,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$d1de70a877d6e43c
                ];
            }
        ], this, 0, function() {
            var strm = new $461bf5d8bd29e0d8$export$d1de70a877d6e43c();
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 7);
    }
    return AsyncInflate;
}();
function $461bf5d8bd29e0d8$export$cae1ce83fe4a1782(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bInflt
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$90366d8b308ba94a(ev.data[0], $461bf5d8bd29e0d8$var$gu8(ev.data[1])));
    }, 1, cb);
}
function $461bf5d8bd29e0d8$export$90366d8b308ba94a(data, out) {
    return $461bf5d8bd29e0d8$var$inflt(data, out);
}
// before you yell at me for not just using extends, my reason is that TS inheritance is hard to workerize.
/**
 * Streaming GZIP compression
 */ var $461bf5d8bd29e0d8$export$8e4b66d280bf8342 = /*#__PURE__*/ function() {
    function Gzip(opts, cb) {
        this.c = $461bf5d8bd29e0d8$var$crc();
        this.l = 0;
        this.v = 1;
        $461bf5d8bd29e0d8$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gzip.prototype.push = function(chunk, final) {
        $461bf5d8bd29e0d8$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Gzip.prototype.p = function(c, f) {
        this.c.p(c);
        this.l += c.length;
        var raw = $461bf5d8bd29e0d8$var$dopt(c, this.o, this.v && $461bf5d8bd29e0d8$var$gzhl(this.o), f && 8, !f);
        if (this.v) $461bf5d8bd29e0d8$var$gzh(raw, this.o), this.v = 0;
        if (f) $461bf5d8bd29e0d8$var$wbytes(raw, raw.length - 8, this.c.d()), $461bf5d8bd29e0d8$var$wbytes(raw, raw.length - 4, this.l);
        this.ondata(raw, f);
    };
    return Gzip;
}();
/**
 * Asynchronous streaming GZIP compression
 */ var $461bf5d8bd29e0d8$export$b4c75ae96cdf708b = /*#__PURE__*/ function() {
    function AsyncGzip(opts, cb) {
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bDflt,
            $461bf5d8bd29e0d8$var$gze,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$ae157b6234afe138,
                    $461bf5d8bd29e0d8$export$8e4b66d280bf8342
                ];
            }
        ], this, $461bf5d8bd29e0d8$var$AsyncCmpStrm.call(this, opts, cb), function(ev) {
            var strm = new $461bf5d8bd29e0d8$export$8e4b66d280bf8342(ev.data);
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 8);
    }
    return AsyncGzip;
}();
function $461bf5d8bd29e0d8$export$69f0ea7cf3a331a8(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bDflt,
        $461bf5d8bd29e0d8$var$gze,
        function() {
            return [
                $461bf5d8bd29e0d8$export$3d616c3fb3e15483
            ];
        }
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$3d616c3fb3e15483(ev.data[0], ev.data[1]));
    }, 2, cb);
}
function $461bf5d8bd29e0d8$export$3d616c3fb3e15483(data, opts) {
    if (!opts) opts = {};
    var c = $461bf5d8bd29e0d8$var$crc(), l = data.length;
    c.p(data);
    var d = $461bf5d8bd29e0d8$var$dopt(data, opts, $461bf5d8bd29e0d8$var$gzhl(opts), 8), s = d.length;
    return $461bf5d8bd29e0d8$var$gzh(d, opts), $461bf5d8bd29e0d8$var$wbytes(d, s - 8, c.d()), $461bf5d8bd29e0d8$var$wbytes(d, s - 4, l), d;
}
/**
 * Streaming GZIP decompression
 */ var $461bf5d8bd29e0d8$export$4cb607de6db70415 = /*#__PURE__*/ function() {
    /**
     * Creates a GUNZIP stream
     * @param cb The callback to call whenever data is inflated
     */ function Gunzip(cb) {
        this.v = 1;
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.call(this, cb);
    }
    /**
     * Pushes a chunk to be GUNZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gunzip.prototype.push = function(chunk, final) {
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        if (this.v) {
            var s = this.p.length > 3 ? $461bf5d8bd29e0d8$var$gzs(this.p) : 4;
            if (s >= this.p.length && !final) return;
            this.p = this.p.subarray(s), this.v = 0;
        }
        if (final) {
            if (this.p.length < 8) $461bf5d8bd29e0d8$var$err(6, 'invalid gzip data');
            this.p = this.p.subarray(0, -8);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.prototype.c.call(this, final);
    };
    return Gunzip;
}();
/**
 * Asynchronous streaming GZIP decompression
 */ var $461bf5d8bd29e0d8$export$d5adcdd968132151 = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous GUNZIP stream
     * @param cb The callback to call whenever data is deflated
     */ function AsyncGunzip(cb) {
        this.ondata = cb;
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bInflt,
            $461bf5d8bd29e0d8$var$guze,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$d1de70a877d6e43c,
                    $461bf5d8bd29e0d8$export$4cb607de6db70415
                ];
            }
        ], this, 0, function() {
            var strm = new $461bf5d8bd29e0d8$export$4cb607de6db70415();
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 9);
    }
    return AsyncGunzip;
}();
function $461bf5d8bd29e0d8$export$b6df3e950734d697(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bInflt,
        $461bf5d8bd29e0d8$var$guze,
        function() {
            return [
                $461bf5d8bd29e0d8$export$c80456f7aaba691c
            ];
        }
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$c80456f7aaba691c(ev.data[0]));
    }, 3, cb);
}
function $461bf5d8bd29e0d8$export$c80456f7aaba691c(data, out) {
    return $461bf5d8bd29e0d8$var$inflt(data.subarray($461bf5d8bd29e0d8$var$gzs(data), -8), out || new $461bf5d8bd29e0d8$var$u8($461bf5d8bd29e0d8$var$gzl(data)));
}
/**
 * Streaming Zlib compression
 */ var $461bf5d8bd29e0d8$export$4187ccf2467013b9 = /*#__PURE__*/ function() {
    function Zlib(opts, cb) {
        this.c = $461bf5d8bd29e0d8$var$adler();
        this.v = 1;
        $461bf5d8bd29e0d8$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be zlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Zlib.prototype.push = function(chunk, final) {
        $461bf5d8bd29e0d8$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Zlib.prototype.p = function(c, f) {
        this.c.p(c);
        var raw = $461bf5d8bd29e0d8$var$dopt(c, this.o, this.v && 2, f && 4, !f);
        if (this.v) $461bf5d8bd29e0d8$var$zlh(raw, this.o), this.v = 0;
        if (f) $461bf5d8bd29e0d8$var$wbytes(raw, raw.length - 4, this.c.d());
        this.ondata(raw, f);
    };
    return Zlib;
}();
/**
 * Asynchronous streaming Zlib compression
 */ var $461bf5d8bd29e0d8$export$bedbe3a2c2136490 = /*#__PURE__*/ function() {
    function AsyncZlib(opts, cb) {
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bDflt,
            $461bf5d8bd29e0d8$var$zle,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$ae157b6234afe138,
                    $461bf5d8bd29e0d8$export$4187ccf2467013b9
                ];
            }
        ], this, $461bf5d8bd29e0d8$var$AsyncCmpStrm.call(this, opts, cb), function(ev) {
            var strm = new $461bf5d8bd29e0d8$export$4187ccf2467013b9(ev.data);
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 10);
    }
    return AsyncZlib;
}();
function $461bf5d8bd29e0d8$export$925212de7058410b(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bDflt,
        $461bf5d8bd29e0d8$var$zle,
        function() {
            return [
                $461bf5d8bd29e0d8$export$f87121a6d50aff25
            ];
        }
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$f87121a6d50aff25(ev.data[0], ev.data[1]));
    }, 4, cb);
}
function $461bf5d8bd29e0d8$export$f87121a6d50aff25(data, opts) {
    if (!opts) opts = {};
    var a = $461bf5d8bd29e0d8$var$adler();
    a.p(data);
    var d = $461bf5d8bd29e0d8$var$dopt(data, opts, 2, 4);
    return $461bf5d8bd29e0d8$var$zlh(d, opts), $461bf5d8bd29e0d8$var$wbytes(d, d.length - 4, a.d()), d;
}
/**
 * Streaming Zlib decompression
 */ var $461bf5d8bd29e0d8$export$af2424f875ff1b17 = /*#__PURE__*/ function() {
    /**
     * Creates a Zlib decompression stream
     * @param cb The callback to call whenever data is inflated
     */ function Unzlib(cb) {
        this.v = 1;
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.call(this, cb);
    }
    /**
     * Pushes a chunk to be unzlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzlib.prototype.push = function(chunk, final) {
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        if (this.v) {
            if (this.p.length < 2 && !final) return;
            this.p = this.p.subarray(2), this.v = 0;
        }
        if (final) {
            if (this.p.length < 4) $461bf5d8bd29e0d8$var$err(6, 'invalid zlib data');
            this.p = this.p.subarray(0, -4);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.prototype.c.call(this, final);
    };
    return Unzlib;
}();
/**
 * Asynchronous streaming Zlib decompression
 */ var $461bf5d8bd29e0d8$export$cf6668790220dcad = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous Zlib decompression stream
     * @param cb The callback to call whenever data is deflated
     */ function AsyncUnzlib(cb) {
        this.ondata = cb;
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bInflt,
            $461bf5d8bd29e0d8$var$zule,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$d1de70a877d6e43c,
                    $461bf5d8bd29e0d8$export$af2424f875ff1b17
                ];
            }
        ], this, 0, function() {
            var strm = new $461bf5d8bd29e0d8$export$af2424f875ff1b17();
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 11);
    }
    return AsyncUnzlib;
}();
function $461bf5d8bd29e0d8$export$ca7cbb494e731274(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bInflt,
        $461bf5d8bd29e0d8$var$zule,
        function() {
            return [
                $461bf5d8bd29e0d8$export$9ec8134f0f1b9fc6
            ];
        }
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$9ec8134f0f1b9fc6(ev.data[0], $461bf5d8bd29e0d8$var$gu8(ev.data[1])));
    }, 5, cb);
}
function $461bf5d8bd29e0d8$export$9ec8134f0f1b9fc6(data, out) {
    return $461bf5d8bd29e0d8$var$inflt(($461bf5d8bd29e0d8$var$zlv(data), data.subarray(2, -4)), out);
}
/**
 * Streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $461bf5d8bd29e0d8$export$578fe199ef655b76 = /*#__PURE__*/ function() {
    /**
     * Creates a decompression stream
     * @param cb The callback to call whenever data is decompressed
     */ function Decompress(cb) {
        this.G = $461bf5d8bd29e0d8$export$4cb607de6db70415;
        this.I = $461bf5d8bd29e0d8$export$d1de70a877d6e43c;
        this.Z = $461bf5d8bd29e0d8$export$af2424f875ff1b17;
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Decompress.prototype.push = function(chunk, final) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (!this.s) {
            if (this.p && this.p.length) {
                var n = new $461bf5d8bd29e0d8$var$u8(this.p.length + chunk.length);
                n.set(this.p), n.set(chunk, this.p.length);
            } else this.p = chunk;
            if (this.p.length > 2) {
                var _this_1 = this;
                var cb = function() {
                    _this_1.ondata.apply(_this_1, arguments);
                };
                this.s = this.p[0] == 31 && this.p[1] == 139 && this.p[2] == 8 ? new this.G(cb) : (this.p[0] & 15) != 8 || this.p[0] >> 4 > 7 || (this.p[0] << 8 | this.p[1]) % 31 ? new this.I(cb) : new this.Z(cb);
                this.s.push(this.p, final);
                this.p = null;
            }
        } else this.s.push(chunk, final);
    };
    return Decompress;
}();
/**
 * Asynchronous streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $461bf5d8bd29e0d8$export$ae2c1d81988d4b43 = /*#__PURE__*/ function() {
    /**
   * Creates an asynchronous decompression stream
   * @param cb The callback to call whenever data is decompressed
   */ function AsyncDecompress(cb) {
        this.G = $461bf5d8bd29e0d8$export$d5adcdd968132151;
        this.I = $461bf5d8bd29e0d8$export$fff8358d6dbaa9cc;
        this.Z = $461bf5d8bd29e0d8$export$cf6668790220dcad;
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncDecompress.prototype.push = function(chunk, final) {
        $461bf5d8bd29e0d8$export$578fe199ef655b76.prototype.push.call(this, chunk, final);
    };
    return AsyncDecompress;
}();
function $461bf5d8bd29e0d8$export$678d868aab8fb3c7(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $461bf5d8bd29e0d8$export$b6df3e950734d697(data, opts, cb) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $461bf5d8bd29e0d8$export$cae1ce83fe4a1782(data, opts, cb) : $461bf5d8bd29e0d8$export$ca7cbb494e731274(data, opts, cb);
}
function $461bf5d8bd29e0d8$export$c4bdbbbc9a4faabe(data, out) {
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $461bf5d8bd29e0d8$export$c80456f7aaba691c(data, out) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $461bf5d8bd29e0d8$export$90366d8b308ba94a(data, out) : $461bf5d8bd29e0d8$export$9ec8134f0f1b9fc6(data, out);
}
// flatten a directory structure
var $461bf5d8bd29e0d8$var$fltn = function(d, p, t, o) {
    for(var k in d){
        var val = d[k], n = p + k, op = o;
        if (Array.isArray(val)) op = $461bf5d8bd29e0d8$var$mrg(o, val[1]), val = val[0];
        if (val instanceof $461bf5d8bd29e0d8$var$u8) t[n] = [
            val,
            op
        ];
        else {
            t[n += '/'] = [
                new $461bf5d8bd29e0d8$var$u8(0),
                op
            ];
            $461bf5d8bd29e0d8$var$fltn(val, n, t, o);
        }
    }
};
// text encoder
var $461bf5d8bd29e0d8$var$te = typeof TextEncoder != 'undefined' && /*#__PURE__*/ new TextEncoder();
// text decoder
var $461bf5d8bd29e0d8$var$td = typeof TextDecoder != 'undefined' && /*#__PURE__*/ new TextDecoder();
// text decoder stream
var $461bf5d8bd29e0d8$var$tds = 0;
try {
    $461bf5d8bd29e0d8$var$td.decode($461bf5d8bd29e0d8$var$et, {
        stream: true
    });
    $461bf5d8bd29e0d8$var$tds = 1;
} catch (e) {}
// decode UTF8
var $461bf5d8bd29e0d8$var$dutf8 = function(d) {
    for(var r = '', i = 0;;){
        var c = d[i++];
        var eb = (c > 127) + (c > 223) + (c > 239);
        if (i + eb > d.length) return [
            r,
            $461bf5d8bd29e0d8$var$slc(d, i - 1)
        ];
        if (!eb) r += String.fromCharCode(c);
        else if (eb == 3) c = ((c & 15) << 18 | (d[i++] & 63) << 12 | (d[i++] & 63) << 6 | d[i++] & 63) - 65536, r += String.fromCharCode(55296 | c >> 10, 56320 | c & 1023);
        else if (eb & 1) r += String.fromCharCode((c & 31) << 6 | d[i++] & 63);
        else r += String.fromCharCode((c & 15) << 12 | (d[i++] & 63) << 6 | d[i++] & 63);
    }
};
/**
 * Streaming UTF-8 decoding
 */ var $461bf5d8bd29e0d8$export$ba46860a31c72e94 = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is decoded
     */ function DecodeUTF8(cb) {
        this.ondata = cb;
        if ($461bf5d8bd29e0d8$var$tds) this.t = new TextDecoder();
        else this.p = $461bf5d8bd29e0d8$var$et;
    }
    /**
     * Pushes a chunk to be decoded from UTF-8 binary
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ DecodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        final = !!final;
        if (this.t) {
            this.ondata(this.t.decode(chunk, {
                stream: true
            }), final);
            if (final) {
                if (this.t.decode().length) $461bf5d8bd29e0d8$var$err(8);
                this.t = null;
            }
            return;
        }
        if (!this.p) $461bf5d8bd29e0d8$var$err(4);
        var dat = new $461bf5d8bd29e0d8$var$u8(this.p.length + chunk.length);
        dat.set(this.p);
        dat.set(chunk, this.p.length);
        var _a = $461bf5d8bd29e0d8$var$dutf8(dat), ch = _a[0], np = _a[1];
        if (final) {
            if (np.length) $461bf5d8bd29e0d8$var$err(8);
            this.p = null;
        } else this.p = np;
        this.ondata(ch, final);
    };
    return DecodeUTF8;
}();
/**
 * Streaming UTF-8 encoding
 */ var $461bf5d8bd29e0d8$export$283f13d12b1b210e = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is encoded
     */ function EncodeUTF8(cb) {
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be encoded to UTF-8
     * @param chunk The string data to push
     * @param final Whether this is the last chunk
     */ EncodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (this.d) $461bf5d8bd29e0d8$var$err(4);
        this.ondata($461bf5d8bd29e0d8$export$366b39a6daa8ed7a(chunk), this.d = final || false);
    };
    return EncodeUTF8;
}();
function $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(str, latin1) {
    if (latin1) {
        var ar_1 = new $461bf5d8bd29e0d8$var$u8(str.length);
        for(var i = 0; i < str.length; ++i)ar_1[i] = str.charCodeAt(i);
        return ar_1;
    }
    if ($461bf5d8bd29e0d8$var$te) return $461bf5d8bd29e0d8$var$te.encode(str);
    var l = str.length;
    var ar = new $461bf5d8bd29e0d8$var$u8(str.length + (str.length >> 1));
    var ai = 0;
    var w = function(v) {
        ar[ai++] = v;
    };
    for(var i = 0; i < l; ++i){
        if (ai + 5 > ar.length) {
            var n = new $461bf5d8bd29e0d8$var$u8(ai + 8 + (l - i << 1));
            n.set(ar);
            ar = n;
        }
        var c = str.charCodeAt(i);
        if (c < 128 || latin1) w(c);
        else if (c < 2048) w(192 | c >> 6), w(128 | c & 63);
        else if (c > 55295 && c < 57344) c = 65536 + (c & 1047552) | str.charCodeAt(++i) & 1023, w(240 | c >> 18), w(128 | c >> 12 & 63), w(128 | c >> 6 & 63), w(128 | c & 63);
        else w(224 | c >> 12), w(128 | c >> 6 & 63), w(128 | c & 63);
    }
    return $461bf5d8bd29e0d8$var$slc(ar, 0, ai);
}
function $461bf5d8bd29e0d8$export$adb211f8cb999894(dat, latin1) {
    if (latin1) {
        var r = '';
        for(var i = 0; i < dat.length; i += 16384)r += String.fromCharCode.apply(null, dat.subarray(i, i + 16384));
        return r;
    } else if ($461bf5d8bd29e0d8$var$td) return $461bf5d8bd29e0d8$var$td.decode(dat);
    else {
        var _a = $461bf5d8bd29e0d8$var$dutf8(dat), out = _a[0], ext = _a[1];
        if (ext.length) $461bf5d8bd29e0d8$var$err(8);
        return out;
    }
}
// deflate bit flag
var $461bf5d8bd29e0d8$var$dbf = function(l) {
    return l == 1 ? 3 : l < 6 ? 2 : l == 9 ? 1 : 0;
};
// skip local zip header
var $461bf5d8bd29e0d8$var$slzh = function(d, b) {
    return b + 30 + $461bf5d8bd29e0d8$var$b2(d, b + 26) + $461bf5d8bd29e0d8$var$b2(d, b + 28);
};
// read zip header
var $461bf5d8bd29e0d8$var$zh = function(d, b, z) {
    var fnl = $461bf5d8bd29e0d8$var$b2(d, b + 28), fn = $461bf5d8bd29e0d8$export$adb211f8cb999894(d.subarray(b + 46, b + 46 + fnl), !($461bf5d8bd29e0d8$var$b2(d, b + 8) & 2048)), es = b + 46 + fnl, bs = $461bf5d8bd29e0d8$var$b4(d, b + 20);
    var _a = z && bs == 4294967295 ? $461bf5d8bd29e0d8$var$z64e(d, es) : [
        bs,
        $461bf5d8bd29e0d8$var$b4(d, b + 24),
        $461bf5d8bd29e0d8$var$b4(d, b + 42)
    ], sc = _a[0], su = _a[1], off = _a[2];
    return [
        $461bf5d8bd29e0d8$var$b2(d, b + 10),
        sc,
        su,
        fn,
        es + $461bf5d8bd29e0d8$var$b2(d, b + 30) + $461bf5d8bd29e0d8$var$b2(d, b + 32),
        off
    ];
};
// read zip64 extra field
var $461bf5d8bd29e0d8$var$z64e = function(d, b) {
    for(; $461bf5d8bd29e0d8$var$b2(d, b) != 1; b += 4 + $461bf5d8bd29e0d8$var$b2(d, b + 2));
    return [
        $461bf5d8bd29e0d8$var$b8(d, b + 12),
        $461bf5d8bd29e0d8$var$b8(d, b + 4),
        $461bf5d8bd29e0d8$var$b8(d, b + 20)
    ];
};
// extra field length
var $461bf5d8bd29e0d8$var$exfl = function(ex) {
    var le = 0;
    if (ex) for(var k in ex){
        var l = ex[k].length;
        if (l > 65535) $461bf5d8bd29e0d8$var$err(9);
        le += l + 4;
    }
    return le;
};
// write zip header
var $461bf5d8bd29e0d8$var$wzh = function(d, b, f, fn, u, c, ce, co) {
    var fl = fn.length, ex = f.extra, col = co && co.length;
    var exl = $461bf5d8bd29e0d8$var$exfl(ex);
    $461bf5d8bd29e0d8$var$wbytes(d, b, ce != null ? 0x2014B50 : 0x4034B50), b += 4;
    if (ce != null) d[b++] = 20, d[b++] = f.os;
    d[b] = 20, b += 2; // spec compliance? what's that?
    d[b++] = f.flag << 1 | (c == null && 8), d[b++] = u && 8;
    d[b++] = f.compression & 255, d[b++] = f.compression >> 8;
    var dt = new Date(f.mtime == null ? Date.now() : f.mtime), y = dt.getFullYear() - 1980;
    if (y < 0 || y > 119) $461bf5d8bd29e0d8$var$err(10);
    $461bf5d8bd29e0d8$var$wbytes(d, b, y << 25 | dt.getMonth() + 1 << 21 | dt.getDate() << 16 | dt.getHours() << 11 | dt.getMinutes() << 5 | dt.getSeconds() >>> 1), b += 4;
    if (c != null) {
        $461bf5d8bd29e0d8$var$wbytes(d, b, f.crc);
        $461bf5d8bd29e0d8$var$wbytes(d, b + 4, c);
        $461bf5d8bd29e0d8$var$wbytes(d, b + 8, f.size);
    }
    $461bf5d8bd29e0d8$var$wbytes(d, b + 12, fl);
    $461bf5d8bd29e0d8$var$wbytes(d, b + 14, exl), b += 16;
    if (ce != null) {
        $461bf5d8bd29e0d8$var$wbytes(d, b, col);
        $461bf5d8bd29e0d8$var$wbytes(d, b + 6, f.attrs);
        $461bf5d8bd29e0d8$var$wbytes(d, b + 10, ce), b += 14;
    }
    d.set(fn, b);
    b += fl;
    if (exl) for(var k in ex){
        var exf = ex[k], l = exf.length;
        $461bf5d8bd29e0d8$var$wbytes(d, b, +k);
        $461bf5d8bd29e0d8$var$wbytes(d, b + 2, l);
        d.set(exf, b + 4), b += 4 + l;
    }
    if (col) d.set(co, b), b += col;
    return b;
};
// write zip footer (end of central directory)
var $461bf5d8bd29e0d8$var$wzf = function(o, b, c, d, e) {
    $461bf5d8bd29e0d8$var$wbytes(o, b, 0x6054B50); // skip disk
    $461bf5d8bd29e0d8$var$wbytes(o, b + 8, c);
    $461bf5d8bd29e0d8$var$wbytes(o, b + 10, c);
    $461bf5d8bd29e0d8$var$wbytes(o, b + 12, d);
    $461bf5d8bd29e0d8$var$wbytes(o, b + 16, e);
};
/**
 * A pass-through stream to keep data uncompressed in a ZIP archive.
 */ var $461bf5d8bd29e0d8$export$2b25194e1767ea06 = /*#__PURE__*/ function() {
    /**
     * Creates a pass-through stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     */ function ZipPassThrough(filename) {
        this.filename = filename;
        this.c = $461bf5d8bd29e0d8$var$crc();
        this.size = 0;
        this.compression = 0;
    }
    /**
     * Processes a chunk and pushes to the output stream. You can override this
     * method in a subclass for custom behavior, but by default this passes
     * the data through. You must call this.ondata(err, chunk, final) at some
     * point in this method.
     * @param chunk The chunk to process
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.process = function(chunk, final) {
        this.ondata(null, chunk, final);
    };
    /**
     * Pushes a chunk to be added. If you are subclassing this with a custom
     * compression algorithm, note that you must push data from the source
     * file only, pre-compression.
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.push = function(chunk, final) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        this.c.p(chunk);
        this.size += chunk.length;
        if (final) this.crc = this.c.d();
        this.process(chunk, final || false);
    };
    return ZipPassThrough;
}();
// I don't extend because TypeScript extension adds 1kB of runtime bloat
/**
 * Streaming DEFLATE compression for ZIP archives. Prefer using AsyncZipDeflate
 * for better performance
 */ var $461bf5d8bd29e0d8$export$f7e481ca646388b6 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function ZipDeflate(filename, opts) {
        var _this_1 = this;
        if (!opts) opts = {};
        $461bf5d8bd29e0d8$export$2b25194e1767ea06.call(this, filename);
        this.d = new $461bf5d8bd29e0d8$export$ae157b6234afe138(opts, function(dat, final) {
            _this_1.ondata(null, dat, final);
        });
        this.compression = 8;
        this.flag = $461bf5d8bd29e0d8$var$dbf(opts.level);
    }
    ZipDeflate.prototype.process = function(chunk, final) {
        try {
            this.d.push(chunk, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipDeflate.prototype.push = function(chunk, final) {
        $461bf5d8bd29e0d8$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return ZipDeflate;
}();
/**
 * Asynchronous streaming DEFLATE compression for ZIP archives
 */ var $461bf5d8bd29e0d8$export$ffb5e59e179924b2 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function AsyncZipDeflate(filename, opts) {
        var _this_1 = this;
        if (!opts) opts = {};
        $461bf5d8bd29e0d8$export$2b25194e1767ea06.call(this, filename);
        this.d = new $461bf5d8bd29e0d8$export$84e526fabcba03e3(opts, function(err, dat, final) {
            _this_1.ondata(err, dat, final);
        });
        this.compression = 8;
        this.flag = $461bf5d8bd29e0d8$var$dbf(opts.level);
        this.terminate = this.d.terminate;
    }
    AsyncZipDeflate.prototype.process = function(chunk, final) {
        this.d.push(chunk, final);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncZipDeflate.prototype.push = function(chunk, final) {
        $461bf5d8bd29e0d8$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return AsyncZipDeflate;
}();
// TODO: Better tree shaking
/**
 * A zippable archive to which files can incrementally be added
 */ var $461bf5d8bd29e0d8$export$9a4d4a7c32a75d2f = /*#__PURE__*/ function() {
    /**
     * Creates an empty ZIP archive to which files can be added
     * @param cb The callback to call whenever data for the generated ZIP archive
     *           is available
     */ function Zip(cb) {
        this.ondata = cb;
        this.u = [];
        this.d = 1;
    }
    /**
     * Adds a file to the ZIP archive
     * @param file The file stream to add
     */ Zip.prototype.add = function(file) {
        var _this_1 = this;
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        // finishing or finished
        if (this.d & 2) this.ondata($461bf5d8bd29e0d8$var$err(4 + (this.d & 1) * 8, 0, 1), null, false);
        else {
            var f = $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(file.filename), fl_1 = f.length;
            var com = file.comment, o = com && $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(com);
            var u = fl_1 != file.filename.length || o && com.length != o.length;
            var hl_1 = fl_1 + $461bf5d8bd29e0d8$var$exfl(file.extra) + 30;
            if (fl_1 > 65535) this.ondata($461bf5d8bd29e0d8$var$err(11, 0, 1), null, false);
            var header = new $461bf5d8bd29e0d8$var$u8(hl_1);
            $461bf5d8bd29e0d8$var$wzh(header, 0, file, f, u);
            var chks_1 = [
                header
            ];
            var pAll_1 = function() {
                for(var _i = 0, chks_2 = chks_1; _i < chks_2.length; _i++){
                    var chk = chks_2[_i];
                    _this_1.ondata(null, chk, false);
                }
                chks_1 = [];
            };
            var tr_1 = this.d;
            this.d = 0;
            var ind_1 = this.u.length;
            var uf_1 = $461bf5d8bd29e0d8$var$mrg(file, {
                f: f,
                u: u,
                o: o,
                t: function() {
                    if (file.terminate) file.terminate();
                },
                r: function() {
                    pAll_1();
                    if (tr_1) {
                        var nxt = _this_1.u[ind_1 + 1];
                        if (nxt) nxt.r();
                        else _this_1.d = 1;
                    }
                    tr_1 = 1;
                }
            });
            var cl_1 = 0;
            file.ondata = function(err, dat, final) {
                if (err) {
                    _this_1.ondata(err, dat, final);
                    _this_1.terminate();
                } else {
                    cl_1 += dat.length;
                    chks_1.push(dat);
                    if (final) {
                        var dd = new $461bf5d8bd29e0d8$var$u8(16);
                        $461bf5d8bd29e0d8$var$wbytes(dd, 0, 0x8074B50);
                        $461bf5d8bd29e0d8$var$wbytes(dd, 4, file.crc);
                        $461bf5d8bd29e0d8$var$wbytes(dd, 8, cl_1);
                        $461bf5d8bd29e0d8$var$wbytes(dd, 12, file.size);
                        chks_1.push(dd);
                        uf_1.c = cl_1, uf_1.b = hl_1 + cl_1 + 16, uf_1.crc = file.crc, uf_1.size = file.size;
                        if (tr_1) uf_1.r();
                        tr_1 = 1;
                    } else if (tr_1) pAll_1();
                }
            };
            this.u.push(uf_1);
        }
    };
    /**
     * Ends the process of adding files and prepares to emit the final chunks.
     * This *must* be called after adding all desired files for the resulting
     * ZIP file to work properly.
     */ Zip.prototype.end = function() {
        var _this_1 = this;
        if (this.d & 2) {
            this.ondata($461bf5d8bd29e0d8$var$err(4 + (this.d & 1) * 8, 0, 1), null, true);
            return;
        }
        if (this.d) this.e();
        else this.u.push({
            r: function() {
                if (!(_this_1.d & 1)) return;
                _this_1.u.splice(-1, 1);
                _this_1.e();
            },
            t: function() {}
        });
        this.d = 3;
    };
    Zip.prototype.e = function() {
        var bt = 0, l = 0, tl = 0;
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            tl += 46 + f.f.length + $461bf5d8bd29e0d8$var$exfl(f.extra) + (f.o ? f.o.length : 0);
        }
        var out = new $461bf5d8bd29e0d8$var$u8(tl + 22);
        for(var _b = 0, _c = this.u; _b < _c.length; _b++){
            var f = _c[_b];
            $461bf5d8bd29e0d8$var$wzh(out, bt, f, f.f, f.u, f.c, l, f.o);
            bt += 46 + f.f.length + $461bf5d8bd29e0d8$var$exfl(f.extra) + (f.o ? f.o.length : 0), l += f.b;
        }
        $461bf5d8bd29e0d8$var$wzf(out, bt, this.u.length, tl, l);
        this.ondata(null, out, true);
        this.d = 2;
    };
    /**
     * A method to terminate any internal workers used by the stream. Subsequent
     * calls to add() will fail.
     */ Zip.prototype.terminate = function() {
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            f.t();
        }
        this.d = 2;
    };
    return Zip;
}();
function $461bf5d8bd29e0d8$export$8901015135f2fb22(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    var r = {};
    $461bf5d8bd29e0d8$var$fltn(data, '', r, opts);
    var k = Object.keys(r);
    var lft = k.length, o = 0, tot = 0;
    var slft = lft, files = new Array(lft);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var cbd = function(a, b) {
        $461bf5d8bd29e0d8$var$mt(function() {
            cb(a, b);
        });
    };
    $461bf5d8bd29e0d8$var$mt(function() {
        cbd = cb;
    });
    var cbf = function() {
        var out = new $461bf5d8bd29e0d8$var$u8(tot + 22), oe = o, cdl = tot - o;
        tot = 0;
        for(var i = 0; i < slft; ++i){
            var f = files[i];
            try {
                var l = f.c.length;
                $461bf5d8bd29e0d8$var$wzh(out, tot, f, f.f, f.u, l);
                var badd = 30 + f.f.length + $461bf5d8bd29e0d8$var$exfl(f.extra);
                var loc = tot + badd;
                out.set(f.c, loc);
                $461bf5d8bd29e0d8$var$wzh(out, o, f, f.f, f.u, l, tot, f.m), o += 16 + badd + (f.m ? f.m.length : 0), tot = loc + l;
            } catch (e) {
                return cbd(e, null);
            }
        }
        $461bf5d8bd29e0d8$var$wzf(out, o, files.length, cdl, oe);
        cbd(null, out);
    };
    if (!lft) cbf();
    var _loop_1 = function(i) {
        var fn = k[i];
        var _a = r[fn], file = _a[0], p = _a[1];
        var c = $461bf5d8bd29e0d8$var$crc(), size = file.length;
        c.p(file);
        var f = $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $461bf5d8bd29e0d8$var$exfl(p.extra);
        var compression = p.level == 0 ? 0 : 8;
        var cbl = function(e, d) {
            if (e) {
                tAll();
                cbd(e, null);
            } else {
                var l = d.length;
                files[i] = $461bf5d8bd29e0d8$var$mrg(p, {
                    size: size,
                    crc: c.d(),
                    c: d,
                    f: f,
                    m: m,
                    u: s != fn.length || m && com.length != ms,
                    compression: compression
                });
                o += 30 + s + exl + l;
                tot += 76 + 2 * (s + exl) + (ms || 0) + l;
                if (!--lft) cbf();
            }
        };
        if (s > 65535) cbl($461bf5d8bd29e0d8$var$err(11, 0, 1), null);
        if (!compression) cbl(null, file);
        else if (size < 160000) try {
            cbl(null, $461bf5d8bd29e0d8$export$21533ff51b8a0b4a(file, p));
        } catch (e) {
            cbl(e, null);
        }
        else term.push($461bf5d8bd29e0d8$export$2316623ecd1285ab(file, p, cbl));
    };
    // Cannot use lft because it can decrease
    for(var i = 0; i < slft; ++i)_loop_1(i);
    return tAll;
}
function $461bf5d8bd29e0d8$export$eb1654f146d54eb3(data, opts) {
    if (!opts) opts = {};
    var r = {};
    var files = [];
    $461bf5d8bd29e0d8$var$fltn(data, '', r, opts);
    var o = 0;
    var tot = 0;
    for(var fn in r){
        var _a = r[fn], file = _a[0], p = _a[1];
        var compression = p.level == 0 ? 0 : 8;
        var f = $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $461bf5d8bd29e0d8$var$exfl(p.extra);
        if (s > 65535) $461bf5d8bd29e0d8$var$err(11);
        var d = compression ? $461bf5d8bd29e0d8$export$21533ff51b8a0b4a(file, p) : file, l = d.length;
        var c = $461bf5d8bd29e0d8$var$crc();
        c.p(file);
        files.push($461bf5d8bd29e0d8$var$mrg(p, {
            size: file.length,
            crc: c.d(),
            c: d,
            f: f,
            m: m,
            u: s != fn.length || m && com.length != ms,
            o: o,
            compression: compression
        }));
        o += 30 + s + exl + l;
        tot += 76 + 2 * (s + exl) + (ms || 0) + l;
    }
    var out = new $461bf5d8bd29e0d8$var$u8(tot + 22), oe = o, cdl = tot - o;
    for(var i = 0; i < files.length; ++i){
        var f = files[i];
        $461bf5d8bd29e0d8$var$wzh(out, f.o, f, f.f, f.u, f.c.length);
        var badd = 30 + f.f.length + $461bf5d8bd29e0d8$var$exfl(f.extra);
        out.set(f.c, f.o + badd);
        $461bf5d8bd29e0d8$var$wzh(out, o, f, f.f, f.u, f.c.length, f.o, f.m), o += 16 + badd + (f.m ? f.m.length : 0);
    }
    $461bf5d8bd29e0d8$var$wzf(out, o, files.length, cdl, oe);
    return out;
}
/**
 * Streaming pass-through decompression for ZIP archives
 */ var $461bf5d8bd29e0d8$export$93f81d5bbbb7c6bf = /*#__PURE__*/ function() {
    function UnzipPassThrough() {}
    UnzipPassThrough.prototype.push = function(data, final) {
        this.ondata(null, data, final);
    };
    UnzipPassThrough.compression = 0;
    return UnzipPassThrough;
}();
/**
 * Streaming DEFLATE decompression for ZIP archives. Prefer AsyncZipInflate for
 * better performance.
 */ var $461bf5d8bd29e0d8$export$eb188945cc39e642 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function UnzipInflate() {
        var _this_1 = this;
        this.i = new $461bf5d8bd29e0d8$export$d1de70a877d6e43c(function(dat, final) {
            _this_1.ondata(null, dat, final);
        });
    }
    UnzipInflate.prototype.push = function(data, final) {
        try {
            this.i.push(data, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    UnzipInflate.compression = 8;
    return UnzipInflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression for ZIP archives
 */ var $461bf5d8bd29e0d8$export$6235d84645dad4f9 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function AsyncUnzipInflate(_, sz) {
        var _this_1 = this;
        if (sz < 320000) this.i = new $461bf5d8bd29e0d8$export$d1de70a877d6e43c(function(dat, final) {
            _this_1.ondata(null, dat, final);
        });
        else {
            this.i = new $461bf5d8bd29e0d8$export$fff8358d6dbaa9cc(function(err, dat, final) {
                _this_1.ondata(err, dat, final);
            });
            this.terminate = this.i.terminate;
        }
    }
    AsyncUnzipInflate.prototype.push = function(data, final) {
        if (this.i.terminate) data = $461bf5d8bd29e0d8$var$slc(data, 0);
        this.i.push(data, final);
    };
    AsyncUnzipInflate.compression = 8;
    return AsyncUnzipInflate;
}();
/**
 * A ZIP archive decompression stream that emits files as they are discovered
 */ var $461bf5d8bd29e0d8$export$9b7485f84cbaaa56 = /*#__PURE__*/ function() {
    /**
     * Creates a ZIP decompression stream
     * @param cb The callback to call whenever a file in the ZIP archive is found
     */ function Unzip(cb) {
        this.onfile = cb;
        this.k = [];
        this.o = {
            0: $461bf5d8bd29e0d8$export$93f81d5bbbb7c6bf
        };
        this.p = $461bf5d8bd29e0d8$var$et;
    }
    /**
     * Pushes a chunk to be unzipped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzip.prototype.push = function(chunk, final) {
        var _this_1 = this;
        if (!this.onfile) $461bf5d8bd29e0d8$var$err(5);
        if (!this.p) $461bf5d8bd29e0d8$var$err(4);
        if (this.c > 0) {
            var len = Math.min(this.c, chunk.length);
            var toAdd = chunk.subarray(0, len);
            this.c -= len;
            if (this.d) this.d.push(toAdd, !this.c);
            else this.k[0].push(toAdd);
            chunk = chunk.subarray(len);
            if (chunk.length) return this.push(chunk, final);
        } else {
            var f = 0, i = 0, is = void 0, buf = void 0;
            if (!this.p.length) buf = chunk;
            else if (!chunk.length) buf = this.p;
            else {
                buf = new $461bf5d8bd29e0d8$var$u8(this.p.length + chunk.length);
                buf.set(this.p), buf.set(chunk, this.p.length);
            }
            var l = buf.length, oc = this.c, add = oc && this.d;
            var _loop_2 = function() {
                var _a;
                var sig = $461bf5d8bd29e0d8$var$b4(buf, i);
                if (sig == 0x4034B50) {
                    f = 1, is = i;
                    this_1.d = null;
                    this_1.c = 0;
                    var bf = $461bf5d8bd29e0d8$var$b2(buf, i + 6), cmp_1 = $461bf5d8bd29e0d8$var$b2(buf, i + 8), u = bf & 2048, dd = bf & 8, fnl = $461bf5d8bd29e0d8$var$b2(buf, i + 26), es = $461bf5d8bd29e0d8$var$b2(buf, i + 28);
                    if (l > i + 30 + fnl + es) {
                        var chks_3 = [];
                        this_1.k.unshift(chks_3);
                        f = 2;
                        var sc_1 = $461bf5d8bd29e0d8$var$b4(buf, i + 18), su_1 = $461bf5d8bd29e0d8$var$b4(buf, i + 22);
                        var fn_1 = $461bf5d8bd29e0d8$export$adb211f8cb999894(buf.subarray(i + 30, i += 30 + fnl), !u);
                        if (sc_1 == 4294967295) _a = dd ? [
                            -2
                        ] : $461bf5d8bd29e0d8$var$z64e(buf, i), sc_1 = _a[0], su_1 = _a[1];
                        else if (dd) sc_1 = -1;
                        i += es;
                        this_1.c = sc_1;
                        var d_1;
                        var file_1 = {
                            name: fn_1,
                            compression: cmp_1,
                            start: function() {
                                if (!file_1.ondata) $461bf5d8bd29e0d8$var$err(5);
                                if (!sc_1) file_1.ondata(null, $461bf5d8bd29e0d8$var$et, true);
                                else {
                                    var ctr = _this_1.o[cmp_1];
                                    if (!ctr) file_1.ondata($461bf5d8bd29e0d8$var$err(14, 'unknown compression type ' + cmp_1, 1), null, false);
                                    d_1 = sc_1 < 0 ? new ctr(fn_1) : new ctr(fn_1, sc_1, su_1);
                                    d_1.ondata = function(err, dat, final) {
                                        file_1.ondata(err, dat, final);
                                    };
                                    for(var _i = 0, chks_4 = chks_3; _i < chks_4.length; _i++){
                                        var dat = chks_4[_i];
                                        d_1.push(dat, false);
                                    }
                                    if (_this_1.k[0] == chks_3 && _this_1.c) _this_1.d = d_1;
                                    else d_1.push($461bf5d8bd29e0d8$var$et, true);
                                }
                            },
                            terminate: function() {
                                if (d_1 && d_1.terminate) d_1.terminate();
                            }
                        };
                        if (sc_1 >= 0) file_1.size = sc_1, file_1.originalSize = su_1;
                        this_1.onfile(file_1);
                    }
                    return "break";
                } else if (oc) {
                    if (sig == 0x8074B50) {
                        is = i += 12 + (oc == -2 && 8), f = 3, this_1.c = 0;
                        return "break";
                    } else if (sig == 0x2014B50) {
                        is = i -= 4, f = 3, this_1.c = 0;
                        return "break";
                    }
                }
            };
            var this_1 = this;
            for(; i < l - 4; ++i){
                var state_1 = _loop_2();
                if (state_1 === "break") break;
            }
            this.p = $461bf5d8bd29e0d8$var$et;
            if (oc < 0) {
                var dat = f ? buf.subarray(0, is - 12 - (oc == -2 && 8) - ($461bf5d8bd29e0d8$var$b4(buf, is - 16) == 0x8074B50 && 4)) : buf.subarray(0, i);
                if (add) add.push(dat, !!f);
                else this.k[+(f == 2)].push(dat);
            }
            if (f & 2) return this.push(buf.subarray(i), final);
            this.p = buf.subarray(i);
        }
        if (final) {
            if (this.c) $461bf5d8bd29e0d8$var$err(13);
            this.p = null;
        }
    };
    /**
     * Registers a decoder with the stream, allowing for files compressed with
     * the compression type provided to be expanded correctly
     * @param decoder The decoder constructor
     */ Unzip.prototype.register = function(decoder) {
        this.o[decoder.compression] = decoder;
    };
    return Unzip;
}();
var $461bf5d8bd29e0d8$var$mt = typeof queueMicrotask == 'function' ? queueMicrotask : typeof setTimeout == 'function' ? setTimeout : function(fn) {
    fn();
};
function $461bf5d8bd29e0d8$export$23c8d3f8757cab88(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var files = {};
    var cbd = function(a, b) {
        $461bf5d8bd29e0d8$var$mt(function() {
            cb(a, b);
        });
    };
    $461bf5d8bd29e0d8$var$mt(function() {
        cbd = cb;
    });
    var e = data.length - 22;
    for(; $461bf5d8bd29e0d8$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) {
        cbd($461bf5d8bd29e0d8$var$err(13, 0, 1), null);
        return tAll;
    }
    var lft = $461bf5d8bd29e0d8$var$b2(data, e + 8);
    if (lft) {
        var c = lft;
        var o = $461bf5d8bd29e0d8$var$b4(data, e + 16);
        var z = o == 4294967295;
        if (z) {
            e = $461bf5d8bd29e0d8$var$b4(data, e - 12);
            if ($461bf5d8bd29e0d8$var$b4(data, e) != 0x6064B50) {
                cbd($461bf5d8bd29e0d8$var$err(13, 0, 1), null);
                return tAll;
            }
            c = lft = $461bf5d8bd29e0d8$var$b4(data, e + 32);
            o = $461bf5d8bd29e0d8$var$b4(data, e + 48);
        }
        var fltr = opts && opts.filter;
        var _loop_3 = function(i) {
            var _a = $461bf5d8bd29e0d8$var$zh(data, o, z), c_1 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $461bf5d8bd29e0d8$var$slzh(data, off);
            o = no;
            var cbl = function(e, d) {
                if (e) {
                    tAll();
                    cbd(e, null);
                } else {
                    if (d) files[fn] = d;
                    if (!--lft) cbd(null, files);
                }
            };
            if (!fltr || fltr({
                name: fn,
                size: sc,
                originalSize: su,
                compression: c_1
            })) {
                if (!c_1) cbl(null, $461bf5d8bd29e0d8$var$slc(data, b, b + sc));
                else if (c_1 == 8) {
                    var infl = data.subarray(b, b + sc);
                    if (sc < 320000) try {
                        cbl(null, $461bf5d8bd29e0d8$export$90366d8b308ba94a(infl, new $461bf5d8bd29e0d8$var$u8(su)));
                    } catch (e) {
                        cbl(e, null);
                    }
                    else term.push($461bf5d8bd29e0d8$export$cae1ce83fe4a1782(infl, {
                        size: su
                    }, cbl));
                } else cbl($461bf5d8bd29e0d8$var$err(14, 'unknown compression type ' + c_1, 1), null);
            } else cbl(null, null);
        };
        for(var i = 0; i < c; ++i)_loop_3(i);
    } else cbd(null, {});
    return tAll;
}
function $461bf5d8bd29e0d8$export$c757709326bb5901(data, opts) {
    var files = {};
    var e = data.length - 22;
    for(; $461bf5d8bd29e0d8$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) $461bf5d8bd29e0d8$var$err(13);
    var c = $461bf5d8bd29e0d8$var$b2(data, e + 8);
    if (!c) return {};
    var o = $461bf5d8bd29e0d8$var$b4(data, e + 16);
    var z = o == 4294967295;
    if (z) {
        e = $461bf5d8bd29e0d8$var$b4(data, e - 12);
        if ($461bf5d8bd29e0d8$var$b4(data, e) != 0x6064B50) $461bf5d8bd29e0d8$var$err(13);
        c = $461bf5d8bd29e0d8$var$b4(data, e + 32);
        o = $461bf5d8bd29e0d8$var$b4(data, e + 48);
    }
    var fltr = opts && opts.filter;
    for(var i = 0; i < c; ++i){
        var _a = $461bf5d8bd29e0d8$var$zh(data, o, z), c_2 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $461bf5d8bd29e0d8$var$slzh(data, off);
        o = no;
        if (!fltr || fltr({
            name: fn,
            size: sc,
            originalSize: su,
            compression: c_2
        })) {
            if (!c_2) files[fn] = $461bf5d8bd29e0d8$var$slc(data, b, b + sc);
            else if (c_2 == 8) files[fn] = $461bf5d8bd29e0d8$export$90366d8b308ba94a(data.subarray(b, b + sc), new $461bf5d8bd29e0d8$var$u8(su));
            else $461bf5d8bd29e0d8$var$err(14, 'unknown compression type ' + c_2);
        }
    }
    return files;
}

});

parcelRegister("cF21O", function(module, exports) {
/*! dicom-parser - 1.8.12 - 2023-02-20 | (c) 2017 Chris Hafey | https://github.com/cornerstonejs/dicomParser */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $937ae3202df95507$require$Buffer = $6ZWSX.Buffer;

!function(e, t) {
    module.exports = t((parcelRequire("kjyEk")));
}(module.exports, function(r) {
    var a, i;
    return a = [
        function(e, t) {
            e.exports = r;
        },
        function(e, t, s) {
            "use strict";
            s.r(t), s.d(t, "isStringVr", function() {
                return d;
            }), s.d(t, "isPrivateTag", function() {
                return f;
            }), s.d(t, "parsePN", function() {
                return a;
            }), s.d(t, "parseTM", function() {
                return n;
            }), s.d(t, "parseDA", function() {
                return o;
            }), s.d(t, "explicitElementToString", function() {
                return l;
            }), s.d(t, "explicitDataSetToJS", function() {
                return u;
            }), s.d(t, "createJPEGBasicOffsetTable", function() {
                return p;
            }), s.d(t, "parseDicomDataSetExplicit", function() {
                return q;
            }), s.d(t, "parseDicomDataSetImplicit", function() {
                return T;
            }), s.d(t, "readFixedString", function() {
                return b;
            }), s.d(t, "alloc", function() {
                return k;
            }), s.d(t, "version", function() {
                return L;
            }), s.d(t, "bigEndianByteArrayParser", function() {
                return N;
            }), s.d(t, "ByteStream", function() {
                return J;
            }), s.d(t, "sharedCopy", function() {
                return j;
            }), s.d(t, "DataSet", function() {
                return w;
            }), s.d(t, "findAndSetUNElementLength", function() {
                return y;
            }), s.d(t, "findEndOfEncapsulatedElement", function() {
                return g;
            }), s.d(t, "findItemDelimitationItemAndSetElementLength", function() {
                return x;
            }), s.d(t, "littleEndianByteArrayParser", function() {
                return M;
            }), s.d(t, "parseDicom", function() {
                return V;
            }), s.d(t, "readDicomElementExplicit", function() {
                return B;
            }), s.d(t, "readDicomElementImplicit", function() {
                return A;
            }), s.d(t, "readEncapsulatedImageFrame", function() {
                return W;
            }), s.d(t, "readEncapsulatedPixelData", function() {
                return K;
            }), s.d(t, "readEncapsulatedPixelDataFromFragments", function() {
                return _;
            }), s.d(t, "readPart10Header", function() {
                return G;
            }), s.d(t, "readSequenceItemsExplicit", function() {
                return I;
            }), s.d(t, "readSequenceItemsImplicit", function() {
                return F;
            }), s.d(t, "readSequenceItem", function() {
                return S;
            }), s.d(t, "readTag", function() {
                return h;
            });
            var r = {
                AE: !0,
                AS: !0,
                AT: !1,
                CS: !0,
                DA: !0,
                DS: !0,
                DT: !0,
                FL: !1,
                FD: !1,
                IS: !0,
                LO: !0,
                LT: !0,
                OB: !1,
                OD: !1,
                OF: !1,
                OW: !1,
                PN: !0,
                SH: !0,
                SL: !1,
                SQ: !1,
                SS: !1,
                ST: !0,
                TM: !0,
                UI: !0,
                UL: !1,
                UN: void 0,
                UR: !0,
                US: !1,
                UT: !0
            }, d = function(e) {
                return r[e];
            }, f = function(e) {
                e = parseInt(e[4], 16);
                if (isNaN(e)) throw "dicomParser.isPrivateTag: cannot parse last character of group";
                return e % 2 == 1;
            }, a = function(e) {
                if (void 0 !== e) {
                    e = e.split("^");
                    return {
                        familyName: e[0],
                        givenName: e[1],
                        middleName: e[2],
                        prefix: e[3],
                        suffix: e[4]
                    };
                }
            };
            function n(e, t) {
                if (2 <= e.length) {
                    var r = parseInt(e.substring(0, 2), 10), a = 4 <= e.length ? parseInt(e.substring(2, 4), 10) : void 0, n = 6 <= e.length ? parseInt(e.substring(4, 6), 10) : void 0, i = 8 <= e.length ? e.substring(7, 13) : void 0, i = i ? parseInt(i, 10) * Math.pow(10, 6 - i.length) : void 0;
                    if (t && (isNaN(r) || void 0 !== a && isNaN(a) || void 0 !== n && isNaN(n) || void 0 !== i && isNaN(i) || r < 0 || 23 < r || a && (a < 0 || 59 < a) || n && (n < 0 || 59 < n) || i && (i < 0 || 999999 < i))) throw "invalid TM '".concat(e, "'");
                    return {
                        hours: r,
                        minutes: a,
                        seconds: n,
                        fractionalSeconds: i
                    };
                }
                if (t) throw "invalid TM '".concat(e, "'");
            }
            function i(e, t, r) {
                return !isNaN(r) && 0 < t && t <= 12 && 0 < e && e <= function(e, t) {
                    switch(e){
                        case 2:
                            return t % 4 == 0 && t % 100 || t % 400 == 0 ? 29 : 28;
                        case 9:
                        case 4:
                        case 6:
                        case 11:
                            return 30;
                        default:
                            return 31;
                    }
                }(t, r);
            }
            function o(e, t) {
                if (e && 8 === e.length) {
                    var r = parseInt(e.substring(0, 4), 10), a = parseInt(e.substring(4, 6), 10), n = parseInt(e.substring(6, 8), 10);
                    if (t && !0 !== i(n, a, r)) throw "invalid DA '".concat(e, "'");
                    return {
                        year: r,
                        month: a,
                        day: n
                    };
                }
                if (t) throw "invalid DA '".concat(e, "'");
            }
            function l(n, e) {
                if (void 0 === n || void 0 === e) throw "dicomParser.explicitElementToString: missing required parameters";
                if (void 0 === e.vr) throw "dicomParser.explicitElementToString: cannot convert implicit element to string";
                var t, r = e.vr, i = e.tag;
                function a(e, t) {
                    for(var r = "", a = 0; a < e; a++)0 !== a && (r += "/"), r += t.call(n, i, a).toString();
                    return r;
                }
                if (!0 === d(r)) t = n.string(i);
                else {
                    if ("AT" === r) {
                        var o = n.uint32(i);
                        return void 0 === o ? void 0 : "x".concat((o = o < 0 ? 4294967295 + o + 1 : o).toString(16).toUpperCase());
                    }
                    "US" === r ? t = a(e.length / 2, n.uint16) : "SS" === r ? t = a(e.length / 2, n.int16) : "UL" === r ? t = a(e.length / 4, n.uint32) : "SL" === r ? t = a(e.length / 4, n.int32) : "FD" === r ? t = a(e.length / 8, n.double) : "FL" === r && (t = a(e.length / 4, n.float));
                }
                return t;
            }
            function u(e, t) {
                if (void 0 === e) throw "dicomParser.explicitDataSetToJS: missing required parameter dataSet";
                t = t || {
                    omitPrivateAttibutes: !0,
                    maxElementLength: 128
                };
                var r, a = {};
                for(r in e.elements){
                    var n = e.elements[r];
                    if (!0 !== t.omitPrivateAttibutes || !f(r)) {
                        if (n.items) {
                            for(var i = [], o = 0; o < n.items.length; o++)i.push(u(n.items[o].dataSet, t));
                            a[r] = i;
                        } else {
                            var s = void 0;
                            n.length < t.maxElementLength && (s = l(e, n)), a[r] = void 0 !== s ? s : {
                                dataOffset: n.dataOffset,
                                length: n.length
                            };
                        }
                    }
                }
                return a;
            }
            function c(e, t) {
                return 255 === e.byteArray[t] && 217 === e.byteArray[t + 1];
            }
            function m(e, t, r) {
                for(var a, n, i = r; i < t.fragments.length; i++)if (a = e, n = i, n = t.fragments[n], !(!c(a, n.position + n.length - 2) && !c(a, n.position + n.length - 3))) return i;
            }
            function p(e, t, r) {
                if (void 0 === e) throw "dicomParser.createJPEGBasicOffsetTable: missing required parameter dataSet";
                if (void 0 === t) throw "dicomParser.createJPEGBasicOffsetTable: missing required parameter pixelDataElement";
                if ("x7fe00010" !== t.tag) throw "dicomParser.createJPEGBasicOffsetTable: parameter 'pixelDataElement' refers to non pixel data tag (expected tag = x7fe00010'";
                if (!0 !== t.encapsulatedPixelData) throw "dicomParser.createJPEGBasicOffsetTable: parameter 'pixelDataElement' refers to pixel data element that does not have encapsulated pixel data";
                if (!0 !== t.hadUndefinedLength) throw "dicomParser.createJPEGBasicOffsetTable: parameter 'pixelDataElement' refers to pixel data element that does not have encapsulated pixel data";
                if (void 0 === t.basicOffsetTable) throw "dicomParser.createJPEGBasicOffsetTable: parameter 'pixelDataElement' refers to pixel data element that does not have encapsulated pixel data";
                if (void 0 === t.fragments) throw "dicomParser.createJPEGBasicOffsetTable: parameter 'pixelDataElement' refers to pixel data element that does not have encapsulated pixel data";
                if (t.fragments.length <= 0) throw "dicomParser.createJPEGBasicOffsetTable: parameter 'pixelDataElement' refers to pixel data element that does not have encapsulated pixel data";
                if (r && r.length <= 0) throw "dicomParser.createJPEGBasicOffsetTable: parameter 'fragments' must not be zero length";
                r = r || t.fragments;
                for(var a = [], n = 0;;){
                    a.push(t.fragments[n].offset);
                    var i = m(e, t, n);
                    if (void 0 === i || i === t.fragments.length - 1) return a;
                    n = i + 1;
                }
            }
            function h(e) {
                if (void 0 === e) throw "dicomParser.readTag: missing required parameter 'byteStream'";
                var t = 256 * e.readUint16() * 256, e = e.readUint16();
                return "x".concat("00000000".concat((t + e).toString(16)).substr(-8));
            }
            function g(e, t, r) {
                if (void 0 === e) throw "dicomParser.findEndOfEncapsulatedElement: missing required parameter 'byteStream'";
                if (void 0 === t) throw "dicomParser.findEndOfEncapsulatedElement: missing required parameter 'element'";
                if (t.encapsulatedPixelData = !0, t.basicOffsetTable = [], t.fragments = [], "xfffee000" !== h(e)) throw "dicomParser.findEndOfEncapsulatedElement: basic offset table not found";
                for(var a = e.readUint32() / 4, n = 0; n < a; n++){
                    var i = e.readUint32();
                    t.basicOffsetTable.push(i);
                }
                for(var o = e.position; e.position < e.byteArray.length;){
                    var s = h(e), d = e.readUint32();
                    if ("xfffee0dd" === s) return e.seek(d), void (t.length = e.position - t.dataOffset);
                    if ("xfffee000" !== s) return r && r.push("unexpected tag ".concat(s, " while searching for end of pixel data element with undefined length")), d > e.byteArray.length - e.position && (d = e.byteArray.length - e.position), t.fragments.push({
                        offset: e.position - o - 8,
                        position: e.position,
                        length: d
                    }), e.seek(d), void (t.length = e.position - t.dataOffset);
                    t.fragments.push({
                        offset: e.position - o - 8,
                        position: e.position,
                        length: d
                    }), e.seek(d);
                }
                r && r.push("pixel data element ".concat(t.tag, " missing sequence delimiter tag xfffee0dd"));
            }
            function y(e, t) {
                if (void 0 === e) throw "dicomParser.findAndSetUNElementLength: missing required parameter 'byteStream'";
                for(var r = e.byteArray.length - 8; e.position <= r;)if (65534 === e.readUint16()) {
                    var a = e.readUint16();
                    if (57565 === a) return 0 !== e.readUint32() && e.warnings("encountered non zero length following item delimiter at position ".concat(e.position - 4, " while reading element of undefined length with tag ").concat(t.tag)), void (t.length = e.position - t.dataOffset);
                }
                t.length = e.byteArray.length - t.dataOffset, e.seek(e.byteArray.length - e.position);
            }
            function b(e, t, r) {
                if (r < 0) throw "dicomParser.readFixedString - length cannot be less than 0";
                if (t + r > e.length) throw "dicomParser.readFixedString: attempt to read past end of buffer";
                for(var a, n = "", i = 0; i < r; i++){
                    if (0 === (a = e[t + i])) return t += r, n;
                    n += String.fromCharCode(a);
                }
                return n;
            }
            function v(e, t) {
                for(var r = 0; r < t.length; r++){
                    var a = t[r];
                    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
                }
            }
            function P(e, t) {
                return void 0 !== e.parser ? e.parser : t;
            }
            var w = function() {
                function a(e, t, r) {
                    !function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, a), this.byteArrayParser = e, this.byteArray = t, this.elements = r;
                }
                var e, t, r;
                return e = a, t = [
                    {
                        key: "uint16",
                        value: function(e, t) {
                            e = this.elements[e];
                            if (t = void 0 !== t ? t : 0, e && 0 !== e.length) return P(e, this.byteArrayParser).readUint16(this.byteArray, e.dataOffset + 2 * t);
                        }
                    },
                    {
                        key: "int16",
                        value: function(e, t) {
                            e = this.elements[e];
                            if (t = void 0 !== t ? t : 0, e && 0 !== e.length) return P(e, this.byteArrayParser).readInt16(this.byteArray, e.dataOffset + 2 * t);
                        }
                    },
                    {
                        key: "uint32",
                        value: function(e, t) {
                            e = this.elements[e];
                            if (t = void 0 !== t ? t : 0, e && 0 !== e.length) return P(e, this.byteArrayParser).readUint32(this.byteArray, e.dataOffset + 4 * t);
                        }
                    },
                    {
                        key: "int32",
                        value: function(e, t) {
                            e = this.elements[e];
                            if (t = void 0 !== t ? t : 0, e && 0 !== e.length) return P(e, this.byteArrayParser).readInt32(this.byteArray, e.dataOffset + 4 * t);
                        }
                    },
                    {
                        key: "float",
                        value: function(e, t) {
                            e = this.elements[e];
                            if (t = void 0 !== t ? t : 0, e && 0 !== e.length) return P(e, this.byteArrayParser).readFloat(this.byteArray, e.dataOffset + 4 * t);
                        }
                    },
                    {
                        key: "double",
                        value: function(e, t) {
                            e = this.elements[e];
                            if (t = void 0 !== t ? t : 0, e && 0 !== e.length) return P(e, this.byteArrayParser).readDouble(this.byteArray, e.dataOffset + 8 * t);
                        }
                    },
                    {
                        key: "numStringValues",
                        value: function(e) {
                            e = this.elements[e];
                            if (e && 0 < e.length) {
                                e = b(this.byteArray, e.dataOffset, e.length).match(/\\/g);
                                return null === e ? 1 : e.length + 1;
                            }
                        }
                    },
                    {
                        key: "string",
                        value: function(e, t) {
                            e = this.elements[e];
                            if (e && e.Value) return e.Value;
                            if (e && 0 < e.length) {
                                e = b(this.byteArray, e.dataOffset, e.length);
                                return 0 <= t ? e.split("\\")[t].trim() : e.trim();
                            }
                        }
                    },
                    {
                        key: "text",
                        value: function(e, t) {
                            e = this.elements[e];
                            if (e && 0 < e.length) {
                                e = b(this.byteArray, e.dataOffset, e.length);
                                return 0 <= t ? e.split("\\")[t].replace(/ +$/, "") : e.replace(/ +$/, "");
                            }
                        }
                    },
                    {
                        key: "floatString",
                        value: function(e, t) {
                            var r = this.elements[e];
                            if (r && 0 < r.length) {
                                t = this.string(e, t = void 0 !== t ? t : 0);
                                if (void 0 !== t) return parseFloat(t);
                            }
                        }
                    },
                    {
                        key: "intString",
                        value: function(e, t) {
                            var r = this.elements[e];
                            if (r && 0 < r.length) {
                                t = this.string(e, t = void 0 !== t ? t : 0);
                                if (void 0 !== t) return parseInt(t);
                            }
                        }
                    },
                    {
                        key: "attributeTag",
                        value: function(e) {
                            var t = this.elements[e];
                            if (t && 4 === t.length) {
                                var r = P(t, this.byteArrayParser).readUint16, e = this.byteArray, t = t.dataOffset;
                                return "x".concat("00000000".concat((256 * r(e, t) * 256 + r(e, t + 2)).toString(16)).substr(-8));
                            }
                        }
                    }
                ], v(e.prototype, t), r && v(e, r), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), a;
            }();
            function x(e, t) {
                if (void 0 === e) throw "dicomParser.readDicomElementImplicit: missing required parameter 'byteStream'";
                for(var r = e.byteArray.length - 8; e.position <= r;)if (65534 === e.readUint16()) {
                    var a = e.readUint16();
                    if (57357 === a) return 0 !== e.readUint32() && e.warnings("encountered non zero length following item delimiter at position ".concat(e.position - 4, " while reading element of undefined length with tag ").concat(t.tag)), void (t.length = e.position - t.dataOffset);
                }
                t.length = e.byteArray.length - t.dataOffset, e.seek(e.byteArray.length - e.position);
            }
            var E = function(e, t) {
                if (void 0 !== e.vr) return "SQ" === e.vr;
                if (t.position + 4 <= t.byteArray.length) {
                    e = h(t);
                    return t.seek(-4), "xfffee000" === e || "xfffee0dd" === e;
                }
                return t.warnings.push("eof encountered before finding sequence item tag or sequence delimiter tag in peeking to determine VR"), !1;
            };
            function A(e, t, r) {
                if (void 0 === e) throw "dicomParser.readDicomElementImplicit: missing required parameter 'byteStream'";
                var a = h(e), a = {
                    tag: a,
                    vr: void 0 !== r ? r(a) : void 0,
                    length: e.readUint32(),
                    dataOffset: e.position
                };
                return 4294967295 === a.length && (a.hadUndefinedLength = !0), a.tag === t || (!E(a, e) || f(a.tag) && !a.hadUndefinedLength ? a.hadUndefinedLength ? x(e, a) : e.seek(a.length) : (F(e, a, r), f(a.tag) && (a.items = void 0))), a;
            }
            function S(e) {
                if (void 0 === e) throw "dicomParser.readSequenceItem: missing required parameter 'byteStream'";
                var t = {
                    tag: h(e),
                    length: e.readUint32(),
                    dataOffset: e.position
                };
                if ("xfffee000" !== t.tag) throw "dicomParser.readSequenceItem: item tag (FFFE,E000) not found at offset ".concat(e.position);
                return t;
            }
            function D(e, t) {
                var r = S(e);
                return 4294967295 === r.length ? (r.hadUndefinedLength = !0, r.dataSet = function(e, t) {
                    for(var r = {}; e.position < e.byteArray.length;){
                        var a = A(e, void 0, t);
                        if ("xfffee00d" === (r[a.tag] = a).tag) return new w(e.byteArrayParser, e.byteArray, r);
                    }
                    return e.warnings.push("eof encountered before finding sequence item delimiter in sequence item of undefined length"), new w(e.byteArrayParser, e.byteArray, r);
                }(e, t), r.length = e.position - r.dataOffset) : (r.dataSet = new w(e.byteArrayParser, e.byteArray, {}), T(r.dataSet, e, e.position + r.length, {
                    vrCallback: t
                })), r;
            }
            function F(e, t, r) {
                if (void 0 === e) throw "dicomParser.readSequenceItemsImplicit: missing required parameter 'byteStream'";
                if (void 0 === t) throw "dicomParser.readSequenceItemsImplicit: missing required parameter 'element'";
                t.items = [], (4294967295 === t.length ? function(e, t, r) {
                    for(; e.position + 4 <= e.byteArray.length;){
                        var a = h(e);
                        if (e.seek(-4), "xfffee0dd" === a) return t.length = e.position - t.dataOffset, e.seek(8);
                        a = D(e, r);
                        t.items.push(a);
                    }
                    e.warnings.push("eof encountered before finding sequence delimiter in sequence of undefined length"), t.length = e.byteArray.length - t.dataOffset;
                } : function(e, t, r) {
                    for(var a = t.dataOffset + t.length; e.position < a;){
                        var n = D(e, r);
                        t.items.push(n);
                    }
                })(e, t, r);
            }
            function O(e, t) {
                var r = S(e);
                return 4294967295 === r.length ? (r.hadUndefinedLength = !0, r.dataSet = function(e, t) {
                    for(var r = {}; e.position < e.byteArray.length;){
                        var a = B(e, t);
                        if ("xfffee00d" === (r[a.tag] = a).tag) return new w(e.byteArrayParser, e.byteArray, r);
                    }
                    return t.push("eof encountered before finding item delimiter tag while reading sequence item of undefined length"), new w(e.byteArrayParser, e.byteArray, r);
                }(e, t), r.length = e.position - r.dataOffset) : (r.dataSet = new w(e.byteArrayParser, e.byteArray, {}), q(r.dataSet, e, e.position + r.length)), r;
            }
            function I(e, t, r) {
                if (void 0 === e) throw "dicomParser.readSequenceItemsExplicit: missing required parameter 'byteStream'";
                if (void 0 === t) throw "dicomParser.readSequenceItemsExplicit: missing required parameter 'element'";
                t.items = [], (4294967295 === t.length ? function(e, t, r) {
                    for(; e.position + 4 <= e.byteArray.length;){
                        var a = h(e);
                        if (e.seek(-4), "xfffee0dd" === a) return t.length = e.position - t.dataOffset, e.seek(8);
                        a = O(e, r);
                        t.items.push(a);
                    }
                    r.push("eof encountered before finding sequence delimitation tag while reading sequence of undefined length"), t.length = e.position - t.dataOffset;
                } : function(e, t, r) {
                    for(var a = t.dataOffset + t.length; e.position < a;){
                        var n = O(e, r);
                        t.items.push(n);
                    }
                })(e, t, r);
            }
            var U = function(e) {
                return "OB" === e || "OD" === e || "OL" === e || "OW" === e || "SQ" === e || "OF" === e || "UC" === e || "UR" === e || "UT" === e || "UN" === e ? 4 : 2;
            };
            function B(e, t, r) {
                if (void 0 === e) throw "dicomParser.readDicomElementExplicit: missing required parameter 'byteStream'";
                var a = {
                    tag: h(e),
                    vr: e.readFixedString(2)
                };
                return 2 === U(a.vr) ? a.length = e.readUint16() : (e.seek(2), a.length = e.readUint32()), a.dataOffset = e.position, 4294967295 === a.length && (a.hadUndefinedLength = !0), a.tag === r || ("SQ" === a.vr ? I(e, a, t) : 4294967295 === a.length ? "x7fe00010" === a.tag ? g(e, a, t) : ("UN" === a.vr ? F : x)(e, a) : e.seek(a.length)), a;
            }
            function q(e, t, r) {
                var a = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : {};
                if (r = void 0 === r ? t.byteArray.length : r, void 0 === t) throw "dicomParser.parseDicomDataSetExplicit: missing required parameter 'byteStream'";
                if (r < t.position || r > t.byteArray.length) throw "dicomParser.parseDicomDataSetExplicit: invalid value for parameter 'maxP osition'";
                for(var n = e.elements; t.position < r;){
                    var i = B(t, e.warnings, a.untilTag);
                    if ((n[i.tag] = i).tag === a.untilTag) return;
                }
                if (t.position > r) throw "dicomParser:parseDicomDataSetExplicit: buffer overrun";
            }
            function T(e, t, r) {
                var a = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : {};
                if (r = void 0 === r ? e.byteArray.length : r, void 0 === t) throw "dicomParser.parseDicomDataSetImplicit: missing required parameter 'byteStream'";
                if (r < t.position || r > t.byteArray.length) throw "dicomParser.parseDicomDataSetImplicit: invalid value for parameter 'maxPosition'";
                for(var n = e.elements; t.position < r;){
                    var i = A(t, a.untilTag, a.vrCallback);
                    if ((n[i.tag] = i).tag === a.untilTag) return;
                }
            }
            function k(e, t) {
                if ("undefined" != typeof $937ae3202df95507$require$Buffer && e instanceof $937ae3202df95507$require$Buffer) return $937ae3202df95507$require$Buffer.alloc(t);
                if (e instanceof Uint8Array) return new Uint8Array(t);
                throw "dicomParser.alloc: unknown type for byteArray";
            }
            var L = "1.8.12", N = {
                readUint16: function(e, t) {
                    if (t < 0) throw "bigEndianByteArrayParser.readUint16: position cannot be less than 0";
                    if (t + 2 > e.length) throw "bigEndianByteArrayParser.readUint16: attempt to read past end of buffer";
                    return (e[t] << 8) + e[t + 1];
                },
                readInt16: function(e, t) {
                    if (t < 0) throw "bigEndianByteArrayParser.readInt16: position cannot be less than 0";
                    if (t + 2 > e.length) throw "bigEndianByteArrayParser.readInt16: attempt to read past end of buffer";
                    t = (e[t] << 8) + e[t + 1];
                    return t = 32768 & t ? t - 65535 - 1 : t;
                },
                readUint32: function(e, t) {
                    if (t < 0) throw "bigEndianByteArrayParser.readUint32: position cannot be less than 0";
                    if (t + 4 > e.length) throw "bigEndianByteArrayParser.readUint32: attempt to read past end of buffer";
                    return 256 * (256 * (256 * e[t] + e[t + 1]) + e[t + 2]) + e[t + 3];
                },
                readInt32: function(e, t) {
                    if (t < 0) throw "bigEndianByteArrayParser.readInt32: position cannot be less than 0";
                    if (t + 4 > e.length) throw "bigEndianByteArrayParser.readInt32: attempt to read past end of buffer";
                    return (e[t] << 24) + (e[t + 1] << 16) + (e[t + 2] << 8) + e[t + 3];
                },
                readFloat: function(e, t) {
                    if (t < 0) throw "bigEndianByteArrayParser.readFloat: position cannot be less than 0";
                    if (t + 4 > e.length) throw "bigEndianByteArrayParser.readFloat: attempt to read past end of buffer";
                    var r = new Uint8Array(4);
                    return r[3] = e[t], r[2] = e[t + 1], r[1] = e[t + 2], r[0] = e[t + 3], new Float32Array(r.buffer)[0];
                },
                readDouble: function(e, t) {
                    if (t < 0) throw "bigEndianByteArrayParser.readDouble: position cannot be less than 0";
                    if (t + 8 > e.length) throw "bigEndianByteArrayParser.readDouble: attempt to read past end of buffer";
                    var r = new Uint8Array(8);
                    return r[7] = e[t], r[6] = e[t + 1], r[5] = e[t + 2], r[4] = e[t + 3], r[3] = e[t + 4], r[2] = e[t + 5], r[1] = e[t + 6], r[0] = e[t + 7], new Float64Array(r.buffer)[0];
                }
            };
            function j(e, t, r) {
                if ("undefined" != typeof $937ae3202df95507$require$Buffer && e instanceof $937ae3202df95507$require$Buffer) return e.slice(t, t + r);
                if (e instanceof Uint8Array) return new Uint8Array(e.buffer, e.byteOffset + t, r);
                throw "dicomParser.from: unknown type for byteArray";
            }
            function C(e, t) {
                for(var r = 0; r < t.length; r++){
                    var a = t[r];
                    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
                }
            }
            var J = function() {
                function a(e, t, r) {
                    if (!function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, a), void 0 === e) throw "dicomParser.ByteStream: missing required parameter 'byteArrayParser'";
                    if (void 0 === t) throw "dicomParser.ByteStream: missing required parameter 'byteArray'";
                    if (t instanceof Uint8Array == !1 && ("undefined" == typeof $937ae3202df95507$require$Buffer || t instanceof $937ae3202df95507$require$Buffer == !1)) throw "dicomParser.ByteStream: parameter byteArray is not of type Uint8Array or Buffer";
                    if (r < 0) throw "dicomParser.ByteStream: parameter 'position' cannot be less than 0";
                    if (r >= t.length) throw "dicomParser.ByteStream: parameter 'position' cannot be greater than or equal to 'byteArray' length";
                    this.byteArrayParser = e, this.byteArray = t, this.position = r || 0, this.warnings = [];
                }
                var e, t, r;
                return e = a, t = [
                    {
                        key: "seek",
                        value: function(e) {
                            if (this.position + e < 0) throw "dicomParser.ByteStream.prototype.seek: cannot seek to position < 0";
                            this.position += e;
                        }
                    },
                    {
                        key: "readByteStream",
                        value: function(e) {
                            if (this.position + e > this.byteArray.length) throw "dicomParser.ByteStream.prototype.readByteStream: readByteStream - buffer overread";
                            var t = j(this.byteArray, this.position, e);
                            return this.position += e, new a(this.byteArrayParser, t);
                        }
                    },
                    {
                        key: "getSize",
                        value: function() {
                            return this.byteArray.length;
                        }
                    },
                    {
                        key: "readUint16",
                        value: function() {
                            var e = this.byteArrayParser.readUint16(this.byteArray, this.position);
                            return this.position += 2, e;
                        }
                    },
                    {
                        key: "readUint32",
                        value: function() {
                            var e = this.byteArrayParser.readUint32(this.byteArray, this.position);
                            return this.position += 4, e;
                        }
                    },
                    {
                        key: "readFixedString",
                        value: function(e) {
                            var t = b(this.byteArray, this.position, e);
                            return this.position += e, t;
                        }
                    }
                ], C(e.prototype, t), r && C(e, r), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), a;
            }(), M = {
                readUint16: function(e, t) {
                    if (t < 0) throw "littleEndianByteArrayParser.readUint16: position cannot be less than 0";
                    if (t + 2 > e.length) throw "littleEndianByteArrayParser.readUint16: attempt to read past end of buffer";
                    return e[t] + 256 * e[t + 1];
                },
                readInt16: function(e, t) {
                    if (t < 0) throw "littleEndianByteArrayParser.readInt16: position cannot be less than 0";
                    if (t + 2 > e.length) throw "littleEndianByteArrayParser.readInt16: attempt to read past end of buffer";
                    t = e[t] + (e[t + 1] << 8);
                    return t = 32768 & t ? t - 65535 - 1 : t;
                },
                readUint32: function(e, t) {
                    if (t < 0) throw "littleEndianByteArrayParser.readUint32: position cannot be less than 0";
                    if (t + 4 > e.length) throw "littleEndianByteArrayParser.readUint32: attempt to read past end of buffer";
                    return e[t] + 256 * e[t + 1] + 256 * e[t + 2] * 256 + 256 * e[t + 3] * 65536;
                },
                readInt32: function(e, t) {
                    if (t < 0) throw "littleEndianByteArrayParser.readInt32: position cannot be less than 0";
                    if (t + 4 > e.length) throw "littleEndianByteArrayParser.readInt32: attempt to read past end of buffer";
                    return e[t] + (e[t + 1] << 8) + (e[t + 2] << 16) + (e[t + 3] << 24);
                },
                readFloat: function(e, t) {
                    if (t < 0) throw "littleEndianByteArrayParser.readFloat: position cannot be less than 0";
                    if (t + 4 > e.length) throw "littleEndianByteArrayParser.readFloat: attempt to read past end of buffer";
                    var r = new Uint8Array(4);
                    return r[0] = e[t], r[1] = e[t + 1], r[2] = e[t + 2], r[3] = e[t + 3], new Float32Array(r.buffer)[0];
                },
                readDouble: function(e, t) {
                    if (t < 0) throw "littleEndianByteArrayParser.readDouble: position cannot be less than 0";
                    if (t + 8 > e.length) throw "littleEndianByteArrayParser.readDouble: attempt to read past end of buffer";
                    var r = new Uint8Array(8);
                    return r[0] = e[t], r[1] = e[t + 1], r[2] = e[t + 2], r[3] = e[t + 3], r[4] = e[t + 4], r[5] = e[t + 5], r[6] = e[t + 6], r[7] = e[t + 7], new Float64Array(r.buffer)[0];
                }
            };
            function G(e) {
                var i = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};
                if (void 0 === e) throw "dicomParser.readPart10Header: missing required parameter 'byteArray'";
                var o = i.TransferSyntaxUID, s = new J(M, e);
                return function() {
                    var e = function() {
                        if (s.getSize() <= 132 && o) return !1;
                        if (s.seek(128), "DICM" === s.readFixedString(4)) return !0;
                        if (!(i || {}).TransferSyntaxUID) throw "dicomParser.readPart10Header: DICM prefix not found at location 132 - this is not a valid DICOM P10 file.";
                        return s.seek(0), !1;
                    }(), t = [], r = {};
                    if (!e) return s.position = 0, {
                        elements: {
                            x00020010: {
                                tag: "x00020010",
                                vr: "UI",
                                Value: o
                            }
                        },
                        warnings: t
                    };
                    for(; s.position < s.byteArray.length;){
                        var a = s.position, n = B(s, t);
                        if ("x0002ffff" < n.tag) {
                            s.position = a;
                            break;
                        }
                        n.parser = M, r[n.tag] = n;
                    }
                    return (e = new w(s.byteArrayParser, s.byteArray, r)).warnings = s.warnings, e.position = s.position, e;
                }();
            }
            var z = "1.2.840.10008.1.2.2";
            function V(i) {
                var o = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};
                if (void 0 === i) throw new Error("dicomParser.parseDicom: missing required parameter 'byteArray'");
                var e, a = function(e) {
                    if (void 0 === e.elements.x00020010) throw new Error("dicomParser.parseDicom: missing required meta header attribute 0002,0010");
                    e = e.elements.x00020010;
                    return e && e.Value || b(i, e.dataOffset, e.length);
                };
                function t(t) {
                    var e = a(t), r = "1.2.840.10008.1.2" !== e, e = function(e, t) {
                        var r = "[object process]" === Object.prototype.toString.call(0);
                        if ("1.2.840.10008.1.2.1.99" !== e) return new J(e === z ? N : M, i, t);
                        if (o && o.inflater) {
                            e = o.inflater(i, t);
                            return new J(M, e, 0);
                        }
                        if (!0 == r) {
                            var a = s(0), n = j(i, t, i.length - t), a = a.inflateRawSync(n), n = k(i, a.length + t);
                            return i.copy(n, 0, 0, t), a.copy(n, t), new J(M, n, 0);
                        }
                        if ("undefined" == typeof pako) throw "dicomParser.parseDicom: no inflater available to handle deflate transfer syntax";
                        return a = i.slice(t), n = pako.inflateRaw(a), (a = k(i, n.length + t)).set(i.slice(0, t), 0), a.set(n, t), new J(M, a, 0);
                    }(e, t.position), t = new w(e.byteArrayParser, e.byteArray, {});
                    t.warnings = e.warnings;
                    try {
                        (r ? q : T)(t, e, e.byteArray.length, o);
                    } catch (e) {
                        throw {
                            exception: e,
                            dataSet: t
                        };
                    }
                    return t;
                }
                return function(e, t) {
                    for(var r in e.elements)e.elements.hasOwnProperty(r) && (t.elements[r] = e.elements[r]);
                    return void 0 !== e.warnings && (t.warnings = e.warnings.concat(t.warnings)), t;
                }(e = G(i, o), t(e));
            }
            var R = function(e, t, r) {
                for(var a = 0, n = t; n < t + r; n++)a += e[n].length;
                return a;
            };
            function _(e, t, r, a, n) {
                if (n = n || t.fragments, void 0 === e) throw "dicomParser.readEncapsulatedPixelDataFromFragments: missing required parameter 'dataSet'";
                if (void 0 === t) throw "dicomParser.readEncapsulatedPixelDataFromFragments: missing required parameter 'pixelDataElement'";
                if (void 0 === r) throw "dicomParser.readEncapsulatedPixelDataFromFragments: missing required parameter 'startFragmentIndex'";
                if (void 0 === (a = a || 1)) throw "dicomParser.readEncapsulatedPixelDataFromFragments: missing required parameter 'numFragments'";
                if ("x7fe00010" !== t.tag) throw "dicomParser.readEncapsulatedPixelDataFromFragments: parameter 'pixelDataElement' refers to non pixel data tag (expected tag = x7fe00010";
                if (!0 !== t.encapsulatedPixelData) throw "dicomParser.readEncapsulatedPixelDataFromFragments: parameter 'pixelDataElement' refers to pixel data element that does not have encapsulated pixel data";
                if (!0 !== t.hadUndefinedLength) throw "dicomParser.readEncapsulatedPixelDataFromFragments: parameter 'pixelDataElement' refers to pixel data element that does not have encapsulated pixel data";
                if (void 0 === t.basicOffsetTable) throw "dicomParser.readEncapsulatedPixelDataFromFragments: parameter 'pixelDataElement' refers to pixel data element that does not have encapsulated pixel data";
                if (void 0 === t.fragments) throw "dicomParser.readEncapsulatedPixelDataFromFragments: parameter 'pixelDataElement' refers to pixel data element that does not have encapsulated pixel data";
                if (t.fragments.length <= 0) throw "dicomParser.readEncapsulatedPixelDataFromFragments: parameter 'pixelDataElement' refers to pixel data element that does not have encapsulated pixel data";
                if (r < 0) throw "dicomParser.readEncapsulatedPixelDataFromFragments: parameter 'startFragmentIndex' must be >= 0";
                if (r >= t.fragments.length) throw "dicomParser.readEncapsulatedPixelDataFromFragments: parameter 'startFragmentIndex' must be < number of fragments";
                if (a < 1) throw "dicomParser.readEncapsulatedPixelDataFromFragments: parameter 'numFragments' must be > 0";
                if (r + a > t.fragments.length) throw "dicomParser.readEncapsulatedPixelDataFromFragments: parameter 'startFragment' + 'numFragments' < number of fragments";
                var i = new J(e.byteArrayParser, e.byteArray, t.dataOffset), t = S(i);
                if ("xfffee000" !== t.tag) throw "dicomParser.readEncapsulatedPixelData: missing basic offset table xfffee000";
                i.seek(t.length);
                var o = i.position;
                if (1 === a) return j(i.byteArray, o + n[r].offset + 8, n[r].length);
                for(var t = R(n, r, a), s = k(i.byteArray, t), d = 0, f = r; f < r + a; f++)for(var l = o + n[f].offset + 8, u = 0; u < n[f].length; u++)s[d++] = i.byteArray[l++];
                return s;
            }
            var H = function(e, t) {
                for(var r = 0; r < e.length; r++)if (e[r].offset === t) return r;
            }, Q = function(e, t, r, a) {
                if (e === t.length - 1) return r.length - a;
                for(var n = t[e + 1], i = a + 1; i < r.length; i++)if (r[i].offset === n) return i - a;
                throw "dicomParser.calculateNumberOfFragmentsForFrame: could not find fragment with offset matching basic offset table";
            };
            function W(e, t, r, a, n) {
                if (a = a || t.basicOffsetTable, n = n || t.fragments, void 0 === e) throw "dicomParser.readEncapsulatedImageFrame: missing required parameter 'dataSet'";
                if (void 0 === t) throw "dicomParser.readEncapsulatedImageFrame: missing required parameter 'pixelDataElement'";
                if (void 0 === r) throw "dicomParser.readEncapsulatedImageFrame: missing required parameter 'frameIndex'";
                if (void 0 === a) throw "dicomParser.readEncapsulatedImageFrame: parameter 'pixelDataElement' does not have basicOffsetTable";
                if ("x7fe00010" !== t.tag) throw "dicomParser.readEncapsulatedImageFrame: parameter 'pixelDataElement' refers to non pixel data tag (expected tag = x7fe00010)";
                if (!0 !== t.encapsulatedPixelData) throw "dicomParser.readEncapsulatedImageFrame: parameter 'pixelDataElement' refers to pixel data element that does not have encapsulated pixel data";
                if (!0 !== t.hadUndefinedLength) throw "dicomParser.readEncapsulatedImageFrame: parameter 'pixelDataElement' refers to pixel data element that does not have undefined length";
                if (void 0 === t.fragments) throw "dicomParser.readEncapsulatedImageFrame: parameter 'pixelDataElement' refers to pixel data element that does not have fragments";
                if (0 === a.length) throw "dicomParser.readEncapsulatedImageFrame: basicOffsetTable has zero entries";
                if (r < 0) throw "dicomParser.readEncapsulatedImageFrame: parameter 'frameIndex' must be >= 0";
                if (r >= a.length) throw "dicomParser.readEncapsulatedImageFrame: parameter 'frameIndex' must be < basicOffsetTable.length";
                var i = a[r], i = H(n, i);
                if (void 0 === i) throw "dicomParser.readEncapsulatedImageFrame: unable to find fragment that matches basic offset table entry";
                return _(e, t, i, Q(r, a, n, i), n);
            }
            var $ = !1;
            function K(e, t, r) {
                if ($ || ($ = !0, console && console.log && console.log("WARNING: dicomParser.readEncapsulatedPixelData() has been deprecated")), void 0 === e) throw "dicomParser.readEncapsulatedPixelData: missing required parameter 'dataSet'";
                if (void 0 === t) throw "dicomParser.readEncapsulatedPixelData: missing required parameter 'element'";
                if (void 0 === r) throw "dicomParser.readEncapsulatedPixelData: missing required parameter 'frame'";
                if ("x7fe00010" !== t.tag) throw "dicomParser.readEncapsulatedPixelData: parameter 'element' refers to non pixel data tag (expected tag = x7fe00010)";
                if (!0 !== t.encapsulatedPixelData) throw "dicomParser.readEncapsulatedPixelData: parameter 'element' refers to pixel data element that does not have encapsulated pixel data";
                if (!0 !== t.hadUndefinedLength) throw "dicomParser.readEncapsulatedPixelData: parameter 'element' refers to pixel data element that does not have encapsulated pixel data";
                if (void 0 === t.basicOffsetTable) throw "dicomParser.readEncapsulatedPixelData: parameter 'element' refers to pixel data element that does not have encapsulated pixel data";
                if (void 0 === t.fragments) throw "dicomParser.readEncapsulatedPixelData: parameter 'element' refers to pixel data element that does not have encapsulated pixel data";
                if (r < 0) throw "dicomParser.readEncapsulatedPixelData: parameter 'frame' must be >= 0";
                return 0 !== t.basicOffsetTable.length ? W(e, t, r) : _(e, t, 0, t.fragments.length);
            }
            t.default = {
                isStringVr: d,
                isPrivateTag: f,
                parsePN: a,
                parseTM: n,
                parseDA: o,
                explicitElementToString: l,
                explicitDataSetToJS: u,
                createJPEGBasicOffsetTable: p,
                parseDicomDataSetExplicit: q,
                parseDicomDataSetImplicit: T,
                readFixedString: b,
                alloc: k,
                version: L,
                bigEndianByteArrayParser: N,
                ByteStream: J,
                sharedCopy: j,
                DataSet: w,
                findAndSetUNElementLength: y,
                findEndOfEncapsulatedElement: g,
                findItemDelimitationItemAndSetElementLength: x,
                littleEndianByteArrayParser: M,
                parseDicom: V,
                readDicomElementExplicit: B,
                readDicomElementImplicit: A,
                readEncapsulatedImageFrame: W,
                readEncapsulatedPixelData: K,
                readEncapsulatedPixelDataFromFragments: _,
                readPart10Header: G,
                readSequenceItemsExplicit: I,
                readSequenceItemsImplicit: F,
                readSequenceItem: S,
                readTag: h,
                LEI: "1.2.840.10008.1.2",
                LEE: "1.2.840.10008.1.2.1"
            };
        }
    ], i = {}, n.m = a, n.c = i, n.d = function(e, t, r) {
        n.o(e, t) || Object.defineProperty(e, t, {
            enumerable: !0,
            get: r
        });
    }, n.r = function(e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(e, "__esModule", {
            value: !0
        });
    }, n.t = function(t, e) {
        if (1 & e && (t = n(t)), 8 & e) return t;
        if (4 & e && "object" == typeof t && t && t.__esModule) return t;
        var r = Object.create(null);
        if (n.r(r), Object.defineProperty(r, "default", {
            enumerable: !0,
            value: t
        }), 2 & e && "string" != typeof t) for(var a in t)n.d(r, a, (function(e) {
            return t[e];
        }).bind(null, a));
        return r;
    }, n.n = function(e) {
        var t = e && e.__esModule ? function() {
            return e.default;
        } : function() {
            return e;
        };
        return n.d(t, "a", t), t;
    }, n.o = function(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 1);
    function n(e) {
        if (i[e]) return i[e].exports;
        var t = i[e] = {
            i: e,
            l: !1,
            exports: {}
        };
        return a[e].call(t.exports, t, t.exports, n), t.l = !0, t.exports;
    }
});

});
parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("kjyEk", function(module, exports) {
"use strict";

});





parcelRegister("2WSRS", function(module, exports) {

$parcel$export(module.exports, "useDicomUpload", () => $225b8f2d08ed4546$export$9e757e81a22d1b0d);

var $acw62 = parcelRequire("acw62");

var $a4gAe = parcelRequire("a4gAe");
// The doctor's DICOM queue — one row per study, one upload session per study.
// docs/DICOM_COMPRESSION_LIMITS_AND_DOCUMENT_OCR_DESIGN.md §8.3, §10.1, §24.10.
//
//   open session → skip what the server already holds (`present`) → pack whole
//   instances into batches ≤ maxBatchBytes → send each with progress, retrying a
//   batch up to three times (waits 1 s, 4 s) → commit → the study's record row.
//
// One session per study, not one for the selection: a row then has exactly one
// outcome, a failed study is retried without touching the one that worked, and a
// commit can never flip a half-sent study visible.
//
// A committed session whose record step failed (DICOM_RECORD_PENDING) is retried at
// the COMMIT only — the bytes are already stored and commit is idempotent. An
// expired session starts again from open; instances already stored are skipped.
//
// Nothing here runs AI (§10.1 step 8).
const $225b8f2d08ed4546$var$MiB = 1048576;
const $225b8f2d08ed4546$var$DEFAULT_BATCH_BYTES = 16 * $225b8f2d08ed4546$var$MiB;
const $225b8f2d08ed4546$var$DEFAULT_INSTANCE_BYTES = 22 * $225b8f2d08ed4546$var$MiB;
const $225b8f2d08ed4546$export$46724b8ba8ac0660 = [
    1000,
    4000
];
const $225b8f2d08ed4546$var$wait = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
function $225b8f2d08ed4546$export$3181a6d5c18d7823(instances, maxBatchBytes) {
    const batches = [];
    let current = [];
    let bytes = 0;
    instances.forEach((it)=>{
        const size = it.size || 0;
        if (size > maxBatchBytes) {
            if (current.length) {
                batches.push(current);
                current = [];
                bytes = 0;
            }
            batches.push([
                it
            ]);
            return;
        }
        if (bytes + size > maxBatchBytes && current.length) {
            batches.push(current);
            current = [];
            bytes = 0;
        }
        current.push(it);
        bytes += size;
    });
    if (current.length) batches.push(current);
    return batches;
}
const $225b8f2d08ed4546$var$rowFor = (study)=>({
        id: `study-${study.studyUid}`,
        ...study,
        documentDate: study.studyDate || '',
        phase: 'queued',
        progress: null,
        sentInstances: 0,
        presentCount: 0,
        rejectedCount: 0,
        tooLargeCount: 0,
        error: null,
        result: null,
        sessionId: null,
        uploaded: false
    });
function $225b8f2d08ed4546$export$9e757e81a22d1b0d({ patientId: patientId, clinicId: clinicId = null, api: api = $a4gAe, sleep: sleep = $225b8f2d08ed4546$var$wait } = {}) {
    const [studies, setStudies] = (0, $acw62.useState)([]);
    const [sending, setSending] = (0, $acw62.useState)(false);
    const studiesRef = (0, $acw62.useRef)(studies);
    studiesRef.current = studies;
    const controllerRef = (0, $acw62.useRef)(null);
    const activeSessionRef = (0, $acw62.useRef)(null);
    const patch = (0, $acw62.useCallback)((id, change)=>{
        setStudies((list)=>list.map((s)=>{
                if (s.id !== id) return s;
                const next = {
                    ...s,
                    ...typeof change === 'function' ? change(s) : change
                };
                studiesRef.current = studiesRef.current.map((x)=>x.id === id ? next : x);
                return next;
            }));
    }, []);
    /** Add intake study rows; a study already queued gains the instances it lacked. */ const addStudies = (0, $acw62.useCallback)((incoming)=>{
        if (!incoming?.length) return;
        setStudies((list)=>{
            const next = list.slice();
            incoming.forEach((study)=>{
                const at = next.findIndex((s)=>s.studyUid === study.studyUid);
                if (at === -1) {
                    next.push($225b8f2d08ed4546$var$rowFor(study));
                    return;
                }
                const existing = next[at];
                const known = new Set(existing.instances.map((i)=>i.sopUid));
                const fresh = study.instances.filter((i)=>!known.has(i.sopUid));
                if (!fresh.length) return;
                const instances = [
                    ...existing.instances,
                    ...fresh
                ];
                next[at] = {
                    ...existing,
                    instances: instances,
                    instanceCount: instances.length,
                    bytes: instances.reduce((n, i)=>n + (i.size || 0), 0),
                    frameCount: instances.reduce((n, i)=>n + (i.numberOfFrames || 1), 0),
                    phase: existing.phase === 'done' ? 'queued' : existing.phase,
                    uploaded: false
                };
            });
            studiesRef.current = next;
            return next;
        });
    }, []);
    const remove = (0, $acw62.useCallback)((id)=>setStudies((list)=>list.filter((s)=>s.id !== id)), []);
    const setDocumentDate = (0, $acw62.useCallback)((id, documentDate)=>patch(id, {
            documentDate: documentDate
        }), [
        patch
    ]);
    const reset = (0, $acw62.useCallback)(()=>{
        studiesRef.current = [];
        setStudies([]);
    }, []);
    /** SOP UIDs already queued — the intake skips them when the same CD is dropped again. */ const knownSopUids = (0, $acw62.useMemo)(()=>new Set(studies.flatMap((s)=>s.instances.map((i)=>i.sopUid))), [
        studies
    ]);
    // Leaving the page mid-send would abandon a study the doctor believes is on its way.
    (0, $acw62.useEffect)(()=>{
        if (!sending) return undefined;
        const guard = (e)=>{
            e.preventDefault();
            e.returnValue = '';
        };
        window.addEventListener('beforeunload', guard);
        return ()=>window.removeEventListener('beforeunload', guard);
    }, [
        sending
    ]);
    const sendBatchWithRetry = (0, $acw62.useCallback)(async (sessionId, batch, { onProgress: onProgress, signal: signal })=>{
        for(let attempt = 0;; attempt += 1)try {
            // eslint-disable-next-line no-await-in-loop
            return await api.sendBatch(sessionId, batch, {
                onProgress: onProgress,
                signal: signal
            });
        } catch (err) {
            if (attempt >= $225b8f2d08ed4546$export$46724b8ba8ac0660.length || !api.isRetryable(err) || signal?.aborted) throw err;
            onProgress?.(0);
            // eslint-disable-next-line no-await-in-loop
            await sleep($225b8f2d08ed4546$export$46724b8ba8ac0660[attempt]);
        }
    }, [
        api,
        sleep
    ]);
    const sendStudy = (0, $acw62.useCallback)(async (row, shared, signal)=>{
        if (typeof navigator !== 'undefined' && navigator.onLine === false) {
            patch(row.id, {
                phase: 'failed',
                error: {
                    code: 'OFFLINE'
                }
            });
            return null;
        }
        let sessionId = row.uploaded ? row.sessionId : null;
        try {
            if (!row.uploaded) {
                patch(row.id, {
                    phase: 'sending',
                    progress: 0,
                    error: null,
                    sentInstances: 0
                });
                const opened = await api.openSession({
                    patientId: patientId,
                    clinicId: clinicId || null,
                    appointmentId: shared.appointmentId || null,
                    orderId: shared.orderId || null,
                    studies: [
                        {
                            studyUid: row.studyUid,
                            bytes: row.bytes,
                            instances: row.instanceCount
                        }
                    ]
                }, {
                    signal: signal
                });
                sessionId = opened.sessionId;
                activeSessionRef.current = sessionId;
                const maxBatch = opened.maxBatchBytes || shared.maxBatchBytes || $225b8f2d08ed4546$var$DEFAULT_BATCH_BYTES;
                const maxInstance = opened.maxInstanceBytes || shared.maxInstanceBytes || $225b8f2d08ed4546$var$DEFAULT_INSTANCE_BYTES;
                const present = new Set((opened.present || []).filter((p)=>p.studyUid === row.studyUid).flatMap((p)=>p.sopUids || []));
                const tooLarge = row.instances.filter((i)=>(i.size || 0) > maxInstance);
                const toSend = row.instances.filter((i)=>!present.has(i.sopUid) && (i.size || 0) <= maxInstance);
                patch(row.id, {
                    sessionId: sessionId,
                    presentCount: present.size,
                    tooLargeCount: tooLarge.length
                });
                if (!toSend.length && !present.size) throw new $a4gAe.DicomSessionError(tooLarge.length ? 'DICOM_INSTANCE_TOO_LARGE' : 'DICOM_NO_FILES', '', 0, {
                    maxInstanceBytes: maxInstance
                });
                const totalBytes = toSend.reduce((n, i)=>n + (i.size || 0), 0) || 1;
                let sentBytes = 0;
                let sentInstances = 0;
                let rejected = 0;
                for (const batch of $225b8f2d08ed4546$export$3181a6d5c18d7823(toSend, maxBatch)){
                    const batchBytes = batch.reduce((n, i)=>n + (i.size || 0), 0);
                    // eslint-disable-next-line no-await-in-loop
                    const verdict = await sendBatchWithRetry(sessionId, batch, {
                        signal: signal,
                        onProgress: (loaded)=>patch(row.id, {
                                progress: Math.min(1, (sentBytes + Math.min(loaded, batchBytes)) / totalBytes)
                            })
                    });
                    sentBytes += batchBytes;
                    sentInstances += batch.length;
                    rejected += (verdict?.rejected || []).length;
                    patch(row.id, {
                        progress: Math.min(1, sentBytes / totalBytes),
                        sentInstances: sentInstances,
                        rejectedCount: rejected
                    });
                }
                patch(row.id, {
                    uploaded: true
                });
            }
            patch(row.id, {
                phase: 'committing',
                error: null
            });
            const committed = await api.commitSession(sessionId, {
                documentDate: row.documentDate || null,
                description: shared.description?.trim() ? shared.description.trim() : null,
                perStudy: [
                    {
                        studyUid: row.studyUid,
                        documentDate: row.documentDate || null
                    }
                ]
            }, {
                signal: signal
            });
            const file = (committed?.files || [])[0] || null;
            activeSessionRef.current = null;
            patch(row.id, {
                phase: 'done',
                progress: 1,
                result: file,
                uploaded: true
            });
            return file;
        } catch (error) {
            activeSessionRef.current = null;
            if (error?.code === 'ABORTED') {
                if (sessionId) api.abortSession(sessionId);
                patch(row.id, {
                    phase: 'queued',
                    progress: null,
                    error: null,
                    uploaded: false,
                    sessionId: null
                });
                return null;
            }
            const recordPending = error?.code === 'DICOM_RECORD_PENDING';
            // Bytes that never got as far as a commit are released now rather than left
            // pending for the sweeper; a record-pending session is kept for its retry.
            if (sessionId && !recordPending && !row.uploaded) api.abortSession(sessionId);
            patch(row.id, (s)=>({
                    phase: 'failed',
                    error: error,
                    uploaded: recordPending ? true : false,
                    sessionId: recordPending ? sessionId : null,
                    progress: recordPending ? 1 : s.progress
                }));
            return null;
        }
    }, [
        api,
        patientId,
        clinicId,
        patch,
        sendBatchWithRetry
    ]);
    /**
   * Send every study that is not done (or only `onlyId`). `shared` carries the visit,
   * request and description, plus capability ceilings as a fallback for the session's.
   * Resolves `{ stored: ClinicalFile[], failed }`.
   */ const send = (0, $acw62.useCallback)(async (shared = {}, onlyId)=>{
        const controller = new AbortController();
        controllerRef.current = controller;
        setSending(true);
        const stored = [];
        let failed = 0;
        try {
            for (const row of studiesRef.current){
                if (row.phase === 'done') {
                    if (row.result) stored.push(row.result);
                    continue;
                }
                if (onlyId && row.id !== onlyId) continue;
                if (row.blocked) {
                    failed += 1;
                    continue;
                }
                if (controller.signal.aborted) break;
                // eslint-disable-next-line no-await-in-loop
                const file = await sendStudy(studiesRef.current.find((s)=>s.id === row.id) || row, shared, controller.signal);
                if (file) stored.push(file);
                else if (!controller.signal.aborted) failed += 1;
            }
        } finally{
            controllerRef.current = null;
            setSending(false);
        }
        return {
            stored: stored,
            failed: failed,
            cancelled: controller.signal.aborted
        };
    }, [
        sendStudy
    ]);
    /** Stop the send in flight; its session is aborted and the row returns to the queue. */ const cancel = (0, $acw62.useCallback)(()=>{
        controllerRef.current?.abort();
    }, []);
    /** Mark rows the overlay's limits refuse, so a send counts them out instead of trying. */ const setBlocked = (0, $acw62.useCallback)((blockedIds)=>{
        setStudies((list)=>{
            let changed = false;
            const next = list.map((s)=>{
                const blocked = blockedIds.has(s.id);
                if (Boolean(s.blocked) === blocked) return s;
                changed = true;
                return {
                    ...s,
                    blocked: blocked
                };
            });
            if (!changed) return list;
            studiesRef.current = next;
            return next;
        });
    }, []);
    return {
        studies: studies,
        sending: sending,
        addStudies: addStudies,
        remove: remove,
        setDocumentDate: setDocumentDate,
        reset: reset,
        send: send,
        cancel: cancel,
        knownSopUids: knownSopUids,
        setBlocked: setBlocked
    };
}
var $225b8f2d08ed4546$export$2e2bcd8739ae039 = $225b8f2d08ed4546$export$9e757e81a22d1b0d;

});

parcelRegister("6kym7", function(module, exports) {

$parcel$export(module.exports, "useUploadLimits", () => $49bf42b1e5c69ef4$export$4225000df8440168);

var $acw62 = parcelRequire("acw62");

var $eVM84 = parcelRequire("eVM84");

var $j7Lry = parcelRequire("j7Lry");
function $49bf42b1e5c69ef4$export$4225000df8440168({ open: open, patientId: patientId, clinicId: clinicId }) {
    const [capabilities, setCapabilities] = (0, $acw62.useState)(null);
    const [basePolicy, setBasePolicy] = (0, $acw62.useState)(null);
    const [byKind, setByKind] = (0, $acw62.useState)({});
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const requested = (0, $acw62.useRef)(new Set());
    const readyRef = (0, $acw62.useRef)(Promise.resolve());
    (0, $acw62.useEffect)(()=>{
        if (!open || !patientId) return undefined;
        let cancelled = false;
        requested.current = new Set();
        setByKind({});
        setLoading(true);
        const caps = (0, $eVM84.bffQuery)((0, $j7Lry.UPLOAD_CAPABILITIES), {}).then((d)=>{
            if (!cancelled) setCapabilities(d?.uploadCapabilities || null);
            return d?.uploadCapabilities || null;
        }).catch(()=>{
            if (!cancelled) setCapabilities(null);
            return null;
        });
        const base = (0, $eVM84.bffQuery)((0, $j7Lry.UPLOAD_POLICY), {
            patientId: patientId,
            clinicId: clinicId || null,
            kind: null
        }).then((d)=>{
            if (!cancelled) setBasePolicy(d?.uploadPolicy || null);
            return d?.uploadPolicy || null;
        }).catch(()=>{
            if (!cancelled) setBasePolicy(null);
            return null;
        });
        readyRef.current = Promise.all([
            caps,
            base
        ]).then(([c, p])=>({
                capabilities: c,
                policy: p
            }));
        readyRef.current.finally(()=>{
            if (!cancelled) setLoading(false);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        open,
        patientId,
        clinicId
    ]);
    /** Make sure a kind's policy is (being) read. */ const ensureKind = (0, $acw62.useCallback)((kind)=>{
        if (!kind || !patientId || requested.current.has(kind)) return;
        requested.current.add(kind);
        (0, $eVM84.bffQuery)((0, $j7Lry.UPLOAD_POLICY), {
            patientId: patientId,
            clinicId: clinicId || null,
            kind: kind
        }).then((d)=>setByKind((m)=>({
                    ...m,
                    [kind]: d?.uploadPolicy || null
                }))).catch(()=>setByKind((m)=>({
                    ...m,
                    [kind]: null
                })));
    }, [
        patientId,
        clinicId
    ]);
    const policyFor = (0, $acw62.useCallback)((kind)=>kind && byKind[kind] !== undefined ? byKind[kind] || basePolicy : basePolicy, [
        byKind,
        basePolicy
    ]);
    /** Resolves once capabilities and the base policy have answered (or failed). */ const ready = (0, $acw62.useCallback)(()=>readyRef.current, []);
    return {
        capabilities: capabilities,
        basePolicy: basePolicy,
        policyFor: policyFor,
        ensureKind: ensureKind,
        loading: loading,
        ready: ready
    };
}
var $49bf42b1e5c69ef4$export$2e2bcd8739ae039 = $49bf42b1e5c69ef4$export$4225000df8440168;

});



parcelRegister("a8TVX", function(module, exports) {

$parcel$export(module.exports, "default", () => $a73dbad6d1e43f27$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $eBrFc = parcelRequire("eBrFc");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $aJ1FU = parcelRequire("aJ1FU");
var $lxEfx = parcelRequire("lxEfx");
var $cjPik = parcelRequire("cjPik");
var $bfs4Q = parcelRequire("bfs4Q");
var $fAR2n = parcelRequire("fAR2n");
var $66joL = parcelRequire("66joL");
var $gCvEY = parcelRequire("gCvEY");

var $jTCZr = parcelRequire("jTCZr");

var $42KYO = parcelRequire("42KYO");
var $2WFPf = parcelRequire("2WFPf");
var $94UvM = parcelRequire("94UvM");
var $iDwyV = parcelRequire("iDwyV");
var $chm1L = parcelRequire("chm1L");
parcelRequire("dSPMK");
var $asXy3 = parcelRequire("asXy3");
var $LNQP4 = parcelRequire("LNQP4");
parcelRequire("fkEOT");
var $k27hS = parcelRequire("k27hS");

var $eVM84 = parcelRequire("eVM84");

var $j7Lry = parcelRequire("j7Lry");

var $1yr2B = parcelRequire("1yr2B");

var $7LBYc = parcelRequire("7LBYc");

var $7sS0P = parcelRequire("7sS0P");

var $eAIjx = parcelRequire("eAIjx");

var $aMDcZ = parcelRequire("aMDcZ");

var $1Qo7B = parcelRequire("1Qo7B");

var $3VOBa = parcelRequire("3VOBa");

var $6wb9F = parcelRequire("6wb9F");

var $4pAHp = parcelRequire("4pAHp");

var $SeSDF = parcelRequire("SeSDF");

var $eFS97 = parcelRequire("eFS97");

var $1Zgj3 = parcelRequire("1Zgj3");

var $2J9GV = parcelRequire("2J9GV");

var $gS5Gq = parcelRequire("gS5Gq");

var $8qEaX = parcelRequire("8qEaX");

var $hm7Q7 = parcelRequire("hm7Q7");

var $hRWhk = parcelRequire("hRWhk");
// «استخراج هوشمند» — a model decides what a stored document IS, reads it the way that
// kind of document is read, and the doctor decides what of it enters the record.
// docs/DOCTOR_PATIENT_FILES_AND_AI_EXTRACTION_DESIGN.md §6.2–§6.4, §7.7–§7.8, §8.5;
// docs/DICOM_COMPRESSION_LIMITS_AND_DOCUMENT_OCR_DESIGN.md §9, §10.4, §24.1 (R-A3, R-A4, R-P1), §24.7.
//
// The rules the overlay is built around:
//
//  1. It spends پارسه only on an explicit press (DESIGN_CONCEPT §13.4). Opening it from
//     «استخراج» IS that press, and the price is on the button that opened it; opening it
//     from «بازبینی» shows a stored run and costs nothing. «استخراج مجدد» and «تغییر روش
//     استخراج» say their price before they run. The price is the policy's
//     (AnalyzeClinicalFile), one per run whatever the class.
//  2. Nothing enters the record until «ثبت در پرونده». The run is a reading of a
//     document, labelled «پیشنهاد هوش مصنوعی» until a clinician saves it (§13.3).
//  3. A failed, illegible or not-medical run says nothing was charged, and the manual
//     path is never blocked.
//  4. The class is decided AFTER the run (R-A4): a chip says what the model thought the
//     document is and how sure it was; «تغییر نوع» corrects the file's kind and «تغییر
//     روش استخراج» reads it again as another class. There is no mid-run pause.
//  5. There is no progress signal, so the running state says one honest sentence
//     (R-P1), not timed stages.
//  6. A drug line never enters the visit's نسخه by itself (§23.3 A13). With the
//     host's `onAddToVisitPrescription` capability (a Visit page) each line offers
//     «افزودن به نسخه ویزیت», which fills the visit's drug form and saves nothing;
//     an unverified or low-confidence line asks first, and a line goes once per review.
//  7. A LAB sheet is reviewed as raw OCR beside its image (docs/lab_results_ocr_wireframe_ai_agent.md):
//     the model supplies each row's name and value, the catalogue supplies the unit,
//     reference range and status for this patient (`labReview`), only the value is
//     editable, and «ثبت و ادامه» first stops on values it cannot record, then asks
//     about doubtful rows, then records and closes.
const $a73dbad6d1e43f27$var$PHASE = {
    CHOOSE: 'choose',
    RUNNING: 'running',
    READY: 'ready',
    ERROR: 'error'
};
// Legacy modes keep their existing titles.
const $a73dbad6d1e43f27$var$TITLE_KEY = {
    LAB_RESULTS: 'patient.files.extract.lab',
    REPORT: 'patient.files.extract.report',
    PRESCRIPTION: 'patient.files.extract.modeTitle.PRESCRIPTION',
    NOTE: 'patient.files.extract.modeTitle.NOTE',
    RECORD: 'patient.files.extract.modeTitle.RECORD',
    NOT_MEDICAL: 'patient.files.extract.modeTitle.NOT_MEDICAL'
};
// The lab review wants the room of a near-full-screen modal on a workstation (§3); the
// kit's widest dialog is 52rem, and the dialog merges a caller's class last.
const $a73dbad6d1e43f27$var$LAB_DIALOG_CLASS = 'max-w-[min(96rem,calc(100vw-2rem))]';
function $a73dbad6d1e43f27$var$RunningSkeleton({ isMobile: isMobile }) {
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        "data-testid": "extract-running-label",
        "aria-live": "polite",
        style: {
            margin: 0,
            fontSize: '0.8125rem',
            color: (0, $jTCZr.CT).ink2
        }
    }, t('patient.files.extract.runningDetect')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonRegion), {
        label: t('patient.files.extract.runningDetect'),
        "data-testid": "extract-loading",
        style: {
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : 'minmax(0, 5fr) minmax(0, 6fr)',
            gap: '1rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: "100%",
        height: isMobile ? 160 : 420,
        radius: (0, $7sS0P.RADIUS).card
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonText), {
        lines: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonTable), {
        rows: 6,
        columns: isMobile ? 2 : 5,
        dense: true
    }))));
}
/** «تشخیص: نسخه · اطمینان زیاد» */ function $a73dbad6d1e43f27$var$ClassChip({ run: run }) {
    const { t: t } = (0, $LNQP4.default)();
    const key = (0, $1Qo7B.documentClassLabelKey)(run?.documentClass);
    if (!key) return null;
    const bucket = (0, $1Qo7B.confidenceBucket)(run.classConfidence);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hRWhk.FileChip), {
        tone: "accent",
        "data-testid": "extract-class",
        "data-class": run.documentClass,
        "data-source": run.classSource || undefined
    }, bucket ? t('patient.files.extract.classChip', {
        class: t(key),
        confidence: t(`patient.files.extract.confidence.${bucket}`)
    }) : t('patient.files.extract.classChipNoConfidence', {
        class: t(key)
    }));
}
function $a73dbad6d1e43f27$export$2e2bcd8739ae039({ open: open, file: file, patientId: patientId, appointmentId: appointmentId, initialRun: initialRun, initialMode: initialMode, onClose: onClose, onRan: onRan, onSaved: onSaved, onAddToVisitPrescription: onAddToVisitPrescription = null }) {
    const { t: t, has: has, formatDigits: formatDigits, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const { isMobile: isMobile } = (0, $k27hS.default)();
    const navigate = (0, $eBrFc.useAppNavigate)();
    const toast = (0, $7LBYc.useOptionalToast)();
    // «افزایش اعتبار» on a refused run only where this deployment sells credit (PM-0211).
    const { costOf: costOf, purchaseAvailable: purchaseAvailable } = (0, $1yr2B.useCreditPrices)();
    const price = costOf('ANALYZE_FILE');
    const kind = (0, $1Qo7B.canonicalKind)(file?.kind);
    const needsChoice = !kind || kind === 'OTHER';
    const [phase, setPhase] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState($a73dbad6d1e43f27$var$PHASE.RUNNING);
    const [chosenClass, setChosenClass] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('AUTO');
    const [run, setRun] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // { kind: 'credit'|'inflight'|'illegible'|'failed', text }
    const [rows, setRows] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [pickedDx, setPickedDx] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>new Set());
    const [pickedMeds, setPickedMeds] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>new Set());
    const [documentDate, setDocumentDate] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [report, setReport] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [rxRows, setRxRows] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [note, setNote] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [record, setRecord] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [saving, setSaving] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [saved, setSaved] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // { text, tone }
    const [saveError, setSaveError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [confirmDiscard, setConfirmDiscard] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false); // false | 'close' | 'leave'
    const [confirmRerun, setConfirmRerun] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // { classOverride } | null
    // «افزودن به نسخه ویزیت», per row key: 'added' | 'already'. Held for this review only.
    const [visitAdds, setVisitAdds] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>new Map());
    const [confirmVisitAdd, setConfirmVisitAdd] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // the row awaiting «افزودن؟»
    const [methodMenu, setMethodMenu] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [kindState, setKindState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        saving: false,
        done: false,
        error: ''
    });
    // The lab review: the image panel (open beside the table on a workstation, on demand
    // on a phone), rows «ثبت و ادامه» was stopped on, and doubtful rows awaiting «ادامه؟».
    const [labSourceVisible, setLabSourceVisible] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>!isMobile);
    const [labBlocked, setLabBlocked] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [confirmSuspicious, setConfirmSuspicious] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // rows | null
    const labContinuing = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    const labPanelRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const methodRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const adoptRun = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((r)=>{
        setRun(r);
        setRows((0, $6wb9F.labRowsFromRun)(r));
        setPickedDx(new Set());
        setPickedMeds(new Set());
        setDocumentDate(r?.detectedDocumentDate || file?.documentDate || '');
        setReport((0, $eFS97.reportDraftFromRun)(r, file, appointmentId));
        setRxRows((0, $1Zgj3.prescriptionRowsFrom)(r?.prescription?.items));
        setNote((0, $2J9GV.noteDraftFrom)(r?.note, file, appointmentId));
        setRecord((0, $gS5Gq.recordDraftFrom)(r?.record, file, appointmentId));
        setTouched(false);
        setSaved(null);
        setSaveError('');
        setKindState({
            saving: false,
            done: false,
            error: ''
        });
        setVisitAdds(new Map());
        setConfirmVisitAdd(null);
        setLabBlocked(false);
        setConfirmSuspicious(null);
    }, [
        file,
        appointmentId
    ]);
    const extract = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ({ mode: mode = 'AUTO', classOverride: classOverride = null } = {})=>{
        if (!file?.id) return;
        setPhase($a73dbad6d1e43f27$var$PHASE.RUNNING);
        setError(null);
        try {
            // The model reads a whole lab sheet: 30–40s is ORDINARY here, and the
            // default 30s budget aborted the fetch mid-run. The server finished anyway
            // and recorded a charged, successful extraction — so the doctor saw
            // «استخراج انجام نشد؛ هزینه‌ای کسر نشده است» over a run that HAD cost 10
            // پارسه, and was invited to spend 10 more retrying it. Measured on beta1
            // 2026-09-20: 35s and 37s for the same sheet, both reported as failures.
            const d = await (0, $eVM84.bffMutation)((0, $j7Lry.EXTRACT_CLINICAL_FILE), {
                fileId: file.id,
                mode: mode,
                classOverride: classOverride
            }, {
                timeoutMs: (0, $eVM84.LONG_REQUEST_TIMEOUT_MS)
            });
            const r = d?.extractClinicalFile || null;
            onRan?.(r);
            if (!r || r.status === 'failed') {
                const code = String(r?.errorCode || '').toUpperCase();
                setError({
                    kind: code === 'ILLEGIBLE' ? 'illegible' : 'failed',
                    text: code === 'ILLEGIBLE' ? t('patient.files.extract.illegible') : code === 'UNSUPPORTED' ? t('patient.files.extract.noBytes') : t('patient.files.extract.failed')
                });
                setPhase($a73dbad6d1e43f27$var$PHASE.ERROR);
                return;
            }
            adoptRun(r);
            setPhase($a73dbad6d1e43f27$var$PHASE.READY);
        } catch (e) {
            const code = e?.extensions?.code;
            setError({
                kind: code === 'INSUFFICIENT_CREDITS' ? 'credit' : code === 'ANALYSIS_IN_FLIGHT' ? 'inflight' : 'failed',
                text: code === 'INSUFFICIENT_CREDITS' ? t('patient.files.extract.credit') : code === 'ANALYSIS_IN_FLIGHT' ? t('patient.files.extract.inFlight') : (0, $3VOBa.fileErrorText)(t, has, e, 'patient.files.extract.failed')
            });
            setPhase($a73dbad6d1e43f27$var$PHASE.ERROR);
        }
    }, [
        file?.id,
        adoptRun,
        onRan,
        t,
        has
    ]);
    // Opening the overlay is the press: run now — unless it was opened on a stored run
    // («بازبینی», free) or the document does not say what it is (the doctor may name it).
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open || !file?.id) return;
        setConfirmDiscard(false);
        setConfirmRerun(null);
        if (initialRun) {
            adoptRun(initialRun);
            setPhase($a73dbad6d1e43f27$var$PHASE.READY);
            return;
        }
        if (needsChoice && !initialMode) {
            setRun(null);
            setChosenClass('AUTO');
            setPhase($a73dbad6d1e43f27$var$PHASE.CHOOSE);
            return;
        }
        extract({
            mode: initialMode || 'AUTO'
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open,
        file?.id
    ]);
    const notMedical = String(run?.errorCode || '').toUpperCase() === 'NOT_MEDICAL';
    const editorMode = notMedical ? 'NOT_MEDICAL' : run?.mode || 'REPORT';
    const labMode = phase === $a73dbad6d1e43f27$var$PHASE.READY && editorMode === 'LAB_RESULTS';
    const labReview = (0, $SeSDF.default)({
        patientId: patientId || file?.patientId,
        run: run,
        enabled: labMode
    });
    const labReady = labReview.status === 'ready';
    const labInput = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>labReady ? (0, $6wb9F.labSaveInput)(rows, labReview.review) : [], [
        labReady,
        rows,
        labReview.review
    ]);
    const reportText = report ? (0, $eFS97.assembledText)(report) : '';
    const legibility = run?.legibility || run?.note?.legibility || '';
    const recordReady = ()=>{
        if (!record) return false;
        const meds = record.includeMedications ? record.medications.filter((r)=>r.selected) : [];
        if (meds.some((r)=>(0, $1Zgj3.prescriptionRowProblem)(r))) return false;
        return Boolean((0, $eFS97.assembledText)(record.report)) || record.pickedDiagnoses.length > 0 || meds.length > 0;
    };
    const modeReady = {
        // Without the catalogue a lab value has no unit or status: nothing is recordable.
        LAB_RESULTS: ()=>labReady && (labInput.length > 0 || pickedDx.size > 0 || pickedMeds.size > 0),
        REPORT: ()=>Boolean(reportText),
        PRESCRIPTION: ()=>(0, $1Zgj3.prescriptionRowsReady)(rxRows),
        NOTE: ()=>Boolean(note) && (0, $2J9GV.noteReadyToSave)(note, legibility),
        RECORD: recordReady,
        NOT_MEDICAL: ()=>false
    }[editorMode] || (()=>false);
    const nothingFound = phase === $a73dbad6d1e43f27$var$PHASE.READY && !notMedical && ({
        LAB_RESULTS: !rows.length && !run?.diagnoses?.length && !run?.medications?.length,
        REPORT: !reportText,
        PRESCRIPTION: !rxRows.length,
        NOTE: !note?.lines?.length && !(note && (0, $eFS97.assembledText)(note.report)),
        RECORD: !(record && (0, $eFS97.assembledText)(record.report)) && !run?.record?.diagnoses?.length
    })[editorMode];
    const canSave = phase === $a73dbad6d1e43f27$var$PHASE.READY && !saving && !saved && modeReady();
    const dirty = phase === $a73dbad6d1e43f27$var$PHASE.READY && !saved && touched;
    // How many ticked rows still cannot be recorded — live, so the notice leaves as the
    // doctor fixes them.
    const labBlockingCount = labMode && labBlocked && labReady ? (0, $6wb9F.labSubmitCheck)(rows, labReview.review).blocking.length : 0;
    const requestClose = ()=>{
        if (saving) return;
        if (dirty) {
            setConfirmDiscard('close');
            return;
        }
        onClose?.();
    };
    // «رفتن به نسخه ویزیت» — the review closes for the page's drug form. An unsaved
    // history import is still guarded: leaving is not the same as discarding it silently.
    const leaveToVisitPrescription = ()=>{
        if (saving) return;
        if (dirty) {
            setConfirmDiscard('leave');
            return;
        }
        onClose?.({
            toVisitPrescription: true
        });
    };
    const commitVisitAdd = (row)=>{
        if (!onAddToVisitPrescription || visitAdds.has(row.key)) return;
        const outcome = onAddToVisitPrescription((0, $8qEaX.visitRxDraftFromRow)(row));
        setVisitAdds((prev)=>new Map(prev).set(row.key, outcome === 'alreadyPrescribed' ? 'already' : 'added'));
    };
    const requestVisitAdd = (row)=>{
        if (visitAdds.has(row.key)) return;
        if ((0, $8qEaX.documentRxNeedsConfirm)(row)) {
            setConfirmVisitAdd(row);
            return;
        }
        commitVisitAdd(row);
    };
    const visitRx = onAddToVisitPrescription ? {
        onAdd: requestVisitAdd,
        added: visitAdds,
        disabled: saving
    } : null;
    const save = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        if (!canSave) return;
        setSaving(true);
        setSaveError('');
        const analysisId = run?.id || null;
        try {
            if (editorMode === 'REPORT' || editorMode === 'NOTE') {
                const draft = editorMode === 'NOTE' ? note.report : report;
                const base = (0, $eFS97.reportInput)(draft);
                const d = await (0, $eVM84.bffMutation)((0, $j7Lry.SAVE_CLINICAL_REPORT), {
                    input: {
                        fileId: file.id,
                        analysisId: analysisId,
                        ...base,
                        fullText: editorMode === 'NOTE' ? (0, $2J9GV.noteFullText)(note) : base.fullText,
                        alsoNote: Boolean(appointmentId) && draft.alsoNote,
                        appointmentId: appointmentId || null
                    }
                });
                const noteMissed = Boolean(appointmentId) && draft.alsoNote && !d?.saveClinicalReport?.noteSaved;
                setSaved({
                    tone: noteMissed ? 'warning' : 'success',
                    text: t(noteMissed ? 'patient.files.extract.savedReportNoNote' : 'patient.files.extract.savedReport')
                });
                onSaved?.(d?.saveClinicalReport?.file || null);
            } else if (editorMode === 'PRESCRIPTION') {
                const items = (0, $1Zgj3.prescriptionItemsInput)(rxRows);
                const d = await (0, $eVM84.bffMutation)((0, $j7Lry.SAVE_PRESCRIPTION_EXTRACTION), {
                    input: {
                        fileId: file.id,
                        analysisId: analysisId,
                        items: items,
                        appointmentId: appointmentId || null
                    }
                });
                const r = d?.savePrescriptionExtraction;
                if (r?.failed > 0) {
                    setSaveError(t('patient.files.extract.savedPartial', {
                        saved: formatDigits(r.saved ?? 0),
                        total: formatDigits(items.length)
                    }));
                    if (r.saved > 0) onSaved?.(r.file || null);
                } else {
                    setSaved({
                        tone: 'success',
                        text: t('patient.files.extract.rx.saved', {
                            count: formatNumber(r?.saved ?? items.length)
                        })
                    });
                    onSaved?.(r?.file || null);
                }
            } else if (editorMode === 'RECORD') {
                const base = (0, $eFS97.reportInput)(record.report);
                const dx = run?.record?.diagnoses || [];
                const meds = record.includeMedications ? (0, $1Zgj3.prescriptionItemsInput)(record.medications) : [];
                const d = await (0, $eVM84.bffMutation)((0, $j7Lry.SAVE_MEDICAL_RECORD_EXTRACTION), {
                    input: {
                        fileId: file.id,
                        analysisId: analysisId,
                        report: {
                            fileId: file.id,
                            analysisId: analysisId,
                            ...base,
                            alsoNote: Boolean(appointmentId) && record.report.alsoNote,
                            appointmentId: appointmentId || null
                        },
                        diagnoses: record.pickedDiagnoses.map((i)=>dx[i]).filter(Boolean).map((x)=>({
                                text: x.text,
                                icd10: x.icd10Hint || null
                            })),
                        medications: meds.length ? meds : null
                    }
                });
                const r = d?.saveMedicalRecordExtraction;
                if (r?.failed > 0) {
                    setSaveError(t('patient.files.extract.record.savedPartial', {
                        failed: formatNumber(r.failed)
                    }));
                    onSaved?.(r.file || null);
                } else {
                    setSaved({
                        tone: 'success',
                        text: t('patient.files.extract.record.saved')
                    });
                    onSaved?.(r?.file || null);
                }
            } else {
                // The rows carry their provenance; the BFF re-resolves test, unit, reference
                // range and status from the catalogue before anything is written.
                const d = await (0, $eVM84.bffMutation)((0, $j7Lry.SAVE_LAB_RESULTS_FOR_FILE), {
                    input: {
                        patientId: patientId,
                        fileId: file.id,
                        analysisId: analysisId,
                        appointmentId: file.appointmentId || appointmentId || null,
                        fileName: file.fileName || '',
                        documentType: run?.documentType || 'lab_report',
                        effectiveDate: documentDate || null,
                        labResults: labInput,
                        diagnoses: (run?.diagnoses || []).filter((_, i)=>pickedDx.has(i)),
                        medications: (run?.medications || []).filter((_, i)=>pickedMeds.has(i)).map((m)=>({
                                name: m.name,
                                dosage: m.dosage,
                                frequency: m.frequency
                            })),
                        clinicalNotes: run?.clinicalNotes || '',
                        abnormalFlags: run?.abnormalFlags || [],
                        categories: []
                    }
                });
                const r = d?.saveLabResults;
                const savedCount = r?.savedObservations ?? 0;
                if (r?.errorCode === 'FILE_NOT_FOUND' || r?.errorCode === 'LAB_REFERENCES_UNAVAILABLE') setSaveError(t(`patient.files.saveLabError.${r.errorCode}`));
                else if (savedCount < labInput.length) {
                    setSaveError(t('patient.files.extract.savedPartial', {
                        saved: formatDigits(savedCount),
                        total: formatDigits(labInput.length)
                    }));
                    if (savedCount > 0) onSaved?.(null);
                } else if (r?.errorCode || savedCount === 0) {
                    setSaved({
                        tone: r?.errorCode ? 'warning' : 'success',
                        text: r?.errorCode ? t(`patient.files.saveLabError.${r.errorCode}`) : t('patient.files.extract.savedLab', {
                            count: formatDigits(savedCount)
                        })
                    });
                    onSaved?.(null);
                } else {
                    // «ثبت و ادامه»: the values are in the record, so the review is done.
                    toast.success?.(t('patient.files.extract.labReview.saved', {
                        count: savedCount
                    }));
                    onSaved?.(null);
                    onClose?.();
                }
            }
        } catch (e) {
            setSaveError((0, $3VOBa.fileErrorText)(t, has, e, editorMode === 'LAB_RESULTS' ? 'patient.files.extract.saveLabFailed' : 'patient.files.extract.saveReportFailed'));
        } finally{
            setSaving(false);
        }
    }, [
        canSave,
        editorMode,
        file,
        run,
        report,
        note,
        rxRows,
        record,
        appointmentId,
        patientId,
        documentDate,
        labInput,
        pickedDx,
        pickedMeds,
        onSaved,
        onClose,
        toast,
        t,
        has,
        formatDigits,
        formatNumber
    ]);
    // §15 — before a lab review is recorded: values it cannot record stop it (and the
    // first one is focused), doubtful rows ask «ادامه با موارد مشکوک؟», then it saves.
    const requestSave = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        if (!canSave) return;
        if (editorMode === 'LAB_RESULTS') {
            const check = (0, $6wb9F.labSubmitCheck)(rows, labReview.review);
            if (check.blocking.length) {
                setLabBlocked(true);
                labPanelRef.current?.focusRow(check.blocking[0].key);
                return;
            }
            setLabBlocked(false);
            if (check.suspicious.length) {
                setConfirmSuspicious(check.suspicious);
                return;
            }
        }
        save();
    }, [
        canSave,
        editorMode,
        rows,
        labReview.review,
        save
    ]);
    // Ctrl+Enter records it (DESKTOP_WEB §5).
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open || isMobile) return undefined;
        const onKey = (e)=>{
            if ((e.ctrlKey || e.metaKey) && e.key === 'Enter') {
                e.preventDefault();
                requestSave();
            }
        };
        window.addEventListener('keydown', onKey);
        return ()=>window.removeEventListener('keydown', onKey);
    }, [
        open,
        isMobile,
        requestSave
    ]);
    // «تغییر نوع» — the file's kind follows what the document turned out to be.
    const applyKindSuggestion = async ()=>{
        if (!run?.kindSuggestion) return;
        setKindState({
            saving: true,
            done: false,
            error: ''
        });
        try {
            await (0, $eVM84.bffMutation)((0, $j7Lry.UPDATE_CLINICAL_FILE), {
                fileId: file.id,
                input: {
                    kind: run.kindSuggestion
                }
            });
            setKindState({
                saving: false,
                done: true,
                error: ''
            });
            onRan?.(run);
        } catch (e) {
            setKindState({
                saving: false,
                done: false,
                error: (0, $3VOBa.fileErrorText)(t, has, e, 'patient.files.edit.failed')
            });
        }
    };
    if (!open || !file) return null;
    const toggleSet = (setter)=>(i, checked)=>{
            setTouched(true);
            setter((prev)=>{
                const next = new Set(prev);
                if (checked) next.add(i);
                else next.delete(i);
                return next;
            });
        };
    const touch = (setter)=>(next)=>{
            setTouched(true);
            setter(next);
        };
    const disabled = saving || Boolean(saved);
    const title = phase === $a73dbad6d1e43f27$var$PHASE.CHOOSE ? t('patient.files.extract.chooseTitle') : t($a73dbad6d1e43f27$var$TITLE_KEY[phase === $a73dbad6d1e43f27$var$PHASE.READY ? editorMode : 'REPORT'] || $a73dbad6d1e43f27$var$TITLE_KEY.REPORT);
    const header = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            flexWrap: 'wrap'
        }
    }, phase === $a73dbad6d1e43f27$var$PHASE.READY && !saved && !notMedical && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "extract-ai-badge",
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.25rem',
            padding: '0.125rem 0.5rem',
            borderRadius: (0, $7sS0P.RADIUS).chip,
            background: (0, $jTCZr.CT).accentSoft,
            color: (0, $jTCZr.CT).accentInk,
            fontSize: '0.6875rem',
            fontWeight: 700
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $chm1L.default), {
        size: 12,
        "aria-hidden": true
    }), " ", t('patient.files.extract.aiBadge')), labMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hRWhk.FileChip), {
        tone: "neutral",
        "data-testid": "extract-source-ocr"
    }, t('patient.files.extract.labReview.sourceOcr')), phase === $a73dbad6d1e43f27$var$PHASE.READY && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a73dbad6d1e43f27$var$ClassChip, {
        run: run
    }), labMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: labSourceVisible ? 'outline' : 'ghost',
        size: "sm",
        className: "h-7 gap-1 px-2",
        "aria-pressed": labSourceVisible,
        onClick: ()=>setLabSourceVisible((v)=>!v),
        "data-testid": "extract-image-toggle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $94UvM.default), {
        size: 13,
        "aria-hidden": true
    }), " ", t('patient.files.extract.labReview.imageToggle')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).mute,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            maxWidth: '100%'
        }
    }, file.fileName));
    const rerunAvailable = phase === $a73dbad6d1e43f27$var$PHASE.READY || phase === $a73dbad6d1e43f27$var$PHASE.ERROR && (error?.kind === 'failed' || error?.kind === 'illegible');
    const rerunButtons = rerunAvailable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        className: "gap-1.5",
        onClick: ()=>setConfirmRerun({
                classOverride: run?.classSource === 'override' ? run.documentClass : null
            }),
        disabled: saving,
        "data-testid": "extract-rerun"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $iDwyV.default), {
        size: 14,
        "aria-hidden": true
    }), " ", t('patient.files.extract.rerun'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eAIjx.default), {
        cost: price,
        size: "sm",
        testid: "extract-rerun-price"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        ref: methodRef,
        variant: "ghost",
        className: "gap-1",
        onClick: ()=>setMethodMenu((v)=>!v),
        "aria-haspopup": "menu",
        "aria-expanded": methodMenu,
        disabled: saving,
        "data-testid": "extract-method"
    }, t('patient.files.extract.changeMethod'), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2WFPf.default), {
        size: 14,
        "aria-hidden": true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bfs4Q.default), {
        open: methodMenu,
        onClose: ()=>setMethodMenu(false),
        anchorRef: methodRef,
        width: 240,
        placement: "auto",
        ariaLabel: t('patient.files.extract.changeMethod'),
        "data-testid": "extract-method-menu"
    }, (0, $1Qo7B.OVERRIDE_CLASSES).map((cls)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            key: cls,
            variant: "ghost",
            role: "menuitem",
            className: "w-full justify-start font-normal",
            onClick: ()=>{
                setMethodMenu(false);
                setConfirmRerun({
                    classOverride: cls
                });
            },
            "data-testid": `extract-method-${cls}`,
            "aria-current": run?.documentClass === cls ? 'true' : undefined
        }, t((0, $1Qo7B.documentClassLabelKey)(cls))))));
    const footer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: '0.5rem',
            flexWrap: 'wrap',
            width: '100%',
            alignItems: 'center'
        }
    }, rerunButtons, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1
        }
    }), phase === $a73dbad6d1e43f27$var$PHASE.CHOOSE ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        onClick: requestClose,
        "data-testid": "extract-cancel"
    }, t('common.actions.cancel')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        className: "gap-1.5",
        onClick: ()=>extract({
                classOverride: chosenClass === 'AUTO' ? null : chosenClass
            }),
        "data-testid": "extract-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $chm1L.default), {
        size: 15,
        "aria-hidden": true
    }), " ", t('patient.files.actions.extract'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eAIjx.default), {
        cost: price,
        size: "sm",
        tone: "onDark",
        testid: "extract-start-price"
    }))) : saved || notMedical ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        onClick: onClose,
        "data-testid": "extract-done"
    }, t('common.actions.close')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        onClick: requestClose,
        disabled: saving,
        "data-testid": "extract-cancel"
    }, t('common.actions.cancel')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        onClick: requestSave,
        disabled: !canSave,
        className: labMode ? 'gap-1.5' : undefined,
        "data-testid": "extract-save"
    }, saving ? t('common.state.saving') : labMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, t('patient.files.extract.labReview.save', {
        count: labInput.length
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $42KYO.default), {
        size: 15,
        "aria-hidden": true,
        style: (0, $asXy3.MIRROR_ICON)
    })) : t('patient.files.extract.saveReport'))));
    const viewer = isMobile ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lxEfx.default), {
        title: t('patient.files.extract.showDocument')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aMDcZ.default), {
        file: file,
        height: "16rem",
        testid: "extract-viewer"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'sticky',
            top: 0,
            alignSelf: 'start'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aMDcZ.default), {
        file: file,
        height: "min(70vh, 40rem)",
        testid: "extract-viewer"
    }));
    // What the run said about the document before any editor: truncation, handwriting,
    // legibility, the class disagreement, a name on the page, and document-wide flags.
    const banners = phase === $a73dbad6d1e43f27$var$PHASE.READY && run ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, run.truncatedPages > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "info",
        "data-testid": "extract-truncated"
    }, t('patient.files.extract.truncated', {
        count: formatNumber(run.truncatedPages)
    })), [
        'partial',
        'predominant'
    ].includes(String(run.handwriting || '').toLowerCase()) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "info",
        "data-testid": "extract-handwriting"
    }, t(`patient.files.extract.handwriting.${String(run.handwriting).toLowerCase()}`)), [
        'fair',
        'poor'
    ].includes(String(legibility).toLowerCase()) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "warning",
        "data-testid": "extract-legibility",
        "data-legibility": legibility
    }, t(`patient.files.extract.legibility.${String(legibility).toLowerCase()}`)), run.kindSuggestion && (0, $1Qo7B.canonicalKind)(run.kindSuggestion) !== kind && !notMedical && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "info",
        "data-testid": "extract-kind-suggestion",
        action: kindState.done ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "outline",
            size: "sm",
            onClick: applyKindSuggestion,
            disabled: kindState.saving,
            "data-testid": "extract-kind-apply"
        }, kindState.saving ? t('common.state.saving') : t('patient.files.extract.changeKind'))
    }, kindState.done ? t('patient.files.extract.kindChanged', {
        kind: t((0, $1Qo7B.documentKindLabelKey)(run.kindSuggestion) || 'patient.files.kind.other')
    }) : t('patient.files.extract.kindDisagrees', {
        suggested: t((0, $1Qo7B.documentKindLabelKey)(run.kindSuggestion) || 'patient.files.kind.other'),
        declared: t((0, $1Qo7B.documentKindLabelKey)(kind) || 'patient.files.kind.other')
    }), kindState.error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'block',
            color: (0, $jTCZr.CT).danger
        }
    }, kindState.error)), run.patientNameOnDocument && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        "data-testid": "extract-name-on-document",
        style: {
            margin: 0,
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).ink2
        }
    }, t('patient.files.extract.nameOnDocument'), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            unicodeBidi: 'isolate',
            fontWeight: 600
        }
    }, run.patientNameOnDocument)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hm7Q7.FlagList), {
        flags: (0, $1Qo7B.documentFlags)(run.flags),
        testid: "extract-document-flags"
    })) : null;
    const chargeNote = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, run?.costParseh > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        "data-testid": "extract-charged",
        style: {
            margin: 0,
            fontSize: '0.6875rem',
            color: (0, $jTCZr.CT).mute
        }
    }, t('patient.files.extract.chargedAmount', {
        price: formatDigits(run.costParseh)
    })), run?.charged === false && !(run?.costParseh > 0) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        "data-testid": "extract-uncharged",
        style: {
            margin: 0,
            fontSize: '0.6875rem',
            color: (0, $jTCZr.CT).mute
        }
    }, t('patient.files.extract.uncharged')));
    let content;
    if (phase === $a73dbad6d1e43f27$var$PHASE.CHOOSE) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "extract-choose",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem',
            maxWidth: '32rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        style: {
            margin: 0,
            fontSize: '0.8125rem',
            color: (0, $jTCZr.CT).ink2,
            lineHeight: 1.9
        }
    }, t('patient.files.extract.chooseClass')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fAR2n.default), {
        label: t('patient.files.extract.chooseClassLabel'),
        value: chosenClass,
        onChange: (e)=>setChosenClass(e.target.value),
        options: [
            {
                value: 'AUTO',
                label: t('patient.files.extract.autoDetect')
            },
            ...(0, $1Qo7B.OVERRIDE_CLASSES).map((cls)=>({
                    value: cls,
                    label: t((0, $1Qo7B.documentClassLabelKey)(cls))
                }))
        ],
        placeholder: "",
        "data-testid": "extract-choose-class"
    }));
    else if (phase === $a73dbad6d1e43f27$var$PHASE.RUNNING) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a73dbad6d1e43f27$var$RunningSkeleton, {
        isMobile: isMobile
    });
    else if (phase === $a73dbad6d1e43f27$var$PHASE.ERROR) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "extract-error",
        "data-kind": error?.kind,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: error?.kind === 'credit' ? 'warning' : 'error',
        action: error?.kind === 'credit' && purchaseAvailable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "outline",
            size: "sm",
            onClick: ()=>navigate('credits'),
            "data-testid": "extract-top-up"
        }, t('patient.files.extract.topUp')) : undefined
    }, error?.text), error?.kind !== 'inflight' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        style: {
            margin: 0,
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).mute
        }
    }, t('patient.files.extract.manualHint')), viewer);
    else if (labMode) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4pAHp.default), {
        ref: labPanelRef,
        file: file,
        run: run,
        rows: rows,
        onRowsChange: touch(setRows),
        review: labReview,
        documentDate: documentDate,
        onDocumentDateChange: (v)=>{
            setTouched(true);
            setDocumentDate(v);
        },
        pickedDiagnoses: pickedDx,
        onPickDiagnosis: toggleSet(setPickedDx),
        pickedMedications: pickedMeds,
        onPickMedication: toggleSet(setPickedMeds),
        disabled: disabled,
        isMobile: isMobile,
        sourceVisible: labSourceVisible,
        onSourceVisibleChange: setLabSourceVisible,
        footnote: chargeNote,
        notices: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, banners, nothingFound && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
            variant: "info",
            "data-testid": "extract-nothing"
        }, t('patient.files.extract.nothingFound')), saved && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
            variant: saved.tone,
            "data-testid": "extract-saved"
        }, saved.text), saveError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
            variant: "error",
            "data-testid": "extract-save-error"
        }, saveError), labBlockingCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
            variant: "error",
            "data-testid": "extract-lab-blocking"
        }, t('patient.files.extract.labReview.blocking', {
            count: labBlockingCount
        })))
    });
    else {
        let editor = null;
        if (notMedical) editor = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
            variant: "info",
            "data-testid": "extract-not-medical"
        }, t('patient.files.extract.notMedical'));
        else if (editorMode === 'REPORT') editor = report && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eFS97.default), {
            draft: report,
            onChange: touch(setReport),
            canWriteNote: Boolean(appointmentId),
            compact: isMobile,
            disabled: disabled
        });
        else if (editorMode === 'PRESCRIPTION') editor = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (run?.prescription?.prescriberName || run?.prescription?.prescribedOn) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
            "data-testid": "rx-prescriber",
            style: {
                margin: 0,
                fontSize: '0.75rem',
                color: (0, $jTCZr.CT).ink2
            },
            dir: "auto"
        }, [
            run.prescription.prescriberName,
            run.prescription.prescriberSpecialty,
            run.prescription.prescribedOn
        ].filter(Boolean).join(" \xb7 ")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
            style: {
                margin: 0,
                fontSize: '0.71875rem',
                color: (0, $jTCZr.CT).mute
            }
        }, t('patient.files.extract.rx.intoHistory')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1Zgj3.default), {
            rows: rxRows,
            onRowsChange: touch(setRxRows),
            flags: run?.flags,
            compact: isMobile,
            disabled: disabled,
            visitRx: visitRx
        }));
        else if (editorMode === 'NOTE') editor = note && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2J9GV.default), {
            draft: note,
            onChange: touch(setNote),
            legibility: legibility,
            canWriteNote: Boolean(appointmentId),
            compact: isMobile,
            disabled: disabled
        });
        else if (editorMode === 'RECORD') editor = record && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gS5Gq.default), {
            record: run?.record,
            draft: record,
            onChange: touch(setRecord),
            flags: run?.flags,
            canWriteNote: Boolean(appointmentId),
            compact: isMobile,
            disabled: disabled,
            visitRx: visitRx
        });
        content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'grid',
                gridTemplateColumns: isMobile ? '1fr' : 'minmax(0, 5fr) minmax(0, 6fr)',
                gap: '1rem',
                alignItems: 'start'
            }
        }, viewer, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: '0.75rem',
                minWidth: 0
            }
        }, banners, nothingFound && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
            variant: "info",
            "data-testid": "extract-nothing"
        }, t('patient.files.extract.nothingFound')), saved && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
            variant: saved.tone,
            "data-testid": "extract-saved"
        }, saved.text), saveError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
            variant: "error",
            "data-testid": "extract-save-error"
        }, saveError), visitRx && [
            ...visitAdds.values()
        ].includes('added') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
            variant: "info",
            "data-testid": "extract-visit-rx-added",
            action: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
                variant: "outline",
                size: "sm",
                onClick: leaveToVisitPrescription,
                disabled: saving,
                "data-testid": "extract-visit-rx-go"
            }, t('patient.files.extract.rx.goToVisitRx'))
        }, t('patient.files.extract.rx.addedHint')), editor, chargeNote));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gCvEY.default), {
        open: open,
        onClose: requestClose,
        title: title,
        header: header,
        footer: footer,
        busy: saving || phase === $a73dbad6d1e43f27$var$PHASE.RUNNING,
        size: "xl",
        className: labMode && !isMobile ? $a73dbad6d1e43f27$var$LAB_DIALOG_CLASS : undefined,
        isMobile: isMobile,
        closeLabel: t('common.actions.close'),
        "data-testid": "extraction-review"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-state": phase,
        "data-mode": editorMode
    }, content)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cjPik.default), {
        open: Boolean(confirmDiscard),
        onOpenChange: (o)=>{
            if (!o) setConfirmDiscard(false);
        },
        title: t('patient.files.extract.discardTitle'),
        description: t('patient.files.extract.discardMessage'),
        confirmLabel: t('patient.files.upload.discardConfirm'),
        cancelLabel: t('patient.files.upload.keepEditing'),
        destructive: true,
        onConfirm: ()=>{
            const leave = confirmDiscard === 'leave';
            setConfirmDiscard(false);
            if (leave) onClose?.({
                toVisitPrescription: true
            });
            else onClose?.();
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cjPik.default), {
        open: Boolean(confirmSuspicious),
        onOpenChange: (o)=>{
            if (o) return;
            const first = confirmSuspicious?.[0];
            setConfirmSuspicious(null);
            // «بازگشت به بررسی» takes the doctor to the first doubtful row.
            if (!labContinuing.current && first) labPanelRef.current?.focusRow(first.key);
            labContinuing.current = false;
        },
        title: t('patient.files.extract.labReview.confirmTitle', {
            count: confirmSuspicious?.length || 0
        }),
        description: t('patient.files.extract.labReview.confirmBody'),
        confirmLabel: t('patient.files.extract.labReview.confirmContinue'),
        cancelLabel: t('patient.files.extract.labReview.confirmBack'),
        onConfirm: ()=>{
            labContinuing.current = true;
            setConfirmSuspicious(null);
            save();
        },
        confirmTestId: "extract-lab-confirm-continue"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cjPik.default), {
        open: Boolean(confirmVisitAdd),
        onOpenChange: (o)=>{
            if (!o) setConfirmVisitAdd(null);
        },
        title: t('patient.files.extract.rx.confirmAddTitle'),
        description: confirmVisitAdd?.verified === false ? t('patient.files.extract.rx.confirmAddUnverified') : t('patient.files.extract.rx.confirmAddReview'),
        confirmLabel: t('patient.files.extract.rx.confirmAddAction'),
        cancelLabel: t('common.actions.cancel'),
        onConfirm: ()=>{
            const row = confirmVisitAdd;
            setConfirmVisitAdd(null);
            if (row) commitVisitAdd(row);
        },
        confirmTestId: "extract-visit-rx-confirm"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cjPik.default), {
        open: Boolean(confirmRerun),
        onOpenChange: (o)=>{
            if (!o) setConfirmRerun(null);
        },
        title: confirmRerun?.classOverride ? t('patient.files.extract.rerunAsTitle', {
            class: t((0, $1Qo7B.documentClassLabelKey)(confirmRerun.classOverride))
        }) : t('patient.files.extract.rerunTitle'),
        description: t('patient.files.extract.rerunMessage', {
            price: formatDigits(price ?? 0)
        }),
        confirmLabel: t('patient.files.extract.rerun'),
        cancelLabel: t('common.actions.cancel'),
        onConfirm: ()=>{
            const next = confirmRerun;
            setConfirmRerun(null);
            extract({
                classOverride: next?.classOverride || null
            });
        },
        confirmTestId: "extract-rerun-confirm"
    }));
}

});
parcelRegister("94UvM", function(module, exports) {

$parcel$export(module.exports, "default", () => $272fea46916dddb1$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $272fea46916dddb1$export$a2387ed3b5d536eb = {
    name: "image",
    size: 24,
    node: [
        [
            "rect",
            {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2",
                ry: "2",
                key: "1m3agn"
            }
        ],
        [
            "circle",
            {
                cx: "9",
                cy: "9",
                r: "2",
                key: "af1f0g"
            }
        ],
        [
            "path",
            {
                d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21",
                key: "1xmnt7"
            }
        ]
    ]
};
$272fea46916dddb1$export$a2387ed3b5d536eb.node;
const $272fea46916dddb1$export$2e2bcd8739ae039 = (0, $9QBug.default)($272fea46916dddb1$export$a2387ed3b5d536eb);

});

parcelRegister("6wb9F", function(module, exports) {

$parcel$export(module.exports, "foldText", () => $4bee6261c6e7da77$export$4fa6c6d12e97b690);
$parcel$export(module.exports, "labRowsFromRun", () => $4bee6261c6e7da77$export$725f4e3b103b8ffd);
$parcel$export(module.exports, "newManualLabRow", () => $4bee6261c6e7da77$export$7eba22ca66154cf6);
$parcel$export(module.exports, "reviewQueryItems", () => $4bee6261c6e7da77$export$9402c7d9ee327bb9);
$parcel$export(module.exports, "indexLabReview", () => $4bee6261c6e7da77$export$adc9098288f9ed0b);
$parcel$export(module.exports, "labRowView", () => $4bee6261c6e7da77$export$d1f0b5cf52fcd31);
$parcel$export(module.exports, "labSubmitCheck", () => $4bee6261c6e7da77$export$b0c762580619fe10);
$parcel$export(module.exports, "labSaveInput", () => $4bee6261c6e7da77$export$2ace0c9b49273a05);
$parcel$export(module.exports, "catalogOptions", () => $4bee6261c6e7da77$export$446eb29412604ad7);
// ─────────────────────────────────────────────────────────────────────────────
// The lab-result review, as data — docs/lab_results_ocr_wireframe_ai_agent.md.
//
// OCR IS RAW DATA. From the image come exactly: the row, the test name as printed
// and the value as printed (plus the printed row as evidence, a confidence and where
// the row is on the page). Everything shown beside them comes from the internal
// catalogue through the BFF's `labReview` query, resolved for THIS patient:
//
//   unit / reference range   → the catalogue reference (never editable)
//   status                   → interpretLabValue(value, reference)  (never editable)
//   the value                → the ONE thing the doctor corrects
//
// `interpretLabValue` MIRRORS `interpret_value` in the AI service's
// app/services/reference_ranges.py so a corrected value re-evaluates as it is typed.
// It is a preview: the BFF re-resolves every row through the service before anything
// is written. Change one, change both — src/__tests__/labReview.test.js carries the
// same cases as tests/test_lab_reference_catalog.py.
//
// A value the doctor TYPES is first read in the page language (`typedLabValue`,
// PM-0203): under a decimal-comma language «7,34» is 7.34, not 734, and a French
// «Négatif» is `negative`. That is input parsing only — it turns the typed text into
// the ASCII dot-decimal / canonical token the service already reads, so
// `interpretLabValue` and the service's `interpret_value` it mirrors are untouched
// and the mirror holds. A value OCR read off a document is not
// re-read in the page language (a printed sheet's commas belong to the sheet).
// ─────────────────────────────────────────────────────────────────────────────

var $hlTfq = parcelRequire("hlTfq");
// Folding tables, written as code points: Arabic letter forms → their Persian forms
// (yeh, alef maksura → ی; kaf → ک; teh marbuta, heh-yeh → ه; hamza/madda alefs → ا).
const $4bee6261c6e7da77$var$LETTERS = {
    "\u064A": "\u06CC",
    "\u0649": "\u06CC",
    "\u0643": "\u06A9",
    "\u0629": "\u0647",
    "\u06C0": "\u0647",
    "\u0623": "\u0627",
    "\u0625": "\u0627",
    "\u0622": "\u0627"
}; // i18n-exempt: letter folding for matching printed values, mirrored from reference_ranges.py
const $4bee6261c6e7da77$var$INVISIBLE = /[‌‍‎‏‪-‮⁦-⁩﻿ـ]/g;
// Persian (U+06F0–U+06F9) and Arabic-Indic (U+0660–U+0669) digits → ASCII: the low
// nibble of either code point is the digit.
const $4bee6261c6e7da77$var$foldDigits = (text)=>String(text ?? '').replace(/[۰-۹٠-٩]/g, (d)=>String(d.charCodeAt(0) & 0xF));
function $4bee6261c6e7da77$export$4fa6c6d12e97b690(text) {
    return $4bee6261c6e7da77$var$foldDigits(text).replace(/[يىكةۀأإآ]/g, (c)=>$4bee6261c6e7da77$var$LETTERS[c]).replace($4bee6261c6e7da77$var$INVISIBLE, ' ').replace(/\s+/g, ' ').trim().toLowerCase();
}
// i18n-exempt: matchers against printed lab values, mirrored from reference_ranges.py
const $4bee6261c6e7da77$var$QUALITATIVE_NORMAL = [
    'negative',
    'neg',
    'absent',
    'none',
    'normal',
    'nil',
    "\u0645\u0646\u0641\u06CC"
];
// i18n-exempt: matchers against printed lab values, mirrored from reference_ranges.py
const $4bee6261c6e7da77$var$QUALITATIVE_ABNORMAL = [
    'positive',
    'pos',
    'present',
    'trace',
    "\u0645\u062B\u0628\u062A"
];
// Printed results that are valid but carry no numeric rule (the status stays unknown).
// i18n-exempt: matchers against printed lab values
const $4bee6261c6e7da77$var$QUALITATIVE_OTHER = [
    'reactive',
    'non-reactive',
    'nonreactive',
    'non reactive',
    'detected',
    'not detected',
    'not seen',
    'rare',
    'few',
    'many',
    'moderate',
    'occasional',
    'seen',
    'normal range'
];
const $4bee6261c6e7da77$var$VALUE_NUMBER = /^([<>≤≥])?\s*(-?\d+(?:\.\d+)?)$/;
function $4bee6261c6e7da77$export$806c78176a41fb4e(value) {
    const text = $4bee6261c6e7da77$var$foldDigits(value).replace(/٫/g, '.').replace(/[٬,]/g, '').trim(); // i18n-exempt: Arabic decimal/thousands separators in printed values
    const match = text.match($4bee6261c6e7da77$var$VALUE_NUMBER);
    if (!match) return null;
    return {
        comparator: match[1] || null,
        number: Number(match[2])
    };
}
// Qualitative words a reader types in their own language → the canonical token the
// rule engine (and the service) already understands. Keyed by language subtag and
// matched case- and accent-insensitively; a language with no row types the canonical
// words as before.
// i18n-exempt: matchers against values a reader types, mapped onto reference_ranges.py tokens
const $4bee6261c6e7da77$var$TYPED_QUALITATIVE = {
    fr: {
        negatif: 'negative',
        negative: 'negative',
        positif: 'positive',
        positive: 'positive',
        normal: 'normal',
        normale: 'normal',
        absent: 'absent',
        absente: 'absent',
        present: 'present',
        presente: 'present',
        trace: 'trace',
        traces: 'trace'
    },
    // German, matched case-insensitively (an umlaut would fold like an accent; none of
    // these words has one). «nicht nachweisbar» / «nachweisbar» map onto the service's
    // own `not detected` / `detected`, which stay valid with no numeric rule.
    de: {
        negativ: 'negative',
        negative: 'negative',
        positiv: 'positive',
        positive: 'positive',
        normal: 'normal',
        abwesend: 'absent',
        vorhanden: 'present',
        spur: 'trace',
        spuren: 'trace',
        'nicht nachweisbar': 'not detected',
        nachweisbar: 'detected'
    }
};
const $4bee6261c6e7da77$var$foldAccents = (text)=>text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, ' ').trim().toLowerCase();
const $4bee6261c6e7da77$var$escapeRegExp = (text)=>text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
function $4bee6261c6e7da77$export$58193cdef089e53e(value, locale = (0, $hlTfq.documentLocale)()) {
    const text = String(value ?? '');
    const lang = String(locale || '').toLowerCase().split(/[-_]/)[0];
    const word = $4bee6261c6e7da77$var$TYPED_QUALITATIVE[lang]?.[$4bee6261c6e7da77$var$foldAccents(text)];
    if (word) return word;
    const { decimal: decimal, group: group } = (0, $hlTfq.numeralsFor)(locale);
    if (decimal !== ',') return value;
    // A «.» group mark (German) is never accepted here: it is read only by the stricter
    // dotted rule below, so «7.500» / «1.234» are refused rather than read as thousands.
    const groups = `[\\s\u00A0\u202F${group === ',' || group === '.' ? '' : $4bee6261c6e7da77$var$escapeRegExp(group)}]`;
    const folded = $4bee6261c6e7da77$var$foldDigits(text).trim();
    const toDot = (m)=>`${m[1]}${m[2].replace(/\D/g, '')}${m[3] != null ? `.${m[3]}` : ''}`;
    const match = folded.match(new RegExp(`^([<>\u{2264}\u{2265}]?\\s*-?)(\\d{1,3}(?:${groups}\\d{3})+|\\d+)(?:,(\\d+))?$`));
    if (match) return toDot(match);
    const dotted = folded.match(/^([<>≤≥]?\s*-?)(\d{1,3}(?:\.\d{3})+)(?:,(\d+))?$/);
    if (dotted && (dotted[3] != null || dotted[2].split('.').length > 2)) return toDot(dotted);
    // Only number-shaped text can be misread; a titre «1/320» or a word passes through.
    if (/^[<>≤≥]?\s*-?[\d\s\u00A0\u202F.,]+$/.test(folded) && (/\./.test(folded) && /,/.test(folded) || /^[<>≤≥]?\s*-?[1-9]\d{0,2}\.\d{3}$/.test(folded))) return null;
    return value;
}
/**
 * The value a row is judged and saved with: typed text read in the page language.
 * null when `typedLabValue` refused it as ambiguous.
 */ function $4bee6261c6e7da77$var$rowValue(row, locale) {
    const typed = row.source === 'manual' || row.source === 'ocr' && row.ocrValue != null && String(row.value).trim() !== String(row.ocrValue).trim();
    return typed ? $4bee6261c6e7da77$export$58193cdef089e53e(row.value, locale) : row.value;
}
const $4bee6261c6e7da77$var$UNKNOWN_VERDICT = Object.freeze({
    interpretation: 'unknown',
    critical: false,
    status: 'unknown'
});
function $4bee6261c6e7da77$export$77819e6353fc2d38(value, reference) {
    const text = String(value ?? '').trim();
    if (!text || !reference?.matched) return $4bee6261c6e7da77$var$UNKNOWN_VERDICT;
    const folded = $4bee6261c6e7da77$export$4fa6c6d12e97b690(text);
    if ($4bee6261c6e7da77$var$QUALITATIVE_NORMAL.includes(folded)) return {
        interpretation: 'normal',
        critical: false,
        status: 'normal'
    };
    if ($4bee6261c6e7da77$var$QUALITATIVE_ABNORMAL.includes(folded)) return {
        interpretation: 'abnormal',
        critical: false,
        status: 'abnormal'
    };
    if (!reference.referenceAvailable) return $4bee6261c6e7da77$var$UNKNOWN_VERDICT;
    const parsed = $4bee6261c6e7da77$export$806c78176a41fb4e(text);
    if (!parsed) return $4bee6261c6e7da77$var$UNKNOWN_VERDICT;
    let n = parsed.number;
    // "<5" sits just below 5 and ">40" just above 40, as the service reads them.
    if (parsed.comparator === '<' || parsed.comparator === "\u2264") n -= 0.001;
    else if (parsed.comparator === '>' || parsed.comparator === "\u2265") n += 0.001;
    const { low: low, high: high, criticalLow: criticalLow, criticalHigh: criticalHigh } = reference;
    let interpretation = 'normal';
    if (low != null && n < low) interpretation = 'low';
    else if (high != null && n > high) interpretation = 'high';
    const critical = interpretation !== 'normal' && (criticalLow != null && n < criticalLow || criticalHigh != null && n > criticalHigh);
    const status = critical ? 'critical' : interpretation === 'normal' ? 'normal' : 'abnormal';
    return {
        interpretation: interpretation,
        critical: critical,
        status: status
    };
}
function $4bee6261c6e7da77$export$59e23cb7df3fc649(value) {
    const text = String(value ?? '').trim();
    if (!text) return 'missing';
    if ($4bee6261c6e7da77$export$806c78176a41fb4e(text)) return null;
    const folded = $4bee6261c6e7da77$export$4fa6c6d12e97b690(text);
    if ($4bee6261c6e7da77$var$QUALITATIVE_NORMAL.includes(folded) || $4bee6261c6e7da77$var$QUALITATIVE_ABNORMAL.includes(folded) || $4bee6261c6e7da77$var$QUALITATIVE_OTHER.includes(folded)) return null;
    if (/^\d?\s*\+{1,4}$/.test(folded)) return null; // 1+, ++, +++
    if (/^\d+\s*[:/]\s*\d+$/.test(folded)) return null; // a titre: 1/320, 1:80
    return 'invalid';
}
function $4bee6261c6e7da77$export$3aee0d7cce272488(confidence, policy) {
    if (confidence == null) return null;
    const c = Number(confidence);
    const accept = policy?.acceptConfidence;
    const review = policy?.reviewConfidence;
    if (!Number.isFinite(c) || accept == null || review == null) return null;
    if (c >= accept) return 'accepted';
    if (c >= review) return 'review';
    return 'uncertain';
}
function $4bee6261c6e7da77$export$725f4e3b103b8ffd(run) {
    return (run?.labResults || []).map((r, i)=>{
        const value = r.value == null ? '' : String(r.value);
        return {
            key: `ocr-${i}`,
            source: 'ocr',
            row: Number.isInteger(r.row) && r.row > 0 ? r.row : i + 1,
            rawTestName: r.testName || '',
            ocrTestKey: r.testKey || null,
            testKey: r.testKey || '',
            value: value,
            ocrValue: value,
            confidence: r.confidence ?? null,
            verified: r.verified ?? null,
            sourceText: r.sourceText || '',
            region: r.region || null,
            implausible: r.flag === 'implausible',
            // A row with no evidence in what the model read starts UNTICKED (§9.6).
            selected: r.verified !== false
        };
    });
}
let $4bee6261c6e7da77$var$manualSeq = 0;
function $4bee6261c6e7da77$export$7eba22ca66154cf6(rows = []) {
    $4bee6261c6e7da77$var$manualSeq += 1;
    const next = rows.reduce((max, r)=>Math.max(max, Number(r.row) || 0), 0) + 1;
    return {
        key: `manual-${Date.now().toString(36)}-${$4bee6261c6e7da77$var$manualSeq}`,
        source: 'manual',
        row: next,
        rawTestName: '',
        ocrTestKey: null,
        testKey: '',
        value: '',
        ocrValue: null,
        confidence: null,
        verified: null,
        sourceText: '',
        region: null,
        implausible: false,
        selected: true
    };
}
function $4bee6261c6e7da77$export$9402c7d9ee327bb9(rows) {
    return rows.map((r)=>({
            testKey: r.testKey || null,
            testName: r.rawTestName || '',
            value: r.value || ''
        }));
}
function $4bee6261c6e7da77$export$adc9098288f9ed0b(data, rows) {
    const byRowKey = new Map();
    (data?.items || []).forEach((item, i)=>{
        if (rows[i]) byRowKey.set(rows[i].key, item);
    });
    const catalog = data?.catalog || [];
    return {
        byRowKey: byRowKey,
        catalog: catalog,
        catalogByKey: new Map(catalog.filter((c)=>c.testKey).map((c)=>[
                c.testKey,
                c
            ])),
        policy: data?.policy || null,
        patientSex: data?.patientSex || null,
        patientAgeYears: data?.patientAgeYears ?? null
    };
}
const $4bee6261c6e7da77$var$UNMATCHED = Object.freeze({
    testKey: null,
    matched: false,
    unit: null,
    low: null,
    high: null,
    criticalLow: null,
    criticalHigh: null,
    referenceText: null,
    referenceAvailable: false,
    missingReason: 'not_matched',
    basis: null
});
function $4bee6261c6e7da77$export$c7c79a53ae71fe3b(row, review) {
    if (!review) return null;
    if (row.testKey) {
        const picked = review.catalogByKey.get(row.testKey);
        if (picked) return picked;
    }
    const own = review.byRowKey.get(row.key);
    if (own && (!row.testKey || own.testKey === row.testKey)) return own;
    return $4bee6261c6e7da77$var$UNMATCHED;
}
const $4bee6261c6e7da77$export$843191028a978a16 = Object.freeze([
    'noTest',
    'missing',
    'invalid'
]);
const $4bee6261c6e7da77$export$bcb12241a240418c = Object.freeze([
    'unmatched',
    'uncertain',
    'review',
    'implausible',
    'unverified'
]);
function $4bee6261c6e7da77$export$d1f0b5cf52fcd31(row, review, locale = (0, $hlTfq.documentLocale)()) {
    const ref = $4bee6261c6e7da77$export$c7c79a53ae71fe3b(row, review);
    const matched = Boolean(ref?.matched);
    const value = $4bee6261c6e7da77$var$rowValue(row, locale);
    const verdict = ref && value != null ? $4bee6261c6e7da77$export$77819e6353fc2d38(value, ref) : $4bee6261c6e7da77$var$UNKNOWN_VERDICT;
    const valueProblem = value == null ? 'invalid' : $4bee6261c6e7da77$export$59e23cb7df3fc649(value);
    const corrected = row.source === 'ocr' && row.ocrValue != null && String(row.value).trim() !== String(row.ocrValue).trim();
    const band = row.source === 'ocr' ? $4bee6261c6e7da77$export$3aee0d7cce272488(row.confidence, review?.policy) : null;
    const issues = [];
    if (row.source === 'manual' && !matched) issues.push('noTest');
    else if (!matched) issues.push('unmatched');
    if (valueProblem) issues.push(valueProblem);
    if (matched && !ref.referenceAvailable) issues.push('noReference');
    // Correcting the value is the doctor's answer to every doubt about the READING. A
    // reading that produced nothing has no value to doubt («مقدار قابل تشخیص نیست» says
    // it), but a row with no evidence on the page is still worth a look.
    if (!corrected && row.source === 'ocr') {
        if (String(row.ocrValue ?? '').trim()) {
            if (band === 'uncertain') issues.push('uncertain');
            else if (band === 'review') issues.push('review');
            if (row.implausible) issues.push('implausible');
        }
        if (row.verified === false) issues.push('unverified');
    }
    return {
        ref: ref,
        matched: matched,
        ...verdict,
        valueProblem: valueProblem,
        band: band,
        corrected: corrected,
        issues: issues
    };
}
function $4bee6261c6e7da77$export$b0c762580619fe10(rows, review, locale = (0, $hlTfq.documentLocale)()) {
    const blocking = [];
    const suspicious = [];
    rows.filter((r)=>r.selected !== false).forEach((row)=>{
        const { issues: issues } = $4bee6261c6e7da77$export$d1f0b5cf52fcd31(row, review, locale);
        if (issues.some((i)=>$4bee6261c6e7da77$export$843191028a978a16.includes(i))) blocking.push(row);
        else if (issues.some((i)=>$4bee6261c6e7da77$export$bcb12241a240418c.includes(i))) suspicious.push(row);
    });
    return {
        blocking: blocking,
        suspicious: suspicious
    };
}
function $4bee6261c6e7da77$export$2ace0c9b49273a05(rows, review, locale = (0, $hlTfq.documentLocale)()) {
    return rows.filter((r)=>r.selected !== false).map((row)=>{
        const view = $4bee6261c6e7da77$export$d1f0b5cf52fcd31(row, review, locale);
        const ref = view.ref || $4bee6261c6e7da77$var$UNMATCHED;
        return {
            testName: view.matched && ref.displayName || row.rawTestName,
            // A typed value leaves the client ASCII dot-decimal: the BFF re-resolves it
            // through the service's parse_value, which drops every «,». A refused value
            // is sent as nothing at all (the row is blocked before a save anyway).
            value: String($4bee6261c6e7da77$var$rowValue(row, locale) ?? '').trim(),
            unit: ref.unit || '',
            referenceRange: ref.referenceText || '',
            status: view.status,
            source: row.source,
            testKey: view.matched && ref.testKey || null,
            ocrTestKey: row.ocrTestKey || null,
            rawTestName: row.rawTestName || null,
            ocrValue: row.source === 'ocr' ? row.ocrValue : null,
            row: Number.isInteger(row.row) ? row.row : null,
            confidence: row.confidence ?? null
        };
    }).filter((input)=>input.testName && input.value);
}
function $4bee6261c6e7da77$export$446eb29412604ad7(review) {
    return (review?.catalog || []).map((c)=>({
            value: c.testKey,
            label: c.displayName || c.testKey
        }));
}

});

parcelRegister("4pAHp", function(module, exports) {

$parcel$export(module.exports, "default", () => $52ac9b8dd4c1cc5a$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $aJ1FU = parcelRequire("aJ1FU");
var $9gEOi = parcelRequire("9gEOi");
var $lxEfx = parcelRequire("lxEfx");
var $7phmx = parcelRequire("7phmx");
var $4Qco3 = parcelRequire("4Qco3");
var $66joL = parcelRequire("66joL");

var $jTCZr = parcelRequire("jTCZr");

var $97xXr = parcelRequire("97xXr");
var $aGlWN = parcelRequire("aGlWN");
var $8g4t5 = parcelRequire("8g4t5");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $7sS0P = parcelRequire("7sS0P");

var $dLdf9 = parcelRequire("dLdf9");

var $6wb9F = parcelRequire("6wb9F");

var $6aqqm = parcelRequire("6aqqm");

var $fpMTR = parcelRequire("fpMTR");

var $87Vkn = parcelRequire("87Vkn");

var $1dCSZ = parcelRequire("1dCSZ");
// «استخراج نتایج آزمایش» — the body of the review overlay in LAB_RESULTS mode.
// doctor-app/parsina.client.web/docs/lab_results_ocr_wireframe_ai_agent.md
//
//   ┌ source panel (≈40 %) ──────────┐ ┌ results (≈60 %) ───────────────┐
//   │ LabImageViewer + highlights    │ │ notices · date · table · extras│  ← only this scrolls
//   │ «اطلاعات استخراج‌شده از تصویر» │ │                                │
//   └────────────────────────────────┘ └────────────────────────────────┘
//
// The overlay owns the rows (so it knows what is unsaved), the catalogue state and the
// commit; this component owns which row is active and the value fields, and exposes
// `focusRow(key)` so «ثبت و ادامه» can send the doctor to the row that needs them.
const $52ac9b8dd4c1cc5a$var$k = (s)=>`patient.files.extract.labReview.${s}`;
const $52ac9b8dd4c1cc5a$var$checkedValue = (v)=>typeof v === 'boolean' ? v : Boolean(v?.target?.checked);
function $52ac9b8dd4c1cc5a$var$ExtractionInfo() {
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "lab-extraction-info",
        style: {
            display: 'flex',
            gap: '0.5rem',
            padding: '0.625rem 0.75rem',
            border: `1px solid ${(0, $jTCZr.CT).border}`,
            background: (0, $jTCZr.CT).surface2,
            borderRadius: (0, $7sS0P.RADIUS).card
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $97xXr.default), {
        size: 16,
        "aria-hidden": true,
        style: {
            color: (0, $jTCZr.CT).accentInk,
            flexShrink: 0,
            marginTop: '0.125rem'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.125rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        style: {
            margin: 0,
            fontSize: '0.75rem',
            fontWeight: 700,
            color: (0, $jTCZr.CT).ink
        }
    }, t($52ac9b8dd4c1cc5a$var$k('sourcePanelTitle'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        style: {
            margin: 0,
            fontSize: '0.71875rem',
            color: (0, $jTCZr.CT).ink2,
            lineHeight: 1.8
        }
    }, t($52ac9b8dd4c1cc5a$var$k('sourcePanelBody1'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        style: {
            margin: 0,
            fontSize: '0.71875rem',
            color: (0, $jTCZr.CT).ink2,
            lineHeight: 1.8
        }
    }, t($52ac9b8dd4c1cc5a$var$k('sourcePanelBody2')))));
}
const $52ac9b8dd4c1cc5a$var$LabResultExtraction = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function LabResultExtraction({ file: file, run: run, rows: rows, onRowsChange: onRowsChange, review: review, documentDate: documentDate, onDocumentDateChange: onDocumentDateChange, pickedDiagnoses: pickedDiagnoses, onPickDiagnosis: onPickDiagnosis, pickedMedications: pickedMedications, onPickMedication: onPickMedication, disabled: disabled = false, isMobile: isMobile = false, sourceVisible: sourceVisible = true, onSourceVisibleChange: onSourceVisibleChange, notices: notices = null, footnote: footnote = null }, ref) {
    const { t: t } = (0, $LNQP4.default)();
    const titleId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const [active, setActive] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        key: null,
        source: null
    });
    const [expanded, setExpanded] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const valueRefs = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Map());
    const sourceRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const ready = review.status === 'ready';
    const views = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>new Map(rows.map((r)=>[
                r.key,
                (0, $6wb9F.labRowView)(r, review.review)
            ])), [
        rows,
        review.review
    ]);
    const options = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $6wb9F.catalogOptions)(review.review), [
        review.review
    ]);
    const marks = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>rows.map((r)=>({
                key: r.key,
                row: r.row,
                name: (0, $1dCSZ.labRowName)(r, views.get(r.key)),
                region: r.region
            })), [
        rows,
        views
    ]);
    const registerValue = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((key, el)=>{
        if (el) valueRefs.current.set(key, el);
        else valueRefs.current.delete(key);
    }, []);
    const revealSource = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        if (!sourceVisible) onSourceVisibleChange?.(true);
        else if (isMobile) sourceRef.current?.scrollIntoView?.({
            block: 'start',
            behavior: 'smooth'
        });
    }, [
        sourceVisible,
        onSourceVisibleChange,
        isMobile
    ]);
    const activate = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((key, source = 'table', options = {})=>{
        setActive((prev)=>prev.key === key && prev.source === source ? prev : {
                key: key,
                source: source
            });
        if (options.reveal) revealSource();
    }, [
        revealSource
    ]);
    const focusValue = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((key)=>{
        const el = valueRefs.current.get(key);
        if (!el) return;
        el.scrollIntoView?.({
            block: 'center'
        });
        el.focus();
        el.select?.();
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useImperativeHandle(ref, ()=>({
            focusRow: (key)=>{
                activate(key, 'table');
                focusValue(key);
            }
        }), [
        activate,
        focusValue
    ]);
    // A phone opens the image above the results; bring it into view when it opens.
    const wasVisible = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(sourceVisible);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (isMobile && sourceVisible && !wasVisible.current) sourceRef.current?.scrollIntoView?.({
            block: 'start',
            behavior: 'smooth'
        });
        wasVisible.current = sourceVisible;
    }, [
        isMobile,
        sourceVisible
    ]);
    const update = (key, patch)=>onRowsChange(rows.map((r)=>r.key === key ? {
                ...r,
                ...patch
            } : r));
    const revert = (key)=>{
        const row = rows.find((r)=>r.key === key);
        if (row) update(key, {
            value: row.ocrValue ?? ''
        });
        focusValue(key);
    };
    const pickTest = (key, testKey)=>update(key, {
            testKey: testKey || ''
        });
    const remove = (key)=>onRowsChange(rows.filter((r)=>r.key !== key));
    const addRow = ()=>{
        const row = (0, $6wb9F.newManualLabRow)(rows);
        onRowsChange([
            ...rows,
            row
        ]);
        setActive({
            key: row.key,
            source: 'table'
        });
    };
    const onValueKeyDown = (key)=>(e)=>{
            if (![
                'ArrowDown',
                'ArrowUp',
                'Enter'
            ].includes(e.key) || e.ctrlKey || e.metaKey || e.altKey || e.shiftKey) return;
            const index = rows.findIndex((r)=>r.key === key);
            const next = rows[index + (e.key === 'ArrowUp' ? -1 : 1)];
            if (!next) return;
            e.preventDefault();
            focusValue(next.key);
        };
    const onImageActivate = (key)=>{
        setActive({
            key: key,
            source: 'image'
        });
        valueRefs.current.get(key)?.scrollIntoView?.({
            block: 'nearest'
        });
    };
    const actions = run?.recommendedActions || [];
    const diagnoses = run?.diagnoses || [];
    const medications = run?.medications || [];
    const listProps = {
        rows: rows,
        views: views,
        activeKey: active.key,
        onActivate: activate,
        onRowChange: update,
        onRevert: revert,
        onPickTest: pickTest,
        onRemove: remove,
        onValueKeyDown: onValueKeyDown,
        onEditValue: focusValue,
        registerValue: registerValue,
        catalogOptions: options,
        disabled: disabled
    };
    const basisNotes = ready ? [
        review.review.patientAgeYears == null ? t($52ac9b8dd4c1cc5a$var$k('adultAssumed')) : null,
        !review.review.patientSex ? t($52ac9b8dd4c1cc5a$var$k('sexUnknown')) : null
    ].filter(Boolean) : [];
    const results = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
        "aria-labelledby": titleId,
        "data-testid": "lab-results-panel",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem',
            minWidth: 0,
            minHeight: 0,
            overflowY: isMobile ? 'visible' : 'auto',
            paddingInlineEnd: isMobile ? 0 : '0.25rem',
            overscrollBehavior: 'contain'
        }
    }, notices, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        label: t('patient.files.documentDate'),
        helperText: t('patient.files.extract.dateHint')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4Qco3.default), {
        value: documentDate,
        onChange: onDocumentDateChange,
        disableFuture: true,
        disabled: disabled,
        placeholder: t('patient.files.upload.datePlaceholder')
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.375rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h3", {
        id: titleId,
        style: {
            margin: 0,
            fontSize: '0.875rem',
            fontWeight: 700,
            color: (0, $jTCZr.CT).ink
        }
    }, t($52ac9b8dd4c1cc5a$var$k('tableTitle'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        "data-testid": "lab-standard-info",
        style: {
            margin: 0,
            display: 'flex',
            alignItems: 'flex-start',
            gap: '0.375rem',
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).ink2,
            lineHeight: 1.8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $97xXr.default), {
        size: 14,
        "aria-hidden": true,
        style: {
            color: (0, $jTCZr.CT).accentInk,
            flexShrink: 0,
            marginTop: '0.25rem'
        }
    }), t($52ac9b8dd4c1cc5a$var$k('standardInfo'))), basisNotes.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "info",
        "data-testid": "lab-basis-notes"
    }, basisNotes.join(' '))), review.status === 'loading' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonRegion), {
        label: t($52ac9b8dd4c1cc5a$var$k('loadingReferences')),
        "data-testid": "lab-review-loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonTable), {
        rows: Math.min(Math.max(rows.length, 3), 8),
        columns: isMobile ? 2 : 6,
        dense: true
    })), review.status === 'error' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "lab-review-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dLdf9.default), {
        title: t($52ac9b8dd4c1cc5a$var$k('referencesFailed')),
        onRetry: review.retry
    })), ready && rows.length > 0 && (isMobile ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $87Vkn.default), listProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fpMTR.default), listProps)), ready && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            flexWrap: 'wrap'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "sm",
        className: "gap-1.5",
        onClick: addRow,
        disabled: disabled,
        "data-testid": "lab-add-row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8g4t5.default), {
        size: 14,
        "aria-hidden": true
    }), " ", t($52ac9b8dd4c1cc5a$var$k('addRow'))), rows.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "lab-only-value",
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.25rem',
            fontSize: '0.71875rem',
            color: (0, $jTCZr.CT).mute
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aGlWN.default), {
        size: 12,
        "aria-hidden": true
    }), " ", t($52ac9b8dd4c1cc5a$var$k('onlyValueEditable')))), actions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lxEfx.default), {
        title: t('patient.files.extract.actions', {
            count: actions.length
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        style: {
            margin: 0,
            paddingInlineStart: '1.125rem',
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).ink2,
            lineHeight: 1.9
        }
    }, actions.map((a, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: i,
            dir: "auto"
        }, a)))), (diagnoses.length > 0 || medications.length > 0) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "lab-opt-in",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.375rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.71875rem',
            color: (0, $jTCZr.CT).mute
        }
    }, t('patient.files.extract.optInHint')), diagnoses.map((d, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9gEOi.default), {
            key: `dx-${i}`,
            checked: pickedDiagnoses.has(i),
            onChange: (checked)=>onPickDiagnosis(i, $52ac9b8dd4c1cc5a$var$checkedValue(checked)),
            label: t('patient.files.extract.diagnosisOption', {
                name: d
            }),
            disabled: disabled,
            "data-testid": `lab-dx-${i}`
        })), medications.map((m, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9gEOi.default), {
            key: `med-${i}`,
            checked: pickedMedications.has(i),
            onChange: (checked)=>onPickMedication(i, $52ac9b8dd4c1cc5a$var$checkedValue(checked)),
            label: t('patient.files.extract.medicationOption', {
                name: [
                    m.name,
                    m.dosage,
                    m.frequency
                ].filter(Boolean).join(' ')
            }),
            disabled: disabled,
            "data-testid": `lab-med-${i}`
        }))), run?.summaryText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lxEfx.default), {
        title: t('patient.files.extract.readText')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: "auto",
        style: {
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).ink2,
            whiteSpace: 'pre-wrap',
            lineHeight: 1.9
        }
    }, run.summaryText)), footnote);
    const source = sourceVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("aside", {
        ref: sourceRef,
        "aria-label": t($52ac9b8dd4c1cc5a$var$k('viewer.label')),
        "data-testid": "lab-source-panel",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.625rem',
            minWidth: 0,
            minHeight: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6aqqm.default), {
        file: file,
        marks: marks,
        activeKey: active.key,
        activeSource: active.source,
        onActivate: onImageActivate,
        expanded: expanded,
        onToggleExpand: isMobile ? undefined : ()=>setExpanded((v)=>!v),
        height: isMobile ? '18rem' : undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($52ac9b8dd4c1cc5a$var$ExtractionInfo, null));
    if (isMobile) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "lab-review",
        "data-layout": "stack",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem'
        }
    }, source, results);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "lab-review",
        "data-layout": "split",
        "data-expanded": expanded || undefined,
        style: {
            display: 'grid',
            // The image sits at the inline start, the results at the end; ≈40 / 60, and
            // ≈60 / 40 while the image is expanded — but the results never narrower than
            // their six columns need, so expanding on a small workstation cannot push the
            // status out of sight.
            gridTemplateColumns: !sourceVisible ? 'minmax(0, 1fr)' : expanded ? 'minmax(0, 3fr) minmax(40rem, 2fr)' : 'minmax(0, 2fr) minmax(0, 3fr)',
            gap: '1rem',
            height: 'calc(100vh - 15rem)',
            minHeight: '26rem'
        }
    }, source, results);
});
var $52ac9b8dd4c1cc5a$export$2e2bcd8739ae039 = $52ac9b8dd4c1cc5a$var$LabResultExtraction;

});
parcelRegister("6aqqm", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddefab495daaa435$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $5MbI8 = parcelRequire("5MbI8");
var $66joL = parcelRequire("66joL");

var $jTCZr = parcelRequire("jTCZr");

var $axyPa = parcelRequire("axyPa");
var $iH4cM = parcelRequire("iH4cM");
var $6ivsH = parcelRequire("6ivsH");
var $i7GA0 = parcelRequire("i7GA0");
var $47abO = parcelRequire("47abO");
var $bU80g = parcelRequire("bU80g");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $7sS0P = parcelRequire("7sS0P");

var $dLdf9 = parcelRequire("dLdf9");

var $3t8yQ = parcelRequire("3t8yQ");
// The lab sheet beside its extracted rows — docs/lab_results_ocr_wireframe_ai_agent.md §6–§7.
//
// What it must let the doctor answer: «was this value really read from THIS row?»
//
//   • zoom (buttons, Ctrl/⌘ + wheel about the cursor, + / −), fit (0), pan (drag, wheel
//     or arrow keys once zoomed), and «expand» for more room — at the image's own
//     resolution: the bitmap is scaled by the browser, never re-encoded;
//   • a numbered, subtle highlight over every row the model could place. Hovering or
//     focusing a table row lights its highlight (and brings it into view when zoomed);
//     pressing a highlight makes its table row active;
//   • a PDF is drawn by the browser's own viewer, where no highlight can be laid over
//     the page — the panel says so, and each row still carries its printed text.
//
// The frame is laid out left-to-right on purpose: an image has no reading direction,
// and its row coordinates are measured from its top-left corner (the same exception
// DESIGN_SYSTEM §11 makes for the dental arch). The chrome around it stays logical.
const $ddefab495daaa435$var$MIN_ZOOM = 0.5;
const $ddefab495daaa435$var$MAX_ZOOM = 8;
const $ddefab495daaa435$var$STEP = 1.25;
const $ddefab495daaa435$var$PAN_STEP = 48;
const $ddefab495daaa435$var$DRAG_THRESHOLD = 4;
const $ddefab495daaa435$var$clamp = (v, lo, hi)=>Math.min(hi, Math.max(lo, v));
const $ddefab495daaa435$var$TOOL = 34;
function $ddefab495daaa435$var$Highlight({ mark: mark, active: active, label: label, number: number, onPress: onPress, testid: testid }) {
    const { region: region } = mark;
    // The number sits just OUTSIDE the row's end edge, where a lab sheet has margin,
    // so it never covers the printed name or value (§7). A row that runs to the page's
    // edge keeps it inside, on that edge.
    const roomOutside = region.x + region.width < 0.95;
    return(// A raw button on purpose: a highlight is a hit-area laid over a bitmap at the
    // row's own geometry, not a control with the kit's padding and height.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        "data-testid": testid,
        "data-active": active || undefined,
        "aria-pressed": active,
        "aria-label": label,
        title: label,
        onClick: onPress,
        style: {
            position: 'absolute',
            insetInlineStart: `${region.x * 100}%`,
            top: `${region.y * 100}%`,
            width: `${region.width * 100}%`,
            height: `${region.height * 100}%`,
            padding: 0,
            margin: 0,
            background: 'transparent',
            border: 'none',
            borderRadius: 3,
            cursor: 'pointer',
            outlineOffset: 2
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true,
        style: {
            position: 'absolute',
            inset: 0,
            borderRadius: 3,
            border: `${active ? 2 : 1}px solid ${(0, $jTCZr.CT).accent}`,
            opacity: active ? 1 : 0.4
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true,
        style: {
            position: 'absolute',
            inset: 0,
            borderRadius: 3,
            background: (0, $jTCZr.CT).accent,
            opacity: active ? 0.12 : 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true,
        style: {
            position: 'absolute',
            top: '50%',
            ...roomOutside ? {
                insetInlineStart: 'calc(100% + 4px)',
                transform: 'translateY(-50%)'
            } : {
                insetInlineEnd: 2,
                transform: 'translateY(-50%)'
            },
            minWidth: 16,
            height: 16,
            padding: '0 3px',
            borderRadius: 8,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '0.625rem',
            fontWeight: 700,
            lineHeight: 1,
            background: active ? (0, $jTCZr.CT).accent : (0, $jTCZr.CT).card,
            color: active ? (0, $jTCZr.CT).card : (0, $jTCZr.CT).accentInk,
            border: `1px solid ${(0, $jTCZr.CT).accent}`,
            opacity: active ? 1 : 0.85
        }
    }, number)));
}
function $ddefab495daaa435$export$2e2bcd8739ae039({ file: file, marks: marks = [], activeKey: activeKey = null, activeSource: activeSource = null, onActivate: onActivate, expanded: expanded = false, onToggleExpand: onToggleExpand, height: height, testid: testid = 'lab-image-viewer' }) {
    const { t: t, formatDigits: formatDigits } = (0, $LNQP4.default)();
    const k = (s)=>`patient.files.extract.labReview.viewer.${s}`;
    const view = (0, $3t8yQ.default)(file);
    const hintId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const [frame, setFrame] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        w: 0,
        h: 0
    });
    const [natural, setNatural] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [zoom, setZoom] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(1);
    const [pan, setPan] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        x: 0,
        y: 0
    });
    const current = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef({
        zoom: 1,
        pan: {
            x: 0,
            y: 0
        }
    });
    const drag = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const suppressClick = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    const isImage = view.status === 'ready' && view.type.startsWith('image/');
    const isPdf = view.status === 'ready' && view.type === 'application/pdf';
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(()=>{
        const el = frameRef.current;
        if (!el) return undefined;
        const measure = ()=>setFrame({
                w: el.clientWidth,
                h: el.clientHeight
            });
        measure();
        if (typeof ResizeObserver === 'undefined') return undefined;
        const observer = new ResizeObserver(measure);
        observer.observe(el);
        return ()=>observer.disconnect();
    }, [
        view.status
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setNatural(null);
        setZoom(1);
        setPan({
            x: 0,
            y: 0
        });
        current.current = {
            zoom: 1,
            pan: {
                x: 0,
                y: 0
            }
        };
    }, [
        view.url
    ]);
    const measured = Boolean(natural) && frame.w > 0 && frame.h > 0;
    const fit = measured ? Math.min(frame.w / natural.w, frame.h / natural.h) : 1;
    const scale = fit * zoom;
    const size = measured ? {
        w: natural.w * scale,
        h: natural.h * scale
    } : null;
    const apply = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((z, p)=>{
        if (!measured) return;
        const w = natural.w * fit * z;
        const h = natural.h * fit * z;
        const maxX = Math.max(0, (w - frame.w) / 2);
        const maxY = Math.max(0, (h - frame.h) / 2);
        const next = {
            x: $ddefab495daaa435$var$clamp(p.x, -maxX, maxX),
            y: $ddefab495daaa435$var$clamp(p.y, -maxY, maxY)
        };
        current.current = {
            zoom: z,
            pan: next
        };
        setZoom(z);
        setPan(next);
    }, [
        measured,
        natural,
        fit,
        frame.w,
        frame.h
    ]);
    // Zoom keeping one point of the image under one point of the frame.
    const zoomTo = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((next, anchor)=>{
        if (!measured) return;
        const { zoom: z1, pan: p } = current.current;
        const z2 = $ddefab495daaa435$var$clamp(next, $ddefab495daaa435$var$MIN_ZOOM, $ddefab495daaa435$var$MAX_ZOOM);
        const ax = anchor ? anchor.x : frame.w / 2;
        const ay = anchor ? anchor.y : frame.h / 2;
        const ox = (frame.w - natural.w * fit * z1) / 2 + p.x;
        const oy = (frame.h - natural.h * fit * z1) / 2 + p.y;
        const ix = (ax - ox) / (fit * z1);
        const iy = (ay - oy) / (fit * z1);
        apply(z2, {
            x: ax - ix * fit * z2 - (frame.w - natural.w * fit * z2) / 2,
            y: ay - iy * fit * z2 - (frame.h - natural.h * fit * z2) / 2
        });
    }, [
        measured,
        natural,
        fit,
        frame.w,
        frame.h,
        apply
    ]);
    const fitView = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>apply(1, {
            x: 0,
            y: 0
        }), [
        apply
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const el = frameRef.current;
        if (!el || !isImage) return undefined;
        const onWheel = (e)=>{
            if (e.ctrlKey || e.metaKey) {
                e.preventDefault();
                const rect = el.getBoundingClientRect();
                zoomTo(current.current.zoom * (e.deltaY < 0 ? $ddefab495daaa435$var$STEP : 1 / $ddefab495daaa435$var$STEP), {
                    x: e.clientX - rect.left,
                    y: e.clientY - rect.top
                });
                return;
            }
            if (current.current.zoom > 1) {
                e.preventDefault();
                const { zoom: z, pan: p } = current.current;
                apply(z, {
                    x: p.x - e.deltaX,
                    y: p.y - e.deltaY
                });
            }
        };
        el.addEventListener('wheel', onWheel, {
            passive: false
        });
        return ()=>el.removeEventListener('wheel', onWheel);
    }, [
        isImage,
        zoomTo,
        apply
    ]);
    const activeMark = marks.find((m)=>m.key === activeKey) || null;
    const activeRegion = activeMark?.region && (activeMark.region.page || 1) === 1 ? activeMark.region : null;
    // A row activated from the table is brought into view when the zoom has hidden it.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!activeRegion || !measured || activeSource === 'image') return;
        const { zoom: z, pan: p } = current.current;
        const w = natural.w * fit * z;
        const h = natural.h * fit * z;
        const cx = (frame.w - w) / 2 + p.x + (activeRegion.x + activeRegion.width / 2) * w;
        const cy = (frame.h - h) / 2 + p.y + (activeRegion.y + activeRegion.height / 2) * h;
        const margin = 24;
        if (cx >= margin && cx <= frame.w - margin && cy >= margin && cy <= frame.h - margin) return;
        apply(z, {
            x: p.x + (frame.w / 2 - cx),
            y: p.y + (frame.h / 2 - cy)
        });
    }, [
        activeKey,
        activeRegion,
        activeSource,
        measured,
        natural,
        fit,
        frame.w,
        frame.h,
        apply
    ]);
    const onPointerDown = (e)=>{
        if (e.button !== 0 || !measured) return;
        drag.current = {
            id: e.pointerId,
            x: e.clientX,
            y: e.clientY,
            pan: current.current.pan,
            moved: false
        };
    };
    const onPointerMove = (e)=>{
        const d = drag.current;
        if (!d || d.id !== e.pointerId) return;
        const dx = e.clientX - d.x;
        const dy = e.clientY - d.y;
        if (!d.moved) {
            if (Math.hypot(dx, dy) < $ddefab495daaa435$var$DRAG_THRESHOLD) return;
            d.moved = true;
            e.currentTarget.setPointerCapture?.(e.pointerId);
        }
        apply(current.current.zoom, {
            x: d.pan.x + dx,
            y: d.pan.y + dy
        });
    };
    const onPointerUp = (e)=>{
        const d = drag.current;
        drag.current = null;
        if (d?.moved) {
            e.currentTarget.releasePointerCapture?.(e.pointerId);
            suppressClick.current = true;
        }
    };
    // A drag that ends over a highlight is a pan, not a press.
    const onClickCapture = (e)=>{
        if (!suppressClick.current) return;
        suppressClick.current = false;
        e.stopPropagation();
        e.preventDefault();
    };
    const onKeyDown = (e)=>{
        if (!measured || e.ctrlKey || e.metaKey || e.altKey) return;
        const { zoom: z, pan: p } = current.current;
        const actions = {
            '+': ()=>zoomTo(z * $ddefab495daaa435$var$STEP),
            '=': ()=>zoomTo(z * $ddefab495daaa435$var$STEP),
            '-': ()=>zoomTo(z / $ddefab495daaa435$var$STEP),
            '0': fitView,
            ArrowLeft: ()=>apply(z, {
                    x: p.x + $ddefab495daaa435$var$PAN_STEP,
                    y: p.y
                }),
            ArrowRight: ()=>apply(z, {
                    x: p.x - $ddefab495daaa435$var$PAN_STEP,
                    y: p.y
                }),
            ArrowUp: ()=>apply(z, {
                    x: p.x,
                    y: p.y + $ddefab495daaa435$var$PAN_STEP
                }),
            ArrowDown: ()=>apply(z, {
                    x: p.x,
                    y: p.y - $ddefab495daaa435$var$PAN_STEP
                })
        };
        const action = actions[e.key];
        if (!action || e.target !== e.currentTarget) return;
        e.preventDefault();
        action();
    };
    const placed = marks.filter((m)=>m.region && (m.region.page || 1) === 1);
    const atFit = zoom === 1 && pan.x === 0 && pan.y === 0;
    let body;
    if (view.status === 'loading') body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonRegion), {
        label: t('common.state.loading'),
        "data-testid": `${testid}-loading`,
        style: {
            position: 'absolute',
            inset: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: "100%",
        height: "100%",
        radius: 0
    }));
    else if (view.status === 'error') body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${testid}-error`,
        style: {
            position: 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '1rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dLdf9.default), {
        title: t('patient.files.unavailable'),
        onRetry: view.retry
    }));
    else if (isPdf) body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("iframe", {
        title: file?.fileName || t('patient.files.unnamed'),
        src: view.url,
        style: {
            width: '100%',
            height: '100%',
            border: 'none',
            display: 'block'
        }
    });
    else if (isImage) body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${testid}-canvas`,
        style: {
            position: 'absolute',
            top: 0,
            insetInlineStart: 0,
            width: size ? size.w : '100%',
            height: size ? size.h : '100%',
            transform: size ? `translate(${(frame.w - size.w) / 2 + pan.x}px, ${(frame.h - size.h) / 2 + pan.y}px)` : undefined
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: view.url,
        alt: file?.fileName || '',
        draggable: false,
        "data-testid": `${testid}-image`,
        onLoad: (e)=>{
            const img = e.currentTarget;
            if (img.naturalWidth && img.naturalHeight) setNatural({
                w: img.naturalWidth,
                h: img.naturalHeight
            });
        },
        style: {
            width: '100%',
            height: '100%',
            objectFit: size ? 'fill' : 'contain',
            display: 'block',
            userSelect: 'none',
            pointerEvents: 'none'
        }
    }), size && placed.map((mark)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ddefab495daaa435$var$Highlight, {
            key: mark.key,
            mark: mark,
            active: mark.key === activeKey,
            number: formatDigits(mark.row),
            label: t(k('highlight'), {
                row: formatDigits(mark.row),
                name: mark.name || "\u2014"
            }),
            onPress: ()=>onActivate?.(mark.key),
            testid: `lab-highlight-${mark.key}`
        })));
    else body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'absolute',
            inset: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.5rem',
            color: (0, $jTCZr.CT).mute,
            fontSize: '0.75rem',
            padding: '1rem',
            textAlign: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $iH4cM.default), {
        size: 32,
        strokeWidth: 1.5,
        "aria-hidden": true
    }), t('patient.files.detail.noPreview'));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testid,
        "data-state": view.status,
        "data-type": view.type || undefined,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.375rem',
            minHeight: 0,
            flex: height ? undefined : 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "toolbar",
        "aria-label": t(k('label')),
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.125rem',
            minHeight: $ddefab495daaa435$var$TOOL
        }
    }, isImage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5MbI8.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $47abO.default), {
            size: 16,
            "aria-hidden": true
        }),
        label: t(k('zoomIn')),
        variant: "ghost",
        size: $ddefab495daaa435$var$TOOL,
        onClick: ()=>zoomTo(zoom * $ddefab495daaa435$var$STEP),
        disabled: !measured || zoom >= $ddefab495daaa435$var$MAX_ZOOM,
        "data-testid": `${testid}-zoom-in`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5MbI8.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bU80g.default), {
            size: 16,
            "aria-hidden": true
        }),
        label: t(k('zoomOut')),
        variant: "ghost",
        size: $ddefab495daaa435$var$TOOL,
        onClick: ()=>zoomTo(zoom / $ddefab495daaa435$var$STEP),
        disabled: !measured || zoom <= $ddefab495daaa435$var$MIN_ZOOM,
        "data-testid": `${testid}-zoom-out`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5MbI8.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6ivsH.default), {
            size: 16,
            "aria-hidden": true
        }),
        label: t(k('fit')),
        variant: "ghost",
        size: $ddefab495daaa435$var$TOOL,
        onClick: fitView,
        disabled: !measured || atFit,
        "data-testid": `${testid}-fit`
    }), measured && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-live": "polite",
        "data-testid": `${testid}-zoom-level`,
        style: {
            fontSize: '0.6875rem',
            color: (0, $jTCZr.CT).mute,
            paddingInline: '0.375rem',
            fontVariantNumeric: 'tabular-nums',
            whiteSpace: 'nowrap'
        }
    }, t(k('zoomLevel'), {
        percent: Math.round(scale * 100)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1
        }
    }), onToggleExpand && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5MbI8.default), {
        icon: expanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $i7GA0.default), {
            size: 16,
            "aria-hidden": true
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $axyPa.default), {
            size: 16,
            "aria-hidden": true
        }),
        label: t(k(expanded ? 'collapse' : 'expand')),
        variant: "ghost",
        size: $ddefab495daaa435$var$TOOL,
        "aria-pressed": expanded,
        onClick: onToggleExpand,
        "data-testid": `${testid}-expand`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: frameRef,
        "data-testid": `${testid}-frame`,
        tabIndex: isImage ? 0 : undefined,
        role: isImage ? 'region' : undefined,
        "aria-label": isImage ? t(k('label')) : undefined,
        "aria-describedby": isImage ? hintId : undefined,
        onKeyDown: isImage ? onKeyDown : undefined,
        onPointerDown: isImage ? onPointerDown : undefined,
        onPointerMove: isImage ? onPointerMove : undefined,
        onPointerUp: isImage ? onPointerUp : undefined,
        onPointerCancel: isImage ? onPointerUp : undefined,
        onClickCapture: isImage ? onClickCapture : undefined,
        style: {
            position: 'relative',
            direction: 'ltr',
            overflow: 'hidden',
            flex: height ? undefined : 1,
            height: height,
            minHeight: '14rem',
            background: (0, $jTCZr.CT).surface2,
            border: `1px solid ${(0, $jTCZr.CT).border}`,
            borderRadius: (0, $7sS0P.RADIUS).card,
            cursor: isImage && zoom > 1 ? 'grab' : 'default',
            touchAction: isImage && zoom > 1 ? 'none' : 'pan-y'
        }
    }, body, isImage && activeMark && !activeRegion && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-live": "polite",
        "data-testid": `${testid}-no-region`,
        style: {
            position: 'absolute',
            bottom: 8,
            insetInlineStart: 8,
            insetInlineEnd: 8,
            direction: 'rtl',
            display: 'flex',
            justifyContent: 'center',
            pointerEvents: 'none'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            background: (0, $jTCZr.CT).card,
            color: (0, $jTCZr.CT).ink2,
            border: `1px solid ${(0, $jTCZr.CT).border}`,
            borderRadius: (0, $7sS0P.RADIUS).chip,
            padding: '0.125rem 0.5rem',
            fontSize: '0.6875rem'
        }
    }, t(k('noRegion'), {
        row: formatDigits(activeMark.row)
    })))), isImage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        id: hintId,
        className: "sr-only"
    }, t(k('keyboardHint'))), isPdf && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "info",
        "data-testid": `${testid}-pdf-note`
    }, t(k('pdfNoHighlight'))));
}

});
parcelRegister("axyPa", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbc3cbe2df76370b$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $dbc3cbe2df76370b$export$a2387ed3b5d536eb = {
    name: "expand",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m15 15 6 6",
                key: "1s409w"
            }
        ],
        [
            "path",
            {
                d: "m15 9 6-6",
                key: "ko1vev"
            }
        ],
        [
            "path",
            {
                d: "M21 16v5h-5",
                key: "1ck2sf"
            }
        ],
        [
            "path",
            {
                d: "M21 8V3h-5",
                key: "1qoq8a"
            }
        ],
        [
            "path",
            {
                d: "M3 16v5h5",
                key: "1t08am"
            }
        ],
        [
            "path",
            {
                d: "m3 21 6-6",
                key: "wwnumi"
            }
        ],
        [
            "path",
            {
                d: "M3 8V3h5",
                key: "1ln10m"
            }
        ],
        [
            "path",
            {
                d: "M9 9 3 3",
                key: "v551iv"
            }
        ]
    ]
};
$dbc3cbe2df76370b$export$a2387ed3b5d536eb.node;
const $dbc3cbe2df76370b$export$2e2bcd8739ae039 = (0, $9QBug.default)($dbc3cbe2df76370b$export$a2387ed3b5d536eb);

});

parcelRegister("i7GA0", function(module, exports) {

$parcel$export(module.exports, "default", () => $61d40a05e8e57206$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $61d40a05e8e57206$export$a2387ed3b5d536eb = {
    name: "shrink",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m15 15 6 6m-6-6v4.8m0-4.8h4.8",
                key: "17vawe"
            }
        ],
        [
            "path",
            {
                d: "M9 19.8V15m0 0H4.2M9 15l-6 6",
                key: "chjx8e"
            }
        ],
        [
            "path",
            {
                d: "M15 4.2V9m0 0h4.8M15 9l6-6",
                key: "lav6yq"
            }
        ],
        [
            "path",
            {
                d: "M9 4.2V9m0 0H4.2M9 9 3 3",
                key: "1pxi2q"
            }
        ]
    ]
};
$61d40a05e8e57206$export$a2387ed3b5d536eb.node;
const $61d40a05e8e57206$export$2e2bcd8739ae039 = (0, $9QBug.default)($61d40a05e8e57206$export$a2387ed3b5d536eb);

});


parcelRegister("fpMTR", function(module, exports) {

$parcel$export(module.exports, "default", () => $a64846894ac678ef$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $9gEOi = parcelRequire("9gEOi");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $7sS0P = parcelRequire("7sS0P");

var $1dCSZ = parcelRequire("1dCSZ");
// «جدول نتایج» on a workstation — docs/lab_results_ocr_wireframe_ai_agent.md §4.
//
//   ردیف │ آیتم آزمایش │ مقدار │ واحد │ محدودهٔ مرجع │ وضعیت
//   OCR  │ OCR+catalog │ OCR ✎ │ DB   │ DB           │ rule engine
//
// Only the value is a field. Hovering or focusing a row makes it the active row (its
// highlight lights on the image); ↑ / ↓ / Enter move between the value fields.
const $a64846894ac678ef$var$k = (s)=>`patient.files.extract.labReview.${s}`;
const $a64846894ac678ef$var$checkedValue = (v)=>typeof v === 'boolean' ? v : Boolean(v?.target?.checked);
const $a64846894ac678ef$var$headerCell = {
    position: 'sticky',
    top: 0,
    zIndex: 1,
    background: (0, $jTCZr.CT).surface2,
    padding: '0.5rem',
    textAlign: 'start',
    fontWeight: 600,
    color: (0, $jTCZr.CT).mute,
    whiteSpace: 'nowrap',
    borderBottom: `1px solid ${(0, $jTCZr.CT).border}`,
    fontSize: '0.75rem'
};
const $a64846894ac678ef$var$cell = {
    padding: '0.375rem 0.5rem',
    verticalAlign: 'middle'
};
function $a64846894ac678ef$export$2e2bcd8739ae039({ rows: rows, views: views, activeKey: activeKey, onActivate: onActivate, onRowChange: onRowChange, onRevert: onRevert, onPickTest: onPickTest, onRemove: onRemove, onValueKeyDown: onValueKeyDown, onEditValue: onEditValue, registerValue: registerValue, catalogOptions: catalogOptions, disabled: disabled }) {
    const { t: t, formatDigits: formatDigits } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            border: `1px solid ${(0, $jTCZr.CT).border}`,
            borderRadius: (0, $7sS0P.RADIUS).card,
            background: (0, $jTCZr.CT).card
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("table", {
        "data-testid": "lab-results-table",
        style: {
            width: '100%',
            borderCollapse: 'separate',
            borderSpacing: 0,
            fontSize: '0.8125rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("caption", {
        className: "sr-only"
    }, t($a64846894ac678ef$var$k('tableTitle'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        scope: "col",
        style: {
            ...$a64846894ac678ef$var$headerCell,
            width: '2.5rem',
            borderStartStartRadius: (0, $7sS0P.RADIUS).card
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "sr-only"
    }, t($a64846894ac678ef$var$k('columns.record')))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        scope: "col",
        style: {
            ...$a64846894ac678ef$var$headerCell,
            width: '3.25rem'
        }
    }, t($a64846894ac678ef$var$k('columns.row'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        scope: "col",
        style: $a64846894ac678ef$var$headerCell
    }, t($a64846894ac678ef$var$k('columns.test'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        scope: "col",
        style: {
            ...$a64846894ac678ef$var$headerCell,
            width: '9rem'
        }
    }, t($a64846894ac678ef$var$k('columns.value'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        scope: "col",
        style: {
            ...$a64846894ac678ef$var$headerCell,
            width: '6rem'
        }
    }, t($a64846894ac678ef$var$k('columns.unit'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        scope: "col",
        style: {
            ...$a64846894ac678ef$var$headerCell,
            width: '7rem',
            textAlign: 'end'
        }
    }, t($a64846894ac678ef$var$k('columns.range'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        scope: "col",
        style: {
            ...$a64846894ac678ef$var$headerCell,
            width: '8rem',
            borderStartEndRadius: (0, $7sS0P.RADIUS).card
        }
    }, t($a64846894ac678ef$var$k('columns.status'))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tbody", null, rows.map((row)=>{
        const view = views.get(row.key);
        if (!view) return null;
        const active = row.key === activeKey;
        const selected = row.selected !== false;
        const name = (0, $1dCSZ.labRowName)(row, view);
        const noticesId = `lab-row-notices-${row.key}`;
        const withNotices = (0, $1dCSZ.rowHasNotices)(row, view, active);
        const band = active ? (0, $jTCZr.CT).accentSoft : 'transparent';
        const edge = {
            borderInlineStart: `3px solid ${active ? (0, $jTCZr.CT).accent : 'transparent'}`
        };
        const dim = selected ? undefined : 0.55;
        const activate = ()=>onActivate(row.key, 'table');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
            key: row.key
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", {
            "data-testid": "lab-row",
            "data-key": row.key,
            "data-active": active || undefined,
            "data-status": view.status,
            "data-selected": selected,
            "data-issues": view.issues.join(' ') || undefined,
            onMouseEnter: activate,
            onFocusCapture: activate,
            style: {
                background: band
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: {
                ...$a64846894ac678ef$var$cell,
                ...edge,
                borderTop: `1px solid ${(0, $jTCZr.CT).border}`,
                textAlign: 'center'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9gEOi.default), {
            checked: selected,
            onChange: (v)=>onRowChange(row.key, {
                    selected: $a64846894ac678ef$var$checkedValue(v)
                }),
            "aria-label": t('patient.files.extract.recordRow', {
                name: name || t('patient.files.extract.test')
            }),
            disabled: disabled,
            "data-testid": `lab-row-select-${row.key}`
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: {
                ...$a64846894ac678ef$var$cell,
                borderTop: `1px solid ${(0, $jTCZr.CT).border}`,
                opacity: dim
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            size: "sm",
            className: "h-8 min-w-8 px-2 tabular-nums",
            onClick: ()=>onActivate(row.key, 'table', {
                    reveal: true
                }),
            "aria-label": t($a64846894ac678ef$var$k('showOnImage'), {
                row: formatDigits(row.row)
            }),
            "data-testid": `lab-row-locate-${row.key}`
        }, formatDigits(row.row))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: {
                ...$a64846894ac678ef$var$cell,
                borderTop: `1px solid ${(0, $jTCZr.CT).border}`,
                opacity: dim,
                minWidth: '8rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            dir: "auto",
            "data-testid": `lab-row-name-${row.key}`,
            style: {
                fontWeight: 600,
                color: view.matched ? (0, $jTCZr.CT).ink : (0, $jTCZr.CT).ink2,
                unicodeBidi: 'isolate'
            }
        }, name || "\u2014"), (0, $1dCSZ.printedNameWorthShowing)(row, view) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.6875rem',
                color: (0, $jTCZr.CT).mute
            }
        }, t($a64846894ac678ef$var$k('onDocument'), {
            name: ''
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "auto",
            style: {
                unicodeBidi: 'isolate'
            }
        }, row.rawTestName))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: {
                ...$a64846894ac678ef$var$cell,
                borderTop: `1px solid ${(0, $jTCZr.CT).border}`,
                opacity: dim
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1dCSZ.LabValueInput), {
            ref: (el)=>registerValue(row.key, el),
            row: row,
            view: view,
            name: name,
            onChange: (value)=>onRowChange(row.key, {
                    value: value
                }),
            onRevert: ()=>onRevert(row.key),
            onKeyDown: onValueKeyDown(row.key),
            disabled: disabled,
            describedBy: withNotices ? noticesId : undefined,
            testid: `lab-row-value-${row.key}`
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: {
                ...$a64846894ac678ef$var$cell,
                borderTop: `1px solid ${(0, $jTCZr.CT).border}`,
                opacity: dim
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1dCSZ.LabUnit), {
            view: view,
            testid: `lab-row-unit-${row.key}`
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: {
                ...$a64846894ac678ef$var$cell,
                borderTop: `1px solid ${(0, $jTCZr.CT).border}`,
                opacity: dim,
                textAlign: 'end'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1dCSZ.LabRange), {
            view: view,
            testid: `lab-row-range-${row.key}`
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: {
                ...$a64846894ac678ef$var$cell,
                borderTop: `1px solid ${(0, $jTCZr.CT).border}`,
                opacity: dim
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1dCSZ.LabStatus), {
            view: view,
            testid: `lab-row-status-${row.key}`
        }))), withNotices && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", {
            "data-testid": "lab-row-detail",
            onMouseEnter: activate,
            style: {
                background: band
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: {
                ...edge,
                padding: 0
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            colSpan: 5,
            style: {
                padding: '0 0.5rem 0.5rem',
                opacity: dim
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1dCSZ.LabRowNotices), {
            id: noticesId,
            row: row,
            view: view,
            active: active,
            catalogOptions: catalogOptions,
            onPickTest: (testKey)=>onPickTest(row.key, testKey),
            onEditValue: ()=>onEditValue(row.key),
            onRemove: ()=>onRemove(row.key),
            disabled: disabled,
            testid: `lab-row-notices-${row.key}`
        }))));
    }))));
}

});
parcelRegister("1dCSZ", function(module, exports) {

$parcel$export(module.exports, "labRowName", () => $e984a1b6384d4ce7$export$d5d8e8d16b0c6ec2);
$parcel$export(module.exports, "printedNameWorthShowing", () => $e984a1b6384d4ce7$export$e39d377614ea8158);
$parcel$export(module.exports, "LabStatus", () => $e984a1b6384d4ce7$export$1dd29eecb96d6990);
$parcel$export(module.exports, "LabUnit", () => $e984a1b6384d4ce7$export$76451f5ae0877040);
$parcel$export(module.exports, "LabRange", () => $e984a1b6384d4ce7$export$9419155be3602f77);
$parcel$export(module.exports, "LabValueInput", () => $e984a1b6384d4ce7$export$1690d49a4660854d);
$parcel$export(module.exports, "rowHasNotices", () => $e984a1b6384d4ce7$export$8442fca60fc3bfd2);
$parcel$export(module.exports, "LabRowNotices", () => $e984a1b6384d4ce7$export$18ebf7db3a596718);

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $5MbI8 = parcelRequire("5MbI8");
var $fAR2n = parcelRequire("fAR2n");
var $a7Rbr = parcelRequire("a7Rbr");

var $jTCZr = parcelRequire("jTCZr");

var $dfuoR = parcelRequire("dfuoR");
var $QG9Z3 = parcelRequire("QG9Z3");
var $98Fib = parcelRequire("98Fib");
var $7dUy9 = parcelRequire("7dUy9");
var $kBNa0 = parcelRequire("kBNa0");
var $8MlIT = parcelRequire("8MlIT");
var $97xXr = parcelRequire("97xXr");
var $kx99t = parcelRequire("kx99t");
var $aGlWN = parcelRequire("aGlWN");
var $iDwyV = parcelRequire("iDwyV");
var $lUsTt = parcelRequire("lUsTt");
var $eSMMS = parcelRequire("eSMMS");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $7sS0P = parcelRequire("7sS0P");

var $6wb9F = parcelRequire("6wb9F");

var $hm7Q7 = parcelRequire("hm7Q7");

var $hRWhk = parcelRequire("hRWhk");
// The pieces one lab row is drawn from, shared by the desktop table and the phone
// cards (design-language parts, not layout — DESIGN_SYSTEM §7).
//
//   read-only  → the test name, unit, reference range and status: plain text, no box
//   editable   → the value alone: a bordered field, so the difference never depends on
//                colour (§17)
//
// Every state is said in words with an icon (§18): a status is «بالا» with an arrow,
// never a red cell.
const $e984a1b6384d4ce7$var$k = (s)=>`patient.files.extract.labReview.${s}`;
const $e984a1b6384d4ce7$var$LTR = {
    direction: 'ltr',
    unicodeBidi: 'isolate'
};
const $e984a1b6384d4ce7$var$TONE = {
    normal: {
        background: (0, $jTCZr.CT).goodSoft,
        color: (0, $jTCZr.CT).goodInk,
        Icon: (0, $kBNa0.default)
    },
    high: {
        background: (0, $jTCZr.CT).warnSoft,
        color: (0, $jTCZr.CT).warnInk,
        Icon: (0, $7dUy9.default)
    },
    low: {
        background: (0, $jTCZr.CT).warnSoft,
        color: (0, $jTCZr.CT).warnInk,
        Icon: (0, $98Fib.default)
    },
    abnormal: {
        background: (0, $jTCZr.CT).warnSoft,
        color: (0, $jTCZr.CT).warnInk,
        Icon: (0, $QG9Z3.default)
    },
    critical: {
        background: (0, $jTCZr.CT).dangerSoft,
        color: (0, $jTCZr.CT).dangerInk,
        Icon: (0, $dfuoR.default)
    },
    unknown: {
        background: (0, $jTCZr.CT).surface2,
        color: (0, $jTCZr.CT).mute,
        Icon: (0, $8MlIT.default)
    }
};
function $e984a1b6384d4ce7$export$d5d8e8d16b0c6ec2(row, view) {
    return view?.matched && view.ref?.displayName || row.rawTestName || '';
}
function $e984a1b6384d4ce7$export$e39d377614ea8158(row, view) {
    if (!view?.matched || !row.rawTestName) return false;
    return (0, $6wb9F.foldText)(row.rawTestName) !== (0, $6wb9F.foldText)(view.ref?.displayName || '');
}
function $e984a1b6384d4ce7$export$1dd29eecb96d6990({ view: view, testid: testid }) {
    const { t: t } = (0, $LNQP4.default)();
    const key = view.critical ? 'critical' : $e984a1b6384d4ce7$var$TONE[view.interpretation] ? view.interpretation : 'unknown';
    const labelKey = view.critical ? view.interpretation === 'low' ? 'criticalLow' : 'criticalHigh' : key;
    const { Icon: Icon, ...tone } = $e984a1b6384d4ce7$var$TONE[key];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": testid,
        "data-status": key,
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.25rem',
            padding: '0.125rem 0.5rem',
            borderRadius: (0, $7sS0P.RADIUS).chip,
            fontSize: '0.71875rem',
            fontWeight: 600,
            whiteSpace: 'nowrap',
            lineHeight: 1.6,
            ...tone
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        size: 12,
        "aria-hidden": true
    }), " ", t($e984a1b6384d4ce7$var$k(`status.${labelKey}`)));
}
function $e984a1b6384d4ce7$export$76451f5ae0877040({ view: view, testid: testid }) {
    return view.ref?.unit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": testid,
        style: {
            ...$e984a1b6384d4ce7$var$LTR,
            color: (0, $jTCZr.CT).ink2,
            whiteSpace: 'nowrap'
        }
    }, view.ref.unit) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": testid,
        style: {
            color: (0, $jTCZr.CT).mute
        }
    }, "\u2014");
}
function $e984a1b6384d4ce7$export$9419155be3602f77({ view: view, testid: testid }) {
    return view.ref?.referenceAvailable && view.ref.referenceText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": testid,
        style: {
            ...$e984a1b6384d4ce7$var$LTR,
            color: (0, $jTCZr.CT).ink2,
            whiteSpace: 'nowrap',
            fontVariantNumeric: 'tabular-nums'
        }
    }, view.ref.referenceText) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": testid,
        style: {
            color: (0, $jTCZr.CT).mute
        }
    }, "\u2014");
}
const $e984a1b6384d4ce7$export$1690d49a4660854d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function LabValueInput({ row: row, view: view, name: name, onChange: onChange, onRevert: onRevert, onKeyDown: onKeyDown, onFocus: onFocus, disabled: disabled, describedBy: describedBy, testid: testid }, ref) {
    const { t: t } = (0, $LNQP4.default)();
    const invalid = view.valueProblem === 'invalid';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.25rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: '4.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
        ref: ref,
        value: row.value,
        onChange: (e)=>onChange(typeof e === 'string' ? e : e?.target?.value ?? ''),
        dir: "ltr",
        inputMode: "decimal",
        autoComplete: "off",
        spellCheck: false,
        "aria-label": t($e984a1b6384d4ce7$var$k('valueLabel'), {
            name: name || t('patient.files.extract.test')
        }),
        "aria-invalid": invalid || undefined,
        "aria-describedby": describedBy,
        placeholder: view.valueProblem === 'missing' ? "\u2014" : undefined,
        disabled: disabled,
        onKeyDown: onKeyDown,
        onFocus: onFocus,
        inputStyle: {
            fontWeight: 600,
            fontVariantNumeric: 'tabular-nums',
            ...invalid ? {
                borderColor: (0, $jTCZr.CT).danger
            } : null
        },
        "data-testid": testid
    })), view.corrected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5MbI8.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $iDwyV.default), {
            size: 14,
            "aria-hidden": true
        }),
        label: t($e984a1b6384d4ce7$var$k('revert')),
        variant: "ghost",
        size: 32,
        onClick: onRevert,
        disabled: disabled,
        "data-testid": `${testid}-revert`
    }));
});
function $e984a1b6384d4ce7$var$Notice({ tone: tone = 'warn', icon: Icon, children: children, action: action, testid: testid }) {
    const color = {
        warn: (0, $jTCZr.CT).warnInk,
        danger: (0, $jTCZr.CT).dangerInk,
        info: (0, $jTCZr.CT).ink2,
        mute: (0, $jTCZr.CT).mute
    }[tone];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testid,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.375rem',
            flexWrap: 'wrap',
            fontSize: '0.71875rem',
            color: color,
            lineHeight: 1.7
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        size: 13,
        "aria-hidden": true,
        style: {
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, children), action);
}
function $e984a1b6384d4ce7$export$8442fca60fc3bfd2(row, view, active) {
    return view.issues.length > 0 || view.corrected || row.source === 'manual' || row.source === 'ocr' && row.testKey && row.testKey !== row.ocrTestKey || active && Boolean(row.sourceText);
}
function $e984a1b6384d4ce7$export$18ebf7db3a596718({ row: row, view: view, active: active, catalogOptions: catalogOptions, onPickTest: onPickTest, onEditValue: onEditValue, onRemove: onRemove, disabled: disabled, id: id, testid: testid }) {
    const { t: t } = (0, $LNQP4.default)();
    const [picking, setPicking] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const has = (issue)=>view.issues.includes(issue);
    const pickedByDoctor = row.source === 'ocr' && Boolean(row.testKey) && row.testKey !== row.ocrTestKey;
    const showPicker = row.source === 'manual' || pickedByDoctor || has('unmatched') && picking;
    const editAction = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        className: "h-7 gap-1 px-2",
        onClick: onEditValue,
        disabled: disabled,
        "data-testid": `${testid}-edit`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aGlWN.default), {
        size: 12,
        "aria-hidden": true
    }), " ", t($e984a1b6384d4ce7$var$k('edit')));
    const reasonKey = view.ref?.missingReason === 'sex_unknown' ? 'noReferenceSex' : view.ref?.missingReason === 'no_band' ? 'noReferenceBand' : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: id,
        "data-testid": testid,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.25rem'
        }
    }, has('noTest') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e984a1b6384d4ce7$var$Notice, {
        icon: (0, $QG9Z3.default),
        testid: `${testid}-no-test`
    }, t($e984a1b6384d4ce7$var$k('noTest'))), has('unmatched') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e984a1b6384d4ce7$var$Notice, {
        icon: (0, $QG9Z3.default),
        testid: `${testid}-unmatched`,
        action: !picking && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "outline",
            size: "sm",
            className: "h-7 px-2",
            onClick: ()=>setPicking(true),
            disabled: disabled,
            "data-testid": `${testid}-pick-open`
        }, t($e984a1b6384d4ce7$var$k('pickTest')))
    }, t($e984a1b6384d4ce7$var$k('unmatched'))), showPicker && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            maxWidth: '18rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fAR2n.default), {
        label: t($e984a1b6384d4ce7$var$k('pickTestLabel')),
        value: row.testKey || '',
        onChange: (e)=>onPickTest(e.target.value),
        options: catalogOptions,
        placeholder: t($e984a1b6384d4ce7$var$k('pickTestPlaceholder')),
        disabled: disabled,
        "data-testid": `${testid}-pick`
    })), has('invalid') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e984a1b6384d4ce7$var$Notice, {
        tone: "danger",
        icon: (0, $eSMMS.default),
        testid: `${testid}-invalid`
    }, t($e984a1b6384d4ce7$var$k('invalidValue'))), has('missing') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e984a1b6384d4ce7$var$Notice, {
        tone: "mute",
        icon: (0, $kx99t.default),
        testid: `${testid}-missing`
    }, t($e984a1b6384d4ce7$var$k('missingValue'))), has('uncertain') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e984a1b6384d4ce7$var$Notice, {
        icon: (0, $QG9Z3.default),
        testid: `${testid}-uncertain`,
        action: editAction
    }, t($e984a1b6384d4ce7$var$k('uncertain')), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: (0, $jTCZr.CT).ink2
        }
    }, t($e984a1b6384d4ce7$var$k('extractedValue'), {
        value: ''
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            ...$e984a1b6384d4ce7$var$LTR,
            fontWeight: 600,
            color: (0, $jTCZr.CT).ink
        }
    }, row.ocrValue)), has('review') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e984a1b6384d4ce7$var$Notice, {
        tone: "info",
        icon: (0, $97xXr.default),
        testid: `${testid}-review`,
        action: editAction
    }, t($e984a1b6384d4ce7$var$k('reviewBand'))), has('implausible') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e984a1b6384d4ce7$var$Notice, {
        icon: (0, $QG9Z3.default),
        testid: `${testid}-implausible`
    }, view.ref?.unit ? t($e984a1b6384d4ce7$var$k('implausible'), {
        unit: view.ref.unit
    }) : t($e984a1b6384d4ce7$var$k('implausibleNoUnit'))), has('noReference') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e984a1b6384d4ce7$var$Notice, {
        icon: (0, $QG9Z3.default),
        testid: `${testid}-no-reference`
    }, t($e984a1b6384d4ce7$var$k('noReference')), reasonKey ? ` ${t($e984a1b6384d4ce7$var$k(reasonKey))}` : ''), view.corrected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e984a1b6384d4ce7$var$Notice, {
        tone: "mute",
        icon: (0, $aGlWN.default),
        testid: `${testid}-corrected`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hRWhk.FileChip), {
        tone: "accent"
    }, t($e984a1b6384d4ce7$var$k('corrected'))), ' ', t($e984a1b6384d4ce7$var$k('ocrValue'), {
        value: ''
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: $e984a1b6384d4ce7$var$LTR
    }, row.ocrValue || "\u2014")), has('unverified') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'flex',
            gap: '0.25rem',
            flexWrap: 'wrap'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hm7Q7.EvidenceChips), {
        item: {
            verified: false
        },
        testid: `${testid}-evidence`
    })), active && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hm7Q7.SourceSnippet), {
        text: row.sourceText,
        testid: `${testid}-source`
    }), row.source === 'manual' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        className: "h-7 gap-1 px-2",
        onClick: onRemove,
        disabled: disabled,
        "data-testid": `${testid}-remove`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lUsTt.default), {
        size: 12,
        "aria-hidden": true
    }), " ", t('patient.files.extract.removeRow'))));
}

});
parcelRegister("98Fib", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8d58349d145e6a3$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $c8d58349d145e6a3$export$a2387ed3b5d536eb = {
    name: "arrow-down",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M12 5v14",
                key: "s699le"
            }
        ],
        [
            "path",
            {
                d: "m19 12-7 7-7-7",
                key: "1idqje"
            }
        ]
    ]
};
$c8d58349d145e6a3$export$a2387ed3b5d536eb.node;
const $c8d58349d145e6a3$export$2e2bcd8739ae039 = (0, $9QBug.default)($c8d58349d145e6a3$export$a2387ed3b5d536eb);

});

parcelRegister("7dUy9", function(module, exports) {

$parcel$export(module.exports, "default", () => $eda1c78859f80095$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $eda1c78859f80095$export$a2387ed3b5d536eb = {
    name: "arrow-up",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m5 12 7-7 7 7",
                key: "hav0vg"
            }
        ],
        [
            "path",
            {
                d: "M12 19V5",
                key: "x0mq9r"
            }
        ]
    ]
};
$eda1c78859f80095$export$a2387ed3b5d536eb.node;
const $eda1c78859f80095$export$2e2bcd8739ae039 = (0, $9QBug.default)($eda1c78859f80095$export$a2387ed3b5d536eb);

});

parcelRegister("8MlIT", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2768ed5a904339e$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $c2768ed5a904339e$export$a2387ed3b5d536eb = {
    name: "circle-question-mark",
    size: 24,
    node: [
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                r: "10",
                key: "1mglay"
            }
        ],
        [
            "path",
            {
                d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3",
                key: "1u773s"
            }
        ],
        [
            "path",
            {
                d: "M12 17h.01",
                key: "p32p05"
            }
        ]
    ],
    aliases: [
        "help-circle",
        "circle-help"
    ]
};
$c2768ed5a904339e$export$a2387ed3b5d536eb.node;
const $c2768ed5a904339e$export$2e2bcd8739ae039 = (0, $9QBug.default)($c2768ed5a904339e$export$a2387ed3b5d536eb);

});

parcelRegister("eSMMS", function(module, exports) {

$parcel$export(module.exports, "default", () => $854b6748a2b0b789$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $854b6748a2b0b789$export$a2387ed3b5d536eb = {
    name: "circle-x",
    size: 24,
    node: [
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                r: "10",
                key: "1mglay"
            }
        ],
        [
            "path",
            {
                d: "m15 9-6 6",
                key: "1uzhvr"
            }
        ],
        [
            "path",
            {
                d: "m9 9 6 6",
                key: "z0biqf"
            }
        ]
    ],
    aliases: [
        "x-circle"
    ]
};
$854b6748a2b0b789$export$a2387ed3b5d536eb.node;
const $854b6748a2b0b789$export$2e2bcd8739ae039 = (0, $9QBug.default)($854b6748a2b0b789$export$a2387ed3b5d536eb);

});

parcelRegister("hm7Q7", function(module, exports) {

$parcel$export(module.exports, "evidenceTint", () => $9d2aabecd4883b7c$export$db8ce6b495f12ddc);
$parcel$export(module.exports, "EvidenceChips", () => $9d2aabecd4883b7c$export$2e9eab6b9d145d15);
$parcel$export(module.exports, "SourceSnippet", () => $9d2aabecd4883b7c$export$d01dc4a28d149339);
$parcel$export(module.exports, "FlagList", () => $9d2aabecd4883b7c$export$1c49e2087a373b64);

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");

var $QG9Z3 = parcelRequire("QG9Z3");
var $g1Pnh = parcelRequire("g1Pnh");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $1Qo7B = parcelRequire("1Qo7B");

var $hRWhk = parcelRequire("hRWhk");
const $9d2aabecd4883b7c$export$95f93c6e984947ba = (item)=>Number.isFinite(Number(item?.confidence)) && item.confidence !== null && Number(item.confidence) < (0, $1Qo7B.REVIEW_CONFIDENCE);
const $9d2aabecd4883b7c$export$1c8d84be23596b2a = (item)=>item?.verified === false;
const $9d2aabecd4883b7c$export$db8ce6b495f12ddc = (item)=>$9d2aabecd4883b7c$export$1c8d84be23596b2a(item) || $9d2aabecd4883b7c$export$95f93c6e984947ba(item) ? (0, $jTCZr.CT).warnSoft : 'transparent';
function $9d2aabecd4883b7c$export$2e9eab6b9d145d15({ item: item, testid: testid }) {
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, $9d2aabecd4883b7c$export$1c8d84be23596b2a(item) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hRWhk.FileChip), {
        tone: "warn",
        "data-testid": `${testid}-unverified`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $QG9Z3.default), {
        size: 11,
        "aria-hidden": true
    }), " ", t('patient.files.extract.evidence.unverified')), !$9d2aabecd4883b7c$export$1c8d84be23596b2a(item) && $9d2aabecd4883b7c$export$95f93c6e984947ba(item) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hRWhk.FileChip), {
        tone: "warn",
        "data-testid": `${testid}-review`
    }, t('patient.files.extract.evidence.review')));
}
function $9d2aabecd4883b7c$export$d01dc4a28d149339({ text: text, testid: testid }) {
    const { t: t } = (0, $LNQP4.default)();
    if (!text) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": testid,
        style: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: '0.25rem',
            fontSize: '0.6875rem',
            color: (0, $jTCZr.CT).ink2
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $g1Pnh.default), {
        size: 11,
        "aria-hidden": true,
        style: {
            flexShrink: 0,
            marginTop: '0.1875rem',
            color: (0, $jTCZr.CT).mute
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: (0, $jTCZr.CT).mute
        }
    }, t('patient.files.extract.evidence.source'), " "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            unicodeBidi: 'isolate'
        }
    }, text)));
}
function $9d2aabecd4883b7c$export$1c49e2087a373b64({ flags: flags, testid: testid }) {
    if (!flags?.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        "data-testid": testid,
        style: {
            margin: 0,
            paddingInlineStart: '1rem',
            fontSize: '0.6875rem',
            color: (0, $jTCZr.CT).warnInk,
            lineHeight: 1.8
        }
    }, flags.map((f, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: `${f.code}-${i}`,
            "data-code": f.code,
            dir: "auto"
        }, f.message || f.code)));
}

});
parcelRegister("g1Pnh", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcfebb84a9a026be$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $dcfebb84a9a026be$export$a2387ed3b5d536eb = {
    name: "quote",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M16 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z",
                key: "rib7q0"
            }
        ],
        [
            "path",
            {
                d: "M5 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z",
                key: "1ymkrd"
            }
        ]
    ]
};
$dcfebb84a9a026be$export$a2387ed3b5d536eb.node;
const $dcfebb84a9a026be$export$2e2bcd8739ae039 = (0, $9QBug.default)($dcfebb84a9a026be$export$a2387ed3b5d536eb);

});




parcelRegister("87Vkn", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a4a7b67771311d8$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $9gEOi = parcelRequire("9gEOi");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $7sS0P = parcelRequire("7sS0P");

var $1dCSZ = parcelRequire("1dCSZ");
// «جدول نتایج» on a phone: one card per row, the same parts as the desktop table and
// the same rule — the value is the only field (docs/lab_results_ocr_wireframe_ai_agent.md §4, §17).
const $6a4a7b67771311d8$var$k = (s)=>`patient.files.extract.labReview.${s}`;
const $6a4a7b67771311d8$var$checkedValue = (v)=>typeof v === 'boolean' ? v : Boolean(v?.target?.checked);
function $6a4a7b67771311d8$export$2e2bcd8739ae039({ rows: rows, views: views, activeKey: activeKey, onActivate: onActivate, onRowChange: onRowChange, onRevert: onRevert, onPickTest: onPickTest, onRemove: onRemove, onValueKeyDown: onValueKeyDown, onEditValue: onEditValue, registerValue: registerValue, catalogOptions: catalogOptions, disabled: disabled }) {
    const { t: t, formatDigits: formatDigits } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        "data-testid": "lab-result-cards",
        "aria-label": t($6a4a7b67771311d8$var$k('tableTitle')),
        style: {
            listStyle: 'none',
            margin: 0,
            padding: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem'
        }
    }, rows.map((row)=>{
        const view = views.get(row.key);
        if (!view) return null;
        const active = row.key === activeKey;
        const selected = row.selected !== false;
        const name = (0, $1dCSZ.labRowName)(row, view);
        const noticesId = `lab-row-notices-${row.key}`;
        const withNotices = (0, $1dCSZ.rowHasNotices)(row, view, active);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: row.key,
            "data-testid": "lab-row",
            "data-key": row.key,
            "data-active": active || undefined,
            "data-status": view.status,
            "data-selected": selected,
            "data-issues": view.issues.join(' ') || undefined,
            onFocusCapture: ()=>onActivate(row.key, 'table'),
            style: {
                border: `1px solid ${active ? (0, $jTCZr.CT).accent : (0, $jTCZr.CT).border}`,
                borderRadius: (0, $7sS0P.RADIUS).card,
                background: active ? (0, $jTCZr.CT).accentSoft : (0, $jTCZr.CT).card,
                padding: '0.625rem',
                display: 'flex',
                flexDirection: 'column',
                gap: '0.5rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9gEOi.default), {
            checked: selected,
            onChange: (v)=>onRowChange(row.key, {
                    selected: $6a4a7b67771311d8$var$checkedValue(v)
                }),
            "aria-label": t('patient.files.extract.recordRow', {
                name: name || t('patient.files.extract.test')
            }),
            disabled: disabled,
            "data-testid": `lab-row-select-${row.key}`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            size: "sm",
            className: "h-9 min-w-9 px-2 tabular-nums",
            onClick: ()=>onActivate(row.key, 'table', {
                    reveal: true
                }),
            "aria-label": t($6a4a7b67771311d8$var$k('showOnImage'), {
                row: formatDigits(row.row)
            }),
            "data-testid": `lab-row-locate-${row.key}`
        }, formatDigits(row.row)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1,
                minWidth: 0,
                opacity: selected ? undefined : 0.55
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            dir: "auto",
            style: {
                fontWeight: 600,
                fontSize: '0.875rem',
                color: view.matched ? (0, $jTCZr.CT).ink : (0, $jTCZr.CT).ink2,
                unicodeBidi: 'isolate',
                overflowWrap: 'anywhere'
            }
        }, name || "\u2014"), (0, $1dCSZ.printedNameWorthShowing)(row, view) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.6875rem',
                color: (0, $jTCZr.CT).mute
            }
        }, t($6a4a7b67771311d8$var$k('onDocument'), {
            name: ''
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "auto",
            style: {
                unicodeBidi: 'isolate'
            }
        }, row.rawTestName))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1dCSZ.LabStatus), {
            view: view,
            testid: `lab-row-status-${row.key}`
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                opacity: selected ? undefined : 0.55,
                display: 'flex',
                flexDirection: 'column',
                gap: '0.375rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1dCSZ.LabValueInput), {
            ref: (el)=>registerValue(row.key, el),
            row: row,
            view: view,
            name: name,
            onChange: (value)=>onRowChange(row.key, {
                    value: value
                }),
            onRevert: ()=>onRevert(row.key),
            onKeyDown: onValueKeyDown(row.key),
            disabled: disabled,
            describedBy: withNotices ? noticesId : undefined,
            testid: `lab-row-value-${row.key}`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("dl", {
            style: {
                margin: 0,
                display: 'grid',
                gridTemplateColumns: 'auto 1fr',
                gap: '0.125rem 0.5rem',
                fontSize: '0.75rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("dt", {
            style: {
                color: (0, $jTCZr.CT).mute
            }
        }, t($6a4a7b67771311d8$var$k('columns.unit'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("dd", {
            style: {
                margin: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1dCSZ.LabUnit), {
            view: view,
            testid: `lab-row-unit-${row.key}`
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("dt", {
            style: {
                color: (0, $jTCZr.CT).mute
            }
        }, t($6a4a7b67771311d8$var$k('columns.range'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("dd", {
            style: {
                margin: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1dCSZ.LabRange), {
            view: view,
            testid: `lab-row-range-${row.key}`
        }))), withNotices && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1dCSZ.LabRowNotices), {
            id: noticesId,
            row: row,
            view: view,
            active: active,
            catalogOptions: catalogOptions,
            onPickTest: (testKey)=>onPickTest(row.key, testKey),
            onEditValue: ()=>onEditValue(row.key),
            onRemove: ()=>onRemove(row.key),
            disabled: disabled,
            testid: `lab-row-notices-${row.key}`
        })));
    }));
}

});


parcelRegister("SeSDF", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a30962c2cbe3aeb$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $eVM84 = parcelRequire("eVM84");

var $j7Lry = parcelRequire("j7Lry");

var $6wb9F = parcelRequire("6wb9F");
function $0a30962c2cbe3aeb$export$2e2bcd8739ae039({ patientId: patientId, run: run, enabled: enabled }) {
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        status: 'idle',
        review: null
    });
    const [attempt, setAttempt] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!enabled || !patientId || !run) {
            setState({
                status: 'idle',
                review: null
            });
            return undefined;
        }
        let cancelled = false;
        const rows = (0, $6wb9F.labRowsFromRun)(run);
        setState({
            status: 'loading',
            review: null
        });
        (0, $eVM84.bffQuery)((0, $j7Lry.LAB_REVIEW), {
            patientId: patientId,
            items: (0, $6wb9F.reviewQueryItems)(rows)
        }).then((d)=>{
            if (cancelled) return;
            if (!d?.labReview) {
                setState({
                    status: 'error',
                    review: null
                });
                return;
            }
            setState({
                status: 'ready',
                review: (0, $6wb9F.indexLabReview)(d.labReview, rows)
            });
        }).catch(()=>{
            if (!cancelled) setState({
                status: 'error',
                review: null
            });
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        enabled,
        patientId,
        run,
        attempt
    ]);
    const retry = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>setAttempt((n)=>n + 1), []);
    return {
        ...state,
        retry: retry
    };
}

});

parcelRegister("eFS97", function(module, exports) {

$parcel$export(module.exports, "sectionsFrom", () => $9dde797c4c39f144$export$db22bbf0b0807335);
$parcel$export(module.exports, "reportDraftFromRun", () => $9dde797c4c39f144$export$30d31e5015655e10);
$parcel$export(module.exports, "assembledText", () => $9dde797c4c39f144$export$4d7a379d161f67c1);
$parcel$export(module.exports, "reportInput", () => $9dde797c4c39f144$export$119b361f471fb70e);
$parcel$export(module.exports, "default", () => $9dde797c4c39f144$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $9gEOi = parcelRequire("9gEOi");
var $7phmx = parcelRequire("7phmx");
var $4Qco3 = parcelRequire("4Qco3");
var $fAR2n = parcelRequire("fAR2n");
var $iygI2 = parcelRequire("iygI2");
var $a7Rbr = parcelRequire("a7Rbr");

var $jTCZr = parcelRequire("jTCZr");

var $8g4t5 = parcelRequire("8g4t5");
var $lUsTt = parcelRequire("lUsTt");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $7sS0P = parcelRequire("7sS0P");

var $1Qo7B = parcelRequire("1Qo7B");
// A medical / imaging report read off a document, as the doctor proofreads it against
// the scan beside it. docs/DOCTOR_PATIENT_FILES_AND_AI_EXTRACTION_DESIGN.md §7.8, §5.3.
//
// Sections keep the heading AS PRINTED (`title`) beside a closed `key`, so the doctor's
// panel can label a section in its own language without translating the report. With
// no sections the whole text is one field — a report the model could not split is
// still a report.
//
// The same editor carries a handwritten note's sections (history / exam / assessment /
// plan) and a medical record's: `sectionKeys` is the closed set for the document at
// hand, and `showMeta` hides the modality/body-region/date row a note does not have.
let $9dde797c4c39f144$var$sectionSeq = 0;
function $9dde797c4c39f144$export$3e4b15c08f658203(key = 'findings') {
    $9dde797c4c39f144$var$sectionSeq += 1;
    return {
        id: `section-${$9dde797c4c39f144$var$sectionSeq}`,
        key: key,
        title: '',
        text: ''
    };
}
function $9dde797c4c39f144$export$db22bbf0b0807335(sections, keys = (0, $1Qo7B.REPORT_SECTION_KEYS)) {
    return (sections || []).map((s)=>({
            ...$9dde797c4c39f144$export$3e4b15c08f658203(keys.includes(s.key) ? s.key : 'other'),
            title: s.title || '',
            text: s.text || ''
        }));
}
function $9dde797c4c39f144$export$30d31e5015655e10(run, file, appointmentId) {
    const r = run?.report || {};
    return {
        sections: $9dde797c4c39f144$export$db22bbf0b0807335(r.sections),
        fullText: r.fullText || run?.summaryText || '',
        modality: r.modality || '',
        bodyRegion: r.bodyRegion || '',
        reportDate: r.reportDate || file?.documentDate || '',
        alsoNote: Boolean(appointmentId)
    };
}
function $9dde797c4c39f144$export$4d7a379d161f67c1(draft) {
    const fromSections = draft.sections.map((s)=>s.text.trim()).filter(Boolean).join('\n\n');
    return fromSections || draft.fullText.trim();
}
function $9dde797c4c39f144$export$119b361f471fb70e(draft) {
    return {
        fullText: $9dde797c4c39f144$export$4d7a379d161f67c1(draft),
        sections: draft.sections.filter((s)=>s.text.trim()).map((s)=>({
                key: s.key,
                title: s.title || null,
                text: s.text.trim()
            })),
        modality: draft.modality || null,
        bodyRegion: draft.bodyRegion || null,
        reportDate: draft.reportDate || null
    };
}
function $9dde797c4c39f144$export$2e2bcd8739ae039({ draft: draft, onChange: onChange, canWriteNote: canWriteNote, compact: compact = false, disabled: disabled = false, sectionKeys: sectionKeys = (0, $1Qo7B.REPORT_SECTION_KEYS), showMeta: showMeta = true, testid: testid = 'report-sections-editor' }) {
    const { t: t } = (0, $LNQP4.default)();
    const set = (patch)=>onChange({
            ...draft,
            ...patch
        });
    const setSection = (id, patch)=>set({
            sections: draft.sections.map((s)=>s.id === id ? {
                    ...s,
                    ...patch
                } : s)
        });
    const keyOptions = sectionKeys.map((k)=>({
            value: k,
            label: t(`patient.files.sections.${k}`)
        }));
    const modalityOptions = (0, $1Qo7B.REPORT_MODALITIES).map((m)=>({
            value: m,
            label: t(`patient.files.modality.${m}`)
        }));
    const firstKey = sectionKeys[0] === 'clinical_info' ? 'findings' : sectionKeys[0];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testid,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem'
        }
    }, showMeta && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'grid',
            gridTemplateColumns: compact ? '1fr' : 'repeat(3, minmax(0, 1fr))',
            gap: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fAR2n.default), {
        label: t('patient.files.extract.modality'),
        value: draft.modality,
        onChange: (e)=>set({
                modality: e.target.value
            }),
        options: modalityOptions,
        placeholder: t('patient.files.extract.notStated'),
        disabled: disabled
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
        label: t('patient.files.extract.bodyRegion'),
        value: draft.bodyRegion,
        onChange: (v)=>set({
                bodyRegion: typeof v === 'string' ? v : v?.target?.value ?? ''
            }),
        dir: "auto",
        disabled: disabled
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        label: t('patient.files.extract.reportDate')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4Qco3.default), {
        value: draft.reportDate,
        onChange: (v)=>set({
                reportDate: v
            }),
        disableFuture: true,
        disabled: disabled,
        placeholder: t('patient.files.upload.datePlaceholder')
    }))), draft.sections.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $iygI2.default), {
        label: t('patient.files.extract.fullText'),
        value: draft.fullText,
        onChange: (e)=>set({
                fullText: e.target.value
            }),
        rows: compact ? 8 : 12,
        dir: "auto",
        disabled: disabled,
        "data-testid": "report-full-text"
    }) : draft.sections.map((s, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: s.id,
            "data-testid": "report-section",
            "data-key": s.key,
            style: {
                borderRadius: (0, $7sS0P.RADIUS).card,
                border: `1px solid ${(0, $jTCZr.CT).border}`,
                padding: '0.625rem 0.75rem',
                display: 'flex',
                flexDirection: 'column',
                gap: '0.5rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                gap: '0.5rem',
                alignItems: 'flex-end',
                flexWrap: compact ? 'wrap' : 'nowrap'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                minWidth: '9rem',
                flex: compact ? '1 1 100%' : '0 0 11rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fAR2n.default), {
            label: t('patient.files.extract.sectionKey'),
            value: s.key,
            onChange: (e)=>setSection(s.id, {
                    key: e.target.value
                }),
            options: keyOptions,
            placeholder: "",
            disabled: disabled
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1,
                minWidth: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
            label: t('patient.files.extract.sectionTitle'),
            value: s.title,
            onChange: (v)=>setSection(s.id, {
                    title: typeof v === 'string' ? v : v?.target?.value ?? ''
                }),
            dir: "auto",
            disabled: disabled
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            size: "icon",
            className: "h-11 w-11 shrink-0",
            onClick: ()=>set({
                    sections: draft.sections.filter((x)=>x.id !== s.id)
                }),
            "aria-label": t('patient.files.extract.removeSection', {
                index: index + 1
            }),
            disabled: disabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lUsTt.default), {
            size: 15,
            "aria-hidden": true
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $iygI2.default), {
            "aria-label": t('patient.files.extract.sectionText'),
            value: s.text,
            onChange: (e)=>setSection(s.id, {
                    text: e.target.value
                }),
            rows: 4,
            dir: "auto",
            disabled: disabled
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "sm",
        className: "gap-1.5",
        onClick: ()=>set({
                sections: [
                    ...draft.sections,
                    $9dde797c4c39f144$export$3e4b15c08f658203(draft.sections.length ? 'other' : firstKey)
                ]
            }),
        disabled: disabled,
        "data-testid": "report-add-section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8g4t5.default), {
        size: 14,
        "aria-hidden": true
    }), " ", t('patient.files.extract.addSection'))), canWriteNote && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9gEOi.default), {
        checked: draft.alsoNote,
        onChange: (checked)=>set({
                alsoNote: typeof checked === 'boolean' ? checked : Boolean(checked?.target?.checked)
            }),
        label: t('patient.files.extract.alsoNote'),
        disabled: disabled,
        "data-testid": "report-also-note"
    }));
}

});

parcelRegister("1Zgj3", function(module, exports) {

$parcel$export(module.exports, "prescriptionRowsFrom", () => $8f52a74ebbd4d691$export$795b12f8cb8a81c7);
$parcel$export(module.exports, "prescriptionRowProblem", () => $8f52a74ebbd4d691$export$2670ff772f77e35);
$parcel$export(module.exports, "prescriptionRowsReady", () => $8f52a74ebbd4d691$export$87efde12b0cfb4b2);
$parcel$export(module.exports, "prescriptionItemsInput", () => $8f52a74ebbd4d691$export$746c205fdeed75ed);
$parcel$export(module.exports, "default", () => $8f52a74ebbd4d691$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $aJ1FU = parcelRequire("aJ1FU");
var $9gEOi = parcelRequire("9gEOi");
var $fAR2n = parcelRequire("fAR2n");
var $a7Rbr = parcelRequire("a7Rbr");

var $jTCZr = parcelRequire("jTCZr");

var $huNwV = parcelRequire("huNwV");
var $aVx4q = parcelRequire("aVx4q");
var $8g4t5 = parcelRequire("8g4t5");
var $lUsTt = parcelRequire("lUsTt");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $7sS0P = parcelRequire("7sS0P");

var $1Qo7B = parcelRequire("1Qo7B");

var $8qEaX = parcelRequire("8qEaX");

var $hm7Q7 = parcelRequire("hm7Q7");
// A prescription read off a document — one row per drug line, as the doctor checks it
// before it enters the patient's MEDICATION HISTORY (never the visit's نسخه: §23.3 A13,
// §24.8). DICOM_COMPRESSION_LIMITS_AND_DOCUMENT_OCR_DESIGN.md §9.5, §10.6 E23.
//
// Copying a line into the visit's نسخه is a separate, explicit per-row act —
// «افزودن به نسخه ویزیت» — offered only when the host passes `visitRx` (a Visit page
// with an editable prescription). It fills the visit's drug form; it saves nothing.
//
// Each line names the drug AS WRITTEN and offers the formulary's closest candidates;
// the model pre-selects one only when both the match and the reading were confident.
// A line the model could not verify starts unticked. A drug name with an illegible
// mark cannot be recorded until the doctor picks a formulary drug or corrects the text.
let $8f52a74ebbd4d691$var$seq = 0;
const $8f52a74ebbd4d691$var$FIELDS = [
    'strength',
    'form',
    'dose',
    'frequency',
    'route',
    'duration',
    'quantity'
];
function $8f52a74ebbd4d691$export$795b12f8cb8a81c7(items, { selectByDefault: selectByDefault = true } = {}) {
    return (items || []).map((it, index)=>{
        $8f52a74ebbd4d691$var$seq += 1;
        return {
            key: `rx-${$8f52a74ebbd4d691$var$seq}`,
            index: index,
            selected: selectByDefault ? it.verified !== false : false,
            drugText: it.drugText || '',
            drugId: it.selectedDrugId || '',
            strength: it.strength || '',
            form: it.form || '',
            dose: it.dose || '',
            frequency: it.frequency || '',
            frequencyCode: it.frequencyCode || '',
            route: it.route || '',
            duration: it.duration || '',
            quantity: it.quantity || '',
            instructions: it.instructions || '',
            candidates: it.candidates || [],
            sourceText: it.sourceText || '',
            confidence: it.confidence ?? null,
            verified: it.verified ?? null,
            ai: true
        };
    });
}
function $8f52a74ebbd4d691$export$e71d71e9768ed106() {
    $8f52a74ebbd4d691$var$seq += 1;
    return {
        key: `rx-${$8f52a74ebbd4d691$var$seq}`,
        index: null,
        selected: true,
        drugText: '',
        drugId: '',
        strength: '',
        form: '',
        dose: '',
        frequency: '',
        frequencyCode: '',
        route: '',
        duration: '',
        quantity: '',
        instructions: '',
        candidates: [],
        sourceText: '',
        confidence: null,
        verified: null,
        ai: false
    };
}
function $8f52a74ebbd4d691$export$2670ff772f77e35(row) {
    if (!row.selected) return null;
    if (!row.drugText.trim() && !row.drugId) return 'patient.files.extract.rx.needsDrug';
    if ((0, $1Qo7B.hasIllegibleMark)(row.drugText) && !row.drugId) return 'patient.files.extract.rx.illegibleDrug';
    return null;
}
const $8f52a74ebbd4d691$export$87efde12b0cfb4b2 = (rows)=>rows.some((r)=>r.selected) && rows.every((r)=>!$8f52a74ebbd4d691$export$2670ff772f77e35(r));
function $8f52a74ebbd4d691$export$746c205fdeed75ed(rows) {
    const blank = (v)=>v && String(v).trim() ? String(v).trim() : null;
    return rows.filter((r)=>r.selected).map((r)=>{
        const candidate = r.candidates.find((c)=>c.drugId === r.drugId);
        return {
            drugText: r.drugText.trim() || candidate?.name || '',
            drugId: r.drugId || null,
            strength: blank(r.strength),
            form: blank(r.form),
            dose: blank(r.dose),
            frequency: blank(r.frequency),
            frequencyCode: blank(r.frequencyCode),
            route: blank(r.route),
            duration: blank(r.duration),
            quantity: blank(r.quantity),
            instructions: blank(r.instructions)
        };
    });
}
const $8f52a74ebbd4d691$var$inputValue = (v)=>typeof v === 'string' ? v : v?.target?.value ?? '';
function $8f52a74ebbd4d691$export$2e2bcd8739ae039({ rows: rows, onRowsChange: onRowsChange, flags: flags, flagPrefix: flagPrefix = 'prescription.items', compact: compact = false, disabled: disabled = false, testid: testid = 'rx-editor', visitRx: visitRx = null, recordable: recordable = true }) {
    const { t: t, formatPercent: formatPercent } = (0, $LNQP4.default)();
    const patchRow = (key, patch)=>onRowsChange(rows.map((r)=>r.key === key ? {
                ...r,
                ...patch,
                ai: false
            } : r));
    const remove = (key)=>onRowsChange(rows.filter((r)=>r.key !== key));
    const candidateLabel = (c)=>{
        const name = [
            c.name,
            c.strength,
            c.form
        ].filter(Boolean).join(' ');
        // `score` is 0..1; formatPercent takes a percentage.
        return Number.isFinite(Number(c.score)) ? t('patient.files.extract.rx.candidate', {
            name: name,
            score: formatPercent(Math.round(Number(c.score) * 100))
        }) : name;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testid,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.625rem'
        }
    }, rows.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "info",
        "data-testid": `${testid}-empty`
    }, t('patient.files.extract.rx.empty')), rows.map((row)=>{
        const problem = $8f52a74ebbd4d691$export$2670ff772f77e35(row);
        const itemFlags = row.index == null ? [] : (0, $1Qo7B.flagsFor)(flags, `${flagPrefix}[${row.index}]`);
        const options = [
            {
                value: '',
                label: t('patient.files.extract.rx.asWritten')
            },
            ...row.candidates.map((c)=>({
                    value: c.drugId,
                    label: candidateLabel(c)
                }))
        ];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: row.key,
            "data-testid": `${testid}-row`,
            "data-selected": row.selected,
            "data-ready": !problem,
            style: {
                borderRadius: (0, $7sS0P.RADIUS).card,
                border: `1px solid ${problem ? (0, $jTCZr.CT).warn : (0, $jTCZr.CT).border}`,
                background: row.ai ? (0, $hm7Q7.evidenceTint)(row) : 'transparent',
                padding: '0.625rem 0.75rem',
                display: 'flex',
                flexDirection: 'column',
                gap: '0.5rem',
                opacity: row.selected ? 1 : 0.8
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                flexWrap: 'wrap'
            }
        }, recordable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9gEOi.default), {
            checked: row.selected,
            onChange: (v)=>onRowsChange(rows.map((r)=>r.key === row.key ? {
                        ...r,
                        selected: typeof v === 'boolean' ? v : Boolean(v?.target?.checked)
                    } : r)),
            label: t('patient.files.extract.rx.record'),
            disabled: disabled,
            "data-testid": `${testid}-select-${row.key}`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                display: 'flex',
                gap: '0.25rem',
                flexWrap: 'wrap',
                flex: 1
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hm7Q7.EvidenceChips), {
            item: row,
            testid: `${testid}-${row.key}`
        })), visitRx && (()=>{
            const state = visitRx.added?.get(row.key) || null;
            const blocked = Boolean((0, $8qEaX.documentRxRowProblem)(row));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
                variant: state ? 'subtle' : 'outline',
                size: "sm",
                className: `gap-1.5${compact ? ' min-h-11' : ''}`,
                onClick: ()=>visitRx.onAdd(row),
                disabled: Boolean(state) || blocked || Boolean(visitRx.disabled),
                "data-state": state || (blocked ? 'blocked' : 'ready'),
                "data-testid": `${testid}-add-visit-${row.key}`
            }, state ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
                size: 14,
                "aria-hidden": true
            }), " ", t(state === 'already' ? 'patient.files.extract.rx.alreadyInVisit' : 'patient.files.extract.rx.addedToVisit')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aVx4q.default), {
                size: 14,
                "aria-hidden": true
            }), " ", t('patient.files.extract.rx.addToVisit')));
        })(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            size: "icon",
            className: compact ? 'h-11 w-11' : 'h-9 w-9',
            onClick: ()=>remove(row.key),
            "aria-label": t('patient.files.extract.removeRow'),
            disabled: disabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lUsTt.default), {
            size: 15,
            "aria-hidden": true
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'grid',
                gridTemplateColumns: compact ? '1fr' : 'minmax(0, 1fr) minmax(0, 1fr)',
                gap: '0.5rem 0.75rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
            label: t('patient.files.extract.rx.drugText'),
            value: row.drugText,
            onChange: (v)=>patchRow(row.key, {
                    drugText: $8f52a74ebbd4d691$var$inputValue(v)
                }),
            dir: "auto",
            disabled: disabled,
            "data-testid": `${testid}-drug-text-${row.key}`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fAR2n.default), {
            label: t('patient.files.extract.rx.formulary'),
            value: row.drugId,
            onChange: (e)=>patchRow(row.key, {
                    drugId: e.target.value
                }),
            options: options,
            placeholder: "",
            disabled: disabled,
            "data-testid": `${testid}-drug-${row.key}`
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'grid',
                gridTemplateColumns: compact ? 'repeat(2, minmax(0, 1fr))' : 'repeat(4, minmax(0, 1fr))',
                gap: '0.5rem 0.75rem'
            }
        }, $8f52a74ebbd4d691$var$FIELDS.map((f)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
                key: f,
                label: t(`patient.files.extract.rx.${f}`),
                value: row[f],
                onChange: (v)=>patchRow(row.key, {
                        [f]: $8f52a74ebbd4d691$var$inputValue(v),
                        ...f === 'frequency' ? {
                            frequencyCode: ''
                        } : {}
                    }),
                dir: "auto",
                disabled: disabled,
                "data-testid": `${testid}-${f}-${row.key}`
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
            label: t('patient.files.extract.rx.instructions'),
            value: row.instructions,
            onChange: (v)=>patchRow(row.key, {
                    instructions: $8f52a74ebbd4d691$var$inputValue(v)
                }),
            dir: "auto",
            disabled: disabled
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hm7Q7.SourceSnippet), {
            text: row.sourceText,
            testid: `${testid}-source-${row.key}`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hm7Q7.FlagList), {
            flags: itemFlags,
            testid: `${testid}-flags-${row.key}`
        }), problem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "data-testid": `${testid}-problem-${row.key}`,
            style: {
                fontSize: '0.71875rem',
                color: (0, $jTCZr.CT).warnInk
            }
        }, t(problem)));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "sm",
        className: "gap-1.5",
        onClick: ()=>onRowsChange([
                ...rows,
                $8f52a74ebbd4d691$export$e71d71e9768ed106()
            ]),
        disabled: disabled,
        "data-testid": `${testid}-add`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8g4t5.default), {
        size: 14,
        "aria-hidden": true
    }), " ", t('patient.files.extract.rx.add'))));
}

});

parcelRegister("2J9GV", function(module, exports) {

$parcel$export(module.exports, "noteDraftFrom", () => $03ea67e3552fde0c$export$e23fc6f95352710c);
$parcel$export(module.exports, "noteReadyToSave", () => $03ea67e3552fde0c$export$a979aee123e1947c);
$parcel$export(module.exports, "noteFullText", () => $03ea67e3552fde0c$export$e02b4268ba84d59b);
$parcel$export(module.exports, "default", () => $03ea67e3552fde0c$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $aJ1FU = parcelRequire("aJ1FU");
var $lxEfx = parcelRequire("lxEfx");
var $a7Rbr = parcelRequire("a7Rbr");

var $jTCZr = parcelRequire("jTCZr");

var $gr49X = parcelRequire("gr49X");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $7sS0P = parcelRequire("7sS0P");

var $1Qo7B = parcelRequire("1Qo7B");

var $eFS97 = parcelRequire("eFS97");
function $03ea67e3552fde0c$export$e23fc6f95352710c(note, file, appointmentId) {
    return {
        lines: (note?.lines || []).map((l, i)=>({
                key: `line-${i}`,
                text: l.text || '',
                confidence: l.confidence ?? null
            })),
        report: {
            sections: (0, $eFS97.sectionsFrom)(note?.sections, (0, $1Qo7B.NOTE_SECTION_KEYS)),
            fullText: note?.transcript || (note?.lines || []).map((l)=>l.text).join('\n'),
            modality: '',
            bodyRegion: '',
            reportDate: file?.documentDate || '',
            alsoNote: Boolean(appointmentId)
        },
        opened: []
    };
}
const $03ea67e3552fde0c$export$a6af00b81fcce69b = (draft)=>draft.lines.filter((l)=>(0, $1Qo7B.hasIllegibleMark)(l.text));
function $03ea67e3552fde0c$export$a979aee123e1947c(draft, legibility) {
    if (!(0, $eFS97.assembledText)(draft.report) && !draft.lines.some((l)=>l.text.trim())) return false;
    if (String(legibility || '').toLowerCase() !== 'poor') return true;
    return $03ea67e3552fde0c$export$a6af00b81fcce69b(draft).every((l)=>draft.opened.includes(l.key));
}
function $03ea67e3552fde0c$export$e02b4268ba84d59b(draft) {
    return (0, $eFS97.assembledText)(draft.report) || draft.lines.map((l)=>l.text.trim()).filter(Boolean).join('\n');
}
function $03ea67e3552fde0c$var$MarkedText({ text: text }) {
    const parts = String(text).split(/(\[\?\])/);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            unicodeBidi: 'isolate'
        }
    }, parts.map((p, i)=>p === '[?]' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("mark", {
            key: i,
            "data-illegible": true,
            style: {
                background: (0, $jTCZr.CT).warnSoft,
                color: (0, $jTCZr.CT).warnInk,
                borderRadius: (0, $7sS0P.RADIUS).chip,
                padding: '0 0.125rem'
            }
        }, p) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
            key: i
        }, p)));
}
function $03ea67e3552fde0c$export$2e2bcd8739ae039({ draft: draft, onChange: onChange, legibility: legibility, canWriteNote: canWriteNote, compact: compact = false, disabled: disabled = false }) {
    const { t: t, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const poor = String(legibility || '').toLowerCase() === 'poor';
    const marked = $03ea67e3552fde0c$export$a6af00b81fcce69b(draft);
    const unopened = marked.filter((l)=>!draft.opened.includes(l.key)).length;
    const setLine = (key, text)=>onChange({
            ...draft,
            lines: draft.lines.map((l)=>l.key === key ? {
                    ...l,
                    text: text
                } : l)
        });
    const open = (key)=>{
        if (!draft.opened.includes(key)) onChange({
            ...draft,
            opened: [
                ...draft.opened,
                key
            ]
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "note-lines-editor",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem'
        }
    }, poor && unopened > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "warning",
        "data-testid": "note-open-required"
    }, t('patient.files.extract.note.openRequired', {
        count: formatNumber(unopened)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lxEfx.default), {
        title: t('patient.files.extract.note.lines', {
            count: formatNumber(draft.lines.length)
        }),
        defaultOpen: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ol", {
        "data-testid": "note-lines",
        style: {
            margin: 0,
            padding: 0,
            listStyle: 'none',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.25rem'
        }
    }, draft.lines.map((line)=>{
        const isMarked = (0, $1Qo7B.hasIllegibleMark)(line.text);
        const isOpen = draft.opened.includes(line.key);
        const lowConfidence = line.confidence != null && line.confidence < (0, $1Qo7B.REVIEW_CONFIDENCE);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: line.key,
            "data-testid": `note-line-${line.key}`,
            "data-marked": isMarked || undefined,
            "data-opened": isOpen || undefined,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                borderRadius: (0, $7sS0P.RADIUS).control,
                padding: '0.25rem 0.375rem',
                background: isMarked || lowConfidence ? (0, $jTCZr.CT).warnSoft : 'transparent',
                fontSize: '0.8125rem'
            }
        }, isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
            "aria-label": t('patient.files.extract.note.lineText'),
            value: line.text,
            onChange: (v)=>setLine(line.key, typeof v === 'string' ? v : v?.target?.value ?? ''),
            dir: "auto",
            disabled: disabled,
            "data-testid": `note-line-input-${line.key}`
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                flex: 1,
                color: (0, $jTCZr.CT).ink,
                lineHeight: 1.9
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($03ea67e3552fde0c$var$MarkedText, {
            text: line.text
        })), !isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: isMarked ? 'outline' : 'ghost',
            size: "sm",
            className: compact ? 'min-h-11 gap-1' : 'gap-1',
            onClick: ()=>open(line.key),
            disabled: disabled,
            "data-testid": `note-line-open-${line.key}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gr49X.default), {
            size: 13,
            "aria-hidden": true
        }), " ", t(isMarked ? 'patient.files.extract.note.review' : 'patient.files.extract.note.edit')));
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eFS97.default), {
        draft: draft.report,
        onChange: (report)=>onChange({
                ...draft,
                report: report
            }),
        canWriteNote: canWriteNote,
        compact: compact,
        disabled: disabled,
        sectionKeys: (0, $1Qo7B.NOTE_SECTION_KEYS),
        showMeta: false,
        testid: "note-sections-editor"
    }));
}

});

parcelRegister("gS5Gq", function(module, exports) {

$parcel$export(module.exports, "recordDraftFrom", () => $48e3b9f1b8c2cc26$export$1a4e5ae4f93ae22);
$parcel$export(module.exports, "default", () => $48e3b9f1b8c2cc26$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $9gEOi = parcelRequire("9gEOi");
var $lxEfx = parcelRequire("lxEfx");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $1Qo7B = parcelRequire("1Qo7B");

var $eFS97 = parcelRequire("eFS97");

var $1Zgj3 = parcelRequire("1Zgj3");

var $hm7Q7 = parcelRequire("hm7Q7");

var $hRWhk = parcelRequire("hRWhk");
const $48e3b9f1b8c2cc26$export$5989ba6500cbc848 = Object.freeze([
    ...new Set([
        ...(0, $1Qo7B.REPORT_SECTION_KEYS),
        ...(0, $1Qo7B.NOTE_SECTION_KEYS)
    ])
]);
function $48e3b9f1b8c2cc26$export$1a4e5ae4f93ae22(record, file, appointmentId) {
    return {
        report: {
            sections: (0, $eFS97.sectionsFrom)(record?.sections, $48e3b9f1b8c2cc26$export$5989ba6500cbc848),
            fullText: record?.fullText || '',
            modality: '',
            bodyRegion: '',
            reportDate: record?.dischargeDate || record?.admissionDate || file?.documentDate || '',
            alsoNote: Boolean(appointmentId)
        },
        pickedDiagnoses: [],
        includeMedications: false,
        medications: (0, $1Zgj3.prescriptionRowsFrom)(record?.medications, {
            selectByDefault: false
        })
    };
}
function $48e3b9f1b8c2cc26$export$2e2bcd8739ae039({ record: record, draft: draft, onChange: onChange, flags: flags, canWriteNote: canWriteNote, compact: compact = false, disabled: disabled = false, visitRx: visitRx = null }) {
    const { t: t, has: has, formatDate: formatDate, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const set = (patch)=>onChange({
            ...draft,
            ...patch
        });
    const diagnoses = record?.diagnoses || [];
    const procedures = record?.procedures || [];
    const typeKey = record?.recordType ? `patient.files.extract.record.types.${record.recordType}` : null;
    const facts = [
        [
            'recordType',
            typeKey ? has(typeKey) ? t(typeKey) : record.recordType : ''
        ],
        [
            'facility',
            record?.facility || ''
        ],
        [
            'admissionDate',
            record?.admissionDate ? (0, $hRWhk.formatDocDate)(record.admissionDate, formatDate) : ''
        ],
        [
            'dischargeDate',
            record?.dischargeDate ? (0, $hRWhk.formatDocDate)(record.dischargeDate, formatDate) : ''
        ],
        [
            'followUp',
            record?.followUp || ''
        ]
    ].filter(([, v])=>v);
    const toggleDx = (i, checked)=>set({
            pickedDiagnoses: checked ? [
                ...new Set([
                    ...draft.pickedDiagnoses,
                    i
                ])
            ] : draft.pickedDiagnoses.filter((x)=>x !== i)
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "medical-record-editor",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem'
        }
    }, facts.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("dl", {
        "data-testid": "record-facts",
        style: {
            margin: 0,
            display: 'grid',
            gridTemplateColumns: 'auto 1fr',
            gap: '0.25rem 0.75rem',
            fontSize: '0.75rem'
        }
    }, facts.map(([k, v])=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
            key: k
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("dt", {
            style: {
                color: (0, $jTCZr.CT).mute
            }
        }, t(`patient.files.extract.record.${k}`)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("dd", {
            style: {
                margin: 0,
                color: (0, $jTCZr.CT).ink
            },
            dir: "auto"
        }, v)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eFS97.default), {
        draft: draft.report,
        onChange: (report)=>set({
                report: report
            }),
        canWriteNote: canWriteNote,
        compact: compact,
        disabled: disabled,
        sectionKeys: $48e3b9f1b8c2cc26$export$5989ba6500cbc848,
        showMeta: false,
        testid: "record-sections-editor"
    }), procedures.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lxEfx.default), {
        title: t('patient.files.extract.record.procedures')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        "data-testid": "record-procedures",
        style: {
            margin: 0,
            paddingInlineStart: '1.125rem',
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).ink2,
            lineHeight: 1.9
        }
    }, procedures.map((p, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: i,
            dir: "auto"
        }, p.text, p.date ? ` \u{2014} ${p.date}` : '')))), diagnoses.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "record-diagnoses",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.375rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.71875rem',
            color: (0, $jTCZr.CT).mute
        }
    }, t('patient.files.extract.record.diagnosesHint')), diagnoses.map((d, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: '0.125rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.375rem',
                flexWrap: 'wrap'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9gEOi.default), {
            checked: draft.pickedDiagnoses.includes(i),
            onChange: (v)=>toggleDx(i, typeof v === 'boolean' ? v : Boolean(v?.target?.checked)),
            label: t('patient.files.extract.diagnosisOption', {
                name: d.icd10Hint ? `${d.text} (${d.icd10Hint})` : d.text
            }),
            disabled: disabled,
            "data-testid": `record-dx-${i}`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hm7Q7.EvidenceChips), {
            item: d,
            testid: `record-dx-${i}`
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hm7Q7.SourceSnippet), {
            text: d.sourceText,
            testid: `record-dx-source-${i}`
        })))), draft.medications.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9gEOi.default), {
        checked: draft.includeMedications,
        onChange: (v)=>set({
                includeMedications: typeof v === 'boolean' ? v : Boolean(v?.target?.checked)
            }),
        label: t('patient.files.extract.record.includeMedications', {
            count: formatNumber(draft.medications.length)
        }),
        disabled: disabled,
        "data-testid": "record-include-meds"
    }), (draft.includeMedications || visitRx) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1Zgj3.default), {
        rows: draft.medications,
        onRowsChange: (medications)=>set({
                medications: medications
            }),
        flags: flags,
        flagPrefix: "record.medications",
        compact: compact,
        disabled: disabled,
        testid: "record-meds",
        visitRx: visitRx,
        recordable: draft.includeMedications
    })));
}

});


parcelRegister("gQlnS", function(module, exports) {

$parcel$export(module.exports, "default", () => $96636c9b1990d1e6$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $lxEfx = parcelRequire("lxEfx");
var $7gSBD = parcelRequire("7gSBD");
var $fYgeo = parcelRequire("fYgeo");
var $66joL = parcelRequire("66joL");
var $gCvEY = parcelRequire("gCvEY");

var $jTCZr = parcelRequire("jTCZr");

var $ftsGP = parcelRequire("ftsGP");
var $98711 = parcelRequire("98711");
var $ltuDQ = parcelRequire("ltuDQ");
var $6ivsH = parcelRequire("6ivsH");
var $6bOwI = parcelRequire("6bOwI");
var $1m5zA = parcelRequire("1m5zA");
var $4gxLI = parcelRequire("4gxLI");
var $iDwyV = parcelRequire("iDwyV");
var $bF8pu = parcelRequire("bF8pu");
var $8DISS = parcelRequire("8DISS");
var $3Yjlx = parcelRequire("3Yjlx");
var $iO3Ob = parcelRequire("iO3Ob");
var $47abO = parcelRequire("47abO");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $eVM84 = parcelRequire("eVM84");

var $j7Lry = parcelRequire("j7Lry");

var $7sS0P = parcelRequire("7sS0P");

var $dLdf9 = parcelRequire("dLdf9");

var $eARX3 = parcelRequire("eARX3");

var $a4gAe = parcelRequire("a4gAe");

var $d6Clo = parcelRequire("d6Clo");

var $cmmZD = parcelRequire("cmmZD");

// The full DICOM viewer — doctor desktop only (§8.9.1, R-C6).
//
// A kit `TaskOverlay` at `xl` (its desktop half is the framed Dialog), so the Visit
// page stays mounted underneath and its timer and recording carry on. It is one of
// the overlays `useClinicalFiles` owns: nothing else is open while it is.
//
// Cornerstone is heavy (WASM codecs, workers), so the viewer is a lazy chunk loaded
// with this overlay and never imported by a phone route — the phone gets the
// server-rendered `RenderedStudySheet` instead.
//
// Keyboard (recorded in docs/APP-SPEC.md): ↑/↓ and PageUp/PageDown step frames,
// ←/→ step series, W window/level, Z zoom, P pan, L length, A angle, R reset,
// I invert, Space cine, Esc closes (the overlay's own). Bound on the overlay's own
// element — focus is trapped inside it while it is open, so the keys exist exactly
// as long as the viewer does, with no global listener. Bare digits are never bound
// (DESKTOP_WEB §5), so presets are chosen with the segmented control.
const $96636c9b1990d1e6$var$DicomViewer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).lazy(()=>(parcelRequire("gDDAu")));
const $96636c9b1990d1e6$var$TOOLS = [
    {
        id: 'windowLevel',
        icon: (0, $ftsGP.default),
        key: 'w'
    },
    {
        id: 'zoom',
        icon: (0, $47abO.default),
        key: 'z'
    },
    {
        id: 'pan',
        icon: (0, $6bOwI.default),
        key: 'p'
    },
    {
        id: 'length',
        icon: (0, $8DISS.default),
        key: 'l'
    },
    {
        id: 'angle',
        icon: (0, $iO3Ob.default),
        key: 'a'
    }
];
const $96636c9b1990d1e6$var$CINE_FPS = 15;
function $96636c9b1990d1e6$var$ViewerSkeleton() {
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonRegion), {
        label: t('patient.files.loadingDicom'),
        "data-testid": "dicom-viewer-loading",
        style: {
            display: 'grid',
            gridTemplateColumns: '9rem 1fr',
            gap: '0.75rem',
            height: '100%'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem'
        }
    }, [
        1,
        2,
        3
    ].map((i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
            key: i,
            width: "100%",
            height: 88,
            radius: (0, $7sS0P.RADIUS).control
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: "100%",
        height: "100%",
        radius: (0, $7sS0P.RADIUS).card,
        tone: "onDark"
    }));
}
function $96636c9b1990d1e6$export$2e2bcd8739ae039({ open: open, file: file, patient: patient, onClose: onClose, onConfirmIdentity: onConfirmIdentity, confirming: confirming = false }) {
    const { t: t, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const study = file?.dicom || null;
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        status: 'loading',
        viewer: null
    });
    const [attempt, setAttempt] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    const [seriesIndex, setSeriesIndex] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    const [tool, setTool] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('windowLevel');
    const [presetId, setPresetId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('auto');
    const [frame, setFrame] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        index: 0,
        total: 0
    });
    const [cine, setCine] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const apiRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open || !file?.id) return undefined;
        let cancelled = false;
        setState({
            status: 'loading',
            viewer: null
        });
        (0, $eVM84.bffQuery)((0, $j7Lry.DICOM_STUDY_VIEWER), {
            fileId: file.id
        }).then((d)=>{
            if (cancelled) return;
            const viewer = d?.dicomStudyViewer || null;
            setState({
                status: viewer?.series?.length ? 'content' : 'empty',
                viewer: viewer
            });
            setSeriesIndex(0);
        }).catch((error)=>{
            if (!cancelled) setState({
                status: 'error',
                viewer: null,
                error: error
            });
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        open,
        file?.id,
        attempt
    ]);
    const seriesList = state.viewer?.series || [];
    const active = seriesList[seriesIndex] || null;
    const presets = (0, $eARX3.presetsForModality)(active?.modality);
    // A new series starts from its own defaults.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setPresetId('auto');
        setCine(false);
        setFrame({
            index: 0,
            total: 0
        });
    }, [
        active?.seriesUid
    ]);
    // Focus lands inside the viewer so its keys work at once.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (open && state.status === 'content') frameRef.current?.focus?.();
    }, [
        open,
        state.status
    ]);
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>active && state.viewer ? {
            dicomWebRoot: (0, $eARX3.dicomWebRoot)(),
            studyInstanceUid: state.viewer.studyUid,
            seriesInstanceUid: active.seriesUid,
            // Instances that predate the rendering engine are read whole, by id.
            fallbackInstances: (active.instances || []).map((inst)=>({
                    url: `${(0, $a4gAe.bffOrigin)()}/wado/instances/${encodeURIComponent(inst.instanceId)}`,
                    instanceNumber: inst.number ?? 0
                }))
        } : null, [
        active,
        state.viewer
    ]);
    const api = ()=>apiRef.current;
    const chooseTool = (id)=>{
        setTool(id);
        api()?.setTool(id);
    };
    const choosePreset = (id)=>{
        setPresetId(id);
        const p = presets.find((x)=>x.id === id);
        api()?.setWindow(p?.center ?? null, p?.width ?? null);
    };
    const toggleCine = ()=>{
        const next = !cine;
        setCine(next);
        api()?.setCine(next, $96636c9b1990d1e6$var$CINE_FPS);
    };
    const stepSeries = (delta)=>{
        if (!seriesList.length) return;
        setSeriesIndex((i)=>Math.max(0, Math.min(seriesList.length - 1, i + delta)));
    };
    const onKeyDown = (e)=>{
        if (e.ctrlKey || e.metaKey || e.altKey) return;
        if (e.target?.closest?.('input, textarea, select')) return;
        const key = e.key.length === 1 ? e.key.toLowerCase() : e.key;
        const rtl = typeof document !== 'undefined' && document.documentElement.dir === 'rtl';
        const handled = {
            ArrowUp: ()=>api()?.step(-1),
            PageUp: ()=>api()?.step(-1),
            ArrowDown: ()=>api()?.step(1),
            PageDown: ()=>api()?.step(1),
            // The series rail reads in the page's direction.
            ArrowLeft: ()=>stepSeries(rtl ? 1 : -1),
            ArrowRight: ()=>stepSeries(rtl ? -1 : 1),
            r: ()=>api()?.reset(),
            i: ()=>api()?.toggleInvert(),
            ' ': toggleCine,
            ...Object.fromEntries($96636c9b1990d1e6$var$TOOLS.map((tl)=>[
                    tl.key,
                    ()=>chooseTool(tl.id)
                ]))
        }[key];
        if (!handled) return;
        e.preventDefault();
        e.stopPropagation();
        handled();
    };
    const toolButton = ({ id: id, icon: Icon, label: label, onClick: onClick, pressed: pressed, testid: testid })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            key: id,
            variant: pressed ? 'subtle' : 'ghost',
            size: "icon",
            className: "h-9 w-9",
            onClick: onClick,
            "aria-label": label,
            title: label,
            "aria-pressed": pressed === undefined ? undefined : pressed,
            "data-testid": testid
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
            size: 16,
            "aria-hidden": true
        }));
    const toolbar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "dicom-viewer-toolbar",
        role: "toolbar",
        "aria-label": t('patient.files.dicom.viewer.toolbar'),
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.25rem',
            flexWrap: 'wrap'
        }
    }, $96636c9b1990d1e6$var$TOOLS.map((tl)=>toolButton({
            id: tl.id,
            icon: tl.icon,
            label: t(`patient.files.dicom.viewer.tools.${tl.id}`),
            onClick: ()=>chooseTool(tl.id),
            pressed: tool === tl.id,
            testid: `dicom-viewer-tool-${tl.id}`
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true,
        style: {
            width: 1,
            alignSelf: 'stretch',
            background: (0, $jTCZr.CT).border,
            marginInline: '0.25rem'
        }
    }), toolButton({
        id: 'reset',
        icon: (0, $iDwyV.default),
        label: t('patient.files.dicom.viewer.tools.reset'),
        onClick: ()=>api()?.reset(),
        testid: 'dicom-viewer-reset'
    }), toolButton({
        id: 'invert',
        icon: (0, $3Yjlx.default),
        label: t('patient.files.dicom.viewer.tools.invert'),
        onClick: ()=>api()?.toggleInvert(),
        testid: 'dicom-viewer-invert'
    }), toolButton({
        id: 'rotate',
        icon: (0, $bF8pu.default),
        label: t('patient.files.dicom.viewer.tools.rotate'),
        onClick: ()=>api()?.rotate(),
        testid: 'dicom-viewer-rotate'
    }), toolButton({
        id: 'flip',
        icon: (0, $98711.default),
        label: t('patient.files.dicom.viewer.tools.flip'),
        onClick: ()=>api()?.flip(),
        testid: 'dicom-viewer-flip'
    }), toolButton({
        id: 'cine',
        icon: cine ? (0, $1m5zA.default) : (0, $4gxLI.default),
        label: t(cine ? 'patient.files.dicom.viewer.tools.pause' : 'patient.files.dicom.viewer.tools.play'),
        onClick: toggleCine,
        pressed: cine,
        testid: 'dicom-viewer-cine'
    }), toolButton({
        id: 'fullscreen',
        icon: (0, $6ivsH.default),
        label: t('patient.files.dicom.viewer.tools.fullscreen'),
        onClick: ()=>frameRef.current?.requestFullscreen?.(),
        testid: 'dicom-viewer-fullscreen'
    }), presets.length > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginInlineStart: 'auto'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fYgeo.default), {
        semantics: "filter",
        ariaLabel: t('patient.files.dicom.viewer.presets'),
        value: presetId,
        onChange: choosePreset,
        options: presets.map((p)=>({
                value: p.id,
                label: t(`patient.files.dicom.presets.${p.id}`)
            })),
        "data-testid": "dicom-viewer-presets"
    })));
    const rail = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("nav", {
        "aria-label": t('patient.files.dicom.viewer.series'),
        "data-testid": "dicom-viewer-series",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem',
            overflowY: 'auto',
            minHeight: 0
        }
    }, seriesList.map((s, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            key: s.seriesUid,
            variant: i === seriesIndex ? 'subtle' : 'ghost',
            onClick: ()=>setSeriesIndex(i),
            "aria-current": i === seriesIndex ? 'true' : undefined,
            "data-testid": `dicom-viewer-series-${i}`,
            className: "h-auto w-full flex-col items-stretch gap-1 p-1.5 font-normal"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d6Clo.default), {
            study: {
                studyUid: state.viewer.studyUid,
                rendered: state.viewer.rendered
            },
            seriesUid: s.seriesUid,
            modality: s.modality,
            size: "100%",
            testid: `dicom-viewer-series-thumb-${i}`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.25rem',
                fontSize: '0.6875rem',
                color: (0, $jTCZr.CT).ink2
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cmmZD.ModalityChip), {
            modality: s.modality,
            testid: `dicom-viewer-series-modality-${i}`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, t('patient.files.dicom.imageCount', {
            count: formatNumber((s.instances || []).reduce((n, x)=>n + (x.frames || 1), 0))
        }))), s.description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "auto",
            style: {
                fontSize: '0.6875rem',
                color: (0, $jTCZr.CT).mute,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            }
        }, s.description))));
    let body;
    if (state.status === 'loading') body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($96636c9b1990d1e6$var$ViewerSkeleton, null);
    else if (state.status === 'error') body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "dicom-viewer-error",
        "data-state": "error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dLdf9.default), {
        error: state.error,
        title: t('patient.files.dicomLoadFailed'),
        onRetry: ()=>setAttempt((n)=>n + 1)
    }));
    else if (state.status === 'empty') body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        "data-testid": "dicom-viewer-empty",
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ltuDQ.default), {
            size: 40,
            strokeWidth: 1.5,
            color: (0, $jTCZr.CT).mute,
            "aria-hidden": true
        }),
        title: t('patient.files.dicom.viewer.empty')
    });
    else body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'grid',
            gridTemplateColumns: '9rem minmax(0, 1fr) minmax(12rem, 16rem)',
            gap: '0.75rem',
            height: 'min(72vh, 46rem)',
            minHeight: 0
        }
    }, rail, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem',
            minHeight: 0
        }
    }, toolbar, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: frameRef,
        tabIndex: -1,
        onKeyDown: onKeyDown,
        "data-testid": "dicom-viewer-stage",
        style: {
            position: 'relative',
            flex: 1,
            minHeight: 0,
            background: (0, $jTCZr.CT).ink,
            borderRadius: (0, $7sS0P.RADIUS).card,
            overflow: 'hidden',
            outline: 'none'
        }
    }, source && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
            width: "100%",
            height: "100%",
            radius: 0,
            tone: "onDark"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($96636c9b1990d1e6$var$DicomViewer, {
        key: active.seriesUid,
        source: source,
        height: "100%",
        onReady: (viewerApi)=>{
            apiRef.current = viewerApi;
            viewerApi.setTool(tool);
        },
        onFrameChange: (index, total)=>setFrame({
                index: index,
                total: total
            })
    })), frame.total > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "dicom-viewer-frame",
        "aria-live": "polite",
        style: {
            position: 'absolute',
            insetBlockStart: '0.5rem',
            insetInlineStart: '0.5rem',
            padding: '0.125rem 0.5rem',
            borderRadius: (0, $7sS0P.RADIUS).chip,
            background: (0, $jTCZr.CT).surface,
            color: (0, $jTCZr.CT).ink,
            fontSize: '0.6875rem',
            fontWeight: 600
        }
    }, t('patient.files.dicom.viewer.frame', {
        index: formatNumber(frame.index + 1),
        total: formatNumber(frame.total)
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            overflowY: 'auto',
            minHeight: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lxEfx.default), {
        title: t('patient.files.dicom.viewer.metadata'),
        defaultOpen: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cmmZD.DicomMetadata), {
        study: study
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gCvEY.default), {
        open: open,
        onClose: onClose,
        title: study?.description || file?.fileName || t('patient.files.dicomStudy'),
        header: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: '0.5rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cmmZD.IdentityAlert), {
            file: file,
            patient: patient,
            onConfirm: onConfirmIdentity,
            confirming: confirming,
            testid: "dicom-viewer-identity"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cmmZD.LossyAlert), {
            study: active ? {
                lossySource: active.lossy || study?.lossySource
            } : study,
            testid: "dicom-viewer-lossy"
        })),
        size: "xl",
        isMobile: false,
        closeLabel: t('common.actions.close'),
        "data-testid": "dicom-viewer-overlay"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-state": state.status
    }, body));
}

});
parcelRegister("ftsGP", function(module, exports) {

$parcel$export(module.exports, "default", () => $a92bbd74876a0a00$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $a92bbd74876a0a00$export$a2387ed3b5d536eb = {
    name: "contrast",
    size: 24,
    node: [
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                r: "10",
                key: "1mglay"
            }
        ],
        [
            "path",
            {
                d: "M12 18a6 6 0 0 0 0-12v12z",
                key: "j4l70d"
            }
        ]
    ]
};
$a92bbd74876a0a00$export$a2387ed3b5d536eb.node;
const $a92bbd74876a0a00$export$2e2bcd8739ae039 = (0, $9QBug.default)($a92bbd74876a0a00$export$a2387ed3b5d536eb);

});

parcelRegister("98711", function(module, exports) {

$parcel$export(module.exports, "default", () => $484a5b076ae10f4a$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $484a5b076ae10f4a$export$a2387ed3b5d536eb = {
    name: "triangles-centerline-dashed-horizontal",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M10 12H8",
                key: "s88cx1"
            }
        ],
        [
            "path",
            {
                d: "M16 12h-2",
                key: "10asgb"
            }
        ],
        [
            "path",
            {
                d: "M22 12h-2",
                key: "14jgyd"
            }
        ],
        [
            "path",
            {
                d: "M4 12H2",
                key: "rhcxmi"
            }
        ],
        [
            "path",
            {
                d: "M7.298 20.288A1 1 0 008 22h8a1 1 0 00.703-1.712l-3.991-3.99a1 1 0 00-1.424-.001z",
                key: "15ue1v"
            }
        ],
        [
            "path",
            {
                d: "M7.298 3.712A1 1 0 018 2h8a1 1 0 01.703 1.712l-3.991 3.99a1 1 0 01-1.424.001z",
                key: "lzh03e"
            }
        ]
    ],
    aliases: [
        "flip-horizontal-2"
    ]
};
$484a5b076ae10f4a$export$a2387ed3b5d536eb.node;
const $484a5b076ae10f4a$export$2e2bcd8739ae039 = (0, $9QBug.default)($484a5b076ae10f4a$export$a2387ed3b5d536eb);

});

parcelRegister("ltuDQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc10787427ff9cd4$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $cc10787427ff9cd4$export$a2387ed3b5d536eb = {
    name: "layers",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z",
                key: "zw3jo"
            }
        ],
        [
            "path",
            {
                d: "M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12",
                key: "1wduqc"
            }
        ],
        [
            "path",
            {
                d: "M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17",
                key: "kqbvx6"
            }
        ]
    ],
    aliases: [
        "layers-3"
    ]
};
$cc10787427ff9cd4$export$a2387ed3b5d536eb.node;
const $cc10787427ff9cd4$export$2e2bcd8739ae039 = (0, $9QBug.default)($cc10787427ff9cd4$export$a2387ed3b5d536eb);

});

parcelRegister("6bOwI", function(module, exports) {

$parcel$export(module.exports, "default", () => $754dfea6cb717fed$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $754dfea6cb717fed$export$a2387ed3b5d536eb = {
    name: "move",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M12 2v20",
                key: "t6zp3m"
            }
        ],
        [
            "path",
            {
                d: "m15 19-3 3-3-3",
                key: "11eu04"
            }
        ],
        [
            "path",
            {
                d: "m19 9 3 3-3 3",
                key: "1mg7y2"
            }
        ],
        [
            "path",
            {
                d: "M2 12h20",
                key: "9i4pu4"
            }
        ],
        [
            "path",
            {
                d: "m5 9-3 3 3 3",
                key: "j64kie"
            }
        ],
        [
            "path",
            {
                d: "m9 5 3-3 3 3",
                key: "l8vdw6"
            }
        ]
    ]
};
$754dfea6cb717fed$export$a2387ed3b5d536eb.node;
const $754dfea6cb717fed$export$2e2bcd8739ae039 = (0, $9QBug.default)($754dfea6cb717fed$export$a2387ed3b5d536eb);

});

parcelRegister("1m5zA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0ad648fb4fb7066$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $c0ad648fb4fb7066$export$a2387ed3b5d536eb = {
    name: "pause",
    size: 24,
    node: [
        [
            "rect",
            {
                x: "14",
                y: "3",
                width: "5",
                height: "18",
                rx: "1",
                key: "kaeet6"
            }
        ],
        [
            "rect",
            {
                x: "5",
                y: "3",
                width: "5",
                height: "18",
                rx: "1",
                key: "1wsw3u"
            }
        ]
    ]
};
$c0ad648fb4fb7066$export$a2387ed3b5d536eb.node;
const $c0ad648fb4fb7066$export$2e2bcd8739ae039 = (0, $9QBug.default)($c0ad648fb4fb7066$export$a2387ed3b5d536eb);

});

parcelRegister("8DISS", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4c2dda478a7569e$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $e4c2dda478a7569e$export$a2387ed3b5d536eb = {
    name: "ruler",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M21.3 15.3a2.4 2.4 0 0 1 0 3.4l-2.6 2.6a2.4 2.4 0 0 1-3.4 0L2.7 8.7a2.41 2.41 0 0 1 0-3.4l2.6-2.6a2.41 2.41 0 0 1 3.4 0Z",
                key: "icamh8"
            }
        ],
        [
            "path",
            {
                d: "m14.5 12.5 2-2",
                key: "inckbg"
            }
        ],
        [
            "path",
            {
                d: "m11.5 9.5 2-2",
                key: "fmmyf7"
            }
        ],
        [
            "path",
            {
                d: "m8.5 6.5 2-2",
                key: "vc6u1g"
            }
        ],
        [
            "path",
            {
                d: "m17.5 15.5 2-2",
                key: "wo5hmg"
            }
        ]
    ]
};
$e4c2dda478a7569e$export$a2387ed3b5d536eb.node;
const $e4c2dda478a7569e$export$2e2bcd8739ae039 = (0, $9QBug.default)($e4c2dda478a7569e$export$a2387ed3b5d536eb);

});

parcelRegister("3Yjlx", function(module, exports) {

$parcel$export(module.exports, "default", () => $c569109e8b7be3a9$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $c569109e8b7be3a9$export$a2387ed3b5d536eb = {
    name: "sun-moon",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M12 2v2",
                key: "tus03m"
            }
        ],
        [
            "path",
            {
                d: "M14.837 16.385a6 6 0 1 1-7.223-7.222c.624-.147.97.66.715 1.248a4 4 0 0 0 5.26 5.259c.589-.255 1.396.09 1.248.715",
                key: "xlf6rm"
            }
        ],
        [
            "path",
            {
                d: "M16 12a4 4 0 0 0-4-4",
                key: "6vsxu"
            }
        ],
        [
            "path",
            {
                d: "m19 5-1.256 1.256",
                key: "1yg6a6"
            }
        ],
        [
            "path",
            {
                d: "M20 12h2",
                key: "1q8mjw"
            }
        ]
    ]
};
$c569109e8b7be3a9$export$a2387ed3b5d536eb.node;
const $c569109e8b7be3a9$export$2e2bcd8739ae039 = (0, $9QBug.default)($c569109e8b7be3a9$export$a2387ed3b5d536eb);

});

parcelRegister("iO3Ob", function(module, exports) {

$parcel$export(module.exports, "default", () => $727bbd7113825529$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $727bbd7113825529$export$a2387ed3b5d536eb = {
    name: "triangle",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M13.73 4a2 2 0 0 0-3.46 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z",
                key: "14u9p9"
            }
        ]
    ]
};
$727bbd7113825529$export$a2387ed3b5d536eb.node;
const $727bbd7113825529$export$2e2bcd8739ae039 = (0, $9QBug.default)($727bbd7113825529$export$a2387ed3b5d536eb);

});

parcelRegister("gDDAu", function(module, exports) {
module.exports = import("eYTu9").then(()=>parcelRequire('eNok6'));

});


parcelRegister("cTsk0", function(module, exports) {

$parcel$export(module.exports, "default", () => $39e00aa6827caf22$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $cZOyb = parcelRequire("cZOyb");
var $7gSBD = parcelRequire("7gSBD");
var $bhQd4 = parcelRequire("bhQd4");
var $66joL = parcelRequire("66joL");

var $jTCZr = parcelRequire("jTCZr");

var $16WeC = parcelRequire("16WeC");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $eVM84 = parcelRequire("eVM84");

var $j7Lry = parcelRequire("j7Lry");

var $dLdf9 = parcelRequire("dLdf9");

var $eARX3 = parcelRequire("eARX3");

var $cmmZD = parcelRequire("cmmZD");
// A study on the phone — server-rendered frames in the kit's `ImageStackViewer`
// (§8.9.2, R-C6). The diagnostic viewer is a desktop tool and is never loaded here.
//
// Every frame is fetched through the BFF's per-study-authorised `/rendered` proxy
// with the token in a header, handed to the kit as an object URL, and revoked by the
// kit's `revokeFrame` the moment it leaves the preload window. Window presets are
// rendered by the SERVER, so a preset change is a new set of frames.
//
// A full-height `BottomSheet` — it owns the screen and its history entry.
const $39e00aa6827caf22$var$RENDER_SIZE = 1024;
function $39e00aa6827caf22$export$2e2bcd8739ae039({ open: open, file: file, patient: patient, onClose: onClose }) {
    const { t: t, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        status: 'loading',
        viewer: null
    });
    const [attempt, setAttempt] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    const [seriesId, setSeriesId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [presetId, setPresetId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('auto');
    const [index, setIndex] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open || !file?.id) return undefined;
        let cancelled = false;
        setState({
            status: 'loading',
            viewer: null
        });
        (0, $eVM84.bffQuery)((0, $j7Lry.DICOM_STUDY_VIEWER), {
            fileId: file.id
        }).then((d)=>{
            if (cancelled) return;
            const viewer = d?.dicomStudyViewer || null;
            const status = !viewer?.series?.length ? 'empty' : viewer.rendered === false ? 'unavailable' : 'content';
            setState({
                status: status,
                viewer: viewer
            });
            setSeriesId(viewer?.series?.[0]?.seriesUid || null);
        }).catch((error)=>{
            if (!cancelled) setState({
                status: 'error',
                viewer: null,
                error: error
            });
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        open,
        file?.id,
        attempt
    ]);
    const viewer = state.viewer;
    const series = viewer?.series?.find((s)=>s.seriesUid === seriesId) || viewer?.series?.[0] || null;
    const frames = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $eARX3.framesOf)(series), [
        series
    ]);
    const presets = (0, $eARX3.presetsForModality)(series?.modality);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setIndex(0);
        setPresetId('auto');
    }, [
        series?.seriesUid
    ]);
    const loadFrame = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((i, { signal: signal } = {})=>{
        const f = frames[i];
        if (!f || !viewer) return Promise.reject(new Error('no frame'));
        const url = (0, $eARX3.renderedUrl)(viewer.studyUid, series.seriesUid, f.sopUid, {
            frame: f.frame,
            window: (0, $eARX3.presetWindow)(presetId, series.modality),
            size: $39e00aa6827caf22$var$RENDER_SIZE
        });
        return (0, $eARX3.fetchObjectUrl)(url, {
            signal: signal
        });
    }, [
        frames,
        viewer,
        series,
        presetId
    ]);
    const revokeFrame = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((url)=>{
        try {
            URL.revokeObjectURL(url);
        } catch  {}
    }, []);
    const labels = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
            frame: (i, n)=>t('patient.files.dicom.viewer.frame', {
                    index: formatNumber(i),
                    total: formatNumber(n)
                }),
            prev: t('patient.files.dicom.stack.prev'),
            next: t('patient.files.dicom.stack.next'),
            slider: t('patient.files.dicom.stack.slider'),
            zoomIn: t('patient.files.dicom.stack.zoomIn'),
            zoomOut: t('patient.files.dicom.stack.zoomOut'),
            reset: t('patient.files.dicom.stack.reset'),
            series: t('patient.files.dicom.viewer.series'),
            presets: t('patient.files.dicom.viewer.presets'),
            viewport: t('patient.files.dicom.stack.viewport'),
            loading: t('patient.files.dicom.stack.loading'),
            error: t('patient.files.dicom.stack.error'),
            retry: t('common.actions.retry'),
            empty: t('patient.files.dicom.viewer.empty')
        }), [
        t,
        formatNumber
    ]);
    const study = file?.dicom || null;
    let body;
    if (state.status === 'loading') body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonRegion), {
        label: t('patient.files.loadingDicom'),
        "data-testid": "rendered-study-loading",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: "100%",
        height: "55dvh",
        radius: 12,
        tone: "onDark"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: "100%",
        height: 36,
        radius: 8
    }));
    else if (state.status === 'error') body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "rendered-study-error",
        "data-state": "error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dLdf9.default), {
        error: state.error,
        title: t('patient.files.dicomLoadFailed'),
        onRetry: ()=>setAttempt((n)=>n + 1)
    }));
    else if (state.status === 'unavailable' || state.status === 'empty') body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        "data-testid": `rendered-study-${state.status}`,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $16WeC.default), {
            size: 40,
            strokeWidth: 1.5,
            color: (0, $jTCZr.CT).mute,
            "aria-hidden": true
        }),
        title: t(state.status === 'unavailable' ? 'patient.files.dicom.stack.unavailable' : 'patient.files.dicom.viewer.empty')
    });
    else body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bhQd4.default), {
        frameCount: frames.length,
        index: index,
        onIndexChange: setIndex,
        loadFrame: loadFrame,
        revokeFrame: revokeFrame,
        preloadRadius: 5,
        sourceKey: `${series?.seriesUid}:${presetId}`,
        series: (viewer.series || []).map((s)=>({
                id: s.seriesUid,
                label: s.description || t('patient.files.dicom.seriesNumber', {
                    number: formatNumber(s.number ?? 0)
                }),
                badge: s.modality || undefined
            })),
        activeSeriesId: series?.seriesUid,
        onSeriesChange: setSeriesId,
        presets: presets.length > 1 ? presets.map((p)=>({
                id: p.id,
                label: t(`patient.files.dicom.presets.${p.id}`)
            })) : undefined,
        activePresetId: presetId,
        onPresetChange: setPresetId,
        caption: t('patient.files.dicom.stack.caption'),
        banner: series?.lossy || study?.lossySource ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cmmZD.LossyAlert), {
            study: {
                lossySource: true
            },
            testid: "rendered-study-lossy"
        }) : null,
        labels: labels,
        "data-testid": "rendered-study-stack"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: open,
        onClose: onClose,
        title: study?.description || file?.fileName || t('patient.files.dicomStudy'),
        fullHeight: true,
        snap: 1,
        closeLabel: t('common.actions.close'),
        "data-testid": "rendered-study-sheet"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-state": state.status,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cmmZD.IdentityAlert), {
        file: file,
        patient: patient,
        testid: "rendered-study-identity"
    }), body));
}

});
parcelRegister("16WeC", function(module, exports) {

$parcel$export(module.exports, "default", () => $3237de5b7cdbe550$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $3237de5b7cdbe550$export$a2387ed3b5d536eb = {
    name: "image-off",
    size: 24,
    node: [
        [
            "line",
            {
                x1: "2",
                x2: "22",
                y1: "2",
                y2: "22",
                key: "a6p6uj"
            }
        ],
        [
            "path",
            {
                d: "M10.41 10.41a2 2 0 1 1-2.83-2.83",
                key: "1bzlo9"
            }
        ],
        [
            "line",
            {
                x1: "13.5",
                x2: "6",
                y1: "13.5",
                y2: "21",
                key: "1q0aeu"
            }
        ],
        [
            "line",
            {
                x1: "18",
                x2: "21",
                y1: "12",
                y2: "15",
                key: "5mozeu"
            }
        ],
        [
            "path",
            {
                d: "M3.59 3.59A1.99 1.99 0 0 0 3 5v14a2 2 0 0 0 2 2h14c.55 0 1.052-.22 1.41-.59",
                key: "mmje98"
            }
        ],
        [
            "path",
            {
                d: "M21 15V5a2 2 0 0 0-2-2H9",
                key: "43el77"
            }
        ]
    ]
};
$3237de5b7cdbe550$export$a2387ed3b5d536eb.node;
const $3237de5b7cdbe550$export$2e2bcd8739ae039 = (0, $9QBug.default)($3237de5b7cdbe550$export$a2387ed3b5d536eb);

});


parcelRegister("zi6VT", function(module, exports) {

$parcel$export(module.exports, "fileKey", () => $8f9df774fdbf117f$export$ffad0796900cb77b);
$parcel$export(module.exports, "useGalleryKeys", () => $8f9df774fdbf117f$export$a9a61ad1d840765a);
$parcel$export(module.exports, "revealTile", () => $8f9df774fdbf117f$export$924230e9e05c859f);
$parcel$export(module.exports, "resolveCurrent", () => $8f9df774fdbf117f$export$605d1355e4167591);
$parcel$export(module.exports, "FileGalleryPane", () => $8f9df774fdbf117f$export$73f34145c0b11671);
$parcel$export(module.exports, "FileStrip", () => $8f9df774fdbf117f$export$7ca12f100fb0e59f);
$parcel$export(module.exports, "default", () => $8f9df774fdbf117f$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $5JYPc = parcelRequire("5JYPc");
var $gCvEY = parcelRequire("gCvEY");

var $gKFEi = parcelRequire("gKFEi");
var $kzPvP = parcelRequire("kzPvP");
var $2XwcZ = parcelRequire("2XwcZ");
var $97xXr = parcelRequire("97xXr");
var $9he56 = parcelRequire("9he56");
var $chm1L = parcelRequire("chm1L");
var $lUsTt = parcelRequire("lUsTt");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $gdEay = parcelRequire("gdEay");

var $eARX3 = parcelRequire("eARX3");

var $5WzF8 = parcelRequire("5WzF8");

var $d6Clo = parcelRequire("d6Clo");

var $aMDcZ = parcelRequire("aMDcZ");

var $jGozX = parcelRequire("jGozX");

var $hRWhk = parcelRequire("hRWhk");
const $8f9df774fdbf117f$export$ffad0796900cb77b = (0, $5WzF8.fileBytesKey);
const $8f9df774fdbf117f$var$isTyping = (el)=>{
    const tag = String(el?.tagName || '').toLowerCase();
    return tag === 'input' || tag === 'textarea' || tag === 'select' || el?.isContentEditable;
};
// The direction the doctor SEES at this element — computed in a browser; the nearest
// `dir` where nothing computes it (a test DOM).
function $8f9df774fdbf117f$var$isRtlAt(el) {
    try {
        const computed = window.getComputedStyle(el).direction;
        if (computed) return computed === 'rtl';
    } catch  {}
    return el?.closest?.('[dir]')?.getAttribute('dir') === 'rtl';
}
const $8f9df774fdbf117f$var$indexOf = (files, current)=>Math.max(0, files.findIndex((f)=>$8f9df774fdbf117f$export$ffad0796900cb77b(f) === $8f9df774fdbf117f$export$ffad0796900cb77b(current)));
function $8f9df774fdbf117f$export$a9a61ad1d840765a({ files: files, current: current, onSelect: onSelect }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((e)=>{
        if (e.defaultPrevented || e.altKey || e.ctrlKey || e.metaKey || $8f9df774fdbf117f$var$isTyping(e.target)) return;
        if (![
            'ArrowLeft',
            'ArrowRight',
            'Home',
            'End'
        ].includes(e.key)) return;
        if (!files.length) return;
        const at = $8f9df774fdbf117f$var$indexOf(files, current);
        let to = at;
        if (e.key === 'Home') to = 0;
        else if (e.key === 'End') to = files.length - 1;
        else {
            const forward = $8f9df774fdbf117f$var$isRtlAt(e.currentTarget) ? e.key === 'ArrowLeft' : e.key === 'ArrowRight';
            to = Math.min(files.length - 1, Math.max(0, at + (forward ? 1 : -1)));
        }
        e.preventDefault();
        if (to !== at) onSelect(files[to]);
    }, [
        files,
        current,
        onSelect
    ]);
}
const $8f9df774fdbf117f$var$SWIPE_MIN_PX = 48;
function $8f9df774fdbf117f$export$b2f154a59603898d({ files: files, current: current, onSelect: onSelect }) {
    const start = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const reset = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        start.current = null;
    }, []);
    const onTouchStart = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((e)=>{
        const t = e.touches;
        start.current = t && t.length === 1 ? {
            x: t[0].clientX,
            y: t[0].clientY
        } : null;
    }, []);
    const onTouchMove = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((e)=>{
        if (e.touches && e.touches.length > 1) start.current = null;
    }, []);
    const onTouchEnd = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((e)=>{
        const s = start.current;
        start.current = null;
        const t = e.changedTouches && e.changedTouches[0];
        if (!s || !t || !files.length) return;
        const dx = t.clientX - s.x;
        const dy = t.clientY - s.y;
        if (Math.abs(dx) < $8f9df774fdbf117f$var$SWIPE_MIN_PX || Math.abs(dx) < 1.5 * Math.abs(dy)) return;
        const zoom = typeof window !== 'undefined' && window.visualViewport ? window.visualViewport.scale : 1;
        if (zoom > 1.01) return;
        const forward = $8f9df774fdbf117f$var$isRtlAt(e.currentTarget) ? dx > 0 : dx < 0;
        const at = $8f9df774fdbf117f$var$indexOf(files, current);
        const to = Math.min(files.length - 1, Math.max(0, at + (forward ? 1 : -1)));
        if (to !== at) onSelect(files[to]);
    }, [
        files,
        current,
        onSelect
    ]);
    return {
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd,
        onTouchCancel: reset
    };
}
function $8f9df774fdbf117f$export$924230e9e05c859f(scroller, tile, axis) {
    if (!scroller || !tile) return;
    if (typeof scroller.scrollBy === 'function') {
        const s = scroller.getBoundingClientRect();
        const r = tile.getBoundingClientRect();
        if (axis === 'x') {
            if (r.left < s.left) scroller.scrollBy({
                left: r.left - s.left - 8
            });
            else if (r.right > s.right) scroller.scrollBy({
                left: r.right - s.right + 8
            });
        } else if (r.top < s.top) scroller.scrollBy({
            top: r.top - s.top - 8
        });
        else if (r.bottom > s.bottom) scroller.scrollBy({
            top: r.bottom - s.bottom + 8
        });
    }
    const active = typeof document !== 'undefined' ? document.activeElement : null;
    if (active && active !== tile && scroller.contains(active)) tile.focus({
        preventScroll: true
    });
}
function $8f9df774fdbf117f$export$605d1355e4167591(files, wanted, lastIndexRef) {
    if (!files.length) return null;
    const at = wanted ? files.findIndex((f)=>$8f9df774fdbf117f$export$ffad0796900cb77b(f) === $8f9df774fdbf117f$export$ffad0796900cb77b(wanted)) : -1;
    if (at >= 0) {
        if (lastIndexRef) lastIndexRef.current = at;
        return files[at];
    }
    const i = Math.min(lastIndexRef?.current ?? 0, files.length - 1);
    return files[Math.max(0, i)];
}
function $8f9df774fdbf117f$export$73f34145c0b11671({ files: files, current: current, onSelect: onSelect, onDetail: onDetail, onView: onView, onExtract: onExtract, onDownload: onDownload, onDelete: onDelete, clinicNameOf: clinicNameOf, viewerHeight: viewerHeight = '30rem', isMobile: isMobile = false, testid: testid = 'file-gallery' }) {
    const { t: t, formatDate: formatDate, formatDigits: formatDigits, isRTL: isRTL } = (0, $LNQP4.default)();
    const at = current ? files.findIndex((f)=>$8f9df774fdbf117f$export$ffad0796900cb77b(f) === $8f9df774fdbf117f$export$ffad0796900cb77b(current)) : -1;
    const swipe = $8f9df774fdbf117f$export$b2f154a59603898d({
        files: files,
        current: current,
        onSelect: onSelect
    });
    // The neighbours are read ahead, so «بعدی» shows its document at once.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (at < 0) return;
        [
            files[at + 1],
            files[at - 1]
        ].forEach((f)=>{
            if (f && !(0, $eARX3.isDicomFile)(f)) (0, $5WzF8.prefetchFileBytes)(f);
        });
    }, [
        files,
        at
    ]);
    if (!current) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testid,
        "data-state": "empty",
        className: "p-8 text-center text-[0.8125rem] text-muted-foreground"
    }, t('patient.files.gallery.empty'));
    const study = (0, $eARX3.isDicomFile)(current) ? current.dicom : null;
    const canExtract = Boolean(current.extractable && onExtract && (!study || (0, $eARX3.hasDocumentObjects)(study)));
    const canDownload = Boolean(onDownload) && !study;
    const canDelete = Boolean(current.canDelete && onDelete);
    // The drawer's rule: a study opens where it can be drawn — the diagnostic viewer,
    // or on a phone the server-rendered preview.
    const canViewImages = Boolean(study && onView && (study.viewable || isMobile && study.rendered));
    const date = (0, $gdEay.documentDateOf)(current);
    const clinicName = clinicNameOf && current.clinicId ? clinicNameOf(current.clinicId) : null;
    const PrevIcon = isRTL ? (0, $kzPvP.default) : (0, $gKFEi.default);
    const NextIcon = isRTL ? (0, $gKFEi.default) : (0, $kzPvP.default);
    // The phone's targets are the touch floor (MOBILE_WEB_PWA §5); the workstation's compact.
    const navButton = isMobile ? 'h-11 w-11' : 'h-9 w-9';
    const actionSize = isMobile ? 'default' : 'sm';
    const nav = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $5JYPc.cn)('flex shrink-0 items-center', isMobile ? 'w-full justify-between gap-2' : 'gap-1')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "icon",
        className: navButton,
        "aria-label": t('patient.files.gallery.prev'),
        title: t('patient.files.gallery.prev'),
        disabled: at <= 0,
        onClick: ()=>onSelect(files[at - 1]),
        "data-testid": `${testid}-prev`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(PrevIcon, {
        size: isMobile ? 18 : 16,
        "aria-hidden": true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": `${testid}-position`,
        className: "min-w-[4rem] text-center text-xs text-muted-foreground"
    }, t('patient.files.gallery.position', {
        pos: formatDigits(at + 1),
        total: formatDigits(files.length)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "icon",
        className: navButton,
        "aria-label": t('patient.files.gallery.next'),
        title: t('patient.files.gallery.next'),
        disabled: at >= files.length - 1,
        onClick: ()=>onSelect(files[at + 1]),
        "data-testid": `${testid}-next`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(NextIcon, {
        size: isMobile ? 18 : 16,
        "aria-hidden": true
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
        "aria-label": t('patient.files.gallery.title'),
        "data-testid": testid,
        "data-state": "content",
        "data-current": current.id,
        className: "flex min-w-0 flex-col overflow-hidden rounded-lg border border-border bg-white"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "flex flex-wrap items-center gap-2 border-b border-border px-3.5 py-2.5"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "flex min-w-0 flex-[1_1_14rem] flex-col gap-1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        "data-testid": `${testid}-name`,
        title: current.fileName,
        className: "truncate text-sm font-bold text-foreground [unicode-bidi:isolate]"
    }, current.fileName || t('patient.files.unnamed')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "flex flex-wrap items-center gap-1.5 text-[0.6875rem] text-muted-foreground"
    }, date && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, (0, $hRWhk.formatDocDate)(date, formatDate)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hRWhk.FileFacts), {
        file: current,
        clinicName: clinicName
    }))), !isMobile && nav), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "touch-pan-y touch-pinch-zoom bg-muted p-2.5",
        "data-testid": `${testid}-stage`,
        ...swipe
    }, study ? // The one inline style: the host decides how tall the document may be.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "flex flex-col items-center justify-center gap-3",
        style: {
            height: viewerHeight
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d6Clo.default), {
        study: study,
        size: isMobile ? '10rem' : '14rem',
        testid: `${testid}-dicom`
    }), onView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        onClick: ()=>onView(current),
        disabled: !canViewImages,
        className: "gap-1.5",
        "data-testid": `${testid}-view-images`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9he56.default), {
        size: 14,
        "aria-hidden": true
    }), " ", t('patient.files.dicom.viewImages')), onView && !canViewImages && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "text-center text-[0.6875rem] text-muted-foreground",
        "data-testid": `${testid}-not-viewable`
    }, t('patient.files.dicom.notViewable'))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aMDcZ.default), {
        key: $8f9df774fdbf117f$export$ffad0796900cb77b(current),
        file: current,
        height: viewerHeight,
        testid: `${testid}-viewer`
    })), isMobile && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "border-t border-border px-3 py-2"
    }, nav), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "flex flex-wrap items-center gap-1.5 border-t border-border px-3.5 py-2"
    }, canExtract && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        size: actionSize,
        className: "gap-1.5",
        onClick: ()=>onExtract(current),
        "data-testid": `${testid}-extract`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $chm1L.default), {
        size: 14,
        "aria-hidden": true
    }), " ", t('patient.files.actions.extract')), onDetail && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        size: actionSize,
        variant: "outline",
        className: "gap-1.5",
        onClick: ()=>onDetail(current),
        "data-testid": `${testid}-details`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $97xXr.default), {
        size: 14,
        "aria-hidden": true
    }), " ", t('patient.files.gallery.details')), canDownload && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        size: actionSize,
        variant: "outline",
        className: "gap-1.5",
        onClick: ()=>onDownload(current),
        "data-testid": `${testid}-download`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2XwcZ.default), {
        size: 14,
        "aria-hidden": true
    }), " ", t('patient.files.actions.download')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "flex-1"
    }), !isMobile && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "text-[0.6875rem] text-muted-foreground"
    }, t('patient.files.gallery.keyboardHint')), canDelete && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        size: actionSize,
        variant: "ghost",
        className: "gap-1.5 text-destructive",
        onClick: ()=>onDelete(current),
        "data-testid": `${testid}-delete`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lUsTt.default), {
        size: 14,
        "aria-hidden": true
    }), " ", t('patient.files.actions.delete'))));
}
function $8f9df774fdbf117f$export$7ca12f100fb0e59f({ files: files, current: current, onSelect: onSelect, badgeFor: badgeFor, testid: testid = 'file-strip', tileClassName: tileClassName = 'w-[7.5rem]', className: className }) {
    const { t: t } = (0, $LNQP4.default)();
    const refs = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Map());
    const stripRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const currentKey = current ? $8f9df774fdbf117f$export$ffad0796900cb77b(current) : null;
    // The selection stays in sight along the strip, and focus follows it from a tile.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        $8f9df774fdbf117f$export$924230e9e05c859f(stripRef.current, currentKey && refs.current.get(currentKey), 'x');
    }, [
        currentKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: stripRef,
        role: "group",
        "aria-label": t('patient.files.gallery.strip'),
        "data-testid": testid,
        className: (0, $5JYPc.cn)('flex gap-2 overflow-x-auto pb-1', className)
    }, files.map((f)=>{
        const key = $8f9df774fdbf117f$export$ffad0796900cb77b(f);
        return(// A fixed width that a long file name cannot stretch (min-width: 0).
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: key,
            className: (0, $5JYPc.cn)('min-w-0 shrink-0', tileClassName)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $jGozX.default), {
            file: f,
            compact: true,
            selected: key === currentKey,
            onSelect: onSelect,
            badge: badgeFor ? badgeFor(f) : null,
            testid: `${testid}-tile`,
            buttonRef: (el)=>{
                if (el) refs.current.set(key, el);
                else refs.current.delete(key);
            }
        })));
    }));
}
function $8f9df774fdbf117f$export$144d5d824b3f539b({ open: open, onClose: onClose, files: files, current: current, onSelect: onSelect, isMobile: isMobile, ...actions }) {
    const { t: t } = (0, $LNQP4.default)();
    const lastIndex = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(0);
    const shown = $8f9df774fdbf117f$export$605d1355e4167591(files, current, lastIndex);
    const onKeyDown = $8f9df774fdbf117f$export$a9a61ad1d840765a({
        files: files,
        current: shown,
        onSelect: onSelect
    });
    const bodyRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // The arrow keys must work the moment the gallery opens (a paired keyboard on a
    // phone too), so focus starts on the gallery itself rather than on the ✕.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return undefined;
        const id = setTimeout(()=>bodyRef.current?.focus?.({
                preventScroll: true
            }), 0);
        return ()=>clearTimeout(id);
    }, [
        open
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gCvEY.default), {
        open: open,
        onClose: onClose,
        title: t('patient.files.gallery.title'),
        size: "xl",
        isMobile: isMobile,
        closeLabel: t('common.actions.close'),
        "data-testid": "file-gallery-overlay"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: bodyRef,
        tabIndex: -1,
        onKeyDown: onKeyDown,
        className: "flex flex-col gap-3 outline-none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8f9df774fdbf117f$export$73f34145c0b11671, {
        files: files,
        current: shown,
        onSelect: onSelect,
        // Leaves the strip room inside the dialog, so paging never scrolls it. On a
        // phone the pages take most of the sheet, but never so much that the
        // buttons under them leave a short screen (≈21rem of chrome around them).
        viewerHeight: isMobile ? 'min(52dvh, 30rem, calc(100dvh - 21rem))' : 'min(50vh, 34rem)',
        isMobile: isMobile,
        testid: "file-gallery",
        ...actions
    }), !isMobile && files.length > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8f9df774fdbf117f$export$7ca12f100fb0e59f, {
        files: files,
        current: shown,
        onSelect: onSelect,
        testid: "file-gallery-strip",
        className: "[@media(max-height:35rem)]:hidden"
    })));
}
var $8f9df774fdbf117f$export$2e2bcd8739ae039 = $8f9df774fdbf117f$export$144d5d824b3f539b;

});

parcelRegister("dJNjA", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b640a58c29e336a$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $5JYPc = parcelRequire("5JYPc");
var $4fYdd = parcelRequire("4fYdd");
var $9BgRG = parcelRequire("9BgRG");

var $gKFEi = parcelRequire("gKFEi");
var $kzPvP = parcelRequire("kzPvP");
var $2XwcZ = parcelRequire("2XwcZ");
var $16WeC = parcelRequire("16WeC");
var $97xXr = parcelRequire("97xXr");
var $gXsFl = parcelRequire("gXsFl");
var $9he56 = parcelRequire("9he56");
var $chm1L = parcelRequire("chm1L");
var $lUsTt = parcelRequire("lUsTt");
var $6TdpC = parcelRequire("6TdpC");
var $47abO = parcelRequire("47abO");
var $bU80g = parcelRequire("bU80g");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $1Qo7B = parcelRequire("1Qo7B");

var $gdEay = parcelRequire("gdEay");

var $eARX3 = parcelRequire("eARX3");

var $5WzF8 = parcelRequire("5WzF8");

var $3t8yQ = parcelRequire("3t8yQ");

var $d6Clo = parcelRequire("d6Clo");

var $jGozX = parcelRequire("jGozX");

var $hRWhk = parcelRequire("hRWhk");

var $zi6VT = parcelRequire("zi6VT");

var $041LL = parcelRequire("041LL");
// «نمایش تمام‌صفحه» — the patient's documents on a phone, the way the phone's own
// gallery shows photos (PM-0568).
//
// A tap on a document's tile opens this, and the whole screen is the document: the
// photos follow the finger left and right (under rtl the next one comes in from the
// left, as everywhere in the gallery), two fingers zoom about the spot between them,
// a double tap zooms in on the tapped spot and back, one finger pans a zoomed photo,
// a drag down (or the platform back) closes it, and a single tap hides the bars for
// an unobstructed look. Every gesture duplicates a visible control (MOBILE_WEB_PWA
// §5): «قبلی»/«بعدی», the zoom button and ✕ are always one tap away, and nothing
// destructive ever fires from a gesture — «حذف» asks first.
//
// A document that is not a photo (a PDF, a DICOM study) is a card with its own way
// in, so a swipe through a patient's library never lands on a blank screen.
//
// The shell is the kit Dialog's `fullscreen` layout — the focus trap, Escape, the
// scroll lock and the dialog layer, so the delete confirm stacks above — and the
// viewer joins the history stack itself (DESIGN_SYSTEM §9.5), so back closes it and
// a document's detail opened from it hands back to it. While a finger moves, the
// transforms are written straight to the DOM: a re-render per pointer event would
// stutter on the phones doctors actually carry.
const $3b640a58c29e336a$var$SETTLE_MS = 220;
const $3b640a58c29e336a$var$TAP_MS = 260; // a second tap within this is a double tap
const $3b640a58c29e336a$var$AXIS_LOCK_PX = 8; // how far one finger moves before it is a drag, not a tap
const $3b640a58c29e336a$var$reducedMotion = ()=>{
    try {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch  {
        return false;
    }
};
const $3b640a58c29e336a$var$isControl = (el)=>Boolean(el?.closest?.('button, a, [role="button"], input, select, textarea'));
function $3b640a58c29e336a$var$Slide({ file: file, offset: offset, active: active, zoomRef: zoomRef, imgRef: imgRef, onDetail: onDetail, onView: onView }) {
    const { t: t } = (0, $LNQP4.default)();
    const study = (0, $eARX3.isDicomFile)(file) ? file.dicom : null;
    const image = !study && (0, $jGozX.isImageFile)(file);
    const view = (0, $3t8yQ.default)(file, {
        enabled: image,
        priority: active
    });
    const name = file.fileName || t('patient.files.unnamed');
    const Icon = (0, $hRWhk.KIND_ICON)[(0, $1Qo7B.canonicalKind)(file.kind)] || (0, $gXsFl.default);
    const canViewImages = Boolean(study && onView && (study.viewable || study.rendered));
    let body;
    if (image && view.status === 'ready') body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: active ? zoomRef : undefined,
        "data-zoom-layer": true,
        className: "flex h-full w-full items-center justify-center will-change-transform"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        ref: active ? imgRef : undefined,
        src: view.url,
        alt: name,
        draggable: false,
        "data-testid": active ? 'file-photo-image' : undefined,
        className: "max-h-full max-w-full select-none object-contain [-webkit-touch-callout:none]"
    }));
    else if (image && view.status === 'error') body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "flex flex-col items-center gap-3 px-6 text-center",
        "data-state": "error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $16WeC.default), {
        size: 44,
        strokeWidth: 1.25,
        className: "text-white/70",
        "aria-hidden": true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "text-sm text-white/80"
    }, t('patient.files.unavailable')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        className: "border-white/30 bg-transparent text-white hover:bg-transparent [@media(hover:hover)]:hover:bg-white/10",
        onClick: view.retry
    }, t('common.actions.retry')));
    else if (image) body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "status",
        "aria-label": t('common.state.loading'),
        "data-state": "loading",
        className: "h-28 w-28 animate-pulse rounded-lg bg-white/10"
    });
    else if (study) body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "flex flex-col items-center gap-3 px-6 text-center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d6Clo.default), {
        study: study,
        size: "12rem",
        testid: active ? 'file-photo-dicom' : undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        className: "text-sm font-semibold"
    }, name), onView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        onClick: ()=>onView(file),
        disabled: !canViewImages,
        className: "gap-1.5",
        "data-testid": active ? 'file-photo-view-images' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9he56.default), {
        size: 16,
        "aria-hidden": true
    }), " ", t('patient.files.dicom.viewImages')));
    else body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "flex max-w-xs flex-col items-center gap-3 px-6 text-center",
        "data-state": "document"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        size: 56,
        strokeWidth: 1.25,
        className: "text-white/80",
        "aria-hidden": true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        className: "text-sm font-semibold"
    }, name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "text-xs text-white/60"
    }, t('patient.files.gallery.noPhotoPreview')), onDetail && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        className: "border-white/30 bg-transparent text-white hover:bg-transparent [@media(hover:hover)]:hover:bg-white/10",
        onClick: ()=>onDetail(file),
        "data-testid": active ? 'file-photo-open-document' : undefined
    }, t('patient.files.gallery.openDocument')));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "absolute inset-0 flex items-center justify-center",
        // Each neighbour waits one screen-width away; the track moves them all.
        style: {
            transform: `translateX(${offset * 100}%)`
        },
        "aria-hidden": active ? undefined : true,
        "data-testid": active ? 'file-photo-slide' : undefined,
        "data-file": file.id
    }, body);
}
function $3b640a58c29e336a$export$2e2bcd8739ae039({ open: open, onClose: onClose, files: files, current: current, onSelect: onSelect, onDetail: onDetail, onView: onView, onExtract: onExtract, onDownload: onDownload, onDelete: onDelete }) {
    const { t: t, formatDate: formatDate, formatDigits: formatDigits, isRTL: isRTL } = (0, $LNQP4.default)();
    const lastIndex = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(0);
    const shown = (0, $zi6VT.resolveCurrent)(files, current, lastIndex);
    const at = shown ? files.findIndex((f)=>(0, $5WzF8.fileBytesKey)(f) === (0, $5WzF8.fileBytesKey)(shown)) : -1;
    const prevFile = at > 0 ? files[at - 1] : null;
    const nextFile = at >= 0 && at < files.length - 1 ? files[at + 1] : null;
    const currentKey = shown ? (0, $5WzF8.fileBytesKey)(shown) : null;
    const study = shown && (0, $eARX3.isDicomFile)(shown) ? shown.dicom : null;
    const isPhoto = Boolean(shown && !study && (0, $jGozX.isImageFile)(shown));
    const [chrome, setChrome] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [zoomed, setZoomed] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // The platform back closes the viewer, not the screen under it (§9.5).
    (0, $9BgRG.default)(open, onClose, {
        id: 'file-photo-viewer'
    });
    const stageRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const trackRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const backdropRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const zoomRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const imgRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const view = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef({
        ...(0, $041LL.IDENTITY)
    });
    const zoomedRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    const gesture = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const pointers = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Map());
    const lastTap = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const tapTimer = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const busy = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    const timers = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef([]);
    const later = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((fn, ms)=>{
        if (!ms) {
            fn();
            return;
        }
        const id = setTimeout(fn, ms);
        timers.current.push(id);
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>()=>{
            timers.current.forEach(clearTimeout);
            clearTimeout(tapTimer.current);
        }, []);
    const duration = ()=>$3b640a58c29e336a$var$reducedMotion() ? 0 : $3b640a58c29e336a$var$SETTLE_MS;
    const stageBox = ()=>{
        const r = stageRef.current?.getBoundingClientRect?.();
        return r && r.width ? {
            w: r.width,
            h: r.height,
            cx: r.left + r.width / 2,
            cy: r.top + r.height / 2
        } : {
            w: 1,
            h: 1,
            cx: 0,
            cy: 0
        };
    };
    const fittedBox = ()=>{
        const img = imgRef.current;
        return img && img.clientWidth ? {
            w: img.clientWidth,
            h: img.clientHeight
        } : {
            w: 1,
            h: 1
        };
    };
    const paintZoom = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((v, animate)=>{
        view.current = v;
        const el = zoomRef.current;
        if (el) {
            const ms = animate ? duration() : 0;
            el.style.transition = ms ? `transform ${ms}ms ease-out` : 'none';
            el.style.transform = `translate3d(${v.x}px, ${v.y}px, 0) scale(${v.scale})`;
        }
        const z = v.scale > 1.01;
        if (z !== zoomedRef.current) {
            zoomedRef.current = z;
            setZoomed(z);
        }
    }, []);
    const paintTrack = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((dx, dy, animate)=>{
        const ms = animate ? duration() : 0;
        const transition = ms ? `transform ${ms}ms ease-out, opacity ${ms}ms ease-out` : 'none';
        const el = trackRef.current;
        if (el) {
            el.style.transition = transition;
            el.style.transform = `translate3d(${dx}px, ${dy}px, 0)`;
        }
        const bd = backdropRef.current;
        if (bd) {
            bd.style.transition = transition;
            bd.style.opacity = String(1 - Math.min(0.85, Math.abs(dy) / 400));
        }
    }, []);
    // A new document: it starts centred, at fit, with the track at rest — and so does
    // the one it replaced, which may have been left zoomed when the buttons paged on.
    const resetView = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        busy.current = false;
        gesture.current = null;
        trackRef.current?.querySelectorAll?.('[data-zoom-layer]').forEach((el)=>{
            el.style.transition = 'none';
            el.style.transform = '';
        });
        paintTrack(0, 0, false);
        paintZoom({
            ...(0, $041LL.IDENTITY)
        }, false);
    }, [
        paintTrack,
        paintZoom
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(()=>{
        resetView();
    }, [
        currentKey,
        resetView
    ]);
    // A turned phone is a new stage: offsets measured on the old one no longer fit.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (typeof window === 'undefined') return undefined;
        window.addEventListener('resize', resetView);
        return ()=>window.removeEventListener('resize', resetView);
    }, [
        resetView
    ]);
    // Page with a slide: the track carries the next document in, then it becomes current.
    const goTo = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((target, direction)=>{
        if (!target || busy.current) return;
        const forward = direction === 'next';
        const sign = (isRTL ? 1 : -1) * (forward ? 1 : -1);
        busy.current = true;
        paintTrack(sign * stageBox().w, 0, true);
        later(()=>onSelect(target), duration());
    }, [
        isRTL,
        onSelect,
        paintTrack,
        later
    ]);
    const close = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        clearTimeout(tapTimer.current);
        onClose?.();
    }, [
        onClose
    ]);
    const toggleZoom = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        if (!isPhoto) return;
        if (view.current.scale > 1.01) paintZoom({
            ...(0, $041LL.IDENTITY)
        }, true);
        else paintZoom((0, $041LL.clampPan)((0, $041LL.zoomAbout)((0, $041LL.IDENTITY), (0, $041LL.DOUBLE_TAP_SCALE), {
            x: 0,
            y: 0
        }), fittedBox(), stageBox()), true);
    }, [
        isPhoto,
        paintZoom
    ]);
    // A tap shows or hides the bars; a second tap soon after is a double tap.
    const handleTap = (p)=>{
        const now = Date.now();
        const last = lastTap.current;
        if (last && now - last.t < $3b640a58c29e336a$var$TAP_MS && Math.hypot(p.x - last.x, p.y - last.y) < 30) {
            clearTimeout(tapTimer.current);
            lastTap.current = null;
            if (isPhoto) paintZoom((0, $041LL.doubleTapView)(view.current, p, fittedBox(), stageBox()), true);
            return;
        }
        lastTap.current = {
            t: now,
            x: p.x,
            y: p.y
        };
        clearTimeout(tapTimer.current);
        tapTimer.current = setTimeout(()=>{
            lastTap.current = null;
            setChrome((c)=>!c);
        }, $3b640a58c29e336a$var$TAP_MS);
    };
    const local = (e)=>{
        const b = stageBox();
        return {
            x: e.clientX - b.cx,
            y: e.clientY - b.cy,
            t: e.timeStamp || Date.now()
        };
    };
    const onPointerDown = (e)=>{
        if (busy.current || $3b640a58c29e336a$var$isControl(e.target)) return;
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        try {
            e.currentTarget.setPointerCapture?.(e.pointerId);
        } catch  {}
        pointers.current.set(e.pointerId, local(e));
        const pts = [
            ...pointers.current.values()
        ];
        if (pts.length === 2) {
            // A second finger: whatever the first was doing becomes a pinch.
            const g = gesture.current;
            if (g && (g.kind === 'page' || g.kind === 'dismiss')) paintTrack(0, 0, true);
            clearTimeout(tapTimer.current);
            lastTap.current = null;
            gesture.current = isPhoto ? {
                kind: 'pinch',
                dist: Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y) || 1,
                mid: {
                    x: (pts[0].x + pts[1].x) / 2,
                    y: (pts[0].y + pts[1].y) / 2
                },
                view: {
                    ...view.current
                }
            } : {
                kind: 'none'
            };
        } else if (pts.length === 1) gesture.current = {
            kind: 'pending',
            start: pts[0],
            view: {
                ...view.current
            },
            samples: [
                pts[0]
            ]
        };
    };
    const onPointerMove = (e)=>{
        if (!pointers.current.has(e.pointerId)) return;
        const p = local(e);
        pointers.current.set(e.pointerId, p);
        const g = gesture.current;
        if (!g || g.kind === 'none') return;
        if (g.kind === 'pinch') {
            const pts = [
                ...pointers.current.values()
            ];
            if (pts.length < 2) return;
            const mid = {
                x: (pts[0].x + pts[1].x) / 2,
                y: (pts[0].y + pts[1].y) / 2
            };
            const dist = Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y);
            paintZoom((0, $041LL.zoomAbout)(g.view, (0, $041LL.clampScale)(g.view.scale * (dist / g.dist), {
                live: true
            }), g.mid, mid), false);
            return;
        }
        g.samples.push(p);
        if (g.samples.length > 10) g.samples.shift();
        const dx = p.x - g.start.x;
        const dy = p.y - g.start.y;
        if (g.kind === 'pending') {
            if (Math.hypot(dx, dy) < $3b640a58c29e336a$var$AXIS_LOCK_PX) return;
            clearTimeout(tapTimer.current);
            lastTap.current = null;
            if (view.current.scale > 1.01) g.kind = 'pan';
            else if (Math.abs(dx) >= Math.abs(dy)) g.kind = 'page';
            else g.kind = dy > 0 ? 'dismiss' : 'none';
        }
        if (g.kind === 'pan') paintZoom((0, $041LL.clampPan)({
            scale: g.view.scale,
            x: g.view.x + dx,
            y: g.view.y + dy
        }, fittedBox(), stageBox()), false);
        else if (g.kind === 'page') paintTrack((0, $041LL.resistEdge)(dx, {
            rtl: isRTL,
            hasPrev: Boolean(prevFile),
            hasNext: Boolean(nextFile)
        }), 0, false);
        else if (g.kind === 'dismiss') paintTrack(0, Math.max(0, dy), false);
    };
    const finish = (e, cancelled = false)=>{
        if (!pointers.current.has(e.pointerId)) return;
        pointers.current.delete(e.pointerId);
        const g = gesture.current;
        const remaining = [
            ...pointers.current.values()
        ];
        if (g && g.kind === 'pinch') {
            if (remaining.length === 1) {
                // One finger stays: it carries on panning from where the pinch left the photo.
                gesture.current = {
                    kind: 'pan',
                    start: remaining[0],
                    view: {
                        ...view.current
                    },
                    samples: [
                        remaining[0]
                    ]
                };
                return;
            }
            gesture.current = null;
            paintZoom((0, $041LL.settle)(view.current, fittedBox(), stageBox()), true);
            return;
        }
        if (remaining.length > 0) return;
        gesture.current = null;
        if (!g || g.kind === 'none') return;
        const p = local(e);
        const dx = p.x - g.start.x;
        const dy = p.y - g.start.y;
        if (cancelled) {
            paintTrack(0, 0, true);
            paintZoom((0, $041LL.settle)(view.current, fittedBox(), stageBox()), true);
            return;
        }
        if (g.kind === 'pan') paintZoom((0, $041LL.settle)(view.current, fittedBox(), stageBox()), true);
        else if (g.kind === 'page') {
            const decision = (0, $041LL.pageDecision)({
                dx: dx,
                vx: (0, $041LL.velocity)(g.samples, 'x'),
                width: stageBox().w,
                rtl: isRTL,
                hasPrev: Boolean(prevFile),
                hasNext: Boolean(nextFile)
            });
            if (decision === 'next') goTo(nextFile, 'next');
            else if (decision === 'prev') goTo(prevFile, 'prev');
            else paintTrack(0, 0, true);
        } else if (g.kind === 'dismiss') {
            if ((0, $041LL.dismissDecision)({
                dy: dy,
                vy: (0, $041LL.velocity)(g.samples, 'y')
            })) {
                busy.current = true;
                paintTrack(0, stageBox().h, true);
                later(close, duration());
            } else paintTrack(0, 0, true);
        } else if (g.kind === 'pending') handleTap(p);
    };
    // Keys for a paired keyboard: the gallery's arrows and Home/End, + − 0 for zoom.
    const galleryKeys = (0, $zi6VT.useGalleryKeys)({
        files: files,
        current: shown,
        onSelect: onSelect
    });
    const onKeyDown = (e)=>{
        if (isPhoto && (e.key === '+' || e.key === '=')) {
            e.preventDefault();
            paintZoom((0, $041LL.settle)((0, $041LL.zoomAbout)(view.current, (0, $041LL.clampScale)(view.current.scale * 1.5), {
                x: 0,
                y: 0
            }), fittedBox(), stageBox()), true);
        } else if (isPhoto && (e.key === '-' || e.key === '_')) {
            e.preventDefault();
            paintZoom((0, $041LL.settle)((0, $041LL.zoomAbout)(view.current, (0, $041LL.clampScale)(view.current.scale / 1.5), {
                x: 0,
                y: 0
            }), fittedBox(), stageBox()), true);
        } else if (isPhoto && e.key === '0') {
            e.preventDefault();
            paintZoom({
                ...(0, $041LL.IDENTITY)
            }, true);
        } else galleryKeys(e);
    };
    if (!shown) return null;
    const name = shown.fileName || t('patient.files.unnamed');
    const date = (0, $gdEay.documentDateOf)(shown);
    const canExtract = Boolean(shown.extractable && onExtract && (!study || (0, $eARX3.hasDocumentObjects)(study)));
    const canDownload = Boolean(onDownload) && !study;
    const canDelete = Boolean(shown.canDelete && onDelete);
    const PrevIcon = isRTL ? (0, $kzPvP.default) : (0, $gKFEi.default);
    const NextIcon = isRTL ? (0, $gKFEi.default) : (0, $kzPvP.default);
    const bar = (0, $5JYPc.cn)('absolute inset-x-0 z-10 flex flex-col transition-[opacity,visibility] duration-200 motion-reduce:transition-none', chrome ? 'visible opacity-100' : 'invisible opacity-0');
    // A touch screen has no hover: a tapped button must not keep a highlight it only
    // earned by being touched. The tint is for a pointer that can hover.
    const onDark = 'text-white hover:bg-transparent hover:text-white [@media(hover:hover)]:hover:bg-white/10';
    const action = (0, $5JYPc.cn)('h-auto min-h-11 min-w-[3.75rem] flex-col gap-1 px-2 py-1.5 text-[0.6875rem] font-medium', onDark);
    const slides = [
        prevFile && {
            file: prevFile,
            offset: isRTL ? 1 : -1
        },
        {
            file: shown,
            offset: 0
        },
        nextFile && {
            file: nextFile,
            offset: isRTL ? -1 : 1
        }
    ].filter(Boolean);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.Dialog), {
        open: open,
        onOpenChange: (o)=>{
            if (!o) close();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogContent), {
        layout: "fullscreen",
        showClose: false,
        onKeyDown: onKeyDown,
        className: "bg-transparent",
        "data-testid": "file-photo-viewer",
        "data-current": shown.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogTitle), {
        className: "sr-only"
    }, t('patient.files.gallery.viewer')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogDescription), {
        className: "sr-only"
    }, t('patient.files.gallery.gestureHint')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: backdropRef,
        className: "absolute inset-0 bg-black",
        "aria-hidden": true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: stageRef,
        className: "absolute inset-0 touch-none select-none overflow-hidden",
        "data-testid": "file-photo-stage",
        onPointerDown: onPointerDown,
        onPointerMove: onPointerMove,
        onPointerUp: (e)=>finish(e),
        onPointerCancel: (e)=>finish(e, true)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: trackRef,
        className: "absolute inset-0 will-change-transform"
    }, slides.map(({ file: file, offset: offset })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3b640a58c29e336a$var$Slide, {
            key: (0, $5WzF8.fileBytesKey)(file),
            file: file,
            offset: offset,
            active: offset === 0,
            zoomRef: zoomRef,
            imgRef: imgRef,
            onDetail: onDetail,
            onView: onView
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $5JYPc.cn)(bar, 'top-0 bg-gradient-to-b from-black/75 to-transparent px-1 pb-8 pt-[max(0.25rem,env(safe-area-inset-top))]'),
        "aria-hidden": chrome ? undefined : true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "flex items-center gap-1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "icon",
        className: (0, $5JYPc.cn)('h-11 w-11 shrink-0', onDark),
        "aria-label": t('common.actions.close'),
        title: t('common.actions.close'),
        onClick: close,
        "data-testid": "file-photo-close"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
        size: 22,
        "aria-hidden": true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "flex min-w-0 flex-1 flex-col"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        className: "truncate text-sm font-semibold [unicode-bidi:isolate]",
        "data-testid": "file-photo-name"
    }, name), date && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "text-[0.6875rem] text-white/70"
    }, (0, $hRWhk.formatDocDate)(date, formatDate))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "shrink-0 px-3 text-xs text-white/80",
        "aria-live": "polite",
        "data-testid": "file-photo-position"
    }, t('patient.files.gallery.position', {
        pos: formatDigits(at + 1),
        total: formatDigits(files.length)
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $5JYPc.cn)(bar, 'bottom-0 gap-1 bg-gradient-to-t from-black/80 to-transparent px-2 pb-[max(0.5rem,env(safe-area-inset-bottom))] pt-10'),
        "aria-hidden": chrome ? undefined : true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "flex items-center justify-center gap-6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "icon",
        className: (0, $5JYPc.cn)('h-11 w-11', onDark),
        disabled: !prevFile,
        onClick: ()=>goTo(prevFile, 'prev'),
        "aria-label": t('patient.files.gallery.prev'),
        title: t('patient.files.gallery.prev'),
        "data-testid": "file-photo-prev"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(PrevIcon, {
        size: 22,
        "aria-hidden": true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "icon",
        className: (0, $5JYPc.cn)('h-11 w-11', onDark),
        disabled: !isPhoto,
        onClick: toggleZoom,
        "aria-label": t(zoomed ? 'patient.files.gallery.zoomOut' : 'patient.files.gallery.zoomIn'),
        title: t(zoomed ? 'patient.files.gallery.zoomOut' : 'patient.files.gallery.zoomIn'),
        "aria-pressed": zoomed,
        "data-testid": "file-photo-zoom"
    }, zoomed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bU80g.default), {
        size: 22,
        "aria-hidden": true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $47abO.default), {
        size: 22,
        "aria-hidden": true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "icon",
        className: (0, $5JYPc.cn)('h-11 w-11', onDark),
        disabled: !nextFile,
        onClick: ()=>goTo(nextFile, 'next'),
        "aria-label": t('patient.files.gallery.next'),
        title: t('patient.files.gallery.next'),
        "data-testid": "file-photo-next"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(NextIcon, {
        size: 22,
        "aria-hidden": true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "flex flex-wrap items-stretch justify-center gap-1"
    }, canExtract && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        className: action,
        onClick: ()=>onExtract(shown),
        "data-testid": "file-photo-extract"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $chm1L.default), {
        size: 20,
        "aria-hidden": true
    }), " ", t('patient.files.gallery.extractShort')), onDetail && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        className: action,
        onClick: ()=>onDetail(shown),
        "data-testid": "file-photo-details"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $97xXr.default), {
        size: 20,
        "aria-hidden": true
    }), " ", t('patient.files.gallery.details')), canDownload && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        className: action,
        onClick: ()=>onDownload(shown),
        "data-testid": "file-photo-download"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2XwcZ.default), {
        size: 20,
        "aria-hidden": true
    }), " ", t('patient.files.actions.download')), canDelete && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        className: action,
        onClick: ()=>onDelete(shown),
        "data-testid": "file-photo-delete"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lUsTt.default), {
        size: 20,
        "aria-hidden": true
    }), " ", t('patient.files.actions.delete'))))));
}

});
parcelRegister("041LL", function(module, exports) {

$parcel$export(module.exports, "DOUBLE_TAP_SCALE", () => $00c1bf30223c5aef$export$2ed99d9894be9aaf);
$parcel$export(module.exports, "IDENTITY", () => $00c1bf30223c5aef$export$76c0f2b8ecfc3d8a);
$parcel$export(module.exports, "clampScale", () => $00c1bf30223c5aef$export$817738923b3e6f50);
$parcel$export(module.exports, "zoomAbout", () => $00c1bf30223c5aef$export$9ac08a69ce6f4f3a);
$parcel$export(module.exports, "clampPan", () => $00c1bf30223c5aef$export$96b6e0edf0004ed3);
$parcel$export(module.exports, "settle", () => $00c1bf30223c5aef$export$dbcd80e881882416);
$parcel$export(module.exports, "doubleTapView", () => $00c1bf30223c5aef$export$9496f1edad00bd5c);
$parcel$export(module.exports, "pageDecision", () => $00c1bf30223c5aef$export$2de321c1bd1b5aff);
$parcel$export(module.exports, "resistEdge", () => $00c1bf30223c5aef$export$4c014554e1e02ab5);
$parcel$export(module.exports, "dismissDecision", () => $00c1bf30223c5aef$export$cc455a7d53bc696b);
$parcel$export(module.exports, "velocity", () => $00c1bf30223c5aef$export$b9fe5d314b12b4ca);
// The arithmetic of the phone's full-screen photo viewer (PM-0568), kept pure so it
// can be tested without a touch screen. Every point is in CSS pixels RELATIVE TO THE
// CENTRE OF THE STAGE, and a view is `{ scale, x, y }`: the photo, fitted to the
// stage ("contain") at scale 1, scaled about its centre and then moved by (x, y).
//
// Pan offsets are physical pixels on purpose — the finger moves the picture — and
// the picture is never mirrored for rtl (a radiograph has a patient left and right).
// Only PAGING follows the reading direction: under rtl the next document sits to the
// left, as the gallery's tiles and arrow keys already have it.
const $00c1bf30223c5aef$export$e4985ca28e204935 = 1;
const $00c1bf30223c5aef$export$44e5bd0fef8d913c = 5;
const $00c1bf30223c5aef$export$2ed99d9894be9aaf = 2.5;
const $00c1bf30223c5aef$export$76c0f2b8ecfc3d8a = Object.freeze({
    scale: 1,
    x: 0,
    y: 0
});
const $00c1bf30223c5aef$export$7d15b64cf5a3a4c4 = (v, lo, hi)=>Math.min(hi, Math.max(lo, v));
function $00c1bf30223c5aef$export$817738923b3e6f50(scale, { live: live = false } = {}) {
    return live ? $00c1bf30223c5aef$export$7d15b64cf5a3a4c4(scale, $00c1bf30223c5aef$export$e4985ca28e204935 * 0.8, $00c1bf30223c5aef$export$44e5bd0fef8d913c * 1.15) : $00c1bf30223c5aef$export$7d15b64cf5a3a4c4(scale, $00c1bf30223c5aef$export$e4985ca28e204935, $00c1bf30223c5aef$export$44e5bd0fef8d913c);
}
function $00c1bf30223c5aef$export$9ac08a69ce6f4f3a(start, scale, startPoint, point = startPoint) {
    const k = scale / start.scale;
    return {
        scale: scale,
        x: point.x - (startPoint.x - start.x) * k,
        y: point.y - (startPoint.y - start.y) * k
    };
}
function $00c1bf30223c5aef$export$96b6e0edf0004ed3(view, fitted, stage) {
    const maxX = Math.max(0, (view.scale * fitted.w - stage.w) / 2);
    const maxY = Math.max(0, (view.scale * fitted.h - stage.h) / 2);
    return {
        scale: view.scale,
        x: $00c1bf30223c5aef$export$7d15b64cf5a3a4c4(view.x, -maxX, maxX),
        y: $00c1bf30223c5aef$export$7d15b64cf5a3a4c4(view.y, -maxY, maxY)
    };
}
function $00c1bf30223c5aef$export$dbcd80e881882416(view, fitted, stage) {
    const scale = $00c1bf30223c5aef$export$817738923b3e6f50(view.scale);
    if (scale <= $00c1bf30223c5aef$export$e4985ca28e204935 + 0.001) return {
        ...$00c1bf30223c5aef$export$76c0f2b8ecfc3d8a
    };
    // Scaling back from an over-pinch keeps the photo where the fingers left it.
    const k = scale / view.scale;
    return $00c1bf30223c5aef$export$96b6e0edf0004ed3({
        scale: scale,
        x: view.x * k,
        y: view.y * k
    }, fitted, stage);
}
function $00c1bf30223c5aef$export$9496f1edad00bd5c(view, point, fitted, stage) {
    if (view.scale > $00c1bf30223c5aef$export$e4985ca28e204935 + 0.01) return {
        ...$00c1bf30223c5aef$export$76c0f2b8ecfc3d8a
    };
    return $00c1bf30223c5aef$export$96b6e0edf0004ed3($00c1bf30223c5aef$export$9ac08a69ce6f4f3a($00c1bf30223c5aef$export$76c0f2b8ecfc3d8a, $00c1bf30223c5aef$export$2ed99d9894be9aaf, point, {
        x: 0,
        y: 0
    }), fitted, stage);
}
function $00c1bf30223c5aef$export$2de321c1bd1b5aff({ dx: dx, vx: vx = 0, width: width, rtl: rtl, hasPrev: hasPrev, hasNext: hasNext }) {
    const far = Math.abs(dx) > width * 0.2;
    const flick = Math.abs(vx) > 0.45 && Math.abs(dx) > 24;
    if (!far && !flick) return 'stay';
    const towardRight = (flick ? vx : dx) > 0;
    const forward = rtl ? towardRight : !towardRight;
    if (forward) return hasNext ? 'next' : 'stay';
    return hasPrev ? 'prev' : 'stay';
}
function $00c1bf30223c5aef$export$4c014554e1e02ab5(dx, { rtl: rtl, hasPrev: hasPrev, hasNext: hasNext }) {
    const towardRight = dx > 0;
    const forward = rtl ? towardRight : !towardRight;
    const open = forward ? hasNext : hasPrev;
    return open ? dx : dx * 0.3;
}
function $00c1bf30223c5aef$export$cc455a7d53bc696b({ dy: dy, vy: vy = 0 }) {
    return dy > 120 || vy > 0.5 && dy > 30;
}
function $00c1bf30223c5aef$export$b9fe5d314b12b4ca(samples, axis) {
    if (!samples || samples.length < 2) return 0;
    const last = samples[samples.length - 1];
    let first = samples[0];
    for(let i = samples.length - 1; i >= 0; i -= 1){
        if (last.t - samples[i].t > 100) break;
        first = samples[i];
    }
    const dt = last.t - first.t;
    return dt > 0 ? (last[axis] - first[axis]) / dt : 0;
}

});



parcelRegister("90sfp", function(module, exports) {

$parcel$export(module.exports, "default", () => $b567ba15159c8a42$export$2e2bcd8739ae039);
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");
parcelRequire("7sS0P");
var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $hZDga = parcelRequire("hZDga");

var $huNwV = parcelRequire("huNwV");
var $1J4VI = parcelRequire("1J4VI");
var $bF8pu = parcelRequire("bF8pu");
var $chm1L = parcelRequire("chm1L");
var $6TdpC = parcelRequire("6TdpC");

var $lTG78 = parcelRequire("lTG78");
var $jTCZr = parcelRequire("jTCZr");
// The AI treatment-plan review panel, docked under the «برنامه» section of the
// SOAP note (§13.3: AI-labelled until the doctor owns it). One AI call composes
// meds + labs + imaging + procedures, grounded in the whole SOAP note, the
// reviewed differentials and the patient's longitudinal history.
//
// The plan's prose is NOT edited here — it was written straight into the «برنامه»
// textarea above, which is the note the doctor signs. This panel carries only
// what is not prose: interaction warnings, the structured items to tick off, and
// the clinical rationale. All mutations live in the screen; this is render-only.
const $b567ba15159c8a42$var$planKey = (type, name)=>`${type}:${name}`;
// The four plan buckets, each mapped to a display name + optional sub-line.
const $b567ba15159c8a42$var$GROUPS = (t)=>[
        {
            key: 'med',
            title: t('visit.rx.medications'),
            field: 'medications',
            nameOf: (m)=>m.name,
            subOf: (m)=>[
                    m.dosage,
                    m.frequency,
                    m.duration ? t('visit.rx.forDuration', {
                        duration: m.duration
                    }) : '',
                    m.notes
                ].filter(Boolean).join(" \xb7 ")
        },
        {
            key: 'lab',
            title: t('visit.orders.tests'),
            field: 'labTests',
            nameOf: (test)=>test.testName,
            subOf: (test)=>[
                    test.reason,
                    test.loincCode ? `LOINC ${test.loincCode}` : ''
                ].filter(Boolean).join(" \xb7 ")
        },
        {
            key: 'imaging',
            title: t('patient.orderType.imaging'),
            field: 'imagingStudies',
            nameOf: (s)=>s.studyType,
            subOf: (s)=>[
                    s.modality,
                    [
                        s.bodyPart,
                        s.reason
                    ].filter(Boolean).join(" \u2014 ")
                ].filter(Boolean).join(" \xb7 ")
        },
        {
            key: 'procedure',
            title: t('visit.orders.paraclinical'),
            field: 'procedureOrders',
            nameOf: (p)=>p.name,
            subOf: (p)=>p.reason || ''
        }
    ];
const $b567ba15159c8a42$var$PlanCheckRow = ({ name: name, sub: sub, checked: checked, onToggle: onToggle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        onClick: onToggle,
        "aria-pressed": checked,
        className: "w-full min-h-11 h-auto justify-start rounded-lg px-2 py-2 gap-2 hover:bg-transparent font-normal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: '1.125rem',
            height: '1.125rem',
            borderRadius: '0.3125rem',
            flexShrink: 0,
            border: `1.5px solid ${checked ? (0, $jTCZr.CT).accent : (0, $jTCZr.C).border}`,
            background: checked ? (0, $jTCZr.CT).accent : 'transparent',
            display: 'grid',
            placeItems: 'center'
        }
    }, checked && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
        size: 12,
        color: "#fff",
        "aria-hidden": true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            minWidth: 0,
            textAlign: 'start'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'block',
            fontSize: '0.8125rem',
            fontWeight: 500,
            color: (0, $jTCZr.C).textPrimary
        }
    }, name), sub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'block',
            fontSize: '0.625rem',
            color: (0, $jTCZr.C).textMuted,
            marginTop: '0.0625rem',
            lineHeight: 1.5
        }
    }, sub)));
const $b567ba15159c8a42$var$MobileVisitPlan = ({ suggestion: suggestion, loading: loading, saving: saving, status: status, error: error, selected: selected, onToggle: onToggle, onGenerate: onGenerate, onConfirm: onConfirm, inprogress: inprogress, canGenerate: canGenerate, onClose: onClose, onRestore: onRestore, canRestore: canRestore = false })=>{
    const { t: t } = (0, $LNQP4.default)();
    const confirmed = status === 'confirmed';
    const totalItems = suggestion ? $b567ba15159c8a42$var$GROUPS(t).reduce((n, g)=>n + (suggestion[g.field] || []).length, 0) : 0;
    const dropped = suggestion ? totalItems - selected.size : 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-plan-content",
        "data-state": suggestion ? 'content' : loading ? 'loading' : 'empty',
        style: {
            background: (0, $jTCZr.CT).surface2,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: '0.75rem',
            padding: '0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lTG78.VisitSectionHead), {
        badge: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.375rem'
            }
        }, confirmed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.625rem',
                fontWeight: 700,
                padding: '0.125rem 0.5rem',
                borderRadius: '0.75rem',
                background: (0, $jTCZr.C).greenLight,
                color: (0, $jTCZr.CT).goodInk
            }
        }, t('visit.state.confirmedAdj')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lTG78.AiBadge), {
            label: t('visit.plan.basis')
        }), onClose && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            size: "icon",
            className: "h-11 w-11 shrink-0",
            "data-testid": "visit-plan-close",
            "aria-label": t('common.actions.close'),
            onClick: onClose,
            style: {
                color: (0, $jTCZr.C).textMuted
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
            size: 13,
            "aria-hidden": true
        })))
    }, t('credits.price.plan')), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-plan-error",
        style: {
            padding: '0.5rem 0.75rem',
            marginBottom: '0.625rem',
            background: (0, $jTCZr.CT).dangerSoft,
            border: `1px solid ${(0, $jTCZr.C).redLight}`,
            borderRadius: '0.5rem',
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).dangerInk
        }
    }, error), canRestore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0.5rem 0.625rem',
            marginBottom: '0.625rem',
            background: (0, $jTCZr.C).amberLight,
            border: `1px solid ${(0, $jTCZr.CT).warn}`,
            borderRadius: '0.5rem',
            fontSize: '0.6875rem',
            color: (0, $jTCZr.CT).warnInk
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            lineHeight: 1.7
        }
    }, t('visit.plan.replacedNotice')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "sm",
        className: "min-h-11 shrink-0 px-3 text-xs",
        "data-testid": "visit-plan-restore",
        onClick: onRestore,
        style: {
            color: (0, $jTCZr.CT).warnInk,
            borderColor: (0, $jTCZr.CT).warn
        }
    }, t('visit.plan.restorePrevious'))), !suggestion && !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: (0, $jTCZr.C).card,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: '0.75rem',
            padding: '0.875rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        style: {
            fontSize: '0.8125rem',
            color: (0, $jTCZr.C).textSecondary,
            lineHeight: 1.9,
            margin: '0 0 0.875rem'
        }
    }, t('visit.plan.explainer')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "teal",
        size: "lg",
        className: "w-full min-h-11 gap-1.5",
        "data-testid": "visit-plan-generate",
        onClick: onGenerate,
        disabled: !canGenerate
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $chm1L.default), {
        size: 15,
        "aria-hidden": true
    }), " ", t('visit.plan.generate')), !inprogress && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.6875rem',
            color: (0, $jTCZr.C).textMuted,
            textAlign: 'center',
            marginTop: '0.5rem'
        }
    }, t('visit.plan.needsOpenVisit'))), loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '0.5rem 0'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lTG78.InlineLoading), {
        label: t('visit.plan.generating')
    })), suggestion && !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem'
        }
    }, suggestion.interactionWarnings?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.375rem'
        }
    }, suggestion.interactionWarnings.map((w, i)=>{
        const tone = (0, $lTG78.SEVERITY_TONE)(t)[w.severity] || (0, $lTG78.SEVERITY_TONE)(t).medium;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                padding: '0.5rem 0.6875rem',
                borderRadius: '0.5rem',
                background: tone.bg,
                border: `1px solid ${(0, $jTCZr.soft)(tone.color, 0.35)}`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.5625rem',
                fontWeight: 700,
                padding: '0.0625rem 0.375rem',
                borderRadius: '0.25rem',
                background: tone.color,
                color: '#fff',
                marginInlineEnd: '0.375rem'
            }
        }, tone.label), w.drugPair && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.75rem',
                fontWeight: 700,
                color: tone.color
            }
        }, w.drugPair, " \xb7 "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.75rem',
                color: (0, $jTCZr.C).textSecondary
            }
        }, w.description));
    })), $b567ba15159c8a42$var$GROUPS(t).map((g)=>{
        const rows = suggestion[g.field] || [];
        if (!rows.length) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: g.key,
            "data-testid": `visit-plan-group-${g.key}`,
            style: {
                background: (0, $jTCZr.C).card,
                border: `1px solid ${(0, $jTCZr.C).border}`,
                borderRadius: '0.75rem',
                padding: '0.5rem 0.5rem 0.625rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                padding: '0.25rem 0.375rem 0.375rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.75rem',
                fontWeight: 700,
                color: (0, $jTCZr.C).textPrimary
            }
        }, g.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.625rem',
                fontWeight: 700,
                padding: '0.0625rem 0.375rem',
                borderRadius: '0.75rem',
                background: (0, $jTCZr.CT).surface2,
                color: (0, $jTCZr.C).textSecondary
            }
        }, rows.length)), rows.map((it, i)=>{
            const name = g.nameOf(it);
            const key = $b567ba15159c8a42$var$planKey(g.key, name);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b567ba15159c8a42$var$PlanCheckRow, {
                key: `${key}:${i}`,
                name: name,
                sub: g.subOf(it),
                checked: selected.has(key),
                onToggle: ()=>onToggle(key)
            });
        }));
    }), suggestion.clinicalRationale && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '0.625rem 0.75rem',
            borderRadius: '0.625rem',
            background: (0, $jTCZr.CT).surface2,
            border: `1px dashed ${(0, $jTCZr.C).border}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.625rem',
            fontWeight: 700,
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            color: (0, $jTCZr.C).textMuted,
            marginBottom: '0.25rem'
        }
    }, t('visit.copilot.clinicalRationale')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.75rem',
            color: (0, $jTCZr.C).textSecondary,
            lineHeight: 1.8
        }
    }, suggestion.clinicalRationale)), dropped > 0 && !confirmed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-plan-drift",
        style: {
            padding: '0.5rem 0.625rem',
            background: (0, $jTCZr.C).amberLight,
            border: `1px solid ${(0, $jTCZr.CT).warn}`,
            borderRadius: '0.5rem',
            fontSize: '0.6875rem',
            color: (0, $jTCZr.CT).warnInk,
            lineHeight: 1.7
        }
    }, t('visit.plan.editNoteHint', {
        count: dropped
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "default",
        size: "lg",
        className: "w-full min-h-11 gap-1.5",
        "data-testid": "visit-plan-confirm",
        onClick: onConfirm,
        disabled: saving || confirmed
    }, saving ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 14,
        color: "#fff",
        thickness: 2
    }), " ", t('visit.plan.saving')) : confirmed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1J4VI.default), {
        size: 15,
        "aria-hidden": true
    }), " ", t('visit.plan.approved')) : t('visit.plan.confirmWithCount', {
        count: selected.size
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "sm",
        className: "w-full min-h-11 gap-1.5",
        "data-testid": "visit-plan-regenerate",
        onClick: onGenerate,
        disabled: saving,
        style: {
            color: (0, $jTCZr.C).textMuted
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bF8pu.default), {
        size: 13,
        "aria-hidden": true
    }), " ", t('visit.plan.regenerate')))));
};
var $b567ba15159c8a42$export$2e2bcd8739ae039 = $b567ba15159c8a42$var$MobileVisitPlan;

});
parcelRegister("1J4VI", function(module, exports) {

$parcel$export(module.exports, "default", () => $11d7bd64b06fae29$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $11d7bd64b06fae29$export$a2387ed3b5d536eb = {
    name: "clipboard-check",
    size: 24,
    node: [
        [
            "rect",
            {
                width: "8",
                height: "4",
                x: "8",
                y: "2",
                rx: "1",
                ry: "1",
                key: "tgr4d6"
            }
        ],
        [
            "path",
            {
                d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
                key: "116196"
            }
        ],
        [
            "path",
            {
                d: "m9 14 2 2 4-4",
                key: "df797q"
            }
        ]
    ]
};
$11d7bd64b06fae29$export$a2387ed3b5d536eb.node;
const $11d7bd64b06fae29$export$2e2bcd8739ae039 = (0, $9QBug.default)($11d7bd64b06fae29$export$a2387ed3b5d536eb);

});


parcelRegister("lqfll", function(module, exports) {

$parcel$export(module.exports, "useVisitLeaveAnchor", () => $f987ed8f19153509$export$b78e23134a4d4c2b);

var $acw62 = parcelRequire("acw62");
parcelRequire("2tKqm");
var $9BgRG = parcelRequire("9BgRG");
function $f987ed8f19153509$export$b78e23134a4d4c2b({ active: active, visitKey: visitKey, onRequest: onRequest, back: back }) {
    const leavingRef = (0, $acw62.useRef)(false);
    const visitHref = (0, $acw62.useRef)(null);
    // The latest callbacks without re-arming the anchor on every render: re-running
    // the effect would push a fresh anchor each time.
    const latest = (0, $acw62.useRef)({
        onRequest: onRequest,
        back: back
    });
    latest.current = {
        onRequest: onRequest,
        back: back
    };
    (0, $acw62.useEffect)(()=>{
        if (!active) return undefined;
        leavingRef.current = false;
        const onPop = ()=>{
            if (leavingRef.current) {
                if (window.location.href === visitHref.current) latest.current.back?.();
                return;
            }
            if ((0, $9BgRG.overlayOwnsPop)()) return;
            // Put the anchor back so the URL does not change yet.
            window.history.pushState(null, '', window.location.href);
            latest.current.onRequest?.(()=>window.history.go(-(2 + (0, $9BgRG.overlayHistoryDepth)())));
        };
        visitHref.current = window.location.href;
        // Anchor the current state so the first popstate is catchable.
        window.history.pushState(null, '', window.location.href);
        window.addEventListener('popstate', onPop);
        return ()=>window.removeEventListener('popstate', onPop);
    }, [
        active,
        visitKey
    ]);
    return (0, $acw62.useCallback)((run)=>{
        leavingRef.current = true;
        run?.();
    }, []);
}
var $f987ed8f19153509$export$2e2bcd8739ae039 = $f987ed8f19153509$export$b78e23134a4d4c2b;

});

parcelRegister("fijM5", function(module, exports) {

$parcel$export(module.exports, "default", () => $0385119c9c941a3e$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $bHjRG = parcelRequire("bHjRG");
var $aJ1FU = parcelRequire("aJ1FU");
var $5JYPc = parcelRequire("5JYPc");
var $5MbI8 = parcelRequire("5MbI8");
var $9iIGe = parcelRequire("9iIGe");
var $amyVq = parcelRequire("amyVq");
var $fYgeo = parcelRequire("fYgeo");
var $66joL = parcelRequire("66joL");
var $hZDga = parcelRequire("hZDga");
var $cT2Zr = parcelRequire("cT2Zr");
var $iygI2 = parcelRequire("iygI2");
var $a7Rbr = parcelRequire("a7Rbr");

var $huNwV = parcelRequire("huNwV");
var $2WFPf = parcelRequire("2WFPf");
var $azOWV = parcelRequire("azOWV");
var $i5dmF = parcelRequire("i5dmF");
var $ltuDQ = parcelRequire("ltuDQ");
var $2SsUu = parcelRequire("2SsUu");
var $6lig1 = parcelRequire("6lig1");
var $8g4t5 = parcelRequire("8g4t5");
var $1comv = parcelRequire("1comv");
var $6TdpC = parcelRequire("6TdpC");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $eVM84 = parcelRequire("eVM84");

var $3OnFU = parcelRequire("3OnFU");

var $dLdf9 = parcelRequire("dLdf9");

var $6xvbB = parcelRequire("6xvbB");

var $ltciA = parcelRequire("ltciA");

var $aQGDs = parcelRequire("aQGDs");

var $hz8CN = parcelRequire("hz8CN");
// ─────────────────────────────────────────────────────────────────────────────
// «پروسهٔ درمان» — docs/TREATMENT_PROCESS_AND_SERVICE_BUNDLES_PLAN.md §8, the
// doctor's side.
//
// The doctor attaches a list of catalogue services to this visit and decides
// whether they must happen in order. The CLINIC approves it (never the doctor);
// after that the doctor may still add steps (they arrive unapproved, at the
// end), cancel a step or the whole process, record a session they performed
// themselves («انجام شد») and void one.
//
// Nothing here derives a state. `ready`, `blockedReason`, the step status and
// the process status are clinicalencounter's; the panel only chooses which
// affordance to draw, and after any write to a step it re-reads the whole
// process, because one step's session can unlock the next one's.
//
// Styling note: Tailwind classes, and never the `navy`/`primary`/`accent`
// colours — the visit room redefines `--primary` and `--accent` on :root as
// plain colours (Visit.shared.jsx CSS_VARS), which turns `hsl(var(--primary))`
// into nothing. `--p-*` and `--chip-*` are the tokens that survive both the
// desktop room and the phone one, which does not inject CSS_VARS at all.
//
// `compact` is the phone's reduction of the same panel: 44px targets, rows that
// wrap their actions onto a second line, and a stacked picker.
// ─────────────────────────────────────────────────────────────────────────────
const $0385119c9c941a3e$var$PROCESS_STATUS = {
    PROPOSED: [
        'proposed',
        'warning'
    ],
    APPROVED: [
        'approved',
        'info'
    ],
    IN_PROGRESS: [
        'inProgress',
        'info'
    ],
    COMPLETED: [
        'completed',
        'success'
    ],
    CANCELLED: [
        'cancelled',
        'muted'
    ]
};
// A step is an order: its chip names its stage from the one map
// (constants/statuses `orderStageColors`, PM-0634), read from its status.
const $0385119c9c941a3e$var$STEP_TONE = {
    SCHEDULED: 'info',
    IN_PROGRESS: 'info',
    DONE: 'success',
    CANCELLED: 'muted'
};
const $0385119c9c941a3e$var$LOCK_KEYS = {
    NOT_APPROVED: 'notApproved',
    WAITING_PREVIOUS: 'waitingPrevious'
};
function $0385119c9c941a3e$var$Tone({ tone: tone, className: className, children: children, ...rest }) {
    const variant = tone === 'success' || tone === 'warning' ? tone : 'outline';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bHjRG.default), {
        variant: variant,
        className: (0, $5JYPc.cn)('gap-1 text-[0.65625rem] px-2', tone === 'info' && 'border-[var(--p-teal)] bg-[var(--p-teal-light)] text-[var(--p-navy-dark)]', tone === 'muted' && 'text-muted-foreground', className),
        ...rest
    }, children);
}
function $0385119c9c941a3e$var$BundleBadge({ count: count, testId: testId }) {
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0385119c9c941a3e$var$Tone, {
        tone: "info",
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ltuDQ.default), {
        size: 11,
        "aria-hidden": true
    }), t('visit.process.bundleParts', {
        count: count
    }));
}
// ── Catalogue picker ─────────────────────────────────────────────────────────
// The orders tab's picker rules (server page, browse on an empty query, «keep
// typing» under ORDER_MIN_QUERY) over a document that also returns bundles.
function $0385119c9c941a3e$var$StepPicker({ appointmentId: appointmentId, compact: compact, busy: busy, submitLabel: submitLabel, hint: hint, onAdd: onAdd, onClose: onClose, testId: testId }) {
    const { t: t, readsPersianData: readsPersianData, locale: locale } = (0, $LNQP4.default)();
    const [query, setQuery] = (0, $acw62.useState)('');
    const [type, setType] = (0, $acw62.useState)('all');
    const [page, setPage] = (0, $acw62.useState)({
        loading: true,
        error: null,
        entries: [],
        total: 0
    });
    const [picked, setPicked] = (0, $acw62.useState)(null);
    const [sessions, setSessions] = (0, $acw62.useState)('1');
    const typeLabels = (0, $6xvbB.ORDER_TYPE_FA)(t);
    (0, $acw62.useEffect)(()=>{
        let live = true;
        setPage((p)=>({
                ...p,
                loading: true,
                error: null
            }));
        const handle = setTimeout(()=>{
            (0, $hz8CN.searchProcessCatalog)({
                query: query,
                orderType: type === 'all' ? '' : type,
                appointmentId: appointmentId,
                minQuery: (0, $6xvbB.ORDER_MIN_QUERY)
            }).then((r)=>{
                if (live) setPage({
                    loading: false,
                    error: null,
                    ...r
                });
            }).catch((error)=>{
                if (live) setPage({
                    loading: false,
                    error: error,
                    entries: [],
                    total: 0
                });
            });
        }, query ? 250 : 0);
        return ()=>{
            live = false;
            clearTimeout(handle);
        };
    }, [
        query,
        type,
        appointmentId
    ]);
    const submit = async ()=>{
        if (!picked) return;
        const entry = picked;
        const ok = await onAdd(entry, sessions);
        // Only clear what was added: a second pick made while the write was in
        // flight is the doctor's next step, not something to throw away.
        if (ok !== false) {
            setPicked((cur)=>cur === entry ? null : cur);
            setSessions('1');
        }
    };
    const q = query.trim();
    const typeOptions = [
        {
            value: 'all',
            label: t('common.state.all')
        },
        {
            value: 'procedure',
            label: typeLabels.procedure
        },
        {
            value: 'lab',
            label: typeLabels.lab
        },
        {
            value: 'imaging',
            label: typeLabels.imaging
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId,
        className: "flex flex-col gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $5JYPc.cn)('flex gap-2', compact ? 'flex-col' : 'items-center')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $5JYPc.cn)(compact && 'max-w-full overflow-x-auto')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fYgeo.default), {
        semantics: "filter",
        size: compact ? 'lg' : 'sm',
        ariaLabel: t('visit.process.typeFilter'),
        options: typeOptions,
        value: type,
        onChange: setType
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $amyVq.default), {
        className: "flex-1",
        value: query,
        onChange: (e)=>setQuery(e.target.value),
        placeholder: t('visit.orders.searchCatalog'),
        clearLabel: t('common.actions.clearSearch'),
        inputProps: {
            'data-testid': `${testId}-search`
        }
    })), page.loading && !page.entries.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonRegion), {
        label: t('common.state.loading'),
        className: "flex flex-col gap-1.5"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        height: 30
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        height: 30
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        height: 30
    })) : page.error ? // Said out loud: a picker that silently lists nothing reads as a
    // catalogue that does not carry the service.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        role: "alert",
        "data-testid": `${testId}-error`,
        className: "m-0 text-xs text-destructive"
    }, t('visit.orders.catalogSearchFailed')) : page.entries.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        "data-testid": `${testId}-empty`,
        className: "m-0 text-xs text-muted-foreground"
    }, q && q.length < (0, $6xvbB.ORDER_MIN_QUERY) ? t('visit.orders.keepTyping') : t('visit.orders.noCatalogMatch')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        "data-testid": `${testId}-results`,
        className: "m-0 p-0 list-none max-h-56 overflow-y-auto flex flex-col gap-1"
    }, page.entries.map((entry)=>{
        const names = (0, $6xvbB.orderNameLines)(entry, readsPersianData, (0, $6xvbB.ownCatalogName)(entry, locale));
        const selected = picked?.id === entry.id;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: entry.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            "aria-pressed": selected,
            "data-testid": `${testId}-entry-${entry.id}`,
            onClick: ()=>setPicked(entry),
            className: (0, $5JYPc.cn)('w-full h-auto justify-start gap-2 px-2 py-1.5 font-normal text-start', compact ? 'min-h-11' : 'min-h-9', selected && 'bg-muted ring-1 ring-border')
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "flex-1 min-w-0 flex flex-col"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "text-[0.78125rem] font-semibold text-foreground truncate"
        }, names.primary), names.secondary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "text-[0.65625rem] text-muted-foreground truncate"
        }, names.secondary)), entry.isBundle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0385119c9c941a3e$var$BundleBadge, {
            count: (entry.parts || []).length,
            testId: `${testId}-bundle-${entry.id}`
        }), entry.inHouse && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0385119c9c941a3e$var$Tone, {
            tone: "success"
        }, t('visit.orders.thisClinic')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "text-[0.65625rem] text-muted-foreground whitespace-nowrap"
        }, typeLabels[entry.orderType] || entry.orderType)));
    }), page.total > page.entries.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        className: "text-center text-[0.6875rem] text-muted-foreground py-1"
    }, t('visit.rx.moreResults', {
        shown: page.entries.length,
        total: page.total
    }))), picked && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${testId}-picked`,
        className: "rounded-lg bg-muted p-2.5 flex flex-col gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "flex items-center gap-2 flex-wrap"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "text-[0.78125rem] font-bold text-foreground"
    }, (0, $6xvbB.orderNameLines)(picked, readsPersianData, (0, $6xvbB.ownCatalogName)(picked, locale)).primary), picked.isBundle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0385119c9c941a3e$var$BundleBadge, {
        count: (picked.parts || []).length
    })), picked.isBundle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        "data-testid": `${testId}-parts`,
        className: "m-0 p-0 list-none flex flex-col gap-0.5"
    }, (picked.parts || []).map((part)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: part.childId,
            className: "flex items-center gap-1.5 text-[0.71875rem] text-foreground"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ltuDQ.default), {
            size: 11,
            "aria-hidden": true,
            className: "text-muted-foreground"
        }), part.childName || part.childId, part.quantity > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "text-muted-foreground"
        }, t('visit.process.sessionsLabel', {
            count: part.quantity
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        className: "m-0 text-[0.6875rem] text-muted-foreground"
    }, t('visit.process.bundleFixed'))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "w-28"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9iIGe.default), {
        label: t('visit.process.sessionCount'),
        value: sessions,
        onChange: (e)=>setSessions(e.target.value),
        validate: ()=>'',
        "data-testid": `${testId}-sessions`
    })), hint && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        className: "m-0 text-[0.6875rem] text-muted-foreground"
    }, hint), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "flex items-center justify-end gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "teal",
        size: "sm",
        disabled: busy,
        onClick: submit,
        "data-testid": `${testId}-add`,
        className: (0, $5JYPc.cn)('gap-1.5', compact && 'min-h-11')
    }, busy ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 12,
        thickness: 2,
        color: "currentColor",
        label: t('common.state.saving')
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8g4t5.default), {
        size: 13,
        "aria-hidden": true
    }), submitLabel))), onClose && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "flex justify-end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        onClick: onClose,
        "data-testid": `${testId}-close`,
        className: (0, $5JYPc.cn)(compact && 'min-h-11')
    }, t('common.actions.close'))));
}
// ── Reorder arrows ───────────────────────────────────────────────────────────
function $0385119c9c941a3e$var$MoveButtons({ name: name, index: index, count: count, disabled: disabled, compact: compact, onMove: onMove, testId: testId }) {
    const { t: t } = (0, $LNQP4.default)();
    const size = compact ? 44 : 26;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "inline-flex items-center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5MbI8.default), {
        variant: "ghost",
        size: size,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $azOWV.default), {
            size: 14,
            "aria-hidden": true
        }),
        label: t('visit.process.moveUp', {
            name: name
        }),
        disabled: disabled || index === 0,
        onClick: ()=>onMove(index, -1),
        "data-testid": `${testId}-up`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5MbI8.default), {
        variant: "ghost",
        size: size,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2WFPf.default), {
            size: 14,
            "aria-hidden": true
        }),
        label: t('visit.process.moveDown', {
            name: name
        }),
        disabled: disabled || index === count - 1,
        onClick: ()=>onMove(index, 1),
        "data-testid": `${testId}-down`
    }));
}
// ── Builder: the process before it exists ───────────────────────────────────
let $0385119c9c941a3e$var$draftSeq = 0;
function $0385119c9c941a3e$var$ProcessBuilder({ appointmentId: appointmentId, compact: compact, busy: busy, onCreate: onCreate, onClose: onClose }) {
    const { t: t, formatNumber: formatNumber, readsPersianData: readsPersianData, locale: locale } = (0, $LNQP4.default)();
    const [title, setTitle] = (0, $acw62.useState)('');
    const [sequential, setSequential] = (0, $acw62.useState)(false);
    const [draft, setDraft] = (0, $acw62.useState)([]);
    const add = (entry, sessions)=>{
        $0385119c9c941a3e$var$draftSeq += 1;
        setDraft((d)=>[
                ...d,
                {
                    key: `d${$0385119c9c941a3e$var$draftSeq}`,
                    entry: entry,
                    sessions: sessions || '1'
                }
            ]);
        return true;
    };
    const move = (from, delta)=>setDraft((d)=>{
            const to = from + delta;
            if (to < 0 || to >= d.length) return d;
            const next = [
                ...d
            ];
            [next[from], next[to]] = [
                next[to],
                next[from]
            ];
            return next;
        });
    const remove = (key)=>setDraft((d)=>d.filter((x)=>x.key !== key));
    const setSessions = (key, value)=>setDraft((d)=>d.map((x)=>x.key === key ? {
                    ...x,
                    sessions: value
                } : x));
    const submit = ()=>onCreate({
            title: title.trim() || null,
            isSequential: sequential,
            steps: draft.map((d)=>(0, $hz8CN.stepInputFromEntry)(d.entry, d.sessions))
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-process-builder",
        className: "rounded-[10px] border border-dashed border-border p-3 flex flex-col gap-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $5JYPc.cn)('grid gap-3', compact ? 'grid-cols-1' : 'grid-cols-[1fr_auto] items-end')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
        label: t('visit.process.titleLabel'),
        placeholder: t('visit.process.titlePlaceholder'),
        value: title,
        onChange: (e)=>setTitle(e.target.value),
        "data-testid": "visit-process-title"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $5JYPc.cn)('flex items-center gap-2 text-[0.75rem] font-semibold text-foreground', compact ? 'min-h-11' : 'h-11')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cT2Zr.default), {
        checked: sequential,
        onChange: setSequential,
        label: t('visit.process.sequential')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, t('visit.process.sequential')))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        className: "m-0 text-[0.6875rem] text-muted-foreground"
    }, t('visit.process.sequentialHint')), draft.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        "data-testid": "visit-process-draft-empty",
        className: "m-0 text-xs text-muted-foreground"
    }, t('visit.process.draftEmpty')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ol", {
        "data-testid": "visit-process-draft",
        className: "m-0 p-0 list-none flex flex-col divide-y divide-border rounded-lg border border-border"
    }, draft.map((d, i)=>{
        // Named as the picker named it: the Persian `name` is what is sent.
        const name = (0, $6xvbB.orderNameLines)(d.entry, readsPersianData, (0, $6xvbB.ownCatalogName)(d.entry, locale)).primary;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: d.key,
            "data-testid": `visit-process-draft-${i}`,
            className: (0, $5JYPc.cn)('flex items-center gap-2 px-2 py-1.5', compact && 'flex-wrap')
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "w-5 h-5 shrink-0 grid place-items-center rounded-full bg-muted text-[0.6875rem] font-bold text-muted-foreground"
        }, formatNumber(i + 1)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "flex-1 min-w-0 text-[0.78125rem] font-semibold text-foreground truncate"
        }, name), d.entry.isBundle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0385119c9c941a3e$var$BundleBadge, {
            count: (d.entry.parts || []).length
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "w-20"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9iIGe.default), {
            "aria-label": t('visit.process.sessionCount'),
            value: d.sessions,
            onChange: (e)=>setSessions(d.key, e.target.value),
            validate: ()=>'',
            "data-testid": `visit-process-draft-${i}-sessions`
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0385119c9c941a3e$var$MoveButtons, {
            name: name,
            index: i,
            count: draft.length,
            compact: compact,
            onMove: move,
            testId: `visit-process-draft-${i}`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5MbI8.default), {
            variant: "ghost",
            size: compact ? 44 : 26,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
                size: 14,
                "aria-hidden": true
            }),
            label: t('visit.process.removeStep', {
                name: name
            }),
            onClick: ()=>remove(d.key),
            "data-testid": `visit-process-draft-${i}-remove`
        }));
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0385119c9c941a3e$var$StepPicker, {
        appointmentId: appointmentId,
        compact: compact,
        submitLabel: t('visit.process.addStep'),
        onAdd: add,
        testId: "visit-process-builder-picker"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "flex items-center justify-end gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "sm",
        onClick: onClose,
        disabled: busy,
        "data-testid": "visit-process-builder-cancel",
        className: (0, $5JYPc.cn)(compact && 'min-h-11')
    }, t('common.actions.cancel')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "teal",
        size: "sm",
        onClick: submit,
        disabled: busy || draft.length === 0,
        "data-testid": "visit-process-create",
        className: (0, $5JYPc.cn)('gap-1.5', compact && 'min-h-11')
    }, busy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 12,
        thickness: 2,
        color: "currentColor",
        label: t('common.state.saving')
    }), busy ? t('visit.process.creating') : t('visit.process.create'))));
}
// ── One process ──────────────────────────────────────────────────────────────
function $0385119c9c941a3e$var$StepChips({ step: step, readiness: readiness = true }) {
    const { t: t } = (0, $LNQP4.default)();
    const status = step.status || 'pending';
    const stage = (0, $ltciA.orderStageOf)({
        ...step,
        status: status
    });
    const lock = $0385119c9c941a3e$var$LOCK_KEYS[step.blockedReason];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, stage && stage !== 'REQUESTED' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0385119c9c941a3e$var$Tone, {
        tone: $0385119c9c941a3e$var$STEP_TONE[stage],
        "data-testid": `visit-process-step-${step.id}-status`,
        "data-stage": stage
    }, stage === 'DONE' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
        size: 10,
        "aria-hidden": true
    }), t((0, $ltciA.orderStageColors)[stage].labelKey)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aQGDs.OrderBookingLine), {
        order: step,
        compact: true,
        testid: `visit-process-step-${step.id}-booking`
    }), readiness && lock && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0385119c9c941a3e$var$Tone, {
        tone: lock === 'notApproved' ? 'warning' : 'muted',
        "data-testid": `visit-process-step-${step.id}-lock`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6lig1.default), {
        size: 10,
        "aria-hidden": true
    }), t(`visit.process.blocked.${lock}`)), readiness && !lock && step.ready && status === 'pending' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0385119c9c941a3e$var$Tone, {
        tone: "info",
        "data-testid": `visit-process-step-${step.id}-ready`
    }, t('visit.process.ready')));
}
// One chip per session row. Since PM-0618 a step has a row per session from the
// moment it is placed, so a row is not "done": each says its status from the one
// session map (constants/statuses `sessionStatusColors`). Only a DONE row can be
// voided; history rows (NOT_DONE / CANCELLED / VOIDED) are muted, with their reason.
function $0385119c9c941a3e$var$Sessions({ step: step, editable: editable, busy: busy, compact: compact, onVoid: onVoid }) {
    const { t: t, formatDate: formatDate } = (0, $LNQP4.default)();
    const sessions = [
        ...step.sessions || []
    ].sort((a, b)=>a.sessionNo - b.sessionNo || String(a.createdAt || '').localeCompare(String(b.createdAt || '')));
    if (!sessions.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        "data-testid": `visit-process-step-${step.id}-sessions`,
        className: "m-0 p-0 list-none flex flex-wrap gap-1.5"
    }, sessions.map((s)=>{
        const status = (0, $ltciA.sessionStatusOf)(s);
        const st = (0, $ltciA.sessionStatusColors)[status] || (0, $ltciA.sessionStatusColors).REQUESTED;
        const voided = status === 'VOIDED';
        const history = st.history;
        const reason = status === 'NOT_DONE' ? s.notDoneReason : s.voidReason;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: s.id,
            "data-testid": `visit-process-session-${s.id}`,
            "data-status": status,
            "data-voided": voided || undefined,
            className: "inline-flex items-center gap-1 rounded-full border border-border bg-white ps-2 pe-1 py-0.5 text-[0.6875rem] text-foreground"
        }, voided ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1comv.default), {
            size: 11,
            "aria-hidden": true,
            className: "text-muted-foreground"
        }) : status === 'DONE' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
            size: 11,
            "aria-hidden": true,
            className: "text-[var(--chip-success-ink)]"
        }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: (0, $5JYPc.cn)(history && 'text-muted-foreground', voided && 'line-through')
        }, t('visit.process.session', {
            no: s.sessionNo
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "data-testid": `visit-process-session-${s.id}-status`,
            style: {
                background: st.bg,
                color: st.text,
                borderRadius: 999,
                padding: '0 6px',
                fontWeight: 600,
                opacity: history ? 0.75 : 1
            }
        }, t(st.labelKey)), status === 'DONE' && s.performedAt && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "text-muted-foreground"
        }, formatDate(s.performedAt, 'short')), voided && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "text-muted-foreground"
        }, s.voidReason ? t('visit.process.voidedReason', {
            reason: s.voidReason
        }) : t('visit.process.voided')), !voided && history && reason && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "text-muted-foreground"
        }, "(", reason, ")"), editable && status === 'DONE' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5MbI8.default), {
            variant: "ghost",
            size: compact ? 44 : 20,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1comv.default), {
                size: 11,
                "aria-hidden": true
            }),
            label: t('visit.process.voidSessionAria', {
                no: s.sessionNo,
                name: step.description
            }),
            disabled: busy,
            onClick: ()=>onVoid(step, s),
            "data-testid": `visit-process-session-${s.id}-void`
        }));
    }));
}
function $0385119c9c941a3e$var$DoneButton({ step: step, busy: busy, spinning: spinning, compact: compact, onRecord: onRecord }) {
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "teal",
        size: "sm",
        disabled: busy,
        onClick: ()=>onRecord(step),
        "aria-label": t('visit.process.markDoneAria', {
            name: step.description
        }),
        "data-testid": `visit-process-step-${step.id}-done`,
        className: (0, $5JYPc.cn)('gap-1 shrink-0', compact ? 'min-h-11 px-3' : 'h-7 px-2.5')
    }, spinning ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 11,
        thickness: 2,
        color: "currentColor",
        label: t('common.state.saving')
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
        size: 12,
        "aria-hidden": true
    }), t('visit.process.markDone'));
}
function $0385119c9c941a3e$var$ProcessCard({ process: process, editable: editable, compact: compact, busy: busy, earlier: earlier, appointmentId: appointmentId, onMove: onMove, onToggleSequential: onToggleSequential, onAddStep: onAddStep, onRecord: onRecord, onCancelStep: onCancelStep, onCancelProcess: onCancelProcess, onVoid: onVoid }) {
    const { t: t, formatNumber: formatNumber, formatDate: formatDate } = (0, $LNQP4.default)();
    const [adding, setAdding] = (0, $acw62.useState)(false);
    const live = (0, $hz8CN.isLiveProcess)(process);
    const cancelled = !!process.cancelledAt || process.status === 'CANCELLED';
    const steps = process.steps || [];
    const reorderable = editable && (0, $hz8CN.canReorder)(process);
    const sequentialLocked = (0, $hz8CN.hasLiveSession)(process);
    const anyApproved = steps.some((s)=>!!s.approvedAt);
    const [statusKey, statusTone] = $0385119c9c941a3e$var$PROCESS_STATUS[process.status] || $0385119c9c941a3e$var$PROCESS_STATUS.PROPOSED;
    const isBusy = !!busy;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("article", {
        "data-testid": `visit-process-${process.id}`,
        "data-status": process.status,
        className: "rounded-[10px] border border-border bg-white overflow-hidden"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "flex flex-wrap items-center gap-2 px-3 py-2 border-b border-border bg-muted"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "text-[0.78125rem] font-bold text-foreground min-w-0 truncate"
    }, process.title || t('visit.process.title')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0385119c9c941a3e$var$Tone, {
        tone: statusTone,
        "data-testid": `visit-process-${process.id}-status`
    }, t(`visit.process.status.${statusKey}`)), earlier && process.createdAt && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "text-[0.6875rem] text-muted-foreground"
    }, formatDate(process.createdAt, 'medium')), !editable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "text-[0.6875rem] text-muted-foreground"
    }, t('visit.process.otherDoctor')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $5JYPc.cn)('flex items-center gap-2', compact ? 'w-full justify-between' : 'ms-auto')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "flex items-center gap-2 text-[0.71875rem] text-muted-foreground",
        title: editable && live && sequentialLocked ? t('visit.process.sequentialLocked') : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cT2Zr.default), {
        checked: !!process.isSequential,
        onChange: (next)=>onToggleSequential(process, next),
        disabled: !editable || cancelled || !live || sequentialLocked || isBusy,
        label: t('visit.process.sequential')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, t('visit.process.sequential'))), editable && live && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        disabled: isBusy,
        onClick: ()=>onCancelProcess(process),
        "data-testid": `visit-process-${process.id}-cancel`,
        className: (0, $5JYPc.cn)('text-destructive', compact ? 'min-h-11 px-3' : 'h-7 px-2')
    }, t('visit.process.cancelProcess')))), cancelled && process.cancelReason && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        className: "m-0 px-3 pt-2 text-[0.71875rem] text-muted-foreground"
    }, t('visit.process.cancelledWithReason', {
        reason: process.cancelReason
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ol", {
        className: "m-0 p-0 list-none flex flex-col divide-y divide-border"
    }, steps.map((step, i)=>{
        const open = (0, $hz8CN.isOpenStep)(step);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: step.id,
            "data-testid": `visit-process-step-${step.id}`,
            "data-ready": step.ready ? 'true' : 'false',
            "data-blocked": step.blockedReason || undefined,
            className: "px-3 py-2 flex flex-col gap-1.5"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $5JYPc.cn)('flex items-center gap-2', compact && 'flex-wrap')
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "w-5 h-5 shrink-0 grid place-items-center rounded-full bg-muted text-[0.6875rem] font-bold text-muted-foreground"
        }, formatNumber(i + 1)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: (0, $5JYPc.cn)('min-w-0 truncate text-[0.78125rem] font-semibold text-foreground', step.status === 'cancelled' && 'line-through text-muted-foreground')
        }, step.description), step.isBundle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0385119c9c941a3e$var$BundleBadge, {
            count: (step.parts || []).length,
            testId: `visit-process-step-${step.id}-bundle`
        }), step.sessionCount > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "data-testid": `visit-process-step-${step.id}-progress`,
            className: "text-[0.6875rem] text-muted-foreground whitespace-nowrap"
        }, t('visit.process.sessionsProgress', {
            done: step.completedSessions || 0,
            total: step.sessionCount
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0385119c9c941a3e$var$StepChips, {
            step: step
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $5JYPc.cn)('flex items-center gap-1 shrink-0', compact ? 'w-full justify-end' : 'ms-auto')
        }, reorderable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0385119c9c941a3e$var$MoveButtons, {
            name: step.description,
            index: i,
            count: steps.length,
            compact: compact,
            disabled: isBusy,
            onMove: (from, delta)=>onMove(process, from, delta),
            testId: `visit-process-step-${step.id}`
        }), editable && step.ready && !step.isBundle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0385119c9c941a3e$var$DoneButton, {
            step: step,
            busy: isBusy,
            spinning: busy === `record:${step.id}`,
            compact: compact,
            onRecord: (s)=>onRecord(process, s)
        }), editable && open && !cancelled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            size: "sm",
            disabled: isBusy,
            onClick: ()=>onCancelStep(process, step),
            "data-testid": `visit-process-step-${step.id}-cancel`,
            className: (0, $5JYPc.cn)('text-destructive', compact ? 'min-h-11 px-3' : 'h-7 px-2')
        }, t('visit.process.cancelStep')))), step.status === 'cancelled' && step.cancelReason && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
            className: "m-0 ps-7 text-[0.6875rem] text-muted-foreground"
        }, t('visit.process.cancelledWithReason', {
            reason: step.cancelReason
        })), !step.isBundle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "ps-7"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0385119c9c941a3e$var$Sessions, {
            step: step,
            editable: editable,
            busy: isBusy,
            compact: compact,
            onVoid: (s, x)=>onVoid(process, s, x)
        })), step.isBundle && // The parts are fixed (D13): no reorder, no cancel of their own
        // (D16). Each is performed — and recorded — on its own; the
        // bundle completes, and bills once, with the last of them.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
            "data-testid": `visit-process-step-${step.id}-parts`,
            className: "m-0 ps-7 list-none flex flex-col gap-1"
        }, (step.parts || []).map((part)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
                key: part.id,
                "data-testid": `visit-process-part-${part.id}`,
                className: "flex flex-col gap-1"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: (0, $5JYPc.cn)('flex items-center gap-2', compact && 'flex-wrap')
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ltuDQ.default), {
                size: 12,
                "aria-hidden": true,
                className: "shrink-0 text-muted-foreground"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: (0, $5JYPc.cn)('min-w-0 truncate text-[0.75rem] text-foreground', part.status === 'cancelled' && 'line-through text-muted-foreground')
            }, part.description), part.sessionCount > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: "text-[0.6875rem] text-muted-foreground whitespace-nowrap"
            }, t('visit.process.sessionsProgress', {
                done: part.completedSessions || 0,
                total: part.sessionCount
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0385119c9c941a3e$var$StepChips, {
                step: part,
                readiness: false
            }), editable && part.ready && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: (0, $5JYPc.cn)('flex items-center', compact ? 'w-full justify-end' : 'ms-auto')
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0385119c9c941a3e$var$DoneButton, {
                step: part,
                busy: isBusy,
                spinning: busy === `record:${part.id}`,
                compact: compact,
                onRecord: (s)=>onRecord(process, s)
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0385119c9c941a3e$var$Sessions, {
                step: part,
                editable: editable,
                busy: isBusy,
                compact: compact,
                onVoid: (s, x)=>onVoid(process, s, x)
            })))));
    })), editable && !cancelled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "px-3 py-2 border-t border-border"
    }, adding ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0385119c9c941a3e$var$StepPicker, {
        appointmentId: appointmentId,
        compact: compact,
        busy: busy === `add:${process.id}`,
        submitLabel: t('visit.process.addToProcess'),
        hint: anyApproved ? t('visit.process.lateStepHint') : null,
        onAdd: async (entry, sessions)=>{
            const ok = await onAddStep(process, entry, sessions);
            if (ok) setAdding(false);
            return ok;
        },
        onClose: ()=>setAdding(false),
        testId: `visit-process-${process.id}-picker`
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        disabled: isBusy,
        onClick: ()=>setAdding(true),
        "data-testid": `visit-process-${process.id}-add`,
        className: (0, $5JYPc.cn)('gap-1', compact ? 'min-h-11 px-3' : 'h-7 px-2')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8g4t5.default), {
        size: 13,
        "aria-hidden": true
    }), t('visit.process.addStep'))));
}
function $0385119c9c941a3e$export$2e2bcd8739ae039({ appointmentId: appointmentId, patientId: patientId, doctorId: doctorId, compact: compact = false, className: className }) {
    const { t: t, has: has, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const [processes, setProcesses] = (0, $acw62.useState)(null);
    const [loadError, setLoadError] = (0, $acw62.useState)(null);
    const [unsupported, setUnsupported] = (0, $acw62.useState)(false);
    const [actionError, setActionError] = (0, $acw62.useState)(null);
    const [busy, setBusy] = (0, $acw62.useState)(null);
    const [building, setBuilding] = (0, $acw62.useState)(false);
    const [showEarlier, setShowEarlier] = (0, $acw62.useState)(false);
    const [confirm, setConfirm] = (0, $acw62.useState)(null);
    const [reason, setReason] = (0, $acw62.useState)('');
    const loadSeq = (0, $acw62.useRef)(0);
    const busyRef = (0, $acw62.useRef)(null);
    const load = (0, $acw62.useCallback)(async ()=>{
        if (!appointmentId) return;
        const seq = ++loadSeq.current;
        setLoadError(null);
        try {
            const data = await (0, $eVM84.bffQuery)((0, $hz8CN.LIST_TREATMENT_PROCESSES), patientId ? {
                patientId: patientId
            } : {
                appointmentId: appointmentId
            });
            if (seq === loadSeq.current) setProcesses(data?.treatmentProcesses || []);
        } catch (err) {
            if (seq !== loadSeq.current) return;
            if ((0, $hz8CN.isSchemaMissing)(err)) setUnsupported(true);
            else setLoadError(err);
        }
    }, [
        appointmentId,
        patientId
    ]);
    (0, $acw62.useEffect)(()=>{
        setProcesses(null);
        load();
    }, [
        load
    ]);
    const putProcess = (p)=>{
        if (!p) return;
        setProcesses((prev)=>{
            const list = prev || [];
            return list.some((x)=>x.id === p.id) ? list.map((x)=>x.id === p.id ? p : x) : [
                p,
                ...list
            ];
        });
    };
    // One write at a time across the panel: two taps on «انجام شد» must not be
    // two sessions, and a reorder must not race a cancel.
    const run = async (key, fallbackKey, fn)=>{
        if (busyRef.current) return false;
        busyRef.current = key;
        setBusy(key);
        setActionError(null);
        try {
            await fn();
            return true;
        } catch (err) {
            setActionError((0, $hz8CN.treatmentErrorText)(t, has, err, fallbackKey));
            return false;
        } finally{
            busyRef.current = null;
            setBusy(null);
        }
    };
    // A step write answers with that step only, but its session may have opened
    // the next step of a sequential process and moved the process status — so the
    // whole process is read back. If that read fails the step itself is already
    // current, and the rest is re-read on the next load.
    const afterStepWrite = async (process, step)=>{
        if (step) setProcesses((prev)=>(prev || []).map((x)=>x.id === process.id ? (0, $hz8CN.replaceStep)(x, step) : x));
        try {
            const data = await (0, $eVM84.bffQuery)((0, $hz8CN.GET_TREATMENT_PROCESS), {
                id: process.id
            });
            putProcess(data?.treatmentProcess);
        } catch  {}
    };
    const create = (input)=>run('create', 'errors.bff.treatment.createFailed', async ()=>{
            const data = await (0, $eVM84.bffMutation)((0, $hz8CN.CREATE_TREATMENT_PROCESS), {
                input: {
                    appointmentId: appointmentId,
                    patientId: patientId,
                    title: input.title,
                    isSequential: input.isSequential,
                    steps: input.steps
                }
            });
            putProcess(data?.createTreatmentProcess);
            setBuilding(false);
        });
    const addStep = (process, entry, sessions)=>run(`add:${process.id}`, 'errors.bff.treatment.editFailed', async ()=>{
            const data = await (0, $eVM84.bffMutation)((0, $hz8CN.ADD_TREATMENT_STEP), {
                processId: process.id,
                step: (0, $hz8CN.stepInputFromEntry)(entry, sessions)
            });
            putProcess(data?.addTreatmentStep);
        });
    const move = (process, from, delta)=>{
        const orderIds = (0, $hz8CN.movedStepIds)(process.steps, from, delta);
        if (!orderIds) return;
        run(`move:${process.id}`, 'errors.bff.treatment.editFailed', async ()=>{
            const data = await (0, $eVM84.bffMutation)((0, $hz8CN.REORDER_TREATMENT_STEPS), {
                processId: process.id,
                orderIds: orderIds
            });
            putProcess(data?.reorderTreatmentSteps);
        });
    };
    const toggleSequential = (process, next)=>run(`seq:${process.id}`, 'errors.bff.treatment.editFailed', async ()=>{
            const data = await (0, $eVM84.bffMutation)((0, $hz8CN.UPDATE_TREATMENT_PROCESS), {
                processId: process.id,
                isSequential: next
            });
            putProcess(data?.updateTreatmentProcess);
        });
    const record = (process, step)=>run(`record:${step.id}`, 'errors.bff.treatment.recordFailed', async ()=>{
            const data = await (0, $eVM84.bffMutation)((0, $hz8CN.RECORD_ORDER_SESSION), {
                orderId: step.id,
                appointmentId: appointmentId
            });
            await afterStepWrite(process, data?.recordOrderSession);
        });
    const ask = (next)=>{
        setReason('');
        setConfirm(next);
    };
    const confirmNow = ()=>{
        const c = confirm;
        const why = reason.trim();
        if (!c) return;
        if (c.kind === 'cancelProcess') run(`cancel:${c.process.id}`, 'errors.bff.treatment.cancelFailed', async ()=>{
            const data = await (0, $eVM84.bffMutation)((0, $hz8CN.CANCEL_TREATMENT_PROCESS), {
                processId: c.process.id,
                reason: why || null
            });
            putProcess(data?.cancelTreatmentProcess);
        });
        else if (c.kind === 'cancelStep') run(`cancel:${c.step.id}`, 'errors.bff.treatment.cancelFailed', async ()=>{
            const data = await (0, $eVM84.bffMutation)((0, $hz8CN.CANCEL_TREATMENT_STEP), {
                orderId: c.step.id,
                reason: why || null
            });
            await afterStepWrite(c.process, data?.cancelTreatmentStep);
        });
        else if (c.kind === 'void' && why) run(`void:${c.session.id}`, 'errors.bff.treatment.voidFailed', async ()=>{
            const data = await (0, $eVM84.bffMutation)((0, $hz8CN.VOID_ORDER_SESSION), {
                sessionId: c.session.id,
                reason: why
            });
            await afterStepWrite(c.process, data?.voidOrderSession);
        });
    };
    if (unsupported) return null;
    const list = processes || [];
    const thisVisit = list.filter((p)=>p.appointmentId === appointmentId);
    const earlier = list.filter((p)=>p.appointmentId !== appointmentId && (0, $hz8CN.isLiveProcess)(p));
    const editableOf = (p)=>doctorId ? p.doctorId === doctorId : p.appointmentId === appointmentId;
    const canBuild = !!appointmentId && !!patientId && processes !== null && !building;
    const cardProps = {
        compact: compact,
        busy: busy,
        appointmentId: appointmentId,
        onMove: move,
        onToggleSequential: toggleSequential,
        onAddStep: addStep,
        onRecord: record,
        onCancelStep: (process, step)=>ask({
                kind: 'cancelStep',
                process: process,
                step: step
            }),
        onCancelProcess: (process)=>ask({
                kind: 'cancelProcess',
                process: process
            }),
        onVoid: (process, step, session)=>ask({
                kind: 'void',
                process: process,
                step: step,
                session: session
            })
    };
    const dialog = confirm && ({
        cancelProcess: {
            title: t('visit.process.cancelProcessTitle'),
            body: t('visit.process.cancelProcessBody'),
            confirm: t('visit.process.cancelProcess')
        },
        cancelStep: {
            title: t('visit.process.cancelStepTitle', {
                name: confirm.step?.description || ''
            }),
            body: t('visit.process.cancelStepBody'),
            confirm: t('visit.process.cancelStep')
        },
        void: {
            title: t('visit.process.voidTitle', {
                no: confirm.session?.sessionNo ?? '',
                name: confirm.step?.description || ''
            }),
            body: t('visit.process.voidBody'),
            confirm: t('visit.process.voidConfirm')
        }
    })[confirm.kind];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
        "data-testid": "visit-process-panel",
        "aria-label": t('visit.process.title'),
        className: (0, $5JYPc.cn)('rounded-[14px] border border-border bg-white overflow-hidden', className)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("header", {
        className: "flex items-center justify-between gap-2 px-4 py-2.5 border-b border-border bg-muted"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "flex items-center gap-2 text-[0.8125rem] font-semibold text-foreground"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "grid place-items-center w-[22px] h-[22px] rounded-md bg-[var(--p-teal-light)] text-[var(--p-navy-dark)]"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2SsUu.default), {
        size: 12,
        "aria-hidden": true
    })), t('visit.process.title'), thisVisit.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0385119c9c941a3e$var$Tone, {
        tone: "muted"
    }, formatNumber(thisVisit.length))), canBuild && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "sm",
        onClick: ()=>setBuilding(true),
        disabled: !!busy,
        "data-testid": "visit-process-new",
        className: (0, $5JYPc.cn)('gap-1', compact ? 'min-h-11' : 'h-8 px-3')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8g4t5.default), {
        size: 13,
        "aria-hidden": true
    }), t('visit.process.new'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $5JYPc.cn)('flex flex-col gap-3', compact ? 'p-3' : 'p-4')
    }, actionError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "error",
        role: "alert",
        "data-testid": "visit-process-error",
        action: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5MbI8.default), {
            variant: "ghost",
            size: compact ? 44 : 28,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
                size: 14,
                "aria-hidden": true
            }),
            label: t('errors.dismiss'),
            onClick: ()=>setActionError(null)
        })
    }, actionError), !appointmentId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        "data-testid": "visit-process-needs-visit",
        className: "m-0 text-xs text-muted-foreground"
    }, t('visit.process.needsVisit')) : loadError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dLdf9.default), {
        error: loadError,
        title: t('visit.process.loadFailed'),
        onRetry: load
    }) : processes === null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonRegion), {
        label: t('common.state.loading'),
        "data-testid": "visit-process-loading",
        className: "flex flex-col gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        height: 40
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        height: 40
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, building && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0385119c9c941a3e$var$ProcessBuilder, {
        appointmentId: appointmentId,
        compact: compact,
        busy: busy === 'create',
        onCreate: create,
        onClose: ()=>setBuilding(false)
    }), thisVisit.length === 0 && !building && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        "data-testid": "visit-process-empty",
        className: "m-0 text-xs text-muted-foreground leading-6"
    }, t('visit.process.emptyHint')), thisVisit.map((p)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0385119c9c941a3e$var$ProcessCard, {
            key: p.id,
            process: p,
            editable: editableOf(p),
            ...cardProps
        })), earlier.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "flex flex-col gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        "aria-expanded": showEarlier,
        onClick: ()=>setShowEarlier((v)=>!v),
        "data-testid": "visit-process-earlier-toggle",
        className: (0, $5JYPc.cn)('self-start gap-1.5 text-muted-foreground', compact ? 'min-h-11' : 'h-8 px-2')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $i5dmF.default), {
        size: 13,
        "aria-hidden": true
    }), t('visit.process.earlier'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0385119c9c941a3e$var$Tone, {
        tone: "muted"
    }, formatNumber(earlier.length))), showEarlier && earlier.map((p)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0385119c9c941a3e$var$ProcessCard, {
            key: p.id,
            process: p,
            editable: editableOf(p),
            earlier: true,
            ...cardProps
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3OnFU.default), {
        open: !!confirm,
        onOpenChange: (open)=>{
            if (!open) {
                setConfirm(null);
                setReason('');
            }
        },
        title: dialog?.title,
        description: dialog?.body,
        confirmLabel: dialog?.confirm,
        // The confirm button of a cancellation is itself «لغو»: dismissing it says
        // «بازگشت», never a second «Annuler» beside it (PM-0185 style §2).
        cancelLabel: confirm?.kind === 'void' ? undefined : t('common.actions.back'),
        destructive: true,
        confirmDisabled: confirm?.kind === 'void' && !reason.trim(),
        onConfirm: confirmNow,
        "data-testid": "visit-process-dialog",
        confirmTestId: "visit-process-dialog-confirm",
        cancelTestId: "visit-process-dialog-cancel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $iygI2.default), {
        label: confirm?.kind === 'void' ? t('visit.process.reasonRequired') : t('visit.process.reasonOptional'),
        required: confirm?.kind === 'void',
        value: reason,
        onChange: (e)=>setReason(e.target.value),
        rows: 2,
        "data-testid": "visit-process-reason"
    })));
}

});
parcelRegister("2SsUu", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fb6c94f3b917ca1$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $6fb6c94f3b917ca1$export$a2387ed3b5d536eb = {
    name: "list-checks",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M13 5h8",
                key: "a7qcls"
            }
        ],
        [
            "path",
            {
                d: "M13 12h8",
                key: "h98zly"
            }
        ],
        [
            "path",
            {
                d: "M13 19h8",
                key: "c3s6r1"
            }
        ],
        [
            "path",
            {
                d: "m3 17 2 2 4-4",
                key: "1jhpwq"
            }
        ],
        [
            "path",
            {
                d: "m3 7 2 2 4-4",
                key: "1obspn"
            }
        ]
    ]
};
$6fb6c94f3b917ca1$export$a2387ed3b5d536eb.node;
const $6fb6c94f3b917ca1$export$2e2bcd8739ae039 = (0, $9QBug.default)($6fb6c94f3b917ca1$export$a2387ed3b5d536eb);

});

parcelRegister("1comv", function(module, exports) {

$parcel$export(module.exports, "default", () => $3645c7b532883384$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $3645c7b532883384$export$a2387ed3b5d536eb = {
    name: "undo-2",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M9 14 4 9l5-5",
                key: "102s5s"
            }
        ],
        [
            "path",
            {
                d: "M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5a5.5 5.5 0 0 1-5.5 5.5H11",
                key: "f3b9sd"
            }
        ]
    ]
};
$3645c7b532883384$export$a2387ed3b5d536eb.node;
const $3645c7b532883384$export$2e2bcd8739ae039 = (0, $9QBug.default)($3645c7b532883384$export$a2387ed3b5d536eb);

});

parcelRegister("hz8CN", function(module, exports) {

$parcel$export(module.exports, "LIST_TREATMENT_PROCESSES", () => $cc9c65451b327263$export$ded596a6f695eb70);
$parcel$export(module.exports, "GET_TREATMENT_PROCESS", () => $cc9c65451b327263$export$9654bb78a2d6522c);
$parcel$export(module.exports, "CREATE_TREATMENT_PROCESS", () => $cc9c65451b327263$export$437e33b36726a318);
$parcel$export(module.exports, "ADD_TREATMENT_STEP", () => $cc9c65451b327263$export$bda37785cd9face4);
$parcel$export(module.exports, "REORDER_TREATMENT_STEPS", () => $cc9c65451b327263$export$576c4c8d321ab8be);
$parcel$export(module.exports, "UPDATE_TREATMENT_PROCESS", () => $cc9c65451b327263$export$6dd17c00d60d61ff);
$parcel$export(module.exports, "CANCEL_TREATMENT_PROCESS", () => $cc9c65451b327263$export$aac1481a680a885b);
$parcel$export(module.exports, "CANCEL_TREATMENT_STEP", () => $cc9c65451b327263$export$77405f779326be7d);
$parcel$export(module.exports, "RECORD_ORDER_SESSION", () => $cc9c65451b327263$export$e270757d3cbed79f);
$parcel$export(module.exports, "VOID_ORDER_SESSION", () => $cc9c65451b327263$export$472bbc624aac8d8);
$parcel$export(module.exports, "searchProcessCatalog", () => $cc9c65451b327263$export$85f2b5118ae3d90f);
$parcel$export(module.exports, "isOpenStep", () => $cc9c65451b327263$export$7aebe44be0193f30);
$parcel$export(module.exports, "isLiveProcess", () => $cc9c65451b327263$export$d3f4649a1e650bff);
$parcel$export(module.exports, "canReorder", () => $cc9c65451b327263$export$eecaad90352df6df);
$parcel$export(module.exports, "hasLiveSession", () => $cc9c65451b327263$export$12467dc22e28ee1d);
$parcel$export(module.exports, "replaceStep", () => $cc9c65451b327263$export$ed6ac67359824afd);
$parcel$export(module.exports, "movedStepIds", () => $cc9c65451b327263$export$1dac6939cf74bd);
$parcel$export(module.exports, "stepInputFromEntry", () => $cc9c65451b327263$export$5b2832ec8df1654c);
$parcel$export(module.exports, "treatmentErrorText", () => $cc9c65451b327263$export$2cc0e11189006055);
$parcel$export(module.exports, "isSchemaMissing", () => $cc9c65451b327263$export$c2acac313c7201fb);
// «پروسهٔ درمان» — the GraphQL documents and the pure helpers behind
// TreatmentProcessPanel (docs/TREATMENT_PROCESS_AND_SERVICE_BUNDLES_PLAN.md §8).
//
// Its own module rather than more lines in Visit.shared.jsx, for one reason that
// matters at release time: every document here names fields only the doctor BFF
// that ships the treatment schema knows (`treatmentProcesses`, `isBundle`,
// `parts`). Kept apart, the orders tab's own catalogue query (SEARCH_CATALOG)
// is untouched, so a kit released ahead of that BFF costs the visit nothing but
// this panel — which hides itself on a schema that does not know it (see
// `isSchemaMissing`).
//
// The panel never derives a status or a lock. `ready`, `blockedReason`,
// `status` and the process status all come from clinicalencounter; what this
// module decides is only which AFFORDANCES to draw, and the service refuses
// anything drawn wrongly.

var $eVM84 = parcelRequire("eVM84");

var $cwVZP = parcelRequire("cwVZP");

var $6xvbB = parcelRequire("6xvbB");

var $ltciA = parcelRequire("ltciA");
// ── Documents ────────────────────────────────────────────────────────────────
// `status` / `plannedDate` / `notDoneReason` since PM-0618 (§6.2).
const $cc9c65451b327263$var$SESSION_FIELDS = 'id sessionNo appointmentId performerId performerType performedAt outcome voidedAt voidReason status plannedDate notDoneReason';
// A bundle's parts are TreatmentSteps one level down (D13: bundles do not nest),
// so they ask for everything a step does except `parts`.
const $cc9c65451b327263$var$STEP_CORE = `id processId sequenceNo catalogId orderType description urgency notes status sessionCount completedSessions approvedAt cancelledAt cancelReason ready blockedReason isBundle performedDate performedHere stage nextBookingAt sessions{${$cc9c65451b327263$var$SESSION_FIELDS}}`;
const $cc9c65451b327263$var$STEP_FIELDS = `${$cc9c65451b327263$var$STEP_CORE} parts{${$cc9c65451b327263$var$STEP_CORE}}`;
const $cc9c65451b327263$var$PROCESS_FIELDS = `id appointmentId patientId doctorId title isSequential status createdAt cancelledAt cancelReason steps{${$cc9c65451b327263$var$STEP_FIELDS}}`;
const $cc9c65451b327263$export$ded596a6f695eb70 = `query TreatmentProcesses($appointmentId:ID,$patientId:ID){treatmentProcesses(appointmentId:$appointmentId,patientId:$patientId){${$cc9c65451b327263$var$PROCESS_FIELDS}}}`;
const $cc9c65451b327263$export$9654bb78a2d6522c = `query TreatmentProcess($id:ID!){treatmentProcess(id:$id){${$cc9c65451b327263$var$PROCESS_FIELDS}}}`;
const $cc9c65451b327263$export$437e33b36726a318 = `mutation CreateTreatmentProcess($input:CreateTreatmentProcessInput!){createTreatmentProcess(input:$input){${$cc9c65451b327263$var$PROCESS_FIELDS}}}`;
const $cc9c65451b327263$export$bda37785cd9face4 = `mutation AddTreatmentStep($processId:ID!,$step:TreatmentStepInput!){addTreatmentStep(processId:$processId,step:$step){${$cc9c65451b327263$var$PROCESS_FIELDS}}}`;
const $cc9c65451b327263$export$576c4c8d321ab8be = `mutation ReorderTreatmentSteps($processId:ID!,$orderIds:[ID!]!){reorderTreatmentSteps(processId:$processId,orderIds:$orderIds){${$cc9c65451b327263$var$PROCESS_FIELDS}}}`;
const $cc9c65451b327263$export$6dd17c00d60d61ff = `mutation UpdateTreatmentProcess($processId:ID!,$title:String,$isSequential:Boolean){updateTreatmentProcess(processId:$processId,title:$title,isSequential:$isSequential){${$cc9c65451b327263$var$PROCESS_FIELDS}}}`;
const $cc9c65451b327263$export$aac1481a680a885b = `mutation CancelTreatmentProcess($processId:ID!,$reason:String){cancelTreatmentProcess(processId:$processId,reason:$reason){${$cc9c65451b327263$var$PROCESS_FIELDS}}}`;
const $cc9c65451b327263$export$77405f779326be7d = `mutation CancelTreatmentStep($orderId:ID!,$reason:String){cancelTreatmentStep(orderId:$orderId,reason:$reason){${$cc9c65451b327263$var$STEP_FIELDS}}}`;
const $cc9c65451b327263$export$e270757d3cbed79f = `mutation RecordOrderSession($orderId:ID!,$appointmentId:ID,$sessionNo:Int){recordOrderSession(orderId:$orderId,appointmentId:$appointmentId,sessionNo:$sessionNo){${$cc9c65451b327263$var$STEP_FIELDS}}}`;
const $cc9c65451b327263$export$472bbc624aac8d8 = `mutation VoidOrderSession($sessionId:ID!,$reason:String!){voidOrderSession(sessionId:$sessionId,reason:$reason){${$cc9c65451b327263$var$STEP_FIELDS}}}`;
const $cc9c65451b327263$export$69e17ba6f90ba607 = `query SearchProcessCatalog($query:String,$orderType:String,$appointmentId:ID,$limit:Int,$offset:Int){searchClinicalOrderCatalog(query:$query,orderType:$orderType,appointmentId:$appointmentId,limit:$limit,offset:$offset){total entries{id orderType name nameEn nameAr nameFr nameDe category code codeSystem modality bodyPart inHouse isClinicOwned isBundle parts{childId quantity childName childOrderType}}}}`;
const $cc9c65451b327263$export$208e1de6c5d1e37f = 30;
// `nameFr` (PM-0185) may be newer than the BFF answering: refused, the question
// is asked again without it — as the orders tab's is (Visit.shared
// askWithoutNameFrWhenRefused) — rather than leave the picker empty. `nameDe`
// (PM-0212) is shed the same way, wrapped outside `nameFr` as the orders tab's.
const $cc9c65451b327263$var$askProcessCatalog = (0, $6xvbB.askWithoutNameDeWhenRefused)((0, $6xvbB.askWithoutNameFrWhenRefused)((0, $eVM84.bffQuery)));
async function $cc9c65451b327263$export$85f2b5118ae3d90f({ query: query = '', orderType: orderType = '', appointmentId: appointmentId = null, minQuery: minQuery = 2 } = {}) {
    const q = (query || '').trim();
    if (q && q.length < minQuery) return {
        entries: [],
        total: 0
    };
    const data = await $cc9c65451b327263$var$askProcessCatalog($cc9c65451b327263$export$69e17ba6f90ba607, {
        query: q || null,
        orderType: orderType || null,
        appointmentId: appointmentId,
        limit: $cc9c65451b327263$export$208e1de6c5d1e37f,
        offset: 0
    });
    return {
        entries: data?.searchClinicalOrderCatalog?.entries || [],
        total: data?.searchClinicalOrderCatalog?.total || 0
    };
}
// ── Reading a process ────────────────────────────────────────────────────────
const $cc9c65451b327263$var$OPEN_STEP = new Set([
    'pending',
    'in_progress'
]);
const $cc9c65451b327263$var$LIVE_PROCESS = new Set([
    'PROPOSED',
    'APPROVED',
    'IN_PROGRESS'
]);
const $cc9c65451b327263$export$7aebe44be0193f30 = (step)=>$cc9c65451b327263$var$OPEN_STEP.has(step?.status || 'pending');
const $cc9c65451b327263$export$d3f4649a1e650bff = (process)=>$cc9c65451b327263$var$LIVE_PROCESS.has(process?.status);
const $cc9c65451b327263$export$5a1be7d780aea15d = (session)=>!!session?.voidedAt;
const $cc9c65451b327263$export$eecaad90352df6df = (process)=>!process?.cancelledAt && (process?.steps || []).length > 1 && (process?.steps || []).every((s)=>!s.approvedAt);
// Work under way or done. Since PM-0618 every session has a row from the moment
// its order is placed (REQUESTED, then SCHEDULED into a مراجعه), so "has a live
// row" no longer means "work was done" — the status does.
const $cc9c65451b327263$var$WORKED = new Set([
    'IN_PROGRESS',
    'DONE'
]);
const $cc9c65451b327263$export$12467dc22e28ee1d = (process)=>(process?.steps || []).some((step)=>[
            step,
            ...step.parts || []
        ].some((s)=>(s.sessions || []).some((x)=>$cc9c65451b327263$var$WORKED.has((0, $ltciA.sessionStatusOf)(x)))));
function $cc9c65451b327263$export$ed6ac67359824afd(process, step) {
    if (!process || !step) return process;
    return {
        ...process,
        steps: (process.steps || []).map((s)=>{
            if (s.id === step.id) return {
                ...s,
                ...step
            };
            if ((s.parts || []).some((p)=>p.id === step.id)) return {
                ...s,
                parts: s.parts.map((p)=>p.id === step.id ? {
                        ...p,
                        ...step
                    } : p)
            };
            return s;
        })
    };
}
function $cc9c65451b327263$export$1dac6939cf74bd(steps, from, delta) {
    const ids = (steps || []).map((s)=>s.id);
    const to = from + delta;
    if (from < 0 || from >= ids.length || to < 0 || to >= ids.length) return null;
    [ids[from], ids[to]] = [
        ids[to],
        ids[from]
    ];
    return ids;
}
function $cc9c65451b327263$export$5b2832ec8df1654c(entry, sessionCount = 1) {
    const n = Math.max(1, Math.min(100, parseInt(sessionCount, 10) || 1));
    return {
        catalogId: entry.id || null,
        orderType: entry.orderType || null,
        description: entry.name || null,
        code: entry.code || null,
        // D14: a bundle is ONE session, and the BFF ignores the field for one.
        // Sending it anyway would only put a number on the wire nobody reads.
        ...entry.isBundle ? {} : {
            sessionCount: n
        }
    };
}
// ── Errors ───────────────────────────────────────────────────────────────────
// ORDER_NOT_READY carries `extensions.reason` as well as its key, and the
// reason is the contract (docs/ERROR_CODES.md): a BFF that sent the code but a
// key this catalogue does not know still gets the right sentence.
const $cc9c65451b327263$var$REASON_KEYS = {
    NOT_APPROVED: 'errors.bff.treatment.notApproved',
    WAITING_PREVIOUS: 'errors.bff.treatment.waitingPrevious',
    CLOSED: 'errors.bff.treatment.closed',
    PROCESS_CANCELLED: 'errors.bff.treatment.processCancelled',
    BUNDLE_PARENT: 'errors.bff.treatment.bundleParent'
};
// Failures that never reached a resolver: the BFF has no sentence for them, and
// «ثبت انجام شد با خطا مواجه شد» would hide that it is the network.
const $cc9c65451b327263$var$TRANSPORT_KINDS = new Set([
    (0, $cwVZP.ErrorKind).OFFLINE,
    (0, $cwVZP.ErrorKind).NETWORK,
    (0, $cwVZP.ErrorKind).TIMEOUT,
    (0, $cwVZP.ErrorKind).MAINTENANCE,
    (0, $cwVZP.ErrorKind).UNAUTHENTICATED
]);
function $cc9c65451b327263$export$2cc0e11189006055(t, has, err, fallbackKey) {
    const key = err?.extensions?.messageKey;
    const knows = (k)=>typeof has === 'function' && has(k);
    if (key && knows(key)) return t(key);
    const reasonKey = err?.extensions?.code === 'ORDER_NOT_READY' && $cc9c65451b327263$var$REASON_KEYS[err?.extensions?.reason];
    if (reasonKey) return t(reasonKey);
    const kind = (0, $cwVZP.classifyError)(err);
    if ($cc9c65451b327263$var$TRANSPORT_KINDS.has(kind)) return t(`${(0, $cwVZP.kindKey)(kind)}.title`);
    const message = String(err?.message || '');
    if (key && message) return message;
    return t(fallbackKey);
}
function $cc9c65451b327263$export$c2acac313c7201fb(err) {
    const errors = err?.graphQLErrors || (err?.extensions ? [
        err
    ] : []);
    return errors.some((e)=>e?.extensions?.code === 'GRAPHQL_VALIDATION_FAILED' && /treatmentProcess|TreatmentProcess/.test(String(e?.message || '')));
}

});


parcelRegister("glimY", function(module, exports) {

$parcel$export(module.exports, "STEP", () => $be5cdb537ae81129$export$8a2ed3f7f077984e);
$parcel$export(module.exports, "GROUP", () => $be5cdb537ae81129$export$2b9b886dddb4ba32);
$parcel$export(module.exports, "default", () => $be5cdb537ae81129$export$2e2bcd8739ae039);
$parcel$export(module.exports, "END_ANSWER", () => $be5cdb537ae81129$export$d7da4d37605314a0);
$parcel$export(module.exports, "useEndVisitServices", () => $be5cdb537ae81129$export$8f0448bd80362eb8);

var $acw62 = parcelRequire("acw62");

var $eVM84 = parcelRequire("eVM84");

var $85jFj = parcelRequire("85jFj");

var $6ojK3 = parcelRequire("6ojK3");

var $1yr2B = parcelRequire("1yr2B");

var $g6gAc = parcelRequire("g6gAc");

var $eQiuG = parcelRequire("eQiuG");

var $6xvbB = parcelRequire("6xvbB");

var $7TTuK = parcelRequire("7TTuK");

var $feEcD = parcelRequire("feEcD");

var $k6Haa = parcelRequire("k6Haa");

var $5qIQm = parcelRequire("5qIQm");
const $be5cdb537ae81129$export$8a2ed3f7f077984e = {
    PENDING: 'pending',
    RUNNING: 'running',
    DONE: 'done',
    FAILED: 'failed',
    SKIPPED: 'skipped'
};
const $be5cdb537ae81129$export$2b9b886dddb4ba32 = {
    SWEEP: 'sweep',
    CLOSE: 'close',
    ENCOUNTER: 'encounter',
    SOAP: 'soap',
    DRUG: 'drug',
    DIAGNOSIS: 'diagnosis',
    ORDERS: 'orders'
};
const $be5cdb537ae81129$var$EMPTY_PROGRESS = {
    steps: [],
    running: false
};
/** Minutes a visit lasted, rounded up — a 40-second visit reads «۱ دقیقه», not «۰». */ const $be5cdb537ae81129$var$minutesOf = (seconds)=>Math.max(1, Math.ceil((Number(seconds) || 0) / 60));
function $be5cdb537ae81129$export$2e2bcd8739ae039(deps) {
    // Every input arrives through a ref rather than the dependency array: the
    // sequence reads the state as it was when the doctor pressed the button, and
    // `start` / `retryFailed` keep a stable identity so they can be handed to a
    // memoised dialog without re-arming it on every keystroke in the SOAP field.
    const depsRef = (0, $acw62.useRef)(deps);
    depsRef.current = deps;
    const [progress, setProgress] = (0, $acw62.useState)($be5cdb537ae81129$var$EMPTY_PROGRESS);
    const [saveFailures, setSaveFailures] = (0, $acw62.useState)([]);
    const [endedAt, setEndedAt] = (0, $acw62.useState)(null);
    const [durationMin, setDurationMin] = (0, $acw62.useState)(null);
    // The runner for each recorded failure, keyed by the failure's id. Kept out
    // of state because it is a closure, not data: state holds what the screen
    // renders (group + label), this holds what «تلاش مجدد» executes.
    const runnersRef = (0, $acw62.useRef)(new Map());
    // Facts captured at the moment the visit closed. A retry minutes later must
    // update the SAME SOAP row and stamp the SAME encounter — re-deriving them
    // from a later `Date.now()` would file a second note for one visit.
    const contextRef = (0, $acw62.useRef)(null);
    const inFlightRef = (0, $acw62.useRef)(false);
    // High findings an earlier stop of the sweep put in front of the doctor, under
    // the signature of the نسخه they were found in (interactionSeen.sweepHolds).
    const sweepShownRef = (0, $acw62.useRef)(null);
    const mark = (0, $acw62.useCallback)((key, state)=>{
        setProgress((p)=>({
                ...p,
                steps: p.steps.map((s)=>s.key === key ? {
                        ...s,
                        state: state
                    } : s)
            }));
    }, []);
    const markRemaining = (0, $acw62.useCallback)((fromKey, state)=>{
        setProgress((p)=>{
            const i = p.steps.findIndex((s)=>s.key === fromKey);
            if (i === -1) return p;
            return {
                ...p,
                steps: p.steps.map((s, n)=>n > i && s.state === $be5cdb537ae81129$export$8a2ed3f7f077984e.PENDING ? {
                        ...s,
                        state: state
                    } : s)
            };
        });
    }, []);
    // ── the plan ──────────────────────────────────────────────────────────────
    // Built from the visit's actual content, so a visit with no prescription
    // never shows a «نسخه» row that would only ever say "skipped". Each task owns
    // its label and its runner; the runner is what a retry re-executes.
    const buildPlan = (0, $acw62.useCallback)(()=>{
        const d = depsRef.current;
        const { t: t, soap: soap = {}, rxItems: rxItems = [], pendingTests: pendingTests = [], patient: patient, diagnosis: diagnosis, interactionSweepEnabled: // «بررسی تداخل دارویی در پایان ویزیت». Defaults to true so a caller that
        // has not learned about the switch keeps the backstop — and so does a
        // doctor whose settings query failed, which is why the Visit page reads
        // this one switch directly instead of through its "is the choice known"
        // guard. Only an explicit «off» removes the step, and then it is not a
        // SKIPPED row either: a plan row for a check nobody asked for would be
        // the screen explaining a decision the doctor already made in Settings.
        interactionSweepEnabled = true } = d;
        const ctx = contextRef.current;
        const tasks = [];
        if (interactionSweepEnabled && rxItems.length > 0 && patient?.id) tasks.push({
            key: $be5cdb537ae81129$export$2b9b886dddb4ba32.SWEEP,
            group: $be5cdb537ae81129$export$2b9b886dddb4ba32.SWEEP,
            retryable: false,
            label: t('visit.end.step.sweep'),
            run: async ()=>{
                const dd = depsRef.current;
                const sweepConditions = [
                    ...(dd.patient?.clinicalConditions || []).map((c)=>c.display),
                    ...(dd.differential || []).filter((0, $6xvbB.isDifferentialAccepted)).map((x)=>x.description),
                    ...(0, $6xvbB.inferConditionsFromObservations)(dd.patient?.clinicalObservations)
                ];
                const sweepAllergies = (dd.patient?.clinicalAllergies || []).map((a)=>a.allergen).filter(Boolean);
                const res = await (0, $eVM84.bffQuery)((0, $6xvbB.CHECK_DRUG_INTERACTION), {
                    // Names, not formulary ids — see interactionDrugName.
                    medicationIds: (0, $g6gAc.interactionDrugNames)(dd.rxItems),
                    patientId: dd.patient.id,
                    patientConditions: sweepConditions,
                    patientAllergies: sweepAllergies
                });
                // The sweep is an AI call like any other and the service debits for
                // it, so it belongs in the visit's own tally. Without this the debit
                // showed up in the account panel and NOWHERE on the visit — a doctor
                // closing a visit watched credits leave for something they never
                // pressed a button for and the page never mentioned. Charged on the
                // answer, not the request: a sweep that threw is not billed.
                dd.chargeVisit?.((0, $1yr2B.costOf)('INTERACTION_CHECK'), 'interaction');
                const warnings = res.checkDrugInteraction?.warnings || [];
                // Only a high finding the doctor has NOT already been shown for THIS
                // نسخه holds the visit open — every one of them, matched by its drugs,
                // against a result whose signature is the current one. It used to be
                // "any earlier result had any high finding", which let a new A + C
                // through on the strength of an A + B shown before C was added
                // (interactionSeen.js). Medium and low findings wait in the نسخه tab.
                if ((0, $k6Haa.sweepHolds)(warnings, {
                    shown: dd.rxInteractions,
                    signature: dd.rxSignature,
                    memo: sweepShownRef
                })) {
                    dd.onInteractionFound?.(warnings);
                    return 'stop';
                }
                return 'ok';
            }
        });
        tasks.push({
            key: $be5cdb537ae81129$export$2b9b886dddb4ba32.CLOSE,
            group: $be5cdb537ae81129$export$2b9b886dddb4ba32.CLOSE,
            fatal: true,
            retryable: false,
            label: t('visit.end.step.close'),
            run: async ()=>{
                const dd = depsRef.current;
                await (0, $eVM84.bffMutation)((0, $6xvbB.END_VISIT), {
                    id: dd.visitId
                });
                return 'ok';
            }
        });
        if (ctx.pmEncId) tasks.push({
            key: $be5cdb537ae81129$export$2b9b886dddb4ba32.ENCOUNTER,
            group: $be5cdb537ae81129$export$2b9b886dddb4ba32.ENCOUNTER,
            retryable: true,
            label: t('visit.end.partEncounter'),
            run: async ()=>{
                const dd = depsRef.current;
                await (0, $eVM84.bffMutation)((0, $6xvbB.UPDATE_ENCOUNTER), {
                    id: ctx.pmEncId,
                    input: {
                        status: 'finished',
                        periodEnd: ctx.endTime,
                        reason: dd.soap?.a || dd.diagnosis || ''
                    }
                });
            }
        });
        if (patient?.id && (soap.s || soap.o || soap.a || soap.p)) tasks.push({
            key: $be5cdb537ae81129$export$2b9b886dddb4ba32.SOAP,
            group: $be5cdb537ae81129$export$2b9b886dddb4ba32.SOAP,
            retryable: true,
            label: t('visit.end.partSoap'),
            run: async ()=>{
                const dd = depsRef.current;
                const content = {
                    s: dd.soap.s || '',
                    o: dd.soap.o || '',
                    a: dd.soap.a || '',
                    p: dd.soap.p || ''
                };
                // The in-visit autosave already owns a row — update it. Only a visit
                // whose SOAP was never autosaved creates one here; writing a second
                // SOAP_NOTE for one appointment is what made post-visit editing
                // ambiguous. `ctx.soapNoteId` is the id as it was at closure, which
                // is why a retry cannot drift onto a create.
                if (ctx.soapNoteId) await (0, $eVM84.bffMutation)((0, $6xvbB.UPDATE_CLINICAL_NOTE), {
                    id: ctx.soapNoteId,
                    input: {
                        content: content
                    }
                });
                else {
                    const created = await (0, $eVM84.bffMutation)((0, $6xvbB.CREATE_CLINICAL_NOTE), {
                        patientId: dd.patient.id,
                        input: {
                            noteType: 'SOAP_NOTE',
                            content: content,
                            authorRole: 'doctor',
                            appointmentId: ctx.pmEncId || dd.visitId
                        }
                    });
                    // A retry after a failed create must not create a second note.
                    const id = created?.createClinicalNote?.id;
                    if (id) ctx.soapNoteId = id;
                }
            }
        });
        // Rows that already carry a `medicationId` live in the record from the
        // moment a template put them there, and every edit since was written to
        // that row. Writing them again gives the patient two rows for one drug.
        const drugsToWrite = patient?.id ? rxItems.filter((item)=>!item.medicationId) : [];
        if (drugsToWrite.length > 0) tasks.push({
            key: $be5cdb537ae81129$export$2b9b886dddb4ba32.DRUG,
            group: $be5cdb537ae81129$export$2b9b886dddb4ba32.DRUG,
            retryable: true,
            fanOut: true,
            label: t('visit.end.step.rx', {
                count: drugsToWrite.length
            }),
            // One step row, N writes: the doctor thinks «نسخه», not «six mutations».
            // Failures are still per drug, because that is what a retry re-sends.
            items: drugsToWrite.map((item)=>({
                    id: `${$be5cdb537ae81129$export$2b9b886dddb4ba32.DRUG}:${item.id || item.drug?.id || item.drug?.name}`,
                    label: `${t('visit.end.partDrug')} \u{2014} ${(0, $g6gAc.drugDisplayName)(item.drug)}`,
                    run: async ()=>{
                        const dd = depsRef.current;
                        await (0, $eVM84.bffMutation)((0, $6xvbB.CREATE_MEDICATION), {
                            patientId: dd.patient.id,
                            input: {
                                code: item.drug.genericName || item.drug.name,
                                display: item.drug.name,
                                status: 'active',
                                authoredOn: ctx.today,
                                // The SAME structured payload the persistence hook writes for a
                                // row that already lives server-side; a bare `text` here would
                                // make a drug added on this tab come back from the record as one
                                // undifferentiated string in the dose column.
                                dosageInstruction: (0, $85jFj.dosageInstructionFromRxItem)(item),
                                // تعداد as a first-class column: a تأمین اجتماعی ثبت‌نسخه reads
                                // srvQty from it and drops any drug line that has none.
                                quantity: (0, $eQiuG.quantityNumber)(item.quantity),
                                // The drug-list row it came from — how an eRx drug reaches the
                                // insurer with its product code instead of as a name.
                                meta: (0, $85jFj.medicationMetaFromDrug)(item.drug),
                                appointmentId: ctx.pmEncId || dd.visitId
                            }
                        });
                    }
                }))
        });
        const primaryDisplay = (soap.a || diagnosis || '').trim();
        if (patient?.id && primaryDisplay) tasks.push({
            key: $be5cdb537ae81129$export$2b9b886dddb4ba32.DIAGNOSIS,
            group: $be5cdb537ae81129$export$2b9b886dddb4ba32.DIAGNOSIS,
            retryable: true,
            label: t('visit.end.partDiagnosis'),
            run: async ()=>{
                const dd = depsRef.current;
                // Accepted differential items are already persisted server-side by
                // ai.js's updateDifferentialItem resolver (action 'accept') the moment
                // the doctor accepts them — do NOT re-save those here, or every
                // accepted diagnosis ends up with two duplicate Condition rows.
                await (0, $eVM84.bffMutation)((0, $6xvbB.ADD_CONDITION), {
                    patientId: dd.patient.id,
                    input: {
                        code: '',
                        display: primaryDisplay,
                        status: 'active',
                        // Free prose nobody was asked to type: a working diagnosis until
                        // the doctor says otherwise in the record panel.
                        verificationStatus: (0, $6ojK3.DX_PROVISIONAL),
                        onsetDate: ctx.today,
                        appointmentId: ctx.pmEncId || dd.visitId
                    }
                });
            }
        });
        const unsaved = pendingTests.filter((test)=>!test.savedToBackend);
        if (patient?.id && unsaved.length > 0) tasks.push({
            key: $be5cdb537ae81129$export$2b9b886dddb4ba32.ORDERS,
            group: $be5cdb537ae81129$export$2b9b886dddb4ba32.ORDERS,
            retryable: true,
            fanOut: true,
            label: t('visit.end.partOrders'),
            count: unsaved.length,
            // One write per order, like the drugs. This was one batch whose answer
            // was never read, and the BFF said `success: true` even when every
            // order inside it failed — the closure reported «ثبت شد» over orders
            // that were not in the record. Per order, a refusal is a failure the
            // doctor sees, and «تلاش مجدد» re-sends that order alone rather than
            // the batch, which would write the ones that landed a second time.
            items: unsaved.map((order, n)=>({
                    id: `${$be5cdb537ae81129$export$2b9b886dddb4ba32.ORDERS}:${n}:${order.id || order.name || ''}`,
                    label: `${t('visit.end.partOrders')} \u{2014} ${order.name || order.testName || order}`,
                    run: async ()=>{
                        const dd = depsRef.current;
                        await (0, $5qIQm.saveDoctorOrder)({
                            patientId: dd.patient.id,
                            appointmentId: ctx.pmEncId || dd.visitId
                        }, (0, $5qIQm.doctorOrderInput)(order));
                    }
                }))
        });
        return tasks;
    }, []);
    /** The local draft is the sole surviving copy when a write failed — it goes only on a clean end. */ const dropDraft = (0, $acw62.useCallback)(()=>{
        const d = depsRef.current;
        try {
            localStorage.removeItem(`visit_draft_${d.patient?.id}`);
        } catch  {}
    }, []);
    // ── run ───────────────────────────────────────────────────────────────────
    const start = (0, $acw62.useCallback)(async ()=>{
        const d = depsRef.current;
        if (inFlightRef.current || !d.visitId) return 'failed';
        inFlightRef.current = true;
        contextRef.current = {
            pmEncId: d.pmEncounterId || d.visitId || null,
            // Captured BEFORE the caller resets it: the SOAP save must UPDATE the row
            // the in-visit autosave created.
            soapNoteId: d.soapNoteId || null,
            today: new Date().toISOString().split('T')[0],
            endTime: new Date().toISOString()
        };
        runnersRef.current = new Map();
        const plan = buildPlan();
        setSaveFailures([]);
        setProgress({
            running: true,
            steps: plan.map((task)=>({
                    key: task.key,
                    label: task.label,
                    count: task.count,
                    state: $be5cdb537ae81129$export$8a2ed3f7f077984e.PENDING
                }))
        });
        const failures = [];
        const runners = new Map();
        try {
            for (const task of plan){
                mark(task.key, $be5cdb537ae81129$export$8a2ed3f7f077984e.RUNNING);
                if (task.group === $be5cdb537ae81129$export$2b9b886dddb4ba32.SWEEP) {
                    let verdict = 'ok';
                    // The sweep is advisory: an API failure must not prevent a doctor
                    // from closing a visit, so it is the one task whose own error is not
                    // recorded as a failed write.
                    try {
                        verdict = await task.run();
                    } catch  {
                        verdict = 'error';
                    }
                    if (verdict === 'stop') {
                        mark(task.key, $be5cdb537ae81129$export$8a2ed3f7f077984e.DONE);
                        markRemaining(task.key, $be5cdb537ae81129$export$8a2ed3f7f077984e.SKIPPED);
                        setProgress((p)=>({
                                ...p,
                                running: false
                            }));
                        return 'stopped-interaction';
                    }
                    mark(task.key, verdict === 'error' ? $be5cdb537ae81129$export$8a2ed3f7f077984e.SKIPPED : $be5cdb537ae81129$export$8a2ed3f7f077984e.DONE);
                    continue;
                }
                if (task.fanOut) {
                    let anyFailed = false;
                    for (const item of task.items)try {
                        await item.run();
                    } catch (e) {
                        console.warn('[endVisit] write failed:', task.key, e?.message);
                        anyFailed = true;
                        failures.push({
                            id: item.id,
                            group: task.group,
                            label: item.label
                        });
                        runners.set(item.id, item.run);
                    }
                    mark(task.key, anyFailed ? $be5cdb537ae81129$export$8a2ed3f7f077984e.FAILED : $be5cdb537ae81129$export$8a2ed3f7f077984e.DONE);
                    continue;
                }
                try {
                    await task.run();
                    mark(task.key, $be5cdb537ae81129$export$8a2ed3f7f077984e.DONE);
                } catch (e) {
                    // `END_VISIT` failing means the sequence never started, not that part
                    // of it landed. The caller must not show a closure that says the
                    // visit is done, so this is the one write that aborts.
                    if (task.fatal) {
                        console.error('[endVisit]', e);
                        mark(task.key, $be5cdb537ae81129$export$8a2ed3f7f077984e.FAILED);
                        markRemaining(task.key, $be5cdb537ae81129$export$8a2ed3f7f077984e.SKIPPED);
                        setProgress((p)=>({
                                ...p,
                                running: false
                            }));
                        return 'failed';
                    }
                    console.warn('[endVisit] write failed:', task.key, e?.message);
                    mark(task.key, $be5cdb537ae81129$export$8a2ed3f7f077984e.FAILED);
                    failures.push({
                        id: task.key,
                        group: task.group,
                        label: task.label
                    });
                    runners.set(task.key, task.run);
                    continue;
                }
                // Everything after this point is bookkeeping on a visit that IS closed.
                if (task.group === $be5cdb537ae81129$export$2b9b886dddb4ba32.CLOSE) {
                    d.onVisitClosed?.();
                    setEndedAt(new Date());
                    setDurationMin($be5cdb537ae81129$var$minutesOf(d.elapsedSeconds));
                }
            }
        } finally{
            inFlightRef.current = false;
        }
        runnersRef.current = runners;
        setSaveFailures(failures);
        if (failures.length === 0) dropDraft();
        setProgress((p)=>({
                ...p,
                running: false
            }));
        return failures.length > 0 ? 'partial' : 'done';
    }, [
        buildPlan,
        mark,
        markRemaining,
        dropDraft
    ]);
    // ── retry ─────────────────────────────────────────────────────────────────
    // Only the writes that failed, and never automatically: §14.2 — a duplicated
    // clinical write is strictly worse than a failed one the doctor can see.
    const [retrying, setRetrying] = (0, $acw62.useState)(false);
    const retryFailed = (0, $acw62.useCallback)(async ()=>{
        if (inFlightRef.current) return false;
        const pending = saveFailures;
        if (pending.length === 0) return true;
        inFlightRef.current = true;
        setRetrying(true);
        const stillFailing = [];
        try {
            for (const failure of pending){
                const run = runnersRef.current.get(failure.id);
                if (!run) continue;
                try {
                    await run();
                    runnersRef.current.delete(failure.id);
                } catch (e) {
                    console.warn('[endVisit] retry failed:', failure.id, e?.message);
                    stillFailing.push(failure);
                }
            }
        } finally{
            inFlightRef.current = false;
            setRetrying(false);
        }
        setSaveFailures(stillFailing);
        setProgress((p)=>({
                ...p,
                steps: p.steps.map((s)=>s.state === $be5cdb537ae81129$export$8a2ed3f7f077984e.FAILED && !stillFailing.some((f)=>f.group === s.key) ? {
                        ...s,
                        state: $be5cdb537ae81129$export$8a2ed3f7f077984e.DONE
                    } : s)
            }));
        if (stillFailing.length === 0) dropDraft();
        return stillFailing.length === 0;
    }, [
        saveFailures,
        dropDraft
    ]);
    /** Groups that did not reach the record — what the closure marks «ثبت نشد». */ const failedGroups = saveFailures.reduce((acc, f)=>{
        acc[f.group] = (acc[f.group] || 0) + 1;
        return acc;
    }, {});
    const reset = (0, $acw62.useCallback)(()=>{
        setProgress($be5cdb537ae81129$var$EMPTY_PROGRESS);
        setSaveFailures([]);
        runnersRef.current = new Map();
    }, []);
    return {
        endProgress: progress,
        saveFailures: saveFailures,
        failedGroups: failedGroups,
        retrying: retrying,
        start: start,
        retryFailed: retryFailed,
        reset: reset,
        endedAt: endedAt,
        durationMin: durationMin
    };
}
const $be5cdb537ae81129$export$d7da4d37605314a0 = {
    DONE: 'done',
    CLINIC: 'clinic',
    LATER: 'later'
};
function $be5cdb537ae81129$export$dc7edd6bc9f8a82f(orders, visitId, isInHouse) {
    if (!visitId) return [];
    return (orders || []).filter((o)=>o && String(o.appointmentId || '') === String(visitId)).filter((o)=>!(0, $7TTuK.isProcessStep)(o) && [
            'pending',
            'in_progress'
        ].includes(o.status)).filter((o)=>typeof isInHouse === 'function' ? isInHouse(o) : o.performedHere === true).filter((o)=>(0, $7TTuK.isOpenInVisit)(o, visitId)).map((o)=>({
            order: o,
            session: (0, $7TTuK.sessionInVisit)(o, visitId)
        }));
}
function $be5cdb537ae81129$export$8f0448bd80362eb8({ orders: orders, visitId: visitId, isInHouse: isInHouse }) {
    const depsRef = (0, $acw62.useRef)({
        orders: orders,
        visitId: visitId,
        isInHouse: isInHouse
    });
    depsRef.current = {
        orders: orders,
        visitId: visitId,
        isInHouse: isInHouse
    };
    const [items, setItems] = (0, $acw62.useState)([]);
    const [answers, setAnswers] = (0, $acw62.useState)({});
    const [failures, setFailures] = (0, $acw62.useState)([]);
    const [running, setRunning] = (0, $acw62.useState)(false);
    // The answers that already landed — a retry must not record a session twice.
    const landedRef = (0, $acw62.useRef)(new Set());
    const itemsRef = (0, $acw62.useRef)([]);
    const answersRef = (0, $acw62.useRef)({});
    answersRef.current = answers;
    /**
   * Re-read this visit's orders (the desk may have answered one meanwhile) and
   * return what is still open; on a failed read, the list the room holds.
   */ const prepare = (0, $acw62.useCallback)(async ()=>{
        const { orders: held, visitId: vid, isInHouse: inHouse } = depsRef.current;
        if (!vid) return [];
        let list = held;
        try {
            const data = await (0, $eVM84.bffQuery)((0, $6xvbB.LIST_CLINICAL_ORDERS), {
                appointmentId: vid
            });
            if (Array.isArray(data?.listOrders)) list = data.listOrders;
        } catch  {}
        const next = $be5cdb537ae81129$export$dc7edd6bc9f8a82f(list, vid, inHouse);
        itemsRef.current = next;
        landedRef.current = new Set();
        const initial = {};
        for (const { order: order } of next)initial[order.id] = {
            answer: $be5cdb537ae81129$export$d7da4d37605314a0.DONE,
            date: ''
        };
        answersRef.current = initial;
        setItems(next);
        setAnswers(initial);
        setFailures([]);
        return next;
    }, []);
    const setAnswer = (0, $acw62.useCallback)((orderId, patch)=>{
        setAnswers((prev)=>{
            const next = {
                ...prev,
                [orderId]: {
                    ...prev[orderId] || {
                        answer: $be5cdb537ae81129$export$d7da4d37605314a0.DONE,
                        date: ''
                    },
                    ...patch
                }
            };
            answersRef.current = next;
            return next;
        });
    }, []);
    /**
   * Send every answer not yet landed, in order; then — only when none failed —
   * `onEnd()` (the visit's end) and its result. 'failed' when any answer did not land.
   */ const run = (0, $acw62.useCallback)(async (onEnd)=>{
        const { visitId: vid } = depsRef.current;
        setRunning(true);
        const failed = [];
        const today = (0, $feEcD.clinicTodayIso)();
        try {
            for (const { order: order, session: session } of itemsRef.current){
                if (landedRef.current.has(order.id)) continue;
                const { answer: answer, date: date } = answersRef.current[order.id] || {
                    answer: $be5cdb537ae81129$export$d7da4d37605314a0.DONE
                };
                if (answer === $be5cdb537ae81129$export$d7da4d37605314a0.LATER && !((0, $feEcD.isIsoDay)(date) && date > today)) {
                    failed.push({
                        orderId: order.id,
                        reason: 'pickDate'
                    });
                    continue;
                }
                try {
                    if (answer === $be5cdb537ae81129$export$d7da4d37605314a0.DONE) await (0, $eVM84.bffMutation)((0, $7TTuK.RECORD_VISIT_SESSION), {
                        orderId: order.id,
                        appointmentId: vid,
                        sessionId: session?.id || null
                    });
                    else if (answer === $be5cdb537ae81129$export$d7da4d37605314a0.LATER) await (0, $eVM84.bffMutation)((0, $6xvbB.UPDATE_ORDER_DATE), {
                        orderId: order.id,
                        performedDate: date
                    });
                    landedRef.current.add(order.id);
                } catch (e) {
                    failed.push({
                        orderId: order.id,
                        message: e?.message || ''
                    });
                }
            }
        } finally{
            setRunning(false);
        }
        setFailures(failed);
        if (failed.length > 0) return 'failed';
        return onEnd ? onEnd() : 'done';
    }, []);
    const close = (0, $acw62.useCallback)(()=>{
        itemsRef.current = [];
        setItems([]);
        setFailures([]);
    }, []);
    return {
        items: items,
        answers: answers,
        failures: failures,
        running: running,
        prepare: prepare,
        setAnswer: setAnswer,
        run: run,
        close: close
    };
}

});

parcelRegister("hScMH", function(module, exports) {

$parcel$export(module.exports, "default", () => $648b75d6cb92ff50$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $cjPik = parcelRequire("cjPik");
var $4Qco3 = parcelRequire("4Qco3");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $glimY = parcelRequire("glimY");

var $aQGDs = parcelRequire("aQGDs");
// «پیش از پایان ویزیت» (PM-0618, contract §7.2) — what became of each in-house
// service ordered in this visit that is still open in it. The rules and the
// writes are `useEndVisitServices` (screens/Visit/useEndVisit.js); this only draws
// them. It REPLACES the plain «پایان ویزیت» confirm when there is something to
// answer: its own «پایان ویزیت» is the confirmation, so the doctor is not asked
// twice. Desktop and phone share it; `compact` gives the phone 44 px targets.
//
// The three answers are a radio group per row, not a select: three short words
// read at a glance, and «انجام دادم» — preselected (D4) — is visibly chosen.
const $648b75d6cb92ff50$var$ANSWERS = [
    (0, $glimY.END_ANSWER).DONE,
    (0, $glimY.END_ANSWER).CLINIC,
    (0, $glimY.END_ANSWER).LATER
];
function $648b75d6cb92ff50$export$2e2bcd8739ae039({ open: open, onOpenChange: onOpenChange, items: items, answers: answers, failures: failures, running: running, onAnswer: onAnswer, onConfirm: onConfirm, compact: compact = false }) {
    const { t: t } = (0, $LNQP4.default)();
    const failureOf = (id)=>(failures || []).find((f)=>f.orderId === id);
    const pill = compact ? {
        minHeight: 44,
        padding: '0 12px'
    } : {
        minHeight: 28,
        padding: '0 10px'
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cjPik.default), {
        open: open,
        onOpenChange: onOpenChange,
        "data-testid": "visit-end-services",
        confirmTestId: "visit-end-services-ok",
        cancelTestId: "visit-end-services-cancel",
        title: t('visit.endServices.title'),
        description: t('visit.endServices.lead'),
        confirmLabel: t('visit.endServices.confirm'),
        cancelLabel: t('visit.endConfirm.cancel'),
        loading: running,
        onConfirm: onConfirm
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        style: {
            listStyle: 'none',
            margin: 0,
            padding: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: 10
        }
    }, (items || []).map(({ order: order, session: session })=>{
        const a = answers?.[order.id] || {
            answer: (0, $glimY.END_ANSWER).DONE,
            date: ''
        };
        const failure = failureOf(order.id);
        const name = order.description || '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: order.id,
            "data-testid": `visit-end-services-item-${order.id}`,
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: 6,
                paddingBottom: 8,
                borderBottom: `1px solid ${(0, $jTCZr.CT).border}`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 6,
                minWidth: 0,
                flexWrap: 'wrap'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("bdi", {
            dir: "auto",
            style: {
                fontSize: '0.8125rem',
                fontWeight: 700,
                color: (0, $jTCZr.CT).ink,
                overflowWrap: 'anywhere'
            }
        }, name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aQGDs.SessionStatusChip), {
            session: session,
            compact: compact,
            testid: `visit-end-services-${order.id}-status`
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            role: "radiogroup",
            "aria-label": t('visit.endServices.answerFor', {
                name: name
            }),
            style: {
                display: 'flex',
                gap: 6,
                flexWrap: 'wrap'
            }
        }, $648b75d6cb92ff50$var$ANSWERS.map((key)=>{
            const on = a.answer === key;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                key: key,
                type: "button",
                role: "radio",
                "aria-checked": on,
                disabled: running,
                onClick: ()=>onAnswer(order.id, {
                        answer: key
                    }),
                "data-testid": `visit-end-services-${order.id}-${key}`,
                style: {
                    ...pill,
                    borderRadius: 8,
                    fontSize: '0.75rem',
                    fontWeight: on ? 700 : 500,
                    cursor: 'pointer',
                    border: `1px solid ${on ? (0, $jTCZr.CT).accentInk : (0, $jTCZr.CT).border}`,
                    background: on ? (0, $jTCZr.CT).accentSoft : 'transparent',
                    color: on ? (0, $jTCZr.CT).accentInk : (0, $jTCZr.CT).ink2
                }
            }, t(`visit.endServices.answer.${key}`));
        })), a.answer === (0, $glimY.END_ANSWER).LATER && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                width: compact ? '100%' : '12rem',
                maxWidth: '100%'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4Qco3.default), {
            value: a.date || '',
            onChange: (date)=>onAnswer(order.id, {
                    date: date
                }),
            height: compact ? 44 : 30,
            placeholder: t('visit.orders.date.pick'),
            "aria-label": t('visit.endServices.date', {
                name: name
            }),
            "data-testid": `visit-end-services-${order.id}-date`
        })), failure && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
            variant: "error",
            "data-testid": `visit-end-services-${order.id}-error`
        }, failure.message || (failure.reason ? t(`visit.endServices.${failure.reason}`) : t('visit.endServices.failed'))));
    })));
}

});

parcelRegister("jzVrj", function(module, exports) {

$parcel$export(module.exports, "default", () => $98d2db25dd94efee$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $hZDga = parcelRequire("hZDga");

var $jTCZr = parcelRequire("jTCZr");

var $huNwV = parcelRequire("huNwV");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $eVM84 = parcelRequire("eVM84");

var $fWbIA = parcelRequire("fWbIA");

var $7TTuK = parcelRequire("7TTuK");

var $aQGDs = parcelRequire("aQGDs");
// «خدمات این مراجعه» (PM-0618, contract §7.2) — under the visit's orders: the
// orders from EARLIER visits whose session sits in this one (physio session 3,
// booked by the desk), whoever ordered them (doctor BFF `visitServices`). Orders
// prescribed in this visit are already in the list above and are left out here.
// Each row: the service, its session's badge, and «انجام شد» while that session
// is open — one session recorded in THIS visit, performer = the doctor.
//
// Four states: loading (a skeleton row), empty (the block is not drawn), error
// (one sentence and «تلاش دوباره»; the rest of the room keeps working), data. A
// BFF that does not know the query yet is "empty", not an error.
const $98d2db25dd94efee$var$schemaMissing = (err)=>{
    const errors = err?.graphQLErrors || (err?.extensions ? [
        err
    ] : []);
    return errors.some((e)=>e?.extensions?.code === 'GRAPHQL_VALIDATION_FAILED' && /visitServices|sessions|sameVisit|openSessions/.test(String(e?.message || '')));
};
function $98d2db25dd94efee$export$2e2bcd8739ae039({ appointmentId: appointmentId, compact: compact = false, refreshKey: refreshKey = 0, onRecorded: onRecorded }) {
    const { t: t, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const [state, setState] = (0, $acw62.useState)({
        status: 'loading',
        orders: []
    });
    const [busyId, setBusyId] = (0, $acw62.useState)(null);
    const [doneError, setDoneError] = (0, $acw62.useState)(null);
    const load = (0, $acw62.useCallback)(async ()=>{
        if (!appointmentId) {
            setState({
                status: 'empty',
                orders: []
            });
            return;
        }
        setState((s)=>({
                ...s,
                status: s.orders.length ? s.status : 'loading'
            }));
        try {
            const data = await (0, $eVM84.bffQuery)((0, $7TTuK.VISIT_SERVICES), {
                appointmentId: appointmentId
            });
            const earlier = (data?.visitServices || []).filter((o)=>o && String(o.appointmentId || '') !== String(appointmentId) && (0, $7TTuK.sessionInVisit)(o, appointmentId));
            setState({
                status: earlier.length ? 'data' : 'empty',
                orders: earlier
            });
        } catch (e) {
            setState({
                status: $98d2db25dd94efee$var$schemaMissing(e) ? 'empty' : 'error',
                orders: []
            });
        }
    }, [
        appointmentId
    ]);
    (0, $acw62.useEffect)(()=>{
        load();
    }, [
        load,
        refreshKey
    ]);
    const markDone = async (order)=>{
        if (busyId) return;
        setBusyId(order.id);
        setDoneError(null);
        try {
            await (0, $7TTuK.markOrderDoneHere)({
                order: order,
                visitId: appointmentId
            });
            await load();
            onRecorded?.(order);
        } catch (e) {
            setDoneError({
                id: order.id,
                message: e?.message || t('visit.services.doneFailed')
            });
        } finally{
            setBusyId(null);
        }
    };
    if (state.status === 'empty') return null;
    const title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: compact ? '0.6875rem' : '0.75rem',
            fontWeight: 700,
            color: (0, $jTCZr.CT).ink2
        }
    }, t('visit.services.title'));
    if (state.status === 'loading') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 6,
            marginTop: 10
        }
    }, title, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fWbIA.OrdersListSkeleton), {
        count: 1,
        dense: true,
        testId: "visit-services-loading"
    }));
    if (state.status === 'error') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
        "data-testid": "visit-services-error",
        role: "alert",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            flexWrap: 'wrap',
            marginTop: 10
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).dangerInk
        }
    }, t('visit.services.loadError')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        className: compact ? 'min-h-11 px-2' : 'h-7 px-2',
        onClick: load,
        "data-testid": "visit-services-retry"
    }, t('common.actions.retry')));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
        "data-testid": "visit-services",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 6,
            marginTop: 10
        }
    }, title, state.orders.map((order)=>{
        const session = (0, $7TTuK.sessionInVisit)(order, appointmentId);
        const open = (0, $7TTuK.isOpenInVisit)(order, appointmentId);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: order.id,
            "data-testid": `visit-services-item-${order.id}`,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                flexWrap: 'wrap',
                border: `1px solid ${(0, $jTCZr.CT).border}`,
                borderRadius: 10,
                padding: compact ? '0.5rem 0.625rem' : '7px 10px'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("bdi", {
            dir: "auto",
            style: {
                flex: '1 1 8rem',
                minWidth: 0,
                fontSize: '0.8125rem',
                fontWeight: 600,
                color: (0, $jTCZr.CT).ink,
                overflowWrap: 'anywhere'
            }
        }, order.description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aQGDs.SessionStatusChip), {
            session: session,
            compact: compact,
            prefix: t('visit.services.session', {
                n: formatNumber(session?.sessionNo ?? 0)
            }),
            testid: `visit-services-session-${order.id}`
        }), open && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "subtle",
            size: "sm",
            className: compact ? 'min-h-11 gap-1' : 'h-7 px-3 gap-1',
            onClick: ()=>markDone(order),
            disabled: !!busyId,
            title: t('visit.orders.markDoneHint'),
            "data-testid": `visit-services-done-${order.id}`,
            style: {
                color: (0, $jTCZr.CT).goodInk || (0, $jTCZr.CT).accentInk
            }
        }, busyId === order.id ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
            size: 11,
            thickness: 2
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
            size: 12,
            "aria-hidden": true
        }), t('visit.services.markDone')), doneError?.id === order.id && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            role: "alert",
            "data-testid": `visit-services-error-${order.id}`,
            style: {
                flexBasis: '100%',
                fontSize: '0.6875rem',
                color: (0, $jTCZr.CT).dangerInk
            }
        }, doneError.message));
    }));
}

});


parcelRegister("1GWj2", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b4ee9e6346f75da$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $lfHhF = parcelRequire("lfHhF");

var $eQiuG = parcelRequire("eQiuG");

var $5VYuu = parcelRequire("5VYuu");

var $eBrFc = parcelRequire("eBrFc");
parcelRequire("7sS0P");
var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");

var $k5DdK = parcelRequire("k5DdK");

var $9ycDe = parcelRequire("9ycDe");

var $eVM84 = parcelRequire("eVM84");

var $dL6zl = parcelRequire("dL6zl");

var $fOM5k = parcelRequire("fOM5k");

var $gXsFl = parcelRequire("gXsFl");

var $hRWhk = parcelRequire("hRWhk");

var $gRy9t = parcelRequire("gRy9t");

var $zi6VT = parcelRequire("zi6VT");

var $0xK7i = parcelRequire("0xK7i");

var $8qEaX = parcelRequire("8qEaX");

var $bkBaq = parcelRequire("bkBaq");

var $gdEay = parcelRequire("gdEay");

var $1Qo7B = parcelRequire("1Qo7B");

var $fBZG6 = parcelRequire("fBZG6");
parcelRequire("dsmcB");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $aJ1FU = parcelRequire("aJ1FU");
var $4fYdd = parcelRequire("4fYdd");
var $7gSBD = parcelRequire("7gSBD");
var $h4ZeB = parcelRequire("h4ZeB");
var $7phmx = parcelRequire("7phmx");
var $jOGbh = parcelRequire("jOGbh");
var $4Qco3 = parcelRequire("4Qco3");
var $3tGMU = parcelRequire("3tGMU");
var $Ydgp5 = parcelRequire("Ydgp5");
var $lffTJ = parcelRequire("lffTJ");
var $jbdF9 = parcelRequire("jbdF9");
var $fAR2n = parcelRequire("fAR2n");
var $66joL = parcelRequire("66joL");
var $hZDga = parcelRequire("hZDga");
var $a7Rbr = parcelRequire("a7Rbr");

var $7LBYc = parcelRequire("7LBYc");

var $kyxc1 = parcelRequire("kyxc1");

var $fWbIA = parcelRequire("fWbIA");

var $fijM5 = parcelRequire("fijM5");

var $3wi2X = parcelRequire("3wi2X");

var $cVuA6 = parcelRequire("cVuA6");

var $3EzBq = parcelRequire("3EzBq");

var $1yr2B = parcelRequire("1yr2B");

var $4s6k1 = parcelRequire("4s6k1");
parcelRequire("epeHA");
var $jTCZr = parcelRequire("jTCZr");

var $3OnFU = parcelRequire("3OnFU");

var $16oOu = parcelRequire("16oOu");

var $fiHxp = parcelRequire("fiHxp");

var $gq4TR = parcelRequire("gq4TR");
parcelRequire("dLdf9");

var $cwVZP = parcelRequire("cwVZP");

var $cvBw3 = parcelRequire("cvBw3");

var $fGLlt = parcelRequire("fGLlt");

var $U8Lvw = parcelRequire("U8Lvw");

var $4UqGT = parcelRequire("4UqGT");

var $5zccn = parcelRequire("5zccn");

var $9SQfR = parcelRequire("9SQfR");

var $bOPUe = parcelRequire("bOPUe");

var $aQGDs = parcelRequire("aQGDs");

var $feEcD = parcelRequire("feEcD");

var $7ZSin = parcelRequire("7ZSin");

var $5hFXE = parcelRequire("5hFXE");

var $jDxJA = parcelRequire("jDxJA");

var $3O5pt = parcelRequire("3O5pt");

var $85jFj = parcelRequire("85jFj");

var $3Tnyk = parcelRequire("3Tnyk");

var $7Z50p = parcelRequire("7Z50p");

var $aoLHg = parcelRequire("aoLHg");

var $6xvbB = parcelRequire("6xvbB");

var $i9Cif = parcelRequire("i9Cif");

var $g6gAc = parcelRequire("g6gAc");

var $d2Zvn = parcelRequire("d2Zvn");

var $e317r = parcelRequire("e317r");

var $6ojK3 = parcelRequire("6ojK3");

var $lqfll = parcelRequire("lqfll");

var $glimY = parcelRequire("glimY");

var $7TTuK = parcelRequire("7TTuK");

var $hScMH = parcelRequire("hScMH");

var $jzVrj = parcelRequire("jzVrj");

var $e7Ndt = parcelRequire("e7Ndt");

var $5qFC5 = parcelRequire("5qFC5");

var $jCgjY = parcelRequire("jCgjY");

var $5kzaL = parcelRequire("5kzaL");

var $bwSot = parcelRequire("bwSot");

var $4SCt2 = parcelRequire("4SCt2");

var $7akOU = parcelRequire("7akOU");

var $dXWAH = parcelRequire("dXWAH");

var $fIKok = parcelRequire("fIKok");

var $icdDW = parcelRequire("icdDW");

var $b4nOl = parcelRequire("b4nOl");

var $cEPPo = parcelRequire("cEPPo");

var $ajYTu = parcelRequire("ajYTu");

var $l7onJ = parcelRequire("l7onJ");

var $5iiH3 = parcelRequire("5iiH3");

var $jOg3R = parcelRequire("jOg3R");
// The copilot composer grows with the question up to this height (≈6 lines at
// 12.5px/1.6 plus the field's own block padding), then scrolls inside itself
// rather than eating the conversation above it.
const $9b4ee9e6346f75da$var$ASK_MAX_H = 126;
// سوابق ویزیت‌های قبلی — how deep each surface goes. The rail is a preview: it
// competes for height with allergies, vitals, meds, diagnoses and labs in a
// column that already overflows, so it shows three and defers the rest to the
// sheet. The sheet's cap is what one patient's history is allowed to cost.
const $9b4ee9e6346f75da$var$VISIT_HISTORY_PREVIEW = 3;
const $9b4ee9e6346f75da$var$VISIT_HISTORY_MAX = 12;
// Diagnosis chips that fit a 340px rail row before the «+N» rollup takes over.
const $9b4ee9e6346f75da$var$RAIL_DX_CHIPS = 2;
// ─────────────────────────────────────────────────────────────────────────────
// SoapPlanPanel — the AI treatment plan, docked under the SOAP «P» editor.
//
// The plan's prose already went into the P field when it was generated; what
// lives here is everything that is NOT prose: the interaction warnings, the
// structured items the doctor ticks off, and the clinical rationale. Confirming
// persists the ticked items and files the P text as the visit's treatment plan.
// ─────────────────────────────────────────────────────────────────────────────
const $9b4ee9e6346f75da$var$PLAN_GROUPS = (t, s)=>[
        {
            key: 'med',
            title: t('visit.rx.medications'),
            items: s.medications || [],
            nameOf: (m)=>m.name,
            reasonOf: (m, tt)=>[
                    m.dosage,
                    m.frequency,
                    m.duration ? tt('visit.text.forDuration', {
                        duration: m.duration
                    }) : '',
                    m.notes
                ].filter(Boolean).join(" \u2022 ")
        },
        {
            key: 'lab',
            title: t('visit.orders.tests'),
            items: s.labTests || [],
            nameOf: (x)=>x.testName,
            reasonOf: (x)=>x.reason
        },
        {
            key: 'imaging',
            title: t('visit.orders.imaging'),
            items: s.imagingStudies || [],
            nameOf: (x)=>x.studyType,
            reasonOf: (x)=>[
                    x.bodyPart,
                    x.reason
                ].filter(Boolean).join(" \u2014 ")
        },
        {
            key: 'procedure',
            title: t('visit.orders.paraclinical'),
            items: s.procedureOrders || [],
            nameOf: (x)=>x.name,
            reasonOf: (x)=>x.reason
        }
    ];
function $9b4ee9e6346f75da$var$SoapPlanPanel({ suggestion: suggestion, loading: loading, saving: saving, status: status, error: error, selected: selected, planKey: planKey, onToggle: onToggle, onConfirm: onConfirm, onRegenerate: onRegenerate, onClose: onClose, onRestore: onRestore, canRestore: canRestore, canGenerate: canGenerate }) {
    const { t: t } = (0, $LNQP4.default)();
    const confirmed = status === 'confirmed';
    const totalItems = suggestion ? $9b4ee9e6346f75da$var$PLAN_GROUPS(t, suggestion).reduce((n, g)=>n + g.items.length, 0) : 0;
    const dropped = suggestion ? totalItems - selected.size : 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-plan-panel",
        style: {
            marginTop: 8,
            borderRadius: 10,
            border: '1px solid oklch(0.87 0.06 290)',
            background: 'oklch(0.985 0.008 290)',
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '8px 12px',
            borderBottom: '1px solid oklch(0.90 0.04 290)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: 'oklch(0.38 0.14 290)',
            display: 'grid',
            placeItems: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).sparkle, {
        width: 12,
        height: 12
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.75rem',
            fontWeight: 700,
            color: 'oklch(0.38 0.14 290)'
        }
    }, t('credits.price.plan')), confirmed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "visit-plan-status",
        style: {
            fontSize: '0.5625rem',
            fontWeight: 700,
            letterSpacing: '.04em',
            padding: '2px 6px',
            borderRadius: 4,
            background: 'var(--good-soft)',
            color: 'var(--good-ink)'
        }
    }, t('visit.state.confirmedAdj')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.5625rem',
            fontWeight: 700,
            letterSpacing: '.04em',
            padding: '2px 6px',
            borderRadius: 4,
            background: 'var(--accent-soft)',
            color: 'var(--accent-ink)'
        }
    }, t('visit.plan.basis')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        "data-testid": "visit-plan-close",
        onClick: onClose,
        "aria-label": t('common.actions.close'),
        style: {
            marginInlineStart: 'auto',
            border: 'none',
            background: 'none',
            color: 'var(--mute)',
            cursor: 'pointer',
            padding: 2,
            display: 'grid',
            placeItems: 'center',
            fontFamily: 'inherit'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).close, {
        width: 11,
        height: 11
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: 12
        }
    }, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-plan-error",
        style: {
            marginBottom: 10,
            padding: '8px 10px',
            borderRadius: 7,
            background: 'var(--danger-soft)',
            border: '1px solid var(--danger)',
            color: 'var(--danger-ink)',
            fontSize: '0.71875rem'
        }
    }, error), canRestore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginBottom: 10,
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '7px 10px',
            borderRadius: 7,
            background: 'var(--warn-soft)',
            border: '1px solid var(--warn)',
            fontSize: '0.6875rem',
            color: 'var(--warn-ink)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1
        }
    }, t('visit.plan.replacedNotice')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        "data-testid": "visit-plan-restore",
        onClick: onRestore,
        style: {
            border: '1px solid var(--warn)',
            background: 'var(--panel-2)',
            color: 'var(--warn-ink)',
            borderRadius: 6,
            padding: '3px 8px',
            fontSize: '0.65625rem',
            fontWeight: 600,
            cursor: 'pointer',
            fontFamily: 'inherit'
        }
    }, t('visit.plan.restorePrevious'))), loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 9,
            padding: '22px 0',
            color: 'var(--mute)',
            fontSize: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 13,
            height: 13,
            border: '2px solid var(--line)',
            borderTopColor: 'var(--accent)',
            borderRadius: '50%',
            animation: 'spin .7s linear infinite'
        }
    }), t('visit.plan.generating')), !suggestion && !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            textAlign: 'center',
            padding: '14px 8px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.71875rem',
            color: 'var(--mute)',
            lineHeight: 1.9,
            marginBottom: 12
        }
    }, t('visit.plan.explainer')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        "data-testid": "visit-plan-generate",
        onClick: onRegenerate,
        disabled: !canGenerate,
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6,
            padding: '8px 16px',
            borderRadius: 8,
            border: 'none',
            background: 'var(--accent)',
            color: '#fff',
            fontSize: '0.78125rem',
            fontWeight: 600,
            fontFamily: 'inherit',
            cursor: canGenerate ? 'pointer' : 'not-allowed',
            opacity: canGenerate ? 1 : 0.55
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).sparkle, {
        width: 12,
        height: 12
    }), t('visit.plan.generate')), !canGenerate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.65625rem',
            color: 'var(--mute-2)',
            marginTop: 8
        }
    }, t('visit.plan.needsOpenVisit'))), suggestion && !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, suggestion.interactionWarnings?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginBottom: 12
        }
    }, suggestion.interactionWarnings.map((w, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                display: 'flex',
                alignItems: 'flex-start',
                gap: 8,
                padding: '8px 10px',
                marginBottom: 5,
                borderRadius: 7,
                background: ((0, $6xvbB.SEVERITY_CLR)[w.severity] || (0, $jTCZr.C).amber) + '14',
                border: `1px solid ${(0, $6xvbB.SEVERITY_CLR)[w.severity] || (0, $jTCZr.C).amber}44`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.59375rem',
                fontWeight: 700,
                padding: '1px 6px',
                borderRadius: 4,
                background: (0, $6xvbB.SEVERITY_CLR)[w.severity] || (0, $jTCZr.C).amber,
                color: '#fff',
                flexShrink: 0
            }
        }, (0, $6xvbB.SEVERITY_LBL)(t)[w.severity] || w.severity), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.6875rem',
                color: 'var(--ink)',
                lineHeight: 1.6
            }
        }, w.drugPair && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("strong", {
            style: {
                marginInlineEnd: 4
            }
        }, w.drugPair, ":"), w.description)))), $9b4ee9e6346f75da$var$PLAN_GROUPS(t, suggestion).filter((g)=>g.items.length > 0).map((group)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: group.key,
            "data-testid": `visit-plan-group-${group.key}`,
            style: {
                marginBottom: 12
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 6,
                marginBottom: 6
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.71875rem',
                fontWeight: 600,
                color: 'var(--ink)'
            }
        }, group.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.59375rem',
                background: 'var(--line)',
                color: 'var(--ink-2)',
                padding: '1px 6px',
                borderRadius: 4,
                fontWeight: 700
            }
        }, group.items.length)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: 5
            }
        }, group.items.map((item, i)=>{
            const name = group.nameOf(item);
            const key = planKey(group.key, name);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.OrderCheckItem), {
                key: `${key}-${i}`,
                item: {
                    key: key,
                    name: name,
                    reason: group.reasonOf(item, t),
                    urgency: item.urgency,
                    loincCode: item.loincCode,
                    modality: item.modality
                },
                selected: selected.has(key),
                onToggle: onToggle,
                showLoinc: group.key === 'lab'
            });
        })))), suggestion.clinicalRationale && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginBottom: 12,
            padding: '9px 11px',
            borderRadius: 7,
            background: 'var(--bg)',
            border: '1px solid var(--line)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.65625rem',
            fontWeight: 600,
            color: 'var(--mute)',
            marginBottom: 3
        }
    }, t('visit.copilot.clinicalRationale')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.6875rem',
            color: 'var(--ink-2)',
            lineHeight: 1.8
        }
    }, suggestion.clinicalRationale)), dropped > 0 && !confirmed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-plan-drift",
        style: {
            marginBottom: 10,
            fontSize: '0.65625rem',
            color: 'var(--warn-ink)',
            background: 'var(--warn-soft)',
            border: '1px solid var(--warn)',
            borderRadius: 7,
            padding: '7px 10px',
            lineHeight: 1.7
        }
    }, t('visit.plan.editNoteHint', {
        count: dropped
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        "data-testid": "visit-plan-apply",
        onClick: onConfirm,
        disabled: saving || confirmed,
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6,
            padding: '8px 16px',
            borderRadius: 8,
            border: 'none',
            background: confirmed ? 'var(--line)' : 'var(--accent)',
            color: confirmed ? 'var(--mute)' : '#fff',
            fontSize: '0.78125rem',
            fontWeight: 600,
            fontFamily: 'inherit',
            cursor: saving || confirmed ? 'not-allowed' : 'pointer',
            opacity: saving ? 0.7 : 1
        }
    }, saving && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 10,
            height: 10,
            border: '2px solid #ffffff55',
            borderTopColor: '#fff',
            borderRadius: '50%',
            animation: 'spin .7s linear infinite'
        }
    }), confirmed ? t('visit.plan.approved') : t('visit.plan.confirmWithCount', {
        count: selected.size
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        "data-testid": "visit-plan-regen",
        onClick: onRegenerate,
        disabled: loading || saving,
        style: {
            padding: '8px 12px',
            borderRadius: 8,
            border: '1px solid var(--line)',
            background: 'none',
            color: 'var(--mute)',
            fontSize: '0.71875rem',
            fontFamily: 'inherit',
            cursor: loading || saving ? 'not-allowed' : 'pointer'
        }
    }, t('visit.plan.regenerateIcon'))))));
}
// ── Work-tab section vocabulary ────────────────────────────────────────────────
// The SEC_* card/head/title/icon/field vocabulary now lives in Visit.shared.js
// (imported above) so the shared order forms render the exact same language as
// the encounter-order form here. Used by all four work tabs, not orders alone.
// ─────────────────────────────────────────────────────────────────────────────
// سوابق ویزیت‌های قبلی — previous-visit history
//
// Two surfaces over one cache. The RAIL row answers "what happened last time?"
// without a click: date, the diagnoses, and how many drugs and orders came out
// of it. The SHEET answers "what exactly?" — every diagnosis, every drug with
// its dosage, every order with its state, and the visit summary — for all
// visits at once, so the doctor compares rather than pogo-sticks.
//
// The rail deliberately does NOT expand in place. Its column already scrolls
// past the viewport with allergies, vitals, meds, diagnoses and labs above it;
// an accordion there buries the sections below whichever visit is open.
// ─────────────────────────────────────────────────────────────────────────────
const $9b4ee9e6346f75da$var$HIST_CHIP = {
    fontSize: '0.65625rem',
    fontWeight: 600,
    padding: '2px 7px',
    borderRadius: 5,
    background: 'var(--accent-soft)',
    color: 'var(--accent-ink)',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '100%'
};
const $9b4ee9e6346f75da$var$HIST_COUNT = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 3,
    fontSize: '0.65625rem',
    color: 'var(--mute)',
    whiteSpace: 'nowrap'
};
const $9b4ee9e6346f75da$var$HIST_SECTION_LABEL = {
    fontSize: '0.625rem',
    fontWeight: 700,
    color: 'var(--mute-2)',
    letterSpacing: '.06em',
    marginBottom: 6
};
// A past visit's SOAP sections, as the closure's SOAP card names them.
const $9b4ee9e6346f75da$var$HIST_SOAP_LABEL = {
    S: 'visit.soap.sLetter',
    O: 'visit.soap.oLetter',
    A: 'visit.soap.aLetter',
    P: 'visit.soap.pLetter'
};
function $9b4ee9e6346f75da$export$1926cf20f638f600({ notes: notes, visitId: visitId }) {
    const { t: t } = (0, $LNQP4.default)();
    const parts = (0, $dL6zl.visitSoapSections)(notes);
    if (!parts.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": `history-row-soap-${visitId}`,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 3,
            marginTop: 6
        }
    }, parts.map(({ key: key, text: text })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            key: key,
            "data-testid": `history-row-soap-${visitId}-${key}`,
            style: {
                display: 'flex',
                alignItems: 'flex-start',
                gap: 6
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            title: t($9b4ee9e6346f75da$var$HIST_SOAP_LABEL[key]),
            style: {
                flexShrink: 0,
                minWidth: 16,
                textAlign: 'center',
                fontSize: '0.625rem',
                fontWeight: 700,
                color: 'var(--accent-ink)',
                background: 'var(--panel)',
                border: '1px solid var(--line)',
                borderRadius: 4,
                padding: '0 3px',
                lineHeight: 1.6
            }
        }, key), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "auto",
            style: {
                flex: 1,
                minWidth: 0,
                fontSize: '0.6875rem',
                color: 'var(--ink-2)',
                lineHeight: 1.6,
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                whiteSpace: 'pre-line'
            }
        }, text))));
}
/** «۳ دارو · ۲ دستور» — the counts that make a row worth opening. */ function $9b4ee9e6346f75da$var$VisitCountStrip({ medCount: medCount, orderCount: orderCount }) {
    const { t: t } = (0, $LNQP4.default)();
    if (!medCount && !orderCount) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            marginTop: 5
        }
    }, medCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: $9b4ee9e6346f75da$var$HIST_COUNT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).pill, {
        width: 11,
        height: 11
    }), t('visit.history.drugCount', {
        count: medCount
    })), orderCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: $9b4ee9e6346f75da$var$HIST_COUNT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).notes, {
        width: 11,
        height: 11
    }), t('visit.history.orderCount', {
        count: orderCount
    })));
}
// «تکمیل نحوه مصرف» is hidden for now (PM-0096, owner's call 2026-10-05). The
// button, its handler and its price row all stay; flip this to show it again.
const $9b4ee9e6346f75da$var$SHOW_RX_DIRECTIONS = false;
function $9b4ee9e6346f75da$export$b320a358c3c13da4({ visit: visit, ctx: ctx, summary: summary, onOpen: onOpen, onReprescribe: onReprescribe, prescribedNames: prescribedNames, allergies: allergies, erxCodes: erxCodes }) {
    const { t: t, formatDate: formatDate, formatTime: formatTime, formatRelativeTime: formatRelativeTime } = (0, $LNQP4.default)();
    const data = ctx?.state === 'ready' ? ctx.data : null;
    const failed = ctx?.state === 'error';
    const busy = !ctx || ctx.state === 'loading';
    const dx = (0, $6xvbB.visitDiagnosisLabels)(data, summary);
    const meds = data?.medications || [];
    const orders = data?.orders || [];
    const shown = dx.slice(0, $9b4ee9e6346f75da$var$RAIL_DX_CHIPS);
    const rest = dx.length - shown.length;
    const dateLabel = visit.scheduledDate ? formatDate(visit.scheduledDate, 'medium') : '';
    const timeLabel = visit.scheduledDate ? formatTime(visit.scheduledDate) : '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: ()=>onOpen(visit.id),
        title: t('visit.history.openDetails', {
            date: dateLabel
        }),
        style: {
            width: '100%',
            textAlign: 'start',
            fontFamily: 'inherit',
            cursor: 'pointer',
            padding: '9px 11px',
            borderRadius: 10,
            border: '1px solid var(--line)',
            background: 'var(--panel-2)',
            display: 'block'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'baseline',
            gap: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 6,
            height: 6,
            borderRadius: '50%',
            background: 'var(--accent)',
            flexShrink: 0,
            alignSelf: 'center'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.75rem',
            fontWeight: 600,
            color: 'var(--ink)'
        }
    }, dateLabel), timeLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.65625rem',
            color: 'var(--mute)'
        }
    }, timeLabel), visit.scheduledDate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.625rem',
            color: 'var(--mute-2)',
            marginInlineStart: 'auto'
        }
    }, formatRelativeTime(visit.scheduledDate))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: 5,
            marginInlineStart: 12
        }
    }, busy ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 120,
        height: 11
    }) : failed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.6875rem',
            color: 'var(--mute)'
        }
    }, t('visit.history.loadFailed')) : shown.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: 4
        }
    }, shown.map((label, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            key: i,
            style: $9b4ee9e6346f75da$var$HIST_CHIP
        }, label)), rest > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            ...$9b4ee9e6346f75da$var$HIST_CHIP,
            background: 'var(--panel)',
            color: 'var(--mute)',
            border: '1px solid var(--line)'
        }
    }, t('visit.history.more', {
        count: rest
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.6875rem',
            color: 'var(--mute-2)'
        }
    }, t('visit.history.noDiagnoses')), !busy && !failed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$export$1926cf20f638f600, {
        notes: data?.notes,
        visitId: visit.id
    }), erxCodes?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $jDxJA.ErxCodeChips), {
        codes: erxCodes,
        nested: true,
        testid: `history-row-erx-${visit.id}`
    })), !busy && !failed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'flex-end',
            gap: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$VisitCountStrip, {
        medCount: meds.length,
        orderCount: orders.length
    })), onReprescribe && meds.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fGLlt.default), {
        meds: meds,
        title: t('visit.rx.represcribeFromVisit', {
            date: dateLabel
        }),
        onApply: onReprescribe,
        prescribedNames: prescribedNames,
        allergies: allergies,
        testid: "history-row-represcribe"
    }))));
}
/** A titled group inside the sheet; renders its own empty line rather than vanishing. */ function $9b4ee9e6346f75da$var$VisitDetailGroup({ icon: Icon, title: title, empty: empty, children: children, count: count }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginBottom: 14
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            ...$9b4ee9e6346f75da$var$HIST_SECTION_LABEL,
            display: 'flex',
            alignItems: 'center',
            gap: 5
        }
    }, Icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        width: 11,
        height: 11
    }), title, count > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontWeight: 400,
            color: 'var(--mute)',
            background: 'var(--line-2)',
            padding: '1px 6px',
            borderRadius: 99
        }
    }, count)), count > 0 ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.71875rem',
            color: 'var(--mute-2)',
            fontStyle: 'italic'
        }
    }, empty));
}
function $9b4ee9e6346f75da$export$a11c0a1f10498aa7({ ctx: ctx, summary: summary, onReprescribe: onReprescribe, prescribedNames: prescribedNames, onReorder: onReorder, isOrdered: isOrdered, reorderingId: reorderingId, erxCodes: erxCodes }) {
    const { t: t, readsPersianData: readsPersianData } = (0, $LNQP4.default)();
    const orderName = (0, $6xvbB.useCatalogNamesEn)((ctx?.data?.orders || []).map((o)=>o.description));
    if (!ctx || ctx.state === 'loading') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fWbIA.VisitDetailSkeleton), null);
    if (ctx.state === 'error') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.75rem',
            color: 'var(--danger)',
            marginBottom: 14
        }
    }, t('visit.history.loadFailed')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $jDxJA.ErxCodeGroup), {
        codes: erxCodes,
        testid: "history-visit-erx"
    }));
    const data = ctx.data || {};
    const conds = data.conditions || [];
    const meds = data.medications || [];
    const orders = data.orders || [];
    const soapParts = (0, $dL6zl.visitSoapSections)(data.notes);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$VisitDetailGroup, {
        icon: (0, $6xvbB.I).sparkle,
        title: t('visit.history.diagnoses'),
        empty: t('visit.history.noDiagnoses'),
        count: conds.length
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: 5
        }
    }, conds.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            key: c.id,
            style: {
                ...$9b4ee9e6346f75da$var$HIST_CHIP,
                fontSize: '0.71875rem',
                padding: '3px 9px'
            }
        }, c.display || c.code, c.code && c.display && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontFamily: 'monospace',
                fontWeight: 400,
                opacity: .7,
                marginInlineStart: 5
            }
        }, c.code))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$VisitDetailGroup, {
        icon: (0, $6xvbB.I).pill,
        title: t('visit.history.medications'),
        empty: t('visit.history.noMedications'),
        count: meds.length
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 4
        }
    }, meds.map((m)=>{
        const added = prescribedNames?.has((m.display || m.code || '').trim().toLowerCase());
        const medName = (0, $g6gAc.medDisplayName)(m);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: m.id,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                padding: '5px 8px',
                borderRadius: 7,
                background: 'var(--panel-2)'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1,
                minWidth: 0,
                display: 'flex',
                alignItems: 'baseline',
                gap: 8,
                flexWrap: 'wrap'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "auto",
            style: {
                fontSize: '0.75rem',
                fontWeight: 600,
                color: 'var(--ink)'
            }
        }, medName), m.dosageInstruction && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.6875rem',
                color: 'var(--mute)'
            }
        }, (0, $6xvbB.doseLineLabel)(typeof m.dosageInstruction === 'string' ? m.dosageInstruction : m.dosageInstruction.text, t, readsPersianData))), onReprescribe && (added ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "data-testid": "history-med-represcribed",
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 4,
                fontSize: '0.65625rem',
                fontWeight: 700,
                color: 'var(--good)',
                flexShrink: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).check, {
            width: 11,
            height: 11
        }), " ", t('visit.rx.represcribed')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            onClick: ()=>onReprescribe(m),
            "data-testid": "history-med-represcribe",
            "aria-label": t('visit.rx.represcribeAria', {
                name: m.display || m.code
            }),
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 4,
                flexShrink: 0,
                fontSize: '0.65625rem',
                fontWeight: 700,
                fontFamily: 'inherit',
                cursor: 'pointer',
                padding: '3px 8px',
                borderRadius: 6,
                border: '1px solid var(--line)',
                background: 'var(--panel)',
                color: 'var(--accent-ink)'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).reload, {
            width: 11,
            height: 11
        }), " ", t('visit.rx.represcribe'))));
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$VisitDetailGroup, {
        icon: (0, $6xvbB.I).notes,
        title: t('visit.history.orders'),
        empty: t('visit.history.noOrders'),
        count: orders.length
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 4
        }
    }, orders.map((o)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: o.id,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                padding: '5px 8px',
                borderRadius: 7,
                background: 'var(--panel-2)'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.625rem',
                fontWeight: 700,
                color: 'var(--mute)',
                flexShrink: 0
            }
        }, (0, $6xvbB.ORDER_TYPE_FA)(t)[o.orderType] || o.orderType), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
                flex: 1,
                minWidth: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.75rem',
                color: 'var(--ink)'
            }
        }, orderName(o.description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aQGDs.OrderDateLine), {
            order: o,
            compact: true,
            testid: `history-order-date-${o.id}`
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 1,
                flexShrink: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aQGDs.OrderStageChip), {
            order: o,
            compact: true,
            testid: `history-order-stage-${o.id}`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aQGDs.OrderBookingLine), {
            order: o,
            compact: true,
            testid: `history-order-booking-${o.id}`
        })), onReorder && (isOrdered?.(o) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "data-testid": "history-order-reordered",
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 4,
                fontSize: '0.65625rem',
                fontWeight: 700,
                color: 'var(--good)',
                flexShrink: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).check, {
            width: 11,
            height: 11
        }), " ", t('visit.orders.added')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            type: "button",
            onClick: ()=>onReorder(o),
            disabled: !!reorderingId,
            "aria-busy": reorderingId === o.id || undefined,
            "data-testid": "history-order-reorder",
            "aria-label": t('visit.rx.represcribeAria', {
                name: orderName(o.description)
            }),
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 4,
                flexShrink: 0,
                fontSize: '0.65625rem',
                fontWeight: 700,
                fontFamily: 'inherit',
                cursor: reorderingId ? 'default' : 'pointer',
                padding: '3px 8px',
                borderRadius: 6,
                border: '1px solid var(--line)',
                background: 'var(--panel)',
                color: 'var(--accent-ink)',
                opacity: reorderingId && reorderingId !== o.id ? 0.55 : 1
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).reload, {
            width: 11,
            height: 11
        }), " ", t('visit.rx.represcribe'))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $jDxJA.ErxCodeGroup), {
        codes: erxCodes,
        testid: "history-visit-erx",
        style: {
            marginBottom: 14
        }
    }), soapParts.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "history-visit-soap",
        style: {
            marginBottom: 14
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: $9b4ee9e6346f75da$var$HIST_SECTION_LABEL
    }, t('visit.end.partSoap')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 8
        }
    }, soapParts.map(({ key: key, text: text })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: key,
            "data-testid": `history-visit-soap-${key}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.65625rem',
                fontWeight: 700,
                color: 'var(--mute)',
                marginBottom: 2
            }
        }, t($9b4ee9e6346f75da$var$HIST_SOAP_LABEL[key])), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            dir: "auto",
            style: {
                fontSize: '0.71875rem',
                color: 'var(--ink-2)',
                lineHeight: 1.8,
                whiteSpace: 'pre-wrap'
            }
        }, text))))), (summary?.summary || summary?.icdCodes?.length > 0) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: $9b4ee9e6346f75da$var$HIST_SECTION_LABEL
    }, t('visit.history.summary')), summary.summary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.71875rem',
            color: 'var(--ink-2)',
            lineHeight: 1.8
        }
    }, summary.summary), summary.icdCodes?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: 4,
            marginTop: 7
        }
    }, summary.icdCodes.map((c, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            key: i,
            style: {
                fontSize: '0.625rem',
                padding: '2px 7px',
                borderRadius: 5,
                background: 'var(--panel)',
                border: '1px solid var(--line)',
                color: 'var(--mute)',
                fontFamily: 'monospace'
            }
        }, c.code, c.description ? ` \xb7 ${c.description}` : '')))));
}
function $9b4ee9e6346f75da$export$8be8592afbe60619({ visits: visits, ctxById: ctxById, summaryMap: summaryMap, expandedId: expandedId, onExpand: onExpand, onClose: onClose, onReprescribe: onReprescribe, onReprescribeMany: onReprescribeMany, onLoadContext: onLoadContext, prescribedNames: prescribedNames, allergies: allergies, onReorder: onReorder, isOrdered: isOrdered, reorderingId: reorderingId, erxCodes: erxCodes }) {
    const { t: t, formatDate: formatDate, formatTime: formatTime, formatRelativeTime: formatRelativeTime, formatList: formatList } = (0, $LNQP4.default)();
    (0, $acw62.useEffect)(()=>{
        const onKey = (e)=>{
            if (e.key === 'Escape') onClose();
        };
        window.addEventListener('keydown', onKey);
        return ()=>window.removeEventListener('keydown', onKey);
    }, [
        onClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'fixed',
            inset: 0,
            zIndex: 1200,
            background: 'rgba(28,27,24,.45)',
            backdropFilter: 'blur(3px)'
        },
        onClick: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "dialog",
        "aria-modal": "true",
        "aria-label": t('visit.history.sheetTitle'),
        "data-testid": "visit-history-sheet",
        onClick: (e)=>e.stopPropagation(),
        style: {
            position: 'absolute',
            insetBlock: 0,
            insetInlineStart: 0,
            width: 'min(560px, 94vw)',
            background: 'var(--panel)',
            borderInlineEnd: '1px solid var(--line)',
            display: 'flex',
            flexDirection: 'column',
            boxShadow: '0 0 40px rgba(0,0,0,.18)',
            animation: 'fadeUp .18s ease'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '14px 16px',
            borderBottom: '1px solid var(--line)',
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).history, {
        width: 15,
        height: 15,
        style: {
            color: 'var(--accent)'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.84375rem',
            fontWeight: 600,
            color: 'var(--ink)'
        }
    }, t('visit.history.sheetTitle')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.6875rem',
            color: 'var(--mute)',
            background: 'var(--line-2)',
            padding: '2px 8px',
            borderRadius: 99
        }
    }, t('visit.history.visitCount', {
        count: visits.length
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: onClose,
        "aria-label": t('common.actions.close'),
        style: {
            marginInlineStart: 'auto',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            color: 'var(--mute)',
            display: 'grid',
            placeItems: 'center',
            width: 26,
            height: 26,
            borderRadius: 7
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).close, {
        width: 15,
        height: 15
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            overflowY: 'auto',
            padding: '10px 16px 20px'
        }
    }, visits.map((v)=>{
        const isOpen = expandedId === v.id;
        const summary = summaryMap.get(String(v.id));
        const ctx = ctxById[v.id];
        const data = ctx?.state === 'ready' ? ctx.data : null;
        const dateLabel = v.scheduledDate ? formatDate(v.scheduledDate, 'medium') : '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: v.id,
            style: {
                borderBottom: '1px solid var(--line-2)',
                paddingBottom: isOpen ? 12 : 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            onClick: ()=>onExpand(isOpen ? null : v.id),
            "aria-expanded": isOpen,
            style: {
                width: '100%',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                fontFamily: 'inherit',
                padding: '11px 2px',
                display: 'flex',
                alignItems: 'center',
                gap: 9,
                textAlign: 'start'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
            viewBox: "0 0 16 16",
            fill: "none",
            stroke: "currentColor",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            style: {
                width: 13,
                height: 13,
                color: 'var(--mute)',
                flexShrink: 0,
                transform: isOpen ? 'rotate(90deg)' : 'none',
                transition: 'transform .2s'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M5 3l5 5-5 5"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1,
                minWidth: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'baseline',
                gap: 7
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.78125rem',
                fontWeight: 600,
                color: 'var(--ink)'
            }
        }, dateLabel), v.scheduledDate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.65625rem',
                color: 'var(--mute)'
            }
        }, formatTime(v.scheduledDate))), !isOpen && data && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.6875rem',
                color: 'var(--mute)',
                marginTop: 2,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            }
        }, formatList((0, $6xvbB.visitDiagnosisLabels)(data, summary)) || t('visit.history.noDiagnoses'))), onReprescribeMany && ctx?.state !== 'error' && !(data && !(data.medications || []).length) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fGLlt.default), {
            meds: data?.medications || [],
            state: data ? 'ready' : 'loading',
            title: t('visit.rx.represcribeFromVisit', {
                date: dateLabel
            }),
            onOpen: ()=>onLoadContext?.(v.id),
            onApply: onReprescribeMany,
            prescribedNames: prescribedNames,
            allergies: allergies,
            testid: "history-sheet-represcribe"
        }), v.scheduledDate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.625rem',
                color: 'var(--mute-2)',
                flexShrink: 0
            }
        }, formatRelativeTime(v.scheduledDate))), isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                paddingInlineStart: 22,
                animation: 'fadeUp .18s ease'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$export$a11c0a1f10498aa7, {
            ctx: ctx,
            summary: summary,
            onReprescribe: onReprescribe,
            prescribedNames: prescribedNames,
            onReorder: onReorder ? (o)=>onReorder(v.id, o) : null,
            isOrdered: isOrdered,
            reorderingId: reorderingId,
            erxCodes: erxCodes?.get(String(v.id))
        })));
    }))));
}
// ── پرونده بیمار — collapsible context-panel sections ────────────────────────
//
// Every section of the record column speaks one header grammar: title, count
// pill, a one-line gist of the content, optional inline actions, and the
// chevron. The gist renders only while the section is CLOSED, so a collapsed
// section still tells the doctor what it holds without re-opening it. Open
// state persists per section in localStorage, so the layout a doctor arranges
// (labs collapsed, vitals open) survives reloads and carries to the next visit.
//
// Long lists never grow in place — beyond the preview cap they open in a
// RecordListSheet, the same inline-start sheet the visit history uses (§5.2:
// contextual detail beside a list you must not lose), so the work area and the
// rest of the record stay visible underneath.
// ─────────────────────────────────────────────────────────────────────────────
// Preview caps for the record rail — beyond these the section opens its sheet.
/** Where the record column's open/closed choice is remembered, per browser (PM-0035). Unset = the screen-size default. */ const $9b4ee9e6346f75da$var$RECORD_OPEN_KEY = 'parsina.visit.record.open';
/** After this many dismissals in one visit the dock's nudge stays quiet (PM-0048). */ const $9b4ee9e6346f75da$var$NUDGE_MAX_DISMISSALS = 2;
const $9b4ee9e6346f75da$var$RECORD_PREVIEW = {
    meds: 6,
    dx: 6,
    conds: 8,
    labs: 10,
    files: 3
};
// ── The visit dock — «پرونده» and «دستیار» in ONE strip (PM-0048) ─────────────
//
// The two side panels used to fold to two rails on opposite edges of the page.
// They now share a single strip at the inline-start that is always there, open
// or closed, so each panel has one button in one place:
//
//   · «پرونده» first — the record is what the doctor works from; its panel
//     opens right beside the dock.
//   · «دستیار» second — with a count of what it is holding, so a closed
//     assistant still says it has something.
//   · «نسخه» third — «ارسال به بیمه» (PM-0152, K1 2026-10-12): it opens the
//     e-prescription panel for the whole visit, and replaces the نسخه and
//     دستورات headers' own send buttons. An amber dot when a registered
//     prescription has changes a correction can still carry. Only where the
//     visit offers an Iranian insurer at all (erxAvailable).
//   · the NUDGE: when the assistant is closed and something NEW arrived
//     (differentials after the history is written, a clinical note after
//     vitals), one small card beside its button says what, and «مشاهده» opens
//     that tab. It appears once per arrival, never on a timer, never loops, and
//     after two dismissals in a visit it stays quiet — the count remains.
//   · what must survive a closed record: the allergy alert (a safety signal,
//     not reference material) and the way to a video visit.
//
// The mic / «پایش بالینی» is NOT here: it lives in the page's top bar.
// The dock's two tones in CT tokens (PM-0154). The page's own `var(--primary)` /
// `var(--accent)` lose to tokens.css `:root[data-panel]`, which makes them bare HSL
// triples — an invalid colour — so a pressed «پرونده» or «نسخه» had no border, no
// tint and black text, looked unpressed, and jumped 2 px when toggled.
const $9b4ee9e6346f75da$var$DOCK_TONE = {
    primary: {
        line: (0, $jTCZr.CT).navy,
        tint: (0, $jTCZr.soft)((0, $jTCZr.CT).navy, 0.1),
        ink: (0, $jTCZr.CT).navy
    },
    accent: {
        line: (0, $jTCZr.CT).accent,
        tint: (0, $jTCZr.CT).accentSoft,
        ink: (0, $jTCZr.CT).accentInk
    }
};
const $9b4ee9e6346f75da$export$5ba9ea9124f78b58 = (on, tone)=>{
    const c = $9b4ee9e6346f75da$var$DOCK_TONE[tone] || $9b4ee9e6346f75da$var$DOCK_TONE.primary;
    return {
        position: 'relative',
        width: 44,
        padding: '8px 0 6px',
        borderRadius: 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 4,
        border: `1px solid ${on ? c.line : 'transparent'}`,
        background: on ? c.tint : 'transparent',
        color: c.ink,
        cursor: 'pointer',
        fontFamily: 'inherit',
        fontSize: '0.625rem',
        fontWeight: 600
    };
};
function $9b4ee9e6346f75da$export$cccda98cbc9f2aa5({ t: t, formatNumber: formatNumber, recordOpen: recordOpen, recordLocked: recordLocked, onToggleRecord: onToggleRecord, copilotOpen: copilotOpen, copilotLocked: copilotLocked, onToggleCopilot: onToggleCopilot, copilotCount: copilotCount, allergyCount: allergyCount, allergyTitle: allergyTitle, showCall: showCall, lowBalance: lowBalance, onOpenRecord: onOpenRecord, onOpenCopilot: onOpenCopilot, nudge: nudge, onNudgeView: onNudgeView, onNudgeDismiss: onNudgeDismiss, erxAvailable: erxAvailable = false, erxOpen: erxOpen = false, onToggleErx: onToggleErx, erxPendingCount: erxPendingCount = 0, canBuyCredits: canBuyCredits = true }) {
    // The low-balance button opens the copilot, where the strip offers «شارژ
    // اعتبار» — or, where credit is not sold here, only says the balance is low.
    const lowBalanceLabel = canBuyCredits ? t('credits.topUp') : t('credits.level.low');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("nav", {
        "data-testid": "visit-dock",
        "aria-label": t('visit.panel.dock'),
        style: {
            gridRow: 2,
            gridColumn: 1,
            position: 'relative',
            zIndex: 5,
            background: 'var(--panel)',
            borderInlineEnd: '1px solid var(--line)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 8,
            padding: '12px 0',
            minHeight: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: recordLocked ? undefined : onToggleRecord,
        "data-testid": "visit-dock-record",
        "aria-pressed": recordOpen,
        "aria-label": recordOpen ? t('visit.panel.foldRecord') : t('visit.panel.openRecord'),
        title: recordOpen ? t('visit.panel.foldRecord') : t('visit.panel.openRecord'),
        style: $9b4ee9e6346f75da$export$5ba9ea9124f78b58(recordOpen, 'primary')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).doc, {
        width: 18,
        height: 18
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: 'var(--ink-2)'
        }
    }, t('visit.panel.recordShort'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: copilotLocked ? undefined : onToggleCopilot,
        "data-testid": "visit-dock-copilot",
        "aria-pressed": copilotOpen,
        "aria-label": copilotOpen ? t('visit.copilot.fold') : t('visit.copilot.open'),
        title: copilotOpen ? t('visit.copilot.fold') : t('visit.copilot.open'),
        style: $9b4ee9e6346f75da$export$5ba9ea9124f78b58(copilotOpen, 'accent')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).sparkle, {
        width: 18,
        height: 18
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: 'var(--ink-2)'
        }
    }, t('visit.copilot.assistant')), !copilotOpen && copilotCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "visit-dock-copilot-count",
        style: {
            position: 'absolute',
            top: -6,
            insetInlineEnd: -5,
            minWidth: 17,
            height: 17,
            padding: '0 4px',
            borderRadius: 9,
            background: 'var(--accent-ink)',
            color: '#fff',
            fontSize: '0.59375rem',
            fontWeight: 700,
            display: 'grid',
            placeItems: 'center',
            lineHeight: 1
        }
    }, formatNumber(copilotCount))), erxAvailable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onToggleErx,
        "data-testid": "visit-dock-erx",
        "aria-pressed": erxOpen,
        "aria-label": erxOpen ? t('visit.erx.dock.fold') : t('visit.erx.dock.open'),
        title: erxOpen ? t('visit.erx.dock.fold') : t('visit.erx.dock.open'),
        style: $9b4ee9e6346f75da$export$5ba9ea9124f78b58(erxOpen, 'primary')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).send, {
        width: 18,
        height: 18
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: 'var(--ink-2)'
        }
    }, t('visit.erx.dock.label')), erxPendingCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": "true",
        "data-testid": "visit-dock-erx-pending",
        style: {
            position: 'absolute',
            top: -3,
            insetInlineEnd: -2,
            width: 8,
            height: 8,
            borderRadius: '50%',
            background: (0, $jTCZr.CT).warn
        }
    })), !recordOpen && allergyCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onOpenRecord,
        "data-testid": "visit-dock-allergy",
        "aria-label": allergyTitle,
        title: allergyTitle,
        style: {
            position: 'relative',
            width: 40,
            height: 40,
            borderRadius: 8,
            display: 'grid',
            placeItems: 'center',
            cursor: 'pointer',
            fontFamily: 'inherit',
            marginTop: 4,
            border: '1px solid var(--danger)',
            background: 'var(--danger-soft)',
            color: 'var(--danger-ink)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).alert, {
        width: 16,
        height: 16
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            position: 'absolute',
            top: -6,
            insetInlineEnd: -6,
            minWidth: 17,
            height: 17,
            padding: '0 4px',
            borderRadius: 9,
            background: 'var(--danger)',
            color: '#fff',
            fontSize: '0.59375rem',
            fontWeight: 700,
            display: 'grid',
            placeItems: 'center',
            lineHeight: 1
        }
    }, formatNumber(allergyCount))), !recordOpen && showCall && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onOpenRecord,
        "data-testid": "visit-dock-call",
        "aria-label": t('visit.panel.recordCall'),
        title: t('visit.panel.recordCall'),
        style: {
            width: 40,
            padding: '7px 0 5px',
            borderRadius: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 3,
            border: '1px solid var(--accent)',
            background: 'var(--accent-soft)',
            color: 'var(--accent-ink)',
            cursor: 'pointer',
            fontFamily: 'inherit',
            fontSize: '0.59375rem',
            fontWeight: 700
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: 6,
            height: 6,
            borderRadius: '50%',
            background: 'var(--accent)',
            display: 'inline-block'
        }
    }), t('visit.panel.recordCallShort')), !copilotOpen && lowBalance && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onOpenCopilot,
        "data-testid": "visit-dock-lowbalance",
        "aria-label": lowBalanceLabel,
        title: lowBalanceLabel,
        style: {
            width: 28,
            height: 28,
            borderRadius: 7,
            display: 'grid',
            placeItems: 'center',
            cursor: 'pointer',
            border: '1px solid var(--warn)',
            background: 'var(--warn-soft)',
            color: 'var(--warn-ink)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).alert, {
        width: 13,
        height: 13
    })), nudge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-dock-nudge",
        role: "status",
        style: {
            position: 'absolute',
            insetInlineStart: 'calc(100% + 8px)',
            top: 70,
            width: 250,
            background: 'var(--panel)',
            border: '1px solid var(--accent)',
            borderRadius: 10,
            boxShadow: 'var(--shadow-pop)',
            padding: '10px 12px',
            display: 'flex',
            flexDirection: 'column',
            gap: 8,
            animation: 'fadeUp .22s ease both'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            fontSize: '0.6875rem',
            fontWeight: 600,
            color: 'var(--accent-ink)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).sparkle, {
        width: 13,
        height: 13
    }), t('visit.copilot.title'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onNudgeDismiss,
        "data-testid": "visit-dock-nudge-dismiss",
        "aria-label": t('visit.panel.nudgeDismiss'),
        title: t('visit.panel.nudgeDismiss'),
        style: {
            marginInlineStart: 'auto',
            width: 22,
            height: 22,
            display: 'grid',
            placeItems: 'center',
            border: 'none',
            background: 'transparent',
            color: 'var(--mute)',
            cursor: 'pointer'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).x, {
        width: 12,
        height: 12
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.78125rem',
            fontWeight: 600,
            color: 'var(--ink)',
            lineHeight: 1.7
        }
    }, t(nudge.kind === 'diff' ? 'visit.panel.nudgeDiff' : 'visit.panel.nudgeSugg', {
        count: formatNumber(nudge.count)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onNudgeView,
        "data-testid": "visit-dock-nudge-view",
        style: {
            alignSelf: 'flex-start',
            padding: '4px 12px',
            borderRadius: 8,
            cursor: 'pointer',
            fontFamily: 'inherit',
            fontSize: '0.75rem',
            fontWeight: 600,
            border: '1px solid var(--accent-ink)',
            background: 'var(--accent-ink)',
            color: '#fff'
        }
    }, t('visit.panel.nudgeView'))));
}
function $9b4ee9e6346f75da$var$RecordSection({ id: id, icon: Icon, title: title, count: count, badge: badge, gist: gist, actions: actions, open: open, onToggle: onToggle, tone: tone, children: children }) {
    const { t: t } = (0, $LNQP4.default)();
    const danger = tone === 'danger';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `record-section-${id}`,
        style: {
            borderBottom: '1px solid var(--line)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: ()=>onToggle(id),
        "aria-expanded": open,
        "data-testid": `record-toggle-${id}`,
        title: open ? t('visit.recordPanel.collapseSection', {
            title: title
        }) : t('visit.recordPanel.expandSection', {
            title: title
        }),
        style: {
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '11px 16px',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontFamily: 'inherit',
            textAlign: 'start'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 7
        }
    }, danger ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: 16,
            height: 16,
            borderRadius: '50%',
            background: 'var(--danger)',
            color: '#fff',
            display: 'grid',
            placeItems: 'center',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).alert, {
        width: 9,
        height: 9
    })) : Icon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        width: 13,
        height: 13,
        style: {
            color: 'var(--mute)',
            flexShrink: 0
        }
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontWeight: 600,
            fontSize: '0.8125rem',
            color: danger ? 'var(--danger-ink)' : 'var(--ink)',
            whiteSpace: 'nowrap'
        }
    }, title), count > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.6875rem',
            fontWeight: 400,
            padding: '2px 8px',
            borderRadius: 99,
            flexShrink: 0,
            background: danger ? 'var(--danger-soft)' : 'var(--line-2)',
            color: danger ? 'var(--danger-ink)' : 'var(--mute)'
        }
    }, count), badge), !open && gist && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.6875rem',
            color: 'var(--mute)',
            marginTop: 3,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    }, gist)), actions, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: 'var(--mute)',
            display: 'grid',
            placeItems: 'center',
            flexShrink: 0,
            transition: 'transform .18s',
            transform: open ? 'rotate(-90deg)' : 'rotate(90deg)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).arrow, {
        width: 11,
        height: 11
    }))), open && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '0 16px 14px'
        }
    }, children));
}
/** «مشاهدهٔ همه» — the header action that opens a section's full-list sheet. */ function $9b4ee9e6346f75da$var$RecordViewAll({ onOpen: onOpen, testid: testid }) {
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordHeaderAction, {
        label: t('common.actions.viewAll'),
        onClick: onOpen,
        testid: testid
    });
}
// ── «پرونده بیمار» — the rail's ONE visual vocabulary (PM-0036) ───────────────
// Every section used to carry its own copy of these — three header-action
// styles, two label sizes, two chip radii, two empty-line styles — and they had
// drifted. A section now picks from here and nowhere else:
//   · header: icon + title + count (+ badge) + ONE kind of action + chevron
//   · body:   RECORD_LABEL over values, RECORD_CHIP for short facts,
//             RECORD_CARD for a boxed value, RECORD_EMPTY when there is nothing,
//             RecordMore as the «+N» line under a preview
const $9b4ee9e6346f75da$var$RECORD_LABEL = {
    fontSize: '0.59375rem',
    fontWeight: 600,
    letterSpacing: '.04em',
    color: 'var(--mute-2)'
};
const $9b4ee9e6346f75da$var$RECORD_EMPTY = {
    fontSize: '0.71875rem',
    color: 'var(--mute-2)'
};
const $9b4ee9e6346f75da$var$RECORD_CHIP = {
    fontSize: '0.71875rem',
    padding: '3px 9px',
    borderRadius: 6,
    background: 'var(--panel-2)',
    border: '1px solid var(--line)',
    color: 'var(--ink-2)'
};
const $9b4ee9e6346f75da$var$RECORD_CHIP_DANGER = {
    ...$9b4ee9e6346f75da$var$RECORD_CHIP,
    background: 'var(--panel)',
    border: '1px solid oklch(0.82 0.08 25)',
    color: 'var(--danger-ink)',
    fontWeight: 500
};
const $9b4ee9e6346f75da$var$RECORD_CARD = {
    background: 'var(--panel-2)',
    border: '1px solid var(--line)',
    borderRadius: 'var(--radius)'
};
/**
 * A section header's inline action («ویرایش», «مشاهدهٔ جزئیات», «مشاهدهٔ همه»).
 * A span, not a button: it sits inside the section's toggle <button>.
 */ function $9b4ee9e6346f75da$var$RecordHeaderAction({ icon: Icon, label: label, onClick: onClick, testid: testid }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        onClick: (e)=>{
            e.stopPropagation();
            onClick();
        },
        "data-testid": testid,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 3,
            fontSize: '0.6875rem',
            fontWeight: 600,
            color: 'var(--accent-ink)',
            flexShrink: 0,
            whiteSpace: 'nowrap'
        }
    }, Icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        width: 10,
        height: 10
    }), " ", label);
}
/** The «+N …» line under a section's preview; opens that section's full list. */ function $9b4ee9e6346f75da$var$RecordMore({ onOpen: onOpen, testid: testid, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: onOpen,
        "data-testid": testid,
        style: {
            width: '100%',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontFamily: 'inherit',
            fontSize: '0.6875rem',
            fontWeight: 600,
            color: 'var(--accent-ink)',
            textAlign: 'center',
            paddingTop: 6
        }
    }, children);
}
/**
 * Full-list sheet for one record section. Same chrome and same edge as the
 * visit-history sheet, so «مشاهدهٔ همه» behaves identically wherever it
 * appears in the record column.
 */ function $9b4ee9e6346f75da$var$RecordListSheet({ icon: Icon, title: title, count: count, onClose: onClose, children: children, testid: testid }) {
    const { t: t } = (0, $LNQP4.default)();
    (0, $acw62.useEffect)(()=>{
        const onKey = (e)=>{
            if (e.key === 'Escape') onClose();
        };
        window.addEventListener('keydown', onKey);
        return ()=>window.removeEventListener('keydown', onKey);
    }, [
        onClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'fixed',
            inset: 0,
            zIndex: 1200,
            background: 'rgba(28,27,24,.45)',
            backdropFilter: 'blur(3px)'
        },
        onClick: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "dialog",
        "aria-modal": "true",
        "aria-label": title,
        "data-testid": testid,
        onClick: (e)=>e.stopPropagation(),
        style: {
            position: 'absolute',
            insetBlock: 0,
            insetInlineStart: 0,
            width: 'min(480px, 94vw)',
            background: 'var(--panel)',
            borderInlineEnd: '1px solid var(--line)',
            display: 'flex',
            flexDirection: 'column',
            boxShadow: '0 0 40px rgba(0,0,0,.18)',
            animation: 'fadeUp .18s ease'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '14px 16px',
            borderBottom: '1px solid var(--line)',
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            flexShrink: 0
        }
    }, Icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        width: 15,
        height: 15,
        style: {
            color: 'var(--accent)'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.84375rem',
            fontWeight: 600,
            color: 'var(--ink)'
        }
    }, title), count > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.6875rem',
            color: 'var(--mute)',
            background: 'var(--line-2)',
            padding: '2px 8px',
            borderRadius: 99
        }
    }, count), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: onClose,
        "aria-label": t('common.actions.close'),
        style: {
            marginInlineStart: 'auto',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            color: 'var(--mute)',
            display: 'grid',
            placeItems: 'center',
            width: 26,
            height: 26,
            borderRadius: 7
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).close, {
        width: 15,
        height: 15
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            overflowY: 'auto',
            padding: '12px 16px 20px'
        }
    }, children)));
}
// ─────────────────────────────────────────────────────────────────────────────
// «بیمار در یک نگاه» — the patient at a glance (PM-0023)
//
// One modal that answers "who is this patient, clinically?" without a search
// through the record: the history, what was prescribed before, what they take
// now, and what needs attention. It holds NO data of its own — every panel reads
// what the rail already loaded (the patient, the three prefetched past visits,
// the summaries), so opening it costs no request and it can never disagree with
// the sections beside it. Read-only by design: editing stays in the rail.
// ─────────────────────────────────────────────────────────────────────────────
/**
 * A past visit's «شرح حال» — the S the DOCTOR wrote, and nothing standing in for
 * it. No assessment, no plan, no AI summary: a doctor reading «شرح حال» must be
 * reading their own words or an honest "nothing was written".
 */ function $9b4ee9e6346f75da$var$visitHistoryText(context) {
    for (const note of context?.notes || []){
        const c = (0, $dL6zl.parseNoteContent)(note?.content);
        const s = c.subjective || c.s || c.S;
        if (typeof s === 'string' && s.trim()) return s.trim();
    }
    return '';
}
// The glance shows a preview of the two lists that can run long; «مشاهدهٔ همه»
// hands over to the SAME full-list sheet the rail opens, so there is one full
// list per section, not two.
const $9b4ee9e6346f75da$var$GLANCE_PREVIEW = {
    meds: 6,
    dx: 6
};
const $9b4ee9e6346f75da$var$GLANCE_EMPTY = {
    fontSize: '0.71875rem',
    color: 'var(--mute-2)',
    fontStyle: 'italic'
};
function $9b4ee9e6346f75da$var$GlancePanel({ icon: Icon, title: title, count: count, tone: tone, testid: testid, action: action, children: children }) {
    const danger = tone === 'danger';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
        "data-testid": testid,
        style: {
            border: `1px solid ${danger ? 'oklch(0.85 0.08 25)' : 'var(--line)'}`,
            borderRadius: 10,
            background: 'var(--panel)',
            display: 'flex',
            flexDirection: 'column',
            minHeight: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 7,
            padding: '10px 12px',
            borderBottom: '1px solid var(--line)',
            flexShrink: 0
        }
    }, Icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        width: 13,
        height: 13,
        style: {
            color: danger ? 'var(--danger)' : 'var(--accent)',
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.78125rem',
            fontWeight: 700,
            color: danger ? 'var(--danger-ink)' : 'var(--ink)'
        }
    }, title), count > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.6875rem',
            padding: '1px 7px',
            borderRadius: 99,
            background: danger ? 'var(--danger-soft)' : 'var(--line-2)',
            color: danger ? 'var(--danger-ink)' : 'var(--mute)'
        }
    }, count), action && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            marginInlineStart: 'auto',
            flexShrink: 0
        }
    }, action)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '10px 12px 12px',
            overflowY: 'auto',
            minHeight: 0
        }
    }, children));
}
function $9b4ee9e6346f75da$var$PatientGlanceModal({ patient: patient, conditions: conditions, activeConds: activeConds, visits: visits, ctxById: ctxById, currentMeds: currentMeds, abnormalLabs: abnormalLabs, vitalsAlert: vitalsAlert, hasMoreVisits: hasMoreVisits, onOpenHistory: onOpenHistory, onViewAllMeds: onViewAllMeds, onViewAllDx: onViewAllDx, onClose: onClose }) {
    const { t: t, formatDate: formatDate, formatRelativeTime: formatRelativeTime, formatList: formatList, readsPersianData: readsPersianData } = (0, $LNQP4.default)();
    (0, $acw62.useEffect)(()=>{
        const onKey = (e)=>{
            if (e.key === 'Escape') onClose();
        };
        window.addEventListener('keydown', onKey);
        return ()=>window.removeEventListener('keydown', onKey);
    }, [
        onClose
    ]);
    const allergies = patient?.allergies || [];
    const doseOf = (m)=>{
        const text = typeof m.dosageInstruction === 'string' ? m.dosageInstruction : m.dosageInstruction?.text;
        return text ? (0, $6xvbB.doseLineLabel)(text, t, readsPersianData) : '';
    };
    const medLine = (m, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: (m.id || m.display) + '_' + i,
            style: {
                display: 'flex',
                alignItems: 'baseline',
                gap: 8,
                flexWrap: 'wrap',
                padding: '5px 8px',
                borderRadius: 7,
                background: 'var(--panel-2)'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "auto",
            style: {
                fontSize: '0.75rem',
                fontWeight: 600,
                color: 'var(--ink)'
            }
        }, (0, $g6gAc.medDisplayName)(m)), doseOf(m) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.6875rem',
                color: 'var(--mute)'
            }
        }, doseOf(m)));
    const visitHead = (v)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'baseline',
                gap: 6,
                marginBottom: 4
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                width: 6,
                height: 6,
                borderRadius: '50%',
                background: 'var(--accent)',
                flexShrink: 0,
                alignSelf: 'center'
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.75rem',
                fontWeight: 600,
                color: 'var(--ink)'
            }
        }, v.scheduledDate ? formatDate(v.scheduledDate, 'medium') : ''), v.scheduledDate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.625rem',
                color: 'var(--mute-2)',
                marginInlineStart: 'auto'
            }
        }, formatRelativeTime(v.scheduledDate)));
    const ctxOf = (v)=>ctxById[v.id];
    const dataOf = (v)=>ctxOf(v)?.state === 'ready' ? ctxOf(v).data : null;
    const loading = visits.some((v)=>!ctxOf(v) || ctxOf(v).state === 'loading');
    // «شرح حال» is the LAST visit's, only — older ones are one click away in
    // «همهٔ سوابق ویزیت», and three half-read histories are not a glance.
    const lastVisit = visits[0] || null;
    const lastCtx = lastVisit ? ctxOf(lastVisit) : null;
    const lastLoading = Boolean(lastVisit) && (!lastCtx || lastCtx.state === 'loading');
    const lastHistory = lastVisit ? $9b4ee9e6346f75da$var$visitHistoryText(dataOf(lastVisit)) : '';
    const rxRows = visits.map((v)=>({
            v: v,
            meds: dataOf(v)?.medications || []
        })).filter((r)=>r.meds.length);
    const hasHistory = conditions.length > 0 || activeConds.length > 0 || Boolean(lastVisit);
    const attentionCount = allergies.length + abnormalLabs.length + (vitalsAlert?.messages?.length || 0);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'fixed',
            inset: 0,
            zIndex: 1200,
            background: 'rgba(28,27,24,.45)',
            backdropFilter: 'blur(3px)',
            display: 'grid',
            placeItems: 'center',
            padding: 24
        },
        onClick: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "dialog",
        "aria-modal": "true",
        "aria-label": t('visit.glance.title'),
        "data-testid": "patient-glance-modal",
        onClick: (e)=>e.stopPropagation(),
        style: {
            width: 'min(1040px, 100%)',
            maxHeight: '100%',
            background: 'var(--panel-2)',
            border: '1px solid var(--line)',
            borderRadius: 14,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            boxShadow: '0 12px 48px rgba(0,0,0,.22)',
            animation: 'fadeUp .18s ease'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '14px 16px',
            borderBottom: '1px solid var(--line)',
            background: 'var(--panel)',
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).scan, {
        width: 15,
        height: 15,
        style: {
            color: 'var(--accent)'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.84375rem',
            fontWeight: 600,
            color: 'var(--ink)'
        }
    }, t('visit.glance.title')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.75rem',
            color: 'var(--mute)',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    }, [
        patient?.name,
        patient?.age ? t('visit.patient.years', {
            count: patient.age
        }) : null
    ].filter(Boolean).join(" \xb7 ")), hasMoreVisits && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "link",
        size: "sm",
        onClick: onOpenHistory,
        "data-testid": "glance-all-visits",
        style: {
            marginInlineStart: 'auto'
        }
    }, t('visit.glance.allVisits')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: onClose,
        "aria-label": t('common.actions.close'),
        "data-testid": "glance-close",
        style: {
            marginInlineStart: hasMoreVisits ? 0 : 'auto',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            color: 'var(--mute)',
            display: 'grid',
            placeItems: 'center',
            width: 26,
            height: 26,
            borderRadius: 7
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).close, {
        width: 15,
        height: 15
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minHeight: 0,
            overflowY: 'auto',
            padding: 14,
            display: 'grid',
            gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
            gap: 12,
            alignItems: 'start'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$GlancePanel, {
        icon: (0, $6xvbB.I).alert,
        title: t('visit.glance.attention'),
        count: attentionCount,
        tone: attentionCount > 0 ? 'danger' : undefined,
        testid: "glance-attention"
    }, attentionCount === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: $9b4ee9e6346f75da$var$GLANCE_EMPTY
    }, t('visit.glance.noAttention')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 10
        }
    }, allergies.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: $9b4ee9e6346f75da$var$HIST_SECTION_LABEL
    }, t('visit.patient.allergyAlert')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: 5
        }
    }, allergies.map((a, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            key: i,
            style: {
                fontSize: '0.71875rem',
                padding: '3px 9px',
                borderRadius: 4,
                background: 'var(--danger-soft)',
                border: '1px solid oklch(0.82 0.08 25)',
                color: 'var(--danger-ink)',
                fontWeight: 500
            }
        }, a)))), vitalsAlert?.messages?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: $9b4ee9e6346f75da$var$HIST_SECTION_LABEL
    }, t('visit.vitals.title')), vitalsAlert.messages.map((m, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                fontSize: '0.75rem',
                color: 'var(--ink)'
            }
        }, m))), abnormalLabs.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: $9b4ee9e6346f75da$var$HIST_SECTION_LABEL
    }, t('visit.patient.labResults')), abnormalLabs.map((obs, i, arr)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$LabResultRow, {
            key: (obs.id || '') + '_' + i,
            obs: obs,
            isLast: i === arr.length - 1
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$GlancePanel, {
        icon: (0, $6xvbB.I).pill,
        title: t('patient.meds.current'),
        count: currentMeds.length,
        testid: "glance-current-meds",
        action: currentMeds.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "link",
            size: "sm",
            onClick: onViewAllMeds,
            "data-testid": "glance-viewall-meds"
        }, t('common.actions.viewAll')) : null
    }, currentMeds.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: $9b4ee9e6346f75da$var$GLANCE_EMPTY
    }, t('visit.glance.noCurrentMeds')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 4
        }
    }, currentMeds.slice(0, $9b4ee9e6346f75da$var$GLANCE_PREVIEW.meds).map(medLine), currentMeds.length > $9b4ee9e6346f75da$var$GLANCE_PREVIEW.meds && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.6875rem',
            color: 'var(--mute)',
            textAlign: 'center',
            paddingTop: 2
        }
    }, "+ ", currentMeds.length - $9b4ee9e6346f75da$var$GLANCE_PREVIEW.meds, " ", t('visit.rx.moreMedications')))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$GlancePanel, {
        icon: (0, $6xvbB.I).notes,
        title: t('visit.glance.history'),
        testid: "glance-history"
    }, !hasHistory ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: $9b4ee9e6346f75da$var$GLANCE_EMPTY
    }, t('visit.glance.noHistory')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 10
        }
    }, lastVisit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "glance-last-history"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: $9b4ee9e6346f75da$var$HIST_SECTION_LABEL
    }, t('visit.glance.lastVisitHistory')), visitHead(lastVisit), lastLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 180,
        height: 11
    }) : lastHistory ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: "auto",
        style: {
            fontSize: '0.78125rem',
            color: 'var(--ink)',
            lineHeight: 1.9,
            whiteSpace: 'pre-wrap'
        }
    }, lastHistory) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: $9b4ee9e6346f75da$var$GLANCE_EMPTY
    }, t('visit.glance.noLastHistory'))), activeConds.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 8,
            marginBottom: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            ...$9b4ee9e6346f75da$var$HIST_SECTION_LABEL,
            marginBottom: 0
        }
    }, t('patient.conditions.active')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "link",
        size: "sm",
        onClick: onViewAllDx,
        "data-testid": "glance-viewall-dx"
    }, t('common.actions.viewAll'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: 5
        }
    }, activeConds.slice(0, $9b4ee9e6346f75da$var$GLANCE_PREVIEW.dx).map((c, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            key: (c.id || c.display) + '_' + i,
            style: {
                ...$9b4ee9e6346f75da$var$HIST_CHIP,
                fontSize: '0.71875rem',
                padding: '3px 9px'
            }
        }, c.display)), activeConds.length > $9b4ee9e6346f75da$var$GLANCE_PREVIEW.dx && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            ...$9b4ee9e6346f75da$var$HIST_CHIP,
            fontSize: '0.71875rem',
            padding: '3px 9px',
            background: 'var(--panel)',
            color: 'var(--mute)',
            border: '1px solid var(--line)'
        }
    }, t('visit.history.more', {
        count: activeConds.length - $9b4ee9e6346f75da$var$GLANCE_PREVIEW.dx
    })))), conditions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: $9b4ee9e6346f75da$var$HIST_SECTION_LABEL
    }, t('visit.patient.conditionHistory')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.71875rem',
            color: 'var(--ink-2)',
            lineHeight: 1.8
        }
    }, formatList([
        ...new Set(conditions.filter(Boolean))
    ]))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$GlancePanel, {
        icon: (0, $6xvbB.I).history,
        title: t('visit.glance.pastRx'),
        testid: "glance-past-rx"
    }, loading && rxRows.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fWbIA.VisitDetailSkeleton), null) : rxRows.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: $9b4ee9e6346f75da$var$GLANCE_EMPTY
    }, t('visit.glance.noPastRx')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 10
        }
    }, rxRows.map(({ v: v, meds: meds })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: v.id
        }, visitHead(v), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: 4
            }
        }, meds.map(medLine)))))))));
}
/** One active-medication card — shared by the record rail and the full sheet. */ function $9b4ee9e6346f75da$var$MedCard({ med: med, onRemove: onRemove, onReprescribe: onReprescribe, represcribed: represcribed }) {
    const { t: t, readsPersianData: readsPersianData } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "med-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: "iconbtn danger",
        onClick: ()=>onRemove(med),
        title: t('visit.rx.stop'),
        style: {
            color: 'var(--mute)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).trash, {
        width: 14,
        height: 14
    })), onReprescribe && (represcribed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        title: t('visit.rx.represcribed'),
        "data-testid": "med-represcribed",
        style: {
            width: 28,
            height: 28,
            display: 'grid',
            placeItems: 'center',
            color: 'var(--good)',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).check, {
        width: 14,
        height: 14
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: "iconbtn",
        onClick: ()=>onReprescribe(med),
        title: t('visit.rx.represcribe'),
        "aria-label": t('visit.rx.represcribeAria', {
            name: (0, $g6gAc.medDisplayName)(med)
        }),
        "data-testid": "med-represcribe",
        style: {
            color: 'var(--accent-ink)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).reload, {
        width: 14,
        height: 14
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "med-card-info"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "med-card-name",
        dir: "auto"
    }, (0, $g6gAc.medDisplayName)(med)), med.warn && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "med-warn-badge"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).alert, {
        width: 10,
        height: 10
    }), med.warn), med.dosageInstruction?.text && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "med-card-dose"
    }, (0, $6xvbB.doseLineLabel)(med.dosageInstruction.text, t, readsPersianData))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: 28,
            height: 28,
            borderRadius: 8,
            background: 'var(--accent-soft)',
            display: 'grid',
            placeItems: 'center',
            color: 'var(--accent-ink)',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).pill, {
        width: 14,
        height: 14
    })));
}
/**
 * One active-diagnosis card — shared by the record rail and the full sheet.
 *
 * Carries the «نوع تشخیص» badge (موقت/احتمالی vs قطعی): requirement 4 is that a
 * doctor can tell the two apart at a glance in this list, so the badge sits on
 * the title line rather than being deferred to a detail view. `onChangeType`
 * makes the badge the edit affordance too — the type is changed where it is
 * read, which is also the only place a diagnosis NOT promoted from a
 * differential (one typed into SOAP «A») can be re-typed at all.
 */ function $9b4ee9e6346f75da$var$CondCard({ cond: cond, onRemove: onRemove, onChangeType: onChangeType, busy: busy }) {
    const { t: t } = (0, $LNQP4.default)();
    const [picking, setPicking] = (0, $acw62.useState)(false);
    const type = (0, $6ojK3.diagnosisTypeOf)(cond);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "med-card",
        style: {
            flexWrap: 'wrap'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: "iconbtn danger",
        onClick: ()=>onRemove(cond),
        title: t('visit.dx.remove'),
        style: {
            color: 'var(--mute)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).trash, {
        width: 14,
        height: 14
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "med-card-info"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "med-card-name",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            flexWrap: 'wrap'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, cond.display), onChangeType ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        "data-testid": `dx-type-edit-${cond.id || cond.display}`,
        onClick: ()=>setPicking((v)=>!v),
        title: t('visit.dx.type.changeTitle'),
        style: {
            background: 'none',
            border: 'none',
            padding: 0,
            cursor: 'pointer',
            font: 'inherit'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $i9Cif.DiagnosisTypeBadge), {
        cond: cond
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $i9Cif.DiagnosisTypeBadge), {
        cond: cond
    })), cond.code && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "med-card-dose"
    }, cond.code)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: 28,
            height: 28,
            borderRadius: 8,
            background: 'var(--accent-soft)',
            display: 'grid',
            placeItems: 'center',
            color: 'var(--accent-ink)',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).sparkle, {
        width: 14,
        height: 14
    })), picking && onChangeType && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flexBasis: '100%'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $i9Cif.DiagnosisTypeChoice), {
        testidPrefix: `dx-type-choice-${cond.id || cond.display}`,
        title: t('visit.dx.type.changeTitle'),
        current: type,
        busy: busy,
        onCancel: ()=>setPicking(false),
        onPick: async (next)=>{
            if (next !== type) await onChangeType(cond, next);
            setPicking(false);
        }
    })));
}
/** One lab-result row — shared by the record rail and the full sheet. */ function $9b4ee9e6346f75da$var$LabResultRow({ obs: obs, isLast: isLast }) {
    const { t: t, formatDate: formatDate } = (0, $LNQP4.default)();
    const isCritical = obs.status === 'CRITICAL';
    const isAbnormal = obs.status === 'ABNORMAL';
    const valColor = isCritical ? 'var(--danger)' : isAbnormal ? 'oklch(0.52 0.18 50)' : 'var(--good)';
    const rowBg = isCritical ? 'var(--danger-soft)' : isAbnormal ? 'oklch(0.98 0.025 55)' : 'transparent';
    const dateStr = obs.effectiveDate ? formatDate(obs.effectiveDate, 'dayMonth') : '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '7px 9px',
            borderRadius: 8,
            background: rowBg,
            borderBottom: isLast ? 'none' : '1px solid var(--line)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 7,
            height: 7,
            borderRadius: '50%',
            background: valColor,
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.75rem',
            fontWeight: 500,
            color: 'var(--ink)',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    }, obs.display), obs.referenceRange && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.59375rem',
            color: 'var(--mute)',
            marginTop: 1,
            direction: 'ltr'
        }
    }, "ref: ", obs.referenceRange)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            textAlign: 'end',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontWeight: 700,
            fontSize: '0.84375rem',
            color: valColor,
            fontFamily: 'monospace',
            direction: 'ltr',
            lineHeight: 1.2
        }
    }, obs.value, obs.unit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.59375rem',
            fontWeight: 400,
            color: 'var(--mute)',
            marginInlineStart: 2
        }
    }, " ", obs.unit) : ''), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.5625rem',
            color: 'var(--mute)',
            textAlign: 'start',
            marginTop: 1
        }
    }, dateStr)), (isCritical || isAbnormal) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.5625rem',
            padding: '1px 5px',
            borderRadius: 4,
            flexShrink: 0,
            background: isCritical ? 'var(--danger)' : 'oklch(0.88 0.08 55)',
            color: isCritical ? '#fff' : 'oklch(0.42 0.14 55)',
            fontWeight: 700
        }
    }, isCritical ? t('visit.vitals.critical') : t('visit.vitals.abnormal')));
}
function $9b4ee9e6346f75da$export$2e2bcd8739ae039({ navigate: navProp, patient: routePatient }) {
    const { t: t, has: has, formatNumber: formatNumber, formatList: formatList, formatDigits: formatDigits, formatDate: formatDate, formatTime: formatTime, formatRelativeTime: formatRelativeTime, readsPersianData: readsPersianData, locale: locale } = (0, $LNQP4.default)();
    // The Iranian insurer rails — «ارسال به بیمه», the eRx registry's category — only
    // for a clinic in rials, or one the host has not said (host.jsx useIranianRails).
    const iranianRails = (0, $e317r.useIranianRails)();
    const goBack = (0, $eBrFc.useAppBack)();
    const { patient: patient, loading: pLoading, refresh: refreshPatient } = (0, $k5DdK.usePatient)(routePatient?.id);
    // `loading` matters: until the doctor's settings have arrived, `ai` is {}
    // and every `!== false` gate reads as ENABLED. Deciding an auto-run in that
    // window means the setting is honoured only when the doctor query happens to
    // win the race against the patient query.
    const { doctor: doctor, loading: doctorLoading, error: doctorError, update: updateDoctorSettings } = (0, $9ycDe.useDoctor)();
    const toast = (0, $7LBYc.useOptionalToast)();
    const walletBalance = (0, $3wi2X.useWalletBalance)(doctor?.id);
    // ── Layout the doctor arranged in Settings → «صفحه ویزیت» ────────────────
    // Resolved once per settings object: which record sections render and in
    // what order, which work/copilot tabs exist, and which open first. `null`
    // (settings in flight or failed) resolves to the page as it shipped, so the
    // first paint is never wrong, only default. See screens/Visit/visitLayout.js.
    const storedVisitLayout = doctor?.settings?.visitLayout ?? null;
    const visitLayout = (0, $acw62.useMemo)(()=>(0, $aoLHg.resolveVisitLayout)(storedVisitLayout), [
        storedVisitLayout
    ]);
    const workTabVisible = (0, $acw62.useMemo)(()=>Object.fromEntries(visitLayout.workTabs.map((tab)=>[
                tab.id,
                tab.visible
            ])), [
        visitLayout
    ]);
    const copilotTabVisible = (0, $acw62.useMemo)(()=>Object.fromEntries(visitLayout.copilotTabs.map((tab)=>[
                tab.id,
                tab.visible
            ])), [
        visitLayout
    ]);
    // The per-visit «پارسه» tally lives with the visit — see the coin ledger
    // below, declared once the encounter id it is keyed by exists.
    const ai = doctor?.settings?.aiAgent || {};
    // «نکات بالینی» is always available — the doctor only chooses whether it
    // arrives unprompted. Off ONLY on an explicit `false`, so an absent key never
    // reads as an opt-out. See Settings.shared.js. An empty `ai` is a different
    // case entirely, and the predicate below is what tells the two apart.
    // Whether the doctor's choice is KNOWN. `loading` was the only guard here,
    // which made every gate below fail OPEN on a failed query: `me` fetches
    // `settings` through a second gRPC call inside the same request, so one
    // unavailable doctor-preference call throws the whole query, leaves `doctor`
    // null and `ai` empty — and an empty `ai` reads as ENABLED, because an absent
    // key is not an opt-out. A doctor who switched all three automations off then
    // got the differential, the polling loop and the insight pass anyway, and was
    // billed for them. An error is not a choice, so it reads as "don't run
    // anything by yourself"; every manual button stays live.
    const aiSettingsUnknown = doctorLoading || !!doctorError;
    // Auto-run only when we know the doctor left it on. This also decides
    // whether the RECORDING produces «نکات بالینی»: the AI service runs a hint
    // agent on its own timer for the whole visit, a second producer of the same
    // feed that this switch did not use to reach.
    const suggestionsAutoRun = !aiSettingsUnknown && (0, $3Tnyk.clinicalSuggestionsAutoRun)(ai);
    // The other three automatic runs, each on its own switch now. They used to
    // ride on the two above — which was honest about the billing and dishonest
    // about the naming — or, in the sweep's case, on nothing at all. Every one of
    // them reads as OFF while the doctor's choice is unknown: see the predicate
    // above, and Settings.shared.js for what each switch actually stops.
    const liveHintsOn = !aiSettingsUnknown && (0, $3Tnyk.liveHintsActive)(ai);
    // «موتور تبدیل گفتار به متن». Unlike the switches above this is NOT held off
    // while the choice is unknown: the default is Parsina STT, and the AI service
    // serves the assistant engine whenever Parsina STT cannot answer — so the
    // worst an unknown choice costs is the default, never a dead microphone.
    const speechPref = (0, $4s6k1.speechEnginePreference)(ai);
    const ambientSpeechEngine = (0, $4s6k1.ambientEngine)(speechPref);
    const autoAssistOn = !aiSettingsUnknown && (0, $3Tnyk.autoPrescriptionAssistActive)(ai);
    const reassessOnEdit = !aiSettingsUnknown && (0, $3Tnyk.reassessOnNoteEditActive)(ai);
    // «تکمیل خودکار پس از پایش بالینی» — the top bar's «تکمیل» once the doctor stops.
    const autoCompleteOn = !aiSettingsUnknown && (0, $3Tnyk.autoCompleteOnStopActive)(ai);
    // «تایید خودکار» (PM-0573, DESIGN_CONCEPT §13.3) — the doctor's own switch, and
    // never into a visit being closed. Whether it is closing is known only further
    // down (useEndVisit), so the two hooks that confirm get a reader, asked when a
    // proposal lands; it is set beside «تکمیل»'s own `autoRunOnStop`.
    const autoConfirmOn = !aiSettingsUnknown && (0, $3Tnyk.autoConfirmActive)(ai);
    // The order picker's three display preferences (PM-0701): an absent key reads as
    // the default, so there is nothing to hold back while the choice is unknown — only
    // the FETCHES wait for it, below.
    const { showClinic: orderShowClinic, showFrequent: orderShowFrequent, frequentFirst: orderFrequentFirst } = (0, $3Tnyk.orderPickerPrefs)(ai);
    const autoConfirmNow = (0, $acw62.useRef)(false);
    const autoConfirmAllowed = (0, $acw62.useCallback)(()=>autoConfirmNow.current, []);
    // The sweep is the exception to "unknown reads as off": it is a SAFETY
    // backstop, and a settings query that failed is no reason to stop checking a
    // prescription for a high-severity interaction. Only an explicit «off» from a
    // doctor who says they check by hand stops it.
    const endVisitSweepOn = (0, $3Tnyk.endVisitSweepActive)(ai);
    const [visitId, setVisitId] = (0, $acw62.useState)(null);
    const [visitStatus, setVisitStatus] = (0, $acw62.useState)(null);
    const [leaveConfirm, setLeaveConfirm] = (0, $acw62.useState)(false);
    const pendingNavRef = (0, $acw62.useRef)(null);
    const [tab, setTab] = (0, $acw62.useState)('notes');
    // Prescription
    const [rxItems, setRxItems] = (0, $acw62.useState)([]);
    const [rxInteractions, setRxInteractions] = (0, $acw62.useState)(null);
    const [interactionLoading, setIxLoading] = (0, $acw62.useState)(false);
    const [ixError, setIxError] = (0, $acw62.useState)(null);
    const [aiResult, setAiResult] = (0, $acw62.useState)(null);
    const [aiLoading, setAiLoading] = (0, $acw62.useState)(false);
    const [diagnosis, setDiagnosis] = (0, $acw62.useState)('');
    // ── نسخه drug picker ────────────────────────────────────────────────────────
    // A drug the doctor never prescribed is found by search alone (PM-0043) and
    // reaches the نسخه only through the add form, whose required fields must be
    // filled first (PM-0059). The doctor's FREQUENT drugs are listed under the
    // search before anything is typed and added with one click, with the sig
    // saved the first time (PM-0516, owner 2026-10-20). All of it lives in
    // RxDrugSearch; what stays here is what the visit feeds it.
    //
    // A drug offered from outside — a document review («افزودن به نسخه ویزیت»,
    // §23.3 A13) or an approved AI proposal: its form opens prefilled, and it
    // becomes a نسخه line only by that form's «افزودن به نسخه». Several wait their
    // turn, one form at a time, as on the phone; a drug already waiting is not
    // queued twice.
    const [rxAddQueue, setRxAddQueue] = (0, $acw62.useState)([]);
    const queueRxAdds = (0, $acw62.useCallback)((requests)=>setRxAddQueue((prev)=>[
                ...prev,
                ...requests.filter((r)=>!prev.some((p)=>p.drug.id === r.drug.id))
            ]), []);
    // A search asked for from outside the picker (an AI proposal the list did not settle).
    const [rxSearchRequest, setRxSearchRequest] = (0, $acw62.useState)(null);
    // «داروهای پرتکرار من»: the doctor's most prescribed drugs, each with the sig of
    // their latest prescription of it — the picker's one-click list (PM-0516) and
    // the starting sig of any such drug in the add form. A drug added in THIS
    // visit joins the list at once (withFrequentDrug); the service returns it
    // from the next visit on.
    const [frequentDrugs, setFrequentDrugs] = (0, $acw62.useState)([]);
    const frequentDrugsFetched = (0, $acw62.useRef)(false);
    // AI Recommendations. `recsRan` records that the pass completed at least once,
    // so an empty panel can say "nothing to suggest" instead of "not run yet".
    const [recommendations, setRecommendations] = (0, $acw62.useState)(null);
    const [recsLoading, setRecsLoading] = (0, $acw62.useState)(false);
    const [recsError, setRecsError] = (0, $acw62.useState)(null);
    const [recsRan, setRecsRan] = (0, $acw62.useState)(false);
    const recsAutoFired = (0, $acw62.useRef)(false);
    const assistAutoFired = (0, $acw62.useRef)('');
    // Notes & visit
    const [notes, setNotes] = (0, $acw62.useState)('');
    const [aiInput, setAiInput] = (0, $acw62.useState)('');
    const [aiMessages, setAiMessages] = (0, $acw62.useState)([]);
    const [aiChatLoading, setAiChatLoading] = (0, $acw62.useState)(false);
    const [labOpen, setLabOpen] = (0, $acw62.useState)(false);
    const [savedLabResults, setSavedLabResults] = (0, $acw62.useState)([]);
    const [showClosureFlow, setShowClosureFlow] = (0, $acw62.useState)(false);
    // «ثبت نسخه در بیمه» while the visit is open — the e-prescription card in a
    // panel at the inline-end of the work area (PM-0097; it used to open above the
    // نسخه, K1 2026-10-03, and had to scroll itself into view). Opened from the
    // dock's «نسخه» alone (PM-0152; the top bar's chip went with PM-0187), always
    // on ALL — the card's checkboxes choose the lines. null = closed.
    const [erxScope, setErxScope] = (0, $acw62.useState)(null);
    const erxOpen = erxScope !== null;
    // A login waiting for its code, or a send in flight, is unsaved work: closing
    // the panel or changing its part unmounts the card, so either asks first —
    // as the closure dialog does before it exits.
    const [erxBusy, setErxBusy] = (0, $acw62.useState)(false);
    const erxBusyRef = (0, $acw62.useRef)(false);
    erxBusyRef.current = erxBusy;
    const [erxLeave, setErxLeave] = (0, $acw62.useState)(null); // null | { next: scope | null }
    const changeErxScope = (0, $acw62.useCallback)((next)=>{
        if (erxBusyRef.current) {
            setErxLeave({
                next: next
            });
            return;
        }
        setErxScope(next);
    }, []);
    const erxScopeRef = (0, $acw62.useRef)(null);
    erxScopeRef.current = erxScope;
    // The work area's width decides whether the panel stands beside the work or
    // lies over its edge (VisitErxPanel). Unknown (no ResizeObserver) = beside.
    // A callback ref: the workspace mounts after the record has loaded, long
    // after this component did.
    const [workBodyWidth, setWorkBodyWidth] = (0, $acw62.useState)(0);
    const workBodyObserver = (0, $acw62.useRef)(null);
    const workBodyRef = (0, $acw62.useCallback)((el)=>{
        workBodyObserver.current?.disconnect();
        workBodyObserver.current = null;
        if (!el || typeof ResizeObserver === 'undefined') return;
        const ro = new ResizeObserver((entries)=>setWorkBodyWidth(Math.round(entries[0]?.contentRect?.width || 0)));
        ro.observe(el);
        workBodyObserver.current = ro;
    }, []);
    // «پایان ویزیت» asks before it closes an encounter that cannot be reopened —
    // Reception and the phone always did, the workspace's own topbar did not.
    const [pendingEnd, setPendingEnd] = (0, $acw62.useState)(false);
    // «پیش از پایان ویزیت» (PM-0618): shown INSTEAD of that confirm when an in-house
    // service of this visit is still open in it — its «پایان ویزیت» is the confirmation.
    const [endServicesOpen, setEndServicesOpen] = (0, $acw62.useState)(false);
    // Bumped after a «انجام شد», so «خدمات این مراجعه» reads again.
    const [visitServicesKey, setVisitServicesKey] = (0, $acw62.useState)(0);
    // A high-severity interaction found by the closing sweep held the visit open
    // in silence. This raises the banner in the نسخه tab that says why.
    const [interactionStop, setInteractionStop] = (0, $acw62.useState)(false);
    const [pmEncounterId, setPmEncounterId] = (0, $acw62.useState)(null);
    // ── Per-visit «پارسه» tally ────────────────────────────────────────────────
    // Persisted against the encounter, so it survives a refresh, leaving and
    // re-entering the visit, and a reload of the record — see useVisitCoinLedger.
    // `chargeVisit` stays stable for the whole visit (the ledger's `charge` is
    // created once), which is what lets the billing effects depend on it.
    const { entries: coinLedger, total: visitCoins, charge: recordCoinCharge, refetch: refetchCoins } = (0, $6xvbB.useVisitCoinLedger)(pmEncounterId || visitId || null);
    // The toast is the surface's own voice, so it stays here rather than in the
    // shared ledger; the moving parts it needs are read through a ref so the
    // callback identity never changes.
    const chargeDepsRef = (0, $acw62.useRef)({
        toast: toast,
        t: t,
        formatNumber: formatNumber
    });
    chargeDepsRef.current = {
        toast: toast,
        t: t,
        formatNumber: formatNumber
    };
    const chargeVisit = (0, $acw62.useCallback)((coins, itemId, label)=>{
        if (!coins) return;
        recordCoinCharge(coins, itemId);
        const { toast: tst, t: tr, formatNumber: fn } = chargeDepsRef.current;
        if (label) tst.success(tr('visit.header.coinsToast', {
            label: label,
            coins: (0, $3EzBq.fmtCoins)(coins, fn)
        }));
    }, [
        recordCoinCharge
    ]);
    const [differential, setDifferential] = (0, $acw62.useState)(null);
    const [diffLoading, setDiffLoading] = (0, $acw62.useState)(false);
    const [sessionReady, setSessionReady] = (0, $acw62.useState)(false);
    const [resumedVisit, setResumedVisit] = (0, $acw62.useState)(false); // true when visit was recovered on page reload
    const [soapDiffConfirm, setSoapDiffConfirm] = (0, $acw62.useState)(null); // { description, diagnosisCode }
    // diagnosisCode whose «نوع تشخیص» is being chosen. Confirming a differential
    // is a two-step act on purpose: the type is not a detail to fix up later,
    // it is part of the diagnosis, so there is no path that records one without it.
    const [diffTypePick, setDiffTypePick] = (0, $acw62.useState)(null);
    const [diffTypeBusy, setDiffTypeBusy] = (0, $acw62.useState)(false);
    const [addedSugTests, setAddedSugTests] = (0, $acw62.useState)(new Set());
    const [vitals, setVitals] = (0, $acw62.useState)((0, $6xvbB.emptyVitals));
    const [vitalsMode, setVitalsMode] = (0, $acw62.useState)('form'); // 'form' | 'saved'
    // Per-section open state for the record column — persisted so the layout the
    // doctor arranges (labs collapsed, vitals open) survives reloads mid-visit.
    const [recordSheet, setRecordSheet] = (0, $acw62.useState)(null); // 'meds' | 'dx' | 'conds' | 'labs' | 'files' | null
    // The kind filter of the «مدارک بیمار» sheet; null = every kind.
    const [fileKindFilter, setFileKindFilter] = (0, $acw62.useState)(null);
    // Open/closed per section — the doctor's preference, shared with the phone's
    // record sheet (Visit.shared.js).
    const { recordOpen: recordOpen, toggleRecordSection: toggleRecordSection } = (0, $6xvbB.useRecordSections)(visitLayout, storedVisitLayout, doctorLoading, updateDoctorSettings);
    const [vitalsLoading, setVitalsLoading] = (0, $acw62.useState)(false);
    const [vitalsAlert, setVitalsAlert] = (0, $acw62.useState)(null);
    const [vitalsError, setVitalsError] = (0, $acw62.useState)(null); // validation errors (array of strings)
    const [showVitalsModal, setShowVitalsModal] = (0, $acw62.useState)(false);
    const [showEditPatient, setShowEditPatient] = (0, $acw62.useState)(false);
    const [editPatientForm, setEditPatientForm] = (0, $acw62.useState)({});
    const [editPatientSaving, setEditPatientSaving] = (0, $acw62.useState)(false);
    const [editPatientError, setEditPatientError] = (0, $acw62.useState)('');
    // The clinic country's national-id rule and phone country for that dialog
    // (PM-0218); `undefined` — no capabilities, or an Iranian clinic — is Iran's, as before.
    const { nationalIdCountry: nidDefault, phoneCountry: phoneCountry } = (0, $kyxc1.useCountryDefaults)();
    const savedVitalIds = (0, $acw62.useRef)([]); // IDs of this encounter's vital observations
    const vitalsSeeded = (0, $acw62.useRef)(null); // encounter whose recorded vitals we already adopted
    const [creditError, setCreditError] = (0, $acw62.useState)(null);
    // «خرید پارسه» on the out-of-credit banner and «شارژ اعتبار» on the low-balance
    // strip are offered only where this deployment sells credit (PM-0211,
    // lib/useCreditPrices.js); the warnings themselves always show. Asked of the
    // BFF only once one of the two is on screen.
    const canBuyCredits = (0, $1yr2B.usePurchaseAvailable)(Boolean(creditError) || walletBalance !== null && (0, $jTCZr.creditLevel)(walletBalance) === 'low');
    const [prescriptionTemplates, setPrescriptionTemplates] = (0, $acw62.useState)([]);
    // Visit timer
    const [elapsed, setElapsed] = (0, $acw62.useState)(0);
    const [recElapsed, setRecElapsed] = (0, $acw62.useState)(0); // recording-specific counter
    // New SOAP + copilot/work tab state
    const [soap, setSoap] = (0, $acw62.useState)({
        s: '',
        o: '',
        a: '',
        p: ''
    });
    const [copilotTab, setCopilotTab] = (0, $acw62.useState)('sugg');
    const [copilotExpanded, setCopilotExpanded] = (0, $acw62.useState)(false);
    // Both side panels START by screen size (PM-0048): open on a large monitor,
    // closed on a tablet or a small laptop, where the note needs the width. The
    // dock keeps both one click away either way.
    //   · the assistant's choice lasts for this visit only — a fold remembered
    //     per browser once meant the page opened with it minimized and the doctor
    //     could not tell why;
    //   · the record's choice (PM-0035) is remembered per browser, and a stored
    //     choice wins over the screen-size default.
    const [copilotOpen, setCopilotOpen] = (0, $acw62.useState)((0, $fWbIA.visitPanelsOpenByDefault));
    const toggleCopilotOpen = (0, $acw62.useCallback)((next)=>{
        setCopilotOpen((prev)=>typeof next === 'boolean' ? next : !prev);
    }, []);
    const [recordPanelOpen, setRecordPanelOpen] = (0, $acw62.useState)(()=>{
        try {
            const stored = localStorage.getItem($9b4ee9e6346f75da$var$RECORD_OPEN_KEY);
            if (stored === '0' || stored === '1') return stored === '1';
        } catch  {}
        return (0, $fWbIA.visitPanelsOpenByDefault)();
    });
    const toggleRecordPanelOpen = (0, $acw62.useCallback)((next)=>{
        setRecordPanelOpen((prev)=>{
            const v = typeof next === 'boolean' ? next : !prev;
            try {
                localStorage.setItem($9b4ee9e6346f75da$var$RECORD_OPEN_KEY, v ? '1' : '0');
            } catch  {}
            return v;
        });
    }, []);
    // The dock's nudge: what the assistant held when the doctor last looked (or
    // last dismissed the card), and how often they dismissed it this visit.
    const [copilotSeen, setCopilotSeen] = (0, $acw62.useState)({
        sugg: 0,
        diff: 0
    });
    const [nudgeDismissals, setNudgeDismissals] = (0, $acw62.useState)(0);
    // Which tab each column opens on comes from Settings, but only until the
    // doctor picks one themselves in this visit — a settings refetch mid-visit
    // must not yank a tab out from under them. A tab that became hidden while
    // active falls back to the default regardless.
    const tabsTouched = (0, $acw62.useRef)({
        work: false,
        copilot: false
    });
    const [contextExpanded, setContextExpanded] = (0, $acw62.useState)(false);
    const [diagAIQuestions, setDiagAIQuestions] = (0, $acw62.useState)({}); // { [diagCode]: [{id,question,hint}] }
    const [diagAIAnswers, setDiagAIAnswers] = (0, $acw62.useState)({}); // { [diagCode]: { [qId]: {answer:'yes'|'no', followUp:''} } }
    const [diagAILoading, setDiagAILoading] = (0, $acw62.useState)({}); // { [diagCode]: boolean }
    // An answer is committed the moment it is picked, so the in-flight and failed
    // states are per QUESTION, not per diagnosis: `${diagCode}:${questionId}`.
    const [diagQSubmitting, setDiagQSubmitting] = (0, $acw62.useState)({}); // { [diagCode:qId]: 'yes'|'no' }
    const [diagQError, setDiagQError] = (0, $acw62.useState)({}); // { [diagCode:qId]: string }
    const [openAIDiag, setOpenAIDiag] = (0, $acw62.useState)(null); // diagCode | null
    const [workTab, setWorkTab] = (0, $acw62.useState)('soap');
    (0, $acw62.useEffect)(()=>{
        setWorkTab((prev)=>!tabsTouched.current.work || workTabVisible[prev] === false ? visitLayout.defaultWorkTab : prev);
        setCopilotTab((prev)=>!tabsTouched.current.copilot || copilotTabVisible[prev] === false ? visitLayout.defaultCopilotTab : prev);
    }, [
        visitLayout,
        workTabVisible,
        copilotTabVisible
    ]);
    const pickWorkTab = (0, $acw62.useCallback)((id)=>{
        tabsTouched.current.work = true;
        setWorkTab(id);
    }, []);
    // The tabs that render the SOAP note's editors: S/O/A on «ویزیت», P on «برنامه درمان».
    const noteTab = workTab === 'soap' || workTab === 'plan';
    const pickCopilotTab = (0, $acw62.useCallback)((id)=>{
        tabsTouched.current.copilot = true;
        setCopilotTab(id);
    }, []);
    const [soapNoteId, setSoapNoteId] = (0, $acw62.useState)(null); // ID of the in-progress ClinicalNote for this visit
    // AI-assisted treatment plan — lives inside the SOAP «P» section (the AI button
    // there generates it) rather than in the copilot panel, so the plan is produced,
    // reviewed and filed in the one place the plan belongs: the note.
    const [planSuggestion, setPlanSuggestion] = (0, $acw62.useState)(null); // TreatmentPlanSuggestion | null
    const [planLoading, setPlanLoading] = (0, $acw62.useState)(false);
    const [selectedPlanItems, setSelectedPlanItems] = (0, $acw62.useState)(new Set()); // "med:name" | "lab:name" | ...
    const [planSaving, setPlanSaving] = (0, $acw62.useState)(false);
    const [planStatus, setPlanStatus] = (0, $acw62.useState)(null); // null | 'draft' | 'confirmed'
    const [planError, setPlanError] = (0, $acw62.useState)(null);
    const [planPanelOpen, setPlanPanelOpen] = (0, $acw62.useState)(false); // review panel under the P field
    // The P text the AI note replaced, kept so the doctor can undo a generation
    // that overwrote something they had already written. null = nothing to restore.
    const [planReplacedP, setPlanReplacedP] = (0, $acw62.useState)(null);
    // Clinical orders (from clinicalencounter microservice)
    const [clinicalOrders, setClinicalOrders] = (0, $acw62.useState)([]);
    const [ordersLoading, setOrdersLoading] = (0, $acw62.useState)(false);
    // Whether the list above is the server's answer rather than "not asked yet".
    // The plan reconciler DERIVES «P» from it, and an empty list means "this visit
    // has no orders" — a claim we may only make once the fetch has come back.
    const [ordersLoaded, setOrdersLoaded] = (0, $acw62.useState)(false);
    const [orderTransitioning, setOrderTransitioning] = (0, $acw62.useState)(null); // orderId being transitioned
    const [orderSaving, setOrderSaving] = (0, $acw62.useState)(false);
    const [orderError, setOrderError] = (0, $acw62.useState)(null); // last add-order failure, surfaced in the tab
    const [orderToCancel, setOrderToCancel] = (0, $acw62.useState)(null); // order pending a §5.2 destructive cancel confirm
    const [cancellingVisit, setCancellingVisit] = (0, $acw62.useState)(false);
    // The order catalogue is SEARCHED, never held. It is about to carry the national
    // مکسا list (~20,000 rows): loading it to filter in the browser would be ~4 MB
    // per picker open, and this service has already been OOM-killed once by that
    // shape. Two pieces of state replace the old blob:
    //
    //   catalogPage      the CURRENT PAGE the picker shows — one server search
    //   catalogResolved  what orders ALREADY on the chart need from the catalogue:
    //                    the English name the SOAP plan block prints, whether this
    //                    clinic performs the service, and its code. Keyed by
    //                    catalogId, and by name for the older orders that have none.
    const [catalogPage, setCatalogPage] = (0, $acw62.useState)({
        entries: [],
        total: 0,
        loading: false,
        error: null
    });
    // The two shortcuts in front of the order search (PM-0701): the doctor's frequent
    // orders `[{ times, entry }]`, and the services the visit's clinic performs.
    const [frequentOrders, setFrequentOrders] = (0, $acw62.useState)([]);
    const [clinicOrders, setClinicOrders] = (0, $acw62.useState)({
        entries: [],
        total: 0
    });
    const [catalogResolved, setCatalogResolved] = (0, $acw62.useState)(()=>new Map());
    // Checked items survive a change of query: the doctor ticks «CBC», searches for
    // something else, and both are still added. The old code resolved keys against
    // the full catalogue at submit time, which no longer exists.
    const selectedOrderItems = (0, $acw62.useRef)(new Map());
    // AI order suggestions for the encounter order list (درخواست‌های بالینی)
    const [encOrderSugg, setEncOrderSugg] = (0, $acw62.useState)(null); // { items: [...ranked best-first], rationale }
    const [encOrderSuggLoading, setEncOrderSuggLoading] = (0, $acw62.useState)(false);
    const [encSuggAdding, setEncSuggAdding] = (0, $acw62.useState)(null); // suggestion key being added
    const [encSuggAdded, setEncSuggAdded] = (0, $acw62.useState)(new Set()); // keys already added to the list
    // The tab's structured add-order form. One search over EVERY kind of order —
    // there is no lab / imaging / procedure filter in front of it; each result says
    // its own kind. selectedOrderKeys holds the checked catalog items (keyed `type:name`).
    const [orderSearch, setOrderSearch] = (0, $acw62.useState)('');
    const [orderUrgency, setOrderUrgency] = (0, $acw62.useState)('routine');
    // «تاریخ انجام» (PM-0634): one choice for every item picked, as «فوریت» is.
    const [orderDate, setOrderDate] = (0, $acw62.useState)({
        preset: 'TODAY',
        date: ''
    });
    const [orderNotes, setOrderNotes] = (0, $acw62.useState)('');
    const [orderSessions, setOrderSessions] = (0, $acw62.useState)(1); // procedure only (physiotherapy → N appointments)
    const [selectedOrderKeys, setSelectedOrderKeys] = (0, $acw62.useState)(new Set());
    // Refs for contentEditable SOAP editors
    const soapEditorRefs = (0, $acw62.useRef)({
        s: null,
        o: null,
        a: null,
        p: null
    });
    // Keep contentEditable DOM in sync with soap state (draft restore, AI appends, tab remount, etc.)
    // useLayoutEffect fires synchronously after refs are attached but before browser paint,
    // so adding workTab as a dep ensures fields repopulate immediately when SOAP tab remounts.
    // Skip update if the element is currently focused (user is actively typing).
    (0, $acw62.useLayoutEffect)(()=>{
        [
            's',
            'o',
            'a',
            'p'
        ].forEach((key)=>{
            const el = soapEditorRefs.current[key];
            if (el && document.activeElement !== el && el.textContent !== (soap[key] || '')) el.textContent = soap[key] || '';
        });
    }, [
        soap.s,
        soap.o,
        soap.a,
        soap.p,
        workTab
    ]);
    // Load saved SOAP note from server on visit resume/reload
    (0, $acw62.useEffect)(()=>{
        const encId = pmEncounterId || visitId;
        if (!encId || !patient?.id || visitStatus !== 'inprogress' || soapNoteId) return;
        (0, $eVM84.bffQuery)((0, $6xvbB.LIST_CLINICAL_NOTES), {
            patientId: patient.id,
            appointmentId: encId
        }).then((data)=>{
            // The note is matched with the SHARED reader, not on a literal noteType.
            // When encounters merged into appointments the service dropped
            // `note_type` and kept only `format`, which it refuses to store as
            // anything but "SOAP" — so the BFF now reports every note as
            // noteType 'SOAP'. The old `=== 'SOAP_NOTE'` filter could therefore
            // never match: the editors came up empty on reload AND `soapNoteId`
            // stayed null, so the next autosave took the CREATE branch and left the
            // appointment with two SOAP rows that disagree.
            const note = (0, $dL6zl.primarySoapNote)(data?.listClinicalNotes || []);
            if (!note) return;
            // The id FIRST and unconditionally — the next save must UPDATE this row
            // even if it is currently empty, or the duplicate comes back.
            setSoapNoteId(note.id);
            const draft = (0, $dL6zl.readSoapDraft)([
                note
            ]);
            const next = {
                s: draft.S || '',
                o: draft.O || '',
                a: draft.A || '',
                p: draft.P || ''
            };
            if (!(next.s || next.o || next.a || next.p)) return;
            // A localStorage draft restored moments ago is FRESHER than the server
            // copy (it holds keystrokes made after the last autosave), so it wins.
            setSoap((prev)=>prev.s || prev.o || prev.a || prev.p ? prev : next);
        }).catch(()=>{});
    }, [
        pmEncounterId,
        visitId,
        patient?.id,
        visitStatus
    ]);
    const [dismissedSuggs, setDismissedSuggs] = (0, $acw62.useState)(new Set());
    // ── سوابق ویزیت‌های قبلی ────────────────────────────────────────────────────
    // The rail shows VISIT_HISTORY_PREVIEW visits as scannable rows and nothing
    // else — it is already taller than the viewport, so full detail lives in the
    // sheet instead of expanding in place. `visitCtx` caches one
    // getEncounterContext per visit, keyed by encounter id, and is shared by both.
    const [pastVisitSummaries, setPastVisitSummaries] = (0, $acw62.useState)(null);
    const [expandedEncId, setExpandedEncId] = (0, $acw62.useState)(null);
    const [visitCtx, setVisitCtx] = (0, $acw62.useState)({});
    const [historyOpen, setHistoryOpen] = (0, $acw62.useState)(false);
    // «بیمار در یک نگاه» — reads the same cache; one overlay at a time (§5.2).
    const [glanceOpen, setGlanceOpen] = (0, $acw62.useState)(false);
    // Requested ids live in a ref, not in `visitCtx`, so a re-render mid-flight
    // cannot fire the same query twice.
    const visitCtxRequested = (0, $acw62.useRef)(new Set());
    const loadVisitContext = (0, $acw62.useCallback)((encId)=>{
        if (!encId || visitCtxRequested.current.has(encId)) return;
        visitCtxRequested.current.add(encId);
        setVisitCtx((prev)=>({
                ...prev,
                [encId]: {
                    state: 'loading'
                }
            }));
        (0, $eVM84.bffQuery)((0, $6xvbB.GET_ENCOUNTER_CONTEXT), {
            appointmentId: encId
        }).then((data)=>setVisitCtx((prev)=>({
                    ...prev,
                    [encId]: {
                        state: 'ready',
                        data: data?.getEncounterContext || {}
                    }
                }))).catch(()=>setVisitCtx((prev)=>({
                    ...prev,
                    [encId]: {
                        state: 'error'
                    }
                })));
    }, []);
    // Accepted suggestions tracking
    const [pendingTests, setPendingTests] = (0, $acw62.useState)([]);
    // Current-meds panel: delete via mutation, undo re-adds locally (optimistic)
    const [removedMedNames, setRemovedMedNames] = (0, $acw62.useState)(new Set());
    const [undoMed, setUndoMed] = (0, $acw62.useState)(null);
    const undoTimerRef = (0, $acw62.useRef)(null);
    const [removedCondIds, setRemovedCondIds] = (0, $acw62.useState)(new Set());
    const [undoCond, setUndoCond] = (0, $acw62.useState)(null);
    const undoCondTimerRef = (0, $acw62.useRef)(null);
    const [activeVisitConflict, setActiveVisitConflict] = (0, $acw62.useState)(null); // { visitId } | null
    // The OTHER way starting a visit fails. `activeVisitConflict` is the one cause
    // we can offer a choice about; this is everything else — the encounter was
    // never created, so `visitStatus` stays null and the recording control, the
    // end-visit button and the duration all silently do not render. Holding the
    // error is what turns three missing buttons into one sentence.
    const [startError, setStartError] = (0, $acw62.useState)(null);
    const medKey = (med)=>(med.display || '').trim().toLowerCase();
    const removeMed = async (med)=>{
        setRemovedMedNames((prev)=>new Set([
                ...prev,
                medKey(med)
            ]));
        setUndoMed(med);
        clearTimeout(undoTimerRef.current);
        undoTimerRef.current = setTimeout(()=>setUndoMed(null), 8000);
        const duplicates = (patient?.clinicalMedications || []).filter((m)=>medKey(m) === medKey(med));
        for (const m of duplicates)try {
            await (0, $eVM84.bffMutation)((0, $6xvbB.UPDATE_MEDICATION), {
                id: m.id,
                input: {
                    status: 'stopped'
                }
            });
        } catch  {}
        refreshPatient();
    };
    const restoreMed = async ()=>{
        if (!undoMed) return;
        clearTimeout(undoTimerRef.current);
        const key = medKey(undoMed);
        setRemovedMedNames((prev)=>{
            const s = new Set(prev);
            s.delete(key);
            return s;
        });
        setUndoMed(null);
        const stopped = (patient?.clinicalMedications || []).filter((m)=>medKey(m) === key && m.status === 'stopped');
        for (const m of stopped)try {
            await (0, $eVM84.bffMutation)((0, $6xvbB.UPDATE_MEDICATION), {
                id: m.id,
                input: {
                    status: 'active'
                }
            });
        } catch  {}
        refreshPatient();
    };
    const removeCondition = async (cond)=>{
        setRemovedCondIds((prev)=>new Set([
                ...prev,
                cond.id
            ]));
        setUndoCond(cond);
        clearTimeout(undoCondTimerRef.current);
        undoCondTimerRef.current = setTimeout(()=>setUndoCond(null), 8000);
        try {
            await (0, $eVM84.bffMutation)((0, $6xvbB.DELETE_CONDITION), {
                id: cond.id
            });
        } catch  {}
        refreshPatient();
    };
    const restoreCondition = async ()=>{
        if (!undoCond) return;
        clearTimeout(undoCondTimerRef.current);
        setRemovedCondIds((prev)=>{
            const s = new Set(prev);
            s.delete(undoCond.id);
            return s;
        });
        setUndoCond(null);
        // Restoring must carry the type the row had — an undo that silently
        // downgraded a قطعی diagnosis to موقت would be an unannounced clinical edit.
        try {
            await (0, $eVM84.bffMutation)((0, $6xvbB.ADD_CONDITION), {
                patientId: patient.id,
                input: {
                    code: undoCond.code,
                    display: undoCond.display,
                    clinicalStatus: 'active',
                    verificationStatus: (0, $6ojK3.diagnosisTypeOf)(undoCond)
                }
            });
        } catch  {}
        refreshPatient();
    };
    // «تغییر نوع تشخیص» from the record panel — the one edit path that works for
    // every diagnosis, including those never promoted from a differential.
    const changeCondType = async (cond, type)=>{
        setDiffTypeBusy(true);
        try {
            await (0, $eVM84.bffMutation)((0, $6xvbB.UPDATE_CONDITION), {
                id: cond.id,
                input: {
                    verificationStatus: type
                }
            });
            await refreshPatient();
        } catch  {}
        setDiffTypeBusy(false);
    };
    const toggleMed = (id)=>{};
    const visitStartTime = (0, $acw62.useRef)(null);
    // Vitals belong to the visit, so the recorder opens EMPTY — never seeded with
    // the patient's older readings (see vitalsForEncounter in Visit.shared).
    (0, $acw62.useEffect)(()=>{
        setVitalsMode('form');
        setVitals((0, $6xvbB.emptyVitals)());
        savedVitalIds.current = [];
        vitalsSeeded.current = null;
    }, [
        visitId
    ]);
    // …and fills in only from vitals actually recorded against THIS encounter, so
    // a reload mid-visit shows what was measured today. Runs on every patient
    // refetch but adopts once per encounter, so it can never wipe a form the
    // doctor is filling in.
    (0, $acw62.useEffect)(()=>{
        const encId = pmEncounterId || visitId || null;
        if (!encId || !patient) return;
        const key = String(encId);
        if (vitalsSeeded.current === key) return;
        const { values: values, ids: ids, recorded: recorded } = (0, $6xvbB.vitalsForEncounter)(patient.clinicalObservations, encId);
        if (!recorded) return;
        vitalsSeeded.current = key;
        setVitals(values);
        savedVitalIds.current = ids;
        setVitalsMode('saved');
    }, [
        patient,
        pmEncounterId,
        visitId
    ]);
    // Fetch doctor's prescription templates once on mount
    (0, $acw62.useEffect)(()=>{
        (0, $eVM84.bffQuery)((0, $6xvbB.GET_PRESCRIPTION_TEMPLATES)).then((r)=>{
            if (r?.prescriptionTemplates) setPrescriptionTemplates(r.prescriptionTemplates);
        }).catch(()=>{});
    }, []);
    // Declared BEFORE useTranscription, and that ordering is load-bearing:
    // the transcription hook reads `call.audioSource` to decide whether the
    // visit's audio comes from the conference or from the microphone.
    // ── ویزیت تصویری ───────────────────────────────────────────────────────────
    // The call is opened by a button, never by mounting this screen. Pressing it
    // also starts the visit — `ensureVisitStarted` runs the screen's OWN start
    // path, so there is still exactly one place that marks an appointment
    // in_visit, and a doctor answering a patient who is already waiting does not
    // have to press «شروع ویزیت» first.
    const ensureVisitStarted = (0, $acw62.useCallback)(async ()=>{
        const existing = pmEncounterId || visitId;
        if (existing) return existing;
        const id = await handleStart();
        // null means handleStart already surfaced the reason — the active-visit
        // conflict dialog, or the start-error banner. Nothing to add here.
        if (!id) throw new Error('unavailable');
        return id;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pmEncounterId,
        visitId,
        patient?.id
    ]);
    const call = (0, $fiHxp.useVideoVisit)({
        patientId: patient?.id,
        appointmentId: pmEncounterId || visitId || null,
        ensureVisitStarted: ensureVisitStarted,
        // The brand the CALL shows (window title, join/leave toasts). Passed from
        // here because jitsiEmbed.js is React-free and has no i18n of its own.
        providerName: t('visit.call.providerName')
    });
    // Ask once per patient whether a call is even possible. Cheap: the query mints
    // nothing and writes nothing, and answers `not_configured` rather than failing
    // where no media server exists.
    const { probe: probeCall } = call;
    (0, $acw62.useEffect)(()=>{
        probeCall();
    }, [
        probeCall
    ]);
    // The page is about to be frozen mid-recording — a laptop lid closing, a tab
    // going to the background. Everything still only in memory reaches the draft
    // in this call; see A2 in useTranscription.
    const systemPauseRef = (0, $acw62.useRef)(null);
    const onSystemPause = (0, $acw62.useCallback)((snapshot)=>{
        systemPauseRef.current?.(snapshot);
    }, []);
    const { recState: recState, recError: recError, hints: hints, liveTranscript: liveTranscript, startRec: startRec, stopRec: stopRec, resumeRec: resumeRec, dismissPause: dismissPause, dismissError: dismissError } = (0, $fBZG6.useTranscription)({
        patientId: patient?.id,
        visitId: visitId,
        patientHistory: (0, $6xvbB.buildPatientHistory)(patient) + '\n' + (0, $6xvbB.buildVisitContext)(soap, diagnosis, pendingTests),
        // During a video visit the audio comes from the CALL, not from a second
        // microphone — the mic cannot hear the patient (echo cancellation removes
        // them) and on iOS it would steal the call's own audio session. Null when
        // no call is live, which leaves the in-person path exactly as it was.
        callAudio: call.audioSource,
        onSystemPause: onSystemPause,
        // The switch reaches the STREAM, so the hint agent is never RUN for a
        // doctor who turned «نکات بالینی زنده هنگام ضبط» off — rather than run,
        // billed for in tokens, and then hidden on arrival.
        hintsEnabled: liveHintsOn,
        engine: ambientSpeechEngine
    });
    const isRecording = recState === 'recording';
    const isStopping = recState === 'stopping';
    // Pressed, not yet recording: the button is held so a second press cannot
    // open a second recording (useTranscription, `connecting`).
    const isConnecting = recState === 'connecting';
    const isRecError = recState === 'error';
    // The OS closed the socket while the page was in the background. A desktop
    // tab suspends far less often than a phone does, but it does suspend — and
    // the failure mode was the same on both: the panel went on saying «در حال
    // ضبط» over a socket that no longer existed (§3.1 A1).
    const isRecPaused = recState === 'paused-by-system';
    const hint = hints[0] ? typeof hints[0] === 'string' ? hints[0] : hints[0].text || '' : '';
    // ── Visit lifecycle ────────────────────────────────────────────────────────
    // Returns the started visit's id (= the scheduling appointment id) so that
    // «تماس با بیمار» can start the visit and open the room in one press without
    // a second, subtly different start path. Returns null on every failure it
    // already handles — the conflict dialog and the error banner still surface it.
    const handleStart = async ()=>{
        if (!patient?.id) return null;
        setStartError(null);
        try {
            const now = new Date().toISOString();
            visitStartTime.current = now;
            const cv = await (0, $eVM84.bffMutation)((0, $6xvbB.CREATE_VISIT), {
                patientId: patient.id,
                type: 'OUTPATIENT'
            });
            const id = cv.createVisit.id;
            await (0, $eVM84.bffMutation)((0, $6xvbB.START_VISIT), {
                id: id
            });
            setVisitId(id);
            setPmEncounterId(id);
            setVisitStatus('inprogress');
            setSoapNoteId(null);
            setSessionReady(false);
            (0, $eVM84.bffMutation)((0, $6xvbB.INITIALIZE_VISIT_SESSION), {
                visitId: id,
                patientId: patient.id
            }).then(()=>setSessionReady(true)).catch(()=>setSessionReady(true));
            return id;
        } catch (e) {
            const code = e?.extensions?.code || e?.graphQLErrors?.[0]?.extensions?.code;
            if (code === 'ACTIVE_VISIT_EXISTS') {
                const activeId = e?.extensions?.activeVisitId || e?.graphQLErrors?.[0]?.extensions?.activeVisitId;
                setActiveVisitConflict({
                    visitId: activeId || null
                });
                return null;
            }
            // Was a bare console.warn. A doctor cannot see the console, and the only
            // other symptom is three controls quietly not rendering — which reads as
            // "the feature is gone", not "the visit was never created". They can be
            // half-way through a SOAP note before noticing.
            console.warn('handleStart error:', e);
            setStartError(e);
            return null;
        }
    };
    const handleResumeConflictVisit = ()=>{
        const activeId = activeVisitConflict?.visitId;
        setActiveVisitConflict(null);
        setStartError(null);
        if (!activeId) return;
        setVisitId(activeId);
        setPmEncounterId(activeId);
        setVisitStatus('inprogress');
        setSoapNoteId(null);
        setSessionReady(false);
        (0, $eVM84.bffMutation)((0, $6xvbB.INITIALIZE_VISIT_SESSION), {
            visitId: activeId,
            patientId: patient.id
        }).then(()=>setSessionReady(true)).catch(()=>setSessionReady(true));
    };
    const handleCloseConflictVisit = async ()=>{
        const activeId = activeVisitConflict?.visitId;
        setActiveVisitConflict(null);
        if (activeId) try {
            await (0, $eVM84.bffMutation)((0, $6xvbB.END_VISIT), {
                id: activeId
            });
        } catch  {}
        handleStart();
    };
    // Resolves to whether the note is now persisted. Most callers are fire-and-
    // forget autosaves that ignore it; the confirmation-question flow does not —
    // it may only close its panel once the write it just made has landed.
    //
    // Saves can race for a note not created yet — the editor's blur and the
    // «تأیید» that caused it both save. useSoapNoteRow keeps that to ONE CREATE:
    // a save behind it waits and updates the row it made.
    const writeSoapNoteRow = (0, $6xvbB.useSoapNoteRow)(soapNoteId, setSoapNoteId, visitId);
    const handleSaveSoapNote = async (currentSoap)=>{
        const s = currentSoap || soap;
        if (!patient?.id) return false;
        if (!(s.s || s.o || s.a || s.p)) return true;
        const resolvedEncId = pmEncounterId || visitId || null;
        const content = {
            s: s.s || '',
            o: s.o || '',
            a: s.a || '',
            p: s.p || ''
        };
        try {
            await writeSoapNoteRow({
                update: (id)=>(0, $eVM84.bffMutation)((0, $6xvbB.UPDATE_CLINICAL_NOTE), {
                        id: id,
                        input: {
                            content: content
                        }
                    }),
                create: async ()=>{
                    const res = await (0, $eVM84.bffMutation)((0, $6xvbB.CREATE_CLINICAL_NOTE), {
                        patientId: patient.id,
                        input: {
                            noteType: 'SOAP_NOTE',
                            content: content,
                            authorRole: 'doctor',
                            appointmentId: resolvedEncId
                        }
                    });
                    return res?.createClinicalNote?.id;
                }
            });
            return true;
        } catch (e) {
            console.warn('handleSaveSoapNote error:', e);
            return false;
        }
    };
    // ── Plan ⇄ نسخه/دستورات reconciliation ────────────────────────────────────
    //
    // The «P» text carries a managed block listing every prescribed drug and every
    // live order (see buildPlanBlock in Visit.shared). This effect is the loop that
    // keeps it true: it recomputes the block from the current lists, compares it
    // against what «P» actually says, and rewrites only on drift.
    //
    // It runs on every render path that can change either list OR «P» itself, so
    // divergence introduced by any means — a drug added, a dose edited, an order
    // cancelled, a draft restored from localStorage, the doctor deleting half the
    // block by hand — is corrected on the next pass rather than only at the point
    // of the edit. Recomputing from scratch is what makes that safe: the block is
    // derived, never accumulated, so replaying it can't double up.
    //
    // The block is written in English (it is a clinical document, not UI), so an
    // order needs its English catalogue name. The catalogue is keyed twice: by
    // catalogId, which an order created from the picker carries, and by the
    // Persian name, which is all an order created before that linkage — or by the
    // AI suggestion rail — has to identify itself with.
    // The English names the SOAP plan block prints, for the orders on this chart.
    // Resolved by id (and by name for orders older than catalogIds), never by
    // holding the dictionary. An order the server could not resolve is simply
    // absent here, and buildPlanBlock falls back to its Persian description — the
    // same behaviour as before, for the same rows.
    const catalogNameEn = (0, $acw62.useMemo)(()=>{
        const m = new Map();
        for (const [key, row] of catalogResolved)if (row?.nameEn) m.set(key, row.nameEn);
        return m;
    }, [
        catalogResolved
    ]);
    const orderNameEn = (0, $acw62.useCallback)((o)=>catalogNameEn.get(o?.catalogId) || catalogNameEn.get((o?.description || '').trim()) || '', [
        catalogNameEn
    ]);
    // What the orders tab SHOWS a reader who does not read Persian: the catalogue's
    // English name, for suggestions (named by their Persian catalogue name) and for
    // the orders on the chart. What is stored and matched stays the Persian.
    const suggestedOrderName = (0, $6xvbB.useCatalogNamesEn)((encOrderSugg?.items || []).map((i)=>i.name));
    const chartOrderName = (o)=>readsPersianData ? o?.description : orderNameEn(o) || o?.description;
    const planBlock = (0, $acw62.useMemo)(()=>(0, $6xvbB.buildPlanBlock)({
            rxItems: rxItems,
            orders: clinicalOrders,
            orderNameEn: orderNameEn
        }), [
        rxItems,
        clinicalOrders,
        orderNameEn
    ]);
    // Live views of the two lists, for the one caller that mutates them and then
    // needs the result within the same async run: handleApplyPlan creates meds and
    // orders and must file a plan note that already lists them, which its own
    // closure — captured before any of those writes — cannot supply.
    const rxItemsRef = (0, $acw62.useRef)(rxItems);
    rxItemsRef.current = rxItems;
    const clinicalOrdersRef = (0, $acw62.useRef)(clinicalOrders);
    clinicalOrdersRef.current = clinicalOrders;
    // Same reason, for the note: a confirmation answer appends to «S» and awaits
    // the save, so it must append to the latest text rather than to whatever the
    // closure captured before the previous answer landed.
    const soapRef = (0, $acw62.useRef)(soap);
    soapRef.current = soap;
    // ── تکمیل یادداشت — merge-aware SOAP completion ──────────────────────────
    //
    // The server merges (doctor text is authoritative, only new facts are added)
    // and the doctor reviews per section before anything touches the note. The
    // charge follows the server's `charged` flag, never the click.
    //
    // handleSaveSoapNote is recreated each render, so the stable apply callback
    // below reads it through a ref — otherwise it would save with the FIRST
    // render's patient/soapNoteId closure and file a duplicate note.
    const saveSoapNoteRef = (0, $acw62.useRef)(null);
    saveSoapNoteRef.current = handleSaveSoapNote;
    const applyRefinedSections = (0, $acw62.useCallback)((entries)=>{
        setSoap((prev)=>{
            const next = {
                ...prev
            };
            Object.entries(entries).forEach(([k, text])=>{
                // The merge worked on the «P» NARRATIVE only; the managed drug/order
                // block the note already carries is preserved verbatim and re-spliced —
                // re-deriving it here would repeat the "orders not loaded yet ⇒ nothing
                // ordered" trap the reconciler guards against.
                if (k === 'p') next.p = (0, $6xvbB.splicePlanBlock)(text, (0, $6xvbB.planBlockText)(prev.p));
                else next[k] = text;
            });
            saveSoapNoteRef.current?.(next);
            return next;
        });
    }, []);
    // What «تایید خودکار» confirmed in this visit: the header chip, each item's undo
    // and the record of both. An undo writes back through «تأیید»'s own writers and
    // puts the proposal on screen again, to be read like any other.
    const vitalsRef = (0, $acw62.useRef)(vitals);
    vitalsRef.current = vitals;
    const autoConfirm = (0, $cEPPo.useAutoConfirm)({
        visitId: visitId,
        appointmentId: pmEncounterId || visitId,
        read: (kind, key)=>{
            if (kind === 'soap') return (0, $6xvbB.soapSectionText)(soap, key);
            if (kind === 'vitals') return (0, $b4nOl.vitalsFormValue)(vitals, key);
            // PM-0586: a نسخه line by its product — its directions as added; an order by its id.
            if (kind === 'rx') {
                const line = rxItems.find((r)=>r.drug?.id === key);
                return line ? (0, $bwSot.autoRxSummary)(line) : '';
            }
            const order = clinicalOrders.find((o)=>o.id === key);
            return order && order.status !== 'cancelled' ? order.description || '' : '';
        },
        undoers: {
            soap: (item)=>{
                applyRefinedSections({
                    [item.key]: item.before
                });
                soapRefine.restore(item.key, item.payload.entry);
            },
            vitals: (item)=>{
                setVitals((prev)=>({
                        ...prev,
                        ...(0, $b4nOl.vitalsFormClear)(item.key)
                    }));
                monitoringExtract.restore('VITALS', [
                    item.payload.row
                ]);
            },
            // The line comes off through the نسخه's own removal (a saved one is deleted), and
            // the drug waits in the review again; an order is cancelled as the list cancels one.
            rx: (item)=>{
                const line = rxItemsRef.current.find((r)=>r.drug?.id === item.key);
                if (line) removeDrug(line.id);
                rxAssist.restore(item.payload.source, item.payload.row);
            },
            order: (item)=>{
                handleOrderTransition(item.key, 'cancel');
                monitoringExtract.restore('ORDERS', [
                    item.payload.row
                ]);
            }
        },
        labelOf: (kind, key)=>kind === 'soap' ? t({
                s: 'visit.soap.subjective',
                o: 'visit.soap.objective',
                a: 'visit.soap.assessment',
                p: 'visit.soap.plan'
            }[key]) : t(`visit.monitoringExtract.vital.${key}`),
        toast: toast,
        t: t,
        joinList: formatList
    });
    const soapRefine = (0, $6xvbB.useSoapRefine)({
        visitId: visitId,
        patientId: patient?.id || null,
        soapRef: soapRef,
        liveTranscript: liveTranscript,
        chargeVisit: chargeVisit,
        onApply: applyRefinedSections,
        onCreditError: setCreditError,
        t: t,
        autoConfirm: autoConfirmAllowed,
        isEditing: (0, $6xvbB.soapEditorFocused),
        onAutoConfirm: (records)=>autoConfirm.add('soap', records)
    });
    const soapRefineLoading = soapRefine.loading;
    const soapFieldRefineLoading = soapRefine.loadingSections?.length === 1 ? soapRefine.loadingSections[0] : null;
    const handleSoapRefine = ()=>soapRefine.refine();
    const handleSoapFieldRefine = (fieldKey)=>soapRefine.refine([
            fieldKey
        ]);
    // The proposals the S/O/A tab shows — and so the only ones its «اعمال همه» may
    // confirm. «P» is on «برنامه درمان».
    const soapTabProposals = Object.entries(soapRefine.preview || {}).filter(([k, v])=>k !== 'p' && !v.stale).map(([k])=>k);
    // Writing to «P» while the doctor has the caret in it would fight them for the
    // field: the DOM-sync layout effect deliberately skips a focused editor, so the
    // state write would be reverted by their very next keystroke. Defer instead —
    // this flag is a dependency of the reconciler, so blur re-runs it immediately.
    const [planEditorFocused, setPlanEditorFocused] = (0, $acw62.useState)(false);
    // Leaving the «برنامه درمان» tab unmounts the editor without firing blur, which
    // would strand the flag at true and silently stop reconciling for the rest of
    // the visit — the exact failure this guard is meant to prevent, inverted.
    (0, $acw62.useEffect)(()=>{
        if (workTab !== 'plan') setPlanEditorFocused(false);
    }, [
        workTab
    ]);
    // Rapid edits (a dosage typed character by character) must not each cost a
    // mutation, but the text on screen must still be right immediately. So the
    // splice is synchronous and only the write is debounced, with the latest
    // snapshot always winning.
    const planSaveTimer = (0, $acw62.useRef)(null);
    const schedulePlanNoteSave = (0, $acw62.useCallback)((nextSoap)=>{
        clearTimeout(planSaveTimer.current);
        planSaveTimer.current = setTimeout(()=>{
            handleSaveSoapNote(nextSoap);
        }, 700);
    }, [
        handleSaveSoapNote
    ]);
    (0, $acw62.useEffect)(()=>()=>clearTimeout(planSaveTimer.current), []);
    // A resumed visit restores «P» from the server note, which already lists the
    // orders this encounter carries. Reconciling before the order list has been
    // fetched would compare that text against an empty list and strip those lines —
    // the block is derived, so "not loaded yet" and "nothing ordered" are the same
    // input. Wait for the fetch. With no encounter there is nothing to fetch and
    // nothing to wait for, so the drug side keeps reconciling as usual.
    const ordersAuthoritative = ordersLoaded || !(pmEncounterId || visitId);
    (0, $acw62.useEffect)(()=>{
        if (planEditorFocused) return;
        if (!ordersAuthoritative) return;
        const nextP = (0, $6xvbB.splicePlanBlock)(soap.p, planBlock);
        if (nextP === (soap.p || '')) return; // already consistent — the common case
        setSoap((prev)=>prev.p === soap.p ? {
                ...prev,
                p: nextP
            } : prev);
        schedulePlanNoteSave({
            ...soap,
            p: nextP
        });
    }, [
        planBlock,
        planEditorFocused,
        ordersAuthoritative,
        soap,
        schedulePlanNoteSave
    ]);
    // Returns whether the list is now authoritative — a failed fetch leaves the
    // previous list standing rather than reporting an empty visit, because the
    // reconciler would take that literally and delete the doctor's orders from «P».
    const loadClinicalOrders = async (encId)=>{
        if (!encId) return false;
        setOrdersLoading(true);
        try {
            const data = await (0, $eVM84.bffQuery)((0, $6xvbB.LIST_CLINICAL_ORDERS), {
                appointmentId: encId
            });
            setClinicalOrders(data?.listOrders || []);
            setOrdersLoaded(true);
            return true;
        } catch  {
            return false;
        } finally{
            setOrdersLoading(false);
        }
    };
    // Creates an encounter order carrying the full catalog linkage the backend
    // supports (code / catalogId / sessionCount). Returns the created order on
    // success, or null on failure so callers keep what the doctor entered.
    //
    // `performedDate` is the form's «تاریخ انجام» (PM-0634); every other caller
    // sends none, and the service writes the clinic's today.
    const handleCreateOrder = async ({ type: type, urgency: urgency, name: name, notes: notes, code: code, catalogId: catalogId, sessionCount: sessionCount, performedDate: performedDate })=>{
        const encId = pmEncounterId || visitId;
        if (!encId || !patient?.id || !name) return null;
        setOrderSaving(true);
        setOrderError(null);
        try {
            const data = await (0, $eVM84.bffMutation)((0, $6xvbB.CREATE_CLINICAL_ORDER), {
                appointmentId: encId,
                patientId: patient.id,
                orderType: type,
                description: name,
                urgency: urgency,
                notes: notes || '',
                code: code || null,
                catalogId: catalogId || null,
                sessionCount: sessionCount && sessionCount > 1 ? sessionCount : null,
                performedDate: performedDate || null
            });
            const created = data?.createOrder;
            // A successful mutation with no order back means the write didn't land —
            // treat it as a failure rather than pushing a null row into the list.
            if (!created) {
                setOrderError(t('visit.orders.saveRetry'));
                return null;
            }
            setClinicalOrders((prev)=>[
                    created,
                    ...prev
                ]);
            return created;
        } catch (e) {
            // Don't swallow: surface why nothing was added (backend down, unmigrated
            // schema, validation) instead of a silent no-op that looks like a dead button.
            if (e?.extensions?.code === 'INSUFFICIENT_CREDITS') setCreditError(e.message);
            else setOrderError(e?.message || t('errors.save.order'));
            console.error('[createOrder]', e);
            return null;
        } finally{
            setOrderSaving(false);
        }
    };
    // Lab/imaging/procedure orders are mirrored into pendingTests so the printed
    // نسخه and the end-of-visit doctor-order save keep working exactly as before.
    //
    // `savedToBackend` says whether the row ALREADY exists as an encounter order.
    // `useEndVisit` flushes every pendingTest that says it does not, so a row that is
    // already saved and claims otherwise is written a second time. Every caller here
    // mirrors an order it has just created on the server, so every one passes true;
    // the catalogue «افزودن», AI-suggested and plan-confirm paths passed the default
    // and each such order was saved twice (2026-09-29, beta1: two CBC rows per visit,
    // sent twice to تأمین and op-naji). clinical/__tests__/visitOrderMirror.test.js
    // pins it.
    const mirrorOrderToPendingTests = (o, { savedToBackend: savedToBackend = false } = {})=>{
        if (![
            'lab',
            'imaging',
            'procedure'
        ].includes(o.type)) return;
        setPendingTests((prev)=>[
                ...prev,
                {
                    id: `${Date.now()}-${o.name}`,
                    name: o.name,
                    type: o.type,
                    urgency: o.urgency || 'routine',
                    reason: o.reason || '',
                    loincCode: o.loincCode || o.code || '',
                    savedToBackend: savedToBackend
                }
            ]);
    };
    // ── Structured order form ────────────────────────────────────────────────────
    // Flatten the fetched catalog into one common item shape per type. Each item
    // carries the identifiers the create mutation wants: catalogId (row id), code
    // (LOINC for labs / CPT for procedures), and a display sub-line + modality.
    // The current page, in the shape OrderCheckItem reads. The server has already
    // filtered by query and type and ranked in-house first, so there is nothing to
    // filter here — only to group, which is a display decision.
    const orderItemOf = (0, $acw62.useCallback)((e, times = 0)=>({
            key: `${e.orderType}:${e.name}`,
            type: e.orderType,
            name: e.name,
            nameEn: e.nameEn || '',
            // The reader's own-language name is read from these (ownCatalogName). This
            // shape used to drop them, which left an Arabic reader with English here.
            nameAr: e.nameAr || '',
            nameFr: e.nameFr || '',
            nameDe: e.nameDe || '',
            catalogId: e.id || null,
            code: e.code || '',
            // A LOINC badge is only honest when the code IS a LOINC: the same column now
            // also carries CPT and, soon, LAB-ir and Radiology-ir numbers.
            loincCode: e.codeSystem === 'LOINC' ? e.code || '' : '',
            modality: e.modality || '',
            sub: e.orderType === 'imaging' ? e.bodyPart || '' : e.code ? `${e.codeSystem || ''} ${e.code}`.trim() : '',
            category: e.category || t('common.state.other'),
            inHouse: !!e.inHouse,
            // «در فهرست تأمین» — for a تأمین patient (K1, 2026-10-07).
            taminListed: (0, $6xvbB.taminFlagOf)(e, (0, $eQiuG.insurerKeyOf)(patient?.insurance)),
            times: // How often THIS doctor ordered it (PM-0701) — 0 for never, and 0 while they have
            // the shortcut switched off, so nothing downstream ranks or marks by it.
            times
        }), [
        t,
        patient?.insurance
    ]);
    const frequentTimesById = (0, $acw62.useMemo)(()=>new Map(orderShowFrequent ? frequentOrders.map((f)=>[
                f.entry.id,
                f.times
            ]) : []), [
        frequentOrders,
        orderShowFrequent
    ]);
    const catalogItems = (0, $acw62.useMemo)(()=>catalogPage.entries.map((e)=>orderItemOf(e, frequentTimesById.get(e.id) || 0)), [
        catalogPage.entries,
        orderItemOf,
        frequentTimesById
    ]);
    const frequentItems = (0, $acw62.useMemo)(()=>orderShowFrequent ? frequentOrders.map((f)=>orderItemOf(f.entry, f.times)) : [], [
        frequentOrders,
        orderShowFrequent,
        orderItemOf
    ]);
    const clinicItems = (0, $acw62.useMemo)(()=>orderShowClinic ? clinicOrders.entries.map((e)=>orderItemOf(e, frequentTimesById.get(e.id) || 0)) : [], [
        clinicOrders.entries,
        orderShowClinic,
        orderItemOf,
        frequentTimesById
    ]);
    const idleBlocks = (0, $acw62.useMemo)(()=>(0, $7Z50p.idleOrderBlocks)({
            frequent: frequentItems,
            clinic: clinicItems,
            prefs: {
                showFrequent: orderShowFrequent,
                showClinic: orderShowClinic,
                frequentFirst: orderFrequentFirst
            }
        }), [
        frequentItems,
        clinicItems,
        orderShowFrequent,
        orderShowClinic,
        orderFrequentFirst
    ]);
    const clinicGroups = (0, $acw62.useMemo)(()=>(0, $7Z50p.groupOrderItems)(clinicItems, {
            frequentFirst: orderFrequentFirst
        }), [
        clinicItems,
        orderFrequentFirst
    ]);
    // Grouped by kind, then category; the doctor's frequent and the clinic's own rows
    // first, whichever leads by their preference (lib/orderPicker.js).
    const groupedCatalog = (0, $acw62.useMemo)(()=>(0, $7Z50p.groupOrderItems)(catalogItems, {
            frequentFirst: orderFrequentFirst
        }), [
        catalogItems,
        orderFrequentFirst
    ]);
    const catalogByKey = (0, $acw62.useMemo)(()=>{
        // A row picked from a shortcut is selected exactly as a search result is, so all
        // three lists answer the lookup.
        const m = new Map();
        for (const it of [
            ...clinicItems,
            ...frequentItems,
            ...catalogItems
        ])m.set(it.key, it);
        return m;
    }, [
        catalogItems,
        frequentItems,
        clinicItems
    ]);
    // Catalog ids the clinic has an ACTIVE service declaration for (inHouse flag from
    // getClinicalOrderCatalog). Only these orders can be performed — and billed — here,
    // so only they get the انجام button (accounting bills on completion iff declared, §3½).
    const inHouseCatalogIds = (0, $acw62.useMemo)(()=>{
        const ids = new Set();
        for (const [key, row] of catalogResolved)if (row?.inHouse && key === row.id) ids.add(row.id);
        return ids;
    }, [
        catalogResolved
    ]);
    // Whether an order is fulfilled by the current clinic — i.e. its catalog item is
    // one this clinic declares (in-house). Same signal that gates the انجام button.
    const isClinicOrder = (0, $acw62.useCallback)((o)=>!!o?.catalogId && inHouseCatalogIds.has(o.catalogId), [
        inHouseCatalogIds
    ]);
    // In the clinic, for PM-0618's rules: the BFF's `performedHere`, or the above.
    const isOrderInHouse = (0, $acw62.useCallback)((o)=>o?.performedHere === true || isClinicOrder(o), [
        isClinicOrder
    ]);
    // Orders performed by the current clinic float to the top of the list; every other
    // order keeps its original (creation) order. Stable sort via the paired index.
    const sortedClinicalOrders = (0, $acw62.useMemo)(()=>clinicalOrders.map((o, i)=>[
                o,
                i
            ]).sort((a, b)=>isClinicOrder(b[0]) - isClinicOrder(a[0]) || a[1] - b[1]).map(([o])=>o), [
        clinicalOrders,
        isClinicOrder
    ]);
    const toggleOrderKey = (key)=>setSelectedOrderKeys((prev)=>{
            const next = new Set(prev);
            if (next.has(key)) {
                next.delete(key);
                selectedOrderItems.current.delete(key);
            } else {
                next.add(key);
                // Remember the ITEM, not just its key: the list under the doctor changes
                // with the next keystroke, and the old code looked keys up in a catalogue
                // that was fully resident. Nothing resolves a key at submit time now.
                const item = catalogByKey.get(key);
                if (item) selectedOrderItems.current.set(key, item);
            }
            return next;
        });
    // Add every selected catalog item (or the single free-text entry for 'other')
    // as an encounter order, applying the shared urgency / notes / session count.
    const handleAddSelectedOrders = async ()=>{
        if (orderSaving) return;
        const encId = pmEncounterId || visitId;
        if (!encId || !patient?.id) return;
        const chosen = Array.from(selectedOrderKeys).map((k)=>selectedOrderItems.current.get(k) || catalogByKey.get(k)).filter(Boolean);
        if (!chosen.length) return;
        // A «تاریخ دلخواه» with no day, or a past one, holds the form (the field says why).
        if ((0, $feEcD.orderDateProblem)(orderDate, (0, $feEcD.clinicTodayIso)())) return;
        const performedDate = (0, $feEcD.orderDateToSend)(orderDate, (0, $feEcD.clinicTodayIso)());
        // «تعداد جلسات» is a خدمت's: a lab picked beside one is ordered once.
        const sessions = Math.max(1, Number(orderSessions) || 1);
        let anyOk = false;
        for (const it of chosen){
            const created = await handleCreateOrder({
                type: it.type,
                urgency: orderUrgency,
                name: it.name,
                notes: orderNotes,
                code: it.code,
                catalogId: it.catalogId,
                sessionCount: it.type === 'procedure' ? sessions : 1,
                performedDate: performedDate
            });
            if (created) {
                anyOk = true;
                mirrorOrderToPendingTests({
                    type: it.type,
                    name: it.name,
                    urgency: orderUrgency,
                    code: it.code,
                    loincCode: it.loincCode
                }, {
                    savedToBackend: true
                });
            }
        }
        if (anyOk) {
            setSelectedOrderKeys(new Set());
            selectedOrderItems.current.clear();
            setOrderSearch('');
            setOrderNotes('');
            setOrderSessions(1);
            setOrderUrgency('routine');
            setOrderDate({
                preset: 'TODAY',
                date: ''
            });
        }
    };
    // AI: rank the most appropriate orders for the patient's current conditions
    // (record diagnoses + the SOAP assessment) and offer them for one-tap
    // insertion into the encounter order list. Best candidate first.
    const URGENCY_RANK = {
        stat: 0,
        urgent: 1,
        routine: 2
    };
    const handleSuggestEncounterOrders = async ()=>{
        if (!patient?.id || encOrderSuggLoading) return;
        setEncOrderSuggLoading(true);
        try {
            const icdCodes = (patient.clinicalConditions || []).map((c)=>c.code).filter(Boolean);
            const diagnoses = (patient.clinicalConditions || []).map((c)=>c.display).filter(Boolean);
            if (soap.a.trim()) diagnoses.push(soap.a.trim().slice(0, 160));
            const existingTests = (patient.clinicalObservations || []).map((o)=>o.display).filter(Boolean);
            const data = await (0, $eVM84.bffQuery)((0, $6xvbB.SUGGEST_DOCTOR_ORDERS), {
                appointmentId: pmEncounterId || visitId || undefined,
                patientId: patient.id,
                icdCodes: icdCodes.slice(0, 8),
                diagnoses: diagnoses.slice(0, 8),
                age: (0, $6xvbB.aiPatientAge)(patient),
                gender: patient.gender || '',
                existingTests: existingTests.slice(0, 10)
            });
            const s = data.suggestDoctorOrders || {};
            // Each row keeps the code its catalogue row came with (lib/suggestedOrders):
            // built without it, the order reached the record and the insurer uncoded.
            const items = (0, $d2Zvn.suggestedOrderRows)(s).sort((a, b)=>(URGENCY_RANK[a.urgency] != null ? URGENCY_RANK[a.urgency] : 2) - (URGENCY_RANK[b.urgency] != null ? URGENCY_RANK[b.urgency] : 2));
            // The suggestions carry Persian catalogue names; an English reader's names
            // are fetched first, so the list never shows Persian that flips to English.
            if (!readsPersianData) await (0, $6xvbB.primeCatalogNamesEn)(items.map((i)=>i.name)).catch((err)=>console.warn('suggested order English names unavailable:', err));
            setEncOrderSugg({
                items: items,
                rationale: s.clinicalRationale || ''
            });
            chargeVisit((0, $1yr2B.costOf)('DOCTOR_ORDERS'), 'orders', t('visit.suggest.orderReady'));
        } catch (e) {
            if (e?.extensions?.code === 'INSUFFICIENT_CREDITS') setCreditError(e.message);
            else console.warn('suggestDoctorOrders (orders tab) failed:', e);
        } finally{
            setEncOrderSuggLoading(false);
        }
    };
    const handleAddSuggestedOrder = async (item)=>{
        const encId = pmEncounterId || visitId;
        if (!encId || !patient?.id || encSuggAdding) return;
        // Already on this visit — picked from the catalogue, or added from an
        // earlier suggestion pass. A second press would be a second order.
        if ((0, $d2Zvn.isAlreadyOrdered)(clinicalOrders, item.orderType, item.name)) return;
        setEncSuggAdding(item.key);
        try {
            // Through handleCreateOrder, like every other add on this page, so the
            // catalogue code travels with the order — this was the one desktop path
            // that wrote its own mutation and sent none. There is no catalogId to
            // send: the suggestion is a catalogue NAME, and the service links the row
            // by that exact name, which is what the «انجام» button reads.
            const created = await handleCreateOrder({
                type: item.orderType,
                urgency: item.urgency,
                name: item.name,
                notes: item.reason,
                code: item.code
            });
            if (!created) return;
            setEncSuggAdded((prev)=>new Set(prev).add(item.key));
            mirrorOrderToPendingTests({
                type: item.orderType,
                name: item.name,
                urgency: item.urgency,
                reason: item.reason,
                code: item.code,
                loincCode: item.loincCode
            }, {
                savedToBackend: true
            });
        } finally{
            setEncSuggAdding(null);
        }
    };
    // ── تجویز مجدد — a past visit's order on this visit's دستورات (PM-0630) ─────
    // The drugs' refill, for a دستور. The order is placed as it was — type, name,
    // urgency, notes, its catalogue row and code, its sessions — so it is linked,
    // coded and priced like one picked from the catalogue now. The visit context
    // does not carry those, so they are read from that visit's own orders; if that
    // read fails the order goes by name, as a suggestion does. One already on this
    // visit (same type and name, not cancelled) is never added twice, and the
    // history sheet stays open — its row flips to «اضافه شد».
    const [reorderingOrderId, setReorderingOrderId] = (0, $acw62.useState)(null);
    const isOrderedNow = (0, $acw62.useCallback)((o)=>(0, $d2Zvn.isAlreadyOrdered)(clinicalOrders, o?.orderType, o?.description), [
        clinicalOrders
    ]);
    const reorderPastOrder = async (pastVisitId, order)=>{
        if (!order?.description || reorderingOrderId || isOrderedNow(order)) return;
        setReorderingOrderId(order.id);
        try {
            const rows = await (0, $eVM84.bffQuery)((0, $6xvbB.PAST_VISIT_ORDERS), {
                appointmentId: pastVisitId
            }).then((d)=>d?.listOrders || []).catch(()=>[]);
            const src = rows.find((r)=>String(r.id) === String(order.id)) || order;
            const urgency = src.urgency || 'routine';
            const created = await handleCreateOrder({
                type: src.orderType,
                urgency: urgency,
                name: src.description,
                notes: src.notes,
                code: src.code,
                catalogId: src.catalogId,
                sessionCount: src.sessionCount
            });
            if (!created) {
                toast.error(t('visit.orders.saveRetry'));
                return;
            }
            mirrorOrderToPendingTests({
                type: src.orderType,
                name: src.description,
                urgency: urgency,
                code: src.code
            }, {
                savedToBackend: true
            });
            setWorkTab('orders');
        } finally{
            setReorderingOrderId(null);
        }
    };
    const handleOrderTransition = async (orderId, action)=>{
        setOrderTransitioning(orderId);
        const mutMap = {
            start: (0, $6xvbB.START_ORDER_MUT),
            complete: (0, $6xvbB.COMPLETE_ORDER_MUT),
            cancel: (0, $6xvbB.CANCEL_ORDER_MUT)
        };
        const fieldMap = {
            start: 'startOrder',
            complete: 'completeOrder',
            cancel: 'cancelOrder'
        };
        try {
            const data = await (0, $eVM84.bffMutation)(mutMap[action], {
                orderId: orderId
            });
            const updated = data[fieldMap[action]];
            // The stage the BFF read is the old status's: dropped, so the row reads
            // the new one from its status (constants/statuses `orderStageOf`).
            setClinicalOrders((prev)=>prev.map((o)=>o.id === orderId ? {
                        ...o,
                        status: updated.status,
                        stage: null
                    } : o));
        } catch (e) {
            setOrderError(e?.message || t('errors.save.orderStatus'));
            console.error('[orderTransition]', action, e);
        } finally{
            setOrderTransitioning(null);
        }
    };
    // «انجام شد». In the clinic (PM-0618) it records ONE session of the order in
    // THIS visit — performer = the doctor, on this visit's invoice — and reads the
    // list again: the answer is a TreatmentStep, not the row (visitSessions.js).
    // Otherwise the old chain: the lifecycle is pending → in_progress → completed
    // with no shortcut, so a pending order is started first. An order done
    // elsewhere never gets here — it has no «انجام شد» (PM-0680).
    const handleOrderDone = async (order)=>{
        if (orderTransitioning) return;
        setOrderTransitioning(order.id);
        setOrderError(null);
        if (isOrderInHouse(order) && !order.processId) {
            try {
                const done = await (0, $7TTuK.markOrderDoneHere)({
                    order: order,
                    visitId: pmEncounterId || visitId
                });
                if (done.orders) setClinicalOrders(done.orders);
                setVisitServicesKey((k)=>k + 1);
            } catch (e) {
                setOrderError(e?.message || t('errors.save.orderDone'));
                console.error('[orderDone]', e);
            } finally{
                setOrderTransitioning(null);
            }
            return;
        }
        try {
            if (order.status === 'pending') {
                const startData = await (0, $eVM84.bffMutation)((0, $6xvbB.START_ORDER_MUT), {
                    orderId: order.id
                });
                const started = startData?.startOrder;
                // The START result is written back BEFORE the second hop, and that is
                // the whole point of this branch. The list is loaded exactly once per
                // encounter (`ordersLoadedFor` fences the only refetch), so the row's
                // local status is the only status this screen will ever have. Throwing
                // the result away left it saying «در انتظار» while the server had
                // already moved to in_progress: the retry re-entered this branch,
                // re-sent StartOrder, and clinicalencounter refused it
                // (FAILED_PRECONDITION — only a pending order can be started), so
                // CompleteOrder was never reached. «لغو» failed for the same reason,
                // and the order could be neither finished nor retracted until the
                // doctor left the visit and came back. Visit.mobile.jsx has always
                // chained through handleOrderTransition, which does write it back.
                if (started) setClinicalOrders((prev)=>prev.map((o)=>o.id === order.id ? {
                            ...o,
                            status: started.status,
                            stage: null
                        } : o));
            }
            const data = await (0, $eVM84.bffMutation)((0, $6xvbB.COMPLETE_ORDER_MUT), {
                orderId: order.id
            });
            const updated = data?.completeOrder;
            if (updated) setClinicalOrders((prev)=>prev.map((o)=>o.id === order.id ? {
                        ...o,
                        status: updated.status,
                        stage: null
                    } : o));
        } catch (e) {
            setOrderError(e?.message || t('errors.save.orderDone'));
            console.error('[orderDone]', e);
        } finally{
            setOrderTransitioning(null);
        }
    };
    // A row's «تاریخ انجام» changed (PM-0634). Answers null once it landed — the row
    // takes the order the service returns — or the sentence to show under it: the
    // service's own («… پیش از امروز …», «… دستور بسته …») when it refused.
    const handleOrderDateChange = async (orderId, performedDate)=>{
        try {
            const data = await (0, $eVM84.bffMutation)((0, $6xvbB.UPDATE_ORDER_DATE), {
                orderId: orderId,
                performedDate: performedDate
            });
            const updated = data?.updateOrderDate;
            if (!updated) return t('visit.orders.date.saveFailed');
            setClinicalOrders((prev)=>prev.map((o)=>o.id === orderId ? {
                        ...o,
                        ...updated
                    } : o));
            return null;
        } catch (e) {
            console.error('[updateOrderDate]', e);
            return e?.message || t('visit.orders.date.saveFailed');
        }
    };
    const handleCancelEncounter = async ()=>{
        if (!visitId || cancellingVisit) return;
        setCancellingVisit(true);
        try {
            await (0, $eVM84.bffMutation)((0, $6xvbB.CANCEL_ENCOUNTER), {
                id: visitId
            });
            if (isRecording) stopRec();
            setVisitId(null);
            setVisitStatus(null);
            setPmEncounterId(null);
            // Cancelled visit leaves nothing behind: drop the recovery draft and leave
            // the visit screen. navProp (not the wrapped navigate) — this closure still
            // sees visitStatus 'inprogress', which would re-arm the leave guard.
            try {
                localStorage.removeItem(`visit_draft_${patient?.id}`);
            } catch  {}
            navProp('patient-detail', {
                id: patient?.id
            });
        } catch (e) {
            console.error('[cancelEncounter]', e);
        } finally{
            setCancellingVisit(false);
        }
    };
    // ── پایان ویزیت ───────────────────────────────────────────────────────────
    // The write sequence itself lives in `useEndVisit` — it is identical on the
    // phone, and keeping two copies of "what ending a visit does" is how the two
    // forks drift on the one thing they must agree about. What stays here is the
    // three things the SCREEN does with the result.
    const endServices = (0, $glimY.useEndVisitServices)({
        orders: clinicalOrders,
        visitId: pmEncounterId || visitId || null,
        isInHouse: isOrderInHouse
    });
    // «پایان ویزیت» pressed: the open services of this visit first (re-read, since
    // the desk may have answered one), else the plain confirm.
    const requestEnd = async ()=>{
        const items = await endServices.prepare();
        if (items.length > 0) setEndServicesOpen(true);
        else setPendingEnd(true);
    };
    const runEnd = async ()=>{
        setPendingEnd(false);
        if (!visitId || endProgress.running) return;
        if (isRecording) stopRec();
        const outcome = await startEndVisit();
        if (outcome === 'stopped-interaction') {
            // The sweep used to abort in silence: the doctor was dropped into the نسخه
            // tab with no message and no idea why the visit had not ended, and the
            // obvious next move — pressing پایان ویزیت again — just repeated it.
            setWorkTab('rx');
            setInteractionStop(true);
            toast?.warn?.(t('visit.end.stoppedForInteraction'));
            return;
        }
        if (outcome === 'failed') {
            // The sequence itself broke, so the visit is still open. Refusing to show
            // the closure is the point: "the visit is complete" would be a lie.
            toast?.error?.(t('visit.end.failedToast'));
            return;
        }
        // `partial` comes back from the hook rather than being read off its state:
        // this closure captured the previous render, so `saveFailures` here would
        // still be the empty array it was before the sequence ran.
        if (outcome === 'partial') toast?.error?.(t('visit.end.partialSaveToast'));
        setShowClosureFlow(true);
    };
    // Leaving the closure returns to پذیرش, not to the record: the visit is over
    // and the next thing the doctor does is call the next patient. The record is
    // one tap away from the queue for the rare case they want to re-read it.
    const goToReception = ()=>{
        setShowClosureFlow(false);
        // `from` is how پذیرش knows to take focus on arrival. The closure owned the
        // screen and the button that opened it no longer exists, so there is
        // nothing for the dialog to hand focus back to — without this it lands on
        // <body> and a keyboard user tabs from the top of the document (§12.2).
        navigate('reception', {
            from: 'visit-closure'
        });
    };
    // ── Load the AI visit summaries for the context panel ────────────────────
    // Fetched to the sheet's depth, not the rail's: the sheet lists every visit
    // the rail summarises plus the rest, and a summary missing there reads as
    // "this visit had no summary" rather than "we only asked for four".
    (0, $acw62.useEffect)(()=>{
        if (!patient?.id || pastVisitSummaries !== null) return;
        (0, $eVM84.bffQuery)((0, $6xvbB.PATIENT_VISIT_HISTORY), {
            patientId: patient.id,
            limit: $9b4ee9e6346f75da$var$VISIT_HISTORY_MAX
        }).then((data)=>setPastVisitSummaries(data.patientVisitHistory?.visits || [])).catch(()=>setPastVisitSummaries([]));
    }, [
        patient?.id
    ]);
    // The patient's finished visits, newest first, minus the one in progress.
    const pastVisits = (0, $acw62.useMemo)(()=>(0, $6xvbB.pastFinishedVisits)(patient?.encounters, {
            limit: $9b4ee9e6346f75da$var$VISIT_HISTORY_MAX,
            excludeId: pmEncounterId || visitId
        }), [
        patient?.encounters,
        pmEncounterId,
        visitId
    ]);
    const railVisits = (0, $acw62.useMemo)(()=>pastVisits.slice(0, $9b4ee9e6346f75da$var$VISIT_HISTORY_PREVIEW), [
        pastVisits
    ]);
    // «کد رهگیری» of the past visits the doctor registered — one read for the rail and
    // the sheet, both of which show the same finished visits (PM-0686).
    const { codes: pastErxCodes } = (0, $5hFXE.useVisitErxCodes)(pastVisits.map((v)=>v.id));
    // «مدارک بیمار» (docs/DOCTOR_PATIENT_FILES_AND_AI_EXTRACTION_DESIGN.md §7.1). The
    // patient's whole library, this visit's documents first; «جدید» counts what the
    // PATIENT sent since the last finished visit (or the last 30 days without one).
    const currentVisitId = pmEncounterId || visitId || null;
    const visitFiles = (0, $acw62.useMemo)(()=>{
        const all = patient?.clinicalFiles || [];
        const { thisVisit: thisVisit, others: others } = (0, $gdEay.splitByVisit)(all, currentVisitId);
        const since = pastVisits[0]?.scheduledDate || new Date(Date.now() - 2592000000).toISOString();
        return {
            all: all,
            thisVisit: thisVisit,
            others: others,
            ordered: [
                ...thisVisit,
                ...others
            ],
            newCount: (0, $gdEay.countNewPatientUploads)(all, since)
        };
    }, [
        patient?.clinicalFiles,
        currentVisitId,
        pastVisits
    ]);
    // The review's «افزودن به نسخه ویزیت» lands in the نسخه picker below; the ref lets
    // the files host be built before the drug handlers it reaches are.
    const docRxCapability = (0, $acw62.useRef)(null);
    const addToVisitPrescription = (0, $acw62.useCallback)((draft)=>docRxCapability.current?.(draft), []);
    const clinicalFiles = (0, $0xK7i.useClinicalFiles)({
        patient: patient,
        files: visitFiles.all,
        appointmentId: currentVisitId,
        onChanged: refreshPatient,
        onAddToVisitPrescription: addToVisitPrescription
    });
    // One row for the rail and the sheet; from the sheet, an action closes it first so
    // only one overlay is ever open (DESIGN_CONCEPT §5.2).
    const renderVisitFile = (f, fromSheet = false)=>{
        const via = (fn)=>(file, opts)=>{
                if (fromSheet) setRecordSheet(null);
                fn(file, opts);
            };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hRWhk.default), {
            key: f.id,
            file: f,
            dense: true,
            testid: "record-file",
            onOpen: via(clinicalFiles.openDetail),
            onView: via(clinicalFiles.openViewer),
            onPreview: via((file)=>clinicalFiles.openGallery(file, visitFiles.ordered)),
            onExtract: via((file)=>clinicalFiles.openExtract(file)),
            onEdit: via((file)=>clinicalFiles.openDetail(file, {
                    edit: true
                })),
            onDownload: clinicalFiles.download,
            onDelete: via(clinicalFiles.requestDelete)
        });
    };
    const renderVisitFileList = (list, fromSheet = false)=>list.map((f, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), {
                key: f.id
            }, i === 0 && f.appointmentId === currentVisitId && currentVisitId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    fontSize: '0.65625rem',
                    fontWeight: 700,
                    color: 'var(--mute)',
                    padding: '4px 0 2px'
                }
            }, t('visit.files.thisVisit')), i > 0 && currentVisitId && list[i - 1].appointmentId === currentVisitId && f.appointmentId !== currentVisitId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    fontSize: '0.65625rem',
                    fontWeight: 700,
                    color: 'var(--mute)',
                    padding: '8px 0 2px'
                }
            }, t('visit.files.otherDocuments')), renderVisitFile(f, fromSheet)));
    const summaryMap = (0, $acw62.useMemo)(()=>(0, $6xvbB.summariesByVisit)(pastVisitSummaries), [
        pastVisitSummaries
    ]);
    // Prefetch only what the rail shows. The sheet loads the rest as each visit is
    // opened, so a patient with forty visits still costs three calls on mount.
    const railVisitKey = railVisits.map((v)=>v.id).join(',');
    (0, $acw62.useEffect)(()=>{
        railVisits.forEach((v)=>loadVisitContext(v.id));
    }, [
        railVisitKey,
        loadVisitContext
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    // ── Elapsed timer (ticks only while visit is in progress) ─────────────────
    (0, $acw62.useEffect)(()=>{
        if (visitStatus !== 'inprogress') return;
        const timer = setInterval(()=>setElapsed((e)=>e + 1), 1000);
        return ()=>clearInterval(timer);
    }, [
        visitStatus
    ]);
    // ── Recording timer (resets to 0 each time recording starts) ──────────────
    (0, $acw62.useEffect)(()=>{
        // A system pause FREEZES the count rather than resetting it: the doctor
        // should see how long the interrupted segment ran. It bills nothing
        // either way — the ledger line is the BFF's now (§3.1 A5).
        if (isRecPaused) return undefined;
        if (!isRecording) {
            setRecElapsed(0);
            return undefined;
        }
        const timer = setInterval(()=>setRecElapsed((e)=>e + 1), 1000);
        return ()=>clearInterval(timer);
    }, [
        isRecording,
        isRecPaused
    ]);
    // ── The transcription line, read back rather than written (§3.1 A5) ───────
    const wasRecordingRef = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        const was = wasRecordingRef.current;
        wasRecordingRef.current = isRecording;
        if (!was || isRecording) return undefined;
        const first = setTimeout(refetchCoins, 1200);
        const second = setTimeout(refetchCoins, 6000);
        return ()=>{
            clearTimeout(first);
            clearTimeout(second);
        };
    }, [
        isRecording,
        refetchCoins
    ]);
    // ── Auto-start or resume encounter when patient loads ────────────────────
    // Checks for an active in-progress encounter on the server first.
    // If found for this patient, restores visitId/status and pulls SOAP draft
    // from localStorage instead of creating a duplicate encounter.
    const autoStarted = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        if (!patient?.id || visitId || autoStarted.current) return;
        autoStarted.current = true;
        (0, $eVM84.bffQuery)((0, $6xvbB.GET_ACTIVE_ENCOUNTER)).then((data)=>{
            const enc = data?.getActiveEncounter;
            if (enc?.id && enc.patientId === patient.id && enc.status === 'in_progress') {
                setVisitId(enc.id);
                setPmEncounterId(enc.id);
                setVisitStatus('inprogress');
                setResumedVisit(true);
                // Restore draft from localStorage — it's the only recovery path now;
                // enc.notes/enc.diagnosis no longer exist on Encounter, so there is no
                // server-side fallback anymore.
                try {
                    const raw = localStorage.getItem(`visit_draft_${patient.id}`);
                    if (raw) {
                        const draft = JSON.parse(raw);
                        if (draft.visitId === enc.id && Date.now() - draft.ts < 3600000) {
                            if (draft.soap) setSoap(draft.soap);
                            if (draft.rxItems?.length) setRxItems(draft.rxItems);
                            if (draft.diagnosis) setDiagnosis(draft.diagnosis);
                        }
                    }
                } catch  {}
                // Re-initialize AI session and differential for the resumed encounter
                setSessionReady(false);
                (0, $eVM84.bffMutation)((0, $6xvbB.INITIALIZE_VISIT_SESSION), {
                    visitId: enc.id,
                    patientId: patient.id
                }).then(()=>setSessionReady(true)).catch(()=>setSessionReady(true));
            } else handleStart();
        }).catch(()=>handleStart());
    }, [
        patient?.id
    ]);
    // ── Leave-guard ───────────────────────────────────────────────────────────
    // window.__parsina_visit_guard: called by WebLayout/AppShell before navigating.
    (0, $acw62.useEffect)(()=>{
        if (visitStatus === 'inprogress') window.__parsina_visit_guard = (proceedFn)=>{
            pendingNavRef.current = {
                callback: proceedFn
            };
            setLeaveConfirm(true);
        };
        else window.__parsina_visit_guard = null;
        return ()=>{
            window.__parsina_visit_guard = null;
        };
    }, [
        visitStatus
    ]);
    // ── The leave-guard's history anchor (spec §C.3 rule 2) ──────────────────
    // A browser/platform back asks «خروج از ویزیت؟» through the anchor; a leave the
    // doctor has confirmed goes through `leaveVisit`, so it is not asked twice
    // (PM-0135). The anchor, the overlay rules and the unwind depth live in the hook.
    const leaveVisit = (0, $lqfll.useVisitLeaveAnchor)({
        active: visitStatus === 'inprogress',
        visitKey: patient?.id,
        onRequest: (proceed)=>{
            pendingNavRef.current = {
                callback: proceed
            };
            setLeaveConfirm(true);
        },
        back: goBack
    });
    // Wrap the prop-based navigate so it also goes through the guard
    const navigate = (...args)=>{
        if (visitStatus === 'inprogress') {
            pendingNavRef.current = args;
            setLeaveConfirm(true);
        } else navProp(...args);
    };
    // ── Layer 1: Warn before accidental page close ────────────────────────────
    // beforeunload works on desktop Chrome/Firefox/Edge but is suppressed by
    // iOS Safari. Layers 1b handles iOS via visibilitychange + pagehide.
    (0, $acw62.useEffect)(()=>{
        if (visitStatus !== 'inprogress') return;
        const onUnload = (e)=>{
            e.preventDefault();
            e.returnValue = '';
        };
        window.addEventListener('beforeunload', onUnload);
        return ()=>window.removeEventListener('beforeunload', onUnload);
    }, [
        visitStatus
    ]);
    // ── Layer 1b: iOS / Android — immediate flush on page hide ───────────────
    // iOS Safari never fires beforeunload. visibilitychange (hidden) + pagehide
    // are the reliable signals that the page is about to die. When fired we
    // immediately write localStorage AND attempt a server save so no work is
    // lost between 30-second auto-save ticks.
    // Use a ref so the handlers always see the latest state without re-registering
    // on every keystroke.
    const draftFlushRef = (0, $acw62.useRef)(null);
    draftFlushRef.current = (recording = null)=>{
        if (!visitId || visitStatus !== 'inprogress') return;
        try {
            localStorage.setItem(`visit_draft_${patient?.id}`, JSON.stringify({
                visitId: visitId,
                soap: soap,
                rxItems: rxItems,
                diagnosis: diagnosis,
                ts: Date.now(),
                // §3.1 A2: the live transcript and the elapsed count exist only in
                // the transcription hook's memory, and the page is about to be
                // frozen. They ride into the draft so a reloaded tab still has what
                // was said before the interruption.
                ...recording ? {
                    recording: recording
                } : null
            }));
        } catch  {}
    };
    // Called INSIDE the `visibilitychange` handler — the last moment JS is
    // guaranteed to run — so it must stay synchronous.
    systemPauseRef.current = (snapshot)=>draftFlushRef.current(snapshot);
    (0, $acw62.useEffect)(()=>{
        if (visitStatus !== 'inprogress' || !visitId) return;
        const onVis = ()=>{
            if (document.visibilityState === 'hidden') draftFlushRef.current();
        };
        const onHide = ()=>draftFlushRef.current();
        document.addEventListener('visibilitychange', onVis);
        window.addEventListener('pagehide', onHide);
        return ()=>{
            document.removeEventListener('visibilitychange', onVis);
            window.removeEventListener('pagehide', onHide);
        };
    }, [
        visitStatus,
        visitId
    ]);
    // ── Layer 2: Save draft to localStorage on every SOAP / rx / diagnosis change
    // Keyed by patientId so recovery can find it even if the component remounts.
    (0, $acw62.useEffect)(()=>{
        if (!visitId || visitStatus !== 'inprogress') return;
        try {
            localStorage.setItem(`visit_draft_${patient?.id}`, JSON.stringify({
                visitId: visitId,
                soap: soap,
                rxItems: rxItems,
                diagnosis: diagnosis,
                ts: Date.now()
            }));
        } catch  {}
    }, [
        soap,
        rxItems,
        diagnosis,
        visitId,
        visitStatus
    ]);
    // Layer 3 (server auto-save every 30s) removed — VisitInput no longer accepts
    // notes/diagnosis/prescription; the Layer 2 localStorage draft above is the
    // only persistence for in-progress drafts now.
    // ── Fetch/refresh differential diagnosis ─────────────────────────────────
    //
    // Nothing below runs — not the visit-open call, not the loop, not the refresh
    // button — until «S» carries a chief complaint and the history behind it. The
    // panel says so rather than sitting empty. Clinical monitoring is NOT part of
    // this: it is one way of filling «S», not a licence to reason from it.
    const diffGate = (0, $6xvbB.differentialReadiness)({
        soap: soap
    });
    const diffReady = diffGate.ready;
    const diffReadyRef = (0, $acw62.useRef)(false);
    diffReadyRef.current = diffReady;
    // One in-flight request at a time. Every call re-runs the assessment against
    // whatever the visit knows at that moment, so two overlapping calls answer the
    // same question twice — and a poll that ticks while the previous one is still
    // out would stack requests without ever showing a newer answer.
    const diffInFlightRef = (0, $acw62.useRef)(false);
    // Moves whenever a confirm/dismiss leaves or settles — see
    // trackDifferentialDecision. A poll whose answer comes back with it moved
    // must not undo that decision on screen.
    const diffDecisionSeqRef = (0, $acw62.useRef)(0);
    const fetchDifferential = (0, $acw62.useCallback)(()=>{
        if (!visitId || visitStatus !== 'inprogress') return;
        if (!diffReadyRef.current) return;
        if (diffInFlightRef.current) return;
        diffInFlightRef.current = true;
        setDiffLoading(true);
        const decisionSeq = diffDecisionSeqRef.current;
        (0, $eVM84.bffQuery)((0, $6xvbB.GET_DIFFERENTIAL), {
            visitId: visitId
        }).then((data)=>{
            const newItems = data.getDifferentialDiagnosis?.items || [];
            // Only a call that actually re-ran the assessment billed the wallet
            // (`regenerated` — the AI service's own charge gate). Recording a
            // charge for every poll used to overstate a 10-minute visit by
            // hundreds of Parseh against a wallet that debited a fraction of it.
            if (data.getDifferentialDiagnosis?.regenerated) chargeVisit((0, $1yr2B.costOf)('DIFFERENTIAL'), 'differential');
            const stale = diffDecisionSeqRef.current !== decisionSeq;
            setDifferential((prev)=>(0, $6xvbB.mergeDifferentialPoll)(prev, newItems, {
                    stale: stale
                }));
        }).catch(()=>{}).finally(()=>{
            diffInFlightRef.current = false;
            setDiffLoading(false);
        });
    }, [
        visitId,
        visitStatus,
        chargeVisit
    ]);
    // Settings → دستیار هوشمند → «اجرای خودکار تشخیص افتراقی». It gates the two
    // AUTOMATIC paths below only; the list's «به‌روزرسانی» button still calls
    // fetchDifferential directly, so turning this off means "don't run it for
    // me", not "take the feature away". Undefined reads as on.
    const autoDifferential = !aiSettingsUnknown && ai.autoDifferentialOnStart !== false;
    // Only fetch differential after session init is done — avoids race condition
    // where AI service has no session data and returns the empty fallback.
    // diffReady is a real dependency, not just the ref read inside
    // fetchDifferential: on a page reload the saved SOAP note is still in flight
    // when sessionReady flips, so the fetch used to be skipped by the readiness
    // guard and never retried (nothing else fetches unless recording) — the list
    // then only showed up after a remount, where the localStorage draft restores
    // SOAP first. It now also carries clinical monitoring, so the first automatic
    // run happens when the visit is genuinely under way rather than the moment a
    // stale draft is restored.
    // Latched per visit so this stays ONE automatic call (each one bills credits).
    const autoDiffVisitRef = (0, $acw62.useRef)(null);
    // What each SOAP section said when the doctor put the caret in it. `onInput`
    // writes every keystroke into `soap`, so by the time blur runs the state and
    // the field already agree — comparing them would answer "nothing changed" for
    // every edit ever made. The entry value is the only thing that still knows.
    const soapEntryTextRef = (0, $acw62.useRef)({});
    (0, $acw62.useEffect)(()=>{
        if (!sessionReady || !autoDifferential || !diffReady) return;
        if (autoDiffVisitRef.current === visitId) return;
        autoDiffVisitRef.current = visitId;
        fetchDifferential();
    }, [
        sessionReady,
        autoDifferential,
        diffReady,
        visitId,
        fetchDifferential
    ]);
    // ── Re-assessment while the visit is live ────────────────────────────────
    //
    // Each tick is a full re-evaluation, not a cache read: the AI service rebuilds
    // the list from the transcript as it has grown, SOAP notes saved since, and
    // vitals recorded since, and returns the stored list untouched when none of
    // those moved. So the cadence decides how often the differential is allowed to
    // change its mind — which is a clinical preference, and now the doctor's.
    //
    // Settings → دستیار هوشمند set the standing preference (and honour the master
    // «اجرای خودکار تشخیص افتراقی» switch, because polling is a kind of automatic
    // run). `useDifferentialPolling` layers this visit's own on/off on top, so the
    // toolbar switch below changes the loop for THIS visit without touching them.
    const { active: pollingActive, pollMs: pollMs, seconds: pollSeconds, overridden: pollOverridden, toggle: togglePolling } = (0, $6xvbB.useDifferentialPolling)(ai, aiSettingsUnknown, visitId);
    (0, $acw62.useEffect)(()=>{
        if (!pollingActive) return;
        // Recording is this LOOP's own prerequisite, not the differential's: each
        // tick exists to re-ask as the conversation grows, and with nothing being
        // transcribed there is nothing new to re-ask about — it would re-answer the
        // same note and bill for it. A doctor who writes the history by hand still
        // gets the differential; they get it on their own «به‌روزرسانی».
        if (!diffReady || recState !== 'recording') return;
        if (!visitId || visitStatus !== 'inprogress') return;
        // A hidden tab is nobody reading the list. The visit keeps recording — this
        // only defers the re-assessment, which the next visible tick picks up with
        // MORE context than it would have had, not less.
        const tick = ()=>{
            if (typeof document !== 'undefined' && document.visibilityState === 'hidden') return;
            fetchDifferential();
        };
        const initial = setTimeout(tick, Math.min((0, $6xvbB.DIFFERENTIAL_POLL_LEAD_MS), pollMs));
        const interval = setInterval(tick, pollMs);
        return ()=>{
            clearTimeout(initial);
            clearInterval(interval);
        };
    }, [
        diffReady,
        recState,
        visitId,
        visitStatus,
        fetchDifferential,
        pollingActive,
        pollMs
    ]);
    // Reset confirmation state only when the actual set of active diagnosis codes changes,
    // not on every poll (differential is a new array reference each fetch even with same data).
    // A refresh REVISES the list — a diagnosis that survives the reassessment keeps
    // its questions and the answers already recorded against it.
    const prevDiffCodesRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        const active = (differential || []).filter((d)=>d.status !== 'rejected').map((d)=>d.diagnosisCode);
        const codes = [
            ...active
        ].sort().join(',');
        if (prevDiffCodesRef.current !== null && prevDiffCodesRef.current !== codes) {
            setDiagAIQuestions((prev)=>(0, $6xvbB.pruneDiagnosisKeyed)(prev, active));
            setDiagAIAnswers((prev)=>(0, $6xvbB.pruneDiagnosisKeyed)(prev, active));
            setDiagQSubmitting((prev)=>(0, $6xvbB.pruneDiagnosisKeyed)(prev, active));
            setDiagQError((prev)=>(0, $6xvbB.pruneDiagnosisKeyed)(prev, active));
            setOpenAIDiag((prev)=>prev && active.includes(prev) ? prev : null);
        }
        prevDiffCodesRef.current = codes;
    }, [
        differential
    ]);
    // Load clinical orders when orders tab opens
    // Loaded as soon as the encounter is known, NOT when the دستورات tab opens: the
    // plan block lists these orders, so a doctor who goes straight to «برنامه» must
    // see them there without having visited the tab first. The tab remains a retry
    // point for a fetch that failed.
    const ordersLoadedFor = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        const encId = pmEncounterId || visitId;
        if (!encId || ordersLoadedFor.current === encId) return;
        ordersLoadedFor.current = encId;
        loadClinicalOrders(encId).then((ok)=>{
            if (!ok) ordersLoadedFor.current = null;
        });
    }, [
        workTab,
        pmEncounterId,
        visitId
    ]);
    // What the orders ALREADY on the chart need from the catalogue.
    //
    // This used to be a reason to fetch the whole dictionary — the plan block wants
    // English names and the list wants the «انجام» button, so «any visit that HAS
    // orders» fetched everything whatever tab was open. It is a lookup by id, and
    // is now asked as one. Orders written before catalogIds existed are resolved by
    // name; an ambiguous name resolves to nothing rather than to a guess.
    const resolveKey = (0, $acw62.useMemo)(()=>clinicalOrders.map((o)=>o?.catalogId || (o?.description || '').trim()).filter(Boolean).sort().join('\u0000'), [
        clinicalOrders
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!resolveKey) {
            setCatalogResolved(new Map());
            return undefined;
        }
        let live = true;
        const ids = clinicalOrdersRef.current.map((o)=>o?.catalogId).filter(Boolean);
        const names = clinicalOrdersRef.current.filter((o)=>!o?.catalogId).map((o)=>(o?.description || '').trim()).filter(Boolean);
        (0, $6xvbB.resolveOrderCatalog)({
            ids: ids,
            names: names,
            appointmentId: pmEncounterId || visitId
        }).then((rows)=>{
            if (!live) return;
            const m = new Map();
            for (const r of rows){
                m.set(r.id, r);
                if (r.matchedName) m.set(r.matchedName, r); // so orderNameEn can find it by description
            }
            (0, $6xvbB.rememberCatalogNamesEn)(rows); // the closure card reads these by name
            setCatalogResolved(m);
        }).catch((err)=>{
            // A failed resolve costs a badge and an English name, never the visit.
            // It must NOT leave a half-filled map: a plan block written from one
            // would be saved with some lines translated and some not.
            console.error('order catalogue resolve failed:', err);
        });
        return ()=>{
            live = false;
        };
    }, [
        resolveKey,
        pmEncounterId,
        visitId
    ]);
    // The picker's page. One search per pause in typing, across every kind of order,
    // and the reply to an older query never overwrites a newer one.
    (0, $acw62.useEffect)(()=>{
        if (workTab !== 'orders') return undefined;
        // Nothing is listed until the doctor searches (PM-0098, as on the نسخه): the
        // picker used to open on the first page of the catalogue.
        if (orderSearch.trim().length < (0, $6xvbB.ORDER_MIN_QUERY)) {
            setCatalogPage({
                entries: [],
                total: 0,
                loading: false,
                error: null
            });
            return undefined;
        }
        let live = true;
        setCatalogPage((prev)=>({
                ...prev,
                loading: true
            }));
        const timer = setTimeout(()=>{
            (0, $6xvbB.searchOrderCatalog)({
                query: orderSearch,
                orderType: '',
                appointmentId: pmEncounterId || visitId
            }).then((page)=>{
                if (live) setCatalogPage({
                    ...page,
                    loading: false,
                    error: null
                });
            }).catch((err)=>{
                if (!live) return;
                // Shown, not swallowed: a picker that silently returns nothing is
                // indistinguishable from a catalogue that does not carry the service.
                console.error('order catalog search failed:', err);
                setCatalogPage({
                    entries: [],
                    total: 0,
                    loading: false,
                    error: err?.message || 'error'
                });
            });
        }, 250);
        return ()=>{
            live = false;
            clearTimeout(timer);
        };
    }, [
        workTab,
        orderSearch,
        pmEncounterId,
        visitId
    ]);
    // «دستورات پرتکرار من» and «در این کلینیک» (PM-0701): one fetch each per visit, when
    // the tab first opens — and only once the doctor's settings are known and they have
    // the shortcut on, so a doctor who switched one off never pays for it. Both are
    // shortcuts: a failure is an empty list, and the search below is untouched.
    const frequentOrdersFor = (0, $acw62.useRef)(null);
    const clinicOrdersFor = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        const appt = pmEncounterId || visitId;
        if (workTab !== 'orders' || aiSettingsUnknown || !appt) return;
        if (orderShowFrequent && frequentOrdersFor.current !== appt) {
            frequentOrdersFor.current = appt;
            (0, $6xvbB.fetchFrequentOrders)({
                appointmentId: appt,
                limit: 20
            }).then(setFrequentOrders);
        }
        if (orderShowClinic && clinicOrdersFor.current !== appt) {
            clinicOrdersFor.current = appt;
            (0, $6xvbB.fetchClinicOrders)({
                appointmentId: appt,
                limit: 60
            }).then(setClinicOrders);
        }
    }, [
        workTab,
        aiSettingsUnknown,
        orderShowFrequent,
        orderShowClinic,
        pmEncounterId,
        visitId
    ]);
    // ── Clinical insight pass ──────────────────────────────────────────────────
    // The one pass, callable from two places: the automatic effect below and the
    // «دریافت نکات بالینی» button in the نکات بالینی tab. Only the response's
    // `clinicalRationale` reaches the feed — its test/medication halves are
    // orders, and they belong to «دستورات» and «نسخه». Failures are kept rather
    // than swallowed — a silently empty panel is indistinguishable from "the AI
    // had nothing to say", which is the one thing it must never be confused with.
    const runRecommendations = (0, $acw62.useCallback)(()=>{
        if (!patient?.id) return;
        const conditions = (patient.clinicalConditions || []).map((c)=>c.code || c.display).filter(Boolean);
        setRecsError(null);
        setRecsLoading(true);
        return (0, $eVM84.bffQuery)((0, $6xvbB.RECOMMEND_TESTS), {
            input: {
                patientId: patient.id,
                icdCodes: conditions.slice(0, 5),
                age: (0, $6xvbB.aiPatientAge)(patient),
                gender: '',
                existingMedications: (patient.clinicalMedications || []).filter((m)=>m.status === 'active').map((m)=>m.display),
                existingTests: []
            }
        }).then((data)=>{
            setRecommendations(data.recommendTestsAndMedications);
            setRecsRan(true);
            chargeVisit((0, $1yr2B.costOf)('RECOMMENDATIONS'), 'recs');
        }).catch((err)=>{
            console.error('[recommendations]', err);
            setRecsError(err?.message || t('errors.ai.suggestionsFailed'));
        }).finally(()=>setRecsLoading(false));
    }, [
        patient,
        chargeVisit,
        t
    ]);
    // Auto-fire it when the patient loads — but only if the doctor has left the
    // automation on. `suggestionsAutoRun` is in the deps on purpose: turning the
    // setting on mid-visit must start the pass, not wait for a remount.
    (0, $acw62.useEffect)(()=>{
        // Nothing is decided while the settings are still loading — otherwise the
        // default-on fallback fires the pass and latches recsAutoFired before the
        // doctor's actual choice is known.
        if (aiSettingsUnknown) return;
        if (!patient?.id || recsAutoFired.current) return;
        if (!suggestionsAutoRun) return;
        recsAutoFired.current = true;
        runRecommendations();
    }, [
        patient,
        aiSettingsUnknown,
        suggestionsAutoRun,
        runRecommendations
    ]);
    // ── Drug management ────────────────────────────────────────────────────────
    // None of these touch the SOAP «P» text. They used to: addDrug appended a line
    // to «P» from inside the setRxItems updater — an impure updater, and a one-way
    // append that no later edit or delete could take back. The plan block is
    // derived from rxItems instead (see the reconciler below), so add / edit /
    // remove stay pure list operations and the text follows automatically.
    //
    // One entry point for every source of a prescribed drug — the catalogue
    // picker, the AI panel, and an applied treatment plan all land here, so a
    // medication has the same shape whichever door it came through. `defaults`
    // carries the picker's batch fields; anything the caller does not set falls
    // back to the formulary's own first common dose/frequency.
    // مقدار تحویلی, when not given, is worked out from the line's دوز × تناوب × مدت
    // (withAutoQuantity) — the e-prescription refuses a line without one.
    // The doctor's last directions, by product (PM-0574, useRxMemory): «داروهای
    // پرتکرار من», then `myLastDrugSigs` for any product the picker offers, then a
    // line added in this visit — the newest wins, on today's lists.
    const rxLists = (0, $acw62.useMemo)(()=>({
            routes: (0, $6xvbB.RX_ROUTES)(),
            durations: (0, $6xvbB.DURATIONS)(t)
        }), [
        t
    ]);
    // What a product opens the add form with: the doctor's own last sig for it where
    // there is one, else the product's — one unit of its form, the formulary's
    // frequency, the route its name states (as the route's VALUE, never a
    // translated label: K1, 2026-10-03) — and a one-week course (rxAddDefaults).
    const rxMemory = (0, $5VYuu.useRxMemory)({
        frequentDrugs: frequentDrugs,
        lists: rxLists,
        defaultDuration: t('visit.duration.d7')
    });
    const { usualRx: usualRx, rxDefaultsFor: rxDefaultsFor, remember: rememberRx } = rxMemory;
    // One unit of the product's form, never the formulary's first dose: a تأمین
    // row's list holds its STRENGTH («5 MG»), which the e-prescription refuses. The
    // shape itself is lib/rxOptions.js newRxLine — the phone makes its lines there too.
    // An empty مدت or تناوب on a new line follows from a given quantity (newRxLine).
    const makeRxItem = (0, $acw62.useCallback)((drug, defaults = {}, seq = 0)=>(0, $eQiuG.newRxLine)(drug, defaults, seq, {
            durations: (0, $6xvbB.DURATIONS)(t)
        }), [
        t
    ]);
    // The form's «افزودن به نسخه» and the one-click frequent row land here alike:
    // the same line (newRxLine), persisted the same way — a draft until the visit
    // closes or writeNow, written with medicationMetaFromDrug (useVisitRxPersistence).
    const addDrug = (0, $acw62.useCallback)((drug, defaults)=>{
        setRxItems((prev)=>{
            if (prev.find((r)=>r.drug.id === drug.id)) return prev;
            return [
                ...prev,
                makeRxItem(drug, defaults)
            ];
        });
        // Saved once: from now on, this visit included, the drug is one click (PM-0516),
        // and these are its latest directions (PM-0574).
        setFrequentDrugs((prev)=>(0, $eQiuG.withFrequentDrug)(prev, drug, defaults));
        rememberRx(drug, defaults);
    }, [
        makeRxItem,
        rememberRx
    ]);
    // What the picker lists (PM-0516): every frequent drug the visit could map onto
    // today's lists, with that sig — the one a click adds.
    const frequentRx = (0, $acw62.useMemo)(()=>(0, $eQiuG.frequentRxEntries)(frequentDrugs, usualRx), [
        frequentDrugs,
        usualRx
    ]);
    // Null when the doctor hid «داروهای پرتکرار من» (PM-0631): the picker is then
    // search-only. The list is still read — the add form's last directions come from it.
    const showFrequentRx = (0, $aoLHg.isWorkPartVisible)(visitLayout, 'rx.frequent');
    const rxFrequent = (0, $acw62.useMemo)(()=>showFrequentRx ? {
            entries: frequentRx,
            onAddUsual: addDrug
        } : null, [
        showFrequentRx,
        frequentRx,
        addDrug
    ]);
    // «افزودن به نسخه ویزیت» from a document review (§23.3 A13). The line is NOT added:
    // the add form opens on it, prefilled with the document's sig — on the closed
    // lists where the paper named an option, as written where it did not — and it
    // becomes a نسخه line only by that form's «افزودن به نسخه», the same door as a
    // drug the doctor searched for (so the «P» block follows as usual).
    const prefillRxFromDocument = (0, $acw62.useCallback)(({ drug: drug, defaults: defaults })=>{
        if ((0, $8qEaX.isAlreadyPrescribed)(rxItemsRef.current, drug)) return 'alreadyPrescribed';
        queueRxAdds([
            {
                key: `document:${drug.id}:${Date.now()}`,
                drug: drug,
                defaults: (0, $eQiuG.listValuesWhereNamed)(drug, defaults, rxLists),
                sourceLabel: t('visit.rx.documentDraft.title')
            }
        ]);
        setWorkTab('rx');
        return 'prefilled';
    }, [
        rxLists,
        t,
        queueRxAdds
    ]);
    docRxCapability.current = prefillRxFromDocument;
    // «داروهای پرتکرار من» — once per visit, and optional: without it every drug
    // starts from the product's sig and the picker is search-only. Thirty, since
    // the list is now at hand in the picker (PM-0516).
    (0, $acw62.useEffect)(()=>{
        if (workTab !== 'rx' || frequentDrugsFetched.current) return;
        frequentDrugsFetched.current = true;
        (0, $6xvbB.fetchFrequentDrugs)(30).then(setFrequentDrugs).catch((err)=>console.error('[rx] myFrequentDrugs failed:', err));
    }, [
        workTab
    ]);
    // Already on the نسخه — checking it again would be a no-op, so the row says so.
    const prescribedDrugIds = (0, $acw62.useMemo)(()=>new Set(rxItems.map((r)=>r.drug?.id)), [
        rxItems
    ]);
    // Rows that already exist server-side — everything a template put here, and
    // everything read back when this visit was reopened — are edited and deleted
    // through the record, not only in local state. See useVisitRxPersistence.
    const rxPersistence = (0, $U8Lvw.useVisitRxPersistence)({
        appointmentId: pmEncounterId || visitId,
        patientId: patient?.id,
        setRxItems: setRxItems,
        rxItems: rxItems
    });
    // The in-visit e-prescription card re-reads when the نسخه or the دستورات change —
    // once they have settled, so a dose being typed is not re-read per keystroke.
    const erxContent = (0, $acw62.useMemo)(()=>JSON.stringify([
            rxItems.map((r)=>[
                    r.id,
                    r.dosage,
                    r.frequency,
                    r.route,
                    r.duration,
                    r.quantity
                ]),
            // An order's «تاریخ انجام» decides which prescription it goes in (PM-0634).
            clinicalOrders.map((o)=>[
                    o.id,
                    o.status,
                    o.performedDate || null
                ])
        ]), [
        rxItems,
        clinicalOrders
    ]);
    const [erxRefreshKey, setErxRefreshKey] = (0, $acw62.useState)(erxContent);
    (0, $acw62.useEffect)(()=>{
        if (!erxOpen) return undefined;
        const h = setTimeout(()=>setErxRefreshKey(erxContent), 900);
        return ()=>clearTimeout(h);
    }, [
        erxContent,
        erxOpen
    ]);
    const updateDrug = (0, $acw62.useCallback)((id, key, val)=>{
        // applyRxEdit: a دوز/تناوب/مدت change carries a worked-out quantity along.
        // A doctor's own edit ends the line's «پیشنهاد هوش مصنوعی» mark, and — on a
        // line whose removal failed — the «حذف نشد» mark: they are keeping it.
        // Any two of مقدار تحویلی / تناوب / مدت settle an empty third (applyRxEdit).
        setRxItems((prev)=>prev.map((r)=>r.id === id ? {
                    ...(0, $eQiuG.applyRxEdit)(r, key, val, {
                        durations: (0, $6xvbB.DURATIONS)(t)
                    }),
                    aiNote: undefined,
                    removeFailed: undefined
                } : r));
        rxPersistence.scheduleSave(id);
    }, [
        rxPersistence,
        t
    ]);
    const removeDrug = (0, $acw62.useCallback)((id)=>{
        // Delete FIRST: the hook reads the row it is deleting out of the list it
        // last saw, and clearing local state before that would leave it nothing to
        // find and the record row orphaned.
        rxPersistence.deleteRow(id);
        setRxItems((prev)=>prev.filter((r)=>r.id !== id));
        // A result naming a drug that is no longer on the list is worse than no
        // result, so a removal clears it outright rather than marking it stale.
        setRxInteractions(null);
        setIxError(null);
    }, [
        rxPersistence
    ]);
    // ── Applying a «قالب نسخه» ──────────────────────────────────────────────────
    //
    // The server has already created the rows; this only shows them. They arrive
    // as ordinary نسخه rows carrying their own ids, so from here on they are
    // edited, removed and printed exactly like a drug the doctor typed — which is
    // the property the whole feature is for.
    const handleMedicationTemplateApplied = (0, $acw62.useCallback)((result, outcome)=>{
        setRxItems((prev)=>(0, $85jFj.mergeRxItems)(prev, (result?.medications || []).map((0, $85jFj.rxItemFromMedication))));
        // A displayed interaction result was computed against the old list.
        if (outcome.applied) {
            setRxInteractions(null);
            setIxError(null);
        }
        const message = (0, $cvBw3.applyMessage)('medication', result, outcome, t, formatList);
        // A partial apply is reported as an error, not a success: the sentence
        // names drugs the doctor still has to add by hand, and a green toast is
        // read as "done" and dismissed.
        if (outcome.kind === 'partial') toast.error(message);
        else toast.success(message);
    }, [
        t,
        formatList,
        toast
    ]);
    const handleOrderTemplateApplied = (0, $acw62.useCallback)((result, outcome)=>{
        const orders = result?.orders || [];
        setClinicalOrders((prev)=>(0, $85jFj.mergeOrders)(prev, orders));
        // Same mirror the manual دستورات form does, so the printed نسخه and the
        // end-of-visit flush see a template-placed order like any other.
        // `savedToBackend: true` — applying a template is a SERVER write: these
        // orders exist already. Mirroring them as unsaved would have the
        // end-of-visit flush create every one of them a second time.
        orders.forEach((o)=>mirrorOrderToPendingTests({
                type: o.orderType,
                name: o.description,
                urgency: o.urgency,
                reason: o.notes || '',
                code: o.code || '',
                loincCode: o.code || ''
            }, {
                savedToBackend: true
            }));
        const message = (0, $cvBw3.applyMessage)('order', result, outcome, t, formatList);
        // A partial apply is reported as an error, not a success: the sentence
        // names drugs the doctor still has to add by hand, and a green toast is
        // read as "done" and dismissed.
        if (outcome.kind === 'partial') toast.error(message);
        else toast.success(message);
    }, [
        t,
        formatList,
        toast
    ]);
    // Only diagnoses the doctor has ACCEPTED reach the rule engine, so a reshuffle
    // of the suggestions below them does not change the clinical picture a check
    // was run against.
    const acceptedDiagnoses = (0, $acw62.useMemo)(()=>(differential || []).filter((0, $6xvbB.isDifferentialAccepted)).map((d)=>d.description), [
        differential
    ]);
    const acceptedDiagnosesKey = acceptedDiagnoses.join(' ');
    // The interaction check runs ONLY when the doctor asks for it. It used to fire
    // itself 800ms after any change to rxItems or the accepted diagnoses, so the
    // doctor was interrupted — and billed — mid-thought, over a prescription that
    // wasn't finished enough to judge yet. The one check that still runs unasked is
    // the sweep in `useEndVisit`, and it speaks up only for a high-severity finding:
    // that is the backstop for a doctor who never pressed this button, not a second
    // opinion on one who did.
    //
    // `signature` records the rx list + clinical picture the displayed result was
    // computed from; when it stops matching, the result is stale and says so
    // instead of silently re-running.
    const rxSignature = (0, $acw62.useMemo)(()=>(0, $6xvbB.rxCheckSignature)(rxItems, acceptedDiagnosesKey), [
        rxItems,
        acceptedDiagnosesKey
    ]);
    // The stop banner describes a finding computed from one prescription; editing
    // that prescription makes it a statement about a list that no longer exists.
    (0, $acw62.useEffect)(()=>{
        setInteractionStop(false);
    }, [
        rxSignature
    ]);
    // ── The end-of-visit write sequence ───────────────────────────────────────
    // Placed here rather than beside the other state because it reads
    // `rxSignature`: a sweep result the doctor is shown must carry the signature
    // of the prescription it was computed from, or the نسخه tab reports it as
    // fresh forever.
    const { endProgress: endProgress, saveFailures: saveFailures, failedGroups: failedGroups, retrying: retrying, start: startEndVisit, retryFailed: retryFailed, endedAt: endedAt, durationMin: durationMin } = (0, $glimY.default)({
        t: t,
        visitId: visitId,
        pmEncounterId: pmEncounterId,
        soapNoteId: soapNoteId,
        soap: soap,
        rxItems: rxItems,
        pendingTests: pendingTests,
        patient: patient,
        diagnosis: diagnosis,
        differential: differential,
        rxInteractions: rxInteractions,
        rxSignature: // What the sweep reads `rxInteractions` against: a result counts as "shown"
        // only for the نسخه it was computed from (interactionSeen.js).
        rxSignature,
        elapsedSeconds: elapsed,
        chargeVisit: // The closure sweep is a billed AI call; the hook charges it to the visit.
        chargeVisit,
        // «بررسی تداخل دارویی در پایان ویزیت». The only automation switch that is
        // about safety rather than spend, so it is the only one that survives an
        // unknown settings state — see `endVisitSweepOn`.
        interactionSweepEnabled: endVisitSweepOn,
        // Marking the visit finished immediately is what stops every reactive AI
        // effect (SOAP refine, differential regen) from firing into a closed visit;
        // their cleanups run here too.
        onVisitClosed: ()=>{
            setVisitStatus('finished');
            setSoapNoteId(null);
        },
        onInteractionFound: (warnings)=>{
            setRxInteractions({
                hasInteractions: true,
                warnings: warnings,
                signature: rxSignature
            });
        }
    });
    // The in-visit «ارسال به بیمه»: on every tab (PM-0097 — it was the نسخه and
    // دستورات tabs only), once the visit has an id and a patient, and never while
    // the visit is being closed — nor in a clinic outside Iran, whose patients no
    // Iranian insurer covers.
    const erxAvailable = iranianRails && !!patient?.id && !!(pmEncounterId || visitId) && !endProgress.running && !showClosureFlow;
    // ── «اصلاح نسخهٔ ثبت‌شده» (K1, 2026-10-04; docs/eprescription/CORRECTION.md) ──
    //
    // Once a part of this visit is registered, each نسخه line and دستورات row says
    // where it stands with the insurer, and the «ارسال … به بیمه» buttons count
    // what a correction would carry. `ePrescriptionStatus` never reaches the
    // insurer: it is read once the visit is known, again when the نسخه or دستورات
    // tab opens, once an edit there has settled, and after the card sends or
    // corrects — each time behind the نسخه's queued saves (rxPersistence.flush),
    // since the server reads the record. A read that fails shows nothing new.
    const erxStatusActive = iranianRails && !!patient?.id && !!(pmEncounterId || visitId) && !endProgress.running && !showClosureFlow;
    const { status: erxStatus, reload: reloadErxStatus } = (0, $7ZSin.useErxStatus)({
        appointmentId: pmEncounterId || visitId,
        patientId: patient?.id,
        prepare: rxPersistence.flush,
        active: erxStatusActive
    });
    const erxTabOpen = workTab === 'rx' || workTab === 'orders';
    // What the chips depend on: the card's content, and which lines have reached
    // the record (a line is matched by its record id).
    const erxStatusContent = (0, $acw62.useMemo)(()=>JSON.stringify([
            erxContent,
            rxItems.map((r)=>r.medicationId || null)
        ]), [
        erxContent,
        rxItems
    ]);
    const erxStatusReadFor = (0, $acw62.useRef)(erxStatusContent);
    const erxStatusTab = (0, $acw62.useRef)(null);
    // The نسخه or دستورات tab opening (or the doctor moving between them).
    (0, $acw62.useEffect)(()=>{
        const tab = erxStatusActive && erxTabOpen ? workTab : null;
        if (tab && erxStatusTab.current !== tab) {
            erxStatusReadFor.current = erxStatusContent;
            reloadErxStatus();
        }
        erxStatusTab.current = tab;
    }, [
        workTab,
        erxTabOpen,
        erxStatusActive,
        erxStatusContent,
        reloadErxStatus
    ]);
    // An edit there, once it has settled — as the card's own refreshKey.
    (0, $acw62.useEffect)(()=>{
        if (!erxStatusActive || !erxTabOpen || erxStatusReadFor.current === erxStatusContent) return undefined;
        const h = setTimeout(()=>{
            erxStatusReadFor.current = erxStatusContent;
            reloadErxStatus();
        }, 900);
        return ()=>clearTimeout(h);
    }, [
        erxStatusContent,
        erxStatusActive,
        erxTabOpen,
        reloadErxStatus
    ]);
    const erxIndex = (0, $acw62.useMemo)(()=>(0, $3O5pt.indexErxStatus)(erxStatus), [
        erxStatus
    ]);
    const erxPending = (0, $acw62.useMemo)(()=>(0, $3O5pt.pendingCorrections)(erxStatus), [
        erxStatus
    ]);
    const erxRemovedRx = (0, $acw62.useMemo)(()=>(0, $3O5pt.erxRemovedLines)(erxIndex, 'DRUGS', rxItems.map((r)=>r.medicationId)), [
        erxIndex,
        rxItems
    ]);
    const erxRemovedOrders = (0, $acw62.useMemo)(()=>(0, $3O5pt.erxRemovedLines)(erxIndex, 'SERVICES', clinicalOrders.map((o)=>o.id)), [
        erxIndex,
        clinicalOrders
    ]);
    // The card's words for a line as it is now: a نسخه line's dose — beside what
    // the insurer holds of a changed one — and a دستور's kind (the panel's preview,
    // PM-0187).
    const describeErxLine = (0, $acw62.useCallback)((line)=>{
        if (line?.orderId && !line.medicationId) {
            const order = clinicalOrders.find((o)=>String(o.id) === String(line.orderId));
            return order ? (0, $6xvbB.ORDER_TYPE_FA)(t)[order.orderType] || null : null;
        }
        const row = line?.medicationId ? rxItems.find((r)=>r.medicationId && String(r.medicationId) === String(line.medicationId)) : null;
        return row ? (0, $6xvbB.rxItemSummary)(row, t, readsPersianData) : null;
    }, [
        rxItems,
        clinicalOrders,
        t,
        readsPersianData
    ]);
    const ixStale = !!rxInteractions && rxInteractions.signature !== rxSignature;
    // Two drugs, or one with an allergy or a condition to read it against
    // (Visit.shared canRunInteractionCheck — the same rule on both surfaces).
    const interactionCheckReady = (0, $6xvbB.canRunInteractionCheck)(rxItems, patient, acceptedDiagnoses);
    const canCheckInteractions = interactionCheckReady && !interactionLoading;
    const runInteractionCheck = (0, $acw62.useCallback)(async ()=>{
        if (!(0, $6xvbB.canRunInteractionCheck)(rxItems, patient, acceptedDiagnoses) || interactionLoading) return;
        setIxLoading(true);
        setIxError(null);
        try {
            const { conditions: conditions, allergies: allergies } = (0, $6xvbB.interactionContext)(patient, acceptedDiagnoses);
            const result = await (0, $eVM84.bffQuery)((0, $6xvbB.CHECK_DRUG_INTERACTION), {
                // The drugs' Latin substance names. The argument is still called
                // `medicationIds`, but the service prompts its model with these strings
                // and matches its rules on them: a formulary id («tamin-70521») told it
                // nothing, and it invented a finding (lib/drugNames interactionDrugName).
                medicationIds: (0, $g6gAc.interactionDrugNames)(rxItems),
                patientId: patient.id,
                patientConditions: conditions,
                patientAllergies: allergies
            });
            const warnings = result.checkDrugInteraction?.warnings || [];
            setRxInteractions({
                hasInteractions: warnings.length > 0,
                warnings: warnings,
                signature: rxSignature
            });
            chargeVisit((0, $1yr2B.costOf)('INTERACTION_CHECK'), 'interaction');
        } catch (e) {
            // A check the doctor asked for has to say when it failed — swallowing the
            // error leaves an empty panel that reads as «تداخلی نیست».
            setIxError(e?.message || t('errors.load.interactions'));
        } finally{
            setIxLoading(false);
        }
    }, [
        patient,
        rxItems,
        acceptedDiagnoses,
        interactionLoading,
        rxSignature,
        chargeVisit,
        t
    ]);
    // ── AI Assist ──────────────────────────────────────────────────────────────
    // Grounds the prescription assist in the full clinical picture of the current
    // visit: recorded conditions + accepted differentials + lab-inferred conditions
    // + the SOAP subjective/assessment + the working diagnosis, plus allergies.
    const buildAssistPrescriptionInput = ()=>{
        const recordedConditions = (patient.clinicalConditions || []).map((c)=>c.display).filter(Boolean);
        const diffConditions = (differential || []).filter((0, $6xvbB.isDifferentialAccepted)).map((d)=>d.description);
        const labConditions = (0, $6xvbB.inferConditionsFromObservations)(patient.clinicalObservations);
        const soapConditions = [
            soap.s,
            soap.a
        ].filter(Boolean);
        const allergies = (patient.clinicalAllergies || []).map((a)=>a.allergen).filter(Boolean);
        return {
            visitId: visitId || '',
            patientId: patient.id,
            // Checked by the same rule engine as the interaction check, so the same names.
            medications: (0, $g6gAc.interactionDrugNames)(rxItems),
            conditions: [
                ...recordedConditions,
                ...diffConditions,
                ...labConditions,
                ...soapConditions
            ],
            diagnosis: soap.a || diagnosis || '',
            age: (0, $6xvbB.aiPatientAge)(patient),
            gender: '',
            existingTests: [],
            patientAllergies: allergies
        };
    };
    const handleAssistPrescription = async ()=>{
        if (!patient?.id) return;
        setAiLoading(true);
        try {
            const data = await (0, $eVM84.bffMutation)((0, $6xvbB.ASSIST_PRESCRIPTION), {
                input: buildAssistPrescriptionInput()
            });
            setAiResult(data.assistPrescription);
            // The service debits for this exactly as it does for the نسخه tab's
            // button, so it goes on the visit ledger exactly as that one does. It used
            // to be the quietest spend on the page: unasked, and invisible everywhere
            // except the account panel.
            // `costOf`, not the constant. A Parseh price is a ROW served by the
            // active pricing policy (docs/AI_COST_AND_PARSEH_PRICING_MANAGEMENT_
            // DESIGN.md); the shipped constant in creditPricing.js is the OFFLINE FALLBACK the PriceBook uses
            // before its first load. Reading the constant here put a stale figure on
            // the visit ledger while the wallet was debited the real one — the same
            // call one panel over already did this correctly.
            chargeVisit((0, $1yr2B.costOf)('ASSIST_PRESCRIPTION'), 'rx');
        } catch (e) {
            // A spent wallet is the one failure the doctor has to be told about —
            // otherwise the panel simply never fills and nothing says why.
            if (e?.extensions?.code === 'INSUFFICIENT_CREDITS') setCreditError(e.message);
            else console.warn(e);
        } finally{
            setAiLoading(false);
        }
    };
    // ── The نسخه's AI helpers: dictation · «پایش بالینی» · شرح حال ──────────────
    // docs/VISIT_RX_AI_ASSIST.md. Three sources, one review: every proposal is a
    // formulary drug the server matched in code, and it waits for the doctor's
    // tick. The approved lines then open the add form a searched drug opens, one
    // after another, prefilled with the model's sig (proposalFormRequests, K1
    // 2026-10-05) — they used to land on the نسخه directly and arrive «ناقص» where
    // the model left a required field out. Each becomes a line only by the form's
    // «افزودن به نسخه», through addDrug like any other. The old «پیشنهاد دارو» panel
    // added the model's free-text names as synthetic `sugg-med-` drugs one click at
    // a time; «پیشنهاد از شرح حال» replaces it.
    const rxHistoryCtx = {
        soap: soap,
        diagnoses: [
            ...acceptedDiagnoses,
            diagnosis
        ].filter(Boolean)
    };
    const rxAssist = (0, $5kzaL.useMedicationProposals)({
        getContext: ()=>({
                appointmentId: visitId || '',
                patient: patient,
                soap: soap,
                diagnoses: rxHistoryCtx.diagnoses,
                rxItems: rxItemsRef.current,
                transcript: liveTranscript
            }),
        chargeVisit: chargeVisit,
        chargeLabel: (source)=>t(`visit.rxAssist.charged.${source.toLowerCase()}`),
        onCreditError: setCreditError,
        // «تایید خودکار» (PM-0586): what the AI service marked goes on the نسخه as the form's
        // «افزودن به نسخه» would put it — the voice's values, then the doctor's own last
        // directions (PM-0574) — and only when the line needs no guess (autoRxSig).
        autoConfirm: autoConfirmAllowed,
        onAutoConfirm: async (source, rows)=>{
            await rxMemory.request(rows.map((r)=>r.proposal.autoDrug.id));
            const added = [];
            const records = [];
            rows.forEach((row)=>{
                const drug = row.proposal.autoDrug;
                if (rxItemsRef.current.some((r)=>r.drug?.id === drug.id)) return;
                const line = (0, $bwSot.autoRxSig)(row.proposal, drug, rxMemory.usualOf(drug.id), {
                    durations: rxLists.durations,
                    makeLine: (d, sig)=>makeRxItem(d, {
                            ...sig,
                            route: sig.route || (0, $eQiuG.autoRouteFor)(d)
                        })
                });
                if (!line) return;
                const { dosage: dosage, frequency: frequency, route: route, duration: duration, quantity: quantity, instructions: instructions } = line;
                addDrug(drug, {
                    dosage: dosage,
                    frequency: frequency,
                    route: route,
                    duration: duration,
                    quantity: quantity,
                    instructions: instructions
                });
                added.push(row.key);
                records.push({
                    key: drug.id,
                    label: drug.name || (0, $g6gAc.drugDisplayName)(drug),
                    before: '',
                    after: (0, $bwSot.autoRxSummary)(line),
                    row: row,
                    source: source
                });
            });
            if (records.length) autoConfirm.add('rx', records);
            return added;
        },
        onApply: (lines, source)=>{
            const have = new Set(rxItemsRef.current.map((r)=>r.drug?.id));
            queueRxAdds((0, $bwSot.proposalFormRequests)(lines.filter((l)=>!have.has(l.drug.id)), {
                source: source,
                durations: rxLists.durations,
                label: (n, total)=>total > 1 ? t('visit.rxAssist.formSourceN', {
                        n: formatNumber(n),
                        total: formatNumber(total)
                    }) : t('visit.rxAssist.formSource')
            }));
            // The form opens in «افزودن دارو», right below the closed card.
            requestAnimationFrame(()=>document.querySelector('[data-testid="visit-rx-picker"]')?.scrollIntoView?.({
                    block: 'nearest',
                    behavior: 'smooth'
                }));
        }
    });
    // ── «تکمیل نحوه مصرف» (K1, 2026-10-03) ─────────────────────────────────────
    // One press fills دوز, تناوب, نحوه مصرف, مدت and مقدار تحویلی on the lines that
    // still need them (missingRxFields). The AI only fills what the doctor has not
    // DECIDED: an empty field, or one still holding what the app itself pre-filled
    // — the product's one-unit دوز, the route read from its name. A value the
    // doctor picked is never replaced, and a line edited while the call was out is
    // left alone. The quantity follows the formula where it can (applyRxEdit);
    // the AI's count is used only where the formula has none (a syrup's bottles).
    const [rxDirectionsBusy, setRxDirectionsBusy] = (0, $acw62.useState)(false);
    // The patient's basic insurer, for the «در فهرست تأمین» chips on the نسخه.
    const patientInsurer = (0, $acw62.useMemo)(()=>(0, $eQiuG.insurerKeyOf)(patient?.insurance), [
        patient?.insurance
    ]);
    const rxIncompleteCount = (0, $acw62.useMemo)(()=>rxItems.filter((r)=>(0, $eQiuG.missingRxFields)(r).length > 0).length, [
        rxItems
    ]);
    const completeRxDirections = (0, $acw62.useCallback)(async ()=>{
        const snapshot = rxItemsRef.current.filter((r)=>(0, $eQiuG.missingRxFields)(r).length > 0);
        if (!snapshot.length || rxDirectionsBusy) return;
        setRxDirectionsBusy(true);
        try {
            const data = await (0, $eVM84.bffMutation)((0, $6xvbB.COMPLETE_RX_DIRECTIONS), {
                input: {
                    appointmentId: pmEncounterId || visitId || '',
                    patientId: patient?.id || null,
                    lines: snapshot.map((r)=>({
                            lineId: String(r.id),
                            drugName: r.drug?.name || '',
                            genericName: r.drug?.genericName || '',
                            doseOptions: (0, $eQiuG.doseOptionsFor)(r.drug),
                            dosage: r.dosage || '',
                            frequency: r.frequency || '',
                            route: r.route || '',
                            duration: r.duration || '',
                            quantity: r.quantity || ''
                        })),
                    frequencyOptions: (0, $eQiuG.FREQUENCY_OPTIONS),
                    // The routes' VALUES, as a line stores them in every UI language — the
                    // answer is one of these and is written as it comes (K1, 2026-10-03).
                    routeOptions: (0, $6xvbB.RX_ROUTES)(),
                    durationOptions: (0, $6xvbB.DURATIONS)(t),
                    diagnoses: [
                        ...acceptedDiagnoses,
                        diagnosis
                    ].filter((d)=>typeof d === 'string' && d.trim()),
                    soapS: soap?.s || '',
                    soapA: soap?.a || '',
                    patientAllergies: (patient?.clinicalAllergies || []).map((a)=>a?.allergen).filter(Boolean),
                    age: Number.isFinite(patient?.age) ? patient.age : null,
                    gender: patient?.gender || ''
                }
            });
            const result = data?.completeRxDirections || {
                status: 'none_completed',
                charged: false,
                lines: []
            };
            if (result.charged) chargeVisit((0, $1yr2B.costOf)('RX_DIRECTIONS'), 'rx-directions');
            // Matched to the lines by their ids, and merged into each line AS IT IS NOW.
            // They were matched by object identity, so a line that changed in any way
            // while the call was out — writeNow giving it its record id is enough —
            // lost its answer, though the call was charged and the toast said
            // «applied» (K1, 2026-10-03). fillRxDirections fills only what is still
            // open in the line now, so a field the doctor set meanwhile still wins.
            const answers = new Map((result.lines || []).map((l)=>[
                    String(l.lineId),
                    l
                ]));
            const asked = new Set(snapshot.map((r)=>String(r.id)));
            const merge = (r)=>asked.has(String(r.id)) ? (0, $eQiuG.fillRxDirections)(r, answers.get(String(r.id)), {
                    durations: (0, $6xvbB.DURATIONS)(t)
                }) : r;
            const applied = rxItemsRef.current.filter((r)=>merge(r) !== r).map((r)=>r.id);
            setRxItems((prev)=>prev.map(merge));
            applied.forEach((id)=>rxPersistence.scheduleSave(id));
            if (applied.length) toast.success(t('visit.rx.directions.applied', {
                count: applied.length
            }));
            else toast.info(t('visit.rx.directions.none'));
        } catch (e) {
            if (e?.extensions?.code === 'INSUFFICIENT_CREDITS') setCreditError(e.message);
            else toast.error(t('visit.rx.directions.failed'));
        } finally{
            setRxDirectionsBusy(false);
        }
    }, [
        rxDirectionsBusy,
        pmEncounterId,
        visitId,
        patient,
        t,
        acceptedDiagnoses,
        diagnosis,
        soap,
        chargeVisit,
        rxPersistence,
        toast
    ]);
    // ── «تکمیل از پایش بالینی» beyond the note and the نسخه (PM-0029, PM-0038) ──
    // علائم حیاتی, دستورات and اطلاعات پرونده read from the same transcript, each
    // from the «تکمیل» button of its own section. Findings are proposals; what the
    // doctor ticks is written through the path a hand-entered value takes
    // (monitoringApply.js): vitals land in the vitals FORM for the doctor to «ثبت»,
    // orders join the order list, a follow-up becomes a line of «P».
    const monitoringExtract = (0, $fIKok.useMonitoringExtraction)({
        // The visit's orders and encounter id say what it already holds: a second
        // «تکمیل» shows those findings as already on the visit, never writes them again.
        getContext: ()=>({
                appointmentId: visitId || '',
                encounterId: pmEncounterId || visitId || '',
                patient: patient,
                transcript: liveTranscript,
                orders: clinicalOrdersRef.current,
                vitals: vitalsRef.current
            }),
        chargeVisit: chargeVisit,
        chargeLabel: (group)=>t(`visit.monitoringExtract.charged.${group}`),
        onCreditError: setCreditError,
        // A heard lab / imaging / procedure is matched to its catalogue entry with the
        // picker's own search, so it is saved with its code like a hand-picked one.
        searchCatalog: (0, $6xvbB.searchOrderCatalog),
        // «تایید خودکار»: the علائم حیاتی rows the form takes without overwriting
        // anything go where «تأیید» puts them — the form, for the doctor's «ثبت».
        autoConfirm: autoConfirmAllowed,
        onAutoConfirm: async (group, rows)=>{
            // PM-0586: each order the AI service marked, created as its catalogue row through
            // the path «تأیید» takes (applyMonitoringFindings) — one at a time, so each
            // created order is the one its row asked for.
            if (group === 'ORDERS') {
                const made = [];
                const records = [];
                for (const row of rows){
                    const res = await (0, $l7onJ.applyMonitoringFindings)({
                        picked: {
                            vitals: [],
                            orders: [
                                row.finding
                            ],
                            record: []
                        },
                        patientId: patient.id,
                        appointmentId: pmEncounterId || visitId,
                        t: t
                    });
                    if (res.creditError) setCreditError(res.creditError);
                    const o = res.orders[0];
                    if (!o?.created?.id) continue;
                    setClinicalOrders((prev)=>[
                            o.created,
                            ...prev
                        ]);
                    mirrorOrderToPendingTests({
                        type: o.item.orderType,
                        name: o.item.name,
                        urgency: o.item.urgency,
                        reason: o.item.reason,
                        code: o.item.code,
                        loincCode: o.item.loincCode
                    }, {
                        savedToBackend: true
                    });
                    made.push(row.key);
                    records.push({
                        key: o.created.id,
                        label: o.item.name,
                        before: '',
                        after: o.created.description || o.item.name,
                        row: row
                    });
                }
                if (records.length) autoConfirm.add('order', records);
                return made;
            }
            const filled = (0, $b4nOl.vitalsFormPatch)(rows.map((r)=>r.finding));
            setVitals((prev)=>({
                    ...prev,
                    ...filled
                }));
            setVitalsMode('form');
            autoConfirm.add('vitals', rows.map((row)=>({
                    key: row.finding.kind,
                    before: '',
                    after: (0, $b4nOl.vitalsFormValue)(filled, row.finding.kind),
                    row: row
                })));
        },
        onApply: async (picked)=>{
            const res = await (0, $l7onJ.applyMonitoringFindings)({
                picked: picked,
                patientId: patient.id,
                appointmentId: pmEncounterId || visitId,
                t: t
            });
            if (res.creditError) setCreditError(res.creditError);
            if (Object.keys(res.vitalsPatch).length) {
                setVitals((prev)=>({
                        ...prev,
                        ...res.vitalsPatch
                    }));
                setVitalsMode('form');
            }
            if (res.orders.length) {
                setClinicalOrders((prev)=>[
                        ...res.orders.map((o)=>o.created),
                        ...prev
                    ]);
                res.orders.forEach((o)=>mirrorOrderToPendingTests({
                        type: o.item.orderType,
                        name: o.item.name,
                        urgency: o.item.urgency,
                        reason: o.item.reason,
                        code: o.item.code,
                        loincCode: o.item.loincCode
                    }, {
                        savedToBackend: true
                    }));
            }
            if (res.followUps.length) applyRefinedSections({
                p: (0, $b4nOl.appendFollowUps)((0, $6xvbB.planNarrative)(soapRef.current?.p || ''), res.followUps)
            });
            if (res.saved) refreshPatient();
            // Nothing landed at all: keep the review open so the ticks are not lost.
            const landed = res.saved + res.followUps.length + Object.keys(res.vitalsPatch).length;
            if (!landed && res.failed) throw new Error('monitoring findings were not saved');
            if (res.failed) toast.error(t('visit.monitoringExtract.partlyApplied', {
                failed: res.failed
            }));
            else toast.success(t(Object.keys(res.vitalsPatch).length ? 'visit.monitoringExtract.appliedVitals' : 'visit.monitoringExtract.applied'));
        }
    });
    // ── «تکمیل» as one flow (PM-0038) ─────────────────────────────────────────
    // The same button in every section, the visit-wide one beside «پایش بالینی» in
    // the top bar, and the guide that walks from one section's proposals to the next.
    autoConfirmNow.current = autoConfirmOn && visitStatus === 'inprogress' && !endProgress.running && !showClosureFlow;
    const completion = (0, $icdDW.useVisitCompletion)({
        t: t,
        formatNumber: formatNumber,
        toast: toast,
        costOf: $1yr2B.costOf,
        soapRefine: soapRefine,
        rxAssist: rxAssist,
        monitoringExtract: monitoringExtract,
        disabled: !visitId || !patient?.id,
        recState: // «تکمیل خودکار پس از پایش بالینی»: never into a visit being closed.
        recState,
        autoRunOnStop: autoCompleteOn && visitStatus === 'inprogress' && !endProgress.running && !showClosureFlow
    });
    // The stop control's own press — the one stop that may run «تکمیل» after it.
    const stopMonitoring = ()=>{
        completion.armAutoRun();
        stopRec();
    };
    // The note is two tabs (S/O/A and «برنامه درمان»), one section of the guide.
    const completeSectionShown = {
        soap: 'soap',
        plan: 'soap',
        rx: 'rx',
        orders: 'orders'
    }[workTab];
    const goCompleteSection = (id)=>{
        if (id === 'vitals' || id === 'record') {
            toggleRecordPanelOpen(true);
            if (id === 'vitals' && !recordOpen.vitals) toggleRecordSection('vitals');
            requestAnimationFrame(()=>document.querySelector(`[data-testid="visit-complete-${id}"]`)?.scrollIntoView?.({
                    block: 'nearest',
                    behavior: 'smooth'
                }));
            return;
        }
        if (id === 'soap') {
            const keys = Object.keys(soapRefine.preview || {});
            pickWorkTab(keys.length && keys.every((k)=>k === 'p') ? 'plan' : 'soap');
            return;
        }
        pickWorkTab(id);
    };
    const findingsCard = (group, style)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4SCt2.default), {
            group: group,
            review: monitoringExtract.reviews[group],
            onToggle: (key)=>monitoringExtract.toggle(group, key),
            onSetAll: (checked)=>monitoringExtract.setAll(group, checked),
            onApply: ()=>monitoringExtract.apply(group),
            onClose: ()=>monitoringExtract.close(group),
            onRetry: ()=>monitoringExtract.run([
                    group
                ]),
            onCatalog: (key, choice)=>monitoringExtract.chooseCatalog(group, key, choice),
            style: style
        });
    // An unmatched proposal is searched for by hand, in the picker right below.
    const searchRxPicker = (0, $acw62.useCallback)((query)=>{
        setRxSearchRequest({
            query: query || '',
            nonce: Date.now()
        });
        document.querySelector('[data-testid="visit-rx-picker"]')?.scrollIntoView?.({
            block: 'nearest',
            behavior: 'smooth'
        });
    }, []);
    // ── تجویز مجدد — refill from the record rail or a past visit ───────────────
    // One entry point for both refill sources: a current medication on the
    // record rail and a drug prescribed in a previous visit (history sheet).
    // The previous dosing rides along as the new row's defaults, so the doctor
    // lands on an editable نسخه row instead of re-typing the drug. The product is
    // the one the line was written from, looked up by its id (refillDrugFor) — a
    // match by name put another strength or product on the نسخه (K1, 2026-10-03);
    // only a line with no id is matched by name, and a miss keeps the doctor's
    // text under a synthesized id.
    const represcribeMed = (0, $acw62.useCallback)(async (med)=>{
        const src = (0, $85jFj.refillSourceFromMedication)(med);
        if (!src) return;
        const nameKey = src.name.toLowerCase();
        const drug = await (0, $6xvbB.refillDrugFor)(src);
        setRxItems((prev)=>prev.some((r)=>r.drug.id === drug.id || (r.drug.name || '').trim().toLowerCase() === nameKey) ? prev : [
                ...prev,
                makeRxItem(drug, {
                    // `|| undefined` on dose/frequency so an empty source still falls
                    // back to the matched formulary entry's own first common values.
                    dosage: src.dosage || undefined,
                    frequency: src.frequency || undefined,
                    // A route stored under an older translated label («Oral») is written
                    // again as the route's value — the one the insurer codes.
                    route: (0, $eQiuG.toRouteOption)(src.route) || src.route,
                    duration: src.duration,
                    quantity: src.quantity,
                    instructions: src.instructions
                })
            ]);
        // Land the doctor where the editable row now is. The history sheet stays
        // open over it — its row flips to «در نسخه» — so several refills in a row
        // cost one click each.
        setWorkTab('rx');
    }, [
        makeRxItem
    ]);
    // Refill sources are keyed by NAME, not id: a current medication and a
    // formulary entry never share ids, and the same drug must read as «در نسخه»
    // whichever door it came through.
    const prescribedMedNames = (0, $acw62.useMemo)(()=>new Set(rxItems.map((r)=>(r.drug?.name || '').trim().toLowerCase()).filter(Boolean)), [
        rxItems
    ]);
    // «تجویز مجدد» as a batch — the picker on «داروهای جاری» and on each past
    // visit. Every chosen drug goes through the single refill, so the rows are
    // identical to one-at-a-time refills (formulary match, dosing, no duplicates).
    const represcribeMeds = (0, $acw62.useCallback)(async (meds)=>{
        await Promise.all((meds || []).map((m)=>represcribeMed(m)));
        if (meds?.length) toast.success(t('visit.rx.represcribeApplied', {
            count: meds.length
        }));
    }, [
        represcribeMed,
        t,
        toast
    ]);
    const rxAllergens = (0, $acw62.useMemo)(()=>(patient?.clinicalAllergies || []).map((a)=>a.allergen).filter(Boolean), [
        patient?.clinicalAllergies
    ]);
    // Auto-fire prescription assist when SOAP assessment is filled.
    //
    // Gated by the «نکات بالینی» switch, because that is where this answer LANDS:
    // the interaction warnings and the follow-up line it returns are cards in that
    // feed, beside the ones the insight pass produces. It is also an automatic
    // spend — 3 پارسه for every DISTINCT assessment text, so refining «A» three
    // times pays three times — which is precisely what a doctor turning the
    // automation off is asking to stop. The «پیشنهاد دارو» button in the نسخه tab
    // is untouched: that one they asked for.
    (0, $acw62.useEffect)(()=>{
        if (!autoAssistOn) return;
        const assessment = soap.a?.trim();
        if (!assessment || !patient?.id) return;
        if (assistAutoFired.current === assessment) return;
        const timer = setTimeout(()=>{
            assistAutoFired.current = assessment;
            handleAssistPrescription();
        }, 2500);
        return ()=>clearTimeout(timer);
    }, [
        soap.a,
        patient?.id,
        autoAssistOn
    ]);
    // ── AI Chat ────────────────────────────────────────────────────────────────
    // A clinical question is rarely one line, so the composer is a textarea that
    // grows with its content. It is collapsed to `auto` BEFORE measuring —
    // otherwise `scrollHeight` can only ever grow and a deleted line would leave
    // the box permanently tall. The clamp lives in CSS (`maxHeight: ASK_MAX_H`),
    // so this assignment can never exceed it and the field starts scrolling
    // inside itself at that point instead of pushing the thread off-screen.
    const askFieldRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        const el = askFieldRef.current;
        if (!el) return;
        const fit = ()=>{
            el.style.height = 'auto';
            el.style.height = `${el.scrollHeight}px`;
        };
        fit();
        // Re-wrapping (window resize, panel expand/collapse) changes the height the
        // same text needs, so the measurement is not a one-shot on value change.
        window.addEventListener('resize', fit);
        return ()=>window.removeEventListener('resize', fit);
    }, [
        aiInput,
        copilotExpanded
    ]);
    const handleAsk = async (q)=>{
        const question = q || aiInput;
        if (!question.trim()) return;
        setAiMessages((prev)=>[
                ...prev,
                {
                    role: 'user',
                    text: question
                }
            ]);
        setAiInput('');
        setAiChatLoading(true);
        try {
            const history = (0, $6xvbB.buildPatientHistory)(patient);
            const visitCtx = (0, $6xvbB.buildVisitContext)(soap, diagnosis, pendingTests);
            const conditionNames = (patient?.clinicalConditions || []).map((c)=>c.display).filter(Boolean);
            const [bffResult, citations] = await Promise.allSettled([
                (0, $eVM84.bffQuery)((0, $6xvbB.ASK_DOCTOR_QUESTION), {
                    visitId: visitId || '',
                    question: question,
                    transcriptionContext: visitCtx,
                    patientHistory: history,
                    patientId: patient?.id
                }),
                (0, $fOM5k.searchPubMed)(question, conditionNames)
            ]);
            if (bffResult.status === 'rejected') throw bffResult.reason;
            chargeVisit((0, $1yr2B.costOf)('ASK_QUESTION'), 'ask');
            setAiMessages((prev)=>[
                    ...prev,
                    {
                        role: 'ai',
                        text: bffResult.value.askDoctorQuestion.answer,
                        confidence: bffResult.value.askDoctorQuestion.confidence,
                        suggestions: bffResult.value.askDoctorQuestion.followUpSuggestions,
                        citations: citations.status === 'fulfilled' ? citations.value : []
                    }
                ]);
        } catch (e) {
            if (e?.extensions?.code === 'INSUFFICIENT_CREDITS') setCreditError(e.message);
            setAiMessages((prev)=>[
                    ...prev,
                    {
                        role: 'ai',
                        text: t('errors.ai.responseFailed'),
                        suggestions: [],
                        citations: []
                    }
                ]);
        } finally{
            setAiChatLoading(false);
        }
    };
    // ── Confirmation questions ────────────────────────────────────────────────
    const handleLoadDiagAIQuestions = async (diag)=>{
        if (diagAILoading[diag.diagnosisCode]) return;
        setDiagAILoading((prev)=>({
                ...prev,
                [diag.diagnosisCode]: true
            }));
        try {
            const history = (0, $6xvbB.buildPatientHistory)(patient);
            const visitCtx = (0, $6xvbB.buildVisitContext)(soap, diagnosis, pendingTests);
            const result = await (0, $eVM84.bffQuery)((0, $6xvbB.GENERATE_CONFIRM_Q), {
                visitId: visitId,
                patientId: patient?.id,
                differentials: [
                    {
                        diagnosisCode: diag.diagnosisCode,
                        description: diag.description
                    }
                ],
                transcriptionContext: visitCtx,
                patientHistory: history
            });
            const items = result?.generateConfirmationQuestions?.items || [];
            chargeVisit((0, $1yr2B.costOf)('CONFIRM_QUESTIONS'), 'confirmq');
            const qs = items[0]?.questions || [];
            setDiagAIQuestions((prev)=>({
                    ...prev,
                    [diag.diagnosisCode]: qs
                }));
        } catch (e) {
            if (e?.extensions?.code === 'INSUFFICIENT_CREDITS') setCreditError(e.message);
        } finally{
            setDiagAILoading((prev)=>({
                    ...prev,
                    [diag.diagnosisCode]: false
                }));
        }
    };
    // One question, one commit: picking بله/خیر writes that finding into «S»,
    // saves the note, and — only once the save has landed — closes THAT question,
    // which collapses to the finding it recorded. The panel itself stays open on
    // the questions still unanswered, so the doctor works straight down the list.
    //
    // Nothing here is keyed to the first question: every one of them takes the
    // same path. A committed question is inert (its answer is part of the note;
    // un-picking it would have to un-write prose the doctor may since have
    // edited), so re-clicking it does nothing.
    const handleAnswerDiagQuestion = async (diag, q, value)=>{
        const code = diag.diagnosisCode;
        const key = `${code}:${q.id}`;
        if (diagQSubmitting[key]) return; // in flight
        if (diagAIAnswers[code]?.[q.id]?.answer) return; // already recorded
        setDiagQSubmitting((prev)=>({
                ...prev,
                [key]: value
            }));
        setDiagQError((prev)=>{
            const next = {
                ...prev
            };
            delete next[key];
            return next;
        });
        const updated = {
            ...soapRef.current,
            s: (0, $6xvbB.appendSubjectiveFinding)(soapRef.current.s, (0, $6xvbB.questionFinding)(q, value, t))
        };
        const saved = await handleSaveSoapNote(updated);
        setDiagQSubmitting((prev)=>{
            const next = {
                ...prev
            };
            delete next[key];
            return next;
        });
        if (!saved) {
            // «S» is left untouched, the answer unrecorded, and the panel open, so the
            // doctor can retry the same question rather than lose the finding.
            setDiagQError((prev)=>({
                    ...prev,
                    [key]: t('errors.save.answer')
                }));
            return;
        }
        soapRef.current = updated;
        setSoap(updated);
        // Recording the answer is what closes this question: the panel renders an
        // answered one as the single line it wrote, with no choices left to make.
        setDiagAIAnswers((prev)=>({
                ...prev,
                [code]: {
                    ...prev[code],
                    [q.id]: {
                        answer: value
                    }
                }
            }));
    };
    // ── Add suggested med/test from summary modal ─────────────────────────────
    // The summary modal's «افزودن دارو» is gone, and with it handleAddSuggestedMed:
    // nothing called it, and what it did was write the drug as an uncoded prose
    // record — `{ text }` and a name — that no insurer could be sent (K1,
    // 2026-10-03). A drug suggested anywhere now reaches the نسخه as a structured
    // line (the AI helpers' review, or the treatment plan below).
    const handleAddSuggestedTest = (idx)=>{
        setAddedSugTests((prev)=>new Set([
                ...prev,
                idx
            ]));
    };
    // ── AI-assisted treatment plan (SOAP «P» section) ──────────────────────────
    // The plan composes all four categories in one call. The AI grounds it in the
    // whole SOAP note (S/O/A as well as the current P), the differentials the
    // doctor accepted/rejected, and the patient's longitudinal history — so we send
    // SOAP and differentials rather than just a diagnosis string, and let the
    // service fetch the history itself.
    //
    // The generated note is the doctor's «P» draft: it lands straight in the P
    // editor, where it is edited like any other SOAP text, and the review panel
    // below P only governs which structured items get persisted on confirm.
    const planKey = (type, name)=>`${type}:${name}`;
    const togglePlanItem = (key)=>{
        setSelectedPlanItems((prev)=>{
            const next = new Set(prev);
            if (next.has(key)) next.delete(key);
            else next.add(key);
            return next;
        });
    };
    const handleSuggestPlan = async ()=>{
        if (!patient?.id) return;
        setPlanLoading(true);
        setPlanError(null);
        try {
            const appointmentId = pmEncounterId || visitId || undefined;
            // Send rejected differentials too — a ruled-out diagnosis tells the AI what
            // NOT to work up, which is as useful as an accepted one. The service ranks
            // accepted first and labels each with its status.
            const reviewedDiffs = differential || [];
            const data = await (0, $eVM84.bffQuery)((0, $6xvbB.SUGGEST_TREATMENT_PLAN), {
                input: {
                    appointmentId: appointmentId,
                    patientId: patient.id,
                    diagnosis: soap.a || '',
                    icdCodes: (patient.clinicalConditions || []).filter((c)=>c.code).slice(0, 8).map((c)=>({
                            code: c.code,
                            description: c.display || ''
                        })),
                    age: (0, $6xvbB.aiPatientAge)(patient),
                    gender: patient.gender || '',
                    patientAllergies: (patient.clinicalAllergies || []).map((a)=>a.allergen).filter(Boolean),
                    existingMedications: rxItems.map((r)=>r.drug.name).filter(Boolean),
                    existingTests: (patient.clinicalObservations || []).map((o)=>o.display).filter(Boolean).slice(0, 10),
                    existingImaging: clinicalOrders.filter((o)=>o.orderType === 'imaging').map((o)=>o.description).filter(Boolean),
                    soapSubjective: soap.s || '',
                    soapObjective: soap.o || '',
                    soapAssessment: soap.a || '',
                    soapPlan: soap.p || '',
                    differentials: reviewedDiffs.map((d)=>({
                            diagnosisCode: d.diagnosisCode || '',
                            diagnosisName: d.description || '',
                            confidence: d.confidence || '',
                            status: d.status || 'active',
                            supportingEvidence: d.supportingEvidence || [],
                            contradictingEvidence: d.contradictingEvidence || []
                        }))
                }
            });
            const plan = data.suggestTreatmentPlan;
            if (!plan) return;
            setPlanSuggestion(plan);
            chargeVisit((0, $1yr2B.costOf)('TREATMENT_PLAN'), 'plan', t('visit.plan.ready'));
            // Preselect everything: the doctor reviews by unchecking, which is faster
            // than checking a dozen boxes.
            const preselected = new Set([
                ...(plan.medications || []).map((m)=>planKey('med', m.name)),
                ...(plan.labTests || []).map((test)=>planKey('lab', test.testName)),
                ...(plan.imagingStudies || []).map((s)=>planKey('imaging', s.studyType)),
                ...(plan.procedureOrders || []).map((p)=>planKey('procedure', p.name))
            ]);
            setSelectedPlanItems(preselected);
            // The note IS the «P» section — write it there and autosave, so the plan
            // is visible and editable in the note the moment it exists. It replaces the
            // NARRATIVE only: the managed drug/order block is owned by the reconciler
            // and is spliced back on, so generating a plan never drops the list of what
            // is already prescribed. Whatever narrative P held before is kept for
            // one-click restore rather than silently lost.
            const note = (plan.planNote || '').trim();
            if (note) {
                const prevNarrative = (0, $6xvbB.planNarrative)(soap.p);
                setPlanReplacedP(prevNarrative && prevNarrative !== note ? prevNarrative : null);
                const nextP = (0, $6xvbB.splicePlanBlock)(note, planBlock);
                setSoap((s)=>({
                        ...s,
                        p: nextP
                    }));
                await handleSaveSoapNote({
                    ...soap,
                    p: nextP
                });
            }
        } catch (e) {
            if (e?.extensions?.code === 'INSUFFICIENT_CREDITS') setCreditError(e.message);
            else {
                console.warn('suggestTreatmentPlan failed:', e);
                setPlanError(e.message || t('errors.ai.treatmentPlan'));
            }
        } finally{
            setPlanLoading(false);
        }
    };
    // Open the panel and generate on first use; afterwards the button just toggles
    // the panel so the doctor is never charged twice by a stray click. Opening on
    // a visit that is not in progress still shows the panel — it explains why the
    // generate button is disabled, which a dead AI button would not.
    const handleOpenPlanPanel = ()=>{
        if (planPanelOpen) {
            setPlanPanelOpen(false);
            return;
        }
        setPlanPanelOpen(true);
        if (!planSuggestion && !planLoading && patient?.id && visitStatus === 'inprogress') handleSuggestPlan();
    };
    // Undo a generation that overwrote the doctor's own «P» narrative. The managed
    // block rides along untouched — it describes what is prescribed, which the undo
    // has no business changing.
    const handleRestorePlanText = async ()=>{
        if (planReplacedP == null) return;
        const restored = (0, $6xvbB.splicePlanBlock)(planReplacedP, planBlock);
        setPlanReplacedP(null);
        setSoap((s)=>({
                ...s,
                p: restored
            }));
        await handleSaveSoapNote({
            ...soap,
            p: restored
        });
    };
    // Persist the checked items, then the note, then flip the plan to confirmed.
    // The confirmed plan is the visit's output, so applying it also propagates
    // into the work area: meds land in the نسخه (rxItems) and orders go through the
    // same createOrder rail as the manual دستورات form (live list + pendingTests
    // mirror, so the printed نسخه and the end-of-visit doctor-order flush keep
    // working). The plan text itself is the SOAP «P» the doctor is looking at —
    // it was written there at generation time, so confirming files that text as
    // the visit's treatment plan rather than appending a second summary to it.
    const handleApplyPlan = async ()=>{
        const appointmentId = pmEncounterId || visitId;
        if (!patient?.id || !appointmentId || !planSuggestion) return;
        setPlanSaving(true);
        setPlanError(null);
        const failures = [];
        try {
            // 1) Medications → the نسخه, ONE structured line each (K1, 2026-10-03).
            // They were written as a prose record — a name and `{ text }`, which no
            // insurer can be sent — AND mirrored as a `plan-med-` line carrying the AI's
            // raw dose, so the e-prescription listed every plan drug twice. They now
            // take the AI helpers' path: the drug-list product the name stands for
            // (matchFormularyDrug), the plan's sig held to the closed lists
            // (closedListDefaults), one line (makeRxItem) — written to the record with
            // the rest of the نسخه, exactly as a line the doctor added (writeNow).
            const meds = (planSuggestion.medications || []).filter((m)=>selectedPlanItems.has(planKey('med', m.name)));
            const matched = [];
            const unmatched = [];
            for (const m of meds){
                let drug = null;
                try {
                    drug = await (0, $6xvbB.matchFormularyDrug)(m.name);
                } catch (e) {
                    console.warn('plan: drug-list lookup failed:', e.message);
                }
                if (!drug) {
                    // No product the list settles. The line keeps the plan's name — on the
                    // نسخه, not silently dropped — and the doctor is told to choose the
                    // product, without which no insurer will take it.
                    unmatched.push(m.name);
                    drug = {
                        id: `plan-med-${m.name}`,
                        name: m.name,
                        genericName: '',
                        category: '',
                        commonDosages: [],
                        commonFrequencies: []
                    };
                }
                matched.push({
                    m: m,
                    drug: drug
                });
            }
            // What the plan leaves empty comes from the doctor's last directions for
            // the product, before the product's own defaults (PM-0574).
            await rxMemory.request(matched.filter((x)=>!String(x.drug.id).startsWith('plan-med-')).map((x)=>x.drug.id));
            const planLines = matched.map(({ m: m, drug: drug }, i)=>{
                const sig = (0, $eQiuG.fillFromMemory)((0, $eQiuG.closedListDefaults)(drug, {
                    dosage: m.dosage,
                    frequency: m.frequency,
                    duration: m.duration,
                    instructions: m.notes
                }, rxLists), rxMemory.usualOf(drug.id));
                // The plan names no route: the product's own, read from its name.
                return makeRxItem(drug, {
                    ...sig,
                    route: sig.route || (0, $eQiuG.autoRouteFor)(drug)
                }, i);
            });
            const planFresh = planLines.filter((l, i)=>!(0, $8qEaX.isAlreadyPrescribed)(rxItemsRef.current, l.drug) && !planLines.slice(0, i).some((p)=>p.drug.id === l.drug.id));
            if (planFresh.length) {
                setRxItems((prev)=>[
                        ...prev,
                        ...planFresh
                    ]);
                await rxPersistence.writeNow(planFresh);
            }
            if (unmatched.length) toast.warn(t('visit.rx.planUnmatched', {
                names: formatList(unmatched)
            }));
            // 2) Lab / imaging / procedure → encounter orders, one createOrder per
            // item like the manual form (updates the دستورات list in place). A catalog
            // match attaches the id/code linkage that enables in-house performance.
            const orderItems = [];
            (planSuggestion.labTests || []).forEach((test)=>{
                if (selectedPlanItems.has(planKey('lab', test.testName))) orderItems.push({
                    type: 'lab',
                    name: test.testName,
                    code: test.loincCode || '',
                    reason: test.reason || '',
                    urgency: test.urgency || 'routine',
                    label: t('patient.orderType.lab')
                });
            });
            (planSuggestion.imagingStudies || []).forEach((s)=>{
                if (selectedPlanItems.has(planKey('imaging', s.studyType))) orderItems.push({
                    type: 'imaging',
                    name: s.studyType,
                    code: '',
                    reason: [
                        s.bodyPart,
                        s.reason
                    ].filter(Boolean).join(" \u2014 "),
                    urgency: s.urgency || 'routine',
                    label: t('visit.orders.imaging')
                });
            });
            (planSuggestion.procedureOrders || []).forEach((p)=>{
                if (selectedPlanItems.has(planKey('procedure', p.name))) orderItems.push({
                    type: 'procedure',
                    name: p.name,
                    code: p.code || '',
                    reason: p.reason || '',
                    urgency: p.urgency || 'routine',
                    label: t('visit.orders.procedure')
                });
            });
            // The plan proposes services as free text, and each one has to find its
            // catalogue row before it can be billed — the linkage the «انجام» button
            // and the invoice both read. That match used to run against a resident
            // catalogue; it is now one lookup per type, and a name that answers to two
            // services resolves to NOTHING rather than to the wrong one.
            const planMatches = new Map();
            for (const type of [
                ...new Set(orderItems.map((o)=>o.type))
            ]){
                const names = orderItems.filter((o)=>o.type === type).map((o)=>o.name);
                try {
                    const rows = await (0, $6xvbB.resolveOrderCatalog)({
                        names: names,
                        orderType: type,
                        appointmentId: pmEncounterId || visitId
                    });
                    for (const r of rows)planMatches.set(`${type}:${r.matchedName || r.name}`, r);
                } catch (err) {
                    // An unmatched plan order is still created — it just carries no
                    // catalogue linkage, exactly as a hand-typed order does.
                    console.error('plan catalogue match failed:', err);
                }
            }
            const createdOrders = [];
            for (const o of orderItems){
                const hit = planMatches.get(`${o.type}:${o.name}`);
                const cat = hit && {
                    code: hit.code || '',
                    catalogId: hit.id,
                    loincCode: hit.codeSystem === 'LOINC' ? hit.code || '' : ''
                };
                const created = await handleCreateOrder({
                    type: o.type,
                    urgency: o.urgency,
                    name: o.name,
                    notes: o.reason,
                    code: cat?.code || o.code || '',
                    catalogId: cat?.catalogId || null
                });
                if (created) {
                    createdOrders.push(created);
                    mirrorOrderToPendingTests({
                        type: o.type,
                        name: o.name,
                        urgency: o.urgency,
                        reason: o.reason,
                        code: cat?.code || o.code || '',
                        loincCode: cat?.loincCode || o.code || ''
                    }, {
                        savedToBackend: true
                    });
                } else failures.push(o.name);
            }
            // 3) The plan text is the SOAP «P» the doctor just reviewed — narrative
            // plus the managed block. Reconcile once more before filing so the block
            // reflects the items this very confirm just created, cancel any debounced
            // write so it cannot land after (and overwrite) this one, and save
            // synchronously. `aiGenerated` compares the NARRATIVE: the block is always
            // machine-written, so including it would make the flag permanently true.
            // The orders this confirm just created are taken from the calls themselves,
            // not from clinicalOrdersRef: that ref is only as fresh as the last RENDER,
            // and nothing guarantees one happened between the final create and this
            // line. When it had not, the block was filed WITHOUT the orders — the plan
            // note in the record then disagreed with the orders on the chart, silently.
            const justCreated = createdOrders.filter(Boolean);
            const ordersForBlock = [
                ...justCreated,
                ...clinicalOrdersRef.current.filter((o)=>!justCreated.some((c)=>c?.id === o?.id))
            ];
            // The same for the lines this confirm put on the نسخه.
            const rxForBlock = [
                ...rxItemsRef.current.filter((r)=>!planFresh.some((l)=>l.id === r.id)),
                ...planFresh
            ];
            const freshBlock = (0, $6xvbB.buildPlanBlock)({
                rxItems: rxForBlock,
                orders: ordersForBlock,
                orderNameEn: orderNameEn
            });
            const planNote = (0, $6xvbB.splicePlanBlock)(soap.p, freshBlock).trim();
            if (planNote) {
                clearTimeout(planSaveTimer.current);
                const nextSoap = {
                    ...soap,
                    p: planNote
                };
                setSoap(nextSoap);
                await handleSaveSoapNote(nextSoap);
                await (0, $eVM84.bffMutation)((0, $6xvbB.SAVE_TREATMENT_PLAN_NOTE), {
                    appointmentId: appointmentId,
                    patientId: patient.id,
                    planNote: planNote,
                    aiGenerated: (0, $6xvbB.planNarrative)(planNote) === (planSuggestion.planNote || '').trim()
                });
            }
            // 4) Confirm. A plan with no note is still a valid plan.
            const res = await (0, $eVM84.bffMutation)((0, $6xvbB.CONFIRM_TREATMENT_PLAN), {
                appointmentId: appointmentId
            });
            setPlanStatus(res.confirmTreatmentPlan?.status || 'confirmed');
            setPlanReplacedP(null);
            if (failures.length) setPlanError(t('visit.plan.partialFailure', {
                items: formatList(failures)
            }));
        } catch (e) {
            console.warn('plan: confirm failed:', e);
            setPlanError(e.message || t('errors.save.treatmentPlan'));
        } finally{
            setPlanSaving(false);
        }
    };
    // Load an already-saved plan once the visit is known, so a resumed visit shows
    // «تأییدشده» on the P section instead of offering to generate a second plan.
    // The SOAP note is the authority for the P text; the stored plan note is only
    // a fallback for the case where the note was lost but the plan survived.
    const planTabLoaded = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        const appointmentId = pmEncounterId || visitId;
        if (planTabLoaded.current || !appointmentId || !patient?.id) return;
        planTabLoaded.current = true;
        (0, $eVM84.bffQuery)((0, $6xvbB.GET_TREATMENT_PLAN), {
            appointmentId: appointmentId,
            patientId: patient.id
        }).then((data)=>{
            const plan = data?.treatmentPlan;
            if (!plan?.exists) return;
            setPlanStatus(plan.status || 'draft');
            if (plan.planNote) setSoap((s)=>(s.p || '').trim() ? s : {
                    ...s,
                    p: plan.planNote
                });
        }).catch((e)=>console.warn('treatmentPlan load failed:', e.message));
    }, [
        pmEncounterId,
        visitId,
        patient?.id
    ]);
    // ── Mid-visit SOAP save ───────────────────────────────────────────────────
    // ── Vitals ────────────────────────────────────────────────────────────────
    const handleSaveVitals = async ()=>{
        if (!patient?.id) return;
        // ── Validation: plausible physiological ranges; reject nonsensical input ──
        const RANGES = {
            bpSys: {
                min: 40,
                max: 300,
                label: t('patient.vitals.systolic')
            },
            bpDia: {
                min: 20,
                max: 200,
                label: t('patient.vitals.diastolic')
            },
            pulse: {
                min: 20,
                max: 300,
                label: t('patient.vitals.hr')
            },
            spo2: {
                min: 50,
                max: 100,
                label: t('patient.vitals.spo2')
            },
            temp: {
                min: 30,
                max: 45,
                label: t('patient.vitals.bodyTemp')
            },
            weight: {
                min: 1,
                max: 500,
                label: t('patient.vitals.wt')
            }
        };
        const errors = [];
        for (const [key, r] of Object.entries(RANGES)){
            const raw = vitals[key];
            if (raw === '' || raw == null) continue;
            const n = Number(raw);
            if (!Number.isFinite(n)) {
                errors.push(t('visit.vitals.notNumeric', {
                    field: r.label
                }));
                continue;
            }
            if (n < r.min || n > r.max) errors.push(t('visit.vitals.outOfRange', {
                field: r.label,
                min: r.min,
                max: r.max
            }));
        }
        // Cross-field: systolic must exceed diastolic when both are entered
        if (vitals.bpSys && vitals.bpDia && Number.isFinite(Number(vitals.bpSys)) && Number.isFinite(Number(vitals.bpDia)) && Number(vitals.bpSys) <= Number(vitals.bpDia)) errors.push(t('visit.vitals.bpOrder'));
        if (errors.length) {
            setVitalsError(errors);
            return;
        }
        const today = new Date().toISOString().split('T')[0];
        const entries = [
            vitals.bpSys && {
                code: '8480-6',
                display: t('patient.vitals.systolic'),
                value: vitals.bpSys,
                unit: 'mmHg'
            },
            vitals.bpDia && {
                code: '8462-4',
                display: t('patient.vitals.diastolic'),
                value: vitals.bpDia,
                unit: 'mmHg'
            },
            vitals.pulse && {
                code: '8867-4',
                display: t('patient.vitals.hr'),
                value: vitals.pulse,
                unit: 'bpm'
            },
            vitals.spo2 && {
                code: '59408-5',
                display: t('patient.vitals.spo2'),
                value: vitals.spo2,
                unit: '%'
            },
            vitals.temp && {
                code: '8310-5',
                display: t('patient.vitals.bodyTemp'),
                value: vitals.temp,
                unit: "\xb0C"
            },
            vitals.weight && {
                code: '29463-7',
                display: t('patient.vitals.wt'),
                value: vitals.weight,
                unit: 'kg'
            }
        ].filter(Boolean);
        if (!entries.length) {
            setVitalsError([
                t('validation.atLeastOneValue')
            ]);
            return;
        }
        setVitalsError(null);
        setVitalsLoading(true);
        try {
            // On edit: delete this encounter's existing vitals first to avoid duplicates
            if (savedVitalIds.current.length) {
                await Promise.allSettled(savedVitalIds.current.map((id)=>(0, $eVM84.bffMutation)((0, $6xvbB.DELETE_OBSERVATION), {
                        id: id
                    })));
                savedVitalIds.current = [];
            }
            const results = await Promise.all(entries.map((e)=>(0, $eVM84.bffMutation)((0, $6xvbB.ADD_OBSERVATION), {
                    patientId: patient.id,
                    input: {
                        code: e.code,
                        display: e.display,
                        value: e.value,
                        unit: e.unit,
                        status: 'NORMAL',
                        effectiveDate: today,
                        appointmentId: pmEncounterId || visitId || undefined
                    }
                })));
            // Store the new IDs so editing again can delete them
            savedVitalIds.current = results.map((r)=>r?.addObservation?.id).filter(Boolean);
            // What's on screen is now the encounter's record: no re-adoption on refetch.
            vitalsSeeded.current = String(pmEncounterId || visitId || '');
            setVitalsMode('saved');
            const spo2Limit = ai.spo2Threshold ?? 95;
            const bpLimit = ai.bpSystolicThreshold ?? 140;
            const alerts = [];
            if (vitals.spo2 && Number(vitals.spo2) < spo2Limit) alerts.push(t('visit.vitals.spo2Alert', {
                value: vitals.spo2,
                limit: spo2Limit
            }));
            if (vitals.bpSys && Number(vitals.bpSys) > bpLimit) alerts.push(t('visit.vitals.bpAlert', {
                value: vitals.bpSys,
                limit: bpLimit
            }));
            if (alerts.length) {
                const isCritical = vitals.spo2 && Number(vitals.spo2) < spo2Limit - 5 || vitals.bpSys && Number(vitals.bpSys) > bpLimit + 20;
                if (isCritical ? ai.interruptOnCritical !== false : ai.interruptOnWarning !== false) setVitalsAlert({
                    level: isCritical ? 'critical' : 'warning',
                    messages: alerts
                });
            }
            refreshPatient();
        } catch (e) {
            console.warn('saveVitals error:', e);
        } finally{
            setVitalsLoading(false);
        }
    };
    // ── Helpers ────────────────────────────────────────────────────────────────
    const patientConditions = (patient?.clinicalConditions || []).map((c)=>c.display);
    // Record-column lists, hoisted out of the JSX so the rail (preview slice) and
    // the full-list sheets render from the same source.
    const currentMeds = (()=>{
        const seenIds = new Set();
        const seenNames = new Set();
        return (patient?.clinicalMedications || []).filter((m)=>{
            if (m.status !== 'active' && m.status !== 'on-hold') return false;
            const nm = (m.display || '').trim().toLowerCase();
            if (removedMedNames.has(nm)) return false;
            if (seenIds.has(m.id)) return false;
            if (nm && seenNames.has(nm)) return false;
            seenIds.add(m.id);
            if (nm) seenNames.add(nm);
            return true;
        });
    })();
    const activeConds = (patient?.clinicalConditions || []).filter((c)=>c.clinicalStatus === 'active' && !removedCondIds.has(c.id));
    const labObsAll = (patient?.clinicalObservations || []).filter((o)=>!(0, $gq4TR.VITAL_LOINC_SET).has(o.code)) // vitals are not lab results
    .slice().sort((a, b)=>{
        // Abnormal/critical first, then by date desc
        const sA = a.status === 'CRITICAL' ? 0 : a.status === 'ABNORMAL' ? 1 : 2;
        const sB = b.status === 'CRITICAL' ? 0 : b.status === 'ABNORMAL' ? 1 : 2;
        if (sA !== sB) return sA - sB;
        return (b.effectiveDate || '').localeCompare(a.effectiveDate || '');
    });
    const labCriticalCount = labObsAll.filter((o)=>o.status === 'CRITICAL').length;
    const labAbnormalCount = labObsAll.filter((o)=>o.status === 'ABNORMAL').length;
    const rxText = rxItems.length > 0 ? rxItems.map((r)=>`\u{2022} ${(0, $g6gAc.drugDisplayName)(r.drug)}${r.dosage ? ' ' + r.dosage : ''}${r.route ? ' ' + r.route : ''}${r.frequency ? ' - ' + r.frequency : ''}${r.duration ? ' ' + t('visit.rx.forDuration', {
            duration: r.duration
        }) : ''}${r.instructions ? ' (' + r.instructions + ')' : ''}`).join('\n') : '';
    // Route-level data load → the workspace's own skeleton (top bar, record rail,
    // SOAP centre, copilot rail at their real grid), never a bare spinner (§2.4).
    if (pLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fWbIA.VisitSkeleton), null);
    const p = patient || routePatient;
    // ── Timer display ─────────────────────────────────────────────────────────
    const mm = String(Math.floor(elapsed / 60)).padStart(2, '0');
    const ss = String(elapsed % 60).padStart(2, '0');
    // ── «نکات بالینی» derived from live data ──────────────────────────────────
    // Insight only. Nothing orderable is built here — see Visit.shared.js for the
    // policy and filterClinicalInsights below for the backstop.
    const rawSuggestions = [];
    if (hints.length > 0) hints.forEach((h, i)=>{
        const text = typeof h === 'string' ? h : h.text || '';
        const hintType = typeof h === 'string' ? 'clinical_note' : h.hint_type || 'clinical_note';
        // A live hint that is really an order («CBC بده») is dropped rather than
        // shown: the doctor places tests in «دستورات» and drugs in «نسخه», and the
        // AI is prompted to reason instead of ordering.
        if (hintType === 'lab_test' || hintType === 'medication') return;
        const kind = t('visit.copilot.clinicalNote');
        // Skip if an existing card of the same kind already covers this hint
        // (Visit.shared `insightSimilarity`: Persian-folded words, not raw text).
        const isDup = rawSuggestions.some((s)=>s.kind === kind && (0, $6xvbB.insightSimilarity)(s.title, text) > (0, $6xvbB.INSIGHT_REPEAT_THRESHOLD));
        if (!isDup && text) rawSuggestions.push({
            id: `hint-${i}`,
            kind: kind,
            type: 'note',
            level: 'ok',
            conf: null,
            title: text,
            body: '',
            evidence: ''
        });
    });
    if (rxInteractions?.hasInteractions) rxInteractions.warnings.forEach((w, i)=>{
        const kindMap = {
            contraindication: t('visit.rx.contraindication'),
            allergy: t('visit.patient.allergyAlert'),
            black_box: 'Black Box FDA',
            interaction: t('visit.rx.interaction')
        };
        const kind = kindMap[w.warningType] || t('visit.rx.interaction');
        // A خفیف interaction is information, so it enters the feed as a note at the
        // same volume as every other clinical note; only شدید/متوسط raise a card
        // that looks like a warning.
        const mild = (0, $6xvbB.normalizeSeverity)(w.severity) === 'low';
        rawSuggestions.push({
            id: `ix-${i}`,
            kind: kind,
            type: mild ? 'note' : 'safety',
            level: mild ? 'ok' : 'warn',
            conf: null,
            title: w.description,
            body: w.drug ? t('visit.text.drugCondition', {
                drug: w.drug
            }) + (w.condition ? t('visit.text.condition', {
                condition: w.condition
            }) : '') : '',
            evidence: w.drugPair || w.drug || '',
            _source: w.source || null
        });
    });
    // The insight pass answers with three things at once: recommended tests,
    // recommended medications, and the clinical rationale. Only the rationale is
    // read — the other two are orders, and they reach the doctor through
    // «دستورات» and «نسخه», which is where they can actually be placed.
    if (recommendations?.clinicalRationale) rawSuggestions.push({
        id: 'rationale',
        kind: t('visit.copilot.clinicalAnalysis'),
        type: 'rationale',
        level: 'ok',
        conf: null,
        title: t('visit.copilot.patientAssessment'),
        body: recommendations.clinicalRationale,
        evidence: ''
    });
    if (aiResult) {
        if (aiResult.hasInteractions && aiResult.interactionWarnings?.length) {
            // The assist answered about the نسخه as it was when it ran. A warning that
            // names a drug the doctor has since removed is no longer true, so it is not
            // shown (warningOnRx). Skipped by index rather than filtered first, so the
            // `aiix-` ids a dismissal is keyed on stay with the same warning.
            const rxNames = (0, $g6gAc.interactionDrugNames)(rxItems);
            // «بررسی تداخل» runs the same rule engine over the same drugs; a finding
            // its card already shows is not shown a second time (interactionAlreadyShown).
            const checkedIx = rxInteractions?.hasInteractions ? rxInteractions.warnings : [];
            aiResult.interactionWarnings.forEach((w, i)=>{
                if (!(0, $g6gAc.warningOnRx)(w, rxNames)) return;
                if ((0, $6xvbB.interactionAlreadyShown)(w, checkedIx)) return;
                const kindMap = {
                    contraindication: t('visit.rx.contraindication'),
                    allergy: t('visit.patient.allergyAlert'),
                    black_box: 'Black Box FDA',
                    interaction: t('visit.rx.interaction')
                };
                const mild = (0, $6xvbB.normalizeSeverity)(w.severity) === 'low';
                rawSuggestions.push({
                    id: `aiix-${i}`,
                    kind: kindMap[w.warningType] || t('visit.rx.interaction'),
                    type: mild ? 'note' : 'safety',
                    level: mild ? 'ok' : 'warn',
                    conf: null,
                    title: w.description,
                    body: w.drug ? t('visit.text.drugCondition', {
                        drug: w.drug
                    }) + (w.condition ? t('visit.text.condition', {
                        condition: w.condition
                    }) : '') : '',
                    evidence: w.drugPair || w.drug || '',
                    _source: w.source || null
                });
            });
        }
        // `suggestedMedications` / `recommendedTests` from the same response are
        // deliberately not read here — they are the نسخه tab's AI panel and the
        // دستورات tab's suggest button respectively.
        if (aiResult.followUpTimeline) rawSuggestions.push({
            id: 'followup',
            kind: t('visit.copilot.followUpKind'),
            type: 'followup',
            level: 'ok',
            conf: null,
            title: aiResult.followUpTimeline,
            body: '',
            evidence: ''
        });
    }
    // The backstop: no producer above builds an orderable card, and this makes
    // sure a new AI response field cannot reintroduce one. See Visit.shared.js.
    // Note completion no longer injects a card here — «نکات بالینی» is insight
    // only; the note's own tab owns the completion flow (per-section previews).
    const copilotSuggestions = (0, $6xvbB.filterClinicalInsights)(rawSuggestions.filter((s)=>!dismissedSuggs.has(s.id)));
    const activeDiffs = (differential || []).filter((d)=>d.status !== 'rejected');
    const diffQuickQ = activeDiffs.length > 0 ? [
        ...activeDiffs.slice(0, 3).map((d)=>t('visit.text.confirmQuestionsPrompt', {
                diagnosis: d.description
            })),
        t('visit.plan.prompt')
    ] : (0, $6xvbB.QUICK_Q)(t);
    const handleLeaveConfirm = ()=>{
        setLeaveConfirm(false);
        const pending = pendingNavRef.current;
        pendingNavRef.current = null;
        if (!pending) return;
        leaveVisit(()=>{
            if (pending.callback) pending.callback();
            else if (pending[0] === '__back__') goBack();
            else navProp(...pending);
        });
    };
    const handleLeaveCancel = ()=>{
        setLeaveConfirm(false);
        pendingNavRef.current = null;
    };
    // A visit that failed to start says so from the copilot column (its «پایش
    // بالینی» slot) — that alert is never folded away.
    const copilotShown = copilotOpen || !!startError && visitStatus !== 'inprogress';
    // The video call's band lives at the foot of the record column, and folding
    // the column would unmount a call in progress — so a call holds it open.
    const callHoldsRecord = call.live || call.busy;
    const recordShown = recordPanelOpen || callHoldsRecord;
    const copilotDiffCount = (differential || []).filter((d)=>d.status !== 'rejected').length;
    const copilotSuggCount = copilotSuggestions.length;
    const copilotRailCount = copilotSuggCount + copilotDiffCount;
    // While the assistant is open the doctor sees what it holds, so that is the
    // baseline; only what arrives AFTER it is closed can raise the nudge.
    // (Adjusted during render, not in an effect: this sits below the loading
    // early-return, where a hook may not live.)
    if (copilotShown && (copilotSeen.sugg !== copilotSuggCount || copilotSeen.diff !== copilotDiffCount)) setCopilotSeen({
        sugg: copilotSuggCount,
        diff: copilotDiffCount
    });
    const dockNudge = copilotShown || nudgeDismissals >= $9b4ee9e6346f75da$var$NUDGE_MAX_DISMISSALS ? null : copilotDiffCount > copilotSeen.diff && copilotTabVisible.diff !== false ? {
        kind: 'diff',
        count: copilotDiffCount
    } : copilotSuggCount > copilotSeen.sugg && copilotTabVisible.sugg !== false ? {
        kind: 'sugg',
        count: copilotSuggCount
    } : null;
    const dismissDockNudge = ()=>{
        setCopilotSeen({
            sugg: copilotSuggCount,
            diff: copilotDiffCount
        });
        setNudgeDismissals((n)=>n + 1);
    };
    const viewDockNudge = ()=>{
        if (dockNudge) pickCopilotTab(dockNudge.kind);
        toggleCopilotOpen(true);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", null, (0, $6xvbB.KF) + (0, $6xvbB.CSS_VARS) + (0, $6xvbB.MOBILE_CSS)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3OnFU.default), {
        open: leaveConfirm,
        onOpenChange: (v)=>{
            if (!v) handleLeaveCancel();
        },
        title: t('visit.confirm.leaveTitle'),
        message: t('visit.confirm.leaveBody'),
        confirmLabel: t('visit.confirm.leaveConfirm'),
        cancelLabel: t('visit.confirm.leaveCancel'),
        destructive: true,
        onConfirm: handleLeaveConfirm
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3OnFU.default), {
        open: !!orderToCancel,
        onOpenChange: (v)=>{
            if (!v) setOrderToCancel(null);
        },
        title: orderToCancel ? t('visit.orders.cancelNamed', {
            name: orderToCancel.description
        }) : t('visit.orders.cancelTitle'),
        message: t('visit.orders.cancelBody'),
        confirmLabel: t('visit.orders.cancelAction'),
        cancelLabel: t('common.actions.back'),
        destructive: true,
        onConfirm: ()=>{
            if (orderToCancel) handleOrderTransition(orderToCancel.id, 'cancel');
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3OnFU.default), {
        open: !!erxLeave,
        onOpenChange: (open)=>{
            if (!open) setErxLeave(null);
        },
        title: t('visit.erx.leaveTitle'),
        description: t('visit.erx.leaveBody'),
        confirmLabel: t('common.actions.leave'),
        cancelLabel: t('visit.erx.stayLabel'),
        confirmTestId: "visit-erx-leave-ok",
        cancelTestId: "visit-erx-leave-cancel",
        "data-testid": "visit-erx-leave-confirm",
        onConfirm: ()=>{
            const next = erxLeave?.next ?? null;
            setErxLeave(null);
            setErxBusy(false);
            setErxScope(next);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-workspace",
        style: {
            display: 'grid',
            gridTemplateColumns: (0, $fWbIA.visitGridColumns)({
                contextExpanded: contextExpanded,
                copilotExpanded: copilotExpanded,
                recordOpen: recordShown,
                copilotOpen: copilotShown
            }),
            gridTemplateRows: 'auto 1fr',
            height: '100vh',
            background: 'var(--bg)',
            transition: 'grid-template-columns .22s ease',
            // The doctor's chosen face, not a pinned one — see src/constants/fonts.js.
            fontFamily: 'var(--app-font)',
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            gridColumn: '1 / -1'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $jOGbh.default), {
        "data-testid": "visit-topbar",
        onBack: ()=>visitStatus === 'inprogress' ? (pendingNavRef.current = [
                '__back__'
            ], setLeaveConfirm(true)) : goBack(),
        backLabel: t('common.actions.back'),
        avatar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                width: 40,
                height: 40,
                borderRadius: '50%',
                background: 'var(--primary)',
                color: '#fff',
                display: 'grid',
                placeItems: 'center',
                fontWeight: 700,
                fontSize: '0.9375rem'
            }
        }, p?.name?.charAt(0) || '?'),
        title: p?.name || "\u2014",
        status: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            type: "button",
            onClick: ()=>setGlanceOpen(true),
            "data-testid": "visit-record-glance",
            title: t('visit.glance.title'),
            "aria-label": t('visit.glance.title'),
            "aria-haspopup": "dialog",
            style: {
                display: 'inline-flex',
                alignItems: 'center',
                gap: 5,
                flexShrink: 0,
                padding: '4px 11px',
                borderRadius: 'var(--radius)',
                background: 'var(--primary)',
                border: 'none',
                color: '#fff',
                fontSize: '0.75rem',
                fontWeight: 700,
                fontFamily: 'inherit',
                whiteSpace: 'nowrap',
                cursor: 'pointer'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).scan, {
            width: 13,
            height: 13
        }), " ", t('visit.glance.open')), visitStatus === 'inprogress' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                display: 'inline-flex',
                alignItems: 'center',
                gap: 5,
                padding: '3px 9px',
                borderRadius: 'var(--radius)',
                background: 'var(--good-soft)',
                color: 'var(--good-ink)',
                fontSize: '0.6875rem',
                fontWeight: 700
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                width: 5,
                height: 5,
                borderRadius: '50%',
                background: 'var(--good)',
                animation: 'pulse 1.6s infinite',
                display: 'inline-block'
            }
        }), t('visit.resume.inProgress')) : visitStatus === 'finished' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                padding: '3px 9px',
                borderRadius: 'var(--radius)',
                background: 'var(--good-soft)',
                color: 'var(--good-ink)',
                fontSize: '0.6875rem',
                fontWeight: 700
            }
        }, t('visit.header.ended')) : null),
        badges: // A live call must read at a glance from anywhere on the screen —
        // the doctor may have the record rail folded away or be deep in the
        // prescription tab when they need to know the camera is on.
        call.live ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "data-testid": "visit-header-call-pill",
            style: {
                display: 'inline-flex',
                alignItems: 'center',
                gap: 6,
                padding: '3px 9px',
                borderRadius: 'var(--radius)',
                background: 'var(--accent-soft)',
                color: 'var(--accent-ink)',
                fontSize: '0.6875rem',
                fontWeight: 700
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                width: 5,
                height: 5,
                borderRadius: '50%',
                background: 'var(--accent)',
                animation: 'pulse 1.6s infinite',
                display: 'inline-block'
            }
        }), t('visit.call.headerPill')) : resumedVisit && visitStatus === 'inprogress' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                display: 'inline-flex',
                alignItems: 'center',
                gap: 6,
                padding: '3px 9px',
                borderRadius: 'var(--radius)',
                background: 'var(--warn-soft)',
                border: '1px solid var(--warn)',
                fontSize: '0.6875rem',
                color: 'var(--warn-ink)',
                fontWeight: 600
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).history, {
            width: 12,
            height: 12
        }), t('visit.resume.recovered'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            size: "icon",
            "aria-label": t('common.actions.close'),
            "data-testid": "visit-resumed-dismiss",
            className: "h-5 w-5",
            onClick: ()=>setResumedVisit(false)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).x, {
            width: 12,
            height: 12
        }))) : null,
        meta: [
            p?.age ? t('visit.patient.years', {
                count: p.age
            }) : null,
            p?.bloodType || null,
            p?.nationalId ? t('visit.patient.codeIs', {
                code: p.nationalId
            }) : null
        ]
    }, visitStatus === 'inprogress' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dXWAH.MonitoringControl), {
        recState: recState,
        recElapsed: recElapsed,
        disabled: isStopping || isConnecting,
        onToggle: isRecording ? stopMonitoring : isRecPaused ? resumeRec : startRec,
        complete: completion.allButton
    }), visitStatus === 'inprogress' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ajYTu.AutoConfirmChip), {
        items: autoConfirm.items,
        onUndo: autoConfirm.undo,
        onAcknowledge: autoConfirm.acknowledge
    }), visitStatus === 'inprogress' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "visit-header-duration",
        "aria-label": `${t('visit.header.duration')} ${formatDigits(`${mm}:${ss}`)}`,
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6,
            padding: '5px 11px',
            borderRadius: 999,
            fontSize: '0.75rem',
            fontWeight: 700,
            lineHeight: 1.6,
            whiteSpace: 'nowrap',
            background: 'var(--panel-2)',
            color: 'var(--ink)',
            border: '1px solid var(--line)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).clock, {
        width: 13,
        height: 13,
        style: {
            color: 'var(--mute)'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontWeight: 600,
            color: 'var(--mute)'
        }
    }, t('visit.header.duration')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontVariantNumeric: 'tabular-nums'
        }
    }, formatDigits(`${mm}:${ss}`))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cVuA6.default), {
        entries: coinLedger,
        total: visitCoins
    }), visitStatus === 'inprogress' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "sm",
        onClick: handleCancelEncounter,
        disabled: cancellingVisit,
        "aria-label": t('visit.header.cancelVisit'),
        "data-testid": "visit-topbar-cancel",
        className: "gap-1.5 text-destructive border-destructive/30"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).close, {
        width: 12,
        height: 12
    }), " ", cancellingVisit ? t('visit.header.cancelling') : t('visit.header.cancelVisit')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "default",
        size: "sm",
        onClick: requestEnd,
        disabled: endProgress.running,
        "data-testid": "visit-topbar-end",
        className: "gap-1.5",
        title: t('visit.header.endVisitTitle')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).stop, {
        width: 13,
        height: 13
    }), " ", t('visit.header.endVisit')))), creditError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "alert",
        "data-testid": "visit-credit-banner",
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: 12,
            background: 'var(--danger-soft)',
            borderBottom: '2px solid var(--danger)',
            padding: '8px 20px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: 6,
            fontSize: '0.85rem',
            fontWeight: 600,
            color: 'var(--danger-ink)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).alert, {
        width: 15,
        height: 15
    }), " ", t('errors.kind.insufficientCredits.title'), walletBalance !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            opacity: 0.85
        }
    }, "\xb7 ", t('visit.header.balanceLabel'), " ", (0, $3EzBq.fmtCoins)(walletBalance, formatNumber), " ", t('common.units.coin'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8
        }
    }, canBuyCredits && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        size: "sm",
        "data-testid": "visit-credit-topup",
        onClick: ()=>navProp('credits')
    }, t('credits.buyCoins')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        "aria-label": t('visit.state.dismissAlert'),
        title: t('visit.state.dismissAlert'),
        "data-testid": "visit-credit-dismiss",
        onClick: ()=>setCreditError(null),
        style: {
            display: 'grid',
            placeItems: 'center',
            width: 30,
            height: 30,
            padding: 0,
            borderRadius: 8,
            border: '1px solid var(--danger)',
            background: 'transparent',
            color: 'var(--danger-ink)',
            cursor: 'pointer',
            fontFamily: 'inherit'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).x, {
        width: 15,
        height: 15
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dXWAH.CompletionGuide), {
        steps: completion.flow.steps,
        current: completeSectionShown,
        next: completion.flow.nextFrom(completeSectionShown),
        onGo: goCompleteSection
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$export$cccda98cbc9f2aa5, {
        t: t,
        formatNumber: formatNumber,
        recordOpen: recordShown,
        recordLocked: callHoldsRecord,
        onToggleRecord: ()=>toggleRecordPanelOpen(),
        onOpenRecord: ()=>toggleRecordPanelOpen(true),
        copilotOpen: copilotShown,
        copilotLocked: copilotShown && !copilotOpen,
        onToggleCopilot: ()=>toggleCopilotOpen(),
        onOpenCopilot: ()=>toggleCopilotOpen(true),
        copilotCount: copilotRailCount,
        allergyCount: p?.allergies?.length || 0,
        allergyTitle: p?.allergies?.length ? `${t('visit.patient.allergyAlert')}: ${formatList(p.allergies)}` : '',
        showCall: !!call.available,
        lowBalance: walletBalance !== null && (0, $jTCZr.creditLevel)(walletBalance) === 'low',
        canBuyCredits: canBuyCredits,
        nudge: dockNudge,
        onNudgeView: viewDockNudge,
        onNudgeDismiss: dismissDockNudge,
        erxAvailable: erxAvailable,
        erxOpen: erxOpen,
        onToggleErx: ()=>changeErxScope(erxScopeRef.current !== null ? null : 'ALL'),
        erxPendingCount: erxPending.ALL
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            gridRow: 2,
            gridColumn: 4,
            background: 'var(--panel)',
            borderInlineStart: '1px solid var(--line)',
            display: copilotShown ? 'flex' : 'none',
            flexDirection: 'column',
            minHeight: 0,
            minWidth: 0
        }
    }, copilotShown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '14px 16px 10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderBottom: '1px solid var(--line)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            fontWeight: 600,
            fontSize: '0.8125rem',
            color: 'var(--ink)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: ()=>setCopilotExpanded((v)=>!v),
        title: copilotExpanded ? t('visit.panel.collapse') : t('visit.panel.expand'),
        "aria-label": copilotExpanded ? t('visit.panel.collapseCopilot') : t('visit.panel.expandCopilot'),
        "aria-pressed": copilotExpanded,
        style: {
            width: 24,
            height: 24,
            borderRadius: 6,
            flexShrink: 0,
            display: 'grid',
            placeItems: 'center',
            cursor: 'pointer',
            fontFamily: 'inherit',
            border: '1px solid var(--line)',
            background: copilotExpanded ? 'var(--accent-soft)' : 'var(--panel-2)',
            color: copilotExpanded ? 'var(--accent-ink)' : 'var(--mute)'
        }
    }, copilotExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).arrow, {
        width: 14,
        height: 14
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).back, {
        width: 14,
        height: 14
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: 7,
            height: 7,
            borderRadius: '50%',
            background: visitStatus === 'inprogress' ? 'var(--good)' : 'var(--mute-2)',
            display: 'inline-block',
            boxShadow: visitStatus === 'inprogress' ? '0 0 0 3px var(--good-soft)' : 'none'
        }
    }), t('visit.copilot.title')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.625rem',
            color: 'var(--mute)',
            fontFamily: 'monospace'
        }
    }, "AI \xb7 v2"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: ()=>toggleCopilotOpen(false),
        "data-testid": "visit-copilot-fold",
        title: t('visit.copilot.fold'),
        "aria-label": t('visit.copilot.fold'),
        style: {
            width: 24,
            height: 24,
            borderRadius: 6,
            flexShrink: 0,
            display: 'grid',
            placeItems: 'center',
            cursor: 'pointer',
            fontFamily: 'inherit',
            border: '1px solid var(--line)',
            background: 'var(--panel-2)',
            color: 'var(--mute)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).x, {
        width: 13,
        height: 13
    })))), walletBalance !== null && (0, $jTCZr.creditLevel)(walletBalance) === 'low' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-lowbalance-strip",
        style: {
            padding: '8px 12px',
            borderBottom: '1px solid var(--line)',
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            background: 'var(--warn-soft)',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).alert, {
        width: 13,
        height: 13
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            fontSize: '0.6875rem',
            fontWeight: 600,
            color: 'var(--warn-ink)'
        }
    }, t('visit.header.lowCreditPrefix'), (0, $3EzBq.fmtCoins)(walletBalance, formatNumber), " ", t('visit.header.lowCreditSuffix')), canBuyCredits && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: ()=>navProp('credits'),
        "data-testid": "visit-lowbalance-topup",
        style: {
            border: '1px solid var(--warn)',
            color: 'var(--warn-ink)',
            background: 'transparent',
            borderRadius: 6,
            padding: '2px 9px',
            fontSize: '0.65625rem',
            fontWeight: 700,
            cursor: 'pointer',
            fontFamily: 'inherit',
            whiteSpace: 'nowrap'
        }
    }, t('credits.topUp'))), startError && visitStatus !== 'inprogress' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-start-failed",
        role: "alert",
        style: {
            padding: '10px 12px',
            borderBottom: '1px solid var(--line)',
            background: 'var(--danger-soft)',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).alert, {
        width: 13,
        height: 13
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            fontSize: '0.71875rem',
            fontWeight: 700,
            color: 'var(--danger-ink)'
        }
    }, t('visit.start.failed')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "sm",
        "data-testid": "visit-start-retry",
        onClick: handleStart,
        className: "h-7 gap-1.5 text-[0.65625rem]"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).reload, {
        width: 11,
        height: 11
    }), " ", t('visit.start.retry'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.65625rem',
            color: 'var(--mute)',
            marginTop: 5,
            lineHeight: 1.7
        }
    }, t(`${(0, $cwVZP.kindKey)((0, $cwVZP.classifyError)(startError))}.body`)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.65625rem',
            color: 'var(--mute)',
            marginTop: 3,
            lineHeight: 1.7
        }
    }, t('visit.start.failedHint'))), visitStatus === 'inprogress' && isRecPaused && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-recording-interrupted",
        role: "status",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '8px 12px',
            borderBottom: '1px solid var(--line)',
            background: 'oklch(0.97 0.04 85)',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            fontSize: '0.6875rem',
            fontWeight: 600,
            color: 'oklch(0.45 0.09 70)'
        }
    }, t('visit.record.interrupted')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        "data-testid": "visit-recording-dismiss",
        onClick: dismissPause,
        style: {
            background: 'transparent',
            border: 'none',
            color: 'oklch(0.45 0.09 70)',
            fontSize: '0.6875rem',
            fontWeight: 600,
            cursor: 'pointer',
            fontFamily: 'inherit'
        }
    }, t('common.actions.dismiss'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            borderBottom: '1px solid var(--line)',
            background: 'var(--panel)',
            flexShrink: 0
        }
    }, [
        {
            id: 'sugg',
            label: t('visit.copilot.clinicalNotes'),
            count: copilotSuggestions.length
        },
        {
            id: 'diff',
            label: t('visit.copilot.differential'),
            count: (differential || []).filter((d)=>d.status !== 'rejected').length
        },
        // «برنامه درمانی» is not a copilot tab: the plan is generated,
        // reviewed and filed from the SOAP «P» section in the work area.
        {
            id: 'ask',
            label: t('visit.copilot.ask'),
            count: 0
        }
    ].filter((tab)=>copilotTabVisible[tab.id] !== false || copilotTab === tab.id).map((tab)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: tab.id,
            "data-testid": `visit-copilot-tab-${tab.id}`,
            onClick: ()=>pickCopilotTab(tab.id),
            style: {
                flex: 1,
                padding: '10px 6px',
                fontSize: '0.6875rem',
                fontWeight: 500,
                color: copilotTab === tab.id ? 'var(--ink)' : 'var(--mute)',
                borderBottom: copilotTab === tab.id ? '2px solid var(--ink)' : '2px solid transparent',
                background: 'none',
                borderTop: 'none',
                borderInlineEnd: 'none',
                borderInlineStart: 'none',
                borderBottom: copilotTab === tab.id ? '2px solid var(--ink)' : '2px solid transparent',
                cursor: 'pointer',
                fontFamily: 'inherit',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 5
            }
        }, tab.label, tab.count > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.5625rem',
                fontWeight: 700,
                padding: '1px 5px',
                borderRadius: 4,
                background: copilotTab === tab.id ? 'var(--accent-soft)' : 'var(--line)',
                color: copilotTab === tab.id ? 'var(--accent-ink)' : 'var(--ink-2)'
            }
        }, tab.count)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            overflowY: 'auto',
            padding: 12
        }
    }, copilotTab === 'sugg' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, recsLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.75rem',
            color: 'var(--mute)',
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            padding: '10px 0'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 11,
            height: 11,
            border: '2px solid var(--line)',
            borderTopColor: 'var(--accent)',
            borderRadius: '50%',
            animation: 'spin .7s linear infinite'
        }
    }), t('visit.copilot.loadingNotes')), copilotSuggestions.length === 0 && !recsLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-sugg-empty",
        style: {
            textAlign: 'center',
            padding: '32px 12px',
            color: 'var(--mute)',
            fontSize: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 36,
            height: 36,
            borderRadius: 9,
            background: 'var(--line)',
            display: 'grid',
            placeItems: 'center',
            margin: '0 auto 10px',
            color: 'var(--mute)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).sparkle, null)), recsError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            lineHeight: 1.8,
            color: 'var(--danger)'
        }
    }, recsError), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "sm",
        style: {
            marginTop: 10
        },
        "data-testid": "visit-sugg-run",
        onClick: runRecommendations
    }, t('common.actions.retry'))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            lineHeight: 1.8
        }
    }, recsRan ? t('errors.empty.clinicalNotes') : t('visit.copilot.autoRunOff')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "sm",
        style: {
            marginTop: 10
        },
        className: "gap-1.5",
        "data-testid": "visit-sugg-run",
        onClick: runRecommendations
    }, t('visit.copilot.getClinicalNotes')))), copilotSuggestions.map((s, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: (s.id || s.title) + '_' + i,
            style: {
                background: s.level === 'warn' ? 'linear-gradient(180deg,var(--warn-soft),var(--panel-2) 60%)' : 'var(--panel-2)',
                border: `1px solid ${s.level === 'warn' ? 'oklch(0.85 0.06 55)' : 'var(--line)'}`,
                borderRadius: 9,
                padding: '11px 12px',
                marginBottom: 8
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 7,
                marginBottom: 6
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.5625rem',
                fontWeight: 700,
                letterSpacing: '.04em',
                textTransform: 'uppercase',
                padding: '2px 6px',
                borderRadius: 4,
                background: s.level === 'warn' ? 'var(--warn-soft)' : 'var(--accent-soft)',
                color: s.level === 'warn' ? 'oklch(0.42 0.12 50)' : 'var(--accent-ink)'
            }
        }, s.kind), s.conf != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.625rem',
                color: 'var(--mute)',
                fontFamily: 'monospace',
                marginInlineStart: 'auto'
            }
        }, Math.round(s.conf * 100), "%")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.78125rem',
                fontWeight: 600,
                color: 'var(--ink)',
                marginBottom: 3,
                lineHeight: 1.45
            }
        }, s.title), s.body && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.75rem',
                color: 'var(--ink-2)',
                lineHeight: 1.65,
                marginBottom: 5,
                whiteSpace: 'pre-line'
            }
        }, s.body), s.evidence && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.6875rem',
                color: 'var(--mute)',
                marginTop: 5,
                padding: '5px 8px',
                borderRadius: 5,
                background: 'rgba(0,0,0,.025)',
                border: '1px dashed var(--line)',
                lineHeight: 1.5
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("b", {
            style: {
                color: 'var(--ink-2)'
            }
        }, t('visit.copilot.evidence'), " "), s.evidence)))), copilotTab === 'diff' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            marginBottom: 10
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.5625rem',
            fontWeight: 700,
            letterSpacing: '.04em',
            padding: '2px 6px',
            borderRadius: 4,
            background: 'var(--accent-soft)',
            color: 'var(--accent-ink)'
        }
    }, t('visit.copilot.fromVisitEvidence')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginInlineStart: 'auto',
            display: 'flex',
            alignItems: 'center',
            gap: 8
        }
    }, visitStatus === 'inprogress' && diffReady && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        "data-testid": "visit-diff-poll-toggle",
        "data-poll-state": pollingActive ? 'on' : 'off',
        "data-poll-seconds": pollingActive ? String(pollSeconds) : undefined,
        "aria-pressed": pollingActive,
        onClick: togglePolling,
        title: pollingActive ? t('visit.copilot.pollDisable') : t('visit.copilot.pollEnable'),
        style: {
            background: pollingActive ? 'var(--accent-soft)' : 'transparent',
            border: `1px solid ${pollingActive ? 'var(--accent)' : 'var(--line)'}`,
            cursor: 'pointer',
            padding: '3px 8px',
            borderRadius: 6,
            fontSize: '0.65625rem',
            color: pollingActive ? 'var(--accent-ink)' : 'var(--mute)',
            fontFamily: 'inherit',
            display: 'flex',
            alignItems: 'center',
            gap: 4
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: 6,
            height: 6,
            borderRadius: '50%',
            background: pollingActive ? 'var(--accent)' : 'var(--mute)',
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, t('visit.copilot.pollLabel')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontWeight: 700
        },
        "data-testid": "visit-diff-poll-state"
    }, pollingActive ? (0, $3Tnyk.differentialPollLabel)(pollSeconds, t, formatNumber) : t('visit.copilot.pollOff'))), diffLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 11,
            height: 11,
            border: '2px solid var(--line)',
            borderTopColor: 'var(--accent)',
            borderRadius: '50%',
            animation: 'spin .7s linear infinite'
        }
    }), !diffLoading && visitStatus === 'inprogress' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        "data-testid": "visit-diff-refresh",
        onClick: fetchDifferential,
        disabled: !diffReady,
        title: diffReady ? t('common.actions.refresh') : t('visit.copilot.diffGate.blockedRefresh'),
        style: {
            background: 'transparent',
            border: '1px solid var(--line)',
            cursor: diffReady ? 'pointer' : 'not-allowed',
            opacity: diffReady ? 1 : 0.5,
            padding: '3px 8px',
            borderRadius: 6,
            fontSize: '0.65625rem',
            color: 'var(--mute)',
            fontFamily: 'inherit',
            display: 'flex',
            alignItems: 'center',
            gap: 4
        }
    }, t('visit.copilot.refresh')))), pollOverridden && visitStatus === 'inprogress' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-diff-poll-note",
        style: {
            marginTop: -4,
            marginBottom: 10,
            fontSize: '0.65625rem',
            color: 'var(--mute)'
        }
    }, t('visit.copilot.pollVisitOnly')), !diffReady && visitStatus === 'inprogress' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-diff-gate",
        "data-missing": diffGate.missing.join(','),
        style: {
            marginBottom: 10,
            padding: '12px 13px',
            background: 'var(--panel-2)',
            border: '1px solid var(--line)',
            borderRadius: 9
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: 8,
            marginBottom: 9
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).sparkle, {
        width: 13,
        height: 13,
        style: {
            flexShrink: 0,
            color: 'var(--accent-ink)',
            marginTop: 2
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            fontSize: '0.75rem',
            fontWeight: 600,
            color: 'var(--ink)',
            lineHeight: 1.65
        }
    }, t('visit.copilot.diffGate.title'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-diff-gate-history",
        "data-state": "todo",
        style: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: 7,
            fontSize: '0.71875rem',
            lineHeight: 1.7,
            color: 'var(--ink-2)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flexShrink: 0,
            marginTop: 5,
            width: 6,
            height: 6,
            borderRadius: '50%',
            background: 'var(--accent)'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1
        }
    }, t(`visit.copilot.diffGate.${diffGate.missing.includes('historyThin') ? 'historyThin' : 'history'}`))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-diff-gate-hint",
        style: {
            marginTop: 7,
            paddingTop: 7,
            borderTop: '1px dashed var(--line)',
            fontSize: '0.6875rem',
            lineHeight: 1.7,
            color: 'var(--mute)'
        }
    }, t('visit.copilot.diffGate.monitoringHint'))), soapDiffConfirm && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginBottom: 8,
            padding: '10px 12px',
            background: 'var(--accent-soft)',
            border: '1px solid var(--accent)',
            borderRadius: 9
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: 8,
            marginBottom: 8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).sparkle, {
        width: 13,
        height: 13,
        style: {
            flexShrink: 0,
            color: 'var(--accent-ink)',
            marginTop: 2
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            fontSize: '0.75rem',
            color: 'var(--ink)',
            lineHeight: 1.6
        }
    }, t('visit.soap.addToAssessment', {
        text: soapDiffConfirm.description
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: ()=>{
            setSoap((prev)=>{
                const updated = {
                    ...prev,
                    a: [
                        prev.a,
                        soapDiffConfirm.description
                    ].filter(Boolean).join('\n')
                };
                handleSaveSoapNote(updated);
                return updated;
            });
            setSoapDiffConfirm(null);
        },
        style: {
            flex: 1,
            padding: '5px 12px',
            borderRadius: 6,
            border: 'none',
            background: 'var(--accent)',
            color: '#fff',
            fontSize: '0.71875rem',
            fontWeight: 600,
            cursor: 'pointer',
            fontFamily: 'inherit'
        }
    }, t('common.actions.yes')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: ()=>setSoapDiffConfirm(null),
        style: {
            padding: '5px 12px',
            borderRadius: 6,
            border: '1px solid var(--line)',
            background: 'transparent',
            color: 'var(--mute)',
            fontSize: '0.71875rem',
            cursor: 'pointer',
            fontFamily: 'inherit'
        }
    }, t('common.actions.no')))), (!differential || differential.length === 0) && !diffLoading && (diffReady || visitStatus !== 'inprogress') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            textAlign: 'center',
            padding: '32px 12px',
            color: 'var(--mute)',
            fontSize: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 36,
            height: 36,
            borderRadius: 9,
            background: 'var(--line)',
            display: 'grid',
            placeItems: 'center',
            margin: '0 auto 10px',
            color: 'var(--mute)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).sparkle, null)), visitStatus === 'inprogress' ? sessionReady ? t('errors.empty.differential') : t('visit.header.preparing') : t('visit.copilot.afterStart')), (differential || []).map((d, i)=>{
        const confColor = {
            high: 'var(--good)',
            medium: 'var(--warn)',
            low: 'var(--mute)'
        }[d.confidenceScore?.level || d.confidence] || 'var(--mute)';
        const confBg = {
            high: 'var(--good-soft)',
            medium: 'var(--warn-soft)',
            low: 'var(--panel-2)'
        }[d.confidenceScore?.level || d.confidence] || 'var(--panel-2)';
        const confLabel = {
            high: t('visit.confidenceLevel.high'),
            medium: t('visit.confidenceLevel.medium'),
            low: t('visit.confidenceLevel.low')
        }[d.confidence] || d.confidence;
        const rawScore = d.confidenceScore?.score || 0;
        const confPct = Math.round(rawScore <= 1 ? rawScore * 100 : rawScore);
        const isAccepted = (0, $6xvbB.isDifferentialAccepted)(d);
        const isRejected = d.status === 'rejected';
        const acceptedType = (0, $6xvbB.diagnosisTypeForCode)(activeConds, d.diagnosisCode);
        const isAIOpen = openAIDiag === d.diagnosisCode;
        const aiQs = diagAIQuestions[d.diagnosisCode] || [];
        const aiAnswers = diagAIAnswers[d.diagnosisCode] || {};
        const aiLoading = diagAILoading[d.diagnosisCode] || false;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                background: isAccepted ? 'linear-gradient(180deg,var(--good-soft),var(--panel-2) 60%)' : 'var(--panel-2)',
                border: `1px solid ${isAccepted ? 'var(--good)' : 'var(--line)'}`,
                borderRadius: 9,
                padding: '11px 12px',
                marginBottom: 8,
                opacity: isRejected ? 0.55 : 1
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 6,
                marginBottom: 6,
                flexWrap: 'wrap'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.59375rem',
                fontWeight: 700,
                fontFamily: 'monospace',
                letterSpacing: '.03em',
                padding: '2px 6px',
                borderRadius: 4,
                background: 'var(--line)',
                color: 'var(--ink-2)',
                direction: 'ltr'
            }
        }, d.diagnosisCode), isAccepted && (acceptedType ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $i9Cif.DiagnosisTypeBadge), {
            cond: {
                verificationStatus: acceptedType
            },
            testid: `visit-diff-type-badge-${d.diagnosisCode}`
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.5625rem',
                fontWeight: 700,
                padding: '2px 6px',
                borderRadius: 4,
                background: 'var(--good-soft)',
                color: 'var(--good)'
            }
        }, t('visit.state.confirmed'))), isRejected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.5625rem',
                fontWeight: 700,
                padding: '2px 6px',
                borderRadius: 4,
                background: 'var(--panel)',
                color: 'var(--mute)'
            }
        }, t('visit.state.dismissed')), d.confidenceScore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.625rem',
                fontWeight: 700,
                color: confColor,
                fontFamily: 'monospace',
                marginInlineStart: 'auto'
            }
        }, confPct, t('visit.state.percentSign')) : confLabel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.625rem',
                fontWeight: 700,
                padding: '2px 7px',
                borderRadius: 4,
                background: confBg,
                color: confColor,
                marginInlineStart: 'auto'
            }
        }, confLabel) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.78125rem',
                fontWeight: 600,
                color: isAccepted ? 'var(--good)' : 'var(--ink)',
                lineHeight: 1.45,
                textDecoration: isRejected ? 'line-through' : 'none'
            }
        }, d.description), d.confidenceScore && !isRejected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 6,
                marginTop: 7
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "conf-bar-track",
            style: {
                flex: 1
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "conf-bar-fill",
            style: {
                width: `${confPct}%`,
                background: confColor
            }
        })), confLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.5625rem',
                color: 'var(--mute)',
                flexShrink: 0
            }
        }, t('visit.copilot.confidence'), " ", confLabel)), d.vitalSignImpact?.length > 0 && !isRejected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                marginTop: 8,
                paddingTop: 8,
                borderTop: '1px dashed var(--line)'
            },
            "data-testid": "visit-diff-vital-impact"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                ...(0, $6xvbB.SEC_LABEL),
                fontSize: '0.59375rem',
                marginBottom: 4
            }
        }, t('visit.copilot.vitalImpact.title')), d.vitalSignImpact.map((v, j)=>{
            const meta = (0, $6xvbB.vitalEffectMeta)(v.effect, t);
            const tone = {
                good: 'var(--good)',
                danger: 'var(--danger)',
                mute: 'var(--mute)'
            }[meta.tone];
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                key: j,
                style: {
                    display: 'flex',
                    gap: 6,
                    marginBottom: 3,
                    fontSize: '0.65625rem',
                    lineHeight: 1.55,
                    color: 'var(--ink-2)'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    width: 5,
                    height: 5,
                    borderRadius: '50%',
                    background: tone,
                    flexShrink: 0,
                    marginTop: 5
                }
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    fontWeight: 600,
                    color: 'var(--ink)'
                }
            }, v.vital, v.value ? ` ${v.value}` : ''), v.status && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    color: tone,
                    fontWeight: 600
                }
            }, " \xb7 ", v.status), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    color: 'var(--mute)'
                }
            }, " \xb7 ", meta.label), " \u2014 ", v.explanation));
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                gap: 6,
                marginTop: 10,
                paddingTop: 10,
                borderTop: '1px solid var(--line)'
            }
        }, !isRejected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            "data-testid": `visit-diff-accept-${d.diagnosisCode}`,
            // Opens the «نوع تشخیص» choice instead of confirming
            // outright — there is no path from this button to a
            // recorded diagnosis that skips the type. On an
            // already-accepted item the same button is how the
            // doctor CHANGES the type.
            onClick: ()=>setDiffTypePick(diffTypePick === d.diagnosisCode ? null : d.diagnosisCode),
            title: isAccepted ? t('visit.dx.type.changeTitle') : t('common.actions.confirm'),
            style: {
                flex: 1,
                padding: '5px 8px',
                borderRadius: 6,
                fontSize: '0.71875rem',
                fontWeight: 500,
                background: isAccepted ? 'var(--good-soft)' : 'var(--ink)',
                color: isAccepted ? 'var(--good)' : '#faf7f4',
                border: isAccepted ? '1px solid var(--good)' : 'none',
                cursor: 'pointer',
                fontFamily: 'inherit',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 5
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).check, {
            width: 11,
            height: 11
        }), " ", isAccepted ? t('visit.dx.type.change') : t('visit.copilot.confirmDiagnosis')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            onClick: async ()=>{
                try {
                    setDiffTypePick(null);
                    await (0, $6xvbB.trackDifferentialDecision)(diffDecisionSeqRef, async ()=>{
                        const res = await (0, $eVM84.bffMutation)((0, $6xvbB.UPDATE_DIFFERENTIAL), {
                            appointmentId: visitId,
                            diagnosisCode: d.diagnosisCode,
                            action: 'reject'
                        });
                        const updated = res.updateDifferentialItem?.items;
                        if (updated) setDifferential((prev)=>{
                            const prevMap = Object.fromEntries((prev || []).map((x)=>[
                                    x.diagnosisCode,
                                    x
                                ]));
                            return updated.map((item)=>({
                                    ...item,
                                    confidenceScore: item.confidenceScore ?? prevMap[item.diagnosisCode]?.confidenceScore
                                }));
                        });
                    });
                } catch  {}
            },
            title: t('visit.state.dismiss'),
            style: {
                padding: '5px 10px',
                borderRadius: 6,
                fontSize: '0.71875rem',
                fontWeight: 500,
                background: 'transparent',
                color: 'var(--ink-2)',
                border: '1px solid var(--line)',
                cursor: 'pointer',
                fontFamily: 'inherit',
                display: 'flex',
                alignItems: 'center',
                gap: 5
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).x, {
            width: 11,
            height: 11
        }), " ", t('visit.state.dismiss'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            "data-testid": `visit-diff-ai-${d.diagnosisCode}`,
            "aria-expanded": isAIOpen,
            onClick: ()=>{
                const next = isAIOpen ? null : d.diagnosisCode;
                setOpenAIDiag(next);
                if (next && !diagAIQuestions[d.diagnosisCode] && !aiLoading) handleLoadDiagAIQuestions(d);
            },
            title: t('visit.copilot.confirmQuestions'),
            style: {
                flex: isRejected ? 1 : undefined,
                padding: '5px 10px',
                borderRadius: 6,
                fontSize: '0.71875rem',
                fontWeight: 500,
                border: `1px solid ${isAIOpen ? 'var(--accent)' : 'var(--line)'}`,
                background: isAIOpen ? 'var(--accent-soft)' : 'transparent',
                color: isAIOpen ? 'var(--accent-ink)' : 'var(--ink-2)',
                cursor: 'pointer',
                fontFamily: 'inherit',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 5
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).sparkle, {
            width: 11,
            height: 11
        }), " ", t('visit.copilot.questions'))), diffTypePick === d.diagnosisCode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $i9Cif.DiagnosisTypeChoice), {
            testidPrefix: `visit-diff-type-${d.diagnosisCode}`,
            current: (0, $6xvbB.diagnosisTypeForCode)(activeConds, d.diagnosisCode),
            busy: diffTypeBusy,
            title: isAccepted ? t('visit.dx.type.changeTitle') : undefined,
            onCancel: ()=>setDiffTypePick(null),
            onPick: async (type)=>{
                setDiffTypeBusy(true);
                try {
                    await (0, $6xvbB.trackDifferentialDecision)(diffDecisionSeqRef, ()=>(0, $6xvbB.confirmDifferentialType)({
                            bffMutation: $eVM84.bffMutation,
                            visitId: visitId,
                            diagnosisCode: d.diagnosisCode,
                            diagnosisType: type,
                            isAccepted: isAccepted,
                            setDifferential: setDifferential
                        }));
                    setDiffTypePick(null);
                    // The chart now holds this diagnosis with its type —
                    // pull it back so the record panel and this card agree.
                    refreshPatient();
                    if (!isAccepted) setSoapDiffConfirm({
                        description: d.description,
                        diagnosisCode: d.diagnosisCode
                    });
                } catch  {}
                setDiffTypeBusy(false);
            }
        }), isAIOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": `visit-diff-qbox-${d.diagnosisCode}`,
            style: {
                marginTop: 10,
                padding: '11px 12px',
                background: 'var(--panel)',
                border: '1px solid var(--line)',
                borderRadius: 9,
                display: 'flex',
                flexDirection: 'column',
                gap: 10
            }
        }, aiLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                justifyContent: 'center',
                gap: 4,
                padding: '10px 0'
            }
        }, [
            0,
            1,
            2
        ].map((j)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                key: j,
                style: {
                    width: 6,
                    height: 6,
                    borderRadius: '50%',
                    background: 'var(--mute)',
                    animation: `pulse .9s ease ${j * .2}s infinite`
                }
            }))), !aiLoading && aiQs.map((q)=>{
            const ans = aiAnswers[q.id];
            const qKey = `${d.diagnosisCode}:${q.id}`;
            const submitting = diagQSubmitting[qKey];
            const qError = diagQError[qKey];
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                key: q.id,
                "data-testid": `visit-diff-q-${q.id}`,
                "data-state": ans?.answer ? 'answered' : 'open',
                style: {
                    border: `1.5px solid ${ans?.answer ? ans.answer === 'yes' ? 'oklch(0.72 0.18 145)' : 'oklch(0.72 0.18 30)' : qError ? 'var(--danger)' : 'var(--line)'}`,
                    borderRadius: 9,
                    padding: '9px 11px',
                    background: ans?.answer ? ans.answer === 'yes' ? 'oklch(0.96 0.05 145)' : 'oklch(0.97 0.05 30)' : 'var(--panel-2)',
                    transition: 'all .15s'
                }
            }, ans?.answer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                    fontSize: '0.71875rem',
                    fontWeight: 600,
                    color: ans.answer === 'yes' ? 'oklch(0.25 0.14 145)' : 'oklch(0.35 0.12 30)'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).check, {
                width: 11,
                height: 11
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    flex: 1
                }
            }, (0, $6xvbB.questionStatement)(q, ans.answer, t)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    fontSize: '0.625rem',
                    fontWeight: 700,
                    color: 'var(--mute)'
                }
            }, t('visit.state.recorded'))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    fontSize: '0.78125rem',
                    color: 'var(--ink)',
                    lineHeight: 1.65,
                    marginBottom: q.hint ? 3 : 7
                }
            }, q.question), q.hint && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    fontSize: '0.65625rem',
                    color: 'var(--mute)',
                    lineHeight: 1.5,
                    marginBottom: 7
                }
            }, q.hint), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gap: 5
                }
            }, [
                {
                    v: 'yes',
                    label: t('visit.state.yesTick'),
                    hue: 145
                },
                {
                    v: 'no',
                    label: t('visit.state.noCross'),
                    hue: 30
                }
            ].map(({ v: v, label: label, hue: hue })=>{
                const pending = submitting === v;
                const locked = !!submitting;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                    key: v,
                    "data-testid": `visit-diff-q-${v}-${q.id}`,
                    disabled: locked,
                    "aria-busy": pending || undefined,
                    onClick: ()=>handleAnswerDiagQuestion(d, q, v),
                    style: {
                        padding: '7px 0',
                        borderRadius: 7,
                        fontSize: '0.78125rem',
                        fontWeight: 700,
                        fontFamily: 'inherit',
                        cursor: locked ? 'default' : 'pointer',
                        transition: 'all .12s',
                        opacity: locked && !pending ? 0.5 : 1,
                        background: 'var(--panel)',
                        border: `1.5px solid ${pending ? `oklch(0.65 0.2 ${hue})` : 'var(--line)'}`,
                        color: 'var(--ink-2)'
                    }
                }, pending ? t('common.state.saving') : label);
            }))), qError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                role: "alert",
                "data-testid": `visit-diff-q-error-${q.id}`,
                style: {
                    marginTop: 6,
                    fontSize: '0.6875rem',
                    color: 'var(--danger)',
                    lineHeight: 1.5
                }
            }, qError));
        }), !aiLoading && aiQs.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            "data-testid": `visit-diff-q-reload-${d.diagnosisCode}`,
            onClick: ()=>{
                // The findings already committed stay in «S» — this
                // only drops the questions they came from.
                setDiagAIQuestions((prev)=>({
                        ...prev,
                        [d.diagnosisCode]: []
                    }));
                setDiagAIAnswers((prev)=>({
                        ...prev,
                        [d.diagnosisCode]: {}
                    }));
                setDiagQError((prev)=>Object.fromEntries(Object.entries(prev).filter(([k])=>!k.startsWith(`${d.diagnosisCode}:`))));
                handleLoadDiagAIQuestions(d);
            },
            style: {
                padding: '5px 0',
                borderRadius: 7,
                border: '1px solid var(--line)',
                background: 'transparent',
                fontSize: '0.6875rem',
                color: 'var(--mute)',
                fontFamily: 'inherit',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 5
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).reload, {
            width: 10,
            height: 10
        }), " ", t('visit.copilot.regenerateQuestions'))));
    })), copilotTab === 'ask' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 8,
            height: '100%'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, aiMessages.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            textAlign: 'center',
            padding: '28px 12px',
            color: 'var(--mute)',
            fontSize: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 36,
            height: 36,
            borderRadius: 9,
            background: 'var(--line)',
            display: 'grid',
            placeItems: 'center',
            margin: '0 auto 10px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).ai, null)), t('visit.copilot.askOrQuick')), aiMessages.map((m, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                animation: 'fadeUp .2s ease'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                padding: '9px 12px',
                borderRadius: 9,
                fontSize: '0.78125rem',
                lineHeight: 1.7,
                // The composer accepts newlines, so the bubble has to keep
                // them — otherwise a multi-line question echoes back as one
                // run-on line.
                whiteSpace: 'pre-wrap',
                background: m.role === 'user' ? 'var(--ink)' : 'var(--panel-2)',
                color: m.role === 'user' ? '#faf7f4' : 'var(--ink)',
                border: m.role === 'ai' ? '1px solid var(--line)' : 'none',
                marginInlineStart: m.role === 'user' ? 20 : 0,
                marginInlineEnd: m.role === 'ai' ? 20 : 0
            }
        }, m.text), m.role === 'ai' && m.citations?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                marginTop: 5,
                padding: '7px 10px',
                background: 'var(--panel)',
                border: '1px dashed var(--line)',
                borderRadius: 7,
                marginInlineEnd: 20
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.59375rem',
                fontWeight: 700,
                color: 'var(--mute)',
                letterSpacing: '.05em',
                textTransform: 'uppercase',
                marginBottom: 5
            }
        }, t('visit.copilot.pubmedSources')), m.citations.map((c, j)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
                key: j,
                href: c.url,
                target: "_blank",
                rel: "noreferrer",
                style: {
                    display: 'block',
                    fontSize: '0.6875rem',
                    color: 'var(--accent-ink)',
                    lineHeight: 1.45,
                    marginBottom: 4,
                    textDecoration: 'none'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    fontWeight: 600
                }
            }, c.title), c.journal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    color: 'var(--mute)',
                    fontStyle: 'italic'
                }
            }, " \xb7 ", c.journal), c.year && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    color: 'var(--mute-2)'
                }
            }, " (", c.year, ")")))), m.suggestions?.map((s, j)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                key: j,
                onClick: ()=>handleAsk(s),
                style: {
                    background: 'none',
                    border: '1px solid var(--line)',
                    borderRadius: 7,
                    padding: '4px 10px',
                    fontSize: '0.6875rem',
                    color: 'var(--accent-ink)',
                    cursor: 'pointer',
                    marginTop: 4,
                    display: 'block',
                    width: '100%',
                    textAlign: 'start',
                    fontFamily: 'inherit'
                }
            }, s)))), aiChatLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 4,
            padding: '8px 12px',
            background: 'var(--panel-2)',
            border: '1px solid var(--line)',
            borderRadius: 9,
            width: 'fit-content'
        }
    }, [
        0,
        1,
        2
    ].map((i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                width: 5,
                height: 5,
                borderRadius: '50%',
                background: 'var(--mute)',
                animation: `pulse .9s ease ${i * .2}s infinite`
            }
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: 4,
            fontSize: '0.625rem',
            fontWeight: 600,
            textTransform: 'uppercase',
            letterSpacing: '.06em',
            color: 'var(--mute-2)',
            marginBottom: 4
        }
    }, t('visit.copilot.quickQuestions')), diffQuickQ.map((q, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: i,
            onClick: ()=>handleAsk(q),
            style: {
                display: 'block',
                width: '100%',
                textAlign: 'start',
                padding: '7px 10px',
                marginBottom: 3,
                background: 'var(--panel-2)',
                border: '1px solid var(--line)',
                borderRadius: 8,
                fontSize: '0.6875rem',
                color: 'var(--ink-2)',
                cursor: 'pointer',
                fontFamily: 'inherit'
            }
        }, q))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            borderTop: '1px solid var(--line)',
            padding: '10px 12px',
            background: 'var(--panel)',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'flex-end',
            gap: 7,
            padding: '7px 11px',
            borderRadius: 9,
            background: 'var(--panel-2)',
            border: '1px solid var(--line)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("textarea", {
        ref: askFieldRef,
        value: aiInput,
        onChange: (e)=>setAiInput(e.target.value),
        onKeyDown: (e)=>{
            if (e.key !== 'Enter' || e.shiftKey) return; // Shift+Enter = newline
            // Committing Persian predictive text ends with Enter too —
            // that one is not a send.
            if (e.nativeEvent?.isComposing) return;
            e.preventDefault();
            setCopilotTab('ask');
            handleAsk();
        },
        placeholder: t('visit.copilot.askPlaceholder'),
        "aria-label": t('visit.copilot.askPlaceholder'),
        rows: 1,
        "data-testid": "visit-copilot-ask-field",
        style: {
            flex: 1,
            minWidth: 0,
            display: 'block',
            boxSizing: 'border-box',
            border: 'none',
            background: 'transparent',
            outline: 'none',
            fontSize: '0.78125rem',
            lineHeight: 1.6,
            fontFamily: 'inherit',
            color: 'var(--ink)',
            // 3px block padding makes the one-line field exactly as tall as
            // the 26px send button, so the row reads as it did before.
            padding: '3px 0',
            margin: 0,
            resize: 'none',
            maxHeight: $9b4ee9e6346f75da$var$ASK_MAX_H,
            overflowY: 'auto'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: ()=>{
            setCopilotTab('ask');
            handleAsk();
        },
        style: {
            width: 26,
            height: 26,
            flexShrink: 0,
            borderRadius: 6,
            background: 'var(--ink)',
            border: 'none',
            color: '#faf7f4',
            display: 'grid',
            placeItems: 'center',
            cursor: 'pointer'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).send, null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            marginTop: 6,
            fontSize: '0.625rem',
            color: 'var(--mute)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, t('visit.copilot.answerBasis')))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            gridRow: 2,
            gridColumn: 3,
            background: 'var(--bg)',
            display: 'flex',
            flexDirection: 'column',
            minHeight: 0,
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 0,
            padding: '0 16px',
            background: 'var(--bg)',
            borderBottom: '1px solid var(--line)',
            flexShrink: 0
        }
    }, [
        {
            id: 'soap',
            label: t('visit.tabs.soap'),
            icon: (0, $6xvbB.I).notes,
            proposals: Object.keys(soapRefine.preview || {}).filter((k)=>k !== 'p').length
        },
        {
            id: 'rx',
            label: t('visit.tabs.rx'),
            icon: (0, $6xvbB.I).pill,
            badge: rxItems.length || null,
            proposals: completion.pending.rx
        },
        {
            id: 'orders',
            label: t('visit.tabs.orders'),
            icon: (0, $6xvbB.I).doc,
            badge: clinicalOrders.filter((o)=>o.status === 'pending').length || null,
            proposals: completion.pending.orders
        },
        {
            id: 'plan',
            label: t('visit.tabs.plan'),
            icon: (0, $6xvbB.I).steth,
            proposals: soapRefine.preview?.p ? 1 : 0
        }
    ].filter(({ id: id })=>workTabVisible[id] !== false || workTab === id).map(({ id: id, label: label, icon: Ic, badge: badge, loading: loading, proposals: proposals })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: id,
            "data-testid": `visit-work-tab-${id}`,
            onClick: ()=>pickWorkTab(id),
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 6,
                padding: '11px 16px',
                fontSize: '0.875rem',
                fontWeight: workTab === id ? 600 : 400,
                color: workTab === id ? 'var(--ink)' : 'var(--mute)',
                borderBottom: workTab === id ? '2px solid var(--ink)' : '2px solid transparent',
                background: 'none',
                borderTop: 'none',
                borderInlineEnd: 'none',
                borderInlineStart: 'none',
                cursor: 'pointer',
                fontFamily: 'inherit',
                transition: 'color .12s'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Ic, null), label, loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                width: 8,
                height: 8,
                border: '1.5px solid var(--line)',
                borderTopColor: 'var(--accent)',
                borderRadius: '50%',
                animation: 'spin .7s linear infinite'
            }
        }), !loading && badge > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.625rem',
                background: 'var(--line)',
                color: 'var(--ink-2)',
                padding: '1px 5px',
                borderRadius: 4,
                fontWeight: 600
            }
        }, badge), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dXWAH.ProposalBadge), {
            count: proposals,
            testid: `visit-work-tab-proposals-${id}`
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: workBodyRef,
        "data-testid": "visit-work-body",
        style: {
            flex: 1,
            minHeight: 0,
            display: 'flex',
            position: 'relative'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: 0,
            overflowY: 'auto',
            padding: noteTab ? '18px 20px' : '18px 20px 40px',
            ...noteTab ? {
                display: 'flex',
                flexDirection: 'column'
            } : {}
        }
    }, noteTab && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `visit-note-card-${workTab}`,
        style: {
            ...(0, $6xvbB.SEC_CARD),
            flex: 1,
            display: 'flex',
            flexDirection: 'column'
        }
    }, workTab === 'plan' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: (0, $6xvbB.SEC_HEAD)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: (0, $6xvbB.SEC_TITLE)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: (0, $6xvbB.SEC_ICON)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).steth, {
        width: 12,
        height: 12
    })), t('visit.tabs.plan'))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: (0, $6xvbB.SEC_HEAD)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: (0, $6xvbB.SEC_TITLE)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: (0, $6xvbB.SEC_ICON)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).notes, {
        width: 12,
        height: 12
    })), t('visit.soap.title')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8
        }
    }, soapRefine.hasNewContent && !soapRefineLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "visit-soap-refine-newdot",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 5,
            fontSize: '0.65625rem',
            color: 'var(--accent-ink)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: 6,
            height: 6,
            borderRadius: '50%',
            background: 'var(--accent)',
            flexShrink: 0
        }
    }), t('visit.soap.refine.newContent')), soapTabProposals.length > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        "data-testid": "visit-soap-refine-apply-all",
        onClick: ()=>soapRefine.applyAll(soapTabProposals),
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 5,
            padding: '5px 11px',
            borderRadius: 999,
            border: `1px solid ${(0, $jTCZr.CT).accent}`,
            background: (0, $jTCZr.CT).accent,
            color: (0, $jTCZr.CT).surface,
            fontSize: '0.71875rem',
            fontWeight: 700,
            cursor: 'pointer',
            fontFamily: 'inherit'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).check, {
        width: 11,
        height: 11
    }), " ", t('visit.soap.refine.applyAll')))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-soap-scroll",
        style: {
            padding: '16px',
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            minHeight: 0,
            overflowY: 'auto'
        }
    }, workTab === 'soap' && soapRefine.status && soapRefine.status !== 'ok' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-soap-refine-status",
        "data-status": soapRefine.status,
        role: soapRefine.status === 'error' ? 'alert' : undefined,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            marginBottom: 12,
            padding: '8px 11px',
            borderRadius: 8,
            fontSize: '0.71875rem',
            flexShrink: 0,
            background: soapRefine.status === 'error' ? 'var(--warn-soft)' : 'var(--panel-2)',
            border: `1px solid ${soapRefine.status === 'error' ? 'oklch(0.85 0.06 55)' : 'var(--line)'}`,
            color: soapRefine.status === 'error' ? 'oklch(0.42 0.12 50)' : 'var(--ink-2)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).info, {
        width: 12,
        height: 12,
        style: {
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1
        }
    }, soapRefine.status === 'error' ? t('visit.soap.refine.error') : soapRefine.status === 'no_transcript' ? t('visit.soap.refine.noTranscript') : t('visit.soap.refine.noNew')), soapRefine.status === 'error' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        "data-testid": "visit-soap-refine-retry",
        onClick: handleSoapRefine,
        style: {
            padding: '3px 10px',
            borderRadius: 6,
            fontSize: '0.6875rem',
            fontWeight: 600,
            background: 'transparent',
            color: 'inherit',
            border: '1px solid currentColor',
            cursor: 'pointer',
            fontFamily: 'inherit'
        }
    }, t('common.actions.retry'))), [
        {
            k: 'S',
            key: 's',
            name: t('visit.soap.subjective'),
            hint: t('visit.soap.subjectiveHint'),
            ph: t('visit.soap.subjectivePlaceholder')
        },
        {
            k: 'O',
            key: 'o',
            name: t('visit.soap.objective'),
            hint: t('visit.soap.objectiveHint'),
            ph: t('visit.soap.objectivePlaceholder')
        },
        {
            k: 'A',
            key: 'a',
            name: t('visit.soap.assessment'),
            hint: t('visit.soap.assessmentHint'),
            ph: t('visit.soap.assessmentPlaceholder')
        },
        {
            k: 'P',
            key: 'p',
            name: t('visit.soap.plan'),
            hint: t('visit.soap.planHint'),
            ph: t('visit.soap.planPlaceholder')
        }
    ].filter((s)=>s.key === 'p' === (workTab === 'plan')).map((s)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: s.k,
            style: {
                marginBottom: 16,
                flex: '1 0 auto',
                display: 'flex',
                flexDirection: 'column'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                marginBottom: 7,
                flexShrink: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                width: 22,
                height: 22,
                borderRadius: '50%',
                background: 'var(--accent-soft)',
                color: 'var(--accent-ink)',
                fontFamily: 'monospace',
                fontSize: '0.6875rem',
                fontWeight: 700,
                display: 'grid',
                placeItems: 'center',
                flexShrink: 0
            }
        }, s.k), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontWeight: 600,
                fontSize: '0.8125rem',
                color: 'var(--ink)'
            }
        }, s.name), autoConfirm.live('soap', s.key) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ajYTu.AutoConfirmBadge), {
            testid: `visit-soap-auto-${s.key}`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.6875rem',
                color: 'var(--mute-2)',
                marginInlineStart: 'auto'
            }
        }, s.hint), s.key === 'p' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            className: "v-micbtn",
            "data-testid": "visit-soap-plan-ai",
            onClick: handleOpenPlanPanel,
            disabled: planLoading || planSaving || !visitId,
            "aria-expanded": planPanelOpen,
            style: {
                color: planLoading ? 'oklch(0.38 0.14 290)' : undefined
            },
            title: t('visit.plan.generate')
        }, planLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                width: 8,
                height: 8,
                border: '1.5px solid oklch(0.80 0.06 290)',
                borderTopColor: 'oklch(0.38 0.14 290)',
                borderRadius: '50%',
                animation: 'spin .7s linear infinite'
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).sparkle, {
            width: 9,
            height: 9
        }), ' ', "AI") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dXWAH.CompleteButton), {
            compact: true,
            testid: `visit-soap-complete-${s.key}`,
            title: t('visit.complete.hintPrice', {
                section: s.name,
                coins: formatNumber((0, $1yr2B.costOf)('SOAP_REFINE'))
            }),
            onClick: ()=>handleSoapFieldRefine(s.key),
            disabled: !!soapFieldRefineLoading || soapRefineLoading || !visitId,
            busy: soapFieldRefineLoading === s.key
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            ref: (el)=>{
                soapEditorRefs.current[s.key] = el;
            },
            contentEditable: true,
            suppressContentEditableWarning: true,
            "data-soap-key": s.key,
            "data-placeholder": s.ph,
            onInput: (e)=>{
                const text = e.currentTarget.textContent;
                setSoap((prev)=>({
                        ...prev,
                        [s.key]: text
                    }));
            },
            style: {
                ...(0, $6xvbB.SEC_FIELD),
                padding: '10px 12px',
                lineHeight: 1.75,
                minHeight: 72,
                // basis auto + no shrink: a short note still grows to
                // fill the work area, a long one keeps its full height
                // and scrolls the card body instead of spilling out.
                flex: '1 0 auto',
                transition: 'border-color .12s',
                textAlign: 'start',
                whiteSpace: 'pre-wrap',
                overflowWrap: 'break-word',
                cursor: 'text'
            },
            onFocus: (e)=>{
                e.currentTarget.style.background = 'var(--panel)';
                e.currentTarget.style.borderColor = 'var(--accent)';
                soapEntryTextRef.current[s.key] = e.currentTarget.textContent;
                // Hold the plan reconciler off «P» while the caret is in it.
                if (s.key === 'p') setPlanEditorFocused(true);
            },
            onBlur: async (e)=>{
                e.currentTarget.style.background = 'var(--field)';
                e.currentTarget.style.borderColor = 'var(--line)';
                const text = e.currentTarget.textContent;
                const enteredWith = soapEntryTextRef.current[s.key];
                // No entry value means this blur belongs to no editing
                // session at all — nothing was typed, so there is
                // nothing to re-read.
                const sectionChanged = enteredWith !== undefined && text !== enteredWith;
                delete soapEntryTextRef.current[s.key];
                const updated = {
                    ...soap,
                    [s.key]: text
                };
                // Releasing the field re-runs the reconciler, which
                // repairs a block the doctor edited or deleted by hand.
                if (s.key === 'p') setPlanEditorFocused(false);
                await handleSaveSoapNote(updated);
                // Re-assess on what was just written — an AUTOMATIC
                // run like any other, and the one that used to answer
                // to nothing: a doctor with every «دستیار هوشمند»
                // switch off still paid 10 پارسه for a fresh
                // differential every time they clicked out of a SOAP
                // box. «بازبینی پس از ویرایش یادداشت» governs it now,
                // under the differential master switch — NOT under the
                // timed loop, which needs a recording this path exists
                // without.
                //
                // And only when the text actually MOVED. Tabbing
                // through the four boxes, or clicking into one and out
                // again, changes nothing the AI could reason from — the
                // service would re-answer the same note, and bill for
                // it once per blur.
                if (sectionChanged && reassessOnEdit) fetchDifferential();
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7akOU.default), {
            sectionKey: s.key,
            title: s.name,
            preview: soapRefine.preview?.[s.key],
            onAccept: ()=>soapRefine.apply(s.key),
            onDismiss: ()=>soapRefine.dismiss(s.key),
            onRerun: ()=>soapRefine.refine([
                    s.key
                ]),
            busy: soapRefineLoading,
            style: {
                marginTop: 6
            }
        }), s.key === 'p' && planBlock && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": "visit-plan-block-hint",
            style: {
                marginTop: 5,
                display: 'flex',
                alignItems: 'center',
                gap: 5,
                fontSize: '0.625rem',
                color: 'var(--mute-2)'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                width: 5,
                height: 5,
                borderRadius: '50%',
                background: 'var(--good)',
                display: 'inline-block',
                flexShrink: 0
            }
        }), t('visit.plan.blockHint')), s.key === 'p' && planPanelOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$SoapPlanPanel, {
            suggestion: planSuggestion,
            loading: planLoading,
            saving: planSaving,
            status: planStatus,
            error: planError,
            selected: selectedPlanItems,
            planKey: planKey,
            onToggle: togglePlanItem,
            onConfirm: handleApplyPlan,
            onRegenerate: handleSuggestPlan,
            onClose: ()=>setPlanPanelOpen(false),
            onRestore: handleRestorePlanText,
            canRestore: planReplacedP != null,
            canGenerate: !!patient?.id && visitStatus === 'inprogress'
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            borderTop: '1px solid var(--line)',
            paddingTop: 10,
            marginTop: 4,
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            flexWrap: 'wrap',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.625rem',
            padding: '2px 8px',
            borderRadius: 20,
            background: 'var(--panel)',
            border: '1px solid var(--line)',
            color: 'var(--mute)',
            fontWeight: 500
        }
    }, t('visit.soap.draft')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 4,
            fontSize: '0.625rem',
            color: 'var(--mute)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: 5,
            height: 5,
            borderRadius: '50%',
            background: 'var(--good)',
            display: 'inline-block'
        }
    }), t('visit.soap.autosaveOn')), (pmEncounterId || visitId) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.625rem',
            padding: '2px 8px',
            borderRadius: 20,
            background: 'var(--accent-soft)',
            border: '1px solid var(--accent)',
            color: 'var(--accent-ink)',
            fontWeight: 500
        }
    }, t('visit.soap.linkedToVisit'))))), workTab === 'rx' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            ...(0, $6xvbB.SEC_CARD),
            overflow: 'visible'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: (0, $6xvbB.SEC_HEAD)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: (0, $6xvbB.SEC_TITLE)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: (0, $6xvbB.SEC_ICON)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).pill, {
        width: 12,
        height: 12
    })), t('visit.rx.forThisVisit'), rxItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: (0, $6xvbB.SEC_BADGE)
    }, rxItems.length)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cvBw3.default), {
        kind: "medication",
        allergies: (patient?.clinicalAllergies || []).map((a)=>a.allergen).filter(Boolean),
        existingDrugIds: rxItems.map((r)=>r.drug?.id).filter(Boolean),
        appointmentId: pmEncounterId || visitId,
        patientId: patient?.id,
        onApplied: handleMedicationTemplateApplied
    }), rxInteractions?.hasInteractions && !ixStale && (()=>{
        const top = (0, $6xvbB.topSeverity)(rxInteractions.warnings);
        if (top === 'low') return null;
        const high = top === 'high';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "data-testid": "visit-rx-ix-chip",
            "data-severity": top,
            style: {
                fontSize: '0.6875rem',
                padding: '2px 8px',
                borderRadius: 4,
                fontWeight: 700,
                display: 'flex',
                alignItems: 'center',
                gap: 4,
                background: high ? 'var(--danger-soft)' : 'var(--warn-soft)',
                color: high ? 'var(--danger-ink)' : 'var(--warn-ink)'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).alert, {
            width: 10,
            height: 10
        }), high ? t('visit.rx.ixHighChip') : t('visit.rx.ixMediumChip'));
    })(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: runInteractionCheck,
        disabled: !canCheckInteractions,
        "data-testid": "visit-rx-check-interactions",
        title: !interactionCheckReady ? t('visit.rx.ixNeedsDrugs') : undefined,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 5,
            padding: '5px 11px',
            borderRadius: 7,
            border: '1px solid var(--line)',
            background: 'var(--panel-2)',
            color: 'var(--ink-2)',
            fontSize: '0.71875rem',
            fontWeight: 600,
            fontFamily: 'inherit',
            cursor: canCheckInteractions ? 'pointer' : 'not-allowed',
            opacity: canCheckInteractions ? 1 : 0.55
        }
    }, interactionLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 9,
            height: 9,
            border: '1.5px solid var(--line)',
            borderTopColor: 'var(--ink-2)',
            borderRadius: '50%',
            animation: 'spin .7s linear infinite'
        }
    }), " ", t('visit.rx.checkingInteractionsShort')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).shield, {
        width: 11,
        height: 11
    }), " ", t('visit.rx.checkInteractions'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dXWAH.CompleteButton), {
        testid: "visit-rx-ai-monitoring",
        ...completion.button('rx'),
        disabled: !visitId
    }), [
        {
            source: (0, $bwSot.PROPOSAL_SOURCES).HISTORY,
            testid: 'visit-rx-ai-suggest',
            icon: (0, $6xvbB.I).sparkle,
            label: t('visit.rxAssist.history'),
            disabled: !visitId || !(0, $bwSot.sourceReady)((0, $bwSot.PROPOSAL_SOURCES).HISTORY, rxHistoryCtx),
            title: (0, $bwSot.sourceReady)((0, $bwSot.PROPOSAL_SOURCES).HISTORY, rxHistoryCtx) ? undefined : t('visit.rxAssist.historyNeeded'),
            onClick: ()=>rxAssist.run((0, $bwSot.PROPOSAL_SOURCES).HISTORY)
        },
        {
            source: 'DIRECTIONS',
            testid: 'visit-rx-ai-directions',
            icon: (0, $6xvbB.I).pill,
            label: t('visit.rx.directions.button'),
            disabled: !visitId || rxIncompleteCount === 0,
            title: rxIncompleteCount === 0 ? t('visit.rx.directions.allComplete') : t('visit.rx.directions.hint'),
            onClick: completeRxDirections,
            busy: rxDirectionsBusy
        }
    ].filter((b)=>$9b4ee9e6346f75da$var$SHOW_RX_DIRECTIONS || b.source !== 'DIRECTIONS').map((b)=>{
        const busy = b.busy !== undefined ? b.busy : rxAssist.review.phase === 'loading' && rxAssist.review.source === b.source;
        const off = b.disabled || busy;
        const Icon = b.icon;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: b.source,
            onClick: b.onClick,
            disabled: off,
            title: b.title,
            "data-testid": b.testid,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 5,
                padding: '5px 11px',
                borderRadius: 7,
                border: '1px solid oklch(0.87 0.06 290)',
                background: busy ? 'oklch(0.95 0.02 290)' : 'oklch(0.97 0.02 290)',
                color: 'oklch(0.38 0.14 290)',
                fontSize: '0.71875rem',
                fontWeight: 600,
                cursor: off ? 'not-allowed' : 'pointer',
                opacity: off ? 0.6 : 1,
                fontFamily: 'inherit',
                whiteSpace: 'nowrap'
            }
        }, busy ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                width: 9,
                height: 9,
                border: '1.5px solid oklch(0.80 0.06 290)',
                borderTopColor: 'oklch(0.38 0.14 290)',
                borderRadius: '50%',
                animation: 'spin .7s linear infinite'
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
            width: 11,
            height: 11
        }), b.label);
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: 16,
            display: 'flex',
            flexDirection: 'column',
            gap: 12
        }
    }, interactionStop && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "error",
        role: "alert",
        "data-testid": "visit-rx-interaction-stop",
        style: {
            alignItems: 'flex-start'
        },
        title: t('visit.end.stoppedForInteraction'),
        action: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                gap: 6
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "outline",
            size: "sm",
            onClick: ()=>{
                setInteractionStop(false);
                requestEnd();
            },
            "data-testid": "visit-rx-interaction-continue"
        }, t('visit.end.continueEnding')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            size: "sm",
            onClick: ()=>setInteractionStop(false),
            "aria-label": t('common.actions.close')
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).x, {
            width: 13,
            height: 13
        })))
    }, t('visit.end.stoppedForInteractionBody')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $jCgjY.default), {
        review: rxAssist.review,
        rxItems: rxItems,
        allergies: (patient?.clinicalAllergies || []).map((a)=>a.allergen).filter(Boolean),
        onToggle: rxAssist.toggle,
        onChoose: rxAssist.choose,
        onSetAll: rxAssist.setAll,
        onApply: rxAssist.apply,
        onClose: rxAssist.close,
        onRetry: ()=>rxAssist.run(rxAssist.review.source),
        onSearch: searchRxPicker
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: (0, $6xvbB.SEC_SUBCARD),
        "data-testid": "visit-rx-picker"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: (0, $6xvbB.SEC_ICON)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).plus, {
        width: 12,
        height: 12
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.78125rem',
            fontWeight: 700,
            color: 'var(--ink)'
        }
    }, t('visit.rx.addMedication'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9SQfR.default), {
        defaultsFor: rxDefaultsFor,
        memory: rxMemory.memory,
        prescribedIds: prescribedDrugIds,
        insurer: patientInsurer,
        onAdd: addDrug,
        frequent: rxFrequent,
        request: rxAddQueue[0] || null,
        onRequestDone: (req)=>setRxAddQueue((q)=>q.filter((r)=>r.key !== req.key)),
        searchRequest: rxSearchRequest,
        showKeys: true
    })), rxItems.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-rx-empty",
        "data-state": "empty"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).pill, {
            width: 40,
            height: 40
        }),
        title: t('visit.rx.noneRecorded'),
        description: t('visit.rx.emptyHint')
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-rx-list",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 8
        }
    }, rxItems.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.RxItemCard), {
            key: item.id,
            item: item,
            onChange: (key, val)=>updateDrug(item.id, key, val),
            onRemove: ()=>removeDrug(item.id),
            insurer: patientInsurer,
            erxLine: (0, $3O5pt.erxStateForRx)(item, erxIndex)
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bOPUe.ErxRemovedLines), {
        lines: erxRemovedRx
    }), interactionLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.75rem',
            color: 'var(--mute)',
            display: 'flex',
            alignItems: 'center',
            gap: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 11,
            height: 11,
            border: '2px solid var(--line)',
            borderTopColor: 'var(--warn)',
            borderRadius: '50%',
            animation: 'spin .7s linear infinite'
        }
    }), t('visit.rx.checkingInteractions')), ixError && !interactionLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-rx-ix-error",
        style: {
            background: 'var(--danger-soft)',
            border: '1px solid var(--danger)',
            borderRadius: 9,
            padding: '7px 12px',
            fontSize: '0.75rem',
            color: 'var(--danger-ink)',
            fontWeight: 600
        }
    }, t('errors.load.interactions')), rxInteractions && !interactionLoading && !ixError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 8
        },
        "data-testid": "visit-rx-ix-report"
    }, ixStale && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-rx-ix-stale",
        style: {
            background: 'var(--panel-2)',
            border: '1px dashed var(--line)',
            borderRadius: 9,
            padding: '7px 12px',
            fontSize: '0.71875rem',
            color: 'var(--mute)'
        }
    }, t('visit.rx.ixStale')), rxInteractions.hasInteractions ? (()=>{
        // One panel per severity, and the panel's whole appearance —
        // colour, border weight, icon, type weight — is set by which
        // severity it is. شدید shouts, متوسط informs, خفیف just sits
        // there as reference text.
        const groups = (0, $6xvbB.bucketWarnings)(rxInteractions.warnings);
        const line = (w, i, muted)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                key: i,
                style: {
                    fontSize: muted ? '0.71875rem' : '0.78125rem',
                    color: muted ? 'var(--ink-2)' : 'var(--ink)',
                    lineHeight: 1.65,
                    padding: '3px 0',
                    borderTop: i > 0 ? '1px solid var(--line-2)' : 'none'
                }
            }, w.drugPair && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("strong", {
                style: {
                    marginInlineEnd: 4
                }
            }, w.drugPair, ":"), w.description, w.drug && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    color: 'var(--mute)'
                }
            }, " \xb7 ", w.drug, w.condition ? ` / ${w.condition}` : ''));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, groups.high.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": "visit-rx-ix-high",
            role: "alert",
            style: {
                background: 'var(--danger-soft)',
                border: '2px solid var(--danger)',
                borderRadius: 9,
                padding: '10px 13px'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 6,
                fontWeight: 800,
                fontSize: '0.8125rem',
                color: 'var(--danger-ink)',
                marginBottom: 6
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).alert, {
            width: 14,
            height: 14
        }), t('visit.rx.ixHighTitle'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.65625rem',
                fontWeight: 700,
                padding: '1px 7px',
                borderRadius: 20,
                background: 'var(--danger)',
                color: '#fff'
            }
        }, groups.high.length)), groups.high.map((w, i)=>line(w, i, false))), groups.medium.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": "visit-rx-ix-medium",
            style: {
                background: 'var(--warn-soft)',
                border: '1px solid var(--warn)',
                borderRadius: 9,
                padding: '9px 12px'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontWeight: 700,
                fontSize: '0.75rem',
                color: 'var(--warn-ink)',
                marginBottom: 5
            }
        }, t('visit.rx.ixMediumTitle'), " (", groups.medium.length, ")"), groups.medium.map((w, i)=>line(w, i, false))), groups.low.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": "visit-rx-ix-low",
            style: {
                background: 'var(--panel-2)',
                border: '1px solid var(--line)',
                borderRadius: 9,
                padding: '8px 12px'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 5,
                fontWeight: 600,
                fontSize: '0.71875rem',
                color: 'var(--mute)',
                marginBottom: 4
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).info, {
            width: 11,
            height: 11
        }), t('visit.rx.ixLowTitle'), " (", groups.low.length, ")"), groups.low.map((w, i)=>line(w, i, true))));
    })() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: 'var(--good-soft)',
            border: '1px solid var(--good)',
            borderRadius: 9,
            padding: '7px 12px',
            fontSize: '0.75rem',
            color: 'var(--good-ink)',
            fontWeight: 600
        }
    }, t('visit.rx.noInteractions'))))), workTab === 'orders' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: (0, $6xvbB.SEC_CARD)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: (0, $6xvbB.SEC_HEAD)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: (0, $6xvbB.SEC_TITLE)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: (0, $6xvbB.SEC_ICON)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).flask, {
        width: 12,
        height: 12
    })), t('visit.orders.title'), clinicalOrders.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: (0, $6xvbB.SEC_BADGE)
    }, clinicalOrders.length)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: '1 1 0',
            minWidth: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            flexWrap: 'wrap',
            gap: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cvBw3.default), {
        kind: "order",
        appointmentId: pmEncounterId || visitId,
        patientId: patient?.id,
        onApplied: handleOrderTemplateApplied
    }), visitStatus === 'inprogress' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dXWAH.CompleteButton), {
        testid: "visit-orders-complete",
        ...completion.button('orders')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: handleSuggestEncounterOrders,
        disabled: encOrderSuggLoading || !visitId,
        "data-testid": "visit-orders-ai-suggest",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 5,
            padding: '5px 11px',
            borderRadius: 7,
            border: '1px solid oklch(0.87 0.06 290)',
            background: encOrderSuggLoading ? 'oklch(0.95 0.02 290)' : 'oklch(0.97 0.02 290)',
            color: 'oklch(0.38 0.14 290)',
            fontSize: '0.71875rem',
            fontWeight: 600,
            cursor: encOrderSuggLoading || !visitId ? 'not-allowed' : 'pointer',
            opacity: encOrderSuggLoading || !visitId ? 0.6 : 1,
            fontFamily: 'inherit'
        }
    }, encOrderSuggLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 9,
            height: 9,
            border: '1.5px solid oklch(0.80 0.06 290)',
            borderTopColor: 'oklch(0.38 0.14 290)',
            borderRadius: '50%',
            animation: 'spin .7s linear infinite'
        }
    }), " ", t('visit.copilot.checking')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).sparkle, {
        width: 11,
        height: 11
    }), " ", t('visit.suggest.order'))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: 16,
            display: 'flex',
            flexDirection: 'column',
            gap: 12
        }
    }, orderError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-order-error",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '9px 12px',
            borderRadius: 8,
            background: 'var(--danger-soft)',
            border: '1px solid var(--danger-ink)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).alert, {
        width: 15,
        height: 15,
        style: {
            color: 'var(--danger-ink)',
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            fontSize: '0.75rem',
            fontWeight: 600,
            color: 'var(--danger-ink)',
            lineHeight: 1.6
        }
    }, orderError), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: ()=>setOrderError(null),
        "aria-label": t('errors.dismiss'),
        style: {
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            color: 'var(--danger-ink)',
            display: 'flex',
            padding: 2
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).x, {
        width: 14,
        height: 14
    }))), findingsCard('ORDERS'), encOrderSugg && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            ...(0, $6xvbB.SEC_SUBCARD),
            borderColor: 'var(--accent)'
        },
        "data-testid": "visit-orders-ai-panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: (0, $6xvbB.SEC_ICON)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).sparkle, {
        width: 12,
        height: 12
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.75rem',
            fontWeight: 700,
            color: 'var(--ink)'
        }
    }, t('visit.suggest.orderBasis')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.59375rem',
            fontWeight: 700,
            padding: '1px 7px',
            borderRadius: 20,
            background: 'var(--accent-soft)',
            color: 'var(--accent-ink)'
        }
    }, "AI"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: ()=>setEncOrderSugg(null),
        "aria-label": t('visit.suggest.close'),
        style: {
            marginInlineStart: 'auto',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            color: 'var(--mute)',
            display: 'flex',
            padding: 2
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).x, {
        width: 13,
        height: 13
    }))), encOrderSugg.rationale && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.71875rem',
            color: 'var(--ink-2)',
            lineHeight: 1.7
        }
    }, encOrderSugg.rationale), encOrderSugg.items.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.75rem',
            color: 'var(--mute)'
        }
    }, t('visit.copilot.noneForState')), encOrderSugg.items.map((item, idx)=>{
        const added = encSuggAdded.has(item.key) || (0, $d2Zvn.isAlreadyOrdered)(clinicalOrders, item.orderType, item.name);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: item.key,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                padding: '8px 10px',
                borderRadius: 8,
                border: `1px solid ${idx === 0 ? 'var(--accent)' : 'var(--line)'}`,
                background: idx === 0 ? 'var(--accent-soft)' : 'var(--field)'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1,
                minWidth: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.78125rem',
                fontWeight: 600,
                color: 'var(--ink)',
                display: 'flex',
                alignItems: 'center',
                gap: 6,
                flexWrap: 'wrap'
            }
        }, suggestedOrderName(item.name), idx === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.59375rem',
                fontWeight: 700,
                padding: '1px 7px',
                borderRadius: 4,
                background: 'var(--accent)',
                color: '#fff'
            }
        }, t('visit.copilot.bestOption')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.625rem',
                color: 'var(--mute)',
                padding: '1px 7px',
                borderRadius: 4,
                background: 'var(--panel-2)',
                border: '1px solid var(--line)'
            }
        }, (0, $6xvbB.ORDER_TYPE_FA)(t)[item.orderType] || item.orderType)), item.reason && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.65625rem',
                color: 'var(--mute)',
                marginTop: 2,
                lineHeight: 1.5
            }
        }, item.reason)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.UrgencyBadge), {
            urgency: item.urgency
        }), added ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.6875rem',
                fontWeight: 700,
                color: 'var(--good)',
                display: 'flex',
                alignItems: 'center',
                gap: 4,
                flexShrink: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).check, {
            width: 11,
            height: 11
        }), " ", t('visit.suggest.added')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "subtle",
            size: "sm",
            onClick: ()=>handleAddSuggestedOrder(item),
            disabled: encSuggAdding === item.key,
            "data-testid": `visit-order-suggest-add-${idx}`,
            className: "gap-1 shrink-0"
        }, encSuggAdding === item.key ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
            size: 11,
            thickness: 2
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).plus, {
            width: 11,
            height: 11
        }), " ", t('common.actions.add')));
    })), (()=>{
        // Must mirror the precondition handleAddSelectedOrders/handleCreateOrder
        // actually enforce (encounter id + patient id) — otherwise the button can
        // show enabled while the patient hasn't loaded yet and silently no-op.
        const encReady = !!((pmEncounterId || visitId) && patient?.id);
        const selectedCount = selectedOrderKeys.size;
        const canAdd = encReady && !orderSaving && selectedCount > 0 && !(0, $feEcD.orderDateProblem)(orderDate, (0, $feEcD.clinicTodayIso)());
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: (0, $6xvbB.SEC_SUBCARD),
            "data-testid": "visit-order-form"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 8
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: (0, $6xvbB.SEC_ICON)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).plus, {
            width: 12,
            height: 12
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.78125rem',
                fontWeight: 700,
                color: 'var(--ink)'
            }
        }, t('visit.orders.add')), selectedCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                ...(0, $6xvbB.SEC_BADGE),
                background: 'var(--accent-soft)',
                color: 'var(--accent-ink)'
            }
        }, selectedCount, " ", t('visit.orders.selectedCount'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                position: 'relative'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                position: 'absolute',
                insetInlineStart: 10,
                top: '50%',
                transform: 'translateY(-50%)',
                color: 'var(--mute)',
                pointerEvents: 'none',
                display: 'flex'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).search, {
            width: 13,
            height: 13
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
            value: orderSearch,
            onChange: (e)=>setOrderSearch(e.target.value),
            placeholder: t('visit.orders.searchCatalog'),
            "data-testid": "visit-order-catalog-search",
            style: {
                ...(0, $6xvbB.SEC_FIELD),
                paddingInlineStart: 32
            }
        })), orderSearch.trim().length < (0, $6xvbB.ORDER_MIN_QUERY) ? !orderSearch.trim() && idleBlocks.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": "visit-order-shortcuts",
            "data-state": "content",
            style: {
                maxHeight: 320,
                overflowY: 'auto',
                display: 'flex',
                flexDirection: 'column',
                gap: 12,
                paddingInlineEnd: 2
            }
        }, idleBlocks.map((block)=>block === 'frequent' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                key: "frequent",
                "data-testid": "visit-order-frequent",
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 6
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    fontSize: '0.71875rem',
                    fontWeight: 700,
                    color: 'var(--ink)'
                }
            }, t('visit.orders.frequentTitle')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gap: 6
                }
            }, frequentItems.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.OrderCheckItem), {
                    key: item.key,
                    item: item,
                    selected: selectedOrderKeys.has(item.key),
                    onToggle: toggleOrderKey,
                    showLoinc: item.type === 'lab'
                })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                key: "clinic",
                "data-testid": "visit-order-clinic",
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 6
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    fontSize: '0.71875rem',
                    fontWeight: 700,
                    color: 'var(--ink)'
                }
            }, t('visit.orders.clinicTitle')), clinicGroups.map(({ gk: gk, type: type, category: category, list: list })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    key: gk,
                    "data-testid": `visit-order-clinic-group-${type}`,
                    style: {
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 6
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        fontSize: '0.65625rem',
                        fontWeight: 700,
                        color: 'var(--mute-2)',
                        letterSpacing: '.02em'
                    }
                }, (0, $6xvbB.ORDER_TYPE_FA)(t)[type] || type, " \xb7 ", (0, $lfHhF.orderCategoryLabel)(category, t)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr',
                        gap: 6
                    }
                }, list.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.OrderCheckItem), {
                        key: item.key,
                        item: item,
                        selected: selectedOrderKeys.has(item.key),
                        onToggle: toggleOrderKey,
                        showLoinc: item.type === 'lab'
                    }))))), clinicOrders.total > clinicOrders.entries.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                "data-testid": "visit-order-clinic-more",
                style: {
                    fontSize: '0.6875rem',
                    color: 'var(--mute)'
                }
            }, t('visit.orders.clinicMore', {
                count: clinicOrders.total - clinicOrders.entries.length
            })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": "visit-order-shortcuts-hint",
            style: {
                fontSize: '0.71875rem',
                color: 'var(--ink-2)',
                lineHeight: 1.7
            }
        }, t('visit.orders.shortcutsHint'))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": "visit-order-search-idle",
            "data-state": "idle",
            style: {
                fontSize: '0.71875rem',
                color: 'var(--ink-2)',
                lineHeight: 1.7
            }
        }, orderSearch.trim() ? t('visit.orders.keepTyping') : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontWeight: 600,
                color: 'var(--ink)'
            }
        }, t('visit.orders.searchTitle')), " \u2014 ", t('visit.orders.searchBody'))) : catalogPage.loading && !catalogItems.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fWbIA.CatalogListSkeleton), {
            testId: "visit-order-catalog-loading",
            count: 4
        }) : catalogPage.error ? /* Said out loud. A picker that silently returns nothing is
                           indistinguishable from a catalogue that does not carry
                           the service, and the doctor would type it by hand. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": "visit-order-catalog-error",
            style: {
                fontSize: '0.75rem',
                color: 'var(--danger-ink)',
                textAlign: 'center',
                padding: 14
            }
        }, t('visit.orders.catalogSearchFailed')) : groupedCatalog.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": "visit-order-catalog-empty",
            style: {
                fontSize: '0.75rem',
                color: 'var(--mute)',
                textAlign: 'center',
                padding: 14
            }
        }, t('visit.orders.noCatalogMatch')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": "visit-order-catalog-list",
            style: {
                maxHeight: 320,
                overflowY: 'auto',
                display: 'flex',
                flexDirection: 'column',
                gap: 10,
                paddingInlineEnd: 2
            }
        }, groupedCatalog.map(({ gk: gk, type: type, category: category, list: list })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                key: gk,
                "data-testid": `visit-order-group-${type}`,
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 6
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    fontSize: '0.65625rem',
                    fontWeight: 700,
                    color: 'var(--mute-2)',
                    letterSpacing: '.02em'
                }
            }, (0, $6xvbB.ORDER_TYPE_FA)(t)[type] || type, " \xb7 ", (0, $lfHhF.orderCategoryLabel)(category, t)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gap: 6
                }
            }, list.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.OrderCheckItem), {
                    key: item.key,
                    item: item,
                    selected: selectedOrderKeys.has(item.key),
                    onToggle: toggleOrderKey,
                    showLoinc: item.type === 'lab'
                }))))), catalogPage.total > catalogItems.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": "visit-order-more-results",
            style: {
                textAlign: 'center',
                fontSize: '0.6875rem',
                color: 'var(--mute)',
                padding: '4px 0'
            }
        }, t('visit.rx.moreResults', {
            shown: catalogItems.length,
            total: catalogPage.total
        }))), selectedCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": "visit-order-selected-chips",
            style: {
                display: 'flex',
                flexWrap: 'wrap',
                gap: 6
            }
        }, Array.from(selectedOrderKeys).map((key)=>{
            const it = selectedOrderItems.current.get(key);
            if (!it) return null;
            // Named as its picker row names it (OrderCheckItem).
            const name = (0, $6xvbB.orderNameLines)(it, readsPersianData, (0, $6xvbB.ownCatalogName)(it, locale)).primary;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                key: key,
                onClick: ()=>toggleOrderKey(key),
                "aria-label": t('visit.rx.removeAria', {
                    name: name
                }),
                "data-testid": `visit-order-selected-${key}`,
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                    padding: '0 9px',
                    lineHeight: '24px',
                    borderRadius: 6,
                    border: '1px solid var(--accent)',
                    background: 'var(--accent-soft)',
                    color: 'var(--accent-ink)',
                    fontSize: '0.75rem',
                    fontWeight: 600,
                    fontFamily: 'inherit',
                    cursor: 'pointer'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    fontSize: '0.65625rem',
                    fontWeight: 500,
                    opacity: 0.8
                }
            }, (0, $6xvbB.ORDER_TYPE_FA)(t)[it.type] || it.type), name, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).x, {
                width: 11,
                height: 11
            }));
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'flex-end',
                gap: 8,
                flexWrap: 'wrap'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: 4
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
            style: (0, $6xvbB.SEC_LABEL)
        }, t('visit.orders.urgency')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("select", {
            value: orderUrgency,
            onChange: (e)=>setOrderUrgency(e.target.value),
            "data-testid": "visit-order-urgency",
            style: {
                ...(0, $6xvbB.SEC_SELECT),
                width: 120
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
            value: "routine"
        }, t('common.urgency.routine')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
            value: "urgent"
        }, t('common.urgency.urgent')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
            value: "stat"
        }, t('common.urgency.stat')))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: 4
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
            style: (0, $6xvbB.SEC_LABEL)
        }, t('visit.orders.date.label')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aQGDs.OrderDateChoice), {
            value: orderDate,
            onChange: setOrderDate
        })), Array.from(selectedOrderKeys).some((k)=>k.startsWith('procedure:')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: 4
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
            style: (0, $6xvbB.SEC_LABEL)
        }, t('visit.rx.sessions')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
            type: "number",
            min: 1,
            value: orderSessions,
            onChange: (e)=>setOrderSessions(e.target.value),
            "data-testid": "visit-order-sessions",
            style: {
                ...(0, $6xvbB.SEC_FIELD),
                width: 90
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: 4,
                flex: 1,
                minWidth: 160
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
            style: (0, $6xvbB.SEC_LABEL)
        }, t('visit.orders.noteOptional')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
            value: orderNotes,
            onChange: (e)=>setOrderNotes(e.target.value),
            placeholder: t('visit.orders.clinicalNotePlaceholder'),
            "data-testid": "visit-order-notes",
            style: (0, $6xvbB.SEC_FIELD)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "default",
            size: "sm",
            onClick: handleAddSelectedOrders,
            disabled: !canAdd,
            "data-testid": "visit-order-create",
            className: "gap-1.5 shrink-0"
        }, orderSaving ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
            size: 13,
            color: "#fff",
            thickness: 2
        }), " ", t('visit.orders.saving')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).plus, {
            width: 13,
            height: 13
        }), " ", selectedCount > 0 ? t('visit.orders.addWithCount', {
            count: selectedCount
        }) : t('visit.orders.add')))));
    })(), ordersLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fWbIA.OrdersListSkeleton), {
        count: 3
    }) : clinicalOrders.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-orders-empty",
        "data-state": "empty"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).flask, {
            width: 40,
            height: 40
        }),
        title: t('visit.orders.noneRecorded'),
        description: t('visit.orders.emptyHint')
    })) : sortedClinicalOrders.map((order)=>{
        // Orders the current clinic performs are tagged and sorted to the top.
        const isClinic = isClinicOrder(order);
        const TypeIcon = (0, $6xvbB.I)[(0, $6xvbB.ORDER_TYPE_ICON)[order.orderType]] || (0, $6xvbB.I).doc;
        const isTransitioning = orderTransitioning === order.id;
        // انجام only for services the clinic has an active declaration for —
        // completing is what triggers billing, so undeclared orders (including
        // free-text) are fulfilled elsewhere and offer no doctor-side انجام.
        // PM-0618: one session in THIS visit, never on a process step
        // (the process panel records those), never twice.
        const canPerformHere = (0, $7TTuK.canMarkDoneHere)(order, {
            inHouse: isOrderInHouse(order),
            visitId: pmEncounterId || visitId,
            visitOnline: call.available === true
        });
        // A service the clinic does not perform (`performedHere` false —
        // a lab, a scan elsewhere) offers no «انجام شد»: its stage turns
        // «انجام شده» only when a result is attached (PM-0680, the owner's
        // decision, reversing PM-0634's manual mark).
        // Backend allows cancelling pending orders only.
        const canCancel = order.status === 'pending';
        const erxLine = (0, $3O5pt.erxStateForOrder)(order, erxIndex);
        return(// Two lines, like a نسخه row: the name, then its details — type, code,
        // urgency, where it stands with the insurer, the note — at a size
        // that reads, wrapping instead of being clipped (PM-0098).
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: order.id,
            "data-testid": `visit-order-card-${order.id}`,
            "data-clinic-order": isClinic || undefined,
            style: {
                background: 'var(--panel)',
                border: '1px solid var(--line)',
                borderRadius: 10,
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                padding: '9px 10px'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                width: 30,
                height: 30,
                borderRadius: 8,
                flexShrink: 0,
                display: 'grid',
                placeItems: 'center',
                background: 'var(--accent-soft)',
                color: 'var(--accent-ink)'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(TypeIcon, {
            width: 15,
            height: 15
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1,
                minWidth: 0,
                display: 'flex',
                flexDirection: 'column',
                gap: 5
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'baseline',
                gap: 8,
                minWidth: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.8125rem',
                fontWeight: 700,
                color: 'var(--ink)',
                lineHeight: 1.5,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                flex: '0 1 auto',
                minWidth: 0
            }
        }, chartOrderName(order)), isClinic && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.6875rem',
                fontWeight: 700,
                color: 'var(--accent-ink)',
                background: 'var(--accent-soft)',
                padding: '0 8px',
                borderRadius: 6,
                lineHeight: '20px',
                flexShrink: 0,
                whiteSpace: 'nowrap'
            }
        }, t('visit.orders.thisClinic'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": `visit-order-details-${order.id}`,
            style: {
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: 6,
                minWidth: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.75rem',
                fontWeight: 500,
                lineHeight: '22px',
                padding: '0 9px',
                borderRadius: 6,
                whiteSpace: 'nowrap',
                flexShrink: 0,
                color: 'var(--ink)',
                background: 'var(--panel-2)'
            }
        }, (0, $6xvbB.ORDER_TYPE_FA)(t)[order.orderType] || order.orderType), order.code && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "ltr",
            style: {
                fontSize: '0.75rem',
                fontWeight: 500,
                lineHeight: '22px',
                padding: '0 9px',
                borderRadius: 6,
                whiteSpace: 'nowrap',
                flexShrink: 0,
                color: 'var(--ink-2)',
                background: 'var(--panel-2)'
            }
        }, order.orderType === 'procedure' ? 'CPT' : 'LOINC', " ", order.code), order.urgency === 'stat' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.75rem',
                fontWeight: 500,
                lineHeight: '22px',
                padding: '0 9px',
                borderRadius: 6,
                whiteSpace: 'nowrap',
                flexShrink: 0,
                fontWeight: 700,
                color: 'var(--danger-ink)',
                background: 'var(--danger-soft)'
            }
        }, "STAT"), order.urgency === 'urgent' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.75rem',
                fontWeight: 500,
                lineHeight: '22px',
                padding: '0 9px',
                borderRadius: 6,
                whiteSpace: 'nowrap',
                flexShrink: 0,
                fontWeight: 700,
                color: 'var(--warn-ink)',
                background: 'var(--warn-soft)'
            }
        }, t('common.urgency.urgent')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bOPUe.ErxLineChip), {
            line: erxLine,
            testid: `visit-order-erx-state-${order.id}`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.InsurerListChip), {
            drug: {
                id: order.id
            },
            size: 11.5,
            listed: (0, $6xvbB.orderTaminListed)(order, catalogResolved, patientInsurer),
            testid: `visit-order-coverage-${order.id}`,
            hint: t('visit.orders.outTaminHint')
        }), order.notes && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "auto",
            style: {
                fontSize: '0.75rem',
                color: 'var(--ink-2)',
                lineHeight: '22px',
                overflowWrap: 'anywhere',
                minWidth: 0
            }
        }, order.notes)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aQGDs.OrderDateLine), {
            order: order,
            erxLine: erxLine,
            onSave: handleOrderDateChange
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aQGDs.OrderWhenCaption), {
            order: order,
            inHouse: isOrderInHouse(order),
            visitOnline: call.available === true,
            testid: `visit-order-when-${order.id}`
        }), (order.sessionCount || 0) > 1 && (0, $7TTuK.sessionInVisit)(order, pmEncounterId || visitId) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aQGDs.SessionStatusChip), {
            session: (0, $7TTuK.sessionInVisit)(order, pmEncounterId || visitId),
            prefix: t('visit.services.session', {
                n: formatNumber((0, $7TTuK.sessionInVisit)(order, pmEncounterId || visitId).sessionNo)
            }),
            testid: `visit-order-session-${order.id}`
        })), canPerformHere && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "subtle",
            size: "sm",
            className: "h-7 px-3 shrink-0",
            onClick: ()=>handleOrderDone(order),
            disabled: isTransitioning,
            "data-testid": `visit-order-done-${order.id}`,
            title: t('visit.orders.markDoneHint'),
            style: {
                color: 'var(--good-ink)'
            }
        }, isTransitioning ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
            size: 11,
            thickness: 2
        }) : t('visit.orders.markDoneHere')), canCancel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            size: "sm",
            className: "h-7 px-3 shrink-0",
            onClick: ()=>setOrderToCancel(order),
            disabled: isTransitioning,
            "data-testid": `visit-order-cancel-${order.id}`,
            style: {
                color: 'var(--danger-ink)'
            }
        }, t('common.actions.discard')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 2,
                flexShrink: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aQGDs.OrderStageChip), {
            order: order,
            testid: `visit-order-stage-${order.id}`,
            withIcon: (s)=>s === 'REQUESTED' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).clock, {
                    width: 11,
                    height: 11
                }) : s === 'DONE' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).check, {
                    width: 11,
                    height: 11
                }) : null
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aQGDs.OrderBookingLine), {
            order: order,
            testid: `visit-order-booking-${order.id}`
        }))));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bOPUe.ErxRemovedLines), {
        lines: erxRemovedOrders,
        part: "SERVICES",
        testid: "visit-orders-erx-removed"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $jzVrj.default), {
        appointmentId: pmEncounterId || visitId || null,
        refreshKey: visitServicesKey
    }))), workTab === 'orders' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fijM5.default), {
        className: "mt-3",
        appointmentId: pmEncounterId || visitId || null,
        patientId: patient?.id,
        doctorId: doctor?.id
    }), workTab === '__removed__' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 12
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.8125rem',
            fontWeight: 600,
            color: 'var(--ink)'
        }
    }, vitalsMode === 'saved' ? t('visit.vitals.thisVisit') : t('visit.vitals.record')), vitalsMode === 'saved' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: ()=>setVitalsMode('form'),
        style: {
            fontSize: '0.75rem',
            fontWeight: 600,
            color: 'var(--accent-ink)',
            background: 'var(--accent-soft)',
            border: '1px solid var(--accent)',
            borderRadius: 7,
            padding: '4px 10px',
            cursor: 'pointer',
            fontFamily: 'inherit'
        }
    }, t('common.actions.edit'))), vitalsAlert && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            borderRadius: 8,
            padding: '10px 12px',
            background: vitalsAlert.level === 'critical' ? 'var(--danger-soft)' : 'var(--warn-soft)',
            border: `1.5px solid ${vitalsAlert.level === 'critical' ? 'oklch(0.82 0.09 25)' : 'oklch(0.85 0.06 55)'}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontWeight: 700,
            fontSize: '0.8125rem',
            color: vitalsAlert.level === 'critical' ? 'var(--danger-ink)' : 'oklch(0.42 0.12 50)',
            marginBottom: 4
        }
    }, vitalsAlert.level === 'critical' ? t('visit.state.criticalWarning') : t('visit.state.warning')), vitalsAlert.messages.map((m, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                fontSize: '0.78125rem',
                color: 'var(--ink)'
            }
        }, m)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: ()=>setVitalsAlert(null),
        style: {
            marginTop: 6,
            fontSize: '0.6875rem',
            background: 'none',
            border: 'none',
            color: 'var(--mute)',
            cursor: 'pointer',
            padding: 0,
            fontFamily: 'inherit'
        }
    }, t('common.actions.close'))), vitalsMode === 'saved' ? // ── Read-only saved view ──
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: 10
        }
    }, (vitals.bpSys || vitals.bpDia) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            gridColumn: '1 / -1',
            background: 'var(--good-soft)',
            border: '1px solid oklch(0.88 0.07 145)',
            borderRadius: 10,
            padding: '10px 12px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.625rem',
            fontWeight: 600,
            color: 'var(--mute-2)',
            marginBottom: 4,
            textTransform: 'uppercase',
            letterSpacing: '.04em'
        }
    }, t('patient.vitals.bp')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'baseline',
            gap: 4
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '1.375rem',
            fontWeight: 700,
            color: 'var(--ink)',
            fontFamily: 'JetBrains Mono,monospace'
        }
    }, vitals.bpSys || "\u2014"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '1rem',
            color: 'var(--mute)',
            fontWeight: 400,
            fontFamily: 'JetBrains Mono,monospace'
        }
    }, "/"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '1.375rem',
            fontWeight: 700,
            color: 'var(--ink)',
            fontFamily: 'JetBrains Mono,monospace'
        }
    }, vitals.bpDia || "\u2014"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.6875rem',
            color: 'var(--mute)',
            fontWeight: 500
        }
    }, "mmHg"))), [
        {
            key: 'pulse',
            label: t('patient.vitals.hr'),
            unit: 'bpm'
        },
        {
            key: 'spo2',
            label: t('patient.vitals.spo2'),
            unit: '%'
        },
        {
            key: 'temp',
            label: t('patient.vitals.bodyTemp'),
            unit: "\xb0C"
        },
        {
            key: 'weight',
            label: t('patient.vitals.wt'),
            unit: 'kg'
        }
    ].map(({ key: key, label: label, unit: unit })=>vitals[key] ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: key,
            style: {
                background: 'var(--good-soft)',
                border: '1px solid oklch(0.88 0.07 145)',
                borderRadius: 10,
                padding: '10px 12px'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.625rem',
                fontWeight: 600,
                color: 'var(--mute-2)',
                marginBottom: 4,
                textTransform: 'uppercase',
                letterSpacing: '.04em'
            }
        }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'baseline',
                gap: 4
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '1.375rem',
                fontWeight: 700,
                color: 'var(--ink)',
                fontFamily: 'JetBrains Mono,monospace'
            }
        }, vitals[key]), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.6875rem',
                color: 'var(--mute)',
                fontWeight: 500
            }
        }, unit))) : null)) : // ── Editable form ──
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: 10
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            gridColumn: '1 / -1',
            background: 'var(--panel-2)',
            border: '1px solid var(--line)',
            borderRadius: 10,
            padding: '10px 12px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.625rem',
            fontWeight: 600,
            color: 'var(--mute-2)',
            marginBottom: 6,
            textTransform: 'uppercase',
            letterSpacing: '.04em'
        }
    }, t('patient.vitals.bp')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        type: "text",
        inputMode: "decimal",
        dir: "ltr",
        value: vitals.bpSys,
        onChange: (e)=>setVitals((v)=>({
                    ...v,
                    bpSys: (0, $6xvbB.vitalDigits)(e.target.value)
                })),
        placeholder: "120",
        style: {
            flex: 1,
            border: 'none',
            outline: 'none',
            fontSize: '1.25rem',
            fontWeight: 700,
            fontFamily: 'inherit',
            background: 'transparent',
            color: 'var(--ink)',
            width: 0,
            textAlign: 'center'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '1.125rem',
            color: 'var(--mute)',
            fontWeight: 300,
            lineHeight: 1
        }
    }, "/"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        type: "text",
        inputMode: "decimal",
        dir: "ltr",
        value: vitals.bpDia,
        onChange: (e)=>setVitals((v)=>({
                    ...v,
                    bpDia: (0, $6xvbB.vitalDigits)(e.target.value)
                })),
        placeholder: "80",
        style: {
            flex: 1,
            border: 'none',
            outline: 'none',
            fontSize: '1.25rem',
            fontWeight: 700,
            fontFamily: 'inherit',
            background: 'transparent',
            color: 'var(--ink)',
            width: 0,
            textAlign: 'center'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.6875rem',
            color: 'var(--mute)',
            fontWeight: 500
        }
    }, "mmHg"))), [
        {
            key: 'pulse',
            label: t('patient.vitals.hr'),
            unit: 'bpm',
            ph: '72'
        },
        {
            key: 'spo2',
            label: t('patient.vitals.spo2'),
            unit: '%',
            ph: '98'
        },
        {
            key: 'temp',
            label: t('patient.vitals.bodyTemp'),
            unit: "\xb0C",
            ph: '37'
        },
        {
            key: 'weight',
            label: t('patient.vitals.wt'),
            unit: 'kg',
            ph: ''
        }
    ].map(({ key: key, label: label, unit: unit, ph: ph })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: key,
            style: {
                background: 'var(--panel-2)',
                border: '1px solid var(--line)',
                borderRadius: 10,
                padding: '10px 12px'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.625rem',
                fontWeight: 600,
                color: 'var(--mute-2)',
                marginBottom: 6,
                textTransform: 'uppercase',
                letterSpacing: '.04em'
            }
        }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 6
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
            type: "text",
            inputMode: "decimal",
            dir: "ltr",
            value: vitals[key],
            onChange: (e)=>setVitals((v)=>({
                        ...v,
                        [key]: (0, $6xvbB.vitalDigits)(e.target.value)
                    })),
            placeholder: ph,
            style: {
                flex: 1,
                border: 'none',
                outline: 'none',
                fontSize: '1.25rem',
                fontWeight: 700,
                fontFamily: 'inherit',
                background: 'transparent',
                color: 'var(--ink)',
                width: 0
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.6875rem',
                color: 'var(--mute)',
                fontWeight: 500
            }
        }, unit))))), vitalsError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            borderRadius: 8,
            padding: '8px 11px',
            background: 'var(--danger-soft)',
            border: '1.5px solid oklch(0.82 0.09 25)',
            marginTop: 10
        }
    }, vitalsError.map((m, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                fontSize: '0.75rem',
                color: 'var(--danger-ink)',
                fontWeight: 600
            }
        }, m))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: handleSaveVitals,
        disabled: vitalsLoading,
        style: {
            height: 40,
            background: 'var(--ink)',
            color: '#faf7f4',
            border: 'none',
            borderRadius: 10,
            fontSize: '0.8125rem',
            fontWeight: 600,
            cursor: vitalsLoading ? 'not-allowed' : 'pointer',
            fontFamily: 'inherit'
        }
    }, vitalsLoading ? '...' : t('visit.vitals.record'))), (()=>{
        const VITAL_META = {
            '8480-6': {
                label: 'BP sys',
                unit: 'mmHg',
                status: (v)=>v > 140 || v < 90 ? 'crit' : v > 120 ? 'warn' : 'ok'
            },
            '8462-4': {
                label: 'BP dia',
                unit: 'mmHg',
                status: (v)=>v > 90 || v < 60 ? 'crit' : v > 80 ? 'warn' : 'ok'
            },
            '8867-4': {
                label: t('visit.vitals.pulse'),
                unit: 'bpm',
                status: (v)=>v > 110 || v < 50 ? 'crit' : v > 100 || v < 60 ? 'warn' : 'ok'
            },
            '59408-5': {
                label: "SpO\u2082",
                unit: '%',
                status: (v)=>v < 92 ? 'crit' : v < 95 ? 'warn' : 'ok'
            },
            '8310-5': {
                label: t('patient.vitals.temp'),
                unit: "\xb0C",
                status: (v)=>v > 38.5 || v < 36 ? 'crit' : v > 37.2 ? 'warn' : 'ok'
            },
            '29463-7': {
                label: t('patient.vitals.wt'),
                unit: 'kg',
                status: ()=>'ok'
            }
        };
        const STATUS_COLOR = {
            ok: 'var(--good)',
            warn: 'var(--warn)',
            crit: 'var(--danger)'
        };
        const STATUS_BG = {
            ok: 'var(--good-soft)',
            warn: 'var(--warn-soft)',
            crit: 'var(--danger-soft)'
        };
        const vGroups = {};
        (patient?.clinicalObservations || []).forEach((obs)=>{
            const meta = VITAL_META[obs.code];
            if (!meta) return;
            const val = parseFloat(obs.value);
            if (isNaN(val)) return;
            if (!vGroups[obs.code]) vGroups[obs.code] = {
                ...meta,
                code: obs.code,
                pts: []
            };
            vGroups[obs.code].pts.push({
                date: obs.effectiveDate,
                value: val
            });
        });
        const cards = Object.values(vGroups);
        if (!cards.length) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                background: 'var(--panel-2)',
                border: '1px solid var(--line)',
                borderRadius: 'var(--radius-lg)',
                boxShadow: 'var(--shadow)',
                overflow: 'hidden'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                padding: '10px 14px',
                borderBottom: '1px solid var(--line-2)',
                fontSize: '0.75rem',
                fontWeight: 600,
                color: 'var(--ink)',
                background: 'var(--field)'
            }
        }, t('visit.vitals.history')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                padding: '12px',
                display: 'grid',
                gridTemplateColumns: '1fr 1fr 1fr',
                gap: 8
            }
        }, cards.map((m)=>{
            const sorted = [
                ...m.pts
            ].sort((a, b)=>new Date(a.date) - new Date(b.date));
            const last = sorted[sorted.length - 1];
            const prev = sorted[sorted.length - 2];
            const st = m.status(last.value);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.VitalCard), {
                key: m.code,
                m: m,
                clr: STATUS_COLOR[st],
                bg: STATUS_BG[st],
                last: last,
                prev: prev,
                sorted: sorted
            });
        })));
    })())), erxAvailable && erxOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5zccn.default), {
        scope: erxScope,
        onClose: ()=>changeErxScope(null),
        overlay: workBodyWidth > 0 && workBodyWidth < (0, $5zccn.ERX_PANEL_PUSH_MIN),
        notOffered: erxStatus?.enabled === false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4UqGT.default), {
        key: erxScope,
        scope: erxScope,
        flow: "panel",
        testIdPrefix: "visit-erx",
        appointmentId: pmEncounterId || visitId,
        patientId: patient.id,
        prepare: rxPersistence.writeNow,
        refreshKey: erxRefreshKey,
        onSubmitted: reloadErxStatus,
        onBusyChange: setErxBusy,
        describeLine: describeErxLine
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            gridRow: 2,
            gridColumn: 2,
            background: 'var(--panel)',
            borderInlineEnd: '1px solid var(--line)',
            display: recordShown ? 'flex' : 'none',
            flexDirection: 'column',
            minHeight: 0,
            minWidth: 0,
            overflowY: 'auto'
        }
    }, recordShown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '14px 16px 10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderBottom: '1px solid var(--line)',
            position: 'sticky',
            top: 0,
            zIndex: 2,
            background: 'var(--panel)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            fontWeight: 600,
            fontSize: '0.8125rem',
            color: 'var(--ink)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: ()=>setContextExpanded((v)=>!v),
        title: contextExpanded ? t('visit.panel.collapse') : t('visit.panel.expand'),
        "aria-label": contextExpanded ? t('visit.panel.collapseRecord') : t('visit.panel.expandRecord'),
        "aria-pressed": contextExpanded,
        style: {
            width: 24,
            height: 24,
            borderRadius: 6,
            flexShrink: 0,
            display: 'grid',
            placeItems: 'center',
            cursor: 'pointer',
            fontFamily: 'inherit',
            border: '1px solid var(--line)',
            background: contextExpanded ? 'var(--accent-soft)' : 'var(--panel-2)',
            color: contextExpanded ? 'var(--accent-ink)' : 'var(--mute)'
        }
    }, contextExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).back, {
        width: 14,
        height: 14
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).arrow, {
        width: 14,
        height: 14
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: 7,
            height: 7,
            borderRadius: '50%',
            background: 'var(--primary)',
            display: 'inline-block'
        }
    }), t('visit.patient.record')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 6
        }
    }, visitStatus === 'inprogress' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dXWAH.CompleteButton), {
        compact: true,
        testid: "visit-record-complete",
        ...completion.button('record')
    }), !callHoldsRecord && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: ()=>toggleRecordPanelOpen(false),
        "data-testid": "visit-record-fold",
        title: t('visit.panel.foldRecord'),
        "aria-label": t('visit.panel.foldRecord'),
        style: {
            width: 24,
            height: 24,
            borderRadius: 6,
            flexShrink: 0,
            display: 'grid',
            placeItems: 'center',
            cursor: 'pointer',
            fontFamily: 'inherit',
            border: '1px solid var(--line)',
            background: 'var(--panel-2)',
            color: 'var(--mute)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).x, {
        width: 13,
        height: 13
    })))), monitoringExtract.reviews.RECORD.open && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '10px 12px',
            borderBottom: '1px solid var(--line)'
        }
    }, findingsCard('RECORD')), (()=>{
        const recordBlocks = {
            /* Allergies — collapsible like every section, but the header keeps the
              red identity and the count, so the safety signal survives collapse. */ allergy: p?.allergies?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordSection, {
                id: "allergy",
                tone: "danger",
                title: t('visit.patient.allergyAlert'),
                count: p.allergies.length,
                gist: formatList(p.allergies),
                open: recordOpen.allergy,
                onToggle: toggleRecordSection
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 7,
                    padding: '8px 10px',
                    background: 'var(--danger-soft)',
                    border: '1px solid oklch(0.85 0.08 25)',
                    borderRadius: 8,
                    marginBottom: 7
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    fontSize: '0.75rem',
                    color: 'var(--danger-ink)',
                    fontWeight: 600
                }
            }, t('visit.patient.allergyHint'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 5
                }
            }, p.allergies.map((a, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    key: i,
                    style: $9b4ee9e6346f75da$var$RECORD_CHIP_DANGER
                }, a)))),
            /* Demographics */ demo: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordSection, {
                id: "demo",
                icon: (0, $6xvbB.I).users,
                title: t('visit.patient.details'),
                gist: [
                    p?.age ? t('visit.patient.years', {
                        count: p.age
                    }) : null,
                    p?.bloodType || null,
                    (0, $gq4TR.INSURANCE_LABEL_KEYS)[p?.insurance] ? t((0, $gq4TR.INSURANCE_LABEL_KEYS)[p.insurance]) : p?.insurance || null
                ].filter(Boolean).join(" \xb7 "),
                actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordHeaderAction, {
                    icon: (0, $6xvbB.I).edit,
                    label: t('common.actions.edit'),
                    testid: "visit-demographics-edit",
                    onClick: ()=>{
                        setEditPatientError('');
                        setEditPatientForm({
                            name: p?.name || '',
                            phone: p?.phone || '',
                            nationalId: p?.nationalId || '',
                            birthDate: p?.birthDate || '',
                            bloodType: p?.bloodType || '',
                            job: p?.job || '',
                            insurance: p?.insurance || '',
                            height: p?.height != null ? String(p.height) : ''
                        });
                        setShowEditPatient(true);
                    }
                }),
                open: recordOpen.demo,
                onToggle: toggleRecordSection
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gap: '7px 12px'
                }
            }, [
                {
                    k: t('common.labels.age'),
                    v: p?.age ? t('visit.patient.years', {
                        count: p.age
                    }) : "\u2014"
                },
                {
                    k: t('visit.patient.bloodType'),
                    v: p?.bloodType || "\u2014"
                },
                {
                    k: t('visit.patient.insurance'),
                    v: (0, $gq4TR.INSURANCE_LABEL_KEYS)[p?.insurance] ? t((0, $gq4TR.INSURANCE_LABEL_KEYS)[p.insurance]) : p?.insurance || "\u2014"
                },
                {
                    k: 'BMI',
                    v: p?.bmi || "\u2014"
                }
            ].map(({ k: k, v: v })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    key: k
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        ...$9b4ee9e6346f75da$var$RECORD_LABEL,
                        marginBottom: 1
                    }
                }, k), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        fontSize: '0.8125rem',
                        color: 'var(--ink)',
                        fontWeight: 500
                    }
                }, v))))),
            /* Vitals — inline editable */ vitals: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordSection, {
                id: "vitals",
                icon: (0, $6xvbB.I).trend,
                title: t('visit.vitals.title'),
                badge: vitalsAlert ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        width: 7,
                        height: 7,
                        borderRadius: '50%',
                        flexShrink: 0,
                        display: 'inline-block',
                        background: vitalsAlert.level === 'critical' ? 'var(--danger)' : 'oklch(0.62 0.15 55)'
                    }
                }) : null,
                gist: (()=>{
                    const parts = [
                        vitals.bpSys || vitals.bpDia ? `${vitals.bpSys || "\u2014"}/${vitals.bpDia || "\u2014"}` : null,
                        vitals.spo2 ? `${vitals.spo2}% SpO\u{2082}` : null,
                        vitals.pulse ? `${vitals.pulse} bpm` : null,
                        vitals.temp ? `${vitals.temp}\xb0C` : null
                    ].filter(Boolean);
                    return parts.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                        dir: "ltr"
                    }, parts.join(" \xb7 ")) : null;
                })(),
                actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, visitStatus === 'inprogress' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dXWAH.CompleteButton), {
                    nested: true,
                    compact: true,
                    testid: "visit-vitals-complete",
                    ...completion.button('vitals'),
                    onClick: ()=>{
                        if (!recordOpen.vitals) toggleRecordSection('vitals');
                        completion.runSection('vitals');
                    }
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordHeaderAction, {
                    label: t('common.actions.viewDetails'),
                    onClick: ()=>setShowVitalsModal(true),
                    testid: "record-vitals-details"
                })),
                open: recordOpen.vitals,
                onToggle: toggleRecordSection
            }, findingsCard('VITALS', {
                marginBottom: 10
            }), autoConfirm.items.some((i)=>i.kind === 'vitals' && i.state === 'live') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                "data-testid": "visit-vitals-auto",
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                    flexWrap: 'wrap',
                    marginBottom: 10,
                    fontSize: '0.6875rem',
                    lineHeight: 1.6,
                    color: 'var(--ink-2)'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ajYTu.AutoConfirmBadge), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, t('visit.autoConfirm.vitalsHint'))), vitalsAlert && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    borderRadius: 8,
                    padding: '9px 11px',
                    background: vitalsAlert.level === 'critical' ? 'var(--danger-soft)' : 'var(--warn-soft)',
                    border: `1.5px solid ${vitalsAlert.level === 'critical' ? 'oklch(0.82 0.09 25)' : 'oklch(0.85 0.06 55)'}`,
                    marginBottom: 10
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    fontWeight: 700,
                    fontSize: '0.75rem',
                    color: vitalsAlert.level === 'critical' ? 'var(--danger-ink)' : 'oklch(0.42 0.12 50)',
                    marginBottom: 3
                }
            }, vitalsAlert.level === 'critical' ? t('visit.state.criticalWarning') : t('visit.state.warning')), vitalsAlert.messages.map((m, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    key: i,
                    style: {
                        fontSize: '0.75rem',
                        color: 'var(--ink)'
                    }
                }, m)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                onClick: ()=>setVitalsAlert(null),
                style: {
                    marginTop: 4,
                    fontSize: '0.625rem',
                    background: 'none',
                    border: 'none',
                    color: 'var(--mute)',
                    cursor: 'pointer',
                    padding: 0,
                    fontFamily: 'inherit'
                }
            }, t('common.actions.close'))), vitalsMode === 'saved' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gap: 7,
                    marginBottom: 8
                }
            }, (vitals.bpSys || vitals.bpDia) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    background: 'var(--good-soft)',
                    border: '1px solid oklch(0.88 0.07 145)',
                    borderRadius: 'var(--radius)',
                    padding: '9px 11px'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    ...$9b4ee9e6346f75da$var$RECORD_LABEL,
                    marginBottom: 4
                }
            }, t('visit.vitals.bpUnit')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    fontSize: '1.25rem',
                    fontWeight: 700,
                    color: 'var(--ink)',
                    fontFamily: 'JetBrains Mono,monospace',
                    lineHeight: 1
                }
            }, vitals.bpSys || "\u2014", "/", vitals.bpDia || "\u2014")), [
                {
                    key: 'spo2',
                    label: t('patient.vitals.spo2'),
                    unit: '%'
                },
                {
                    key: 'pulse',
                    label: t('patient.vitals.hr'),
                    unit: 'bpm'
                },
                {
                    key: 'temp',
                    label: t('patient.vitals.bodyTemp'),
                    unit: "\xb0C"
                },
                {
                    key: 'weight',
                    label: t('patient.vitals.wt'),
                    unit: 'kg'
                }
            ].map(({ key: key, label: label, unit: unit })=>vitals[key] ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    key: key,
                    style: {
                        background: 'var(--good-soft)',
                        border: '1px solid oklch(0.88 0.07 145)',
                        borderRadius: 'var(--radius)',
                        padding: '9px 11px'
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        ...$9b4ee9e6346f75da$var$RECORD_LABEL,
                        marginBottom: 4
                    }
                }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        display: 'flex',
                        alignItems: 'baseline',
                        gap: 3
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        fontSize: '1.25rem',
                        fontWeight: 700,
                        color: 'var(--ink)',
                        fontFamily: 'JetBrains Mono,monospace',
                        lineHeight: 1
                    }
                }, vitals[key]), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        fontSize: '0.5625rem',
                        color: 'var(--mute)',
                        fontWeight: 500
                    }
                }, unit))) : null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                onClick: ()=>setVitalsMode('form'),
                "data-testid": "record-vitals-edit",
                style: {
                    width: '100%',
                    padding: '6px',
                    borderRadius: 'var(--radius)',
                    background: 'none',
                    border: '1px solid var(--line)',
                    fontSize: '0.75rem',
                    fontWeight: 600,
                    color: 'var(--accent-ink)',
                    cursor: 'pointer',
                    fontFamily: 'inherit'
                }
            }, t('common.actions.edit'))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gap: 7,
                    marginBottom: 8
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    gridColumn: '1 / -1',
                    ...$9b4ee9e6346f75da$var$RECORD_CARD,
                    padding: '7px 10px'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    ...$9b4ee9e6346f75da$var$RECORD_LABEL,
                    marginBottom: 4
                }
            }, t('patient.vitals.bp')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 5
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
                type: "text",
                inputMode: "decimal",
                dir: "ltr",
                value: vitals.bpSys,
                onChange: (e)=>setVitals((v)=>({
                            ...v,
                            bpSys: (0, $6xvbB.vitalDigits)(e.target.value)
                        })),
                placeholder: "120",
                style: {
                    flex: 1,
                    border: 'none',
                    outline: 'none',
                    fontSize: '1.0625rem',
                    fontWeight: 700,
                    fontFamily: 'inherit',
                    background: 'transparent',
                    color: 'var(--ink)',
                    width: 0,
                    textAlign: 'center'
                }
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    fontSize: '0.9375rem',
                    color: 'var(--mute)',
                    fontWeight: 300,
                    lineHeight: 1
                }
            }, "/"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
                type: "text",
                inputMode: "decimal",
                dir: "ltr",
                value: vitals.bpDia,
                onChange: (e)=>setVitals((v)=>({
                            ...v,
                            bpDia: (0, $6xvbB.vitalDigits)(e.target.value)
                        })),
                placeholder: "80",
                style: {
                    flex: 1,
                    border: 'none',
                    outline: 'none',
                    fontSize: '1.0625rem',
                    fontWeight: 700,
                    fontFamily: 'inherit',
                    background: 'transparent',
                    color: 'var(--ink)',
                    width: 0,
                    textAlign: 'center'
                }
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    fontSize: '0.625rem',
                    color: 'var(--mute)',
                    fontWeight: 500
                }
            }, "mmHg"))), [
                {
                    key: 'pulse',
                    label: t('patient.vitals.hr'),
                    unit: 'bpm',
                    ph: '72'
                },
                {
                    key: 'spo2',
                    label: t('patient.vitals.spo2'),
                    unit: '%',
                    ph: '98'
                },
                {
                    key: 'temp',
                    label: t('patient.vitals.bodyTemp'),
                    unit: "\xb0C",
                    ph: '37'
                },
                {
                    key: 'weight',
                    label: t('patient.vitals.wt'),
                    unit: 'kg',
                    ph: ''
                }
            ].map(({ key: key, label: label, unit: unit, ph: ph })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    key: key,
                    style: {
                        ...$9b4ee9e6346f75da$var$RECORD_CARD,
                        padding: '7px 10px'
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        ...$9b4ee9e6346f75da$var$RECORD_LABEL,
                        marginBottom: 4
                    }
                }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: 5
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
                    type: "text",
                    inputMode: "decimal",
                    dir: "ltr",
                    value: vitals[key],
                    onChange: (e)=>setVitals((v)=>({
                                ...v,
                                [key]: (0, $6xvbB.vitalDigits)(e.target.value)
                            })),
                    placeholder: ph,
                    style: {
                        flex: 1,
                        border: 'none',
                        outline: 'none',
                        fontSize: '1.0625rem',
                        fontWeight: 700,
                        fontFamily: 'inherit',
                        background: 'transparent',
                        color: 'var(--ink)',
                        width: 0
                    }
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        fontSize: '0.625rem',
                        color: 'var(--mute)',
                        fontWeight: 500
                    }
                }, unit))))), vitalsError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    borderRadius: 8,
                    padding: '7px 10px',
                    background: 'var(--danger-soft)',
                    border: '1.5px solid oklch(0.82 0.09 25)',
                    marginBottom: 8
                }
            }, vitalsError.map((m, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    key: i,
                    style: {
                        fontSize: '0.71875rem',
                        color: 'var(--danger-ink)',
                        fontWeight: 600
                    }
                }, m))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                onClick: handleSaveVitals,
                disabled: vitalsLoading,
                style: {
                    width: '100%',
                    height: 36,
                    background: 'var(--primary)',
                    color: '#fff',
                    border: 'none',
                    borderRadius: 'var(--radius)',
                    fontSize: '0.75rem',
                    fontWeight: 600,
                    cursor: vitalsLoading ? 'not-allowed' : 'pointer',
                    fontFamily: 'inherit'
                }
            }, vitalsLoading ? '...' : t('visit.vitals.record')))),
            /* Active medications */ meds: (currentMeds.length + removedMedNames.size > 0 || undoMed) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordSection, {
                id: "meds",
                icon: (0, $6xvbB.I).pill,
                title: t('patient.meds.current'),
                count: currentMeds.length,
                gist: formatList(currentMeds.slice(0, 3).map((m)=>m.display)),
                actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, currentMeds.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fGLlt.default), {
                    meds: currentMeds,
                    title: t('visit.rx.represcribeFromCurrent'),
                    onApply: represcribeMeds,
                    prescribedNames: prescribedMedNames,
                    allergies: rxAllergens,
                    testid: "current-meds-represcribe"
                }), currentMeds.length > $9b4ee9e6346f75da$var$RECORD_PREVIEW.meds && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordViewAll, {
                    onOpen: ()=>setRecordSheet('meds'),
                    testid: "record-viewall-meds"
                })),
                open: recordOpen.meds,
                onToggle: toggleRecordSection
            }, undoMed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "med-undo-banner"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: "med-undo-text"
            }, t('visit.rx.stoppedNotAdded', {
                name: undoMed.display
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                className: "med-undo-btn",
                onClick: restoreMed
            }, t('visit.orders.undo'))), currentMeds.slice(0, $9b4ee9e6346f75da$var$RECORD_PREVIEW.meds).map((m, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$MedCard, {
                    key: (m.id || m.display) + '_' + i,
                    med: m,
                    onRemove: removeMed,
                    onReprescribe: represcribeMed,
                    represcribed: prescribedMedNames.has((m.display || '').trim().toLowerCase())
                })), currentMeds.length > $9b4ee9e6346f75da$var$RECORD_PREVIEW.meds && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordMore, {
                onOpen: ()=>setRecordSheet('meds'),
                testid: "record-more-meds"
            }, "+ ", currentMeds.length - $9b4ee9e6346f75da$var$RECORD_PREVIEW.meds, " ", t('visit.rx.moreMedications'))),
            /* Active Diagnoses */ dx: (activeConds.length + removedCondIds.size > 0 || undoCond) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordSection, {
                id: "dx",
                icon: (0, $6xvbB.I).sparkle,
                title: t('patient.conditions.active'),
                count: activeConds.length,
                gist: formatList(activeConds.slice(0, 3).map((c)=>c.display)),
                actions: activeConds.length > $9b4ee9e6346f75da$var$RECORD_PREVIEW.dx ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordViewAll, {
                    onOpen: ()=>setRecordSheet('dx'),
                    testid: "record-viewall-dx"
                }) : null,
                open: recordOpen.dx,
                onToggle: toggleRecordSection
            }, undoCond && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "med-undo-banner"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: "med-undo-text"
            }, t('visit.dx.removedNamed', {
                name: undoCond.display
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                className: "med-undo-btn",
                onClick: restoreCondition
            }, t('visit.orders.undo'))), activeConds.slice(0, $9b4ee9e6346f75da$var$RECORD_PREVIEW.dx).map((c, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$CondCard, {
                    key: (c.id || c.display) + '_' + i,
                    cond: c,
                    onRemove: removeCondition,
                    onChangeType: changeCondType,
                    busy: diffTypeBusy
                })), activeConds.length > $9b4ee9e6346f75da$var$RECORD_PREVIEW.dx && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordMore, {
                onOpen: ()=>setRecordSheet('dx'),
                testid: "record-more-dx"
            }, "+ ", activeConds.length - $9b4ee9e6346f75da$var$RECORD_PREVIEW.dx, " ", t('visit.dx.moreDiagnoses'))),
            /* Conditions */ conds: patientConditions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordSection, {
                id: "conds",
                icon: (0, $6xvbB.I).notes,
                title: t('visit.patient.conditionHistory'),
                count: patientConditions.length,
                gist: formatList(patientConditions.slice(0, 3)),
                actions: patientConditions.length > $9b4ee9e6346f75da$var$RECORD_PREVIEW.conds ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordViewAll, {
                    onOpen: ()=>setRecordSheet('conds'),
                    testid: "record-viewall-conds"
                }) : null,
                open: recordOpen.conds,
                onToggle: toggleRecordSection
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 5
                }
            }, patientConditions.slice(0, $9b4ee9e6346f75da$var$RECORD_PREVIEW.conds).map((c, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    key: i,
                    style: $9b4ee9e6346f75da$var$RECORD_CHIP
                }, c)), patientConditions.length > $9b4ee9e6346f75da$var$RECORD_PREVIEW.conds && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                onClick: ()=>setRecordSheet('conds'),
                "data-testid": "record-more-conds",
                style: {
                    ...$9b4ee9e6346f75da$var$RECORD_CHIP,
                    background: 'none',
                    border: '1px dashed var(--line)',
                    color: 'var(--accent-ink)',
                    cursor: 'pointer',
                    fontFamily: 'inherit',
                    fontWeight: 600
                }
            }, "+", patientConditions.length - $9b4ee9e6346f75da$var$RECORD_PREVIEW.conds))),
            /* ── Lab results ── */ labs: labObsAll.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordSection, {
                id: "labs",
                icon: (0, $6xvbB.I).flask,
                title: t('visit.patient.labResults'),
                count: labObsAll.length,
                badge: labCriticalCount > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        fontSize: '0.625rem',
                        fontWeight: 700,
                        padding: '1px 7px',
                        borderRadius: 99,
                        background: 'var(--danger)',
                        color: '#fff',
                        flexShrink: 0
                    }
                }, t('visit.recordPanel.criticalCount', {
                    count: labCriticalCount
                })) : labAbnormalCount > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        fontSize: '0.625rem',
                        fontWeight: 700,
                        padding: '1px 7px',
                        borderRadius: 99,
                        background: 'oklch(0.88 0.08 55)',
                        color: 'oklch(0.42 0.14 55)',
                        flexShrink: 0
                    }
                }, t('visit.recordPanel.abnormalCount', {
                    count: labAbnormalCount
                })) : null,
                gist: formatList(labObsAll.slice(0, 3).map((o)=>o.display)),
                actions: labObsAll.length > $9b4ee9e6346f75da$var$RECORD_PREVIEW.labs ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordViewAll, {
                    onOpen: ()=>setRecordSheet('labs'),
                    testid: "record-viewall-labs"
                }) : null,
                open: recordOpen.labs,
                onToggle: toggleRecordSection
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1
                }
            }, labObsAll.slice(0, $9b4ee9e6346f75da$var$RECORD_PREVIEW.labs).map((obs, i, arr)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$LabResultRow, {
                    key: (obs.id || '') + '_' + i,
                    obs: obs,
                    isLast: i === arr.length - 1
                }))), labObsAll.length > $9b4ee9e6346f75da$var$RECORD_PREVIEW.labs && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordMore, {
                onOpen: ()=>setRecordSheet('labs'),
                testid: "record-more-labs"
            }, "+ ", labObsAll.length - $9b4ee9e6346f75da$var$RECORD_PREVIEW.labs, " ", t('patient.obs.result'))),
            /* ── مدارک بیمار — every document of the patient, this visit's first ── */ files: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordSection, {
                id: "files",
                icon: (0, $gXsFl.default),
                title: t('visit.patient.files'),
                count: visitFiles.all.length,
                badge: visitFiles.newCount > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    "data-testid": "record-files-new",
                    style: {
                        fontSize: '0.625rem',
                        fontWeight: 700,
                        padding: '1px 7px',
                        borderRadius: 99,
                        background: 'var(--accent-soft)',
                        color: 'var(--accent-ink)',
                        flexShrink: 0
                    }
                }, t('visit.files.newCount', {
                    count: visitFiles.newCount
                })) : null,
                gist: formatList([
                    ...new Set(visitFiles.ordered.slice(0, 3).map((f)=>(0, $1Qo7B.documentKindLabelKey)(f.kind)).filter(Boolean))
                ].map((k)=>t(k))),
                /* «افزودن فایل» lives HERE and nowhere else in the rail (PM-0036):
                 adding a document is an act on this section, and two buttons for
                 one act read as two different things. «مشاهدهٔ همه» shows whenever
                 there is a file, as on the other list sections of the glance —
                 the sheet is also where the kind filter lives. */ actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordHeaderAction, {
                    icon: (0, $6xvbB.I).plus,
                    label: t('visit.patient.addFile'),
                    onClick: ()=>clinicalFiles.openUpload(),
                    testid: "record-files-add"
                }), visitFiles.all.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordViewAll, {
                    onOpen: ()=>{
                        setFileKindFilter(null);
                        setRecordSheet('files');
                    },
                    testid: "record-viewall-files"
                })),
                open: recordOpen.files !== false,
                onToggle: toggleRecordSection
            }, visitFiles.all.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                "data-testid": "record-files-empty",
                "data-state": "empty",
                style: $9b4ee9e6346f75da$var$RECORD_EMPTY
            }, t('patient.files.empty')) : /* PM-0560: every document as a picture, this visit's first; a tile
                   opens the gallery on it, where the doctor pages through the rest
                   without closing anything. The rows stay in «مشاهدهٔ همه». */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                "data-testid": "record-files",
                "data-state": "content"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $zi6VT.FileStrip), {
                files: visitFiles.ordered,
                current: null,
                onSelect: (f)=>clinicalFiles.openGallery(f, visitFiles.ordered),
                tileClassName: "w-[6.5rem]",
                testid: "record-files-strip",
                badgeFor: currentVisitId ? (f)=>f.appointmentId === currentVisitId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                        style: {
                            fontSize: '0.625rem',
                            fontWeight: 700,
                            padding: '1px 6px',
                            borderRadius: 99,
                            background: 'var(--accent-soft)',
                            color: 'var(--accent-ink)'
                        }
                    }, t('patient.files.gallery.thisVisit')) : null : null
            }))),
            /* ── سوابق ویزیت‌های قبلی ── */ /* Preview only: three rows, each already carrying diagnoses and the
              drug/order counts. Full detail opens in the sheet, never in place —
              this column is the app's longest scroll already. */ history: (railVisits.length > 0 || pastVisitSummaries === null) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordSection, {
                id: "history",
                icon: (0, $6xvbB.I).history,
                title: t('visit.history.title'),
                count: pastVisits.length,
                gist: railVisits[0]?.scheduledDate ? formatRelativeTime(railVisits[0].scheduledDate) : null,
                actions: pastVisits.length > railVisits.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordViewAll, {
                    onOpen: ()=>{
                        setExpandedEncId(null);
                        setHistoryOpen(true);
                    },
                    testid: "visit-history-view-all"
                }) : null,
                open: recordOpen.history,
                onToggle: toggleRecordSection
            }, pastVisitSummaries === null && !railVisits.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fWbIA.VisitHistoryRailSkeleton), {
                count: 3
            }) : railVisits.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 6
                },
                "data-testid": "visit-history-rail"
            }, railVisits.map((v)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$export$b320a358c3c13da4, {
                    key: v.id,
                    visit: v,
                    ctx: visitCtx[v.id],
                    summary: summaryMap.get(String(v.id)),
                    onOpen: (id)=>{
                        setExpandedEncId(id);
                        loadVisitContext(id);
                        setHistoryOpen(true);
                    },
                    onReprescribe: represcribeMeds,
                    prescribedNames: prescribedMedNames,
                    allergies: rxAllergens,
                    erxCodes: pastErxCodes.get(String(v.id))
                }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: $9b4ee9e6346f75da$var$RECORD_EMPTY
            }, t('visit.history.empty')))
        };
        return (0, $aoLHg.visibleRecordSections)(visitLayout).map(({ id: id })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), {
                key: id
            }, recordBlocks[id]));
    })(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $16oOu.default), {
        call: call,
        patientName: p?.name,
        dock: "bottom"
    })))), historyOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$export$8be8592afbe60619, {
        visits: pastVisits,
        ctxById: visitCtx,
        summaryMap: summaryMap,
        expandedId: expandedEncId,
        onExpand: (id)=>{
            setExpandedEncId(id);
            if (id) loadVisitContext(id);
        },
        onClose: ()=>setHistoryOpen(false),
        onReprescribe: represcribeMed,
        onReprescribeMany: represcribeMeds,
        onLoadContext: loadVisitContext,
        prescribedNames: prescribedMedNames,
        allergies: rxAllergens,
        onReorder: reorderPastOrder,
        isOrdered: isOrderedNow,
        reorderingId: reorderingOrderId,
        erxCodes: pastErxCodes
    }), glanceOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$PatientGlanceModal, {
        patient: p,
        conditions: patientConditions,
        activeConds: activeConds,
        visits: railVisits,
        ctxById: visitCtx,
        currentMeds: currentMeds,
        abnormalLabs: labObsAll.filter((o)=>o.status === 'CRITICAL' || o.status === 'ABNORMAL'),
        vitalsAlert: vitalsAlert,
        hasMoreVisits: pastVisits.length > 0,
        onOpenHistory: ()=>{
            setGlanceOpen(false);
            setExpandedEncId(null);
            setHistoryOpen(true);
        },
        onViewAllMeds: ()=>{
            setGlanceOpen(false);
            setRecordSheet('meds');
        },
        onViewAllDx: ()=>{
            setGlanceOpen(false);
            setRecordSheet('dx');
        },
        onClose: ()=>setGlanceOpen(false)
    }), recordSheet === 'meds' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordListSheet, {
        icon: (0, $6xvbB.I).pill,
        title: t('patient.meds.current'),
        count: currentMeds.length,
        onClose: ()=>setRecordSheet(null),
        testid: "record-sheet-meds"
    }, currentMeds.map((m, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$MedCard, {
            key: (m.id || m.display) + '_' + i,
            med: m,
            onRemove: removeMed,
            onReprescribe: represcribeMed,
            represcribed: prescribedMedNames.has((m.display || '').trim().toLowerCase())
        }))), recordSheet === 'dx' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordListSheet, {
        icon: (0, $6xvbB.I).sparkle,
        title: t('patient.conditions.active'),
        count: activeConds.length,
        onClose: ()=>setRecordSheet(null),
        testid: "record-sheet-dx"
    }, activeConds.map((c, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$CondCard, {
            key: (c.id || c.display) + '_' + i,
            cond: c,
            onRemove: removeCondition,
            onChangeType: changeCondType,
            busy: diffTypeBusy
        }))), recordSheet === 'conds' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordListSheet, {
        icon: (0, $6xvbB.I).notes,
        title: t('visit.patient.conditionHistory'),
        count: patientConditions.length,
        onClose: ()=>setRecordSheet(null),
        testid: "record-sheet-conds"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: 5
        }
    }, patientConditions.map((c, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            key: i,
            style: $9b4ee9e6346f75da$var$RECORD_CHIP
        }, c)))), recordSheet === 'labs' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordListSheet, {
        icon: (0, $6xvbB.I).flask,
        title: t('visit.patient.labResults'),
        count: labObsAll.length,
        onClose: ()=>setRecordSheet(null),
        testid: "record-sheet-labs"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 1
        }
    }, labObsAll.map((obs, i, arr)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$LabResultRow, {
            key: (obs.id || '') + '_' + i,
            obs: obs,
            isLast: i === arr.length - 1
        })))), recordSheet === 'files' && (()=>{
        const kinds = [
            ...new Set(visitFiles.all.map((f)=>(0, $1Qo7B.canonicalKind)(f.kind)).filter(Boolean))
        ];
        const shown = fileKindFilter ? visitFiles.ordered.filter((f)=>(0, $1Qo7B.canonicalKind)(f.kind) === fileKindFilter) : visitFiles.ordered;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9b4ee9e6346f75da$var$RecordListSheet, {
            icon: (0, $gXsFl.default),
            title: t('visit.patient.files'),
            count: visitFiles.all.length,
            onClose: ()=>setRecordSheet(null),
            testid: "record-sheet-files"
        }, kinds.length > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": "record-files-kinds",
            style: {
                display: 'flex',
                flexWrap: 'wrap',
                gap: 6,
                marginBottom: 8
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $h4ZeB.default), {
            label: t('common.state.all'),
            active: !fileKindFilter,
            onClick: ()=>setFileKindFilter(null)
        }), kinds.map((k)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $h4ZeB.default), {
                key: k,
                label: t((0, $1Qo7B.DOCUMENT_KIND_LABEL_KEYS)[k]),
                active: fileKindFilter === k,
                onClick: ()=>setFileKindFilter(k),
                "data-testid": `record-files-kind-${k}`
            }))), renderVisitFileList(shown, true));
    })(), clinicalFiles.overlays, patient?.id && true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gRy9t.default), {
        patientId: patient.id,
        onChange: refreshPatient
    }), showVitalsModal && (()=>{
        const VITAL_META = {
            '8480-6': {
                label: 'BP sys',
                unit: 'mmHg',
                status: (v)=>v > 140 || v < 90 ? 'crit' : v > 120 ? 'warn' : 'ok'
            },
            '8462-4': {
                label: 'BP dia',
                unit: 'mmHg',
                status: (v)=>v > 90 || v < 60 ? 'crit' : v > 80 ? 'warn' : 'ok'
            },
            '8867-4': {
                label: t('visit.vitals.pulse'),
                unit: 'bpm',
                status: (v)=>v > 110 || v < 50 ? 'crit' : v > 100 || v < 60 ? 'warn' : 'ok'
            },
            '59408-5': {
                label: "SpO\u2082",
                unit: '%',
                status: (v)=>v < 92 ? 'crit' : v < 95 ? 'warn' : 'ok'
            },
            '8310-5': {
                label: t('patient.vitals.temp'),
                unit: "\xb0C",
                status: (v)=>v > 38.5 || v < 36 ? 'crit' : v > 37.2 ? 'warn' : 'ok'
            },
            '29463-7': {
                label: t('patient.vitals.wt'),
                unit: 'kg',
                status: ()=>'ok'
            }
        };
        const STATUS_COLOR = {
            ok: 'var(--good)',
            warn: 'var(--warn)',
            crit: 'var(--danger)'
        };
        const STATUS_BG = {
            ok: 'var(--good-soft)',
            warn: 'var(--warn-soft)',
            crit: 'var(--danger-soft)'
        };
        const vGroups = {};
        (patient?.clinicalObservations || []).forEach((obs)=>{
            const meta = VITAL_META[obs.code];
            if (!meta) return;
            const val = parseFloat(obs.value);
            if (isNaN(val)) return;
            if (!vGroups[obs.code]) vGroups[obs.code] = {
                ...meta,
                code: obs.code,
                pts: []
            };
            vGroups[obs.code].pts.push({
                date: obs.effectiveDate,
                value: val
            });
        });
        const cards = Object.values(vGroups);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                position: 'fixed',
                inset: 0,
                zIndex: 1100,
                background: 'rgba(28,27,24,.55)',
                backdropFilter: 'blur(4px)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 20
            },
            onClick: (e)=>e.target === e.currentTarget && setShowVitalsModal(false)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                background: 'var(--panel)',
                borderRadius: 16,
                width: '100%',
                maxWidth: 680,
                maxHeight: '80vh',
                display: 'flex',
                flexDirection: 'column',
                boxShadow: '0 24px 64px rgba(0,0,0,0.22)',
                overflow: 'hidden'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                padding: '16px 20px',
                borderBottom: '1px solid var(--line)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                flexShrink: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.9375rem',
                fontWeight: 700,
                color: 'var(--ink)'
            }
        }, t('visit.vitals.history')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            onClick: ()=>setShowVitalsModal(false),
            style: {
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                fontSize: '1.25rem',
                color: 'var(--mute)',
                lineHeight: 1
            }
        }, "\xd7")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1,
                overflowY: 'auto',
                padding: '16px 20px'
            }
        }, cards.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                textAlign: 'center',
                color: 'var(--mute)',
                fontSize: '0.8125rem',
                padding: '32px 0'
            }
        }, t('visit.patient.noHistory')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'grid',
                gridTemplateColumns: '1fr 1fr 1fr',
                gap: 10
            }
        }, cards.map((m)=>{
            const sorted = [
                ...m.pts
            ].sort((a, b)=>new Date(a.date) - new Date(b.date));
            const last = sorted[sorted.length - 1];
            const prev = sorted[sorted.length - 2];
            const st = m.status(last.value);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.VitalCard), {
                key: m.code,
                m: m,
                clr: STATUS_COLOR[st],
                bg: STATUS_BG[st],
                last: last,
                prev: prev,
                sorted: sorted
            });
        })))));
    })(), showEditPatient && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.Dialog), {
        open: true,
        onOpenChange: (o)=>{
            if (!o) setShowEditPatient(false);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogTitle), null, t('visit.patient.edit'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 12
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
        label: t('common.labels.name'),
        value: editPatientForm.name || '',
        onChange: (e)=>setEditPatientForm((f)=>({
                    ...f,
                    name: e.target.value
                })),
        placeholder: t('visit.patient.fullName')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lffTJ.default), {
        label: t('common.labels.phone'),
        value: editPatientForm.phone || '',
        key: phoneCountry || '',
        defaultCountry: phoneCountry,
        onChange: (phone)=>setEditPatientForm((f)=>({
                    ...f,
                    phone: phone
                }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $Ydgp5.default), {
        label: t('common.labels.nationalId'),
        value: editPatientForm.nationalId || '',
        allowOtherCountries: true,
        defaultCountry: nidDefault,
        onChange: (e)=>setEditPatientForm((f)=>({
                    ...f,
                    nationalId: e.target.value
                })),
        onCountryChange: (c)=>setEditPatientForm((f)=>({
                    ...f,
                    nationalIdCountry: c
                })),
        "data-testid": "visit-edit-patient-nid"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7phmx.default), {
        label: t('common.labels.birthDate')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4Qco3.default), {
        value: editPatientForm.birthDate || '',
        onChange: (v)=>setEditPatientForm((f)=>({
                    ...f,
                    birthDate: v
                })),
        height: 40,
        placeholder: t('visit.patient.birthDatePlaceholder'),
        disableFuture: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
        label: t('visit.patient.occupation'),
        value: editPatientForm.job || '',
        onChange: (e)=>setEditPatientForm((f)=>({
                    ...f,
                    job: e.target.value
                })),
        placeholder: t('visit.patient.occupation')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
        label: t('visit.vitals.height'),
        type: "number",
        dir: "ltr",
        value: editPatientForm.height || '',
        onChange: (e)=>setEditPatientForm((f)=>({
                    ...f,
                    height: e.target.value
                })),
        placeholder: "175"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fAR2n.default), {
        label: t('visit.patient.bloodType'),
        value: editPatientForm.bloodType || '',
        onChange: (e)=>setEditPatientForm((f)=>({
                    ...f,
                    bloodType: e.target.value
                })),
        placeholder: t('common.actions.select'),
        options: [
            'A+',
            'A-',
            'B+',
            'B-',
            'AB+',
            'AB-',
            'O+',
            'O-'
        ].map((bt)=>({
                value: bt,
                label: bt
            }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fAR2n.default), {
        label: t('visit.patient.insurance'),
        value: editPatientForm.insurance || '',
        onChange: (e)=>setEditPatientForm((f)=>({
                    ...f,
                    insurance: e.target.value
                })),
        placeholder: t('common.actions.select'),
        options: [
            {
                value: 'social',
                label: t('patient.insurance.social')
            },
            {
                value: 'health',
                label: t('patient.insurance.health')
            },
            {
                value: 'military',
                label: t('patient.insurance.military')
            },
            {
                value: 'other',
                label: t('patient.insurance.other')
            }
        ]
    }), editPatientError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.75rem',
            color: 'var(--danger-ink)',
            fontWeight: 600
        }
    }, editPatientError), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $jbdF9.default), {
        onCancel: ()=>setShowEditPatient(false),
        cancelLabel: t('common.actions.cancel'),
        saveLabel: editPatientSaving ? t('common.state.saving') : t('common.actions.save'),
        onSave: async ()=>{
            if (editPatientSaving) return;
            // A changed code must pass its country's rule; an unchanged one is
            // the record's and is not re-judged here.
            if (editPatientForm.nationalId !== (p?.nationalId || '') && (0, $3tGMU).nationalIdProblem(editPatientForm.nationalId, {
                country: editPatientForm.nationalIdCountry || nidDefault
            })) {
                setEditPatientError(t('validation.nationalId'));
                return;
            }
            setEditPatientSaving(true);
            setEditPatientError('');
            try {
                const u = {};
                if (editPatientForm.name !== (p?.name || '')) u.name = editPatientForm.name;
                if (editPatientForm.phone !== (p?.phone || '')) u.phone = editPatientForm.phone;
                if (editPatientForm.nationalId !== (p?.nationalId || '')) u.nationalId = editPatientForm.nationalId;
                if (editPatientForm.birthDate !== (p?.birthDate || '')) u.birthDate = editPatientForm.birthDate;
                if (editPatientForm.bloodType !== (p?.bloodType || '')) u.bloodType = editPatientForm.bloodType;
                if (editPatientForm.job !== (p?.job || '')) u.job = editPatientForm.job;
                if (editPatientForm.insurance !== (p?.insurance || '')) u.insurance = editPatientForm.insurance;
                const nh = parseFloat(editPatientForm.height);
                if (!Number.isNaN(nh) && nh !== p?.height) u.height = nh;
                if (Object.keys(u).length) {
                    await (0, $eVM84.bffMutation)((0, $6xvbB.UPDATE_PATIENT), {
                        id: p.id,
                        input: u
                    });
                    await refreshPatient();
                }
                setShowEditPatient(false);
            } catch (e) {
                // The BFF's messageKey in the doctor's language — a claimed patient's
                // identity, a number the patient proved (PM-0539, PM-0536).
                setEditPatientError((0, $bkBaq.patientEditErrorText)(t, has, e, 'errors.save.patientEdit'));
            } finally{
                setEditPatientSaving(false);
            }
        }
    })))), endProgress.running && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5iiH3.default), {
        steps: endProgress.steps
    }), activeVisitConflict && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'fixed',
            inset: 0,
            zIndex: 200,
            background: 'rgba(20,20,20,.6)',
            backdropFilter: 'blur(5px)',
            display: 'grid',
            placeItems: 'center',
            padding: 20,
            animation: 'fadeIn .18s ease'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: 'var(--panel-2)',
            borderRadius: 20,
            padding: '32px 28px',
            border: '1px solid var(--line)',
            boxShadow: 'var(--shadow-pop)',
            width: '100%',
            maxWidth: 400,
            textAlign: 'start',
            animation: 'fadeUp .2s ease'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            justifyContent: 'center',
            marginBottom: 20
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 56,
            height: 56,
            borderRadius: '50%',
            background: 'rgba(245,158,11,.12)',
            border: '1.5px solid rgba(245,158,11,.35)',
            display: 'grid',
            placeItems: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: "26",
        height: "26",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "#f59e0b",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
        x1: "12",
        y1: "9",
        x2: "12",
        y2: "13"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
        x1: "12",
        y1: "17",
        x2: "12.01",
        y2: "17"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            textAlign: 'center',
            marginBottom: 8,
            fontSize: '1rem',
            fontWeight: 700,
            color: 'var(--text)'
        }
    }, t('visit.resume.activeTitle')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            textAlign: 'center',
            marginBottom: 28,
            fontSize: '0.8125rem',
            color: 'var(--mute)',
            lineHeight: 1.8
        }
    }, t('visit.resume.activeShort'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("br", null), t('visit.resume.activeChoice')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 10
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: handleResumeConflictVisit,
        style: {
            width: '100%',
            padding: '12px 0',
            borderRadius: 12,
            background: 'var(--accent)',
            border: 'none',
            color: '#fff',
            fontSize: '0.875rem',
            fontWeight: 700,
            cursor: 'pointer',
            fontFamily: 'inherit',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
        points: "5 3 19 12 5 21 5 3"
    })), t('visit.resume.continuePrevious')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: handleCloseConflictVisit,
        style: {
            width: '100%',
            padding: '12px 0',
            borderRadius: 12,
            background: 'rgba(239,68,68,.08)',
            border: '1px solid rgba(239,68,68,.25)',
            color: '#ef4444',
            fontSize: '0.875rem',
            fontWeight: 600,
            cursor: 'pointer',
            fontFamily: 'inherit',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: "3",
        y: "3",
        width: "18",
        height: "18",
        rx: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
        x1: "9",
        y1: "9",
        x2: "15",
        y2: "15"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
        x1: "15",
        y1: "9",
        x2: "9",
        y2: "15"
    })), t('visit.resume.closeAndStart')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: ()=>setActiveVisitConflict(null),
        style: {
            width: '100%',
            padding: '9px 0',
            borderRadius: 10,
            background: 'transparent',
            border: 'none',
            color: 'var(--mute)',
            fontSize: '0.8125rem',
            cursor: 'pointer',
            fontFamily: 'inherit'
        }
    }, t('common.actions.cancel'))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5qFC5.default), {
        error: recError,
        onRetry: startRec,
        onClose: dismissError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hScMH.default), {
        open: endServicesOpen,
        onOpenChange: (o)=>{
            if (!o && !endServices.running) {
                setEndServicesOpen(false);
                endServices.close();
            }
        },
        items: endServices.items,
        answers: endServices.answers,
        failures: endServices.failures,
        running: endServices.running,
        onAnswer: endServices.setAnswer,
        onConfirm: ()=>endServices.run(async ()=>{
                setEndServicesOpen(false);
                endServices.close();
                await runEnd();
                return 'done';
            })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e7Ndt.default), {
        open: pendingEnd,
        onOpenChange: setPendingEnd,
        patientName: patient?.name,
        recording: isRecording,
        onConfirm: runEnd
    }), showClosureFlow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $jOg3R.default), {
        patient: patient,
        doctor: doctor,
        soap: soap,
        rxItems: rxItems,
        pendingTests: pendingTests,
        diagnosis: diagnosis,
        acceptedDifferential: (differential || []).filter((0, $6xvbB.isDifferentialAccepted)),
        prescriptionTemplates: prescriptionTemplates,
        appointmentId: visitId,
        saveFailures: saveFailures,
        failedGroups: failedGroups,
        retrying: retrying,
        onRetryFailed: retryFailed,
        endedAt: endedAt,
        durationMin: durationMin,
        coins: {
            entries: coinLedger,
            total: visitCoins
        },
        onExit: goToReception,
        onViewRecord: ()=>navProp('patient-detail', {
                id: patient?.id
            })
    }));
}

});
parcelRegister("cVuA6", function(module, exports) {

$parcel$export(module.exports, "default", () => $95619a68e42b6cf6$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $jTCZr = parcelRequire("jTCZr");

var $eAIjx = parcelRequire("eAIjx");

var $3EzBq = parcelRequire("3EzBq");
/**
 * VisitCoinUsage — the ONE coin readout on the Visit page.
 *
 * The page used to price itself in place: a cost chip next to every AI button
 * («۱۰» beside «تکمیل متن ویزیت», «۵ / دقیقه» beside the recorder, …). That put
 * a price tag in the doctor's eye-line during the visit and still never
 * answered the only question worth asking — *what has this visit cost so far?*
 * All of those chips are gone; this badge in the page header replaces them.
 *
 * Closed, it is the running total. Opened — hover, focus, or click to pin — it
 * breaks that total down by the component that spent it, so «۳۸ پارسه» becomes
 * «رونویسی ۲۰ · برنامه درمانی ۱۰ · تداخل دارویی ۳ …». Hover is the discovery
 * path and click is the reading path: a hover popover that vanishes when the
 * pointer travels toward it cannot be read, so a click pins it open until the
 * next click outside (or Escape).
 *
 * Props:
 *   entries — [{ id, coins, count }] where `id` is a PRICE_LIST id, `coins` the
 *             running total for that component and `count` how many times it
 *             ran. Unknown ids are rendered with the id itself rather than
 *             dropped: a missing row would silently make the total not add up.
 *   total   — coins spent in this visit (the caller's sum, not re-derived here).
 */ /**
 * Framework tokens, not the Visit workspace's private `--…` set — the same
 * rule, for the same reason, as `VisitCall.jsx`.
 *
 * Both apps stamp `data-panel` on <html>, and tokens.css's
 * `:root[data-panel=…]` redefines `--accent` as a bare HSL triplet for the
 * Tailwind layer. That selector outranks the page's injected `:root`, so here
 * `var(--accent)` was an invalid colour: the browser dropped the declaration,
 * kept the literal `#fff` beside it, and opening the breakdown turned the badge
 * into white text on a white header — it vanished exactly when clicked.
 */ const $95619a68e42b6cf6$var$S = {
    accent: (0, $jTCZr.CT).accent,
    accentSoft: (0, $jTCZr.CT).accentSoft,
    accentInk: (0, $jTCZr.CT).accentInk,
    panel: (0, $jTCZr.CT).surface,
    line: (0, $jTCZr.CT).border,
    ink: (0, $jTCZr.CT).ink,
    mute: (0, $jTCZr.CT).mute
};
function $95619a68e42b6cf6$export$2e2bcd8739ae039({ entries: entries = [], total: total = 0, testid: testid = 'visit-coin-usage' }) {
    const { t: t, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const [open, setOpen] = (0, $acw62.useState)(false);
    const [pinned, setPinned] = (0, $acw62.useState)(false);
    const wrapRef = (0, $acw62.useRef)(null);
    // Pinned means "the doctor asked to read this": it survives the pointer
    // leaving, and only an outside click or Escape takes it back.
    (0, $acw62.useEffect)(()=>{
        if (!pinned) return undefined;
        const onDocDown = (e)=>{
            if (wrapRef.current && !wrapRef.current.contains(e.target)) {
                setPinned(false);
                setOpen(false);
            }
        };
        const onKey = (e)=>{
            if (e.key === 'Escape') {
                setPinned(false);
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', onDocDown);
        document.addEventListener('keydown', onKey);
        return ()=>{
            document.removeEventListener('mousedown', onDocDown);
            document.removeEventListener('keydown', onKey);
        };
    }, [
        pinned
    ]);
    // Biggest spender first — the breakdown is read to find where the coins went.
    const rows = (0, $acw62.useMemo)(()=>{
        const labelKeyById = Object.fromEntries((0, $3EzBq.PRICE_LIST).map((p)=>[
                p.id,
                p.labelKey
            ]));
        return [
            ...entries
        ].filter((e)=>e && e.coins > 0).sort((a, b)=>b.coins - a.coins).map((e)=>({
                ...e,
                label: labelKeyById[e.id] ? t(labelKeyById[e.id]) : e.id
            }));
    }, [
        entries,
        t
    ]);
    const show = ()=>setOpen(true);
    const hide = ()=>{
        if (!pinned) setOpen(false);
    };
    const toggle = ()=>{
        setPinned((p)=>{
            const next = !p;
            setOpen(next);
            return next;
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        ref: wrapRef,
        style: {
            position: 'relative',
            display: 'inline-flex'
        },
        onMouseEnter: show,
        onMouseLeave: hide
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        "data-testid": testid,
        // The visible total is locale-formatted (Persian digits by default);
        // this is the same number in a form a test — or a screenshot diff —
        // can assert on without re-implementing the formatter.
        "data-coins": total,
        onClick: toggle,
        onFocus: show,
        onBlur: hide,
        "aria-expanded": open,
        "aria-haspopup": "dialog",
        "aria-label": t('visit.coins.aria', {
            coins: (0, $3EzBq.fmtCoins)(total, formatNumber)
        }),
        title: t('visit.coins.hint'),
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6,
            padding: '5px 11px',
            borderRadius: 999,
            cursor: 'pointer',
            fontFamily: 'inherit',
            fontSize: '0.75rem',
            fontWeight: 700,
            lineHeight: 1.6,
            background: open ? $95619a68e42b6cf6$var$S.accent : $95619a68e42b6cf6$var$S.accentSoft,
            color: open ? '#fff' : $95619a68e42b6cf6$var$S.accentInk,
            border: `1px solid ${$95619a68e42b6cf6$var$S.accent}`,
            whiteSpace: 'nowrap'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eAIjx.CoinGlyph), {
        size: 13
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontVariantNumeric: 'tabular-nums'
        }
    }, (0, $3EzBq.fmtCoins)(total, formatNumber)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontWeight: 600,
            opacity: 0.85
        }
    }, t('common.units.coin'))), open && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "dialog",
        "aria-label": t('visit.coins.panelTitle'),
        "data-testid": `${testid}-panel`,
        style: {
            position: 'absolute',
            top: 'calc(100% + 7px)',
            insetInlineEnd: 0,
            zIndex: 80,
            width: 268,
            maxHeight: 320,
            overflowY: 'auto',
            background: $95619a68e42b6cf6$var$S.panel,
            border: `1px solid ${$95619a68e42b6cf6$var$S.line}`,
            borderRadius: 10,
            boxShadow: '0 10px 28px rgba(15,23,42,.16)',
            padding: '10px 12px 8px',
            textAlign: 'start'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.71875rem',
            fontWeight: 700,
            color: $95619a68e42b6cf6$var$S.ink,
            marginBottom: 2
        }
    }, t('visit.coins.panelTitle')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.65625rem',
            color: $95619a68e42b6cf6$var$S.mute,
            marginBottom: 8
        }
    }, t('visit.coins.hint')), rows.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${testid}-empty`,
        style: {
            fontSize: '0.71875rem',
            color: $95619a68e42b6cf6$var$S.mute,
            lineHeight: 1.9,
            padding: '4px 0 8px'
        }
    }, t('visit.coins.empty')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, rows.map((row)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: row.id,
            "data-testid": `${testid}-row-${row.id}`,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                padding: '5px 0',
                borderBottom: `1px dashed ${$95619a68e42b6cf6$var$S.line}`,
                fontSize: '0.71875rem',
                color: $95619a68e42b6cf6$var$S.ink
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                flex: 1,
                minWidth: 0
            }
        }, row.label), row.count > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.625rem',
                color: $95619a68e42b6cf6$var$S.mute,
                flexShrink: 0
            }
        }, t('visit.coins.times', {
            count: row.count
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontWeight: 700,
                fontVariantNumeric: 'tabular-nums',
                flexShrink: 0,
                display: 'inline-flex',
                alignItems: 'center',
                gap: 3,
                color: $95619a68e42b6cf6$var$S.accentInk
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eAIjx.CoinGlyph), {
            size: 10
        }), (0, $3EzBq.fmtCoins)(row.coins, formatNumber))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${testid}-total`,
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 8,
            paddingTop: 8,
            marginTop: 2,
            fontSize: '0.75rem',
            fontWeight: 800,
            color: $95619a68e42b6cf6$var$S.ink
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, t('visit.coins.total')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 4,
            fontVariantNumeric: 'tabular-nums',
            color: $95619a68e42b6cf6$var$S.accentInk
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eAIjx.CoinGlyph), {
        size: 11
    }), (0, $3EzBq.fmtCoins)(total, formatNumber), " ", t('common.units.coin')))));
}

});

parcelRegister("fGLlt", function(module, exports) {

$parcel$export(module.exports, "default", () => $b69acda6ae3622c4$export$2e2bcd8739ae039);
// ─────────────────────────────────────────────────────────────────────────────
// «تجویز مجدد» — refill several drugs at once, picked off a list.
//
// The batch twin of the per-drug refill buttons: it sits on the «داروهای جاری»
// header and on every past visit in «سوابق ویزیت‌های قبلی», and opens the same
// review step «افزودن از قالب نسخه» has — every drug with a tick, «همه» /
// «هیچ‌کدام», and one commit button. Same interaction because it is the same
// task: take a known list of drugs and leave out what this visit should not get.
//
// Ticked by default, except a drug already on the نسخه (shown as «در نسخه»,
// never added twice) and a recorded-allergy match (unticked, and it says why).
//
// It decides nothing about what refilling MEANS — `onApply` receives the chosen
// medication records and the screen puts them on the نسخه the way its single
// refill does, so both doors keep producing identical rows.
//
// The trigger is a `span role="button"`, not a button: both places it lives are
// themselves whole-row buttons (the section header, the visit row). The popover
// is portalled to escape the record column's overflow, and it stops click
// propagation because React bubbles portal events up the COMPONENT tree — a tick
// would otherwise also toggle the section or open the visit behind it. Colours
// come from the token module for the reason TemplateApplyButton records.
// ─────────────────────────────────────────────────────────────────────────────

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $cvBw3 = parcelRequire("cvBw3");
const $b69acda6ae3622c4$var$PAL = {
    panel: (0, $jTCZr.CT).surface,
    line: (0, $jTCZr.CT).border,
    line2: (0, $jTCZr.CT).border2,
    ink: (0, $jTCZr.CT).ink,
    ink2: (0, $jTCZr.CT).ink2,
    mute: (0, $jTCZr.CT).mute,
    accent: (0, $jTCZr.CT).accent,
    accentInk: (0, $jTCZr.CT).accentInk,
    dangerSoft: (0, $jTCZr.CT).dangerSoft,
    dangerInk: (0, $jTCZr.CT).dangerInk,
    shadowPop: '0 8px 28px rgba(15,23,42,.10), 0 2px 6px rgba(15,23,42,.06)'
};
const $b69acda6ae3622c4$export$5474f41aa0731c97 = 330;
const $b69acda6ae3622c4$export$a2958ba5d3e441bd = 420;
const $b69acda6ae3622c4$var$POP_GAP = 8;
// Above the history sheet (1200) it is opened from, below nothing else it can
// share the screen with.
const $b69acda6ae3622c4$var$POP_Z = 1300;
// Clearance between trigger and popover, and the least usable list height.
const $b69acda6ae3622c4$var$POP_OFFSET = 6;
const $b69acda6ae3622c4$var$POP_MIN_HEIGHT = 120;
function $b69acda6ae3622c4$export$1534ebe230218d96(rect, vw, vh, isRTL) {
    let left = isRTL ? rect.left : rect.right - $b69acda6ae3622c4$export$5474f41aa0731c97;
    if (vw) left = Math.max($b69acda6ae3622c4$var$POP_GAP, Math.min(left, vw - $b69acda6ae3622c4$export$5474f41aa0731c97 - $b69acda6ae3622c4$var$POP_GAP));
    // No viewport to measure (jsdom, a detached render): keep the simple placement.
    if (!vh) return {
        top: rect.bottom + $b69acda6ae3622c4$var$POP_OFFSET,
        left: left,
        maxHeight: $b69acda6ae3622c4$export$a2958ba5d3e441bd
    };
    const below = vh - rect.bottom - $b69acda6ae3622c4$var$POP_OFFSET - $b69acda6ae3622c4$var$POP_GAP;
    const above = rect.top - $b69acda6ae3622c4$var$POP_OFFSET - $b69acda6ae3622c4$var$POP_GAP;
    // Flip only when it actually helps — a cramped viewport keeps the list below,
    // where the doctor's eye already is.
    const flip = below < Math.min($b69acda6ae3622c4$export$a2958ba5d3e441bd, 240) && above > below;
    const room = Math.max($b69acda6ae3622c4$var$POP_MIN_HEIGHT, Math.min($b69acda6ae3622c4$export$a2958ba5d3e441bd, flip ? above : below));
    const top = flip ? Math.max($b69acda6ae3622c4$var$POP_GAP, rect.top - $b69acda6ae3622c4$var$POP_OFFSET - room) : Math.min(rect.bottom + $b69acda6ae3622c4$var$POP_OFFSET, Math.max($b69acda6ae3622c4$var$POP_GAP, vh - room - $b69acda6ae3622c4$var$POP_GAP));
    return {
        top: top,
        left: left,
        maxHeight: room
    };
}
const $b69acda6ae3622c4$var$medName = (m)=>(m?.display || m?.code || '').trim();
const $b69acda6ae3622c4$var$medKey = (m)=>$b69acda6ae3622c4$var$medName(m).toLowerCase();
const $b69acda6ae3622c4$var$medDose = (m)=>{
    const di = m?.dosageInstruction;
    return typeof di === 'string' ? di : di?.text || '';
};
function $b69acda6ae3622c4$export$2e2bcd8739ae039({ meds: meds = [], state: state = 'ready', title: title, onOpen: onOpen, onApply: onApply, prescribedNames: prescribedNames, allergies: allergies = [], testid: testid = 'represcribe' }) {
    const { t: t, formatNumber: formatNumber, isRTL: isRTL } = (0, $LNQP4.default)();
    const [open, setOpen] = (0, $acw62.useState)(false);
    const [selected, setSelected] = (0, $acw62.useState)(new Set());
    const [applying, setApplying] = (0, $acw62.useState)(false);
    const [pos, setPos] = (0, $acw62.useState)(null);
    const rootRef = (0, $acw62.useRef)(null);
    const popRef = (0, $acw62.useRef)(null);
    const initialised = (0, $acw62.useRef)(false);
    const rows = (0, $acw62.useMemo)(()=>(meds || []).filter((m)=>$b69acda6ae3622c4$var$medName(m)).map((m, i)=>({
                i: i,
                med: m,
                already: Boolean(prescribedNames?.has($b69acda6ae3622c4$var$medKey(m))),
                allergy: (0, $cvBw3.allergyHit)({
                    name: $b69acda6ae3622c4$var$medName(m)
                }, allergies)
            })), [
        meds,
        prescribedNames,
        allergies
    ]);
    const selectable = rows.filter((r)=>!r.already);
    const close = (0, $acw62.useCallback)(()=>{
        setOpen(false);
        initialised.current = false;
    }, []);
    // Tick the defaults once the list is there — immediately for current
    // medications, after the context arrives for a past visit.
    (0, $acw62.useEffect)(()=>{
        if (!open || state !== 'ready' || initialised.current) return;
        initialised.current = true;
        setSelected(new Set(rows.filter((r)=>!r.already && !r.allergy).map((r)=>r.i)));
    }, [
        open,
        state,
        rows
    ]);
    (0, $acw62.useLayoutEffect)(()=>{
        if (!open) {
            setPos(null);
            return undefined;
        }
        const measure = ()=>{
            const r = rootRef.current?.getBoundingClientRect();
            if (!r) return;
            setPos($b69acda6ae3622c4$export$1534ebe230218d96(r, window.innerWidth || 0, window.innerHeight || 0, isRTL));
        };
        measure();
        window.addEventListener('resize', measure);
        document.addEventListener('scroll', measure, true);
        return ()=>{
            window.removeEventListener('resize', measure);
            document.removeEventListener('scroll', measure, true);
        };
    }, [
        open,
        isRTL
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!open) return undefined;
        const onDocDown = (e)=>{
            if (!rootRef.current?.contains(e.target) && !popRef.current?.contains(e.target)) close();
        };
        // Stopped here so Esc closes the picker and NOT the history sheet under it,
        // which listens on window.
        const onEsc = (e)=>{
            if (e.key === 'Escape') {
                e.stopPropagation();
                close();
            }
        };
        document.addEventListener('mousedown', onDocDown);
        document.addEventListener('keydown', onEsc);
        return ()=>{
            document.removeEventListener('mousedown', onDocDown);
            document.removeEventListener('keydown', onEsc);
        };
    }, [
        open,
        close
    ]);
    const toggleOpen = (e)=>{
        e.stopPropagation();
        e.preventDefault();
        if (open) {
            close();
            return;
        }
        setOpen(true);
        onOpen?.();
    };
    const toggle = (i)=>setSelected((prev)=>{
            const next = new Set(prev);
            if (next.has(i)) next.delete(i);
            else next.add(i);
            return next;
        });
    const confirm = async ()=>{
        const chosen = rows.filter((r)=>selected.has(r.i) && !r.already).map((r)=>r.med);
        if (!chosen.length) return;
        setApplying(true);
        try {
            await onApply?.(chosen);
            close();
        } finally{
            setApplying(false);
        }
    };
    const count = rows.filter((r)=>selected.has(r.i) && !r.already).length;
    const smallLink = {
        background: 'none',
        border: 0,
        padding: 0,
        fontFamily: 'inherit',
        fontSize: '0.6875rem',
        fontWeight: 700,
        color: $b69acda6ae3622c4$var$PAL.accentInk,
        cursor: 'pointer'
    };
    const renderBody = ()=>{
        if (state === 'loading') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                padding: '10px 4px',
                fontSize: '0.75rem',
                color: $b69acda6ae3622c4$var$PAL.mute
            }
        }, t('common.state.loadingEllipsis'));
        if (state === 'error') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            role: "alert",
            style: {
                padding: '10px 4px',
                fontSize: '0.75rem',
                color: $b69acda6ae3622c4$var$PAL.dangerInk
            }
        }, t('visit.history.loadFailed'));
        if (!rows.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                padding: '10px 4px',
                fontSize: '0.75rem',
                color: $b69acda6ae3622c4$var$PAL.mute
            }
        }, t('visit.history.noMedications'));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                fontSize: '0.6875rem',
                color: $b69acda6ae3622c4$var$PAL.mute,
                padding: '4px 4px 6px',
                borderBottom: `1px solid ${$b69acda6ae3622c4$var$PAL.line2}`,
                flexShrink: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            type: "button",
            style: smallLink,
            onClick: ()=>setSelected(new Set(selectable.map((r)=>r.i))),
            "data-testid": `${testid}-select-all`
        }, t('visit.templates.selectAll')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, "\xb7"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            type: "button",
            style: smallLink,
            onClick: ()=>setSelected(new Set()),
            "data-testid": `${testid}-select-none`
        }, t('visit.templates.selectNone')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                flex: 1
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, t('visit.templates.selectedOf', {
            selected: formatNumber(count),
            total: formatNumber(selectable.length)
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            role: "group",
            "data-testid": `${testid}-items`,
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                paddingTop: 4,
                flex: '1 1 auto',
                minHeight: 0,
                overflowY: 'auto'
            }
        }, rows.map(({ i: i, med: med, already: already, allergy: allergy })=>{
            const checked = already || selected.has(i);
            const dose = $b69acda6ae3622c4$var$medDose(med);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
                key: med.id || i,
                "data-testid": "represcribe-item",
                "data-checked": checked ? 'true' : 'false',
                "data-prescribed": already || undefined,
                style: {
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: 8,
                    padding: '6px 6px',
                    borderRadius: 7,
                    cursor: already ? 'default' : 'pointer',
                    opacity: already ? 0.6 : 1,
                    background: allergy && !checked ? $b69acda6ae3622c4$var$PAL.dangerSoft : 'transparent'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
                type: "checkbox",
                checked: checked,
                disabled: already,
                onChange: ()=>toggle(i),
                style: {
                    marginTop: 3,
                    accentColor: $b69acda6ae3622c4$var$PAL.accent,
                    flexShrink: 0
                }
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    flex: 1,
                    minWidth: 0
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'flex',
                    alignItems: 'baseline',
                    gap: 6,
                    flexWrap: 'wrap'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    fontSize: '0.78125rem',
                    fontWeight: 600,
                    color: checked ? $b69acda6ae3622c4$var$PAL.ink : $b69acda6ae3622c4$var$PAL.mute,
                    overflowWrap: 'anywhere'
                }
            }, $b69acda6ae3622c4$var$medName(med)), already && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    fontSize: '0.65625rem',
                    fontWeight: 700,
                    color: $b69acda6ae3622c4$var$PAL.accentInk
                }
            }, t('visit.rx.represcribed'))), dose && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    fontSize: '0.65625rem',
                    color: $b69acda6ae3622c4$var$PAL.mute,
                    marginTop: 1
                }
            }, dose), allergy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    fontSize: '0.65625rem',
                    fontWeight: 700,
                    color: $b69acda6ae3622c4$var$PAL.dangerInk,
                    marginTop: 2
                }
            }, t('visit.templates.allergyHit', {
                substance: allergy
            }))));
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": `${testid}-footer`,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 6,
                paddingTop: 8,
                marginTop: 4,
                borderTop: `1px solid ${$b69acda6ae3622c4$var$PAL.line2}`,
                flexShrink: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            type: "button",
            onClick: close,
            style: {
                ...smallLink,
                color: $b69acda6ae3622c4$var$PAL.ink2,
                fontSize: '0.71875rem',
                padding: '6px 8px'
            }
        }, t('common.actions.cancel')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                flex: 1
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            type: "button",
            onClick: confirm,
            disabled: applying || count === 0,
            "data-testid": `${testid}-apply`,
            style: {
                padding: '6px 12px',
                borderRadius: 7,
                border: 0,
                fontFamily: 'inherit',
                background: $b69acda6ae3622c4$var$PAL.accent,
                color: '#fff',
                fontSize: '0.71875rem',
                fontWeight: 700,
                cursor: applying || count === 0 ? 'not-allowed' : 'pointer',
                opacity: applying || count === 0 ? 0.55 : 1
            }
        }, applying ? t('visit.templates.applying') : t('visit.templates.applySelected', {
            count: count
        }))));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        ref: rootRef,
        style: {
            display: 'inline-flex',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        role: "button",
        tabIndex: 0,
        onClick: toggleOpen,
        onKeyDown: (e)=>{
            if (e.key === 'Enter' || e.key === ' ') toggleOpen(e);
        },
        "aria-haspopup": "listbox",
        "aria-expanded": open,
        title: title,
        "data-testid": `${testid}-open`,
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 4,
            whiteSpace: 'nowrap',
            padding: '3px 8px',
            borderRadius: 6,
            border: `1px solid ${$b69acda6ae3622c4$var$PAL.line}`,
            background: $b69acda6ae3622c4$var$PAL.panel,
            color: $b69acda6ae3622c4$var$PAL.accentInk,
            fontSize: '0.65625rem',
            fontWeight: 700,
            cursor: 'pointer'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        width: "11",
        height: "11",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "1.6",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M13.5 8a5.5 5.5 0 1 1-1.6-3.9M13.5 2.5v2.8h-2.8"
    })), t('visit.rx.represcribe')), open && pos && /*#__PURE__*/ (0, $1u0KT.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: popRef,
        role: "listbox",
        "aria-label": title,
        dir: isRTL ? 'rtl' : 'ltr',
        "data-testid": `${testid}-list`,
        onClick: (e)=>e.stopPropagation(),
        onMouseDown: (e)=>e.stopPropagation(),
        style: {
            position: 'fixed',
            top: pos.top,
            left: pos.left,
            width: $b69acda6ae3622c4$export$5474f41aa0731c97,
            maxHeight: pos.maxHeight,
            zIndex: $b69acda6ae3622c4$var$POP_Z,
            display: 'flex',
            flexDirection: 'column',
            boxSizing: 'border-box',
            background: $b69acda6ae3622c4$var$PAL.panel,
            border: `1px solid ${$b69acda6ae3622c4$var$PAL.line}`,
            borderRadius: 10,
            boxShadow: $b69acda6ae3622c4$var$PAL.shadowPop,
            padding: 8,
            fontFamily: 'inherit',
            textAlign: 'start',
            cursor: 'default'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.78125rem',
            fontWeight: 700,
            color: $b69acda6ae3622c4$var$PAL.ink,
            padding: '2px 4px',
            flexShrink: 0
        }
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.65625rem',
            color: $b69acda6ae3622c4$var$PAL.mute,
            lineHeight: 1.7,
            flexShrink: 0,
            padding: '2px 4px 6px',
            borderBottom: `1px solid ${$b69acda6ae3622c4$var$PAL.line2}`,
            marginBottom: 4
        }
    }, t('visit.rx.represcribeHint')), renderBody()), document.body));
}

});

parcelRegister("5zccn", function(module, exports) {

$parcel$export(module.exports, "ERX_PANEL_PUSH_MIN", () => $82f55e2793e90da1$export$2aa65abd2a659822);
$parcel$export(module.exports, "default", () => $82f55e2793e90da1$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $6TdpC = parcelRequire("6TdpC");
parcelRequire("5N0ZI");
var $5MbI8 = parcelRequire("5MbI8");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
const $82f55e2793e90da1$export$d25afe3d0bd013b5 = 400;
const $82f55e2793e90da1$export$2aa65abd2a659822 = 860;
function $82f55e2793e90da1$export$2e2bcd8739ae039({ scope: scope = 'ALL', onClose: onClose, overlay: overlay = false, notOffered: notOffered = false, children: children }) {
    const { t: t } = (0, $LNQP4.default)();
    const ref = (0, $acw62.useRef)(null);
    // Opened from the dock: bring the keyboard along.
    (0, $acw62.useEffect)(()=>{
        ref.current?.focus?.({
            preventScroll: true
        });
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("aside", {
        ref: ref,
        tabIndex: -1,
        "aria-label": t('visit.erx.panel.title'),
        "data-testid": "visit-erx-panel",
        "data-scope": scope,
        "data-layout": overlay ? 'overlay' : 'push',
        style: {
            display: 'flex',
            flexDirection: 'column',
            minHeight: 0,
            outline: 'none',
            background: (0, $jTCZr.CT).surface,
            borderInlineStart: `1px solid ${(0, $jTCZr.C).border}`,
            ...overlay ? {
                position: 'absolute',
                top: 0,
                bottom: 0,
                insetInlineEnd: 0,
                zIndex: 5,
                width: `min(${$82f55e2793e90da1$export$d25afe3d0bd013b5}px, 100%)`,
                boxShadow: (0, $jTCZr.SHADOW).floating
            } : {
                flex: `0 0 ${$82f55e2793e90da1$export$d25afe3d0bd013b5}px`,
                width: $82f55e2793e90da1$export$d25afe3d0bd013b5
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '10px 12px 10px 14px',
            borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h2", {
        style: {
            margin: 0,
            flex: 1,
            minWidth: 0,
            fontSize: '0.875rem',
            fontWeight: 700,
            color: (0, $jTCZr.CT).ink
        }
    }, t('visit.erx.panel.title')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5MbI8.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
            size: 16,
            "aria-hidden": "true"
        }),
        label: t('visit.erx.inVisit.close'),
        variant: "ghost",
        size: 32,
        onClick: onClose,
        "data-testid": "visit-erx-panel-close"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-erx-panel-body",
        style: {
            flex: 1,
            minHeight: 0,
            overflowY: 'auto',
            padding: '14px 16px 0',
            display: 'flex',
            flexDirection: 'column'
        }
    }, notOffered ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-erx-panel-not-offered",
        style: {
            fontSize: '0.78125rem',
            color: (0, $jTCZr.CT).ink2,
            lineHeight: 1.8,
            paddingBottom: 14
        }
    }, t('visit.erx.inVisit.notOffered')) : children));
}

});

parcelRegister("7Z50p", function(module, exports) {

$parcel$export(module.exports, "idleOrderBlocks", () => $5d021cf04c8c26e0$export$8dd577ba5f2637d3);
$parcel$export(module.exports, "groupOrderItems", () => $5d021cf04c8c26e0$export$465aaadca029630e);
// The visit's «افزودن دستور» picker — what it lists before anything is typed, and in
// which order (PM-0701). Pure: no markup, no text, no fetching; the page asks.
//
// Two shortcuts sit in front of the search, both the doctor's to switch off
// (Settings.shared `orderPickerPrefs`):
//   - «دستورات پرتکرار من» — the services this doctor orders most, counted by the
//     clinical service (`myFrequentOrders`), each with how often;
//   - «در این کلینیک» — the services the visit's clinic performs
//     (`clinicOrderCatalog`).
// And one preference decides which of the two leads. Both always sit above the rest of
// a search's results; neither limits what a search finds.
/** Which blocks the idle picker shows, in the order it shows them. */ function $5d021cf04c8c26e0$export$8dd577ba5f2637d3({ frequent: frequent = [], clinic: clinic = [], prefs: prefs = {} } = {}) {
    const blocks = [];
    if (prefs.showFrequent && frequent.length) blocks.push('frequent');
    if (prefs.showClinic && clinic.length) blocks.push('clinic');
    return prefs.frequentFirst ? blocks : blocks.reverse();
}
// The sort key of one row. Clinic first: the clinic's own rows, then among those the
// doctor's frequent ones, then how often. Frequent first: the doctor's frequent rows,
// the most-ordered leading — whether or not the clinic performs them — then the clinic's.
// Either way the two groups stay above everything else.
const $5d021cf04c8c26e0$var$lead = (it, frequentFirst)=>{
    const c = it.inHouse ? 1 : 0;
    const f = it.times > 0 ? 1 : 0;
    const times = it.times || 0;
    return frequentFirst ? [
        f,
        times,
        c
    ] : [
        c,
        f,
        times
    ];
};
const $5d021cf04c8c26e0$var$byLead = (a, b)=>{
    for(let i = 0; i < a.length; i += 1)if (a[i] !== b[i]) return b[i] - a[i];
    return 0;
};
function $5d021cf04c8c26e0$export$465aaadca029630e(items, { frequentFirst: frequentFirst = false } = {}) {
    const byKey = new Map();
    for (const it of items || []){
        const gk = `${it.type}\u0000${it.category}`;
        if (!byKey.has(gk)) byKey.set(gk, {
            gk: gk,
            type: it.type,
            category: it.category,
            list: []
        });
        byKey.get(gk).list.push(it);
    }
    const groups = Array.from(byKey.values()).map((g, i)=>{
        const ranked = g.list.map((it, idx)=>[
                it,
                idx,
                $5d021cf04c8c26e0$var$lead(it, frequentFirst)
            ]).sort((a, b)=>$5d021cf04c8c26e0$var$byLead(a[2], b[2]) || a[1] - b[1]);
        return {
            gk: g.gk,
            type: g.type,
            category: g.category,
            list: ranked.map(([it])=>it),
            best: ranked[0][2],
            i: i
        };
    });
    return groups.sort((a, b)=>$5d021cf04c8c26e0$var$byLead(a.best, b.best) || a.i - b.i).map(({ gk: gk, type: type, category: category, list: list })=>({
            gk: gk,
            type: type,
            category: category,
            list: list
        }));
}

});

parcelRegister("e7Ndt", function(module, exports) {

$parcel$export(module.exports, "default", () => $54b8ecca4695c6ef$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $cjPik = parcelRequire("cjPik");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
function $54b8ecca4695c6ef$export$2e2bcd8739ae039({ open: open, onOpenChange: onOpenChange, patientName: patientName, recording: recording, onConfirm: onConfirm }) {
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cjPik.default), {
        open: open,
        onOpenChange: onOpenChange,
        "data-testid": "visit-end-confirm",
        confirmTestId: "visit-end-confirm-ok",
        cancelTestId: "visit-end-confirm-cancel",
        // A node, not an interpolated string: the patient's name is data in an
        // unknown script, so it is bidi-isolated rather than glued into the
        // sentence (§16.4).
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, t('visit.endConfirm.titleLead'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("bdi", {
            dir: "auto"
        }, patientName || ''), t('visit.endConfirm.titleTail')),
        description: recording ? `${t('visit.endConfirm.body')} ${t('visit.endConfirm.recordingNote')}` : t('visit.endConfirm.body'),
        confirmLabel: t('visit.endConfirm.confirm'),
        cancelLabel: t('visit.endConfirm.cancel'),
        onConfirm: onConfirm
    });
}

});

parcelRegister("5iiH3", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d5a7a965cfe42c6$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $1xPg4 = parcelRequire("1xPg4");
var $bSvYG = parcelRequire("bSvYG");
var $kBNa0 = parcelRequire("kBNa0");
var $6pF0p = parcelRequire("6pF0p");
parcelRequire("5N0ZI");
var $4fYdd = parcelRequire("4fYdd");
var $hZDga = parcelRequire("hZDga");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $glimY = parcelRequire("glimY");
// The wait while the visit is written to the record.
//
// The overlay this replaces showed a spinner, the sentence «در حال ذخیره
// یادداشت‌ها و تهیه خلاصه AI» — no AI has run here since ending a visit became
// free — and three chips whose dots pulsed on a timer, forever, connected to
// nothing. Everything here is the real plan: one row per write, flipping as it
// lands, so a doctor watching a slow connection can see WHICH step is slow and,
// afterwards, which one failed.
//
// Nothing can interrupt it. Esc, the scrim and the close button are all
// disabled, because a half-run sequence is worse than a slow one.
const $6d5a7a965cfe42c6$var$GLYPH = {
    [(0, $glimY.STEP).PENDING]: {
        Icon: (0, $1xPg4.default),
        color: (0, $jTCZr.CT).mute
    },
    [(0, $glimY.STEP).DONE]: {
        Icon: (0, $kBNa0.default),
        color: (0, $jTCZr.CT).good
    },
    [(0, $glimY.STEP).FAILED]: {
        Icon: (0, $bSvYG.default),
        color: (0, $jTCZr.CT).danger
    },
    [(0, $glimY.STEP).SKIPPED]: {
        Icon: (0, $6pF0p.default),
        color: (0, $jTCZr.CT).mute
    }
};
const $6d5a7a965cfe42c6$var$STATE_KEY = {
    [(0, $glimY.STEP).PENDING]: 'visit.end.stepState.pending',
    [(0, $glimY.STEP).RUNNING]: 'visit.end.stepState.running',
    [(0, $glimY.STEP).DONE]: 'visit.end.stepState.done',
    [(0, $glimY.STEP).FAILED]: 'visit.end.stepState.failed',
    [(0, $glimY.STEP).SKIPPED]: 'visit.end.stepState.skipped'
};
function $6d5a7a965cfe42c6$var$StepRow({ step: step }) {
    const { t: t } = (0, $LNQP4.default)();
    const glyph = $6d5a7a965cfe42c6$var$GLYPH[step.state];
    const running = step.state === (0, $glimY.STEP).RUNNING;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            minWidth: 0
        },
        "data-testid": `visit-end-step-${step.key}`,
        "data-state": step.state
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'inline-flex',
            flexShrink: 0,
            width: '1rem',
            justifyContent: 'center'
        },
        "aria-hidden": "true"
    }, running ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 14,
        color: (0, $jTCZr.CT).accent,
        label: ""
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(glyph.Icon, {
        size: 15,
        color: glyph.color
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            minWidth: 0,
            fontSize: '0.8125rem',
            color: step.state === (0, $glimY.STEP).PENDING ? (0, $jTCZr.CT).mute : (0, $jTCZr.CT).ink,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        }
    }, step.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.6875rem',
            color: (0, $jTCZr.CT).mute,
            flexShrink: 0
        }
    }, t($6d5a7a965cfe42c6$var$STATE_KEY[step.state])));
}
function $6d5a7a965cfe42c6$export$2e2bcd8739ae039({ steps: steps = [] }) {
    const { t: t } = (0, $LNQP4.default)();
    const stop = (e)=>e.preventDefault();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.Dialog), {
        open: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogContent), {
        size: "sm",
        layout: "frame",
        showClose: false,
        onEscapeKeyDown: stop,
        onPointerDownOutside: stop,
        onInteractOutside: stop,
        "data-testid": "visit-end-progress",
        "aria-busy": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 18,
        color: (0, $jTCZr.CT).accent,
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogTitle), {
        style: {
            fontSize: '0.9375rem'
        }
    }, t('visit.header.ending'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogDescription), {
        style: {
            fontSize: '0.75rem'
        }
    }, t('visit.header.endingHint'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        style: {
            margin: 0,
            padding: 0,
            listStyle: 'none',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem'
        },
        "aria-live": "polite"
    }, steps.map((step)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($6d5a7a965cfe42c6$var$StepRow, {
            key: step.key,
            step: step
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null)));
}

});
parcelRegister("1xPg4", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e081ec70e23b03f$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $4e081ec70e23b03f$export$a2387ed3b5d536eb = {
    name: "circle",
    size: 24,
    node: [
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                r: "10",
                key: "1mglay"
            }
        ]
    ]
};
$4e081ec70e23b03f$export$a2387ed3b5d536eb.node;
const $4e081ec70e23b03f$export$2e2bcd8739ae039 = (0, $9QBug.default)($4e081ec70e23b03f$export$a2387ed3b5d536eb);

});

parcelRegister("6pF0p", function(module, exports) {

$parcel$export(module.exports, "default", () => $034b067d9e02706b$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $034b067d9e02706b$export$a2387ed3b5d536eb = {
    name: "circle-minus",
    size: 24,
    node: [
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                r: "10",
                key: "1mglay"
            }
        ],
        [
            "path",
            {
                d: "M8 12h8",
                key: "1wcyev"
            }
        ]
    ],
    aliases: [
        "minus-circle"
    ]
};
$034b067d9e02706b$export$a2387ed3b5d536eb.node;
const $034b067d9e02706b$export$2e2bcd8739ae039 = (0, $9QBug.default)($034b067d9e02706b$export$a2387ed3b5d536eb);

});


parcelRegister("jOg3R", function(module, exports) {

$parcel$export(module.exports, "default", () => $c82e14f46c6e08fd$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $huNwV = parcelRequire("huNwV");
var $a0SXV = parcelRequire("a0SXV");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $aJ1FU = parcelRequire("aJ1FU");
var $cjPik = parcelRequire("cjPik");
var $4fYdd = parcelRequire("4fYdd");
var $hZDga = parcelRequire("hZDga");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
parcelRequire("2tKqm");
var $9BgRG = parcelRequire("9BgRG");

var $7LBYc = parcelRequire("7LBYc");

var $6xvbB = parcelRequire("6xvbB");

var $glimY = parcelRequire("glimY");

var $4UqGT = parcelRequire("4UqGT");

var $7MmQM = parcelRequire("7MmQM");

var $e317r = parcelRequire("e317r");

var $btold = parcelRequire("btold");

var $bkhim = parcelRequire("bkhim");

var $eiMd7 = parcelRequire("eiMd7");

var $lee5W = parcelRequire("lee5W");

var $jOWbd = parcelRequire("jOWbd");

var $dKaB4 = parcelRequire("dKaB4");

var $80UPz = parcelRequire("80UPz");
function $c82e14f46c6e08fd$export$2e2bcd8739ae039({ patient: patient, doctor: doctor, soap: soap = {}, rxItems: rxItems = [], pendingTests: pendingTests = [], diagnosis: diagnosis, acceptedDifferential: acceptedDifferential = [], prescriptionTemplates: prescriptionTemplates = [], appointmentId: appointmentId, saveFailures: saveFailures = [], failedGroups: failedGroups = {}, retrying: retrying = false, onRetryFailed: onRetryFailed, endedAt: endedAt, durationMin: durationMin, coins: coins, onExit: onExit, onViewRecord: onViewRecord }) {
    const { t: t } = (0, $LNQP4.default)();
    const toast = (0, $7LBYc.useOptionalToast)();
    // Both insurer cards below are Iranian rails (host.jsx useIranianRails).
    const iranianRails = (0, $e317r.useIranianRails)();
    const [view, setView] = (0, $acw62.useState)('review');
    const [expanded, setExpanded] = (0, $acw62.useState)({});
    const [tplId, setTplId] = (0, $acw62.useState)(prescriptionTemplates[0]?.id || '');
    // The e-prescription card's login or send in flight — unsaved work.
    const [erxBusy, setErxBusy] = (0, $acw62.useState)(false);
    const [leaveConfirm, setLeaveConfirm] = (0, $acw62.useState)(null);
    const partial = saveFailures.length > 0;
    const nothingRecorded = !(soap.s || soap.o || soap.a || soap.p || rxItems.length || pendingTests.length || diagnosis);
    const state = partial ? 'partial' : nothingRecorded ? 'empty' : 'clean';
    const canPrint = rxItems.length > 0 || pendingTests.length > 0;
    const toggle = (0, $acw62.useCallback)((key)=>{
        setExpanded((prev)=>({
                ...prev,
                [key]: !prev[key]
            }));
    }, []);
    // ── leaving ───────────────────────────────────────────────────────────────
    // An e-prescription login or send mid-flight is the one piece of unsaved work
    // on this screen (§5.2: an overlay with unsaved input asks before it closes).
    // Every exit path funnels through here — the footer, Esc, the scrim and the
    // platform back button — so none of them can quietly abandon an OTP the
    // doctor is halfway through typing.
    const guardedExit = (0, $acw62.useCallback)((run)=>{
        if (erxBusy) {
            setLeaveConfirm(()=>run);
            return;
        }
        run();
    }, [
        erxBusy
    ]);
    const exit = (0, $acw62.useCallback)(()=>guardedExit(onExit), [
        guardedExit,
        onExit
    ]);
    const viewRecord = (0, $acw62.useCallback)(()=>guardedExit(onViewRecord), [
        guardedExit,
        onViewRecord
    ]);
    // Back closes the RECEIPT, not the route behind it. The receipt is safe to
    // re-enter: the encounter is already final when it opens and every action on
    // it is idempotent.
    (0, $9BgRG.default)(true, exit, {
        id: 'visit-closure'
    });
    const handlePrint = (0, $acw62.useCallback)(()=>{
        const template = prescriptionTemplates.find((x)=>x.id === tplId) || null;
        const ok = (0, $6xvbB.printPrescription)({
            template: template,
            rxItems: rxItems,
            pendingTests: pendingTests,
            diagnosis: diagnosis,
            soap: soap,
            doctor: doctor,
            patient: patient,
            t: t
        });
        // A blocked popup is silent in every browser; without this the doctor
        // presses «چاپ» and concludes the app is broken.
        if (ok === false) toast?.error?.(t('visit.rx.printBlocked'));
    }, [
        prescriptionTemplates,
        tplId,
        rxItems,
        pendingTests,
        diagnosis,
        soap,
        doctor,
        patient,
        t,
        toast
    ]);
    const handleRetry = (0, $acw62.useCallback)(async ()=>{
        const allSaved = await onRetryFailed?.();
        if (allSaved) toast?.success?.(t('visit.end.retrySucceeded'));
        else toast?.error?.(t('visit.end.retryPartial'));
    }, [
        onRetryFailed,
        toast,
        t
    ]);
    const failedDrugs = failedGroups[(0, $glimY.GROUP).DRUG] || 0;
    const body = (0, $acw62.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dKaB4.default), {
            failures: saveFailures,
            onRetry: handleRetry,
            retrying: retrying
        }), state === 'empty' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
            variant: "neutral",
            style: {
                alignItems: 'flex-start',
                marginBottom: '1rem'
            },
            "data-testid": "visit-closure-empty"
        }, t('visit.closure.emptyVisitBody')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(18rem, 1fr))',
                gap: '0.75rem',
                alignItems: 'stretch'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bkhim.default), {
            soap: soap,
            diagnosis: diagnosis,
            accepted: acceptedDifferential,
            failedCount: failedGroups[(0, $glimY.GROUP).DIAGNOSIS] || 0,
            expanded: expanded.dx,
            onToggle: ()=>toggle('dx')
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eiMd7.default), {
            rxItems: rxItems,
            failedCount: failedDrugs,
            expanded: expanded.rx,
            onToggle: ()=>toggle('rx')
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lee5W.default), {
            pendingTests: pendingTests,
            failedCount: failedGroups[(0, $glimY.GROUP).ORDERS] || 0,
            expanded: expanded.orders,
            onToggle: ()=>toggle('orders')
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $jOWbd.default), {
            soap: soap,
            failedCount: failedGroups[(0, $glimY.GROUP).SOAP] || 0,
            expanded: expanded.soap,
            onToggle: ()=>toggle('soap')
        })), iranianRails && appointmentId && patient?.id && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                marginTop: '0.75rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7MmQM.default), {
            appointmentId: appointmentId,
            patientId: patient.id
        })), iranianRails && appointmentId && patient?.id && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                marginTop: '0.75rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4UqGT.default), {
            appointmentId: appointmentId,
            patientId: patient.id,
            onBusyChange: setErxBusy,
            compactWhenSettled: true
        }))), [
        saveFailures,
        handleRetry,
        retrying,
        state,
        t,
        soap,
        diagnosis,
        acceptedDifferential,
        failedGroups,
        failedDrugs,
        expanded,
        toggle,
        rxItems,
        pendingTests,
        appointmentId,
        patient,
        iranianRails
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.Dialog), {
        open: true,
        onOpenChange: (open)=>{
            if (!open) exit();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogContent), {
        size: "xl",
        layout: "frame",
        showClose: false,
        "data-testid": "visit-closure",
        "data-state": retrying ? 'retrying' : state,
        "data-view": view,
        onEscapeKeyDown: (e)=>{
            // Esc in the preview means "back to the receipt", not "leave the
            // visit". It is the only place this dialog intercepts the key.
            if (view === 'print') {
                e.preventDefault();
                setView('review');
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogHeader), null, view === 'print' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $80UPz.PrintViewHeader), {
        onBack: ()=>setView('review')
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $btold.default), {
        state: state,
        patient: patient,
        endedAt: endedAt,
        durationMin: durationMin,
        coins: coins
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogBody), null, view === 'print' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $80UPz.default), {
        rxItems: rxItems,
        pendingTests: pendingTests,
        diagnosis: diagnosis,
        soap: soap,
        doctor: doctor,
        patient: patient,
        prescriptionTemplates: prescriptionTemplates,
        selectedTplId: tplId,
        onSelectTemplate: setTplId
    }) : body), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogFooter), null, view === 'print' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $80UPz.PrintViewFooter), {
        onBack: ()=>setView('review'),
        onPrint: handlePrint
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, canPrint && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        onClick: ()=>setView('print'),
        disabled: retrying,
        className: "gap-1.5",
        "data-testid": "visit-closure-print"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a0SXV.default), {
        size: 15,
        "aria-hidden": "true"
    }), " ", t('visit.rx.print')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        onClick: viewRecord,
        disabled: retrying,
        "data-testid": "visit-closure-view-record"
    }, t('visit.closure.viewRecord')), partial ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "default",
        onClick: handleRetry,
        disabled: retrying,
        className: "gap-1.5",
        "data-testid": "visit-closure-primary"
    }, retrying && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 14,
        color: "currentColor",
        label: ""
    }), t('visit.end.retryFailed')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        onClick: exit,
        disabled: retrying,
        "data-testid": "visit-closure-exit"
    }, t('visit.closure.backToReception'))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "default",
        onClick: exit,
        autoFocus: true,
        className: "gap-1.5",
        "data-testid": "visit-closure-primary"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
        size: 15,
        "aria-hidden": "true"
    }), " ", t('visit.closure.backToReception')))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cjPik.default), {
        open: !!leaveConfirm,
        onOpenChange: (open)=>{
            if (!open) setLeaveConfirm(null);
        },
        title: t('visit.erx.leaveTitle'),
        description: t('visit.erx.leaveBody'),
        confirmLabel: t('common.actions.leave'),
        cancelLabel: t('visit.erx.stayLabel'),
        confirmTestId: "visit-closure-leave-ok",
        cancelTestId: "visit-closure-leave-cancel",
        "data-testid": "visit-closure-leave-confirm",
        onConfirm: ()=>{
            const run = leaveConfirm;
            setLeaveConfirm(null);
            run?.();
        }
    }));
}

});
parcelRegister("btold", function(module, exports) {

$parcel$export(module.exports, "default", () => $e85a01c372dd00b8$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $huNwV = parcelRequire("huNwV");
var $QG9Z3 = parcelRequire("QG9Z3");
parcelRequire("5N0ZI");
var $4fYdd = parcelRequire("4fYdd");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $cVuA6 = parcelRequire("cVuA6");

var $79UOV = parcelRequire("79UOV");
// The receipt's first line, and the one sentence a doctor reads before walking
// away from the visit.
//
// The disc is a CLAIM. A green tick over a save that half failed is the single
// most expensive lie this screen could tell, so it follows the fact rather than
// the act: ⚠ whenever anything did not reach the record.
//
// The subtitle used to read «خلاصه ثبت‌شده در پرونده الکترونیک بیمار» — there
// has been no summary since ending a visit stopped calling the AI, so it named
// a thing that does not exist. It now names the four things that were actually
// written.
const $e85a01c372dd00b8$var$SUBTITLE_KEY = {
    clean: 'visit.closure.subtitleSaved',
    empty: 'visit.closure.subtitleEmpty',
    partial: 'visit.end.partialSaveSubtitle'
};
function $e85a01c372dd00b8$export$2e2bcd8739ae039({ state: state, patient: patient, endedAt: endedAt, durationMin: durationMin, coins: coins }) {
    const { t: t, formatDate: formatDate, formatTime: formatTime } = (0, $LNQP4.default)();
    const partial = state === 'partial';
    const meta = [
        endedAt ? formatDate(endedAt, 'short') : null,
        endedAt ? formatTime(endedAt) : null,
        durationMin ? t('visit.closure.durationMinutes', {
            count: durationMin
        }) : null
    ].filter(Boolean);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": "true",
        style: {
            width: '2.25rem',
            height: '2.25rem',
            borderRadius: '50%',
            flexShrink: 0,
            display: 'grid',
            placeItems: 'center',
            background: partial ? (0, $jTCZr.CT).warnSoft : (0, $jTCZr.CT).goodSoft,
            color: partial ? (0, $jTCZr.CT).warn : (0, $jTCZr.CT).good
        }
    }, partial ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $QG9Z3.default), {
        size: 18
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
        size: 18,
        strokeWidth: 2.6
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogTitle), {
        style: {
            fontSize: '1.0625rem',
            fontWeight: 700,
            color: (0, $jTCZr.CT).ink,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        },
        title: patient?.name || ''
    }, t('visit.closure.titleLead'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("bdi", {
        dir: "auto"
    }, patient?.name || ''), t('visit.closure.titleTail')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).mute,
            marginTop: '0.125rem'
        }
    }, t($e85a01c372dd00b8$var$SUBTITLE_KEY[state] || $e85a01c372dd00b8$var$SUBTITLE_KEY.clean)), (meta.length > 0 || patient?.nationalId) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            gap: '0.375rem',
            fontSize: '0.6875rem',
            color: (0, $jTCZr.CT).mute2,
            marginTop: '0.25rem'
        }
    }, meta.map((part, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
            key: i
        }, i > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "aria-hidden": "true"
        }, "\xb7"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, part))), patient?.nationalId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, meta.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": "true"
    }, "\xb7"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, t('visit.closure.patientCodeLabel'), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", (0, $79UOV.LTR_ISLAND), patient.nationalId))))), coins?.total > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginInlineStart: 'auto',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cVuA6.default), {
        entries: coins.entries,
        total: coins.total
    })));
}

});
parcelRegister("79UOV", function(module, exports) {

$parcel$export(module.exports, "CARD", () => $53657303f9877f90$export$95783a805443ad7d);
$parcel$export(module.exports, "CARD_HEAD", () => $53657303f9877f90$export$6dbe65f67bd0d0fd);
$parcel$export(module.exports, "CARD_TITLE", () => $53657303f9877f90$export$ab4acd4f7dcb595f);
$parcel$export(module.exports, "BODY_TEXT", () => $53657303f9877f90$export$72b0f1ae75602dae);
$parcel$export(module.exports, "MUTED_TEXT", () => $53657303f9877f90$export$32d70c2a0f618291);
$parcel$export(module.exports, "LTR_ISLAND", () => $53657303f9877f90$export$2eca6f417e9e523e);

var $jTCZr = parcelRequire("jTCZr");
const $53657303f9877f90$export$95783a805443ad7d = {
    background: (0, $jTCZr.CT).surface,
    border: `1px solid ${(0, $jTCZr.C).border}`,
    borderRadius: (0, $jTCZr.RADIUS).card,
    boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
    padding: '0.875rem 1rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.625rem',
    minWidth: 0
};
const $53657303f9877f90$export$6dbe65f67bd0d0fd = {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    minWidth: 0
};
const $53657303f9877f90$export$ab4acd4f7dcb595f = {
    fontSize: '0.8125rem',
    fontWeight: 700,
    color: (0, $jTCZr.CT).ink,
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical'
};
const $53657303f9877f90$export$72b0f1ae75602dae = {
    fontSize: '0.78125rem',
    lineHeight: 1.7,
    color: (0, $jTCZr.CT).ink2
};
const $53657303f9877f90$export$32d70c2a0f618291 = {
    fontSize: '0.78125rem',
    lineHeight: 1.7,
    color: (0, $jTCZr.CT).mute
};
const $53657303f9877f90$export$67c34e73d0f66b9f = {
    dir: 'auto'
};
const $53657303f9877f90$export$2eca6f417e9e523e = {
    dir: 'ltr',
    style: {
        unicodeBidi: 'isolate',
        display: 'inline-block'
    }
};

});


parcelRegister("bkhim", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a43bdf6bf7b450a$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $fX0JO = parcelRequire("fX0JO");
parcelRequire("5N0ZI");
var $bHjRG = parcelRequire("bHjRG");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $NvwVB = parcelRequire("NvwVB");

var $79UOV = parcelRequire("79UOV");
function $0a43bdf6bf7b450a$export$2e2bcd8739ae039({ soap: soap, diagnosis: diagnosis, accepted: accepted = [], failedCount: failedCount, expanded: expanded, onToggle: onToggle }) {
    const { t: t } = (0, $LNQP4.default)();
    const primary = (soap?.a || '').trim() || (diagnosis || '').trim();
    const items = [
        ...primary ? [
            {
                text: primary,
                tag: t('visit.closure.provisionalTag'),
                key: 'primary'
            }
        ] : [],
        ...accepted.map((d, i)=>({
                text: d.description || d.display || '',
                code: d.icdCode || d.code || '',
                tag: t('visit.closure.acceptedTag'),
                key: `accepted-${d.id || i}`
            })).filter((d)=>d.text)
    ];
    const shown = expanded ? items : items.slice(0, (0, $NvwVB.PREVIEW_LIMIT));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $NvwVB.default), {
        icon: (0, $fX0JO.default),
        title: t('visit.dx.title'),
        total: items.length,
        expanded: expanded,
        onToggle: onToggle,
        failedCount: failedCount,
        testId: "visit-closure-dx"
    }, items.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $NvwVB.ClosureEmptyLine), null, t('visit.closure.noDiagnosis')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        style: {
            margin: 0,
            padding: 0,
            listStyle: 'none',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.375rem'
        }
    }, shown.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: item.key,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.375rem',
                flexWrap: 'wrap',
                minWidth: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "auto",
            style: {
                padding: '0.1875rem 0.625rem',
                borderRadius: (0, $jTCZr.RADIUS).chip,
                background: (0, $jTCZr.CT).accentSoft,
                color: (0, $jTCZr.CT).accentInk,
                fontSize: '0.71875rem',
                fontWeight: 600,
                minWidth: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("bdi", null, item.text)), item.code && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            ...(0, $79UOV.LTR_ISLAND),
            style: {
                ...(0, $79UOV.LTR_ISLAND).style,
                fontSize: '0.6875rem',
                color: (0, $jTCZr.CT).mute,
                fontFamily: 'monospace'
            }
        }, item.code), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bHjRG.default), {
            variant: "outline"
        }, item.tag)))));
}

});
parcelRegister("NvwVB", function(module, exports) {

$parcel$export(module.exports, "PREVIEW_LIMIT", () => $437b45feafd91083$export$b299642011ab9f53);
$parcel$export(module.exports, "default", () => $437b45feafd91083$export$2e2bcd8739ae039);
$parcel$export(module.exports, "ClosureEmptyLine", () => $437b45feafd91083$export$21407d21daa9d31);

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $bHjRG = parcelRequire("bHjRG");
var $aJ1FU = parcelRequire("aJ1FU");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $79UOV = parcelRequire("79UOV");
const $437b45feafd91083$export$b299642011ab9f53 = 3;
function $437b45feafd91083$export$2e2bcd8739ae039({ icon: Icon, title: title, count: count, total: total, expanded: expanded, onToggle: onToggle, failedCount: failedCount, testId: testId, children: children }) {
    const { t: t } = (0, $LNQP4.default)();
    const listId = testId ? `${testId}-list` : undefined;
    const hasMore = typeof total === 'number' && total > $437b45feafd91083$export$b299642011ab9f53;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
        style: (0, $79UOV.CARD),
        "data-testid": testId,
        "data-state": failedCount ? 'failed' : 'saved'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: (0, $79UOV.CARD_HEAD)
    }, Icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'inline-flex',
            color: (0, $jTCZr.CT).mute,
            flexShrink: 0
        },
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        size: 16
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h3", {
        style: {
            ...(0, $79UOV.CARD_TITLE),
            margin: 0
        }
    }, title), typeof count === 'number' && count > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bHjRG.default), {
        variant: "outline"
    }, t('visit.closure.itemsCount', {
        count: count
    })), failedCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bHjRG.default), {
        variant: "destructive",
        "data-testid": testId ? `${testId}-unsaved` : undefined
    }, failedCount > 1 ? t('visit.closure.notSavedCount', {
        count: failedCount
    }) : t('visit.closure.notSavedTag'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: listId,
        style: {
            minWidth: 0
        }
    }, children), hasMore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "link",
        size: "sm",
        className: "h-auto p-0",
        onClick: onToggle,
        "aria-expanded": !!expanded,
        "aria-controls": listId,
        "data-testid": testId ? `${testId}-expand` : undefined
    }, expanded ? t('visit.closure.showLess') : t('visit.closure.showAll', {
        count: total
    }))));
}
function $437b45feafd91083$export$21407d21daa9d31({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        style: {
            ...(0, $79UOV.MUTED_TEXT),
            margin: 0
        }
    }, children);
}

});


parcelRegister("eiMd7", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f321e934a2c42ad$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $aVx4q = parcelRequire("aVx4q");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $NvwVB = parcelRequire("NvwVB");

var $79UOV = parcelRequire("79UOV");

var $g6gAc = parcelRequire("g6gAc");

var $lfHhF = parcelRequire("lfHhF");

var $eQiuG = parcelRequire("eQiuG");

var $6xvbB = parcelRequire("6xvbB");
function $3f321e934a2c42ad$export$2e2bcd8739ae039({ rxItems: rxItems = [], failedCount: failedCount, expanded: expanded, onToggle: onToggle }) {
    const { t: t, readsPersianData: readsPersianData } = (0, $LNQP4.default)();
    const shown = expanded ? rxItems : rxItems.slice(0, (0, $NvwVB.PREVIEW_LIMIT));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $NvwVB.default), {
        icon: (0, $aVx4q.default),
        title: t('visit.tabs.rx'),
        count: rxItems.length,
        total: rxItems.length,
        expanded: expanded,
        onToggle: onToggle,
        failedCount: failedCount,
        testId: "visit-closure-rx"
    }, rxItems.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $NvwVB.ClosureEmptyLine), null, t('visit.rx.none')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        style: {
            margin: 0,
            padding: 0,
            listStyle: 'none',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.375rem'
        }
    }, shown.map((item, i)=>{
        const parts = (readsPersianData ? [
            item.dosage,
            item.route,
            item.frequency,
            item.duration
        ] : [
            item.dosage && (0, $6xvbB.drugDosageLabel)(item.dosage, false, t),
            item.route && (0, $eQiuG.routeLabel)(item.route, t),
            item.frequency && (0, $lfHhF.drugFrequencyLabel)(item.frequency, t),
            item.duration
        ]).filter(Boolean);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: item.id || `${item.drug?.id}-${i}`,
            style: {
                borderInlineStart: `2px solid ${(0, $jTCZr.CT).accent}`,
                paddingInlineStart: '0.5rem',
                minWidth: 0
            },
            "data-testid": "visit-closure-rx-row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "auto",
            style: {
                fontSize: '0.8125rem',
                fontWeight: 700,
                color: (0, $jTCZr.CT).ink
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("bdi", null, (0, $g6gAc.drugDisplayName)(item.drug) || item.name)), parts.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                ...(0, $79UOV.BODY_TEXT),
                color: (0, $jTCZr.CT).mute,
                display: 'block'
            }
        }, parts.map((part, n)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                key: n
            }, n > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                "aria-hidden": "true"
            }, " \xb7 "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("bdi", null, part)))), (0, $eQiuG.quantityNumber)(item.quantity) > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                ...(0, $79UOV.BODY_TEXT),
                color: (0, $jTCZr.CT).mute2,
                display: 'block'
            }
        }, t('visit.closure.quantity', {
            count: (0, $eQiuG.quantityNumber)(item.quantity)
        })), (0, $eQiuG.missingRxFields)(item).length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "data-testid": "visit-closure-rx-incomplete",
            title: t('visit.rx.incompleteHint'),
            style: {
                ...(0, $79UOV.BODY_TEXT),
                color: (0, $jTCZr.CT).warnInk,
                fontWeight: 700,
                display: 'block'
            }
        }, (0, $eQiuG.rxIncompleteLabel)((0, $eQiuG.missingRxFields)(item), t)));
    })));
}

});

parcelRegister("lee5W", function(module, exports) {

$parcel$export(module.exports, "default", () => $915e51e033df3655$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $4CVxl = parcelRequire("4CVxl");
parcelRequire("5N0ZI");
var $bHjRG = parcelRequire("bHjRG");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $NvwVB = parcelRequire("NvwVB");

var $6xvbB = parcelRequire("6xvbB");
// درخواست‌های بالینی — labs, imaging and referrals.
//
// Urgency is a badge with a word in it, never a colour alone: §12.3 says colour
// is never the only carrier of meaning, and «اورژانسی» is precisely the fact a
// colour-blind doctor must not miss.
const $915e51e033df3655$var$TYPE_KEY = {
    lab: 'visit.orders.lab',
    imaging: 'visit.orders.imaging',
    referral: 'visit.orders.referral'
};
function $915e51e033df3655$export$2e2bcd8739ae039({ pendingTests: pendingTests = [], failedCount: failedCount, expanded: expanded, onToggle: onToggle }) {
    const { t: t } = (0, $LNQP4.default)();
    const shown = expanded ? pendingTests : pendingTests.slice(0, (0, $NvwVB.PREVIEW_LIMIT));
    // The order carries its Persian catalogue name; an English reader sees the
    // catalogue's English one.
    const orderName = (0, $6xvbB.useCatalogNamesEn)(pendingTests.map((o)=>o.name || o.testName));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $NvwVB.default), {
        icon: (0, $4CVxl.default),
        title: t('visit.orders.requests'),
        count: pendingTests.length,
        total: pendingTests.length,
        expanded: expanded,
        onToggle: onToggle,
        failedCount: failedCount,
        testId: "visit-closure-orders"
    }, pendingTests.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $NvwVB.ClosureEmptyLine), null, t('visit.orders.noneRecordedShort')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        style: {
            margin: 0,
            padding: 0,
            listStyle: 'none',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.375rem'
        }
    }, shown.map((order, i)=>{
        const type = order.type || 'lab';
        const urgent = order.urgency === 'urgent' || order.urgency === 'stat';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: order.id || `${order.name}-${i}`,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.375rem',
                flexWrap: 'wrap',
                minWidth: 0
            },
            "data-testid": "visit-closure-orders-row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bHjRG.default), {
            variant: "outline"
        }, t($915e51e033df3655$var$TYPE_KEY[type] || $915e51e033df3655$var$TYPE_KEY.lab)), urgent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bHjRG.default), {
            variant: "destructive"
        }, t('common.urgency.stat')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "auto",
            style: {
                fontSize: '0.78125rem',
                minWidth: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("bdi", null, orderName(order.name || order.testName) || String(order))));
    })));
}

});

parcelRegister("jOWbd", function(module, exports) {

$parcel$export(module.exports, "default", () => $62be6e4f8a045166$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jhSl7 = parcelRequire("jhSl7");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $NvwVB = parcelRequire("NvwVB");
// یادداشت SOAP — the four sections as they were written.
//
// Each block clamps to three lines and the card expands all four together. The
// version this replaces rendered the raw text into a 10.5px quadrant with no
// clamp at all, so one long plan pushed the prescription card off the screen.
//
// The section count is COMPUTED. It used to be the literal string «۴ بخش»,
// which claimed four sections for a visit that had one — and, being a literal,
// showed Persian digits in the English UI.
const $62be6e4f8a045166$var$SECTIONS = [
    's',
    'o',
    'a',
    'p'
];
const $62be6e4f8a045166$var$LETTER_KEY = {
    s: 'visit.soap.sLetter',
    o: 'visit.soap.oLetter',
    a: 'visit.soap.aLetter',
    p: 'visit.soap.pLetter'
};
function $62be6e4f8a045166$export$2e2bcd8739ae039({ soap: soap = {}, failedCount: failedCount, expanded: expanded, onToggle: onToggle }) {
    const { t: t } = (0, $LNQP4.default)();
    const filled = $62be6e4f8a045166$var$SECTIONS.filter((k)=>(soap[k] || '').trim());
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $NvwVB.default), {
        icon: (0, $jhSl7.default),
        title: t('visit.end.partSoap'),
        count: filled.length,
        failedCount: failedCount,
        testId: "visit-closure-soap"
    }, filled.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $NvwVB.ClosureEmptyLine), null, t('visit.closure.noSoap')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(8rem, 1fr))',
            gap: '0.375rem'
        }
    }, $62be6e4f8a045166$var$SECTIONS.map((k)=>{
        const text = (soap[k] || '').trim();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: k,
            style: {
                background: (0, $jTCZr.CT).surface2,
                border: `1px solid ${(0, $jTCZr.C).border}`,
                borderRadius: (0, $jTCZr.RADIUS).chip,
                padding: '0.375rem 0.5rem',
                minWidth: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.625rem',
                fontWeight: 800,
                color: (0, $jTCZr.CT).mute,
                letterSpacing: '.08em',
                display: 'block'
            }
        }, t($62be6e4f8a045166$var$LETTER_KEY[k])), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "auto",
            style: {
                fontSize: '0.71875rem',
                lineHeight: 1.7,
                color: text ? (0, $jTCZr.CT).ink2 : (0, $jTCZr.CT).mute,
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
                display: '-webkit-box',
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                ...expanded ? {} : {
                    WebkitLineClamp: 3
                }
            }
        }, text || t('visit.closure.sectionEmpty')));
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "link",
        size: "sm",
        className: "h-auto p-0",
        onClick: onToggle,
        "aria-expanded": !!expanded,
        "data-testid": "visit-closure-soap-expand"
    }, expanded ? t('visit.closure.showLess') : t('visit.closure.showFullNote')))));
}

});

parcelRegister("dKaB4", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a45f32ddaf989a5$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $QG9Z3 = parcelRequire("QG9Z3");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $aJ1FU = parcelRequire("aJ1FU");
var $hZDga = parcelRequire("hZDga");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
function $5a45f32ddaf989a5$export$2e2bcd8739ae039({ failures: failures = [], onRetry: onRetry, retrying: retrying }) {
    const { t: t } = (0, $LNQP4.default)();
    if (failures.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "warning",
        "data-testid": "closure-partial-save",
        role: "alert",
        style: {
            alignItems: 'flex-start',
            marginBottom: '1rem'
        },
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $QG9Z3.default), {
            size: 18,
            "aria-hidden": "true"
        }),
        title: t('visit.end.partialSaveTitle'),
        action: onRetry && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "outline",
            size: "sm",
            onClick: onRetry,
            disabled: retrying,
            "data-testid": "visit-closure-retry",
            className: "gap-1.5"
        }, retrying && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
            size: 13,
            color: "currentColor",
            label: ""
        }), t('visit.end.retryFailed'))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        style: {
            margin: '0 0 0.5rem',
            fontSize: '0.71875rem',
            lineHeight: 1.85
        }
    }, t('visit.end.partialSaveBody')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        style: {
            margin: 0,
            paddingInlineStart: '1.125rem',
            fontSize: '0.71875rem',
            lineHeight: 1.9,
            color: (0, $jTCZr.CT).ink
        }
    }, failures.map((failure, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: failure.id || i,
            dir: "auto"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("bdi", null, failure.label || failure)))));
}

});

parcelRegister("80UPz", function(module, exports) {

$parcel$export(module.exports, "PrintViewHeader", () => $858d5203ed82f22a$export$652305dc8151bb22);
$parcel$export(module.exports, "PrintViewFooter", () => $858d5203ed82f22a$export$515831587eb72291);
$parcel$export(module.exports, "default", () => $858d5203ed82f22a$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $d8YVq = parcelRequire("d8YVq");
var $a0SXV = parcelRequire("a0SXV");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $4fYdd = parcelRequire("4fYdd");
var $5MbI8 = parcelRequire("5MbI8");
var $fAR2n = parcelRequire("fAR2n");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $asXy3 = parcelRequire("asXy3");
var $LNQP4 = parcelRequire("LNQP4");

var $6xvbB = parcelRequire("6xvbB");

var $g6gAc = parcelRequire("g6gAc");
// پیش‌نمایش نسخه — a VIEW of the closure dialog, not a modal above it.
//
// It used to be a second fixed overlay at z-70 stacked on the closure's z-50:
// two scrims, two focus scopes, and no answer to «which one does Esc close?».
// §5.2 allows exactly one floating layer at a time, so the preview swaps the
// dialog's body instead of covering it. Esc here goes back to the review; the
// only way out of the closure is still its own footer.
//
// The sheet is the one RTL island in the app that does not follow the UI
// language: it is a picture of the paper an Iranian pharmacy reads. Its colours
// come from `PRINT_SHEET` for the same reason — see the note beside it.
function $858d5203ed82f22a$var$SectionTitle({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            margin: '12px 0 7px',
            fontSize: 11,
            fontWeight: 700,
            color: (0, $6xvbB.PRINT_SHEET).brand,
            letterSpacing: '.03em'
        }
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            height: 1,
            background: (0, $6xvbB.PRINT_SHEET).rule
        }
    }));
}
function $858d5203ed82f22a$export$652305dc8151bb22({ onBack: onBack }) {
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.625rem',
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5MbI8.default), {
        variant: "ghost",
        size: 36,
        label: t('visit.closure.backToReview'),
        onClick: onBack,
        "data-testid": "visit-closure-print-back",
        // A directional glyph: "back" points the other way under `ltr`, so it is
        // mirrored rather than swapped for a second icon at each site (§16.3).
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d8YVq.default), {
            size: 17,
            style: (0, $asXy3.MIRROR_ICON)
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogTitle), {
        style: {
            fontSize: '0.9375rem'
        }
    }, t('visit.rx.preview')));
}
function $858d5203ed82f22a$export$515831587eb72291({ onBack: onBack, onPrint: onPrint }) {
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        onClick: onBack,
        "data-testid": "visit-closure-print-back-cta"
    }, t('visit.closure.backToReview')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "default",
        onClick: onPrint,
        className: "gap-1.5",
        "data-testid": "visit-closure-print-submit"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a0SXV.default), {
        size: 15,
        "aria-hidden": "true"
    }), " ", t('common.actions.print')));
}
function $858d5203ed82f22a$export$2e2bcd8739ae039({ rxItems: rxItems = [], pendingTests: pendingTests = [], diagnosis: diagnosis, soap: soap, doctor: doctor, patient: patient, prescriptionTemplates: prescriptionTemplates = [], selectedTplId: selectedTplId, onSelectTemplate: onSelectTemplate }) {
    const { t: t } = (0, $LNQP4.default)();
    const selectedTemplate = prescriptionTemplates.find((tpl)=>tpl.id === selectedTplId) || null;
    // i18n-exempt: printed-document date — stamped on the paper an Iranian
    // pharmacy reads, so it is Persian whatever the UI language is. Same reason
    // as the matching note in `printPrescription`.
    const today = new Date().toLocaleDateString('fa-IR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
    const dxText = soap?.a || diagnosis || '';
    const instructions = soap?.p || '';
    const labOrders = (pendingTests || []).filter((x)=>!x.type || x.type === 'lab');
    const imgOrders = (pendingTests || []).filter((x)=>x.type === 'imaging');
    const filledPreviewText = selectedTemplate ? (0, $6xvbB.fillPrescriptionTemplate)(selectedTemplate.content, {
        t: t,
        rxItems: rxItems,
        pendingTests: pendingTests,
        diagnosis: diagnosis,
        soap: soap,
        doctor: doctor,
        patient: patient,
        today: today
    }) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.625rem',
            padding: '0.5rem 0.75rem',
            marginBottom: '1rem',
            background: (0, $jTCZr.CT).surface2,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: 10
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fAR2n.default), {
        label: t('visit.rx.template'),
        value: selectedTplId,
        onChange: (e)=>onSelectTemplate(e.target.value),
        style: {
            flex: 1,
            minWidth: 0
        },
        "data-testid": "visit-closure-print-template",
        options: [
            ...prescriptionTemplates.map((tpl)=>({
                    value: tpl.id,
                    label: tpl.title
                })),
            {
                value: '',
                label: t('visit.rx.systemFormat')
            }
        ]
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": "true",
        dir: "rtl",
        lang: "fa",
        "data-testid": "visit-closure-print-sheet",
        style: {
            display: 'flex',
            justifyContent: 'center',
            background: (0, $jTCZr.CT).surface2,
            padding: '1.25rem',
            borderRadius: 10
        }
    }, selectedTemplate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 'min(30rem, 100%)',
            background: (0, $6xvbB.PRINT_SHEET).paper,
            borderRadius: 4,
            boxShadow: '0 4px 24px rgba(0,0,0,.18)',
            padding: '1.5rem 1.75rem',
            minHeight: '36rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("pre", {
        style: {
            whiteSpace: 'pre-wrap',
            fontFamily: (0, $6xvbB.PRINT_SHEET).font,
            fontSize: 12.5,
            lineHeight: 1.9,
            color: (0, $6xvbB.PRINT_SHEET).inkSoft,
            margin: 0
        }
    }, filledPreviewText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 9,
            color: (0, $6xvbB.PRINT_SHEET).watermark,
            textAlign: 'center',
            marginTop: 20,
            paddingTop: 8,
            borderTop: `1px solid ${(0, $6xvbB.PRINT_SHEET).hairline}`
        }
    }, t('visit.rx.generatedBy'))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 'min(27.5rem, 100%)',
            background: (0, $6xvbB.PRINT_SHEET).paper,
            borderRadius: 4,
            boxShadow: '0 4px 24px rgba(0,0,0,.18)',
            padding: '1.5rem 1.75rem',
            fontFamily: (0, $6xvbB.PRINT_SHEET).font,
            minHeight: '36rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            borderBottom: `2.5px solid ${(0, $6xvbB.PRINT_SHEET).brand}`,
            paddingBottom: 11,
            marginBottom: 13,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 18,
            fontWeight: 900,
            color: (0, $6xvbB.PRINT_SHEET).brand
        }
    }, t('visit.print.doctorTitle'), " ", doctor?.name || "\u2014"), doctor?.specialty && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 11,
            color: (0, $6xvbB.PRINT_SHEET).inkMuted,
            marginTop: 2
        }
    }, t('visit.print.specialistIn'), " ", doctor.specialty), doctor?.medicalCode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 10.5,
            color: (0, $6xvbB.PRINT_SHEET).inkFaint,
            marginTop: 1
        }
    }, t('visit.print.councilCode'), " ", doctor.medicalCode)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            textAlign: 'center',
            border: `1px solid ${(0, $6xvbB.PRINT_SHEET).rule}`,
            borderRadius: 5,
            padding: '5px 10px',
            fontSize: 11,
            color: (0, $6xvbB.PRINT_SHEET).inkMuted
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontWeight: 700,
            color: (0, $6xvbB.PRINT_SHEET).inkSoft,
            marginBottom: 2
        }
    }, today), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 10,
            color: (0, $6xvbB.PRINT_SHEET).watermark
        }
    }, t('visit.rx.date')))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: (0, $6xvbB.PRINT_SHEET).patientBg,
            borderRadius: 6,
            padding: '7px 12px',
            marginBottom: 13,
            display: 'flex',
            gap: 24,
            fontSize: 11.5
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 10,
            color: (0, $6xvbB.PRINT_SHEET).inkFaint,
            marginBottom: 1
        }
    }, t('visit.print.patientNameLabel')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontWeight: 700,
            color: (0, $6xvbB.PRINT_SHEET).brand
        }
    }, patient?.name || "\u2014")), patient?.nationalId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 10,
            color: (0, $6xvbB.PRINT_SHEET).inkFaint,
            marginBottom: 1
        }
    }, t('common.labels.nationalId')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontWeight: 600,
            color: (0, $6xvbB.PRINT_SHEET).inkSoft
        }
    }, patient.nationalId))), dxText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($858d5203ed82f22a$var$SectionTitle, null, t('patient.conditions.one')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: (0, $6xvbB.PRINT_SHEET).dxBg,
            borderInlineStart: `3px solid ${(0, $6xvbB.PRINT_SHEET).dxRule}`,
            padding: '7px 12px',
            borderRadius: 4,
            fontSize: 12.5,
            color: (0, $6xvbB.PRINT_SHEET).inkSoft,
            marginBottom: 11
        }
    }, dxText)), rxItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($858d5203ed82f22a$var$SectionTitle, null, t('visit.rx.medications')), rxItems.map((item, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: item.id || idx,
            style: {
                display: 'flex',
                gap: 10,
                marginBottom: 9,
                paddingBottom: 9,
                borderBottom: idx < rxItems.length - 1 ? `1px dashed ${(0, $6xvbB.PRINT_SHEET).hairline}` : 'none',
                alignItems: 'flex-start'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                width: 21,
                height: 21,
                borderRadius: '50%',
                background: (0, $6xvbB.PRINT_SHEET).brand,
                color: (0, $6xvbB.PRINT_SHEET).paper,
                fontSize: 11,
                fontWeight: 700,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                marginTop: 1
            }
        }, idx + 1), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            dir: "auto",
            style: {
                fontWeight: 700,
                fontSize: 13,
                color: (0, $6xvbB.PRINT_SHEET).ink
            }
        }, (0, $g6gAc.drugDisplayName)(item.drug) || item.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: 11,
                color: (0, $6xvbB.PRINT_SHEET).inkMuted,
                marginTop: 2
            }
        }, [
            item.dosage,
            item.route,
            item.frequency,
            item.duration && t('visit.text.forDuration', {
                duration: item.duration
            })
        ].filter(Boolean).join(" \xb7 ")), item.instructions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: 11,
                color: (0, $6xvbB.PRINT_SHEET).inkMuted,
                marginTop: 2
            }
        }, item.instructions))))), labOrders.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($858d5203ed82f22a$var$SectionTitle, null, t('visit.orders.labRequest')), labOrders.map((order, ii)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: ii,
            style: {
                display: 'flex',
                gap: 7,
                marginBottom: 5,
                alignItems: 'center'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 10,
                padding: '1px 7px',
                borderRadius: 10,
                background: (0, $6xvbB.PRINT_SHEET).labBg,
                color: (0, $6xvbB.PRINT_SHEET).labInk,
                fontWeight: 600
            }
        }, t('visit.orders.lab')), (order.urgency === 'urgent' || order.urgency === 'stat') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 10,
                padding: '1px 6px',
                borderRadius: 10,
                background: (0, $6xvbB.PRINT_SHEET).statBg,
                color: (0, $6xvbB.PRINT_SHEET).statInk,
                fontWeight: 700
            }
        }, t('common.urgency.stat')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 12,
                color: (0, $6xvbB.PRINT_SHEET).inkSoft
            }
        }, order.name || order.testName)))), imgOrders.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($858d5203ed82f22a$var$SectionTitle, null, t('visit.orders.imagingRequest')), imgOrders.map((order, ii)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: ii,
            style: {
                display: 'flex',
                gap: 7,
                marginBottom: 5,
                alignItems: 'center'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 10,
                padding: '1px 7px',
                borderRadius: 10,
                background: (0, $6xvbB.PRINT_SHEET).imgBg,
                color: (0, $6xvbB.PRINT_SHEET).imgInk,
                fontWeight: 600
            }
        }, t('visit.orders.imaging')), (order.urgency === 'urgent' || order.urgency === 'stat') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 10,
                padding: '1px 6px',
                borderRadius: 10,
                background: (0, $6xvbB.PRINT_SHEET).statBg,
                color: (0, $6xvbB.PRINT_SHEET).statInk,
                fontWeight: 700
            }
        }, t('common.urgency.stat')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: 12,
                color: (0, $6xvbB.PRINT_SHEET).inkSoft
            }
        }, order.name || order.testName)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($858d5203ed82f22a$var$SectionTitle, null, t('visit.orders.doctorOrders')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            border: `1px dashed ${(0, $6xvbB.PRINT_SHEET).dashed}`,
            borderRadius: 6,
            padding: '8px 12px',
            fontSize: 12,
            color: (0, $6xvbB.PRINT_SHEET).inkSoft,
            lineHeight: 1.8,
            whiteSpace: 'pre-wrap',
            minHeight: 44,
            marginBottom: 10
        }
    }, instructions), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
            marginTop: 16,
            paddingTop: 12,
            borderTop: `1px solid ${(0, $6xvbB.PRINT_SHEET).rule}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 9,
            color: (0, $6xvbB.PRINT_SHEET).watermark
        }
    }, t('visit.rx.generatedBy')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            textAlign: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 90,
            borderBottom: `1px solid ${(0, $6xvbB.PRINT_SHEET).inkFaint}`,
            marginBottom: 4,
            height: 30
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 10,
            color: (0, $6xvbB.PRINT_SHEET).inkFaint
        }
    }, t('visit.rx.signature')))))));
}

});




parcelRegister("f61oO", function(module, exports) {

$parcel$export(module.exports, "default", () => $a04c8d3c93655abb$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $fkEOT = parcelRequire("fkEOT");

var $eBrFc = parcelRequire("eBrFc");

var $luRi7 = parcelRequire("luRi7");

var $d5Mun = parcelRequire("d5Mun");
function $a04c8d3c93655abb$export$2e2bcd8739ae039({ patient: patient, tab: tab, onTabChange: onTabChange, onBack: onBack, mobile: mobile }) {
    const navigate = (0, $eBrFc.useAppNavigate)();
    const back = (0, $eBrFc.useAppBack)();
    const { isMobile: isMobile } = (0, $fkEOT.default)();
    const phone = typeof mobile === 'boolean' ? mobile : isMobile;
    if (!patient?.id) return null;
    const props = {
        navigate: navigate,
        onBack: onBack || back,
        patient: patient,
        tab: tab,
        setTab: onTabChange || (()=>{})
    };
    return phone ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $luRi7.default), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d5Mun.default), props);
}

});
parcelRegister("luRi7", function(module, exports) {

$parcel$export(module.exports, "default", () => $2515f4e67960210f$export$2e2bcd8739ae039);
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");
parcelRequire("7sS0P");
var $jTCZr = parcelRequire("jTCZr");
parcelRequire("jTCZr");

var $asVAE = parcelRequire("asVAE");

var $fdoIv = parcelRequire("fdoIv");

var $k5DdK = parcelRequire("k5DdK");

var $gq4TR = parcelRequire("gq4TR");

var $dLdf9 = parcelRequire("dLdf9");

var $8st6E = parcelRequire("8st6E");

var $cwVZP = parcelRequire("cwVZP");

var $64nJX = parcelRequire("64nJX");

var $dBAbF = parcelRequire("dBAbF");

var $hVtO3 = parcelRequire("hVtO3");

var $28KUI = parcelRequire("28KUI");

var $dnT4W = parcelRequire("dnT4W");

var $4wm3E = parcelRequire("4wm3E");

var $ky7vJ = parcelRequire("ky7vJ");

var $cGTI2 = parcelRequire("cGTI2");

var $2Oaoe = parcelRequire("2Oaoe");

var $bkBaq = parcelRequire("bkBaq");
// The mobile patient EHR — a drilled-into full-screen record (DESIGN-CONCEPT-
// MOBILE v2 §1.1/§3.2): the gradient MobileHeader (back to the list + the
// patient's name), the identity glance as the compact header's figures row (PM-0120), the persistent
// allergy safety strip, then the section navigator over one scrolling body.
// Composed entirely from the dedicated mobile library; behaviour comes from the
// same `usePatient` hook the desktop record uses (render-only screen, §5/§9).
//
// Section parity: the phone renders the SAME five sections as the desktop record
// (خلاصه / تحلیل / مشاهدات / تاریخچه مراجعات / فایل‌ها) — see PATIENT_SECTIONS.
// The identity facts that used to have their own «اطلاعات» section now ride the
// header's meta line, mirroring the desktop InnerPageHeader.
const $2515f4e67960210f$var$PatientDetailMobile = ({ navigate: navigate, onBack: onBack, patient: routePatient, tab: tabProp, setTab: setTab })=>{
    const { t: t, formatDigits: formatDigits } = (0, $LNQP4.default)();
    // Section from the URL (screen index owns the /patients/:id/:tab navigation);
    // an unknown segment — e.g. a web-only tab id after a viewport switch — falls
    // back to the overview.
    const tab = (0, $hVtO3.PATIENT_SECTIONS)(t).some((s)=>s.id === tabProp) ? tabProp : 'overview';
    const patientId = routePatient?.patientId || routePatient?.id;
    const { patient: fullPatient, loading: loading, error: error, refresh: refresh } = (0, $k5DdK.usePatient)(patientId);
    const p = fullPatient || routePatient || {};
    const allergies = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(p.clinicalAllergies || p.allergies || []).filter((a)=>typeof a === 'string' ? a : a?.allergen), [
        p.clinicalAllergies,
        p.allergies
    ]);
    const isLoading = loading && !fullPatient;
    const isError = !!error && !fullPatient;
    const isMissing = isError && [
        (0, $cwVZP.ErrorKind).NOT_FOUND,
        (0, $cwVZP.ErrorKind).FORBIDDEN
    ].includes((0, $cwVZP.classifyError)(error));
    const contentState = isLoading ? 'loading' : isMissing ? 'missing' : isError ? 'error' : 'content';
    // Desktop parity: web/layout/PatientHeader renders age · blood · phone ·
    // insurance as the identity meta line. INSURANCE_LABEL_KEYS maps the wire
    // value to its Persian label, exactly as the desktop demographics do.
    const phones = (0, $bkBaq.patientPhoneParts)(p);
    const meta = [
        p.age != null && t('patient.ageYears', {
            age: formatDigits(p.age),
            count: Number(p.age)
        }),
        p.bloodType && t('patient.bloodTypeLabel', {
            type: p.bloodType
        }),
        // Same as the desktop header: the main number through the kit's PhoneNumber
        // (landline-tolerant, the raw value when it cannot parse one, so nothing here
        // can blank). The record's other numbers are the «+N» beside the status, where
        // a thumb can reach them (PM-0536).
        phones.primary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, t('common.labels.phone'), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2Oaoe.PatientPrimaryPhone), {
            patient: p
        })),
        p.insurance && t('patient.insuranceLabel', {
            name: (0, $gq4TR.INSURANCE_LABEL_KEYS)[p.insurance] ? t((0, $gq4TR.INSURANCE_LABEL_KEYS)[p.insurance]) : p.insurance
        })
    ].filter(Boolean);
    // The header's one meta line (compact mode): the identifier first, then the
    // same facts the desktop header carries.
    const headerMeta = [
        p.nationalId && `${t('common.labels.nationalId')} ${formatDigits(p.nationalId)}`,
        ...meta
    ].filter(Boolean);
    const subtitle = headerMeta.length ? headerMeta.map((m, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
            key: i
        }, i > 0 && ' \u00b7 ', m)) : undefined;
    const headerAction = phones.others.length > 0 || p.status ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.25rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2Oaoe.PatientMorePhones), {
        patient: p,
        sheet: true,
        onDark: true
    }), p.status && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fdoIv.default), {
        status: p.status
    })) : undefined;
    // The glance, as the header's figures (`null` = unknown, never a dash string:
    // the strip prints «–» itself and hides when nothing is known).
    const figures = [
        {
            key: 'age',
            label: t('common.labels.age'),
            value: p.age != null ? formatDigits(p.age) : null
        },
        {
            key: 'blood',
            label: t('visit.patient.bloodType'),
            value: p.bloodType || null
        },
        {
            key: 'bmi',
            label: 'BMI',
            value: p.bmi ? formatDigits(Math.round(p.bmi * 10) / 10) : null
        },
        {
            key: 'visits',
            label: t('patient.visit'),
            value: p.visitsCount != null ? formatDigits(p.visitsCount) : null
        }
    ];
    const sectionProps = {
        p: p,
        patientId: patientId,
        onRefresh: refresh
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'absolute',
            inset: 0,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            background: (0, $jTCZr.C).bg
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minHeight: 0,
            overflowY: 'auto',
            WebkitOverflowScrolling: 'touch'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $64nJX.default), {
        compact: true,
        title: p.name || t('nav.items.patients'),
        subtitle: subtitle,
        onBack: onBack,
        backLabel: t('common.actions.back'),
        action: headerAction,
        figures: figures,
        figuresLoading: isLoading,
        figuresLabel: t('patient.visit'),
        figuresTestIdPrefix: "patient"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'sticky',
            top: 0,
            zIndex: 20,
            background: (0, $jTCZr.C).card
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dBAbF.default), {
        allergies: allergies
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hVtO3.default), {
        active: tab,
        onChange: setTab
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '0.875rem 1rem 2rem'
        },
        "data-testid": "patient-content",
        "data-state": contentState,
        "aria-busy": isLoading || undefined
    }, isMissing ? // A record that does not exist is not a record that failed to load,
    // and retrying will never produce it. Same split as the desktop
    // surface — see PatientDetail.web.jsx.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8st6E.RecordNotFound), {
        titleKey: "patient.empty.notFoundTitle",
        bodyKey: "patient.empty.notFoundBody",
        detail: patientId
    }) : isError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dLdf9.default), {
        error: error,
        title: t('errors.load.record'),
        onRetry: refresh
    }) : isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $asVAE.default), {
        tab: tab
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, tab === 'overview' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $28KUI.default), {
        ...sectionProps,
        setTab: setTab
    }), tab === 'analysis' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dnT4W.default), {
        p: p,
        patientId: patientId
    }), tab === 'labs' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ky7vJ.default), sectionProps), tab === 'visits' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4wm3E.default), sectionProps), tab === 'files' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cGTI2.default), sectionProps)))));
};
var $2515f4e67960210f$export$2e2bcd8739ae039 = $2515f4e67960210f$var$PatientDetailMobile;

});
parcelRegister("asVAE", function(module, exports) {

$parcel$export(module.exports, "default", () => $64a1fb07b6844f34$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $g6X9N = parcelRequire("g6X9N");
var $66joL = parcelRequire("66joL");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
// ─────────────────────────────────────────────────────────────────────────────
// The mobile record's loading shape — the SECTION body only. The MobileHeader
// band, the overlapping stat tiles (`MobileStatTiles loading`), the allergy
// strip and the section nav all render for real above it, so the phone keeps
// its chrome through the wait. Per section, like the desktop pane: overview
// cards, an analysis chart, observation tiles, visit rows, file cards.
// ─────────────────────────────────────────────────────────────────────────────
const $64a1fb07b6844f34$var$MobileSectionCard = ({ lines: lines = 2, title: title = true })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $g6X9N.default), {
        "aria-hidden": true,
        style: {
            padding: '0.875rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.625rem'
        }
    }, title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 110,
        height: 13
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonText), {
        lines: lines,
        height: 12,
        lastWidth: "72%"
    }));
const $64a1fb07b6844f34$var$MobileVisitRow = ({ i: i })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $g6X9N.default), {
        "aria-hidden": true,
        style: {
            padding: '0.75rem 0.875rem',
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 40,
        height: 40,
        radius: (0, $jTCZr.RADIUS).control
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: `${50 + i * 13 % 28}%`,
        height: 13
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: `${30 + i * 9 % 20}%`,
        height: 11
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 56,
        height: 20,
        radius: (0, $jTCZr.RADIUS).pill
    }));
const $64a1fb07b6844f34$var$MobileFileCard = ({ i: i })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $g6X9N.default), {
        "aria-hidden": true,
        style: {
            padding: '0.75rem',
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 44,
        height: 44,
        radius: (0, $jTCZr.RADIUS).control
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: `${44 + i * 17 % 30}%`,
        height: 13
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: `${26 + i * 11 % 22}%`,
        height: 11
    })));
function $64a1fb07b6844f34$export$2e2bcd8739ae039({ tab: tab = 'overview', label: label }) {
    const { t: t } = (0, $LNQP4.default)();
    const lbl = label ?? t('common.state.loading');
    let body;
    switch(tab){
        case 'analysis':
            body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $g6X9N.default), {
                "aria-hidden": true,
                style: {
                    padding: '0.875rem'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonChart), {
                height: 160,
                line: true,
                legend: 2,
                label: lbl
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($64a1fb07b6844f34$var$MobileSectionCard, {
                lines: 3
            }));
            break;
        case 'labs':
            body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
                    gap: '0.625rem'
                }
            }, Array.from({
                length: 4
            }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $g6X9N.default), {
                    key: i,
                    "aria-hidden": true,
                    style: {
                        padding: '0.75rem',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 8
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
                    width: 64,
                    height: 11
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
                    width: 52,
                    height: 18
                })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($64a1fb07b6844f34$var$MobileSectionCard, {
                lines: 2
            }));
            break;
        case 'visits':
            body = [
                0,
                1,
                2,
                3
            ].map((i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($64a1fb07b6844f34$var$MobileVisitRow, {
                    key: i,
                    i: i
                }));
            break;
        case 'files':
            body = [
                0,
                1,
                2
            ].map((i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($64a1fb07b6844f34$var$MobileFileCard, {
                    key: i,
                    i: i
                }));
            break;
        default:
            body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $g6X9N.default), {
                "aria-hidden": true,
                style: {
                    padding: '0.875rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.75rem'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonAvatar), {
                size: 40
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 6
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
                width: "55%",
                height: 13
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
                width: "35%",
                height: 11
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($64a1fb07b6844f34$var$MobileSectionCard, {
                lines: 2
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($64a1fb07b6844f34$var$MobileSectionCard, {
                lines: 3
            }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonRegion), {
        label: lbl,
        "data-testid": `patient-section-skeleton-${tab}`,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem'
        }
    }, body);
}

});

parcelRegister("8st6E", function(module, exports) {

$parcel$export(module.exports, "RecordNotFound", () => $4f09c2fbf6e97540$export$1c8a31b6c319fadd);

var $acw62 = parcelRequire("acw62");

var $iH4cM = parcelRequire("iH4cM");

var $cZWc7 = parcelRequire("cZWc7");

var $eBrFc = parcelRequire("eBrFc");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
function $4f09c2fbf6e97540$export$1c8a31b6c319fadd({ titleKey: titleKey, bodyKey: bodyKey, detail: detail, onBack: onBack }) {
    const { t: t } = (0, $LNQP4.default)();
    const navigate = (0, $eBrFc.useAppNavigate)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZWc7.default), {
        testId: "record-not-found",
        tone: "neutral",
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $iH4cM.default), {
            size: 28,
            strokeWidth: 1.8,
            "aria-hidden": true
        }),
        title: t(titleKey || 'errors.routes.recordNotFoundTitle'),
        body: t(bodyKey || 'errors.routes.recordNotFoundBody'),
        detail: detail,
        actions: [
            ...onBack ? [
                {
                    key: 'back',
                    label: t('common.actions.back'),
                    onClick: onBack
                }
            ] : [],
            {
                key: 'reception',
                label: t('errors.routes.goReception'),
                onClick: ()=>navigate('reception'),
                variant: onBack ? 'secondary' : 'primary'
            }
        ]
    });
}
var $4f09c2fbf6e97540$export$2e2bcd8739ae039 = $4f09c2fbf6e97540$export$1c8a31b6c319fadd;

});
parcelRegister("cZWc7", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc04608d7d7444fa$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
parcelRequire("7sS0P");
var $jTCZr = parcelRequire("jTCZr");
var $7sS0P = parcelRequire("7sS0P");

var $1HT9m = parcelRequire("1HT9m");

var $fkEOT = parcelRequire("fkEOT");
// ─────────────────────────────────────────────────────────────────────────────
// The one shell every whole-page system state renders through: 404, 403, the
// crash recovery page, maintenance, the cold offline boot, session expiry.
//
// Why one component rather than six designs: these screens are, by definition,
// the moments a doctor is already unsure whether the app is working. Six
// different layouts for six different faults reads as six different kinds of
// broken. One recognisable shape — icon, one-line verdict, one-line advice, a
// primary action — makes an unexpected page legible as "the app is telling me
// something", which is exactly the reassurance the situation needs.
//
// The shape is deliberately NOT the framework's `EmptyState`. An empty state
// says «there is nothing here yet» inside a working screen and must stay quiet;
// a system state says «something is wrong» and owns the viewport. Collapsing
// them is how a failed load ends up looking like a successful load of nothing.
//
// DESIGN COMPLIANCE — this page is not a special case:
//   • every size/weight comes from `type` (constants/typography); no literal
//     fontSize, because a page that invents its own is a page that stops
//     matching the app the first time the scale moves,
//   • radius and elevation from RADIUS/SHADOW, so the card matches every other
//     card rather than being 2px rounder,
//   • actions are the kit `Button` — the app has seven button variants and a
//     hand-rolled one here would be an eighth,
//   • colours from `C`, never literal hex, so an accent preset reaches this
//     page too.
// ─────────────────────────────────────────────────────────────────────────────
/**
 * Tone drives the icon disc only, never the page. A red wash behind a 404 would
 * make a mistyped URL look like a clinical incident.
 */ const $fc04608d7d7444fa$var$TONES = {
    neutral: ()=>({
            fg: (0, $jTCZr.C).textMuted,
            bg: (0, $jTCZr.soft)((0, $jTCZr.C).textMuted, 0.1)
        }),
    info: ()=>({
            fg: (0, $jTCZr.C).navy,
            bg: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.1)
        }),
    warning: ()=>({
            fg: (0, $jTCZr.C).amber,
            bg: (0, $jTCZr.C).amberLight
        }),
    danger: ()=>({
            fg: (0, $jTCZr.C).red,
            bg: (0, $jTCZr.C).redLight
        })
};
// The disc matches ErrorState's, so the inline and full-page failures read as
// one family seen at two sizes.
const $fc04608d7d7444fa$var$DISC = 56;
function $fc04608d7d7444fa$export$2e2bcd8739ae039({ tone: tone = 'neutral', icon: icon, code: code, title: title, body: body, detail: detail, actions: actions = [], children: children, footer: footer, fullscreen: fullscreen = false, testId: testId = 'system-page' }) {
    const palette = ($fc04608d7d7444fa$var$TONES[tone] || $fc04608d7d7444fa$var$TONES.neutral)();
    // ── The phone is not a narrow desktop (spec §B.5, J-15) ───────────────────
    // These pages were the last surface in the app with no mobile geometry at
    // all: a 460px card, centred, with 2rem of padding around it — which on a
    // 320px screen is a card wider than the window inside a page that then
    // scrolls sideways, and on any phone is a lot of empty chrome around one
    // sentence. They are also the pages a doctor is MOST likely to meet on a
    // phone, because a bad link arrives in a message.
    //
    // On a phone the card stops being a card: it fills the width, drops its
    // border and shadow (there is nothing to float above), and the actions stack
    // full-width so each is a real target rather than two half-width buttons on
    // a 320px row.
    const { isMobile: isMobile } = (0, $fkEOT.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId,
        "data-system-state": tone,
        role: "alert",
        // `polite`, not `assertive`: the page has already replaced everything the
        // doctor was looking at, so the screen reader does not also need to
        // interrupt itself mid-sentence to say so.
        "aria-live": "polite",
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flex: fullscreen ? undefined : 1,
            width: '100%',
            // `100dvh`, not `100vh`: `vh` is the LARGEST viewport, so a fullscreen
            // system page on iOS Safari ran under the address bar — and the part
            // that went missing was its action buttons (§3.4 Z3, §H.1).
            height: fullscreen ? '100dvh' : '100%',
            minHeight: fullscreen ? undefined : '20rem',
            padding: isMobile ? '1.5rem 0.875rem' : '2rem 1.25rem',
            background: (0, $jTCZr.C).bg,
            boxSizing: 'border-box'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: (0, $jTCZr.C).card,
            border: isMobile ? 'none' : `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: isMobile ? 0 : (0, $7sS0P.RADIUS).card,
            padding: isMobile ? '2rem 1.25rem 1.5rem' : '2.5rem 2rem 2rem',
            maxWidth: isMobile ? '100%' : '28.75rem',
            width: '100%',
            textAlign: 'center',
            position: 'relative',
            overflow: 'hidden',
            boxShadow: isMobile ? 'none' : (0, $7sS0P.SHADOW).card
        }
    }, code && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            ...(0, $1HT9m.type).hero,
            position: 'absolute',
            top: '-0.5rem',
            insetInlineStart: '0.875rem',
            color: (0, $jTCZr.soft)((0, $jTCZr.C).textMuted, 0.09),
            userSelect: 'none',
            direction: 'ltr',
            pointerEvents: 'none'
        }
    }, code), icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: $fc04608d7d7444fa$var$DISC,
            height: $fc04608d7d7444fa$var$DISC,
            borderRadius: (0, $7sS0P.RADIUS).pill,
            background: palette.bg,
            color: palette.fg,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 1rem',
            position: 'relative'
        }
    }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            ...(0, $1HT9m.type).metric,
            color: (0, $jTCZr.C).textPrimary,
            marginBottom: '0.5rem'
        }
    }, title), body && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            ...(0, $1HT9m.type).body,
            fontWeight: 500,
            color: (0, $jTCZr.C).textSecondary,
            lineHeight: 1.85,
            marginBottom: '1.25rem'
        }
    }, body), children, detail && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${testId}-detail`,
        style: {
            ...(0, $1HT9m.type).caption,
            color: (0, $jTCZr.C).textMuted,
            direction: 'ltr',
            textAlign: 'left',
            fontFamily: 'monospace',
            wordBreak: 'break-word',
            background: (0, $jTCZr.C).bg,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: (0, $7sS0P.RADIUS).chip,
            padding: '0.5rem 0.625rem',
            margin: '0 0 1.25rem',
            maxHeight: '7.5rem',
            overflow: 'auto'
        }
    }, detail), actions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            // Stacked on a phone whatever the count: two half-width buttons on
            // a 320px row are two targets that are each too small.
            flexDirection: isMobile || actions.length > 2 ? 'column' : 'row',
            gap: '0.625rem',
            justifyContent: 'center'
        }
    }, actions.map((action, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fc04608d7d7444fa$var$SystemAction, {
            key: action.key || action.label || i,
            ...action,
            // The first action is the recommended one unless a caller says
            // otherwise — a system page with two equally-weighted buttons
            // makes the doctor decide something they have no basis to decide.
            variant: action.variant || (i === 0 ? 'primary' : 'secondary')
        }))), footer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            ...(0, $1HT9m.type).caption,
            color: (0, $jTCZr.C).textMuted,
            marginTop: '1.25rem',
            lineHeight: 1.8
        }
    }, footer)));
}
// The two roles a system page offers map onto kit variants: `default` (the
// navy fill) for the recommended action, `outline` for the alternative. The
// prop names stay primary/secondary because that is what the CALLER is
// choosing — an intent, not a paint job — and it keeps the call sites readable.
const $fc04608d7d7444fa$var$VARIANT_MAP = {
    primary: 'default',
    secondary: 'outline',
    ghost: 'ghost'
};
function $fc04608d7d7444fa$var$SystemAction({ label: label, onClick: onClick, href: href, variant: variant, testId: testId }) {
    const kitVariant = $fc04608d7d7444fa$var$VARIANT_MAP[variant] || 'outline';
    // `asChild` renders the anchor with the button's styling, so a link action is
    // visually identical to a button one instead of being a hand-styled <a>.
    if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        asChild: true,
        variant: kitVariant,
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
        href: href
    }, label));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        type: "button",
        variant: kitVariant,
        onClick: onClick,
        "data-testid": testId
    }, label);
}

});


parcelRegister("hVtO3", function(module, exports) {

$parcel$export(module.exports, "PATIENT_SECTIONS", () => $d1e2b5d6e06e4f47$export$d6b7a0e86411dcc0);
$parcel$export(module.exports, "default", () => $d1e2b5d6e06e4f47$export$2e2bcd8739ae039);
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");
parcelRequire("7sS0P");
var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");

var $k2reB = parcelRequire("k2reB");
var $4CVxl = parcelRequire("4CVxl");
var $8jE1c = parcelRequire("8jE1c");
var $aRAFQ = parcelRequire("aRAFQ");
var $fX0JO = parcelRequire("fX0JO");
const $d1e2b5d6e06e4f47$export$d6b7a0e86411dcc0 = (t)=>[
        {
            id: 'overview',
            label: t('patient.tabs.overview'),
            Icon: (0, $k2reB.default)
        },
        // «تحلیل» — the record's measurements, prescriptions and events on one time
        // axis. Sits beside «خلاصه» on both surfaces: summary is what changed, the
        // analysis is how it moved.
        {
            id: 'analysis',
            label: t('patient.tabs.analysis'),
            Icon: (0, $aRAFQ.default)
        },
        // «مشاهدات» — vitals + laboratory analytes. The route segment stays `labs`
        // so existing links and bookmarks keep resolving.
        {
            id: 'labs',
            label: t('patient.tabs.observations'),
            Icon: (0, $4CVxl.default)
        },
        {
            id: 'visits',
            label: t('patient.tabs.visits'),
            Icon: (0, $fX0JO.default)
        },
        {
            id: 'files',
            label: t('patient.tabs.files'),
            Icon: (0, $8jE1c.default)
        }
    ];
const $d1e2b5d6e06e4f47$var$MobilePatientNav = ({ active: active, onChange: onChange })=>{
    const { t: t } = (0, $LNQP4.default)();
    // Keep the selected tab in view: five tabs fit most phones, but on a narrow
    // viewport the strip still scrolls, so centre the selected one.
    const activeRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        activeRef.current?.scrollIntoView({
            inline: 'center',
            block: 'nearest',
            behavior: 'smooth'
        });
    }, [
        active
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "patient-nav",
        role: "tablist",
        "aria-label": t('patient.tabs.sectionsLabel'),
        style: {
            background: (0, $jTCZr.C).card,
            borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
            flexShrink: 0,
            overflowX: 'auto',
            display: 'flex',
            scrollbarWidth: 'none',
            padding: '0 0.25rem'
        }
    }, $d1e2b5d6e06e4f47$export$d6b7a0e86411dcc0(t).map(({ id: id, label: label, Icon: Icon })=>{
        const on = active === id;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            key: id,
            ref: on ? activeRef : undefined,
            variant: "ghost",
            role: "tab",
            "aria-selected": on,
            "data-testid": `patient-nav-${id}`,
            onClick: ()=>onChange(id),
            className: "h-auto min-h-11 flex-col gap-0.5 rounded-none px-3.5 py-2 shrink-0 hover:bg-transparent",
            style: {
                color: on ? (0, $jTCZr.C).navy : (0, $jTCZr.C).textMuted,
                fontWeight: on ? 700 : 500,
                borderBottom: on ? `2.5px solid ${(0, $jTCZr.C).navy}` : '2.5px solid transparent'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
            size: 16,
            strokeWidth: on ? 2.4 : 2,
            "aria-hidden": true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.6875rem'
            }
        }, label));
    }));
};
var $d1e2b5d6e06e4f47$export$2e2bcd8739ae039 = $d1e2b5d6e06e4f47$var$MobilePatientNav;

});
parcelRegister("aRAFQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7191d404a5f3bf70$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $7191d404a5f3bf70$export$a2387ed3b5d536eb = {
    name: "chart-line",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M3 3v16a2 2 0 0 0 2 2h16",
                key: "c24i48"
            }
        ],
        [
            "path",
            {
                d: "m19 9-5 5-4-4-3 3",
                key: "2osh9i"
            }
        ]
    ],
    aliases: [
        "line-chart"
    ]
};
$7191d404a5f3bf70$export$a2387ed3b5d536eb.node;
const $7191d404a5f3bf70$export$2e2bcd8739ae039 = (0, $9QBug.default)($7191d404a5f3bf70$export$a2387ed3b5d536eb);

});


parcelRegister("28KUI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d983d5badec2112a$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
parcelRequire("7sS0P");
var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $7gSBD = parcelRequire("7gSBD");
var $3Amwd = parcelRequire("3Amwd");
var $6usBW = parcelRequire("6usBW");

var $QG9Z3 = parcelRequire("QG9Z3");
var $huNwV = parcelRequire("huNwV");
var $3FyOw = parcelRequire("3FyOw");
var $4CVxl = parcelRequire("4CVxl");
var $aVx4q = parcelRequire("aVx4q");
var $fX0JO = parcelRequire("fX0JO");
var $6TdpC = parcelRequire("6TdpC");

var $eVM84 = parcelRequire("eVM84");

var $3OnFU = parcelRequire("3OnFU");

var $gcegg = parcelRequire("gcegg");
var $jTCZr = parcelRequire("jTCZr");

var $i9Cif = parcelRequire("i9Cif");

var $gq4TR = parcelRequire("gq4TR");

var $g6gAc = parcelRequire("g6gAc");
// Overview — «خلاصه», the record's landing section.
//
// This is the phone rendering of the DESKTOP overview (PatientDetail/web/tabs/
// OverviewTab.jsx), which is the source of truth for what the section contains:
// the last-visit AI summary, active medications (prescribe + delete), active
// diagnoses, allergies, abnormal labs and the vitals glance — in that order.
// The phone stacks what the desktop lays out as main + rail; the derivations
// below are the same ones, so the two surfaces can never disagree.
//
// The mobile-only «رویدادهای بالینی» milestone timeline and «یادداشت‌های اخیر»
// block were removed: neither exists on the desktop record, and notes are read
// in the visit they belong to («تاریخچه مراجعات»).
const $d983d5badec2112a$var$LIST_DOCTOR_ORDERS_VISITS = `query ListDoctorOrders($patientId:ID!){listDoctorOrders(patientId:$patientId){id appointmentId orderType name code urgency status notes createdAt performedDate performedHere stage nextBookingAt}}`;
const $d983d5badec2112a$var$DELETE_MEDICATION = `mutation DeleteMedication($id: ID!) { deleteMedication(id: $id) }`;
// Same vital LOINC set + labels the desktop overview glances at (web/constants →
// OV_VITAL_DEF). Kept in the same order so both surfaces read alike.
const $d983d5badec2112a$var$OV_VITAL_DEF = (t)=>[
        {
            code: '55284-4',
            label: t('patient.vitals.bp'),
            unit: 'mmHg'
        },
        {
            code: '8867-4',
            label: t('patient.vitals.hr'),
            unit: 'bpm'
        },
        {
            code: '59408-5',
            label: t('patient.vitals.spo2'),
            unit: '%'
        },
        {
            code: '8310-5',
            label: t('patient.vitals.bodyTemp'),
            unit: "\xb0C"
        }
    ];
const $d983d5badec2112a$var$ENCOUNTER_TYPE = (t)=>({
        ambulatory: t('patient.encType.outpatient'),
        emergency: t('common.urgency.emergency'),
        inpatient: t('patient.encType.inpatient'),
        observation: t('patient.encType.observation')
    });
const $d983d5badec2112a$var$OV_SEVERITY = (t)=>({
        severe: {
            l: t('patient.allergies.severity.severe'),
            tone: 'high'
        },
        moderate: {
            l: t('patient.allergies.severity.moderate'),
            tone: 'mid'
        },
        mild: {
            l: t('patient.allergies.severity.mild'),
            tone: 'mid'
        }
    });
// ── Card chrome ──────────────────────────────────────────────────────────────
const $d983d5badec2112a$var$Card = ({ children: children, style: style })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: (0, $jTCZr.C).card,
            borderRadius: '0.75rem',
            border: `1px solid ${(0, $jTCZr.C).border}`,
            overflow: 'hidden',
            ...style
        }
    }, children);
const $d983d5badec2112a$var$CardHead = ({ Icon: Icon, title: title, count: count, action: action, danger: danger })=>{
    const { formatDigits: formatDigits } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0.6875rem 0.875rem',
            borderBottom: `1px solid ${(0, $jTCZr.C).border}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: '1.625rem',
            height: '1.625rem',
            borderRadius: '0.5rem',
            flexShrink: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: danger ? (0, $jTCZr.CT).dangerSoft : (0, $jTCZr.CT).accentSoft,
            color: danger ? (0, $jTCZr.CT).dangerInk : (0, $jTCZr.CT).accentInk
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        size: 14,
        "aria-hidden": true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.8125rem',
            fontWeight: 700,
            color: (0, $jTCZr.C).textPrimary
        }
    }, title), count != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.6875rem',
            fontWeight: 600,
            color: (0, $jTCZr.C).textMuted,
            background: (0, $jTCZr.CT).surface2,
            padding: '0.0625rem 0.4375rem',
            borderRadius: '0.75rem'
        }
    }, formatDigits(count)), action && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            marginInlineStart: 'auto'
        }
    }, action));
};
const $d983d5badec2112a$var$LinkButton = ({ onClick: onClick, children: children, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        onClick: onClick,
        "data-testid": testId,
        className: "min-h-11 px-1 font-bold",
        style: {
            fontSize: '0.6875rem',
            color: (0, $jTCZr.CT).accentInk
        }
    }, children);
const $d983d5badec2112a$var$CardEmpty = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '0.875rem',
            textAlign: 'center',
            fontSize: '0.75rem',
            color: (0, $jTCZr.C).textMuted
        }
    }, children);
const $d983d5badec2112a$var$MobilePatientOverview = ({ p: p, patientId: patientId, onRefresh: onRefresh, setTab: setTab })=>{
    const { t: t, formatDate: formatDate, formatDigits: formatDigits } = (0, $LNQP4.default)();
    const toast = (0, $6usBW.useToast)();
    const pid = patientId || p.id;
    // Doctor orders back the last-visit "what was done" list, exactly as on desktop.
    const [orders, setOrders] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!pid) return;
        setOrders(null);
        (0, $eVM84.bffQuery)($d983d5badec2112a$var$LIST_DOCTOR_ORDERS_VISITS, {
            patientId: pid
        }).then((r)=>setOrders(r.listDoctorOrders || [])).catch(()=>setOrders([]));
    }, [
        pid
    ]);
    // ── Derived data (mirrors web/tabs/OverviewTab.jsx) ────────────────────────
    const conditions = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const seen = new Set();
        return (p.clinicalConditions || []).filter((c)=>{
            if (seen.has(c.id)) return false;
            seen.add(c.id);
            return true;
        });
    }, [
        p.clinicalConditions
    ]);
    const activeConditions = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>conditions.filter((c)=>c.clinicalStatus === 'active'), [
        conditions
    ]);
    const medications = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const seen = new Set();
        return (p.clinicalMedications || []).filter((m)=>{
            if (seen.has(m.id)) return false;
            seen.add(m.id);
            return true;
        });
    }, [
        p.clinicalMedications
    ]);
    const activeMeds = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const byCode = {};
        medications.filter((m)=>m.status === 'active' || m.status === 'on-hold').forEach((m)=>{
            const key = m.code || m.display;
            if (!byCode[key] || (m.authoredOn || '') > (byCode[key].authoredOn || '')) byCode[key] = m;
        });
        return Object.values(byCode).sort((a, b)=>(b.authoredOn || '').localeCompare(a.authoredOn || ''));
    }, [
        medications
    ]);
    const allergies = p.clinicalAllergies || [];
    const obsByCode = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const map = {};
        [
            ...p.clinicalObservations || []
        ].sort((a, b)=>(a.effectiveDate || a.createdAt || '').localeCompare(b.effectiveDate || b.createdAt || '')).forEach((o)=>{
            (map[o.code] = map[o.code] || []).push(o);
        });
        return map;
    }, [
        p.clinicalObservations
    ]);
    const abnormalLabs = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const seenId = new Set();
        const abnormal = [
            ...p.clinicalObservations || []
        ].filter((o)=>{
            if (seenId.has(o.id)) return false;
            seenId.add(o.id);
            return true;
        }).filter((o)=>!(0, $gq4TR.VITAL_LOINC_SET).has(o.code)).filter((o)=>[
                'abnormal',
                'critical',
                'high',
                'low',
                'h',
                'l'
            ].includes((o.status || '').toLowerCase()));
        const seenCode = new Set();
        return abnormal.filter((o)=>{
            const k = o.code || o.display;
            if (seenCode.has(k)) return false;
            seenCode.add(k);
            return true;
        }).reverse().slice(0, 6).map((o)=>({
                ...o,
                series: (obsByCode[o.code] || []).map((x)=>parseFloat(x.value)).filter((v)=>!isNaN(v)).slice(-6)
            }));
    }, [
        p.clinicalObservations,
        obsByCode
    ]);
    const lastVisitSummary = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const notes = [
            ...p.clinicalNotes || []
        ].reverse();
        return notes.find((n)=>n.noteType === 'VISIT_SUMMARY') || null;
    }, [
        p.clinicalNotes
    ]);
    const lastVisitInfo = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (!lastVisitSummary) return null;
        const encId = lastVisitSummary.appointmentId;
        const encounter = (p.encounters || []).find((e)=>e.id === encId);
        const bp = (obsByCode['55284-4'] || []).filter((o)=>o.appointmentId === encId).slice(-1)[0];
        const actions = [
            ...medications.filter((m)=>m.appointmentId === encId).map((m)=>m.dosageInstruction?.text ? t('patient.overview.medStartedWithDose', {
                    name: m.display,
                    dose: m.dosageInstruction.text
                }) : t('patient.overview.medStarted', {
                    name: m.display
                })),
            ...(orders || []).filter((o)=>o.appointmentId === encId).map((o)=>t('patient.overview.orderRequested', {
                    name: o.name
                }))
        ];
        return {
            date: (0, $gcegg.faDate)(lastVisitSummary.createdAt, formatDate),
            type: encounter ? $d983d5badec2112a$var$ENCOUNTER_TYPE(t)[encounter.type] || encounter.type : null,
            dxCount: conditions.filter((c)=>c.appointmentId === encId).length,
            bp: bp?.value || null,
            text: (lastVisitSummary.content?.text || '').replace(/<[^>]*>/g, ''),
            actions: actions
        };
    }, [
        lastVisitSummary,
        p.encounters,
        obsByCode,
        medications,
        orders,
        conditions,
        t,
        formatDate
    ]);
    const vitals = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>$d983d5badec2112a$var$OV_VITAL_DEF(t).map((v)=>{
            const series = (obsByCode[v.code] || []).map((o)=>parseFloat(o.value)).filter((n)=>!isNaN(n)).slice(-6);
            const latest = (obsByCode[v.code] || [])[obsByCode[v.code]?.length - 1];
            return {
                ...v,
                value: latest?.value,
                series: series
            };
        }).filter((v)=>v.value != null), [
        obsByCode,
        t
    ]);
    // ── Medication list: confirm-gated delete only. The free-text «+ تجویز» that
    // wrote a name into the medication list is gone (PM-0118): a drug reaches the
    // record through a visit's نسخه, where it is a formulary row with a sig, is
    // interaction-checked and can go to بیمه — a typed name was none of those and
    // read as a prescription to the doctor.
    const [confirmMed, setConfirmMed] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [deletingMed, setDeletingMed] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const doDeleteMed = async (id)=>{
        setDeletingMed(id);
        try {
            await (0, $eVM84.bffMutation)($d983d5badec2112a$var$DELETE_MEDICATION, {
                id: id
            });
            onRefresh?.();
        } catch  {
            toast?.error?.(t('errors.save.medicationDelete'));
        } finally{
            setDeletingMed(null);
        }
    };
    const nothing = !lastVisitInfo && !activeMeds.length && !activeConditions.length && !allergies.length && !abnormalLabs.length && !vitals.length;
    if (nothing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $QG9Z3.default), {
            size: 44,
            color: (0, $jTCZr.C).textMuted,
            strokeWidth: 1.5,
            "aria-hidden": true
        }),
        title: t('patient.empty.nothingToShow')
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.875rem'
        },
        "data-testid": "overview-content"
    }, lastVisitInfo && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d983d5badec2112a$var$Card, {
        "data-testid": "overview-last-visit"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d983d5badec2112a$var$CardHead, {
        Icon: (0, $3FyOw.default),
        title: t('patient.overview.lastVisitSummary'),
        action: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d983d5badec2112a$var$LinkButton, {
            testId: "overview-view-visit",
            onClick: ()=>setTab?.('visits')
        }, t('patient.overview.viewFull'))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '0.75rem 0.875rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: '0.375rem',
            marginBottom: '0.5rem',
            fontSize: '0.6875rem',
            color: (0, $jTCZr.C).textMuted
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("b", {
        style: {
            color: (0, $jTCZr.C).textPrimary
        }
    }, lastVisitInfo.date), lastVisitInfo.type && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true
    }, "\xb7"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, lastVisitInfo.type)), lastVisitInfo.dxCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true
    }, "\xb7"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, formatDigits(lastVisitInfo.dxCount), " ", t('patient.conditions.one'))), lastVisitInfo.bp && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true
    }, "\xb7"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, t('patient.vitals.bp'), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("b", {
        dir: "ltr",
        style: {
            color: (0, $jTCZr.C).textPrimary
        }
    }, formatDigits(lastVisitInfo.bp))))), lastVisitInfo.text && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        style: {
            fontSize: '0.78125rem',
            color: (0, $jTCZr.C).textSecondary,
            lineHeight: 1.75,
            margin: 0
        }
    }, lastVisitInfo.text), lastVisitInfo.actions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: '0.625rem',
            paddingTop: '0.625rem',
            borderTop: `1px solid ${(0, $jTCZr.C).border}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.625rem',
            fontWeight: 700,
            color: (0, $jTCZr.C).textMuted,
            letterSpacing: '0.05em',
            marginBottom: '0.375rem'
        }
    }, t('patient.overview.visitActions')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        style: {
            listStyle: 'none',
            margin: 0,
            padding: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: '0.3125rem'
        }
    }, lastVisitInfo.actions.map((a, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: i,
            style: {
                display: 'flex',
                alignItems: 'flex-start',
                gap: '0.4375rem',
                fontSize: '0.75rem',
                color: (0, $jTCZr.C).textSecondary,
                lineHeight: 1.6
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                color: (0, $jTCZr.CT).good,
                flexShrink: 0,
                marginTop: '0.1875rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
            size: 11,
            "aria-hidden": true
        })), a)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d983d5badec2112a$var$Card, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d983d5badec2112a$var$CardHead, {
        Icon: (0, $aVx4q.default),
        title: t('patient.meds.active'),
        count: activeMeds.length
    }), activeMeds.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d983d5badec2112a$var$CardEmpty, null, t('visit.rx.noneRecorded')) : activeMeds.map((m, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: m.id || i,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.625rem',
                padding: '0.625rem 0.875rem',
                borderTop: i ? `1px solid ${(0, $jTCZr.C).border}` : 'none'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                width: '2rem',
                height: '2rem',
                borderRadius: '0.5rem',
                background: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.08),
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aVx4q.default), {
            size: 15,
            color: (0, $jTCZr.C).navy,
            "aria-hidden": true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1,
                minWidth: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            dir: "auto",
            style: {
                fontSize: '0.8125rem',
                fontWeight: 600,
                color: (0, $jTCZr.C).textPrimary
            }
        }, (0, $g6gAc.medDisplayName)(m)), m.dosageInstruction?.text && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.6875rem',
                color: (0, $jTCZr.C).textMuted,
                marginTop: '0.0625rem'
            }
        }, m.dosageInstruction.text)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            size: "icon",
            className: "h-11 w-11 shrink-0",
            onClick: ()=>setConfirmMed(m.id),
            disabled: deletingMed === m.id,
            "aria-label": t('patient.meds.removeAria', {
                name: m.display
            }),
            "data-testid": `overview-med-delete-${m.id}`,
            style: {
                color: (0, $jTCZr.CT).danger,
                opacity: deletingMed === m.id ? 0.4 : 1
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
            size: 16,
            "aria-hidden": true
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d983d5badec2112a$var$Card, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d983d5badec2112a$var$CardHead, {
        Icon: (0, $fX0JO.default),
        title: t('patient.conditions.active'),
        count: activeConditions.length
    }), activeConditions.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d983d5badec2112a$var$CardEmpty, null, t('patient.empty.noneRecorded')) : activeConditions.map((c, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: c.id || i,
            style: {
                padding: '0.625rem 0.875rem',
                borderTop: i ? `1px solid ${(0, $jTCZr.C).border}` : 'none'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: '0.375rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.625rem',
                fontWeight: 700,
                padding: '0.0625rem 0.4375rem',
                borderRadius: '0.25rem',
                background: (0, $jTCZr.CT).goodSoft,
                color: (0, $jTCZr.CT).goodInk
            }
        }, t('common.state.active')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $i9Cif.DiagnosisTypeBadge), {
            cond: c
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.8125rem',
                fontWeight: 600,
                color: (0, $jTCZr.C).textPrimary
            }
        }, c.display), c.code && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "ltr",
            style: {
                fontSize: '0.625rem',
                color: (0, $jTCZr.C).textMuted,
                fontFamily: 'ui-monospace, monospace'
            }
        }, c.code)), c.onsetDate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.6875rem',
                color: (0, $jTCZr.C).textMuted,
                marginTop: '0.1875rem'
            }
        }, t('patient.conditions.onset'), " ", (0, $gcegg.faDate)(c.onsetDate, formatDate))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d983d5badec2112a$var$Card, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d983d5badec2112a$var$CardHead, {
        Icon: (0, $QG9Z3.default),
        title: t('patient.allergies.drug'),
        count: allergies.length,
        danger: true
    }), allergies.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d983d5badec2112a$var$CardEmpty, null, t('patient.allergies.none')) : allergies.map((a, i)=>{
        const sev = $d983d5badec2112a$var$OV_SEVERITY(t)[a.severity];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: a.id || i,
            style: {
                display: 'flex',
                alignItems: 'flex-start',
                gap: '0.5rem',
                padding: '0.625rem 0.875rem',
                borderTop: i ? `1px solid ${(0, $jTCZr.C).border}` : 'none'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.625rem',
                fontWeight: 700,
                padding: '0.125rem 0.4375rem',
                borderRadius: '0.25rem',
                flexShrink: 0,
                background: sev?.tone === 'high' ? (0, $jTCZr.CT).dangerSoft : (0, $jTCZr.C).amberLight,
                color: sev?.tone === 'high' ? (0, $jTCZr.CT).dangerInk : (0, $jTCZr.CT).warnInk
            }
        }, sev?.l || a.severity || "\u2014"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1,
                minWidth: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.8125rem',
                fontWeight: 600,
                color: (0, $jTCZr.C).textPrimary
            }
        }, a.allergen), a.reaction && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.6875rem',
                color: (0, $jTCZr.C).textMuted,
                marginTop: '0.0625rem'
            }
        }, t('patient.allergies.reaction'), " ", a.reaction)));
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d983d5badec2112a$var$Card, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d983d5badec2112a$var$CardHead, {
        Icon: (0, $4CVxl.default),
        title: t('patient.obs.abnormal'),
        count: abnormalLabs.length,
        action: abnormalLabs.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d983d5badec2112a$var$LinkButton, {
            testId: "overview-view-labs",
            onClick: ()=>setTab?.('labs')
        }, t('patient.obs.viewAll')) : null
    }), abnormalLabs.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d983d5badec2112a$var$CardEmpty, null, t('patient.empty.noneRecorded')) : abnormalLabs.map((o, i)=>{
        const isCrit = (o.status || '').toLowerCase() === 'critical';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: o.id || i,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                padding: '0.625rem 0.875rem',
                borderTop: i ? `1px solid ${(0, $jTCZr.C).border}` : 'none'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1,
                minWidth: 0,
                fontSize: '0.78125rem',
                color: (0, $jTCZr.C).textPrimary,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            }
        }, o.display), o.series.length > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3Amwd.default), {
            points: o.series,
            width: 40,
            height: 18,
            tone: isCrit ? 'danger' : 'warn'
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                textAlign: 'end',
                flexShrink: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            dir: "ltr",
            style: {
                fontSize: '0.8125rem',
                fontWeight: 700,
                fontFamily: 'ui-monospace, monospace',
                color: isCrit ? (0, $jTCZr.CT).danger : (0, $jTCZr.CT).warnInk
            }
        }, formatDigits(o.value)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.5625rem',
                fontWeight: 700,
                color: isCrit ? (0, $jTCZr.CT).danger : (0, $jTCZr.CT).warnInk
            }
        }, isCrit ? t('visit.vitals.critical') : t('visit.vitals.abnormal'))));
    })), vitals.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gcegg.SectionTitle), null, t('patient.labCategory.vitals')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '0.5rem'
        }
    }, vitals.map((v)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: v.code,
            style: {
                background: (0, $jTCZr.C).card,
                borderRadius: '0.625rem',
                border: `1px solid ${(0, $jTCZr.C).border}`,
                padding: '0.625rem 0.75rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.625rem',
                fontWeight: 600,
                color: (0, $jTCZr.C).textMuted,
                marginBottom: '0.25rem'
            }
        }, v.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'baseline',
                gap: '0.25rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "ltr",
            style: {
                fontSize: '1rem',
                fontWeight: 700,
                color: (0, $jTCZr.C).textPrimary,
                fontFamily: 'ui-monospace, monospace'
            }
        }, formatDigits(v.value)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.5625rem',
                color: (0, $jTCZr.C).textMuted
            }
        }, v.unit)), v.series.length > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                marginTop: '0.25rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3Amwd.default), {
            points: v.series,
            width: 40,
            height: 9
        })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3OnFU.default), {
        open: !!confirmMed,
        onOpenChange: (o)=>{
            if (!o) setConfirmMed(null);
        },
        title: t('patient.meds.delete'),
        message: t('patient.meds.deleteConfirm'),
        destructive: true,
        confirmLabel: t('common.actions.delete'),
        cancelLabel: t('common.actions.cancel'),
        onConfirm: ()=>doDeleteMed(confirmMed)
    }));
};
var $d983d5badec2112a$export$2e2bcd8739ae039 = $d983d5badec2112a$var$MobilePatientOverview;

});

parcelRegister("dnT4W", function(module, exports) {

$parcel$export(module.exports, "default", () => $450dbe611cd068cd$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
parcelRequire("7sS0P");
var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $g6X9N = parcelRequire("g6X9N");
var $cRX9v = parcelRequire("cRX9v");
var $7gSBD = parcelRequire("7gSBD");
var $cLQXb = parcelRequire("cLQXb");
var $h4ZeB = parcelRequire("h4ZeB");
var $ctU9L = parcelRequire("ctU9L");
var $kCQwN = parcelRequire("kCQwN");
var $66joL = parcelRequire("66joL");
var $cPdQE = parcelRequire("cPdQE");
var $3uzzV = parcelRequire("3uzzV");

var $k2reB = parcelRequire("k2reB");
var $aRAFQ = parcelRequire("aRAFQ");
var $8g4t5 = parcelRequire("8g4t5");
var $5v9tj = parcelRequire("5v9tj");
var $6TdpC = parcelRequire("6TdpC");
var $bU80g = parcelRequire("bU80g");

var $dLdf9 = parcelRequire("dLdf9");

var $gcegg = parcelRequire("gcegg");

var $5jjrw = parcelRequire("5jjrw");

var $eCeEG = parcelRequire("eCeEG");

var $40l8T = parcelRequire("40l8T");

var $lDuaU = parcelRequire("lDuaU");

var $1NWBy = parcelRequire("1NWBy");
// ─────────────────────────────────────────────────────────────────────────────
// «تحلیل» on the phone — the same model as the desktop tab, a different shape.
//
// The desktop lane (a fixed rail beside the plot) does not survive 390px: the
// rail would eat half the width, and the plot — the only part carrying
// information — would get the rest. So the phone stacks: the label row sits
// ABOVE its plot, full-bleed, and the plot keeps the whole width.
//
// What does NOT change is the model (DESIGN-CONCEPT-MOBILE §1.1): the window,
// the metric pool, the selection cap and the derivation all come from
// `useAnalysisTimeline`, so the phone and the workstation can never disagree
// about which readings exist or when a drug was running.
//
// The crosshair is a pointer affordance and has no place here (§6: touch has no
// hover); a tap opens the picker instead, and the values ride the label rows.
// ─────────────────────────────────────────────────────────────────────────────
const $450dbe611cd068cd$var$Block = ({ title: title, sub: sub, value: value, tone: tone, action: action, children: children, testId: testId, state: state })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $g6X9N.default), {
        style: {
            padding: '0.625rem 0',
            overflow: 'hidden'
        },
        "data-testid": testId,
        "data-state": state
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0 0.75rem 0.5rem',
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.8125rem',
            fontWeight: 800,
            color: (0, $jTCZr.C).text,
            overflowWrap: 'anywhere'
        }
    }, title), sub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.625rem',
            color: (0, $jTCZr.C).textMuted,
            marginTop: '0.0625rem'
        }
    }, sub)), value && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginInlineStart: 'auto',
            fontSize: '1.0625rem',
            fontWeight: 800,
            direction: 'ltr',
            letterSpacing: '-0.02em',
            color: tone || (0, $jTCZr.C).text
        }
    }, value), action), children);
const $450dbe611cd068cd$var$MobilePatientAnalysis = ({ p: p, patientId: patientId })=>{
    const { t: t, formatDigits: formatDigits, formatDate: formatDate, formatTime: formatTime, formatClinicMonth: formatClinicMonth } = (0, $LNQP4.default)();
    const fmt = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
            formatDate: formatDate,
            formatTime: formatTime,
            formatClinicMonth: formatClinicMonth
        }), [
        formatDate,
        formatTime,
        formatClinicMonth
    ]);
    const a = (0, $5jjrw.useAnalysisTimeline)(p);
    const [plotRef, plotWidth] = (0, $3uzzV.default)(340);
    const [pickerOpen, setPickerOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [rangeOpen, setRangeOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // Per-session, like desktop: reopening the section starts on the chart.
    const [showTable, setShowTable] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // The phone's rail is gone, so the value gutter shrinks — but every lane
    // still shares one scale, or the stack stops meaning "the same moment".
    const scale = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $cRX9v.createTimeScale)({
            min: a.domain.min,
            max: a.domain.max,
            width: plotWidth,
            padStart: 34,
            padEnd: 8
        }), [
        a.domain,
        plotWidth
    ]);
    const eventMarks = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>a.events.map((e)=>{
            const kind = (0, $eCeEG.EVENT_KIND)[e.kind] || (0, $eCeEG.EVENT_KIND).order;
            return {
                id: e.id,
                t: e.t,
                row: kind.row,
                shape: kind.shape,
                // Labels are dropped on the phone: at this width they would collide into
                // noise. The event's identity still reads from its shape and row, and the
                // full list stays one tab away in «دستورات» / «تشخیص».
                tone: kind.tone === 'accent' ? (0, $jTCZr.CT).accent : (0, $jTCZr.CT).warn
            };
        }), [
        a.events
    ]);
    const encounterMarks = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>a.encounters.map((e)=>({
                id: e.id,
                t: e.t,
                shape: e.cancelled ? 'cross' : 'circle',
                filled: e.live,
                tone: e.live ? (0, $jTCZr.CT).accent : (0, $jTCZr.CT).mute
            })), [
        a.encounters
    ]);
    const medRowsInWindow = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>a.medRows.filter((r)=>r.segments.some((s)=>s.from <= a.domain.max && (s.to ?? a.now) >= a.domain.min)), [
        a.medRows,
        a.domain,
        a.now
    ]);
    if (a.loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "analysis-content",
        "data-state": "loading",
        "aria-busy": true,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonChart), {
        height: 160,
        line: true,
        legend: 2,
        label: t('common.state.loading')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonCard), {
        avatar: false,
        lines: 2,
        chips: 0,
        actions: 0,
        label: t('common.state.loading')
    }));
    if (a.error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "analysis-content",
        "data-state": "error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dLdf9.default), {
        title: t('patient.analysis.historyLoadFailed'),
        detail: a.error?.message || String(a.error),
        onRetry: a.retry
    }));
    if (!a.hasData) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "analysis-content",
        "data-state": "empty"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $k2reB.default), {
            size: 24,
            "aria-hidden": true
        }),
        title: t('patient.analysis.nothingToAnalyse'),
        description: t('patient.analysis.emptyHint')
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "analysis-content",
        "data-state": "content",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: '0.375rem',
            overflowX: 'auto',
            paddingBottom: '0.125rem'
        },
        role: "group",
        "aria-label": t('common.labels.dateRange')
    }, (0, $eCeEG.RANGE_PRESETS).map((r)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $h4ZeB.default), {
            key: r.id,
            label: t(r.labelKey),
            active: a.range === r.id,
            onClick: ()=>a.setRange(r.id),
            "data-testid": `analysis-range-${r.id}`
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $h4ZeB.default), {
        label: t('patient.analysis.custom'),
        active: a.isCustom,
        onClick: ()=>setRangeOpen(true),
        "data-testid": "analysis-range-custom"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "analysis-active-range",
        "aria-live": "polite",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            flexWrap: 'wrap'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.6875rem',
            color: (0, $jTCZr.C).textMuted,
            fontWeight: 700
        }
    }, t('patient.analysis.activeRange')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.75rem',
            fontWeight: 800,
            color: (0, $jTCZr.C).text,
            background: (0, $jTCZr.CT).accentSoft,
            borderRadius: '999px',
            padding: '0.125rem 0.625rem'
        }
    }, (0, $eCeEG.describeWindow)(a.target, t, {
        fmt: fmt
    })), a.isCustom && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        type: "button",
        onClick: a.resetWindow,
        "data-testid": "analysis-range-reset"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bU80g.default), {
        size: 13,
        "aria-hidden": true
    }), " ", t('common.actions.reset')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "sm",
        type: "button",
        className: "min-h-11 gap-1",
        style: {
            marginInlineStart: 'auto'
        },
        "aria-pressed": showTable,
        onClick: ()=>setShowTable((v)=>!v),
        "data-testid": "analysis-view-toggle"
    }, showTable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aRAFQ.default), {
        size: 14,
        "aria-hidden": true
    }), " ", t('patient.analysis.chartView')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5v9tj.default), {
        size: 14,
        "aria-hidden": true
    }), " ", t('patient.analysis.tableView')))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gcegg.SectionTitle), {
        action: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "subtle",
            size: "sm",
            type: "button",
            onClick: ()=>setPickerOpen(true),
            "data-testid": "analysis-pick-metrics"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8g4t5.default), {
            size: 14,
            "aria-hidden": true
        }), " ", t('patient.analysis.metricsCountPrefix'), formatDigits(a.selected.length), "/", formatDigits(a.cap), ")")
    }, t('patient.analysis.selectedObservations')), showTable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1NWBy.default), {
        metrics: a.selectedMetrics,
        medRows: medRowsInWindow,
        events: a.events,
        encounters: a.encounters,
        domain: a.domain
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $g6X9N.default), {
        style: {
            padding: '0.625rem 0 0',
            overflow: 'hidden'
        },
        "data-testid": "analysis-lane-ruler"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '0 0.75rem 0.25rem',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.8125rem',
            fontWeight: 800,
            color: (0, $jTCZr.C).text
        }
    }, t('patient.tabs.visits')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.625rem',
            color: (0, $jTCZr.C).textMuted
        }
    }, formatDigits(a.encounters.length), " ", t('patient.encounter'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: plotRef,
        style: {
            direction: 'ltr'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cPdQE.default), {
        width: plotWidth,
        scale: scale,
        ticks: a.ticks,
        formatTick: (ms)=>(0, $eCeEG.formatMonthTick)(ms, fmt),
        nowAt: a.now,
        markers: encounterMarks,
        height: 50
    }))), a.events.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($450dbe611cd068cd$var$Block, {
        title: t('patient.analysis.events'),
        sub: t('patient.analysis.legend'),
        testId: "analysis-lane-events",
        state: "content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            direction: 'ltr'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cLQXb.default), {
        width: plotWidth,
        scale: scale,
        events: eventMarks,
        rows: 2,
        rowHeight: 22,
        ticks: a.ticks,
        nowAt: a.now,
        showLabels: false
    }))), medRowsInWindow.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($450dbe611cd068cd$var$Block, {
        title: t('visit.rx.medications'),
        // At phone width most bars are too narrow to carry their own label, so
        // the kit drops it rather than clipping it — which would leave a bar
        // with no identity at all. The names ride the header instead, in the
        // same top-to-bottom order as the rows beneath.
        sub: medRowsInWindow.map((r)=>r.label).join(" \xb7 "),
        testId: "analysis-lane-meds",
        state: "content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            direction: 'ltr'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ctU9L.default), {
        width: plotWidth,
        scale: scale,
        rows: medRowsInWindow,
        rowHeight: 24,
        ticks: a.ticks,
        nowAt: a.now
    }))), a.selectedMetrics.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "analysis-metrics-empty",
        "data-state": "empty"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aRAFQ.default), {
            size: 22,
            "aria-hidden": true
        }),
        title: t('patient.analysis.noneSelected'),
        description: t('patient.analysis.allAvailableList'),
        action: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            type: "button",
            size: "sm",
            onClick: ()=>setPickerOpen(true),
            "data-testid": "analysis-metrics-empty-cta"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8g4t5.default), {
            size: 14,
            "aria-hidden": true
        }), " ", t('patient.analysis.pickMetrics'))
    })) : a.selectedMetrics.map((m)=>{
        const st = m.latestStatus;
        const tone = st === 'critical' ? (0, $jTCZr.CT).danger : st === 'abnormal' ? (0, $jTCZr.CT).warnInk : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($450dbe611cd068cd$var$Block, {
            key: m.key,
            testId: `analysis-lane-${m.key}`,
            state: "content",
            title: (0, $eCeEG.metricName)(t, m),
            sub: [
                m.unit,
                m.refLow != null && m.refHigh != null ? t('patient.analysis.referenceRange', {
                    low: formatDigits(m.refLow),
                    high: formatDigits(m.refHigh)
                }) : null
            ].filter(Boolean).join(" \xb7 "),
            value: formatDigits(Math.round(m.latest.y * 10) / 10),
            tone: tone,
            action: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
                variant: "ghost",
                size: "icon",
                type: "button",
                "aria-label": t('patient.analysis.removeFromChartAria', {
                    name: m.name
                }),
                "data-testid": `analysis-lane-remove-${m.key}`,
                onClick: ()=>a.toggleMetric(m.key),
                style: {
                    marginInlineStart: '0.25rem',
                    color: (0, $jTCZr.C).textMuted
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
                size: 15,
                "aria-hidden": true
            }))
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                direction: 'ltr'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kCQwN.default), {
            width: plotWidth,
            scale: scale,
            series: [
                {
                    id: m.key,
                    points: m.points,
                    color: (0, $jTCZr.CT).accent
                }
            ],
            refLow: m.refLow,
            refHigh: m.refHigh,
            ticks: a.ticks,
            nowAt: a.now,
            height: 86,
            formatValue: (v)=>formatDigits(Math.round(v * 10) / 10),
            emptyLabel: t('patient.analysis.noneInRange')
        })));
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lDuaU.default), {
        open: rangeOpen,
        onClose: ()=>setRangeOpen(false),
        domain: a.target,
        earliest: a.earliest,
        now: a.now,
        onApply: (from, to)=>{
            a.setWindow(from, to);
            setRangeOpen(false);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $40l8T.default), {
        open: pickerOpen,
        onClose: ()=>setPickerOpen(false),
        groups: a.groups,
        selected: a.selected,
        cap: a.cap,
        onApply: (keys)=>{
            a.setSelection(keys);
            setPickerOpen(false);
        }
    }));
};
var $450dbe611cd068cd$export$2e2bcd8739ae039 = $450dbe611cd068cd$var$MobilePatientAnalysis;

});
parcelRegister("5v9tj", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7762e62111820ee$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $b7762e62111820ee$export$a2387ed3b5d536eb = {
    name: "table-2",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M3 9h18",
                key: "1pudct"
            }
        ],
        [
            "path",
            {
                d: "M9 3v18",
                key: "fh3hqa"
            }
        ],
        [
            "rect",
            {
                x: "3",
                y: "3",
                width: "18",
                height: "18",
                rx: "2",
                key: "h1oib"
            }
        ]
    ]
};
$b7762e62111820ee$export$a2387ed3b5d536eb.node;
const $b7762e62111820ee$export$2e2bcd8739ae039 = (0, $9QBug.default)($b7762e62111820ee$export$a2387ed3b5d536eb);

});

parcelRegister("5jjrw", function(module, exports) {

$parcel$export(module.exports, "useAnalysisTimeline", () => $3dddcf07f47e64f7$export$e015f957982fab20);

var $acw62 = parcelRequire("acw62");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $eVM84 = parcelRequire("eVM84");

var $xQteh = parcelRequire("xQteh");

var $j7Lry = parcelRequire("j7Lry");

var $eCeEG = parcelRequire("eCeEG");
// A zoom that jumps is disorienting: the eye loses which part of the old window
// it is now looking at. Tweening the domain keeps that thread — every lane is
// derived from it, so one animated value moves the whole timeline together.
//
// Motion is opt-out by environment, not by preference alone: without
// `matchMedia` (jsdom) or `requestAnimationFrame` there is nothing to tween
// against, so the value snaps. That is also what keeps component tests
// deterministic — they never observe a half-finished zoom (§15.2).
const $3dddcf07f47e64f7$var$ZOOM_MS = 260;
const $3dddcf07f47e64f7$var$easeOutCubic = (item)=>1 - Math.pow(1 - item, 3);
function $3dddcf07f47e64f7$var$prefersInstant() {
    if (typeof window === 'undefined') return true;
    if (typeof window.requestAnimationFrame !== 'function') return true;
    if (typeof window.matchMedia !== 'function') return true;
    try {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch  {
        return true;
    }
}
function $3dddcf07f47e64f7$var$useAnimatedWindow(target) {
    const [shown, setShown] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(target);
    const fromRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(target);
    const rafRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(0);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const from = fromRef.current;
        if (from.min === target.min && from.max === target.max) return undefined;
        if ($3dddcf07f47e64f7$var$prefersInstant()) {
            fromRef.current = target;
            setShown(target);
            return undefined;
        }
        const t0 = performance.now();
        const step = (now)=>{
            const k = $3dddcf07f47e64f7$var$easeOutCubic(Math.min(1, (now - t0) / $3dddcf07f47e64f7$var$ZOOM_MS));
            const cur = {
                min: from.min + (target.min - from.min) * k,
                max: from.max + (target.max - from.max) * k
            };
            fromRef.current = cur;
            setShown(cur);
            if (k < 1) rafRef.current = requestAnimationFrame(step);
            else {
                fromRef.current = target;
                setShown(target);
            }
        };
        rafRef.current = requestAnimationFrame(step);
        return ()=>cancelAnimationFrame(rafRef.current);
    }, [
        target.min,
        target.max
    ]);
    return shown;
}
// The «تحلیل» section's data + selection behaviour, kept out of the render tree
// (DESIGN-CONCEPT §2.6) so the desktop tab and the mobile section share one
// answer — and so the derivation is unit-testable without a DOM.
//
// Three sources feed one timeline:
//   • the record payload (`usePatient`) — observations, medications,
//     conditions, encounters: already loaded by the page root, never refetched;
//   • `useVitalSeries` — the vitals service's full history, the same hook
//     «مشاهدات» calls;
//   • `listDoctorOrders` — the only query this section adds.
//
// Selection persists per patient: an investigation is usually resumed, and
// re-picking six metrics on every visit to the tab is a tax, not a feature.
const $3dddcf07f47e64f7$var$storageKey = (patientId)=>`parsina.analysis.metrics.${patientId}`;
const $3dddcf07f47e64f7$var$readStored = (patientId)=>{
    if (!patientId || typeof localStorage === 'undefined') return null;
    try {
        const raw = localStorage.getItem($3dddcf07f47e64f7$var$storageKey(patientId));
        const parsed = raw ? JSON.parse(raw) : null;
        return Array.isArray(parsed) && parsed.length ? parsed : null;
    } catch  {
        return null;
    }
};
const $3dddcf07f47e64f7$var$writeStored = (patientId, keys)=>{
    if (!patientId || typeof localStorage === 'undefined') return;
    try {
        localStorage.setItem($3dddcf07f47e64f7$var$storageKey(patientId), JSON.stringify(keys));
    } catch  {}
};
function $3dddcf07f47e64f7$export$e015f957982fab20(patient, options = {}) {
    const { t: t } = (0, $LNQP4.default)();
    // «now» is pinned for the life of the section, not read per render.
    //
    // As a default parameter it was re-evaluated on every render, so the window's
    // upper bound moved by a few milliseconds each time. Nothing looked wrong,
    // but everything downstream churned: `target` was a new value on every
    // render, the zoom tween restarted continuously, and the custom-range
    // dialog's "seed from the current window" effect re-fired and wiped whatever
    // the doctor had just typed. A timeline's clock has to hold still to be
    // reasoned about — and tests still inject their own (§15.2).
    const nowRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(options.now ?? Date.now());
    const now = options.now ?? nowRef.current;
    const patientId = patient?.id;
    const vitals = (0, $xQteh.useVitalSeries)(patientId);
    // ── Doctor orders ─────────────────────────────────────────────────────────
    // `null` = in flight, `[]` = loaded-or-failed. A failed order fetch degrades
    // to *no procedure events* rather than blanking the timeline: the rest of the
    // analysis stays valid without it, but the failure is still surfaced (§14.3)
    // via `ordersError` so it never reads as "this patient has no orders".
    const [orders, setOrders] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [ordersError, setOrdersError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const loadOrders = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        if (!patientId) return;
        setOrders(null);
        setOrdersError(null);
        (0, $eVM84.bffQuery)((0, $j7Lry.LIST_DOCTOR_ORDERS), {
            patientId: patientId
        }).then((r)=>setOrders(r.listDoctorOrders || [])).catch((e)=>{
            setOrders([]);
            setOrdersError(e);
        });
    }, [
        patientId
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        loadOrders();
    }, [
        loadOrders
    ]);
    // ── Derivation ────────────────────────────────────────────────────────────
    const metrics = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $eCeEG.buildMetrics)({
            patient: patient,
            vitalsByLoinc: vitals.byLoinc
        }), [
        patient,
        vitals.byLoinc
    ]);
    const groups = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $eCeEG.groupMetrics)(metrics, t), [
        metrics,
        t
    ]);
    const medRows = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $eCeEG.buildMedicationRows)(patient?.clinicalMedications, now), [
        patient?.clinicalMedications,
        now
    ]);
    const events = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $eCeEG.buildEvents)({
            conditions: patient?.clinicalConditions,
            orders: orders
        }, t), [
        patient?.clinicalConditions,
        orders,
        t
    ]);
    const encounters = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $eCeEG.buildEncounterMarks)(patient?.encounters), [
        patient?.encounters
    ]);
    // ── Selection ─────────────────────────────────────────────────────────────
    const [selected, setSelected] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const seededFor = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // Seed once per patient, from the stored set when it still resolves against
    // this record, else from the smart default. Re-seeding on every metrics
    // change would yank the doctor's own selection away as data streams in.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!metrics.length || seededFor.current === patientId) return;
        const valid = new Set(metrics.map((m)=>m.key));
        const stored = ($3dddcf07f47e64f7$var$readStored(patientId) || []).filter((k)=>valid.has(k));
        setSelected(stored.length ? stored.slice(0, (0, $eCeEG.METRIC_CAP)) : (0, $eCeEG.defaultSelection)(metrics));
        seededFor.current = patientId;
    }, [
        metrics,
        patientId
    ]);
    // A patient switch must drop the previous patient's selection immediately —
    // showing patient A's metrics under patient B's name, even for one frame, is
    // a clinical-safety defect, not a flicker.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (seededFor.current !== patientId) setSelected([]);
    }, [
        patientId
    ]);
    const persist = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((keys)=>{
        setSelected(keys);
        $3dddcf07f47e64f7$var$writeStored(patientId, keys);
    }, [
        patientId
    ]);
    const toggleMetric = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((key)=>{
        setSelected((prev)=>{
            const next = prev.includes(key) ? prev.filter((k)=>k !== key) : prev.length >= (0, $eCeEG.METRIC_CAP) ? prev : [
                ...prev,
                key
            ];
            $3dddcf07f47e64f7$var$writeStored(patientId, next);
            return next;
        });
    }, [
        patientId
    ]);
    const selectedMetrics = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>selected.map((k)=>metrics.find((m)=>m.key === k)).filter(Boolean), [
        selected,
        metrics
    ]);
    // ── The shared window ─────────────────────────────────────────────────────
    // One window drives every lane, so zooming, picking a preset and typing a
    // custom range are the same operation with three front doors.
    const [range, setRangeState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState((0, $eCeEG.DEFAULT_RANGE));
    const [custom, setCustom] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // { from, to } in ms
    const earliest = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $eCeEG.earliestOf)({
            metrics: metrics,
            medRows: medRows,
            events: events,
            encounters: encounters
        }), [
        metrics,
        medRows,
        events,
        encounters
    ]);
    const target = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $eCeEG.windowFor)(range, earliest, now, custom), [
        range,
        earliest,
        now,
        custom
    ]);
    // What the lanes actually draw — the tweened value on its way to `target`.
    const domain = $3dddcf07f47e64f7$var$useAnimatedWindow(target);
    const setRange = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((id)=>{
        setCustom(null); // a preset always replaces a zoom
        setRangeState(id);
    }, []);
    // Drag-zoom and the custom picker both land here.
    const setWindow = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((from, to)=>{
        const w = (0, $eCeEG.normalizeWindow)(from, to);
        setCustom({
            from: w.min,
            to: w.max
        });
        setRangeState((0, $eCeEG.CUSTOM_RANGE));
    }, []);
    const isCustom = range === (0, $eCeEG.CUSTOM_RANGE) && !!custom;
    const resetWindow = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>setRange((0, $eCeEG.DEFAULT_RANGE)), [
        setRange
    ]);
    const ticks = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $eCeEG.jalaliMonthTicks)(domain.min, domain.max), [
        domain.min,
        domain.max
    ]);
    // Layer visibility — the lanes the doctor wants to reason with right now.
    const [layers, setLayers] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        events: true,
        meds: true,
        metrics: true
    });
    const toggleLayer = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((id)=>setLayers((prev)=>({
                ...prev,
                [id]: !prev[id]
            })), []);
    const inWindow = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((item)=>item >= domain.min && item <= domain.max, [
        domain
    ]);
    return {
        metrics: // data
        metrics,
        groups: groups,
        medRows: medRows,
        events: events,
        encounters: encounters,
        selected: selected,
        selectedMetrics: selectedMetrics,
        cap: (0, $eCeEG.METRIC_CAP),
        range: // window
        range,
        setRange: setRange,
        domain: domain,
        target: target,
        ticks: ticks,
        now: now,
        earliest: earliest,
        inWindow: inWindow,
        setWindow: setWindow,
        isCustom: isCustom,
        resetWindow: resetWindow,
        layers: // layers
        layers,
        toggleLayer: toggleLayer,
        toggleMetric: // selection
        toggleMetric,
        setSelection: persist,
        // state
        loading: vitals.loading,
        error: vitals.error,
        retry: vitals.retry,
        ordersLoading: orders === null,
        ordersError: ordersError,
        retryOrders: loadOrders,
        hasData: metrics.length > 0 || medRows.length > 0 || events.length > 0 || encounters.length > 0
    };
}
var $3dddcf07f47e64f7$export$2e2bcd8739ae039 = $3dddcf07f47e64f7$export$e015f957982fab20;

});
parcelRegister("xQteh", function(module, exports) {

$parcel$export(module.exports, "useVitalSeries", () => $065bc8b7ead4fbf6$export$dbab5d47820ca910);
$parcel$export(module.exports, "vitalsGlance", () => $065bc8b7ead4fbf6$export$31957fd116297820);

var $acw62 = parcelRequire("acw62");

var $eVM84 = parcelRequire("eVM84");

var $gq4TR = parcelRequire("gq4TR");

var $01rTJ = parcelRequire("01rTJ");
// The patient's vital-sign history — ONE source for both surfaces of «مشاهدات».
//
// The desktop tab read `queryVitalTimeSeries` (full history, so it can plot a
// trend) while the mobile section derived latest-only values from whatever
// vitals happened to be embedded in the record payload. Same section, two data
// paths, two answers — the divergence DESIGN-CONCEPT-MOBILE §1.1 exists to
// prevent. Both now call this.
//
// The vitals service returns points without a status, so «out of range» is
// derived here from the reference bounds in `VITAL_DEFS`; beyond ±15% of the
// bound it is critical rather than merely abnormal.
const $065bc8b7ead4fbf6$var$QUERY_VITAL_TIME_SERIES = `query QueryVitalTimeSeries($patientId:ID!,$codes:[String!]){queryVitalTimeSeries(patientId:$patientId,codes:$codes){code display unit points{timestamp value}}}`;
function $065bc8b7ead4fbf6$var$statusFor(def, numVal) {
    if (def?.refLow == null || def?.refHigh == null || Number.isNaN(numVal)) return 'normal';
    if (numVal < def.refLow * 0.85 || numVal > def.refHigh * 1.15) return 'critical';
    if (numVal < def.refLow || numVal > def.refHigh) return 'abnormal';
    return 'normal';
}
function $065bc8b7ead4fbf6$export$dbab5d47820ca910(patientId) {
    const [raw, setRaw] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    const load = (0, $acw62.useCallback)(()=>{
        if (!patientId) return;
        setLoading(true);
        setError(null);
        (0, $eVM84.bffQuery)($065bc8b7ead4fbf6$var$QUERY_VITAL_TIME_SERIES, {
            patientId: patientId,
            codes: (0, $gq4TR.VITAL_DEFS).map((d)=>d.loinc)
        }).then((d)=>setRaw(d?.queryVitalTimeSeries || []))// A failed query must not look like a patient with no vitals (§14.3).
        .catch((e)=>{
            setRaw(null);
            setError(e);
        }).finally(()=>setLoading(false));
    }, [
        patientId
    ]);
    (0, $acw62.useEffect)(()=>{
        load();
    }, [
        load
    ]);
    const byLoinc = (0, $acw62.useMemo)(()=>{
        const map = {};
        (0, $gq4TR.VITAL_DEFS).forEach((d)=>{
            map[d.loinc] = [];
        });
        (raw || []).forEach((series)=>{
            if (map[series.code] === undefined) return;
            const def = (0, $gq4TR.VITAL_DEFS).find((d)=>d.loinc === series.code);
            map[series.code] = (series.points || []).map((pt, idx)=>{
                const numVal = typeof pt.value === 'number' ? pt.value : parseFloat(pt.value);
                const value = Number.isNaN(numVal) ? String(pt.value ?? '') : Number.isInteger(numVal) ? String(numVal) : parseFloat(numVal.toFixed(2)).toString();
                return {
                    id: `${series.code}-${idx}`,
                    date: pt.timestamp || '',
                    value: value,
                    numVal: numVal,
                    status: $065bc8b7ead4fbf6$var$statusFor(def, numVal)
                };
            });
        });
        return map;
    }, [
        raw
    ]);
    const flagged = (0, $gq4TR.VITAL_DEFS).filter((def)=>{
        const readings = byLoinc[def.loinc];
        return (0, $01rTJ.isAbnormalStatus)(readings?.[readings.length - 1]?.status);
    });
    return {
        byLoinc: byLoinc,
        flagged: flagged,
        loading: loading,
        error: error,
        retry: load
    };
}
function $065bc8b7ead4fbf6$export$31957fd116297820(byLoinc) {
    return (0, $gq4TR.VITAL_DEFS).map((def)=>{
        const readings = byLoinc[def.loinc] || [];
        const last = readings[readings.length - 1];
        if (!last) return null;
        const prev = readings[readings.length - 2];
        const delta = prev && !Number.isNaN(last.numVal) && !Number.isNaN(prev.numVal) ? last.numVal - prev.numVal : null;
        return {
            id: def.id,
            labelKey: def.labelKey,
            unit: def.unit,
            value: last.value,
            delta: delta,
            alert: (0, $01rTJ.isAbnormalStatus)(last.status)
        };
    }).filter(Boolean);
}

});

parcelRegister("eCeEG", function(module, exports) {

$parcel$export(module.exports, "DAY_MS", () => $aa3ffb82ad5c03f7$export$fa2e89afea4272f6);
$parcel$export(module.exports, "RANGE_PRESETS", () => $aa3ffb82ad5c03f7$export$5f37411c4bafeb65);
$parcel$export(module.exports, "DEFAULT_RANGE", () => $aa3ffb82ad5c03f7$export$5cd86cf5917308cd);
$parcel$export(module.exports, "CUSTOM_RANGE", () => $aa3ffb82ad5c03f7$export$f791bb8fbe557da2);
$parcel$export(module.exports, "windowFor", () => $aa3ffb82ad5c03f7$export$1d7a4698f4e579a2);
$parcel$export(module.exports, "normalizeWindow", () => $aa3ffb82ad5c03f7$export$3a6936c7cae8c4f5);
$parcel$export(module.exports, "validateWindow", () => $aa3ffb82ad5c03f7$export$50a7e9003a1e4b26);
$parcel$export(module.exports, "jalaliMonthTicks", () => $aa3ffb82ad5c03f7$export$71edd4bcc3ce038a);
$parcel$export(module.exports, "formatMonthTick", () => $aa3ffb82ad5c03f7$export$57a214e89a3308a1);
$parcel$export(module.exports, "jalaliFull", () => $aa3ffb82ad5c03f7$export$d2cb3004af48acf4);
$parcel$export(module.exports, "jalaliShort", () => $aa3ffb82ad5c03f7$export$e00157e2cd456ae7);
$parcel$export(module.exports, "describeWindow", () => $aa3ffb82ad5c03f7$export$bd8d071cb0dcf3ae);
$parcel$export(module.exports, "pickerValueToMs", () => $aa3ffb82ad5c03f7$export$8d73c39233125377);
$parcel$export(module.exports, "msToPickerValue", () => $aa3ffb82ad5c03f7$export$9b9263c8189aa410);
$parcel$export(module.exports, "metricName", () => $aa3ffb82ad5c03f7$export$ac9f012a8e2fccf4);
$parcel$export(module.exports, "buildMetrics", () => $aa3ffb82ad5c03f7$export$ff45910b09935506);
$parcel$export(module.exports, "groupMetrics", () => $aa3ffb82ad5c03f7$export$d93eda82a58a56de);
$parcel$export(module.exports, "METRIC_CAP", () => $aa3ffb82ad5c03f7$export$36a174dd9be4b0f5);
$parcel$export(module.exports, "defaultSelection", () => $aa3ffb82ad5c03f7$export$792e61c1707842c4);
$parcel$export(module.exports, "buildMedicationRows", () => $aa3ffb82ad5c03f7$export$347601b23791171);
$parcel$export(module.exports, "EVENT_KIND", () => $aa3ffb82ad5c03f7$export$d57ad9ef2fc84619);
$parcel$export(module.exports, "buildEvents", () => $aa3ffb82ad5c03f7$export$f575cae50c008afe);
$parcel$export(module.exports, "buildEncounterMarks", () => $aa3ffb82ad5c03f7$export$eb6bc7e4d8dbcf1c);
$parcel$export(module.exports, "earliestOf", () => $aa3ffb82ad5c03f7$export$9113702d80a167d8);
$parcel$export(module.exports, "nearestPoint", () => $aa3ffb82ad5c03f7$export$ba330bb14d26e4ac);
$parcel$export(module.exports, "activeAt", () => $aa3ffb82ad5c03f7$export$29e5558020ac2bd3);
// ─────────────────────────────────────────────────────────────────────────────
// The analysis-timeline model — ONE behavioural truth for the «تحلیل» section of
// the patient record, shared by the desktop tab and the mobile section
// (DESIGN-CONCEPT-MOBILE §1.1: the two surfaces may look nothing alike, but they
// must never disagree about which observations exist, which reading is out of
// range, or when a medication was actually running).
//
// It answers the question the record's other tabs cannot: *how did this patient
// move over time, and did what we did line up with the change?* Everything is
// projected onto one time axis — measurements as series, prescriptions as
// intervals, diagnoses/orders/encounters as events.
//
// The vocabulary is NOT re-declared here: observations come from
// `lib/observations` (`buildSeriesMap`), vitals from `hooks/useVitalSeries`, the
// taxonomy and reference ranges from `constants/patientRecord`. This module is
// the projection onto a clock, nothing more.
// ─────────────────────────────────────────────────────────────────────────────

var $eLeza = parcelRequire("eLeza");

var $gq4TR = parcelRequire("gq4TR");
parcelRequire("kQnM4");
var $4UJrq = parcelRequire("4UJrq");

var $01rTJ = parcelRequire("01rTJ");

var $g6gAc = parcelRequire("g6gAc");
const $aa3ffb82ad5c03f7$export$fa2e89afea4272f6 = 86400000;
// ── The clinic's calendar ────────────────────────────────────────────────────
// «This month», the month gridlines and «which year» are the CLINIC's calendar:
// Jalali, unless the brand puts the product on the Gregorian one
// (`calendar: 'gregory'`, ui/lib/brand.js). The formatters agree — the locale
// descriptors switch `formatClinicMonth` to the same calendar — so a gridline
// is always labelled with the month it starts. Both read the UTC day, as
// `msToJalali` always has.
const $aa3ffb82ad5c03f7$var$gregorianClinic = ()=>(0, $eLeza.calendarSystem)('jalali') === 'gregory';
/** `{ y, m, d }` of the day `ms` falls on, in the clinic's calendar; null when corrupt. */ function $aa3ffb82ad5c03f7$var$clinicDate(ms) {
    if (!$aa3ffb82ad5c03f7$var$gregorianClinic()) return (0, $4UJrq.msToJalali)(ms);
    const date = new Date(ms);
    if (Number.isNaN(date.getTime())) return null;
    return {
        y: date.getUTCFullYear(),
        m: date.getUTCMonth() + 1,
        d: date.getUTCDate()
    };
}
/** The first day of month `m` of year `y` in the clinic's calendar, at UTC midnight. */ const $aa3ffb82ad5c03f7$var$clinicMonthStart = (y, m)=>$aa3ffb82ad5c03f7$var$gregorianClinic() ? Date.UTC(y, m - 1, 1) : (0, $4UJrq.jalaliToMs)(y, m, 1);
function $aa3ffb82ad5c03f7$export$ff695c3374a8851c(value) {
    if (value == null || value === '') return null;
    if (typeof value === 'number') return Number.isFinite(value) ? value : null;
    const s = String(value);
    const iso = /^\d{4}-\d{2}-\d{2}$/.test(s) ? `${s}T12:00:00Z` : s;
    const ms = new Date(iso).getTime();
    return Number.isNaN(ms) ? null : ms;
}
const $aa3ffb82ad5c03f7$export$5f37411c4bafeb65 = [
    {
        id: 'month',
        labelKey: 'patient.analysis.range.month',
        calendarMonth: true
    },
    {
        id: '3m',
        labelKey: 'patient.analysis.range.3m',
        months: 3
    },
    {
        id: '6m',
        labelKey: 'patient.analysis.range.6m',
        months: 6
    },
    {
        id: '12m',
        labelKey: 'patient.analysis.range.12m',
        months: 12
    },
    {
        id: 'all',
        labelKey: 'patient.analysis.range.all',
        months: 0
    }
];
const $aa3ffb82ad5c03f7$export$5cd86cf5917308cd = '12m';
const $aa3ffb82ad5c03f7$export$f791bb8fbe557da2 = 'custom';
const $aa3ffb82ad5c03f7$export$b5a289615f33ef57 = 3600000; // one hour
function $aa3ffb82ad5c03f7$export$1d7a4698f4e579a2(rangeId, earliest, now = Date.now(), custom = null) {
    if (rangeId === $aa3ffb82ad5c03f7$export$f791bb8fbe557da2 && custom && custom.from != null && custom.to != null) return $aa3ffb82ad5c03f7$export$3a6936c7cae8c4f5(custom.from, custom.to);
    const preset = $aa3ffb82ad5c03f7$export$5f37411c4bafeb65.find((r)=>r.id === rangeId) || $aa3ffb82ad5c03f7$export$5f37411c4bafeb65.find((r)=>r.id === $aa3ffb82ad5c03f7$export$5cd86cf5917308cd);
    // A little air after «now» so the marker and an open interval's arrow cap are
    // not clipped by the plot edge.
    const max = now + 6 * $aa3ffb82ad5c03f7$export$fa2e89afea4272f6;
    if (preset.calendarMonth) {
        const j = $aa3ffb82ad5c03f7$var$clinicDate(now);
        // Before the converter's epoch there is no Jalali month to speak of; fall
        // back to a rolling month rather than throwing.
        if (!j) return {
            min: now - 30 * $aa3ffb82ad5c03f7$export$fa2e89afea4272f6,
            max: max
        };
        const min = $aa3ffb82ad5c03f7$var$clinicMonthStart(j.y, j.m);
        const nextM = j.m === 12 ? 1 : j.m + 1;
        const nextY = j.m === 12 ? j.y + 1 : j.y;
        // The month's own end, but never beyond «now»'s breathing room — a window
        // reaching into next week would waste half the axis on empty future.
        return {
            min: min,
            max: Math.min($aa3ffb82ad5c03f7$var$clinicMonthStart(nextY, nextM), max)
        };
    }
    if (!preset.months) {
        const min = earliest != null ? earliest - 7 * $aa3ffb82ad5c03f7$export$fa2e89afea4272f6 : now - 365 * $aa3ffb82ad5c03f7$export$fa2e89afea4272f6;
        return {
            min: Math.min(min, now - 30 * $aa3ffb82ad5c03f7$export$fa2e89afea4272f6),
            max: max
        };
    }
    return {
        min: now - preset.months * 30.44 * $aa3ffb82ad5c03f7$export$fa2e89afea4272f6,
        max: max
    };
}
function $aa3ffb82ad5c03f7$export$50a7e9003a1e4b26(fromMs, toMs, t) {
    if (fromMs == null || toMs == null) return t('validation.date.bothRequired');
    if (!Number.isFinite(fromMs) || !Number.isFinite(toMs)) return t('validation.date.invalid');
    if (Math.abs(toMs - fromMs) < $aa3ffb82ad5c03f7$export$b5a289615f33ef57) return t('validation.date.minOneHour');
    return null;
}
function $aa3ffb82ad5c03f7$export$3a6936c7cae8c4f5(a, b) {
    let min = Math.min(a, b);
    let max = Math.max(a, b);
    if (max - min < $aa3ffb82ad5c03f7$export$b5a289615f33ef57) {
        const mid = (min + max) / 2;
        min = mid - $aa3ffb82ad5c03f7$export$b5a289615f33ef57 / 2;
        max = mid + $aa3ffb82ad5c03f7$export$b5a289615f33ef57 / 2;
    }
    return {
        min: min,
        max: max
    };
}
function $aa3ffb82ad5c03f7$export$71edd4bcc3ce038a(min, max, limit = 40) {
    const start = $aa3ffb82ad5c03f7$var$clinicDate(min);
    // The converter reaches both sides of its 1400/01/01 anchor as of framework
    // v0.5.0, so this guard is now only about a corrupt timestamp rather than
    // about the old epoch floor.
    if (!start) return [];
    const ticks = [];
    let { y: y, m: m } = start;
    for(let i = 0; i < limit; i += 1){
        const ms = $aa3ffb82ad5c03f7$var$clinicMonthStart(y, m);
        if (ms > max) break;
        if (ms >= min) ticks.push(ms);
        m += 1;
        if (m > 12) {
            m = 1;
            y += 1;
        }
    }
    return ticks;
}
function $aa3ffb82ad5c03f7$export$57a214e89a3308a1(ms, { formatClinicMonth: formatClinicMonth }) {
    const j = $aa3ffb82ad5c03f7$var$clinicDate(ms);
    if (!j) return '';
    return formatClinicMonth(ms, {
        withYear: j.m === 1
    });
}
function $aa3ffb82ad5c03f7$export$d2cb3004af48acf4(ms, { formatDate: formatDate }) {
    if (!(0, $4UJrq.msToJalali)(ms)) return '';
    return formatDate(ms, 'long');
}
function $aa3ffb82ad5c03f7$export$e00157e2cd456ae7(ms, { formatDate: formatDate }) {
    if (!(0, $4UJrq.msToJalali)(ms)) return '';
    return formatDate(ms, 'short');
}
function $aa3ffb82ad5c03f7$export$3ff7acb1a8ca9b7c(ms, { formatDate: formatDate }, withYear = false) {
    if (!(0, $4UJrq.msToJalali)(ms)) return '';
    return formatDate(ms, withYear ? 'long' : 'dayMonth');
}
const $aa3ffb82ad5c03f7$var$pad2 = (n)=>String(n).padStart(2, '0');
function $aa3ffb82ad5c03f7$export$77faf5e1a63b35f8(ms, { formatTime: formatTime }) {
    return formatTime(ms);
}
function $aa3ffb82ad5c03f7$export$bd8d071cb0dcf3ae({ min: min, max: max }, t, { withTime: withTime = false, fmt: fmt } = {}) {
    const a = $aa3ffb82ad5c03f7$var$clinicDate(min);
    const b = $aa3ffb82ad5c03f7$var$clinicDate(max);
    if (!a || !b) return '';
    const crossesYear = a.y !== b.y;
    const time = withTime || max - min <= 3 * $aa3ffb82ad5c03f7$export$fa2e89afea4272f6;
    const one = (ms)=>$aa3ffb82ad5c03f7$export$3ff7acb1a8ca9b7c(ms, fmt, crossesYear) + (time ? ` ${$aa3ffb82ad5c03f7$export$77faf5e1a63b35f8(ms, fmt)}` : '');
    return t('patient.analysis.rangeBetween', {
        from: one(min),
        to: one(max)
    });
}
function $aa3ffb82ad5c03f7$export$8d73c39233125377(value) {
    if (!value) return null;
    const s = String(value).trim();
    const m = s.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?/);
    if (!m) return null;
    const [, y, mo, d, hh, mi] = m;
    const utc = Date.UTC(+y, +mo - 1, +d, +(hh ?? 0), +(mi ?? 0));
    return utc - (0, $4UJrq.IRAN_OFFSET_MS);
}
function $aa3ffb82ad5c03f7$export$9b9263c8189aa410(ms, { withTime: withTime = true } = {}) {
    if (ms == null) return '';
    const d = new Date(ms + (0, $4UJrq.IRAN_OFFSET_MS));
    const date = `${d.getUTCFullYear()}-${$aa3ffb82ad5c03f7$var$pad2(d.getUTCMonth() + 1)}-${$aa3ffb82ad5c03f7$var$pad2(d.getUTCDate())}`;
    return withTime ? `${date} ${$aa3ffb82ad5c03f7$var$pad2(d.getUTCHours())}:${$aa3ffb82ad5c03f7$var$pad2(d.getUTCMinutes())}` : date;
}
const $aa3ffb82ad5c03f7$export$9671b56f5ba0f2e4 = 'vitals';
const $aa3ffb82ad5c03f7$export$1d2f2fd46e4fd6c4 = 'other';
const $aa3ffb82ad5c03f7$export$1fe33fa0a1eed6fa = (catId)=>((0, $gq4TR.LAB_CATEGORIES).find((c)=>c.id === catId) || {}).labelKey || 'patient.labCategory.other';
const $aa3ffb82ad5c03f7$export$ac9f012a8e2fccf4 = (item, m)=>(m?.nameKey && item ? item(m.nameKey) : m?.name) || '';
const $aa3ffb82ad5c03f7$var$statusOf = (reading, def)=>{
    if (reading.status && reading.status !== 'normal') return String(reading.status).toLowerCase();
    if (def && def.refLow != null && def.refHigh != null && Number.isFinite(reading.numVal)) {
        if (reading.numVal < def.refLow * 0.85 || reading.numVal > def.refHigh * 1.15) return 'critical';
        if (reading.numVal < def.refLow || reading.numVal > def.refHigh) return 'abnormal';
    }
    return 'normal';
};
function $aa3ffb82ad5c03f7$export$ff45910b09935506({ patient: patient, vitalsByLoinc: vitalsByLoinc } = {}) {
    const metrics = [];
    // Which LOINCs the vitals service actually delivered a series for. The record
    // payload is skipped for exactly these and no others — see the note below.
    const coveredByVitalsService = new Set();
    // Vitals — full history from the vitals service (the same hook «مشاهدات»
    // uses), so the two sections cannot disagree about a reading.
    (0, $gq4TR.VITAL_DEFS).forEach((def)=>{
        const readings = (vitalsByLoinc || {})[def.loinc] || [];
        const points = readings.map((r)=>({
                x: $aa3ffb82ad5c03f7$export$ff695c3374a8851c(r.date),
                y: r.numVal,
                status: $aa3ffb82ad5c03f7$var$statusOf(r, def),
                id: r.id
            })).filter((p)=>p.x != null && Number.isFinite(p.y)).sort((a, b)=>a.x - b.x);
        if (!points.length) return;
        coveredByVitalsService.add(def.loinc);
        metrics.push({
            key: `vital:${def.loinc}`,
            nameKey: def.labelKey,
            unit: def.unit,
            category: $aa3ffb82ad5c03f7$export$9671b56f5ba0f2e4,
            catId: 'vitals',
            isVital: true,
            refLow: def.refLow,
            refHigh: def.refHigh,
            points: points
        });
    });
    // Everything else on the record — laboratory analytes, and any measurement
    // the vitals service did not answer for.
    //
    // The skip below is keyed to what was ACTUALLY covered above, never to the
    // broader `VITAL_LOINC_SET`. Those two sets are not the same size and never
    // were: the taxonomy classes eight LOINCs as vital, while the vitals service
    // is only asked for the five in `VITAL_DEFS`. Skipping on the taxonomy made
    // the difference — systolic `8480-6`, diastolic `8462-4`, respiratory rate
    // `9279-1` — fall through both paths and vanish from the record entirely
    // (14 of 51 observations on the dev data set). A measurement the patient
    // actually has must never be silently unselectable, so anything the vitals
    // service did not return is taken from the record payload instead.
    const seriesMap = (0, $01rTJ.buildSeriesMap)(patient?.clinicalObservations);
    Object.values(seriesMap).forEach((s)=>{
        if (coveredByVitalsService.has(s.code)) return; // already covered, with better history
        const points = s.readings.map((r)=>({
                x: $aa3ffb82ad5c03f7$export$ff695c3374a8851c(r.date),
                y: r.numVal,
                status: $aa3ffb82ad5c03f7$var$statusOf(r, null),
                id: r.id
            })).filter((p)=>p.x != null && Number.isFinite(p.y)).sort((a, b)=>a.x - b.x);
        if (!points.length) return;
        metrics.push({
            key: `lab:${s.display}`,
            // A lab analyte's name is what the lab reported — wire data, not UI copy,
            // so it is shown verbatim in either language.
            name: s.display,
            unit: s.unit || '',
            category: s.catId || $aa3ffb82ad5c03f7$export$1d2f2fd46e4fd6c4,
            catId: s.catId,
            isVital: false,
            refLow: null,
            refHigh: null,
            points: points
        });
    });
    metrics.forEach((m)=>{
        m.latest = m.points[m.points.length - 1];
        m.worst = m.points.some((p)=>p.status === 'critical') ? 'critical' : m.points.some((p)=>(0, $01rTJ.isAbnormalStatus)(p.status) || p.status === 'abnormal') ? 'abnormal' : 'normal';
        m.latestStatus = m.latest?.status && m.latest.status !== 'normal' ? m.latest.status : null;
    });
    return metrics;
}
function $aa3ffb82ad5c03f7$export$d93eda82a58a56de(metrics, item) {
    const order = [
        $aa3ffb82ad5c03f7$export$9671b56f5ba0f2e4,
        ...(0, $gq4TR.LAB_CATEGORIES).filter((c)=>c.id !== 'vitals').map((c)=>c.id),
        $aa3ffb82ad5c03f7$export$1d2f2fd46e4fd6c4
    ];
    const byCat = new Map();
    metrics.forEach((m)=>{
        if (!byCat.has(m.category)) byCat.set(m.category, []);
        byCat.get(m.category).push(m);
    });
    // A metric's own name may be a key (vitals) or a wire string (lab analytes),
    // so resolve before sorting — otherwise the list is ordered by key path.
    const nameOf = (m)=>m.nameKey && item ? item(m.nameKey) : m.name || '';
    return order.filter((c)=>byCat.has(c)).map((c)=>({
            category: c,
            categoryKey: $aa3ffb82ad5c03f7$export$1fe33fa0a1eed6fa(c),
            metrics: byCat.get(c).sort((a, b)=>nameOf(a).localeCompare(nameOf(b))),
            abnormal: byCat.get(c).filter((m)=>m.latestStatus).length
        }));
}
const $aa3ffb82ad5c03f7$export$36a174dd9be4b0f5 = 6;
function $aa3ffb82ad5c03f7$export$792e61c1707842c4(metrics, cap = 3) {
    const rank = (m)=>m.latestStatus === 'critical' ? 3 : m.latestStatus ? 2 : 0;
    return [
        ...metrics
    ].sort((a, b)=>rank(b) - rank(a) || (b.latest?.x || 0) - (a.latest?.x || 0) || b.points.length - a.points.length).slice(0, cap).map((m)=>m.key);
}
function $aa3ffb82ad5c03f7$export$347601b23791171(medications, now = Date.now()) {
    const byName = new Map();
    (medications || []).forEach((m)=>{
        const from = $aa3ffb82ad5c03f7$export$ff695c3374a8851c(m.authoredOn || m.createdAt);
        if (from == null) return;
        // The Latin generic leads here too, so a bar on the rail carries the same
        // name as the نسخه row that created it.
        const name = (0, $g6gAc.medDisplayName)(m) || "\u2014";
        const key = m.code || name;
        const to = $aa3ffb82ad5c03f7$export$ff695c3374a8851c(m.endDate);
        const dose = m.dosageInstruction?.text || m.dosage || '';
        if (!byName.has(key)) byName.set(key, {
            id: key,
            label: name,
            segments: []
        });
        byName.get(key).segments.push({
            id: m.id,
            from: from,
            to: to && to <= now ? to : null,
            dose: dose,
            label: dose ? `${name} ${dose}` : name
        });
    });
    return [
        ...byName.values()
    ].map((row)=>({
            ...row,
            segments: row.segments.sort((a, b)=>a.from - b.from)
        })).sort((a, b)=>{
        const aOpen = a.segments.some((s)=>s.to == null);
        const bOpen = b.segments.some((s)=>s.to == null);
        if (aOpen !== bOpen) return aOpen ? -1 : 1;
        return (b.segments[b.segments.length - 1]?.from || 0) - (a.segments[a.segments.length - 1]?.from || 0);
    });
}
const $aa3ffb82ad5c03f7$export$d57ad9ef2fc84619 = {
    dx: {
        row: 1,
        shape: 'triangle',
        tone: 'accent'
    },
    order: {
        row: 0,
        shape: 'diamond',
        tone: 'warn'
    }
};
function $aa3ffb82ad5c03f7$export$f575cae50c008afe({ conditions: conditions, orders: orders } = {}, t) {
    const out = [];
    (conditions || []).forEach((c)=>{
        const ms = $aa3ffb82ad5c03f7$export$ff695c3374a8851c(c.onsetDate || c.createdAt);
        if (ms == null) return;
        const resolved = c.clinicalStatus === 'resolved';
        out.push({
            id: `dx-${c.id}`,
            t: ms,
            kind: 'dx',
            label: c.display || "\u2014",
            detail: resolved ? t('patient.conditions.resolved') : c.code ? `ICD ${c.code}` : t('patient.conditions.one'),
            hollow: resolved
        });
    });
    (orders || []).forEach((o)=>{
        // When it was ORDERED. performedDate is the day it is to be done (PM-0634),
        // possibly weeks ahead — not something that happened.
        const ms = $aa3ffb82ad5c03f7$export$ff695c3374a8851c(o.createdAt);
        if (ms == null) return;
        out.push({
            id: `ord-${o.id}`,
            t: ms,
            kind: 'order',
            label: o.name || "\u2014",
            detail: o.orderType || t('visit.orders.procedure')
        });
    });
    return out.sort((a, b)=>a.t - b.t);
}
function $aa3ffb82ad5c03f7$export$eb6bc7e4d8dbcf1c(encounters) {
    return (encounters || []).map((e)=>{
        const ms = $aa3ffb82ad5c03f7$export$ff695c3374a8851c(e.scheduledDate || e.startDate || e.createdAt);
        if (ms == null) return null;
        const status = String(e.status || '').toLowerCase();
        const live = status === 'in-progress' || status === 'in_progress' || status === 'arrived' || status === 'active';
        const cancelled = status === 'cancelled';
        return {
            id: e.id,
            t: ms,
            live: live,
            cancelled: cancelled,
            type: e.encounterType || e.type || '',
            status: status
        };
    }).filter(Boolean).sort((a, b)=>a.t - b.t);
}
function $aa3ffb82ad5c03f7$export$9113702d80a167d8({ metrics: metrics, medRows: medRows, events: events, encounters: encounters }) {
    const candidates = [
        ...(metrics || []).map((m)=>m.points[0]?.x),
        ...(medRows || []).flatMap((r)=>r.segments.map((s)=>s.from)),
        ...(events || []).map((e)=>e.t),
        ...(encounters || []).map((e)=>e.t)
    ].filter((v)=>v != null);
    return candidates.length ? Math.min(...candidates) : null;
}
function $aa3ffb82ad5c03f7$export$ba330bb14d26e4ac(points, item, tolerance) {
    let best = null;
    let bestD = Infinity;
    (points || []).forEach((p)=>{
        const d = Math.abs(p.x - item);
        if (d < bestD) {
            bestD = d;
            best = p;
        }
    });
    return bestD <= tolerance ? best : null;
}
function $aa3ffb82ad5c03f7$export$29e5558020ac2bd3(medRows, item, now = Date.now()) {
    return (medRows || []).filter((r)=>r.segments.some((s)=>item >= s.from && item <= (s.to ?? now))).map((r)=>r.label);
}

});


parcelRegister("40l8T", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ea1e5b4638e5be6$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $2VplL = parcelRequire("2VplL");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
parcelRequire("7sS0P");
var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $cZOyb = parcelRequire("cZOyb");
var $aJ1FU = parcelRequire("aJ1FU");
var $9gEOi = parcelRequire("9gEOi");
var $7gSBD = parcelRequire("7gSBD");
var $h4ZeB = parcelRequire("h4ZeB");
var $amyVq = parcelRequire("amyVq");
var $3Amwd = parcelRequire("3Amwd");

var $eCeEG = parcelRequire("eCeEG");
// «انتخاب سنجه‌ها» on the phone — the same catalogue as the desktop dialog, in
// the overlay the mobile tier uses for it (§5.2: Dialog on desktop ⇒
// BottomSheet on mobile).
//
// The category dropdown becomes a scrollable chip row: a native <select> on a
// phone opens a full-screen wheel that hides the list it is filtering, while
// chips keep the choice and its result on screen together.
//
// Selection is drafted and committed on «اعمال», like the desktop dialog — a
// mis-tap in a long list must not silently rewrite the chart underneath.
const $9ea1e5b4638e5be6$var$STATUS_META = (t)=>({
        critical: {
            label: t('visit.vitals.critical'),
            color: (0, $jTCZr.CT).danger,
            soft: (0, $jTCZr.CT).dangerSoft,
            tone: 'danger'
        },
        abnormal: {
            label: t('visit.vitals.abnormal'),
            color: (0, $jTCZr.CT).warnInk,
            soft: (0, $jTCZr.CT).warnSoft,
            tone: 'warn'
        }
    });
const $9ea1e5b4638e5be6$var$MobileMetricPickerSheet = ({ open: open, onClose: onClose, groups: groups, selected: selected, onApply: onApply, cap: cap = (0, $eCeEG.METRIC_CAP) })=>{
    const { t: t, formatDigits: formatDigits } = (0, $LNQP4.default)();
    const [draft, setDraft] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(selected);
    const [query, setQuery] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [category, setCategory] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [abnormalOnly, setAbnormalOnly] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // BottomSheet unmounts its children when closed, so this also resets the
    // draft on every open — but state the intent explicitly rather than relying
    // on that implementation detail.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (open) {
            setDraft(selected);
            setQuery('');
            setCategory('');
            setAbnormalOnly(false);
        }
    }, [
        open,
        selected
    ]);
    const filtered = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const q = query.trim();
        return groups.filter((g)=>!category || g.category === category).map((g)=>({
                ...g,
                metrics: g.metrics.filter((m)=>(!q || (0, $eCeEG.metricName)(t, m).includes(q)) && (!abnormalOnly || !!m.latestStatus))
            })).filter((g)=>g.metrics.length);
    }, [
        groups,
        category,
        query,
        abnormalOnly,
        t
    ]);
    const abnormalCount = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>groups.reduce((n, g)=>n + g.abnormal, 0), [
        groups
    ]);
    const full = draft.length >= cap;
    const toggle = (key)=>setDraft((prev)=>prev.includes(key) ? prev.filter((k)=>k !== key) : prev.length >= cap ? prev : [
                ...prev,
                key
            ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: open,
        onClose: onClose,
        title: t('patient.analysis.pickMetrics'),
        closeLabel: t('common.actions.close')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "analysis-picker",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $amyVq.default), {
        value: query,
        onChange: (e)=>setQuery(e.target.value),
        placeholder: t('patient.analysis.searchMetric'),
        clearLabel: t('common.actions.clearSearch'),
        "data-testid": "analysis-picker-search"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: '0.375rem',
            overflowX: 'auto',
            paddingBottom: '0.125rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $h4ZeB.default), {
        label: t('common.state.all'),
        active: !category && !abnormalOnly,
        onClick: ()=>{
            setCategory('');
            setAbnormalOnly(false);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $h4ZeB.default), {
        label: t('patient.analysis.abnormalOnly'),
        count: abnormalCount ? formatDigits(abnormalCount) : undefined,
        active: abnormalOnly,
        onClick: ()=>setAbnormalOnly((v)=>!v),
        "data-testid": "analysis-picker-abnormal"
    }), groups.map((g)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $h4ZeB.default), {
            key: g.category,
            label: t(g.categoryKey),
            count: formatDigits(g.metrics.length),
            active: category === g.category,
            onClick: ()=>setCategory((c)=>c === g.category ? '' : g.category)
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "analysis-picker-list",
        "data-state": filtered.length ? 'content' : 'empty',
        style: {
            maxHeight: '50vh',
            overflowY: 'auto',
            margin: '0 -0.25rem'
        }
    }, !filtered.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2VplL.default), {
            size: 44,
            strokeWidth: 1.5,
            "aria-hidden": true
        }),
        title: t('patient.analysis.noMetricMatch'),
        description: t('accounting.changeFilters')
    }) : filtered.map((g)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
            key: g.category
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h3", {
            style: {
                position: 'sticky',
                top: 0,
                zIndex: 1,
                margin: 0,
                background: (0, $jTCZr.C).card,
                padding: '0.4375rem 0.25rem 0.25rem',
                fontSize: '0.6875rem',
                fontWeight: 800,
                color: (0, $jTCZr.C).textMuted
            }
        }, t(g.categoryKey)), g.metrics.map((m)=>{
            const on = draft.includes(m.key);
            const st = $9ea1e5b4638e5be6$var$STATUS_META(t)[m.latestStatus];
            const disabled = full && !on;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9gEOi.default), {
                key: m.key,
                checked: on,
                disabled: disabled,
                onChange: ()=>toggle(m.key),
                "data-testid": `analysis-picker-row-${m.key}`,
                "data-state": on ? 'selected' : 'unselected',
                labelClassName: "flex-1 min-w-0",
                style: {
                    padding: '0.5rem 0.25rem',
                    minHeight: '2.75rem'
                },
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem'
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        fontSize: '0.8125rem',
                        fontWeight: 600,
                        color: (0, $jTCZr.C).text,
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                    }
                }, (0, $eCeEG.metricName)(t, m)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        marginInlineStart: 'auto',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                        flexShrink: 0
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3Amwd.default), {
                    points: m.points.slice(-8).map((p)=>p.y),
                    tone: st ? st.tone : 'accent',
                    width: 40,
                    height: 15
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        fontSize: '0.8125rem',
                        fontWeight: 800,
                        direction: 'ltr',
                        color: st ? st.color : (0, $jTCZr.C).textMuted
                    }
                }, formatDigits(Math.round(m.latest.y * 10) / 10)), st && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        fontSize: '0.5625rem',
                        fontWeight: 800,
                        borderRadius: '0.3125rem',
                        padding: '0.0625rem 0.375rem',
                        background: st.soft,
                        color: st.color
                    }
                }, st.label)))
            });
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            paddingTop: '0.25rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        type: "button",
        onClick: ()=>onApply(draft),
        "data-testid": "analysis-picker-apply",
        style: {
            flex: 1
        }
    }, t('common.actions.apply')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        type: "button",
        onClick: onClose
    }, t('common.actions.cancel')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.6875rem',
            fontWeight: 700,
            color: full ? (0, $jTCZr.CT).warnInk : (0, $jTCZr.C).textMuted,
            whiteSpace: 'nowrap'
        }
    }, formatDigits(draft.length), "/", formatDigits(cap)))));
};
var $9ea1e5b4638e5be6$export$2e2bcd8739ae039 = $9ea1e5b4638e5be6$var$MobileMetricPickerSheet;

});

parcelRegister("lDuaU", function(module, exports) {

$parcel$export(module.exports, "default", () => $8de549f95d07f683$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
parcelRequire("7sS0P");
var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $cZOyb = parcelRequire("cZOyb");
var $aJ1FU = parcelRequire("aJ1FU");
var $4Qco3 = parcelRequire("4Qco3");

var $eCeEG = parcelRequire("eCeEG");
// «بازهٔ دلخواه» on the phone — the same exact-window task as the desktop
// dialog, in the overlay the mobile tier uses for it (§5.2).
//
// The calendar and the time spinners are the kit's `JalaliDatePicker`
// (`withTime`), and the ms conversion lives in the shared model, so a range
// typed here and a range dragged on the desktop chart are the same object.
const $8de549f95d07f683$var$QUICK = [
    'month',
    '3m',
    '6m'
];
const $8de549f95d07f683$var$MobileRangeSheet = ({ open: open, onClose: onClose, domain: domain, earliest: earliest, now: now, onApply: onApply })=>{
    const { t: t, formatDate: formatDate, formatTime: formatTime } = (0, $LNQP4.default)();
    const fmt = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
            formatDate: formatDate,
            formatTime: formatTime
        }), [
        formatDate,
        formatTime
    ]);
    const [from, setFrom] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [to, setTo] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return;
        setFrom((0, $eCeEG.msToPickerValue)(domain.min));
        setTo((0, $eCeEG.msToPickerValue)(domain.max));
        setError('');
    }, [
        open,
        domain.min,
        domain.max
    ]);
    const fromMs = (0, $eCeEG.pickerValueToMs)(from);
    const toMs = (0, $eCeEG.pickerValueToMs)(to);
    const preview = fromMs != null && toMs != null ? (0, $eCeEG.describeWindow)((0, $eCeEG.normalizeWindow)(fromMs, toMs), t, {
        withTime: true,
        fmt: fmt
    }) : '';
    const apply = ()=>{
        const problem = (0, $eCeEG.validateWindow)(fromMs, toMs, t);
        if (problem) {
            setError(problem);
            return;
        }
        // A reversed pair is a slip, not an error — the model orders it either way.
        onApply(fromMs, toMs);
    };
    const applyQuick = (id)=>{
        const w = (0, $eCeEG.windowFor)(id, earliest, now);
        setFrom((0, $eCeEG.msToPickerValue)(w.min));
        setTo((0, $eCeEG.msToPickerValue)(w.max));
        setError('');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: open,
        onClose: onClose,
        title: t('patient.analysis.customRange'),
        closeLabel: t('common.actions.close')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "analysis-range-dialog",
        style: {
            display: 'grid',
            gap: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        style: {
            display: 'grid',
            gap: '0.3125rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.75rem',
            fontWeight: 700,
            color: (0, $jTCZr.C).textMuted
        }
    }, t('common.labels.from')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "analysis-range-from"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4Qco3.default), {
        value: from,
        onChange: setFrom,
        withTime: true,
        placeholder: t('patient.analysis.startDateTime')
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        style: {
            display: 'grid',
            gap: '0.3125rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.75rem',
            fontWeight: 700,
            color: (0, $jTCZr.C).textMuted
        }
    }, t('common.labels.to')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "analysis-range-to"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4Qco3.default), {
        value: to,
        onChange: setTo,
        withTime: true,
        placeholder: t('patient.analysis.endDateTime')
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: '0.375rem',
            alignItems: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.6875rem',
            color: (0, $jTCZr.C).textMuted,
            fontWeight: 700
        }
    }, t('patient.analysis.shortcut')), (0, $eCeEG.RANGE_PRESETS).filter((r)=>$8de549f95d07f683$var$QUICK.includes(r.id)).map((r)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            key: r.id,
            type: "button",
            variant: "outline",
            size: "sm",
            onClick: ()=>applyQuick(r.id),
            "data-testid": `analysis-range-quick-${r.id}`
        }, t(r.labelKey)))), preview && !error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        style: {
            margin: 0,
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).accentInk,
            fontWeight: 700
        },
        "data-testid": "analysis-range-preview"
    }, preview), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        role: "alert",
        style: {
            margin: 0,
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).danger,
            fontWeight: 700
        },
        "data-testid": "analysis-range-error"
    }, error), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        type: "button",
        onClick: apply,
        style: {
            flex: 1
        },
        "data-testid": "analysis-range-apply"
    }, t('common.actions.apply')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        type: "button",
        onClick: onClose
    }, t('common.actions.cancel')))));
};
var $8de549f95d07f683$export$2e2bcd8739ae039 = $8de549f95d07f683$var$MobileRangeSheet;

});

parcelRegister("1NWBy", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf9f992bce10c377$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
parcelRequire("7sS0P");
var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $7gSBD = parcelRequire("7gSBD");

var $gcegg = parcelRequire("gcegg");

var $eCeEG = parcelRequire("eCeEG");
// ─────────────────────────────────────────────────────────────────────────────
// The «تحلیل» chart's accessible twin on the phone.
//
// The stacked lanes are `aria-hidden` SVG — the same posture the desktop chart
// takes. Desktop pairs that with a table carrying every value as text; shipping
// the chart on the phone without it is not "the mobile version", it is the
// surface being unreadable for anyone who cannot read the chart.
//
// Same rows the desktop table builds, from the same derived model, sorted newest
// first. At phone width a five-column grid cannot hold them, so each row stacks:
// the date and kind ride a header line, the value sits large beneath it. Long
// analyte names wrap — a phone has no hover to reveal a truncated title.
// ─────────────────────────────────────────────────────────────────────────────
const $bf9f992bce10c377$var$KIND_KEYS = {
    metric: 'patient.obs.measurement',
    med: 'patient.meds.one',
    dx: 'patient.tabs.conditions',
    order: 'visit.orders.procedure',
    enc: 'patient.encounter'
};
const $bf9f992bce10c377$var$KIND_TONE = {
    metric: 'teal',
    med: 'navy',
    dx: 'teal',
    order: 'amber',
    enc: 'muted'
};
const $bf9f992bce10c377$var$MobileAnalysisTable = ({ metrics: metrics, medRows: medRows, events: events, encounters: encounters, domain: domain })=>{
    const { t: t, formatDigits: formatDigits, formatDate: formatDate } = (0, $LNQP4.default)();
    const rows = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const out = [];
        metrics.forEach((m)=>m.points.forEach((pt)=>out.push({
                    t: pt.x,
                    kind: 'metric',
                    name: (0, $eCeEG.metricName)(t, m),
                    value: `${formatDigits(Math.round(pt.y * 10) / 10)}${m.unit ? ` ${m.unit}` : ''}`,
                    status: pt.status !== 'normal' ? pt.status : null
                })));
        medRows.forEach((r)=>r.segments.forEach((s)=>out.push({
                    t: s.from,
                    kind: 'med',
                    name: s.label,
                    value: '',
                    status: null,
                    note: s.to == null ? t('common.state.active') : t('dashboard.queue.finished')
                })));
        events.forEach((e)=>out.push({
                t: e.t,
                kind: e.kind,
                name: e.label,
                value: '',
                status: null,
                note: e.detail
            }));
        encounters.forEach((e)=>out.push({
                t: e.t,
                kind: 'enc',
                name: e.type || t('patient.encounter'),
                value: '',
                status: null,
                note: e.live ? t('common.state.inProgress') : e.cancelled ? t('common.state.cancelled') : t('patient.meds.finished')
            }));
        return out.filter((r)=>r.t >= domain.min && r.t <= domain.max).sort((a, b)=>b.t - a.t);
    }, [
        metrics,
        medRows,
        events,
        encounters,
        domain,
        t,
        formatDigits
    ]);
    if (!rows.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "analysis-table",
        "data-state": "empty"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        title: t('patient.analysis.noDataInRange'),
        description: t('patient.analysis.widenRange')
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "analysis-table",
        "data-state": "content",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.375rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "sr-only"
    }, t('patient.analysis.tableCaption')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        style: {
            listStyle: 'none',
            margin: 0,
            padding: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: '0.375rem'
        }
    }, rows.map((r, i)=>{
        const crit = r.status === 'critical';
        const abnormal = !!r.status;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: `${r.kind}-${r.t}-${r.name}-${i}`,
            "data-testid": "analysis-table-row",
            style: {
                background: (0, $jTCZr.C).card,
                borderRadius: '0.625rem',
                border: `1px solid ${abnormal ? crit ? (0, $jTCZr.CT).dangerSoft : (0, $jTCZr.CT).warnSoft : (0, $jTCZr.C).border}`,
                padding: '0.5rem 0.75rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.375rem',
                flexWrap: 'wrap'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.625rem',
                color: (0, $jTCZr.C).textMuted,
                whiteSpace: 'nowrap'
            }
        }, (0, $eCeEG.jalaliShort)(r.t, {
            formatDate: formatDate
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gcegg.Pill), {
            tone: $bf9f992bce10c377$var$KIND_TONE[r.kind] || 'muted'
        }, t($bf9f992bce10c377$var$KIND_KEYS[r.kind] || $bf9f992bce10c377$var$KIND_KEYS.enc)), abnormal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gcegg.Pill), {
            tone: crit ? 'danger' : 'amber'
        }, t(crit ? 'visit.vitals.critical' : 'visit.vitals.abnormal'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'baseline',
                gap: '0.5rem',
                marginTop: '0.25rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                flex: 1,
                minWidth: 0,
                fontSize: '0.75rem',
                fontWeight: 700,
                color: (0, $jTCZr.C).textPrimary,
                overflowWrap: 'anywhere'
            }
        }, r.name), r.value && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "ltr",
            style: {
                fontSize: '0.875rem',
                fontWeight: 800,
                flexShrink: 0,
                fontVariantNumeric: 'tabular-nums',
                color: crit ? (0, $jTCZr.CT).danger : abnormal ? (0, $jTCZr.CT).warnInk : (0, $jTCZr.C).textPrimary
            }
        }, r.value)), !r.value && r.note && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.625rem',
                color: (0, $jTCZr.C).textMuted,
                marginTop: '0.125rem'
            }
        }, r.note));
    })));
};
var $bf9f992bce10c377$export$2e2bcd8739ae039 = $bf9f992bce10c377$var$MobileAnalysisTable;

});


parcelRegister("4wm3E", function(module, exports) {

$parcel$export(module.exports, "default", () => $e99e18a7ba5d97dc$export$2e2bcd8739ae039);
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");
parcelRequire("7sS0P");
var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $7gSBD = parcelRequire("7gSBD");
var $66joL = parcelRequire("66joL");
var $iygI2 = parcelRequire("iygI2");

var $2WFPf = parcelRequire("2WFPf");
var $i5dmF = parcelRequire("i5dmF");
var $aGlWN = parcelRequire("aGlWN");
var $aVx4q = parcelRequire("aVx4q");
var $fX0JO = parcelRequire("fX0JO");

var $eVM84 = parcelRequire("eVM84");

var $a83Oj = parcelRequire("a83Oj");

var $gcegg = parcelRequire("gcegg");
var $jTCZr = parcelRequire("jTCZr");

var $bVoWw = parcelRequire("bVoWw");

var $i9Cif = parcelRequire("i9Cif");

var $g6gAc = parcelRequire("g6gAc");

var $93kEN = parcelRequire("93kEN");

var $jDxJA = parcelRequire("jDxJA");

var $5hFXE = parcelRequire("5hFXE");

var $5UCQz = parcelRequire("5UCQz");

var $aQGDs = parcelRequire("aQGDs");

var $ltciA = parcelRequire("ltciA");

var $gq4TR = parcelRequire("gq4TR");

var $dL6zl = parcelRequire("dL6zl");
const $e99e18a7ba5d97dc$var$LIST_ORDERS_ENC = `query ListDoctorOrdersEnc($patientId:ID!,$appointmentId:ID){listDoctorOrders(patientId:$patientId,appointmentId:$appointmentId){id appointmentId orderType name code urgency status notes createdAt performedDate performedHere stage nextBookingAt}}`;
// amendClinicalNote (unlike updateClinicalNote, the in-visit autosave) is
// attributed to the calling doctor server-side: the prior content is snapshotted
// into the revision history and updatedAt is stamped.
const $e99e18a7ba5d97dc$var$AMEND_CLINICAL_NOTE = `mutation AmendClinicalNote($id:ID!,$input:UpdateClinicalNoteInput!){amendClinicalNote(id:$id,input:$input){id content updatedAt}}`;
// First post-visit save on a visit that never got a SOAP row: a plain create —
// there is no prior content, so correctly no revision either.
const $e99e18a7ba5d97dc$var$CREATE_SOAP_NOTE = `mutation CreateClinicalNote($patientId:ID!,$input:ClinicalNoteInput!){createClinicalNote(patientId:$patientId,input:$input){id content createdAt updatedAt}}`;
const $e99e18a7ba5d97dc$var$CLINICAL_NOTE_REVISIONS = `query ClinicalNoteRevisions($appointmentId:ID!){clinicalNoteRevisions(appointmentId:$appointmentId){id noteId editedBy editedAt content}}`;
// «تاریخچه مراجعات» — the encounter history as a stack of expandable cards.
// Tapping a card opens its workspace: SOAP notes, this-visit diagnoses,
// medications and orders (orders fetched lazily on first open). A live visit is
// ringed in teal.
//
// This is the record's CORRECTION rail, not a charting surface: a finished
// visit's SOAP can be amended here (attributed, with a revision trail), but a
// live visit's note belongs to the Visit page and is read-only here — the same
// gate the desktop rail applies.
const $e99e18a7ba5d97dc$var$InnerEmpty = ({ text: text })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                opacity: 0.4
            }
        }, "\u2014"),
        title: text,
        style: {
            padding: '1.5rem 1rem'
        }
    });
const $e99e18a7ba5d97dc$var$SoapSectionShell = ({ letter: letter, name: name, action: action, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            borderRadius: '0.625rem',
            border: `1px solid ${(0, $jTCZr.C).border}`,
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0.5rem 0.75rem',
            background: (0, $jTCZr.C).bg,
            borderBottom: `1px solid ${(0, $jTCZr.C).border}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: '1.375rem',
            height: '1.375rem',
            borderRadius: '0.375rem',
            background: (0, $jTCZr.CT).accentSoft,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '0.6875rem',
            fontWeight: 700,
            color: (0, $jTCZr.CT).accentInk,
            flexShrink: 0
        }
    }, letter), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.75rem',
            fontWeight: 600,
            color: (0, $jTCZr.C).textPrimary
        }
    }, name), action), children);
const $e99e18a7ba5d97dc$var$MobilePatientVisits = ({ p: p, patientId: patientId, onRefresh: onRefresh })=>{
    const { t: t, formatDate: formatDate, formatDateTime: formatDateTime, formatDigits: formatDigits } = (0, $LNQP4.default)();
    const [openId, setOpenId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [innerTab, setInnerTab] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('soap');
    const [encOrders, setEncOrders] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({});
    const [loadingOrders, setLoadingOrders] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({});
    const [orderErr, setOrderErr] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({});
    const [assistantOpen, setAssistantOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // ── post-visit SOAP amendment ───────────────────────────────────────────────
    const [editingId, setEditingId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [soapDraft, setSoapDraft] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        S: '',
        O: '',
        A: '',
        P: ''
    });
    const [savingSoap, setSavingSoap] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [soapSaveError, setSoapSaveError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    // Saves are reflected without refetching the whole patient: an overlay of
    // {noteId: {content, updatedAt}} plus any notes created from this section.
    const [noteOverlay, setNoteOverlay] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({});
    const [createdNotes, setCreatedNotes] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [historyId, setHistoryId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [revisions, setRevisions] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // null = not fetched yet
    const [expandedRevId, setExpandedRevId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const myDoctorId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $a83Oj.parseJwt)((0, $a83Oj.getToken)() || '')?.sub || null, []);
    const encounters = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>[
            ...p.encounters || []
        ].sort((a, b)=>(b.scheduledDate || b.createdAt || '').localeCompare(a.scheduledDate || a.createdAt || '')), [
        p.encounters
    ]);
    // «کد رهگیری» of what the doctor sent to the insurer, per visit that is over (PM-0686):
    // one read for the list; read again once the e-prescription sheet closes.
    const { codes: erxCodes, reload: reloadErxCodes } = (0, $5hFXE.useVisitErxCodes)(encounters.filter((e)=>!(0, $dL6zl.isLiveEncounter)(e)).map((e)=>e.id));
    // The record's notes with this section's own saves folded in.
    const allNotes = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>[
            ...p.clinicalNotes || [],
            ...createdNotes
        ].map((n)=>noteOverlay[n.id] ? {
                ...n,
                ...noteOverlay[n.id]
            } : n), [
        p.clinicalNotes,
        createdNotes,
        noteOverlay
    ]);
    const fetchOrders = (id)=>{
        setLoadingOrders((prev)=>({
                ...prev,
                [id]: true
            }));
        setOrderErr((prev)=>({
                ...prev,
                [id]: false
            }));
        (0, $eVM84.bffQuery)($e99e18a7ba5d97dc$var$LIST_ORDERS_ENC, {
            patientId: patientId,
            appointmentId: id
        }).then((d)=>setEncOrders((prev)=>({
                    ...prev,
                    [id]: d.listDoctorOrders || []
                }))).catch(()=>setOrderErr((prev)=>({
                    ...prev,
                    [id]: true
                }))).finally(()=>setLoadingOrders((prev)=>({
                    ...prev,
                    [id]: false
                })));
    };
    const closeEditUi = ()=>{
        // Collapsing or switching visits drops the edit/history UI state, never the
        // saves — those live in the overlay.
        setEditingId(null);
        setSoapSaveError('');
        setHistoryId(null);
        setRevisions(null);
        setExpandedRevId(null);
    };
    const toggle = (id)=>{
        closeEditUi();
        if (openId === id) {
            setOpenId(null);
            return;
        }
        setOpenId(id);
        setInnerTab('soap');
        if (!encOrders[id] && !loadingOrders[id]) fetchOrders(id);
    };
    const startSoapEdit = (encId, encNotes)=>{
        setSoapDraft((0, $dL6zl.readSoapDraft)(encNotes));
        setSoapSaveError('');
        setHistoryId(null);
        setEditingId(encId);
    };
    const refreshRevisions = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((encId)=>{
        (0, $eVM84.bffQuery)($e99e18a7ba5d97dc$var$CLINICAL_NOTE_REVISIONS, {
            appointmentId: encId
        }).then((d)=>setRevisions(d?.clinicalNoteRevisions || [])).catch(()=>setRevisions([]));
    }, []);
    const toggleHistory = (encId)=>{
        if (historyId === encId) {
            setHistoryId(null);
            return;
        }
        setHistoryId(encId);
        setExpandedRevId(null);
        if (revisions === null) refreshRevisions(encId);
    };
    const saveSoapEdit = async (encId, note)=>{
        if (savingSoap) return;
        setSavingSoap(true);
        setSoapSaveError('');
        const content = {
            s: soapDraft.S,
            o: soapDraft.O,
            a: soapDraft.A,
            p: soapDraft.P
        };
        try {
            if (note) {
                const d = await (0, $eVM84.bffMutation)($e99e18a7ba5d97dc$var$AMEND_CLINICAL_NOTE, {
                    id: note.id,
                    input: {
                        content: content
                    }
                });
                const saved = d?.amendClinicalNote;
                if (saved) setNoteOverlay((prev)=>({
                        ...prev,
                        [note.id]: {
                            content: saved.content,
                            updatedAt: saved.updatedAt || note.updatedAt
                        }
                    }));
                // An open history panel must show the newly recorded revision.
                if (revisions !== null) refreshRevisions(encId);
            } else {
                const d = await (0, $eVM84.bffMutation)($e99e18a7ba5d97dc$var$CREATE_SOAP_NOTE, {
                    patientId: patientId,
                    input: {
                        noteType: 'SOAP_NOTE',
                        content: content,
                        authorRole: 'doctor',
                        appointmentId: encId
                    }
                });
                const created = d?.createClinicalNote;
                if (created) setCreatedNotes((prev)=>[
                        ...prev,
                        {
                            ...created,
                            appointmentId: encId,
                            noteType: 'SOAP_NOTE'
                        }
                    ]);
            }
            setEditingId(null);
        } catch (e) {
            // Inline, not a toast: the draft stays on screen and editable so nothing
            // typed is lost while the doctor retries (§11).
            setSoapSaveError(e?.message || t('errors.save.edit'));
        } finally{
            setSavingSoap(false);
        }
    };
    // The record's id rides in as `patientId`; `p` is the loaded patient.
    const visitNowPatient = {
        id: p?.id || patientId,
        encounters: p?.encounters
    };
    if (!encounters.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visits-content",
        "data-state": "empty"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fX0JO.default), {
            size: 44,
            color: (0, $jTCZr.C).textMuted,
            strokeWidth: 1.5,
            "aria-hidden": true
        }),
        title: t('patient.visits.noOwnVisits')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5UCQz.default), {
        patient: visitNowPatient,
        fullWidth: true,
        size: "default",
        testId: "visits-visit-now"
    }));
    const INNER_TABS = (encConds, encMeds, orders)=>[
            {
                id: 'soap',
                label: 'SOAP'
            },
            {
                id: 'conds',
                label: encConds.length ? t('patient.visits.condsWithCount', {
                    count: encConds.length
                }) : t('patient.tabs.conditions')
            },
            {
                id: 'meds',
                label: encMeds.length ? t('patient.visits.medsWithCount', {
                    count: encMeds.length
                }) : t('patient.tabs.medications')
            },
            {
                id: 'orders',
                label: orders.length ? t('patient.visits.ordersWithCount', {
                    count: orders.length
                }) : t('visit.tabs.orders')
            }
        ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visits-content",
        "data-state": "content",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bVoWw.MobilePatientAssistantBar), {
        onOpen: ()=>setAssistantOpen(true)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5UCQz.default), {
        patient: visitNowPatient,
        fullWidth: true,
        size: "default",
        testId: "visits-visit-now"
    }), encounters.map((enc)=>{
        const isOpen = openId === enc.id;
        const encConds = (p.clinicalConditions || []).filter((c)=>c.appointmentId === enc.id);
        const encMeds = (p.clinicalMedications || []).filter((m)=>m.appointmentId === enc.id);
        const encNotes = allNotes.filter((n)=>n.appointmentId === enc.id);
        const summary = encNotes.find((0, $dL6zl.isSummaryNote));
        const orders = encOrders[enc.id] || [];
        const live = (0, $dL6zl.isLiveEncounter)(enc);
        const soapNote = (0, $dL6zl.primarySoapNote)(encNotes);
        const soapUpdatedAt = soapNote?.updatedAt || null;
        const isEditing = editingId === enc.id;
        // Amendment is a post-visit affordance only — a live visit's SOAP belongs
        // to the Visit page. Charting stays there; this is the correction rail.
        const canEdit = !live;
        const hasSoap = (0, $dL6zl.hasSoapContent)(encNotes);
        const extraNotes = (0, $dL6zl.otherNotes)(encNotes);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: enc.id,
            style: {
                background: (0, $jTCZr.C).card,
                borderRadius: '0.75rem',
                border: `1px solid ${live ? (0, $jTCZr.CT).accent : (0, $jTCZr.C).border}`,
                overflow: 'hidden'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            onClick: ()=>toggle(enc.id),
            "aria-expanded": isOpen,
            "data-testid": `visit-toggle-${enc.id}`,
            className: "w-full h-auto min-h-11 justify-start gap-2.5 rounded-none px-4 py-3 text-start hover:bg-transparent"
        }, live && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                width: '0.5rem',
                height: '0.5rem',
                borderRadius: '50%',
                background: (0, $jTCZr.CT).good,
                flexShrink: 0
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1,
                minWidth: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.375rem',
                marginBottom: '0.25rem',
                flexWrap: 'wrap'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.8125rem',
                fontWeight: 700,
                color: (0, $jTCZr.C).textPrimary
            }
        }, (0, $gq4TR.ENC_TYPE_KEYS)[enc.type] ? t((0, $gq4TR.ENC_TYPE_KEYS)[enc.type]) : enc.type || t('patient.visit')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gcegg.Pill), {
            tone: live ? 'teal' : 'muted'
        }, (0, $gq4TR.ENC_STATUS_KEYS)[enc.status] ? t((0, $gq4TR.ENC_STATUS_KEYS)[enc.status]) : enc.status || "\u2014")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                gap: '0.5rem',
                fontSize: '0.6875rem',
                color: (0, $jTCZr.C).textMuted,
                fontWeight: 400,
                flexWrap: 'wrap'
            }
        }, (enc.scheduledDate || enc.createdAt) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, (0, $gcegg.faDate)(enc.scheduledDate || enc.createdAt, formatDate)), encConds.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, formatDigits(encConds.length), " ", t('patient.conditions.one')), encMeds.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, formatDigits(encMeds.length), " ", t('patient.meds.one')), orders.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, formatDigits(orders.length), " ", t('patient.orderType.procedure')))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2WFPf.default), {
            size: 16,
            strokeWidth: 2,
            "aria-hidden": true,
            style: {
                flexShrink: 0,
                color: (0, $jTCZr.C).textMuted,
                transform: isOpen ? 'rotate(180deg)' : 'rotate(0)',
                transition: 'transform .2s'
            }
        })), !isOpen && erxCodes.get(String(enc.id))?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                padding: '0 1rem 0.75rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $jDxJA.ErxCodeChips), {
            codes: erxCodes.get(String(enc.id)),
            touch: true,
            testid: `visit-erx-${enc.id}`
        })), isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                borderTop: `1px solid ${(0, $jTCZr.C).border}`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $93kEN.default), {
            style: {
                display: 'flex',
                padding: '0.625rem 1rem',
                borderBottom: `1px solid ${(0, $jTCZr.C).border}`
            },
            visit: enc,
            patientId: patientId,
            insurance: p.insurance,
            mine: !!myDoctorId && enc.doctorId === myDoctorId,
            hasLines: encMeds.length + orders.length > 0,
            onChanged: ()=>{
                onRefresh?.();
                fetchOrders(enc.id);
                reloadErxCodes();
            },
            testid: `history-erx-${enc.id}`
        }), erxCodes.get(String(enc.id))?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                padding: '0.625rem 1rem',
                borderBottom: `1px solid ${(0, $jTCZr.C).border}`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $jDxJA.ErxCodeGroup), {
            codes: erxCodes.get(String(enc.id)),
            touch: true,
            testid: `visit-erx-group-${enc.id}`
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                overflowX: 'auto',
                scrollbarWidth: 'none',
                background: (0, $jTCZr.C).bg,
                borderBottom: `1px solid ${(0, $jTCZr.C).border}`
            }
        }, INNER_TABS(encConds, encMeds, orders).map((item)=>{
            const on = innerTab === item.id;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
                key: item.id,
                variant: "ghost",
                onClick: ()=>setInnerTab(item.id),
                role: "tab",
                "aria-selected": on,
                "data-testid": `visit-inner-${enc.id}-${item.id}`,
                className: "h-auto min-h-11 rounded-none px-3.5 py-2.5 shrink-0 hover:bg-transparent",
                style: {
                    fontSize: '0.75rem',
                    fontWeight: on ? 700 : 500,
                    color: on ? (0, $jTCZr.CT).accentInk : (0, $jTCZr.C).textMuted,
                    borderBottom: on ? `2px solid ${(0, $jTCZr.CT).accent}` : '2px solid transparent'
                }
            }, item.label);
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                padding: '0.875rem 1rem'
            }
        }, innerTab === 'soap' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": `visits-soap-${enc.id}`,
            "data-state": isEditing ? 'editing' : hasSoap ? 'content' : 'empty',
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: '0.625rem'
            }
        }, summary && !isEditing && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                background: (0, $jTCZr.CT).accentSoft,
                borderRadius: '0.625rem',
                padding: '0.75rem 0.875rem',
                border: `1px solid ${(0, $jTCZr.soft)((0, $jTCZr.CT).accent, 0.2)}`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.6875rem',
                fontWeight: 700,
                color: (0, $jTCZr.CT).accentInk,
                marginBottom: '0.375rem'
            }
        }, t('credits.price.summary')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.75rem',
                color: (0, $jTCZr.CT).ink2,
                lineHeight: 1.75,
                whiteSpace: 'pre-wrap'
            }
        }, (0, $dL6zl.parseNoteContent)(summary.content).text || (0, $dL6zl.noteText)(summary))), (hasSoap || isEditing) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.375rem',
                flexWrap: 'wrap'
            }
        }, soapUpdatedAt && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gcegg.Pill), {
            tone: "muted",
            style: {
                fontWeight: 600
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "data-testid": `visits-soap-edited-${enc.id}`
        }, t('patient.visits.soapEditedAt', {
            date: (0, $dL6zl.soapEditStamp)(soapUpdatedAt, formatDateTime)
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                marginInlineStart: 'auto',
                display: 'flex',
                gap: '0.25rem'
            }
        }, soapUpdatedAt && !isEditing && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            size: "sm",
            className: "min-h-11 gap-1",
            onClick: ()=>toggleHistory(enc.id),
            "data-testid": `visits-soap-history-${enc.id}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $i5dmF.default), {
            size: 13,
            "aria-hidden": true
        }), " ", t('patient.visits.editHistory')), canEdit && !isEditing && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "outline",
            size: "sm",
            className: "min-h-11 gap-1",
            onClick: ()=>startSoapEdit(enc.id, encNotes),
            "data-testid": `visits-soap-edit-${enc.id}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aGlWN.default), {
            size: 13,
            "aria-hidden": true
        }), " ", t('common.actions.edit')))), isEditing ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.6875rem',
                color: (0, $jTCZr.C).textMuted
            }
        }, t('patient.visits.editSoapHint')), (0, $gq4TR.SOAP_SECTIONS).map((sec)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e99e18a7ba5d97dc$var$SoapSectionShell, {
                key: sec.k,
                letter: sec.k,
                name: t(sec.nameKey)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    padding: '0.5rem 0.625rem'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $iygI2.default), {
                value: soapDraft[sec.k] || '',
                onChange: (e)=>{
                    const v = e.target.value;
                    setSoapDraft((prev)=>({
                            ...prev,
                            [sec.k]: v
                        }));
                },
                rows: 3,
                "data-testid": `visits-soap-field-${enc.id}-${sec.k}`
            })))), soapSaveError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            role: "alert",
            "data-testid": `visits-soap-error-${enc.id}`,
            style: {
                fontSize: '0.75rem',
                fontWeight: 600,
                color: (0, $jTCZr.CT).dangerInk,
                background: (0, $jTCZr.CT).dangerSoft,
                borderRadius: '0.5rem',
                padding: '0.5rem 0.625rem'
            }
        }, t('patient.visits.soapSaveError'), " \u2014 ", soapSaveError), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                gap: '0.5rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "outline",
            size: "lg",
            className: "flex-1 min-h-11",
            disabled: savingSoap,
            onClick: ()=>{
                setEditingId(null);
                setSoapSaveError('');
            },
            "data-testid": `visits-soap-cancel-${enc.id}`
        }, t('common.actions.cancel')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            size: "lg",
            className: "flex-1 min-h-11 bg-gradient-brand font-bold",
            disabled: savingSoap,
            onClick: ()=>saveSoapEdit(enc.id, soapNote),
            "data-testid": `visits-soap-save-${enc.id}`
        }, savingSoap ? t('common.state.saving') : t('common.actions.save')))) : (0, $gq4TR.SOAP_SECTIONS).map((sec)=>{
            const text = (0, $dL6zl.readSoapSection)(encNotes, sec.k);
            if (!text) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e99e18a7ba5d97dc$var$SoapSectionShell, {
                key: sec.k,
                letter: sec.k,
                name: t(sec.nameKey)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    padding: '0.625rem 0.75rem',
                    fontSize: '0.75rem',
                    color: (0, $jTCZr.C).textSecondary,
                    lineHeight: 1.75,
                    whiteSpace: 'pre-wrap'
                }
            }, text));
        }), historyId === enc.id && !isEditing && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": `visits-soap-history-panel-${enc.id}`,
            "data-state": revisions === null ? 'loading' : revisions.length ? 'content' : 'empty',
            style: {
                borderRadius: '0.625rem',
                border: `1px solid ${(0, $jTCZr.C).border}`,
                padding: '0.625rem 0.75rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.6875rem',
                fontWeight: 700,
                color: (0, $jTCZr.C).textMuted,
                textTransform: 'uppercase',
                letterSpacing: '0.06em',
                marginBottom: '0.5rem'
            }
        }, t('patient.visits.editHistory')), revisions === null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonText), {
            lines: 2,
            height: 11,
            lastWidth: "45%"
        }), revisions !== null && !revisions.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.75rem',
                color: (0, $jTCZr.C).textMuted
            }
        }, t('patient.visits.noRevisions')), (revisions || []).map((rev)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                key: rev.id,
                style: {
                    borderTop: `1px solid ${(0, $jTCZr.C).border}`,
                    paddingTop: '0.375rem',
                    marginTop: '0.375rem'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
                variant: "ghost",
                onClick: ()=>setExpandedRevId(expandedRevId === rev.id ? null : rev.id),
                "aria-expanded": expandedRevId === rev.id,
                "data-testid": `visits-revision-${rev.id}`,
                className: "w-full h-auto min-h-11 justify-start gap-2 rounded-none px-0 hover:bg-transparent"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    fontSize: '0.75rem',
                    fontWeight: 600,
                    color: (0, $jTCZr.C).textPrimary
                }
            }, (0, $dL6zl.soapEditStamp)(rev.editedAt, formatDateTime)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    fontSize: '0.6875rem',
                    color: (0, $jTCZr.C).textMuted
                }
            }, rev.editedBy && rev.editedBy === myDoctorId ? t('patient.visits.editedByYou') : rev.editedBy || "\u2014"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2WFPf.default), {
                size: 14,
                "aria-hidden": true,
                style: {
                    marginInlineStart: 'auto',
                    color: (0, $jTCZr.C).textMuted,
                    transform: expandedRevId === rev.id ? 'rotate(180deg)' : 'rotate(0)'
                }
            })), expandedRevId === rev.id && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '0.375rem',
                    paddingBottom: '0.5rem'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    fontSize: '0.625rem',
                    color: (0, $jTCZr.C).textMuted
                }
            }, t('patient.visits.priorVersion')), (0, $gq4TR.SOAP_SECTIONS).map((sec)=>{
                const c = (0, $dL6zl.parseNoteContent)(rev.content);
                const lk = sec.k.toLowerCase();
                const txt = typeof c[lk] === 'string' && c[lk].trim() ? c[lk] : typeof c[sec.k] === 'string' ? c[sec.k] : '';
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    key: sec.k,
                    style: {
                        fontSize: '0.6875rem',
                        lineHeight: 1.75
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        fontWeight: 700,
                        color: (0, $jTCZr.CT).accentInk
                    }
                }, sec.k, " "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        color: txt ? (0, $jTCZr.C).textSecondary : (0, $jTCZr.C).textMuted,
                        whiteSpace: 'pre-wrap'
                    }
                }, txt || t('patient.obs.notRecorded')));
            }))))), extraNotes.map((n, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                key: n.id || i,
                style: {
                    borderRadius: '0.625rem',
                    border: `1px solid ${(0, $jTCZr.C).border}`,
                    padding: '0.625rem 0.75rem'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    fontSize: '0.6875rem',
                    fontWeight: 600,
                    color: (0, $jTCZr.C).textMuted,
                    marginBottom: '0.3125rem'
                }
            }, (0, $gq4TR.NOTE_TYPE_LABEL_KEYS)[n.noteType] ? t((0, $gq4TR.NOTE_TYPE_LABEL_KEYS)[n.noteType]) : n.noteType), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    fontSize: '0.75rem',
                    color: (0, $jTCZr.C).textSecondary,
                    lineHeight: 1.75,
                    whiteSpace: 'pre-wrap'
                }
            }, (0, $dL6zl.noteText)(n)))), !summary && !hasSoap && !extraNotes.length && !isEditing && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e99e18a7ba5d97dc$var$InnerEmpty, {
            text: t('visit.empty.noNoteForEncounter')
        }), canEdit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "outline",
            size: "lg",
            className: "w-full min-h-11 gap-1",
            onClick: ()=>startSoapEdit(enc.id, encNotes),
            "data-testid": `visits-soap-add-${enc.id}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aGlWN.default), {
            size: 14,
            "aria-hidden": true
        }), " ", t('patient.visits.addSoapNote')))), innerTab === 'conds' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: '0.5rem'
            }
        }, !encConds.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e99e18a7ba5d97dc$var$InnerEmpty, {
            text: t('patient.conditions.none')
        }), encConds.map((c, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                key: c.id || i,
                style: {
                    background: (0, $jTCZr.C).bg,
                    borderRadius: '0.625rem',
                    padding: '0.625rem 0.875rem',
                    border: `1px solid ${(0, $jTCZr.C).border}`
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.375rem',
                    flexWrap: 'wrap'
                }
            }, i === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gcegg.Pill), {
                tone: "teal"
            }, t('visit.dx.primary')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    fontSize: '0.8125rem',
                    fontWeight: 600,
                    color: (0, $jTCZr.C).textPrimary
                }
            }, c.display || c.code)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'flex',
                    gap: '0.375rem',
                    marginTop: '0.25rem',
                    alignItems: 'center',
                    flexWrap: 'wrap'
                }
            }, c.code && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gcegg.Pill), {
                tone: "navy"
            }, c.code), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    fontSize: '0.6875rem',
                    color: c.clinicalStatus === 'active' ? (0, $jTCZr.CT).warnInk : (0, $jTCZr.C).textMuted,
                    fontWeight: 600
                }
            }, (0, $gq4TR.STATUS_COND_KEYS)[c.clinicalStatus] ? t((0, $gq4TR.STATUS_COND_KEYS)[c.clinicalStatus]) : c.clinicalStatus), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $i9Cif.DiagnosisTypeBadge), {
                cond: c
            }))))), innerTab === 'meds' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: '0.5rem'
            }
        }, !encMeds.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e99e18a7ba5d97dc$var$InnerEmpty, {
            text: t('patient.meds.none')
        }), encMeds.map((m, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                key: m.id || i,
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.625rem',
                    background: (0, $jTCZr.C).bg,
                    borderRadius: '0.625rem',
                    padding: '0.625rem 0.875rem',
                    border: `1px solid ${(0, $jTCZr.C).border}`
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aVx4q.default), {
                size: 16,
                color: (0, $jTCZr.C).navy,
                "aria-hidden": true,
                style: {
                    flexShrink: 0
                }
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    flex: 1,
                    minWidth: 0
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                dir: "auto",
                style: {
                    fontSize: '0.8125rem',
                    fontWeight: 600,
                    color: (0, $jTCZr.C).textPrimary
                }
            }, (0, $g6gAc.medDisplayName)(m)), m.dosageInstruction?.text && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    fontSize: '0.6875rem',
                    color: (0, $jTCZr.C).textMuted,
                    marginTop: '0.125rem'
                }
            }, m.dosageInstruction.text)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    fontSize: '0.6875rem',
                    fontWeight: 600,
                    color: m.status === 'active' ? (0, $jTCZr.CT).good : (0, $jTCZr.C).textMuted
                }
            }, (0, $gq4TR.STATUS_MED_KEYS)[m.status] ? t((0, $gq4TR.STATUS_MED_KEYS)[m.status]) : m.status || "\u2014")))), innerTab === 'orders' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: '0.5rem'
            }
        }, loadingOrders[enc.id] && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonText), {
            lines: 2,
            height: 12,
            lastWidth: "55%",
            style: {
                padding: '0.5rem 0'
            }
        }), !loadingOrders[enc.id] && orderErr[enc.id] && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                textAlign: 'center',
                padding: '1.25rem 1rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.75rem',
                color: (0, $jTCZr.CT).dangerInk,
                marginBottom: '0.625rem'
            }
        }, t('visit.orders.loadFailed')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "outline",
            size: "sm",
            className: "min-h-11",
            onClick: ()=>fetchOrders(enc.id),
            "data-testid": `visit-orders-retry-${enc.id}`
        }, t('common.actions.retry'))), !loadingOrders[enc.id] && !orderErr[enc.id] && !orders.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e99e18a7ba5d97dc$var$InnerEmpty, {
            text: t('visit.orders.noneRecordedShort')
        }), orders.map((o, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                key: o.id || i,
                style: {
                    background: (0, $jTCZr.C).bg,
                    borderRadius: '0.625rem',
                    padding: '0.625rem 0.875rem',
                    border: `1px solid ${(0, $jTCZr.C).border}`
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    fontSize: '0.8125rem',
                    fontWeight: 600,
                    color: (0, $jTCZr.C).textPrimary,
                    marginBottom: '0.3125rem'
                }
            }, o.name || o.code || "\u2014"), o.notes && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    fontSize: '0.6875rem',
                    color: (0, $jTCZr.C).textMuted,
                    marginBottom: '0.3125rem'
                }
            }, o.notes), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    marginBottom: '0.3125rem'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aQGDs.OrderDateLine), {
                order: o,
                compact: true,
                testid: `patient-order-date-${o.id}`
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'flex',
                    gap: '0.375rem',
                    flexWrap: 'wrap',
                    alignItems: 'center'
                }
            }, o.orderType && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gcegg.Pill), {
                tone: "navy"
            }, (0, $gq4TR.ORDER_TYPE_KEYS)[o.orderType] ? t((0, $gq4TR.ORDER_TYPE_KEYS)[o.orderType]) : o.orderType), o.urgency && o.urgency !== 'routine' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gcegg.Pill), {
                tone: "amber"
            }, o.urgency === 'stat' ? t('common.urgency.stat') : t('common.urgency.urgent')), (()=>{
                const st = (0, $ltciA.orderStageColors)[(0, $ltciA.orderStageOf)(o)];
                return st ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gcegg.Pill), {
                    tone: st.pill
                }, t(st.labelKey)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gcegg.Pill), {
                    tone: "muted"
                }, o.status || "\u2014");
            })(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aQGDs.OrderBookingLine), {
                order: o,
                compact: true,
                testid: `patient-order-booking-${o.id}`
            }))))))));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bVoWw.MobilePatientAssistantSheet), {
        open: assistantOpen,
        onClose: ()=>setAssistantOpen(false),
        patientId: patientId,
        encounterCount: encounters.length
    }));
};
var $e99e18a7ba5d97dc$export$2e2bcd8739ae039 = $e99e18a7ba5d97dc$var$MobilePatientVisits;

});
parcelRegister("bVoWw", function(module, exports) {

$parcel$export(module.exports, "MobilePatientAssistantBar", () => $67c1024be06ff12d$export$449e370937586546);
$parcel$export(module.exports, "MobilePatientAssistantSheet", () => $67c1024be06ff12d$export$7a3c97ef8da260ee);
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");
parcelRequire("7sS0P");
var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $cZOyb = parcelRequire("cZOyb");
var $aJ1FU = parcelRequire("aJ1FU");
var $a7Rbr = parcelRequire("a7Rbr");

var $iDwyV = parcelRequire("iDwyV");
var $6OGKD = parcelRequire("6OGKD");
var $chm1L = parcelRequire("chm1L");

var $eVM84 = parcelRequire("eVM84");
parcelRequire("gcegg");
var $jTCZr = parcelRequire("jTCZr");
// ─────────────────────────────────────────────────────────────────────────────
// «دستیار تاریخچه» on the phone — the record assistant that answers across a
// patient's visits (desktop VisitsTab's «دستیار» rail).
//
// Desktop affords a permanently visible rail because it has a spare column;
// the phone has none, so the assistant is a docked entry inside «تاریخچه
// مراجعات» that opens a full sheet. It is NOT a screen-fixed floating button:
// nothing else on this record floats, and one floating control for one section
// of one screen is chrome the doctor has to learn for a single feature.
//
// `chat` IS the session memory — it renders the thread and is replayed to the
// BFF on every turn, so a follow-up can be asked short. Same contract as
// desktop; this screen adds no billing surface of its own.
// ─────────────────────────────────────────────────────────────────────────────
const $67c1024be06ff12d$var$ASK_PATIENT_AI = `
  query AskDoctorQuestion($question: String!, $patientId: ID, $conversationHistory: [ChatTurnInput!]) {
    askDoctorQuestion(question: $question, patientId: $patientId, conversationHistory: $conversationHistory) {
      answer confidence followUpSuggestions referencedVisitIds
    }
  }
`;
const $67c1024be06ff12d$var$CONFIDENCE_KEYS = {
    high: 'visit.confidenceLevel.high',
    medium: 'visit.confidenceLevel.medium',
    low: 'visit.confidenceLevel.low'
};
const $67c1024be06ff12d$var$QUICK_Q_KEYS = [
    'visit.quick.a1cTrend',
    'visit.quick.medChanges',
    'visit.quick.openOrders',
    'visit.quick.sixMonthCourse'
];
// A tappable suggestion — quick question before the first turn, follow-up after.
const $67c1024be06ff12d$var$QuickQuestion = ({ label: label, onPick: onPick, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "sm",
        onClick: ()=>onPick(label),
        "data-testid": testId,
        className: "w-full min-h-11 justify-start text-start whitespace-normal h-auto py-2",
        style: {
            fontSize: '0.75rem',
            color: (0, $jTCZr.C).textSecondary
        }
    }, label);
const $67c1024be06ff12d$export$449e370937586546 = ({ onOpen: onOpen, disabled: disabled })=>{
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "lg",
        onClick: onOpen,
        disabled: disabled,
        "data-testid": "patient-assistant-open",
        className: "w-full min-h-11 gap-2 justify-start",
        style: {
            borderColor: (0, $jTCZr.soft)((0, $jTCZr.CT).accent, 0.35),
            background: (0, $jTCZr.CT).accentSoft,
            color: (0, $jTCZr.CT).accentInk,
            fontWeight: 700
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $chm1L.default), {
        size: 16,
        "aria-hidden": true
    }), " ", t('patient.visits.askAssistant'));
};
const $67c1024be06ff12d$export$7a3c97ef8da260ee = ({ open: open, onClose: onClose, patientId: patientId, encounterCount: encounterCount = 0 })=>{
    const { t: t } = (0, $LNQP4.default)();
    const [chat, setChat] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [draft, setDraft] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const bodyRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const seq = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(0);
    // A new patient is a new conversation — never carry one patient's thread over.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setChat([]);
        setDraft('');
    }, [
        patientId
    ]);
    // Keep the newest turn in view. The sheet owns its own scroll, so this scrolls
    // the panel rather than the page behind it.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const el = bodyRef.current;
        if (el) el.scrollTop = el.scrollHeight;
    }, [
        chat,
        loading,
        open
    ]);
    const ask = (raw)=>{
        const q = (raw ?? draft).trim();
        if (!q || loading) return;
        // Snapshot the thread BEFORE this turn is appended — the new question travels
        // as `question`, so replaying it here would duplicate it.
        const history = chat.filter((m)=>!m.error && m.text).map((m)=>({
                role: m.role === 'user' ? 'user' : 'assistant',
                content: m.text
            }));
        setChat((prev)=>[
                ...prev,
                {
                    id: ++seq.current,
                    role: 'user',
                    text: q
                }
            ]);
        setDraft('');
        setLoading(true);
        (0, $eVM84.bffQuery)($67c1024be06ff12d$var$ASK_PATIENT_AI, {
            question: q,
            patientId: patientId,
            conversationHistory: history
        }).then((d)=>{
            const a = d?.askDoctorQuestion || {};
            setChat((prev)=>[
                    ...prev,
                    {
                        id: ++seq.current,
                        role: 'assistant',
                        text: a.answer || t('errors.ai.noResponse'),
                        confidence: a.confidence,
                        suggestions: a.followUpSuggestions || []
                    }
                ]);
        })// Surface the real reason — a failed turn that just says «خطا» sends the
        // doctor looking for a fault that isn't theirs (credits, service down).
        .catch((e)=>setChat((prev)=>[
                    ...prev,
                    {
                        id: ++seq.current,
                        role: 'assistant',
                        error: true,
                        text: e?.extensions?.code === 'INSUFFICIENT_CREDITS' ? t('visit.copilot.notEnoughCredit') : t('visit.copilot.askError') + (e?.message ? ` \u{2014} ${e.message}` : '')
                    }
                ])).finally(()=>setLoading(false));
    };
    const state = loading ? 'loading' : chat.length ? 'content' : 'empty';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: open,
        onClose: onClose,
        title: t('visit.copilot.historyAssistant')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "patient-assistant-sheet",
        "data-state": state,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            fontSize: '0.6875rem',
            color: (0, $jTCZr.C).textMuted
        }
    }, chat.length ? t('visit.copilot.threadOpen') : t('visit.copilot.askAcrossVisits', {
        count: encounterCount
    })), chat.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        className: "min-h-11 gap-1",
        disabled: loading,
        onClick: ()=>{
            setChat([]);
            setDraft('');
        },
        "data-testid": "patient-assistant-reset"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $iDwyV.default), {
        size: 13,
        "aria-hidden": true
    }), " ", t('visit.copilot.newThread'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: bodyRef,
        role: "log",
        "aria-live": "polite",
        "data-testid": "patient-assistant-thread",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.625rem',
            maxHeight: '22rem',
            overflowY: 'auto'
        }
    }, chat.length === 0 && !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.375rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.6875rem',
            fontWeight: 700,
            color: (0, $jTCZr.C).textMuted,
            textTransform: 'uppercase',
            letterSpacing: '0.06em'
        }
    }, t('visit.copilot.quickQuestions')), $67c1024be06ff12d$var$QUICK_Q_KEYS.map((k, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($67c1024be06ff12d$var$QuickQuestion, {
            key: k,
            label: t(k),
            onPick: ask,
            testId: `patient-assistant-quick-${i}`
        }))), chat.map((m)=>m.role === 'user' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: m.id,
            style: {
                alignSelf: 'flex-end',
                maxWidth: '85%'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                background: (0, $jTCZr.CT).accent,
                color: (0, $jTCZr.CT).onAccent || '#fff',
                borderRadius: '0.875rem',
                padding: '0.5rem 0.75rem',
                fontSize: '0.75rem',
                lineHeight: 1.75
            }
        }, m.text)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: m.id,
            style: {
                alignSelf: 'flex-start',
                maxWidth: '92%',
                display: 'flex',
                flexDirection: 'column',
                gap: '0.375rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                background: m.error ? (0, $jTCZr.CT).dangerSoft : (0, $jTCZr.CT).surface2,
                border: `1px solid ${m.error ? (0, $jTCZr.soft)((0, $jTCZr.CT).danger, 0.3) : (0, $jTCZr.C).border}`,
                color: m.error ? (0, $jTCZr.CT).dangerInk : (0, $jTCZr.C).textSecondary,
                borderRadius: '0.875rem',
                padding: '0.5rem 0.75rem',
                fontSize: '0.75rem',
                lineHeight: 1.75,
                whiteSpace: 'pre-wrap'
            }
        }, !m.error && $67c1024be06ff12d$var$CONFIDENCE_KEYS[String(m.confidence).toLowerCase()] && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.625rem',
                fontWeight: 700,
                color: (0, $jTCZr.CT).accentInk,
                marginBottom: '0.25rem'
            }
        }, t('visit.copilot.confidence'), " ", t($67c1024be06ff12d$var$CONFIDENCE_KEYS[String(m.confidence).toLowerCase()])), m.text), m.suggestions?.length > 0 && !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: '0.3125rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.625rem',
                color: (0, $jTCZr.C).textMuted,
                fontWeight: 700
            }
        }, t('visit.copilot.continue')), m.suggestions.map((q, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($67c1024be06ff12d$var$QuickQuestion, {
                key: i,
                label: q,
                onPick: ask,
                testId: `patient-assistant-followup-${i}`
            }))))), loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "patient-assistant-typing",
        "aria-label": t('visit.copilot.typing'),
        style: {
            alignSelf: 'flex-start',
            background: (0, $jTCZr.CT).surface2,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: '0.875rem',
            padding: '0.5rem 0.875rem',
            fontSize: '0.75rem',
            color: (0, $jTCZr.C).textMuted
        }
    }, "\u2026")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: '0.5rem',
            alignItems: 'flex-end'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
        value: draft,
        onChange: (e)=>setDraft(e.target.value),
        onKeyDown: (e)=>{
            if (e.key === 'Enter') ask();
        },
        placeholder: chat.length ? t('visit.copilot.nextQuestion') : t('visit.copilot.askHistory'),
        disabled: loading,
        "data-testid": "patient-assistant-input"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        size: "lg",
        className: "min-h-11 shrink-0 bg-gradient-brand",
        disabled: loading || !draft.trim(),
        onClick: ()=>ask(),
        "aria-label": t('visit.copilot.send'),
        "data-testid": "patient-assistant-send"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6OGKD.default), {
        size: 16,
        "aria-hidden": true
    })))));
};

});

parcelRegister("93kEN", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f64ac416f593a18$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $1bCzH = parcelRequire("1bCzH");
var $6OGKD = parcelRequire("6OGKD");
var $bo0GS = parcelRequire("bo0GS");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $k27hS = parcelRequire("k27hS");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $e317r = parcelRequire("e317r");

var $7ZSin = parcelRequire("7ZSin");

var $3O5pt = parcelRequire("3O5pt");

var $eQiuG = parcelRequire("eQiuG");

var $dL6zl = parcelRequire("dL6zl");

var $3yLHS = parcelRequire("3yLHS");
function $5f64ac416f593a18$export$2e2bcd8739ae039({ visit: visit, patientId: patientId, insurance: insurance, mine: mine, hasLines: hasLines, onChanged: onChanged, testid: testid = 'history-erx', style: style }) {
    const { isMobile: isMobile } = (0, $k27hS.default)();
    const { t: t } = (0, $LNQP4.default)();
    const iranian = (0, $e317r.useIranianRails)();
    const eligible = !!(visit?.id && patientId && mine && hasLines && iranian && !(0, $dL6zl.isLiveEncounter)(visit));
    const { status: status, reload: reload } = (0, $7ZSin.useErxStatus)({
        appointmentId: visit?.id,
        patientId: patientId,
        active: eligible
    });
    const [open, setOpen] = (0, $acw62.useState)(false);
    const close = (0, $acw62.useCallback)(()=>{
        setOpen(false);
        reload();
        onChanged?.();
    }, [
        reload,
        onChanged
    ]);
    if (!eligible || !status?.enabled) return null;
    const sent = !!(0, $3O5pt.registeredStatus)(status);
    if (sent && !(0, $3O5pt.correctionPossible)(status)) {
        const why = status.final ? t('visit.erx.correction.unavailable.FINAL') : t('visit.erx.correction.unavailable.EXPIRED');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: style
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "data-testid": `${testid}-registered`,
            "data-state": "registered",
            title: why,
            style: {
                display: 'inline-flex',
                alignItems: 'center',
                gap: 5,
                fontSize: '0.71875rem',
                fontWeight: 600,
                padding: '3px 9px',
                borderRadius: 999,
                background: (0, $jTCZr.CT).goodSoft,
                color: (0, $jTCZr.CT).goodInk
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bo0GS.default), {
            size: 13,
            "aria-hidden": true
        }), t('visit.historyErx.registered')));
    }
    const label = sent ? t('visit.historyErx.correct') : t('visit.historyErx.send');
    // `style` places it (the caller's row); nothing is drawn while it is hidden.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: sent ? 'subtle' : 'default',
        size: "sm",
        // 44 px on a phone (it was 36 — PM-0137 c); the desktop row keeps its compact size.
        className: isMobile ? 'min-h-11 gap-1.5' : 'gap-1.5',
        onClick: (e)=>{
            e.stopPropagation();
            setOpen(true);
        },
        "data-testid": testid,
        "data-state": sent ? 'registered' : 'send'
    }, sent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1bCzH.default), {
        size: 13,
        "aria-hidden": true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6OGKD.default), {
        size: 13,
        "aria-hidden": true
    }), label), open && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3yLHS.default), {
        visit: visit,
        patientId: patientId,
        insurer: (0, $eQiuG.insurerKeyOf)(insurance),
        mode: sent ? 'correct' : 'send',
        onClose: close
    }));
}

});
parcelRegister("1bCzH", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2114e9cca6c57fd$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $f2114e9cca6c57fd$export$a2387ed3b5d536eb = {
    name: "pencil-line",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M13 21h8",
                key: "1jsn5i"
            }
        ],
        [
            "path",
            {
                d: "m15 5 4 4",
                key: "1mk7zo"
            }
        ],
        [
            "path",
            {
                d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
                key: "1a8usu"
            }
        ]
    ]
};
$f2114e9cca6c57fd$export$a2387ed3b5d536eb.node;
const $f2114e9cca6c57fd$export$2e2bcd8739ae039 = (0, $9QBug.default)($f2114e9cca6c57fd$export$a2387ed3b5d536eb);

});

parcelRegister("3yLHS", function(module, exports) {

$parcel$export(module.exports, "default", () => $49c99466dee6cafa$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $cZOyb = parcelRequire("cZOyb");
var $aJ1FU = parcelRequire("aJ1FU");
var $66joL = parcelRequire("66joL");
var $hZDga = parcelRequire("hZDga");
var $k27hS = parcelRequire("k27hS");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $eVM84 = parcelRequire("eVM84");

var $U8Lvw = parcelRequire("U8Lvw");

var $7ZSin = parcelRequire("7ZSin");

var $eQiuG = parcelRequire("eQiuG");

var $5VYuu = parcelRequire("5VYuu");

var $3O5pt = parcelRequire("3O5pt");

var $aQGDs = parcelRequire("aQGDs");

var $6xvbB = parcelRequire("6xvbB");

var $9SQfR = parcelRequire("9SQfR");

var $8qirc = parcelRequire("8qirc");

var $4UqGT = parcelRequire("4UqGT");

var $bOPUe = parcelRequire("bOPUe");

var $3OnFU = parcelRequire("3OnFU");
// ─────────────────────────────────────────────────────────────────────────────
// «اصلاح نسخهٔ ویزیت {date}» — a past visit's نسخه, corrected after the visit
// (K1, 2026-10-04; docs/eprescription/CORRECTION.md).
//
// op-naji allows a registered prescription to be corrected for one month after
// the visit. This sheet opens on ONE past visit: its نسخه lines, read by that
// appointment; edited, removed and added exactly as on the visit's own نسخه —
// the same RxItemCard and closed lists, the same persistence (useVisitRxPersistence,
// pointed at that appointment); and the same e-prescription card, which sends a
// prescription never sent or corrects a registered one.
//
// Its دستورات too (K1, 2026-10-10): an order the insurer cannot take — a free-text
// «LFT» — is cancelled and replaced from the catalogue (AST, ALT, ALP), with the
// visit room's own operations: listOrders, cancelOrder, createOrder.
//
// It touches that visit's medication rows and orders and nothing else: the visit
// is not started, ended, reopened or edited. Opening the sheet costs two reads,
// its نسخه and its دستورات.
//
// An inline-start sheet like «سوابق ویزیت‌های قبلی», but layered BELOW the kit's
// dialogs (1100) rather than above them as that one is (1200): the card asks for
// a confirmation from inside it, and a dialog drawn behind its sheet freezes the
// page (DESIGN.md «Overlay layering»).
// ─────────────────────────────────────────────────────────────────────────────
const $49c99466dee6cafa$var$SHEET_Z = 1050;
// On a phone the sheet is mounted from the patient record, which never loads the
// visit page's stylesheet — so RxItemCard's fields drew with no border at 12 px
// and its ✎/✕ shrank to the bare 14 px glyph (`.iconbtn` lives in MOBILE_CSS;
// seen in the 2026-10-12 tour, PM-0119). The sheet brings that stylesheet with
// it and, inside itself only, lifts every control to the phone floor: 44 px
// targets, 16 px text in fields (anything smaller makes iOS zoom on focus).
const $49c99466dee6cafa$var$PHONE_SCOPE = '[data-testid="visit-rx-correction-sheet"]';
const $49c99466dee6cafa$var$PHONE_CSS = `
${$49c99466dee6cafa$var$PHONE_SCOPE} .iconbtn{width:44px;height:44px;border-radius:10px}
${$49c99466dee6cafa$var$PHONE_SCOPE} .iconbtn svg{width:18px;height:18px}
${$49c99466dee6cafa$var$PHONE_SCOPE} [data-testid$="-search"]{min-height:44px !important}
${$49c99466dee6cafa$var$PHONE_SCOPE} select,${$49c99466dee6cafa$var$PHONE_SCOPE} input:not([type=checkbox]):not([type=radio]),${$49c99466dee6cafa$var$PHONE_SCOPE} textarea{font-size:1rem !important;min-height:44px !important}
${$49c99466dee6cafa$var$PHONE_SCOPE} [role=radiogroup] button,${$49c99466dee6cafa$var$PHONE_SCOPE} [role=tablist] button,${$49c99466dee6cafa$var$PHONE_SCOPE} [aria-pressed]{min-height:44px !important}
`;
// Edits settle before the card and the chips read again, as on the visit's نسخه.
const $49c99466dee6cafa$var$SETTLE_MS = 900;
function $49c99466dee6cafa$var$useSettled(value, ms) {
    const [settled, setSettled] = (0, $acw62.useState)(value);
    (0, $acw62.useEffect)(()=>{
        const h = setTimeout(()=>setSettled(value), ms);
        return ()=>clearTimeout(h);
    }, [
        value,
        ms
    ]);
    return settled;
}
function $49c99466dee6cafa$export$2e2bcd8739ae039({ visit: visit, patientId: patientId, insurer: insurer, onClose: onClose, mode: mode = 'correct', memory: memory = null }) {
    const { t: t, formatDate: formatDate, readsPersianData: readsPersianData } = (0, $LNQP4.default)();
    const durations = (0, $acw62.useMemo)(()=>(0, $6xvbB.DURATIONS)(t), [
        t
    ]);
    const orderTypes = (0, $acw62.useMemo)(()=>(0, $6xvbB.ORDER_TYPE_FA)(t), [
        t
    ]);
    const [rxItems, setRxItems] = (0, $acw62.useState)([]);
    const { scheduleSave: scheduleSave, deleteRow: deleteRow, writeNow: writeNow, flush: flush, hydration: hydration, rehydrate: rehydrate } = (0, $U8Lvw.useVisitRxPersistence)({
        appointmentId: visit.id,
        patientId: patientId,
        setRxItems: setRxItems,
        rxItems: rxItems
    });
    // ── the chips: where each line stands with the insurer ──
    const { status: status, reload: reloadStatus } = (0, $7ZSin.useErxStatus)({
        appointmentId: visit.id,
        patientId: patientId,
        prepare: flush
    });
    const erxIndex = (0, $acw62.useMemo)(()=>(0, $3O5pt.indexErxStatus)(status), [
        status
    ]);
    const removedLines = (0, $acw62.useMemo)(()=>(0, $3O5pt.erxRemovedLines)(erxIndex, 'DRUGS', rxItems.map((r)=>r.medicationId)), [
        erxIndex,
        rxItems
    ]);
    // ── this visit's دستورات, read as the visit room's دستورات tab reads them ──
    // A cancelled order is no longer on the visit: it is not listed, and what the
    // insurer still holds of it shows under the list (ErxRemovedLines).
    const [orders, setOrders] = (0, $acw62.useState)([]);
    const [ordersState, setOrdersState] = (0, $acw62.useState)('loading'); // 'loading' | 'ready' | 'error'
    const ordersRead = (0, $acw62.useRef)(0);
    const loadOrders = (0, $acw62.useCallback)(async ()=>{
        const mine = ++ordersRead.current; // only the newest read lands
        try {
            const d = await (0, $eVM84.bffQuery)((0, $6xvbB.LIST_CLINICAL_ORDERS), {
                appointmentId: visit.id
            });
            if (mine !== ordersRead.current) return;
            setOrders(d?.listOrders || []);
            setOrdersState('ready');
        } catch (e) {
            if (mine !== ordersRead.current) return;
            console.warn('[rx-correction] could not read the visit\'s orders:', e?.message);
            setOrdersState('error');
        }
    }, [
        visit.id
    ]);
    (0, $acw62.useEffect)(()=>{
        loadOrders();
    }, [
        loadOrders
    ]);
    const retryOrders = (0, $acw62.useCallback)(()=>{
        setOrdersState('loading');
        loadOrders();
    }, [
        loadOrders
    ]);
    const liveOrders = (0, $acw62.useMemo)(()=>orders.filter((o)=>o && o.status !== 'cancelled'), [
        orders
    ]);
    const removedOrders = (0, $acw62.useMemo)(()=>(0, $3O5pt.erxRemovedLines)(erxIndex, 'SERVICES', liveOrders.map((o)=>o.id)), [
        erxIndex,
        liveOrders
    ]);
    const orderName = (0, $6xvbB.useCatalogNamesEn)(liveOrders.map((o)=>o.description));
    // The card re-reads once an edit has settled — a نسخه line's, or an order added
    // or cancelled; the chips too, and also once a line has been written (its
    // record id is what they are matched by).
    const cardContent = (0, $acw62.useMemo)(()=>JSON.stringify([
            rxItems.map((r)=>[
                    r.id,
                    r.dosage,
                    r.frequency,
                    r.route,
                    r.duration,
                    r.quantity
                ]),
            orders.map((o)=>[
                    o.id,
                    o.status
                ])
        ]), [
        rxItems,
        orders
    ]);
    const cardKey = $49c99466dee6cafa$var$useSettled(cardContent, $49c99466dee6cafa$var$SETTLE_MS);
    const statusContent = (0, $acw62.useMemo)(()=>JSON.stringify([
            cardContent,
            rxItems.map((r)=>r.medicationId || null)
        ]), [
        cardContent,
        rxItems
    ]);
    const statusKey = $49c99466dee6cafa$var$useSettled(statusContent, $49c99466dee6cafa$var$SETTLE_MS);
    const firstStatusKey = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(()=>{
        if (firstStatusKey.current) {
            firstStatusKey.current = false;
            return;
        }
        reloadStatus();
    }, [
        statusKey,
        reloadStatus
    ]);
    // ── editing, as on the visit's نسخه ──
    const updateDrug = (0, $acw62.useCallback)((id, key, val)=>{
        setRxItems((prev)=>prev.map((r)=>r.id === id ? {
                    ...(0, $eQiuG.applyRxEdit)(r, key, val, {
                        durations: durations
                    }),
                    aiNote: undefined,
                    removeFailed: undefined
                } : r));
        scheduleSave(id);
    }, [
        scheduleSave,
        durations
    ]);
    const removeDrug = (0, $acw62.useCallback)((id)=>{
        // Delete first: the hook finds the row it deletes in the list it last saw.
        deleteRow(id);
        setRxItems((prev)=>prev.filter((r)=>r.id !== id));
    }, [
        deleteRow
    ]);
    // ── adding from the formulary: search, pick the drug, complete its form ──
    // The same search and the same add form as the visit's own نسخه (RxDrugSearch):
    // a line is added only with every required field filled (PM-0059).
    const seq = (0, $acw62.useRef)(0);
    const prescribed = (0, $acw62.useMemo)(()=>new Set(rxItems.map((r)=>r.drug?.id)), [
        rxItems
    ]);
    // A drug opens on the doctor's last directions for it (PM-0574): the host's
    // memory when the sheet is opened from the visit room (`memory`, its
    // useRxMemory), else the sheet's own — opened from the patient record.
    const rxLists = (0, $acw62.useMemo)(()=>({
            routes: (0, $6xvbB.RX_ROUTES)(),
            durations: durations
        }), [
        durations
    ]);
    const ownMemory = (0, $5VYuu.useRxMemory)({
        lists: rxLists,
        defaultDuration: t('visit.duration.d7')
    });
    const rxMemory = memory || ownMemory;
    const { rxDefaultsFor: defaultsFor, remember: remember } = rxMemory;
    const addDrug = (0, $acw62.useCallback)((drug, sig)=>{
        if (!drug?.id) return;
        remember(drug, sig);
        seq.current += 1;
        const n = seq.current;
        setRxItems((prev)=>prev.some((r)=>r.drug?.id === drug.id) ? prev : [
                ...prev,
                (0, $eQiuG.newRxLine)(drug, sig, n, {
                    durations: durations
                })
            ]);
    }, [
        durations,
        remember
    ]);
    // The card's own words for a line as it is now, beside what the insurer holds.
    const describeLine = (0, $acw62.useCallback)((line)=>{
        const row = line?.medicationId ? rxItems.find((r)=>r.medicationId && String(r.medicationId) === String(line.medicationId)) : null;
        return row ? (0, $6xvbB.rxItemSummary)(row, t, readsPersianData) : null;
    }, [
        rxItems,
        t,
        readsPersianData
    ]);
    // ── cancelling and adding an order, as on the دستورات tab ──
    // One write at a time (a second press joins the first), then the list is read
    // again. Closing, and each read and send of the card, wait for a write still in
    // flight: the server builds the prescription from the record, and an order
    // pressed a moment before «ارسال» must be in it.
    const [cancelling, setCancelling] = (0, $acw62.useState)(null); // the order being cancelled
    const [adding, setAdding] = (0, $acw62.useState)(null); // the catalogue row being added
    const [orderError, setOrderError] = (0, $acw62.useState)(null);
    const [orderToCancel, setOrderToCancel] = (0, $acw62.useState)(null);
    const orderBusy = !!(cancelling || adding);
    const orderWrite = (0, $acw62.useRef)(null);
    const writeOrder = (0, $acw62.useCallback)((run)=>{
        if (orderWrite.current) return orderWrite.current;
        const p = run().finally(()=>{
            orderWrite.current = null;
        });
        orderWrite.current = p;
        return p;
    }, []);
    const cancelOrder = (0, $acw62.useCallback)((order)=>writeOrder(async ()=>{
            setCancelling(order.id);
            setOrderError(null);
            try {
                await (0, $eVM84.bffMutation)((0, $6xvbB.CANCEL_ORDER_MUT), {
                    orderId: order.id
                });
                await loadOrders();
            } catch (e) {
                console.error('[rx-correction] cancelOrder failed:', e);
                setOrderError(e?.message || t('errors.save.orderStatus'));
            } finally{
                setCancelling(null);
            }
        }), [
        writeOrder,
        loadOrders,
        t
    ]);
    // The visit room's «افزودن» (handleCreateOrder): the catalogue row travels with
    // the order — its code and catalogId are what the insurer's service is found by.
    const addOrder = (0, $acw62.useCallback)((entry)=>writeOrder(async ()=>{
            setAdding(entry.id);
            setOrderError(null);
            try {
                const d = await (0, $eVM84.bffMutation)((0, $6xvbB.CREATE_CLINICAL_ORDER), {
                    appointmentId: visit.id,
                    patientId: patientId,
                    orderType: entry.orderType,
                    description: entry.name,
                    urgency: 'routine',
                    notes: '',
                    code: entry.code || null,
                    catalogId: entry.id || null,
                    sessionCount: null
                });
                // An answer with no order back is a write that did not land.
                if (!d?.createOrder) setOrderError(t('visit.orders.saveRetry'));
                await loadOrders();
            } catch (e) {
                console.error('[rx-correction] createOrder failed:', e);
                setOrderError(e?.message || t('errors.save.order'));
            } finally{
                setAdding(null);
            }
        }), [
        writeOrder,
        loadOrders,
        visit.id,
        patientId,
        t
    ]);
    // Every write asked for, landed: an order in flight, then the نسخه's lines.
    const writeAll = (0, $acw62.useCallback)(async ()=>{
        await orderWrite.current;
        return writeNow();
    }, [
        writeNow
    ]);
    // ── leaving ──
    // Every change is written before the sheet goes — an edit still on its delay,
    // a drug just added, an order being added or cancelled — so nothing done here
    // is lost by closing. A send or a login in flight on the card is unsaved work:
    // it asks first, as the closure dialog does.
    const [erxBusy, setErxBusy] = (0, $acw62.useState)(false);
    const [leaveConfirm, setLeaveConfirm] = (0, $acw62.useState)(false);
    const [closing, setClosing] = (0, $acw62.useState)(false);
    const closingRef = (0, $acw62.useRef)(false); // a second click before the re-render
    const close = (0, $acw62.useCallback)(async ()=>{
        if (closingRef.current) return;
        closingRef.current = true;
        setClosing(true);
        try {
            await writeAll();
        } catch (e) {
            console.warn('[rx-correction] could not write before closing:', e?.message);
        }
        onClose?.();
    }, [
        writeAll,
        onClose
    ]);
    const requestClose = (0, $acw62.useCallback)(()=>{
        if (erxBusy) {
            setLeaveConfirm(true);
            return;
        }
        close();
    }, [
        erxBusy,
        close
    ]);
    const panelRef = (0, $acw62.useRef)(null);
    // On a phone the sheet is the kit BottomSheet (PM-0119): full height, a 44 px
    // close, the keyboard inset, and — what the side panel never had — an entry in
    // history, so the platform back closes the SHEET instead of leaving the
    // patient record under it. The panel below stays the workstation's.
    const { isMobile: isMobile } = (0, $k27hS.default)();
    (0, $acw62.useEffect)(()=>{
        if (!isMobile) panelRef.current?.focus?.();
    }, [
        isMobile
    ]);
    (0, $acw62.useEffect)(()=>{
        if (isMobile) return undefined; // the BottomSheet owns Escape there
        const onKey = (e)=>{
            if (e.key !== 'Escape' || e.defaultPrevented) return;
            // A dialog opened from inside the sheet closes itself, not the sheet.
            const inDialog = e.target instanceof Element ? e.target.closest('[role="dialog"],[role="alertdialog"]') : null;
            if (inDialog && inDialog !== panelRef.current) return;
            requestClose();
        };
        window.addEventListener('keydown', onKey);
        return ()=>window.removeEventListener('keydown', onKey);
    }, [
        requestClose,
        isMobile
    ]);
    const dateLabel = visit.scheduledDate ? formatDate(visit.scheduledDate, 'medium') : '';
    const sending = mode === 'send';
    // Until when a correction may go — the server's word (ePrescriptionStatus.until),
    // null while it offers none: op-naji documents no correction since its 2026-10
    // revision, and a window that cannot be used is not one to state.
    const lastDay = sending || !status?.until ? null : new Date(status.until);
    const title = sending ? t('visit.rxCorrection.sendTitle', {
        date: dateLabel
    }) : t('visit.rxCorrection.title', {
        date: dateLabel
    });
    const loading = hydration === 'loading' || hydration === 'idle';
    const body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, closing && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.71875rem',
            color: (0, $jTCZr.CT).mute
        }
    }, t('common.state.saving')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
        "aria-label": t('visit.rxCorrection.lines'),
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            fontSize: '0.75rem',
            fontWeight: 700,
            color: (0, $jTCZr.CT).ink2
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).pill, {
        width: 12,
        height: 12
    }), t('visit.rxCorrection.lines'), rxItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.625rem',
            background: (0, $jTCZr.CT).border,
            color: (0, $jTCZr.CT).ink2,
            padding: '1px 6px',
            borderRadius: 4,
            fontWeight: 600
        }
    }, rxItems.length)), hydration === 'error' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-rx-correction-error",
        "data-state": "error",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '8px 10px',
            borderRadius: 8,
            background: (0, $jTCZr.CT).dangerSoft
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).alert, {
        width: 14,
        height: 14,
        style: {
            color: (0, $jTCZr.CT).dangerInk,
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            fontSize: '0.75rem',
            fontWeight: 600,
            color: (0, $jTCZr.CT).dangerInk
        }
    }, t('visit.history.loadFailed')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "subtle",
        size: "sm",
        onClick: rehydrate,
        "data-testid": "visit-rx-correction-retry"
    }, t('common.actions.retry'))) : loading && rxItems.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-rx-correction-loading",
        "data-state": "loading",
        style: {
            display: 'grid',
            gap: 8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        height: 42
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        height: 42
    })) : rxItems.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-rx-correction-empty",
        "data-state": "empty",
        style: {
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).mute,
            fontStyle: 'italic'
        }
    }, t('visit.history.noMedications')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-rx-correction-list",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 8
        }
    }, rxItems.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.RxItemCard), {
            key: item.id,
            item: item,
            onChange: (key, val)=>updateDrug(item.id, key, val),
            onRemove: ()=>removeDrug(item.id),
            insurer: insurer,
            erxLine: (0, $3O5pt.erxStateForRx)(item, erxIndex)
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bOPUe.ErxRemovedLines), {
        lines: removedLines,
        testid: "visit-rx-correction-removed"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
        "aria-label": t('visit.rx.addMedication'),
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        htmlFor: "visit-rx-correction-search",
        style: {
            fontSize: '0.6875rem',
            fontWeight: 600,
            color: (0, $jTCZr.CT).mute
        }
    }, t('visit.rx.addMedication')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9SQfR.default), {
        touch: isMobile,
        testIdPrefix: "visit-rx-correction",
        inputId: "visit-rx-correction-search",
        defaultsFor: defaultsFor,
        memory: rxMemory.memory,
        prescribedIds: prescribed,
        insurer: insurer,
        onAdd: addDrug
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
        "aria-label": t('visit.rxCorrection.orders'),
        "data-testid": "visit-rx-correction-orders",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            fontSize: '0.75rem',
            fontWeight: 700,
            color: (0, $jTCZr.CT).ink2
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).flask, {
        width: 12,
        height: 12
    }), t('visit.rxCorrection.orders'), liveOrders.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.625rem',
            background: (0, $jTCZr.CT).border,
            color: (0, $jTCZr.CT).ink2,
            padding: '1px 6px',
            borderRadius: 4,
            fontWeight: 600
        }
    }, liveOrders.length)), orderError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-rx-correction-order-error",
        role: "alert",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '8px 10px',
            borderRadius: 8,
            background: (0, $jTCZr.CT).dangerSoft
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).alert, {
        width: 14,
        height: 14,
        style: {
            color: (0, $jTCZr.CT).dangerInk,
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            fontSize: '0.75rem',
            fontWeight: 600,
            color: (0, $jTCZr.CT).dangerInk
        }
    }, orderError), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: ()=>setOrderError(null),
        "aria-label": t('errors.dismiss'),
        style: {
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            color: (0, $jTCZr.CT).dangerInk,
            display: 'grid',
            placeItems: 'center',
            padding: 2
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).x, {
        width: 13,
        height: 13
    }))), ordersState === 'error' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-rx-correction-orders-error",
        "data-state": "error",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '8px 10px',
            borderRadius: 8,
            background: (0, $jTCZr.CT).dangerSoft
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).alert, {
        width: 14,
        height: 14,
        style: {
            color: (0, $jTCZr.CT).dangerInk,
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            fontSize: '0.75rem',
            fontWeight: 600,
            color: (0, $jTCZr.CT).dangerInk
        }
    }, t('visit.orders.loadFailed')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "subtle",
        size: "sm",
        onClick: retryOrders,
        "data-testid": "visit-rx-correction-orders-retry"
    }, t('common.actions.retry'))) : ordersState === 'loading' && liveOrders.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-rx-correction-orders-loading",
        "data-state": "loading",
        style: {
            display: 'grid',
            gap: 8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        height: 42
    })) : liveOrders.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-rx-correction-orders-empty",
        "data-state": "empty",
        style: {
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).mute,
            fontStyle: 'italic'
        }
    }, t('visit.history.noOrders')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-rx-correction-orders-list",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 8
        }
    }, liveOrders.map((order)=>{
        const TypeIcon = (0, $6xvbB.I)[(0, $6xvbB.ORDER_TYPE_ICON)[order.orderType]] || (0, $6xvbB.I).doc;
        // Only a pending order can be withdrawn; any other says where it stands
        // (the one stage map, constants/statuses) — a merely requested one is the
        // plain case and says nothing.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: order.id,
            "data-testid": `visit-rx-correction-order-${order.id}`,
            "data-status": order.status,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                padding: '9px 10px',
                borderRadius: 10,
                background: (0, $jTCZr.CT).surface,
                border: `1px solid ${(0, $jTCZr.CT).border}`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "aria-hidden": "true",
            style: {
                width: 30,
                height: 30,
                borderRadius: 8,
                flexShrink: 0,
                display: 'grid',
                placeItems: 'center',
                background: (0, $jTCZr.CT).accentSoft,
                color: (0, $jTCZr.CT).accentInk
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(TypeIcon, {
            width: 15,
            height: 15
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1,
                minWidth: 0,
                display: 'flex',
                flexDirection: 'column',
                gap: 5
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "auto",
            style: {
                fontSize: '0.8125rem',
                fontWeight: 700,
                color: (0, $jTCZr.CT).ink,
                lineHeight: 1.5,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            }
        }, orderName(order.description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: 6,
                minWidth: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.75rem',
                fontWeight: 500,
                lineHeight: '22px',
                padding: '0 9px',
                borderRadius: 6,
                whiteSpace: 'nowrap',
                color: (0, $jTCZr.CT).ink,
                background: (0, $jTCZr.CT).surface2
            }
        }, orderTypes[order.orderType] || order.orderType), order.code && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "ltr",
            style: {
                fontSize: '0.75rem',
                lineHeight: '22px',
                padding: '0 9px',
                borderRadius: 6,
                whiteSpace: 'nowrap',
                color: (0, $jTCZr.CT).ink2,
                background: (0, $jTCZr.CT).surface2
            }
        }, order.code), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aQGDs.OrderStageChip), {
            order: order,
            hide: [
                'REQUESTED'
            ],
            testid: `visit-rx-correction-order-stage-${order.id}`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bOPUe.ErxLineChip), {
            line: (0, $3O5pt.erxStateForOrder)(order, erxIndex),
            testid: `visit-rx-correction-order-erx-state-${order.id}`
        }))), order.status === 'pending' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            size: "sm",
            className: "h-7 px-3 shrink-0",
            onClick: ()=>setOrderToCancel(order),
            disabled: orderBusy,
            "data-testid": `visit-rx-correction-order-cancel-${order.id}`,
            style: {
                color: (0, $jTCZr.CT).dangerInk
            }
        }, cancelling === order.id ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
            size: 11,
            thickness: 2
        }) : t('common.actions.discard')));
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bOPUe.ErxRemovedLines), {
        lines: removedOrders,
        part: "SERVICES",
        testid: "visit-rx-correction-orders-removed"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
        "aria-label": t('visit.rxCorrection.addOrder'),
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        htmlFor: "visit-rx-correction-order-search",
        style: {
            fontSize: '0.6875rem',
            fontWeight: 600,
            color: (0, $jTCZr.CT).mute
        }
    }, t('visit.rxCorrection.addOrder')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8qirc.default), {
        testIdPrefix: "visit-rx-correction-order",
        inputId: "visit-rx-correction-order-search",
        appointmentId: visit.id,
        insurer: insurer,
        orders: liveOrders,
        adding: adding,
        disabled: orderBusy,
        onAdd: addOrder
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4UqGT.default), {
        testIdPrefix: "visit-rx-correction-erx",
        scope: "ALL",
        appointmentId: visit.id,
        patientId: patientId,
        prepare: writeAll,
        refreshKey: cardKey,
        onSubmitted: reloadStatus,
        describeLine: describeLine,
        onBusyChange: setErxBusy
    }));
    const dialogs = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3OnFU.default), {
        open: leaveConfirm,
        onOpenChange: (open)=>{
            if (!open) setLeaveConfirm(false);
        },
        title: t('visit.erx.leaveTitle'),
        description: t('visit.erx.leaveBody'),
        confirmLabel: t('common.actions.leave'),
        cancelLabel: t('visit.erx.stayLabel'),
        confirmTestId: "visit-rx-correction-leave-ok",
        cancelTestId: "visit-rx-correction-leave-cancel",
        "data-testid": "visit-rx-correction-leave-confirm",
        onConfirm: ()=>{
            setLeaveConfirm(false);
            close();
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3OnFU.default), {
        open: !!orderToCancel,
        onOpenChange: (open)=>{
            if (!open) setOrderToCancel(null);
        },
        title: orderToCancel ? t('visit.orders.cancelNamed', {
            name: orderName(orderToCancel.description)
        }) : t('visit.orders.cancelTitle'),
        description: t('visit.orders.cancelBody'),
        confirmLabel: t('visit.orders.cancelAction'),
        cancelLabel: t('common.actions.back'),
        destructive: true,
        confirmTestId: "visit-rx-correction-order-cancel-ok",
        cancelTestId: "visit-rx-correction-order-cancel-back",
        "data-testid": "visit-rx-correction-order-cancel-confirm",
        onConfirm: ()=>{
            if (orderToCancel) cancelOrder(orderToCancel);
        }
    }));
    if (isMobile) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", null, (0, $6xvbB.CSS_VARS) + (0, $6xvbB.MOBILE_CSS) + $49c99466dee6cafa$var$PHONE_CSS), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: true,
        onClose: requestClose,
        title: title,
        fullHeight: true,
        snap: 1,
        closeLabel: t('common.actions.close'),
        "data-testid": "visit-rx-correction-sheet",
        "data-appointment-id": visit.id,
        "data-mode": sending ? 'send' : 'correct'
    }, lastDay && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-rx-correction-window",
        style: {
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).mute,
            marginBottom: '0.5rem'
        }
    }, t('visit.erx.correction.until', {
        date: formatDate(lastDay, 'medium')
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 12,
            paddingBottom: '0.5rem'
        }
    }, body)), dialogs);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'fixed',
            inset: 0,
            zIndex: $49c99466dee6cafa$var$SHEET_Z,
            background: 'rgba(28,27,24,.45)',
            backdropFilter: 'blur(3px)'
        },
        onClick: requestClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: panelRef,
        role: "dialog",
        "aria-modal": "true",
        "aria-label": title,
        tabIndex: -1,
        "data-testid": "visit-rx-correction-sheet",
        "data-appointment-id": visit.id,
        "data-mode": sending ? 'send' : 'correct',
        onClick: (e)=>e.stopPropagation(),
        style: {
            position: 'absolute',
            insetBlock: 0,
            insetInlineStart: 0,
            width: 'min(640px, 94vw)',
            background: (0, $jTCZr.CT).surface,
            borderInlineEnd: `1px solid ${(0, $jTCZr.CT).border}`,
            outline: 'none',
            display: 'flex',
            flexDirection: 'column',
            boxShadow: '0 0 40px rgba(0,0,0,.18)',
            animation: 'fadeUp .18s ease'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '14px 16px',
            borderBottom: `1px solid ${(0, $jTCZr.CT).border}`,
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": "true",
        style: {
            width: 24,
            height: 24,
            borderRadius: 7,
            display: 'grid',
            placeItems: 'center',
            background: (0, $jTCZr.CT).accentSoft,
            color: (0, $jTCZr.CT).accentInk,
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).edit, {
        width: 13,
        height: 13
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.84375rem',
            fontWeight: 600,
            color: (0, $jTCZr.CT).ink
        }
    }, title), lastDay && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visit-rx-correction-window",
        style: {
            fontSize: '0.6875rem',
            color: (0, $jTCZr.CT).mute
        }
    }, t('visit.erx.correction.until', {
        date: formatDate(lastDay, 'medium')
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: requestClose,
        disabled: closing,
        "aria-label": t('common.actions.close'),
        "data-testid": "visit-rx-correction-close",
        style: {
            background: 'none',
            border: 'none',
            cursor: closing ? 'default' : 'pointer',
            color: (0, $jTCZr.CT).mute,
            display: 'grid',
            placeItems: 'center',
            width: 26,
            height: 26,
            borderRadius: 7
        }
    }, closing ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 14
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.I).close, {
        width: 15,
        height: 15
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            overflowY: 'auto',
            padding: '14px 16px 24px',
            display: 'flex',
            flexDirection: 'column',
            gap: 12
        }
    }, body))), dialogs);
}

});
parcelRegister("8qirc", function(module, exports) {

$parcel$export(module.exports, "default", () => $064eb81477d0449c$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $hZDga = parcelRequire("hZDga");

var $jTCZr = parcelRequire("jTCZr");

var $QG9Z3 = parcelRequire("QG9Z3");
var $8g4t5 = parcelRequire("8g4t5");
var $e5Ore = parcelRequire("e5Ore");
var $6TdpC = parcelRequire("6TdpC");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $d2Zvn = parcelRequire("d2Zvn");

var $6xvbB = parcelRequire("6xvbB");
// ─────────────────────────────────────────────────────────────────────────────
// «افزودن دستور» on a past visit — the دستورات tab's catalogue search, in the
// past-visit sheet (RxCorrectionSheet; K1, 2026-10-10).
//
// The same question as the visit room's picker (searchOrderCatalog): a type
// first — آزمایشگاه، تصویربرداری، اقدام درمانی — then nothing until two letters,
// one server page per pause in typing, scoped to the clinic of the visit by its
// appointment. A result says whether تأمین lists the service, and one already on
// the visit says so instead of offering a second row. Pressing a result adds it
// (`onAdd(entry)`): there is no form — an order added to a past visit is routine,
// one session, as the doctor would have written it then.
// ─────────────────────────────────────────────────────────────────────────────
const $064eb81477d0449c$var$ORDER_KINDS = [
    'lab',
    'imaging',
    'procedure'
];
const $064eb81477d0449c$var$DEBOUNCE_MS = 250;
function $064eb81477d0449c$export$2e2bcd8739ae039({ appointmentId: appointmentId, insurer: insurer, orders: orders, onAdd: onAdd, adding: adding = null, disabled: disabled = false, testIdPrefix: testIdPrefix = 'visit-order', inputId: inputId }) {
    const { t: t, readsPersianData: readsPersianData, locale: locale } = (0, $LNQP4.default)();
    const [kind, setKind] = (0, $acw62.useState)('lab');
    const [query, setQuery] = (0, $acw62.useState)('');
    const [search, setSearch] = (0, $acw62.useState)({
        state: 'idle',
        entries: [],
        total: 0
    });
    const [moreLoading, setMoreLoading] = (0, $acw62.useState)(false);
    const [attempt, setAttempt] = (0, $acw62.useState)(0);
    const inputRef = (0, $acw62.useRef)(null);
    const live = (0, $acw62.useRef)(0);
    // ── the search: nothing until two letters, then a debounced server page ──
    (0, $acw62.useEffect)(()=>{
        const q = query.trim();
        const mine = ++live.current;
        if (q.length < (0, $6xvbB.ORDER_MIN_QUERY)) {
            setSearch({
                state: q ? 'short' : 'idle',
                entries: [],
                total: 0
            });
            return undefined;
        }
        setSearch((s)=>({
                ...s,
                state: 'loading'
            }));
        const h = setTimeout(()=>{
            (0, $6xvbB.searchOrderCatalog)({
                query: q,
                orderType: kind,
                appointmentId: appointmentId
            }).then(({ entries: entries, total: total })=>{
                if (mine === live.current) setSearch({
                    state: 'ready',
                    entries: entries || [],
                    total: total || 0
                });
            }).catch((err)=>{
                if (mine !== live.current) return;
                // Said, not swallowed: an empty list would read as «not in the catalogue».
                console.error('[orders] catalogue search failed:', err);
                setSearch({
                    state: 'error',
                    entries: [],
                    total: 0
                });
            });
        }, $064eb81477d0449c$var$DEBOUNCE_MS);
        return ()=>clearTimeout(h);
    }, [
        query,
        kind,
        appointmentId,
        attempt
    ]);
    const loadMore = (0, $acw62.useCallback)(()=>{
        const mine = live.current;
        setMoreLoading(true);
        (0, $6xvbB.searchOrderCatalog)({
            query: query.trim(),
            orderType: kind,
            appointmentId: appointmentId,
            offset: search.entries.length
        }).then(({ entries: entries, total: total })=>{
            if (mine !== live.current) return;
            setSearch((s)=>({
                    ...s,
                    entries: [
                        ...s.entries,
                        ...entries || []
                    ],
                    total: total || s.total
                }));
        }).catch((err)=>console.error('[orders] catalogue search (more) failed:', err)).finally(()=>setMoreLoading(false));
    }, [
        query,
        kind,
        appointmentId,
        search.entries.length
    ]);
    // Another type is another search: the last type's rows never stand under it.
    const chooseKind = (k)=>{
        if (k === kind) return;
        setSearch((s)=>({
                ...s,
                entries: [],
                total: 0
            }));
        setKind(k);
    };
    const p = testIdPrefix;
    const types = (0, $6xvbB.ORDER_TYPE_FA)(t);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${p}-types`,
        style: {
            display: 'flex',
            gap: 4,
            flexWrap: 'wrap'
        }
    }, $064eb81477d0449c$var$ORDER_KINDS.map((k)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            key: k,
            type: "button",
            size: "sm",
            variant: kind === k ? 'default' : 'outline',
            "aria-pressed": kind === k,
            onClick: ()=>chooseKind(k),
            "data-testid": `${p}-type-${k}`
        }, types[k]))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            background: (0, $jTCZr.CT).surface,
            border: `1px solid ${query ? (0, $jTCZr.C).navy : (0, $jTCZr.CT).border}`,
            borderRadius: 10,
            padding: '0 10px',
            minHeight: 36
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e5Ore.default), {
        size: 14,
        color: (0, $jTCZr.CT).ink2,
        "aria-hidden": true,
        style: {
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ref: inputRef,
        id: inputId,
        value: query,
        onChange: (e)=>setQuery(e.target.value),
        onKeyDown: (e)=>{
            if (e.key === 'Escape' && query) {
                setQuery('');
                e.stopPropagation();
            }
        },
        placeholder: t('visit.orders.searchCatalog'),
        "aria-label": t('visit.orders.searchCatalog'),
        autoComplete: "off",
        "data-testid": `${p}-search`,
        style: {
            flex: 1,
            minWidth: 0,
            border: 'none',
            outline: 'none',
            background: 'transparent',
            fontFamily: 'inherit',
            fontSize: '0.8125rem',
            color: (0, $jTCZr.CT).ink,
            minHeight: 34
        }
    }), search.state === 'loading' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 14,
        color: (0, $jTCZr.CT).accent,
        thickness: 2
    }), query && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        type: "button",
        variant: "ghost",
        size: "icon",
        onClick: ()=>{
            setQuery('');
            inputRef.current?.focus?.();
        },
        "aria-label": t('common.actions.clearSearch'),
        "data-testid": `${p}-search-clear`,
        className: "h-7 w-7 shrink-0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
        size: 13,
        "aria-hidden": true
    }))), search.state === 'idle' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${p}-search-idle`,
        "data-state": "idle",
        style: {
            fontSize: '0.71875rem',
            color: (0, $jTCZr.CT).ink2,
            lineHeight: 1.7
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontWeight: 600,
            color: (0, $jTCZr.CT).ink
        }
    }, t('visit.orders.searchTitle')), " \u2014 ", t('visit.orders.searchBody')) : search.state === 'short' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${p}-search-short`,
        style: {
            fontSize: '0.71875rem',
            color: (0, $jTCZr.CT).ink2
        }
    }, t('visit.orders.keepTyping')) : search.state === 'error' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${p}-search-error`,
        "data-state": "error",
        role: "alert",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '8px 10px',
            borderRadius: 8,
            background: (0, $jTCZr.CT).dangerSoft
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $QG9Z3.default), {
        size: 15,
        color: (0, $jTCZr.CT).dangerInk,
        "aria-hidden": true,
        style: {
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            fontSize: '0.75rem',
            fontWeight: 600,
            color: (0, $jTCZr.CT).dangerInk
        }
    }, t('visit.orders.catalogSearchFailed')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        type: "button",
        variant: "subtle",
        size: "sm",
        onClick: ()=>setAttempt((n)=>n + 1),
        "data-testid": `${p}-search-retry`,
        className: "shrink-0"
    }, t('common.actions.retry'))) : search.state === 'ready' && search.entries.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${p}-no-results`,
        "data-state": "no-results",
        style: {
            padding: 12,
            textAlign: 'center',
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).ink2
        }
    }, t('visit.orders.noCatalogMatch')) : search.entries.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${p}-results`,
        "data-state": "content",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 6
        }
    }, search.entries.map((e)=>{
        const names = (0, $6xvbB.orderNameLines)(e, readsPersianData, (0, $6xvbB.ownCatalogName)(e, locale));
        const already = (0, $d2Zvn.isAlreadyOrdered)(orders, e.orderType, e.name);
        const sub = e.orderType === 'imaging' ? e.bodyPart || '' : e.code ? `${e.codeSystem || ''} ${e.code}`.trim() : '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            key: e.id || `${e.orderType}:${e.name}`,
            type: "button",
            variant: "outline",
            onClick: ()=>onAdd(e),
            disabled: already || disabled,
            "data-testid": `${p}-result-${e.id}`,
            "data-added": already || undefined,
            className: "w-full h-auto justify-start text-start gap-2 px-3 py-2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                flex: 1,
                minWidth: 0,
                display: 'flex',
                flexDirection: 'column',
                gap: 2
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "auto",
            style: {
                fontSize: '0.8125rem',
                fontWeight: 700,
                color: (0, $jTCZr.CT).ink,
                whiteSpace: 'normal',
                overflowWrap: 'anywhere'
            }
        }, names.primary), sub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "auto",
            style: {
                fontSize: '0.71875rem',
                fontWeight: 400,
                color: (0, $jTCZr.CT).ink2,
                whiteSpace: 'normal',
                overflowWrap: 'anywhere'
            }
        }, sub)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xvbB.InsurerListChip), {
            drug: {
                id: e.id
            },
            listed: (0, $6xvbB.taminFlagOf)(e, insurer),
            both: true,
            size: 10.5,
            testid: `${p}-result-coverage-${e.id}`,
            hint: t('visit.orders.outTaminHint')
        }), already ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.65625rem',
                fontWeight: 700,
                padding: '1px 6px',
                borderRadius: 4,
                background: (0, $jTCZr.CT).goodSoft,
                color: (0, $jTCZr.CT).goodInk,
                whiteSpace: 'nowrap'
            }
        }, t('visit.orders.added')) : adding != null && adding === e.id ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
            size: 13,
            color: (0, $jTCZr.CT).accent,
            thickness: 2
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                display: 'inline-flex',
                alignItems: 'center',
                gap: 4,
                fontSize: '0.71875rem',
                fontWeight: 600,
                color: (0, $jTCZr.CT).accentInk,
                whiteSpace: 'nowrap'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8g4t5.default), {
            size: 13,
            "aria-hidden": true
        }), " ", t('common.actions.add')));
    }), search.total > search.entries.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${p}-more-results`,
        style: {
            display: 'flex',
            justifyContent: 'center'
        }
    }, moreLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZDga.Spinner), {
        size: 14,
        color: (0, $jTCZr.CT).accent,
        thickness: 2
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        type: "button",
        variant: "link",
        size: "sm",
        onClick: loadMore
    }, t('visit.rx.moreResults', {
        shown: search.entries.length,
        total: search.total
    })))) : null);
}

});




parcelRegister("ky7vJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e797c45ee6cbcd0d$export$2e2bcd8739ae039);
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");
parcelRequire("7sS0P");
var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $7gSBD = parcelRequire("7gSBD");
var $h4ZeB = parcelRequire("h4ZeB");

var $7LBYc = parcelRequire("7LBYc");

var $k2reB = parcelRequire("k2reB");
var $4CVxl = parcelRequire("4CVxl");
var $chm1L = parcelRequire("chm1L");

var $eVM84 = parcelRequire("eVM84");

var $0xK7i = parcelRequire("0xK7i");

var $gdEay = parcelRequire("gdEay");

var $3OnFU = parcelRequire("3OnFU");

var $gcegg = parcelRequire("gcegg");

var $145k1 = parcelRequire("145k1");

var $01rTJ = parcelRequire("01rTJ");

var $xQteh = parcelRequire("xQteh");
const $e797c45ee6cbcd0d$var$DELETE_OBSERVATION = `mutation DeleteObservation($id: ID!) { deleteObservation(id: $id) }`;
// «مشاهدات» — the record's measured values on the phone. Latest vitals first,
// then panel chips that filter the analyte list; each analyte taps through to a
// trend + history sheet. Deleting a reading is destructive ⇒ ConfirmDialog (§6).
// Upload adds the document and, on «بارگذاری و استخراج», reads its values for the
// doctor to review before any enters the record (useClinicalFiles).
//
// Composition only: the grouping/counting/ordering all come from
// `lib/observations`, the same module the desktop tab uses, so the two surfaces
// can never disagree about which panel a test belongs to (§1.1).
const $e797c45ee6cbcd0d$var$MobilePatientObservations = ({ p: p, patientId: patientId, onRefresh: onRefresh })=>{
    const { t: t, formatDigits: formatDigits, formatList: formatList } = (0, $LNQP4.default)();
    const toast = (0, $7LBYc.useOptionalToast)();
    const vitals = (0, $xQteh.useVitalSeries)(patientId);
    const documents = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $gdEay.sortByDocumentDate)(p.clinicalFiles || []), [
        p.clinicalFiles
    ]);
    const files = (0, $0xK7i.useClinicalFiles)({
        patient: {
            ...p,
            id: p.id || patientId
        },
        files: documents,
        onChanged: onRefresh
    });
    const [activeCategory, setActiveCategory] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [detailItem, setDetailItem] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [pendingDelete, setPendingDelete] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const seriesMap = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $01rTJ.buildSeriesMap)(p.clinicalObservations), [
        p.clinicalObservations
    ]);
    const counts = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $01rTJ.countByCategory)(seriesMap), [
        seriesMap
    ]);
    // `flagged` per panel is the same derivation the desktop tab's hook makes, so
    // the two surfaces cannot mark different panels as holding a bad result.
    const panels = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $01rTJ.categoriesWithData)(counts).map((c)=>({
                ...c,
                flagged: (0, $01rTJ.flaggedInCategory)(seriesMap, c.id)
            })), [
        counts,
        seriesMap
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (activeCategory) return;
        setActiveCategory((0, $01rTJ.defaultCategory)(counts));
    }, [
        counts
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const tests = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $01rTJ.testsInCategory)(seriesMap, activeCategory), [
        seriesMap,
        activeCategory
    ]);
    const hasAny = Object.keys(seriesMap).length > 0;
    const confirmDelete = ()=>(0, $eVM84.bffMutation)($e797c45ee6cbcd0d$var$DELETE_OBSERVATION, {
            id: pendingDelete.id
        }).then(()=>{
            setDetailItem(null);
            onRefresh();
        })// A confirmed delete that quietly fails reads as success (§7 / §14.3).
        .catch(()=>toast.error(t('patient.obs.deleteFailed')));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "observations-content",
        "data-state": hasAny ? 'content' : 'empty',
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        size: "lg",
        onClick: ()=>files.openUpload(),
        "data-testid": "observations-upload",
        className: "w-full min-h-11 gap-2 bg-gradient-brand font-bold"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $chm1L.default), {
        size: 16,
        "aria-hidden": true
    }), " ", t('patient.files.uploadAndAnalyse')), !vitals.loading && !vitals.error && vitals.flagged.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "status",
        "data-testid": "observations-out-of-range",
        style: {
            background: (0, $jTCZr.CT).dangerSoft,
            border: `1px solid ${(0, $jTCZr.CT).danger}`,
            borderRadius: '0.5rem',
            padding: '0.625rem 0.75rem',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).dangerInk,
            flexWrap: 'wrap'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: '0.5rem',
            height: '0.5rem',
            borderRadius: '50%',
            background: (0, $jTCZr.CT).danger,
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontWeight: 700
        }
    }, t('patient.obs.outOfRangeCount', {
        count: formatDigits(vitals.flagged.length)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, formatList(vitals.flagged.map((d)=>t(d.labelKey))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gcegg.VitalsStrip), {
        vitals: (0, $xQteh.vitalsGlance)(vitals.byLoinc),
        testId: "observations-vitals"
    }), p.bmi != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "observations-bmi",
        style: {
            background: (0, $jTCZr.C).card,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: '0.75rem',
            padding: '0.75rem 0.875rem',
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $k2reB.default), {
        size: 18,
        color: (0, $jTCZr.CT).accent,
        strokeWidth: 2,
        "aria-hidden": true,
        style: {
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.6875rem',
            color: (0, $jTCZr.C).textMuted,
            fontWeight: 600
        }
    }, t('patient.vitals.bmi')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'baseline',
            gap: '0.5rem',
            marginTop: '0.125rem',
            flexWrap: 'wrap'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "ltr",
        style: {
            fontSize: '1.25rem',
            fontWeight: 800,
            color: (0, $jTCZr.C).textPrimary
        }
    }, formatDigits(p.bmi.toFixed(1))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.625rem',
            color: (0, $jTCZr.C).textMuted
        }
    }, "kg/m\xb2"), p.lastWeight && p.height && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.625rem',
            color: (0, $jTCZr.C).textMuted
        }
    }, formatDigits(p.lastWeight), " kg \xb7 ", formatDigits(p.height), " cm")))), panels.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "observations-panels",
        style: {
            overflowX: 'auto',
            display: 'flex',
            gap: '0.375rem',
            scrollbarWidth: 'none'
        }
    }, panels.map((cat)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $h4ZeB.default), {
            key: cat.id,
            // A flagged panel is marked with a danger dot composed into the
            // chip's own label slot — the kit has no `flagged` variant and
            // this needs no new one.
            label: cat.flagged ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '0.25rem'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                "data-testid": `observations-panel-flag-${cat.id}`,
                "aria-label": t('patient.obs.outOfRange'),
                style: {
                    width: '0.375rem',
                    height: '0.375rem',
                    borderRadius: '50%',
                    background: (0, $jTCZr.CT).danger,
                    flexShrink: 0
                }
            }), cat.label) : cat.label,
            count: formatDigits(cat.count),
            active: activeCategory === cat.id,
            onClick: ()=>setActiveCategory(cat.id),
            "data-testid": `observations-panel-${cat.id}`
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "observations-list",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem'
        }
    }, tests.map((test, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gcegg.ObservationRow), {
            key: test.display,
            test: test,
            onOpen: ()=>setDetailItem(test),
            testId: `observations-row-${i}`
        })))), !hasAny && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        "data-testid": "observations-empty",
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4CVxl.default), {
            size: 44,
            color: (0, $jTCZr.C).textMuted,
            strokeWidth: 1.5,
            "aria-hidden": true
        }),
        title: t('patient.obs.none'),
        description: t('patient.obs.uploadHint')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $145k1.ObservationDetailSheet), {
        test: detailItem,
        onClose: ()=>setDetailItem(null),
        onDeleteRequest: (r)=>setPendingDelete(r)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3OnFU.default), {
        open: !!pendingDelete,
        onOpenChange: (o)=>{
            if (!o) setPendingDelete(null);
        },
        title: t('patient.obs.deleteValue'),
        message: t('patient.obs.deleteConfirm'),
        confirmLabel: t('common.actions.delete'),
        cancelLabel: t('common.actions.cancel'),
        destructive: true,
        onConfirm: confirmDelete
    }), files.overlays);
};
var $e797c45ee6cbcd0d$export$2e2bcd8739ae039 = $e797c45ee6cbcd0d$var$MobilePatientObservations;

});
parcelRegister("145k1", function(module, exports) {

$parcel$export(module.exports, "ObservationDetailSheet", () => $9bde5d8958d2209d$export$4fa2d36987272d1b);
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");
parcelRequire("7sS0P");
var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $cZOyb = parcelRequire("cZOyb");
var $aJ1FU = parcelRequire("aJ1FU");
var $lffTJ = parcelRequire("lffTJ");
var $fAR2n = parcelRequire("fAR2n");
var $3Amwd = parcelRequire("3Amwd");
var $iygI2 = parcelRequire("iygI2");
var $a7Rbr = parcelRequire("a7Rbr");

var $94UvM = parcelRequire("94UvM");
var $lUsTt = parcelRequire("lUsTt");

var $eVM84 = parcelRequire("eVM84");

var $gcegg = parcelRequire("gcegg");

var $gdEay = parcelRequire("gdEay");

var $15wQy = parcelRequire("15wQy");

var $kyxc1 = parcelRequire("kyxc1");
// ─────────────────────────────────────────────────────────────────────────────
// Patient-record sheets — every task/overlay is the kit BottomSheet (§6), every
// field a kit input (≥1rem font ⇒ no iOS zoom), every action the kit Button.
// RecordFormSheet & ObservationDetailSheet are presentational (events via callbacks);
// EditPatientSheet is a self-contained editor. Destructive rows never delete
// inline — they ask the parent, which raises a ConfirmDialog (§6).
// ─────────────────────────────────────────────────────────────────────────────
const $9bde5d8958d2209d$var$primaryCta = 'w-full min-h-11 bg-gradient-brand font-extrabold';
const $9bde5d8958d2209d$export$a89d1549ab715ef1 = ({ open: open, title: title, fields: fields, onSave: onSave, onClose: onClose, saving: saving, submitLabel: submitLabel })=>{
    const { t: t } = (0, $LNQP4.default)();
    const submitLabelText = submitLabel ?? t('common.actions.save');
    const [form, setForm] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({});
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return;
        const init = {};
        fields.forEach((f)=>{
            init[f.key] = f.default || '';
        });
        setForm(init);
    }, [
        open
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const set = (k)=>(e)=>setForm((f)=>({
                    ...f,
                    [k]: e.target.value
                }));
    // Dirty = anything typed that the schema did not put there. A sheet opened by
    // mistake still shuts in one tap; a half-written medication asks first —
    // `onClose` was unconditional, and on a phone the sheet has four dismissals
    // including an accidental edge-swipe.
    const dirty = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>fields.some((f)=>(form[f.key] ?? '') !== (f.default || '')), [
        form,
        fields
    ]);
    const { requestClose: requestClose, guard: guard } = (0, $15wQy.useDirtyClose)(dirty, onClose);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: open,
        onClose: requestClose,
        title: title,
        closeLabel: t('common.actions.close')
    }, guard, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.875rem'
        }
    }, fields.map((f)=>f.type === 'select' ? // A schema that omits `placeholder` would otherwise land on the
        // framework's own Persian default, which no language switch reaches.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fAR2n.default), {
            key: f.key,
            label: f.label,
            value: form[f.key] || '',
            onChange: set(f.key),
            options: f.options || [],
            placeholder: f.placeholder ?? t('common.actions.select')
        }) : f.type === 'textarea' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $iygI2.default), {
            key: f.key,
            label: f.label,
            value: form[f.key] || '',
            onChange: set(f.key),
            placeholder: f.placeholder,
            rows: 4
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
            key: f.key,
            label: f.label,
            value: form[f.key] || '',
            onChange: set(f.key),
            placeholder: f.placeholder,
            type: f.type || 'text',
            dir: f.type === 'date' ? 'ltr' : 'rtl'
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        size: "lg",
        className: $9bde5d8958d2209d$var$primaryCta,
        disabled: saving,
        onClick: ()=>onSave(form),
        "data-testid": "record-sheet-save"
    }, saving ? t('common.state.saving') : submitLabelText)));
};
const $9bde5d8958d2209d$export$4fa2d36987272d1b = ({ test: test, onClose: onClose, onDeleteRequest: onDeleteRequest })=>{
    const { t: t, formatDate: formatDate, formatDigits: formatDigits } = (0, $LNQP4.default)();
    if (!test) return null;
    const readings = [
        ...test.readings
    ].sort((a, b)=>(b.date || '').localeCompare(a.date || ''));
    const last = readings[0];
    const abn = (v)=>[
            'abnormal',
            'ABNORMAL',
            'critical',
            'CRITICAL'
        ].includes(v);
    const isAbn = abn(last?.status);
    const points = test.readings.slice(-8).map((r)=>r.value);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: !!test,
        onClose: onClose,
        title: test.display,
        closeLabel: t('common.actions.close')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            textAlign: 'center',
            marginBottom: '1rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '2.5rem',
            fontWeight: 800,
            color: isAbn ? (0, $jTCZr.CT).danger : (0, $jTCZr.C).textPrimary,
            lineHeight: 1
        }
    }, last?.value != null ? formatDigits(last.value) : "\u2014"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.8125rem',
            color: (0, $jTCZr.C).textMuted,
            marginTop: '0.25rem'
        }
    }, test.unit || ''), isAbn && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'inline-block',
            fontSize: '0.6875rem',
            fontWeight: 700,
            color: (0, $jTCZr.CT).dangerInk,
            background: (0, $jTCZr.CT).dangerSoft,
            padding: '0.1875rem 0.625rem',
            borderRadius: '0.75rem',
            marginTop: '0.375rem'
        }
    }, t('patient.obs.outOfRange'))), points.length >= 2 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            justifyContent: 'center',
            marginBottom: '1rem',
            padding: '0.75rem',
            background: (0, $jTCZr.C).bg,
            borderRadius: '0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3Amwd.default), {
        points: points,
        width: 260,
        height: 48,
        tone: isAbn ? 'danger' : 'accent'
    })), readings.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.6875rem',
            fontWeight: 700,
            color: (0, $jTCZr.C).textMuted,
            textTransform: 'uppercase',
            letterSpacing: '0.06em',
            marginBottom: '0.5rem'
        }
    }, t('patient.obs.history')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.375rem'
        }
    }, readings.map((r, i)=>{
        const prev = readings[i + 1];
        const dlt = prev && !Number.isNaN(parseFloat(r.value)) && !Number.isNaN(parseFloat(prev.value)) ? parseFloat(r.value) - parseFloat(prev.value) : null;
        const rAbn = abn(r.status);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: r.id || i,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.625rem',
                padding: '0.625rem 0.75rem',
                background: (0, $jTCZr.C).bg,
                borderRadius: '0.5625rem',
                border: `1px solid ${rAbn ? (0, $jTCZr.CT).dangerSoft : (0, $jTCZr.C).border}`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1,
                fontSize: '0.75rem',
                color: (0, $jTCZr.C).textMuted
            }
        }, (0, $gcegg.faDate)(r.date, formatDate) || "\u2014"), dlt != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.6875rem',
                fontWeight: 600,
                color: dlt > 0 ? (0, $jTCZr.CT).danger : (0, $jTCZr.CT).good
            }
        }, dlt > 0 ? "\u25B2" : "\u25BC", formatDigits(Math.abs(dlt).toFixed(1))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '1rem',
                fontWeight: 700,
                color: rAbn ? (0, $jTCZr.CT).danger : (0, $jTCZr.C).textPrimary,
                minWidth: '3rem',
                textAlign: 'end'
            }
        }, formatDigits(r.value), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.625rem',
                fontWeight: 400,
                color: (0, $jTCZr.C).textMuted
            }
        }, test.unit)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            size: "icon",
            className: "h-11 w-11 text-muted-foreground shrink-0",
            "aria-label": t('patient.obs.deleteValueShort'),
            "data-testid": `observations-reading-delete-${r.id}`,
            onClick: ()=>onDeleteRequest?.(r)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lUsTt.default), {
            size: 14,
            "aria-hidden": true
        })));
    }))));
};
const $9bde5d8958d2209d$export$9bd51fc9a60d7978 = ({ file: file, onClose: onClose, onPreview: onPreview, onDeleteRequest: onDeleteRequest })=>{
    const { t: t, formatDigits: formatDigits } = (0, $LNQP4.default)();
    if (!file) return null;
    const rows = (0, $gdEay.parseOcrRows)(file.ocrContent);
    // A narrative report parses into `raw` rows only — it is prose, and reads as
    // prose, not as a one-cell-per-sentence table.
    const structured = (0, $gdEay.hasStructuredRows)(rows);
    const hasContent = !!file.ocrContent;
    const th = {
        textAlign: 'start',
        fontSize: '0.625rem',
        fontWeight: 700,
        color: (0, $jTCZr.C).textMuted,
        background: (0, $jTCZr.CT).surface2,
        padding: '0.375rem 0.5rem',
        borderBottom: `1px solid ${(0, $jTCZr.C).border}`
    };
    const td = {
        padding: '0.375rem 0.5rem',
        borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
        color: (0, $jTCZr.C).textSecondary
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: !!file,
        onClose: onClose,
        title: t('patient.files.detailTitle')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "files-detail-sheet",
        "data-state": hasContent ? 'content' : 'empty',
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: "ltr",
        style: {
            fontSize: '0.8125rem',
            fontWeight: 700,
            color: (0, $jTCZr.C).textPrimary,
            wordBreak: 'break-word',
            textAlign: 'start'
        }
    }, file.fileName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: '0.375rem',
            alignItems: 'center',
            flexWrap: 'wrap',
            marginTop: '0.25rem'
        }
    }, file.createdAt && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.625rem',
            color: (0, $jTCZr.C).textMuted
        }
    }, (0, $gcegg.faDate)(file.createdAt)), structured && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gcegg.Pill), {
        tone: "muted"
    }, t('patient.files.testCount', {
        count: formatDigits(rows.filter((r)=>r.testName).length)
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "lg",
        className: "w-full min-h-11 gap-2",
        "data-testid": "files-detail-preview",
        onClick: ()=>onPreview?.(file)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $94UvM.default), {
        size: 16,
        "aria-hidden": true
    }), " ", t('patient.files.viewImage')), structured && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            borderRadius: '0.5rem',
            border: `1px solid ${(0, $jTCZr.C).border}`,
            overflowX: 'auto'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("table", {
        "data-testid": "files-detail-table",
        style: {
            width: '100%',
            borderCollapse: 'collapse',
            fontSize: '0.6875rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        style: th,
        scope: "col"
    }, t('patient.orderType.lab')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        style: {
            ...th,
            textAlign: 'end'
        },
        scope: "col"
    }, t('patient.obs.resultHeader')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        style: th,
        scope: "col"
    }, t('patient.obs.referenceRange')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        style: th,
        scope: "col"
    }, t('common.labels.status')))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tbody", null, rows.map((r, i)=>{
        if (r.raw) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", {
            key: i
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            colSpan: 4,
            style: {
                ...td,
                color: (0, $jTCZr.C).textMuted
            }
        }, r.raw));
        const crit = r.status === 'critical';
        const abnormal = r.status !== 'normal' && r.status !== 'unknown';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", {
            key: i,
            style: {
                background: crit ? (0, $jTCZr.CT).dangerSoft : abnormal ? (0, $jTCZr.C).amberLight : 'transparent'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: {
                ...td,
                color: (0, $jTCZr.C).textPrimary,
                fontWeight: abnormal ? 700 : 400
            }
        }, r.testName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            dir: "ltr",
            style: {
                ...td,
                textAlign: 'end',
                fontVariantNumeric: 'tabular-nums',
                fontWeight: abnormal ? 700 : 400,
                color: crit ? (0, $jTCZr.CT).danger : abnormal ? (0, $jTCZr.CT).warnInk : (0, $jTCZr.C).textPrimary
            }
        }, formatDigits(r.value), " ", r.unit || ''), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            dir: "ltr",
            style: {
                ...td,
                color: (0, $jTCZr.C).textMuted,
                textAlign: 'start'
            }
        }, r.refRange ? formatDigits(r.refRange) : "\u2014"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: td
        }, abnormal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gcegg.Pill), {
            tone: crit ? 'danger' : 'amber'
        }, t(crit ? 'visit.vitals.critical' : 'visit.vitals.abnormal')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gcegg.Pill), {
            tone: "good"
        }, t('patient.obs.normal'))));
    })))), !structured && file.ocrContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: "ltr",
        style: {
            borderRadius: '0.5rem',
            border: `1px solid ${(0, $jTCZr.C).border}`,
            background: (0, $jTCZr.CT).surface2,
            padding: '0.625rem 0.75rem',
            fontSize: '0.6875rem',
            color: (0, $jTCZr.C).textSecondary,
            lineHeight: 1.8,
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
            textAlign: 'start'
        }
    }, file.ocrContent), !hasContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            borderRadius: '0.5rem',
            border: `1px solid ${(0, $jTCZr.C).border}`,
            background: (0, $jTCZr.CT).surface2,
            padding: '0.75rem',
            fontSize: '0.6875rem',
            color: (0, $jTCZr.C).textMuted
        }
    }, t('patient.empty.noContent')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "lg",
        className: "w-full min-h-11 gap-2",
        style: {
            color: (0, $jTCZr.CT).danger,
            borderColor: (0, $jTCZr.CT).dangerSoft
        },
        "data-testid": "files-detail-delete",
        onClick: ()=>onDeleteRequest?.(file)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lUsTt.default), {
        size: 15,
        "aria-hidden": true
    }), " ", t('patient.files.delete'))));
};
// ── Edit patient — self-contained editor over UPDATE_PATIENT ──────────────────
const $9bde5d8958d2209d$var$UPDATE_PATIENT = `mutation UpdatePatient($id: ID!, $input: UpdatePatientInput!) {
  updatePatient(id: $id, input: $input) { id name phone birthDate bloodType insurance job lastWeight height bmi status }
}`;
const $9bde5d8958d2209d$var$BLOOD_TYPES = [
    'A+',
    'A-',
    'B+',
    'B-',
    'AB+',
    'AB-',
    'O+',
    'O-'
];
const $9bde5d8958d2209d$var$INSURANCE_OPTS = (t)=>[
        {
            value: 'social',
            label: t('patient.insurance.social')
        },
        {
            value: 'health',
            label: t('patient.insurance.health')
        },
        {
            value: 'military',
            label: t('patient.insurance.military')
        },
        {
            value: 'other',
            label: t('patient.insurance.other')
        }
    ];
const $9bde5d8958d2209d$export$826bc793596d1870 = ({ patient: patient, open: open, onClose: onClose, onSaved: onSaved })=>{
    const { t: t } = (0, $LNQP4.default)();
    // An EMPTY number starts on the clinic country's code (PM-0218); `undefined` —
    // no capabilities, an Iranian clinic — is the field's own default, as before.
    const { phoneCountry: phoneCountry } = (0, $kyxc1.useCountryDefaults)();
    const [form, setForm] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({});
    const [saving, setSaving] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [err, setErr] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return;
        setErr('');
        setForm({
            name: patient.name || '',
            phone: patient.phone || '',
            birthDate: patient.birthDate || '',
            bloodType: patient.bloodType || '',
            insurance: patient.insurance || '',
            job: patient.job || '',
            height: patient.height != null ? String(patient.height) : ''
        });
    }, [
        open
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const set = (k)=>(e)=>setForm((f)=>({
                    ...f,
                    [k]: e.target.value
                }));
    // The same comparison `handleSave` makes to build its patch: if there is
    // nothing to send, there is nothing to lose by closing.
    const dirty = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>form.name !== (patient.name || '') || form.phone !== (patient.phone || '') || form.birthDate !== (patient.birthDate || '') || form.bloodType !== (patient.bloodType || '') || form.insurance !== (patient.insurance || '') || form.job !== (patient.job || '') || (form.height || '') !== (patient.height != null ? String(patient.height) : ''), [
        form,
        patient
    ]);
    const { requestClose: requestClose, guard: guard } = (0, $15wQy.useDirtyClose)(dirty, onClose);
    const handleSave = async ()=>{
        setSaving(true);
        setErr('');
        try {
            const u = {};
            if (form.name !== (patient.name || '')) u.name = form.name;
            if (form.phone !== (patient.phone || '')) u.phone = form.phone;
            if (form.birthDate !== (patient.birthDate || '')) u.birthDate = form.birthDate;
            if (form.bloodType !== (patient.bloodType || '')) u.bloodType = form.bloodType;
            if (form.insurance !== (patient.insurance || '')) u.insurance = form.insurance;
            if (form.job !== (patient.job || '')) u.job = form.job;
            const nh = parseFloat(form.height);
            if (!Number.isNaN(nh) && nh !== patient.height) u.height = nh;
            if (!Object.keys(u).length) {
                onClose();
                return;
            }
            await (0, $eVM84.bffMutation)($9bde5d8958d2209d$var$UPDATE_PATIENT, {
                id: patient.id,
                input: u
            });
            onSaved();
            onClose();
        } catch (e) {
            setErr(e?.message || t('errors.save.edit'));
        } finally{
            setSaving(false);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: open,
        onClose: requestClose,
        title: t('patient.edit.title'),
        closeLabel: t('common.actions.close')
    }, guard, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.875rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
        label: t('common.labels.name'),
        value: form.name || '',
        onChange: set('name'),
        placeholder: t('visit.patient.fullName')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lffTJ.default), {
        label: t('common.labels.phone'),
        value: form.phone || '',
        key: phoneCountry || '',
        defaultCountry: phoneCountry,
        onChange: (phone)=>setForm((f)=>({
                    ...f,
                    phone: phone
                }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
        label: t('patient.edit.birthDate'),
        value: form.birthDate || '',
        onChange: set('birthDate'),
        placeholder: "1990-01-01",
        dir: "ltr"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
        label: t('visit.patient.occupation'),
        value: form.job || '',
        onChange: set('job'),
        placeholder: t('visit.patient.occupation')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fAR2n.default), {
        label: t('visit.patient.bloodType'),
        value: form.bloodType || '',
        onChange: set('bloodType'),
        options: $9bde5d8958d2209d$var$BLOOD_TYPES.map((bt)=>({
                value: bt,
                label: bt
            })),
        placeholder: t('common.actions.select')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fAR2n.default), {
        label: t('visit.patient.insurance'),
        value: form.insurance || '',
        onChange: set('insurance'),
        options: $9bde5d8958d2209d$var$INSURANCE_OPTS(t),
        placeholder: t('common.actions.select')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a7Rbr.default), {
        label: t('visit.vitals.height'),
        value: form.height || '',
        onChange: set('height'),
        placeholder: "175",
        type: "number",
        dir: "ltr"
    }), err && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.75rem',
            color: (0, $jTCZr.CT).danger,
            fontWeight: 600
        }
    }, err), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        size: "lg",
        className: $9bde5d8958d2209d$var$primaryCta,
        disabled: saving,
        onClick: handleSave,
        "data-testid": "patient-edit-save"
    }, saving ? t('common.state.saving') : t('common.actions.saveChanges'))));
};

});
parcelRegister("15wQy", function(module, exports) {

$parcel$export(module.exports, "useDirtyClose", () => $6ad2538fee34d7d1$export$db6b977dd1b3391f);

var $acw62 = parcelRequire("acw62");

var $3OnFU = parcelRequire("3OnFU");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
function $6ad2538fee34d7d1$export$db6b977dd1b3391f(dirty, onClose) {
    const [asking, setAsking] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // Read through refs so `requestClose` keeps one identity for the life of the
    // sheet: it is handed to `BottomSheet`'s `onClose`, and a changing identity
    // there re-runs the sheet's own history and focus effects on every keystroke.
    const dirtyRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(dirty);
    dirtyRef.current = dirty;
    const onCloseRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(onClose);
    onCloseRef.current = onClose;
    const requestClose = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        if (!dirtyRef.current) {
            onCloseRef.current?.();
            return;
        }
        setAsking(true);
    }, []);
    const discard = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        setAsking(false);
        onCloseRef.current?.();
    }, []);
    return {
        requestClose: requestClose,
        asking: asking,
        guard: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($6ad2538fee34d7d1$export$2e2bcd8739ae039, {
            open: asking,
            onDiscard: discard,
            onKeepEditing: ()=>setAsking(false)
        })
    };
}
function $6ad2538fee34d7d1$export$2e2bcd8739ae039({ open: open, onDiscard: onDiscard, onKeepEditing: onKeepEditing }) {
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3OnFU.default), {
        open: open,
        onOpenChange: (next)=>{
            if (!next) onKeepEditing?.();
        },
        title: t('common.unsaved.title'),
        message: t('common.unsaved.body'),
        confirmLabel: t('common.unsaved.discard'),
        cancelLabel: t('common.unsaved.keepEditing'),
        destructive: true,
        onConfirm: onDiscard
    });
}

});



parcelRegister("cGTI2", function(module, exports) {

$parcel$export(module.exports, "default", () => $93d0222d1c690f96$export$2e2bcd8739ae039);
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");
parcelRequire("7sS0P");
var $jTCZr = parcelRequire("jTCZr");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $7gSBD = parcelRequire("7gSBD");
var $h4ZeB = parcelRequire("h4ZeB");
var $fYgeo = parcelRequire("fYgeo");
var $66joL = parcelRequire("66joL");

var $2WFPf = parcelRequire("2WFPf");
var $5l8OP = parcelRequire("5l8OP");
var $3FyOw = parcelRequire("3FyOw");
var $4CVxl = parcelRequire("4CVxl");
var $8jE1c = parcelRequire("8jE1c");
var $ljvFv = parcelRequire("ljvFv");
var $ksL7p = parcelRequire("ksL7p");
var $03cDl = parcelRequire("03cDl");
var $he6AI = parcelRequire("he6AI");

var $eVM84 = parcelRequire("eVM84");

var $dLdf9 = parcelRequire("dLdf9");

var $gcegg = parcelRequire("gcegg");

var $gq4TR = parcelRequire("gq4TR");

var $j7Lry = parcelRequire("j7Lry");

var $hRWhk = parcelRequire("hRWhk");

var $0xK7i = parcelRequire("0xK7i");

var $jGozX = parcelRequire("jGozX");

var $zi6VT = parcelRequire("zi6VT");

var $41vLC = parcelRequire("41vLC");
// «فایل‌ها» — the record's documents on the phone.
// docs/DOCTOR_PATIENT_FILES_AND_AI_EXTRACTION_DESIGN.md §8.6.
//
// The same documents, the same row and the same host (`useClinicalFiles`) as the
// workstation's tab — the queries are imported from the one contract module rather
// than copied (design F17). On the phone the overlays are sheets, the upload offers
// the camera, and the extraction review stacks its viewer above the editor.
//
// A DICOM study is a row like any document (DICOM_COMPRESSION_LIMITS_AND_DOCUMENT_OCR_DESIGN.md
// §24.12). On the phone «مشاهده» opens the server-rendered preview sheet, never the
// desktop diagnostic viewer (R-C6); the host decides which from the tier.
//
// «گالری» (PM-0561, the phone half of PM-0560): the documents as pictures in a grid,
// and a tap opens them all in one full-height sheet that pages by «قبلی»/«بعدی» and by
// swipe — the doctor no longer opens and closes one document at a time. «فهرست»
// keeps the rows; the choice is the workstation's too (lib/filesView).
const $93d0222d1c690f96$var$CAT_ICON = {
    all: (0, $5l8OP.default),
    lab_report: (0, $4CVxl.default),
    imaging: (0, $03cDl.default),
    ecg: (0, $ljvFv.default),
    pathology: (0, $ksL7p.default),
    general: (0, $3FyOw.default)
};
const $93d0222d1c690f96$var$asRow = (f)=>f._source === 'storage' ? {
        ...f,
        canEdit: false,
        editScope: null,
        extractable: false,
        canDelete: true
    } : f;
const $93d0222d1c690f96$var$MobilePatientFiles = ({ p: p = {}, patientId: patientId, onRefresh: onRefresh })=>{
    const { t: t, formatDigits: formatDigits } = (0, $LNQP4.default)();
    const [storageFiles, setStorageFiles] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [filterCat, setFilterCat] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('all');
    const [collapsedCats, setCollapsedCats] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>new Set());
    const [view, changeView] = (0, $41vLC.useFilesView)();
    const load = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        setLoading(true);
        setError(null);
        (0, $eVM84.bffQuery)((0, $j7Lry.STORAGE_LAB_FILES), {
            patientId: patientId
        }).then((d)=>setStorageFiles(d.storageLabFiles || [])).catch((e)=>setError(e)).finally(()=>setLoading(false));
    }, [
        patientId
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        load();
    }, [
        load
    ]);
    const allFiles = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $gq4TR.mergeClinicalAndStorageFiles)(p.clinicalFiles, storageFiles).map($93d0222d1c690f96$var$asRow), [
        p.clinicalFiles,
        storageFiles
    ]);
    const refreshAll = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        load();
        onRefresh?.();
    }, [
        load,
        onRefresh
    ]);
    const files = (0, $0xK7i.useClinicalFiles)({
        patient: {
            ...p,
            id: p.id || patientId
        },
        files: allFiles,
        onChanged: refreshAll
    });
    const catCounts = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $gq4TR.FILE_CATEGORIES).reduce((acc, c)=>{
            acc[c.id] = c.id === 'all' ? allFiles.length : allFiles.filter((f)=>(0, $gq4TR.resolveFileCat)(f) === c.id).length;
            return acc;
        }, {}), [
        allFiles
    ]);
    const chips = (0, $gq4TR.FILE_CATEGORIES).filter((c)=>c.id === 'all' || catCounts[c.id] > 0);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (filterCat !== 'all' && !catCounts[filterCat]) setFilterCat('all');
    }, [
        catCounts,
        filterCat
    ]);
    const visibleFiles = filterCat === 'all' ? allFiles : allFiles.filter((f)=>(0, $gq4TR.resolveFileCat)(f) === filterCat);
    const groups = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (filterCat !== 'all') return [
            {
                id: filterCat,
                files: visibleFiles
            }
        ];
        const byCat = new Map();
        visibleFiles.forEach((f)=>{
            const id = (0, $gq4TR.resolveFileCat)(f);
            if (!byCat.has(id)) byCat.set(id, []);
            byCat.get(id).push(f);
        });
        return (0, $gq4TR.FILE_CATEGORIES).filter((c)=>c.id !== 'all' && byCat.has(c.id)).map((c)=>({
                id: c.id,
                files: byCat.get(c.id)
            }));
    }, [
        visibleFiles,
        filterCat
    ]);
    const toggleCat = (catId)=>setCollapsedCats((prev)=>{
            const next = new Set(prev);
            if (next.has(catId)) next.delete(catId);
            else next.add(catId);
            return next;
        });
    const catLabel = (id)=>{
        const cat = (0, $gq4TR.FILE_CATEGORIES).find((c)=>c.id === id);
        return cat ? t(cat.labelKey) : id;
    };
    const state = loading ? 'loading' : error ? 'error' : allFiles.length ? 'content' : 'empty';
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "files-content",
        "data-state": "error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dLdf9.default), {
        error: error,
        title: t('patient.files.loadFailed'),
        onRetry: load
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "files-content",
        "data-state": state,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        size: "lg",
        onClick: ()=>files.openUpload(),
        "data-testid": "files-upload",
        className: "w-full min-h-11 gap-2 bg-gradient-brand font-bold"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $he6AI.default), {
        size: 16,
        "aria-hidden": true
    }), " ", t('visit.patient.addFile')), !loading && chips.length > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "files-categories",
        style: {
            overflowX: 'auto',
            display: 'flex',
            gap: '0.375rem',
            scrollbarWidth: 'none'
        }
    }, chips.map((c)=>{
        const Icon = $93d0222d1c690f96$var$CAT_ICON[c.id] || (0, $3FyOw.default);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $h4ZeB.default), {
            key: c.id,
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '0.25rem'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
                size: 13,
                "aria-hidden": true
            }), t(c.labelKey)),
            count: catCounts[c.id] ? formatDigits(catCounts[c.id]) : undefined,
            active: filterCat === c.id,
            onClick: ()=>setFilterCat(c.id),
            "data-testid": `files-category-${c.id}`
        });
    })), !loading && allFiles.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fYgeo.default), {
        size: "lg",
        semantics: "filter",
        ariaLabel: t('patient.files.gallery.viewLabel'),
        value: view,
        onChange: changeView,
        options: [
            {
                value: 'grid',
                label: t('patient.files.gallery.viewGrid')
            },
            {
                value: 'list',
                label: t('patient.files.gallery.viewList')
            }
        ],
        "data-testid": "files-view"
    }), !loading && view === 'grid' && visibleFiles.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $jGozX.FileTileGrid), {
        files: visibleFiles,
        keyOf: (0, $zi6VT.fileKey),
        onSelect: (f)=>files.openGallery(f, visibleFiles),
        testid: "files-tile"
    }), loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.625rem'
        }
    }, [
        1,
        2
    ].map((i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonCard), {
            key: i,
            chips: 0,
            actions: 0,
            padding: 12,
            label: t('common.state.loading')
        }))), !loading && view === 'list' && groups.map((g)=>{
        const collapsed = collapsedCats.has(g.id);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: g.id,
            "data-testid": `files-group-${g.id}`,
            "data-state": collapsed ? 'collapsed' : 'content'
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            onClick: ()=>toggleCat(g.id),
            "aria-expanded": !collapsed,
            "data-testid": `files-group-toggle-${g.id}`,
            className: "w-full h-auto min-h-11 justify-start gap-2 rounded-none px-0 py-1 hover:bg-transparent"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gcegg.SectionTitle), null, catLabel(g.id)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.625rem',
                color: (0, $jTCZr.C).textMuted,
                marginBottom: '0.625rem'
            }
        }, formatDigits(g.files.length)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2WFPf.default), {
            size: 15,
            strokeWidth: 2,
            "aria-hidden": true,
            style: {
                marginInlineStart: 'auto',
                marginBottom: '0.625rem',
                color: (0, $jTCZr.C).textMuted,
                transform: collapsed ? 'rotate(-90deg)' : 'rotate(0)',
                transition: 'transform .2s'
            }
        })), !collapsed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                background: (0, $jTCZr.C).card,
                borderRadius: '0.75rem',
                border: `1px solid ${(0, $jTCZr.C).border}`,
                padding: '0 0.75rem'
            }
        }, g.files.map((f)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hRWhk.default), {
                key: `${f._source}-${f.id}`,
                file: f,
                touch: true,
                dense: true,
                testid: "files-row",
                onOpen: files.openDetail,
                onView: files.openViewer,
                onPreview: (file)=>files.openGallery(file, visibleFiles),
                onExtract: (file)=>files.openExtract(file),
                onEdit: (file)=>files.openDetail(file, {
                        edit: true
                    }),
                onDownload: files.download,
                onDelete: files.requestDelete
            }))));
    }), !loading && allFiles.length > 0 && !visibleFiles.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        "data-testid": "files-category-empty",
        title: t('patient.files.noneInCategory')
    }), !loading && !allFiles.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8jE1c.default), {
            size: 44,
            color: (0, $jTCZr.C).textMuted,
            strokeWidth: 1.5,
            "aria-hidden": true
        }),
        title: t('patient.files.empty'),
        description: t('patient.files.emptyHint')
    }), files.overlays);
};
var $93d0222d1c690f96$export$2e2bcd8739ae039 = $93d0222d1c690f96$var$MobilePatientFiles;

});
parcelRegister("5l8OP", function(module, exports) {

$parcel$export(module.exports, "default", () => $b77ca10bb12022b4$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $b77ca10bb12022b4$export$a2387ed3b5d536eb = {
    name: "files",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M15 2h-4a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V8",
                key: "14sh0y"
            }
        ],
        [
            "path",
            {
                d: "M16.706 2.706A2.4 2.4 0 0 0 15 2v5a1 1 0 0 0 1 1h5a2.4 2.4 0 0 0-.706-1.706z",
                key: "1970lx"
            }
        ],
        [
            "path",
            {
                d: "M5 7a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h8a2 2 0 0 0 1.732-1",
                key: "l4dndm"
            }
        ]
    ]
};
$b77ca10bb12022b4$export$a2387ed3b5d536eb.node;
const $b77ca10bb12022b4$export$2e2bcd8739ae039 = (0, $9QBug.default)($b77ca10bb12022b4$export$a2387ed3b5d536eb);

});

parcelRegister("ljvFv", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e5fcd5ed76b0a6f$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $9e5fcd5ed76b0a6f$export$a2387ed3b5d536eb = {
    name: "heart-pulse",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5",
                key: "mvr1a0"
            }
        ],
        [
            "path",
            {
                d: "M3.22 13H9.5l.5-1 2 4.5 2-7 1.5 3.5h5.27",
                key: "auskq0"
            }
        ]
    ]
};
$9e5fcd5ed76b0a6f$export$a2387ed3b5d536eb.node;
const $9e5fcd5ed76b0a6f$export$2e2bcd8739ae039 = (0, $9QBug.default)($9e5fcd5ed76b0a6f$export$a2387ed3b5d536eb);

});

parcelRegister("ksL7p", function(module, exports) {

$parcel$export(module.exports, "default", () => $5935de03d6f5e9ca$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $5935de03d6f5e9ca$export$a2387ed3b5d536eb = {
    name: "microscope",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M6 18h8",
                key: "1borvv"
            }
        ],
        [
            "path",
            {
                d: "M3 22h18",
                key: "8prr45"
            }
        ],
        [
            "path",
            {
                d: "M14 22a7 7 0 1 0 0-14h-1",
                key: "1jwaiy"
            }
        ],
        [
            "path",
            {
                d: "M9 14h2",
                key: "197e7h"
            }
        ],
        [
            "path",
            {
                d: "M9 12a2 2 0 0 1-2-2V6h6v4a2 2 0 0 1-2 2Z",
                key: "1bmzmy"
            }
        ],
        [
            "path",
            {
                d: "M12 6V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v3",
                key: "1drr47"
            }
        ]
    ]
};
$5935de03d6f5e9ca$export$a2387ed3b5d536eb.node;
const $5935de03d6f5e9ca$export$2e2bcd8739ae039 = (0, $9QBug.default)($5935de03d6f5e9ca$export$a2387ed3b5d536eb);

});

parcelRegister("41vLC", function(module, exports) {

$parcel$export(module.exports, "useFilesView", () => $2edfe5afc4853bde$export$61179c06f0e31f9d);

var $acw62 = parcelRequire("acw62");
const $2edfe5afc4853bde$export$a0ada20a6f936f81 = 'parsina.clinical.filesView';
function $2edfe5afc4853bde$export$af5824977bda278a() {
    try {
        return window.localStorage.getItem($2edfe5afc4853bde$export$a0ada20a6f936f81) === 'list' ? 'list' : 'grid';
    } catch  {
        return 'grid';
    }
}
function $2edfe5afc4853bde$export$64587431375ddb0a(view) {
    try {
        window.localStorage.setItem($2edfe5afc4853bde$export$a0ada20a6f936f81, view === 'list' ? 'list' : 'grid');
    } catch  {}
}
function $2edfe5afc4853bde$export$61179c06f0e31f9d() {
    const [view, set] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState($2edfe5afc4853bde$export$af5824977bda278a);
    const setView = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((v)=>{
        set(v);
        $2edfe5afc4853bde$export$64587431375ddb0a(v);
    }, []);
    return [
        view,
        setView
    ];
}

});


parcelRegister("2Oaoe", function(module, exports) {

$parcel$export(module.exports, "PatientPrimaryPhone", () => $ca663251e1371907$export$f6de2ce6bc56133c);
$parcel$export(module.exports, "PatientMorePhones", () => $ca663251e1371907$export$32822cd354ffd633);

var $acw62 = parcelRequire("acw62");

var $huNwV = parcelRequire("huNwV");
var $2uCMp = parcelRequire("2uCMp");
parcelRequire("5N0ZI");
var $bHjRG = parcelRequire("bHjRG");
var $cZOyb = parcelRequire("cZOyb");
var $5JYPc = parcelRequire("5JYPc");
var $bfs4Q = parcelRequire("bfs4Q");
var $5AX1S = parcelRequire("5AX1S");
var $8ym5i = parcelRequire("8ym5i");
var $9Bif4 = parcelRequire("9Bif4");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $bkBaq = parcelRequire("bkBaq");
// ─────────────────────────────────────────────────────────────────────────────
// A patient's numbers on the record's header (PM-0536; findings 05 §3.3).
//
// The MAIN number is shown — the kit's PhoneNumber: national spelling, the page's
// digits, an LTR island — and, when the record holds more, a «+N» chip (the tags
// overflow's outline badge) that opens the others: an anchored `Menu` on a
// workstation, a `BottomSheet` on a phone (DESIGN_SYSTEM §8 — a popover at the
// bottom edge of a phone is not a menu). Each other number comes with whose number
// it is and «کپی», which copies the national form as every copy button does.
//
// The chip says «+۲» to the eye and «۲ شمارهٔ دیگر» to a screen reader (DC §12.3).
// The screens are tier-specific, so the caller says which overlay (`sheet`); on the
// header's gradient `onDark` turns the chip white-alpha (§2.2) and gives it the
// phone tier's 2.75rem target.
// ─────────────────────────────────────────────────────────────────────────────
const $ca663251e1371907$var$COPIED_MS = 1500;
/** «همسر» · «سایر — همسایه»: whose number it is, in the page language. */ function $ca663251e1371907$var$relationText(p, locale) {
    const word = (0, $9Bif4.phoneRelationLabel)(p.relation, locale);
    return [
        word,
        p.label
    ].filter(Boolean).join(" \u2014 ");
}
function $ca663251e1371907$export$f6de2ce6bc56133c({ patient: patient, 'data-testid': testid = 'patient-phone' }) {
    const { locale: locale } = (0, $LNQP4.default)();
    const { primary: primary } = (0, $bkBaq.patientPhoneParts)(patient);
    if (!primary) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8ym5i.default), {
        value: primary,
        locale: locale,
        "data-testid": testid
    });
}
// One other number in the desktop menu: the whole row is the menu item, and
// pressing it copies the number — a tick and «کپی شد» say it happened.
function $ca663251e1371907$var$MenuPhoneRow({ p: p, locale: locale, t: t, testid: testid }) {
    const [copied, setCopied] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const timer = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>()=>clearTimeout(timer.current), []);
    const value = p.number || p.raw;
    const copy = async ()=>{
        try {
            await navigator.clipboard.writeText((0, $5AX1S).forDisplay(value));
        } catch  {
            return; // nothing was copied, so nothing says it was
        }
        setCopied(true);
        clearTimeout(timer.current);
        timer.current = setTimeout(()=>setCopied(false), $ca663251e1371907$var$COPIED_MS);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        role: "menuitem",
        onClick: copy,
        "data-testid": `${testid}-item-${p.id}`,
        "data-state": copied ? 'copied' : 'idle',
        className: "flex w-full items-center gap-2 rounded-md px-2.5 py-2 text-start text-[0.8125rem] hover:bg-muted focus-visible:bg-muted focus-visible:outline-none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8ym5i.default), {
        value: value,
        locale: locale
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "min-w-0 truncate text-muted-foreground text-[0.75rem]"
    }, $ca663251e1371907$var$relationText(p, locale)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "ms-auto inline-flex shrink-0 items-center gap-1 text-muted-foreground text-[0.75rem]"
    }, copied ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
        size: 14,
        "aria-hidden": "true"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2uCMp.default), {
        size: 14,
        "aria-hidden": "true"
    }), copied ? t('common.actions.copied') : t('common.actions.copy')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "sr-only",
        role: "status",
        "aria-live": "polite"
    }, copied ? t('common.actions.copied') : ''));
}
function $ca663251e1371907$export$32822cd354ffd633({ patient: patient, sheet: sheet = false, onDark: onDark = false, 'data-testid': testid = 'patient-phones' }) {
    const { t: t, locale: locale, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const { others: others } = (0, $bkBaq.patientPhoneParts)(patient);
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const anchor = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const close = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>setOpen(false), []);
    if (!others.length) return null;
    const count = others.length;
    const chip = (0, $5JYPc.cn)((0, $bHjRG.badgeVariants)({
        variant: 'outline'
    }), onDark && 'border-white/50 text-white');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        ref: anchor,
        type: "button",
        onClick: ()=>setOpen((o)=>!o),
        "aria-haspopup": sheet ? 'dialog' : 'menu',
        "aria-expanded": open,
        "data-testid": `${testid}-more`,
        className: (0, $5JYPc.cn)('inline-flex items-center justify-center rounded-full cursor-pointer focus-visible:outline-none focus-visible:ring-2', onDark ? 'min-h-11 min-w-11 focus-visible:ring-white/60' : 'focus-visible:ring-ring'),
        style: {
            background: 'transparent',
            border: 0,
            padding: 0,
            font: 'inherit'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": "true",
        className: chip
    }, "+", formatNumber(count)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "sr-only"
    }, t('patient.phones.more', {
        count: count
    }))), sheet ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cZOyb.default), {
        open: open,
        onClose: close,
        title: t('patient.phones.title'),
        closeLabel: t('common.actions.close')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        "data-testid": `${testid}-sheet`,
        style: {
            listStyle: 'none',
            margin: 0,
            padding: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: '0.25rem'
        }
    }, others.map((p)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: p.id,
            "data-testid": `${testid}-item-${p.id}`,
            className: "flex items-center gap-2 min-h-11"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8ym5i.default), {
            value: p.number || p.raw,
            locale: locale,
            copy: true,
            isMobile: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "min-w-0 truncate text-muted-foreground text-[0.8125rem]"
        }, $ca663251e1371907$var$relationText(p, locale)))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bfs4Q.default), {
        open: open,
        onClose: close,
        anchorRef: anchor,
        ariaLabel: t('patient.phones.title'),
        width: 320,
        "data-testid": `${testid}-menu`
    }, others.map((p)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ca663251e1371907$var$MenuPhoneRow, {
            key: p.id,
            p: p,
            locale: locale,
            t: t,
            testid: testid
        }))));
}

});


parcelRegister("d5Mun", function(module, exports) {

$parcel$export(module.exports, "default", () => $86511c54b887fe2a$export$2e2bcd8739ae039);
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");

var $k5DdK = parcelRequire("k5DdK");

var $dLdf9 = parcelRequire("dLdf9");

var $8st6E = parcelRequire("8st6E");

var $cwVZP = parcelRequire("cwVZP");

var $2Ieny = parcelRequire("2Ieny");

var $BrEe9 = parcelRequire("BrEe9");

var $25kYp = parcelRequire("25kYp");

var $hkwbL = parcelRequire("hkwbL");

var $3bbzC = parcelRequire("3bbzC");

var $aX9TZ = parcelRequire("aX9TZ");

var $hUKVy = parcelRequire("hUKVy");

var $ftxDC = parcelRequire("ftxDC");

var $laikc = parcelRequire("laikc");

var $kTp82 = parcelRequire("kTp82");

var $cwxsI = parcelRequire("cwxsI");
// ── Desktop Patient record (archetype C) ──────────────────────────────────────
// Thin composition root: loads the patient once via `usePatient`, injects the
// scoped stylesheet, and switches between the five section tabs. Every piece of
// UI lives in ./web/* (layout, tabs, media, modals) and is built from the
// @parsina/framework kit + framework tokens (DESIGN §1). Render-only — data
// mutations happen inside the individual tabs.
const $86511c54b887fe2a$var$PatientDetailWeb = ({ patient: patientProp, onBack: onBack, tab: tabProp, setTab: setTab })=>{
    const { t: t } = (0, $LNQP4.default)();
    // The section lives in the URL (/patients/:id/:tab, screen index owns the
    // navigation); an unknown segment — including a mobile-only section id after
    // a viewport switch — falls back to the overview rather than a blank pane.
    const tab = (0, $3bbzC.TABS)(t).some((item)=>item.id === tabProp) ? tabProp : 'overview';
    const { patient: p, loading: loading, error: error, refresh: refresh } = (0, $k5DdK.usePatient)(patientProp?.id);
    if (loading && !p) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aX9TZ.default), {
        tab: tab
    });
    // "This record does not exist" and "this record would not load" are different
    // events, and telling them apart is the difference between a doctor pressing
    // retry forever and a doctor realising they followed a stale link. Both used
    // to render the same retry card below.
    //
    // FORBIDDEN lands here too, on purpose: «not yours» and «does not exist» are
    // the same fact seen from two angles, and neither is fixed by retrying. (The
    // BFF scopes VISITS to the requesting doctor — PM-0599; refusing a whole
    // patient record is PM-0615, not done yet.)
    const missing = error && !p && [
        (0, $cwVZP.ErrorKind).NOT_FOUND,
        (0, $cwVZP.ErrorKind).FORBIDDEN
    ].includes((0, $cwVZP.classifyError)(error));
    if (missing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8st6E.RecordNotFound), {
        titleKey: "patient.empty.notFoundTitle",
        bodyKey: "patient.empty.notFoundBody",
        detail: patientProp?.id,
        onBack: onBack
    });
    // §2.4: a failed load renders a retry card (wired to refetch), never a dead end.
    if (error && !p) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "patient-detail-error",
        "data-state": "error",
        role: "alert",
        style: {
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: (0, $2Ieny.CL).bg
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dLdf9.default), {
        error: error,
        title: t('patient.empty.unavailable'),
        note: t('errors.load.recordRetry'),
        onRetry: ()=>refresh?.()
    }));
    const renderTab = ()=>{
        // A refresh with the header already on screen: only the pane skeletons, in
        // the shape of the tab it is about to show.
        if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aX9TZ.PatientTabSkeleton), {
            tab: tab
        });
        switch(tab){
            case 'overview':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hUKVy.default), {
                    p: p,
                    setTab: setTab,
                    onRefresh: refresh
                });
            case 'analysis':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ftxDC.default), {
                    p: p,
                    setTab: setTab
                });
            case 'labs':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $laikc.default), {
                    p: p,
                    onRefresh: refresh
                });
            case 'visits':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kTp82.default), {
                    p: p,
                    onRefresh: refresh
                });
            case 'files':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cwxsI.default), {
                    p: p,
                    onRefresh: refresh
                });
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            background: (0, $2Ieny.CL).bg,
            fontFamily: 'var(--app-font)',
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", null, `@keyframes spin { to{transform:rotate(360deg)} }` + (0, $BrEe9.PATIENT_SUMMARY_CSS)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $25kYp.default), {
        p: p,
        onBack: onBack
    }), tab !== 'overview' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hkwbL.default), {
        allergies: (p.clinicalAllergies || []).map((a)=>a.allergen || a).filter(Boolean),
        alerts: p.alerts || []
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3bbzC.default), {
        tab: tab,
        setTab: setTab
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            display: 'flex',
            overflow: 'hidden'
        }
    }, tab === 'visits' ? renderTab() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            overflowY: 'auto',
            padding: '20px 28px 40px'
        }
    }, renderTab())));
};
var $86511c54b887fe2a$export$2e2bcd8739ae039 = $86511c54b887fe2a$var$PatientDetailWeb;

});
parcelRegister("2Ieny", function(module, exports) {

$parcel$export(module.exports, "CL", () => $1f9ad82cbe711bba$export$9bf3043cb7503aa1);
$parcel$export(module.exports, "OV_VITAL_DEF", () => $1f9ad82cbe711bba$export$770e25a75af047b6);
$parcel$export(module.exports, "OV_DX_STATUS", () => $1f9ad82cbe711bba$export$1574ad95f483ccf4);
// Shared design + domain constants for the desktop Patient record.
// Colours come from the framework token set only (DESIGN §1.1): the legacy `CL`
// field names are kept (thousands of inline call-sites) but every value is sourced
// from the canonical `CT` tokens, so the page renders in the shared navy/teal
// language — no raw hex is introduced.

var $jTCZr = parcelRequire("jTCZr");
const $1f9ad82cbe711bba$export$9bf3043cb7503aa1 = {
    bg: (0, $jTCZr.CT).bg,
    surface: (0, $jTCZr.CT).surface,
    surface2: (0, $jTCZr.CT).surface2,
    border: (0, $jTCZr.CT).border,
    border2: (0, $jTCZr.CT).border2,
    text1: (0, $jTCZr.CT).ink,
    text2: (0, $jTCZr.CT).ink2,
    text3: (0, $jTCZr.CT).mute,
    text4: (0, $jTCZr.CT).mute2,
    accent: (0, $jTCZr.CT).accent,
    accentInk: (0, $jTCZr.CT).accentInk,
    accentSoft: (0, $jTCZr.CT).accentSoft,
    // The panel's primary (azure #0173BE in the doctor panel). Used as the "medication"
    // timeline category so it reads distinct from the teal "diagnosis" accent
    // without importing an off-brand blue.
    navy: (0, $jTCZr.CT).navy,
    navySoft: (0, $jTCZr.soft)((0, $jTCZr.CT).navy, 0.10),
    good: (0, $jTCZr.CT).good,
    goodInk: (0, $jTCZr.CT).goodInk,
    goodSoft: (0, $jTCZr.CT).goodSoft,
    warn: (0, $jTCZr.CT).warn,
    warnInk: (0, $jTCZr.CT).warnInk,
    warnSoft: (0, $jTCZr.CT).warnSoft,
    danger: (0, $jTCZr.CT).danger,
    dangerInk: (0, $jTCZr.CT).dangerInk,
    dangerSoft: (0, $jTCZr.CT).dangerSoft
};
const $1f9ad82cbe711bba$export$770e25a75af047b6 = (t)=>[
        {
            code: '55284-4',
            label: t('patient.vitals.bp'),
            unit: 'mmHg'
        },
        {
            code: '8867-4',
            label: t('patient.vitals.hr'),
            unit: 'bpm'
        },
        {
            code: '59408-5',
            label: t('patient.vitals.spo2'),
            unit: '%'
        },
        {
            code: '8310-5',
            label: t('patient.vitals.bodyTemp'),
            unit: "\xb0C"
        }
    ];
const $1f9ad82cbe711bba$export$1574ad95f483ccf4 = (t)=>({
        active: {
            l: t('common.state.active'),
            cls: 'active'
        },
        resolved: {
            l: t('patient.conditions.resolved'),
            cls: 'resolved'
        }
    });

});

parcelRegister("BrEe9", function(module, exports) {

$parcel$export(module.exports, "PATIENT_SUMMARY_CSS", () => $0708e7191fc9d5b2$export$72b22e63cf166bcb);
// Scoped stylesheet for the desktop Patient record. Injected once by the root.
// Colour values interpolate from the framework-sourced CL token map (DESIGN §1.1).

var $2Ieny = parcelRequire("2Ieny");
const $0708e7191fc9d5b2$export$72b22e63cf166bcb = `
  :root{
    --bg:${(0, $2Ieny.CL).bg}; --panel-2:${(0, $2Ieny.CL).surface}; --surface:${(0, $2Ieny.CL).surface}; --line:${(0, $2Ieny.CL).border}; --line-2:${(0, $2Ieny.CL).border2};
    --ink:${(0, $2Ieny.CL).text1}; --ink-2:${(0, $2Ieny.CL).text2}; --mute:${(0, $2Ieny.CL).text3}; --mute-2:${(0, $2Ieny.CL).text4};
    --accent:${(0, $2Ieny.CL).accent}; --accent-ink:${(0, $2Ieny.CL).accentInk}; --accent-soft:${(0, $2Ieny.CL).accentSoft};
    --navy:${(0, $2Ieny.CL).navy}; --navy-soft:${(0, $2Ieny.CL).navySoft};
    --good:${(0, $2Ieny.CL).good}; --good-soft:${(0, $2Ieny.CL).goodSoft};
    --warn:${(0, $2Ieny.CL).warn}; --warn-ink:${(0, $2Ieny.CL).warnInk}; --warn-soft:${(0, $2Ieny.CL).warnSoft};
    --danger:${(0, $2Ieny.CL).danger}; --danger-ink:${(0, $2Ieny.CL).dangerInk}; --danger-soft:${(0, $2Ieny.CL).dangerSoft};
  }
  /* The Record's zone-\u{2460} identity band now lives in the shared InnerPageHeader
     (DESIGN-CONCEPT \xa72.3-C); the old .pb* breadcrumb+banner CSS was removed. */

  .pt-tabs{display:flex;gap:2px;padding:0 28px;background:var(--panel-2);border-bottom:1px solid var(--line);
    position:sticky;top:0;z-index:10;overflow-x:auto;flex-shrink:0}
  .pt-tab{position:relative;padding:13px 16px;font-size:0.84375rem;font-weight:600;color:var(--mute);
    border-bottom:2.5px solid transparent;margin-bottom:-1px;transition:color .14s;white-space:nowrap;
    background:none;border-inline:none;border-top:none;cursor:pointer;font-family:inherit}
  .pt-tab:hover{color:var(--ink-2)}
  .pt-tab.active{color:var(--accent-ink);border-bottom-color:var(--accent)}
  .pt-tab-dot{display:inline-block;width:5px;height:5px;border-radius:50%;background:var(--accent);margin-inline-start:6px;vertical-align:middle}

  .ps-grid{display:grid;grid-template-columns:minmax(0,1fr) 320px;gap:16px;align-items:start}
  .ps-main{display:flex;flex-direction:column;gap:16px;min-width:0}
  .ps-two{display:grid;grid-template-columns:1fr 1fr;gap:16px}
  .ps-rail{display:flex;flex-direction:column;gap:16px}
  @media(max-width:1180px){.ps-grid{grid-template-columns:1fr}.ps-two{grid-template-columns:1fr}}

  .ps-card{background:var(--panel-2);border:1px solid var(--line);border-radius:14px;
    box-shadow:0 1px 2px rgba(20,20,15,.04);overflow:hidden}
  .ps-card-head{display:flex;align-items:center;gap:9px;padding:13px 16px;border-bottom:1px solid var(--line-2)}
  .ps-card-title{display:flex;align-items:center;gap:9px;font-size:0.875rem;font-weight:700}
  .ps-ic{width:26px;height:26px;border-radius:8px;display:grid;place-items:center;flex-shrink:0;
    background:var(--accent-soft);color:var(--accent-ink);font-size:0.8125rem}
  .ps-count{font-size:0.6875rem;color:var(--mute);font-weight:600;background:var(--bg);padding:2px 9px;border-radius:999px;margin-inline-start:2px}
  .ps-card-body{padding:14px 16px}
  .ps-card-body.pad0{padding:2px 16px}
  .ps-link{display:inline-flex;align-items:center;gap:5px;color:var(--accent-ink);font-weight:600;font-size:0.78125rem;
    background:none;border:none;cursor:pointer;font-family:inherit}
  .ps-link.sm{font-size:0.75rem;margin-inline-start:auto}

  .ps-card.hero{background:linear-gradient(120deg,var(--accent-soft),var(--panel-2) 75%);border-color:transparent;
    box-shadow:0 1px 2px rgba(20,20,15,.04),0 6px 20px rgba(20,20,15,.04)}
  .ps-summary-text{margin:0;font-size:0.8125rem;line-height:1.95;color:var(--ink-2);text-align:justify}
  .ps-summary-actions{margin-top:13px}
  .ps-summary-actions-l{font-size:0.71875rem;font-weight:800;color:var(--ink);margin-bottom:9px;
    display:flex;align-items:center;gap:7px}
  .ps-summary-actions-l::before{content:"";width:4px;height:13px;border-radius:2px;background:var(--accent)}
  .ps-summary-actions ul{list-style:none;margin:0;padding:0;display:flex;flex-direction:column;gap:7px}
  .ps-summary-actions li{display:flex;align-items:flex-start;gap:9px;font-size:0.78125rem;color:var(--ink-2);line-height:1.55}
  .ps-bullet{width:16px;height:16px;border-radius:5px;flex-shrink:0;margin-top:1px;display:grid;place-items:center;
    background:var(--accent-soft);color:var(--accent-ink);font-size:0.625rem}

  .dx-row{display:flex;align-items:flex-start;gap:12px;padding:12px 0;border-top:1px solid var(--line-2)}
  .dx-row:first-child{border-top:0}
  .dx-main{flex:1;min-width:0}
  .dx-title-row{display:flex;align-items:center;gap:8px;flex-wrap:wrap}
  .dx-cat{font-size:0.59375rem;font-weight:800;padding:2px 8px;border-radius:5px;letter-spacing:.03em}
  .dx-cat.active{background:var(--good-soft);color:var(--good)}
  .dx-cat.diff{background:var(--warn-soft);color:var(--warn-ink)}
  .dx-cat.resolved{background:var(--line-2);color:var(--mute)}
  .dx-name{font-size:0.8125rem;font-weight:600;line-height:1.4}
  .dx-code{background:var(--bg);border:1px solid var(--line);color:var(--ink-2);padding:1px 7px;border-radius:5px;font-size:0.65625rem;font-weight:700}
  .dx-note{font-size:0.71875rem;color:var(--mute);margin-top:4px;line-height:1.55}

  .med-row{display:flex;align-items:flex-start;gap:11px;padding:10px 0;border-top:1px solid var(--line-2)}
  .med-row:first-child{border-top:0}
  .med-pill{width:30px;height:30px;border-radius:8px;background:var(--accent-soft);display:grid;place-items:center;
    color:var(--accent-ink);flex-shrink:0;margin-top:1px;font-size:0.8125rem}
  .med-top{display:flex;align-items:center;gap:8px;flex-wrap:wrap}
  .med-top .n{font-size:0.8125rem;font-weight:700}
  .med-dose{font-size:0.6875rem;font-weight:700;color:var(--accent-ink);background:var(--accent-soft);padding:1px 7px;border-radius:5px}
  .med-row .d{font-size:0.71875rem;color:var(--mute);margin-top:1px}
  .med-badges{display:flex;flex-wrap:wrap;gap:5px;margin-top:6px}
  .med-badge{display:inline-flex;align-items:center;gap:4px;font-size:0.625rem;font-weight:600;padding:2px 7px;border-radius:6px}
  .med-badge.warn{background:var(--warn-soft);color:var(--warn-ink)}

  .ps-rail-block{background:var(--panel-2);border:1px solid var(--line);border-radius:14px;padding:14px 15px;
    box-shadow:0 1px 2px rgba(20,20,15,.04)}
  .ps-rail-title{display:flex;align-items:center;font-size:0.78125rem;font-weight:800;color:var(--ink);margin-bottom:11px}

  .vit-grid{display:grid;grid-template-columns:1fr 1fr;gap:9px}
  .vit-cell{padding:9px 11px;border-radius:10px;background:var(--bg);border:1px solid var(--line)}
  .vit-cell .k{font-size:0.65625rem;color:var(--mute);font-weight:600}
  .vit-cell .v{display:flex;align-items:baseline;gap:3px;margin-top:2px}
  .vit-cell .v .mono{font-size:1rem;font-weight:800;letter-spacing:-.02em}
  .vit-cell .v .u{font-size:0.59375rem;color:var(--mute);font-weight:600}
  .vit-cell .trend{margin-top:5px}

  .ps-tabph{text-align:center;padding:60px 20px}
  .ps-tabph-t{font-size:1rem;font-weight:800}
  .ps-tabph-s{font-size:0.78125rem;color:var(--mute);margin-top:4px}

  /* \xab\u{646}\u{645}\u{627}\u{6CC} \u{6A9}\u{644}\u{6CC} \u{628}\u{627}\u{644}\u{6CC}\u{646}\u{6CC}\xbb (.ov-*) and \xab\u{645}\u{631}\u{627}\u{62C}\u{639}\u{627}\u{62A} \u{627}\u{62E}\u{6CC}\u{631}\xbb (.ps-enc*) were removed from the
     Summary tab; their rules went with them. The visit history lives in the
     \xab\u{62A}\u{627}\u{631}\u{6CC}\u{62E}\u{686}\u{647} \u{645}\u{631}\u{627}\u{62C}\u{639}\u{627}\u{62A}\xbb tab. */

  .lv-meta{display:flex;align-items:center;gap:8px;flex-wrap:wrap;font-size:0.75rem;color:var(--mute);
    padding-bottom:11px;margin-bottom:12px;border-bottom:1px solid var(--line-2)}
  .lv-meta b{color:var(--ink);font-weight:700}
  .lv-meta .dot{width:3px;height:3px;border-radius:50%;background:var(--mute-2)}
  .lv-type{font-size:0.59375rem;font-weight:800;letter-spacing:.04em;padding:2px 7px;border-radius:5px;
    background:var(--accent-soft);color:var(--accent-ink)}

  .ps-card-head.danger{border-bottom-color:var(--line-2)}
  .ps-ic.danger{background:var(--danger-soft);color:var(--danger-ink)}
  .alg-row{display:flex;align-items:center;gap:11px;padding:12px 16px;border-top:1px solid var(--line-2)}
  .alg-row:first-child{border-top:0}
  .alg-sev{font-size:0.6875rem;font-weight:800;padding:4px 11px;border-radius:8px;flex-shrink:0;color:var(--surface)}
  .alg-sev.high{background:var(--danger)}
  .alg-sev.mid{background:var(--warn)}
  .alg-body{flex:1;min-width:0}
  .alg-name{font-size:0.8125rem;font-weight:700}
  .alg-react{font-size:0.6875rem;color:var(--mute);margin-top:2px}

  .abn-row{display:flex;align-items:center;gap:11px;padding:12px 16px;border-top:1px solid var(--line-2)}
  .abn-row:first-child{border-top:0}
  .abn-info{flex:1;min-width:0}
  .abn-name{font-size:0.8125rem;font-weight:700}
  .abn-ref{font-size:0.65625rem;color:var(--mute);margin-top:2px}
  .abn-spark{flex-shrink:0}
  .abn-val{text-align:center;flex-shrink:0;min-width:46px}
  .abn-v{display:block;font-size:1rem;font-weight:800;letter-spacing:-.02em}
  .abn-v.hi{color:var(--danger-ink)}.abn-v.mid{color:var(--warn-ink)}
  .abn-state{display:block;font-size:0.59375rem;font-weight:700;margin-top:1px}
  .abn-state.hi{color:var(--danger-ink)}.abn-state.mid{color:var(--warn-ink)}

  .ps-empty{text-align:center;padding:18px 8px}
  .ps-empty-ic{width:42px;height:42px;border-radius:12px;margin:0 auto 10px;display:grid;place-items:center;
    background:var(--bg);border:1px solid var(--line);color:var(--mute-2);font-size:1.125rem}
  .ps-empty-t{font-size:0.8125rem;font-weight:700;color:var(--ink)}
  .ps-empty-s{font-size:0.71875rem;color:var(--mute);margin-top:4px;line-height:1.6;max-width:240px;margin-inline:auto}

  .demo-grid{display:grid;grid-template-columns:1fr 1fr;gap:8px 14px}
  .demo-item .k{font-size:0.65625rem;color:var(--mute);text-transform:uppercase;letter-spacing:.05em;font-weight:600;margin-bottom:1px}
  .demo-item .v{font-size:0.8125rem;color:var(--ink);font-weight:500}
  .demo-item .v.mono{font-family:ui-monospace,monospace;font-weight:600}

  .vit-cell.alert{background:var(--warn-soft);border-color:transparent}
  .vit-cell.alert .k{color:var(--warn-ink)}

  .allergy-banner{display:flex;align-items:center;gap:8px;padding:8px 11px;
    background:var(--danger-soft);border:1px solid transparent;border-radius:8px;margin-bottom:8px}
  .allergy-banner .ic{width:18px;height:18px;border-radius:50%;background:var(--danger-ink);
    color:#fff;display:grid;place-items:center;flex-shrink:0;font-size:0.6875rem}
  .allergy-list{display:flex;flex-wrap:wrap;gap:5px}
  .allergy-chip{font-size:0.71875rem;padding:3px 9px;border-radius:999px;
    background:var(--panel-2);border:1px solid var(--line);color:var(--danger-ink);font-weight:500}

  .history-list{display:flex;flex-direction:column;gap:10px}
  .hist-item{display:grid;grid-template-columns:auto 1fr;gap:10px}
  .hist-marker{width:8px;height:8px;border-radius:50%;background:var(--accent);margin-top:7px;flex-shrink:0;position:relative}
  .hist-marker::after{content:"";position:absolute;top:12px;inset-inline-start:3.5px;width:1px;height:32px;background:var(--line)}
  .hist-item:last-child .hist-marker::after{display:none}
  .hist-title{font-size:0.78125rem;font-weight:600;color:var(--ink)}
  .hist-meta{font-size:0.6875rem;color:var(--mute);font-family:ui-monospace,monospace;margin-top:1px}

  .cond-list{display:flex;flex-wrap:wrap;gap:5px}
  .cond-chip{font-size:0.71875rem;padding:4px 10px;border-radius:6px;
    background:var(--bg);border:1px solid var(--line);color:var(--ink-2);display:inline-flex;align-items:center;gap:6px}
  .cond-chip.primary{background:var(--accent-soft);border-color:transparent;color:var(--accent-ink)}
  .cond-chip .code{font-family:ui-monospace,monospace;font-size:0.625rem;color:var(--mute);font-weight:600}
  .cond-chip.primary .code{color:var(--accent-ink);opacity:.7}

  /* \u{2500}\u{2500} Encounter workspace (\u{62A}\u{627}\u{631}\u{6CC}\u{62E}\u{686}\u{647} \u{645}\u{631}\u{627}\u{62C}\u{639}\u{627}\u{62A} tab) \u{2500}\u{2500} */
  .soap-tabs{display:flex;gap:4px;padding:0 20px;background:var(--bg);border-bottom:1px solid var(--line)}
  .soap-tab{padding:10px 14px;font-size:0.8125rem;font-weight:500;color:var(--mute);
    border-bottom:2px solid transparent;margin-bottom:-1px;
    display:flex;align-items:center;gap:7px;background:transparent;transition:color .12s}
  .soap-tab:hover{color:var(--ink-2)}
  .soap-tab.active{color:var(--ink);border-bottom-color:var(--ink);font-weight:600}
  .soap-tab .badge{font-size:0.625rem;background:var(--line-2,#ece9e4);color:var(--ink-2);
    padding:1px 6px;border-radius:999px;font-weight:600}
  .soap-tab.active .badge{background:var(--accent-soft);color:var(--accent-ink)}

  .work-scroll{flex:1;overflow-y:auto;padding:22px 24px 60px}

  .enc-card{background:var(--surface);border:1px solid var(--line);border-radius:12px;
    margin-bottom:14px;overflow:hidden}
  .enc-card-head{padding:11px 16px;border-bottom:1px solid var(--line-2,#ece9e4);
    display:flex;align-items:center;justify-content:space-between;background:var(--bg)}
  .enc-card-title{font-weight:600;font-size:0.8125rem;display:flex;align-items:center;gap:8px}
  .enc-card-title .ic{width:22px;height:22px;border-radius:6px;background:var(--accent-soft);
    color:var(--accent-ink);display:grid;place-items:center;font-size:0.75rem}
  .enc-card-body{padding:14px 16px}

  .soap-section{margin-bottom:16px}
  .soap-label{display:flex;align-items:center;gap:8px;margin-bottom:7px}
  .soap-letter{width:22px;height:22px;border-radius:6px;background:var(--accent-soft);
    color:var(--accent-ink);font-family:ui-monospace,monospace;font-size:0.6875rem;font-weight:700;
    display:grid;place-items:center;flex-shrink:0}
  .soap-name{font-weight:600;font-size:0.8125rem}
  .soap-editor{border:1px solid var(--line);border-radius:8px;padding:10px 12px;
    background:var(--bg);font-size:0.8125rem;line-height:1.75;min-height:52px;color:var(--ink-2);
    white-space:pre-wrap;word-break:break-word}

  .diff-row{display:grid;grid-template-columns:1fr auto;align-items:center;gap:12px;
    padding:11px 0;border-top:1px solid var(--line-2,#ece9e4)}
  .diff-row:first-child{border-top:0;padding-top:0}
  .diff-name{font-size:0.8125rem;font-weight:600;display:flex;align-items:center;gap:7px;flex-wrap:wrap}
  .diff-code{font-size:0.6875rem;color:var(--mute);font-family:ui-monospace,monospace}
  .diff-evidence{font-size:0.71875rem;color:var(--mute);margin-top:3px;line-height:1.5}
  .diff-conf{display:flex;align-items:center;gap:7px;flex-shrink:0}
  .conf-bar{width:72px;height:5px;background:var(--line-2,#ece9e4);border-radius:3px;overflow:hidden}
  .conf-fill{height:100%;background:var(--accent);border-radius:3px}
  .conf-num{font-family:ui-monospace,monospace;font-size:0.6875rem;color:var(--ink-2);font-weight:600;width:34px}

  .rx-row{display:grid;grid-template-columns:minmax(0,2fr) 80px 1fr auto;
    align-items:center;gap:10px;padding:10px 0;border-top:1px solid var(--line-2,#ece9e4)}
  .rx-row:first-child{border-top:0;padding-top:0}
  .rx-row.header{padding-bottom:5px;border-bottom:1px solid var(--line-2,#ece9e4);margin-bottom:4px}
  .rx-name{font-weight:600;font-size:0.8125rem;display:flex;align-items:center;gap:7px;flex-wrap:wrap}
  .rx-gen{font-size:0.6875rem;color:var(--mute);margin-top:1px}
  .rx-cell{font-size:0.75rem;color:var(--ink-2);font-family:ui-monospace,monospace}
  .rx-cell.label{font-size:0.65625rem;color:var(--mute);font-family:inherit;
    text-transform:uppercase;letter-spacing:.05em;font-weight:600}
  .rx-warn{display:inline-flex;align-items:center;gap:4px;padding:2px 7px;border-radius:999px;
    background:var(--warn-soft);color:var(--warn-ink);font-size:0.65625rem;font-weight:600}
  .rx-badge{display:inline-flex;padding:2px 8px;border-radius:999px;font-size:0.65625rem;font-weight:600}
  .rx-badge.continue{background:var(--accent-soft);color:var(--accent-ink)}
  .rx-badge.reduce{background:var(--warn-soft);color:var(--warn-ink)}

  .order-group-h{display:flex;align-items:center;gap:8px;font-size:0.6875rem;
    text-transform:uppercase;letter-spacing:.06em;color:var(--mute);font-weight:600;
    padding:10px 0 6px;border-top:1px solid var(--line-2,#ece9e4)}
  .order-group-h:first-child{border-top:0;padding-top:2px}
  .order-row{display:grid;grid-template-columns:1fr auto auto;gap:10px;align-items:center;
    padding:9px 0;border-top:1px dashed var(--line-2,#ece9e4)}
  .order-row:first-child{border-top:0}
  .order-name{font-size:0.8125rem;font-weight:500}
  .order-meta{font-size:0.6875rem;color:var(--mute);margin-top:1px}
  .order-urg{font-size:0.625rem;font-weight:700;padding:2px 7px;border-radius:3px;
    text-transform:uppercase;letter-spacing:.04em}
  .order-urg.routine{background:var(--line-2,#ece9e4);color:var(--ink-2)}
  .order-urg.stat{background:var(--danger-soft);color:var(--danger-ink)}
  .order-urg.urgent{background:var(--warn-soft);color:var(--warn-ink)}
  .order-urg.requested{background:var(--accent-soft);color:var(--accent-ink)}
  .order-urg.active{background:var(--good-soft);color:oklch(0.38 0.08 155)}

  .iconbtn{width:28px;height:28px;border-radius:6px;display:grid;place-items:center;
    color:var(--mute);background:transparent;border:0;cursor:pointer}
  .iconbtn:hover{background:var(--line-2,#ece9e4);color:var(--ink)}

  /* Right panel toggle */
  .enc-rtabs{display:flex;padding:0 14px;background:var(--surface);
    border-bottom:1px solid var(--line)}
  .enc-rtab{flex:1;padding:12px 8px;font-size:0.8125rem;font-weight:500;color:var(--mute);
    border-bottom:2px solid transparent;margin-bottom:-1px;background:transparent;
    display:flex;align-items:center;justify-content:center;gap:6px;transition:color .12s}
  .enc-rtab:hover{color:var(--ink-2)}
  .enc-rtab.active{color:var(--ink);border-bottom-color:var(--ink);font-weight:600}

  /* Encounter list (right \u{645}\u{631}\u{627}\u{62C}\u{639}\u{627}\u{62A} panel) */
  .enc-list{overflow-y:auto;flex:1;padding:8px 0}
  .enc-list-item{padding:12px 14px;cursor:pointer;border-bottom:1px solid var(--line-2,#ece9e4);
    transition:background .1s;position:relative}
  .enc-list-item:hover{background:var(--bg)}
  .enc-list-item.selected{background:var(--accent-soft);border-inline-start:3px solid var(--accent)}
  .enc-list-item .enc-li-row{display:flex;align-items:center;gap:7px;margin-bottom:4px}
  .enc-li-date{font-size:0.6875rem;color:var(--mute);font-family:ui-monospace,monospace}
  .enc-li-type{font-size:0.65625rem;padding:2px 7px;border-radius:999px;
    background:var(--line-2,#ece9e4);color:var(--ink-2);font-weight:500}
  .enc-li-status{font-size:0.625rem;padding:2px 6px;border-radius:999px;font-weight:600}
  .enc-li-status.live{background:var(--good-soft);color:oklch(0.38 0.08 155)}
  .enc-li-status.done{background:var(--line-2,#ece9e4);color:var(--ink-2)}
  .enc-li-status.emergency{background:var(--danger-soft);color:var(--danger-ink)}
  .enc-live-dot{width:6px;height:6px;border-radius:50%;background:oklch(0.55 0.09 155);
    animation:pulse-dot 1.6s infinite;flex-shrink:0}
  @keyframes pulse-dot{0%{box-shadow:0 0 0 0 rgba(22,163,74,.4)}70%{box-shadow:0 0 0 6px rgba(22,163,74,0)}100%{box-shadow:0 0 0 0 rgba(22,163,74,0)}}
  .enc-li-title{font-size:0.8125rem;font-weight:600;color:var(--ink);margin-bottom:3px;
    white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
  .enc-li-counts{font-size:0.6875rem;color:var(--mute)}

  /* AI assistant panel \u{2014} conversational */
  .ai-panel{display:flex;flex-direction:column;flex:1;overflow:hidden;min-height:0}
  .ai-chat-head{display:flex;align-items:center;gap:10px;padding:12px 14px;
    border-bottom:1px solid var(--line-2,#ece9e4);background:var(--surface);flex-shrink:0}
  .ai-chat-avatar{width:32px;height:32px;border-radius:9px;flex-shrink:0;
    background:linear-gradient(135deg,var(--accent),var(--navy));
    display:grid;place-items:center;color:#fff;font-size:0.9375rem}
  .ai-panel-title{font-weight:700;font-size:0.84375rem;color:var(--ink);margin-bottom:2px}
  .ai-panel-sub{font-size:0.6875rem;color:var(--mute);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
  .ai-newchat{margin-inline-start:auto;flex-shrink:0;font-family:inherit;font-size:0.6875rem;
    padding:4px 9px;border-radius:7px;border:1px solid var(--line);background:var(--bg);
    color:var(--ink-2);cursor:pointer;transition:all .12s}
  .ai-newchat:hover:not(:disabled){border-color:var(--accent);color:var(--accent-ink)}
  .ai-newchat:disabled{opacity:.5;cursor:default}
  .ai-panel-body{flex:1;overflow-y:auto;padding:12px 14px;min-height:0}

  .ai-chat{display:flex;flex-direction:column;gap:10px}
  .ai-chat-intro{font-size:0.75rem;line-height:1.8;color:var(--mute);
    background:var(--bg);border:1px dashed var(--line);border-radius:9px;padding:10px 12px;margin-bottom:4px}
  .ai-msg{display:flex;flex-direction:column;max-width:100%;animation:ai-msg-in .18s ease}
  .ai-msg.user{align-items:flex-start}
  .ai-msg.bot{align-items:flex-end}
  @keyframes ai-msg-in{from{opacity:0;transform:translateY(4px)}to{opacity:1;transform:none}}
  .ai-bubble{max-width:88%;padding:9px 12px;border-radius:11px;font-size:0.78125rem;line-height:1.8;
    word-break:break-word}
  .ai-bubble-text{white-space:pre-wrap}
  /* Tail corner sits on the side the bubble hangs off: user is inline-start
     (right in RTL), assistant inline-end (left). */
  .ai-bubble.user{background:var(--ink);color:#faf7f4;border-end-start-radius:4px}
  .ai-bubble.bot{background:var(--surface);border:1px solid var(--line);color:var(--ink);
    border-end-end-radius:4px}
  .ai-bubble.bot.error{background:var(--danger-soft);border-color:transparent;color:var(--danger-ink)}
  .ai-typing{display:flex;gap:4px;align-items:center;padding:12px}
  .ai-typing span{width:5px;height:5px;border-radius:50%;background:var(--mute);
    animation:ai-typing-dot .9s ease infinite}
  .ai-typing span:nth-child(2){animation-delay:.15s}
  .ai-typing span:nth-child(3){animation-delay:.3s}
  @keyframes ai-typing-dot{0%,60%,100%{opacity:.25}30%{opacity:1}}
  .ai-quick-q{display:block;width:100%;text-align:start;padding:9px 11px;margin-bottom:6px;
    background:var(--surface);border:1px solid var(--line);border-radius:8px;
    font-size:0.75rem;color:var(--ink-2);transition:all .12s;cursor:pointer;font-family:inherit}
  .ai-quick-q:hover{background:#fff;border-color:var(--accent);color:var(--ink)}
  .ai-quick-q-arrow{float:left;color:var(--mute);font-size:0.625rem;margin-inline-start:4px;transform:scaleX(var(--dir-flip,1))}
  /* The \xab\u{2190}\xbb is an onward arrow at the row's inline END: mirrored, and floated
     right, under an LTR language (MIRROR_ICON's --dir-flip). */
  [dir="ltr"] .ai-quick-q-arrow{float:right}
  .ai-answer-meta{font-size:0.65625rem;color:var(--mute);margin-bottom:6px;display:flex;gap:6px;align-items:center}
  .ai-follow-ups{display:flex;flex-direction:column;gap:5px;margin-top:7px;width:88%;align-self:flex-end}
  .ai-follow-up-label{font-size:0.65625rem;color:var(--mute);text-transform:uppercase;letter-spacing:.05em;font-weight:600;margin-bottom:4px}
  .ai-composer{border-top:1px solid var(--line);padding:11px 14px;background:var(--surface)}
  .ai-composer-row{display:flex;align-items:center;gap:7px;padding:7px 11px;
    border-radius:9px;background:var(--bg);border:1px solid var(--line)}
  .ai-composer-row input{flex:1;border:0;background:transparent;outline:none;font-size:0.8125rem;font-family:inherit}
  .ai-composer-row input::placeholder{color:var(--mute)}
  .ai-send{width:28px;height:28px;border-radius:7px;background:var(--ink);color:#fff;
    display:grid;place-items:center;flex-shrink:0;border:0;cursor:pointer;font-size:0.875rem}
  .ai-send:hover:not(:disabled){background:var(--accent)}
  .ai-send:disabled{opacity:.4;cursor:default}
  .ai-composer-row input:disabled{cursor:default}

  /* Collapsible left panel \u{2014} strip always visible */
  .enc-left-panel{
    display:flex;flex-direction:row;overflow:hidden;flex-shrink:0;
    transition:width .35s cubic-bezier(.4,0,.2,1);
    border-inline-end:1px solid var(--line);
  }
  .enc-left-panel.open{width:390px}
  .enc-left-panel.closed{width:40px}

  /* 40px always-visible strip */
  .enc-collapse-strip{
    width:40px;flex-shrink:0;display:flex;flex-direction:column;
    align-items:center;padding:8px 0;gap:4px;
    background:var(--surface);border-inline-start:1px solid var(--line-2,#ece9e4);
    order:1
  }
  .enc-collapse-btn{
    width:26px;height:26px;border-radius:6px;border:1px solid var(--line);
    background:transparent;display:flex;align-items:center;justify-content:center;
    cursor:pointer;color:var(--mute);transition:all .18s;flex-shrink:0;margin-bottom:6px
  }
  .enc-collapse-btn:hover{background:var(--line-2,#ece9e4);color:var(--ink)}
  .enc-collapse-btn svg{transition:transform .35s cubic-bezier(.4,0,.2,1)}
  /* Hide chevron when closed \u{2014} only tab buttons show */
  .enc-left-panel.closed .enc-collapse-btn{display:none}

  /* Vertical tab buttons \u{2014} only visible when collapsed */
  .enc-strip-tab{
    display:none;width:32px;padding:10px 0;align-items:center;justify-content:center;
    cursor:pointer;border:1px solid var(--line);background:transparent;
    border-radius:7px;transition:background .15s,color .15s,border-color .15s;
    flex-shrink:0
  }
  .enc-left-panel.closed .enc-strip-tab{display:flex}
  .enc-strip-tab:hover{background:var(--line-2,#ece9e4);border-color:var(--ink-2)}
  .enc-strip-tab.active{background:var(--accent-soft);border-color:var(--accent)}
  .enc-strip-label{
    writing-mode:vertical-lr;font-size:0.6875rem;font-weight:600;
    letter-spacing:.06em;transform:rotate(180deg);
    color:var(--mute);transition:color .15s;user-select:none
  }
  .enc-strip-tab.active .enc-strip-label{color:var(--accent-ink)}
  .enc-strip-tab:hover .enc-strip-label{color:var(--ink)}

  /* Scrollable panel content \u{2014} 350px, hides as panel collapses */
  .enc-panel-inner{
    width:350px;flex-shrink:0;display:flex;flex-direction:column;
    overflow:hidden;transition:opacity .2s;order:2
  }
  .enc-left-panel.closed .enc-panel-inner{opacity:0;pointer-events:none}

  /* \u{2500}\u{2500} \xab\u{62A}\u{62D}\u{644}\u{6CC}\u{644}\xbb \u{2014} the analysis timeline (\xa74.5: rem everywhere; the 1px hairlines
        are the documented optical exception, and the plot itself is 1:1 pixel
        by contract \u{2014} see the kit's useMeasuredWidth). \u{2500}\u{2500}\u{2500}\u{2500}\u{2500}\u{2500}\u{2500}\u{2500}\u{2500}\u{2500}\u{2500}\u{2500}\u{2500}\u{2500}\u{2500}\u{2500}\u{2500}\u{2500}\u{2500}\u{2500}\u{2500}\u{2500} */
  .an-root{display:flex;flex-direction:column;gap:0.75rem}

  .an-toolbar{display:flex;flex-wrap:wrap;align-items:center;gap:0.5rem 0.75rem;
    padding:0.625rem 0.875rem;background:var(--panel-2);border:1px solid var(--line);
    border-radius:0.75rem;box-shadow:0 1px 2px rgba(20,20,15,.04)}
  .an-toolbar-l{font-size:0.6875rem;color:var(--mute);font-weight:700}
  .an-toolbar-end{margin-inline-start:auto;display:flex;align-items:center;gap:0.5rem}
  .an-seg{display:flex;background:var(--bg);border:1px solid var(--line);border-radius:0.5625rem;padding:0.125rem}
  .an-seg-b{border:0;background:none;font:inherit;font-size:0.71875rem;color:var(--ink-2);
    padding:0.25rem 0.75rem;border-radius:0.4375rem;cursor:pointer;min-height:1.75rem}
  .an-seg-b:hover{color:var(--ink)}
  .an-seg-b.on{background:var(--panel-2);color:var(--ink);font-weight:800;box-shadow:0 1px 2px rgba(20,20,15,.06)}

  .an-range{display:flex;align-items:center;gap:0.5rem;width:100%;padding-top:0.125rem}
  .an-range-l{font-size:0.625rem;color:var(--mute);font-weight:700}
  .an-range-v{font-size:0.6875rem;color:var(--ink);font-weight:800;
    background:var(--accent-soft);border-radius:999px;padding:0.125rem 0.625rem}
  .an-range-x{display:inline-flex;align-items:center;gap:0.25rem;border:1px solid var(--line);
    background:var(--panel-2);color:var(--ink-2);font:inherit;font-size:0.625rem;font-weight:700;
    border-radius:0.4375rem;padding:0.1875rem 0.5rem;cursor:pointer;min-height:1.5rem}
  .an-range-x:hover{border-color:var(--accent);color:var(--accent-ink)}

  .an-card{background:var(--panel-2);border:1px solid var(--line);border-radius:0.875rem;
    box-shadow:0 1px 2px rgba(20,20,15,.04);overflow:clip}
  /* Drag across the plot to zoom. pan-y keeps the page scrollable under a
     finger while a horizontal drag still selects a range. */
  .an-zoomable{position:relative;cursor:crosshair;touch-action:pan-y}
  .an-zoomable.dragging{user-select:none}
  .an-brush{position:absolute;top:0;bottom:0;z-index:8;pointer-events:none;
    background:var(--accent-soft);border-inline:1px solid var(--accent)}
  .an-brush-label{position:absolute;top:0.375rem;left:50%;transform:translateX(-50%);
    white-space:nowrap;background:var(--ink);color:var(--panel-2);
    font-size:0.625rem;font-weight:800;border-radius:0.375rem;padding:0.125rem 0.5rem}

  .an-lane{display:grid;grid-template-columns:10.75rem minmax(0,1fr);border-top:1px solid var(--line-2)}
  .an-lane:first-child{border-top:0}
  /* The clock never scrolls away while the lanes beneath it do. */
  .an-lane-ruler{position:sticky;top:0;z-index:6;background:var(--panel-2);
    box-shadow:0 3px 0.5rem -0.3125rem rgba(10,20,30,.14)}
  .an-rail{padding:0.625rem 0.875rem;border-inline-end:1px solid var(--line-2);
    display:flex;flex-direction:column;justify-content:center;gap:0.125rem;min-width:0}
  .an-rail-t{font-size:0.75rem;font-weight:800;color:var(--ink);overflow-wrap:anywhere}
  .an-rail-u{font-size:0.625rem;color:var(--mute)}
  .an-rail-v{font-size:1rem;font-weight:800;letter-spacing:-.02em;direction:ltr;text-align:end;color:var(--ink)}
  .an-keys{display:flex;flex-direction:column;gap:0.0625rem;margin-top:0.1875rem}
  .an-key{display:flex;align-items:center;gap:0.375rem;font-size:0.625rem;color:var(--ink-2)}
  .an-key i{width:0.75rem;height:0;border-top:2px solid;border-radius:2px}
  .an-rm{align-self:flex-start;margin-top:0.25rem;border:1px solid var(--line);background:var(--bg);
    color:var(--mute);font:inherit;font-size:0.625rem;border-radius:0.4375rem;
    padding:0.125rem 0.5rem;cursor:pointer;min-height:1.375rem}
  .an-rm:hover{color:var(--danger);border-color:var(--danger)}
  .an-plot{position:relative;direction:ltr;min-width:0}
  .an-plot svg{display:block;width:100%}
  .an-lane-empty{padding:0.75rem 0.875rem;color:var(--mute);font-size:0.71875rem}
  .an-empty-cta{padding:0;grid-column:1/-1}

  .an-obs-head{display:flex;flex-wrap:wrap;align-items:center;gap:0.5rem 0.625rem;
    padding:0.6875rem 0.875rem;border-top:1px solid var(--line-2);background:var(--bg)}
  .an-obs-t{font-size:0.75rem;font-weight:800;color:var(--ink)}
  .an-obs-hint{font-size:0.625rem;color:var(--mute);flex:1 1 12rem;min-width:0}
  .an-obs-btn{margin-inline-start:auto}
  .an-obs-count{font-size:0.625rem;font-weight:700;color:var(--ink-2)}
  .an-chips{display:flex;flex-wrap:wrap;gap:0.375rem;width:100%}
  .an-chip{display:inline-flex;align-items:center;gap:0.375rem;background:var(--panel-2);
    border:1px solid var(--line);border-radius:999px;padding:0.125rem 0.3125rem 0.125rem 0.6875rem;
    font-size:0.625rem;font-weight:700;color:var(--ink-2)}
  .an-chip::before{content:"";width:0.4375rem;height:0.4375rem;border-radius:50%;background:var(--accent)}
  .an-chip button{border:0;background:var(--bg);color:var(--mute);width:1.125rem;height:1.125rem;
    border-radius:50%;cursor:pointer;display:grid;place-items:center;padding:0}
  .an-chip button:hover{background:var(--danger-soft);color:var(--danger)}

  .an-legend{display:flex;gap:0.875rem;flex-wrap:wrap;padding:0.5625rem 1rem;
    border-top:1px solid var(--line-2);background:var(--bg);font-size:0.65625rem;color:var(--ink-2)}
  .an-legend-l{font-weight:700;color:var(--mute)}
  .an-legend-i{display:flex;align-items:center;gap:0.375rem}
  .an-legend-i .lg-dot{width:0.625rem;height:0.625rem;border-radius:50%;border:2px solid var(--mute)}
  .an-legend-i .lg-bar{width:0.875rem;height:0.5625rem;border-radius:2px 0.25rem 0.25rem 2px;background:var(--navy)}
  .an-legend-i .lg-sq{width:0.5rem;height:0.5rem;border-radius:2px}
  .an-legend-i .lg-now{width:2px;height:0.75rem;background:var(--accent)}

  .an-note{display:flex;flex-wrap:wrap;align-items:center;gap:0.5rem;padding:0.5rem 0.875rem;
    background:var(--warn-soft);border:1px solid var(--warn);border-radius:0.625rem;
    font-size:0.71875rem;color:var(--warn-ink)}

  /* Compact tier (\xa74.1): the rail narrows before the plot does \u{2014} the plot is
     where the information is. */
  @media(max-width:1180px){
    .an-lane{grid-template-columns:8.25rem minmax(0,1fr)}
    .an-rail{padding:0.5rem 0.625rem}
    .an-obs-hint{display:none}
  }
`;

});

parcelRegister("25kYp", function(module, exports) {

$parcel$export(module.exports, "default", () => $489311c8b0711f95$export$2e2bcd8739ae039);
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $jOGbh = parcelRequire("jOGbh");

var $2Ieny = parcelRequire("2Ieny");

var $51HmE = parcelRequire("51HmE");

var $gq4TR = parcelRequire("gq4TR");

var $5UCQz = parcelRequire("5UCQz");

var $2Oaoe = parcelRequire("2Oaoe");

var $bkBaq = parcelRequire("bkBaq");
// The desktop Record's zone-① header (archetype C, DESIGN-CONCEPT §2.3-C).
// It is the shared `InnerPageHeader` in its identity-band density: a back
// affordance to the referrer (§3.2 — replaces the old, banned breadcrumb),
// the patient identity (avatar + name + live-visit status + کد ملی), a
// dot-separated meta line, and the quick stat chips on the end edge.
// (The ویرایش / ویزیت جدید actions were removed per product decision.)
// «ویزیت همین الان» sits beside the stat chips (PM-0565, owner 2026-10-24): it was
// at the top of the «مراجعات» rail, one tab deep; here it is on every tab. Doctor
// panel only — the button renders nothing where the host did not opt in.
const $489311c8b0711f95$var$PatientHeader = ({ p: p, onBack: onBack })=>{
    const { formatDigits: formatDigits, t: t } = (0, $LNQP4.default)();
    const initials = p.name ? p.name.split(' ').map((w)=>w[0]).join('').slice(0, 2) : t('common.punct.question');
    const isLive = (p.encounters || []).some((e)=>e.status === 'in_progress' || e.status === 'arrived');
    const avatar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: '2.5rem',
            height: '2.5rem',
            borderRadius: '0.75rem',
            flexShrink: 0,
            display: 'grid',
            placeItems: 'center',
            background: (0, $2Ieny.CL).text1,
            color: (0, $2Ieny.CL).surface,
            fontWeight: 700,
            fontSize: '0.9375rem'
        }
    }, initials);
    const status = isLive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.375rem',
            paddingInline: '0.625rem',
            paddingBlock: '0.1875rem',
            borderRadius: 999,
            background: (0, $2Ieny.CL).accentSoft,
            color: (0, $2Ieny.CL).accentInk,
            fontSize: '0.71875rem',
            fontWeight: 600
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: '0.375rem',
            height: '0.375rem',
            borderRadius: '50%',
            background: (0, $2Ieny.CL).accent
        }
    }), t('patient.visitInProgress'));
    const badges = p.nationalId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.71875rem',
            color: (0, $2Ieny.CL).text3,
            background: (0, $2Ieny.CL).bg,
            border: `1px solid ${(0, $2Ieny.CL).border}`,
            paddingInline: '0.5625rem',
            paddingBlock: '0.1875rem',
            borderRadius: '0.4375rem',
            fontWeight: 600
        }
    }, t('common.labels.code'), " ", (0, $51HmE.faNum)(p.nationalId, formatDigits));
    const phones = (0, $bkBaq.patientPhoneParts)(p);
    const hasPhone = Boolean(phones.primary) || phones.others.length > 0;
    const meta = [
        p.age != null && t('patient.ageYears', {
            age: (0, $51HmE.faNum)(p.age, formatDigits),
            count: Number(p.age)
        }),
        p.bloodType && t('patient.bloodTypeLabel', {
            type: p.bloodType
        }),
        // The main number through the kit's PhoneNumber — `phone.forDisplay`'s spelling
        // (landline-tolerant, the raw value when it cannot parse one, so this line never
        // blanks) in the page's digits, as an LTR island — and «+N» for the record's
        // other numbers, which opens them (PM-0536).
        hasPhone && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.375rem'
            }
        }, t('common.labels.phone'), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2Oaoe.PatientPrimaryPhone), {
            patient: p
        }), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2Oaoe.PatientMorePhones), {
            patient: p
        })),
        p.insurance && t('patient.insuranceLabel', {
            name: (0, $gq4TR.INSURANCE_LABEL_KEYS)[p.insurance] ? t((0, $gq4TR.INSURANCE_LABEL_KEYS)[p.insurance]) : p.insurance
        })
    ];
    const stats = [
        p.age != null && {
            label: t('common.labels.age'),
            value: (0, $51HmE.faNum)(p.age, formatDigits)
        },
        p.bmi != null && {
            label: 'BMI',
            value: (0, $51HmE.faNum)(p.bmi.toFixed(1), formatDigits)
        },
        p.lastWeight != null && {
            label: t('patient.vitals.weightKg'),
            value: (0, $51HmE.faNum)(p.lastWeight, formatDigits)
        },
        p.visitsCount != null && {
            label: t('patient.totalVisits'),
            value: (0, $51HmE.faNum)(p.visitsCount, formatDigits),
            accent: true
        }
    ].filter(Boolean);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $jOGbh.default), {
        "data-testid": "patient-detail-header",
        onBack: onBack,
        backLabel: t('common.actions.back'),
        title: p.name || "\u2014",
        avatar: avatar,
        status: status,
        badges: badges,
        meta: meta,
        stats: stats
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5UCQz.default), {
        patient: p,
        compact: true,
        testId: "visits-visit-now"
    }));
};
var $489311c8b0711f95$export$2e2bcd8739ae039 = $489311c8b0711f95$var$PatientHeader;

});
parcelRegister("51HmE", function(module, exports) {

$parcel$export(module.exports, "faNum", () => $3a8eaefcca13cf5f$export$25b095a1ad9e1176);
$parcel$export(module.exports, "isoToJalali", () => $3a8eaefcca13cf5f$export$d5126f8c047ed6ad);
// Shared pure helpers for the desktop Patient record.
// Locale digits (DESIGN-CONCEPT §16.1, hard rule): every number the UI *displays*
// on the Persian surface renders in Persian digits — mixing digit sets in one
// view is a defect. Display-only: storage/wire stay ASCII. Separators, units and
// Latin identifiers pass through untouched.
/**
 * Digits in the reading locale.
 *
 * This used to hardcode the Persian digit set. It now delegates to the locale's
 * own numbering system, so an English UI keeps Latin digits — and it takes the
 * formatter as an argument rather than reaching for a hook, because it is also
 * called from plain helpers and from tests.
 *
 * Without a formatter it returns the value untouched, which is the correct
 * Latin-digit rendering rather than a wrong Persian one.
 */ 
var $gdEay = parcelRequire("gdEay");
const $3a8eaefcca13cf5f$export$25b095a1ad9e1176 = (n, formatDigits)=>{
    if (n == null || n === '') return n;
    return formatDigits ? formatDigits(n) : String(n);
};
const $3a8eaefcca13cf5f$export$d5126f8c047ed6ad = (iso, formatDate)=>{
    if (!iso) return '';
    const [y, m, d] = iso.slice(0, 10).split('-');
    const at = new Date(`${y}-${m}-${d}T12:00:00Z`);
    return formatDate ? formatDate(at, 'short') : iso.slice(0, 10);
};

});


parcelRegister("hkwbL", function(module, exports) {

$parcel$export(module.exports, "default", () => $39b130ae8b467aab$export$2e2bcd8739ae039);
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");

var $QG9Z3 = parcelRequire("QG9Z3");

var $2Ieny = parcelRequire("2Ieny");

var $7vtJ3 = parcelRequire("7vtJ3");
// Persistent allergy / alert safety strip shown above every non-overview tab.
const $39b130ae8b467aab$var$SafetyStrip = ({ allergies: allergies = [], alerts: alerts = [] })=>{
    const { t: t } = (0, $LNQP4.default)();
    if (!allergies.length && !alerts.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            padding: '6px 28px',
            background: 'rgba(220,38,38,0.04)',
            borderBottom: `1px solid ${(0, $2Ieny.CL).border}`,
            overflowX: 'auto',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 4,
            fontSize: '0.625rem',
            textTransform: 'uppercase',
            letterSpacing: '0.08em',
            color: (0, $2Ieny.CL).text2,
            fontWeight: 600,
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $QG9Z3.default), {
        size: 12
    }), " ", t('patient.safety')), allergies.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 5,
            paddingInlineStart: 10,
            borderInlineStart: `1px solid ${(0, $2Ieny.CL).border}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.625rem',
            color: (0, $2Ieny.CL).text3,
            flexShrink: 0
        }
    }, t('patient.allergies.title')), allergies.map((a, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7vtJ3.Pill), {
            key: i,
            tone: "danger"
        }, a))), alerts.map((a, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7vtJ3.Pill), {
            key: i,
            tone: a.severity === 'CRITICAL' ? 'danger' : 'warn'
        }, a.message)));
};
var $39b130ae8b467aab$export$2e2bcd8739ae039 = $39b130ae8b467aab$var$SafetyStrip;

});
parcelRegister("7vtJ3", function(module, exports) {

$parcel$export(module.exports, "Pill", () => $749083270f41223e$export$d2cf3038149dd1b5);
// Shared display primitives for the desktop Patient record.
//
// `Sparkline` and `TrendChart` used to live here (and, separately, in the mobile
// record's kit). Both are now framework components — `import { Sparkline,
// TrendChart } from '@parsina/framework'` — because a trend glyph is a
// design-language primitive, not a doctor-app one.

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $bHjRG = parcelRequire("bHjRG");
// ── Clinical pill ─────────────────────────────────────────────────────────────
// Thin adapter over the kit `Badge` (DESIGN §1 — no hand-rolled chips): the
// screen's clinical `tone` vocabulary maps onto Badge's CVA variants.
const $749083270f41223e$var$TONE_VARIANT = {
    accent: 'default',
    good: 'success',
    warn: 'warning',
    danger: 'destructive',
    mono: 'outline',
    neutral: 'outline'
};
const $749083270f41223e$export$d2cf3038149dd1b5 = ({ tone: tone = 'neutral', size: size, children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bHjRG.default), {
        variant: $749083270f41223e$var$TONE_VARIANT[tone] || 'outline',
        ...rest
    }, children);

});


parcelRegister("3bbzC", function(module, exports) {

$parcel$export(module.exports, "TABS", () => $54fb4340d9fc8f69$export$73b877b58963a4f);
$parcel$export(module.exports, "default", () => $54fb4340d9fc8f69$export$2e2bcd8739ae039);
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");
const $54fb4340d9fc8f69$export$73b877b58963a4f = (t)=>[
        {
            id: 'overview',
            label: t('patient.tabs.overview')
        },
        // «تحلیل» sits next to «خلاصه» because the two are companions: the summary is
        // *what changed*, the analysis is *how it moved* — the record reads
        // narrative → evidence.
        {
            id: 'analysis',
            label: t('patient.tabs.analysis')
        },
        // «مشاهدات» — vitals + laboratory analytes. The route segment stays `labs`
        // so existing links and bookmarks keep resolving.
        {
            id: 'labs',
            label: t('patient.tabs.observations')
        },
        // «دستورات و اقدامات» was removed from the record: orders are read in the
        // visit they belong to («تاریخچه مراجعات» → دستورات) rather than as a
        // standalone patient-level section.
        // «تاریخچه مراجعات» — the tab reads as a chronological visit history
        // (newest first), not as a static file cabinet. Route segment stays `visits`.
        {
            id: 'visits',
            label: t('patient.tabs.visitHistory')
        },
        {
            id: 'files',
            label: t('patient.tabs.files')
        }
    ];
const $54fb4340d9fc8f69$var$ClinicalTabBar = ({ tab: tab, setTab: setTab })=>{
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "pt-tabs"
    }, $54fb4340d9fc8f69$export$73b877b58963a4f(t).map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: item.id,
            className: 'pt-tab' + (tab === item.id ? ' active' : ''),
            onClick: ()=>setTab(item.id)
        }, item.label, item.id === 'overview' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "pt-tab-dot"
        }))));
};
var $54fb4340d9fc8f69$export$2e2bcd8739ae039 = $54fb4340d9fc8f69$var$ClinicalTabBar;

});

parcelRegister("aX9TZ", function(module, exports) {

$parcel$export(module.exports, "VitalTileSkeleton", () => $d1e1ffd8e261dcdc$export$cb1cd28f421b0672);
$parcel$export(module.exports, "PatientTabSkeleton", () => $d1e1ffd8e261dcdc$export$33f6e3467d893933);
$parcel$export(module.exports, "default", () => $d1e1ffd8e261dcdc$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $66joL = parcelRequire("66joL");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $2Ieny = parcelRequire("2Ieny");
// ─────────────────────────────────────────────────────────────────────────────
// The patient record's loading shapes (DESIGN.md §"Loading & skeleton").
//
// `PatientDetailSkeleton` is the whole page on first entry: breadcrumb strip,
// identity row, vitals strip, the five-tab bar, then the overview's cards —
// each at the height the real `PatientHeader` / `SafetyStrip` / `ClinicalTabBar`
// draw, so the record fills the shape in place. `PatientTabSkeleton` is the
// pane alone, for a refresh while the header is already on screen, and it is
// per tab: the analysis pane is a chart, the observations pane a tile grid,
// the visits pane a list — one generic skeleton would fit none of them.
// ─────────────────────────────────────────────────────────────────────────────
const $d1e1ffd8e261dcdc$var$TAB_WIDTHS = [
    70,
    60,
    110,
    90,
    65
];
const $d1e1ffd8e261dcdc$var$SectionCardSkeleton = ({ lines: lines = 2 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            background: (0, $2Ieny.CL).surface,
            borderRadius: 10,
            padding: 20,
            border: `1px solid ${(0, $2Ieny.CL).border}`,
            display: 'flex',
            flexDirection: 'column',
            gap: 12
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 120,
        height: 14
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonText), {
        lines: lines,
        height: 12,
        lastWidth: "80%"
    }));
const $d1e1ffd8e261dcdc$export$cb1cd28f421b0672 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            background: (0, $2Ieny.CL).surface,
            border: `1px solid ${(0, $2Ieny.CL).border}`,
            borderRadius: 10,
            padding: '0.75rem 0.875rem',
            display: 'flex',
            flexDirection: 'column',
            gap: 8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 8,
        circle: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 64,
        height: 11
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'space-between',
            gap: 8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 56,
        height: 18
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 70,
        height: 22,
        radius: (0, $jTCZr.RADIUS).chip
    })));
const $d1e1ffd8e261dcdc$export$33f6e3467d893933 = ({ tab: tab = 'overview', label: label })=>{
    const { t: t } = (0, $LNQP4.default)();
    const lbl = label ?? t('common.state.loading');
    let body;
    switch(tab){
        case 'analysis':
            body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonChart), {
                height: 220,
                line: true,
                legend: 3,
                label: lbl
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d1e1ffd8e261dcdc$var$SectionCardSkeleton, {
                lines: 3
            }));
            break;
        case 'labs':
            body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(10.9375rem, 1fr))',
                    gap: '0.625rem'
                }
            }, Array.from({
                length: 6
            }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d1e1ffd8e261dcdc$export$cb1cd28f421b0672, {
                    key: i
                }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d1e1ffd8e261dcdc$var$SectionCardSkeleton, {
                lines: 3
            }));
            break;
        case 'visits':
            body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonList), {
                count: 4,
                avatar: false,
                trailing: 72,
                label: lbl
            });
            break;
        case 'files':
            body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(14rem, 1fr))',
                    gap: 12
                }
            }, Array.from({
                length: 4
            }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonCard), {
                    key: i,
                    avatar: false,
                    lines: 2,
                    chips: 1,
                    actions: 0,
                    label: lbl
                })));
            break;
        default:
            body = [
                1,
                2,
                3
            ].map((i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d1e1ffd8e261dcdc$var$SectionCardSkeleton, {
                    key: i
                }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonRegion), {
        label: lbl,
        "data-testid": `patient-tab-skeleton-${tab}`,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 16
        }
    }, body);
};
/** The whole record on first entry. */ const $d1e1ffd8e261dcdc$var$PatientDetailSkeleton = ({ tab: tab = 'overview', label: label })=>{
    const { t: t } = (0, $LNQP4.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonRegion), {
        label: label ?? t('common.state.loading'),
        "data-testid": "patient-detail-skeleton",
        style: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            background: (0, $2Ieny.CL).bg,
            fontFamily: 'var(--app-font)',
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            background: (0, $2Ieny.CL).surface2,
            borderBottom: `1px solid ${(0, $2Ieny.CL).border}`,
            padding: '7px 28px',
            display: 'flex',
            gap: 8,
            alignItems: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 60,
        height: 12
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 8,
        height: 8,
        radius: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 50,
        height: 12
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 8,
        height: 8,
        radius: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 90,
        height: 12
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            background: (0, $2Ieny.CL).surface,
            borderBottom: `1px solid ${(0, $2Ieny.CL).border}`,
            padding: '14px 28px',
            display: 'flex',
            gap: 14,
            alignItems: 'flex-start'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonAvatar), {
        size: 50
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: 8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 10,
            alignItems: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 140,
        height: 22
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 70,
        height: 20,
        radius: (0, $jTCZr.RADIUS).pill
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 50,
        height: 20,
        radius: (0, $jTCZr.RADIUS).pill
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 14
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 60,
        height: 12
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 80,
        height: 12
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 55,
        height: 12
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
        width: 100,
        height: 12
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonButton), {
        size: "sm",
        width: 104
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonButton), {
        size: "sm",
        width: 36
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            background: (0, $2Ieny.CL).surface2,
            borderBottom: `1px solid ${(0, $2Ieny.CL).border}`,
            display: 'flex',
            padding: '9px 28px',
            overflowX: 'hidden'
        }
    }, [
        130,
        110,
        120,
        110
    ].map((w, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                padding: '0 16px',
                borderInlineEnd: i < 3 ? `1px solid ${(0, $2Ieny.CL).border}` : 'none',
                display: 'flex',
                flexDirection: 'column',
                gap: 4
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
            width: 60,
            height: 10
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.default), {
            width: w,
            height: 16
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonTabs), {
        widths: $d1e1ffd8e261dcdc$var$TAB_WIDTHS,
        gap: 0,
        padding: "12px 14px",
        style: {
            background: (0, $2Ieny.CL).surface,
            borderBottom: `1px solid ${(0, $2Ieny.CL).border}`,
            padding: '0 28px'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            padding: 28,
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d1e1ffd8e261dcdc$export$33f6e3467d893933, {
        tab: tab
    })));
};
var $d1e1ffd8e261dcdc$export$2e2bcd8739ae039 = $d1e1ffd8e261dcdc$var$PatientDetailSkeleton;

});

parcelRegister("hUKVy", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb877cde7ef1a601$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
parcelRequire("5N0ZI");
var $3Amwd = parcelRequire("3Amwd");
var $6usBW = parcelRequire("6usBW");

var $QG9Z3 = parcelRequire("QG9Z3");
var $huNwV = parcelRequire("huNwV");
var $3FyOw = parcelRequire("3FyOw");
var $4CVxl = parcelRequire("4CVxl");
var $aVx4q = parcelRequire("aVx4q");
var $fX0JO = parcelRequire("fX0JO");
var $6TdpC = parcelRequire("6TdpC");

var $eVM84 = parcelRequire("eVM84");

var $3OnFU = parcelRequire("3OnFU");

var $2Ieny = parcelRequire("2Ieny");

var $i9Cif = parcelRequire("i9Cif");

var $gq4TR = parcelRequire("gq4TR");

var $51HmE = parcelRequire("51HmE");

var $j7Lry = parcelRequire("j7Lry");

var $g6gAc = parcelRequire("g6gAc");
// Overview-only label map (not shared with other tabs). Encounter *status*
// labels left with «مراجعات اخیر» when that rail block was removed.
const $bb877cde7ef1a601$var$ENCOUNTER_TYPE = (t)=>({
        ambulatory: t('patient.encType.outpatient'),
        emergency: t('common.urgency.emergency'),
        inpatient: t('patient.encType.inpatient'),
        observation: t('patient.encType.observation')
    });
// An ALLERGY's severity, on the generic scale — not visit.severity.*, which grades a
// drug interaction («Geringfügig» beside an allergy reads as "insignificant").
const $bb877cde7ef1a601$var$OV_SEVERITY = (t)=>({
        severe: {
            l: t('patient.allergies.severity.severe'),
            cls: 'high'
        },
        moderate: {
            l: t('patient.allergies.severity.moderate'),
            cls: 'mid'
        },
        mild: {
            l: t('patient.allergies.severity.mild'),
            cls: 'mid'
        }
    });
const $bb877cde7ef1a601$var$OverviewTab = ({ p: p, setTab: setTab, onRefresh: onRefresh })=>{
    const { formatDigits: formatDigits, formatDate: formatDate, t: t } = (0, $LNQP4.default)();
    const toast = (0, $6usBW.useToast)();
    const [orders, setOrders] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!p.id) return;
        setOrders(null);
        (0, $eVM84.bffQuery)((0, $j7Lry.LIST_DOCTOR_ORDERS_VISITS), {
            patientId: p.id
        }).then((r)=>setOrders(r.listDoctorOrders || [])).catch(()=>setOrders([]));
    }, [
        p.id
    ]);
    // ── Derived data ──────────────────────────────────────────────────────────
    const conditions = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const seen = new Set();
        return (p.clinicalConditions || []).filter((c)=>{
            if (seen.has(c.id)) return false;
            seen.add(c.id);
            return true;
        });
    }, [
        p.clinicalConditions
    ]);
    const activeConditions = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>conditions.filter((c)=>c.clinicalStatus === 'active'), [
        conditions
    ]);
    const medications = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const seen = new Set();
        return (p.clinicalMedications || []).filter((m)=>{
            if (seen.has(m.id)) return false;
            seen.add(m.id);
            return true;
        });
    }, [
        p.clinicalMedications
    ]);
    const activeMeds = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const byCode = {};
        medications.filter((m)=>m.status === 'active' || m.status === 'on-hold').forEach((m)=>{
            const key = m.code || m.display;
            if (!byCode[key] || (m.authoredOn || '') > (byCode[key].authoredOn || '')) byCode[key] = m;
        });
        return Object.values(byCode).sort((a, b)=>(b.authoredOn || '').localeCompare(a.authoredOn || ''));
    }, [
        medications
    ]);
    const allergies = p.clinicalAllergies || [];
    const abnormalObs = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const seen = new Set();
        return [
            ...p.clinicalObservations || []
        ].filter((o)=>{
            if (seen.has(o.id)) return false;
            seen.add(o.id);
            return true;
        }).filter((o)=>!(0, $gq4TR.VITAL_LOINC_SET).has(o.code)).filter((o)=>[
                'abnormal',
                'critical',
                'high',
                'low',
                'h',
                'l'
            ].includes((o.status || '').toLowerCase()));
    }, [
        p.clinicalObservations
    ]);
    const obsByCode = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const map = {};
        [
            ...p.clinicalObservations || []
        ].sort((a, b)=>(a.effectiveDate || a.createdAt || '').localeCompare(b.effectiveDate || b.createdAt || '')).forEach((o)=>{
            (map[o.code] = map[o.code] || []).push(o);
        });
        return map;
    }, [
        p.clinicalObservations
    ]);
    const abnormalLabs = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const seen = new Set();
        return abnormalObs.filter((o)=>{
            const k = o.code || o.display;
            if (seen.has(k)) return false;
            seen.add(k);
            return true;
        }).reverse().slice(0, 6).map((o)=>({
                ...o,
                series: (obsByCode[o.code] || []).map((x)=>parseFloat(x.value)).filter((v)=>!isNaN(v)).slice(-6)
            }));
    }, [
        abnormalObs,
        obsByCode
    ]);
    const lastVisitSummary = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const notes = [
            ...p.clinicalNotes || []
        ].reverse();
        return notes.find((n)=>n.noteType === 'VISIT_SUMMARY') || null;
    }, [
        p.clinicalNotes
    ]);
    // ── Last-visit hero card ─────────────────────────────────────────────────
    const lastVisitInfo = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (!lastVisitSummary) return null;
        const encId = lastVisitSummary.appointmentId;
        const encounter = (p.encounters || []).find((e)=>e.id === encId);
        const bp = (obsByCode['55284-4'] || []).filter((o)=>o.appointmentId === encId).slice(-1)[0];
        const actions = [
            ...medications.filter((m)=>m.appointmentId === encId).map((m)=>m.dosageInstruction?.text ? t('patient.overview.medStartedWithDose', {
                    name: m.display,
                    dose: m.dosageInstruction.text
                }) : t('patient.overview.medStarted', {
                    name: m.display
                })),
            ...(orders || []).filter((o)=>o.appointmentId === encId).map((o)=>t('patient.overview.orderRequested', {
                    name: o.name
                }))
        ];
        return {
            date: (0, $51HmE.isoToJalali)(lastVisitSummary.createdAt, formatDate),
            type: encounter ? $bb877cde7ef1a601$var$ENCOUNTER_TYPE(t)[encounter.type] || encounter.type : null,
            dxCount: conditions.filter((c)=>c.appointmentId === encId).length,
            bp: bp?.value || null,
            text: lastVisitSummary.content?.text || '',
            actions: actions
        };
    }, [
        lastVisitSummary,
        p.encounters,
        obsByCode,
        medications,
        orders,
        conditions,
        t,
        formatDate
    ]);
    const vitals = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $2Ieny.OV_VITAL_DEF)(t).map((v)=>{
            const series = (obsByCode[v.code] || []).map((o)=>parseFloat(o.value)).filter((n)=>!isNaN(n)).slice(-6);
            const latest = (obsByCode[v.code] || [])[obsByCode[v.code]?.length - 1];
            return {
                ...v,
                value: latest?.value,
                series: series
            };
        }).filter((v)=>v.value != null), [
        obsByCode,
        t
    ]);
    const [deletingMed, setDeletingMed] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [confirmMed, setConfirmMed] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const doDeleteMed = async (id)=>{
        setDeletingMed(id);
        try {
            await (0, $eVM84.bffMutation)((0, $j7Lry.DELETE_MEDICATION), {
                id: id
            });
            onRefresh();
        } catch  {
            toast.error(t('errors.save.medicationDelete'));
        } finally{
            setDeletingMed(null);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-grid"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-main"
    }, lastVisitInfo && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-card hero"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-card-head"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-card-title"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "ps-ic"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3FyOw.default), {
        size: 15,
        "aria-hidden": true
    })), t('patient.overview.lastVisitSummary')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: "ps-link sm",
        onClick: ()=>setTab('visits')
    }, t('patient.overview.viewFull'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-card-body"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "lv-meta"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("b", null, lastVisitInfo.date), lastVisitInfo.type && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "dot"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "lv-type"
    }, lastVisitInfo.type)), lastVisitInfo.dxCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "dot"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, (0, $51HmE.faNum)(lastVisitInfo.dxCount, formatDigits), " ", t('patient.conditions.one'))), lastVisitInfo.bp && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "dot"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, t('patient.vitals.bp'), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("b", {
        dir: "ltr"
    }, (0, $51HmE.faNum)(lastVisitInfo.bp, formatDigits))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        className: "ps-summary-text",
        dangerouslySetInnerHTML: {
            __html: lastVisitInfo.text
        }
    }), lastVisitInfo.actions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-summary-actions"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-summary-actions-l"
    }, t('patient.overview.visitActions')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", null, lastVisitInfo.actions.map((a, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: i
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "ps-bullet"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $huNwV.default), {
            size: 11,
            "aria-hidden": true
        })), a)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-two"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-card-head"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-card-title"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "ps-ic"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aVx4q.default), {
        size: 15,
        "aria-hidden": true
    })), t('patient.meds.active'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "ps-count"
    }, (0, $51HmE.faNum)(activeMeds.length, formatDigits), " ", t('patient.meds.one')))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-card-body pad0"
    }, activeMeds.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-empty"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-empty-t"
    }, t('visit.rx.noneRecorded'))) : activeMeds.map((m)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "med-row",
            key: m.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "med-pill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aVx4q.default), {
            size: 15,
            "aria-hidden": true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "med-info",
            style: {
                flex: 1
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "med-top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "n",
            dir: "auto"
        }, (0, $g6gAc.medDisplayName)(m))), m.dosageInstruction?.text && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "d"
        }, m.dosageInstruction.text)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            onClick: ()=>setConfirmMed(m.id),
            disabled: deletingMed === m.id,
            "aria-label": t('patient.meds.removeAria', {
                name: (0, $g6gAc.medDisplayName)(m)
            }),
            style: {
                background: 'none',
                border: 'none',
                color: (0, $2Ieny.CL).danger,
                cursor: 'pointer',
                display: 'grid',
                placeItems: 'center',
                opacity: deletingMed === m.id ? 0.4 : 1,
                flexShrink: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
            size: 16,
            "aria-hidden": true
        })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-card-head"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-card-title"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "ps-ic"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fX0JO.default), {
        size: 15,
        "aria-hidden": true
    })), t('patient.conditions.active'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "ps-count"
    }, (0, $51HmE.faNum)(activeConditions.length, formatDigits), " ", t('patient.overview.entryCount', {
        count: activeConditions.length
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-card-body pad0"
    }, activeConditions.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-empty"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-empty-t"
    }, t('patient.empty.noneRecorded'))) : activeConditions.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "dx-row",
            key: c.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "dx-main"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "dx-title-row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "dx-cat active"
        }, (0, $2Ieny.OV_DX_STATUS)(t).active.l), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $i9Cif.DiagnosisTypeBadge), {
            cond: c
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "dx-name"
        }, c.display), c.code && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "dx-code",
            dir: "ltr"
        }, c.code)), c.onsetDate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "dx-note"
        }, t('patient.conditions.onset'), " ", (0, $51HmE.isoToJalali)(c.onsetDate, formatDate))))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-rail"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-card allergy-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-card-head danger"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-card-title"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "ps-ic danger"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $QG9Z3.default), {
        size: 15,
        "aria-hidden": true
    })), t('patient.allergies.drug')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "ps-count"
    }, (0, $51HmE.faNum)(allergies.length, formatDigits), " ", t('patient.overview.entryCount', {
        count: allergies.length
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-card-body pad0"
    }, allergies.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-empty"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-empty-t"
    }, t('patient.allergies.none'))) : allergies.map((a, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "alg-row",
            key: a.id || i
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "alg-sev " + ($bb877cde7ef1a601$var$OV_SEVERITY(t)[a.severity]?.cls || 'mid')
        }, $bb877cde7ef1a601$var$OV_SEVERITY(t)[a.severity]?.l || a.severity), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "alg-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "alg-name"
        }, a.allergen), a.reaction && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "alg-react"
        }, t('patient.allergies.reaction'), " ", a.reaction)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-card-head"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-card-title"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "ps-ic"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4CVxl.default), {
        size: 15,
        "aria-hidden": true
    })), t('patient.obs.abnormal')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "ps-count"
    }, (0, $51HmE.faNum)(abnormalLabs.length, formatDigits), " ", t('patient.overview.entryCount', {
        count: abnormalLabs.length
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-card-body pad0"
    }, abnormalLabs.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-empty"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-empty-t"
    }, t('patient.empty.noneRecorded'))) : abnormalLabs.map((o)=>{
        const isCrit = (o.status || '').toLowerCase() === 'critical';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "abn-row",
            key: o.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "abn-info"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "abn-name"
        }, o.display)), o.series.length > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "abn-spark"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3Amwd.default), {
            points: o.series,
            width: 40,
            height: 18,
            tone: isCrit ? 'danger' : 'warn'
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "abn-val"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "abn-v " + (isCrit ? 'hi' : 'mid')
        }, (0, $51HmE.faNum)(o.value, formatDigits)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "abn-state " + (isCrit ? 'hi' : 'mid')
        }, isCrit ? t('visit.vitals.critical') : t('visit.vitals.abnormal'))));
    })), abnormalLabs.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '8px 16px 12px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: "ps-link sm",
        onClick: ()=>setTab('labs')
    }, t('patient.obs.viewAll')))), vitals.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-rail-block"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ps-rail-title"
    }, t('patient.labCategory.vitals')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "vit-grid"
    }, vitals.map((v)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "vit-cell",
            key: v.code
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "k"
        }, v.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "v"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "mono",
            dir: "ltr"
        }, (0, $51HmE.faNum)(v.value, formatDigits)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "u"
        }, v.unit)), v.series.length > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "trend"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3Amwd.default), {
            points: v.series,
            width: 40,
            height: 9
        })));
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3OnFU.default), {
        open: !!confirmMed,
        onOpenChange: (o)=>{
            if (!o) setConfirmMed(null);
        },
        title: t('patient.meds.delete'),
        message: t('patient.meds.deleteConfirm'),
        destructive: true,
        confirmLabel: t('common.actions.delete'),
        onConfirm: ()=>doDeleteMed(confirmMed)
    }));
};
var $bb877cde7ef1a601$export$2e2bcd8739ae039 = $bb877cde7ef1a601$var$OverviewTab;

});

parcelRegister("ftxDC", function(module, exports) {

$parcel$export(module.exports, "default", () => $b89e7462d024c03d$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
parcelRequire("5N0ZI");
var $bHjRG = parcelRequire("bHjRG");
var $aJ1FU = parcelRequire("aJ1FU");
var $cRX9v = parcelRequire("cRX9v");
var $7gSBD = parcelRequire("7gSBD");
var $cLQXb = parcelRequire("cLQXb");
var $h4ZeB = parcelRequire("h4ZeB");
var $ctU9L = parcelRequire("ctU9L");
var $kCQwN = parcelRequire("kCQwN");
var $66joL = parcelRequire("66joL");
var $cPdQE = parcelRequire("cPdQE");
var $3uzzV = parcelRequire("3uzzV");

var $k2reB = parcelRequire("k2reB");
var $i7Rt0 = parcelRequire("i7Rt0");
var $aRAFQ = parcelRequire("aRAFQ");
var $8g4t5 = parcelRequire("8g4t5");
var $5v9tj = parcelRequire("5v9tj");
var $6TdpC = parcelRequire("6TdpC");
var $bU80g = parcelRequire("bU80g");

var $dLdf9 = parcelRequire("dLdf9");

var $2Ieny = parcelRequire("2Ieny");

var $51HmE = parcelRequire("51HmE");

var $5jjrw = parcelRequire("5jjrw");

var $eCeEG = parcelRequire("eCeEG");

var $6HKFj = parcelRequire("6HKFj");

var $hLmrW = parcelRequire("hLmrW");

var $gN4fd = parcelRequire("gN4fd");

var $9TRvY = parcelRequire("9TRvY");
// ─────────────────────────────────────────────────────────────────────────────
// «تحلیل» — the record's investigation surface.
//
// Where «خلاصه» tells the story of what changed, this tab answers *how it
// moved, and did what we did line up with it*: measurements, prescriptions,
// diagnoses, orders and visits all projected onto ONE time axis, so a vertical
// glance means «at the same moment».
//
// Structural notes:
//   • Read-only. Not one mutation lives here — it is a lens, never a pen.
//     Authoring stays on the Visit page, correction on «خلاصه».
//   • The lanes are `aria-hidden` SVG from the kit's timeline family; the table
//     view (نمای جدول) is their accessible twin, carrying every value as text.
//   • Nothing is listed by default: metrics come only from the picker dialog,
//     so the screen spends its pixels on the chart rather than on a catalogue.
//   • Every lane shares one scale, built once here from the measured plot width
//     — that shared object is what makes the crosshair mean the same thing in
//     all of them.
// ─────────────────────────────────────────────────────────────────────────────
const $b89e7462d024c03d$var$EVENT_ROWS = 2;
// Below this a drag is a click that wobbled, not a selection.
const $b89e7462d024c03d$var$MIN_DRAG_PX = 8;
// A lane row: the RTL rail (name/unit/latest) beside the LTR plot.
const $b89e7462d024c03d$var$Lane = ({ title: title, sub: sub, value: value, valueTone: valueTone, keys: keys, action: action, children: children, testId: testId, state: state })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "an-lane",
        "data-testid": testId,
        "data-state": state
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "an-rail"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "an-rail-t"
    }, title), sub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "an-rail-u"
    }, sub), value && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "an-rail-v",
        style: valueTone ? {
            color: valueTone
        } : undefined
    }, value), keys, action), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "an-plot"
    }, children));
const $b89e7462d024c03d$var$AnalysisTab = ({ p: p, setTab: setTab })=>{
    const { formatDigits: formatDigits, t: t, formatDate: formatDate, formatTime: formatTime, formatClinicMonth: formatClinicMonth } = (0, $LNQP4.default)();
    // The timeline's date helpers are plain module functions, so they take the
    // formatters rather than reaching for the hook themselves.
    const fmt = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
            formatDate: formatDate,
            formatTime: formatTime,
            formatClinicMonth: formatClinicMonth
        }), [
        formatDate,
        formatTime,
        formatClinicMonth
    ]);
    const a = (0, $5jjrw.useAnalysisTimeline)(p);
    const [plotRef, plotWidth] = (0, $3uzzV.default)(640);
    const [pickerOpen, setPickerOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [rangeOpen, setRangeOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [view, setView] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('chart');
    const [cursor, setCursor] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // { t, x, y } | null
    // ONE scale for every lane. `padStart` reserves the value-axis gutter in all
    // lanes — including those that draw no axis — or they would not line up.
    const scale = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $cRX9v.createTimeScale)({
            min: a.domain.min,
            max: a.domain.max,
            width: plotWidth,
            padStart: 44,
            padEnd: 12
        }), [
        a.domain,
        plotWidth
    ]);
    // How far from the pointer a datum still counts as "at this moment". It
    // scales with the window: on a year-wide view, demanding pixel-perfect aim on
    // a reading three weeks away would make the crosshair useless.
    const tolerance = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>Math.max(3 * (0, $eCeEG.DAY_MS), (a.domain.max - a.domain.min) * 0.022), [
        a.domain
    ]);
    // Pointer → plot x. Measured against the PLOT's own box — the same box whose
    // width built the scale. Converting against the card would silently bake in
    // the rail width and the card border, and any layout change would re-break it.
    const plotX = (clientX)=>{
        const node = plotRef.current;
        if (!node) return null;
        return clientX - node.getBoundingClientRect().left;
    };
    // ── Drag to zoom ──────────────────────────────────────────────────────────
    // A range is easier to point at than to type: the doctor sees the interesting
    // stretch and draws across it. The band is drawn live and labelled with the
    // range it currently covers, so the gesture is committed with the answer
    // already visible — no "select, release, hope".
    const [drag, setDrag] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // { from, to } in plot px
    const dragRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const beginDrag = (e)=>{
        // Left button only, and never from a control that happens to sit over the plot.
        if (e.button !== 0 || e.target.closest('button, a, input, select, label')) return;
        const x = plotX(e.clientX);
        if (x == null || x < scale.x0 || x > scale.x1) return;
        dragRef.current = {
            from: x,
            to: x,
            moved: false
        };
        setDrag({
            from: x,
            to: x
        });
        setCursor(null);
        e.currentTarget.setPointerCapture?.(e.pointerId);
    };
    const onPointerMove = (e)=>{
        const x = plotX(e.clientX);
        if (x == null) return;
        if (dragRef.current) {
            const to = Math.min(scale.x1, Math.max(scale.x0, x));
            dragRef.current = {
                ...dragRef.current,
                to: to,
                moved: true
            };
            setDrag({
                from: dragRef.current.from,
                to: to
            });
            return;
        }
        if (x < scale.x0 || x > scale.x1) {
            setCursor(null);
            return;
        }
        setCursor({
            t: scale.invert(x),
            x: e.clientX,
            y: e.clientY
        });
    };
    const endDrag = (e)=>{
        const d = dragRef.current;
        dragRef.current = null;
        setDrag(null);
        e?.currentTarget?.releasePointerCapture?.(e.pointerId);
        if (!d) return;
        // A drag shorter than this is a click that wobbled, not a selection.
        if (!d.moved || Math.abs(d.to - d.from) < $b89e7462d024c03d$var$MIN_DRAG_PX) return;
        a.setWindow(scale.invert(d.from), scale.invert(d.to));
    };
    // Esc abandons a drag in progress — the same escape hatch every overlay gives.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!drag) return undefined;
        const onKey = (ev)=>{
            if (ev.key === 'Escape') {
                dragRef.current = null;
                setDrag(null);
            }
        };
        window.addEventListener('keydown', onKey);
        return ()=>window.removeEventListener('keydown', onKey);
    }, [
        drag
    ]);
    const dragBand = drag && Math.abs(drag.to - drag.from) >= 2 ? {
        left: Math.min(drag.from, drag.to),
        width: Math.abs(drag.to - drag.from)
    } : null;
    const dragLabel = dragBand ? (0, $eCeEG.describeWindow)((0, $eCeEG.normalizeWindow)(scale.invert(drag.from), scale.invert(drag.to)), t, {
        fmt: fmt
    }) : '';
    const eventMarks = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>a.events.map((e)=>{
            const kind = (0, $eCeEG.EVENT_KIND)[e.kind] || (0, $eCeEG.EVENT_KIND).order;
            return {
                id: e.id,
                t: e.t,
                row: kind.row,
                shape: kind.shape,
                label: e.label,
                tone: kind.tone === 'accent' ? (0, $2Ieny.CL).accent : (0, $2Ieny.CL).warn
            };
        }), [
        a.events
    ]);
    const encounterMarks = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>a.encounters.map((e)=>({
                id: e.id,
                t: e.t,
                shape: e.cancelled ? 'cross' : 'circle',
                filled: e.live,
                tone: e.live ? (0, $2Ieny.CL).accent : (0, $2Ieny.CL).text3
            })), [
        a.encounters
    ]);
    const medRowsInWindow = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>a.medRows.filter((r)=>r.segments.some((s)=>s.from <= a.domain.max && (s.to ?? a.now) >= a.domain.min)), [
        a.medRows,
        a.domain,
        a.now
    ]);
    // ── States (§2.4) ─────────────────────────────────────────────────────────
    if (a.loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "analysis-content",
        "data-state": "loading",
        "aria-busy": true,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonChart), {
        height: 220,
        line: true,
        legend: 3,
        label: t('common.state.loading')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66joL.SkeletonCard), {
        avatar: false,
        lines: 3,
        chips: 0,
        actions: 0,
        label: t('common.state.loading')
    }));
    if (a.error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "analysis-content",
        "data-state": "error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dLdf9.default), {
        title: t('patient.analysis.historyLoadFailed'),
        note: t('patient.analysis.needsData'),
        detail: a.error?.message || String(a.error),
        onRetry: a.retry
    }));
    if (!a.hasData) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "analysis-content",
        "data-state": "empty"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $k2reB.default), {
            size: 26,
            "aria-hidden": true
        }),
        title: t('patient.analysis.nothingToAnalyse'),
        description: t('patient.analysis.emptyHintLong')
    }));
    const rangeKey = ((0, $eCeEG.RANGE_PRESETS).find((r)=>r.id === a.range) || {}).labelKey;
    const rangeLabel = rangeKey ? t(rangeKey) : '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "analysis-content",
        "data-state": "content",
        className: "an-root"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "an-toolbar",
        "data-testid": "analysis-toolbar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "an-toolbar-l"
    }, t('common.labels.dateRange')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "an-seg",
        role: "group",
        "aria-label": t('common.labels.dateRange')
    }, (0, $eCeEG.RANGE_PRESETS).map((r)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: r.id,
            type: "button",
            className: 'an-seg-b' + (a.range === r.id ? ' on' : ''),
            "aria-pressed": a.range === r.id,
            "data-testid": `analysis-range-${r.id}`,
            onClick: ()=>a.setRange(r.id)
        }, t(r.labelKey))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        className: 'an-seg-b' + (a.isCustom ? ' on' : ''),
        "aria-pressed": a.isCustom,
        "data-testid": "analysis-range-custom",
        onClick: ()=>setRangeOpen(true)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $i7Rt0.default), {
        size: 13,
        "aria-hidden": true
    }), " ", t('patient.analysis.custom'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "an-toolbar-l"
    }, t('patient.analysis.layers')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $h4ZeB.default), {
        label: t('patient.analysis.events'),
        active: a.layers.events,
        onClick: ()=>a.toggleLayer('events'),
        "data-testid": "analysis-layer-events"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $h4ZeB.default), {
        label: t('visit.rx.medications'),
        active: a.layers.meds,
        onClick: ()=>a.toggleLayer('meds'),
        "data-testid": "analysis-layer-meds"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $h4ZeB.default), {
        label: t('patient.analysis.metrics'),
        active: a.layers.metrics,
        onClick: ()=>a.toggleLayer('metrics'),
        "data-testid": "analysis-layer-metrics"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "an-toolbar-end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        size: "sm",
        type: "button",
        onClick: ()=>setView((v)=>v === 'chart' ? 'table' : 'chart'),
        "data-testid": "analysis-view-toggle",
        "aria-pressed": view === 'table'
    }, view === 'chart' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5v9tj.default), {
        size: 14,
        "aria-hidden": true
    }), " ", t('patient.analysis.tableView')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aRAFQ.default), {
        size: 14,
        "aria-hidden": true
    }), " ", t('patient.analysis.chartView')))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "an-range",
        "data-testid": "analysis-active-range",
        "aria-live": "polite"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "an-range-l"
    }, t('patient.analysis.activeRange')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "an-range-v"
    }, (0, $eCeEG.describeWindow)(a.target, t, {
        fmt: fmt
    })), a.isCustom && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        className: "an-range-x",
        onClick: a.resetWindow,
        "data-testid": "analysis-range-reset"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bU80g.default), {
        size: 12,
        "aria-hidden": true
    }), " ", t('common.actions.reset')))), view === 'table' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "an-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9TRvY.default), {
        metrics: a.selectedMetrics,
        medRows: a.layers.meds ? a.medRows : [],
        events: a.layers.events ? a.events : [],
        encounters: a.encounters,
        domain: a.domain,
        now: a.now
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: 'an-card an-zoomable' + (drag ? ' dragging' : ''),
        "data-testid": "analysis-chart",
        onPointerDown: beginDrag,
        onPointerMove: onPointerMove,
        onPointerUp: endDrag,
        onPointerCancel: endDrag,
        onPointerLeave: ()=>{
            if (!dragRef.current) setCursor(null);
        }
    }, dragBand && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "an-brush",
        style: {
            left: dragBand.left,
            width: dragBand.width
        },
        "data-testid": "analysis-brush"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "an-brush-label"
    }, dragLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "an-lane an-lane-ruler"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "an-rail"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "an-rail-t"
    }, t('patient.tabs.visits')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "an-rail-u"
    }, (0, $51HmE.faNum)(a.encounters.length, formatDigits), " ", t('patient.encounter'), rangeLabel ? ` \xb7 ${rangeLabel}` : '')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "an-plot",
        ref: plotRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cPdQE.default), {
        width: plotWidth,
        scale: scale,
        ticks: a.ticks,
        formatTick: (ms)=>(0, $eCeEG.formatMonthTick)(ms, fmt),
        nowAt: a.now,
        cursorAt: cursor?.t,
        markers: encounterMarks,
        height: 56
    }))), a.layers.events && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b89e7462d024c03d$var$Lane, {
        title: t('patient.analysis.events'),
        testId: "analysis-lane-events",
        state: a.events.length ? 'content' : 'empty',
        keys: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "an-keys"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "an-key"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("i", {
            style: {
                borderColor: (0, $2Ieny.CL).accent
            }
        }), t('patient.analysis.legendDx')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "an-key"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("i", {
            style: {
                borderColor: (0, $2Ieny.CL).warn
            }
        }), t('patient.analysis.legendProc')))
    }, a.events.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cLQXb.default), {
        width: plotWidth,
        scale: scale,
        events: eventMarks,
        rows: $b89e7462d024c03d$var$EVENT_ROWS,
        rowHeight: 24,
        ticks: a.ticks,
        nowAt: a.now,
        cursorAt: cursor?.t
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "an-lane-empty"
    }, t('patient.analysis.noEventsInRange'))), a.layers.meds && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b89e7462d024c03d$var$Lane, {
        title: t('visit.rx.medications'),
        sub: t('patient.analysis.medBandCaption'),
        testId: "analysis-lane-meds",
        state: medRowsInWindow.length ? 'content' : 'empty'
    }, medRowsInWindow.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ctU9L.default), {
        width: plotWidth,
        scale: scale,
        rows: medRowsInWindow,
        rowHeight: 26,
        ticks: a.ticks,
        nowAt: a.now,
        cursorAt: cursor?.t
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "an-lane-empty"
    }, t('patient.analysis.noMedsInRange'))), a.layers.metrics && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "an-obs-head",
        "data-testid": "analysis-metrics-head"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "an-obs-t"
    }, t('patient.analysis.selectedObservations')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "an-obs-hint"
    }, t('patient.analysis.pickerHint')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "subtle",
        size: "sm",
        type: "button",
        className: "an-obs-btn",
        onClick: ()=>setPickerOpen(true),
        "data-testid": "analysis-pick-metrics"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8g4t5.default), {
        size: 14,
        "aria-hidden": true
    }), " ", t('patient.analysis.pickMetrics')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "an-obs-count"
    }, (0, $51HmE.faNum)(a.selected.length, formatDigits), "/", (0, $51HmE.faNum)(a.cap, formatDigits), " ", t('patient.analysis.metric')), a.selectedMetrics.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "an-chips"
    }, a.selectedMetrics.map((m)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            key: m.key,
            className: "an-chip"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, (0, $eCeEG.metricName)(t, m)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            type: "button",
            "aria-label": t('patient.analysis.removeFromChartAria', {
                name: m.name
            }),
            "data-testid": `analysis-chip-remove-${m.key}`,
            onClick: ()=>a.toggleMetric(m.key)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
            size: 11,
            "aria-hidden": true
        })))))), a.selectedMetrics.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "an-lane-empty an-empty-cta",
        "data-testid": "analysis-metrics-empty",
        "data-state": "empty"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aRAFQ.default), {
            size: 24,
            "aria-hidden": true
        }),
        title: t('patient.analysis.noneSelected'),
        description: t('patient.analysis.allAvailableDialog'),
        action: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            type: "button",
            size: "sm",
            onClick: ()=>setPickerOpen(true),
            "data-testid": "analysis-metrics-empty-cta"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8g4t5.default), {
            size: 14,
            "aria-hidden": true
        }), " ", t('patient.analysis.pickMetrics'))
    })) : a.selectedMetrics.map((m)=>{
        const st = m.latestStatus;
        const tone = st === 'critical' ? (0, $2Ieny.CL).danger : st === 'abnormal' ? (0, $2Ieny.CL).warnInk : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b89e7462d024c03d$var$Lane, {
            key: m.key,
            testId: `analysis-lane-${m.key}`,
            state: "content",
            title: (0, $eCeEG.metricName)(t, m),
            sub: [
                m.unit,
                m.refLow != null && m.refHigh != null ? t('patient.analysis.referenceRange', {
                    low: (0, $51HmE.faNum)(m.refLow, formatDigits),
                    high: (0, $51HmE.faNum)(m.refHigh, formatDigits)
                }) : null
            ].filter(Boolean).join(" \xb7 "),
            value: (0, $51HmE.faNum)(Math.round(m.latest.y * 10) / 10, formatDigits),
            valueTone: tone,
            action: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                type: "button",
                className: "an-rm",
                "aria-label": t('patient.analysis.removeFromChartAria', {
                    name: m.name
                }),
                "data-testid": `analysis-lane-remove-${m.key}`,
                onClick: ()=>a.toggleMetric(m.key)
            }, t('common.actions.delete'))
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kCQwN.default), {
            width: plotWidth,
            scale: scale,
            series: [
                {
                    id: m.key,
                    points: m.points,
                    color: (0, $2Ieny.CL).accent
                }
            ],
            refLow: m.refLow,
            refHigh: m.refHigh,
            ticks: a.ticks,
            nowAt: a.now,
            cursorAt: cursor?.t,
            height: 92,
            formatValue: (v)=>(0, $51HmE.faNum)(Math.round(v * 10) / 10, formatDigits),
            emptyLabel: t('patient.analysis.noneInRange')
        }));
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "an-legend"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "an-legend-l"
    }, t('patient.analysis.legendLabel')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "an-legend-i"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("i", {
        className: "lg-dot"
    }), t('patient.visit')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "an-legend-i"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: (0, $2Ieny.CL).accent
        }
    }, "\u25B2"), t('patient.conditions.one')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "an-legend-i"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: (0, $2Ieny.CL).warn
        }
    }, "\u25C6"), t('visit.orders.procedure')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "an-legend-i"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("i", {
        className: "lg-bar"
    }), t('patient.analysis.medBand')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "an-legend-i"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("i", {
        className: "lg-sq",
        style: {
            background: (0, $2Ieny.CL).warn
        }
    }), t('visit.vitals.abnormal')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "an-legend-i"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("i", {
        className: "lg-sq",
        style: {
            background: (0, $2Ieny.CL).danger
        }
    }), t('visit.vitals.critical')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "an-legend-i"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("i", {
        className: "lg-now"
    }), t('common.time.now')))), a.ordersError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "an-note",
        role: "status"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bHjRG.default), {
        variant: "warning"
    }, t('patient.analysis.actionsLoadFailed')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, t('patient.analysis.ordersMissing')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        className: "ps-link",
        onClick: a.retryOrders,
        "data-testid": "analysis-orders-retry"
    }, t('common.actions.retry'))), cursor && view === 'chart' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'fixed',
            zIndex: 40,
            pointerEvents: 'none',
            top: Math.min(cursor.y + 14, (typeof window !== 'undefined' ? window.innerHeight : 800) - 220),
            left: Math.max(12, cursor.x - 300)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gN4fd.default), {
        at: cursor.t,
        metrics: a.layers.metrics ? a.selectedMetrics : [],
        medRows: a.layers.meds ? a.medRows : [],
        events: a.layers.events ? a.events : [],
        encounters: a.encounters,
        tolerance: tolerance,
        now: a.now
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6HKFj.default), {
        open: pickerOpen,
        onOpenChange: setPickerOpen,
        groups: a.groups,
        selected: a.selected,
        cap: a.cap,
        onApply: (keys)=>{
            a.setSelection(keys);
            setPickerOpen(false);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hLmrW.default), {
        open: rangeOpen,
        onOpenChange: setRangeOpen,
        domain: a.target,
        earliest: a.earliest,
        now: a.now,
        onApply: (from, to)=>{
            a.setWindow(from, to);
            setRangeOpen(false);
        }
    }));
};
var $b89e7462d024c03d$export$2e2bcd8739ae039 = $b89e7462d024c03d$var$AnalysisTab;

});
parcelRegister("i7Rt0", function(module, exports) {

$parcel$export(module.exports, "default", () => $b885961d6f223caf$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $b885961d6f223caf$export$a2387ed3b5d536eb = {
    name: "calendar-range",
    size: 24,
    node: [
        [
            "rect",
            {
                x: "3",
                y: "3",
                width: "18",
                height: "18",
                rx: "2",
                key: "h1oib"
            }
        ],
        [
            "path",
            {
                d: "M16 2v3",
                key: "otl347"
            }
        ],
        [
            "path",
            {
                d: "M3 9h18",
                key: "1pudct"
            }
        ],
        [
            "path",
            {
                d: "M8 2v3",
                key: "1ioesn"
            }
        ],
        [
            "path",
            {
                d: "M17 13h-6",
                key: "1qbiup"
            }
        ],
        [
            "path",
            {
                d: "M13 17H7",
                key: "1x38vv"
            }
        ],
        [
            "path",
            {
                d: "M7 13h.01",
                key: "1vezk1"
            }
        ],
        [
            "path",
            {
                d: "M17 17h.01",
                key: "1sd3ek"
            }
        ]
    ]
};
$b885961d6f223caf$export$a2387ed3b5d536eb.node;
const $b885961d6f223caf$export$2e2bcd8739ae039 = (0, $9QBug.default)($b885961d6f223caf$export$a2387ed3b5d536eb);

});

parcelRegister("6HKFj", function(module, exports) {

$parcel$export(module.exports, "default", () => $89dd3c5e44c5e235$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $2VplL = parcelRequire("2VplL");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $9gEOi = parcelRequire("9gEOi");
var $4fYdd = parcelRequire("4fYdd");
var $7gSBD = parcelRequire("7gSBD");
var $h4ZeB = parcelRequire("h4ZeB");
var $amyVq = parcelRequire("amyVq");
var $fAR2n = parcelRequire("fAR2n");
var $3Amwd = parcelRequire("3Amwd");

var $2Ieny = parcelRequire("2Ieny");

var $51HmE = parcelRequire("51HmE");

var $eCeEG = parcelRequire("eCeEG");
// ─────────────────────────────────────────────────────────────────────────────
// «انتخاب سنجه‌ها» — the ONE way observations get onto the analysis chart.
//
// The tab deliberately lists nothing by default: a chronic patient carries
// dozens of analytes, and an always-visible catalogue would spend the whole
// screen on a menu. So the full catalogue lives here — vitals and laboratory
// analytes in one pool, because the entire point of the tab is putting a vital
// beside an analyte on one clock — narrowed by a category dropdown, a search
// box, and an «فقط غیرطبیعی» toggle.
//
// Each row carries the evidence the choice needs: last value, its status, and a
// sparkline. Choosing what to investigate IS a triage decision; a bare list of
// names would make the doctor open six charts to find the one that moved.
//
// Selection is drafted locally and committed on «اعمال» (§5.2: an overlay with
// unsaved input closes only through an explicit action), so a mis-tap in a
// 40-row list never silently rewrites the chart behind the dialog.
// ─────────────────────────────────────────────────────────────────────────────
const $89dd3c5e44c5e235$var$STATUS_META = (t)=>({
        critical: {
            label: t('visit.vitals.critical'),
            color: (0, $2Ieny.CL).danger,
            soft: (0, $2Ieny.CL).dangerSoft,
            tone: 'danger'
        },
        abnormal: {
            label: t('visit.vitals.abnormal'),
            color: (0, $2Ieny.CL).warnInk,
            soft: (0, $2Ieny.CL).warnSoft,
            tone: 'warn'
        }
    });
const $89dd3c5e44c5e235$var$MetricPickerDialog = ({ open: open, onOpenChange: onOpenChange, groups: groups, selected: selected, onApply: onApply, cap: cap = (0, $eCeEG.METRIC_CAP) })=>{
    const { formatDigits: formatDigits, t: t } = (0, $LNQP4.default)();
    const [draft, setDraft] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(selected);
    const [query, setQuery] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [category, setCategory] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [abnormalOnly, setAbnormalOnly] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // Reopening always starts from what is actually on the chart — a stale draft
    // from a cancelled session would silently re-apply on the next «اعمال».
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (open) {
            setDraft(selected);
            setQuery('');
            setCategory('');
            setAbnormalOnly(false);
        }
    }, [
        open,
        selected
    ]);
    // §5.2: closing returns focus to the trigger. Radix restores to whatever was
    // focused at mount, but this dialog is opened from a *controlled* state (there
    // is no DialogTrigger — two different buttons open it), and the re-render that
    // opens it costs the automatic restore its anchor: focus lands on <body>,
    // which strands a keyboard user at the top of the document. So the opener is
    // captured on the way in and focused explicitly on the way out.
    const openerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (open) openerRef.current = document.activeElement;
    }, [
        open
    ]);
    const returnFocus = (e)=>{
        const el = openerRef.current;
        if (el && typeof el.focus === 'function' && el.isConnected) {
            e.preventDefault();
            el.focus();
        }
    };
    const categoryOptions = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>groups.map((g)=>({
                value: g.category,
                label: `${t(g.categoryKey)} (${(0, $51HmE.faNum)(g.metrics.length, formatDigits)})`
            })), [
        groups,
        t,
        formatDigits
    ]);
    const filtered = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const q = query.trim();
        return groups.filter((g)=>!category || g.category === category).map((g)=>({
                ...g,
                metrics: g.metrics.filter((m)=>(!q || (0, $eCeEG.metricName)(t, m).includes(q)) && (!abnormalOnly || !!m.latestStatus))
            })).filter((g)=>g.metrics.length);
    }, [
        groups,
        category,
        query,
        abnormalOnly,
        t
    ]);
    const total = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>groups.reduce((n, g)=>n + g.metrics.length, 0), [
        groups
    ]);
    const abnormalCount = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>groups.reduce((n, g)=>n + g.abnormal, 0), [
        groups
    ]);
    const full = draft.length >= cap;
    const toggle = (key)=>setDraft((prev)=>prev.includes(key) ? prev.filter((k)=>k !== key) : prev.length >= cap ? prev : [
                ...prev,
                key
            ]);
    const filtersActive = !!query || !!category || abnormalOnly;
    const clearFilters = ()=>{
        setQuery('');
        setCategory('');
        setAbnormalOnly(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.Dialog), {
        open: open,
        onOpenChange: onOpenChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogContent), {
        className: "max-w-2xl",
        "aria-describedby": undefined,
        "data-testid": "analysis-picker",
        onCloseAutoFocus: returnFocus
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogTitle), null, t('patient.analysis.pickForChart')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        style: {
            margin: 0,
            fontSize: '0.6875rem',
            color: (0, $2Ieny.CL).text3,
            fontWeight: 600,
            display: 'flex',
            gap: '0.375rem',
            flexWrap: 'wrap'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, t('patient.analysis.compareHint')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: (0, $2Ieny.CL).text2
        }
    }, "(", (0, $51HmE.faNum)(total, formatDigits), " ", t('patient.analysis.metricsCountSuffix')))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: '0.5rem',
            alignItems: 'center',
            marginBottom: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: '1 1 12rem',
            minWidth: '10rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $amyVq.default), {
        value: query,
        onChange: (e)=>setQuery(e.target.value),
        placeholder: t('patient.analysis.searchMetric'),
        clearLabel: t('common.actions.clearSearch'),
        "data-testid": "analysis-picker-search"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: '0 1 11rem',
            minWidth: '9rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fAR2n.default), {
        value: category,
        onChange: (e)=>setCategory(e.target.value),
        options: categoryOptions,
        placeholder: t('patient.analysis.allCategories')
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $h4ZeB.default), {
        label: t('patient.analysis.abnormalOnly'),
        count: abnormalCount ? (0, $51HmE.faNum)(abnormalCount, formatDigits) : undefined,
        active: abnormalOnly,
        onClick: ()=>setAbnormalOnly((v)=>!v),
        "data-testid": "analysis-picker-abnormal"
    }), filtersActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "ghost",
        size: "sm",
        type: "button",
        onClick: clearFilters
    }, t('encounters.clearFilters'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "analysis-picker-list",
        "data-state": filtered.length ? 'content' : 'empty',
        style: {
            maxHeight: '26rem',
            overflowY: 'auto',
            margin: '0 -0.5rem',
            borderTop: `1px solid ${(0, $2Ieny.CL).border2}`
        }
    }, !filtered.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2VplL.default), {
            size: 44,
            strokeWidth: 1.5,
            "aria-hidden": true
        }),
        title: t('patient.analysis.noMetricMatch'),
        description: total ? t('accounting.changeOrClearFilters') : t('patient.analysis.noMeasurements'),
        action: filtersActive ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "outline",
            size: "sm",
            type: "button",
            onClick: clearFilters
        }, t('encounters.clearFilters')) : null,
        style: {
            padding: '1.5rem 1rem'
        }
    }) : filtered.map((group)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
            key: group.category
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h3", {
            style: {
                position: 'sticky',
                top: 0,
                zIndex: 1,
                margin: 0,
                padding: '0.5rem 1rem 0.25rem',
                background: (0, $2Ieny.CL).surface,
                fontSize: '0.6875rem',
                fontWeight: 800,
                color: (0, $2Ieny.CL).text3
            }
        }, t(group.categoryKey)), group.metrics.map((m)=>{
            const on = draft.includes(m.key);
            // Only the two off-normal states have a badge; «طبیعی» rows
            // show a dash, so a miss here is the normal case, not an error.
            const st = $89dd3c5e44c5e235$var$STATUS_META(t)[m.latestStatus] || null;
            const disabled = full && !on;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9gEOi.default), {
                key: m.key,
                checked: on,
                disabled: disabled,
                onChange: ()=>toggle(m.key),
                "data-testid": `analysis-picker-row-${m.key}`,
                "data-state": on ? 'selected' : 'unselected',
                labelClassName: "flex-1 min-w-0",
                style: {
                    padding: '0.4375rem 1rem',
                    background: on ? (0, $2Ieny.CL).accentSoft : 'transparent'
                },
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.625rem'
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        fontSize: '0.75rem',
                        fontWeight: 600,
                        color: (0, $2Ieny.CL).text1,
                        whiteSpace: 'nowrap'
                    }
                }, (0, $eCeEG.metricName)(t, m), m.unit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        color: (0, $2Ieny.CL).text3,
                        fontWeight: 400,
                        fontSize: '0.625rem'
                    }
                }, " ", m.unit)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        marginInlineStart: 'auto',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.625rem'
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3Amwd.default), {
                    points: m.points.slice(-8).map((p)=>p.y),
                    tone: st ? st.tone : 'accent',
                    width: 52,
                    height: 16
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        fontSize: '0.75rem',
                        fontWeight: 800,
                        direction: 'ltr',
                        minWidth: '2.75rem',
                        textAlign: 'end',
                        color: st ? st.color : (0, $2Ieny.CL).text2
                    }
                }, (0, $51HmE.faNum)(Math.round(m.latest.y * 10) / 10, formatDigits)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        minWidth: '3.25rem',
                        textAlign: 'center',
                        fontSize: '0.5625rem',
                        fontWeight: 800,
                        borderRadius: '0.3125rem',
                        padding: '0.0625rem 0.375rem',
                        background: st ? st.soft : 'transparent',
                        color: st ? st.color : 'transparent'
                    }
                }, st ? st.label : "\u2014")))
            });
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogFooter), {
        className: "justify-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        type: "button",
        onClick: ()=>onApply(draft),
        "data-testid": "analysis-picker-apply"
    }, t('common.actions.apply')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        type: "button",
        onClick: ()=>onOpenChange(false)
    }, t('common.actions.cancel')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            marginInlineStart: 'auto',
            alignSelf: 'center',
            fontSize: '0.6875rem',
            fontWeight: 700,
            color: full ? (0, $2Ieny.CL).warnInk : (0, $2Ieny.CL).text3
        }
    }, (0, $51HmE.faNum)(draft.length, formatDigits), "/", (0, $51HmE.faNum)(cap, formatDigits), " ", t('common.state.selected'), full && t('patient.analysis.maxSuffix')))));
};
var $89dd3c5e44c5e235$export$2e2bcd8739ae039 = $89dd3c5e44c5e235$var$MetricPickerDialog;

});

parcelRegister("hLmrW", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1b7856d4270460e$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $4fYdd = parcelRequire("4fYdd");
var $4Qco3 = parcelRequire("4Qco3");

var $2Ieny = parcelRequire("2Ieny");

var $eCeEG = parcelRequire("eCeEG");
// ─────────────────────────────────────────────────────────────────────────────
// «بازهٔ دلخواه» — an exact analysis window, to the minute.
//
// The presets answer "roughly the last N months"; this answers "between the
// admission and the discharge", which is the question that needs a *time*, not
// just a date — two visits on one day are a normal Tuesday, and a day-precision
// range would fold them together.
//
// The Jalali calendar and the time spinners both come from the kit's
// `JalaliDatePicker` (`withTime`) — the only Jalaali implementation in the
// system (DESIGN.md), so this dialog never re-implements calendar maths. Values
// are Iran wall-clock; the ms conversion lives in the model so the picker, the
// drag-zoom and the presets all produce the same kind of window.
// ─────────────────────────────────────────────────────────────────────────────
const $e1b7856d4270460e$var$QUICK = [
    'month',
    '3m',
    '6m'
];
const $e1b7856d4270460e$var$CustomRangeDialog = ({ open: open, onOpenChange: onOpenChange, domain: domain, earliest: earliest, now: now, onApply: onApply })=>{
    const { t: t, formatDate: formatDate, formatTime: formatTime } = (0, $LNQP4.default)();
    const fmt = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
            formatDate: formatDate,
            formatTime: formatTime
        }), [
        formatDate,
        formatTime
    ]);
    const [from, setFrom] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [to, setTo] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    // Open on the window currently in view: the commonest edit is a nudge to one
    // end, not a range typed from nothing.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return;
        setFrom((0, $eCeEG.msToPickerValue)(domain.min));
        setTo((0, $eCeEG.msToPickerValue)(domain.max));
        setError('');
    }, [
        open,
        domain.min,
        domain.max
    ]);
    const openerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (open) openerRef.current = document.activeElement;
    }, [
        open
    ]);
    const returnFocus = (e)=>{
        const el = openerRef.current;
        if (el?.focus && el.isConnected) {
            e.preventDefault();
            el.focus();
        }
    };
    const fromMs = (0, $eCeEG.pickerValueToMs)(from);
    const toMs = (0, $eCeEG.pickerValueToMs)(to);
    const preview = fromMs != null && toMs != null ? (0, $eCeEG.describeWindow)((0, $eCeEG.normalizeWindow)(fromMs, toMs), t, {
        withTime: true,
        fmt: fmt
    }) : '';
    const apply = ()=>{
        const problem = (0, $eCeEG.validateWindow)(fromMs, toMs, t);
        if (problem) {
            setError(problem);
            return;
        }
        // A reversed pair is a slip, not an error — the model orders it either way.
        onApply(fromMs, toMs);
    };
    const applyQuick = (id)=>{
        const w = (0, $eCeEG.windowFor)(id, earliest, now);
        setFrom((0, $eCeEG.msToPickerValue)(w.min));
        setTo((0, $eCeEG.msToPickerValue)(w.max));
        setError('');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.Dialog), {
        open: open,
        onOpenChange: onOpenChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogContent), {
        className: "max-w-lg",
        "aria-describedby": undefined,
        "data-testid": "analysis-range-dialog",
        onCloseAutoFocus: returnFocus
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogTitle), null, t('patient.analysis.customRange')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        style: {
            margin: 0,
            fontSize: '0.6875rem',
            color: (0, $2Ieny.CL).text3,
            fontWeight: 600
        }
    }, t('patient.analysis.rangeHint'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'grid',
            gap: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        style: {
            display: 'grid',
            gap: '0.3125rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.6875rem',
            fontWeight: 700,
            color: (0, $2Ieny.CL).text2
        }
    }, t('common.labels.from')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "analysis-range-from"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4Qco3.default), {
        value: from,
        onChange: setFrom,
        withTime: true,
        placeholder: t('patient.analysis.startDateTime')
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        style: {
            display: 'grid',
            gap: '0.3125rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.6875rem',
            fontWeight: 700,
            color: (0, $2Ieny.CL).text2
        }
    }, t('common.labels.to')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "analysis-range-to"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4Qco3.default), {
        value: to,
        onChange: setTo,
        withTime: true,
        placeholder: t('patient.analysis.endDateTime')
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: '0.375rem',
            alignItems: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.625rem',
            color: (0, $2Ieny.CL).text3,
            fontWeight: 700
        }
    }, t('patient.analysis.shortcut')), (0, $eCeEG.RANGE_PRESETS).filter((r)=>$e1b7856d4270460e$var$QUICK.includes(r.id)).map((r)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            key: r.id,
            type: "button",
            variant: "outline",
            size: "sm",
            onClick: ()=>applyQuick(r.id),
            "data-testid": `analysis-range-quick-${r.id}`
        }, t(r.labelKey)))), preview && !error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        style: {
            margin: 0,
            fontSize: '0.6875rem',
            color: (0, $2Ieny.CL).accentInk,
            fontWeight: 700
        },
        "data-testid": "analysis-range-preview"
    }, preview), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        role: "alert",
        style: {
            margin: 0,
            fontSize: '0.6875rem',
            color: (0, $2Ieny.CL).danger,
            fontWeight: 700
        },
        "data-testid": "analysis-range-error"
    }, error)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fYdd.DialogFooter), {
        className: "justify-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        type: "button",
        onClick: apply,
        "data-testid": "analysis-range-apply"
    }, t('common.actions.apply')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        type: "button",
        onClick: ()=>onOpenChange(false)
    }, t('common.actions.cancel')))));
};
var $e1b7856d4270460e$export$2e2bcd8739ae039 = $e1b7856d4270460e$var$CustomRangeDialog;

});

parcelRegister("gN4fd", function(module, exports) {

$parcel$export(module.exports, "default", () => $f17f7c741e45d648$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $2Ieny = parcelRequire("2Ieny");

var $51HmE = parcelRequire("51HmE");

var $eCeEG = parcelRequire("eCeEG");
// The crosshair's readout: everything true at ONE moment, in one card.
//
// It reads across lanes rather than per-lane on purpose — the pointer never has
// to land on a line to get its value, and the answer the doctor came for
// («the pressure was that, on this drug, right after that order») is a single
// vertical slice, not five separate hovers.
//
// Tooltips enhance, they never gate (§12): every value here is also in the
// table view, so nothing is reachable only by hovering.
const $f17f7c741e45d648$var$TimelineReadout = ({ at: at, metrics: metrics, medRows: medRows, events: events, encounters: encounters, tolerance: tolerance, now: now, style: style })=>{
    const { t: t, formatDigits: formatDigits, formatList: formatList, formatDate: formatDate } = (0, $LNQP4.default)();
    if (at == null) return null;
    const rows = metrics.map((m)=>({
            m: m,
            p: (0, $eCeEG.nearestPoint)(m.points, at, tolerance)
        })).filter((r)=>r.p);
    const near = (item)=>Math.abs(item - at) <= tolerance;
    const evs = events.filter((e)=>near(e.t));
    const encs = encounters.filter((e)=>near(e.t));
    const meds = (0, $eCeEG.activeAt)(medRows, at, now);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "status",
        "data-testid": "analysis-readout",
        style: {
            background: (0, $2Ieny.CL).surface,
            border: `1px solid ${(0, $2Ieny.CL).border}`,
            borderRadius: '0.6875rem',
            boxShadow: '0 8px 26px rgba(10,20,30,.16)',
            padding: '0.625rem 0.8125rem',
            minWidth: '12.5rem',
            maxWidth: '18rem',
            pointerEvents: 'none',
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontWeight: 800,
            fontSize: '0.71875rem',
            color: (0, $2Ieny.CL).text1,
            borderBottom: `1px solid ${(0, $2Ieny.CL).border2}`,
            paddingBottom: '0.3125rem',
            marginBottom: '0.375rem'
        }
    }, (0, $eCeEG.jalaliFull)(at, {
        formatDate: formatDate
    })), rows.map(({ m: m, p: p })=>{
        const tone = p.status === 'critical' ? (0, $2Ieny.CL).danger : p.status === 'abnormal' ? (0, $2Ieny.CL).warnInk : (0, $2Ieny.CL).accentInk;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: m.key,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.4375rem',
                margin: '0.15625rem 0',
                fontSize: '0.71875rem',
                color: (0, $2Ieny.CL).text2
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("i", {
            style: {
                width: '0.6875rem',
                borderTop: `2.5px solid ${tone}`,
                borderRadius: '2px',
                flexShrink: 0
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            }
        }, (0, $eCeEG.metricName)(t, m)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("b", {
            style: {
                marginInlineStart: 'auto',
                color: (0, $2Ieny.CL).text1,
                direction: 'ltr',
                unicodeBidi: 'isolate'
            }
        }, (0, $51HmE.faNum)(Math.round(p.y * 10) / 10, formatDigits), m.unit ? ` ${m.unit}` : ''));
    }), !rows.length && !evs.length && !encs.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.6875rem',
            color: (0, $2Ieny.CL).text3
        }
    }, t('patient.analysis.noDataOnDate')), encs.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.625rem',
            color: (0, $2Ieny.CL).text3,
            fontWeight: 700,
            marginTop: '0.3125rem'
        }
    }, t('patient.analysis.encounterLabel'), " ", formatList(encs.map((e)=>e.type || t('patient.visit')))), evs.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.625rem',
            color: (0, $2Ieny.CL).text3,
            fontWeight: 700,
            marginTop: '0.3125rem'
        }
    }, t('patient.analysis.eventLabel'), " ", formatList(evs.map((e)=>e.label))), meds.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.625rem',
            color: (0, $2Ieny.CL).text3,
            fontWeight: 700,
            marginTop: '0.3125rem'
        }
    }, t('patient.analysis.activeMedLabel'), " ", formatList(meds)));
};
var $f17f7c741e45d648$export$2e2bcd8739ae039 = $f17f7c741e45d648$var$TimelineReadout;

});

parcelRegister("9TRvY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b61a9124911a13c6$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $ggYuf = parcelRequire("ggYuf");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
parcelRequire("5N0ZI");
var $7gSBD = parcelRequire("7gSBD");

var $2Ieny = parcelRequire("2Ieny");

var $51HmE = parcelRequire("51HmE");

var $eCeEG = parcelRequire("eCeEG");
// The chart's accessible twin (§12.4 / DESIGN.md data-viz rule): the lanes are
// `aria-hidden` SVG, so every value they draw must also be reachable as text.
//
// It is the same slice the chart shows — same window, same selection — sorted
// newest first, because "what happened lately" is the question a list answers
// well and a timeline answers slowly.
const $b61a9124911a13c6$var$KIND = (t)=>({
        metric: {
            label: t('patient.obs.measurement'),
            bg: (0, $2Ieny.CL).accentSoft,
            fg: (0, $2Ieny.CL).accentInk
        },
        med: {
            label: t('patient.meds.one'),
            bg: (0, $2Ieny.CL).navySoft,
            fg: (0, $2Ieny.CL).navy
        },
        dx: {
            label: t('patient.tabs.conditions'),
            bg: (0, $2Ieny.CL).accentSoft,
            fg: (0, $2Ieny.CL).accentInk
        },
        order: {
            label: t('visit.orders.procedure'),
            bg: (0, $2Ieny.CL).warnSoft,
            fg: (0, $2Ieny.CL).warnInk
        },
        enc: {
            label: t('patient.encounter'),
            bg: (0, $2Ieny.CL).border2,
            fg: (0, $2Ieny.CL).text2
        }
    });
const $b61a9124911a13c6$var$STATUS_LBL = (t)=>({
        critical: t('visit.vitals.critical'),
        abnormal: t('visit.vitals.abnormal')
    });
const $b61a9124911a13c6$var$Chip = ({ kind: kind })=>{
    const { t: t } = (0, $LNQP4.default)();
    const k = $b61a9124911a13c6$var$KIND(t)[kind] || $b61a9124911a13c6$var$KIND(t).enc;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'inline-block',
            fontSize: '0.625rem',
            fontWeight: 800,
            borderRadius: '0.3125rem',
            padding: '0.09375rem 0.5rem',
            background: k.bg,
            color: k.fg
        }
    }, k.label);
};
const $b61a9124911a13c6$var$AnalysisTable = ({ metrics: metrics, medRows: medRows, events: events, encounters: encounters, domain: domain, now: now })=>{
    const { formatDigits: formatDigits, t: t, formatDate: formatDate } = (0, $LNQP4.default)();
    const rows = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const out = [];
        metrics.forEach((m)=>m.points.forEach((p)=>out.push({
                    t: p.x,
                    kind: 'metric',
                    name: (0, $eCeEG.metricName)(t, m),
                    value: `${(0, $51HmE.faNum)(Math.round(p.y * 10) / 10, formatDigits)}${m.unit ? ` ${m.unit}` : ''}`,
                    status: p.status !== 'normal' ? p.status : null
                })));
        medRows.forEach((r)=>r.segments.forEach((s)=>out.push({
                    t: s.from,
                    kind: 'med',
                    name: s.label,
                    value: '',
                    status: null,
                    note: s.to == null ? t('common.state.active') : t('dashboard.queue.finished')
                })));
        events.forEach((e)=>out.push({
                t: e.t,
                kind: e.kind,
                name: e.label,
                value: '',
                status: null,
                note: e.detail
            }));
        encounters.forEach((e)=>out.push({
                t: e.t,
                kind: 'enc',
                name: e.type || t('patient.encounter'),
                value: '',
                status: null,
                note: e.live ? t('common.state.inProgress') : e.cancelled ? t('common.state.cancelled') : t('patient.meds.finished')
            }));
        return out.filter((r)=>r.t >= domain.min && r.t <= domain.max).sort((a, b)=>b.t - a.t);
    }, [
        metrics,
        medRows,
        events,
        encounters,
        domain,
        t,
        formatDigits
    ]);
    if (!rows.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ggYuf.default), {
            size: 44,
            strokeWidth: 1.5,
            "aria-hidden": true
        }),
        title: t('patient.analysis.noDataInRange'),
        description: t('patient.analysis.widenRange'),
        "data-testid": "analysis-table-empty"
    });
    const th = {
        textAlign: 'start',
        fontSize: '0.65625rem',
        color: (0, $2Ieny.CL).text3,
        fontWeight: 700,
        background: (0, $2Ieny.CL).surface2,
        padding: '0.5rem 0.875rem',
        borderBottom: `1px solid ${(0, $2Ieny.CL).border}`,
        position: 'sticky',
        top: 0,
        zIndex: 1
    };
    const td = {
        padding: '0.4375rem 0.875rem',
        borderBottom: `1px solid ${(0, $2Ieny.CL).border2}`,
        color: (0, $2Ieny.CL).text2
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            overflowX: 'auto'
        },
        "data-testid": "analysis-table",
        "data-state": "content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("table", {
        style: {
            width: '100%',
            borderCollapse: 'collapse',
            fontSize: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("caption", {
        className: "sr-only"
    }, t('patient.analysis.tableCaption')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        style: th,
        scope: "col"
    }, t('common.labels.date')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        style: th,
        scope: "col"
    }, t('common.labels.type')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        style: th,
        scope: "col"
    }, t('common.labels.title')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        style: {
            ...th,
            textAlign: 'end'
        },
        scope: "col"
    }, t('common.labels.value')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        style: th,
        scope: "col"
    }, t('common.labels.status')))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tbody", null, rows.map((r, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", {
            key: `${r.kind}-${r.t}-${r.name}-${i}`,
            "data-testid": "analysis-table-row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: {
                ...td,
                whiteSpace: 'nowrap'
            }
        }, (0, $eCeEG.jalaliShort)(r.t, {
            formatDate: formatDate
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: td
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b61a9124911a13c6$var$Chip, {
            kind: r.kind
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: {
                ...td,
                color: (0, $2Ieny.CL).text1,
                fontWeight: 700
            }
        }, r.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: {
                ...td,
                direction: 'ltr',
                textAlign: 'end',
                fontVariantNumeric: 'tabular-nums'
            }
        }, r.value || "\u2014"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: td
        }, r.status ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.625rem',
                fontWeight: 800,
                borderRadius: '0.3125rem',
                padding: '0.09375rem 0.5rem',
                background: r.status === 'critical' ? (0, $2Ieny.CL).dangerSoft : (0, $2Ieny.CL).warnSoft,
                color: r.status === 'critical' ? (0, $2Ieny.CL).danger : (0, $2Ieny.CL).warnInk
            }
        }, $b61a9124911a13c6$var$STATUS_LBL(t)[r.status] || r.status) : r.note || ''))))));
};
var $b61a9124911a13c6$export$2e2bcd8739ae039 = $b61a9124911a13c6$var$AnalysisTable;

});


parcelRegister("laikc", function(module, exports) {

$parcel$export(module.exports, "default", () => $d25dbf9aade1aa26$export$2e2bcd8739ae039);
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $7gSBD = parcelRequire("7gSBD");

var $aX9TZ = parcelRequire("aX9TZ");

var $k2reB = parcelRequire("k2reB");
var $4CVxl = parcelRequire("4CVxl");

var $eVM84 = parcelRequire("eVM84");

var $3OnFU = parcelRequire("3OnFU");

var $dLdf9 = parcelRequire("dLdf9");

var $gq4TR = parcelRequire("gq4TR");

var $2Ieny = parcelRequire("2Ieny");

var $51HmE = parcelRequire("51HmE");

var $j7Lry = parcelRequire("j7Lry");

var $5VLSD = parcelRequire("5VLSD");

var $dOedW = parcelRequire("dOedW");

var $k7gz6 = parcelRequire("k7gz6");

var $355Fy = parcelRequire("355Fy");

var $gH9BX = parcelRequire("gH9BX");

var $f49Lg = parcelRequire("f49Lg");

var $8CHX0 = parcelRequire("8CHX0");
// ─────────────────────────────────────────────────────────────────────────────
// «مشاهدات» — the record's measured-values tab: vital signs and laboratory
// analytes, two families the doctor reads the same way (latest value, is it in
// range, how has it moved), so they share one section and one detail rail.
//
// This file is composition + the normalisation that turns either family into
// the rail's single shape. Data/selection live in `useObservations`, markup in
// `web/observations/*` (DESIGN §1.2 / §2.6).
// ─────────────────────────────────────────────────────────────────────────────
const $d25dbf9aade1aa26$var$ClinicalObservationsTab = ({ p: p, onRefresh: onRefresh })=>{
    const { formatDigits: formatDigits, formatList: formatList, t: t } = (0, $LNQP4.default)();
    const o = (0, $dOedW.useObservations)(p);
    const [confirmObs, setConfirmObs] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [deleteError, setDeleteError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // Both families normalise into one detail shape — the reason a single rail can
    // render a vital and an analyte without knowing which it got.
    const detail = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const sel = o.selected;
        if (!sel) return null;
        if (sel.type === 'vital') {
            const def = (0, $5VLSD.VITAL_TILES).find((d)=>d.id === sel.defId);
            const readings = def ? o.vitalsByLoinc[def.loinc] : null;
            if (!def || !readings?.length) return null;
            const last = readings[readings.length - 1];
            return {
                categoryLabel: t('patient.labCategory.vitals'),
                categoryColor: (0, $2Ieny.CL).accent,
                Icon: def.Icon,
                displayName: def.label,
                value: last.value,
                unit: def.unit,
                status: last.status,
                date: last.date,
                readings: readings,
                refLow: def.refLow,
                refHigh: def.refHigh,
                canDelete: false
            };
        }
        const series = o.seriesMap[sel.display];
        const last = series?.readings[series.readings.length - 1];
        if (!last) return null;
        const cat = (0, $gq4TR.LAB_CATEGORIES).find((c)=>c.id === series.catId);
        return {
            categoryLabel: `\u{622}\u{632}\u{645}\u{627}\u{6CC}\u{634}\u{6AF}\u{627}\u{647}\u{6CC} \xb7 ${cat?.label || t('common.state.other')}`,
            categoryColor: cat?.color || (0, $2Ieny.CL).accent,
            Icon: null,
            displayName: series.display,
            value: last.value,
            unit: series.unit,
            status: last.status,
            date: last.date,
            readings: series.readings,
            refLow: null,
            refHigh: null,
            canDelete: true
        };
    }, [
        o.selected,
        o.vitalsByLoinc,
        o.seriesMap,
        t
    ]);
    const deleteReading = (id)=>{
        setDeleteError(null);
        (0, $eVM84.bffMutation)((0, $j7Lry.DELETE_OBSERVATION), {
            id: id
        }).then(onRefresh)// A silent no-op after a confirmed delete reads as "it worked" (§14.3).
        .catch((e)=>setDeleteError(e?.message || String(e)));
    };
    const activePanel = o.panels.find((c)=>c.id === o.activeCategory);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "observations-content",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $k7gz6.default), {
        title: t('patient.labCategory.vitals'),
        hint: t('patient.obs.vitalsCaption'),
        summary: !o.vitalsLoading && !o.vitalsError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.3125rem',
                fontSize: '0.75rem',
                fontWeight: 600,
                color: o.flaggedVitals.length ? (0, $2Ieny.CL).dangerInk : (0, $2Ieny.CL).goodInk
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                width: '0.4375rem',
                height: '0.4375rem',
                borderRadius: '50%',
                background: o.flaggedVitals.length ? (0, $2Ieny.CL).danger : (0, $2Ieny.CL).good
            }
        }), o.flaggedVitals.length ? t('patient.obs.outOfRangeShort', {
            count: (0, $51HmE.faNum)(o.flaggedVitals.length, formatDigits)
        }) : t('patient.obs.allNormal'))
    }), o.flaggedVitals.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "status",
        style: {
            background: (0, $2Ieny.CL).dangerSoft,
            border: `1px solid ${(0, $2Ieny.CL).danger}`,
            borderRadius: '0.5rem',
            padding: '0.625rem 0.875rem',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            fontSize: '0.78125rem',
            color: (0, $2Ieny.CL).dangerInk
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: '0.5rem',
            height: '0.5rem',
            borderRadius: '50%',
            background: (0, $2Ieny.CL).danger,
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontWeight: 600
        }
    }, t('patient.obs.outOfRangeCount', {
        count: (0, $51HmE.faNum)(o.flaggedVitals.length, formatDigits)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: (0, $2Ieny.CL).danger
        }
    }, "\xb7"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, formatList(o.flaggedVitals.map((d)=>d.label)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'grid',
            gridTemplateColumns: detail ? '1fr 23.75rem' : '1fr',
            gap: '0.875rem',
            alignItems: 'start'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.875rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "observations-vitals",
        "data-state": o.vitalsLoading ? 'loading' : o.vitalsError ? 'error' : 'content'
    }, o.vitalsError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dLdf9.default), {
        title: t('patient.obs.vitalsHistoryFailed'),
        detail: o.vitalsError?.message || String(o.vitalsError),
        onRetry: o.retryVitals
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(10.9375rem, 1fr))',
            gap: '0.625rem'
        }
    }, o.vitalsLoading ? (0, $5VLSD.VITAL_TILES).map((d)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aX9TZ.VitalTileSkeleton), {
            key: d.id
        })) : (0, $5VLSD.VITAL_TILES).map((def)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $355Fy.default), {
            key: def.id,
            def: def,
            readings: o.vitalsByLoinc[def.loinc],
            selected: o.selected?.type === 'vital' && o.selected.defId === def.id,
            onSelect: ()=>o.setSelected({
                    type: 'vital',
                    defId: def.id
                })
        })))), p.bmi != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: (0, $2Ieny.CL).surface,
            border: `1px solid ${(0, $2Ieny.CL).border}`,
            borderRadius: '0.75rem',
            padding: '0.875rem 1rem',
            display: 'flex',
            alignItems: 'center',
            gap: '0.875rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $k2reB.default), {
        size: 18,
        color: (0, $2Ieny.CL).accent,
        strokeWidth: 2,
        "aria-hidden": true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.75rem',
            color: (0, $2Ieny.CL).text2,
            fontWeight: 500
        }
    }, t('patient.vitals.bmi')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'baseline',
            gap: '0.5rem',
            marginTop: '0.25rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '1.375rem',
            fontWeight: 700,
            color: (0, $2Ieny.CL).text1,
            direction: 'ltr'
        }
    }, (0, $51HmE.faNum)(p.bmi.toFixed(1), formatDigits)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.6875rem',
            color: (0, $2Ieny.CL).text3
        }
    }, "kg/m\xb2"), p.lastWeight && p.height && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.6875rem',
            color: (0, $2Ieny.CL).text3
        }
    }, (0, $51HmE.faNum)(p.lastWeight, formatDigits), " kg \xb7 ", (0, $51HmE.faNum)(p.height, formatDigits), " cm")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: '0.25rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $k7gz6.default), {
        dot: (0, $2Ieny.CL).navy,
        title: t('visit.orders.tests'),
        hint: t('patient.obs.labCaption')
    })), o.hasObservations ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "observations-panels",
        style: {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(8.75rem, 1fr))',
            gap: '0.5rem'
        }
    }, o.panels.map((cat)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gH9BX.default), {
            key: cat.id,
            ...cat,
            active: o.activeCategory === cat.id,
            onSelect: ()=>o.openPanel(cat.id)
        }))), o.activeCategory && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f49Lg.default), {
        category: activePanel,
        tests: o.categoryTests,
        selectedDisplay: o.selected?.type === 'lab' ? o.selected.display : null,
        onSelect: (display)=>o.setSelected({
                type: 'lab',
                display: display
            })
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        "data-testid": "observations-empty",
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4CVxl.default), {
            size: 44,
            color: (0, $2Ieny.CL).text3,
            strokeWidth: 1.5,
            "aria-hidden": true
        }),
        title: t('patient.obs.noLabResults'),
        description: t('patient.obs.uploadHintFiles')
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8CHX0.default), {
        detail: detail,
        onDeleteReading: setConfirmObs
    })), deleteError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dLdf9.default), {
        title: t('patient.obs.deleteResultFailed'),
        detail: deleteError,
        onRetry: ()=>setDeleteError(null)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3OnFU.default), {
        open: !!confirmObs,
        onOpenChange: (open)=>{
            if (!open) setConfirmObs(null);
        },
        title: t('patient.obs.deleteResult'),
        message: t('patient.obs.deleteResultConfirm'),
        destructive: true,
        confirmLabel: t('common.actions.delete'),
        cancelLabel: t('common.actions.cancel'),
        onConfirm: ()=>deleteReading(confirmObs)
    }));
};
var $d25dbf9aade1aa26$export$2e2bcd8739ae039 = $d25dbf9aade1aa26$var$ClinicalObservationsTab;

});
parcelRegister("5VLSD", function(module, exports) {

$parcel$export(module.exports, "VITAL_TILES", () => $45176aa1d6f403ce$export$7be94d9308953985);
$parcel$export(module.exports, "STATUS_LABEL", () => $45176aa1d6f403ce$export$a1176940376eb77f);
$parcel$export(module.exports, "statusOf", () => $45176aa1d6f403ce$export$1094b4db5e23d27c);
$parcel$export(module.exports, "statusTone", () => $45176aa1d6f403ce$export$348dc3495f07d294);
$parcel$export(module.exports, "statusRowBg", () => $45176aa1d6f403ce$export$eafbb00f0f1ef8c5);
$parcel$export(module.exports, "numOf", () => $45176aa1d6f403ce$export$bd269aa233c571a9);
// Desktop presentation vocabulary for the «مشاهدات» section.
//
// The section renders two families of observation that the record treats alike:
// vital signs (fixed set, reference ranges known) and laboratory analytes (open
// set, grouped into panels). Both families' *domain* definitions are shared with
// the mobile surface — `VITAL_DEFS` and the lab taxonomy in
// `constants/patientRecord.js` — so only the desktop's rendering choices live
// here.

var $k2reB = parcelRequire("k2reB");
var $ljvFv = parcelRequire("ljvFv");
var $78hrr = parcelRequire("78hrr");
var $fCLAg = parcelRequire("fCLAg");
var $1GCGa = parcelRequire("1GCGa");

var $jTCZr = parcelRequire("jTCZr");

var $gq4TR = parcelRequire("gq4TR");

var $2Ieny = parcelRequire("2Ieny");
// The shared definitions name their icon; the desktop resolves it to a lucide
// component (a constants module stays free of React imports).
const $45176aa1d6f403ce$var$ICONS = {
    HeartPulse: $ljvFv.default,
    Activity: $k2reB.default,
    Thermometer: $fCLAg.default,
    Wind: $1GCGa.default,
    Scale: $78hrr.default
};
const $45176aa1d6f403ce$export$7be94d9308953985 = (0, $gq4TR.VITAL_DEFS).map((d)=>({
        ...d,
        Icon: $45176aa1d6f403ce$var$ICONS[d.icon] || (0, $k2reB.default)
    }));
const $45176aa1d6f403ce$export$2c2158458d644e4b = (s)=>s === 'abnormal' || s === 'ABNORMAL';
const $45176aa1d6f403ce$export$32de35ebf66c4eca = (s)=>s === 'critical' || s === 'CRITICAL';
const $45176aa1d6f403ce$export$a1176940376eb77f = (t)=>({
        critical: t('visit.vitals.critical'),
        abnormal: t('visit.vitals.abnormal'),
        normal: t('patient.obs.normal')
    });
const $45176aa1d6f403ce$export$1094b4db5e23d27c = (s)=>$45176aa1d6f403ce$export$32de35ebf66c4eca(s) ? 'critical' : $45176aa1d6f403ce$export$2c2158458d644e4b(s) ? 'abnormal' : 'normal';
const $45176aa1d6f403ce$export$348dc3495f07d294 = (s)=>$45176aa1d6f403ce$export$32de35ebf66c4eca(s) ? (0, $2Ieny.CL).danger : $45176aa1d6f403ce$export$2c2158458d644e4b(s) ? (0, $2Ieny.CL).warn : (0, $2Ieny.CL).good;
const $45176aa1d6f403ce$export$eafbb00f0f1ef8c5 = (s)=>$45176aa1d6f403ce$export$32de35ebf66c4eca(s) ? (0, $jTCZr.CT).dangerSoft : $45176aa1d6f403ce$export$2c2158458d644e4b(s) ? (0, $jTCZr.CT).warnSoft : 'transparent';
const $45176aa1d6f403ce$export$bd269aa233c571a9 = (r)=>typeof r?.numVal === 'number' ? r.numVal : parseFloat(r?.value);

});
parcelRegister("78hrr", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ca1411ae90a041d$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $0ca1411ae90a041d$export$a2387ed3b5d536eb = {
    name: "scale",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M12 3v18",
                key: "108xh3"
            }
        ],
        [
            "path",
            {
                d: "m19 8 3 8a5 5 0 0 1-6 0zV7",
                key: "zcdpyk"
            }
        ],
        [
            "path",
            {
                d: "M3 7h1a17 17 0 0 0 8-2 17 17 0 0 0 8 2h1",
                key: "1yorad"
            }
        ],
        [
            "path",
            {
                d: "m5 8 3 8a5 5 0 0 1-6 0zV7",
                key: "eua70x"
            }
        ],
        [
            "path",
            {
                d: "M7 21h10",
                key: "1b0cd5"
            }
        ]
    ]
};
$0ca1411ae90a041d$export$a2387ed3b5d536eb.node;
const $0ca1411ae90a041d$export$2e2bcd8739ae039 = (0, $9QBug.default)($0ca1411ae90a041d$export$a2387ed3b5d536eb);

});

parcelRegister("fCLAg", function(module, exports) {

$parcel$export(module.exports, "default", () => $445e5c36990c15a3$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $445e5c36990c15a3$export$a2387ed3b5d536eb = {
    name: "thermometer",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M14 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z",
                key: "17jzev"
            }
        ]
    ]
};
$445e5c36990c15a3$export$a2387ed3b5d536eb.node;
const $445e5c36990c15a3$export$2e2bcd8739ae039 = (0, $9QBug.default)($445e5c36990c15a3$export$a2387ed3b5d536eb);

});

parcelRegister("1GCGa", function(module, exports) {

$parcel$export(module.exports, "default", () => $434e7bc41e3193cc$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $434e7bc41e3193cc$export$a2387ed3b5d536eb = {
    name: "wind",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M12.8 19.6A2 2 0 1 0 14 16H2",
                key: "148xed"
            }
        ],
        [
            "path",
            {
                d: "M17.5 8a2.5 2.5 0 1 1 2 4H2",
                key: "1u4tom"
            }
        ],
        [
            "path",
            {
                d: "M9.8 4.4A2 2 0 1 1 11 8H2",
                key: "75valh"
            }
        ]
    ]
};
$434e7bc41e3193cc$export$a2387ed3b5d536eb.node;
const $434e7bc41e3193cc$export$2e2bcd8739ae039 = (0, $9QBug.default)($434e7bc41e3193cc$export$a2387ed3b5d536eb);

});


parcelRegister("dOedW", function(module, exports) {

$parcel$export(module.exports, "useObservations", () => $a0dafa72fb6939ff$export$4acc038e2d2fe1df);

var $acw62 = parcelRequire("acw62");

var $xQteh = parcelRequire("xQteh");

var $01rTJ = parcelRequire("01rTJ");
function $a0dafa72fb6939ff$export$4acc038e2d2fe1df(patient) {
    const vitals = (0, $xQteh.useVitalSeries)(patient?.id);
    const seriesMap = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $01rTJ.buildSeriesMap)(patient?.clinicalObservations), [
        patient?.clinicalObservations
    ]);
    const counts = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $01rTJ.countByCategory)(seriesMap), [
        seriesMap
    ]);
    const panels = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $01rTJ.categoriesWithData)(counts).map((c)=>({
                ...c,
                flagged: (0, $01rTJ.flaggedInCategory)(seriesMap, c.id)
            })), [
        counts,
        seriesMap
    ]);
    const [activeCategory, setActiveCategory] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (activeCategory || !Object.keys(counts).length) return;
        setActiveCategory((0, $01rTJ.defaultCategory)(counts));
    }, [
        counts
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const categoryTests = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $01rTJ.testsInCategory)(seriesMap, activeCategory), [
        seriesMap,
        activeCategory
    ]);
    // ── One selection across both families ────────────────────────────────────
    const [selected, setSelected] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const selectedRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(selected);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        selectedRef.current = selected;
    }, [
        selected
    ]);
    // Opening a panel selects its first test — unless the doctor is currently
    // reading a vital, which must not be yanked away underneath them.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!categoryTests.length) return;
        const cur = selectedRef.current;
        if (cur?.type === 'vital') return;
        const stillListed = cur?.type === 'lab' && categoryTests.some((test)=>test.display === cur.display);
        if (!stillListed) setSelected({
            type: 'lab',
            display: categoryTests[0].display
        });
    }, [
        categoryTests
    ]);
    const openPanel = (catId)=>{
        if (activeCategory === catId) {
            setActiveCategory(null);
            setSelected(null);
            return;
        }
        setActiveCategory(catId);
        const first = (0, $01rTJ.testsInCategory)(seriesMap, catId)[0];
        setSelected(first ? {
            type: 'lab',
            display: first.display
        } : null);
    };
    return {
        // vitals (from the shared hook)
        vitalsByLoinc: vitals.byLoinc,
        vitalsLoading: vitals.loading,
        vitalsError: vitals.error,
        flaggedVitals: vitals.flagged,
        retryVitals: vitals.retry,
        seriesMap: // labs
        seriesMap,
        counts: counts,
        panels: panels,
        categoryTests: categoryTests,
        activeCategory: activeCategory,
        openPanel: openPanel,
        hasObservations: Object.keys(seriesMap).length > 0,
        selected: // selection
        selected,
        setSelected: setSelected
    };
}

});

parcelRegister("k7gz6", function(module, exports) {

$parcel$export(module.exports, "default", () => $35983bafd431f487$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $2Ieny = parcelRequire("2Ieny");
// The «مشاهدات» section's zone heading: a coloured dot, the zone's name, its
// technical vocabulary, and an optional right-aligned status summary. Used twice
// (علائم حیاتی and آزمایش‌ها) so the two zones read as one section.
const $35983bafd431f487$var$SectionHead = ({ dot: dot = (0, $2Ieny.CL).accent, title: title, hint: hint, summary: summary })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: '0.625rem',
            height: '0.625rem',
            borderRadius: '50%',
            background: dot,
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.9375rem',
            fontWeight: 700,
            color: (0, $2Ieny.CL).text1
        }
    }, title), hint && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.75rem',
            color: (0, $2Ieny.CL).text3
        }
    }, hint)), summary);
var $35983bafd431f487$export$2e2bcd8739ae039 = $35983bafd431f487$var$SectionHead;

});

parcelRegister("355Fy", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5d0b046c6a6fc0f$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $3Amwd = parcelRequire("3Amwd");

var $jTCZr = parcelRequire("jTCZr");

var $2Ieny = parcelRequire("2Ieny");

var $51HmE = parcelRequire("51HmE");

var $5VLSD = parcelRequire("5VLSD");

var $01rTJ = parcelRequire("01rTJ");
// One vital sign as a selectable tile: name, latest value, change against the
// previous reading, a trend glyph and the reference range. Selecting it drives
// the section's shared detail rail — so it is the kit `Button` re-laid-out as a
// card (DESIGN §1.2), never a styled div with an onClick.
const $c5d0b046c6a6fc0f$var$VitalTile = ({ def: def, readings: readings = [], selected: selected, onSelect: onSelect })=>{
    const { formatDigits: formatDigits, formatDate: formatDate, t: t } = (0, $LNQP4.default)();
    const latest = readings[readings.length - 1];
    const prev = readings[readings.length - 2];
    const tone = (0, $5VLSD.statusTone)(latest?.status);
    const delta = latest && prev && !Number.isNaN((0, $5VLSD.numOf)(latest)) && !Number.isNaN((0, $5VLSD.numOf)(prev)) ? (0, $5VLSD.numOf)(latest) - (0, $5VLSD.numOf)(prev) : null;
    const points = readings.map((0, $5VLSD.numOf)).filter((v)=>!Number.isNaN(v));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        onClick: onSelect,
        "aria-pressed": !!selected,
        "data-testid": `observations-vital-${def.id}`,
        "data-state": latest ? 'content' : 'empty',
        className: "h-auto w-full flex-col items-stretch justify-start gap-0 rounded-xl p-3 text-start font-normal",
        style: {
            background: selected ? (0, $jTCZr.soft)(tone, 0.06) : (0, $2Ieny.CL).surface,
            borderColor: selected ? tone : (0, $2Ieny.CL).border
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.4375rem',
            marginBottom: '0.4375rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(def.Icon, {
        size: 15,
        color: (0, $2Ieny.CL).text2,
        strokeWidth: 2,
        "aria-hidden": true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.75rem',
            color: (0, $2Ieny.CL).text2,
            fontWeight: 600,
            flex: 1
        }
    }, t(def.labelKey)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: '0.5rem',
            height: '0.5rem',
            borderRadius: '50%',
            background: latest ? tone : (0, $2Ieny.CL).border
        }
    })), latest ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'flex',
            alignItems: 'baseline',
            gap: '0.3125rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '1.5rem',
            fontWeight: 700,
            color: tone,
            direction: 'ltr'
        }
    }, (0, $51HmE.faNum)(latest.value, formatDigits)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.6875rem',
            color: (0, $2Ieny.CL).text3
        }
    }, def.unit), delta !== null && delta !== 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.6875rem',
            fontWeight: 600,
            color: delta > 0 ? (0, $2Ieny.CL).dangerInk : (0, $2Ieny.CL).goodInk,
            marginInlineStart: 'auto'
        }
    }, delta > 0 ? "\u2191" : "\u2193", (0, $51HmE.faNum)((0, $01rTJ.formatDelta)(delta), formatDigits))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'space-between',
            marginTop: '0.375rem',
            gap: '0.375rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.625rem',
            color: (0, $2Ieny.CL).text3
        }
    }, (0, $51HmE.isoToJalali)(latest.date, formatDate)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3Amwd.default), {
        points: points,
        width: 70,
        height: 22,
        tone: tone === (0, $2Ieny.CL).good ? 'accent' : 'danger'
    })), def.refLow != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'block',
            fontSize: '0.625rem',
            color: (0, $2Ieny.CL).text3,
            marginTop: '0.1875rem',
            direction: 'ltr',
            unicodeBidi: 'isolate',
            textAlign: 'start'
        }
    }, t('patient.obs.referenceLabel'), " ", (0, $51HmE.faNum)(def.refLow, formatDigits), "\u2013", (0, $51HmE.faNum)(def.refHigh, formatDigits), " ", def.unit)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.75rem',
            color: (0, $2Ieny.CL).text3,
            marginTop: '0.25rem'
        }
    }, t('patient.obs.notRecorded')));
};
var $c5d0b046c6a6fc0f$export$2e2bcd8739ae039 = $c5d0b046c6a6fc0f$var$VitalTile;

});

parcelRegister("gH9BX", function(module, exports) {

$parcel$export(module.exports, "default", () => $29e63e805722b904$export$2e2bcd8739ae039);
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");

var $jTCZr = parcelRequire("jTCZr");

var $2Ieny = parcelRequire("2Ieny");

var $51HmE = parcelRequire("51HmE");
// One laboratory panel (بیوشیمی، هماتولوژی، تیروئید…) as a selectable tile:
// how many analytes it holds, and a danger dot when any of them has ever come
// back out of range. Selecting it opens that panel's test list below.
//
// `color` is the panel's identity hue from the shared lab taxonomy — a
// categorical palette (18 panels the brand tokens cannot tell apart), used only
// to distinguish panels from each other; status still speaks in semantic tokens.
const $29e63e805722b904$var$PanelTile = ({ id: id, label: label, color: color, count: count = 0, flagged: flagged = 0, active: active, onSelect: onSelect })=>{
    const { formatDigits: formatDigits, t: t } = (0, $LNQP4.default)();
    const hue = color || (0, $2Ieny.CL).accent;
    const hasData = count > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        variant: "outline",
        onClick: onSelect,
        "aria-pressed": !!active,
        "data-testid": `observations-panel-${id}`,
        "data-state": hasData ? 'content' : 'empty',
        className: "h-auto w-full flex-col items-stretch justify-start gap-0 rounded-lg p-3 text-start font-normal",
        style: {
            background: active ? (0, $jTCZr.soft)(hue, 0.08) : hasData ? (0, $2Ieny.CL).surface : (0, $2Ieny.CL).surface2,
            borderColor: active ? hue : (0, $2Ieny.CL).border
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.3125rem',
            marginBottom: '0.3125rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: '0.4375rem',
            height: '0.4375rem',
            borderRadius: '50%',
            background: hasData ? hue : (0, $2Ieny.CL).border,
            flexShrink: 0
        }
    }), flagged > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-label": t('patient.obs.outOfRangeCount', {
            count: (0, $51HmE.faNum)(flagged, formatDigits)
        }),
        style: {
            width: '0.375rem',
            height: '0.375rem',
            borderRadius: '50%',
            background: (0, $2Ieny.CL).danger,
            flexShrink: 0,
            marginInlineStart: 'auto'
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.78125rem',
            fontWeight: 700,
            color: active ? hue : hasData ? (0, $2Ieny.CL).text1 : (0, $2Ieny.CL).text3
        }
    }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.6875rem',
            marginTop: '0.3125rem',
            fontWeight: hasData ? 600 : 400,
            color: hasData ? active ? hue : (0, $2Ieny.CL).accentInk : (0, $2Ieny.CL).text3
        }
    }, hasData ? t('patient.obs.observationCount', {
        count: (0, $51HmE.faNum)(count, formatDigits)
    }) : t('patient.obs.noData')));
};
var $29e63e805722b904$export$2e2bcd8739ae039 = $29e63e805722b904$var$PanelTile;

});

parcelRegister("f49Lg", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed28e0b1a389c1e7$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $7gSBD = parcelRequire("7gSBD");
var $3Amwd = parcelRequire("3Amwd");

var $jTCZr = parcelRequire("jTCZr");

var $4CVxl = parcelRequire("4CVxl");

var $2Ieny = parcelRequire("2Ieny");

var $51HmE = parcelRequire("51HmE");

var $5VLSD = parcelRequire("5VLSD");
// The selected panel's analytes, one row each: name, trend glyph, latest value
// and status. Rows drive the shared detail rail, so each is the kit `Button`
// re-laid-out as a table row.
const $ed28e0b1a389c1e7$var$ObservationList = ({ category: category, tests: tests = [], selectedDisplay: selectedDisplay, onSelect: onSelect })=>{
    const { formatDigits: formatDigits, t: t } = (0, $LNQP4.default)();
    const hue = category?.color || (0, $2Ieny.CL).accent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "observations-list",
        "data-state": tests.length ? 'content' : 'empty',
        style: {
            background: (0, $2Ieny.CL).surface,
            border: `1px solid ${(0, $2Ieny.CL).border}`,
            borderRadius: '0.6875rem',
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '0.6875rem 0.9375rem',
            borderBottom: `1px solid ${(0, $2Ieny.CL).border}`,
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: '0.5rem',
            height: '0.5rem',
            borderRadius: '50%',
            background: hue,
            flexShrink: 0
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.8125rem',
            fontWeight: 700,
            color: (0, $2Ieny.CL).text1
        }
    }, category?.labelKey && t(category.labelKey)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.6875rem',
            color: (0, $2Ieny.CL).text3,
            marginInlineStart: 'auto'
        }
    }, (0, $51HmE.faNum)(tests.length, formatDigits), " ", t('patient.obs.view'))), tests.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4CVxl.default), {
            size: 36,
            color: (0, $2Ieny.CL).text3,
            strokeWidth: 1.5,
            "aria-hidden": true
        }),
        title: t('patient.obs.noneInCategory'),
        description: t('patient.obs.resultsAppearHere')
    }) : tests.map((s, i)=>{
        const last = s.readings[s.readings.length - 1];
        const tone = (0, $5VLSD.statusTone)(last?.status);
        const selected = selectedDisplay === s.display;
        const points = s.readings.map((0, $5VLSD.numOf)).filter((v)=>!Number.isNaN(v));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            key: s.display,
            variant: "ghost",
            onClick: ()=>onSelect(s.display),
            "aria-pressed": selected,
            "data-testid": `observations-row-${s.display}`,
            className: "h-auto w-full justify-start gap-3 rounded-none px-4 py-3 text-start font-normal hover:bg-muted/60",
            style: {
                background: selected ? (0, $jTCZr.soft)(hue, 0.06) : 'transparent',
                borderInlineStart: `3px solid ${selected ? hue : 'transparent'}`,
                borderBottom: i < tests.length - 1 ? `1px solid ${(0, $2Ieny.CL).border}` : 'none'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.8125rem',
                fontWeight: 600,
                color: (0, $2Ieny.CL).text1,
                flex: 1,
                direction: 'ltr',
                unicodeBidi: 'isolate',
                textAlign: 'start'
            }
        }, s.display), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3Amwd.default), {
            points: points,
            width: 56,
            height: 20,
            tone: (0, $5VLSD.statusOf)(last?.status) === 'normal' ? 'accent' : 'danger'
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.8125rem',
                direction: 'ltr',
                fontWeight: (0, $5VLSD.statusOf)(last?.status) === 'normal' ? 500 : 700,
                color: tone,
                minWidth: '5.625rem',
                textAlign: 'end'
            }
        }, last ? `${(0, $51HmE.faNum)(last.value, formatDigits)} ${s.unit || ''}`.trim() : "\u2014"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.3125rem',
                fontSize: '0.71875rem',
                color: tone,
                minWidth: '4.25rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                width: '0.4375rem',
                height: '0.4375rem',
                borderRadius: '50%',
                background: tone,
                flexShrink: 0
            }
        }), (0, $5VLSD.STATUS_LABEL)(t)[(0, $5VLSD.statusOf)(last?.status)]));
    }));
};
var $ed28e0b1a389c1e7$export$2e2bcd8739ae039 = $ed28e0b1a389c1e7$var$ObservationList;

});

parcelRegister("8CHX0", function(module, exports) {

$parcel$export(module.exports, "default", () => $f68b3042ba8834db$export$2e2bcd8739ae039);
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $ePaaC = parcelRequire("ePaaC");

var $jTCZr = parcelRequire("jTCZr");

var $6TdpC = parcelRequire("6TdpC");

var $2Ieny = parcelRequire("2Ieny");

var $51HmE = parcelRequire("51HmE");

var $5VLSD = parcelRequire("5VLSD");

var $01rTJ = parcelRequire("01rTJ");
// The section's one detail rail — whichever observation is selected, vital or
// analyte, renders here in the same shape: identity, current value, the trend,
// then every reading. Only the two families' *sources* differ, and the tab
// normalises that before it gets here (`detail`), which is why one rail can
// serve both.
//
// The readings table is the chart's accessible equivalent (the chart itself is
// aria-hidden), so it always renders — never behind a toggle.
const $f68b3042ba8834db$var$ObservationDetail = ({ detail: detail, onDeleteReading: onDeleteReading })=>{
    const { formatDigits: formatDigits, formatDate: formatDate, t: t } = (0, $LNQP4.default)();
    if (!detail) return null;
    const tone = (0, $5VLSD.statusTone)(detail.status);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'sticky',
            top: '4.625rem'
        },
        "data-testid": "observations-detail"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: (0, $2Ieny.CL).surface,
            border: `1.5px solid ${(0, $jTCZr.soft)(detail.categoryColor, 0.35)}`,
            borderRadius: '0.8125rem',
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '0.875rem 1rem',
            borderBottom: `1px solid ${(0, $2Ieny.CL).border}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.3125rem',
            padding: '0.125rem 0.5625rem',
            borderRadius: '0.3125rem',
            fontSize: '0.71875rem',
            fontWeight: 600,
            background: (0, $jTCZr.soft)(detail.categoryColor, 0.08),
            color: detail.categoryColor,
            border: `1px solid ${(0, $jTCZr.soft)(detail.categoryColor, 0.2)}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: '0.375rem',
            height: '0.375rem',
            borderRadius: '50%',
            background: detail.categoryColor
        }
    }), detail.categoryLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            marginTop: '0.5rem'
        }
    }, detail.Icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(detail.Icon, {
        size: 17,
        color: (0, $2Ieny.CL).text2,
        strokeWidth: 2,
        "aria-hidden": true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '1.0625rem',
            fontWeight: 700,
            color: (0, $2Ieny.CL).text1,
            direction: 'ltr',
            unicodeBidi: 'isolate',
            textAlign: 'start'
        }
    }, detail.displayName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'baseline',
            gap: '0.5rem',
            marginTop: '0.375rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '1.875rem',
            fontWeight: 700,
            color: tone,
            direction: 'ltr',
            letterSpacing: '-0.01em'
        }
    }, (0, $51HmE.faNum)(detail.value, formatDigits)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.8125rem',
            color: (0, $2Ieny.CL).text3
        }
    }, detail.unit), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.3125rem',
            marginInlineStart: 'auto',
            fontSize: '0.78125rem',
            fontWeight: 600,
            color: tone
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: '0.5rem',
            height: '0.5rem',
            borderRadius: '50%',
            background: tone
        }
    }), (0, $5VLSD.STATUS_LABEL)(t)[(0, $5VLSD.statusOf)(detail.status)])), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.71875rem',
            color: (0, $2Ieny.CL).text3,
            marginTop: '0.25rem'
        }
    }, t('patient.obs.lastRecorded'), " ", (0, $51HmE.isoToJalali)(detail.date, formatDate), " \xb7 ", (0, $51HmE.faNum)(detail.readings.length, formatDigits), " ", t('patient.obs.result'))), detail.readings.filter((r)=>!Number.isNaN((0, $5VLSD.numOf)(r))).length > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '0.875rem 1rem',
            borderBottom: `1px solid ${(0, $2Ieny.CL).border}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ePaaC.default), {
        readings: detail.readings,
        color: detail.categoryColor,
        refLow: detail.refLow,
        refHigh: detail.refHigh,
        height: 156,
        formatX: (r)=>(0, $51HmE.isoToJalali)(r.date, formatDate),
        formatValue: (v)=>(0, $51HmE.faNum)(v.toFixed(1), formatDigits),
        "data-testid": "observations-trend"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("table", {
        style: {
            width: '100%',
            borderCollapse: 'collapse',
            fontSize: '0.8125rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("caption", {
        className: "sr-only"
    }, t('patient.obs.valueHistory'), " ", detail.displayName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", {
        style: {
            background: (0, $2Ieny.CL).surface2
        }
    }, [
        t('common.labels.date'),
        t('common.labels.value'),
        t('patient.obs.change'),
        t('common.labels.status'),
        ''
    ].map((h, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
            key: i,
            scope: "col",
            style: {
                textAlign: 'start',
                padding: '0.5rem 1rem',
                fontSize: '0.6875rem',
                fontWeight: 600,
                color: (0, $2Ieny.CL).text3,
                borderBottom: `1px solid ${(0, $2Ieny.CL).border}`
            }
        }, h)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tbody", null, [
        ...detail.readings
    ].reverse().map((r, i, rows)=>{
        const prev = rows[i + 1];
        const delta = prev && !Number.isNaN((0, $5VLSD.numOf)(r)) && !Number.isNaN((0, $5VLSD.numOf)(prev)) ? (0, $5VLSD.numOf)(r) - (0, $5VLSD.numOf)(prev) : null;
        const rTone = (0, $5VLSD.statusTone)(r.status);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", {
            key: r.id,
            style: {
                background: (0, $5VLSD.statusRowBg)(r.status)
            },
            "data-testid": `observations-reading-${r.id}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: {
                padding: '0.5625rem 1rem',
                borderBottom: `1px solid ${(0, $2Ieny.CL).border}`,
                color: (0, $2Ieny.CL).text2
            }
        }, (0, $51HmE.isoToJalali)(r.date, formatDate)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: {
                padding: '0.5625rem 1rem',
                borderBottom: `1px solid ${(0, $2Ieny.CL).border}`,
                direction: 'ltr',
                unicodeBidi: 'isolate',
                textAlign: 'start'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                color: rTone,
                fontWeight: (0, $5VLSD.statusOf)(r.status) === 'normal' ? 500 : 700
            }
        }, (0, $51HmE.faNum)(r.value, formatDigits), " ", detail.unit)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: {
                padding: '0.5625rem 1rem',
                borderBottom: `1px solid ${(0, $2Ieny.CL).border}`,
                direction: 'ltr',
                textAlign: 'start',
                color: delta == null ? (0, $2Ieny.CL).text3 : delta > 0 ? (0, $2Ieny.CL).dangerInk : (0, $2Ieny.CL).goodInk
            }
        }, delta == null ? "\u2014" : (0, $51HmE.faNum)(`${delta > 0 ? '+' : '-'}${(0, $01rTJ.formatDelta)(delta)}`, formatDigits)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: {
                padding: '0.5625rem 1rem',
                borderBottom: `1px solid ${(0, $2Ieny.CL).border}`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.375rem',
                color: rTone,
                fontSize: '0.75rem',
                fontWeight: 500
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                width: '0.4375rem',
                height: '0.4375rem',
                borderRadius: '50%',
                background: rTone
            }
        }), (0, $5VLSD.STATUS_LABEL)(t)[(0, $5VLSD.statusOf)(r.status)])), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: {
                padding: '0.5625rem 1rem',
                borderBottom: `1px solid ${(0, $2Ieny.CL).border}`
            }
        }, detail.canDelete && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            size: "icon",
            className: "h-8 w-8 text-destructive",
            "aria-label": t('patient.obs.removeValueAria', {
                date: (0, $51HmE.isoToJalali)(r.date, formatDate)
            }),
            "data-testid": `observations-reading-delete-${r.id}`,
            onClick: ()=>onDeleteReading(r.id)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6TdpC.default), {
            size: 15,
            "aria-hidden": true
        }))));
    })))));
};
var $f68b3042ba8834db$export$2e2bcd8739ae039 = $f68b3042ba8834db$var$ObservationDetail;

});


parcelRegister("kTp82", function(module, exports) {

$parcel$export(module.exports, "default", () => $347125b38e367f5e$export$2e2bcd8739ae039);
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $ggYuf = parcelRequire("ggYuf");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");

var $eVM84 = parcelRequire("eVM84");

var $a83Oj = parcelRequire("a83Oj");

var $2Ieny = parcelRequire("2Ieny");

var $9q7ak = parcelRequire("9q7ak");

var $7iw9n = parcelRequire("7iw9n");

var $51HmE = parcelRequire("51HmE");

var $j7Lry = parcelRequire("j7Lry");

var $i9Cif = parcelRequire("i9Cif");

var $g6gAc = parcelRequire("g6gAc");

var $93kEN = parcelRequire("93kEN");

var $jDxJA = parcelRequire("jDxJA");

var $5hFXE = parcelRequire("5hFXE");

var $aQGDs = parcelRequire("aQGDs");

var $dL6zl = parcelRequire("dL6zl");
// Post-visit SOAP amendment rail. amendClinicalNote (unlike updateClinicalNote,
// the in-visit autosave) is attributed to the calling doctor server-side: the
// prior content is snapshotted into the revision history and updatedAt stamped.
const $347125b38e367f5e$var$AMEND_CLINICAL_NOTE = `
  mutation AmendClinicalNote($id: ID!, $input: UpdateClinicalNoteInput!) {
    amendClinicalNote(id: $id, input: $input) { id content updatedAt }
  }
`;
// First post-visit save on a visit that never got a SOAP row: a plain create —
// there is no prior content, so correctly no revision either.
const $347125b38e367f5e$var$CREATE_SOAP_NOTE = `
  mutation CreateClinicalNote($patientId: ID!, $input: ClinicalNoteInput!) {
    createClinicalNote(patientId: $patientId, input: $input) { id content createdAt updatedAt }
  }
`;
const $347125b38e367f5e$var$CLINICAL_NOTE_REVISIONS = `
  query ClinicalNoteRevisions($appointmentId: ID!) {
    clinicalNoteRevisions(appointmentId: $appointmentId) {
      id noteId editedBy editedAt content
    }
  }
`;
// A visit IS a scheduling appointment. The BFF (apptToEncounter) normalizes the
// appointment's type to 'in-person'|'online' and its status to
// planned|arrived|in_progress|finished|cancelled. Legacy keys kept for old rows.
const $347125b38e367f5e$var$ENC_TYPE_KEYS = (t)=>({
        'in-person': t('encounters.type.inPerson'),
        online: t('encounters.type.online'),
        OUTPATIENT: t('patient.encType.outpatient'),
        INPATIENT: t('patient.encType.inpatient'),
        EMERGENCY: t('common.urgency.emergency'),
        FOLLOW_UP: t('patient.encType.followUp'),
        outpatient: t('patient.encType.outpatient'),
        inpatient: t('patient.encType.inpatient'),
        emergency: t('common.urgency.emergency'),
        follow_up: t('patient.encType.followUp')
    });
const $347125b38e367f5e$var$ENC_STATUS_KEYS = (t)=>({
        planned: t('encounters.status.scheduled'),
        arrived: t('encounters.status.arrived'),
        in_progress: t('common.state.inProgress'),
        finished: t('patient.encStatus.finished'),
        'in-progress': t('common.state.inProgress'),
        completed: t('patient.encStatus.finished'),
        cancelled: t('patient.encStatus.cancelled'),
        'on-hold': t('visit.state.onHold'),
        active: t('common.state.inProgress')
    });
// The four SOAP sections. `k` is the mnemonic letter, which is already the
// whole point of the initialism — so there is no English `hint` beside the
// Persian name any more.
//
// There was one, a literal 'Subjective' / 'Objective' / … never wired to t(),
// sitting at the far end of the label row. In a Persian record it read as data
// rather than as a label: a clinic reported «معاینه و یافته‌ها / Objective /
// <the dentist's text>» as weird content in the patient's file. The phone
// surface never had it (constants/patientRecord.js carries only `nameKey`), so
// removing it also makes the two agree.
const $347125b38e367f5e$var$SOAP_SECTIONS = (t)=>[
        {
            k: 'S',
            name: t('visit.soap.subjective'),
            types: [
                'SOAP_S',
                'subjective',
                'chief_complaint',
                'history'
            ]
        },
        {
            k: 'O',
            name: t('visit.soap.objective'),
            types: [
                'SOAP_O',
                'objective',
                'examination',
                'findings'
            ]
        },
        {
            k: 'A',
            name: t('patient.soap.assessment'),
            types: [
                'SOAP_A',
                'assessment',
                'evaluation'
            ]
        },
        {
            k: 'P',
            name: t('patient.soap.plan'),
            types: [
                'SOAP_P',
                'plan',
                'treatment_plan'
            ]
        }
    ];
const $347125b38e367f5e$var$ORDER_URG_CLS = {
    stat: 'stat',
    urgent: 'urgent',
    routine: 'routine',
    requested: 'requested',
    active: 'active',
    completed: 'routine'
};
// The AI service answers with an English confidence level; the panel is Persian.
const $347125b38e367f5e$var$AI_CONFIDENCE = (t)=>({
        high: t('visit.confidenceLevel.high'),
        medium: t('visit.confidenceLevel.medium'),
        low: t('visit.confidenceLevel.low')
    });
const $347125b38e367f5e$var$AI_QUICK_Q = (t)=>[
        t('visit.quick.a1cTrend'),
        t('visit.quick.medChanges'),
        t('visit.quick.openOrders'),
        t('visit.quick.sixMonthCourse')
    ];
const $347125b38e367f5e$var$VisitsTab = ({ p: p, onRefresh: onRefresh })=>{
    const { t: t, formatDate: formatDate } = (0, $LNQP4.default)();
    const encounters = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>[
            ...p.encounters || []
        ].sort((a, b)=>(b.scheduledDate || b.createdAt || '').localeCompare(a.scheduledDate || a.createdAt || '')), [
        p.encounters
    ]);
    const [selEncId, setSelEncId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>encounters[0]?.id || null);
    const [rightTab, setRightTab] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('visits');
    const [innerTab, setInnerTab] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('soap');
    const [encOrders, setEncOrders] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    // The order whose result is being reviewed, or null. Held here rather than
    // in the row so the drawer survives the list re-rendering under it.
    const [reviewOrder, setReviewOrder] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [leftOpen, setLeftOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [aiQ, setAiQ] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    // The assistant is a conversation, not a one-shot lookup: `chat` IS the
    // session memory — it renders the thread and is replayed to the BFF on every
    // turn so the answer can build on what came before.
    const [chat, setChat] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [aiLoading, setAiLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const chatBodyRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const chatSeq = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(0);
    const selEnc = encounters.find((e)=>e.id === selEncId) || encounters[0] || null;
    // «کد رهگیری» of what the doctor sent to the insurer, per visit that is over (PM-0686):
    // one read for the list; read again once the e-prescription sheet closes.
    const { codes: erxCodes, reload: reloadErxCodes } = (0, $5hFXE.useVisitErxCodes)(encounters.filter((e)=>!(0, $dL6zl.isLiveEncounter)(e)).map((e)=>e.id));
    // ── post-visit SOAP editing ─────────────────────────────────────────────────
    // State lives HERE, not in SoapView: the inner views are inline components
    // recreated on every render, so any state inside them would be lost.
    const [editingSoap, setEditingSoap] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [soapDraft, setSoapDraft] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        S: '',
        O: '',
        A: '',
        P: ''
    });
    const [savingSoap, setSavingSoap] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [soapSaveError, setSoapSaveError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    // Saves are reflected without refetching the whole patient: an overlay of
    // {noteId: {content, updatedAt}} plus any notes created from this tab.
    const [noteOverlay, setNoteOverlay] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({});
    const [createdNotes, setCreatedNotes] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [historyOpen, setHistoryOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [revisions, setRevisions] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // null = not fetched yet
    const [expandedRevId, setExpandedRevId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        // Selecting another visit drops the edit/history UI state, never the saves.
        setEditingSoap(false);
        setSoapSaveError('');
        setHistoryOpen(false);
        setRevisions(null);
        setExpandedRevId(null);
    }, [
        selEncId
    ]);
    const encNotes = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>[
            ...p.clinicalNotes || [],
            ...createdNotes
        ].filter((n)=>n.appointmentId === selEncId).map((n)=>noteOverlay[n.id] ? {
                ...n,
                ...noteOverlay[n.id]
            } : n), [
        p.clinicalNotes,
        createdNotes,
        noteOverlay,
        selEncId
    ]);
    const encConds = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(p.clinicalConditions || []).filter((c)=>c.appointmentId === selEncId), [
        p.clinicalConditions,
        selEncId
    ]);
    const encMeds = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(p.clinicalMedications || []).filter((m)=>m.appointmentId === selEncId), [
        p.clinicalMedications,
        selEncId
    ]);
    const encObs = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(p.clinicalObservations || []).filter((o)=>o.appointmentId === selEncId), [
        p.clinicalObservations,
        selEncId
    ]);
    const loadEncOrders = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        if (!selEncId || !p.id) return Promise.resolve();
        return (0, $eVM84.bffQuery)((0, $j7Lry.LIST_DOCTOR_ORDERS_ENC), {
            patientId: p.id,
            appointmentId: selEncId
        }).then((d)=>setEncOrders(d.listDoctorOrders || [])).catch(()=>setEncOrders([]));
    }, [
        selEncId,
        p.id
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        loadEncOrders();
    }, [
        loadEncOrders
    ]);
    // Selecting another visit closes the drawer: it is bound to one order, and
    // leaving it open over a different visit's list would let a verdict be typed
    // against a row no longer on screen.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setReviewOrder(null);
    }, [
        selEncId
    ]);
    // A new patient is a new conversation — never carry one patient's thread over.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setChat([]);
        setAiQ('');
    }, [
        p.id
    ]);
    // Keep the newest turn in view (also while the typing indicator is up).
    // Scroll the panel itself rather than scrollIntoView — the chat lives inside
    // nested scroll containers and must not drag the page along with it.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const el = chatBodyRef.current;
        if (el) el.scrollTop = el.scrollHeight;
    }, [
        chat,
        aiLoading,
        rightTab
    ]);
    const askAi = (raw)=>{
        const q = (raw ?? aiQ).trim();
        if (!q || aiLoading) return;
        // Snapshot the thread BEFORE this turn is appended — the new question
        // travels as `question`, so replaying it here would duplicate it.
        const history = chat.filter((m)=>!m.error && m.text).map((m)=>({
                role: m.role === 'user' ? 'user' : 'assistant',
                content: m.text
            }));
        setChat((prev)=>[
                ...prev,
                {
                    id: ++chatSeq.current,
                    role: 'user',
                    text: q
                }
            ]);
        setAiQ('');
        setAiLoading(true);
        (0, $eVM84.bffQuery)((0, $j7Lry.ASK_PATIENT_AI), {
            question: q,
            patientId: p.id,
            conversationHistory: history
        }).then((d)=>{
            const a = d.askDoctorQuestion || {};
            setChat((prev)=>[
                    ...prev,
                    {
                        id: ++chatSeq.current,
                        role: 'assistant',
                        text: a.answer || t('errors.ai.noResponse'),
                        confidence: a.confidence,
                        suggestions: a.followUpSuggestions || []
                    }
                ]);
        })// Surface the real reason — a failed turn that just says «خطا» sends the
        // doctor looking for a fault that isn't theirs (credits, service down).
        .catch((e)=>setChat((prev)=>[
                    ...prev,
                    {
                        id: ++chatSeq.current,
                        role: 'assistant',
                        error: true,
                        text: e?.extensions?.code === 'INSUFFICIENT_CREDITS' ? t('visit.copilot.notEnoughCredit') : t('visit.copilot.askError') + (e?.message ? ` \u{2014} ${e.message}` : '')
                    }
                ])).finally(()=>setAiLoading(false));
    };
    const resetChat = ()=>{
        if (!aiLoading) {
            setChat([]);
            setAiQ('');
        }
    };
    const isLive = (0, $dL6zl.isLiveEncounter);
    const encType = (enc)=>$347125b38e367f5e$var$ENC_TYPE_KEYS(t)[enc?.type] || enc?.type || t('patient.visit');
    const encStat = (enc)=>$347125b38e367f5e$var$ENC_STATUS_KEYS(t)[(enc?.status || '').toLowerCase()] || enc?.status || '';
    const encDate = (enc)=>(0, $51HmE.isoToJalali)(enc?.scheduledDate || enc?.createdAt, formatDate);
    const parseContent = (0, $dL6zl.parseNoteContent);
    const noteStr = (0, $dL6zl.noteText);
    const soapKey = (0, $dL6zl.soapKey);
    const encTitle = (enc)=>{
        const note = (p.clinicalNotes || []).find((n)=>n.appointmentId === enc.id && noteStr(n).trim());
        if (note) {
            const value = noteStr(note).trim();
            return value.slice(0, 55) + (value.length > 55 ? "\u2026" : '');
        }
        return encType(enc);
    };
    const encCounts = (encId)=>{
        const c = (p.clinicalConditions || []).filter((x)=>x.appointmentId === encId).length;
        const m = (p.clinicalMedications || []).filter((x)=>x.appointmentId === encId).length;
        return [
            c && t('patient.visits.condsCount', {
                count: c
            }),
            m && t('patient.visits.medsCount', {
                count: m
            })
        ].filter(Boolean).join(" \xb7 ");
    };
    const soapKeyFromEncNotes = (k)=>(0, $dL6zl.readSoapSection)(encNotes, k);
    const encVitals = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $2Ieny.OV_VITAL_DEF)(t).map((v)=>{
            const obs = encObs.filter((o)=>o.code === v.code);
            const latest = obs[obs.length - 1];
            return latest ? {
                ...v,
                value: latest.value
            } : null;
        }).filter(Boolean), [
        encObs,
        t
    ]);
    // The note an amendment writes to — picked exactly the way the reader reads
    // (first SOAP row with any content; historical duplicates exist per visit).
    // Saving writes the FULL merged {s,o,a,p} into it, making it authoritative.
    const primarySoapNote = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $dL6zl.primarySoapNote)(encNotes), [
        encNotes
    ]);
    const soapUpdatedAt = primarySoapNote?.updatedAt || null;
    const myDoctorId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $a83Oj.parseJwt)((0, $a83Oj.getToken)() || '')?.sub || null, []);
    const startSoapEdit = ()=>{
        setSoapDraft({
            S: soapKeyFromEncNotes('S'),
            O: soapKeyFromEncNotes('O'),
            A: soapKeyFromEncNotes('A'),
            P: soapKeyFromEncNotes('P')
        });
        setSoapSaveError('');
        setEditingSoap(true);
    };
    const refreshRevisions = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((encId)=>{
        (0, $eVM84.bffQuery)($347125b38e367f5e$var$CLINICAL_NOTE_REVISIONS, {
            appointmentId: encId
        }).then((d)=>setRevisions(d?.clinicalNoteRevisions || [])).catch(()=>setRevisions([]));
    }, []);
    const toggleHistory = ()=>{
        const next = !historyOpen;
        setHistoryOpen(next);
        if (next && revisions === null && selEncId) refreshRevisions(selEncId);
    };
    const saveSoapEdit = async ()=>{
        if (savingSoap || !selEncId) return;
        setSavingSoap(true);
        setSoapSaveError('');
        const content = {
            s: soapDraft.S,
            o: soapDraft.O,
            a: soapDraft.A,
            p: soapDraft.P
        };
        try {
            if (primarySoapNote) {
                const d = await (0, $eVM84.bffMutation)($347125b38e367f5e$var$AMEND_CLINICAL_NOTE, {
                    id: primarySoapNote.id,
                    input: {
                        content: content
                    }
                });
                const saved = d?.amendClinicalNote;
                if (saved) setNoteOverlay((prev)=>({
                        ...prev,
                        [primarySoapNote.id]: {
                            content: saved.content,
                            updatedAt: saved.updatedAt || primarySoapNote.updatedAt
                        }
                    }));
                // An open history panel must show the newly recorded revision.
                if (revisions !== null) refreshRevisions(selEncId);
            } else {
                const d = await (0, $eVM84.bffMutation)($347125b38e367f5e$var$CREATE_SOAP_NOTE, {
                    patientId: p.id,
                    input: {
                        noteType: 'SOAP_NOTE',
                        content: content,
                        authorRole: 'doctor',
                        appointmentId: selEncId
                    }
                });
                const created = d?.createClinicalNote;
                if (created) setCreatedNotes((prev)=>[
                        ...prev,
                        {
                            ...created,
                            appointmentId: selEncId,
                            noteType: 'SOAP_NOTE'
                        }
                    ]);
            }
            setEditingSoap(false);
        } catch (e) {
            setSoapSaveError(e?.message || 'save failed');
        } finally{
            setSavingSoap(false);
        }
    };
    // ── inner views ──────────────────────────────────────────────────────────────
    const SoapView = ()=>{
        const { t: t, formatDateTime: formatDateTime } = (0, $LNQP4.default)();
        const summaryNote = encNotes.find((n)=>(n.noteType || '').toUpperCase() === 'VISIT_SUMMARY');
        const summaryText = summaryNote ? parseContent(summaryNote.content).text || noteStr(summaryNote) : '';
        const hasSoap = $347125b38e367f5e$var$SOAP_SECTIONS(t).some((s)=>soapKeyFromEncNotes(s.k).trim());
        const otherNotes = encNotes.filter((n)=>{
            const nt = (n.noteType || '').toUpperCase();
            return nt !== 'VISIT_SUMMARY' && nt !== 'SOAP_NOTE' && nt !== 'SOAP';
        });
        // Editing is a post-visit affordance only — a live visit's SOAP belongs to
        // the Visit page. Charting stays there; this is the correction rail.
        const canEdit = selEnc && !isLive(selEnc);
        if (!summaryText && !hasSoap && encNotes.length === 0 && !editingSoap) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "ps-empty",
            style: {
                padding: 40
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "ps-empty-t"
        }, t('visit.empty.noNoteForVisit')), canEdit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            type: "button",
            variant: "subtle",
            size: "sm",
            "data-testid": "soap-add-btn",
            style: {
                marginTop: 14
            },
            onClick: startSoapEdit
        }, t('patient.visits.addSoapNote')));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: 12
            }
        }, summaryText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card-head"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card-title"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "ic"
        }, "\uD83D\uDCCB"), t('credits.price.summary'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "soap-editor",
            style: {
                whiteSpace: 'pre-wrap',
                lineHeight: 1.9
            }
        }, summaryText))), (hasSoap || editingSoap) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card-head"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card-title"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "ic"
        }, "\uD83D\uDCDD"), t('patient.noteType.SOAP_NOTE')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                marginInlineStart: 'auto'
            }
        }, soapUpdatedAt && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "data-testid": "soap-edited-badge",
            style: {
                fontSize: '0.6875rem',
                padding: '2px 9px',
                borderRadius: 999,
                background: 'var(--line-2,#ece9e4)',
                color: 'var(--ink-2)'
            }
        }, t('patient.visits.soapEditedAt', {
            date: (0, $dL6zl.soapEditStamp)(soapUpdatedAt, formatDateTime)
        })), soapUpdatedAt && !editingSoap && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            "data-testid": "soap-history-btn",
            onClick: toggleHistory,
            style: {
                fontSize: '0.71875rem',
                background: 'none',
                border: 'none',
                color: 'var(--ink-2)',
                cursor: 'pointer',
                textDecoration: 'underline',
                padding: 0
            }
        }, t('patient.visits.editHistory')), canEdit && !editingSoap && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            type: "button",
            variant: "subtle",
            size: "sm",
            "data-testid": "soap-edit-btn",
            onClick: startSoapEdit
        }, t('common.actions.edit')))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card-body"
        }, editingSoap ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.71875rem',
                color: 'var(--mute)',
                marginBottom: 10
            }
        }, t('patient.visits.editSoapHint')), $347125b38e367f5e$var$SOAP_SECTIONS(t).map((s)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "soap-section",
                key: s.k
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "soap-label"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: "soap-letter"
            }, s.k), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: "soap-name"
            }, s.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("textarea", {
                className: "soap-editor",
                "data-testid": `soap-edit-${s.k}`,
                dir: "auto",
                rows: 3,
                style: {
                    width: '100%',
                    resize: 'vertical',
                    font: 'inherit',
                    lineHeight: 1.8,
                    border: '1px solid var(--line)',
                    borderRadius: 8,
                    padding: '8px 10px',
                    background: 'var(--surface)',
                    color: 'var(--ink)'
                },
                value: soapDraft[s.k],
                onChange: (e)=>{
                    const v = e.target.value;
                    setSoapDraft((prev)=>({
                            ...prev,
                            [s.k]: v
                        }));
                }
            }))), soapSaveError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.75rem',
                color: 'var(--bad,#b3261e)',
                marginTop: 6
            }
        }, t('patient.visits.soapSaveError'), " \u2014 ", soapSaveError), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                gap: 8,
                justifyContent: 'flex-end',
                marginTop: 12
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            type: "button",
            variant: "outline",
            size: "sm",
            "data-testid": "soap-cancel-btn",
            disabled: savingSoap,
            onClick: ()=>setEditingSoap(false)
        }, t('common.actions.cancel')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            type: "button",
            size: "sm",
            "data-testid": "soap-save-btn",
            disabled: savingSoap,
            onClick: saveSoapEdit
        }, savingSoap ? "\u2026" : t('common.actions.save')))) : $347125b38e367f5e$var$SOAP_SECTIONS(t).map((s)=>{
            const txt = soapKeyFromEncNotes(s.k);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "soap-section",
                key: s.k
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "soap-label"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: "soap-letter"
            }, s.k), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: "soap-name"
            }, s.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "soap-editor",
                style: {
                    whiteSpace: 'pre-wrap'
                }
            }, txt || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    color: 'var(--mute)',
                    fontStyle: 'italic',
                    fontSize: '0.75rem'
                }
            }, t('patient.obs.notRecorded'))));
        }))), historyOpen && !editingSoap && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card",
            "data-testid": "soap-history-panel"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card-head"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card-title"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "ic"
        }, "\uD83D\uDD58"), t('patient.visits.editHistory'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card-body"
        }, revisions === null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.75rem',
                color: 'var(--mute)'
            }
        }, "\u2026"), revisions !== null && revisions.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.75rem',
                color: 'var(--mute)'
            }
        }, t('patient.visits.noRevisions')), (revisions || []).map((rev)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                key: rev.id,
                style: {
                    borderBottom: '1px solid var(--line-2,#ece9e4)',
                    padding: '8px 0'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                onClick: ()=>setExpandedRevId(expandedRevId === rev.id ? null : rev.id),
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    width: '100%',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    padding: 0,
                    textAlign: 'start'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    fontSize: '0.78125rem',
                    fontWeight: 600,
                    color: 'var(--ink)'
                }
            }, (0, $dL6zl.soapEditStamp)(rev.editedAt, formatDateTime)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    fontSize: '0.71875rem',
                    color: 'var(--ink-2)'
                }
            }, rev.editedBy && rev.editedBy === myDoctorId ? t('patient.visits.editedByYou') : rev.editedBy || "\u2014"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    marginInlineStart: 'auto',
                    fontSize: '0.6875rem',
                    color: 'var(--mute)'
                }
            }, expandedRevId === rev.id ? "\u25B4" : "\u25BE")), expandedRevId === rev.id && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    marginTop: 8
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    fontSize: '0.6875rem',
                    color: 'var(--mute)',
                    marginBottom: 6
                }
            }, t('patient.visits.priorVersion')), $347125b38e367f5e$var$SOAP_SECTIONS(t).map((s)=>{
                const lk = s.k.toLowerCase();
                const c = parseContent(rev.content);
                const txt = typeof c[lk] === 'string' && c[lk].trim() ? c[lk] : typeof c[s.k] === 'string' ? c[s.k] : '';
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: "soap-section",
                    key: s.k
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: "soap-label"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    className: "soap-letter"
                }, s.k), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    className: "soap-name"
                }, s.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: "soap-editor",
                    style: {
                        whiteSpace: 'pre-wrap'
                    }
                }, txt || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: {
                        color: 'var(--mute)',
                        fontStyle: 'italic',
                        fontSize: '0.75rem'
                    }
                }, t('patient.obs.notRecorded'))));
            })))))), otherNotes.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card-body"
        }, otherNotes.map((n)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                key: n.id,
                style: {
                    marginBottom: 14
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                style: {
                    fontSize: '0.6875rem',
                    color: 'var(--mute)',
                    marginBottom: 5,
                    textTransform: 'uppercase',
                    letterSpacing: '.05em'
                }
            }, n.noteType || t('common.labels.note')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "soap-editor",
                style: {
                    whiteSpace: 'pre-wrap'
                }
            }, noteStr(n) || "\u2014"))))));
    };
    const DiffView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card-head"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card-title"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "ic"
        }, "\u2728"), t('visit.copilot.differentials'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card-body"
        }, encConds.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "ps-empty",
            style: {
                padding: 20
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "ps-empty-t"
        }, t('patient.conditions.none'))) : encConds.map((c, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "diff-row",
                key: c.id
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "diff-name"
            }, i === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    fontSize: '0.59375rem',
                    fontWeight: 700,
                    background: 'var(--accent)',
                    color: '#fff',
                    padding: '2px 7px',
                    borderRadius: 3
                }
            }, t('visit.dx.primary')), c.display, c.code && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: "diff-code"
            }, "\xb7 ", c.code)), c.clinicalStatus && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "diff-evidence"
            }, t('visit.state.statusLabel'), " ", (0, $2Ieny.OV_DX_STATUS)(t)[c.clinicalStatus]?.l || c.clinicalStatus)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $i9Cif.DiagnosisTypeBadge), {
                cond: c
            })))));
    const MedsView = ()=>{
        const { t: t } = (0, $LNQP4.default)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card-head"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card-title"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "ic"
        }, "\uD83D\uDC8A"), t('visit.rx.visitMedications'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card-body"
        }, encMeds.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "ps-empty",
            style: {
                padding: 20
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "ps-empty-t"
        }, t('visit.rx.noneRecorded'))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "rx-row header"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "rx-cell label"
        }, t('visit.rx.drugName')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "rx-cell label"
        }, t('visit.rx.dose')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "rx-cell label"
        }, t('visit.rx.frequency')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "rx-cell label"
        }, t('common.labels.status'))), encMeds.map((m)=>{
            const di = m.dosageInstruction || {};
            const dose = di.doseQuantity || di.dose || '';
            const freq = di.timing || di.text || '';
            const statCls = m.status === 'active' ? 'continue' : m.status === 'stopped' ? 'reduce' : '';
            const statL = m.status === 'active' ? t('visit.rx.continueShort') : m.status === 'stopped' ? t('visit.rx.stopShort') : m.status || '';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "rx-row",
                key: m.id
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "rx-name",
                dir: "auto"
            }, (0, $g6gAc.medNameLines)(m).primary), (0, $g6gAc.medNameLines)(m).secondary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "rx-gen",
                dir: "auto"
            }, (0, $g6gAc.medNameLines)(m).secondary)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "rx-cell"
            }, dose), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "rx-cell"
            }, freq), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, statL && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: `rx-badge${statCls ? ' ' + statCls : ''}`
            }, statL)));
        }))));
    };
    const OrdersView = ()=>{
        const { t: t } = (0, $LNQP4.default)();
        const ordGroups = [
            {
                type: 'lab',
                label: t('visit.orders.lab')
            },
            {
                type: 'imaging',
                label: t('patient.orderType.imaging')
            },
            {
                type: 'referral',
                label: t('visit.orders.specialistReferral')
            },
            {
                type: 'procedure',
                label: t('visit.orders.clinicalAction')
            },
            {
                type: 'medication',
                label: t('patient.meds.one')
            }
        ];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card-head"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card-title"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "ic"
        }, "\uD83D\uDCCB"), t('visit.orders.requests'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-card-body"
        }, encOrders.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "ps-empty",
            style: {
                padding: 20
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "ps-empty-t"
        }, t('visit.orders.noneRecordedShort'))) : ordGroups.map((g)=>{
            const items = encOrders.filter((o)=>(o.orderType || '').toLowerCase() === g.type)// An unread result is the one thing on this list that is
            // waiting on the doctor, so it goes to the top of its group.
            .sort((a, b)=>(b.reviewStatus === 'awaiting_review' ? 1 : 0) - (a.reviewStatus === 'awaiting_review' ? 1 : 0));
            if (!items.length) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                key: g.type
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "order-group-h"
            }, g.label, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    marginInlineStart: 'auto',
                    background: 'var(--line-2,#ece9e4)',
                    padding: '1px 7px',
                    borderRadius: 999,
                    fontSize: '0.625rem'
                }
            }, items.length)), items.map((o, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: "order-row",
                    key: o.id || i
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        minWidth: 0
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: "order-name"
                }, o.name || o.code || "\u2014"), o.notes && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: "order-meta"
                }, o.notes), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aQGDs.OrderDateLine), {
                    order: o,
                    compact: true,
                    testid: `patient-order-date-${o.id}`
                }), (0, $9q7ak.isResultBearingOrder)(o) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        marginTop: 4
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9q7ak.default), {
                    order: o,
                    onOpen: setReviewOrder,
                    compact: true
                }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: 3,
                        flexShrink: 0
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    className: `order-urg ${$347125b38e367f5e$var$ORDER_URG_CLS[o.urgency] || 'routine'}`
                }, o.urgency === 'stat' ? t('common.urgency.urgent') : o.urgency === 'urgent' ? t('visit.orders.priority') : t('common.urgency.routine')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aQGDs.OrderStageChip), {
                    order: o,
                    compact: true,
                    testid: `patient-order-stage-${o.id}`
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aQGDs.OrderBookingLine), {
                    order: o,
                    compact: true,
                    testid: `patient-order-booking-${o.id}`
                })))));
        })));
    };
    // ── empty state ───────────────────────────────────────────────────────────────
    // The list holds only the visits THIS doctor performed (PM-0599): an empty one
    // says so, and says nothing about anybody else's.
    if (encounters.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visits-content",
        "data-state": "empty",
        style: {
            display: 'flex',
            flex: 1,
            alignItems: 'center',
            justifyContent: 'center',
            color: 'var(--mute)',
            flexDirection: 'column',
            gap: 10
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ggYuf.default), {
        size: 44,
        strokeWidth: 1.5,
        "aria-hidden": true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.875rem'
        }
    }, t('patient.visits.noOwnVisits')));
    // ── main layout ───────────────────────────────────────────────────────────────
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "visits-content",
        "data-state": "content",
        style: {
            display: 'flex',
            flex: 1,
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: 'enc-left-panel' + (leftOpen ? ' open' : ' closed')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "enc-collapse-strip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: "enc-collapse-btn",
        onClick: ()=>setLeftOpen((o)=>!o),
        title: leftOpen ? t('common.actions.close') : t('common.actions.open')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: "10",
        height: "14",
        viewBox: "0 0 10 14",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M3 1L7 7L3 13",
        stroke: "currentColor",
        strokeWidth: "1.6",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: 'enc-strip-tab' + (rightTab === 'visits' ? ' active' : ''),
        onClick: ()=>{
            setRightTab('visits');
            setLeftOpen(true);
        },
        title: t('visit.patient.encounters')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "enc-strip-label"
    }, t('visit.patient.encounters'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: 'enc-strip-tab' + (rightTab === 'ai' ? ' active' : ''),
        onClick: ()=>{
            setRightTab('ai');
            setLeftOpen(true);
        },
        title: t('visit.copilot.assistant')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "enc-strip-label"
    }, t('visit.copilot.assistant')))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "enc-panel-inner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "enc-rtabs"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: 'enc-rtab' + (rightTab === 'visits' ? ' active' : ''),
        onClick: ()=>setRightTab('visits')
    }, t('visit.patient.encounters'), encounters.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.625rem',
            background: 'var(--line-2,#ece9e4)',
            color: 'var(--ink-2)',
            padding: '1px 6px',
            borderRadius: 999,
            marginInlineStart: 5
        }
    }, encounters.length)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: 'enc-rtab' + (rightTab === 'ai' ? ' active' : ''),
        onClick: ()=>setRightTab('ai')
    }, t('visit.copilot.assistant'))), rightTab === 'visits' ? /* Encounter list */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "enc-list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.6875rem',
            color: 'var(--mute)',
            padding: '6px 14px 4px',
            borderBottom: '1px solid var(--line-2,#ece9e4)'
        }
    }, t('visit.patient.newestFirst')), encounters.map((enc)=>{
        const live = isLive(enc);
        const sel = enc.id === selEncId;
        const cts = encCounts(enc.id);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: enc.id,
            className: 'enc-list-item' + (sel ? ' selected' : ''),
            onClick: ()=>{
                setSelEncId(enc.id);
                setInnerTab('soap');
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-li-row"
        }, live && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "enc-live-dot"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "enc-li-date"
        }, encDate(enc)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "enc-li-type"
        }, encType(enc)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: 'enc-li-status' + (live ? ' live' : ' done')
        }, encStat(enc) || t('visit.state.recordedShort'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-li-title"
        }, encTitle(enc)), cts && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "enc-li-counts"
        }, cts), erxCodes.get(String(enc.id))?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                marginTop: 5
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $jDxJA.ErxCodeChips), {
            codes: erxCodes.get(String(enc.id)),
            testid: `visits-erx-${enc.id}`
        })));
    })) : /* AI assistant — a conversation over this patient's history */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ai-panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ai-chat-head"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ai-chat-avatar"
    }, "\u2726"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ai-panel-title"
    }, t('visit.copilot.historyAssistant')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ai-panel-sub"
    }, chat.length > 0 ? t('visit.copilot.threadOpen') : t('visit.copilot.askAcrossVisits', {
        count: encounters.length
    }))), chat.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: "ai-newchat",
        onClick: resetChat,
        disabled: aiLoading,
        title: t('visit.copilot.clearThread')
    }, t('visit.copilot.newThread'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ai-panel-body ai-chat",
        role: "log",
        "aria-live": "polite",
        ref: chatBodyRef
    }, chat.length === 0 && !aiLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ai-chat-intro"
    }, t('visit.copilot.chatIntro')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ai-follow-up-label"
    }, t('visit.copilot.quickQuestions')), $347125b38e367f5e$var$AI_QUICK_Q(t).map((q, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: i,
            className: "ai-quick-q",
            onClick: ()=>askAi(q)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "ai-quick-q-arrow"
        }, "\u2190"), q))), chat.map((m)=>m.role === 'user' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: m.id,
            className: "ai-msg user"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "ai-bubble user"
        }, m.text)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: m.id,
            className: "ai-msg bot"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: 'ai-bubble bot' + (m.error ? ' error' : '')
        }, !m.error && $347125b38e367f5e$var$AI_CONFIDENCE(t)[String(m.confidence).toLowerCase()] && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "ai-answer-meta"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, "\u2726"), t('visit.copilot.confidence'), " ", $347125b38e367f5e$var$AI_CONFIDENCE(t)[String(m.confidence).toLowerCase()]), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "ai-bubble-text"
        }, m.text)), m.suggestions?.length > 0 && !aiLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "ai-follow-ups"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "ai-follow-up-label"
        }, t('visit.copilot.continue')), m.suggestions.map((q, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                key: i,
                className: "ai-quick-q",
                onClick: ()=>askAi(q)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: "ai-quick-q-arrow"
            }, "\u2190"), q))))), aiLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ai-msg bot"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ai-bubble bot ai-typing",
        "aria-label": t('visit.copilot.typing')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ai-composer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ai-composer-row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        placeholder: chat.length ? t('visit.copilot.nextQuestion') : t('visit.copilot.askHistory'),
        value: aiQ,
        onChange: (e)=>setAiQ(e.target.value),
        onKeyDown: (e)=>{
            if (e.key === 'Enter') askAi();
        },
        disabled: aiLoading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: "ai-send",
        onClick: ()=>askAi(),
        disabled: aiLoading || !aiQ.trim(),
        title: t('visit.copilot.send')
    }, "\u21A9")))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            minWidth: 0,
            background: 'var(--bg)'
        }
    }, selEnc && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '14px 22px',
            background: 'var(--surface)',
            borderBottom: '1px solid var(--line)',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: 10,
            marginBottom: encVitals.length ? 10 : 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontWeight: 700,
            fontSize: '1.0625rem',
            color: 'var(--ink)'
        }
    }, encDate(selEnc)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.71875rem',
            padding: '2px 9px',
            borderRadius: 999,
            background: 'var(--line-2,#ece9e4)',
            color: 'var(--ink-2)'
        }
    }, encType(selEnc)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.6875rem',
            padding: '2px 8px',
            borderRadius: 999,
            fontWeight: 600,
            display: 'flex',
            alignItems: 'center',
            gap: 5,
            background: isLive(selEnc) ? 'var(--good-soft)' : 'var(--line-2,#ece9e4)',
            color: isLive(selEnc) ? 'oklch(0.38 0.08 155)' : 'var(--ink-2)'
        }
    }, isLive(selEnc) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: 6,
            height: 6,
            borderRadius: '50%',
            background: 'oklch(0.55 0.09 155)',
            display: 'inline-block'
        }
    }), encStat(selEnc) || t('visit.state.recordedShort')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $jDxJA.ErxCodeChips), {
        codes: erxCodes.get(String(selEnc.id)),
        testid: "history-erx-codes"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $93kEN.default), {
        key: selEnc.id,
        style: {
            marginInlineStart: 'auto'
        },
        visit: selEnc,
        patientId: p.id,
        insurance: p.insurance,
        mine: !!myDoctorId && selEnc.doctorId === myDoctorId,
        hasLines: encMeds.length + encOrders.length > 0,
        onChanged: ()=>{
            onRefresh?.();
            loadEncOrders();
            reloadErxCodes();
        },
        testid: "history-erx"
    })), encVitals.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: 6
        }
    }, encVitals.map((v)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            key: v.code,
            style: {
                fontSize: '0.75rem',
                padding: '3px 9px',
                borderRadius: 999,
                background: 'var(--bg)',
                border: '1px solid var(--line)',
                color: 'var(--ink-2)',
                fontFamily: 'ui-monospace,monospace'
            }
        }, v.label, ": ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("strong", {
            dir: "ltr"
        }, v.value), " ", v.unit)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "soap-tabs",
        style: {
            flexShrink: 0
        }
    }, [
        {
            id: 'soap',
            label: t('patient.noteType.SOAP_NOTE')
        },
        {
            id: 'diff',
            label: t('credits.price.differential'),
            count: encConds.length
        },
        {
            id: 'meds',
            label: t('patient.meds.one'),
            count: encMeds.length
        },
        {
            id: 'ord',
            label: t('visit.tabs.orders'),
            count: encOrders.length
        }
    ].map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: item.id,
            className: 'soap-tab' + (innerTab === item.id ? ' active' : ''),
            onClick: ()=>setInnerTab(item.id)
        }, item.label, item.count > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "badge"
        }, item.count)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            overflowY: 'auto',
            padding: '20px 22px 60px'
        }
    }, innerTab === 'soap' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(SoapView, null), innerTab === 'diff' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(DiffView, null), innerTab === 'meds' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(MedsView, null), innerTab === 'ord' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(OrdersView, null))), reviewOrder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7iw9n.default), {
        order: reviewOrder,
        onClose: ()=>setReviewOrder(null),
        onReviewed: async (updated)=>{
            // Reflect the verdict immediately, then refetch so the row and the
            // drawer agree with the server rather than with an optimistic guess.
            if (updated) setEncOrders((prev)=>prev.map((o)=>o.id === updated.id ? {
                        ...o,
                        ...updated
                    } : o));
            await loadEncOrders();
        }
    }));
};
var $347125b38e367f5e$export$2e2bcd8739ae039 = $347125b38e367f5e$var$VisitsTab;

});
parcelRegister("9q7ak", function(module, exports) {

$parcel$export(module.exports, "normalizeReviewStatus", () => $adc2a88d4c0b6ec2$export$f60e5202fed3ee65);
$parcel$export(module.exports, "isResultBearingOrder", () => $adc2a88d4c0b6ec2$export$baa601d96b21e0d1);
$parcel$export(module.exports, "default", () => $adc2a88d4c0b6ec2$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");
/**
 * The result state of one order, as a compact chip group.
 *
 * Presentational only: it takes an order and renders how many documents have
 * arrived and whether they have been read. It never derives that state —
 * `reviewStatus` is computed by clinicalencounter and re-deriving it here would be a
 * second copy of the rule, free to disagree with the first.
 *
 * Colours come from the same CSS variables the Visit page's order status pill
 * uses, so the two read as one system rather than as two independent badges that
 * happen to sit near each other.
 */ const $adc2a88d4c0b6ec2$var$TONE = {
    none: {
        bg: 'var(--panel-2)',
        fg: 'var(--mute)'
    },
    awaiting_review: {
        bg: 'var(--warn-soft)',
        fg: 'var(--warn-ink)'
    },
    accepted: {
        bg: 'var(--good-soft)',
        fg: 'var(--good-ink)'
    },
    // Attention, not error: nothing failed — the patient is being asked for one
    // more action. Red here would say something broke.
    needs_resubmission: {
        bg: 'var(--warn-soft)',
        fg: 'var(--warn-ink)'
    }
};
const $adc2a88d4c0b6ec2$var$LABEL_KEY = {
    none: 'visit.orders.result.none',
    awaiting_review: 'visit.orders.result.awaiting',
    accepted: 'visit.orders.result.accepted',
    needs_resubmission: 'visit.orders.result.needsResubmission'
};
function $adc2a88d4c0b6ec2$export$f60e5202fed3ee65(status) {
    const key = String(status || 'none').toLowerCase().replace(/-/g, '_');
    return $adc2a88d4c0b6ec2$var$LABEL_KEY[key] ? key : 'none';
}
function $adc2a88d4c0b6ec2$export$baa601d96b21e0d1(order) {
    const type = String(order?.orderType || '').toLowerCase();
    return type.includes('lab') || type.includes('imag') || type.includes('radiolog');
}
function $adc2a88d4c0b6ec2$export$2e2bcd8739ae039({ order: order, onOpen: onOpen, compact: compact = false }) {
    const { t: t } = (0, $LNQP4.default)();
    if (!order || !$adc2a88d4c0b6ec2$export$baa601d96b21e0d1(order)) return null;
    const status = $adc2a88d4c0b6ec2$export$f60e5202fed3ee65(order.reviewStatus);
    const files = order.resultFiles || [];
    const tone = $adc2a88d4c0b6ec2$var$TONE[status];
    // An order with no result and nothing to read offers nothing to open — the row
    // stays quiet rather than growing a button that leads to an empty drawer.
    const actionable = files.length > 0 || status !== 'none';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `order-result-chips-${order.id}`,
        "data-review-status": status,
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6,
            flexWrap: 'wrap'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.625rem',
            color: 'var(--mute)',
            fontWeight: 600
        }
    }, t('visit.orders.result.title')), files.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.625rem',
            fontWeight: 700,
            padding: '1px 7px',
            borderRadius: 999,
            background: 'var(--panel-2)',
            color: 'var(--ink)',
            whiteSpace: 'nowrap'
        }
    }, files.length, " ", t('visit.orders.result.fileCount')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "order-result-status",
        style: {
            fontSize: '0.625rem',
            fontWeight: 700,
            padding: '1px 7px',
            borderRadius: 999,
            background: tone.bg,
            color: tone.fg,
            whiteSpace: 'nowrap'
        }
    }, t($adc2a88d4c0b6ec2$var$LABEL_KEY[status])), actionable && onOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: ()=>onOpen(order),
        "data-testid": "order-result-open",
        style: {
            fontSize: '0.625rem',
            fontWeight: 700,
            padding: compact ? '1px 7px' : '2px 9px',
            borderRadius: 6,
            cursor: 'pointer',
            border: '1px solid var(--line)',
            background: 'var(--panel)',
            color: status === 'awaiting_review' ? 'var(--accent-ink)' : 'var(--mute)'
        }
    }, status === 'awaiting_review' ? t('visit.orders.result.reviewCta') : t('visit.orders.result.viewCta')));
}

});

parcelRegister("7iw9n", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0e90198918904d7$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $eVM84 = parcelRequire("eVM84");

var $j7Lry = parcelRequire("j7Lry");

var $gdEay = parcelRequire("gdEay");

var $9q7ak = parcelRequire("9q7ak");
function $b0e90198918904d7$export$2e2bcd8739ae039({ order: order, onClose: onClose, onReviewed: onReviewed }) {
    const { t: t } = (0, $LNQP4.default)();
    const [verdict, setVerdict] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [note, setNote] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [saving, setSaving] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [stale, setStale] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [preview, setPreview] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // { fileId, url, type, name }
    const [loadingFile, setLoadingFile] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const files = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>order?.resultFiles || [], [
        order
    ]);
    const status = (0, $9q7ak.normalizeReviewStatus)(order?.reviewStatus);
    // Start from the verdict already recorded, so reopening a reviewed order shows
    // what was decided rather than an empty form.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setVerdict(order?.reviewVerdict || null);
        setNote(order?.reviewNote || '');
        setError('');
        setStale(false);
    }, [
        order?.id,
        order?.reviewVerdict,
        order?.reviewNote
    ]);
    // Open the first document automatically: the drawer exists to be read, and a
    // doctor who has to click once more before seeing anything is being charged
    // for the drawer's own structure.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (files.length && !preview) openFile(files[0]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        order?.id,
        files.length
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>()=>{
            if (preview?.url?.startsWith('blob:')) URL.revokeObjectURL(preview.url);
        }, [
        preview
    ]);
    async function openFile(file) {
        if (!file?.id) return;
        setLoadingFile(file.id);
        try {
            const d = await (0, $eVM84.bffQuery)((0, $j7Lry.GET_FILE_URL), {
                fileId: file.id
            });
            const dataUri = d?.clinicalFileUrl;
            if (!dataUri) throw new Error('no url');
            setPreview({
                fileId: file.id,
                url: dataUri,
                type: String(file.fileType || ''),
                name: file.fileName || '',
                reportText: file.reportText || ''
            });
            setError('');
        } catch (e) {
            console.error('openFile failed:', e);
            setError(t('visit.orders.result.openFailed'));
        } finally{
            setLoadingFile(null);
        }
    }
    const noteRequired = verdict === 'needs_resubmission' && !note.trim();
    const canSave = Boolean(verdict) && !noteRequired && !saving && files.length > 0;
    async function save() {
        if (!canSave) return;
        setSaving(true);
        setError('');
        setStale(false);
        try {
            const d = await (0, $eVM84.bffMutation)((0, $j7Lry.REVIEW_ORDER_RESULT), {
                orderId: order.id,
                verdict: verdict === 'accepted' ? 'ACCEPTED' : 'NEEDS_RESUBMISSION',
                note: note.trim() || null,
                // The marker this drawer was showing. Empty is allowed and simply means
                // «no guard» — but it is always sent when known.
                seenResultAt: order.lastResultAt || null
            });
            onReviewed?.(d?.reviewOrderResult || null);
            onClose?.();
        } catch (e) {
            // A newer document arrived while the drawer was open. Not the doctor's
            // mistake, and not something a retry of the same submission should fix —
            // they have to see the new file first.
            if (e?.code === 'STALE_RESULT' || /STALE_RESULT/.test(String(e?.message))) setStale(true);
            else setError(e?.message || t('visit.orders.result.saveFailed'));
        } finally{
            setSaving(false);
        }
    }
    // Ctrl+S saves, Esc closes — the two shortcuts every editing surface in this
    // app already carries.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const onKey = (e)=>{
            if (e.key === 'Escape' && !saving) {
                onClose?.();
                return;
            }
            if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 's') {
                e.preventDefault();
                save();
            }
        };
        window.addEventListener('keydown', onKey);
        return ()=>window.removeEventListener('keydown', onKey);
    });
    if (!order) return null;
    const isImage = preview?.type?.startsWith('image/');
    const isPdf = preview?.type === 'application/pdf';
    const ocrRows = preview?.reportText ? (0, $gdEay.parseOcrRows)(preview.reportText) : [];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "result-review-drawer",
        "data-review-status": status,
        style: {
            position: 'fixed',
            insetBlock: 0,
            insetInlineEnd: 0,
            width: 'min(560px, 100vw)',
            background: 'var(--panel)',
            borderInlineStart: '1px solid var(--line)',
            boxShadow: '-8px 0 28px rgba(0, 0, 0, 0.10)',
            zIndex: 70,
            display: 'flex',
            flexDirection: 'column'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '14px 16px',
            borderBottom: '1px solid var(--line)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("strong", {
        style: {
            fontSize: '0.875rem',
            color: 'var(--ink)'
        }
    }, t('visit.orders.result.drawerTitle')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onClose,
        disabled: saving,
        "data-testid": "result-review-close",
        style: {
            border: 'none',
            background: 'none',
            cursor: 'pointer',
            color: 'var(--mute)',
            fontSize: '1.125rem',
            lineHeight: 1,
            padding: 4
        },
        "aria-label": t('common.actions.close')
    }, "\xd7")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: "auto",
        style: {
            marginTop: 4,
            fontSize: '0.78125rem',
            fontWeight: 700,
            color: 'var(--ink)'
        }
    }, order.name || order.description || "\u2014"), order.code && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: 2,
            fontSize: '0.625rem',
            color: 'var(--mute)',
            fontFamily: 'monospace'
        }
    }, order.orderType === 'procedure' ? 'CPT' : 'LOINC', " ", order.code)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            overflowY: 'auto',
            padding: '14px 16px',
            display: 'flex',
            flexDirection: 'column',
            gap: 14
        }
    }, stale && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "result-review-stale",
        style: {
            padding: '8px 10px',
            borderRadius: 8,
            fontSize: '0.71875rem',
            lineHeight: 1.8,
            background: 'var(--warn-soft)',
            color: 'var(--warn-ink)',
            border: '1px solid var(--warn-ink)'
        }
    }, t('visit.orders.result.staleWarning')), files.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        style: {
            margin: 0,
            fontSize: '0.75rem',
            color: 'var(--mute)',
            lineHeight: 1.9
        }
    }, t('visit.orders.result.noFiles')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h4", {
        style: {
            margin: '0 0 8px',
            fontSize: '0.71875rem',
            color: 'var(--mute)',
            fontWeight: 700
        }
    }, t('visit.orders.result.filesTitle'), " (", files.length, ")"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: 6,
            marginBottom: 10
        }
    }, files.map((f)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: f.id,
            type: "button",
            onClick: ()=>openFile(f),
            "data-testid": "result-review-file",
            "data-active": preview?.fileId === f.id || undefined,
            style: {
                display: 'inline-flex',
                alignItems: 'center',
                gap: 5,
                maxWidth: 200,
                padding: '3px 8px',
                borderRadius: 6,
                cursor: 'pointer',
                fontSize: '0.6875rem',
                background: preview?.fileId === f.id ? 'var(--accent-soft)' : 'var(--panel-2)',
                border: `1px solid ${preview?.fileId === f.id ? 'var(--accent)' : 'var(--line)'}`,
                color: 'var(--ink)'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "auto",
            style: {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            }
        }, loadingFile === f.id ? "\u2026" : f.fileName || "\u2014"), f.uploadedBy === 'patient' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.5625rem',
                color: 'var(--accent-ink)',
                fontWeight: 700,
                whiteSpace: 'nowrap'
            }
        }, t('visit.orders.result.uploadedByPatient'))))), preview && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            border: '1px solid var(--line)',
            borderRadius: 8,
            overflow: 'hidden',
            background: 'var(--panel-2)',
            minHeight: 220,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }
    }, isImage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: preview.url,
        alt: preview.name,
        "data-testid": "result-review-image",
        style: {
            maxWidth: '100%',
            maxHeight: 420,
            display: 'block'
        }
    }), isPdf && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("iframe", {
        title: preview.name,
        src: preview.url,
        "data-testid": "result-review-pdf",
        style: {
            width: '100%',
            height: 420,
            border: 'none'
        }
    }), !isImage && !isPdf && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
        href: preview.url,
        target: "_blank",
        rel: "noopener noreferrer",
        style: {
            padding: 20,
            fontSize: '0.75rem'
        }
    }, preview.name)), (0, $gdEay.hasStructuredRows)(preview?.reportText || '') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: 10,
            fontSize: '0.6875rem',
            color: 'var(--ink)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: 'var(--mute)',
            marginBottom: 4
        }
    }, "OCR \u2014 ", (0, $gdEay.abnormalRowCount)(ocrRows), " / ", ocrRows.length))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h4", {
        style: {
            margin: '0 0 8px',
            fontSize: '0.71875rem',
            color: 'var(--mute)',
            fontWeight: 700
        }
    }, t('visit.orders.result.verdictTitle')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 8,
            marginBottom: 10
        }
    }, [
        {
            key: 'accepted',
            label: t('visit.orders.result.accepted')
        },
        {
            key: 'needs_resubmission',
            label: t('visit.orders.result.needsResubmission')
        }
    ].map((opt)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: opt.key,
            type: "button",
            onClick: ()=>setVerdict(opt.key),
            disabled: files.length === 0,
            "data-testid": `result-verdict-${opt.key}`,
            "data-selected": verdict === opt.key || undefined,
            style: {
                flex: 1,
                padding: '7px 10px',
                borderRadius: 8,
                cursor: 'pointer',
                fontSize: '0.75rem',
                fontWeight: 700,
                background: verdict === opt.key ? 'var(--accent-soft)' : 'var(--panel-2)',
                border: `1px solid ${verdict === opt.key ? 'var(--accent)' : 'var(--line)'}`,
                color: verdict === opt.key ? 'var(--accent-ink)' : 'var(--mute)'
            }
        }, opt.label))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        style: {
            display: 'block',
            fontSize: '0.6875rem',
            color: 'var(--mute)',
            marginBottom: 4
        }
    }, t('visit.orders.result.noteLabel')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("textarea", {
        value: note,
        onChange: (e)=>setNote(e.target.value),
        dir: "auto",
        rows: 4,
        "data-testid": "result-review-note",
        placeholder: t('visit.orders.result.noteHint'),
        style: {
            width: '100%',
            padding: '8px 10px',
            borderRadius: 8,
            resize: 'vertical',
            border: `1px solid ${noteRequired ? 'var(--danger-ink)' : 'var(--line)'}`,
            background: 'var(--panel)',
            color: 'var(--ink)',
            fontSize: '0.75rem',
            lineHeight: 1.9,
            fontFamily: 'inherit'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: 4,
            fontSize: '0.65625rem',
            color: noteRequired ? 'var(--danger-ink)' : 'var(--mute)',
            lineHeight: 1.8
        }
    }, noteRequired ? t('visit.orders.result.noteRequired') : t('visit.orders.result.noteHint')), order.reviewedAt && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: 8,
            fontSize: '0.65625rem',
            color: 'var(--mute)'
        }
    }, t('visit.orders.result.lastReviewed'), ": ", String(order.reviewedAt).slice(0, 10))), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "result-review-error",
        style: {
            padding: '8px 10px',
            borderRadius: 8,
            fontSize: '0.71875rem',
            background: 'var(--danger-soft)',
            color: 'var(--danger-ink)'
        }
    }, error)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '12px 16px',
            borderTop: '1px solid var(--line)',
            display: 'flex',
            gap: 8,
            justifyContent: 'flex-end'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onClose,
        disabled: saving,
        style: {
            padding: '7px 14px',
            borderRadius: 8,
            cursor: 'pointer',
            fontSize: '0.75rem',
            border: '1px solid var(--line)',
            background: 'var(--panel)',
            color: 'var(--mute)'
        }
    }, t('common.actions.cancel')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: save,
        disabled: !canSave,
        "data-testid": "result-review-save",
        style: {
            padding: '7px 14px',
            borderRadius: 8,
            fontSize: '0.75rem',
            fontWeight: 700,
            cursor: canSave ? 'pointer' : 'not-allowed',
            border: '1px solid var(--accent)',
            background: canSave ? 'var(--accent)' : 'var(--panel-2)',
            color: canSave ? '#fff' : 'var(--mute)'
        }
    }, saving ? t('visit.orders.result.saving') : t('visit.orders.result.save'))));
}

});


parcelRegister("cwxsI", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab3a679d970a4d5f$export$2e2bcd8739ae039);
parcelRequire("dSPMK");
var $LNQP4 = parcelRequire("LNQP4");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $aJ1FU = parcelRequire("aJ1FU");
var $7gSBD = parcelRequire("7gSBD");
var $h4ZeB = parcelRequire("h4ZeB");
var $fYgeo = parcelRequire("fYgeo");
var $3uzzV = parcelRequire("3uzzV");

var $jTCZr = parcelRequire("jTCZr");

var $2WFPf = parcelRequire("2WFPf");
var $5l8OP = parcelRequire("5l8OP");
var $3FyOw = parcelRequire("3FyOw");
var $4CVxl = parcelRequire("4CVxl");
var $8jE1c = parcelRequire("8jE1c");
var $ljvFv = parcelRequire("ljvFv");
var $ksL7p = parcelRequire("ksL7p");
var $9he56 = parcelRequire("9he56");
var $he6AI = parcelRequire("he6AI");

var $eVM84 = parcelRequire("eVM84");

var $2Ieny = parcelRequire("2Ieny");

var $7sS0P = parcelRequire("7sS0P");

var $gq4TR = parcelRequire("gq4TR");

var $j7Lry = parcelRequire("j7Lry");

var $4z4tf = parcelRequire("4z4tf");

var $hRWhk = parcelRequire("hRWhk");

var $0xK7i = parcelRequire("0xK7i");

var $jGozX = parcelRequire("jGozX");

var $zi6VT = parcelRequire("zi6VT");

var $41vLC = parcelRequire("41vLC");
// The tiles and the viewer sit side by side only when both fit: 24rem of tiles, a
// 1rem gap, a 28rem viewer and the 2rem of padding (PM-0561). Narrower — a tablet, a
// half-screen window — the tiles take the width and a tile opens the gallery dialog,
// rather than changing a viewer that has wrapped below the fold.
const $ab3a679d970a4d5f$var$SIDE_BY_SIDE_REM = 55;
const $ab3a679d970a4d5f$var$rootRemPx = ()=>{
    try {
        return parseFloat(window.getComputedStyle(document.documentElement).fontSize) || 16;
    } catch  {
        return 16;
    }
};
// «فایل‌ها» — the patient's documents on the workstation.
// docs/DOCTOR_PATIENT_FILES_AND_AI_EXTRACTION_DESIGN.md §7.2, §8.
//
// One list. A document is a clinical record + its bytes in storage (merged into one
// entry by `mergeClinicalAndStorageFiles`), and a DICOM study is a clinical record too
// (`mediaClass = 'dicom'`) — including studies that arrived before study rows existed,
// which the BFF mirrors into rows when the list is read
// (DICOM_COMPRESSION_LIMITS_AND_DOCUMENT_OCR_DESIGN.md §24.8). Every action — view,
// extract, edit, download, delete, upload of documents and studies alike — goes
// through `useClinicalFiles`, the host the Visit page and the phone use, so a file
// behaves the same wherever the doctor meets it.
const $ab3a679d970a4d5f$var$CAT_ICON = {
    all: (0, $5l8OP.default),
    lab_report: (0, $4CVxl.default),
    imaging: (0, $9he56.default),
    ecg: (0, $ljvFv.default),
    pathology: (0, $ksL7p.default),
    general: (0, $3FyOw.default)
};
// A storage-only row has no clinical record: nothing to edit or extract, and the
// doctor's own legacy upload stays deletable exactly as it always was.
const $ab3a679d970a4d5f$var$asRow = (f)=>f._source === 'storage' ? {
        ...f,
        canEdit: false,
        editScope: null,
        extractable: false,
        canDelete: true
    } : f;
const $ab3a679d970a4d5f$var$FilesTab = ({ p: p, onRefresh: onRefresh })=>{
    const { t: t, formatDigits: formatDigits } = (0, $LNQP4.default)();
    const [storageFiles, setStorageFiles] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [loadError, setLoadError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [filterCat, setFilterCat] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('all');
    const [collapsedCats, setCollapsedCats] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>new Set());
    // «گالری» or «فهرست», remembered per browser (lib/filesView — shared with the phone).
    const [view, changeView] = (0, $41vLC.useFilesView)();
    const [galleryRef, galleryWidth] = (0, $3uzzV.default)(1200);
    const sideBySide = galleryWidth >= $ab3a679d970a4d5f$var$SIDE_BY_SIDE_REM * $ab3a679d970a4d5f$var$rootRemPx();
    const [selected, setSelected] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const lastIndex = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(0);
    // A failed load is reported, never swallowed: this list is part of a medical
    // record, so "no files" must mean no files, not "the query errored".
    const loadStorage = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        setLoadError(null);
        (0, $eVM84.bffQuery)((0, $j7Lry.STORAGE_LAB_FILES), {
            patientId: p.id
        }).then((d)=>setStorageFiles(d.storageLabFiles || [])).catch((err)=>setLoadError(err));
    }, [
        p.id
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        loadStorage();
    }, [
        loadStorage
    ]);
    const allFiles = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $gq4TR.mergeClinicalAndStorageFiles)(p.clinicalFiles, storageFiles).map($ab3a679d970a4d5f$var$asRow), [
        p.clinicalFiles,
        storageFiles
    ]);
    // The clinic chip only for a doctor who works at more than one clinic: on a
    // single-clinic doctor's screen it would say the same thing on every row.
    const { clinics: clinics } = (0, $4z4tf.useMyClinics)();
    const clinicNameById = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const m = new Map();
        (clinics || []).forEach((c)=>{
            const id = c?.clinic?.id || c?.id;
            if (id) m.set(String(id), c?.clinic?.name || null);
        });
        return m;
    }, [
        clinics
    ]);
    const clinicNameOf = clinicNameById.size > 1 ? (id)=>clinicNameById.get(String(id)) || null : null;
    const refreshAll = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        loadStorage();
        onRefresh?.();
    }, [
        loadStorage,
        onRefresh
    ]);
    const files = (0, $0xK7i.useClinicalFiles)({
        patient: p,
        files: allFiles,
        clinicNameOf: clinicNameOf,
        onChanged: refreshAll
    });
    const catCounts = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $gq4TR.FILE_CATEGORIES).reduce((acc, c)=>{
            acc[c.id] = c.id === 'all' ? allFiles.length : allFiles.filter((f)=>(0, $gq4TR.resolveFileCat)(f) === c.id).length;
            return acc;
        }, {}), [
        allFiles
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (filterCat !== 'all' && !catCounts[filterCat]) setFilterCat('all');
    }, [
        catCounts,
        filterCat
    ]);
    const visibleFiles = filterCat === 'all' ? allFiles : allFiles.filter((f)=>(0, $gq4TR.resolveFileCat)(f) === filterCat);
    // The gallery's selection survives a filter change while the file is still shown,
    // and falls to the nearest one when it is not (deleted, filtered out).
    const current = (0, $zi6VT.resolveCurrent)(visibleFiles, selected, lastIndex);
    const selectFile = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((f)=>setSelected(f), []);
    const onGalleryKeys = (0, $zi6VT.useGalleryKeys)({
        files: visibleFiles,
        current: current,
        onSelect: selectFile
    });
    // The selected tile stays in sight in the grid, and focus follows it from a tile.
    const gridRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const tileRefs = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Map());
    const currentKey = current ? (0, $zi6VT.fileKey)(current) : null;
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        (0, $zi6VT.revealTile)(gridRef.current, currentKey && tileRefs.current.get(currentKey), 'y');
    }, [
        currentKey,
        view
    ]);
    const groups = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (filterCat !== 'all') return [
            {
                id: filterCat,
                files: visibleFiles
            }
        ];
        const byCat = new Map();
        visibleFiles.forEach((f)=>{
            const id = (0, $gq4TR.resolveFileCat)(f);
            if (!byCat.has(id)) byCat.set(id, []);
            byCat.get(id).push(f);
        });
        return (0, $gq4TR.FILE_CATEGORIES).filter((c)=>c.id !== 'all' && byCat.has(c.id)).map((c)=>({
                id: c.id,
                files: byCat.get(c.id)
            }));
    }, [
        visibleFiles,
        filterCat
    ]);
    const toggleCat = (id)=>setCollapsedCats((prev)=>{
            const next = new Set(prev);
            if (next.has(id)) next.delete(id);
            else next.add(id);
            return next;
        });
    const catLabel = (id)=>{
        const cat = (0, $gq4TR.FILE_CATEGORIES).find((c)=>c.id === id);
        return cat ? t(cat.labelKey) : id;
    };
    const card = {
        background: (0, $2Ieny.CL).surface,
        borderRadius: (0, $7sS0P.RADIUS).card,
        border: `1px solid ${(0, $2Ieny.CL).border}`,
        overflow: 'hidden'
    };
    const cardHeader = {
        padding: '0.75rem 1rem',
        borderBottom: `1px solid ${(0, $2Ieny.CL).border}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '0.75rem',
        flexWrap: 'wrap'
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "files-tab",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem'
        }
    }, allFiles.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "files-categories",
        style: {
            display: 'flex',
            gap: '0.375rem',
            flexWrap: 'wrap'
        }
    }, (0, $gq4TR.FILE_CATEGORIES).filter((c)=>c.id === 'all' || catCounts[c.id] > 0).map((c)=>{
        const Icon = $ab3a679d970a4d5f$var$CAT_ICON[c.id] || (0, $3FyOw.default);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $h4ZeB.default), {
            key: c.id,
            active: filterCat === c.id,
            // A new category starts at its first document unless the one on
            // screen belongs to it too (resolveCurrent keeps it then).
            onClick: ()=>{
                lastIndex.current = 0;
                setFilterCat(c.id);
            },
            count: catCounts[c.id] ? formatDigits(catCounts[c.id]) : undefined,
            "data-testid": `files-category-${c.id}`,
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '0.25rem'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
                size: 13,
                "aria-hidden": true
            }), t(c.labelKey))
        });
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: card
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: cardHeader
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.8125rem',
            fontWeight: 600,
            color: (0, $2Ieny.CL).text1
        }
    }, filterCat === 'all' ? t('patient.files.all') : catLabel(filterCat), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.6875rem',
            color: (0, $2Ieny.CL).text3,
            fontWeight: 400,
            marginInlineStart: '0.5rem'
        }
    }, formatDigits(visibleFiles.length), " ", t('patient.files.file'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.5rem',
            flexWrap: 'wrap'
        }
    }, allFiles.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fYgeo.default), {
        size: "sm",
        semantics: "filter",
        ariaLabel: t('patient.files.gallery.viewLabel'),
        value: view,
        onChange: changeView,
        options: [
            {
                value: 'grid',
                label: t('patient.files.gallery.viewGrid')
            },
            {
                value: 'list',
                label: t('patient.files.gallery.viewList')
            }
        ],
        "data-testid": "files-view"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
        size: "sm",
        className: "gap-1.5",
        onClick: ()=>files.openUpload(),
        "data-testid": "files-upload"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $he6AI.default), {
        size: 14,
        "aria-hidden": true
    }), " ", t('visit.patient.addFile')))), loadError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '0.75rem 1rem 0'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dOauK.default), {
        variant: "error",
        "data-testid": "files-partial-load",
        action: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "outline",
            size: "sm",
            onClick: loadStorage
        }, t('common.actions.retry'))
    }, t('patient.files.partialLoadFailed'))), allFiles.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '1.5rem 1rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        "data-testid": "files-empty",
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8jE1c.default), {
            size: 44,
            strokeWidth: 1.5,
            color: (0, $jTCZr.CT).mute,
            "aria-hidden": true
        }),
        title: loadError ? t('patient.files.partialLoad') : t('patient.files.empty'),
        description: loadError ? undefined : t('patient.files.emptyHint'),
        action: loadError ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "outline",
            size: "sm",
            className: "gap-1.5",
            onClick: ()=>files.openUpload()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $he6AI.default), {
            size: 14,
            "aria-hidden": true
        }), " ", t('visit.patient.addFile'))
    })) : view === 'grid' ? visibleFiles.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "p-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        "data-testid": "files-category-empty",
        title: t('patient.files.noneInCategory')
    })) : // Tiles and the viewer side by side; the arrow keys work from any tile or
    // the viewer. Too narrow for both, a tile opens the gallery dialog instead.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: galleryRef,
        "data-testid": "files-gallery",
        "data-layout": sideBySide ? 'side-by-side' : 'tiles',
        onKeyDown: sideBySide ? onGalleryKeys : undefined,
        className: "flex items-start gap-4 px-4 pb-4 pt-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: gridRef,
        role: "group",
        "aria-label": filterCat === 'all' ? t('patient.files.all') : catLabel(filterCat),
        // Beside the viewer the tiles scroll inside their own column, as tall
        // as the viewer, so both stay on screen while the doctor flips through.
        className: sideBySide ? 'grid max-h-[calc(min(60vh,36rem)+7.5rem)] min-w-0 flex-[1_1_24rem] grid-cols-[repeat(auto-fill,minmax(7.5rem,1fr))] gap-2.5 overflow-y-auto p-0.5' : 'grid w-full min-w-0 grid-cols-[repeat(auto-fill,minmax(7.5rem,1fr))] gap-2.5 p-0.5'
    }, visibleFiles.map((f)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $jGozX.default), {
            key: (0, $zi6VT.fileKey)(f),
            file: f,
            selected: sideBySide && currentKey === (0, $zi6VT.fileKey)(f),
            onSelect: sideBySide ? selectFile : (file)=>files.openGallery(file, visibleFiles),
            buttonRef: (el)=>{
                if (el) tileRefs.current.set((0, $zi6VT.fileKey)(f), el);
                else tileRefs.current.delete((0, $zi6VT.fileKey)(f));
            }
        }))), sideBySide && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "min-w-0 flex-[2_1_28rem]"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $zi6VT.FileGalleryPane), {
        files: visibleFiles,
        current: current,
        onSelect: selectFile,
        onDetail: (f)=>files.openDetail(f),
        onView: files.openViewer,
        onExtract: (f)=>files.openExtract(f),
        onDownload: files.download,
        onDelete: files.requestDelete,
        clinicNameOf: clinicNameOf,
        viewerHeight: "min(60vh, 36rem)",
        testid: "files-gallery-pane"
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '0.25rem 1rem 0.75rem'
        }
    }, groups.map((g)=>{
        const collapsed = filterCat === 'all' && collapsedCats.has(g.id);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: g.id,
            "data-testid": `files-group-${g.id}`,
            "data-state": collapsed ? 'collapsed' : 'content'
        }, filterCat === 'all' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aJ1FU.default), {
            variant: "ghost",
            onClick: ()=>toggleCat(g.id),
            "aria-expanded": !collapsed,
            "data-testid": `files-group-toggle-${g.id}`,
            className: "w-full h-auto min-h-9 justify-start gap-2 rounded-none px-0 py-1 hover:bg-transparent"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.6875rem',
                fontWeight: 700,
                color: (0, $2Ieny.CL).accentInk
            }
        }, catLabel(g.id)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.6875rem',
                color: (0, $2Ieny.CL).text3
            }
        }, formatDigits(g.files.length)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "aria-hidden": true,
            style: {
                flex: 1,
                height: 1,
                background: (0, $2Ieny.CL).border
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2WFPf.default), {
            size: 14,
            "aria-hidden": true,
            style: {
                color: (0, $2Ieny.CL).text3,
                transform: collapsed ? 'rotate(90deg)' : 'none',
                transition: 'transform .18s'
            }
        })), !collapsed && g.files.map((f)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hRWhk.default), {
                key: `${f._source}-${f.id}`,
                file: f,
                clinicName: clinicNameOf && f.clinicId ? clinicNameOf(f.clinicId) : null,
                onOpen: files.openDetail,
                onView: files.openViewer,
                onPreview: (file)=>files.openGallery(file, visibleFiles),
                onExtract: (file)=>files.openExtract(file),
                onEdit: (file)=>files.openDetail(file, {
                        edit: true
                    }),
                onDownload: files.download,
                onDelete: files.requestDelete
            })));
    }), visibleFiles.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7gSBD.default), {
        "data-testid": "files-category-empty",
        title: t('patient.files.noneInCategory')
    }))), files.overlays);
};
var $ab3a679d970a4d5f$export$2e2bcd8739ae039 = $ab3a679d970a4d5f$var$FilesTab;

});
parcelRegister("4z4tf", function(module, exports) {

$parcel$export(module.exports, "useMyClinics", () => $352de6198ea69bb8$export$f9eed3ff0df23e5c);

var $acw62 = parcelRequire("acw62");

var $eVM84 = parcelRequire("eVM84");
// The doctor's clinic memberships, for the settings «مطب‌ها» section.
//
// Deliberately NOT the `listClinics` document that Encounters and Accounting
// declare: that one is a clinic *directory* filtered to clinics this account
// owns, and returns nothing for a doctor who joined a clinic by invitation code.
// `myClinics` reads doctorpreference's `clinic_doctors`, so it answers the
// question this section asks — which clinics am I actually in, and are they
// still pending.
const $352de6198ea69bb8$var$MY_CLINICS = `
  query MyClinics {
    myClinics {
      id
      status
      clinic { id name city province officePhone }
    }
  }
`;
function $352de6198ea69bb8$export$f9eed3ff0df23e5c({ enabled: enabled = true } = {}) {
    const [clinics, setClinics] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(enabled);
    const [error, setError] = (0, $acw62.useState)(null);
    const fetchClinics = (0, $acw62.useCallback)(async ()=>{
        try {
            const data = await (0, $eVM84.bffQuery)($352de6198ea69bb8$var$MY_CLINICS);
            setClinics(data?.myClinics ?? []);
            setError(null);
        } catch (err) {
            setError(err);
        }
    }, []);
    const refetch = (0, $acw62.useCallback)(()=>{
        setLoading(true);
        return fetchClinics().finally(()=>setLoading(false));
    }, [
        fetchClinics
    ]);
    // Fetched only once the section is actually opened — the other four tabs must
    // not pay for a query they never show (§8).
    (0, $acw62.useEffect)(()=>{
        if (!enabled) return;
        let alive = true;
        setLoading(true);
        fetchClinics().finally(()=>{
            if (alive) setLoading(false);
        });
        return ()=>{
            alive = false;
        };
    }, [
        enabled,
        fetchClinics
    ]);
    // A join succeeds by making the list longer — the caller re-reads rather than
    // splicing an optimistic row, so «در انتظار تأیید» comes from the server.
    return {
        clinics: clinics,
        loading: loading,
        error: error,
        refetch: refetch
    };
}

});







parcelRegister("fk1mD", function(module, exports) {

$parcel$export(module.exports, "useCountryDefaults", () => $b279c821b4dd5adc$export$80c17785b45f4556);

var $acw62 = parcelRequire("acw62");

var $e3sfE = parcelRequire("e3sfE");

var $83YQ0 = parcelRequire("83YQ0");
function $b279c821b4dd5adc$export$80c17785b45f4556() {
    const caps = (0, $e3sfE.useClinicCapabilities)();
    return (0, $acw62.useMemo)(()=>(0, $83YQ0.countryDefaults)(caps), [
        caps
    ]);
}
var $b279c821b4dd5adc$export$2e2bcd8739ae039 = $b279c821b4dd5adc$export$80c17785b45f4556;

});
parcelRegister("83YQ0", function(module, exports) {

$parcel$export(module.exports, "countryDefaults", () => $5dedcba69d0fadbd$export$6ad9cfbbc7eddb2d);
parcelRequire("5N0ZI");
var $3tGMU = parcelRequire("3tGMU");
var $5AX1S = parcelRequire("5AX1S");
/**
 * What the clinic's COUNTRY sets where nothing else has (PM-0218, country
 * configuration §5 «locale»): the rule a NEW national id is judged by, the
 * country an EMPTY phone field starts on, where a map with no pin opens, and
 * whether an address is picked from Iran's provinces or typed.
 *
 * The same rules as the kit's `ui/lib/countryDefaults.js` and the doctor panel's
 * copy — this one exists until the panel's framework pin carries the kit's; then
 * it goes.
 *
 * Each answer is a DEFAULT and nothing more. What the desk picked (the national
 * id's country chip, the phone's country picker) and what the record already
 * holds (a stored E.164 number, a saved pin) win, exactly as they do today.
 *
 * `caps` is `myClinic.capabilities` (hooks/useClinicCapabilities.js). Every
 * answer here is `undefined` — "do what you did before" to every caller — when
 * the capabilities are not known (`null`), when the country leaves a field
 * empty, and for an `IR` country:
 *
 *   * Iran's profile states exactly what this client already does, and
 *   * a clinic that never set its country reads as IR — an Iraqi clinic on IQD
 *     among them, whose forms today already start on +964 and the generic id
 *     (hooks/useClinicRegion.js). It keeps that until its country is set
 *     (contract rule 2); on a deployment outside the Iranian market it is no
 *     Iranian clinic at all.
 *
 * So an Iranian clinic, and every clinic whose country nobody could read, sees
 * no change; a clinic in another country gets that country's defaults.
 */ /** The national-id country for "any rule but Iran's" — the kit's generic rule. */ const $5dedcba69d0fadbd$var$GENERIC_COUNTRY = 'ZZ';
const $5dedcba69d0fadbd$var$ISO2 = /^[A-Z]{2}$/;
function $5dedcba69d0fadbd$export$8c23214a20fd00f5(caps) {
    if (!caps || typeof caps !== 'object') return null;
    if (typeof caps.country !== 'string' || !$5dedcba69d0fadbd$var$ISO2.test(caps.country) || caps.country === 'IR') return null;
    return caps;
}
function $5dedcba69d0fadbd$export$6c3f3a03d56800ae(caps) {
    const c = $5dedcba69d0fadbd$export$8c23214a20fd00f5(caps);
    if (!c?.nationalIdRule) return undefined;
    if (c.nationalIdRule === 'IR') return 'IR';
    // The clinic's own code when the kit keeps no rule of its own for it — the
    // field's chip then shows that country — else the generic placeholder.
    return (0, $3tGMU).NATIONAL_ID_RULES[c.country] ? $5dedcba69d0fadbd$var$GENERIC_COUNTRY : c.country;
}
function $5dedcba69d0fadbd$export$99c041a5caf796a6(caps) {
    const country = $5dedcba69d0fadbd$export$8c23214a20fd00f5(caps)?.country;
    return country && (0, $5AX1S).findByIso2(country) ? country : undefined;
}
function $5dedcba69d0fadbd$export$7647f78674ba6234(caps) {
    const view = $5dedcba69d0fadbd$export$8c23214a20fd00f5(caps)?.mapView;
    if (!view || typeof view !== 'object') return undefined;
    const lat = Number(view.lat);
    const lon = Number(view.lon);
    const zoom = Number(view.zoom);
    if (![
        lat,
        lon,
        zoom
    ].every(Number.isFinite)) return undefined;
    return [
        lat,
        lon,
        Math.trunc(zoom)
    ];
}
function $5dedcba69d0fadbd$export$e07b841fc5d2792c(caps) {
    const model = $5dedcba69d0fadbd$export$8c23214a20fd00f5(caps)?.addressModel;
    if (!model) return undefined;
    return model === 'iran_provinces' ? undefined : false;
}
function $5dedcba69d0fadbd$export$6ad9cfbbc7eddb2d(caps) {
    return {
        nationalIdCountry: $5dedcba69d0fadbd$export$6c3f3a03d56800ae(caps),
        phoneCountry: $5dedcba69d0fadbd$export$99c041a5caf796a6(caps),
        mapOpenAt: $5dedcba69d0fadbd$export$7647f78674ba6234(caps),
        iranianProvinces: $5dedcba69d0fadbd$export$e07b841fc5d2792c(caps)
    };
}

});


parcelRegister("2YFrP", function(module, exports) {

$parcel$export(module.exports, "default", () => $7094d8c37b766297$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $hZDga = parcelRequire("hZDga");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");
parcelRequire("52bn2");
var $jTCZr = parcelRequire("jTCZr");

var $1zLkf = parcelRequire("1zLkf");

var $lOI39 = parcelRequire("lOI39");

var $kZuTn = parcelRequire("kZuTn");
/**
 * «سهم بیمار» before the patient sits down — and, when an insurer is waiting on
 * a معرفی‌نامه, the chance to register it here rather than discover it at the
 * cash desk.
 *
 * ONE panel for booking and for check-in, because the question is the same at
 * both: what will this visit cost, and is anything stopping an insurer from
 * paying its part. Two copies would be two ideas of what a quote says.
 *
 * Every insurer gets a line, including the ones paying nothing: «طرف قرارداد
 * نیست» and «معرفی‌نامه لازم است» are precisely what the desk must act on, and
 * they are invisible in the total.
 *
 * A quote is ADVISORY — its failure never blocks a booking, so the panel simply
 * does not appear.
 */ const $7094d8c37b766297$var$CARD = {
    border: `1px solid ${(0, $jTCZr.C).border}`,
    borderRadius: 10,
    background: (0, $jTCZr.C).card,
    padding: '9px 11px',
    display: 'flex',
    flexDirection: 'column',
    gap: 6
};
const $7094d8c37b766297$var$LINE = {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    fontSize: '0.75rem'
};
function $7094d8c37b766297$export$2e2bcd8739ae039({ patientId: patientId, doctorId: doctorId, services: services = [], serviceDeclarationId: // «خدمت نوبت» — the PRIMARY service the booking is about to store. Quoted by
// the same resolver that prices the proforma, so the preview is the whole
// bill rather than only the extras beside it.
serviceDeclarationId = null, atTs: atTs, appointmentId: appointmentId, choice: choice, onChoiceChange: onChoiceChange, enabled: enabled = true }) {
    const { t: t, moneyUnit: moneyUnit, formatMoney: formatMoney } = (0, $e1LEq.default)();
    const nameOf = (0, $1zLkf.useInsurerName)();
    const { supplementaries: supplementaries } = (0, $1zLkf.usePatientPolicies)(patientId, {
        activeOnly: true
    });
    const { letters: letters, create: create } = (0, $1zLkf.useReferralLetters)(patientId, {
        enabled: !!patientId && enabled
    });
    const [dialogFor, setDialogFor] = (0, $acw62.useState)(null);
    const [saving, setSaving] = (0, $acw62.useState)(false);
    const { quote: quote, loading: loading } = (0, $1zLkf.useInsuranceQuote)({
        patientId: patientId,
        doctorId: doctorId,
        services: services,
        atTs: atTs,
        appointmentId: appointmentId,
        choice: choice,
        enabled: enabled,
        serviceDeclarationId: serviceDeclarationId
    });
    // Which policy each waiting insurer belongs to, so «ثبت» opens the dialog on
    // the right one rather than asking a question already answered.
    const policyByInsurer = (0, $acw62.useMemo)(()=>new Map(supplementaries.map((p)=>[
                p.insurerId,
                p.id
            ])), [
        supplementaries
    ]);
    const excluded = choice?.excludedPolicyIds || [];
    const toggleExcluded = (policyId)=>{
        if (!onChoiceChange) return;
        onChoiceChange({
            ...choice || {},
            excludedPolicyIds: excluded.includes(policyId) ? excluded.filter((id)=>id !== policyId) : [
                ...excluded,
                policyId
            ]
        });
    };
    const onSaveLetter = async (input)=>{
        setSaving(true);
        try {
            const letter = await create(input);
            // Bind it to THIS visit straight away: the desk registered it because this
            // quote asked for it, and making them pick it again would be a second
            // question with one possible answer.
            if (letter && onChoiceChange) {
                const pairs = (choice?.letterByPolicyId || []).filter((p)=>p.policyId !== input.policyId);
                onChoiceChange({
                    ...choice || {},
                    letterByPolicyId: [
                        ...pairs,
                        {
                            policyId: input.policyId,
                            letterId: letter.id
                        }
                    ]
                });
            }
        } finally{
            setSaving(false);
        }
    };
    if (!enabled || !patientId) return null;
    if (loading && !quote) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hZDga.Spinner), {
        "data-testid": "insurance-quote-loading"
    });
    if (!quote) return null;
    // Every insurer named across the quote's lines, each with the worst thing it
    // has to say — a leg that needs a letter on ANY line needs one.
    const insurerRows = [];
    for (const line of quote.lines || [])for (const leg of line.legs || []){
        let row = insurerRows.find((r)=>r.insurerId === leg.insurerId);
        if (!row) {
            row = {
                insurerId: leg.insurerId,
                name: nameOf(leg.insurerId, leg.insurerName),
                share: 0,
                kind: leg.kind,
                contracted: !!leg.contractId,
                needsLetter: false
            };
            insurerRows.push(row);
        }
        row.share += leg.shareRial || 0;
        if (leg.source === (0, $kZuTn.SOURCE).NEEDS_REFERRAL) row.needsLetter = true;
        if (leg.contractId) row.contracted = true;
    }
    const verdicts = (quote.lines || []).map((line)=>line.configVerdictFa).filter((v, i, all)=>v && all.indexOf(v) === i);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: $7094d8c37b766297$var$CARD,
        "data-testid": "insurance-quote-panel",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    ...$7094d8c37b766297$var$LINE,
                    fontWeight: 700
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        children: t('insurance.share.patient')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            flex: 1
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            fontVariantNumeric: 'tabular-nums'
                        },
                        "data-testid": "insurance-quote-patient",
                        children: `${formatMoney(quote.patientShareRial, {
                            currency: quote?.currency
                        })} ${moneyUnit('short', quote?.currency)}`
                    })
                ]
            }),
            insurerRows.map((row)=>{
                const policyId = policyByInsurer.get(row.insurerId);
                const isExcluded = policyId && excluded.includes(policyId);
                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: $7094d8c37b766297$var$LINE,
                    "data-testid": `insurance-quote-leg-${row.insurerId}`,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            style: {
                                color: isExcluded ? (0, $jTCZr.C).textMuted : (0, $jTCZr.C).textPrimary
                            },
                            children: row.name
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            style: {
                                flex: 1
                            }
                        }),
                        isExcluded ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            style: {
                                color: (0, $jTCZr.C).textMuted,
                                fontSize: '0.71875rem'
                            },
                            children: t('insurance.legs.excludeThisVisit')
                        }) : row.needsLetter ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        color: (0, $jTCZr.C).amber,
                                        fontSize: '0.71875rem',
                                        fontWeight: 600
                                    },
                                    children: t('insurance.explain.needsReferral')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                    variant: "ghost",
                                    size: "sm",
                                    onClick: ()=>setDialogFor(policyId || ''),
                                    "data-testid": `insurance-quote-letter-${row.insurerId}`,
                                    children: t('insurance.letter.add')
                                })
                            ]
                        }) : !row.contracted ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            style: {
                                color: (0, $jTCZr.C).textMuted,
                                fontSize: '0.71875rem'
                            },
                            children: t('insurance.explain.notContracted')
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            style: {
                                fontVariantNumeric: 'tabular-nums'
                            },
                            children: `${formatMoney(row.share, {
                                currency: row?.currency
                            })} ${moneyUnit('short', row?.currency)}`
                        }),
                        policyId && onChoiceChange ? /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            type: "button",
                            onClick: ()=>toggleExcluded(policyId),
                            "aria-label": isExcluded ? t('insurance.legs.includeThisVisit') : t('insurance.legs.excludeThisVisit'),
                            title: isExcluded ? t('insurance.legs.includeThisVisit') : t('insurance.legs.excludeThisVisit'),
                            "data-testid": `insurance-quote-exclude-${row.insurerId}`,
                            style: {
                                border: 'none',
                                background: 'none',
                                cursor: 'pointer',
                                padding: 0,
                                color: (0, $jTCZr.C).textMuted,
                                fontSize: '0.8125rem',
                                lineHeight: 1
                            },
                            children: isExcluded ? "\u21BA" : "\xd7"
                        }) : null
                    ]
                }, row.insurerId);
            }),
            verdicts.map((verdict)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        fontSize: '0.6875rem',
                        color: (0, $jTCZr.C).textMuted,
                        lineHeight: 1.8
                    },
                    children: verdict
                }, verdict)),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lOI39.default), {
                open: dialogFor !== null,
                onClose: ()=>setDialogFor(null),
                onSave: onSaveLetter,
                policies: supplementaries,
                policyId: dialogFor || null,
                appointmentId: appointmentId,
                saving: saving
            })
        ]
    });
}

});
parcelRegister("lOI39", function(module, exports) {

$parcel$export(module.exports, "default", () => $826856d201fadb19$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $aJ1FU = parcelRequire("aJ1FU");
var $4Qco3 = parcelRequire("4Qco3");
var $cT2Zr = parcelRequire("cT2Zr");
parcelRequire("52bn2");
var $jTCZr = parcelRequire("jTCZr");

var $ciRrJ = parcelRequire("ciRrJ");

var $kZuTn = parcelRequire("kZuTn");

var $1zLkf = parcelRequire("1zLkf");

var $7guRV = parcelRequire("7guRV");
/**
 * «ثبت معرفی‌نامه» — registering one insurer's authorisation to treat this
 * patient here.
 *
 * ONE dialog, opened from three places that all mean the same act: the patient
 * drawer (any time), the booking modal (before the visit), and check-in (where a
 * missing letter is usually discovered). Three copies of this form would be three
 * chances for them to disagree about what a letter is.
 *
 * `policyId` may be pre-selected by the caller — the desk clicked «ثبت» on a
 * specific insurer's «معرفی‌نامه لازم است» notice, and re-asking which insurer it
 * was for would be asking a question already answered.
 */ const $826856d201fadb19$var$FIELD = {
    display: 'flex',
    flexDirection: 'column',
    gap: 4
};
const $826856d201fadb19$var$LABEL = {
    fontSize: '0.6875rem',
    fontWeight: 600,
    color: (0, $jTCZr.C).textMuted
};
const $826856d201fadb19$var$ROW = {
    display: 'flex',
    gap: 10,
    flexWrap: 'wrap'
};
const $826856d201fadb19$var$input = (invalid)=>({
        border: `1px solid ${invalid ? (0, $jTCZr.C).red : (0, $jTCZr.C).border}`,
        borderRadius: 8,
        padding: '6px 9px',
        fontSize: '0.78125rem',
        fontFamily: 'inherit',
        background: (0, $jTCZr.C).card,
        color: (0, $jTCZr.C).textPrimary,
        width: '100%',
        boxSizing: 'border-box'
    });
const $826856d201fadb19$var$DAY = 86400000;
// The same overlay the other modals in this app use, so a second
// dialog does not introduce a second idea of what a modal looks like.
const $826856d201fadb19$var$OVERLAY = {
    position: 'fixed',
    inset: 0,
    zIndex: 1000,
    background: 'rgba(0,0,0,0.55)',
    backdropFilter: 'blur(3px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 16
};
const $826856d201fadb19$var$SHEET = {
    background: (0, $jTCZr.C).card,
    borderRadius: 16,
    width: '100%',
    maxWidth: 460,
    maxHeight: '90vh',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0 24px 64px rgba(0,0,0,0.22)',
    overflow: 'hidden'
};
const $826856d201fadb19$var$HEAD = {
    padding: '14px 16px',
    borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
    fontSize: '0.84375rem',
    fontWeight: 700,
    color: (0, $jTCZr.C).textPrimary
};
function $826856d201fadb19$export$2e2bcd8739ae039({ open: open, onClose: onClose, onSave: onSave, policies: policies = [], policyId: initialPolicyId = null, appointmentId: appointmentId = null, saving: saving = false }) {
    const { t: t, fromDisplayAmount: fromDisplayAmount } = (0, $e1LEq.default)();
    const nameOf = (0, $1zLkf.useInsurerName)();
    // Only بیمهٔ تکمیلی: basic insurers do not issue معرفی‌نامه in this model, and
    // offering one would invite a letter that authorises nothing.
    const supplementaries = (0, $acw62.useMemo)(()=>(policies || []).filter((p)=>p.kind === 'supplementary').sort((a, b)=>(a.priority || 0) - (b.priority || 0)), [
        policies
    ]);
    const [form, setForm] = (0, $acw62.useState)(()=>$826856d201fadb19$var$blank(initialPolicyId, supplementaries));
    const [error, setError] = (0, $acw62.useState)('');
    (0, $acw62.useEffect)(()=>{
        if (open) {
            setForm($826856d201fadb19$var$blank(initialPolicyId, supplementaries));
            setError('');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open,
        initialPolicyId,
        supplementaries.length
    ]);
    const set = (patch)=>{
        setForm((f)=>({
                ...f,
                ...patch
            }));
        setError('');
    };
    const submit = async ()=>{
        const input_ = {
            policyId: form.policyId,
            letterNumber: form.letterNumber.trim(),
            issuedAt: form.issuedAt || null,
            validFrom: form.validFrom,
            validTo: form.validTo,
            scopeCatalogIds: [],
            scopeItemType: form.scopeItemType || null,
            approvedCeilingRial: form.ceilingToman === '' ? 0 : fromDisplayAmount(Number(form.ceilingToman)),
            patientSharePctOverride: form.sharePct === '' ? null : Number(form.sharePct),
            singleUse: form.singleUse,
            note: form.note.trim() || null,
            appointmentId: appointmentId || null
        };
        const bad = (0, $kZuTn.validateReferralLetter)(t, input_);
        if (bad) {
            setError(bad);
            return;
        }
        try {
            await onSave(input_);
            onClose();
        } catch (e) {
            setError(e?.message || t('common.errors.generic'));
        }
    };
    // Ctrl+S saves and Esc closes, through the ONE registry — a per-dialog window
    // listener is what makes two shortcuts fight (clinic-app/CLAUDE.md §4.2), and
    // it is also what puts them in the `?` overlay.
    (0, $ciRrJ.useShortcut)('ctrl+s', submit, {
        label: t('common.actions.save'),
        group: t('insurance.letter.title'),
        enabled: open && !saving,
        firesInInput: true
    });
    (0, $ciRrJ.useShortcut)('esc', onClose, {
        label: t('common.actions.close'),
        group: t('insurance.letter.title'),
        enabled: open
    });
    if (!open) return null;
    const noSupplementary = !supplementaries.length;
    const body = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            noSupplementary ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                tone: "warning",
                "data-testid": "referral-letter-no-policy",
                children: t('insurance.letter.errors.noSupplementary')
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: $826856d201fadb19$var$FIELD,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                style: $826856d201fadb19$var$LABEL,
                                htmlFor: "rl-policy",
                                children: t('insurance.groups.supplementary')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("select", {
                                id: "rl-policy",
                                style: $826856d201fadb19$var$input(false),
                                value: form.policyId || '',
                                onChange: (e)=>set({
                                        policyId: e.target.value
                                    }),
                                "data-testid": "referral-letter-policy",
                                children: supplementaries.map((p)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("option", {
                                        value: p.id,
                                        children: [
                                            nameOf(p.insurerId, p.insurerName),
                                            p.policyNumber ? ` \u{2014} ${p.policyNumber}` : ''
                                        ]
                                    }, p.id))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: $826856d201fadb19$var$FIELD,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                style: $826856d201fadb19$var$LABEL,
                                htmlFor: "rl-number",
                                children: t('insurance.letter.number')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                id: "rl-number",
                                style: $826856d201fadb19$var$input(false),
                                value: form.letterNumber,
                                onChange: (e)=>set({
                                        letterNumber: e.target.value
                                    }),
                                maxLength: 64,
                                autoFocus: true,
                                "data-testid": "referral-letter-number"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: $826856d201fadb19$var$ROW,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    ...$826856d201fadb19$var$FIELD,
                                    flex: 1,
                                    minWidth: 150
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                        style: $826856d201fadb19$var$LABEL,
                                        children: t('insurance.letter.validFrom')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Qco3.default), {
                                        value: form.validFrom || null,
                                        onChange: (ms)=>set({
                                                validFrom: ms || null
                                            }),
                                        "data-testid": "referral-letter-from"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    ...$826856d201fadb19$var$FIELD,
                                    flex: 1,
                                    minWidth: 150
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                        style: $826856d201fadb19$var$LABEL,
                                        children: t('insurance.letter.validTo')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Qco3.default), {
                                        value: form.validTo || null,
                                        onChange: (ms)=>set({
                                                validTo: ms || null
                                            }),
                                        "data-testid": "referral-letter-to"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: $826856d201fadb19$var$ROW,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    ...$826856d201fadb19$var$FIELD,
                                    flex: 1,
                                    minWidth: 150
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                        style: $826856d201fadb19$var$LABEL,
                                        htmlFor: "rl-ceiling",
                                        children: t('insurance.letter.ceiling')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                        id: "rl-ceiling",
                                        style: $826856d201fadb19$var$input(false),
                                        inputMode: "numeric",
                                        value: form.ceilingToman,
                                        onChange: (e)=>set({
                                                ceilingToman: e.target.value.replace(/[^\d]/g, '')
                                            }),
                                        "data-testid": "referral-letter-ceiling"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            fontSize: '0.65625rem',
                                            color: (0, $jTCZr.C).textMuted
                                        },
                                        children: t('insurance.letter.ceilingHint')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    ...$826856d201fadb19$var$FIELD,
                                    flex: 1,
                                    minWidth: 130
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                        style: $826856d201fadb19$var$LABEL,
                                        htmlFor: "rl-pct",
                                        children: t('insurance.letter.sharePct')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                        id: "rl-pct",
                                        style: $826856d201fadb19$var$input(false),
                                        inputMode: "numeric",
                                        value: form.sharePct,
                                        onChange: (e)=>set({
                                                sharePct: e.target.value.replace(/[^\d]/g, '')
                                            }),
                                        "data-testid": "referral-letter-pct"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            fontSize: '0.65625rem',
                                            color: (0, $jTCZr.C).textMuted
                                        },
                                        children: t('insurance.letter.sharePctHint')
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            gap: 8,
                            alignItems: 'center'
                        },
                        "data-testid": "referral-letter-single-use",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cT2Zr.default), {
                                checked: form.singleUse,
                                onCheckedChange: (on)=>set({
                                        singleUse: on
                                    })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: $826856d201fadb19$var$LABEL,
                                children: t('insurance.letter.singleUse')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: $826856d201fadb19$var$FIELD,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                style: $826856d201fadb19$var$LABEL,
                                htmlFor: "rl-note",
                                children: t('insurance.letter.note')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                id: "rl-note",
                                style: $826856d201fadb19$var$input(false),
                                value: form.note,
                                onChange: (e)=>set({
                                        note: e.target.value
                                    }),
                                "data-testid": "referral-letter-note"
                            })
                        ]
                    })
                ]
            }),
            error ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                tone: "danger",
                "data-testid": "referral-letter-error",
                children: error
            }) : null
        ]
    });
    const actions = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                variant: "ghost",
                onClick: onClose,
                "data-testid": "referral-letter-cancel",
                children: t('common.actions.cancel')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                onClick: submit,
                disabled: saving || noSupplementary,
                "data-testid": "referral-letter-save",
                children: t('common.actions.save')
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7guRV.default), {
        open: open,
        onClose: onClose,
        title: t('insurance.letter.add'),
        snap: 0.9,
        fullHeight: false,
        footer: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            style: {
                display: 'flex',
                gap: 8,
                justifyContent: 'flex-end'
            },
            children: actions
        }),
        "data-testid": "referral-letter-dialog",
        desktop: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            style: $826856d201fadb19$var$OVERLAY,
            onClick: (e)=>e.target === e.currentTarget && onClose(),
            "data-testid": "referral-letter-dialog",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: $826856d201fadb19$var$SHEET,
                role: "dialog",
                "aria-modal": "true",
                "aria-label": t('insurance.letter.add'),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: $826856d201fadb19$var$HEAD,
                        children: t('insurance.letter.add')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 12,
                            padding: 16,
                            overflowY: 'auto'
                        },
                        children: [
                            body,
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    display: 'flex',
                                    gap: 8,
                                    justifyContent: 'flex-end'
                                },
                                children: actions
                            })
                        ]
                    })
                ]
            })
        }),
        children: body
    });
}
/**
 * A fresh form.
 *
 * The window defaults to today → thirty days, which is what Iranian supplementary
 * insurers actually issue; the desk overrides it when the letter says otherwise.
 * Guessing saves two date pickers on the common path and costs nothing when it is
 * wrong, because both fields are visible.
 */ function $826856d201fadb19$var$blank(policyId, supplementaries) {
    const now = Date.now();
    return {
        policyId: policyId || supplementaries[0]?.id || '',
        letterNumber: '',
        issuedAt: now,
        validFrom: now,
        validTo: now + 30 * $826856d201fadb19$var$DAY,
        scopeItemType: null,
        ceilingToman: '',
        sharePct: '',
        singleUse: true,
        note: ''
    };
}

});
parcelRegister("7guRV", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ff2c26776dcb089$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("5N0ZI");
var $4fYdd = parcelRequire("4fYdd");
parcelRequire("52bn2");
var $jTCZr = parcelRequire("jTCZr");

var $9h2jQ = parcelRequire("9h2jQ");

var $4WVD9 = parcelRequire("4WVD9");
function $5ff2c26776dcb089$export$2e2bcd8739ae039({ open: open = true, onClose: onClose, title: /** The sheet's header and the dialog's `DialogTitle`. */ title, subtitle: /** One muted line under the title — a count, a phone number, a patient. */ subtitle, footer: /** The commit row: the sheet's docked footer, the dialog's last block. */ footer, children: children, desktop: /** The desktop anatomy, already built. Omit for the kit `Dialog`. */ desktop, size: /** Kit-`Dialog` width, when `desktop` is omitted. */ size = 'md', snap: /** Fraction of the viewport the sheet may take. */ snap = 0.92, sheetPadded: /** Sheet-side gutter around `children`. Off for a body that is a full-bleed list. */ sheetPadded = true, fullHeight: fullHeight = true, 'data-testid': testId }) {
    const { isMobile: isMobile } = (0, $9h2jQ.default)();
    if (!open) return null;
    if (isMobile) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4WVD9.default), {
        open: true,
        onClose: onClose,
        title: title,
        footer: footer,
        snap: snap,
        fullHeight: fullHeight,
        "data-testid": testId,
        children: [
            subtitle ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    padding: '0.75rem 1rem 0',
                    fontSize: '0.75rem',
                    color: (0, $jTCZr.C).textMuted,
                    lineHeight: 1.9
                },
                children: subtitle
            }) : null,
            sheetPadded ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    padding: '0.875rem 1rem',
                    display: 'grid',
                    gap: '0.875rem'
                },
                children: children
            }) : children
        ]
    });
    if (desktop) return desktop;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fYdd.Dialog), {
        open: true,
        onOpenChange: (v)=>{
            if (!v) onClose?.();
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4fYdd.DialogContent), {
            size: size,
            "data-testid": testId,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4fYdd.DialogHeader), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fYdd.DialogTitle), {
                            children: title
                        }),
                        subtitle ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            style: {
                                fontSize: '0.75rem',
                                color: (0, $jTCZr.C).textMuted
                            },
                            children: subtitle
                        }) : null
                    ]
                }),
                children,
                footer
            ]
        })
    });
}

});
parcelRegister("4WVD9", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd8cb3a41c473adf$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $6TdpC = parcelRequire("6TdpC");
parcelRequire("5N0ZI");
var $5MbI8 = parcelRequire("5MbI8");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $fzygI = parcelRequire("fzygI");

var $fXl0x = parcelRequire("fXl0x");
/**
 * The mobile task overlay.
 *
 * Every form, filter and picker on the phone renders through this, which is
 * the point: at the pinned framework version (v0.10.1) the kit's `BottomSheet`
 * has six separate problems on a real device, and each one would otherwise be
 * fixed — or missed — eight times over.
 *
 * | Kit v0.10.1                     | Here                                    |
 * |---------------------------------|-----------------------------------------|
 * | `max-height: 85vh`              | `85dvh`, `vh` kept as the fallback      |
 * | blind to the software keyboard  | sits inside the visible box (PM-0168)   |
 * | outside the history stack       | `useOverlayHistory`                     |
 * | rendered where it is mounted    | portaled to `<body>`                    |
 * | focus leaks to the page behind  | focus moves in, Tab cycles, opener back |
 * | page scrolls behind it          | body scroll lock                        |
 *
 * `vh` is the LARGEST viewport, so with iOS Safari's address bar expanded an
 * 85vh sheet is taller than the screen. `dvh` fixes that but is still blind to
 * the keyboard: `position: fixed`, `dvh` and `svh` all describe the LAYOUT
 * viewport, and the keyboard is painted over it — so a focused field's submit
 * button ends up under the keys with no CSS-only way to know.
 *
 * **The keyboard (PM-0168, the kit's PM-0108 fix ported).** This sheet used to
 * keep its bottom edge on the LAYOUT viewport and only shrink its ceiling by
 * the keyboard inset — and then pad its footer by the same inset again. On
 * Android Chrome (`interactive-widget=resizes-visual`) the keyboard is painted
 * OVER the layout viewport, so the sheet's lower part sat under the keys, the
 * footer's commit row floated on a keyboard-high slab of padding, and Chrome's
 * own reveal of the focused field PANNED the visual viewport, sliding the title
 * bar off the top of the screen. Now the scrim sits exactly on the box the
 * user can actually see, the sheet takes `snap` of that box, the footer never
 * pads by the keyboard, and the focused field is re-revealed when the box
 * changes — the kit `BottomSheet`'s v0.23.3 idea, measured differently (below).
 *
 * **iPhone (PM-0181).** The kit hook reads the keyboard off `innerHeight`,
 * which iOS Safari shrinks together with the visual viewport, so on an iPhone
 * it reports no keyboard. The sheet therefore takes the visible box straight
 * from `visualViewport` (`useVisibleBox`: top + height, no `innerHeight`) and
 * places its scrim exactly on it. Two more iOS-only rules: a field below 16px
 * makes Safari ZOOM the page on focus (and never zoom back), so every field
 * inside the sheet is held at ≥16px by `SHEET_FIELD_CSS`; and with the
 * keyboard up the home indicator is under the keys, so the footer drops its
 * `safe-area-inset-bottom` pad instead of floating 34px above them.
 *
 * The portal is not tidiness either. On iOS WebKit a `position: fixed`
 * descendant of a momentum scroller is trapped in it: a sheet mounted inside a
 * screen's scroll region is clipped to that region and painted UNDER the
 * screen's docked bar. Chromium does not do this, so no desktop browser test
 * ever sees it.
 *
 * See docs/MOBILE-REDESIGN.md §4.2.
 */ /**
 * iOS Safari zooms the page when a field under 16px takes focus. Inline styles
 * across the forms (`bookInputStyle` is 14px) lose to this on purpose: inside a
 * phone sheet a field is never smaller than 16px (PM-0181).
 */ const $cd8cb3a41c473adf$var$SHEET_FIELD_CSS = '[data-mobile-sheet] :is(input, textarea, select) { font-size: max(16px, 1em) !important; }';
/** Room kept around a focused field inside the scroller: its label, its ring. */ const $cd8cb3a41c473adf$var$REVEAL_MARGIN = 32;
const $cd8cb3a41c473adf$var$SHEET_UNIT = typeof CSS !== 'undefined' && typeof CSS.supports === 'function' && CSS.supports('height: 1dvh') ? 'dvh' : 'vh';
function $cd8cb3a41c473adf$export$2e2bcd8739ae039({ open: open, onClose: onClose, title: title, children: children, footer: footer, fullHeight: /** A tall form fills the sheet, so its footer sits at the bottom edge rather than halfway up. */ fullHeight = false, snap: /** Fraction of the viewport the sheet may occupy. `snap={1}` + `fullHeight` is a full-screen task. */ snap = 0.85, closeLabel: closeLabel, 'data-testid': testId, 'aria-label': ariaLabel, ...rest }) {
    const { t: t } = (0, $e1LEq.default)();
    // The box the user can see, straight from `visualViewport` (PM-0168, PM-0181).
    const box = (0, $fXl0x.default)();
    const panInset = box ? box.top : 0;
    const keyboardInset = box ? box.covered : 0;
    // Something covers part of the screen (keyboard, Chrome's pan): the sheet
    // then lives in the visible box. 1px of rounding is not a keyboard.
    const boxed = Boolean(box) && (box.top > 0 || box.covered > 1);
    // A real keyboard, not a toolbar wobble: the home indicator is under it.
    const keyboardUp = Boolean(box) && box.covered > 120;
    const panelRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const scrollerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const openerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const titleId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    (0, $fzygI.default)(open, onClose);
    // Remember who opened us, and give focus back on close. A modal that leaves
    // focus on <body> strands a keyboard or screen-reader user at the top of the
    // page they were already halfway down.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return undefined;
        openerRef.current = document.activeElement;
        return ()=>{
            const opener = openerRef.current;
            if (opener && typeof opener.focus === 'function' && document.contains(opener)) opener.focus();
        };
    }, [
        open
    ]);
    // Move focus in once the panel exists.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return;
        const panel = panelRef.current;
        if (!panel) return;
        const first = panel.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        (first || panel).focus?.({
            preventScroll: true
        });
    }, [
        open
    ]);
    // Escape closes; Tab cycles inside. Both on the panel's own listener so a
    // nested ConfirmDialog (which sits above us on the z-scale) still wins.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return undefined;
        const onKey = (e)=>{
            if (e.key === 'Escape') {
                e.stopPropagation();
                onClose?.();
                return;
            }
            if (e.key !== 'Tab') return;
            const panel = panelRef.current;
            if (!panel) return;
            const focusable = [
                ...panel.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')
            ].filter((el)=>el.offsetParent !== null || el === document.activeElement);
            if (!focusable.length) return;
            const first = focusable[0];
            const last = focusable[focusable.length - 1];
            if (e.shiftKey && document.activeElement === first) {
                e.preventDefault();
                last.focus();
            } else if (!e.shiftKey && document.activeElement === last) {
                e.preventDefault();
                first.focus();
            }
        };
        document.addEventListener('keydown', onKey);
        return ()=>document.removeEventListener('keydown', onKey);
    }, [
        open,
        onClose
    ]);
    // Keep the field being typed into fully inside the sheet's scroller, with
    // room around it — its label above, its focus ring below. Runs when the
    // visible box changes under an open sheet (the keyboard arriving, the
    // browser panning) and on every focus change inside it. `scrollIntoView
    // ('nearest')`, which the kit uses, leaves the field flush against the
    // footer with its lower edge and ring cut off — what the owner saw on the
    // phone field of «بیمار جدید» (PM-0168). Only the sheet's own scroller
    // moves: the panel is inside the visible box by construction.
    const reveal = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        const panel = panelRef.current;
        const scroller = scrollerRef.current;
        const active = typeof document === 'undefined' ? null : document.activeElement;
        if (!panel || !scroller || !active || active === panel || !scroller.contains(active)) return;
        const box = scroller.getBoundingClientRect();
        const field = active.getBoundingClientRect();
        const below = field.bottom - (box.bottom - $cd8cb3a41c473adf$var$REVEAL_MARGIN);
        const above = box.top + $cd8cb3a41c473adf$var$REVEAL_MARGIN - field.top;
        // Too low: scroll down, but never so far that the field's top (a tall
        // textarea) passes the top margin. Too high: scroll up.
        if (below > 0) scroller.scrollTop += Math.min(below, Math.max(0, -above));
        else if (above > 0) scroller.scrollTop -= above;
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open || typeof requestAnimationFrame !== 'function') return undefined;
        const raf = requestAnimationFrame(reveal);
        // Again once the keyboard animation settles: Chrome's own reveal on the
        // resize scrolls only the CARET into view, after ours, and undoes the margin.
        const settle = setTimeout(reveal, 300);
        return ()=>{
            cancelAnimationFrame(raf);
            clearTimeout(settle);
        };
    }, [
        open,
        panInset,
        keyboardInset,
        reveal
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const panel = panelRef.current;
        if (!open || !panel || typeof requestAnimationFrame !== 'function') return undefined;
        // After the browser's own focus scroll, which is the flush one.
        const onFocusIn = ()=>requestAnimationFrame(reveal);
        panel.addEventListener('focusin', onFocusIn);
        return ()=>panel.removeEventListener('focusin', onFocusIn);
    }, [
        open,
        reveal
    ]);
    // Lock the page behind. iOS ignores `overflow: hidden` on its own, so the
    // touch-action and overscroll properties carry the rest of the weight.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open || typeof document === 'undefined') return undefined;
        const { body: body } = document;
        const prev = {
            overflow: body.style.overflow,
            touchAction: body.style.touchAction,
            overscrollBehavior: body.style.overscrollBehavior
        };
        body.style.overflow = 'hidden';
        body.style.touchAction = 'none';
        body.style.overscrollBehavior = 'none';
        return ()=>{
            body.style.overflow = prev.overflow;
            body.style.touchAction = prev.touchAction;
            body.style.overscrollBehavior = prev.overscrollBehavior;
        };
    }, [
        open
    ]);
    if (!open || typeof document === 'undefined') return null;
    const pct = Math.round(Math.max(0.3, Math.min(1, snap)) * 100);
    // With the screen partly covered, the scrim IS the visible box and the sheet
    // may take `snap` of it — the keyboard's height never enters the arithmetic,
    // so neither does `innerHeight`, which the two engines disagree about.
    //
    // Otherwise the old ceiling. The unit is resolved once, at runtime, rather
    // than declared twice: two `maxHeight` keys in one style object is not a CSS
    // cascade, it is an object literal, and the second silently deletes the
    // first. `dvh` is the correct unit (`vh` is the LARGEST viewport, so an 85vh
    // sheet overflows a Safari window whose address bar is expanded); `vh`
    // remains the answer for an engine that has never heard of `dvh`.
    const ceiling = boxed ? `${Math.floor(box.height * pct / 100)}px` : `${pct}${$cd8cb3a41c473adf$var$SHEET_UNIT}`;
    const sheet = /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            position: 'fixed',
            zIndex: 1000,
            ...boxed ? {
                top: `${box.top}px`,
                left: 0,
                right: 0,
                height: `${box.height}px`
            } : {
                inset: 0
            },
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'center',
            background: (0, $jTCZr.SCRIM)
        },
        onMouseDown: (e)=>{
            if (e.target === e.currentTarget) onClose?.();
        },
        "data-testid": testId ? `${testId}-scrim` : undefined,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("style", {
                children: $cd8cb3a41c473adf$var$SHEET_FIELD_CSS
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                ref: panelRef,
                role: "dialog",
                "aria-modal": "true",
                "aria-label": title ? undefined : ariaLabel,
                "aria-labelledby": title ? titleId : undefined,
                tabIndex: -1,
                "data-testid": testId,
                "data-mobile-sheet": "",
                style: {
                    width: '100%',
                    background: (0, $jTCZr.C).card,
                    borderTopLeftRadius: (0, $jTCZr.RADIUS).hero,
                    borderTopRightRadius: (0, $jTCZr.RADIUS).hero,
                    boxShadow: (0, $jTCZr.SHADOW).modal,
                    maxHeight: ceiling,
                    height: fullHeight ? ceiling : undefined,
                    display: 'flex',
                    flexDirection: 'column',
                    outline: 'none'
                },
                ...rest,
                children: [
                    (title || onClose) && /*#__PURE__*/ (0, $ayMG0.jsxs)("header", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.5rem',
                            padding: '0.75rem 1rem',
                            borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
                            flexShrink: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                id: titleId,
                                style: {
                                    flex: 1,
                                    minWidth: 0,
                                    margin: 0,
                                    fontSize: '1rem',
                                    fontWeight: 700,
                                    color: (0, $jTCZr.C).textPrimary,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'
                                },
                                children: title
                            }),
                            onClose && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5MbI8.default), {
                                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6TdpC.default), {
                                    size: 18
                                }),
                                label: closeLabel || t('common.actions.close'),
                                onClick: onClose,
                                variant: "ghost",
                                "data-testid": testId ? `${testId}-close` : undefined
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        ref: scrollerRef,
                        style: {
                            flex: 1,
                            minHeight: 0,
                            overflowY: 'auto',
                            WebkitOverflowScrolling: 'touch'
                        },
                        children: children
                    }),
                    footer && /*#__PURE__*/ (0, $ayMG0.jsx)("footer", {
                        style: {
                            flexShrink: 0,
                            borderTop: `1px solid ${(0, $jTCZr.C).border}`,
                            padding: '0.75rem 1rem',
                            // The sheet already ends at the keyboard's top edge, so the footer
                            // never pads by the keyboard (PM-0168) — and with the keyboard up
                            // the home indicator is under the keys, so not by the safe area
                            // either (PM-0181); iOS would float the commit row 34px above them.
                            paddingBottom: keyboardUp ? '0.75rem' : 'calc(0.75rem + env(safe-area-inset-bottom, 0px))',
                            background: (0, $jTCZr.C).card
                        },
                        children: footer
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $1u0KT.createPortal)(sheet, document.body);
}

});
parcelRegister("fzygI", function(module, exports) {

$parcel$export(module.exports, "overlayOwnsPop", () => $b564b4f27b6496d9$export$2846246580854e2f);
$parcel$export(module.exports, "default", () => $b564b4f27b6496d9$export$2e2bcd8739ae039);
$parcel$export(module.exports, "consumeOverlayEntry", () => $b564b4f27b6496d9$export$97ad35f555bccf4f);

var $acw62 = parcelRequire("acw62");
/**
 * The overlay-history law, implemented locally.
 *
 * On a phone the platform back gesture is the primary way people dismiss
 * things. An overlay that owns the screen — a sheet, a full-screen picker, a
 * multi-step flow — must therefore join the history stack, so that back closes
 * IT and not the route underneath it. Without this, a receptionist with a
 * half-typed invoice open swipes back and loses the whole screen.
 *
 * `@parsina/framework` grows a `useOverlayHistory` of its own at v0.11+, and
 * `BottomSheet` calls it internally from then on. This app is pinned at
 * v0.10.1, so the behaviour lives here — as a thin module with the same
 * contract, so that raising the pin is a delete-and-re-export rather than a
 * rewrite. See docs/MOBILE-REDESIGN.md §4.2.
 *
 * ── The depth counter ──
 *
 * `depth` is module-level rather than per-hook because the question it answers
 * is global: "does any overlay currently own a history entry?". A route-level
 * leave guard is a different component from the sheet, and it has no other way
 * to tell a genuine back-out-of-the-route from a back-that-closed-a-sheet.
 *
 * `justPopped` covers the other half of the same problem. When an overlay is
 * closed from inside (the × button, a successful submit) it pops its own
 * entry, and that pop reaches any `popstate` listener on the page a tick
 * later. A guard that treats it as a navigation asks "discard your changes?"
 * every single time a sheet is dismissed — which is the exact bug this flag
 * exists to prevent.
 *
 * ── The hand-off ──
 *
 * A step flow swaps one sheet for the next in a SINGLE React commit: picking
 * the doctor in «ثبت نوبت» unmounts the picker and mounts `BookingModal` in the
 * same flush. React runs every destroy before every create, so a release that
 * called `history.back()` there and then would be immediately followed by the
 * next sheet's `pushState` — and `back()` is QUEUED, not synchronous. The
 * traversal resolves after the push, so the entry it takes off the stack is
 * the one the NEW sheet just added, and the `popstate` lands on the new
 * sheet's own listener, which reads it as the platform back and closes the
 * flow. The operator picks a doctor and the whole booking disappears.
 *
 * jsdom cannot show this — it drops a traversal that a `pushState` overtakes,
 * so the hook's own tests passed the entire time the phone was broken. Chrome
 * and WebKit both fire the pop.
 *
 * So a release is DEFERRED to a microtask, which is after React's whole
 * destroy-then-create flush, and an overlay mounting inside that same flush
 * CLAIMS the pending entry instead of pushing one of its own. Two sheets, one
 * entry, no traversal at all: back still closes the flow exactly once, and the
 * step swap never touches the history stack.
 *
 * ── The repurposed entry ──
 *
 * The same hazard has a third face, and it is the one that needs no cooperation
 * from the call site. A sheet that writes to the URL while it is open — every
 * filter sheet on the phone, and «بیماران»'s row menu, which opens the record
 * by putting `patient=` in the query — does it with a REPLACE, and the entry it
 * replaces is the overlay's own, because the overlay pushed the entry that is
 * on top. Popping that on close would undo the write: the filters snapped back
 * the moment the sheet closed, and the record drawer never opened at all.
 *
 * A `replace` writes its own state object, so the mark this hook pushed is no
 * longer there — which is exactly the signal. An entry whose mark has gone has
 * been repurposed by the page, and is no longer the overlay's to pop. One rule,
 * no call site has to remember anything, and `consumeOverlayEntry` stays for
 * the case the mark cannot see: a PUSH, where the destination is a new entry
 * stacked ABOVE the overlay's rather than written into it.
 *
 * The mark is read off the stack top at cleanup, which is the overlay's own
 * entry for the overlay being dismissed. Two sheets nested one inside the other
 * where the INNER one is the one replaced would read the inner entry for both;
 * no screen does that today, and the cost would be one entry left behind rather
 * than a lost navigation.
 */ let $b564b4f27b6496d9$var$depth = 0;
let $b564b4f27b6496d9$var$justPopped = false;
// Entries promised to a navigation that is about to replace them. See
// `consumeOverlayEntry`.
let $b564b4f27b6496d9$var$consumed = 0;
let $b564b4f27b6496d9$var$justPoppedTimer = null;
// Entries whose overlay has gone but which are still on the stack, waiting for
// either the next sheet to claim one or the microtask below to pop them.
let $b564b4f27b6496d9$var$pendingRelease = 0;
let $b564b4f27b6496d9$var$releaseScheduled = false;
const $b564b4f27b6496d9$var$MARK = '__parsinaOverlay';
function $b564b4f27b6496d9$export$9452f2c4c9460e1e() {
    return $b564b4f27b6496d9$var$depth;
}
function $b564b4f27b6496d9$export$2846246580854e2f() {
    // `pendingRelease` is the deferred half: the overlay has gone but its entry
    // is still on the stack and a pop for it is on the way.
    return $b564b4f27b6496d9$var$depth > 0 || $b564b4f27b6496d9$var$pendingRelease > 0 || $b564b4f27b6496d9$var$justPopped;
}
/**
 * Pop every entry no overlay owns any more.
 *
 * Deferred to a microtask so that a step flow's next sheet — mounted in the
 * same React flush as the previous one's teardown — gets to claim the entry
 * first. One `go(-n)` rather than n `back()` calls: each queued traversal
 * resolves against the stack as it is when it RUNS, so issuing them separately
 * is the same race in miniature.
 */ function $b564b4f27b6496d9$var$flushRelease() {
    $b564b4f27b6496d9$var$releaseScheduled = false;
    const n = $b564b4f27b6496d9$var$pendingRelease;
    $b564b4f27b6496d9$var$pendingRelease = 0;
    if (n <= 0 || typeof window === 'undefined') return;
    $b564b4f27b6496d9$var$markPopped();
    window.history.go(-n);
}
function $b564b4f27b6496d9$var$releaseEntry() {
    $b564b4f27b6496d9$var$pendingRelease += 1;
    if ($b564b4f27b6496d9$var$releaseScheduled) return;
    $b564b4f27b6496d9$var$releaseScheduled = true;
    queueMicrotask($b564b4f27b6496d9$var$flushRelease);
}
function $b564b4f27b6496d9$var$markPopped() {
    $b564b4f27b6496d9$var$justPopped = true;
    if ($b564b4f27b6496d9$var$justPoppedTimer) clearTimeout($b564b4f27b6496d9$var$justPoppedTimer);
    // One task is enough: `popstate` listeners registered elsewhere run in the
    // same turn as the pop. The timer only guards against a listener that
    // defers its own work.
    $b564b4f27b6496d9$var$justPoppedTimer = setTimeout(()=>{
        $b564b4f27b6496d9$var$justPopped = false;
        $b564b4f27b6496d9$var$justPoppedTimer = null;
    }, 0);
}
function $b564b4f27b6496d9$export$2e2bcd8739ae039(open, onClose, enabled = true) {
    const ownsEntry = (0, $acw62.useRef)(false);
    const closeRef = (0, $acw62.useRef)(onClose);
    closeRef.current = onClose;
    (0, $acw62.useEffect)(()=>{
        if (!enabled || !open || typeof window === 'undefined') return undefined;
        if ($b564b4f27b6496d9$var$pendingRelease > 0) // A sheet that closed in this same flush left a marked entry behind and
        // we are its replacement: take it over. Pushing here instead is what
        // made picking a doctor close the booking flow — see the hand-off note.
        $b564b4f27b6496d9$var$pendingRelease -= 1;
        else // Push our own entry. The state mark lets a listener recognise it; the
        // URL is deliberately unchanged, because the overlay is not a route.
        window.history.pushState({
            ...window.history.state || {},
            [$b564b4f27b6496d9$var$MARK]: true
        }, '');
        ownsEntry.current = true;
        $b564b4f27b6496d9$var$depth += 1;
        const onPop = ()=>{
            if (!ownsEntry.current) return;
            // The browser has already removed our entry by the time this fires.
            ownsEntry.current = false;
            $b564b4f27b6496d9$var$depth = Math.max(0, $b564b4f27b6496d9$var$depth - 1);
            $b564b4f27b6496d9$var$markPopped();
            closeRef.current?.();
        };
        window.addEventListener('popstate', onPop);
        return ()=>{
            window.removeEventListener('popstate', onPop);
            // Closed from inside rather than by the back gesture: take our entry
            // back off the stack, or every sheet the operator opens leaves one
            // behind and back stops working entirely.
            if (ownsEntry.current) {
                ownsEntry.current = false;
                $b564b4f27b6496d9$var$depth = Math.max(0, $b564b4f27b6496d9$var$depth - 1);
                // Promised to a navigation that is replacing this entry: leave it on
                // the stack for the replace to overwrite, or the traversal would eat
                // the destination instead (see `consumeOverlayEntry`).
                if ($b564b4f27b6496d9$var$consumed > 0) $b564b4f27b6496d9$var$consumed -= 1;
                else if (!window.history.state?.[$b564b4f27b6496d9$var$MARK]) ;
                else $b564b4f27b6496d9$var$releaseEntry();
            }
        };
    }, [
        enabled,
        open
    ]);
}
function $b564b4f27b6496d9$export$97ad35f555bccf4f() {
    if ($b564b4f27b6496d9$var$depth <= 0) return false;
    $b564b4f27b6496d9$var$consumed += 1;
    return true;
}
function $b564b4f27b6496d9$export$868881c2cb22c40a() {
    $b564b4f27b6496d9$var$depth = 0;
    $b564b4f27b6496d9$var$justPopped = false;
    $b564b4f27b6496d9$var$consumed = 0;
    $b564b4f27b6496d9$var$pendingRelease = 0;
    $b564b4f27b6496d9$var$releaseScheduled = false;
    if ($b564b4f27b6496d9$var$justPoppedTimer) {
        clearTimeout($b564b4f27b6496d9$var$justPoppedTimer);
        $b564b4f27b6496d9$var$justPoppedTimer = null;
    }
}

});

parcelRegister("fXl0x", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9dca960f49ad5ef$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $b9dca960f49ad5ef$export$2e2bcd8739ae039() {
    const [box, setBox] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const vv = typeof window === 'undefined' ? null : window.visualViewport;
        if (!vv) return undefined;
        const read = ()=>{
            const top = Math.max(0, Math.round(vv.offsetTop));
            const height = Math.round(vv.height);
            const layout = document.documentElement.clientHeight || window.innerHeight || height;
            const covered = Math.max(0, Math.round(layout - height));
            setBox((prev)=>prev && prev.top === top && prev.height === height && prev.covered === covered ? prev : {
                    top: top,
                    height: height,
                    covered: covered
                });
        };
        read();
        vv.addEventListener('resize', read);
        vv.addEventListener('scroll', read);
        return ()=>{
            vv.removeEventListener('resize', read);
            vv.removeEventListener('scroll', read);
        };
    }, []);
    return box;
}

});





parcelRegister("5JA6O", function(module, exports) {

$parcel$export(module.exports, "default", () => $319646d7b9f3f8e1$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $9gEOi = parcelRequire("9gEOi");
var $7phmx = parcelRequire("7phmx");
parcelRequire("52bn2");
var $jTCZr = parcelRequire("jTCZr");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $1aTQQ = parcelRequire("1aTQQ");

var $hSpRf = parcelRequire("hSpRf");

var $2MpEq = parcelRequire("2MpEq");

var $87xEb = parcelRequire("87xEb");

var $e3sfE = parcelRequire("e3sfE");
function $319646d7b9f3f8e1$export$2e2bcd8739ae039({ value: value, onChange: onChange, disabled: disabled = false, disabledHint: disabledHint = null, template: template = '', text: text = null, onTextChange: onTextChange = null }) {
    const { t: t, formatDigits: formatDigits } = (0, $e1LEq.default)();
    const { session: session } = (0, $87xEb.default)();
    const capabilities = (0, $e3sfE.useClinicCapabilities)();
    const waBlocked = (0, $2MpEq.whatsappBlocked)(session);
    const channels = value || [];
    const offered = (0, $2MpEq.NOTIFY_CHANNEL_ORDER).filter((key)=>(0, $hSpRf.channelOffered)(capabilities, key));
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const keep = (key)=>(0, $hSpRf.channelOffered)(capabilities, key) && !(key === 'whatsapp' && waBlocked);
        if (channels.some((key)=>!keep(key))) onChange((0, $2MpEq.orderChannels)(channels.filter(keep)));
    // Only when a verdict changes — the session's or the country's — not on every
    // tick the desk makes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        waBlocked,
        capabilities
    ]);
    const hint = disabled ? disabledHint : waBlocked ? t('reception.notify.whatsappNotLinked') : null;
    const editable = !!onTextChange && !!template && !disabled && channels.length > 0;
    const editing = editable && text !== null;
    // Over the tokens, not the names that replace them: «حدود», never a promise.
    const parts = editing ? (0, $hSpRf.smsSegments)(text).segments : 0;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7phmx.default), {
        label: t('reception.notify.label'),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                role: "group",
                "aria-label": t('reception.notify.label'),
                "data-testid": "booking-notify",
                "data-state": disabled ? 'disabled' : 'idle',
                style: {
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    columnGap: 18,
                    rowGap: 8
                },
                children: offered.map((key)=>{
                    const off = disabled || key === 'whatsapp' && waBlocked;
                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9gEOi.default), {
                        checked: !off && channels.includes(key),
                        disabled: off,
                        onChange: (next)=>onChange((0, $2MpEq.withChannel)(channels, key, next === true)),
                        "data-testid": `booking-notify-${key}`,
                        label: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            style: {
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: 6
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1aTQQ.default), {
                                    channel: key,
                                    size: 14,
                                    color: (0, $jTCZr.C).textMuted
                                }),
                                t((0, $hSpRf.CHANNELS)[key].labelKey)
                            ]
                        })
                    }, key);
                })
            }),
            hint ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                "data-testid": "booking-notify-hint",
                style: {
                    fontSize: '0.71875rem',
                    color: (0, $jTCZr.C).textMuted,
                    marginTop: 6,
                    lineHeight: 1.7
                },
                children: hint
            }) : null,
            editable && !editing ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                variant: "link",
                size: "sm",
                onClick: ()=>onTextChange(template),
                "data-testid": "booking-notify-edit",
                children: t('reception.notify.editText')
            }) : null,
            editing ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                "data-testid": "booking-notify-text",
                style: {
                    marginTop: 8
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                        value: text,
                        onChange: (e)=>onTextChange(e.target.value),
                        maxLength: (0, $2MpEq.NOTIFY_BODY_MAX),
                        rows: 3,
                        dir: "auto",
                        "aria-label": t('reception.notify.textLabel'),
                        "data-testid": "booking-notify-textarea",
                        style: {
                            width: '100%',
                            boxSizing: 'border-box',
                            resize: 'vertical',
                            border: `1px solid ${(0, $jTCZr.C).border}`,
                            borderRadius: 10,
                            padding: '8px 10px',
                            fontSize: '0.8125rem',
                            lineHeight: 1.8,
                            fontFamily: 'inherit',
                            color: (0, $jTCZr.C).textPrimary,
                            background: (0, $jTCZr.C).bg
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            gap: 12,
                            fontSize: '0.71875rem',
                            color: (0, $jTCZr.C).textMuted,
                            lineHeight: 1.7
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: t('reception.notify.textHint')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                style: {
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: 8,
                                    whiteSpace: 'nowrap'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        "data-testid": "booking-notify-segments",
                                        children: t('reception.notify.segments', {
                                            count: formatDigits(parts)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                        variant: "link",
                                        size: "sm",
                                        onClick: ()=>onTextChange(null),
                                        "data-testid": "booking-notify-reset",
                                        children: t('reception.notify.resetText')
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }) : null
        ]
    });
}

});
parcelRegister("1aTQQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb62ef7cc12fda1e$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $51CfB = parcelRequire("51CfB");
var $O6OQL = parcelRequire("O6OQL");
var $keX90 = parcelRequire("keX90");
/**
 * The glyph for a messaging channel.
 *
 * One map, so the compose cards and the send history cannot draw the same channel
 * two ways. With two channels each site wrote its own `whatsapp ? … : …` ternary;
 * a third channel turned every one of those into a chain that would have to be
 * remembered four times.
 *
 * Lucide carries no brand marks, so these stand in by what the channel IS: a chat
 * app, a phone's text message, a bot. An unknown key falls back to the phone —
 * a history row from a channel this build does not know still gets an icon.
 */ const $bb62ef7cc12fda1e$var$GLYPH = {
    whatsapp: (0, $O6OQL.default),
    sms: (0, $keX90.default),
    bale: (0, $51CfB.default)
};
function $bb62ef7cc12fda1e$export$2e2bcd8739ae039({ channel: channel, ...rest }) {
    const Glyph = $bb62ef7cc12fda1e$var$GLYPH[channel] || (0, $keX90.default);
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Glyph, {
        "aria-hidden": "true",
        ...rest
    });
}

});
parcelRegister("51CfB", function(module, exports) {

$parcel$export(module.exports, "default", () => $26d04379a1704a17$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $26d04379a1704a17$export$a2387ed3b5d536eb = {
    name: "bot",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M12 8V4H8",
                key: "hb8ula"
            }
        ],
        [
            "rect",
            {
                width: "16",
                height: "12",
                x: "4",
                y: "8",
                rx: "2",
                key: "enze0r"
            }
        ],
        [
            "path",
            {
                d: "M2 14h2",
                key: "vft8re"
            }
        ],
        [
            "path",
            {
                d: "M20 14h2",
                key: "4cs60a"
            }
        ],
        [
            "path",
            {
                d: "M15 13v2",
                key: "1xurst"
            }
        ],
        [
            "path",
            {
                d: "M9 13v2",
                key: "rq6x2g"
            }
        ]
    ]
};
$26d04379a1704a17$export$a2387ed3b5d536eb.node;
const $26d04379a1704a17$export$2e2bcd8739ae039 = (0, $9QBug.default)($26d04379a1704a17$export$a2387ed3b5d536eb);

});

parcelRegister("O6OQL", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffa913da585dd100$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $ffa913da585dd100$export$a2387ed3b5d536eb = {
    name: "message-square",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
                key: "18887p"
            }
        ]
    ]
};
$ffa913da585dd100$export$a2387ed3b5d536eb.node;
const $ffa913da585dd100$export$2e2bcd8739ae039 = (0, $9QBug.default)($ffa913da585dd100$export$a2387ed3b5d536eb);

});

parcelRegister("keX90", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbab5fddbd2c27f4$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $bbab5fddbd2c27f4$export$a2387ed3b5d536eb = {
    name: "smartphone",
    size: 24,
    node: [
        [
            "rect",
            {
                width: "14",
                height: "20",
                x: "5",
                y: "2",
                rx: "2",
                ry: "2",
                key: "1yt0o3"
            }
        ],
        [
            "path",
            {
                d: "M12 18h.01",
                key: "mhygvu"
            }
        ]
    ]
};
$bbab5fddbd2c27f4$export$a2387ed3b5d536eb.node;
const $bbab5fddbd2c27f4$export$2e2bcd8739ae039 = (0, $9QBug.default)($bbab5fddbd2c27f4$export$a2387ed3b5d536eb);

});


parcelRegister("87xEb", function(module, exports) {

$parcel$export(module.exports, "useWhatsappSession", () => $5e9913c85df4bacb$export$9f5453a079f8d8f8);
$parcel$export(module.exports, "default", () => $5e9913c85df4bacb$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $2Mst8 = parcelRequire("2Mst8");

var $iAkVL = parcelRequire("iAkVL");

var $58BYB = parcelRequire("58BYB");

var $1k2zw = parcelRequire("1k2zw");
const $5e9913c85df4bacb$var$SESSION_QUERY = `
  query WhatsappSession {
    whatsappSession {
      clinicId state phone deviceLabel code codeExpiresAt linkedAt detail
    }
  }
`;
const $5e9913c85df4bacb$var$UNLINK = `mutation UnlinkWhatsapp { unlinkWhatsapp }`;
const $5e9913c85df4bacb$export$d93f6ed7ecacb902 = (session)=>session?.state === 'CONNECTED';
/** Where the BFF streams the pairing conversation. */ const $5e9913c85df4bacb$var$PAIRING_PATH = '/integrations/whatsapp/pairing';
function $5e9913c85df4bacb$export$9f5453a079f8d8f8({ pollWhileDisconnected: pollWhileDisconnected = false } = {}) {
    const [session, setSession] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    // The live pairing attempt: { kind, code, expiresAt, message } or null.
    const [pairing, setPairing] = (0, $acw62.useState)(null);
    const controller = (0, $acw62.useRef)(null);
    const refetch = (0, $acw62.useCallback)(async ()=>{
        try {
            const data = await (0, $2Mst8.bffQuery)($5e9913c85df4bacb$var$SESSION_QUERY);
            setSession(data?.whatsappSession || null);
            setError(null);
            return data?.whatsappSession || null;
        } catch (err) {
            setError(err);
            return null;
        } finally{
            setLoading(false);
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        refetch();
    }, [
        refetch
    ]);
    const stopPairing = (0, $acw62.useCallback)(()=>{
        // Aborting closes the HTTP response, which the BFF turns into a gRPC cancel. Without
        // it the gateway holds a fresh, half-linked device open for the full three-minute
        // window and the clinic's phone accumulates abandoned entries in «linked devices».
        controller.current?.abort();
        controller.current = null;
        setPairing(null);
    }, []);
    // Whatever happens — a tab closed, a route change, a component unmounted — the stream
    // must not outlive the screen that opened it.
    (0, $acw62.useEffect)(()=>()=>{
            controller.current?.abort();
        }, []);
    // DISCONNECTED is transient and recovers on its own (the service README says so),
    // which is why the compose dialog asks to watch it: an operator who fixes the link in
    // another tab, or simply waits, must see the channel become selectable without
    // closing and reopening the dialog. Opt-in, because a settings screen has no such
    // need and a poll nobody is watching is a request nobody wanted. PAIRING is NOT
    // polled here — the stream above delivers it.
    (0, $acw62.useEffect)(()=>{
        if (!pollWhileDisconnected || session?.state !== 'DISCONNECTED') return undefined;
        const timer = setInterval(refetch, 2500);
        return ()=>clearInterval(timer);
    }, [
        pollWhileDisconnected,
        session?.state,
        refetch
    ]);
    const startLink = (0, $acw62.useCallback)(async (method, phone)=>{
        stopPairing();
        // A new attempt clears the last one's failure. Without this the screen keeps
        // reporting a gateway that was down two minutes ago while a code is on the way.
        setError(null);
        const token = await $5e9913c85df4bacb$var$validToken();
        if (!token) throw new Error('Not authenticated');
        const url = new URL($5e9913c85df4bacb$var$PAIRING_PATH, (0, $iAkVL.BFF_URL));
        url.searchParams.set('method', method === 'PAIRING_CODE' ? 'PAIRING_CODE' : 'QR');
        if (phone) url.searchParams.set('phone', phone);
        const ctrl = new AbortController();
        controller.current = ctrl;
        // The clinic this pairing is FOR, from the `/c/:ref/…` route — the same header
        // bffClient puts on every GraphQL call. Without it the BFF inferred the doctor's
        // default clinic, so someone in two clinics linked a phone to clinic A while
        // clinic B's panel, which does send the header, went on reading «متصل نیست».
        const clinicRef = (0, $1k2zw.getActiveClinicRef)();
        const res = await fetch(url.toString(), {
            headers: {
                Authorization: `Bearer ${token}`,
                Accept: 'text/event-stream',
                ...clinicRef ? {
                    'x-active-clinic-id': clinicRef
                } : {}
            },
            signal: ctrl.signal
        });
        if (!res.ok || !res.body) {
            const body = await res.json().catch(()=>null);
            controller.current = null;
            // The BFF's own sentence when it has one — it knows whether this was a missing
            // permission, a missing clinic or an unreachable gateway, and the screen does
            // not. An EMPTY message on purpose otherwise: copy belongs in the catalogue, so
            // the caller falls back to its own translated string rather than to a Persian
            // literal frozen into a hook.
            throw new Error(body?.error || '');
        }
        setPairing({
            kind: 'CONNECTING',
            code: '',
            expiresAt: null,
            message: ''
        });
        // Deliberately not awaited: the stream lives for as long as the pairing does, and
        // the caller needs its button back the moment the first code can start arriving.
        $5e9913c85df4bacb$var$readStream(res.body, ctrl, controller, {
            setPairing: setPairing,
            refetch: refetch,
            setError: setError
        });
        return true;
    }, [
        refetch,
        stopPairing
    ]);
    const unlink = (0, $acw62.useCallback)(async ()=>{
        stopPairing();
        await (0, $2Mst8.bffMutation)($5e9913c85df4bacb$var$UNLINK);
        await refetch();
    }, [
        refetch,
        stopPairing
    ]);
    return {
        session: session,
        loading: loading,
        error: error,
        pairing: pairing,
        refetch: refetch,
        startLink: startLink,
        stopPairing: stopPairing,
        unlink: unlink,
        canSend: $5e9913c85df4bacb$export$d93f6ed7ecacb902(session)
    };
}
async function $5e9913c85df4bacb$var$validToken() {
    let token = (0, $58BYB.getToken)();
    if (!token) return null;
    if ((0, $58BYB.isTokenExpired)(token)) {
        if (!await (0, $58BYB.refreshAccessToken)()) return null;
        token = (0, $58BYB.getToken)();
    }
    return token;
}
/**
 * Reads SSE frames off the response body.
 *
 * Frames are separated by a blank line and a frame's `data:` is one JSON object. Lines
 * beginning `:` are the server's keep-alive comments and carry nothing — they exist so
 * an intermediary does not close a connection that is idle between two QR codes.
 */ async function $5e9913c85df4bacb$var$readStream(body, ctrl, controller, { setPairing: setPairing, refetch: refetch, setError: setError }) {
    const reader = body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';
    try {
        for(;;){
            const { value: value, done: done } = await reader.read();
            if (done) break;
            buffer += decoder.decode(value, {
                stream: true
            });
            let split;
            while((split = buffer.indexOf('\n\n')) >= 0){
                const frame = buffer.slice(0, split);
                buffer = buffer.slice(split + 2);
                const parsed = $5e9913c85df4bacb$var$parseFrame(frame);
                if (!parsed) continue;
                if (parsed.event === 'error') {
                    // Server copy, or nothing — see the comment on the failed-response branch.
                    setError(new Error(parsed.data?.message || ''));
                    setPairing(null);
                    continue;
                }
                const { kind: kind, code: code, expiresInSeconds: expiresInSeconds, message: message } = parsed.data || {};
                if (kind === 'SUCCESS') {
                    setPairing(null);
                    await refetch();
                    continue;
                }
                if (kind === 'TIMEOUT' || kind === 'ERROR') {
                    setPairing({
                        kind: kind,
                        code: '',
                        expiresAt: null,
                        message: message || ''
                    });
                    continue;
                }
                setPairing({
                    kind: kind || 'QR',
                    code: code || '',
                    // An absolute instant, not a countdown: a component that re-renders for its
                    // own reasons must not restart the clock.
                    expiresAt: expiresInSeconds > 0 ? new Date(Date.now() + expiresInSeconds * 1000).toISOString() : null,
                    message: message || ''
                });
            }
        }
    } catch (err) {
        // An abort is this hook's own doing — the operator navigated away — and is not a
        // failure to report.
        if (err?.name !== 'AbortError') setError(err);
    } finally{
        // The stream that just finished may not be the one now in flight: pressing «اتصال»
        // twice aborts the first, and its cleanup must not wipe the second one's code off
        // the screen.
        if (controller.current === ctrl) {
            controller.current = null;
            setPairing(null);
        }
    }
}
function $5e9913c85df4bacb$var$parseFrame(frame) {
    let event = 'message';
    const data = [];
    for (const line of frame.split('\n')){
        if (!line || line.startsWith(':')) continue;
        if (line.startsWith('event:')) event = line.slice(6).trim();
        else if (line.startsWith('data:')) data.push(line.slice(5).trim());
    }
    if (!data.length) return null;
    try {
        return {
            event: event,
            data: JSON.parse(data.join('\n'))
        };
    } catch  {
        return null;
    }
}
var $5e9913c85df4bacb$export$2e2bcd8739ae039 = $5e9913c85df4bacb$export$9f5453a079f8d8f8;

});


parcelRegister("iNs7v", function(module, exports) {

$parcel$export(module.exports, "useAppointmentNotificationSettings", () => $daf29da851c43e90$export$92bb4c6a16f6977a);

var $acw62 = parcelRequire("acw62");

var $2Mst8 = parcelRequire("2Mst8");
const $daf29da851c43e90$var$FIELDS = 'channels templateId defaultBody isDefault updatedAt template { id title body } rescheduleTemplateId defaultRescheduleBody rescheduleTemplate { id title body }';
const $daf29da851c43e90$export$6530187ae157b3cc = `
  query AppointmentNotificationSettings {
    appointmentNotificationSettings { ${$daf29da851c43e90$var$FIELDS} }
  }
`;
const $daf29da851c43e90$var$UPDATE = `
  mutation UpdateAppointmentNotificationSettings($input: AppointmentNotificationSettingsInput!) {
    updateAppointmentNotificationSettings(input: $input) { ${$daf29da851c43e90$var$FIELDS} }
  }
`;
function $daf29da851c43e90$export$92bb4c6a16f6977a({ enabled: enabled = true } = {}) {
    const [settings, setSettings] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(enabled);
    const [error, setError] = (0, $acw62.useState)(null);
    const reload = (0, $acw62.useCallback)(async ()=>{
        if (!enabled) {
            setLoading(false);
            return;
        }
        setLoading(true);
        try {
            const data = await (0, $2Mst8.bffQuery)($daf29da851c43e90$export$6530187ae157b3cc);
            setSettings(data?.appointmentNotificationSettings || null);
            setError(null);
        } catch (err) {
            setError(err?.message || String(err));
        } finally{
            setLoading(false);
        }
    }, [
        enabled
    ]);
    (0, $acw62.useEffect)(()=>{
        reload();
    }, [
        reload
    ]);
    /**
   * Saves `{ channels, templateId, rescheduleTemplateId }`; returns what the server
   * wrote. `rescheduleTemplateId` left undefined is not sent, which the server reads as
   * «unchanged».
   */ const save = (0, $acw62.useCallback)(async ({ channels: channels, templateId: templateId, rescheduleTemplateId: rescheduleTemplateId })=>{
        const input = {
            channels: channels || [],
            templateId: templateId || null
        };
        if (rescheduleTemplateId !== undefined) input.rescheduleTemplateId = rescheduleTemplateId || null;
        const data = await (0, $2Mst8.bffMutation)($daf29da851c43e90$var$UPDATE, {
            input: input
        });
        const next = data?.updateAppointmentNotificationSettings || null;
        if (next) setSettings(next);
        return next;
    }, []);
    return {
        settings: settings,
        loading: loading,
        error: error,
        reload: reload,
        save: save
    };
}
var $daf29da851c43e90$export$2e2bcd8739ae039 = $daf29da851c43e90$export$92bb4c6a16f6977a;

});

parcelRegister("jVdQx", function(module, exports) {

$parcel$export(module.exports, "usePhoneCandidates", () => $e80e14cfde1ef7f4$export$7c328c1bba90a599);
$parcel$export(module.exports, "usePhoneListCandidates", () => $e80e14cfde1ef7f4$export$382901477c6200ee);

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $5AX1S = parcelRequire("5AX1S");

var $2Mst8 = parcelRequire("2Mst8");

var $6P09x = parcelRequire("6P09x");
const $e80e14cfde1ef7f4$var$NONE = Object.freeze([]);
function $e80e14cfde1ef7f4$export$7c328c1bba90a599(raw, { delay: delay = 400 } = {}) {
    const number = raw ? (0, $5AX1S).normalizePhone(String(raw).trim()) || '' : '';
    const cache = (0, $acw62.useRef)(new Map());
    const [, rerender] = (0, $acw62.useReducer)((n)=>n + 1, 0);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (!number || cache.current.has(number)) {
            setLoading(false);
            return undefined;
        }
        let live = true;
        setLoading(true);
        const timer = setTimeout(async ()=>{
            try {
                const data = await (0, $2Mst8.bffQuery)((0, $6P09x.LOOKUP_PATIENTS_BY_PHONE), {
                    phone: number
                });
                cache.current.set(number, data?.lookupPatientsByPhone?.candidates || $e80e14cfde1ef7f4$var$NONE);
            } catch  {
            // Not cached, so the next visit to this number asks again.
            } finally{
                if (live) {
                    setLoading(false);
                    rerender();
                }
            }
        }, delay);
        return ()=>{
            live = false;
            clearTimeout(timer);
        };
    }, [
        number,
        delay
    ]);
    const seed = (0, $acw62.useCallback)((n, candidates)=>{
        const key = (0, $5AX1S).normalizePhone(String(n || '').trim()) || '';
        if (!key) return;
        cache.current.set(key, candidates || $e80e14cfde1ef7f4$var$NONE);
        rerender();
    }, []);
    return {
        number: number,
        candidates: number && cache.current.get(number) || $e80e14cfde1ef7f4$var$NONE,
        loading: loading && !!number,
        seed: seed
    };
}
function $e80e14cfde1ef7f4$export$382901477c6200ee(numbers, { delay: delay = 400, except: except = null } = {}) {
    const keys = (numbers || []).map((raw)=>raw ? (0, $5AX1S).normalizePhone(String(raw).trim()) || '' : '');
    const wanted = [
        ...new Set(keys.filter(Boolean))
    ].join('|');
    const cache = (0, $acw62.useRef)(new Map());
    const inflight = (0, $acw62.useRef)(new Set());
    const failed = (0, $acw62.useRef)(new Set());
    const live = (0, $acw62.useRef)(true);
    const [, rerender] = (0, $acw62.useReducer)((n)=>n + 1, 0);
    (0, $acw62.useEffect)(()=>()=>{
            live.current = false;
        }, []);
    (0, $acw62.useEffect)(()=>{
        failed.current.clear();
        const todo = wanted ? wanted.split('|').filter((k)=>!cache.current.has(k)) : [];
        if (!todo.length) return undefined;
        const timer = setTimeout(()=>{
            for (const key of todo){
                if (cache.current.has(key) || inflight.current.has(key)) continue;
                inflight.current.add(key);
                (0, $2Mst8.bffQuery)((0, $6P09x.LOOKUP_PATIENTS_BY_PHONE), {
                    phone: key
                }).then((data)=>{
                    cache.current.set(key, data?.lookupPatientsByPhone?.candidates || $e80e14cfde1ef7f4$var$NONE);
                }).catch(()=>{
                    failed.current.add(key);
                }).finally(()=>{
                    inflight.current.delete(key);
                    if (live.current) rerender();
                });
            }
        }, delay);
        return ()=>clearTimeout(timer);
    }, [
        wanted,
        delay
    ]);
    const state = (0, $acw62.useCallback)((raw)=>{
        const number = raw ? (0, $5AX1S).normalizePhone(String(raw).trim()) || '' : '';
        const found = number ? cache.current.get(number) : undefined;
        const candidates = found ? found.filter((c)=>c.patientId !== except) : $e80e14cfde1ef7f4$var$NONE;
        return {
            number: number,
            candidates: candidates,
            loading: !!number && !found && !failed.current.has(number),
            failed: !!number && failed.current.has(number)
        };
    }, [
        except
    ]);
    const seed = (0, $acw62.useCallback)((n, candidates)=>{
        const key = (0, $5AX1S).normalizePhone(String(n || '').trim()) || '';
        if (!key) return;
        cache.current.set(key, candidates || $e80e14cfde1ef7f4$var$NONE);
        failed.current.delete(key);
        rerender();
    }, []);
    const markLinked = (0, $acw62.useCallback)((n, patientId)=>{
        const key = (0, $5AX1S).normalizePhone(String(n || '').trim()) || '';
        const list = cache.current.get(key);
        if (!list) return;
        cache.current.set(key, list.map((c)=>c.patientId === patientId ? {
                ...c,
                isLinkedToThisClinic: true
            } : c));
        rerender();
    }, []);
    return {
        state: state,
        seed: seed,
        markLinked: markLinked
    };
}
var $e80e14cfde1ef7f4$export$2e2bcd8739ae039 = $e80e14cfde1ef7f4$export$7c328c1bba90a599;

});

parcelRegister("jmIrn", function(module, exports) {

$parcel$export(module.exports, "default", () => $13dd2c147dec1423$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("5N0ZI");
var $9cQDs = parcelRequire("9cQDs");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");
function $13dd2c147dec1423$export$2e2bcd8739ae039({ messages: messages, ...props }) {
    const { t: t, locale: locale } = (0, $e1LEq.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9cQDs.default), {
        locale: locale,
        messages: {
            // The kit hands both values over already in the page's digits.
            birthYear: (year)=>t('patients.phoneCandidates.birthYear', {
                    year: year
                }),
            fileNumber: (number)=>t('patients.phoneCandidates.fileNumber', {
                    number: number
                }),
            male: t('common.gender.male'),
            female: t('common.gender.female'),
            hasAppAccount: t('patients.phoneCandidates.hasAppAccount'),
            inYourList: t('patients.origin.inYourList'),
            alreadyInList: t('patients.phoneCandidates.alreadyInList'),
            addToList: t('patients.phoneCandidates.addToList'),
            adding: t('patients.phoneCandidates.adding'),
            linkFailed: t('patients.phoneCandidates.linkFailed'),
            newOnSameNumber: t('patients.phoneCandidates.newOnSameNumber'),
            matchedOther: t('patients.phones.matchedOther'),
            ...messages
        },
        ...props
    });
}

});

parcelRegister("dNtjz", function(module, exports) {

$parcel$export(module.exports, "fetchBookableSlots", () => $a0b697425024452c$export$4bc5424c754f242e);
$parcel$export(module.exports, "useBookableSlots", () => $a0b697425024452c$export$2836071ed5187b7f);

var $acw62 = parcelRequire("acw62");

var $2Mst8 = parcelRequire("2Mst8");
const $a0b697425024452c$export$30c4abbfe9faa04d = `
  query BookableSlots($serviceCatalogId: ID, $providerType: String!, $providerId: ID!, $fromDate: String!, $days: Int, $durationMinutes: Int!, $fit: String) {
    bookableSlots(serviceCatalogId: $serviceCatalogId, providerType: $providerType, providerId: $providerId, fromDate: $fromDate, days: $days, durationMinutes: $durationMinutes, fit: $fit) {
      date
      slots { startMs free reason }
    }
  }
`;
const $a0b697425024452c$export$50b579764bb3a9a = (performer)=>String(performer?.type || 'DOCTOR').toUpperCase() === 'STAFF' ? 'staff' : 'doctor';
async function $a0b697425024452c$export$4bc5424c754f242e({ serviceCatalogId: serviceCatalogId = null, performer: performer, fromDate: fromDate, days: days = 14, durationMinutes: durationMinutes, fit: fit = 'START_INSIDE' }) {
    const d = await (0, $2Mst8.bffQuery)($a0b697425024452c$export$30c4abbfe9faa04d, {
        serviceCatalogId: serviceCatalogId || null,
        providerType: $a0b697425024452c$export$50b579764bb3a9a(performer),
        providerId: performer.id,
        fromDate: fromDate,
        days: days,
        durationMinutes: durationMinutes,
        fit: fit
    }, 'BookableSlots');
    return d?.bookableSlots || [];
}
function $a0b697425024452c$export$2836071ed5187b7f({ enabled: enabled = true, serviceCatalogId: serviceCatalogId = null, performer: performer = null, fromDate: fromDate, days: days = 14, durationMinutes: durationMinutes = null, fit: fit = 'START_INSIDE', refreshKey: refreshKey = 0 } = {}) {
    const [data, setData] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    const ready = !!enabled && !!performer?.id && !!fromDate && Number(durationMinutes) > 0;
    const performerKey = performer ? `${performer.type}:${performer.id}` : '';
    const load = (0, $acw62.useCallback)(async ()=>{
        if (!ready) {
            setData([]);
            setError(null);
            setLoading(false);
            return;
        }
        setLoading(true);
        try {
            const rows = await $a0b697425024452c$export$4bc5424c754f242e({
                serviceCatalogId: serviceCatalogId,
                performer: performer,
                fromDate: fromDate,
                days: days,
                durationMinutes: durationMinutes,
                fit: fit
            });
            setData(rows);
            setError(null);
        } catch (e) {
            setData([]);
            setError(e?.message || 'bookableSlots');
        } finally{
            setLoading(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ready,
        serviceCatalogId,
        performerKey,
        fromDate,
        days,
        durationMinutes,
        fit,
        refreshKey
    ]);
    (0, $acw62.useEffect)(()=>{
        load();
    }, [
        load
    ]);
    return {
        days: data,
        loading: loading,
        error: error,
        reload: load,
        ready: ready
    };
}
var $a0b697425024452c$export$2e2bcd8739ae039 = $a0b697425024452c$export$2836071ed5187b7f;

});

parcelRegister("gXHpd", function(module, exports) {

$parcel$export(module.exports, "servicePerformers", () => $c593d3816c42df04$export$79da7d073b7bcbab);
$parcel$export(module.exports, "performerKind", () => $c593d3816c42df04$export$2bed4fdaf08a1a60);
$parcel$export(module.exports, "groupBookableServices", () => $c593d3816c42df04$export$7aaa298a4d639837);
$parcel$export(module.exports, "entryFromOrder", () => $c593d3816c42df04$export$8980991c6fd76412);
$parcel$export(module.exports, "performerRow", () => $c593d3816c42df04$export$71d8aa2c557276b0);
$parcel$export(module.exports, "resolveDuration", () => $c593d3816c42df04$export$d098e094ceff10d2);
$parcel$export(module.exports, "defaultPerformer", () => $c593d3816c42df04$export$741ad3e168ea685d);
$parcel$export(module.exports, "defaultEntry", () => $c593d3816c42df04$export$46b87782c410d089);
$parcel$export(module.exports, "firstFree", () => $c593d3816c42df04$export$7ae7ab75c86dda63);
$parcel$export(module.exports, "nextFree", () => $c593d3816c42df04$export$adc09bb5719024b3);
$parcel$export(module.exports, "slotsOn", () => $c593d3816c42df04$export$6718be91b868c0c4);
$parcel$export(module.exports, "gridSlots", () => $c593d3816c42df04$export$361a83d2c9a4726d);
$parcel$export(module.exports, "mapBookingError", () => $c593d3816c42df04$export$335cf8487c2a0265);
$parcel$export(module.exports, "newRequestId", () => $c593d3816c42df04$export$735d967b73ba0c93);
/**
 * The desk's «ثبت نوبت» on the slot ENGINE (PM-0468 §2.4 / §4.3,
 * docs/SERVICE_OFFERING_AND_BOOKING_DESIGN.md). Pure helpers — no React, no
 * network — so the dialog's decisions can be proved in isolation:
 *
 *   • which service rows form ONE pickable entry («ویزیت» is many per-doctor
 *     declarations on one catalogue row);
 *   • who performs it, and which row prices THAT performer;
 *   • how long it takes, and where that number came from (PM-0160 §7);
 *   • the first free instant and the next few after a refused one;
 *   • the engine's `reason` on a cell, as the kit `SlotGrid` wants it;
 *   • which FIELD a server refusal belongs to.
 *
 * Nothing here guesses a time: instants come from `bookableSlots` (anchored at
 * the shift start on the clinic's clock) and are never built with `setHours`.
 */ /**
 * The people an entry's service may be given to — its performers.
 *
 * The declaration names them as a doctor, a staff member or a group, and the
 * BFF has already expanded a group to its holders (`members`). Inactive people
 * are dropped, duplicates across groups merged, and the declaration's default
 * comes first. `role` is the group's name when the person came in through one
 * («فیزیوتراپیست»), which says more than «همکار».
 */ function $c593d3816c42df04$export$79da7d073b7bcbab(source) {
    const seen = new Map();
    for (const perf of source?.performers || [])for (const m of perf.members || []){
        if (m.active === false) continue;
        const key = `${m.type}:${m.id}`;
        const prev = seen.get(key);
        const isDefault = !!(perf.isDefault && perf.type !== 'ROLE');
        if (!prev) seen.set(key, {
            key: key,
            type: m.type,
            id: m.id,
            name: m.name || m.id,
            isDefault: isDefault,
            role: perf.type === 'ROLE' ? perf.label : ''
        });
        else {
            prev.isDefault = prev.isDefault || isDefault;
            if (!prev.role && perf.type === 'ROLE') prev.role = perf.label;
        }
    }
    return [
        ...seen.values()
    ].sort((a, b)=>Number(b.isDefault) - Number(a.isDefault));
}
const $c593d3816c42df04$export$2bed4fdaf08a1a60 = (p, t)=>p.role || (p.type === 'DOCTOR' ? t('common.entity.doctor') : t('reception.paraclinic.coworker'));
function $c593d3816c42df04$export$7aaa298a4d639837(rows) {
    const byCatalog = new Map();
    for (const row of rows || []){
        if (!row?.catalogId || row.isActive === false) continue;
        const key = String(row.catalogId);
        let entry = byCatalog.get(key);
        if (!entry) {
            entry = {
                catalogId: key,
                name: row.name,
                orderType: row.orderType || null,
                schedulingMode: row.schedulingMode || 'TIMED',
                rows: [],
                performers: []
            };
            byCatalog.set(key, entry);
        }
        entry.rows.push(row);
        // A doctor's own price row names only them; the union keeps everyone once.
        const people = $c593d3816c42df04$export$79da7d073b7bcbab(row);
        for (const p of people){
            if (!entry.performers.some((q)=>q.key === p.key)) entry.performers.push(p);
            else if (p.isDefault) entry.performers.find((q)=>q.key === p.key).isDefault = true;
        }
    }
    const entries = [
        ...byCatalog.values()
    ].map((e)=>({
            ...e,
            performers: [
                ...e.performers
            ].sort((a, b)=>Number(b.isDefault) - Number(a.isDefault))
        }));
    return {
        visits: entries.filter((e)=>e.orderType === 'consultation'),
        services: entries.filter((e)=>e.orderType !== 'consultation')
    };
}
function $c593d3816c42df04$export$8980991c6fd76412(order) {
    if (!order) return null;
    return {
        catalogId: String(order.catalogId || order.declarationId || ''),
        name: order.description || '',
        orderType: order.orderType || null,
        schedulingMode: order.schedulingMode || (order.requiresAppointment === false ? 'QUEUE' : 'TIMED'),
        rows: [
            {
                declarationId: order.declarationId,
                catalogId: order.catalogId,
                doctorId: null,
                // A session's length is the DECLARATION's (bookServiceSession reads it there);
                // an order row that predates the field carries none, and the engine still
                // needs a number to draw the grid — 30 is the declaration default it was
                // written with, not a guess about the service.
                durationMinutes: order.durationMinutes || 30,
                durationSource: order.durationMinutes ? 'SERVICE' : 'UNSET',
                unitPrice: order.unitPrice,
                currency: order.currency
            }
        ],
        performers: $c593d3816c42df04$export$79da7d073b7bcbab(order),
        order: order
    };
}
function $c593d3816c42df04$export$71d8aa2c557276b0(entry, performer) {
    const rows = entry?.rows || [];
    if (!rows.length) return null;
    if (performer?.type === 'DOCTOR') return rows.find((r)=>r.doctorId === performer.id) || rows.find((r)=>!r.doctorId) || rows[0];
    return rows.find((r)=>!r.doctorId) || rows[0];
}
function $c593d3816c42df04$export$d098e094ceff10d2(entry, performer, doctorRow) {
    const row = $c593d3816c42df04$export$71d8aa2c557276b0(entry, performer);
    if (row && Number(row.durationMinutes) > 0) return {
        minutes: Number(row.durationMinutes),
        source: 'SERVICE'
    };
    if (performer?.type === 'DOCTOR' && doctorRow) return {
        minutes: Number(doctorRow.visitDurationMinutes) > 0 ? Number(doctorRow.visitDurationMinutes) : 30,
        source: 'DOCTOR'
    };
    return {
        minutes: null,
        source: null
    };
}
function $c593d3816c42df04$export$741ad3e168ea685d(people, presetId = null) {
    if (!people?.length) return null;
    if (presetId) {
        const hit = people.find((p)=>p.id === presetId);
        if (hit) return hit;
    }
    return people.find((p)=>p.isDefault) || people[0];
}
function $c593d3816c42df04$export$46b87782c410d089(groups, presetCatalogId = null) {
    const all = [
        ...groups?.visits || [],
        ...groups?.services || []
    ];
    if (presetCatalogId) {
        const hit = all.find((e)=>e.catalogId === String(presetCatalogId));
        if (hit) return hit;
    }
    return groups?.visits?.[0] || groups?.services?.[0] || null;
}
function $c593d3816c42df04$export$7ae7ab75c86dda63(days, nowMs = Date.now()) {
    for (const day of days || [])for (const s of day.slots || []){
        if (s.free && Number(s.startMs) > nowMs) return {
            startMs: Number(s.startMs),
            date: day.date
        };
    }
    return null;
}
function $c593d3816c42df04$export$adc09bb5719024b3(days, afterMs, n = 3) {
    const out = [];
    for (const day of days || []){
        for (const s of day.slots || [])if (s.free && Number(s.startMs) > afterMs) {
            out.push({
                startMs: Number(s.startMs),
                date: day.date
            });
            if (out.length >= n) return out;
        }
    }
    return out;
}
function $c593d3816c42df04$export$6718be91b868c0c4(days, iso) {
    return (days || []).find((d)=>d.date === iso)?.slots || [];
}
function $c593d3816c42df04$export$361a83d2c9a4726d(slots, { formatTime: formatTime, t: t, nowMs: nowMs = Date.now() } = {}) {
    return (slots || []).map((s)=>{
        const past = Number(s.startMs) <= nowMs;
        const reason = past && s.free ? 'PAST' : s.free ? null : s.reason || 'BUSY';
        const mark = reason === 'OUTSIDE_SERVICE_WINDOW';
        return {
            value: String(s.startMs),
            label: formatTime ? formatTime(Number(s.startMs)) : String(s.startMs),
            disabled: !!reason && !mark,
            held: mark,
            reason: reason,
            title: reason && t ? t(`reception.booking.reason.${reason}`) : undefined
        };
    });
}
function $c593d3816c42df04$export$335cf8487c2a0265(e, t) {
    const code = e?.extensions?.code || '';
    const message = e?.message || t('errors.reception.bookFailed');
    if (code === 'SERVICE_NOT_IN_SHIFT') return {
        field: 'time',
        code: code,
        message: message
    };
    if (code === 'PROVIDER_NOT_PRESENT' || code === 'DOCTOR_NOT_PRESENT') return {
        field: 'performer',
        code: code,
        message: message
    };
    if (code === 'APPOINTMENT_CONFLICT') return {
        field: 'time',
        code: code,
        message: t('reception.booking.doctorBusy'),
        nextFree: true
    };
    if (code === 'NO_SLOT_AVAILABLE') return {
        field: 'time',
        code: code,
        message: t('reception.booking.noSlotToday')
    };
    if (code === 'PERFORMER_NOT_ALLOWED' || code === 'PERFORMER_IS_A_GROUP') return {
        field: 'performer',
        code: code,
        message: message
    };
    return {
        field: 'form',
        code: code,
        message: message
    };
}
function $c593d3816c42df04$export$735d967b73ba0c93() {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
    return `req-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}

});

parcelRegister("wuSZs", function(module, exports) {

$parcel$export(module.exports, "usePrepaymentPolicy", () => $061af293fd599890$export$6e9daa9dec8bee24);
$parcel$export(module.exports, "usePrepaymentMode", () => $061af293fd599890$export$a1ce992017bba9e7);

var $acw62 = parcelRequire("acw62");

var $2Mst8 = parcelRequire("2Mst8");

var $ett75 = parcelRequire("ett75");
const $061af293fd599890$export$b8c6e5196d5c2777 = `
  mode amountMode fixedAmountRial percent refundWindowHours
  noShowOutcome noShowFeePercent isDefault currency
`;
const $061af293fd599890$export$1bbdf0a8b973033f = `
  query PrepaymentPolicy {
    prepaymentPolicy { ${$061af293fd599890$export$b8c6e5196d5c2777} }
  }
`;
const $061af293fd599890$export$5d7d34ee26002cb = `
  mutation UpdatePrepaymentPolicy($input: PrepaymentPolicyInput!) {
    updatePrepaymentPolicy(input: $input) { ${$061af293fd599890$export$b8c6e5196d5c2777} }
  }
`;
const $061af293fd599890$var$TTL_MS = 300000;
// clinicId → { promise, value, at } — `value` once answered.
const $061af293fd599890$var$answers = new Map();
const $061af293fd599890$var$listeners = new Set();
function $061af293fd599890$var$load(clinicId, { force: force = false } = {}) {
    const hit = $061af293fd599890$var$answers.get(clinicId);
    if (!force && hit && (!('value' in hit) || Date.now() - hit.at < $061af293fd599890$var$TTL_MS)) return hit.promise;
    const entry = {};
    entry.promise = (0, $2Mst8.bffQuery)($061af293fd599890$export$1bbdf0a8b973033f, {}, 'PrepaymentPolicy').then((data)=>{
        const value = data?.prepaymentPolicy && typeof data.prepaymentPolicy === 'object' ? data.prepaymentPolicy : null;
        if (!value) throw new Error('prepaymentPolicy missing');
        entry.value = value;
        entry.at = Date.now();
        return value;
    }).catch((err)=>{
        $061af293fd599890$var$answers.delete(clinicId);
        throw err;
    });
    $061af293fd599890$var$answers.set(clinicId, entry);
    return entry.promise;
}
function $061af293fd599890$var$known(clinicId) {
    const hit = clinicId ? $061af293fd599890$var$answers.get(clinicId) : null;
    return hit && 'value' in hit ? hit.value : null;
}
function $061af293fd599890$var$remember(clinicId, value) {
    $061af293fd599890$var$answers.set(clinicId, {
        promise: Promise.resolve(value),
        value: value,
        at: Date.now()
    });
    $061af293fd599890$var$listeners.forEach((fn)=>fn(clinicId, value));
}
function $061af293fd599890$export$b01b7ad863fed763() {
    $061af293fd599890$var$answers.clear();
}
function $061af293fd599890$export$6e9daa9dec8bee24() {
    const clinic = (0, $ett75.useOptionalClinicContext)();
    const clinicId = clinic?.activeMembership?.clinicId || '';
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>({
            clinicId: clinicId,
            policy: $061af293fd599890$var$known(clinicId),
            loading: !$061af293fd599890$var$known(clinicId),
            error: null
        }));
    const fetchPolicy = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((force = false)=>{
        if (!clinicId) {
            setState({
                clinicId: clinicId,
                policy: null,
                loading: false,
                error: null
            });
            return undefined;
        }
        let live = true;
        setState((prev)=>({
                ...prev,
                clinicId: clinicId,
                loading: !$061af293fd599890$var$known(clinicId) || force,
                error: null
            }));
        $061af293fd599890$var$load(clinicId, {
            force: force
        }).then((policy)=>{
            if (live) setState({
                clinicId: clinicId,
                policy: policy,
                loading: false,
                error: null
            });
        }, (error)=>{
            if (live) setState({
                clinicId: clinicId,
                policy: null,
                loading: false,
                error: error
            });
        });
        return ()=>{
            live = false;
        };
    }, [
        clinicId
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>fetchPolicy(false), [
        fetchPolicy
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const fn = (id, policy)=>{
            if (id === clinicId) setState({
                clinicId: clinicId,
                policy: policy,
                loading: false,
                error: null
            });
        };
        $061af293fd599890$var$listeners.add(fn);
        return ()=>{
            $061af293fd599890$var$listeners.delete(fn);
        };
    }, [
        clinicId
    ]);
    const reload = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        fetchPolicy(true);
    }, [
        fetchPolicy
    ]);
    const save = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (input)=>{
        const data = await (0, $2Mst8.bffMutation)($061af293fd599890$export$5d7d34ee26002cb, {
            input: input
        }, 'UpdatePrepaymentPolicy');
        const policy = data?.updatePrepaymentPolicy || null;
        if (policy && clinicId) $061af293fd599890$var$remember(clinicId, policy);
        return policy;
    }, [
        clinicId
    ]);
    const current = state.clinicId === clinicId ? state : {
        policy: $061af293fd599890$var$known(clinicId),
        loading: !$061af293fd599890$var$known(clinicId),
        error: null
    };
    return {
        policy: current.policy,
        loading: current.loading,
        error: current.error,
        reload: reload,
        save: save
    };
}
function $061af293fd599890$export$a1ce992017bba9e7() {
    const { policy: policy } = $061af293fd599890$export$6e9daa9dec8bee24();
    return policy?.mode || 'OFF';
}
var $061af293fd599890$export$2e2bcd8739ae039 = $061af293fd599890$export$6e9daa9dec8bee24;

});

parcelRegister("j5293", function(module, exports) {

$parcel$export(module.exports, "useBookingDeposit", () => $99704f3c7a00de75$export$9d8b2e4f371f4d88);
$parcel$export(module.exports, "depositFieldError", () => $99704f3c7a00de75$export$e6a91f0b875cee22);
$parcel$export(module.exports, "BookingDepositBlock", () => $99704f3c7a00de75$export$ab7e26ed87733881);
$parcel$export(module.exports, "DepositAfterBookingFailed", () => $99704f3c7a00de75$export$c870f3167d018d42);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $aJ1FU = parcelRequire("aJ1FU");
var $hZDga = parcelRequire("hZDga");
parcelRequire("7c6z4");
var $gVWNP = parcelRequire("gVWNP");
var $e1LEq = parcelRequire("e1LEq");
parcelRequire("52bn2");
var $jTCZr = parcelRequire("jTCZr");

var $2xQve = parcelRequire("2xQve");

var $5OgPq = parcelRequire("5OgPq");

var $5pHac = parcelRequire("5pHac");

var $eP0nH = parcelRequire("eP0nH");

var $eatxv = parcelRequire("eatxv");
function $99704f3c7a00de75$export$9d8b2e4f371f4d88({ policy: policy, priceRial: priceRial, applies: applies = true }) {
    const { parseMoney: parseMoney, toDisplayAmount: toDisplayAmount } = (0, $e1LEq.default)();
    const mode = policy?.mode || 'OFF';
    const shown = !!applies && mode !== 'OFF';
    const required = shown && mode === 'REQUIRED';
    const [opened, setOpened] = (0, $acw62.useState)(false);
    const open = shown && (required || opened);
    const suggested = (0, $eP0nH.suggestedDepositRial)(policy, priceRial);
    const [amountText, setAmountTextRaw] = (0, $acw62.useState)('');
    const [edited, setEdited] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (edited) return;
        setAmountTextRaw(suggested ? String(toDisplayAmount(suggested)) : '');
    }, [
        suggested,
        edited,
        toDisplayAmount
    ]);
    const setAmountText = (v)=>{
        setEdited(true);
        setAmountTextRaw(v);
    };
    const [method, setMethod] = (0, $acw62.useState)((0, $5pHac.DEFAULT_PAYMENT_METHOD));
    const [reference, setReference] = (0, $acw62.useState)('');
    const [requestId, setRequestId] = (0, $acw62.useState)(()=>(0, $eatxv.newDepositRequestId)('booking-deposit'));
    // After a deposit was RECORDED, a form that stays open (the row's dialog) must
    // not send the same id again: accounting answers a repeated id with the first
    // write, so a second deposit would be cash taken with nothing recorded.
    const reset = ()=>{
        setRequestId((0, $eatxv.newDepositRequestId)('booking-deposit'));
        setEdited(false);
        setReference('');
    };
    const amountRial = open && amountText !== '' ? parseMoney(amountText) || 0 : 0;
    const wire = amountRial > 0 ? {
        amountRial: amountRial,
        paymentMethod: method,
        referenceNumber: reference.trim() || null,
        requestId: requestId
    } : null;
    return {
        mode: mode,
        shown: shown,
        required: required,
        open: open,
        setOpen: setOpened,
        amountText: amountText,
        setAmountText: setAmountText,
        method: method,
        setMethod: setMethod,
        reference: reference,
        setReference: setReference,
        amountRial: amountRial,
        wire: wire,
        requestId: requestId,
        reset: reset,
        // REQUIRED and nothing typed → the form asks once before booking (C9).
        needsConfirm: required && !(amountRial > 0)
    };
}
function $99704f3c7a00de75$export$e6a91f0b875cee22(t, deposit) {
    if (!deposit?.wire) return '';
    const meta = (0, $5pHac.PAYMENT_METHODS)(t)[deposit.method] || {};
    if (meta.needsRef && !String(deposit.reference || '').trim()) return meta.refLabel;
    return '';
}
const $99704f3c7a00de75$var$FIELD = {
    width: '100%',
    boxSizing: 'border-box',
    padding: '7px 9px',
    borderRadius: 7,
    border: `1px solid ${(0, $jTCZr.C).border}`,
    fontSize: '0.8125rem',
    fontFamily: 'inherit',
    color: (0, $jTCZr.C).textPrimary,
    background: 'var(--p-surface, #fff)'
};
const $99704f3c7a00de75$var$LABEL = {
    fontSize: '0.71875rem',
    fontWeight: 700,
    color: (0, $jTCZr.C).textMuted,
    marginBottom: 4,
    display: 'block'
};
function $99704f3c7a00de75$export$ab7e26ed87733881({ deposit: deposit, error: error = '', onTouch: onTouch, style: style }) {
    const { t: t, moneyUnit: moneyUnit } = (0, $e1LEq.default)();
    const methods = (0, $acw62.useMemo)(()=>(0, $5pHac.PAYMENT_METHODS)(t), [
        t
    ]);
    if (!deposit?.shown) return null;
    const touch = ()=>onTouch?.();
    const meta = methods[deposit.method] || {};
    if (!deposit.open) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
            type: "button",
            "data-testid": "booking-deposit-add",
            onClick: ()=>{
                deposit.setOpen(true);
                touch();
            },
            style: {
                border: 'none',
                background: 'none',
                padding: 0,
                fontFamily: 'inherit',
                fontSize: '0.78125rem',
                fontWeight: 700,
                color: 'var(--p-navy)',
                cursor: 'pointer'
            },
            children: t('reception.booking.deposit.add')
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": "booking-deposit",
        "data-mode": deposit.mode,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: (0, $2xQve.STACK).tight,
            padding: (0, $2xQve.ROW_PAD).compact,
            borderRadius: 10,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            ...style
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    fontSize: '0.8125rem',
                    fontWeight: 700,
                    color: (0, $jTCZr.C).textPrimary
                },
                children: t('reception.booking.deposit.title')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    gap: 8,
                    flexWrap: 'wrap'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            flex: 1,
                            minWidth: 140
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: $99704f3c7a00de75$var$LABEL,
                                children: t('reception.booking.deposit.amount', {
                                    unit: moneyUnit()
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5OgPq.default), {
                                value: deposit.amountText,
                                onChange: (v)=>{
                                    deposit.setAmountText(v);
                                    touch();
                                },
                                "aria-label": t('reception.booking.deposit.amount', {
                                    unit: moneyUnit()
                                }),
                                "data-testid": "booking-deposit-amount"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            flex: 1,
                            minWidth: 140
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: $99704f3c7a00de75$var$LABEL,
                                children: t('reception.booking.deposit.method')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("select", {
                                style: $99704f3c7a00de75$var$FIELD,
                                value: deposit.method,
                                onChange: (e)=>{
                                    deposit.setMethod(e.target.value);
                                    touch();
                                },
                                "aria-label": t('reception.booking.deposit.method'),
                                "data-testid": "booking-deposit-method",
                                children: Object.entries(methods).filter(([, m])=>m.enabled).map(([key, m])=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: key,
                                        children: m.label
                                    }, key))
                            })
                        ]
                    })
                ]
            }),
            meta.needsRef ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: $99704f3c7a00de75$var$LABEL,
                        children: meta.refLabel || t('reception.booking.deposit.reference')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        ...(0, $gVWNP.LTR_TEXT),
                        style: $99704f3c7a00de75$var$FIELD,
                        value: deposit.reference,
                        onChange: (e)=>{
                            deposit.setReference(e.target.value);
                            touch();
                        },
                        "aria-label": meta.refLabel || t('reception.booking.deposit.reference'),
                        "data-testid": "booking-deposit-reference"
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    fontSize: '0.71875rem',
                    color: (0, $jTCZr.C).textMuted,
                    lineHeight: 1.7
                },
                children: t('reception.booking.deposit.hint')
            }),
            error ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                role: "alert",
                "data-testid": "booking-deposit-error",
                style: {
                    fontSize: '0.75rem',
                    color: (0, $jTCZr.C).red
                },
                children: error
            }) : null
        ]
    });
}
function $99704f3c7a00de75$export$c870f3167d018d42({ reason: reason, retrying: retrying, onRetry: onRetry, onCloseWithout: onCloseWithout }) {
    const { t: t } = (0, $e1LEq.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": "booking-deposit-failed",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 10
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                variant: "warning",
                children: t('reception.booking.deposit.failedAfterBooking', {
                    reason: reason || t('errors.generic')
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    gap: 8,
                    justifyContent: 'flex-end',
                    flexWrap: 'wrap'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                        variant: "ghost",
                        onClick: onCloseWithout,
                        disabled: retrying,
                        "data-testid": "booking-deposit-close-without",
                        children: t('reception.booking.deposit.closeWithout')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                        onClick: onRetry,
                        disabled: retrying,
                        "data-testid": "booking-deposit-retry",
                        children: [
                            retrying ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hZDga.Spinner), {
                                size: "sm"
                            }) : null,
                            t('reception.booking.deposit.retry')
                        ]
                    })
                ]
            })
        ]
    });
}
var $99704f3c7a00de75$export$2e2bcd8739ae039 = $99704f3c7a00de75$export$ab7e26ed87733881;

});
parcelRegister("5OgPq", function(module, exports) {

$parcel$export(module.exports, "default", () => $d66974607df111ab$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("5N0ZI");
var $lkMIV = parcelRequire("lkMIV");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $1O6TO = parcelRequire("1O6TO");
function $d66974607df111ab$export$2e2bcd8739ae039({ currency: currency, ...props }) {
    const { t: t, currency: inContext } = (0, $e1LEq.default)();
    const code = currency || inContext;
    if (!(0, $1O6TO.isUnknownCurrency)(code)) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkMIV.default), {
        ...props,
        currency: code
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkMIV.default), {
        ...props,
        currency: undefined,
        unitLabel: props.unitLabel ?? code,
        disabled: true,
        error: undefined,
        helperText: t('common.money.unsupportedCurrency', {
            code: code
        }),
        "data-currency-unsupported": code
    });
}

});

parcelRegister("eP0nH", function(module, exports) {

$parcel$export(module.exports, "suggestedDepositRial", () => $aca61fcce52ead71$export$a4c6485083f9f961);
$parcel$export(module.exports, "depositChip", () => $aca61fcce52ead71$export$66e7bdafa45a5eaa);
$parcel$export(module.exports, "hasDepositMoney", () => $aca61fcce52ead71$export$19660ebd027f163e);
$parcel$export(module.exports, "refundAllowed", () => $aca61fcce52ead71$export$12e80003bc1d782e);
$parcel$export(module.exports, "heldDepositOf", () => $aca61fcce52ead71$export$a6edd5e1dfc51424);
$parcel$export(module.exports, "netOfHeldDeposit", () => $aca61fcce52ead71$export$a747f57be7e91c21);
$parcel$export(module.exports, "depositPaymentIds", () => $aca61fcce52ead71$export$15d11b8b9a69f215);
/**
 * «پیش‌پرداخت مراجعه» — money held FOR one appointment (PM-0657, contract §6.1).
 *
 * One rule, one file: the amount the desk is offered, what the reception row
 * says about a deposit, and whether the refund window is still open. Every
 * surface (the booking dialog, the row chip, the deposit dialog, the cancel /
 * no-show modal, the settle drawer) reads these and never works them out again.
 *
 * MONEY: minor units of the deposit's currency, like everything on the wire.
 * TIME: the refund deadline is an INSTANT (epoch ms, computed by the BFF as the
 * appointment's instant minus the snapshot window in hours) — no wall clock or
 * zone enters the comparison. Only its DISPLAY is on the clinic's zone.
 */ /** The flows on which a deposit can still be taken / is still expected. */ const $aca61fcce52ead71$export$6236c16c6ec8ca54 = [
    'scheduled',
    'arrived',
    'in_visit'
];
function $aca61fcce52ead71$export$a4c6485083f9f961(policy, priceRial) {
    if (!policy || policy.mode === 'OFF') return null;
    if (policy.amountMode === 'FIXED') {
        const fixed = Number(policy.fixedAmountRial) || 0;
        return fixed > 0 ? fixed : null;
    }
    const price = Number(priceRial);
    if (!Number.isFinite(price) || price <= 0) return null;
    if (policy.amountMode === 'PERCENT') {
        const pct = Number(policy.percent) || 0;
        return Math.floor((price * pct + 50) / 100);
    }
    return price;
}
function $aca61fcce52ead71$export$66e7bdafa45a5eaa(deposit, mode, flow) {
    if (!$aca61fcce52ead71$export$19660ebd027f163e(deposit)) return mode === 'REQUIRED' && (flow === 'scheduled' || flow === 'arrived') ? 'missing' : null;
    if (deposit.state === 'HELD') return 'held';
    if ((Number(deposit.forfeitedRial) || 0) > 0) return 'forfeited';
    const deposited = Number(deposit.depositedRial) || 0;
    if (deposit.closeReason === 'REFUNDED' || deposited > 0 && (Number(deposit.refundedRial) || 0) >= deposited) return 'refunded';
    if (deposit.closeReason === 'APPLIED') return 'applied';
    return 'released';
}
function $aca61fcce52ead71$export$19660ebd027f163e(deposit) {
    if (!deposit) return false;
    if (deposit.depositedRial == null) return true;
    return (Number(deposit.depositedRial) || 0) > 0;
}
function $aca61fcce52ead71$export$d5427e830b04bb8a(deposit) {
    const raw = deposit?.refundDeadline;
    if (raw == null || raw === '') return null;
    const n = Number(raw);
    return Number.isFinite(n) ? n : null;
}
function $aca61fcce52ead71$export$12e80003bc1d782e(deposit, now = Date.now()) {
    const deadline = $aca61fcce52ead71$export$d5427e830b04bb8a(deposit);
    return deadline != null && now <= deadline;
}
function $aca61fcce52ead71$export$a6edd5e1dfc51424(deposit) {
    return deposit?.state === 'HELD' ? Math.max(0, Number(deposit.heldRial) || 0) : 0;
}
function $aca61fcce52ead71$export$a747f57be7e91c21(due, held) {
    return Math.max(0, (Number(due) || 0) - (Number(held) || 0));
}
function $aca61fcce52ead71$export$15d11b8b9a69f215(deposit) {
    const ids = new Set();
    for (const row of deposit?.rows || [])if (row?.paymentId) ids.add(row.paymentId);
    return ids;
}
const $aca61fcce52ead71$export$f5571d95ce541dc5 = `
  state closeReason heldRial depositedRial appliedRial refundedRial forfeitedRial releasedRial
  refundableRial refundDeadline refundWindowHours noShowOutcome noShowFeePercent currency
`;

});

parcelRegister("eatxv", function(module, exports) {

$parcel$export(module.exports, "newDepositRequestId", () => $a508e9c3fc4b1be6$export$801e623828bf7d03);
$parcel$export(module.exports, "recordAppointmentDeposit", () => $a508e9c3fc4b1be6$export$9e47cf37b58b5810);
$parcel$export(module.exports, "releaseAppointmentDeposit", () => $a508e9c3fc4b1be6$export$86fdef221743c173);
$parcel$export(module.exports, "refundAppointmentDeposit", () => $a508e9c3fc4b1be6$export$f70ba3c1aba12917);
$parcel$export(module.exports, "loadAppointmentDeposit", () => $a508e9c3fc4b1be6$export$e6459983035cfd3d);

var $2Mst8 = parcelRequire("2Mst8");
/**
 * «پیش‌پرداخت مراجعه» — the desk's writes and the one read (PM-0657, contract
 * §5.2 / §6.3). Plain functions rather than a stateful hook: the booking
 * dialogs, the row dialog and the settle drawer each own their own state, and
 * a second copy of the deposit held here would be a second answer to «how much
 * is held».
 *
 * MONEY: minor units of the clinic's currency on the wire (rials for IRR).
 * Every write takes a `requestId` the caller keeps across retries, so a retry
 * after NO_OPEN_SHIFT records ONE deposit, not two.
 */ const $a508e9c3fc4b1be6$var$DEPOSIT_FIELDS = `
  appointmentId state closeReason
  depositedRial appliedRial refundedRial forfeitedRial heldRial releasedRial refundableRial
  invoiceId feeInvoiceId refundWindowHours refundDeadline noShowOutcome noShowFeePercent currency
`;
const $a508e9c3fc4b1be6$var$RESULT_FIELDS = `
  currency
  deposit { ${$a508e9c3fc4b1be6$var$DEPOSIT_FIELDS} }
  credit { id amountRial source paymentMethod currency }
`;
const $a508e9c3fc4b1be6$export$dd2156137049cf1e = `
  mutation RecordAppointmentDeposit(
    $appointmentId: ID!, $amountRial: Float!, $paymentMethod: String,
    $referenceNumber: String, $note: String, $accountId: ID, $requestId: ID
  ) {
    recordAppointmentDeposit(
      appointmentId: $appointmentId, amountRial: $amountRial, paymentMethod: $paymentMethod,
      referenceNumber: $referenceNumber, note: $note, accountId: $accountId, requestId: $requestId
    ) { ${$a508e9c3fc4b1be6$var$RESULT_FIELDS} }
  }
`;
const $a508e9c3fc4b1be6$export$7cd06a7af6b84ebb = `
  mutation ReleaseAppointmentDeposit($appointmentId: ID!, $reason: String) {
    releaseAppointmentDeposit(appointmentId: $appointmentId, reason: $reason) { ${$a508e9c3fc4b1be6$var$RESULT_FIELDS} }
  }
`;
const $a508e9c3fc4b1be6$export$88e781ce94a6159e = `
  mutation RefundAppointmentDeposit(
    $appointmentId: ID!, $amountRial: Float, $paymentMethod: String,
    $referenceNumber: String, $accountId: ID, $reason: String!, $requestId: ID
  ) {
    refundAppointmentDeposit(
      appointmentId: $appointmentId, amountRial: $amountRial, paymentMethod: $paymentMethod,
      referenceNumber: $referenceNumber, accountId: $accountId, reason: $reason, requestId: $requestId
    ) { ${$a508e9c3fc4b1be6$var$RESULT_FIELDS} }
  }
`;
const $a508e9c3fc4b1be6$export$91b345249d0f2c7a = `
  query AppointmentDeposit($appointmentId: ID!) {
    receptionSettlement(appointmentId: $appointmentId) {
      currency
      creditBalanceRial
      deposit {
        ${$a508e9c3fc4b1be6$var$DEPOSIT_FIELDS}
        rows { id amountRial source paymentMethod note createdAt paymentId currency }
      }
    }
  }
`;
const $a508e9c3fc4b1be6$export$801e623828bf7d03 = (prefix = 'appt-deposit')=>`${prefix}-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
async function $a508e9c3fc4b1be6$export$9e47cf37b58b5810({ appointmentId: appointmentId, amountRial: amountRial, paymentMethod: paymentMethod, referenceNumber: referenceNumber, note: note, accountId: accountId, requestId: requestId }) {
    const data = await (0, $2Mst8.bffMutation)($a508e9c3fc4b1be6$export$dd2156137049cf1e, {
        appointmentId: appointmentId,
        amountRial: amountRial,
        paymentMethod: paymentMethod || 'CASH',
        referenceNumber: referenceNumber || null,
        note: note || null,
        accountId: accountId || null,
        requestId: requestId || null
    }, 'RecordAppointmentDeposit');
    return data?.recordAppointmentDeposit || null;
}
async function $a508e9c3fc4b1be6$export$86fdef221743c173({ appointmentId: appointmentId, reason: reason }) {
    const data = await (0, $2Mst8.bffMutation)($a508e9c3fc4b1be6$export$7cd06a7af6b84ebb, {
        appointmentId: appointmentId,
        reason: reason || null
    }, 'ReleaseAppointmentDeposit');
    return data?.releaseAppointmentDeposit || null;
}
async function $a508e9c3fc4b1be6$export$f70ba3c1aba12917({ appointmentId: appointmentId, amountRial: amountRial, paymentMethod: paymentMethod, referenceNumber: referenceNumber, accountId: accountId, reason: reason, requestId: requestId }) {
    const data = await (0, $2Mst8.bffMutation)($a508e9c3fc4b1be6$export$88e781ce94a6159e, {
        appointmentId: appointmentId,
        // 0 / null = everything refundable (§3.3).
        amountRial: amountRial || null,
        paymentMethod: paymentMethod || 'CASH',
        referenceNumber: referenceNumber || null,
        accountId: accountId || null,
        reason: reason,
        requestId: requestId || null
    }, 'RefundAppointmentDeposit');
    return data?.refundAppointmentDeposit || null;
}
async function $a508e9c3fc4b1be6$export$e6459983035cfd3d(appointmentId) {
    const data = await (0, $2Mst8.bffQuery)($a508e9c3fc4b1be6$export$91b345249d0f2c7a, {
        appointmentId: appointmentId
    }, 'AppointmentDeposit');
    const s = data?.receptionSettlement || null;
    return {
        deposit: s?.deposit || null,
        creditBalanceRial: s?.creditBalanceRial ?? null,
        currency: s?.currency || s?.deposit?.currency || null
    };
}

});



parcelRegister("gnVfo", function(module, exports) {

$parcel$export(module.exports, "default", () => $d091b13ea2ccf422$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");
parcelRequire("5N0ZI");
var $66joL = parcelRequire("66joL");
parcelRequire("52bn2");
var $jTCZr = parcelRequire("jTCZr");

var $lM08I = parcelRequire("lM08I");

var $7guRV = parcelRequire("7guRV");
function $d091b13ea2ccf422$export$2e2bcd8739ae039({ title: title, subtitle: subtitle, people: people, loading: loading = false, loadingLabel: loadingLabel, onPick: onPick, onClose: onClose, empty: empty = null, notice: notice = null }) {
    const { t: t } = (0, $e1LEq.default)();
    const picker = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            notice ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                role: "alert",
                "data-testid": "practitioner-picker-notice",
                style: {
                    fontSize: '0.75rem',
                    lineHeight: 1.7,
                    fontWeight: 700,
                    color: 'var(--chip-warning-ink)',
                    background: 'var(--chip-warning-bg)',
                    borderRadius: 8,
                    padding: '8px 10px'
                },
                children: notice
            }) : null,
            loading && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonRegion), {
                label: loadingLabel || t('common.state.loading'),
                "data-testid": "booking-doctors-skeleton",
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 8
                },
                children: Array.from({
                    length: 3
                }, (_, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 12,
                            padding: '12px 14px',
                            borderRadius: 12,
                            border: `1.5px solid ${(0, $jTCZr.C).border}`,
                            background: 'white'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonAvatar), {
                                size: 38
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    flex: 1,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 6
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                        width: "50%",
                                        height: 14
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                        width: "35%",
                                        height: 11
                                    })
                                ]
                            })
                        ]
                    }, i))
            }),
            !loading && people.length === 0 ? empty : null,
            people.map((p)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                    onClick: ()=>onPick(p),
                    "data-testid": `practitioner-pick-${p.id}`,
                    style: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: 12,
                        width: '100%',
                        padding: '12px 14px',
                        borderRadius: 12,
                        cursor: 'pointer',
                        textAlign: 'end',
                        border: `1.5px solid ${(0, $jTCZr.C).border}`,
                        background: 'white',
                        fontFamily: 'inherit',
                        transition: 'border-color 0.14s, background 0.14s'
                    },
                    onMouseEnter: (e)=>{
                        e.currentTarget.style.borderColor = (0, $jTCZr.C).navy;
                        e.currentTarget.style.background = 'color-mix(in srgb, var(--p-navy) 6%, transparent)';
                    },
                    onMouseLeave: (e)=>{
                        e.currentTarget.style.borderColor = (0, $jTCZr.C).border;
                        e.currentTarget.style.background = 'white';
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                width: 38,
                                height: 38,
                                borderRadius: '50%',
                                flexShrink: 0,
                                background: (0, $lM08I.doctorColor)(p.id),
                                color: 'white',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '0.75rem',
                                fontWeight: 800
                            },
                            children: (0, $lM08I.getInitials)(p.name)
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                minWidth: 0,
                                flex: 1
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 6
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                fontSize: '0.875rem',
                                                fontWeight: 700,
                                                color: (0, $jTCZr.C).textPrimary
                                            },
                                            children: p.name
                                        }),
                                        p.tag ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                fontSize: '0.65625rem',
                                                fontWeight: 700,
                                                color: (0, $jTCZr.C).navy,
                                                background: 'color-mix(in srgb, var(--p-navy) 10%, transparent)',
                                                borderRadius: 999,
                                                padding: '1px 8px'
                                            },
                                            children: p.tag
                                        }) : null
                                    ]
                                }),
                                p.meta ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    style: {
                                        fontSize: '0.71875rem',
                                        color: (0, $jTCZr.C).textMuted,
                                        marginTop: 2
                                    },
                                    children: p.meta
                                }) : null
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                            viewBox: "0 0 24 24",
                            fill: (0, $jTCZr.C).textMuted,
                            width: "15",
                            height: "15",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
                            })
                        })
                    ]
                }, p.key))
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7guRV.default), {
        onClose: onClose,
        title: title,
        subtitle: subtitle,
        snap: 0.85,
        fullHeight: false,
        desktop: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            style: {
                position: 'fixed',
                inset: 0,
                zIndex: 8000,
                background: 'rgba(15,28,46,0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 20
            },
            onClick: (e)=>{
                if (e.target === e.currentTarget) onClose();
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                role: "dialog",
                "aria-modal": "true",
                "aria-label": title,
                style: {
                    background: 'white',
                    borderRadius: 20,
                    width: '100%',
                    maxWidth: 420,
                    maxHeight: '86vh',
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                    boxShadow: '0 32px 80px rgba(0,0,0,0.26)',
                    fontFamily: 'Meshkat, sans-serif'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            padding: '18px 22px 14px',
                            borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            gap: 12
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    minWidth: 0
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            fontSize: '1.0625rem',
                                            fontWeight: 800,
                                            color: (0, $jTCZr.C).textPrimary
                                        },
                                        children: title
                                    }),
                                    subtitle ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            fontSize: '0.75rem',
                                            color: (0, $jTCZr.C).textMuted,
                                            marginTop: 3
                                        },
                                        children: subtitle
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: onClose,
                                "aria-label": t('common.actions.close'),
                                style: {
                                    background: (0, $jTCZr.C).bg,
                                    border: 'none',
                                    cursor: 'pointer',
                                    color: (0, $jTCZr.C).textMuted,
                                    width: 32,
                                    height: 32,
                                    borderRadius: 8,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    flexShrink: 0
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    viewBox: "0 0 24 24",
                                    fill: "currentColor",
                                    width: "16",
                                    height: "16",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            flex: 1,
                            overflowY: 'auto',
                            padding: '14px 22px 20px',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 8
                        },
                        children: picker
                    })
                ]
            })
        }),
        children: picker
    });
}

});

parcelRegister("94n92", function(module, exports) {

$parcel$export(module.exports, "default", () => $2953b5fdd6d18f7a$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");
parcelRequire("1NzLv");
var $fzygI = parcelRequire("fzygI");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $aJ1FU = parcelRequire("aJ1FU");
var $hZDga = parcelRequire("hZDga");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");
parcelRequire("52bn2");
var $jTCZr = parcelRequire("jTCZr");

var $7guRV = parcelRequire("7guRV");

var $2xQve = parcelRequire("2xQve");

var $1iGMR = parcelRequire("1iGMR");

var $lM08I = parcelRequire("lM08I");

var $aHwe7 = parcelRequire("aHwe7");
function $2953b5fdd6d18f7a$export$2e2bcd8739ae039({ pending: pending = [], onAccept: onAccept, onClose: onClose }) {
    const { t: t } = (0, $e1LEq.default)();
    const navigate = (0, $aphAM.useNavigate)();
    const { can: can, isAdmin: isAdmin } = (0, $1iGMR.useAccess)();
    const canManage = isAdmin || can('doctors.manage');
    const [busyId, setBusyId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const accept = async (link)=>{
        if (busyId || !onAccept) return;
        setError('');
        setBusyId(link.id);
        try {
            await onAccept(link.id);
        // No close here: the parent re-derives `bookable` from the accepted link
        // and swaps this modal for the picker on its own.
        } catch (e) {
            setError(e?.message || t('reception.connectDoctor.acceptFailed'));
        } finally{
            setBusyId(null);
        }
    };
    /**
   * Leave for «همکاران».
   *
   * On a phone this modal is a sheet holding a history entry, so the entry has
   * to be handed to the navigation — otherwise the sheet's deferred release
   * pops the destination straight back off and the button does nothing. On the
   * desk it is a centred dialog with no entry at all, and `consumeOverlayEntry`
   * says so by returning false, which leaves this an ordinary push.
   */ const goToPeople = ()=>{
        const replace = (0, $fzygI.consumeOverlayEntry)();
        onClose?.();
        navigate('/people?kind=practitioner', {
            replace: replace
        });
    };
    const body = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            pending.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                "aria-label": t('reception.connectDoctor.pendingTitle'),
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: (0, $2xQve.STACK).tight
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: '0.8125rem',
                            fontWeight: 800,
                            color: (0, $jTCZr.C).textPrimary
                        },
                        children: t('reception.connectDoctor.pendingTitle')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: '0.75rem',
                            color: (0, $jTCZr.C).textMuted,
                            lineHeight: 1.8
                        },
                        children: canManage ? t('reception.connectDoctor.pendingHint') : t('reception.connectDoctor.pendingAwaitingManager')
                    }),
                    pending.map((link)=>{
                        const name = link.doctorName || t('doctors.placeholder.unnamed', {
                            id: (link.doctorId || '').slice(0, 6)
                        });
                        const busy = busyId === link.id;
                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                display: 'flex',
                                alignItems: 'center',
                                gap: 12,
                                padding: '10px 12px',
                                borderRadius: 12,
                                border: `1.5px solid ${(0, $jTCZr.C).border}`,
                                background: (0, $jTCZr.C).bg
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    style: {
                                        width: 36,
                                        height: 36,
                                        borderRadius: '50%',
                                        flexShrink: 0,
                                        background: (0, $lM08I.doctorColor)(link.doctorId),
                                        color: 'white',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '0.75rem',
                                        fontWeight: 800
                                    },
                                    children: (0, $lM08I.getInitials)(name)
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        minWidth: 0,
                                        flex: 1
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                fontSize: '0.875rem',
                                                fontWeight: 700,
                                                color: (0, $jTCZr.C).textPrimary,
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap'
                                            },
                                            children: name
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                fontSize: '0.71875rem',
                                                color: (0, $jTCZr.C).amber,
                                                marginTop: 2
                                            },
                                            children: t('people.status.pending')
                                        })
                                    ]
                                }),
                                canManage && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                    size: "sm",
                                    onClick: ()=>accept(link),
                                    disabled: !!busyId,
                                    children: busy ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hZDga.Spinner), {
                                        size: 14
                                    }) : t('doctors.actions.acceptLink')
                                })
                            ]
                        }, link.id);
                    }),
                    error && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                        variant: "error",
                        children: error
                    })
                ]
            }),
            canManage ? /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                "aria-label": t('reception.connectDoctor.inviteTitle'),
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: (0, $2xQve.STACK).tight
                },
                children: [
                    pending.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: '0.8125rem',
                            fontWeight: 800,
                            color: (0, $jTCZr.C).textPrimary,
                            marginTop: 4
                        },
                        children: t('reception.connectDoctor.inviteTitle')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aHwe7.InvitePane), {
                        open: true
                    })
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                variant: "info",
                children: t('reception.connectDoctor.needPermission')
            })
        ]
    });
    const actions = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            canManage && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                variant: "outline",
                onClick: goToPeople,
                children: t('reception.connectDoctor.manageColleagues')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                variant: "ghost",
                onClick: onClose,
                children: t('common.actions.close')
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7guRV.default), {
        onClose: onClose,
        title: t('reception.connectDoctor.title'),
        subtitle: t('reception.connectDoctor.subtitle'),
        snap: 0.9,
        footer: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            style: {
                display: 'flex',
                gap: 8
            },
            children: actions
        }),
        desktop: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            role: "dialog",
            "aria-modal": "true",
            "aria-label": t('reception.connectDoctor.title'),
            style: {
                position: 'fixed',
                inset: 0,
                zIndex: 8000,
                background: 'rgba(15,28,46,0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 20
            },
            onClick: (e)=>{
                if (e.target === e.currentTarget) onClose();
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    background: 'white',
                    borderRadius: 20,
                    width: '100%',
                    maxWidth: 460,
                    maxHeight: '86vh',
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                    boxShadow: '0 32px 80px rgba(0,0,0,0.26)',
                    fontFamily: 'Meshkat, sans-serif'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            padding: '18px 22px 14px',
                            borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            gap: 12
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    minWidth: 0
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            fontSize: '1.0625rem',
                                            fontWeight: 800,
                                            color: (0, $jTCZr.C).textPrimary
                                        },
                                        children: t('reception.connectDoctor.title')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            fontSize: '0.75rem',
                                            color: (0, $jTCZr.C).textMuted,
                                            marginTop: 3,
                                            lineHeight: 1.8
                                        },
                                        children: t('reception.connectDoctor.subtitle')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                onClick: onClose,
                                "aria-label": t('common.actions.close'),
                                style: {
                                    background: (0, $jTCZr.C).bg,
                                    border: 'none',
                                    cursor: 'pointer',
                                    color: (0, $jTCZr.C).textMuted,
                                    width: 32,
                                    height: 32,
                                    borderRadius: 8,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    flexShrink: 0
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    viewBox: "0 0 24 24",
                                    fill: "currentColor",
                                    width: "16",
                                    height: "16",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            flex: 1,
                            overflowY: 'auto',
                            padding: '16px 22px 20px',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: (0, $2xQve.STACK).regular
                        },
                        children: body
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            padding: '12px 22px',
                            borderTop: `1px solid ${(0, $jTCZr.C).border}`,
                            display: 'flex',
                            gap: 8,
                            justifyContent: 'flex-start'
                        },
                        children: actions
                    })
                ]
            })
        }),
        children: body
    });
}

});
parcelRegister("1NzLv", function(module, exports) {

$parcel$export(module.exports, "MobileScreen", () => (parcelRequire("8RTRt")).default);
$parcel$export(module.exports, "MobileHeader", () => (parcelRequire("5zhhf")).default);
$parcel$export(module.exports, "MobileSheet", () => (parcelRequire("4WVD9")).default);
$parcel$export(module.exports, "MobileFormSheet", () => (parcelRequire("6y32F")).default);
$parcel$export(module.exports, "MobileField", () => (parcelRequire("6y32F")).MobileField);
$parcel$export(module.exports, "MobileRowMenu", () => (parcelRequire("cxfrY")).default);
$parcel$export(module.exports, "overlayOwnsPop", () => (parcelRequire("fzygI")).overlayOwnsPop);
$parcel$export(module.exports, "consumeOverlayEntry", () => (parcelRequire("fzygI")).consumeOverlayEntry);
$parcel$export(module.exports, "MobileList", () => (parcelRequire("cEwTy")).default);
$parcel$export(module.exports, "MobileCardSkeleton", () => (parcelRequire("7NBSI")).default);
$parcel$export(module.exports, "MobileCard", () => (parcelRequire("cXlM6")).default);
$parcel$export(module.exports, "MobileCardHead", () => (parcelRequire("cXlM6")).MobileCardHead);
$parcel$export(module.exports, "MobileCardMeta", () => (parcelRequire("cXlM6")).MobileCardMeta);
$parcel$export(module.exports, "MobileCardActions", () => (parcelRequire("cXlM6")).MobileCardActions);
$parcel$export(module.exports, "MobileFilterBar", () => (parcelRequire("gmg4I")).default);
$parcel$export(module.exports, "MobileSectionNav", () => (parcelRequire("0UhMT")).default);
$parcel$export(module.exports, "MobileStatTiles", () => (parcelRequire("bKUa1")).default);
$parcel$export(module.exports, "MobileMoneyRow", () => (parcelRequire("brmQA")).default);
$parcel$export(module.exports, "MobileMoneyTile", () => (parcelRequire("dHEom")).MobileMoneyTile);
$parcel$export(module.exports, "MobileDetailRow", () => (parcelRequire("dHEom")).MobileDetailRow);
$parcel$export(module.exports, "MobileDesktopNote", () => (parcelRequire("aLdCl")).default);
$parcel$export(module.exports, "MobileAppointmentCard", () => (parcelRequire("ajGTC")).default);
$parcel$export(module.exports, "MobilePaymentCard", () => (parcelRequire("3P099")).default);
$parcel$export(module.exports, "MobileClaimCard", () => (parcelRequire("9HOnT")).default);
/**
 * The mobile layout library — `src/mobile/`.
 *
 * Layer 3 of the three the design keeps apart (docs/MOBILE-REDESIGN.md §4.0):
 *
 *   1. **Kit primitive** (`@parsina/framework`) — design language shared by
 *      both surfaces: `Button`, `Card`, `Badge`, `Alert`, `EmptyState`,
 *      `ErrorState`, `ConfirmDialog`, `StatusBadge`, the form controls. Reach
 *      here FIRST; hand-rolling something the kit already has is a defect.
 *   2. **App-shared, surface-agnostic** (`src/hooks/`, `src/lib/`,
 *      `src/constants/`, `*.shared.js`) — logic, vocabulary, view-state,
 *      formatting. Imported by BOTH surfaces, which is what stops the two
 *      disagreeing about a count or a status.
 *   3. **Mobile layout** (here) — anatomy, chrome, cards, sheets. Imported
 *      only by `*.mobile.jsx`, and never exported back into a `.web.jsx`.
 *
 * The test for something new: does it carry LAYOUT opinion? Layer 3. BEHAVIOUR
 * or VOCABULARY? Layer 2, and both surfaces use it. DESIGN LANGUAGE with no
 * layout? It belongs in the framework — open a PR there rather than copying it
 * in here.
 *
 * Several components here are thin wrappers over a kit primitive, adding a
 * capability the pinned v0.10.1 lacks (`MobileSheet`'s keyboard inset and
 * history entry, `MobileHeader`'s search field). They are wrappers rather than
 * forks precisely so that raising the pin deletes them instead of leaving two
 * divergent implementations behind.
 */ // Shell

var $8RTRt = parcelRequire("8RTRt");

var $5zhhf = parcelRequire("5zhhf");

var $lUZHL = parcelRequire("lUZHL");

var $kt5mZ = parcelRequire("kt5mZ");

var $4WVD9 = parcelRequire("4WVD9");

var $6y32F = parcelRequire("6y32F");

var $cxfrY = parcelRequire("cxfrY");

var $fzygI = parcelRequire("fzygI");

var $cEwTy = parcelRequire("cEwTy");

var $7NBSI = parcelRequire("7NBSI");

var $cXlM6 = parcelRequire("cXlM6");

var $gmg4I = parcelRequire("gmg4I");

var $0UhMT = parcelRequire("0UhMT");

var $bKUa1 = parcelRequire("bKUa1");

var $brmQA = parcelRequire("brmQA");

var $dHEom = parcelRequire("dHEom");

var $71yN3 = parcelRequire("71yN3");

var $aLdCl = parcelRequire("aLdCl");

var $ajGTC = parcelRequire("ajGTC");

var $3P099 = parcelRequire("3P099");

var $9HOnT = parcelRequire("9HOnT");

var $a3DRM = parcelRequire("a3DRM");

var $2px22 = parcelRequire("2px22");

var $c5gO0 = parcelRequire("c5gO0");

});
parcelRegister("8RTRt", function(module, exports) {

$parcel$export(module.exports, "SCREEN_CTA_VAR", () => $b01ac379866c8d88$export$a58313242474beee);
$parcel$export(module.exports, "FAB_SPACE_VAR", () => $b01ac379866c8d88$export$8b397655d50c143e);
$parcel$export(module.exports, "default", () => $b01ac379866c8d88$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
/**
 * The frame every mobile screen is built in.
 *
 * It exists to make the viewport contract (docs/MOBILE-REDESIGN.md §3.1) a
 * property of the frame rather than a rule each screen has to remember:
 *
 *   • ONE scroll region. The document does not scroll on a phone (`styles.css`
 *     locks it), and a nested second scroller inside a screen is a defect —
 *     it steals the gesture, and on iOS it traps `position: fixed` descendants
 *     (which is what clips a sheet mounted inside it).
 *   • The last card is never covered, and a docked CTA sits directly above the
 *     bottom nav rather than a bar's height away from it.
 *
 * ── Why this frame reserves NO space for the bottom nav ─────────────────────
 *
 * It used to, via `--app-bottom-nav` — the measured height the kit's `BottomNav`
 * publishes while it is mounted. That variable is for things that FLOAT OVER the
 * shell (a toast, an install card, a `position: fixed` CTA), and this frame is
 * not one of them: `ClinicLayout`'s phone branch is a flex column whose children
 * are [this screen][the nav], and the kit's bar is `position: relative` with
 * `flexShrink: 0`. The frame's box therefore ALREADY ends exactly where the bar
 * begins — its own docstring calls it "a fixed bar", which the style has not
 * been for some time.
 *
 * So adding the bar's height inside the frame reserved it twice, and the second
 * reservation was visible: «فراخوان بیمار بعدی» on پذیرش floated 72px above the
 * nav on a 390×844 phone — 12px of the CTA bar's own breathing room, and 60px of
 * bar height that nothing occupied. Every mobile list also carried 60px of dead
 * scroll slack under its last row.
 *
 * The safe-area inset is the same story with one twist: `BottomNav` already
 * applies `max(env(safe-area-inset-bottom), 0.25rem)` as its own bottom
 * padding, so when the bar is there the home indicator is already cleared and
 * adding the inset here pushes the CTA up a second time. When the bar is NOT
 * there — a drilled-into flow, or a person whose access yields no bottom-nav
 * destination at all — nothing below clears it and the frame must.
 *
 * `--app-bottom-nav` is exactly the signal for that, since the bar sets it on
 * mount and clears it on unmount, so `BOTTOM_INSET` subtracts the bar's height
 * from the inset and floors at zero: a 60px bar swallows a 34px indicator and
 * the term vanishes, no bar leaves the full inset. That is why it reads the
 * variable at all — to know whether a bar EXISTS, never to reserve its height.
 */ /**
 * The home indicator, minus whatever the bottom bar is already clearing.
 * See the note above; `hasNav={false}` forces the no-bar answer for a surface
 * that knows it is full-screen before the bar has unmounted.
 */ const $b01ac379866c8d88$var$BOTTOM_INSET = 'max(env(safe-area-inset-bottom, 0px) - var(--app-bottom-nav, 0px), 0px)';
const $b01ac379866c8d88$export$a58313242474beee = '--app-screen-cta';
const $b01ac379866c8d88$export$8b397655d50c143e = '--app-fab-space';
function $b01ac379866c8d88$var$usePublishedHeight(ref, cssVar, active) {
    (0, $acw62.useLayoutEffect)(()=>{
        const root = typeof document !== 'undefined' ? document.documentElement : null;
        const el = ref.current;
        if (!root || !active || !el) return undefined;
        const publish = ()=>root.style.setProperty(cssVar, `${Math.round(el.getBoundingClientRect().height)}px`);
        publish();
        const watch = typeof ResizeObserver === 'function' ? new ResizeObserver(publish) : null;
        watch?.observe(el);
        return ()=>{
            watch?.disconnect();
            root.style.removeProperty(cssVar);
        };
    }, [
        ref,
        cssVar,
        active
    ]);
}
function $b01ac379866c8d88$export$2e2bcd8739ae039({ header: header, children: children, cta: /** The screen's single primary action, docked above the bottom nav. */ cta, hasNav: /** False for a drilled-into surface, which has no bottom nav. */ hasNav = true, 'data-state': dataState, 'data-testid': testId }) {
    // Nothing for the bar's HEIGHT — it sits below this frame, not over it.
    const bottomInset = hasNav ? $b01ac379866c8d88$var$BOTTOM_INSET : 'env(safe-area-inset-bottom, 0px)';
    const ctaRef = (0, $acw62.useRef)(null);
    $b01ac379866c8d88$var$usePublishedHeight(ctaRef, $b01ac379866c8d88$export$a58313242474beee, Boolean(cta));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-state": dataState,
        "data-testid": testId,
        style: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            background: (0, $jTCZr.C).bg,
            overflow: 'hidden'
        },
        children: [
            header,
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    flex: 1,
                    minHeight: 0,
                    overflowY: 'auto',
                    WebkitOverflowScrolling: 'touch',
                    overscrollBehavior: 'contain',
                    // …plus the floating secretary button's room, so the last row can scroll
                    // clear of it — its «⋮» sits exactly where the button floats.
                    paddingBottom: `calc(1rem + ${bottomInset} + var(${$b01ac379866c8d88$export$8b397655d50c143e}, 0px))`
                },
                children: children
            }),
            cta && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                ref: ctaRef,
                "data-testid": "mobile-screen-cta",
                style: {
                    flexShrink: 0,
                    padding: '0.75rem 1rem',
                    paddingBottom: `calc(0.75rem + ${bottomInset})`,
                    background: (0, $jTCZr.C).card,
                    borderTop: `1px solid ${(0, $jTCZr.C).border}`
                },
                children: cta
            })
        ]
    });
}

});

parcelRegister("5zhhf", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bd853e459ae0504$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $e5Ore = parcelRequire("e5Ore");
var $6TdpC = parcelRequire("6TdpC");
parcelRequire("5N0ZI");
var $dSwFB = parcelRequire("dSwFB");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");
function $3bd853e459ae0504$export$2e2bcd8739ae039({ search: search, sticky: sticky = false, children: children, style: style, ...rest }) {
    const { t: t } = (0, $e1LEq.default)();
    const context = (search || children) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            search && /*#__PURE__*/ (0, $ayMG0.jsx)($3bd853e459ae0504$var$OnGradientSearch, {
                ...search,
                t: t
            }),
            children
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dSwFB.default), {
        ...rest,
        style: {
            ...sticky ? {
                position: 'sticky',
                top: 0,
                zIndex: 3
            } : null,
            ...style
        },
        children: context
    });
}
function $3bd853e459ae0504$var$OnGradientSearch({ value: value, onChange: onChange, onClear: onClear, onSubmit: onSubmit, placeholder: placeholder, autoFocus: autoFocus, testId: testId, t: t }) {
    const inputRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (autoFocus) inputRef.current?.focus();
    }, [
        autoFocus
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
        role: "search",
        onSubmit: (e)=>{
            e.preventDefault();
            onSubmit?.(value);
        },
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            background: 'rgba(255,255,255,0.16)',
            border: '1px solid rgba(255,255,255,0.24)',
            borderRadius: '0.625rem',
            paddingInline: '0.75rem',
            minHeight: '2.75rem'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e5Ore.default), {
                size: 16,
                color: "rgba(255,255,255,0.85)",
                "aria-hidden": "true",
                style: {
                    flexShrink: 0
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                ref: inputRef,
                type: "search",
                value: value || '',
                onChange: (e)=>onChange?.(e.target.value),
                placeholder: placeholder,
                "aria-label": placeholder,
                "data-testid": testId,
                style: {
                    flex: 1,
                    minWidth: 0,
                    background: 'transparent',
                    border: 'none',
                    outline: 'none',
                    color: '#fff',
                    // ≥1rem is not a preference. Below it, iOS Safari zooms the viewport
                    // on focus and the operator loses the layout they were working in.
                    fontSize: '1rem',
                    fontFamily: 'inherit'
                }
            }),
            value ? /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                type: "button",
                onClick: ()=>onClear?.(),
                "aria-label": t('common.actions.clearSearch'),
                style: {
                    display: 'grid',
                    placeItems: 'center',
                    width: '2rem',
                    height: '2rem',
                    flexShrink: 0,
                    background: 'transparent',
                    border: 'none',
                    cursor: 'pointer',
                    color: 'rgba(255,255,255,0.85)'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6TdpC.default), {
                    size: 16,
                    "aria-hidden": "true"
                })
            }) : null
        ]
    });
}

});

parcelRegister("lUZHL", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff1c46d3f41994f3$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7VXKQ = parcelRequire("7VXKQ");
parcelRequire("5N0ZI");
var $iuHQQ = parcelRequire("iuHQQ");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $kaeHn = parcelRequire("kaeHn");

var $4NjkN = parcelRequire("4NjkN");
function $ff1c46d3f41994f3$export$2e2bcd8739ae039({ access: access, barePath: barePath, pendingCount: pendingCount = 0, onNavigate: onNavigate, onOpenMore: onOpenMore }) {
    const { t: t, formatDigits: formatDigits } = (0, $e1LEq.default)();
    const plan = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $4NjkN.bottomNavPlan)(access), [
        access
    ]);
    const navItems = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $kaeHn.NAV_ITEMS)(t), [
        t
    ]);
    if (!plan.items.length) return null;
    const byId = new Map(navItems.map((n)=>[
            n.id,
            n
        ]));
    const items = plan.items.map((id)=>{
        if (id === (0, $4NjkN.MORE_ID)) return {
            key: (0, $4NjkN.MORE_ID),
            label: t('nav.mobile.more'),
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7VXKQ.default), {
                size: 20
            }),
            // The fold carries the invitation count, because «دعوت‌ها» lives
            // behind it. A count on a destination nobody can see from the bar is
            // the only honest place to put it.
            badge: pendingCount > 0 ? $ff1c46d3f41994f3$var$cap(pendingCount, formatDigits) : undefined,
            badgeTone: 'count',
            badgeLabel: pendingCount > 0 ? t('nav.items.invitations') : undefined
        };
        const entry = byId.get(id);
        return {
            key: id,
            label: entry?.label || id,
            icon: entry?.icon
        };
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iuHQQ.default), {
        items: items,
        active: (0, $4NjkN.activeNavId)(barePath, plan),
        onSelect: (key)=>key === (0, $4NjkN.MORE_ID) ? onOpenMore() : onNavigate(key),
        "data-testid": "mobile-bottom-nav"
    });
}
/** «+۹۹» beyond two digits: a bubble sized for one glyph cannot hold a count. */ function $ff1c46d3f41994f3$var$cap(n, formatDigits) {
    return n > 99 ? `+${formatDigits(99)}` : formatDigits(n);
}

});
parcelRegister("kaeHn", function(module, exports) {

$parcel$export(module.exports, "NAV_ITEMS", () => $8f467c050c93a24b$export$d42503afcc3a9b06);
/**
 * The navigation entries as the OPERATOR sees them — one label and one glyph
 * per section, for every surface that draws navigation.
 *
 * This lived in `ClinicLayout.jsx` while the sidebar was the only thing that
 * drew a nav. The phone's bottom bar draws the same sections, and it cannot
 * import the layout that renders it without a cycle — so the list moved here,
 * to the layer both surfaces already depend on.
 *
 * POLICY still lives in `nav.js`: which sections a person may see, which
 * permission each needs, and where a bare `/c/:ref/` lands. Splitting copy
 * from policy is why a permission change never touches a translation, and why
 * renaming a section never touches an access rule.
 *
 * The glyphs are hand-drawn rather than lucide because they are the product's
 * own section marks and read at 20px in a gradient rail; the kit owns generic
 * icons, an app owns its own landmarks.
 */ 
var $ayMG0 = parcelRequire("ayMG0");
const $8f467c050c93a24b$export$d42503afcc3a9b06 = (t)=>[
        {
            id: 'reception',
            label: t('nav.items.reception'),
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                viewBox: "0 0 24 24",
                fill: "currentColor",
                width: "20",
                height: "20",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"
                })
            })
        },
        {
            id: 'patients',
            label: t('nav.items.patients'),
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                viewBox: "0 0 24 24",
                fill: "currentColor",
                width: "20",
                height: "20",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
                })
            })
        },
        {
            /* «کالاها و خدمات» — what the clinic stocks, what it offers and what it
       owns: انبار, خدمات و تعرفه, تجهیزات, تأمین‌کنندگان, بیمه. It was split
       from «مدیریت هزینه‌ها» (the two are the halves of one former row), and
       sits after «بیماران» in the order the clinic set on 2026-09-30.

       The glyph is a box with a price tag: the ledger above it keeps the lined
       sheet, so the pair reads as "what it cost" and "what it is". Hand-drawn
       like its siblings — the kit owns generic icons, an app owns its own
       section marks. */ id: 'goods',
            label: t('nav.items.goods'),
            icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                viewBox: "0 0 24 24",
                fill: "currentColor",
                width: "20",
                height: "20",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M12 2 3 6.5v11L12 22l9-4.5v-11L12 2zm0 2.2 6.5 3.3L12 10.8 5.5 7.5 12 4.2zM5 9.2l6 3v7.3l-6-3V9.2zm8 10.3v-7.3l6-3v7.3l-6 3z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M16.5 12.6a1.1 1.1 0 1 0 0 2.2 1.1 1.1 0 0 0 0-2.2z",
                        opacity: ".35"
                    })
                ]
            })
        },
        {
            /* «تقویم و نوبت‌دهی» is not a row here any more, and is no longer a screen
       at all. It became a view of پذیرش on 2026-09-06 and was removed from the
       panel on 2026-09-13: پذیرش shows the desk's own work, and a week grid of a
       practitioner's presence is not it — the شیفت‌ها that define it are edited
       in that person's drawer on «همکاران», and booking is «ثبت نوبت» here. */ /* «حقوق و دستمزد» is not a row here any more either. It became a TAB of
       «همکاران» on 2026-09-13: it is something you do TO the people on this
       page — every line computed from a contract written in their drawer — and
       a second row for the same population made the round trip between them
       look like two jobs. Its permission did not move: the tab is absent, not
       disabled, without `payroll.view`, and the money an accountant reads is a
       view of «حسابداری». */ id: 'people',
            label: t('nav.items.people'),
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                viewBox: "0 0 24 24",
                fill: "currentColor",
                width: "20",
                height: "20",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
                })
            })
        },
        {
            /* «مدیریت هزینه‌ها» — the expense ledger, قبوض, and the definitions that
       classify them. It was «عملیات و هزینه», the merged home of هزینه‌ها +
       انبار و کالا + خدمات, until 2026-09-12: sixteen rail destinations
       answering two different questions is not one screen, it is two wearing one
       label, so the warehouse and the service list moved next door
       (docs/CLINIC_EXPENSES_AND_GOODS_SPLIT_DESIGN.md). The route kept its path
       — the bank's return URL and the reports' attention links name it. */ id: 'operations',
            label: t('nav.items.operations'),
            icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                viewBox: "0 0 24 24",
                fill: "currentColor",
                width: "20",
                height: "20",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M19.5 3.5 21 5l-4 4-2-2 1.5-1.5L17 6.5l2.5-3z",
                        opacity: ".35"
                    })
                ]
            })
        },
        {
            /* «حسابداری» — the Financial Operations hub, in the slot «پرداخت‌ها» held
       until 2026-09-12. The receipts ledger and the claims ledger moved INSIDE
       it rather than sitting beside it: the old row said «پرداخت‌ها» and meant
       money IN, while an accountant means money OUT by the same word, and two
       rows using one word for opposite directions is the duplication the hub
       exists to end (docs/CLINIC_ACCOUNTING_FINOPS_DESIGN.md D3).
       A ledger: a bound book with ruled lines and a column of figures. */ id: 'accounting',
            label: t('nav.items.accounting'),
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                viewBox: "0 0 24 24",
                fill: "currentColor",
                width: "20",
                height: "20",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M5 3h13a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2zm0 2v14h13v-2h-3v-2h3v-2h-3v-2h3V9h-3V7h3V5H5zm2 2h5v2H7V7zm0 4h5v2H7v-2zm0 4h5v2H7v-2z"
                })
            })
        },
        {
            id: 'reports',
            label: t('nav.items.reports'),
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                viewBox: "0 0 24 24",
                fill: "currentColor",
                width: "20",
                height: "20",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"
                })
            })
        },
        {
            /* «فروشگاه» — what the clinic SELLS: the storefront, its listings, the
       orders people placed, and the clinic's seat in the Parsina Marketplace
       (docs/CLINIC_STORE_MARKETPLACE_DESIGN.md §8.1). The commercial
       continuation of «کالاها و خدمات»: every listing is created FROM an item or a service declared
       there — the pair reads as "what we have" and "what we sell".

       The glyph is a storefront: a scalloped awning over a shop with a door,
       the awning's inner scallops picked out at the sibling's accent opacity.
       Hand-drawn like the rest — the kit owns generic icons, an app owns its
       own section marks. */ id: 'store',
            label: t('nav.items.store'),
            icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                viewBox: "0 0 24 24",
                fill: "currentColor",
                width: "20",
                height: "20",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M4 3h16l2 5.2c0 1.5-1 2.8-2.5 2.8-.9 0-1.7-.5-2.1-1.2-.5.7-1.3 1.2-2.2 1.2-.9 0-1.7-.5-2.2-1.2-.5.7-1.3 1.2-2.2 1.2-.9 0-1.7-.5-2.1-1.2C8.3 10.5 7.5 11 6.6 11 5.1 11 4 9.7 4 8.2L4 3zM5 12.6c.5.2 1 .4 1.6.4 1 0 1.8-.3 2.6-.9.7.6 1.6.9 2.6.9s1.9-.3 2.6-.9c.7.6 1.6.9 2.6.9.6 0 1.1-.1 1.6-.4V21H5v-8.4zM9 15v4h3v-4H9z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M6.2 5h11.6l1 2.6H5.2L6.2 5z",
                        opacity: ".35"
                    })
                ]
            })
        },
        {
            // «اشتراک کلینیک» + «معرفی کلینیک», merged. They described one subject — the
            // clinic as an entity — at one frequency, while every row above is a job
            // somebody does all day, so two rows for them diluted the operational nav.
            id: 'clinic',
            label: t('nav.items.clinic'),
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                viewBox: "0 0 24 24",
                fill: "currentColor",
                width: "20",
                height: "20",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M12 3 2 8v13h7v-6h6v6h7V8L12 3zm1 6h2v2h2v2h-2v2h-2v-2h-2v-2h2V9z"
                })
            })
        },
        {
            // Person-scoped, not clinic-scoped: an invitation belongs to the person, and
            // this row appears only while one is waiting. A permanent «دعوت‌ها (۰)» would
            // be the standing nag that trains people to stop reading the sidebar — which
            // then fails when something real needs attention.
            id: 'invitations',
            label: t('nav.items.invitations'),
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                viewBox: "0 0 24 24",
                fill: "currentColor",
                width: "20",
                height: "20",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5-8-5V6l8 5 8-5v2z"
                })
            })
        }
    ];

});

parcelRegister("4NjkN", function(module, exports) {

$parcel$export(module.exports, "MORE_ID", () => $37dabc7681d25dc2$export$29c7b090833356e2);
$parcel$export(module.exports, "bottomNavPlan", () => $37dabc7681d25dc2$export$40798ff17423185a);
$parcel$export(module.exports, "activeNavId", () => $37dabc7681d25dc2$export$f4b45a5704257659);

var $7D4kr = parcelRequire("7D4kr");
const $37dabc7681d25dc2$export$29c7b090833356e2 = 'more';
const $37dabc7681d25dc2$export$1c2c29f09fdfbffe = 4;
function $37dabc7681d25dc2$export$40798ff17423185a(access) {
    // `visibleNavIds` is the sidebar's own resolver, including its `ready`
    // guard. Reading it rather than re-filtering `NAV_PERMISSIONS` is what makes
    // "the bar and the sidebar can never disagree" true by construction instead
    // of by review.
    const visible = (0, $7D4kr.visibleNavIds)(access);
    // A person with nothing gets no bar at all — never a row of disabled icons.
    // ClinicGate already sends them to the no-permission page; a bar under it
    // would be four controls that each answer "not you".
    if (visible.length === 0) return {
        items: [],
        overflow: [],
        folded: false
    };
    if (visible.length <= $37dabc7681d25dc2$export$1c2c29f09fdfbffe) return {
        items: visible,
        overflow: [],
        folded: false
    };
    return {
        items: [
            ...visible.slice(0, $37dabc7681d25dc2$export$1c2c29f09fdfbffe - 1),
            $37dabc7681d25dc2$export$29c7b090833356e2
        ],
        overflow: visible.slice($37dabc7681d25dc2$export$1c2c29f09fdfbffe - 1),
        folded: true
    };
}
function $37dabc7681d25dc2$export$f4b45a5704257659(barePath, plan) {
    const path = barePath || '/';
    const match = (0, $7D4kr.NAV_PERMISSIONS).map((e)=>e.id).filter((id)=>path === `/${id}` || path.startsWith(`/${id}/`)).sort((a, b)=>b.length - a.length)[0];
    if (!match) return null;
    if (plan.items.includes(match)) return match;
    if (plan.overflow.includes(match)) return $37dabc7681d25dc2$export$29c7b090833356e2;
    return null;
}

});
parcelRegister("7D4kr", function(module, exports) {

$parcel$export(module.exports, "NAV_PERMISSIONS", () => $58df888399335ec9$export$deb282cd4f357d5b);
$parcel$export(module.exports, "PERSON_NAV", () => $58df888399335ec9$export$f9b6b8343142158a);
$parcel$export(module.exports, "visibleNavIds", () => $58df888399335ec9$export$3388f12e3faa2246);
$parcel$export(module.exports, "mayOpenPath", () => $58df888399335ec9$export$ea7b419fc6ed0a4c);
$parcel$export(module.exports, "landingPath", () => $58df888399335ec9$export$e8e93b5a71ff20c1);
/**
 * The navigation model — one definition, read by the sidebar, the router guard and
 * the landing-route resolver.
 *
 * docs/CLINIC_MULTI_CLINIC_UX_REV2.md §5.8. Three rules it encodes:
 *
 * 1. AN ENTRY THAT LEADS TO A DENIAL IS WORSE THAN NO ENTRY. The sidebar FILTERS on
 *    permission; it never renders a disabled row. A warehouse keeper who can see
 *    «صندوق» greyed out learns only that the product is withholding something.
 * 2. THE LANDING ROUTE IS DERIVED, never hardcoded to `/reception`. A warehouse
 *    keeper whose only grant is `inventory.view` must land on «کالاها و خدمات»;
 *    sending them to a reception page that 403s is a broken front door.
 * 3. THE SIDEBAR AND THE BOUNDARY READ THE SAME SOURCE — these keys are catalog
 *    keys from the BFF's permissionCatalog.js, and the permissions themselves are
 *    resolved server-side per clinic. The client cannot disagree with the guard
 *    because it is not making an independent judgement.
 *
 * Labels stay in ClinicLayout with the icons: this module is the POLICY, and
 * keeping copy out of it means a permission change never touches a translation.
 */ /** Nav entries in sidebar order. `perm` may be a key, an array (any-of), or null. */ const $58df888399335ec9$export$deb282cd4f357d5b = [
    {
        id: 'reception',
        perm: 'appointments.view'
    },
    {
        id: 'patients',
        perm: 'patients.view'
    },
    // «کالاها و خدمات» — the warehouse, the service declarations and the equipment
    // register. FOUR keys, any one of which opens it, because four different jobs
    // land here: stock (مسئول انبار), the price list (مدیر), the device register,
    // and the insurer contracts. Two of those four — `equipment.view` and
    // `contracts.manage` — opened NO sidebar row before the split even though the
    // rail inside had an entry for each, so a person holding only one of them was
    // denied at the gate for a screen built for them.
    {
        id: 'goods',
        perm: [
            'inventory.view',
            'services.view',
            'equipment.view',
            'contracts.manage'
        ]
    },
    // «همکاران» — the clinic's people, their roles, and since 2026-09-13 their
    // payroll. THREE keys, any one of which opens the row, because the page is now
    // three objects behind one population: the roster (`people.view`), the
    // practitioner half (`doctors.view` — which opened no row of its own before,
    // so a practitioner manager was denied at the gate for a screen built for
    // them), and the monthly run (`payroll.view`).
    //
    // Payroll is still its OWN key and not part of `people.*`: a منشی holds
    // `people.view` and must not see what everyone earns, so the TAB is absent —
    // not disabled, absent — without it. What changed is only that a salary screen
    // is not a second row in the sidebar for the same people.
    {
        id: 'people',
        perm: [
            'people.view',
            'doctors.view',
            'payroll.view'
        ]
    },
    // «مدیریت هزینه‌ها» — the expense ledger, قبوض and the definitions that classify
    // them. It was «عملیات و هزینه» until 2026-09-12, when the warehouse and the
    // service list moved to their own page
    // (docs/CLINIC_EXPENSES_AND_GOODS_SPLIT_DESIGN.md), and its gate narrowed with
    // it: what remains here is money out, and `expenses.view` is the key for that.
    {
        id: 'operations',
        perm: 'expenses.view'
    },
    // «حسابداری» — the Financial Operations hub, in the slot «پرداخت‌ها» used to
    // hold (docs/CLINIC_ACCOUNTING_FINOPS_DESIGN.md §7.2, D3). EITHER key opens it:
    // the receipts ledger and the claims ledger MOVED INTO it, so a person who
    // could open the old row on `payments.view` alone must still reach them — and
    // an accountant holding `accounting.view` reaches the rest. The rail inside
    // then shows each of them only what their own keys permit.
    {
        id: 'accounting',
        perm: [
            'accounting.view',
            'payments.view'
        ]
    },
    // EITHER reports key opens the module. An accountant may hold only
    // `reports.finance.view` — the P&L is their job and the visit counts are not — and
    // a row gated on `reports.view` alone would hide the screen from the person who
    // reads it most. `allows` treats an array as "any of", which is the right reading
    // here; the RAIL inside then shows each of them only what their own keys permit.
    {
        id: 'reports',
        perm: [
            'reports.view',
            'reports.finance.view'
        ]
    },
    // «فروشگاه» — what the clinic SELLS to the public, and what people bought. It
    // is the commercial continuation of «کالاها و خدمات»:
    // a listing is always created FROM an item or a service
    // declared there, never invented here (docs/CLINIC_STORE_MARKETPLACE_DESIGN.md
    // §3, §8.1). ONE key opens the row; the rail inside then gates finance and
    // settings on their own keys.
    {
        id: 'store',
        perm: 'store.view'
    },
    {
        id: 'clinic',
        perm: [
            'clinic.settings.manage',
            'clinic.billing.manage'
        ]
    }
];
const $58df888399335ec9$export$f9b6b8343142158a = [
    {
        id: 'invitations',
        when: (ctx)=>(ctx.pendingInvitations?.length || 0) > 0
    }
];
const $58df888399335ec9$export$e8dc4f7335b35d91 = {
    '/reception': 'appointments.view',
    '/patients': 'patients.view',
    '/patients/new': 'patients.manage',
    '/operations': 'expenses.view',
    '/goods': [
        'inventory.view',
        'services.view',
        'equipment.view',
        'contracts.manage'
    ],
    '/store': 'store.view',
    '/reports': [
        'reports.view',
        'reports.finance.view'
    ],
    '/accounting': [
        'accounting.view',
        'payments.view'
    ],
    '/people': [
        'people.view',
        'doctors.view',
        'payroll.view'
    ],
    '/people/roles': 'roles.manage',
    '/clinic': [
        'clinic.settings.manage',
        'clinic.billing.manage'
    ]
};
function $58df888399335ec9$export$1e5901f44ff1577d(access, perm) {
    if (!perm) return true;
    if (Array.isArray(perm)) return access.canAny(perm);
    return access.can(perm);
}
function $58df888399335ec9$export$3388f12e3faa2246(access) {
    if (!access?.ready) return [];
    return $58df888399335ec9$export$deb282cd4f357d5b.filter((n)=>$58df888399335ec9$export$1e5901f44ff1577d(access, n.perm)).map((n)=>n.id);
}
function $58df888399335ec9$export$9591b6dab88542c6(path) {
    const clean = (path || '').split('?')[0].replace(/\/+$/, '') || '/';
    let best = null;
    for (const [prefix, perm] of Object.entries($58df888399335ec9$export$e8dc4f7335b35d91)){
        if (clean === prefix || clean.startsWith(`${prefix}/`)) {
            if (!best || prefix.length > best.prefix.length) best = {
                prefix: prefix,
                perm: perm
            };
        }
    }
    return best ? best.perm : null;
}
function $58df888399335ec9$export$ea7b419fc6ed0a4c(access, path) {
    return $58df888399335ec9$export$1e5901f44ff1577d(access, $58df888399335ec9$export$9591b6dab88542c6(path));
}
const $58df888399335ec9$export$42bb2ec5e0ab3cdc = {
    reception: '/reception',
    accounting: '/accounting',
    operations: '/operations',
    goods: '/goods',
    store: '/store',
    patients: '/patients',
    reports: '/reports',
    people: '/people',
    clinic: '/clinic'
};
function $58df888399335ec9$export$e8e93b5a71ff20c1(access) {
    const [first] = $58df888399335ec9$export$3388f12e3faa2246(access);
    // No first entry means no permissions at all — a real state (§5.9.2) that gets
    // its own page rather than a redirect loop through a route they cannot open.
    return first ? $58df888399335ec9$export$42bb2ec5e0ab3cdc[first] : null;
}

});



parcelRegister("kt5mZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $77cc2070dbbb829f$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $jis86 = parcelRequire("jis86");
var $gKFEi = parcelRequire("gKFEi");
var $cxlxT = parcelRequire("cxlxT");
var $0hzSL = parcelRequire("0hzSL");
var $9q6Mp = parcelRequire("9q6Mp");
var $bo0GS = parcelRequire("bo0GS");
parcelRequire("5N0ZI");
var $7wZCE = parcelRequire("7wZCE");
var $bHjRG = parcelRequire("bHjRG");
var $aJ1FU = parcelRequire("aJ1FU");
var $cjPik = parcelRequire("cjPik");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("7c6z4");
var $gVWNP = parcelRequire("gVWNP");
var $e1LEq = parcelRequire("e1LEq");

var $kaeHn = parcelRequire("kaeHn");

var $4WVD9 = parcelRequire("4WVD9");

var $fzygI = parcelRequire("fzygI");
function $77cc2070dbbb829f$export$2e2bcd8739ae039({ open: open, onClose: onClose, overflow: /** Destination ids folded out of the bar, in nav order. */ overflow = [], onNavigate: onNavigate, user: user, personalCredit: personalCredit, personalLevel: personalLevel, accountHref: accountHref, creditsHref: creditsHref, memberships: memberships = [], activeRef: activeRef, canSwitch: canSwitch, onSwitchClinic: onSwitchClinic, pendingInvitations: pendingInvitations = [], onOpenAccess: onOpenAccess, onSignOut: onSignOut }) {
    const { t: t, formatNumber: formatNumber } = (0, $e1LEq.default)();
    const [confirmOut, setConfirmOut] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const byId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>new Map((0, $kaeHn.NAV_ITEMS)(t).map((n)=>[
                n.id,
                n
            ])), [
        t
    ]);
    /**
   * Leave for a destination.
   *
   * The `consumeOverlayEntry()` is not optional and not tidiness: without it
   * this sheet's history entry is released a microtask after the router has
   * already pushed the destination, and the deferred `history.go(-1)` pops the
   * DESTINATION rather than the sheet — so every row here closed the menu and
   * left the operator exactly where they were. «بیماران», «همکاران» and
   * «کلینیک من» live behind this fold, so all three were unreachable from the
   * phone's navigation while each screen worked perfectly if you typed its URL.
   *
   * Consume, then close, then navigate with `replace` so the destination takes
   * the entry this sheet is giving up. See `useOverlayHistory.consumeOverlayEntry`.
   */ const go = (id)=>{
        (0, $fzygI.consumeOverlayEntry)();
        onClose();
        onNavigate(id, {
            replace: true
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4WVD9.default), {
                open: open,
                onClose: onClose,
                title: t('nav.mobile.moreTitle'),
                fullHeight: true,
                snap: 0.9,
                "data-testid": "mobile-more-sheet",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        padding: '0.75rem 1rem 1.5rem',
                        display: 'grid',
                        gap: '1.25rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                            "aria-label": t('nav.mobile.account'),
                            style: {
                                display: 'grid',
                                gap: '0.5rem'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '0.75rem'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7wZCE.default), {
                                            name: user?.name,
                                            size: 44,
                                            src: user?.avatarUrl || undefined
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            style: {
                                                minWidth: 0,
                                                flex: 1
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    style: {
                                                        fontSize: '0.9375rem',
                                                        fontWeight: 700,
                                                        color: (0, $jTCZr.C).textPrimary,
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap'
                                                    },
                                                    dir: "auto",
                                                    children: user?.name
                                                }),
                                                user?.subtitle ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    style: {
                                                        fontSize: '0.75rem',
                                                        color: (0, $jTCZr.C).textSecondary
                                                    },
                                                    dir: "auto",
                                                    children: user.subtitle
                                                }) : null
                                            ]
                                        })
                                    ]
                                }),
                                personalCredit ? /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                    href: creditsHref,
                                    "data-testid": "mobile-more-credit",
                                    style: {
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        gap: '0.5rem',
                                        minHeight: '2.75rem',
                                        padding: '0.5rem 0.75rem',
                                        borderRadius: '0.625rem',
                                        background: (0, $jTCZr.soft)((0, $jTCZr.creditColor)(personalLevel), 0.1),
                                        color: (0, $jTCZr.C).textPrimary,
                                        textDecoration: 'none'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                fontSize: '0.8125rem',
                                                color: (0, $jTCZr.C).textSecondary
                                            },
                                            children: t('nav.credits.label')
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            style: {
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '0.375rem'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                    style: {
                                                        fontSize: '0.9375rem',
                                                        color: (0, $jTCZr.creditColor)(personalLevel)
                                                    },
                                                    children: formatNumber(personalCredit.balance)
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    style: {
                                                        fontSize: '0.75rem',
                                                        color: (0, $jTCZr.C).textSecondary
                                                    },
                                                    children: t('nav.credits.unit')
                                                })
                                            ]
                                        })
                                    ]
                                }) : null,
                                /*#__PURE__*/ (0, $ayMG0.jsx)($77cc2070dbbb829f$var$Row, {
                                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cxlxT.default), {
                                        size: 18
                                    }),
                                    label: t('nav.actions.account'),
                                    hint: t('nav.account.parsinaHint'),
                                    href: accountHref,
                                    testId: "mobile-more-account"
                                })
                            ]
                        }),
                        (overflow.length, /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                            "aria-label": t('nav.mobile.sections'),
                            style: {
                                display: 'grid',
                                gap: '0.25rem'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)($77cc2070dbbb829f$var$SectionLabel, {
                                    children: t('nav.mobile.sections')
                                }),
                                overflow.map((id)=>/*#__PURE__*/ (0, $ayMG0.jsx)($77cc2070dbbb829f$var$Row, {
                                        icon: byId.get(id)?.icon,
                                        label: byId.get(id)?.label || id,
                                        onClick: ()=>go(id),
                                        testId: `mobile-more-nav-${id}`
                                    }, id)),
                                pendingInvitations.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)($77cc2070dbbb829f$var$Row, {
                                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9q6Mp.default), {
                                        size: 18
                                    }),
                                    label: t('nav.items.invitations'),
                                    badge: pendingInvitations.length,
                                    onClick: ()=>go('invitations'),
                                    testId: "mobile-more-nav-invitations"
                                })
                            ]
                        })),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                            "aria-label": t('nav.mobile.clinicSection'),
                            style: {
                                display: 'grid',
                                gap: '0.25rem'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)($77cc2070dbbb829f$var$SectionLabel, {
                                    children: t('nav.mobile.clinicSection')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($77cc2070dbbb829f$var$Row, {
                                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bo0GS.default), {
                                        size: 18
                                    }),
                                    label: t('nav.mobile.myAccess'),
                                    onClick: ()=>{
                                        onClose();
                                        onOpenAccess();
                                    },
                                    testId: "mobile-more-access"
                                }),
                                canSwitch && memberships.map((m)=>{
                                    const isActive = m.slug === activeRef || m.clinicId === activeRef;
                                    // A blocked membership stays VISIBLE and says why. Hiding it
                                    // answers "why can't I see my other clinic?" with silence.
                                    const blocked = !m.enterable;
                                    return /*#__PURE__*/ (0, $ayMG0.jsx)($77cc2070dbbb829f$var$Row, {
                                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jis86.default), {
                                            size: 18
                                        }),
                                        label: m.clinicName,
                                        hint: blocked ? t(`clinic.gate.blocked.${m.blockedReason}.title`) : m.city,
                                        disabled: blocked || isActive,
                                        trailing: isActive ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bHjRG.default), {
                                            variant: "success",
                                            children: t('common.state.active')
                                        }) : null,
                                        /* Consumes the entry for the same reason `go` does:
                     `switchClinic` navigates synchronously when no screen has
                     registered an unsaved-work guard, so without this the
                     sheet's deferred release popped the new clinic straight
                     back off and tapping the other clinic did nothing at all. */ onClick: ()=>{
                                            (0, $fzygI.consumeOverlayEntry)();
                                            onClose();
                                            onSwitchClinic(m);
                                        },
                                        testId: `mobile-more-clinic-${m.clinicId}`
                                    }, m.clinicId);
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                            variant: "outline",
                            onClick: ()=>setConfirmOut(true),
                            "data-testid": "mobile-more-signout",
                            style: {
                                width: '100%',
                                color: (0, $jTCZr.C).red,
                                borderColor: (0, $jTCZr.soft)((0, $jTCZr.C).red, 0.35),
                                minHeight: '2.75rem'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0hzSL.default), {
                                    size: 16,
                                    style: {
                                        marginInlineEnd: '0.5rem'
                                    },
                                    "aria-hidden": "true"
                                }),
                                t('nav.actions.signOut')
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjPik.default), {
                open: confirmOut,
                onOpenChange: (v)=>{
                    if (!v) setConfirmOut(false);
                },
                title: t('nav.actions.signOut'),
                description: t('auth.signOut.confirm'),
                confirmLabel: t('nav.actions.signOut'),
                cancelLabel: t('common.actions.cancel'),
                destructive: true,
                onConfirm: ()=>{
                    setConfirmOut(false);
                    onSignOut();
                }
            })
        ]
    });
}
function $77cc2070dbbb829f$var$SectionLabel({ children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: {
            fontSize: '0.6875rem',
            fontWeight: 700,
            color: (0, $jTCZr.C).textMuted,
            padding: '0.25rem 0.25rem 0'
        },
        children: children
    });
}
/** One ≥44px destination. A real element with a role, never a div with onClick. */ function $77cc2070dbbb829f$var$Row({ icon: icon, label: label, hint: hint, badge: badge, trailing: trailing, onClick: onClick, href: href, disabled: disabled, testId: testId }) {
    const inner = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                style: {
                    display: 'grid',
                    placeItems: 'center',
                    width: 22,
                    color: (0, $jTCZr.C).textSecondary,
                    flexShrink: 0
                },
                children: icon
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                style: {
                    flex: 1,
                    minWidth: 0,
                    textAlign: 'start'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            display: 'block',
                            fontSize: '0.875rem',
                            fontWeight: 600,
                            color: (0, $jTCZr.C).textPrimary,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                        },
                        dir: "auto",
                        children: label
                    }),
                    hint ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            display: 'block',
                            fontSize: '0.6875rem',
                            color: (0, $jTCZr.C).textMuted
                        },
                        dir: "auto",
                        children: hint
                    }) : null
                ]
            }),
            badge != null ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bHjRG.default), {
                variant: "count",
                children: badge
            }) : null,
            trailing,
            !trailing && !href ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gKFEi.default), {
                size: 16,
                style: {
                    ...(0, $gVWNP.MIRROR_ICON),
                    color: (0, $jTCZr.C).textMuted,
                    flexShrink: 0
                },
                "aria-hidden": "true"
            }) : null
        ]
    });
    const style = {
        display: 'flex',
        alignItems: 'center',
        gap: '0.625rem',
        width: '100%',
        minHeight: '2.75rem',
        padding: '0.5rem 0.25rem',
        background: 'transparent',
        border: 'none',
        cursor: disabled ? 'default' : 'pointer',
        opacity: disabled ? 0.55 : 1,
        textDecoration: 'none',
        fontFamily: 'inherit'
    };
    if (href) return /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
        href: href,
        style: style,
        "data-testid": testId,
        children: inner
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
        type: "button",
        onClick: disabled ? undefined : onClick,
        "aria-disabled": disabled || undefined,
        style: style,
        "data-testid": testId,
        children: inner
    });
}

});
parcelRegister("9q6Mp", function(module, exports) {

$parcel$export(module.exports, "default", () => $64ced83eeb5f69d6$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $64ced83eeb5f69d6$export$a2387ed3b5d536eb = {
    name: "mail",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7",
                key: "132q7q"
            }
        ],
        [
            "rect",
            {
                x: "2",
                y: "4",
                width: "20",
                height: "16",
                rx: "2",
                key: "izxlao"
            }
        ]
    ]
};
$64ced83eeb5f69d6$export$a2387ed3b5d536eb.node;
const $64ced83eeb5f69d6$export$2e2bcd8739ae039 = (0, $9QBug.default)($64ced83eeb5f69d6$export$a2387ed3b5d536eb);

});


parcelRegister("6y32F", function(module, exports) {

$parcel$export(module.exports, "default", () => $b17b8e22dad870e0$export$2e2bcd8739ae039);
$parcel$export(module.exports, "MobileField", () => $b17b8e22dad870e0$export$7eda936955feae4d);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $aJ1FU = parcelRequire("aJ1FU");
var $cjPik = parcelRequire("cjPik");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $4WVD9 = parcelRequire("4WVD9");

var $9fovs = parcelRequire("9fovs");
function $b17b8e22dad870e0$export$2e2bcd8739ae039({ open: open, onClose: onClose, title: title, children: children, dirty: /** Set true while the form has unsaved changes; guards the close. */ dirty = false, onSubmit: onSubmit, submitLabel: submitLabel, submitDisabled: /** Blocks the commit — a form that is not yet valid. */ submitDisabled = false, submitting: submitting = false, error: /** Rendered as an inline Alert above the fields. A string or a node. */ error, secondary: /** Secondary action beside the submit; omit for a single-button form. */ secondary, fullHeight: fullHeight = true, snap: snap = 0.92, 'data-testid': testId }) {
    const { t: t } = (0, $e1LEq.default)();
    const [confirmLeave, setConfirmLeave] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    /**
   * The commit button is docked in the footer and the error renders at the top
   * of the scrolling body, so a refusal lands off-screen for anyone who scrolled
   * down to reach the button — it reads as «nothing happened».
   *
   * The counter is what makes a REPEATED refusal work: the same message twice is
   * the same string, so an effect watching only the text fires once and the
   * second tap looks dead again.
   */ const errorRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const [attempt, setAttempt] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    (0, $9fovs.default)(errorRef, error, attempt);
    const submit = (e)=>{
        setAttempt((n)=>n + 1);
        return onSubmit?.(e);
    };
    const requestClose = ()=>{
        if (dirty && !submitting) {
            setConfirmLeave(true);
            return;
        }
        onClose();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4WVD9.default), {
                open: open,
                onClose: requestClose,
                title: title,
                fullHeight: fullHeight,
                snap: snap,
                "data-testid": testId,
                footer: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        display: 'flex',
                        gap: '0.5rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                            onClick: submit,
                            disabled: submitDisabled || submitting,
                            style: {
                                flex: 1,
                                minHeight: '2.75rem'
                            },
                            "data-testid": testId ? `${testId}-submit` : undefined,
                            children: submitting ? t('common.state.saving') : submitLabel || t('common.actions.save')
                        }),
                        secondary
                    ]
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        padding: '0.875rem 1rem',
                        display: 'grid',
                        gap: '0.875rem'
                    },
                    children: [
                        error ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            ref: errorRef,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                                variant: "error",
                                role: "alert",
                                "data-testid": testId ? `${testId}-error` : undefined,
                                children: error
                            })
                        }) : null,
                        children
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjPik.default), {
                open: confirmLeave,
                onOpenChange: (v)=>{
                    if (!v) setConfirmLeave(false);
                },
                title: t('common.confirm.unsavedTitle'),
                description: t('common.confirm.unsavedChanges'),
                confirmLabel: t('common.confirm.leaveWithoutSaving'),
                cancelLabel: t('common.actions.cancel'),
                destructive: true,
                onConfirm: ()=>{
                    setConfirmLeave(false);
                    onClose();
                }
            })
        ]
    });
}
function $b17b8e22dad870e0$export$7eda936955feae4d({ label: label, hint: hint, error: error, children: children, htmlFor: htmlFor }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'grid',
            gap: '0.3125rem'
        },
        children: [
            label ? /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                htmlFor: htmlFor,
                style: {
                    fontSize: '0.75rem',
                    fontWeight: 600,
                    color: (0, $jTCZr.C).textSecondary
                },
                children: label
            }) : null,
            children,
            error ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                role: "alert",
                style: {
                    fontSize: '0.6875rem',
                    color: (0, $jTCZr.C).red
                },
                children: error
            }) : null,
            !error && hint ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                style: {
                    fontSize: '0.6875rem',
                    color: (0, $jTCZr.C).textMuted
                },
                children: hint
            }) : null
        ]
    });
}

});
parcelRegister("9fovs", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bb886381b12364e$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $6bb886381b12364e$export$2e2bcd8739ae039(ref, error, attempt = 0) {
    // Skips the first commit: a sheet that opens with an error already set is
    // showing it at the top anyway, and jumping on mount is motion with no cause.
    const seen = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        if (!error) {
            seen.current = true;
            return undefined;
        }
        if (!seen.current) {
            seen.current = true;
            return undefined;
        }
        const id = requestAnimationFrame(()=>{
            // `?.()` on both: jsdom implements neither `requestAnimationFrame`'s
            // target nor `scrollIntoView`, and an unhandled throw here would take out
            // the refusal this exists to show.
            ref.current?.scrollIntoView?.({
                block: 'start',
                behavior: 'auto'
            });
        });
        return ()=>cancelAnimationFrame(id);
    }, [
        ref,
        error,
        attempt
    ]);
}

});


parcelRegister("cxfrY", function(module, exports) {

$parcel$export(module.exports, "default", () => $90bb5414b618fd89$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $022jy = parcelRequire("022jy");
parcelRequire("5N0ZI");
var $5MbI8 = parcelRequire("5MbI8");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $4WVD9 = parcelRequire("4WVD9");
function $90bb5414b618fd89$export$2e2bcd8739ae039({ items: /** `[{ id, label, icon, onClick, tone, disabled, disabledReason, separatorBefore }]` */ items = [], subject: /** Names the record the actions apply to, for the trigger's accessible name. */ subject, title: title, 'data-testid': testId }) {
    const { t: t } = (0, $e1LEq.default)();
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const shown = items.filter(Boolean);
    if (!shown.length) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5MbI8.default), {
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $022jy.default), {
                    size: 18
                }),
                label: subject ? t('reception.day.moreActionsFor', {
                    name: subject
                }) : t('common.actions.more'),
                onClick: (e)=>{
                    e.stopPropagation();
                    setOpen(true);
                },
                variant: "ghost",
                "data-testid": testId ? `${testId}-trigger` : undefined
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4WVD9.default), {
                open: open,
                onClose: ()=>setOpen(false),
                title: title || subject,
                "data-testid": testId,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    role: "menu",
                    style: {
                        padding: '0.5rem 0.75rem 1rem',
                        display: 'grid',
                        gap: '0.125rem'
                    },
                    children: shown.map((item)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                            children: [
                                item.separatorBefore ? /*#__PURE__*/ (0, $ayMG0.jsx)("hr", {
                                    style: {
                                        border: 'none',
                                        borderTop: `1px solid ${(0, $jTCZr.C).border}`,
                                        margin: '0.375rem 0'
                                    }
                                }) : null,
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    type: "button",
                                    role: "menuitem",
                                    disabled: item.disabled,
                                    "aria-disabled": item.disabled || undefined,
                                    onClick: ()=>{
                                        setOpen(false);
                                        item.onClick?.();
                                    },
                                    "data-testid": testId ? `${testId}-item-${item.id}` : undefined,
                                    style: {
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '0.625rem',
                                        width: '100%',
                                        minHeight: '2.75rem',
                                        padding: '0.5rem 0.5rem',
                                        background: 'transparent',
                                        border: 'none',
                                        borderRadius: '0.5rem',
                                        textAlign: 'start',
                                        font: 'inherit',
                                        cursor: item.disabled ? 'default' : 'pointer',
                                        color: item.tone === 'danger' ? (0, $jTCZr.C).red : item.tone === 'success' ? (0, $jTCZr.C).green : (0, $jTCZr.C).textPrimary,
                                        opacity: item.disabled ? 0.5 : 1
                                    },
                                    children: [
                                        item.icon ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                display: 'grid',
                                                placeItems: 'center',
                                                width: 20,
                                                flexShrink: 0
                                            },
                                            children: item.icon
                                        }) : null,
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            style: {
                                                flex: 1,
                                                minWidth: 0
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    style: {
                                                        display: 'block',
                                                        fontSize: '0.875rem',
                                                        fontWeight: 600
                                                    },
                                                    children: item.label
                                                }),
                                                item.disabled && item.disabledReason ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    style: {
                                                        display: 'block',
                                                        fontSize: '0.6875rem',
                                                        color: (0, $jTCZr.C).textMuted,
                                                        fontWeight: 400
                                                    },
                                                    children: item.disabledReason
                                                }) : null
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, item.id))
                })
            })
        ]
    });
}

});

parcelRegister("cEwTy", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbfd1cbe86b4e107$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $2VplL = parcelRequire("2VplL");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $7gSBD = parcelRequire("7gSBD");
var $2vXUl = parcelRequire("2vXUl");
var $66joL = parcelRequire("66joL");

var $7NBSI = parcelRequire("7NBSI");

var $jTCZr = parcelRequire("jTCZr");

var $2xQve = parcelRequire("2xQve");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");
function $bbfd1cbe86b4e107$export$2e2bcd8739ae039({ loading: loading, error: error, onRetry: onRetry, items: items = [], renderItem: renderItem, filtersActive: /** True when any filter, search or non-default sort is applied. */ filtersActive = false, emptyFiltered: /** The filtered-empty state. `{ icon, title, description, action }` */ emptyFiltered, empty: /** The truly-empty state. `{ icon, title, description, action }` */ empty, more: /** `{ shown, total, onMore, loading }` — omit for a complete list. */ more, skeletonCount: skeletonCount = 5, renderSkeleton: /**
   * `(i) => node` — the placeholder for ONE item, shaped like the card this
   * list renders (an appointment card has an avatar and an action shelf, an
   * item card has neither), so the list keeps its geometry when the data lands.
   * Defaults to a plain `MobileCardSkeleton`.
   */ renderSkeleton, gap: gap = (0, $2xQve.STACK).tight, errorTitle: errorTitle, errorDescription: errorDescription, 'data-testid': testId }) {
    const { t: t, formatNumber: formatNumber } = (0, $e1LEq.default)();
    const state = loading ? 'loading' : error ? 'error' : items.length ? 'content' : 'empty';
    // The root is a `SkeletonRegion` ONLY while loading, and a plain box in the
    // other three states.
    //
    // Both halves of that matter. A `SkeletonRegion` announces and labels itself,
    // so making it the permanent root would leave a settled list still saying
    // «در حال بارگذاری». But a hand-rolled `role="status"` is no good either: the
    // kit's region is what knows whether it is nested inside a PAGE skeleton, and
    // only a real `SkeletonRegion` falls silent when it is — a phone page that
    // draws its own region around this list would otherwise announce "loading"
    // twice (DESIGN.md §"Loading & skeleton" — region root).
    const Root = state === 'loading' ? (0, $66joL.SkeletonRegion) : 'div';
    const rootProps = state === 'loading' ? {
        label: t('common.state.loading')
    } : {};
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(Root, {
        ...rootProps,
        "data-state": state,
        "data-testid": testId,
        style: {
            display: 'grid',
            gap: `${gap}px`
        },
        children: [
            state === 'loading' && Array.from({
                length: skeletonCount
            }, (_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                    children: renderSkeleton ? renderSkeleton(i) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7NBSI.default), {})
                }, i)),
            state === 'error' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2vXUl.default), {
                title: errorTitle || t('errors.state.unavailable'),
                description: errorDescription || error?.message,
                onRetry: onRetry,
                retryLabel: t('common.actions.retry')
            }),
            state === 'empty' && (filtersActive ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7gSBD.default), {
                icon: emptyFiltered?.icon || /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2VplL.default), {
                    size: 44,
                    strokeWidth: 1.5,
                    "aria-hidden": true
                }),
                title: emptyFiltered?.title || t('operations.empty.noneMatchFilters'),
                description: emptyFiltered?.description || t('common.empty.clearFiltersRetry'),
                action: emptyFiltered?.action
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7gSBD.default), {
                icon: empty?.icon,
                title: empty?.title,
                description: empty?.description,
                action: empty?.action
            })),
            state === 'content' && items.map(renderItem),
            state === 'content' && more && more.shown < more.total && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'grid',
                    gap: '0.25rem',
                    justifyItems: 'center',
                    marginTop: '0.25rem'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                        variant: "outline",
                        onClick: more.onMore,
                        disabled: more.loading,
                        style: {
                            width: '100%',
                            minHeight: '2.75rem'
                        },
                        "data-testid": testId ? `${testId}-more` : undefined,
                        children: more.loading ? t('common.state.loading') : t('common.actions.showMore')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            fontSize: '0.6875rem',
                            color: (0, $jTCZr.C).textMuted
                        },
                        children: t('common.pagination.shownOfTotal', {
                            shown: formatNumber(more.shown),
                            total: formatNumber(more.total)
                        })
                    })
                ]
            })
        ]
    });
}

});
parcelRegister("7NBSI", function(module, exports) {

$parcel$export(module.exports, "default", () => $46f4a4577733aa44$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("5N0ZI");
var $66joL = parcelRequire("66joL");

var $jTCZr = parcelRequire("jTCZr");

var $2xQve = parcelRequire("2xQve");
function $46f4a4577733aa44$export$2e2bcd8739ae039({ avatar: /** A leading disc, at the size the card's `Avatar` renders (0 for none). */ avatar = 0, metaLines: /** Meta lines under the head line. */ metaLines = 1, badge: /** A trailing pill on the head line (a status badge), 0 for none. */ badge = 56, actions: /** Buttons in an action shelf, 0 for none. */ actions = 0, chips: /** Small pills under the meta (tags, chips). */ chips = 0, style: style, ...rest }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "aria-hidden": true,
        style: {
            background: (0, $jTCZr.C).card,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: (0, $jTCZr.RADIUS).card,
            boxShadow: (0, $jTCZr.SHADOW).card,
            padding: '0.75rem 0.875rem',
            minHeight: '2.75rem',
            ...style
        },
        ...rest,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.625rem'
                },
                children: [
                    avatar > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonAvatar), {
                        size: avatar
                    }) : null,
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            flex: 1,
                            minWidth: 0,
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 6
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                width: "58%",
                                height: 15
                            }),
                            Array.from({
                                length: metaLines
                            }, (_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                    width: `${34 + i * 13 % 30}%`,
                                    height: 11
                                }, i))
                        ]
                    }),
                    badge > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: badge,
                        height: 22,
                        radius: (0, $jTCZr.RADIUS).pill
                    }) : null
                ]
            }),
            chips > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    display: 'flex',
                    gap: 6,
                    marginTop: '0.5rem'
                },
                children: Array.from({
                    length: chips
                }, (_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: 52 + i % 2 * 16,
                        height: 20,
                        radius: (0, $jTCZr.RADIUS).pill
                    }, i))
            }) : null,
            actions > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    display: 'flex',
                    gap: `${(0, $2xQve.STACK).tight}px`,
                    alignItems: 'center',
                    marginTop: '0.625rem',
                    paddingTop: '0.625rem',
                    borderTop: `1px solid ${(0, $jTCZr.C).border}`
                },
                children: Array.from({
                    length: actions
                }, (_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        height: 36,
                        radius: (0, $jTCZr.RADIUS).control,
                        style: {
                            flex: i === 0 ? 1 : 0,
                            width: i === 0 ? 'auto' : 36
                        }
                    }, i))
            }) : null
        ]
    });
}

});


parcelRegister("cXlM6", function(module, exports) {

$parcel$export(module.exports, "default", () => $b982416b514aff8a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "MobileCardHead", () => $b982416b514aff8a$export$9e6471883867892e);
$parcel$export(module.exports, "MobileCardMeta", () => $b982416b514aff8a$export$4e32faffccdacd70);
$parcel$export(module.exports, "MobileCardActions", () => $b982416b514aff8a$export$4012f9a151d0e1de);

var $ayMG0 = parcelRequire("ayMG0");

var $jTCZr = parcelRequire("jTCZr");

var $2xQve = parcelRequire("2xQve");
function $b982416b514aff8a$export$2e2bcd8739ae039({ children: children, onClick: onClick, label: /** Names the whole-card tap for assistive tech. Required with `onClick`. */ label, navigates: /** `true` when the tap navigates, so assistive tech announces a link. */ navigates = false, marker: /** A token colour for the inset status marker, or null for none. */ marker = null, muted: /** Dims a card whose record is finished or inactive. */ muted = false, tone: /** Tints the whole card, for a record that needs to be seen at a glance. */ tone = null, style: style, 'data-testid': testId, 'data-state': dataState, ...rest }) {
    const interactive = Boolean(onClick);
    const base = {
        position: 'relative',
        display: 'block',
        width: '100%',
        textAlign: 'start',
        background: tone || (0, $jTCZr.C).card,
        border: `1px solid ${(0, $jTCZr.C).border}`,
        borderRadius: (0, $jTCZr.RADIUS).card,
        boxShadow: marker ? `${(0, $jTCZr.SHADOW).card}, inset 3px 0 0 ${marker}` : (0, $jTCZr.SHADOW).card,
        padding: '0.75rem 0.875rem',
        minHeight: '2.75rem',
        opacity: muted ? 0.6 : 1,
        font: 'inherit',
        color: 'inherit',
        ...style
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: base,
        "data-testid": testId,
        "data-state": dataState,
        ...rest,
        children: [
            interactive && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                type: "button",
                role: navigates ? 'link' : undefined,
                onClick: onClick,
                "aria-label": label,
                "data-testid": testId ? `${testId}-open` : undefined,
                style: {
                    position: 'absolute',
                    inset: 0,
                    zIndex: 1,
                    width: '100%',
                    background: 'transparent',
                    border: 'none',
                    borderRadius: (0, $jTCZr.RADIUS).card,
                    cursor: 'pointer',
                    font: 'inherit'
                }
            }),
            children
        ]
    });
}
function $b982416b514aff8a$export$9e6471883867892e({ children: children, style: style }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            minWidth: 0,
            ...style
        },
        children: children
    });
}
function $b982416b514aff8a$export$4e32faffccdacd70({ parts: parts = [], style: style }) {
    const shown = parts.filter(Boolean);
    if (!shown.length) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        dir: "auto",
        style: {
            fontSize: '0.6875rem',
            color: (0, $jTCZr.C).textMuted,
            marginTop: '0.25rem',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            ...style
        },
        children: shown.reduce((acc, p, i)=>i === 0 ? [
                p
            ] : [
                ...acc,
                " \xb7 ",
                p
            ], [])
    });
}
function $b982416b514aff8a$export$4012f9a151d0e1de({ children: children, style: style }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: {
            position: 'relative',
            zIndex: 2,
            display: 'flex',
            gap: `${(0, $2xQve.STACK).tight}px`,
            alignItems: 'center',
            marginTop: '0.625rem',
            paddingTop: '0.625rem',
            borderTop: `1px solid ${(0, $jTCZr.soft)((0, $jTCZr.C).border, 1)}`,
            ...style
        },
        children: children
    });
}

});

parcelRegister("gmg4I", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f605f0d30605681$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $2rN5o = parcelRequire("2rN5o");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $h4ZeB = parcelRequire("h4ZeB");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $4WVD9 = parcelRequire("4WVD9");
function $4f605f0d30605681$export$2e2bcd8739ae039({ chips: /** `[{ id, label, count, active, disabled, disabledReason }]` */ chips = [], onSelect: onSelect, activeFilterCount: /** How many controls inside the sheet are currently non-default. */ activeFilterCount = 0, filterSheet: /** Sheet contents. Omit to render the strip alone. */ filterSheet, sticky: sticky = true, 'data-testid': testId }) {
    const { t: t, formatNumber: formatNumber } = (0, $e1LEq.default)();
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const reasons = chips.filter((c)=>c.disabled && c.disabledReason);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    ...sticky ? {
                        position: 'sticky',
                        top: 0,
                        zIndex: 2
                    } : null,
                    background: (0, $jTCZr.C).bg,
                    paddingBlock: '0.5rem'
                },
                "data-testid": testId,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        role: "group",
                        className: "mobile-strip",
                        style: {
                            display: 'flex',
                            gap: '0.375rem',
                            alignItems: 'center',
                            overflowX: 'auto',
                            paddingInline: '1rem'
                        },
                        children: [
                            chips.map((c)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $h4ZeB.default), {
                                    label: c.label,
                                    count: c.count == null ? undefined : formatNumber(c.count),
                                    active: c.active,
                                    disabled: c.disabled,
                                    onClick: ()=>onSelect?.(c.id),
                                    "data-testid": testId ? `${testId}-chip-${c.id}` : undefined,
                                    style: {
                                        flexShrink: 0
                                    }
                                }, c.id)),
                            filterSheet && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                                variant: activeFilterCount > 0 ? 'subtle' : 'outline',
                                size: "sm",
                                onClick: ()=>setOpen(true),
                                "aria-expanded": open,
                                "data-testid": testId ? `${testId}-filters` : undefined,
                                style: {
                                    flexShrink: 0,
                                    minHeight: '2.75rem',
                                    gap: '0.375rem'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2rN5o.default), {
                                        size: 14,
                                        "aria-hidden": "true"
                                    }),
                                    t('common.actions.filters'),
                                    activeFilterCount > 0 ? ` (${formatNumber(activeFilterCount)})` : ''
                                ]
                            })
                        ]
                    }),
                    reasons.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            paddingInline: '1rem',
                            marginTop: '0.375rem'
                        },
                        children: reasons.map((c)=>/*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                style: {
                                    fontSize: '0.6875rem',
                                    color: (0, $jTCZr.C).textMuted,
                                    margin: 0
                                },
                                children: c.disabledReason
                            }, c.id))
                    })
                ]
            }),
            filterSheet && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4WVD9.default), {
                open: open,
                onClose: ()=>setOpen(false),
                title: t('common.actions.filters'),
                "data-testid": testId ? `${testId}-filter-sheet` : undefined,
                footer: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        display: 'flex',
                        gap: '0.5rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                            onClick: ()=>{
                                filterSheet.onApply?.();
                                setOpen(false);
                            },
                            style: {
                                flex: 1,
                                minHeight: '2.75rem'
                            },
                            children: t('common.actions.apply')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                            variant: "outline",
                            onClick: ()=>{
                                filterSheet.onClear?.();
                                setOpen(false);
                            },
                            style: {
                                minHeight: '2.75rem'
                            },
                            children: t('common.actions.clearFilters')
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        padding: '0.875rem 1rem',
                        display: 'grid',
                        gap: '0.875rem'
                    },
                    children: filterSheet.children
                })
            })
        ]
    });
}

});

parcelRegister("0UhMT", function(module, exports) {

$parcel$export(module.exports, "default", () => $12ee0059e52e42ab$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("5N0ZI");
var $fh5c7 = parcelRequire("fh5c7");

var $jTCZr = parcelRequire("jTCZr");
function $12ee0059e52e42ab$export$2e2bcd8739ae039({ items: items, active: active, onSelect: onSelect, ariaLabel: ariaLabel, sticky: sticky = true, style: style }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: {
            ...sticky ? {
                position: 'sticky',
                top: 0,
                zIndex: 2
            } : null,
            background: (0, $jTCZr.C).bg,
            borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
            ...style
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fh5c7.default), {
            items: items,
            active: active,
            onSelect: onSelect,
            ariaLabel: ariaLabel
        })
    });
}

});

parcelRegister("bKUa1", function(module, exports) {

$parcel$export(module.exports, "default", () => $27374716a60e4315$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("5N0ZI");
var $9y25V = parcelRequire("9y25V");
function $27374716a60e4315$export$2e2bcd8739ae039({ tiles: tiles, loading: loading, columns: columns = 4, style: style, 'data-testid': testId }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: {
            paddingInline: '1rem',
            ...style
        },
        "data-testid": testId,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9y25V.default), {
            tiles: tiles,
            loading: loading,
            columns: columns
        })
    });
}

});

parcelRegister("brmQA", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b2e6d1ae620bd32$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("7c6z4");
var $gVWNP = parcelRequire("gVWNP");
function $9b2e6d1ae620bd32$export$2e2bcd8739ae039({ label: label, value: value, unit: /** «ت», «٪», «مورد» — whatever the figure is counted in. */ unit, tone: /** `null` (default), 'good', 'warn', 'danger', 'muted' */ tone = null, strong: /** Renders the row as the section's headline. */ strong = false, struck: /** Struck through, for a voided or superseded figure. */ struck = false, hint: hint, style: style, 'data-testid': testId }) {
    const color = {
        good: (0, $jTCZr.C).green,
        warn: (0, $jTCZr.C).amber,
        danger: (0, $jTCZr.C).red,
        muted: (0, $jTCZr.C).textMuted
    }[tone] || (strong ? (0, $jTCZr.C).textPrimary : (0, $jTCZr.C).textSecondary);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": testId,
        style: {
            display: 'flex',
            alignItems: 'baseline',
            justifyContent: 'space-between',
            gap: '0.75rem',
            minHeight: '1.75rem',
            ...style
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                style: {
                    minWidth: 0,
                    flexShrink: 1
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            display: 'block',
                            fontSize: strong ? '0.8125rem' : '0.75rem',
                            fontWeight: strong ? 700 : 500,
                            color: (0, $jTCZr.C).textSecondary
                        },
                        children: label
                    }),
                    hint ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            display: 'block',
                            fontSize: '0.6875rem',
                            color: (0, $jTCZr.C).textMuted
                        },
                        children: hint
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                ...(0, $gVWNP.LTR_TEXT),
                style: {
                    flexShrink: 0,
                    fontSize: strong ? '1.125rem' : '0.875rem',
                    fontWeight: strong ? 800 : 700,
                    color: color,
                    fontVariantNumeric: 'tabular-nums',
                    textDecoration: struck ? 'line-through' : undefined
                },
                children: [
                    value,
                    unit ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            fontSize: '0.6875rem',
                            fontWeight: 500,
                            marginInlineStart: '0.25rem',
                            color: (0, $jTCZr.C).textMuted
                        },
                        children: unit
                    }) : null
                ]
            })
        ]
    });
}

});

parcelRegister("dHEom", function(module, exports) {

$parcel$export(module.exports, "MobileMoneyTile", () => $cfaa6f09a6e97b04$export$7206b8becfe38ef7);
$parcel$export(module.exports, "MobileDetailRow", () => $cfaa6f09a6e97b04$export$a92006f72d09c5e2);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("52bn2");
var $jTCZr = parcelRequire("jTCZr");

var $cXlM6 = parcelRequire("cXlM6");

var $brmQA = parcelRequire("brmQA");
function $cfaa6f09a6e97b04$export$7206b8becfe38ef7({ label: label, value: value, hint: hint, tone: tone, onClick: onClick, testid: testid }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cXlM6.default), {
        onClick: onClick,
        label: label,
        tone: tone === 'warn' ? (0, $jTCZr.C).amberLight : undefined,
        "data-testid": testid,
        style: {
            padding: '0.75rem 0.875rem'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $brmQA.default), {
            label: label,
            value: value,
            hint: hint,
            tone: tone
        })
    });
}
function $cfaa6f09a6e97b04$export$a92006f72d09c5e2({ label: label, value: value }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            justifyContent: 'space-between',
            gap: '0.75rem',
            padding: '0.5rem 0',
            borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
            fontSize: '0.8125rem'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                style: {
                    color: (0, $jTCZr.C).textMuted
                },
                children: label
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                dir: "auto",
                style: {
                    color: (0, $jTCZr.C).textPrimary,
                    fontWeight: 600,
                    textAlign: 'end'
                },
                children: value
            })
        ]
    });
}

});

parcelRegister("71yN3", function(module, exports) {

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("5N0ZI");
var $gehDE = parcelRequire("gehDE");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");
function $15edba17e2b51dc8$export$2e2bcd8739ae039({ value: value, onChange: onChange, dateLabel: dateLabel, subLabel: subLabel, isToday: isToday, onPrev: onPrev, onNext: onNext, onToday: onToday }) {
    const { t: t } = (0, $e1LEq.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gehDE.default), {
        value: value,
        onChange: onChange,
        dateLabel: dateLabel,
        subLabel: subLabel,
        isToday: isToday,
        onPrev: onPrev,
        onNext: onNext,
        onToday: onToday,
        prevLabel: t('reception.dayNav.previous'),
        nextLabel: t('reception.dayNav.next'),
        pickLabel: t('reception.dayNav.pickDate'),
        todayLabel: t('reception.dayNav.today'),
        sheetTitle: t('reception.dayNav.pickDate'),
        closeLabel: t('common.actions.close'),
        variant: "onGradient"
    });
}

});

parcelRegister("aLdCl", function(module, exports) {

$parcel$export(module.exports, "default", () => $3579b91a05457596$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $5g6Xf = parcelRequire("5g6Xf");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");
function $3579b91a05457596$export$2e2bcd8739ae039({ what: what, style: style, 'data-testid': testId }) {
    const { t: t } = (0, $e1LEq.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
        variant: "neutral",
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5g6Xf.default), {
            size: 16,
            "aria-hidden": "true"
        }),
        style: style,
        "data-testid": testId || 'mobile-desktop-note',
        children: t('operations.desktopOnly.notice', {
            what: what
        })
    });
}

});
parcelRegister("5g6Xf", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e79cc7fca7ac647$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $4e79cc7fca7ac647$export$a2387ed3b5d536eb = {
    name: "monitor",
    size: 24,
    node: [
        [
            "rect",
            {
                width: "20",
                height: "14",
                x: "2",
                y: "3",
                rx: "2",
                key: "48i651"
            }
        ],
        [
            "line",
            {
                x1: "8",
                x2: "16",
                y1: "21",
                y2: "21",
                key: "1svkeh"
            }
        ],
        [
            "line",
            {
                x1: "12",
                x2: "12",
                y1: "17",
                y2: "21",
                key: "vw1qmm"
            }
        ]
    ]
};
$4e79cc7fca7ac647$export$a2387ed3b5d536eb.node;
const $4e79cc7fca7ac647$export$2e2bcd8739ae039 = (0, $9QBug.default)($4e79cc7fca7ac647$export$a2387ed3b5d536eb);

});


parcelRegister("ajGTC", function(module, exports) {

$parcel$export(module.exports, "default", () => $f411e01e122ab4a1$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("5N0ZI");
var $7wZCE = parcelRequire("7wZCE");
var $bHjRG = parcelRequire("bHjRG");
var $aJ1FU = parcelRequire("aJ1FU");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("7c6z4");
var $gVWNP = parcelRequire("gVWNP");
var $e1LEq = parcelRequire("e1LEq");

var $cXlM6 = parcelRequire("cXlM6");

var $cxfrY = parcelRequire("cxfrY");
/**
 * One appointment, as a card (docs/MOBILE-REDESIGN.md §4.7, §6.1).
 *
 * **Render-only, and deliberately vocabulary-free.** Every word and every status
 * colour arrives already resolved: `flow`, `pay`, `urgency` and `meta` come from
 * the reception vocabulary (`Reception/dayPanel.jsx`) and `ops` from the shared
 * op matrix (`Reception/rowOps.js`). That is what keeps `src/mobile/` a LAYOUT
 * library — a card that imported a screen's vocabulary would make the dependency
 * point the wrong way, and a card that re-derived «حاضر» would be the second
 * answer §2.5 forbids.
 *
 * The anatomy is fixed because a desk scans forty of these:
 *
 *   ① queue position · time · urgency ……………………………… flow status
 *   ② avatar · name · «بدون پرونده» …………………… pay chip + amount
 *   ③ پرونده {n} · حضوری · {phone}
 *   ③b a finished visit's «کد رهگیری نسخه» chips, when it has any (PM-0686)
 *   ④ the primary action (+ a companion, when there is one) …………… ⋮
 *
 * ④ is the first `primary` op from the matrix; every other operation is a ≥44px
 * row in the sheet behind ⋮. A phone that laid four small buttons across a card
 * would give each of them about 70px, and «لغو نوبت» beside «ثبت حضور» at 70px
 * is a cancelled appointment.
 *
 * AT MOST ONE op may join it, and only by asking: `companion` on the matrix. It
 * splits the shelf in half — never a third button, which is how the 70px row
 * starts. Today that is «شروع ویزیت» / «ادامهٔ ویزیت» on the row of a person who
 * is both this desk and this doctor: the money is the desk's job and the visit is
 * theirs, and neither may be buried in a menu behind the other. It is rendered
 * `teal` against the primary's navy — the clinical act and the desk's act are not
 * the same kind of act, and at a glance the colour is what says so.
 *
 * The whole card body is the tap target for the patient's record — the same
 * thing the desktop row click does. It is only interactive when there IS a
 * record: a «ثبت سریع» placeholder has no file to open, so the card is inert
 * and «تکمیل پرونده» is its primary action instead.
 */ // The pay chip's four states, in the kit's own semantic variants rather than a
// fifth palette invented here.
const $f411e01e122ab4a1$var$PAY_VARIANT = {
    settled: 'success',
    partial: 'warning',
    due: 'destructive',
    free: 'outline'
};
// «پیش‌پرداخت» (PM-0657 §6.3): held is the teal of money the clinic holds, a
// missing REQUIRED deposit the amber of a warning, the closed states neutral.
const $f411e01e122ab4a1$var$DEPOSIT_VARIANT = {
    held: 'success',
    missing: 'warning'
};
function $f411e01e122ab4a1$export$2e2bcd8739ae039({ row: /** The derived reception row: `{ id, name, time, placeholder, … }`. */ row, queuePos: /** Position in this doctor's queue, or null when the patient is not in it. */ queuePos = null, flow: /** `{ label, dot }` from FLOW_STATUS — where the patient is in the visit flow. */ flow, pay: /** `{ label, cls }` from PAY_STATUS, or null. */ pay = null, amount: /** The outstanding amount, ALREADY in toman and formatted. Null when nothing is due. */ amount = null, urgency: /** `{ l, color, bg }` from URGENCY_BADGE, or null. */ urgency = null, meta: /** The sub-line's parts, already built and already digit-formatted. */ meta = [], ops: /** The ordered op list from `rowOperations()`. */ ops = [], onOpen: /** Opens the patient's record. Omit for a row with no patient. */ onOpen, queueLabel: /** «نفر بعدی» / «نوبت {n}», already worded and digit-formatted. */ queueLabel = null, timeLabel: /** The time, already digit-formatted. */ timeLabel = null, noFileLabel: /** «بدون پرونده» — the marker on a «ثبت سریع» row. */ noFileLabel = null, onlineLabel: /** «آنلاین» — the patient booked it themselves (PM-0382), already worded. */ onlineLabel = null, onlineHint: /** Which online channel it was, as a sentence for the tooltip. */ onlineHint = null, muted: /** Dims a finished row (ویزیت‌شده / عدم‌حضور / لغو شده). */ muted = false, deposit: /** `{ kind, label }` — the «پیش‌پرداخت» chip (PM-0657), already worded; null = none. */ deposit = null, erx: /**
   * The finished visit's «کد رهگیری نسخه» chips (PM-0686), already a node — the card
   * only gives it a place, so it stays vocabulary-free. Null = nothing to show.
   */ erx = null, 'data-testid': testId }) {
    const { t: t } = (0, $e1LEq.default)();
    const primary = ops.find((o)=>o.primary) || ops[0] || null;
    // Only when it is not already the primary — a paid row has no money op, so the
    // visit IS `ops[0]` there and takes the whole shelf, as it did before.
    const companion = ops.find((o)=>o.companion && o !== primary) || null;
    const rest = ops.filter((o)=>o !== primary && o !== companion);
    const emergency = row?.urgency === 'emergency';
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cXlM6.default), {
        onClick: onOpen,
        // The overlay that makes the whole card tappable has no text of its own,
        // so it is named here. Without it a screen reader announces the card's
        // primary affordance as an unlabelled button.
        label: row?.name ? t('reception.mobile.openRecordFor', {
            name: row.name
        }) : undefined,
        navigates: Boolean(onOpen),
        marker: flow?.dot || null,
        muted: muted,
        // An emergency is a safety fact (§2.4 rule 1): it stays visible at a
        // glance even when the row is finished and dimmed.
        tone: emergency ? (0, $jTCZr.soft)((0, $jTCZr.C).red, 0.06) : null,
        "data-testid": testId,
        "data-state": row?.flow,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cXlM6.MobileCardHead), {
                children: [
                    queueLabel ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bHjRG.default), {
                        variant: queuePos === 1 ? 'default' : 'outline',
                        "data-testid": testId ? `${testId}-queue` : undefined,
                        children: queueLabel
                    }) : null,
                    timeLabel ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        ...(0, $gVWNP.LTR_TEXT),
                        style: {
                            fontSize: '0.9375rem',
                            fontWeight: 800,
                            fontVariantNumeric: 'tabular-nums',
                            letterSpacing: '-0.02em',
                            color: (0, $jTCZr.C).textPrimary
                        },
                        children: timeLabel
                    }) : null,
                    urgency ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            fontSize: '0.625rem',
                            fontWeight: 800,
                            borderRadius: '0.3125rem',
                            padding: '0.0625rem 0.375rem',
                            whiteSpace: 'nowrap',
                            flexShrink: 0,
                            color: urgency.color,
                            background: urgency.bg
                        },
                        children: urgency.l
                    }) : null,
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            flex: 1
                        }
                    }),
                    flow ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        style: {
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '0.3125rem',
                            fontSize: '0.75rem',
                            fontWeight: 700,
                            color: flow.dot,
                            whiteSpace: 'nowrap'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                "aria-hidden": "true",
                                style: {
                                    width: '0.375rem',
                                    height: '0.375rem',
                                    borderRadius: '50%',
                                    background: flow.dot,
                                    display: 'inline-block'
                                }
                            }),
                            flow.label
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    marginTop: '0.5rem',
                    minWidth: 0
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7wZCE.default), {
                        name: row?.name,
                        size: 34
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        dir: "auto",
                        style: {
                            flex: 1,
                            minWidth: 0,
                            fontSize: '0.875rem',
                            fontWeight: 700,
                            color: (0, $jTCZr.C).textPrimary,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                        },
                        children: row?.name
                    }),
                    noFileLabel ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bHjRG.default), {
                        variant: "warning",
                        children: noFileLabel
                    }) : null,
                    onlineLabel ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bHjRG.default), {
                        variant: "default",
                        title: onlineHint || undefined,
                        "data-testid": testId ? `${testId}-online` : undefined,
                        children: onlineLabel
                    }) : null,
                    pay ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bHjRG.default), {
                        variant: $f411e01e122ab4a1$var$PAY_VARIANT[pay.cls] || 'outline',
                        "data-testid": testId ? `${testId}-pay` : undefined,
                        children: [
                            pay.label,
                            amount ? /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                ...(0, $gVWNP.LTR_TEXT),
                                style: {
                                    marginInlineStart: '0.25rem',
                                    fontWeight: 800
                                },
                                children: amount
                            }) : null
                        ]
                    }) : null,
                    deposit ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bHjRG.default), {
                        variant: $f411e01e122ab4a1$var$DEPOSIT_VARIANT[deposit.kind] || 'outline',
                        "data-testid": testId ? `${testId}-deposit` : 'reception-deposit-chip',
                        "data-kind": deposit.kind,
                        children: deposit.label
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cXlM6.MobileCardMeta), {
                parts: meta
            }),
            erx ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    position: 'relative',
                    zIndex: 2,
                    marginTop: '0.5rem'
                },
                children: erx
            }) : null,
            primary ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cXlM6.MobileCardActions), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                        variant: primary.danger ? 'destructive' : 'default',
                        // The card itself navigates; an action inside it must not do both.
                        onClick: primary.onClick,
                        // `flex: 1` on both halves, and `minWidth: 0` so a long label
                        // ellipsises inside its half instead of pushing the other one out.
                        style: {
                            flex: 1,
                            minWidth: 0,
                            minHeight: '2.75rem'
                        },
                        "data-testid": testId ? `${testId}-primary` : undefined,
                        children: primary.label
                    }),
                    companion ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                        variant: "teal",
                        onClick: companion.onClick,
                        style: {
                            flex: 1,
                            minWidth: 0,
                            minHeight: '2.75rem'
                        },
                        "data-testid": testId ? `${testId}-companion` : undefined,
                        children: companion.label
                    }) : null,
                    rest.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cxfrY.default), {
                        subject: row?.name,
                        items: rest.map((o)=>({
                                id: o.id,
                                label: o.label,
                                tone: o.danger ? 'danger' : undefined,
                                // One rule between the ops that act on the VISIT and the ops that
                                // act on the PATIENT — «لغو نوبت» and «پرونده بیمار» flush against
                                // each other invite the mis-click.
                                separatorBefore: o.patient && rest.indexOf(o) > 0 && !rest[rest.indexOf(o) - 1].patient,
                                onClick: o.onClick
                            })),
                        "data-testid": testId ? `${testId}-menu` : undefined
                    })
                ]
            }) : null
        ]
    });
}

});

parcelRegister("3P099", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba7f40ecc552be09$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("5N0ZI");
var $7wZCE = parcelRequire("7wZCE");
var $aJ1FU = parcelRequire("aJ1FU");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("7c6z4");
var $gVWNP = parcelRequire("gVWNP");

var $cXlM6 = parcelRequire("cXlM6");
function $ba7f40ecc552be09$export$2e2bcd8739ae039({ name: name, meta: /** Sub-line parts — date, time, doctor, reference. Missing ones are omitted. */ meta = [], amount: /** Already formatted, already in toman. */ amount, unit: unit, negative: /** Renders the leading «−» that says the money went the other way. */ negative = false, struck: struck = false, tone: /** 'good' (money in) | 'danger' (money out) | 'muted' (void, or not yet real) */ tone = 'good', badges: /** `[{ key, label, bg, text }]` — method, invoice status, transaction status. */ badges = [], notes: /** Finished sentences shown under the badges: a void reason, a partial refund. */ notes = [], onOpen: onOpen, openLabel: openLabel, menu: /** A `MobileRowMenu` element, or null when the viewer may do nothing here. */ menu, 'data-testid': testId }) {
    const amountColor = tone === 'danger' ? (0, $jTCZr.C).red : tone === 'muted' ? (0, $jTCZr.C).textMuted : (0, $jTCZr.C).green;
    const body = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7wZCE.default), {
                name: name,
                size: 36
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                style: {
                    flex: 1,
                    minWidth: 0,
                    display: 'block'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        style: {
                            display: 'flex',
                            alignItems: 'baseline',
                            justifyContent: 'space-between',
                            gap: '0.5rem'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                dir: "auto",
                                style: {
                                    fontSize: '0.8125rem',
                                    fontWeight: 700,
                                    color: tone === 'muted' ? (0, $jTCZr.C).textMuted : (0, $jTCZr.C).textPrimary,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'
                                },
                                children: name
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                ...(0, $gVWNP.LTR_TEXT),
                                style: {
                                    flexShrink: 0,
                                    fontSize: '0.875rem',
                                    fontWeight: 800,
                                    color: amountColor,
                                    fontVariantNumeric: 'tabular-nums',
                                    textDecoration: struck ? 'line-through' : undefined,
                                    whiteSpace: 'nowrap'
                                },
                                children: [
                                    negative ? "\u2212" : '',
                                    amount,
                                    unit ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            fontSize: '0.6875rem',
                                            fontWeight: 500,
                                            color: (0, $jTCZr.C).textMuted,
                                            marginInlineStart: '0.1875rem'
                                        },
                                        children: unit
                                    }) : null
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cXlM6.MobileCardMeta), {
                        parts: meta
                    }),
                    badges.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: '0.25rem',
                            marginTop: '0.375rem'
                        },
                        children: badges.map((b)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                "data-testid": testId ? `${testId}-badge-${b.key}` : undefined,
                                style: {
                                    padding: '0.125rem 0.5rem',
                                    borderRadius: '999px',
                                    fontSize: '0.625rem',
                                    fontWeight: 700,
                                    background: b.bg,
                                    color: b.text,
                                    whiteSpace: 'nowrap'
                                },
                                children: b.label
                            }, b.key))
                    }),
                    notes.filter(Boolean).map((note, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            style: {
                                display: 'block',
                                marginTop: '0.25rem',
                                fontSize: '0.6875rem',
                                color: (0, $jTCZr.C).textMuted,
                                lineHeight: 1.6
                            },
                            children: note
                        }, i))
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cXlM6.default), {
        muted: tone === 'muted',
        marker: tone === 'danger' ? (0, $jTCZr.C).red : undefined,
        "data-testid": testId,
        "data-state": tone,
        style: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: '0.375rem',
            padding: '0.5rem 0.5rem 0.5rem 0.375rem'
        },
        children: [
            onOpen ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                variant: "ghost",
                onClick: onOpen,
                "aria-label": openLabel,
                "data-testid": testId ? `${testId}-open` : undefined,
                className: "flex-1 min-w-0 justify-start items-start gap-2.5 whitespace-normal",
                style: {
                    height: 'auto',
                    minHeight: '2.75rem',
                    padding: '0.375rem 0.5rem',
                    textAlign: 'start'
                },
                children: body
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                style: {
                    flex: 1,
                    minWidth: 0,
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '0.625rem',
                    padding: '0.375rem 0.5rem'
                },
                children: body
            }),
            menu || null
        ]
    });
}

});

parcelRegister("9HOnT", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1d13e4b5fb488a7$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("7c6z4");
var $gVWNP = parcelRequire("gVWNP");

var $cXlM6 = parcelRequire("cXlM6");

var $brmQA = parcelRequire("brmQA");
function $a1d13e4b5fb488a7$export$2e2bcd8739ae039({ patientName: patientName, insurerName: insurerName, invoiceNumber: invoiceNumber, invoiceNumberLabel: invoiceNumberLabel, statusBadge: /** `{ label, bg, text }` — the claim's status, from the shared vocabulary. */ statusBadge, moneyRows: /** `[{ key, label, value, tone, strong }]` — claimed / paid / outstanding. */ moneyRows = [], note: /** Shown when a shortfall still has no disposition recorded. */ note, 'data-testid': testId }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cXlM6.default), {
        "data-testid": testId,
        "data-state": "content",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'flex-start',
                    justifyContent: 'space-between',
                    gap: '0.5rem'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            minWidth: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                dir: "auto",
                                style: {
                                    fontSize: '0.8125rem',
                                    fontWeight: 700,
                                    color: (0, $jTCZr.C).textPrimary,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'
                                },
                                children: patientName
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cXlM6.MobileCardMeta), {
                                parts: [
                                    insurerName
                                ]
                            })
                        ]
                    }),
                    statusBadge ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        "data-testid": testId ? `${testId}-status` : undefined,
                        style: {
                            flexShrink: 0,
                            padding: '0.125rem 0.5rem',
                            borderRadius: '999px',
                            fontSize: '0.625rem',
                            fontWeight: 700,
                            background: statusBadge.bg,
                            color: statusBadge.text,
                            whiteSpace: 'nowrap'
                        },
                        children: statusBadge.label
                    }) : null
                ]
            }),
            invoiceNumber ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    marginTop: '0.375rem',
                    fontSize: '0.6875rem',
                    color: (0, $jTCZr.C).textMuted
                },
                children: [
                    invoiceNumberLabel,
                    ' ',
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        ...(0, $gVWNP.LTR_TEXT),
                        style: {
                            fontVariantNumeric: 'tabular-nums'
                        },
                        children: invoiceNumber
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    marginTop: '0.5rem',
                    display: 'grid',
                    gap: '0.125rem'
                },
                children: moneyRows.map((r)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $brmQA.default), {
                        label: r.label,
                        value: r.value,
                        unit: r.unit,
                        tone: r.tone,
                        strong: r.strong,
                        "data-testid": testId ? `${testId}-${r.key}` : undefined
                    }, r.key))
            }),
            note ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                style: {
                    margin: '0.375rem 0 0',
                    fontSize: '0.6875rem',
                    color: (0, $jTCZr.C).amber,
                    lineHeight: 1.6
                },
                children: note
            }) : null
        ]
    });
}

});

parcelRegister("a3DRM", function(module, exports) {

var $ayMG0 = parcelRequire("ayMG0");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("7c6z4");
var $gVWNP = parcelRequire("gVWNP");
function $07b92302225bdf1a$export$2e2bcd8739ae039({ items: /** `[{ key, label, valueText, percent, color }]` — `percent` is 0–100. */ items = [], emptyLabel: emptyLabel, 'data-testid': testId }) {
    if (!items.length) return /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
        "data-testid": testId,
        "data-state": "empty",
        style: {
            margin: 0,
            fontSize: '0.75rem',
            color: (0, $jTCZr.C).textMuted
        },
        children: emptyLabel
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
        "data-testid": testId,
        "data-state": "content",
        style: {
            margin: 0,
            padding: 0,
            listStyle: 'none',
            display: 'grid',
            gap: '0.75rem'
        },
        children: items.map((d)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                "data-testid": testId ? `${testId}-${d.key}` : undefined,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            justifyContent: 'space-between',
                            gap: '0.75rem',
                            marginBottom: '0.3125rem'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                dir: "auto",
                                style: {
                                    fontSize: '0.8125rem',
                                    fontWeight: 600,
                                    color: (0, $jTCZr.C).textSecondary,
                                    minWidth: 0,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'
                                },
                                children: d.label
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                ...(0, $gVWNP.LTR_TEXT),
                                style: {
                                    flexShrink: 0,
                                    fontSize: '0.8125rem',
                                    fontWeight: 700,
                                    color: (0, $jTCZr.C).textPrimary,
                                    fontVariantNumeric: 'tabular-nums'
                                },
                                children: d.valueText
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        "aria-hidden": "true",
                        style: {
                            height: '0.5rem',
                            background: (0, $jTCZr.C).bg,
                            borderRadius: (0, $jTCZr.RADIUS).chip,
                            overflow: 'hidden'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                height: '100%',
                                width: `${Math.max(0, Math.min(100, d.percent || 0))}%`,
                                background: d.color || (0, $jTCZr.C).navy,
                                borderRadius: 'inherit'
                            }
                        })
                    })
                ]
            }, d.key))
    });
}

});

parcelRegister("2px22", function(module, exports) {

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("5N0ZI");
var $7wZCE = parcelRequire("7wZCE");
var $aJ1FU = parcelRequire("aJ1FU");
var $5AX1S = parcelRequire("5AX1S");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("7c6z4");
var $gVWNP = parcelRequire("gVWNP");
var $e1LEq = parcelRequire("e1LEq");

var $cXlM6 = parcelRequire("cXlM6");

var $brmQA = parcelRequire("brmQA");
function $aeda58823364d336$export$2e2bcd8739ae039({ invoice: invoice, paid: /** Σ of the payments recorded against it, in RIALS. */ paid = 0, due: /** What is still owed, in RIALS. */ due = 0, statusMeta: /** `{ label, bg, text }` from `STATUS_META` — the money-derived status, not the wire one. */ statusMeta, canSettle: /** True when the invoice can still be settled (neither PAID nor VOID). */ canSettle = false, onOpen: onOpen, onSettle: onSettle, 'data-testid': testId }) {
    const { t: t, moneyUnit: moneyUnit, formatMoney: formatMoney, formatList: formatList } = (0, $e1LEq.default)();
    const name = invoice.patientName || t('patients.placeholder.byId', {
        id: invoice.patientId?.slice(-6) || ''
    });
    const descriptions = (invoice.lineItems || []).map((li)=>li.description).filter(Boolean);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cXlM6.default), {
        // Tapping the body opens the invoice, exactly as clicking the desktop's
        // row does. This is safe to pair with the action button below because
        // `MobileCard`'s tap target is a sibling overlay rather than a wrapper —
        // the two controls sit side by side in the DOM instead of nesting, which
        // is what would have been invalid.
        onClick: onOpen ? ()=>onOpen(invoice) : undefined,
        label: t('cashier.mobile.openInvoiceFor', {
            name: name
        }),
        marker: due > 0 ? (0, $jTCZr.C).red : (0, $jTCZr.C).green,
        "data-testid": testId,
        "data-state": canSettle ? 'open' : 'closed',
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cXlM6.MobileCardHead), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7wZCE.default), {
                        name: name,
                        size: 36
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        style: {
                            flex: 1,
                            minWidth: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                dir: "auto",
                                style: {
                                    display: 'block',
                                    fontSize: '0.875rem',
                                    fontWeight: 700,
                                    color: (0, $jTCZr.C).textPrimary,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'
                                },
                                children: name
                            }),
                            invoice.doctorName ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    display: 'block',
                                    fontSize: '0.6875rem',
                                    color: (0, $jTCZr.C).textSecondary
                                },
                                children: t('doctors.placeholder.withTitle', {
                                    name: invoice.doctorName
                                })
                            }) : null
                        ]
                    }),
                    statusMeta ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            flexShrink: 0,
                            fontSize: '0.625rem',
                            fontWeight: 700,
                            padding: '0.1875rem 0.625rem',
                            borderRadius: 999,
                            background: statusMeta.bg,
                            color: statusMeta.text,
                            whiteSpace: 'nowrap'
                        },
                        "data-testid": testId ? `${testId}-status` : undefined,
                        children: statusMeta.label
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cXlM6.MobileCardMeta), {
                parts: [
                    descriptions.length ? formatList(descriptions) : t('accounting.empty.noLineItems'),
                    invoice.patientPhone ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        ...(0, $gVWNP.LTR_TEXT),
                        children: (0, $5AX1S).forDisplay(invoice.patientPhone)
                    }, "phone") : null
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'grid',
                    gap: '0.125rem',
                    marginTop: '0.5rem'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $brmQA.default), {
                        label: t('cashier.invoice.total'),
                        value: formatMoney(invoice.patientPayable, {
                            currency: invoice?.currency
                        }),
                        unit: moneyUnit('short', invoice?.currency),
                        "data-testid": testId ? `${testId}-total` : undefined
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $brmQA.default), {
                        label: t('accounting.fields.paid'),
                        value: formatMoney(paid),
                        unit: moneyUnit('short'),
                        tone: paid > 0 ? 'good' : 'muted',
                        "data-testid": testId ? `${testId}-paid` : undefined
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $brmQA.default), {
                        label: t('accounting.fields.remaining'),
                        value: formatMoney(due),
                        unit: moneyUnit('short'),
                        tone: due > 0 ? 'danger' : 'good',
                        strong: true,
                        "data-testid": testId ? `${testId}-due` : undefined
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cXlM6.MobileCardActions), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                    variant: canSettle ? 'default' : 'outline',
                    onClick: ()=>canSettle && onSettle ? onSettle(invoice) : onOpen?.(invoice),
                    "aria-label": t('cashier.mobile.openInvoice', {
                        name: name
                    }),
                    style: {
                        flex: 1,
                        minHeight: '2.75rem'
                    },
                    "data-testid": testId ? `${testId}-${canSettle ? 'settle' : 'view'}` : undefined,
                    children: canSettle ? t('accounting.actions.settle') : t('common.actions.view')
                })
            })
        ]
    });
}

});

parcelRegister("c5gO0", function(module, exports) {

$parcel$export(module.exports, "default", () => $287c3b7301b3c36e$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $aGlWN = parcelRequire("aGlWN");
var $8g4t5 = parcelRequire("8g4t5");
var $lUsTt = parcelRequire("lUsTt");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $7wZCE = parcelRequire("7wZCE");
var $aJ1FU = parcelRequire("aJ1FU");
var $cjPik = parcelRequire("cjPik");
var $5AX1S = parcelRequire("5AX1S");
var $a7Rbr = parcelRequire("a7Rbr");

var $5OgPq = parcelRequire("5OgPq");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("7c6z4");
var $aBaxB = parcelRequire("aBaxB");
var $gVWNP = parcelRequire("gVWNP");
var $e1LEq = parcelRequire("e1LEq");

var $kZuTn = parcelRequire("kZuTn");

var $1zLkf = parcelRequire("1zLkf");

var $ciRrJ = parcelRequire("ciRrJ");

var $407sw = parcelRequire("407sw");

var $5pHac = parcelRequire("5pHac");

var $eP0nH = parcelRequire("eP0nH");

var $4WVD9 = parcelRequire("4WVD9");

var $9fovs = parcelRequire("9fovs");

var $6y32F = parcelRequire("6y32F");

var $brmQA = parcelRequire("brmQA");

var $cxfrY = parcelRequire("cxfrY");

var $69ZlR = parcelRequire("69ZlR");

var $jpfyA = parcelRequire("jpfyA");

var $3fdwV = parcelRequire("3fdwV");
/**
 * Taking a payment, on a phone. The reason the cashier screen has a mobile
 * surface at all.
 *
 * Issuing a complex invoice stays a desk job; TAKING money is the most common
 * standing-up money action in a clinic, and refusing it on a phone is why staff
 * photograph invoices. So this sheet carries the whole settle flow — the lines,
 * the waterfall, issuance, the amount, the method, the reference and the
 * patient's on-account credit — and it does so without re-deriving a single
 * figure: every rule below comes from `lib/billing.js`, which the desktop
 * drawer reads too.
 *
 * The rules that are easy to lose in a rewrite, and are not:
 *
 *   • `shownStatus` is derived from MONEY, not from the wire status — the two
 *     legitimately disagree for a beat after a payment clears.
 *   • `frozen` (an ISSUED invoice) means the lines are never edited or removed; a
 *     correction is a negative line or void-and-reissue.
 *   • `canRemove` needs no payment, no settlement and no issuance, and the VISIT
 *     line is never removable at all.
 *   • Adding a line to a SETTLED invoice reopens it, so it asks first, with the
 *     full consequence including "the new line will not be removable".
 *   • The insurer's share is editable only where nothing computed it; overriding a
 *     computed one needs `payments.manage` and a mandatory reason.
 *   • An empty invoice's typed amount becomes the VISIT line BEFORE the payment.
 *   • `recordPayment` goes WITHOUT a `shiftId`, so the service banks it into the
 *     drawer that is actually open.
 *   • Overpayment is NAMED, never rounded into a tidy zero.
 *
 * The summary is stacked full-width rows rather than a KPI grid: a quarter of
 * 320px cannot hold a large toman figure, and the row would take the page into
 * horizontal scroll.
 */ function $287c3b7301b3c36e$var$MobileSettleSheet({ open: open, invoice: invoice, onClose: onClose, onPaymentDone: onPaymentDone, tariffs: tariffs = [], recordPayment: recordPayment, addLineItem: addLineItem, updateLineItem: updateLineItem, overrideLineInsurance: overrideLineInsurance, removeLineItem: removeLineItem, setInvoiceDiscount: setInvoiceDiscount, getPayments: getPayments, issueInvoice: issueInvoice, applyCredit: applyCredit, getCreditBalance: getCreditBalance, canOverrideInsurance: canOverrideInsurance = false, openAddItem: openAddItem = false, openSection: openSection = null, settlement: // «خدمت نوبت» — the same settlement the desktop drawer reads, so the phone
// and the desk cannot tell different stories about one appointment
// (docs/CLINIC_RECEPTION_SERVICE_INVOICE_DESIGN.md §10).
settlement = null, onChangeService: onChangeService, onReconcileService: onReconcileService }) {
    const { t: t, moneyUnit: moneyUnit, formatNumber: formatNumber, formatMoney: formatMoney, formatTime: formatTime, currency: currency, toDisplayAmount: toDisplayAmount, parseMoney: parseMoney } = (0, $e1LEq.default)();
    const [method, setMethod] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState((0, $5pHac.DEFAULT_PAYMENT_METHOD));
    const [reference, setReference] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [creditBalance, setCreditBalance] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    const [issuing, setIssuing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [saving, setSaving] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [addingItem, setAddingItem] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [reopenAsk, setReopenAsk] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [discountOpen, setDiscountOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [editingId, setEditingId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // «تغییر خدمت» / «هم‌سان‌سازی» — the same two acts the desk has, in a sheet.
    const [serviceAsk, setServiceAsk] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [reconciling, setReconciling] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // «قیمت دستی» — the same mandatory reason the desk gives (§D7).
    const [manualReason, setManualReason] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [error, setErrorText] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    /**
   * Bumped on every refusal, including a REPEAT of the same one.
   *
   * The scroll below keys on this rather than on `error`, and that is the whole
   * point of having it: «صندوقی به نام شما باز نیست» twice in a row is the same
   * string, so an effect watching the text would fire once and never again. The
   * operator taps پرداخت, scrolls away, taps it again — and the second tap would
   * look like nothing happened, which is the bug this fixes.
   */ const [errorSeq, setErrorSeq] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    const errorRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    /** Every refusal in this sheet goes through here, so none can forget to scroll. */ const setError = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((message)=>{
        setErrorText(message);
        if (message) setErrorSeq((n)=>n + 1);
    }, []);
    /**
   * Take the operator to the refusal — the shared behaviour every sheet in
   * this folder needs, because they all dock the commit button in the footer
   * and render the error at the top of the scroll body.
   */ (0, $9fovs.default)(errorRef, error, errorSeq);
    const [localInv, setLocalInv] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(invoice);
    const [paid, setPaid] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    const [paidLoaded, setPaidLoaded] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [payAmount, setPayAmount] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [amountTouched, setAmountTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // This patient's in-house orders, so the desk can bill them onto the visit
    // invoice in one tap instead of hand-picking a tariff.
    const { orders: patientOrders, refresh: refreshPatientOrders } = (0, $407sw.usePatientInHouseOrders)(invoice?.patientId);
    // «پیش‌پرداخت مراجعه» (PM-0657 §6.4) — the same netting as the desk's drawer.
    const { lineDiscount: lineDiscount, subtotal: subtotal, invDiscount: invDiscount, payable: payable, outstanding: outstanding, isVoid: isVoid, isSettled: isSettled, frozen: frozen, canRemove: canRemove, canEditDiscount: canEditDiscount, overpaid: overpaid, shownStatus: shownStatus, isEmptyInvoice: isEmptyInvoice, maxChargeable: maxChargeable, heldDeposit: heldDeposit, dueNow: dueNow } = (0, $5pHac.settleState)(localInv, paid, paidLoaded, (0, $eP0nH.heldDepositOf)(settlement?.deposit));
    const statusMeta = (0, $5pHac.STATUS_META)(t)[shownStatus] || (0, $5pHac.STATUS_META)(t).DRAFT;
    const badge = (0, $5pHac.issuanceBadge)(t, localInv);
    const methods = (0, $5pHac.PAYMENT_METHODS)(t);
    const activeMethod = methods[method];
    const refreshPaid = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        try {
            const ps = await getPayments(localInv.id);
            setPaid(ps.reduce((s, p)=>s + (p.amount || 0), 0));
        } catch  {} finally{
            setPaidLoaded(true);
        }
    }, [
        getPayments,
        localInv.id
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        refreshPaid();
    }, [
        refreshPaid
    ]);
    // What the clinic holds on account for this patient («علی‌الحساب»), so the desk
    // can settle out of it before asking for cash. Cosmetic on failure: no balance,
    // no button.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!getCreditBalance || !invoice?.patientId) return undefined;
        let cancelled = false;
        getCreditBalance(invoice.patientId).then((b)=>{
            if (!cancelled) setCreditBalance(b?.balanceRial || 0);
        }).catch(()=>{});
        return ()=>{
            cancelled = true;
        };
    }, [
        getCreditBalance,
        invoice?.patientId
    ]);
    // Opened straight from reception's «افزودن قلم»: jump to the picker, or to the
    // reopen confirmation if the invoice is already settled. Waits for the paid
    // total, since `isSettled` is meaningless before it lands. Runs once.
    const autoOpened = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (autoOpened.current || !openAddItem || !paidLoaded || isVoid) return;
        autoOpened.current = true;
        if (isSettled) setReopenAsk(true);
        else setAddingItem(true);
    }, [
        openAddItem,
        paidLoaded,
        isSettled,
        isVoid
    ]);
    // Default the amount to the full outstanding balance until the cashier edits it.
    // For an empty invoice there is no balance yet, so the field stays blank for the
    // appointment fee.
    //
    // `payAmount` is TOMAN — what sits in the box the cashier reads and types in.
    // `payRial` is what is actually charged. Keeping rials in the box was the whole
    // bug: a 500,000 ت visit asked the patient for 5,000,000 ت.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!amountTouched && !isEmptyInvoice) setPayAmount(String(toDisplayAmount(dueNow) ?? 0));
    }, [
        dueNow,
        amountTouched,
        isEmptyInvoice
    ]);
    const payRial = parseMoney(payAmount);
    // ── Writes ────────────────────────────────────────────────────────────────
    const handleIssue = async ()=>{
        if (!issueInvoice) return;
        setIssuing(true);
        setError('');
        try {
            const updated = await issueInvoice(localInv.id);
            setLocalInv((prev)=>({
                    ...prev,
                    ...updated
                }));
        } catch (e) {
            setError((0, $3fdwV.moneyErrorText)(e, t) || t('errors.cashier.issueFailed'));
        } finally{
            setIssuing(false);
        }
    };
    const handleApplyCredit = async ()=>{
        if (!applyCredit) return;
        const amount = Math.min(creditBalance, dueNow);
        if (!(amount > 0)) return;
        setSaving(true);
        setError('');
        try {
            await applyCredit(localInv.id, amount);
            onPaymentDone();
        } catch (e) {
            setError((0, $3fdwV.moneyErrorText)(e, t) || t('errors.cashier.creditApplyFailed'));
        } finally{
            setSaving(false);
        }
    };
    const handleRemoveItem = async (lineItemId)=>{
        try {
            await removeLineItem(localInv.id, lineItemId);
            setLocalInv((prev)=>(0, $5pHac.withLineItems)(prev, prev.lineItems.filter((li)=>li.id !== lineItemId)));
        } catch (e) {
            setError((0, $3fdwV.moneyErrorText)(e, t) || t('errors.cashier.lineDeleteFailed'));
        }
    };
    // Rethrows: the editor owns the error, so a rejected edit is shown against the
    // fields the cashier is still looking at and the sheet stays open.
    const handleEditItem = async (lineItemId, patch)=>{
        const item = await updateLineItem({
            lineItemId: lineItemId,
            ...patch
        });
        setLocalInv((prev)=>(0, $5pHac.withLineItems)(prev, prev.lineItems.map((li)=>li.id === item.id ? item : li)));
    };
    // A separate call from the edit because it is a separate act: its own
    // permission, a mandatory reason, and the service keeps what the rules said
    // beside what the person chose. Rethrows, for the same reason.
    const handleOverrideInsurance = async (lineItemId, insuranceShare, reason)=>{
        const item = await overrideLineInsurance(lineItemId, insuranceShare, reason);
        setLocalInv((prev)=>(0, $5pHac.withLineItems)(prev, prev.lineItems.map((li)=>li.id === item.id ? item : li)));
    };
    const handleSetDiscount = async (discountType, discountValue)=>{
        const updated = await setInvoiceDiscount(localInv.id, discountType, discountValue);
        setLocalInv((prev)=>({
                ...prev,
                ...updated
            }));
        setDiscountOpen(false);
    };
    // One-tap bill of an in-house order. The line carries sourceId = the ORDER id
    // and catalogId = the service (NOT a tariff id), so it traces back to the order
    // that caused it.
    const handleBillOrder = async (order)=>{
        setError('');
        try {
            const item = await addLineItem({
                invoiceId: localInv.id,
                itemType: 'MEDICAL_SERVICE',
                sourceId: order.id,
                catalogId: order.catalogId,
                // The DECLARATION prices it, not the number this sheet last loaded
                // (docs/CLINIC_RECEPTION_SERVICE_INVOICE_DESIGN.md §D3).
                serviceDeclarationId: order.declarationId || undefined,
                priceFromDeclaration: !!order.declarationId,
                description: order.description,
                quantity: order.sessionCount || 1,
                unitTariff: order.unitPrice
            });
            setLocalInv((prev)=>(0, $5pHac.withLineItems)(prev, [
                    ...prev.lineItems,
                    item
                ]));
            await refreshPatientOrders();
            setAddingItem(false);
        } catch (e) {
            setError((0, $3fdwV.moneyErrorText)(e, t) || t('errors.cashier.lineAddFailed'));
        }
    };
    // «هم‌سان‌سازی» — re-price the invoice from the service the appointment
    // names. One action for one state; the desk does not choose HOW (§D6).
    const handleReconcile = async ()=>{
        if (!onReconcileService) return;
        setReconciling(true);
        setError('');
        try {
            const next = await onReconcileService();
            if (next?.invoice) setLocalInv(next.invoice);
        } catch (e) {
            setError((0, $3fdwV.moneyErrorText)(e, t) || t('errors.cashier.lineAddFailed'));
        } finally{
            setReconciling(false);
        }
    };
    const handlePickTariff = async (tariff)=>{
        setAddingItem(false);
        try {
            const item = await addLineItem({
                invoiceId: localInv.id,
                itemType: 'MEDICAL_SERVICE',
                // No sourceId: the server mints `desk:<uuid>`, so a declaration id
                // never sits there posing as the order that caused the line (§F8).
                sourcePrefix: 'desk',
                catalogId: tariff.catalogId || undefined,
                serviceDeclarationId: tariff.id,
                priceFromDeclaration: true,
                description: tariff.description,
                quantity: 1,
                unitTariff: tariff.unitPrice,
                discount: 0,
                insuranceShare: 0
            });
            setLocalInv((prev)=>(0, $5pHac.withLineItems)(prev, [
                    ...prev.lineItems,
                    item
                ]));
        } catch (e) {
            setError((0, $3fdwV.moneyErrorText)(e, t) || t('errors.cashier.lineAddFailed'));
        }
    };
    const handlePay = async ()=>{
        // Rials from here on: the toman in the box converts once, at the boundary.
        const amt = payRial;
        const refusal = (0, $5pHac.validatePayment)({
            t: t,
            method: method,
            reference: reference,
            amountRial: amt,
            maxChargeable: maxChargeable
        });
        if (refusal) {
            setError(refusal);
            return;
        }
        if (isEmptyInvoice && !manualReason.trim()) {
            setError(t('cashier.manualPrice.reasonRequired'));
            return;
        }
        setSaving(true);
        setError('');
        try {
            // Empty invoice (a reception appointment with no priced fee yet): the typed
            // amount IS the appointment fee — add it as a line before charging.
            if (isEmptyInvoice) {
                const item = await addLineItem({
                    invoiceId: localInv.id,
                    itemType: 'VISIT',
                    reason: manualReason.trim(),
                    sourceId: localInv.appointmentId || localInv.id,
                    // The appointment's own service when it has one, so even a typed fee
                    // is recorded against WHAT the patient came for (§D7).
                    serviceDeclarationId: settlement?.service?.declarationId || undefined,
                    description: settlement?.service?.label || t('common.entity.visit'),
                    quantity: 1,
                    unitTariff: amt,
                    discount: 0,
                    insuranceShare: 0
                });
                setLocalInv((prev)=>({
                        ...prev,
                        lineItems: [
                            ...prev.lineItems,
                            item
                        ]
                    }));
            }
            // No shiftId: the service banks the money into the drawer that is actually
            // OPEN. Sending the INVOICE's shift put today's cash into the shift the
            // invoice was raised in — for an invoice raised by the encounter.ended
            // event, no shift at all — so the payment vanished from every drawer total
            // the clinic reconciles against.
            await recordPayment({
                invoiceId: localInv.id,
                patientId: localInv.patientId,
                amount: amt,
                paymentMethod: method,
                referenceNumber: reference.trim() || undefined
            });
            onPaymentDone();
        } catch (e) {
            setError((0, $3fdwV.moneyErrorText)(e, t) || t('errors.cashier.paymentFailed'));
        } finally{
            setSaving(false);
        }
    };
    // A paired keyboard (a tablet under 768px) still commits from anywhere in the
    // sheet. Registered in the shortcut registry, never as a local window listener,
    // so precedence and the caret rule keep working. `saving` unbinds it, so a slow
    // network cannot be double-charged by a second press.
    (0, $ciRrJ.useShortcut)('ctrl+s', handlePay, {
        label: t('reception.actions.takePayment'),
        group: t('accounting.entity.invoice'),
        enabled: open && !saving && !isSettled
    });
    const canPay = !saving && (0, $5pHac.canSubmitPayment)({
        t: t,
        method: method,
        amountRial: payRial,
        maxChargeable: maxChargeable
    });
    const patientName = localInv.patientName || t('patients.placeholder.byId', {
        id: localInv.patientId?.slice(-6) || ''
    });
    const editingItem = localInv.lineItems.find((li)=>li.id === editingId) || null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4WVD9.default), {
                open: open,
                onClose: onClose,
                title: t('cashier.mobile.settleTitle'),
                fullHeight: true,
                snap: 1,
                closeLabel: t('common.actions.close'),
                "data-testid": "cashier-settle-sheet",
                footer: isSettled ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                    variant: "outline",
                    onClick: onClose,
                    style: {
                        width: '100%',
                        minHeight: '2.75rem'
                    },
                    "data-testid": "cashier-settle-close",
                    children: t('common.actions.close')
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                    onClick: handlePay,
                    disabled: !canPay,
                    style: {
                        width: '100%',
                        minHeight: '2.75rem'
                    },
                    "data-testid": "cashier-settle-pay",
                    children: saving ? t('common.state.saving') : t('cashier.actions.payWith', {
                        method: activeMethod?.short,
                        amount: formatMoney(payRial > 0 ? payRial : 0)
                    })
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        padding: '0.875rem 1rem',
                        display: 'grid',
                        gap: '1.125rem'
                    },
                    children: [
                        error ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            ref: errorRef,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                                variant: "error",
                                role: "alert",
                                "data-testid": "cashier-settle-error",
                                children: error
                            })
                        }) : null,
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.625rem'
                            },
                            "data-testid": "cashier-settle-identity",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7wZCE.default), {
                                    name: patientName,
                                    size: 40
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        flex: 1,
                                        minWidth: 0
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            dir: "auto",
                                            style: {
                                                fontSize: '0.9375rem',
                                                fontWeight: 700,
                                                color: (0, $jTCZr.C).textPrimary,
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap'
                                            },
                                            children: patientName
                                        }),
                                        localInv.patientPhone ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                fontSize: '0.6875rem',
                                                color: (0, $jTCZr.C).textMuted
                                            },
                                            ...(0, $gVWNP.LTR_TEXT),
                                            children: (0, $5AX1S).forDisplay(localInv.patientPhone)
                                        }) : null
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    "data-testid": "cashier-settle-status",
                                    style: {
                                        flexShrink: 0,
                                        fontSize: '0.625rem',
                                        fontWeight: 700,
                                        padding: '0.1875rem 0.625rem',
                                        borderRadius: 999,
                                        background: statusMeta.bg,
                                        color: statusMeta.text,
                                        whiteSpace: 'nowrap'
                                    },
                                    children: statusMeta.label
                                })
                            ]
                        }),
                        settlement ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            "data-testid": "settle-chain",
                            style: {
                                padding: '0.5rem 0.75rem',
                                borderRadius: '0.625rem',
                                background: (0, $jTCZr.C).bg,
                                border: `1px solid ${(0, $jTCZr.C).border}`,
                                fontSize: '0.75rem',
                                lineHeight: 1.7,
                                color: (0, $jTCZr.C).textMuted
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        t('cashier.chain.booked'),
                                        ' ',
                                        settlement.appointment?.dateTime ? formatTime(Number(settlement.appointment.dateTime)) : "\u2014",
                                        settlement.appointment?.arrivedAt ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                " \xb7 ",
                                                t('cashier.chain.arrived'),
                                                ' ',
                                                formatTime(Number(settlement.appointment.arrivedAt))
                                            ]
                                        }) : null
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        color: (0, $jTCZr.C).textPrimary,
                                        fontWeight: 700,
                                        marginTop: '0.125rem'
                                    },
                                    children: [
                                        settlement.service ? settlement.service.label : "\u2014",
                                        settlement.service?.unitPriceRial ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            style: {
                                                color: (0, $jTCZr.C).textMuted,
                                                fontWeight: 400
                                            },
                                            children: [
                                                " \xb7 ",
                                                formatMoney(settlement.service.unitPriceRial, {
                                                    currency: settlement?.currency
                                                }),
                                                ' ',
                                                moneyUnit('short', settlement?.currency)
                                            ]
                                        }) : null
                                    ]
                                })
                            ]
                        }) : null,
                        settlement && settlement.consistency !== 'OK' && settlement.consistency !== 'LEGACY' && settlement.consistency !== 'NO_INVOICE' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            "data-testid": `settle-consistency-${settlement.consistency}`,
                            style: {
                                display: 'grid',
                                gap: '0.5rem',
                                padding: '0.625rem 0.75rem',
                                borderRadius: '0.625rem',
                                background: settlement.consistency === 'SERVICE_MISMATCH' ? '#FEF2F2' : (0, $jTCZr.C).amberLight,
                                fontSize: '0.75rem',
                                lineHeight: 1.7,
                                color: settlement.consistency === 'SERVICE_MISMATCH' ? '#991B1B' : (0, $jTCZr.CT).warnInk
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    children: t(`cashier.consistency.${settlement.consistency}`)
                                }),
                                settlement.consistency === 'SERVICE_MISMATCH' && onReconcileService ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                    variant: "outline",
                                    onClick: handleReconcile,
                                    disabled: reconciling,
                                    style: {
                                        width: '100%',
                                        minHeight: '2.75rem'
                                    },
                                    children: t('cashier.consistency.reconcile')
                                }) : null
                            ]
                        }) : null,
                        !isVoid && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            "data-testid": "cashier-settle-issuance-badge",
                            style: {
                                padding: '0.5rem 0.75rem',
                                borderRadius: '0.625rem',
                                background: badge.frozen ? (0, $jTCZr.C).tealLight : (0, $jTCZr.C).amberLight
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    style: {
                                        fontSize: '0.75rem',
                                        fontWeight: 700,
                                        color: badge.frozen ? (0, $jTCZr.C).teal : (0, $jTCZr.C).amber
                                    },
                                    children: badge.label
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    style: {
                                        fontSize: '0.6875rem',
                                        color: (0, $jTCZr.C).textSecondary,
                                        marginTop: '0.125rem'
                                    },
                                    children: badge.hint
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            role: "list",
                            "data-testid": "cashier-settle-journey",
                            style: {
                                display: 'grid',
                                gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
                                border: `1px solid ${(0, $jTCZr.C).border}`,
                                borderRadius: '0.75rem',
                                overflow: 'hidden'
                            },
                            children: (0, $5pHac.journeySteps)(t, {
                                hasLines: localInv.lineItems.length > 0,
                                frozen: frozen,
                                isSettled: isSettled
                            }).map((step)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    role: "listitem",
                                    "data-state": step.done ? 'done' : 'pending',
                                    style: {
                                        padding: '0.5rem 0.25rem',
                                        textAlign: 'center',
                                        background: step.done ? (0, $jTCZr.C).greenLight : 'transparent'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                fontSize: '1rem'
                                            },
                                            "aria-hidden": "true",
                                            children: step.icon
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                fontSize: '0.625rem',
                                                fontWeight: 600,
                                                marginTop: '0.125rem',
                                                color: step.done ? (0, $jTCZr.C).green : (0, $jTCZr.C).textMuted
                                            },
                                            children: step.label
                                        })
                                    ]
                                }, step.id))
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                            "data-testid": "cashier-settle-lines",
                            style: {
                                display: 'grid',
                                gap: '0.5rem'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)($287c3b7301b3c36e$var$SectionHead, {
                                    title: t('cashier.invoice.lineItems')
                                }),
                                localInv.lineItems.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    style: {
                                        margin: 0,
                                        padding: '1rem',
                                        textAlign: 'center',
                                        fontSize: '0.8125rem',
                                        color: (0, $jTCZr.C).textMuted,
                                        border: `1px dashed ${(0, $jTCZr.C).border}`,
                                        borderRadius: '0.625rem'
                                    },
                                    children: t('cashier.invoice.noLines')
                                }) : localInv.lineItems.map((item)=>{
                                    // The PRIMARY line is changed by re-pointing the APPOINTMENT, never
                                    // by editing the invoice — the same rule the desk keeps (§D1).
                                    const isPrimary = item.role === 'PRIMARY';
                                    return /*#__PURE__*/ (0, $ayMG0.jsx)($287c3b7301b3c36e$var$LineCard, {
                                        item: item,
                                        canEdit: !isVoid && !frozen && !isPrimary,
                                        canRemove: (0, $5pHac.canRemoveLine)(item, canRemove) && !isPrimary,
                                        onEdit: ()=>setEditingId(item.id),
                                        onRemove: ()=>handleRemoveItem(item.id),
                                        roleLabel: $287c3b7301b3c36e$var$ROLE_LABELS.has(item.role) ? t(`cashier.line.role.${item.role}`) : '',
                                        onChangeService: isPrimary && onChangeService && !frozen && !isVoid ? ()=>setServiceAsk(true) : null
                                    }, item.id);
                                }),
                                !isVoid && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                                    variant: "outline",
                                    onClick: ()=>isSettled ? setReopenAsk(true) : setAddingItem(true),
                                    style: {
                                        width: '100%',
                                        minHeight: '2.75rem',
                                        gap: '0.375rem'
                                    },
                                    "data-testid": "cashier-settle-add-line",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8g4t5.default), {
                                            size: 16,
                                            "aria-hidden": "true"
                                        }),
                                        t('cashier.invoice.addLine')
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                            "data-testid": "cashier-settle-summary",
                            "aria-label": t('cashier.mobile.invoiceSummary'),
                            style: {
                                display: 'grid',
                                gap: '0.25rem',
                                background: (0, $jTCZr.C).bg,
                                border: `1px solid ${(0, $jTCZr.C).border}`,
                                borderRadius: '0.75rem',
                                padding: '0.75rem 0.875rem'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $brmQA.default), {
                                    label: t('cashier.invoice.linesTotal'),
                                    value: formatMoney(localInv.totalAmount, {
                                        currency: localInv?.currency
                                    }),
                                    unit: moneyUnit('short', localInv?.currency),
                                    "data-testid": "cashier-settle-lines-total"
                                }),
                                lineDiscount > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $brmQA.default), {
                                    label: t('cashier.invoice.lineDiscounts'),
                                    value: `\u{2212}${formatMoney(lineDiscount)}`,
                                    unit: moneyUnit('short'),
                                    tone: "good",
                                    "data-testid": "cashier-settle-line-discounts"
                                }),
                                localInv.insuranceShare > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $brmQA.default), {
                                    label: t('accounting.fields.insuranceShare'),
                                    value: `\u{2212}${formatMoney(localInv.insuranceShare, {
                                        currency: localInv?.currency
                                    })}`,
                                    unit: moneyUnit('short'),
                                    tone: "warn",
                                    "data-testid": "cashier-settle-insurance"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $brmQA.default), {
                                    label: t('cashier.discount.wholeInvoice'),
                                    value: invDiscount > 0 ? `\u{2212}${(0, $5pHac.discountLabel)({
                                        ...localInv,
                                        discount: invDiscount
                                    }, t, formatNumber, formatMoney)}` : "\u2014",
                                    tone: invDiscount > 0 ? 'good' : 'muted',
                                    "data-testid": "cashier-settle-invoice-discount"
                                }),
                                canEditDiscount && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                    variant: "outline",
                                    size: "sm",
                                    onClick: ()=>setDiscountOpen(true),
                                    style: {
                                        minHeight: '2.75rem',
                                        justifySelf: 'stretch'
                                    },
                                    "data-testid": "cashier-settle-edit-discount",
                                    children: invDiscount > 0 ? t('common.actions.edit') : t('cashier.invoice.addDiscount')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $brmQA.default), {
                                    label: t('cashier.invoice.patientShare'),
                                    value: formatMoney(payable),
                                    unit: moneyUnit('short'),
                                    "data-testid": "cashier-settle-payable"
                                }),
                                paid > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $brmQA.default), {
                                    label: t('cashier.invoice.paidSoFar'),
                                    value: formatMoney(paid),
                                    unit: moneyUnit('short'),
                                    tone: "good",
                                    "data-testid": "cashier-settle-paid"
                                }),
                                paidLoaded ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $brmQA.default), {
                                    strong: true,
                                    label: t('cashier.invoice.remaining'),
                                    value: formatMoney(outstanding),
                                    unit: moneyUnit('short'),
                                    tone: outstanding > 0 ? 'danger' : 'good',
                                    "data-testid": "cashier-settle-outstanding"
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jpfyA.MobileMoneyRowSkeleton), {
                                    strong: true
                                }),
                                heldDeposit > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    "data-testid": "settle-deposit-line",
                                    style: {
                                        fontSize: '0.75rem',
                                        fontWeight: 700,
                                        color: (0, $jTCZr.C).teal,
                                        padding: '4px 0'
                                    },
                                    children: t('cashier.deposit.appointmentLine', {
                                        amount: formatMoney(heldDeposit)
                                    })
                                }) : null,
                                overpaid > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $brmQA.default), {
                                    strong: true,
                                    label: t('cashier.invoice.overpaid'),
                                    value: formatMoney(overpaid),
                                    unit: moneyUnit('short'),
                                    tone: "warn",
                                    "data-testid": "cashier-settle-overpaid"
                                })
                            ]
                        }),
                        !isVoid && !frozen && localInv.lineItems.length > 0 && issueInvoice && /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                            "data-testid": "cashier-settle-issuance",
                            style: {
                                display: 'grid',
                                gap: '0.5rem'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                                    variant: "warning",
                                    children: t('cashier.invoice.proformaExplainer')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                    onClick: handleIssue,
                                    disabled: issuing,
                                    style: {
                                        width: '100%',
                                        minHeight: '2.75rem'
                                    },
                                    "data-testid": "cashier-settle-issue",
                                    children: issuing ? t('common.state.saving') : t('cashier.invoice.issueFinal')
                                })
                            ]
                        }),
                        !isSettled && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                                    "data-testid": "cashier-settle-amount",
                                    style: {
                                        display: 'grid',
                                        gap: '0.375rem'
                                    },
                                    children: [
                                        isEmptyInvoice ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            "data-testid": "settle-manual-price",
                                            style: {
                                                padding: '0.5rem 0.75rem',
                                                borderRadius: '0.625rem',
                                                background: (0, $jTCZr.C).amberLight,
                                                fontSize: '0.75rem',
                                                lineHeight: 1.7,
                                                color: (0, $jTCZr.CT).warnInk
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    children: t('cashier.manualPrice.hint')
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                                                    value: manualReason,
                                                    onChange: (e)=>setManualReason(e.target.value),
                                                    placeholder: t('cashier.manualPrice.reasonPlaceholder'),
                                                    "aria-label": t('cashier.manualPrice.reason'),
                                                    "data-testid": "settle-manual-reason",
                                                    style: {
                                                        marginTop: '0.5rem'
                                                    }
                                                })
                                            ]
                                        }) : null,
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            style: {
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '0.5rem'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    htmlFor: "cashier-pay-amount",
                                                    style: {
                                                        flex: 1,
                                                        fontSize: '0.8125rem',
                                                        fontWeight: 700,
                                                        color: (0, $jTCZr.C).textPrimary
                                                    },
                                                    children: isEmptyInvoice ? t('cashier.manualPrice.title') : t('cashier.invoice.amountReceived')
                                                }),
                                                !isEmptyInvoice && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                                    variant: "ghost",
                                                    size: "sm",
                                                    onClick: ()=>setAmountTouched(false),
                                                    style: {
                                                        minHeight: '2.75rem'
                                                    },
                                                    "data-testid": "cashier-settle-reset-amount",
                                                    children: t('cashier.invoice.totalOutstandingWithAmount', {
                                                        amount: formatMoney(dueNow)
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5OgPq.default), {
                                            currency: currency,
                                            id: "cashier-pay-amount",
                                            value: payAmount,
                                            onChange: (v)=>{
                                                setAmountTouched(true);
                                                setPayAmount(v);
                                            },
                                            placeholder: isEmptyInvoice ? t('cashier.invoice.enterAmountToman') : undefined,
                                            "aria-label": isEmptyInvoice ? t('cashier.invoice.visitFeeToman') : t('cashier.invoice.amountReceivedToman'),
                                            "data-testid": "cashier-settle-amount-input",
                                            // The unit is the field's own chip now; the caption that used
                                            // to say «تومان» under it went with the hand-drawn box.
                                            inputStyle: {
                                                minHeight: '3rem',
                                                // ≥1rem or iOS Safari zooms the viewport on focus.
                                                fontSize: '1.0625rem',
                                                fontWeight: 700,
                                                ...!isEmptyInvoice && payRial > dueNow + 0.5 ? {
                                                    borderColor: (0, $jTCZr.C).red
                                                } : null
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                                    "data-testid": "cashier-settle-methods",
                                    style: {
                                        display: 'grid',
                                        gap: '0.5rem'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($287c3b7301b3c36e$var$SectionHead, {
                                            title: t('cashier.invoice.paymentMethod')
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            role: "radiogroup",
                                            "aria-label": t('cashier.invoice.paymentMethod'),
                                            style: {
                                                display: 'grid',
                                                gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
                                                gap: '0.5rem'
                                            },
                                            children: Object.entries(methods).map(([key, m])=>{
                                                const selected = method === key;
                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                                                    variant: "outline",
                                                    role: "radio",
                                                    "aria-checked": selected,
                                                    disabled: !m.enabled,
                                                    onClick: ()=>m.enabled && setMethod(key),
                                                    "data-testid": `cashier-settle-method-${key}`,
                                                    "data-state": selected ? 'selected' : 'idle',
                                                    style: {
                                                        display: 'block',
                                                        width: '100%',
                                                        minHeight: '3.25rem',
                                                        height: 'auto',
                                                        paddingBlock: '0.5rem',
                                                        textAlign: 'start',
                                                        whiteSpace: 'normal',
                                                        border: `2px solid ${selected ? m.color : (0, $jTCZr.C).border}`,
                                                        background: !m.enabled ? (0, $jTCZr.C).bg : selected ? m.bg : (0, $jTCZr.C).card
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            style: {
                                                                display: 'block',
                                                                fontSize: '0.8125rem',
                                                                fontWeight: 700,
                                                                color: selected ? m.color : (0, $jTCZr.C).textPrimary
                                                            },
                                                            children: m.label
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            style: {
                                                                display: 'block',
                                                                fontSize: '0.6875rem',
                                                                fontWeight: 400,
                                                                color: m.enabled ? (0, $jTCZr.C).textMuted : (0, $jTCZr.C).amber
                                                            },
                                                            children: m.desc
                                                        })
                                                    ]
                                                }, key);
                                            })
                                        }),
                                        activeMethod?.needsRef && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                                            label: activeMethod.refLabel,
                                            value: reference,
                                            onChange: (e)=>setReference(e?.target ? e.target.value : e),
                                            placeholder: activeMethod.refLabel,
                                            "aria-label": activeMethod.refLabel,
                                            dir: "ltr",
                                            "data-testid": "cashier-settle-reference",
                                            inputStyle: {
                                                minHeight: '2.75rem',
                                                fontSize: '1rem'
                                            }
                                        }),
                                        creditBalance > 0 && dueNow > 0 && !isEmptyInvoice && applyCredit && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            "data-testid": "cashier-settle-credit",
                                            style: {
                                                display: 'grid',
                                                gap: '0.5rem',
                                                padding: '0.625rem 0.75rem',
                                                borderRadius: '0.625rem',
                                                background: (0, $jTCZr.C).tealLight,
                                                border: `1px solid ${(0, $jTCZr.C).teal}`
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $brmQA.default), {
                                                    label: t('cashier.credit.balanceLabel'),
                                                    value: formatMoney(creditBalance),
                                                    unit: moneyUnit('short')
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                                    onClick: handleApplyCredit,
                                                    disabled: saving,
                                                    style: {
                                                        width: '100%',
                                                        minHeight: '2.75rem'
                                                    },
                                                    "data-testid": "cashier-settle-apply-credit",
                                                    children: t('cashier.credit.applyAction', {
                                                        amount: formatMoney(Math.min(creditBalance, dueNow))
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        isSettled && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                textAlign: 'center',
                                padding: '1rem 0'
                            },
                            "data-testid": "cashier-settle-receipt",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    style: {
                                        fontSize: '2rem'
                                    },
                                    "aria-hidden": "true",
                                    children: overpaid > 0 ? "\u26A0\uFE0F" : "\u2705"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    style: {
                                        margin: '0.5rem 0 0',
                                        fontSize: '0.9375rem',
                                        fontWeight: 700,
                                        color: overpaid > 0 ? (0, $jTCZr.C).amber : (0, $jTCZr.C).green
                                    },
                                    children: overpaid > 0 ? t('cashier.invoice.settledOverpaid') : t('cashier.invoice.fullySettled')
                                }),
                                overpaid > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    style: {
                                        margin: '0.375rem 0 0',
                                        fontSize: '0.75rem',
                                        color: (0, $jTCZr.C).textSecondary,
                                        lineHeight: 1.8
                                    },
                                    children: t('cashier.invoice.refundDue', {
                                        amount: formatMoney(overpaid)
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjPik.default), {
                open: reopenAsk,
                onOpenChange: (v)=>{
                    if (!v) setReopenAsk(false);
                },
                title: t('cashier.reopen.title'),
                description: t('cashier.reopen.explainer'),
                confirmLabel: t('cashier.reopen.confirm'),
                cancelLabel: t('common.actions.cancel'),
                onConfirm: ()=>{
                    setReopenAsk(false);
                    setAddingItem(true);
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4WVD9.default), {
                open: serviceAsk,
                onClose: ()=>setServiceAsk(false),
                title: t('cashier.changeService.title'),
                closeLabel: t('common.actions.close'),
                "data-testid": "settle-change-service-sheet",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        padding: '0.875rem 1rem'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $69ZlR.default), {
                        open: serviceAsk,
                        current: settlement?.service?.declarationId || null,
                        options: settlement?.serviceOptions || [],
                        hasMoney: paid > 0,
                        onCancel: ()=>setServiceAsk(false),
                        onConfirm: async (declarationId, reason)=>{
                            const next = await onChangeService(declarationId, reason);
                            setServiceAsk(false);
                            if (next?.invoice) setLocalInv(next.invoice);
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($287c3b7301b3c36e$var$AddItemSheet, {
                open: addingItem,
                onClose: ()=>setAddingItem(false),
                tariffs: tariffs,
                orders: isVoid ? [] : patientOrders,
                onPickTariff: handlePickTariff,
                onBillOrder: handleBillOrder
            }),
            editingItem && /*#__PURE__*/ (0, $ayMG0.jsx)($287c3b7301b3c36e$var$LineEditSheet, {
                open: true,
                item: editingItem,
                canOverride: canOverrideInsurance,
                onClose: ()=>setEditingId(null),
                onSave: async (patch)=>{
                    await handleEditItem(editingItem.id, patch);
                    setEditingId(null);
                },
                onOverride: handleOverrideInsurance
            }, editingItem.id),
            discountOpen && /*#__PURE__*/ (0, $ayMG0.jsx)($287c3b7301b3c36e$var$InvoiceDiscountSheet, {
                open: true,
                invoice: localInv,
                subtotal: subtotal,
                onClose: ()=>setDiscountOpen(false),
                onSave: handleSetDiscount
            })
        ]
    });
}
// ── Pieces ───────────────────────────────────────────────────────────────────
function $287c3b7301b3c36e$var$SectionHead({ title: title }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
        style: {
            margin: 0,
            fontSize: '0.8125rem',
            fontWeight: 700,
            color: (0, $jTCZr.C).textPrimary
        },
        children: title
    });
}
/**
 * One billed line. Its two operations live in a row menu rather than as hover
 * icons — the desktop's ✎/🗑 are pointer affordances with `title`-only
 * explanations, neither of which exists on a phone.
 *
 * Edit stays available after a payment and on a settled invoice, exactly as on
 * the desk: a line billed at the wrong price has to remain correctable. Only a
 * voided or ISSUED invoice freezes it.
 */ // The roles that have a name worth showing. PRODUCT and LEGACY are absent for
// the same reason as on the desk: one already reads as what it is, the other
// has no role to announce.
const $287c3b7301b3c36e$var$ROLE_LABELS = new Set([
    'PRIMARY',
    'PLANNED',
    'PERFORMED',
    'DESK',
    'CREDIT_NOTE'
]);
function $287c3b7301b3c36e$var$LineCard({ item: item, canEdit: canEdit, canRemove: canRemove, onEdit: onEdit, onRemove: onRemove, roleLabel: roleLabel = '', onChangeService: onChangeService = null }) {
    const { t: t, moneyUnit: moneyUnit, formatNumber: formatNumber, formatMoney: formatMoney } = (0, $e1LEq.default)();
    const meta = (0, $5pHac.ITEM_TYPE_META)(t)[item.itemType] || (0, $5pHac.ITEM_TYPE_META)(t).VISIT;
    const isSettledLine = item.settlementStatus === 'SETTLED';
    const actions = [
        canEdit && {
            id: 'edit',
            label: t('cashier.line.edit'),
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aGlWN.default), {
                size: 16
            }),
            onClick: onEdit
        },
        canRemove && {
            id: 'remove',
            label: t('cashier.line.delete'),
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lUsTt.default), {
                size: 16
            }),
            tone: 'danger',
            onClick: onRemove
        },
        // «تغییر خدمت» is a ROW in the menu rather than a chip on the card: on a
        // phone the card is already three lines of money, and a second control
        // beside the name is the one a thumb hits by accident.
        onChangeService && {
            id: 'service',
            label: t('cashier.changeService.action'),
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aGlWN.default), {
                size: 16
            }),
            onClick: onChangeService
        }
    ].filter(Boolean);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": `cashier-settle-line-${item.id}`,
        "data-state": isSettledLine ? 'settled' : 'open',
        style: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: '0.625rem',
            padding: '0.625rem 0.75rem',
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: '0.625rem',
            background: (0, $jTCZr.C).card,
            opacity: isSettledLine ? 0.7 : 1
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                style: {
                    fontSize: '1.125rem',
                    flexShrink: 0
                },
                "aria-hidden": "true",
                children: meta.icon
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    flex: 1,
                    minWidth: 0
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        dir: "auto",
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.375rem',
                            flexWrap: 'wrap',
                            fontSize: '0.8125rem',
                            fontWeight: 600,
                            color: (0, $jTCZr.C).textPrimary
                        },
                        children: [
                            item.description,
                            roleLabel ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    fontSize: '0.625rem',
                                    fontWeight: 700,
                                    padding: '0.0625rem 0.375rem',
                                    borderRadius: '0.25rem',
                                    background: (0, $jTCZr.C).tealLight,
                                    color: (0, $jTCZr.C).teal
                                },
                                children: roleLabel
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            fontSize: '0.6875rem',
                            color: (0, $jTCZr.C).textMuted,
                            marginTop: '0.125rem'
                        },
                        children: [
                            meta.label,
                            item.quantity > 1 ? ` \xb7 ${formatNumber(item.quantity)}\xd7` : '',
                            ' ',
                            formatMoney(item.unitTariff, {
                                currency: item?.currency
                            }),
                            " ",
                            moneyUnit('short', item?.currency)
                        ]
                    }),
                    item.discount > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            fontSize: '0.6875rem',
                            color: (0, $jTCZr.C).green
                        },
                        children: [
                            t('cashier.line.discountSuffix'),
                            ' ',
                            (0, $5pHac.discountLabel)(item, t, formatNumber, formatMoney)
                        ]
                    }),
                    item.insuranceShare > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            fontSize: '0.6875rem',
                            color: (0, $jTCZr.C).amber
                        },
                        children: [
                            t('cashier.line.insuranceSuffix'),
                            ' ',
                            formatMoney(item.insuranceShare, {
                                currency: item?.currency
                            }),
                            " ",
                            moneyUnit('short', item?.currency)
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        ...(0, $gVWNP.LTR_TEXT),
                        style: {
                            fontSize: '0.875rem',
                            fontWeight: 700,
                            color: (0, $jTCZr.C).textPrimary,
                            marginTop: '0.25rem'
                        },
                        children: [
                            formatMoney(item.patientPayable, {
                                currency: item?.currency
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    fontSize: '0.625rem',
                                    fontWeight: 400,
                                    color: (0, $jTCZr.C).textMuted,
                                    marginInlineStart: '0.25rem'
                                },
                                children: moneyUnit('short', item?.currency)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cxfrY.default), {
                items: actions,
                subject: item.description,
                title: t('cashier.mobile.lineActions'),
                "data-testid": `cashier-settle-line-menu-${item.id}`
            })
        ]
    });
}
/**
 * Fixing a line that was billed wrong.
 *
 * The form holds TOMAN as raw strings; only rials are ever sent, converted once
 * at the boundary. `insuranceShare` is offered ONLY when nothing computed it: on
 * a line the service priced from the patient's cover, a free-typed share is
 * exactly the defect the insurance feature exists to close — that line gets the
 * read-only explanation and, for `payments.manage` only, a deliberate override
 * with a mandatory reason.
 */ function $287c3b7301b3c36e$var$LineEditSheet({ item: item, open: open, onClose: onClose, onSave: onSave, onOverride: onOverride, canOverride: canOverride }) {
    const { t: t, moneyUnit: moneyUnit, formatMoney: formatMoney, currency: currency, toDisplayAmount: toDisplayAmount } = (0, $e1LEq.default)();
    const insState = (0, $kZuTn.lineInsuranceState)(item);
    const computedShare = insState !== (0, $kZuTn.SOURCE).NONE;
    const pctOnOpen = (item.discountType || 'AMOUNT') === 'PERCENT';
    const [form, setForm] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        description: item.description || '',
        quantity: String(item.quantity ?? 1),
        unitTariff: String(toDisplayAmount(item.unitTariff ?? 0) ?? 0),
        discountType: item.discountType || 'AMOUNT',
        // A PERCENT discountValue is a percent, not money — it does not convert.
        discountValue: String((pctOnOpen ? item.discountValue : toDisplayAmount(item.discountValue ?? 0)) ?? 0),
        insuranceShare: String(toDisplayAmount(item.insuranceShare ?? 0) ?? 0)
    });
    const [dirty, setDirty] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [saving, setSaving] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [err, setErr] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const set = (key, value)=>{
        setDirty(true);
        setForm((f)=>({
                ...f,
                [key]: value
            }));
    };
    const { isPct: isPct, qty: qty, dval: dval, unit: unit, ins: ins, disc: disc, payable: payable } = (0, $5pHac.lineEditPreview)(form, item.currency || currency);
    const invalid = (0, $5pHac.validateLineEdit)(t, form, item.currency || currency);
    const submit = async ()=>{
        if (invalid) {
            setErr(invalid);
            return;
        }
        setSaving(true);
        setErr('');
        try {
            await onSave({
                description: form.description.trim(),
                quantity: qty,
                // Rials from here down — the toman above never leaves this sheet.
                unitTariff: unit,
                discountType: form.discountType,
                discountValue: isPct ? dval : disc,
                // A computed share is not the cashier's to resend: the service re-derives
                // it from the snapshot on the line, and echoing the form's copy back would
                // silently turn it into a manual figure.
                insuranceShare: computedShare ? item.insuranceShare : ins
            });
        } catch (e) {
            setErr((0, $3fdwV.moneyErrorText)(e, t) || t('errors.cashier.lineEditFailed'));
            setSaving(false);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6y32F.default), {
        open: open,
        onClose: onClose,
        title: t('cashier.line.editTitle'),
        dirty: dirty,
        submitting: saving,
        submitDisabled: Boolean(invalid),
        submitLabel: t('common.actions.save'),
        onSubmit: submit,
        error: err || invalid || null,
        "data-testid": "cashier-line-edit-sheet",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6y32F.MobileField), {
                label: t('accounting.fields.lineDescription'),
                htmlFor: "cashier-line-description",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                    id: "cashier-line-description",
                    value: form.description,
                    onChange: (e)=>set('description', e?.target ? e.target.value : e),
                    placeholder: t('accounting.fields.lineDescription'),
                    "aria-label": t('accounting.fields.lineDescription'),
                    "data-testid": "cashier-line-description",
                    inputStyle: {
                        minHeight: '2.75rem',
                        fontSize: '1rem'
                    }
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6y32F.MobileField), {
                label: t('accounting.fields.quantity'),
                htmlFor: "cashier-line-quantity",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                    id: "cashier-line-quantity",
                    type: "number",
                    inputMode: "numeric",
                    value: form.quantity,
                    onChange: (e)=>set('quantity', e?.target ? e.target.value : e),
                    "aria-label": t('accounting.fields.quantity'),
                    dir: "ltr",
                    "data-testid": "cashier-line-quantity",
                    inputStyle: {
                        minHeight: '2.75rem',
                        fontSize: '1rem'
                    }
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6y32F.MobileField), {
                label: t('accounting.fields.unitPriceToman'),
                htmlFor: "cashier-line-unit",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5OgPq.default), {
                    currency: currency,
                    id: "cashier-line-unit",
                    value: form.unitTariff,
                    onChange: (v)=>set('unitTariff', v),
                    "aria-label": t('accounting.fields.unitPriceToman'),
                    "data-testid": "cashier-line-unit",
                    inputStyle: $287c3b7301b3c36e$var$FIELD_STYLE
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6y32F.MobileField), {
                label: t('accounting.fields.discount'),
                hint: isPct && disc > 0 ? `${t('accounting.fields.equivalent')} ${formatMoney(disc)} ${moneyUnit()}` : undefined,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5OgPq.default), {
                        currency: currency,
                        allowDecimal: true,
                        value: form.discountValue,
                        onChange: (v)=>set('discountValue', v),
                        "aria-label": t('accounting.fields.discount'),
                        "data-testid": "cashier-line-discount",
                        unitLabel: isPct ? t('cashier.discount.percentSymbol') : moneyUnit('field'),
                        inputStyle: $287c3b7301b3c36e$var$FIELD_STYLE
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        role: "radiogroup",
                        "aria-label": t('accounting.fields.discount'),
                        style: {
                            display: 'flex',
                            gap: '0.375rem',
                            marginTop: '0.375rem'
                        },
                        children: [
                            {
                                key: 'AMOUNT',
                                label: moneyUnit(),
                                name: t('cashier.discount.byAmount')
                            },
                            {
                                key: 'PERCENT',
                                label: t('cashier.discount.percentSymbol'),
                                name: t('cashier.discount.byPercent')
                            }
                        ].map((type)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                variant: form.discountType === type.key ? 'subtle' : 'outline',
                                role: "radio",
                                "aria-checked": form.discountType === type.key,
                                "aria-label": type.name,
                                onClick: ()=>set('discountType', type.key),
                                style: {
                                    flex: 1,
                                    minHeight: '2.75rem'
                                },
                                "data-testid": `cashier-line-discount-${type.key}`,
                                children: type.label
                            }, type.key))
                    })
                ]
            }),
            computedShare ? /*#__PURE__*/ (0, $ayMG0.jsx)($287c3b7301b3c36e$var$InsurancePanel, {
                item: item,
                canOverride: canOverride,
                onOverride: onOverride
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6y32F.MobileField), {
                label: t('accounting.fields.insuranceShareToman'),
                htmlFor: "cashier-line-insurance",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5OgPq.default), {
                    currency: currency,
                    id: "cashier-line-insurance",
                    value: form.insuranceShare,
                    onChange: (v)=>set('insuranceShare', v),
                    "aria-label": t('accounting.fields.insuranceShareToman'),
                    "data-testid": "cashier-line-insurance",
                    inputStyle: $287c3b7301b3c36e$var$FIELD_STYLE
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $brmQA.default), {
                strong: true,
                label: t('cashier.line.payableAfterEdit'),
                value: Number.isFinite(payable) ? formatMoney(payable) : "\u2014",
                unit: moneyUnit('short'),
                "data-testid": "cashier-line-payable"
            })
        ]
    });
}
/**
 * The insurer's share, explained rather than offered as a blank.
 *
 * Read-only by default: the explanation says WHICH insurer and under what
 * فرانشیز, so the number answers for itself. «ویرایش» appears only for
 * `payments.manage`, which is what stops a منشی putting the share back to a typed
 * guess, and the override records what the rules said beside what the person
 * decided.
 */ function $287c3b7301b3c36e$var$InsurancePanel({ item: item, canOverride: canOverride, onOverride: onOverride }) {
    const { t: t, moneyUnit: moneyUnit, formatMoney: formatMoney, currency: currency, toDisplayAmount: toDisplayAmount, fromDisplayAmount: fromDisplayAmount } = (0, $e1LEq.default)();
    const nameOf = (0, $1zLkf.useInsurerName)();
    const [editing, setEditing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [amount, setAmount] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(String(toDisplayAmount(item.insuranceShare ?? 0) ?? 0));
    const [reason, setReason] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [busy, setBusy] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [err, setErr] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const state = (0, $kZuTn.lineInsuranceState)(item);
    const explanation = (0, $kZuTn.explainLegs)(item, {
        insurerName: null,
        t: t,
        nameOf: nameOf
    });
    const gross = (item.totalAmount || 0) - (item.discount || 0);
    const commit = async ()=>{
        const refusal = (0, $5pHac.validateInsuranceOverride)(t, {
            amountToman: amount,
            reason: reason,
            gross: gross,
            currency: item.currency || currency
        });
        if (refusal) {
            setErr(refusal);
            return;
        }
        setBusy(true);
        setErr('');
        try {
            await onOverride(item.id, fromDisplayAmount(amount), reason.trim());
            setEditing(false);
            setReason('');
        } catch (e) {
            setErr((0, $3fdwV.moneyErrorText)(e, t) || t('errors.cashier.lineEditFailed'));
        } finally{
            setBusy(false);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": "cashier-line-insurance",
        style: {
            display: 'grid',
            gap: '0.375rem',
            padding: '0.625rem 0.75rem',
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: '0.625rem',
            background: (0, $jTCZr.C).card
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $brmQA.default), {
                label: t('insurance.share.insurer'),
                value: formatMoney(item.insuranceShare || 0, {
                    currency: item?.currency
                }),
                unit: moneyUnit('short', item?.currency),
                tone: "warn",
                // Joined on the phone, where a row's hint is one line by design — the
                // desktop drawer has the room to give each insurer its own.
                hint: explanation.length ? explanation.join(" \xb7 ") : undefined,
                "data-testid": "cashier-line-insurance-amount"
            }),
            state === (0, $kZuTn.SOURCE).MANUAL && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                variant: "neutral",
                children: t('insurance.override.applied')
            }),
            state === (0, $kZuTn.SOURCE).UNAVAILABLE && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                variant: "warning",
                children: t('insurance.state.unavailable')
            }),
            canOverride && !editing && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                variant: "outline",
                onClick: ()=>setEditing(true),
                style: {
                    width: '100%',
                    minHeight: '2.75rem'
                },
                "data-testid": "cashier-line-insurance-edit",
                children: t('insurance.actions.editShare')
            }),
            editing && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    item.computedInsuranceShare != null && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        style: {
                            margin: 0,
                            fontSize: '0.6875rem',
                            color: (0, $jTCZr.C).textMuted
                        },
                        children: t('insurance.override.computedWas', {
                            amount: `${formatMoney(item.computedInsuranceShare, {
                                currency: item?.currency
                            })} ${moneyUnit('short', item?.currency)}`
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5OgPq.default), {
                        currency: currency,
                        value: amount,
                        onChange: setAmount,
                        "aria-label": t('insurance.share.insurer'),
                        "data-testid": "cashier-line-insurance-amount-input",
                        inputStyle: $287c3b7301b3c36e$var$FIELD_STYLE
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                        value: reason,
                        onChange: (e)=>setReason(e?.target ? e.target.value : e),
                        placeholder: t('insurance.override.reasonPlaceholder'),
                        "aria-label": t('insurance.override.reason'),
                        "data-testid": "cashier-line-insurance-reason",
                        inputStyle: {
                            minHeight: '2.75rem',
                            fontSize: '1rem'
                        }
                    }),
                    err ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                        variant: "error",
                        role: "alert",
                        children: err
                    }) : null,
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            gap: '0.5rem'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                onClick: commit,
                                disabled: busy,
                                style: {
                                    flex: 1,
                                    minHeight: '2.75rem'
                                },
                                "data-testid": "cashier-line-insurance-save",
                                children: busy ? t('common.state.saving') : t('common.actions.save')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                variant: "outline",
                                onClick: ()=>{
                                    setEditing(false);
                                    setErr('');
                                },
                                style: {
                                    minHeight: '2.75rem'
                                },
                                children: t('common.actions.cancel')
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
/**
 * The invoice-wide discount.
 *
 * Its base is the PATIENT'S SHARE, not the gross, and unlike a line discount it
 * is clamped to that base — a fixed discount can outlive the lines it was sized
 * against, and the service clamps it the same way. The preview says what will
 * actually be applied.
 */ function $287c3b7301b3c36e$var$InvoiceDiscountSheet({ open: open, invoice: invoice, subtotal: subtotal, onClose: onClose, onSave: onSave }) {
    const { t: t, moneyUnit: moneyUnit, formatNumber: formatNumber, formatMoney: formatMoney, currency: currency, toDisplayAmount: toDisplayAmount, fromDisplayAmount: fromDisplayAmount } = (0, $e1LEq.default)();
    const pctOnOpen = (invoice.discountType || 'AMOUNT') === 'PERCENT';
    const [type, setType] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(invoice.discountType || 'AMOUNT');
    const [value, setValue] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(String((pctOnOpen ? invoice.discountValue : toDisplayAmount(invoice.discountValue ?? 0)) ?? 0));
    const [dirty, setDirty] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [saving, setSaving] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [err, setErr] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const isPct = type === 'PERCENT';
    const v = value === '' ? NaN : Number(value);
    // What the service will store: a percent as-is, an amount in rials.
    const saveValue = isPct ? v : fromDisplayAmount(value);
    const resolved = Math.min((0, $5pHac.resolveDiscount)(type, saveValue, subtotal), subtotal);
    const invalid = (0, $5pHac.validateInvoiceDiscount)(t, {
        type: type,
        value: value
    });
    const run = async (nextType, nextValue, failKey)=>{
        setSaving(true);
        setErr('');
        try {
            await onSave(nextType, nextValue);
        } catch (e) {
            setErr((0, $3fdwV.moneyErrorText)(e, t) || t(failKey));
            setSaving(false);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6y32F.default), {
        open: open,
        onClose: onClose,
        title: t('cashier.discount.wholeInvoice'),
        dirty: dirty,
        submitting: saving,
        submitDisabled: Boolean(invalid),
        submitLabel: t('cashier.discount.apply'),
        onSubmit: ()=>invalid ? setErr(invalid) : run(type, saveValue, 'errors.cashier.discountSaveFailed'),
        error: err || invalid || null,
        snap: 0.7,
        fullHeight: false,
        "data-testid": "cashier-invoice-discount-sheet",
        secondary: invoice.discountValue > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
            variant: "outline",
            onClick: ()=>run('AMOUNT', 0, 'errors.cashier.discountRemoveFailed'),
            disabled: saving,
            style: {
                minHeight: '2.75rem'
            },
            "data-testid": "cashier-invoice-discount-remove",
            children: t('cashier.discount.remove')
        }) : null,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6y32F.MobileField), {
            label: t('cashier.discount.wholeInvoice'),
            hint: isPct ? t('cashier.discount.percentExplainer', {
                percent: formatNumber(Number.isFinite(v) ? v : 0),
                base: formatMoney(subtotal),
                amount: formatMoney(resolved)
            }) : t('cashier.discount.amountExplainer', {
                base: formatMoney(subtotal)
            }),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5OgPq.default), {
                    currency: currency,
                    allowDecimal: true,
                    value: value,
                    onChange: (next)=>{
                        setDirty(true);
                        setValue(next);
                    },
                    "aria-label": t('cashier.discount.wholeInvoice'),
                    "data-testid": "cashier-invoice-discount-value",
                    unitLabel: isPct ? t('cashier.discount.percentSymbol') : moneyUnit('field'),
                    inputStyle: $287c3b7301b3c36e$var$FIELD_STYLE
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    role: "radiogroup",
                    "aria-label": t('accounting.fields.discount'),
                    style: {
                        display: 'flex',
                        gap: '0.375rem',
                        marginTop: '0.375rem'
                    },
                    children: [
                        {
                            key: 'AMOUNT',
                            label: moneyUnit(),
                            name: t('cashier.discount.byAmount')
                        },
                        {
                            key: 'PERCENT',
                            label: t('cashier.discount.percentSymbol'),
                            name: t('cashier.discount.byPercent')
                        }
                    ].map((option)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                            variant: type === option.key ? 'subtle' : 'outline',
                            role: "radio",
                            "aria-checked": type === option.key,
                            "aria-label": option.name,
                            onClick: ()=>{
                                setDirty(true);
                                setType(option.key);
                            },
                            style: {
                                flex: 1,
                                minHeight: '2.75rem'
                            },
                            "data-testid": `cashier-invoice-discount-${option.key}`,
                            children: option.label
                        }, option.key))
                })
            ]
        })
    });
}
/**
 * Adding a line: this patient's own un-billed in-house orders first, then the
 * clinic's declared services.
 *
 * An un-billed order is work the doctor ordered and the clinic performs itself,
 * with no invoice line yet — one tap bills it, and the line traces back to the
 * order that caused it. Billed ones drop out: their line already exists.
 */ function $287c3b7301b3c36e$var$AddItemSheet({ open: open, onClose: onClose, tariffs: tariffs, orders: orders, onPickTariff: onPickTariff, onBillOrder: onBillOrder }) {
    const { t: t, moneyUnit: moneyUnit, formatNumber: formatNumber, formatMoney: formatMoney } = (0, $e1LEq.default)();
    const unbilled = (orders || []).filter((o)=>o.billed === false);
    const active = (tariffs || []).filter((tariff)=>tariff.isActive);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4WVD9.default), {
        open: open,
        onClose: onClose,
        title: t('cashier.line.addParaclinical'),
        closeLabel: t('common.actions.close'),
        snap: 0.85,
        "data-testid": "cashier-add-item-sheet",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            style: {
                padding: '0.875rem 1rem',
                display: 'grid',
                gap: '1rem'
            },
            children: [
                unbilled.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                    style: {
                        display: 'grid',
                        gap: '0.5rem'
                    },
                    "data-testid": "cashier-add-item-orders",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($287c3b7301b3c36e$var$SectionHead, {
                            title: t('cashier.line.patientOrders')
                        }),
                        unbilled.map((o)=>/*#__PURE__*/ (0, $ayMG0.jsx)($287c3b7301b3c36e$var$PickRow, {
                                testId: `cashier-add-item-order-${o.id}`,
                                title: o.description,
                                badge: o.sessionCount > 1 ? `\xd7${formatNumber(o.sessionCount)} ${t('common.units.session')}` : null,
                                price: `${formatMoney(o.unitPrice, {
                                    currency: o?.currency
                                })} ${moneyUnit('short', o?.currency)}`,
                                onClick: ()=>onBillOrder(o)
                            }, o.id))
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                    style: {
                        display: 'grid',
                        gap: '0.5rem'
                    },
                    "data-testid": "cashier-add-item-tariffs",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($287c3b7301b3c36e$var$SectionHead, {
                            title: t('cashier.line.addParaclinical')
                        }),
                        active.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            style: {
                                margin: 0,
                                fontSize: '0.75rem',
                                color: (0, $jTCZr.C).textMuted
                            },
                            children: t('accounting.empty.noLineItems')
                        }) : active.map((tariff)=>/*#__PURE__*/ (0, $ayMG0.jsx)($287c3b7301b3c36e$var$PickRow, {
                                testId: `cashier-add-item-tariff-${tariff.id}`,
                                title: tariff.description,
                                price: `${formatMoney(tariff.unitPrice, {
                                    currency: tariff?.currency
                                })} ${moneyUnit('short', tariff?.currency)}`,
                                onClick: ()=>onPickTariff(tariff)
                            }, tariff.id))
                    ]
                })
            ]
        })
    });
}
function $287c3b7301b3c36e$var$PickRow({ title: title, badge: badge, price: price, onClick: onClick, testId: testId }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
        variant: "outline",
        onClick: onClick,
        "data-testid": testId,
        style: {
            display: 'block',
            width: '100%',
            minHeight: '2.75rem',
            height: 'auto',
            paddingBlock: '0.5rem',
            textAlign: 'start',
            whiteSpace: 'normal'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                dir: "auto",
                style: {
                    display: 'block',
                    fontSize: '0.8125rem',
                    fontWeight: 600,
                    color: (0, $jTCZr.C).textPrimary
                },
                children: [
                    title,
                    badge ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            fontSize: '0.6875rem',
                            fontWeight: 700,
                            color: (0, $jTCZr.C).navy,
                            marginInlineStart: '0.375rem'
                        },
                        children: badge
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                ...(0, $gVWNP.LTR_TEXT),
                style: {
                    display: 'block',
                    fontSize: '0.6875rem',
                    fontWeight: 400,
                    color: (0, $jTCZr.C).textMuted
                },
                children: price
            })
        ]
    });
}
// Reaches the kit's real `<input>` via `inputStyle` (v0.13.0). The box —
// border, radius, height, the «تومان» chip — is the kit's own now, so only the
// two phone rules remain: ≥1rem or iOS Safari zooms the viewport on focus, and
// a bold figure for money.
const $287c3b7301b3c36e$var$FIELD_STYLE = {
    minHeight: '2.75rem',
    fontSize: '1rem',
    fontWeight: 700
};
var // The invoice is read in ITS currency (docs/clinic-currency/CONTRACTS.md §0.5).
$287c3b7301b3c36e$export$2e2bcd8739ae039 = (0, $aBaxB.inDocumentCurrency)($287c3b7301b3c36e$var$MobileSettleSheet, (p)=>p.invoice);

});
parcelRegister("69ZlR", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d0584f1404cb0b7$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $aJ1FU = parcelRequire("aJ1FU");
var $hZDga = parcelRequire("hZDga");
parcelRequire("52bn2");
var $jTCZr = parcelRequire("jTCZr");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");
function $5d0584f1404cb0b7$export$2e2bcd8739ae039({ open: open, current: current, options: options = [], hasMoney: hasMoney = false, onCancel: onCancel, onConfirm: onConfirm }) {
    const { t: t, moneyUnit: moneyUnit, formatMoney: formatMoney } = (0, $e1LEq.default)();
    const [picked, setPicked] = (0, $acw62.useState)(current || null);
    const [reason, setReason] = (0, $acw62.useState)('');
    const [saving, setSaving] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)('');
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (open) {
            setPicked(current || null);
            setReason('');
            setError('');
        }
    }, [
        open,
        current
    ]);
    if (!open) return null;
    const changed = !!picked && picked !== current;
    const needsReason = hasMoney && !reason.trim();
    const submit = async ()=>{
        if (!changed || needsReason) return;
        setSaving(true);
        setError('');
        try {
            await onConfirm(picked, reason.trim());
        } catch (e) {
            // Reported HERE, inside the open form, and every keystroke survives: a
            // refusal the desk has to retype its answer after is a refusal it will
            // learn to route around.
            setError(e.message || t('cashier.changeService.failed'));
            setSaving(false);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": "change-service-dialog",
        style: {
            marginBottom: 14,
            padding: '12px 14px',
            borderRadius: 10,
            background: '#fff',
            border: `1px solid ${(0, $jTCZr.C).navy}`
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    fontSize: '0.8125rem',
                    fontWeight: 700,
                    color: (0, $jTCZr.C).textPrimary,
                    marginBottom: 4
                },
                children: t('cashier.changeService.title')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    fontSize: '0.71875rem',
                    color: (0, $jTCZr.C).textMuted,
                    lineHeight: 1.7,
                    marginBottom: 10
                },
                children: t('cashier.changeService.hint')
            }),
            error ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    marginBottom: 10
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                    variant: "error",
                    children: error
                })
            }) : null,
            options.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    fontSize: '0.75rem',
                    color: (0, $jTCZr.C).textMuted
                },
                children: t('cashier.changeService.noOptions')
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    display: 'grid',
                    gap: 6,
                    marginBottom: 10
                },
                children: options.map((svc)=>{
                    const on = picked === svc.declarationId;
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        type: "button",
                        onClick: ()=>setPicked(svc.declarationId),
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            gap: 10,
                            padding: '8px 10px',
                            borderRadius: 8,
                            cursor: 'pointer',
                            textAlign: 'start',
                            fontFamily: 'inherit',
                            fontSize: '0.78125rem',
                            border: `1px solid ${on ? (0, $jTCZr.C).navy : (0, $jTCZr.C).border}`,
                            background: on ? (0, $jTCZr.C).navyLight || '#EFF6FF' : '#fff',
                            color: (0, $jTCZr.C).textPrimary
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                style: {
                                    fontWeight: on ? 700 : 500
                                },
                                children: [
                                    svc.label,
                                    svc.declarationId === current ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        style: {
                                            color: (0, $jTCZr.C).textMuted,
                                            fontWeight: 400
                                        },
                                        children: [
                                            " \xb7 ",
                                            t('cashier.changeService.current')
                                        ]
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    color: (0, $jTCZr.C).textMuted,
                                    flexShrink: 0
                                },
                                children: svc.unitPriceRial ? `${formatMoney(svc.unitPriceRial, {
                                    currency: svc?.currency
                                })} ${moneyUnit('short', svc?.currency)}` : t('cashier.line.unpriced')
                            })
                        ]
                    }, svc.declarationId);
                })
            }),
            hasMoney ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    marginBottom: 10
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: '0.71875rem',
                            color: (0, $jTCZr.C).textMuted,
                            marginBottom: 4
                        },
                        children: t('cashier.changeService.reasonRequired')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        value: reason,
                        onChange: (e)=>setReason(e.target.value),
                        placeholder: t('cashier.changeService.reasonPlaceholder'),
                        style: {
                            width: '100%',
                            boxSizing: 'border-box',
                            padding: '7px 10px',
                            border: `1px solid ${(0, $jTCZr.C).border}`,
                            borderRadius: 8,
                            fontSize: '0.78125rem',
                            fontFamily: 'inherit'
                        }
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    gap: 8,
                    justifyContent: 'flex-end'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                        variant: "ghost",
                        onClick: onCancel,
                        disabled: saving,
                        children: t('common.actions.cancel')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                        onClick: submit,
                        disabled: !changed || needsReason || saving,
                        "data-testid": "change-service-submit",
                        children: saving ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hZDga.Spinner), {
                            size: 14
                        }) : t('cashier.changeService.submit')
                    })
                ]
            })
        ]
    });
}

});

parcelRegister("jpfyA", function(module, exports) {

$parcel$export(module.exports, "MobileMoneyRowSkeleton", () => $5aae280bff943b39$export$8b19f61523736e4c);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("5N0ZI");
var $66joL = parcelRequire("66joL");
function $5aae280bff943b39$export$8b19f61523736e4c({ strong: strong = false }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "aria-hidden": true,
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '0.75rem',
            minHeight: '1.75rem'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                width: strong ? 72 : 60,
                height: strong ? 13 : 12
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                width: strong ? 96 : 80,
                height: strong ? 18 : 14
            })
        ]
    });
}

});

parcelRegister("3fdwV", function(module, exports) {

$parcel$export(module.exports, "moneyErrorText", () => $25cd4492ed380f3f$export$d16cc4cddf583b74);
/**
 * The currency refusals (docs/clinic-currency/CONTRACTS.md §2, §11.9), in the
 * reader's language.
 *
 * The BFF lifts each service's `error-code` into `extensions.code`. The copy lives
 * HERE rather than in the server's sentence: a coded refusal is one we have written
 * words for, and the wire's sentence is only the fallback for a code nobody
 * anticipated (the rule `screens/Onboarding/errors.js` states for the same reason).
 */ const $25cd4492ed380f3f$export$314b3eac7ffe2577 = Object.freeze({
    INVALID_CURRENCY: 'errors.currency.invalid',
    CURRENCY_LOCKED: 'errors.currency.locked',
    CURRENCY_MISMATCH: 'errors.currency.mismatch',
    MIXED_CURRENCY: 'errors.currency.mixed',
    RAIL_REQUIRES_IRR: 'errors.currency.railRequiresIrr',
    CURRENCY_CHANGE_INCOMPLETE: 'errors.currency.changeIncomplete'
});
function $25cd4492ed380f3f$export$61465484f198f511(err) {
    return err?.extensions?.code || err?.graphQLErrors?.[0]?.extensions?.code || (Array.isArray(err?.errors) ? err.errors[0]?.extensions?.code : '') || '';
}
function $25cd4492ed380f3f$export$6d3fd9aa7cf061c9(err, t) {
    const key = $25cd4492ed380f3f$export$314b3eac7ffe2577[$25cd4492ed380f3f$export$61465484f198f511(err)];
    return key ? t(key) : '';
}
function $25cd4492ed380f3f$export$d16cc4cddf583b74(err, t) {
    return $25cd4492ed380f3f$export$6d3fd9aa7cf061c9(err, t) || err?.message || '';
}

});



parcelRegister("aHwe7", function(module, exports) {

$parcel$export(module.exports, "StaffPane", () => $cd50f89b14530f26$export$3d7b5c8f76ce4d94);
$parcel$export(module.exports, "InvitePane", () => $cd50f89b14530f26$export$6468dcee36a0d01b);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $huNwV = parcelRequire("huNwV");
var $2uCMp = parcelRequire("2uCMp");

var $bYoyu = parcelRequire("bYoyu");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $aJ1FU = parcelRequire("aJ1FU");
var $bkKUS = parcelRequire("bkKUS");
var $Ydgp5 = parcelRequire("Ydgp5");
var $66joL = parcelRequire("66joL");
var $a7Rbr = parcelRequire("a7Rbr");
var $5Rv3V = parcelRequire("5Rv3V");

var $iRTrY = parcelRequire("iRTrY");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");
parcelRequire("52bn2");
var $jTCZr = parcelRequire("jTCZr");

var $2xQve = parcelRequire("2xQve");

var $2Mst8 = parcelRequire("2Mst8");
/**
 * The two panes of «افزودن فرد» (docs/PEOPLE_PAGE_REDESIGN.md §8).
 *
 * They are two panes rather than two dialogs because the model says one thing
 * and the old UI said another. Adding a member of staff and inviting a
 * practitioner really are different acts — the clinic creates the first
 * relationship outright and can only offer the second
 * (PLATFORM_USER_CONNECTIONS §8) — but they answer the same question, «how do I
 * get another person into this clinic», and splitting them across a hand-rolled
 * dropdown meant the answer depended on a menu the phone never opened.
 *
 * Nothing here renders its own chrome. The dialog on desktop and the sheet on
 * a phone both mount these, which is what keeps the two surfaces from drifting
 * — the phone used to be missing the national id, the tier and the entire
 * practitioner path.
 */ const $cd50f89b14530f26$var$MY_CLINIC_CODE = 'query MyClinicInviteCode { myClinic { id name invitationCode } }';
function $cd50f89b14530f26$export$3d7b5c8f76ce4d94({ value: value, onChange: onChange, roles: roles = [], canAdmin: canAdmin, canSeedRoles: canSeedRoles, phoneError: phoneError, formError: formError, onShowExisting: onShowExisting, onSeedRoles: onSeedRoles, onGoToRoles: onGoToRoles, seeding: seeding, phoneRef: phoneRef, nationalIdError: nationalIdError }) {
    const { t: t } = (0, $e1LEq.default)();
    const set = (patch)=>onChange({
            ...value,
            ...patch
        });
    const roleOptions = roles.map((r)=>({
            value: r.id,
            label: r.nameFa
        }));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 14
        },
        children: [
            formError && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                variant: "error",
                action: formError.existingId ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                    variant: "outline",
                    onClick: ()=>onShowExisting(formError.existingId),
                    children: t('people.add.showExisting')
                }) : undefined,
                children: formError.message
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                ref: phoneRef,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iRTrY.default), {
                    label: t('people.fields.phone'),
                    error: phoneError,
                    value: value.phone,
                    onChange: (e164, meta)=>set({
                            phone: e164,
                            phoneDraft: meta.draft
                        })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gap: 12
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                        label: t('common.fields.name'),
                        value: value.firstName,
                        onChange: (e)=>set({
                                firstName: e?.target ? e.target.value : e
                            })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                        label: t('people.fields.lastName'),
                        value: value.lastName,
                        onChange: (e)=>set({
                                lastName: e?.target ? e.target.value : e
                            })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $Ydgp5.default), {
                label: t('patients.fields.nationalIdOptional'),
                value: value.nationalId,
                onChange: (e)=>set({
                        nationalId: e?.target ? e.target.value : e
                    }),
                allowOtherCountries: true,
                country: value.nationalIdCountry || undefined,
                onCountryChange: (c)=>set({
                        nationalIdCountry: c
                    }),
                error: nationalIdError || undefined
            }),
            canAdmin ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5Rv3V.default), {
                label: t('people.fields.tier'),
                value: value.tier,
                onChange: (v)=>v && set({
                        tier: v
                    }),
                options: [
                    {
                        value: 'MEMBER',
                        label: t('people.tiers.member')
                    },
                    {
                        value: 'ADMIN',
                        label: t('people.tiers.admin')
                    }
                ]
            }) : null,
            value.tier === 'MEMBER' && (roles.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                variant: "info",
                action: canSeedRoles ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                    variant: "outline",
                    disabled: seeding,
                    onClick: onSeedRoles,
                    children: t('people.add.seedRoles')
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                    variant: "outline",
                    onClick: onGoToRoles,
                    children: t('people.add.goToRoles')
                }),
                children: t('people.add.noRoles')
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bkKUS.default), {
                label: t('people.fields.roles'),
                multi: true,
                value: value.roleIds,
                onChange: (v)=>set({
                        roleIds: v
                    }),
                options: roleOptions
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    fontSize: '0.75rem',
                    color: (0, $jTCZr.C).textMuted,
                    lineHeight: 1.9
                },
                children: t('people.add.truth')
            })
        ]
    });
}
function $cd50f89b14530f26$export$6468dcee36a0d01b({ open: open }) {
    const { t: t } = (0, $e1LEq.default)();
    const navigate = (0, $aphAM.useNavigate)();
    const [clinic, setClinic] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)('');
    const [copied, setCopied] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        if (!open) {
            setCopied(null);
            return undefined;
        }
        let alive = true;
        setLoading(true);
        setError('');
        (0, $2Mst8.bffQuery)($cd50f89b14530f26$var$MY_CLINIC_CODE, {}, 'MyClinicInviteCode').then((d)=>{
            if (alive) setClinic(d?.myClinic || null);
        }).catch((e)=>{
            if (alive) setError(e.message || t('errors.load.generic'));
        }).finally(()=>{
            if (alive) setLoading(false);
        });
        return ()=>{
            alive = false;
        };
    }, [
        open,
        t
    ]);
    const code = clinic?.invitationCode || '';
    const link = code ? `${window.location.origin}/invite/${code}` : '';
    const canShare = typeof navigator !== 'undefined' && typeof navigator.share === 'function';
    const copy = async (value, which)=>{
        try {
            await navigator.clipboard.writeText(value);
            setCopied(which);
            setTimeout(()=>setCopied((c)=>c === which ? null : c), 2000);
        } catch  {
        // A denied clipboard is not an error worth a toast — the value is on
        // screen and selectable, which is the fallback the operator already has.
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: (0, $2xQve.STACK).regular
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    fontSize: '0.8125rem',
                    color: (0, $jTCZr.C).textSecondary,
                    lineHeight: 1.9
                },
                children: t('people.invite.explainer')
            }),
            loading && /*#__PURE__*/ (0, $ayMG0.jsx)($cd50f89b14530f26$var$InviteCodeSkeleton, {
                t: t
            }),
            !loading && error && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                variant: "error",
                children: error
            }),
            !loading && !error && !code && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                variant: "warning",
                action: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                    variant: "outline",
                    onClick: ()=>navigate('/clinic?view=connect'),
                    children: t('people.invite.generateHere')
                }),
                children: t('people.invite.noCode')
            }),
            !loading && !error && !!code && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($cd50f89b14530f26$var$CopyRow, {
                        label: t('people.invite.codeLabel'),
                        value: code,
                        mono: true,
                        copied: copied === 'code',
                        onCopy: ()=>copy(code, 'code'),
                        t: t
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($cd50f89b14530f26$var$CopyRow, {
                        label: t('people.invite.linkLabel'),
                        value: link,
                        copied: copied === 'link',
                        onCopy: ()=>copy(link, 'link'),
                        t: t
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: 8
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    background: '#fff',
                                    padding: 12,
                                    borderRadius: 12,
                                    border: `1px solid ${(0, $jTCZr.C).border}`,
                                    lineHeight: 0
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bYoyu.QRCodeSVG), {
                                    value: link,
                                    size: 168,
                                    level: "M",
                                    marginSize: 2,
                                    bgColor: "#ffffff",
                                    fgColor: "#000000",
                                    title: t('people.invite.qrTitle')
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    fontSize: '0.78125rem',
                                    color: (0, $jTCZr.C).textMuted,
                                    textAlign: 'center',
                                    lineHeight: 1.8
                                },
                                children: t('people.invite.qrHint')
                            })
                        ]
                    }),
                    canShare && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                        variant: "outline",
                        onClick: ()=>navigator.share({
                                url: link
                            }).catch(()=>{}),
                        children: t('people.invite.share')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                        variant: "info",
                        children: t('people.invite.afterScan')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    fontSize: '0.75rem',
                    color: (0, $jTCZr.C).textMuted,
                    lineHeight: 1.8
                },
                children: t('people.invite.searchComingSoon')
            })
        ]
    });
}
/**
 * The code panel's own shape while the invitation code loads: the two copy
 * rows, the QR on its white ground, the hint under it — so the panel does not
 * grow from a spinner into a card when the code lands.
 */ function $cd50f89b14530f26$var$InviteCodeSkeleton({ t: t }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $66joL.SkeletonRegion), {
        label: t('common.state.loading'),
        "data-testid": "invite-code-skeleton",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: (0, $2xQve.STACK).regular
        },
        children: [
            [
                0,
                1
            ].map((i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 6
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                            width: i === 0 ? 72 : 96,
                            height: 13
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                display: 'flex',
                                alignItems: 'center',
                                gap: 8
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                    width: "100%",
                                    height: 41,
                                    radius: 10,
                                    style: {
                                        flex: 1
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonButton), {
                                    width: 88
                                })
                            ]
                        })
                    ]
                }, i)),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 8
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: 194,
                        height: 194,
                        radius: 12
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: 220,
                        height: 13
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                width: "100%",
                height: 48,
                radius: 10
            })
        ]
    });
}
function $cd50f89b14530f26$var$CopyRow({ label: label, value: value, copied: copied, onCopy: onCopy, t: t, mono: mono = false }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 6
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                style: {
                    fontSize: '0.78125rem',
                    color: (0, $jTCZr.C).textSecondary
                },
                children: label
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        dir: "ltr",
                        style: {
                            flex: 1,
                            minWidth: 0,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            unicodeBidi: 'isolate',
                            textAlign: 'start',
                            background: (0, $jTCZr.C).bg,
                            border: `1px solid ${(0, $jTCZr.C).border}`,
                            borderRadius: 10,
                            padding: '10px 12px',
                            fontSize: mono ? '0.9375rem' : '0.78125rem',
                            fontWeight: mono ? 800 : 500,
                            letterSpacing: mono ? 1 : 0,
                            color: (0, $jTCZr.C).textPrimary
                        },
                        children: value
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                        variant: "outline",
                        onClick: onCopy,
                        children: [
                            copied ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $huNwV.default), {
                                size: 15
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2uCMp.default), {
                                size: 15
                            }),
                            copied ? t('people.invite.copied') : t('people.invite.copy')
                        ]
                    })
                ]
            })
        ]
    });
}

});
parcelRegister("bYoyu", function(module, exports) {

$parcel$export(module.exports, "QRCodeSVG", () => $8b78587e05097331$export$10307208e61210e9);

var $acw62 = parcelRequire("acw62");
var $8b78587e05097331$var$__defProp = Object.defineProperty;
var $8b78587e05097331$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $8b78587e05097331$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $8b78587e05097331$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $8b78587e05097331$var$__defNormalProp = (obj, key, value)=>key in obj ? $8b78587e05097331$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $8b78587e05097331$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($8b78587e05097331$var$__hasOwnProp.call(b, prop)) $8b78587e05097331$var$__defNormalProp(a, prop, b[prop]);
    if ($8b78587e05097331$var$__getOwnPropSymbols) {
        for (var prop of $8b78587e05097331$var$__getOwnPropSymbols(b))if ($8b78587e05097331$var$__propIsEnum.call(b, prop)) $8b78587e05097331$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $8b78587e05097331$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($8b78587e05097331$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $8b78587e05097331$var$__getOwnPropSymbols) {
        for (var prop of $8b78587e05097331$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $8b78587e05097331$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
// src/third-party/qrcodegen/index.ts
/**
 * @license QR Code generator library (TypeScript)
 * Copyright (c) Project Nayuki.
 * SPDX-License-Identifier: MIT
 */ var $8b78587e05097331$var$qrcodegen;
((qrcodegen2)=>{
    const _QrCode = class _QrCode {
        /*-- Constructor (low level) and fields --*/ // Creates a new QR Code with the given version number,
        // error correction level, data codeword bytes, and mask number.
        // This is a low-level API that most users should not use directly.
        // A mid-level API is the encodeSegments() function.
        constructor(version, errorCorrectionLevel, dataCodewords, msk){
            this.version = version;
            this.errorCorrectionLevel = errorCorrectionLevel;
            // The modules of this QR Code (false = light, true = dark).
            // Immutable after constructor finishes. Accessed through getModule().
            this.modules = [];
            // Indicates function modules that are not subjected to masking. Discarded when constructor finishes.
            this.isFunction = [];
            if (version < _QrCode.MIN_VERSION || version > _QrCode.MAX_VERSION) throw new RangeError("Version value out of range");
            if (msk < -1 || msk > 7) throw new RangeError("Mask value out of range");
            this.size = version * 4 + 17;
            let row = [];
            for(let i = 0; i < this.size; i++)row.push(false);
            for(let i = 0; i < this.size; i++){
                this.modules.push(row.slice());
                this.isFunction.push(row.slice());
            }
            this.drawFunctionPatterns();
            const allCodewords = this.addEccAndInterleave(dataCodewords);
            this.drawCodewords(allCodewords);
            if (msk == -1) {
                let minPenalty = 1e9;
                for(let i = 0; i < 8; i++){
                    this.applyMask(i);
                    this.drawFormatBits(i);
                    const penalty = this.getPenaltyScore();
                    if (penalty < minPenalty) {
                        msk = i;
                        minPenalty = penalty;
                    }
                    this.applyMask(i);
                }
            }
            assert(0 <= msk && msk <= 7);
            this.mask = msk;
            this.applyMask(msk);
            this.drawFormatBits(msk);
            this.isFunction = [];
        }
        /*-- Static factory functions (high level) --*/ // Returns a QR Code representing the given Unicode text string at the given error correction level.
        // As a conservative upper bound, this function is guaranteed to succeed for strings that have 738 or fewer
        // Unicode code points (not UTF-16 code units) if the low error correction level is used. The smallest possible
        // QR Code version is automatically chosen for the output. The ECC level of the result may be higher than the
        // ecl argument if it can be done without increasing the version.
        static encodeText(text, ecl) {
            const segs = qrcodegen2.QrSegment.makeSegments(text);
            return _QrCode.encodeSegments(segs, ecl);
        }
        // Returns a QR Code representing the given binary data at the given error correction level.
        // This function always encodes using the binary segment mode, not any text mode. The maximum number of
        // bytes allowed is 2953. The smallest possible QR Code version is automatically chosen for the output.
        // The ECC level of the result may be higher than the ecl argument if it can be done without increasing the version.
        static encodeBinary(data, ecl) {
            const seg = qrcodegen2.QrSegment.makeBytes(data);
            return _QrCode.encodeSegments([
                seg
            ], ecl);
        }
        /*-- Static factory functions (mid level) --*/ // Returns a QR Code representing the given segments with the given encoding parameters.
        // The smallest possible QR Code version within the given range is automatically
        // chosen for the output. Iff boostEcl is true, then the ECC level of the result
        // may be higher than the ecl argument if it can be done without increasing the
        // version. The mask number is either between 0 to 7 (inclusive) to force that
        // mask, or -1 to automatically choose an appropriate mask (which may be slow).
        // This function allows the user to create a custom sequence of segments that switches
        // between modes (such as alphanumeric and byte) to encode text in less space.
        // This is a mid-level API; the high-level API is encodeText() and encodeBinary().
        static encodeSegments(segs, ecl, minVersion = 1, maxVersion = 40, mask = -1, boostEcl = true) {
            if (!(_QrCode.MIN_VERSION <= minVersion && minVersion <= maxVersion && maxVersion <= _QrCode.MAX_VERSION) || mask < -1 || mask > 7) throw new RangeError("Invalid value");
            let version;
            let dataUsedBits;
            for(version = minVersion;; version++){
                const dataCapacityBits2 = _QrCode.getNumDataCodewords(version, ecl) * 8;
                const usedBits = QrSegment.getTotalBits(segs, version);
                if (usedBits <= dataCapacityBits2) {
                    dataUsedBits = usedBits;
                    break;
                }
                if (version >= maxVersion) throw new RangeError("Data too long");
            }
            for (const newEcl of [
                _QrCode.Ecc.MEDIUM,
                _QrCode.Ecc.QUARTILE,
                _QrCode.Ecc.HIGH
            ])if (boostEcl && dataUsedBits <= _QrCode.getNumDataCodewords(version, newEcl) * 8) ecl = newEcl;
            let bb = [];
            for (const seg of segs){
                appendBits(seg.mode.modeBits, 4, bb);
                appendBits(seg.numChars, seg.mode.numCharCountBits(version), bb);
                for (const b of seg.getData())bb.push(b);
            }
            assert(bb.length == dataUsedBits);
            const dataCapacityBits = _QrCode.getNumDataCodewords(version, ecl) * 8;
            assert(bb.length <= dataCapacityBits);
            appendBits(0, Math.min(4, dataCapacityBits - bb.length), bb);
            appendBits(0, (8 - bb.length % 8) % 8, bb);
            assert(bb.length % 8 == 0);
            for(let padByte = 236; bb.length < dataCapacityBits; padByte ^= 253)appendBits(padByte, 8, bb);
            let dataCodewords = [];
            while(dataCodewords.length * 8 < bb.length)dataCodewords.push(0);
            bb.forEach((b, i)=>dataCodewords[i >>> 3] |= b << 7 - (i & 7));
            return new _QrCode(version, ecl, dataCodewords, mask);
        }
        /*-- Accessor methods --*/ // Returns the color of the module (pixel) at the given coordinates, which is false
        // for light or true for dark. The top left corner has the coordinates (x=0, y=0).
        // If the given coordinates are out of bounds, then false (light) is returned.
        getModule(x, y) {
            return 0 <= x && x < this.size && 0 <= y && y < this.size && this.modules[y][x];
        }
        // Modified to expose modules for easy access
        getModules() {
            return this.modules;
        }
        /*-- Private helper methods for constructor: Drawing function modules --*/ // Reads this object's version field, and draws and marks all function modules.
        drawFunctionPatterns() {
            for(let i = 0; i < this.size; i++){
                this.setFunctionModule(6, i, i % 2 == 0);
                this.setFunctionModule(i, 6, i % 2 == 0);
            }
            this.drawFinderPattern(3, 3);
            this.drawFinderPattern(this.size - 4, 3);
            this.drawFinderPattern(3, this.size - 4);
            const alignPatPos = this.getAlignmentPatternPositions();
            const numAlign = alignPatPos.length;
            for(let i = 0; i < numAlign; i++){
                for(let j = 0; j < numAlign; j++)if (!(i == 0 && j == 0 || i == 0 && j == numAlign - 1 || i == numAlign - 1 && j == 0)) this.drawAlignmentPattern(alignPatPos[i], alignPatPos[j]);
            }
            this.drawFormatBits(0);
            this.drawVersion();
        }
        // Draws two copies of the format bits (with its own error correction code)
        // based on the given mask and this object's error correction level field.
        drawFormatBits(mask) {
            const data = this.errorCorrectionLevel.formatBits << 3 | mask;
            let rem = data;
            for(let i = 0; i < 10; i++)rem = rem << 1 ^ (rem >>> 9) * 1335;
            const bits = (data << 10 | rem) ^ 21522;
            assert(bits >>> 15 == 0);
            for(let i = 0; i <= 5; i++)this.setFunctionModule(8, i, getBit(bits, i));
            this.setFunctionModule(8, 7, getBit(bits, 6));
            this.setFunctionModule(8, 8, getBit(bits, 7));
            this.setFunctionModule(7, 8, getBit(bits, 8));
            for(let i = 9; i < 15; i++)this.setFunctionModule(14 - i, 8, getBit(bits, i));
            for(let i = 0; i < 8; i++)this.setFunctionModule(this.size - 1 - i, 8, getBit(bits, i));
            for(let i = 8; i < 15; i++)this.setFunctionModule(8, this.size - 15 + i, getBit(bits, i));
            this.setFunctionModule(8, this.size - 8, true);
        }
        // Draws two copies of the version bits (with its own error correction code),
        // based on this object's version field, iff 7 <= version <= 40.
        drawVersion() {
            if (this.version < 7) return;
            let rem = this.version;
            for(let i = 0; i < 12; i++)rem = rem << 1 ^ (rem >>> 11) * 7973;
            const bits = this.version << 12 | rem;
            assert(bits >>> 18 == 0);
            for(let i = 0; i < 18; i++){
                const color = getBit(bits, i);
                const a = this.size - 11 + i % 3;
                const b = Math.floor(i / 3);
                this.setFunctionModule(a, b, color);
                this.setFunctionModule(b, a, color);
            }
        }
        // Draws a 9*9 finder pattern including the border separator,
        // with the center module at (x, y). Modules can be out of bounds.
        drawFinderPattern(x, y) {
            for(let dy = -4; dy <= 4; dy++)for(let dx = -4; dx <= 4; dx++){
                const dist = Math.max(Math.abs(dx), Math.abs(dy));
                const xx = x + dx;
                const yy = y + dy;
                if (0 <= xx && xx < this.size && 0 <= yy && yy < this.size) this.setFunctionModule(xx, yy, dist != 2 && dist != 4);
            }
        }
        // Draws a 5*5 alignment pattern, with the center module
        // at (x, y). All modules must be in bounds.
        drawAlignmentPattern(x, y) {
            for(let dy = -2; dy <= 2; dy++)for(let dx = -2; dx <= 2; dx++)this.setFunctionModule(x + dx, y + dy, Math.max(Math.abs(dx), Math.abs(dy)) != 1);
        }
        // Sets the color of a module and marks it as a function module.
        // Only used by the constructor. Coordinates must be in bounds.
        setFunctionModule(x, y, isDark) {
            this.modules[y][x] = isDark;
            this.isFunction[y][x] = true;
        }
        /*-- Private helper methods for constructor: Codewords and masking --*/ // Returns a new byte string representing the given data with the appropriate error correction
        // codewords appended to it, based on this object's version and error correction level.
        addEccAndInterleave(data) {
            const ver = this.version;
            const ecl = this.errorCorrectionLevel;
            if (data.length != _QrCode.getNumDataCodewords(ver, ecl)) throw new RangeError("Invalid argument");
            const numBlocks = _QrCode.NUM_ERROR_CORRECTION_BLOCKS[ecl.ordinal][ver];
            const blockEccLen = _QrCode.ECC_CODEWORDS_PER_BLOCK[ecl.ordinal][ver];
            const rawCodewords = Math.floor(_QrCode.getNumRawDataModules(ver) / 8);
            const numShortBlocks = numBlocks - rawCodewords % numBlocks;
            const shortBlockLen = Math.floor(rawCodewords / numBlocks);
            let blocks = [];
            const rsDiv = _QrCode.reedSolomonComputeDivisor(blockEccLen);
            for(let i = 0, k = 0; i < numBlocks; i++){
                let dat = data.slice(k, k + shortBlockLen - blockEccLen + (i < numShortBlocks ? 0 : 1));
                k += dat.length;
                const ecc = _QrCode.reedSolomonComputeRemainder(dat, rsDiv);
                if (i < numShortBlocks) dat.push(0);
                blocks.push(dat.concat(ecc));
            }
            let result = [];
            for(let i = 0; i < blocks[0].length; i++)blocks.forEach((block, j)=>{
                if (i != shortBlockLen - blockEccLen || j >= numShortBlocks) result.push(block[i]);
            });
            assert(result.length == rawCodewords);
            return result;
        }
        // Draws the given sequence of 8-bit codewords (data and error correction) onto the entire
        // data area of this QR Code. Function modules need to be marked off before this is called.
        drawCodewords(data) {
            if (data.length != Math.floor(_QrCode.getNumRawDataModules(this.version) / 8)) throw new RangeError("Invalid argument");
            let i = 0;
            for(let right = this.size - 1; right >= 1; right -= 2){
                if (right == 6) right = 5;
                for(let vert = 0; vert < this.size; vert++)for(let j = 0; j < 2; j++){
                    const x = right - j;
                    const upward = (right + 1 & 2) == 0;
                    const y = upward ? this.size - 1 - vert : vert;
                    if (!this.isFunction[y][x] && i < data.length * 8) {
                        this.modules[y][x] = getBit(data[i >>> 3], 7 - (i & 7));
                        i++;
                    }
                }
            }
            assert(i == data.length * 8);
        }
        // XORs the codeword modules in this QR Code with the given mask pattern.
        // The function modules must be marked and the codeword bits must be drawn
        // before masking. Due to the arithmetic of XOR, calling applyMask() with
        // the same mask value a second time will undo the mask. A final well-formed
        // QR Code needs exactly one (not zero, two, etc.) mask applied.
        applyMask(mask) {
            if (mask < 0 || mask > 7) throw new RangeError("Mask value out of range");
            for(let y = 0; y < this.size; y++)for(let x = 0; x < this.size; x++){
                let invert;
                switch(mask){
                    case 0:
                        invert = (x + y) % 2 == 0;
                        break;
                    case 1:
                        invert = y % 2 == 0;
                        break;
                    case 2:
                        invert = x % 3 == 0;
                        break;
                    case 3:
                        invert = (x + y) % 3 == 0;
                        break;
                    case 4:
                        invert = (Math.floor(x / 3) + Math.floor(y / 2)) % 2 == 0;
                        break;
                    case 5:
                        invert = x * y % 2 + x * y % 3 == 0;
                        break;
                    case 6:
                        invert = (x * y % 2 + x * y % 3) % 2 == 0;
                        break;
                    case 7:
                        invert = ((x + y) % 2 + x * y % 3) % 2 == 0;
                        break;
                    default:
                        throw new Error("Unreachable");
                }
                if (!this.isFunction[y][x] && invert) this.modules[y][x] = !this.modules[y][x];
            }
        }
        // Calculates and returns the penalty score based on state of this QR Code's current modules.
        // This is used by the automatic mask choice algorithm to find the mask pattern that yields the lowest score.
        getPenaltyScore() {
            let result = 0;
            for(let y = 0; y < this.size; y++){
                let runColor = false;
                let runX = 0;
                let runHistory = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ];
                for(let x = 0; x < this.size; x++)if (this.modules[y][x] == runColor) {
                    runX++;
                    if (runX == 5) result += _QrCode.PENALTY_N1;
                    else if (runX > 5) result++;
                } else {
                    this.finderPenaltyAddHistory(runX, runHistory);
                    if (!runColor) result += this.finderPenaltyCountPatterns(runHistory) * _QrCode.PENALTY_N3;
                    runColor = this.modules[y][x];
                    runX = 1;
                }
                result += this.finderPenaltyTerminateAndCount(runColor, runX, runHistory) * _QrCode.PENALTY_N3;
            }
            for(let x = 0; x < this.size; x++){
                let runColor = false;
                let runY = 0;
                let runHistory = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ];
                for(let y = 0; y < this.size; y++)if (this.modules[y][x] == runColor) {
                    runY++;
                    if (runY == 5) result += _QrCode.PENALTY_N1;
                    else if (runY > 5) result++;
                } else {
                    this.finderPenaltyAddHistory(runY, runHistory);
                    if (!runColor) result += this.finderPenaltyCountPatterns(runHistory) * _QrCode.PENALTY_N3;
                    runColor = this.modules[y][x];
                    runY = 1;
                }
                result += this.finderPenaltyTerminateAndCount(runColor, runY, runHistory) * _QrCode.PENALTY_N3;
            }
            for(let y = 0; y < this.size - 1; y++)for(let x = 0; x < this.size - 1; x++){
                const color = this.modules[y][x];
                if (color == this.modules[y][x + 1] && color == this.modules[y + 1][x] && color == this.modules[y + 1][x + 1]) result += _QrCode.PENALTY_N2;
            }
            let dark = 0;
            for (const row of this.modules)dark = row.reduce((sum, color)=>sum + (color ? 1 : 0), dark);
            const total = this.size * this.size;
            const k = Math.ceil(Math.abs(dark * 20 - total * 10) / total) - 1;
            assert(0 <= k && k <= 9);
            result += k * _QrCode.PENALTY_N4;
            assert(0 <= result && result <= 2568888);
            return result;
        }
        /*-- Private helper functions --*/ // Returns an ascending list of positions of alignment patterns for this version number.
        // Each position is in the range [0,177), and are used on both the x and y axes.
        // This could be implemented as lookup table of 40 variable-length lists of integers.
        getAlignmentPatternPositions() {
            if (this.version == 1) return [];
            else {
                const numAlign = Math.floor(this.version / 7) + 2;
                const step = this.version == 32 ? 26 : Math.ceil((this.version * 4 + 4) / (numAlign * 2 - 2)) * 2;
                let result = [
                    6
                ];
                for(let pos = this.size - 7; result.length < numAlign; pos -= step)result.splice(1, 0, pos);
                return result;
            }
        }
        // Returns the number of data bits that can be stored in a QR Code of the given version number, after
        // all function modules are excluded. This includes remainder bits, so it might not be a multiple of 8.
        // The result is in the range [208, 29648]. This could be implemented as a 40-entry lookup table.
        static getNumRawDataModules(ver) {
            if (ver < _QrCode.MIN_VERSION || ver > _QrCode.MAX_VERSION) throw new RangeError("Version number out of range");
            let result = (16 * ver + 128) * ver + 64;
            if (ver >= 2) {
                const numAlign = Math.floor(ver / 7) + 2;
                result -= (25 * numAlign - 10) * numAlign - 55;
                if (ver >= 7) result -= 36;
            }
            assert(208 <= result && result <= 29648);
            return result;
        }
        // Returns the number of 8-bit data (i.e. not error correction) codewords contained in any
        // QR Code of the given version number and error correction level, with remainder bits discarded.
        // This stateless pure function could be implemented as a (40*4)-cell lookup table.
        static getNumDataCodewords(ver, ecl) {
            return Math.floor(_QrCode.getNumRawDataModules(ver) / 8) - _QrCode.ECC_CODEWORDS_PER_BLOCK[ecl.ordinal][ver] * _QrCode.NUM_ERROR_CORRECTION_BLOCKS[ecl.ordinal][ver];
        }
        // Returns a Reed-Solomon ECC generator polynomial for the given degree. This could be
        // implemented as a lookup table over all possible parameter values, instead of as an algorithm.
        static reedSolomonComputeDivisor(degree) {
            if (degree < 1 || degree > 255) throw new RangeError("Degree out of range");
            let result = [];
            for(let i = 0; i < degree - 1; i++)result.push(0);
            result.push(1);
            let root = 1;
            for(let i = 0; i < degree; i++){
                for(let j = 0; j < result.length; j++){
                    result[j] = _QrCode.reedSolomonMultiply(result[j], root);
                    if (j + 1 < result.length) result[j] ^= result[j + 1];
                }
                root = _QrCode.reedSolomonMultiply(root, 2);
            }
            return result;
        }
        // Returns the Reed-Solomon error correction codeword for the given data and divisor polynomials.
        static reedSolomonComputeRemainder(data, divisor) {
            let result = divisor.map((_)=>0);
            for (const b of data){
                const factor = b ^ result.shift();
                result.push(0);
                divisor.forEach((coef, i)=>result[i] ^= _QrCode.reedSolomonMultiply(coef, factor));
            }
            return result;
        }
        // Returns the product of the two given field elements modulo GF(2^8/0x11D). The arguments and result
        // are unsigned 8-bit integers. This could be implemented as a lookup table of 256*256 entries of uint8.
        static reedSolomonMultiply(x, y) {
            if (x >>> 8 != 0 || y >>> 8 != 0) throw new RangeError("Byte out of range");
            let z = 0;
            for(let i = 7; i >= 0; i--){
                z = z << 1 ^ (z >>> 7) * 285;
                z ^= (y >>> i & 1) * x;
            }
            assert(z >>> 8 == 0);
            return z;
        }
        // Can only be called immediately after a light run is added, and
        // returns either 0, 1, or 2. A helper function for getPenaltyScore().
        finderPenaltyCountPatterns(runHistory) {
            const n = runHistory[1];
            assert(n <= this.size * 3);
            const core = n > 0 && runHistory[2] == n && runHistory[3] == n * 3 && runHistory[4] == n && runHistory[5] == n;
            return (core && runHistory[0] >= n * 4 && runHistory[6] >= n ? 1 : 0) + (core && runHistory[6] >= n * 4 && runHistory[0] >= n ? 1 : 0);
        }
        // Must be called at the end of a line (row or column) of modules. A helper function for getPenaltyScore().
        finderPenaltyTerminateAndCount(currentRunColor, currentRunLength, runHistory) {
            if (currentRunColor) {
                this.finderPenaltyAddHistory(currentRunLength, runHistory);
                currentRunLength = 0;
            }
            currentRunLength += this.size;
            this.finderPenaltyAddHistory(currentRunLength, runHistory);
            return this.finderPenaltyCountPatterns(runHistory);
        }
        // Pushes the given value to the front and drops the last value. A helper function for getPenaltyScore().
        finderPenaltyAddHistory(currentRunLength, runHistory) {
            if (runHistory[0] == 0) currentRunLength += this.size;
            runHistory.pop();
            runHistory.unshift(currentRunLength);
        }
    };
    /*-- Constants and tables --*/ // The minimum version number supported in the QR Code Model 2 standard.
    _QrCode.MIN_VERSION = 1;
    // The maximum version number supported in the QR Code Model 2 standard.
    _QrCode.MAX_VERSION = 40;
    // For use in getPenaltyScore(), when evaluating which mask is best.
    _QrCode.PENALTY_N1 = 3;
    _QrCode.PENALTY_N2 = 3;
    _QrCode.PENALTY_N3 = 40;
    _QrCode.PENALTY_N4 = 10;
    _QrCode.ECC_CODEWORDS_PER_BLOCK = [
        // Version: (note that index 0 is for padding, and is set to an illegal value)
        //0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40    Error correction level
        [
            -1,
            7,
            10,
            15,
            20,
            26,
            18,
            20,
            24,
            30,
            18,
            20,
            24,
            26,
            30,
            22,
            24,
            28,
            30,
            28,
            28,
            28,
            28,
            30,
            30,
            26,
            28,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30
        ],
        // Low
        [
            -1,
            10,
            16,
            26,
            18,
            24,
            16,
            18,
            22,
            22,
            26,
            30,
            22,
            22,
            24,
            24,
            28,
            28,
            26,
            26,
            26,
            26,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28
        ],
        // Medium
        [
            -1,
            13,
            22,
            18,
            26,
            18,
            24,
            18,
            22,
            20,
            24,
            28,
            26,
            24,
            20,
            30,
            24,
            28,
            28,
            26,
            30,
            28,
            30,
            30,
            30,
            30,
            28,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30
        ],
        // Quartile
        [
            -1,
            17,
            28,
            22,
            16,
            22,
            28,
            26,
            26,
            24,
            28,
            24,
            28,
            22,
            24,
            24,
            30,
            28,
            28,
            26,
            28,
            30,
            24,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30
        ]
    ];
    _QrCode.NUM_ERROR_CORRECTION_BLOCKS = [
        // Version: (note that index 0 is for padding, and is set to an illegal value)
        //0, 1, 2, 3, 4, 5, 6, 7, 8, 9,10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40    Error correction level
        [
            -1,
            1,
            1,
            1,
            1,
            1,
            2,
            2,
            2,
            2,
            4,
            4,
            4,
            4,
            4,
            6,
            6,
            6,
            6,
            7,
            8,
            8,
            9,
            9,
            10,
            12,
            12,
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19,
            19,
            20,
            21,
            22,
            24,
            25
        ],
        // Low
        [
            -1,
            1,
            1,
            1,
            2,
            2,
            4,
            4,
            4,
            5,
            5,
            5,
            8,
            9,
            9,
            10,
            10,
            11,
            13,
            14,
            16,
            17,
            17,
            18,
            20,
            21,
            23,
            25,
            26,
            28,
            29,
            31,
            33,
            35,
            37,
            38,
            40,
            43,
            45,
            47,
            49
        ],
        // Medium
        [
            -1,
            1,
            1,
            2,
            2,
            4,
            4,
            6,
            6,
            8,
            8,
            8,
            10,
            12,
            16,
            12,
            17,
            16,
            18,
            21,
            20,
            23,
            23,
            25,
            27,
            29,
            34,
            34,
            35,
            38,
            40,
            43,
            45,
            48,
            51,
            53,
            56,
            59,
            62,
            65,
            68
        ],
        // Quartile
        [
            -1,
            1,
            1,
            2,
            4,
            4,
            4,
            5,
            6,
            8,
            8,
            11,
            11,
            16,
            16,
            18,
            16,
            19,
            21,
            25,
            25,
            25,
            34,
            30,
            32,
            35,
            37,
            40,
            42,
            45,
            48,
            51,
            54,
            57,
            60,
            63,
            66,
            70,
            74,
            77,
            81
        ]
    ];
    let QrCode = _QrCode;
    qrcodegen2.QrCode = _QrCode;
    function appendBits(val, len, bb) {
        if (len < 0 || len > 31 || val >>> len != 0) throw new RangeError("Value out of range");
        for(let i = len - 1; i >= 0; i--)bb.push(val >>> i & 1);
    }
    function getBit(x, i) {
        return (x >>> i & 1) != 0;
    }
    function assert(cond) {
        if (!cond) throw new Error("Assertion error");
    }
    const _QrSegment = class _QrSegment {
        /*-- Constructor (low level) and fields --*/ // Creates a new QR Code segment with the given attributes and data.
        // The character count (numChars) must agree with the mode and the bit buffer length,
        // but the constraint isn't checked. The given bit buffer is cloned and stored.
        constructor(mode, numChars, bitData){
            this.mode = mode;
            this.numChars = numChars;
            this.bitData = bitData;
            if (numChars < 0) throw new RangeError("Invalid argument");
            this.bitData = bitData.slice();
        }
        /*-- Static factory functions (mid level) --*/ // Returns a segment representing the given binary data encoded in
        // byte mode. All input byte arrays are acceptable. Any text string
        // can be converted to UTF-8 bytes and encoded as a byte mode segment.
        static makeBytes(data) {
            let bb = [];
            for (const b of data)appendBits(b, 8, bb);
            return new _QrSegment(_QrSegment.Mode.BYTE, data.length, bb);
        }
        // Returns a segment representing the given string of decimal digits encoded in numeric mode.
        static makeNumeric(digits) {
            if (!_QrSegment.isNumeric(digits)) throw new RangeError("String contains non-numeric characters");
            let bb = [];
            for(let i = 0; i < digits.length;){
                const n = Math.min(digits.length - i, 3);
                appendBits(parseInt(digits.substring(i, i + n), 10), n * 3 + 1, bb);
                i += n;
            }
            return new _QrSegment(_QrSegment.Mode.NUMERIC, digits.length, bb);
        }
        // Returns a segment representing the given text string encoded in alphanumeric mode.
        // The characters allowed are: 0 to 9, A to Z (uppercase only), space,
        // dollar, percent, asterisk, plus, hyphen, period, slash, colon.
        static makeAlphanumeric(text) {
            if (!_QrSegment.isAlphanumeric(text)) throw new RangeError("String contains unencodable characters in alphanumeric mode");
            let bb = [];
            let i;
            for(i = 0; i + 2 <= text.length; i += 2){
                let temp = _QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i)) * 45;
                temp += _QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i + 1));
                appendBits(temp, 11, bb);
            }
            if (i < text.length) appendBits(_QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i)), 6, bb);
            return new _QrSegment(_QrSegment.Mode.ALPHANUMERIC, text.length, bb);
        }
        // Returns a new mutable list of zero or more segments to represent the given Unicode text string.
        // The result may use various segment modes and switch modes to optimize the length of the bit stream.
        static makeSegments(text) {
            if (text == "") return [];
            else if (_QrSegment.isNumeric(text)) return [
                _QrSegment.makeNumeric(text)
            ];
            else if (_QrSegment.isAlphanumeric(text)) return [
                _QrSegment.makeAlphanumeric(text)
            ];
            else return [
                _QrSegment.makeBytes(_QrSegment.toUtf8ByteArray(text))
            ];
        }
        // Returns a segment representing an Extended Channel Interpretation
        // (ECI) designator with the given assignment value.
        static makeEci(assignVal) {
            let bb = [];
            if (assignVal < 0) throw new RangeError("ECI assignment value out of range");
            else if (assignVal < 128) appendBits(assignVal, 8, bb);
            else if (assignVal < 16384) {
                appendBits(2, 2, bb);
                appendBits(assignVal, 14, bb);
            } else if (assignVal < 1e6) {
                appendBits(6, 3, bb);
                appendBits(assignVal, 21, bb);
            } else throw new RangeError("ECI assignment value out of range");
            return new _QrSegment(_QrSegment.Mode.ECI, 0, bb);
        }
        // Tests whether the given string can be encoded as a segment in numeric mode.
        // A string is encodable iff each character is in the range 0 to 9.
        static isNumeric(text) {
            return _QrSegment.NUMERIC_REGEX.test(text);
        }
        // Tests whether the given string can be encoded as a segment in alphanumeric mode.
        // A string is encodable iff each character is in the following set: 0 to 9, A to Z
        // (uppercase only), space, dollar, percent, asterisk, plus, hyphen, period, slash, colon.
        static isAlphanumeric(text) {
            return _QrSegment.ALPHANUMERIC_REGEX.test(text);
        }
        /*-- Methods --*/ // Returns a new copy of the data bits of this segment.
        getData() {
            return this.bitData.slice();
        }
        // (Package-private) Calculates and returns the number of bits needed to encode the given segments at
        // the given version. The result is infinity if a segment has too many characters to fit its length field.
        static getTotalBits(segs, version) {
            let result = 0;
            for (const seg of segs){
                const ccbits = seg.mode.numCharCountBits(version);
                if (seg.numChars >= 1 << ccbits) return Infinity;
                result += 4 + ccbits + seg.bitData.length;
            }
            return result;
        }
        // Returns a new array of bytes representing the given string encoded in UTF-8.
        static toUtf8ByteArray(str) {
            str = encodeURI(str);
            let result = [];
            for(let i = 0; i < str.length; i++)if (str.charAt(i) != "%") result.push(str.charCodeAt(i));
            else {
                result.push(parseInt(str.substring(i + 1, i + 3), 16));
                i += 2;
            }
            return result;
        }
    };
    /*-- Constants --*/ // Describes precisely all strings that are encodable in numeric mode.
    _QrSegment.NUMERIC_REGEX = /^[0-9]*$/;
    // Describes precisely all strings that are encodable in alphanumeric mode.
    _QrSegment.ALPHANUMERIC_REGEX = /^[A-Z0-9 $%*+.\/:-]*$/;
    // The set of all legal characters in alphanumeric mode,
    // where each character value maps to the index in the string.
    _QrSegment.ALPHANUMERIC_CHARSET = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:";
    let QrSegment = _QrSegment;
    qrcodegen2.QrSegment = _QrSegment;
})($8b78587e05097331$var$qrcodegen || ($8b78587e05097331$var$qrcodegen = {}));
((qrcodegen2)=>{
    let QrCode;
    ((QrCode2)=>{
        const _Ecc = class _Ecc {
            // The QR Code can tolerate about 30% erroneous codewords
            /*-- Constructor and fields --*/ constructor(ordinal, formatBits){
                this.ordinal = ordinal;
                this.formatBits = formatBits;
            }
        };
        /*-- Constants --*/ _Ecc.LOW = new _Ecc(0, 1);
        // The QR Code can tolerate about  7% erroneous codewords
        _Ecc.MEDIUM = new _Ecc(1, 0);
        // The QR Code can tolerate about 15% erroneous codewords
        _Ecc.QUARTILE = new _Ecc(2, 3);
        // The QR Code can tolerate about 25% erroneous codewords
        _Ecc.HIGH = new _Ecc(3, 2);
        let Ecc = _Ecc;
        QrCode2.Ecc = _Ecc;
    })(QrCode = qrcodegen2.QrCode || (qrcodegen2.QrCode = {}));
})($8b78587e05097331$var$qrcodegen || ($8b78587e05097331$var$qrcodegen = {}));
((qrcodegen2)=>{
    let QrSegment;
    ((QrSegment2)=>{
        const _Mode = class _Mode {
            /*-- Constructor and fields --*/ constructor(modeBits, numBitsCharCount){
                this.modeBits = modeBits;
                this.numBitsCharCount = numBitsCharCount;
            }
            /*-- Method --*/ // (Package-private) Returns the bit width of the character count field for a segment in
            // this mode in a QR Code at the given version number. The result is in the range [0, 16].
            numCharCountBits(ver) {
                return this.numBitsCharCount[Math.floor((ver + 7) / 17)];
            }
        };
        /*-- Constants --*/ _Mode.NUMERIC = new _Mode(1, [
            10,
            12,
            14
        ]);
        _Mode.ALPHANUMERIC = new _Mode(2, [
            9,
            11,
            13
        ]);
        _Mode.BYTE = new _Mode(4, [
            8,
            16,
            16
        ]);
        _Mode.KANJI = new _Mode(8, [
            8,
            10,
            12
        ]);
        _Mode.ECI = new _Mode(7, [
            0,
            0,
            0
        ]);
        let Mode = _Mode;
        QrSegment2.Mode = _Mode;
    })(QrSegment = qrcodegen2.QrSegment || (qrcodegen2.QrSegment = {}));
})($8b78587e05097331$var$qrcodegen || ($8b78587e05097331$var$qrcodegen = {}));
var $8b78587e05097331$var$qrcodegen_default = $8b78587e05097331$var$qrcodegen;
// src/index.tsx
/**
 * @license qrcode.react
 * Copyright (c) Paul O'Shannessy
 * SPDX-License-Identifier: ISC
 */ var $8b78587e05097331$var$ERROR_LEVEL_MAP = {
    L: $8b78587e05097331$var$qrcodegen_default.QrCode.Ecc.LOW,
    M: $8b78587e05097331$var$qrcodegen_default.QrCode.Ecc.MEDIUM,
    Q: $8b78587e05097331$var$qrcodegen_default.QrCode.Ecc.QUARTILE,
    H: $8b78587e05097331$var$qrcodegen_default.QrCode.Ecc.HIGH
};
var $8b78587e05097331$var$DEFAULT_SIZE = 128;
var $8b78587e05097331$var$DEFAULT_LEVEL = "L";
var $8b78587e05097331$var$DEFAULT_BGCOLOR = "#FFFFFF";
var $8b78587e05097331$var$DEFAULT_FGCOLOR = "#000000";
var $8b78587e05097331$var$DEFAULT_INCLUDEMARGIN = false;
var $8b78587e05097331$var$DEFAULT_MINVERSION = 1;
var $8b78587e05097331$var$SPEC_MARGIN_SIZE = 4;
var $8b78587e05097331$var$DEFAULT_MARGIN_SIZE = 0;
var $8b78587e05097331$var$DEFAULT_IMG_SCALE = 0.1;
function $8b78587e05097331$var$generatePath(modules, margin = 0) {
    const ops = [];
    modules.forEach(function(row, y) {
        let start = null;
        row.forEach(function(cell, x) {
            if (!cell && start !== null) {
                ops.push(`M${start + margin} ${y + margin}h${x - start}v1H${start + margin}z`);
                start = null;
                return;
            }
            if (x === row.length - 1) {
                if (!cell) return;
                if (start === null) ops.push(`M${x + margin},${y + margin} h1v1H${x + margin}z`);
                else ops.push(`M${start + margin},${y + margin} h${x + 1 - start}v1H${start + margin}z`);
                return;
            }
            if (cell && start === null) start = x;
        });
    });
    return ops.join("");
}
function $8b78587e05097331$var$excavateModules(modules, excavation) {
    return modules.slice().map((row, y)=>{
        if (y < excavation.y || y >= excavation.y + excavation.h) return row;
        return row.map((cell, x)=>{
            if (x < excavation.x || x >= excavation.x + excavation.w) return cell;
            return false;
        });
    });
}
function $8b78587e05097331$var$getImageSettings(cells, size, margin, imageSettings) {
    if (imageSettings == null) return null;
    const numCells = cells.length + margin * 2;
    const defaultSize = Math.floor(size * $8b78587e05097331$var$DEFAULT_IMG_SCALE);
    const scale = numCells / size;
    const w = (imageSettings.width || defaultSize) * scale;
    const h = (imageSettings.height || defaultSize) * scale;
    const x = imageSettings.x == null ? cells.length / 2 - w / 2 : imageSettings.x * scale;
    const y = imageSettings.y == null ? cells.length / 2 - h / 2 : imageSettings.y * scale;
    const opacity = imageSettings.opacity == null ? 1 : imageSettings.opacity;
    let excavation = null;
    if (imageSettings.excavate) {
        let floorX = Math.floor(x);
        let floorY = Math.floor(y);
        let ceilW = Math.ceil(w + x - floorX);
        let ceilH = Math.ceil(h + y - floorY);
        excavation = {
            x: floorX,
            y: floorY,
            w: ceilW,
            h: ceilH
        };
    }
    const crossOrigin = imageSettings.crossOrigin;
    return {
        x: x,
        y: y,
        h: h,
        w: w,
        excavation: excavation,
        opacity: opacity,
        crossOrigin: crossOrigin
    };
}
function $8b78587e05097331$var$getMarginSize(includeMargin, marginSize) {
    if (marginSize != null) return Math.max(Math.floor(marginSize), 0);
    return includeMargin ? $8b78587e05097331$var$SPEC_MARGIN_SIZE : $8b78587e05097331$var$DEFAULT_MARGIN_SIZE;
}
function $8b78587e05097331$var$useQRCode({ value: value, level: level, minVersion: minVersion, includeMargin: includeMargin, marginSize: marginSize, imageSettings: imageSettings, size: size, boostLevel: boostLevel }) {
    let qrcode = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const values = Array.isArray(value) ? value : [
            value
        ];
        const segments = values.reduce((accum, v)=>{
            accum.push(...$8b78587e05097331$var$qrcodegen_default.QrSegment.makeSegments(v));
            return accum;
        }, []);
        return $8b78587e05097331$var$qrcodegen_default.QrCode.encodeSegments(segments, $8b78587e05097331$var$ERROR_LEVEL_MAP[level], minVersion, void 0, void 0, boostLevel);
    }, [
        value,
        level,
        minVersion,
        boostLevel
    ]);
    const { cells: cells, margin: margin, numCells: numCells, calculatedImageSettings: calculatedImageSettings } = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        let cells2 = qrcode.getModules();
        const margin2 = $8b78587e05097331$var$getMarginSize(includeMargin, marginSize);
        const numCells2 = cells2.length + margin2 * 2;
        const calculatedImageSettings2 = $8b78587e05097331$var$getImageSettings(cells2, size, margin2, imageSettings);
        return {
            cells: cells2,
            margin: margin2,
            numCells: numCells2,
            calculatedImageSettings: calculatedImageSettings2
        };
    }, [
        qrcode,
        size,
        imageSettings,
        includeMargin,
        marginSize
    ]);
    return {
        qrcode: qrcode,
        margin: margin,
        cells: cells,
        numCells: numCells,
        calculatedImageSettings: calculatedImageSettings
    };
}
var $8b78587e05097331$var$SUPPORTS_PATH2D = function() {
    try {
        new Path2D().addPath(new Path2D());
    } catch (e) {
        return false;
    }
    return true;
}();
var $8b78587e05097331$export$7e3713cf0c0fe9d0 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function QRCodeCanvas2(props, forwardedRef) {
    const _a = props, { value: value, size: size = $8b78587e05097331$var$DEFAULT_SIZE, level: level = $8b78587e05097331$var$DEFAULT_LEVEL, bgColor: bgColor = $8b78587e05097331$var$DEFAULT_BGCOLOR, fgColor: fgColor = $8b78587e05097331$var$DEFAULT_FGCOLOR, includeMargin: includeMargin = $8b78587e05097331$var$DEFAULT_INCLUDEMARGIN, minVersion: minVersion = $8b78587e05097331$var$DEFAULT_MINVERSION, boostLevel: boostLevel, marginSize: marginSize, imageSettings: imageSettings } = _a, extraProps = $8b78587e05097331$var$__objRest(_a, [
        "value",
        "size",
        "level",
        "bgColor",
        "fgColor",
        "includeMargin",
        "minVersion",
        "boostLevel",
        "marginSize",
        "imageSettings"
    ]);
    const _b = extraProps, { style: style } = _b, otherProps = $8b78587e05097331$var$__objRest(_b, [
        "style"
    ]);
    const imgSrc = imageSettings == null ? void 0 : imageSettings.src;
    const _canvas = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const _image = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const setCanvasRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((node)=>{
        _canvas.current = node;
        if (typeof forwardedRef === "function") forwardedRef(node);
        else if (forwardedRef) forwardedRef.current = node;
    }, [
        forwardedRef
    ]);
    const [isImgLoaded, setIsImageLoaded] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const { margin: margin, cells: cells, numCells: numCells, calculatedImageSettings: calculatedImageSettings } = $8b78587e05097331$var$useQRCode({
        value: value,
        level: level,
        minVersion: minVersion,
        boostLevel: boostLevel,
        includeMargin: includeMargin,
        marginSize: marginSize,
        imageSettings: imageSettings,
        size: size
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (_canvas.current != null) {
            const canvas = _canvas.current;
            const ctx = canvas.getContext("2d");
            if (!ctx) return;
            let cellsToDraw = cells;
            const image = _image.current;
            const haveImageToRender = calculatedImageSettings != null && image !== null && image.complete && image.naturalHeight !== 0 && image.naturalWidth !== 0;
            if (haveImageToRender) {
                if (calculatedImageSettings.excavation != null) cellsToDraw = $8b78587e05097331$var$excavateModules(cells, calculatedImageSettings.excavation);
            }
            const pixelRatio = window.devicePixelRatio || 1;
            canvas.height = canvas.width = size * pixelRatio;
            const scale = size / numCells * pixelRatio;
            ctx.scale(scale, scale);
            ctx.fillStyle = bgColor;
            ctx.fillRect(0, 0, numCells, numCells);
            ctx.fillStyle = fgColor;
            if ($8b78587e05097331$var$SUPPORTS_PATH2D) ctx.fill(new Path2D($8b78587e05097331$var$generatePath(cellsToDraw, margin)));
            else cells.forEach(function(row, rdx) {
                row.forEach(function(cell, cdx) {
                    if (cell) ctx.fillRect(cdx + margin, rdx + margin, 1, 1);
                });
            });
            if (calculatedImageSettings) ctx.globalAlpha = calculatedImageSettings.opacity;
            if (haveImageToRender) ctx.drawImage(image, calculatedImageSettings.x + margin, calculatedImageSettings.y + margin, calculatedImageSettings.w, calculatedImageSettings.h);
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setIsImageLoaded(false);
    }, [
        imgSrc
    ]);
    const canvasStyle = $8b78587e05097331$var$__spreadValues({
        height: size,
        width: size
    }, style);
    let img = null;
    if (imgSrc != null) img = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: imgSrc,
        key: imgSrc,
        style: {
            display: "none"
        },
        onLoad: ()=>{
            setIsImageLoaded(true);
        },
        ref: _image,
        crossOrigin: calculatedImageSettings == null ? void 0 : calculatedImageSettings.crossOrigin
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("canvas", $8b78587e05097331$var$__spreadValues({
        style: canvasStyle,
        height: size,
        width: size,
        ref: setCanvasRef,
        role: "img"
    }, otherProps)), img);
});
$8b78587e05097331$export$7e3713cf0c0fe9d0.displayName = "QRCodeCanvas";
var $8b78587e05097331$export$10307208e61210e9 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function QRCodeSVG2(props, forwardedRef) {
    const _a = props, { value: value, size: size = $8b78587e05097331$var$DEFAULT_SIZE, level: level = $8b78587e05097331$var$DEFAULT_LEVEL, bgColor: bgColor = $8b78587e05097331$var$DEFAULT_BGCOLOR, fgColor: fgColor = $8b78587e05097331$var$DEFAULT_FGCOLOR, includeMargin: includeMargin = $8b78587e05097331$var$DEFAULT_INCLUDEMARGIN, minVersion: minVersion = $8b78587e05097331$var$DEFAULT_MINVERSION, boostLevel: boostLevel, title: title, marginSize: marginSize, imageSettings: imageSettings } = _a, otherProps = $8b78587e05097331$var$__objRest(_a, [
        "value",
        "size",
        "level",
        "bgColor",
        "fgColor",
        "includeMargin",
        "minVersion",
        "boostLevel",
        "title",
        "marginSize",
        "imageSettings"
    ]);
    const { margin: margin, cells: cells, numCells: numCells, calculatedImageSettings: calculatedImageSettings } = $8b78587e05097331$var$useQRCode({
        value: value,
        level: level,
        minVersion: minVersion,
        boostLevel: boostLevel,
        includeMargin: includeMargin,
        marginSize: marginSize,
        imageSettings: imageSettings,
        size: size
    });
    let cellsToDraw = cells;
    let image = null;
    if (imageSettings != null && calculatedImageSettings != null) {
        if (calculatedImageSettings.excavation != null) cellsToDraw = $8b78587e05097331$var$excavateModules(cells, calculatedImageSettings.excavation);
        image = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("image", {
            href: imageSettings.src,
            height: calculatedImageSettings.h,
            width: calculatedImageSettings.w,
            x: calculatedImageSettings.x + margin,
            y: calculatedImageSettings.y + margin,
            preserveAspectRatio: "none",
            opacity: calculatedImageSettings.opacity,
            crossOrigin: calculatedImageSettings.crossOrigin
        });
    }
    const fgPath = $8b78587e05097331$var$generatePath(cellsToDraw, margin);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $8b78587e05097331$var$__spreadValues({
        height: size,
        width: size,
        viewBox: `0 0 ${numCells} ${numCells}`,
        ref: forwardedRef,
        role: "img"
    }, otherProps), !!title && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: bgColor,
        d: `M0,0 h${numCells}v${numCells}H0z`,
        shapeRendering: "crispEdges"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: fgColor,
        d: fgPath,
        shapeRendering: "crispEdges"
    }), image);
});
$8b78587e05097331$export$10307208e61210e9.displayName = "QRCodeSVG";

});



parcelRegister("338ed", function(module, exports) {

$parcel$export(module.exports, "REQUESTS_QUERY", () => $238808e27aceb50b$export$8ce176979f715c94);
$parcel$export(module.exports, "useAppointmentRequests", () => $238808e27aceb50b$export$bc2039484bd8cf2f);
$parcel$export(module.exports, "usePendingRequestCount", () => $238808e27aceb50b$export$403f575511b3aaca);

var $acw62 = parcelRequire("acw62");

var $2Mst8 = parcelRequire("2Mst8");
const $238808e27aceb50b$export$8ce176979f715c94 = `
  query AppointmentRequests($state: String, $providerId: ID, $limit: Int) {
    appointmentRequests(state: $state, providerId: $providerId, limit: $limit) {
      membershipStatus
      slotStillAvailable
      ageMinutes
      patient { id name phone fileNumber }
      appointment {
        id patientId placeholderLabel doctorId doctorName providerId
        dateTime time date type status urgency
        patientNote rejectionReason rejectionNote source requestedAt
      }
    }
  }
`;
const $238808e27aceb50b$export$eb6308551460254a = `
  query PendingAppointmentRequestCount {
    pendingAppointmentRequestCount
  }
`;
const $238808e27aceb50b$var$CONFIRM_REQUEST = `
  mutation ConfirmAppointmentRequest($appointmentId: ID!, $newDateTime: String) {
    confirmAppointmentRequest(appointmentId: $appointmentId, newDateTime: $newDateTime) { id status dateTime }
  }
`;
const $238808e27aceb50b$var$REJECT_REQUEST = `
  mutation RejectAppointmentRequest($appointmentId: ID!, $reasonCode: String!, $note: String) {
    rejectAppointmentRequest(appointmentId: $appointmentId, reasonCode: $reasonCode, note: $note) { id status }
  }
`;
function $238808e27aceb50b$export$bc2039484bd8cf2f({ state: state = 'open', providerId: providerId = '', enabled: enabled = true } = {}) {
    const [rows, setRows] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(enabled);
    const [error, setError] = (0, $acw62.useState)(null);
    // Every read takes a ticket. Switching the filter while a read is in flight
    // would otherwise let the old answer land on the new filter — the same race
    // `useReception` solves the same way.
    const reqId = (0, $acw62.useRef)(0);
    const reload = (0, $acw62.useCallback)(async ()=>{
        if (!enabled) return;
        const req = ++reqId.current;
        setLoading(true);
        try {
            const data = await (0, $2Mst8.bffQuery)($238808e27aceb50b$export$8ce176979f715c94, {
                state: state,
                providerId: providerId || undefined,
                limit: 200
            });
            if (req !== reqId.current) return;
            setRows(data?.appointmentRequests || []);
            setError(null);
        } catch (err) {
            if (req !== reqId.current) return;
            // Four states, exactly one rendered: the rows are cleared so a stale list
            // cannot sit under an error banner and be acted on.
            setRows([]);
            setError(err?.message || String(err));
        } finally{
            if (req === reqId.current) setLoading(false);
        }
    }, [
        state,
        providerId,
        enabled
    ]);
    (0, $acw62.useEffect)(()=>{
        reload();
    }, [
        reload
    ]);
    /**
   * تأیید, or «تأیید با زمان دیگر» when `newDateTime` is given.
   *
   * Never swallows the refusal: SLOT_TAKEN is the case the whole screen exists
   * for, and the caller turns it into «تأیید با زمان دیگر» rather than a toast
   * that says the confirmation failed.
   */ const confirm = (0, $acw62.useCallback)(async (appointmentId, newDateTime = null)=>{
        const data = await (0, $2Mst8.bffMutation)($238808e27aceb50b$var$CONFIRM_REQUEST, {
            appointmentId: appointmentId,
            newDateTime: newDateTime == null ? undefined : String(newDateTime)
        });
        await reload();
        return data?.confirmAppointmentRequest || null;
    }, [
        reload
    ]);
    const reject = (0, $acw62.useCallback)(async (appointmentId, reasonCode, note)=>{
        const data = await (0, $2Mst8.bffMutation)($238808e27aceb50b$var$REJECT_REQUEST, {
            appointmentId: appointmentId,
            reasonCode: reasonCode,
            note: note || undefined
        });
        await reload();
        return data?.rejectAppointmentRequest || null;
    }, [
        reload
    ]);
    return {
        rows: rows,
        loading: loading,
        error: error,
        reload: reload,
        confirm: confirm,
        reject: reject
    };
}
function $238808e27aceb50b$export$403f575511b3aaca({ enabled: enabled = true, refreshKey: refreshKey = 0 } = {}) {
    const [count, setCount] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        if (!enabled) return undefined;
        let live = true;
        (0, $2Mst8.bffQuery)($238808e27aceb50b$export$eb6308551460254a).then((data)=>{
            if (!live) return;
            const n = data?.pendingAppointmentRequestCount;
            setCount(typeof n === 'number' ? n : null);
        }).catch(()=>{
            if (live) setCount(null);
        });
        return ()=>{
            live = false;
        };
    }, [
        enabled,
        refreshKey
    ]);
    return count;
}

});

parcelRegister("jssTS", function(module, exports) {

$parcel$export(module.exports, "useBookableServices", () => $e2a70cd3925cc1e0$export$d0af05e0762a2f2e);

var $acw62 = parcelRequire("acw62");

var $2Mst8 = parcelRequire("2Mst8");
const $e2a70cd3925cc1e0$export$3e61ad2ea76313b1 = `
  declarationId catalogId name category orderType schedulingMode
  durationMinutes durationSource unitPrice currency isActive doctorId
  performers { type id label isDefault members { type id name active } }
  patientBookable publicVisible prepInstructions
`;
const $e2a70cd3925cc1e0$export$6410c78b563aaba = `
  query BookableServices($providerType: PerformerType, $providerId: ID, $patientFacing: Boolean) {
    bookableServices(providerType: $providerType, providerId: $providerId, patientFacing: $patientFacing) {
      ${$e2a70cd3925cc1e0$export$3e61ad2ea76313b1}
    }
  }
`;
function $e2a70cd3925cc1e0$export$d0af05e0762a2f2e({ providerType: providerType = null, providerId: providerId = null, patientFacing: patientFacing = false, enabled: enabled = true } = {}) {
    const [services, setServices] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(!!enabled);
    const [loaded, setLoaded] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    const load = (0, $acw62.useCallback)(async ()=>{
        if (!enabled) {
            setServices([]);
            setLoaded(false);
            setLoading(false);
            setError(null);
            return;
        }
        setLoading(true);
        try {
            const d = await (0, $2Mst8.bffQuery)($e2a70cd3925cc1e0$export$6410c78b563aaba, {
                providerType: providerType || null,
                providerId: providerId || null,
                patientFacing: !!patientFacing
            }, 'BookableServices');
            setServices(d?.bookableServices || []);
            setLoaded(true);
            setError(null);
        } catch (e) {
            setServices([]);
            setLoaded(false);
            setError(e?.message || 'bookableServices');
        } finally{
            setLoading(false);
        }
    }, [
        enabled,
        providerType,
        providerId,
        patientFacing
    ]);
    (0, $acw62.useEffect)(()=>{
        load();
    }, [
        load
    ]);
    return {
        services: services,
        loading: loading,
        loaded: loaded,
        error: error,
        reload: load
    };
}
var $e2a70cd3925cc1e0$export$2e2bcd8739ae039 = $e2a70cd3925cc1e0$export$d0af05e0762a2f2e;

});

parcelRegister("58VTS", function(module, exports) {

$parcel$export(module.exports, "default", () => $56dc65ee208cb438$export$2e2bcd8739ae039);
$parcel$export(module.exports, "usePerformersFirstFree", () => $56dc65ee208cb438$export$4fff79acc0e6d75f);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $QG9Z3 = parcelRequire("QG9Z3");
var $6Md3F = parcelRequire("6Md3F");
var $2WFPf = parcelRequire("2WFPf");
var $gKFEi = parcelRequire("gKFEi");
var $kzPvP = parcelRequire("kzPvP");
var $e5Ore = parcelRequire("e5Ore");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $aJ1FU = parcelRequire("aJ1FU");
var $cjPik = parcelRequire("cjPik");
var $4fYdd = parcelRequire("4fYdd");
var $2vXUl = parcelRequire("2vXUl");
var $h4ZeB = parcelRequire("h4ZeB");
var $5AX1S = parcelRequire("5AX1S");
var $fYgeo = parcelRequire("fYgeo");
var $66joL = parcelRequire("66joL");
var $hZDga = parcelRequire("hZDga");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");
parcelRequire("52bn2");
var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");

var $2xQve = parcelRequire("2xQve");

var $ciRrJ = parcelRequire("ciRrJ");

var $2Mst8 = parcelRequire("2Mst8");

var $bDmHD = parcelRequire("bDmHD");

var $jssTS = parcelRequire("jssTS");

var $dNtjz = parcelRequire("dNtjz");

var $lJ8aj = parcelRequire("lJ8aj");

var $iNs7v = parcelRequire("iNs7v");

var $407sw = parcelRequire("407sw");

var $c2icR = parcelRequire("c2icR");

var $iRTrY = parcelRequire("iRTrY");

var $jmIrn = parcelRequire("jmIrn");

var $jVdQx = parcelRequire("jVdQx");

var $9qvnH = parcelRequire("9qvnH");

var $fk1mD = parcelRequire("fk1mD");

var $6P09x = parcelRequire("6P09x");

var $7GAiB = parcelRequire("7GAiB");

var $5JA6O = parcelRequire("5JA6O");

var $2YFrP = parcelRequire("2YFrP");

var $2MpEq = parcelRequire("2MpEq");

var $5qKOB = parcelRequire("5qKOB");

var $hrj86 = parcelRequire("hrj86");

var $94n92 = parcelRequire("94n92");

var $wuSZs = parcelRequire("wuSZs");

var $eatxv = parcelRequire("eatxv");

var $j5293 = parcelRequire("j5293");

var $3fdwV = parcelRequire("3fdwV");

var $gXHpd = parcelRequire("gXHpd");
// «ویرایش نوبت» (PM-0102): the row is MOVED, never booked beside. Two documents for
// the reason booking has two — only a move that asked for a notice selects channels.
const $56dc65ee208cb438$var$RESCHEDULE_APPOINTMENT = `
  mutation RescheduleAppointment($appointmentId: ID!, $newDateTime: String!) {
    rescheduleAppointment(appointmentId: $appointmentId, newDateTime: $newDateTime) { id status dateTime }
  }
`;
const $56dc65ee208cb438$var$RESCHEDULE_APPOINTMENT_NOTIFYING = `
  mutation RescheduleAppointmentNotifying($appointmentId: ID!, $newDateTime: String!, $notifyChannels: [String!]) {
    rescheduleAppointment(appointmentId: $appointmentId, newDateTime: $newDateTime, notifyChannels: $notifyChannels) {
      id status dateTime
      notifications { channel status reason detail cost }
    }
  }
`;
const $56dc65ee208cb438$var$SET_APPOINTMENT_NOTE = `
  mutation SetAppointmentNote($appointmentId: ID!, $note: String!) {
    setAppointmentNote(appointmentId: $appointmentId, note: $note) { id reminderNote }
  }
`;
const $56dc65ee208cb438$var$HORIZON_DAYS = 14;
const $56dc65ee208cb438$var$LABEL = {
    fontSize: '0.71875rem',
    fontWeight: 700,
    color: (0, $jTCZr.C).textSecondary,
    minWidth: 86,
    paddingTop: 10
};
const $56dc65ee208cb438$var$ROW = {
    display: 'grid',
    gridTemplateColumns: '86px minmax(0, 1fr)',
    gap: 12,
    alignItems: 'start'
};
function $56dc65ee208cb438$export$2e2bcd8739ae039({ preset: preset = null, reschedule: reschedule = null, onClose: onClose, onBooked: onBooked, onNewPatient: onNewPatient = null, onNeedsShift: onNeedsShift = null }) {
    const { t: t, formatDate: formatDate, formatTime: formatTime, formatDigits: formatDigits, formatMoney: formatMoney, formatNumber: formatNumber } = (0, $e1LEq.default)();
    const order = preset?.order || null;
    const editing = reschedule?.appointment || null;
    // ── What can be booked ────────────────────────────────────────────────────
    const services = (0, $jssTS.useBookableServices)({
        patientFacing: false
    });
    const { doctors: doctors, loading: doctorsLoading, acceptDoctor: acceptDoctor } = (0, $bDmHD.useClinicDoctors)();
    const bookableDoctors = (0, $acw62.useMemo)(()=>(doctors || []).filter((d)=>d.status === 'accepted' && d.active !== false), [
        doctors
    ]);
    const pendingDoctors = (0, $acw62.useMemo)(()=>(doctors || []).filter((d)=>d.status && d.status !== 'accepted'), [
        doctors
    ]);
    const groups = (0, $acw62.useMemo)(()=>(0, $gXHpd.groupBookableServices)(services.services), [
        services.services
    ]);
    const allEntries = (0, $acw62.useMemo)(()=>[
            ...groups.visits,
            ...groups.services
        ], [
        groups
    ]);
    // ── The service ───────────────────────────────────────────────────────────
    const [serviceId, setServiceId] = (0, $acw62.useState)(preset?.serviceCatalogId || null);
    const orderEntry = (0, $acw62.useMemo)(()=>(0, $gXHpd.entryFromOrder)(order), [
        order
    ]);
    const entry = (0, $acw62.useMemo)(()=>{
        if (orderEntry) return orderEntry;
        if (editing) return allEntries.find((e)=>e.catalogId === String(editing.serviceCatalogId || '')) || {
            catalogId: editing.serviceCatalogId ? String(editing.serviceCatalogId) : null,
            name: editing.serviceLabel || t('common.entity.visit'),
            orderType: 'consultation',
            schedulingMode: 'TIMED',
            rows: [],
            performers: []
        };
        return serviceId && allEntries.find((e)=>e.catalogId === serviceId) || (0, $gXHpd.defaultEntry)(groups, preset?.serviceCatalogId);
    }, [
        orderEntry,
        editing,
        allEntries,
        serviceId,
        groups,
        preset?.serviceCatalogId,
        t
    ]);
    const queue = !editing && entry?.schedulingMode === 'QUEUE';
    const serviceLocked = !!order || !!editing;
    // ── The performer ─────────────────────────────────────────────────────────
    const people = (0, $acw62.useMemo)(()=>{
        if (editing) return [
            {
                key: `DOCTOR:${editing.doctorId}`,
                type: 'DOCTOR',
                id: editing.doctorId,
                name: editing.doctorName || (doctors || []).find((d)=>d.doctorId === editing.doctorId)?.doctorName || '',
                isDefault: true
            }
        ];
        return entry?.performers || [];
    }, [
        editing,
        entry,
        doctors
    ]);
    const [performerKey, setPerformerKey] = (0, $acw62.useState)(null);
    // A preset performer: «نوبت بعدی» names the dentist; a doctor section's «+ نوبت» names its doctor.
    const presetDoctorId = preset?.patient?.presetDoctorId || preset?.presetDoctorId || null;
    const performer = (0, $acw62.useMemo)(()=>people.find((p)=>p.key === performerKey) || (0, $gXHpd.defaultPerformer)(people, presetDoctorId), [
        people,
        performerKey,
        presetDoctorId
    ]);
    const doctorRow = performer?.type === 'DOCTOR' ? (doctors || []).find((d)=>d.doctorId === performer.id) || null : null;
    const duration = (0, $acw62.useMemo)(()=>{
        const presetMin = Number(preset?.patient?.presetDurationMinutes) || 0;
        if (presetMin > 0) return {
            minutes: presetMin,
            source: 'SERVICE'
        };
        return (0, $gXHpd.resolveDuration)(entry, performer, doctorRow);
    }, [
        entry,
        performer,
        doctorRow,
        preset?.patient?.presetDurationMinutes
    ]);
    const minutes = queue ? null : duration.minutes;
    const declarationId = order ? order.declarationId : (0, $gXHpd.performerRow)(entry, performer)?.declarationId || null;
    // ── The time ──────────────────────────────────────────────────────────────
    const today = (0, $5qKOB.clinicTodayIso)();
    const startIso = (0, $acw62.useMemo)(()=>{
        const floor = Number(preset?.patient?.notBefore) || 0;
        return floor > Date.now() ? (0, $5qKOB.isoDayOf)(floor) : today;
    }, [
        preset?.patient?.notBefore,
        today
    ]);
    const [timeMode, setTimeMode] = (0, $acw62.useState)(editing ? 'pick' : 'first');
    const [dayIso, setDayIso] = (0, $acw62.useState)(editing ? (0, $5qKOB.isoDayOf)(Number(editing.dateTime)) : startIso);
    const [pickedMs, setPickedMs] = (0, $acw62.useState)(editing ? String(editing.dateTime) : null);
    const [allowOutside, setAllowOutside] = (0, $acw62.useState)(false);
    const [outsideAsk, setOutsideAsk] = (0, $acw62.useState)(null);
    const [horizonFrom, setHorizonFrom] = (0, $acw62.useState)(startIso);
    const [engineKey, setEngineKey] = (0, $acw62.useState)(0);
    const timed = !queue && !!entry;
    const horizon = (0, $dNtjz.useBookableSlots)({
        enabled: timed,
        serviceCatalogId: entry?.catalogId || null,
        performer: performer,
        fromDate: horizonFrom,
        days: $56dc65ee208cb438$var$HORIZON_DAYS,
        durationMinutes: minutes,
        refreshKey: engineKey
    });
    const dayRead = (0, $dNtjz.useBookableSlots)({
        enabled: timed && timeMode === 'pick',
        serviceCatalogId: entry?.catalogId || null,
        performer: performer,
        fromDate: dayIso,
        days: 1,
        durationMinutes: minutes,
        refreshKey: engineKey
    });
    const first = (0, $acw62.useMemo)(()=>(0, $gXHpd.firstFree)(horizon.days, Date.now()), [
        horizon.days
    ]);
    const effectiveMs = queue ? null : timeMode === 'first' ? first ? String(first.startMs) : null : pickedMs;
    // Each performer's first free time TODAY (UX #11) — one small engine read per chip.
    // (§3.4 names a `servicePerformersWithNextFree` resolver; the BFF shipped the
    // engine alone, so the dialog derives it here, per performer.)
    // A QUEUE service holds no hour, but «does this person have a shift today» is
    // still worth a chip (the day-level warning, §2.3): the probe then asks the
    // engine at a nominal length, and only «no shift» is shown from the answer.
    const perfFirst = $56dc65ee208cb438$export$4fff79acc0e6d75f(people, {
        enabled: !!entry && !editing,
        catalogId: entry?.catalogId || null,
        today: today,
        minutesFor: (p)=>Number(preset?.patient?.presetDurationMinutes) || (0, $gXHpd.resolveDuration)(entry, p, p.type === 'DOCTOR' ? (doctors || []).find((d)=>d.doctorId === p.id) : null).minutes || (queue ? 15 : null)
    });
    // ── The patient ───────────────────────────────────────────────────────────
    const presetPatient = order ? {
        id: order.patientId,
        name: order.patientName || '',
        phone: order.patientPhone || ''
    } : editing ? reschedule.patient || null : preset?.patient?.id ? preset.patient : null;
    const [patient, setPatient] = (0, $acw62.useState)(presetPatient);
    const patientLocked = !!order || !!editing;
    const [query, setQuery] = (0, $acw62.useState)('');
    const search = (0, $lJ8aj.usePatientSearch)(patientLocked || patient ? '' : query);
    const [quick, setQuick] = (0, $acw62.useState)(false);
    const [marker, setMarker] = (0, $acw62.useState)('');
    // «بیمار جدید» (PM-0468 R4 follow-up): a walk-in nobody has registered is
    // registered HERE — mobile + full name, the records already on that mobile shown
    // first — and booked in the same submit. «ثبت سریع» is for a slot held on a phone
    // call; this is for the person standing at the desk. The rest of the file
    // (کد ملی, بیمه, شماره پرونده) is completed later from «تکمیل پرونده».
    const [newMode, setNewMode] = (0, $acw62.useState)(false);
    const [newName, setNewName] = (0, $acw62.useState)('');
    const [newPhone, setNewPhone] = (0, $acw62.useState)('');
    const [sharedPhoneOk, setSharedPhoneOk] = (0, $acw62.useState)(false);
    const region = (0, $9qvnH.useClinicRegion)();
    const countryDefaults = (0, $fk1mD.useCountryDefaults)();
    const phoneCountry = countryDefaults.phoneCountry || region.country || null;
    const phoneLookup = (0, $jVdQx.usePhoneCandidates)(newMode ? newPhone : '');
    const phoneHasRecords = newMode && phoneLookup.candidates.length > 0 && !sharedPhoneOk;
    const [requestId, setRequestId] = (0, $acw62.useState)(()=>(0, $gXHpd.newRequestId)());
    const patientRef = (0, $acw62.useRef)(null);
    const serviceRef = (0, $acw62.useRef)(null);
    // ── «گزینه‌های بیشتر» ───────────────────────────────────────────────────────
    // An edit changes two things — the hour and the note — so the note is never
    // folded away there (PM-0102: «a corrected note is saved alone»).
    const [moreOpen, setMoreOpen] = (0, $acw62.useState)(!!editing);
    const [type, setType] = (0, $acw62.useState)('in_person');
    const [companions, setCompanions] = (0, $acw62.useState)([]);
    const [note, setNote] = (0, $acw62.useState)(editing?.note || preset?.patient?.presetNote || '');
    const notifyOn = !order && !!(patient?.id || !quick);
    const { settings: notifyDefaults } = (0, $iNs7v.useAppointmentNotificationSettings)({
        enabled: notifyOn
    });
    const [notifyPick, setNotifyPick] = (0, $acw62.useState)(null);
    const notifyChannels = notifyPick ?? (0, $2MpEq.orderChannels)(notifyDefaults?.channels);
    const [insuranceChoice, setInsuranceChoice] = (0, $acw62.useState)(null);
    // ── «پیش‌پرداخت» (PM-0657 §6.2) ───────────────────────────────────────────
    // Only on a fresh booking for a person: never an edit (the نوبت exists; the
    // row's own op takes a deposit), never an order's session, never «ثبت سریع»
    // (no patient to hold it for). Prefilled from the booked service's tariff.
    const { policy: prepaymentPolicy } = (0, $wuSZs.usePrepaymentPolicy)();
    const deposit = (0, $j5293.useBookingDeposit)({
        policy: prepaymentPolicy,
        priceRial: (0, $gXHpd.performerRow)(entry, performer)?.unitPrice ?? null,
        applies: !editing && !order && !quick
    });
    // The booking stood and the deposit did not: `{ id, said }` of the نوبت, the
    // refusal, and whether a retry is in flight.
    const [booked, setBooked] = (0, $acw62.useState)(null);
    const [depositFailure, setDepositFailure] = (0, $acw62.useState)('');
    const [depositRetrying, setDepositRetrying] = (0, $acw62.useState)(false);
    const [requiredAsk, setRequiredAsk] = (0, $acw62.useState)(false);
    const skipRequired = (0, $acw62.useRef)(false);
    // ── Feedback ──────────────────────────────────────────────────────────────
    const [errors, setErrors] = (0, $acw62.useState)({});
    const [nextFreeChips, setNextFreeChips] = (0, $acw62.useState)([]);
    const [submitting, setSubmitting] = (0, $acw62.useState)(false);
    const [dirty, setDirty] = (0, $acw62.useState)(false);
    const [confirmClose, setConfirmClose] = (0, $acw62.useState)(false);
    const touch = ()=>setDirty(true);
    const clearError = (field)=>setErrors((e)=>e[field] ? {
                ...e,
                [field]: null
            } : e);
    // The performer changes → the picked hour and its override no longer apply.
    (0, $acw62.useEffect)(()=>{
        if (!editing) {
            setPickedMs(null);
            setAllowOutside(false);
            setNextFreeChips([]);
        }
    }, [
        performer?.key,
        entry?.catalogId,
        editing
    ]);
    // ── Keyboard: registry only, never a window listener ──────────────────────
    const group = t('reception.actions.book');
    const requestClose = (0, $acw62.useCallback)(()=>{
        // After a booking whose deposit failed there is nothing unsaved to lose: the
        // نوبت exists. Leaving is «بستن بدون پیش‌پرداخت».
        if (booked) {
            onBooked?.(booked.said);
            onClose?.();
            return;
        }
        if (dirty) setConfirmClose(true);
        else onClose?.();
    }, [
        dirty,
        onClose,
        booked,
        onBooked
    ]);
    (0, $ciRrJ.useShortcut)('esc', requestClose, {
        label: t('common.actions.close'),
        group: group,
        enabled: !confirmClose && !outsideAsk && !requiredAsk
    });
    (0, $ciRrJ.useShortcut)('f3', ()=>patientRef.current?.focus(), {
        label: t('reception.booking.shortcutPatientSearch'),
        group: group,
        enabled: !patientLocked
    });
    (0, $ciRrJ.useShortcut)('ctrl+s', ()=>submit(), {
        label: t('reception.booking.shortcutSubmit'),
        group: group,
        enabled: !submitting
    });
    // ── Submit ────────────────────────────────────────────────────────────────
    const validate = ()=>{
        const next = {};
        if (!entry) next.service = t('reception.booking.serviceRequired');
        if (!performer) next.performer = t('reception.booking.performerRequired');
        if (timed && !effectiveMs) next.time = t('reception.booking.timeRequired');
        if (!patientLocked && !patient) {
            if (newMode) {
                if (newName.trim().length < 2) next.patient = t('reception.booking.newPatientNameRequired');
                else if (!(0, $5AX1S).isValidPhone(String(newPhone || '').trim())) next.patient = t('reception.booking.newPatientPhoneRequired');
                else if (phoneHasRecords) next.patient = t('reception.booking.newPatientPickRecord');
            } else if (!(quick && marker.trim())) next.patient = t('reception.booking.patientRequired');
        }
        setErrors(next);
        const firstBad = [
            'service',
            'performer',
            'time',
            'patient'
        ].find((k)=>next[k]);
        if (firstBad === 'patient') patientRef.current?.focus();
        if (firstBad === 'service') serviceRef.current?.focus();
        return !firstBad;
    };
    const performerName = performer?.name || '';
    const whenLabel = (ms)=>(0, $7GAiB.fmtSlotLabel)(ms, t, formatDate, formatTime);
    // The deposit alone, for a نوبت already booked — the first try and every retry
    // carry the SAME request id, so the money is taken once (PM-0657 §6.2).
    const runDeposit = async (appointmentId, said)=>{
        try {
            await (0, $eatxv.recordAppointmentDeposit)({
                appointmentId: appointmentId,
                amountRial: deposit.wire.amountRial,
                paymentMethod: deposit.wire.paymentMethod,
                referenceNumber: deposit.wire.referenceNumber,
                requestId: deposit.wire.requestId
            });
            setBooked(null);
            setDepositFailure('');
            onBooked?.(`${said} \xb7 ${t('reception.deposit.done.taken')}`);
            onClose?.();
            return true;
        } catch (e) {
            setBooked({
                id: appointmentId,
                said: said
            });
            setDepositFailure((0, $3fdwV.moneyErrorText)(e, t) || t('errors.generic'));
            if (e?.extensions?.code === 'NO_OPEN_SHIFT' && onNeedsShift) onNeedsShift(()=>retryDeposit({
                    id: appointmentId,
                    said: said
                }));
            return false;
        }
    };
    const retryDeposit = async (target = booked)=>{
        if (!target || depositRetrying) return;
        setDepositRetrying(true);
        try {
            await runDeposit(target.id, target.said);
        } finally{
            setDepositRetrying(false);
        }
    };
    const submit = async ()=>{
        if (submitting) return;
        if (booked) {
            retryDeposit();
            return;
        }
        if (!validate()) return;
        const depositError = (0, $j5293.depositFieldError)(t, deposit);
        if (depositError) {
            setErrors({
                deposit: depositError
            });
            return;
        }
        // «الزامی» is a question, not a refusal (C9): asked once, then allowed.
        if (!editing && !order && deposit.needsConfirm && !skipRequired.current) {
            setRequiredAsk(true);
            return;
        }
        skipRequired.current = false;
        setSubmitting(true);
        setErrors({});
        setNextFreeChips([]);
        try {
            let said = '';
            if (editing) said = await commitReschedule();
            else if (order) said = await commitOrder();
            else said = await commitBooking();
            // Success: a NEW id for the next booking; the same one would have ridden a retry.
            setRequestId((0, $gXHpd.newRequestId)());
            // Booked, with a deposit to take: the deposit is its own write. It
            // closes the dialog itself on success and keeps it open on a refusal.
            if (said && typeof said === 'object' && said.depositFor) {
                await runDeposit(said.depositFor, said.said);
                return;
            }
            onBooked?.(said);
            onClose?.();
        } catch (e) {
            const mapped = (0, $gXHpd.mapBookingError)(e, t);
            setErrors({
                [mapped.field]: mapped.message
            });
            if (mapped.nextFree) setNextFreeChips((0, $gXHpd.nextFree)(horizon.days, Number(effectiveMs) || Date.now(), 3));
            // A refused hour stays on screen as the hour it was, marked — the desk
            // sees WHICH cell was refused and re-reads the engine around it.
            if (mapped.field === 'time' && !queue) {
                if (effectiveMs) {
                    setPickedMs(String(effectiveMs));
                    setDayIso((0, $5qKOB.isoDayOf)(Number(effectiveMs)));
                }
                setTimeMode('pick');
                setEngineKey((k)=>k + 1);
            }
        } finally{
            setSubmitting(false);
        }
    };
    async function commitBooking() {
        let who = patient;
        if (!who?.id && newMode) {
            const created = await (0, $2Mst8.bffMutation)((0, $c2icR.ADD_PATIENT), {
                input: {
                    name: newName.trim(),
                    phone: newPhone,
                    ...(0, $6P09x.phoneFlags)({
                        noPhone: false,
                        allowSharedPhone: sharedPhoneOk
                    })
                }
            });
            const id = created?.addPatient?.id;
            if (!id) throw new Error(t('errors.reception.bookFailed'));
            // From here the dialog books for THIS record: a booking refused below and
            // retried never registers the same person twice (B07).
            who = {
                id: id,
                name: created.addPatient.name || newName.trim(),
                phone: created.addPatient.phone || newPhone
            };
            setPatient(who);
            setNewMode(false);
        }
        const notify = who?.id && notifyChannels?.length ? notifyChannels : null;
        const input = {
            ...who?.id ? {
                patientId: who.id
            } : {
                placeholderLabel: marker.trim()
            },
            performer: {
                type: performer.type,
                id: performer.id
            },
            ...performer.type === 'DOCTOR' ? {
                doctorId: performer.id
            } : {},
            serviceCatalogId: entry.catalogId,
            serviceDeclarationId: declarationId || undefined,
            ...queue ? {
                untimed: 'DAY',
                dateTime: String((0, $5qKOB.wallToMs)(today, 720))
            } : {
                dateTime: String(effectiveMs),
                ...allowOutside && pickedMs === effectiveMs ? {
                    allowOutsideServiceWindow: true
                } : {}
            },
            type: type || 'in_person',
            reminderNote: note.trim() || undefined,
            services: companions.length ? companions : undefined,
            insuranceChoice: insuranceChoice || undefined,
            notifyChannels: notify || undefined,
            followUpId: preset?.patient?.followUpId || undefined
        };
        const res = await (0, $2Mst8.bffMutation)(notify ? (0, $c2icR.CREATE_APPOINTMENT_NOTIFYING) : (0, $c2icR.CREATE_APPOINTMENT), {
            input: input
        });
        const booked = res?.createAppointment;
        if (!booked?.id) throw new Error(t('errors.reception.bookFailed'));
        const when = booked.dateTime && !queue ? formatTime(Number(booked.dateTime)) : t('common.dates.today');
        const msg = t('reception.booking.bookedToast', {
            when: when,
            performer: performerName
        });
        const notified = (0, $2MpEq.notificationSummary)(booked.notifications, t);
        const said = notified ? `${msg} \xb7 ${notified}` : msg;
        return deposit.wire ? {
            depositFor: booked.id,
            said: said
        } : said;
    }
    async function commitOrder() {
        const who = order.patientName || t('common.entity.patient');
        if (queue) {
            const q = await (0, $407sw.enqueueServiceTicket)({
                orderId: order.id,
                patientId: order.patientId,
                declarationId: order.declarationId,
                performer: {
                    type: performer.type,
                    id: performer.id
                }
            });
            const mine = (q?.entries || []).find((e)=>e.patientId === order.patientId);
            return t('reception.paraclinic.queueTicket', {
                ticket: formatDigits(mine?.ticketNo ?? "\u2014"),
                performer: performerName
            });
        }
        const booked = await (0, $407sw.bookServiceSession)({
            orderId: order.id,
            patientId: order.patientId,
            declarationId: order.declarationId,
            performer: {
                type: performer.type,
                id: performer.id
            },
            dateTimeMs: Number(effectiveMs),
            reminderNote: note.trim() || undefined,
            sessionId: order.sessionId || undefined
        });
        return t('reception.paraclinic.bookedAt', {
            who: who,
            performer: performerName,
            when: whenLabel(booked?.dateTime || effectiveMs)
        });
    }
    async function commitReschedule() {
        const who = reschedule.patient?.name || t('common.entity.patient');
        const moving = effectiveMs && String(effectiveMs) !== String(editing.dateTime);
        const trimmed = note.trim();
        const noteChanged = trimmed !== String(editing.note || '').trim();
        const said = [];
        if (moving) {
            const notify = reschedule.patient?.id && notifyChannels?.length ? notifyChannels : null;
            const res = await (0, $2Mst8.bffMutation)(notify ? $56dc65ee208cb438$var$RESCHEDULE_APPOINTMENT_NOTIFYING : $56dc65ee208cb438$var$RESCHEDULE_APPOINTMENT, {
                appointmentId: editing.id,
                newDateTime: String(effectiveMs),
                ...notify ? {
                    notifyChannels: notify
                } : {}
            });
            const moved = res?.rescheduleAppointment;
            if (!moved?.id) throw new Error(t('reception.edit.failed'));
            said.push(t('reception.edit.movedTo', {
                who: who,
                when: whenLabel(moved.dateTime || effectiveMs)
            }));
            const notified = (0, $2MpEq.notificationSummary)(moved.notifications, t);
            if (notified) said.push(notified);
        }
        if (noteChanged) try {
            await (0, $2Mst8.bffMutation)($56dc65ee208cb438$var$SET_APPOINTMENT_NOTE, {
                appointmentId: editing.id,
                note: trimmed
            });
            if (!moving) said.push(t('reception.edit.noteSaved', {
                who: who
            }));
        } catch (e) {
            if (!moving) throw e;
            said.push(t('reception.edit.noteFailed'));
        }
        return said.length ? said.join(" \xb7 ") : null;
    }
    // ── Nothing to book for → connect a practitioner, not an empty form ───────
    if (!order && !editing && services.loaded && allEntries.length === 0 && !doctorsLoading && bookableDoctors.length === 0) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $94n92.default), {
        pending: pendingDoctors,
        onAccept: acceptDoctor,
        onClose: onClose
    });
    const pickSlot = (cell)=>{
        touch();
        clearError('time');
        setNextFreeChips([]);
        if (cell.held) {
            setOutsideAsk(cell);
            return;
        }
        setAllowOutside(false);
        setPickedMs(cell.value);
        setTimeMode('pick');
    };
    const companionCandidates = groups.services.filter((e)=>e.catalogId !== entry?.catalogId && e.rows[0]?.unitPrice > 0);
    const quoteLine = order || editing ? null : !patient?.id ? quick ? t('reception.booking.quoteQuick') : t('reception.booking.quoteNoPatient') : null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fYdd.Dialog), {
        open: true,
        onOpenChange: (o)=>{
            if (!o) requestClose();
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4fYdd.DialogContent), {
            size: "lg",
            layout: "frame",
            "data-testid": "reception-booking-dialog",
            "data-request-id": requestId,
            "data-booked-id": booked?.id || undefined,
            onOpenAutoFocus: (e)=>{
                e.preventDefault();
                (serviceLocked || patientLocked ? null : serviceRef.current)?.focus?.();
            },
            onEscapeKeyDown: (e)=>{
                e.preventDefault();
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fYdd.DialogHeader), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fYdd.DialogTitle), {
                        children: editing ? t('reception.edit.title') : order?.bookingTitle || t('reception.actions.book')
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fYdd.DialogBody), {
                    children: booked ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $j5293.DepositAfterBookingFailed), {
                        reason: depositFailure,
                        retrying: depositRetrying,
                        onRetry: ()=>retryDeposit(),
                        onCloseWithout: requestClose
                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: (0, $2xQve.STACK).regular
                        },
                        children: [
                            errors.form ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                                variant: "error",
                                "data-testid": "reception-booking-form-error",
                                children: errors.form
                            }) : null,
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: $56dc65ee208cb438$var$ROW,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: $56dc65ee208cb438$var$LABEL,
                                        children: t('reception.booking.service')
                                    }),
                                    serviceLocked ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        "data-testid": "reception-booking-locked-service",
                                        style: {
                                            paddingTop: 9,
                                            fontSize: '0.8125rem',
                                            fontWeight: 700,
                                            color: (0, $jTCZr.C).textPrimary
                                        },
                                        children: t('reception.booking.lockedService', {
                                            service: entry?.name || ''
                                        })
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)($56dc65ee208cb438$var$ServiceCombobox, {
                                        ref: serviceRef,
                                        groups: groups,
                                        value: entry?.catalogId || null,
                                        loading: services.loading && !services.loaded,
                                        error: services.error,
                                        onRetry: services.reload,
                                        onChange: (id)=>{
                                            setServiceId(id);
                                            setPerformerKey(null);
                                            touch();
                                            clearError('service');
                                        },
                                        onCommit: ()=>patientRef.current?.focus(),
                                        fieldError: errors.service
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: $56dc65ee208cb438$var$ROW,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: $56dc65ee208cb438$var$LABEL,
                                        children: t('reception.booking.performer')
                                    }),
                                    editing ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        "data-testid": "reception-booking-locked-performer",
                                        style: {
                                            paddingTop: 9,
                                            fontSize: '0.8125rem',
                                            fontWeight: 700,
                                            color: (0, $jTCZr.C).textPrimary
                                        },
                                        children: t('reception.booking.lockedPerformer', {
                                            performer: people[0]?.name || ''
                                        })
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)($56dc65ee208cb438$var$PerformerChips, {
                                        people: people,
                                        selected: performer,
                                        firstFree: perfFirst,
                                        queue: queue,
                                        error: errors.performer,
                                        onPick: (p)=>{
                                            setPerformerKey(p.key);
                                            touch();
                                            clearError('performer');
                                        },
                                        t: t,
                                        formatTime: formatTime
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: $56dc65ee208cb438$var$ROW,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: $56dc65ee208cb438$var$LABEL,
                                        children: t('reception.booking.time')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        "data-testid": "reception-booking-time",
                                        "data-mode": queue ? 'ticket' : timeMode,
                                        "data-ms": effectiveMs || undefined,
                                        style: {
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: 8
                                        },
                                        children: queue ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                                            variant: "info",
                                            children: t('reception.booking.queueMode')
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                editing ? // Where the نوبت is NOW, stated before any hour is touched — the
                                                // grid below is where it can move to (PM-0102).
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    "data-testid": "reception-booking-current",
                                                    style: {
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        gap: 2
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            style: {
                                                                fontSize: '0.8125rem',
                                                                fontWeight: 700,
                                                                color: (0, $jTCZr.C).textPrimary
                                                            },
                                                            children: t('reception.edit.currentTime', {
                                                                when: whenLabel(Number(editing.dateTime))
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            style: {
                                                                fontSize: '0.71875rem',
                                                                color: (0, $jTCZr.C).textMuted
                                                            },
                                                            children: t('reception.edit.hint')
                                                        })
                                                    ]
                                                }) : null,
                                                !editing && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fYgeo.default), {
                                                    size: "sm",
                                                    semantics: "filter",
                                                    ariaLabel: t('reception.booking.time'),
                                                    value: timeMode,
                                                    onChange: (v)=>{
                                                        setTimeMode(v);
                                                        touch();
                                                        clearError('time');
                                                    },
                                                    options: [
                                                        {
                                                            value: 'first',
                                                            label: t('reception.booking.modeFirstFree')
                                                        },
                                                        {
                                                            value: 'pick',
                                                            label: t('reception.booking.modePick')
                                                        }
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    "data-testid": "reception-booking-length",
                                                    style: {
                                                        fontSize: '0.71875rem',
                                                        color: (0, $jTCZr.C).textMuted
                                                    },
                                                    children: minutes ? duration.source === 'DOCTOR' ? t('reception.booking.lengthFromDoctor', {
                                                        minutes: formatDigits(minutes)
                                                    }) : t('reception.booking.lengthFromService', {
                                                        minutes: formatDigits(minutes)
                                                    }) : null
                                                }),
                                                timeMode === 'first' ? /*#__PURE__*/ (0, $ayMG0.jsx)($56dc65ee208cb438$var$FirstFreeLine, {
                                                    read: horizon,
                                                    first: first,
                                                    onLater: ()=>setHorizonFrom((d)=>(0, $5qKOB.addDaysIso)(d, $56dc65ee208cb438$var$HORIZON_DAYS)),
                                                    whenLabel: whenLabel,
                                                    t: t,
                                                    formatDigits: formatDigits
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)($56dc65ee208cb438$var$DayPicker, {
                                                    dayIso: dayIso,
                                                    today: today,
                                                    onDay: (iso)=>{
                                                        setDayIso(iso);
                                                        touch();
                                                    },
                                                    read: dayRead,
                                                    cells: (0, $gXHpd.gridSlots)((0, $gXHpd.slotsOn)(dayRead.days, dayIso), {
                                                        formatTime: formatTime,
                                                        t: t,
                                                        nowMs: Date.now()
                                                    }),
                                                    pickedMs: pickedMs,
                                                    onPick: pickSlot,
                                                    t: t,
                                                    formatDate: formatDate
                                                }),
                                                errors.time ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    role: "alert",
                                                    "data-testid": "reception-booking-time-error",
                                                    style: {
                                                        fontSize: '0.75rem',
                                                        color: (0, $jTCZr.C).red
                                                    },
                                                    children: errors.time
                                                }) : null,
                                                nextFreeChips.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    "data-testid": "reception-booking-next-free",
                                                    style: {
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: 6,
                                                        flexWrap: 'wrap'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            style: {
                                                                fontSize: '0.71875rem',
                                                                color: (0, $jTCZr.C).textMuted
                                                            },
                                                            children: t('reception.booking.nextFree')
                                                        }),
                                                        nextFreeChips.map((s)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $h4ZeB.default), {
                                                                label: whenLabel(s.startMs),
                                                                "data-ms": String(s.startMs),
                                                                onClick: ()=>{
                                                                    setDayIso(s.date);
                                                                    pickSlot({
                                                                        value: String(s.startMs),
                                                                        held: false
                                                                    });
                                                                }
                                                            }, s.startMs))
                                                    ]
                                                }) : null
                                            ]
                                        })
                                    })
                                ]
                            }),
                            deposit.shown ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: $56dc65ee208cb438$var$ROW,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: $56dc65ee208cb438$var$LABEL
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $j5293.BookingDepositBlock), {
                                        deposit: deposit,
                                        error: errors.deposit,
                                        onTouch: ()=>{
                                            touch();
                                            clearError('deposit');
                                        }
                                    })
                                ]
                            }) : null,
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: $56dc65ee208cb438$var$ROW,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: $56dc65ee208cb438$var$LABEL,
                                        children: t('reception.booking.patient')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($56dc65ee208cb438$var$PatientField, {
                                        patient: patient,
                                        locked: patientLocked,
                                        query: query,
                                        onQuery: (v)=>{
                                            setQuery(v);
                                            touch();
                                            clearError('patient');
                                        },
                                        search: search,
                                        onPick: (p)=>{
                                            setPatient(p);
                                            setQuery('');
                                            setQuick(false);
                                            setNewMode(false);
                                            touch();
                                            clearError('patient');
                                        },
                                        onClear: ()=>{
                                            setPatient(null);
                                            touch();
                                            setTimeout(()=>patientRef.current?.focus(), 0);
                                        },
                                        quick: quick,
                                        onQuick: ()=>{
                                            setQuick((q)=>!q);
                                            setNewMode(false);
                                            touch();
                                            clearError('patient');
                                        },
                                        newMode: newMode,
                                        onNewMode: (fromQuery)=>{
                                            setNewMode((on)=>!on || fromQuery != null);
                                            setQuick(false);
                                            // What was typed into the search seeds the form: digits are the
                                            // mobile, anything else the name.
                                            if (fromQuery != null) {
                                                const q = String(fromQuery).trim();
                                                if (/^[+0-9۰-۹٠-٩\s-]+$/.test(q)) setNewPhone(q);
                                                else setNewName(q);
                                            }
                                            setQuery('');
                                            touch();
                                            clearError('patient');
                                        },
                                        newFields: newMode ? /*#__PURE__*/ (0, $ayMG0.jsx)($56dc65ee208cb438$var$NewPatientFields, {
                                            name: newName,
                                            onName: (v)=>{
                                                setNewName(v);
                                                touch();
                                                clearError('patient');
                                            },
                                            phone: newPhone,
                                            onPhone: (v)=>{
                                                setNewPhone(v);
                                                setSharedPhoneOk(false);
                                                touch();
                                                clearError('patient');
                                            },
                                            phoneCountry: phoneCountry,
                                            candidates: phoneLookup.candidates,
                                            sharedPhoneOk: sharedPhoneOk,
                                            onChooseLinked: (c)=>{
                                                setPatient(c.patient || {
                                                    id: c.patientId,
                                                    name: c.displayName,
                                                    phone: phoneLookup.number
                                                });
                                                setNewMode(false);
                                                clearError('patient');
                                            },
                                            onLink: async (c)=>{
                                                const data = await (0, $2Mst8.bffMutation)((0, $6P09x.LINK_EXISTING_PATIENT), {
                                                    patientId: c.patientId
                                                });
                                                const linked = data?.linkExistingPatient;
                                                if (!linked?.id) throw new Error('linkExistingPatient returned no patient');
                                                setPatient(linked);
                                                setNewMode(false);
                                                clearError('patient');
                                            },
                                            onSameNumber: ()=>{
                                                setSharedPhoneOk(true);
                                                clearError('patient');
                                            },
                                            t: t
                                        }) : null,
                                        marker: marker,
                                        onMarker: (v)=>{
                                            setMarker(v);
                                            touch();
                                            clearError('patient');
                                        },
                                        inputRef: patientRef,
                                        error: errors.patient,
                                        onNewPatient: onNewPatient,
                                        t: t,
                                        formatDigits: formatDigits
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                        type: "button",
                                        onClick: ()=>setMoreOpen((o)=>!o),
                                        "aria-expanded": moreOpen,
                                        "data-testid": "reception-booking-more",
                                        style: {
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            gap: 6,
                                            border: 'none',
                                            background: 'none',
                                            padding: 0,
                                            fontFamily: 'inherit',
                                            fontSize: '0.78125rem',
                                            fontWeight: 700,
                                            color: 'var(--p-navy)',
                                            cursor: 'pointer'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2WFPf.default), {
                                                size: 14,
                                                style: {
                                                    transform: moreOpen ? 'rotate(180deg)' : 'none',
                                                    transition: 'transform .2s'
                                                },
                                                "aria-hidden": true
                                            }),
                                            t('reception.booking.moreOptions')
                                        ]
                                    }),
                                    moreOpen && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        style: {
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: (0, $2xQve.STACK).regular,
                                            marginTop: 10
                                        },
                                        children: [
                                            !editing && !order && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                style: $56dc65ee208cb438$var$ROW,
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        style: $56dc65ee208cb438$var$LABEL,
                                                        children: t('reception.booking.visitType')
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fYgeo.default), {
                                                        size: "sm",
                                                        semantics: "filter",
                                                        ariaLabel: t('reception.booking.visitType'),
                                                        value: type,
                                                        onChange: (v)=>{
                                                            setType(v);
                                                            touch();
                                                        },
                                                        options: [
                                                            {
                                                                value: 'in_person',
                                                                label: t('reception.booking.inPerson')
                                                            },
                                                            {
                                                                value: 'online',
                                                                label: t('reception.booking.online')
                                                            }
                                                        ]
                                                    })
                                                ]
                                            }),
                                            !editing && !order && companionCandidates.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                style: $56dc65ee208cb438$var$ROW,
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        style: $56dc65ee208cb438$var$LABEL,
                                                        children: t('reception.booking.companions')
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        style: {
                                                            display: 'flex',
                                                            flexWrap: 'wrap',
                                                            gap: 6
                                                        },
                                                        "data-testid": "reception-booking-companions",
                                                        children: companionCandidates.map((e)=>{
                                                            const on = companions.some((c)=>c.catalogId === e.catalogId);
                                                            const price = e.rows[0]?.unitPrice;
                                                            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $h4ZeB.default), {
                                                                label: price ? `${e.name} \xb7 ${formatMoney(price, {
                                                                    currency: e.rows[0]?.currency
                                                                })}` : e.name,
                                                                active: on,
                                                                onClick: ()=>{
                                                                    touch();
                                                                    setCompanions((prev)=>on ? prev.filter((c)=>c.catalogId !== e.catalogId) : [
                                                                            ...prev,
                                                                            {
                                                                                catalogId: e.catalogId,
                                                                                quantity: 1
                                                                            }
                                                                        ]);
                                                                }
                                                            }, e.catalogId);
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                style: $56dc65ee208cb438$var$ROW,
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        htmlFor: "reception-booking-note",
                                                        style: $56dc65ee208cb438$var$LABEL,
                                                        children: t('reception.booking.note')
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                                        id: "reception-booking-note",
                                                        "data-testid": "reception-booking-note",
                                                        value: note,
                                                        onChange: (e)=>{
                                                            setNote(e.target.value);
                                                            touch();
                                                        },
                                                        placeholder: t('reception.booking.notePlaceholder'),
                                                        rows: 2,
                                                        style: {
                                                            width: '100%',
                                                            boxSizing: 'border-box',
                                                            resize: 'vertical',
                                                            fontFamily: 'inherit',
                                                            fontSize: '0.8125rem',
                                                            padding: '8px 10px',
                                                            borderRadius: 8,
                                                            border: `1px solid ${(0, $jTCZr.C).border}`
                                                        }
                                                    })
                                                ]
                                            }),
                                            !order && (patient?.id || editing) && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                style: $56dc65ee208cb438$var$ROW,
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        style: $56dc65ee208cb438$var$LABEL
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5JA6O.default), {
                                                        value: notifyChannels,
                                                        onChange: (v)=>{
                                                            setNotifyPick(v);
                                                            touch();
                                                        }
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !order && !editing && patient?.id && !queue ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2YFrP.default), {
                                patientId: patient.id,
                                doctorId: performer?.type === 'DOCTOR' ? performer.id : null,
                                services: companions,
                                serviceDeclarationId: declarationId,
                                choice: insuranceChoice,
                                onChoiceChange: (c)=>{
                                    setInsuranceChoice(c);
                                    touch();
                                }
                            }) : null
                        ]
                    })
                }),
                booked ? null : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fYdd.DialogFooter), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 10,
                            width: '100%'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                "data-testid": "reception-booking-quote",
                                style: {
                                    fontSize: '0.75rem',
                                    color: (0, $jTCZr.C).textMuted,
                                    flex: 1,
                                    minWidth: 0
                                },
                                children: quoteLine
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                variant: "ghost",
                                onClick: requestClose,
                                disabled: submitting,
                                children: t('common.actions.cancel')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                                onClick: submit,
                                disabled: submitting,
                                "data-testid": "reception-booking-submit",
                                children: [
                                    submitting ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hZDga.Spinner), {
                                        size: "sm"
                                    }) : null,
                                    editing ? t('reception.edit.save') : queue ? t('reception.booking.ticketSubmit') : t('reception.actions.book'),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ciRrJ.Kbd), {
                                        combo: "ctrl+s"
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjPik.default), {
                    open: requiredAsk,
                    onOpenChange: (o)=>{
                        if (!o) setRequiredAsk(false);
                    },
                    title: t('reception.booking.deposit.requiredTitle'),
                    description: t('reception.booking.deposit.requiredConfirm'),
                    confirmLabel: t('reception.booking.deposit.requiredConfirmAction'),
                    cancelLabel: t('reception.booking.deposit.back'),
                    "data-testid": "booking-deposit-required-confirm",
                    onConfirm: ()=>{
                        setRequiredAsk(false);
                        skipRequired.current = true;
                        submit();
                    }
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjPik.default), {
                    open: !!outsideAsk,
                    onOpenChange: (o)=>{
                        if (!o) setOutsideAsk(null);
                    },
                    title: t('reception.booking.outsideWindow'),
                    description: t('reception.booking.outsideWindowConfirm', {
                        service: entry?.name || ''
                    }),
                    confirmLabel: t('reception.booking.outsideWindowYes'),
                    cancelLabel: t('common.actions.cancel'),
                    "data-testid": "reception-booking-outside-window",
                    onConfirm: ()=>{
                        setAllowOutside(true);
                        setPickedMs(outsideAsk.value);
                        setTimeMode('pick');
                        setOutsideAsk(null);
                    }
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjPik.default), {
                    open: confirmClose,
                    onOpenChange: (o)=>{
                        if (!o) setConfirmClose(false);
                    },
                    title: t('reception.booking.dirtyTitle'),
                    description: t('common.actions.unsavedChanges'),
                    confirmLabel: t('reception.booking.dirtyLeave'),
                    cancelLabel: t('common.actions.cancel'),
                    destructive: true,
                    onConfirm: ()=>{
                        setConfirmClose(false);
                        onClose?.();
                    }
                })
            ]
        })
    });
}
function $56dc65ee208cb438$export$4fff79acc0e6d75f(people, { enabled: enabled, catalogId: catalogId, today: today, minutesFor: minutesFor }) {
    const [state, setState] = (0, $acw62.useState)({});
    const keys = people.map((p)=>p.key).join(',');
    (0, $acw62.useEffect)(()=>{
        // An empty answer stays the SAME object: a fresh {} would re-render the caller for nothing.
        if (!enabled || !people.length) {
            setState((s)=>Object.keys(s).length ? {} : s);
            return undefined;
        }
        let live = true;
        setState(Object.fromEntries(people.map((p)=>[
                p.key,
                {
                    loading: true
                }
            ])));
        people.forEach(async (p)=>{
            const minutes = minutesFor(p);
            if (!(minutes > 0)) {
                if (live) setState((s)=>({
                        ...s,
                        [p.key]: {
                            loading: false,
                            firstMs: null,
                            noShift: true
                        }
                    }));
                return;
            }
            try {
                const days = await (0, $dNtjz.fetchBookableSlots)({
                    serviceCatalogId: catalogId,
                    performer: p,
                    fromDate: today,
                    days: 1,
                    durationMinutes: minutes
                });
                const hit = (0, $gXHpd.firstFree)(days, Date.now());
                const noShift = !days.length || days.every((d)=>!(d.slots || []).length);
                if (live) setState((s)=>({
                        ...s,
                        [p.key]: {
                            loading: false,
                            firstMs: hit?.startMs || null,
                            noShift: noShift
                        }
                    }));
            } catch  {
                if (live) setState((s)=>({
                        ...s,
                        [p.key]: {
                            loading: false,
                            firstMs: null,
                            failed: true
                        }
                    }));
            }
        });
        return ()=>{
            live = false;
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        enabled,
        catalogId,
        today,
        keys
    ]);
    return state;
}
function $56dc65ee208cb438$var$PerformerChips({ people: people, selected: selected, firstFree: perfFirst, queue: queue, error: error, onPick: onPick, t: t, formatTime: formatTime }) {
    const single = people.length === 1;
    const onKeyDown = (e)=>{
        if (![
            'ArrowLeft',
            'ArrowRight',
            'Home',
            'End'
        ].includes(e.key) || !people.length) return;
        e.preventDefault();
        const at = Math.max(0, people.findIndex((p)=>p.key === selected?.key));
        const rtl = typeof document !== 'undefined' && document.documentElement.dir === 'rtl';
        const forward = e.key === 'ArrowRight' !== rtl;
        const next = e.key === 'Home' ? 0 : e.key === 'End' ? people.length - 1 : (at + (forward ? 1 : people.length - 1)) % people.length;
        onPick(people[next]);
        e.currentTarget.querySelectorAll('button')[next]?.focus();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 4
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                role: "group",
                "aria-label": t('reception.booking.performer'),
                "data-testid": "reception-booking-performers",
                "data-state": single ? 'single' : people.length ? 'many' : 'none',
                onKeyDown: onKeyDown,
                style: {
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 6,
                    paddingTop: 4
                },
                children: [
                    people.map((p)=>{
                        const on = selected?.key === p.key;
                        const ff = perfFirst[p.key];
                        const meta = !ff || ff.loading ? queue ? null : "\u2026" : ff.noShift && p.type === 'STAFF' ? t('reception.booking.noHours') : queue ? null : ff.firstMs ? t('reception.booking.firstFreeAt', {
                            when: formatTime(ff.firstMs)
                        }) : t('reception.booking.noFreeToday');
                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                            type: "button",
                            "aria-pressed": on,
                            tabIndex: on ? 0 : -1,
                            "data-testid": `reception-booking-performer-${p.id}`,
                            "data-first-ms": ff?.firstMs ? String(ff.firstMs) : undefined,
                            onClick: ()=>onPick(p),
                            style: {
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: 6,
                                padding: '6px 12px',
                                borderRadius: 999,
                                border: `1px solid ${on ? 'var(--p-navy)' : error ? (0, $jTCZr.C).red : (0, $jTCZr.C).border}`,
                                background: on ? 'var(--p-navy)' : '#fff',
                                color: on ? '#fff' : (0, $jTCZr.C).textPrimary,
                                fontFamily: 'inherit',
                                fontSize: '0.78125rem',
                                fontWeight: 600,
                                cursor: 'pointer'
                            },
                            children: [
                                p.isDefault ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    "aria-hidden": true,
                                    children: "\u2605"
                                }) : null,
                                p.name,
                                meta ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    style: {
                                        opacity: on ? 0.85 : 0.7,
                                        fontSize: '0.6875rem'
                                    },
                                    children: [
                                        "\xb7 ",
                                        meta
                                    ]
                                }) : null
                            ]
                        }, p.key);
                    }),
                    !people.length ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            fontSize: '0.75rem',
                            color: (0, $jTCZr.CT).warnInk
                        },
                        "data-testid": "reception-booking-no-performer",
                        children: t('reception.booking.noPerformer')
                    }) : null
                ]
            }),
            error ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                role: "alert",
                "data-testid": "reception-booking-performer-error",
                style: {
                    fontSize: '0.75rem',
                    color: (0, $jTCZr.C).red
                },
                children: error
            }) : null
        ]
    });
}
function $56dc65ee208cb438$var$FirstFreeLine({ read: read, first: first, onLater: onLater, whenLabel: whenLabel, t: t, formatDigits: formatDigits }) {
    if (!read.ready) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: {
            fontSize: '0.75rem',
            color: (0, $jTCZr.C).textMuted
        },
        children: t('reception.booking.performerRequired')
    });
    if (read.loading && !read.days.length) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonRegion), {
        label: t('common.state.loading'),
        style: {
            maxWidth: 320
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
            height: 40
        })
    });
    if (read.error) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2vXUl.default), {
        title: t('reception.booking.slotsFailed'),
        description: read.error,
        retryLabel: t('common.actions.retry'),
        onRetry: read.reload,
        "data-testid": "reception-booking-time-errorstate"
    });
    if (!first) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            flexWrap: 'wrap'
        },
        "data-testid": "reception-booking-first-free",
        "data-state": "empty",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                style: {
                    fontSize: '0.78125rem',
                    color: (0, $jTCZr.CT).warnInk
                },
                children: t('reception.booking.noFreeInHorizon', {
                    days: formatDigits($56dc65ee208cb438$var$HORIZON_DAYS)
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                variant: "outline",
                size: "sm",
                onClick: onLater,
                children: t('reception.booking.showLaterDays')
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": "reception-booking-first-free",
        "data-ms": String(first.startMs),
        "data-state": "content",
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 8,
            padding: '8px 12px',
            borderRadius: 10,
            border: `1.5px solid ${(0, $jTCZr.CT).accent}`,
            background: 'color-mix(in srgb, var(--p-teal) 10%, transparent)',
            fontSize: '0.8125rem',
            fontWeight: 700,
            color: (0, $jTCZr.C).textPrimary,
            alignSelf: 'flex-start'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Md3F.default), {
                size: 15,
                "aria-hidden": true
            }),
            whenLabel(first.startMs)
        ]
    });
}
/**
 * The day stepper and the grid. App-local cells rather than the kit `SlotGrid`:
 * the kit draws free/taken/held with no per-cell REASON (title, tone), and the
 * desk's law is that a taken hour says why (DC §12.3) — the kit gap is noted in
 * CL §5; the geometry and testid shape follow the kit so a promotion is a swap.
 */ function $56dc65ee208cb438$var$DayPicker({ dayIso: dayIso, today: today, onDay: onDay, read: read, cells: cells, pickedMs: pickedMs, onPick: onPick, t: t, formatDate: formatDate }) {
    const dayDate = new Date((0, $5qKOB.wallToMs)(dayIso, 720));
    const state = !read.ready ? 'empty' : read.loading && !read.days.length ? 'loading' : read.error ? 'error' : cells.length ? 'content' : 'empty';
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 8
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                        variant: "outline",
                        size: "sm",
                        onClick: ()=>onDay((0, $5qKOB.addDaysIso)(dayIso, -1)),
                        "aria-label": t('reception.booking.dayPrev'),
                        "data-testid": "reception-booking-day-prev",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kzPvP.default), {
                            size: 14,
                            "aria-hidden": true
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        style: {
                            fontSize: '0.8125rem',
                            fontWeight: 700,
                            color: (0, $jTCZr.C).textPrimary,
                            minWidth: 160,
                            textAlign: 'center'
                        },
                        "data-testid": "reception-booking-day",
                        "data-iso": dayIso,
                        children: [
                            dayIso === today ? `${t('common.dates.today')} \xb7 ` : '',
                            formatDate(dayDate, 'dayMonth')
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                        variant: "outline",
                        size: "sm",
                        onClick: ()=>onDay((0, $5qKOB.addDaysIso)(dayIso, 1)),
                        "aria-label": t('reception.booking.dayNext'),
                        "data-testid": "reception-booking-day-next",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gKFEi.default), {
                            size: 14,
                            "aria-hidden": true
                        })
                    }),
                    dayIso !== today ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                        variant: "ghost",
                        size: "sm",
                        onClick: ()=>onDay(today),
                        "data-testid": "reception-booking-day-today",
                        children: t('common.dates.today')
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                role: "group",
                "aria-label": t('reception.booking.time'),
                "data-testid": "reception-booking-grid",
                "data-state": state,
                style: state === 'content' || state === 'loading' ? {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(5rem, 1fr))',
                    gap: '0.5rem'
                } : undefined,
                children: [
                    state === 'loading' ? Array.from({
                        length: 12
                    }, (_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                            height: 44
                        }, i)) : null,
                    state === 'error' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2vXUl.default), {
                        title: t('reception.booking.slotsFailed'),
                        description: read.error,
                        retryLabel: t('common.actions.retry'),
                        onRetry: read.reload
                    }) : null,
                    state === 'empty' ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: '0.78125rem',
                            color: (0, $jTCZr.C).textMuted,
                            padding: '10px 0'
                        },
                        children: t('reception.booking.noShiftThisDay')
                    }) : null,
                    state === 'content' ? cells.map((cell)=>{
                        const selected = pickedMs != null && cell.value === pickedMs;
                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                            type: "button",
                            onClick: cell.disabled ? undefined : ()=>onPick(cell),
                            disabled: cell.disabled,
                            "aria-pressed": selected,
                            title: cell.title,
                            "data-testid": `reception-booking-slot-${cell.value}`,
                            "data-state": cell.disabled ? 'disabled' : selected ? 'selected' : 'default',
                            "data-held": cell.held || undefined,
                            "data-reason": cell.reason || undefined,
                            className: "tabular-nums",
                            style: {
                                minHeight: '2.75rem',
                                padding: '0.5rem 0.625rem',
                                borderRadius: 10,
                                fontSize: '0.8125rem',
                                fontWeight: 600,
                                fontFamily: 'inherit',
                                cursor: cell.disabled ? 'not-allowed' : 'pointer',
                                border: selected ? `2px solid ${(0, $jTCZr.CT).accent}` : cell.held ? `1.5px dashed ${(0, $jTCZr.CT).warn}` : `1.5px solid ${(0, $jTCZr.C).border}`,
                                background: selected ? 'color-mix(in srgb, var(--p-teal) 14%, transparent)' : cell.held ? 'rgba(217,119,6,0.10)' : (0, $jTCZr.C).card,
                                color: selected ? (0, $jTCZr.CT).accentInk : cell.held ? (0, $jTCZr.CT).warnInk : (0, $jTCZr.C).textPrimary,
                                opacity: cell.disabled ? 0.45 : 1,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                gap: 2
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    children: cell.label
                                }),
                                cell.held ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        fontSize: '0.625rem',
                                        fontWeight: 600
                                    },
                                    children: t('reception.booking.outsideWindow')
                                }) : null
                            ]
                        }, cell.value);
                    }) : null
                ]
            })
        ]
    });
}
function $56dc65ee208cb438$var$PatientField({ patient: patient, locked: locked, query: query, onQuery: onQuery, search: search, onPick: onPick, onClear: onClear, quick: quick, onQuick: onQuick, marker: marker, onMarker: onMarker, inputRef: inputRef, error: error, onNewPatient: onNewPatient, newMode: newMode, onNewMode: onNewMode, newFields: newFields, t: t, formatDigits: formatDigits }) {
    const [open, setOpen] = (0, $acw62.useState)(false);
    const hits = search.results || [];
    if (patient) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": "reception-booking-patient",
        "data-patient": patient.id || '',
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            paddingTop: 6,
            flexWrap: 'wrap'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                style: {
                    fontSize: '0.84375rem',
                    fontWeight: 700,
                    color: (0, $jTCZr.C).textPrimary
                },
                children: patient.name || t('patients.placeholder.noName')
            }),
            patient.phone ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                style: {
                    fontSize: '0.75rem',
                    color: (0, $jTCZr.C).textMuted
                },
                dir: "ltr",
                children: formatDigits((0, $5AX1S).forDisplay(patient.phone))
            }) : null,
            !locked ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                variant: "ghost",
                size: "sm",
                onClick: onClear,
                children: t('common.actions.change')
            }) : null
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": "reception-booking-patient",
        "data-patient": "",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 6,
            position: 'relative'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            position: 'relative',
                            flex: 1
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e5Ore.default), {
                                size: 14,
                                "aria-hidden": true,
                                style: {
                                    position: 'absolute',
                                    insetInlineStart: 10,
                                    top: 13,
                                    color: (0, $jTCZr.C).textMuted
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                ref: inputRef,
                                value: query,
                                onChange: (e)=>{
                                    onQuery(e.target.value);
                                    setOpen(true);
                                },
                                onFocus: ()=>setOpen(true),
                                onBlur: ()=>setTimeout(()=>setOpen(false), 120),
                                onKeyDown: (e)=>{
                                    if (e.key === 'Enter' && hits[0]) {
                                        e.preventDefault();
                                        onPick(hits[0]);
                                    }
                                },
                                placeholder: t('reception.booking.patientSearchPlaceholder'),
                                "aria-label": t('reception.booking.patient'),
                                "aria-invalid": !!error,
                                "data-testid": "reception-booking-patient-input",
                                style: {
                                    width: '100%',
                                    boxSizing: 'border-box',
                                    height: 40,
                                    paddingInlineStart: 30,
                                    paddingInlineEnd: 10,
                                    borderRadius: 8,
                                    border: `1px solid ${error ? (0, $jTCZr.C).red : (0, $jTCZr.C).border}`,
                                    fontFamily: 'inherit',
                                    fontSize: '0.8125rem'
                                }
                            }),
                            open && search.active ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                role: "listbox",
                                "data-testid": "reception-booking-patient-results",
                                style: {
                                    position: 'absolute',
                                    insetInline: 0,
                                    top: 44,
                                    zIndex: 5,
                                    background: '#fff',
                                    borderRadius: 10,
                                    border: `1px solid ${(0, $jTCZr.C).border}`,
                                    boxShadow: '0 12px 30px rgba(15,28,46,.14)',
                                    maxHeight: 240,
                                    overflowY: 'auto'
                                },
                                children: search.loading && !hits.length ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    style: {
                                        padding: 10,
                                        fontSize: '0.75rem',
                                        color: (0, $jTCZr.C).textMuted
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hZDga.Spinner), {
                                        size: "sm"
                                    })
                                }) : !hits.length ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        padding: 10,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: 6
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                fontSize: '0.75rem',
                                                color: (0, $jTCZr.C).textMuted
                                            },
                                            children: t('reception.booking.patientNoneFound')
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            type: "button",
                                            onMouseDown: (e)=>e.preventDefault(),
                                            onClick: ()=>onNewMode(query),
                                            "data-testid": "reception-booking-new-from-query",
                                            style: {
                                                alignSelf: 'flex-start',
                                                border: 'none',
                                                background: 'none',
                                                padding: 0,
                                                fontFamily: 'inherit',
                                                fontSize: '0.78125rem',
                                                fontWeight: 700,
                                                color: 'var(--p-navy)',
                                                cursor: 'pointer'
                                            },
                                            children: t('reception.booking.newPatientFromQuery', {
                                                query: query.trim()
                                            })
                                        })
                                    ]
                                }) : hits.map((p)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                        type: "button",
                                        role: "option",
                                        "aria-selected": false,
                                        onMouseDown: (e)=>e.preventDefault(),
                                        onClick: ()=>onPick(p),
                                        "data-testid": `reception-booking-patient-hit-${p.id}`,
                                        style: {
                                            display: 'flex',
                                            width: '100%',
                                            alignItems: 'center',
                                            gap: 8,
                                            padding: '8px 10px',
                                            border: 'none',
                                            borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
                                            background: 'transparent',
                                            fontFamily: 'inherit',
                                            textAlign: 'start',
                                            cursor: 'pointer'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    fontSize: '0.8125rem',
                                                    fontWeight: 700,
                                                    color: (0, $jTCZr.C).textPrimary
                                                },
                                                children: p.name
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    fontSize: '0.71875rem',
                                                    color: (0, $jTCZr.C).textMuted
                                                },
                                                dir: "ltr",
                                                children: p.phone ? formatDigits((0, $5AX1S).forDisplay(p.phone)) : ''
                                            }),
                                            p.fileNumber ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    fontSize: '0.6875rem',
                                                    color: (0, $jTCZr.C).textMuted
                                                },
                                                children: t('reception.day.fileNumberChip', {
                                                    number: formatDigits(p.fileNumber)
                                                })
                                            }) : null
                                        ]
                                    }, p.id))
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ciRrJ.Kbd), {
                        combo: "f3"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $h4ZeB.default), {
                        label: t('reception.booking.newPatient'),
                        active: newMode,
                        onClick: ()=>onNewMode(null),
                        "data-testid": "reception-booking-new"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $h4ZeB.default), {
                        label: t('reception.booking.quickRegister'),
                        active: quick,
                        onClick: onQuick,
                        "data-testid": "reception-booking-quick"
                    })
                ]
            }),
            newFields,
            quick ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 4
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        value: marker,
                        onChange: (e)=>onMarker(e.target.value),
                        placeholder: t('reception.booking.markerPlaceholder'),
                        "aria-label": t('reception.booking.markerLabel'),
                        "data-testid": "reception-booking-marker",
                        style: {
                            height: 40,
                            padding: '0 10px',
                            borderRadius: 8,
                            border: `1px solid ${(0, $jTCZr.C).border}`,
                            fontFamily: 'inherit',
                            fontSize: '0.8125rem'
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            fontSize: '0.6875rem',
                            color: (0, $jTCZr.C).textMuted
                        },
                        children: t('reception.booking.quickOn')
                    })
                ]
            }) : null,
            onNewPatient ? /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                type: "button",
                onClick: onNewPatient,
                "data-testid": "reception-booking-new-patient",
                style: {
                    alignSelf: 'flex-start',
                    border: 'none',
                    background: 'none',
                    padding: 0,
                    fontFamily: 'inherit',
                    fontSize: '0.71875rem',
                    fontWeight: 700,
                    color: 'var(--p-navy)',
                    textDecoration: 'underline',
                    cursor: 'pointer'
                },
                children: t('reception.booking.newPatientLink')
            }) : null,
            error ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                role: "alert",
                "data-testid": "reception-booking-patient-error",
                style: {
                    fontSize: '0.75rem',
                    color: (0, $jTCZr.C).red
                },
                children: error
            }) : null
        ]
    });
}
/**
 * «بیمار جدید» inside «ثبت نوبت»: the mobile first (where focus lands — the desk
 * asks for the number before anything else), the records already on it right
 * under it, then the full name. A household shares a mobile, so a number with
 * records waits for the desk's pick: one of them, or «بیمار جدید با همین شماره».
 */ function $56dc65ee208cb438$var$NewPatientFields({ name: name, onName: onName, phone: phone, onPhone: onPhone, phoneCountry: phoneCountry, candidates: candidates, sharedPhoneOk: sharedPhoneOk, onChooseLinked: onChooseLinked, onLink: onLink, onSameNumber: onSameNumber, t: t }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": "reception-booking-new-fields",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: (0, $2xQve.STACK).tight,
            padding: '8px 10px',
            borderRadius: 8,
            background: (0, $jTCZr.C).bg
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iRTrY.default), {
                autoFocus: true,
                defaultCountry: phoneCountry || undefined,
                label: t('common.fields.mobile'),
                required: true,
                value: phone,
                onChange: (e164)=>onPhone(e164),
                "data-testid": "reception-booking-new-phone"
            }, phoneCountry || ''),
            candidates.length > 0 && !sharedPhoneOk ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: '0.75rem',
                            fontWeight: 700,
                            color: (0, $jTCZr.C).textSecondary
                        },
                        children: t('reception.booking.phoneCandidatesHint')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jmIrn.default), {
                        candidates: candidates,
                        onChooseLinked: onChooseLinked,
                        chooseLabel: t('patients.phoneCandidates.choose'),
                        onLink: onLink,
                        linkLabel: t('patients.phoneCandidates.addAndChoose'),
                        onNewPatient: onSameNumber,
                        "data-testid": "reception-booking-new-candidates"
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 4,
                    fontSize: '0.75rem',
                    fontWeight: 600,
                    color: (0, $jTCZr.C).textSecondary
                },
                children: [
                    t('common.fields.fullName'),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        value: name,
                        onChange: (e)=>onName(e.target.value),
                        placeholder: t('patients.form.fullNamePlaceholder'),
                        "data-testid": "reception-booking-new-name",
                        style: {
                            height: 40,
                            padding: '0 10px',
                            borderRadius: 8,
                            border: `1px solid ${(0, $jTCZr.C).border}`,
                            fontFamily: 'inherit',
                            fontSize: '0.8125rem'
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                style: {
                    fontSize: '0.6875rem',
                    color: (0, $jTCZr.C).textMuted
                },
                children: t('reception.booking.newPatientHint')
            })
        ]
    });
}
/**
 * «خدمت» — a combobox over the bookable services, grouped «ویزیت» / «خدمات»;
 * typing filters, arrows move, Enter chooses (or, with a choice already made,
 * commits the step and moves on to the patient). App-local: the kit exports no
 * Combobox yet (CL §5 gap); `ServiceCombobox` in «خدمات» is the same shape over
 * the dictionary rather than the bookable list.
 */ function $56dc65ee208cb438$var$ServiceComboboxInner({ groups: groups, value: value, loading: loading, error: error, onRetry: onRetry, onChange: onChange, onCommit: onCommit, fieldError: fieldError }, ref) {
    const { t: t, formatDigits: formatDigits } = (0, $e1LEq.default)();
    const [query, setQuery] = (0, $acw62.useState)('');
    const [open, setOpen] = (0, $acw62.useState)(false);
    const [hi, setHi] = (0, $acw62.useState)(0);
    const all = [
        ...groups.visits.map((e)=>({
                ...e,
                group: 'visit'
            })),
        ...groups.services.map((e)=>({
                ...e,
                group: 'service'
            }))
    ];
    const filtered = query ? all.filter((e)=>(0, $hrj86.faIncludes)(e.name, query)) : all;
    const selected = all.find((e)=>e.catalogId === value) || null;
    (0, $acw62.useEffect)(()=>{
        setHi(0);
    }, [
        query,
        open
    ]);
    const choose = (e)=>{
        onChange(e.catalogId);
        setQuery('');
        setOpen(false);
    };
    const onKeyDown = (e)=>{
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            setOpen(true);
            setHi((h)=>Math.min(h + 1, filtered.length - 1));
            return;
        }
        if (e.key === 'ArrowUp') {
            e.preventDefault();
            setHi((h)=>Math.max(h - 1, 0));
            return;
        }
        if (e.key === 'Escape' && open) {
            e.preventDefault();
            e.stopPropagation();
            setOpen(false);
            setQuery('');
            return;
        }
        if (e.key === 'Enter') {
            e.preventDefault();
            if (open && filtered[hi]) {
                choose(filtered[hi]);
                onCommit?.();
                return;
            }
            if (selected) onCommit?.();
        }
    };
    if (error) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2vXUl.default), {
        title: t('reception.booking.servicesFailed'),
        description: error,
        retryLabel: t('common.actions.retry'),
        onRetry: onRetry
    });
    const renderGroup = (title, items)=>items.length ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            role: "group",
            "aria-label": title,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        fontSize: '0.65625rem',
                        fontWeight: 700,
                        color: (0, $jTCZr.C).textMuted,
                        padding: '6px 10px 2px'
                    },
                    children: title
                }),
                items.map((e)=>{
                    const i = filtered.indexOf(e);
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        type: "button",
                        role: "option",
                        "aria-selected": e.catalogId === value,
                        onMouseDown: (ev)=>ev.preventDefault(),
                        onClick: ()=>{
                            choose(e);
                            onCommit?.();
                        },
                        "data-testid": `reception-booking-service-option-${e.catalogId}`,
                        style: {
                            display: 'flex',
                            width: '100%',
                            alignItems: 'center',
                            gap: 8,
                            padding: '8px 10px',
                            border: 'none',
                            textAlign: 'start',
                            background: i === hi ? (0, $jTCZr.C).bg : 'transparent',
                            fontFamily: 'inherit',
                            fontSize: '0.8125rem',
                            cursor: 'pointer',
                            color: (0, $jTCZr.C).textPrimary,
                            fontWeight: e.catalogId === value ? 700 : 500
                        },
                        children: [
                            e.name,
                            e.schedulingMode === 'QUEUE' ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    fontSize: '0.65625rem',
                                    fontWeight: 700,
                                    padding: '1px 6px',
                                    borderRadius: 5,
                                    background: (0, $jTCZr.C).amberLight,
                                    color: (0, $jTCZr.CT).warnInk
                                },
                                children: t('reception.booking.queueChip')
                            }) : e.rows[0]?.durationMinutes ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                style: {
                                    fontSize: '0.6875rem',
                                    color: (0, $jTCZr.C).textMuted
                                },
                                children: [
                                    formatDigits(e.rows[0].durationMinutes),
                                    "\u2032"
                                ]
                            }) : null
                        ]
                    }, e.catalogId);
                })
            ]
        }, title) : null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": "reception-booking-service",
        "data-value": value || '',
        style: {
            position: 'relative'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    position: 'relative'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        ref: ref,
                        role: "combobox",
                        "aria-expanded": open,
                        "aria-autocomplete": "list",
                        "aria-label": t('reception.booking.service'),
                        "aria-invalid": !!fieldError,
                        value: open ? query : selected?.name || query,
                        onChange: (e)=>{
                            setQuery(e.target.value);
                            setOpen(true);
                        },
                        // PM-0486: focus does NOT open the list. The dialog opens with focus here,
                        // and an open list hid the preselected «ویزیت» and covered «انجام‌دهنده»
                        // and «زمان» — the 90 % path must read as "confirm", not "choose". The
                        // label is selected so typing replaces it; click, typing or ArrowDown open.
                        onFocus: (e)=>e.target.select(),
                        onClick: ()=>setOpen(true),
                        onBlur: ()=>setTimeout(()=>{
                                setOpen(false);
                                setQuery('');
                            }, 120),
                        onKeyDown: onKeyDown,
                        placeholder: loading ? t('common.state.loading') : t('reception.booking.serviceSearch'),
                        "data-testid": "reception-booking-service-input",
                        style: {
                            width: '100%',
                            boxSizing: 'border-box',
                            height: 40,
                            padding: '0 10px',
                            paddingInlineEnd: 30,
                            borderRadius: 8,
                            border: `1px solid ${fieldError ? (0, $jTCZr.C).red : (0, $jTCZr.C).border}`,
                            fontFamily: 'inherit',
                            fontSize: '0.8125rem',
                            fontWeight: 600
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2WFPf.default), {
                        size: 14,
                        "aria-hidden": true,
                        style: {
                            position: 'absolute',
                            insetInlineEnd: 10,
                            top: 13,
                            color: (0, $jTCZr.C).textMuted
                        }
                    })
                ]
            }),
            open ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                role: "listbox",
                style: {
                    position: 'absolute',
                    insetInline: 0,
                    top: 44,
                    zIndex: 5,
                    background: '#fff',
                    borderRadius: 10,
                    border: `1px solid ${(0, $jTCZr.C).border}`,
                    boxShadow: '0 12px 30px rgba(15,28,46,.14)',
                    maxHeight: 280,
                    overflowY: 'auto'
                },
                children: loading && !all.length ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        padding: 10
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        height: 32
                    })
                }) : !filtered.length ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        padding: 10,
                        fontSize: '0.75rem',
                        color: (0, $jTCZr.C).textMuted
                    },
                    children: t('reception.booking.noServices')
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        renderGroup(t('reception.booking.groupVisit'), filtered.filter((e)=>e.group === 'visit')),
                        renderGroup(t('reception.booking.groupServices'), filtered.filter((e)=>e.group === 'service'))
                    ]
                })
            }) : null,
            fieldError ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                role: "alert",
                "data-testid": "reception-booking-service-error",
                style: {
                    fontSize: '0.75rem',
                    color: (0, $jTCZr.C).red,
                    marginTop: 4
                },
                children: fieldError
            }) : null,
            !open && selected && !selected.performers.length ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 4,
                    fontSize: '0.71875rem',
                    color: (0, $jTCZr.CT).warnInk,
                    marginTop: 4
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $QG9Z3.default), {
                        size: 12,
                        "aria-hidden": true
                    }),
                    t('reception.booking.noPerformer')
                ]
            }) : null
        ]
    });
}
const $56dc65ee208cb438$var$ServiceCombobox = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef($56dc65ee208cb438$var$ServiceComboboxInner);

});
parcelRegister("lJ8aj", function(module, exports) {

$parcel$export(module.exports, "usePatientSearch", () => $fd142269863b16ba$export$c2a0e1e82a1adac5);

var $acw62 = parcelRequire("acw62");

var $2Mst8 = parcelRequire("2Mst8");
parcelRequire("bLQhC");
var $5JYPc = parcelRequire("5JYPc");

var $fzbcG = parcelRequire("fzbcG");

var $jSTkY = parcelRequire("jSTkY");
// Clinic-wide patient search — the whole registry, not the day on screen.
//
// The day panel's own filter can only narrow the appointments of the day being shown,
// so a patient who is not booked today is invisible to it: the walk-in at the desk, the
// caller asking about their bill, the person whose نوبت is next Tuesday. This searches
// the clinic's patients instead.
//
// `patientsPage` matches DB-side and clinic-scoped on full name / phone / کد ملی /
// شماره پرونده (see list_patients_by_clinic in patientmanagement). The file number lives
// on the clinic-patient link, so clinic A's «۱۲» can never surface clinic B's patient.
// Exactly what a hit is used for and no more: the four fields it is IDENTIFIED by, the debt
// badge, and keycloakUserId — which EditPatientModal reads to keep an app-verified patient's
// identity fields locked from the first frame, before its own re-read lands. Everything else
// about the patient is fetched by whatever the hit is handed to.
const $fd142269863b16ba$var$SEARCH_QUERY = `
  query ReceptionPatientSearch($search: String, $limit: Int) {
    patientsPage(search: $search, limit: $limit) {
      currency
      total
      items {
        currency
        id
        name
        phone
        # Every number: a search matches any of them, and the row says which (PM-0536).
        ${(0, $jSTkY.PATIENT_PHONES_LIST_FIELDS)}
        nationalId
        fileNumber
        keycloakUserId
        # RIALS still owed to the clinic (0 = settled). The BFF resolves it from one
        # batched accounting call and swallows a billing outage, so it costs the badge,
        # never the search.
        outstandingRial
      }
    }
  }
`;
const $fd142269863b16ba$export$83404369f70233e1 = 2;
function $fd142269863b16ba$export$c2a0e1e82a1adac5(query, { limit: limit = 8 } = {}) {
    const q = (query || '').trim();
    const active = q.length >= $fd142269863b16ba$export$83404369f70233e1;
    // Only a live query is debounced. Clearing the box must empty the results at once —
    // debouncing '' would leave the last patient's name hanging under an empty input.
    const debounced = (0, $fzbcG.default)(active ? q : '', 260);
    const [results, setResults] = (0, $acw62.useState)([]);
    const [total, setTotal] = (0, $acw62.useState)(0);
    const [fetching, setFetching] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    // Keystrokes race: the read for «رض» must not land on top of the results for «رضایی»
    // just because it was slower. Only the newest request may write.
    const reqId = (0, $acw62.useRef)(0);
    (0, $acw62.useEffect)(()=>{
        if (!debounced) {
            setResults([]);
            setTotal(0);
            setFetching(false);
            setError(null);
            return;
        }
        const req = ++reqId.current;
        setFetching(true);
        // Numbers are stored in ASCII digits but typed on a Persian keyboard, and the server
        // matches with ILIKE — «۱۴۰۳» would find nothing. Letters pass through untouched.
        (0, $2Mst8.bffQuery)($fd142269863b16ba$var$SEARCH_QUERY, {
            search: (0, $5JYPc.toEnDigits)(debounced),
            limit: limit
        }).then((data)=>{
            if (req !== reqId.current) return;
            setResults(data?.patientsPage?.items || []);
            setTotal(data?.patientsPage?.total || 0);
            setError(null);
            setFetching(false);
        }).catch((err)=>{
            if (req !== reqId.current) return;
            console.error('patient search error:', err);
            setResults([]);
            setTotal(0);
            setError(err);
            setFetching(false);
        });
    }, [
        debounced,
        limit
    ]);
    return {
        results: results,
        total: total,
        error: error,
        // True from the first keystroke past MIN_QUERY, not a debounce later — otherwise the
        // panel shows «یافت نشد» for a quarter of a second before it has even asked.
        loading: fetching || active && debounced !== q,
        active: active
    };
}
var $fd142269863b16ba$export$2e2bcd8739ae039 = $fd142269863b16ba$export$c2a0e1e82a1adac5;

});
parcelRegister("fzbcG", function(module, exports) {

$parcel$export(module.exports, "default", () => $b552d0b73e8c29fd$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $b552d0b73e8c29fd$export$2e2bcd8739ae039(value, delay = 300) {
    const [debounced, setDebounced] = (0, $acw62.useState)(value);
    (0, $acw62.useEffect)(()=>{
        const t = setTimeout(()=>setDebounced(value), delay);
        return ()=>clearTimeout(t);
    }, [
        value,
        delay
    ]);
    return debounced;
}

});


parcelRegister("hrj86", function(module, exports) {

$parcel$export(module.exports, "EXPENSES_RAIL_GROUPS", () => $cb23cc05191f9c31$export$b4d9d06c1506a5c1);
$parcel$export(module.exports, "GOODS_RAIL_GROUPS", () => $cb23cc05191f9c31$export$3f4531bd8feebfcb);
$parcel$export(module.exports, "visibleRail", () => $cb23cc05191f9c31$export$90bd3a8757b6e5be);
$parcel$export(module.exports, "resolveView", () => $cb23cc05191f9c31$export$85b4e0f374ef171);
$parcel$export(module.exports, "EXPENSE_CATEGORIES", () => $cb23cc05191f9c31$export$e79e6f86f71d4025);
$parcel$export(module.exports, "categoryLabel", () => $cb23cc05191f9c31$export$312b808f6ccb3cb4);
$parcel$export(module.exports, "sourceLabel", () => $cb23cc05191f9c31$export$8bb2d7d77febdab);
$parcel$export(module.exports, "APPROVAL_STATES", () => $cb23cc05191f9c31$export$2071f6da3288f3f6);
$parcel$export(module.exports, "approvalLabel", () => $cb23cc05191f9c31$export$24b354f2563504fc);
$parcel$export(module.exports, "approvalTone", () => $cb23cc05191f9c31$export$21645706badfbbbf);
$parcel$export(module.exports, "needsRuling", () => $cb23cc05191f9c31$export$b5e5debdca2287db);
$parcel$export(module.exports, "ITEM_CATEGORIES", () => $cb23cc05191f9c31$export$d9fb7ccf9451ffa1);
$parcel$export(module.exports, "itemCategoryLabel", () => $cb23cc05191f9c31$export$79b7acb3fd081bec);
$parcel$export(module.exports, "stockState", () => $cb23cc05191f9c31$export$bb6611d817b030f);
$parcel$export(module.exports, "reasonsFor", () => $cb23cc05191f9c31$export$10fbada5b3f2fc47);
$parcel$export(module.exports, "reasonLabel", () => $cb23cc05191f9c31$export$af8453371ec6dd70);
$parcel$export(module.exports, "movementLabel", () => $cb23cc05191f9c31$export$511554380935107b);
$parcel$export(module.exports, "INVENTORY_TIERS", () => $cb23cc05191f9c31$export$4c47059104d91bf6);
$parcel$export(module.exports, "tierLabel", () => $cb23cc05191f9c31$export$4f49b3815c00b719);
$parcel$export(module.exports, "TIER_ORDER", () => $cb23cc05191f9c31$export$67a3419b6c83c58c);
$parcel$export(module.exports, "ITEM_CLASSES", () => $cb23cc05191f9c31$export$cf1fd92d66c8c489);
$parcel$export(module.exports, "lotStateLabel", () => $cb23cc05191f9c31$export$9ece033a3bd8e54e);
$parcel$export(module.exports, "lotStateTone", () => $cb23cc05191f9c31$export$8f74a576c845ac03);
$parcel$export(module.exports, "LOT_STATE_ACTIONS", () => $cb23cc05191f9c31$export$fab2a49b8d2e8a61);
$parcel$export(module.exports, "INSPECTION_REASONS", () => $cb23cc05191f9c31$export$71b578b91ab56aed);
$parcel$export(module.exports, "expiryActionLabel", () => $cb23cc05191f9c31$export$403de46fafeaee4b);
$parcel$export(module.exports, "expiryTone", () => $cb23cc05191f9c31$export$15748564aa51dead);
$parcel$export(module.exports, "LOCATION_KINDS", () => $cb23cc05191f9c31$export$99d72df7bd14adaf);
$parcel$export(module.exports, "locationKindLabel", () => $cb23cc05191f9c31$export$213bc3f0d6decf50);
$parcel$export(module.exports, "docStatusLabel", () => $cb23cc05191f9c31$export$70a94b14973f05ea);
$parcel$export(module.exports, "OPEN_DOC_STATUSES", () => $cb23cc05191f9c31$export$2dd980c3598be123);
$parcel$export(module.exports, "POSITION_FIGURES", () => $cb23cc05191f9c31$export$4154f973bb2e21cd);
$parcel$export(module.exports, "APPLICABILITIES", () => $cb23cc05191f9c31$export$5c9d23f753d827d0);
$parcel$export(module.exports, "CHART_EFFECTS", () => $cb23cc05191f9c31$export$a5a2a58e8e5d8a26);
$parcel$export(module.exports, "COMMISSION_MODES", () => $cb23cc05191f9c31$export$c3beb33eb6469d35);
$parcel$export(module.exports, "DATE_PRESETS", () => $cb23cc05191f9c31$export$925c8ee11af609ba);
$parcel$export(module.exports, "presetLabel", () => $cb23cc05191f9c31$export$7c8f4e6fb24544c5);
$parcel$export(module.exports, "presetRange", () => $cb23cc05191f9c31$export$c1d4212a2686aaff);
$parcel$export(module.exports, "fmtJalaliDay", () => $cb23cc05191f9c31$export$14b8c981d4152256);
$parcel$export(module.exports, "fmtJalaliMoment", () => $cb23cc05191f9c31$export$663c1095cfec8a9d);
$parcel$export(module.exports, "normalizeFa", () => $cb23cc05191f9c31$export$a7f0d01bd35ee833);
$parcel$export(module.exports, "faIncludes", () => $cb23cc05191f9c31$export$801cf36633b27f40);
$parcel$export(module.exports, "expensesCsv", () => $cb23cc05191f9c31$export$9b6e4855945c5a61);
$parcel$export(module.exports, "itemsCsv", () => $cb23cc05191f9c31$export$1581afe0455af1e2);
$parcel$export(module.exports, "BILL_KINDS", () => $cb23cc05191f9c31$export$2b60ac49fd4a936f);
$parcel$export(module.exports, "billKindLabel", () => $cb23cc05191f9c31$export$5d09a53e0a45b133);
$parcel$export(module.exports, "BILL_CADENCES", () => $cb23cc05191f9c31$export$86e162620ddf29f3);
$parcel$export(module.exports, "billCadenceLabel", () => $cb23cc05191f9c31$export$b6bd4a72d93e2a2d);
$parcel$export(module.exports, "CADENCE_MONTHS", () => $cb23cc05191f9c31$export$a68ca3e495bf4fdb);
$parcel$export(module.exports, "billStatusView", () => $cb23cc05191f9c31$export$8fc01b5984740769);
$parcel$export(module.exports, "billOutstandingRial", () => $cb23cc05191f9c31$export$59a3ccf9224a02d0);
$parcel$export(module.exports, "BILL_PAYMENT_METHODS", () => $cb23cc05191f9c31$export$30cda6cc6269ba06);
$parcel$export(module.exports, "billMethodLabel", () => $cb23cc05191f9c31$export$454d7e0b72be399e);
$parcel$export(module.exports, "billNeedsReference", () => $cb23cc05191f9c31$export$f3e6c205a5f83cb1);
$parcel$export(module.exports, "BILL_SUB_KINDS", () => $cb23cc05191f9c31$export$8969a3dd361ad23f);
$parcel$export(module.exports, "billSubKindLabel", () => $cb23cc05191f9c31$export$314b0604256e5261);
$parcel$export(module.exports, "kindWantsIdentifiers", () => $cb23cc05191f9c31$export$8ce16052fcee4363);
$parcel$export(module.exports, "iranRailsAvailable", () => $cb23cc05191f9c31$export$9e213822de2778f7);
$parcel$export(module.exports, "billIsEditable", () => $cb23cc05191f9c31$export$8c125c9d92e45eb3);
$parcel$export(module.exports, "billIsPayable", () => $cb23cc05191f9c31$export$77522c9f1f9cd3a);
$parcel$export(module.exports, "billIsPlaceholder", () => $cb23cc05191f9c31$export$4f51c5358b8c10bb);
$parcel$export(module.exports, "periodLabelOf", () => $cb23cc05191f9c31$export$2d11d1ec8504ddf9);
$parcel$export(module.exports, "recentPeriods", () => $cb23cc05191f9c31$export$98d1ceeb5496cb13);
$parcel$export(module.exports, "billsCsv", () => $cb23cc05191f9c31$export$ad3f99c1896911de);
$parcel$export(module.exports, "expenseStrip", () => $cb23cc05191f9c31$export$e100f822fb63bc47);
$parcel$export(module.exports, "clinicWideServices", () => $cb23cc05191f9c31$export$d714c0091121a304);
$parcel$export(module.exports, "serviceToOpen", () => $cb23cc05191f9c31$export$5b494a4d3e145f22);
$parcel$export(module.exports, "goodsStrip", () => $cb23cc05191f9c31$export$d15374946961f1f1);
$parcel$export(module.exports, "equipmentAlertCounts", () => $cb23cc05191f9c31$export$45c573a67b2fe1a6);
$parcel$export(module.exports, "goodsReportFor", () => $cb23cc05191f9c31$export$7907d2e5c5625ad2);
$parcel$export(module.exports, "equipmentKindsFrom", () => $cb23cc05191f9c31$export$d99df780f94c7fa3);
$parcel$export(module.exports, "equipmentKindPermission", () => $cb23cc05191f9c31$export$9b5276ce6629c761);
$parcel$export(module.exports, "equipmentKindHasMoney", () => $cb23cc05191f9c31$export$de671d5dfa2cc968);
$parcel$export(module.exports, "equipmentStatusLabel", () => $cb23cc05191f9c31$export$242d7ff368bd1fda);
$parcel$export(module.exports, "EQUIPMENT_STATUS_FILTERS", () => $cb23cc05191f9c31$export$f0625c2b6fd6711d);
$parcel$export(module.exports, "equipmentKindLabel", () => $cb23cc05191f9c31$export$dd9ae63dc3404c40);
$parcel$export(module.exports, "equipmentKindTone", () => $cb23cc05191f9c31$export$f4933b0054029da3);
$parcel$export(module.exports, "EQUIPMENT_OWNERSHIPS", () => $cb23cc05191f9c31$export$13c5aebd26424208);
$parcel$export(module.exports, "EQUIPMENT_CRITICALITIES", () => $cb23cc05191f9c31$export$691b4a7cacad1894);
$parcel$export(module.exports, "criticalityLabel", () => $cb23cc05191f9c31$export$f98f99024b9b284d);
$parcel$export(module.exports, "criticalityTone", () => $cb23cc05191f9c31$export$ea41d202bc631074);
$parcel$export(module.exports, "EQUIPMENT_PLAN_KINDS", () => $cb23cc05191f9c31$export$c65ce11629564ead);
$parcel$export(module.exports, "EQUIPMENT_TRIGGERS", () => $cb23cc05191f9c31$export$2c026fcebf30028);
$parcel$export(module.exports, "triggerLabel", () => $cb23cc05191f9c31$export$818d30c55c3d17b5);
$parcel$export(module.exports, "EQUIPMENT_CONTRACT_KINDS", () => $cb23cc05191f9c31$export$ef4342fe5c579e2e);
$parcel$export(module.exports, "contractKindLabel", () => $cb23cc05191f9c31$export$813f7986fd8c73c1);
$parcel$export(module.exports, "EQUIPMENT_COVERAGES", () => $cb23cc05191f9c31$export$a9efdb6183b63b3);
$parcel$export(module.exports, "EQUIPMENT_DEPRECIATION_METHODS", () => $cb23cc05191f9c31$export$14dfda68aeefa147);
$parcel$export(module.exports, "CHECK_RESULTS", () => $cb23cc05191f9c31$export$8ef7c14ef4bde21f);
$parcel$export(module.exports, "equipmentPresetsFor", () => $cb23cc05191f9c31$export$e38e84e5fe379d1);
$parcel$export(module.exports, "equipmentStatusView", () => $cb23cc05191f9c31$export$45f4380d3043bcc8);
$parcel$export(module.exports, "equipmentDueView", () => $cb23cc05191f9c31$export$e28bfc425ce85a98);
$parcel$export(module.exports, "alertSentence", () => $cb23cc05191f9c31$export$9d25530073c655bb);
$parcel$export(module.exports, "equipmentCsv", () => $cb23cc05191f9c31$export$e69647e0ddc238c1);
$parcel$export(module.exports, "downloadCsv", () => (parcelRequire("jmEyz")).downloadCsv);
/**
 * The vocabulary and derivations shared by «مدیریت هزینه‌ها» and «کالاها و خدمات».
 *
 * FOUR surfaces import this file, not two: each of the two workbenches has a
 * desktop variant and a mobile reduction, and they render nothing alike — that is
 * the doctrine (clinic-app/CLAUDE.md §4.1: `.web.jsx` is canonical, `.mobile.jsx`
 * is a reduction of it). What they must NEVER do is disagree about what a thing is
 * called, which rail entries a person may see, or what the totals add up to — so
 * every label set, every permission gate and every derivation lives here and is
 * imported by all of them.
 *
 * It still lives under `screens/Operations/` after the split
 * (docs/CLINIC_EXPENSES_AND_GOODS_SPLIT_DESIGN.md §12 D5): two other screens
 * already import it across folder boundaries (`hooks/useEquipment.js`,
 * `Clinic/components/InventoryTierView.jsx`), so a cross-folder import of it is
 * the codebase's existing shape rather than a new smell. Promoting it to
 * `src/lib/` is a thirty-import rename with no behaviour change, deliberately
 * deferred so the split reads as a move rather than a rewrite.
 *
 * Nothing in this file renders. No React, no JSX, no tokens.
 */ 
var $eLeza = parcelRequire("eLeza");

var $1O6TO = parcelRequire("1O6TO");
parcelRequire("dNNpt");
var $4UJrq = parcelRequire("4UJrq");

var $j7Rqy = parcelRequire("j7Rqy");

var $fhoLy = parcelRequire("fhoLy");

var $68yjU = parcelRequire("68yjU");

var $6PcIc = parcelRequire("6PcIc");

var $jmEyz = parcelRequire("jmEyz");

var $7KqRH = parcelRequire("7KqRH");

var $5qKOB = parcelRequire("5qKOB");
const $cb23cc05191f9c31$export$b4d9d06c1506a5c1 = (t)=>[
        {
            key: 'daily',
            labelFa: t('operations.rail.dailyWork'),
            items: [
                {
                    key: 'expenses',
                    labelFa: t('operations.views.expenses'),
                    perm: 'expenses.view',
                    // Legacy route this view replaces — used to redirect old links and bookmarks.
                    legacyPath: '/expenses'
                },
                {
                    // «قبوض» is daily work, not setup: what is overdue is a question someone
                    // asks every morning, while «انواع قبض» is touched twice a year.
                    key: 'bills',
                    labelFa: t('operations.views.bills'),
                    perm: 'expenses.view'
                }
            ]
        },
        {
            key: 'setup',
            labelFa: t('operations.rail.definitions'),
            items: [
                {
                    key: 'recurring',
                    labelFa: t('operations.views.recurring'),
                    perm: 'expenses.view'
                },
                {
                    key: 'billTypes',
                    labelFa: t('operations.views.billTypes'),
                    perm: 'expenses.view'
                }
            ]
        }
    ];
const $cb23cc05191f9c31$export$3f4531bd8feebfcb = (t)=>[
        {
            key: 'daily',
            labelFa: t('operations.rail.dailyWork'),
            items: [
                {
                    key: 'services',
                    labelFa: t('operations.views.services'),
                    perm: 'services.view',
                    legacyPath: '/services'
                },
                {
                    key: 'items',
                    labelFa: t('operations.views.items'),
                    perm: 'inventory.view',
                    legacyPath: '/inventory'
                },
                {
                    // «تجهیزات» is daily work for the same reason «کالاها» is: what needs a
                    // service TODAY is a question the keeper asks every morning. Its own key,
                    // not inventory.view — a device is not stock (equipment design §B.4) —
                    // but it IS a physical good the clinic owns, its drawer consumes `items`
                    // for spare parts and `suppliers` for the vendor, and the persona who
                    // runs it is مسئول انبار. That is why the register came to this page
                    // rather than staying beside the ledger it posts to (split design §12 D1).
                    key: 'equipment',
                    labelFa: t('operations.views.equipment'),
                    perm: 'equipment.view'
                }
            ]
        },
        {
            key: 'setup',
            labelFa: t('operations.rail.definitions'),
            items: [
                {
                    key: 'suppliers',
                    labelFa: t('operations.views.suppliers'),
                    perm: 'inventory.view'
                },
                // The definitions a device is an instance of. Touched a few times a year,
                // and only by somebody who may register devices.
                {
                    key: 'equipmentTypes',
                    labelFa: t('operations.views.equipmentTypes'),
                    perm: 'equipment.manage'
                },
                // ── The lifecycle entries ────────────────────────────────────
                //
                // `cap` is the CLINIC's inventory capability that reveals the entry, on top
                // of the permission that reveals it to this person. A «ساده» clinic has no
                // capabilities at all and therefore sees none of these — which is the whole
                // of progressive complexity in the rail: not a different screen, the same
                // screen with fewer destinations.
                {
                    key: 'expiry',
                    labelFa: t('operations.views.expiry'),
                    perm: 'inventory.view',
                    cap: 'expiry'
                },
                {
                    key: 'procurement',
                    labelFa: t('operations.views.procurement'),
                    perm: 'inventory.view',
                    cap: 'procurement'
                },
                {
                    key: 'custody',
                    labelFa: t('operations.views.custody'),
                    perm: 'inventory.view',
                    cap: 'custody'
                },
                {
                    key: 'counts',
                    labelFa: t('operations.views.counts'),
                    perm: 'inventory.view',
                    cap: 'counts'
                },
                {
                    key: 'locations',
                    labelFa: t('operations.views.locations'),
                    perm: 'inventory.view',
                    cap: 'locations'
                },
                // `contracts.manage`, not `services.view`: this screen is the clinic↔insurer
                // COMMERCIAL AGREEMENT, the same kind of thing as a doctor's contract, and
                // the warehouse-keeper template holds `services.view` so it can see the
                // service list for stock. Gating on that would put the clinic's insurance
                // terms in front of مسئول انبار.
                //
                // It sits on the GOODS page because it is service pricing seen from the
                // insurer's side: the view's own header calls it «what each service costs
                // the patient under that agreement», and its picker is fed by the services
                // the clinic declares — a rule can never name a service it does not
                // perform (split design §12 D2).
                //
                // Reading a coverage rule to EXPLAIN a share is a different question and
                // stays on `services.view` at the BFF, so the settle drawer's ⓘ still works
                // for a منشی who can never open this editor.
                {
                    key: 'insurance',
                    labelFa: t('insurance.title'),
                    perm: 'contracts.manage'
                }
            ]
        }
    ];
const $cb23cc05191f9c31$export$f6c354a527f4818f = (t)=>[
        ...$cb23cc05191f9c31$export$b4d9d06c1506a5c1(t),
        ...$cb23cc05191f9c31$export$3f4531bd8feebfcb(t)
    ];
/**
 * Every rail destination, flattened — the STRUCTURE only.
 *
 * Read through a translator that returns the key it is handed, because nothing
 * here needs the labels: the key lists validate a `?view=` parameter, and
 * `viewForLegacyPath`/`pageForView` answer which page owns a view. Those are all
 * answers about the URL, and a URL has no language. Threading a real `t` in
 * would have made module constants into functions and every reader into a call,
 * for labels none of them reads.
 */ const $cb23cc05191f9c31$var$flatten = (groups)=>groups((key)=>key).flatMap((g)=>g.items);
const $cb23cc05191f9c31$var$ALL_VIEWS = [
    ...$cb23cc05191f9c31$var$flatten($cb23cc05191f9c31$export$b4d9d06c1506a5c1),
    ...$cb23cc05191f9c31$var$flatten($cb23cc05191f9c31$export$3f4531bd8feebfcb)
];
const $cb23cc05191f9c31$export$88b3856d82763646 = [
    ...(0, $6PcIc.EXPENSES_VIEWS),
    ...(0, $6PcIc.GOODS_VIEWS)
];
function $cb23cc05191f9c31$export$90bd3a8757b6e5be(can, t, caps = [], groups = $cb23cc05191f9c31$export$f6c354a527f4818f) {
    const enabled = new Set(caps || []);
    return groups(t).map((g)=>({
            ...g,
            items: g.items.filter((i)=>can(i.perm) && (!i.cap || enabled.has(i.cap)))
        })).filter((g)=>g.items.length);
}
function $cb23cc05191f9c31$export$85b4e0f374ef171(requested, can, t, caps = [], groups = $cb23cc05191f9c31$export$f6c354a527f4818f) {
    const visible = $cb23cc05191f9c31$export$90bd3a8757b6e5be(can, t, caps, groups);
    const allowed = visible.flatMap((g)=>g.items.map((i)=>i.key));
    if (requested && allowed.includes(requested)) return requested;
    return allowed[0] || null;
}
function $cb23cc05191f9c31$export$929aefa2053ee956(path) {
    const hit = $cb23cc05191f9c31$var$ALL_VIEWS.find((v)=>v.legacyPath === path);
    return hit ? {
        page: (0, $6PcIc.pageForView)(hit.key),
        view: hit.key
    } : null;
}
const $cb23cc05191f9c31$export$e79e6f86f71d4025 = (t)=>[
        {
            key: 'personnel',
            labelFa: t('operations.expenseCategories.payroll'),
            tone: 'info'
        },
        {
            key: 'operating',
            labelFa: t('operations.expenseCategories.operating'),
            tone: 'accent'
        },
        {
            key: 'equipment',
            labelFa: t('operations.expenseCategories.equipment'),
            tone: 'violet'
        },
        {
            key: 'consumable',
            labelFa: t('operations.expenseCategories.consumables'),
            tone: 'warn'
        },
        {
            key: 'depreciation',
            labelFa: t('operations.expenseCategories.depreciation'),
            tone: 'mute'
        },
        {
            key: 'other',
            labelFa: t('common.state.other'),
            tone: 'mute'
        }
    ];
const $cb23cc05191f9c31$export$312b808f6ccb3cb4 = (key, t)=>$cb23cc05191f9c31$export$e79e6f86f71d4025(t).find((c)=>c.key === key)?.labelFa || key || "\u2014";
const $cb23cc05191f9c31$export$9208bdefb3ad3c45 = (t)=>({
        manual: '',
        recurring: t('operations.expenseSources.recurring'),
        inventory_purchase: t('operations.expenseSources.purchase'),
        hr_payroll: t('operations.expenseSources.payroll'),
        depreciation_accrual: t('operations.expenseCategories.depreciation'),
        inventory_withdrawal: t('operations.expenseSources.stockOut')
    });
const $cb23cc05191f9c31$export$8bb2d7d77febdab = (key, t)=>$cb23cc05191f9c31$export$9208bdefb3ad3c45(t)[key] ?? '';
const $cb23cc05191f9c31$export$2071f6da3288f3f6 = (t)=>[
        {
            key: 'pending',
            labelFa: t('operations.approval.pending'),
            tone: 'warn'
        },
        {
            key: 'approved',
            labelFa: t('operations.approval.approved'),
            tone: 'good'
        },
        {
            key: 'rejected',
            labelFa: t('operations.approval.rejected'),
            tone: 'danger'
        }
    ];
const $cb23cc05191f9c31$export$24b354f2563504fc = (key, t)=>$cb23cc05191f9c31$export$2071f6da3288f3f6(t).find((s)=>s.key === key)?.labelFa || key || "\u2014";
const $cb23cc05191f9c31$export$21645706badfbbbf = (key, t)=>$cb23cc05191f9c31$export$2071f6da3288f3f6(t).find((s)=>s.key === key)?.tone || 'mute';
const $cb23cc05191f9c31$export$b5e5debdca2287db = (expense)=>!!expense && expense.status !== 'void' && expense.approvalStatus === 'pending';
const $cb23cc05191f9c31$export$d9fb7ccf9451ffa1 = (t)=>[
        {
            key: 'consumable',
            labelFa: t('operations.expenseCategories.consumables')
        },
        {
            key: 'device',
            labelFa: t('operations.serviceGroups.device')
        },
        {
            key: 'pharma',
            labelFa: t('patients.medication.entity')
        },
        {
            key: 'orthopedic',
            labelFa: t('operations.serviceGroups.orthopaedics')
        }
    ];
const $cb23cc05191f9c31$export$79b7acb3fd081bec = (key, t)=>$cb23cc05191f9c31$export$d9fb7ccf9451ffa1(t).find((c)=>c.key === key)?.labelFa || key || "\u2014";
function $cb23cc05191f9c31$export$bb6611d817b030f(item, t) {
    if (!item) return {
        key: 'ok',
        labelFa: t('operations.stock.inStock'),
        tone: 'good'
    };
    if (item.currentStock <= 0) return {
        key: 'out',
        labelFa: t('operations.stock.outOfStock'),
        tone: 'danger'
    };
    if (item.currentStock <= item.minimumStock) return {
        key: 'low',
        labelFa: t('operations.stock.low'),
        tone: 'warn'
    };
    return {
        key: 'ok',
        labelFa: t('operations.stock.inStock'),
        tone: 'good'
    };
}
const $cb23cc05191f9c31$export$7df3f102b14f9e62 = (t)=>[
        {
            key: 'waste',
            labelFa: t('operations.stockReasons.waste')
        },
        {
            key: 'damage',
            labelFa: t('operations.stockReasons.damage')
        },
        {
            key: 'expired',
            labelFa: t('operations.stockReasons.expiry')
        },
        {
            key: 'internal_use',
            labelFa: t('operations.stockReasons.internalUse')
        },
        {
            key: 'count_correction',
            labelFa: t('operations.stockReasons.countCorrection')
        },
        {
            key: 'return_to_supplier',
            labelFa: t('operations.stockReasons.returnToSupplier')
        }
    ];
const $cb23cc05191f9c31$export$5e98dc8ec22466b2 = (t)=>[
        {
            key: 'count_correction',
            labelFa: t('operations.stockReasons.countCorrection')
        },
        {
            key: 'return_from_use',
            labelFa: t('operations.stockReasons.returnedUnused')
        },
        {
            key: 'opening_balance',
            labelFa: t('operations.stockReasons.opening')
        }
    ];
const $cb23cc05191f9c31$export$10fbada5b3f2fc47 = (quantity, t)=>quantity < 0 ? $cb23cc05191f9c31$export$7df3f102b14f9e62(t) : $cb23cc05191f9c31$export$5e98dc8ec22466b2(t);
const $cb23cc05191f9c31$export$af8453371ec6dd70 = (key, t)=>[
        ...$cb23cc05191f9c31$export$7df3f102b14f9e62(t),
        ...$cb23cc05191f9c31$export$5e98dc8ec22466b2(t)
    ].find((r)=>r.key === key)?.labelFa || key || '';
const $cb23cc05191f9c31$export$452fa822239d873e = (t)=>({
        PURCHASE_IN: t('operations.stockReasons.fromPurchase'),
        MANUAL_ADJUST: t('operations.stockReasons.manualAdjustment'),
        MANUAL_ADJUSTMENT: t('operations.stockReasons.manualAdjustment'),
        RECEIVE: t('operations.stockReasons.fromPurchase'),
        ADJUSTMENT: t('operations.stockReasons.manualAdjustment'),
        CONSUMPTION: t('operations.stockReasons.usedForPatient'),
        TRANSFER_OUT: t('operations.movements.transferOut'),
        TRANSFER_IN: t('operations.movements.transferIn'),
        ISSUE: t('operations.movements.issue'),
        SALE: t('operations.movements.sale'),
        RETURN_IN: t('operations.movements.returnIn'),
        SUPPLIER_RETURN: t('operations.stockReasons.returnToSupplier'),
        DISPOSAL: t('operations.movements.disposal'),
        LOST: t('operations.movements.lost'),
        THEFT: t('operations.movements.theft'),
        RECALL_BLOCK: t('operations.movements.recallBlock'),
        STATE_CHANGE: t('operations.movements.stateChange'),
        OPEN: t('operations.movements.open')
    });
const $cb23cc05191f9c31$export$511554380935107b = (key, t)=>$cb23cc05191f9c31$export$452fa822239d873e(t)[key] || key || "\u2014";
const $cb23cc05191f9c31$export$4c47059104d91bf6 = (t)=>[
        {
            key: 'simple',
            labelFa: t('operations.tiers.simple'),
            descriptionFa: t('operations.tiers.simpleHint')
        },
        {
            key: 'standard',
            labelFa: t('operations.tiers.standard'),
            descriptionFa: t('operations.tiers.standardHint')
        },
        {
            key: 'advanced',
            labelFa: t('operations.tiers.advanced'),
            descriptionFa: t('operations.tiers.advancedHint')
        }
    ];
const $cb23cc05191f9c31$export$4f49b3815c00b719 = (key, t)=>$cb23cc05191f9c31$export$4c47059104d91bf6(t).find((x)=>x.key === key)?.labelFa || key || '';
const $cb23cc05191f9c31$export$67a3419b6c83c58c = {
    simple: 0,
    standard: 1,
    advanced: 2
};
const $cb23cc05191f9c31$export$cf1fd92d66c8c489 = (t)=>[
        {
            key: 'consumable',
            labelFa: t('operations.itemClasses.consumable')
        },
        {
            key: 'serialized',
            labelFa: t('operations.itemClasses.serialized')
        },
        {
            key: 'reusable',
            labelFa: t('operations.itemClasses.reusable')
        },
        {
            key: 'sellable',
            labelFa: t('operations.itemClasses.sellable')
        }
    ];
const $cb23cc05191f9c31$export$20f562801211cccf = (t)=>[
        {
            key: 'available',
            labelFa: t('operations.lotStates.available'),
            tone: 'good'
        },
        {
            key: 'opened',
            labelFa: t('operations.lotStates.opened'),
            tone: 'info'
        },
        {
            key: 'quarantine',
            labelFa: t('operations.lotStates.quarantine'),
            tone: 'warn'
        },
        {
            key: 'blocked',
            labelFa: t('operations.lotStates.blocked'),
            tone: 'danger'
        },
        {
            key: 'expired',
            labelFa: t('operations.lotStates.expired'),
            tone: 'danger'
        },
        {
            key: 'damaged',
            labelFa: t('operations.lotStates.damaged'),
            tone: 'danger'
        },
        {
            key: 'in_transit',
            labelFa: t('operations.lotStates.inTransit'),
            tone: 'mute'
        }
    ];
const $cb23cc05191f9c31$export$9ece033a3bd8e54e = (key, t)=>$cb23cc05191f9c31$export$20f562801211cccf(t).find((s)=>s.key === key)?.labelFa || key || "\u2014";
const $cb23cc05191f9c31$export$8f74a576c845ac03 = (key, t)=>$cb23cc05191f9c31$export$20f562801211cccf(t).find((s)=>s.key === key)?.tone || 'mute';
const $cb23cc05191f9c31$export$fab2a49b8d2e8a61 = (t)=>[
        {
            key: 'quarantine',
            labelFa: t('operations.lotStates.quarantine')
        },
        {
            key: 'available',
            labelFa: t('operations.lotActions.release')
        },
        {
            key: 'damaged',
            labelFa: t('operations.lotStates.damaged')
        },
        {
            key: 'blocked',
            labelFa: t('operations.lotStates.blocked')
        }
    ];
const $cb23cc05191f9c31$export$71b578b91ab56aed = (t)=>[
        {
            key: 'suspect_packaging',
            labelFa: t('operations.inspection.suspectPackaging')
        },
        {
            key: 'damaged_on_arrival',
            labelFa: t('operations.inspection.damagedOnArrival')
        },
        {
            key: 'discrepancy',
            labelFa: t('operations.inspection.discrepancy')
        },
        {
            key: 'cold_chain',
            labelFa: t('operations.inspection.coldChain')
        },
        {
            key: 'batch_problem',
            labelFa: t('operations.inspection.batchProblem')
        },
        {
            key: 'quality_review',
            labelFa: t('operations.inspection.qualityReview')
        },
        {
            key: 'recall',
            labelFa: t('operations.inspection.recall')
        }
    ];
const $cb23cc05191f9c31$export$d1143db0b0cfcf48 = (t)=>({
        flag: t('operations.expiry.actionFlag'),
        consume_first: t('operations.expiry.actionConsumeFirst'),
        transfer: t('operations.expiry.actionTransfer'),
        discount_or_return: t('operations.expiry.actionDiscountOrReturn'),
        prepare_disposal: t('operations.expiry.actionPrepareDisposal'),
        expired: t('operations.lotStates.expired')
    });
const $cb23cc05191f9c31$export$403de46fafeaee4b = (key, t)=>$cb23cc05191f9c31$export$d1143db0b0cfcf48(t)[key] || '';
function $cb23cc05191f9c31$export$15748564aa51dead(daysLeft) {
    if (daysLeft == null) return 'mute';
    if (daysLeft <= 30) return 'danger';
    if (daysLeft <= 90) return 'warn';
    return 'info';
}
const $cb23cc05191f9c31$export$99d72df7bd14adaf = (t)=>[
        {
            key: 'warehouse',
            labelFa: t('operations.locationKinds.warehouse')
        },
        {
            key: 'room',
            labelFa: t('operations.locationKinds.room')
        },
        {
            key: 'fridge',
            labelFa: t('operations.locationKinds.fridge')
        },
        {
            key: 'cabinet',
            labelFa: t('operations.locationKinds.cabinet')
        },
        {
            key: 'custodian',
            labelFa: t('operations.locationKinds.custodian')
        }
    ];
const $cb23cc05191f9c31$export$213bc3f0d6decf50 = (key, t)=>$cb23cc05191f9c31$export$99d72df7bd14adaf(t).find((k)=>k.key === key)?.labelFa || key || "\u2014";
const $cb23cc05191f9c31$export$2b7f48e82c266e59 = (t)=>({
        draft: t('operations.docStatus.draft'),
        pending_approval: t('operations.docStatus.pendingApproval'),
        approved: t('common.state.approved'),
        rejected: t('operations.docStatus.rejected'),
        converted: t('operations.docStatus.converted'),
        ordered: t('operations.docStatus.ordered'),
        partially_received: t('operations.docStatus.partiallyReceived'),
        received: t('operations.docStatus.received'),
        cancelled: t('operations.docStatus.cancelled'),
        requested: t('operations.docStatus.requested'),
        issued: t('operations.docStatus.issued'),
        disputed: t('operations.docStatus.disputed'),
        shipped: t('operations.docStatus.shipped'),
        picked: t('operations.docStatus.picked'),
        open: t('operations.docStatus.open'),
        counting: t('operations.docStatus.counting'),
        review: t('operations.docStatus.review'),
        posted: t('operations.docStatus.posted'),
        abandoned: t('operations.docStatus.abandoned'),
        sent: t('operations.docStatus.sent'),
        credited: t('operations.docStatus.credited'),
        disposed: t('operations.docStatus.disposed'),
        blocked: t('operations.lotStates.blocked'),
        closed: t('operations.docStatus.closed'),
        inspected: t('operations.docStatus.inspected'),
        pending_inspection: t('operations.docStatus.pendingInspection'),
        short: t('operations.docStatus.short'),
        accepted: t('common.state.approved'),
        quarantine: t('operations.lotStates.quarantine'),
        damaged: t('operations.lotStates.damaged'),
        expired: t('operations.lotStates.expired')
    });
const $cb23cc05191f9c31$export$70a94b14973f05ea = (key, t)=>$cb23cc05191f9c31$export$2b7f48e82c266e59(t)[key] || key || "\u2014";
const $cb23cc05191f9c31$export$2dd980c3598be123 = {
    requests: [
        'draft',
        'pending_approval'
    ],
    orders: [
        'ordered',
        'partially_received'
    ],
    issues: [
        'requested',
        'approved',
        'issued',
        'disputed'
    ],
    counts: [
        'open',
        'counting',
        'review'
    ]
};
const $cb23cc05191f9c31$export$4154f973bb2e21cd = (t)=>[
        {
            key: 'onHand',
            labelFa: t('operations.position.onHand')
        },
        {
            key: 'available',
            labelFa: t('operations.position.available')
        },
        {
            key: 'reserved',
            labelFa: t('operations.position.reserved')
        },
        {
            key: 'inCustody',
            labelFa: t('operations.position.inCustody')
        },
        {
            key: 'inTransit',
            labelFa: t('operations.position.inTransit')
        },
        {
            key: 'onOrder',
            labelFa: t('operations.position.onOrder')
        }
    ];
const $cb23cc05191f9c31$export$2f7aede420a3ff50 = (t)=>[
        {
            key: 'doctor',
            labelFa: t('common.roles.doctor')
        },
        {
            key: 'nurse',
            labelFa: t('common.roles.nurse')
        },
        {
            key: 'physiotherapist',
            labelFa: t('common.roles.physiotherapist')
        },
        {
            key: 'technician',
            labelFa: t('common.roles.technician')
        },
        {
            key: 'radiologist',
            labelFa: t('common.roles.radiologist')
        }
    ];
const $cb23cc05191f9c31$export$5c9d23f753d827d0 = (t)=>[
        {
            key: '',
            labelFa: t('operations.applicability.unset')
        },
        {
            key: 'tooth',
            labelFa: t('operations.applicability.tooth')
        },
        {
            key: 'surfaces',
            labelFa: t('operations.applicability.surfaces')
        },
        {
            key: 'quadrant',
            labelFa: t('operations.applicability.quadrant')
        },
        {
            key: 'arch',
            labelFa: t('operations.applicability.arch')
        },
        {
            key: 'mouth',
            labelFa: t('operations.applicability.mouth')
        }
    ];
const $cb23cc05191f9c31$export$a5a2a58e8e5d8a26 = (t)=>[
        {
            key: '',
            labelFa: t('operations.applicability.unset')
        },
        {
            key: 'none',
            labelFa: t('operations.chartEffect.none')
        },
        {
            key: 'surface:restoration',
            labelFa: t('operations.chartEffect.surfaceRestoration')
        },
        {
            key: 'surface:sealant',
            labelFa: t('operations.chartEffect.surfaceSealant')
        },
        {
            key: 'surface:temporary',
            labelFa: t('operations.chartEffect.surfaceTemporary')
        },
        {
            key: 'condition:root_canal',
            labelFa: t('operations.chartEffect.rootCanal')
        },
        {
            key: 'condition:crown',
            labelFa: t('operations.chartEffect.crown')
        },
        {
            key: 'condition:veneer',
            labelFa: t('operations.chartEffect.veneer')
        },
        {
            key: 'condition:implant',
            labelFa: t('operations.chartEffect.implant')
        },
        {
            key: 'condition:post_core',
            labelFa: t('operations.chartEffect.postCore')
        },
        {
            key: 'condition:bridge_abutment',
            labelFa: t('operations.chartEffect.bridgeAbutment')
        },
        {
            key: 'condition:sealant',
            labelFa: t('operations.chartEffect.sealant')
        },
        {
            key: 'condition:temporary',
            labelFa: t('operations.chartEffect.temporary')
        },
        {
            key: 'presence:extracted',
            labelFa: t('operations.chartEffect.extracted')
        }
    ];
const $cb23cc05191f9c31$export$c3beb33eb6469d35 = (t)=>[
        {
            key: 'percent',
            labelFa: t('operations.commission.percentOfTariff')
        },
        {
            key: 'fixed',
            labelFa: t('operations.commission.fixedAmount')
        }
    ];
// ── The date window ──────────────────────────────────────────────────────────
// One window governs the whole module: the cost strip, the expense ledger, the
// purchase history. Frozen when the preset is picked, never computed in render —
// a live Date.now() in a render body makes the value fed to the hooks change every
// frame and refetches forever (the trap useCashier documents).
const $cb23cc05191f9c31$var$DAY = 86400000;
// The clinic's UTC offset at an instant (PM-0088) — was a fixed +03:30.
const $cb23cc05191f9c31$var$offsetAt = (ms)=>(0, $5qKOB.zoneOffsetMs)(ms);
const $cb23cc05191f9c31$export$925c8ee11af609ba = (t)=>[
        {
            key: 'today',
            labelFa: t('common.dates.today')
        },
        {
            key: '7d',
            labelFa: t('common.ranges.last7Days')
        },
        {
            key: 'month',
            labelFa: t('common.ranges.thisMonth')
        },
        {
            key: 'all',
            labelFa: t('common.filters.all')
        }
    ];
const $cb23cc05191f9c31$export$7c8f4e6fb24544c5 = (key, t)=>$cb23cc05191f9c31$export$925c8ee11af609ba(t).find((p)=>p.key === key)?.labelFa || '';
function $cb23cc05191f9c31$export$c1d4212a2686aaff(key, now = Date.now()) {
    if (key === 'all') return null;
    if (key === '7d') return {
        fromTs: now - 7 * $cb23cc05191f9c31$var$DAY,
        toTs: now
    };
    const clinicMidnight = (0, $5qKOB.clinicDayStart)(now);
    if (key === 'today') return {
        fromTs: clinicMidnight,
        toTs: (0, $5qKOB.clinicDayEnd)(now) + 1
    };
    // 'month' — the current JALALI month. A clinic's «این ماه» is مرداد, not August —
    // unless the brand keeps Gregorian books (lib/dateRange.js), where it is August.
    if ((0, $j7Rqy.gregorianBooks)()) return {
        fromTs: (0, $j7Rqy.monthStartMs)(now),
        toTs: now + $cb23cc05191f9c31$var$DAY
    };
    const j = (0, $4UJrq.msToJalali)(now + $cb23cc05191f9c31$var$offsetAt(now));
    const monthStart = j ? (0, $5qKOB.wallToMs)(new Date((0, $4UJrq.jalaliToMs)(j.y, j.m, 1)).toISOString().slice(0, 10), 0) : clinicMidnight;
    return {
        fromTs: monthStart,
        toTs: now + $cb23cc05191f9c31$var$DAY
    };
}
function $cb23cc05191f9c31$export$14b8c981d4152256(ms, formatDate) {
    if (!ms) return "\u2014";
    return formatDate(Number(ms), 'long');
}
function $cb23cc05191f9c31$export$663c1095cfec8a9d(ms, formatDate, formatTime) {
    if (!ms) return "\u2014";
    const n = Number(ms);
    return `${formatDate(n, 'long')} \xb7 ${formatTime(n)}`;
}
const $cb23cc05191f9c31$export$a7f0d01bd35ee833 = (s)=>// i18n-exempt: the CHARACTERS being folded, not copy. This is a search
    // normaliser over data the clinic stored in Persian, and it stays correct
    // whatever language the panel's chrome is in.
    String(s || '').replace(/ي/g, "\u06CC").replace(/ك/g, "\u06A9");
const $cb23cc05191f9c31$export$801cf36633b27f40 = (haystack, needle)=>$cb23cc05191f9c31$export$a7f0d01bd35ee833(haystack).includes($cb23cc05191f9c31$export$a7f0d01bd35ee833(needle));
function $cb23cc05191f9c31$export$9b6e4855945c5a61(expenses, t, formatDate) {
    return (0, $jmEyz.toCsv)([
        t('common.fields.date'),
        t('operations.fields.description'),
        t('operations.fields.payee'),
        t('operations.fields.category'),
        t('operations.fields.costCentre'),
        t('operations.fields.amountToman'),
        t('common.fields.status'),
        t('common.actions.confirm')
    ], expenses.map((e)=>[
            $cb23cc05191f9c31$export$14b8c981d4152256(e.occurredAt, formatDate),
            // i18n-exempt: CSV-hostile characters stripped from a description — the
            // Persian semicolon «؛» is one of them. Punctuation, not copy.
            (e.description || '').replace(/[\r\n,؛]/g, ' '),
            e.payee || '',
            $cb23cc05191f9c31$export$312b808f6ccb3cb4(e.category, t),
            (0, $7KqRH.costCenterLabel)(e.costCenter, t),
            String((0, $1O6TO.toDisplay)(e.amountRial, e.currency) ?? 0),
            e.status === 'void' ? t('accounting.status.void') : t('common.state.active'),
            $cb23cc05191f9c31$export$24b354f2563504fc(e.approvalStatus, t)
        ]));
}
function $cb23cc05191f9c31$export$1581afe0455af1e2(items, t) {
    return (0, $jmEyz.toCsv)([
        t('operations.fields.itemName'),
        t('operations.fields.code'),
        t('operations.fields.category'),
        t('operations.fields.unit'),
        t('operations.fields.stock'),
        t('operations.fields.minimum'),
        t('operations.fields.costPriceToman'),
        t('operations.fields.sellingPriceToman'),
        t('operations.fields.stockValueToman'),
        t('common.fields.status')
    ], items.map((i)=>[
            i.name,
            i.code,
            $cb23cc05191f9c31$export$79b7acb3fd081bec(i.category, t),
            i.unit,
            String(i.currentStock ?? 0),
            String(i.minimumStock ?? 0),
            // TOMAN under the «(تومان)» headers. These three wrote RIALS until the
            // currency work — ten times the money under a toman label.
            (0, $jmEyz.csvMoney)(i.averageCost || 0, i.currency),
            (0, $jmEyz.csvMoney)(i.sellingPrice || 0, i.currency),
            (0, $jmEyz.csvMoney)((i.averageCost || 0) * Math.max(i.currentStock || 0, 0), i.currency),
            $cb23cc05191f9c31$export$bb6611d817b030f(i, t).labelFa
        ]));
}
const $cb23cc05191f9c31$export$2b60ac49fd4a936f = (t)=>[
        {
            key: 'electricity',
            labelFa: t('operations.billKinds.electricity')
        },
        {
            key: 'water',
            labelFa: t('operations.billKinds.water')
        },
        {
            key: 'gas',
            labelFa: t('operations.billKinds.gas')
        },
        {
            key: 'landline',
            labelFa: t('operations.billKinds.landline')
        },
        {
            key: 'mobile',
            labelFa: t('operations.billKinds.mobile')
        },
        {
            key: 'internet',
            labelFa: t('operations.billKinds.internet')
        },
        {
            key: 'municipality',
            labelFa: t('operations.billKinds.municipality')
        },
        {
            key: 'tax',
            labelFa: t('operations.billKinds.tax')
        },
        {
            key: 'insurance_premium',
            labelFa: t('operations.billKinds.insurancePremium')
        },
        {
            key: 'rent',
            labelFa: t('operations.billKinds.rent')
        },
        {
            key: 'service_charge',
            labelFa: t('operations.billKinds.serviceCharge')
        },
        {
            key: 'other',
            labelFa: t('common.state.other')
        }
    ];
const $cb23cc05191f9c31$export$5d09a53e0a45b133 = (key, t)=>$cb23cc05191f9c31$export$2b60ac49fd4a936f(t).find((k)=>k.key === key)?.labelFa || key || "\u2014";
const $cb23cc05191f9c31$export$86e162620ddf29f3 = (t)=>[
        {
            key: 'monthly',
            labelFa: t('operations.billCadences.monthly')
        },
        {
            key: 'bimonthly',
            labelFa: t('operations.billCadences.bimonthly')
        },
        {
            key: 'quarterly',
            labelFa: t('operations.billCadences.quarterly')
        },
        {
            key: 'yearly',
            labelFa: t('operations.billCadences.yearly')
        },
        {
            key: 'custom',
            labelFa: t('operations.billCadences.custom')
        }
    ];
const $cb23cc05191f9c31$export$b6bd4a72d93e2a2d = (key, t)=>$cb23cc05191f9c31$export$86e162620ddf29f3(t).find((c)=>c.key === key)?.labelFa || key || "\u2014";
const $cb23cc05191f9c31$export$a68ca3e495bf4fdb = {
    monthly: 1,
    bimonthly: 2,
    quarterly: 3,
    yearly: 12
};
const $cb23cc05191f9c31$export$1cbcb29ac3f13a2b = (t)=>[
        {
            key: 'expected',
            labelFa: t('operations.billStatuses.expected'),
            tone: 'accent'
        },
        {
            key: 'unpaid',
            labelFa: t('operations.billStatuses.unpaid'),
            tone: 'mute'
        },
        {
            key: 'paid',
            labelFa: t('operations.billStatuses.paid'),
            tone: 'good'
        },
        {
            key: 'cancelled',
            labelFa: t('operations.billStatuses.cancelled'),
            tone: 'mute'
        }
    ];
function $cb23cc05191f9c31$export$8fc01b5984740769(bill, t) {
    if (!bill) return {
        labelFa: "\u2014",
        tone: 'mute'
    };
    if (bill.status === 'unpaid' && bill.isOverdue) return {
        labelFa: t('operations.billStatuses.overdue'),
        tone: 'danger'
    };
    if (bill.status === 'unpaid' && bill.isDueSoon) return {
        labelFa: t('operations.billStatuses.dueSoon'),
        tone: 'warn'
    };
    if (bill.status === 'unpaid' && Number(bill.settledRial) > 0) return {
        labelFa: t('operations.billStatuses.partiallyPaid'),
        tone: 'warn'
    };
    const s = $cb23cc05191f9c31$export$1cbcb29ac3f13a2b(t).find((x)=>x.key === bill.status);
    return {
        labelFa: s?.labelFa || bill.status || "\u2014",
        tone: s?.tone || 'mute'
    };
}
const $cb23cc05191f9c31$export$59a3ccf9224a02d0 = (bill)=>Math.max(0, (Number(bill?.amountRial) || 0) + (Number(bill?.lateFeeRial) || 0) - (Number(bill?.settledRial) || 0));
const $cb23cc05191f9c31$export$30cda6cc6269ba06 = (t)=>[
        {
            key: 'card',
            labelFa: t('operations.billMethods.card')
        },
        {
            key: 'bank_transfer',
            labelFa: t('operations.billMethods.bankTransfer')
        },
        {
            key: 'direct_debit',
            labelFa: t('operations.billMethods.directDebit')
        },
        {
            key: 'cash',
            labelFa: t('operations.billMethods.cash')
        },
        {
            key: 'other',
            labelFa: t('common.state.other')
        }
    ];
const $cb23cc05191f9c31$export$454d7e0b72be399e = (key, t)=>$cb23cc05191f9c31$export$30cda6cc6269ba06(t).find((m)=>m.key === key)?.labelFa || key || "\u2014";
const $cb23cc05191f9c31$export$98143b01d088bf96 = new Set([
    'card',
    'bank_transfer',
    'direct_debit'
]);
const $cb23cc05191f9c31$export$f3e6c205a5f83cb1 = (method)=>$cb23cc05191f9c31$export$98143b01d088bf96.has(method);
const $cb23cc05191f9c31$export$8969a3dd361ad23f = (t)=>[
        {
            key: 'regular',
            labelFa: t('operations.billSubKinds.regular')
        },
        {
            key: 'interim',
            labelFa: t('operations.billSubKinds.interim')
        },
        {
            key: 'correction',
            labelFa: t('operations.billSubKinds.correction')
        },
        {
            key: 'penalty',
            labelFa: t('operations.billSubKinds.penalty')
        }
    ];
const $cb23cc05191f9c31$export$314b0604256e5261 = (key, t)=>$cb23cc05191f9c31$export$8969a3dd361ad23f(t).find((s)=>s.key === key)?.labelFa || '';
/** Kinds with no شناسه قبض to type — the fields are hidden rather than optional. */ const $cb23cc05191f9c31$var$KINDS_WITHOUT_IDENTIFIERS = new Set([
    'rent',
    'service_charge',
    'insurance_premium',
    'other'
]);
const $cb23cc05191f9c31$export$8ce16052fcee4363 = (kind)=>!$cb23cc05191f9c31$var$KINDS_WITHOUT_IDENTIFIERS.has(kind);
const $cb23cc05191f9c31$export$9e213822de2778f7 = (currency)=>(0, $eLeza.isIranMarket)() && (!currency || currency === 'IRR');
const $cb23cc05191f9c31$export$8c125c9d92e45eb3 = (bill)=>!!bill && bill.status !== 'paid' && bill.status !== 'cancelled';
const $cb23cc05191f9c31$export$77522c9f1f9cd3a = (bill, billType)=>{
    if (!bill || bill.status !== 'unpaid') return false;
    if (billType?.requiresAuthorization && !bill.authorizedAt) return false;
    return true;
};
const $cb23cc05191f9c31$export$4f51c5358b8c10bb = (bill)=>bill?.status === 'expected';
function $cb23cc05191f9c31$export$ef333a470e0581ae(ms = Date.now()) {
    const j = (0, $4UJrq.msToJalali)(ms + $cb23cc05191f9c31$var$offsetAt(ms));
    return j ? `${String(j.y).padStart(4, '0')}-${String(j.m).padStart(2, '0')}` : '';
}
function $cb23cc05191f9c31$export$6974f36a78eaac81(key) {
    const [y, m] = String(key || '').split('-');
    const jy = Number(y);
    const jm = Number(m);
    return Number.isFinite(jy) && Number.isFinite(jm) && jm >= 1 && jm <= 12 ? {
        jy: jy,
        jm: jm
    } : null;
}
function $cb23cc05191f9c31$export$2d14dc66f38a5d5f(jy, jm, n) {
    const total = jy * 12 + (jm - 1) + n;
    return {
        jy: Math.floor(total / 12),
        jm: total % 12 + 1
    };
}
function $cb23cc05191f9c31$export$2d11d1ec8504ddf9(key, months = 1, monthNames = []) {
    const p = $cb23cc05191f9c31$export$6974f36a78eaac81(key);
    if (!p) return key || "\u2014";
    const name = (m)=>monthNames[m - 1] || String(m);
    if (months <= 1) return `${name(p.jm)} ${p.jy}`;
    const end = $cb23cc05191f9c31$export$2d14dc66f38a5d5f(p.jy, p.jm, months - 1);
    return end.jy === p.jy ? `${name(p.jm)}\u{2013}${name(end.jm)} ${p.jy}` : `${name(p.jm)} ${p.jy}\u{2013}${name(end.jm)} ${end.jy}`;
}
function $cb23cc05191f9c31$export$98d1ceeb5496cb13(cadence = 'monthly', count = 14, now = Date.now()) {
    const months = $cb23cc05191f9c31$export$a68ca3e495bf4fdb[cadence] || 1;
    const cur = $cb23cc05191f9c31$export$6974f36a78eaac81($cb23cc05191f9c31$export$ef333a470e0581ae(now));
    if (!cur) return [];
    const out = [];
    // One period AHEAD as well: a bill for next month can legitimately arrive early.
    let { jy: jy, jm: jm } = $cb23cc05191f9c31$export$2d14dc66f38a5d5f(cur.jy, cur.jm, months);
    for(let i = 0; i < count; i += 1){
        out.push(`${String(jy).padStart(4, '0')}-${String(jm).padStart(2, '0')}`);
        ({ jy: jy, jm: jm } = $cb23cc05191f9c31$export$2d14dc66f38a5d5f(jy, jm, -months));
    }
    return out;
}
function $cb23cc05191f9c31$export$ad3f99c1896911de(bills, t, formatDate) {
    return (0, $jmEyz.toCsv)([
        t('common.fields.status'),
        t('operations.fields.billType'),
        t('operations.fields.period'),
        t('operations.fields.amountToman'),
        t('operations.fields.lateFeeToman'),
        t('operations.fields.paidToman'),
        t('operations.fields.dueDate'),
        t('operations.fields.billIdentifier'),
        t('operations.fields.paymentIdentifier')
    ], bills.map((b)=>[
            $cb23cc05191f9c31$export$8fc01b5984740769(b, t).labelFa,
            b.billTypeTitle || '',
            b.periodLabel || b.periodKey || '',
            String((0, $1O6TO.toDisplay)(b.amountRial, b.currency) ?? 0),
            String((0, $1O6TO.toDisplay)(b.lateFeeRial, b.currency) ?? 0),
            String((0, $1O6TO.toDisplay)(b.settledRial, b.currency) ?? 0),
            b.dueAt ? $cb23cc05191f9c31$export$14b8c981d4152256(b.dueAt, formatDate) : '',
            // Quoted as text by toCsv, so Excel cannot turn a 13-digit identifier into
            // 1.23457E+12 — which is exactly what it does to a bare long number.
            b.billIdentifier || '',
            b.paymentIdentifier || ''
        ]));
}
function $cb23cc05191f9c31$export$e100f822fb63bc47({ summary: summary, billsDashboard: billsDashboard }) {
    const byCategory = Object.fromEntries((summary?.byCategory || []).map((c)=>[
            c.category,
            Number(c.totalRial) || 0
        ]));
    const hasSummary = !!summary;
    const hasBills = !!billsDashboard;
    return {
        totalRial: hasSummary ? Number(summary.totalRial) || 0 : null,
        // Goods receipts post themselves as consumable expenses, so this is a SLICE of
        // totalRial, not something to add to it. It is also the one figure on this
        // page that belongs to the other one, which is why its card links there.
        purchasesRial: hasSummary ? byCategory.consumable || 0 : null,
        personnelRial: hasSummary ? byCategory.personnel || 0 : null,
        pendingRial: hasSummary ? Number(summary.pendingRial) || 0 : null,
        pendingCount: hasSummary ? Number(summary.pendingCount) || 0 : null,
        // What the clinic owes and has not paid. It replaced «ارزش انبار» when the
        // warehouse left for «کالاها و خدمات»: the page already computed it for the
        // rail badge, and it is the number a manager looks for first.
        overdueCount: hasBills ? Number(billsDashboard.overdueCount) || 0 : null,
        overdueRial: hasBills ? Number(billsDashboard.overdueRial) || 0 : null,
        dueSoonCount: hasBills ? Number(billsDashboard.dueSoonCount) || 0 : null
    };
}
const $cb23cc05191f9c31$export$d714c0091121a304 = (services)=>(services || []).filter((s)=>!s.doctorId);
function $cb23cc05191f9c31$export$5b494a4d3e145f22(services, id) {
    const list = services || [];
    const found = list.find((s)=>s.id === id);
    if (!found?.doctorId) return found || null;
    return list.find((s)=>!s.doctorId && s.catalogId === found.catalogId) || null;
}
function $cb23cc05191f9c31$export$d15374946961f1f1({ inventorySummary: inventorySummary, equipmentAlerts: equipmentAlerts, services: services }) {
    const hasInventory = !!inventorySummary;
    const declared = Array.isArray(services) ? services : null;
    const active = declared?.filter((s)=>s.isActive !== false) || null;
    const unpriced = declared?.filter((s)=>!(Number(s.unitPrice) > 0)) || null;
    return {
        stockValueRial: hasInventory ? Number(inventorySummary.totalValue) || 0 : null,
        lowStockCount: hasInventory ? Number(inventorySummary.lowStockCount) || 0 : null,
        outOfStockCount: hasInventory ? Number(inventorySummary.outOfStockCount) || 0 : null,
        // `null` when the register was never read — which is the case for anybody
        // without `equipment.view`, and is why the card is absent rather than zero.
        equipmentAlertCount: Array.isArray(equipmentAlerts) ? $cb23cc05191f9c31$export$45c573a67b2fe1a6(equipmentAlerts).total : null,
        servicesActiveCount: active ? active.length : null,
        servicesUnpricedCount: unpriced ? unpriced.length : null
    };
}
/**
 * «کالاها و خدمات»'s way to its numbers: the report that answers for the view
 * the person is on, or null when they may not open it (PM-0495).
 *
 * The page carries no stat strip — figures about the shelf, the offer and the
 * devices are a subject of their own and live in «گزارش‌ها» (DESIGN_CONCEPT §2.3.1).
 * The link is the report's own permission, read from the report registry, so a
 * person never gets a link that lands on the overview instead.
 */ const $cb23cc05191f9c31$var$GOODS_REPORTS = {
    items: 'inventory-value',
    expiry: 'inventory-value',
    procurement: 'inventory-value',
    custody: 'inventory-value',
    counts: 'inventory-value',
    locations: 'inventory-value',
    suppliers: 'inventory-value',
    services: 'services',
    equipment: 'equipment',
    equipmentTypes: 'equipment',
    insurance: 'insurance'
};
const $cb23cc05191f9c31$var$GOODS_REPORT_LABEL = {
    'inventory-value': 'goods.reports.inventory',
    services: 'goods.reports.services',
    equipment: 'goods.reports.equipment',
    insurance: 'goods.reports.insurance'
};
function $cb23cc05191f9c31$export$7907d2e5c5625ad2(view, can) {
    const report = $cb23cc05191f9c31$var$GOODS_REPORTS[view];
    const perm = report ? (0, $68yjU.permFor)(report) : null;
    if (!perm) return null;
    const allowed = Array.isArray(perm) ? perm.every((p)=>can(p)) : can(perm);
    return allowed ? {
        view: report,
        labelKey: $cb23cc05191f9c31$var$GOODS_REPORT_LABEL[report]
    } : null;
}
const $cb23cc05191f9c31$export$a6309135d60f374a = (0, (/*@__PURE__*/$parcel$interopDefault($fhoLy)));
function $cb23cc05191f9c31$export$d99df780f94c7fa3(status) {
    return Object.entries($cb23cc05191f9c31$export$a6309135d60f374a.kinds).filter(([, spec])=>!spec.system && spec.from.includes(status)).map(([kind])=>kind);
}
function $cb23cc05191f9c31$export$9b5276ce6629c761(kind) {
    const spec = $cb23cc05191f9c31$export$a6309135d60f374a.kinds[kind] || {};
    if (spec.retire) return 'equipment.retire';
    if (spec.service) return 'equipment.service';
    return 'equipment.manage';
}
const $cb23cc05191f9c31$export$de671d5dfa2cc968 = (kind)=>!!$cb23cc05191f9c31$export$a6309135d60f374a.kinds[kind]?.money;
const $cb23cc05191f9c31$export$1161a63ac4caeb32 = (t)=>[
        {
            key: 'in_service',
            labelFa: t('operations.equipment.status.inService'),
            tone: 'good'
        },
        {
            key: 'under_repair',
            labelFa: t('operations.equipment.status.underRepair'),
            tone: 'danger'
        },
        {
            key: 'idle',
            labelFa: t('operations.equipment.status.idle'),
            tone: 'mute'
        },
        {
            key: 'ordered',
            labelFa: t('operations.equipment.status.ordered'),
            tone: 'info'
        },
        {
            key: 'received',
            labelFa: t('operations.equipment.status.received'),
            tone: 'info'
        },
        {
            key: 'installed',
            labelFa: t('operations.equipment.status.installed'),
            tone: 'info'
        },
        {
            key: 'retired',
            labelFa: t('operations.equipment.status.retired'),
            tone: 'mute'
        },
        {
            key: 'sold',
            labelFa: t('operations.equipment.status.sold'),
            tone: 'mute'
        },
        {
            key: 'scrapped',
            labelFa: t('operations.equipment.status.scrapped'),
            tone: 'mute'
        }
    ];
const $cb23cc05191f9c31$export$242d7ff368bd1fda = (key, t)=>$cb23cc05191f9c31$export$1161a63ac4caeb32(t).find((s)=>s.key === key)?.labelFa || key || "\u2014";
const $cb23cc05191f9c31$export$e899c9d599b3e0ba = (key, t)=>$cb23cc05191f9c31$export$1161a63ac4caeb32(t).find((s)=>s.key === key)?.tone || 'mute';
const $cb23cc05191f9c31$export$f0625c2b6fd6711d = (t)=>[
        {
            key: 'all',
            labelFa: t('common.filters.all'),
            statuses: null
        },
        {
            key: 'active',
            labelFa: t('operations.equipment.filters.active'),
            statuses: [
                'ordered',
                'received',
                'installed',
                'in_service',
                'idle',
                'under_repair'
            ]
        },
        {
            key: 'in_service',
            labelFa: t('operations.equipment.status.inService'),
            statuses: [
                'in_service'
            ]
        },
        {
            key: 'under_repair',
            labelFa: t('operations.equipment.status.underRepair'),
            statuses: [
                'under_repair'
            ]
        },
        {
            key: 'idle',
            labelFa: t('operations.equipment.status.idle'),
            statuses: [
                'idle'
            ]
        },
        {
            key: 'out',
            labelFa: t('operations.equipment.status.retired'),
            statuses: [
                'retired',
                'sold',
                'scrapped'
            ]
        }
    ];
const $cb23cc05191f9c31$export$b2eb1a0bfd083554 = (t)=>({
        purchased: t('operations.equipment.kinds.purchased'),
        received: t('operations.equipment.kinds.received'),
        installed: t('operations.equipment.kinds.installed'),
        commissioned: t('operations.equipment.kinds.commissioned'),
        serviced: t('operations.equipment.kinds.serviced'),
        calibrated: t('operations.equipment.kinds.calibrated'),
        checked: t('operations.equipment.kinds.checked'),
        meter_read: t('operations.equipment.kinds.meterRead'),
        fault_reported: t('operations.equipment.kinds.faultReported'),
        repair_started: t('operations.equipment.kinds.repairStarted'),
        repaired: t('operations.equipment.kinds.repaired'),
        idle: t('operations.equipment.kinds.idle'),
        reactivated: t('operations.equipment.kinds.reactivated'),
        moved: t('operations.equipment.kinds.moved'),
        retired: t('operations.equipment.kinds.retired'),
        sold: t('operations.equipment.kinds.sold'),
        scrapped: t('operations.equipment.kinds.scrapped'),
        depreciated: t('operations.equipment.kinds.depreciated')
    });
const $cb23cc05191f9c31$export$dd9ae63dc3404c40 = (kind, t)=>$cb23cc05191f9c31$export$b2eb1a0bfd083554(t)[kind] || kind || "\u2014";
const $cb23cc05191f9c31$export$f4933b0054029da3 = (kind)=>({
        fault_reported: 'danger',
        repaired: 'good',
        serviced: 'accent',
        calibrated: 'info',
        checked: 'mute',
        commissioned: 'good',
        reactivated: 'good',
        retired: 'mute',
        sold: 'good',
        scrapped: 'mute',
        depreciated: 'mute',
        purchased: 'info',
        installed: 'info',
        received: 'info',
        moved: 'mute',
        idle: 'mute',
        meter_read: 'mute',
        repair_started: 'warn'
    })[kind] || 'mute';
const $cb23cc05191f9c31$export$13c5aebd26424208 = (t)=>[
        {
            key: 'owned',
            labelFa: t('operations.equipment.ownership.owned')
        },
        {
            key: 'rented',
            labelFa: t('operations.equipment.ownership.rented')
        },
        {
            key: 'loaned',
            labelFa: t('operations.equipment.ownership.loaned')
        }
    ];
const $cb23cc05191f9c31$export$691b4a7cacad1894 = (t)=>[
        {
            key: 'critical',
            labelFa: t('operations.equipment.criticality.critical'),
            tone: 'danger'
        },
        {
            key: 'high',
            labelFa: t('operations.equipment.criticality.high'),
            tone: 'warn'
        },
        {
            key: 'medium',
            labelFa: t('operations.equipment.criticality.medium'),
            tone: 'info'
        },
        {
            key: 'low',
            labelFa: t('operations.equipment.criticality.low'),
            tone: 'mute'
        }
    ];
const $cb23cc05191f9c31$export$f98f99024b9b284d = (key, t)=>$cb23cc05191f9c31$export$691b4a7cacad1894(t).find((c)=>c.key === key)?.labelFa || key || "\u2014";
const $cb23cc05191f9c31$export$ea41d202bc631074 = (key, t)=>$cb23cc05191f9c31$export$691b4a7cacad1894(t).find((c)=>c.key === key)?.tone || 'mute';
const $cb23cc05191f9c31$export$c65ce11629564ead = (t)=>[
        {
            key: 'periodic',
            labelFa: t('operations.equipment.planKinds.periodic')
        },
        {
            key: 'calibration',
            labelFa: t('operations.equipment.planKinds.calibration')
        }
    ];
const $cb23cc05191f9c31$export$2c026fcebf30028 = (t)=>[
        {
            key: 'calendar',
            labelFa: t('operations.equipment.triggers.calendar')
        },
        {
            key: 'usage',
            labelFa: t('operations.equipment.triggers.usage')
        },
        {
            key: 'hours',
            labelFa: t('operations.equipment.triggers.hours')
        },
        {
            key: 'whichever_first',
            labelFa: t('operations.equipment.triggers.whicheverFirst')
        }
    ];
const $cb23cc05191f9c31$export$818d30c55c3d17b5 = (key, t)=>$cb23cc05191f9c31$export$2c026fcebf30028(t).find((x)=>x.key === key)?.labelFa || key || "\u2014";
const $cb23cc05191f9c31$export$ef4342fe5c579e2e = (t)=>[
        {
            key: 'warranty',
            labelFa: t('operations.equipment.contractKinds.warranty')
        },
        {
            key: 'service_contract',
            labelFa: t('operations.equipment.contractKinds.serviceContract')
        }
    ];
const $cb23cc05191f9c31$export$813f7986fd8c73c1 = (key, t)=>$cb23cc05191f9c31$export$ef4342fe5c579e2e(t).find((x)=>x.key === key)?.labelFa || key || "\u2014";
const $cb23cc05191f9c31$export$a9efdb6183b63b3 = (t)=>[
        {
            key: 'full',
            labelFa: t('operations.equipment.coverage.full')
        },
        {
            key: 'parts',
            labelFa: t('operations.equipment.coverage.parts')
        },
        {
            key: 'labor',
            labelFa: t('operations.equipment.coverage.labor')
        }
    ];
const $cb23cc05191f9c31$export$14dfda68aeefa147 = (t)=>[
        {
            key: 'straight_line',
            labelFa: t('operations.equipment.depreciation.straightLine')
        },
        {
            key: 'per_use',
            labelFa: t('operations.equipment.depreciation.perUse')
        }
    ];
const $cb23cc05191f9c31$export$8ef7c14ef4bde21f = (t)=>[
        {
            key: 'pass',
            labelFa: t('operations.equipment.check.pass')
        },
        {
            key: 'fail',
            labelFa: t('operations.equipment.check.fail')
        }
    ];
/**
 * The statutory presets («جدول استهلاکات») a clinic picks a type from, so its
 * first action is «انتخاب» rather than «تایپ». Lives here, not in the service:
 * the numbers are defaults the clinic may override per type or per device, and
 * a Persian table in a Python module would be a second copy of copy.
 *
 * `usefulLifeMonths` is the straight-line default; a device the clinic bought
 * second-hand or runs harder overrides it on the device.
 *
 * `clinicTypes` is which «نوع کلینیک» the device belongs to — keys of the
 * clinicmanagement registry (`useClinicTypes`). An eye clinic opening this list
 * wants a slit lamp, not a dental unit; `equipmentPresetsFor` narrows by it.
 */ const $cb23cc05191f9c31$var$PRIMARY_CARE = [
    'general',
    'specialty',
    'internal',
    'pediatric',
    'cardiology'
];
const $cb23cc05191f9c31$var$PROCEDURAL = [
    'general',
    'specialty',
    'dental',
    'ophthalmology',
    'dermatology',
    'pediatric',
    'cardiology',
    'orthopedic',
    'neurology',
    'gynecology',
    'internal',
    'ent',
    'urology',
    'aesthetic'
];
const $cb23cc05191f9c31$var$REHAB = [
    'physiotherapy',
    'rehabilitation',
    'orthopedic'
];
const $cb23cc05191f9c31$var$P = (key, code, i18nKey, usefulLifeMonths, serviceIntervalDays, calibrationIntervalDays, criticality, clinicTypes)=>({
        key: key,
        code: code,
        i18nKey: i18nKey,
        usefulLifeMonths: usefulLifeMonths,
        serviceIntervalDays: serviceIntervalDays,
        needsCalibration: !!calibrationIntervalDays,
        calibrationIntervalDays: calibrationIntervalDays || null,
        criticality: criticality,
        clinicTypes: clinicTypes
    });
const $cb23cc05191f9c31$var$PRESET_TABLE = [
    // Sterilisation and utilities
    $cb23cc05191f9c31$var$P('autoclave', 'AUTOCLAVE', 'autoclave', 120, 180, 365, 'critical', [
        ...$cb23cc05191f9c31$var$PROCEDURAL,
        'laboratory'
    ]),
    $cb23cc05191f9c31$var$P('sterilizer_dry', 'DRY-HEAT', 'dryHeat', 120, 365, 365, 'critical', [
        'general',
        'specialty',
        'dental',
        'dermatology',
        'gynecology',
        'ent',
        'aesthetic'
    ]),
    $cb23cc05191f9c31$var$P('compressor', 'COMPRESSOR', 'compressor', 96, 180, null, 'medium', [
        'dental'
    ]),
    $cb23cc05191f9c31$var$P('suction', 'SUCTION', 'suction', 96, 365, null, 'medium', [
        'general',
        'specialty',
        'dental',
        'pediatric',
        'internal',
        'ent',
        'gynecology',
        'urology'
    ]),
    $cb23cc05191f9c31$var$P('electrocautery', 'CAUTERY', 'electrocautery', 96, 365, 365, 'high', [
        'general',
        'specialty',
        'dermatology',
        'aesthetic',
        'gynecology',
        'ent',
        'urology'
    ]),
    $cb23cc05191f9c31$var$P('cold_storage', 'MED-FRIDGE', 'coldStorage', 96, 365, 365, 'high', [
        'general',
        'specialty',
        'pediatric',
        'internal',
        'pharmacy',
        'laboratory'
    ]),
    // Monitoring and emergency
    $cb23cc05191f9c31$var$P('ecg', 'ECG', 'ecg', 96, 365, 365, 'high', $cb23cc05191f9c31$var$PRIMARY_CARE),
    $cb23cc05191f9c31$var$P('vital_monitor', 'MONITOR', 'vitalMonitor', 96, 365, 365, 'high', [
        ...$cb23cc05191f9c31$var$PRIMARY_CARE,
        'aesthetic'
    ]),
    $cb23cc05191f9c31$var$P('defibrillator', 'AED', 'defibrillator', 96, 180, 365, 'critical', [
        'general',
        'specialty',
        'cardiology',
        'internal',
        'aesthetic'
    ]),
    $cb23cc05191f9c31$var$P('oxygen', 'OXYGEN', 'oxygen', 96, 365, null, 'high', [
        'general',
        'specialty',
        'internal',
        'pediatric',
        'cardiology',
        'dental'
    ]),
    $cb23cc05191f9c31$var$P('nebulizer', 'NEBULIZER', 'nebulizer', 60, 365, null, 'medium', [
        'general',
        'specialty',
        'pediatric',
        'internal',
        'ent'
    ]),
    // Dental
    $cb23cc05191f9c31$var$P('dental_unit', 'DENTAL-UNIT', 'dentalUnit', 120, 180, null, 'high', [
        'dental'
    ]),
    $cb23cc05191f9c31$var$P('dental_xray', 'DENTAL-XRAY', 'dentalXray', 120, 365, 365, 'critical', [
        'dental'
    ]),
    $cb23cc05191f9c31$var$P('light_cure', 'LIGHT-CURE', 'lightCure', 60, 365, 365, 'medium', [
        'dental'
    ]),
    $cb23cc05191f9c31$var$P('scaler', 'SCALER', 'scaler', 60, 365, null, 'medium', [
        'dental'
    ]),
    // Eye
    $cb23cc05191f9c31$var$P('slit_lamp', 'SLIT-LAMP', 'slitLamp', 120, 365, null, 'high', [
        'ophthalmology'
    ]),
    $cb23cc05191f9c31$var$P('autorefractometer', 'AUTOREF', 'autorefractometer', 96, 365, 365, 'high', [
        'ophthalmology'
    ]),
    $cb23cc05191f9c31$var$P('tonometer', 'TONOMETER', 'tonometer', 96, 365, 365, 'high', [
        'ophthalmology'
    ]),
    $cb23cc05191f9c31$var$P('oct', 'OCT', 'oct', 96, 365, 365, 'high', [
        'ophthalmology'
    ]),
    // Skin and aesthetic
    $cb23cc05191f9c31$var$P('laser', 'LASER', 'laser', 60, 180, 365, 'high', [
        'dermatology',
        'aesthetic',
        'ophthalmology',
        'dental'
    ]),
    $cb23cc05191f9c31$var$P('dermatoscope', 'DERMATOSCOPE', 'dermatoscope', 60, 365, null, 'medium', [
        'dermatology',
        'aesthetic'
    ]),
    $cb23cc05191f9c31$var$P('cryotherapy', 'CRYO', 'cryotherapy', 96, 365, null, 'medium', [
        'dermatology',
        'aesthetic'
    ]),
    // Heart
    $cb23cc05191f9c31$var$P('echocardiography', 'ECHO', 'echocardiography', 96, 365, 365, 'high', [
        'cardiology'
    ]),
    $cb23cc05191f9c31$var$P('holter', 'HOLTER', 'holter', 60, 365, 365, 'medium', [
        'cardiology',
        'internal'
    ]),
    $cb23cc05191f9c31$var$P('stress_test', 'TREADMILL', 'stressTest', 96, 180, 365, 'high', [
        'cardiology'
    ]),
    // Nerves and mind
    $cb23cc05191f9c31$var$P('eeg', 'EEG', 'eeg', 96, 365, 365, 'high', [
        'neurology',
        'psychology'
    ]),
    $cb23cc05191f9c31$var$P('emg', 'EMG', 'emg', 96, 365, 365, 'high', [
        'neurology',
        'rehabilitation'
    ]),
    $cb23cc05191f9c31$var$P('neurofeedback', 'NEUROFEEDBACK', 'neurofeedback', 60, 365, null, 'medium', [
        'psychology',
        'neurology'
    ]),
    // Women, ENT, urology
    $cb23cc05191f9c31$var$P('ultrasound', 'ULTRASOUND', 'ultrasound', 96, 365, null, 'medium', [
        'general',
        'specialty',
        'gynecology',
        'internal',
        'urology',
        'radiology'
    ]),
    $cb23cc05191f9c31$var$P('colposcope', 'COLPOSCOPE', 'colposcope', 96, 365, null, 'medium', [
        'gynecology'
    ]),
    $cb23cc05191f9c31$var$P('fetal_doppler', 'FETAL-DOPPLER', 'fetalDoppler', 60, 365, 365, 'medium', [
        'gynecology'
    ]),
    $cb23cc05191f9c31$var$P('endoscope', 'ENDOSCOPE', 'endoscope', 60, 180, null, 'high', [
        'ent',
        'urology',
        'internal'
    ]),
    $cb23cc05191f9c31$var$P('audiometer', 'AUDIOMETER', 'audiometer', 96, 365, 365, 'high', [
        'ent'
    ]),
    $cb23cc05191f9c31$var$P('uroflowmeter', 'UROFLOW', 'uroflowmeter', 96, 365, 365, 'medium', [
        'urology'
    ]),
    // Physiotherapy and rehabilitation
    $cb23cc05191f9c31$var$P('electrotherapy', 'ELECTROTHERAPY', 'electrotherapy', 96, 365, 365, 'medium', $cb23cc05191f9c31$var$REHAB),
    $cb23cc05191f9c31$var$P('therapeutic_ultrasound', 'US-THERAPY', 'therapeuticUltrasound', 96, 365, 365, 'medium', $cb23cc05191f9c31$var$REHAB),
    $cb23cc05191f9c31$var$P('traction', 'TRACTION', 'traction', 120, 365, null, 'medium', $cb23cc05191f9c31$var$REHAB),
    $cb23cc05191f9c31$var$P('shockwave', 'SHOCKWAVE', 'shockwave', 96, 365, 365, 'medium', $cb23cc05191f9c31$var$REHAB),
    // Imaging
    $cb23cc05191f9c31$var$P('imaging', 'IMAGING', 'imaging', 120, 180, 365, 'critical', [
        'radiology',
        'orthopedic'
    ]),
    $cb23cc05191f9c31$var$P('xray', 'XRAY', 'xray', 120, 180, 365, 'critical', [
        'radiology',
        'orthopedic'
    ]),
    $cb23cc05191f9c31$var$P('mammography', 'MAMMO', 'mammography', 120, 180, 365, 'critical', [
        'radiology'
    ]),
    $cb23cc05191f9c31$var$P('ct', 'CT', 'ct', 120, 90, 365, 'critical', [
        'radiology'
    ]),
    $cb23cc05191f9c31$var$P('mri', 'MRI', 'mri', 120, 90, 365, 'critical', [
        'radiology'
    ]),
    // Laboratory
    $cb23cc05191f9c31$var$P('centrifuge', 'CENTRIFUGE', 'centrifuge', 96, 365, 365, 'high', [
        'laboratory'
    ]),
    $cb23cc05191f9c31$var$P('cell_counter', 'CBC', 'cellCounter', 96, 180, 180, 'critical', [
        'laboratory'
    ]),
    $cb23cc05191f9c31$var$P('chemistry_analyzer', 'CHEM', 'chemistryAnalyzer', 96, 180, 180, 'critical', [
        'laboratory'
    ]),
    $cb23cc05191f9c31$var$P('microscope', 'MICROSCOPE', 'microscope', 120, 365, null, 'medium', [
        'laboratory',
        'dermatology'
    ]),
    $cb23cc05191f9c31$var$P('incubator', 'INCUBATOR', 'incubator', 96, 365, 365, 'high', [
        'laboratory'
    ])
];
const $cb23cc05191f9c31$export$1a7a2059f7ab348a = (t)=>$cb23cc05191f9c31$var$PRESET_TABLE.map(({ i18nKey: i18nKey, ...p })=>({
            ...p,
            labelFa: t(`operations.equipment.presets.${i18nKey}`)
        }));
function $cb23cc05191f9c31$export$e38e84e5fe379d1(clinicType, t) {
    const all = $cb23cc05191f9c31$export$1a7a2059f7ab348a(t);
    const matched = clinicType ? all.filter((p)=>p.clinicTypes.includes(clinicType)) : [];
    if (!matched.length) return {
        matched: all,
        others: [],
        filtered: false
    };
    return {
        matched: matched,
        others: all.filter((p)=>!matched.includes(p)),
        filtered: true
    };
}
function $cb23cc05191f9c31$export$45f4380d3043bcc8(e, t, formatDigits = (n)=>n) {
    if (!e) return {
        labelFa: "\u2014",
        tone: 'mute'
    };
    if (e.status === 'under_repair') {
        const days = Number(e.daysUnderRepair) || 0;
        return {
            labelFa: days ? t('operations.equipment.status.underRepairFor', {
                days: formatDigits(days)
            }) : t('operations.equipment.status.underRepair'),
            tone: 'danger'
        };
    }
    return {
        labelFa: $cb23cc05191f9c31$export$242d7ff368bd1fda(e.status, t),
        tone: $cb23cc05191f9c31$export$e899c9d599b3e0ba(e.status, t)
    };
}
function $cb23cc05191f9c31$export$e28bfc425ce85a98(e, t, formatDigits = (n)=>n) {
    if (!e) return null;
    if (e.alertSeverity === 'overdue') return {
        labelFa: t('operations.equipment.due.overdue'),
        tone: 'danger'
    };
    if (e.nextDueAt) {
        const days = Math.floor((Number(e.nextDueAt) - Date.now()) / $cb23cc05191f9c31$var$DAY);
        if (days <= 0) return {
            labelFa: t('operations.equipment.due.today'),
            tone: 'warn'
        };
        return {
            labelFa: t('operations.equipment.due.inDays', {
                days: formatDigits(days)
            }),
            tone: e.alertSeverity === 'due_soon' ? 'warn' : 'mute'
        };
    }
    if (e.nextDueUses != null) return {
        labelFa: t('operations.equipment.due.afterUses', {
            uses: formatDigits(Math.max(e.nextDueUses, 0))
        }),
        tone: e.alertSeverity === 'due_soon' ? 'warn' : 'mute'
    };
    return null;
}
const $cb23cc05191f9c31$export$37e3f34d0687480e = (t)=>({
        service_due: t('operations.equipment.alerts.serviceDue'),
        calibration_due: t('operations.equipment.alerts.calibrationDue'),
        contract_expiring: t('operations.equipment.alerts.contractExpiring'),
        wear_part: t('operations.equipment.alerts.wearPart'),
        under_repair: t('operations.equipment.status.underRepair'),
        return_due: t('operations.equipment.alerts.returnDue')
    });
const $cb23cc05191f9c31$export$bbc2d6b7c40eac13 = (kind, t)=>$cb23cc05191f9c31$export$37e3f34d0687480e(t)[kind] || kind || '';
function $cb23cc05191f9c31$export$9d25530073c655bb(alert, t, formatDigits = (n)=>n) {
    if (!alert) return '';
    const where = alert.room ? ` ${alert.room}` : '';
    const who = `${alert.equipmentName}${where}`;
    if (alert.kind === 'under_repair') return t('operations.equipment.alerts.sentenceRepair', {
        who: who
    });
    if (alert.kind === 'wear_part') return alert.severity === 'overdue' ? t('operations.equipment.alerts.sentenceWearDue', {
        who: who
    }) : t('operations.equipment.alerts.sentenceWearSoon', {
        who: who,
        uses: formatDigits(Math.max(alert.usesLeft || 0, 0))
    });
    const what = $cb23cc05191f9c31$export$bbc2d6b7c40eac13(alert.kind, t);
    if (alert.severity === 'overdue') return t('operations.equipment.alerts.sentenceOverdue', {
        what: what,
        who: who,
        days: formatDigits(Math.abs(alert.daysLeft || 0))
    });
    if (alert.daysLeft != null) return t('operations.equipment.alerts.sentenceDueSoon', {
        what: what,
        who: who,
        days: formatDigits(Math.max(alert.daysLeft, 0))
    });
    if (alert.usesLeft != null) return t('operations.equipment.alerts.sentenceDueUses', {
        what: what,
        who: who,
        uses: formatDigits(Math.max(alert.usesLeft, 0))
    });
    return `${what} \xb7 ${who}`;
}
function $cb23cc05191f9c31$export$45c573a67b2fe1a6(alerts = []) {
    const out = {
        overdue: 0,
        dueSoon: 0,
        underRepair: 0,
        total: 0
    };
    for (const a of alerts){
        if (a.kind === 'under_repair') out.underRepair += 1;
        else if (a.severity === 'overdue') out.overdue += 1;
        else if (a.severity === 'due_soon') out.dueSoon += 1;
    }
    out.total = out.overdue + out.dueSoon + out.underRepair;
    return out;
}
function $cb23cc05191f9c31$export$e69647e0ddc238c1(rows, t, formatDate) {
    return (0, $jmEyz.toCsv)([
        t('operations.fields.code'),
        t('operations.equipment.entity'),
        t('common.fields.type'),
        t('operations.equipment.fields.room'),
        t('common.fields.status'),
        t('operations.equipment.fields.nextService'),
        t('operations.equipment.fields.calibration'),
        t('operations.equipment.fields.criticality'),
        t('operations.equipment.fields.regulatoryId'),
        t('operations.equipment.fields.purchasePriceToman')
    ], rows.map((e)=>[
            e.code,
            e.name,
            e.typeName || '',
            e.room || '',
            $cb23cc05191f9c31$export$242d7ff368bd1fda(e.status, t),
            e.nextDueAt ? $cb23cc05191f9c31$export$14b8c981d4152256(e.nextDueAt, formatDate) : '',
            e.calibrationDueAt ? $cb23cc05191f9c31$export$14b8c981d4152256(e.calibrationDueAt, formatDate) : '',
            $cb23cc05191f9c31$export$f98f99024b9b284d(e.criticality, t),
            e.regulatoryId || '',
            String((0, $1O6TO.toDisplay)(e.purchasePriceRial, e.currency) ?? 0)
        ]));
}

});
parcelRegister("j7Rqy", function(module, exports) {

$parcel$export(module.exports, "gStrStart", () => $dec81d525012b4fe$export$7ae4e0f9ad244996);
$parcel$export(module.exports, "gStrEnd", () => $dec81d525012b4fe$export$cebf74efb444b1ea);
$parcel$export(module.exports, "toGStr", () => $dec81d525012b4fe$export$dd406c1fcd009e84);
$parcel$export(module.exports, "RANGE_PRESETS", () => $dec81d525012b4fe$export$5f37411c4bafeb65);
$parcel$export(module.exports, "PRESET_IDS", () => $dec81d525012b4fe$export$1b97b3aaba94652f);
$parcel$export(module.exports, "gregorianBooks", () => $dec81d525012b4fe$export$72b4297a48776642);
$parcel$export(module.exports, "monthStartMs", () => $dec81d525012b4fe$export$2daf648e3af7a874);
$parcel$export(module.exports, "resolveRange", () => $dec81d525012b4fe$export$91fff1052285fb6d);
$parcel$export(module.exports, "bucketFor", () => $dec81d525012b4fe$export$323e0a97c92fe112);
$parcel$export(module.exports, "foldBuckets", () => $dec81d525012b4fe$export$f50382fc564c2597);
// The date window, for every screen that has one.
//
// Promoted here because there were already TWO implementations — `Payments.shared.js`
// (`RANGE_PRESETS`/`presetRange`, ids `today|week|month|all`) and
// `Operations.shared.js` (`DATE_PRESETS`/`presetRange`, keys `today|7d|month|all`) —
// which disagreed about what «این هفته» means and computed the Jalali month start
// two different ways. A third copy for the reports module would have made the same
// filter name three different windows in one app, and both older screens now import
// from here so there is one answer.
//
// Everything is computed on the **clinic's wall clock** (`clinicZone.js`, PM-0088)
// on the **Jalali calendar**. Both halves matter: «این ماه» is a Jalali month
// beginning at the CLINIC's midnight — Tehran's for a Tehran clinic, Baghdad's for a
// Baghdad one — and a `new Date().setHours(0,0,0,0)` opens the day at the BROWSER's
// midnight, so takings near midnight fall out of «امروز» or leak into it.
//
// A BRAND on the Gregorian calendar (`calendar: 'gregory'`, docs/rebranding/
// CONTRACT.md) keeps Gregorian books: there «این ماه» / "this month" is the
// Gregorian month, «امسال» the Gregorian year, and a folded bucket a Gregorian
// month — the same clinic clock, the other calendar. Without one, nothing below
// moves: `calendarOf`/`calendarStartMs` ARE the Jalali conversions they replaced.

var $eLeza = parcelRequire("eLeza");
parcelRequire("dNNpt");
var $4UJrq = parcelRequire("4UJrq");

var $5qKOB = parcelRequire("5qKOB");
const $dec81d525012b4fe$export$fa2e89afea4272f6 = 86400000;
function $dec81d525012b4fe$export$63fa379ae8a9ba2(ts) {
    return (0, $5qKOB.clinicDayStart)(ts);
}
const $dec81d525012b4fe$export$eb9a03f0e9aa6cea = (ts)=>(0, $5qKOB.clinicDayEnd)(ts);
const $dec81d525012b4fe$var$pad2 = (n)=>String(n).padStart(2, '0');
function $dec81d525012b4fe$export$7ae4e0f9ad244996(s) {
    const [y, m, d] = String(s || '').split('-').map(Number);
    if (!y || !m || !d) return NaN;
    return (0, $5qKOB.wallToMs)(`${y}-${$dec81d525012b4fe$var$pad2(m)}-${$dec81d525012b4fe$var$pad2(d)}`, 0);
}
function $dec81d525012b4fe$export$cebf74efb444b1ea(s) {
    const start = $dec81d525012b4fe$export$7ae4e0f9ad244996(s);
    return Number.isNaN(start) ? NaN : $dec81d525012b4fe$export$eb9a03f0e9aa6cea(start);
}
function $dec81d525012b4fe$export$dd406c1fcd009e84(ts) {
    return (0, $5qKOB.isoDayOf)(ts);
}
const $dec81d525012b4fe$export$5f37411c4bafeb65 = (t)=>[
        {
            id: 'today',
            label: t('common.dates.today')
        },
        {
            id: 'week',
            label: t('reports.range.week')
        },
        {
            id: 'month',
            label: t('reports.range.month')
        },
        {
            id: 'lastMonth',
            label: t('reports.range.lastMonth')
        },
        {
            id: '3m',
            label: t('reports.range.threeMonths')
        },
        {
            id: 'year',
            label: t('reports.range.year')
        },
        {
            id: 'custom',
            label: t('reports.range.custom')
        }
    ];
const $dec81d525012b4fe$export$1b97b3aaba94652f = [
    'today',
    'week',
    'month',
    'lastMonth',
    '3m',
    'year',
    'custom'
];
function $dec81d525012b4fe$export$42c81a444fbfb5d4(ts) {
    const iso = (0, $5qKOB.isoDayOf)(ts);
    const dow = new Date(`${iso}T12:00:00Z`).getUTCDay();
    return (0, $5qKOB.wallToMs)((0, $5qKOB.addDaysIso)(iso, -((dow + 1) % 7)), 0);
}
/**
 * The Jalali calendar, read on the CLINIC's clock (Tehran's until PM-0088).
 *
 * `msToJalali`/`jalaliToMs` in the kit work off a UTC anchor: they read an instant
 * as the UTC calendar day it falls in, and return UTC midnight of the day they are
 * given. That is the kit's documented convention — `iranNow()` is `Date.now() +
 * IRAN_OFFSET_MS` read with `getUTC*` — and using the pair raw here shifted every
 * Jalali boundary in this file by three and a half hours: «این ماه» opened at 03:30
 * on the first, «ماه قبل» ended at 03:30 on the first of THIS month (counting the
 * small hours of the wrong month), and `foldBuckets` — which converts a Tehran
 * midnight — read every day as the one before it, so the first day of a Jalali month
 * folded into the previous month's bucket.
 *
 * Shifting on the way in and back out on the way out is the whole correction, and it
 * belongs here rather than in each call site: there were eleven of them.
 */ const $dec81d525012b4fe$var$jalaliOf = (ts)=>(0, $4UJrq.msToJalali)(ts + (0, $5qKOB.zoneOffsetMs)(ts));
const $dec81d525012b4fe$var$jalaliStartMs = (jy, jm, jd)=>(0, $5qKOB.wallToMs)(new Date((0, $4UJrq.jalaliToMs)(jy, jm, jd)).toISOString().slice(0, 10), 0);
const $dec81d525012b4fe$export$72b4297a48776642 = ()=>(0, $eLeza.calendarSystem)('jalali') === 'gregory';
/** An instant → `{ y, m, d }` on the clinic's clock, in the clinic's calendar. */ function $dec81d525012b4fe$var$calendarOf(ts) {
    if (!$dec81d525012b4fe$export$72b4297a48776642()) return $dec81d525012b4fe$var$jalaliOf(ts);
    const [y, m, d] = (0, $5qKOB.isoDayOf)(ts).split('-').map(Number);
    return {
        y: y,
        m: m,
        d: d
    };
}
/** The clinic's midnight of a date in the clinic's calendar. */ function $dec81d525012b4fe$var$calendarStartMs(y, m, d) {
    return $dec81d525012b4fe$export$72b4297a48776642() ? (0, $5qKOB.wallToMs)(`${y}-${$dec81d525012b4fe$var$pad2(m)}-${$dec81d525012b4fe$var$pad2(d)}`, 0) : $dec81d525012b4fe$var$jalaliStartMs(y, m, d);
}
function $dec81d525012b4fe$export$2daf648e3af7a874(now = Date.now()) {
    const j = $dec81d525012b4fe$var$calendarOf(now);
    return $dec81d525012b4fe$var$calendarStartMs(j.y, j.m, 1);
}
/** Twelve months a year in both calendars, so month arithmetic is the same. */ function $dec81d525012b4fe$var$addMonths(y, m, delta) {
    const total = y * 12 + (m - 1) + delta;
    return {
        y: Math.floor(total / 12),
        m: total % 12 + 1
    };
}
function $dec81d525012b4fe$export$c1d4212a2686aaff(id, now = Date.now()) {
    const j = $dec81d525012b4fe$var$calendarOf(now);
    switch(id){
        case 'today':
            return {
                fromTs: $dec81d525012b4fe$export$63fa379ae8a9ba2(now),
                toTs: now
            };
        case 'week':
            return {
                fromTs: $dec81d525012b4fe$export$42c81a444fbfb5d4(now),
                toTs: now
            };
        case 'lastMonth':
            {
                const prev = $dec81d525012b4fe$var$addMonths(j.y, j.m, -1);
                return {
                    fromTs: $dec81d525012b4fe$var$calendarStartMs(prev.y, prev.m, 1),
                    toTs: $dec81d525012b4fe$var$calendarStartMs(j.y, j.m, 1) - 1
                };
            }
        case '3m':
            {
                const back = $dec81d525012b4fe$var$addMonths(j.y, j.m, -2);
                return {
                    fromTs: $dec81d525012b4fe$var$calendarStartMs(back.y, back.m, 1),
                    toTs: now
                };
            }
        case 'year':
            return {
                fromTs: $dec81d525012b4fe$var$calendarStartMs(j.y, 1, 1),
                toTs: now
            };
        case 'month':
        default:
            return {
                fromTs: $dec81d525012b4fe$var$calendarStartMs(j.y, j.m, 1),
                toTs: now
            };
    }
}
function $dec81d525012b4fe$export$91fff1052285fb6d(preset, from, to, now = Date.now()) {
    if (preset === 'custom') {
        const a = $dec81d525012b4fe$export$7ae4e0f9ad244996(from);
        const b = $dec81d525012b4fe$export$cebf74efb444b1ea(to);
        if (!Number.isFinite(a) || !Number.isFinite(b)) return $dec81d525012b4fe$export$c1d4212a2686aaff('month', now);
        return a <= b ? {
            fromTs: a,
            toTs: b
        } : {
            fromTs: $dec81d525012b4fe$export$7ae4e0f9ad244996(to),
            toTs: $dec81d525012b4fe$export$cebf74efb444b1ea(from)
        };
    }
    return $dec81d525012b4fe$export$c1d4212a2686aaff($dec81d525012b4fe$export$1b97b3aaba94652f.includes(preset) ? preset : 'month', now);
}
function $dec81d525012b4fe$export$323e0a97c92fe112({ fromTs: fromTs, toTs: toTs }) {
    const days = Math.ceil((toTs - fromTs) / $dec81d525012b4fe$export$fa2e89afea4272f6);
    if (days <= 45) return 'day';
    if (days <= 130) return 'week';
    return 'month';
}
function $dec81d525012b4fe$export$f50382fc564c2597(rows, bucket, sum = []) {
    if (!rows?.length || bucket === 'day') return rows || [];
    const out = new Map();
    for (const row of rows){
        const ts = $dec81d525012b4fe$export$7ae4e0f9ad244996(row.day || row.key);
        if (!Number.isFinite(ts)) continue;
        const j = $dec81d525012b4fe$var$calendarOf(ts);
        const key = bucket === 'month' ? `${j.y}-${String(j.m).padStart(2, '0')}` : `${j.y}-${String(j.m).padStart(2, '0')}-w${Math.ceil(j.d / 7)}`;
        const slot = out.get(key);
        if (!slot) out.set(key, {
            ...row,
            day: key,
            _from: ts,
            _jalali: j,
            _bucket: bucket
        });
        else for (const field of sum)slot[field] = (slot[field] || 0) + (row[field] || 0);
    }
    return [
        ...out.values()
    ];
}
function $dec81d525012b4fe$export$84316ae541f49165(preset, window, now = Date.now()) {
    const span = window.toTs - window.fromTs;
    const j = $dec81d525012b4fe$var$calendarOf(now);
    switch(preset){
        case 'today':
            {
                const start = (0, $5qKOB.wallToMs)((0, $5qKOB.addDaysIso)((0, $5qKOB.isoDayOf)(now), -1), 0);
                return {
                    fromTs: start,
                    toTs: start + span
                };
            }
        case 'week':
            {
                const start = (0, $5qKOB.wallToMs)((0, $5qKOB.addDaysIso)((0, $5qKOB.isoDayOf)($dec81d525012b4fe$export$42c81a444fbfb5d4(now)), -7), 0);
                return {
                    fromTs: start,
                    toTs: start + span
                };
            }
        case 'month':
            {
                const prev = $dec81d525012b4fe$var$addMonths(j.y, j.m, -1);
                const start = $dec81d525012b4fe$var$calendarStartMs(prev.y, prev.m, 1);
                return {
                    fromTs: start,
                    toTs: start + span
                };
            }
        case 'lastMonth':
            {
                const prev = $dec81d525012b4fe$var$addMonths(j.y, j.m, -2);
                const next = $dec81d525012b4fe$var$addMonths(prev.y, prev.m, 1);
                return {
                    fromTs: $dec81d525012b4fe$var$calendarStartMs(prev.y, prev.m, 1),
                    toTs: $dec81d525012b4fe$var$calendarStartMs(next.y, next.m, 1) - 1
                };
            }
        case '3m':
            {
                const back = $dec81d525012b4fe$var$addMonths(j.y, j.m, -5);
                const start = $dec81d525012b4fe$var$calendarStartMs(back.y, back.m, 1);
                return {
                    fromTs: start,
                    toTs: start + span
                };
            }
        case 'year':
            {
                const start = $dec81d525012b4fe$var$calendarStartMs(j.y - 1, 1, 1);
                return {
                    fromTs: start,
                    toTs: start + span
                };
            }
        default:
            return {
                fromTs: window.fromTs - span - 1,
                toTs: window.fromTs - 1
            };
    }
}

});

parcelRegister("fhoLy", function(module, exports) {
module.exports = JSON.parse('{"$comment":"The equipment status machine (docs/CLINIC_EQUIPMENT_MANAGEMENT_DESIGN.md \xa7C). ONE copy per repository, byte-identical: app/domain/equipment_transitions.json in the warehousing service and src/constants/equipmentTransitions.json in the clinic client. The service DECIDES; the client only greys buttons. `dev/check-equipment-transitions.sh` compares them, like the proto copies.","statuses":["ordered","received","installed","in_service","idle","under_repair","retired","sold","scrapped"],"active_statuses":["ordered","received","installed","in_service","idle","under_repair"],"kinds":{"purchased":{"from":["ordered"],"to":null,"money":true},"received":{"from":["ordered"],"to":"received"},"installed":{"from":["received"],"to":"installed","money":true},"commissioned":{"from":["received","installed"],"to":"in_service"},"serviced":{"from":["in_service","idle"],"to":null,"money":true,"service":true},"calibrated":{"from":["in_service","idle"],"to":null,"money":true,"service":true},"checked":{"from":["in_service","idle"],"to":null,"service":true},"meter_read":{"from":["in_service","idle","under_repair"],"to":null,"service":true},"fault_reported":{"from":["in_service","idle"],"to":"under_repair"},"repair_started":{"from":["under_repair"],"to":null},"repaired":{"from":["under_repair"],"to":"in_service","money":true},"idle":{"from":["in_service"],"to":"idle"},"reactivated":{"from":["idle"],"to":"in_service"},"moved":{"from":["received","installed","in_service","idle","under_repair"],"to":null},"retired":{"from":["received","installed","in_service","idle","under_repair"],"to":"retired","retire":true},"sold":{"from":["retired"],"to":"sold","money":true,"retire":true},"scrapped":{"from":["retired"],"to":"scrapped","retire":true},"depreciated":{"from":["in_service","idle","under_repair"],"to":null,"money":true,"system":true}}}');

});

parcelRegister("68yjU", function(module, exports) {

$parcel$export(module.exports, "OVERVIEW", () => $477e1cb787e3cd3f$export$9cbb0f231a0ab7ea);
$parcel$export(module.exports, "permFor", () => $477e1cb787e3cd3f$export$bfe390e8ab7b9874);
$parcel$export(module.exports, "visibleRail", () => $477e1cb787e3cd3f$export$90bd3a8757b6e5be);
$parcel$export(module.exports, "VIEW_META", () => $477e1cb787e3cd3f$export$55a991242032f64a);
$parcel$export(module.exports, "FILTER_SCHEMAS", () => $477e1cb787e3cd3f$export$a8c7a179a2583653);
$parcel$export(module.exports, "STATIC_OPTIONS", () => $477e1cb787e3cd3f$export$4d7d8ff231b57ed2);
$parcel$export(module.exports, "parseParams", () => $477e1cb787e3cd3f$export$ef804106d1571703);
$parcel$export(module.exports, "serializeParams", () => $477e1cb787e3cd3f$export$7ca73062a3ed781f);
$parcel$export(module.exports, "activeFilterCount", () => $477e1cb787e3cd3f$export$ab72d5afd544f97d);
$parcel$export(module.exports, "computeInsights", () => $477e1cb787e3cd3f$export$6826d416ea0d8e0e);
$parcel$export(module.exports, "EMPTY_ICON", () => $477e1cb787e3cd3f$export$1628350cec985bc6);
$parcel$export(module.exports, "groupOfView", () => $477e1cb787e3cd3f$export$8d33583691e7052c);
$parcel$export(module.exports, "bucketFor", () => (parcelRequire("j7Rqy")).bucketFor);
$parcel$export(module.exports, "foldBuckets", () => (parcelRequire("j7Rqy")).foldBuckets);
/**
 * «گزارش‌ها» — the vocabulary, the structure and the derivations both surfaces share.
 *
 * Design: docs/CLINIC_REPORTS_REDESIGN.md. The desktop workbench and the mobile
 * reduction render nothing alike, and that is the doctrine (clinic-app/CLAUDE.md
 * §4.1). What they must never do is disagree about which reports exist, who may see
 * one, what question it answers, or which filters it takes — so all of that lives
 * here and is imported by both.
 *
 * Nothing in this file renders. No React, no JSX, no tokens.
 */ 
var $7KqRH = parcelRequire("7KqRH");

var $j7Rqy = parcelRequire("j7Rqy");
const $477e1cb787e3cd3f$export$f6c354a527f4818f = (t)=>[
        {
            key: 'finance',
            labelFa: t('reports.rail.groups.finance'),
            items: [
                {
                    key: 'pnl',
                    perm: 'reports.finance.view'
                },
                {
                    key: 'revenue',
                    perm: 'reports.finance.view'
                },
                {
                    key: 'collections',
                    perm: 'reports.finance.view'
                },
                {
                    key: 'expenses',
                    perm: 'reports.finance.view'
                },
                {
                    key: 'receivables',
                    perm: 'reports.finance.view'
                },
                {
                    key: 'shifts',
                    perm: [
                        'reports.finance.view',
                        'cashier.view'
                    ]
                },
                {
                    key: 'bills',
                    perm: 'reports.finance.view'
                }
            ]
        },
        {
            key: 'practitioners',
            labelFa: t('reports.rail.groups.practitioners'),
            items: [
                {
                    key: 'practitioners',
                    perm: 'reports.view'
                },
                {
                    key: 'practitioner-finance',
                    perm: [
                        'reports.finance.view',
                        'doctors.view'
                    ]
                }
            ]
        },
        {
            key: 'patients',
            labelFa: t('reports.rail.groups.patients'),
            items: [
                {
                    key: 'patients',
                    perm: 'reports.view'
                },
                {
                    key: 'patient-value',
                    perm: 'reports.finance.view'
                },
                {
                    key: 'followups',
                    perm: [
                        'reports.view',
                        'patients.view'
                    ]
                }
            ]
        },
        {
            key: 'services',
            labelFa: t('reports.rail.groups.services'),
            items: [
                {
                    key: 'services',
                    perm: 'reports.view'
                }
            ]
        },
        {
            key: 'appointments',
            labelFa: t('reports.rail.groups.appointments'),
            items: [
                {
                    key: 'appointments',
                    perm: 'reports.view'
                },
                {
                    key: 'peak-times',
                    perm: 'reports.view'
                },
                {
                    key: 'capacity',
                    perm: 'reports.view'
                }
            ]
        },
        {
            key: 'insurance',
            labelFa: t('reports.rail.groups.insurance'),
            items: [
                {
                    key: 'insurance',
                    perm: 'reports.finance.view'
                }
            ]
        },
        {
            key: 'inventory',
            labelFa: t('reports.rail.groups.inventory'),
            items: [
                {
                    key: 'inventory-value',
                    perm: [
                        'reports.view',
                        'inventory.view'
                    ]
                },
                {
                    key: 'consumption',
                    perm: [
                        'reports.view',
                        'inventory.view'
                    ]
                },
                {
                    key: 'stock-movements',
                    perm: [
                        'reports.view',
                        'inventory.view'
                    ]
                }
            ]
        },
        {
            key: 'equipment',
            labelFa: t('reports.rail.groups.equipment'),
            items: [
                {
                    key: 'equipment',
                    perm: [
                        'reports.view',
                        'equipment.view'
                    ]
                }
            ]
        }
    ];
const $477e1cb787e3cd3f$export$9cbb0f231a0ab7ea = 'overview';
const $477e1cb787e3cd3f$var$ALL_VIEWS = $477e1cb787e3cd3f$export$f6c354a527f4818f((k)=>k).flatMap((g)=>g.items);
const $477e1cb787e3cd3f$export$88b3856d82763646 = [
    $477e1cb787e3cd3f$export$9cbb0f231a0ab7ea,
    ...$477e1cb787e3cd3f$var$ALL_VIEWS.map((v)=>v.key)
];
const $477e1cb787e3cd3f$export$bfe390e8ab7b9874 = (viewKey)=>$477e1cb787e3cd3f$var$ALL_VIEWS.find((v)=>v.key === viewKey)?.perm ?? null;
const $477e1cb787e3cd3f$var$satisfies = (can, perm)=>Array.isArray(perm) ? perm.every((p)=>can(p)) : can(perm);
function $477e1cb787e3cd3f$export$90bd3a8757b6e5be(can, t) {
    return $477e1cb787e3cd3f$export$f6c354a527f4818f(t).map((g)=>({
            ...g,
            items: g.items.filter((i)=>$477e1cb787e3cd3f$var$satisfies(can, i.perm))
        })).filter((g)=>g.items.length);
}
function $477e1cb787e3cd3f$export$85b4e0f374ef171(requested, can) {
    if (!requested || requested === $477e1cb787e3cd3f$export$9cbb0f231a0ab7ea) return $477e1cb787e3cd3f$export$9cbb0f231a0ab7ea;
    const perm = $477e1cb787e3cd3f$export$bfe390e8ab7b9874(requested);
    if (perm && $477e1cb787e3cd3f$var$satisfies(can, perm)) return requested;
    return $477e1cb787e3cd3f$export$9cbb0f231a0ab7ea;
}
const $477e1cb787e3cd3f$export$55a991242032f64a = (t)=>({
        overview: {
            title: t('reports.views.overview.title'),
            question: t('reports.views.overview.question'),
            range: true,
            compare: true
        },
        pnl: {
            title: t('reports.views.pnl.title'),
            question: t('reports.views.pnl.question'),
            range: true,
            compare: true
        },
        revenue: {
            title: t('reports.views.revenue.title'),
            question: t('reports.views.revenue.question'),
            range: true,
            compare: true
        },
        collections: {
            title: t('reports.views.collections.title'),
            question: t('reports.views.collections.question'),
            range: true,
            compare: true
        },
        expenses: {
            title: t('reports.views.expenses.title'),
            question: t('reports.views.expenses.question'),
            range: true,
            compare: true
        },
        receivables: {
            title: t('reports.views.receivables.title'),
            question: t('reports.views.receivables.question'),
            range: false,
            compare: false
        },
        shifts: {
            title: t('reports.views.shifts.title'),
            question: t('reports.views.shifts.question'),
            range: true,
            compare: false,
            defaultRange: 'week'
        },
        bills: {
            title: t('reports.views.bills.title'),
            question: t('reports.views.bills.question'),
            range: true,
            compare: false,
            defaultRange: 'year'
        },
        practitioners: {
            title: t('reports.views.practitioners.title'),
            question: t('reports.views.practitioners.question'),
            range: true,
            compare: true
        },
        'practitioner-finance': {
            title: t('reports.views.practitionerFinance.title'),
            question: t('reports.views.practitionerFinance.question'),
            range: true,
            compare: true
        },
        patients: {
            title: t('reports.views.patients.title'),
            question: t('reports.views.patients.question'),
            range: true,
            compare: true
        },
        'patient-value': {
            title: t('reports.views.patientValue.title'),
            question: t('reports.views.patientValue.question'),
            range: true,
            compare: false
        },
        followups: {
            title: t('reports.views.followups.title'),
            question: t('reports.views.followups.question'),
            range: true,
            compare: false
        },
        services: {
            title: t('reports.views.services.title'),
            question: t('reports.views.services.question'),
            range: true,
            compare: true
        },
        appointments: {
            title: t('reports.views.appointments.title'),
            question: t('reports.views.appointments.question'),
            range: true,
            compare: true
        },
        'peak-times': {
            title: t('reports.views.peakTimes.title'),
            question: t('reports.views.peakTimes.question'),
            range: true,
            compare: false
        },
        capacity: {
            title: t('reports.views.capacity.title'),
            question: t('reports.views.capacity.question'),
            range: true,
            compare: true
        },
        insurance: {
            title: t('reports.views.insurance.title'),
            question: t('reports.views.insurance.question'),
            range: true,
            compare: true
        },
        'inventory-value': {
            title: t('reports.views.inventoryValue.title'),
            question: t('reports.views.inventoryValue.question'),
            range: false,
            compare: false
        },
        consumption: {
            title: t('reports.views.consumption.title'),
            question: t('reports.views.consumption.question'),
            range: true,
            compare: true
        },
        'stock-movements': {
            title: t('reports.views.stockMovements.title'),
            question: t('reports.views.stockMovements.question'),
            range: true,
            compare: true
        },
        equipment: {
            title: t('reports.views.equipment.title'),
            question: t('reports.views.equipment.question'),
            range: true,
            compare: true
        }
    });
// ── Filters ──────────────────────────────────────────────────────────────────
//
// One schema per report, read by BOTH the desktop filter row and the mobile sheet,
// so the two cannot offer different filters for the same report — which is exactly
// what happens when each surface builds its own controls.
//
//   control  'select' | 'segment' | 'search' | 'money' | 'date'
//   source   which option list the screen must load ('doctors', 'services', …)
//   primary  shown in the desktop row; the rest go behind «فیلترهای بیشتر»
const $477e1cb787e3cd3f$var$GROUP_BY = (key, options)=>({
        key: 'group',
        control: 'segment',
        labelKey: 'reports.filters.groupBy',
        options: options,
        primary: true,
        urlKey: 'group',
        default: options[0]
    });
const $477e1cb787e3cd3f$export$a8c7a179a2583653 = {
    overview: [],
    pnl: [
        // `optionLabelKey`: these two are a BASIS, not a grouping — «تعهدی» and «نقدی»
        // live under `reports.basis.*`, which is also where the footnote reads them.
        {
            key: 'basis',
            control: 'segment',
            labelKey: 'reports.filters.basis',
            options: [
                'accrual',
                'cash'
            ],
            optionLabelKey: 'reports.basis',
            primary: true,
            default: 'accrual'
        }
    ],
    revenue: [
        $477e1cb787e3cd3f$var$GROUP_BY('group', [
            'day',
            'doctor',
            'service',
            'kind',
            'insurer'
        ]),
        {
            key: 'doctor',
            control: 'select',
            source: 'doctors',
            labelKey: 'reports.filters.doctor',
            primary: true
        },
        {
            key: 'kind',
            control: 'select',
            source: 'itemTypes',
            labelKey: 'reports.filters.itemType'
        },
        {
            key: 'insurer',
            control: 'select',
            source: 'insurers',
            labelKey: 'reports.filters.insurer'
        }
    ],
    collections: [
        $477e1cb787e3cd3f$var$GROUP_BY('group', [
            'day',
            'method',
            'cashier',
            'doctor'
        ]),
        {
            key: 'method',
            control: 'select',
            source: 'methods',
            labelKey: 'reports.filters.method',
            primary: true
        },
        {
            key: 'cashier',
            control: 'select',
            source: 'cashiers',
            labelKey: 'reports.filters.cashier'
        },
        {
            key: 'doctor',
            control: 'select',
            source: 'doctors',
            labelKey: 'reports.filters.doctor'
        }
    ],
    expenses: [
        $477e1cb787e3cd3f$var$GROUP_BY('group', [
            'category',
            'source',
            'costCenter',
            'payee',
            'day'
        ]),
        {
            key: 'category',
            control: 'select',
            source: 'expenseCategories',
            labelKey: 'reports.filters.category',
            primary: true
        },
        {
            key: 'cc',
            control: 'select',
            source: 'costCentres',
            labelKey: 'reports.filters.costCenter',
            primary: true
        },
        {
            key: 'source',
            control: 'select',
            source: 'expenseSources',
            labelKey: 'reports.filters.source'
        },
        {
            key: 'approval',
            control: 'select',
            source: 'approvals',
            labelKey: 'reports.filters.approval'
        }
    ],
    receivables: [
        {
            key: 'bucket',
            control: 'segment',
            source: 'ageBuckets',
            labelKey: 'reports.filters.bucket',
            primary: true
        },
        {
            key: 'q',
            control: 'search',
            labelKey: 'reports.filters.search',
            primary: true
        },
        {
            key: 'doctor',
            control: 'select',
            source: 'doctors',
            labelKey: 'reports.filters.doctor'
        },
        {
            key: 'min',
            control: 'money',
            labelKey: 'reports.filters.minAmount'
        },
        {
            key: 'asOf',
            control: 'date',
            labelKey: 'reports.range.asOfDate'
        }
    ],
    shifts: [
        {
            key: 'cashier',
            control: 'select',
            source: 'cashiers',
            labelKey: 'reports.filters.cashier',
            primary: true
        },
        {
            key: 'status',
            control: 'select',
            source: 'shiftStatuses',
            labelKey: 'reports.filters.status',
            primary: true
        }
    ],
    bills: [],
    practitioners: [
        {
            key: 'profession',
            control: 'select',
            source: 'professions',
            labelKey: 'reports.filters.profession',
            primary: true
        },
        {
            key: 'doctor',
            control: 'select',
            source: 'doctors',
            labelKey: 'reports.filters.doctor',
            primary: true
        },
        {
            key: 'service',
            control: 'select',
            source: 'services',
            labelKey: 'reports.filters.service'
        }
    ],
    'practitioner-finance': [
        {
            key: 'doctor',
            control: 'select',
            source: 'doctors',
            labelKey: 'reports.filters.doctor',
            primary: true
        },
        {
            key: 'status',
            control: 'select',
            source: 'earningStatuses',
            labelKey: 'reports.filters.status',
            primary: true
        }
    ],
    patients: [
        {
            key: 'doctor',
            control: 'select',
            source: 'doctors',
            labelKey: 'reports.filters.doctor',
            primary: true
        },
        {
            key: 'via',
            control: 'select',
            source: 'registeredVia',
            labelKey: 'reports.filters.registeredVia'
        }
    ],
    'patient-value': [
        {
            key: 'q',
            control: 'search',
            labelKey: 'reports.filters.search',
            primary: true
        },
        {
            key: 'doctor',
            control: 'select',
            source: 'doctors',
            labelKey: 'reports.filters.doctor',
            primary: true
        },
        {
            key: 'min',
            control: 'money',
            labelKey: 'reports.filters.minAmount'
        }
    ],
    followups: [
        {
            key: 'status',
            control: 'segment',
            source: 'followUpStatuses',
            labelKey: 'reports.filters.status',
            primary: true
        },
        {
            key: 'assignee',
            control: 'select',
            source: 'staff',
            labelKey: 'reports.filters.assignee',
            primary: true
        },
        {
            key: 'kind',
            control: 'select',
            source: 'followUpKinds',
            labelKey: 'reports.filters.kind'
        }
    ],
    services: [
        {
            key: 'sort',
            control: 'segment',
            source: 'serviceSorts',
            labelKey: 'reports.filters.sortBy',
            primary: true
        },
        {
            key: 'serviceCat',
            control: 'select',
            source: 'serviceCategories',
            labelKey: 'reports.filters.serviceCategory',
            primary: true
        },
        {
            key: 'doctor',
            control: 'select',
            source: 'doctors',
            labelKey: 'reports.filters.doctor'
        },
        {
            key: 'insurer',
            control: 'select',
            source: 'insurers',
            labelKey: 'reports.filters.insurer'
        }
    ],
    appointments: [
        $477e1cb787e3cd3f$var$GROUP_BY('group', [
            'day',
            'provider',
            'status',
            'type'
        ]),
        {
            key: 'doctor',
            control: 'select',
            source: 'providers',
            labelKey: 'reports.filters.provider',
            primary: true
        },
        {
            key: 'mode',
            control: 'select',
            source: 'schedulingModes',
            labelKey: 'reports.filters.mode'
        },
        {
            key: 'type',
            control: 'select',
            source: 'appointmentTypes',
            labelKey: 'reports.filters.type'
        }
    ],
    'peak-times': [
        {
            key: 'metric',
            control: 'segment',
            source: 'peakMetrics',
            labelKey: 'reports.filters.metric',
            primary: true
        },
        {
            key: 'doctor',
            control: 'select',
            source: 'providers',
            labelKey: 'reports.filters.provider',
            primary: true
        }
    ],
    capacity: [
        {
            key: 'doctor',
            control: 'select',
            source: 'doctors',
            labelKey: 'reports.filters.doctor',
            primary: true
        }
    ],
    insurance: [
        $477e1cb787e3cd3f$var$GROUP_BY('group', [
            'insurer',
            'doctor',
            'service'
        ]),
        {
            key: 'insurer',
            control: 'select',
            source: 'insurers',
            labelKey: 'reports.filters.insurer',
            primary: true
        },
        {
            key: 'kind',
            control: 'select',
            source: 'insurerKinds',
            labelKey: 'reports.filters.insurerKind'
        },
        {
            key: 'claimStatus',
            control: 'select',
            source: 'claimStatuses',
            labelKey: 'reports.filters.claimStatus'
        },
        {
            key: 'doctor',
            control: 'select',
            source: 'doctors',
            labelKey: 'reports.filters.doctor'
        }
    ],
    'inventory-value': [
        {
            key: 'tab',
            control: 'segment',
            source: 'inventoryTabs',
            labelKey: 'reports.filters.view',
            primary: true
        },
        {
            key: 'itemCat',
            control: 'select',
            source: 'itemCategories',
            labelKey: 'reports.filters.itemCategory'
        }
    ],
    consumption: [
        $477e1cb787e3cd3f$var$GROUP_BY('group', [
            'item',
            'service',
            'performer',
            'day'
        ]),
        {
            key: 'itemCat',
            control: 'select',
            source: 'itemCategories',
            labelKey: 'reports.filters.itemCategory',
            primary: true
        },
        {
            key: 'item',
            control: 'select',
            source: 'items',
            labelKey: 'reports.filters.item'
        }
    ],
    'stock-movements': [
        {
            key: 'mtype',
            control: 'select',
            source: 'movementTypes',
            labelKey: 'reports.filters.movementType',
            primary: true
        },
        {
            key: 'item',
            control: 'select',
            source: 'items',
            labelKey: 'reports.filters.item',
            primary: true
        }
    ],
    equipment: [
        {
            key: 'status',
            control: 'select',
            source: 'equipmentStatuses',
            labelKey: 'reports.filters.status',
            primary: true
        },
        {
            key: 'criticality',
            control: 'select',
            source: 'criticalities',
            labelKey: 'reports.filters.criticality'
        }
    ]
};
const $477e1cb787e3cd3f$export$4d7d8ff231b57ed2 = (t)=>({
        // Cost centres are a PLATFORM vocabulary, not a per-clinic list, so they belong
        // with the static options rather than in the lazy filter fetch: there is nothing
        // to load, and nothing that can be «not yet defined»
        // (docs/CLINIC_COST_CENTER_AUTO_MAPPING_DESIGN.md).
        costCentres: (0, $7KqRH.costCenterOptions)(t).map(({ value: value, label: label })=>({
                id: value,
                label: label
            })),
        itemTypes: [
            {
                id: 'visit',
                label: t('reports.itemTypes.visit')
            },
            {
                id: 'medical_service',
                label: t('reports.itemTypes.medicalService')
            },
            {
                id: 'product',
                label: t('reports.itemTypes.product')
            },
            // «هزینهٔ لغو/عدم حضور» — the no-show fee's FINAL invoice line (PM-0657 C5).
            {
                id: 'fee',
                label: t('reports.itemTypes.fee')
            }
        ],
        methods: [
            {
                id: 'cash',
                label: t('accounting.methods.cash')
            },
            {
                id: 'card',
                label: t('accounting.methods.card')
            },
            {
                id: 'online',
                label: t('accounting.methods.online')
            },
            {
                id: 'bank_transfer',
                label: t('reports.methods.bankTransfer')
            },
            {
                id: 'third_party',
                label: t('reports.methods.thirdParty')
            },
            {
                id: 'credit',
                label: t('reports.methods.credit')
            }
        ],
        // Mirrors EXPENSE_CATEGORIES in the accounting service's app/domain/expenses.py.
        expenseCategories: [
            {
                id: 'personnel',
                label: t('operations.expenseCategories.payroll')
            },
            {
                id: 'operating',
                label: t('operations.expenseCategories.operating')
            },
            {
                id: 'equipment',
                label: t('operations.expenseCategories.equipment')
            },
            {
                id: 'consumable',
                label: t('operations.expenseCategories.consumables')
            },
            {
                id: 'depreciation',
                label: t('operations.expenseCategories.depreciation')
            },
            {
                id: 'marketing',
                label: t('operations.expenseCategories.marketing')
            },
            {
                id: 'other',
                label: t('common.state.other')
            }
        ],
        // Mirrors EXPENSE_SOURCES in the same module. This is where «قبوض», «تعمیرات» and
        // «سرویس دوره‌ای» actually live — they are SOURCES of an expense, not categories,
        // which is why the P&L nests them one level under the category.
        expenseSources: [
            {
                id: 'manual',
                label: t('reports.expenseSources.manual')
            },
            {
                id: 'recurring',
                label: t('reports.expenseSources.recurring')
            },
            {
                id: 'bill_payment',
                label: t('reports.expenseSources.billPayment')
            },
            {
                id: 'inventory_purchase',
                label: t('reports.expenseSources.inventoryPurchase')
            },
            {
                id: 'inventory_withdrawal',
                label: t('reports.expenseSources.inventoryWithdrawal')
            },
            {
                id: 'equipment_purchase',
                label: t('reports.expenseSources.equipmentPurchase')
            },
            {
                id: 'equipment_service',
                label: t('reports.expenseSources.equipmentService')
            },
            {
                id: 'equipment_repair',
                label: t('reports.expenseSources.equipmentRepair')
            },
            {
                id: 'hr_payroll',
                label: t('reports.expenseSources.payroll')
            },
            {
                id: 'depreciation_accrual',
                label: t('reports.expenseSources.depreciation')
            }
        ],
        approvals: [
            {
                id: 'approved',
                label: t('reports.approvals.approved')
            },
            {
                id: 'pending',
                label: t('reports.approvals.pending')
            }
        ],
        ageBuckets: [
            {
                id: '',
                label: t('common.filters.all')
            },
            {
                id: '0-30',
                label: t('reports.ageBuckets.b0')
            },
            {
                id: '31-60',
                label: t('reports.ageBuckets.b31')
            },
            {
                id: '61-90',
                label: t('reports.ageBuckets.b61')
            },
            {
                id: '90+',
                label: t('reports.ageBuckets.b90')
            }
        ],
        shiftStatuses: [
            {
                id: 'open',
                label: t('reports.shiftStatuses.open')
            },
            {
                id: 'closed',
                label: t('reports.shiftStatuses.closed')
            }
        ],
        earningStatuses: [
            {
                id: 'accrued',
                label: t('reports.earningStatuses.accrued')
            },
            {
                id: 'realized',
                label: t('reports.earningStatuses.realized')
            },
            {
                id: 'settled',
                label: t('reports.earningStatuses.settled')
            }
        ],
        followUpStatuses: [
            {
                id: '',
                label: t('common.filters.all')
            },
            {
                id: 'open',
                label: t('reports.followUpStatuses.open')
            },
            {
                id: 'done',
                label: t('reports.followUpStatuses.done')
            }
        ],
        serviceSorts: [
            {
                id: 'count',
                label: t('reports.serviceSorts.popular')
            },
            {
                id: 'net',
                label: t('reports.serviceSorts.topRevenue')
            },
            {
                id: 'worst',
                label: t('reports.serviceSorts.lowPerforming')
            },
            {
                id: 'margin',
                label: t('reports.serviceSorts.topMargin')
            }
        ],
        schedulingModes: [
            {
                id: 'timed',
                label: t('reports.schedulingModes.timed')
            },
            {
                id: 'queue',
                label: t('reports.schedulingModes.queue')
            }
        ],
        appointmentTypes: [
            {
                id: 'in_person',
                label: t('reports.appointmentTypes.inPerson')
            },
            {
                id: 'online',
                label: t('reports.appointmentTypes.online')
            },
            {
                id: 'medical_service',
                label: t('reports.itemTypes.medicalService')
            }
        ],
        peakMetrics: [
            {
                id: 'booked',
                label: t('reports.peakMetrics.booked')
            },
            {
                id: 'completed',
                label: t('reports.peakMetrics.completed')
            },
            {
                id: 'arrived',
                label: t('reports.peakMetrics.arrived')
            }
        ],
        insurerKinds: [
            {
                id: 'basic',
                label: t('reports.insurerKinds.basic')
            },
            {
                id: 'supplementary',
                label: t('reports.insurerKinds.supplementary')
            }
        ],
        claimStatuses: [
            {
                id: 'draft',
                label: t('insurance.claimStatus.draft')
            },
            {
                id: 'submitted',
                label: t('insurance.claimStatus.submitted')
            },
            {
                id: 'accepted',
                label: t('insurance.claimStatus.accepted')
            },
            {
                id: 'paid',
                label: t('insurance.claimStatus.paid')
            },
            {
                id: 'partially_paid',
                label: t('insurance.claimStatus.partiallyPaid')
            },
            {
                id: 'rejected',
                label: t('insurance.claimStatus.rejected')
            },
            {
                id: 'written_off',
                label: t('insurance.claimStatus.writtenOff')
            }
        ],
        inventoryTabs: [
            {
                id: 'value',
                label: t('reports.inventoryTabs.value')
            },
            {
                id: 'low',
                label: t('reports.inventoryTabs.low')
            },
            {
                id: 'expiry',
                label: t('reports.inventoryTabs.expiry')
            }
        ],
        movementTypes: [
            {
                id: 'RECEIVE',
                label: t('reports.movementTypes.receive')
            },
            {
                id: 'CONSUMPTION',
                label: t('reports.movementTypes.consumption')
            },
            {
                id: 'SALE',
                label: t('reports.movementTypes.sale')
            },
            {
                id: 'DISPOSAL',
                label: t('reports.movementTypes.disposal')
            },
            {
                id: 'ADJUSTMENT',
                label: t('reports.movementTypes.adjustment')
            }
        ],
        equipmentStatuses: [
            {
                id: 'in_service',
                label: t('reports.equipmentStatuses.inService')
            },
            {
                id: 'under_repair',
                label: t('reports.equipmentStatuses.underRepair')
            },
            {
                id: 'retired',
                label: t('reports.equipmentStatuses.retired')
            }
        ],
        criticalities: [
            {
                id: 'high',
                label: t('reports.criticalities.high')
            },
            {
                id: 'medium',
                label: t('reports.criticalities.medium')
            },
            {
                id: 'low',
                label: t('reports.criticalities.low')
            }
        ],
        professions: [
            {
                id: 'physician',
                label: t('reports.professions.physician')
            },
            {
                id: 'dentist',
                label: t('reports.professions.dentist')
            },
            {
                id: 'physiotherapist',
                label: t('reports.professions.physiotherapist')
            },
            {
                id: 'psychologist',
                label: t('reports.professions.psychologist')
            }
        ],
        registeredVia: [
            {
                id: 'QR_INVITATION',
                label: t('reports.registeredVia.qr')
            },
            {
                id: 'RECEPTION',
                label: t('reports.registeredVia.reception')
            }
        ],
        followUpKinds: [
            {
                id: 'call',
                label: t('reports.followUpKinds.call')
            },
            {
                id: 'visit',
                label: t('reports.followUpKinds.visit')
            },
            {
                id: 'other',
                label: t('common.state.other')
            }
        ]
    });
// ── URL codec ────────────────────────────────────────────────────────────────
//
// The URL is the state (design §2 rule 7). A bookmarked report reopens identically,
// and the browser's back button steps through view changes rather than through every
// keystroke in a filter — which is why the surfaces PUSH a view change and REPLACE
// everything else.
const $477e1cb787e3cd3f$var$RESERVED = new Set([
    'view',
    'range',
    'from',
    'to',
    'cmp',
    'sort',
    'dir',
    'page'
]);
function $477e1cb787e3cd3f$export$ef804106d1571703(search, can) {
    const p = new URLSearchParams(search);
    const view = $477e1cb787e3cd3f$export$85b4e0f374ef171(p.get('view'), can);
    const meta = $477e1cb787e3cd3f$export$55a991242032f64a((k)=>k)[view] || {};
    const preset = (0, $j7Rqy.PRESET_IDS).includes(p.get('range')) ? p.get('range') : meta.defaultRange || 'month';
    const filters = {};
    for (const spec of $477e1cb787e3cd3f$export$a8c7a179a2583653[view] || []){
        const urlKey = spec.urlKey || spec.key;
        const raw = p.get(urlKey);
        if (raw !== null && raw !== '') filters[spec.key] = raw;
        else if (spec.default !== undefined) filters[spec.key] = spec.default;
    }
    return {
        view: view,
        preset: preset,
        from: p.get('from') || null,
        to: p.get('to') || null,
        // Comparison defaults ON for reports that support it: the number a clinic acts
        // on is «۱۲٪ بیشتر از ماه قبل», not «۴۸۰ میلیون» on its own.
        compare: meta.compare !== false && p.get('cmp') !== '0',
        sort: p.get('sort') || null,
        dir: p.get('dir') === 'asc' ? 'asc' : 'desc',
        page: Math.max(1, Number(p.get('page')) || 1),
        filters: filters
    };
}
function $477e1cb787e3cd3f$export$7ca73062a3ed781f(state) {
    const p = new URLSearchParams();
    if (state.view && state.view !== $477e1cb787e3cd3f$export$9cbb0f231a0ab7ea) p.set('view', state.view);
    if (state.preset && state.preset !== 'month') p.set('range', state.preset);
    if (state.preset === 'custom') {
        if (state.from) p.set('from', state.from);
        if (state.to) p.set('to', state.to);
    }
    if (state.compare === false) p.set('cmp', '0');
    for (const [k, v] of Object.entries(state.filters || {}))if (v !== null && v !== undefined && v !== '' && !$477e1cb787e3cd3f$var$RESERVED.has(k)) p.set(k, String(v));
    if (state.sort) {
        p.set('sort', state.sort);
        p.set('dir', state.dir || 'desc');
    }
    if (state.page && state.page > 1) p.set('page', String(state.page));
    return p.toString();
}
function $477e1cb787e3cd3f$export$ab72d5afd544f97d(view, filters) {
    const schema = $477e1cb787e3cd3f$export$a8c7a179a2583653[view] || [];
    return schema.filter((s)=>{
        const value = filters?.[s.key];
        if (value === undefined || value === null || value === '') return false;
        return value !== s.default;
    }).length;
}
const $477e1cb787e3cd3f$export$2c92ad586c049ff1 = {
    goodMargin: 20,
    expenseSurge: 15,
    revenueFlat: 5,
    categoryDominates: 50,
    categoryRise: 25,
    lowCollection: 70,
    oldDebtShare: 30,
    topDoctorShare: 60,
    highCancelRate: 20,
    unusedServices: 3,
    longWait: 30,
    lowUtilization: 50,
    highShortfall: 10
};
const $477e1cb787e3cd3f$var$T = $477e1cb787e3cd3f$export$2c92ad586c049ff1;
const $477e1cb787e3cd3f$var$up = (d)=>d?.pct ?? null;
function $477e1cb787e3cd3f$export$6826d416ea0d8e0e(view, data) {
    if (!data) return [];
    const out = [];
    const push = (key, tone, values)=>out.push({
            key: key,
            tone: tone,
            values: values
        });
    if (view === 'pnl' || view === 'overview') {
        const f = view === 'overview' ? data.finance : data;
        if (!f) return [];
        const margin = f.marginPct;
        const net = f.netResult?.current ?? 0;
        if (net < 0) push('P2', 'warning', {
            amount: Math.abs(net)
        });
        else if (f.hasMargin && margin >= $477e1cb787e3cd3f$var$T.goodMargin) push('P1', 'info', {
            margin: margin
        });
        const expenseDelta = $477e1cb787e3cd3f$var$up(f.expenses);
        const revenueDelta = $477e1cb787e3cd3f$var$up(f.netRevenue);
        if (expenseDelta !== null && revenueDelta !== null && expenseDelta >= $477e1cb787e3cd3f$var$T.expenseSurge && revenueDelta < $477e1cb787e3cd3f$var$T.revenueFlat) push('P3', 'warning', {
            delta: expenseDelta
        });
    }
    if (view === 'pnl') {
        const expenses = data.expenses?.current || 0;
        const top = (data.lines || []).filter((l)=>l.kind === 'expense' && l.level === 1).sort((a, b)=>b.current - a.current)[0];
        if (top && expenses && top.current / expenses * 100 >= $477e1cb787e3cd3f$var$T.categoryDominates) push('P4', 'info', {
            category: top.key
        });
    }
    if (view === 'revenue') {
        const d = $477e1cb787e3cd3f$var$up(data.netRevenue);
        if (d !== null && Math.round(d) !== 0) push('R1', 'info', {
            delta: d,
            rising: d > 0
        });
        const share = data.netRevenue?.current ? data.insuranceShare.current / data.netRevenue.current * 100 : 0;
        if (share >= 40) push('R2', 'info', {
            share: share
        });
    }
    if (view === 'collections' && data.collectionRatio?.current != null) {
        if (data.collectionRatio.current < $477e1cb787e3cd3f$var$T.lowCollection) push('C1', 'warning', {
            ratio: data.collectionRatio.current
        });
    }
    if (view === 'expenses') {
        const top = (data.rows || [])[0];
        if (top?.deltaPct != null && top.deltaPct >= $477e1cb787e3cd3f$var$T.categoryRise) push('E1', 'warning', {
            category: top.label || top.key,
            delta: top.deltaPct
        });
    }
    if (view === 'receivables' && data.total) {
        const share = data.overNinety / data.total * 100;
        if (share >= $477e1cb787e3cd3f$var$T.oldDebtShare) push('A1', 'warning', {
            share: share
        });
    }
    if (view === 'practitioners') {
        const rows = data.rows || [];
        const total = rows.reduce((s, r)=>s + (r.net || 0), 0);
        const top = rows[0];
        if (total && top?.net && top.net / total * 100 >= $477e1cb787e3cd3f$var$T.topDoctorShare) push('D1', 'info', {
            name: top.name,
            share: top.net / total * 100
        });
        const risky = rows.find((r)=>r.cancelRate >= $477e1cb787e3cd3f$var$T.highCancelRate);
        if (risky) push('D2', 'warning', {
            name: risky.name,
            rate: risky.cancelRate
        });
    }
    if (view === 'services' && data.unusedCount >= $477e1cb787e3cd3f$var$T.unusedServices) push('S1', 'info', {
        count: data.unusedCount
    });
    if (view === 'appointments' && (data.avgWait?.current ?? 0) >= $477e1cb787e3cd3f$var$T.longWait) push('V1', 'warning', {
        minutes: data.avgWait.current
    });
    if (view === 'capacity' && (data.utilizationPct?.current ?? 100) < $477e1cb787e3cd3f$var$T.lowUtilization) push('K1', 'warning', {
        pct: data.utilizationPct.current
    });
    if (view === 'insurance' && data.claimed?.current) {
        const share = data.shortfall.current / data.claimed.current * 100;
        if (share >= $477e1cb787e3cd3f$var$T.highShortfall) push('I1', 'warning', {
            share: share
        });
    }
    if (view === 'inventory-value' && data.lowStockCount > 0) push('N1', 'warning', {
        count: data.lowStockCount
    });
    return out.slice(0, 3);
}
const $477e1cb787e3cd3f$export$1628350cec985bc6 = {
    finance: 'ReceiptText',
    practitioners: 'Stethoscope',
    patients: 'Users',
    services: 'ClipboardList',
    appointments: 'CalendarDays',
    insurance: 'ShieldCheck',
    inventory: 'Package',
    equipment: 'Wrench'
};
function $477e1cb787e3cd3f$export$8d33583691e7052c(view) {
    const group = $477e1cb787e3cd3f$export$f6c354a527f4818f((k)=>k).find((g)=>g.items.some((i)=>i.key === view));
    return group?.key || 'finance';
}

});
parcelRegister("7KqRH", function(module, exports) {

$parcel$export(module.exports, "costCenterLabel", () => $5a41ab1e6e893366$export$6ef199667938f4e9);
$parcel$export(module.exports, "costCenterOptions", () => $5a41ab1e6e893366$export$9c4c9a2826aa2fab);
$parcel$export(module.exports, "previewCostCenterForCategory", () => $5a41ab1e6e893366$export$f12a7c6178921592);
$parcel$export(module.exports, "originLabel", () => $5a41ab1e6e893366$export$b0c4fd215b5002d2);
/**
 * Cost centres — the client's read-only half of a system-managed dimension.
 *
 * docs/CLINIC_COST_CENTER_AUTO_MAPPING_DESIGN.md.
 *
 * Nobody defines, picks or edits a cost centre. Every expense declares where it
 * arose — an origin domain and an origin event — and the accounting service derives
 * the centre from that pair plus the nature-of-cost category, at write time, on a
 * row that is never rewritten afterwards.
 *
 * This module exists for two jobs, and neither of them decides anything:
 *
 *   1. LABELS — turning the codes that come back on an expense, a report row or a
 *      P&L line into «تأمین و خرید». Exactly what `categoryLabel` does for
 *      categories; the centre is one more closed vocabulary, not a lookup table.
 *   2. PREVIEW — showing the person filling in a form which centre their row will
 *      land in, as they change the category, BEFORE they save. Without it the
 *      automatic mapping would be invisible and would read as data going missing.
 *
 * `costCenterMap.json` is byte-identical to the accounting service's own
 * `app/domain/cost_center_map.json` (`make cost-center-map-check`), because a drifted
 * copy would promise one centre on the form and file another in the ledger — and
 * nothing would fail.
 *
 * The SERVICE decides. A preview that disagrees with the row that comes back is a
 * bug in this file, never a reason to send a centre: there is no field to send one in.
 */ 
var $dJlac = parcelRequire("dJlac");
const $5a41ab1e6e893366$export$f7c226106d41ee4d = 'expenses';
const $5a41ab1e6e893366$export$8961b5c31104821b = Object.keys((0, (/*@__PURE__*/$parcel$interopDefault($dJlac))).cost_centers);
const $5a41ab1e6e893366$var$RULES = (0, (/*@__PURE__*/$parcel$interopDefault($dJlac))).rules.map((rule)=>{
    const [domain, ...rest] = String(rule.origin).split('.');
    const event = rest.join('.');
    const wildcard = event.endsWith('*');
    return {
        domain: domain,
        prefix: wildcard ? event.slice(0, -1) : event,
        wildcard: wildcard,
        category: rule.category ?? null,
        costCenter: rule.cost_center
    };
});
function $5a41ab1e6e893366$export$6ef199667938f4e9(key, t) {
    if (!key) return '';
    const translated = t ? t(`operations.costCenters.${key}`) : null;
    if (translated && translated !== `operations.costCenters.${key}`) return translated;
    return (0, (/*@__PURE__*/$parcel$interopDefault($dJlac))).cost_centers[key]?.fa || key;
}
const $5a41ab1e6e893366$export$9c4c9a2826aa2fab = (t)=>$5a41ab1e6e893366$export$8961b5c31104821b.map((key)=>({
            value: key,
            label: $5a41ab1e6e893366$export$6ef199667938f4e9(key, t)
        }));
function $5a41ab1e6e893366$export$24bac7e1cf9dd54b(domain, event, category) {
    let best = null;
    let bestScore = null;
    for (const rule of $5a41ab1e6e893366$var$RULES){
        if (rule.domain !== domain) continue;
        if (rule.wildcard ? !String(event).startsWith(rule.prefix) : event !== rule.prefix) continue;
        if (rule.category !== null && rule.category !== category) continue;
        const score = [
            rule.wildcard ? 0 : 1,
            rule.prefix.length,
            rule.category !== null ? 1 : 0
        ];
        if (!bestScore || score > bestScore) {
            best = rule.costCenter;
            bestScore = score;
        }
    }
    return best;
}
const $5a41ab1e6e893366$export$f12a7c6178921592 = (category)=>$5a41ab1e6e893366$export$24bac7e1cf9dd54b($5a41ab1e6e893366$export$f7c226106d41ee4d, 'manual', category);
function $5a41ab1e6e893366$export$b0c4fd215b5002d2(domain, event, t) {
    if (!domain || !event) return '';
    const key = `operations.origins.${domain}.${event}`;
    const translated = t ? t(key) : null;
    if (translated && translated !== key) return translated;
    // A bill's event is «bill.<kind>»; fall back to the domain's own label rather
    // than printing a dotted machine key at a person.
    const domainKey = `operations.origins.${domain}._`;
    const fallback = t ? t(domainKey) : null;
    return fallback && fallback !== domainKey ? fallback : `${domain}.${event}`;
}

});
parcelRegister("dJlac", function(module, exports) {
module.exports = JSON.parse('{"version":1,"cost_centers":{"hr":{"fa":"\u0645\u0646\u0627\u0628\u0639 \u0627\u0646\u0633\u0627\u0646\u06CC","en":"Human resources"},"procurement":{"fa":"\u062A\u0623\u0645\u06CC\u0646 \u0648 \u062E\u0631\u06CC\u062F","en":"Procurement"},"equipment":{"fa":"\u062A\u062C\u0647\u06CC\u0632\u0627\u062A","en":"Equipment"},"admin":{"fa":"\u0627\u062F\u0627\u0631\u06CC","en":"Administration"},"marketing":{"fa":"\u0628\u0627\u0632\u0627\u0631\u06CC\u0627\u0628\u06CC","en":"Marketing"},"medical_services":{"fa":"\u062E\u062F\u0645\u0627\u062A \u067E\u0632\u0634\u06A9\u06CC","en":"Medical services"}},"origins":{"expenses":["manual","recurring"],"people":["payroll"],"inventory":["purchase","supplier_return"],"equipment":["purchase","install","service","calibration","repair","depreciation"],"clinic":["bill.electricity","bill.water","bill.gas","bill.landline","bill.mobile","bill.internet","bill.municipality","bill.tax","bill.insurance_premium","bill.rent","bill.service_charge","bill.other"],"marketing":["campaign"],"medical_services":["consumption","side_cost"]},"rules":[{"origin":"people.payroll","cost_center":"hr"},{"origin":"inventory.purchase","cost_center":"procurement"},{"origin":"inventory.supplier_return","cost_center":"procurement"},{"origin":"equipment.*","cost_center":"equipment"},{"origin":"clinic.bill.*","cost_center":"admin"},{"origin":"marketing.campaign","cost_center":"marketing"},{"origin":"medical_services.*","cost_center":"medical_services"},{"origin":"expenses.*","category":"personnel","cost_center":"hr"},{"origin":"expenses.*","category":"operating","cost_center":"admin"},{"origin":"expenses.*","category":"equipment","cost_center":"equipment"},{"origin":"expenses.*","category":"consumable","cost_center":"procurement"},{"origin":"expenses.*","category":"depreciation","cost_center":"equipment"},{"origin":"expenses.*","category":"marketing","cost_center":"marketing"},{"origin":"expenses.*","category":"other","cost_center":"admin"}]}');

});



parcelRegister("6PcIc", function(module, exports) {

$parcel$export(module.exports, "EXPENSES_VIEWS", () => $4f815dcbee26bb40$export$9d057af351d5189b);
$parcel$export(module.exports, "GOODS_VIEWS", () => $4f815dcbee26bb40$export$869f89992a039b5);
$parcel$export(module.exports, "isAccountingView", () => $4f815dcbee26bb40$export$653b77da3717056b);
$parcel$export(module.exports, "STORE_VIEWS", () => $4f815dcbee26bb40$export$bc265c801ebc72c0);
$parcel$export(module.exports, "isStoreView", () => $4f815dcbee26bb40$export$f22e3bd01c21cd84);
$parcel$export(module.exports, "pageForView", () => $4f815dcbee26bb40$export$47ab4d46d3d1d567);
$parcel$export(module.exports, "isGoodsView", () => $4f815dcbee26bb40$export$ae543ed59ff9f99b);
/**
 * Which `?view=` belongs to which page — the routing half of the 2026-09-12
 * split of «عملیات و هزینه» into «مدیریت هزینه‌ها» and «کالاها و خدمات»
 * (docs/CLINIC_EXPENSES_AND_GOODS_SPLIT_DESIGN.md).
 *
 * **Why this is its own module.** Three EAGER consumers need this fact before
 * any screen chunk loads: the router's moved-view guard (`App.jsx`), the
 * pre-chunk skeleton registry (`screens/skeletons.jsx`), and the rail
 * definitions themselves (`screens/Operations/Operations.shared.js`). The rails
 * are the natural place to DECLARE a destination, but that module is ~1400
 * lines of vocabulary, money helpers, Jalali arithmetic and the equipment state
 * machine — pulling it into the entry bundle to answer "which page owns
 * `items`?" would make every first paint pay for the answer.
 *
 * So the two key lists live here, with no imports at all, and the rails are
 * checked against them. One source, and the check is a test rather than a
 * review: `Operations.shared.test.js` asserts each rail's keys are exactly the
 * list below, in order — a destination added to a rail and forgotten here (or
 * the reverse) fails immediately instead of producing a view that renders but
 * cannot be linked to.
 *
 * Nothing here is user-facing. A URL has no language, so there is no `t`.
 */ /** «مدیریت هزینه‌ها» — money out, and the definitions that classify it. */ const $4f815dcbee26bb40$export$42c04508fd5e94e2 = '/operations';
const $4f815dcbee26bb40$export$445df4e4e163ee21 = '/goods';
const $4f815dcbee26bb40$export$9d057af351d5189b = [
    'expenses',
    'bills',
    'recurring',
    'billTypes'
];
const $4f815dcbee26bb40$export$869f89992a039b5 = [
    'services',
    'items',
    'equipment',
    'suppliers',
    'equipmentTypes',
    'expiry',
    'procurement',
    'custody',
    'counts',
    'locations',
    'insurance'
];
const $4f815dcbee26bb40$export$9b7e1c41c195ba72 = [
    'dashboard',
    'transactions',
    'receipts',
    'payments',
    'payroll',
    'accounts',
    'counterparties',
    'receivables',
    'payables'
];
const $4f815dcbee26bb40$var$ACCOUNTING_SET = new Set($4f815dcbee26bb40$export$9b7e1c41c195ba72);
const $4f815dcbee26bb40$export$653b77da3717056b = (view)=>!!view && $4f815dcbee26bb40$var$ACCOUNTING_SET.has(view);
const $4f815dcbee26bb40$export$bc265c801ebc72c0 = [
    'dashboard',
    'orders',
    'listings',
    'storefront',
    'finance',
    'settings'
];
const $4f815dcbee26bb40$var$STORE_SET = new Set($4f815dcbee26bb40$export$bc265c801ebc72c0);
const $4f815dcbee26bb40$export$f22e3bd01c21cd84 = (view)=>!!view && $4f815dcbee26bb40$var$STORE_SET.has(view);
const $4f815dcbee26bb40$var$PAGE_OF = new Map([
    ...$4f815dcbee26bb40$export$9d057af351d5189b.map((v)=>[
            v,
            $4f815dcbee26bb40$export$42c04508fd5e94e2
        ]),
    ...$4f815dcbee26bb40$export$869f89992a039b5.map((v)=>[
            v,
            $4f815dcbee26bb40$export$445df4e4e163ee21
        ])
]);
function $4f815dcbee26bb40$export$47ab4d46d3d1d567(view) {
    return view && $4f815dcbee26bb40$var$PAGE_OF.get(view) || null;
}
const $4f815dcbee26bb40$export$ae543ed59ff9f99b = (view)=>$4f815dcbee26bb40$export$47ab4d46d3d1d567(view) === $4f815dcbee26bb40$export$445df4e4e163ee21;

});

parcelRegister("jmEyz", function(module, exports) {

$parcel$export(module.exports, "toCsv", () => $e18f8810327a9cf8$export$171e304ea3e0c0ae);
$parcel$export(module.exports, "csvMoney", () => $e18f8810327a9cf8$export$2fdfc445f7468c76);
$parcel$export(module.exports, "csvNumber", () => $e18f8810327a9cf8$export$a28976411e6d6576);
$parcel$export(module.exports, "csvPercent", () => $e18f8810327a9cf8$export$86a9c7cb00d5496a);
$parcel$export(module.exports, "downloadCsv", () => $e18f8810327a9cf8$export$c6d851d1877b46af);
$parcel$export(module.exports, "csvHeaderBlock", () => $e18f8810327a9cf8$export$97748d3bda0daa2);
// CSV export, for every screen that has one.
//
// Promoted from `Operations.shared.js` (which had the tests) after a second,
// subtly different copy appeared in the cash desk's screen — different line ending,
// different digit handling — so the same «خروجی» button produced two dialects of
// file depending on which screen it sat on. Both screens now import from here.
//
// The rules below are all about ONE consumer: Excel, in Persian, on Windows. Every
// one of them was a real defect first.

var $1O6TO = parcelRequire("1O6TO");
var $lHVFz = parcelRequire("lHVFz");
function $e18f8810327a9cf8$export$171e304ea3e0c0ae(headers, rows) {
    const esc = (cell)=>`"${String(cell ?? '').replace(/"/g, '""')}"`;
    return "\uFEFF" + [
        headers,
        ...rows
    ].map((r)=>r.map(esc).join(',')).join('\r\n');
}
const $e18f8810327a9cf8$export$2fdfc445f7468c76 = (rial, currency)=>{
    const info = (0, $1O6TO.currencyInfo)(currency);
    if (info.code === (0, $lHVFz.DEFAULT_CURRENCY)) return String(Math.round((Number(rial) || 0) / 10));
    return (0, $1O6TO.toDisplay)(Number(rial) || 0, info.code).toFixed(info.maxDisplayDecimals);
};
const $e18f8810327a9cf8$export$a28976411e6d6576 = (n)=>String(Number(n) || 0);
const $e18f8810327a9cf8$export$86a9c7cb00d5496a = (v)=>v === null || v === undefined || Number.isNaN(v) ? '' : (Math.round(Number(v) * 10) / 10).toString();
function $e18f8810327a9cf8$export$c6d851d1877b46af(filename, csv) {
    const blob = new Blob([
        csv
    ], {
        type: 'text/csv;charset=utf-8;'
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}
function $e18f8810327a9cf8$export$97748d3bda0daa2({ title: title, range: range, filters: filters = [] }) {
    const lines = [
        [
            title
        ]
    ];
    if (range) lines.push([
        range
    ]);
    for (const f of filters)if (f) lines.push([
        f
    ]);
    lines.push([]);
    return lines;
}

});




parcelRegister("4xGOs", function(module, exports) {

$parcel$export(module.exports, "default", () => $efaacf8e2e2b294d$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $efaacf8e2e2b294d$export$a2387ed3b5d536eb = {
    name: "calendar-check",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M8 2v3",
                key: "1ioesn"
            }
        ],
        [
            "path",
            {
                d: "M16 2v3",
                key: "otl347"
            }
        ],
        [
            "rect",
            {
                x: "3",
                y: "3",
                width: "18",
                height: "18",
                rx: "2",
                key: "h1oib"
            }
        ],
        [
            "path",
            {
                d: "M3 9h18",
                key: "1pudct"
            }
        ],
        [
            "path",
            {
                d: "m9 15 2 2 4-4",
                key: "1grp1n"
            }
        ]
    ]
};
$efaacf8e2e2b294d$export$a2387ed3b5d536eb.node;
const $efaacf8e2e2b294d$export$2e2bcd8739ae039 = (0, $9QBug.default)($efaacf8e2e2b294d$export$a2387ed3b5d536eb);

});

parcelRegister("4l6DR", function(module, exports) {

$parcel$export(module.exports, "default", () => $87513a585d30c268$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $87513a585d30c268$export$a2387ed3b5d536eb = {
    name: "calendar-clock",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M16 14v2.2l1.6 1",
                key: "fo4ql5"
            }
        ],
        [
            "path",
            {
                d: "M16 2v3",
                key: "otl347"
            }
        ],
        [
            "path",
            {
                d: "M21 7.338V5a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2h2.338",
                key: "7hb8p4"
            }
        ],
        [
            "path",
            {
                d: "M3 9h5.859",
                key: "numkqi"
            }
        ],
        [
            "path",
            {
                d: "M8 2v3",
                key: "1ioesn"
            }
        ],
        [
            "circle",
            {
                cx: "16",
                cy: "16",
                r: "6",
                key: "qoo3c4"
            }
        ]
    ]
};
$87513a585d30c268$export$a2387ed3b5d536eb.node;
const $87513a585d30c268$export$2e2bcd8739ae039 = (0, $9QBug.default)($87513a585d30c268$export$a2387ed3b5d536eb);

});

parcelRegister("dBbFF", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fe01e99f8f7285e$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $6fe01e99f8f7285e$export$a2387ed3b5d536eb = {
    name: "user-check",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m16 11 2 2 4-4",
                key: "9rsbq5"
            }
        ],
        [
            "path",
            {
                d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2",
                key: "1yyitq"
            }
        ],
        [
            "circle",
            {
                cx: "9",
                cy: "7",
                r: "4",
                key: "nufk8"
            }
        ]
    ]
};
$6fe01e99f8f7285e$export$a2387ed3b5d536eb.node;
const $6fe01e99f8f7285e$export$2e2bcd8739ae039 = (0, $9QBug.default)($6fe01e99f8f7285e$export$a2387ed3b5d536eb);

});

parcelRegister("l37hw", function(module, exports) {

$parcel$export(module.exports, "default", () => $7dfd9db3a50f7eb1$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $7dfd9db3a50f7eb1$export$a2387ed3b5d536eb = {
    name: "wallet",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1",
                key: "18etb6"
            }
        ],
        [
            "path",
            {
                d: "M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4",
                key: "xoc0q4"
            }
        ]
    ]
};
$7dfd9db3a50f7eb1$export$a2387ed3b5d536eb.node;
const $7dfd9db3a50f7eb1$export$2e2bcd8739ae039 = (0, $9QBug.default)($7dfd9db3a50f7eb1$export$a2387ed3b5d536eb);

});

parcelRegister("aIxvs", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fb661ead567131f$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $9fb661ead567131f$export$a2387ed3b5d536eb = {
    name: "user-plus",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2",
                key: "1yyitq"
            }
        ],
        [
            "circle",
            {
                cx: "9",
                cy: "7",
                r: "4",
                key: "nufk8"
            }
        ],
        [
            "line",
            {
                x1: "19",
                x2: "19",
                y1: "8",
                y2: "14",
                key: "1bvyxn"
            }
        ],
        [
            "line",
            {
                x1: "22",
                x2: "16",
                y1: "11",
                y2: "11",
                key: "1shjgl"
            }
        ]
    ]
};
$9fb661ead567131f$export$a2387ed3b5d536eb.node;
const $9fb661ead567131f$export$2e2bcd8739ae039 = (0, $9QBug.default)($9fb661ead567131f$export$a2387ed3b5d536eb);

});

parcelRegister("cqw4c", function(module, exports) {

$parcel$export(module.exports, "useServerVoiceInput", () => $90c0c98292f8e95a$export$b567139352913093);

var $acw62 = parcelRequire("acw62");

var $58BYB = parcelRequire("58BYB");

var $iAkVL = parcelRequire("iAkVL");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $1k2zw = parcelRequire("1k2zw");

var $ecBbY = parcelRequire("ecBbY");
/**
 * Server-side speech-to-text: records with MediaRecorder (works in every modern
 * browser, incl. Firefox) and streams the audio to the clinic BFF's
 * /ws/transcribe WebSocket, which relays it to the AI assistant's transcription.
 *
 * Exposes the SAME shape as useVoiceInput (browser Web Speech) so callers are
 * interchangeable: { status, transcript, errorDetail, start, stop, reset, isSupported }.
 */ function $90c0c98292f8e95a$var$pickMime() {
    // `audio/mp4` is the only one Safari/iOS (before 18.4) accepts. Without it the
    // recorder still falls back to its own default, but naming it keeps the
    // choice explicit rather than accidental.
    const types = [
        'audio/webm;codecs=opus',
        'audio/webm',
        'audio/ogg;codecs=opus',
        'audio/mp4'
    ];
    try {
        return types.find((type)=>window.MediaRecorder?.isTypeSupported?.(type)) || '';
    } catch  {
        return '';
    }
}
const $90c0c98292f8e95a$export$a645acfccdcdbcbd = 30000;
function $90c0c98292f8e95a$export$b567139352913093({ continuous: continuous = false, onFinalSegment: onFinalSegment, onSilence: onSilence, onNoSpeech: onNoSpeech, onAutoStopUnavailable: onAutoStopUnavailable, onLevel: onLevel } = {}) {
    const { t: t } = (0, $e1LEq.default)();
    const [status, setStatus] = (0, $acw62.useState)('idle');
    const [transcript, setTranscript] = (0, $acw62.useState)('');
    const [errorDetail, setErrorDetail] = (0, $acw62.useState)('');
    const wsRef = (0, $acw62.useRef)(null);
    const mrRef = (0, $acw62.useRef)(null);
    const streamRef = (0, $acw62.useRef)(null);
    const accRef = (0, $acw62.useRef)('');
    const interimRef = (0, $acw62.useRef)(''); // latest interim delta, not yet in accRef
    const finishRef = (0, $acw62.useRef)(null); // fallback timer to force-close the socket
    const startingRef = (0, $acw62.useRef)(false); // guards against opening a second socket
    const finalResolveRef = (0, $acw62.useRef)(null); // a pending finishTranscript() promise
    // Audio chunks go out IN ORDER, each after the previous one's arrayBuffer()
    // resolved. `done` is chained onto the same queue, so the recorder's last
    // chunk — emitted asynchronously by MediaRecorder.stop() — cannot land after
    // the server has already been told the recording is over.
    const sendChainRef = (0, $acw62.useRef)(Promise.resolve());
    // The silence watch of an auto-stopping recording, and the callers' latest handlers.
    const vadRef = (0, $acw62.useRef)(null);
    // Which start() is current. A teardown while start() still awaits the microphone
    // makes that start stale: without this, the late stream would open a recording
    // nobody is listening to — and the BFF would bill it.
    const genRef = (0, $acw62.useRef)(0);
    const handlersRef = (0, $acw62.useRef)({});
    handlersRef.current = {
        onSilence: onSilence,
        onNoSpeech: onNoSpeech,
        onAutoStopUnavailable: onAutoStopUnavailable,
        onLevel: onLevel
    };
    const stopSilenceWatch = (0, $acw62.useCallback)(()=>{
        if (vadRef.current) {
            vadRef.current.stop();
            vadRef.current = null;
        }
    }, []);
    // Hard teardown: stop recorder/mic, clear the timer, and CLOSE the socket.
    const teardown = (0, $acw62.useCallback)(()=>{
        genRef.current += 1;
        startingRef.current = false;
        stopSilenceWatch();
        // Settle a pending «پایان» with whatever arrived. Every exit — final message,
        // server error, socket close, timeout, unmount — passes through here, so a
        // caller awaiting finishTranscript() is never left hanging.
        if (finalResolveRef.current) {
            const settle = finalResolveRef.current;
            finalResolveRef.current = null;
            settle((accRef.current + interimRef.current).trim());
        }
        if (finishRef.current) {
            clearTimeout(finishRef.current);
            finishRef.current = null;
        }
        try {
            if (mrRef.current && mrRef.current.state !== 'inactive') mrRef.current.stop();
        } catch  {}
        try {
            streamRef.current?.getTracks().forEach((track)=>track.stop());
        } catch  {}
        mrRef.current = null;
        streamRef.current = null;
        const ws = wsRef.current;
        wsRef.current = null;
        if (ws) {
            try {
                ws.onmessage = ws.onerror = ws.onclose = null;
            } catch  {}
            try {
                ws.close(1000, 'client done');
            } catch  {}
        }
    }, [
        stopSilenceWatch
    ]);
    // User pressed پایان/stop: stop capturing, ask the server to flush the final
    // transcript, then close. A fallback timer guarantees the socket never lingers
    // open even if the server is slow or the final message is lost.
    const stop = (0, $acw62.useCallback)(()=>{
        const ws = wsRef.current;
        stopSilenceWatch();
        try {
            if (mrRef.current && mrRef.current.state !== 'inactive') mrRef.current.stop();
        } catch  {}
        try {
            streamRef.current?.getTracks().forEach((track)=>track.stop());
        } catch  {}
        mrRef.current = null;
        streamRef.current = null;
        setStatus('idle');
        if (ws && ws.readyState === WebSocket.OPEN) {
            try {
                ws.send(JSON.stringify({
                    done: true
                }));
            } catch  {}
            if (finishRef.current) clearTimeout(finishRef.current);
            finishRef.current = setTimeout(teardown, 6000); // close after final transcript, or force after 6s
        } else teardown();
    }, [
        teardown,
        stopSilenceWatch
    ]);
    /**
   * The transcript as of right now, including the interim not yet finalised.
   * Callers confirm in the same tick they call stop(), where the `transcript`
   * state is still the previous render's value.
   */ const getTranscript = (0, $acw62.useCallback)(()=>(accRef.current + interimRef.current).trim(), []);
    /**
   * «پایان» for the server path: stop capturing, flush the last chunk, tell the
   * server the recording is over, and resolve with the FINAL transcript once it
   * arrives — or with what has arrived by `timeoutMs`. Never rejects.
   */ const finishTranscript = (0, $acw62.useCallback)((timeoutMs = $90c0c98292f8e95a$export$a645acfccdcdbcbd)=>new Promise((resolve)=>{
            // The recording is ending: nothing is left for the silence watch to end.
            stopSilenceWatch();
            const ws = wsRef.current;
            const mr = mrRef.current;
            const stream = streamRef.current;
            mrRef.current = null;
            streamRef.current = null;
            setStatus('idle');
            if (!ws || ws.readyState !== WebSocket.OPEN) {
                try {
                    if (mr && mr.state !== 'inactive') mr.stop();
                } catch  {}
                try {
                    stream?.getTracks().forEach((track)=>track.stop());
                } catch  {}
                teardown();
                resolve((accRef.current + interimRef.current).trim());
                return;
            }
            finalResolveRef.current = resolve;
            const sendDone = ()=>sendChainRef.current.then(()=>{
                    if (ws.readyState === WebSocket.OPEN) try {
                        ws.send(JSON.stringify({
                            done: true
                        }));
                    } catch  {}
                });
            if (mr && mr.state !== 'inactive') {
                mr.onstop = ()=>{
                    try {
                        stream?.getTracks().forEach((track)=>track.stop());
                    } catch  {}
                    sendDone();
                };
                try {
                    mr.stop();
                } catch  {
                    sendDone();
                }
            } else {
                try {
                    stream?.getTracks().forEach((track)=>track.stop());
                } catch  {}
                sendDone();
            }
            if (finishRef.current) clearTimeout(finishRef.current);
            finishRef.current = setTimeout(teardown, timeoutMs);
        }), [
        teardown,
        stopSilenceWatch
    ]);
    const reset = (0, $acw62.useCallback)(()=>{
        accRef.current = '';
        interimRef.current = '';
        setTranscript('');
        setStatus('idle');
        setErrorDetail('');
    }, []);
    /**
   * Throw the recording away: close the socket WITHOUT «done». The BFF then cancels
   * the upstream stream (transcribeHandler.js), and a recording that had not yet
   * reached the AI service's first pass is never transcribed — or charged.
   */ const cancel = (0, $acw62.useCallback)(()=>{
        accRef.current = '';
        interimRef.current = '';
        setTranscript('');
        setStatus('idle');
        setErrorDetail('');
        teardown();
    }, [
        teardown
    ]);
    const start = (0, $acw62.useCallback)(async ({ autoStop: autoStop = false, meter: meter = false } = {})=>{
        // Re-entry guard: if a socket is already connecting/open (or start() is
        // mid-flight), do nothing. The inline voice bar's auto-restart effect can call start()
        // again while the WS is still connecting (status not yet 'listening'); without
        // this guard that opens a second WebSocket.
        if (startingRef.current || wsRef.current && wsRef.current.readyState !== WebSocket.CLOSED) return;
        startingRef.current = true;
        const gen = genRef.current;
        setErrorDetail('');
        if (!window.MediaRecorder || !navigator.mediaDevices?.getUserMedia) {
            setStatus('unsupported');
            startingRef.current = false;
            return;
        }
        let stream;
        try {
            stream = await navigator.mediaDevices.getUserMedia({
                audio: true
            });
        } catch (err) {
            if (gen !== genRef.current) return;
            const name = err?.name || '';
            if (name === 'NotAllowedError' || name === 'PermissionDeniedError') setStatus('denied');
            else if (name === 'NotFoundError' || name === 'DevicesNotFoundError') {
                setStatus('error');
                setErrorDetail(t('errors.voice.noMicrophone'));
            } else {
                setStatus('error');
                setErrorDetail(err?.message || t('errors.voice.microphoneDenied'));
            }
            startingRef.current = false;
            return;
        }
        // Cancelled while the browser was asking for the microphone: release it, record nothing.
        if (gen !== genRef.current) {
            try {
                stream.getTracks().forEach((track)=>track.stop());
            } catch  {}
            return;
        }
        streamRef.current = stream;
        const token = (0, $58BYB.getToken)() || '';
        const wsUrl = `${(0, $iAkVL.BFF_WS_BASE)}/ws/transcribe?token=${encodeURIComponent(token)}`;
        // The clinic is NOT inferable here, so it travels with the socket exactly as it
        // travels with every HTTP request (design §A10); the BFF validates it against
        // membership. It does not decide who pays: server-side transcription bills the
        // PERSON who opened the socket (their verified sub), like every AI call.
        const activeClinic = (0, $1k2zw.getActiveClinicRef)();
        const wsUrlWithClinic = activeClinic ? `${wsUrl}&clinic=${encodeURIComponent(activeClinic)}` : wsUrl;
        let ws;
        try {
            ws = new WebSocket(wsUrlWithClinic);
        } catch  {
            setStatus('error');
            setErrorDetail(t('errors.voice.serviceUnreachable'));
            teardown();
            return;
        }
        ws.binaryType = 'arraybuffer';
        wsRef.current = ws;
        ws.onopen = ()=>{
            const mimeType = $90c0c98292f8e95a$var$pickMime();
            let mr;
            try {
                mr = new MediaRecorder(stream, mimeType ? {
                    mimeType: mimeType
                } : {});
            } catch  {
                setStatus('error');
                setErrorDetail(t('errors.voice.unsupported'));
                teardown();
                return;
            }
            mrRef.current = mr;
            mr.ondataavailable = (e)=>{
                if (!e.data || e.data.size === 0) return;
                const blob = e.data;
                sendChainRef.current = sendChainRef.current.then(()=>blob.arrayBuffer()).then((buf)=>{
                    if (ws.readyState === WebSocket.OPEN) try {
                        ws.send(buf);
                    } catch  {}
                }).catch(()=>{});
            };
            mr.start(500); // emit a chunk every 500ms
            startingRef.current = false;
            setStatus('listening');
            if (autoStop || meter) {
                const vad = (0, $ecBbY.watchSilence)(stream, {
                    detect: autoStop,
                    onSilence: ()=>handlersRef.current.onSilence?.(),
                    onNoSpeech: ()=>handlersRef.current.onNoSpeech?.(),
                    onLevel: (level)=>handlersRef.current.onLevel?.(level)
                });
                vadRef.current = vad;
                vad.ready.then((ok)=>{
                    if (!ok && vadRef.current === vad) {
                        vadRef.current = null;
                        vad.stop();
                        // Only a recording that was to END on silence has lost something.
                        if (autoStop) handlersRef.current.onAutoStopUnavailable?.();
                    }
                });
            }
        };
        ws.onmessage = (ev)=>{
            let msg;
            try {
                msg = JSON.parse(typeof ev.data === 'string' ? ev.data : '');
            } catch  {
                return;
            }
            if (!msg) return;
            if (msg.error) {
                setStatus('error');
                setErrorDetail(msg.error);
                teardown();
                return;
            }
            if (typeof msg.text === 'string') {
                if (msg.is_final) {
                    // Final message carries the FULL authoritative transcript — replace,
                    // don't append (interim messages were deltas).
                    const full = String(msg.text).trim();
                    if (full) accRef.current = full + ' ';
                    interimRef.current = '';
                    onFinalSegment?.(full);
                    setTranscript(accRef.current.trim());
                    setStatus('idle');
                    teardown(); // final received → close the socket now
                } else {
                    interimRef.current = msg.text;
                    setTranscript((accRef.current + msg.text).trim());
                }
            }
        };
        ws.onerror = ()=>{
            setStatus('error');
            setErrorDetail(t('errors.voice.serviceConnection'));
            teardown();
        };
        ws.onclose = (ev)=>{
            if (finishRef.current) {
                clearTimeout(finishRef.current);
                finishRef.current = null;
            }
            // A SERVER REFUSAL, not a normal end of stream. The BFF closes with a
            // 4xxx code before any audio is transcribed — 4001 when the token is bad,
            // 4003 when the account has no clinic to bill the پارسه to.
            //
            // Ignoring the code left the worst possible state: the socket closes, the
            // status flips listening → idle, and because `teardown()` is never called
            // on this path the MediaRecorder and the microphone TRACKS keep running.
            // The browser's recording indicator stayed lit, the user saw no message
            // at all, and every frame was silently dropped by `ondataavailable`'s
            // readyState guard. It looked like the feature was working.
            const REFUSALS = {
                4001: 'errors.voice.serviceConnection',
                4003: 'errors.voice.noClinic'
            };
            if (ev?.code >= 4000) {
                setStatus('error');
                setErrorDetail(t(REFUSALS[ev.code] || 'errors.voice.refused'));
                teardown();
                return;
            }
            // A normal close while «پایان» is still waiting: settle it with what came.
            if (finalResolveRef.current) teardown();
            setStatus((prev)=>prev === 'listening' ? 'idle' : prev);
        };
    }, [
        continuous,
        onFinalSegment,
        teardown,
        t
    ]);
    (0, $acw62.useEffect)(()=>()=>teardown(), [
        teardown
    ]);
    return {
        status: status,
        transcript: transcript,
        errorDetail: errorDetail,
        start: start,
        stop: stop,
        reset: reset,
        cancel: cancel,
        getTranscript: getTranscript,
        finishTranscript: finishTranscript,
        isSupported: typeof window !== 'undefined' && !!window.MediaRecorder
    };
}

});
parcelRegister("ecBbY", function(module, exports) {

$parcel$export(module.exports, "watchSilence", () => $a56f093f3e022d90$export$ed2b6ffb9c219141);
/**
 * When a spoken ANSWER is over — «منشی هوشمند»'s follow-up questions (PM-0080).
 *
 * An answer is a few words («۰۹۱۳…», «تأمین اجتماعی»), and making the desk press
 * «توقف و اجرا» after each one is what made the secretary feel like a form. So an
 * answer's recording ends by itself: speech, then SILENCE_MS of quiet. And one that
 * never hears speech gives up after NO_SPEECH_MS — cancelled, never sent, so a
 * question nobody answered by voice costs nothing.
 *
 * `createSilenceDetector` is the rule, pure: fed one microphone level (RMS, 0..1) at
 * a time with the time it was read. `watchSilence` feeds it from a live stream.
 */ const $a56f093f3e022d90$export$d8d6f00b2a88693f = 1200;
const $a56f093f3e022d90$export$540905bfcff672ca = 10000;
function $a56f093f3e022d90$export$d463afe274e83102({ silenceMs: silenceMs = $a56f093f3e022d90$export$d8d6f00b2a88693f, noSpeechMs: noSpeechMs = $a56f093f3e022d90$export$540905bfcff672ca, minLevel: minLevel = 0.012, ratio: ratio = 2.5, floorReadings: floorReadings = 4 } = {}) {
    let startedAt = null;
    const floorSeen = [];
    let floor = null;
    let spoke = false;
    let quietSince = null;
    let decided = false;
    return function feed(level, now) {
        if (decided) return null;
        if (startedAt === null) startedAt = now;
        if (floor === null) {
            // Speech can start at once: a loud first reading is speech, not the floor.
            if (level >= minLevel * 3) spoke = true;
            else floorSeen.push(level);
            if (floorSeen.length >= floorReadings || spoke) floor = floorSeen.length ? floorSeen.reduce((a, b)=>a + b, 0) / floorSeen.length : 0;
            if (!spoke) return null;
        }
        const threshold = Math.max(minLevel, floor * ratio);
        if (level >= threshold) {
            spoke = true;
            quietSince = null;
            return null;
        }
        if (spoke) {
            if (quietSince === null) quietSince = now;
            if (now - quietSince >= silenceMs) {
                decided = true;
                return 'silence';
            }
            return null;
        }
        if (now - startedAt >= noSpeechMs) {
            decided = true;
            return 'no-speech';
        }
        return null;
    };
}
function $a56f093f3e022d90$export$ed2b6ffb9c219141(stream, { onSilence: onSilence, onNoSpeech: onNoSpeech, onLevel: onLevel, detect: detect = true, ...rule } = {}) {
    const Ctx = typeof window !== 'undefined' ? window.AudioContext || window.webkitAudioContext : null;
    if (!Ctx || !stream) return {
        stop () {},
        ready: Promise.resolve(false)
    };
    let ctx;
    let source;
    try {
        ctx = new Ctx();
        source = ctx.createMediaStreamSource(stream);
    } catch  {
        try {
            ctx?.close();
        } catch  {}
        return {
            stop () {},
            ready: Promise.resolve(false)
        };
    }
    const analyser = ctx.createAnalyser();
    analyser.fftSize = 1024;
    source.connect(analyser);
    const samples = new Float32Array(analyser.fftSize);
    const feed = $a56f093f3e022d90$export$d463afe274e83102(rule);
    let timer = null;
    let stopped = false;
    // Once: closing a closed AudioContext REJECTS (it does not throw), and the hook's
    // teardown may stop a watch that already stopped itself on silence.
    const stop = ()=>{
        if (stopped) return;
        stopped = true;
        if (timer) {
            clearInterval(timer);
            timer = null;
        }
        try {
            source.disconnect();
        } catch  {}
        try {
            Promise.resolve(ctx.close()).catch(()=>{});
        } catch  {}
    };
    timer = setInterval(()=>{
        if (ctx.state !== 'running') return;
        analyser.getFloatTimeDomainData(samples);
        let sum = 0;
        for(let i = 0; i < samples.length; i += 1)sum += samples[i] * samples[i];
        const level = Math.sqrt(sum / samples.length);
        onLevel?.(level);
        if (!detect) return;
        const event = feed(level, Date.now());
        if (event === 'silence') {
            stop();
            onSilence?.();
        } else if (event === 'no-speech') {
            stop();
            onNoSpeech?.();
        }
    }, 100);
    const ready = (async ()=>{
        try {
            await ctx.resume?.();
        } catch  {}
        await new Promise((resolve)=>{
            setTimeout(resolve, 300);
        });
        return ctx.state === 'running';
    })();
    return {
        stop: stop,
        ready: ready
    };
}

});


parcelRegister("7h1oo", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5e13059631a6518$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $a5e13059631a6518$export$a2387ed3b5d536eb = {
    name: "circle-dashed",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M10.1 2.182a10 10 0 0 1 3.8 0",
                key: "5ilxe3"
            }
        ],
        [
            "path",
            {
                d: "M13.9 21.818a10 10 0 0 1-3.8 0",
                key: "11zvb9"
            }
        ],
        [
            "path",
            {
                d: "M17.609 3.721a10 10 0 0 1 2.69 2.7",
                key: "1iw5b2"
            }
        ],
        [
            "path",
            {
                d: "M2.182 13.9a10 10 0 0 1 0-3.8",
                key: "c0bmvh"
            }
        ],
        [
            "path",
            {
                d: "M20.279 17.609a10 10 0 0 1-2.7 2.69",
                key: "1ruxm7"
            }
        ],
        [
            "path",
            {
                d: "M21.818 10.1a10 10 0 0 1 0 3.8",
                key: "qkgqxc"
            }
        ],
        [
            "path",
            {
                d: "M3.721 6.391a10 10 0 0 1 2.7-2.69",
                key: "1mcia2"
            }
        ],
        [
            "path",
            {
                d: "M6.391 20.279a10 10 0 0 1-2.69-2.7",
                key: "1fvljs"
            }
        ]
    ]
};
$a5e13059631a6518$export$a2387ed3b5d536eb.node;
const $a5e13059631a6518$export$2e2bcd8739ae039 = (0, $9QBug.default)($a5e13059631a6518$export$a2387ed3b5d536eb);

});

parcelRegister("1oGgm", function(module, exports) {

$parcel$export(module.exports, "default", () => $456310d582313b5b$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $456310d582313b5b$export$a2387ed3b5d536eb = {
    name: "wrench",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.106-3.105c.32-.322.863-.22.983.218a6 6 0 0 1-8.259 7.057l-7.91 7.91a1 1 0 0 1-2.999-3l7.91-7.91a6 6 0 0 1 7.057-8.259c.438.12.54.662.219.984z",
                key: "1ngwbx"
            }
        ]
    ]
};
$456310d582313b5b$export$a2387ed3b5d536eb.node;
const $456310d582313b5b$export$2e2bcd8739ae039 = (0, $9QBug.default)($456310d582313b5b$export$a2387ed3b5d536eb);

});

parcelRegister("kB1PK", function(module, exports) {

$parcel$export(module.exports, "ReceptionKpiSkeleton", () => $fc9cad95cac62ce8$export$ea86d78772ca5bec);
$parcel$export(module.exports, "ReceptionSkeletonWeb", () => $fc9cad95cac62ce8$export$2e160dc577b7a7d3);
$parcel$export(module.exports, "ReceptionAppointmentCardSkeleton", () => $fc9cad95cac62ce8$export$4e3410b0423053f0);
$parcel$export(module.exports, "ReceptionRegistryCardSkeleton", () => $fc9cad95cac62ce8$export$e1df03f29cfd0cd2);
$parcel$export(module.exports, "ReceptionSkeletonMobile", () => $fc9cad95cac62ce8$export$c24307ca23e4a30d);
$parcel$export(module.exports, "default", () => $fc9cad95cac62ce8$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("5N0ZI");
var $aM2JY = parcelRequire("aM2JY");
var $66joL = parcelRequire("66joL");

var $jTCZr = parcelRequire("jTCZr");

var $2xQve = parcelRequire("2xQve");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $9h2jQ = parcelRequire("9h2jQ");

var $8RTRt = parcelRequire("8RTRt");

var $5zhhf = parcelRequire("5zhhf");

var $cEwTy = parcelRequire("cEwTy");

var $7NBSI = parcelRequire("7NBSI");
const $fc9cad95cac62ce8$export$4f4b2279be1888ce = 6;
// The blocks alone (aria-hidden) — a page skeleton nests them under its own
// status root; the screen's KPI-region refetch uses the labelled composite.
function $fc9cad95cac62ce8$var$KpiTiles({ isToday: isToday, ...rest }) {
    const n = isToday ? $fc9cad95cac62ce8$export$4f4b2279be1888ce : $fc9cad95cac62ce8$export$4f4b2279be1888ce - 1;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        "aria-hidden": true,
        style: {
            display: 'grid',
            gridTemplateColumns: `repeat(${n},1fr)`,
            gap: 9,
            padding: '6px 24px 14px'
        },
        ...rest,
        children: Array.from({
            length: n
        }, (_, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10,
                    background: (0, $jTCZr.CT).surface,
                    border: `1px solid ${(0, $jTCZr.CT).border}`,
                    borderRadius: 13,
                    padding: '11px 13px'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: 32,
                        height: 32,
                        radius: 9
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 3
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                width: "60%",
                                height: 18,
                                radius: 4
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                width: "80%",
                                height: 11,
                                radius: 4
                            })
                        ]
                    })
                ]
            }, i))
    });
}
function $fc9cad95cac62ce8$export$ea86d78772ca5bec({ isToday: isToday = true, ...rest }) {
    const { t: t } = (0, $e1LEq.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonRegion), {
        label: t('common.state.loading'),
        ...rest,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($fc9cad95cac62ce8$var$KpiTiles, {
            isToday: isToday
        })
    });
}
// The day table's real columns: #, drag handle, time, patient, status, money,
// actions. DayList rows are ROW_PAD.compact (8px) around a 34px avatar = 50px;
// the kit's 52px row is the nearest step.
const $fc9cad95cac62ce8$var$DAY_COLUMNS = [
    24,
    24,
    60,
    200,
    96,
    96,
    140
];
function $fc9cad95cac62ce8$var$DoctorTabsSkeleton() {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        "aria-hidden": true,
        style: {
            display: 'flex',
            gap: 7,
            padding: '0 24px 12px',
            flexWrap: 'wrap',
            alignItems: 'center'
        },
        children: [
            112,
            150,
            150
        ].map((w, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                width: w,
                height: 45,
                radius: (0, $jTCZr.RADIUS).pill
            }, i))
    });
}
// Reception.shared's FILTERS has five chips: 7px 13px padding on 12.5px text.
const $fc9cad95cac62ce8$var$FILTER_CHIPS = [
    78,
    68,
    104,
    84,
    74
];
function $fc9cad95cac62ce8$var$FilterChipsSkeleton() {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        "aria-hidden": true,
        style: {
            display: 'flex',
            gap: 8,
            padding: '0 24px 12px',
            flexWrap: 'wrap'
        },
        children: $fc9cad95cac62ce8$var$FILTER_CHIPS.map((w, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                width: w,
                height: 32,
                radius: (0, $jTCZr.RADIUS).pill
            }, i))
    });
}
function $fc9cad95cac62ce8$export$2e160dc577b7a7d3({ isToday: isToday = true }) {
    const { t: t } = (0, $e1LEq.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $66joL.SkeletonRegion), {
        label: t('common.state.loading'),
        "data-testid": "reception-skeleton",
        style: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            background: (0, $jTCZr.CT).bg
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("header", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 14,
                    padding: '14px 24px 12px',
                    flexWrap: 'wrap',
                    background: (0, $jTCZr.CT).surface,
                    borderBottom: `1px solid ${(0, $jTCZr.CT).border}`
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                        style: {
                            margin: 0,
                            fontSize: '1.25rem',
                            fontWeight: 800,
                            color: (0, $jTCZr.CT).ink,
                            whiteSpace: 'nowrap'
                        },
                        children: t('nav.items.reception')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            width: 1,
                            alignSelf: 'stretch',
                            background: (0, $jTCZr.CT).border,
                            margin: '2px 0'
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: 300,
                        height: 32,
                        radius: 10
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 7
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                width: 30,
                                height: 30,
                                radius: 8
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                width: 190,
                                height: 30,
                                radius: 8
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                width: 30,
                                height: 30,
                                radius: 8
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                width: 56,
                                height: 30,
                                radius: 8
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 14,
                            flex: '1 1 410px',
                            marginInlineStart: 'auto',
                            minWidth: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    flex: 1,
                                    minWidth: 260,
                                    maxWidth: 560,
                                    marginInlineStart: 'auto'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                    width: "100%",
                                    height: 38,
                                    radius: 10
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                width: 150,
                                height: 36,
                                radius: 10
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($fc9cad95cac62ce8$var$KpiTiles, {
                isToday: isToday
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($fc9cad95cac62ce8$var$DoctorTabsSkeleton, {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)($fc9cad95cac62ce8$var$FilterChipsSkeleton, {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    flex: 1,
                    minHeight: 0,
                    overflow: 'hidden',
                    padding: '4px 24px 32px'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonTable), {
                    rows: 8,
                    columns: $fc9cad95cac62ce8$var$DAY_COLUMNS,
                    label: t('common.state.loading'),
                    style: {
                        borderRadius: 14
                    }
                })
            })
        ]
    });
}
function $fc9cad95cac62ce8$export$4e3410b0423053f0({ style: style, ...rest }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "aria-hidden": true,
        style: {
            background: (0, $jTCZr.C).card,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: (0, $jTCZr.RADIUS).card,
            boxShadow: (0, $jTCZr.SHADOW).card,
            padding: '0.75rem 0.875rem',
            minHeight: '2.75rem',
            ...style
        },
        ...rest,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: 44,
                        height: 15
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            flex: 1
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: 56,
                        height: 12
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    marginTop: '0.5rem'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonAvatar), {
                        size: 34
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: "48%",
                        height: 14,
                        style: {
                            flex: 1,
                            maxWidth: '48%'
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            flex: 1
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: 72,
                        height: 22,
                        radius: (0, $jTCZr.RADIUS).pill
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                width: "62%",
                height: 11,
                style: {
                    marginTop: '0.25rem'
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    gap: `${(0, $2xQve.STACK).tight}px`,
                    alignItems: 'center',
                    marginTop: '0.625rem',
                    paddingTop: '0.625rem',
                    borderTop: `1px solid ${(0, $jTCZr.C).border}`
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        height: 44,
                        radius: (0, $jTCZr.RADIUS).control,
                        style: {
                            flex: 1,
                            width: 'auto'
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: 44,
                        height: 44,
                        radius: (0, $jTCZr.RADIUS).control
                    })
                ]
            })
        ]
    });
}
function $fc9cad95cac62ce8$export$e1df03f29cfd0cd2(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7NBSI.default), {
        avatar: 0,
        metaLines: 1,
        badge: 0,
        actions: 2,
        ...props
    });
}
function $fc9cad95cac62ce8$export$c24307ca23e4a30d() {
    const { t: t } = (0, $e1LEq.default)();
    // The day cockpit's geometry (PM-0052): the header card (lens row 44 + day
    // bar 48), the one-row strip — the kit's own, loading, so its «–» figures sit
    // exactly where the counts land — then «ثبت نوبت» and the cards.
    const strip = [
        {
            key: 'all',
            label: t('reception.mobile.strip.total')
        },
        {
            key: 'present',
            label: t('reception.status.present')
        },
        {
            key: 'visited',
            label: t('reception.status.seen')
        },
        {
            key: 'noshow',
            label: t('reception.status.noShow')
        }
    ].map((x)=>({
            ...x,
            value: null
        }));
    const header = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5zhhf.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                    tone: "onDark",
                    width: "100%",
                    height: 92,
                    radius: 12
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aM2JY.default), {
                items: strip,
                loading: true,
                testIdPrefix: "reception-skeleton"
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonRegion), {
        label: t('common.state.loading'),
        "data-testid": "reception-skeleton",
        style: {
            height: '100%'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $8RTRt.default), {
            header: header,
            "data-state": "loading",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        padding: '0.75rem 1rem 0'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        height: 44,
                        radius: (0, $jTCZr.RADIUS).control,
                        style: {
                            width: '100%'
                        }
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        padding: '0 1rem'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cEwTy.default), {
                        loading: true,
                        items: [],
                        skeletonCount: 4,
                        renderSkeleton: (i)=>/*#__PURE__*/ (0, $ayMG0.jsx)($fc9cad95cac62ce8$export$4e3410b0423053f0, {}, i)
                    })
                })
            ]
        })
    });
}
function $fc9cad95cac62ce8$export$2e2bcd8739ae039(props) {
    const { isMobile: isMobile } = (0, $9h2jQ.default)();
    return isMobile ? /*#__PURE__*/ (0, $ayMG0.jsx)($fc9cad95cac62ce8$export$c24307ca23e4a30d, {
        ...props
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)($fc9cad95cac62ce8$export$2e160dc577b7a7d3, {
        ...props
    });
}

});

parcelRegister("fpkFc", function(module, exports) {

$parcel$export(module.exports, "TableSkeletonBody", () => $db0bce0926fa0487$export$594a3db5494954b7);
$parcel$export(module.exports, "PatientCardSkeleton", () => $db0bce0926fa0487$export$bfe7070dd6a1c87b);
$parcel$export(module.exports, "BroadcastCardSkeleton", () => $db0bce0926fa0487$export$652bcb31339d9ed3);
$parcel$export(module.exports, "PatientsSkeletonWeb", () => $db0bce0926fa0487$export$bac2d68aa3a9310d);
$parcel$export(module.exports, "PatientsSkeletonMobile", () => $db0bce0926fa0487$export$4948d30d9050f5d9);
$parcel$export(module.exports, "default", () => $db0bce0926fa0487$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("5N0ZI");
var $aM2JY = parcelRequire("aM2JY");
var $h4ZeB = parcelRequire("h4ZeB");
var $kyZIh = parcelRequire("kyZIh");
var $66joL = parcelRequire("66joL");
var $jFCWB = parcelRequire("jFCWB");

var $jTCZr = parcelRequire("jTCZr");

var $2xQve = parcelRequire("2xQve");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $9h2jQ = parcelRequire("9h2jQ");
parcelRequire("1NzLv");
var $7NBSI = parcelRequire("7NBSI");
var $gmg4I = parcelRequire("gmg4I");
var $5zhhf = parcelRequire("5zhhf");
var $8RTRt = parcelRequire("8RTRt");
function $db0bce0926fa0487$export$594a3db5494954b7({ columns: columns, rows: rows = 7, dense: dense = false, label: label, standalone: /** False when a parent composite already announces the loading state. */ standalone = true, style: style, ...rest }) {
    const cols = columns.map((col, i)=>({
            ...col,
            // The select-all checkbox is a control the pending body cannot serve.
            header: typeof col.header === 'string' ? col.header : null,
            render: ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                    width: col.skeletonWidth || (i === 0 ? '30%' : '70%'),
                    height: i === 0 ? 16 : 13,
                    style: col.align === 'center' ? {
                        marginInline: 'auto'
                    } : undefined
                })
        }));
    const placeholders = Array.from({
        length: rows
    }, (_, i)=>({
            id: `skeleton-${i}`
        }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        ...standalone ? {
            role: 'status',
            'aria-busy': 'true',
            'aria-label': label
        } : {
            'aria-hidden': true
        },
        "data-state": "loading",
        style: style,
        ...rest,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jFCWB.default), {
            columns: cols,
            rows: placeholders,
            rowKey: (r)=>r.id,
            dense: dense
        })
    });
}
/**
 * The stat strip's four figures, the kit strip in its own loading state («–»),
 * with the labels real: the labels are chrome, the numbers are data.
 */ const $db0bce0926fa0487$var$STAT_KEYS = [
    'patients.stats.registeredThisMonth',
    'patients.stats.debtSum',
    'patients.stats.followUpsToday',
    'patients.stats.overdue'
];
function $db0bce0926fa0487$var$StatStripSkeleton({ t: t, style: style }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aM2JY.default), {
        testIdPrefix: "patients",
        items: $db0bce0926fa0487$var$STAT_KEYS.map((key)=>({
                key: key,
                label: t(key),
                value: null
            })),
        loading: true,
        ariaLabel: t('patients.stats.label'),
        style: style
    });
}
function $db0bce0926fa0487$export$bfe7070dd6a1c87b(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7NBSI.default), {
        avatar: 34,
        metaLines: 1,
        badge: 0,
        chips: 1,
        style: {
            paddingInlineEnd: '3.5rem'
        },
        ...props
    });
}
function $db0bce0926fa0487$export$652bcb31339d9ed3(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7NBSI.default), {
        avatar: 0,
        metaLines: 3,
        badge: 64,
        ...props
    });
}
const $db0bce0926fa0487$var$noop = ()=>{};
const $db0bce0926fa0487$var$SEGMENT_KEYS = [
    'patients.segments.all',
    'patients.segments.pending',
    'patients.segments.debtor',
    'patients.segments.followup',
    'patients.segments.inactive'
];
const $db0bce0926fa0487$var$SURFACE = {
    background: '#fff',
    border: `1px solid ${(0, $jTCZr.C).border}`,
    borderRadius: 14,
    overflow: 'hidden',
    boxShadow: '0 1px 4px rgba(0,0,0,.04)'
};
// ── Desktop ────────────────────────────────────────────────────────────────────
function $db0bce0926fa0487$var$ListSkeletonWeb({ t: t, label: label }) {
    const columns = [
        {
            key: 'pick',
            header: null,
            align: 'center',
            width: 96,
            skeletonWidth: 18
        },
        {
            key: 'patient',
            header: t('patients.columns.patient')
        },
        {
            key: 'contact',
            header: t('patients.columns.contact'),
            width: 210
        },
        {
            key: 'insurance',
            header: t('patients.fields.insurance'),
            width: 132
        },
        {
            key: 'visits',
            header: t('patients.columns.visits'),
            width: 172
        },
        {
            key: 'finance',
            header: t('patients.columns.finance'),
            width: 120
        },
        {
            key: 'actions',
            header: t('common.fields.actions'),
            width: 150,
            skeletonWidth: 40
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $66joL.SkeletonRegion), {
        label: label,
        "data-testid": "patients-skeleton",
        style: {
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            minHeight: 0,
            position: 'relative',
            background: (0, $jTCZr.C).bg
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $kyZIh.default), {
                title: t('nav.items.patients'),
                sub: t('patients.page.sub'),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonButton), {
                        width: 150
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonButton), {
                        width: 150
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    flex: 1,
                    minHeight: 0,
                    overflowY: 'auto',
                    padding: '16px 32px 24px'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        display: 'flex',
                        flexDirection: 'column',
                        gap: (0, $2xQve.STACK).regular,
                        minHeight: '100%'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                paddingBlock: (0, $2xQve.STACK).tight,
                                display: 'flex',
                                gap: 8,
                                alignItems: 'center',
                                flexWrap: 'wrap'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                    height: 44,
                                    radius: (0, $jTCZr.RADIUS).control,
                                    style: {
                                        flex: '1 1 320px',
                                        minWidth: 240
                                    },
                                    "aria-hidden": true
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    style: {
                                        display: 'flex',
                                        gap: 6,
                                        flexWrap: 'wrap'
                                    },
                                    children: $db0bce0926fa0487$var$SEGMENT_KEYS.map((key, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $h4ZeB.default), {
                                            label: t(key),
                                            active: i === 0,
                                            onClick: $db0bce0926fa0487$var$noop
                                        }, key))
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                    width: 110,
                                    height: 44,
                                    radius: (0, $jTCZr.RADIUS).control,
                                    "aria-hidden": true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                ...$db0bce0926fa0487$var$SURFACE,
                                flexGrow: 1,
                                flexShrink: 0
                            },
                            "data-testid": "patients-table-card",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($db0bce0926fa0487$export$594a3db5494954b7, {
                                columns: columns,
                                rows: 7,
                                standalone: false
                            })
                        })
                    ]
                })
            })
        ]
    });
}
function $db0bce0926fa0487$var$BroadcastsSkeletonWeb({ t: t, label: label }) {
    const columns = [
        {
            key: 'when',
            header: t('patients.broadcasts.columns.date'),
            width: 150
        },
        {
            key: 'channel',
            header: t('patients.broadcasts.columns.channel'),
            width: 120
        },
        {
            key: 'body',
            header: t('patients.broadcasts.columns.body')
        },
        {
            key: 'audience',
            header: t('patients.broadcasts.columns.recipients'),
            width: 160
        },
        {
            key: 'result',
            header: t('patients.broadcasts.columns.result'),
            width: 150
        },
        {
            key: 'sender',
            header: t('patients.broadcasts.columns.sender'),
            width: 130
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $66joL.SkeletonRegion), {
        label: label,
        "data-testid": "patients-skeleton",
        "data-view": "broadcasts",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: (0, $2xQve.STACK).regular,
            padding: '16px 32px 24px',
            background: (0, $jTCZr.C).bg
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonButton), {
                        size: "icon"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            fontSize: '0.8125rem',
                            color: (0, $jTCZr.C).textMuted
                        },
                        children: t('nav.items.patients')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            color: (0, $jTCZr.C).textMuted
                        },
                        children: "/"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        style: {
                            fontSize: '0.9375rem',
                            fontWeight: 800,
                            margin: 0
                        },
                        children: t('patients.broadcasts.title')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                "aria-hidden": true,
                style: {
                    display: 'flex',
                    gap: 8,
                    alignItems: 'center',
                    flexWrap: 'wrap'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: 240,
                        height: 44,
                        radius: (0, $jTCZr.RADIUS).control
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: 130,
                        height: 44,
                        radius: (0, $jTCZr.RADIUS).control
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: 140,
                        height: 44,
                        radius: (0, $jTCZr.RADIUS).control
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        height: 44,
                        radius: (0, $jTCZr.RADIUS).control,
                        style: {
                            flex: 1,
                            minWidth: 220
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: $db0bce0926fa0487$var$SURFACE,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($db0bce0926fa0487$export$594a3db5494954b7, {
                    columns: columns,
                    rows: 5,
                    standalone: false
                })
            })
        ]
    });
}
function $db0bce0926fa0487$export$bac2d68aa3a9310d({ view: view = 'list' }) {
    const { t: t } = (0, $e1LEq.default)();
    const label = t('common.state.loading');
    return view === 'broadcasts' ? /*#__PURE__*/ (0, $ayMG0.jsx)($db0bce0926fa0487$var$BroadcastsSkeletonWeb, {
        t: t,
        label: label
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)($db0bce0926fa0487$var$ListSkeletonWeb, {
        t: t,
        label: label
    });
}
// ── Mobile ─────────────────────────────────────────────────────────────────────
function $db0bce0926fa0487$var$ListSkeletonMobile({ t: t, label: label }) {
    const chips = $db0bce0926fa0487$var$SEGMENT_KEYS.map((key, i)=>({
            id: key,
            label: t(key),
            active: i === 0
        }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8RTRt.default), {
        header: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5zhhf.default), {
            sticky: true,
            title: t('nav.items.patients'),
            subtitle: t('patients.page.sub'),
            search: {
                value: '',
                onChange: $db0bce0926fa0487$var$noop,
                placeholder: t('patients.search.placeholderShort')
            }
        }),
        "data-state": "loading",
        "data-testid": "patients-skeleton",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $66joL.SkeletonRegion), {
            label: label,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gmg4I.default), {
                    chips: chips,
                    onSelect: ()=>{}
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($db0bce0926fa0487$var$StatStripSkeleton, {
                    t: t,
                    style: {
                        paddingInline: '1rem'
                    }
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        padding: '0.75rem 1rem 0',
                        display: 'grid',
                        gap: `${(0, $2xQve.STACK).tight}px`
                    },
                    children: Array.from({
                        length: 6
                    }, (_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)($db0bce0926fa0487$export$bfe7070dd6a1c87b, {}, i))
                })
            ]
        })
    });
}
const $db0bce0926fa0487$var$BROADCAST_STATE_KEYS = [
    'patients.broadcasts.filters.stateAll',
    'patients.broadcasts.state.runningShort',
    'patients.broadcasts.state.done',
    'patients.broadcasts.state.halted',
    'patients.broadcasts.state.cancelled'
];
function $db0bce0926fa0487$var$BroadcastsSkeletonMobile({ t: t, label: label }) {
    const chips = $db0bce0926fa0487$var$BROADCAST_STATE_KEYS.map((key, i)=>({
            id: key,
            label: t(key),
            active: i === 0
        }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8RTRt.default), {
        header: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5zhhf.default), {
            sticky: true,
            title: t('patients.broadcasts.title')
        }),
        "data-state": "loading",
        "data-testid": "patients-skeleton",
        "data-view": "broadcasts",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $66joL.SkeletonRegion), {
            label: label,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gmg4I.default), {
                    chips: chips,
                    onSelect: ()=>{}
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        padding: '0.75rem 1rem 0',
                        display: 'grid',
                        gap: `${(0, $2xQve.STACK).tight}px`
                    },
                    children: Array.from({
                        length: 5
                    }, (_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)($db0bce0926fa0487$export$652bcb31339d9ed3, {}, i))
                })
            ]
        })
    });
}
function $db0bce0926fa0487$export$4948d30d9050f5d9({ view: view = 'list' }) {
    const { t: t } = (0, $e1LEq.default)();
    const label = t('common.state.loading');
    return view === 'broadcasts' ? /*#__PURE__*/ (0, $ayMG0.jsx)($db0bce0926fa0487$var$BroadcastsSkeletonMobile, {
        t: t,
        label: label
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)($db0bce0926fa0487$var$ListSkeletonMobile, {
        t: t,
        label: label
    });
}
function $db0bce0926fa0487$export$2e2bcd8739ae039(props) {
    const { isMobile: isMobile } = (0, $9h2jQ.default)();
    return isMobile ? /*#__PURE__*/ (0, $ayMG0.jsx)($db0bce0926fa0487$export$4948d30d9050f5d9, {
        ...props
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)($db0bce0926fa0487$export$bac2d68aa3a9310d, {
        ...props
    });
}

});

parcelRegister("6A5OY", function(module, exports) {

$parcel$export(module.exports, "InsurerSelectorSkeleton", () => $9ae59f25d2e9abfa$export$355cdd33cf6d3382);
$parcel$export(module.exports, "default", () => $9ae59f25d2e9abfa$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("5N0ZI");
var $eJIXW = parcelRequire("eJIXW");
var $66joL = parcelRequire("66joL");

var $jTCZr = parcelRequire("jTCZr");

var $2xQve = parcelRequire("2xQve");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $9h2jQ = parcelRequire("9h2jQ");
parcelRequire("1NzLv");
var $5zhhf = parcelRequire("5zhhf");
var $8RTRt = parcelRequire("8RTRt");

var $2QJx7 = parcelRequire("2QJx7");
/**
 * «ثبت بیمار جدید» while it loads — the registration form's own shape.
 *
 * The router's Suspense fallback for `/patients/new`, so it is imported
 * eagerly and stays light: kit primitives, tokens, density, i18n, the mobile
 * shell and the section icons — never the form hook, the voice module or the
 * insurer query. The three numbered `SectionCard`s render for REAL (their
 * titles are static) with each card's field grid in placeholder blocks, so the
 * form that replaces this one lands in the same boxes.
 *
 * `InsurerSelectorSkeleton` is the one region the LOADED screen still waits
 * on: بیمه is required and its catalog is a query, so the screen draws the
 * selector's tiles as blocks until the insurers answer, in place of a spinner
 * beside a sentence (DESIGN.md §"Loading & skeleton" — region load).
 */ const $9ae59f25d2e9abfa$var$grid2 = {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 14
};
function $9ae59f25d2e9abfa$export$355cdd33cf6d3382({ columns: columns = 4, count: count = columns, label: label, standalone: /** False inside a page skeleton that already announces itself. */ standalone = true, ...rest }) {
    const { t: t } = (0, $e1LEq.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        ...standalone ? {
            role: 'status',
            'aria-busy': 'true',
            'aria-label': label || t('patients.mobile.insurersLoading'),
            'data-testid': 'insurers-skeleton'
        } : {
            'aria-hidden': true
        },
        "data-state": "loading",
        style: {
            display: 'grid',
            gap: 6
        },
        ...rest,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                width: 72,
                height: 12
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    display: 'grid',
                    gridTemplateColumns: `repeat(${columns}, 1fr)`,
                    gap: 8
                },
                children: Array.from({
                    length: count
                }, (_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        height: 74,
                        radius: 12,
                        style: {
                            width: '100%'
                        }
                    }, i))
            })
        ]
    });
}
/** The «اطلاعات پایه» card body: the name, then three two-up rows, then the two toggle groups. */ function $9ae59f25d2e9abfa$var$BasicsFields({ mobile: mobile }) {
    const row = mobile ? undefined : $9ae59f25d2e9abfa$var$grid2;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 14
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonInput), {}),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: row,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonInput), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonInput), {})
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: row,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonInput), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonInput), {})
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: row,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonInput), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonInput), {})
                ]
            })
        ]
    });
}
/** The «بیمه» card body: the selector tiles and the policy number. */ function $9ae59f25d2e9abfa$var$InsuranceFields({ mobile: mobile }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 14
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($9ae59f25d2e9abfa$export$355cdd33cf6d3382, {
                columns: mobile ? 2 : 4,
                count: 4,
                standalone: false
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonInput), {})
        ]
    });
}
/** The «سوابق» card body: the drug search, the allergy chips, the notes textarea. */ function $9ae59f25d2e9abfa$var$HistoryFields() {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 16
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonInput), {}),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'grid',
                    gap: 6
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: 88,
                        height: 12
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            display: 'flex',
                            gap: 6,
                            flexWrap: 'wrap'
                        },
                        children: Array.from({
                            length: 4
                        }, (_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                width: 64 + i % 2 * 20,
                                height: 30,
                                radius: (0, $jTCZr.RADIUS).pill
                            }, i))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonInput), {
                multiline: true
            })
        ]
    });
}
// ── Desktop ────────────────────────────────────────────────────────────────────
const $9ae59f25d2e9abfa$var$card = {
    background: (0, $jTCZr.C).card,
    border: `1px solid ${(0, $jTCZr.C).border}`,
    borderRadius: 18,
    padding: '18px 20px'
};
function $9ae59f25d2e9abfa$export$c00411908bae195f() {
    const { t: t } = (0, $e1LEq.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $66joL.SkeletonRegion), {
        label: t('common.state.loading'),
        "data-testid": "add-patient-skeleton",
        style: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            background: (0, $jTCZr.C).bg
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("header", {
                style: {
                    flexShrink: 0,
                    background: (0, $jTCZr.C).card,
                    borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
                    padding: (0, $2xQve.PANEL_PAD).regular
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            fontSize: '0.71875rem',
                            color: (0, $jTCZr.C).textMuted,
                            marginBottom: 5
                        },
                        children: [
                            t('common.brand.name'),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    margin: '0 5px'
                                },
                                children: "/"
                            }),
                            t('nav.items.patients'),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    margin: '0 5px'
                                },
                                children: "/"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                style: {
                                    color: (0, $jTCZr.C).textSecondary
                                },
                                children: t('patients.actions.addNew')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                        style: {
                            margin: 0,
                            fontSize: '1.25rem',
                            fontWeight: 800,
                            color: (0, $jTCZr.C).textPrimary
                        },
                        children: t('patients.actions.addNew')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        style: {
                            margin: '3px 0 0',
                            fontSize: '0.78125rem',
                            color: (0, $jTCZr.C).textMuted
                        },
                        children: t('patients.form.subtitle')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("main", {
                style: {
                    overflowY: 'auto',
                    flex: 1
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        display: 'flex',
                        gap: 20,
                        padding: '18px 24px 48px',
                        alignItems: 'flex-start'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                flex: 1,
                                minWidth: 0,
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 16
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                    height: 56,
                                    radius: 14
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eJIXW.default), {
                                    n: 1,
                                    title: t('patients.sections.basics'),
                                    sub: t('patients.sections.basicsHint'),
                                    icon: (0, $2QJx7.UserIcon),
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($9ae59f25d2e9abfa$var$BasicsFields, {})
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eJIXW.default), {
                                    n: 2,
                                    title: t('patients.sections.insurance'),
                                    sub: t('patients.sections.insuranceHint'),
                                    icon: (0, $2QJx7.ShieldIcon),
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($9ae59f25d2e9abfa$var$InsuranceFields, {})
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eJIXW.default), {
                                    n: 3,
                                    title: t('patients.sections.history'),
                                    sub: t('patients.sections.historyHint'),
                                    icon: (0, $2QJx7.ClipboardIcon),
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($9ae59f25d2e9abfa$var$HistoryFields, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("aside", {
                            style: {
                                width: 290,
                                flexShrink: 0,
                                position: 'sticky',
                                top: 18,
                                display: 'flex',
                                flexDirection: 'column',
                                gap: (0, $2xQve.STACK).regular
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: $9ae59f25d2e9abfa$var$card,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                fontSize: '0.78125rem',
                                                fontWeight: 700,
                                                color: (0, $jTCZr.C).textMuted,
                                                marginBottom: 14,
                                                textAlign: 'center'
                                            },
                                            children: t('patients.preview.title')
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                display: 'grid',
                                                placeItems: 'center',
                                                marginBottom: 10
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonAvatar), {
                                                size: 60
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                            width: 140,
                                            height: 18,
                                            style: {
                                                margin: '0 auto 14px'
                                            }
                                        }),
                                        Array.from({
                                            length: 8
                                        }, (_, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                style: {
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    padding: '7px 0',
                                                    borderBottom: `1px solid ${(0, $jTCZr.C).border}`
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                                        width: 70,
                                                        height: 12
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                                        width: 56,
                                                        height: 12
                                                    })
                                                ]
                                            }, i))
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    style: {
                                        ...$9ae59f25d2e9abfa$var$card,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: (0, $2xQve.STACK).tight
                                    },
                                    children: Array.from({
                                        length: 4
                                    }, (_, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            style: {
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 8
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                                    width: 18,
                                                    circle: true
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                                    width: 110 + i % 2 * 30,
                                                    height: 12
                                                })
                                            ]
                                        }, i))
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonButton), {
                                    width: "100%",
                                    style: {
                                        height: 48
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonButton), {
                                    width: "100%"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
function $9ae59f25d2e9abfa$export$83e5d3a5c259d1ba() {
    const { t: t } = (0, $e1LEq.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8RTRt.default), {
        header: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5zhhf.default), {
            title: t('patients.actions.addNew'),
            subtitle: t('patients.form.subtitle')
        }),
        cta: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            "aria-hidden": true,
            style: {
                display: 'grid',
                gap: '0.5rem'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        display: 'flex',
                        gap: '0.75rem',
                        flexWrap: 'wrap'
                    },
                    children: Array.from({
                        length: 3
                    }, (_, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            style: {
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '0.3125rem'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                    width: 14,
                                    circle: true
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                    width: 56 + i % 2 * 16,
                                    height: 11
                                })
                            ]
                        }, i))
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonButton), {
                    width: "100%"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonButton), {
                    width: "100%"
                })
            ]
        }),
        "data-state": "loading",
        "data-testid": "add-patient-skeleton",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $66joL.SkeletonRegion), {
            label: t('common.state.loading'),
            style: {
                padding: '0.75rem 0.75rem 0',
                display: 'grid',
                gap: `${(0, $2xQve.STACK).regular}px`
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                    height: 56,
                    radius: 14
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eJIXW.default), {
                    n: 1,
                    title: t('patients.sections.basics'),
                    icon: (0, $2QJx7.UserIcon),
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($9ae59f25d2e9abfa$var$BasicsFields, {
                        mobile: true
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eJIXW.default), {
                    n: 2,
                    title: t('patients.sections.insurance'),
                    icon: (0, $2QJx7.ShieldIcon),
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($9ae59f25d2e9abfa$var$InsuranceFields, {
                        mobile: true
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eJIXW.default), {
                    n: 3,
                    title: t('patients.sections.history'),
                    icon: (0, $2QJx7.ClipboardIcon),
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($9ae59f25d2e9abfa$var$HistoryFields, {})
                })
            ]
        })
    });
}
function $9ae59f25d2e9abfa$export$2e2bcd8739ae039(props) {
    const { isMobile: isMobile } = (0, $9h2jQ.default)();
    return isMobile ? /*#__PURE__*/ (0, $ayMG0.jsx)($9ae59f25d2e9abfa$export$83e5d3a5c259d1ba, {
        ...props
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)($9ae59f25d2e9abfa$export$c00411908bae195f, {
        ...props
    });
}

});
parcelRegister("2QJx7", function(module, exports) {

$parcel$export(module.exports, "MicIcon", () => $87a027a4824c69bc$export$592efa5f07538585);
$parcel$export(module.exports, "StopIcon", () => $87a027a4824c69bc$export$dc6949a98411e916);
$parcel$export(module.exports, "CheckIcon", () => $87a027a4824c69bc$export$7dd004358974b05d);
$parcel$export(module.exports, "CloseIcon", () => $87a027a4824c69bc$export$cae179f078f4b4a4);
$parcel$export(module.exports, "PlusIcon", () => $87a027a4824c69bc$export$f21ab0717a89c77f);
$parcel$export(module.exports, "TrashIcon", () => $87a027a4824c69bc$export$d23329de703dffc4);
$parcel$export(module.exports, "PillIcon", () => $87a027a4824c69bc$export$4174a484cb4ffc82);
$parcel$export(module.exports, "SparkleIcon", () => $87a027a4824c69bc$export$1019ff5537a7252e);
$parcel$export(module.exports, "CoinIcon", () => $87a027a4824c69bc$export$eaa014e170f0b2a6);
$parcel$export(module.exports, "UserIcon", () => $87a027a4824c69bc$export$4202723ba73439f5);
$parcel$export(module.exports, "ShieldIcon", () => $87a027a4824c69bc$export$2d8598c0b89a07db);
$parcel$export(module.exports, "ClipboardIcon", () => $87a027a4824c69bc$export$60f3f00eeba09710);
$parcel$export(module.exports, "DropIcon", () => $87a027a4824c69bc$export$d6db6492234ff599);
$parcel$export(module.exports, "INS_ICONS", () => $87a027a4824c69bc$export$5481ec96cba3e00b);
/**
 * The line icons the registration screen draws.
 *
 * The kit ships no icon set, and both presenters used to carry their own copy of
 * these twenty paths at two different sizes. One copy, one size prop.
 */ 
var $ayMG0 = parcelRequire("ayMG0");
const $87a027a4824c69bc$var$Ic = ({ d: d, size: size = 18, sw: sw = 1.7, ...rest })=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: sw,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": "true",
        ...rest,
        children: Array.isArray(d) ? d.map((p, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: p
            }, i)) : /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: d
        })
    });
const $87a027a4824c69bc$export$592efa5f07538585 = (p)=>/*#__PURE__*/ (0, $ayMG0.jsx)($87a027a4824c69bc$var$Ic, {
        ...p,
        d: [
            'M12 2a3 3 0 0 0-3 3v6a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3z',
            'M19 10v1a7 7 0 0 1-14 0v-1',
            'M12 18v4M8 22h8'
        ]
    });
const $87a027a4824c69bc$export$dc6949a98411e916 = (p)=>/*#__PURE__*/ (0, $ayMG0.jsx)($87a027a4824c69bc$var$Ic, {
        ...p,
        d: "M7 7h10v10H7z",
        sw: 0
    });
const $87a027a4824c69bc$export$7dd004358974b05d = (p)=>/*#__PURE__*/ (0, $ayMG0.jsx)($87a027a4824c69bc$var$Ic, {
        ...p,
        d: "m5 12 4.5 4.5L19 7"
    });
const $87a027a4824c69bc$export$cae179f078f4b4a4 = (p)=>/*#__PURE__*/ (0, $ayMG0.jsx)($87a027a4824c69bc$var$Ic, {
        ...p,
        d: [
            'M18 6 6 18',
            'M6 6l12 12'
        ]
    });
const $87a027a4824c69bc$export$f21ab0717a89c77f = (p)=>/*#__PURE__*/ (0, $ayMG0.jsx)($87a027a4824c69bc$var$Ic, {
        ...p,
        d: [
            'M12 5v14',
            'M5 12h14'
        ]
    });
const $87a027a4824c69bc$export$d23329de703dffc4 = (p)=>/*#__PURE__*/ (0, $ayMG0.jsx)($87a027a4824c69bc$var$Ic, {
        ...p,
        d: [
            'M3 6h18',
            'M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2m2 0v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6',
            'M10 11v6',
            'M14 11v6'
        ]
    });
const $87a027a4824c69bc$export$4174a484cb4ffc82 = (p)=>/*#__PURE__*/ (0, $ayMG0.jsx)($87a027a4824c69bc$var$Ic, {
        ...p,
        d: [
            'M10.5 20.5a5 5 0 0 1-7-7l6-6a5 5 0 0 1 7 7z',
            'm8 8 7 7'
        ]
    });
const $87a027a4824c69bc$export$1019ff5537a7252e = (p)=>/*#__PURE__*/ (0, $ayMG0.jsx)($87a027a4824c69bc$var$Ic, {
        ...p,
        d: [
            'M12 3l1.8 4.9L18 9.7l-4.2 1.8L12 16l-1.8-4.5L6 9.7l4.2-1.8z',
            'M19 14l.7 1.8L21 16.5l-1.3.7L19 19l-.7-1.8L17 16.5l1.3-.7z'
        ]
    });
const $87a027a4824c69bc$export$eaa014e170f0b2a6 = (p)=>/*#__PURE__*/ (0, $ayMG0.jsx)($87a027a4824c69bc$var$Ic, {
        ...p,
        d: [
            'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z',
            'M12 7v10',
            'M14.5 9.5A2.5 2.5 0 0 0 12 8h-.5a2 2 0 0 0 0 4h1a2 2 0 0 1 0 4H12a2.5 2.5 0 0 1-2.5-1.5'
        ]
    });
const $87a027a4824c69bc$export$4202723ba73439f5 = (p)=>/*#__PURE__*/ (0, $ayMG0.jsx)($87a027a4824c69bc$var$Ic, {
        ...p,
        d: [
            'M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8z',
            'M4 21v-1a6 6 0 0 1 6-6h4a6 6 0 0 1 6 6v1'
        ]
    });
const $87a027a4824c69bc$export$2d8598c0b89a07db = (p)=>/*#__PURE__*/ (0, $ayMG0.jsx)($87a027a4824c69bc$var$Ic, {
        ...p,
        d: "M12 3l8 3v5c0 5-3.5 8-8 10-4.5-2-8-5-8-10V6z"
    });
const $87a027a4824c69bc$export$60f3f00eeba09710 = (p)=>/*#__PURE__*/ (0, $ayMG0.jsx)($87a027a4824c69bc$var$Ic, {
        ...p,
        d: [
            'M9 4h6v3H9z',
            'M7 5H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1',
            'M9 12h6',
            'M9 16h4'
        ]
    });
const $87a027a4824c69bc$export$303bcfb89f07c53e = (p)=>/*#__PURE__*/ (0, $ayMG0.jsx)($87a027a4824c69bc$var$Ic, {
        ...p,
        d: [
            'M4 5h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1z',
            'M12 9v6',
            'M9 12h6'
        ]
    });
const $87a027a4824c69bc$export$e32f68df2d27987 = (p)=>/*#__PURE__*/ (0, $ayMG0.jsx)($87a027a4824c69bc$var$Ic, {
        ...p,
        d: [
            'M12 14a5 5 0 1 0 0-10 5 5 0 0 0 0 10z',
            'M8.5 13l-1.5 8 5-3 5 3-1.5-8'
        ]
    });
const $87a027a4824c69bc$export$16f03ed71cfb60c9 = (p)=>/*#__PURE__*/ (0, $ayMG0.jsx)($87a027a4824c69bc$var$Ic, {
        ...p,
        d: "M19 14c1.5-1.5 3-3.2 3-5.5A4.5 4.5 0 0 0 12 5.5 4.5 4.5 0 0 0 2 8.5c0 2.3 1.5 4 3 5.5l7 7z"
    });
const $87a027a4824c69bc$export$d6db6492234ff599 = (p)=>/*#__PURE__*/ (0, $ayMG0.jsx)($87a027a4824c69bc$var$Ic, {
        ...p,
        d: "M12 2C12 2 5 10 5 14a7 7 0 0 0 14 0C19 10 12 2 12 2z"
    });
const $87a027a4824c69bc$export$5481ec96cba3e00b = {
    tamin: $87a027a4824c69bc$export$303bcfb89f07c53e,
    armed: $87a027a4824c69bc$export$e32f68df2d27987,
    salamat: $87a027a4824c69bc$export$16f03ed71cfb60c9,
    azad: $87a027a4824c69bc$export$60f3f00eeba09710
};
var $87a027a4824c69bc$export$2e2bcd8739ae039 = $87a027a4824c69bc$var$Ic;

});


parcelRegister("bOuMz", function(module, exports) {

$parcel$export(module.exports, "OperationsSkeletonWeb", () => $78dbb32fdd474f3f$export$e971469f70ac4e8e);
$parcel$export(module.exports, "renderOperationsCardSkeleton", () => $78dbb32fdd474f3f$export$d140b067e391bdf2);
$parcel$export(module.exports, "OperationsSkeletonMobile", () => $78dbb32fdd474f3f$export$4010e70675c54b6a);
$parcel$export(module.exports, "default", () => $78dbb32fdd474f3f$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $66joL = parcelRequire("66joL");

var $jTCZr = parcelRequire("jTCZr");

var $2xQve = parcelRequire("2xQve");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $9h2jQ = parcelRequire("9h2jQ");
parcelRequire("1NzLv");
var $7NBSI = parcelRequire("7NBSI");
var $5zhhf = parcelRequire("5zhhf");
var $8RTRt = parcelRequire("8RTRt");

var $9TvQP = parcelRequire("9TvQP");
/**
 * «مدیریت هزینه‌ها» while it is still fetching — the page's own shape, in
 * placeholder blocks, drawn for a `view` (DESIGN.md §"Loading & skeleton").
 *
 * The router's Suspense fallback imports this EAGERLY, and the screen uses the
 * same component for its first load, so the fallback → first-load transition
 * does not jump. That is why it imports nothing from the screen: only the kit,
 * the tokens, the density scale, i18n, the mobile primitives and the shared
 * workbench geometry.
 *
 * The desktop anatomy it mirrors (Operations.web.jsx):
 *
 *   ① header     title · subtitle | window picker · primary action
 *   ② cost strip four KPI cards, no icon slot
 *   ③ rail       176px, two groups — two daily entries and three definitions
 *   ④ surface    the view's toolbar + its dense table (دفتر هزینه، قبوض), or a
 *                heading + add-form + bordered rows (the setup views — those are
 *                NOT tables, see RowSkeleton)
 *
 * Static chrome that needs no data (the page title, the view's heading) renders
 * for real so the page keeps its identity through the wait (brief rule 5);
 * everything data-dependent is a block.
 *
 * The goods views it used to draw moved to `screens/Goods/GoodsSkeleton.jsx`
 * with their page (docs/CLINIC_EXPENSES_AND_GOODS_SPLIT_DESIGN.md). A bookmark
 * to an old `/operations?view=items` link never reaches this file: the skeleton
 * registry resolves it to the goods page BEFORE the router forwards it, so the
 * operator sees one skeleton rather than the wrong one and then the right one.
 */ /** `?view=setup` is not a real view; it lands on the first setup entry. */ // «تعریف‌ها» used to open on «تعریف مراکز هزینه»; that view is gone (centres are
// derived now), so the group's first surviving destination is the recurring one.
const $78dbb32fdd474f3f$var$VIEW_ALIASES = {
    setup: 'recurring',
    costCenters: 'recurring'
};
const $78dbb32fdd474f3f$var$TABLE_VIEWS = {
    // Column widths mirror each view's `columns` definition; the first column is
    // the flexible one and gets the name-cell block.
    expenses: {
        columns: [
            130,
            180,
            120,
            130,
            120,
            128,
            132
        ],
        rows: 8,
        filters: {
            search: 240,
            select: 150,
            chips: 3
        }
    },
    // Column widths mirror BillsView's own `columns`; the five status chips are the
    // derived filters plus the two stored ones the toolbar offers.
    bills: {
        columns: [
            124,
            180,
            150,
            130,
            128,
            168,
            128,
            128
        ],
        rows: 8,
        filters: {
            search: 240,
            select: 180,
            chips: 5
        }
    }
};
const $78dbb32fdd474f3f$var$SETUP_VIEWS = {
    recurring: {
        maxWidth: 720,
        form: null,
        rows: 2,
        actions: 2
    },
    billTypes: {
        maxWidth: 860,
        form: [
            {
                flex: 1
            },
            {
                width: 150
            },
            {
                width: 150
            }
        ],
        rows: 3,
        actions: 3
    }
};
function $78dbb32fdd474f3f$export$84eccba4d569bd61(view) {
    const key = $78dbb32fdd474f3f$var$VIEW_ALIASES[view] || view;
    return $78dbb32fdd474f3f$var$TABLE_VIEWS[key] || $78dbb32fdd474f3f$var$SETUP_VIEWS[key] ? key : 'expenses';
}
const $78dbb32fdd474f3f$var$viewTitleKey = (view)=>`operations.views.${view}`;
function $78dbb32fdd474f3f$export$764c583567ddd868() {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9TvQP.RailSkeleton), {
        groups: [
            2,
            3
        ]
    });
}
function $78dbb32fdd474f3f$export$e971469f70ac4e8e({ view: requested = 'expenses' }) {
    const { t: t } = (0, $e1LEq.default)();
    const view = $78dbb32fdd474f3f$export$84eccba4d569bd61(requested);
    const label = t('common.state.loading');
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $66joL.SkeletonRegion), {
        label: label,
        "data-testid": "operations-skeleton",
        "data-view": view,
        style: (0, $9TvQP.WORKBENCH_ROOT),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("header", {
                style: (0, $9TvQP.WORKBENCH_HEADER),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                style: {
                                    margin: 0,
                                    fontSize: '1.125rem',
                                    fontWeight: 700,
                                    color: (0, $jTCZr.C).textPrimary
                                },
                                children: t('nav.items.operations')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                style: {
                                    margin: '3px 0 0',
                                    fontSize: '0.75rem',
                                    color: (0, $jTCZr.C).textMuted
                                },
                                children: t('operations.subtitle')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 10
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9TvQP.WindowPicker), {}),
                            $78dbb32fdd474f3f$var$TABLE_VIEWS[view] ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonButton), {
                                width: 128
                            }) : null
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    padding: '14px 20px',
                    flexShrink: 0
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonStats), {
                    count: 4,
                    icon: false,
                    label: label
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    flex: 1,
                    minHeight: 0,
                    borderTop: `1px solid ${(0, $jTCZr.C).border}`
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($78dbb32fdd474f3f$export$764c583567ddd868, {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("main", {
                        style: (0, $9TvQP.WORKBENCH_MAIN),
                        children: $78dbb32fdd474f3f$var$TABLE_VIEWS[view] ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9TvQP.TableSurface), {
                            spec: $78dbb32fdd474f3f$var$TABLE_VIEWS[view],
                            label: label
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9TvQP.SetupSurface), {
                            spec: $78dbb32fdd474f3f$var$SETUP_VIEWS[view],
                            title: t($78dbb32fdd474f3f$var$viewTitleKey(view)),
                            label: label
                        })
                    })
                ]
            })
        ]
    });
}
const $78dbb32fdd474f3f$export$7038643fd9d36899 = {
    // MobileExpenseCard: title + amount on the head line, one meta line, a
    // status badge, and (for an approver) the approve/reject shelf.
    expenses: ({ actions: actions = 0 } = {})=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $7NBSI.default), {
            badge: 72,
            metaLines: 1,
            chips: 1,
            actions: actions
        }),
    // Bills reuse MobileExpenseCard, but with a longer meta line — period, due
    // date, cost centre and the payment identifier — and one action shelf
    // («ثبت پرداخت» / «تأیید قبض»).
    bills: ({ actions: actions = 0 } = {})=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $7NBSI.default), {
            badge: 72,
            metaLines: 2,
            chips: 1,
            actions: actions
        })
};
const $78dbb32fdd474f3f$export$d140b067e391bdf2 = (view, opts)=>(i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
            children: ($78dbb32fdd474f3f$export$7038643fd9d36899[view] || $78dbb32fdd474f3f$export$7038643fd9d36899.expenses)(opts)
        }, i);
const $78dbb32fdd474f3f$var$MOBILE_VIEWS = new Set([
    'expenses',
    'bills'
]);
function $78dbb32fdd474f3f$export$4010e70675c54b6a({ view: requested = 'expenses', actions: actions = 0 }) {
    const { t: t } = (0, $e1LEq.default)();
    const view = $78dbb32fdd474f3f$var$MOBILE_VIEWS.has(requested) ? requested : 'expenses';
    const label = t('common.state.loading');
    const card = $78dbb32fdd474f3f$export$7038643fd9d36899[view];
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonRegion), {
        label: label,
        "data-testid": "operations-skeleton",
        "data-view": view,
        style: {
            height: '100%'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $8RTRt.default), {
            header: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5zhhf.default), {
                title: t('nav.items.operations'),
                subtitle: t('operations.mobileTitle'),
                sticky: true,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "mobile-strip",
                    style: {
                        overflowX: 'hidden',
                        paddingBlock: '0.125rem'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9TvQP.WindowPicker), {
                        height: 44
                    })
                })
            }),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9TvQP.MobileSectionStrip), {
                    widths: [
                        64,
                        52
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        padding: '0.75rem 1rem 0',
                        display: 'grid',
                        gap: '0.5rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7NBSI.default), {
                            metaLines: 0,
                            badge: 88
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7NBSI.default), {
                            metaLines: 0,
                            badge: 88
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    "aria-hidden": true,
                    style: {
                        display: 'flex',
                        gap: '0.5rem',
                        paddingBlock: '0.5rem',
                        paddingInline: '1rem',
                        overflow: 'hidden'
                    },
                    children: [
                        56,
                        96,
                        80,
                        72
                    ].map((w, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                            width: w,
                            height: 44,
                            radius: (0, $jTCZr.RADIUS).pill
                        }, i))
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        padding: '0 1rem 1.5rem',
                        display: 'grid',
                        gap: `${(0, $2xQve.STACK).tight}px`
                    },
                    children: Array.from({
                        length: 5
                    }, (_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                            children: card({
                                actions: actions
                            })
                        }, i))
                })
            ]
        })
    });
}
function $78dbb32fdd474f3f$export$2e2bcd8739ae039(props) {
    const { isMobile: isMobile } = (0, $9h2jQ.default)();
    return isMobile ? /*#__PURE__*/ (0, $ayMG0.jsx)($78dbb32fdd474f3f$export$4010e70675c54b6a, {
        ...props
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)($78dbb32fdd474f3f$export$e971469f70ac4e8e, {
        ...props
    });
}

});
parcelRegister("9TvQP", function(module, exports) {

$parcel$export(module.exports, "WindowPicker", () => $9bdaa4469975b76a$export$dc1b4b9f77d8d05f);
$parcel$export(module.exports, "RailSkeleton", () => $9bdaa4469975b76a$export$1cb8a98a759dc5c5);
$parcel$export(module.exports, "TableSurface", () => $9bdaa4469975b76a$export$97dc1ef6dd8b19f);
$parcel$export(module.exports, "SetupSurface", () => $9bdaa4469975b76a$export$4e07f0ae38a83140);
$parcel$export(module.exports, "MobileSectionStrip", () => $9bdaa4469975b76a$export$8536b0c4c862ac94);
$parcel$export(module.exports, "WORKBENCH_ROOT", () => $9bdaa4469975b76a$export$68d0db57d00a7f7);
$parcel$export(module.exports, "WORKBENCH_HEADER", () => $9bdaa4469975b76a$export$e44ef8200d982d2c);
$parcel$export(module.exports, "WORKBENCH_MAIN", () => $9bdaa4469975b76a$export$e515b04767d39a7c);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("5N0ZI");
var $66joL = parcelRequire("66joL");

var $jTCZr = parcelRequire("jTCZr");

var $2xQve = parcelRequire("2xQve");

var $k1cLa = parcelRequire("k1cLa");
function $9bdaa4469975b76a$export$dc1b4b9f77d8d05f({ height: height = 36 }) {
    // The kit `SegmentedControl`: 36px options (44 at `lg`) in a 4px-padded track.
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        "aria-hidden": true,
        style: {
            display: 'inline-flex',
            gap: 4,
            padding: 4,
            borderRadius: 12,
            background: (0, $jTCZr.C).bg
        },
        children: [
            64,
            72,
            68,
            48
        ].map((w, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                width: w,
                height: height,
                radius: 9
            }, i))
    });
}
function $9bdaa4469975b76a$export$1cb8a98a759dc5c5({ groups: groups = [
    3,
    4
] }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("nav", {
        "aria-hidden": true,
        style: {
            width: 176,
            flexShrink: 0,
            borderInlineEnd: `1px solid ${(0, $jTCZr.C).border}`,
            background: (0, $jTCZr.C).card,
            padding: '12px 8px'
        },
        children: [
            groups.map((count, gi)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        marginTop: gi ? 18 : 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                padding: '0 10px',
                                marginBottom: 6
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                width: 64,
                                height: 11
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 2
                            },
                            children: Array.from({
                                length: count
                            }, (_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    style: {
                                        padding: '9px 10px'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                        width: [
                                            72,
                                            56,
                                            64,
                                            80
                                        ][i % 4],
                                        height: 13
                                    })
                                }, i))
                        })
                    ]
                }, gi)),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    height: (0, $2xQve.STACK).regular
                }
            })
        ]
    });
}
function $9bdaa4469975b76a$export$97dc1ef6dd8b19f({ spec: spec, label: label }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            minHeight: 0,
            flex: 1
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                "aria-hidden": true,
                style: {
                    display: 'flex',
                    gap: 8,
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    padding: '10px 20px',
                    borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
                    flexShrink: 0
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: spec.filters.search,
                        height: 44,
                        radius: (0, $jTCZr.RADIUS).control
                    }),
                    spec.filters.select ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: spec.filters.select,
                        height: 44,
                        radius: (0, $jTCZr.RADIUS).control
                    }) : null,
                    Array.from({
                        length: spec.filters.chips
                    }, (_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                            width: [
                                52,
                                96,
                                88
                            ][i % 3],
                            height: 36,
                            radius: (0, $jTCZr.RADIUS).pill
                        }, i)),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            marginInlineStart: 'auto',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                width: 56,
                                height: 12
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonButton), {
                                size: "sm",
                                width: 72
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonButton), {
                                size: "sm",
                                width: 96
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    flex: 1,
                    overflow: 'hidden',
                    padding: '12px 20px 20px'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonTable), {
                    dense: true,
                    rows: spec.rows,
                    columns: spec.columns,
                    label: label
                })
            })
        ]
    });
}
function $9bdaa4469975b76a$export$4e07f0ae38a83140({ spec: spec, title: title, label: label }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: {
            flex: 1,
            overflow: 'hidden',
            padding: (0, $2xQve.PANEL_PAD).regular
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            style: {
                maxWidth: spec.maxWidth
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    style: {
                        margin: 0,
                        fontSize: '1rem',
                        fontWeight: 700,
                        color: (0, $jTCZr.C).textPrimary
                    },
                    children: title
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    "aria-hidden": true,
                    style: {
                        margin: '6px 0 16px',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 6
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                            width: "72%",
                            height: 12
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                            width: "48%",
                            height: 12
                        })
                    ]
                }),
                spec.form ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    "aria-hidden": true,
                    style: {
                        display: 'flex',
                        gap: 8,
                        alignItems: 'flex-end',
                        marginBottom: 16
                    },
                    children: [
                        spec.form.map((f, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonInput), {
                                width: f.width,
                                style: f.flex ? {
                                    flex: 1
                                } : undefined
                            }, i)),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonButton), {
                            width: 96
                        })
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    "aria-hidden": true,
                    style: {
                        padding: 12,
                        border: `1px solid ${(0, $jTCZr.C).border}`,
                        borderRadius: 10,
                        marginBottom: 16
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                display: 'grid',
                                gridTemplateColumns: '1fr 1fr',
                                gap: 10,
                                marginBottom: 10
                            },
                            children: Array.from({
                                length: 4
                            }, (_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonInput), {}, i))
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                marginBottom: 10
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonInput), {})
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonButton), {
                            width: 140
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonRegion), {
                    label: label,
                    children: Array.from({
                        length: spec.rows
                    }, (_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $k1cLa.SetupRowSkeleton), {
                            actions: spec.actions
                        }, i))
                })
            ]
        })
    });
}
function $9bdaa4469975b76a$export$8536b0c4c862ac94({ widths: widths = [
    64,
    52,
    48
] }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        "aria-hidden": true,
        style: {
            display: 'flex',
            gap: 4,
            padding: '0 0.25rem',
            borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
            background: (0, $jTCZr.C).bg
        },
        children: widths.map((w, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    padding: '12px 14px'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                    width: w,
                    height: 12
                })
            }, i))
    });
}
const $9bdaa4469975b76a$export$68d0db57d00a7f7 = {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    background: (0, $jTCZr.C).bg,
    overflow: 'hidden'
};
const $9bdaa4469975b76a$export$e44ef8200d982d2c = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 16,
    flexWrap: 'wrap',
    padding: '14px 20px',
    background: (0, $jTCZr.C).card,
    borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
    flexShrink: 0
};
const $9bdaa4469975b76a$export$e515b04767d39a7c = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
    background: (0, $jTCZr.C).card
};

});
parcelRegister("k1cLa", function(module, exports) {

$parcel$export(module.exports, "SetupRowSkeleton", () => $fd0496cb5cb05de4$export$4d08364282233148);
$parcel$export(module.exports, "SetupRowsSkeleton", () => $fd0496cb5cb05de4$export$a8309c61e37042e5);
$parcel$export(module.exports, "CatalogRowsSkeleton", () => $fd0496cb5cb05de4$export$fda6d15648f107c9);
$parcel$export(module.exports, "MovementRowsSkeleton", () => $fd0496cb5cb05de4$export$ec02723921bf9538);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $66joL = parcelRequire("66joL");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");
function $fd0496cb5cb05de4$export$4d08364282233148({ actions: actions = 2, meta: meta = true, style: style }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "aria-hidden": true,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '9px 12px',
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: 10,
            marginBottom: 8,
            background: '#fff',
            ...style
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    flex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    minWidth: 0
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: "34%",
                        height: 14
                    }),
                    meta ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: "18%",
                        height: 11
                    }) : null
                ]
            }),
            Array.from({
                length: actions
            }, (_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonButton), {
                    size: "sm",
                    width: [
                        52,
                        60,
                        48
                    ][i % 3]
                }, i))
        ]
    });
}
function $fd0496cb5cb05de4$export$a8309c61e37042e5({ count: count = 3, actions: actions = 2, meta: meta = true, label: label, style: style, ...rest }) {
    const { t: t } = (0, $e1LEq.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonRegion), {
        label: label ?? t('common.state.loading'),
        style: style,
        ...rest,
        children: Array.from({
            length: count
        }, (_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)($fd0496cb5cb05de4$export$4d08364282233148, {
                actions: actions,
                meta: meta
            }, i))
    });
}
function $fd0496cb5cb05de4$export$fda6d15648f107c9({ groups: groups = 2, rows: rows = 4, multi: multi = false, label: label, ...rest }) {
    const { t: t } = (0, $e1LEq.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonRegion), {
        label: label ?? t('common.state.loading'),
        ...rest,
        children: Array.from({
            length: groups
        }, (_, g)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            padding: '9px 12px 4px'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                            width: 72 + g % 2 * 24,
                            height: 11
                        })
                    }),
                    Array.from({
                        length: rows
                    }, (_, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                display: 'flex',
                                alignItems: 'center',
                                gap: 8,
                                padding: '7px 12px',
                                minHeight: 34
                            },
                            children: [
                                multi ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                    width: 14,
                                    height: 14,
                                    radius: 3
                                }) : null,
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                    width: `${40 + (g * 3 + i) * 13 % 35}%`,
                                    height: 13
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        flex: 1
                                    }
                                }),
                                i % 3 === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                    width: 44,
                                    height: 16,
                                    radius: 5
                                }) : null,
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                    width: 22,
                                    height: 11
                                })
                            ]
                        }, i))
                ]
            }, g))
    });
}
function $fd0496cb5cb05de4$export$ec02723921bf9538({ count: count = 3, label: label, ...rest }) {
    const { t: t } = (0, $e1LEq.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonRegion), {
        label: label ?? t('common.state.loading'),
        ...rest,
        children: Array.from({
            length: count
        }, (_, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    gap: 10,
                    padding: '10px 0',
                    borderBottom: `1px solid ${(0, $jTCZr.C).border}`
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: 28,
                        circle: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            flex: 1,
                            minWidth: 0,
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 6
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    gap: 8
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                        width: `${44 + i * 17 % 30}%`,
                                        height: 12
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                        width: 36,
                                        height: 12
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                width: "30%",
                                height: 10,
                                radius: (0, $jTCZr.RADIUS).chip
                            })
                        ]
                    })
                ]
            }, i))
    });
}

});



parcelRegister("c8S29", function(module, exports) {

$parcel$export(module.exports, "GoodsSkeletonWeb", () => $64342bc4200bc29f$export$f59a51f6709a8d6b);
$parcel$export(module.exports, "renderGoodsCardSkeleton", () => $64342bc4200bc29f$export$207b8bd2756ea503);
$parcel$export(module.exports, "GoodsSkeletonMobile", () => $64342bc4200bc29f$export$27367d93507316ca);
$parcel$export(module.exports, "default", () => $64342bc4200bc29f$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $66joL = parcelRequire("66joL");

var $jTCZr = parcelRequire("jTCZr");

var $2xQve = parcelRequire("2xQve");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $9h2jQ = parcelRequire("9h2jQ");
parcelRequire("1NzLv");
var $7NBSI = parcelRequire("7NBSI");
var $5zhhf = parcelRequire("5zhhf");
var $8RTRt = parcelRequire("8RTRt");

var $9TvQP = parcelRequire("9TvQP");
/**
 * «کالاها و خدمات» while it is still fetching — the page's own shape, in
 * placeholder blocks, drawn for a `view` (DESIGN.md §"Loading & skeleton").
 *
 * The router's Suspense fallback imports this EAGERLY, and the screen uses the
 * same component for its first load, so the fallback → first-load transition
 * does not jump. That is why it imports nothing from the screen: only the kit,
 * the tokens, the density scale, i18n, the mobile primitives and the shared
 * workbench geometry.
 *
 * The desktop anatomy it mirrors (Goods.web.jsx):
 *
 *   ① header      title · subtitle | «گزارش …» link · primary action — and NO
 *                 window picker and NO stat strip: nothing here is windowed,
 *                 and the figures live in «گزارش‌ها» (PM-0495)
 *   ③ rail        176px, two groups — three daily entries and up to eight
 *                 definitions, five of which only a clinic's tier reveals
 *   ④ surface     the view's toolbar + its dense table (کالاها، خدمات، تجهیزات),
 *                 or a heading + add-form + bordered rows (the setup views and
 *                 the lifecycle screens — those are NOT tables, see RowSkeleton)
 *
 * **The rail is drawn at its «ساده» size**, for the same reason the screen
 * assumes «ساده» until the settings land: adding entries is far better than
 * flashing five that then vanish.
 */ const $64342bc4200bc29f$var$TABLE_VIEWS = {
    // Column widths mirror each view's `columns` definition; the first column is
    // the flexible one and gets the name-cell block.
    items: {
        columns: [
            160,
            100,
            160,
            120,
            120,
            110,
            110
        ],
        rows: 8,
        filters: {
            search: 220,
            select: 150,
            chips: 3
        }
    },
    services: {
        columns: [
            180,
            120,
            120,
            130,
            84,
            110,
            92
        ],
        rows: 6,
        filters: {
            search: 240,
            select: 160,
            chips: 0
        }
    },
    // EquipmentView's own `columns`; the six chips are the status filters.
    equipment: {
        columns: [
            84,
            200,
            120,
            130,
            170,
            130,
            96
        ],
        rows: 8,
        filters: {
            search: 220,
            select: 150,
            chips: 6
        }
    }
};
const $64342bc4200bc29f$var$SETUP_VIEWS = {
    suppliers: {
        maxWidth: 720,
        form: [
            {
                flex: 1
            },
            {
                width: 170
            }
        ],
        rows: 3,
        actions: 3
    },
    equipmentTypes: {
        maxWidth: 860,
        form: [
            {
                flex: 1
            },
            {
                width: 150
            },
            {
                width: 150
            }
        ],
        rows: 3,
        actions: 2
    },
    insurance: {
        maxWidth: 860,
        form: [
            {
                flex: 1
            },
            {
                width: 130
            },
            {
                width: 160
            }
        ],
        rows: 3,
        actions: 2
    },
    // The five tier-gated lifecycle screens. Each is a heading over a document
    // list rather than a table, so they draw the setup shape at their own width.
    expiry: {
        maxWidth: 900,
        form: null,
        rows: 4,
        actions: 2
    },
    procurement: {
        maxWidth: 900,
        form: null,
        rows: 4,
        actions: 2
    },
    custody: {
        maxWidth: 900,
        form: null,
        rows: 3,
        actions: 2
    },
    counts: {
        maxWidth: 860,
        form: null,
        rows: 3,
        actions: 2
    },
    locations: {
        maxWidth: 720,
        form: [
            {
                flex: 1
            },
            {
                width: 150
            }
        ],
        rows: 3,
        actions: 2
    }
};
function $64342bc4200bc29f$export$84eccba4d569bd61(view) {
    return $64342bc4200bc29f$var$TABLE_VIEWS[view] || $64342bc4200bc29f$var$SETUP_VIEWS[view] ? view : 'services';
}
/** «بیمه» is its own namespace; every other view names itself in `operations`. */ function $64342bc4200bc29f$var$viewTitleKey(view) {
    return view === 'insurance' ? 'insurance.title' : `operations.views.${view}`;
}
function $64342bc4200bc29f$export$5c65f31afd3d2ceb() {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9TvQP.RailSkeleton), {
        groups: [
            3,
            2
        ]
    });
}
function $64342bc4200bc29f$export$f59a51f6709a8d6b({ view: requested = 'services' }) {
    const { t: t } = (0, $e1LEq.default)();
    const view = $64342bc4200bc29f$export$84eccba4d569bd61(requested);
    const label = t('common.state.loading');
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $66joL.SkeletonRegion), {
        label: label,
        "data-testid": "goods-skeleton",
        "data-view": view,
        style: (0, $9TvQP.WORKBENCH_ROOT),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("header", {
                style: (0, $9TvQP.WORKBENCH_HEADER),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                style: {
                                    margin: 0,
                                    fontSize: '1.125rem',
                                    fontWeight: 700,
                                    color: (0, $jTCZr.C).textPrimary
                                },
                                children: t('nav.items.goods')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                style: {
                                    margin: '3px 0 0',
                                    fontSize: '0.75rem',
                                    color: (0, $jTCZr.C).textMuted
                                },
                                children: t('goods.subtitle')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 10
                        },
                        children: $64342bc4200bc29f$var$TABLE_VIEWS[view] ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonButton), {
                            width: 128
                        }) : null
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    flex: 1,
                    minHeight: 0,
                    borderTop: `1px solid ${(0, $jTCZr.C).border}`
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($64342bc4200bc29f$export$5c65f31afd3d2ceb, {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("main", {
                        style: (0, $9TvQP.WORKBENCH_MAIN),
                        children: $64342bc4200bc29f$var$TABLE_VIEWS[view] ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9TvQP.TableSurface), {
                            spec: $64342bc4200bc29f$var$TABLE_VIEWS[view],
                            label: label
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9TvQP.SetupSurface), {
                            spec: $64342bc4200bc29f$var$SETUP_VIEWS[view],
                            title: t($64342bc4200bc29f$var$viewTitleKey(view)),
                            label: label
                        })
                    })
                ]
            })
        ]
    });
}
const $64342bc4200bc29f$export$7038643fd9d36899 = {
    // MobileItemCard: name + state badge, the code, two fact rows, and (for a
    // keeper) the adjust shelf.
    items: ({ actions: actions = 0 } = {})=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $7NBSI.default), {
            badge: 56,
            metaLines: 3,
            actions: actions
        }),
    // MobileServiceCard: name + tariff, one meta line, up to two chips.
    services: ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $7NBSI.default), {
            badge: 64,
            metaLines: 1,
            chips: 2
        }),
    // MobileEquipmentCard: name + status badge, the code and room, two fact rows.
    equipment: ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $7NBSI.default), {
            badge: 64,
            metaLines: 3
        }),
    // The setup lists: a name, one meta line, and the edit/toggle shelf.
    suppliers: ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $7NBSI.default), {
            badge: 48,
            metaLines: 1,
            actions: 2
        }),
    equipmentTypes: ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $7NBSI.default), {
            badge: 56,
            metaLines: 2,
            actions: 2
        }),
    locations: ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $7NBSI.default), {
            badge: 48,
            metaLines: 1
        }),
    insurance: ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $7NBSI.default), {
            badge: 56,
            metaLines: 1,
            actions: 2
        }),
    // The lifecycle documents: a status badge and two or three fact rows.
    expiry: ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $7NBSI.default), {
            badge: 64,
            metaLines: 3,
            actions: 1
        }),
    procurement: ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $7NBSI.default), {
            badge: 56,
            metaLines: 3
        }),
    custody: ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $7NBSI.default), {
            badge: 56,
            metaLines: 1,
            actions: 2
        }),
    counts: ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $7NBSI.default), {
            badge: 56,
            metaLines: 3,
            actions: 1
        })
};
const $64342bc4200bc29f$export$207b8bd2756ea503 = (view, opts)=>(i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
            children: ($64342bc4200bc29f$export$7038643fd9d36899[view] || $64342bc4200bc29f$export$7038643fd9d36899.items)(opts)
        }, i);
/**
 * The phone carries every destination the rail does, so the skeleton has a card
 * shape for each — the fallback to «کالاها» would otherwise draw a two-fact
 * stock card in front of a supplier list and jump when the data landed.
 */ const $64342bc4200bc29f$var$MOBILE_VIEWS = new Set(Object.keys($64342bc4200bc29f$export$7038643fd9d36899));
function $64342bc4200bc29f$export$27367d93507316ca({ view: requested = 'services', actions: actions = 0 }) {
    const { t: t } = (0, $e1LEq.default)();
    const view = $64342bc4200bc29f$var$MOBILE_VIEWS.has(requested) ? requested : 'services';
    const label = t('common.state.loading');
    const card = $64342bc4200bc29f$export$7038643fd9d36899[view];
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonRegion), {
        label: label,
        "data-testid": "goods-skeleton",
        "data-view": view,
        style: {
            height: '100%'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $8RTRt.default), {
            header: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5zhhf.default), {
                title: t('nav.items.goods'),
                subtitle: t('goods.mobileTitle'),
                sticky: true
            }),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9TvQP.MobileSectionStrip), {
                    widths: [
                        52,
                        48,
                        60
                    ]
                }),
                view === 'items' || view === 'custody' ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    "aria-hidden": true,
                    style: {
                        display: 'flex',
                        gap: '0.5rem',
                        paddingBlock: '0.5rem',
                        paddingInline: '1rem',
                        overflow: 'hidden'
                    },
                    children: [
                        56,
                        96,
                        80,
                        72
                    ].map((w, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                            width: w,
                            height: 44,
                            radius: (0, $jTCZr.RADIUS).pill
                        }, i))
                }) : null,
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        padding: view === 'items' || view === 'custody' ? '0 1rem 1.5rem' : '0.75rem 1rem 1.5rem',
                        display: 'grid',
                        gap: `${(0, $2xQve.STACK).tight}px`
                    },
                    children: Array.from({
                        length: 5
                    }, (_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                            children: card({
                                actions: actions
                            })
                        }, i))
                })
            ]
        })
    });
}
function $64342bc4200bc29f$export$2e2bcd8739ae039(props) {
    const { isMobile: isMobile } = (0, $9h2jQ.default)();
    return isMobile ? /*#__PURE__*/ (0, $ayMG0.jsx)($64342bc4200bc29f$export$27367d93507316ca, {
        ...props
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)($64342bc4200bc29f$export$f59a51f6709a8d6b, {
        ...props
    });
}

});

parcelRegister("3jrpA", function(module, exports) {

$parcel$export(module.exports, "StoreSkeletonWeb", () => $4496affe256bf58c$export$f79bfdb9c0031f1d);
$parcel$export(module.exports, "renderStoreCardSkeleton", () => $4496affe256bf58c$export$46328b3538e0b038);
$parcel$export(module.exports, "StoreSkeletonMobile", () => $4496affe256bf58c$export$b28e259d47a99a9e);
$parcel$export(module.exports, "default", () => $4496affe256bf58c$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $66joL = parcelRequire("66joL");

var $jTCZr = parcelRequire("jTCZr");

var $2xQve = parcelRequire("2xQve");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $9h2jQ = parcelRequire("9h2jQ");
parcelRequire("1NzLv");
var $7NBSI = parcelRequire("7NBSI");
var $5zhhf = parcelRequire("5zhhf");
var $8RTRt = parcelRequire("8RTRt");

var $9TvQP = parcelRequire("9TvQP");
/**
 * «فروشگاه» while it is still fetching — the page's own shape, per view
 * (design §14.3; DESIGN.md §"Loading & skeleton").
 *
 * The router's Suspense fallback imports this EAGERLY and the screen uses the
 * same component for its first load, so nothing jumps between the two. That is
 * why it imports nothing from the screen: only the kit, the tokens, density,
 * i18n, the mobile primitives and the shared workbench geometry.
 *
 * Desktop: header band · five KPI blocks · rail (3 + 3) · the view's surface.
 * Mobile:  the real header · 4 tile placeholders · 6 card placeholders.
 */ const $4496affe256bf58c$var$TABLE_VIEWS = {
    listings: {
        columns: [
            40,
            220,
            84,
            120,
            130,
            120,
            150,
            110,
            120
        ],
        rows: 8,
        filters: {
            search: 220,
            select: 170,
            chips: 4
        }
    },
    orders: {
        columns: [
            110,
            180,
            180,
            120,
            120,
            130,
            120,
            150
        ],
        rows: 8,
        filters: {
            search: 220,
            select: 0,
            chips: 5
        }
    }
};
const $4496affe256bf58c$export$e50ddd14a153f5d = [
    'dashboard',
    'orders',
    'listings',
    'storefront',
    'finance',
    'settings'
];
function $4496affe256bf58c$export$14875bb31dc107bc(view) {
    return $4496affe256bf58c$export$e50ddd14a153f5d.includes(view) ? view : 'dashboard';
}
function $4496affe256bf58c$var$Surface({ view: view, label: label }) {
    if ($4496affe256bf58c$var$TABLE_VIEWS[view]) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9TvQP.TableSurface), {
        spec: $4496affe256bf58c$var$TABLE_VIEWS[view],
        label: label
    });
    if (view === 'dashboard') return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            flex: 1,
            overflow: 'hidden',
            padding: (0, $2xQve.PANEL_PAD).regular,
            display: 'grid',
            gridTemplateColumns: 'minmax(0,1fr) 300px',
            gap: (0, $2xQve.STACK).regular
        },
        "data-surface": "dashboard",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'grid',
                    gap: (0, $2xQve.STACK).regular,
                    alignContent: 'start'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonTable), {
                        dense: true,
                        rows: 6,
                        columns: [
                            110,
                            160,
                            180,
                            120,
                            130,
                            150
                        ],
                        label: label
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonChart), {
                        height: 160,
                        label: label
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    display: 'grid',
                    gap: (0, $2xQve.STACK).regular,
                    alignContent: 'start'
                },
                "aria-hidden": true,
                children: [
                    120,
                    150,
                    140
                ].map((h, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        height: h,
                        radius: (0, $jTCZr.RADIUS).card
                    }, i))
            })
        ]
    });
    if (view === 'finance') return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            flex: 1,
            overflow: 'hidden'
        },
        "data-surface": "finance",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                "aria-hidden": true,
                style: {
                    display: 'flex',
                    gap: 8,
                    padding: '10px 20px',
                    borderBottom: `1px solid ${(0, $jTCZr.C).border}`
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: 36,
                        height: 36,
                        radius: (0, $jTCZr.RADIUS).control
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: 120,
                        height: 36
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: 36,
                        height: 36,
                        radius: (0, $jTCZr.RADIUS).control
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    padding: '14px 20px'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonStats), {
                    count: 3,
                    icon: false,
                    label: label
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    padding: '0 20px'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonTable), {
                    dense: true,
                    rows: 4,
                    columns: 6,
                    label: label
                })
            })
        ]
    });
    if (view === 'storefront') return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            flex: 1,
            overflow: 'hidden',
            padding: (0, $2xQve.PANEL_PAD).regular,
            display: 'grid',
            gridTemplateColumns: 'minmax(0,1fr) 320px',
            gap: (0, $2xQve.STACK).regular
        },
        "aria-hidden": true,
        "data-surface": "storefront",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                height: 600,
                radius: (0, $jTCZr.RADIUS).card
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'grid',
                    gap: (0, $2xQve.STACK).regular,
                    alignContent: 'start'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        height: 300,
                        radius: (0, $jTCZr.RADIUS).card
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        height: 140,
                        radius: (0, $jTCZr.RADIUS).card
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            flex: 1,
            overflow: 'hidden'
        },
        "data-surface": "settings",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                "aria-hidden": true,
                style: {
                    display: 'flex',
                    gap: 4,
                    padding: '10px 20px',
                    borderBottom: `1px solid ${(0, $jTCZr.C).border}`
                },
                children: [
                    72,
                    96,
                    72,
                    96,
                    84
                ].map((w, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: w,
                        height: 36,
                        radius: 9
                    }, i))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    padding: (0, $2xQve.PANEL_PAD).regular,
                    maxWidth: 820
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonForm), {
                    fields: 5,
                    label: label
                })
            })
        ]
    });
}
function $4496affe256bf58c$export$f79bfdb9c0031f1d({ view: requested = 'dashboard' }) {
    const { t: t } = (0, $e1LEq.default)();
    const view = $4496affe256bf58c$export$14875bb31dc107bc(requested);
    const label = t('common.state.loading');
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $66joL.SkeletonRegion), {
        label: label,
        "data-testid": "store-skeleton",
        "data-view": view,
        style: (0, $9TvQP.WORKBENCH_ROOT),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("header", {
                style: (0, $9TvQP.WORKBENCH_HEADER),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                style: {
                                    margin: 0,
                                    fontSize: '1.125rem',
                                    fontWeight: 700,
                                    color: (0, $jTCZr.C).textPrimary
                                },
                                children: t('nav.items.store')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                "aria-hidden": true,
                                style: {
                                    marginTop: 5
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                    width: 180,
                                    height: 12
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 10
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonButton), {
                                width: 120
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonButton), {
                                width: 110
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    padding: '14px 20px',
                    flexShrink: 0
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonStats), {
                    count: 5,
                    icon: false,
                    label: label
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    flex: 1,
                    minHeight: 0,
                    borderTop: `1px solid ${(0, $jTCZr.C).border}`
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9TvQP.RailSkeleton), {
                        groups: [
                            3,
                            3
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("main", {
                        style: (0, $9TvQP.WORKBENCH_MAIN),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($4496affe256bf58c$var$Surface, {
                            view: view,
                            label: label
                        })
                    })
                ]
            })
        ]
    });
}
const $4496affe256bf58c$export$7038643fd9d36899 = {
    listings: ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $7NBSI.default), {
            badge: 72,
            metaLines: 2
        }),
    orders: ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $7NBSI.default), {
            badge: 64,
            metaLines: 2,
            chips: 2
        }),
    finance: ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $7NBSI.default), {
            badge: 0,
            metaLines: 2
        })
};
const $4496affe256bf58c$export$46328b3538e0b038 = (view)=>(i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
            children: ($4496affe256bf58c$export$7038643fd9d36899[view] || $4496affe256bf58c$export$7038643fd9d36899.orders)()
        }, i);
function $4496affe256bf58c$export$b28e259d47a99a9e({ view: requested = 'dashboard' }) {
    const { t: t } = (0, $e1LEq.default)();
    const view = $4496affe256bf58c$export$14875bb31dc107bc(requested);
    const label = t('common.state.loading');
    const card = $4496affe256bf58c$export$7038643fd9d36899[view] || $4496affe256bf58c$export$7038643fd9d36899.orders;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonRegion), {
        label: label,
        "data-testid": "store-skeleton",
        "data-view": view,
        style: {
            height: '100%'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $8RTRt.default), {
            header: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5zhhf.default), {
                title: t('nav.items.store'),
                sticky: true
            }),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9TvQP.MobileSectionStrip), {
                    widths: [
                        56,
                        48,
                        52,
                        48,
                        44,
                        56
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    "aria-hidden": true,
                    style: {
                        display: 'grid',
                        gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
                        gap: '0.5rem',
                        padding: '0.75rem 1rem 0'
                    },
                    children: Array.from({
                        length: 4
                    }, (_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                            height: 60,
                            radius: 14,
                            style: {
                                border: `1px dashed ${(0, $jTCZr.C).border}`
                            }
                        }, i))
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        padding: '0.75rem 1rem 1.5rem',
                        display: 'grid',
                        gap: `${(0, $2xQve.STACK).tight}px`
                    },
                    children: Array.from({
                        length: 6
                    }, (_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                            children: card()
                        }, i))
                })
            ]
        })
    });
}
function $4496affe256bf58c$export$2e2bcd8739ae039(props) {
    const { isMobile: isMobile } = (0, $9h2jQ.default)();
    return isMobile ? /*#__PURE__*/ (0, $ayMG0.jsx)($4496affe256bf58c$export$b28e259d47a99a9e, {
        ...props
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)($4496affe256bf58c$export$f79bfdb9c0031f1d, {
        ...props
    });
}

});

parcelRegister("9CB84", function(module, exports) {

$parcel$export(module.exports, "ReportsSkeletonWeb", () => $4ffb7459f4cb1144$export$cf35e9a75fe93265);
$parcel$export(module.exports, "ReportsSkeletonMobile", () => $4ffb7459f4cb1144$export$6ae438ce9366eec1);
$parcel$export(module.exports, "default", () => $4ffb7459f4cb1144$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("5N0ZI");
var $66joL = parcelRequire("66joL");
parcelRequire("52bn2");
var $jTCZr = parcelRequire("jTCZr");

var $2xQve = parcelRequire("2xQve");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");
function $4ffb7459f4cb1144$export$cf35e9a75fe93265() {
    const { t: t } = (0, $e1LEq.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonRegion), {
        label: t('reports.loading'),
        "data-testid": "reports-skeleton",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                background: (0, $jTCZr.C).bg,
                overflow: 'hidden'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        background: (0, $jTCZr.C).card,
                        borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
                        padding: '14px 32px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 20,
                        minHeight: 64,
                        flexShrink: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                flex: 1,
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 6
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                    width: 90,
                                    height: 10
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                    width: 190,
                                    height: 16
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                display: 'flex',
                                gap: 8
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonButton), {
                                    width: 120
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonButton), {
                                    size: "icon"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonButton), {
                                    width: 96
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        display: 'flex',
                        flex: 1,
                        minHeight: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                width: 176,
                                flexShrink: 0,
                                background: (0, $jTCZr.C).card,
                                borderInlineEnd: `1px solid ${(0, $jTCZr.C).border}`,
                                padding: '12px 8px',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 10
                            },
                            children: Array.from({
                                length: 8
                            }).map((_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonText), {
                                    width: i % 3 === 0 ? '55%' : '85%'
                                }, i))
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                flex: 1,
                                minWidth: 0,
                                padding: (0, $2xQve.PANEL_PAD).regular,
                                display: 'flex',
                                flexDirection: 'column',
                                gap: (0, $2xQve.STACK).regular
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonFilters), {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonStats), {
                                    count: 4
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonChart), {
                                    height: 260
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonTable), {
                                    rows: 8,
                                    columns: 6
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
function $4ffb7459f4cb1144$export$6ae438ce9366eec1() {
    const { t: t } = (0, $e1LEq.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonRegion), {
        label: t('reports.loading'),
        "data-testid": "reports-skeleton-mobile",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: (0, $2xQve.STACK).regular,
                padding: 12
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonHeader), {}),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr',
                        gap: 10
                    },
                    children: Array.from({
                        length: 4
                    }).map((_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonStats), {
                            count: 1
                        }, i))
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonChart), {
                    height: 180
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonList), {
                    rows: 6
                })
            ]
        })
    });
}
var $4ffb7459f4cb1144$export$2e2bcd8739ae039 = $4ffb7459f4cb1144$export$cf35e9a75fe93265;

});

parcelRegister("8fFE7", function(module, exports) {

$parcel$export(module.exports, "AccountingSkeletonWeb", () => $6d517a25ca116ed1$export$2687f58974c30e63);
$parcel$export(module.exports, "AccountingSkeletonMobile", () => $6d517a25ca116ed1$export$8c8f8d480cdf00db);
$parcel$export(module.exports, "default", () => $6d517a25ca116ed1$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("5N0ZI");
var $kyZIh = parcelRequire("kyZIh");
var $66joL = parcelRequire("66joL");

var $jTCZr = parcelRequire("jTCZr");

var $2xQve = parcelRequire("2xQve");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $9h2jQ = parcelRequire("9h2jQ");
parcelRequire("1NzLv");
var $5zhhf = parcelRequire("5zhhf");
var $8RTRt = parcelRequire("8RTRt");
/**
 * «حسابداری» while it is waiting — the hub's own shape in placeholder blocks
 * (DESIGN.md §"Loading & skeleton").
 *
 * It is VIEW-AWARE because the hub's eight destinations do not have one shape: a
 * ledger is a KPI strip over a wide table, «حساب‌های مالی» is a short table with no
 * strip, and the dashboard is tiles. Drawing the ledger's eight columns while the
 * dashboard's chunk is in flight is a flash of the wrong page, which is exactly
 * what this registry exists to prevent.
 *
 * LIGHT by contract: it ships in the MAIN bundle as the lazy chunk's fallback, so
 * it imports nothing from the screen, its views or its hooks — kit primitives,
 * tokens, density and i18n only.
 */ /** How many columns each view's table has, and whether it carries a KPI strip. */ const $6d517a25ca116ed1$var$SHAPE = {
    dashboard: {
        cols: 0,
        kpis: 4
    },
    transactions: {
        cols: 8,
        kpis: 3
    },
    receipts: {
        cols: 8,
        kpis: 4
    },
    payments: {
        cols: 7,
        kpis: 4
    },
    accounts: {
        cols: 6,
        kpis: 0
    },
    counterparties: {
        cols: 5,
        kpis: 0
    },
    receivables: {
        cols: 6,
        kpis: 3
    },
    payables: {
        cols: 5,
        kpis: 3
    }
};
const $6d517a25ca116ed1$var$shapeOf = (view)=>$6d517a25ca116ed1$var$SHAPE[view] || $6d517a25ca116ed1$var$SHAPE.receipts;
function $6d517a25ca116ed1$var$KpiStripSkeleton({ count: count }) {
    if (!count) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        "aria-hidden": true,
        style: {
            display: 'flex',
            gap: 14,
            marginBottom: 18,
            flexWrap: 'wrap'
        },
        children: Array.from({
            length: count
        }, (_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                width: 180,
                height: 84,
                radius: 16
            }, i))
    });
}
function $6d517a25ca116ed1$var$TableSkeleton({ cols: cols, rows: rows = 8 }) {
    if (!cols) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "aria-hidden": true,
        style: {
            background: (0, $jTCZr.C).card,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: 16,
            overflow: 'hidden'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    display: 'flex',
                    gap: 12,
                    padding: '13px 20px',
                    background: '#f8fafc',
                    borderBottom: `2px solid ${(0, $jTCZr.C).border}`
                },
                children: Array.from({
                    length: cols
                }, (_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: 70,
                        height: 11
                    }, i))
            }),
            Array.from({
                length: rows
            }, (_, r)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        display: 'flex',
                        gap: 12,
                        padding: '13px 20px',
                        borderTop: `1px solid ${(0, $jTCZr.C).border}`
                    },
                    children: Array.from({
                        length: cols
                    }, (_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                            width: i === 1 ? 140 : 72,
                            height: 13
                        }, i))
                }, r))
        ]
    });
}
function $6d517a25ca116ed1$export$2687f58974c30e63({ view: view, rows: rows = 8 }) {
    const { t: t } = (0, $e1LEq.default)();
    const shape = $6d517a25ca116ed1$var$shapeOf(view);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            background: (0, $jTCZr.C).bg,
            overflow: 'hidden'
        },
        "data-testid": "accounting-skeleton",
        "data-view": view || '',
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kyZIh.default), {
                title: t('accounting.hub.title'),
                sub: t('accounting.hub.subtitle')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    flex: 1,
                    minHeight: 0
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        "aria-hidden": true,
                        style: {
                            width: 176,
                            flexShrink: 0,
                            borderInlineEnd: `1px solid ${(0, $jTCZr.C).border}`,
                            background: (0, $jTCZr.C).card,
                            padding: '12px 8px',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: (0, $2xQve.STACK).tight
                        },
                        children: Array.from({
                            length: 8
                        }, (_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                width: "100%",
                                height: 30,
                                radius: 8
                            }, i))
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $66joL.SkeletonRegion), {
                        label: t('accounting.hub.title'),
                        style: {
                            flex: 1,
                            minWidth: 0,
                            overflow: 'hidden',
                            padding: (0, $2xQve.PANEL_PAD).regular
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($6d517a25ca116ed1$var$KpiStripSkeleton, {
                                count: shape.kpis
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($6d517a25ca116ed1$var$TableSkeleton, {
                                cols: shape.cols,
                                rows: rows
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function $6d517a25ca116ed1$export$8c8f8d480cdf00db({ view: view, cards: cards = 5 }) {
    const { t: t } = (0, $e1LEq.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8RTRt.default), {
        "data-testid": "accounting-skeleton",
        "data-view": view || '',
        header: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5zhhf.default), {
            sticky: true,
            title: t('accounting.hub.title'),
            subtitle: t('accounting.hub.subtitle')
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonRegion), {
            label: t('accounting.hub.title'),
            style: {
                display: 'grid',
                gap: (0, $2xQve.STACK).regular,
                padding: '0.75rem 1rem'
            },
            children: Array.from({
                length: cards
            }, (_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                    width: "100%",
                    height: 72,
                    radius: 12
                }, i))
        })
    });
}
function $6d517a25ca116ed1$export$2e2bcd8739ae039(props) {
    const { isMobile: isMobile } = (0, $9h2jQ.default)();
    return isMobile ? /*#__PURE__*/ (0, $ayMG0.jsx)($6d517a25ca116ed1$export$8c8f8d480cdf00db, {
        ...props
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)($6d517a25ca116ed1$export$2687f58974c30e63, {
        ...props
    });
}

});

parcelRegister("lnXsr", function(module, exports) {

$parcel$export(module.exports, "PeopleTableSkeleton", () => $bbbc5b3f23e60d9d$export$d96def749054ba83);
$parcel$export(module.exports, "RoleCardsSkeleton", () => $bbbc5b3f23e60d9d$export$f172741c38a396f1);
$parcel$export(module.exports, "PeopleSkeletonWebBody", () => $bbbc5b3f23e60d9d$export$d431245ac388f6b3);
$parcel$export(module.exports, "renderPersonSkeleton", () => $bbbc5b3f23e60d9d$export$a72b67d8723fb564);
$parcel$export(module.exports, "renderRoleSkeleton", () => $bbbc5b3f23e60d9d$export$3136ab7ec1ed3689);
$parcel$export(module.exports, "default", () => $bbbc5b3f23e60d9d$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $QG9Z3 = parcelRequire("QG9Z3");
var $kMJsW = parcelRequire("kMJsW");
var $fX0JO = parcelRequire("fX0JO");
var $6imzq = parcelRequire("6imzq");
parcelRequire("5N0ZI");
var $g6X9N = parcelRequire("g6X9N");
var $h4ZeB = parcelRequire("h4ZeB");
var $lUcdx = parcelRequire("lUcdx");
var $kyZIh = parcelRequire("kyZIh");
var $amyVq = parcelRequire("amyVq");
var $fYgeo = parcelRequire("fYgeo");
var $66joL = parcelRequire("66joL");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $2xQve = parcelRequire("2xQve");

var $9h2jQ = parcelRequire("9h2jQ");
parcelRequire("1NzLv");
var $7NBSI = parcelRequire("7NBSI");
var $gmg4I = parcelRequire("gmg4I");
var $5zhhf = parcelRequire("5zhhf");
var $cEwTy = parcelRequire("cEwTy");
var $8RTRt = parcelRequire("8RTRt");
var $0UhMT = parcelRequire("0UhMT");
var $bKUa1 = parcelRequire("bKUa1");
/**
 * «همکاران» while it loads — the page's own shape in placeholder blocks
 * (DESIGN.md §"Loading & skeleton").
 *
 * This file is the router's Suspense fallback for `/people`, so it is imported
 * eagerly and stays light: kit primitives, tokens, density, i18n and the mobile
 * layout library only — never the screen, its hooks or its data. The screen
 * itself renders the SAME body on its first load (`PeopleSkeletonWebBody`,
 * `renderPersonSkeleton`, …) so the fallback → first-load → data transitions
 * draw one shape three times rather than three shapes.
 *
 * Static chrome — the title, the tab labels, the kind chips, the KPI labels,
 * the column headers — renders for real; anything that needs data (counts,
 * the role filter's options, the rows) is a block.
 */ const $bbbc5b3f23e60d9d$var$noop = ()=>{};
/** The people table's column headers, in the order the screen draws them. */ function $bbbc5b3f23e60d9d$var$useColumns(t, actions) {
    return [
        {
            key: 'name',
            header: t('people.fields.person'),
            width: 160
        },
        {
            key: 'kind',
            header: t('common.fields.type'),
            width: 72
        },
        {
            key: 'roles',
            header: t('people.fields.roleOrProfession'),
            width: 110
        },
        {
            key: 'status',
            header: t('common.fields.status'),
            width: 96
        },
        {
            key: 'joinedAt',
            header: t('people.fields.membership'),
            align: 'end',
            width: 80
        },
        ...actions ? [
            {
                key: 'actions',
                header: t('people.fields.action'),
                align: 'end',
                width: 120
            }
        ] : []
    ];
}
function $bbbc5b3f23e60d9d$export$d96def749054ba83({ columns: columns, rows: rows = 5, widths: widths, style: style }) {
    const cellWidths = widths || columns.map((c)=>c.width || 90);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: {
            background: (0, $jTCZr.C).card,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: 16,
            overflow: 'hidden',
            ...style
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
            style: {
                width: '100%',
                borderCollapse: 'collapse',
                fontSize: '0.84375rem'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                        children: columns.map((col)=>/*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                style: {
                                    background: (0, $jTCZr.C).bg,
                                    color: (0, $jTCZr.C).textSecondary,
                                    fontWeight: 700,
                                    fontSize: '0.78125rem',
                                    textAlign: col.align === 'end' ? 'left' : 'right',
                                    padding: '10px 14px',
                                    borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
                                    whiteSpace: 'nowrap'
                                },
                                children: col.header
                            }, col.key))
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                    children: Array.from({
                        length: rows
                    }, (_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonRow), {
                            cols: columns.length,
                            widths: cellWidths
                        }, i))
                })
            ]
        })
    });
}
function $bbbc5b3f23e60d9d$export$c5bd15151f4d1d84() {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $g6X9N.default), {
        "aria-hidden": true,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 8,
            minHeight: 118
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 8
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                    width: "45%",
                    height: 18
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 4
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: "60%",
                        height: 14
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: "50%",
                        height: 12
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                width: 64,
                height: 14
            })
        ]
    });
}
function $bbbc5b3f23e60d9d$export$f172741c38a396f1({ count: count = 3, label: label, style: style }) {
    const { t: t } = (0, $e1LEq.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonRegion), {
        label: label ?? t('common.state.loading'),
        style: {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
            gap: 14,
            ...style
        },
        children: Array.from({
            length: count
        }, (_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)($bbbc5b3f23e60d9d$export$c5bd15151f4d1d84, {}, i))
    });
}
function $bbbc5b3f23e60d9d$export$d431245ac388f6b3({ tab: tab = 'people', actions: actions = true, staff: staff = true, practitioners: practitioners = true }) {
    const { t: t } = (0, $e1LEq.default)();
    const columns = $bbbc5b3f23e60d9d$var$useColumns(t, actions);
    const tabOptions = [
        {
            value: 'people',
            label: t('people.tabs.people')
        },
        {
            value: 'roles',
            label: t('people.fields.roles')
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $66joL.SkeletonRegion), {
        label: t('common.state.loading'),
        "data-testid": "people-skeleton-body",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    gap: 14,
                    marginBottom: 18,
                    flexWrap: 'wrap'
                },
                children: [
                    practitioners && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lUcdx.default), {
                        label: t('people.kpi.practitioners'),
                        value: "",
                        loading: true,
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fX0JO.default), {
                            size: 20,
                            color: (0, $jTCZr.C).teal
                        }),
                        bg: (0, $jTCZr.C).tealLight
                    }),
                    staff && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lUcdx.default), {
                        label: t('people.kpi.staff'),
                        value: "",
                        loading: true,
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6imzq.default), {
                            size: 20,
                            color: (0, $jTCZr.C).navy
                        }),
                        bg: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.06)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lUcdx.default), {
                        label: t('people.kpi.pending'),
                        value: "",
                        loading: true,
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kMJsW.default), {
                            size: 20,
                            color: (0, $jTCZr.C).amber
                        }),
                        bg: (0, $jTCZr.C).amberLight
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lUcdx.default), {
                        label: t('people.kpi.needsAttention'),
                        value: "",
                        loading: true,
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $QG9Z3.default), {
                            size: 20,
                            color: (0, $jTCZr.C).amber
                        }),
                        bg: (0, $jTCZr.C).amberLight
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    paddingBlock: (0, $2xQve.STACK).tight,
                    marginBottom: 6,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 10
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            gap: 10,
                            alignItems: 'center',
                            flexWrap: 'wrap'
                        },
                        children: [
                            staff && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fYgeo.default), {
                                value: tab,
                                onChange: $bbbc5b3f23e60d9d$var$noop,
                                options: tabOptions
                            }),
                            tab === 'people' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    gap: 6,
                                    flexWrap: 'wrap'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $h4ZeB.default), {
                                        label: t('people.tabs.all'),
                                        active: true,
                                        onClick: $bbbc5b3f23e60d9d$var$noop
                                    }),
                                    practitioners && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $h4ZeB.default), {
                                        label: t('people.kinds.practitionerPlural'),
                                        onClick: $bbbc5b3f23e60d9d$var$noop
                                    }),
                                    staff && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $h4ZeB.default), {
                                        label: t('people.kinds.staffPlural'),
                                        onClick: $bbbc5b3f23e60d9d$var$noop
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                width: 72,
                                height: 13,
                                style: {
                                    marginInlineStart: 'auto'
                                }
                            })
                        ]
                    }),
                    tab === 'people' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            gap: 10,
                            alignItems: 'center',
                            flexWrap: 'wrap'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    flex: 1,
                                    minWidth: 240
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $amyVq.default), {
                                    value: "",
                                    onChange: $bbbc5b3f23e60d9d$var$noop,
                                    placeholder: t('people.search.placeholder'),
                                    readOnly: true
                                })
                            }),
                            staff && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonInput), {
                                label: false,
                                width: 168
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonInput), {
                                label: false,
                                width: 168
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonInput), {
                                label: false,
                                width: 168
                            })
                        ]
                    })
                ]
            }),
            tab === 'people' ? /*#__PURE__*/ (0, $ayMG0.jsx)($bbbc5b3f23e60d9d$export$d96def749054ba83, {
                columns: columns
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)($bbbc5b3f23e60d9d$export$f172741c38a396f1, {})
        ]
    });
}
function $bbbc5b3f23e60d9d$export$ae83bc102141616e(props) {
    const { t: t } = (0, $e1LEq.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-state": "loading",
        "data-testid": "people-skeleton",
        style: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            background: (0, $jTCZr.C).bg,
            position: 'relative'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kyZIh.default), {
                title: t('people.title'),
                sub: t('people.subtitle'),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonButton), {
                    width: 132
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    flex: 1,
                    minHeight: 0,
                    overflowY: 'auto',
                    padding: '24px 32px'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($bbbc5b3f23e60d9d$export$d431245ac388f6b3, {
                    ...props
                })
            })
        ]
    });
}
const $bbbc5b3f23e60d9d$export$a72b67d8723fb564 = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $7NBSI.default), {
        avatar: 40,
        badge: 56,
        metaLines: 1,
        chips: 1
    });
const $bbbc5b3f23e60d9d$export$3136ab7ec1ed3689 = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $7NBSI.default), {
        avatar: 0,
        badge: 18,
        metaLines: 2
    });
function $bbbc5b3f23e60d9d$export$8496aa4c2a61b519({ tab: tab = 'people', staff: staff = true, practitioners: practitioners = true }) {
    const { t: t } = (0, $e1LEq.default)();
    const tiles = [
        practitioners && {
            key: 'practitioners',
            label: t('people.kpi.practitioners'),
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fX0JO.default), {
                size: 16,
                "aria-hidden": "true"
            }),
            color: (0, $jTCZr.C).teal,
            solid: true
        },
        staff && {
            key: 'staff',
            label: t('people.kpi.staff'),
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6imzq.default), {
                size: 16,
                "aria-hidden": "true"
            }),
            color: (0, $jTCZr.C).navy
        },
        {
            key: 'pending',
            label: t('people.kpi.pending'),
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kMJsW.default), {
                size: 16,
                "aria-hidden": "true"
            }),
            color: (0, $jTCZr.C).amber
        },
        {
            key: 'needsAttention',
            label: t('people.kpi.needsAttention'),
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $QG9Z3.default), {
                size: 16,
                "aria-hidden": "true"
            }),
            color: (0, $jTCZr.C).amber
        }
    ].filter(Boolean);
    const header = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5zhhf.default), {
        title: t('people.title'),
        subtitle: t('people.subtitle'),
        onBack: ()=>window.history.back(),
        backLabel: t('common.actions.back'),
        "data-testid": "people-header"
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $8RTRt.default), {
        header: header,
        "data-state": "loading",
        "data-testid": "people-skeleton",
        children: [
            staff && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0UhMT.default), {
                items: [
                    {
                        key: 'people',
                        label: t('people.tabs.people')
                    },
                    {
                        key: 'roles',
                        label: t('people.fields.roles')
                    }
                ],
                active: tab,
                onSelect: $bbbc5b3f23e60d9d$var$noop,
                ariaLabel: t('people.title')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: `${(0, $2xQve.STACK).regular}px`,
                    paddingTop: '0.75rem'
                },
                children: tab === 'people' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bKUa1.default), {
                            tiles: tiles,
                            loading: true,
                            columns: tiles.length
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gmg4I.default), {
                            sticky: false,
                            chips: [
                                {
                                    id: 'all',
                                    label: t('people.tabs.all'),
                                    active: true
                                },
                                ...practitioners ? [
                                    {
                                        id: 'practitioner',
                                        label: t('people.kinds.practitionerPlural')
                                    }
                                ] : [],
                                ...staff ? [
                                    {
                                        id: 'staff',
                                        label: t('people.kinds.staffPlural')
                                    }
                                ] : []
                            ],
                            onSelect: $bbbc5b3f23e60d9d$var$noop
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                display: 'grid',
                                gap: `${(0, $2xQve.STACK).tight}px`,
                                paddingInline: '1rem'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $amyVq.default), {
                                value: "",
                                onChange: $bbbc5b3f23e60d9d$var$noop,
                                placeholder: t('people.search.placeholder'),
                                readOnly: true
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                paddingInline: '1rem'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cEwTy.default), {
                                loading: true,
                                items: [],
                                renderItem: $bbbc5b3f23e60d9d$var$noop,
                                renderSkeleton: $bbbc5b3f23e60d9d$export$a72b67d8723fb564
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        display: 'grid',
                        gap: `${(0, $2xQve.STACK).regular}px`,
                        paddingInline: '1rem'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cEwTy.default), {
                        loading: true,
                        items: [],
                        renderItem: $bbbc5b3f23e60d9d$var$noop,
                        skeletonCount: 3,
                        renderSkeleton: $bbbc5b3f23e60d9d$export$3136ab7ec1ed3689
                    })
                })
            })
        ]
    });
}
function $bbbc5b3f23e60d9d$export$2e2bcd8739ae039(props) {
    const { isMobile: isMobile } = (0, $9h2jQ.default)();
    return isMobile ? /*#__PURE__*/ (0, $ayMG0.jsx)($bbbc5b3f23e60d9d$export$8496aa4c2a61b519, {
        ...props
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)($bbbc5b3f23e60d9d$export$ae83bc102141616e, {
        ...props
    });
}

});

parcelRegister("3lftY", function(module, exports) {

$parcel$export(module.exports, "RoleEditorSkeletonWebBody", () => $5080285735fc5bef$export$1d9dbe2a510f9edb);
$parcel$export(module.exports, "RoleEditorSkeletonMobileBody", () => $5080285735fc5bef$export$6e17980d90635217);
$parcel$export(module.exports, "default", () => $5080285735fc5bef$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("5N0ZI");
var $g6X9N = parcelRequire("g6X9N");
var $jOGbh = parcelRequire("jOGbh");
var $eJIXW = parcelRequire("eJIXW");
var $66joL = parcelRequire("66joL");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $2xQve = parcelRequire("2xQve");

var $9h2jQ = parcelRequire("9h2jQ");
parcelRequire("1NzLv");
var $5zhhf = parcelRequire("5zhhf");
var $8RTRt = parcelRequire("8RTRt");
/**
 * The role editor while its role loads — the numbered section cards, the
 * holders, the permission modules and the delete rail, in placeholder blocks.
 *
 * The router's Suspense fallback for `/people/roles/:id`, so it is imported
 * eagerly and stays light (kit, tokens, density, i18n, the mobile layout
 * library). The screen renders the same body inside its own header while
 * `usePeople` loads (`RoleEditorSkeletonWebBody`, `RoleEditorSkeletonMobileBody`),
 * because the header carries the back affordance and that must stay REAL — a
 * failed or slow load never traps the reader.
 */ const $5080285735fc5bef$var$MODULES = 3;
const $5080285735fc5bef$var$PERMS_PER_MODULE = 3;
const $5080285735fc5bef$var$MEMBERS = 4;
/** One permission row: label + description on one side, a 44×24 switch on the other. */ function $5080285735fc5bef$var$PermissionRowSkeleton({ i: i }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 12,
            padding: '6px 0'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 5,
                    flex: 1
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: `${38 + i * 17 % 22}%`,
                        height: 14
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: `${55 + i * 11 % 25}%`,
                        height: 12
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                width: 44,
                height: 24,
                radius: (0, $jTCZr.RADIUS).pill
            })
        ]
    });
}
/** The holders row: `MEMBERS` avatar-26 + name pairs. */ function $5080285735fc5bef$var$MembersSkeleton({ size: size = 26 }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: 10
        },
        children: Array.from({
            length: $5080285735fc5bef$var$MEMBERS
        }, (_, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 7
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonAvatar), {
                        size: size
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: 64 + i * 19 % 40,
                        height: 13
                    })
                ]
            }, i))
    });
}
function $5080285735fc5bef$export$1d9dbe2a510f9edb() {
    const { t: t } = (0, $e1LEq.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $66joL.SkeletonRegion), {
        label: t('common.state.loading'),
        "data-testid": "role-editor-skeleton-body",
        className: "role-editor-grid",
        style: {
            display: 'grid',
            gridTemplateColumns: '1fr 300px',
            gap: 18,
            alignItems: 'start'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 16
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eJIXW.default), {
                        n: 1,
                        title: t('people.roleEditor.details'),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonInput), {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonInput), {
                                multiline: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eJIXW.default), {
                        n: 2,
                        title: t('people.roleEditor.members'),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: (0, $2xQve.STACK).tight
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($5080285735fc5bef$var$MembersSkeleton, {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    marginTop: (0, $2xQve.STACK).regular
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonButton), {
                                    width: 160
                                })
                            })
                        ]
                    }),
                    Array.from({
                        length: $5080285735fc5bef$var$MODULES
                    }, (_, m)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $eJIXW.default), {
                            n: m + 3,
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                width: 96 + m % 2 * 28,
                                height: 16
                            }),
                            children: Array.from({
                                length: $5080285735fc5bef$var$PERMS_PER_MODULE
                            }, (_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)($5080285735fc5bef$var$PermissionRowSkeleton, {
                                    i: m * $5080285735fc5bef$var$PERMS_PER_MODULE + i
                                }, i))
                        }, m))
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 16
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eJIXW.default), {
                    n: "!",
                    title: t('people.actions.deleteRole'),
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                            width: "90%",
                            height: 13,
                            style: {
                                marginBottom: 8
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonButton), {
                            width: 140
                        })
                    ]
                })
            })
        ]
    });
}
function $5080285735fc5bef$export$66921ce616399928() {
    const { t: t } = (0, $e1LEq.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-state": "loading",
        "data-testid": "role-editor-skeleton",
        style: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            background: (0, $jTCZr.C).bg
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("style", {
                children: `
        @media (max-width: 1180px) {
          .role-editor-grid { grid-template-columns: 1fr !important; }
        }
      `
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jOGbh.default), {
                backLabel: t('common.actions.back'),
                title: t('people.entity.role'),
                sub: t('people.roleEditor.subtitle'),
                onBack: ()=>window.history.back()
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    flex: 1,
                    minHeight: 0,
                    overflowY: 'auto',
                    padding: 32
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($5080285735fc5bef$export$1d9dbe2a510f9edb, {})
            })
        ]
    });
}
/** One collapsed `MobilePermissionGroup`: the 44px header row — title, count, chevron. */ function $5080285735fc5bef$var$PermissionGroupSkeleton({ i: i }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            minHeight: 44,
            padding: '14px 4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 8,
            borderBottom: `1px solid ${(0, $jTCZr.C).border}`
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 6
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: 88 + i * 23 % 40,
                        height: 14
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: 22,
                        height: 12
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                width: 16,
                height: 16
            })
        ]
    });
}
function $5080285735fc5bef$export$6e17980d90635217() {
    const { t: t } = (0, $e1LEq.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $66joL.SkeletonRegion), {
        label: t('common.state.loading'),
        "data-testid": "role-editor-skeleton-body",
        style: {
            padding: '1rem',
            display: 'grid',
            gap: `${(0, $2xQve.STACK).regular}px`
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonInput), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonInput), {
                multiline: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $g6X9N.default), {
                "aria-hidden": true,
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: `${(0, $2xQve.STACK).tight}px`
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: 120,
                        height: 15
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($5080285735fc5bef$var$MembersSkeleton, {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonButton), {
                            width: 168
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonInput), {
                label: false
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    background: (0, $jTCZr.C).card,
                    border: `1px solid ${(0, $jTCZr.C).border}`,
                    borderRadius: 14,
                    padding: '0.25rem 0.75rem'
                },
                children: Array.from({
                    length: $5080285735fc5bef$var$MODULES
                }, (_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)($5080285735fc5bef$var$PermissionGroupSkeleton, {
                        i: i
                    }, i))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonButton), {
                width: "100%"
            })
        ]
    });
}
function $5080285735fc5bef$export$323a9fc4df0d447d() {
    const { t: t } = (0, $e1LEq.default)();
    const header = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5zhhf.default), {
        title: t('people.entity.role'),
        subtitle: t('people.roleEditor.subtitle'),
        onBack: ()=>window.history.back(),
        backLabel: t('common.actions.back'),
        "data-testid": "role-editor-header"
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8RTRt.default), {
        header: header,
        "data-state": "loading",
        "data-testid": "role-editor-skeleton",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($5080285735fc5bef$export$6e17980d90635217, {})
    });
}
function $5080285735fc5bef$export$2e2bcd8739ae039(props) {
    const { isMobile: isMobile } = (0, $9h2jQ.default)();
    return isMobile ? /*#__PURE__*/ (0, $ayMG0.jsx)($5080285735fc5bef$export$323a9fc4df0d447d, {
        ...props
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)($5080285735fc5bef$export$66921ce616399928, {
        ...props
    });
}

});

parcelRegister("c8Px0", function(module, exports) {

$parcel$export(module.exports, "SETTINGS_SECTIONS", () => $8d6e346b1f443e45$export$960960fcb3e6d29a);
$parcel$export(module.exports, "resolveSettingsSection", () => $8d6e346b1f443e45$export$8de9b66865a2a325);
$parcel$export(module.exports, "settingsSectionLabel", () => $8d6e346b1f443e45$export$2bab3a8a28f26973);
/**
 * «تنظیمات» — the section registry, and the one place `?section=` is decided.
 *
 * Both surfaces read this. Before it existed the list was written twice, and the
 * two copies had already drifted: the desktop sidebar carried nine sections and
 * the phone menu carried seven, so «دستیار هوشمند» and «واتس‌اپ» — the latter the
 * only place a clinic can pair its WhatsApp number — were unreachable on a phone
 * except through a detour into «کلینیک من». A registry duplicated is a registry
 * that will disagree; the only question is when.
 *
 * The active section lives in the URL (`?section=`), which `ROUTES.settings`
 * already emits and both surfaces previously ignored in favour of a local
 * `useState`. In the URL it is linkable, survives a refresh, and answers the
 * platform back gesture — none of which local state can do.
 *
 * Nothing here renders. No React, no JSX, no tokens: `icon` is an emoji STRING,
 * which the desktop sidebar and the mobile `SectionNav` each dress themselves.
 *
 * Only sections with a backend are listed. نوبت‌دهی, بیمه‌ها, امنیت and دستیار
 * هوشمند were copied from the doctor panel and saved through `me` /
 * `update*Settings`, which the clinic BFF has never served; a bookmark of one
 * of them lands on the first section, like any unknown id.
 */ const $8d6e346b1f443e45$export$960960fcb3e6d29a = (t)=>[
        {
            id: 'profile',
            label: t('settings.sections.profile'),
            icon: "\uD83D\uDC64"
        },
        {
            id: 'appearance',
            label: t('settings.sections.appearance'),
            icon: "\uD83C\uDFA8"
        },
        {
            id: 'whatsapp',
            label: t('settings.sections.whatsapp'),
            icon: "\uD83D\uDCAC"
        }
    ];
const $8d6e346b1f443e45$export$f7937c8462a767a5 = $8d6e346b1f443e45$export$960960fcb3e6d29a((key)=>key).map((s)=>s.id);
const $8d6e346b1f443e45$export$c5f7c86ecc00c828 = 'profile';
function $8d6e346b1f443e45$export$8de9b66865a2a325(requested) {
    return $8d6e346b1f443e45$export$f7937c8462a767a5.includes(requested) ? requested : $8d6e346b1f443e45$export$c5f7c86ecc00c828;
}
function $8d6e346b1f443e45$export$2bab3a8a28f26973(id, t) {
    return $8d6e346b1f443e45$export$960960fcb3e6d29a(t).find((s)=>s.id === id)?.label || '';
}

});

parcelRegister("ivK8f", function(module, exports) {

$parcel$export(module.exports, "default", () => $74c1948dea6e77c3$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("1NzLv");
var $aLdCl = parcelRequire("aLdCl");
var $5zhhf = parcelRequire("5zhhf");
var $8RTRt = parcelRequire("8RTRt");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");
function $74c1948dea6e77c3$export$2e2bcd8739ae039() {
    const { t: t } = (0, $e1LEq.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8RTRt.default), {
        "data-testid": "settings-mobile",
        "data-state": "desktop-only",
        header: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5zhhf.default), {
            title: t('settings.title'),
            onBack: ()=>window.history.back(),
            backLabel: t('common.actions.back'),
            "data-testid": "settings-mobile-header"
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            style: {
                padding: '0.875rem 1rem'
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aLdCl.default), {
                what: t('operations.desktopOnly.settings'),
                "data-testid": "settings-desktop-note"
            })
        })
    });
}

});

parcelRegister("h7MBc", function(module, exports) {

$parcel$export(module.exports, "BillingBodySkeleton", () => $93aa64c589e25605$export$9915e590fcf0e2b6);
$parcel$export(module.exports, "WhatsappBodySkeleton", () => $93aa64c589e25605$export$586c4cbd152b4594);
$parcel$export(module.exports, "InventoryTierBodySkeleton", () => $93aa64c589e25605$export$d74314c07d2c25b3);
$parcel$export(module.exports, "ClinicViewSkeleton", () => $93aa64c589e25605$export$cc85f3b93acc6036);
$parcel$export(module.exports, "default", () => $93aa64c589e25605$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("5N0ZI");
var $kyZIh = parcelRequire("kyZIh");
var $eJIXW = parcelRequire("eJIXW");
var $66joL = parcelRequire("66joL");

var $jTCZr = parcelRequire("jTCZr");

var $jis86 = parcelRequire("jis86");
var $luQPr = parcelRequire("luQPr");
var $8GaEa = parcelRequire("8GaEa");
var $caALp = parcelRequire("caALp");
var $gyZlE = parcelRequire("gyZlE");

var $2xQve = parcelRequire("2xQve");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $9h2jQ = parcelRequire("9h2jQ");
parcelRequire("1NzLv");
var $5zhhf = parcelRequire("5zhhf");
var $8RTRt = parcelRequire("8RTRt");
/**
 * «کلینیک من» while it is waiting — the page's own anatomy in placeholder
 * blocks, drawn for a `view` (DESIGN.md §"Loading & skeleton"). The router's
 * Suspense fallback imports this EAGERLY and the screen reuses the body
 * pieces for its own first load, so the two draw the same shape and nothing
 * jumps when the clinic record lands.
 *
 * Archetype D, zones ① ③ ④ ⑤ (Clinic.web.jsx): PageHeader with its sub-line,
 * the KPI strip, the view SegmentedControl, then either P1 stacked
 * SectionCards (profile, billing, whatsapp) or the P2 main + rail (connect).
 *
 * Section titles are static and render for real — the SectionCard is the
 * chrome the reader recognises the page by. The fields, figures, QR and rows
 * inside are blocks. Light by contract: kit, tokens, density, i18n, mobile
 * primitives, lucide — never the screen or its hooks.
 */ const $93aa64c589e25605$var$VIEWS = new Set([
    'profile',
    'connect',
    'billing',
    'whatsapp',
    'inventory'
]);
const $93aa64c589e25605$export$6c11f739634b0b63 = (view)=>$93aa64c589e25605$var$VIEWS.has(view) ? view : 'profile';
/**
 * The kit's `SkeletonRegion` under this file's own prop names.
 *
 * It is the one announced `role="status"` when it is outermost and a plain
 * `aria-hidden` box when nested in another, so the whole-page skeleton — header
 * band plus a view body, each a region in its own right — announces "loading"
 * once rather than twice (DESIGN.md §"Loading & skeleton" — region root).
 */ function $93aa64c589e25605$var$Status({ label: label, testId: testId, className: className, style: style, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonRegion), {
        label: label,
        "data-testid": testId,
        className: className,
        style: style,
        children: children
    });
}
function $93aa64c589e25605$export$62cb697e7c4379e8({ compact: compact = false }) {
    const { t: t } = (0, $e1LEq.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($93aa64c589e25605$var$Status, {
        label: t('common.state.loading'),
        testId: "clinic-profile-skeleton",
        className: compact ? 'flex flex-col gap-4' : 'max-w-[1100px] space-y-5',
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eJIXW.default), {
                title: t('clinic.sections.identity'),
                icon: (0, $jis86.default),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: compact ? 'grid grid-cols-1 gap-4' : 'grid grid-cols-1 gap-4 sm:grid-cols-2',
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonInput), {}),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonInput), {}),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonInput), {}),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonInput), {}),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonInput), {
                            style: compact ? undefined : {
                                gridColumn: '1 / -1'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonInput), {})
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eJIXW.default), {
                title: t('clinic.sections.status'),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex flex-wrap items-center justify-between gap-3",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                            width: "55%",
                            height: 14
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                            width: 44,
                            height: 24,
                            radius: (0, $jTCZr.RADIUS).pill
                        })
                    ]
                })
            })
        ]
    });
}
function $93aa64c589e25605$export$9e61ae9c5de4241b({ compact: compact = false }) {
    const { t: t } = (0, $e1LEq.default)();
    const qr = compact ? 180 : 200;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($93aa64c589e25605$var$Status, {
        label: t('common.state.loading'),
        testId: "clinic-connect-skeleton",
        className: compact ? 'flex flex-col gap-4' : 'grid grid-cols-1 items-start gap-6 xl:grid-cols-[minmax(0,1fr)_340px]',
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eJIXW.default), {
                title: t('clinic.sections.qr'),
                icon: (0, $caALp.default),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex justify-center",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "inline-flex rounded-2xl border-2 border-border bg-white p-5 shadow-card",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                width: qr,
                                height: qr,
                                radius: 8
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonInput), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonInput), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex flex-wrap gap-2",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonButton), {
                                width: 132
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonButton), {
                                width: 112
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonButton), {
                                width: 96
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eJIXW.default), {
                title: t('clinic.sections.guide'),
                icon: (0, $8GaEa.default),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonText), {
                        lines: 4,
                        height: 12,
                        gap: 12
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "border-t border-border pt-4",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                            width: "70%",
                            height: 12
                        })
                    })
                ]
            })
        ]
    });
}
/** One offer card (سالانه or دائمی): heading, struck price, price, saving box, action. */ function $93aa64c589e25605$var$OfferCardSkeleton({ compact: compact }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "aria-hidden": true,
        style: {
            background: (0, $jTCZr.C).card,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: (0, $jTCZr.RADIUS).card,
            padding: compact ? 16 : 20,
            display: 'flex',
            flexDirection: 'column',
            gap: 14
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 12
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: 44,
                        height: 44,
                        radius: 12
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 6,
                            flex: 1
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                width: "45%",
                                height: 15
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                width: "70%",
                                height: 11
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                width: "50%",
                height: 14
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                width: "65%",
                height: compact ? 30 : 38
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                width: "100%",
                height: compact ? 64 : 72,
                radius: 12
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonButton), {
                width: "100%"
            })
        ]
    });
}
function $93aa64c589e25605$export$9915e590fcf0e2b6({ compact: compact = false, children: children }) {
    const { t: t } = (0, $e1LEq.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($93aa64c589e25605$var$Status, {
        label: t('common.state.loading'),
        testId: "subscription-loading",
        className: compact ? 'space-y-4' : 'space-y-5',
        children: [
            children,
            compact ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "rounded-2xl border border-border bg-white p-4 shadow-card",
                "aria-hidden": true,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex items-start justify-between gap-3",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 8,
                                flex: 1
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                    width: "40%",
                                    height: 14
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                    width: "80%",
                                    height: 12
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                    width: "55%",
                                    height: 12
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                            width: 72,
                            height: 24,
                            radius: (0, $jTCZr.RADIUS).pill
                        })
                    ]
                })
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eJIXW.default), {
                title: t('subscription.sections.plans'),
                icon: (0, $luQPr.default),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    "data-testid": "plan-offers-skeleton",
                    className: compact ? 'flex flex-col gap-5' : 'flex flex-wrap gap-5',
                    children: [
                        0,
                        1
                    ].map((i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: compact ? '' : 'min-w-0 flex-[1_1_360px]',
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($93aa64c589e25605$var$OfferCardSkeleton, {
                                compact: compact
                            })
                        }, i))
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eJIXW.default), {
                title: t('subscription.sections.history'),
                icon: (0, $gyZlE.default),
                children: compact ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "flex flex-col gap-2",
                    "aria-hidden": true,
                    children: [
                        0,
                        1
                    ].map((i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "rounded-lg border border-border bg-white p-3",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex items-center justify-between gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                            width: "45%",
                                            height: 13
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                            width: 64,
                                            height: 13
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                    width: "60%",
                                    height: 11,
                                    style: {
                                        marginTop: 8
                                    }
                                })
                            ]
                        }, i))
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonTable), {
                    rows: 3,
                    columns: 4,
                    label: t('common.state.loading')
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eJIXW.default), {
                title: t('subscription.sections.reminders'),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex flex-wrap items-center justify-between gap-3",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                            width: "50%",
                            height: 14
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonButton), {
                            width: 140
                        })
                    ]
                })
            })
        ]
    });
}
function $93aa64c589e25605$export$586c4cbd152b4594({ compact: compact = false }) {
    const { t: t } = (0, $e1LEq.default)();
    const pad = compact ? 14 : 20;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($93aa64c589e25605$var$Status, {
        label: t('common.state.loading'),
        testId: "whatsapp-loading",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                "aria-hidden": true,
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 14,
                    padding: compact ? '14px' : '16px 18px',
                    background: '#fff',
                    border: `1px solid ${(0, $jTCZr.C).border}`,
                    borderRadius: 14
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: 42,
                        height: 42,
                        radius: 12
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 8
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                width: "35%",
                                height: 14
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                width: "70%",
                                height: 12
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                width: "100%",
                height: 52,
                radius: (0, $jTCZr.RADIUS).card,
                style: {
                    marginTop: 16
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                "aria-hidden": true,
                style: {
                    marginTop: 20,
                    padding: pad,
                    background: '#fff',
                    border: `1px solid ${(0, $jTCZr.C).border}`,
                    borderRadius: 14
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: "100%",
                        height: 52,
                        radius: (0, $jTCZr.RADIUS).card,
                        style: {
                            marginBottom: 18
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonButton), {
                        width: compact ? '100%' : 168
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: "60%",
                        height: 11,
                        style: {
                            marginTop: 10
                        }
                    })
                ]
            })
        ]
    });
}
function $93aa64c589e25605$export$d74314c07d2c25b3({ compact: compact = false }) {
    const { t: t } = (0, $e1LEq.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($93aa64c589e25605$var$Status, {
        label: t('common.state.loading'),
        testId: "clinic-inventory-skeleton",
        className: compact ? 'flex flex-col gap-4' : 'max-w-[1100px] space-y-5',
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                "aria-hidden": true,
                style: {
                    display: 'grid',
                    gridTemplateColumns: compact ? '1fr' : 'repeat(3, 1fr)',
                    gap: 12
                },
                children: [
                    0,
                    1,
                    2
                ].map((i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            padding: 14,
                            borderRadius: 12,
                            background: '#fff',
                            border: `2px solid ${(0, $jTCZr.C).border}`
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                width: 88 + i * 12,
                                height: 14,
                                style: {
                                    marginBottom: 8
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                width: "100%",
                                height: 12,
                                style: {
                                    marginBottom: 6
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                width: "72%",
                                height: 12
                            })
                        ]
                    }, i))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                "aria-hidden": true,
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 12,
                    padding: '12px 14px',
                    background: '#fff',
                    border: `1px solid ${(0, $jTCZr.C).border}`,
                    borderRadius: 12
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: "42%",
                        height: 13
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: 40,
                        height: 22,
                        radius: (0, $jTCZr.RADIUS).pill
                    })
                ]
            })
        ]
    });
}
function $93aa64c589e25605$var$Body({ view: view, compact: compact }) {
    if (view === 'billing') return /*#__PURE__*/ (0, $ayMG0.jsx)($93aa64c589e25605$export$9915e590fcf0e2b6, {
        compact: compact
    });
    if (view === 'whatsapp') return /*#__PURE__*/ (0, $ayMG0.jsx)($93aa64c589e25605$export$586c4cbd152b4594, {
        compact: compact
    });
    if (view === 'connect') return /*#__PURE__*/ (0, $ayMG0.jsx)($93aa64c589e25605$export$9e61ae9c5de4241b, {
        compact: compact
    });
    if (view === 'inventory') return /*#__PURE__*/ (0, $ayMG0.jsx)($93aa64c589e25605$export$d74314c07d2c25b3, {
        compact: compact
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($93aa64c589e25605$export$62cb697e7c4379e8, {
        compact: compact
    });
}
function $93aa64c589e25605$export$cc85f3b93acc6036({ view: requested = 'profile', compact: compact = false }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($93aa64c589e25605$var$Body, {
        view: $93aa64c589e25605$export$6c11f739634b0b63(requested),
        compact: compact
    });
}
const $93aa64c589e25605$export$8709a824f9d9d7a = $93aa64c589e25605$export$9915e590fcf0e2b6;
function $93aa64c589e25605$export$7c40ce2dce2a2f2b({ view: requested = 'profile' }) {
    const { t: t } = (0, $e1LEq.default)();
    const view = $93aa64c589e25605$export$6c11f739634b0b63(requested);
    const label = t('common.state.loading');
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $66joL.SkeletonRegion), {
        className: "flex h-full flex-col bg-background",
        label: label,
        "data-testid": "clinic-skeleton",
        "data-view": view,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kyZIh.default), {
                title: t('nav.items.clinic'),
                sub: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                    width: 220,
                    height: 12
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "min-h-0 flex-1 overflow-y-auto px-8 py-6",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mb-5",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonStats), {
                            count: 4,
                            label: label
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mb-5",
                        "aria-hidden": true,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                display: 'inline-flex',
                                gap: 4,
                                padding: 4,
                                borderRadius: 12,
                                background: (0, $jTCZr.C).bg
                            },
                            children: [
                                88,
                                96,
                                104
                            ].map((w, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                    width: w,
                                    height: 36,
                                    radius: 9
                                }, i))
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: view === 'whatsapp' ? 'max-w-[1100px]' : undefined,
                        children: view === 'whatsapp' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                maxWidth: 640
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        marginBottom: 24
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                            style: {
                                                margin: 0,
                                                fontSize: '1.125rem',
                                                fontWeight: 800,
                                                color: (0, $jTCZr.C).textPrimary
                                            },
                                            children: t('settings.whatsapp.title')
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                            width: "60%",
                                            height: 12,
                                            style: {
                                                marginTop: 8
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($93aa64c589e25605$export$586c4cbd152b4594, {})
                            ]
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)($93aa64c589e25605$var$Body, {
                            view: view,
                            compact: false
                        })
                    })
                ]
            })
        ]
    });
}
function $93aa64c589e25605$export$a46ef5dd72fe26a7({ view: requested = 'profile' }) {
    const { t: t } = (0, $e1LEq.default)();
    const view = $93aa64c589e25605$export$6c11f739634b0b63(requested);
    const label = t('common.state.loading');
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonRegion), {
        className: "flex h-full flex-col bg-background",
        label: label,
        "data-testid": "clinic-skeleton",
        "data-view": view,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $8RTRt.default), {
            header: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5zhhf.default), {
                title: t('nav.items.clinic'),
                subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                    tone: "onDark",
                    width: 160,
                    height: 11
                })
            }),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    "aria-hidden": true,
                    style: {
                        display: 'flex',
                        gap: 4,
                        padding: '0 0.25rem',
                        borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
                        background: (0, $jTCZr.C).bg
                    },
                    children: [
                        64,
                        88,
                        72
                    ].map((w, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                padding: '12px 14px'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                width: w,
                                height: 12
                            })
                        }, i))
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "flex flex-col gap-4 p-4",
                    style: {
                        gap: (0, $2xQve.STACK).regular + 4
                    },
                    children: view === 'whatsapp' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    marginBottom: 16
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                        style: {
                                            margin: 0,
                                            fontSize: '1rem',
                                            fontWeight: 800,
                                            color: (0, $jTCZr.C).textPrimary
                                        },
                                        children: t('settings.whatsapp.title')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                        width: "70%",
                                        height: 12,
                                        style: {
                                            marginTop: 8
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($93aa64c589e25605$export$586c4cbd152b4594, {
                                compact: true
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)($93aa64c589e25605$var$Body, {
                        view: view,
                        compact: true
                    })
                })
            ]
        })
    });
}
function $93aa64c589e25605$export$2e2bcd8739ae039(props) {
    const { isMobile: isMobile } = (0, $9h2jQ.default)();
    return isMobile ? /*#__PURE__*/ (0, $ayMG0.jsx)($93aa64c589e25605$export$a46ef5dd72fe26a7, {
        ...props
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)($93aa64c589e25605$export$7c40ce2dce2a2f2b, {
        ...props
    });
}

});
parcelRegister("luQPr", function(module, exports) {

$parcel$export(module.exports, "default", () => $02c719a0dfee0bc4$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $02c719a0dfee0bc4$export$a2387ed3b5d536eb = {
    name: "credit-card",
    size: 24,
    node: [
        [
            "rect",
            {
                width: "20",
                height: "14",
                x: "2",
                y: "5",
                rx: "2",
                key: "ynyp8z"
            }
        ],
        [
            "line",
            {
                x1: "2",
                x2: "22",
                y1: "10",
                y2: "10",
                key: "1b3vmo"
            }
        ],
        [
            "path",
            {
                d: "M6 14h2",
                key: "mk7k0u"
            }
        ]
    ]
};
$02c719a0dfee0bc4$export$a2387ed3b5d536eb.node;
const $02c719a0dfee0bc4$export$2e2bcd8739ae039 = (0, $9QBug.default)($02c719a0dfee0bc4$export$a2387ed3b5d536eb);

});

parcelRegister("8GaEa", function(module, exports) {

$parcel$export(module.exports, "default", () => $076dec67eda939bc$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $076dec67eda939bc$export$a2387ed3b5d536eb = {
    name: "lightbulb",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5",
                key: "1gvzjb"
            }
        ],
        [
            "path",
            {
                d: "M9 18h6",
                key: "x1upvd"
            }
        ],
        [
            "path",
            {
                d: "M10 22h4",
                key: "ceow96"
            }
        ]
    ]
};
$076dec67eda939bc$export$a2387ed3b5d536eb.node;
const $076dec67eda939bc$export$2e2bcd8739ae039 = (0, $9QBug.default)($076dec67eda939bc$export$a2387ed3b5d536eb);

});

parcelRegister("caALp", function(module, exports) {

$parcel$export(module.exports, "default", () => $a96b0ecd9446b1f0$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $a96b0ecd9446b1f0$export$a2387ed3b5d536eb = {
    name: "qr-code",
    size: 24,
    node: [
        [
            "rect",
            {
                width: "5",
                height: "5",
                x: "3",
                y: "3",
                rx: "1",
                key: "1tu5fj"
            }
        ],
        [
            "rect",
            {
                width: "5",
                height: "5",
                x: "16",
                y: "3",
                rx: "1",
                key: "1v8r4q"
            }
        ],
        [
            "rect",
            {
                width: "5",
                height: "5",
                x: "3",
                y: "16",
                rx: "1",
                key: "1x03jg"
            }
        ],
        [
            "path",
            {
                d: "M21 16h-3a2 2 0 0 0-2 2v3",
                key: "177gqh"
            }
        ],
        [
            "path",
            {
                d: "M21 21v.01",
                key: "ents32"
            }
        ],
        [
            "path",
            {
                d: "M12 7v3a2 2 0 0 1-2 2H7",
                key: "8crl2c"
            }
        ],
        [
            "path",
            {
                d: "M3 12h.01",
                key: "nlz23k"
            }
        ],
        [
            "path",
            {
                d: "M12 3h.01",
                key: "n36tog"
            }
        ],
        [
            "path",
            {
                d: "M12 16v.01",
                key: "133mhm"
            }
        ],
        [
            "path",
            {
                d: "M16 12h1",
                key: "1slzba"
            }
        ],
        [
            "path",
            {
                d: "M21 12v.01",
                key: "1lwtk9"
            }
        ],
        [
            "path",
            {
                d: "M12 21v-1",
                key: "1880an"
            }
        ]
    ]
};
$a96b0ecd9446b1f0$export$a2387ed3b5d536eb.node;
const $a96b0ecd9446b1f0$export$2e2bcd8739ae039 = (0, $9QBug.default)($a96b0ecd9446b1f0$export$a2387ed3b5d536eb);

});

parcelRegister("gyZlE", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9d1da00c6e56295$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $b9d1da00c6e56295$export$a2387ed3b5d536eb = {
    name: "receipt",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M12 17V7",
                key: "pyj7ub"
            }
        ],
        [
            "path",
            {
                d: "M16 8h-6a2 2 0 0 0 0 4h4a2 2 0 0 1 0 4H8",
                key: "1elt7d"
            }
        ],
        [
            "path",
            {
                d: "M4 3a1 1 0 0 1 1-1 1.3 1.3 0 0 1 .7.2l.933.6a1.3 1.3 0 0 0 1.4 0l.934-.6a1.3 1.3 0 0 1 1.4 0l.933.6a1.3 1.3 0 0 0 1.4 0l.933-.6a1.3 1.3 0 0 1 1.4 0l.934.6a1.3 1.3 0 0 0 1.4 0l.933-.6A1.3 1.3 0 0 1 19 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1 1.3 1.3 0 0 1-.7-.2l-.933-.6a1.3 1.3 0 0 0-1.4 0l-.934.6a1.3 1.3 0 0 1-1.4 0l-.933-.6a1.3 1.3 0 0 0-1.4 0l-.933.6a1.3 1.3 0 0 1-1.4 0l-.934-.6a1.3 1.3 0 0 0-1.4 0l-.933.6a1.3 1.3 0 0 1-.7.2 1 1 0 0 1-1-1z",
                key: "ycz6yz"
            }
        ]
    ]
};
$b9d1da00c6e56295$export$a2387ed3b5d536eb.node;
const $b9d1da00c6e56295$export$2e2bcd8739ae039 = (0, $9QBug.default)($b9d1da00c6e56295$export$a2387ed3b5d536eb);

});


parcelRegister("7cb0D", function(module, exports) {

$parcel$export(module.exports, "default", () => $f65df25345db8f1b$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("bnX6X");
var $asVAE = parcelRequire("asVAE");
var $aX9TZ = parcelRequire("aX9TZ");
var $fWbIA = parcelRequire("fWbIA");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $9h2jQ = parcelRequire("9h2jQ");
function $f65df25345db8f1b$export$2e2bcd8739ae039({ kind: kind, tab: tab }) {
    const { t: t } = (0, $e1LEq.default)();
    const { isMobile: isMobile } = (0, $9h2jQ.default)();
    const label = t('common.state.loading');
    if (kind === 'visit') return isMobile ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fWbIA.VisitMobileSkeleton), {
        label: label
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fWbIA.VisitSkeleton), {
        label: label
    });
    return isMobile ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $asVAE.default), {
        tab: tab || 'overview',
        label: label
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aX9TZ.default), {
        tab: tab || 'overview',
        label: label
    });
}

});

parcelRegister("eYxJa", function(module, exports) {

$parcel$export(module.exports, "planKindFrom", () => $ae70d4e093e87f2f$export$5c79798da0ef8019);
$parcel$export(module.exports, "stashPurchaseIntent", () => $ae70d4e093e87f2f$export$bc990d8886bf3af6);
$parcel$export(module.exports, "clinicEntryPath", () => $ae70d4e093e87f2f$export$b37e74a75d504599);
/**
 * «خرید اشتراک» on the landing sites — carried through sign-up and onboarding.
 *
 * parsinabot.ir and parsinadent.ir send a plan card's button to
 * `/subscription?plan=<kind>`. For a clinic owner that already works on its own:
 * auth.js keeps the path across the Keycloak round trip, and `/subscription`
 * forwards into «کلینیک من → اشتراک» with the query intact.
 *
 * A person with NO clinic is the case this file exists for. Every path they
 * open is sent to «شروع», and onboarding used to end on the new clinic's home —
 * so someone who pressed «خرید» signed up, built a clinic, and landed on پذیرش
 * with no idea where the plan they chose had gone. The no-clinic redirect
 * (StartRedirect) writes the intent here, and the two places onboarding ends
 * (the wizard's `enter`, quick setup's `enter`) read it back through
 * `clinicEntryPath`.
 *
 * What it never does is start a checkout. The billing page marks the card and
 * waits for the person to press it: the price — the congress price included —
 * is something they confirm, not something that happens to them after sign-up.
 *
 * `sessionStorage`, like the return path in auth.js: scoped to this tab, which
 * is the tab the sign-up happens in. The TTL stops a buy click that was
 * abandoned at «شروع» from steering a clinic created hours later in that tab.
 */ const $ae70d4e093e87f2f$var$KEY = 'purchase.intent.v1';
const $ae70d4e093e87f2f$var$TTL_MS = 7200000;
const $ae70d4e093e87f2f$export$fce90c1ff699dd99 = [
    'annual',
    'perpetual',
    'monthly'
];
function $ae70d4e093e87f2f$export$5c79798da0ef8019(search) {
    const kind = new URLSearchParams(search || '').get('plan') || '';
    return $ae70d4e093e87f2f$export$fce90c1ff699dd99.includes(kind) ? kind : '';
}
function $ae70d4e093e87f2f$export$bc990d8886bf3af6(plan, now = Date.now()) {
    try {
        sessionStorage.setItem($ae70d4e093e87f2f$var$KEY, JSON.stringify({
            plan: $ae70d4e093e87f2f$export$fce90c1ff699dd99.includes(plan) ? plan : '',
            at: now
        }));
    } catch  {}
}
function $ae70d4e093e87f2f$export$aaef2089077eaf53(now = Date.now()) {
    try {
        const raw = sessionStorage.getItem($ae70d4e093e87f2f$var$KEY);
        sessionStorage.removeItem($ae70d4e093e87f2f$var$KEY);
        const intent = raw ? JSON.parse(raw) : null;
        if (!intent || typeof intent.at !== 'number' || now - intent.at > $ae70d4e093e87f2f$var$TTL_MS) return null;
        return {
            plan: $ae70d4e093e87f2f$export$fce90c1ff699dd99.includes(intent.plan) ? intent.plan : ''
        };
    } catch  {
        return null;
    }
}
function $ae70d4e093e87f2f$export$b37e74a75d504599(ref) {
    const intent = $ae70d4e093e87f2f$export$aaef2089077eaf53();
    if (!intent) return `/c/${ref}/`;
    return intent.plan ? `/c/${ref}/clinic?view=billing&plan=${intent.plan}` : `/c/${ref}/clinic?view=billing`;
}

});

parcelRegister("bMi4A", function(module, exports) {

$parcel$export(module.exports, "OTHER", () => $8932324c66904a7e$export$d46a05f8561f868a);
$parcel$export(module.exports, "matchProvince", () => $8932324c66904a7e$export$f520b18602db8734);
$parcel$export(module.exports, "matchCity", () => $8932324c66904a7e$export$992c397cef99dbe2);
$parcel$export(module.exports, "provinceOfCity", () => $8932324c66904a7e$export$7bb1a88891778279);
$parcel$export(module.exports, "provinceOptions", () => $8932324c66904a7e$export$a843c9c15d519b7a);
$parcel$export(module.exports, "cityOptions", () => $8932324c66904a7e$export$cc49b451e50b5041);
/**
 * استان و شهر — the pickable list, and the matching that makes it safe.
 *
 * The names themselves live in `iranGeo.json` beside this file. They are DATA,
 * not UI copy: the exact string is stored on the clinic record, it is the same
 * word in an English UI, and translating it would orphan every clinic already
 * saved with a Persian province. JSON also keeps them out of the reach of
 * `scripts/i18n-audit.js`, which walks `.js`/`.jsx` only.
 *
 * ── The rule this module exists to enforce ───────────────────────────────────
 *
 * These two fields were free text until now, and `updateClinic` is a FULL
 * REPLACE (see `Clinic.shared.js` → `toUpdateInput`). So a `<select>` whose
 * options do not contain what the clinic already has renders EMPTY, and the
 * very next save writes that emptiness over a real province. Every caller must
 * therefore go through `provinceOptions` / `cityOptions`, which carry the stored
 * value into the list whenever it is not one of ours.
 *
 * ── Matching ────────────────────────────────────────────────────────────────
 *
 * A geocoder does not answer in our spelling. Nominatim returns «استان تهران»
 * where this list says «تهران», and Persian text arrives with Arabic ي/ك, with
 * or without ZWNJ, and occasionally with Persian digits. `matchProvince` and
 * `matchCity` fold all of that away and give back OUR canonical spelling, so a
 * clinic located from the map and a clinic picked from the list store the same
 * string.
 */ 
var $gHYOt = parcelRequire("gHYOt");

var $8VC51 = parcelRequire("8VC51");

var $cMRsf = parcelRequire("cMRsf");
const $8932324c66904a7e$var$EN_NAMES = (0, (/*@__PURE__*/$parcel$interopDefault($8VC51))).names;
const $8932324c66904a7e$export$d46a05f8561f868a = '__other__';
const $8932324c66904a7e$var$PROVINCES = (0, (/*@__PURE__*/$parcel$interopDefault($gHYOt))).provinces;
const $8932324c66904a7e$export$847492a95cb01552 = $8932324c66904a7e$var$PROVINCES.map((p)=>p.name);
function $8932324c66904a7e$export$eceaf1f7147b66ff(name, locale) {
    return (0, $cMRsf.LOCALES)[locale]?.dir === 'ltr' && $8932324c66904a7e$var$EN_NAMES[name] || name;
}
const $8932324c66904a7e$var$BY_PROVINCE = new Map($8932324c66904a7e$var$PROVINCES.map((p)=>[
        p.name,
        p.cities
    ]));
// i18n-exempt: administrative prefixes stripped before matching — data, not UI copy.
const $8932324c66904a7e$var$PREFIXES = [
    "\u0627\u0633\u062A\u0627\u0646 ",
    "\u0634\u0647\u0631\u0633\u062A\u0627\u0646 ",
    "\u0634\u0647\u0631 ",
    "\u0628\u062E\u0634 "
];
const $8932324c66904a7e$var$DIGITS = {
    "\u06F0": '0',
    "\u06F1": '1',
    "\u06F2": '2',
    "\u06F3": '3',
    "\u06F4": '4',
    "\u06F5": '5',
    "\u06F6": '6',
    "\u06F7": '7',
    "\u06F8": '8',
    "\u06F9": '9',
    "\u0660": '0',
    "\u0661": '1',
    "\u0662": '2',
    "\u0663": '3',
    "\u0664": '4',
    "\u0665": '5',
    "\u0666": '6',
    "\u0667": '7',
    "\u0668": '8',
    "\u0669": '9'
}; // i18n-exempt: digit glyphs folded for comparison — data, not UI copy.
function $8932324c66904a7e$export$ac3df1d77da4d17f(value) {
    if (value == null) return '';
    let out = String(value).trim();
    if (!out) return '';
    out = out.replace(/[\u064a\u0649]/g, '\u06cc') // Arabic ي / ى → Persian ی
    .replace(/\u0643/g, '\u06a9') // Arabic ك → Persian ک
    .replace(/[\u200c\u00a0]/g, ' ') // ZWNJ / nbsp → a plain space
    .replace(/[\u200b\u200d-\u200f\u202a-\u202e\u064b-\u0652]/g, '') // bidi marks, harakat
    .replace(/[\u06f0-\u06f9\u0660-\u0669]/g, (d)=>$8932324c66904a7e$var$DIGITS[d] || d).replace(/\s+/g, ' ').trim();
    for (const prefix of $8932324c66904a7e$var$PREFIXES)if (out.startsWith(prefix)) {
        out = out.slice(prefix.length).trim();
        break;
    }
    // Whitespace goes LAST and goes entirely: «خمینی‌شهر», «خمینی شهر» and
    // «خمینیشهر» are one city typed three ways, and the key has to agree. The
    // prefix strip above needs the spaces, which is why this is not done sooner.
    return out.replace(/\s+/g, '');
}
const $8932324c66904a7e$var$PROVINCE_INDEX = new Map($8932324c66904a7e$export$847492a95cb01552.map((name)=>[
        $8932324c66904a7e$export$ac3df1d77da4d17f(name),
        name
    ]));
function $8932324c66904a7e$export$6663adcca0098c61(province) {
    const canonical = $8932324c66904a7e$export$f520b18602db8734(province);
    return canonical && $8932324c66904a7e$var$BY_PROVINCE.get(canonical) || [];
}
function $8932324c66904a7e$export$f520b18602db8734(raw) {
    const key = $8932324c66904a7e$export$ac3df1d77da4d17f(raw);
    if (!key) return null;
    return $8932324c66904a7e$var$PROVINCE_INDEX.get(key) || null;
}
function $8932324c66904a7e$export$992c397cef99dbe2(province, raw) {
    const key = $8932324c66904a7e$export$ac3df1d77da4d17f(raw);
    if (!key) return null;
    const within = $8932324c66904a7e$export$6663adcca0098c61(province).find((c)=>$8932324c66904a7e$export$ac3df1d77da4d17f(c) === key);
    if (within) return within;
    if ($8932324c66904a7e$export$f520b18602db8734(province)) return null;
    for (const p of $8932324c66904a7e$var$PROVINCES){
        const hit = p.cities.find((c)=>$8932324c66904a7e$export$ac3df1d77da4d17f(c) === key);
        if (hit) return hit;
    }
    return null;
}
function $8932324c66904a7e$export$7bb1a88891778279(raw) {
    const key = $8932324c66904a7e$export$ac3df1d77da4d17f(raw);
    if (!key) return null;
    const owner = $8932324c66904a7e$var$PROVINCES.find((p)=>p.cities.some((c)=>$8932324c66904a7e$export$ac3df1d77da4d17f(c) === key));
    return owner ? owner.name : null;
}
function $8932324c66904a7e$export$a843c9c15d519b7a(stored, locale) {
    const known = $8932324c66904a7e$export$847492a95cb01552.map((name)=>({
            value: name,
            label: $8932324c66904a7e$export$eceaf1f7147b66ff(name, locale)
        }));
    const value = String(stored || '').trim();
    if (value && !$8932324c66904a7e$export$f520b18602db8734(value)) return [
        {
            value: value,
            label: value
        },
        ...known
    ];
    return known;
}
function $8932324c66904a7e$export$cc49b451e50b5041(province, stored, locale) {
    const known = $8932324c66904a7e$export$6663adcca0098c61(province).map((name)=>({
            value: name,
            label: $8932324c66904a7e$export$eceaf1f7147b66ff(name, locale)
        }));
    const value = String(stored || '').trim();
    if (value && !known.some((o)=>$8932324c66904a7e$export$ac3df1d77da4d17f(o.value) === $8932324c66904a7e$export$ac3df1d77da4d17f(value))) return [
        {
            value: value,
            label: value
        },
        ...known
    ];
    return known;
}

});
parcelRegister("gHYOt", function(module, exports) {
module.exports = JSON.parse('{"_readme":"Iranian provinces and their \u0634\u0647\u0631\u0633\u062A\u0627\u0646 centres. DATA, not UI copy: these strings are stored verbatim on the clinic record and are the same words in an English UI. Kept as JSON on purpose \u2014 scripts/i18n-audit.js walks .js/.jsx only, so a place name here cannot be mistaken for an untranslated string. See src/constants/iranGeo.js for the helpers.","provinces":[{"name":"\u0622\u0630\u0631\u0628\u0627\u06CC\u062C\u0627\u0646 \u0634\u0631\u0642\u06CC","cities":["\u062A\u0628\u0631\u06CC\u0632","\u0645\u0631\u0627\u063A\u0647","\u0645\u0631\u0646\u062F","\u0627\u0647\u0631","\u0628\u0646\u0627\u0628","\u0645\u06CC\u0627\u0646\u0647","\u0634\u0628\u0633\u062A\u0631","\u0633\u0631\u0627\u0628","\u0622\u0630\u0631\u0634\u0647\u0631","\u0627\u0633\u06A9\u0648","\u0628\u0633\u062A\u0627\u0646\u200C\u0622\u0628\u0627\u062F","\u062C\u0644\u0641\u0627","\u0639\u062C\u0628\u200C\u0634\u06CC\u0631","\u06A9\u0644\u06CC\u0628\u0631","\u0645\u0644\u06A9\u0627\u0646","\u0648\u0631\u0632\u0642\u0627\u0646","\u0647\u0631\u06CC\u0633","\u0647\u0634\u062A\u0631\u0648\u062F","\u062E\u062F\u0627\u0622\u0641\u0631\u06CC\u0646","\u0686\u0627\u0631\u0627\u0648\u06CC\u0645\u0627\u0642"]},{"name":"\u0622\u0630\u0631\u0628\u0627\u06CC\u062C\u0627\u0646 \u063A\u0631\u0628\u06CC","cities":["\u0627\u0631\u0648\u0645\u06CC\u0647","\u062E\u0648\u06CC","\u0645\u06CC\u0627\u0646\u062F\u0648\u0622\u0628","\u0645\u0647\u0627\u0628\u0627\u062F","\u0628\u0648\u06A9\u0627\u0646","\u0633\u0644\u0645\u0627\u0633","\u0646\u0642\u062F\u0647","\u067E\u06CC\u0631\u0627\u0646\u0634\u0647\u0631","\u0633\u0631\u062F\u0634\u062A","\u0645\u0627\u06A9\u0648","\u0634\u0627\u0647\u06CC\u0646\u200C\u062F\u0698","\u062A\u06A9\u0627\u0628","\u0627\u0634\u0646\u0648\u06CC\u0647","\u0686\u0627\u0644\u062F\u0631\u0627\u0646","\u067E\u0644\u062F\u0634\u062A","\u0686\u0627\u06CC\u067E\u0627\u0631\u0647","\u0634\u0648\u0637"]},{"name":"\u0627\u0631\u062F\u0628\u06CC\u0644","cities":["\u0627\u0631\u062F\u0628\u06CC\u0644","\u067E\u0627\u0631\u0633\u200C\u0622\u0628\u0627\u062F","\u0645\u0634\u06AF\u06CC\u0646\u200C\u0634\u0647\u0631","\u062E\u0644\u062E\u0627\u0644","\u06AF\u0631\u0645\u06CC","\u0628\u06CC\u0644\u0647\u200C\u0633\u0648\u0627\u0631","\u0646\u0645\u06CC\u0646","\u0646\u06CC\u0631","\u06A9\u0648\u062B\u0631","\u0633\u0631\u0639\u06CC\u0646"]},{"name":"\u0627\u0635\u0641\u0647\u0627\u0646","cities":["\u0627\u0635\u0641\u0647\u0627\u0646","\u06A9\u0627\u0634\u0627\u0646","\u062E\u0645\u06CC\u0646\u06CC\u200C\u0634\u0647\u0631","\u0646\u062C\u0641\u200C\u0622\u0628\u0627\u062F","\u0634\u0627\u0647\u06CC\u0646\u200C\u0634\u0647\u0631","\u0634\u0647\u0631\u0636\u0627","\u0641\u0644\u0627\u0648\u0631\u062C\u0627\u0646","\u0645\u0628\u0627\u0631\u06A9\u0647","\u06AF\u0644\u067E\u0627\u06CC\u06AF\u0627\u0646","\u0646\u0637\u0646\u0632","\u0627\u0631\u062F\u0633\u062A\u0627\u0646","\u0633\u0645\u06CC\u0631\u0645","\u0632\u0631\u06CC\u0646\u200C\u0634\u0647\u0631","\u062A\u06CC\u0631\u0627\u0646","\u062F\u0647\u0627\u0642\u0627\u0646","\u062E\u0648\u0627\u0646\u0633\u0627\u0631","\u0641\u0631\u06CC\u062F\u0646","\u0641\u0631\u06CC\u062F\u0648\u0646\u200C\u0634\u0647\u0631","\u0686\u0627\u062F\u06AF\u0627\u0646","\u0628\u0648\u06CC\u06CC\u0646 \u0648 \u0645\u06CC\u0627\u0646\u062F\u0634\u062A","\u0646\u0627\u0626\u06CC\u0646","\u0622\u0631\u0627\u0646 \u0648 \u0628\u06CC\u062F\u06AF\u0644","\u062F\u0648\u0644\u062A\u200C\u0622\u0628\u0627\u062F","\u062E\u0648\u0631"]},{"name":"\u0627\u0644\u0628\u0631\u0632","cities":["\u06A9\u0631\u062C","\u0641\u0631\u062F\u06CC\u0633","\u0646\u0638\u0631\u0622\u0628\u0627\u062F","\u0647\u0634\u062A\u06AF\u0631\u062F","\u0627\u0634\u062A\u0647\u0627\u0631\u062F","\u0637\u0627\u0644\u0642\u0627\u0646","\u0686\u0647\u0627\u0631\u0628\u0627\u063A","\u0645\u0627\u0647\u062F\u0634\u062A","\u0645\u062D\u0645\u062F\u0634\u0647\u0631","\u0645\u0634\u06A9\u06CC\u0646\u200C\u062F\u0634\u062A"]},{"name":"\u0627\u06CC\u0644\u0627\u0645","cities":["\u0627\u06CC\u0644\u0627\u0645","\u062F\u0647\u0644\u0631\u0627\u0646","\u0622\u0628\u062F\u0627\u0646\u0627\u0646","\u0645\u0647\u0631\u0627\u0646","\u0627\u06CC\u0648\u0627\u0646","\u062F\u0631\u0647\u200C\u0634\u0647\u0631","\u0633\u0631\u0627\u0628\u0644\u0647","\u0628\u062F\u0631\u0647","\u0627\u0631\u06A9\u0648\u0627\u0632","\u0686\u0648\u0627\u0631","\u0647\u0644\u06CC\u0644\u0627\u0646"]},{"name":"\u0628\u0648\u0634\u0647\u0631","cities":["\u0628\u0648\u0634\u0647\u0631","\u0628\u0631\u0627\u0632\u062C\u0627\u0646","\u06AF\u0646\u0627\u0648\u0647","\u062F\u06CC\u0644\u0645","\u062E\u0648\u0631\u0645\u0648\u062C","\u0627\u0647\u0631\u0645","\u062C\u0645","\u06A9\u0646\u06AF\u0627\u0646","\u0639\u0633\u0644\u0648\u06CC\u0647","\u062F\u06CC\u0631","\u0628\u0646\u062F\u0631 \u0631\u06CC\u06AF"]},{"name":"\u062A\u0647\u0631\u0627\u0646","cities":["\u062A\u0647\u0631\u0627\u0646","\u0627\u0633\u0644\u0627\u0645\u0634\u0647\u0631","\u0634\u0647\u0631\u06CC\u0627\u0631","\u0631\u06CC","\u0648\u0631\u0627\u0645\u06CC\u0646","\u067E\u0627\u06A9\u062F\u0634\u062A","\u0631\u0628\u0627\u0637\u200C\u06A9\u0631\u06CC\u0645","\u0642\u062F\u0633","\u0645\u0644\u0627\u0631\u062F","\u0642\u0631\u0686\u06A9","\u067E\u0631\u062F\u06CC\u0633","\u062F\u0645\u0627\u0648\u0646\u062F","\u0641\u06CC\u0631\u0648\u0632\u06A9\u0648\u0647","\u067E\u06CC\u0634\u0648\u0627","\u0628\u0647\u0627\u0631\u0633\u062A\u0627\u0646","\u062A\u062C\u0631\u06CC\u0634","\u0628\u0627\u0642\u0631\u0634\u0647\u0631","\u0686\u0647\u0627\u0631\u062F\u0627\u0646\u06AF\u0647","\u0646\u0633\u06CC\u0645\u200C\u0634\u0647\u0631","\u0627\u0646\u062F\u06CC\u0634\u0647","\u0644\u0648\u0627\u0633\u0627\u0646","\u0631\u0648\u062F\u0647\u0646","\u0628\u0648\u0645\u0647\u0646","\u062D\u0633\u0646\u200C\u0622\u0628\u0627\u062F"]},{"name":"\u0686\u0647\u0627\u0631\u0645\u062D\u0627\u0644 \u0648 \u0628\u062E\u062A\u06CC\u0627\u0631\u06CC","cities":["\u0634\u0647\u0631\u06A9\u0631\u062F","\u0628\u0631\u0648\u062C\u0646","\u0644\u0631\u062F\u06AF\u0627\u0646","\u0641\u0627\u0631\u0633\u0627\u0646","\u0627\u0631\u062F\u0644","\u0634\u0644\u0645\u0632\u0627\u0631","\u0686\u0644\u06AF\u0631\u062F","\u0628\u0646","\u0633\u0627\u0645\u0627\u0646","\u062E\u0627\u0646\u0645\u06CC\u0631\u0632\u0627"]},{"name":"\u062E\u0631\u0627\u0633\u0627\u0646 \u062C\u0646\u0648\u0628\u06CC","cities":["\u0628\u06CC\u0631\u062C\u0646\u062F","\u0642\u0627\u0626\u0646","\u0641\u0631\u062F\u0648\u0633","\u0637\u0628\u0633","\u0646\u0647\u0628\u0646\u062F\u0627\u0646","\u0633\u0631\u0627\u06CC\u0627\u0646","\u0628\u0634\u0631\u0648\u06CC\u0647","\u062F\u0631\u0645\u06CC\u0627\u0646","\u062E\u0648\u0633\u0641","\u0632\u06CC\u0631\u06A9\u0648\u0647","\u0633\u0631\u0628\u06CC\u0634\u0647"]},{"name":"\u062E\u0631\u0627\u0633\u0627\u0646 \u0631\u0636\u0648\u06CC","cities":["\u0645\u0634\u0647\u062F","\u0646\u06CC\u0634\u0627\u0628\u0648\u0631","\u0633\u0628\u0632\u0648\u0627\u0631","\u062A\u0631\u0628\u062A \u062D\u06CC\u062F\u0631\u06CC\u0647","\u062A\u0631\u0628\u062A \u062C\u0627\u0645","\u0642\u0648\u0686\u0627\u0646","\u06A9\u0627\u0634\u0645\u0631","\u06AF\u0646\u0627\u0628\u0627\u062F","\u0686\u0646\u0627\u0631\u0627\u0646","\u0641\u0631\u06CC\u0645\u0627\u0646","\u062E\u0648\u0627\u0641","\u0633\u0631\u062E\u0633","\u062A\u0627\u06CC\u0628\u0627\u062F","\u062F\u0631\u06AF\u0632","\u0628\u0631\u062F\u0633\u06A9\u0646","\u0631\u0634\u062A\u062E\u0648\u0627\u0631","\u0641\u06CC\u0636\u200C\u0622\u0628\u0627\u062F","\u062E\u0644\u06CC\u0644\u200C\u0622\u0628\u0627\u062F","\u062C\u0648\u06CC\u0646","\u062C\u063A\u062A\u0627\u06CC","\u062F\u0627\u0648\u0631\u0632\u0646","\u0632\u0627\u0648\u0647","\u0628\u0627\u062E\u0631\u0632","\u0628\u062C\u0633\u062A\u0627\u0646","\u06A9\u0644\u0627\u062A","\u0637\u0631\u0642\u0628\u0647","\u0634\u0627\u0646\u062F\u06CC\u0632","\u0641\u06CC\u0631\u0648\u0632\u0647","\u0635\u0627\u0644\u062D\u200C\u0622\u0628\u0627\u062F"]},{"name":"\u062E\u0631\u0627\u0633\u0627\u0646 \u0634\u0645\u0627\u0644\u06CC","cities":["\u0628\u062C\u0646\u0648\u0631\u062F","\u0634\u06CC\u0631\u0648\u0627\u0646","\u0627\u0633\u0641\u0631\u0627\u06CC\u0646","\u0622\u0634\u062E\u0627\u0646\u0647","\u062C\u0627\u062C\u0631\u0645","\u06AF\u0631\u0645\u0647","\u0641\u0627\u0631\u0648\u062C","\u0631\u0627\u0632"]},{"name":"\u062E\u0648\u0632\u0633\u062A\u0627\u0646","cities":["\u0627\u0647\u0648\u0627\u0632","\u062F\u0632\u0641\u0648\u0644","\u0622\u0628\u0627\u062F\u0627\u0646","\u062E\u0631\u0645\u0634\u0647\u0631","\u0627\u0646\u062F\u06CC\u0645\u0634\u06A9","\u0628\u0647\u0628\u0647\u0627\u0646","\u0628\u0646\u062F\u0631 \u0645\u0627\u0647\u0634\u0647\u0631","\u0634\u0648\u0634\u062A\u0631","\u0627\u06CC\u0630\u0647","\u0634\u0648\u0634","\u0645\u0633\u062C\u062F\u0633\u0644\u06CC\u0645\u0627\u0646","\u0631\u0627\u0645\u0647\u0631\u0645\u0632","\u0633\u0648\u0633\u0646\u06AF\u0631\u062F","\u0628\u0633\u062A\u0627\u0646","\u0647\u0646\u062F\u06CC\u062C\u0627\u0646","\u0627\u0645\u06CC\u062F\u06CC\u0647","\u0628\u0627\u063A\u0645\u0644\u06A9","\u0644\u0627\u0644\u06CC","\u0627\u0646\u062F\u06CC\u06A9\u0627","\u06AF\u062A\u0648\u0646\u062F","\u0647\u0641\u062A\u06A9\u0644","\u0622\u063A\u0627\u062C\u0627\u0631\u06CC","\u0631\u0627\u0645\u0634\u06CC\u0631","\u062D\u0645\u06CC\u062F\u06CC\u0647","\u0634\u0627\u062F\u06AF\u0627\u0646","\u0647\u0648\u06CC\u0632\u0647","\u062F\u0647\u062F\u0632"]},{"name":"\u0632\u0646\u062C\u0627\u0646","cities":["\u0632\u0646\u062C\u0627\u0646","\u0627\u0628\u0647\u0631","\u062E\u0631\u0645\u062F\u0631\u0647","\u0642\u06CC\u062F\u0627\u0631","\u0645\u0627\u0647\u0646\u0634\u0627\u0646","\u0622\u0628\u200C\u0628\u0631","\u0632\u0631\u06CC\u0646\u200C\u0622\u0628\u0627\u062F","\u0633\u0644\u0637\u0627\u0646\u06CC\u0647"]},{"name":"\u0633\u0645\u0646\u0627\u0646","cities":["\u0633\u0645\u0646\u0627\u0646","\u0634\u0627\u0647\u0631\u0648\u062F","\u062F\u0627\u0645\u063A\u0627\u0646","\u06AF\u0631\u0645\u0633\u0627\u0631","\u0645\u0647\u062F\u06CC\u200C\u0634\u0647\u0631","\u0633\u0631\u062E\u0647","\u0622\u0631\u0627\u062F\u0627\u0646","\u0645\u06CC\u0627\u0645\u06CC","\u0628\u0633\u0637\u0627\u0645"]},{"name":"\u0633\u06CC\u0633\u062A\u0627\u0646 \u0648 \u0628\u0644\u0648\u0686\u0633\u062A\u0627\u0646","cities":["\u0632\u0627\u0647\u062F\u0627\u0646","\u0632\u0627\u0628\u0644","\u0686\u0627\u0628\u0647\u0627\u0631","\u0627\u06CC\u0631\u0627\u0646\u0634\u0647\u0631","\u0633\u0631\u0627\u0648\u0627\u0646","\u062E\u0627\u0634","\u0646\u06CC\u06A9\u200C\u0634\u0647\u0631","\u06A9\u0646\u0627\u0631\u06A9","\u0631\u0627\u0633\u06A9","\u062F\u0644\u06AF\u0627\u0646","\u0645\u0647\u0631\u0633\u062A\u0627\u0646","\u0641\u0646\u0648\u062C","\u0642\u0635\u0631\u0642\u0646\u062F","\u0632\u0647\u06A9","\u0647\u06CC\u0631\u0645\u0646\u062F","\u0628\u0645\u067E\u0648\u0631","\u0645\u06CC\u0631\u062C\u0627\u0648\u0647","\u0633\u0648\u0631\u0627\u0646"]},{"name":"\u0641\u0627\u0631\u0633","cities":["\u0634\u06CC\u0631\u0627\u0632","\u0645\u0631\u0648\u062F\u0634\u062A","\u062C\u0647\u0631\u0645","\u0641\u0633\u0627","\u06A9\u0627\u0632\u0631\u0648\u0646","\u0644\u0627\u0631","\u062F\u0627\u0631\u0627\u0628","\u0641\u06CC\u0631\u0648\u0632\u0622\u0628\u0627\u062F","\u0646\u06CC\u200C\u0631\u06CC\u0632","\u0627\u0642\u0644\u06CC\u062F","\u0622\u0628\u0627\u062F\u0647","\u0644\u0627\u0645\u0631\u062F","\u0627\u0633\u062A\u0647\u0628\u0627\u0646","\u0633\u067E\u06CC\u062F\u0627\u0646","\u0646\u0648\u0631\u0622\u0628\u0627\u062F","\u0632\u0631\u06CC\u0646\u200C\u062F\u0634\u062A","\u062E\u0631\u0627\u0645\u0647","\u0633\u0631\u0648\u0633\u062A\u0627\u0646","\u06A9\u0648\u0627\u0631","\u0627\u0631\u0633\u0646\u062C\u0627\u0646","\u0628\u0648\u0627\u0646\u0627\u062A","\u062E\u0646\u062C","\u0641\u0631\u0627\u0634\u0628\u0646\u062F","\u0642\u06CC\u0631","\u06AF\u0631\u0627\u0634","\u0645\u0647\u0631","\u067E\u0627\u0633\u0627\u0631\u06AF\u0627\u062F","\u0628\u06CC\u0636\u0627","\u0635\u0641\u0627\u0634\u0647\u0631","\u0627\u0648\u0632"]},{"name":"\u0642\u0632\u0648\u06CC\u0646","cities":["\u0642\u0632\u0648\u06CC\u0646","\u062A\u0627\u06A9\u0633\u062A\u0627\u0646","\u0627\u0644\u0648\u0646\u062F","\u0622\u0628\u06CC\u06A9","\u0628\u0648\u0626\u06CC\u0646\u200C\u0632\u0647\u0631\u0627","\u0645\u062D\u0645\u062F\u06CC\u0647","\u0622\u0648\u062C","\u0627\u0642\u0628\u0627\u0644\u06CC\u0647","\u0634\u0627\u0644","\u062F\u0627\u0646\u0633\u0641\u0647\u0627\u0646"]},{"name":"\u0642\u0645","cities":["\u0642\u0645","\u062C\u0639\u0641\u0631\u06CC\u0647","\u06A9\u0647\u06A9","\u0633\u0644\u0641\u0686\u06AF\u0627\u0646","\u062F\u0633\u062A\u062C\u0631\u062F","\u0642\u0646\u0648\u0627\u062A"]},{"name":"\u06A9\u0631\u062F\u0633\u062A\u0627\u0646","cities":["\u0633\u0646\u0646\u062F\u062C","\u0633\u0642\u0632","\u0645\u0631\u06CC\u0648\u0627\u0646","\u0628\u0627\u0646\u0647","\u0642\u0631\u0648\u0647","\u0628\u06CC\u062C\u0627\u0631","\u06A9\u0627\u0645\u06CC\u0627\u0631\u0627\u0646","\u062F\u06CC\u0648\u0627\u0646\u062F\u0631\u0647","\u062F\u0647\u06AF\u0644\u0627\u0646","\u0633\u0631\u0648\u0622\u0628\u0627\u062F"]},{"name":"\u06A9\u0631\u0645\u0627\u0646","cities":["\u06A9\u0631\u0645\u0627\u0646","\u0633\u06CC\u0631\u062C\u0627\u0646","\u0631\u0641\u0633\u0646\u062C\u0627\u0646","\u062C\u06CC\u0631\u0641\u062A","\u0628\u0645","\u0632\u0631\u0646\u062F","\u0634\u0647\u0631\u0628\u0627\u0628\u06A9","\u0628\u0631\u062F\u0633\u06CC\u0631","\u0628\u0627\u0641\u062A","\u06A9\u0647\u0646\u0648\u062C","\u0631\u0627\u0648\u0631","\u0627\u0646\u0627\u0631","\u0631\u0627\u0628\u0631","\u0627\u0631\u0632\u0648\u0626\u06CC\u0647","\u0639\u0646\u0628\u0631\u0622\u0628\u0627\u062F","\u0641\u0647\u0631\u062C","\u0642\u0644\u0639\u0647\u200C\u06AF\u0646\u062C","\u0645\u0646\u0648\u062C\u0627\u0646","\u0646\u0631\u0645\u0627\u0634\u06CC\u0631","\u0631\u06CC\u06AF\u0627\u0646","\u06A9\u0648\u0647\u0628\u0646\u0627\u0646","\u0631\u0648\u062F\u0628\u0627\u0631 \u062C\u0646\u0648\u0628"]},{"name":"\u06A9\u0631\u0645\u0627\u0646\u0634\u0627\u0647","cities":["\u06A9\u0631\u0645\u0627\u0646\u0634\u0627\u0647","\u0627\u0633\u0644\u0627\u0645\u200C\u0622\u0628\u0627\u062F \u063A\u0631\u0628","\u0633\u0631\u067E\u0644 \u0630\u0647\u0627\u0628","\u06A9\u0646\u06AF\u0627\u0648\u0631","\u0647\u0631\u0633\u06CC\u0646","\u062C\u0648\u0627\u0646\u0631\u0648\u062F","\u0633\u0646\u0642\u0631","\u067E\u0627\u0648\u0647","\u0635\u062D\u0646\u0647","\u06AF\u06CC\u0644\u0627\u0646\u063A\u0631\u0628","\u0642\u0635\u0631\u0634\u06CC\u0631\u06CC\u0646","\u0631\u0648\u0627\u0646\u0633\u0631","\u062F\u0627\u0644\u0627\u0647\u0648","\u062B\u0644\u0627\u062B \u0628\u0627\u0628\u0627\u062C\u0627\u0646\u06CC"]},{"name":"\u06A9\u0647\u06AF\u06CC\u0644\u0648\u06CC\u0647 \u0648 \u0628\u0648\u06CC\u0631\u0627\u062D\u0645\u062F","cities":["\u06CC\u0627\u0633\u0648\u062C","\u062F\u0648\u06AF\u0646\u0628\u062F\u0627\u0646","\u062F\u0647\u062F\u0634\u062A","\u0644\u06CC\u06A9\u06A9","\u0633\u06CC\u200C\u0633\u062E\u062A","\u0686\u0631\u0627\u0645","\u0644\u0646\u062F\u0647","\u0628\u0627\u0634\u062A","\u0645\u0627\u0631\u06AF\u0648\u0646"]},{"name":"\u06AF\u0644\u0633\u062A\u0627\u0646","cities":["\u06AF\u0631\u06AF\u0627\u0646","\u06AF\u0646\u0628\u062F \u06A9\u0627\u0648\u0648\u0633","\u0639\u0644\u06CC\u200C\u0622\u0628\u0627\u062F \u06A9\u062A\u0648\u0644","\u0622\u0642\u200C\u0642\u0644\u0627","\u06A9\u0631\u062F\u06A9\u0648\u06CC","\u0628\u0646\u062F\u0631 \u062A\u0631\u06A9\u0645\u0646","\u0645\u06CC\u0646\u0648\u062F\u0634\u062A","\u0622\u0632\u0627\u062F\u0634\u0647\u0631","\u0631\u0627\u0645\u06CC\u0627\u0646","\u06A9\u0644\u0627\u0644\u0647","\u06AF\u0645\u06CC\u0634\u0627\u0646","\u06AF\u0627\u0644\u06CC\u06A9\u0634","\u0645\u0631\u0627\u0648\u0647\u200C\u062A\u067E\u0647","\u0628\u0646\u062F\u0631 \u06AF\u0632"]},{"name":"\u06AF\u06CC\u0644\u0627\u0646","cities":["\u0631\u0634\u062A","\u0628\u0646\u062F\u0631 \u0627\u0646\u0632\u0644\u06CC","\u0644\u0627\u0647\u06CC\u062C\u0627\u0646","\u0644\u0646\u06AF\u0631\u0648\u062F","\u0622\u0633\u062A\u0627\u0631\u0627","\u0647\u0634\u062A\u067E\u0631","\u0635\u0648\u0645\u0639\u0647\u200C\u0633\u0631\u0627","\u0641\u0648\u0645\u0646","\u0631\u0648\u062F\u0633\u0631","\u0622\u0633\u062A\u0627\u0646\u0647 \u0627\u0634\u0631\u0641\u06CC\u0647","\u0631\u0648\u062F\u0628\u0627\u0631","\u0645\u0627\u0633\u0627\u0644","\u0634\u0641\u062A","\u0633\u06CC\u0627\u0647\u06A9\u0644","\u0627\u0645\u0644\u0634","\u0631\u0636\u0648\u0627\u0646\u0634\u0647\u0631"]},{"name":"\u0644\u0631\u0633\u062A\u0627\u0646","cities":["\u062E\u0631\u0645\u200C\u0622\u0628\u0627\u062F","\u0628\u0631\u0648\u062C\u0631\u062F","\u062F\u0648\u0631\u0648\u062F","\u0627\u0644\u06CC\u06AF\u0648\u062F\u0631\u0632","\u06A9\u0648\u0647\u062F\u0634\u062A","\u0627\u0632\u0646\u0627","\u0646\u0648\u0631\u0622\u0628\u0627\u062F","\u067E\u0644\u062F\u062E\u062A\u0631","\u0627\u0644\u0634\u062A\u0631","\u0631\u0648\u0645\u0634\u06A9\u0627\u0646","\u0686\u06AF\u0646\u06CC"]},{"name":"\u0645\u0627\u0632\u0646\u062F\u0631\u0627\u0646","cities":["\u0633\u0627\u0631\u06CC","\u0628\u0627\u0628\u0644","\u0622\u0645\u0644","\u0642\u0627\u0626\u0645\u200C\u0634\u0647\u0631","\u0628\u0647\u0634\u0647\u0631","\u0646\u0648\u0634\u0647\u0631","\u0686\u0627\u0644\u0648\u0633","\u062A\u0646\u06A9\u0627\u0628\u0646","\u0631\u0627\u0645\u0633\u0631","\u0646\u0648\u0631","\u0646\u06A9\u0627","\u062C\u0648\u06CC\u0628\u0627\u0631","\u067E\u0644 \u0633\u0641\u06CC\u062F","\u0641\u0631\u06CC\u062F\u0648\u0646\u200C\u06A9\u0646\u0627\u0631","\u0645\u062D\u0645\u0648\u062F\u0622\u0628\u0627\u062F","\u0628\u0627\u0628\u0644\u0633\u0631","\u0639\u0628\u0627\u0633\u200C\u0622\u0628\u0627\u062F","\u06AF\u0644\u0648\u06AF\u0627\u0647","\u0645\u06CC\u0627\u0646\u062F\u0648\u0631\u0648\u062F","\u0633\u06CC\u0645\u0631\u063A","\u06A9\u0644\u0627\u0631\u062F\u0634\u062A","\u0686\u0645\u0633\u062A\u0627\u0646"]},{"name":"\u0645\u0631\u06A9\u0632\u06CC","cities":["\u0627\u0631\u0627\u06A9","\u0633\u0627\u0648\u0647","\u062E\u0645\u06CC\u0646","\u0645\u062D\u0644\u0627\u062A","\u062F\u0644\u06CC\u062C\u0627\u0646","\u0634\u0627\u0632\u0646\u062F","\u062A\u0641\u0631\u0634","\u0622\u0634\u062A\u06CC\u0627\u0646","\u06A9\u0645\u06CC\u062C\u0627\u0646","\u0645\u0623\u0645\u0648\u0646\u06CC\u0647","\u0641\u0631\u0627\u0647\u0627\u0646","\u062E\u0646\u062F\u0627\u0628"]},{"name":"\u0647\u0631\u0645\u0632\u06AF\u0627\u0646","cities":["\u0628\u0646\u062F\u0631\u0639\u0628\u0627\u0633","\u0645\u06CC\u0646\u0627\u0628","\u0628\u0646\u062F\u0631 \u0644\u0646\u06AF\u0647","\u0642\u0634\u0645","\u06A9\u06CC\u0634","\u0631\u0648\u062F\u0627\u0646","\u062D\u0627\u062C\u06CC\u200C\u0622\u0628\u0627\u062F","\u0628\u0633\u062A\u06A9","\u067E\u0627\u0631\u0633\u06CC\u0627\u0646","\u062C\u0627\u0633\u06A9","\u0633\u06CC\u0631\u06CC\u06A9","\u0628\u0646\u062F\u0631 \u062E\u0645\u06CC\u0631","\u0627\u0628\u0648\u0645\u0648\u0633\u06CC"]},{"name":"\u0647\u0645\u062F\u0627\u0646","cities":["\u0647\u0645\u062F\u0627\u0646","\u0645\u0644\u0627\u06CC\u0631","\u0646\u0647\u0627\u0648\u0646\u062F","\u062A\u0648\u06CC\u0633\u0631\u06A9\u0627\u0646","\u0627\u0633\u062F\u0622\u0628\u0627\u062F","\u0628\u0647\u0627\u0631","\u06A9\u0628\u0648\u062F\u0631\u0622\u0647\u0646\u06AF","\u0631\u0632\u0646","\u0641\u0627\u0645\u0646\u06CC\u0646","\u062F\u0631\u06AF\u0632\u06CC\u0646"]},{"name":"\u06CC\u0632\u062F","cities":["\u06CC\u0632\u062F","\u0645\u06CC\u0628\u062F","\u0627\u0631\u062F\u06A9\u0627\u0646","\u0628\u0627\u0641\u0642","\u0645\u0647\u0631\u06CC\u0632","\u0627\u0628\u0631\u06A9\u0648\u0647","\u062A\u0641\u062A","\u0627\u0634\u06A9\u0630\u0631","\u0647\u0631\u0627\u062A","\u0628\u0647\u0627\u0628\u0627\u062F","\u0645\u0631\u0648\u0633\u062A"]}]}');

});

parcelRegister("8VC51", function(module, exports) {
module.exports = JSON.parse('{"_readme":"English names for iranGeo.json, keyed by the stored Persian value. Display only: the value saved on a clinic stays the Persian string.","names":{"\u0622\u0630\u0631\u0628\u0627\u06CC\u062C\u0627\u0646 \u0634\u0631\u0642\u06CC":"East Azerbaijan","\u062A\u0628\u0631\u06CC\u0632":"Tabriz","\u0645\u0631\u0627\u063A\u0647":"Maragheh","\u0645\u0631\u0646\u062F":"Marand","\u0627\u0647\u0631":"Ahar","\u0628\u0646\u0627\u0628":"Bonab","\u0645\u06CC\u0627\u0646\u0647":"Mianeh","\u0634\u0628\u0633\u062A\u0631":"Shabestar","\u0633\u0631\u0627\u0628":"Sarab","\u0622\u0630\u0631\u0634\u0647\u0631":"Azarshahr","\u0627\u0633\u06A9\u0648":"Osku","\u0628\u0633\u062A\u0627\u0646\u200C\u0622\u0628\u0627\u062F":"Bostanabad","\u062C\u0644\u0641\u0627":"Jolfa","\u0639\u062C\u0628\u200C\u0634\u06CC\u0631":"Ajabshir","\u06A9\u0644\u06CC\u0628\u0631":"Kaleybar","\u0645\u0644\u06A9\u0627\u0646":"Malekan","\u0648\u0631\u0632\u0642\u0627\u0646":"Varzaqan","\u0647\u0631\u06CC\u0633":"Heris","\u0647\u0634\u062A\u0631\u0648\u062F":"Hashtrud","\u062E\u062F\u0627\u0622\u0641\u0631\u06CC\u0646":"Khoda Afarin","\u0686\u0627\u0631\u0627\u0648\u06CC\u0645\u0627\u0642":"Charuymaq","\u0622\u0630\u0631\u0628\u0627\u06CC\u062C\u0627\u0646 \u063A\u0631\u0628\u06CC":"West Azerbaijan","\u0627\u0631\u0648\u0645\u06CC\u0647":"Urmia","\u062E\u0648\u06CC":"Khoy","\u0645\u06CC\u0627\u0646\u062F\u0648\u0622\u0628":"Miandoab","\u0645\u0647\u0627\u0628\u0627\u062F":"Mahabad","\u0628\u0648\u06A9\u0627\u0646":"Bukan","\u0633\u0644\u0645\u0627\u0633":"Salmas","\u0646\u0642\u062F\u0647":"Naqadeh","\u067E\u06CC\u0631\u0627\u0646\u0634\u0647\u0631":"Piranshahr","\u0633\u0631\u062F\u0634\u062A":"Sardasht","\u0645\u0627\u06A9\u0648":"Maku","\u0634\u0627\u0647\u06CC\u0646\u200C\u062F\u0698":"Shahin Dezh","\u062A\u06A9\u0627\u0628":"Takab","\u0627\u0634\u0646\u0648\u06CC\u0647":"Oshnavieh","\u0686\u0627\u0644\u062F\u0631\u0627\u0646":"Chaldoran","\u067E\u0644\u062F\u0634\u062A":"Poldasht","\u0686\u0627\u06CC\u067E\u0627\u0631\u0647":"Chaypareh","\u0634\u0648\u0637":"Showt","\u0627\u0631\u062F\u0628\u06CC\u0644":"Ardabil","\u067E\u0627\u0631\u0633\u200C\u0622\u0628\u0627\u062F":"Parsabad","\u0645\u0634\u06AF\u06CC\u0646\u200C\u0634\u0647\u0631":"Meshginshahr","\u062E\u0644\u062E\u0627\u0644":"Khalkhal","\u06AF\u0631\u0645\u06CC":"Germi","\u0628\u06CC\u0644\u0647\u200C\u0633\u0648\u0627\u0631":"Bileh Savar","\u0646\u0645\u06CC\u0646":"Namin","\u0646\u06CC\u0631":"Nir","\u06A9\u0648\u062B\u0631":"Kowsar","\u0633\u0631\u0639\u06CC\u0646":"Sareyn","\u0627\u0635\u0641\u0647\u0627\u0646":"Isfahan","\u06A9\u0627\u0634\u0627\u0646":"Kashan","\u062E\u0645\u06CC\u0646\u06CC\u200C\u0634\u0647\u0631":"Khomeini Shahr","\u0646\u062C\u0641\u200C\u0622\u0628\u0627\u062F":"Najafabad","\u0634\u0627\u0647\u06CC\u0646\u200C\u0634\u0647\u0631":"Shahin Shahr","\u0634\u0647\u0631\u0636\u0627":"Shahreza","\u0641\u0644\u0627\u0648\u0631\u062C\u0627\u0646":"Falavarjan","\u0645\u0628\u0627\u0631\u06A9\u0647":"Mobarakeh","\u06AF\u0644\u067E\u0627\u06CC\u06AF\u0627\u0646":"Golpayegan","\u0646\u0637\u0646\u0632":"Natanz","\u0627\u0631\u062F\u0633\u062A\u0627\u0646":"Ardestan","\u0633\u0645\u06CC\u0631\u0645":"Semirom","\u0632\u0631\u06CC\u0646\u200C\u0634\u0647\u0631":"Zarrin Shahr","\u062A\u06CC\u0631\u0627\u0646":"Tiran","\u062F\u0647\u0627\u0642\u0627\u0646":"Dehaqan","\u062E\u0648\u0627\u0646\u0633\u0627\u0631":"Khansar","\u0641\u0631\u06CC\u062F\u0646":"Fereydan","\u0641\u0631\u06CC\u062F\u0648\u0646\u200C\u0634\u0647\u0631":"Fereydunshahr","\u0686\u0627\u062F\u06AF\u0627\u0646":"Chadegan","\u0628\u0648\u06CC\u06CC\u0646 \u0648 \u0645\u06CC\u0627\u0646\u062F\u0634\u062A":"Buin and Miandasht","\u0646\u0627\u0626\u06CC\u0646":"Nain","\u0622\u0631\u0627\u0646 \u0648 \u0628\u06CC\u062F\u06AF\u0644":"Aran and Bidgol","\u062F\u0648\u0644\u062A\u200C\u0622\u0628\u0627\u062F":"Dolatabad","\u062E\u0648\u0631":"Khur","\u0627\u0644\u0628\u0631\u0632":"Alborz","\u06A9\u0631\u062C":"Karaj","\u0641\u0631\u062F\u06CC\u0633":"Fardis","\u0646\u0638\u0631\u0622\u0628\u0627\u062F":"Nazarabad","\u0647\u0634\u062A\u06AF\u0631\u062F":"Hashtgerd","\u0627\u0634\u062A\u0647\u0627\u0631\u062F":"Eshtehard","\u0637\u0627\u0644\u0642\u0627\u0646":"Taleqan","\u0686\u0647\u0627\u0631\u0628\u0627\u063A":"Chaharbagh","\u0645\u0627\u0647\u062F\u0634\u062A":"Mahdasht","\u0645\u062D\u0645\u062F\u0634\u0647\u0631":"Mohammadshahr","\u0645\u0634\u06A9\u06CC\u0646\u200C\u062F\u0634\u062A":"Meshkin Dasht","\u0627\u06CC\u0644\u0627\u0645":"Ilam","\u062F\u0647\u0644\u0631\u0627\u0646":"Dehloran","\u0622\u0628\u062F\u0627\u0646\u0627\u0646":"Abdanan","\u0645\u0647\u0631\u0627\u0646":"Mehran","\u0627\u06CC\u0648\u0627\u0646":"Eyvan","\u062F\u0631\u0647\u200C\u0634\u0647\u0631":"Darreh Shahr","\u0633\u0631\u0627\u0628\u0644\u0647":"Sarableh","\u0628\u062F\u0631\u0647":"Badreh","\u0627\u0631\u06A9\u0648\u0627\u0632":"Arkavaz","\u0686\u0648\u0627\u0631":"Chavar","\u0647\u0644\u06CC\u0644\u0627\u0646":"Holeylan","\u0628\u0648\u0634\u0647\u0631":"Bushehr","\u0628\u0631\u0627\u0632\u062C\u0627\u0646":"Borazjan","\u06AF\u0646\u0627\u0648\u0647":"Genaveh","\u062F\u06CC\u0644\u0645":"Deylam","\u062E\u0648\u0631\u0645\u0648\u062C":"Khormuj","\u0627\u0647\u0631\u0645":"Ahram","\u062C\u0645":"Jam","\u06A9\u0646\u06AF\u0627\u0646":"Kangan","\u0639\u0633\u0644\u0648\u06CC\u0647":"Asaluyeh","\u062F\u06CC\u0631":"Deyr","\u0628\u0646\u062F\u0631 \u0631\u06CC\u06AF":"Bandar Rig","\u062A\u0647\u0631\u0627\u0646":"Tehran","\u0627\u0633\u0644\u0627\u0645\u0634\u0647\u0631":"Eslamshahr","\u0634\u0647\u0631\u06CC\u0627\u0631":"Shahriar","\u0631\u06CC":"Rey","\u0648\u0631\u0627\u0645\u06CC\u0646":"Varamin","\u067E\u0627\u06A9\u062F\u0634\u062A":"Pakdasht","\u0631\u0628\u0627\u0637\u200C\u06A9\u0631\u06CC\u0645":"Robat Karim","\u0642\u062F\u0633":"Qods","\u0645\u0644\u0627\u0631\u062F":"Malard","\u0642\u0631\u0686\u06A9":"Qarchak","\u067E\u0631\u062F\u06CC\u0633":"Pardis","\u062F\u0645\u0627\u0648\u0646\u062F":"Damavand","\u0641\u06CC\u0631\u0648\u0632\u06A9\u0648\u0647":"Firuzkuh","\u067E\u06CC\u0634\u0648\u0627":"Pishva","\u0628\u0647\u0627\u0631\u0633\u062A\u0627\u0646":"Baharestan","\u062A\u062C\u0631\u06CC\u0634":"Tajrish","\u0628\u0627\u0642\u0631\u0634\u0647\u0631":"Baqershahr","\u0686\u0647\u0627\u0631\u062F\u0627\u0646\u06AF\u0647":"Chahardangeh","\u0646\u0633\u06CC\u0645\u200C\u0634\u0647\u0631":"Nasimshahr","\u0627\u0646\u062F\u06CC\u0634\u0647":"Andisheh","\u0644\u0648\u0627\u0633\u0627\u0646":"Lavasan","\u0631\u0648\u062F\u0647\u0646":"Rudehen","\u0628\u0648\u0645\u0647\u0646":"Bumehen","\u062D\u0633\u0646\u200C\u0622\u0628\u0627\u062F":"Hasanabad","\u0686\u0647\u0627\u0631\u0645\u062D\u0627\u0644 \u0648 \u0628\u062E\u062A\u06CC\u0627\u0631\u06CC":"Chaharmahal and Bakhtiari","\u0634\u0647\u0631\u06A9\u0631\u062F":"Shahrekord","\u0628\u0631\u0648\u062C\u0646":"Borujen","\u0644\u0631\u062F\u06AF\u0627\u0646":"Lordegan","\u0641\u0627\u0631\u0633\u0627\u0646":"Farsan","\u0627\u0631\u062F\u0644":"Ardal","\u0634\u0644\u0645\u0632\u0627\u0631":"Shalamzar","\u0686\u0644\u06AF\u0631\u062F":"Chelgerd","\u0628\u0646":"Ben","\u0633\u0627\u0645\u0627\u0646":"Saman","\u062E\u0627\u0646\u0645\u06CC\u0631\u0632\u0627":"Khanmirza","\u062E\u0631\u0627\u0633\u0627\u0646 \u062C\u0646\u0648\u0628\u06CC":"South Khorasan","\u0628\u06CC\u0631\u062C\u0646\u062F":"Birjand","\u0642\u0627\u0626\u0646":"Qaen","\u0641\u0631\u062F\u0648\u0633":"Ferdows","\u0637\u0628\u0633":"Tabas","\u0646\u0647\u0628\u0646\u062F\u0627\u0646":"Nehbandan","\u0633\u0631\u0627\u06CC\u0627\u0646":"Sarayan","\u0628\u0634\u0631\u0648\u06CC\u0647":"Boshruyeh","\u062F\u0631\u0645\u06CC\u0627\u0646":"Darmian","\u062E\u0648\u0633\u0641":"Khusf","\u0632\u06CC\u0631\u06A9\u0648\u0647":"Zirkuh","\u0633\u0631\u0628\u06CC\u0634\u0647":"Sarbisheh","\u062E\u0631\u0627\u0633\u0627\u0646 \u0631\u0636\u0648\u06CC":"Razavi Khorasan","\u0645\u0634\u0647\u062F":"Mashhad","\u0646\u06CC\u0634\u0627\u0628\u0648\u0631":"Neyshabur","\u0633\u0628\u0632\u0648\u0627\u0631":"Sabzevar","\u062A\u0631\u0628\u062A \u062D\u06CC\u062F\u0631\u06CC\u0647":"Torbat-e Heydarieh","\u062A\u0631\u0628\u062A \u062C\u0627\u0645":"Torbat-e Jam","\u0642\u0648\u0686\u0627\u0646":"Quchan","\u06A9\u0627\u0634\u0645\u0631":"Kashmar","\u06AF\u0646\u0627\u0628\u0627\u062F":"Gonabad","\u0686\u0646\u0627\u0631\u0627\u0646":"Chenaran","\u0641\u0631\u06CC\u0645\u0627\u0646":"Fariman","\u062E\u0648\u0627\u0641":"Khaf","\u0633\u0631\u062E\u0633":"Sarakhs","\u062A\u0627\u06CC\u0628\u0627\u062F":"Taybad","\u062F\u0631\u06AF\u0632":"Dargaz","\u0628\u0631\u062F\u0633\u06A9\u0646":"Bardaskan","\u0631\u0634\u062A\u062E\u0648\u0627\u0631":"Roshtkhar","\u0641\u06CC\u0636\u200C\u0622\u0628\u0627\u062F":"Feyzabad","\u062E\u0644\u06CC\u0644\u200C\u0622\u0628\u0627\u062F":"Khalilabad","\u062C\u0648\u06CC\u0646":"Joveyn","\u062C\u063A\u062A\u0627\u06CC":"Joghatai","\u062F\u0627\u0648\u0631\u0632\u0646":"Davarzan","\u0632\u0627\u0648\u0647":"Zaveh","\u0628\u0627\u062E\u0631\u0632":"Bakharz","\u0628\u062C\u0633\u062A\u0627\u0646":"Bajestan","\u06A9\u0644\u0627\u062A":"Kalat","\u0637\u0631\u0642\u0628\u0647":"Torqabeh","\u0634\u0627\u0646\u062F\u06CC\u0632":"Shandiz","\u0641\u06CC\u0631\u0648\u0632\u0647":"Firuzeh","\u0635\u0627\u0644\u062D\u200C\u0622\u0628\u0627\u062F":"Salehabad","\u062E\u0631\u0627\u0633\u0627\u0646 \u0634\u0645\u0627\u0644\u06CC":"North Khorasan","\u0628\u062C\u0646\u0648\u0631\u062F":"Bojnurd","\u0634\u06CC\u0631\u0648\u0627\u0646":"Shirvan","\u0627\u0633\u0641\u0631\u0627\u06CC\u0646":"Esfarayen","\u0622\u0634\u062E\u0627\u0646\u0647":"Ashkhaneh","\u062C\u0627\u062C\u0631\u0645":"Jajarm","\u06AF\u0631\u0645\u0647":"Garmeh","\u0641\u0627\u0631\u0648\u062C":"Faruj","\u0631\u0627\u0632":"Raz","\u062E\u0648\u0632\u0633\u062A\u0627\u0646":"Khuzestan","\u0627\u0647\u0648\u0627\u0632":"Ahvaz","\u062F\u0632\u0641\u0648\u0644":"Dezful","\u0622\u0628\u0627\u062F\u0627\u0646":"Abadan","\u062E\u0631\u0645\u0634\u0647\u0631":"Khorramshahr","\u0627\u0646\u062F\u06CC\u0645\u0634\u06A9":"Andimeshk","\u0628\u0647\u0628\u0647\u0627\u0646":"Behbahan","\u0628\u0646\u062F\u0631 \u0645\u0627\u0647\u0634\u0647\u0631":"Bandar Mahshahr","\u0634\u0648\u0634\u062A\u0631":"Shushtar","\u0627\u06CC\u0630\u0647":"Izeh","\u0634\u0648\u0634":"Shush","\u0645\u0633\u062C\u062F\u0633\u0644\u06CC\u0645\u0627\u0646":"Masjed Soleyman","\u0631\u0627\u0645\u0647\u0631\u0645\u0632":"Ramhormoz","\u0633\u0648\u0633\u0646\u06AF\u0631\u062F":"Susangerd","\u0628\u0633\u062A\u0627\u0646":"Bostan","\u0647\u0646\u062F\u06CC\u062C\u0627\u0646":"Hendijan","\u0627\u0645\u06CC\u062F\u06CC\u0647":"Omidiyeh","\u0628\u0627\u063A\u0645\u0644\u06A9":"Baghmalek","\u0644\u0627\u0644\u06CC":"Lali","\u0627\u0646\u062F\u06CC\u06A9\u0627":"Andika","\u06AF\u062A\u0648\u0646\u062F":"Gotvand","\u0647\u0641\u062A\u06A9\u0644":"Haftkel","\u0622\u063A\u0627\u062C\u0627\u0631\u06CC":"Aghajari","\u0631\u0627\u0645\u0634\u06CC\u0631":"Ramshir","\u062D\u0645\u06CC\u062F\u06CC\u0647":"Hamidiyeh","\u0634\u0627\u062F\u06AF\u0627\u0646":"Shadegan","\u0647\u0648\u06CC\u0632\u0647":"Hoveyzeh","\u062F\u0647\u062F\u0632":"Dehdez","\u0632\u0646\u062C\u0627\u0646":"Zanjan","\u0627\u0628\u0647\u0631":"Abhar","\u062E\u0631\u0645\u062F\u0631\u0647":"Khorramdarreh","\u0642\u06CC\u062F\u0627\u0631":"Qeydar","\u0645\u0627\u0647\u0646\u0634\u0627\u0646":"Mahneshan","\u0622\u0628\u200C\u0628\u0631":"Ab Bar","\u0632\u0631\u06CC\u0646\u200C\u0622\u0628\u0627\u062F":"Zarrinabad","\u0633\u0644\u0637\u0627\u0646\u06CC\u0647":"Soltaniyeh","\u0633\u0645\u0646\u0627\u0646":"Semnan","\u0634\u0627\u0647\u0631\u0648\u062F":"Shahrud","\u062F\u0627\u0645\u063A\u0627\u0646":"Damghan","\u06AF\u0631\u0645\u0633\u0627\u0631":"Garmsar","\u0645\u0647\u062F\u06CC\u200C\u0634\u0647\u0631":"Mahdishahr","\u0633\u0631\u062E\u0647":"Sorkheh","\u0622\u0631\u0627\u062F\u0627\u0646":"Aradan","\u0645\u06CC\u0627\u0645\u06CC":"Miami","\u0628\u0633\u0637\u0627\u0645":"Bastam","\u0633\u06CC\u0633\u062A\u0627\u0646 \u0648 \u0628\u0644\u0648\u0686\u0633\u062A\u0627\u0646":"Sistan and Baluchestan","\u0632\u0627\u0647\u062F\u0627\u0646":"Zahedan","\u0632\u0627\u0628\u0644":"Zabol","\u0686\u0627\u0628\u0647\u0627\u0631":"Chabahar","\u0627\u06CC\u0631\u0627\u0646\u0634\u0647\u0631":"Iranshahr","\u0633\u0631\u0627\u0648\u0627\u0646":"Saravan","\u062E\u0627\u0634":"Khash","\u0646\u06CC\u06A9\u200C\u0634\u0647\u0631":"Nikshahr","\u06A9\u0646\u0627\u0631\u06A9":"Konarak","\u0631\u0627\u0633\u06A9":"Rask","\u062F\u0644\u06AF\u0627\u0646":"Dalgan","\u0645\u0647\u0631\u0633\u062A\u0627\u0646":"Mehrestan","\u0641\u0646\u0648\u062C":"Fanuj","\u0642\u0635\u0631\u0642\u0646\u062F":"Qasr-e Qand","\u0632\u0647\u06A9":"Zahak","\u0647\u06CC\u0631\u0645\u0646\u062F":"Hirmand","\u0628\u0645\u067E\u0648\u0631":"Bampur","\u0645\u06CC\u0631\u062C\u0627\u0648\u0647":"Mirjaveh","\u0633\u0648\u0631\u0627\u0646":"Suran","\u0641\u0627\u0631\u0633":"Fars","\u0634\u06CC\u0631\u0627\u0632":"Shiraz","\u0645\u0631\u0648\u062F\u0634\u062A":"Marvdasht","\u062C\u0647\u0631\u0645":"Jahrom","\u0641\u0633\u0627":"Fasa","\u06A9\u0627\u0632\u0631\u0648\u0646":"Kazerun","\u0644\u0627\u0631":"Lar","\u062F\u0627\u0631\u0627\u0628":"Darab","\u0641\u06CC\u0631\u0648\u0632\u0622\u0628\u0627\u062F":"Firuzabad","\u0646\u06CC\u200C\u0631\u06CC\u0632":"Neyriz","\u0627\u0642\u0644\u06CC\u062F":"Eqlid","\u0622\u0628\u0627\u062F\u0647":"Abadeh","\u0644\u0627\u0645\u0631\u062F":"Lamerd","\u0627\u0633\u062A\u0647\u0628\u0627\u0646":"Estahban","\u0633\u067E\u06CC\u062F\u0627\u0646":"Sepidan","\u0646\u0648\u0631\u0622\u0628\u0627\u062F":"Nurabad","\u0632\u0631\u06CC\u0646\u200C\u062F\u0634\u062A":"Zarrin Dasht","\u062E\u0631\u0627\u0645\u0647":"Kharameh","\u0633\u0631\u0648\u0633\u062A\u0627\u0646":"Sarvestan","\u06A9\u0648\u0627\u0631":"Kavar","\u0627\u0631\u0633\u0646\u062C\u0627\u0646":"Arsanjan","\u0628\u0648\u0627\u0646\u0627\u062A":"Bavanat","\u062E\u0646\u062C":"Khonj","\u0641\u0631\u0627\u0634\u0628\u0646\u062F":"Farashband","\u0642\u06CC\u0631":"Qir","\u06AF\u0631\u0627\u0634":"Gerash","\u0645\u0647\u0631":"Mohr","\u067E\u0627\u0633\u0627\u0631\u06AF\u0627\u062F":"Pasargad","\u0628\u06CC\u0636\u0627":"Beyza","\u0635\u0641\u0627\u0634\u0647\u0631":"Safashahr","\u0627\u0648\u0632":"Evaz","\u0642\u0632\u0648\u06CC\u0646":"Qazvin","\u062A\u0627\u06A9\u0633\u062A\u0627\u0646":"Takestan","\u0627\u0644\u0648\u0646\u062F":"Alvand","\u0622\u0628\u06CC\u06A9":"Abyek","\u0628\u0648\u0626\u06CC\u0646\u200C\u0632\u0647\u0631\u0627":"Buin Zahra","\u0645\u062D\u0645\u062F\u06CC\u0647":"Mohammadiyeh","\u0622\u0648\u062C":"Avaj","\u0627\u0642\u0628\u0627\u0644\u06CC\u0647":"Eqbaliyeh","\u0634\u0627\u0644":"Shal","\u062F\u0627\u0646\u0633\u0641\u0647\u0627\u0646":"Danesfahan","\u0642\u0645":"Qom","\u062C\u0639\u0641\u0631\u06CC\u0647":"Jafariyeh","\u06A9\u0647\u06A9":"Kahak","\u0633\u0644\u0641\u0686\u06AF\u0627\u0646":"Salafchegan","\u062F\u0633\u062A\u062C\u0631\u062F":"Dastjerd","\u0642\u0646\u0648\u0627\u062A":"Qanavat","\u06A9\u0631\u062F\u0633\u062A\u0627\u0646":"Kurdistan","\u0633\u0646\u0646\u062F\u062C":"Sanandaj","\u0633\u0642\u0632":"Saqqez","\u0645\u0631\u06CC\u0648\u0627\u0646":"Marivan","\u0628\u0627\u0646\u0647":"Baneh","\u0642\u0631\u0648\u0647":"Qorveh","\u0628\u06CC\u062C\u0627\u0631":"Bijar","\u06A9\u0627\u0645\u06CC\u0627\u0631\u0627\u0646":"Kamyaran","\u062F\u06CC\u0648\u0627\u0646\u062F\u0631\u0647":"Divandarreh","\u062F\u0647\u06AF\u0644\u0627\u0646":"Dehgolan","\u0633\u0631\u0648\u0622\u0628\u0627\u062F":"Sarvabad","\u06A9\u0631\u0645\u0627\u0646":"Kerman","\u0633\u06CC\u0631\u062C\u0627\u0646":"Sirjan","\u0631\u0641\u0633\u0646\u062C\u0627\u0646":"Rafsanjan","\u062C\u06CC\u0631\u0641\u062A":"Jiroft","\u0628\u0645":"Bam","\u0632\u0631\u0646\u062F":"Zarand","\u0634\u0647\u0631\u0628\u0627\u0628\u06A9":"Shahr-e Babak","\u0628\u0631\u062F\u0633\u06CC\u0631":"Bardsir","\u0628\u0627\u0641\u062A":"Baft","\u06A9\u0647\u0646\u0648\u062C":"Kahnuj","\u0631\u0627\u0648\u0631":"Ravar","\u0627\u0646\u0627\u0631":"Anar","\u0631\u0627\u0628\u0631":"Rabor","\u0627\u0631\u0632\u0648\u0626\u06CC\u0647":"Arzuiyeh","\u0639\u0646\u0628\u0631\u0622\u0628\u0627\u062F":"Anbarabad","\u0641\u0647\u0631\u062C":"Fahraj","\u0642\u0644\u0639\u0647\u200C\u06AF\u0646\u062C":"Qaleh Ganj","\u0645\u0646\u0648\u062C\u0627\u0646":"Manujan","\u0646\u0631\u0645\u0627\u0634\u06CC\u0631":"Narmashir","\u0631\u06CC\u06AF\u0627\u0646":"Rigan","\u06A9\u0648\u0647\u0628\u0646\u0627\u0646":"Kuhbanan","\u0631\u0648\u062F\u0628\u0627\u0631 \u062C\u0646\u0648\u0628":"Rudbar-e Jonubi","\u06A9\u0631\u0645\u0627\u0646\u0634\u0627\u0647":"Kermanshah","\u0627\u0633\u0644\u0627\u0645\u200C\u0622\u0628\u0627\u062F \u063A\u0631\u0628":"Eslamabad-e Gharb","\u0633\u0631\u067E\u0644 \u0630\u0647\u0627\u0628":"Sarpol-e Zahab","\u06A9\u0646\u06AF\u0627\u0648\u0631":"Kangavar","\u0647\u0631\u0633\u06CC\u0646":"Harsin","\u062C\u0648\u0627\u0646\u0631\u0648\u062F":"Javanrud","\u0633\u0646\u0642\u0631":"Sonqor","\u067E\u0627\u0648\u0647":"Paveh","\u0635\u062D\u0646\u0647":"Sahneh","\u06AF\u06CC\u0644\u0627\u0646\u063A\u0631\u0628":"Gilan-e Gharb","\u0642\u0635\u0631\u0634\u06CC\u0631\u06CC\u0646":"Qasr-e Shirin","\u0631\u0648\u0627\u0646\u0633\u0631":"Ravansar","\u062F\u0627\u0644\u0627\u0647\u0648":"Dalahu","\u062B\u0644\u0627\u062B \u0628\u0627\u0628\u0627\u062C\u0627\u0646\u06CC":"Salas-e Babajani","\u06A9\u0647\u06AF\u06CC\u0644\u0648\u06CC\u0647 \u0648 \u0628\u0648\u06CC\u0631\u0627\u062D\u0645\u062F":"Kohgiluyeh and Boyer-Ahmad","\u06CC\u0627\u0633\u0648\u062C":"Yasuj","\u062F\u0648\u06AF\u0646\u0628\u062F\u0627\u0646":"Dogonbadan","\u062F\u0647\u062F\u0634\u062A":"Dehdasht","\u0644\u06CC\u06A9\u06A9":"Likak","\u0633\u06CC\u200C\u0633\u062E\u062A":"Sisakht","\u0686\u0631\u0627\u0645":"Charam","\u0644\u0646\u062F\u0647":"Landeh","\u0628\u0627\u0634\u062A":"Basht","\u0645\u0627\u0631\u06AF\u0648\u0646":"Margun","\u06AF\u0644\u0633\u062A\u0627\u0646":"Golestan","\u06AF\u0631\u06AF\u0627\u0646":"Gorgan","\u06AF\u0646\u0628\u062F \u06A9\u0627\u0648\u0648\u0633":"Gonbad-e Kavus","\u0639\u0644\u06CC\u200C\u0622\u0628\u0627\u062F \u06A9\u062A\u0648\u0644":"Aliabad-e Katul","\u0622\u0642\u200C\u0642\u0644\u0627":"Aqqala","\u06A9\u0631\u062F\u06A9\u0648\u06CC":"Kordkuy","\u0628\u0646\u062F\u0631 \u062A\u0631\u06A9\u0645\u0646":"Bandar Torkaman","\u0645\u06CC\u0646\u0648\u062F\u0634\u062A":"Minudasht","\u0622\u0632\u0627\u062F\u0634\u0647\u0631":"Azadshahr","\u0631\u0627\u0645\u06CC\u0627\u0646":"Ramian","\u06A9\u0644\u0627\u0644\u0647":"Kalaleh","\u06AF\u0645\u06CC\u0634\u0627\u0646":"Gomishan","\u06AF\u0627\u0644\u06CC\u06A9\u0634":"Galikesh","\u0645\u0631\u0627\u0648\u0647\u200C\u062A\u067E\u0647":"Maraveh Tappeh","\u0628\u0646\u062F\u0631 \u06AF\u0632":"Bandar Gaz","\u06AF\u06CC\u0644\u0627\u0646":"Gilan","\u0631\u0634\u062A":"Rasht","\u0628\u0646\u062F\u0631 \u0627\u0646\u0632\u0644\u06CC":"Bandar Anzali","\u0644\u0627\u0647\u06CC\u062C\u0627\u0646":"Lahijan","\u0644\u0646\u06AF\u0631\u0648\u062F":"Langarud","\u0622\u0633\u062A\u0627\u0631\u0627":"Astara","\u0647\u0634\u062A\u067E\u0631":"Hashtpar","\u0635\u0648\u0645\u0639\u0647\u200C\u0633\u0631\u0627":"Sowme\'eh Sara","\u0641\u0648\u0645\u0646":"Fuman","\u0631\u0648\u062F\u0633\u0631":"Rudsar","\u0622\u0633\u062A\u0627\u0646\u0647 \u0627\u0634\u0631\u0641\u06CC\u0647":"Astaneh-ye Ashrafiyeh","\u0631\u0648\u062F\u0628\u0627\u0631":"Rudbar","\u0645\u0627\u0633\u0627\u0644":"Masal","\u0634\u0641\u062A":"Shaft","\u0633\u06CC\u0627\u0647\u06A9\u0644":"Siahkal","\u0627\u0645\u0644\u0634":"Amlash","\u0631\u0636\u0648\u0627\u0646\u0634\u0647\u0631":"Rezvanshahr","\u0644\u0631\u0633\u062A\u0627\u0646":"Lorestan","\u062E\u0631\u0645\u200C\u0622\u0628\u0627\u062F":"Khorramabad","\u0628\u0631\u0648\u062C\u0631\u062F":"Borujerd","\u062F\u0648\u0631\u0648\u062F":"Dorud","\u0627\u0644\u06CC\u06AF\u0648\u062F\u0631\u0632":"Aligudarz","\u06A9\u0648\u0647\u062F\u0634\u062A":"Kuhdasht","\u0627\u0632\u0646\u0627":"Azna","\u067E\u0644\u062F\u062E\u062A\u0631":"Poldokhtar","\u0627\u0644\u0634\u062A\u0631":"Aleshtar","\u0631\u0648\u0645\u0634\u06A9\u0627\u0646":"Rumeshkan","\u0686\u06AF\u0646\u06CC":"Chegeni","\u0645\u0627\u0632\u0646\u062F\u0631\u0627\u0646":"Mazandaran","\u0633\u0627\u0631\u06CC":"Sari","\u0628\u0627\u0628\u0644":"Babol","\u0622\u0645\u0644":"Amol","\u0642\u0627\u0626\u0645\u200C\u0634\u0647\u0631":"Qaemshahr","\u0628\u0647\u0634\u0647\u0631":"Behshahr","\u0646\u0648\u0634\u0647\u0631":"Nowshahr","\u0686\u0627\u0644\u0648\u0633":"Chalus","\u062A\u0646\u06A9\u0627\u0628\u0646":"Tonekabon","\u0631\u0627\u0645\u0633\u0631":"Ramsar","\u0646\u0648\u0631":"Nur","\u0646\u06A9\u0627":"Neka","\u062C\u0648\u06CC\u0628\u0627\u0631":"Juybar","\u067E\u0644 \u0633\u0641\u06CC\u062F":"Pol Sefid","\u0641\u0631\u06CC\u062F\u0648\u0646\u200C\u06A9\u0646\u0627\u0631":"Fereydunkenar","\u0645\u062D\u0645\u0648\u062F\u0622\u0628\u0627\u062F":"Mahmudabad","\u0628\u0627\u0628\u0644\u0633\u0631":"Babolsar","\u0639\u0628\u0627\u0633\u200C\u0622\u0628\u0627\u062F":"Abbasabad","\u06AF\u0644\u0648\u06AF\u0627\u0647":"Galugah","\u0645\u06CC\u0627\u0646\u062F\u0648\u0631\u0648\u062F":"Miandorud","\u0633\u06CC\u0645\u0631\u063A":"Simorgh","\u06A9\u0644\u0627\u0631\u062F\u0634\u062A":"Kelardasht","\u0686\u0645\u0633\u062A\u0627\u0646":"Chamestan","\u0645\u0631\u06A9\u0632\u06CC":"Markazi","\u0627\u0631\u0627\u06A9":"Arak","\u0633\u0627\u0648\u0647":"Saveh","\u062E\u0645\u06CC\u0646":"Khomein","\u0645\u062D\u0644\u0627\u062A":"Mahallat","\u062F\u0644\u06CC\u062C\u0627\u0646":"Delijan","\u0634\u0627\u0632\u0646\u062F":"Shazand","\u062A\u0641\u0631\u0634":"Tafresh","\u0622\u0634\u062A\u06CC\u0627\u0646":"Ashtian","\u06A9\u0645\u06CC\u062C\u0627\u0646":"Komijan","\u0645\u0623\u0645\u0648\u0646\u06CC\u0647":"Mamuniyeh","\u0641\u0631\u0627\u0647\u0627\u0646":"Farahan","\u062E\u0646\u062F\u0627\u0628":"Khondab","\u0647\u0631\u0645\u0632\u06AF\u0627\u0646":"Hormozgan","\u0628\u0646\u062F\u0631\u0639\u0628\u0627\u0633":"Bandar Abbas","\u0645\u06CC\u0646\u0627\u0628":"Minab","\u0628\u0646\u062F\u0631 \u0644\u0646\u06AF\u0647":"Bandar Lengeh","\u0642\u0634\u0645":"Qeshm","\u06A9\u06CC\u0634":"Kish","\u0631\u0648\u062F\u0627\u0646":"Rudan","\u062D\u0627\u062C\u06CC\u200C\u0622\u0628\u0627\u062F":"Hajiabad","\u0628\u0633\u062A\u06A9":"Bastak","\u067E\u0627\u0631\u0633\u06CC\u0627\u0646":"Parsian","\u062C\u0627\u0633\u06A9":"Jask","\u0633\u06CC\u0631\u06CC\u06A9":"Sirik","\u0628\u0646\u062F\u0631 \u062E\u0645\u06CC\u0631":"Bandar Khamir","\u0627\u0628\u0648\u0645\u0648\u0633\u06CC":"Abu Musa","\u0647\u0645\u062F\u0627\u0646":"Hamadan","\u0645\u0644\u0627\u06CC\u0631":"Malayer","\u0646\u0647\u0627\u0648\u0646\u062F":"Nahavand","\u062A\u0648\u06CC\u0633\u0631\u06A9\u0627\u0646":"Tuyserkan","\u0627\u0633\u062F\u0622\u0628\u0627\u062F":"Asadabad","\u0628\u0647\u0627\u0631":"Bahar","\u06A9\u0628\u0648\u062F\u0631\u0622\u0647\u0646\u06AF":"Kabudarahang","\u0631\u0632\u0646":"Razan","\u0641\u0627\u0645\u0646\u06CC\u0646":"Famenin","\u062F\u0631\u06AF\u0632\u06CC\u0646":"Dargazin","\u06CC\u0632\u062F":"Yazd","\u0645\u06CC\u0628\u062F":"Meybod","\u0627\u0631\u062F\u06A9\u0627\u0646":"Ardakan","\u0628\u0627\u0641\u0642":"Bafq","\u0645\u0647\u0631\u06CC\u0632":"Mehriz","\u0627\u0628\u0631\u06A9\u0648\u0647":"Abarkuh","\u062A\u0641\u062A":"Taft","\u0627\u0634\u06A9\u0630\u0631":"Ashkezar","\u0647\u0631\u0627\u062A":"Harat","\u0628\u0647\u0627\u0628\u0627\u062F":"Bahabad","\u0645\u0631\u0648\u0633\u062A":"Marvast"}}');

});


parcelRegister("hIlpX", function(module, exports) {

$parcel$export(module.exports, "PERMISSION_CATALOG_QUERY", () => $ce5728d57f14d508$export$a866a0d1512cdffb);
$parcel$export(module.exports, "LIST_ROLES_QUERY", () => $ce5728d57f14d508$export$a02d7bdc48c81b2a);
$parcel$export(module.exports, "LIST_MEMBERS_QUERY", () => $ce5728d57f14d508$export$f7b245755e3e1eac);
$parcel$export(module.exports, "SYNC_STATUS_QUERY", () => $ce5728d57f14d508$export$c1374ee2701e4a6c);
$parcel$export(module.exports, "CREATE_ROLE_MUTATION", () => $ce5728d57f14d508$export$e9edecc5c8b5aba5);
$parcel$export(module.exports, "UPDATE_ROLE_MUTATION", () => $ce5728d57f14d508$export$eb24480d40dbdb3c);
$parcel$export(module.exports, "DELETE_ROLE_MUTATION", () => $ce5728d57f14d508$export$adf4b3440f0e016f);
$parcel$export(module.exports, "ADD_MEMBER_MUTATION", () => $ce5728d57f14d508$export$84b03e49766c2992);
$parcel$export(module.exports, "SET_MEMBER_ROLES_MUTATION", () => $ce5728d57f14d508$export$f04ee9f9fa33cf62);
$parcel$export(module.exports, "SET_MEMBER_TIER_MUTATION", () => $ce5728d57f14d508$export$6e8c3c7d95e99446);
$parcel$export(module.exports, "SUSPEND_MEMBER_MUTATION", () => $ce5728d57f14d508$export$dcf7b1e12ba68299);
$parcel$export(module.exports, "ACTIVATE_MEMBER_MUTATION", () => $ce5728d57f14d508$export$9e374614f413ce74);
$parcel$export(module.exports, "REMOVE_MEMBER_MUTATION", () => $ce5728d57f14d508$export$b16e1ae4a31bd992);
$parcel$export(module.exports, "REPAIR_SYNC_MUTATION", () => $ce5728d57f14d508$export$2483b4d4ff1e2f4e);
$parcel$export(module.exports, "PENDING_REQUESTS_QUERY", () => $ce5728d57f14d508$export$6162732408602ef4);
$parcel$export(module.exports, "APPROVE_REQUEST_MUTATION", () => $ce5728d57f14d508$export$699da87ada662399);
$parcel$export(module.exports, "REJECT_REQUEST_MUTATION", () => $ce5728d57f14d508$export$f551e9f931c7c5a6);
$parcel$export(module.exports, "TIER_LABELS", () => $ce5728d57f14d508$export$1ec026ff00c7c5e3);
// GraphQL operation strings for the People Management panel. Co-located per the
// clinic client convention (see src/hooks/useClinicDoctors.js / screens/*/constants.js).
const $ce5728d57f14d508$var$ROLE_FIELDS = `
  id roleKey nameFa description color permissions memberCount syncStatus
`;
const $ce5728d57f14d508$var$MEMBER_FIELDS = `
  id userId displayName phone tier status joinedAt syncStatus
  roles { id nameFa color }
  extraPermissions effectivePermissions
  presences { dayOfWeek startTime endTime serviceCatalogIds }
`;
const $ce5728d57f14d508$export$a866a0d1512cdffb = `
  query PermissionCatalog {
    permissionCatalog { key module moduleFa labelFa descriptionFa }
    roleTemplates { key nameFa permissions }
  }
`;
const $ce5728d57f14d508$export$a02d7bdc48c81b2a = `
  query ListClinicRoles { listClinicRoles { ${$ce5728d57f14d508$var$ROLE_FIELDS} } }
`;
const $ce5728d57f14d508$export$f7b245755e3e1eac = `
  query ListStaffMembers($search: String, $roleId: ID, $status: StaffStatus) {
    listStaffMembers(search: $search, roleId: $roleId, status: $status) { ${$ce5728d57f14d508$var$MEMBER_FIELDS} }
  }
`;
const $ce5728d57f14d508$export$c1374ee2701e4a6c = `
  query PeopleSyncStatus { peopleSyncStatus { inSync issues { kind target detail } } }
`;
const $ce5728d57f14d508$export$e9edecc5c8b5aba5 = `
  mutation CreateClinicRole($input: ClinicRoleInput!) {
    createClinicRole(input: $input) { ${$ce5728d57f14d508$var$ROLE_FIELDS} }
  }
`;
const $ce5728d57f14d508$export$eb24480d40dbdb3c = `
  mutation UpdateClinicRole($id: ID!, $input: ClinicRoleInput!) {
    updateClinicRole(id: $id, input: $input) { ${$ce5728d57f14d508$var$ROLE_FIELDS} }
  }
`;
const $ce5728d57f14d508$export$adf4b3440f0e016f = `
  mutation DeleteClinicRole($id: ID!, $reassignToRoleId: ID) {
    deleteClinicRole(id: $id, reassignToRoleId: $reassignToRoleId)
  }
`;
const $ce5728d57f14d508$export$84b03e49766c2992 = `
  mutation AddStaffMember($input: AddStaffInput!) {
    addStaffMember(input: $input) { ${$ce5728d57f14d508$var$MEMBER_FIELDS} }
  }
`;
const $ce5728d57f14d508$export$f04ee9f9fa33cf62 = `
  mutation SetStaffRoles($staffId: ID!, $roleIds: [ID!]!, $extraPermissions: [String!]) {
    setStaffRoles(staffId: $staffId, roleIds: $roleIds, extraPermissions: $extraPermissions) { ${$ce5728d57f14d508$var$MEMBER_FIELDS} }
  }
`;
const $ce5728d57f14d508$export$6e8c3c7d95e99446 = `
  mutation SetStaffTier($staffId: ID!, $tier: StaffTier!) {
    setStaffTier(staffId: $staffId, tier: $tier) { ${$ce5728d57f14d508$var$MEMBER_FIELDS} }
  }
`;
const $ce5728d57f14d508$export$dcf7b1e12ba68299 = `
  mutation SuspendStaffMember($staffId: ID!) { suspendStaffMember(staffId: $staffId) { ${$ce5728d57f14d508$var$MEMBER_FIELDS} } }
`;
const $ce5728d57f14d508$export$9e374614f413ce74 = `
  mutation ActivateStaffMember($staffId: ID!) { activateStaffMember(staffId: $staffId) { ${$ce5728d57f14d508$var$MEMBER_FIELDS} } }
`;
const $ce5728d57f14d508$export$b16e1ae4a31bd992 = `
  mutation RemoveStaffMember($staffId: ID!) { removeStaffMember(staffId: $staffId) }
`;
const $ce5728d57f14d508$export$2483b4d4ff1e2f4e = `
  mutation RepairPeopleSync { repairPeopleSync { inSync issues { kind target detail } } }
`;
const $ce5728d57f14d508$export$6162732408602ef4 = `
  query PendingJoinRequests {
    pendingJoinRequests { id userId displayName phone status requestedAt }
  }
`;
const $ce5728d57f14d508$export$699da87ada662399 = `
  mutation ApproveJoinRequest($requestId: ID!, $tier: StaffTier!, $roleIds: [ID!]!) {
    approveJoinRequest(requestId: $requestId, tier: $tier, roleIds: $roleIds) { id }
  }
`;
const $ce5728d57f14d508$export$f551e9f931c7c5a6 = `
  mutation RejectJoinRequest($requestId: ID!) { rejectJoinRequest(requestId: $requestId) }
`;
const $ce5728d57f14d508$export$1ec026ff00c7c5e3 = (t)=>({
        OWNER: t('people.tiers.owner'),
        ADMIN: t('people.tiers.admin'),
        MEMBER: t('people.tiers.member')
    });

});

parcelRegister("iet7t", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_VIEW", () => $d4601f54d10a8c87$export$95a35ad66f03cd41);
$parcel$export(module.exports, "resolveView", () => $d4601f54d10a8c87$export$85b4e0f374ef171);
$parcel$export(module.exports, "clinicRights", () => $d4601f54d10a8c87$export$84b80f5e5942da45);
$parcel$export(module.exports, "visibleViews", () => $d4601f54d10a8c87$export$f89f3c55e6850ba1);
$parcel$export(module.exports, "CLINIC_TYPE_LABELS", () => $d4601f54d10a8c87$export$385c2ad14fe1bb2d);
$parcel$export(module.exports, "TYPE_GROUP_LABELS", () => $d4601f54d10a8c87$export$f8174582ba0797ca);
$parcel$export(module.exports, "clinicTypeLabel", () => $d4601f54d10a8c87$export$2174c1d63ff27e0a);
$parcel$export(module.exports, "DEFAULT_CLINIC_TYPE", () => $d4601f54d10a8c87$export$4528488c7778c9a6);
$parcel$export(module.exports, "clinicSummary", () => $d4601f54d10a8c87$export$c96789423ccb4c48);
$parcel$export(module.exports, "joinUrl", () => $d4601f54d10a8c87$export$3b3b88c3d59ef562);
$parcel$export(module.exports, "PROFILE_COORD_FIELDS", () => $d4601f54d10a8c87$export$833e54dca20aa4d4);
$parcel$export(module.exports, "toCoord", () => $d4601f54d10a8c87$export$e9149192108ffe26);
$parcel$export(module.exports, "profileDraft", () => $d4601f54d10a8c87$export$3b8a9b44679e0be7);
$parcel$export(module.exports, "isProfileDirty", () => $d4601f54d10a8c87$export$6751d1764e58e2a1);
$parcel$export(module.exports, "toUpdateInput", () => $d4601f54d10a8c87$export$bd24538eb0a62264);
$parcel$export(module.exports, "setupTasks", () => $d4601f54d10a8c87$export$7b0e1cf76b003e9a);
$parcel$export(module.exports, "isNearExpiry", () => $d4601f54d10a8c87$export$7ecd5e5c4049c2e4);
/**
 * «کلینیک من» — the vocabulary and derivations both surfaces share.
 *
 * The desktop workbench and the mobile reduction render differently by doctrine
 * (clinic-app/CLAUDE.md §4.1: `.web.jsx` is canonical, `.mobile.jsx` is a
 * reduction of it). What they must never do is disagree about which view is
 * active, who may press what, or what still needs setting up — so the registry,
 * the rights derivation and the checklist live here and are imported by both.
 *
 * Nothing in this file renders. No React, no JSX, no tokens.
 */ 
var $exu0F = parcelRequire("exu0F");
const $d4601f54d10a8c87$export$2847034543f8e577 = (t)=>[
        {
            key: 'profile',
            label: t('clinic.views.profile'),
            legacyPath: null
        },
        {
            key: 'connect',
            label: t('clinic.views.connect'),
            legacyPath: '/about'
        },
        // «اپلیکیشن بیمار» — the rules the patient app plays by (booking requests
        // today, document uploads next). It sits between «اتصال بیماران», which is how
        // a patient GETS the app, and «واتس‌اپ», which is the other outbound channel:
        // the three are how the clinic reaches the people it treats.
        {
            key: 'patientApp',
            label: t('clinic.views.patientApp'),
            legacyPath: null
        },
        {
            key: 'whatsapp',
            label: t('clinic.views.whatsapp'),
            legacyPath: null
        },
        // «قالب‌های پیام» — what the clinic SAYS to patients, next to the account it
        // says it from. It is the only place a message template can be written; the
        // «متن پیام» picker in «ارسال پیام» reads exactly this list.
        {
            key: 'templates',
            label: t('clinic.views.templates'),
            legacyPath: null
        },
        // «اعلان‌ها» — WHEN the clinic speaks, beside what it says and the account it says it
        // from. The defaults «ثبت نوبت» ticks used to be a section of «تنظیمات», which is
        // deprecated and which the desktop panel never linked to at all.
        {
            key: 'notifications',
            label: t('clinic.views.notifications'),
            legacyPath: '/settings?section=notifications'
        },
        // «پیش‌پرداخت» (PM-0657 §6.6) — the clinic's rule for money taken at «ثبت نوبت».
        {
            key: 'prepayment',
            label: t('clinic.views.prepayment'),
            legacyPath: null
        },
        {
            key: 'billing',
            label: t('clinic.views.billing'),
            legacyPath: '/subscription'
        },
        // «انبار» — one control (the depth) rather than a settings page. It lives with
        // the clinic's own shape because it changes what every other screen shows, not
        // because it is a warehouse operation.
        {
            key: 'inventory',
            label: t('clinic.views.inventory'),
            legacyPath: null
        }
    ];
const $d4601f54d10a8c87$export$88b3856d82763646 = $d4601f54d10a8c87$export$2847034543f8e577((key)=>key).map((v)=>v.key);
const $d4601f54d10a8c87$export$95a35ad66f03cd41 = 'profile';
function $d4601f54d10a8c87$export$85b4e0f374ef171(param, search = '') {
    const params = new URLSearchParams(search || '');
    if (params.get('payment') || params.get('Authority') || params.get('authority')) return 'billing';
    return $d4601f54d10a8c87$export$88b3856d82763646.includes(param) ? param : $d4601f54d10a8c87$export$95a35ad66f03cd41;
}
function $d4601f54d10a8c87$export$84b80f5e5942da45(access, capabilities, { isOwner: isOwner = false } = {}) {
    const canSettings = !!access?.can?.('clinic.settings.manage');
    const codeBlocked = (0, $exu0F.isBlocked)(capabilities, 'generateInvitationCode');
    return {
        canEditProfile: canSettings,
        /**
     * «نوع کلینیک» — one tier above the rest of the profile.
     *
     * Editing the clinic's details describes it to a patient; changing its TYPE
     * decides which slice of the service catalogue every «افزودن خدمت» picker in
     * the clinic leads with. A receptionist who may fix the address should not
     * be able to turn the clinic dental in passing, so this needs the settings
     * permission AND the owner/admin tier — the same pair the BFF enforces,
     * which strips the field rather than failing the save for anyone below it.
     */ canChangeType: canSettings && !!isOwner,
        /**
     * «واحد پول» — the same pair as the type, and the BFF refuses anyone else
     * (docs/clinic-currency/CONTRACTS.md §7). Saved on its own, never through
     * the profile's full-replace `updateClinic`.
     */ canChangeCurrency: canSettings && !!isOwner,
        canGenerateCode: canSettings && !codeBlocked,
        /** Has the permission, but the subscription is in the way — the actionable case. */ codeBlockedByEntitlement: canSettings && codeBlocked,
        canManageBilling: !!access?.can?.('clinic.billing.manage'),
        /*
     * Linking a WhatsApp account is a clinic-settings act, not a per-message
     * one — the same key the BFF's pairing route checks for itself. Named
     * separately from `canEditProfile` because they only happen to coincide.
     */ canManageWhatsapp: canSettings,
        /*
     * «اپلیکیشن بیمار» — the same key, for the same reason as WhatsApp: deciding
     * whether patients may ask for appointments, and how far ahead, is a
     * clinic-settings act rather than a reception one. Named separately because
     * the two only happen to coincide today, and the BFF gates the policy
     * mutation on `clinic.settings.manage` for both read and write.
     */ canManagePatientApp: canSettings,
        /*
     * The inventory's DEPTH is a clinic-shape decision, so changing it rides
     * `canEditProfile` like the rest of this screen. Seeing the tab is a weaker
     * question — a مسئول انبار should be able to read which level the clinic is
     * at without being able to move it.
     */ canSeeInventory: !!access?.can?.('inventory.view'),
        /*
     * A template is a clinic-wide asset: editing one changes what EVERYONE at the
     * desk sends, which is authority over the clinic's voice rather than over a
     * single message. So it rides the settings key, not `patients.manage` — the
     * same split the BFF's permission map makes (reads ride `patients.view`, so
     * the compose dropdown still loads for a receptionist who may not edit it).
     */ canManageTemplates: canSettings,
        /*
     * «اعلان‌ها» — the same settings key, for the same reason: which channels every
     * booking announces itself on spends the booker's own پارسه and changes what the whole
     * desk sends. The BFF gates the save on `clinic.settings.manage` and lets anyone who
     * may BOOK read the defaults, which is what pre-ticks the boxes in «ثبت نوبت».
     */ canManageNotifications: canSettings,
        /*
     * «پیش‌پرداخت» (PM-0657 §6.6) — `updatePrepaymentPolicy` is gated on
     * `clinic.settings.manage`; the desk READS the policy through its own query
     * wherever it books, so the tab is the settings key's alone.
     */ canManagePrepayment: canSettings
    };
}
function $d4601f54d10a8c87$export$f89f3c55e6850ba1(t, rights) {
    return $d4601f54d10a8c87$export$2847034543f8e577(t).filter((v)=>{
        if (v.key === 'whatsapp') return !!rights?.canManageWhatsapp;
        // The BFF refuses `clinicSettings` without `clinic.settings.manage`, so a tab
        // shown to a receptionist would open onto an error, not a read-only card.
        if (v.key === 'patientApp') return !!rights?.canManagePatientApp;
        // Reading the inventory's depth is «مشاهدهٔ انبار»; changing it is the
        // clinic's own settings right, which the panel itself enforces.
        if (v.key === 'inventory') return !!rights?.canSeeInventory;
        // Hidden rather than disabled, like «واتس‌اپ»: a tab onto a panel whose every
        // button is refused is worse than no tab. A receptionist still READS
        // templates — in the compose dropdown, where they are of use.
        if (v.key === 'templates') return !!rights?.canManageTemplates;
        // Same as «قالب‌های پیام»: every control on the panel is a settings act, and the
        // defaults a receptionist needs are already ticked for them in «ثبت نوبت».
        if (v.key === 'notifications') return !!rights?.canManageNotifications;
        if (v.key === 'prepayment') return !!rights?.canManagePrepayment;
        return true;
    });
}
const $d4601f54d10a8c87$export$385c2ad14fe1bb2d = (t)=>({
        general: t('clinic.types.general'),
        specialty: t('clinic.types.specialty'),
        dental: t('clinic.types.dental'),
        ophthalmology: t('clinic.types.ophthalmology'),
        dermatology: t('clinic.types.dermatology'),
        pediatric: t('clinic.types.pediatric'),
        cardiology: t('clinic.types.cardiology'),
        orthopedic: t('clinic.types.orthopedic'),
        neurology: t('clinic.types.neurology'),
        gynecology: t('clinic.types.gynecology'),
        internal: t('clinic.types.internal'),
        ent: t('clinic.types.ent'),
        urology: t('clinic.types.urology'),
        psychology: t('clinic.types.psychology'),
        aesthetic: t('clinic.types.aesthetic'),
        physiotherapy: t('clinic.types.physiotherapy'),
        rehabilitation: t('clinic.types.rehabilitation'),
        laboratory: t('clinic.types.laboratory'),
        radiology: t('clinic.types.radiology'),
        pharmacy: t('clinic.types.pharmacy')
    });
const $d4601f54d10a8c87$export$f8174582ba0797ca = (t)=>({
        general: t('clinic.typeGroups.general'),
        specialty: t('clinic.typeGroups.specialty'),
        paraclinic: t('clinic.typeGroups.paraclinic')
    });
function $d4601f54d10a8c87$export$2174c1d63ff27e0a(type, t) {
    if (!type) return t('clinic.types.clinic');
    return $d4601f54d10a8c87$export$385c2ad14fe1bb2d(t)[type] || type;
}
const $d4601f54d10a8c87$export$4528488c7778c9a6 = 'general';
function $d4601f54d10a8c87$export$c96789423ccb4c48(clinic, t) {
    if (!clinic) return t('clinic.subtitle');
    return [
        clinic.name,
        $d4601f54d10a8c87$export$2174c1d63ff27e0a(clinic.clinicType, t),
        clinic.city
    ].filter(Boolean).join(" \xb7 ");
}
function $d4601f54d10a8c87$export$3b3b88c3d59ef562(code, patientOrigin) {
    if (!code || !patientOrigin) return null;
    return `${patientOrigin}/join/${code}`;
}
const $d4601f54d10a8c87$export$b35952f259ad2ab2 = [
    'name',
    'province',
    'city',
    'address',
    'officePhone',
    // The kind of clinic this is. A text field like the others — a registry key,
    // never a label — and it joins them for the same reason they are listed here:
    // the form, the dirty check and the read-only view must not drift.
    //
    // Whether it may be CHANGED is a separate question, asked one tier up
    // (owner/admin only); the BFF strips the field for anyone below it, so a
    // read-only render and a stripped write agree without this list knowing.
    'clinicType',
    // The clinic's JURISDICTION (PM-0082): an ISO 3166-1 code. Same shape and
    // same gate as the type — owner/admin, stripped by the BFF for anyone else —
    // and the same "omitted = unchanged" on the wire (see `toUpdateInput`).
    'country'
];
const $d4601f54d10a8c87$export$833e54dca20aa4d4 = [
    'latitude',
    'longitude'
];
function $d4601f54d10a8c87$export$e9149192108ffe26(value) {
    if (value === '' || value == null) return null;
    const n = Number(value);
    return Number.isFinite(n) ? n : null;
}
function $d4601f54d10a8c87$export$73836a526fa9928b(a, b) {
    const x = $d4601f54d10a8c87$export$e9149192108ffe26(a);
    const y = $d4601f54d10a8c87$export$e9149192108ffe26(b);
    if (x == null || y == null) return x === y;
    return Math.abs(x - y) < 1e-7;
}
function $d4601f54d10a8c87$export$3b8a9b44679e0be7(clinic) {
    const draft = {};
    for (const key of $d4601f54d10a8c87$export$b35952f259ad2ab2)draft[key] = clinic?.[key] || '';
    for (const key of $d4601f54d10a8c87$export$833e54dca20aa4d4)draft[key] = $d4601f54d10a8c87$export$e9149192108ffe26(clinic?.[key]);
    return draft;
}
function $d4601f54d10a8c87$export$6751d1764e58e2a1(draft, clinic) {
    if (!draft) return false;
    const saved = $d4601f54d10a8c87$export$3b8a9b44679e0be7(clinic);
    return $d4601f54d10a8c87$export$b35952f259ad2ab2.some((key)=>(draft[key] || '') !== saved[key]) || $d4601f54d10a8c87$export$833e54dca20aa4d4.some((key)=>!$d4601f54d10a8c87$export$73836a526fa9928b(draft[key], saved[key]));
}
function $d4601f54d10a8c87$export$bd24538eb0a62264(clinic, draft = {}, overrides = {}) {
    const merged = {
        ...$d4601f54d10a8c87$export$3b8a9b44679e0be7(clinic),
        ...draft
    };
    return {
        name: (merged.name || '').trim(),
        province: (merged.province || '').trim() || null,
        city: (merged.city || '').trim() || null,
        address: (merged.address || '').trim() || null,
        officePhone: (merged.officePhone || '').trim() || null,
        // Editable since the location picker shipped, and still `null` rather than
        // `0` for "no coordinates" — `0,0` is a real position in the Gulf of Guinea.
        latitude: $d4601f54d10a8c87$export$e9149192108ffe26(merged.latitude),
        longitude: $d4601f54d10a8c87$export$e9149192108ffe26(merged.longitude),
        // The ONE field this full-replace does not full-replace. `UpdateClinicInput`
        // reads an omitted clinicType as "unchanged" all the way down to the
        // repository, so sending `null` for a clinic whose type could not be read
        // would be the one way to blank it. Undefined keeps it.
        clinicType: (merged.clinicType || '').trim() || undefined,
        // Likewise the country: omitted is UNCHANGED down to the repository, so a
        // clinic read from a BFF older than the field keeps its country.
        country: (merged.country || '').trim() || undefined,
        active: clinic?.active ?? true,
        ...overrides
    };
}
function $d4601f54d10a8c87$export$7b0e1cf76b003e9a(clinic, capabilities, t) {
    if (!clinic) return [];
    const tasks = [];
    if (!clinic.address) tasks.push({
        key: 'address',
        label: t('clinic.checklist.address'),
        view: 'profile',
        field: 'address'
    });
    if (!clinic.officePhone) tasks.push({
        key: 'phone',
        label: t('clinic.checklist.phone'),
        view: 'profile',
        field: 'officePhone'
    });
    if (!clinic.invitationCode) tasks.push({
        key: 'code',
        label: t('clinic.checklist.code'),
        view: 'connect'
    });
    if (capabilities && !capabilities.unavailable && capabilities.status === 'TRIALING') tasks.push({
        key: 'subscription',
        label: t('clinic.checklist.subscription'),
        view: 'billing'
    });
    return tasks;
}
const $d4601f54d10a8c87$export$9d567c1061dde937 = 7;
function $d4601f54d10a8c87$export$7ecd5e5c4049c2e4(capabilities) {
    if (!capabilities || capabilities.unavailable) return false;
    if (capabilities.status !== 'ACTIVE') return false;
    const days = capabilities.daysRemaining;
    return days != null && days >= 0 && days <= $d4601f54d10a8c87$export$9d567c1061dde937;
}

});

parcelRegister("ikL6D", function(module, exports) {

$parcel$export(module.exports, "openDoctorPanel", () => $d58ea28b578d9cdb$export$c313cc43841db9f4);
$parcel$export(module.exports, "openDoctorCredits", () => $d58ea28b578d9cdb$export$5c96f829966d837b);
$parcel$export(module.exports, "openDoctorVisitLayout", () => $d58ea28b578d9cdb$export$8cd8b600141ed218);
$parcel$export(module.exports, "doctorHomeUrl", () => $d58ea28b578d9cdb$export$fb065878e80cc06d);

var $iAkVL = parcelRequire("iAkVL");
function $d58ea28b578d9cdb$export$5d5e70be886a5a54() {
    return `${0, $iAkVL.DOCTOR_APP_URL}/credits`;
}
function $d58ea28b578d9cdb$export$aa1487e0e35ed29d() {
    return `${0, $iAkVL.DOCTOR_APP_URL}/profile?tab=visit`;
}
function $d58ea28b578d9cdb$export$c313cc43841db9f4(url) {
    if (!url || typeof window === 'undefined') return false;
    window.open(url, '_blank', 'noopener,noreferrer');
    return true;
}
const $d58ea28b578d9cdb$export$5c96f829966d837b = ()=>$d58ea28b578d9cdb$export$c313cc43841db9f4($d58ea28b578d9cdb$export$5d5e70be886a5a54());
const $d58ea28b578d9cdb$export$8cd8b600141ed218 = ()=>$d58ea28b578d9cdb$export$c313cc43841db9f4($d58ea28b578d9cdb$export$aa1487e0e35ed29d());
function $d58ea28b578d9cdb$export$fb065878e80cc06d() {
    return `${0, $iAkVL.DOCTOR_APP_URL}/`;
}

});

parcelRegister("kcKDu", function(module, exports) {

$parcel$export(module.exports, "default", () => $3199b50e664dbcb5$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $3199b50e664dbcb5$export$a2387ed3b5d536eb = {
    name: "shield-alert",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
                key: "oel41y"
            }
        ],
        [
            "path",
            {
                d: "M12 8v4",
                key: "1got3b"
            }
        ],
        [
            "path",
            {
                d: "M12 16h.01",
                key: "1drbdi"
            }
        ]
    ]
};
$3199b50e664dbcb5$export$a2387ed3b5d536eb.node;
const $3199b50e664dbcb5$export$2e2bcd8739ae039 = (0, $9QBug.default)($3199b50e664dbcb5$export$a2387ed3b5d536eb);

});

parcelRegister("lT9ri", function(module, exports) {

$parcel$export(module.exports, "default", () => $2be730c711095757$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");

var $18fTV = parcelRequire("18fTV");
var $hAUh5 = parcelRequire("hAUh5");
var $5IYz7 = parcelRequire("5IYz7");
var $6uYpx = parcelRequire("6uYpx");
var $6TdpC = parcelRequire("6TdpC");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $iAkVL = parcelRequire("iAkVL");

var $8Rc3K = parcelRequire("8Rc3K");
/**
 * «یافتن نشانی از روی موقعیت» — one picker, two ways in.
 *
 * Used by the clinic profile («کلینیک من» → مشخصات) and by the clinic
 * registration wizard. ONE component on purpose: those two screens ask for the
 * same thing and used to answer it differently — the wizard had a map and the
 * profile had nothing — which is the whole reason this exists.
 *
 * ── Why two ways in, and why the map is the optional one ─────────────────────
 *
 * «موقعیت فعلی من» needs no map, no tiles and no CDN: it is one browser API and
 * one geocoder call. The map needs Leaflet, tile images and a reachable CDN,
 * from a network inside Iran where any of the three can be missing. So the map
 * is loaded ONLY when someone opens it, its failure is reported rather than
 * shown as a grey box, and the button that does not need it keeps working when
 * it fails. Both hosts are overridable per environment — see `runtimeEnv.js`.
 *
 * That ordering is also why one component serves the desktop workbench and the
 * mobile reduction unchanged. On a phone the map is the SECONDARY path: it opens
 * closed, and «موقعیت فعلی من» is both one tap and far more accurate there than
 * a fingertip on a 260px map — which is the reduction «کلینیک من» needs, not a
 * second component to keep in step.
 *
 * ── What it hands back ───────────────────────────────────────────────────────
 *
 * `onPick({latitude, longitude, province, city, address})` — the coordinates
 * always, the three names only when the geocoder answered. The caller decides
 * what to overwrite; the geocoder failing is NOT a failure of the pick, because
 * a point on the map is worth storing even when nobody can name it.
 */ /** Tehran, for a map that has nowhere better to open — unless the caller says where. */ const $2be730c711095757$var$FALLBACK_VIEW = [
    35.6892,
    51.389,
    11
];
const $2be730c711095757$var$LOAD_TIMEOUT_MS = 15000;
/**
 * Leaflet, loaded once per document and shared by every instance.
 *
 * A promise rather than a boolean: two pickers on one page (the wizard's and a
 * future one) must not race two `<script>` tags, and a failure has to be
 * remembered so the second open reports it immediately instead of waiting out
 * the timeout again.
 */ let $2be730c711095757$var$leafletPromise = null;
function $2be730c711095757$var$loadLeaflet() {
    if (typeof window === 'undefined') return Promise.reject(new Error('no-window'));
    if (window.L) return Promise.resolve(window.L);
    if ($2be730c711095757$var$leafletPromise) return $2be730c711095757$var$leafletPromise;
    $2be730c711095757$var$leafletPromise = new Promise((resolve, reject)=>{
        const done = (fn)=>(arg)=>{
                clearTimeout(timer);
                fn(arg);
            };
        const timer = setTimeout(()=>{
            $2be730c711095757$var$leafletPromise = null; // let a later open try again
            reject(new Error('timeout'));
        }, $2be730c711095757$var$LOAD_TIMEOUT_MS);
        if (!document.getElementById('leaflet-css')) {
            const link = document.createElement('link');
            link.id = 'leaflet-css';
            link.rel = 'stylesheet';
            link.href = `${0, $iAkVL.MAP_LIB_BASE}/leaflet.css`;
            document.head.appendChild(link);
        }
        const existing = document.getElementById('leaflet-js');
        if (existing) {
            existing.addEventListener('load', done(()=>resolve(window.L)));
            existing.addEventListener('error', done(()=>{
                $2be730c711095757$var$leafletPromise = null;
                reject(new Error('network'));
            }));
            return;
        }
        const script = document.createElement('script');
        script.id = 'leaflet-js';
        script.src = `${0, $iAkVL.MAP_LIB_BASE}/leaflet.js`;
        script.onload = done(()=>window.L ? resolve(window.L) : reject(new Error('network')));
        script.onerror = done(()=>{
            $2be730c711095757$var$leafletPromise = null;
            reject(new Error('network'));
        });
        document.head.appendChild(script);
    });
    return $2be730c711095757$var$leafletPromise;
}
/** The Leaflet surface. Mounted only while the map is open. */ function $2be730c711095757$var$MapSurface({ latitude: latitude, longitude: longitude, openAt: openAt, onPoint: onPoint, onFailed: onFailed }) {
    const { t: t } = (0, $e1LEq.default)();
    const hostRef = (0, $acw62.useRef)(null);
    const mapRef = (0, $acw62.useRef)(null);
    const markerRef = (0, $acw62.useRef)(null);
    const pointRef = (0, $acw62.useRef)(onPoint);
    const [state, setState] = (0, $acw62.useState)('loading'); // loading | ready | failed
    // The click handler is registered once with Leaflet but must always call the
    // CURRENT callback — re-registering it on every render would leak listeners.
    pointRef.current = onPoint;
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        $2be730c711095757$var$loadLeaflet().then((L)=>{
            if (cancelled || !hostRef.current || mapRef.current) return;
            const [fallbackLat, fallbackLng, fallbackZoom] = openAt || $2be730c711095757$var$FALLBACK_VIEW;
            const center = latitude && longitude ? [
                latitude,
                longitude
            ] : [
                fallbackLat,
                fallbackLng
            ];
            const map = L.map(hostRef.current).setView(center, latitude ? 15 : fallbackZoom);
            L.tileLayer((0, $iAkVL.MAP_TILE_URL), {
                attribution: "\xa9 OpenStreetMap",
                maxZoom: 19
            }).addTo(map);
            if (latitude && longitude) markerRef.current = L.marker(center).addTo(map);
            map.on('click', (e)=>{
                const { lat: lat, lng: lng } = e.latlng;
                if (markerRef.current) markerRef.current.setLatLng([
                    lat,
                    lng
                ]);
                else markerRef.current = L.marker([
                    lat,
                    lng
                ]).addTo(map);
                pointRef.current?.({
                    latitude: lat,
                    longitude: lng
                });
            });
            mapRef.current = map;
            setState('ready');
        }).catch(()=>{
            if (cancelled) return;
            setState('failed');
            onFailed?.();
        });
        return ()=>{
            cancelled = true;
            if (mapRef.current) {
                mapRef.current.remove();
                mapRef.current = null;
                markerRef.current = null;
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Follow coordinates set from outside the map — «موقعیت فعلی من» while the
    // map is open must move the pin, not leave it on the old point.
    (0, $acw62.useEffect)(()=>{
        const map = mapRef.current;
        if (!map || !latitude || !longitude || typeof window === 'undefined' || !window.L) return;
        const at = [
            latitude,
            longitude
        ];
        if (markerRef.current) markerRef.current.setLatLng(at);
        else markerRef.current = window.L.marker(at).addTo(map);
        map.setView(at, Math.max(map.getZoom(), 15));
    }, [
        latitude,
        longitude
    ]);
    if (state === 'failed') return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex min-h-[120px] flex-col items-center justify-center gap-1 rounded-lg border border-dashed border-border bg-muted p-4 text-center",
        "data-testid": "location-map-failed",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "m-0 text-[0.8125rem] font-semibold text-foreground",
                children: t('clinic.location.mapFailed')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "m-0 text-xs text-muted-foreground",
                children: t('clinic.location.mapFailedHint')
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "relative overflow-hidden rounded-lg border border-border",
        "data-testid": "location-map",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                ref: hostRef,
                className: "h-[260px] w-full"
            }),
            state === 'loading' ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "absolute inset-0 flex items-center justify-center bg-card/75 text-[0.8125rem] font-semibold text-primary",
                children: t('clinic.location.loadingMap')
            }) : null
        ]
    });
}
function $2be730c711095757$export$2e2bcd8739ae039({ latitude: latitude, longitude: longitude, onPick: onPick, disabled: disabled, abroad: abroad = false, openAt: openAt }) {
    const { t: t, locale: locale } = (0, $e1LEq.default)();
    const [open, setOpen] = (0, $acw62.useState)(false);
    const [busy, setBusy] = (0, $acw62.useState)(false);
    const [message, setMessage] = (0, $acw62.useState)(null); // { tone: 'error'|'info', text }
    const has = latitude != null && longitude != null;
    /** Coordinates in, names out — the one path both entry points share. */ const resolve = (0, $acw62.useCallback)(async (point)=>{
        setBusy(true);
        setMessage(null);
        try {
            const named = await (0, $8Rc3K.reverseGeocode)({
                ...point,
                abroad: abroad,
                language: locale
            });
            onPick?.({
                ...point,
                ...named
            });
            // An answer with nothing in it is not an error — the point is still good.
            if (!named.province && !named.city && !named.address) setMessage({
                tone: 'info',
                text: t('clinic.location.noAddress')
            });
        } catch  {
            onPick?.(point);
            setMessage({
                tone: 'info',
                text: t('clinic.location.geocodeFailed')
            });
        } finally{
            setBusy(false);
        }
    }, [
        onPick,
        t,
        abroad,
        locale
    ]);
    const useMyLocation = (0, $acw62.useCallback)(async ()=>{
        setBusy(true);
        setMessage(null);
        try {
            const point = await (0, $8Rc3K.currentPosition)();
            await resolve(point);
        } catch (err) {
            const reason = err?.message;
            const key = {
                [(0, $8Rc3K.GEO_ERRORS).denied]: 'clinic.location.geoDenied',
                [(0, $8Rc3K.GEO_ERRORS).unavailable]: 'clinic.location.geoUnavailable',
                [(0, $8Rc3K.GEO_ERRORS).timeout]: 'clinic.location.geoTimeout',
                [(0, $8Rc3K.GEO_ERRORS).unsupported]: 'clinic.location.geoUnsupported'
            }[reason] || 'clinic.location.geoUnavailable';
            setMessage({
                tone: 'error',
                text: t(key)
            });
            setBusy(false);
        }
    }, [
        resolve,
        t
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex flex-col gap-2",
        "data-testid": "location-picker",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex flex-wrap items-center gap-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                        type: "button",
                        variant: "outline",
                        size: "sm",
                        onClick: useMyLocation,
                        disabled: disabled || busy,
                        "data-testid": "location-use-mine",
                        children: [
                            busy ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hAUh5.default), {
                                className: "h-4 w-4 animate-spin",
                                "aria-hidden": "true"
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $18fTV.default), {
                                className: "h-4 w-4",
                                "aria-hidden": "true"
                            }),
                            t('clinic.location.useMine')
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                        type: "button",
                        variant: "outline",
                        size: "sm",
                        onClick: ()=>setOpen((v)=>!v),
                        disabled: disabled,
                        "data-testid": "location-toggle-map",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5IYz7.default), {
                                className: "h-4 w-4",
                                "aria-hidden": "true"
                            }),
                            open ? t('clinic.location.hideMap') : t('clinic.location.pickOnMap')
                        ]
                    }),
                    has ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "inline-flex items-center gap-1.5 text-xs text-muted-foreground",
                        "data-testid": "location-coords",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6uYpx.default), {
                                className: "h-3.5 w-3.5 text-primary",
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                dir: "ltr",
                                style: {
                                    unicodeBidi: 'isolate'
                                },
                                children: [
                                    Number(latitude).toFixed(5),
                                    ", ",
                                    Number(longitude).toFixed(5)
                                ]
                            }),
                            !disabled ? /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                onClick: ()=>{
                                    onPick?.({
                                        latitude: null,
                                        longitude: null
                                    });
                                    setMessage(null);
                                },
                                className: "inline-flex items-center rounded p-0.5 text-muted-foreground hover:text-destructive",
                                "aria-label": t('clinic.location.clear'),
                                "data-testid": "location-clear",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6TdpC.default), {
                                    className: "h-3.5 w-3.5",
                                    "aria-hidden": "true"
                                })
                            }) : null
                        ]
                    }) : null
                ]
            }),
            message ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: `m-0 text-xs ${message.tone === 'error' ? 'text-destructive' : 'text-muted-foreground'}`,
                role: "status",
                "data-testid": "location-message",
                children: message.text
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "m-0 text-xs text-muted-foreground",
                children: t('clinic.location.hint')
            }),
            open ? /*#__PURE__*/ (0, $ayMG0.jsx)($2be730c711095757$var$MapSurface, {
                latitude: latitude,
                longitude: longitude,
                openAt: openAt,
                onPoint: resolve,
                onFailed: ()=>setMessage({
                        tone: 'info',
                        text: t('clinic.location.mapFailed')
                    })
            }) : null,
            busy ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "m-0 text-xs font-semibold text-primary",
                "data-testid": "location-busy",
                children: t('clinic.location.resolving')
            }) : null
        ]
    });
}

});
parcelRegister("18fTV", function(module, exports) {

$parcel$export(module.exports, "default", () => $77b207f3f4e45476$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $77b207f3f4e45476$export$a2387ed3b5d536eb = {
    name: "crosshair",
    size: 24,
    node: [
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                r: "10",
                key: "1mglay"
            }
        ],
        [
            "line",
            {
                x1: "22",
                x2: "18",
                y1: "12",
                y2: "12",
                key: "l9bcsi"
            }
        ],
        [
            "line",
            {
                x1: "6",
                x2: "2",
                y1: "12",
                y2: "12",
                key: "13hhkx"
            }
        ],
        [
            "line",
            {
                x1: "12",
                x2: "12",
                y1: "6",
                y2: "2",
                key: "10w3f3"
            }
        ],
        [
            "line",
            {
                x1: "12",
                x2: "12",
                y1: "22",
                y2: "18",
                key: "15g9kq"
            }
        ]
    ]
};
$77b207f3f4e45476$export$a2387ed3b5d536eb.node;
const $77b207f3f4e45476$export$2e2bcd8739ae039 = (0, $9QBug.default)($77b207f3f4e45476$export$a2387ed3b5d536eb);

});

parcelRegister("5IYz7", function(module, exports) {

$parcel$export(module.exports, "default", () => $2246635c7d368f87$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $2246635c7d368f87$export$a2387ed3b5d536eb = {
    name: "map",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0z",
                key: "169xi5"
            }
        ],
        [
            "path",
            {
                d: "M15 5.764v15",
                key: "1pn4in"
            }
        ],
        [
            "path",
            {
                d: "M9 3.236v15",
                key: "1uimfh"
            }
        ]
    ]
};
$2246635c7d368f87$export$a2387ed3b5d536eb.node;
const $2246635c7d368f87$export$2e2bcd8739ae039 = (0, $9QBug.default)($2246635c7d368f87$export$a2387ed3b5d536eb);

});

parcelRegister("6uYpx", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc37683d2791ff01$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $cc37683d2791ff01$export$a2387ed3b5d536eb = {
    name: "map-pin",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
                key: "1r0f0z"
            }
        ],
        [
            "circle",
            {
                cx: "12",
                cy: "10",
                r: "3",
                key: "ilqhr7"
            }
        ]
    ]
};
$cc37683d2791ff01$export$a2387ed3b5d536eb.node;
const $cc37683d2791ff01$export$2e2bcd8739ae039 = (0, $9QBug.default)($cc37683d2791ff01$export$a2387ed3b5d536eb);

});

parcelRegister("8Rc3K", function(module, exports) {

$parcel$export(module.exports, "reverseGeocode", () => $672ca0b344d9dd3a$export$8f93892f6f928672);
$parcel$export(module.exports, "GEO_ERRORS", () => $672ca0b344d9dd3a$export$391b5f358b5489e6);
$parcel$export(module.exports, "currentPosition", () => $672ca0b344d9dd3a$export$6c960cb9fd49708a);
/**
 * Reverse geocoding — turning a point on the map into استان / شهر / نشانی.
 *
 * One seam, on purpose. The clinic panel is used from inside Iran, and the
 * public OSM geocoder is the WRONG long-term answer for Persian addresses: it
 * is rate-limited, its usage policy is not written for a product, and its
 * Persian coverage of small streets is thin. An Iranian provider (Neshan,
 * map.ir) is the eventual answer, and both need an API key.
 *
 * So callers get `reverseGeocode()` and never learn who answered it. Swapping
 * the provider is a change in this file plus one deployment variable.
 *
 * **A keyed provider must not be called from here.** The bundle is public and
 * `window.__ENV__` is readable in devtools, so the day a key is involved the
 * call moves behind the clinic BFF and this module posts to it instead — which
 * is why the provider is chosen by name rather than by URL.
 *
 * What comes back is normalised through `iranGeo`, so a clinic located on the
 * map and a clinic picked from the dropdowns store the SAME spelling — see the
 * «استان تهران» case in `normalizePlace`.
 *
 * Except `abroad`: a clinic outside Iran has no dropdown to agree with, so its
 * names come back as the geocoder spells them, in the panel's `language`.
 */ 
var $bMi4A = parcelRequire("bMi4A");

var $iAkVL = parcelRequire("iAkVL");

var $cMRsf = parcelRequire("cMRsf");
/** Give up rather than leave «در حال دریافت آدرس...» on screen forever. */ const $672ca0b344d9dd3a$var$TIMEOUT_MS = 12000;
const $672ca0b344d9dd3a$export$3dfe20510d56e597 = {
    unsupported: 'unsupported',
    network: 'network',
    timeout: 'timeout',
    empty: 'empty'
};
class $672ca0b344d9dd3a$export$522bee7f9a82d95c extends Error {
    constructor(reason){
        super(`reverse geocode failed: ${reason}`);
        this.reason = reason;
    }
}
/**
 * Nominatim's `address` object → our shape.
 *
 * `state` is the province and arrives as «استان تهران»; `city`/`town`/`village`
 * are one field in three names depending on how big the place is; and the road
 * parts are joined with «، » because that is a Persian postal address, not a
 * list in a sentence — `formatList` would render an English "and" around
 * Persian data.
 */ function $672ca0b344d9dd3a$var$fromNominatim(data, { abroad: abroad = false, language: language = 'fa' } = {}) {
    const addr = data?.address || {};
    const rawProvince = addr.state || addr.province || addr.county || '';
    const rawCity = addr.city || addr.town || addr.village || addr.municipality || addr.county || '';
    const province = abroad ? rawProvince : (0, $bMi4A.matchProvince)(rawProvince) || (0, $bMi4A.provinceOfCity)(rawCity) || rawProvince || '';
    const city = abroad ? rawCity : (0, $bMi4A.matchCity)(province, rawCity) || rawCity || '';
    const address = [
        addr.road,
        addr.neighbourhood,
        addr.suburb,
        addr.house_number
    ].filter(Boolean)// A Latin comma for every left-to-right language (by its descriptor).
    // i18n-exempt: a postal address separator, not UI copy — «، » in Persian and Arabic.
    .join(abroad && (0, $cMRsf.LOCALES)[language]?.dir === 'ltr' ? ', ' : "\u060C ");
    return {
        province: province,
        city: city,
        address: address
    };
}
async function $672ca0b344d9dd3a$var$nominatim({ latitude: latitude, longitude: longitude, signal: signal, abroad: abroad, language: language }) {
    const base = (0, $iAkVL.GEOCODER_URL) || 'https://nominatim.openstreetmap.org/reverse';
    const url = `${base}?lat=${encodeURIComponent(latitude)}&lon=${encodeURIComponent(longitude)}&format=json&zoom=18&addressdetails=1`;
    const lang = abroad && language ? language : 'fa';
    const res = await fetch(url, {
        signal: signal,
        headers: {
            'Accept-Language': lang
        }
    });
    if (!res.ok) throw new $672ca0b344d9dd3a$export$522bee7f9a82d95c($672ca0b344d9dd3a$export$3dfe20510d56e597.network);
    const data = await res.json();
    if (!data || data.error) throw new $672ca0b344d9dd3a$export$522bee7f9a82d95c($672ca0b344d9dd3a$export$3dfe20510d56e597.empty);
    return $672ca0b344d9dd3a$var$fromNominatim(data, {
        abroad: abroad,
        language: lang
    });
}
const $672ca0b344d9dd3a$var$PROVIDERS = {
    nominatim: $672ca0b344d9dd3a$var$nominatim
};
async function $672ca0b344d9dd3a$export$8f93892f6f928672({ latitude: latitude, longitude: longitude, abroad: abroad = false, language: language }) {
    const provider = $672ca0b344d9dd3a$var$PROVIDERS[0, $iAkVL.GEOCODER] || $672ca0b344d9dd3a$var$nominatim;
    const controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    const timer = setTimeout(()=>controller?.abort(), $672ca0b344d9dd3a$var$TIMEOUT_MS);
    try {
        return await provider({
            latitude: latitude,
            longitude: longitude,
            abroad: abroad,
            language: language,
            signal: controller?.signal
        });
    } catch (err) {
        if (err instanceof $672ca0b344d9dd3a$export$522bee7f9a82d95c) throw err;
        throw new $672ca0b344d9dd3a$export$522bee7f9a82d95c(controller?.signal?.aborted ? $672ca0b344d9dd3a$export$3dfe20510d56e597.timeout : $672ca0b344d9dd3a$export$3dfe20510d56e597.network);
    } finally{
        clearTimeout(timer);
    }
}
const $672ca0b344d9dd3a$export$391b5f358b5489e6 = {
    unsupported: 'unsupported',
    denied: 'denied',
    unavailable: 'unavailable',
    timeout: 'timeout'
};
function $672ca0b344d9dd3a$export$6c960cb9fd49708a({ timeout: timeout = 15000 } = {}) {
    return new Promise((resolve, reject)=>{
        if (typeof navigator === 'undefined' || !navigator.geolocation) {
            reject(new Error($672ca0b344d9dd3a$export$391b5f358b5489e6.unsupported));
            return;
        }
        navigator.geolocation.getCurrentPosition((pos)=>resolve({
                latitude: pos.coords.latitude,
                longitude: pos.coords.longitude
            }), (err)=>{
            const byCode = {
                1: $672ca0b344d9dd3a$export$391b5f358b5489e6.denied,
                2: $672ca0b344d9dd3a$export$391b5f358b5489e6.unavailable,
                3: $672ca0b344d9dd3a$export$391b5f358b5489e6.timeout
            };
            reject(new Error(byCode[err?.code] || $672ca0b344d9dd3a$export$391b5f358b5489e6.unavailable));
        }, {
            enableHighAccuracy: true,
            timeout: timeout,
            maximumAge: 0
        });
    });
}

});


parcelRegister("jiMFP", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ae0d19a3d81fd61$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $fAR2n = parcelRequire("fAR2n");
var $a7Rbr = parcelRequire("a7Rbr");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $bMi4A = parcelRequire("bMi4A");
const $5ae0d19a3d81fd61$export$bdd265f73bcf1f38 = (t)=>({
        value: (0, $bMi4A.OTHER),
        label: t('clinic.fields.otherPlace')
    });
function $5ae0d19a3d81fd61$export$2e2bcd8739ae039({ label: label, value: value, options: options, onChange: onChange, disabled: disabled, placeholder: placeholder, helperText: helperText, error: error, testId: testId, fieldRef: fieldRef }) {
    const { t: t } = (0, $e1LEq.default)();
    const [manual, setManual] = (0, $acw62.useState)(false);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        ref: fieldRef,
        "data-testid": testId,
        children: manual ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
            label: label,
            value: value,
            onChange: (e)=>onChange(e.target.value),
            placeholder: placeholder,
            disabled: disabled,
            helperText: helperText,
            error: error
        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fAR2n.default), {
            label: label,
            value: value || '',
            options: [
                ...options,
                $5ae0d19a3d81fd61$export$bdd265f73bcf1f38(t)
            ],
            placeholder: placeholder,
            disabled: disabled,
            helperText: helperText,
            error: error,
            onChange: (e)=>{
                const next = e.target.value;
                if (next === (0, $bMi4A.OTHER)) {
                    setManual(true);
                    onChange('');
                    return;
                }
                onChange(next);
            }
        })
    });
}

});

parcelRegister("is3AA", function(module, exports) {

$parcel$export(module.exports, "useClinicTypes", () => $d6eda039791c6730$export$99809b96f8b48b71);

var $acw62 = parcelRequire("acw62");

var $2Mst8 = parcelRequire("2Mst8");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $iet7t = parcelRequire("iet7t");
/**
 * The clinic-type registry — «نوع کلینیک» — as the server defines it.
 *
 * This used to be a fourteen-key constant in `Clinic.shared.js` while the server
 * stored an unvalidated string, and the two drifted the moment the registration
 * wizard started writing four uppercase words of its own. The vocabulary is now
 * server-owned: the wizard, the settings form and the service catalogue all read
 * the same list, and `clinicmanagement` refuses a key that is not in it.
 *
 * ── Why the label is still translated locally ────────────────────────────────
 *
 * The registry ships a Persian and an English label, and that is one language
 * short: the panel also runs in Arabic. So the LABEL comes from this app's own
 * catalogue whenever it has a key for it, and falls back to the server's Persian
 * only for a type added to the registry ahead of the client. That fallback is
 * what makes adding a type a server-side change; translating it is what makes it
 * a good one.
 */ const $d6eda039791c6730$var$CLINIC_TYPES_QUERY = `
  query ClinicTypes {
    clinicTypes { key label labelEn group }
  }
`;
/**
 * The registry as this build knows it — `clinic_type_data.py` in clinicmanagement,
 * key for key, group for group, in its sort order.
 *
 * Used whenever the server has not answered with a list: while the query is in
 * flight, and when it fails (the BFF answers `[]` rather than throwing). Without it
 * an empty answer DISABLED «نوع کلینیک» in the registration wizard, so the one
 * choice the product branches on was locked to «عمومی» for anyone whose lookup was
 * slow or refused. Every key here is one the server validates, so picking from the
 * fallback can never produce a create the server rejects.
 */ const $d6eda039791c6730$var$FALLBACK_TYPES = [
    [
        'general',
        'general'
    ],
    [
        'specialty',
        'general'
    ],
    [
        'dental',
        'specialty'
    ],
    [
        'ophthalmology',
        'specialty'
    ],
    [
        'dermatology',
        'specialty'
    ],
    [
        'pediatric',
        'specialty'
    ],
    [
        'cardiology',
        'specialty'
    ],
    [
        'orthopedic',
        'specialty'
    ],
    [
        'neurology',
        'specialty'
    ],
    [
        'gynecology',
        'specialty'
    ],
    [
        'internal',
        'specialty'
    ],
    [
        'ent',
        'specialty'
    ],
    [
        'urology',
        'specialty'
    ],
    [
        'psychology',
        'specialty'
    ],
    [
        'aesthetic',
        'specialty'
    ],
    [
        'physiotherapy',
        'paraclinic'
    ],
    [
        'rehabilitation',
        'paraclinic'
    ],
    [
        'laboratory',
        'paraclinic'
    ],
    [
        'radiology',
        'paraclinic'
    ],
    [
        'pharmacy',
        'paraclinic'
    ]
].map(([key, group])=>({
        key: key,
        group: group,
        label: '',
        labelEn: ''
    }));
function $d6eda039791c6730$export$99809b96f8b48b71() {
    const { t: t } = (0, $e1LEq.default)();
    const [types, setTypes] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        (0, $2Mst8.bffQuery)($d6eda039791c6730$var$CLINIC_TYPES_QUERY, {}, 'ClinicTypes').then((d)=>{
            if (!cancelled) {
                setTypes(d?.clinicTypes || []);
                setError(null);
            }
        }).catch((e)=>{
            if (!cancelled) setError(e.message);
        }).finally(()=>{
            if (!cancelled) setLoading(false);
        });
        return ()=>{
            cancelled = true;
        };
    }, []);
    const labels = (0, $acw62.useMemo)(()=>(0, $iet7t.CLINIC_TYPE_LABELS)(t), [
        t
    ]);
    // The server's list when it has one, else this build's copy of it.
    const effective = types.length ? types : $d6eda039791c6730$var$FALLBACK_TYPES;
    /** The registry as `Select` options, grouped and in the server's order. */ const options = (0, $acw62.useMemo)(()=>effective.map((x)=>({
                value: x.key,
                label: labels[x.key] || x.label || x.key,
                group: x.group,
                groupLabel: (0, $iet7t.TYPE_GROUP_LABELS)(t)[x.group] || x.group
            })), [
        effective,
        labels,
        t
    ]);
    /**
   * The label for a stored key.
   *
   * Falls back through the registry's own Persian label to the raw key, and never
   * to a generic word: a clinic whose type this build has not heard of should
   * read as ITS type, not as «کلینیک».
   */ const labelFor = (0, $acw62.useCallback)((key)=>{
        if (!key) return '';
        return labels[key] || types.find((x)=>x.key === key)?.label || key;
    }, [
        labels,
        types
    ]);
    return {
        types: types,
        options: options,
        labelFor: labelFor,
        loading: loading,
        error: error
    };
}
var $d6eda039791c6730$export$2e2bcd8739ae039 = $d6eda039791c6730$export$99809b96f8b48b71;

});

parcelRegister("6IjMW", function(module, exports) {

$parcel$export(module.exports, "currencyLabel", () => $4e3633b221f8e3ab$export$a77493cee3770d44);
$parcel$export(module.exports, "currencyOptions", () => $4e3633b221f8e3ab$export$b97a6cd60d226dd5);
$parcel$export(module.exports, "DEFAULT_CURRENCY", () => (parcelRequire("lHVFz")).DEFAULT_CURRENCY);
parcelRequire("1O6TO");
var $lHVFz = parcelRequire("lHVFz");
var $1O6TO = parcelRequire("1O6TO");
function $4e3633b221f8e3ab$export$dc766bb5b31bee30(code, t, locale) {
    return code === (0, $lHVFz.DEFAULT_CURRENCY) ? t('clinic.currency.irrName') : (0, $1O6TO.unitLabel)(code, locale, 'long');
}
function $4e3633b221f8e3ab$export$a77493cee3770d44(code, t, locale) {
    if ((0, $1O6TO.isUnknownCurrency)(code)) return String(code);
    return t('clinic.currency.option', {
        name: $4e3633b221f8e3ab$export$dc766bb5b31bee30(code, t, locale),
        code: code
    });
}
function $4e3633b221f8e3ab$export$b97a6cd60d226dd5(t, locale, current) {
    const known = (0, $lHVFz.CURRENCY_CODES).map((code)=>({
            value: code,
            label: $4e3633b221f8e3ab$export$a77493cee3770d44(code, t, locale)
        }));
    return (0, $1O6TO.isUnknownCurrency)(current) ? [
        {
            value: current,
            label: String(current)
        },
        ...known
    ] : known;
}

});

parcelRegister("a4bLu", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_COUNTRY", () => $75436760106f8917$export$84b76667b0a9e7b4);
$parcel$export(module.exports, "countryLabel", () => $75436760106f8917$export$743107802f40dac2);
$parcel$export(module.exports, "countryOptions", () => $75436760106f8917$export$d9f9bfd5c6fdc088);

var $aOzet = parcelRequire("aOzet");
const $75436760106f8917$export$84b76667b0a9e7b4 = 'IR';
function $75436760106f8917$export$743107802f40dac2(code, locale) {
    const iso = code || $75436760106f8917$export$84b76667b0a9e7b4;
    const row = (0, $aOzet.COUNTRIES).find((c)=>c.iso2 === iso);
    return row ? (0, $aOzet.countryName)(row, locale) : iso;
}
function $75436760106f8917$export$d9f9bfd5c6fdc088(locale, current = $75436760106f8917$export$84b76667b0a9e7b4) {
    const rows = (0, $aOzet.COUNTRIES).map((c)=>({
            value: c.iso2,
            label: (0, $aOzet.countryName)(c, locale)
        })).sort((a, b)=>a.label.localeCompare(b.label, locale));
    const iso = current || $75436760106f8917$export$84b76667b0a9e7b4;
    return rows.some((r)=>r.value === iso) ? rows : [
        {
            value: iso,
            label: iso
        },
        ...rows
    ];
}

});

parcelRegister("4TsLl", function(module, exports) {

$parcel$export(module.exports, "default", () => $62728ba8f84606a6$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $62728ba8f84606a6$export$a2387ed3b5d536eb = {
    name: "file-cog",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M15 8a1 1 0 0 1-1-1V2a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8z",
                key: "1ckgky"
            }
        ],
        [
            "path",
            {
                d: "M20 8v12a2 2 0 0 1-2 2h-4.182",
                key: "1726p0"
            }
        ],
        [
            "path",
            {
                d: "m3.305 19.53.923-.382",
                key: "ao1pio"
            }
        ],
        [
            "path",
            {
                d: "M4 10.592V4a2 2 0 0 1 2-2h8",
                key: "1foop0"
            }
        ],
        [
            "path",
            {
                d: "m4.228 16.852-.924-.383",
                key: "1fv9zy"
            }
        ],
        [
            "path",
            {
                d: "m5.852 15.228-.383-.923",
                key: "1a9hc2"
            }
        ],
        [
            "path",
            {
                d: "m5.852 20.772-.383.924",
                key: "1sh9ke"
            }
        ],
        [
            "path",
            {
                d: "m8.148 15.228.383-.923",
                key: "4yu6lf"
            }
        ],
        [
            "path",
            {
                d: "m8.53 21.696-.382-.924",
                key: "18b0s9"
            }
        ],
        [
            "path",
            {
                d: "m9.773 16.852.922-.383",
                key: "ti6xop"
            }
        ],
        [
            "path",
            {
                d: "m9.773 19.148.922.383",
                key: "rws47d"
            }
        ],
        [
            "circle",
            {
                cx: "7",
                cy: "18",
                r: "3",
                key: "lvkj7j"
            }
        ]
    ],
    aliases: [
        "file-cog-2"
    ]
};
$62728ba8f84606a6$export$a2387ed3b5d536eb.node;
const $62728ba8f84606a6$export$2e2bcd8739ae039 = (0, $9QBug.default)($62728ba8f84606a6$export$a2387ed3b5d536eb);

});

parcelRegister("73eW9", function(module, exports) {

$parcel$export(module.exports, "default", () => $9873219481bf93ff$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $9873219481bf93ff$export$a2387ed3b5d536eb = {
    name: "funnel",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M10 20a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341L21.74 4.67A1 1 0 0 0 21 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14z",
                key: "sc7q7i"
            }
        ]
    ],
    aliases: [
        "filter"
    ]
};
$9873219481bf93ff$export$a2387ed3b5d536eb.node;
const $9873219481bf93ff$export$2e2bcd8739ae039 = (0, $9QBug.default)($9873219481bf93ff$export$a2387ed3b5d536eb);

});

parcelRegister("2Hncz", function(module, exports) {

$parcel$export(module.exports, "default", () => $1659d68ddffe688f$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $1659d68ddffe688f$export$a2387ed3b5d536eb = {
    name: "wand-sparkles",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72",
                key: "ul74o6"
            }
        ],
        [
            "path",
            {
                d: "m14 7 3 3",
                key: "1r5n42"
            }
        ],
        [
            "path",
            {
                d: "M5 6v4",
                key: "ilb8ba"
            }
        ],
        [
            "path",
            {
                d: "M19 14v4",
                key: "blhpug"
            }
        ],
        [
            "path",
            {
                d: "M10 2v2",
                key: "7u0qdc"
            }
        ],
        [
            "path",
            {
                d: "M7 8H3",
                key: "zfb6yr"
            }
        ],
        [
            "path",
            {
                d: "M21 16h-4",
                key: "1cnmox"
            }
        ],
        [
            "path",
            {
                d: "M11 3H9",
                key: "1obp7u"
            }
        ]
    ],
    aliases: [
        "wand-2"
    ]
};
$1659d68ddffe688f$export$a2387ed3b5d536eb.node;
const $1659d68ddffe688f$export$2e2bcd8739ae039 = (0, $9QBug.default)($1659d68ddffe688f$export$a2387ed3b5d536eb);

});

parcelRegister("c1ILg", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb9e7c1a808e3cde$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $cb9e7c1a808e3cde$export$a2387ed3b5d536eb = {
    name: "arrow-left-right",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M8 3 4 7l4 4",
                key: "9rb6wj"
            }
        ],
        [
            "path",
            {
                d: "M4 7h16",
                key: "6tx8e3"
            }
        ],
        [
            "path",
            {
                d: "m16 21 4-4-4-4",
                key: "siv7j2"
            }
        ],
        [
            "path",
            {
                d: "M20 17H4",
                key: "h6l3hr"
            }
        ]
    ]
};
$cb9e7c1a808e3cde$export$a2387ed3b5d536eb.node;
const $cb9e7c1a808e3cde$export$2e2bcd8739ae039 = (0, $9QBug.default)($cb9e7c1a808e3cde$export$a2387ed3b5d536eb);

});

parcelRegister("2ZKWm", function(module, exports) {

$parcel$export(module.exports, "default", () => $83c126f077a022b3$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $83c126f077a022b3$export$a2387ed3b5d536eb = {
    name: "badge-percent",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
                key: "3c2336"
            }
        ],
        [
            "path",
            {
                d: "m15 9-6 6",
                key: "1uzhvr"
            }
        ],
        [
            "path",
            {
                d: "M9 9h.01",
                key: "1q5me6"
            }
        ],
        [
            "path",
            {
                d: "M15 15h.01",
                key: "lqbp3k"
            }
        ]
    ]
};
$83c126f077a022b3$export$a2387ed3b5d536eb.node;
const $83c126f077a022b3$export$2e2bcd8739ae039 = (0, $9QBug.default)($83c126f077a022b3$export$a2387ed3b5d536eb);

});

parcelRegister("7jdVF", function(module, exports) {

$parcel$export(module.exports, "default", () => $a403ace69451f9b4$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $a403ace69451f9b4$export$a2387ed3b5d536eb = {
    name: "banknote",
    size: 24,
    node: [
        [
            "rect",
            {
                width: "20",
                height: "12",
                x: "2",
                y: "6",
                rx: "2",
                key: "9lu3g6"
            }
        ],
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                r: "2",
                key: "1c9p78"
            }
        ],
        [
            "path",
            {
                d: "M6 12h.01M18 12h.01",
                key: "113zkx"
            }
        ]
    ]
};
$a403ace69451f9b4$export$a2387ed3b5d536eb.node;
const $a403ace69451f9b4$export$2e2bcd8739ae039 = (0, $9QBug.default)($a403ace69451f9b4$export$a2387ed3b5d536eb);

});

parcelRegister("i7G41", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5028037860f09ff$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $a5028037860f09ff$export$a2387ed3b5d536eb = {
    name: "book-open",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M12 5v16",
                key: "1f6ucr"
            }
        ],
        [
            "path",
            {
                d: "M20.001 19A2 2 0 0022 17V5a2 2 0 00-1.999-2L16 3.002A5 5 0 0012 5a5 5 0 00-4-2H4a2 2 0 00-2 2v12a2 2 0 001.999 2H8a5 5 0 014 2 5 5 0 014-2z",
                key: "1fyvmf"
            }
        ]
    ]
};
$a5028037860f09ff$export$a2387ed3b5d536eb.node;
const $a5028037860f09ff$export$2e2bcd8739ae039 = (0, $9QBug.default)($a5028037860f09ff$export$a2387ed3b5d536eb);

});

parcelRegister("533Hv", function(module, exports) {

$parcel$export(module.exports, "default", () => $de73f8138ad697a9$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $de73f8138ad697a9$export$a2387ed3b5d536eb = {
    name: "calculator",
    size: 24,
    node: [
        [
            "rect",
            {
                width: "16",
                height: "20",
                x: "4",
                y: "2",
                rx: "2",
                key: "1nb95v"
            }
        ],
        [
            "line",
            {
                x1: "8",
                x2: "16",
                y1: "6",
                y2: "6",
                key: "x4nwl0"
            }
        ],
        [
            "line",
            {
                x1: "16",
                x2: "16",
                y1: "14",
                y2: "18",
                key: "wjye3r"
            }
        ],
        [
            "path",
            {
                d: "M16 10h.01",
                key: "1m94wz"
            }
        ],
        [
            "path",
            {
                d: "M12 10h.01",
                key: "1nrarc"
            }
        ],
        [
            "path",
            {
                d: "M8 10h.01",
                key: "19clt8"
            }
        ],
        [
            "path",
            {
                d: "M12 14h.01",
                key: "1etili"
            }
        ],
        [
            "path",
            {
                d: "M8 14h.01",
                key: "6423bh"
            }
        ],
        [
            "path",
            {
                d: "M12 18h.01",
                key: "mhygvu"
            }
        ],
        [
            "path",
            {
                d: "M8 18h.01",
                key: "lrp35t"
            }
        ]
    ]
};
$de73f8138ad697a9$export$a2387ed3b5d536eb.node;
const $de73f8138ad697a9$export$2e2bcd8739ae039 = (0, $9QBug.default)($de73f8138ad697a9$export$a2387ed3b5d536eb);

});

parcelRegister("2dAor", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c5608486995a699$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $3c5608486995a699$export$a2387ed3b5d536eb = {
    name: "calendar-plus",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M16 18h6",
                key: "987eiv"
            }
        ],
        [
            "path",
            {
                d: "M16 2v3",
                key: "otl347"
            }
        ],
        [
            "path",
            {
                d: "M19 15v6",
                key: "10aioa"
            }
        ],
        [
            "path",
            {
                d: "M21 11.5V5a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2h8.3",
                key: "jgwkxf"
            }
        ],
        [
            "path",
            {
                d: "M3 9h18",
                key: "1pudct"
            }
        ],
        [
            "path",
            {
                d: "M8 2v3",
                key: "1ioesn"
            }
        ]
    ]
};
$3c5608486995a699$export$a2387ed3b5d536eb.node;
const $3c5608486995a699$export$2e2bcd8739ae039 = (0, $9QBug.default)($3c5608486995a699$export$a2387ed3b5d536eb);

});

parcelRegister("adLzH", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c0c644cc6773338$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $8c0c644cc6773338$export$a2387ed3b5d536eb = {
    name: "hand-coins",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M11 15h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 17",
                key: "geh8rc"
            }
        ],
        [
            "path",
            {
                d: "m7 21 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9",
                key: "1fto5m"
            }
        ],
        [
            "path",
            {
                d: "m2 16 6 6",
                key: "1pfhp9"
            }
        ],
        [
            "circle",
            {
                cx: "16",
                cy: "9",
                r: "2.9",
                key: "1n0dlu"
            }
        ],
        [
            "circle",
            {
                cx: "6",
                cy: "5",
                r: "3",
                key: "151irh"
            }
        ]
    ]
};
$8c0c644cc6773338$export$a2387ed3b5d536eb.node;
const $8c0c644cc6773338$export$2e2bcd8739ae039 = (0, $9QBug.default)($8c0c644cc6773338$export$a2387ed3b5d536eb);

});

parcelRegister("702kK", function(module, exports) {

$parcel$export(module.exports, "default", () => $41e90a55419824f7$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $41e90a55419824f7$export$a2387ed3b5d536eb = {
    name: "image-plus",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M16 5h6",
                key: "1vod17"
            }
        ],
        [
            "path",
            {
                d: "M19 2v6",
                key: "4bpg5p"
            }
        ],
        [
            "path",
            {
                d: "M21 11.5V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7.5",
                key: "1ue2ih"
            }
        ],
        [
            "path",
            {
                d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21",
                key: "1xmnt7"
            }
        ],
        [
            "circle",
            {
                cx: "9",
                cy: "9",
                r: "2",
                key: "af1f0g"
            }
        ]
    ]
};
$41e90a55419824f7$export$a2387ed3b5d536eb.node;
const $41e90a55419824f7$export$2e2bcd8739ae039 = (0, $9QBug.default)($41e90a55419824f7$export$a2387ed3b5d536eb);

});

parcelRegister("hbI6x", function(module, exports) {

$parcel$export(module.exports, "default", () => $3360dd00c5c73896$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $3360dd00c5c73896$export$a2387ed3b5d536eb = {
    name: "infinity",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M6 16c5 0 7-8 12-8a4 4 0 0 1 0 8c-5 0-7-8-12-8a4 4 0 1 0 0 8",
                key: "18ogeb"
            }
        ]
    ]
};
$3360dd00c5c73896$export$a2387ed3b5d536eb.node;
const $3360dd00c5c73896$export$2e2bcd8739ae039 = (0, $9QBug.default)($3360dd00c5c73896$export$a2387ed3b5d536eb);

});

parcelRegister("2OwQ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e74197513d24334$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $2e74197513d24334$export$a2387ed3b5d536eb = {
    name: "landmark",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M10 18v-7",
                key: "wt116b"
            }
        ],
        [
            "path",
            {
                d: "M11.119 2.205a2 2 0 0 1 1.762 0l7.84 3.846A.5.5 0 0 1 20.5 7h-17a.5.5 0 0 1-.22-.949z",
                key: "yxxwt6"
            }
        ],
        [
            "path",
            {
                d: "M14 18v-7",
                key: "vav6t3"
            }
        ],
        [
            "path",
            {
                d: "M18 18v-7",
                key: "aexdmj"
            }
        ],
        [
            "path",
            {
                d: "M3 22h18",
                key: "8prr45"
            }
        ],
        [
            "path",
            {
                d: "M6 18v-7",
                key: "1ivflk"
            }
        ]
    ]
};
$2e74197513d24334$export$a2387ed3b5d536eb.node;
const $2e74197513d24334$export$2e2bcd8739ae039 = (0, $9QBug.default)($2e74197513d24334$export$a2387ed3b5d536eb);

});

parcelRegister("bd0PP", function(module, exports) {

$parcel$export(module.exports, "default", () => $95ce1f0fbafdd9d0$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $95ce1f0fbafdd9d0$export$a2387ed3b5d536eb = {
    name: "list-ordered",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M11 5h10",
                key: "1cz7ny"
            }
        ],
        [
            "path",
            {
                d: "M11 12h10",
                key: "1438ji"
            }
        ],
        [
            "path",
            {
                d: "M11 19h10",
                key: "11t30w"
            }
        ],
        [
            "path",
            {
                d: "M4 4h1v5",
                key: "10yrso"
            }
        ],
        [
            "path",
            {
                d: "M4 9h2",
                key: "r1h2o0"
            }
        ],
        [
            "path",
            {
                d: "M6.5 20H3.4c0-1 2.6-1.925 2.6-3.5a1.5 1.5 0 0 0-2.6-1.02",
                key: "xtkcd5"
            }
        ]
    ]
};
$95ce1f0fbafdd9d0$export$a2387ed3b5d536eb.node;
const $95ce1f0fbafdd9d0$export$2e2bcd8739ae039 = (0, $9QBug.default)($95ce1f0fbafdd9d0$export$a2387ed3b5d536eb);

});

parcelRegister("l0VCZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $424dbb49b3cb8f20$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $424dbb49b3cb8f20$export$a2387ed3b5d536eb = {
    name: "loader",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M12 2v4",
                key: "3427ic"
            }
        ],
        [
            "path",
            {
                d: "m16.2 7.8 2.9-2.9",
                key: "r700ao"
            }
        ],
        [
            "path",
            {
                d: "M18 12h4",
                key: "wj9ykh"
            }
        ],
        [
            "path",
            {
                d: "m16.2 16.2 2.9 2.9",
                key: "1bxg5t"
            }
        ],
        [
            "path",
            {
                d: "M12 18v4",
                key: "jadmvz"
            }
        ],
        [
            "path",
            {
                d: "m4.9 19.1 2.9-2.9",
                key: "bwix9q"
            }
        ],
        [
            "path",
            {
                d: "M2 12h4",
                key: "j09sii"
            }
        ],
        [
            "path",
            {
                d: "m4.9 4.9 2.9 2.9",
                key: "giyufr"
            }
        ]
    ]
};
$424dbb49b3cb8f20$export$a2387ed3b5d536eb.node;
const $424dbb49b3cb8f20$export$2e2bcd8739ae039 = (0, $9QBug.default)($424dbb49b3cb8f20$export$a2387ed3b5d536eb);

});

parcelRegister("8ewYz", function(module, exports) {

$parcel$export(module.exports, "default", () => $59813a4678999ce6$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $59813a4678999ce6$export$a2387ed3b5d536eb = {
    name: "log-in",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m10 17 5-5-5-5",
                key: "1bsop3"
            }
        ],
        [
            "path",
            {
                d: "M15 12H3",
                key: "6jk70r"
            }
        ],
        [
            "path",
            {
                d: "M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4",
                key: "u53s6r"
            }
        ]
    ]
};
$59813a4678999ce6$export$a2387ed3b5d536eb.node;
const $59813a4678999ce6$export$2e2bcd8739ae039 = (0, $9QBug.default)($59813a4678999ce6$export$a2387ed3b5d536eb);

});

parcelRegister("2p7rn", function(module, exports) {

$parcel$export(module.exports, "default", () => $50265255bd1e3812$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $50265255bd1e3812$export$a2387ed3b5d536eb = {
    name: "message-square-off",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M19 19H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.7.7 0 0 1 2 21.286V5a2 2 0 0 1 1.184-1.826",
                key: "1wyg69"
            }
        ],
        [
            "path",
            {
                d: "m2 2 20 20",
                key: "1ooewy"
            }
        ],
        [
            "path",
            {
                d: "M8.656 3H20a2 2 0 0 1 2 2v11.344",
                key: "mhl4k6"
            }
        ]
    ]
};
$50265255bd1e3812$export$a2387ed3b5d536eb.node;
const $50265255bd1e3812$export$2e2bcd8739ae039 = (0, $9QBug.default)($50265255bd1e3812$export$a2387ed3b5d536eb);

});

parcelRegister("86ZTk", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e508fcee5dd8d86$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $1e508fcee5dd8d86$export$a2387ed3b5d536eb = {
    name: "package-check",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M12 22V12",
                key: "d0xqtd"
            }
        ],
        [
            "path",
            {
                d: "m16 17 2 2 4-4",
                key: "uh5qu3"
            }
        ],
        [
            "path",
            {
                d: "M21 11.127V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.729l7 4a2 2 0 0 0 2 .001l1.32-.753",
                key: "kpkbpo"
            }
        ],
        [
            "path",
            {
                d: "M3.29 7 12 12l8.71-5",
                key: "19ckod"
            }
        ],
        [
            "path",
            {
                d: "m7.5 4.27 8.997 5.148",
                key: "9yrvtv"
            }
        ]
    ]
};
$1e508fcee5dd8d86$export$a2387ed3b5d536eb.node;
const $1e508fcee5dd8d86$export$2e2bcd8739ae039 = (0, $9QBug.default)($1e508fcee5dd8d86$export$a2387ed3b5d536eb);

});

parcelRegister("3E8PC", function(module, exports) {

$parcel$export(module.exports, "default", () => $d66b4b1ba0cc398a$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $d66b4b1ba0cc398a$export$a2387ed3b5d536eb = {
    name: "package-minus",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M12 22V12",
                key: "d0xqtd"
            }
        ],
        [
            "path",
            {
                d: "M16 17h6",
                key: "1ook5g"
            }
        ],
        [
            "path",
            {
                d: "M21 13V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.729l7 4a2 2 0 0 0 2 .001l1.675-.955",
                key: "zu9avd"
            }
        ],
        [
            "path",
            {
                d: "M3.29 7 12 12l8.71-5",
                key: "19ckod"
            }
        ],
        [
            "path",
            {
                d: "m7.5 4.27 8.997 5.148",
                key: "9yrvtv"
            }
        ]
    ]
};
$d66b4b1ba0cc398a$export$a2387ed3b5d536eb.node;
const $d66b4b1ba0cc398a$export$2e2bcd8739ae039 = (0, $9QBug.default)($d66b4b1ba0cc398a$export$a2387ed3b5d536eb);

});

parcelRegister("9oCLU", function(module, exports) {

$parcel$export(module.exports, "default", () => $1464ce6eb72f37f2$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $1464ce6eb72f37f2$export$a2387ed3b5d536eb = {
    name: "package-search",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M12 22V12",
                key: "d0xqtd"
            }
        ],
        [
            "path",
            {
                d: "M20.27 18.27 22 20",
                key: "er2am"
            }
        ],
        [
            "path",
            {
                d: "M21 10.498V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.729l7 4a2 2 0 0 0 2 .001l.98-.559",
                key: "tok1h1"
            }
        ],
        [
            "path",
            {
                d: "M3.29 7 12 12l8.71-5",
                key: "19ckod"
            }
        ],
        [
            "path",
            {
                d: "m7.5 4.27 8.997 5.148",
                key: "9yrvtv"
            }
        ],
        [
            "circle",
            {
                cx: "18.5",
                cy: "16.5",
                r: "2.5",
                key: "ke13xx"
            }
        ]
    ]
};
$1464ce6eb72f37f2$export$a2387ed3b5d536eb.node;
const $1464ce6eb72f37f2$export$2e2bcd8739ae039 = (0, $9QBug.default)($1464ce6eb72f37f2$export$a2387ed3b5d536eb);

});

parcelRegister("9fe6i", function(module, exports) {

$parcel$export(module.exports, "default", () => $03ba326894182d7e$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $03ba326894182d7e$export$a2387ed3b5d536eb = {
    name: "package-plus",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M12 22V12",
                key: "d0xqtd"
            }
        ],
        [
            "path",
            {
                d: "M16 17h6",
                key: "1ook5g"
            }
        ],
        [
            "path",
            {
                d: "M19 14v6",
                key: "1ckrd5"
            }
        ],
        [
            "path",
            {
                d: "M21 10.535V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.729l7 4a2 2 0 0 0 2 .001l1.675-.955",
                key: "28k6lz"
            }
        ],
        [
            "path",
            {
                d: "M3.29 7 12 12l8.71-5",
                key: "19ckod"
            }
        ],
        [
            "path",
            {
                d: "m7.5 4.27 8.997 5.148",
                key: "9yrvtv"
            }
        ]
    ]
};
$03ba326894182d7e$export$a2387ed3b5d536eb.node;
const $03ba326894182d7e$export$2e2bcd8739ae039 = (0, $9QBug.default)($03ba326894182d7e$export$a2387ed3b5d536eb);

});

parcelRegister("871U3", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9c9391d555011b1$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $e9c9391d555011b1$export$a2387ed3b5d536eb = {
    name: "package-x",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M12 22V12",
                key: "d0xqtd"
            }
        ],
        [
            "path",
            {
                d: "m16.5 14.5 5 5",
                key: "ozpm51"
            }
        ],
        [
            "path",
            {
                d: "m16.5 19.5 5-5",
                key: "syf6b9"
            }
        ],
        [
            "path",
            {
                d: "M21 10.5V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.729l7 4a2 2 0 0 0 2 .001l.13-.074",
                key: "isw6gs"
            }
        ],
        [
            "path",
            {
                d: "M3.29 7 12 12l8.71-5",
                key: "19ckod"
            }
        ],
        [
            "path",
            {
                d: "m7.5 4.27 8.997 5.148",
                key: "9yrvtv"
            }
        ]
    ]
};
$e9c9391d555011b1$export$a2387ed3b5d536eb.node;
const $e9c9391d555011b1$export$2e2bcd8739ae039 = (0, $9QBug.default)($e9c9391d555011b1$export$a2387ed3b5d536eb);

});

parcelRegister("8gMKa", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bf1fbadf27297cb$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $9bf1fbadf27297cb$export$a2387ed3b5d536eb = {
    name: "package",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z",
                key: "1a0edw"
            }
        ],
        [
            "path",
            {
                d: "M12 22V12",
                key: "d0xqtd"
            }
        ],
        [
            "polyline",
            {
                points: "3.29 7 12 12 20.71 7",
                key: "ousv84"
            }
        ],
        [
            "path",
            {
                d: "m7.5 4.27 9 5.15",
                key: "1c824w"
            }
        ]
    ]
};
$9bf1fbadf27297cb$export$a2387ed3b5d536eb.node;
const $9bf1fbadf27297cb$export$2e2bcd8739ae039 = (0, $9QBug.default)($9bf1fbadf27297cb$export$a2387ed3b5d536eb);

});

parcelRegister("fLk6s", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a9c585fee1ab085$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $3a9c585fee1ab085$export$a2387ed3b5d536eb = {
    name: "phone-call",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M13 2a9 9 0 0 1 9 9",
                key: "1itnx2"
            }
        ],
        [
            "path",
            {
                d: "M13 6a5 5 0 0 1 5 5",
                key: "11nki7"
            }
        ],
        [
            "path",
            {
                d: "M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384",
                key: "9njp5v"
            }
        ]
    ]
};
$3a9c585fee1ab085$export$a2387ed3b5d536eb.node;
const $3a9c585fee1ab085$export$2e2bcd8739ae039 = (0, $9QBug.default)($3a9c585fee1ab085$export$a2387ed3b5d536eb);

});

parcelRegister("ldAmm", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c2ee334f6cf1a96$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $4c2ee334f6cf1a96$export$a2387ed3b5d536eb = {
    name: "power",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M12 2v10",
                key: "mnfbl"
            }
        ],
        [
            "path",
            {
                d: "M18.4 6.6a9 9 0 1 1-12.77.04",
                key: "obofu9"
            }
        ]
    ]
};
$4c2ee334f6cf1a96$export$a2387ed3b5d536eb.node;
const $4c2ee334f6cf1a96$export$2e2bcd8739ae039 = (0, $9QBug.default)($4c2ee334f6cf1a96$export$a2387ed3b5d536eb);

});

parcelRegister("bCZWx", function(module, exports) {

$parcel$export(module.exports, "default", () => $a54d2547df8b874b$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $a54d2547df8b874b$export$a2387ed3b5d536eb = {
    name: "receipt-text",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M13 16H8",
                key: "wsln4y"
            }
        ],
        [
            "path",
            {
                d: "M14 8H8",
                key: "1l3xfs"
            }
        ],
        [
            "path",
            {
                d: "M16 12H8",
                key: "1fr5h0"
            }
        ],
        [
            "path",
            {
                d: "M4 3a1 1 0 0 1 1-1 1.3 1.3 0 0 1 .7.2l.933.6a1.3 1.3 0 0 0 1.4 0l.934-.6a1.3 1.3 0 0 1 1.4 0l.933.6a1.3 1.3 0 0 0 1.4 0l.933-.6a1.3 1.3 0 0 1 1.4 0l.934.6a1.3 1.3 0 0 0 1.4 0l.933-.6A1.3 1.3 0 0 1 19 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1 1.3 1.3 0 0 1-.7-.2l-.933-.6a1.3 1.3 0 0 0-1.4 0l-.934.6a1.3 1.3 0 0 1-1.4 0l-.933-.6a1.3 1.3 0 0 0-1.4 0l-.933.6a1.3 1.3 0 0 1-1.4 0l-.934-.6a1.3 1.3 0 0 0-1.4 0l-.933.6a1.3 1.3 0 0 1-.7.2 1 1 0 0 1-1-1z",
                key: "ycz6yz"
            }
        ]
    ]
};
$a54d2547df8b874b$export$a2387ed3b5d536eb.node;
const $a54d2547df8b874b$export$2e2bcd8739ae039 = (0, $9QBug.default)($a54d2547df8b874b$export$a2387ed3b5d536eb);

});

parcelRegister("1MQnZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $feb53807aa4ffff7$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $feb53807aa4ffff7$export$a2387ed3b5d536eb = {
    name: "repeat",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m17 2 4 4-4 4",
                key: "nntrym"
            }
        ],
        [
            "path",
            {
                d: "M3 11v-1a4 4 0 0 1 4-4h14",
                key: "84bu3i"
            }
        ],
        [
            "path",
            {
                d: "m7 22-4-4 4-4",
                key: "1wqhfi"
            }
        ],
        [
            "path",
            {
                d: "M21 13v1a4 4 0 0 1-4 4H3",
                key: "1rx37r"
            }
        ]
    ]
};
$feb53807aa4ffff7$export$a2387ed3b5d536eb.node;
const $feb53807aa4ffff7$export$2e2bcd8739ae039 = (0, $9QBug.default)($feb53807aa4ffff7$export$a2387ed3b5d536eb);

});

parcelRegister("68WhD", function(module, exports) {

$parcel$export(module.exports, "default", () => $90b37241122556d5$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $90b37241122556d5$export$a2387ed3b5d536eb = {
    name: "shopping-bag",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M16 10a4 4 0 0 1-8 0",
                key: "1ltviw"
            }
        ],
        [
            "path",
            {
                d: "M3.103 6.034h17.794",
                key: "awc11p"
            }
        ],
        [
            "path",
            {
                d: "M3.4 5.467a2 2 0 0 0-.4 1.2V20a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6.667a2 2 0 0 0-.4-1.2l-2-2.667A2 2 0 0 0 17 2H7a2 2 0 0 0-1.6.8z",
                key: "o988cm"
            }
        ]
    ]
};
$90b37241122556d5$export$a2387ed3b5d536eb.node;
const $90b37241122556d5$export$2e2bcd8739ae039 = (0, $9QBug.default)($90b37241122556d5$export$a2387ed3b5d536eb);

});

parcelRegister("f1lmH", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee6b431120447930$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $ee6b431120447930$export$a2387ed3b5d536eb = {
    name: "shopping-cart",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m2.05 2.05 1.099-.028a1 1 0 0 1 1.008.815l2.69 14.347A1 1 0 0 0 7.83 18H18",
                key: "uebgi3"
            }
        ],
        [
            "path",
            {
                d: "M4.563 5h16.435a1 1 0 0 1 .981 1.204l-1.026 6.226A2 2 0 0 1 18.962 14H6.25",
                key: "1j7c9p"
            }
        ],
        [
            "circle",
            {
                cx: "18",
                cy: "20",
                r: "2",
                key: "t9985n"
            }
        ],
        [
            "circle",
            {
                cx: "8",
                cy: "20",
                r: "2",
                key: "ckkr5m"
            }
        ]
    ]
};
$ee6b431120447930$export$a2387ed3b5d536eb.node;
const $ee6b431120447930$export$2e2bcd8739ae039 = (0, $9QBug.default)($ee6b431120447930$export$a2387ed3b5d536eb);

});

parcelRegister("cvlYg", function(module, exports) {

$parcel$export(module.exports, "default", () => $f395175238a6fe62$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $f395175238a6fe62$export$a2387ed3b5d536eb = {
    name: "star",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z",
                key: "r04s7s"
            }
        ]
    ]
};
$f395175238a6fe62$export$a2387ed3b5d536eb.node;
const $f395175238a6fe62$export$2e2bcd8739ae039 = (0, $9QBug.default)($f395175238a6fe62$export$a2387ed3b5d536eb);

});

parcelRegister("lVOqi", function(module, exports) {

$parcel$export(module.exports, "default", () => $3db25fddaf4be81b$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $3db25fddaf4be81b$export$a2387ed3b5d536eb = {
    name: "sticky-note",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M21 9a2.4 2.4 0 0 0-.706-1.706l-3.588-3.588A2.4 2.4 0 0 0 15 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2z",
                key: "1dfntj"
            }
        ],
        [
            "path",
            {
                d: "M15 3v5a1 1 0 0 0 1 1h5",
                key: "6s6qgf"
            }
        ]
    ]
};
$3db25fddaf4be81b$export$a2387ed3b5d536eb.node;
const $3db25fddaf4be81b$export$2e2bcd8739ae039 = (0, $9QBug.default)($3db25fddaf4be81b$export$a2387ed3b5d536eb);

});

parcelRegister("2cmA8", function(module, exports) {

$parcel$export(module.exports, "default", () => $36ae4e747d9057a9$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $36ae4e747d9057a9$export$a2387ed3b5d536eb = {
    name: "store",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M15 21v-5a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v5",
                key: "slp6dd"
            }
        ],
        [
            "path",
            {
                d: "M17.774 10.31a1.12 1.12 0 0 0-1.549 0 2.5 2.5 0 0 1-3.451 0 1.12 1.12 0 0 0-1.548 0 2.5 2.5 0 0 1-3.452 0 1.12 1.12 0 0 0-1.549 0 2.5 2.5 0 0 1-3.77-3.248l2.889-4.184A2 2 0 0 1 7 2h10a2 2 0 0 1 1.653.873l2.895 4.192a2.5 2.5 0 0 1-3.774 3.244",
                key: "o0xfot"
            }
        ],
        [
            "path",
            {
                d: "M4 10.95V19a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8.05",
                key: "wn3emo"
            }
        ]
    ]
};
$36ae4e747d9057a9$export$a2387ed3b5d536eb.node;
const $36ae4e747d9057a9$export$2e2bcd8739ae039 = (0, $9QBug.default)($36ae4e747d9057a9$export$a2387ed3b5d536eb);

});

parcelRegister("8LRQE", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e5d2d1db089da95$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $5e5d2d1db089da95$export$a2387ed3b5d536eb = {
    name: "tag",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z",
                key: "vktsd0"
            }
        ],
        [
            "circle",
            {
                cx: "7.5",
                cy: "7.5",
                r: ".5",
                fill: "currentColor",
                key: "kqv944"
            }
        ]
    ]
};
$5e5d2d1db089da95$export$a2387ed3b5d536eb.node;
const $5e5d2d1db089da95$export$2e2bcd8739ae039 = (0, $9QBug.default)($5e5d2d1db089da95$export$a2387ed3b5d536eb);

});

parcelRegister("8OM1W", function(module, exports) {

$parcel$export(module.exports, "default", () => $05facb5e901d5499$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $05facb5e901d5499$export$a2387ed3b5d536eb = {
    name: "truck",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2",
                key: "wrbu53"
            }
        ],
        [
            "path",
            {
                d: "M15 18H9",
                key: "1lyqi6"
            }
        ],
        [
            "path",
            {
                d: "M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14",
                key: "lysw3i"
            }
        ],
        [
            "circle",
            {
                cx: "17",
                cy: "18",
                r: "2",
                key: "332jqn"
            }
        ],
        [
            "circle",
            {
                cx: "7",
                cy: "18",
                r: "2",
                key: "19iecd"
            }
        ]
    ]
};
$05facb5e901d5499$export$a2387ed3b5d536eb.node;
const $05facb5e901d5499$export$2e2bcd8739ae039 = (0, $9QBug.default)($05facb5e901d5499$export$a2387ed3b5d536eb);

});

parcelRegister("af8wH", function(module, exports) {

$parcel$export(module.exports, "default", () => $8da4199a62c2ad09$export$2e2bcd8739ae039);
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $8da4199a62c2ad09$export$a2387ed3b5d536eb = {
    name: "unlink",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m18.84 12.25 1.72-1.71h-.02a5.004 5.004 0 0 0-.12-7.07 5.006 5.006 0 0 0-6.95 0l-1.72 1.71",
                key: "yqzxt4"
            }
        ],
        [
            "path",
            {
                d: "m5.17 11.75-1.71 1.71a5.004 5.004 0 0 0 .12 7.07 5.006 5.006 0 0 0 6.95 0l1.71-1.71",
                key: "4qinb0"
            }
        ],
        [
            "line",
            {
                x1: "8",
                x2: "8",
                y1: "2",
                y2: "5",
                key: "1041cp"
            }
        ],
        [
            "line",
            {
                x1: "2",
                x2: "5",
                y1: "8",
                y2: "8",
                key: "14m1p5"
            }
        ],
        [
            "line",
            {
                x1: "16",
                x2: "16",
                y1: "19",
                y2: "22",
                key: "rzdirn"
            }
        ],
        [
            "line",
            {
                x1: "19",
                x2: "22",
                y1: "16",
                y2: "16",
                key: "ox905f"
            }
        ]
    ]
};
$8da4199a62c2ad09$export$a2387ed3b5d536eb.node;
const $8da4199a62c2ad09$export$2e2bcd8739ae039 = (0, $9QBug.default)($8da4199a62c2ad09$export$a2387ed3b5d536eb);

});

parcelRegister("aE6sf", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fd937e4be3c850d$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4l6DR = parcelRequire("4l6DR");
var $2uCMp = parcelRequire("2uCMp");
var $97xXr = parcelRequire("97xXr");
var $7VXKQ = parcelRequire("7VXKQ");
var $8g4t5 = parcelRequire("8g4t5");
var $lUsTt = parcelRequire("lUsTt");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $bHjRG = parcelRequire("bHjRG");
var $aJ1FU = parcelRequire("aJ1FU");
var $9gEOi = parcelRequire("9gEOi");
var $cjPik = parcelRequire("cjPik");
var $7gSBD = parcelRequire("7gSBD");
var $h4ZeB = parcelRequire("h4ZeB");
var $5MbI8 = parcelRequire("5MbI8");
var $bfs4Q = parcelRequire("bfs4Q");
var $fAR2n = parcelRequire("fAR2n");
var $5Rv3V = parcelRequire("5Rv3V");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");
parcelRequire("52bn2");
var $jTCZr = parcelRequire("jTCZr");

var $2xQve = parcelRequire("2xQve");

var $ecQOV = parcelRequire("ecQOV");

var $ckJuK = parcelRequire("ckJuK");
/**
 * ساعات حضور — the weekly shifts a PERFORMER works at THIS clinic: a
 * practitioner, and since PM-0468 §4.2 a staff member who performs a service.
 * Layout and behaviour: `docs/parsina_clinic_hours_wireframe.md`, service
 * windows per `docs/SERVICE_OFFERING_AND_BOOKING_DESIGN.md` §2.3 / §4.2.
 *
 * This is the heart of the person↔clinic relationship: it is what makes them
 * bookable, and `scheduling` enforces it at booking time. The rows live in
 * `scheduling.doctor_presences`, keyed on the provider; the clinic writes the
 * whole week atomically through `replaceProviderPresences` (a merge would
 * resurrect a shift the manager just deleted).
 *
 * Each range may be narrowed to SERVICES (`serviceCatalogIds`, empty = every
 * service the person performs — the 90 %). «۸–۱۰ خدمت A، ۱۰–۱۲ خدمت B» is two
 * ranges with two lists; the picker offers only what this person performs, so
 * a window can never name a service they do not do. «تقسیم بازه» makes that
 * pair in one click.
 *
 * `value` stays the flat wire list — the drawer's dirty flag and the mutation
 * both read it — and the editor only GROUPS it: one row per weekday, 0 = شنبه,
 * Saturday-first (DS §6.3). Within a day, ranges keep their insertion order
 * rather than being sorted, so a row never jumps away from under the cursor
 * while its start time is being typed.
 *
 * «فعال» is derived from the data (a day with ranges is on) plus one piece of
 * view state: a day switched on, or whose last range was just deleted, stays
 * on with «بدون شیفت» until the manager turns it off. That state is reset with
 * `resetKey`.
 *
 * Validation is inline (`role="alert"`) and non-blocking here: the error sits
 * under the range it is about and the save is refused by the caller. Two
 * touching ranges with different lists are fine (filter-then-merge).
 *
 * Props:
 *   services        — [{ catalogId, name }] this person performs; null = not known
 *   servicesLoading — the list is still being read
 *   persona         — 'practitioner' | 'staff' (the empty state's wording)
 */ /** One-tap boundaries in the picker — where a clinic shift nearly always starts or ends. */ const $0fd937e4be3c850d$var$SHIFT_TIMES = [
    '07:00',
    '08:00',
    '10:00',
    '12:00',
    '14:00',
    '16:00',
    '18:00',
    '20:00'
];
const $0fd937e4be3c850d$var$toMin = (hhmm)=>{
    const [h, m] = String(hhmm || '').split(':').map(Number);
    return h * 60 + m;
};
const $0fd937e4be3c850d$var$toHHMM = (m)=>`${String(Math.floor(m / 60)).padStart(2, '0')}:${String(m % 60).padStart(2, '0')}`;
/** The midpoint of a range, rounded down to five minutes — the split dialog's proposal. */ const $0fd937e4be3c850d$var$midpoint = (s)=>{
    const a = $0fd937e4be3c850d$var$toMin(s.startTime);
    const b = $0fd937e4be3c850d$var$toMin(s.endTime);
    if (!Number.isFinite(a) || !Number.isFinite(b) || b <= a) return s.startTime;
    return $0fd937e4be3c850d$var$toHHMM(Math.floor((a + b) / 2 / 5) * 5);
};
function $0fd937e4be3c850d$export$2e2bcd8739ae039({ value: value = [], onChange: onChange, disabled: disabled = false, resetKey: resetKey, services: services = null, servicesLoading: servicesLoading = false, persona: persona = 'practitioner' }) {
    const { t: t, weekdayNames: weekdayNames, formatList: formatList, formatNumber: formatNumber } = (0, $e1LEq.default)();
    const names = weekdayNames();
    const [openDays, setOpenDays] = (0, $acw62.useState)(()=>new Set());
    (0, $acw62.useEffect)(()=>{
        setOpenDays(new Set());
    }, [
        resetKey
    ]);
    const [copy, setCopy] = (0, $acw62.useState)(null); // { from, locked }
    const [disabling, setDisabling] = (0, $acw62.useState)(null); // day index awaiting confirmation
    const [splitting, setSplitting] = (0, $acw62.useState)(null); // slot index awaiting a cut time
    const [removing, setRemoving] = (0, $acw62.useState)(null); // slot index awaiting a Delete confirm
    const performedIds = Array.isArray(services) ? services.map((s)=>String(s.catalogId)) : null;
    const issues = (0, $acw62.useMemo)(()=>(0, $ckJuK.presenceIssues)(value, {
            performedIds: performedIds
        }), [
        value,
        performedIds
    ]);
    const byDay = (0, $acw62.useMemo)(()=>(0, $ckJuK.PRESENCE_DAYS).map((d)=>value.map((slot, index)=>({
                    ...slot,
                    index: index
                })).filter((s)=>Number(s.dayOfWeek) === d)), [
        value
    ]);
    const daysWithHours = (0, $ckJuK.PRESENCE_DAYS).filter((d)=>byDay[d].length > 0);
    const uncovered = (0, $acw62.useMemo)(()=>(0, $ckJuK.presenceReadiness)(value, services), [
        value,
        services
    ]);
    const serviceName = (id)=>services?.find((s)=>String(s.catalogId) === String(id))?.name || String(id);
    const setOpen = (day, on)=>setOpenDays((prev)=>{
            const next = new Set(prev);
            if (on) next.add(day);
            else next.delete(day);
            return next;
        });
    const update = (i, patch)=>onChange(value.map((slot, idx)=>idx === i ? {
                ...slot,
                ...patch
            } : slot));
    const addRange = (day)=>{
        setOpen(day, true);
        onChange([
            ...value,
            (0, $ckJuK.nextPresenceRange)(value, day)
        ]);
    };
    const removeRange = (day, i)=>{
        setOpen(day, true);
        onChange(value.filter((_, idx)=>idx !== i));
    };
    const clearDay = (day)=>{
        setOpen(day, false);
        onChange(value.filter((s)=>Number(s.dayOfWeek) !== day));
    };
    const toggleDay = (day, on)=>{
        if (on) {
            addRange(day);
            return;
        }
        if (byDay[day].length > 0) setDisabling(day);
        else setOpen(day, false);
    };
    const emptyText = persona === 'staff' && services?.length ? t('people.presence.staffEmpty', {
        count: services.length,
        list: formatList(services.map((s)=>s.name))
    }) : t('people.presence.emptyBlocksBooking');
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: (0, $2xQve.STACK).tight
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 8,
                    flexWrap: 'wrap'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        style: {
                            margin: 0,
                            fontSize: '0.875rem',
                            fontWeight: 700,
                            color: (0, $jTCZr.C).textPrimary
                        },
                        children: t('people.presence.title')
                    }),
                    !disabled && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                        variant: "outline",
                        size: "sm",
                        disabled: daysWithHours.length === 0,
                        onClick: ()=>setCopy({
                                from: daysWithHours[0],
                                locked: false
                            }),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2uCMp.default), {
                                size: 14
                            }),
                            " ",
                            t('people.presence.copyAll')
                        ]
                    })
                ]
            }),
            uncovered.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $dOauK.default), {
                variant: "info",
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $97xXr.default), {
                    size: 16
                }),
                "data-testid": "people-schedule-readiness",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        children: t('people.presence.readiness', {
                            count: uncovered.length,
                            list: formatList(uncovered.map((s)=>s.name))
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: '0.71875rem',
                            color: (0, $jTCZr.C).textMuted,
                            marginTop: 2
                        },
                        children: t('people.presence.readinessHint')
                    })
                ]
            }),
            value.length === 0 && (persona === 'staff' ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                "data-testid": "people-schedule-empty-staff",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7gSBD.default), {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4l6DR.default), {
                        size: 44,
                        strokeWidth: 1.5,
                        "aria-hidden": true
                    }),
                    title: emptyText,
                    description: t('people.presence.staffDeskNote')
                })
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    fontSize: '0.78125rem',
                    color: (0, $jTCZr.C).textMuted,
                    lineHeight: 1.9,
                    border: `1px dashed ${(0, $jTCZr.C).border}`,
                    borderRadius: 10,
                    padding: '10px 12px'
                },
                children: emptyText
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    border: `1px solid ${(0, $jTCZr.C).border}`,
                    borderRadius: 10,
                    background: (0, $jTCZr.C).card
                },
                children: (0, $ckJuK.PRESENCE_DAYS).map((day)=>/*#__PURE__*/ (0, $ayMG0.jsx)($0fd937e4be3c850d$var$DayRow, {
                        day: day,
                        name: names[day],
                        ranges: byDay[day],
                        issues: issues,
                        enabled: byDay[day].length > 0 || openDays.has(day),
                        disabled: disabled,
                        last: day === (0, $ckJuK.PRESENCE_DAYS).length - 1,
                        services: services,
                        servicesLoading: servicesLoading,
                        serviceName: serviceName,
                        onToggle: (on)=>toggleDay(day, on),
                        onAdd: ()=>addRange(day),
                        onRemove: (i)=>removeRange(day, i),
                        onAskRemove: (i)=>setRemoving(i),
                        onSplit: (i)=>setSplitting(i),
                        onCopy: ()=>setCopy({
                                from: day,
                                locked: true
                            }),
                        onUpdate: update
                    }, day))
            }),
            copy && /*#__PURE__*/ (0, $ayMG0.jsx)($0fd937e4be3c850d$var$CopyDialog, {
                names: names,
                from: copy.from,
                locked: copy.locked,
                sources: daysWithHours,
                byDay: byDay,
                onClose: ()=>setCopy(null),
                onApply: (from, targets, mode)=>{
                    onChange((0, $ckJuK.copyPresenceDay)(value, from, targets, mode));
                    setOpenDays((prev)=>new Set([
                            ...prev,
                            ...targets
                        ]));
                    setCopy(null);
                }
            }),
            splitting != null && value[splitting] && /*#__PURE__*/ (0, $ayMG0.jsx)($0fd937e4be3c850d$var$SplitDialog, {
                slot: value[splitting],
                dayName: names[Number(value[splitting].dayOfWeek)],
                onClose: ()=>setSplitting(null),
                onSplit: (at)=>{
                    const next = (0, $ckJuK.splitPresenceRange)(value, splitting, at);
                    if (next) onChange(next);
                    setSplitting(null);
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjPik.default), {
                open: removing != null,
                onOpenChange: (open)=>{
                    if (!open) setRemoving(null);
                },
                title: removing != null && value[removing] ? t('people.presence.deleteRange.title', {
                    day: names[Number(value[removing].dayOfWeek)],
                    start: value[removing].startTime,
                    end: value[removing].endTime
                }) : '',
                confirmLabel: t('people.presence.deleteRange.confirm'),
                cancelLabel: t('common.actions.cancel'),
                destructive: true,
                onConfirm: ()=>{
                    if (removing != null && value[removing]) removeRange(Number(value[removing].dayOfWeek), removing);
                    setRemoving(null);
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjPik.default), {
                open: disabling != null,
                onOpenChange: (open)=>{
                    if (!open) setDisabling(null);
                },
                title: disabling != null ? t('people.presence.disable.title', {
                    day: names[disabling]
                }) : '',
                description: t('people.presence.disable.body'),
                confirmLabel: t('people.presence.disable.confirm'),
                cancelLabel: t('common.actions.cancel'),
                destructive: true,
                onConfirm: ()=>{
                    clearDay(disabling);
                    setDisabling(null);
                }
            })
        ]
    });
}
function $0fd937e4be3c850d$var$DayRow({ day: day, name: name, ranges: ranges, issues: issues, enabled: enabled, disabled: disabled, last: last, services: services, servicesLoading: servicesLoading, serviceName: serviceName, onToggle: onToggle, onAdd: onAdd, onRemove: onRemove, onAskRemove: onAskRemove, onSplit: onSplit, onCopy: onCopy, onUpdate: onUpdate }) {
    const { t: t } = (0, $e1LEq.default)();
    const count = ranges.length;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        role: "group",
        "aria-label": name,
        "data-testid": `people-schedule-day-${day}`,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 6,
            padding: '8px 12px',
            borderBottom: last ? 'none' : `1px solid ${(0, $jTCZr.C).border}`,
            background: enabled ? 'transparent' : (0, $jTCZr.C).bg
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    minHeight: 40
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            minWidth: 64,
                            fontSize: '0.84375rem',
                            fontWeight: 600,
                            color: enabled ? (0, $jTCZr.C).textPrimary : (0, $jTCZr.C).textMuted
                        },
                        children: name
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($0fd937e4be3c850d$var$DaySwitch, {
                        checked: enabled,
                        disabled: disabled,
                        label: t('people.presence.toggleDay', {
                            day: name
                        }),
                        onChange: onToggle
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            fontSize: '0.75rem',
                            color: enabled ? (0, $jTCZr.C).textSecondary : (0, $jTCZr.C).textMuted
                        },
                        children: enabled ? t('people.presence.enabled') : t('people.presence.disabled')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bHjRG.default), {
                        variant: "outline",
                        children: t('people.presence.shiftCount', {
                            count: count
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            flex: 1
                        }
                    }),
                    !disabled && count > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5MbI8.default), {
                        variant: "ghost",
                        size: 40,
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2uCMp.default), {
                            size: 15
                        }),
                        label: t('people.presence.copyDay', {
                            day: name
                        }),
                        onClick: onCopy
                    })
                ]
            }),
            enabled && ranges.map((slot, n)=>/*#__PURE__*/ (0, $ayMG0.jsx)($0fd937e4be3c850d$var$RangeRow, {
                    day: day,
                    n: n,
                    name: name,
                    slot: slot,
                    issue: issues[slot.index],
                    disabled: disabled,
                    services: services,
                    servicesLoading: servicesLoading,
                    serviceName: serviceName,
                    onUpdate: onUpdate,
                    onRemove: ()=>onRemove(slot.index),
                    onAskRemove: ()=>onAskRemove(slot.index),
                    onSplit: ()=>onSplit(slot.index)
                }, slot.index)),
            enabled && !disabled && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                    variant: "ghost",
                    size: "sm",
                    onClick: onAdd,
                    "aria-label": t('people.presence.addRangeFor', {
                        day: name
                    }),
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8g4t5.default), {
                            size: 14
                        }),
                        " ",
                        t('people.presence.addRange')
                    ]
                })
            })
        ]
    });
}
/**
 * One range: the two times, its «خدمات» chip set, the `⋯` menu and the
 * delete. The row is a focusable group so `Delete` on it asks before removing
 * (never while the caret is in one of its time inputs).
 */ function $0fd937e4be3c850d$var$RangeRow({ day: day, n: n, name: name, slot: slot, issue: issue, disabled: disabled, services: services, servicesLoading: servicesLoading, serviceName: serviceName, onUpdate: onUpdate, onRemove: onRemove, onAskRemove: onAskRemove, onSplit: onSplit }) {
    const { t: t } = (0, $e1LEq.default)();
    const errorId = issue ? `presence-err-${slot.index}` : undefined;
    const menuRef = (0, $acw62.useRef)(null);
    const [menuOpen, setMenuOpen] = (0, $acw62.useState)(false);
    const id = `people-schedule-range-${day}-${n}`;
    const issueText = issue === (0, $ckJuK.PRESENCE_ISSUE).ORDER ? t('people.presence.errorOrder') : issue === (0, $ckJuK.PRESENCE_ISSUE).OVERLAP ? t('people.presence.errorOverlap') : issue === (0, $ckJuK.PRESENCE_ISSUE).UNKNOWN_SERVICE ? t('people.presence.errorUnknownService') : '';
    const blocking = issue === (0, $ckJuK.PRESENCE_ISSUE).ORDER || issue === (0, $ckJuK.PRESENCE_ISSUE).OVERLAP;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": id,
        role: "group",
        tabIndex: disabled ? -1 : 0,
        "aria-label": t('people.presence.rangeLabel', {
            n: n + 1,
            day: name,
            start: slot.startTime,
            end: slot.endTime
        }),
        onKeyDown: (e)=>{
            if (disabled || e.key !== 'Delete' || e.target !== e.currentTarget) return;
            e.preventDefault();
            onAskRemove();
        },
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 4,
            borderRadius: 8,
            outlineOffset: 2
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                    flexWrap: 'wrap'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ecQOV.default), {
                        suggestions: $0fd937e4be3c850d$var$SHIFT_TIMES,
                        value: slot.startTime,
                        disabled: disabled,
                        invalid: blocking,
                        describedBy: errorId,
                        label: t('people.presence.startOf', {
                            day: name,
                            n: n + 1
                        }),
                        onChange: (v)=>onUpdate(slot.index, {
                                startTime: v
                            })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        "aria-hidden": true,
                        style: {
                            color: (0, $jTCZr.C).textMuted
                        },
                        children: "\u2014"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ecQOV.default), {
                        suggestions: $0fd937e4be3c850d$var$SHIFT_TIMES,
                        value: slot.endTime,
                        disabled: disabled,
                        invalid: blocking,
                        describedBy: errorId,
                        label: t('people.presence.endOf', {
                            day: name,
                            n: n + 1
                        }),
                        onChange: (v)=>onUpdate(slot.index, {
                                endTime: v
                            })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($0fd937e4be3c850d$var$ServiceChips, {
                        testid: `${id}-services`,
                        slot: slot,
                        dayName: name,
                        disabled: disabled,
                        services: services,
                        servicesLoading: servicesLoading,
                        serviceName: serviceName,
                        onChange: (ids)=>onUpdate(slot.index, {
                                serviceCatalogIds: ids
                            })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            flex: 1
                        }
                    }),
                    !disabled && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                ref: menuRef,
                                style: {
                                    display: 'inline-flex'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5MbI8.default), {
                                    variant: "ghost",
                                    size: 40,
                                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7VXKQ.default), {
                                        size: 15
                                    }),
                                    label: t('people.presence.menu.label', {
                                        day: name,
                                        start: slot.startTime,
                                        end: slot.endTime
                                    }),
                                    "aria-haspopup": "menu",
                                    "aria-expanded": menuOpen,
                                    onClick: ()=>setMenuOpen((o)=>!o),
                                    "data-testid": `${id}-menu`
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bfs4Q.default), {
                                open: menuOpen,
                                onClose: ()=>setMenuOpen(false),
                                anchorRef: menuRef,
                                width: 220,
                                ariaLabel: t('people.presence.menu.label', {
                                    day: name,
                                    start: slot.startTime,
                                    end: slot.endTime
                                }),
                                "data-testid": `${id}-menu-popover`,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        type: "button",
                                        role: "menuitem",
                                        style: $0fd937e4be3c850d$var$MENU_ITEM,
                                        onClick: ()=>{
                                            setMenuOpen(false);
                                            onSplit();
                                        },
                                        children: t('people.presence.split.action')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        type: "button",
                                        role: "menuitem",
                                        style: {
                                            ...$0fd937e4be3c850d$var$MENU_ITEM,
                                            color: (0, $jTCZr.C).red
                                        },
                                        onClick: ()=>{
                                            setMenuOpen(false);
                                            onAskRemove();
                                        },
                                        children: t('people.presence.removeRange', {
                                            day: name,
                                            start: slot.startTime,
                                            end: slot.endTime
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5MbI8.default), {
                                variant: "ghost",
                                size: 40,
                                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lUsTt.default), {
                                    size: 15
                                }),
                                label: t('people.presence.removeRange', {
                                    day: name,
                                    start: slot.startTime,
                                    end: slot.endTime
                                }),
                                onClick: onRemove
                            })
                        ]
                    })
                ]
            }),
            issue && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                id: errorId,
                role: "alert",
                style: {
                    fontSize: '0.75rem',
                    color: blocking ? (0, $jTCZr.C).red : $0fd937e4be3c850d$var$CT_WARN
                },
                children: issueText
            })
        ]
    });
}
const $0fd937e4be3c850d$var$CT_WARN = '#92400e';
const $0fd937e4be3c850d$var$MENU_ITEM = {
    display: 'block',
    width: '100%',
    textAlign: 'start',
    padding: '8px 10px',
    border: 'none',
    background: 'transparent',
    fontFamily: 'inherit',
    fontSize: '0.78125rem',
    cursor: 'pointer',
    borderRadius: 6,
    color: (0, $jTCZr.C).textPrimary
};
/**
 * «خدمات» on a range — a `FilterChip` that reads the list («همهٔ خدمات» / the
 * one name / two names / «۳ خدمت») and opens an inline popover listing ONLY
 * the services this person performs. The popover is a roving group with
 * `aria-pressed` buttons; Escape closes it.
 */ function $0fd937e4be3c850d$var$ServiceChips({ testid: testid, slot: slot, dayName: dayName, disabled: disabled, services: services, servicesLoading: servicesLoading, serviceName: serviceName, onChange: onChange }) {
    const { t: t, formatNumber: formatNumber } = (0, $e1LEq.default)();
    const chipRef = (0, $acw62.useRef)(null);
    const [open, setOpen] = (0, $acw62.useState)(false);
    const ids = (0, $ckJuK.normalizeServiceIds)(slot.serviceCatalogIds);
    const label = ids.length === 0 ? t('people.presence.services.all') : ids.length <= 2 ? ids.map(serviceName).join(t('common.punctuation.listSeparator')) : t('people.presence.services.count', {
        count: ids.length
    });
    const toggle = (catalogId)=>{
        const key = String(catalogId);
        onChange(ids.includes(key) ? ids.filter((x)=>x !== key) : [
            ...ids,
            key
        ]);
    };
    const move = (e, i, n)=>{
        if (![
            'ArrowDown',
            'ArrowUp',
            'Home',
            'End'
        ].includes(e.key)) return;
        e.preventDefault();
        const buttons = e.currentTarget.parentElement.querySelectorAll('button[aria-pressed]');
        const next = e.key === 'Home' ? 0 : e.key === 'End' ? n - 1 : (i + (e.key === 'ArrowDown' ? 1 : n - 1)) % n;
        buttons[next]?.focus();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
        "data-testid": testid,
        "data-state": ids.length ? 'narrowed' : 'all',
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 4
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                style: {
                    fontSize: '0.6875rem',
                    color: (0, $jTCZr.C).textMuted
                },
                children: [
                    t('people.presence.services.label'),
                    ":"
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $h4ZeB.default), {
                ref: chipRef,
                label: label,
                active: ids.length > 0,
                disabled: disabled,
                "aria-haspopup": "dialog",
                "aria-expanded": open,
                onClick: ()=>setOpen((o)=>!o),
                style: {
                    minHeight: 32
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bfs4Q.default), {
                open: open,
                onClose: ()=>setOpen(false),
                anchorRef: chipRef,
                width: 260,
                ariaLabel: t('people.presence.services.pick', {
                    day: dayName,
                    start: slot.startTime,
                    end: slot.endTime
                }),
                "data-testid": `${testid}-popover`,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    role: "group",
                    "aria-label": t('people.presence.services.pick', {
                        day: dayName,
                        start: slot.startTime,
                        end: slot.endTime
                    }),
                    onKeyDown: (e)=>{
                        if (e.key === 'Escape') {
                            e.stopPropagation();
                            setOpen(false);
                            chipRef.current?.focus?.();
                        }
                    },
                    style: {
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 2,
                        padding: 4
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                fontSize: '0.6875rem',
                                color: (0, $jTCZr.C).textMuted,
                                padding: '2px 6px 6px',
                                lineHeight: 1.7
                            },
                            children: t('people.presence.services.hint')
                        }),
                        servicesLoading && !services ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                fontSize: '0.75rem',
                                color: (0, $jTCZr.C).textMuted,
                                padding: '4px 6px'
                            },
                            children: t('people.presence.services.loading')
                        }) : !services?.length ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                fontSize: '0.75rem',
                                color: (0, $jTCZr.C).textMuted,
                                padding: '4px 6px'
                            },
                            children: t('people.presence.services.none')
                        }) : services.map((svc, i)=>{
                            const on = ids.includes(String(svc.catalogId));
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                type: "button",
                                "aria-pressed": on,
                                "aria-label": svc.name,
                                "data-menu-focus": i === 0 ? 'true' : undefined,
                                onClick: ()=>toggle(svc.catalogId),
                                onKeyDown: (e)=>move(e, i, services.length),
                                style: {
                                    ...$0fd937e4be3c850d$var$MENU_ITEM,
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 8,
                                    background: on ? (0, $jTCZr.C).navyLight : 'transparent',
                                    fontWeight: on ? 700 : 500
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        "aria-hidden": true,
                                        style: {
                                            width: 14,
                                            height: 14,
                                            borderRadius: 4,
                                            border: `1.5px solid ${on ? (0, $jTCZr.C).navy : (0, $jTCZr.C).border}`,
                                            background: on ? (0, $jTCZr.C).navy : '#fff',
                                            flexShrink: 0
                                        }
                                    }),
                                    svc.name,
                                    svc.durationMinutes ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        style: {
                                            marginInlineStart: 'auto',
                                            fontSize: '0.6875rem',
                                            color: (0, $jTCZr.C).textMuted
                                        },
                                        children: [
                                            formatNumber(svc.durationMinutes),
                                            "\u2032"
                                        ]
                                    }) : null
                                ]
                            }, svc.catalogId);
                        })
                    ]
                })
            })
        ]
    });
}
/** «تقسیم بازه» — one time, two rows; both inherit the list. */ function $0fd937e4be3c850d$var$SplitDialog({ slot: slot, dayName: dayName, onClose: onClose, onSplit: onSplit }) {
    const { t: t } = (0, $e1LEq.default)();
    const [at, setAt] = (0, $acw62.useState)(()=>$0fd937e4be3c850d$var$midpoint(slot));
    const valid = !!at && slot.startTime < at && at < slot.endTime;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjPik.default), {
        open: true,
        onOpenChange: (open)=>{
            if (!open) onClose();
        },
        title: t('people.presence.split.title', {
            day: dayName,
            start: slot.startTime,
            end: slot.endTime
        }),
        description: t('people.presence.split.body'),
        confirmLabel: t('people.presence.split.confirm'),
        cancelLabel: t('common.actions.cancel'),
        confirmDisabled: !valid,
        onConfirm: ()=>valid && onSplit(at),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: 6
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ecQOV.default), {
                    suggestions: $0fd937e4be3c850d$var$SHIFT_TIMES.filter((x)=>slot.startTime < x && x < slot.endTime),
                    value: at,
                    invalid: !valid,
                    label: t('people.presence.split.at'),
                    onChange: setAt
                }),
                !valid && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    role: "alert",
                    style: {
                        fontSize: '0.75rem',
                        color: (0, $jTCZr.C).red
                    },
                    children: t('people.presence.split.invalid')
                })
            ]
        })
    });
}
/**
 * «کپی ساعات» — one dialog for both doors. From a day's own copy button the
 * source is fixed; from the header the manager picks it. Targets default to
 * every other day, and «جایگزین کردن» is the default mode because «همه روزها
 * مثل شنبه» is what the button is pressed for — the dialog itself is the
 * confirmation, and it names the consequence when a target already has hours.
 */ function $0fd937e4be3c850d$var$CopyDialog({ names: names, from: initialFrom, locked: locked, sources: sources, byDay: byDay, onClose: onClose, onApply: onApply }) {
    const { t: t } = (0, $e1LEq.default)();
    const [from, setFrom] = (0, $acw62.useState)(initialFrom);
    const [targets, setTargets] = (0, $acw62.useState)(()=>(0, $ckJuK.PRESENCE_DAYS).filter((d)=>d !== initialFrom));
    const [mode, setMode] = (0, $acw62.useState)('replace');
    const chosen = targets.filter((d)=>d !== from);
    const overwrites = mode === 'replace' && chosen.some((d)=>byDay[d].length > 0);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjPik.default), {
        open: true,
        onOpenChange: (open)=>{
            if (!open) onClose();
        },
        title: locked ? t('people.presence.copy.titleDay', {
            day: names[from]
        }) : t('people.presence.copy.title'),
        confirmLabel: t('common.actions.apply'),
        cancelLabel: t('common.actions.cancel'),
        confirmDisabled: chosen.length === 0,
        onConfirm: ()=>onApply(from, chosen, mode),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: (0, $2xQve.STACK).regular
            },
            children: [
                !locked && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fAR2n.default), {
                    label: t('people.presence.copy.source'),
                    placeholder: t('common.form.chooseEllipsis'),
                    value: String(from),
                    onChange: (e)=>setFrom(Number(e.target.value)),
                    options: sources.map((d)=>({
                            value: String(d),
                            label: names[d]
                        }))
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("fieldset", {
                    style: {
                        border: 'none',
                        margin: 0,
                        padding: 0,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 6
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("legend", {
                            style: {
                                fontSize: '0.78125rem',
                                color: (0, $jTCZr.C).textSecondary,
                                marginBottom: 6
                            },
                            children: t('people.presence.copy.targets')
                        }),
                        (0, $ckJuK.PRESENCE_DAYS).filter((d)=>d !== from).map((d)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $9gEOi.default), {
                                label: names[d],
                                checked: targets.includes(d),
                                onChange: (on)=>setTargets((prev)=>on ? [
                                            ...prev,
                                            d
                                        ] : prev.filter((x)=>x !== d))
                            }, d))
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5Rv3V.default), {
                    label: t('people.presence.copy.mode'),
                    value: mode,
                    onChange: (v)=>{
                        if (v) setMode(v);
                    },
                    options: [
                        {
                            value: 'replace',
                            label: t('people.presence.copy.replace')
                        },
                        {
                            value: 'append',
                            label: t('people.presence.copy.append')
                        }
                    ]
                }),
                overwrites && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        fontSize: '0.75rem',
                        color: (0, $jTCZr.C).textSecondary,
                        lineHeight: 1.8
                    },
                    children: t('people.presence.copy.overwriteWarning')
                })
            ]
        })
    });
}
/**
 * The day's on/off control. The kit `Switch` is a `<div>` no keyboard can
 * reach and `Toggle` brings a full labelled row with its own divider, so this
 * is the kit's switch geometry on a real `<button role="switch">` — Tab, Space
 * and Enter work, and `aria-checked` rather than colour carries the state.
 */ function $0fd937e4be3c850d$var$DaySwitch({ checked: checked, onChange: onChange, disabled: disabled, label: label }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
        type: "button",
        role: "switch",
        "aria-checked": checked,
        "aria-label": label,
        disabled: disabled,
        onClick: ()=>onChange(!checked),
        style: {
            width: 40,
            height: 22,
            borderRadius: 999,
            padding: 0,
            flexShrink: 0,
            position: 'relative',
            border: 'none',
            background: checked ? (0, $jTCZr.C).navy : '#d1d5db',
            cursor: disabled ? 'not-allowed' : 'pointer',
            opacity: disabled ? 0.55 : 1,
            transition: 'background .2s'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            style: {
                position: 'absolute',
                top: 3,
                width: 16,
                height: 16,
                borderRadius: '50%',
                background: '#fff',
                boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
                right: checked ? 3 : 21,
                transition: 'right .2s'
            }
        })
    });
}

});
parcelRegister("ecQOV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3020a8000c84f62a$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $kMJsW = parcelRequire("kMJsW");
parcelRequire("5N0ZI");
var $cZOyb = parcelRequire("cZOyb");
var $aJ1FU = parcelRequire("aJ1FU");
var $k27hS = parcelRequire("k27hS");
parcelRequire("52bn2");
var $jTCZr = parcelRequire("jTCZr");
parcelRequire("7c6z4");
var $gVWNP = parcelRequire("gVWNP");
var $e1LEq = parcelRequire("e1LEq");
/**
 * TimePicker — a clock time field, `HH:MM` on the wire.
 *
 * Replaces the native `<input type="time">`, whose popup is whatever the OS
 * draws: an English AM/PM spinner inside a Persian panel on Windows, a
 * browser-grey dropdown that ignores every token, and digits that never follow
 * the locale. The kit has no time field at the pinned tag, so this sits at the
 * app-shared layer (DESIGN.md sourcing rule) — composed from kit pieces and the
 * system's overlay roles, and the thing to promote once a second app needs it.
 *
 * Three ways in, one value:
 *   • TYPE — the field is a real text input. Digits from any shipped keyboard
 *     (`toAsciiDigits`), `830` → 08:30 and `14` → 14:00 on blur/Enter, and a
 *     complete `HH:MM` is committed as it is typed, so the caller's dirty flag
 *     moves without waiting for a blur.
 *   • PICK — clicking the field (or ↓ / Alt+↓) opens two scroll columns, hours
 *     and minutes, with an AM/PM column when `hourCycle={12}`. Every pick
 *     applies at once; picking a minute closes the panel, because hour-then-
 *     minute is the whole gesture.
 *   • SUGGEST — optional one-tap chips for the times a screen actually uses.
 *
 * Surfaces (DESIGN_SYSTEM §5 roles): desktop is an anchored popover portaled to
 * `<body>` at the `Menu` layer (z 900 — above a Drawer, below a ConfirmDialog);
 * ≤ 768px is a `BottomSheet` with larger rows and a confirm, because a popover
 * anchored to a field near the bottom of a phone is not usable.
 *
 * 24-hour is the default everywhere: Iranian clinical scheduling is written in
 * 24-hour time and `formatTime` renders it that way in every locale.
 * `hourCycle={12}` only changes what is SHOWN; the value stays 24-hour ASCII.
 *
 * The clock is an LTR island (§6.4) — hours sit left of minutes in Persian too —
 * while its digits follow the locale through `formatDigits`.
 */ const $3020a8000c84f62a$var$ROW = 36;
const $3020a8000c84f62a$var$ROW_MOBILE = 44;
const $3020a8000c84f62a$var$VISIBLE_ROWS = 5;
const $3020a8000c84f62a$var$Z_POPOVER = 900;
const $3020a8000c84f62a$var$EDGE = 8;
const $3020a8000c84f62a$var$pad = (n)=>String(n).padStart(2, '0');
function $3020a8000c84f62a$export$e5de97849a5bcce4(text) {
    const m = /^(\d{2}):(\d{2})$/.exec(String(text || ''));
    if (!m) return null;
    const h = Number(m[1]);
    const min = Number(m[2]);
    return h <= 23 && min <= 59 ? `${m[1]}:${m[2]}` : null;
}
function $3020a8000c84f62a$export$6a574025f5dbade5(text) {
    const ascii = (0, $gVWNP.toAsciiDigits)(text).trim().replace(/[.٫،,]/g, ':');
    if (!ascii) return null;
    let h;
    let m;
    if (ascii.includes(':')) {
        const [a, b = '0'] = ascii.split(':');
        if (!/^\d{1,2}$/.test(a) || !/^\d{0,2}$/.test(b)) return null;
        h = Number(a);
        m = Number(b || 0);
    } else {
        if (!/^\d{1,4}$/.test(ascii)) return null;
        if (ascii.length <= 2) {
            h = Number(ascii);
            m = 0;
        } else {
            h = Number(ascii.slice(0, ascii.length - 2));
            m = Number(ascii.slice(-2));
        }
    }
    return h <= 23 && m <= 59 ? `${$3020a8000c84f62a$var$pad(h)}:${$3020a8000c84f62a$var$pad(m)}` : null;
}
const $3020a8000c84f62a$var$splitTime = (value)=>{
    const v = $3020a8000c84f62a$export$e5de97849a5bcce4(value);
    return v ? {
        h: Number(v.slice(0, 2)),
        m: Number(v.slice(3))
    } : null;
};
function $3020a8000c84f62a$export$2e2bcd8739ae039({ value: value, onChange: onChange, label: label, disabled: disabled = false, invalid: invalid = false, describedBy: describedBy, hourCycle: hourCycle = 24, minuteStep: minuteStep = 5, suggestions: suggestions = [], width: width = '100%', maxWidth: maxWidth = 140 }) {
    const { t: t, formatDigits: formatDigits } = (0, $e1LEq.default)();
    const { isMobile: isMobile } = (0, $k27hS.default)();
    const panelId = (0, $acw62.useId)();
    const inputRef = (0, $acw62.useRef)(null);
    const wrapRef = (0, $acw62.useRef)(null);
    const panelRef = (0, $acw62.useRef)(null);
    const [open, setOpen] = (0, $acw62.useState)(false);
    const [focused, setFocused] = (0, $acw62.useState)(false);
    const [draft, setDraft] = (0, $acw62.useState)('');
    // A pick made while the field has focus must show in the field, but a
    // partial "1" being typed must not be wiped by an unrelated re-render — so
    // the draft only follows `value` when `value` actually changes.
    (0, $acw62.useEffect)(()=>{
        setDraft((d)=>$3020a8000c84f62a$export$e5de97849a5bcce4((0, $gVWNP.toAsciiDigits)(d)) === value ? d : formatDigits(value || ''));
    }, [
        value
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const commit = (0, $acw62.useCallback)((next)=>{
        if (next && next !== value) onChange?.(next);
    }, [
        value,
        onChange
    ]);
    const close = (0, $acw62.useCallback)((refocus = false)=>{
        setOpen(false);
        if (refocus) inputRef.current?.focus({
            preventScroll: true
        });
    }, []);
    const openPanel = ()=>{
        if (!disabled) setOpen(true);
    };
    // ── Typing ────────────────────────────────────────────────────────────────
    const handleText = (e)=>{
        let ascii = (0, $gVWNP.toAsciiDigits)(e.target.value).replace(/[^\d:]/g, '');
        if (!ascii.includes(':') && ascii.length === 4) ascii = `${ascii.slice(0, 2)}:${ascii.slice(2)}`;
        ascii = ascii.slice(0, 5);
        setDraft(formatDigits(ascii));
        const complete = $3020a8000c84f62a$export$e5de97849a5bcce4(ascii);
        if (complete) commit(complete);
    };
    const settleDraft = ()=>{
        const parsed = $3020a8000c84f62a$export$6a574025f5dbade5(draft);
        if (parsed) {
            commit(parsed);
            setDraft(formatDigits(parsed));
        } else setDraft(formatDigits(value || ''));
    };
    const handleKey = (e)=>{
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            setOpen(true);
            requestAnimationFrame(()=>panelRef.current?.querySelector('[role="listbox"]')?.focus());
        } else if (e.key === 'Escape' && open) {
            e.stopPropagation();
            close();
        } else if (e.key === 'Enter') {
            e.preventDefault();
            settleDraft();
            close();
        }
    };
    // Close when focus leaves both the field and the panel (Tab onward).
    const handleBlurWithin = (e)=>{
        const next = e.relatedTarget;
        if (next && (wrapRef.current?.contains(next) || panelRef.current?.contains(next))) return;
        setFocused(false);
        settleDraft();
        if (!isMobile) setOpen(false);
    };
    const display = focused ? draft : formatDigits(value || '');
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        ref: wrapRef,
        style: {
            position: 'relative',
            width: width,
            maxWidth: maxWidth,
            minWidth: 0
        },
        onBlur: handleBlurWithin,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                ref: inputRef,
                type: "text",
                dir: "ltr",
                inputMode: isMobile ? 'none' : 'numeric',
                readOnly: isMobile,
                autoComplete: "off",
                role: "combobox",
                "aria-label": label,
                "aria-haspopup": "dialog",
                "aria-expanded": open,
                "aria-controls": open ? panelId : undefined,
                "aria-invalid": invalid || undefined,
                "aria-describedby": describedBy,
                placeholder: t('common.time.picker.placeholder'),
                value: display,
                disabled: disabled,
                onFocus: (e)=>{
                    setFocused(true);
                    setDraft(formatDigits(value || ''));
                    e.target.select?.();
                },
                onMouseDown: ()=>{
                    if (!open) openPanel();
                },
                onChange: handleText,
                onKeyDown: handleKey,
                style: {
                    height: isMobile ? 44 : 40,
                    width: '100%',
                    boxSizing: 'border-box',
                    padding: '0 10px 0 32px',
                    border: `1.5px solid ${invalid ? (0, $jTCZr.C).red : open ? (0, $jTCZr.C).navy : (0, $jTCZr.C).border}`,
                    borderRadius: 10,
                    outline: 'none',
                    boxShadow: open && !invalid ? `0 0 0 3px color-mix(in srgb, var(--p-navy) 14%, transparent)` : 'none',
                    fontFamily: 'inherit',
                    fontSize: isMobile ? '1rem' : '0.84375rem',
                    fontVariantNumeric: 'tabular-nums',
                    color: (0, $jTCZr.C).textPrimary,
                    background: disabled ? (0, $jTCZr.C).bg : '#fff',
                    cursor: disabled ? 'not-allowed' : 'pointer',
                    textAlign: 'center',
                    unicodeBidi: 'isolate',
                    transition: 'border-color .15s, box-shadow .15s'
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kMJsW.default), {
                size: 15,
                "aria-hidden": true,
                style: {
                    position: 'absolute',
                    left: 10,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    color: open ? (0, $jTCZr.C).navy : (0, $jTCZr.C).textMuted,
                    pointerEvents: 'none'
                }
            }),
            open && !isMobile && /*#__PURE__*/ (0, $ayMG0.jsx)($3020a8000c84f62a$var$Popover, {
                anchorRef: wrapRef,
                panelRef: panelRef,
                onDismiss: ()=>close(),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($3020a8000c84f62a$var$TimePanel, {
                    id: panelId,
                    label: label,
                    value: value,
                    hourCycle: hourCycle,
                    minuteStep: minuteStep,
                    suggestions: suggestions,
                    onPick: (next, done)=>{
                        commit(next);
                        setDraft(formatDigits(next));
                        if (done) close(true);
                    },
                    onClose: ()=>close(true)
                })
            }),
            isMobile && /*#__PURE__*/ (0, $ayMG0.jsx)($3020a8000c84f62a$var$MobileTimeSheet, {
                open: open,
                id: panelId,
                panelRef: panelRef,
                label: label,
                value: value,
                hourCycle: hourCycle,
                minuteStep: minuteStep,
                suggestions: suggestions,
                onCancel: ()=>close(),
                onDone: (next)=>{
                    commit(next);
                    close();
                }
            })
        ]
    });
}
/** Portaled, flips above the field when there is no room below. */ function $3020a8000c84f62a$var$Popover({ anchorRef: anchorRef, panelRef: panelRef, onDismiss: onDismiss, children: children }) {
    const [pos, setPos] = (0, $acw62.useState)(null);
    const place = (0, $acw62.useCallback)(()=>{
        const anchor = anchorRef.current;
        const panel = panelRef.current;
        if (!anchor) return;
        const r = anchor.getBoundingClientRect();
        const w = panel?.offsetWidth || 240;
        const h = panel?.offsetHeight || 300;
        const below = window.innerHeight - r.bottom;
        const top = below < h + $3020a8000c84f62a$var$EDGE && r.top > h + $3020a8000c84f62a$var$EDGE ? r.top - h - 6 : r.bottom + 6;
        // Aligned to the field's inline START: its right edge under RTL.
        const rtl = document.documentElement.getAttribute('dir') !== 'ltr';
        let left = rtl ? r.right - w : r.left;
        left = Math.max($3020a8000c84f62a$var$EDGE, Math.min(left, window.innerWidth - w - $3020a8000c84f62a$var$EDGE));
        setPos({
            top: top,
            left: left
        });
    }, [
        anchorRef,
        panelRef
    ]);
    (0, $acw62.useLayoutEffect)(()=>{
        place();
    }, [
        place
    ]);
    (0, $acw62.useEffect)(()=>{
        const onDown = (e)=>{
            if (panelRef.current?.contains(e.target) || anchorRef.current?.contains(e.target)) return;
            onDismiss();
        };
        document.addEventListener('mousedown', onDown);
        window.addEventListener('scroll', place, true);
        window.addEventListener('resize', place);
        return ()=>{
            document.removeEventListener('mousedown', onDown);
            window.removeEventListener('scroll', place, true);
            window.removeEventListener('resize', place);
        };
    }, [
        anchorRef,
        panelRef,
        onDismiss,
        place
    ]);
    return /*#__PURE__*/ (0, $1u0KT.createPortal)(/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        ref: panelRef,
        // Mouse picks keep focus in the field, so typing still works after a click.
        onMouseDown: (e)=>{
            if (!e.target.closest('[role="listbox"]')) e.preventDefault();
        },
        style: {
            position: 'fixed',
            top: pos?.top ?? -9999,
            left: pos?.left ?? -9999,
            zIndex: $3020a8000c84f62a$var$Z_POPOVER,
            background: '#fff',
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: 12,
            boxShadow: '0 8px 24px rgba(0,0,0,.12)',
            padding: 10,
            visibility: pos ? 'visible' : 'hidden'
        },
        children: children
    }), document.body);
}
function $3020a8000c84f62a$var$MobileTimeSheet({ open: open, id: id, panelRef: panelRef, label: label, value: value, hourCycle: hourCycle, minuteStep: minuteStep, suggestions: suggestions, onCancel: onCancel, onDone: onDone }) {
    const { t: t } = (0, $e1LEq.default)();
    const [draft, setDraft] = (0, $acw62.useState)(value || '08:00');
    (0, $acw62.useEffect)(()=>{
        if (open) setDraft($3020a8000c84f62a$export$e5de97849a5bcce4(value) || '08:00');
    }, [
        open,
        value
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cZOyb.default), {
        open: open,
        onClose: onCancel,
        title: label,
        closeLabel: t('common.actions.close'),
        footer: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            style: {
                display: 'flex',
                gap: 8
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                    style: {
                        flex: 1
                    },
                    onClick: ()=>onDone(draft),
                    children: t('common.actions.confirm')
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                    variant: "outline",
                    style: {
                        flex: 1
                    },
                    onClick: onCancel,
                    children: t('common.actions.cancel')
                })
            ]
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            ref: panelRef,
            style: {
                display: 'flex',
                justifyContent: 'center',
                paddingBlock: 8
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($3020a8000c84f62a$var$TimePanel, {
                id: id,
                label: label,
                value: draft,
                hourCycle: hourCycle,
                minuteStep: minuteStep,
                suggestions: suggestions,
                rowHeight: $3020a8000c84f62a$var$ROW_MOBILE,
                onPick: (next)=>setDraft(next)
            })
        })
    });
}
/**
 * The picking surface, shared by both overlays: a readout, the columns, and
 * the suggestion chips. `onPick(next, done)` — `done` is true for a gesture
 * that finishes the choice (a minute, a chip, Enter).
 */ function $3020a8000c84f62a$var$TimePanel({ id: id, label: label, value: value, hourCycle: hourCycle, minuteStep: minuteStep, suggestions: suggestions, rowHeight: rowHeight = $3020a8000c84f62a$var$ROW, onPick: onPick, onClose: onClose }) {
    const { t: t, formatDigits: formatDigits } = (0, $e1LEq.default)();
    const cur = $3020a8000c84f62a$var$splitTime(value);
    const h24 = cur?.h ?? null;
    const min = cur?.m ?? null;
    const twelve = hourCycle === 12;
    const pm = h24 != null && h24 >= 12;
    const hours = twelve ? [
        12,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11
    ] : Array.from({
        length: 24
    }, (_, i)=>i);
    const minutes = Array.from({
        length: Math.ceil(60 / minuteStep)
    }, (_, i)=>i * minuteStep);
    if (min != null && !minutes.includes(min)) {
        minutes.push(min);
        minutes.sort((a, b)=>a - b);
    }
    const shownHour = h24 == null ? null : twelve ? h24 % 12 || 12 : h24;
    const build = (h, m)=>`${$3020a8000c84f62a$var$pad(h)}:${$3020a8000c84f62a$var$pad(m)}`;
    const toH24 = (h12, isPm)=>h12 % 12 + (isPm ? 12 : 0);
    const pickHour = (h)=>onPick(build(twelve ? toH24(h, pm) : h, min ?? 0), false);
    const pickMinute = (m, done = true)=>onPick(build(h24 ?? 8, m), done);
    const pickPeriod = (isPm)=>onPick(build(toH24(shownHour ?? 8, isPm), min ?? 0), false);
    const columnsRef = (0, $acw62.useRef)(null);
    const focusColumn = (i)=>{
        const cols = columnsRef.current?.querySelectorAll('[role="listbox"]');
        if (cols?.[i]) cols[i].focus();
    };
    const periodLabel = (isPm)=>isPm ? t('common.time.picker.pm') : t('common.time.picker.am');
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        id: id,
        role: "dialog",
        "aria-label": label,
        // Escape closes THIS panel only — the drawer behind it listens too.
        onKeyDown: (e)=>{
            if (e.key === 'Escape' && onClose) {
                e.preventDefault();
                e.stopPropagation();
                onClose();
            }
        },
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 10
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                dir: "ltr",
                "aria-live": "polite",
                style: {
                    textAlign: 'center',
                    fontSize: '1.375rem',
                    fontWeight: 700,
                    color: value ? (0, $jTCZr.C).navy : (0, $jTCZr.C).textMuted,
                    fontVariantNumeric: 'tabular-nums',
                    letterSpacing: 1,
                    unicodeBidi: 'isolate'
                },
                children: [
                    value ? formatDigits(twelve ? `${$3020a8000c84f62a$var$pad(shownHour)}:${$3020a8000c84f62a$var$pad(min)}` : value) : t('common.time.picker.placeholder'),
                    value && twelve && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            fontSize: '0.8125rem',
                            marginInlineStart: 6
                        },
                        children: periodLabel(pm)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                ref: columnsRef,
                dir: "ltr",
                style: {
                    display: 'flex',
                    alignItems: 'stretch',
                    gap: 6,
                    justifyContent: 'center'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($3020a8000c84f62a$var$Column, {
                        label: t('common.time.picker.hours'),
                        items: hours,
                        selected: shownHour,
                        rowHeight: rowHeight,
                        render: (h)=>formatDigits($3020a8000c84f62a$var$pad(h)),
                        onSelect: (h)=>pickHour(h),
                        onEnter: ()=>focusColumn(1),
                        onNeighbour: (dir)=>focusColumn(dir > 0 ? 1 : 0)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        "aria-hidden": true,
                        style: {
                            alignSelf: 'center',
                            fontWeight: 700,
                            color: (0, $jTCZr.C).textMuted
                        },
                        children: ":"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($3020a8000c84f62a$var$Column, {
                        label: t('common.time.picker.minutes'),
                        items: minutes,
                        selected: min,
                        rowHeight: rowHeight,
                        render: (m)=>formatDigits($3020a8000c84f62a$var$pad(m)),
                        onSelect: (m, viaKeyboard)=>pickMinute(m, !viaKeyboard),
                        onEnter: ()=>twelve ? focusColumn(2) : onClose?.(),
                        onNeighbour: (dir)=>focusColumn(dir > 0 ? twelve ? 2 : 1 : 0)
                    }),
                    twelve && /*#__PURE__*/ (0, $ayMG0.jsx)($3020a8000c84f62a$var$Column, {
                        label: t('common.time.picker.period'),
                        items: [
                            false,
                            true
                        ],
                        selected: h24 == null ? null : pm,
                        rowHeight: rowHeight,
                        render: (isPm)=>periodLabel(isPm),
                        onSelect: (isPm)=>pickPeriod(isPm),
                        onEnter: ()=>onClose?.(),
                        onNeighbour: (dir)=>focusColumn(dir > 0 ? 2 : 1)
                    })
                ]
            }),
            suggestions.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 6,
                    borderTop: `1px solid ${(0, $jTCZr.C).border}`,
                    paddingTop: 8
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            fontSize: '0.71875rem',
                            color: (0, $jTCZr.C).textMuted
                        },
                        children: t('common.time.picker.suggestions')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        dir: "ltr",
                        style: {
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: 6,
                            maxWidth: twelve ? 260 : 200
                        },
                        children: suggestions.map((s)=>{
                            const active = s === value;
                            return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                "aria-pressed": active,
                                onClick: ()=>onPick(s, true),
                                style: {
                                    height: 30,
                                    padding: '0 10px',
                                    borderRadius: 999,
                                    cursor: 'pointer',
                                    border: `1px solid ${active ? (0, $jTCZr.C).navy : (0, $jTCZr.C).border}`,
                                    background: active ? 'color-mix(in srgb, var(--p-navy) 8%, transparent)' : '#fff',
                                    color: active ? (0, $jTCZr.C).navy : (0, $jTCZr.C).textSecondary,
                                    fontFamily: 'inherit',
                                    fontSize: '0.78125rem',
                                    fontVariantNumeric: 'tabular-nums'
                                },
                                children: formatDigits(s)
                            }, s);
                        })
                    })
                ]
            })
        ]
    });
}
/**
 * One scrolling column. A `listbox` with `aria-activedescendant`, so the column
 * is a single Tab stop and ↑/↓/Home/End/PageUp/PageDown move the selection as a
 * native spinner would; ←/→ step to the neighbouring column, Enter moves on.
 */ function $3020a8000c84f62a$var$Column({ label: label, items: items, selected: selected, rowHeight: rowHeight, render: render, onSelect: onSelect, onEnter: onEnter, onNeighbour: onNeighbour }) {
    const baseId = (0, $acw62.useId)();
    const listRef = (0, $acw62.useRef)(null);
    const index = items.findIndex((v)=>v === selected);
    // Centre the selection — instantly on open, smoothly as it changes.
    const first = (0, $acw62.useRef)(true);
    (0, $acw62.useLayoutEffect)(()=>{
        const el = listRef.current;
        if (!el || index < 0) return;
        const top = index * rowHeight - (el.clientHeight - rowHeight) / 2;
        if (first.current || typeof el.scrollTo !== 'function') el.scrollTop = Math.max(0, top);
        else el.scrollTo({
            top: Math.max(0, top),
            behavior: 'smooth'
        });
        first.current = false;
    }, [
        index,
        rowHeight
    ]);
    const move = (to)=>{
        const next = (to + items.length) % items.length;
        onSelect(items[next], true);
    };
    const onKeyDown = (e)=>{
        const at = index < 0 ? 0 : index;
        const keys = {
            ArrowDown: ()=>move(index < 0 ? 0 : at + 1),
            ArrowUp: ()=>move(index < 0 ? 0 : at - 1),
            PageDown: ()=>move(Math.min(items.length - 1, at + 4)),
            PageUp: ()=>move(Math.max(0, at - 4)),
            Home: ()=>move(0),
            End: ()=>move(items.length - 1),
            ArrowRight: ()=>onNeighbour(1),
            ArrowLeft: ()=>onNeighbour(-1),
            Enter: ()=>onEnter?.()
        };
        if (keys[e.key]) {
            e.preventDefault();
            e.stopPropagation();
            keys[e.key]();
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        ref: listRef,
        role: "listbox",
        tabIndex: 0,
        "aria-label": label,
        "aria-activedescendant": index >= 0 ? `${baseId}-${index}` : undefined,
        onKeyDown: onKeyDown,
        style: {
            width: 64,
            height: rowHeight * $3020a8000c84f62a$var$VISIBLE_ROWS,
            overflowY: 'auto',
            scrollbarWidth: 'none',
            scrollSnapType: 'y proximity',
            borderRadius: 10,
            background: (0, $jTCZr.C).bg,
            outline: 'none',
            paddingBlock: 2,
            boxSizing: 'border-box'
        },
        onFocus: (e)=>{
            e.currentTarget.style.boxShadow = `0 0 0 2px ${(0, $jTCZr.C).navy}`;
        },
        onBlur: (e)=>{
            e.currentTarget.style.boxShadow = 'none';
        },
        children: items.map((item, i)=>{
            const active = i === index;
            return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                id: `${baseId}-${i}`,
                role: "option",
                "aria-selected": active,
                onClick: ()=>onSelect(item, false),
                style: {
                    height: rowHeight - 4,
                    margin: '2px 4px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: 8,
                    cursor: 'pointer',
                    scrollSnapAlign: 'center',
                    userSelect: 'none',
                    fontSize: rowHeight > $3020a8000c84f62a$var$ROW ? '1rem' : '0.875rem',
                    fontVariantNumeric: 'tabular-nums',
                    fontWeight: active ? 700 : 500,
                    background: active ? (0, $jTCZr.C).navy : 'transparent',
                    color: active ? '#fff' : (0, $jTCZr.C).textPrimary,
                    transition: 'background .12s, color .12s'
                },
                children: render(item)
            }, String(item));
        })
    });
}

});

parcelRegister("ckJuK", function(module, exports) {

$parcel$export(module.exports, "KIND", () => $8faaa4a5d53fd019$export$79d3df7dce95d7c4);
$parcel$export(module.exports, "PERSON_STATUS", () => $8faaa4a5d53fd019$export$8889056090ddcb85);
$parcel$export(module.exports, "ISSUE", () => $8faaa4a5d53fd019$export$76a449e52fa0e1e8);
$parcel$export(module.exports, "SORT", () => $8faaa4a5d53fd019$export$1e652a44bda81b79);
$parcel$export(module.exports, "normText", () => $8faaa4a5d53fd019$export$a83e063a54f70454);
$parcel$export(module.exports, "isJoinRequest", () => $8faaa4a5d53fd019$export$eff7ed70701c36df);
$parcel$export(module.exports, "issuesFor", () => $8faaa4a5d53fd019$export$4f678c7512090ba3);
$parcel$export(module.exports, "buildPersonnel", () => $8faaa4a5d53fd019$export$c72140494cc8d8e6);
$parcel$export(module.exports, "filterPersonnel", () => $8faaa4a5d53fd019$export$d75c16082b3a940e);
$parcel$export(module.exports, "sortPersonnel", () => $8faaa4a5d53fd019$export$5667060824c0b2c0);
$parcel$export(module.exports, "personnelCounts", () => $8faaa4a5d53fd019$export$b1e9e6f8866e4947);
$parcel$export(module.exports, "resolvePersonParam", () => $8faaa4a5d53fd019$export$848b6c52544315a5);
$parcel$export(module.exports, "counterpartOf", () => $8faaa4a5d53fd019$export$3f7a6295b043a40d);
$parcel$export(module.exports, "personGuards", () => $8faaa4a5d53fd019$export$2861512a1b166a52);
$parcel$export(module.exports, "usesDoctorTitle", () => $8faaa4a5d53fd019$export$340c49b73afd4274);
$parcel$export(module.exports, "PRESENCE_DAYS", () => $8faaa4a5d53fd019$export$de940f442aaaeea1);
$parcel$export(module.exports, "normalizeServiceIds", () => $8faaa4a5d53fd019$export$e0c88334a06d6a1e);
$parcel$export(module.exports, "toPresenceInput", () => $8faaa4a5d53fd019$export$ac6713c498c0a480);
$parcel$export(module.exports, "presenceProblems", () => $8faaa4a5d53fd019$export$b20af8661428de13);
$parcel$export(module.exports, "presenceIssues", () => $8faaa4a5d53fd019$export$d2661cf6e862f083);
$parcel$export(module.exports, "PRESENCE_ISSUE", () => $8faaa4a5d53fd019$export$bced19520afc6320);
$parcel$export(module.exports, "dropUnknownServices", () => $8faaa4a5d53fd019$export$57a2132702e8192f);
$parcel$export(module.exports, "splitPresenceRange", () => $8faaa4a5d53fd019$export$8972db330ea8b372);
$parcel$export(module.exports, "presenceReadiness", () => $8faaa4a5d53fd019$export$eb331d9fca53878);
$parcel$export(module.exports, "nextPresenceRange", () => $8faaa4a5d53fd019$export$6207f365fc270346);
$parcel$export(module.exports, "copyPresenceDay", () => $8faaa4a5d53fd019$export$e8eacbb2510af96b);
$parcel$export(module.exports, "samePresence", () => $8faaa4a5d53fd019$export$d4fd4dcc60abb741);
/**
 * Unified personnel — the pure layer.
 *
 * docs/UNIFIED_PERSONNEL_MANAGEMENT.md is the spec. The page shows ONE
 * population: every Person with a membership in this clinic, whatever kind of
 * membership that is. Two very different wire shapes feed it —
 *
 *   practitioner → `listClinicDoctors` (doctorpreference link + accounting
 *                  contract + scheduling presences, joined by the clinic BFF)
 *   staff        → `listStaffMembers`  (clinicmanagement + Keycloak)
 *
 * — and everything below exists to turn those two into one row shape so the
 * table, the search box and the filters never branch on kind. Kind stays a
 * DATA field on the row (§7.7 of the spec: a future third kind must be a new
 * badge value, not a new code path).
 *
 * Deliberately free of React and of `t`: this is what the unit tests drive, and
 * display fallbacks («دکتر ۱۲۳۴۵۶») belong to the component that has the
 * catalogue. A row therefore carries `displayName: ''` when the name has not
 * loaded yet rather than a baked-in placeholder.
 *
 * The one import is the kit's digit fold. Numerals are a PLATFORM rule — the same
 * three keyboards feed every screen — and this module has no business keeping its
 * own table of them; see `normText`.
 */ parcelRequire("5N0ZI");
var $5AX1S = parcelRequire("5AX1S");
const $8faaa4a5d53fd019$export$79d3df7dce95d7c4 = {
    PRACTITIONER: 'practitioner',
    STAFF: 'staff'
};
const $8faaa4a5d53fd019$export$8889056090ddcb85 = {
    ACTIVE: 'ACTIVE',
    PENDING: 'PENDING',
    SUSPENDED: 'SUSPENDED',
    // Not the same as SUSPENDED, and the difference is whose decision it was:
    // suspended means the clinic took access away, declined means the PERSON said
    // no. Collapsing them tells an admin their colleague was suspended by someone
    // at the clinic when in fact the invitation was turned down.
    DECLINED: 'DECLINED'
};
/** Pending first — it is the only status with work attached to it (spec §5.1). */ const $8faaa4a5d53fd019$var$STATUS_ORDER = {
    [$8faaa4a5d53fd019$export$8889056090ddcb85.PENDING]: 0,
    [$8faaa4a5d53fd019$export$8889056090ddcb85.ACTIVE]: 1,
    [$8faaa4a5d53fd019$export$8889056090ddcb85.SUSPENDED]: 2,
    // Last: nothing is owed to a declined invitation, but it must still be
    // findable — an admin who cannot see it re-invites into the same refusal.
    [$8faaa4a5d53fd019$export$8889056090ddcb85.DECLINED]: 3
};
const $8faaa4a5d53fd019$export$76a449e52fa0e1e8 = {
    NO_SHIFTS: 'NO_SHIFTS',
    NO_SERVICES: 'NO_SERVICES',
    NO_ROLES: 'NO_ROLES',
    SYNC_ERROR: 'SYNC_ERROR',
    PROFILE_UNAVAILABLE: 'PROFILE_UNAVAILABLE'
};
/**
 * clinic_staff.status → the page's shared vocabulary.
 *
 * REJECTED IS HERE NOW, and it was not before because the state was unreachable:
 * `rejectClinicInvitation` wrote `rejected` to a service that rejected the word,
 * so no roster ever carried one. It does now, `listStaffMembers` does NOT filter
 * it out, and an unmapped status fell through `statusLabel` to «معلق» — telling
 * an admin the clinic had suspended a colleague who had in fact declined.
 *
 * Keeping the row visible is the documented decision (`rejectClinicInvitation`
 * in the clinic BFF): a rejection is a status and never a delete, precisely so
 * «not answered yet» and «declined» do not look identical on this page.
 */ const $8faaa4a5d53fd019$var$STAFF_STATUS_MAP = {
    SUSPENDED: $8faaa4a5d53fd019$export$8889056090ddcb85.SUSPENDED,
    INVITED: $8faaa4a5d53fd019$export$8889056090ddcb85.PENDING,
    ACTIVE: $8faaa4a5d53fd019$export$8889056090ddcb85.ACTIVE,
    REJECTED: $8faaa4a5d53fd019$export$8889056090ddcb85.DECLINED
};
const $8faaa4a5d53fd019$export$1e652a44bda81b79 = {
    STATUS: 'status',
    NAME: 'name',
    JOINED: 'joined'
};
const $8faaa4a5d53fd019$export$a83e063a54f70454 = (value)=>{
    let out = (0, $5AX1S).foldDigits(String(value ?? ''));
    // i18n-exempt: the CHARACTERS are being folded, not copy — an Arabic keyboard
    // and a Persian one produce different codepoints for the same letter, and a
    // search or a typed confirmation must not care which one was used.
    out = out.replace(/ي/g, "\u06CC").replace(/ك/g, "\u06A9");
    // ZWNJ and runs of whitespace both collapse: «علی‌رضا» and «علی رضا» are one name.
    return out.replace(/[‌\s]+/g, ' ').trim().toLowerCase();
};
const $8faaa4a5d53fd019$export$fe09c8f8527cef2a = (link)=>{
    const info = link.info || null;
    const status = link.status === 'accepted' ? $8faaa4a5d53fd019$export$8889056090ddcb85.ACTIVE : $8faaa4a5d53fd019$export$8889056090ddcb85.PENDING;
    return {
        key: `p:${link.id}`,
        kind: $8faaa4a5d53fd019$export$79d3df7dce95d7c4.PRACTITIONER,
        id: link.id,
        personId: link.doctorId || '',
        displayName: (info?.name || link.doctorName || '').trim(),
        phone: info?.phone || '',
        status: status,
        joinedAt: link.joinedAt || '',
        registeredVia: link.registeredVia || '',
        syncStatus: null,
        // Identity (read-only on this page — owned by the person, not the clinic)
        specialty: info?.specialty || '',
        medicalCode: info?.medicalCode || '',
        bio: info?.bio || '',
        email: info?.email || '',
        nationalId: info?.nationalId || '',
        infoLoaded: !!info,
        // Membership (clinic-managed)
        visitDurationMinutes: link.visitDurationMinutes ?? null,
        // تأمین's SIAM id for this practitioner here (e-prescribing only).
        siamId: link.siamId || '',
        // The clinic's grant to book from the doctor app. false (default) = books
        // directly; true = their bookings wait in «درخواست‌های نوبت».
        bookingRequiresApproval: !!link.bookingRequiresApproval,
        // Owned elsewhere, mirrored read-only: accounting / scheduling. `serviceCount`
        // null means «could not be read», which is not «provides nothing».
        serviceCount: link.serviceCount ?? null,
        presences: link.presences || [],
        // Staff-only fields, present so callers never have to check kind first
        tier: null,
        roles: [],
        extraPermissions: [],
        effectivePermissions: [],
        raw: link
    };
};
const $8faaa4a5d53fd019$export$87f0945aa3a602b0 = (member)=>({
        key: `s:${member.id}`,
        kind: $8faaa4a5d53fd019$export$79d3df7dce95d7c4.STAFF,
        id: member.id,
        personId: member.userId || '',
        displayName: (member.displayName || '').trim(),
        phone: member.phone || '',
        // INVITED is a real staff status now, not just a practitioner one: adding a
        // person writes the row `invited` and grants nothing until they accept
        // (docs/CLINIC_MULTI_CLINIC_UX_REV2.md §6.7). It folds onto PENDING so the one
        // «وضعیت» filter, the pending-first sort and the KPI keep working unchanged —
        // the page's own rule is that a new state is a value, never a new code path.
        status: $8faaa4a5d53fd019$var$STAFF_STATUS_MAP[member.status] || $8faaa4a5d53fd019$export$8889056090ddcb85.ACTIVE,
        joinedAt: member.joinedAt || '',
        registeredVia: '',
        syncStatus: member.syncStatus || null,
        specialty: '',
        medicalCode: '',
        bio: '',
        email: '',
        nationalId: '',
        infoLoaded: true,
        visitDurationMinutes: null,
        siamId: '',
        bookingRequiresApproval: false,
        serviceCount: null,
        // The staff member's own weekly shifts (PM-0468 §2.2) — the same rows a
        // doctor has, keyed on the person. Empty = none declared.
        presences: member.presences || [],
        tier: member.tier || 'MEMBER',
        roles: member.roles || [],
        extraPermissions: member.extraPermissions || [],
        effectivePermissions: member.effectivePermissions || [],
        raw: member
    });
const $8faaa4a5d53fd019$export$5e794c88c325abf8 = (request)=>({
        key: `r:${request.id}`,
        kind: $8faaa4a5d53fd019$export$79d3df7dce95d7c4.STAFF,
        id: request.id,
        requestId: request.id,
        personId: request.userId || '',
        displayName: (request.displayName || '').trim(),
        phone: request.phone || '',
        status: $8faaa4a5d53fd019$export$8889056090ddcb85.PENDING,
        joinedAt: '',
        requestedAt: request.requestedAt || '',
        registeredVia: 'qr_invitation',
        syncStatus: null,
        specialty: '',
        medicalCode: '',
        bio: '',
        email: '',
        nationalId: '',
        infoLoaded: true,
        visitDurationMinutes: null,
        siamId: '',
        bookingRequiresApproval: false,
        serviceCount: null,
        presences: [],
        tier: 'MEMBER',
        roles: [],
        extraPermissions: [],
        effectivePermissions: [],
        raw: request
    });
const $8faaa4a5d53fd019$export$eff7ed70701c36df = (person)=>!!person?.requestId;
const $8faaa4a5d53fd019$export$4f678c7512090ba3 = (person)=>{
    if (!person || person.status !== $8faaa4a5d53fd019$export$8889056090ddcb85.ACTIVE) return [];
    const out = [];
    if (person.kind === $8faaa4a5d53fd019$export$79d3df7dce95d7c4.PRACTITIONER) {
        if ((person.presences || []).length === 0) out.push($8faaa4a5d53fd019$export$76a449e52fa0e1e8.NO_SHIFTS);
        if (person.serviceCount === 0) out.push($8faaa4a5d53fd019$export$76a449e52fa0e1e8.NO_SERVICES);
        if (!person.infoLoaded) out.push($8faaa4a5d53fd019$export$76a449e52fa0e1e8.PROFILE_UNAVAILABLE);
    } else {
        if (person.tier === 'MEMBER' && (person.roles || []).length === 0 && (person.extraPermissions || []).length === 0) out.push($8faaa4a5d53fd019$export$76a449e52fa0e1e8.NO_ROLES);
        if (person.syncStatus === 'ERROR') out.push($8faaa4a5d53fd019$export$76a449e52fa0e1e8.SYNC_ERROR);
    }
    return out;
};
const $8faaa4a5d53fd019$export$230e945f678726f4 = (person)=>$8faaa4a5d53fd019$export$4f678c7512090ba3(person).filter((i)=>i !== $8faaa4a5d53fd019$export$76a449e52fa0e1e8.PROFILE_UNAVAILABLE);
/** Whether a staff row carries clinic-wide authority (admin tier, or the founder). */ const $8faaa4a5d53fd019$var$holdsAdminPower = (person)=>person?.kind === $8faaa4a5d53fd019$export$79d3df7dce95d7c4.STAFF && (person.tier === 'ADMIN' || person.tier === 'OWNER' || person.isFounder === true);
const $8faaa4a5d53fd019$export$b0c1eb3f442ccf87 = (people, person)=>{
    if (!$8faaa4a5d53fd019$var$holdsAdminPower(person) || person.status !== $8faaa4a5d53fd019$export$8889056090ddcb85.ACTIVE) return false;
    const admins = (people || []).filter((p)=>$8faaa4a5d53fd019$var$holdsAdminPower(p) && p.status === $8faaa4a5d53fd019$export$8889056090ddcb85.ACTIVE && !$8faaa4a5d53fd019$export$eff7ed70701c36df(p));
    return admins.length <= 1 && admins.some((p)=>p.key === person.key);
};
const $8faaa4a5d53fd019$export$c72140494cc8d8e6 = ({ links: links = [], staff: staff = [], requests: requests = [], canViewPractitioners: canViewPractitioners = true, canViewStaff: canViewStaff = true, viewerSub: viewerSub = '', founderSub: founderSub = '' })=>{
    const rows = [
        ...canViewPractitioners ? links.map($8faaa4a5d53fd019$export$fe09c8f8527cef2a) : [],
        ...canViewStaff ? staff.map($8faaa4a5d53fd019$export$87f0945aa3a602b0) : [],
        ...canViewStaff ? requests.map($8faaa4a5d53fd019$export$5e794c88c325abf8) : []
    ].map((p)=>({
            ...p,
            isSelf: !!viewerSub && p.personId === viewerSub,
            // The founder is identified by `clinics.keycloak_user_id`, not by tier: the
            // BFF stores them as `clinic_admin` and never assigns a `clinic_owner`
            // tier, so a tier check alone would let the panel demote its own owner.
            // The tier check stays as a fallback for a clinic whose data predates that.
            isFounder: p.kind === $8faaa4a5d53fd019$export$79d3df7dce95d7c4.STAFF && (!!founderSub && p.personId === founderSub || p.tier === 'OWNER')
        }));
    // Two passes: `isLastAdmin` is a fact about the whole list, so it cannot be
    // decided while the list is still being built.
    return rows.map((p)=>({
            ...p,
            isLastAdmin: $8faaa4a5d53fd019$export$b0c1eb3f442ccf87(rows, p),
            issues: $8faaa4a5d53fd019$export$4f678c7512090ba3(p)
        }));
};
const $8faaa4a5d53fd019$export$d75c16082b3a940e = (people, { kind: kind = 'all', q: q = '', roleId: roleId = '', status: status = '' } = {})=>{
    const needle = $8faaa4a5d53fd019$export$a83e063a54f70454(q);
    return people.filter((p)=>{
        if (kind !== 'all' && p.kind !== kind) return false;
        if (status && p.status !== status) return false;
        if (roleId) {
            if (p.kind !== $8faaa4a5d53fd019$export$79d3df7dce95d7c4.STAFF) return false;
            if (!(p.roles || []).some((r)=>r.id === roleId)) return false;
        }
        if (needle) {
            // Role names are searchable too: «حسابدار» in the search box is a
            // reasonable way to ask "who are the accountants", and answering it with
            // nothing while a «نقش» filter sits three controls away is a worse
            // answer than the obvious one.
            const haystack = [
                p.displayName,
                p.phone,
                p.medicalCode,
                p.specialty,
                ...(p.roles || []).map((r)=>r.nameFa)
            ].filter(Boolean).map($8faaa4a5d53fd019$export$a83e063a54f70454).join(' ');
            if (!haystack.includes(needle)) return false;
        }
        return true;
    });
};
const $8faaa4a5d53fd019$export$5667060824c0b2c0 = (people, sort = $8faaa4a5d53fd019$export$1e652a44bda81b79.STATUS)=>{
    // Unnamed rows (a profile still loading, or a link with no profile at all)
    // sort last rather than first, where an empty string would otherwise put them.
    const byName = (a, b)=>{
        if (!a.displayName !== !b.displayName) return a.displayName ? -1 : 1;
        return a.displayName.localeCompare(b.displayName, 'fa');
    };
    const compare = {
        [$8faaa4a5d53fd019$export$1e652a44bda81b79.NAME]: byName,
        // Newest relationship first. A request has no `joinedAt`, so its
        // `requestedAt` stands in — both answer "since when has this row existed".
        // Rows with neither sink to the bottom rather than floating to the top,
        // where an empty string compares greater than every real timestamp.
        [$8faaa4a5d53fd019$export$1e652a44bda81b79.JOINED]: (a, b)=>{
            const at = a.joinedAt || a.requestedAt || '';
            const bt = b.joinedAt || b.requestedAt || '';
            if (!at !== !bt) return at ? -1 : 1;
            if (at !== bt) return at < bt ? 1 : -1;
            return byName(a, b);
        },
        [$8faaa4a5d53fd019$export$1e652a44bda81b79.STATUS]: (a, b)=>{
            const byStatus = ($8faaa4a5d53fd019$var$STATUS_ORDER[a.status] ?? 9) - ($8faaa4a5d53fd019$var$STATUS_ORDER[b.status] ?? 9);
            return byStatus || byName(a, b);
        }
    }[sort] || null;
    return [
        ...people
    ].sort(compare || ((a, b)=>{
        const byStatus = ($8faaa4a5d53fd019$var$STATUS_ORDER[a.status] ?? 9) - ($8faaa4a5d53fd019$var$STATUS_ORDER[b.status] ?? 9);
        return byStatus || byName(a, b);
    }));
};
const $8faaa4a5d53fd019$export$b1e9e6f8866e4947 = (people)=>({
        practitioners: people.filter((p)=>p.kind === $8faaa4a5d53fd019$export$79d3df7dce95d7c4.PRACTITIONER && p.status === $8faaa4a5d53fd019$export$8889056090ddcb85.ACTIVE).length,
        staff: people.filter((p)=>p.kind === $8faaa4a5d53fd019$export$79d3df7dce95d7c4.STAFF && p.status === $8faaa4a5d53fd019$export$8889056090ddcb85.ACTIVE).length,
        pending: people.filter((p)=>p.status === $8faaa4a5d53fd019$export$8889056090ddcb85.PENDING).length,
        suspended: people.filter((p)=>p.status === $8faaa4a5d53fd019$export$8889056090ddcb85.SUSPENDED).length,
        /** Active rows with something a human has to go and fix (§5.4). */ needsAttention: people.filter((p)=>$8faaa4a5d53fd019$export$230e945f678726f4(p).length > 0).length
    });
const $8faaa4a5d53fd019$export$848b6c52544315a5 = (people, { person: person = '', personId: personId = '' } = {})=>{
    if (person && (people || []).some((p)=>p.key === person)) return person;
    if (personId) {
        const matches = (people || []).filter((p)=>p.personId === personId);
        const preferred = matches.find((p)=>p.kind === $8faaa4a5d53fd019$export$79d3df7dce95d7c4.PRACTITIONER) || matches[0];
        if (preferred) return preferred.key;
    }
    return '';
};
const $8faaa4a5d53fd019$export$3f7a6295b043a40d = (people, person)=>{
    if (!person?.personId) return null;
    return (people || []).find((p)=>p.personId === person.personId && p.kind !== person.kind && !$8faaa4a5d53fd019$export$eff7ed70701c36df(p)) || null;
};
const $8faaa4a5d53fd019$export$1607b1f1cb03b8bd = (person, { canManageStaff: canManageStaff, canManagePractitioners: canManagePractitioners })=>{
    if (!person) return false;
    if (person.kind === $8faaa4a5d53fd019$export$79d3df7dce95d7c4.PRACTITIONER) return !!canManagePractitioners;
    if (person.tier === 'OWNER' || person.isFounder) return false;
    return !!canManageStaff;
};
const $8faaa4a5d53fd019$export$2861512a1b166a52 = (person, { canManageStaff: canManageStaff, canManagePractitioners: canManagePractitioners, isAdmin: isAdmin = false } = {})=>{
    const base = {
        granted: false,
        canEdit: false,
        canLifecycle: false,
        editReason: '',
        lifecycleReason: ''
    };
    if (!person) return base;
    // `granted` is the coarse answer — does my grant cover this kind of row at
    // all. It is what decides whether an action area is RENDERED; the two finer
    // flags decide whether the controls in it are live. The distinction matters:
    // a blocked-by-rule button must still appear, disabled and explaining itself,
    // while a button the reader has no grant for is simply absent (§10).
    const granted = $8faaa4a5d53fd019$export$1607b1f1cb03b8bd(person, {
        canManageStaff: canManageStaff,
        canManagePractitioners: canManagePractitioners
    });
    if (!granted) {
        const ownerReason = person.isFounder || person.tier === 'OWNER' ? 'people.drawer.ownerReadOnly' : '';
        return {
            ...base,
            editReason: ownerReason,
            lifecycleReason: ownerReason
        };
    }
    // Editing your own roles is self-escalation unless you are already an admin,
    // in which case there is nothing to escalate to.
    const selfEditBlocked = person.isSelf && !isAdmin;
    // Suspending or removing yourself is blocked for everyone, admin included:
    // it is the one destructive action whose victim cannot undo it.
    const selfLifecycleBlocked = person.isSelf;
    const lastAdminBlocked = person.isLastAdmin === true;
    return {
        granted: true,
        canEdit: !selfEditBlocked,
        canLifecycle: !selfLifecycleBlocked && !lastAdminBlocked,
        editReason: selfEditBlocked ? 'people.drawer.self' : '',
        lifecycleReason: lastAdminBlocked ? 'people.guard.lastAdmin' : selfLifecycleBlocked ? 'people.guard.self' : ''
    };
};
/**
 * Professions that carry the «دکتر» honorific.
 *
 * A clinic's کادر درمان is not all doctors — a physiotherapist, a midwife or a
 * nurse practitioner is booked exactly like a physician but is not «دکتر», and
 * prefixing them all would be wrong in the one direction that reads as
 * disrespect. So the title is DATA: a specialty is matched against these stems,
 * and adding a profession never means touching a component.
 *
 * Matched on the folded form, so «دندانپزشک» and «دندان‌پزشک» both hit, and the
 * Latin stems catch a profile written in English.
 */ // i18n-exempt: these are MATCH STEMS against stored professional data, not copy
// shown to anyone — translating them would break the match they exist to make.
const $8faaa4a5d53fd019$var$DOCTORATE_STEMS = [
    "\u067E\u0632\u0634\u06A9",
    "\u062C\u0631\u0627\u062D",
    "\u062F\u0646\u062F\u0627\u0646\u067E\u0632\u0634\u06A9",
    "\u0631\u0648\u0627\u0646\u067E\u0632\u0634\u06A9",
    "\u062F\u06A9\u062A\u0631",
    'doctor',
    'physician',
    'dentist',
    'surgeon',
    'psychiatrist',
    'gp'
];
/** True when a name already carries a title, so it is never doubled. */ // i18n-exempt: prefixes DETECTED in stored names, not rendered copy.
const $8faaa4a5d53fd019$var$EXISTING_TITLES = [
    "\u062F\u06A9\u062A\u0631",
    "\u062F\u06A9\u062A\u0631\u0627",
    'dr',
    'dr.'
];
const $8faaa4a5d53fd019$export$340c49b73afd4274 = (person)=>{
    if (!person || person.kind !== $8faaa4a5d53fd019$export$79d3df7dce95d7c4.PRACTITIONER) return false;
    const name = $8faaa4a5d53fd019$export$a83e063a54f70454(person.displayName);
    if ($8faaa4a5d53fd019$var$EXISTING_TITLES.some((prefix)=>name.startsWith(`${prefix} `) || name.startsWith(`${prefix}.`))) return false;
    const specialty = $8faaa4a5d53fd019$export$a83e063a54f70454(person.specialty);
    if (!specialty) return false;
    return $8faaa4a5d53fd019$var$DOCTORATE_STEMS.some((stem)=>specialty.includes($8faaa4a5d53fd019$export$a83e063a54f70454(stem)));
};
const $8faaa4a5d53fd019$export$de940f442aaaeea1 = [
    0,
    1,
    2,
    3,
    4,
    5,
    6
];
const $8faaa4a5d53fd019$export$e0c88334a06d6a1e = (ids)=>[
        ...new Set((ids || []).map(String).filter(Boolean))
    ].sort();
const $8faaa4a5d53fd019$export$ac6713c498c0a480 = (slots)=>(slots || []).map((s)=>({
            dayOfWeek: Number(s.dayOfWeek) || 0,
            startTime: s.startTime,
            endTime: s.endTime,
            serviceCatalogIds: $8faaa4a5d53fd019$export$e0c88334a06d6a1e(s.serviceCatalogIds)
        }));
const $8faaa4a5d53fd019$export$a454b6bb2393a649 = (slots)=>[
        ...slots || []
    ].sort((a, b)=>a.dayOfWeek - b.dayOfWeek || String(a.startTime).localeCompare(String(b.startTime)));
const $8faaa4a5d53fd019$export$b20af8661428de13 = (slots)=>Object.keys($8faaa4a5d53fd019$export$d2661cf6e862f083(slots)).map(Number).sort((a, b)=>a - b);
const $8faaa4a5d53fd019$export$bced19520afc6320 = {
    ORDER: 'order',
    OVERLAP: 'overlap',
    UNKNOWN_SERVICE: 'unknown_service'
};
const $8faaa4a5d53fd019$export$a169ae97beb02006 = [
    $8faaa4a5d53fd019$export$bced19520afc6320.ORDER,
    $8faaa4a5d53fd019$export$bced19520afc6320.OVERLAP
];
const $8faaa4a5d53fd019$export$d2661cf6e862f083 = (slots, { performedIds: performedIds = null } = {})=>{
    const list = $8faaa4a5d53fd019$export$ac6713c498c0a480(slots);
    const out = {};
    list.forEach((s, i)=>{
        if (!s.startTime || !s.endTime || s.startTime >= s.endTime) out[i] = $8faaa4a5d53fd019$export$bced19520afc6320.ORDER;
    });
    for(let i = 0; i < list.length; i += 1)for(let j = i + 1; j < list.length; j += 1){
        if (list[i].dayOfWeek !== list[j].dayOfWeek) continue;
        if (list[i].startTime < list[j].endTime && list[j].startTime < list[i].endTime) {
            out[i] = out[i] || $8faaa4a5d53fd019$export$bced19520afc6320.OVERLAP;
            out[j] = out[j] || $8faaa4a5d53fd019$export$bced19520afc6320.OVERLAP;
        }
    }
    if (Array.isArray(performedIds)) {
        const known = new Set(performedIds.map(String));
        list.forEach((s, i)=>{
            if (!out[i] && s.serviceCatalogIds.some((id)=>!known.has(id))) out[i] = $8faaa4a5d53fd019$export$bced19520afc6320.UNKNOWN_SERVICE;
        });
    }
    return out;
};
const $8faaa4a5d53fd019$export$57a2132702e8192f = (slots, performedIds)=>{
    const known = new Set((performedIds || []).map(String));
    let touched = 0;
    const out = $8faaa4a5d53fd019$export$ac6713c498c0a480(slots).map((s)=>{
        const kept = s.serviceCatalogIds.filter((id)=>known.has(id));
        if (kept.length !== s.serviceCatalogIds.length) touched += 1;
        return {
            ...s,
            serviceCatalogIds: kept
        };
    });
    return {
        slots: out,
        touched: touched
    };
};
const $8faaa4a5d53fd019$export$8972db330ea8b372 = (slots, index, at)=>{
    const list = $8faaa4a5d53fd019$export$ac6713c498c0a480(slots);
    const s = list[index];
    if (!s || !at || !(s.startTime < at && at < s.endTime)) return null;
    const first = {
        ...s,
        endTime: at,
        serviceCatalogIds: [
            ...s.serviceCatalogIds
        ]
    };
    const second = {
        ...s,
        startTime: at,
        serviceCatalogIds: [
            ...s.serviceCatalogIds
        ]
    };
    return [
        ...list.slice(0, index),
        first,
        second,
        ...list.slice(index + 1)
    ];
};
const $8faaa4a5d53fd019$export$eb331d9fca53878 = (slots, services)=>{
    const list = $8faaa4a5d53fd019$export$ac6713c498c0a480(slots);
    if (!list.length || !Array.isArray(services)) return [];
    if (list.some((s)=>s.serviceCatalogIds.length === 0)) return [];
    const covered = new Set(list.flatMap((s)=>s.serviceCatalogIds));
    return services.filter((svc)=>!covered.has(String(svc.catalogId)));
};
const $8faaa4a5d53fd019$var$toMinutes = (hhmm)=>{
    const [h, m] = String(hhmm || '').split(':').map(Number);
    return Number.isFinite(h) && Number.isFinite(m) ? h * 60 + m : null;
};
const $8faaa4a5d53fd019$var$toHHMM = (minutes)=>`${String(Math.floor(minutes / 60)).padStart(2, '0')}:${String(minutes % 60).padStart(2, '0')}`;
const $8faaa4a5d53fd019$export$6207f365fc270346 = (slots, dayOfWeek)=>{
    const ends = (slots || []).filter((s)=>Number(s.dayOfWeek) === dayOfWeek).map((s)=>$8faaa4a5d53fd019$var$toMinutes(s.endTime)).filter((m)=>m != null);
    if (ends.length === 0) return {
        dayOfWeek: dayOfWeek,
        startTime: '08:00',
        endTime: '12:00'
    };
    const start = Math.min(Math.max(...ends), 1439);
    return {
        dayOfWeek: dayOfWeek,
        startTime: $8faaa4a5d53fd019$var$toHHMM(start),
        endTime: $8faaa4a5d53fd019$var$toHHMM(Math.min(start + 180, 1439))
    };
};
const $8faaa4a5d53fd019$export$e8eacbb2510af96b = (slots, fromDay, toDays, mode = 'replace')=>{
    const list = $8faaa4a5d53fd019$export$ac6713c498c0a480(slots);
    const targets = new Set((toDays || []).filter((d)=>d !== fromDay));
    const source = $8faaa4a5d53fd019$export$a454b6bb2393a649(list.filter((s)=>s.dayOfWeek === fromDay));
    const kept = mode === 'replace' ? list.filter((s)=>!targets.has(s.dayOfWeek)) : list;
    const copies = [
        ...targets
    ].sort((a, b)=>a - b).flatMap((day)=>source.map((s)=>({
                dayOfWeek: day,
                startTime: s.startTime,
                endTime: s.endTime
            })));
    return [
        ...kept,
        ...copies
    ];
};
const $8faaa4a5d53fd019$export$d4fd4dcc60abb741 = (a, b)=>{
    const key = (s)=>`${s.dayOfWeek}|${s.startTime}|${s.endTime}|${s.serviceCatalogIds.join(',')}`;
    const x = $8faaa4a5d53fd019$export$a454b6bb2393a649($8faaa4a5d53fd019$export$ac6713c498c0a480(a)).map(key);
    const y = $8faaa4a5d53fd019$export$a454b6bb2393a649($8faaa4a5d53fd019$export$ac6713c498c0a480(b)).map(key);
    return x.length === y.length && x.every((v, i)=>v === y[i]);
};

});


parcelRegister("cvIOe", function(module, exports) {

$parcel$export(module.exports, "default", () => $982feeb753afb043$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $kPor2 = parcelRequire("kPor2");
function $982feeb753afb043$export$2e2bcd8739ae039({ value: value, onChange: onChange, disabled: disabled, resetKey: resetKey }) {
    const { t: t } = (0, $e1LEq.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kPor2.default), {
        value: value,
        onChange: onChange,
        disabled: disabled,
        resetKey: resetKey,
        label: t('doctors.fields.visitLengthLong'),
        hint: t('people.drawer.visitDurationHint')
    });
}

});
parcelRegister("kPor2", function(module, exports) {

$parcel$export(module.exports, "SERVICE_DURATION_MIN", () => $9439c9660f719287$export$536a2bd430994f1c);
$parcel$export(module.exports, "SERVICE_DURATION_MAX", () => $9439c9660f719287$export$98b5b4c1a2063705);
$parcel$export(module.exports, "isServiceDuration", () => $9439c9660f719287$export$6796dbb49db924c8);
$parcel$export(module.exports, "default", () => $9439c9660f719287$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $9iIGe = parcelRequire("9iIGe");
var $5Rv3V = parcelRequire("5Rv3V");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");
parcelRequire("52bn2");
var $jTCZr = parcelRequire("jTCZr");

var $2xQve = parcelRequire("2xQve");

var $c2icR = parcelRequire("c2icR");
const $9439c9660f719287$export$536a2bd430994f1c = 5;
const $9439c9660f719287$export$98b5b4c1a2063705 = 480;
const $9439c9660f719287$export$6796dbb49db924c8 = (value)=>{
    const n = Number(value);
    return Number.isInteger(n) && n >= $9439c9660f719287$export$536a2bd430994f1c && n <= $9439c9660f719287$export$98b5b4c1a2063705;
};
function $9439c9660f719287$export$2e2bcd8739ae039({ value: value, onChange: onChange, disabled: disabled, resetKey: resetKey, label: label, hint: hint, outOfRangeText: outOfRangeText, min: min = (0, $c2icR.DURATION_MIN), max: max = (0, $c2icR.DURATION_MAX), testid: testid }) {
    const { t: t, formatNumber: formatNumber } = (0, $e1LEq.default)();
    const raw = value == null ? '' : value;
    const numeric = raw === '' ? null : Number(raw);
    const isPreset = numeric != null && (0, $c2icR.DURATION_OPTIONS).includes(numeric);
    // Sticky, not derived. Deriving "is this custom?" from the current value made
    // the field vanish the moment it was cleared — the value became null, null is
    // not a non-preset, and the input unmounted mid-edit. Once «دلخواه» is chosen
    // it stays chosen until a preset is clicked or a different record is opened.
    const [customMode, setCustomMode] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        setCustomMode(false);
    }, [
        resetKey
    ]);
    const showCustom = customMode || numeric != null && !isPreset;
    const outOfRange = numeric != null && (!Number.isInteger(numeric) || numeric < min || numeric > max);
    const rangeArgs = {
        min: formatNumber(min),
        max: formatNumber(max)
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": testid,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: (0, $2xQve.STACK).tight
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5Rv3V.default), {
                label: label,
                value: showCustom ? 'custom' : isPreset ? String(numeric) : '',
                disabled: disabled,
                onChange: (v)=>{
                    if (!v) return; // Radix emits '' when deselecting
                    if (v === 'custom') {
                        setCustomMode(true);
                        return;
                    }
                    setCustomMode(false);
                    onChange(v);
                },
                options: [
                    ...(0, $c2icR.DURATION_OPTIONS).map((m)=>({
                            value: String(m),
                            label: formatNumber(m)
                        })),
                    {
                        value: 'custom',
                        label: t('people.duration.custom')
                    }
                ]
            }),
            showCustom && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iIGe.default), {
                label: t('people.duration.customLabel'),
                helperText: t('people.duration.range', rangeArgs),
                error: outOfRange ? outOfRangeText ? outOfRangeText(rangeArgs) : t('people.duration.outOfRange', rangeArgs) : '',
                value: raw,
                disabled: disabled,
                min: min,
                max: max,
                onChange: (e)=>onChange(String(e?.target ? e.target.value : e))
            }),
            hint ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    fontSize: '0.75rem',
                    color: (0, $jTCZr.C).textMuted,
                    lineHeight: 1.8
                },
                children: hint
            }) : null
        ]
    });
}

});


parcelRegister("fruhj", function(module, exports) {

$parcel$export(module.exports, "TextField", () => $7ba59e9a17132421$export$2c73285ae9390cec);
$parcel$export(module.exports, "NumberField", () => $7ba59e9a17132421$export$63c5fa0b2fdccd2e);
$parcel$export(module.exports, "TextareaField", () => $7ba59e9a17132421$export$c2bf0ac0dd87f3cb);
$parcel$export(module.exports, "MoneyField", () => $7ba59e9a17132421$export$fba099742435cc45);
$parcel$export(module.exports, "SelectField", () => $7ba59e9a17132421$export$d55b50a564d0b931);
$parcel$export(module.exports, "SearchField", () => $7ba59e9a17132421$export$b94867ecbd698f21);
$parcel$export(module.exports, "LABEL", () => $7ba59e9a17132421$export$37aee82a3cb1e8f7);
$parcel$export(module.exports, "fieldControl", () => $7ba59e9a17132421$export$b252083438a005a9);
$parcel$export(module.exports, "asOptions", () => $7ba59e9a17132421$export$a0c20f1d03e4c7f5);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");
parcelRequire("5N0ZI");
var $9iIGe = parcelRequire("9iIGe");
var $amyVq = parcelRequire("amyVq");
var $fAR2n = parcelRequire("fAR2n");
var $iygI2 = parcelRequire("iygI2");
var $a7Rbr = parcelRequire("a7Rbr");

var $5OgPq = parcelRequire("5OgPq");
/**
 * Thin adapters over the kit's form inputs.
 *
 * These do NOT re-draw anything — every one of them renders the kit component and
 * passes straight through. They exist for two reasons, both of them version facts
 * rather than taste:
 *
 *   1. **`data-testid` does not survive.** Only `MoneyInput` spreads `...rest` in
 *      the installed framework (v0.3.2); the others accept a fixed prop list, so a
 *      testid handed to `Select` or `TextInput` is silently dropped. Since §15.1
 *      makes testids a contract the E2E suite depends on, the id goes on a wrapper
 *      the caller controls.
 *   2. **`Select` takes `options`, not children.** `<Select><option/></Select>`
 *      renders an empty dropdown — no error, no warning, just nothing to pick. That
 *      is a trap worth closing once here instead of at every call site.
 *
 * When the framework grows prop spreading and children-as-options, these collapse
 * to re-exports and the call sites do not change. Until then, this is the layer-2
 * (app-shared) slot in the DESIGN.md sourcing hierarchy: composed FROM kit
 * primitives, never instead of them.
 */ /**
 * Wraps a field so its testid lands on something queryable.
 *
 * The id is on the WRAPPER, not the control, because the kit components it wraps
 * drop unknown props. Address the control as `[data-testid="x"] input` (or
 * `select`/`textarea`) — the `fieldControl` helper below does exactly that, and
 * Playwright selectors follow the same shape.
 */ function $7ba59e9a17132421$var$Field({ testid: testid, width: width, flex: flex, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        "data-testid": testid,
        style: {
            width: width,
            flex: flex,
            minWidth: 0
        },
        children: children
    });
}
function $7ba59e9a17132421$export$2c73285ae9390cec({ testid: testid, width: width, flex: flex, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($7ba59e9a17132421$var$Field, {
        testid: testid,
        width: width,
        flex: flex,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
            ...props
        })
    });
}
function $7ba59e9a17132421$export$63c5fa0b2fdccd2e({ testid: testid, width: width, flex: flex, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($7ba59e9a17132421$var$Field, {
        testid: testid,
        width: width,
        flex: flex,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iIGe.default), {
            ...props
        })
    });
}
function $7ba59e9a17132421$export$c2bf0ac0dd87f3cb({ testid: testid, width: width, flex: flex, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($7ba59e9a17132421$var$Field, {
        testid: testid,
        width: width,
        flex: flex,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iygI2.default), {
            ...props
        })
    });
}
function $7ba59e9a17132421$export$fba099742435cc45({ testid: testid, width: width, flex: flex, currency: currency, ...props }) {
    const { currency: clinicCurrency } = (0, $e1LEq.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: {
            width: width,
            flex: flex,
            minWidth: 0
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5OgPq.default), {
            "data-testid": testid,
            currency: currency || clinicCurrency,
            ...props
        })
    });
}
function $7ba59e9a17132421$export$d55b50a564d0b931({ testid: testid, width: width, flex: flex, options: options = [], ...props }) {
    const { t: t } = (0, $e1LEq.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)($7ba59e9a17132421$var$Field, {
        testid: testid,
        width: width,
        flex: flex,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fAR2n.default), {
            placeholder: t('common.form.chooseEllipsis'),
            options: options,
            ...props
        })
    });
}
function $7ba59e9a17132421$export$b94867ecbd698f21({ testid: testid, width: width, flex: flex, ...props }) {
    const { t: t } = (0, $e1LEq.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)($7ba59e9a17132421$var$Field, {
        testid: testid,
        width: width,
        flex: flex,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $amyVq.default), {
            placeholder: t('common.actions.searchPlaceholder'),
            ...props
        })
    });
}
const $7ba59e9a17132421$export$37aee82a3cb1e8f7 = {
    display: 'block',
    fontSize: '0.71875rem',
    fontWeight: 600,
    marginBottom: 4,
    color: 'var(--p-text-secondary, #5a6780)'
};
const $7ba59e9a17132421$export$b252083438a005a9 = (testid, root = document)=>root.querySelector(`[data-testid="${testid}"] input, [data-testid="${testid}"] select, [data-testid="${testid}"] textarea`) || root.querySelector(`input[data-testid="${testid}"]`);
const $7ba59e9a17132421$export$a0c20f1d03e4c7f5 = (list, { valueKey: valueKey = 'key', labelKey: labelKey = 'labelFa' } = {})=>list.map((o)=>({
            value: o[valueKey],
            label: o[labelKey]
        }));

});

parcelRegister("4sLBD", function(module, exports) {

$parcel$export(module.exports, "brandAsset", () => $33feb484f084e2c2$export$62e0383b4cfd0a36);

var $eLeza = parcelRequire("eLeza");

var $33JxX = parcelRequire("33JxX");

var $kFhew = parcelRequire("kFhew");

var $hFBay = parcelRequire("hFBay");

var $1tVQh = parcelRequire("1tVQh");

var $4IShu = parcelRequire("4IShu");

var $k80B3 = parcelRequire("k80B3");

var $dfWPT = parcelRequire("dfWPT");
// ─────────────────────────────────────────────────────────────────────────────
// The panel's own images, chosen by the brand's `assetPack`
// (docs/rebranding/CONTRACT.md §2).
//
//   logo            the gradient mark — the session-error card
//   logoWhite       the white mark on the brand gradient — the boot card
//   logoCircle      the round mark in the middle of every printed QR code
//   posterTemplate  the A4 «پوستر معرفی مطب» background
//
// No pack: today's bundled Parsina images, exactly as before. A pack this build
// carries (its files live in brand-packs/<pack>/, the same folder the image
// bakes and docker-entrypoint.sh serves at /brand/ for the favicon, icons and
// manifest): that pack's images. An image the pack does NOT carry is `null`,
// never Parsina's — Parsina's poster template has «پارسینا» painted into it,
// and a pack exists precisely so nothing of Parsina's shows. Callers hide what
// comes back null.
// ─────────────────────────────────────────────────────────────────────────────
const $33feb484f084e2c2$var$PARSINA = Object.freeze({
    logo: (/*@__PURE__*/$parcel$interopDefault($33JxX)),
    logoWhite: (/*@__PURE__*/$parcel$interopDefault($kFhew)),
    logoCircle: (/*@__PURE__*/$parcel$interopDefault($hFBay)),
    posterTemplate: (/*@__PURE__*/$parcel$interopDefault($1tVQh))
});
const $33feb484f084e2c2$var$PACKS = Object.freeze({
    proxia: Object.freeze({
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($4IShu))),
        logoWhite: (0, (/*@__PURE__*/$parcel$interopDefault($k80B3))),
        logoCircle: (0, (/*@__PURE__*/$parcel$interopDefault($dfWPT))),
        // No poster: Parsina's is a Persian raster with its wordmark baked in, and
        // Proxia has no template yet — the poster button is hidden under it.
        posterTemplate: null
    })
});
/** The pack in force, or null for today's images (none named, or one this build lacks). */ function $33feb484f084e2c2$var$activePack() {
    const id = (0, $eLeza.brand)().assetPack;
    return id && Object.prototype.hasOwnProperty.call($33feb484f084e2c2$var$PACKS, id) ? $33feb484f084e2c2$var$PACKS[id] : null;
}
function $33feb484f084e2c2$export$62e0383b4cfd0a36(name) {
    const pack = $33feb484f084e2c2$var$activePack();
    if (!pack) return $33feb484f084e2c2$var$PARSINA[name] ?? null;
    return pack[name] ?? null;
}

});
parcelRegister("33JxX", function(module, exports) {
module.exports = import.meta.resolve("90mMd");

});

parcelRegister("kFhew", function(module, exports) {
module.exports = import.meta.resolve("8C9I7");

});

parcelRegister("hFBay", function(module, exports) {
module.exports = import.meta.resolve("7j8Ve");

});

parcelRegister("1tVQh", function(module, exports) {
module.exports = import.meta.resolve("7t68v");

});

parcelRegister("4IShu", function(module, exports) {
module.exports = import.meta.resolve("7PY0y");

});

parcelRegister("k80B3", function(module, exports) {
module.exports = import.meta.resolve("b5lck");

});

parcelRegister("dfWPT", function(module, exports) {
module.exports = import.meta.resolve("7M8Mc");

});


parcelRegister("aDWH4", function(module, exports) {
module.exports = Promise.all([
    import("gTTCG"),
    import("43Tcz"),
    import("831zC")
]).then(()=>parcelRequire('hub3Y'));

});

parcelRegister("82CjW", function(module, exports) {
module.exports = Promise.all([
    import("g9Nba"),
    import("guVj1"),
    import("8lEDo"),
    import("4mzV9"),
    import("gTTCG"),
    import("eYnCE")
]).then(()=>parcelRequire('1BMVP'));

});

parcelRegister("iPwX0", function(module, exports) {
module.exports = Promise.all([
    import("guVj1"),
    import("8lEDo"),
    import("4mzV9"),
    import("gTTCG"),
    import("crlRD")
]).then(()=>parcelRequire('aaRJw'));

});

parcelRegister("3qRld", function(module, exports) {
module.exports = Promise.all([
    import("43Tcz"),
    import("lxG0m")
]).then(()=>parcelRequire('iQoFJ'));

});

parcelRegister("g8I2F", function(module, exports) {
module.exports = Promise.all([
    import("guVj1"),
    import("gtl7g")
]).then(()=>parcelRequire('ivnBV'));

});

parcelRegister("if1aE", function(module, exports) {
module.exports = import("hccY3").then(()=>parcelRequire('eDckY'));

});

parcelRegister("fOJ5D", function(module, exports) {
module.exports = Promise.all([
    import("k6SlC"),
    import("gTTCG"),
    import("6SlFT")
]).then(()=>parcelRequire('13F8y'));

});

parcelRegister("bigDG", function(module, exports) {
module.exports = Promise.all([
    import("k6SlC"),
    import("gTTCG"),
    import("etl4W")
]).then(()=>parcelRequire('9GOBU'));

});

parcelRegister("iHwC3", function(module, exports) {
module.exports = Promise.all([
    import("b0KEP"),
    import("eUuNe")
]).then(()=>parcelRequire('fP3KR'));

});

parcelRegister("7sqtK", function(module, exports) {
module.exports = Promise.all([
    import("b0KEP"),
    import("g9Nba"),
    import("guVj1"),
    import("4mzV9"),
    import("kaNwJ")
]).then(()=>parcelRequire('l4NND'));

});

parcelRegister("6aRKN", function(module, exports) {
module.exports = Promise.all([
    import("cAO99"),
    import("evVsk")
]).then(()=>parcelRequire('jeQwt'));

});

parcelRegister("eJLnU", function(module, exports) {
module.exports = Promise.all([
    import("cAO99"),
    import("5lYi2")
]).then(()=>parcelRequire('1ci5I'));

});

parcelRegister("d42w1", function(module, exports) {
module.exports = import("KAk1X").then(()=>parcelRequire('1ceH4'));

});

parcelRegister("gl7sp", function(module, exports) {
module.exports = import("6VD23").then(()=>parcelRequire('5XuRu'));

});


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
var $7e96a608cb33bf79$exports = {};
'use strict';
function $7e96a608cb33bf79$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7e96a608cb33bf79$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7e96a608cb33bf79$var$checkDCE();

$7e96a608cb33bf79$exports = (parcelRequire("iWoMt"));



var $eLeza = parcelRequire("eLeza");
// The brand, configured ONCE, before anything else in the panel evaluates
// (docs/rebranding/CONTRACT.md). App.jsx imports this file first: import order
// is evaluation order, and modules below read the brand while they load — the
// locale registry, the shared clinical module (the visit room follows it on its
// own), the language picker's list.
//
// docker-entrypoint.sh writes `BRAND_B64` into env.js only when the container
// has a brand (BRAND_JSON or BRAND_B64). Absent, this changes nothing and the
// panel is Parsina, byte for byte; a value that does not decode is Parsina too,
// with one console warning — a brand is never the reason a desk does not start.
(0, $eLeza.configureBrandFromEnv)();


parcelRequire("5u54r");

var $lzNIT = parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");
var $aphAM = parcelRequire("aphAM");
parcelRequire("5N0ZI");
var $6usBW = parcelRequire("6usBW");

var $58BYB = parcelRequire("58BYB");

var $ciRrJ = parcelRequire("ciRrJ");
parcelRequire("7c6z4");
var $kJBdz = parcelRequire("kJBdz");
var $e1LEq = parcelRequire("e1LEq");

var $goZUH = parcelRequire("goZUH");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $acw62 = parcelRequire("acw62");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");
parcelRequire("52bn2");
var $jTCZr = parcelRequire("jTCZr");

var $jTCZr = parcelRequire("jTCZr");

var $58BYB = parcelRequire("58BYB");

var $7buzq = parcelRequire("7buzq");

var $iAkVL = parcelRequire("iAkVL");

var $exu0F = parcelRequire("exu0F");

var $5bPPa = parcelRequire("5bPPa");

var $goZUH = parcelRequire("goZUH");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $aJ1FU = parcelRequire("aJ1FU");

var $6TdpC = parcelRequire("6TdpC");

var $3drWo = parcelRequire("3drWo");
/**
 * App-wide subscription banner — canonical alert zone ② (design §2.2).
 *
 * Renders nothing unless something genuinely needs attention: an entitled,
 * comfortably-in-date clinic must never see a billing banner. A permanent nag
 * trains people to ignore the alert zone, which then fails to work when a real
 * safety banner (allergy, forgotten visit) appears there.
 *
 * Shows for EXPIRED / PAST_DUE / SUSPENDED, and as a soft nudge in the last
 * three days of a trial — early enough to act on, late enough not to nag.
 *
 * Hidden while the subscription service is unreachable (`unavailable`): the BFF
 * fails open in that case, so the clinic is not actually restricted and telling
 * it otherwise would be a lie.
 *
 * ── Dismissal (`dismissible`, phones only) ──────────────────────────────────
 *
 * On a workstation the banner costs a strip of a wide screen. On a phone it
 * costs a slice of the only screen there is, above every list the operator is
 * trying to work — and «۱ روز باقی مانده» is the same sentence on the tenth
 * reading as on the first. So the phone gets an «×».
 *
 * **What is dismissed is the STATUS, not the banner.** The choice is stored per
 * clinic as the status it was made about, so:
 *
 *   · dismissing the trial nudge silences it for that clinic, for good — it
 *     does not return tomorrow at «امروز آخرین روز است»;
 *   · if the clinic later LAPSES — EXPIRED, PAST_DUE, SUSPENDED — that is a
 *     different status and a different sentence, and it shows.
 *
 * That second half is the load-bearing one. A dismissal that silenced every
 * future billing message would mean one tap during a calm trial permanently
 * hides the notice that the clinic is now blocked from registering patients —
 * and the operator would never learn why the panel stopped working. «Do not
 * come back» is a promise about the message that was dismissed, not about every
 * message this component will ever carry.
 *
 * Kept in `localStorage`, so it is per device and per browser. That is the right
 * scope for «I have read this»: it is a UI preference, not a clinic fact, and
 * nothing downstream reads it. Every access is wrapped — a private window, or a
 * browser with site data blocked, throws on read as well as on write — and the
 * banner renders normally when storage is unavailable rather than disappearing.
 */ /** One key per clinic; the value is the status that was dismissed. */ const $f619645f3c72a98a$var$storageKey = (clinicRef)=>`parsina.subscriptionBanner.dismissed.${clinicRef || 'unknown'}`;
function $f619645f3c72a98a$var$readDismissed(clinicRef) {
    try {
        return window.localStorage.getItem($f619645f3c72a98a$var$storageKey(clinicRef)) || '';
    } catch  {
        // Private window, or site data blocked. Never a reason to hide the banner.
        return '';
    }
}
function $f619645f3c72a98a$var$writeDismissed(clinicRef, status) {
    try {
        window.localStorage.setItem($f619645f3c72a98a$var$storageKey(clinicRef), status);
    } catch  {
    // The dismissal does not survive the session. The tap still works — the
    // banner is already gone from this render — which is the part the operator
    // asked for.
    }
}
function $f619645f3c72a98a$export$2e2bcd8739ae039({ capabilities: capabilities, onRenew: onRenew, compact: compact = false, dismissible: dismissible = false, clinicRef: clinicRef = '' }) {
    const { t: t } = (0, $e1LEq.default)();
    const status = capabilities?.status || '';
    // Read at mount and whenever the CLINIC or the STATUS changes — the two things
    // that can make a stored dismissal stop applying. Lazy state rather than an
    // effect: an effect would render the banner for one frame and then pull it
    // away, which on a phone is a flash directly above what the operator is reading.
    const [dismissedStatus, setDismissedStatus] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>$f619645f3c72a98a$var$readDismissed(clinicRef));
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setDismissedStatus($f619645f3c72a98a$var$readDismissed(clinicRef));
    }, [
        clinicRef,
        status
    ]);
    if (!(0, $3drWo.shouldWarn)(capabilities)) return null;
    // A READ-ONLY panel is not a nudge: every write on every screen will be
    // refused, so the banner saying why must not be dismissible, even on a phone.
    const canDismiss = dismissible && !capabilities.readOnly;
    if (canDismiss && dismissedStatus && dismissedStatus === status) return null;
    const meta = (0, $3drWo.statusMeta)(capabilities.status, t, capabilities.billing?.checkout);
    // No way to pay (checkout CONTACT): only a suspension reaches here, and it
    // offers no renew button — there is nothing to renew with.
    const contact = (0, $3drWo.isContactCheckout)(capabilities);
    const remaining = (0, $3drWo.remainingLabel)(capabilities.daysRemaining, t);
    // A trial nudge is informational; a lapse is not.
    const variant = capabilities.inTrial ? 'info' : meta.tone === 'warning' ? 'warning' : 'error';
    const message = capabilities.inTrial ? t('subscription.banner.trial', {
        remaining: remaining
    }) : capabilities.paywallMessageFa || meta.description;
    const dismiss = ()=>{
        $f619645f3c72a98a$var$writeDismissed(clinicRef, status);
        setDismissedStatus(status);
    };
    const cta = onRenew && !contact ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
        size: "sm",
        variant: "default",
        onClick: onRenew,
        "data-testid": "subscription-banner-cta",
        children: capabilities.inTrial || capabilities.trialEnded ? t('subscription.actions.activate') : t('subscription.actions.renew')
    }) : null;
    // The kit's `Alert` at the pinned tag has no dismiss of its own, so the «×»
    // rides in the action slot beside the CTA rather than waiting on the kit.
    const action = cta || canDismiss ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6
        },
        children: [
            cta,
            canDismiss ? /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                type: "button",
                onClick: dismiss,
                "aria-label": t('common.actions.dismiss'),
                title: t('common.actions.dismiss'),
                "data-testid": "subscription-banner-dismiss",
                style: {
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    // 44px: the hit-target floor the rest of the mobile design keeps to,
                    // beside a CTA it must not be mistaken for.
                    width: '2.75rem',
                    height: '2.75rem',
                    background: 'transparent',
                    border: 'none',
                    cursor: 'pointer',
                    color: 'inherit',
                    opacity: 0.7,
                    flexShrink: 0
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6TdpC.default), {
                    size: 16,
                    "aria-hidden": "true"
                })
            }) : null
        ]
    }) : null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: compact ? 'px-4 pt-3' : 'px-6 pt-4',
        "data-testid": "subscription-banner",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
            variant: variant,
            action: action,
            children: message
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $cjPik = parcelRequire("cjPik");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $jG8cU = parcelRequire("jG8cU");

var $1iGMR = parcelRequire("1iGMR");

var $3drWo = parcelRequire("3drWo");
const $78574ca1dedb7eda$var$DAY_MS = 86400000;
/** Whole days until an ISO instant; null when there is no date to count to. */ function $78574ca1dedb7eda$var$daysUntil(iso) {
    if (!iso) return null;
    const ms = new Date(iso).getTime();
    if (Number.isNaN(ms)) return null;
    return Math.ceil((ms - Date.now()) / $78574ca1dedb7eda$var$DAY_MS);
}
function $78574ca1dedb7eda$export$2e2bcd8739ae039({ onRenew: onRenew }) {
    const { t: t, formatDate: formatDate } = (0, $e1LEq.default)();
    const { can: can } = (0, $1iGMR.useAccess)();
    const [info, setInfo] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>(0, $jG8cU.onPaywall)((payload)=>{
            // Last one wins. A screen firing two blocked mutations at once would
            // otherwise queue two identical dialogs for the same fact.
            setInfo(payload);
        }), []);
    // Closed from outside on a clinic switch: this dialog's state lives in a module
    // singleton, so without it a renewal wall raised at a lapsed clinic followed the
    // person into an entitled one (design E11).
    //
    // Both subscriptions sit ABOVE the `if (!info)` return, and must: a hook below an
    // early return runs on some renders and not others, and React counts hooks per
    // render — which is exactly the «Rendered more hooks than during the previous
    // render» crash that took the whole dialog down the first time this was added.
    (0, $acw62.useEffect)(()=>(0, $jG8cU.onPaywallReset)(()=>setInfo(null)), []);
    if (!info) return null;
    const meta = (0, $3drWo.statusMeta)(info.status, t);
    const canManageBilling = can('clinic.billing.manage');
    const endText = (0, $3drWo.formatJalaliDate)(info.currentPeriodEnd, formatDate);
    // The extensions carry the period end, not a countdown — the BFF computes
    // `daysRemaining` only for the capabilities query.
    const remaining = (0, $3drWo.remainingLabel)($78574ca1dedb7eda$var$daysUntil(info.currentPeriodEnd), t);
    const close = ()=>setInfo(null);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjPik.default), {
        open: true,
        onOpenChange: (open)=>{
            if (!open) close();
        },
        title: t('clinic.paywall.title'),
        // The server's own Persian sentence names the operation that was blocked
        // and what unblocks it; `meta.description` is the generic fallback for a
        // status whose message did not travel.
        description: info.message || meta.description,
        confirmLabel: canManageBilling ? t('clinic.actions.goToBilling') : t('clinic.paywall.view'),
        cancelLabel: t('clinic.paywall.close'),
        onConfirm: ()=>{
            close();
            onRenew?.();
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            "data-testid": "paywall-dialog",
            "data-status": info.status || '',
            children: endText ? /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                className: "m-0 text-xs text-muted-foreground",
                "data-testid": "paywall-dialog-period",
                children: [
                    t('subscription.fields.validUntil'),
                    " ",
                    endText,
                    remaining ? ` \xb7 ${remaining}` : ''
                ]
            }) : null
        })
    });
}



var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $6usBW = parcelRequire("6usBW");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $acw62 = parcelRequire("acw62");

var $d7OV8 = parcelRequire("d7OV8");

var $b3FwQ = parcelRequire("b3FwQ");

var $1iGMR = parcelRequire("1iGMR");

var $bDP1h = parcelRequire("bDP1h");
const $93988564c39d0bdb$export$9019cc56520547f0 = Object.freeze([
    'appointment.created'
]);
// Module-level, so a remount of the shell or a second listener does not announce
// the same booking twice. Bounded: an open panel runs for a whole shift.
const $93988564c39d0bdb$var$MAX_REMEMBERED = 200;
const $93988564c39d0bdb$var$announced = new Set();
function $93988564c39d0bdb$export$fc11aea3c5902c48(id) {
    const key = String(id ?? '').trim();
    if (!key || $93988564c39d0bdb$var$announced.has(key)) return false;
    $93988564c39d0bdb$var$announced.add(key);
    if ($93988564c39d0bdb$var$announced.size > $93988564c39d0bdb$var$MAX_REMEMBERED) $93988564c39d0bdb$var$announced.delete($93988564c39d0bdb$var$announced.values().next().value);
    return true;
}
function $93988564c39d0bdb$export$676e0bb60eff4e0a() {
    $93988564c39d0bdb$var$announced.clear();
}
const $93988564c39d0bdb$export$247f1fa84df0b4c7 = (evt)=>String(evt?.appointment_id ?? evt?.id ?? '').trim();
function $93988564c39d0bdb$export$9a3486d3a823aba(evt) {
    if (!evt || evt.type !== 'appointment.created') return false;
    if (!(0, $b3FwQ.isOnlineSource)(evt.source)) return false;
    const by = String(evt.confirmed_by ?? evt.confirmedBy ?? '').trim();
    return by === '' || by === 'auto';
}
function $93988564c39d0bdb$export$7d3b724e05a6c548(onAnnounce) {
    const access = (0, $1iGMR.useAccess)() || {};
    const enabled = Boolean(access.isAdmin || access.can?.('appointments.view'));
    const handle = (0, $acw62.useCallback)((evt)=>{
        if (!$93988564c39d0bdb$export$9a3486d3a823aba(evt)) return;
        const id = $93988564c39d0bdb$export$247f1fa84df0b4c7(evt);
        if (!$93988564c39d0bdb$export$fc11aea3c5902c48(id)) return;
        (0, $d7OV8.reportAppointmentsChanged)();
        const when = Number(evt.date_time);
        // Exactly these three — never a field the frame happens to carry besides.
        onAnnounce?.({
            id: id,
            dateTime: Number.isFinite(when) && when > 0 ? when : null,
            source: String(evt.source)
        });
    }, [
        onAnnounce
    ]);
    (0, $bDP1h.useClinicEvents)($93988564c39d0bdb$export$9019cc56520547f0, handle, {
        enabled: enabled
    });
    return {
        enabled: enabled
    };
}
var $93988564c39d0bdb$export$2e2bcd8739ae039 = $93988564c39d0bdb$export$7d3b724e05a6c548;


function $2a14167329d4e363$export$2e2bcd8739ae039() {
    const toast = (0, $6usBW.useToast)();
    const { t: t, formatDate: formatDate, formatTime: formatTime } = (0, $e1LEq.default)();
    const announce = (0, $acw62.useCallback)(({ dateTime: dateTime })=>{
        toast.info(dateTime ? t('reception.online.toast', {
            day: formatDate(dateTime, 'weekdayDayMonth'),
            time: formatTime(dateTime)
        }) : t('reception.online.toastBare'));
    }, [
        toast,
        t,
        formatDate,
        formatTime
    ]);
    (0, $93988564c39d0bdb$export$7d3b724e05a6c548)(announce);
    return null;
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $2XwcZ = parcelRequire("2XwcZ");
var $5g6Xf = parcelRequire("5g6Xf");/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $fef0c2cce19896fe$export$a2387ed3b5d536eb = {
    name: "share",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M12 2v13",
                key: "1km8f5"
            }
        ],
        [
            "path",
            {
                d: "m16 6-4-4-4 4",
                key: "13yo43"
            }
        ],
        [
            "path",
            {
                d: "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8",
                key: "1b2hhj"
            }
        ]
    ]
};
$fef0c2cce19896fe$export$a2387ed3b5d536eb.node;
const $fef0c2cce19896fe$export$2e2bcd8739ae039 = (0, $9QBug.default)($fef0c2cce19896fe$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $1c16d0b78cca1901$export$a2387ed3b5d536eb = {
    name: "square-plus",
    size: 24,
    node: [
        [
            "rect",
            {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2",
                key: "afitv7"
            }
        ],
        [
            "path",
            {
                d: "M8 12h8",
                key: "1wcyev"
            }
        ],
        [
            "path",
            {
                d: "M12 8v8",
                key: "napkw2"
            }
        ]
    ],
    aliases: [
        "plus-square"
    ]
};
$1c16d0b78cca1901$export$a2387ed3b5d536eb.node;
const $1c16d0b78cca1901$export$2e2bcd8739ae039 = (0, $9QBug.default)($1c16d0b78cca1901$export$a2387ed3b5d536eb);


var $6TdpC = parcelRequire("6TdpC");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");
// ─────────────────────────────────────────────────────────────────────────────
// PWA runtime: install-prompt plumbing and display-mode detection. (The
// service-worker registration is src/lib/registerSw.js.)
//
// The install story is asymmetric by platform and this module absorbs that:
//
//   Chromium          Edge / Chrome on Windows (the reception desk — the
//   (Windows,         case this panel is installed for) and on Android fire
//    Android)         `beforeinstallprompt`. The event MUST be captured
//                     (and preventDefault'd) before any UI exists — it often
//                     fires while React is still mounting — so App.jsx calls
//                     initPwa() at module scope and the captured event waits
//                     here until the banner asks for it.
//   iOS Safari        has no install event at all. Installability is inferred
//                     (iOS device, not already standalone) and the banner
//                     shows share-sheet instructions instead of a prompt.
//
// Everything is defensive about environment: under jsdom there is no
// matchMedia and no service worker; in dev/e2e the worker must stay out of
// the way (a worker caching a dev server turns every reload into archaeology).
// ─────────────────────────────────────────────────────────────────────────────
const $8927aec8e5f774d0$var$DISMISS_KEY = 'parsina.pwa.dismissedAt';
const $8927aec8e5f774d0$var$INSTALLED_KEY = 'parsina.pwa.installed';
const $8927aec8e5f774d0$export$94874e4bc2db820e = 1209600000;
let $8927aec8e5f774d0$var$deferredPrompt = null;
let $8927aec8e5f774d0$var$initialized = false;
const $8927aec8e5f774d0$var$listeners = new Set();
const $8927aec8e5f774d0$var$notify = ()=>$8927aec8e5f774d0$var$listeners.forEach((fn)=>{
        try {
            fn();
        } catch  {}
    });
const $8927aec8e5f774d0$var$storageGet = (key)=>{
    try {
        return window.localStorage.getItem(key);
    } catch  {
        return null;
    }
};
const $8927aec8e5f774d0$var$storageSet = (key, value)=>{
    try {
        window.localStorage.setItem(key, value);
    } catch  {}
};
function $8927aec8e5f774d0$export$72fee83dd1572775() {
    if (typeof window === 'undefined') return false;
    // A Windows install can run as `window-controls-overlay` (the user toggled
    // the title-bar chevron) — still the installed app, still no banner.
    if (typeof window.matchMedia === 'function' && [
        'standalone',
        'window-controls-overlay',
        'minimal-ui'
    ].some((mode)=>window.matchMedia(`(display-mode: ${mode})`).matches)) return true;
    // Legacy iOS signal, still the only one some Safari versions expose.
    return window.navigator.standalone === true;
}
function $8927aec8e5f774d0$export$fedb369cb70207f1() {
    if (typeof navigator === 'undefined') return false;
    const ua = navigator.userAgent || '';
    if (/iphone|ipad|ipod/i.test(ua)) return true;
    return navigator.platform === 'MacIntel' && (navigator.maxTouchPoints || 0) > 1;
}
// ── Install prompt state ─────────────────────────────────────────────────────
function $8927aec8e5f774d0$var$isDismissed() {
    const raw = $8927aec8e5f774d0$var$storageGet($8927aec8e5f774d0$var$DISMISS_KEY);
    if (!raw) return false;
    const at = Number(raw);
    return Number.isFinite(at) && Date.now() - at < $8927aec8e5f774d0$export$94874e4bc2db820e;
}
function $8927aec8e5f774d0$export$b42bb9909fdaf235() {
    const standalone = $8927aec8e5f774d0$export$72fee83dd1572775();
    const ios = $8927aec8e5f774d0$export$fedb369cb70207f1();
    const installed = $8927aec8e5f774d0$var$storageGet($8927aec8e5f774d0$var$INSTALLED_KEY) === 'true';
    const dismissed = $8927aec8e5f774d0$var$isDismissed();
    return {
        standalone: standalone,
        ios: ios,
        promptAvailable: $8927aec8e5f774d0$var$deferredPrompt !== null,
        visible: !standalone && !installed && !dismissed && ($8927aec8e5f774d0$var$deferredPrompt !== null || ios)
    };
}
function $8927aec8e5f774d0$export$d5b018cbcf71ee98(fn) {
    $8927aec8e5f774d0$var$listeners.add(fn);
    return ()=>$8927aec8e5f774d0$var$listeners.delete(fn);
}
async function $8927aec8e5f774d0$export$c93c7c5b40a4887c() {
    const prompt = $8927aec8e5f774d0$var$deferredPrompt;
    if (!prompt) return null;
    $8927aec8e5f774d0$var$deferredPrompt = null;
    try {
        prompt.prompt();
        const choice = await prompt.userChoice;
        const outcome = choice && choice.outcome === 'accepted' ? 'accepted' : 'dismissed';
        if (outcome === 'dismissed') $8927aec8e5f774d0$var$storageSet($8927aec8e5f774d0$var$DISMISS_KEY, String(Date.now()));
        return outcome;
    } catch  {
        return 'dismissed';
    } finally{
        $8927aec8e5f774d0$var$notify();
    }
}
function $8927aec8e5f774d0$export$a86c2d0a69142026() {
    $8927aec8e5f774d0$var$storageSet($8927aec8e5f774d0$var$DISMISS_KEY, String(Date.now()));
    $8927aec8e5f774d0$var$notify();
}
function $8927aec8e5f774d0$export$1ffc9258e44c4084() {
    if ($8927aec8e5f774d0$var$initialized || typeof window === 'undefined') return;
    $8927aec8e5f774d0$var$initialized = true;
    window.addEventListener('beforeinstallprompt', (event)=>{
        // Chrome's mini-infobar is suppressed in favour of the in-app banner.
        event.preventDefault();
        $8927aec8e5f774d0$var$deferredPrompt = event;
        $8927aec8e5f774d0$var$notify();
    });
    window.addEventListener('appinstalled', ()=>{
        $8927aec8e5f774d0$var$deferredPrompt = null;
        $8927aec8e5f774d0$var$storageSet($8927aec8e5f774d0$var$INSTALLED_KEY, 'true');
        $8927aec8e5f774d0$var$notify();
    });
    $8927aec8e5f774d0$var$initLaunchQueue();
}
function $8927aec8e5f774d0$export$a40a48dba0950ebf(targetUrl, currentPath, origin) {
    let url;
    try {
        url = new URL(targetUrl, origin);
    } catch  {
        return null;
    }
    if (url.origin !== origin) return null;
    if (url.pathname === '/' && !url.search) return null; // plain launch: just focus
    let path = url.pathname;
    const inClinic = /^\/c\/[^/]+/.exec(currentPath || '');
    if (inClinic && !path.startsWith('/c/')) path = inClinic[0] + path;
    const next = path + url.search;
    return next === currentPath ? null : next;
}
function $8927aec8e5f774d0$var$initLaunchQueue() {
    if (!('launchQueue' in window) || typeof window.launchQueue?.setConsumer !== 'function') return;
    window.launchQueue.setConsumer((params)=>{
        if (!params || !params.targetURL) return;
        const current = window.location.pathname + window.location.search;
        const next = $8927aec8e5f774d0$export$a40a48dba0950ebf(params.targetURL, current, window.location.origin);
        if (!next) return;
        // BrowserRouter listens to popstate, so this is an in-app navigation:
        // no reload, no lost state in other screens' caches, no second SSO bounce.
        window.history.pushState({}, '', next);
        window.dispatchEvent(new PopStateEvent('popstate'));
    });
}
function $8927aec8e5f774d0$export$c87aff83536387ce() {
    $8927aec8e5f774d0$var$deferredPrompt = null;
    $8927aec8e5f774d0$var$initialized = false;
    $8927aec8e5f774d0$var$listeners.clear();
}


/**
 * The install banner — the browser-mode invitation to become an app.
 *
 * The doctor panel's banner (doctor-app InstallPrompt.jsx), with one fork the
 * doctor app does not need: this panel is desktop-first, and its main install
 * target is a reception or accounting PC running Windows. There, Edge and
 * Chrome fire `beforeinstallprompt` exactly as Android does, and «نصب» opens
 * the real system dialog; the installed panel then gets its own window, a
 * taskbar and Start-menu entry, and the manifest's shortcuts as a jump list.
 *
 *   desktop (`isMobile` false)  a compact card in the bottom inline-end
 *                               corner — clear of the centred content and
 *                               the ShortcutProvider's `?` overlay.
 *   phone                       the doctor app's card above the bottom nav;
 *                               iOS gets the share-sheet walkthrough, because
 *                               Safari has no install API.
 *
 * Visibility is entirely `getInstallState()`'s call (installed window,
 * installed flag, cooldown, something-to-offer), so inside the installed app
 * — and in Firefox, which cannot install — this renders nothing.
 */ const $2b9c6217915cd2a6$var$InstallPrompt = ({ isMobile: isMobile = false })=>{
    const { t: t } = (0, $e1LEq.default)();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState((0, $8927aec8e5f774d0$export$b42bb9909fdaf235));
    const [showIosSteps, setShowIosSteps] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>(0, $8927aec8e5f774d0$export$d5b018cbcf71ee98)(()=>setState((0, $8927aec8e5f774d0$export$b42bb9909fdaf235)())), []);
    if (!state.visible) return null;
    const handleInstall = async ()=>{
        if (state.promptAvailable) await (0, $8927aec8e5f774d0$export$c93c7c5b40a4887c)();
        else setShowIosSteps(true);
    };
    const desktop = !isMobile && !state.ios;
    const iosSteps = [
        {
            Icon: (0, $fef0c2cce19896fe$export$2e2bcd8739ae039),
            text: t('common.pwa.iosStep1')
        },
        {
            Icon: (0, $1c16d0b78cca1901$export$2e2bcd8739ae039),
            text: t('common.pwa.iosStep2')
        },
        {
            Icon: (0, $2XwcZ.default),
            text: t('common.pwa.iosStep3')
        }
    ];
    const tile = {
        background: `linear-gradient(160deg, ${(0, $jTCZr.C).navyDark}, ${(0, $jTCZr.C).navyLight})`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0
    };
    const LeadIcon = desktop ? (0, $5g6Xf.default) : (0, $2XwcZ.default);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        "data-testid": "pwa-install-prompt",
        "data-variant": desktop ? 'desktop' : 'mobile',
        role: "dialog",
        "aria-label": t(desktop ? 'common.pwa.desktopTitle' : 'common.pwa.installTitle'),
        style: {
            position: 'fixed',
            zIndex: 90,
            background: '#fff',
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: 16,
            boxShadow: '0 12px 40px rgba(0,0,0,0.16), 0 2px 10px rgba(0,0,0,0.08)',
            padding: 14,
            ...desktop ? {
                insetInlineEnd: 24,
                bottom: 24,
                width: 380
            } : {
                insetInline: 12,
                // Above the bottom nav: the kit's BottomNav publishes its height
                // as `--app-bottom-nav` while mounted.
                bottom: 'calc(12px + env(safe-area-inset-bottom, 0px) + var(--app-bottom-nav, 0px))',
                maxWidth: 440,
                marginInline: 'auto'
            }
        },
        children: !showIosSteps ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 12
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        ...tile,
                        width: 46,
                        height: 46,
                        borderRadius: 12
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)(LeadIcon, {
                        size: 22,
                        color: "#fff",
                        "aria-hidden": true
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        flex: 1,
                        minWidth: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                fontSize: '0.84375rem',
                                fontWeight: 800,
                                color: (0, $jTCZr.C).textPrimary
                            },
                            children: t(desktop ? 'common.pwa.desktopTitle' : 'common.pwa.installTitle')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                fontSize: '0.71875rem',
                                color: (0, $jTCZr.C).textSecondary,
                                lineHeight: 1.7,
                                marginTop: 2
                            },
                            children: t(desktop ? 'common.pwa.desktopBody' : 'common.pwa.installBody')
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 4,
                        flexShrink: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                            "data-testid": "pwa-install-accept",
                            size: "sm",
                            onClick: handleInstall,
                            children: t('common.pwa.install')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                            "data-testid": "pwa-install-dismiss",
                            size: "sm",
                            variant: "ghost",
                            onClick: (0, $8927aec8e5f774d0$export$a86c2d0a69142026),
                            children: t('common.pwa.later')
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            "data-testid": "pwa-ios-steps",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        marginBottom: 10
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                fontSize: '0.84375rem',
                                fontWeight: 800,
                                color: (0, $jTCZr.C).textPrimary
                            },
                            children: t('common.pwa.iosTitle')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                            size: "icon",
                            variant: "ghost",
                            onClick: (0, $8927aec8e5f774d0$export$a86c2d0a69142026),
                            "aria-label": t('common.actions.close'),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6TdpC.default), {
                                size: 15,
                                "aria-hidden": true
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("ol", {
                    style: {
                        listStyle: 'none',
                        margin: 0,
                        padding: 0,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 8
                    },
                    children: iosSteps.map(({ Icon: Icon, text: text }, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                            style: {
                                display: 'flex',
                                alignItems: 'center',
                                gap: 10
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        ...tile,
                                        width: 30,
                                        height: 30,
                                        borderRadius: 9
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, {
                                        size: 15,
                                        color: "#fff",
                                        "aria-hidden": true
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        fontSize: '0.78125rem',
                                        color: (0, $jTCZr.C).textSecondary,
                                        lineHeight: 1.7
                                    },
                                    children: text
                                })
                            ]
                        }, i))
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                    "data-testid": "pwa-ios-got-it",
                    onClick: (0, $8927aec8e5f774d0$export$a86c2d0a69142026),
                    style: {
                        marginTop: 12,
                        width: '100%'
                    },
                    children: t('common.pwa.gotIt')
                })
            ]
        })
    });
};
var $2b9c6217915cd2a6$export$2e2bcd8739ae039 = $2b9c6217915cd2a6$var$InstallPrompt;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $7wZCE = parcelRequire("7wZCE");
var $bHjRG = parcelRequire("bHjRG");
var $bfs4Q = parcelRequire("bfs4Q");
var $66joL = parcelRequire("66joL");
parcelRequire("52bn2");
var $jTCZr = parcelRequire("jTCZr");

var $2xQve = parcelRequire("2xQve");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $ett75 = parcelRequire("ett75");

var $ciRrJ = parcelRequire("ciRrJ");

var $7buzq = parcelRequire("7buzq");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $bHjRG = parcelRequire("bHjRG");
var $beZBx = parcelRequire("beZBx");
var $2vXUl = parcelRequire("2vXUl");
var $66joL = parcelRequire("66joL");
parcelRequire("52bn2");
var $jTCZr = parcelRequire("jTCZr");

var $2xQve = parcelRequire("2xQve");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $ett75 = parcelRequire("ett75");

var $1iGMR = parcelRequire("1iGMR");

var $2Mst8 = parcelRequire("2Mst8");

var $ca2To = parcelRequire("ca2To");
/**
 * «دسترسی‌های من» — what this person can actually do, in this clinic, in plain Persian.
 *
 * design §A18. UX principle 4 asks the panel to communicate the person's role AND
 * their permissions; the role line in the switcher does the first half, and until
 * this existed nothing did the second. The gap showed up as a question the product
 * could not answer from inside itself — «چرا این بخش را ندارم؟» — whose only
 * available answer was to ask an admin to go read the role editor.
 *
 * Read-only by construction. This is the same catalogue the role editor writes, and
 * a second writer against it would be a way to grant yourself permissions from the
 * screen that tells you which ones you lack.
 *
 * Grouped BY MODULE rather than listed flat, and it shows the modules a person does
 * NOT hold as well as the ones they do. A list of only what you have cannot answer
 * "is this section missing, or am I?" — which is the question that brings someone
 * here in the first place.
 */ const $8b0fd7293ac0e6c9$var$CATALOG = `
  query PermissionCatalog {
    permissionCatalog { key module moduleFa labelFa descriptionFa }
  }
`;
function $8b0fd7293ac0e6c9$var$VerbChip({ children: children, granted: granted }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        style: {
            fontSize: '0.6875rem',
            fontWeight: 700,
            borderRadius: 999,
            padding: '2px 9px',
            background: granted ? (0, $jTCZr.C).tealLight : (0, $jTCZr.C).bg,
            color: granted ? (0, $jTCZr.C).teal : (0, $jTCZr.C).textMuted,
            textDecoration: granted ? 'none' : 'line-through',
            whiteSpace: 'nowrap'
        },
        children: children
    });
}
function $8b0fd7293ac0e6c9$export$2e2bcd8739ae039({ open: open, onClose: onClose }) {
    const { t: t, has: has } = (0, $e1LEq.default)();
    const { activeMembership: activeMembership } = (0, $ett75.useClinicContext)();
    const access = (0, $1iGMR.useAccess)();
    const [catalog, setCatalog] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open || catalog) return;
        let alive = true;
        (0, $2Mst8.bffQuery)($8b0fd7293ac0e6c9$var$CATALOG, {}, 'PermissionCatalog').then((d)=>{
            if (alive) {
                setCatalog(d?.permissionCatalog || []);
                setError('');
            }
        })// A catalogue that will not load is an ErrorState, never an empty list: an
        // empty list here reads as «you have no permissions», which is a different
        // and much more alarming fact than «this panel could not load».
        .catch((e)=>{
            if (alive) setError(e.message || t('errors.generic'));
        });
        return ()=>{
            alive = false;
        };
    }, [
        open,
        catalog,
        t
    ]);
    const isAll = access.isAdmin;
    const groups = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (!catalog) return [];
        const byModule = new Map();
        for (const perm of catalog){
            if (!byModule.has(perm.module)) byModule.set(perm.module, {
                module: perm.module,
                perm: perm,
                items: []
            });
            byModule.get(perm.module).items.push(perm);
        }
        return [
            ...byModule.values()
        ];
    }, [
        catalog
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $beZBx.default), {
        open: open,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $beZBx.DrawerHeader), {
                title: t('clinic.myAccess.title'),
                sub: activeMembership?.clinicName || '',
                onClose: onClose
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $beZBx.DrawerBody), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: '0.78125rem',
                            color: (0, $jTCZr.C).textSecondary,
                            lineHeight: 1.9,
                            marginBottom: (0, $2xQve.STACK).regular
                        },
                        children: t('clinic.myAccess.subtitle', {
                            clinic: activeMembership?.clinicName || ''
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            display: 'flex',
                            gap: 6,
                            flexWrap: 'wrap',
                            marginBottom: (0, $2xQve.STACK).regular
                        },
                        children: access.isOwner ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bHjRG.default), {
                            variant: "success",
                            children: t('clinic.context.tier.owner')
                        }) : access.isAdmin ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bHjRG.default), {
                            variant: "success",
                            children: t('clinic.context.tier.admin')
                        }) : access.roles.length ? access.roles.map((r)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $bHjRG.default), {
                                children: r.nameFa
                            }, r.id)) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bHjRG.default), {
                            variant: "warning",
                            children: t('clinic.context.roles.none')
                        })
                    }),
                    isAll ? // Listing 28 individually ticked rows to someone who holds all of them is
                    // noise: the fact is «همه», and the enumeration hides it.
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            padding: 16,
                            borderRadius: 10,
                            background: (0, $jTCZr.C).tealLight,
                            color: (0, $jTCZr.C).teal,
                            fontSize: '0.8125rem',
                            fontWeight: 700
                        },
                        children: t('clinic.myAccess.full')
                    }) : error ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2vXUl.default), {
                        title: t('errors.network.noServer'),
                        description: error,
                        onRetry: ()=>{
                            setError('');
                            setCatalog(null);
                        },
                        // The kit ships Persian defaults for its own copy, so an omitted
                        // label renders «تلاش مجدد» inside the English and Arabic panels.
                        retryLabel: t('common.actions.retry')
                    }) : !catalog ? // The rows this drawer is about to draw — a module name and its verb
                    // chips — at the row padding they will have, not a spinner in a gap.
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonRegion), {
                        label: t('common.state.loading'),
                        "data-testid": "my-access-loading",
                        children: Array.from({
                            length: 8
                        }, (_, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    padding: (0, $2xQve.ROW_PAD).regular,
                                    borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 10
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            flex: 1,
                                            minWidth: 0
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                            width: `${40 + i * 17 % 35}%`,
                                            height: 13
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            display: 'flex',
                                            gap: 5,
                                            justifyContent: 'flex-end'
                                        },
                                        children: Array.from({
                                            length: 1 + i % 3
                                        }, (_, k)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                                width: [
                                                    52,
                                                    40,
                                                    60
                                                ][k % 3],
                                                height: 20,
                                                radius: 999
                                            }, k))
                                    })
                                ]
                            }, i))
                    }) : groups.map(({ module: module, perm: perm, items: items })=>{
                        const granted = items.filter((i)=>access.can(i.key));
                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                padding: (0, $2xQve.ROW_PAD).regular,
                                borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
                                display: 'flex',
                                alignItems: 'flex-start',
                                gap: 10,
                                opacity: granted.length ? 1 : 0.6
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    style: {
                                        flex: 1,
                                        minWidth: 0,
                                        fontSize: '0.8125rem',
                                        fontWeight: 700,
                                        color: (0, $jTCZr.C).textPrimary
                                    },
                                    children: (0, $ca2To.moduleLabel)(perm, t, has)
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    style: {
                                        display: 'flex',
                                        gap: 5,
                                        flexWrap: 'wrap',
                                        justifyContent: 'flex-end',
                                        maxWidth: '60%'
                                    },
                                    children: granted.length ? granted.map((i)=>/*#__PURE__*/ (0, $ayMG0.jsx)($8b0fd7293ac0e6c9$var$VerbChip, {
                                            granted: true,
                                            children: (0, $ca2To.permissionLabel)(i, t, has)
                                        }, i.key)) : /*#__PURE__*/ (0, $ayMG0.jsx)($8b0fd7293ac0e6c9$var$VerbChip, {
                                        granted: false,
                                        children: t('clinic.myAccess.none')
                                    })
                                })
                            ]
                        }, module);
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: '0.71875rem',
                            color: (0, $jTCZr.C).textMuted,
                            lineHeight: 1.9,
                            marginTop: (0, $2xQve.STACK).regular
                        },
                        children: t('clinic.myAccess.footnote')
                    })
                ]
            })
        ]
    });
}


/**
 * The clinic context switcher — the sidebar header.
 *
 * docs/CLINIC_MULTI_CLINIC_UX_REV2.md §5.2 / §A6. The design decisions worth
 * defending, because each looks like a small choice and is not:
 *
 * IDENTITY IS ALWAYS SHOWN; SELECTION IS NOT. The clinic's name renders for
 * everyone — a receptionist at a single clinic still benefits from seeing whose
 * cash desk they are about to bill against. The chevron, the hover, the focus ring
 * and `Ctrl+K` appear ONLY when there is something to choose between. A chevron on
 * a single-membership account is a lie about what pressing it will do, and the
 * requirement is explicit that a single-clinic person must not be asked to select.
 *
 * IT TAKES THE 68px SLOT, AND THE COLLAPSE TOGGLE MOVES TO THE FOOTER. Both cannot
 * survive the collapsed rail, and switching context is a many-times-a-day action
 * while collapsing is a once-a-session one.
 *
 * AN AVATAR MEANS A PERSON, AND THE RAIL SHOWS EXACTLY ONE. The header used to wear
 * a 36px monogram disc of its own, facing the signed-in person's avatar at the foot
 * of the same rail — two discs of the same weight, which read as two profile
 * pictures. A clinic HAS no picture: there is no logo field anywhere in the
 * platform, so that disc could only ever hold two letters. So when the rail is
 * open the clinic is type — its name, its role line, a chevron — and its colour,
 * seeded by `clinicId`, moves to a 3px bar on the inline-start edge.
 *
 * The monogram survives in the two places it does real work, both of which are
 * about telling several clinics apart rather than decorating one: the menu rows
 * below, and the collapsed 68px rail, where nothing else can name a clinic at all.
 * There it carries the clinic's colour instead of the bar, so each state shows
 * exactly one colour cue.
 *
 * BLOCKED ROWS ARE VISIBLE, DIMMED AND SAY WHY. Hiding them is what makes the
 * doctor app's existing switcher misleading — it offers a choice it cannot make.
 */ const $f8290c7dddeafa49$var$MINI = 68;
/** Two-letter monogram. Persian graphemes, so a name in any script degrades safely. */ function $f8290c7dddeafa49$var$initials(name = '', rtl = true) {
    const words = String(name).trim().split(/\s+/).filter(Boolean);
    // i18n-exempt: a GLYPH, not copy — the placeholder mark inside a monogram disc
    // when a clinic has no name yet. It follows the page's script: a Latin "?"
    // inside a Persian avatar would be as wrong as «؟» inside an English one.
    if (!words.length) return rtl ? "\u061F" : '?';
    if (words.length === 1) return [
        ...words[0]
    ].slice(0, 2).join('');
    return [
        ...words[0]
    ][0] + [
        ...words[1]
    ][0];
}
function $f8290c7dddeafa49$var$RoleLine({ membership: membership, t: t }) {
    // ONE badge, resolving tier and roles into a single line (§5.2.2). The founder
    // rule matters here: `isFounder` is decided by the clinic's own row, not by which
    // Keycloak role a given app happened to grant, so the same person is never «مالک»
    // in one session and «مدیر» in the next.
    if (membership.isFounder || membership.tier === 'OWNER') return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: t('clinic.context.tier.owner')
    });
    // A staff invitation not yet accepted carries the OFFERED tier and roles (the inbox
    // shows them as the offer); none of it is held until the person accepts (PM-0536).
    const accepted = membership.staffStatus !== 'INVITED';
    if (accepted && membership.tier === 'ADMIN') return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: t('clinic.context.tier.admin')
    });
    const roles = accepted ? membership.roles || [] : [];
    if (roles.length === 1) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: roles[0].nameFa
    });
    if (roles.length > 1) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: t('clinic.context.roles.more', {
            name: roles[0].nameFa,
            count: roles.length - 1
        })
    });
    if (membership.kinds?.includes('PRACTITIONER')) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: t('clinic.context.kind.practitioner')
    });
    // Conspicuous on purpose: this is the exact state that produces a person who can
    // sign in and then see nothing, and they should learn it before their admin does.
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        style: {
            color: (0, $jTCZr.C).amber
        },
        children: t('clinic.context.roles.none')
    });
}
function $f8290c7dddeafa49$var$MenuRow({ membership: membership, active: active, index: index, onSelect: onSelect, t: t, offline: offline }) {
    const blocked = !membership.enterable || offline;
    const reason = membership.blockedReason ? t(`clinic.context.blocked.${membership.blockedReason}`) : '';
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
        type: "button",
        role: "menuitemradio",
        "aria-checked": active,
        "aria-disabled": blocked || undefined,
        "data-menu-focus": active ? 'true' : undefined,
        "data-testid": `clinic-row-${membership.clinicId}`,
        onClick: ()=>onSelect(membership),
        title: blocked ? reason : membership.clinicName,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            width: '100%',
            padding: (0, $2xQve.ROW_PAD).regular,
            background: active ? (0, $jTCZr.C).tealLight : 'transparent',
            border: 'none',
            borderRadius: 9,
            cursor: blocked ? 'default' : 'pointer',
            textAlign: 'start',
            fontFamily: 'inherit',
            opacity: blocked ? 0.55 : 1
        },
        onMouseEnter: (e)=>{
            if (!active) e.currentTarget.style.background = (0, $jTCZr.C).bg;
        },
        onMouseLeave: (e)=>{
            if (!active) e.currentTarget.style.background = 'transparent';
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7wZCE.default), {
                name: membership.clinicName,
                size: 30,
                bg: (0, $7wZCE.avatarColor)(membership.clinicId)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                style: {
                    flex: 1,
                    minWidth: 0
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            display: 'block',
                            fontSize: '0.8125rem',
                            fontWeight: 600,
                            color: (0, $jTCZr.C).textPrimary,
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        },
                        children: membership.clinicName
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        style: {
                            display: 'block',
                            fontSize: '0.6875rem',
                            fontWeight: 400,
                            color: (0, $jTCZr.C).textSecondary,
                            marginTop: 2,
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        },
                        children: [
                            blocked ? reason : /*#__PURE__*/ (0, $ayMG0.jsx)($f8290c7dddeafa49$var$RoleLine, {
                                membership: membership,
                                t: t
                            }),
                            !blocked && membership.city ? ` \xb7 ${membership.city}` : ''
                        ]
                    })
                ]
            }),
            membership.repairNeeded ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bHjRG.default), {
                variant: "warning",
                children: t('clinic.context.repairNeeded')
            }) : null,
            !blocked && index != null && index < 9 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ciRrJ.Kbd), {
                combo: String(index + 1)
            }) : null,
            active ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                "aria-hidden": true,
                style: {
                    color: (0, $jTCZr.C).teal,
                    fontWeight: 900
                },
                children: "\u2713"
            }) : null
        ]
    });
}
function $f8290c7dddeafa49$var$SectionLabel({ children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: {
            // 11 is the ramp's floor. No letter-spacing: tracking pulls Persian
            // letters apart at their joins.
            padding: '8px 12px 4px',
            fontSize: '0.6875rem',
            fontWeight: 700,
            color: (0, $jTCZr.C).textMuted
        },
        children: children
    });
}
function $f8290c7dddeafa49$var$FooterAction({ onClick: onClick, icon: icon, label: label, count: count, disabled: disabled, hint: hint }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
        type: "button",
        role: "menuitem",
        onClick: disabled ? undefined : onClick,
        "aria-disabled": disabled || undefined,
        title: hint || undefined,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            width: '100%',
            padding: (0, $2xQve.ROW_PAD).regular,
            background: 'transparent',
            border: 'none',
            borderRadius: 9,
            textAlign: 'start',
            // Same size and weight as a clinic row's name: both are the menu's
            // item labels, and a footer label heavier than the rows reads as a heading.
            fontSize: '0.8125rem',
            fontWeight: 600,
            fontFamily: 'inherit',
            color: disabled ? (0, $jTCZr.C).textMuted : (0, $jTCZr.C).textPrimary,
            // One `cursor`, not two. A style object is not a CSS cascade — the
            // second key silently deletes the first, so the unconditional
            // `cursor: 'pointer'` that used to sit above was dead the moment this
            // line was added, and only looked like a fallback.
            cursor: disabled ? 'default' : 'pointer'
        },
        onMouseEnter: (e)=>{
            if (!disabled) e.currentTarget.style.background = (0, $jTCZr.C).bg;
        },
        onMouseLeave: (e)=>{
            e.currentTarget.style.background = 'transparent';
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                "aria-hidden": true,
                style: {
                    width: 30,
                    textAlign: 'center',
                    color: (0, $jTCZr.C).textSecondary
                },
                children: icon
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                style: {
                    flex: 1,
                    minWidth: 0
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            display: 'block'
                        },
                        children: label
                    }),
                    hint ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            display: 'block',
                            fontSize: '0.6875rem',
                            fontWeight: 400,
                            color: (0, $jTCZr.C).textMuted,
                            marginTop: 2
                        },
                        children: hint
                    }) : null
                ]
            }),
            count ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bHjRG.default), {
                children: count
            }) : null
        ]
    });
}
function $f8290c7dddeafa49$export$2e2bcd8739ae039({ collapsed: collapsed = false }) {
    const { t: t, isRTL: isRTL } = (0, $e1LEq.default)();
    const navigate = (0, $7buzq.useAppNavigate)();
    const { memberships: memberships, enterable: enterable, activeMembership: activeMembership, canSwitch: canSwitch, capabilities: capabilities, switchClinic: switchClinic, switching: switching, pendingInvitations: pendingInvitations, state: state } = (0, $ett75.useClinicContext)();
    // «افزودن کلینیک جدید» is for people who already FOUNDED a clinic — founding
    // another is an owner's act. Everyone else reaches their first clinic through
    // «شروع», so the row is absent for them rather than disabled: a receptionist
    // has no use for a greyed-out button about somebody else's decision.
    //
    // For a founder it is live where the platform allows several clinics per
    // account (`multiFounder` = the BFF's CLINIC_MULTI_FOUNDER, which the BFF also
    // ENFORCES in `createClinic`) and disabled-with-a-reason where it does not.
    const alreadyFounder = memberships.some((m)=>m.isFounder);
    const showAddClinic = alreadyFounder;
    const cannotAddClinic = alreadyFounder && !capabilities?.multiFounder;
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [accessOpen, setAccessOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [query, setQuery] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const triggerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // A switch needs the network, and one attempted without it is guaranteed to hit
    // the revert path — which reads as a broken switcher rather than as a broken
    // connection. So it says so instead of trying.
    //
    // `navigator.onLine` ONLY. The framework's `useOnlineStatus` distinguishes a
    // third state — `degraded`, meaning the browser claims to be online while a
    // captive portal, a dead VPN or a firewall eats every packet — and that is the
    // state this guard would most like to catch, because it is the one that produces
    // a confident-looking failure. It ships in framework v0.8.0 and this app installs
    // 0.4.0, where a named import of a missing export is a hard Parcel failure rather
    // than a soft undefined. Widen this to `useOnlineStatus()` when the pin is
    // bumped; until then the guard is honest about covering only the easy half.
    const [offline, setOffline] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>typeof navigator !== 'undefined' && navigator.onLine === false);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const sync = ()=>setOffline(navigator.onLine === false);
        window.addEventListener('online', sync);
        window.addEventListener('offline', sync);
        return ()=>{
            window.removeEventListener('online', sync);
            window.removeEventListener('offline', sync);
        };
    }, []);
    // Interactive when there is a real choice — a second clinic to switch to, or the
    // ability to add one. Creating is always available (§2.7), so in practice this is
    // true for everyone; the guard keeps the ONE case the requirement names — a person
    // with a single membership and nothing to add — free of a selection affordance.
    const interactive = canSwitch || enterable.length > 0;
    const others = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>memberships.filter((m)=>m.clinicId !== activeMembership?.clinicId), [
        memberships,
        activeMembership
    ]);
    const filtered = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const q = query.trim();
        if (!q) return others;
        return others.filter((m)=>`${m.clinicName} ${m.city || ''}`.includes(q));
    }, [
        others,
        query
    ]);
    const selectable = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>filtered.filter((m)=>m.enterable), [
        filtered
    ]);
    const close = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        setOpen(false);
        setQuery('');
    }, []);
    const onSelect = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((m)=>{
        if (offline) return;
        if (!m.enterable) {
            // A blocked row is not inert: an invitation or a request is actionable, just
            // not here. Route to the place where it can be acted on rather than doing
            // nothing, which reads as a broken button.
            if (m.blockedReason === 'INVITED' || m.blockedReason === 'REQUESTED') {
                close();
                navigate('invitations');
            }
            return;
        }
        close();
        switchClinic((0, $ett75.refOf)(m));
    }, [
        close,
        navigate,
        switchClinic,
        offline
    ]);
    // ── Shortcuts. Every one through the registry, never a window listener. ─────
    (0, $ciRrJ.useShortcut)('ctrl+k', ()=>setOpen((v)=>!v), {
        label: t('shortcuts.labels.switchClinic'),
        group: t('shortcuts.groups.general'),
        enabled: interactive
    });
    (0, $ciRrJ.useShortcut)('esc', close, {
        label: t('common.actions.close'),
        enabled: open
    });
    // Bare digits, bound ONLY while the menu is open. `Ctrl+1…9` is NOT used: those
    // are the browser's own tab shortcuts on Windows and Linux, and this app
    // deliberately supports keeping two clinics in two tabs — taking the keys that
    // move between them would be taking the wrong ones.
    for(let i = 0; i < 9; i += 1)// eslint-disable-next-line react-hooks/rules-of-hooks -- fixed-length loop: the
    // hook count is constant across renders, which is what the rule protects.
    (0, $ciRrJ.useShortcut)(String(i + 1), ()=>{
        const target = selectable[i];
        if (target) onSelect(target);
    }, {
        enabled: open,
        group: t('shortcuts.groups.general')
    });
    if (state === 'loading' && !activeMembership) // The trigger's own footprint — whichever one the rail is wearing — rather
    // than 68px of nothing: the rail keeps its shape and the clinic's name fills
    // in place. Open, that is two name lines and no mark, because no mark is
    // coming; collapsed, it is the 36px monogram alone. Muted, because the
    // blocks sit on the dark rail and the neutral sheen at full strength reads
    // as a selected row.
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonRegion), {
        label: t('common.state.loading'),
        "data-testid": "clinic-switcher-loading",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            width: '100%',
            height: 68,
            opacity: 0.4
        },
        children: collapsed ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            style: {
                width: $f8290c7dddeafa49$var$MINI,
                flexShrink: 0,
                display: 'flex',
                justifyContent: 'center'
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                width: 36,
                height: 36,
                radius: 10
            })
        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
            style: {
                flex: 1,
                minWidth: 0,
                display: 'flex',
                flexDirection: 'column',
                gap: 6,
                paddingInlineStart: 16,
                paddingInlineEnd: 10
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                    width: "70%",
                    height: 15
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                    width: "45%",
                    height: 11
                })
            ]
        })
    });
    const name = activeMembership?.clinicName || t('nav.title.clinicPanelShort');
    const label = interactive ? t('clinic.context.triggerSwitch', {
        name: name
    }) : t('clinic.context.trigger', {
        name: name
    });
    const trigger = /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
        ref: triggerRef,
        type: "button",
        "data-testid": "clinic-switcher-trigger",
        "aria-haspopup": interactive ? 'menu' : undefined,
        "aria-expanded": interactive ? open : undefined,
        "aria-label": label,
        title: collapsed ? name : undefined,
        disabled: !interactive,
        onClick: ()=>interactive && setOpen((v)=>!v),
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            width: '100%',
            height: 68,
            padding: 0,
            background: 'transparent',
            border: 'none',
            cursor: interactive ? 'pointer' : 'default',
            color: 'inherit',
            fontFamily: 'inherit',
            textAlign: 'start',
            overflow: 'hidden',
            position: 'relative'
        },
        onMouseEnter: (e)=>{
            if (interactive) e.currentTarget.style.background = 'rgba(255,255,255,0.06)';
        },
        onMouseLeave: (e)=>{
            e.currentTarget.style.background = 'transparent';
        },
        children: [
            !collapsed && activeMembership ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                "aria-hidden": true,
                style: {
                    position: 'absolute',
                    insetBlock: 14,
                    insetInlineStart: 0,
                    width: 3,
                    borderRadius: 2,
                    background: (0, $7wZCE.avatarColor)(activeMembership.clinicId)
                }
            }) : null,
            collapsed ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                style: {
                    width: $f8290c7dddeafa49$var$MINI,
                    flexShrink: 0,
                    display: 'flex',
                    justifyContent: 'center'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    "aria-hidden": true,
                    style: {
                        width: 36,
                        height: 36,
                        borderRadius: 10,
                        background: activeMembership ? (0, $7wZCE.avatarColor)(activeMembership.clinicId) : 'rgba(255,255,255,0.16)',
                        color: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '0.8125rem',
                        fontWeight: 800
                    },
                    children: $f8290c7dddeafa49$var$initials(name, isRTL)
                })
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                style: {
                    flex: 1,
                    minWidth: 0,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                    // The 68px icon column is gone with the disc, so the name insets from
                    // the rail's edge itself — clear of the colour bar, and short of the
                    // 10px the nav pills below are inset by, because a heading that lines
                    // up with the pills reads as one of them.
                    paddingInlineStart: 16
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        style: {
                            flex: 1,
                            minWidth: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    display: 'block',
                                    color: 'white',
                                    fontSize: '0.9375rem',
                                    fontWeight: 800,
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis'
                                },
                                children: name
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    display: 'block',
                                    color: 'rgba(255,255,255,0.45)',
                                    fontSize: '0.6875rem',
                                    marginTop: 1,
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis'
                                },
                                children: activeMembership ? /*#__PURE__*/ (0, $ayMG0.jsx)($f8290c7dddeafa49$var$RoleLine, {
                                    membership: activeMembership,
                                    t: t
                                }) : null
                            })
                        ]
                    }),
                    interactive ? /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "rgba(255,255,255,0.55)",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        width: "14",
                        height: "14",
                        "aria-hidden": true,
                        style: {
                            flexShrink: 0,
                            marginInlineEnd: 10
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
                            points: "6 9 12 15 18 9"
                        })
                    }) : null
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            trigger,
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bfs4Q.default), {
                "data-testid": "clinic-menu",
                open: open && interactive,
                onClose: close,
                anchorRef: triggerRef,
                ariaLabel: t('clinic.context.menuLabel'),
                children: [
                    others.length >= 8 ? /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        autoFocus: true,
                        "data-menu-focus": "true",
                        value: query,
                        onChange: (e)=>setQuery(e.target.value),
                        placeholder: t('clinic.context.searchPlaceholder'),
                        style: {
                            width: '100%',
                            padding: '8px 10px',
                            marginBottom: 4,
                            border: `1px solid ${(0, $jTCZr.C).border}`,
                            borderRadius: 8,
                            fontSize: '0.78125rem',
                            fontFamily: 'inherit',
                            outline: 'none'
                        }
                    }) : null,
                    offline ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            padding: '4px 6px 8px'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                            variant: "warning",
                            children: t('clinic.context.offline')
                        })
                    }) : null,
                    activeMembership ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        role: "group",
                        "aria-label": t('clinic.context.activeSection'),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($f8290c7dddeafa49$var$SectionLabel, {
                                children: t('clinic.context.activeSection')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($f8290c7dddeafa49$var$MenuRow, {
                                membership: activeMembership,
                                active: true,
                                onSelect: onSelect,
                                t: t
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                role: "menuitem",
                                "data-testid": "my-access-link",
                                onClick: ()=>{
                                    close();
                                    setAccessOpen(true);
                                },
                                style: {
                                    display: 'block',
                                    width: '100%',
                                    textAlign: 'start',
                                    padding: '2px 12px 8px',
                                    marginTop: -4,
                                    background: 'transparent',
                                    border: 'none',
                                    cursor: 'pointer',
                                    color: (0, $jTCZr.C).teal,
                                    fontSize: '0.75rem',
                                    fontWeight: 600,
                                    fontFamily: 'inherit'
                                },
                                children: t('clinic.myAccess.link')
                            })
                        ]
                    }) : null,
                    filtered.length ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        role: "group",
                        "aria-label": t('clinic.context.othersSection'),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($f8290c7dddeafa49$var$SectionLabel, {
                                children: t('clinic.context.othersSection')
                            }),
                            filtered.map((m)=>/*#__PURE__*/ (0, $ayMG0.jsx)($f8290c7dddeafa49$var$MenuRow, {
                                    membership: m,
                                    active: false,
                                    index: m.enterable ? selectable.indexOf(m) : null,
                                    onSelect: onSelect,
                                    t: t,
                                    offline: offline
                                }, m.clinicId))
                        ]
                    }) : null,
                    query && !filtered.length ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            padding: '14px 12px',
                            fontSize: '0.78125rem',
                            color: (0, $jTCZr.C).textMuted
                        },
                        children: t('clinic.context.noMatches')
                    }) : null,
                    switching ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            padding: '4px 6px'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                            variant: "info",
                            children: t('clinic.context.switching')
                        })
                    }) : null,
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            borderTop: `1px solid ${(0, $jTCZr.C).border}`,
                            marginTop: 4,
                            paddingTop: 4
                        },
                        children: [
                            showAddClinic ? /*#__PURE__*/ (0, $ayMG0.jsx)($f8290c7dddeafa49$var$FooterAction, {
                                icon: "\uFF0B",
                                label: t('clinic.context.addClinic'),
                                disabled: cannotAddClinic,
                                hint: cannotAddClinic ? t('clinic.context.addClinicUnavailable') : undefined,
                                onClick: ()=>{
                                    close();
                                    navigate('onboarding');
                                }
                            }) : null,
                            /*#__PURE__*/ (0, $ayMG0.jsx)($f8290c7dddeafa49$var$FooterAction, {
                                icon: "\u2709",
                                label: t('clinic.context.invitations'),
                                count: pendingInvitations.length,
                                onClick: ()=>{
                                    close();
                                    navigate('invitations');
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8b0fd7293ac0e6c9$export$2e2bcd8739ae039), {
                open: accessOpen,
                onClose: ()=>setAccessOpen(false)
            })
        ]
    });
}



var $ett75 = parcelRequire("ett75");

var $1iGMR = parcelRequire("1iGMR");

var $7D4kr = parcelRequire("7D4kr");

var $kaeHn = parcelRequire("kaeHn");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $5AX1S = parcelRequire("5AX1S");
var $8ym5i = parcelRequire("8ym5i");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $7wZCE = parcelRequire("7wZCE");
var $bfs4Q = parcelRequire("bfs4Q");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("52bn2");
var $jTCZr = parcelRequire("jTCZr");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $ciRrJ = parcelRequire("ciRrJ");

var $9SI14 = parcelRequire("9SI14");
/**
 * The foot of the clinic sidebar.
 *
 * It replaced three stacked things that did not know about each other: a row
 * that held nothing but the collapse toggle, a bordered card for the person's
 * پارسه, and a borderless identity row under it — three shapes, two chevrons
 * pointing in different directions, and a caption («پنل مدیریت») that named
 * the product instead of the person. The rebuild answers the footer's three
 * questions in two grouped pieces, top to bottom:
 *
 * ── THE UTILITY STRIP ───────────────────────────────────────────────────────
 * Shell controls, not account information: the collapse toggle in the icon
 * column (where its hit target survives the rail) and, beside it, the way into
 * the `?` overlay. The strip used to be a 48px row spent on one 32px button;
 * the overlay is the only place a shortcut is listed, so a visible entry earns
 * the rest of the row in a panel that is designed keyboard-first.
 *
 * ── THE ACCOUNT BLOCK ───────────────────────────────────────────────────────
 * One card, inset like the nav pills above it, holding the PERSON: who is
 * signed in (the menu trigger) and, when they own one, their own پارسه as a
 * second row of the same card. Grouping the balance under the name is what says
 * whose money it is — better than the label it used to carry, which repeated
 * the unit («اعتبار پارسهٔ شما … ۵۰۰ پارسه»). There is no clinic pool: every
 * member of staff has their own wallet and pays for what they do. A balance that
 * could not be read leaves a one-row card, not an empty one.
 *
 * The level word is shown only when it carries information. «کافی» beside a
 * green dot said nothing twice; «کم» is now a red row with a «شارژ» chip in it,
 * «متوسط» an amber word, and a fine balance is simply the number.
 *
 * The balance row stays a real <a> to حساب پارسینا — middle-click and «open in
 * new tab» keep working — and the trigger stays a <button>. They are siblings
 * in the card, never nested, so neither is an interactive element inside
 * another.
 *
 * ── THE 68px RAIL ───────────────────────────────────────────────────────────
 * The icon column is first in DOM order, so under RTL it is rightmost and the
 * collapse — which clips from the inline-end — takes only text. The balance
 * row is NOT rendered when collapsed rather than faded: a faded link keeps its
 * tab stop. Its level moves onto the avatar as a status dot, and the trigger's
 * tooltip carries the amount, so the rail still answers «how much?».
 *
 * Props:
 *   collapsed / onToggleCollapse
 *   user        {name, subtitle?}          — subtitle only when it says something
 *                                            the name does not (email, phone)
 *   credit      {amount, level, unit, href} | null — omit to hide the balance row
 *   items       [{key, label, description?, icon?, href?, external?, onClick?,
 *                 tone?, separatorBefore?, 'data-testid'?}]
 *   menuLabel   accessible name of the menu; the trigger's own text is a name
 */ const $879c64ea7a77d8fb$var$MINI = 68; // the collapsed rail
const $879c64ea7a77d8fb$var$INSET = 10; // the card's inset, matching the nav pills
const $879c64ea7a77d8fb$var$CELL = $879c64ea7a77d8fb$var$MINI - $879c64ea7a77d8fb$var$INSET * 2; // the icon column inside an inset card
// Ink on the sidebar gradient. Kept here rather than in the theme because the
// gradient is the only dark surface in this app and these are its alphas.
const $879c64ea7a77d8fb$var$INK = {
    strong: '#fff',
    body: 'rgba(255,255,255,0.72)',
    muted: 'rgba(255,255,255,0.45)',
    faint: 'rgba(255,255,255,0.3)',
    line: 'rgba(255,255,255,0.08)',
    fill: 'rgba(255,255,255,0.05)',
    fillHover: 'rgba(255,255,255,0.10)',
    fillActive: 'rgba(255,255,255,0.14)'
};
const $879c64ea7a77d8fb$var$CoinGlyph = ({ size: size = 16 })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        width: size,
        height: size,
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "8.5",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M12 7.5v9M9.5 10h5M9.5 14h5",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round"
            })
        ]
    });
// Says the press LEAVES this panel.
const $879c64ea7a77d8fb$var$ExternalGlyph = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        width: "13",
        height: "13",
        "aria-hidden": true,
        style: {
            flexShrink: 0,
            opacity: 0.55
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
                points: "15 3 21 3 21 9"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "10",
                y1: "14",
                x2: "21",
                y2: "3"
            })
        ]
    });
const $879c64ea7a77d8fb$var$Chevron = ({ open: open })=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2.4",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        width: "14",
        height: "14",
        "aria-hidden": true,
        style: {
            flexShrink: 0,
            color: open ? $879c64ea7a77d8fb$var$INK.strong : $879c64ea7a77d8fb$var$INK.muted,
            transform: open ? 'rotate(180deg)' : 'none',
            transition: 'transform 0.18s, color 0.18s'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
            points: "18 15 12 9 6 15"
        })
    });
// ── the utility strip ───────────────────────────────────────────────────────
function $879c64ea7a77d8fb$var$CollapseToggle({ collapsed: collapsed, onToggle: onToggle, t: t }) {
    const label = collapsed ? t('nav.menu.open') : t('nav.menu.close');
    return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
        type: "button",
        onClick: onToggle,
        title: label,
        "aria-label": label,
        "aria-expanded": !collapsed,
        "data-testid": "sidebar-collapse",
        style: {
            width: 32,
            height: 32,
            background: $879c64ea7a77d8fb$var$INK.line,
            border: 'none',
            borderRadius: 9,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            color: $879c64ea7a77d8fb$var$INK.muted,
            transition: 'background 0.18s, color 0.18s'
        },
        onMouseEnter: (e)=>{
            e.currentTarget.style.background = $879c64ea7a77d8fb$var$INK.fillActive;
            e.currentTarget.style.color = $879c64ea7a77d8fb$var$INK.strong;
        },
        onMouseLeave: (e)=>{
            e.currentTarget.style.background = $879c64ea7a77d8fb$var$INK.line;
            e.currentTarget.style.color = $879c64ea7a77d8fb$var$INK.muted;
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
            viewBox: "0 0 24 24",
            fill: "currentColor",
            width: "17",
            height: "17",
            style: {
                transition: 'transform 0.3s cubic-bezier(.4,0,.2,1)',
                transform: collapsed ? 'rotate(0deg)' : 'rotate(180deg)'
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
            })
        })
    });
}
function $879c64ea7a77d8fb$var$ShortcutsEntry({ t: t }) {
    const help = (0, $ciRrJ.useShortcutHelp)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
        type: "button",
        onClick: help.toggle,
        "data-testid": "sidebar-shortcuts",
        "aria-pressed": help.open,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 7,
            height: 32,
            padding: '0 8px',
            marginInlineEnd: $879c64ea7a77d8fb$var$INSET,
            background: 'transparent',
            border: 'none',
            borderRadius: 9,
            color: $879c64ea7a77d8fb$var$INK.muted,
            cursor: 'pointer',
            fontFamily: 'inherit',
            fontSize: '0.71875rem',
            fontWeight: 600,
            whiteSpace: 'nowrap',
            transition: 'background 0.18s, color 0.18s'
        },
        onMouseEnter: (e)=>{
            e.currentTarget.style.background = $879c64ea7a77d8fb$var$INK.line;
            e.currentTarget.style.color = $879c64ea7a77d8fb$var$INK.body;
        },
        onMouseLeave: (e)=>{
            e.currentTarget.style.background = 'transparent';
            e.currentTarget.style.color = $879c64ea7a77d8fb$var$INK.muted;
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("kbd", {
                "aria-hidden": true,
                style: {
                    minWidth: 18,
                    height: 18,
                    padding: '0 4px',
                    borderRadius: 5,
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: $879c64ea7a77d8fb$var$INK.line,
                    border: `1px solid ${$879c64ea7a77d8fb$var$INK.line}`,
                    color: 'inherit',
                    fontFamily: 'inherit',
                    fontSize: '0.6875rem',
                    fontWeight: 800,
                    lineHeight: 1
                },
                children: "?"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                children: t('nav.footer.shortcuts')
            })
        ]
    });
}
// ── one menu row ────────────────────────────────────────────────────────────
function $879c64ea7a77d8fb$var$MenuRow({ item: item, onDone: onDone, testIdBase: testIdBase }) {
    const destructive = item.tone === 'destructive';
    const ink = destructive ? (0, $jTCZr.C).red : (0, $jTCZr.C).textPrimary;
    const hover = destructive ? (0, $jTCZr.soft)((0, $jTCZr.C).red, 0.10) : (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.08);
    const shared = {
        role: 'menuitem',
        'data-testid': item['data-testid'] || `${testIdBase}-item-${item.key}`,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            width: '100%',
            padding: '9px 10px',
            minHeight: 40,
            border: 'none',
            borderRadius: 9,
            background: 'transparent',
            color: ink,
            textAlign: 'start',
            textDecoration: 'none',
            fontFamily: 'inherit',
            fontSize: '0.84375rem',
            fontWeight: 600,
            cursor: 'pointer',
            transition: 'background 0.14s'
        },
        onMouseEnter: (e)=>{
            e.currentTarget.style.background = hover;
        },
        onMouseLeave: (e)=>{
            e.currentTarget.style.background = 'transparent';
        }
    };
    const body = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            item.icon ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                "aria-hidden": true,
                style: {
                    flexShrink: 0,
                    display: 'flex',
                    color: destructive ? (0, $jTCZr.C).red : (0, $jTCZr.C).navy
                },
                children: item.icon
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                style: {
                    flex: 1,
                    minWidth: 0
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            display: 'block',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        },
                        children: item.label
                    }),
                    item.description ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        dir: "auto",
                        style: {
                            display: 'block',
                            fontSize: '0.6875rem',
                            fontWeight: 500,
                            marginTop: 1,
                            color: (0, $jTCZr.C).textMuted,
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        },
                        children: item.description
                    }) : null
                ]
            }),
            item.external ? /*#__PURE__*/ (0, $ayMG0.jsx)($879c64ea7a77d8fb$var$ExternalGlyph, {}) : null
        ]
    });
    // A real <a> when the destination is a URL: focusable, openable in a new tab
    // with the usual modifiers, and readable in the status bar.
    return item.href ? /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
        ...shared,
        href: item.href,
        onClick: ()=>onDone?.(),
        children: body
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
        ...shared,
        type: "button",
        onClick: ()=>{
            onDone?.();
            item.onClick?.();
        },
        children: body
    });
}
// ── the balance row ─────────────────────────────────────────────────────────
function $879c64ea7a77d8fb$var$BalanceRow({ credit: credit, t: t, testId: testId }) {
    const level = credit.level === 'low' || credit.level === 'mid' ? credit.level : 'ok';
    const color = (0, $jTCZr.CREDIT_LEVEL_META)[level].color;
    const low = level === 'low';
    // «شارژ» only where credit is sold and the account app can take the payment
    // (hooks/useCreditPurchase.js); the red row says «low» either way.
    const topUp = (0, $9SI14.useCreditPurchase)(low);
    const sentence = t('nav.credits.title', {
        amount: credit.amount
    });
    const bg = (hovered)=>low ? (0, $jTCZr.soft)((0, $jTCZr.C).red, hovered ? 0.26 : 0.16) : hovered ? $879c64ea7a77d8fb$var$INK.fillHover : 'transparent';
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
        href: credit.href,
        "data-testid": `${testId}-credit`,
        "aria-label": t('nav.credits.aria', {
            amount: credit.amount
        }),
        title: sentence,
        style: {
            display: 'flex',
            alignItems: 'center',
            height: 38,
            borderTop: `1px solid ${$879c64ea7a77d8fb$var$INK.line}`,
            background: bg(false),
            color: 'inherit',
            textDecoration: 'none',
            transition: 'background 0.16s'
        },
        onMouseEnter: (e)=>{
            e.currentTarget.style.background = bg(true);
        },
        onMouseLeave: (e)=>{
            e.currentTarget.style.background = bg(false);
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                "aria-hidden": true,
                style: {
                    width: $879c64ea7a77d8fb$var$CELL,
                    flexShrink: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    color: color
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($879c64ea7a77d8fb$var$CoinGlyph, {
                    size: 16
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                style: {
                    flex: 1,
                    minWidth: 0,
                    display: 'flex',
                    alignItems: 'baseline',
                    gap: 4,
                    whiteSpace: 'nowrap'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            fontSize: '0.84375rem',
                            fontWeight: 800,
                            color: $879c64ea7a77d8fb$var$INK.strong
                        },
                        children: credit.amount
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            fontSize: '0.6875rem',
                            color: $879c64ea7a77d8fb$var$INK.muted
                        },
                        children: credit.unit
                    })
                ]
            }),
            low ? topUp ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                style: {
                    marginInlineEnd: $879c64ea7a77d8fb$var$INSET,
                    flexShrink: 0,
                    padding: '3px 8px',
                    borderRadius: 999,
                    background: (0, $jTCZr.C).teal,
                    color: $879c64ea7a77d8fb$var$INK.strong,
                    fontSize: '0.65625rem',
                    fontWeight: 800,
                    whiteSpace: 'nowrap'
                },
                children: t('nav.credits.topUpShort')
            }) : null : level === 'mid' ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                style: {
                    marginInlineEnd: $879c64ea7a77d8fb$var$INSET + 2,
                    flexShrink: 0,
                    fontSize: '0.65625rem',
                    fontWeight: 700,
                    color: color,
                    whiteSpace: 'nowrap'
                },
                children: t('nav.credits.levelMid')
            }) : null
        ]
    });
}
function $879c64ea7a77d8fb$export$2e2bcd8739ae039({ collapsed: collapsed = false, onToggleCollapse: onToggleCollapse, user: user, credit: credit = null, items: items = [], menuLabel: menuLabel, 'data-testid': testId = 'account-card' }) {
    const { t: t } = (0, $e1LEq.default)();
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const triggerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // The anchor moves 192px under a CSS transition when the rail collapses; a
    // menu left open would float beside where the trigger used to be.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setOpen(false);
    }, [
        collapsed
    ]);
    const close = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>setOpen(false), []);
    const rows = items.filter(Boolean);
    const name = user?.name || "\u2014";
    const level = credit ? (0, $jTCZr.CREDIT_LEVEL_META)[credit.level] ? credit.level : 'ok' : null;
    const levelColor = level ? (0, $jTCZr.CREDIT_LEVEL_META)[level].color : null;
    // When collapsed the balance row is gone, so the tooltip says what it said.
    const tooltip = [
        `${menuLabel} \u{2014} ${name}`,
        credit ? t('nav.credits.title', {
            amount: credit.amount
        }) : null
    ].filter(Boolean).join('\n');
    const fade = {
        opacity: collapsed ? 0 : 1,
        pointerEvents: collapsed ? 'none' : 'auto',
        transition: 'opacity 0.16s ease'
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": testId,
        style: {
            flexShrink: 0,
            borderTop: `1px solid ${$879c64ea7a77d8fb$var$INK.line}`,
            paddingTop: 6
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    height: 40
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            width: $879c64ea7a77d8fb$var$MINI,
                            flexShrink: 0,
                            display: 'flex',
                            justifyContent: 'center'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($879c64ea7a77d8fb$var$CollapseToggle, {
                            collapsed: collapsed,
                            onToggle: onToggleCollapse,
                            t: t
                        })
                    }),
                    !collapsed ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            flex: 1,
                            minWidth: 0,
                            display: 'flex',
                            justifyContent: 'flex-end'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($879c64ea7a77d8fb$var$ShortcutsEntry, {
                            t: t
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    width: `calc(100% - ${$879c64ea7a77d8fb$var$INSET * 2}px)`,
                    margin: `4px ${$879c64ea7a77d8fb$var$INSET}px ${$879c64ea7a77d8fb$var$INSET}px`,
                    borderRadius: 12,
                    overflow: 'hidden',
                    background: $879c64ea7a77d8fb$var$INK.fill,
                    border: `1px solid ${$879c64ea7a77d8fb$var$INK.line}`,
                    transition: 'width 0.3s cubic-bezier(.4,0,.2,1)'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        ref: triggerRef,
                        type: "button",
                        "data-testid": `${testId}-trigger`,
                        onClick: ()=>setOpen((v)=>!v),
                        "aria-haspopup": "menu",
                        "aria-expanded": open,
                        "aria-label": `${menuLabel} \u{2014} ${name}`,
                        title: collapsed ? tooltip : undefined,
                        style: {
                            width: '100%',
                            height: 52,
                            padding: 0,
                            display: 'flex',
                            alignItems: 'center',
                            border: 'none',
                            background: open ? $879c64ea7a77d8fb$var$INK.fillActive : 'transparent',
                            cursor: 'pointer',
                            fontFamily: 'inherit',
                            textAlign: 'start',
                            color: 'inherit',
                            overflow: 'hidden',
                            transition: 'background 0.16s'
                        },
                        onMouseEnter: (e)=>{
                            if (!open) e.currentTarget.style.background = $879c64ea7a77d8fb$var$INK.fillHover;
                        },
                        onMouseLeave: (e)=>{
                            if (!open) e.currentTarget.style.background = 'transparent';
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                style: {
                                    width: $879c64ea7a77d8fb$var$CELL,
                                    flexShrink: 0,
                                    display: 'flex',
                                    justifyContent: 'center',
                                    position: 'relative'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7wZCE.default), {
                                        name: name,
                                        size: 34,
                                        bg: (0, $jTCZr.C).navy,
                                        src: user?.avatarUrl || undefined
                                    }),
                                    collapsed && levelColor ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        "aria-hidden": true,
                                        style: {
                                            position: 'absolute',
                                            insetBlockEnd: 1,
                                            insetInlineStart: 7,
                                            width: 10,
                                            height: 10,
                                            borderRadius: '50%',
                                            // A dark ring, not a brand hex: it must read against any sidebar gradient.
                                            background: levelColor,
                                            boxShadow: '0 0 0 2px rgba(0,0,0,0.45)'
                                        }
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                style: {
                                    ...fade,
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 6,
                                    flex: 1,
                                    minWidth: 0,
                                    paddingInlineEnd: $879c64ea7a77d8fb$var$INSET + 2
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        style: {
                                            flex: 1,
                                            minWidth: 0
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                dir: "auto",
                                                style: {
                                                    display: 'block',
                                                    color: $879c64ea7a77d8fb$var$INK.strong,
                                                    fontSize: '0.8125rem',
                                                    fontWeight: 700,
                                                    whiteSpace: 'nowrap',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis'
                                                },
                                                children: name
                                            }),
                                            user?.subtitle ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                dir: "auto",
                                                style: {
                                                    display: 'block',
                                                    color: $879c64ea7a77d8fb$var$INK.muted,
                                                    fontSize: '0.6875rem',
                                                    marginTop: 1,
                                                    whiteSpace: 'nowrap',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis'
                                                },
                                                children: user.subtitle
                                            }) : null
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($879c64ea7a77d8fb$var$Chevron, {
                                        open: open
                                    })
                                ]
                            })
                        ]
                    }),
                    credit && !collapsed ? /*#__PURE__*/ (0, $ayMG0.jsx)($879c64ea7a77d8fb$var$BalanceRow, {
                        credit: credit,
                        t: t,
                        testId: testId
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bfs4Q.default), {
                open: open,
                onClose: close,
                anchorRef: triggerRef,
                ariaLabel: menuLabel,
                placement: "top",
                width: 240,
                "data-testid": `${testId}-menu`,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            padding: '6px 10px 8px',
                            borderBottom: `1px solid ${(0, $jTCZr.C).border}`,
                            marginBottom: 4
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                dir: "auto",
                                style: {
                                    fontSize: '0.8125rem',
                                    fontWeight: 800,
                                    color: (0, $jTCZr.C).textPrimary,
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis'
                                },
                                children: name
                            }),
                            user?.subtitle ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                dir: "auto",
                                style: {
                                    fontSize: '0.6875rem',
                                    color: (0, $jTCZr.C).textMuted,
                                    marginTop: 2,
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis'
                                },
                                children: user.subtitle
                            }) : null
                        ]
                    }),
                    rows.map((item)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                            children: [
                                item.separatorBefore ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    role: "separator",
                                    style: {
                                        height: 1,
                                        background: (0, $jTCZr.C).border,
                                        margin: '5px 8px'
                                    }
                                }) : null,
                                /*#__PURE__*/ (0, $ayMG0.jsx)($879c64ea7a77d8fb$var$MenuRow, {
                                    item: item,
                                    onDone: close,
                                    testIdBase: testId
                                })
                            ]
                        }, item.key))
                ]
            })
        ]
    });
}



var $9h2jQ = parcelRequire("9h2jQ");

/**
 * «منشی هوشمند پارسینا» — the shell's side of the secretary (PM-0080).
 *
 * `SecretaryProvider` wraps the shell once, so the record button — a sidebar row
 * on a desk (SecretaryRecorder), a round button on a phone (SecretaryFab) — and
 * what it brings back belong to no screen and survive moving between them.
 *
 * `SecretaryHost` is mounted once beside them and owns:
 *   • the keys — F1 records and stops from any screen, Esc throws a recording
 *     away, Shift+F1 opens the newest result;
 *   • the notifications (SecretaryNotices), and where opening one goes
 *     (model.routeOf): «ثبت نوبت» filled in when nothing is missing, the record
 *     for «باز کردن پرونده», and the result's own window (SecretaryWindow) when
 *     something has to be answered or chosen first;
 *   • the hand-off to «ثبت نوبت» — the existing booking form, opened prefilled —
 *     and what happens after a write: the toast, and telling پذیرش to re-read.
 *
 * Who may use it: anyone the BFF would answer. The BFF checks each tool against
 * the caller's own permissions, so there is no permission key for the button —
 * a member who may only read gets answers and refusals, not a missing button.
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $6usBW = parcelRequire("6usBW");

var $7buzq = parcelRequire("7buzq");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $d7OV8 = parcelRequire("d7OV8");

var $ciRrJ = parcelRequire("ciRrJ");

var $a0Xuh = parcelRequire("a0Xuh");
/**
 * «منشی هوشمند پارسینا» — documents, vocabulary and the pure rules of the overlay
 * (PM-0080). DOM-free: the hook and the screen import from here, never the reverse.
 *
 * The secretary PROPOSES and the user COMMITS. `RUN_SECRETARY_COMMAND` writes
 * nothing; the two mutations below it are the operations that already existed for
 * the two writes the overlay can commit itself, and booking is committed by the
 * existing «ثبت نوبت» form, opened prefilled.
 */ 
var $5qKOB = parcelRequire("5qKOB");
// A patient as the overlay shows one: who, told apart from namesakes, and — when a
// name lookup found them — how closely the heard name matched, and why.
const $8af4119da22d78aa$var$PATIENT = 'id name fileNumber age phoneTail isNew score reasons { kind heard stored }';
// What a proposal was made of. Handed back with an answer, so the BFF can rebuild the
// proposal without the model (refineSecretaryCommand); it trusts none of it.
const $8af4119da22d78aa$var$DRAFT = "kind patientId patientName newPatient { name phone nationalId insurance insurerId } doctorId fromDate toDate time timeSaid when similar followUpKind followUpNote dueDate";
const $8af4119da22d78aa$var$RESULT = `
      outcome
      kind
      charged
      heardName
      patients { ${$8af4119da22d78aa$var$PATIENT} }
      doctors { doctorId name specialty }
      patient { ${$8af4119da22d78aa$var$PATIENT} }
      booking {
        patient { ${$8af4119da22d78aa$var$PATIENT} }
        doctor { doctorId name specialty }
        doctorAssumed
        fromMs
        toMs
        slots { dateTime }
        requestedAt
        requestedFree
        newPatient { name phone phoneHeard nationalId insurance insurerId insurerName missing }
      }
      arrival {
        appointmentId
        patient { ${$8af4119da22d78aa$var$PATIENT} }
        dateTime
        doctorName
        status
      }
      followUp {
        patient { ${$8af4119da22d78aa$var$PATIENT} }
        dueAt
        kind
        note
      }
      balance {
        patient { ${$8af4119da22d78aa$var$PATIENT} }
        outstanding
        openInvoices
        currency
      }
      daySummary { dateMs total scheduled arrived inVisit completed cancelled noShow }
      missingPermissions
      topic
      detail
      reason
      questions { kind blocking options { value label selected } }
      draft { ${$8af4119da22d78aa$var$DRAFT} }
`;
const $8af4119da22d78aa$export$a08e426fe22a33ae = `
  mutation RunSecretaryCommand($input: SecretaryCommandInput!) {
    runSecretaryCommand(input: $input) { ${$8af4119da22d78aa$var$RESULT} }
  }
`;
const $8af4119da22d78aa$export$1d585b0310ad88ad = `
  query RefineSecretaryCommand($draft: SecretaryDraftInput!, $answer: SecretaryAnswerInput!) {
    refineSecretaryCommand(draft: $draft, answer: $answer) { ${$8af4119da22d78aa$var$RESULT} }
  }
`;
const $8af4119da22d78aa$export$5b548a56a36e433c = `
  mutation SecretaryMarkArrived($appointmentId: ID!) {
    markArrived(appointmentId: $appointmentId) { id status }
  }
`;
const $8af4119da22d78aa$export$ed9bc2432ccbd5d = `
  mutation SecretaryCreateFollowUp($input: FollowUpInput!) {
    createFollowUp(input: $input) { id }
  }
`;
const $8af4119da22d78aa$export$46118eb9f2550753 = 'secretaryCommand';
const $8af4119da22d78aa$export$957d60e9b2ce814c = 'transcription';
const $8af4119da22d78aa$export$2cc7a2eaaea7809f = Object.freeze({
    LISTENING: 'listening',
    PROCESSING: 'processing',
    RESULT: 'result',
    NO_CREDIT: 'noCredit',
    NO_MIC: 'noMic',
    ERROR: 'error'
});
const $8af4119da22d78aa$export$f2f42820b10476f7 = Object.freeze([
    'refund',
    'void_invoice',
    'take_payment',
    'cashier_shift',
    'doctor_settlement',
    'payroll',
    'expense',
    'inventory',
    'roles_and_access',
    'delete_record',
    'send_message',
    'clinical_record',
    'reschedule_or_cancel',
    'other'
]);
const $8af4119da22d78aa$export$5e789e1047917ea2 = Object.freeze([
    'call',
    'message',
    'appointment',
    'settlement',
    'other'
]);
const $8af4119da22d78aa$export$804201d3d3e57e8f = Object.freeze([
    'exact_name',
    'same_sound',
    'close_spelling',
    'part_of_name',
    'spacing',
    'longer_name',
    'file_number',
    'phone_tail',
    'appointment_soon'
]);
const $8af4119da22d78aa$export$40b2567d493c3c54 = Object.freeze([
    '1',
    '2',
    '3',
    '4',
    '5'
]);
const $8af4119da22d78aa$export$7141cadfecb4bb4f = '0';
const $8af4119da22d78aa$export$848a80d238835a6a = Object.freeze([
    'doctor',
    'phone',
    'insurance',
    'when',
    'followUpDate'
]);
const $8af4119da22d78aa$export$82886d161b378b = Object.freeze([
    'phone',
    'insurance'
]);
const $8af4119da22d78aa$export$c5a6af19f1c90732 = '0';
const $8af4119da22d78aa$export$e22df136dd762dea = Object.freeze([
    'first',
    'today',
    'tomorrow',
    'next_week'
]);
const $8af4119da22d78aa$export$242db653fb7be7f0 = Object.freeze([
    'tomorrow',
    'next_week',
    'next_month'
]);
function $8af4119da22d78aa$export$b648b0cd38d6ee12(result, closed = new Set()) {
    const open = (result?.questions || []).filter((q)=>$8af4119da22d78aa$export$848a80d238835a6a.includes(q?.kind) && !closed.has(q.kind));
    return open.find((q)=>q.blocking) || open[0] || null;
}
function $8af4119da22d78aa$export$fa13ff2bc40a02c1(result, closed = new Set()) {
    if (!result) return 'window';
    if (result.outcome === 'PROPOSAL' && result.kind === 'book_appointment' && result.booking) {
        const question = $8af4119da22d78aa$export$b648b0cd38d6ee12(result, closed);
        return question?.blocking ? 'window' : 'form';
    }
    if (result.outcome === 'NO_SLOT' && result.booking) return 'formDay';
    if (result.outcome === 'NAVIGATE' && result.patient?.id) return 'navigate';
    return 'window';
}
function $8af4119da22d78aa$export$186074bec9436fa3(result, closed = new Set()) {
    return (result?.questions || []).filter((q)=>$8af4119da22d78aa$export$848a80d238835a6a.includes(q?.kind) && q.blocking && !closed.has(q.kind)).length;
}
function $8af4119da22d78aa$export$34cef9d55b98ee60(kind, value) {
    if (kind === 'doctor') return {
        doctorId: String(value)
    };
    if (kind === 'phone') return {
        phone: String(value)
    };
    if (kind === 'insurance') return {
        insurerId: String(value)
    };
    if (kind === 'when') return {
        when: String(value)
    };
    if (kind === 'followUpDate') return {
        followUpWhen: String(value)
    };
    return null;
}
const $8af4119da22d78aa$var$DRAFT_FIELDS = [
    'kind',
    'patientId',
    'patientName',
    'doctorId',
    'fromDate',
    'toDate',
    'time',
    'timeSaid',
    'when',
    'similar',
    'followUpKind',
    'followUpNote',
    'dueDate'
];
const $8af4119da22d78aa$var$DRAFT_PATIENT_FIELDS = [
    'name',
    'phone',
    'nationalId',
    'insurance',
    'insurerId'
];
function $8af4119da22d78aa$export$2c4ca78889c4ffd0(draft) {
    if (!draft) return null;
    const out = {};
    for (const k of $8af4119da22d78aa$var$DRAFT_FIELDS)out[k] = draft[k] ?? null;
    if (draft.newPatient) {
        out.newPatient = {};
        for (const k of $8af4119da22d78aa$var$DRAFT_PATIENT_FIELDS)out.newPatient[k] = draft.newPatient[k] ?? null;
    } else out.newPatient = null;
    return out;
}
function $8af4119da22d78aa$export$146a3c40c2f2a521(previous, next) {
    if (!previous) return next;
    return {
        ...next,
        charged: Boolean(previous.charged || next.charged),
        heardName: next.heardName || previous.heardName || null,
        patients: next.patients?.length ? next.patients : previous.patients || null
    };
}
// i18n-exempt: digit CHARACTERS folded to ASCII, not copy.
const $8af4119da22d78aa$var$DIGITS = {
    persian: "\u06F0\u06F1\u06F2\u06F3\u06F4\u06F5\u06F6\u06F7\u06F8\u06F9",
    arabic: "\u0660\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669"
};
const $8af4119da22d78aa$var$foldDigits = (text)=>String(text || '').replace(/[۰-۹٠-٩]/g, (c)=>{
        const p = $8af4119da22d78aa$var$DIGITS.persian.indexOf(c);
        return String(p >= 0 ? p : $8af4119da22d78aa$var$DIGITS.arabic.indexOf(c));
    });
function $8af4119da22d78aa$export$a72c1b1565163ca(text) {
    return $8af4119da22d78aa$var$foldDigits(text).replace(/[\u064B-\u065F\u0670]/g, '') // harakat, and the hamza of «هفتهٔ»
    .replace(/[يى]/g, "\u06CC").replace(/ك/g, "\u06A9").replace(/[ةۀ]/g, "\u0647").replace(/[أإآ]/g, "\u0627").replace(/ؤ/g, "\u0648") // i18n-exempt: CHARACTERS folded, not copy
    .replace(/\u200c/g, ' ').replace(/[^\p{L}\p{N}\s]/gu, ' ').replace(/\s+/g, ' ').trim().toLowerCase();
}
// Persian number words, as a mobile is dictated: «صفر نهصد و سیزده، سیصد و پنجاه و یک».
// i18n-exempt: words PARSED out of speech, never rendered.
const $8af4119da22d78aa$var$NUMBER_WORDS = new Map(Object.entries({
    \u0635\u0641\u0631: 0,
    \u06CC\u06A9: 1,
    \u062F\u0648: 2,
    \u0633\u0647: 3,
    \u0686\u0647\u0627\u0631: 4,
    \u067E\u0646\u062C: 5,
    \u0634\u0634: 6,
    \u0634\u06CC\u0634: 6,
    \u0647\u0641\u062A: 7,
    \u0647\u0634\u062A: 8,
    \u0646\u0647: 9,
    \u062F\u0647: 10,
    \u06CC\u0627\u0632\u062F\u0647: 11,
    \u062F\u0648\u0627\u0632\u062F\u0647: 12,
    \u0633\u06CC\u0632\u062F\u0647: 13,
    \u0686\u0647\u0627\u0631\u062F\u0647: 14,
    \u067E\u0627\u0646\u0632\u062F\u0647: 15,
    \u067E\u0648\u0646\u0632\u062F\u0647: 15,
    \u0634\u0627\u0646\u0632\u062F\u0647: 16,
    \u0634\u0648\u0646\u0632\u062F\u0647: 16,
    \u0647\u0641\u062F\u0647: 17,
    \u0647\u06CC\u0641\u062F\u0647: 17,
    \u0647\u062C\u062F\u0647: 18,
    \u0647\u06CC\u062C\u062F\u0647: 18,
    \u0646\u0648\u0632\u062F\u0647: 19,
    \u0628\u06CC\u0633\u062A: 20,
    \u0633\u06CC: 30,
    \u0686\u0647\u0644: 40,
    \u067E\u0646\u062C\u0627\u0647: 50,
    \u0634\u0635\u062A: 60,
    \u0647\u0641\u062A\u0627\u062F: 70,
    \u0647\u0634\u062A\u0627\u062F: 80,
    \u0646\u0648\u062F: 90,
    \u0635\u062F: 100,
    \u06CC\u06A9\u0635\u062F: 100,
    \u062F\u0648\u06CC\u0633\u062A: 200,
    \u0633\u06CC\u0635\u062F: 300,
    \u0686\u0647\u0627\u0631\u0635\u062F: 400,
    \u067E\u0627\u0646\u0635\u062F: 500,
    \u067E\u0648\u0646\u0635\u062F: 500,
    \u0634\u0634\u0635\u062F: 600,
    \u0634\u06CC\u0634\u0635\u062F: 600,
    \u0647\u0641\u062A\u0635\u062F: 700,
    \u0647\u0634\u062A\u0635\u062F: 800,
    \u0646\u0647\u0635\u062F: 900
}));
// What a number fills — hundreds 3, tens 2, units 1 — and so what may still follow it.
const $8af4119da22d78aa$var$placeOf = (v)=>v >= 100 ? 3 : v >= 10 ? 2 : 1;
const $8af4119da22d78aa$var$roomAfter = (v)=>v >= 100 ? 2 : v >= 20 ? 1 : 0;
function $8af4119da22d78aa$export$d05343a8a7fc8a21(text) {
    const tokens = $8af4119da22d78aa$var$foldDigits(text).replace(/[يى]/g, "\u06CC").replace(/ك/g, "\u06A9") // i18n-exempt: CHARACTERS folded, not copy
    .replace(/\u200c/g, ' ').match(/\d+|[\p{L}]+|[^\s\p{L}\d]/gu) || [];
    let out = '';
    let group = null; // { value, room }
    const flush = ()=>{
        if (group) {
            out += String(group.value);
            group = null;
        }
    };
    for (const token of tokens){
        if (/^\d+$/.test(token)) {
            flush();
            out += token;
            continue;
        }
        if (token === "\u0648") continue; // i18n-exempt: «و» joins spoken number words, not copy
        const v = $8af4119da22d78aa$var$NUMBER_WORDS.get(token);
        if (v === undefined) {
            flush();
            continue;
        }
        // Zero is always a digit of its own; anything else joins a group with room for it.
        if (group && v !== 0 && $8af4119da22d78aa$var$placeOf(v) <= group.room) {
            group = {
                value: group.value + v,
                room: v < 20 ? 0 : $8af4119da22d78aa$var$roomAfter(v)
            };
            continue;
        }
        flush();
        group = v === 0 ? {
            value: 0,
            room: 0
        } : {
            value: v,
            room: $8af4119da22d78aa$var$roomAfter(v)
        };
    }
    flush();
    return out;
}
function $8af4119da22d78aa$export$86ce13b2f905bab3(digits) {
    const d = String(digits || '');
    if (/^09\d{9}$/.test(d)) return [
        d.slice(0, 4),
        d.slice(4, 7),
        d.slice(7)
    ];
    if (/^9\d{9}$/.test(d)) return [
        d.slice(0, 3),
        d.slice(3, 6),
        d.slice(6)
    ];
    const out = [];
    for(let i = 0; i < d.length; i += 3)out.push(d.slice(i, i + 3));
    if (out.length > 1 && out[out.length - 1].length === 1) out[out.length - 2] += out.pop();
    return out;
}
function $8af4119da22d78aa$export$49f046beb755c5a8(spoken, options, { exact: exact = false, ignore: ignore = [] } = {}) {
    const drop = new Set(ignore.map($8af4119da22d78aa$export$a72c1b1565163ca));
    const words = (text)=>$8af4119da22d78aa$export$a72c1b1565163ca(text).split(' ').filter((w)=>w && !drop.has(w));
    const said = words(spoken);
    if (!said.length) return null;
    const saidText = said.join(' ');
    const hits = (options || []).filter((o)=>{
        const label = words(o?.label);
        if (!label.length) return false;
        if (exact) return label.join(' ') === saidText;
        return saidText.includes(label.join(' ')) || label.some((w)=>w.length >= 3 && said.includes(w));
    });
    return hits.length === 1 ? hits[0] : null;
}
function $8af4119da22d78aa$export$fa7e7bf5f125d593(result) {
    return result?.booking?.patient || result?.arrival?.patient || result?.followUp?.patient || result?.balance?.patient || result?.patient || null;
}
function $8af4119da22d78aa$export$3c6f001f1e489099(result) {
    const current = $8af4119da22d78aa$export$fa7e7bf5f125d593(result);
    return (result?.patients || []).filter((p)=>p?.id && p.id !== current?.id);
}
const $8af4119da22d78aa$var$CREDIT_CODES = new Set([
    'INSUFFICIENT_CREDIT',
    'INSUFFICIENT_CREDITS'
]);
function $8af4119da22d78aa$export$96d5fbfea36fa4ee(err) {
    return $8af4119da22d78aa$var$CREDIT_CODES.has(err?.extensions?.code);
}
function $8af4119da22d78aa$export$9121a1345c1886bc(priceOf) {
    const minute = priceOf?.($8af4119da22d78aa$export$957d60e9b2ce814c);
    const command = priceOf?.($8af4119da22d78aa$export$46118eb9f2550753);
    if (!Number.isFinite(minute) || !Number.isFinite(command)) return null;
    return minute + command;
}
function $8af4119da22d78aa$export$7ac2ab00227c6fe5(balance, priceOf) {
    const min = $8af4119da22d78aa$export$9121a1345c1886bc(priceOf);
    return Number.isFinite(balance) && min !== null && balance < min;
}
function $8af4119da22d78aa$export$7269f8aa89a69593(dateTimeMs) {
    const minutes = (0, $5qKOB.clinicMinuteOfDay)(Number(dateTimeMs));
    if (!Number.isFinite(minutes)) return null;
    const pad = (n)=>String(n).padStart(2, '0');
    return `${pad(Math.floor(minutes / 60))}:${pad(minutes % 60)}`;
}
function $8af4119da22d78aa$export$3c7a65f8740dffe9(seconds) {
    const s = Math.max(0, Math.floor(Number(seconds) || 0));
    const pad = (n)=>String(n).padStart(2, '0');
    return `${pad(Math.floor(s / 60))}:${pad(s % 60)}`;
}
function $8af4119da22d78aa$export$8d14b304fe6a5f00(booking, slotIndex = 0) {
    if (!booking) return null;
    const slot = booking.slots?.[slotIndex] || null;
    const isNew = !!booking.patient?.isNew;
    return {
        doctorId: booking.doctor.doctorId,
        doctorAssumed: booking.doctorAssumed || null,
        patient: isNew ? null : {
            id: booking.patient.id,
            name: booking.patient.name,
            phone: ''
        },
        // Everything that was SAID about a new patient — the form fills it in and asks for the rest.
        newPatient: isNew ? {
            name: booking.patient.name,
            phone: booking.newPatient?.phone || null,
            nationalId: booking.newPatient?.nationalId || null,
            insurerId: booking.newPatient?.insurerId || null
        } : null,
        // No slot (NO_SLOT) → the form opens on the first day of the window, unpinned.
        initialDate: slot ? slot.dateTime : booking.fromMs,
        initialSlotLabel: slot ? $8af4119da22d78aa$export$7269f8aa89a69593(slot.dateTime) : null
    };
}


/**
 * «منشی هوشمند» — what came back, as notifications (PM-0080).
 *
 * A notification says what was understood and waits until it is opened or
 * dismissed: the command has already cost پارسه, so — unlike the kit's toasts,
 * one sentence that leaves after four seconds — it never leaves on a timer.
 * At most three show on a desk and two on a phone; the rest wait behind «+N».
 *
 * Desk: stacked beside the record button at the foot of the sidebar, newest
 * nearest the button — clear of the toasts, which own the opposite corner.
 * Phone: dropping from the top, newest first — the bottom already holds the bar,
 * the round button and the toasts.
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4xGOs = parcelRequire("4xGOs");
var $4l6DR = parcelRequire("4l6DR");
var $huNwV = parcelRequire("huNwV");
var $8MlIT = parcelRequire("8MlIT");/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $eea507cd16630bf5$export$a2387ed3b5d536eb = {
    name: "coins",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M13.744 17.736a6 6 0 1 1-7.48-7.48",
                key: "bq4yh3"
            }
        ],
        [
            "path",
            {
                d: "M15 6h1v4",
                key: "11y1tn"
            }
        ],
        [
            "path",
            {
                d: "m6.134 14.768.866-.5 2 3.464",
                key: "17snzx"
            }
        ],
        [
            "circle",
            {
                cx: "16",
                cy: "8",
                r: "6",
                key: "14bfc9"
            }
        ]
    ]
};
$eea507cd16630bf5$export$a2387ed3b5d536eb.node;
const $eea507cd16630bf5$export$2e2bcd8739ae039 = (0, $9QBug.default)($eea507cd16630bf5$export$a2387ed3b5d536eb);


var $8jE1c = parcelRequire("8jE1c");
var $2SsUu = parcelRequire("2SsUu");
var $6lig1 = parcelRequire("6lig1");
var $iDwyV = parcelRequire("iDwyV");
var $QG9Z3 = parcelRequire("QG9Z3");
var $dBbFF = parcelRequire("dBbFF");
var $6imzq = parcelRequire("6imzq");
var $l37hw = parcelRequire("l37hw");
var $6TdpC = parcelRequire("6TdpC");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("52bn2");
var $jTCZr = parcelRequire("jTCZr");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $ciRrJ = parcelRequire("ciRrJ");

var $9h2jQ = parcelRequire("9h2jQ");

var $9SI14 = parcelRequire("9SI14");

const $5783910e197ee713$var$TONES = {
    ok: ()=>(0, $jTCZr.C).teal,
    ask: ()=>(0, $jTCZr.C).amber,
    pick: ()=>(0, $jTCZr.C).navy,
    info: ()=>(0, $jTCZr.C).navy,
    warn: ()=>(0, $jTCZr.C).amber
};
function $5783910e197ee713$export$572d45771e66f5f2(item, tr, { canTopUp: canTopUp = true } = {}) {
    const { t: t, formatDate: formatDate, formatTime: formatTime, formatDigits: formatDigits, formatNumber: formatNumber, formatMoney: formatMoney } = tr;
    const r = item.result;
    if (item.error === 'credit') return {
        tone: 'warn',
        Icon: (0, $l37hw.default),
        title: t('secretary.noCredit.title'),
        line: item.text ? t('secretary.noCredit.afterRun') : t('secretary.noCredit.notStarted'),
        action: canTopUp ? t('secretary.notice.action.topUp') : t('secretary.notice.action.details')
    };
    if (item.error === 'failed' || !r) return {
        tone: 'warn',
        Icon: (0, $iDwyV.default),
        title: t('secretary.notice.failed'),
        line: t('secretary.notice.failedLine'),
        action: t('secretary.notice.action.retry')
    };
    const patient = (0, $8af4119da22d78aa$export$fa7e7bf5f125d593)(r);
    const name = patient?.name || r.heardName || r.detail || '';
    switch(r.outcome){
        case 'PROPOSAL':
            if (r.kind === 'book_appointment' && r.booking) {
                const b = r.booking;
                const first = b.slots?.[0];
                const line = first ? t('secretary.notice.bookLine', {
                    day: formatDate(first.dateTime, 'weekdayDayMonth'),
                    time: formatTime(first.dateTime),
                    doctor: b.doctor.name
                }) : b.doctor.name;
                const asking = (r.questions || []).filter((q)=>q?.blocking && (0, $8af4119da22d78aa$export$848a80d238835a6a).includes(q.kind));
                if (asking.length) return {
                    tone: 'ask',
                    Icon: (0, $4xGOs.default),
                    title: b.patient.isNew ? t('secretary.notice.bookNew', {
                        name: b.patient.name
                    }) : t('secretary.notice.bookFor', {
                        name: b.patient.name
                    }),
                    line: line,
                    badge: t('secretary.notice.questions', {
                        count: formatNumber(asking.length),
                        list: asking.map((q)=>t(`secretary.notice.ask.${q.kind}`)).join(t('secretary.newPatient.and'))
                    }),
                    action: t('secretary.notice.action.answer')
                };
                return {
                    tone: 'ok',
                    Icon: (0, $4xGOs.default),
                    title: t('secretary.notice.bookReady', {
                        name: b.patient.name
                    }),
                    line: line,
                    action: t('secretary.notice.action.form')
                };
            }
            if (r.kind === 'mark_arrived' && r.arrival) {
                const a = r.arrival;
                const line = !a.dateTime ? '' : a.doctorName ? t('secretary.arrival.today', {
                    time: formatTime(a.dateTime),
                    doctor: a.doctorName
                }) : t('secretary.arrival.todayNoDoctor', {
                    time: formatTime(a.dateTime)
                });
                return {
                    tone: 'ok',
                    Icon: (0, $dBbFF.default),
                    title: t('secretary.notice.arrive', {
                        name: a.patient.name
                    }),
                    line: line,
                    action: t('secretary.notice.action.arrive')
                };
            }
            if (r.kind === 'follow_up' && r.followUp) {
                const f = r.followUp;
                const kind = t(`patients.followUp.kind.${(0, $8af4119da22d78aa$export$5e789e1047917ea2).includes(f.kind) ? f.kind : 'other'}`);
                return {
                    tone: f.dueAt ? 'ok' : 'ask',
                    Icon: (0, $4l6DR.default),
                    title: t('secretary.notice.followUp', {
                        name: f.patient.name
                    }),
                    line: f.dueAt ? t('secretary.notice.followUpLine', {
                        kind: kind,
                        day: formatDate(f.dueAt, 'weekdayDayMonth')
                    }) : t('secretary.notice.followUpNoDay', {
                        kind: kind
                    }),
                    badge: f.dueAt ? null : t('secretary.notice.questions', {
                        count: formatNumber(1),
                        list: t('secretary.notice.ask.followUpDate')
                    }),
                    action: t('secretary.notice.action.followUp')
                };
            }
            break;
        case 'NO_SLOT':
            return {
                tone: 'warn',
                Icon: (0, $4l6DR.default),
                title: t('secretary.notice.noSlot'),
                line: [
                    r.booking?.patient?.name,
                    r.booking?.doctor?.name
                ].filter(Boolean).join(" \xb7 "),
                action: t('secretary.notice.action.form')
            };
        case 'CHOOSE_PATIENT':
            {
                const count = formatNumber(r.patients?.length || 0);
                const offersNew = r.kind === 'book_appointment' && Boolean(r.heardName);
                return {
                    tone: 'pick',
                    Icon: (0, $6imzq.default),
                    title: r.heardName ? t('secretary.notice.choosePatient', {
                        name: r.heardName
                    }) : t('secretary.choosePatient.title'),
                    line: offersNew ? t('secretary.notice.candidatesOrNew', {
                        count: count
                    }) : t('secretary.notice.candidates', {
                        count: count
                    }),
                    badge: t('secretary.notice.pick'),
                    action: t('secretary.notice.action.choose')
                };
            }
        case 'CHOOSE_DOCTOR':
            return {
                tone: 'pick',
                Icon: (0, $6imzq.default),
                title: t('secretary.question.title.doctor'),
                line: name ? t('secretary.notice.bookFor', {
                    name: name
                }) : '',
                badge: t('secretary.notice.pick'),
                action: t('secretary.notice.action.choose')
            };
        case 'NOT_FOUND':
            {
                const said = r.detail;
                const title = !said ? t('secretary.notFound.titleGeneric') : r.reason === 'not_booked_today' ? t('secretary.notFound.notBookedToday', {
                    name: said
                }) : r.reason === 'no_such_patient' ? t('secretary.notFound.noSuchPatient', {
                    name: said
                }) : t('secretary.notFound.title', {
                    name: said
                });
                return {
                    tone: 'warn',
                    Icon: (0, $8MlIT.default),
                    title: title,
                    line: r.patients?.length ? t('secretary.notice.closest') : '',
                    action: t('secretary.notice.action.details')
                };
            }
        case 'NOTHING_TO_DO':
            return {
                tone: 'info',
                Icon: (0, $huNwV.default),
                title: t('secretary.arrival.nothingTitle'),
                line: r.arrival?.patient?.name || '',
                action: t('secretary.notice.action.details')
            };
        case 'NAVIGATE':
            return {
                tone: 'ok',
                Icon: (0, $8jE1c.default),
                title: t('secretary.notice.openRecord', {
                    name: name
                }),
                line: patient?.fileNumber ? t('secretary.choosePatient.file', {
                    file: formatDigits(patient.fileNumber)
                }) : '',
                action: t('secretary.notice.action.record')
            };
        case 'ANSWER':
            if (r.kind === 'patient_balance' && r.balance) {
                const b = r.balance;
                return {
                    tone: 'info',
                    Icon: (0, $eea507cd16630bf5$export$2e2bcd8739ae039),
                    title: b.outstanding > 0 ? t('secretary.notice.balance', {
                        name: b.patient.name,
                        amount: formatMoney(b.outstanding, {
                            currency: b.currency,
                            withUnit: true
                        })
                    }) : t('secretary.notice.balanceNone', {
                        name: b.patient.name
                    }),
                    line: b.outstanding > 0 ? t('secretary.balance.openInvoices', {
                        count: formatNumber(b.openInvoices)
                    }) : '',
                    action: t('secretary.notice.action.details')
                };
            }
            if (r.kind === 'day_summary' && r.daySummary) {
                const d = r.daySummary;
                return {
                    tone: 'info',
                    Icon: (0, $2SsUu.default),
                    title: t('secretary.notice.daySummary', {
                        total: formatNumber(d.total)
                    }),
                    line: t('secretary.notice.daySummaryLine', {
                        arrived: formatNumber(d.arrived),
                        completed: formatNumber(d.completed),
                        scheduled: formatNumber(d.scheduled)
                    }),
                    action: t('secretary.notice.action.details')
                };
            }
            break;
        case 'FORBIDDEN':
            return {
                tone: 'warn',
                Icon: (0, $6lig1.default),
                title: t('secretary.forbidden.title'),
                line: t('secretary.forbidden.hint'),
                action: t('secretary.notice.action.details')
            };
        case 'OUT_OF_SCOPE':
            return {
                tone: 'warn',
                Icon: (0, $QG9Z3.default),
                title: t('secretary.outOfScope.title'),
                line: '',
                action: t('secretary.notice.action.details')
            };
        case 'UNAVAILABLE':
            return {
                tone: 'warn',
                Icon: (0, $8MlIT.default),
                title: t('secretary.unavailable.title'),
                line: '',
                action: t('secretary.notice.action.details')
            };
        default:
            break;
    }
    return {
        tone: 'warn',
        Icon: (0, $8MlIT.default),
        title: t('secretary.unknown.title'),
        line: t('secretary.notice.unknownLine'),
        action: t('secretary.notice.action.fix')
    };
}
function $5783910e197ee713$var$Notice({ item: item, newest: newest, onOpen: onOpen, onDismiss: onDismiss, tr: tr, isMobile: isMobile }) {
    const { t: t, formatTime: formatTime } = tr;
    const canTopUp = (0, $9SI14.useCreditPurchase)(item.error === 'credit');
    const d = $5783910e197ee713$export$572d45771e66f5f2(item, tr, {
        canTopUp: canTopUp
    });
    const tone = $5783910e197ee713$var$TONES[d.tone]?.() || (0, $jTCZr.C).navy;
    const { Icon: Icon } = d;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        role: "group",
        "aria-label": d.title,
        "data-testid": `secretary-notice-${item.id}`,
        "data-tone": d.tone,
        style: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: 4,
            padding: 4,
            borderRadius: 14,
            background: (0, $jTCZr.C).card,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            boxShadow: '0 10px 28px rgba(13, 27, 38, 0.16), 0 1px 3px rgba(13, 27, 38, 0.10)'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                type: "button",
                onClick: onOpen,
                "aria-keyshortcuts": newest && !isMobile ? 'Shift+F1' : undefined,
                "data-testid": "secretary-notice-open",
                style: {
                    flex: 1,
                    minWidth: 0,
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: 10,
                    padding: '8px 8px 8px 4px',
                    border: 0,
                    borderRadius: 11,
                    background: 'transparent',
                    color: (0, $jTCZr.C).textPrimary,
                    textAlign: 'start',
                    fontFamily: 'inherit',
                    cursor: 'pointer'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        "aria-hidden": "true",
                        style: {
                            width: 36,
                            height: 36,
                            flexShrink: 0,
                            borderRadius: 11,
                            display: 'grid',
                            placeItems: 'center',
                            background: (0, $jTCZr.soft)(tone, 0.14),
                            color: tone
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, {
                            size: 18
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        style: {
                            flex: 1,
                            minWidth: 0,
                            display: 'grid',
                            gap: 1
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                dir: "auto",
                                style: {
                                    fontSize: '0.875rem',
                                    fontWeight: 800,
                                    lineHeight: 1.45
                                },
                                "data-testid": "secretary-notice-title",
                                children: d.title
                            }),
                            d.line ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                dir: "auto",
                                style: {
                                    fontSize: '0.78125rem',
                                    color: (0, $jTCZr.C).textSecondary
                                },
                                children: d.line
                            }) : null,
                            item.text ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                dir: "auto",
                                style: {
                                    fontSize: '0.75rem',
                                    color: (0, $jTCZr.C).textMuted,
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis'
                                },
                                children: t('secretary.notice.heard', {
                                    text: item.text
                                })
                            }) : null,
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                style: {
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    alignItems: 'center',
                                    gap: '4px 10px',
                                    marginTop: 5
                                },
                                children: [
                                    d.badge ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            fontSize: '0.71875rem',
                                            fontWeight: 700,
                                            padding: '0 9px',
                                            borderRadius: 999,
                                            background: (0, $jTCZr.soft)(tone, 0.14),
                                            color: tone,
                                            whiteSpace: 'nowrap'
                                        },
                                        "data-testid": "secretary-notice-badge",
                                        children: d.badge
                                    }) : null,
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        style: {
                                            fontSize: '0.78125rem',
                                            fontWeight: 800,
                                            color: (0, $jTCZr.C).navy,
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            gap: 6
                                        },
                                        children: [
                                            d.action,
                                            newest && !isMobile ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ciRrJ.Kbd), {
                                                combo: "shift+f1",
                                                style: {
                                                    background: (0, $jTCZr.C).bg,
                                                    border: `1px solid ${(0, $jTCZr.C).border}`,
                                                    color: (0, $jTCZr.C).textSecondary
                                                }
                                            }) : null
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            marginInlineStart: 'auto',
                                            fontSize: '0.71875rem',
                                            color: (0, $jTCZr.C).textMuted
                                        },
                                        children: formatTime(item.createdAt)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                type: "button",
                onClick: onDismiss,
                "aria-label": t('secretary.notice.dismiss'),
                title: t('secretary.notice.dismiss'),
                "data-testid": "secretary-notice-dismiss",
                style: {
                    width: 28,
                    height: 28,
                    flexShrink: 0,
                    marginTop: 4,
                    border: 0,
                    borderRadius: 8,
                    background: 'transparent',
                    color: (0, $jTCZr.C).textMuted,
                    display: 'grid',
                    placeItems: 'center',
                    cursor: 'pointer'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6TdpC.default), {
                    size: 15,
                    "aria-hidden": "true"
                })
            })
        ]
    });
}
function $5783910e197ee713$export$2e2bcd8739ae039({ items: items, onOpen: onOpen, onDismiss: onDismiss, sidebarWidth: sidebarWidth = 0 }) {
    const tr = (0, $e1LEq.default)();
    const { isMobile: isMobile } = (0, $9h2jQ.default)();
    const [expanded, setExpanded] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (items.length <= (isMobile ? 2 : 3)) setExpanded(false);
    }, [
        items.length,
        isMobile
    ]);
    if (!items.length) return null;
    const max = isMobile ? 2 : 3;
    const newestFirst = [
        ...items
    ].reverse();
    const shown = expanded ? newestFirst : newestFirst.slice(0, max);
    const rest = newestFirst.length - shown.length;
    // Newest nearest the button: last in the column on a desk, first on a phone.
    const ordered = isMobile ? shown : [
        ...shown
    ].reverse();
    const more = rest > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
        type: "button",
        onClick: ()=>setExpanded(true),
        "data-testid": "secretary-notices-more",
        style: {
            alignSelf: 'center',
            border: `1px solid ${(0, $jTCZr.C).border}`,
            borderRadius: 999,
            background: (0, $jTCZr.C).card,
            color: (0, $jTCZr.C).textSecondary,
            fontFamily: 'inherit',
            fontSize: '0.75rem',
            fontWeight: 700,
            padding: '2px 12px',
            cursor: 'pointer'
        },
        children: tr.t('secretary.notice.more', {
            count: tr.formatNumber(rest)
        })
    }) : null;
    const place = isMobile ? {
        position: 'fixed',
        top: 'calc(env(safe-area-inset-top, 0px) + 10px)',
        insetInline: 10,
        zIndex: 85
    } : {
        position: 'fixed',
        bottom: 16,
        insetInlineStart: sidebarWidth + 16,
        width: 360,
        zIndex: 60
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        "aria-label": tr.t('secretary.notice.listLabel'),
        "data-testid": "secretary-notices",
        style: {
            ...place,
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
            maxHeight: 'calc(100dvh - 32px)',
            overflowY: expanded ? 'auto' : 'visible'
        },
        children: [
            isMobile ? null : more,
            ordered.map((item)=>/*#__PURE__*/ (0, $ayMG0.jsx)($5783910e197ee713$var$Notice, {
                    item: item,
                    newest: item === newestFirst[0],
                    onOpen: ()=>onOpen(item),
                    onDismiss: ()=>onDismiss(item.id),
                    tr: tr,
                    isMobile: isMobile
                }, item.id)),
            isMobile ? more : null
        ]
    });
}


/**
 * «منشی هوشمند پارسینا» — one result's window (PM-0080). Render-only: the session
 * is `useSecretary`, the documents and rules are `model.js`.
 *
 * The record button records a command and runs it in the background; its result
 * waits as a notification, and opening that opens THIS — but only when something
 * has to be answered or chosen first (model.routeOf). A booking with nothing
 * missing skips it and opens «ثبت نوبت» itself. Nothing here writes on its own.
 *
 * WHICH patient was meant is the BFF's call, from patientmanagement's ranking of
 * the clinic by sound (PM-0080). Every candidate shows its score and why it matched;
 * «کدام‌یک؟» is answered with one key (1–5, and 0 for «بیمار جدید است» on a booking);
 * a booking for nobody on file goes on as a NEW patient, registered by the form.
 * What the sentence left out is asked on the sheet, one question at a time
 * (QuestionCard) — answered with a tap, a key or a few words.
 *
 * A booking leaves through `onBook` to the existing «ثبت نوبت» form, opened
 * prefilled; «ثبت حضور» and «ثبت پیگیری» are the two writes the
 * sheet commits itself, each with the operation that already existed for it and
 * only on the user's own press. AI-prepared content carries the «پیشنهاد هوش
 * مصنوعی» badge (DESIGN_CONCEPT §13.3); a figure in an answer is the service's.
 *
 * The surface is `AdaptiveModal` — the kit `Dialog` on a desk, `MobileSheet` on a
 * phone — the same one «ثبت نوبت» opens in.
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $huNwV = parcelRequire("huNwV");
var $gKFEi = parcelRequire("gKFEi");
var $8MlIT = parcelRequire("8MlIT");
var $kMJsW = parcelRequire("kMJsW");
var $6lig1 = parcelRequire("6lig1");/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $823ddab00873574d$export$a2387ed3b5d536eb = {
    name: "message-square-plus",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
                key: "18887p"
            }
        ],
        [
            "path",
            {
                d: "M12 8v6",
                key: "1ib9pf"
            }
        ],
        [
            "path",
            {
                d: "M9 11h6",
                key: "1fldmi"
            }
        ]
    ]
};
$823ddab00873574d$export$a2387ed3b5d536eb.node;
const $823ddab00873574d$export$2e2bcd8739ae039 = (0, $9QBug.default)($823ddab00873574d$export$a2387ed3b5d536eb);


var $hSPBf = parcelRequire("hSPBf");
var $3HcoA = parcelRequire("3HcoA");
var $7udIf = parcelRequire("7udIf");
var $QG9Z3 = parcelRequire("QG9Z3");/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $ff4d96da330336c2$export$a2387ed3b5d536eb = {
    name: "user",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2",
                key: "975kel"
            }
        ],
        [
            "circle",
            {
                cx: "12",
                cy: "7",
                r: "4",
                key: "17ys0d"
            }
        ]
    ]
};
$ff4d96da330336c2$export$a2387ed3b5d536eb.node;
const $ff4d96da330336c2$export$2e2bcd8739ae039 = (0, $9QBug.default)($ff4d96da330336c2$export$a2387ed3b5d536eb);


var $aIxvs = parcelRequire("aIxvs");
var $6TdpC = parcelRequire("6TdpC");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $bHjRG = parcelRequire("bHjRG");
var $aJ1FU = parcelRequire("aJ1FU");
var $h4ZeB = parcelRequire("h4ZeB");
var $66joL = parcelRequire("66joL");
var $7h7Jc = parcelRequire("7h7Jc");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("52bn2");
var $jTCZr = parcelRequire("jTCZr");

var $7guRV = parcelRequire("7guRV");

var $jmIrn = parcelRequire("jmIrn");

var $jVdQx = parcelRequire("jVdQx");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $2Mst8 = parcelRequire("2Mst8");

var $6P09x = parcelRequire("6P09x");

var $d7OV8 = parcelRequire("d7OV8");

var $iAkVL = parcelRequire("iAkVL");

var $9SI14 = parcelRequire("9SI14");

var $ciRrJ = parcelRequire("ciRrJ");

var $9h2jQ = parcelRequire("9h2jQ");

/**
 * «منشی هوشمند پارسینا» — one result's session, behind its window (PM-0080).
 * Logic only: state, the microphone, the BFF calls. The screen is SecretaryWindow.jsx.
 *
 * The COMMAND was recorded and run by the record button (useSecretaryController);
 * this session opens on what it brought back — `initial`: the text, the result and
 * whatever was already chosen or answered — and finishes it:
 *
 *   result ── choose a patient (or «بیمار جدید»), a doctor, or correct the text ──► processing ──► result
 *     │
 *     └── «ادامه بگویید» ──► listening ──► the recording is APPENDED to what was heard,
 *                                          and the whole sentence runs again
 *
 * Every change goes back to the item through `onChange`, so closing the window
 * loses nothing: the notification comes back as it was left. «دوباره بگویید» is
 * a NEW command, so it belongs to the record button (`onRecordAgain`).
 *
 * ── SPEECH IS SERVER-SIDE, AND STARTING IS THE USER'S PRESS ──────────────────
 * The audio goes to the BFF's /ws/transcribe stream (`useServerVoiceInput`), never
 * to the browser's Web Speech API (PM-0013). Nothing here starts on a timer: a
 * recording starts on «ادامه بگویید», or — below — when a question the desk opened
 * asks for an answer.
 *
 * ── WHAT THE SENTENCE LEFT OUT ───────────────────────────────────────────────
 * A result may carry `questions` (model.openQuestion), answered ON the sheet: a
 * tapped quick answer, or a mobile the desk confirmed after it was read back, goes
 * to refineSecretaryCommand — rebuilt in code, no model, no پارسه. A blocking
 * question opens the microphone by itself (the user's press opened the secretary,
 * and the sheet asked), and that recording ends by itself on silence
 * (silenceDetector.js); one that never hears speech is thrown away unsent. Only a
 * FREE spoken answer («پنجشنبه عصر») is added to the sentence and runs the command
 * again. What a tap or a read-back settled travels with every later run as `facts`
 * — words the planner reads — so running the sentence again never forgets a mobile
 * the desk already confirmed.
 *
 * ── A COMMAND IS ASKED ONCE ──────────────────────────────────────────────────
 * `runId` makes a superseded answer inert: «دوباره بگویید» while a slow answer is
 * still in flight must not have that answer land on top of the new recording.
 */ 
var $acw62 = parcelRequire("acw62");

var $2Mst8 = parcelRequire("2Mst8");

var $5bPPa = parcelRequire("5bPPa");

var $cqw4c = parcelRequire("cqw4c");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

const $e5b7dbbee71b145f$var$MIC_FAILURES = new Set([
    'denied',
    'unsupported',
    'error'
]);
// A microphone that refused once is not opened again by itself.
const $e5b7dbbee71b145f$var$MIC_REFUSED = new Set([
    'denied',
    'unsupported'
]);
// Words that do not tell one quick answer from another.
// i18n-exempt: words MATCHED in a spoken answer, never rendered.
const $e5b7dbbee71b145f$var$IGNORED_WORDS = {
    doctor: [
        "\u062F\u06A9\u062A\u0631",
        "\u062E\u0627\u0646\u0645",
        "\u0622\u0642\u0627\u06CC",
        "\u0622\u0642\u0627",
        "\u067E\u06CC\u0634",
        "\u0628\u0627",
        'doctor',
        'dr',
        "\u0627\u0644\u062F\u0643\u062A\u0648\u0631",
        "\u062F\u0643\u062A\u0648\u0631"
    ],
    insurance: [
        "\u0628\u06CC\u0645\u0647",
        'insurance'
    ]
};
// A choice must BE the chip; anything more goes back to the planner.
const $e5b7dbbee71b145f$var$CHOICE_KINDS = new Set([
    'when',
    'followUpDate'
]);
/** Where a window opens: on the item's error, else on its result. */ function $e5b7dbbee71b145f$var$phaseOf(initial) {
    if (initial?.error === 'credit') return (0, $8af4119da22d78aa$export$2cc7a2eaaea7809f).NO_CREDIT;
    if (initial?.error === 'failed' || !initial?.result) return (0, $8af4119da22d78aa$export$2cc7a2eaaea7809f).ERROR;
    return (0, $8af4119da22d78aa$export$2cc7a2eaaea7809f).RESULT;
}
function $e5b7dbbee71b145f$export$fe6e2a80470eaba2({ initial: initial = null, onChange: onChange = null, onRecordAgain: onRecordAgain = null } = {}) {
    const { t: t } = (0, $e1LEq.default)();
    // The ends of an ANSWER's recording, read through refs: they are defined further down.
    const onSilenceRef = (0, $acw62.useRef)(null);
    const onNoSpeechRef = (0, $acw62.useRef)(null);
    const onNoAutoStopRef = (0, $acw62.useRef)(null);
    const voice = (0, $cqw4c.useServerVoiceInput)({
        onSilence: ()=>onSilenceRef.current?.(),
        onNoSpeech: ()=>onNoSpeechRef.current?.(),
        onAutoStopUnavailable: ()=>onNoAutoStopRef.current?.()
    });
    const credits = (0, $5bPPa.useCredits)();
    const [phase, setPhase] = (0, $acw62.useState)(()=>$e5b7dbbee71b145f$var$phaseOf(initial));
    const [text, setText] = (0, $acw62.useState)(initial?.text || '');
    const [result, setResult] = (0, $acw62.useState)(initial?.result || null);
    const [selections, setSelections] = (0, $acw62.useState)(initial?.selections || {});
    const [seconds, setSeconds] = (0, $acw62.useState)(0);
    // Whether «پارسه کافی نیست» was found BEFORE recording (nothing ran) or by the server.
    const [creditAfterRun, setCreditAfterRun] = (0, $acw62.useState)(initial?.error === 'credit' && Boolean(initial?.text));
    // Questions closed in this command: skipped (the form asks), and answered.
    const [skipped, setSkipped] = (0, $acw62.useState)(()=>new Set(initial?.skipped || []));
    const [answered, setAnswered] = (0, $acw62.useState)(()=>new Set(initial?.answered || []));
    // The answer under way: { kind, stage: listening | hearing | readback | refining | idle,
    // digits, heard, note, manual }.
    const [answer, setAnswerState] = (0, $acw62.useState)(null);
    // The voice hook's callbacks are read through a ref so the effects below depend
    // on what the session is doing, not on the hook's identity from render to render.
    const voiceRef = (0, $acw62.useRef)(voice);
    voiceRef.current = voice;
    const creditsRef = (0, $acw62.useRef)(credits);
    creditsRef.current = credits;
    const resultRef = (0, $acw62.useRef)(result);
    resultRef.current = result;
    const textRef = (0, $acw62.useRef)(text);
    textRef.current = text;
    const selectionsRef = (0, $acw62.useRef)(selections);
    selectionsRef.current = selections;
    const skippedRef = (0, $acw62.useRef)(skipped);
    skippedRef.current = skipped;
    const answerRef = (0, $acw62.useRef)(answer);
    const runId = (0, $acw62.useRef)(0);
    // What answers settled, as words the planner reads — added to every later run.
    const facts = (0, $acw62.useRef)(new Map(initial?.facts || []));
    const onChangeRef = (0, $acw62.useRef)(onChange);
    onChangeRef.current = onChange;
    const onRecordAgainRef = (0, $acw62.useRef)(onRecordAgain);
    onRecordAgainRef.current = onRecordAgain;
    // «ادامه بگویید»: the recording under way adds to `text` instead of replacing it.
    const appending = (0, $acw62.useRef)(false);
    const [continuing, setContinuing] = (0, $acw62.useState)(false);
    // An answer's recording ends from outside React (the silence watch): the ref is
    // what those callbacks read, so it moves with the state, never a render behind.
    const setAnswer = (0, $acw62.useCallback)((next)=>{
        answerRef.current = next;
        setAnswerState(next);
    }, []);
    const listen = (0, $acw62.useCallback)(()=>{
        setSeconds(0);
        setPhase((0, $8af4119da22d78aa$export$2cc7a2eaaea7809f).LISTENING);
        voiceRef.current.start();
    }, []);
    // ── Everything the session settles goes back to its item ────────────────────
    const reported = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        // Not the values it opened with: they came FROM the item.
        if (!reported.current) {
            reported.current = true;
            return;
        }
        onChangeRef.current?.({
            text: text,
            result: result,
            selections: selections,
            skipped: [
                ...skipped
            ],
            answered: [
                ...answered
            ],
            facts: [
                ...facts.current.entries()
            ],
            error: phase === (0, $8af4119da22d78aa$export$2cc7a2eaaea7809f).NO_CREDIT ? 'credit' : phase === (0, $8af4119da22d78aa$export$2cc7a2eaaea7809f).ERROR ? 'failed' : null
        });
    }, [
        text,
        result,
        selections,
        skipped,
        answered,
        phase
    ]);
    // ── The microphone refused ──────────────────────────────────────────────────
    (0, $acw62.useEffect)(()=>{
        if (phase === (0, $8af4119da22d78aa$export$2cc7a2eaaea7809f).LISTENING && $e5b7dbbee71b145f$var$MIC_FAILURES.has(voice.status)) setPhase((0, $8af4119da22d78aa$export$2cc7a2eaaea7809f).NO_MIC);
        // An answer's recording failing leaves the sheet as it is: the quick answers still work.
        const a = answerRef.current;
        if (phase === (0, $8af4119da22d78aa$export$2cc7a2eaaea7809f).RESULT && a?.stage === 'listening' && $e5b7dbbee71b145f$var$MIC_FAILURES.has(voice.status)) setAnswer({
            kind: a.kind,
            stage: 'idle',
            note: 'mic'
        });
    }, [
        phase,
        voice.status,
        setAnswer
    ]);
    // ── The recording clock: what is on screen while the meter runs ─────────────
    const recording = phase === (0, $8af4119da22d78aa$export$2cc7a2eaaea7809f).LISTENING && voice.status === 'listening';
    (0, $acw62.useEffect)(()=>{
        if (!recording) return undefined;
        const id = setInterval(()=>setSeconds((s)=>s + 1), 1000);
        return ()=>clearInterval(id);
    }, [
        recording
    ]);
    // Leaving the overlay releases the microphone, whatever state it was in.
    (0, $acw62.useEffect)(()=>()=>{
            runId.current += 1;
            voiceRef.current.cancel();
        }, []);
    /** Forget every answer of the command: a NEW command starts from nothing. */ const forgetAnswers = (0, $acw62.useCallback)(()=>{
        facts.current = new Map();
        setSkipped(new Set());
        setAnswered(new Set());
        setAnswer(null);
    }, [
        setAnswer
    ]);
    const submit = (0, $acw62.useCallback)(async (transcript, chosen = {})=>{
        const id = runId.current + 1;
        runId.current = id;
        // A question still listening is not the answer to this run: drop it, unsent.
        if (answerRef.current?.stage === 'listening') voiceRef.current.cancel();
        setSelections(chosen);
        setAnswer(null);
        setPhase((0, $8af4119da22d78aa$export$2cc7a2eaaea7809f).PROCESSING);
        try {
            const data = await (0, $2Mst8.bffMutation)((0, $8af4119da22d78aa$export$a08e426fe22a33ae), {
                input: {
                    transcript: [
                        transcript,
                        ...facts.current.values()
                    ].join(' ').trim(),
                    patientId: chosen.patientId || null,
                    doctorId: chosen.doctorId || null,
                    newPatient: !!chosen.newPatient,
                    // This panel answers what the sentence left out (refineSecretaryCommand).
                    questions: true
                }
            });
            if (id !== runId.current) return;
            setResult(data?.runSecretaryCommand || {
                outcome: 'UNKNOWN',
                charged: false
            });
            setPhase((0, $8af4119da22d78aa$export$2cc7a2eaaea7809f).RESULT);
        } catch (err) {
            if (id !== runId.current) return;
            if ((0, $8af4119da22d78aa$export$96d5fbfea36fa4ee)(err)) {
                setCreditAfterRun(true);
                setPhase((0, $8af4119da22d78aa$export$2cc7a2eaaea7809f).NO_CREDIT);
            } else setPhase((0, $8af4119da22d78aa$export$2cc7a2eaaea7809f).ERROR);
        } finally{
            // The balance on the sidebar and the next «can I afford it» both read this.
            creditsRef.current.refresh?.();
        }
    }, [
        setAnswer
    ]);
    /** «توقف و اجرا» — stop recording, take the server's final transcript, run it. */ const finish = (0, $acw62.useCallback)(async ()=>{
        // Not before the stream is up: a stop pressed while the microphone is still
        // connecting would send nothing and answer «چیزی نشنیدم» to someone who has not
        // been heard yet.
        if (phase !== (0, $8af4119da22d78aa$export$2cc7a2eaaea7809f).LISTENING || voiceRef.current.status !== 'listening') return;
        const id = runId.current + 1;
        runId.current = id;
        setPhase((0, $8af4119da22d78aa$export$2cc7a2eaaea7809f).PROCESSING);
        const heard = String(await voiceRef.current.finishTranscript() || '').trim();
        if (id !== runId.current) return;
        if (appending.current) {
            appending.current = false;
            setContinuing(false);
            // Nothing added: the sheet comes back as it was, and nothing is run or charged.
            if (!heard) {
                setPhase((0, $8af4119da22d78aa$export$2cc7a2eaaea7809f).RESULT);
                return;
            }
            const whole = `${text} ${heard}`.trim();
            setText(whole);
            // The same command, said more fully: the choices already made still stand.
            await submit(whole, selections);
            return;
        }
        setText(heard);
        if (!heard) {
            // Nothing to send: no command was run, so nothing is asked of the BFF.
            setResult({
                outcome: 'UNKNOWN',
                reason: 'nothing_heard',
                charged: false
            });
            setPhase((0, $8af4119da22d78aa$export$2cc7a2eaaea7809f).RESULT);
            return;
        }
        await submit(heard, {});
    }, [
        phase,
        submit,
        text,
        selections
    ]);
    /** «دوباره بگویید» — drop this command; the record button records the new one. */ const again = (0, $acw62.useCallback)(()=>{
        runId.current += 1;
        voiceRef.current.cancel();
        appending.current = false;
        setContinuing(false);
        onRecordAgainRef.current?.();
    }, []);
    /** «اجرا با این متن» — the user corrected what was heard. A new command, no selections. */ const runEdited = (0, $acw62.useCallback)((edited)=>{
        const next = String(edited || '').trim();
        if (!next) return;
        forgetAnswers();
        setText(next);
        submit(next, {});
    }, [
        submit,
        forgetAnswers
    ]);
    const retry = (0, $acw62.useCallback)(()=>submit(text, selections), [
        submit,
        text,
        selections
    ]);
    /**
   * «ادامه بگویید» — record MORE of the same command: the mobile, the insurer, the
   * hour the sheet says is missing. What is heard is appended to the sentence so far.
   */ const continueSpeaking = (0, $acw62.useCallback)(()=>{
        if (!text) return;
        runId.current += 1;
        voiceRef.current.cancel();
        setAnswer(null);
        appending.current = true;
        setContinuing(true);
        listen();
    }, [
        listen,
        text,
        setAnswer
    ]);
    /** Back out of «ادامه بگویید» to the sheet as it was — nothing recorded is used. */ const cancelContinue = (0, $acw62.useCallback)(()=>{
        runId.current += 1;
        voiceRef.current.cancel();
        appending.current = false;
        setContinuing(false);
        setPhase(result ? (0, $8af4119da22d78aa$export$2cc7a2eaaea7809f).RESULT : (0, $8af4119da22d78aa$export$2cc7a2eaaea7809f).LISTENING);
    }, [
        result
    ]);
    // ── Answers ─────────────────────────────────────────────────────────────────
    /** A question's quick answers, each with the words the desk reads (and may say). */ const optionsOf = (0, $acw62.useCallback)((question)=>(question?.options || []).map((o)=>({
                ...o,
                label: $e5b7dbbee71b145f$var$CHOICE_KINDS.has(question.kind) ? t(`secretary.question.choice.${question.kind}.${o.value}`) : o.label || ''
            })), [
        t
    ]);
    /**
   * An answer the BFF can take as it is: rebuilt in code from the result's draft.
   * The recording, if one is open, is dropped unsent — the tap is the answer.
   */ const refine = (0, $acw62.useCallback)(async (kind, value, label)=>{
        const current = resultRef.current;
        const answerInput = (0, $8af4119da22d78aa$export$34cef9d55b98ee60)(kind, value);
        if (!current?.draft || !answerInput) return;
        const id = runId.current + 1;
        runId.current = id;
        voiceRef.current.cancel();
        setAnswer({
            kind: kind,
            stage: 'refining'
        });
        try {
            const data = await (0, $2Mst8.bffQuery)((0, $8af4119da22d78aa$export$1d585b0310ad88ad), {
                draft: (0, $8af4119da22d78aa$export$2c4ca78889c4ffd0)(current.draft),
                answer: answerInput
            });
            if (id !== runId.current) return;
            const next = data?.refineSecretaryCommand;
            if (!next) throw new Error('refineSecretaryCommand returned nothing');
            // Still asked: the answer did not settle it (a mobile the clinic cannot use).
            const still = (next.questions || []).some((q)=>q.kind === kind && q.blocking);
            if (!still) {
                if (kind === 'doctor') setSelections((s)=>({
                        ...s,
                        doctorId: String(value)
                    }));
                else if (kind === 'when' && value === 'first') facts.current.delete('when');
                else facts.current.set(kind, t(`secretary.question.fact.${kind}`, {
                    value: label || value
                }));
                if (kind !== 'when') setAnswered((s)=>new Set(s).add(kind));
            }
            setAnswer(still && kind === 'phone' ? {
                kind: kind,
                stage: 'idle',
                note: 'invalid_phone',
                heard: String(value)
            } : null);
            setResult((0, $8af4119da22d78aa$export$146a3c40c2f2a521)(current, next));
        } catch  {
            if (id !== runId.current) return;
            setAnswer({
                kind: kind,
                stage: 'idle',
                note: 'failed'
            });
        }
    }, [
        t,
        setAnswer
    ]);
    /** What a spoken answer was: digits to read back, a quick answer, or — for a time — more of the sentence. */ const heardAnswer = (0, $acw62.useCallback)((kind, heard)=>{
        const question = (0, $8af4119da22d78aa$export$b648b0cd38d6ee12)(resultRef.current, skippedRef.current);
        if (!question || question.kind !== kind) {
            setAnswer(null);
            return;
        }
        if (!heard) {
            setAnswer({
                kind: kind,
                stage: 'idle',
                note: 'not_heard'
            });
            return;
        }
        if (kind === 'phone') {
            // Never used as heard: speech gets digits wrong, so the desk reads them first.
            const digits = (0, $8af4119da22d78aa$export$d05343a8a7fc8a21)(heard);
            setAnswer(digits ? {
                kind: kind,
                stage: 'readback',
                digits: digits,
                heard: heard
            } : {
                kind: kind,
                stage: 'idle',
                note: 'no_digits',
                heard: heard
            });
            return;
        }
        const choice = $e5b7dbbee71b145f$var$CHOICE_KINDS.has(kind);
        const hit = (0, $8af4119da22d78aa$export$49f046beb755c5a8)(heard, optionsOf(question), {
            exact: choice,
            ignore: $e5b7dbbee71b145f$var$IGNORED_WORDS[kind] || []
        });
        if (hit) {
            refine(kind, hit.value, hit.label);
            return;
        }
        if (choice) {
            // A free answer («پنجشنبه عصر») is more of the sentence, as «ادامه بگویید» is: it
            // is added to what was heard, replaces a chip tapped for the same question, and
            // the command runs again.
            facts.current.delete(kind);
            const whole = `${textRef.current} ${heard}`.trim();
            setText(whole);
            submit(whole, selectionsRef.current);
            return;
        }
        setAnswer({
            kind: kind,
            stage: 'idle',
            note: 'not_matched',
            heard: heard
        });
    }, [
        optionsOf,
        refine,
        submit,
        setAnswer
    ]);
    /** Listen for the answer to the question on screen. Ends by itself on silence. */ const answerByVoice = (0, $acw62.useCallback)((options = {})=>{
        const question = (0, $8af4119da22d78aa$export$b648b0cd38d6ee12)(resultRef.current, skippedRef.current);
        if (!question) return;
        runId.current += 1;
        voiceRef.current.cancel();
        const previous = answerRef.current;
        // «این شماره درست نیست» stays on screen while the number is asked for again.
        const note = options.keepNote && previous?.kind === question.kind ? previous.note || null : null;
        setAnswer({
            kind: question.kind,
            stage: 'listening',
            note: note,
            manual: false
        });
        voiceRef.current.start({
            autoStop: true
        });
    }, [
        setAnswer
    ]);
    /** The answer's recording is over: take what the server heard. */ const finishAnswer = (0, $acw62.useCallback)(async ()=>{
        const a = answerRef.current;
        // Not before the stream is up — the same rule as «توقف و اجرا».
        if (!a || a.stage !== 'listening' || voiceRef.current.status !== 'listening') return;
        const id = runId.current + 1;
        runId.current = id;
        setAnswer({
            ...a,
            stage: 'hearing',
            manual: false
        });
        const heard = String(await voiceRef.current.finishTranscript() || '').trim();
        if (id !== runId.current) return;
        heardAnswer(a.kind, heard);
    }, [
        heardAnswer,
        setAnswer
    ]);
    /** Stop listening for an answer — nothing recorded is sent, the question stays. */ const cancelAnswer = (0, $acw62.useCallback)(()=>{
        const a = answerRef.current;
        if (!a || a.stage !== 'listening' && a.stage !== 'hearing') return;
        runId.current += 1;
        voiceRef.current.cancel();
        setAnswer(null);
    }, [
        setAnswer
    ]);
    onSilenceRef.current = finishAnswer;
    onNoSpeechRef.current = ()=>{
        const a = answerRef.current;
        if (!a || a.stage !== 'listening') return;
        // Nobody answered: the recording is thrown away unsent — and so costs nothing.
        voiceRef.current.cancel();
        setAnswer({
            kind: a.kind,
            stage: 'idle',
            note: 'not_heard'
        });
    };
    onNoAutoStopRef.current = ()=>{
        const a = answerRef.current;
        // This browser will not let the level be read: the desk ends the answer itself.
        if (a?.stage === 'listening') setAnswer({
            ...a,
            manual: true
        });
    };
    /** A tapped quick answer (a chip, or keys 1–5). */ const answerWith = (0, $acw62.useCallback)((value)=>{
        const question = (0, $8af4119da22d78aa$export$b648b0cd38d6ee12)(resultRef.current, skippedRef.current);
        if (!question) return;
        const option = optionsOf(question).find((o)=>o.value === String(value));
        if (!option) return;
        refine(question.kind, option.value, option.label);
    }, [
        optionsOf,
        refine
    ]);
    /** «بله، درست است» — the digits read back are the mobile. */ const confirmPhone = (0, $acw62.useCallback)(()=>{
        const a = answerRef.current;
        if (a?.kind !== 'phone' || a.stage !== 'readback' || !a.digits) return;
        refine('phone', a.digits, a.digits);
    }, [
        refine
    ]);
    /** «رد کردن، در فرم وارد می‌کنم» — the form asks for it instead. */ const skipQuestion = (0, $acw62.useCallback)(()=>{
        const question = (0, $8af4119da22d78aa$export$b648b0cd38d6ee12)(resultRef.current, skippedRef.current);
        if (!question || !(0, $8af4119da22d78aa$export$82886d161b378b).includes(question.kind)) return;
        runId.current += 1;
        voiceRef.current.cancel();
        setAnswer(null);
        setSkipped((s)=>new Set(s).add(question.kind));
    }, [
        setAnswer
    ]);
    const question = phase === (0, $8af4119da22d78aa$export$2cc7a2eaaea7809f).RESULT ? (0, $8af4119da22d78aa$export$b648b0cd38d6ee12)(result, skipped) : null;
    // ── A blocking question opens the microphone by itself — once per question ──
    const autoAsked = (0, $acw62.useRef)({
        result: null,
        kinds: new Set()
    });
    (0, $acw62.useEffect)(()=>{
        if (!question?.blocking) return;
        if (autoAsked.current.result !== result) autoAsked.current = {
            result: result,
            kinds: new Set()
        };
        if (autoAsked.current.kinds.has(question.kind)) return;
        autoAsked.current.kinds.add(question.kind);
        if ($e5b7dbbee71b145f$var$MIC_REFUSED.has(voiceRef.current.status)) return;
        // Known not to cover even a minute of transcription: the quick answers still work.
        const { balance: balance, priceOf: priceOf } = creditsRef.current;
        const minute = priceOf?.((0, $8af4119da22d78aa$export$957d60e9b2ce814c));
        if (Number.isFinite(balance) && Number.isFinite(minute) && balance < minute) return;
        const a = answerRef.current;
        if (a && a.kind === question.kind && (a.stage === 'refining' || a.stage === 'readback')) return;
        answerByVoice({
            keepNote: true
        });
    }, [
        question?.kind,
        question?.blocking,
        result,
        answerByVoice
    ]);
    // Doctor chosen on CHOOSE_DOCTOR: free when the result can be refined, a re-run when not.
    const chooseDoctor = (0, $acw62.useCallback)((doctorId)=>{
        const current = resultRef.current;
        if (current?.draft && (current.questions || []).some((q)=>q.kind === 'doctor')) {
            const doctor = (current.doctors || []).find((d)=>d.doctorId === doctorId);
            refine('doctor', doctorId, doctor?.name || '');
            return;
        }
        submit(text, {
            ...selections,
            doctorId: doctorId
        });
    }, [
        refine,
        submit,
        text,
        selections
    ]);
    const choosePatient = (0, $acw62.useCallback)((patientId)=>{
        // A mobile and an insurer answered for a NEW patient describe nobody on file.
        facts.current.delete('phone');
        facts.current.delete('insurance');
        return submit(text, {
            ...selections,
            patientId: patientId,
            newPatient: false
        });
    }, [
        submit,
        text,
        selections
    ]);
    /** «هیچ‌کدام؛ بیمار جدید است» — none of the candidates: book for a patient with no file yet. */ const chooseNewPatient = (0, $acw62.useCallback)(()=>submit(text, {
            ...selections,
            patientId: null,
            newPatient: true
        }), [
        submit,
        text,
        selections
    ]);
    // «۱ از ۲»: the blocking questions settled so far, and those still open.
    const openKinds = new Set((result?.questions || []).map((q)=>q.kind));
    const settled = [
        ...new Set([
            ...skipped,
            ...answered
        ])
    ].filter((k)=>!openKinds.has(k) || skipped.has(k)).length;
    const step = question?.blocking ? {
        index: settled + 1,
        total: settled + (0, $8af4119da22d78aa$export$186074bec9436fa3)(result, skipped)
    } : null;
    return {
        phase: phase,
        text: text,
        result: result,
        seconds: seconds,
        recording: recording,
        creditAfterRun: creditAfterRun,
        continuing: continuing,
        micStatus: voice.status,
        interim: voice.transcript || '',
        priceOf: credits.priceOf,
        question: question ? {
            ...question,
            options: optionsOf(question),
            step: step
        } : null,
        answer: answer && question && answer.kind === question.kind ? answer : null,
        skipped: skipped,
        selections: selections,
        finish: finish,
        again: again,
        continueSpeaking: continueSpeaking,
        cancelContinue: cancelContinue,
        choosePatient: choosePatient,
        chooseNewPatient: chooseNewPatient,
        chooseDoctor: chooseDoctor,
        runEdited: runEdited,
        retry: retry,
        answerWith: answerWith,
        answerByVoice: answerByVoice,
        finishAnswer: finishAnswer,
        cancelAnswer: cancelAnswer,
        confirmPhone: confirmPhone,
        skipQuestion: skipQuestion
    };
}
var $e5b7dbbee71b145f$export$2e2bcd8739ae039 = $e5b7dbbee71b145f$export$fe6e2a80470eaba2;


const $42c1aae3f39aa268$var$S = {
    card: {
        background: (0, $jTCZr.C).card,
        border: `1px solid ${(0, $jTCZr.C).border}`,
        borderRadius: 14,
        boxShadow: '0 1px 6px rgba(0,0,0,0.05)',
        padding: 20
    },
    label: {
        fontSize: '0.78125rem',
        fontWeight: 700,
        color: (0, $jTCZr.C).textSecondary
    },
    title: {
        fontSize: '1.125rem',
        fontWeight: 800,
        color: (0, $jTCZr.C).textPrimary,
        margin: 0
    },
    hint: {
        fontSize: '0.84375rem',
        color: (0, $jTCZr.C).textSecondary,
        margin: '2px 0 14px'
    },
    row: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 8,
        justifyContent: 'flex-end',
        marginTop: 14
    },
    disc: {
        width: 44,
        height: 44,
        borderRadius: 999,
        flexShrink: 0,
        display: 'grid',
        placeItems: 'center'
    },
    ltr: {
        unicodeBidi: 'isolate',
        fontVariantNumeric: 'tabular-nums'
    },
    kbdOnLight: {
        background: (0, $jTCZr.C).bg,
        border: `1px solid ${(0, $jTCZr.C).border}`,
        color: (0, $jTCZr.C).textSecondary
    }
};
const $42c1aae3f39aa268$var$pick = {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    width: '100%',
    boxSizing: 'border-box',
    minHeight: 60,
    marginBottom: 8,
    padding: '8px 16px',
    borderRadius: 10,
    border: `1.5px solid ${(0, $jTCZr.C).border}`,
    background: (0, $jTCZr.C).card,
    color: (0, $jTCZr.C).textPrimary,
    fontFamily: 'inherit',
    fontSize: '0.875rem',
    textAlign: 'start',
    cursor: 'pointer'
};
/**
 * A key cap — on a keyboard. A phone has no F1 and no Ctrl+Enter, and a cap it
 * cannot press is noise on a screen that has room for nothing extra.
 */ function $42c1aae3f39aa268$var$KeyCap(props) {
    const { isMobile: isMobile } = (0, $9h2jQ.default)();
    return isMobile ? null : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ciRrJ.Kbd), {
        ...props
    });
}
/** A verdict with no action: an icon, one line, one explanation. */ function $42c1aae3f39aa268$var$Verdict({ icon: icon, tone: tone = 'neutral', title: title, children: children, testid: testid }) {
    const tint = tone === 'warning' ? (0, $jTCZr.soft)((0, $jTCZr.C).amber, 0.16) : (0, $jTCZr.C).bg;
    const ink = tone === 'warning' ? (0, $jTCZr.C).amber : (0, $jTCZr.C).textSecondary;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": testid,
        style: {
            display: 'flex',
            gap: 14,
            alignItems: 'flex-start'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                "aria-hidden": "true",
                style: {
                    ...$42c1aae3f39aa268$var$S.disc,
                    background: tint,
                    color: ink
                },
                children: icon
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    flex: 1,
                    minWidth: 0
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        style: $42c1aae3f39aa268$var$S.title,
                        children: title
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: '0.875rem',
                            color: (0, $jTCZr.C).textSecondary,
                            marginTop: 4
                        },
                        children: children
                    })
                ]
            })
        ]
    });
}
function $42c1aae3f39aa268$var$PatientLine({ patient: patient, t: t, formatDigits: formatDigits }) {
    const parts = [];
    if (patient.fileNumber) parts.push(t('secretary.choosePatient.file', {
        file: formatDigits(patient.fileNumber)
    }));
    if (patient.age != null) parts.push(t('secretary.choosePatient.age', {
        age: formatDigits(patient.age)
    }));
    if (patient.phoneTail) parts.push(t('secretary.choosePatient.phoneTail', {
        tail: formatDigits(patient.phoneTail)
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
        style: {
            flex: 1,
            minWidth: 0
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                dir: "auto",
                style: {
                    display: 'block',
                    fontSize: '0.9375rem',
                    fontWeight: 700
                },
                children: patient.name
            }),
            parts.length ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                style: {
                    display: 'block',
                    fontSize: '0.8125rem',
                    color: (0, $jTCZr.C).textSecondary
                },
                children: parts.join(" \xb7 ")
            }) : null
        ]
    });
}
// The BFF's bands (secretary/catalog.js MATCH), for COLOUR only: whether to go on or
// to ask is decided there, and this only tints the bar the desk reads.
const $42c1aae3f39aa268$var$STRONG_MATCH = 90;
const $42c1aae3f39aa268$var$PLAUSIBLE_MATCH = 60;
/** A match score: the number, and a bar that is teal where the secretary would have gone on alone. */ function $42c1aae3f39aa268$var$MatchScore({ score: score, t: t, formatDigits: formatDigits }) {
    if (score == null) return null;
    const tone = score >= $42c1aae3f39aa268$var$STRONG_MATCH ? (0, $jTCZr.C).teal : score >= $42c1aae3f39aa268$var$PLAUSIBLE_MATCH ? (0, $jTCZr.C).amber : (0, $jTCZr.C).textMuted;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
        role: "img",
        "aria-label": t('secretary.match.score', {
            score: formatDigits(score)
        }),
        style: {
            display: 'grid',
            justifyItems: 'end',
            gap: 4,
            flexShrink: 0
        },
        "data-testid": "secretary-match-score",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                "aria-hidden": "true",
                style: {
                    fontSize: '0.9375rem',
                    fontWeight: 800,
                    fontVariantNumeric: 'tabular-nums'
                },
                children: formatDigits(score)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                "aria-hidden": "true",
                style: {
                    display: 'block',
                    width: 64,
                    height: 5,
                    borderRadius: 99,
                    background: (0, $jTCZr.C).border,
                    overflow: 'hidden'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    style: {
                        display: 'block',
                        height: '100%',
                        width: `${Math.max(0, Math.min(100, score))}%`,
                        marginInlineStart: 'auto',
                        borderRadius: 99,
                        background: tone
                    }
                })
            })
        ]
    });
}
/** Why a candidate matched — the BFF's reason codes, in the reader's language. */ function $42c1aae3f39aa268$var$MatchReasons({ reasons: reasons, t: t }) {
    const known = (reasons || []).filter((r)=>(0, $8af4119da22d78aa$export$804201d3d3e57e8f).includes(r?.kind));
    if (!known.length) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        style: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: 4,
            marginTop: 4
        },
        children: known.map((r, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $bHjRG.default), {
                variant: r.kind === 'appointment_soon' ? 'default' : 'outline',
                "data-testid": `secretary-reason-${r.kind}`,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    dir: "auto",
                    children: t(`secretary.match.reason.${r.kind}`, {
                        heard: r.heard || '',
                        stored: r.stored || ''
                    })
                })
            }, `${r.kind}-${i}`))
    });
}
/** One key of a list, bound while its row is on screen — labelled, so «?» lists it. */ function $42c1aae3f39aa268$var$PickKey({ combo: combo, label: label, group: group, onPress: onPress }) {
    (0, $ciRrJ.useShortcut)(combo, onPress, {
        label: label,
        group: group
    });
    return null;
}
/**
 * A list the desk answers with ONE key: 1–5 pick a row, 0 says «بیمار جدید است» —
 * offered only when the command was a booking and a name was heard. «کدام‌یک؟»,
 * «بیمار دیگری است؟» and the closest names under «پیدا نکردم» are all this list.
 */ function $42c1aae3f39aa268$var$PatientChoice({ title: title, hint: hint, patients: patients, newPatientName: newPatientName = null, onPick: onPick, onNew: onNew, onBack: onBack = null, compact: compact = false, tr: tr }) {
    const { t: t, formatDigits: formatDigits } = tr;
    const rows = (patients || []).slice(0, (0, $8af4119da22d78aa$export$40b2567d493c3c54).length);
    const group = t('secretary.shortcuts.open');
    const offerNew = Boolean(newPatientName && onNew);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": "secretary-patient-choice",
        children: [
            compact ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    ...$42c1aae3f39aa268$var$S.label,
                    marginBottom: 6
                },
                children: title
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                style: $42c1aae3f39aa268$var$S.title,
                children: title
            }),
            hint ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                style: $42c1aae3f39aa268$var$S.hint,
                children: hint
            }) : null,
            rows.map((p, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                    type: "button",
                    autoFocus: i === 0 && !compact,
                    style: {
                        ...$42c1aae3f39aa268$var$pick,
                        borderColor: i === 0 && !compact ? (0, $jTCZr.C).navy : (0, $jTCZr.C).border
                    },
                    onClick: ()=>onPick(p.id),
                    "aria-keyshortcuts": (0, $8af4119da22d78aa$export$40b2567d493c3c54)[i],
                    "data-testid": `secretary-patient-${p.id}`,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($42c1aae3f39aa268$var$PickKey, {
                            combo: (0, $8af4119da22d78aa$export$40b2567d493c3c54)[i],
                            label: t('secretary.shortcuts.pickPatient', {
                                n: formatDigits(i + 1)
                            }),
                            group: group,
                            onPress: ()=>onPick(p.id)
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($42c1aae3f39aa268$var$KeyCap, {
                            combo: (0, $8af4119da22d78aa$export$40b2567d493c3c54)[i],
                            style: $42c1aae3f39aa268$var$S.kbdOnLight
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            "aria-hidden": "true",
                            style: {
                                ...$42c1aae3f39aa268$var$S.disc,
                                width: 40,
                                height: 40,
                                background: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.1),
                                color: (0, $jTCZr.C).navy
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ff4d96da330336c2$export$2e2bcd8739ae039), {
                                size: 20
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            style: {
                                flex: 1,
                                minWidth: 0
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)($42c1aae3f39aa268$var$PatientLine, {
                                    patient: p,
                                    t: t,
                                    formatDigits: formatDigits
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($42c1aae3f39aa268$var$MatchReasons, {
                                    reasons: p.reasons,
                                    t: t
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($42c1aae3f39aa268$var$MatchScore, {
                            score: p.score,
                            t: t,
                            formatDigits: formatDigits
                        })
                    ]
                }, p.id)),
            offerNew ? /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                type: "button",
                style: {
                    ...$42c1aae3f39aa268$var$pick,
                    borderStyle: 'dashed'
                },
                onClick: onNew,
                "aria-keyshortcuts": (0, $8af4119da22d78aa$export$7141cadfecb4bb4f),
                "data-testid": "secretary-new-patient",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($42c1aae3f39aa268$var$PickKey, {
                        combo: (0, $8af4119da22d78aa$export$7141cadfecb4bb4f),
                        label: t('secretary.shortcuts.newPatient'),
                        group: group,
                        onPress: onNew
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($42c1aae3f39aa268$var$KeyCap, {
                        combo: (0, $8af4119da22d78aa$export$7141cadfecb4bb4f),
                        style: $42c1aae3f39aa268$var$S.kbdOnLight
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        "aria-hidden": "true",
                        style: {
                            ...$42c1aae3f39aa268$var$S.disc,
                            width: 40,
                            height: 40,
                            background: (0, $jTCZr.soft)((0, $jTCZr.C).teal, 0.14),
                            color: (0, $jTCZr.C).teal
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aIxvs.default), {
                            size: 20
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        style: {
                            flex: 1,
                            minWidth: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    display: 'block',
                                    fontSize: '0.9375rem',
                                    fontWeight: 700
                                },
                                children: t('secretary.choosePatient.newPatient')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                dir: "auto",
                                style: {
                                    display: 'block',
                                    fontSize: '0.8125rem',
                                    color: (0, $jTCZr.C).textSecondary
                                },
                                children: t('secretary.choosePatient.newPatientHint', {
                                    name: newPatientName
                                })
                            })
                        ]
                    })
                ]
            }) : null,
            onBack ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    ...$42c1aae3f39aa268$var$S.row,
                    justifyContent: 'flex-start',
                    marginTop: 6
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                    type: "button",
                    variant: "outline",
                    onClick: onBack,
                    "data-testid": "secretary-choice-back",
                    children: t('secretary.choosePatient.back')
                })
            }) : null
        ]
    });
}
/** «شنیدم» — what the server transcribed, with the two ways to fix it. */ function $42c1aae3f39aa268$var$HeardCard({ text: text, onAgain: onAgain, onContinue: onContinue, onRunEdited: onRunEdited, onEdit: onEdit, t: t }) {
    const [editing, setEditing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [draft, setDraft] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(text);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setDraft(text);
        setEditing(false);
    }, [
        text
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        style: {
            ...$42c1aae3f39aa268$var$S.card,
            padding: 16,
            marginBottom: 14
        },
        "data-testid": "secretary-heard",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    ...$42c1aae3f39aa268$var$S.label,
                    marginBottom: 6
                },
                children: t('secretary.heard.label')
            }),
            editing ? /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                onSubmit: (e)=>{
                    e.preventDefault();
                    onRunEdited(draft);
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        autoFocus: true,
                        value: draft,
                        onChange: (e)=>setDraft(e.target.value),
                        "aria-label": t('secretary.heard.editLabel'),
                        "data-testid": "secretary-heard-input",
                        autoComplete: "off",
                        dir: "auto",
                        style: {
                            width: '100%',
                            boxSizing: 'border-box',
                            height: 44,
                            padding: '0 12px',
                            borderRadius: 10,
                            border: `1.5px solid ${(0, $jTCZr.C).border}`,
                            background: (0, $jTCZr.C).card,
                            color: (0, $jTCZr.C).textPrimary,
                            fontFamily: 'inherit',
                            fontSize: '1rem'
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: 8,
                            marginTop: 10
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                type: "submit",
                                size: "sm",
                                disabled: !draft.trim(),
                                "data-testid": "secretary-heard-run",
                                children: t('secretary.heard.runEdited')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                type: "button",
                                size: "sm",
                                variant: "outline",
                                onClick: ()=>setEditing(false),
                                children: t('secretary.heard.cancelEdit')
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    text ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        dir: "auto",
                        style: {
                            fontSize: '1rem',
                            fontWeight: 700,
                            color: (0, $jTCZr.C).textPrimary
                        },
                        "data-testid": "secretary-heard-text",
                        children: text
                    }) : null,
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: 8,
                            marginTop: 10
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                                type: "button",
                                size: "sm",
                                variant: "outline",
                                onClick: onAgain,
                                "data-testid": "secretary-again",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hSPBf.default), {
                                        size: 16,
                                        "aria-hidden": "true"
                                    }),
                                    " ",
                                    t('secretary.heard.again')
                                ]
                            }),
                            text && onContinue ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                                type: "button",
                                size: "sm",
                                variant: "outline",
                                onClick: onContinue,
                                "aria-keyshortcuts": "Shift+F1",
                                "data-testid": "secretary-continue",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $823ddab00873574d$export$2e2bcd8739ae039), {
                                        size: 16,
                                        "aria-hidden": "true"
                                    }),
                                    " ",
                                    t('secretary.heard.continue'),
                                    " ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($42c1aae3f39aa268$var$KeyCap, {
                                        combo: "shift+f1",
                                        style: $42c1aae3f39aa268$var$S.kbdOnLight
                                    })
                                ]
                            }) : null,
                            text ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                type: "button",
                                size: "sm",
                                variant: "outline",
                                onClick: ()=>{
                                    onEdit?.();
                                    setEditing(true);
                                },
                                "data-testid": "secretary-heard-edit",
                                children: t('secretary.heard.edit')
                            }) : null
                        ]
                    })
                ]
            })
        ]
    });
}
/** «برداشت من» — the structured reading of the sentence. An assumption says it is one. */ function $42c1aae3f39aa268$var$UnderstoodCard({ result: result, onOtherPatient: onOtherPatient, t: t, formatDate: formatDate, formatTime: formatTime, formatDigits: formatDigits }) {
    const patient = (0, $8af4119da22d78aa$export$fa7e7bf5f125d593)(result);
    const facts = [];
    if (result.kind && t(`secretary.action.${result.kind}`)) facts.push({
        key: 'action',
        label: t('secretary.understood.action'),
        value: t(`secretary.action.${result.kind}`)
    });
    if (patient) {
        // How the name was matched travels with the fact, like the assumed doctor does: a
        // score and its strongest reason, or «بیمار جدید» for nobody on file.
        const reason = (patient.reasons || []).find((r)=>(0, $8af4119da22d78aa$export$804201d3d3e57e8f).includes(r?.kind));
        facts.push({
            key: 'patient',
            label: t('secretary.understood.patient'),
            value: patient.fileNumber ? t('secretary.understood.patientFile', {
                name: patient.name,
                file: formatDigits(patient.fileNumber)
            }) : patient.name,
            extra: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                style: {
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    gap: 6,
                    marginTop: 4
                },
                children: [
                    patient.isNew ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bHjRG.default), {
                        variant: "success",
                        "data-testid": "secretary-understood-new",
                        children: t('secretary.match.newPatient')
                    }) : patient.score != null ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bHjRG.default), {
                        variant: patient.score >= $42c1aae3f39aa268$var$STRONG_MATCH ? 'success' : 'warning',
                        "data-testid": "secretary-understood-match",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            dir: "auto",
                            children: [
                                t('secretary.match.score', {
                                    score: formatDigits(patient.score)
                                }),
                                reason ? ` \xb7 ${t(`secretary.match.reason.${reason.kind}`, {
                                    heard: reason.heard || '',
                                    stored: reason.stored || ''
                                })}` : ''
                            ]
                        })
                    }) : null,
                    onOtherPatient ? /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        type: "button",
                        onClick: onOtherPatient,
                        style: {
                            border: 0,
                            padding: 0,
                            background: 'none',
                            color: (0, $jTCZr.C).navy,
                            fontFamily: 'inherit',
                            fontSize: '0.78125rem',
                            fontWeight: 700,
                            textDecoration: 'underline',
                            textUnderlineOffset: 3,
                            cursor: 'pointer'
                        },
                        "data-testid": "secretary-other-patient-link",
                        children: t('secretary.match.otherPatient')
                    }) : null
                ]
            })
        });
    }
    if (result.booking) {
        facts.push({
            key: 'window',
            label: t('secretary.understood.window'),
            value: t('secretary.understood.windowValue', {
                from: formatDate(result.booking.fromMs, 'dayMonth'),
                to: formatDate(result.booking.toMs, 'dayMonth')
            })
        });
        const assumed = result.booking.doctorAssumed;
        facts.push({
            key: 'doctor',
            label: t('secretary.understood.doctor'),
            value: result.booking.doctor.name,
            note: assumed === 'last_doctor' ? t('secretary.understood.assumedLastDoctor') : assumed === 'only_doctor' ? t('secretary.understood.assumedOnlyDoctor') : null
        });
    }
    if (result.booking?.requestedAt) facts.push({
        key: 'time',
        label: t('secretary.understood.time'),
        value: formatTime(result.booking.requestedAt)
    });
    if (result.followUp?.dueAt) facts.push({
        key: 'due',
        label: t('secretary.understood.due'),
        value: formatDate(result.followUp.dueAt, 'weekdayDayMonth')
    });
    if (!facts.length) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        style: {
            ...$42c1aae3f39aa268$var$S.card,
            padding: 16
        },
        "data-testid": "secretary-understood",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    ...$42c1aae3f39aa268$var$S.label,
                    marginBottom: 2
                },
                children: t('secretary.understood.label')
            }),
            facts.map((f)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        padding: '8px 0',
                        borderTop: `1px solid ${(0, $jTCZr.C).border}`
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                fontSize: '0.78125rem',
                                color: (0, $jTCZr.C).textSecondary
                            },
                            children: f.label
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            dir: "auto",
                            style: {
                                fontSize: '0.875rem',
                                fontWeight: 700,
                                color: (0, $jTCZr.C).textPrimary
                            },
                            children: f.value
                        }),
                        f.extra || null,
                        f.note ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bHjRG.default), {
                            variant: "warning",
                            style: {
                                marginTop: 4
                            },
                            "data-testid": `secretary-assumed-${f.key}`,
                            children: f.note
                        }) : null
                    ]
                }, f.key))
        ]
    });
}
function $42c1aae3f39aa268$var$ProposalHead({ title: title, t: t }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 8
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                style: $42c1aae3f39aa268$var$S.title,
                children: title
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bHjRG.default), {
                "data-testid": "secretary-ai-badge",
                children: t('secretary.aiBadge')
            })
        ]
    });
}
/**
 * The hour the desk NAMED («ساعت ۱ بعد از ظهر») and how it stood: free (it is the
 * proposal), taken (the nearest free times follow), or not judged (an older service).
 */ function $42c1aae3f39aa268$var$RequestedHour({ booking: booking, t: t, formatDate: formatDate, formatTime: formatTime }) {
    if (!booking?.requestedAt) return null;
    const when = t('secretary.booking.when', {
        day: formatDate(booking.requestedAt, 'weekdayDayMonth'),
        time: formatTime(booking.requestedAt)
    });
    const free = booking.requestedFree;
    const text = free === true ? t('secretary.booking.requestedFree', {
        when: when
    }) : free === false ? t('secretary.booking.requestedTaken', {
        when: when
    }) : t('secretary.booking.requestedUnchecked', {
        when: when
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
        variant: free === true ? 'success' : 'warning',
        style: {
            marginTop: 12
        },
        "data-testid": "secretary-requested-hour",
        "data-free": free === null || free === undefined ? 'unknown' : String(free),
        children: text
    });
}
/**
 * A booking for a patient the clinic has no record of. Says so, says why it might be
 * wrong when a close record exists, and keeps the closest names one press away.
 */ function $42c1aae3f39aa268$var$NewPatientNotice({ name: name, similar: similar, details: details, onClosest: onClosest, onContinue: onContinue, onBookExisting: onBookExisting, skipped: skipped = null, asking: asking = false, t: t, formatDigits: formatDigits }) {
    const missing = details?.missing || [];
    // «رد کردن» on the sheet's question: the form asks for it, and the row says so.
    const later = (key)=>skipped?.has(key) ? t('secretary.newPatient.skipped') : null;
    // The records already on the mobile that was said — the same list «ثبت بیمار جدید»
    // shows before it creates anyone. A mobile is a household: the person at the desk may
    // be one of these, and the desk says which before a second file is opened.
    const onNumber = (0, $jVdQx.usePhoneCandidates)(details?.phone || '', {
        delay: 0
    });
    const linkAndBook = async (c)=>{
        const data = await (0, $2Mst8.bffMutation)((0, $6P09x.LINK_EXISTING_PATIENT), {
            patientId: c.patientId
        });
        const linked = data?.linkExistingPatient;
        if (!linked?.id) throw new Error('linkExistingPatient returned no patient');
        onBookExisting(linked);
    };
    // What «ثبت نوبت» needs to register them, as it was heard — and what was not.
    const rows = [
        {
            key: 'name',
            value: name,
            ok: true
        },
        {
            key: 'phone',
            value: details?.phone ? formatDigits(details.phone) : details?.phoneHeard ? t('secretary.newPatient.phoneMisheard', {
                heard: formatDigits(details.phoneHeard)
            }) : later('phone'),
            ok: !missing.includes('phone'),
            ltr: !!details?.phone
        },
        {
            key: 'insurance',
            value: details?.insurerName || (details?.insurance ? t('secretary.newPatient.insuranceUnmatched', {
                said: details.insurance
            }) : later('insurance')),
            ok: !missing.includes('insurance')
        }
    ];
    if (details?.nationalId) rows.push({
        key: 'nationalId',
        value: formatDigits(details.nationalId),
        ok: true,
        ltr: true
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            gap: 12,
            alignItems: 'flex-start',
            margin: '12px 0 4px',
            padding: '12px 14px',
            borderRadius: 10,
            background: (0, $jTCZr.soft)((0, $jTCZr.C).teal, 0.07),
            border: `1px solid ${(0, $jTCZr.soft)((0, $jTCZr.C).teal, 0.28)}`
        },
        "data-testid": "secretary-new-patient-notice",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                "aria-hidden": "true",
                style: {
                    ...$42c1aae3f39aa268$var$S.disc,
                    width: 40,
                    height: 40,
                    background: (0, $jTCZr.soft)((0, $jTCZr.C).teal, 0.16),
                    color: (0, $jTCZr.C).teal
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aIxvs.default), {
                    size: 20
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    flex: 1,
                    minWidth: 0
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        dir: "auto",
                        style: {
                            fontSize: '0.9375rem',
                            fontWeight: 800,
                            color: (0, $jTCZr.C).textPrimary
                        },
                        children: similar ? t('secretary.newPatient.titleSaid', {
                            name: name
                        }) : t('secretary.newPatient.title', {
                            name: name
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: '0.8125rem',
                            color: similar ? (0, $jTCZr.C).amber : (0, $jTCZr.C).textSecondary,
                            marginTop: 2
                        },
                        children: similar ? t('secretary.newPatient.similar') : t('secretary.newPatient.hint')
                    }),
                    details ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            display: 'grid',
                            gap: 4,
                            margin: '10px 0 4px'
                        },
                        "data-testid": "secretary-new-patient-checklist",
                        children: rows.map((r)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 8,
                                    fontSize: '0.84375rem'
                                },
                                "data-testid": `secretary-new-${r.key}`,
                                "data-ok": r.ok ? 'true' : 'false',
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        "aria-hidden": "true",
                                        style: {
                                            display: 'inline-grid',
                                            placeItems: 'center',
                                            width: 18,
                                            height: 18,
                                            borderRadius: 999,
                                            background: r.ok ? (0, $jTCZr.soft)((0, $jTCZr.C).teal, 0.18) : (0, $jTCZr.soft)((0, $jTCZr.C).amber, 0.2),
                                            color: r.ok ? (0, $jTCZr.C).teal : (0, $jTCZr.C).amber
                                        },
                                        children: r.ok ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $huNwV.default), {
                                            size: 12
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6TdpC.default), {
                                            size: 12
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            minWidth: 64,
                                            color: (0, $jTCZr.C).textSecondary
                                        },
                                        children: t(`secretary.newPatient.field.${r.key}`)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        dir: r.ltr ? 'ltr' : 'auto',
                                        style: {
                                            fontWeight: 700,
                                            color: r.value ? (0, $jTCZr.C).textPrimary : (0, $jTCZr.C).textMuted,
                                            unicodeBidi: 'isolate'
                                        },
                                        children: r.value || t('secretary.newPatient.notSaid')
                                    })
                                ]
                            }, r.key))
                    }) : null,
                    onNumber.candidates.length && onBookExisting ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            margin: '10px 0 4px'
                        },
                        "data-testid": "secretary-same-phone",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    fontSize: '0.8125rem',
                                    fontWeight: 800,
                                    color: (0, $jTCZr.C).textPrimary
                                },
                                children: t('secretary.newPatient.samePhoneTitle')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    fontSize: '0.78125rem',
                                    color: (0, $jTCZr.C).textSecondary,
                                    margin: '2px 0 8px'
                                },
                                children: t('secretary.newPatient.samePhoneHint')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jmIrn.default), {
                                candidates: onNumber.candidates,
                                onChooseLinked: (c)=>onBookExisting(c.patient || {
                                        id: c.patientId,
                                        name: c.displayName,
                                        phone: details.phone
                                    }),
                                chooseLabel: t('secretary.newPatient.bookForThis'),
                                onLink: linkAndBook,
                                linkLabel: t('patients.phoneCandidates.addAndChoose'),
                                "data-testid": "secretary-same-phone-list"
                            })
                        ]
                    }) : null,
                    missing.length && !asking ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            gap: 8,
                            marginTop: 6
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    fontSize: '0.78125rem',
                                    color: (0, $jTCZr.C).textSecondary
                                },
                                children: t('secretary.newPatient.missingHint', {
                                    list: missing.map((m)=>t(`secretary.newPatient.missing.${m}`)).join(t('secretary.newPatient.and'))
                                })
                            }),
                            onContinue ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                                type: "button",
                                size: "sm",
                                onClick: onContinue,
                                "aria-keyshortcuts": "Shift+F1",
                                "data-testid": "secretary-new-patient-continue",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $823ddab00873574d$export$2e2bcd8739ae039), {
                                        size: 16,
                                        "aria-hidden": "true"
                                    }),
                                    " ",
                                    t('secretary.heard.continue'),
                                    " ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($42c1aae3f39aa268$var$KeyCap, {
                                        combo: "shift+f1"
                                    })
                                ]
                            }) : null
                        ]
                    }) : details && !missing.length ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: '0.78125rem',
                            color: (0, $jTCZr.C).teal,
                            marginTop: 6
                        },
                        "data-testid": "secretary-new-patient-complete",
                        children: t('secretary.newPatient.complete')
                    }) : null,
                    onClosest ? /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        type: "button",
                        onClick: onClosest,
                        style: {
                            marginTop: 6,
                            border: 0,
                            padding: 0,
                            background: 'none',
                            color: (0, $jTCZr.C).navy,
                            fontFamily: 'inherit',
                            fontSize: '0.78125rem',
                            fontWeight: 700,
                            textDecoration: 'underline',
                            textUnderlineOffset: 3,
                            cursor: 'pointer'
                        },
                        "data-testid": "secretary-new-patient-closest",
                        children: t('secretary.newPatient.closest')
                    }) : null
                ]
            })
        ]
    });
}
const $42c1aae3f39aa268$var$Q = {
    card: {
        ...$42c1aae3f39aa268$var$S.card,
        padding: 16,
        border: `1.5px solid ${(0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.3)}`
    },
    link: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        border: 0,
        padding: 0,
        background: 'none',
        color: (0, $jTCZr.C).navy,
        fontFamily: 'inherit',
        fontSize: '0.8125rem',
        fontWeight: 700,
        textDecoration: 'underline',
        textUnderlineOffset: 3,
        cursor: 'pointer'
    }
};
/**
 * What the sentence left out (PM-0080) — ONE question, above what was prepared.
 * A quick answer is a tap or a key (1–5) and costs nothing. A blocking question is
 * already listening when it appears, and the recording ends on its own after a
 * moment of silence; a spoken mobile is read back before it is used; «رد کردن» (0)
 * leaves a mobile or an insurer to the form. «برای چه زمانی؟» is an OFFER: the first
 * free times below stand until it is answered.
 */ function $42c1aae3f39aa268$var$QuestionCard({ session: session, tr: tr }) {
    const { t: t, formatDate: formatDate, formatDigits: formatDigits } = tr;
    const { question: q, answer: a, result: result } = session;
    const [changing, setChanging] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setChanging(false);
    }, [
        result
    ]);
    if (!q) return null;
    const group = t('secretary.shortcuts.open');
    const stage = a?.stage || 'idle';
    const busy = stage === 'refining' || stage === 'hearing';
    const listening = stage === 'listening';
    const live = listening && session.micStatus === 'listening';
    const title = t(`secretary.question.title.${q.kind}`);
    const chosen = q.options.find((o)=>o.selected) || null;
    // «برای چه زمانی؟» answered with a chip: one line, and «تغییر» to open it again.
    if (q.kind === 'when' && chosen && chosen.value !== 'first' && !changing && stage === 'idle' && !a?.note) {
        const b = result?.booking;
        const span = !b ? '' : chosen.value === 'next_week' ? t('secretary.understood.windowValue', {
            from: formatDate(b.fromMs, 'dayMonth'),
            to: formatDate(b.toMs, 'dayMonth')
        }) : formatDate(b.fromMs, 'weekdayDayMonth');
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
            style: {
                ...$42c1aae3f39aa268$var$Q.card,
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 8
            },
            "data-testid": "secretary-question",
            "data-kind": "when",
            "data-answered": "true",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    style: {
                        fontSize: '0.875rem',
                        color: (0, $jTCZr.C).textSecondary
                    },
                    children: [
                        t('secretary.question.answeredWhen'),
                        ' ',
                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                            style: {
                                color: (0, $jTCZr.C).textPrimary
                            },
                            children: chosen.label
                        }),
                        span ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            children: ` (${span})`
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                    type: "button",
                    style: $42c1aae3f39aa268$var$Q.link,
                    onClick: ()=>setChanging(true),
                    "data-testid": "secretary-question-change",
                    children: t('secretary.question.change')
                })
            ]
        });
    }
    const note = q.kind === 'doctor' || q.kind === 'when' ? t(`secretary.question.note.${q.kind}`) : null;
    const step = q.step ? t('secretary.question.step', {
        index: formatDigits(q.step.index),
        total: formatDigits(q.step.total)
    }) : t('secretary.question.optional');
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        style: $42c1aae3f39aa268$var$Q.card,
        "data-testid": "secretary-question",
        "data-kind": q.kind,
        "data-stage": stage,
        "aria-label": title,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 8
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        style: {
                            ...$42c1aae3f39aa268$var$S.title,
                            fontSize: '1rem'
                        },
                        children: title
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bHjRG.default), {
                        variant: "outline",
                        "data-testid": "secretary-question-step",
                        children: step
                    })
                ]
            }),
            note ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                style: {
                    ...$42c1aae3f39aa268$var$S.hint,
                    margin: '4px 0 0'
                },
                children: note
            }) : null,
            stage === 'readback' ? // Speech gets digits wrong: the number is read back, and only a «بله» uses it.
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    marginTop: 10,
                    textAlign: 'center'
                },
                "data-testid": "secretary-readback",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        dir: "ltr",
                        style: {
                            ...$42c1aae3f39aa268$var$S.ltr,
                            fontSize: '1.625rem',
                            fontWeight: 800,
                            letterSpacing: 1,
                            color: (0, $jTCZr.C).textPrimary
                        },
                        "data-testid": "secretary-readback-digits",
                        children: (0, $8af4119da22d78aa$export$86ce13b2f905bab3)(a.digits).map((g)=>formatDigits(g)).join(' ')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: '0.84375rem',
                            color: (0, $jTCZr.C).textSecondary,
                            marginTop: 2
                        },
                        children: t('secretary.question.readBack')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: 8,
                            justifyContent: 'center',
                            marginTop: 10
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                                type: "button",
                                variant: "outline",
                                onClick: ()=>session.answerByVoice(),
                                "data-testid": "secretary-readback-again",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hSPBf.default), {
                                        size: 16,
                                        "aria-hidden": "true"
                                    }),
                                    " ",
                                    t('secretary.question.sayAgain')
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                                type: "button",
                                autoFocus: true,
                                onClick: session.confirmPhone,
                                "aria-keyshortcuts": "Enter",
                                "data-testid": "secretary-readback-confirm",
                                children: [
                                    t('secretary.question.confirm'),
                                    " ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($42c1aae3f39aa268$var$KeyCap, {
                                        combo: "enter"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    q.options.length || !listening ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: 8,
                            marginTop: 10
                        },
                        "data-testid": "secretary-answers",
                        children: [
                            q.options.map((o, i)=>{
                                const key = i < (0, $8af4119da22d78aa$export$40b2567d493c3c54).length ? (0, $8af4119da22d78aa$export$40b2567d493c3c54)[i] : null;
                                const doctor = q.kind === 'doctor' ? (result?.doctors || []).find((d)=>d.doctorId === o.value) : null;
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $h4ZeB.default), {
                                    active: o.selected,
                                    disabled: busy,
                                    onClick: ()=>session.answerWith(o.value),
                                    "aria-keyshortcuts": key || undefined,
                                    "data-testid": `secretary-answer-${o.value}`,
                                    children: [
                                        key && !busy ? /*#__PURE__*/ (0, $ayMG0.jsx)($42c1aae3f39aa268$var$PickKey, {
                                            combo: key,
                                            label: t('secretary.shortcuts.answer', {
                                                n: formatDigits(i + 1)
                                            }),
                                            group: group,
                                            onPress: ()=>session.answerWith(o.value)
                                        }) : null,
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            dir: "auto",
                                            children: o.label
                                        }),
                                        doctor?.specialty ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            dir: "auto",
                                            style: {
                                                fontWeight: 400,
                                                opacity: 0.75
                                            },
                                            children: `\xb7 ${doctor.specialty}`
                                        }) : null,
                                        key ? /*#__PURE__*/ (0, $ayMG0.jsx)($42c1aae3f39aa268$var$KeyCap, {
                                            combo: key,
                                            style: $42c1aae3f39aa268$var$S.kbdOnLight
                                        }) : null
                                    ]
                                }, o.value);
                            }),
                            !listening ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $h4ZeB.default), {
                                disabled: busy,
                                onClick: ()=>session.answerByVoice(),
                                "data-testid": "secretary-answer-speak",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hSPBf.default), {
                                        size: 14,
                                        "aria-hidden": "true"
                                    }),
                                    " ",
                                    t('secretary.question.speak')
                                ]
                            }) : null
                        ]
                    }) : null,
                    listening ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            gap: 10,
                            marginTop: 10
                        },
                        "data-testid": "secretary-answer-listening",
                        "data-manual": a.manual ? 'true' : 'false',
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                "aria-hidden": "true",
                                style: {
                                    width: 10,
                                    height: 10,
                                    borderRadius: 999,
                                    flexShrink: 0,
                                    background: live ? (0, $jTCZr.C).red : (0, $jTCZr.C).border
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                "aria-live": "polite",
                                style: {
                                    flex: '1 1 200px',
                                    minWidth: 0,
                                    fontSize: '0.84375rem',
                                    color: (0, $jTCZr.C).textSecondary
                                },
                                children: !live ? t('secretary.question.preparing') : a.manual ? t('secretary.question.listeningManual') : t('secretary.question.listening')
                            }),
                            live && a.manual ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                type: "button",
                                size: "sm",
                                onClick: session.finishAnswer,
                                "data-testid": "secretary-answer-stop",
                                children: t('secretary.question.stopListening')
                            }) : null,
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                type: "button",
                                size: "sm",
                                variant: "ghost",
                                onClick: session.cancelAnswer,
                                "data-testid": "secretary-answer-cancel",
                                children: t('secretary.question.cancelListening')
                            })
                        ]
                    }) : null,
                    busy ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        "aria-live": "polite",
                        style: {
                            marginTop: 10,
                            fontSize: '0.84375rem',
                            color: (0, $jTCZr.C).textSecondary
                        },
                        "data-testid": "secretary-answer-busy",
                        children: stage === 'hearing' ? t('secretary.question.hearing') : t('secretary.question.refining')
                    }) : null
                ]
            }),
            a?.note ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                role: "status",
                style: {
                    marginTop: 8,
                    fontSize: '0.8125rem',
                    fontWeight: 700,
                    color: (0, $jTCZr.C).amber
                },
                "data-testid": "secretary-answer-note",
                "data-note": a.note,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    dir: "auto",
                    children: t(`secretary.question.problem.${a.note}`, {
                        heard: a.heard ? formatDigits(a.heard) : ''
                    })
                })
            }) : null,
            (0, $8af4119da22d78aa$export$82886d161b378b).includes(q.kind) ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    marginTop: 12
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                    type: "button",
                    style: $42c1aae3f39aa268$var$Q.link,
                    onClick: session.skipQuestion,
                    disabled: busy,
                    "aria-keyshortcuts": (0, $8af4119da22d78aa$export$c5a6af19f1c90732),
                    "data-testid": "secretary-question-skip",
                    children: [
                        !busy ? /*#__PURE__*/ (0, $ayMG0.jsx)($42c1aae3f39aa268$var$PickKey, {
                            combo: (0, $8af4119da22d78aa$export$c5a6af19f1c90732),
                            label: t('secretary.shortcuts.skip'),
                            group: group,
                            onPress: session.skipQuestion
                        }) : null,
                        t('secretary.question.skip'),
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)($42c1aae3f39aa268$var$KeyCap, {
                            combo: (0, $8af4119da22d78aa$export$c5a6af19f1c90732),
                            style: $42c1aae3f39aa268$var$S.kbdOnLight
                        })
                    ]
                })
            }) : null
        ]
    });
}
/** What was prepared — one branch per outcome. `choosing`: «بیمار دیگری است؟» is open. */ function $42c1aae3f39aa268$var$Prepared({ session: session, choosing: choosing, onChoosing: onChoosing, onBook: onBook, onDone: onDone, onOpenPatient: onOpenPatient, onClose: onClose, tr: tr }) {
    const { t: t, formatDate: formatDate, formatTime: formatTime, formatDigits: formatDigits, formatNumber: formatNumber, formatMoney: formatMoney } = tr;
    const { result: result } = session;
    const [busy, setBusy] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [failed, setFailed] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setFailed('');
        setBusy(false);
    }, [
        result
    ]);
    const commit = async (document, variables, doneMessage, failMessage, after)=>{
        setBusy(true);
        setFailed('');
        try {
            await (0, $2Mst8.bffMutation)(document, variables);
            after?.();
            onDone(doneMessage);
        } catch  {
            // The form of this write is this card: it reports here, keeps what it shows,
            // and the button comes back (DESIGN_CONCEPT §2.4).
            setFailed(failMessage);
            setBusy(false);
        }
    };
    const primary = (()=>{
        if (busy || choosing) return null;
        // The form opens on the first proposed time; it lists the others itself.
        if (result.outcome === 'PROPOSAL' && result.kind === 'book_appointment') return ()=>onBook((0, $8af4119da22d78aa$export$8d14b304fe6a5f00)(result.booking, 0));
        if (result.outcome === 'PROPOSAL' && result.kind === 'mark_arrived') return ()=>commit((0, $8af4119da22d78aa$export$5b548a56a36e433c), {
                appointmentId: result.arrival.appointmentId
            }, t('secretary.arrival.done'), t('secretary.arrival.failed'), (0, $d7OV8.reportAppointmentsChanged));
        if (result.outcome === 'PROPOSAL' && result.kind === 'follow_up') {
            const f = result.followUp;
            // No day yet: «کی پیگیری شود؟» is open above, and nothing is saved without one.
            if (!f.dueAt) return null;
            return ()=>commit((0, $8af4119da22d78aa$export$ed9bc2432ccbd5d), {
                    input: {
                        patientId: f.patient.id,
                        dueAt: f.dueAt,
                        kind: f.kind,
                        note: f.note || null
                    }
                }, t('secretary.followUp.done'), t('secretary.followUp.failed'));
        }
        if (result.outcome === 'NAVIGATE' && result.patient) return ()=>onOpenPatient(result.patient.id);
        return null;
    })();
    (0, $ciRrJ.useShortcut)('ctrl+enter', ()=>primary?.(), {
        label: t('common.actions.confirm'),
        group: t('secretary.shortcuts.open'),
        enabled: Boolean(primary)
    });
    const submitKbd = /*#__PURE__*/ (0, $ayMG0.jsx)($42c1aae3f39aa268$var$KeyCap, {
        combo: "ctrl+enter"
    });
    const error = failed ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
        variant: "error",
        style: {
            marginTop: 12
        },
        "data-testid": "secretary-commit-error",
        children: failed
    }) : null;
    const booking = result.kind === 'book_appointment';
    const heard = result.heardName || null;
    if (choosing) {
        // «بیمار دیگری است؟» — the lookup's other candidates; or, under a NEW patient,
        // the closest names that were checked. Picking one re-runs the sentence with it.
        const isNew = !!result.booking?.patient?.isNew;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            "data-testid": "secretary-other-patient",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($42c1aae3f39aa268$var$PatientChoice, {
                title: isNew ? t('secretary.choosePatient.closestTitle') : t('secretary.choosePatient.otherTitle'),
                hint: t('secretary.choosePatient.otherHint'),
                patients: isNew ? result.patients || [] : (0, $8af4119da22d78aa$export$3c6f001f1e489099)(result),
                newPatientName: booking && !isNew ? heard : null,
                onPick: session.choosePatient,
                onNew: session.chooseNewPatient,
                onBack: ()=>onChoosing(false),
                tr: tr
            })
        });
    }
    switch(result.outcome){
        case 'CHOOSE_PATIENT':
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                "data-testid": "secretary-choose-patient",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($42c1aae3f39aa268$var$PatientChoice, {
                        title: t('secretary.choosePatient.title'),
                        hint: heard ? t('secretary.choosePatient.hintHeard', {
                            name: heard
                        }) : t('secretary.choosePatient.hint'),
                        patients: result.patients || [],
                        newPatientName: booking ? heard : null,
                        onPick: session.choosePatient,
                        onNew: session.chooseNewPatient,
                        tr: tr
                    }),
                    booking && heard ? null : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                        type: "button",
                        variant: "outline",
                        onClick: session.again,
                        children: t('secretary.choosePatient.none')
                    })
                ]
            });
        case 'CHOOSE_DOCTOR':
            if (session.question?.kind === 'doctor') // «با کدام پزشک؟» is the question above: free, with a key per doctor.
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                "data-testid": "secretary-choose-doctor",
                "data-asked": "true",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        style: $42c1aae3f39aa268$var$S.title,
                        children: t('secretary.chooseDoctor.waitTitle')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        style: {
                            ...$42c1aae3f39aa268$var$S.hint,
                            marginBottom: 0
                        },
                        children: t('secretary.chooseDoctor.waitHint')
                    })
                ]
            });
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                "data-testid": "secretary-choose-doctor",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        style: $42c1aae3f39aa268$var$S.title,
                        children: t('secretary.chooseDoctor.title')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        style: $42c1aae3f39aa268$var$S.hint,
                        children: t('secretary.chooseDoctor.hint')
                    }),
                    (result.doctors || []).map((d, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            type: "button",
                            autoFocus: i === 0,
                            style: $42c1aae3f39aa268$var$pick,
                            onClick: ()=>session.chooseDoctor(d.doctorId),
                            "data-testid": `secretary-doctor-${d.doctorId}`,
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                style: {
                                    flex: 1,
                                    minWidth: 0
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        dir: "auto",
                                        style: {
                                            display: 'block',
                                            fontSize: '0.9375rem',
                                            fontWeight: 700
                                        },
                                        children: d.name
                                    }),
                                    d.specialty ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        dir: "auto",
                                        style: {
                                            display: 'block',
                                            fontSize: '0.8125rem',
                                            color: (0, $jTCZr.C).textSecondary
                                        },
                                        children: d.specialty
                                    }) : null
                                ]
                            })
                        }, d.doctorId))
                ]
            });
        case 'PROPOSAL':
            if (result.kind === 'book_appointment') {
                // This window opens for a booking only while something must be answered
                // first; the time is chosen in «ثبت نوبت», which opens on the first one.
                const first = result.booking.slots?.[0] || null;
                const isNew = !!result.booking.patient?.isNew;
                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    "data-testid": "secretary-booking",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($42c1aae3f39aa268$var$ProposalHead, {
                            title: t('secretary.window.bookingTitle', {
                                name: result.booking.patient.name
                            }),
                            t: t
                        }),
                        first ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                marginTop: 6,
                                fontSize: '0.90625rem',
                                fontWeight: 700,
                                color: (0, $jTCZr.C).textPrimary
                            },
                            "data-testid": "secretary-booking-when",
                            children: t('secretary.window.bookingWhen', {
                                day: formatDate(first.dateTime, 'weekdayDayMonth'),
                                time: formatTime(first.dateTime),
                                doctor: result.booking.doctor.name
                            })
                        }) : null,
                        isNew ? /*#__PURE__*/ (0, $ayMG0.jsx)($42c1aae3f39aa268$var$NewPatientNotice, {
                            name: result.booking.patient.name,
                            similar: result.reason === 'similar_patient',
                            details: result.booking.newPatient,
                            onClosest: result.patients?.length ? ()=>onChoosing(true) : null,
                            onContinue: session.continueSpeaking,
                            skipped: session.skipped,
                            asking: Boolean(result.draft),
                            // A record already on the number: book the proposed hour for IT, in the form.
                            onBookExisting: (p)=>onBook({
                                    ...(0, $8af4119da22d78aa$export$8d14b304fe6a5f00)(result.booking, 0),
                                    patient: {
                                        id: p.id,
                                        name: p.name || '',
                                        phone: p.phone || ''
                                    },
                                    newPatient: null
                                }),
                            t: t,
                            formatDigits: formatDigits
                        }) : null,
                        /*#__PURE__*/ (0, $ayMG0.jsx)($42c1aae3f39aa268$var$RequestedHour, {
                            booking: result.booking,
                            t: t,
                            formatDate: formatDate,
                            formatTime: formatTime
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                ...$42c1aae3f39aa268$var$S.row,
                                justifyContent: 'space-between',
                                alignItems: 'center'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        fontSize: '0.78125rem',
                                        color: (0, $jTCZr.C).textSecondary
                                    },
                                    children: t('secretary.notSaved')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    style: {
                                        display: 'inline-flex',
                                        flexWrap: 'wrap',
                                        gap: 8
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                            type: "button",
                                            variant: "outline",
                                            onClick: onClose,
                                            "data-testid": "secretary-dismiss",
                                            children: t('secretary.cancel')
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                                            type: "button",
                                            autoFocus: true,
                                            onClick: primary,
                                            "aria-keyshortcuts": "Control+Enter",
                                            "data-testid": "secretary-booking-continue",
                                            children: [
                                                isNew ? t('secretary.booking.continueNew') : t('secretary.booking.continue'),
                                                " ",
                                                submitKbd
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                });
            }
            if (result.kind === 'mark_arrived') {
                const a = result.arrival;
                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    "data-testid": "secretary-arrival",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($42c1aae3f39aa268$var$ProposalHead, {
                            title: t('secretary.arrival.title'),
                            t: t
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                marginTop: 14,
                                padding: '14px 16px',
                                borderRadius: 10,
                                border: `1px solid ${(0, $jTCZr.C).border}`,
                                background: (0, $jTCZr.C).bg
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    dir: "auto",
                                    style: {
                                        fontSize: '0.9375rem',
                                        fontWeight: 700,
                                        color: (0, $jTCZr.C).textPrimary
                                    },
                                    children: a.patient.name
                                }),
                                a.dateTime ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    style: {
                                        fontSize: '0.84375rem',
                                        color: (0, $jTCZr.C).textSecondary,
                                        marginBottom: 10
                                    },
                                    children: a.doctorName ? t('secretary.arrival.today', {
                                        time: formatTime(a.dateTime),
                                        doctor: a.doctorName
                                    }) : t('secretary.arrival.todayNoDoctor', {
                                        time: formatTime(a.dateTime)
                                    })
                                }) : null,
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        gap: 8,
                                        fontSize: '0.8125rem',
                                        color: (0, $jTCZr.C).textSecondary
                                    },
                                    children: [
                                        t('secretary.arrival.status'),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7h7Jc.default), {
                                            status: "scheduled"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gKFEi.default), {
                                            size: 16,
                                            "aria-hidden": "true",
                                            style: {
                                                transform: 'scaleX(var(--dir-flip, 1))'
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7h7Jc.default), {
                                            status: "arrived"
                                        })
                                    ]
                                })
                            ]
                        }),
                        error,
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                ...$42c1aae3f39aa268$var$S.row,
                                justifyContent: 'space-between',
                                alignItems: 'center'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        fontSize: '0.78125rem',
                                        color: (0, $jTCZr.C).textSecondary
                                    },
                                    children: t('secretary.notSaved')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    style: {
                                        display: 'inline-flex',
                                        flexWrap: 'wrap',
                                        gap: 8
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                            type: "button",
                                            variant: "outline",
                                            onClick: onClose,
                                            disabled: busy,
                                            children: t('secretary.cancel')
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                                            type: "button",
                                            autoFocus: true,
                                            onClick: primary,
                                            disabled: busy,
                                            "aria-keyshortcuts": "Control+Enter",
                                            "data-testid": "secretary-arrival-commit",
                                            children: [
                                                t('secretary.arrival.commit'),
                                                " ",
                                                submitKbd
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                });
            }
            if (result.kind === 'follow_up') {
                const f = result.followUp;
                const kind = (0, $8af4119da22d78aa$export$5e789e1047917ea2).includes(f.kind) ? f.kind : 'other';
                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    "data-testid": "secretary-followup",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($42c1aae3f39aa268$var$ProposalHead, {
                            title: t('secretary.followUp.title'),
                            t: t
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                marginTop: 14,
                                padding: '14px 16px',
                                borderRadius: 10,
                                border: `1px solid ${(0, $jTCZr.C).border}`,
                                background: (0, $jTCZr.C).bg,
                                fontSize: '0.875rem'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    dir: "auto",
                                    style: {
                                        fontSize: '0.9375rem',
                                        fontWeight: 700,
                                        color: (0, $jTCZr.C).textPrimary
                                    },
                                    children: f.patient.name
                                }),
                                f.dueAt ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        color: (0, $jTCZr.C).textSecondary
                                    },
                                    children: [
                                        t('secretary.understood.due'),
                                        ": ",
                                        formatDate(f.dueAt, 'weekdayDayMonth')
                                    ]
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    style: {
                                        color: (0, $jTCZr.C).amber,
                                        fontWeight: 700
                                    },
                                    "data-testid": "secretary-followup-no-due",
                                    children: t('secretary.followUp.noDue')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        color: (0, $jTCZr.C).textSecondary
                                    },
                                    children: [
                                        t('secretary.followUp.kind'),
                                        ": ",
                                        t(`patients.followUp.kind.${kind}`)
                                    ]
                                }),
                                f.note ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    dir: "auto",
                                    style: {
                                        color: (0, $jTCZr.C).textSecondary
                                    },
                                    children: [
                                        t('secretary.followUp.note'),
                                        ": ",
                                        f.note
                                    ]
                                }) : null
                            ]
                        }),
                        error,
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                ...$42c1aae3f39aa268$var$S.row,
                                justifyContent: 'space-between',
                                alignItems: 'center'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        fontSize: '0.78125rem',
                                        color: (0, $jTCZr.C).textSecondary
                                    },
                                    children: t('secretary.notSaved')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    style: {
                                        display: 'inline-flex',
                                        flexWrap: 'wrap',
                                        gap: 8
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                            type: "button",
                                            variant: "outline",
                                            onClick: onClose,
                                            disabled: busy,
                                            children: t('secretary.cancel')
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                                            type: "button",
                                            autoFocus: Boolean(f.dueAt),
                                            onClick: primary,
                                            disabled: busy || !f.dueAt,
                                            "aria-keyshortcuts": "Control+Enter",
                                            "data-testid": "secretary-followup-commit",
                                            children: [
                                                t('secretary.followUp.commit'),
                                                " ",
                                                submitKbd
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                });
            }
            break;
        case 'NO_SLOT':
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                "data-testid": "secretary-no-slot",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($42c1aae3f39aa268$var$Verdict, {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kMJsW.default), {
                            size: 22
                        }),
                        title: result.booking?.requestedAt ? t('secretary.booking.noSlotNear', {
                            day: formatDate(result.booking.requestedAt, 'weekdayDayMonth'),
                            time: formatTime(result.booking.requestedAt)
                        }) : t('secretary.booking.noSlotTitle'),
                        children: t('secretary.booking.noSlotHint')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: $42c1aae3f39aa268$var$S.row,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                            type: "button",
                            variant: "outline",
                            autoFocus: true,
                            onClick: ()=>onBook((0, $8af4119da22d78aa$export$8d14b304fe6a5f00)(result.booking, -1)),
                            "data-testid": "secretary-open-form",
                            children: t('secretary.booking.openForm')
                        })
                    })
                ]
            });
        case 'NOTHING_TO_DO':
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                "data-testid": "secretary-nothing",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($42c1aae3f39aa268$var$Verdict, {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $huNwV.default), {
                            size: 22
                        }),
                        title: t('secretary.arrival.nothingTitle'),
                        children: t('secretary.arrival.nothingHint')
                    }),
                    result.arrival ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            gap: 8,
                            marginTop: 14,
                            fontSize: '0.875rem'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                dir: "auto",
                                style: {
                                    fontWeight: 700
                                },
                                children: result.arrival.patient.name
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7h7Jc.default), {
                                status: result.arrival.status
                            })
                        ]
                    }) : null
                ]
            });
        case 'NAVIGATE':
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                "data-testid": "secretary-open-patient",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        style: $42c1aae3f39aa268$var$S.title,
                        children: t('secretary.openPatient.title')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            ...$42c1aae3f39aa268$var$pick,
                            cursor: 'default',
                            marginTop: 14
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                "aria-hidden": "true",
                                style: {
                                    ...$42c1aae3f39aa268$var$S.disc,
                                    width: 40,
                                    height: 40,
                                    background: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.1),
                                    color: (0, $jTCZr.C).navy
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ff4d96da330336c2$export$2e2bcd8739ae039), {
                                    size: 20
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($42c1aae3f39aa268$var$PatientLine, {
                                patient: result.patient,
                                t: t,
                                formatDigits: formatDigits
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: $42c1aae3f39aa268$var$S.row,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                            type: "button",
                            autoFocus: true,
                            onClick: primary,
                            "aria-keyshortcuts": "Control+Enter",
                            "data-testid": "secretary-open-patient-go",
                            children: [
                                t('secretary.openPatient.open'),
                                " ",
                                submitKbd
                            ]
                        })
                    })
                ]
            });
        case 'ANSWER':
            if (result.kind === 'patient_balance' && result.balance) {
                const b = result.balance;
                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    "data-testid": "secretary-balance",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            style: $42c1aae3f39aa268$var$S.title,
                            children: t('secretary.balance.title', {
                                name: b.patient.name
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            style: {
                                ...$42c1aae3f39aa268$var$S.hint,
                                marginBottom: 0
                            },
                            children: t('secretary.balance.source')
                        }),
                        b.outstanding > 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    dir: "ltr",
                                    style: {
                                        ...$42c1aae3f39aa268$var$S.ltr,
                                        margin: '12px 0 4px',
                                        fontSize: '2.125rem',
                                        fontWeight: 800,
                                        color: (0, $jTCZr.C).textPrimary,
                                        whiteSpace: 'nowrap',
                                        textAlign: 'end'
                                    },
                                    "data-testid": "secretary-balance-amount",
                                    children: formatMoney(b.outstanding, {
                                        currency: b.currency,
                                        withUnit: true
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    style: {
                                        fontSize: '0.875rem',
                                        color: (0, $jTCZr.C).textSecondary
                                    },
                                    children: t('secretary.balance.openInvoices', {
                                        count: formatNumber(b.openInvoices)
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                margin: '12px 0',
                                fontSize: '0.9375rem',
                                fontWeight: 700
                            },
                            "data-testid": "secretary-balance-none",
                            children: t('secretary.balance.none')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: $42c1aae3f39aa268$var$S.row,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                type: "button",
                                variant: "outline",
                                onClick: ()=>onOpenPatient(b.patient.id),
                                children: t('secretary.balance.openRecord')
                            })
                        })
                    ]
                });
            }
            if (result.kind === 'day_summary' && result.daySummary) {
                const d = result.daySummary;
                const cells = [
                    'total',
                    'scheduled',
                    'arrived',
                    'inVisit',
                    'completed',
                    'cancelled',
                    'noShow'
                ];
                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    "data-testid": "secretary-day-summary",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            style: $42c1aae3f39aa268$var$S.title,
                            children: t('secretary.daySummary.title')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            style: $42c1aae3f39aa268$var$S.hint,
                            children: t('secretary.daySummary.source')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                display: 'grid',
                                gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))',
                                gap: 10
                            },
                            children: cells.map((k)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        padding: '10px 12px',
                                        borderRadius: 10,
                                        border: `1px solid ${(0, $jTCZr.C).border}`,
                                        background: (0, $jTCZr.C).bg
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                fontSize: '0.78125rem',
                                                color: (0, $jTCZr.C).textSecondary
                                            },
                                            children: t(`secretary.daySummary.${k}`)
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                fontSize: '1.5rem',
                                                fontWeight: 800,
                                                fontVariantNumeric: 'tabular-nums'
                                            },
                                            "data-testid": `secretary-day-${k}`,
                                            children: formatNumber(d[k])
                                        })
                                    ]
                                }, k))
                        })
                    ]
                });
            }
            break;
        case 'UNAVAILABLE':
            return /*#__PURE__*/ (0, $ayMG0.jsx)($42c1aae3f39aa268$var$Verdict, {
                testid: "secretary-unavailable",
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8MlIT.default), {
                    size: 22
                }),
                title: t('secretary.unavailable.title'),
                children: t('secretary.unavailable.hint')
            });
        case 'FORBIDDEN':
            {
                const keys = result.missingPermissions || [];
                return /*#__PURE__*/ (0, $ayMG0.jsxs)($42c1aae3f39aa268$var$Verdict, {
                    testid: "secretary-forbidden",
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lig1.default), {
                        size: 22
                    }),
                    title: t('secretary.forbidden.title'),
                    children: [
                        keys.length ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            children: t('secretary.forbidden.needs', {
                                list: keys.map((k)=>t(`people.permissions.${k}.label`)).join(" \xb7 ")
                            })
                        }) : null,
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            children: t('secretary.forbidden.hint')
                        })
                    ]
                });
            }
        case 'OUT_OF_SCOPE':
            {
                const topic = (0, $8af4119da22d78aa$export$f2f42820b10476f7).includes(result.topic) ? result.topic : 'other';
                return /*#__PURE__*/ (0, $ayMG0.jsx)($42c1aae3f39aa268$var$Verdict, {
                    testid: "secretary-out-of-scope",
                    tone: "warning",
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $QG9Z3.default), {
                        size: 22
                    }),
                    title: t('secretary.outOfScope.title'),
                    children: t(`secretary.outOfScope.topic.${topic}`)
                });
            }
        case 'NOT_FOUND':
            {
                const name = result.detail;
                const title = !name ? t('secretary.notFound.titleGeneric') : result.reason === 'not_booked_today' ? t('secretary.notFound.notBookedToday', {
                    name: name
                }) : result.reason === 'no_such_patient' ? t('secretary.notFound.noSuchPatient', {
                    name: name
                }) : t('secretary.notFound.title', {
                    name: name
                });
                const hint = result.reason === 'no_doctor' ? t('secretary.notFound.noDoctor') : result.reason === 'not_booked_today' ? t('secretary.notFound.notBookedTodayHint') : t('secretary.notFound.hint');
                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    "data-testid": "secretary-not-found",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($42c1aae3f39aa268$var$Verdict, {
                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8MlIT.default), {
                                size: 22
                            }),
                            title: title,
                            children: hint
                        }),
                        result.patients?.length ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                marginTop: 18
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($42c1aae3f39aa268$var$PatientChoice, {
                                compact: true,
                                title: t('secretary.choosePatient.closestTitle'),
                                patients: result.patients,
                                onPick: session.choosePatient,
                                tr: tr
                            })
                        }) : null
                    ]
                });
            }
        default:
            break;
    }
    const nothingHeard = result.reason === 'nothing_heard';
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": "secretary-unknown",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($42c1aae3f39aa268$var$Verdict, {
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8MlIT.default), {
                    size: 22
                }),
                title: nothingHeard ? t('secretary.unknown.nothingHeardTitle') : t('secretary.unknown.title'),
                children: nothingHeard ? t('secretary.unknown.nothingHeardHint') : t('secretary.unknown.hint')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: $42c1aae3f39aa268$var$S.row,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                    type: "button",
                    autoFocus: true,
                    onClick: session.again,
                    "aria-keyshortcuts": "F1",
                    "data-testid": "secretary-unknown-again",
                    children: [
                        t('secretary.heard.again'),
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)($42c1aae3f39aa268$var$KeyCap, {
                            combo: "f1"
                        })
                    ]
                })
            })
        ]
    });
}
function $42c1aae3f39aa268$var$CostLine({ session: session, t: t, formatNumber: formatNumber }) {
    const command = session.priceOf?.((0, $8af4119da22d78aa$export$46118eb9f2550753));
    const minute = session.priceOf?.((0, $8af4119da22d78aa$export$957d60e9b2ce814c));
    const known = Number.isFinite(command) && Number.isFinite(minute);
    let text;
    if (session.phase === (0, $8af4119da22d78aa$export$2cc7a2eaaea7809f).LISTENING) text = known ? t('secretary.cost.before', {
        minute: formatNumber(minute),
        command: formatNumber(command)
    }) : t('secretary.cost.beforeUnknown');
    else if (session.phase === (0, $8af4119da22d78aa$export$2cc7a2eaaea7809f).PROCESSING) text = t('secretary.cost.processing');
    else if (session.phase === (0, $8af4119da22d78aa$export$2cc7a2eaaea7809f).RESULT) {
        if (session.result?.charged) text = Number.isFinite(command) ? t('secretary.cost.charged', {
            command: formatNumber(command)
        }) : t('secretary.cost.chargedUnknown');
        else text = session.result?.reason === 'nothing_heard' ? t('secretary.cost.free') : t('secretary.cost.notCharged');
        if (session.question) text = `${text} ${t('secretary.cost.answers')}`;
    } else text = t('secretary.cost.free');
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        "data-testid": "secretary-cost",
        children: text
    });
}
/** The status under the window's title. */ function $42c1aae3f39aa268$var$statusOf(phase, t) {
    if (phase === (0, $8af4119da22d78aa$export$2cc7a2eaaea7809f).LISTENING) return t('secretary.status.listening');
    if (phase === (0, $8af4119da22d78aa$export$2cc7a2eaaea7809f).PROCESSING) return t('secretary.status.processing');
    if (phase === (0, $8af4119da22d78aa$export$2cc7a2eaaea7809f).RESULT) return t('secretary.status.ready');
    return t('secretary.status.stopped');
}
function $42c1aae3f39aa268$export$2e2bcd8739ae039({ item: item, onClose: onClose, onUpdate: onUpdate, onBook: onBook, onDone: onDone, onOpenPatient: onOpenPatient, onDismiss: onDismiss, onRecordAgain: onRecordAgain }) {
    const tr = (0, $e1LEq.default)();
    const { t: t, formatDigits: formatDigits, formatNumber: formatNumber } = tr;
    const session = (0, $e5b7dbbee71b145f$export$fe6e2a80470eaba2)({
        initial: item,
        onChange: onUpdate,
        onRecordAgain: onRecordAgain
    });
    const { phase: phase, result: result } = session;
    // «شارژ» on the out-of-credit view only where credit is sold (hooks/useCreditPurchase.js).
    const topUp = (0, $9SI14.useCreditPurchase)(phase === (0, $8af4119da22d78aa$export$2cc7a2eaaea7809f).NO_CREDIT);
    // «بیمار دیگری است؟» — open in the window until the next answer arrives.
    const [choosing, setChoosing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setChoosing(false);
    }, [
        result
    ]);
    const others = result ? (0, $8af4119da22d78aa$export$3c6f001f1e489099)(result) : [];
    // Not for a NEW patient: the proposal's own notice offers the closest names.
    const canSwitch = phase === (0, $8af4119da22d78aa$export$2cc7a2eaaea7809f).RESULT && result?.outcome !== 'CHOOSE_PATIENT' && others.length > 0 && !(0, $8af4119da22d78aa$export$fa7e7bf5f125d593)(result)?.isNew;
    // «بیمار دیگری است؟» takes the window: a question's recording stops, unsent.
    const openChoosing = (next)=>{
        if (next) session.cancelAnswer();
        setChoosing(next);
    };
    // A result that no longer needs this window goes where it belongs — once: the
    // last question answered or skipped, a patient chosen, a sentence corrected.
    const routes = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef({
        onBook: onBook,
        onOpenPatient: onOpenPatient
    });
    routes.current = {
        onBook: onBook,
        onOpenPatient: onOpenPatient
    };
    const routed = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // What the window OPENED on stays in it: only what happens here moves it on.
    const opened = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef({
        result: item?.result || null,
        skipped: (item?.skipped || []).length
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (phase !== (0, $8af4119da22d78aa$export$2cc7a2eaaea7809f).RESULT || !result || routed.current === result) return;
        if (result === opened.current.result && session.skipped.size === opened.current.skipped) return;
        const route = (0, $8af4119da22d78aa$export$fa13ff2bc40a02c1)(result, session.skipped);
        if (route === 'window') return;
        routed.current = result;
        if (route === 'form') routes.current.onBook((0, $8af4119da22d78aa$export$8d14b304fe6a5f00)(result.booking, 0));
        else if (route === 'formDay') routes.current.onBook((0, $8af4119da22d78aa$export$8d14b304fe6a5f00)(result.booking, -1));
        else if (route === 'navigate') routes.current.onOpenPatient(result.patient.id);
    }, [
        phase,
        result,
        session.skipped
    ]);
    // F1 inside the window: the one thing the microphone can do next — end what it
    // is recording, or start a new command.
    const talk = phase === (0, $8af4119da22d78aa$export$2cc7a2eaaea7809f).LISTENING ? session.finish : session.answer?.stage === 'listening' ? session.finishAnswer : phase === (0, $8af4119da22d78aa$export$2cc7a2eaaea7809f).RESULT || phase === (0, $8af4119da22d78aa$export$2cc7a2eaaea7809f).ERROR || phase === (0, $8af4119da22d78aa$export$2cc7a2eaaea7809f).NO_MIC ? session.again : null;
    (0, $ciRrJ.useShortcut)('f1', ()=>talk?.(), {
        label: t('secretary.shortcuts.talk'),
        group: t('secretary.shortcuts.open'),
        enabled: Boolean(talk)
    });
    // Registered as well as handled by the dialog itself, so it takes precedence over
    // an `esc` the screen underneath has bound for exactly as long as this is mounted.
    (0, $ciRrJ.useShortcut)('esc', onClose, {
        label: t('secretary.close'),
        group: t('secretary.shortcuts.open')
    });
    // «ادامه بگویید» — record more of the same command; it is appended to what was heard.
    (0, $ciRrJ.useShortcut)('shift+f1', ()=>session.continueSpeaking(), {
        label: t('secretary.shortcuts.continue'),
        group: t('secretary.shortcuts.open'),
        enabled: phase === (0, $8af4119da22d78aa$export$2cc7a2eaaea7809f).RESULT && Boolean(session.text)
    });
    const micProblem = session.micStatus === 'denied' ? t('secretary.noMic.denied') : session.micStatus === 'unsupported' ? t('secretary.noMic.unsupported') : t('secretary.noMic.generic');
    const small = result?.kind === 'mark_arrived' || result?.kind === 'patient_balance';
    let body = null;
    if (phase === (0, $8af4119da22d78aa$export$2cc7a2eaaea7809f).LISTENING) // «ادامه بگویید» — the only recording that starts inside a window.
    body = /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            textAlign: 'center',
            padding: '8px 0'
        },
        "data-testid": "secretary-listening",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                "aria-hidden": "true",
                style: {
                    width: 72,
                    height: 72,
                    margin: '0 auto',
                    borderRadius: 999,
                    display: 'grid',
                    placeItems: 'center',
                    background: (0, $jTCZr.GRADIENT_BRAND),
                    color: (0, $jTCZr.C).card,
                    boxShadow: `0 0 0 10px ${(0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.08)}`
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hSPBf.default), {
                    size: 30,
                    strokeWidth: 1.6
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    marginTop: 22,
                    fontSize: '1.375rem',
                    fontWeight: 800,
                    color: (0, $jTCZr.C).textPrimary
                },
                children: t('secretary.listen.continueTitle')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                dir: "auto",
                style: {
                    maxWidth: 440,
                    margin: '4px auto 0',
                    fontSize: '0.84375rem',
                    color: (0, $jTCZr.C).textSecondary
                },
                "data-testid": "secretary-so-far",
                children: t('secretary.listen.soFar', {
                    text: session.text
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 8,
                    margin: '12px 0 4px',
                    fontSize: '1rem',
                    fontWeight: 700
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        "aria-hidden": "true",
                        style: {
                            width: 9,
                            height: 9,
                            borderRadius: 999,
                            background: session.recording ? (0, $jTCZr.C).red : (0, $jTCZr.C).border
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        dir: "ltr",
                        style: $42c1aae3f39aa268$var$S.ltr,
                        "data-testid": "secretary-clock",
                        children: formatDigits((0, $8af4119da22d78aa$export$3c7a65f8740dffe9)(session.seconds))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    fontSize: '0.84375rem',
                    color: (0, $jTCZr.C).textSecondary
                },
                children: session.recording ? t('secretary.listen.sub') : t('secretary.listen.preparing')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                dir: "auto",
                "aria-live": "polite",
                style: {
                    minHeight: 22,
                    margin: '6px 0 12px',
                    fontSize: '0.875rem',
                    color: (0, $jTCZr.C).textSecondary
                },
                "data-testid": "secretary-interim",
                children: session.interim
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 8,
                    justifyContent: 'center'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                        type: "button",
                        autoFocus: true,
                        onClick: session.finish,
                        disabled: !session.recording,
                        "aria-keyshortcuts": "F1",
                        "data-testid": "secretary-stop",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7udIf.default), {
                                size: 14,
                                "aria-hidden": "true",
                                fill: "currentColor"
                            }),
                            " ",
                            t('secretary.listen.stop'),
                            " ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)($42c1aae3f39aa268$var$KeyCap, {
                                combo: "f1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                        type: "button",
                        variant: "ghost",
                        onClick: session.cancelContinue,
                        "data-testid": "secretary-continue-cancel",
                        children: t('secretary.listen.backToResult')
                    })
                ]
            })
        ]
    });
    else if (phase === (0, $8af4119da22d78aa$export$2cc7a2eaaea7809f).PROCESSING) body = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonRegion), {
        label: t('secretary.status.processing'),
        "data-testid": "secretary-processing",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            style: {
                ...$42c1aae3f39aa268$var$S.card,
                padding: 16
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        fontSize: '0.9375rem',
                        fontWeight: 800,
                        marginBottom: 8,
                        color: (0, $jTCZr.C).textPrimary
                    },
                    children: t('secretary.processing.title')
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: 10,
                        padding: '4px 0',
                        fontSize: '0.875rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $huNwV.default), {
                            size: 18,
                            "aria-hidden": "true",
                            color: (0, $jTCZr.C).green
                        }),
                        " ",
                        t('secretary.processing.received')
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: 10,
                        padding: '4px 0',
                        fontSize: '0.875rem',
                        fontWeight: 700
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kMJsW.default), {
                            size: 18,
                            "aria-hidden": "true",
                            color: (0, $jTCZr.C).navy
                        }),
                        " ",
                        t('secretary.processing.understanding')
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                    height: 44,
                    radius: 10,
                    style: {
                        marginTop: 10
                    }
                })
            ]
        })
    });
    else if (phase === (0, $8af4119da22d78aa$export$2cc7a2eaaea7809f).NO_CREDIT) body = /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": "secretary-no-credit",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                variant: "warning",
                title: t('secretary.noCredit.title'),
                children: session.creditAfterRun ? t('secretary.noCredit.afterRun') : t('secretary.noCredit.notStarted')
            }),
            topUp && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    ...$42c1aae3f39aa268$var$S.row,
                    justifyContent: 'flex-start'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                    asChild: true,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                        href: (0, $iAkVL.accountUrl)('/credits'),
                        "data-testid": "secretary-top-up",
                        children: t('secretary.noCredit.topUp')
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                style: {
                    ...$42c1aae3f39aa268$var$S.hint,
                    margin: '14px 0 0'
                },
                children: t('secretary.noCredit.manual')
            })
        ]
    });
    else if (phase === (0, $8af4119da22d78aa$export$2cc7a2eaaea7809f).NO_MIC) body = /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": "secretary-no-mic",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($42c1aae3f39aa268$var$Verdict, {
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3HcoA.default), {
                    size: 22
                }),
                title: t('secretary.noMic.title'),
                children: micProblem
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    ...$42c1aae3f39aa268$var$S.row,
                    justifyContent: 'flex-start'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                    type: "button",
                    autoFocus: true,
                    onClick: session.continueSpeaking,
                    "data-testid": "secretary-mic-retry",
                    children: t('secretary.noMic.retry')
                })
            })
        ]
    });
    else if (phase === (0, $8af4119da22d78aa$export$2cc7a2eaaea7809f).ERROR) body = /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": "secretary-error",
        children: [
            session.text ? /*#__PURE__*/ (0, $ayMG0.jsx)($42c1aae3f39aa268$var$HeardCard, {
                text: session.text,
                onAgain: session.again,
                onRunEdited: session.runEdited,
                t: t
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                variant: "error",
                title: t('secretary.error.title'),
                children: t('secretary.error.hint')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    ...$42c1aae3f39aa268$var$S.row,
                    justifyContent: 'flex-start'
                },
                children: [
                    session.text ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                        type: "button",
                        autoFocus: true,
                        onClick: session.retry,
                        "data-testid": "secretary-retry",
                        children: t('secretary.error.retry')
                    }) : null,
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                        type: "button",
                        variant: "outline",
                        onClick: session.again,
                        "data-testid": "secretary-error-again",
                        children: t('secretary.error.again')
                    })
                ]
            })
        ]
    });
    else if (result) body = /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 12
        },
        "data-testid": "secretary-result",
        "data-outcome": result.outcome,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($42c1aae3f39aa268$var$HeardCard, {
                text: session.text,
                onAgain: session.again,
                onContinue: session.continueSpeaking,
                onRunEdited: session.runEdited,
                onEdit: session.cancelAnswer,
                t: t
            }),
            !choosing && session.question ? /*#__PURE__*/ (0, $ayMG0.jsx)($42c1aae3f39aa268$var$QuestionCard, {
                session: session,
                tr: tr
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
                style: {
                    ...$42c1aae3f39aa268$var$S.card,
                    padding: 16,
                    minWidth: 0,
                    boxSizing: 'border-box'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($42c1aae3f39aa268$var$Prepared, {
                    session: session,
                    choosing: choosing,
                    onChoosing: openChoosing,
                    onBook: onBook,
                    onDone: onDone,
                    onOpenPatient: onOpenPatient,
                    onClose: onDismiss,
                    tr: tr
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($42c1aae3f39aa268$var$UnderstoodCard, {
                result: result,
                onOtherPatient: canSwitch && !choosing ? ()=>openChoosing(true) : null,
                t: t,
                formatDate: tr.formatDate,
                formatTime: tr.formatTime,
                formatDigits: formatDigits
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7guRV.default), {
        open: true,
        onClose: onClose,
        title: t('secretary.name'),
        subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            "aria-live": "polite",
            "data-testid": "secretary-status",
            children: $42c1aae3f39aa268$var$statusOf(phase, t)
        }),
        size: small ? 'sm' : 'md',
        snap: 0.92,
        footer: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            style: {
                fontSize: '0.75rem',
                color: (0, $jTCZr.C).textSecondary,
                textAlign: 'center',
                lineHeight: 1.7,
                paddingTop: 10
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($42c1aae3f39aa268$var$CostLine, {
                session: session,
                t: t,
                formatNumber: formatNumber
            })
        }),
        "data-testid": "secretary-window",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            "data-state": phase,
            "data-testid": "secretary-window-body",
            children: body
        })
    });
}


/**
 * «منشی هوشمند پارسینا» — the record button (PM-0080). Press: record. Press again:
 * stop, and the command is transcribed and run in the BACKGROUND while the desk
 * carries on. What comes back waits in `items` — shown as notifications — until
 * the desk opens it or dismisses it: a result has already cost پارسه, so it never
 * leaves on a timer. Opening one is SecretaryHost's business (model.routeOf).
 *
 * ── TWO MICROPHONES ──────────────────────────────────────────────────────────
 * A command's final transcript arrives after the press that ended it, and the
 * next command may be recorded meanwhile. Each stream (useServerVoiceInput) holds
 * one recording at a time, so there are two, and a new recording takes whichever
 * is free.
 *
 * ── WHAT IS NEVER SPENT ──────────────────────────────────────────────────────
 * A balance known to be too small never starts the microphone. A recording
 * thrown away (× or Esc) is cancelled without «done», so it is never transcribed.
 * Nothing heard is no command: no result, no notification — the button says so.
 * And a command is one sentence: a recording left running stops itself after
 * RECORD_LIMIT_S, and is sent.
 */ 
var $acw62 = parcelRequire("acw62");

var $2Mst8 = parcelRequire("2Mst8");

var $5bPPa = parcelRequire("5bPPa");

var $cqw4c = parcelRequire("cqw4c");

const $c084c90a57499de0$export$f8e33795e5c52d7a = 60;
const $c084c90a57499de0$export$a87c33a42856e4b3 = 10;
const $c084c90a57499de0$export$936a1ffd8dba2622 = 3500;
const $c084c90a57499de0$var$MIC_FAILURES = new Set([
    'denied',
    'unsupported',
    'error'
]);
let $c084c90a57499de0$var$sequence = 0;
const $c084c90a57499de0$var$nextId = ()=>{
    $c084c90a57499de0$var$sequence += 1;
    return `cmd-${Date.now().toString(36)}-${$c084c90a57499de0$var$sequence}`;
};
function $c084c90a57499de0$export$b7532eb5d18177bb() {
    // The meter's readings go straight to whoever draws them — never through this
    // hook's state, which would re-render the whole shell ten times a second.
    const levelListeners = (0, $acw62.useRef)(new Set());
    const onLevel = (0, $acw62.useCallback)((level)=>{
        levelListeners.current.forEach((fn)=>fn(level));
    }, []);
    const voiceA = (0, $cqw4c.useServerVoiceInput)({
        onLevel: onLevel
    });
    const voiceB = (0, $cqw4c.useServerVoiceInput)({
        onLevel: onLevel
    });
    const credits = (0, $5bPPa.useCredits)();
    const voices = (0, $acw62.useRef)({});
    voices.current = {
        a: voiceA,
        b: voiceB
    };
    const creditsRef = (0, $acw62.useRef)(credits);
    creditsRef.current = credits;
    // The stream recording now — 'a' | 'b' | null. A ref as well: presses arrive
    // from keys and clicks between renders.
    const [slot, setSlotState] = (0, $acw62.useState)(null);
    const slotRef = (0, $acw62.useRef)(null);
    const setSlot = (0, $acw62.useCallback)((next)=>{
        slotRef.current = next;
        setSlotState(next);
    }, []);
    // A stream is busy from its start until its final transcript is in.
    const busy = (0, $acw62.useRef)({
        a: false,
        b: false
    });
    const [seconds, setSeconds] = (0, $acw62.useState)(0);
    // Commands between «stop» and their result: transcribing, then running.
    const [pending, setPending] = (0, $acw62.useState)(0);
    const [warn, setWarn] = (0, $acw62.useState)(null);
    const [items, setItems] = (0, $acw62.useState)([]);
    const [openId, setOpenId] = (0, $acw62.useState)(null);
    const alive = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(()=>()=>{
            alive.current = false;
        }, []);
    const flash = (0, $acw62.useCallback)((kind, detail = null)=>setWarn({
            kind: kind,
            detail: detail,
            at: Date.now()
        }), []);
    (0, $acw62.useEffect)(()=>{
        if (!warn) return undefined;
        const id = setTimeout(()=>setWarn(null), $c084c90a57499de0$export$936a1ffd8dba2622);
        return ()=>clearTimeout(id);
    }, [
        warn
    ]);
    const status = slot ? voices.current[slot].status : null;
    const live = status === 'listening';
    (0, $acw62.useEffect)(()=>{
        if (!live) return undefined;
        const id = setInterval(()=>setSeconds((s)=>s + 1), 1000);
        return ()=>clearInterval(id);
    }, [
        live
    ]);
    const addItem = (0, $acw62.useCallback)((item)=>setItems((list)=>[
                ...list,
                item
            ]), []);
    const update = (0, $acw62.useCallback)((id, patch)=>{
        setItems((list)=>list.map((item)=>item.id === id ? {
                    ...item,
                    ...patch
                } : item));
    }, []);
    const dismiss = (0, $acw62.useCallback)((id)=>{
        setItems((list)=>list.filter((item)=>item.id !== id));
        setOpenId((current)=>current === id ? null : current);
    }, []);
    const run = (0, $acw62.useCallback)(async (id, text)=>{
        setPending((n)=>n + 1);
        try {
            const data = await (0, $2Mst8.bffMutation)((0, $8af4119da22d78aa$export$a08e426fe22a33ae), {
                input: {
                    transcript: text,
                    patientId: null,
                    doctorId: null,
                    newPatient: false,
                    questions: true
                }
            });
            if (!alive.current) return;
            update(id, {
                status: 'ready',
                result: data?.runSecretaryCommand || {
                    outcome: 'UNKNOWN',
                    charged: false
                }
            });
        } catch (err) {
            if (!alive.current) return;
            update(id, {
                status: 'ready',
                error: (0, $8af4119da22d78aa$export$96d5fbfea36fa4ee)(err) ? 'credit' : 'failed'
            });
        } finally{
            if (alive.current) setPending((n)=>n - 1);
            // The balance in the sidebar and the next «can I afford it» both read this.
            creditsRef.current.refresh?.();
        }
    }, [
        update
    ]);
    const start = (0, $acw62.useCallback)(()=>{
        if (slotRef.current) return;
        const { balance: balance, priceOf: priceOf } = creditsRef.current;
        if ((0, $8af4119da22d78aa$export$7ac2ab00227c6fe5)(balance, priceOf)) {
            addItem({
                id: $c084c90a57499de0$var$nextId(),
                createdAt: Date.now(),
                status: 'ready',
                text: '',
                result: null,
                error: 'credit'
            });
            return;
        }
        const free = !busy.current.a ? 'a' : !busy.current.b ? 'b' : null;
        if (!free) {
            flash('busy');
            return;
        }
        busy.current[free] = true;
        setWarn(null);
        setSeconds(0);
        setSlot(free);
        const voice = voices.current[free];
        // A stream that failed before keeps its failure until it is cleared.
        voice.cancel();
        voice.start({
            meter: true
        });
    }, [
        addItem,
        flash,
        setSlot
    ]);
    const stop = (0, $acw62.useCallback)(async ()=>{
        const current = slotRef.current;
        if (!current) return;
        const voice = voices.current[current];
        setSlot(null);
        if (voice.status !== 'listening') {
            // Pressed again before the stream was up: nothing was recorded, nothing is sent.
            voice.cancel();
            busy.current[current] = false;
            return;
        }
        setPending((n)=>n + 1);
        const text = String(await voice.finishTranscript() || '').trim();
        busy.current[current] = false;
        if (!alive.current) return;
        setPending((n)=>n - 1);
        if (!text) {
            flash('nothing');
            return;
        }
        const id = $c084c90a57499de0$var$nextId();
        addItem({
            id: id,
            createdAt: Date.now(),
            status: 'processing',
            text: text,
            result: null,
            error: null
        });
        run(id, text);
    }, [
        addItem,
        flash,
        run,
        setSlot
    ]);
    /** × or Esc — throw the recording away: closed without «done», never transcribed. */ const discard = (0, $acw62.useCallback)(()=>{
        const current = slotRef.current;
        if (!current) return;
        voices.current[current].cancel();
        busy.current[current] = false;
        setSlot(null);
    }, [
        setSlot
    ]);
    const toggle = (0, $acw62.useCallback)(()=>{
        if (slotRef.current) stop();
        else start();
    }, [
        start,
        stop
    ]);
    // The microphone refused: say why on the button, and record nothing.
    (0, $acw62.useEffect)(()=>{
        if (!slot || !$c084c90a57499de0$var$MIC_FAILURES.has(status)) return;
        busy.current[slot] = false;
        setSlot(null);
        flash('mic', status);
    }, [
        slot,
        status,
        flash,
        setSlot
    ]);
    // A command is one sentence: a recording left running stops itself, and is sent.
    (0, $acw62.useEffect)(()=>{
        if (slot && seconds >= $c084c90a57499de0$export$f8e33795e5c52d7a) stop();
    }, [
        slot,
        seconds,
        stop
    ]);
    const subscribeLevel = (0, $acw62.useCallback)((fn)=>{
        levelListeners.current.add(fn);
        return ()=>{
            levelListeners.current.delete(fn);
        };
    }, []);
    // Only what came back is shown; what is still on its way shows on the button.
    const ready = (0, $acw62.useMemo)(()=>items.filter((item)=>item.status === 'ready' && item.id !== openId), [
        items,
        openId
    ]);
    const openItem = (0, $acw62.useMemo)(()=>items.find((item)=>item.id === openId) || null, [
        items,
        openId
    ]);
    return {
        recording: Boolean(slot),
        live: live,
        seconds: seconds,
        remaining: Math.max(0, $c084c90a57499de0$export$f8e33795e5c52d7a - seconds),
        pending: pending,
        warn: warn,
        items: ready,
        openItem: openItem,
        start: start,
        stop: stop,
        discard: discard,
        toggle: toggle,
        open: setOpenId,
        close: (0, $acw62.useCallback)(()=>setOpenId(null), []),
        update: update,
        dismiss: dismiss,
        subscribeLevel: subscribeLevel
    };
}
var $c084c90a57499de0$export$2e2bcd8739ae039 = $c084c90a57499de0$export$b7532eb5d18177bb;


const $52fffe2758f30419$var$SecretaryContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
function $52fffe2758f30419$export$8bcdbfb9578ee87c() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($52fffe2758f30419$var$SecretaryContext);
}
function $52fffe2758f30419$export$199d2b1ebbee7964({ children: children }) {
    const controller = (0, $c084c90a57499de0$export$b7532eb5d18177bb)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)($52fffe2758f30419$var$SecretaryContext.Provider, {
        value: controller,
        children: children
    });
}
function $52fffe2758f30419$export$2e2bcd8739ae039({ sidebarWidth: sidebarWidth = 0 }) {
    const c = $52fffe2758f30419$export$8bcdbfb9578ee87c();
    const { t: t } = (0, $e1LEq.default)();
    const toast = (0, $6usBW.useToast)();
    const navigate = (0, $7buzq.useAppNavigate)();
    const [booking, setBooking] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const busy = Boolean(booking || c?.openItem);
    /** Where a result goes when it is opened. */ const openResult = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((item)=>{
        const route = item.error ? 'window' : (0, $8af4119da22d78aa$export$fa13ff2bc40a02c1)(item.result, new Set(item.skipped || []));
        if (route === 'form' || route === 'formDay') {
            c.dismiss(item.id);
            setBooking((0, $8af4119da22d78aa$export$8d14b304fe6a5f00)(item.result.booking, route === 'form' ? 0 : -1));
            return;
        }
        if (route === 'navigate') {
            c.dismiss(item.id);
            navigate('patient', {
                id: item.result.patient.id
            });
            return;
        }
        c.open(item.id);
    }, [
        c,
        navigate
    ]);
    (0, $ciRrJ.useShortcut)('f1', ()=>c?.toggle(), {
        label: t('secretary.shortcuts.record'),
        group: t('shortcuts.groups.general'),
        enabled: Boolean(c) && !busy
    });
    (0, $ciRrJ.useShortcut)('esc', ()=>c?.discard(), {
        label: t('secretary.shortcuts.discard'),
        group: t('shortcuts.groups.general'),
        enabled: Boolean(c?.recording) && !busy
    });
    (0, $ciRrJ.useShortcut)('shift+f1', ()=>{
        const items = c?.items || [];
        if (items.length) openResult(items[items.length - 1]);
    }, {
        label: t('secretary.shortcuts.openNewest'),
        group: t('shortcuts.groups.general'),
        enabled: Boolean(c?.items.length) && !busy
    });
    if (!c) return null;
    const item = c.openItem;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5783910e197ee713$export$2e2bcd8739ae039), {
                items: c.items,
                onOpen: openResult,
                onDismiss: c.dismiss,
                sidebarWidth: sidebarWidth
            }),
            item ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $42c1aae3f39aa268$export$2e2bcd8739ae039), {
                item: item,
                onClose: c.close,
                onUpdate: (patch)=>c.update(item.id, patch),
                onBook: (handoff)=>{
                    c.dismiss(item.id);
                    setBooking(handoff);
                },
                onDone: (message)=>{
                    c.dismiss(item.id);
                    if (message) toast.success(message);
                },
                onOpenPatient: (id)=>{
                    c.dismiss(item.id);
                    navigate('patient', {
                        id: id
                    });
                },
                onDismiss: ()=>c.dismiss(item.id),
                onRecordAgain: ()=>{
                    c.dismiss(item.id);
                    c.start();
                }
            }, item.id) : null,
            booking ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a0Xuh.default), {
                presetDoctorId: booking.doctorId,
                presetPatient: booking.patient,
                presetNewPatient: booking.newPatient,
                initialDate: booking.initialDate,
                initialSlotLabel: booking.initialSlotLabel,
                notice: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $dOauK.default), {
                    variant: "info",
                    "data-testid": "secretary-form-notice",
                    children: [
                        t('secretary.booking.formNotice'),
                        booking.newPatient ? ` ${t('secretary.booking.formNoticeNewPatient')}` : '',
                        booking.doctorAssumed ? ` ${t('secretary.booking.formNoticeAssumed')}` : ''
                    ]
                }),
                onClose: ()=>setBooking(null),
                onBooked: (message)=>{
                    if (message) toast.success(message);
                    (0, $d7OV8.reportAppointmentsChanged)();
                }
            }) : null
        ]
    });
}


/**
 * «منشی هوشمند پارسینا» on a phone — the record button (PM-0080).
 *
 * On the desk the secretary is a sidebar row and F1. A phone has neither: the
 * sidebar is the bottom bar, which holds DESTINATIONS (the secretary is part of
 * the shell, not a route), and there is no keyboard. So it is one button, in the
 * thumb's corner above the bar — the inline-end of the screen, which is the left
 * on a Persian or Arabic panel — always one tap from whatever screen is open.
 *
 *   ready      the round button — tap to record;
 *   recording  the same RecordCapsule as the desk: stop, the time, the level, ×;
 *   processing the round button with a spinner — a tap records the next command;
 *   warn       why nothing was recorded, for a few seconds.
 *
 * Placed as InstallPrompt places itself — above the kit's BottomNav, whose height
 * is published as `--app-bottom-nav` — and above the screen's docked CTA bar
 * («ارسال پیام», «ثبت بیمار»…), published by MobileScreen as `--app-screen-cta`:
 * a button over a screen's one primary action would be the worst place for it.
 * While shown it publishes its own room as `--app-fab-space`, which MobileScreen
 * adds to its scroll padding so the last row is never trapped under it. It sits
 * UNDER the install card (z-index 80 against 90) — that offer is brief and
 * dismissible, the secretary is not going anywhere.
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $hSPBf = parcelRequire("hSPBf");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("52bn2");
var $jTCZr = parcelRequire("jTCZr");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $8RTRt = parcelRequire("8RTRt");
/**
 * «منشی هوشمند» while it records (PM-0080) — the only loud state of the record
 * button: a small dark capsule with the stop button, the time and the live level,
 * and a quiet × that throws the recording away. It is gone the moment recording
 * stops, so a glance says whether the microphone is on.
 *
 * Dark on every theme and in both places it appears — the desk's sidebar row and
 * the phone's round button — so its colours are its own, not the theme's.
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $6TdpC = parcelRequire("6TdpC");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

const $ed980b5ca3732495$export$bc82d52e15b2056c = '#111417';
const $ed980b5ca3732495$var$ISLAND_EDGE = 'rgba(255, 255, 255, 0.14)';
const $ed980b5ca3732495$export$a11fe7f15509d324 = '#FF453A';
const $ed980b5ca3732495$export$ae8191e16cbd4c0c = '#FFB340';
const $ed980b5ca3732495$export$5fb253c04d577752 = "@keyframes secretarySpin{to{transform:rotate(360deg)}}.secretary-spin{animation:secretarySpin .9s linear infinite}@media (prefers-reduced-motion: reduce){.secretary-spin{animation:none}}";
function $ed980b5ca3732495$export$b5d4aea7110debc0(seconds) {
    const s = Math.max(0, Math.floor(Number(seconds) || 0));
    return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
}
// Seven bars, each its own share of the level, so speech looks like speech.
const $ed980b5ca3732495$var$WEIGHTS = [
    0.45,
    0.8,
    1,
    0.65,
    0.9,
    0.5,
    0.7
];
/** The live level: only this re-renders on each reading (subscribeLevel). */ function $ed980b5ca3732495$var$LevelMeter({ subscribe: subscribe }) {
    const [level, setLevel] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>subscribe?.(setLevel), [
        subscribe
    ]);
    const scale = Math.min(1, level / 0.12);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        "aria-hidden": "true",
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 3,
            height: 18
        },
        children: $ed980b5ca3732495$var$WEIGHTS.map((w, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                style: {
                    display: 'block',
                    width: 2.5,
                    borderRadius: 2,
                    background: $ed980b5ca3732495$export$a11fe7f15509d324,
                    height: Math.max(3, Math.round(18 * Math.max(0.17, scale * w))),
                    transition: 'height 90ms linear'
                }
            }, i))
    });
}
function $ed980b5ca3732495$export$2e2bcd8739ae039({ controls: c, collapsed: collapsed = false, compact: compact = false, height: height = 44 }) {
    const { t: t, formatDigits: formatDigits, formatNumber: formatNumber } = (0, $e1LEq.default)();
    const counting = c.live && c.remaining <= (0, $c084c90a57499de0$export$a87c33a42856e4b3);
    const time = counting ? `\u{2212}${$ed980b5ca3732495$export$b5d4aea7110debc0(c.remaining)}` : $ed980b5ca3732495$export$b5d4aea7110debc0(c.seconds);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        role: "group",
        "aria-label": t('secretary.recorder.recording'),
        "data-testid": "secretary-recording",
        "data-live": c.live ? 'true' : 'false',
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            height: height,
            boxSizing: 'border-box',
            paddingInline: collapsed ? 5 : '6px 8px',
            borderRadius: 999,
            background: $ed980b5ca3732495$export$bc82d52e15b2056c,
            border: `1px solid ${$ed980b5ca3732495$var$ISLAND_EDGE}`,
            color: '#fff',
            boxShadow: '0 6px 18px rgba(0, 0, 0, 0.22)'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("style", {
                children: $ed980b5ca3732495$export$5fb253c04d577752
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                type: "button",
                onClick: c.stop,
                "aria-label": t('secretary.recorder.stop'),
                title: t('secretary.recorder.stop'),
                "aria-keyshortcuts": "F1",
                "data-testid": "secretary-stop",
                style: {
                    width: 32,
                    height: 32,
                    padding: 0,
                    flexShrink: 0,
                    borderRadius: 999,
                    cursor: 'pointer',
                    border: '2px solid rgba(255, 255, 255, 0.92)',
                    background: 'transparent',
                    display: 'grid',
                    placeItems: 'center'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    "aria-hidden": "true",
                    style: {
                        width: 11,
                        height: 11,
                        borderRadius: 3,
                        background: $ed980b5ca3732495$export$a11fe7f15509d324
                    }
                })
            }),
            collapsed ? null : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                        dir: "ltr",
                        "data-testid": "secretary-timer",
                        "data-counting": counting ? 'true' : 'false',
                        style: {
                            minWidth: '2.6em',
                            fontSize: '0.9375rem',
                            fontWeight: 700,
                            fontVariantNumeric: 'tabular-nums',
                            color: counting ? $ed980b5ca3732495$export$ae8191e16cbd4c0c : '#fff'
                        },
                        children: c.live ? formatDigits(time) : "\u2026"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            flex: compact ? '0 0 auto' : 1,
                            minWidth: 36,
                            display: 'flex',
                            justifyContent: 'center'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($ed980b5ca3732495$var$LevelMeter, {
                            subscribe: c.subscribeLevel
                        })
                    }),
                    c.pending > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        role: "img",
                        className: "secretary-spin",
                        "aria-label": t('secretary.recorder.queued', {
                            count: formatNumber(c.pending)
                        }),
                        title: t('secretary.recorder.queued', {
                            count: formatNumber(c.pending)
                        }),
                        "data-testid": "secretary-queued",
                        style: {
                            width: 13,
                            height: 13,
                            flexShrink: 0,
                            borderRadius: 999,
                            boxSizing: 'border-box',
                            border: '2px solid rgba(255, 255, 255, 0.25)',
                            borderTopColor: 'rgba(255, 255, 255, 0.9)'
                        }
                    }) : null,
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        type: "button",
                        onClick: c.discard,
                        "aria-label": t('secretary.recorder.discard'),
                        title: t('secretary.recorder.discard'),
                        "data-testid": "secretary-discard",
                        style: {
                            width: 24,
                            height: 24,
                            padding: 0,
                            flexShrink: 0,
                            borderRadius: 999,
                            border: 0,
                            cursor: 'pointer',
                            background: 'rgba(255, 255, 255, 0.12)',
                            color: 'rgba(255, 255, 255, 0.75)',
                            display: 'grid',
                            placeItems: 'center'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6TdpC.default), {
                            size: 12,
                            strokeWidth: 2.6,
                            "aria-hidden": "true"
                        })
                    })
                ]
            })
        ]
    });
}



/**
 * «منشی هوشمند» on a desk — the record button, at the foot of the sidebar (PM-0080).
 *
 * One height in every state, so nothing on the screen moves when it is pressed:
 *   ready      the microphone, «منشی هوشمند» and F1 — press to record;
 *   recording  RecordCapsule — stop, the time, the live level, ×;
 *   processing the plain row again with a spinner: the microphone is off, and a
 *              press records the next command while this one finishes;
 *   warn       why nothing was recorded («چیزی نشنیدم», the microphone refused),
 *              for a few seconds.
 * On the folded rail only the icon (or the stop button) stays.
 */ 
var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $hSPBf = parcelRequire("hSPBf");
parcelRequire("52bn2");
var $jTCZr = parcelRequire("jTCZr");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $ciRrJ = parcelRequire("ciRrJ");


function $6979733cb21d50fb$export$44874971172f2dba(warn, t) {
    if (!warn) return '';
    if (warn.kind === 'mic') return t(`secretary.recorder.warn.mic.${[
        'denied',
        'unsupported'
    ].includes(warn.detail) ? warn.detail : 'error'}`);
    if (warn.kind === 'busy') return t('secretary.recorder.warn.busy');
    return t('secretary.recorder.warn.nothing');
}
function $6979733cb21d50fb$export$2e2bcd8739ae039({ collapsed: collapsed = false, iconCell: iconCell = 46 }) {
    const c = (0, $52fffe2758f30419$export$8bcdbfb9578ee87c)();
    const { t: t } = (0, $e1LEq.default)();
    if (!c) return null;
    const box = {
        width: 'calc(100% - 20px)',
        margin: '6px 10px 8px',
        height: 44,
        boxSizing: 'border-box',
        flexShrink: 0
    };
    if (c.recording) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: box,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed980b5ca3732495$export$2e2bcd8739ae039), {
            controls: c,
            collapsed: collapsed
        })
    });
    const fade = {
        opacity: collapsed ? 0 : 1,
        transition: 'opacity 0.22s ease',
        pointerEvents: collapsed ? 'none' : 'auto',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    };
    const state = c.warn ? 'warn' : c.pending > 0 ? 'processing' : 'idle';
    const label = state === 'warn' ? $6979733cb21d50fb$export$44874971172f2dba(c.warn, t) : state === 'processing' ? t('secretary.recorder.processing') : t('secretary.navLabel');
    const icon = state === 'warn' ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        "aria-hidden": "true",
        style: {
            width: 22,
            height: 22,
            borderRadius: 999,
            display: 'grid',
            placeItems: 'center',
            background: 'rgba(255, 179, 64, 0.18)',
            color: (0, $ed980b5ca3732495$export$ae8191e16cbd4c0c),
            fontWeight: 800,
            fontSize: '0.875rem'
        },
        children: "!"
    }) : state === 'processing' ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        "aria-hidden": "true",
        className: "secretary-spin",
        style: {
            width: 16,
            height: 16,
            borderRadius: 999,
            boxSizing: 'border-box',
            border: '2px solid rgba(255, 255, 255, 0.3)',
            borderTopColor: (0, $jTCZr.C).tealLight
        }
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hSPBf.default), {
        size: 19,
        "aria-hidden": "true"
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
        type: "button",
        "data-testid": "nav-secretary",
        "data-state": state,
        onClick: c.start,
        title: collapsed ? label : t('secretary.recorder.record'),
        "aria-label": state === 'idle' ? t('secretary.recorder.record') : `${label} \xb7 ${t('secretary.recorder.record')}`,
        "aria-keyshortcuts": "F1",
        style: {
            ...box,
            display: 'flex',
            alignItems: 'center',
            padding: 0,
            borderRadius: 12,
            cursor: 'pointer',
            border: '1px solid rgba(255, 255, 255, 0.22)',
            background: 'rgba(255, 255, 255, 0.08)',
            color: 'white',
            fontFamily: 'inherit'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("style", {
                children: (0, $ed980b5ca3732495$export$5fb253c04d577752)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                style: {
                    width: iconCell,
                    flexShrink: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: state === 'warn' ? (0, $ed980b5ca3732495$export$ae8191e16cbd4c0c) : (0, $jTCZr.C).tealLight
                },
                children: icon
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                "aria-live": "polite",
                style: {
                    ...fade,
                    flex: 1,
                    textAlign: 'start',
                    fontSize: '0.875rem',
                    fontWeight: 700,
                    color: state === 'warn' ? (0, $ed980b5ca3732495$export$ae8191e16cbd4c0c) : 'white'
                },
                children: label
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                style: {
                    ...fade,
                    marginInlineEnd: 12,
                    display: 'inline-flex'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ciRrJ.Kbd), {
                    combo: "f1"
                })
            })
        ]
    });
}


/** The button's size and its margin above whatever it stands on. */ const $802ce23a32497ab9$var$SIZE = 56;
const $802ce23a32497ab9$var$GAP = 16;
function $802ce23a32497ab9$export$2e2bcd8739ae039({ hidden: hidden = false }) {
    const { t: t } = (0, $e1LEq.default)();
    const c = (0, $52fffe2758f30419$export$8bcdbfb9578ee87c)();
    // A result's own window covers the screen; the button comes back when it closes.
    const away = hidden || !c || Boolean(c.openItem);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(()=>{
        if (away || typeof document === 'undefined') return undefined;
        const root = document.documentElement;
        root.style.setProperty((0, $8RTRt.FAB_SPACE_VAR), `${$802ce23a32497ab9$var$SIZE + $802ce23a32497ab9$var$GAP}px`);
        return ()=>root.style.removeProperty((0, $8RTRt.FAB_SPACE_VAR));
    }, [
        away
    ]);
    if (away) return null;
    const place = {
        position: 'fixed',
        zIndex: 80,
        insetInlineEnd: 16,
        // The bar's measured height already includes the home-indicator inset, so
        // it is one OR the other — the inset alone on a surface with no bar.
        bottom: `calc(${$802ce23a32497ab9$var$GAP}px + max(env(safe-area-inset-bottom, 0px), var(--app-bottom-nav, 0px)) + var(${(0, $8RTRt.SCREEN_CTA_VAR)}, 0px))`
    };
    if (c.recording) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: place,
        "data-testid": "mobile-secretary-recorder",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed980b5ca3732495$export$2e2bcd8739ae039), {
            controls: c,
            compact: true,
            height: 52
        })
    });
    if (c.warn) return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
        type: "button",
        onClick: c.start,
        "data-testid": "mobile-secretary-fab",
        "data-state": "warn",
        "aria-label": `${(0, $6979733cb21d50fb$export$44874971172f2dba)(c.warn, t)} \xb7 ${t('secretary.recorder.record')}`,
        style: {
            ...place,
            height: 48,
            display: 'inline-flex',
            alignItems: 'center',
            gap: 8,
            paddingInline: '10px 16px',
            borderRadius: 999,
            border: `1px solid ${(0, $jTCZr.C).border}`,
            background: (0, $jTCZr.C).card,
            color: (0, $jTCZr.C).textPrimary,
            boxShadow: '0 8px 24px rgba(13, 27, 38, 0.18)',
            fontFamily: 'inherit',
            fontSize: '0.84375rem',
            fontWeight: 700,
            whiteSpace: 'nowrap',
            cursor: 'pointer',
            touchAction: 'manipulation'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                "aria-hidden": "true",
                style: {
                    width: 24,
                    height: 24,
                    borderRadius: 999,
                    display: 'grid',
                    placeItems: 'center',
                    background: 'rgba(255, 179, 64, 0.2)',
                    color: (0, $ed980b5ca3732495$export$ae8191e16cbd4c0c),
                    fontWeight: 800
                },
                children: "!"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                "aria-live": "polite",
                children: (0, $6979733cb21d50fb$export$44874971172f2dba)(c.warn, t)
            })
        ]
    });
    const processing = c.pending > 0;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
        type: "button",
        onClick: c.start,
        "aria-label": processing ? `${t('secretary.recorder.processing')} \xb7 ${t('secretary.recorder.record')}` : t('secretary.recorder.record'),
        title: t('secretary.navLabel'),
        "data-testid": "mobile-secretary-fab",
        "data-state": processing ? 'processing' : 'idle',
        style: {
            ...place,
            width: $802ce23a32497ab9$var$SIZE,
            height: $802ce23a32497ab9$var$SIZE,
            borderRadius: 999,
            border: 0,
            display: 'grid',
            placeItems: 'center',
            background: (0, $jTCZr.GRADIENT_BRAND),
            color: '#fff',
            boxShadow: '0 8px 24px rgba(27, 78, 107, 0.35), 0 2px 6px rgba(0, 0, 0, 0.12)',
            cursor: 'pointer',
            touchAction: 'manipulation'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("style", {
                children: (0, $ed980b5ca3732495$export$5fb253c04d577752)
            }),
            processing ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                "aria-hidden": "true",
                className: "secretary-spin",
                style: {
                    width: 22,
                    height: 22,
                    borderRadius: 999,
                    boxSizing: 'border-box',
                    border: '2.5px solid rgba(255, 255, 255, 0.35)',
                    borderTopColor: '#fff'
                }
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hSPBf.default), {
                size: 24,
                "aria-hidden": "true"
            })
        ]
    });
}




var $lUZHL = parcelRequire("lUZHL");

var $kt5mZ = parcelRequire("kt5mZ");

var $4NjkN = parcelRequire("4NjkN");
// Glyphs for the footer menu. App-local, like NAV_ITEMS below: the footer owns
// the menu's shape, not its destinations, so it owns none of their icons either.
const $1dea2a187eaa8cfa$var$ICON = {
    account: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "17",
        height: "17",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z"
        })
    }),
    coin: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        width: "17",
        height: "17",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "8.5",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M12 7.5v9M9.5 10h5M9.5 14h5",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round"
            })
        ]
    }),
    access: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        width: "17",
        height: "17",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M9 12l2 2 4-4"
            })
        ]
    }),
    // Not mirrored: the arrow points out of a door, not along the reading direction.
    logout: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "17",
        height: "17",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"
        })
    })
};
const $1dea2a187eaa8cfa$var$MINI = 68;
const $1dea2a187eaa8cfa$var$FULL = 260;
const $1dea2a187eaa8cfa$var$ClinicLayout = ({ children: children })=>{
    const { t: t, locale: locale, formatNumber: formatNumber } = (0, $e1LEq.default)();
    // The SIGNED-IN PERSON's own پارسه — every member of staff has one, and pays
    // from it for what they do (there is no clinic pool). `balance` is what a new
    // charge can take. Null only when the wallet could not be read, and then the
    // card does not render, because there is nothing true to put in it.
    const { balance: myBalance, level: personalLevel } = (0, $5bPPa.useCredits)();
    const personalCredit = myBalance === null ? null : {
        balance: myBalance
    };
    // Held at the shell so the banner is consistent on every page and the
    // capabilities query runs once per session rather than once per screen.
    const { capabilities: capabilities } = (0, $exu0F.useClinicCapabilities)();
    const [preferCollapsed, setPreferCollapsed] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // The visit room's own rail state, `{ path, collapsed }` — see `collapsed`.
    const [visitRail, setVisitRail] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const navigate = (0, $7buzq.useAppNavigate)();
    const location = (0, $aphAM.useLocation)();
    const { isMobile: isMobile } = (0, $9h2jQ.default)();
    // Owned by the shell rather than by the bar, because both the bar's «بیشتر»
    // fold and (on the desktop) the sidebar's switcher open the same surfaces.
    const [moreOpen, setMoreOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [accessOpen, setAccessOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // Sidebar footer identity from the Keycloak token (the signed-in user),
    // not a hardcoded "کارمند کلینیک" role label.
    const kc = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $58BYB.parseJwt)((0, $58BYB.getToken)()) || {}, []);
    const kcName = kc.name || [
        kc.given_name,
        kc.family_name
    ].filter(Boolean).join(' ') || kc.preferred_username || t('common.roles.user');
    // Staff who signed up by phone and never filled in a name have no `name` and
    // no `email`, so BOTH lines fell through to `preferred_username` and the row
    // printed the same phone number twice — which reads as a rendering fault, not
    // as an account. The second line only earns its place when it says something
    // the first does not — and when it has nothing to say it is EMPTY, not the
    // product's name («پنل مدیریت»), which described the screen the person was
    // already looking at. The footer centres a one-line identity on its own.
    const kcSubtitleRaw = kc.email || kc.preferred_username || '';
    const kcSubtitleText = kcSubtitleRaw && kcSubtitleRaw !== kcName ? kcSubtitleRaw : '';
    // A phone sign-in's username IS the number: an LTR island in the reader's digits
    // (DESIGN_SYSTEM §6.4), the kit's PhoneNumber — never «+989120000103» in Latin
    // digits beside a Persian name (PM-0536).
    const kcSubtitle = kcSubtitleText && !kc.email && (0, $5AX1S).isValidPhone(kcSubtitleText) ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8ym5i.default), {
        value: kcSubtitleText,
        locale: locale,
        "data-testid": "account-card-phone"
    }) : kcSubtitleText;
    // The person's own picture, which the panel had never asked for: the kit's
    // Avatar has always accepted `src`, the account app writes Keycloak's
    // `picture` attribute, and `myProfile.avatar` reads it back — but the footer
    // was handed a name and nothing else, so it drew initials for everyone. Two
    // initial discs on one rail is most of why the person's mark and the clinic's
    // read as the same kind of object.
    //
    // NAME and SUBTITLE deliberately stay on the token: they are there before the
    // first paint, and swapping them for a fetched value would make the identity
    // row flicker on every load. Only the picture waits, and an Avatar with no
    // `src` yet is already showing the correct fallback.
    //
    // Settings runs its own `useMyProfile`, so changing the picture there does not
    // repaint this one until the next load. Worth a shared profile context the day
    // a third caller appears; not worth one for two.
    const { profile: profile } = (0, $goZUH.useMyProfile)();
    const kcAvatar = profile?.avatar || undefined;
    const access = (0, $1iGMR.useAccess)();
    const { pendingInvitations: pendingInvitations, activeMembership: activeMembership, accessChanged: accessChanged, dismissAccessChange: dismissAccessChange, reload: reload, memberships: // The phone has no sidebar to hang the switcher off, so the shell reads the
    // membership list itself and hands it to the more-sheet (§3.5). The FULL
    // list, not just the enterable one: a blocked clinic is shown, dimmed, with
    // its reason — hiding it answers "where is my other clinic?" with silence.
    memberships, activeRef: activeRef, canSwitch: canSwitch, switchClinic: switchClinic } = (0, $ett75.useClinicContext)();
    // Matched against the path WITHOUT its `/c/:ref` prefix. Every one of these
    // comparisons was written against a bare path, and the tenant segment would have
    // made all of them false at once — silently un-highlighting every nav row and
    // making the subscription banner appear on «کلینیک من», which it is suppressed on.
    const barePath = (0, $7buzq.stripClinic)(location.pathname);
    // The visit room OPENS with the rail collapsed — it needs every column it can
    // get. A starting state, not the person's choice: they may expand it for the
    // visit, leaving puts back whatever they had, and the next visit opens
    // collapsed again. Derived rather than set by an effect, so a visit never
    // paints expanded and then snaps shut; keyed by path, so the next patient
    // starts collapsed. (The doctor panel's WebLayout does the same.)
    const onVisit = barePath.startsWith('/visit/');
    const collapsed = onVisit ? visitRail?.path === location.pathname ? visitRail.collapsed : true : preferCollapsed;
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!onVisit) setVisitRail(null);
    }, [
        onVisit
    ]);
    const toggleCollapsed = ()=>{
        if (onVisit) setVisitRail({
            path: location.pathname,
            collapsed: !collapsed
        });
        else setPreferCollapsed((c)=>!c);
    };
    const onClinicPage = barePath.startsWith('/clinic');
    const currentScreen = (0, $kaeHn.NAV_ITEMS)(t).find((item)=>barePath === '/' + item.id || barePath.startsWith('/' + item.id + '/'))?.id || 'reception';
    // FILTERED, never disabled. An entry that leads to a denial is worse than no
    // entry: a warehouse keeper who can see «صندوق» greyed out learns only that the
    // product is withholding something from them (design §5.8).
    //
    // Derived from the SAME `myAccess` payload the BFF enforces on, so the sidebar
    // and the boundary cannot disagree — the client is not making an independent
    // judgement about permissions, it is rendering the one the server made.
    const allowed = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>new Set((0, $7D4kr.visibleNavIds)(access)), [
        access
    ]);
    const navItems = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $kaeHn.NAV_ITEMS)(t).filter((item)=>{
            const person = (0, $7D4kr.PERSON_NAV).find((n)=>n.id === item.id);
            if (person) return person.when({
                pendingInvitations: pendingInvitations
            });
            return allowed.has(item.id);
        }), [
        t,
        allowed,
        pendingInvitations
    ]);
    // The browser tab is the only thing distinguishing two tabs on two clinics in
    // the tab strip, and this design makes that a routine arrangement (§A15).
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const screen = (0, $kaeHn.NAV_ITEMS)(t).find((i)=>i.id === currentScreen)?.label;
        const parts = [
            screen,
            activeMembership?.clinicName,
            t('common.brand.name')
        ].filter(Boolean);
        document.title = parts.join(" \xb7 ");
    }, [
        t,
        currentScreen,
        activeMembership
    ]);
    const fade = {
        opacity: collapsed ? 0 : 1,
        transition: 'opacity 0.22s ease',
        pointerEvents: collapsed ? 'none' : 'auto',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    };
    /* Alert zone ② and the routed screen — identical on both surfaces, because
     they are content, not chrome. Only the navigation is forked. */ const alertZone = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            onClinicPage ? null : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f619645f3c72a98a$export$2e2bcd8739ae039), {
                capabilities: capabilities,
                onRenew: ()=>navigate('subscription'),
                /* Dismissible on a phone only. On a wide monitor the banner costs a
             strip; on a phone it costs a slice of the one screen there is,
             above the list being worked. The dismissal is remembered against
             the STATUS, so the trial nudge goes for good while a later lapse
             still speaks — see the note in SubscriptionBanner. */ dismissible: isMobile,
                clinicRef: activeRef
            }),
            accessChanged ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    padding: '10px 16px 0'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                    variant: "info",
                    action: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        type: "button",
                        onClick: async ()=>{
                            dismissAccessChange();
                            await reload({
                                silent: true
                            });
                        },
                        style: {
                            background: 'transparent',
                            border: 'none',
                            color: (0, $jTCZr.C).navy,
                            fontWeight: 800,
                            fontSize: '0.78125rem',
                            cursor: 'pointer',
                            fontFamily: 'Meshkat, sans-serif',
                            padding: 4
                        },
                        children: t('clinic.context.accessChangedAction')
                    }),
                    children: t('clinic.context.accessChanged')
                })
            }) : null
        ]
    });
    /* ── The phone (docs/MOBILE-REDESIGN.md §3) ──────────────────────────────
     Bottom navigation instead of a sidebar, and no top bar at all: each screen
     brings its own gradient header. The 260px rail is not narrowed here, it is
     not rendered — a fixed rail beside the content is what pushed every screen
     into horizontal scroll on a phone.

     The screen owns the viewport: this wrapper does not scroll, and each
     `X.mobile.jsx` renders inside `MobileScreen`, which holds the page's one
     scroll region. */ // Both shells sit in ONE SecretaryProvider at the same place in the tree, so a
    // recording, or a result still waiting, survives the window crossing the width.
    if (isMobile) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $52fffe2758f30419$export$199d2b1ebbee7964), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                overflow: 'hidden',
                background: (0, $jTCZr.C).bg
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        flex: 1,
                        minHeight: 0,
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'hidden'
                    },
                    children: [
                        alertZone,
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                flex: 1,
                                minHeight: 0,
                                overflow: 'hidden'
                            },
                            children: children
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lUZHL.default), {
                    access: access,
                    barePath: barePath,
                    pendingCount: pendingInvitations.length,
                    onNavigate: (id)=>navigate(id),
                    onOpenMore: ()=>setMoreOpen(true)
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kt5mZ.default), {
                    open: moreOpen,
                    onClose: ()=>setMoreOpen(false),
                    overflow: (0, $4NjkN.bottomNavPlan)(access).overflow,
                    /* `opts` travels: the sheet asks for `replace` because it is handing
             the destination its own history entry. Dropping the argument here
             is what made every row in the fold a no-op — the push landed and
             the sheet's deferred release popped it straight back off. */ onNavigate: (id, opts)=>navigate(id, null, opts),
                    user: {
                        name: kcName,
                        subtitle: kcSubtitle,
                        avatarUrl: kcAvatar
                    },
                    personalCredit: personalCredit,
                    personalLevel: personalLevel,
                    accountHref: (0, $iAkVL.accountUrl)('/'),
                    creditsHref: (0, $iAkVL.accountUrl)('/credits'),
                    memberships: memberships,
                    activeRef: activeRef,
                    canSwitch: canSwitch,
                    onSwitchClinic: (m)=>switchClinic(m.slug || m.clinicId),
                    pendingInvitations: pendingInvitations,
                    onOpenAccess: ()=>setAccessOpen(true),
                    onSignOut: ()=>(0, $58BYB.logout)()
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8b0fd7293ac0e6c9$export$2e2bcd8739ae039), {
                    open: accessOpen,
                    onClose: ()=>setAccessOpen(false)
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $78574ca1dedb7eda$export$2e2bcd8739ae039), {
                    onRenew: ()=>navigate('subscription')
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2a14167329d4e363$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2b9c6217915cd2a6$export$2e2bcd8739ae039), {
                    isMobile: true
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $52fffe2758f30419$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $802ce23a32497ab9$export$2e2bcd8739ae039), {
                    hidden: moreOpen || accessOpen
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $52fffe2758f30419$export$199d2b1ebbee7964), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            style: {
                display: 'flex',
                width: '100vw',
                height: '100vh',
                overflow: 'hidden'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    "data-testid": "app-sidebar",
                    "data-collapsed": collapsed ? 'true' : 'false',
                    style: {
                        width: collapsed ? $1dea2a187eaa8cfa$var$MINI : $1dea2a187eaa8cfa$var$FULL,
                        flexShrink: 0,
                        background: (0, $jTCZr.GRADIENT_SIDEBAR),
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'hidden',
                        transition: 'width 0.3s cubic-bezier(.4,0,.2,1)',
                        zIndex: 10
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                height: 68,
                                display: 'flex',
                                alignItems: 'center',
                                flexShrink: 0,
                                borderBottom: '1px solid rgba(255,255,255,0.07)'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f8290c7dddeafa49$export$2e2bcd8739ae039), {
                                collapsed: collapsed
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("nav", {
                            style: {
                                flex: 1,
                                paddingTop: 10,
                                overflowY: 'auto',
                                overflowX: 'hidden'
                            },
                            children: navItems.map((item)=>{
                                const active = currentScreen === item.id;
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    onClick: ()=>navigate(item.id),
                                    title: collapsed ? item.label : undefined,
                                    style: {
                                        // Rounded pill inset 10px from the sidebar edges. The icon cell is
                                        // 48px, so the icon's optical center stays at 34px from the right
                                        // edge — identical in collapsed (68px) and expanded (260px) states.
                                        width: 'calc(100% - 20px)',
                                        margin: '2px 10px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        padding: 0,
                                        border: 'none',
                                        borderRadius: 10,
                                        background: active ? (0, $jTCZr.C).navy : 'transparent',
                                        boxShadow: active ? '0 2px 8px rgba(0,0,0,0.22)' : 'none',
                                        cursor: 'pointer',
                                        position: 'relative',
                                        transition: 'background 0.18s, box-shadow 0.18s',
                                        fontFamily: 'Meshkat, sans-serif'
                                    },
                                    onMouseEnter: (e)=>{
                                        if (!active) e.currentTarget.style.background = 'rgba(255,255,255,0.07)';
                                    },
                                    onMouseLeave: (e)=>{
                                        if (!active) e.currentTarget.style.background = 'transparent';
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                width: $1dea2a187eaa8cfa$var$MINI - 20,
                                                flexShrink: 0,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                padding: '11px 0',
                                                color: active ? 'white' : 'rgba(255,255,255,0.55)'
                                            },
                                            children: item.icon
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                ...fade,
                                                flex: 1,
                                                // A <button> centres its content by default, so without this the
                                                // label floats in the middle of the row. `start` follows the
                                                // document direction: right edge in Persian/Arabic, left in English.
                                                textAlign: 'start',
                                                color: active ? 'white' : 'rgba(255,255,255,0.55)',
                                                fontSize: '0.875rem',
                                                fontWeight: active ? 700 : 500
                                            },
                                            children: item.label
                                        }),
                                        item.id === 'invitations' && pendingInvitations.length ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            "aria-hidden": false,
                                            "aria-label": t('nav.items.invitationsCount', {
                                                count: pendingInvitations.length
                                            }),
                                            style: {
                                                position: collapsed ? 'absolute' : 'static',
                                                insetInlineEnd: collapsed ? 14 : undefined,
                                                insetBlockStart: collapsed ? 8 : undefined,
                                                minWidth: 18,
                                                height: 18,
                                                borderRadius: 999,
                                                background: (0, $jTCZr.C).teal,
                                                color: 'white',
                                                fontSize: '0.65625rem',
                                                fontWeight: 800,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                padding: '0 5px',
                                                marginInlineEnd: collapsed ? 0 : 12,
                                                flexShrink: 0
                                            },
                                            children: formatNumber(pendingInvitations.length)
                                        }) : null
                                    ]
                                }, item.id);
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6979733cb21d50fb$export$2e2bcd8739ae039), {
                            collapsed: collapsed,
                            iconCell: $1dea2a187eaa8cfa$var$MINI - 22
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $879c64ea7a77d8fb$export$2e2bcd8739ae039), {
                            "data-testid": "account-card",
                            collapsed: collapsed,
                            onToggleCollapse: toggleCollapsed,
                            menuLabel: t('nav.account.menuLabel'),
                            user: {
                                name: kcName,
                                subtitle: kcSubtitle,
                                avatarUrl: kcAvatar
                            },
                            credit: !personalCredit ? null : {
                                // Already localised by the app — the footer renders digits verbatim.
                                amount: formatNumber(personalCredit.balance),
                                level: personalLevel,
                                unit: t('nav.credits.unit'),
                                // A real <a>, as this row has always been: middle-click and
                                // «open in new tab» must keep working on a link out of the panel.
                                href: (0, $iAkVL.accountUrl)('/credits')
                            },
                            items: [
                                {
                                    key: 'account',
                                    label: t('nav.actions.account'),
                                    description: t('nav.account.parsinaHint'),
                                    icon: $1dea2a187eaa8cfa$var$ICON.account,
                                    href: (0, $iAkVL.accountUrl)('/'),
                                    external: true,
                                    'data-testid': 'sidebar-account'
                                },
                                personalCredit && {
                                    key: 'credits',
                                    label: t('nav.credits.topUp'),
                                    icon: $1dea2a187eaa8cfa$var$ICON.coin,
                                    href: (0, $iAkVL.accountUrl)('/credits'),
                                    external: true
                                },
                                {
                                    key: 'access',
                                    label: t('clinic.myAccess.title'),
                                    icon: $1dea2a187eaa8cfa$var$ICON.access,
                                    onClick: ()=>setAccessOpen(true),
                                    'data-testid': 'sidebar-access'
                                },
                                {
                                    key: 'logout',
                                    label: t('nav.actions.signOut'),
                                    icon: $1dea2a187eaa8cfa$var$ICON.logout,
                                    tone: 'destructive',
                                    separatorBefore: true,
                                    onClick: ()=>(0, $58BYB.logout)(),
                                    'data-testid': 'sidebar-signout'
                                }
                            ].filter(Boolean)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        flex: 1,
                        minHeight: 0,
                        overflowY: 'auto',
                        overflowX: 'hidden',
                        background: (0, $jTCZr.C).bg,
                        display: 'flex',
                        flexDirection: 'column'
                    },
                    children: [
                        alertZone,
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                flex: 1,
                                minHeight: 0
                            },
                            children: children
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $78574ca1dedb7eda$export$2e2bcd8739ae039), {
                    onRenew: ()=>navigate('subscription')
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2a14167329d4e363$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8b0fd7293ac0e6c9$export$2e2bcd8739ae039), {
                    open: accessOpen,
                    onClose: ()=>setAccessOpen(false)
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $52fffe2758f30419$export$2e2bcd8739ae039), {
                    sidebarWidth: collapsed ? $1dea2a187eaa8cfa$var$MINI : $1dea2a187eaa8cfa$var$FULL
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2b9c6217915cd2a6$export$2e2bcd8739ae039), {})
            ]
        })
    });
};
var $1dea2a187eaa8cfa$export$2e2bcd8739ae039 = $1dea2a187eaa8cfa$var$ClinicLayout;



var $ett75 = parcelRequire("ett75");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $aphAM = parcelRequire("aphAM");parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");
parcelRequire("5N0ZI");
var $2tqZa = parcelRequire("2tqZa");

var $bOJgt = parcelRequire("bOJgt");
var $7h1oo = parcelRequire("7h1oo");
var $9q6Mp = parcelRequire("9q6Mp");
var $1oGgm = parcelRequire("1oGgm");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $ett75 = parcelRequire("ett75");

var $1iGMR = parcelRequire("1iGMR");

var $7D4kr = parcelRequire("7D4kr");

var $7buzq = parcelRequire("7buzq");


var $ayMG0 = parcelRequire("ayMG0");

var $kB1PK = parcelRequire("kB1PK");

var $fpkFc = parcelRequire("fpkFc");

var $6A5OY = parcelRequire("6A5OY");

var $bOuMz = parcelRequire("bOuMz");

var $c8S29 = parcelRequire("c8S29");

var $3jrpA = parcelRequire("3jrpA");

var $9CB84 = parcelRequire("9CB84");

var $8fFE7 = parcelRequire("8fFE7");

var $lnXsr = parcelRequire("lnXsr");

var $3lftY = parcelRequire("3lftY");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("5N0ZI");
var $g6X9N = parcelRequire("g6X9N");
var $66joL = parcelRequire("66joL");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $9h2jQ = parcelRequire("9h2jQ");

var $c8Px0 = parcelRequire("c8Px0");

var $ivK8f = parcelRequire("ivK8f");
/**
 * «تنظیمات» while its chunk loads — the section rail (real, its labels are
 * static) and the ACTIVE section's own shape: the profile's avatar card, the
 * language card, the WhatsApp link. A generic form would be a blank with a
 * title; each section here reserves the geometry it will fill.
 *
 * The router's Suspense fallback for `/settings` (it reads `?section=` through
 * the shared resolver, so the fallback draws the section the URL names).
 *
 * The workstation is all of it. The phone surface was removed — «تنظیمات» is
 * desktop-only there and says so in one note — so the mobile geometry that used
 * to live here went with it, and the mobile branch below is that same note.
 *
 * `Settings.shared.js` is the one non-kit import: it holds no React and no data,
 * only the registry the surface already reads.
 */ // ── Desktop pieces (the geometry of Settings.web's own cards) ──────────────────
const $8afc7fe814c13ecc$var$CARD = {
    padding: 24,
    marginBottom: 20
};
/** `SectionTitle`: the real h2 + a hint line — static copy, rendered for real. */ function $8afc7fe814c13ecc$var$TitleWeb({ title: title, sub: sub }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            marginBottom: 24
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                style: {
                    margin: 0,
                    fontSize: '1.125rem',
                    fontWeight: 800,
                    color: (0, $jTCZr.C).textPrimary
                },
                children: title
            }),
            sub ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                style: {
                    margin: '4px 0 0',
                    fontSize: '0.8125rem',
                    color: (0, $jTCZr.C).textMuted
                },
                children: sub
            }) : null
        ]
    });
}
/** A card's bold 14px title line. */ function $8afc7fe814c13ecc$var$CardTitle({ width: width = 140, marginBottom: marginBottom = 16 }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
        width: width,
        height: 16,
        style: {
            marginBottom: marginBottom
        }
    });
}
function $8afc7fe814c13ecc$var$ProfileWeb() {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $g6X9N.default), {
            "aria-hidden": true,
            style: {
                padding: 24,
                marginBottom: 24,
                display: 'flex',
                alignItems: 'center',
                gap: 20
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonAvatar), {
                    size: 72
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                            width: 160,
                            height: 17,
                            style: {
                                marginBottom: 12
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                display: 'flex',
                                gap: 8
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                    width: 104,
                                    height: 34,
                                    radius: 8
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                    width: 72,
                                    height: 34,
                                    radius: 8
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
function $8afc7fe814c13ecc$var$AppearanceWeb() {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $g6X9N.default), {
        "aria-hidden": true,
        style: {
            padding: 24,
            marginBottom: 16
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($8afc7fe814c13ecc$var$CardTitle, {
                marginBottom: 4
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                width: "55%",
                height: 13,
                style: {
                    marginBottom: 14
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                width: 200,
                height: 42,
                radius: (0, $jTCZr.RADIUS).control
            })
        ]
    });
}
function $8afc7fe814c13ecc$var$WhatsappWeb() {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $g6X9N.default), {
        "aria-hidden": true,
        style: $8afc7fe814c13ecc$var$CARD,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 14,
                    marginBottom: 16
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: 44,
                        height: 44,
                        radius: 12
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 6
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                width: "40%",
                                height: 15
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                width: "65%",
                                height: 12
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: 72,
                        height: 24,
                        radius: (0, $jTCZr.RADIUS).pill
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonButton), {
                width: 160
            })
        ]
    });
}
const $8afc7fe814c13ecc$var$WEB_SECTIONS = {
    profile: $8afc7fe814c13ecc$var$ProfileWeb,
    appearance: $8afc7fe814c13ecc$var$AppearanceWeb,
    whatsapp: $8afc7fe814c13ecc$var$WhatsappWeb
};
/** The hint key each section prints under its title (static copy). */ const $8afc7fe814c13ecc$var$HINT_KEYS = {
    profile: 'settings.profile.hint',
    appearance: 'settings.appearance.hint'
};
function $8afc7fe814c13ecc$export$82d866fc3ab91067({ section: section }) {
    const { t: t } = (0, $e1LEq.default)();
    const id = (0, $c8Px0.resolveSettingsSection)(section);
    const Body = $8afc7fe814c13ecc$var$WEB_SECTIONS[id] || $8afc7fe814c13ecc$var$ProfileWeb;
    const hintKey = $8afc7fe814c13ecc$var$HINT_KEYS[id];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $66joL.SkeletonRegion), {
        label: t('common.state.loading'),
        "data-testid": "settings-skeleton-body",
        "data-section": id,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($8afc7fe814c13ecc$var$TitleWeb, {
                title: (0, $c8Px0.settingsSectionLabel)(id, t),
                sub: hintKey ? t(hintKey) : null
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)(Body, {})
        ]
    });
}
function $8afc7fe814c13ecc$export$a50ea1f399b31415({ section: section }) {
    const { t: t } = (0, $e1LEq.default)();
    const active = (0, $c8Px0.resolveSettingsSection)(section);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-state": "loading",
        "data-testid": "settings-skeleton",
        style: {
            height: '100%',
            display: 'flex',
            overflow: 'hidden',
            background: '#f8fafc'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    width: 220,
                    flexShrink: 0,
                    background: 'white',
                    borderInlineStart: `1px solid ${(0, $jTCZr.C).border}`,
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '24px 12px',
                    overflowY: 'auto'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: '0.6875rem',
                            fontWeight: 700,
                            color: (0, $jTCZr.C).textMuted,
                            marginBottom: 10,
                            padding: '0 8px',
                            letterSpacing: 0.8
                        },
                        children: t('settings.title')
                    }),
                    (0, $c8Px0.SETTINGS_SECTIONS)(t).map((s)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            "aria-current": active === s.id ? 'page' : undefined,
                            style: {
                                width: '100%',
                                padding: '11px 14px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: 10,
                                background: active === s.id ? (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.1) : 'transparent',
                                borderRadius: 10,
                                color: active === s.id ? (0, $jTCZr.C).navy : (0, $jTCZr.C).textSecondary,
                                fontSize: '0.8125rem',
                                fontWeight: active === s.id ? 700 : 500,
                                textAlign: 'end'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        fontSize: '1rem'
                                    },
                                    children: s.icon
                                }),
                                s.label
                            ]
                        }, s.id))
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    flex: 1,
                    overflowY: 'auto',
                    padding: '36px 40px'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($8afc7fe814c13ecc$export$82d866fc3ab91067, {
                    section: active
                })
            })
        ]
    });
}
function $8afc7fe814c13ecc$export$2e2bcd8739ae039(props) {
    const { isMobile: isMobile } = (0, $9h2jQ.default)();
    // The phone has nothing to wait for: «تنظیمات» is desktop-only there and its
    // surface is one note. Rendering that as the fallback too means the lazy
    // chunk lands on an identical screen — and, more to the point, the desktop
    // rail never flashes at 360px on the way past.
    return isMobile ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ivK8f.default), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)($8afc7fe814c13ecc$export$a50ea1f399b31415, {
        ...props
    });
}



var $h7MBc = parcelRequire("h7MBc");

var $7cb0D = parcelRequire("7cb0D");

var $7buzq = parcelRequire("7buzq");

var $6PcIc = parcelRequire("6PcIc");
/**
 * The route → skeleton registry.
 *
 * A lazy route's `Suspense` fallback must be the DESTINATION page's own shape
 * (DESIGN.md §"Loading & skeleton" — navigation), so the transition draws the
 * next page rather than a spinner where a page should be. The same answer
 * serves `ClinicGate` while access is still resolving: the shell is painted,
 * the person has clicked a nav item, and the page they are going to is known
 * from the URL alone.
 *
 * Every skeleton here is imported EAGERLY on purpose — it is what shows while
 * the screen's chunk is in flight, so it cannot live in that chunk. The files
 * are light by contract (kit primitives, tokens, density, i18n only).
 *
 * The legacy paths are mapped to the page they redirect INTO, so a bookmark to
 * `/inventory` draws the items view it is about to land on rather than a
 * placeholder for a page that no longer exists.
 */ const $70c21bb38a31c977$var$VIEW_ALIASES = {
    '/inventory': [
        '/goods',
        'items'
    ],
    '/expenses': [
        '/operations',
        'expenses'
    ],
    '/services': [
        '/goods',
        'services'
    ],
    '/about': [
        '/clinic',
        'connect'
    ],
    '/subscription': [
        '/clinic',
        'billing'
    ],
    '/calendar': [
        '/reception',
        null
    ],
    '/doctors': [
        '/people',
        null
    ],
    '/dashboard': [
        '/reception',
        null
    ]
};
function $70c21bb38a31c977$export$d7c24f432acc81bf(pathname = '', search = '') {
    let path = (0, $7buzq.stripClinic)(pathname);
    let view = new URLSearchParams(search).get('view') || null;
    if ($70c21bb38a31c977$var$VIEW_ALIASES[path]) {
        const [target, aliasView] = $70c21bb38a31c977$var$VIEW_ALIASES[path];
        path = target;
        view = aliasView || view;
    }
    // `/clinic/:view` is an alias for `/clinic?view=:view`.
    const clinicView = /^\/clinic\/([^/]+)$/.exec(path);
    if (clinicView) {
        path = '/clinic';
        view = clinicView[1];
    }
    // A view that moved to «کالاها و خدمات» in the 2026-09-12 split, asked for at
    // the old address: `App.jsx` is about to forward it, so draw the page it will
    // ARRIVE at. Drawing the expense workbench first would show the operator a
    // ledger skeleton, then a warehouse — a flash of the wrong page, which is
    // exactly what this registry exists to prevent.
    if (path === '/operations' && (0, $6PcIc.isGoodsView)(view)) path = '/goods';
    // A `?view=` the hub does not know is not drawn as a view at all — the hub
    // normalises it, and guessing a shape here would flash the wrong page.
    if (path === '/accounting' && !(0, $6PcIc.isAccountingView)(view)) view = null;
    // The same rule for the store, which normalises an unknown `?view=` itself.
    if (path === '/store' && !(0, $6PcIc.isStoreView)(view)) view = null;
    return {
        path: path,
        view: view
    };
}
function $70c21bb38a31c977$export$95f7d3859a3c0041(pathname, search) {
    const { path: path, view: view } = $70c21bb38a31c977$export$d7c24f432acc81bf(pathname, search);
    const viewProps = view ? {
        view: view
    } : {};
    if (path === '/' || path === '' || path === '/reception') return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kB1PK.default), {
        ...viewProps
    });
    if (path === '/patients/new') return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6A5OY.default), {});
    // The shared clinical screens (docs/CLINICAL_KIT_DESIGN.md) — before `/patients`,
    // which a record path would otherwise match only by accident of being unequal.
    {
        const record = /^\/patients\/[^/]+\/record(?:\/([^/]+))?$/.exec(path);
        if (record) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7cb0D.default), {
            kind: "record",
            tab: record[1]
        });
        if (/^\/visit\/[^/]+$/.test(path)) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7cb0D.default), {
            kind: "visit"
        });
    }
    if (path === '/patients') return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fpkFc.default), {
        ...viewProps
    });
    if (path === '/operations') return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bOuMz.default), {
        ...viewProps
    });
    if (path === '/goods') return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c8S29.default), {
        ...viewProps
    });
    if (path === '/store') return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3jrpA.default), {
        ...viewProps
    });
    if (path === '/reports') return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9CB84.default), {});
    if (path === '/accounting') return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8fFE7.default), {
        ...viewProps
    });
    if (/^\/people\/roles\/[^/]+$/.test(path)) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3lftY.default), {});
    if (path === '/people') return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lnXsr.default), {});
    if (path === '/settings') return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8afc7fe814c13ecc$export$2e2bcd8739ae039), {});
    if (path === '/clinic') return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $h7MBc.default), {
        ...viewProps
    });
    return null;
}
var $70c21bb38a31c977$export$2e2bcd8739ae039 = $70c21bb38a31c977$export$95f7d3859a3c0041;


function $163b9777c503a48b$export$2e2bcd8739ae039({ children: children }) {
    const { t: t } = (0, $e1LEq.default)();
    const location = (0, $aphAM.useLocation)();
    const navigate = (0, $aphAM.useNavigate)();
    const access = (0, $1iGMR.useAccess)();
    const { activeMembership: activeMembership, activeRef: activeRef, enterable: enterable, memberships: memberships, repairSetup: repairSetup, defaultRef: defaultRef } = (0, $ett75.useClinicContext)();
    const [repairing, setRepairing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [repairError, setRepairError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [accessOpen, setAccessOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const goElsewhere = enterable.find((m)=>(0, $ett75.refOf)(m) !== activeRef);
    const elsewhereAction = goElsewhere ? {
        label: t('clinic.gate.goToOther', {
            name: goElsewhere.clinicName
        }),
        onClick: ()=>navigate(`/c/${(0, $ett75.refOf)(goElsewhere)}/`)
    } : {
        label: t('clinic.gate.goToStart'),
        onClick: ()=>navigate('/start')
    };
    // ── 1. Not a member ───────────────────────────────────────────────────────
    if (!activeMembership) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2tqZa.default), {
        tone: "warning",
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bOJgt.default), {
            size: 26,
            "aria-hidden": "true"
        }),
        title: t('clinic.gate.notMemberTitle'),
        body: t('clinic.gate.notMemberBody'),
        actions: [
            {
                key: 'elsewhere',
                ...elsewhereAction
            }
        ],
        detail: activeRef,
        testId: "gate-not-member"
    });
    // ── 2. Cannot be entered — say WHICH reason ───────────────────────────────
    if (!activeMembership.enterable) {
        const reason = activeMembership.blockedReason;
        const isPending = reason === 'INVITED' || reason === 'REQUESTED';
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2tqZa.default), {
            tone: reason === 'SUSPENDED' ? 'warning' : 'info',
            icon: isPending ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9q6Mp.default), {
                size: 26,
                "aria-hidden": "true"
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bOJgt.default), {
                size: 26,
                "aria-hidden": "true"
            }),
            title: t(`clinic.gate.blocked.${reason}.title`, {
                name: activeMembership.clinicName
            }),
            body: t(`clinic.gate.blocked.${reason}.body`, {
                name: activeMembership.clinicName
            }),
            testId: `gate-blocked-${reason}`,
            actions: isPending ? [
                {
                    key: 'invitations',
                    label: t('clinic.context.invitations'),
                    onClick: ()=>navigate('/invitations')
                },
                {
                    key: 'elsewhere',
                    variant: 'outline',
                    ...elsewhereAction
                }
            ] : [
                {
                    key: 'elsewhere',
                    ...elsewhereAction
                }
            ]
        });
    }
    // ── 3. Setup never finished ───────────────────────────────────────────────
    // The founder owns this clinic; they are not blocked, they are one idempotent
    // mutation away from working. Offering "create a clinic" here — which is what a
    // generic empty state would do — is the move that collides on clinics_pkey and
    // makes the situation permanent.
    if (activeMembership.repairNeeded) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2tqZa.default), {
        tone: "warning",
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1oGgm.default), {
            size: 26,
            "aria-hidden": "true"
        }),
        title: t('clinic.gate.repairTitle', {
            name: activeMembership.clinicName
        }),
        body: t('clinic.gate.repairBody'),
        detail: repairError,
        testId: "gate-repair",
        actions: [
            {
                key: 'repair',
                label: repairing ? t('clinic.gate.repairing') : t('clinic.gate.repairAction'),
                onClick: async ()=>{
                    setRepairing(true);
                    setRepairError('');
                    try {
                        await repairSetup(activeMembership.clinicId);
                    } catch (err) {
                        setRepairError(err.message || '');
                    } finally{
                        setRepairing(false);
                    }
                }
            }
        ]
    });
    // Access is resolved server-side; until it arrives, render no VERDICT. Showing
    // an empty sidebar for one frame is indistinguishable from «you have no
    // permissions», which is a claim we are not yet entitled to make. What IS
    // known is the page the URL names, so this draws that page's own skeleton —
    // the shell around it is already painted, and a spinner here was the one
    // moment in every navigation where the panel forgot which page it was on
    // (DESIGN.md §"Loading & skeleton").
    if (!access.ready) return (0, $70c21bb38a31c977$export$95f7d3859a3c0041)(location.pathname, location.search) || /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        role: "status",
        "aria-busy": "true",
        "aria-label": t('common.state.loading'),
        "data-state": "loading",
        style: {
            minHeight: 240
        }
    });
    const path = (0, $7buzq.stripClinic)(location.pathname);
    // ── 4a. A bare clinic root resolves to the first screen they can open ─────
    if (path === '/' || path === '') {
        const landing = (0, $7D4kr.landingPath)(access);
        if (landing) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
            to: `/c/${activeRef}${landing}`,
            replace: true
        });
    }
    // ── 4b. Enterable, but holding nothing at all ─────────────────────────────
    // A real state, and common: a person added before their roles were assigned. An
    // empty rail and a blank page is not an acceptable rendering of it — their own
    // admin can already see it as ISSUE.NO_ROLES on «همکاران».
    if (access.noPermissions || !(0, $7D4kr.landingPath)(access)) {
        // A practitioner here whose STAFF invitation is still open has no staff grants
        // until they accept it: the role has been offered, the missing step is theirs —
        // say so and lead them to it, not «the admin can assign your role» (PM-0536).
        const invited = activeMembership.staffStatus === 'INVITED';
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2tqZa.default), {
                    tone: "info",
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7h1oo.default), {
                        size: 26,
                        "aria-hidden": "true"
                    }),
                    title: t(invited ? 'clinic.gate.invitedTitle' : 'clinic.gate.noRolesTitle', {
                        name: activeMembership.clinicName
                    }),
                    body: t(invited ? 'clinic.gate.invitedBody' : 'clinic.gate.noRolesBody'),
                    testId: "gate-no-roles",
                    actions: [
                        ...invited ? [
                            {
                                key: 'invitations',
                                label: t('clinic.context.invitations'),
                                onClick: ()=>navigate('/invitations')
                            }
                        ] : [],
                        ...goElsewhere ? [
                            {
                                key: 'elsewhere',
                                ...elsewhereAction
                            }
                        ] : [],
                        {
                            key: 'access',
                            variant: 'outline',
                            label: t('clinic.myAccess.link'),
                            onClick: ()=>setAccessOpen(true)
                        }
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8b0fd7293ac0e6c9$export$2e2bcd8739ae039), {
                    open: accessOpen,
                    onClose: ()=>setAccessOpen(false)
                })
            ]
        });
    }
    // ── 4c. This screen, specifically ─────────────────────────────────────────
    if (!(0, $7D4kr.mayOpenPath)(access, path)) {
        const roleName = access.roles?.[0]?.nameFa || t(`clinic.context.tier.${String(access.tier || '').toLowerCase()}`);
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2tqZa.default), {
                    tone: "warning",
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bOJgt.default), {
                        size: 26,
                        "aria-hidden": "true"
                    }),
                    title: t('clinic.gate.noPermissionTitle'),
                    body: t('clinic.gate.noPermissionBody', {
                        clinic: activeMembership.clinicName,
                        role: roleName
                    }),
                    testId: "gate-no-permission",
                    actions: [
                        {
                            key: 'landing',
                            label: t('clinic.gate.backToLanding'),
                            onClick: ()=>navigate(`/c/${activeRef}${(0, $7D4kr.landingPath)(access)}`)
                        },
                        {
                            key: 'access',
                            variant: 'outline',
                            label: t('clinic.myAccess.link'),
                            onClick: ()=>setAccessOpen(true)
                        }
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8b0fd7293ac0e6c9$export$2e2bcd8739ae039), {
                    open: accessOpen,
                    onClose: ()=>setAccessOpen(false)
                })
            ]
        });
    }
    return children;
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $aphAM = parcelRequire("aphAM");parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $eYxJa = parcelRequire("eYxJa");
function $07a2ef0de2415234$export$2e2bcd8739ae039() {
    const location = (0, $aphAM.useLocation)();
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (location.pathname.replace(/\/+$/, '') !== '/subscription') return;
        (0, $eYxJa.stashPurchaseIntent)((0, $eYxJa.planKindFrom)(location.search));
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
        to: "/start",
        replace: true
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $42KYO = parcelRequire("42KYO");
var $aks7U = parcelRequire("aks7U");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $aJ1FU = parcelRequire("aJ1FU");
var $66joL = parcelRequire("66joL");
parcelRequire("bnX6X");
var $4rEI6 = parcelRequire("4rEI6");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("7c6z4");
var $gVWNP = parcelRequire("gVWNP");
var $e1LEq = parcelRequire("e1LEq");

var $2xQve = parcelRequire("2xQve");

var $acw62 = parcelRequire("acw62");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");
function $ca9da969cb04cd38$export$2e2bcd8739ae039(title) {
    const { t: t } = (0, $e1LEq.default)();
    (0, $acw62.useEffect)(()=>{
        if (!title) return undefined;
        const previous = document.title;
        document.title = `${title} \xb7 ${t('common.brand.name')}`;
        return ()=>{
            document.title = previous;
        };
    }, [
        title,
        t
    ]);
}



var $ett75 = parcelRequire("ett75");

var $58BYB = parcelRequire("58BYB");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $fx6O8 = parcelRequire("fx6O8");
var $3EHig = parcelRequire("3EHig");
var $k27hS = parcelRequire("k27hS");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $jTCZr = parcelRequire("jTCZr");
const $1321e40e345bf211$export$18e791503efeda9e = `linear-gradient(145deg, ${(0, $jTCZr.C).navyDark} 0%, ${(0, $jTCZr.C).navy} 55%, ${(0, $jTCZr.C).navyLight} 100%)`;
const $1321e40e345bf211$export$9bb03656a9dbb692 = `linear-gradient(160deg, ${(0, $jTCZr.C).navyDark} 0%, ${(0, $jTCZr.C).navy} 60%, ${(0, $jTCZr.C).navyLight} 100%)`;
const $1321e40e345bf211$export$c4b5c2acabd10f24 = {
    tile: 'rgba(255,255,255,0.12)',
    glyph: 'rgba(255,255,255,0.85)',
    muted: 'rgba(255,255,255,0.55)'
};


/**
 * The one chrome every pre-membership screen renders through.
 *
 * The clinic panel has four screens that a person sees before they are inside a
 * clinic — the auth transitional states, «شروع», the registration wizard and the
 * invitation landing — and until this component they were four hand-rolled
 * copies of the same idea: a white card on the brand gradient. No two agreed.
 * The card was 420, 440, 460 and 560 wide; its radius was 16 or 18; its padding
 * 28, 32 or 44; the gradient was written out by hand at three different angles;
 * and three of them declared their own bouncing-dot keyframes. A person signing
 * up walked through all four in ninety seconds and saw the product change shape
 * under them each time.
 *
 * So the geometry lives here, once — and since 2026-09-19 it is the DOCTOR
 * panel's onboarding card (doctor-app src/screens/Onboarding), which is the
 * reference for every pre-membership screen in Parsina:
 *
 *   • canvas   BRAND_CANVAS  145° navy-dark → navy → navy-light
 *   • band     BRAND_HERO    160°, a 40px frosted tile + 15/800 title + 11px subtitle
 *   • card     white, radius 18, `0 40px 100px` shadow, 520 wide, rises 24px in
 *   • padding  26 / 28 / 32 — the doctor's body padding
 *
 * The gradients are spelt from the navy tokens in `brandSurface.js`, so an
 * accent preset still recolours them.
 *
 * ── Why `title` is focused rather than merely rendered ──────────────────────
 *
 * These screens replace one another without a full page load, and several of
 * them are *steps* rather than routes. A screen reader is told nothing by a
 * React re-render, so the heading takes `tabIndex={-1}` and receives focus when
 * its text changes — which is also what puts a keyboard user at the top of the
 * new screen instead of wherever the last button happened to be.
 *
 * ── `align` ────────────────────────────────────────────────────────────────
 *
 * Centred by default — including «شروع», whose height is data-dependent: the
 * canvas has a `minHeight`, not a `height`, so a card taller than the viewport
 * grows the canvas and the PAGE scrolls instead of clipping. `top` is for the
 * wizard, whose card changes height step to step and would jump vertically if
 * it were re-centred on every step. Never give the card its own inner
 * scrollbar — that hides its primary action behind a gesture nobody makes on a
 * form.
 *
 * ── The mobile reduction (REV2 §A20) ───────────────────────────────────────
 *
 * At or below the product's single 768px breakpoint the card goes full-bleed:
 * no radius, no shadow, no gradient margin, top-aligned. A 560px card centred
 * in a 375px viewport is a card with 24px of gradient either side of it and its
 * submit button below the fold — the phone IS the card. The switch is
 * `useResponsive()` rather than a media query because the width is an inline
 * style, and one breakpoint for the whole product is the kit's rule.
 *
 * PROMOTION NOTE (packages/DESIGN.md rule 4): the doctor app draws this same
 * card inline in its onboarding screen. The right end state is one component in
 * `packages/ui` that both import — this one is deliberately free of clinic
 * vocabulary so that move is a file copy.
 */ /**
 * Whether the pre-membership screens may attempt a write.
 *
 * One `useOnlineStatus()` for the whole shell, shared through context. The hook
 * registers window listeners and owns a probe timer, so calling it once per
 * screen AND once in the shell would run two independent detectors that can
 * disagree — and would show the banner from one while the buttons obeyed the
 * other.
 *
 * ⚠︎ The hook returns an OBJECT (`{ state, isOnline, … }`), not the state
 * string. Comparing its return value against `ConnectionState.ONLINE` is always
 * false, which disables every submit button on every screen — with the banner
 * invisible, because `ConnectivityBanner` looks the object up in its variant map
 * and finds nothing. That is the shape of this bug when it comes back.
 */ const $67626da34750e532$var$OfflineCtx = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(false);
// The doctor's two card widths: 420 for its boot card, 520 for onboarding.
// `lg` used to be 720 for the registration wizard; the wizard now fits the
// doctor's 520 like every other step a new user walks through.
const $67626da34750e532$var$WIDTHS = {
    /** Transitional states: a sentence and one action. */ sm: 420,
    /** A screen you read: «شروع», the invitation landing. */ md: 520,
    /** A screen you fill in: the registration wizard. */ lg: 520
};
/** Material `domain` — the header tile's glyph, in the doctor's filled family. */ const $67626da34750e532$var$ClinicGlyph = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: (0, $1321e40e345bf211$export$c4b5c2acabd10f24).glyph,
        width: "20",
        height: "20",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
        })
    });
function $67626da34750e532$export$2e2bcd8739ae039({ width: width = 'md', align: align = 'center', icon: icon, title: title, subtitle: subtitle, headerEnd: headerEnd, footer: footer, utility: utility, children: children, testId: testId = 'auth-shell' }) {
    const { t: t } = (0, $e1LEq.default)();
    const { state: connection, isOnline: isOnline, recovered: recovered, acknowledgeRecovery: acknowledgeRecovery, check: check } = (0, $3EHig.useOnlineStatus)();
    const { isMobile: isMobile } = (0, $k27hS.default)();
    const headingRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const [probing, setProbing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // Announce the screen, not just paint it. Keyed on the title text so a step
    // change inside one route re-announces, which is the case a route-level
    // effect would miss entirely.
    const titleKey = typeof title === 'string' ? title : '';
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!titleKey) return;
        // Do NOT steal focus from a field that has already claimed it. The
        // registration form autofocuses its first input, which is the more useful
        // place to be — and a heading that grabs focus back on mount would make the
        // caret jump out of the box the moment the person started typing.
        const active = document.activeElement;
        if (active && active !== document.body && headingRef.current?.parentElement?.closest('main')?.contains(active)) return;
        headingRef.current?.focus();
    }, [
        titleKey
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": testId,
        style: {
            ...isMobile ? {
                // At ≤768px the DOCUMENT cannot scroll: styles.css locks html/body and
                // fixes #root to the 100dvh viewport, and every in-app screen brings
                // its own scroll region (MobileScreen). This canvas is that region for
                // the pre-membership screens — without it the wizard on a 568px-tall
                // iPhone SE, or «شروع» with a few invitations, was clipped below the
                // fold with no gesture that reached its submit. `height: 100%` sizes
                // it to #root (the SMALL viewport on iOS), not `100vh` (the large
                // one, whose bottom sits under Safari's toolbar).
                height: '100%',
                overflowY: 'auto',
                overflowX: 'hidden',
                overscrollBehaviorY: 'contain',
                WebkitOverflowScrolling: 'touch'
            } : {
                minHeight: '100vh'
            },
            width: '100%',
            display: 'flex',
            // On a phone the card IS the screen, so it starts at the top rather
            // than floating in the middle of a viewport it fills anyway. Not
            // `stretch`: in a fixed-height flex line that clamps the card to the
            // viewport, and its `overflow: hidden` would clip the rest again.
            alignItems: isMobile || align === 'top' ? 'flex-start' : 'center',
            justifyContent: 'center',
            background: (0, $1321e40e345bf211$export$18e791503efeda9e),
            padding: isMobile ? 0 : align === 'top' ? '40px 16px' : '24px 16px',
            boxSizing: 'border-box'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("main", {
                className: isMobile ? undefined : 'auth-shell-card',
                style: {
                    background: 'white',
                    borderRadius: isMobile ? 0 : 18,
                    boxShadow: isMobile ? 'none' : '0 40px 100px rgba(0,0,0,0.35)',
                    width: isMobile ? '100%' : $67626da34750e532$var$WIDTHS[width] || $67626da34750e532$var$WIDTHS.md,
                    maxWidth: '100%',
                    // At least the scroll region's height, so the white card still fills
                    // a short screen; free to grow past it, which is what scrolls.
                    minHeight: isMobile ? '100%' : undefined,
                    paddingBottom: isMobile ? 'env(safe-area-inset-bottom, 0px)' : undefined,
                    overflow: 'hidden'
                },
                children: [
                    title || subtitle || headerEnd ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            background: (0, $1321e40e345bf211$export$9bb03656a9dbb692),
                            padding: '22px 28px 18px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 14
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    width: 40,
                                    height: 40,
                                    borderRadius: 10,
                                    background: (0, $1321e40e345bf211$export$c4b5c2acabd10f24).tile,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    flexShrink: 0
                                },
                                children: icon || /*#__PURE__*/ (0, $ayMG0.jsx)($67626da34750e532$var$ClinicGlyph, {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    flex: 1,
                                    minWidth: 0
                                },
                                children: [
                                    title ? /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                        ref: headingRef,
                                        tabIndex: -1,
                                        style: {
                                            margin: 0,
                                            fontSize: '0.9375rem',
                                            fontWeight: 800,
                                            color: 'white',
                                            outline: 'none',
                                            lineHeight: 1.5
                                        },
                                        children: title
                                    }) : null,
                                    subtitle ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            fontSize: '0.6875rem',
                                            color: (0, $1321e40e345bf211$export$c4b5c2acabd10f24).muted,
                                            lineHeight: 1.6
                                        },
                                        children: subtitle
                                    }) : null
                                ]
                            }),
                            headerEnd ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    flexShrink: 0
                                },
                                children: headerEnd
                            }) : null
                        ]
                    }) : null,
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            padding: '26px 28px 32px'
                        },
                        children: [
                            !isOnline || recovered ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    marginBottom: 16
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fx6O8.default), {
                                    state: connection,
                                    recovered: recovered,
                                    onAcknowledgeRecovery: acknowledgeRecovery,
                                    onRetry: async ()=>{
                                        setProbing(true);
                                        try {
                                            await check();
                                        } finally{
                                            setProbing(false);
                                        }
                                    },
                                    busy: probing,
                                    offlineLabel: t('common.connectivity.offline'),
                                    degradedLabel: t('common.connectivity.degraded'),
                                    restoredLabel: t('common.connectivity.restored'),
                                    retryLabel: t('common.actions.retry'),
                                    busyLabel: t('common.connectivity.checking')
                                })
                            }) : null,
                            /*#__PURE__*/ (0, $ayMG0.jsx)($67626da34750e532$var$OfflineCtx.Provider, {
                                value: !isOnline,
                                children: children
                            })
                        ]
                    }),
                    footer ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            borderTop: `1px solid ${(0, $jTCZr.C).border}`,
                            padding: '20px 28px 28px'
                        },
                        children: footer
                    }) : null
                ]
            }),
            utility ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    position: 'fixed',
                    insetBlockEnd: 16,
                    insetInlineEnd: 16
                },
                children: utility
            }) : null
        ]
    });
}
function $67626da34750e532$export$effe8bfbb90ac49f() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($67626da34750e532$var$OfflineCtx);
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");

var $jTCZr = parcelRequire("jTCZr");
function $8e54e2ce06aafc96$export$9f36deeb77d11846({ id: id, title: title, subtitle: subtitle }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            marginBottom: 14
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                id: id,
                style: {
                    margin: '0 0 4px',
                    fontSize: '0.9375rem',
                    fontWeight: 700,
                    color: (0, $jTCZr.C).textPrimary
                },
                children: title
            }),
            subtitle ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    fontSize: '0.75rem',
                    color: (0, $jTCZr.C).textSecondary,
                    lineHeight: 1.8
                },
                children: subtitle
            }) : null
        ]
    });
}
const $8e54e2ce06aafc96$export$d2cff7ea2eb1dd47 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function PrimaryAction({ secondary: secondary = false, fullWidth: fullWidth = false, className: className = '', ...props }, ref) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
        ref: ref,
        variant: secondary ? 'outline' : 'default',
        size: "lg",
        className: `min-h-11 font-bold whitespace-nowrap${fullWidth ? ' w-full' : ''}${secondary ? '' : ' bg-gradient-brand'} ${className}`.trim(),
        ...props
    });
});



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $g6X9N = parcelRequire("g6X9N");
var $7gSBD = parcelRequire("7gSBD");
var $66joL = parcelRequire("66joL");
var $6usBW = parcelRequire("6usBW");

var $jTCZr = parcelRequire("jTCZr");
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $4231a10a956723cf$export$a2387ed3b5d536eb = {
    name: "mail-open",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M21.2 8.4c.5.38.8.97.8 1.6v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V10a2 2 0 0 1 .8-1.6l8-6a2 2 0 0 1 2.4 0l8 6Z",
                key: "1jhwl8"
            }
        ],
        [
            "path",
            {
                d: "m22 10-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 10",
                key: "1qfld7"
            }
        ]
    ]
};
$4231a10a956723cf$export$a2387ed3b5d536eb.node;
const $4231a10a956723cf$export$2e2bcd8739ae039 = (0, $9QBug.default)($4231a10a956723cf$export$a2387ed3b5d536eb);



var $2xQve = parcelRequire("2xQve");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $ett75 = parcelRequire("ett75");

var $2Mst8 = parcelRequire("2Mst8");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $7wZCE = parcelRequire("7wZCE");
var $bHjRG = parcelRequire("bHjRG");
var $aJ1FU = parcelRequire("aJ1FU");
var $g6X9N = parcelRequire("g6X9N");
var $hZDga = parcelRequire("hZDga");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $2xQve = parcelRequire("2xQve");
function $4a2d0729e4e27a9d$export$2e2bcd8739ae039({ membership: membership, busy: busy, onAccept: onAccept, onReject: onReject, onCancel: onCancel, disabled: disabled, variant: variant = 'invited' }) {
    const { t: t } = (0, $e1LEq.default)();
    const m = membership;
    const roles = m.roles || [];
    const isRequest = variant === 'requested';
    const meta = [
        m.city,
        !isRequest && m.invitedBy ? t('clinic.invitations.invitedBy', {
            name: m.invitedBy
        }) : null
    ].filter(Boolean);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $g6X9N.default), {
        "data-testid": `membership-${m.clinicId}`,
        style: {
            padding: 16,
            marginBottom: (0, $2xQve.STACK).regular
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: 12
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        "aria-hidden": "true",
                        style: {
                            flexShrink: 0
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7wZCE.default), {
                            name: m.clinicName,
                            size: 38
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            flex: 1,
                            minWidth: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    fontSize: '0.90625rem',
                                    fontWeight: 800,
                                    color: (0, $jTCZr.C).textPrimary,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'
                                },
                                title: m.clinicName,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("bdi", {
                                    children: m.clinicName
                                })
                            }),
                            isRequest ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    fontSize: '0.75rem',
                                    color: (0, $jTCZr.C).textSecondary,
                                    marginTop: 2
                                },
                                children: t('clinic.context.blocked.REQUESTED')
                            }) : meta.length ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    fontSize: '0.75rem',
                                    color: (0, $jTCZr.C).textSecondary,
                                    marginTop: 2
                                },
                                children: meta.join(" \xb7 ")
                            }) : null,
                            !isRequest ? roles.length ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    marginTop: 8,
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: 6
                                },
                                children: roles.map((r)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $bHjRG.default), {
                                        style: r.color ? {
                                            background: (0, $jTCZr.soft)(r.color, 0.15),
                                            color: r.color
                                        } : undefined,
                                        children: r.nameFa
                                    }, r.id))
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                                variant: "warning",
                                style: {
                                    marginTop: 8
                                },
                                children: t('clinic.invitations.noRoleYet')
                            }) : null
                        ]
                    }),
                    isRequest ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                        variant: "ghost",
                        onClick: ()=>onCancel(m),
                        disabled: busy || disabled,
                        "aria-busy": busy || undefined,
                        "data-testid": `cancel-${m.clinicId}`,
                        children: t('clinic.invitations.cancelRequest')
                    }) : null
                ]
            }),
            !isRequest ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    gap: 8,
                    marginTop: 14,
                    flexWrap: 'wrap'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                        onClick: ()=>onAccept(m),
                        disabled: busy || disabled,
                        "aria-busy": busy || undefined,
                        "data-testid": `accept-${m.clinicId}`,
                        children: [
                            busy ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hZDga.Spinner), {
                                size: 14,
                                color: "#fff",
                                label: t('common.state.loading')
                            }) : null,
                            busy ? t('clinic.invitations.accepting') : t('clinic.invitations.accept')
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                        variant: "outline",
                        onClick: ()=>onReject(m),
                        disabled: busy || disabled,
                        "data-testid": `reject-${m.clinicId}`,
                        children: t('clinic.invitations.reject')
                    })
                ]
            }) : null
        ]
    });
}


/**
 * The two membership sections — «دعوت‌های شما» and «درخواست‌های شما».
 *
 * Shared by «شروع» (§A4, outside the shell, for someone with no clinic to show)
 * and «دعوت‌ها» (§5.5, inside the shell, for someone who already has one). One
 * component because they are one thing seen from two places, and letting them
 * drift would put the same invitation in front of the same person twice,
 * worded differently.
 */ const $c3bd3d08bbd0090c$var$ACCEPT = `mutation AcceptClinicInvitation($clinicId: ID!) {
  acceptClinicInvitation(clinicId: $clinicId) { clinicId slug enterable }
}`;
const $c3bd3d08bbd0090c$var$REJECT = `mutation RejectClinicInvitation($clinicId: ID!) { rejectClinicInvitation(clinicId: $clinicId) }`;
const $c3bd3d08bbd0090c$var$CANCEL = `mutation CancelJoinRequest($clinicId: ID!) { cancelJoinRequest(clinicId: $clinicId) }`;
/**
 * One `MembershipCard` in placeholder — a 16px-padded `Card` holding a 38px
 * monogram, the clinic name at 14.5px over a 12px meta line, the proposed-role
 * chips, and the accept/reject pair. Same box, so the decision the reader is
 * about to make does not move under the cursor when the memberships land.
 */ function $c3bd3d08bbd0090c$var$MembershipCardSkeleton() {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $g6X9N.default), {
        "aria-hidden": true,
        style: {
            padding: 16,
            marginBottom: (0, $2xQve.STACK).regular
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: 12
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonAvatar), {
                        size: 38
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            flex: 1,
                            minWidth: 0,
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 6
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                width: "52%",
                                height: 14.5
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                width: "34%",
                                height: 12
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    gap: 6,
                                    marginTop: 2
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                        width: 64,
                                        height: 22,
                                        radius: (0, $jTCZr.RADIUS).pill
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                        width: 82,
                                        height: 22,
                                        radius: (0, $jTCZr.RADIUS).pill
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    gap: 8,
                    marginTop: 14
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonButton), {
                        width: 104
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonButton), {
                        width: 88
                    })
                ]
            })
        ]
    });
}
function $c3bd3d08bbd0090c$var$Heading({ children: children, id: id }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
        id: id,
        style: {
            margin: `0 0 ${(0, $2xQve.STACK).tight}px`,
            fontSize: '0.8125rem',
            fontWeight: 800,
            color: (0, $jTCZr.C).textPrimary
        },
        children: children
    });
}
function $c3bd3d08bbd0090c$export$2e2bcd8739ae039({ onEntered: onEntered, disabled: disabled }) {
    const { t: t } = (0, $e1LEq.default)();
    const toast = (0, $6usBW.useToast)();
    const { memberships: memberships, state: state, refreshGrants: refreshGrants, reload: reload, switchClinic: switchClinic } = (0, $ett75.useClinicContext)();
    const [busy, setBusy] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [failed, setFailed] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const alertRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const invited = memberships.filter((0, $ett75.isPendingInvitation));
    const requested = memberships.filter((m)=>m.status === 'REQUESTED');
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (failed) alertRef.current?.focus();
    }, [
        failed
    ]);
    const accept = async (m)=>{
        setBusy(m.clinicId);
        setFailed('');
        try {
            await (0, $2Mst8.bffMutation)($c3bd3d08bbd0090c$var$ACCEPT, {
                clinicId: m.clinicId
            }, 'AcceptClinicInvitation');
            // The token is holding grants issued BEFORE this acceptance — the composite
            // role was written to Keycloak a moment ago and a token does not
            // retroactively gain role mappings. Without this refresh the very next
            // request is FORBIDDEN and accepting looks like it failed (§A8).
            const fresh = await refreshGrants();
            toast?.success?.(t('clinic.invitations.accepted', {
                name: m.clinicName
            }));
            const now = (fresh || []).find((x)=>x.clinicId === m.clinicId);
            if (now?.enterable) {
                onEntered?.(now);
                switchClinic((0, $ett75.refOf)(now));
            }
        } catch (err) {
            // E17 — withdrawn between render and press. Say precisely that, rather than
            // a generic failure at the one moment a new colleague is forming an
            // impression of the product.
            setFailed(err?.extensions?.code === 'INVITATION_INVALID' ? t('clinic.invitations.noLongerValid') : err.message || t('errors.generic'));
        } finally{
            setBusy('');
        }
    };
    const reject = async (m)=>{
        setBusy(m.clinicId);
        try {
            await (0, $2Mst8.bffMutation)($c3bd3d08bbd0090c$var$REJECT, {
                clinicId: m.clinicId
            }, 'RejectClinicInvitation');
            await reload({
                silent: true
            });
            toast?.info?.(t('clinic.invitations.rejected'));
        } catch (err) {
            setFailed(err.message || t('errors.generic'));
        } finally{
            setBusy('');
        }
    };
    const cancel = async (m)=>{
        setBusy(m.clinicId);
        try {
            await (0, $2Mst8.bffMutation)($c3bd3d08bbd0090c$var$CANCEL, {
                clinicId: m.clinicId
            }, 'CancelJoinRequest');
            await reload({
                silent: true
            });
        } catch (err) {
            setFailed(err.message || t('errors.generic'));
        } finally{
            setBusy('');
        }
    };
    // Loading first, and separately. `memberships` is empty while the boot query
    // is still in flight, so testing emptiness before the state told the reader
    // «دعوتی ندارید» about a list that had not been fetched — the three-states
    // rule (DESIGN.md §"Loading & skeleton"): loading is not empty.
    if (state === (0, $ett75.BOOT).LOADING) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $66joL.SkeletonRegion), {
        // `as="section"`: what lands here is a `<section aria-labelledby>` per
        // membership group, so the placeholder sits in the same document
        // outline rather than collapsing the page to a run of divs.
        as: "section",
        label: t('common.state.loading'),
        "data-testid": "membership-skeleton",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                width: 96,
                height: 13,
                style: {
                    marginBottom: (0, $2xQve.STACK).tight
                }
            }),
            [
                0,
                1
            ].map((i)=>/*#__PURE__*/ (0, $ayMG0.jsx)($c3bd3d08bbd0090c$var$MembershipCardSkeleton, {}, i))
        ]
    });
    if (!invited.length && !requested.length) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7gSBD.default), {
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4231a10a956723cf$export$2e2bcd8739ae039), {
            size: 44,
            strokeWidth: 1.5,
            "aria-hidden": true
        }),
        title: t('clinic.invitations.emptyTitle'),
        description: t('clinic.invitations.emptyBody')
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            failed ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                ref: alertRef,
                tabIndex: -1,
                style: {
                    outline: 'none',
                    marginBottom: (0, $2xQve.STACK).regular
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                    variant: "error",
                    role: "alert",
                    "data-testid": "membership-error",
                    children: failed
                })
            }) : null,
            invited.length ? /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                "aria-labelledby": "inv-h",
                style: {
                    marginBottom: 20
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($c3bd3d08bbd0090c$var$Heading, {
                        id: "inv-h",
                        children: t('clinic.invitations.invitedSection')
                    }),
                    invited.map((m)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a2d0729e4e27a9d$export$2e2bcd8739ae039), {
                            membership: m,
                            variant: "invited",
                            busy: busy === m.clinicId,
                            disabled: disabled || !!busy && busy !== m.clinicId,
                            onAccept: accept,
                            onReject: reject
                        }, m.clinicId))
                ]
            }) : null,
            requested.length ? /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                "aria-labelledby": "req-h",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($c3bd3d08bbd0090c$var$Heading, {
                        id: "req-h",
                        children: t('clinic.invitations.requestedSection')
                    }),
                    requested.map((m)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a2d0729e4e27a9d$export$2e2bcd8739ae039), {
                            membership: m,
                            variant: "requested",
                            busy: busy === m.clinicId,
                            disabled: disabled || !!busy && busy !== m.clinicId,
                            onCancel: cancel
                        }, m.clinicId))
                ]
            }) : null
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");
/**
 * @license lucide-react v1.67.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $9QBug = parcelRequire("9QBug");
const $bfcbc51effea2154$export$a2387ed3b5d536eb = {
    name: "badge-check",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
                key: "3c2336"
            }
        ],
        [
            "path",
            {
                d: "m16 9-5.5 5.5L8 12",
                key: "xofnsj"
            }
        ]
    ],
    aliases: [
        "verified"
    ]
};
$bfcbc51effea2154$export$a2387ed3b5d536eb.node;
const $bfcbc51effea2154$export$2e2bcd8739ae039 = (0, $9QBug.default)($bfcbc51effea2154$export$a2387ed3b5d536eb);


var $jis86 = parcelRequire("jis86");
var $aks7U = parcelRequire("aks7U");
var $fX0JO = parcelRequire("fX0JO");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $aJ1FU = parcelRequire("aJ1FU");
var $a7Rbr = parcelRequire("a7Rbr");
parcelRequire("bnX6X");
var $LNQP4 = parcelRequire("LNQP4");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("7c6z4");
var $gVWNP = parcelRequire("gVWNP");
var $e1LEq = parcelRequire("e1LEq");


var $acw62 = parcelRequire("acw62");
parcelRequire("bnX6X");
var $eVM84 = parcelRequire("eVM84");
const $75660ae1ee1fb9c7$export$3151451f3f8d82d2 = `
  query LookupCouncilMember($code: String!) {
    lookupCouncilMember(code: $code) {
      status
      member { councilNumber fullName specialty degree memberType province city }
    }
  }
`;
const $75660ae1ee1fb9c7$var$COMPLETE_STEP1 = `
  mutation CompleteOnboardingStep1($input: OnboardingStep1Input!) {
    completeOnboardingStep1(input: $input) {
      id fullName medicalCode specialty bio
    }
  }
`;
// ── When the استعلام runs ────────────────────────────────────────────────────
//
// There is no «استعلام» button: the lookup starts by itself, off the number of
// DIGITS typed. The council allows ten searches per ten minutes to the whole
// platform — every pod leaves through one address — so a lookup per keystroke
// would spend that allowance before the first doctor finished typing.
//
//   • 6+ digits — a current council number is six digits, so the moment it is
//     complete there is nothing to wait for;
//   • 4–5 digits — real, but held by long-registered doctors, so those wait for
//     a pause in typing instead;
//   • fewer — never automatically. Leaving the field still looks up.
const $75660ae1ee1fb9c7$var$IMMEDIATE_DIGITS = 6;
const $75660ae1ee1fb9c7$var$AUTO_MIN_DIGITS = 4;
const $75660ae1ee1fb9c7$var$TYPING_PAUSE_MS = 1200;
const $75660ae1ee1fb9c7$export$53d3e8bb896b801f = (value)=>String(value ?? '').replace(/[۰-۹]/g, (d)=>String(d.charCodeAt(0) - 0x06F0)).replace(/[٠-٩]/g, (d)=>String(d.charCodeAt(0) - 0x0660)).replace(/\D/g, '');
function $75660ae1ee1fb9c7$export$5e0dc32a83dd8468(t) {
    const [code, setCode] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [member, setMember] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [looking, setLooking] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [retryable, setRetryable] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // The code the card on screen belongs to. Without it, editing the number
    // after a successful lookup would leave the previous doctor's name sitting
    // under a different number — and «ادامه» would still be enabled.
    const shownFor = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef('');
    // The value of the field right now, readable from a timer callback that was
    // scheduled one or more keystrokes ago.
    const codeRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef('');
    // The value the last request was sent for — set BEFORE the await, so it also
    // means "in flight" and one number is never asked twice.
    const askedRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef('');
    // …except when the answer was UNAVAILABLE, which is ours and transient: a
    // blur must be able to try that same number again.
    const retryableRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    // Latest-wins. A doctor who types «12500», pauses long enough for it to be
    // sent, then adds a «0» must never be shown the record for «12500» because
    // it came back second.
    const seqRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(0);
    const pauseRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>()=>clearTimeout(pauseRef.current), []);
    const runLookup = async (raw)=>{
        const asked = String(raw ?? '').trim();
        if (!asked || !$75660ae1ee1fb9c7$export$53d3e8bb896b801f(asked)) return;
        if (asked === askedRef.current && !retryableRef.current) return;
        askedRef.current = asked;
        retryableRef.current = false;
        const seq = ++seqRef.current;
        setLooking(true);
        setError(null);
        setRetryable(false);
        setMember(null);
        // True while this answer is still the one being waited for. A superseded
        // request returns without touching the screen at all — including `looking`,
        // which the newer request owns.
        const current = ()=>seq === seqRef.current && codeRef.current.trim() === asked;
        try {
            const res = await (0, $eVM84.bffQuery)($75660ae1ee1fb9c7$export$3151451f3f8d82d2, {
                code: asked
            });
            if (!current()) return;
            const result = res?.lookupCouncilMember;
            shownFor.current = asked;
            if (result?.status === 'FOUND' && result.member) setMember(result.member);
            else if (result?.status === 'AMBIGUOUS') setError(t('auth.onboarding.codeAmbiguous'));
            else if (result?.status === 'NOT_FOUND') setError(t('auth.onboarding.codeNotFound'));
            else {
                // UNAVAILABLE — ours to fix, not the doctor's. Never «کد اشتباه است».
                retryableRef.current = true;
                setRetryable(true);
                setError(t('auth.onboarding.registryUnavailable'));
            }
            setLooking(false);
        } catch (e) {
            if (!current()) return;
            shownFor.current = '';
            retryableRef.current = true;
            setRetryable(true);
            setError(e.message || t('auth.onboarding.registryUnavailable'));
            setLooking(false);
        }
    };
    const onChange = (value)=>{
        setCode(value);
        codeRef.current = value;
        clearTimeout(pauseRef.current);
        if (value.trim() !== shownFor.current) {
            setMember(null);
            setError(null);
            setRetryable(false);
        }
        const digits = $75660ae1ee1fb9c7$export$53d3e8bb896b801f(value);
        if (digits.length >= $75660ae1ee1fb9c7$var$IMMEDIATE_DIGITS) runLookup(value);
        else if (digits.length >= $75660ae1ee1fb9c7$var$AUTO_MIN_DIGITS) pauseRef.current = setTimeout(()=>runLookup(codeRef.current), $75660ae1ee1fb9c7$var$TYPING_PAUSE_MS);
    };
    // Leaving the field asks for whatever is in it, however short — the one way a
    // doctor with a two- or three-digit number gets a lookup at all.
    const onBlur = ()=>{
        clearTimeout(pauseRef.current);
        runLookup(codeRef.current);
    };
    const retry = ()=>{
        runLookup(codeRef.current);
    };
    return {
        code: code,
        member: member,
        looking: looking,
        error: error,
        setError: setError,
        retryable: retryable,
        onChange: onChange,
        onBlur: onBlur,
        retry: retry
    };
}
async function $75660ae1ee1fb9c7$export$7e64bbacbe004f09(member, { bio: bio } = {}) {
    const res = await (0, $eVM84.bffMutation)($75660ae1ee1fb9c7$var$COMPLETE_STEP1, {
        input: {
            medicalCode: member.councilNumber,
            bio: String(bio || '').trim() || undefined
        }
    });
    return res?.completeOnboardingStep1 || null;
}
function $75660ae1ee1fb9c7$export$f2d3faa40cc662fc(err, t) {
    const failed = err?.extensions?.code;
    if (failed === 'DUPLICATE_MEDICAL_CODE') return t('auth.onboarding.codeTaken');
    if (failed === 'COUNCIL_CODE_NOT_FOUND') return t('auth.onboarding.codeNotFound');
    if (failed === 'COUNCIL_CODE_AMBIGUOUS') return t('auth.onboarding.codeAmbiguous');
    if (failed === 'COUNCIL_REGISTRY_UNAVAILABLE') return t('auth.onboarding.registryUnavailable');
    return err?.message || t('errors.save.generic');
}



var $2Mst8 = parcelRequire("2Mst8");

var $58BYB = parcelRequire("58BYB");
parcelRequire("bnX6X");
var $eVM84 = parcelRequire("eVM84");
/**
 * Join the doctor to the clinic they just founded.
 *
 * ── Why this is a step at all ──────────────────────────────────────────────
 *
 * A clinic born in THIS panel writes clinicmanagement `clinics` + `clinic_staff`
 * and a Keycloak clinic role. It does not write a doctorpreference
 * `clinic_doctors` row and does not grant the `doctor` role — those are the
 * doctor side's, and `createClinic` has no business reaching into it. So a
 * doctor who registers their own clinic here is, to every doctor-side read,
 * a practitioner of nowhere: `myClinics` comes back empty and the clinic
 * filters, the contracts and the presence hours all say «no clinic».
 *
 * `enterPanelWithOwnedClinic` is the doctor BFF's repair for exactly that. It
 * takes no arguments — it reads the clinics whose `keycloak_user_id` is this
 * token's `sub`, which is what `createClinic` stamped — links EVERY one of them
 * rather than only the newest, accepts the membership (this is the founder's
 * own clinic; there is nobody to approve it) and grants the `doctor` role.
 *
 * ── It is idempotent, and that is load-bearing ─────────────────────────────
 *
 * The resolver skips a clinic it already linked, so running it twice links
 * nothing twice. That is what lets this be retried from the wizard and re-run
 * on a later sign-in without a second copy of the practitioner appearing in the
 * clinic's «پرسنل» list.
 *
 * ── Why the failure is not fatal ───────────────────────────────────────────
 *
 * The clinic exists and is enterable by the time this runs. A doctor blocked
 * from their own reception desk because a doctorpreference write failed would
 * be a worse outcome than a doctor who has to link later, so the caller reports
 * it and walks on.
 */ const $2150cd90b097242b$var$ENTER_PANEL_WITH_OWNED_CLINIC = `
  mutation EnterPanelWithOwnedClinic {
    enterPanelWithOwnedClinic {
      id clinicId doctorId status registeredVia
      clinic { id name }
    }
  }
`;
async function $2150cd90b097242b$export$7b2b6afdaa91e33a() {
    try {
        const res = await (0, $eVM84.bffMutation)($2150cd90b097242b$var$ENTER_PANEL_WITH_OWNED_CLINIC);
        return res?.enterPanelWithOwnedClinic || null;
    } catch (err) {
        // Named in the console rather than swallowed: when a founder later reports
        // «پنل پزشک می‌گوید عضو هیچ کلینیکی نیستم», this line is the evidence.
        console.error('[practitionerLink] enterPanelWithOwnedClinic failed:', err?.message || err);
        return null;
    }
}
var $2150cd90b097242b$export$2e2bcd8739ae039 = $2150cd90b097242b$export$7b2b6afdaa91e33a;



var $1O6TO = parcelRequire("1O6TO");

var $bMi4A = parcelRequire("bMi4A");

var $ett75 = parcelRequire("ett75");

var $hIlpX = parcelRequire("hIlpX");

var $iet7t = parcelRequire("iet7t");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $66joL = parcelRequire("66joL");
var $hZDga = parcelRequire("hZDga");
parcelRequire("bnX6X");
var $eVM84 = parcelRequire("eVM84");
var $4rEI6 = parcelRequire("4rEI6");

var $eLeza = parcelRequire("eLeza");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $iygI2 = parcelRequire("iygI2");
var $a7Rbr = parcelRequire("a7Rbr");
parcelRequire("bnX6X");
var $LNQP4 = parcelRequire("LNQP4");

var $jTCZr = parcelRequire("jTCZr");


/**
 * «مشخصات پزشک» — the doctor's professional identity, inside the clinic wizard.
 *
 * A port of the doctor panel's step 1 (doctor-app src/screens/Onboarding,
 * `StepDoctorInfo`). It is a PORT and not a second design: a doctor who signs
 * up at the clinic panel and one who signs up at the doctor panel are the same
 * person filling in the same council number, and two dialects of that screen is
 * two places to fix a registry bug. Change it there first.
 *
 * ── It talks to the DOCTOR BFF, not this panel's ───────────────────────────
 *
 * `lookupCouncilMember` and `completeOnboardingStep1` live in the doctor BFF,
 * which owns the practitioner record. `bffQuery`/`bffMutation` here are the
 * CLINICAL transport (lib/clinicalHost.js), already pointed at that BFF with
 * this panel's token — the same channel the visit room uses. The clinic BFF
 * exposes none of these operations and must not grow copies of them.
 *
 * Because the transport is the clinical one, the words are the clinical
 * catalogue's too (`auth.onboarding.*`), which is why this file reads
 * `useClinicalTranslation` rather than the panel's own `useTranslation`. The
 * caller mounts it inside `<ClinicalI18n>`.
 *
 * ── One field, and the rest is READ ────────────────────────────────────────
 *
 * The name on a prescription is the one سازمان نظام پزشکی holds against the
 * council number, so the wizard reads it instead of asking anyone. The card
 * below the field is a courtesy: the BFF resolves the code again and writes the
 * council's values whatever this screen sends.
 */ /** One line of the council's record. Rendered, never edited. */ const $41f2ce283a6150ce$var$RegistryRow = ({ label: label, value: value })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            gap: 8,
            alignItems: 'baseline',
            fontSize: '0.8125rem',
            lineHeight: 1.9
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                style: {
                    color: (0, $jTCZr.C).textSecondary,
                    minWidth: 96,
                    flexShrink: 0
                },
                children: label
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                style: {
                    color: (0, $jTCZr.C).textPrimary,
                    fontWeight: 600
                },
                children: value
            })
        ]
    });
function $41f2ce283a6150ce$export$2e2bcd8739ae039({ onDone: onDone, onSkip: onSkip, disabled: disabled = false }) {
    const { t: t } = (0, $LNQP4.default)();
    // The lookup — when it runs, latest-wins, and the registry's own failures
    // kept apart from a wrong number — is shared with «خوش آمدید!» on «شروع».
    const { code: code, member: member, looking: looking, error: error, setError: setError, onChange: setCodeField, onBlur: handleBlur } = (0, $75660ae1ee1fb9c7$export$5e0dc32a83dd8468)(t);
    const [bio, setBio] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [saving, setSaving] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const submit = async (e)=>{
        e?.preventDefault?.();
        if (!member || saving || disabled) return;
        setSaving(true);
        setError(null);
        try {
            const doctor = await (0, $75660ae1ee1fb9c7$export$7e64bbacbe004f09)(member, {
                bio: bio
            });
            if (!doctor?.id) throw new Error(t('errors.save.doctorProfile'));
            // Awaited: the caller asks the BFF one more question (is a wheel owed?)
            // before it decides which phase comes next, and an un-awaited call would
            // drop the button back to «مرحله بعد» over a form already submitted.
            await onDone({
                doctor: doctor
            });
        } catch (err) {
            setError((0, $75660ae1ee1fb9c7$export$f2d3faa40cc662fc)(err, t));
        } finally{
            setSaving(false);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
        onSubmit: submit,
        noValidate: true,
        "data-testid": "onboarding-doctor-step",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8e54e2ce06aafc96$export$9f36deeb77d11846), {
                title: t('auth.onboarding.professional'),
                subtitle: t('auth.onboarding.registryPrompt')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 14
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                                label: t('common.labels.medicalCode'),
                                required: true,
                                value: code,
                                onChange: (e)=>setCodeField(e.target.value),
                                onBlur: handleBlur,
                                dir: "ltr",
                                disabled: saving,
                                "data-testid": "onboarding-medical-code"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                "data-testid": "onboarding-lookup-status",
                                "aria-live": "polite",
                                style: {
                                    fontSize: '0.71875rem',
                                    color: (0, $jTCZr.C).textSecondary,
                                    marginTop: 6,
                                    minHeight: 16,
                                    lineHeight: 1.6
                                },
                                children: looking ? t('auth.onboarding.lookingUp') : ''
                            })
                        ]
                    }),
                    member ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        "data-testid": "onboarding-council-record",
                        style: {
                            border: `1px solid ${(0, $jTCZr.C).border}`,
                            borderRadius: 10,
                            padding: '12px 14px',
                            background: (0, $jTCZr.soft)((0, $jTCZr.C).teal, 0.06),
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 2
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    fontSize: '0.75rem',
                                    fontWeight: 700,
                                    color: (0, $jTCZr.C).teal,
                                    marginBottom: 6
                                },
                                children: t('auth.onboarding.registryTitle')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($41f2ce283a6150ce$var$RegistryRow, {
                                label: t('common.labels.fullName'),
                                value: member.fullName
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($41f2ce283a6150ce$var$RegistryRow, {
                                label: t('common.labels.medicalCode'),
                                value: member.councilNumber
                            }),
                            member.degree ? /*#__PURE__*/ (0, $ayMG0.jsx)($41f2ce283a6150ce$var$RegistryRow, {
                                label: t('auth.onboarding.registryDegree'),
                                value: member.degree
                            }) : null,
                            member.specialty ? /*#__PURE__*/ (0, $ayMG0.jsx)($41f2ce283a6150ce$var$RegistryRow, {
                                label: t('common.labels.specialty'),
                                value: member.specialty
                            }) : null,
                            member.memberType ? /*#__PURE__*/ (0, $ayMG0.jsx)($41f2ce283a6150ce$var$RegistryRow, {
                                label: t('auth.onboarding.registryMemberType'),
                                value: member.memberType
                            }) : null,
                            member.province || member.city ? /*#__PURE__*/ (0, $ayMG0.jsx)($41f2ce283a6150ce$var$RegistryRow, {
                                label: t('auth.onboarding.registryCity'),
                                value: [
                                    member.province,
                                    member.city
                                ].filter(Boolean).join(" \u2014 ")
                            }) : null,
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    fontSize: '0.6875rem',
                                    color: (0, $jTCZr.C).textSecondary,
                                    marginTop: 8,
                                    lineHeight: 1.8
                                },
                                children: t('auth.onboarding.registryLocked')
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iygI2.default), {
                        label: t('auth.onboarding.bioOptional'),
                        value: bio,
                        onChange: (e)=>setBio(e.target.value),
                        rows: 3,
                        disabled: saving,
                        "data-testid": "onboarding-bio"
                    }),
                    error ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                        variant: "error",
                        "data-testid": "onboarding-doctor-error",
                        children: error
                    }) : null,
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            gap: 10,
                            marginTop: 4
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8e54e2ce06aafc96$export$d2cff7ea2eb1dd47), {
                                secondary: true,
                                type: "button",
                                onClick: onSkip,
                                disabled: saving,
                                "data-testid": "onboarding-doctor-skip",
                                children: t('common.actions.back')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8e54e2ce06aafc96$export$d2cff7ea2eb1dd47), {
                                fullWidth: true,
                                type: "submit",
                                disabled: saving || disabled || !member,
                                "data-testid": "onboarding-doctor-next",
                                children: saving ? t('auth.onboarding.saving') : t('auth.onboarding.next')
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $fAR2n = parcelRequire("fAR2n");
var $iygI2 = parcelRequire("iygI2");
var $a7Rbr = parcelRequire("a7Rbr");
parcelRequire("bnX6X");
var $eVM84 = parcelRequire("eVM84");
var $LNQP4 = parcelRequire("LNQP4");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $aOzet = parcelRequire("aOzet");

/**
 * «مشخصات پزشک» for a doctor licensed OUTSIDE Iran (PM-0061).
 *
 * The sibling of DoctorIdentityStep, and like it a PORT of the doctor panel's
 * screen (doctor-app src/screens/Onboarding, `StepForeignInfo`) — change it
 * there first. A doctor who signed in with a non-Iranian number holds no
 * کد نظام پزشکی, so there is nothing to look up and nothing to read: this is the
 * one form on which a doctor TYPES their professional identity. Name,
 * specialty, degree, country and city are required; the licence number their
 * own country issued is optional. Nothing is verified, and the form says so
 * before the doctor saves rather than after.
 *
 * ── Same transport as its sibling ──────────────────────────────────────────
 *
 * `completeForeignOnboarding` lives in the doctor BFF, reached over the
 * CLINICAL transport. WHO may call it is that BFF's decision, read from its own
 * record of the number — DoctorTrack only renders this form on a positive
 * `onboardingContext`, and rendering it for anyone else would earn a refusal.
 *
 * ── Two catalogues ─────────────────────────────────────────────────────────
 *
 * The words shared with the council step (`auth.onboarding.professional`,
 * `.saving`, `.next`, the bio label) are the clinical pack's. The form's own
 * words are this panel's (`auth.onboarding.foreign.*`) until the kit's pack
 * carries them.
 *
 * ── The specialty is picked, not typed (PM-0074) ───────────────────────────
 *
 * From the practitioner service's trilingual catalogue (`specialties`, doctor
 * BFF), labelled in the panel's language. The form sends the row's CODE and
 * the BFF stores its Persian name; «سایر» opens a text box for a specialty the
 * list does not name. The kit's Select has no option groups, so unlike the
 * doctor panel the list here is one alphabetical run. A BFF without the query
 * leaves the old free-text box in place.
 *
 * French (PM-0185) asks for `nameFr` too. A doctor BFF from before that field
 * refuses the whole query, so the form asks again without it — the picker stays,
 * and a French reader reads the English names — and only a BFF without the
 * query at all leaves the free-text box. German (PM-0212) adds `nameDe` the same
 * way, one step earlier: a BFF with `nameFr` but not `nameDe` is asked without
 * `nameDe` first, and a German reader reads the English names.
 */ const $5f6389a205aea172$var$COMPLETE_FOREIGN = `
  mutation CompleteForeignOnboarding($input: ForeignOnboardingInput!) {
    completeForeignOnboarding(input: $input) {
      id fullName medicalCode specialty degree country city selfDeclared bio
    }
  }
`;
const $5f6389a205aea172$var$SPECIALTIES = `
  query Specialties {
    specialties { code kind nameFa nameEn nameAr nameFr nameDe sortOrder }
  }
`;
// The same query for a doctor BFF that predates `nameDe` (see the header).
const $5f6389a205aea172$var$SPECIALTIES_BEFORE_DE = `
  query Specialties {
    specialties { code kind nameFa nameEn nameAr nameFr sortOrder }
  }
`;
// The same query for a doctor BFF that predates `nameFr` (see the header).
const $5f6389a205aea172$var$SPECIALTIES_BEFORE_FR = `
  query Specialties {
    specialties { code kind nameFa nameEn nameAr sortOrder }
  }
`;
// Must match the doctor BFF's OTHER_SPECIALTY_CODE.
const $5f6389a205aea172$var$OTHER_SPECIALTY = 'other';
// The row's fields a reader of each language is labelled from, in order. Persian
// is the last resort for every one — and French and German read English before
// it (docs/locale/FRENCH.md D4, PM-0212). A language not listed reads Persian.
const $5f6389a205aea172$var$SPECIALTY_FIELDS = {
    en: [
        'nameEn'
    ],
    ar: [
        'nameAr'
    ],
    fr: [
        'nameFr',
        'nameEn'
    ],
    de: [
        'nameDe',
        'nameEn'
    ]
};
const $5f6389a205aea172$var$specialtyLabel = (row, locale)=>($5f6389a205aea172$var$SPECIALTY_FIELDS[locale] || []).map((field)=>row[field]).find(Boolean) || row.nameFa;
const $5f6389a205aea172$var$REQUIRED = [
    'fullName',
    'degree',
    'country',
    'city'
];
function $5f6389a205aea172$export$2e2bcd8739ae039({ phone: phone, onDone: onDone, onSkip: onSkip, disabled: disabled = false }) {
    const { t: ct } = (0, $LNQP4.default)();
    const { t: t, locale: locale } = (0, $e1LEq.default)();
    const [form, setForm] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>({
            // `specialtyCode` is a catalogue row's code, or OTHER_SPECIALTY with the
            // doctor's own words in `specialty`.
            fullName: '',
            specialtyCode: '',
            specialty: '',
            degree: '',
            // The country of the number they signed in with is the likeliest issuer of
            // their licence, so it is offered — and stays theirs to change.
            country: (0, $aOzet.countryForPhone)(phone)?.iso2 || '',
            city: '',
            licenseNumber: ''
        }));
    const [bio, setBio] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [saving, setSaving] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // `null` = loading; `[]` = unavailable → the free-text box, never a block.
    const [catalogue, setCatalogue] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        let alive = true;
        (0, $eVM84.bffQuery)($5f6389a205aea172$var$SPECIALTIES).catch(()=>(0, $eVM84.bffQuery)($5f6389a205aea172$var$SPECIALTIES_BEFORE_DE)).catch(()=>(0, $eVM84.bffQuery)($5f6389a205aea172$var$SPECIALTIES_BEFORE_FR)).then((data)=>{
            if (alive) setCatalogue(data?.specialties || []);
        }).catch(()=>{
            if (alive) setCatalogue([]);
        });
        return ()=>{
            alive = false;
        };
    }, []);
    const pickerless = Array.isArray(catalogue) && catalogue.length === 0;
    const typing = pickerless || form.specialtyCode === $5f6389a205aea172$var$OTHER_SPECIALTY;
    const specialtyOptions = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>[
            ...(catalogue || []).map((r)=>({
                    value: r.code,
                    label: $5f6389a205aea172$var$specialtyLabel(r, locale)
                })).sort((a, b)=>a.label.localeCompare(b.label, locale)),
            {
                value: $5f6389a205aea172$var$OTHER_SPECIALTY,
                label: t('auth.onboarding.foreign.specialtyOther')
            }
        ], [
        catalogue,
        locale,
        t
    ]);
    const set = (name)=>(e)=>setForm((f)=>({
                    ...f,
                    [name]: e.target.value
                }));
    const specialtyGiven = typing ? form.specialty.trim() !== '' : form.specialtyCode !== '';
    const complete = specialtyGiven && $5f6389a205aea172$var$REQUIRED.every((name)=>form[name].trim() !== '');
    const countryOptions = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $aOzet.COUNTRIES).map((c)=>({
                value: c.iso2,
                label: (0, $aOzet.countryName)(c, locale)
            })).sort((a, b)=>a.label.localeCompare(b.label, locale)), [
        locale
    ]);
    const submit = async (e)=>{
        e?.preventDefault?.();
        if (saving || disabled) return;
        if (!complete) {
            setError(t('auth.onboarding.foreign.incomplete'));
            return;
        }
        setSaving(true);
        setError(null);
        try {
            const res = await (0, $eVM84.bffMutation)($5f6389a205aea172$var$COMPLETE_FOREIGN, {
                input: {
                    fullName: form.fullName.trim(),
                    // A picked row sends only its code — the BFF stores its Persian name.
                    ...pickerless ? {
                        specialty: form.specialty.trim()
                    } : {
                        specialtyCode: form.specialtyCode,
                        specialty: typing ? form.specialty.trim() : undefined
                    },
                    degree: form.degree.trim(),
                    country: form.country,
                    city: form.city.trim(),
                    licenseNumber: form.licenseNumber.trim() || undefined,
                    bio: bio.trim() || undefined
                }
            });
            const doctor = res?.completeForeignOnboarding;
            if (!doctor?.id) throw new Error(ct('errors.save.doctorProfile'));
            // Awaited, as on the council step: the caller asks the BFF one more
            // question before it decides which phase comes next.
            await onDone({
                doctor: doctor
            });
        } catch (err) {
            const failed = err?.extensions?.code;
            if (failed === 'DUPLICATE_LICENSE_NUMBER') setError(t('auth.onboarding.foreign.licenseTaken'));
            else if (failed === 'FOREIGN_PROFILE_INCOMPLETE') setError(t('auth.onboarding.foreign.incomplete'));
            else if (failed === 'FOREIGN_ONBOARDING_NOT_ALLOWED') setError(t('auth.onboarding.foreign.notAllowed'));
            else if (failed === 'SPECIALTY_UNKNOWN') setError(t('auth.onboarding.foreign.specialtyUnknown'));
            else setError(err.message || ct('errors.save.generic'));
        } finally{
            setSaving(false);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
        onSubmit: submit,
        noValidate: true,
        "data-testid": "onboarding-doctor-step",
        "data-foreign": "true",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8e54e2ce06aafc96$export$9f36deeb77d11846), {
                title: ct('auth.onboarding.professional'),
                subtitle: t('auth.onboarding.foreign.prompt')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 14
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                        label: t('auth.onboarding.foreign.fullName'),
                        required: true,
                        value: form.fullName,
                        onChange: set('fullName'),
                        dir: "auto",
                        autoComplete: "name",
                        maxLength: 120,
                        disabled: saving,
                        "data-testid": "onboarding-foreign-fullName"
                    }),
                    pickerless ? null : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fAR2n.default), {
                        label: t('auth.onboarding.foreign.specialty'),
                        required: true,
                        value: form.specialtyCode,
                        onChange: set('specialtyCode'),
                        options: specialtyOptions,
                        placeholder: t('auth.onboarding.foreign.specialtyChoose'),
                        disabled: saving || catalogue === null,
                        "data-testid": "onboarding-foreign-specialty-select"
                    }),
                    typing ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                        label: t(pickerless ? 'auth.onboarding.foreign.specialty' : 'auth.onboarding.foreign.specialtyOtherLabel'),
                        required: true,
                        value: form.specialty,
                        onChange: set('specialty'),
                        placeholder: t('auth.onboarding.foreign.specialtyPlaceholder'),
                        dir: "auto",
                        maxLength: 120,
                        disabled: saving,
                        "data-testid": "onboarding-foreign-specialty"
                    }) : null,
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                        label: t('auth.onboarding.foreign.degree'),
                        required: true,
                        value: form.degree,
                        onChange: set('degree'),
                        placeholder: t('auth.onboarding.foreign.degreePlaceholder'),
                        dir: "auto",
                        maxLength: 120,
                        disabled: saving,
                        "data-testid": "onboarding-foreign-degree"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fAR2n.default), {
                        label: t('auth.onboarding.foreign.country'),
                        required: true,
                        value: form.country,
                        onChange: set('country'),
                        options: countryOptions,
                        placeholder: t('auth.onboarding.foreign.countryPlaceholder'),
                        disabled: saving,
                        "data-testid": "onboarding-foreign-country"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                        label: t('auth.onboarding.foreign.city'),
                        required: true,
                        value: form.city,
                        onChange: set('city'),
                        dir: "auto",
                        maxLength: 80,
                        disabled: saving,
                        "data-testid": "onboarding-foreign-city"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                        label: t('auth.onboarding.foreign.license'),
                        value: form.licenseNumber,
                        onChange: set('licenseNumber'),
                        helperText: t('auth.onboarding.foreign.licenseHint'),
                        dir: "ltr",
                        maxLength: 40,
                        disabled: saving,
                        "data-testid": "onboarding-foreign-license"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iygI2.default), {
                        label: ct('auth.onboarding.bioOptional'),
                        value: bio,
                        onChange: (e)=>setBio(e.target.value),
                        rows: 3,
                        disabled: saving,
                        "data-testid": "onboarding-bio"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                        variant: "warning",
                        "data-testid": "onboarding-foreign-notice",
                        children: t('auth.onboarding.foreign.notice')
                    }),
                    error ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                        variant: "error",
                        "data-testid": "onboarding-doctor-error",
                        children: error
                    }) : null,
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            gap: 10,
                            marginTop: 4
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8e54e2ce06aafc96$export$d2cff7ea2eb1dd47), {
                                secondary: true,
                                type: "button",
                                onClick: onSkip,
                                disabled: saving,
                                "data-testid": "onboarding-doctor-skip",
                                children: ct('common.actions.back')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8e54e2ce06aafc96$export$d2cff7ea2eb1dd47), {
                                fullWidth: true,
                                type: "submit",
                                disabled: saving || disabled || !complete,
                                "data-testid": "onboarding-doctor-next",
                                children: saving ? ct('auth.onboarding.saving') : ct('auth.onboarding.next')
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $aJ1FU = parcelRequire("aJ1FU");
var $fW63i = parcelRequire("fW63i");
var $k27hS = parcelRequire("k27hS");
var $6usBW = parcelRequire("6usBW");
parcelRequire("bnX6X");
var $eVM84 = parcelRequire("eVM84");
var $LNQP4 = parcelRequire("LNQP4");

var $jTCZr = parcelRequire("jTCZr");
/**
 * «گردونهٔ شانس» — the wheel, when a campaign owes this doctor a spin.
 *
 * A port of the doctor panel's `PrizeStage` (doctor-app src/screens/Onboarding).
 * Same rules, same words — the clinical catalogue's `auth.onboarding.prize.*`,
 * which is why this reads `useClinicalTranslation` and is mounted inside
 * `<ClinicalI18n>`. Change it in the doctor app first.
 *
 * PROMOTION NOTE (packages/DESIGN.md rule 4): two apps now draw this stage, so
 * it belongs in `packages/clinical` beside the wheel and the words it already
 * ships. It is a copy today only because promoting it is a framework release
 * and a pin bump in both apps; do that before a third app needs it.
 *
 * THE SERVER DECIDES. This screen does not pick a slice, does not know the
 * odds, and cannot change the answer by asking twice: it sends a draw id and
 * animates to whatever index comes back. A failure is never a dead end.
 *
 * ── What is NOT here ───────────────────────────────────────────────────────
 *
 * The doctor panel calls `notifyWalletChanged()` after a win so its credits
 * hero refetches. This panel has no such display — a practitioner's پارسه is
 * personal and lives in the doctor panel (lib/doctorPanel.js), and the clinic's
 * own balance is a different wallet that this prize never touches — so there is
 * nothing here to invalidate.
 */ // `canRetry: true` is this client saying it knows what «تلاش دوباره» is. The
// server may only land a draw on that slice for a client that says so — one
// that does not would show a doctor «۰ پارسه» on a result card and let them
// walk away from a prize they are still owed.
const $9d1389f785a3d0eb$var$SPIN_PRIZE_WHEEL = `
  mutation SpinPrizeWheel($drawId: ID!, $canRetry: Boolean) {
    spinPrizeWheel(drawId: $drawId, canRetry: $canRetry) {
      id status segmentIndex kind amount smartVisits
      whatsappMessages baleMessages smsMessages retry
      balance { balance currency }
    }
  }
`;
// The wheel's diameter. Both shrink to their container — the kit's svg is
// `max-width: 100%` — so these are a ceiling rather than a size.
const $9d1389f785a3d0eb$var$WHEEL_PX = {
    mobile: 318,
    desktop: 380
};
/** The winning slice, or null. 0 IS a slice, so `||` and `??` are both wrong. */ const $9d1389f785a3d0eb$var$settledIndex = (draw)=>Number.isInteger(draw?.segmentIndex) ? draw.segmentIndex : null;
/** A draw the doctor has already spun — re-shown, not replayed. */ const $9d1389f785a3d0eb$var$alreadySpun = (draw)=>draw?.status !== 'offered' && $9d1389f785a3d0eb$var$settledIndex(draw) != null;
/** The wheel stopped on «تلاش دوباره»: nothing was won and the draw is STILL
 *  `offered`. The server lands a draw here at most once, so the spin after it
 *  always wins. Read off the server's own flag — never off a label or an
 *  amount of 0, which a real (if stingy) slice could also carry. */ const $9d1389f785a3d0eb$var$landedOnRetry = (draw)=>draw?.retry === true;
function $9d1389f785a3d0eb$var$CheckIcon({ size: size = 26 }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M20 6L9 17l-5-5"
        })
    });
}
function $9d1389f785a3d0eb$export$2e2bcd8739ae039({ draw: draw, onDone: onDone }) {
    const { t: t, has: has, formatNumber: formatNumber } = (0, $LNQP4.default)();
    const { isMobile: isMobile } = (0, $k27hS.default)();
    const toast = (0, $6usBW.useToast)();
    // A draw that arrives already spun opens AT its result: the wheel sits on the
    // winning slice with no animation and the card is there on the first frame.
    // Replaying a four-second spin for a prize decided yesterday would read as a
    // second chance. A draw that landed on «تلاش دوباره» (the doctor closed the
    // tab between the two spins) is kept as well, but NOT as settled.
    const [result, setResult] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>$9d1389f785a3d0eb$var$alreadySpun(draw) || $9d1389f785a3d0eb$var$landedOnRetry(draw) ? draw : null);
    const [spinning, setSpinning] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // `settled` means A PRIZE is on screen — it is what swaps the button for the
    // result card and what makes `spin` a no-op. A retry never sets it.
    const [settled, setSettled] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>$9d1389f785a3d0eb$var$alreadySpun(draw));
    const [busy, setBusy] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const segments = Array.isArray(draw?.segments) ? draw.segments : [];
    const targetIndex = $9d1389f785a3d0eb$var$settledIndex(result);
    const spin = async ()=>{
        if (busy || spinning || settled) return;
        setBusy(true);
        setError('');
        try {
            // The same draw id both times: the second chance is the server's to give,
            // and it is the same draw being spun again.
            const data = await (0, $eVM84.bffMutation)($9d1389f785a3d0eb$var$SPIN_PRIZE_WHEEL, {
                drawId: draw.id,
                canRetry: true
            });
            const spun = data?.spinPrizeWheel;
            // A 200 with no draw in it. Not an exception — the request succeeded — so
            // it is reported as the same sentence as a failure rather than thrown into
            // the catch, where the code/messageKey branches would find nothing.
            if (!spun) {
                setError(t('errors.save.generic'));
                return;
            }
            setResult(spun);
            const index = $9d1389f785a3d0eb$var$settledIndex(spun);
            if (index == null) // The service answered without a slice. There is nothing to animate to,
            // and inventing one (index 0 is a real prize) would show a number that
            // was not won. Skip the wheel, keep the result — unless it is a retry,
            // which has no result to keep.
            {
                if (!$9d1389f785a3d0eb$var$landedOnRetry(spun)) setSettled(true);
            } else setSpinning(true);
        } catch (e) {
            if (e?.extensions?.code === 'PRIZE_NOT_AVAILABLE') {
                // The wheel stopped being spinnable between this page rendering and the
                // button. Say so and move on — there is no second action on this screen,
                // so a doctor left here with a dead button is a doctor who cannot reach
                // their clinic.
                toast?.info?.(t('auth.onboarding.prize.unavailable'));
                onDone?.();
                return;
            }
            // The BFF names the sentence it means; its own text is the fallback for a
            // key this catalogue has not learned yet.
            const key = e?.extensions?.messageKey;
            setError((key && has(key) ? t(key) : '') || e?.message || t('errors.save.generic'));
        } finally{
            setBusy(false);
        }
    };
    // The wheel has come to rest. A win settles the stage; a retry only stops the
    // wheel — it stays parked on that slice, which is what lets the next spin
    // carry on from there — and the button comes back.
    const onWheelSettled = ()=>{
        setSpinning(false);
        if (!$9d1389f785a3d0eb$var$landedOnRetry(result)) setSettled(true);
    };
    const amount = Number(result?.amount || 0);
    // The service's own figures. Absent (an older BFF) → the line is dropped
    // rather than guessed at: a wrong equivalence is worse than none.
    const smartVisits = Number(result?.smartVisits || 0);
    const whatsappMessages = Number(result?.whatsappMessages || 0);
    const baleMessages = Number(result?.baleMessages || 0);
    const smsMessages = Number(result?.smsMessages || 0);
    const newBalance = result?.balance?.balance;
    const showResult = settled && result;
    // «تلاش دوباره» is on screen from the moment the wheel stops on it until the
    // second spin is pressed — not while it is still turning, which would give
    // the animation away exactly as the result card would.
    const retryPending = !settled && $9d1389f785a3d0eb$var$landedOnRetry(result);
    const showRetry = retryPending && !busy && !spinning;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 16
        },
        "data-testid": "onboarding-prize-step",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 6
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: '1.1875rem',
                            fontWeight: 800,
                            color: (0, $jTCZr.C).textPrimary,
                            lineHeight: 1.6
                        },
                        children: draw?.title || t('auth.onboarding.prize.title')
                    }),
                    draw?.subtitle ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: '0.8125rem',
                            fontWeight: 500,
                            color: (0, $jTCZr.C).textSecondary,
                            lineHeight: 1.9
                        },
                        children: draw.subtitle
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fW63i.default), {
                    "data-testid": "prize-wheel",
                    segments: segments,
                    targetIndex: targetIndex,
                    spinning: spinning,
                    onSettled: onWheelSettled,
                    size: isMobile ? $9d1389f785a3d0eb$var$WHEEL_PX.mobile : $9d1389f785a3d0eb$var$WHEEL_PX.desktop,
                    label: t('auth.onboarding.prize.title')
                })
            }),
            error ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                variant: "error",
                "data-testid": "prize-error",
                children: error
            }) : null,
            showResult ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                "data-testid": "prize-result",
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 12,
                    padding: 16,
                    borderRadius: (0, $jTCZr.RADIUS).card,
                    background: (0, $jTCZr.C).card,
                    border: `1px solid ${(0, $jTCZr.C).border}`,
                    boxShadow: `0 6px 24px ${(0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.1)}`
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 12
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                "aria-hidden": "true",
                                style: {
                                    width: 44,
                                    height: 44,
                                    borderRadius: (0, $jTCZr.RADIUS).control,
                                    flexShrink: 0,
                                    background: (0, $jTCZr.C).teal,
                                    color: (0, $jTCZr.C).card,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($9d1389f785a3d0eb$var$CheckIcon, {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 3,
                                    minWidth: 0,
                                    flex: 1
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            fontSize: '0.9375rem',
                                            fontWeight: 700,
                                            color: (0, $jTCZr.C).textPrimary,
                                            lineHeight: 1.6
                                        },
                                        children: newBalance != null ? t('auth.onboarding.prize.wonParseh', {
                                            parseh: formatNumber(amount)
                                        }) : t('auth.onboarding.prize.wonPending', {
                                            parseh: formatNumber(amount)
                                        })
                                    }),
                                    whatsappMessages > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        "data-testid": "prize-worth",
                                        style: {
                                            fontSize: '0.71875rem',
                                            color: (0, $jTCZr.C).textSecondary,
                                            lineHeight: 1.9,
                                            overflowWrap: 'anywhere'
                                        },
                                        children: t('auth.onboarding.prize.worth', {
                                            whatsapp: formatNumber(whatsappMessages),
                                            bale: formatNumber(baleMessages),
                                            sms: formatNumber(smsMessages),
                                            visits: formatNumber(smartVisits)
                                        })
                                    }) : smartVisits > 0 ? // An older BFF, which knows smart visits and nothing else.
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            fontSize: '0.71875rem',
                                            color: (0, $jTCZr.C).textSecondary
                                        },
                                        children: t('auth.onboarding.prize.smartVisits', {
                                            visits: formatNumber(smartVisits)
                                        })
                                    }) : null
                                ]
                            })
                        ]
                    }),
                    newBalance != null ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            padding: '10px 12px',
                            borderRadius: (0, $jTCZr.RADIUS).control,
                            background: (0, $jTCZr.C).bg
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    fontSize: '0.71875rem',
                                    color: (0, $jTCZr.C).textSecondary
                                },
                                children: t('auth.onboarding.prize.newBalance')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    fontSize: '0.9375rem',
                                    fontWeight: 700,
                                    color: (0, $jTCZr.C).navy
                                },
                                dir: "ltr",
                                children: formatNumber(newBalance)
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                        size: "lg",
                        "data-testid": "prize-continue",
                        onClick: ()=>onDone?.(),
                        className: "min-h-11 font-bold w-full bg-gradient-brand",
                        children: t('auth.onboarding.prize.continue')
                    })
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 10
                },
                children: [
                    showRetry ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        role: "status",
                        "data-testid": "prize-retry",
                        style: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 4,
                            padding: '0.75rem 0.875rem',
                            borderRadius: (0, $jTCZr.RADIUS).card,
                            background: (0, $jTCZr.soft)((0, $jTCZr.C).teal, 0.08),
                            border: `1px solid ${(0, $jTCZr.soft)((0, $jTCZr.C).teal, 0.3)}`,
                            textAlign: 'start'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    fontSize: '0.9375rem',
                                    fontWeight: 700,
                                    color: (0, $jTCZr.C).textPrimary,
                                    lineHeight: 1.6
                                },
                                children: t('auth.onboarding.prize.retryTitle')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    fontSize: '0.8125rem',
                                    fontWeight: 500,
                                    color: (0, $jTCZr.C).textSecondary,
                                    lineHeight: 1.9
                                },
                                children: t('auth.onboarding.prize.retryBody')
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                        size: "lg",
                        "data-testid": "prize-spin",
                        onClick: spin,
                        disabled: busy || spinning,
                        className: "min-h-11 font-bold w-full bg-gradient-brand",
                        children: busy || spinning ? t('auth.onboarding.prize.spinning') : t(retryPending ? 'auth.onboarding.prize.spinAgain' : 'auth.onboarding.prize.spin')
                    }),
                    !retryPending ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: '0.71875rem',
                            color: (0, $jTCZr.C).textMuted,
                            textAlign: 'center',
                            lineHeight: 1.8
                        },
                        children: t('auth.onboarding.prize.oneSpin')
                    }) : null
                ]
            })
        ]
    });
}


/**
 * The doctor half of «ثبت کلینیک جدید», for someone who said «من پزشک هستم».
 *
 * Two screens that belong to the DOCTOR panel — the نظام پزشکی lookup and the
 * prize wheel — rendered here so a doctor who arrives at the clinic panel first
 * is not sent to another app to become a doctor and then back to build a
 * clinic. They are the doctor panel's screens, not copies with clinic words on
 * them: same transport (the doctor BFF), same catalogue, same rules.
 *
 * ── Why the extra provider ─────────────────────────────────────────────────
 *
 * The words these two screens use (`auth.onboarding.*`, including the wheel's)
 * ship in the CLINICAL language pack, not this panel's. `ClinicalI18n` is that
 * pack's provider — the same one screens/Clinical mounts around the visit room
 * — and it renders nothing until its first load lands, so it is given a
 * fallback rather than being allowed to blank the wizard mid-flow.
 *
 * The language is this panel's: a clinic owner who switched the panel to
 * English does not meet a Persian step in the middle of registration.
 */ // Asked ONCE, right after the council step succeeds, because that is the moment
// the BFF has written the practitioner record the offer is decided from. It
// returns [] for almost every doctor and it is allowed to fail: a campaign
// service that is down must cost a doctor nothing more than a wheel they never
// knew about.
const $d6b627f40e94434c$var$MY_PRIZE_DRAWS = `
  query MyPrizeDraws {
    myPrizeDraws {
      id wheelCode title subtitle status
      segments { index label kind amount }
      segmentIndex kind amount smartVisits
      whatsappMessages baleMessages smsMessages retry
      balance { balance currency }
      endsAtMs
    }
  }
`;
const $d6b627f40e94434c$export$6ae5916cd240602e = (draws)=>(Array.isArray(draws) ? draws : []).find((d)=>d?.status === 'offered' && Array.isArray(d.segments) && d.segments.length >= 2) || null;
async function $d6b627f40e94434c$export$42f52565954f5175() {
    try {
        const data = await (0, $eVM84.bffQuery)($d6b627f40e94434c$var$MY_PRIZE_DRAWS);
        return $d6b627f40e94434c$export$6ae5916cd240602e(data?.myPrizeDraws);
    } catch  {
        return null; /* the wheel is a bonus; onboarding is not */ 
    }
}
// Which «مشخصات پزشک» this account gets (PM-0061). The doctor BFF answers from
// its own record of the number the account signed in with: a non-Iranian one
// has no کد نظام پزشکی to look up, so that doctor states their identity in a
// form instead.
const $d6b627f40e94434c$var$ONBOARDING_CONTEXT = `
  query OnboardingContext {
    onboardingContext { foreign phone impliedLanguage }
  }
`;
/**
 * The identity step, once it is known which one.
 *
 * The COUNCIL form is what every failure falls back to — a doctor BFF older
 * than this panel, a network error, a number that says nothing. The foreign
 * form is only ever shown on a positive answer — or, under a brand outside the
 * Iranian market (`market: 'intl'`), always: there is no Iranian medical council
 * to look anyone up in, so nobody meets the council form.
 *
 * The language is NOT taken from this answer: the panel already runs in the
 * language the clinic BFF derived from the same number (`myProfile.language`,
 * PM-0060), and two sources for one setting is how they come to disagree.
 */ function $d6b627f40e94434c$var$DoctorIdentity({ onDone: onDone, onSkip: onSkip, disabled: disabled }) {
    // `undefined` while the BFF is being asked; after that always an object.
    const [context, setContext] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(undefined);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        let live = true;
        Promise.resolve().then(()=>(0, $eVM84.bffQuery)($d6b627f40e94434c$var$ONBOARDING_CONTEXT)).then((data)=>data?.onboardingContext || {}).catch(()=>({})).then((ctx)=>{
            if (live) setContext(ctx);
        });
        return ()=>{
            live = false;
        };
    }, []);
    if (context === undefined) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonForm), {
        fields: 2,
        actions: 1,
        "data-testid": "onboarding-doctor-loading"
    });
    return context.foreign || !(0, $eLeza.isIranMarket)() ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5f6389a205aea172$export$2e2bcd8739ae039), {
        phone: context.phone,
        onDone: onDone,
        onSkip: onSkip,
        disabled: disabled
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $41f2ce283a6150ce$export$2e2bcd8739ae039), {
        onDone: onDone,
        onSkip: onSkip,
        disabled: disabled
    });
}
function $d6b627f40e94434c$export$2e2bcd8739ae039({ phase: phase, draw: draw, onIdentityDone: onIdentityDone, onSkip: onSkip, onPrizeDone: onPrizeDone, disabled: disabled }) {
    const { locale: locale } = (0, $e1LEq.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4rEI6.default), {
        language: locale,
        fallback: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            style: {
                display: 'flex',
                justifyContent: 'center',
                padding: '48px 0'
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hZDga.Spinner), {
                size: 20
            })
        }),
        children: phase === 'prize' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9d1389f785a3d0eb$export$2e2bcd8739ae039), {
            draw: draw,
            onDone: onPrizeDone
        }) : /*#__PURE__*/ (0, $ayMG0.jsx)($d6b627f40e94434c$var$DoctorIdentity, {
            onDone: onIdentityDone,
            onSkip: onSkip,
            disabled: disabled
        })
    });
}


/**
 * «تنظیمات پیش‌فرض پارسینا» — what a new clinic starts with when its founder
 * leaves the tick on in the last registration step.
 *
 * One place, because the same values are both APPLIED (the roles are seeded, the
 * founder-doctor's link is written) and SHOWN (the summary under the tick, and
 * the starting point of the editors when the tick is taken off). A default that
 * says one thing and writes another is worse than no default.
 *
 * Every value here is a starting point, never a constraint: the roles are
 * editable in «همکاران ← نقش‌ها», and the hours and visit length in the doctor's
 * row on «همکاران».
 */ var $2188cbd2aa5b5045$exports = {};
$2188cbd2aa5b5045$exports = JSON.parse("{\"source\":\"CLDR 48.0 (ICU 78.2) via scripts/gen-work-week.mjs\",\"weekends\":{\"IR\":[5],\"AF\":[4,5],\"DZ\":[5,6],\"BH\":[5,6],\"EG\":[5,6],\"IN\":[7],\"IQ\":[5,6],\"JO\":[5,6],\"KW\":[5,6],\"LY\":[5,6],\"OM\":[5,6],\"QA\":[5,6],\"SA\":[5,6],\"SD\":[5,6],\"SY\":[5,6],\"YE\":[5,6]}}");


const $3431e62061f78743$export$e72a7d184f34bff8 = 15;
const $3431e62061f78743$export$e185f383cc182376 = [
    0,
    1,
    2,
    3,
    4
];
/** ISO weekday (1 = Monday … 7 = Sunday) → the wire's day index (0 = شنبه … 6 = جمعه). */ const $3431e62061f78743$var$fromIsoWeekday = (iso)=>(iso + 1) % 7;
function $3431e62061f78743$export$195f7ec06aafca89(country) {
    if (country === 'IR') return $3431e62061f78743$export$e185f383cc182376;
    const iso = (0, (/*@__PURE__*/$parcel$interopDefault($2188cbd2aa5b5045$exports))).weekends[country] || [
        6,
        7
    ];
    const weekend = iso.map($3431e62061f78743$var$fromIsoWeekday);
    const lastOff = $3431e62061f78743$var$fromIsoWeekday(Math.max(...iso));
    const days = [];
    for(let i = 1; i <= 7; i += 1){
        const day = (lastOff + i) % 7;
        if (!weekend.includes(day)) days.push(day);
    }
    return days;
}
const $3431e62061f78743$export$4adb2561c0bd3d2a = {
    startTime: '09:00',
    endTime: '18:00'
};
const $3431e62061f78743$export$af7cb0a6aff31a41 = (days = $3431e62061f78743$export$e185f383cc182376)=>days.map((dayOfWeek)=>({
            dayOfWeek: dayOfWeek,
            ...$3431e62061f78743$export$4adb2561c0bd3d2a
        }));
const $3431e62061f78743$export$7de7b62a210b7256 = 'consult-visit';
const $3431e62061f78743$export$e529cc7af34fa780 = 600000;
const $3431e62061f78743$export$559c0bc819e71f53 = ({ priceMinor: priceMinor, durationMinutes: durationMinutes, doctorId: doctorId = null, name: name })=>({
        catalogId: $3431e62061f78743$export$7de7b62a210b7256,
        description: name || "\u0648\u06CC\u0632\u06CC\u062A",
        category: name || "\u0648\u06CC\u0632\u06CC\u062A",
        orderType: 'consultation',
        unitPrice: priceMinor,
        durationMinutes: durationMinutes,
        performerRole: 'doctor',
        schedulingMode: 'TIMED',
        isActive: Boolean(doctorId),
        performers: doctorId ? [
            {
                type: 'DOCTOR',
                id: doctorId,
                isDefault: true
            }
        ] : []
    });
const $3431e62061f78743$export$ac21cf45106f4c98 = (days = $3431e62061f78743$export$e185f383cc182376)=>({
        presences: $3431e62061f78743$export$af7cb0a6aff31a41(days),
        visitDurationMinutes: $3431e62061f78743$export$e72a7d184f34bff8
    });


const $7dbc57fb81650259$export$a2460d16b37e0d91 = 'onboarding.quick.v1';
const $7dbc57fb81650259$export$23a21f8efe49e17f = {
    DOCTOR: 'doctor',
    CLINIC: 'clinic'
};
const $7dbc57fb81650259$export$f9865a0a7f208c15 = {
    DOCTOR: 'doctor',
    CLINIC: 'clinic',
    DEFAULTS: 'defaults',
    LINK: 'link'
};
const $7dbc57fb81650259$var$CREATE_CLINIC = `mutation CreateClinic($input: CreateClinicInput!) {
  createClinic(input: $input) { id name officePhone }
}`;
const $7dbc57fb81650259$var$SEED_ROLES = `mutation SeedClinicRoles($templateKeys: [String!]!) {
  seedClinicRoles(templateKeys: $templateKeys) { id nameFa roleKey }
}`;
const $7dbc57fb81650259$var$DECLARE_VISIT = `mutation SetClinicServiceDeclaration($input: ClinicServiceDeclarationInput!) {
  setClinicServiceDeclaration(input: $input) { id isActive }
}`;
const $7dbc57fb81650259$var$UPDATE_DOCTOR_LINK = `mutation UpdateDoctorLink($id: ID!, $input: UpdateDoctorLinkInput!) {
  updateDoctorLink(id: $id, input: $input) { id visitDurationMinutes }
}`;
function $7dbc57fb81650259$export$3310201397d5aefc() {
    try {
        return JSON.parse(sessionStorage.getItem($7dbc57fb81650259$export$a2460d16b37e0d91) || 'null');
    } catch  {
        return null;
    }
}
function $7dbc57fb81650259$export$3ee6d256957cb557(plan) {
    try {
        sessionStorage.setItem($7dbc57fb81650259$export$a2460d16b37e0d91, JSON.stringify(plan));
    } catch  {}
}
function $7dbc57fb81650259$export$cd8627d153b81d9a() {
    try {
        sessionStorage.removeItem($7dbc57fb81650259$export$a2460d16b37e0d91);
    } catch  {}
}
// i18n-exempt: the clinic's STORED name (invoices, patient messages), written once for an Iranian account — data, not UI copy
const $7dbc57fb81650259$var$OFFICE = "\u0645\u0637\u0628 \u062F\u06A9\u062A\u0631";
// The council sometimes prefixes the name with the title itself.
// i18n-exempt: a title stripped from registry data, never rendered
const $7dbc57fb81650259$var$TITLE = /^\s*(?:دکتر|دكتر|dr\.?)\s+/i;
function $7dbc57fb81650259$export$c1befb4c412448c3(fullName) {
    const name = String(fullName || '').replace($7dbc57fb81650259$var$TITLE, '').trim();
    return name ? `${$7dbc57fb81650259$var$OFFICE} ${name}` : $7dbc57fb81650259$var$OFFICE;
}
function $7dbc57fb81650259$export$3a62894bd56d985a(member) {
    const province = (0, $bMi4A.matchProvince)(member?.province) || (0, $bMi4A.provinceOfCity)(member?.city) || '';
    const city = province && (0, $bMi4A.matchCity)(province, member?.city) || '';
    return {
        province: province,
        city: city
    };
}
/** «ویزیت» at the Parsina price. Iranian accounts only, so always IRR. */ const $7dbc57fb81650259$var$defaultVisit = ()=>({
        priceMinor: (0, $1O6TO.fromDisplay)(String((0, $3431e62061f78743$export$e529cc7af34fa780)), 'IRR'),
        durationMinutes: (0, $3431e62061f78743$export$e72a7d184f34bff8)
    });
// ── The run ──────────────────────────────────────────────────────────────────
let $7dbc57fb81650259$var$run = null;
const $7dbc57fb81650259$var$listeners = new Set();
function $7dbc57fb81650259$var$emit(patch) {
    $7dbc57fb81650259$var$run = {
        ...$7dbc57fb81650259$var$run,
        ...patch
    };
    $7dbc57fb81650259$var$listeners.forEach((fn)=>fn($7dbc57fb81650259$var$run));
}
const $7dbc57fb81650259$export$1fe890d9334e80b9 = ()=>$7dbc57fb81650259$var$run;
function $7dbc57fb81650259$export$c4318b778db87d62(fn) {
    $7dbc57fb81650259$var$listeners.add(fn);
    return ()=>{
        $7dbc57fb81650259$var$listeners.delete(fn);
    };
}
function $7dbc57fb81650259$export$a6263d82821a2a79() {
    $7dbc57fb81650259$var$run = null;
    $7dbc57fb81650259$var$listeners.forEach((fn)=>fn($7dbc57fb81650259$var$run));
}
function $7dbc57fb81650259$export$f162d6628c1629b(deps, opts = {}) {
    if ($7dbc57fb81650259$var$run?.running) return $7dbc57fb81650259$var$run;
    const plan = $7dbc57fb81650259$export$3310201397d5aefc();
    $7dbc57fb81650259$var$run = {
        track: plan?.track || $7dbc57fb81650259$export$23a21f8efe49e17f.CLINIC,
        stage: $7dbc57fb81650259$export$f9865a0a7f208c15.CLINIC,
        running: true,
        done: false,
        error: null,
        ref: '',
        clinicName: plan?.clinicName || '',
        created: false,
        warnings: [],
        draw: null
    };
    $7dbc57fb81650259$var$emit({});
    $7dbc57fb81650259$var$execute(deps, opts).catch((err)=>{
        console.error(`[quickSetup] ${$7dbc57fb81650259$var$run?.stage} failed:`, err?.message || err);
        // `step` tells a clinic that could not be CREATED (nothing exists; retry
        // or go back) from a token that could not be REFRESHED (the clinic exists;
        // retry, or walk on without it as the old wizard allowed).
        $7dbc57fb81650259$var$emit({
            running: false,
            error: {
                stage: $7dbc57fb81650259$var$run?.stage,
                step: $7dbc57fb81650259$var$run?.step,
                err: err
            }
        });
    });
    return $7dbc57fb81650259$var$run;
}
async function $7dbc57fb81650259$var$execute({ memberships: memberships = [], capabilities: capabilities = {}, refreshGrants: refreshGrants, reload: reload, repairSetup: repairSetup }, { skipAccess: skipAccess = false }) {
    let plan = $7dbc57fb81650259$export$3310201397d5aefc();
    if (!plan?.track) throw new Error('no registration plan in this tab');
    const doctor = plan.track === $7dbc57fb81650259$export$23a21f8efe49e17f.DOCTOR;
    const warnings = [
        ...plan.warnings || []
    ];
    const save = (next)=>{
        plan = {
            ...plan,
            ...next
        };
        $7dbc57fb81650259$export$3ee6d256957cb557(plan);
    };
    // ── 1 · The clinic ───────────────────────────────────────────────────────
    $7dbc57fb81650259$var$emit({
        stage: $7dbc57fb81650259$export$f9865a0a7f208c15.CLINIC,
        step: 'create'
    });
    if (!plan.clinicId) {
        const halfBuilt = memberships.find((m)=>m.repairNeeded);
        const founder = memberships.find((m)=>m.isFounder);
        if (halfBuilt) {
            // E1: a half-applied saga is FINISHED, never built again beside itself.
            await repairSetup(halfBuilt.clinicId);
            save({
                clinicId: halfBuilt.clinicId,
                clinicName: halfBuilt.clinicName || plan.clinicName,
                existing: true
            });
        } else if (founder && !capabilities.multiFounder) // One clinic per account here, and this account has it: a doctor who
        // founded it before becoming one is JOINED to it, not refused.
        save({
            clinicId: founder.clinicId,
            clinicName: founder.clinicName || plan.clinicName,
            existing: true
        });
        else {
            const input = {
                name: plan.clinicName,
                clinicType: (0, $iet7t.DEFAULT_CLINIC_TYPE),
                province: plan.province || undefined,
                city: plan.city || undefined
            };
            const created = await (0, $2Mst8.bffMutation)($7dbc57fb81650259$var$CREATE_CLINIC, {
                input: input
            }, 'CreateClinic');
            const id = created?.createClinic?.id;
            if (!id) throw new Error('createClinic answered without an id');
            save({
                clinicId: id,
                clinicName: created.createClinic.name || plan.clinicName,
                created: true
            });
        }
    }
    $7dbc57fb81650259$var$emit({
        clinicName: plan.clinicName,
        created: Boolean(plan.created)
    });
    // The token that can speak for the new clinic. Every call after this one is
    // clinic-scoped, so a stale token here is a 403 on all of them.
    $7dbc57fb81650259$var$emit({
        step: 'access'
    });
    if (!skipAccess) await (0, $58BYB.refreshAccessToken)();
    const list = await refreshGrants();
    const target = (list || []).find((m)=>m.clinicId === plan.clinicId);
    const ref = (0, $ett75.refOf)(target) || plan.clinicId;
    // ── 2 · Parsina's defaults ───────────────────────────────────────────────
    //
    // Only on a clinic THIS run created. An existing clinic has a price for
    // «ویزیت» and the roles its owner chose — re-declaring the defaults over them
    // would undo real decisions.
    $7dbc57fb81650259$var$emit({
        stage: $7dbc57fb81650259$export$f9865a0a7f208c15.DEFAULTS,
        step: 'defaults'
    });
    if (!plan.existing && !plan.defaultsDone) {
        try {
            const catalog = await (0, $2Mst8.bffQuery)((0, $hIlpX.PERMISSION_CATALOG_QUERY), {}, 'PermissionCatalog');
            const keys = (catalog?.roleTemplates || []).map((x)=>x.key);
            if (keys.length) await (0, $2Mst8.bffMutation)($7dbc57fb81650259$var$SEED_ROLES, {
                templateKeys: keys
            }, 'SeedClinicRoles');
        } catch (err) {
            console.error('[quickSetup] seeding roles failed:', err?.message || err);
            warnings.push('roles');
        }
        // Inactive: accounting refuses an active service nobody performs. The
        // join below is what gives it a performer and switches it on.
        let visitDeclared = false;
        try {
            await (0, $2Mst8.bffMutation)($7dbc57fb81650259$var$DECLARE_VISIT, {
                input: (0, $3431e62061f78743$export$559c0bc819e71f53)($7dbc57fb81650259$var$defaultVisit())
            }, 'SetClinicServiceDeclaration');
            visitDeclared = true;
        } catch (err) {
            console.error('[quickSetup] declaring the visit service failed:', err?.message || err);
            warnings.push('visit');
        }
        save({
            defaultsDone: true,
            visitDeclared: visitDeclared,
            warnings: warnings
        });
    }
    // ── 3 · The founder joined to it (doctor only) ───────────────────────────
    if (doctor && !plan.linkDone) {
        $7dbc57fb81650259$var$emit({
            stage: $7dbc57fb81650259$export$f9865a0a7f208c15.LINK,
            step: 'link'
        });
        const link = await (0, $2150cd90b097242b$export$7b2b6afdaa91e33a)(); // never throws
        if (!link) warnings.push('link');
        // Only on the membership of THIS clinic: the join answers with the
        // founder's first owned clinic, and a new clinic's default week written
        // over an older clinic's real one is worse than writing nothing.
        const ownLink = Boolean(link?.id) && link.clinicId === plan.clinicId;
        if (ownLink && !plan.existing) {
            try {
                await (0, $2Mst8.bffMutation)($7dbc57fb81650259$var$UPDATE_DOCTOR_LINK, {
                    id: link.id,
                    input: (0, $3431e62061f78743$export$ac21cf45106f4c98)()
                }, 'UpdateDoctorLink');
            } catch (err) {
                console.error('[quickSetup] updateDoctorLink failed:', err?.message || err);
                warnings.push('hours');
            }
            if (plan.visitDeclared && link.doctorId) try {
                await (0, $2Mst8.bffMutation)($7dbc57fb81650259$var$DECLARE_VISIT, {
                    input: (0, $3431e62061f78743$export$559c0bc819e71f53)({
                        ...$7dbc57fb81650259$var$defaultVisit(),
                        doctorId: link.doctorId
                    })
                }, 'SetClinicServiceDeclaration');
            } catch (err) {
                console.error('[quickSetup] activating the visit service failed:', err?.message || err);
                warnings.push('visit');
            }
        }
        // What the join granted, adopted before entering: without it the desk
        // offers «ثبت پرداخت» alone on the founder's own row until a manual reload.
        if (link) {
            await (0, $58BYB.refreshUntilRole)('doctor');
            try {
                await reload({
                    silent: true
                });
            } catch  {}
        }
        save({
            linkDone: true,
            warnings: warnings
        });
    }
    // A wheel a campaign owes this doctor, asked now that the record it is
    // decided from exists. Never throws; almost always null.
    const draw = doctor ? await (0, $d6b627f40e94434c$export$42f52565954f5175)() : null;
    $7dbc57fb81650259$export$cd8627d153b81d9a();
    $7dbc57fb81650259$var$emit({
        running: false,
        done: true,
        ref: ref,
        warnings: [
            ...new Set(warnings)
        ],
        draw: draw
    });
}


function $a89c64a890bb31ce$export$2e2bcd8739ae039({ disabled: disabled = false }) {
    const { t: t } = (0, $e1LEq.default)();
    const { t: ct } = (0, $LNQP4.default)();
    const navigate = (0, $aphAM.useNavigate)();
    const lookup = (0, $75660ae1ee1fb9c7$export$5e0dc32a83dd8468)(ct);
    const [saving, setSaving] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [saveError, setSaveError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const { member: member } = lookup;
    const clinicName = member ? (0, $7dbc57fb81650259$export$c1befb4c412448c3)(member.fullName) : '';
    const error = saveError || lookup.error;
    const submit = async (e)=>{
        e?.preventDefault?.();
        if (!member || saving || disabled) return;
        setSaving(true);
        setSaveError(null);
        try {
            const doctor = await (0, $75660ae1ee1fb9c7$export$7e64bbacbe004f09)(member);
            if (!doctor?.id) throw new Error(ct('errors.save.doctorProfile'));
            (0, $7dbc57fb81650259$export$3ee6d256957cb557)({
                track: (0, $7dbc57fb81650259$export$23a21f8efe49e17f).DOCTOR,
                clinicName: clinicName,
                doctorName: member.fullName || '',
                specialty: member.specialty || '',
                ...(0, $7dbc57fb81650259$export$3a62894bd56d985a)(member)
            });
            navigate('/onboarding?quick=run');
        } catch (err) {
            setSaveError((0, $75660ae1ee1fb9c7$export$f2d3faa40cc662fc)(err, ct));
            setSaving(false);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
        onSubmit: submit,
        noValidate: true,
        "data-testid": "start-doctor-form",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 12
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        "aria-hidden": "true",
                        style: {
                            width: 44,
                            height: 44,
                            borderRadius: 12,
                            flexShrink: 0,
                            background: (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.1),
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fX0JO.default), {
                            size: 22,
                            color: (0, $jTCZr.C).navy
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        style: {
                            margin: 0,
                            fontSize: '1.25rem',
                            fontWeight: 800,
                            color: (0, $jTCZr.C).textPrimary
                        },
                        children: t('clinic.start.welcome')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                style: {
                    margin: '10px 0 20px',
                    fontSize: '0.8125rem',
                    lineHeight: 1.9,
                    color: (0, $jTCZr.C).textSecondary
                },
                children: t('clinic.start.welcomeBody')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                label: ct('common.labels.medicalCode'),
                required: true,
                value: lookup.code,
                onChange: (e)=>{
                    setSaveError(null);
                    lookup.onChange(e.target.value);
                },
                onBlur: lookup.onBlur,
                inputMode: "numeric",
                autoComplete: "off",
                spellCheck: false,
                autoFocus: true,
                dir: (0, $gVWNP.LTR_TEXT).dir,
                inputStyle: (0, $gVWNP.LTR_TEXT).style,
                disabled: saving || disabled,
                "data-testid": "start-medical-code"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'flex-start',
                    justifyContent: 'space-between',
                    gap: 12,
                    marginTop: 6
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        "aria-live": "polite",
                        "data-testid": "start-lookup-status",
                        style: {
                            flex: 1,
                            minHeight: 18,
                            fontSize: '0.75rem',
                            lineHeight: 1.7,
                            color: (0, $jTCZr.C).textSecondary
                        },
                        children: lookup.looking ? ct('auth.onboarding.lookingUp') : member ? '' : t('clinic.start.autoLookup')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                        variant: "link",
                        type: "button",
                        onClick: ()=>navigate('/onboarding?quick=1'),
                        disabled: saving,
                        "data-testid": "start-not-doctor",
                        style: {
                            height: 'auto',
                            padding: 0,
                            fontWeight: 700
                        },
                        children: t('clinic.start.notDoctor')
                    })
                ]
            }),
            error ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    marginTop: 12,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 8
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                        variant: lookup.retryable && !saveError ? 'warning' : 'error',
                        "data-testid": "start-doctor-error",
                        children: error
                    }),
                    lookup.retryable && !saveError ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                        variant: "outline",
                        type: "button",
                        onClick: lookup.retry,
                        disabled: lookup.looking,
                        "data-testid": "start-lookup-retry",
                        style: {
                            alignSelf: 'flex-start'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aks7U.default), {
                                size: 14,
                                "aria-hidden": "true"
                            }),
                            t('clinic.start.retryLookup')
                        ]
                    }) : null
                ]
            }) : null,
            member ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                "data-testid": "start-council-record",
                style: {
                    marginTop: 14,
                    borderRadius: 12,
                    padding: '14px 16px',
                    border: `1px solid ${(0, $jTCZr.soft)((0, $jTCZr.C).teal, 0.3)}`,
                    background: (0, $jTCZr.soft)((0, $jTCZr.C).teal, 0.06)
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 10
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bfcbc51effea2154$export$2e2bcd8739ae039), {
                                size: 22,
                                color: (0, $jTCZr.C).teal,
                                "aria-hidden": "true",
                                style: {
                                    flexShrink: 0
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    flex: 1,
                                    minWidth: 0
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            fontSize: '0.9375rem',
                                            fontWeight: 800,
                                            color: (0, $jTCZr.C).textPrimary,
                                            lineHeight: 1.6
                                        },
                                        children: member.fullName
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            fontSize: '0.78125rem',
                                            color: (0, $jTCZr.C).textSecondary,
                                            lineHeight: 1.7
                                        },
                                        children: [
                                            member.specialty,
                                            member.city
                                        ].filter(Boolean).join(" \u2014 ")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            height: 1,
                            background: (0, $jTCZr.soft)((0, $jTCZr.C).teal, 0.2),
                            margin: '12px 0 10px'
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8,
                            fontSize: '0.8125rem'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jis86.default), {
                                size: 16,
                                color: (0, $jTCZr.C).textSecondary,
                                "aria-hidden": "true",
                                style: {
                                    flexShrink: 0
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    color: (0, $jTCZr.C).textSecondary
                                },
                                children: t('clinic.start.yourClinic')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                "data-testid": "start-clinic-name",
                                style: {
                                    color: (0, $jTCZr.C).textPrimary,
                                    fontWeight: 800
                                },
                                children: clinicName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: '0.75rem',
                            color: (0, $jTCZr.C).textSecondary,
                            marginTop: 6,
                            lineHeight: 1.8
                        },
                        children: t('clinic.start.completeLater')
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8e54e2ce06aafc96$export$d2cff7ea2eb1dd47), {
                fullWidth: true,
                type: "submit",
                disabled: !member || saving || disabled,
                "data-testid": "start-confirm",
                style: {
                    marginTop: 18
                },
                children: saving ? t('common.state.saving') : t('clinic.start.confirmEnter')
            })
        ]
    });
}



var $drMDV = parcelRequire("drMDV");
function $528774ba5d5aa222$export$2e2bcd8739ae039() {
    const { t: t, locale: locale } = (0, $e1LEq.default)();
    const navigate = (0, $aphAM.useNavigate)();
    const offline = (0, $67626da34750e532$export$effe8bfbb90ac49f)();
    const { state: state, memberships: memberships, enterable: enterable, reload: reload } = (0, $ett75.useClinicContext)();
    // null until the doctor BFF says where the number is from.
    const region = (0, $drMDV.useResolvedAccountRegion)();
    const iranian = Boolean(region) && !region.foreign;
    const [refreshing, setRefreshing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    (0, $ca9da969cb04cd38$export$2e2bcd8739ae039)(t('clinic.start.title'));
    const suspended = memberships.filter((m)=>m.blockedReason === 'SUSPENDED');
    const practitionerOnly = memberships.filter((m)=>m.blockedReason === 'PRACTITIONER_NO_PANEL');
    const hasPending = memberships.some((m)=>m.status === 'INVITED' || m.status === 'REQUESTED');
    const showSections = state === (0, $ett75.BOOT).PENDING_ONLY || hasPending;
    const backTo = enterable[0];
    const refresh = async ()=>{
        setRefreshing(true);
        try {
            await reload({
                silent: true
            });
        } finally{
            setRefreshing(false);
        }
    };
    /* A person who was just added at their clinic's desk should not have to sign
     out and back in to see it. It used to be a translucent button pinned to the
     corner of the gradient, which read as debug chrome; it belongs beside the
     list it refreshes. */ const refreshButton = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
        variant: "ghost",
        onClick: refresh,
        disabled: refreshing || offline,
        "aria-busy": refreshing || undefined,
        "data-testid": "start-refresh",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aks7U.default), {
                size: 14,
                "aria-hidden": "true",
                className: refreshing ? 'parsina-spin' : undefined
            }),
            refreshing ? t('common.state.loading') : t('common.actions.refresh')
        ]
    });
    // A number from abroad: the two ways into the wizard. «من پزشک هستم» first,
    // because it is the SUPERSET — it registers the clinic exactly as the button
    // below does and adds the practitioner before it, so a doctor who picks the
    // shorter path does not end up owning a clinic they are not a practitioner of.
    // The track travels as `?doctor=1` so a reload mid-registration stays on it.
    const wizardWays = /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 10
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 8
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        style: {
                            margin: 0,
                            fontSize: '0.78125rem',
                            fontWeight: 800,
                            color: (0, $jTCZr.C).textPrimary
                        },
                        children: t('clinic.start.waysIn')
                    }),
                    showSections ? null : refreshButton
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8e54e2ce06aafc96$export$d2cff7ea2eb1dd47), {
                fullWidth: true,
                onClick: ()=>navigate('/onboarding?doctor=1'),
                disabled: offline,
                "data-testid": "start-doctor",
                children: t('clinic.start.imDoctor')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8e54e2ce06aafc96$export$d2cff7ea2eb1dd47), {
                secondary: true,
                fullWidth: true,
                onClick: ()=>navigate('/onboarding'),
                disabled: offline,
                "data-testid": "start-create",
                children: t('clinic.start.createClinic')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                variant: "link",
                onClick: ()=>(0, $58BYB.logout)(),
                "data-testid": "start-logout",
                children: t('clinic.start.otherAccount')
            })
        ]
    });
    const signOut = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
        variant: "link",
        onClick: ()=>(0, $58BYB.logout)(),
        "data-testid": "start-logout",
        children: t('clinic.start.otherAccount')
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67626da34750e532$export$2e2bcd8739ae039), {
        width: "md",
        testId: "start",
        title: t('clinic.start.title'),
        subtitle: t('nav.title.clinicPanel'),
        headerEnd: backTo ? /* The kit's `onGradient` treatment, which only `IconButton` carries as
           a variant — this one needs a label beside the arrow, so the
           white-alpha is spelled out with `soft()`. */ /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
            variant: "ghost",
            onClick: ()=>navigate(`/c/${(0, $ett75.refOf)(backTo)}/`),
            style: {
                background: (0, $jTCZr.soft)('#ffffff', 0.16),
                color: '#fff'
            },
            "data-testid": "start-back",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $42KYO.default), {
                    size: 15,
                    "aria-hidden": "true",
                    style: (0, $gVWNP.MIRROR_ICON)
                }),
                t('clinic.gate.goToOther', {
                    name: backTo.clinicName
                })
            ]
        }) : null,
        footer: !region ? null : iranian ? signOut : wizardWays,
        children: [
            region?.foreign ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    marginBottom: 24
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        "aria-hidden": "true",
                        style: {
                            width: 64,
                            height: 64,
                            borderRadius: 16,
                            background: `linear-gradient(135deg, ${(0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.06)}, ${(0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.16)})`,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginBottom: 20
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                            viewBox: "0 0 24 24",
                            fill: (0, $jTCZr.C).navyDark,
                            width: "32",
                            height: "32",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        style: {
                            margin: 0,
                            fontSize: '0.8125rem',
                            color: (0, $jTCZr.C).textSecondary,
                            textAlign: 'center',
                            lineHeight: 1.9,
                            maxWidth: 380
                        },
                        children: hasPending ? t('clinic.start.pendingBody') : t('clinic.start.emptyBody')
                    })
                ]
            }) : null,
            iranian && hasPending ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                style: {
                    margin: `0 0 ${(0, $2xQve.STACK).regular}px`,
                    fontSize: '0.8125rem',
                    color: (0, $jTCZr.C).textSecondary,
                    lineHeight: 1.9
                },
                children: t('clinic.start.pendingBody')
            }) : null,
            suspended.map((m)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                    variant: "warning",
                    style: {
                        marginBottom: (0, $2xQve.STACK).regular
                    },
                    children: t('clinic.start.suspendedAt', {
                        name: m.clinicName
                    })
                }, m.clinicId)),
            practitionerOnly.map((m)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                    variant: "info",
                    style: {
                        marginBottom: (0, $2xQve.STACK).regular
                    },
                    children: t('clinic.start.practitionerAt', {
                        name: m.clinicName
                    })
                }, m.clinicId)),
            showSections ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    marginBottom: iranian ? 24 : 0
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-end',
                            marginBottom: (0, $2xQve.STACK).tight
                        },
                        children: refreshButton
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c3bd3d08bbd0090c$export$2e2bcd8739ae039), {
                        disabled: offline
                    })
                ]
            }) : null,
            !region ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonForm), {
                fields: 1,
                actions: 1,
                "data-testid": "start-loading"
            }) : null,
            iranian ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4rEI6.default), {
                language: locale,
                fallback: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonForm), {
                    fields: 1,
                    actions: 1
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a89c64a890bb31ce$export$2e2bcd8739ae039), {
                    disabled: offline
                })
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "sr-only",
                "aria-live": "polite",
                children: refreshing ? t('common.state.loading') : ''
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");
var $lzNIT = parcelRequire("lzNIT");

var $eLeza = parcelRequire("eLeza");

var $bOJgt = parcelRequire("bOJgt");
var $cxlxT = parcelRequire("cxlxT");
var $1oGgm = parcelRequire("1oGgm");
var $6TdpC = parcelRequire("6TdpC");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $aJ1FU = parcelRequire("aJ1FU");
var $cjPik = parcelRequire("cjPik");
var $5MbI8 = parcelRequire("5MbI8");
var $2tqZa = parcelRequire("2tqZa");
var $6usBW = parcelRequire("6usBW");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");


var $ciRrJ = parcelRequire("ciRrJ");

var $ett75 = parcelRequire("ett75");

var $58BYB = parcelRequire("58BYB");

var $2Mst8 = parcelRequire("2Mst8");

var $aOzet = parcelRequire("aOzet");

var $ikL6D = parcelRequire("ikL6D");


var $eYxJa = parcelRequire("eYxJa");


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");
function $a01dd7430bcac07f$export$2e2bcd8739ae039({ steps: steps = [], current: current, completed: completed, ariaLabel: ariaLabel }) {
    const { formatNumber: formatNumber } = (0, $e1LEq.default)();
    const done = completed instanceof Set ? completed : new Set(completed || []);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("ol", {
        "data-testid": "step-indicator",
        "aria-label": ariaLabel,
        style: {
            listStyle: 'none',
            margin: '0 0 28px',
            padding: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        },
        children: steps.map((step, i)=>{
            const isDone = done.has(step.key);
            const isCurrent = !isDone && step.key === current;
            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                        "aria-current": step.key === current ? 'step' : undefined,
                        style: {
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: 6,
                            minWidth: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                "aria-hidden": "true",
                                style: {
                                    width: 32,
                                    height: 32,
                                    borderRadius: isCurrent ? 8 : '50%',
                                    background: isDone ? (0, $jTCZr.C).green : isCurrent ? (0, $jTCZr.C).navyDark : '#e2e8f0',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    transition: 'all 0.3s'
                                },
                                children: isDone ? /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    viewBox: "0 0 24 24",
                                    fill: "white",
                                    width: "16",
                                    height: "16",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
                                    })
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        fontSize: '0.8125rem',
                                        fontWeight: 700,
                                        color: isCurrent ? 'white' : (0, $jTCZr.C).textMuted
                                    },
                                    children: formatNumber(i + 1)
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                title: step.label,
                                style: {
                                    fontSize: '0.6875rem',
                                    color: isCurrent ? (0, $jTCZr.C).navyDark : isDone ? (0, $jTCZr.C).green : (0, $jTCZr.C).textMuted,
                                    fontWeight: isCurrent ? 700 : 500,
                                    whiteSpace: 'nowrap'
                                },
                                children: step.label
                            })
                        ]
                    }),
                    i < steps.length - 1 ? /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                        role: "presentation",
                        "aria-hidden": "true",
                        style: {
                            flex: 1,
                            height: 3,
                            minWidth: 32,
                            maxWidth: 60,
                            marginBottom: 18,
                            background: isDone ? (0, $jTCZr.C).green : '#e2e8f0',
                            transition: 'background 0.3s'
                        }
                    }) : null
                ]
            }, step.key);
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $huNwV = parcelRequire("huNwV");
var $kcKDu = parcelRequire("kcKDu");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $aJ1FU = parcelRequire("aJ1FU");
var $hZDga = parcelRequire("hZDga");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $2xQve = parcelRequire("2xQve");
function $2fe914cfefd88860$export$2e2bcd8739ae039({ state: state, successTitle: successTitle, onRetry: onRetry, onProceed: onProceed, proceedLabel: proceedLabel, busy: busy = false, testId: testId = 'access-refresh' }) {
    const { t: t } = (0, $e1LEq.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": testId,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: (0, $2xQve.STACK).regular,
            paddingBlock: 8
        },
        children: [
            successTitle ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        "aria-hidden": "true",
                        style: {
                            width: 28,
                            height: 28,
                            borderRadius: 999,
                            flexShrink: 0,
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: (0, $jTCZr.soft)((0, $jTCZr.C).green, 0.14),
                            color: (0, $jTCZr.C).green
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $huNwV.default), {
                            size: 16,
                            strokeWidth: 3
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: '0.875rem',
                            fontWeight: 800,
                            color: (0, $jTCZr.C).textPrimary,
                            minWidth: 0
                        },
                        children: successTitle
                    })
                ]
            }) : null,
            state === 'refreshing' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                "aria-live": "polite",
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10,
                    fontSize: '0.8125rem',
                    color: (0, $jTCZr.C).textSecondary
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hZDga.Spinner), {
                        size: 16
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        children: t('auth.createClinic.refreshing')
                    })
                ]
            }) : null,
            state === 'failed' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                        variant: "error",
                        role: "alert",
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kcKDu.default), {
                            size: 16,
                            "aria-hidden": "true"
                        }),
                        children: t('auth.createClinic.refreshFailed')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            gap: 8,
                            flexWrap: 'wrap'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                                onClick: onRetry,
                                disabled: busy,
                                "aria-busy": busy || undefined,
                                children: [
                                    busy ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hZDga.Spinner), {
                                        size: 14
                                    }) : null,
                                    busy ? t('common.state.saving') : t('common.actions.retry')
                                ]
                            }),
                            onProceed ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                variant: "outline",
                                onClick: onProceed,
                                disabled: busy,
                                children: proceedLabel || t('auth.createClinic.enterWithoutRoles')
                            }) : null
                        ]
                    })
                ]
            }) : null
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $jTCZr = parcelRequire("jTCZr");
function $e78d5ad0755ec3d7$export$2e2bcd8739ae039({ title: title, body: body, children: children, testId: testId = 'onboarding-success' }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": testId,
        role: "status",
        "aria-live": "polite",
        style: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                "aria-hidden": "true",
                style: {
                    width: 72,
                    height: 72,
                    borderRadius: '50%',
                    background: '#E6F5EF',
                    border: '6px solid #D1FAE5',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: 16
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                    viewBox: "0 0 24 24",
                    fill: (0, $jTCZr.C).green,
                    width: "36",
                    height: "36",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    fontSize: '1.1875rem',
                    fontWeight: 800,
                    color: (0, $jTCZr.C).textPrimary,
                    marginBottom: 6,
                    textAlign: 'center'
                },
                children: title
            }),
            body ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    fontSize: '0.75rem',
                    color: (0, $jTCZr.C).textSecondary,
                    marginBottom: 24,
                    textAlign: 'center',
                    lineHeight: 1.8,
                    maxWidth: 320
                },
                children: body
            }) : null,
            children || /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                "aria-hidden": "true",
                style: {
                    display: 'flex',
                    justifyContent: 'center',
                    gap: 10
                },
                children: [
                    0,
                    0.18,
                    0.36
                ].map((delay)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "boot-dot",
                        style: {
                            width: 10,
                            height: 10,
                            borderRadius: '50%',
                            background: (0, $jTCZr.C).navy,
                            animationDelay: `${delay}s`
                        }
                    }, delay))
            })
        ]
    });
}




var $iet7t = parcelRequire("iet7t");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $QG9Z3 = parcelRequire("QG9Z3");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $aJ1FU = parcelRequire("aJ1FU");
var $5AX1S = parcelRequire("5AX1S");
var $fAR2n = parcelRequire("fAR2n");
var $hZDga = parcelRequire("hZDga");
var $a7Rbr = parcelRequire("a7Rbr");
var $k27hS = parcelRequire("k27hS");

var $eLeza = parcelRequire("eLeza");

var $iRTrY = parcelRequire("iRTrY");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("7c6z4");
var $gVWNP = parcelRequire("gVWNP");
var $e1LEq = parcelRequire("e1LEq");

var $2xQve = parcelRequire("2xQve");


var $ciRrJ = parcelRequire("ciRrJ");

var $lT9ri = parcelRequire("lT9ri");

var $jiMFP = parcelRequire("jiMFP");

var $bMi4A = parcelRequire("bMi4A");

var $iet7t = parcelRequire("iet7t");

var $is3AA = parcelRequire("is3AA");
/**
 * Server refusals, mapped to a sentence in the reader's language and — where
 * one exists — a way out.
 *
 * The clinic-creation resolver used to wrap every failure in one Persian
 * string: `new Error('ایجاد کلینیک با خطا مواجه شد')`. Three separate faults
 * arrived through it looking identical — a name the service rejected, a clinic
 * id that already exists, and the accounting service being down — and an
 * English-speaking user read Persian regardless of what they had chosen. None
 * of them could be acted on, so all three became support calls.
 *
 * The BFF now throws a `GraphQLError` carrying `extensions.code`. THIS module
 * owns the copy, because the BFF must not: it serves three languages and a
 * resolver cannot know which one the caller reads.
 *
 * `recovery` names what the screen should offer. It is deliberately a key
 * rather than a component — the same code means different actions on different
 * screens (a duplicate clinic offers «go to your clinic» in the wizard and
 * nothing at all in a background refresh), so the screen decides, and this file
 * only says what kind of way out exists.
 */ const $8d680f6b61d254a4$export$736a71bbf13ce3be = {
    /** Nothing but "try again" — a transient fault. */ RETRY: 'retry',
    /** The name field is wrong; focus it. */ FIELD_NAME: 'field:name',
    /** They already have this clinic; offer to enter it. */ GO_TO_CLINIC: 'go-to-clinic',
    /** A half-applied saga; offer `repairClinicSetup`. */ REPAIR: 'repair',
    /** Their grants are stale; offer the access refresh, not a re-submit. */ REFRESH_ACCESS: 'refresh-access',
    /** Nothing the person can do here. */ NONE: 'none'
};
const $8d680f6b61d254a4$var$CREATE_CLINIC = {
    CLINIC_NAME_INVALID: {
        key: 'errors.clinic.nameInvalid',
        recovery: $8d680f6b61d254a4$export$736a71bbf13ce3be.FIELD_NAME
    },
    CLINIC_ALREADY_EXISTS: {
        key: 'errors.clinic.alreadyExists',
        recovery: $8d680f6b61d254a4$export$736a71bbf13ce3be.GO_TO_CLINIC
    },
    CLINIC_SETUP_INCOMPLETE: {
        key: 'errors.clinic.setupIncomplete',
        recovery: $8d680f6b61d254a4$export$736a71bbf13ce3be.REPAIR
    },
    // Listed although it is the fallback's meaning too: an UNLISTED code shows the
    // server's own sentence, which is Persian whatever language the panel is in.
    CLINIC_CREATE_FAILED: {
        key: 'errors.clinic.createFailed',
        recovery: $8d680f6b61d254a4$export$736a71bbf13ce3be.RETRY
    },
    SERVICE_UNAVAILABLE: {
        key: 'errors.server.unreachable',
        recovery: $8d680f6b61d254a4$export$736a71bbf13ce3be.RETRY
    },
    FORBIDDEN: {
        key: 'errors.access.denied',
        recovery: $8d680f6b61d254a4$export$736a71bbf13ce3be.NONE
    },
    // A currency outside the allow-list (docs/clinic-currency/CONTRACTS.md §1). The
    // picker offers only allowed codes, so this is a stale page, not a typo.
    INVALID_CURRENCY: {
        key: 'errors.currency.invalid',
        recovery: $8d680f6b61d254a4$export$736a71bbf13ce3be.NONE
    },
    // A country that is not an assigned ISO 3166-1 code (PM-0082). Like the
    // currency, the picker offers only real codes, so this is a stale page.
    INVALID_COUNTRY: {
        key: 'errors.country.invalid',
        recovery: $8d680f6b61d254a4$export$736a71bbf13ce3be.NONE
    }
};
const $8d680f6b61d254a4$var$ROLES = {
    ROLE_NAME_INVALID: {
        key: 'errors.roles.nameInvalid',
        recovery: $8d680f6b61d254a4$export$736a71bbf13ce3be.NONE
    },
    // A role that already exists is the retry path working as intended, never an
    // error the person should read. The seeder treats it as success; it is listed
    // so a caller that does surface it says something true.
    ROLE_EXISTS: {
        key: 'errors.roles.exists',
        recovery: $8d680f6b61d254a4$export$736a71bbf13ce3be.NONE
    },
    // The token predates the clinic. Re-running the mutation cannot fix that, and
    // doing so is how the roles step ended up creating duplicates — so this one
    // routes to the access refresh instead of to a retry.
    FORBIDDEN: {
        key: 'errors.access.stale',
        recovery: $8d680f6b61d254a4$export$736a71bbf13ce3be.REFRESH_ACCESS
    },
    SERVICE_UNAVAILABLE: {
        key: 'errors.server.unreachable',
        recovery: $8d680f6b61d254a4$export$736a71bbf13ce3be.RETRY
    }
};
const $8d680f6b61d254a4$var$JOIN = {
    INVITE_INVALID: {
        key: 'errors.invite.notFoundOrExpired',
        recovery: $8d680f6b61d254a4$export$736a71bbf13ce3be.NONE
    },
    ALREADY_MEMBER: {
        key: 'errors.invite.alreadyMember',
        recovery: $8d680f6b61d254a4$export$736a71bbf13ce3be.GO_TO_CLINIC
    },
    ALREADY_REQUESTED: {
        key: 'errors.invite.alreadyRequested',
        recovery: $8d680f6b61d254a4$export$736a71bbf13ce3be.NONE
    },
    SUSPENDED_MEMBER: {
        key: 'errors.invite.suspended',
        recovery: $8d680f6b61d254a4$export$736a71bbf13ce3be.NONE
    },
    // The two halves of the name the invitation page asks for (PM-0453). The page
    // checks them first, so these answer a stale page; the form stays open.
    NAME_REQUIRED: {
        key: 'errors.invite.nameRequired',
        recovery: $8d680f6b61d254a4$export$736a71bbf13ce3be.RETRY
    },
    NAME_TOO_LONG: {
        key: 'errors.invite.nameTooLong',
        recovery: $8d680f6b61d254a4$export$736a71bbf13ce3be.RETRY
    },
    SERVICE_UNAVAILABLE: {
        key: 'errors.server.unreachable',
        recovery: $8d680f6b61d254a4$export$736a71bbf13ce3be.RETRY
    }
};
const $8d680f6b61d254a4$var$TABLES = {
    createClinic: {
        table: $8d680f6b61d254a4$var$CREATE_CLINIC,
        fallback: 'errors.clinic.createFailed'
    },
    roles: {
        table: $8d680f6b61d254a4$var$ROLES,
        fallback: 'errors.roles.seedFailed'
    },
    join: {
        table: $8d680f6b61d254a4$var$JOIN,
        fallback: 'errors.invite.joinFailed'
    }
};
function $8d680f6b61d254a4$export$424a73c529ce205c(err, kind, t) {
    const { table: table, fallback: fallback } = $8d680f6b61d254a4$var$TABLES[kind] || $8d680f6b61d254a4$var$TABLES.createClinic;
    const code = err?.extensions?.code || '';
    const hit = table[code];
    if (hit) return {
        code: code,
        message: t(hit.key),
        recovery: hit.recovery,
        clinicId: err?.extensions?.clinicId || ''
    };
    return {
        code: code,
        message: err?.message || t(fallback),
        recovery: $8d680f6b61d254a4$export$736a71bbf13ce3be.RETRY,
        clinicId: err?.extensions?.clinicId || ''
    };
}
var $8d680f6b61d254a4$export$2e2bcd8739ae039 = $8d680f6b61d254a4$export$424a73c529ce205c;



var $6IjMW = parcelRequire("6IjMW");
var $lHVFz = parcelRequire("lHVFz");

var $a4bLu = parcelRequire("a4bLu");

var $drMDV = parcelRequire("drMDV");
/**
 * Step 1 of registration — «مشخصات کلینیک».
 *
 * ── Why this is a real `<form>` ─────────────────────────────────────────────
 *
 * It was a `<div>` of raw `<input>`s with an `onClick` on the button, which is
 * the shape that makes Enter do nothing. The clinic app's second doctrine
 * (clinic-app/CLAUDE.md §4.2) is that every high-frequency flow has a keyboard
 * path, and while registration is emphatically not high-frequency, it is the
 * first form the owner of a keyboard-driven product ever meets. A form that
 * ignores Enter teaches the wrong thing on the first screen.
 *
 * ── The field set is not arbitrary ──────────────────────────────────────────
 *
 * Only the name is required, and that is deliberate: everything here is
 * editable afterwards in «کلینیک من» (said out loud, under the button), so
 * demanding an address before a person can start is friction with nothing on
 * the other side of it — `clinicType` included, now that `UpdateClinicInput`
 * carries it and the owner can change it in «کلینیک من».
 *
 * `clinicType` is still the answer that matters most, because it is the one the
 * product branches on: it decides which slice of the service catalogue the
 * clinic's «افزودن خدمت» picker leads with. The vocabulary comes from the
 * `clinicTypes` registry the server also validates against, so this picker
 * cannot offer a key the save would refuse — which is exactly what the four
 * uppercase values the wizard once wrote did, and why a clinic registered
 * through it could not declare itself dental at all.
 *
 * ── The phone ───────────────────────────────────────────────────────────────
 *
 * «شماره تلفن کلینیک» is the clinic's OFFICE line and is therefore a LANDLINE —
 * «۰۲۱۸۸…», «۰۶۵…», «۰۳۲…» — so the kit's `PhoneInput` is given
 * `allowLandline`, which drops Iran's mobile pattern and keeps the ten-digit
 * national-number bound that an area code + subscriber number satisfies
 * exactly. The field folds Persian and Arabic-Indic digits itself and hands
 * back E.164 («+982188000000»), which is the one form a dialler and an SMS
 * gateway can both use; a value like «۰۲۱…» on the wire is neither.
 *
 * ── A founder from abroad ───────────────────────────────────────────────────
 *
 * `region.foreign` (their number is not Iranian — accountRegion.js) removes
 * every Iranian default from this step: the office line starts on THEIR
 * country, province and city are typed rather than picked from Iran's list,
 * IRR is not offered, the currency helper does not name Iran, and the map
 * opens on their country instead of Tehran.
 */ /** The office line's country list for a clinic abroad: the kit's, without Iran. */ const $580277ce4df84f5e$var$COUNTRIES_ABROAD = (0, $5AX1S).COUNTRIES.filter((c)=>c.iso2 !== 'IR');
/** Screen order, so «the first invalid field» means the topmost one. */ const $580277ce4df84f5e$var$FIELD_ORDER = [
    'name',
    'officePhone'
];
const $580277ce4df84f5e$var$FIELD_TEST_IDS = {
    name: 'clinic-name',
    officePhone: 'clinic-phone'
};
function $580277ce4df84f5e$export$2e2bcd8739ae039({ form: form, onChange: onChange, onPatch: onPatch, errors: errors, serverError: serverError, onSubmit: onSubmit, onRecover: onRecover, submitting: submitting, disabled: disabled, region: region = {
    foreign: false,
    country: null
} }) {
    const abroad = region.foreign;
    const iranMarket = (0, $eLeza.isIranMarket)();
    const { t: t, locale: locale, formatNumber: formatNumber } = (0, $e1LEq.default)();
    const { isMobile: isMobile } = (0, $k27hS.default)();
    // The clinic-type vocabulary, from the registry the server validates against —
    // or, until/unless it answers, the hook's local copy of it. Never empty.
    const { options: clinicTypeOptions } = (0, $is3AA.useClinicTypes)();
    // Shared with «کلینیک من» (lib/countryOptions.js).
    const countryPickerOptions = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $a4bLu.countryOptions)(locale, form.country), [
        locale,
        form.country
    ]);
    const formRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const alertRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    /**
   * Reach a control by its test id.
   *
   * The kit's inputs are not `forwardRef` — they spread the rest of their props
   * onto the real `<input>`, which is what puts `data-testid` there — so this
   * is how a caller focuses one. It is the pattern «همکاران» already uses for
   * its `F3` search shortcut, kept rather than invented.
   */ const focusField = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((testId)=>{
        formRef.current?.querySelector(`[data-testid="${testId}"]`)?.focus();
    }, []);
    // A server refusal must not be something you scroll to find.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (serverError?.message) alertRef.current?.focus();
    }, [
        serverError
    ]);
    // The first thing that is wrong, focused — in the field ORDER, not in
    // `Object.keys` order, so "the first one" means the first one on screen.
    const firstInvalid = $580277ce4df84f5e$var$FIELD_ORDER.find((f)=>errors?.[f]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (firstInvalid) focusField($580277ce4df84f5e$var$FIELD_TEST_IDS[firstInvalid]);
    }, [
        firstInvalid,
        errors,
        focusField
    ]);
    // Two different reasons a control might be unavailable, and they are NOT the
    // same reason.
    //
    //   `submitting` — a create is in flight. Everything freezes, because the
    //   saga behind it is not re-entrant and a second submit is how a founder
    //   ends up owning two half-built clinics.
    //
    //   `disabled` (offline) — the SUBMIT cannot succeed, but the form is still
    //   worth filling in. Greying out the fields because the network dropped
    //   would throw away what the person has typed the moment a lift or a dead
    //   spot interrupts them; the banner above already explains why the button
    //   will not go.
    const busy = submitting;
    const cannotSubmit = submitting || disabled;
    (0, $ciRrJ.useShortcut)('ctrl+s', ()=>{
        if (!cannotSubmit) formRef.current?.requestSubmit();
    }, {
        label: t('auth.createClinic.submit'),
        group: t('shortcuts.groups.onboarding'),
        enabled: !cannotSubmit
    });
    const errorCount = Object.values(errors || {}).filter(Boolean).length;
    const handleSubmit = (e)=>{
        e.preventDefault();
        if (cannotSubmit) return;
        onSubmit();
    };
    const recoveryActions = ()=>{
        if (!serverError) return null;
        if (serverError.recovery === (0, $8d680f6b61d254a4$export$736a71bbf13ce3be).GO_TO_CLINIC) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
            variant: "outline",
            onClick: ()=>onRecover(serverError),
            children: t('auth.createClinic.goToExisting')
        });
        if (serverError.recovery === (0, $8d680f6b61d254a4$export$736a71bbf13ce3be).REPAIR) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
            variant: "outline",
            onClick: ()=>onRecover(serverError),
            children: t('clinic.gate.repairAction')
        });
        return null;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
        ref: formRef,
        onSubmit: handleSubmit,
        noValidate: true,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8e54e2ce06aafc96$export$9f36deeb77d11846), {
                title: t('auth.steps.details'),
                subtitle: t('auth.createClinic.subtitle')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'grid',
                    // `minmax(0, 1fr)` rather than `1fr`: a track's automatic minimum is
                    // its content, so a long Persian province name in a plain `1fr`
                    // column widens the grid past the card and takes the page into
                    // horizontal scroll. Direction-agnostic — column one is the
                    // inline-start column in Persian and in English alike.
                    gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, minmax(0, 1fr))',
                    gap: 14
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            gridColumn: '1 / -1'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                            label: t('auth.createClinic.nameLabel'),
                            required: true,
                            value: form.name,
                            onChange: (e)=>onChange('name', e.target.value),
                            placeholder: t('auth.createClinic.namePlaceholder'),
                            error: errors.name,
                            maxLength: 120,
                            disabled: busy,
                            "data-testid": "clinic-name",
                            "aria-invalid": errors.name ? 'true' : undefined,
                            "aria-label": t('auth.createClinic.nameLabel'),
                            autoFocus: true
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fAR2n.default), {
                        label: t('auth.createClinic.typeLabel'),
                        value: form.clinicType || (0, $iet7t.DEFAULT_CLINIC_TYPE),
                        options: clinicTypeOptions,
                        placeholder: t('auth.createClinic.typePlaceholder'),
                        onChange: (e)=>onChange('clinicType', e.target.value),
                        helperText: t('auth.createClinic.typeHelperEditable'),
                        disabled: busy,
                        "data-testid": "clinic-type",
                        "aria-label": t('auth.createClinic.typeLabel')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        "data-testid": "clinic-currency",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fAR2n.default), {
                            label: t('clinic.fields.currency'),
                            value: form.currency || (0, $lHVFz.DEFAULT_CURRENCY),
                            options: abroad ? (0, $6IjMW.currencyOptions)(t, locale).filter((o)=>(0, $drMDV.isOfferedAbroad)(o.value) || o.value === form.currency) : (0, $6IjMW.currencyOptions)(t, locale),
                            placeholder: null,
                            onChange: (e)=>onChange('currency', e.target.value),
                            helperText: t(abroad ? 'clinic.currency.createHelperAbroad' : 'clinic.currency.createHelper'),
                            disabled: busy,
                            "aria-label": t('clinic.fields.currency')
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            gridColumn: '1 / -1'
                        },
                        "data-testid": "clinic-country",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fAR2n.default), {
                            label: t('clinic.fields.country'),
                            // Outside the Iranian market an unknown jurisdiction stays EMPTY and
                            // must be chosen (validateClinicDraft): shown as IR, it would be sent
                            // as nothing, and nothing is Iran on the wire.
                            value: form.country || (iranMarket ? (0, $a4bLu.DEFAULT_COUNTRY) : ''),
                            options: countryPickerOptions,
                            placeholder: iranMarket ? null : t('auth.onboarding.foreign.countryPlaceholder'),
                            onChange: (e)=>onChange('country', e.target.value),
                            error: errors.country,
                            helperText: errors.country ? undefined : t('clinic.country.createHelper'),
                            disabled: busy,
                            "aria-label": t('clinic.fields.country')
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iRTrY.default), {
                        label: t('auth.createClinic.phoneLabel'),
                        allowLandline: true,
                        // «۲۱۸۸…» beside «+۹۸», not «۰۲۱۸۸…» — the same spelling «مشخصات کلینیک»
                        // edits it in (see ClinicProfileForm). A typed zero still parses.
                        showTrunk: false,
                        // The kit's own example is Iran's MOBILE one; this field takes an office
                        // line, so it says so. Explicit, because a caller-supplied placeholder is
                        // the only way to override it. From abroad the line is in THEIR country,
                        // and the kit's example for that country beats a Tehran number.
                        defaultCountry: abroad && region.country ? region.country : undefined,
                        countries: abroad ? $580277ce4df84f5e$var$COUNTRIES_ABROAD : undefined,
                        placeholder: abroad ? undefined : t('auth.createClinic.phonePlaceholder'),
                        value: form.officePhone,
                        onChange: (e164, meta)=>onPatch({
                                officePhone: e164,
                                officePhoneDraft: meta.draft
                            }),
                        helperText: errors.officePhone ? undefined : t('auth.createClinic.phoneHelper'),
                        error: errors.officePhone,
                        disabled: busy,
                        "data-testid": "clinic-phone",
                        "aria-label": t('auth.createClinic.phoneLabel')
                    }, abroad ? `abroad-${region.country || ''}` : 'home'),
                    abroad ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                                label: t('auth.createClinic.provinceLabel'),
                                value: form.province,
                                onChange: (e)=>onChange('province', e.target.value),
                                maxLength: 120,
                                dir: "auto",
                                disabled: busy,
                                "data-testid": "clinic-province",
                                "aria-label": t('auth.createClinic.provinceLabel')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                                label: t('auth.createClinic.cityLabel'),
                                value: form.city,
                                onChange: (e)=>onChange('city', e.target.value),
                                maxLength: 120,
                                dir: "auto",
                                disabled: busy,
                                "data-testid": "clinic-city",
                                "aria-label": t('auth.createClinic.cityLabel')
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jiMFP.default), {
                                label: t('auth.createClinic.provinceLabel'),
                                value: form.province,
                                options: (0, $bMi4A.provinceOptions)(form.province, locale),
                                placeholder: t('auth.createClinic.provincePlaceholder'),
                                onChange: (value)=>onPatch({
                                        province: value,
                                        city: ''
                                    }),
                                disabled: busy,
                                testId: "clinic-province"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jiMFP.default), {
                                label: t('auth.createClinic.cityLabel'),
                                value: form.city,
                                options: (0, $bMi4A.cityOptions)(form.province, form.city, locale),
                                placeholder: t('auth.createClinic.cityPlaceholder'),
                                onChange: (value)=>onChange('city', value),
                                disabled: busy || !form.province,
                                helperText: form.province ? undefined : t('auth.createClinic.cityHelper'),
                                testId: "clinic-city"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            gridColumn: '1 / -1'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                            label: t('auth.createClinic.addressLabel'),
                            value: form.address,
                            onChange: (e)=>onChange('address', e.target.value),
                            placeholder: t('auth.createClinic.addressPlaceholder'),
                            maxLength: 300,
                            disabled: busy,
                            "data-testid": "clinic-address",
                            "aria-label": t('auth.createClinic.addressLabel')
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            gridColumn: '1 / -1'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lT9ri.default), {
                            latitude: form.latitude,
                            longitude: form.longitude,
                            abroad: abroad,
                            openAt: abroad ? (0, $drMDV.mapViewForCountry)(region.country) : undefined,
                            onPick: ({ latitude: latitude, longitude: longitude, province: province, city: city, address: address })=>{
                                onPatch({
                                    latitude: latitude,
                                    longitude: longitude,
                                    ...province && {
                                        province: province
                                    },
                                    ...city && {
                                        city: city
                                    },
                                    ...address && {
                                        address: address
                                    }
                                });
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: (0, $2xQve.STACK).regular,
                    marginTop: 20
                },
                children: [
                    errorCount ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                        variant: "warning",
                        role: "alert",
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $QG9Z3.default), {
                            size: 16,
                            "aria-hidden": "true"
                        }),
                        "data-testid": "clinic-form-invalid",
                        children: t('validation.form.fixCount', {
                            count: formatNumber(errorCount)
                        })
                    }) : null,
                    serverError?.message ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        ref: alertRef,
                        tabIndex: -1,
                        style: {
                            outline: 'none'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                            variant: "error",
                            role: "alert",
                            "data-testid": "clinic-form-error",
                            action: recoveryActions(),
                            children: serverError.message
                        })
                    }) : null,
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $8e54e2ce06aafc96$export$d2cff7ea2eb1dd47), {
                        type: "submit",
                        fullWidth: true,
                        disabled: cannotSubmit,
                        "aria-busy": submitting || undefined,
                        "aria-keyshortcuts": "Control+S",
                        "data-testid": "clinic-submit",
                        children: [
                            submitting ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hZDga.Spinner), {
                                size: 16,
                                color: "#fff",
                                label: t('common.state.loading')
                            }) : null,
                            submitting ? t('auth.createClinic.submitting') : t('auth.createClinic.submit'),
                            submitting ? null : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ciRrJ.Kbd), {
                                combo: "ctrl+s"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        style: {
                            margin: 0,
                            fontSize: '0.75rem',
                            color: (0, $jTCZr.C).textMuted,
                            lineHeight: 1.8,
                            textAlign: 'center'
                        },
                        children: t('auth.createClinic.editLater')
                    })
                ]
            })
        ]
    });
}
function $580277ce4df84f5e$export$69453d2bb30eb039(form, t) {
    const errors = {};
    const name = String(form.name || '').trim();
    if (!name) errors.name = t('validation.clinic.nameRequired');
    else if (name.length < 2) errors.name = t('validation.clinic.nameTooShort');
    // Outside the Iranian market the jurisdiction is a choice, never a default:
    // left empty it would travel as nothing, and nothing is Iran (see `country`).
    if (!(0, $eLeza.isIranMarket)() && !form.country) errors.country = t('auth.onboarding.foreign.countryPlaceholder');
    // A value that reached the draft some other way — restored from storage, or a
    // caller building the input directly — is judged by the KIT, not by a local
    // regex. `allowLandline`, because «شماره تلفن کلینیک» is the office line and
    // Iran's mobile pattern would refuse every area code. The local `/^0\d{9,10}$/`
    // it replaces accepted «0218800000» — a Tehran number one digit short — and
    // waved every `+…` string through unread; `isValidPhone` reads both.
    //
    // The fold and the separator strip stay: they shape what goes ON THE WIRE for
    // this legacy path, which is the national spelling the draft carried. The
    // judgement above them is the kit's.
    const phone = (0, $gVWNP.toAsciiDigits)(String(form.officePhone || '')).replace(/[\s-]/g, '');
    const typed = (0, $gVWNP.toAsciiDigits)(String(form.officePhoneDraft ?? '')).replace(/[\s-]/g, '');
    if (phone && !(0, $5AX1S).isValidPhone(phone, {
        allowLandline: true
    })) errors.officePhone = t('validation.phone.invalidLandline');
    else if (!phone && typed) // Something was typed and it is not a number. The field is OPTIONAL, so the
    // dangerous answer is not "invalid" — it is silently sending nothing while
    // the owner believes they gave the clinic's line.
    errors.officePhone = t('validation.phone.invalidLandline');
    // The currency travels only when it is not IRR: absent IS IRR on every BFF, and
    // an older one that has never heard of the field keeps accepting the request.
    const currency = form.currency && form.currency !== (0, $lHVFz.DEFAULT_CURRENCY) ? form.currency : undefined;
    // The country likewise: absent IS IR on the BFF and the service, and an older
    // BFF that has never heard of the field keeps accepting an Iranian clinic.
    const country = form.country && form.country !== (0, $a4bLu.DEFAULT_COUNTRY) ? form.country : undefined;
    const input = {
        name: name,
        clinicType: form.clinicType || (0, $iet7t.DEFAULT_CLINIC_TYPE),
        ...currency ? {
            currency: currency
        } : {},
        ...country ? {
            country: country
        } : {},
        officePhone: phone || undefined,
        province: String(form.province || '').trim() || undefined,
        city: String(form.city || '').trim() || undefined,
        address: String(form.address || '').trim() || undefined,
        latitude: form.latitude ?? undefined,
        longitude: form.longitude ?? undefined
    };
    return {
        errors: errors,
        input: input
    };
}


var $a4bLu = parcelRequire("a4bLu");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $bo0GS = parcelRequire("bo0GS");
var $gyZlE = parcelRequire("gyZlE");
var $kMJsW = parcelRequire("kMJsW");
var $huNwV = parcelRequire("huNwV");
var $QG9Z3 = parcelRequire("QG9Z3");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $9gEOi = parcelRequire("9gEOi");
var $cjPik = parcelRequire("cjPik");
var $2vXUl = parcelRequire("2vXUl");
var $66joL = parcelRequire("66joL");
var $hZDga = parcelRequire("hZDga");
var $k27hS = parcelRequire("k27hS");

var $jTCZr = parcelRequire("jTCZr");

var $eLeza = parcelRequire("eLeza");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $2xQve = parcelRequire("2xQve");


var $ciRrJ = parcelRequire("ciRrJ");

var $2Mst8 = parcelRequire("2Mst8");

var $hIlpX = parcelRequire("hIlpX");

var $ca2To = parcelRequire("ca2To");

var $aE6sf = parcelRequire("aE6sf");

var $cvIOe = parcelRequire("cvIOe");

var $ckJuK = parcelRequire("ckJuK");

var $c2icR = parcelRequire("c2icR");

var $fruhj = parcelRequire("fruhj");
parcelRequire("1O6TO");
var $lHVFz = parcelRequire("lHVFz");


/**
 * The last step of registration — «راه‌اندازی اولیه».
 *
 * ── «تنظیمات پیش‌فرض پارسینا» ────────────────────────────────────────────────
 *
 * The step opens with one tick, ON: every standard role is seeded and, on the
 * doctor track, the founder-doctor gets the default week and visit length
 * (`parsinaDefaults.js`). Taking the tick off opens the same choices as editors
 * — the role tiles, and for a doctor the presence week and the visit length —
 * each starting FROM the defaults, so a founder who wants Thursdays too adds a
 * day rather than building a week from nothing.
 *
 * «ویزیت» is part of the defaults too: the standard visit service, priced at
 * DEFAULT_VISIT_PRICE_TOMAN, or at whatever the founder types with the tick off.
 * This step DECLARES it — clinic-wide, and inactive, because accounting refuses
 * an active service with no performer and nobody performs anything yet.
 *
 * The doctor's settings are only COLLECTED here and handed to `onDone`. They
 * are written by the wizard after the founder is joined to the clinic, because
 * the membership row they live on does not exist until that join has run — and
 * so is the founder's name on «ویزیت», which is what switches it on.
 *
 * ── The roles half ──────────────────────────────────────────────────────────
 *
 * The clinic declares WHICH JOBS EXIST in it at the moment it is created,
 * rather than discovering later that nobody can be given one. The platform
 * ships five role templates (منشی، پرستار، حسابدار، مسئول انبار، مدیر داخلی),
 * each a curated subset of the permission catalog; this step turns the chosen
 * ones into real clinic roles.
 *
 * It runs AFTER the clinic exists and after the token refresh, deliberately:
 * `roleTemplates` and the seeding mutation are both clinic-scoped, and asking
 * for either with a token that predates the clinic is how this 403s on its
 * first real user.
 *
 * ── Partial failure is the state this rewrite exists for ────────────────────
 *
 * The first version fired five sequential `createClinicRole` mutations and
 * reported the set with one boolean. If the third failed, the person saw one
 * error, pressed «ساخت ۵ نقش» again, and created a SECOND «منشی» and a second
 * «پرستار» — each call minted a fresh `roleKey`, so nothing deduplicated them.
 * The clinic then opened with duplicate roles that its owner had to find and
 * delete before hiring anyone.
 *
 * So: each tile carries its own outcome, the seeding mutation is idempotent by
 * template key on the server, and a retry sends only what has not been created.
 * A tile that succeeded is locked — there is nothing left to decide about it.
 *
 * ── Nothing here is mandatory, and now it says what that costs ──────────────
 *
 * «فعلاً نه» was one click from a clinic in which every future hire lands as
 * `ISSUE.NO_ROLES` on «همکاران», and the copy mentioned only that roles are
 * editable later. Skipping is still supported — it is a head start, not a
 * decision the clinic is locked into — but the consequence is now stated, and
 * confirmed, because it is the kind of thing a person only discovers a week
 * later when they try to add their receptionist.
 */ /** The idempotent seeder. Skips a template the clinic already has. */ const $364296aa3ebb7529$var$SEED_ROLES = `mutation SeedClinicRoles($templateKeys: [String!]!) {
  seedClinicRoles(templateKeys: $templateKeys) { id nameFa roleKey }
}`;
/** The per-template fallback, for a BFF that does not yet serve the seeder. */ const $364296aa3ebb7529$var$CREATE_ROLE = `mutation CreateClinicRole($input: ClinicRoleInput!) {
  createClinicRole(input: $input) { id nameFa }
}`;
const $364296aa3ebb7529$var$EXISTING_ROLES = `query ListClinicRoles { listClinicRoles { id nameFa roleKey } }`;
/** «ویزیت» — an upsert keyed on (catalogId, doctorId), so a retry cannot duplicate it. */ const $364296aa3ebb7529$var$DECLARE_VISIT = `mutation SetClinicServiceDeclaration($input: ClinicServiceDeclarationInput!) {
  setClinicServiceDeclaration(input: $input) { id catalogId unitPrice isActive }
}`;
const $364296aa3ebb7529$var$STATUS = {
    IDLE: 'idle',
    PENDING: 'pending',
    DONE: 'done',
    FAILED: 'failed'
};
function $364296aa3ebb7529$export$2e2bcd8739ae039({ onDone: onDone, onStaleAccess: onStaleAccess, disabled: disabled, doctorTrack: doctorTrack = false, currency: currency = (0, $lHVFz.DEFAULT_CURRENCY), presenceDays: presenceDays = (0, $3431e62061f78743$export$e185f383cc182376) }) {
    const { t: t, has: has, formatNumber: formatNumber, formatDigits: formatDigits, formatList: formatList, weekdayNames: weekdayNames, fromDisplayAmount: fromDisplayAmount } = (0, $e1LEq.default)();
    // The default price is a TOMAN figure, so it is a default only for an IRR
    // clinic. Any other currency types its own — 600,000 read as dollars is not a
    // default, it is a mistake the founder would have to notice.
    const irr = currency === (0, $lHVFz.DEFAULT_CURRENCY);
    const { isMobile: isMobile } = (0, $k27hS.default)();
    const [useDefaults, setUseDefaults] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [presences, setPresences] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>(0, $3431e62061f78743$export$af7cb0a6aff31a41)(presenceDays));
    const [duration, setDuration] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(String((0, $3431e62061f78743$export$e72a7d184f34bff8)));
    // In the clinic's DISPLAY units (IRR: toman), as MoneyField reports them.
    const [price, setPrice] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(irr ? String((0, $3431e62061f78743$export$e529cc7af34fa780)) : '');
    // «ویزیت» is written once; a retry after a later failure does not rewrite it.
    const [visitDone, setVisitDone] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [visitFailed, setVisitFailed] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [templates, setTemplates] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [picked, setPicked] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>new Set());
    const [status, setStatus] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({}); // templateKey → STATUS
    const [rowError, setRowError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({}); // templateKey → message
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [loadError, setLoadError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [busy, setBusy] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [confirmSkip, setConfirmSkip] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const alertRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const load = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        setLoading(true);
        setLoadError('');
        let alive = true;
        (0, $2Mst8.bffQuery)((0, $hIlpX.PERMISSION_CATALOG_QUERY), {}, 'PermissionCatalog').then((d)=>{
            if (!alive) return;
            const list = d?.roleTemplates || [];
            setTemplates(list);
            // Everything ticked to begin with: the common case is a clinic that
            // wants the standard set, and unticking two is less work than ticking
            // three. Skipping entirely is still one button away.
            setPicked(new Set(list.map((x)=>x.key)));
        }).catch((e)=>{
            if (!alive) return;
            // A failed load is NOT an empty list (packages/DESIGN.md rule 6). An
            // empty tile grid here would say «your clinic needs no roles», which is
            // both false and unrecoverable.
            const described = (0, $8d680f6b61d254a4$export$424a73c529ce205c)(e, 'roles', t);
            setLoadError(described.message);
            if (described.recovery === (0, $8d680f6b61d254a4$export$736a71bbf13ce3be).REFRESH_ACCESS) onStaleAccess?.();
        }).finally(()=>{
            if (alive) setLoading(false);
        });
        return ()=>{
            alive = false;
        };
    }, [
        t,
        onStaleAccess
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>load(), [
        load
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (error?.message) alertRef.current?.focus();
    }, [
        error
    ]);
    const toggle = (key)=>{
        if (status[key] === $364296aa3ebb7529$var$STATUS.DONE) return; // already created; nothing to decide
        setPicked((prev)=>{
            const next = new Set(prev);
            if (next.has(key)) next.delete(key);
            else next.add(key);
            return next;
        });
    };
    /**
   * Templates still to create: chosen, and not already done. With the defaults
   * on, «chosen» is every template — the tiles are not shown, so a tile
   * unticked before the tick went back on must not quietly drop a role.
   */ const outstanding = templates.filter((x)=>(useDefaults || picked.has(x.key)) && status[x.key] !== $364296aa3ebb7529$var$STATUS.DONE);
    // The doctor's half, when edited by hand. An overlapping or backwards shift
    // is marked on its row by the editor; here it only holds the button, the same
    // way the People drawer refuses the save.
    const durationValue = Number(duration);
    const durationBad = !Number.isInteger(durationValue) || durationValue < (0, $c2icR.DURATION_MIN) || durationValue > (0, $c2icR.DURATION_MAX);
    const hoursBad = Object.keys((0, $ckJuK.presenceIssues)(presences)).length > 0;
    const doctorInvalid = doctorTrack && !useDefaults && (durationBad || hoursBad);
    // «ویزیت» at no price is a service that bills nothing — held like a bad shift.
    // Minor units of the clinic's currency — whole rials for IRR — which is what
    // accounting stores. Asked with the tick on too when there is no default.
    const askPrice = !useDefaults || !irr;
    const visitPriceMinor = fromDisplayAmount(askPrice ? price : String((0, $3431e62061f78743$export$e529cc7af34fa780)), currency) || 0;
    const priceBad = askPrice && !(visitPriceMinor > 0);
    const editsInvalid = doctorInvalid || priceBad;
    const failedCount = templates.filter((x)=>status[x.key] === $364296aa3ebb7529$var$STATUS.FAILED).length;
    const anyDone = templates.some((x)=>status[x.key] === $364296aa3ebb7529$var$STATUS.DONE);
    /**
   * Create the outstanding roles.
   *
   * Prefers the server-side seeder, which is idempotent by template key and
   * needs one round trip. Falls back to per-template creation — reading the
   * clinic's existing roles first, so a retry after a partial failure still
   * cannot duplicate — for a BFF that has not shipped the seeder yet.
   */ const submit = async ()=>{
        if (editsInvalid) return;
        if (!outstanding.length) {
            finish();
            return;
        }
        setBusy(true);
        setError(null);
        setRowError({});
        setStatus((prev)=>{
            const next = {
                ...prev
            };
            outstanding.forEach((x)=>{
                next[x.key] = $364296aa3ebb7529$var$STATUS.PENDING;
            });
            return next;
        });
        try {
            const created = await (0, $2Mst8.bffMutation)($364296aa3ebb7529$var$SEED_ROLES, {
                templateKeys: outstanding.map((x)=>x.key)
            }, 'SeedClinicRoles');
            // The seeder answers with what the clinic HAS, which includes rows a
            // previous attempt already created and this call skipped — so everything
            // asked for is now present, whether this call made it or found it.
            setStatus((prev)=>{
                const next = {
                    ...prev
                };
                outstanding.forEach((x)=>{
                    next[x.key] = $364296aa3ebb7529$var$STATUS.DONE;
                });
                return next;
            });
            setBusy(false);
            finish();
            return;
        } catch (seedErr) {
            // `GRAPHQL_VALIDATION_FAILED` means this BFF predates the seeder; any
            // other code is a real refusal and must not be retried field-by-field.
            const code = seedErr?.extensions?.code || '';
            const unsupported = code === 'GRAPHQL_VALIDATION_FAILED' || /Cannot query field|Unknown (?:type|argument)|seedClinicRoles/i.test(seedErr?.message || '');
            if (!unsupported) {
                const described = (0, $8d680f6b61d254a4$export$424a73c529ce205c)(seedErr, 'roles', t);
                setStatus((prev)=>{
                    const next = {
                        ...prev
                    };
                    outstanding.forEach((x)=>{
                        next[x.key] = $364296aa3ebb7529$var$STATUS.FAILED;
                    });
                    return next;
                });
                setError(described);
                if (described.recovery === (0, $8d680f6b61d254a4$export$736a71bbf13ce3be).REFRESH_ACCESS) onStaleAccess?.();
                setBusy(false);
                return;
            }
        }
        // ── Fallback path ────────────────────────────────────────────────────────
        let existing = new Set();
        try {
            const rows = await (0, $2Mst8.bffQuery)($364296aa3ebb7529$var$EXISTING_ROLES, {}, 'ListClinicRoles');
            existing = new Set((rows?.listClinicRoles || []).map((r)=>String(r.nameFa || '').trim()));
        } catch  {}
        let lastError = null;
        for (const tpl of outstanding){
            if (existing.has(String(tpl.nameFa || '').trim())) {
                setStatus((prev)=>({
                        ...prev,
                        [tpl.key]: $364296aa3ebb7529$var$STATUS.DONE
                    }));
                continue;
            }
            try {
                // Sequential: each role is a Keycloak composite write, and firing them
                // in parallel is how the sync ends up half-applied.
                await (0, $2Mst8.bffMutation)($364296aa3ebb7529$var$CREATE_ROLE, {
                    input: {
                        nameFa: tpl.nameFa,
                        permissions: tpl.permissions
                    }
                }, 'CreateClinicRole');
                setStatus((prev)=>({
                        ...prev,
                        [tpl.key]: $364296aa3ebb7529$var$STATUS.DONE
                    }));
            } catch (e) {
                const described = (0, $8d680f6b61d254a4$export$424a73c529ce205c)(e, 'roles', t);
                lastError = described;
                setStatus((prev)=>({
                        ...prev,
                        [tpl.key]: $364296aa3ebb7529$var$STATUS.FAILED
                    }));
                setRowError((prev)=>({
                        ...prev,
                        [tpl.key]: described.message
                    }));
                if (described.recovery === (0, $8d680f6b61d254a4$export$736a71bbf13ce3be).REFRESH_ACCESS) break;
            }
        }
        setBusy(false);
        if (lastError) {
            setError(lastError);
            if (lastError.recovery === (0, $8d680f6b61d254a4$export$736a71bbf13ce3be).REFRESH_ACCESS) onStaleAccess?.();
            return;
        }
        finish();
    };
    /**
   * Declare «ویزیت», then hand everything to the wizard.
   *
   * Reached from every way out of the step — the primary, «فعلاً نه», and the
   * way past a failed template load — because skipping ROLES is not skipping
   * the visit: a clinic without its visit service cannot bill the first
   * patient, which is a worse surprise than a missing receptionist role.
   * A failure stays on this step with its reason and the same button retries.
   */ const collect = ()=>{
        const doctor = !doctorTrack ? null : useDefaults ? (0, $3431e62061f78743$export$ac21cf45106f4c98)(presenceDays) : {
            presences: (0, $ckJuK.toPresenceInput)(presences),
            visitDurationMinutes: durationValue
        };
        const visit = {
            priceMinor: visitPriceMinor,
            durationMinutes: doctor?.visitDurationMinutes || (0, $3431e62061f78743$export$e72a7d184f34bff8),
            // Stored as the service's name: Persian «ویزیت» in the Iranian market,
            // the panel's own word anywhere else (parsinaDefaults.visitDeclarationInput).
            ...(0, $eLeza.isIranMarket)() ? {} : {
                name: t('common.entity.visit')
            }
        };
        return {
            doctor: doctor,
            visit: visit
        };
    };
    const finish = async ()=>{
        const { doctor: doctor, visit: visit } = collect();
        if (!visitDone) {
            setBusy(true);
            setError(null);
            try {
                await (0, $2Mst8.bffMutation)($364296aa3ebb7529$var$DECLARE_VISIT, {
                    input: (0, $3431e62061f78743$export$559c0bc819e71f53)(visit)
                }, 'SetClinicServiceDeclaration');
                setVisitDone(true);
                setVisitFailed(false);
            } catch (e) {
                setVisitFailed(true);
                const described = (0, $8d680f6b61d254a4$export$424a73c529ce205c)(e, 'roles', t);
                setError({
                    ...described,
                    message: t('auth.setup.visitFailed', {
                        reason: described.message
                    })
                });
                if (described.recovery === (0, $8d680f6b61d254a4$export$736a71bbf13ce3be).REFRESH_ACCESS) onStaleAccess?.();
                setBusy(false);
                return;
            }
            setBusy(false);
        }
        onDone({
            doctor: doctor,
            visit: visit
        });
    };
    /**
   * The way past a visit that would not save. The clinic exists and its owner
   * must be able to reach it — the same rule the failed template load follows —
   * so a failed «ویزیت» offers a retry AND a way on; «کالاها و خدمات» declares
   * it later exactly as this step would have. `visit: null` tells the wizard
   * there is nothing to switch on.
   */ const proceedWithoutVisit = ()=>{
        setError(null);
        onDone({
            doctor: collect().doctor,
            visit: null
        });
    };
    const blocked = busy || loading || disabled || editsInvalid;
    (0, $ciRrJ.useShortcut)('ctrl+s', ()=>{
        if (!blocked) submit();
    }, {
        label: t('auth.roles.confirmShort'),
        group: t('shortcuts.groups.onboarding'),
        enabled: !blocked
    });
    const primaryLabel = ()=>{
        if (busy) return t('common.state.saving');
        if (failedCount) return t('auth.roles.retryFailed', {
            count: formatNumber(failedCount)
        });
        if (useDefaults) return t('auth.setup.apply');
        if (!outstanding.length) return t('auth.roles.continueNone');
        return t('auth.roles.confirm', {
            count: formatNumber(outstanding.length)
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: (0, $2xQve.STACK).regular
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8e54e2ce06aafc96$export$9f36deeb77d11846), {
                id: "setup-heading",
                title: t('auth.setup.title'),
                subtitle: t('auth.setup.explainer')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9gEOi.default), {
                checked: useDefaults,
                onChange: ()=>setUseDefaults((v)=>!v),
                disabled: busy || disabled,
                "data-testid": "setup-use-defaults",
                style: {
                    padding: '12px 14px',
                    borderRadius: (0, $jTCZr.RADIUS).card,
                    minHeight: 44,
                    background: useDefaults ? (0, $jTCZr.soft)((0, $jTCZr.C).teal, 0.06) : (0, $jTCZr.C).card,
                    border: `1.5px solid ${useDefaults ? (0, $jTCZr.C).teal : (0, $jTCZr.C).border}`
                },
                label: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    style: {
                        display: 'block',
                        minWidth: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            style: {
                                display: 'block',
                                fontSize: '0.84375rem',
                                fontWeight: 700,
                                color: (0, $jTCZr.C).textPrimary
                            },
                            children: t('auth.setup.useDefaults')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            style: {
                                display: 'block',
                                fontSize: '0.71875rem',
                                color: (0, $jTCZr.C).textMuted,
                                marginTop: 2
                            },
                            children: t(useDefaults ? 'auth.setup.useDefaultsOnHint' : 'auth.setup.useDefaultsOffHint')
                        })
                    ]
                })
            }),
            useDefaults && !loadError ? /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                "data-testid": "setup-defaults-summary",
                style: {
                    listStyle: 'none',
                    margin: 0,
                    padding: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: (0, $2xQve.STACK).tight
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($364296aa3ebb7529$var$SummaryLine, {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bo0GS.default), {
                            size: 15,
                            color: (0, $jTCZr.C).teal,
                            "aria-hidden": "true"
                        }),
                        children: loading ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonText), {
                            width: "60%",
                            height: 11
                        }) : t('auth.setup.summary.roles', {
                            names: formatList(templates.map((tpl)=>(0, $ca2To.roleTemplateLabel)(tpl, t, has)))
                        })
                    }),
                    irr ? /*#__PURE__*/ (0, $ayMG0.jsx)($364296aa3ebb7529$var$SummaryLine, {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gyZlE.default), {
                            size: 15,
                            color: (0, $jTCZr.C).teal,
                            "aria-hidden": "true"
                        }),
                        children: t('auth.setup.summary.visit', {
                            price: formatNumber((0, $3431e62061f78743$export$e529cc7af34fa780))
                        })
                    }) : null,
                    doctorTrack ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($364296aa3ebb7529$var$SummaryLine, {
                                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kMJsW.default), {
                                    size: 15,
                                    color: (0, $jTCZr.C).teal,
                                    "aria-hidden": "true"
                                }),
                                children: t('auth.setup.summary.hours', {
                                    fromDay: weekdayNames()[presenceDays[0]],
                                    toDay: weekdayNames()[presenceDays[presenceDays.length - 1]],
                                    start: formatDigits((0, $3431e62061f78743$export$4adb2561c0bd3d2a).startTime),
                                    end: formatDigits((0, $3431e62061f78743$export$4adb2561c0bd3d2a).endTime)
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($364296aa3ebb7529$var$SummaryLine, {
                                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kMJsW.default), {
                                    size: 15,
                                    color: (0, $jTCZr.C).teal,
                                    "aria-hidden": "true"
                                }),
                                children: t('auth.setup.summary.duration', {
                                    minutes: formatNumber((0, $3431e62061f78743$export$e72a7d184f34bff8))
                                })
                            })
                        ]
                    }) : null
                ]
            }) : null,
            !useDefaults && !loadError ? /*#__PURE__*/ (0, $ayMG0.jsx)($364296aa3ebb7529$var$SectionHeading, {
                id: "roles-heading",
                title: t('auth.roles.title'),
                subtitle: t('auth.roles.explainer')
            }) : null,
            loading && !useDefaults ? // Kept as role-card-shaped blocks rather than a `SkeletonList`: a role
            // card is a bordered 2-up tile with a name and a caption, and a list
            // row is neither. Announced once for the whole grid.
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonRegion), {
                label: t('common.state.loading'),
                style: {
                    display: 'grid',
                    gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, minmax(0, 1fr))',
                    gap: 10
                },
                "data-testid": "roles-loading",
                children: [
                    0,
                    1,
                    2,
                    3,
                    4
                ].map((i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            border: `1.5px solid ${(0, $jTCZr.C).border}`,
                            borderRadius: (0, $jTCZr.RADIUS).card,
                            padding: '12px 14px',
                            minHeight: 44,
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 6,
                            justifyContent: 'center'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonText), {
                                width: "55%",
                                height: 13
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonText), {
                                width: "35%",
                                height: 10
                            })
                        ]
                    }, i))
            }) : null,
            !loading && loadError ? /* «بارگذاری مجدد», not «تلاش مجدد». When the load failed because the
           token is stale, the wizard is ALSO showing an access-refresh offer
           above this — and two buttons reading «تلاش مجدد» that do different
           things is worse than either of them alone. This one reloads the list;
           that one re-adopts the grants. */ /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2vXUl.default), {
                title: t('errors.roles.loadFailedTitle'),
                description: loadError,
                onRetry: load,
                retryLabel: t('common.actions.reload')
            }) : null,
            !loading && !loadError && !useDefaults ? /*#__PURE__*/ (0, $ayMG0.jsx)("fieldset", {
                style: {
                    border: 0,
                    margin: 0,
                    padding: 0,
                    minWidth: 0
                },
                "aria-labelledby": "roles-heading",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        display: 'grid',
                        gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, minmax(0, 1fr))',
                        gap: 10
                    },
                    children: templates.map((tpl)=>{
                        const on = picked.has(tpl.key);
                        const state = status[tpl.key] || $364296aa3ebb7529$var$STATUS.IDLE;
                        const done = state === $364296aa3ebb7529$var$STATUS.DONE;
                        const failed = state === $364296aa3ebb7529$var$STATUS.FAILED;
                        return(/* The kit `Checkbox` IS the tile. It renders a native <label>
                   wrapping one Radix control and forwards `className`/rest onto
                   that label, which is exactly the "picker row" shape its own
                   docstring describes.

                   The previous version wrapped it in an outer <button> and hid
                   the control with `tabIndex={-1}`: a button inside a button,
                   announced twice, with the checked state invisible to
                   assistive tech. Wrapping it in a <label> instead would have
                   been the same mistake in a second costume — nested labels —
                   so the tile is the checkbox rather than a container for it. */ /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9gEOi.default), {
                            checked: on,
                            onChange: ()=>toggle(tpl.key),
                            disabled: done || blocked,
                            "data-testid": `role-tile-${tpl.key}`,
                            "data-state": state,
                            style: {
                                padding: '12px 14px',
                                borderRadius: (0, $jTCZr.RADIUS).card,
                                minHeight: 44,
                                minWidth: 0,
                                background: failed ? (0, $jTCZr.soft)((0, $jTCZr.C).red, 0.05) : on ? (0, $jTCZr.soft)((0, $jTCZr.C).navy, 0.05) : (0, $jTCZr.C).card,
                                border: `1.5px solid ${failed ? (0, $jTCZr.C).red : on ? (0, $jTCZr.C).navy : (0, $jTCZr.C).border}`,
                                transition: 'border-color .15s, background .15s',
                                opacity: done ? 0.75 : 1
                            },
                            label: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 10,
                                    flex: 1,
                                    minWidth: 0
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        style: {
                                            flex: 1,
                                            minWidth: 0
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    display: 'block',
                                                    fontSize: '0.84375rem',
                                                    fontWeight: 700,
                                                    color: (0, $jTCZr.C).textPrimary,
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap'
                                                },
                                                children: (0, $ca2To.roleTemplateLabel)(tpl, t, has)
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    display: 'block',
                                                    fontSize: '0.71875rem',
                                                    color: failed ? (0, $jTCZr.C).red : (0, $jTCZr.C).textMuted,
                                                    marginTop: 2
                                                },
                                                children: failed ? rowError[tpl.key] || t('auth.roles.status.failed') : done ? t('auth.roles.status.done') : t('people.defaultRoles.permissionCount', {
                                                    count: formatNumber(tpl.permissions.length)
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        "aria-hidden": "true",
                                        style: {
                                            flexShrink: 0,
                                            display: 'inline-flex'
                                        },
                                        children: [
                                            state === $364296aa3ebb7529$var$STATUS.PENDING ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hZDga.Spinner), {
                                                size: 14,
                                                label: t('common.state.loading')
                                            }) : null,
                                            done ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $huNwV.default), {
                                                size: 16,
                                                color: (0, $jTCZr.C).green
                                            }) : null,
                                            failed ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $QG9Z3.default), {
                                                size: 16,
                                                color: (0, $jTCZr.C).red
                                            }) : null
                                        ]
                                    })
                                ]
                            })
                        }, tpl.key));
                    })
                })
            }) : null,
            !loading && !loadError && !useDefaults ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        style: {
                            margin: 0,
                            fontSize: '0.75rem',
                            color: (0, $jTCZr.C).textMuted,
                            lineHeight: 1.8
                        },
                        children: t('auth.roles.changeableLater')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                        variant: "warning",
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $QG9Z3.default), {
                            size: 15,
                            "aria-hidden": "true"
                        }),
                        children: t('auth.roles.skipWarning')
                    })
                ]
            }) : null,
            askPrice ? /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                "aria-labelledby": "visit-heading",
                "data-testid": "setup-visit",
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: (0, $2xQve.STACK).tight
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($364296aa3ebb7529$var$SectionHeading, {
                        id: "visit-heading",
                        title: t('auth.setup.visitTitle'),
                        subtitle: t('auth.setup.visitHint')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fruhj.MoneyField), {
                        testid: "setup-visit-price",
                        currency: currency,
                        label: t('auth.setup.visitPrice'),
                        value: price,
                        onChange: setPrice,
                        disabled: busy || disabled || visitDone,
                        error: priceBad ? t('auth.setup.visitPriceRequired') : ''
                    })
                ]
            }) : null,
            doctorTrack && !useDefaults ? /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                "aria-label": t('auth.setup.hoursTitle'),
                "data-testid": "setup-doctor-hours",
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: (0, $2xQve.STACK).regular
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aE6sf.default), {
                        value: presences,
                        onChange: setPresences,
                        disabled: busy || disabled
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cvIOe.default), {
                        value: duration,
                        onChange: setDuration,
                        disabled: busy || disabled
                    })
                ]
            }) : null,
            error?.message ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                ref: alertRef,
                tabIndex: -1,
                style: {
                    outline: 'none'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                    variant: "error",
                    role: "alert",
                    "data-testid": "roles-error",
                    children: error.message
                })
            }) : null,
            visitFailed && !busy ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8e54e2ce06aafc96$export$d2cff7ea2eb1dd47), {
                secondary: true,
                onClick: proceedWithoutVisit,
                "data-testid": "setup-skip-visit",
                children: t('auth.setup.continueWithoutVisit')
            }) : null,
            !loadError ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    gap: 10,
                    marginTop: 4,
                    flexWrap: 'wrap'
                },
                children: [
                    !useDefaults || anyDone ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8e54e2ce06aafc96$export$d2cff7ea2eb1dd47), {
                        secondary: true,
                        onClick: ()=>anyDone ? finish() : setConfirmSkip(true),
                        disabled: busy || disabled || editsInvalid,
                        "data-testid": "roles-skip",
                        children: anyDone ? t('common.actions.continue') : t('auth.roles.skip')
                    }) : null,
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $8e54e2ce06aafc96$export$d2cff7ea2eb1dd47), {
                        onClick: submit,
                        disabled: blocked,
                        "aria-busy": busy || undefined,
                        "aria-keyshortcuts": "Control+S",
                        "data-testid": "roles-submit",
                        style: {
                            flex: 1,
                            minWidth: 200
                        },
                        children: [
                            busy ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hZDga.Spinner), {
                                size: 14,
                                color: "#fff",
                                label: t('common.state.loading')
                            }) : null,
                            primaryLabel(),
                            busy ? null : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ciRrJ.Kbd), {
                                combo: "ctrl+s"
                            })
                        ]
                    })
                ]
            }) : // Even when the templates cannot be read, the clinic exists and its
            // owner must be able to reach it. A load failure here must never be a
            // wall between a person and the panel they just created.
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8e54e2ce06aafc96$export$d2cff7ea2eb1dd47), {
                secondary: true,
                onClick: finish,
                "data-testid": "roles-skip",
                children: t('auth.roles.skip')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjPik.default), {
                open: confirmSkip,
                onOpenChange: setConfirmSkip,
                title: t('auth.roles.skipConfirmTitle'),
                description: t('auth.roles.skipWarning'),
                confirmLabel: t('auth.roles.skip'),
                cancelLabel: t('common.actions.cancel'),
                onConfirm: ()=>{
                    setConfirmSkip(false);
                    finish();
                }
            })
        ]
    });
}
/** A heading INSIDE the step — one level below the step's own `StepHeading`. */ function $364296aa3ebb7529$var$SectionHeading({ id: id, title: title, subtitle: subtitle }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                id: id,
                style: {
                    margin: '0 0 2px',
                    fontSize: '0.84375rem',
                    fontWeight: 700,
                    color: (0, $jTCZr.C).textPrimary
                },
                children: title
            }),
            subtitle ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    fontSize: '0.75rem',
                    color: (0, $jTCZr.C).textSecondary,
                    lineHeight: 1.8
                },
                children: subtitle
            }) : null
        ]
    });
}
/** One line of what the defaults will write. */ function $364296aa3ebb7529$var$SummaryLine({ icon: icon, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            fontSize: '0.78125rem',
            color: (0, $jTCZr.C).textSecondary,
            lineHeight: 1.8
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                style: {
                    flexShrink: 0,
                    display: 'inline-flex'
                },
                children: icon
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                style: {
                    flex: 1,
                    minWidth: 0
                },
                children: children
            })
        ]
    });
}




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $huNwV = parcelRequire("huNwV");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $aJ1FU = parcelRequire("aJ1FU");
var $hZDga = parcelRequire("hZDga");
var $6usBW = parcelRequire("6usBW");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $ett75 = parcelRequire("ett75");



var $eYxJa = parcelRequire("eYxJa");


/**
 * «در حال آماده‌سازی پنل شما» — the run in quickSetup.js, drawn.
 *
 * Nothing on this screen asks for anything. It lists what is being done, in
 * order, and enters the clinic by itself when the last step is through. The
 * only controls are for a step that failed: the clinic could not be created
 * (try again, or go back), or the token could not be refreshed (try again, or
 * walk on — the clinic exists and the gate has states for a stale token).
 *
 * The steps after the clinic exists never stop the run. A role or «ویزیت» that
 * did not save is said once, on the way in, and is one screen away to fix.
 */ const $5c915477cc2d020f$var$STEP_ORDER = {
    [(0, $7dbc57fb81650259$export$23a21f8efe49e17f).DOCTOR]: [
        (0, $7dbc57fb81650259$export$f9865a0a7f208c15).DOCTOR,
        (0, $7dbc57fb81650259$export$f9865a0a7f208c15).CLINIC,
        (0, $7dbc57fb81650259$export$f9865a0a7f208c15).DEFAULTS,
        (0, $7dbc57fb81650259$export$f9865a0a7f208c15).LINK
    ],
    [(0, $7dbc57fb81650259$export$23a21f8efe49e17f).CLINIC]: [
        (0, $7dbc57fb81650259$export$f9865a0a7f208c15).CLINIC,
        (0, $7dbc57fb81650259$export$f9865a0a7f208c15).DEFAULTS
    ]
};
function $5c915477cc2d020f$var$StepIcon({ state: state }) {
    if (state === 'done') return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        style: {
            width: 26,
            height: 26,
            borderRadius: '50%',
            background: (0, $jTCZr.soft)((0, $jTCZr.C).teal, 0.14),
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $huNwV.default), {
            size: 15,
            strokeWidth: 3,
            color: (0, $jTCZr.C).teal,
            "aria-hidden": "true"
        })
    });
    if (state === 'running') return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hZDga.Spinner), {
        size: 20
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        style: {
            width: 18,
            height: 18,
            borderRadius: '50%',
            boxSizing: 'border-box',
            border: `2px solid ${state === 'failed' ? (0, $jTCZr.C).red : (0, $jTCZr.C).border}`
        }
    });
}
function $5c915477cc2d020f$export$2e2bcd8739ae039() {
    const { t: t } = (0, $e1LEq.default)();
    const navigate = (0, $aphAM.useNavigate)();
    const toast = (0, $6usBW.useToast)();
    const { memberships: memberships, capabilities: capabilities, refreshGrants: refreshGrants, reload: reload, repairSetup: repairSetup, defaultRef: defaultRef } = (0, $ett75.useClinicContext)();
    // The plan as «شروع» left it — read once, for the labels. The run clears it
    // when it finishes, and the labels must not vanish a moment before entering.
    const [plan] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState((0, $7dbc57fb81650259$export$3310201397d5aefc));
    const [run, setRun] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState((0, $7dbc57fb81650259$export$1fe890d9334e80b9));
    const [prizeShown, setPrizeShown] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>(0, $7dbc57fb81650259$export$c4318b778db87d62)(setRun), []);
    const start = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((opts)=>{
        (0, $7dbc57fb81650259$export$f162d6628c1629b)({
            memberships: memberships,
            capabilities: capabilities,
            refreshGrants: refreshGrants,
            reload: reload,
            repairSetup: repairSetup
        }, opts);
    }, [
        memberships,
        capabilities,
        refreshGrants,
        reload,
        repairSetup
    ]);
    // Join the run in flight — this screen is remounted mid-run (quickSetup.js) —
    // or start it. With neither a run nor a plan there is nothing to resume: a
    // reload after the run ended lands in the clinic it built.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if ((0, $7dbc57fb81650259$export$1fe890d9334e80b9)()) return;
        if (!(0, $7dbc57fb81650259$export$3310201397d5aefc)()) {
            navigate(defaultRef ? `/c/${defaultRef}/` : '/start', {
                replace: true
            });
            return;
        }
        start();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    const enter = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        const finished = (0, $7dbc57fb81650259$export$1fe890d9334e80b9)();
        if (!finished?.done) return;
        (0, $7dbc57fb81650259$export$a6263d82821a2a79)(); // first, so a second call finds nothing to do
        if (finished.created) toast?.success?.(t('auth.createClinic.created', {
            name: finished.clinicName
        }));
        if (finished.warnings.length) toast?.info?.(t('clinic.quickSetup.partial'));
        // «اشتراک» rather than the home, for someone who came to buy (lib/purchaseIntent.js).
        navigate((0, $eYxJa.clinicEntryPath)(finished.ref), {
            replace: true
        });
    }, [
        navigate,
        t,
        toast
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (run?.done && !run.draw) enter();
    }, [
        run,
        enter
    ]);
    const track = run?.track || plan?.track || (0, $7dbc57fb81650259$export$23a21f8efe49e17f).CLINIC;
    const abandon = ()=>{
        (0, $7dbc57fb81650259$export$a6263d82821a2a79)();
        (0, $7dbc57fb81650259$export$cd8627d153b81d9a)();
        navigate(track === (0, $7dbc57fb81650259$export$23a21f8efe49e17f).DOCTOR ? '/start' : '/onboarding?quick=1', {
            replace: true
        });
    };
    // ── The wheel, when a campaign owes one ──────────────────────────────────
    if (run?.done && run.draw) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d6b627f40e94434c$export$2e2bcd8739ae039), {
        phase: "prize",
        draw: run.draw,
        onPrizeDone: ()=>{
            setPrizeShown(true);
            enter();
        },
        disabled: prizeShown
    });
    const order = $5c915477cc2d020f$var$STEP_ORDER[track] || $5c915477cc2d020f$var$STEP_ORDER[(0, $7dbc57fb81650259$export$23a21f8efe49e17f).CLINIC];
    const at = run?.done ? order.length : Math.max(order.indexOf(run?.stage), 0);
    const failed = Boolean(run?.error);
    const clinicName = run?.clinicName || plan?.clinicName || '';
    const detail = {
        [(0, $7dbc57fb81650259$export$f9865a0a7f208c15).DOCTOR]: [
            plan?.doctorName,
            plan?.specialty
        ].filter(Boolean).join(" \u2014 "),
        [(0, $7dbc57fb81650259$export$f9865a0a7f208c15).CLINIC]: clinicName ? `\xab${clinicName}\xbb` : '',
        [(0, $7dbc57fb81650259$export$f9865a0a7f208c15).DEFAULTS]: t(track === (0, $7dbc57fb81650259$export$23a21f8efe49e17f).DOCTOR ? 'clinic.quickSetup.details.defaultsDoctor' : 'clinic.quickSetup.details.defaultsClinic'),
        [(0, $7dbc57fb81650259$export$f9865a0a7f208c15).LINK]: t('clinic.quickSetup.details.link')
    };
    const steps = order.map((key, i)=>{
        // The doctor's record was written on «شروع», before this screen opened.
        let state = 'waiting';
        if (key === (0, $7dbc57fb81650259$export$f9865a0a7f208c15).DOCTOR || i < at) state = 'done';
        else if (i === at) state = failed ? 'failed' : 'running';
        return {
            key: key,
            state: state,
            label: t(`clinic.quickSetup.steps.${key}`),
            detail: detail[key]
        };
    });
    // What failed, and which ways out it has.
    const createFailed = failed && run.error.step === 'create';
    const accessFailed = failed && run.error.step === 'access';
    const message = !failed ? '' : createFailed ? (0, $8d680f6b61d254a4$export$424a73c529ce205c)(run.error.err, 'createClinic', t).message : accessFailed ? t('auth.createClinic.refreshFailed') : run.error.err?.message || t('errors.save.generic');
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-testid": "quick-setup",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8e54e2ce06aafc96$export$9f36deeb77d11846), {
                title: t('clinic.quickSetup.title'),
                subtitle: t('clinic.quickSetup.body')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("ol", {
                style: {
                    listStyle: 'none',
                    margin: 0,
                    padding: 0
                },
                "aria-label": t('clinic.quickSetup.title'),
                children: steps.map((s)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                        "data-testid": `quick-step-${s.key}`,
                        "data-state": s.state,
                        style: {
                            display: 'flex',
                            gap: 12,
                            alignItems: 'flex-start',
                            padding: '11px 0',
                            borderBottom: `1px solid ${(0, $jTCZr.C).border}`
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    width: 26,
                                    height: 26,
                                    flexShrink: 0,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($5c915477cc2d020f$var$StepIcon, {
                                    state: s.state
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                style: {
                                    flex: 1,
                                    minWidth: 0
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            display: 'block',
                                            fontSize: '0.84375rem',
                                            fontWeight: 700,
                                            lineHeight: 1.7,
                                            color: s.state === 'waiting' ? (0, $jTCZr.C).textSecondary : (0, $jTCZr.C).textPrimary
                                        },
                                        children: s.label
                                    }),
                                    s.detail ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            display: 'block',
                                            fontSize: '0.75rem',
                                            color: (0, $jTCZr.C).textSecondary,
                                            lineHeight: 1.7
                                        },
                                        children: s.detail
                                    }) : null
                                ]
                            })
                        ]
                    }, s.key))
            }),
            failed ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    marginTop: 16,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 10
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                        variant: "error",
                        "data-testid": "quick-setup-error",
                        children: message
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            gap: 10,
                            flexWrap: 'wrap'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                onClick: ()=>start(),
                                "data-testid": "quick-setup-retry",
                                children: t('common.actions.retry')
                            }),
                            accessFailed ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                variant: "outline",
                                onClick: ()=>start({
                                        skipAccess: true
                                    }),
                                "data-testid": "quick-setup-proceed",
                                children: t('auth.createClinic.continueAnyway')
                            }) : null,
                            createFailed ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                                variant: "outline",
                                onClick: abandon,
                                "data-testid": "quick-setup-back",
                                children: t('common.actions.back')
                            }) : null
                        ]
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "sr-only",
                "aria-live": "polite",
                children: failed ? message : steps.find((s)=>s.state === 'running')?.label || ''
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");
parcelRequire("5N0ZI");
var $aJ1FU = parcelRequire("aJ1FU");
var $a7Rbr = parcelRequire("a7Rbr");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");


function $7f759a25bea3679c$export$2e2bcd8739ae039({ disabled: disabled = false }) {
    const { t: t } = (0, $e1LEq.default)();
    const navigate = (0, $aphAM.useNavigate)();
    const [name, setName] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const submit = (e)=>{
        e?.preventDefault?.();
        if (disabled) return;
        const trimmed = name.trim();
        if (!trimmed) {
            setError(t('validation.clinic.nameRequired'));
            return;
        }
        if (trimmed.length < 2) {
            setError(t('validation.clinic.nameTooShort'));
            return;
        }
        (0, $7dbc57fb81650259$export$3ee6d256957cb557)({
            track: (0, $7dbc57fb81650259$export$23a21f8efe49e17f).CLINIC,
            clinicName: trimmed
        });
        navigate('/onboarding?quick=run', {
            replace: true
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
        onSubmit: submit,
        noValidate: true,
        "data-testid": "quick-clinic-name",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8e54e2ce06aafc96$export$9f36deeb77d11846), {
                title: t('clinic.quickSetup.nameTitle'),
                subtitle: t('clinic.quickSetup.nameBody')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 16
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                        label: t('auth.createClinic.nameLabel'),
                        required: true,
                        value: name,
                        onChange: (e)=>{
                            setName(e.target.value);
                            setError('');
                        },
                        placeholder: t('auth.createClinic.namePlaceholder'),
                        helperText: error ? undefined : t('clinic.quickSetup.nameHelper'),
                        error: error || undefined,
                        maxLength: 120,
                        autoFocus: true,
                        autoComplete: "off",
                        disabled: disabled,
                        "data-testid": "quick-clinic-name-input"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8e54e2ce06aafc96$export$d2cff7ea2eb1dd47), {
                        fullWidth: true,
                        type: "submit",
                        disabled: disabled,
                        "data-testid": "quick-clinic-name-submit",
                        children: t('clinic.quickSetup.nameSubmit')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                        variant: "link",
                        type: "button",
                        onClick: ()=>navigate('/start'),
                        "data-testid": "quick-clinic-name-back",
                        children: t('common.actions.back')
                    })
                ]
            })
        ]
    });
}





var $drMDV = parcelRequire("drMDV");
/**
 * «ثبت کلینیک جدید» — clinic registration, in two steps.
 *
 * This screen used to live inside `App.jsx` as a three-hundred-line component
 * next to the router. Moving it out is not tidying: while it was there it had
 * no test seam, it was invisible to the per-screen i18n checks, and every
 * primitive in it was hand-rolled because reaching for the kit from the router
 * file felt like the wrong shape. The screen is where the screen belongs.
 *
 * ── The two steps, and why the second cannot be first ───────────────────────
 *
 * A clinic declares WHICH JOBS EXIST in it at the moment it is created, instead
 * of discovering weeks later that there is no role to give the receptionist it
 * just hired. But both of the roles step's calls are clinic-scoped, so the
 * clinic — and the token that can speak for it — must exist first. That is the
 * whole reason the token refresh between them is a visible step rather than a
 * swallowed `try/catch`: it is load-bearing, and when it fails the roles step
 * is guaranteed to 403.
 *
 * ── `?quick=` — registration with nothing to fill in (Iranian accounts) ─────
 *
 * `?quick=run` is the run «شروع» hands over to once it knows who this is
 * (quickSetup.js): it builds the clinic, applies Parsina's defaults and, for a
 * doctor, joins them to it — and enters. `?quick=1` is «پزشک نیستم»: the
 * clinic's name, then the same run. Neither touches the wizard below, which is
 * still what the switcher's «افزودن کلینیک» and a number from abroad get.
 *
 * ── Surviving a reload (E8) ─────────────────────────────────────────────────
 *
 * Phase is component state, so a refresh on step two used to drop the person
 * back onto an empty registration form for a clinic that already existed —
 * where the only button submits, and submitting collides on the primary key.
 * A breadcrumb in `sessionStorage` puts them back on the roles step instead.
 * `sessionStorage` rather than `localStorage` deliberately: it is scoped to
 * this tab and dies with it, which is right for a crumb whose whole purpose is
 * to survive one accidental reload.
 */ const $7e995a1f07376a6e$var$RESUME_KEY = 'onboarding.pendingRoles.v1';
/** Step 3's choices onto the crumb: from here on a remount finishes, never re-asks (PM-0195). */ function $7e995a1f07376a6e$var$rememberSetup(setup) {
    try {
        const crumb = JSON.parse(sessionStorage.getItem($7e995a1f07376a6e$var$RESUME_KEY) || 'null');
        if (crumb?.clinicId) sessionStorage.setItem($7e995a1f07376a6e$var$RESUME_KEY, JSON.stringify({
            ...crumb,
            setup: setup
        }));
    } catch  {}
}
const $7e995a1f07376a6e$var$PHASE = {
    /** «من پزشک هستم» — the نظام پزشکی lookup, before any clinic exists. */ DOCTOR: 'doctor',
    /** The wheel a campaign owes this doctor, when it owes one. */ PRIZE: 'prize',
    /** The practitioner record exists; adopting the `doctor` role it granted. */ DOCTOR_ADOPTING: 'doctor-adopting',
    /** The form. */ DETAILS: 'details',
    /** The clinic exists; adopting the grants that came with it. */ ADOPTING: 'adopting',
    /** Choosing which roles the clinic has. */ ROLES: 'roles',
    /** Roles done; adopting those grants before entering. */ ENTERING: 'entering',
    /** Doctor track only — joining the founder to the clinic they just built. */ LINKING: 'linking',
    /** Doctor track only — both halves are done and the way in is a button. */ DONE: 'done'
};
const $7e995a1f07376a6e$var$CREATE_CLINIC = `mutation CreateClinic($input: CreateClinicInput!) {
  createClinic(input: $input) { id name officePhone }
}`;
/** The founder's own sign-in number — what preselects the clinic's country. */ const $7e995a1f07376a6e$var$MY_PHONE = `query MyPhone { myProfile { phone } }`;
/**
 * The founder-doctor's hours and visit length, written on the membership the
 * join just created or found. Same mutation as the doctor's row on «همکاران».
 */ const $7e995a1f07376a6e$var$UPDATE_DOCTOR_LINK = `mutation UpdateDoctorLink($id: ID!, $input: UpdateDoctorLinkInput!) {
  updateDoctorLink(id: $id, input: $input) { id visitDurationMinutes }
}`;
/** «ویزیت», re-declared under the founder-doctor — which is what switches it on. */ const $7e995a1f07376a6e$var$DECLARE_VISIT = `mutation SetClinicServiceDeclaration($input: ClinicServiceDeclarationInput!) {
  setClinicServiceDeclaration(input: $input) { id isActive }
}`;
const $7e995a1f07376a6e$var$emptyDraft = (currency = 'IRR', country = (0, $a4bLu.DEFAULT_COUNTRY))=>({
        name: '',
        clinicType: (0, $iet7t.DEFAULT_CLINIC_TYPE),
        currency: // The clinic's books, IRR unless the founder picks otherwise (CONTRACTS §7) —
        // or, for a founder whose number is from abroad, their country's currency.
        currency,
        country: // The clinic's jurisdiction (PM-0082). IR until the founder's own number
        // suggests otherwise — see `suggestedCountry` below.
        country,
        officePhone: '',
        province: '',
        city: '',
        address: '',
        latitude: null,
        longitude: null
    });
function $7e995a1f07376a6e$export$2e2bcd8739ae039({ onSuccess: onSuccess }) {
    const { t: t } = (0, $e1LEq.default)();
    const navigate = (0, $aphAM.useNavigate)();
    const [params] = (0, $lzNIT.useSearchParams)();
    const toast = (0, $6usBW.useToast)();
    const offline = (0, $67626da34750e532$export$effe8bfbb90ac49f)();
    const { memberships: memberships, enterable: enterable, capabilities: capabilities, refreshGrants: refreshGrants, repairSetup: repairSetup, defaultRef: defaultRef, reload: reload } = (0, $ett75.useClinicContext)();
    // Creating a clinic is an ADDITION, never a replacement (design §2.7/§5.4.1).
    // Knowing whether this person already has one changes two things: the wizard
    // offers a way back instead of reading like being logged out of the clinic
    // they were just in, and the copy says «افزودن» rather than «ایجاد».
    const isAdditional = enterable.length > 0;
    const founderRow = memberships.find((m)=>m.isFounder);
    const halfBuilt = memberships.find((m)=>m.repairNeeded);
    // ── «من پزشک هستم» ───────────────────────────────────────────────────────
    //
    // The doctor track is a QUERY PARAMETER, not a guess. Nothing in a token
    // minted for a fresh phone-number account says «doctor» — that role is
    // granted BY the step below, so reading it from the token would mean the
    // track could only ever be offered to someone who no longer needs it. The
    // «شروع» screen asks, and the answer travels in the URL so a reload during
    // registration stays on the track the person chose.
    //
    // It is not authorization either: `completeOnboardingStep1` refuses a council
    // number that سازمان نظام پزشکی does not hold, whoever asks. The parameter
    // decides which screens are shown, never who may be a doctor.
    const askedAsDoctor = params.get('doctor') === '1';
    const quick = params.get('quick');
    const [doctorTrack, setDoctorTrack] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(askedAsDoctor);
    const [phase, setPhase] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>askedAsDoctor ? $7e995a1f07376a6e$var$PHASE.DOCTOR : $7e995a1f07376a6e$var$PHASE.DETAILS);
    const [draw, setDraw] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [createdId, setCreatedId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [createdName, setCreatedName] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    // Under a brand outside the Iranian market (`market: 'intl'`) nothing in the
    // wizard starts Iranian: the currency starts where a founder from an unknown
    // country starts (USD, never IRR) and the jurisdiction starts EMPTY, to be
    // filled from the founder's number or chosen — the wire reads an absent
    // currency as IRR and an absent country as Iran, so neither may be left at
    // the Iranian default by accident.
    const iranMarket = (0, $eLeza.isIranMarket)();
    const initialCurrency = iranMarket ? 'IRR' : (0, $drMDV.currencyForCountry)(null);
    const initialCountry = iranMarket ? (0, $a4bLu.DEFAULT_COUNTRY) : '';
    const [form, setForm] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>$7e995a1f07376a6e$var$emptyDraft(initialCurrency, initialCountry));
    const [errors, setErrors] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({});
    const [serverError, setServerError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [submitting, setSubmitting] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [adoptFailed, setAdoptFailed] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [confirmLeave, setConfirmLeave] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [repairing, setRepairing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // Doctor track only. `linkFailed` is reported on the closing card rather than
    // thrown, and `enterRef` is the clinic that card's button walks into — held
    // because that button is a user gesture, and the gesture is what the new tab
    // for the doctor panel needs (a `window.open` after an await is blocked).
    const [linkFailed, setLinkFailed] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [enterRef, setEnterRef] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    // What the last step chose: the founder's own hours (doctor track) and what
    // «ویزیت» was declared with. A ref, not state, because it is read by
    // `finishDoctorTrack`, which is reached from three different handlers and
    // must see the latest choice.
    const setupRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const [setupFailed, setSetupFailed] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [visitFailed, setVisitFailed] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    (0, $ca9da969cb04cd38$export$2e2bcd8739ae039)(t(isAdditional ? 'clinic.start.addClinicTitle' : 'auth.createClinic.title'));
    // E8 — a reload during the roles step lands back on the roles step, not on a
    // form that can only fail.
    //
    // Only a screen still BEFORE the clinic resumes (PM-0195). This runs on every
    // memberships re-read, and the wizard makes those itself after step 3 — the
    // grants refresh, then the access re-read after the join — while the doctor
    // track keeps the crumb until its closing card's button. Unguarded, each one
    // put the founder back on a fresh step 3 (for a non-IRR clinic: an EMPTY,
    // required price), so «اعمال تنظیمات» looped although every write had landed.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (quick === 'run' || phase !== $7e995a1f07376a6e$var$PHASE.DOCTOR && phase !== $7e995a1f07376a6e$var$PHASE.DETAILS) return;
        let crumb = null;
        try {
            crumb = JSON.parse(sessionStorage.getItem($7e995a1f07376a6e$var$RESUME_KEY) || 'null');
        } catch  {}
        if (!crumb?.clinicId) return;
        const still = memberships.find((m)=>m.clinicId === crumb.clinicId);
        if (!still) return; // the clinic went away; the crumb is stale
        setCreatedId(crumb.clinicId);
        setCreatedName(crumb.clinicName || still.clinicName || '');
        // The crumb also carries the track. A doctor who reloads on the roles step
        // must still be joined to their clinic at the end of it — without this the
        // reload silently demotes them to the plain track and `enterPanelWith-
        // OwnedClinic` never runs, which is the one step nothing later repairs.
        if (crumb.doctorTrack) setDoctorTrack(true);
        // Step 3 already succeeded in this tab (its choices ride on the crumb): a
        // remount finishes the flow — every step of it idempotent — and never asks
        // for step 3 again.
        if (crumb.setup) {
            setupRef.current = crumb.setup;
            const ref = (0, $ett75.refOf)(still) || still.clinicId;
            if (crumb.doctorTrack) finishDoctorTrack(ref, still.clinicId);
            else enter(ref);
            return;
        }
        setPhase($7e995a1f07376a6e$var$PHASE.ROLES);
    }, [
        memberships
    ]); // eslint-disable-line react-hooks/exhaustive-deps -- reads the phase it runs in, re-runs only on a re-read
    // ── The clinic's country, from the founder's own number (PM-0082) ───────
    //
    // Decided 2026-10-04: preselected from the number the founder signed in
    // with. `myProfile.phone` is that number as Keycloak holds it — never typed
    // here. A number that names no country (national form, none, a failed read)
    // leaves IR. Only an UNTOUCHED field follows the answer: a founder who picked
    // a country before it arrived keeps their pick.
    //
    // The suggestion is also the baseline the leave-guard compares against, so
    // the preselection alone never counts as an unsaved edit.
    const [suggestedCountry, setSuggestedCountry] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(initialCountry);
    const countryTouched = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        let alive = true;
        (0, $2Mst8.bffQuery)($7e995a1f07376a6e$var$MY_PHONE).then((data)=>{
            const iso = (0, $aOzet.countryForPhone)(data?.myProfile?.phone)?.iso2;
            // Outside the Iranian market a +98 number does not make a clinic Iranian.
            if (!alive || !iso || !iranMarket && iso === 'IR') return;
            setSuggestedCountry(iso);
            if (!countryTouched.current) setForm((prev)=>({
                    ...prev,
                    country: iso
                }));
        }).catch(()=>{});
        return ()=>{
            alive = false;
        };
    }, []);
    // A number from abroad: no Iranian defaults anywhere in the wizard (PM-0061).
    // The currency is seeded once the answer arrives, and only over the IRR
    // default — never over a choice the founder already made.
    const region = (0, $drMDV.useAccountRegion)();
    const homeCurrency = region.foreign ? (0, $drMDV.currencyForCountry)(region.country) : 'IRR';
    const presenceDays = region.foreign ? (0, $3431e62061f78743$export$195f7ec06aafca89)(region.country) : (0, $3431e62061f78743$export$e185f383cc182376);
    // «پزشک نیستم» — the clinic's name and nothing else. Only ever linked from an
    // Iranian «شروع»; a number from abroad that arrives here anyway gets the form.
    const quickName = quick === '1' && !doctorTrack && !region.foreign;
    // "Over the IRR default" is, precisely, over whatever was last seeded: IRR the
    // one time it happens for an Iranian-market brand, and under `market: 'intl'`
    // the USD it starts on, followed by the founder's own once their country is
    // known (IQ → IQD) — never over a currency the founder picked.
    const seededCurrency = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(initialCurrency);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!region.foreign) return;
        const seeded = seededCurrency.current;
        seededCurrency.current = homeCurrency;
        setForm((prev)=>prev.currency === seeded ? {
                ...prev,
                currency: homeCurrency
            } : prev);
    }, [
        region.foreign,
        homeCurrency
    ]);
    // …and the jurisdiction (PM-0082) is the founder's country too: the same
    // number, read by the account, when `myProfile.phone` above has not answered.
    // An untouched field only, exactly like the currency.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!region.foreign || !region.country) return;
        setSuggestedCountry((prev)=>prev === initialCountry ? region.country : prev);
        if (!countryTouched.current) setForm((prev)=>prev.country === initialCountry ? {
                ...prev,
                country: region.country
            } : prev);
    }, [
        region.foreign,
        region.country
    ]);
    const dirty = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>Object.entries({
            ...$7e995a1f07376a6e$var$emptyDraft(homeCurrency),
            country: suggestedCountry
        }).some(([k, v])=>form[k] !== v), [
        form,
        homeCurrency,
        suggestedCountry
    ]);
    const setField = (key, val)=>{
        if (key === 'country') countryTouched.current = true;
        setForm((prev)=>({
                ...prev,
                [key]: val
            }));
        setErrors((prev)=>prev[key] ? {
                ...prev,
                [key]: ''
            } : prev);
        setServerError(null);
    };
    const patch = (next)=>{
        setForm((prev)=>({
                ...prev,
                ...next
            }));
        setServerError(null);
    };
    // Back to the clinic they CAME FROM. `defaultRef` is the remembered last clinic,
    // which for someone who opened this from the switcher is the one they were just
    // in; `enterable[0]` is merely the first in display order, and for the owner of
    // several clinics that is often a different one.
    const leave = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        const back = defaultRef || (0, $ett75.refOf)(enterable[0]);
        navigate(back ? `/c/${back}/` : '/start', {
            replace: true
        });
    }, [
        enterable,
        defaultRef,
        navigate
    ]);
    const requestLeave = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        // Never mid-run: by the time the run's clinic exists the person counts as
        // «additional», and leaving would strand a clinic with no roles or visit.
        if (!isAdditional || phase !== $7e995a1f07376a6e$var$PHASE.DETAILS || submitting || quick === 'run') return;
        if (dirty) {
            setConfirmLeave(true);
            return;
        }
        leave();
    }, [
        isAdditional,
        phase,
        submitting,
        quick,
        dirty,
        leave
    ]);
    // `Esc` closes the wizard the same way the ✕ does — including the unsaved
    // guard. Withheld once the clinic exists: there is nothing left to abandon.
    (0, $ciRrJ.useShortcut)('esc', requestLeave, {
        label: t('common.actions.cancel'),
        group: t('shortcuts.groups.onboarding'),
        enabled: isAdditional && phase === $7e995a1f07376a6e$var$PHASE.DETAILS && !submitting && quick !== 'run'
    });
    /**
   * Doctor track only — run the join, then stop on the closing card.
   *
   * Deliberately reachable from BOTH ways the wizard can reach its end: the
   * ordinary one, and «ادامه بدون به‌روزرسانی» after a failed grants refresh.
   * It used to hang off the first alone, so proceeding past a refresh failure
   * entered the clinic and skipped the join — leaving exactly the founder-who-
   * is-not-a-practitioner this whole track exists to prevent, and leaving it
   * silently, on the one path where something had already gone wrong.
   */ const finishDoctorTrack = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (ref, clinicId)=>{
        setAdoptFailed(false);
        setPhase($7e995a1f07376a6e$var$PHASE.LINKING);
        const link = await (0, $2150cd90b097242b$export$7b2b6afdaa91e33a)();
        setLinkFailed(!link);
        // ── The founder's hours, now that there is a membership to hold them ──
        //
        // Only on the link for the clinic just CREATED. The join answers with the
        // founder's first owned clinic, which for a founder of several is not
        // necessarily this one — and writing a new clinic's default week over an
        // older clinic's real one is the one outcome worse than writing nothing.
        //
        // Like the join, it cannot fail the flow: the closing card says so and
        // points at «همکاران», where the same two fields live.
        const { doctor: doctor, visit: visit } = setupRef.current || {};
        const ownLink = Boolean(link?.id) && link.clinicId === clinicId;
        let wrote = !doctor;
        if (doctor && ownLink) try {
            await (0, $2Mst8.bffMutation)($7e995a1f07376a6e$var$UPDATE_DOCTOR_LINK, {
                id: link.id,
                input: doctor
            }, 'UpdateDoctorLink');
            wrote = true;
        } catch (err) {
            console.error('[onboarding] updateDoctorLink failed:', err?.message || err);
        }
        // A failed join already has its own line; this one is about the hours.
        setSetupFailed(Boolean(link) && !wrote);
        // ── «ویزیت», now that it has somebody to perform it ──────────────────
        //
        // The step declared it inactive because accounting refuses an active
        // service nobody performs. The founder is a performer only once joined, so
        // this is where it is switched on — same row (the upsert is keyed on the
        // catalogue id), same price, the founder as its default performer. Same
        // guard as the hours: never on another clinic's membership.
        let activated = !visit;
        if (visit && ownLink && link.doctorId) try {
            await (0, $2Mst8.bffMutation)($7e995a1f07376a6e$var$DECLARE_VISIT, {
                input: (0, $3431e62061f78743$export$559c0bc819e71f53)({
                    ...visit,
                    doctorId: link.doctorId
                })
            }, 'SetClinicServiceDeclaration');
            activated = true;
        } catch (err) {
            console.error('[onboarding] activating the visit service failed:', err?.message || err);
        }
        setVisitFailed(Boolean(link) && !activated);
        // ── What the join granted, adopted before the way in is offered ──────
        //
        // The join is what makes the founder a practitioner HERE: an accepted
        // clinic_doctors row, and the `doctor` role, which it awaits rather than
        // fires and forgets. The panel read its access before the join ran, so
        // `myAccess.practitionerId` — the one thing that offers «شروع ویزیت» on the
        // founder's own row in پذیرش — came back empty. Entering the clinic does
        // not ask again, because that answer was already for this clinic
        // (ClinicContext re-resolves only when the route names a DIFFERENT one), so
        // the desk offered «ثبت پرداخت» alone until a manual reload. So: refresh
        // until the token carries the role (briefly — see refreshUntilRole), then
        // read access again, both before the closing card's button can be pressed.
        // Neither may fail the flow; the clinic is built and enterable already.
        if (link) {
            await (0, $58BYB.refreshUntilRole)('doctor');
            try {
                await reload({
                    silent: true
                });
            } catch  {}
        }
        setEnterRef(ref);
        setPhase($7e995a1f07376a6e$var$PHASE.DONE);
    }, [
        reload
    ]);
    /** Adopt the grants written by the step just completed, then move on. */ const adopt = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (nextPhase, clinicId)=>{
        setAdoptFailed(false);
        setPhase(nextPhase);
        try {
            if (nextPhase === $7e995a1f07376a6e$var$PHASE.ADOPTING) await (0, $58BYB.refreshAccessToken)();
            const list = await refreshGrants();
            if (nextPhase === $7e995a1f07376a6e$var$PHASE.ADOPTING) {
                setPhase($7e995a1f07376a6e$var$PHASE.ROLES);
                return;
            }
            const target = (list || []).find((m)=>m.clinicId === clinicId);
            const ref = (0, $ett75.refOf)(target) || clinicId;
            // ── The join, and why it is HERE ────────────────────────────────────
            //
            // Last, because it is the only step that needs both halves to exist: the
            // practitioner record from the doctor step and the clinic from this one.
            // After the grants refresh, because it is a doctor-BFF call made with
            // this token and the founder's roles have only just been written.
            //
            // It cannot fail the flow. The clinic is built and enterable by now, so a
            // doctorpreference write that did not land is a reason to say so and
            // offer the retry on the next screen — never a reason to hold a founder
            // out of their own reception desk.
            if (doctorTrack) {
                await finishDoctorTrack(ref, clinicId);
                return;
            }
            enter(ref);
        } catch  {
            setAdoptFailed(true);
        }
    }, [
        refreshGrants,
        doctorTrack,
        finishDoctorTrack
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    // Into the clinic — on «اشتراک» instead of its home when this person came from
    // a landing site's «خرید اشتراک» (lib/purchaseIntent.js).
    const enter = (ref)=>{
        try {
            sessionStorage.removeItem($7e995a1f07376a6e$var$RESUME_KEY);
        } catch  {}
        onSuccess?.(createdId);
        navigate((0, $eYxJa.clinicEntryPath)(ref), {
            replace: true
        });
    };
    const submitDetails = async ()=>{
        const { errors: found, input: input } = (0, $580277ce4df84f5e$export$69453d2bb30eb039)(form, t);
        if (Object.keys(found).length) {
            setErrors(found);
            return;
        }
        setErrors({});
        setSubmitting(true);
        setServerError(null);
        try {
            const created = await (0, $2Mst8.bffMutation)($7e995a1f07376a6e$var$CREATE_CLINIC, {
                input: input
            }, 'CreateClinic');
            const id = created?.createClinic?.id || '';
            const name = created?.createClinic?.name || input.name;
            setCreatedId(id);
            setCreatedName(name);
            try {
                sessionStorage.setItem($7e995a1f07376a6e$var$RESUME_KEY, JSON.stringify({
                    clinicId: id,
                    clinicName: name,
                    doctorTrack: doctorTrack
                }));
            } catch  {}
            toast?.success?.(t('auth.createClinic.created', {
                name: name
            }));
            setSubmitting(false);
            adopt($7e995a1f07376a6e$var$PHASE.ADOPTING, id);
        } catch (err) {
            setServerError((0, $8d680f6b61d254a4$export$424a73c529ce205c)(err, 'createClinic', t));
            setSubmitting(false);
        }
    };
    /** The way out a coded refusal offers. */ const recover = async (described)=>{
        if (described.recovery === (0, $8d680f6b61d254a4$export$736a71bbf13ce3be).GO_TO_CLINIC) {
            // The refusal names the clinic they already have; go THERE, not merely back.
            const named = described.clinicId && memberships.find((m)=>m.clinicId === described.clinicId);
            if (named?.enterable) {
                navigate(`/c/${(0, $ett75.refOf)(named)}/`, {
                    replace: true
                });
                return;
            }
            leave();
            return;
        }
        if (described.recovery === (0, $8d680f6b61d254a4$export$736a71bbf13ce3be).REPAIR && described.clinicId) {
            setRepairing(true);
            try {
                await repairSetup(described.clinicId);
                enter(described.clinicId);
            } catch (err) {
                setServerError((0, $8d680f6b61d254a4$export$424a73c529ce205c)(err, 'createClinic', t));
            } finally{
                setRepairing(false);
            }
        }
    };
    // ── The doctor step's handlers ──────────────────────────────────────────
    /**
   * Adopt the `doctor` role, then open the clinic form.
   *
   * `assignDoctorRole` is fire-and-forget inside `completeOnboardingStep1` — it
   * is logged and not awaited there, deliberately, so a Keycloak blip cannot
   * fail a saved profile. That makes it a RACE with this refresh: a token minted
   * a moment too early carries no `doctor` role.
   *
   * Nothing on the next screen needs that role, so this never blocks. It is done
   * here rather than at the end because the token is refreshed again after the
   * clinic is created, and that second refresh is the one that has to carry both
   * — by which time the grant has had a whole form's worth of time to land.
   */ const adoptDoctorRole = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        setPhase($7e995a1f07376a6e$var$PHASE.DOCTOR_ADOPTING);
        try {
            await (0, $58BYB.refreshAccessToken)();
        } catch  {}
        // ── Already a founder: join, do not build a second clinic ─────────────
        //
        // Without this the track walks into the «هر حساب فقط یک کلینیک می‌سازد»
        // refusal below — which is correct about the clinic and wrong about the
        // person. They came here to become a doctor, they now ARE one, and the
        // clinic they founded through this panel has no practitioner record for
        // them. That is precisely what the join repairs, so it runs and the wizard
        // ends where it would have ended anyway.
        if (founderRow && !capabilities.multiFounder) {
            setCreatedId(founderRow.clinicId);
            setCreatedName(founderRow.clinicName || '');
            await finishDoctorTrack((0, $ett75.refOf)(founderRow) || founderRow.clinicId, founderRow.clinicId);
            return;
        }
        setPhase($7e995a1f07376a6e$var$PHASE.DETAILS);
    }, [
        founderRow,
        capabilities.multiFounder,
        finishDoctorTrack
    ]);
    /**
   * The practitioner record is written. Two things follow, in this order:
   * the wheel (if a campaign owes one — asked here because this is the moment
   * the BFF has the record the offer is decided from), and the token refresh
   * that adopts the `doctor` role the step just granted.
   */ const afterIdentity = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        const offered = await (0, $d6b627f40e94434c$export$42f52565954f5175)();
        if (offered) {
            setDraw(offered);
            setPhase($7e995a1f07376a6e$var$PHASE.PRIZE);
            return;
        }
        await adoptDoctorRole();
    // `adoptDoctorRole` and not `[]`: it closes over `founderRow`, which is read
    // from memberships that arrive asynchronously. Pinned at mount, a doctor
    // whose memberships had not loaded yet would be sent to the clinic form to
    // found a second clinic instead of being joined to the one they have.
    }, [
        adoptDoctorRole
    ]);
    /** «من پزشک نیستم» after all — drop the track and register a clinic only. */ const skipDoctor = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        setDoctorTrack(false);
        setPhase($7e995a1f07376a6e$var$PHASE.DETAILS);
    }, []);
    // The NEW clinic's currency, which prices «ویزیت» on the last step. Read from
    // its membership once the grants are re-read — which also covers a reload on
    // that step, when the form is empty — and from what the form chose until then.
    // Never the panel's own currency: during registration that is whichever
    // clinic the founder came from.
    const createdCurrency = memberships.find((m)=>m.clinicId === createdId)?.currency || form.currency || 'IRR';
    const steps = doctorTrack ? [
        {
            key: $7e995a1f07376a6e$var$PHASE.DOCTOR,
            label: t('auth.steps.doctor')
        },
        {
            key: $7e995a1f07376a6e$var$PHASE.DETAILS,
            label: t('auth.steps.details')
        },
        {
            key: $7e995a1f07376a6e$var$PHASE.ROLES,
            label: t('auth.steps.roles')
        }
    ] : [
        {
            key: $7e995a1f07376a6e$var$PHASE.DETAILS,
            label: t('auth.steps.details')
        },
        {
            key: $7e995a1f07376a6e$var$PHASE.ROLES,
            label: t('auth.steps.roles')
        }
    ];
    const onDoctor = phase === $7e995a1f07376a6e$var$PHASE.DOCTOR || phase === $7e995a1f07376a6e$var$PHASE.PRIZE || phase === $7e995a1f07376a6e$var$PHASE.DOCTOR_ADOPTING;
    const onRoles = phase === $7e995a1f07376a6e$var$PHASE.ROLES || phase === $7e995a1f07376a6e$var$PHASE.ENTERING;
    const onClosing = phase === $7e995a1f07376a6e$var$PHASE.LINKING || phase === $7e995a1f07376a6e$var$PHASE.DONE;
    const currentStep = onDoctor ? $7e995a1f07376a6e$var$PHASE.DOCTOR : onRoles || onClosing ? $7e995a1f07376a6e$var$PHASE.ROLES : $7e995a1f07376a6e$var$PHASE.DETAILS;
    const completedSteps = onDoctor ? [] : onClosing ? [
        $7e995a1f07376a6e$var$PHASE.DOCTOR,
        $7e995a1f07376a6e$var$PHASE.DETAILS,
        $7e995a1f07376a6e$var$PHASE.ROLES
    ] : onRoles ? [
        $7e995a1f07376a6e$var$PHASE.DOCTOR,
        $7e995a1f07376a6e$var$PHASE.DETAILS
    ] : [
        $7e995a1f07376a6e$var$PHASE.DOCTOR
    ];
    const shell = (children, { subtitle: subtitle, closable: closable = true } = {})=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $67626da34750e532$export$2e2bcd8739ae039), {
            width: "lg",
            align: "top",
            title: t(isAdditional ? 'clinic.start.addClinicTitle' : 'auth.createClinic.title'),
            subtitle: subtitle,
            testId: "onboarding",
            headerEnd: closable && isAdditional && phase === $7e995a1f07376a6e$var$PHASE.DETAILS ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5MbI8.default), {
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6TdpC.default), {
                    size: 18
                }),
                label: t('common.actions.cancel'),
                variant: "onGradient",
                size: 38,
                onClick: requestLeave,
                disabled: submitting
            }) : null,
            children: children
        });
    // ── The run, ahead of every guard below ───────────────────────────────────
    //
    // Once the run has created the clinic, the person IS a founder — and the
    // one-clinic guard below would take the screen over mid-run. The run makes
    // its own decisions about an existing or half-built clinic (quickSetup.js).
    // Iranian accounts only (an IRR visit price, the council's province): a brand
    // outside the Iranian market never runs it, even from a pasted URL.
    if (quick === 'run' && iranMarket) return shell(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $5c915477cc2d020f$export$2e2bcd8739ae039), {}), {
        subtitle: t('clinic.quickSetup.subtitle'),
        closable: false
    });
    // ── E1 · A half-built clinic is finished, never duplicated ────────────────
    //
    // Offering «ایجاد کلینیک جدید» to a founder whose saga half-applied is the move
    // that leaves them with TWO clinics of one name — the create no longer collides,
    // it succeeds, and the half-built one stays a husk nobody can enter. The only
    // correct action is the repair, so it is the only one offered.
    if (halfBuilt && phase === $7e995a1f07376a6e$var$PHASE.DETAILS) return shell(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2tqZa.default), {
        tone: "warning",
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1oGgm.default), {
            size: 26,
            "aria-hidden": "true"
        }),
        title: t('clinic.gate.repairTitle', {
            name: halfBuilt.clinicName
        }),
        body: t('clinic.gate.repairBody'),
        testId: "onboarding-repair",
        actions: [
            {
                key: 'repair',
                label: repairing ? t('clinic.gate.repairing') : t('clinic.gate.repairAction'),
                onClick: async ()=>{
                    setRepairing(true);
                    try {
                        await repairSetup(halfBuilt.clinicId);
                        enter((0, $ett75.refOf)(halfBuilt) || halfBuilt.clinicId);
                    } finally{
                        setRepairing(false);
                    }
                }
            }
        ]
    }));
    // ── F1 · One clinic per account, where the platform says so ──────────────
    //
    // `multiFounder` is the BFF's CLINIC_MULTI_FOUNDER, and the BFF enforces it:
    // with it off, `createClinic` refuses a founder with CLINIC_ALREADY_EXISTS. This
    // screen says so up front rather than after a filled-in form. With it on, a
    // founder falls through to the ordinary wizard.
    if (founderRow && !capabilities.multiFounder && phase === $7e995a1f07376a6e$var$PHASE.DETAILS) return shell(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2tqZa.default), {
        tone: "info",
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bOJgt.default), {
            size: 26,
            "aria-hidden": "true"
        }),
        title: t('auth.createClinic.oneClinicTitle'),
        body: t('auth.createClinic.oneClinicBody', {
            name: founderRow.clinicName
        }),
        testId: "onboarding-single-clinic",
        actions: [
            {
                key: 'go',
                label: t('clinic.gate.goToOther', {
                    name: founderRow.clinicName
                }),
                onClick: ()=>navigate(`/c/${(0, $ett75.refOf)(founderRow)}/`, {
                        replace: true
                    })
            }
        ]
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            shell(/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    quickName ? null : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a01dd7430bcac07f$export$2e2bcd8739ae039), {
                        steps: steps,
                        current: currentStep,
                        completed: completedSteps,
                        ariaLabel: t('auth.steps.ariaLabel')
                    }),
                    onDoctor && phase !== $7e995a1f07376a6e$var$PHASE.DOCTOR_ADOPTING ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d6b627f40e94434c$export$2e2bcd8739ae039), {
                        phase: phase === $7e995a1f07376a6e$var$PHASE.PRIZE ? 'prize' : 'doctor',
                        draw: draw,
                        onIdentityDone: afterIdentity,
                        onSkip: skipDoctor,
                        onPrizeDone: adoptDoctorRole,
                        disabled: offline
                    }) : null,
                    phase === $7e995a1f07376a6e$var$PHASE.DOCTOR_ADOPTING ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2fe914cfefd88860$export$2e2bcd8739ae039), {
                        state: "refreshing",
                        successTitle: t('auth.onboarding.doctorSaved'),
                        testId: "doctor-access-refresh"
                    }) : null,
                    phase === $7e995a1f07376a6e$var$PHASE.DETAILS && quickName ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7f759a25bea3679c$export$2e2bcd8739ae039), {
                        disabled: offline
                    }) : null,
                    phase === $7e995a1f07376a6e$var$PHASE.DETAILS && !quickName ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $580277ce4df84f5e$export$2e2bcd8739ae039), {
                        form: form,
                        region: region,
                        onChange: setField,
                        onPatch: patch,
                        errors: errors,
                        serverError: serverError,
                        onSubmit: submitDetails,
                        onRecover: recover,
                        submitting: submitting || repairing,
                        disabled: offline
                    }) : null,
                    phase === $7e995a1f07376a6e$var$PHASE.ADOPTING ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2fe914cfefd88860$export$2e2bcd8739ae039), {
                        state: adoptFailed ? 'failed' : 'refreshing',
                        successTitle: t('auth.createClinic.created', {
                            name: createdName
                        }),
                        onRetry: ()=>adopt($7e995a1f07376a6e$var$PHASE.ADOPTING, createdId),
                        // Walking on without the refresh is deliberately available. The
                        // clinic exists; the gate has named states for a stale token and
                        // for a half-applied setup, and either of them is a better place
                        // to be than a wizard that can only offer the same retry again.
                        onProceed: ()=>setPhase($7e995a1f07376a6e$var$PHASE.ROLES),
                        proceedLabel: t('auth.createClinic.continueAnyway')
                    }) : null,
                    onRoles && adoptFailed ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2fe914cfefd88860$export$2e2bcd8739ae039), {
                        state: "failed",
                        onRetry: ()=>adopt(phase === $7e995a1f07376a6e$var$PHASE.ENTERING ? $7e995a1f07376a6e$var$PHASE.ENTERING : $7e995a1f07376a6e$var$PHASE.ADOPTING, createdId),
                        onProceed: ()=>doctorTrack && phase === $7e995a1f07376a6e$var$PHASE.ENTERING ? finishDoctorTrack(createdId, createdId) : enter(createdId),
                        proceedLabel: t('auth.createClinic.enterWithoutRoles')
                    }) : null,
                    phase === $7e995a1f07376a6e$var$PHASE.ENTERING && !adoptFailed ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e78d5ad0755ec3d7$export$2e2bcd8739ae039), {
                        title: t('auth.createClinic.created', {
                            name: createdName
                        }),
                        body: t('auth.createClinic.entering')
                    }) : null,
                    onRoles && !(phase === $7e995a1f07376a6e$var$PHASE.ENTERING && !adoptFailed) ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $364296aa3ebb7529$export$2e2bcd8739ae039), {
                        currency: createdCurrency,
                        presenceDays: presenceDays,
                        doctorTrack: doctorTrack,
                        disabled: offline || phase === $7e995a1f07376a6e$var$PHASE.ENTERING,
                        onStaleAccess: ()=>setAdoptFailed(true),
                        onDone: (setup)=>{
                            setupRef.current = setup;
                            $7e995a1f07376a6e$var$rememberSetup(setup);
                            adopt($7e995a1f07376a6e$var$PHASE.ENTERING, createdId);
                        }
                    }, `${createdCurrency}|${presenceDays.join()}`) : null,
                    phase === $7e995a1f07376a6e$var$PHASE.LINKING ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e78d5ad0755ec3d7$export$2e2bcd8739ae039), {
                        title: t('auth.createClinic.created', {
                            name: createdName
                        }),
                        body: t('auth.onboarding.linking'),
                        testId: "onboarding-linking"
                    }) : null,
                    phase === $7e995a1f07376a6e$var$PHASE.DONE ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e78d5ad0755ec3d7$export$2e2bcd8739ae039), {
                        title: t('auth.createClinic.created', {
                            name: createdName
                        }),
                        body: linkFailed ? t('auth.onboarding.linkFailed') : t('auth.onboarding.joined'),
                        testId: "onboarding-done",
                        children: [
                            setupFailed ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                                variant: "warning",
                                "data-testid": "onboarding-hours-failed",
                                children: t('auth.onboarding.hoursFailed')
                            }) : null,
                            visitFailed ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                                variant: "warning",
                                "data-testid": "onboarding-visit-failed",
                                children: t('auth.onboarding.visitFailed')
                            }) : null,
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 10,
                                    width: '100%'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8e54e2ce06aafc96$export$d2cff7ea2eb1dd47), {
                                        fullWidth: true,
                                        onClick: ()=>enter(enterRef || createdId),
                                        "data-testid": "onboarding-enter-clinic",
                                        children: t('auth.onboarding.enterClinicPanel')
                                    }),
                                    linkFailed ? null : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                                        variant: "outline",
                                        onClick: ()=>(0, $ikL6D.openDoctorPanel)((0, $ikL6D.doctorHomeUrl)()),
                                        "data-testid": "onboarding-open-doctor-panel",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cxlxT.default), {
                                                size: 15,
                                                "aria-hidden": "true"
                                            }),
                                            t('auth.onboarding.openDoctorPanel')
                                        ]
                                    })
                                ]
                            })
                        ]
                    }) : null
                ]
            }), {
                subtitle: onDoctor ? t('auth.steps.doctor') : onClosing ? t('auth.onboarding.complete') : onRoles ? t('auth.steps.roles') : t('auth.createClinic.subtitle')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjPik.default), {
                open: confirmLeave,
                onOpenChange: setConfirmLeave,
                title: t('auth.createClinic.discardTitle'),
                description: t('auth.createClinic.discardBody'),
                confirmLabel: t('auth.createClinic.discardConfirm'),
                cancelLabel: t('common.actions.cancel'),
                destructive: true,
                onConfirm: ()=>{
                    setConfirmLeave(false);
                    leave();
                }
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("5N0ZI");
var $fvho4 = parcelRequire("fvho4");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

var $iAkVL = parcelRequire("iAkVL");

var $4sLBD = parcelRequire("4sLBD");
function $bdb11cac4b9e07d6$export$f5d07be676520812({ onManualSignIn: onManualSignIn, testId: testId = 'auth-redirect' }) {
    const { t: t } = (0, $e1LEq.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fvho4.SessionCheck), {
        testId: testId,
        logo: (0, $4sLBD.brandAsset)('logoWhite'),
        brandName: t('common.brand.name'),
        panelName: t('nav.title.clinicPanel'),
        title: t('auth.redirect.title'),
        subtitle: t('auth.redirect.subtitle'),
        stuckLabel: t('auth.redirect.stuck'),
        manualLabel: t('auth.redirect.manualLink'),
        onManualSignIn: onManualSignIn
    });
}
function $bdb11cac4b9e07d6$export$b1b568c16acfe3d1({ tone: tone = 'danger', title: title, body: body, detail: detail, actionLabel: actionLabel, onAction: onAction, testId: testId = 'auth-error', stateTestId: stateTestId }) {
    const { t: t } = (0, $e1LEq.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fvho4.SessionError), {
        testId: testId,
        stateTestId: stateTestId,
        tone: tone,
        logo: (0, $4sLBD.brandAsset)('logo'),
        brandName: t('common.brand.name'),
        title: title,
        body: body,
        detail: detail,
        actionLabel: actionLabel || t('common.actions.retry'),
        onAction: onAction,
        host: (0, $iAkVL.KC_BASE_URL).replace(/^https?:\/\//, '')
    });
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("5N0ZI");
var $kyZIh = parcelRequire("kyZIh");

var $2xQve = parcelRequire("2xQve");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");

function $9d9c187b8d5e95b0$export$2e2bcd8739ae039() {
    const { t: t } = (0, $e1LEq.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            padding: (0, $2xQve.PANEL_PAD).regular,
            maxWidth: 720
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kyZIh.default), {
                title: t('clinic.invitations.title'),
                subtitle: t('clinic.invitations.subtitle')
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c3bd3d08bbd0090c$export$2e2bcd8739ae039), {})
        ]
    });
}



var $7buzq = parcelRequire("7buzq");

var $6PcIc = parcelRequire("6PcIc");


var $acw62 = parcelRequire("acw62");
const $726b6fe7a5a2248f$export$cee99d5423ecee2e = 'parsina:chunk-reload';
const $726b6fe7a5a2248f$var$CHUNK_ERROR = new RegExp([
    'error loading dynamically imported module',
    'Failed to fetch dynamically imported module',
    'Importing a module script failed',
    'disallowed MIME type',
    'Loading chunk',
    'ChunkLoadError',
    'Could not load'
].join('|'), 'i');
function $726b6fe7a5a2248f$export$8a5d666d6e5b82fc(err) {
    if (!err) return false;
    return err.name === 'ChunkLoadError' || $726b6fe7a5a2248f$var$CHUNK_ERROR.test(String(err.message || err));
}
function $726b6fe7a5a2248f$var$sessionStore() {
    try {
        return window.sessionStorage;
    } catch  {
        return null;
    }
}
function $726b6fe7a5a2248f$export$781b63773dc1c72a(importer, { storage: storage = $726b6fe7a5a2248f$var$sessionStore(), reload: reload = ()=>window.location.reload() } = {}) {
    return importer().then((mod)=>{
        try {
            storage?.removeItem($726b6fe7a5a2248f$export$cee99d5423ecee2e);
        } catch  {}
        return mod;
    }, (err)=>{
        if (!$726b6fe7a5a2248f$export$8a5d666d6e5b82fc(err)) throw err;
        let alreadyReloaded = false;
        try {
            alreadyReloaded = storage?.getItem($726b6fe7a5a2248f$export$cee99d5423ecee2e) === '1';
        } catch  {}
        if (alreadyReloaded || !storage) throw err;
        try {
            storage.setItem($726b6fe7a5a2248f$export$cee99d5423ecee2e, '1');
        } catch  {
            throw err;
        }
        reload();
        // Never settles: the page is being replaced, and rendering anything in the
        // meantime would only flash an error the reload is about to fix.
        return new Promise(()=>{});
    });
}
const $726b6fe7a5a2248f$export$3a40ac72f213d409 = (importer, options)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).lazy(()=>$726b6fe7a5a2248f$export$781b63773dc1c72a(importer, options));



// ─────────────────────────────────────────────────────────────────────────────
// Service-worker registration — the one call that makes the panel installable.
//
// The `new URL('../../sw.js', import.meta.url)` form is not just a URL: it is
// how Parcel DISCOVERS the worker, compiles it for the service-worker
// environment, and emits it at the site root with a stable name. A plain
// string ('/sw.js') is refused by Parcel. Kept in its own module (as in the
// doctor app) so everything testable about PWA behaviour lives in pwa.js and
// swPolicy.js, and App.jsx is the only caller.
//
// The guards are the feature:
//   • production bundles only — a worker over the dev server poisons every
//     reload;
//   • automated browsers (Playwright sets navigator.webdriver) never
//     register, so e2e runs cannot leak cache state between tests;
//   • registration failure is silent — the panel ran without a worker for
//     its whole life and keeps working exactly the same without one.
// ─────────────────────────────────────────────────────────────────────────────
var $aac2e2be59c07ac3$exports = {};
$aac2e2be59c07ac3$exports = import.meta.resolve("2AiUB");


function $0f73dd0c16002d84$export$c6245babf0c60892() {
    if (typeof window === 'undefined' || typeof navigator === 'undefined') return;
    if (!('serviceWorker' in navigator)) return;
    if (navigator.webdriver) return;
    window.addEventListener('load', ()=>{
        // type: 'module' is what lets sw.js use ESM imports. Parcel resolves them
        // at build time and, since the emitted worker has none left, rewrites this
        // registration to a plain classic one — the option exists for the
        // bundler, not the browser.
        navigator.serviceWorker.register($aac2e2be59c07ac3$exports, {
            scope: '/'
        }).catch(()=>{
        /* no worker → no offline shell, nothing else changes */ });
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");
var $aphAM = parcelRequire("aphAM");

var $bSvYG = parcelRequire("bSvYG");
var $jis86 = parcelRequire("jis86");
var $kBNa0 = parcelRequire("kBNa0");
var $6uYpx = parcelRequire("6uYpx");
var $hwzM5 = parcelRequire("hwzM5");
parcelRequire("5N0ZI");
var $dOauK = parcelRequire("dOauK");
var $aJ1FU = parcelRequire("aJ1FU");
var $g6X9N = parcelRequire("g6X9N");
var $5AX1S = parcelRequire("5AX1S");
var $hZDga = parcelRequire("hZDga");
var $2tqZa = parcelRequire("2tqZa");
var $a7Rbr = parcelRequire("a7Rbr");

var $jTCZr = parcelRequire("jTCZr");
parcelRequire("7c6z4");
var $gVWNP = parcelRequire("gVWNP");
var $e1LEq = parcelRequire("e1LEq");

var $2xQve = parcelRequire("2xQve");


var $2Mst8 = parcelRequire("2Mst8");

var $58BYB = parcelRequire("58BYB");


var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("5N0ZI");
var $g6X9N = parcelRequire("g6X9N");
var $66joL = parcelRequire("66joL");

var $jTCZr = parcelRequire("jTCZr");

var $2xQve = parcelRequire("2xQve");
parcelRequire("7c6z4");
var $e1LEq = parcelRequire("e1LEq");
function $f7cb308236f7f8b0$export$2e2bcd8739ae039() {
    const { t: t } = (0, $e1LEq.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $66joL.SkeletonRegion), {
        label: t('common.state.loading'),
        "data-testid": "invite-skeleton",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $g6X9N.default), {
                style: {
                    padding: 18,
                    background: (0, $jTCZr.C).bg
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                        width: "55%",
                        height: 18,
                        style: {
                            marginBottom: 12
                        }
                    }),
                    [
                        0,
                        1,
                        2
                    ].map((i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                display: 'flex',
                                alignItems: 'center',
                                gap: 8,
                                marginTop: i ? 8 : 0
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                    width: 16,
                                    height: 16,
                                    radius: 4
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                                    width: `${34 + i * 19 % 40}%`,
                                    height: 13
                                })
                            ]
                        }, i))
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.default), {
                width: "100%",
                height: 52,
                radius: 12,
                style: {
                    marginTop: (0, $2xQve.STACK).regular
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    gap: 10,
                    marginTop: 20,
                    flexWrap: 'wrap'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonButton), {
                        style: {
                            flex: 1,
                            minWidth: 180,
                            width: 'auto'
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66joL.SkeletonButton), {
                        width: 96
                    })
                ]
            })
        ]
    });
}



var $iet7t = parcelRequire("iet7t");

/**
 * «دعوت‌نامه کلینیک» — the QR / link landing.
 *
 * Routed OUTSIDE `ClinicContextProvider` (see `AppShell`), because it is
 * answerable before anything is known about membership: it is how a person
 * with no clinic at all arrives. That has one consequence worth stating,
 * because it shapes the code below — this screen cannot ask the provider
 * anything, so the one question it does need answered («do they already have a
 * clinic to go back to?») is asked directly, after the join, and only to
 * decide which buttons to draw.
 *
 * ── The success state used to be a dead end ─────────────────────────────────
 *
 * «درخواست شما ثبت شد» was two lines of text and nothing else: no way to the
 * start page, no way back to a panel for someone who already had one. The
 * person scanned a code at a reception desk, got a sentence, and had to guess.
 * Every terminal state on this screen now carries a way forward.
 *
 * ── نام و نام خانوادگی (PM-0453) ─────────────────────────────────────────────
 *
 * A phone sign-up carries no name, and the request used to reach «همکاران» as
 * «بدون نام». The person now types both halves; the BFF writes them to their
 * Keycloak account and files the request under them. The fields start from the
 * name the account already has, so someone who has one only confirms it.
 */ const $ce62217e46558f2b$var$CLINIC_BY_CODE = `
  query ClinicByCode($code: String!) {
    clinicByInvitationCode(code: $code) {
      id name officePhone address clinicType city
    }
  }
`;
const $ce62217e46558f2b$var$JOIN_CLINIC = `
  mutation JoinClinic($code: String!, $firstName: String, $lastName: String) {
    joinClinicByInvitationCode(code: $code, firstName: $firstName, lastName: $lastName) { id name }
  }
`;
/** The longest half of a name the BFF accepts (`JOIN_NAME_MAX`). */ const $ce62217e46558f2b$var$NAME_MAX = 60;
/** The account's name as the sign-in token carries it — where the fields start. */ function $ce62217e46558f2b$var$accountName() {
    const claims = (0, $58BYB.parseJwt)((0, $58BYB.getToken)() || '') || {};
    return {
        first: claims.given_name || '',
        last: claims.family_name || ''
    };
}
/** The person's own memberships, asked without naming a clinic. */ const $ce62217e46558f2b$var$MY_MEMBERSHIPS = `
  query InviteMemberships {
    myMemberships { clinicId slug clinicName enterable }
  }
`;
/** One fact about the clinic, with its glyph. */ function $ce62217e46558f2b$var$Fact({ icon: Icon, children: children, ltr: ltr }) {
    if (!children) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: 8,
            marginTop: 6
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, {
                size: 14,
                color: (0, $jTCZr.C).textMuted,
                "aria-hidden": "true",
                style: {
                    marginTop: 3,
                    flexShrink: 0
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                style: {
                    fontSize: '0.78125rem',
                    color: (0, $jTCZr.C).textSecondary,
                    lineHeight: 1.7,
                    minWidth: 0,
                    ...ltr ? (0, $gVWNP.LTR_TEXT).style : null
                },
                dir: ltr ? (0, $gVWNP.LTR_TEXT).dir : undefined,
                children: children
            })
        ]
    });
}
function $ce62217e46558f2b$export$2e2bcd8739ae039() {
    const { t: t, formatList: formatList } = (0, $e1LEq.default)();
    const { code: code } = (0, $aphAM.useParams)();
    const navigate = (0, $aphAM.useNavigate)();
    const [clinic, setClinic] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [joining, setJoining] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [loadError, setLoadError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [joinError, setJoinError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [joined, setJoined] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [panelRef, setPanelRef] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [name, setName] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState($ce62217e46558f2b$var$accountName);
    const [nameErrors, setNameErrors] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({});
    (0, $ca9da969cb04cd38$export$2e2bcd8739ae039)(t('auth.invite.title'));
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!code) {
            setLoadError({
                message: t('errors.invite.invalidCode')
            });
            setLoading(false);
            return undefined;
        }
        let alive = true;
        (0, $2Mst8.bffQuery)($ce62217e46558f2b$var$CLINIC_BY_CODE, {
            code: code
        }, 'ClinicByCode').then((r)=>{
            if (!alive) return;
            const c = r?.clinicByInvitationCode;
            if (!c) setLoadError({
                message: t('errors.invite.notFoundOrExpired')
            });
            else setClinic(c);
        }).catch((e)=>{
            if (alive) setLoadError((0, $8d680f6b61d254a4$export$424a73c529ce205c)(e, 'join', t));
        }).finally(()=>{
            if (alive) setLoading(false);
        });
        return ()=>{
            alive = false;
        };
    }, [
        code,
        t
    ]);
    /**
   * Does this person already have a panel to go back to?
   *
   * Asked only after the outcome is known, and only to decide whether to draw
   * a second button. A failure here hides that button and is never surfaced —
   * it would be a second, irrelevant error on the screen that just delivered
   * the one that matters.
   */ const lookUpPanel = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        try {
            const r = await (0, $2Mst8.bffQuery)($ce62217e46558f2b$var$MY_MEMBERSHIPS, {}, 'InviteMemberships');
            const mine = (r?.myMemberships || []).find((m)=>m.enterable);
            if (mine) setPanelRef(mine.slug || mine.clinicId);
        } catch  {}
    }, []);
    const editName = (key)=>(e)=>{
            const { value: value } = e.target;
            setName((n)=>({
                    ...n,
                    [key]: value
                }));
            setNameErrors((errs)=>({
                    ...errs,
                    [key]: ''
                }));
        };
    const handleJoin = async ()=>{
        const firstName = name.first.trim();
        const lastName = name.last.trim();
        const tooLong = t('errors.invite.nameTooLong');
        const required = t('errors.invite.nameRequired');
        const errs = {
            first: !firstName ? required : firstName.length > $ce62217e46558f2b$var$NAME_MAX ? tooLong : '',
            last: !lastName ? required : lastName.length > $ce62217e46558f2b$var$NAME_MAX ? tooLong : ''
        };
        if (errs.first || errs.last) {
            setNameErrors(errs);
            return;
        }
        setJoining(true);
        setJoinError(null);
        try {
            await (0, $2Mst8.bffMutation)($ce62217e46558f2b$var$JOIN_CLINIC, {
                code: code,
                firstName: firstName,
                lastName: lastName
            }, 'JoinClinic');
            setJoined(true);
            lookUpPanel();
        } catch (e) {
            const described = (0, $8d680f6b61d254a4$export$424a73c529ce205c)(e, 'join', t);
            setJoinError(described);
            if (described.recovery === (0, $8d680f6b61d254a4$export$736a71bbf13ce3be).GO_TO_CLINIC && described.clinicId) setPanelRef(described.clinicId);
            setJoining(false);
        }
    };
    const goStart = {
        key: 'start',
        label: t('clinic.gate.goToStart'),
        onClick: ()=>navigate('/start')
    };
    const goPanel = panelRef ? {
        key: 'panel',
        label: t('clinic.start.backToPanel'),
        variant: 'outline',
        onClick: ()=>navigate(`/c/${panelRef}/`)
    } : null;
    // ── Loading ───────────────────────────────────────────────────────────────
    // The same shell as the loaded page, with the clinic card in blocks: the
    // shell paints once and the card fills in place (no spinner, no jump).
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67626da34750e532$export$2e2bcd8739ae039), {
        width: "md",
        testId: "invite",
        title: t('auth.invite.title'),
        subtitle: t('auth.invite.subtitle'),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7cb308236f7f8b0$export$2e2bcd8739ae039), {})
    });
    // ── The code is not a code ────────────────────────────────────────────────
    if (loadError) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67626da34750e532$export$2e2bcd8739ae039), {
        width: "md",
        testId: "invite",
        title: t('auth.invite.title'),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2tqZa.default), {
            tone: "danger",
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bSvYG.default), {
                size: 26,
                "aria-hidden": "true"
            }),
            title: t('auth.invite.invalidTitle'),
            body: loadError.message,
            testId: "invite-invalid",
            // No «وارد کردن کد دیگر»: «شروع» no longer takes a typed code. A
            // colleague is added by their number at the clinic's «همکاران».
            actions: [
                goStart
            ]
        })
    });
    // ── The request is in ─────────────────────────────────────────────────────
    if (joined) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67626da34750e532$export$2e2bcd8739ae039), {
        width: "md",
        testId: "invite",
        title: t('auth.invite.title'),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2tqZa.default), {
            tone: "info",
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kBNa0.default), {
                size: 26,
                "aria-hidden": "true"
            }),
            title: t('auth.invite.requestReceived'),
            body: t('auth.invite.awaitingApproval'),
            testId: "invite-joined",
            actions: [
                goStart,
                goPanel
            ].filter(Boolean)
        })
    });
    // ── The clinic, and the decision ──────────────────────────────────────────
    const blocking = joinError && joinError.recovery !== (0, $8d680f6b61d254a4$export$736a71bbf13ce3be).RETRY;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $67626da34750e532$export$2e2bcd8739ae039), {
        width: "md",
        testId: "invite",
        title: t('auth.invite.title'),
        subtitle: t('auth.invite.subtitle'),
        children: [
            clinic ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $g6X9N.default), {
                style: {
                    padding: 18,
                    background: (0, $jTCZr.C).bg
                },
                "data-testid": "invite-clinic",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: '1.03125rem',
                            fontWeight: 800,
                            color: (0, $jTCZr.C).textPrimary,
                            marginBottom: 4
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("bdi", {
                            children: clinic.name
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($ce62217e46558f2b$var$Fact, {
                        icon: (0, $jis86.default),
                        children: (0, $iet7t.clinicTypeLabel)(clinic.clinicType, t)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($ce62217e46558f2b$var$Fact, {
                        icon: (0, $6uYpx.default),
                        children: formatList([
                            clinic.city,
                            clinic.address
                        ].filter(Boolean), 'unit')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($ce62217e46558f2b$var$Fact, {
                        icon: (0, $hwzM5.default),
                        ltr: true,
                        children: (0, $5AX1S).forDisplay(clinic.officePhone)
                    })
                ]
            }) : null,
            blocking ? null : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
                    gap: (0, $2xQve.STACK).regular,
                    marginTop: (0, $2xQve.STACK).regular
                },
                "data-testid": "invite-name",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                        label: t('auth.invite.firstName'),
                        required: true,
                        value: name.first,
                        onChange: editName('first'),
                        error: nameErrors.first || undefined,
                        maxLength: $ce62217e46558f2b$var$NAME_MAX,
                        autoComplete: "given-name",
                        disabled: joining,
                        "data-testid": "invite-first-name"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7Rbr.default), {
                        label: t('auth.invite.lastName'),
                        required: true,
                        value: name.last,
                        onChange: editName('last'),
                        error: nameErrors.last || undefined,
                        helperText: nameErrors.last ? undefined : t('auth.invite.nameHelper'),
                        maxLength: $ce62217e46558f2b$var$NAME_MAX,
                        autoComplete: "family-name",
                        disabled: joining,
                        "data-testid": "invite-last-name"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                variant: "info",
                style: {
                    marginTop: (0, $2xQve.STACK).regular
                },
                children: t('auth.invite.approvalNotice')
            }),
            joinError ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dOauK.default), {
                variant: "error",
                role: "alert",
                style: {
                    marginTop: (0, $2xQve.STACK).regular
                },
                "data-testid": "invite-error",
                children: joinError.message
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    display: 'flex',
                    gap: 10,
                    marginTop: 20,
                    flexWrap: 'wrap'
                },
                children: blocking ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        panelRef ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                            onClick: ()=>navigate(`/c/${panelRef}/`),
                            "data-testid": "invite-go-panel",
                            children: t('clinic.start.backToPanel')
                        }) : null,
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                            variant: "outline",
                            onClick: ()=>navigate('/start'),
                            "data-testid": "invite-go-start",
                            children: t('clinic.gate.goToStart')
                        })
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aJ1FU.default), {
                            onClick: handleJoin,
                            disabled: joining,
                            "aria-busy": joining || undefined,
                            "data-testid": "invite-submit",
                            style: {
                                flex: 1,
                                minWidth: 180
                            },
                            children: [
                                joining ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hZDga.Spinner), {
                                    size: 14,
                                    color: "#fff",
                                    label: t('common.state.sending')
                                }) : null,
                                joining ? t('common.state.sending') : t('auth.invite.submit')
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aJ1FU.default), {
                            variant: "outline",
                            onClick: ()=>navigate('/start'),
                            disabled: joining,
                            "data-testid": "invite-cancel",
                            children: t('common.actions.cancel')
                        })
                    ]
                })
            })
        ]
    });
}




/* ── Route-level code splitting ──────────────────────────────────────────────
   Every screen used to be a static import, so the first bundle carried all of
   them: the 2200-line cash desk, the whole operations module with its four
   drawers, and the imaging dependencies — for a receptionist who opens one
   screen and stays on it.

   That is a desktop-sized bill charged to a phone. The clinic app now has a
   mobile shell, and the people using it are on a handset on a clinic's wifi,
   paying for the cash desk on the way to the day list.

   `Suspense` sits INSIDE the shell (below), so a chunk arriving late shows the
   destination page's own skeleton where the screen goes rather than blanking
   the navigation the operator is using to get there. `Invite` stays eager: it is the pre-auth
   landing for a QR scan, and a person standing at a clinic desk with a
   just-scanned code should not wait for a second round trip.

   `lazyWithReload`, not React.lazy: a tab opened before a deploy asks for the
   previous build's chunk names, and reloading once fetches the current ones. */ const $3712292999d2a2f0$var$ClinicScreen = (0, $726b6fe7a5a2248f$export$3a40ac72f213d409)(()=>(parcelRequire("aDWH4")));

const $3712292999d2a2f0$var$ReceptionScreen = (0, $726b6fe7a5a2248f$export$3a40ac72f213d409)(()=>(parcelRequire("82CjW")));

const $3712292999d2a2f0$var$PatientsScreen = (0, $726b6fe7a5a2248f$export$3a40ac72f213d409)(()=>(parcelRequire("iPwX0")));

const $3712292999d2a2f0$var$SettingsScreen = (0, $726b6fe7a5a2248f$export$3a40ac72f213d409)(()=>(parcelRequire("3qRld")));

const $3712292999d2a2f0$var$AddPatientScreen = (0, $726b6fe7a5a2248f$export$3a40ac72f213d409)(()=>(parcelRequire("g8I2F")));

const $3712292999d2a2f0$var$OperationsScreen = (0, $726b6fe7a5a2248f$export$3a40ac72f213d409)(()=>(parcelRequire("if1aE")));

const $3712292999d2a2f0$var$GoodsScreen = (0, $726b6fe7a5a2248f$export$3a40ac72f213d409)(()=>(parcelRequire("fOJ5D")));

const $3712292999d2a2f0$var$StoreScreen = (0, $726b6fe7a5a2248f$export$3a40ac72f213d409)(()=>(parcelRequire("bigDG")));

const $3712292999d2a2f0$var$ReportsScreen = (0, $726b6fe7a5a2248f$export$3a40ac72f213d409)(()=>(parcelRequire("iHwC3")));

const $3712292999d2a2f0$var$AccountingScreen = (0, $726b6fe7a5a2248f$export$3a40ac72f213d409)(()=>(parcelRequire("7sqtK")));

const $3712292999d2a2f0$var$PeopleScreen = (0, $726b6fe7a5a2248f$export$3a40ac72f213d409)(()=>(parcelRequire("6aRKN")));

const $3712292999d2a2f0$var$RoleEditorScreen = (0, $726b6fe7a5a2248f$export$3a40ac72f213d409)(()=>(parcelRequire("eJLnU")));

// The shared clinical screens — the heaviest code the panel can load, and only a
// practitioner of the clinic ever does, so they are their own chunks.
const $3712292999d2a2f0$var$ClinicalVisitRoute = (0, $726b6fe7a5a2248f$export$3a40ac72f213d409)(()=>(parcelRequire("d42w1")));

const $3712292999d2a2f0$var$ClinicalRecordRoute = (0, $726b6fe7a5a2248f$export$3a40ac72f213d409)(()=>(parcelRequire("gl7sp")));
// Which paths render inside ClinicLayout — i.e. get the sidebar. A path missing
// here still routes and still renders; it just loses the whole shell, silently.
// That is how «عملیات و هزینه» shipped sidebar-less: the merge added /operations
// to the route table and to ROUTES, and this list was left behind. The legacy
// /inventory, /expenses and /services entries stay so their redirect frame keeps
// the shell too — otherwise the sidebar blinks out on the way through, and so
// does /goods, for the same reason and with the same failure mode if forgotten.
const $3712292999d2a2f0$var$WEB_LAYOUT_PREFIXES = [
    '/reception',
    '/patients',
    '/operations',
    '/goods',
    '/store',
    '/inventory',
    '/reports',
    '/accounting',
    '/expenses',
    '/about',
    '/doctors',
    '/services',
    '/people',
    '/subscription',
    '/clinic',
    '/settings'
];
/**
 * `/subscription` and `/about` → «کلینیک من», with the query string intact.
 *
 * Forwarding the query is not tidiness. A checkout started before this merge
 * shipped has `${origin}/subscription` stored as its return URL inside the
 * payment record, and the payment BFF appends `?payment=success&ref_id=…` to
 * whatever that says. Dropping the query on the way through would land a clinic
 * that has just paid on a page with no idea it happened — no toast, no refresh,
 * and a status that still reads «منقضی شده».
 */ const $3712292999d2a2f0$var$MergedClinicRedirect = ({ view: view })=>{
    const location = (0, $aphAM.useLocation)();
    const params = new URLSearchParams(location.search);
    params.set('view', view);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
        to: {
            pathname: '/clinic',
            search: `?${params.toString()}`
        },
        replace: true
    });
};
/**
 * `/clinic/:view` → `/clinic?view=:view`.
 *
 * The BFF hands out `renewUrl: '/clinic/billing'` in every entitlement error, so
 * that path has to resolve to something. An unknown segment falls through to the
 * page's own normalisation rather than 404-ing.
 */ /**
 * `/payroll?y=&m=` → `/people?tab=payroll&y=&m=`.
 *
 * A `<Navigate>` with a literal search would drop the month, which is the one
 * thing a payroll bookmark is FOR. The two parameter names are unchanged across
 * the move (`People/payroll.js` owns them for both halves), so carrying the query
 * through verbatim is the whole redirect.
 */ const $3712292999d2a2f0$var$PayrollRedirect = ()=>{
    const location = (0, $aphAM.useLocation)();
    const params = new URLSearchParams(location.search);
    params.set('tab', 'payroll');
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
        to: {
            pathname: '../people',
            search: `?${params.toString()}`
        },
        replace: true
    });
};
const $3712292999d2a2f0$var$ClinicViewAlias = ()=>{
    const { view: view } = (0, $aphAM.useParams)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
        to: `/clinic?view=${encodeURIComponent(view || '')}`,
        replace: true
    });
};
/**
 * `/operations` — «مدیریت هزینه‌ها», or a forward to «کالاها و خدمات».
 *
 * Eleven of the merged module's sixteen `?view=` values moved to `/goods` on
 * 2026-09-12, and there are years of links at the old address: bookmarks, links
 * pasted into messages, the reception dashboard's alert tiles, the report
 * drill-downs. Each one has to land on the view it named, so this asks the rail
 * which page owns the requested view and forwards the ones that left.
 *
 * Three things it does deliberately:
 *
 *  1. **The whole query string travels.** `?view=services&service=<id>` arrives
 *     at `/goods` intact, so a later fix to that deep link needs no second
 *     redirect and no second place to remember it.
 *  2. **It is relative** (`../goods`), like the legacy redirects beside it: an
 *     absolute `/goods` leaves the clinic, and `LegacyPathRedirect` would then
 *     re-enter through the person's DEFAULT clinic — so a link opened at the
 *     Isfahan branch would quietly land in Tehran.
 *  3. **It runs before the screen's chunk.** Returning early means the
 *     `OperationsScreen` lazy component is never rendered and therefore never
 *     fetched, so an old `?view=items` link downloads one chunk, not two.
 *
 * A view the rail does not know (a typo, a retired key) is NOT forwarded — the
 * expenses page normalises it to the first entry that person may open, which is
 * the behaviour a bad `?view=` has always had.
 */ const $3712292999d2a2f0$var$OperationsOrGoods = ()=>{
    const location = (0, $aphAM.useLocation)();
    const requested = new URLSearchParams(location.search).get('view');
    if ((0, $6PcIc.isGoodsView)(requested)) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
        to: {
            pathname: '../goods',
            search: location.search
        },
        replace: true
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $163b9777c503a48b$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($3712292999d2a2f0$var$OperationsScreen, {})
    });
};
/**
 * Adopt the language stored on the signed-in user.
 *
 * The panel has already painted — the pre-paint script in index.html and
 * I18nProvider both read the localStorage cache, so the first frame is in the
 * right language and direction. This only catches the case the cache cannot:
 * a staff member who chose English at one workstation and is now at another,
 * or one whose cache was cleared. `setLocale` ignores an empty or unshipped
 * tag, so a null `language` (never chosen) leaves the resolution order alone.
 *
 * Renders nothing: it exists so the effect sits inside the authed tree, where
 * `myProfile` is actually answerable, without wrapping the shell in a layer.
 */ const $3712292999d2a2f0$var$LanguageSync = ()=>{
    const { setLocale: setLocale } = (0, $e1LEq.default)();
    const { profile: profile } = (0, $goZUH.useMyProfile)();
    const language = profile?.language;
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (language) setLocale(language);
    }, [
        language,
        setLocale
    ]);
    return null;
};
/**
 * The clinic-scoped route table.
 *
 * Rendered under `/c/:clinicRef/*`, so every path here is relative — react-router
 * resolves them against the prefix and the tenant never has to be threaded through
 * a single one of them.
 *
 * The legacy redirects are relative too, which is what keeps them inside the
 * clinic: `<Navigate to="../operations?view=items">` from `/c/mehr/inventory` lands
 * on `/c/mehr/operations?view=items`. An absolute `/operations` would have dropped
 * the person out of their clinic on the way through a redirect they never saw.
 */ const $3712292999d2a2f0$var$ClinicRoutes = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aphAM.Routes), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                path: "/",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $163b9777c503a48b$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {})
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                path: "reception",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $163b9777c503a48b$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($3712292999d2a2f0$var$ReceptionScreen, {})
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                path: "dashboard",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
                    to: "../reception",
                    replace: true
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                path: "patients",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $163b9777c503a48b$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($3712292999d2a2f0$var$PatientsScreen, {})
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                path: "patients/new",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $163b9777c503a48b$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($3712292999d2a2f0$var$AddPatientScreen, {})
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                path: "patients/:patientId/record/:tab?",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $163b9777c503a48b$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($3712292999d2a2f0$var$ClinicalRecordRoute, {})
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                path: "visit/:patientId",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $163b9777c503a48b$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($3712292999d2a2f0$var$ClinicalVisitRoute, {})
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                path: "operations",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)($3712292999d2a2f0$var$OperationsOrGoods, {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                path: "goods",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $163b9777c503a48b$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($3712292999d2a2f0$var$GoodsScreen, {})
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                path: "store",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $163b9777c503a48b$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($3712292999d2a2f0$var$StoreScreen, {})
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                path: "inventory",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
                    to: "../goods?view=items",
                    replace: true
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                path: "reports",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $163b9777c503a48b$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($3712292999d2a2f0$var$ReportsScreen, {})
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                path: "accounting",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $163b9777c503a48b$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($3712292999d2a2f0$var$AccountingScreen, {})
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                path: "expenses",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
                    to: "../operations?view=expenses",
                    replace: true
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                path: "about",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)($3712292999d2a2f0$var$MergedClinicRedirect, {
                    view: "connect"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                path: "services",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
                    to: "../goods?view=services",
                    replace: true
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                path: "calendar",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
                    to: "../reception",
                    replace: true
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                path: "doctors",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
                    to: "../people?kind=practitioner",
                    replace: true
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                path: "people",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $163b9777c503a48b$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($3712292999d2a2f0$var$PeopleScreen, {})
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                path: "people/roles/:roleId",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $163b9777c503a48b$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($3712292999d2a2f0$var$RoleEditorScreen, {})
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                path: "payroll",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)($3712292999d2a2f0$var$PayrollRedirect, {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                path: "settings",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $163b9777c503a48b$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($3712292999d2a2f0$var$SettingsScreen, {})
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                path: "clinic",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $163b9777c503a48b$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($3712292999d2a2f0$var$ClinicScreen, {})
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                path: "clinic/:view",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)($3712292999d2a2f0$var$ClinicViewAlias, {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                path: "subscription",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)($3712292999d2a2f0$var$MergedClinicRedirect, {
                    view: "billing"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                path: "*",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $163b9777c503a48b$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {})
                })
            })
        ]
    });
/**
 * Legacy un-prefixed paths → the same path inside the person's default clinic.
 *
 * Every bookmark, every link in a message and every muscle-memory URL predates the
 * `/c/:ref` prefix, and there are years of them. They must not land on «شروع» —
 * that would read as "you have been removed from your clinic" to someone whose only
 * mistake was having a bookmark.
 */ const $3712292999d2a2f0$var$LegacyPathRedirect = ()=>{
    const location = (0, $aphAM.useLocation)();
    const { defaultRef: defaultRef } = (0, $ett75.useClinicContext)();
    if (!defaultRef) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
        to: "/start",
        replace: true
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
        to: `/c/${defaultRef}${location.pathname}${location.search}`,
        replace: true
    });
};
/**
 * The router, once memberships are known.
 *
 * FIVE boot outcomes, not two. «The query failed» and «this person genuinely has no
 * clinic» used to collapse into hasClinic=false, whose only rendering is the
 * onboarding wizard — so a database blip told a clinic owner of three years to go
 * create their clinic. That reasoning extends verbatim to the two states this
 * design adds: «waiting on an invitation» and «belongs to several» are answers the
 * BFF actually gave, and neither may be rendered as a failure or as an emptiness.
 */ const $3712292999d2a2f0$var$RoutedApp = ()=>{
    const { t: t } = (0, $e1LEq.default)();
    const location = (0, $aphAM.useLocation)();
    const { state: state, defaultRef: defaultRef, error: error, reload: reload, activeRef: activeRef } = (0, $ett75.useClinicContext)();
    const barePath = (0, $7buzq.stripClinic)(location.pathname);
    const inLayout = Boolean(activeRef) && ($3712292999d2a2f0$var$WEB_LAYOUT_PREFIXES.some((p)=>barePath.startsWith(p)) || barePath === '/');
    // The SAME card the sign-in check showed, continued rather than replaced:
    // the doctor panel keeps one card up for its whole boot, and so does this.
    if (state === (0, $ett75.BOOT).LOADING) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bdb11cac4b9e07d6$export$f5d07be676520812), {
        onManualSignIn: ()=>(0, $58BYB.redirectToLogin)(),
        testId: "boot-loading"
    });
    // The backend could not answer. Say so and offer a retry — never the wizard,
    // which would invite a duplicate clinic for someone who already has one.
    if (state === (0, $ett75.BOOT).ERROR) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bdb11cac4b9e07d6$export$b1b568c16acfe3d1), {
        tone: "warning",
        testId: "boot-error",
        stateTestId: "boot-error-state",
        title: t('errors.network.noServer'),
        body: t('errors.clinic.unavailable'),
        detail: error || undefined,
        onAction: ()=>reload()
    });
    // Nothing to enter. «شروع» is the whole app here: creating a clinic, entering a
    // code, and any invitation waiting are all reachable from it, so it is not a dead
    // end even though it is not a panel. The catch-all remembers a landing-site
    // «خرید اشتراک» on its way past, so onboarding ends on «اشتراک» (StartRedirect).
    if (state === (0, $ett75.BOOT).NONE || state === (0, $ett75.BOOT).PENDING_ONLY) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aphAM.Routes), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                path: "/start",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $528774ba5d5aa222$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                path: "/onboarding",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7e995a1f07376a6e$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                path: "/invitations",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
                    to: "/start",
                    replace: true
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                path: "*",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $07a2ef0de2415234$export$2e2bcd8739ae039), {})
            })
        ]
    });
    const routes = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aphAM.Routes), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                path: "/start",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $528774ba5d5aa222$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                path: "/onboarding",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7e995a1f07376a6e$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                path: "/invitations",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9d9c187b8d5e95b0$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                path: "/c/:clinicRef/*",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)($3712292999d2a2f0$var$ClinicRoutes, {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                path: "/",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
                    to: `/c/${defaultRef}/`,
                    replace: true
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                path: "*",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)($3712292999d2a2f0$var$LegacyPathRedirect, {})
            })
        ]
    });
    // Remounted on the clinic ref. This ONE line is what makes «no stale row survives
    // a switch» structural rather than a review checklist: every screen, filter,
    // drawer and cached list belonging to the previous clinic is thrown away, because
    // the alternative is trusting sixteen screens to each remember to clear themselves.
    // The boundary for the lazy route chunks. It sits here — INSIDE the fragment
    // that ClinicLayout wraps — so that a chunk still arriving leaves the shell
    // painted: the sidebar, or on a phone the bottom navigation, stays on screen
    // and stays operable. A Suspense placed around the layout instead would blank
    // the very navigation the operator just used, which reads as the app having
    // crashed rather than as a screen loading.
    const keyed = /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
            fallback: /*#__PURE__*/ (0, $ayMG0.jsx)($3712292999d2a2f0$var$ScreenFallback, {}),
            children: routes
        })
    }, activeRef || 'none');
    // Outside the layout — including `/onboarding` once the clinic exists, i.e.
    // the roles step — the screen sits in `.bare-screen`, sized in styles.css by
    // the SMALL viewport. It was `height: 100vh` here, which on iOS is the large
    // one: its bottom sat under Safari's toolbar, and «ساخت نقش‌ها و ورود» with it.
    return inLayout ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1dea2a187eaa8cfa$export$2e2bcd8739ae039), {
        children: keyed
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "bare-screen",
        children: keyed
    });
};
/**
 * What a route shows while its chunk is still in flight.
 *
 * The DESTINATION page's own skeleton, chosen from the URL (`skeletons.jsx`),
 * so the transition draws the shape of the page that is coming — its header,
 * its filters, its table — and the data fills it in place. Not a spinner: the
 * shell around this is already painted, and a spinner where a page should be
 * is a small blank moment in which the panel forgets which page it is on
 * (DESIGN.md §"Loading & skeleton" — navigation). It fills its container so
 * nothing collapses and jumps when the real content arrives.
 *
 * The pre-membership routes (`/start`, `/onboarding`, `/invitations`) are
 * eager imports and never suspend; the bare `role="status"` box is only for a
 * path this app has no page for, which the gate turns into «not found» next.
 */ const $3712292999d2a2f0$var$ScreenFallback = ()=>{
    const location = (0, $aphAM.useLocation)();
    const { t: t } = (0, $e1LEq.default)();
    return(// `height`, not `flex` — the shell's page-content column is a block with
    // `overflow-y: auto`, not a flex container, so `flex: 1` here resolved to
    // nothing and this box fell back to its content height. A skeleton inside
    // it then measured `height: 100%` against an auto-height parent, which CSS
    // ignores, so every route skeleton collapsed to the height of its own
    // blocks while the real screen — a direct child of that column — filled.
    // That is the one difference between the two, and it has to be zero: the
    // fallback IS the shape of the page that is coming.
    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: {
            height: '100%',
            minHeight: 0,
            display: 'flex',
            flexDirection: 'column'
        },
        "data-testid": "screen-fallback",
        children: (0, $70c21bb38a31c977$export$95f7d3859a3c0041)(location.pathname, location.search) || /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            role: "status",
            "aria-busy": "true",
            "aria-label": t('common.state.loading'),
            "data-state": "loading",
            style: {
                flex: 1
            }
        })
    }));
};
const $3712292999d2a2f0$var$AppShell = ()=>{
    const location = (0, $aphAM.useLocation)();
    // `/invite/:code` is answerable before anything is known about membership — it is
    // how a person with no clinic at all arrives — so it is routed OUTSIDE the
    // provider's boot gate rather than behind it.
    if (location.pathname.startsWith('/invite/')) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Routes), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
            path: "/invite/:code",
            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ce62217e46558f2b$export$2e2bcd8739ae039), {})
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ett75.ClinicContextProvider), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($3712292999d2a2f0$var$RoutedApp, {})
    });
};
const $3712292999d2a2f0$var$App = ()=>{
    const { t: t } = (0, $e1LEq.default)();
    const [authReady, setAuthReady] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [authError, setAuthError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [bootOffline, setBootOffline] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        (async ()=>{
            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.get('auth_error')) {
                window.history.replaceState({}, '', '/');
                setAuthError(t('errors.auth.serviceUnreachable'));
                return;
            }
            // Every sign-in below is a full navigation to Keycloak. As an installed
            // app (docs/PWA.md) the service worker can boot this shell with no
            // network, and that navigation would replace the window the person just
            // opened from the taskbar with the browser's own connection-error page.
            // Say what happened instead, and offer the one action that helps.
            const signIn = async ()=>{
                if (typeof navigator !== 'undefined' && navigator.onLine === false) {
                    setBootOffline(true);
                    return;
                }
                await (0, $58BYB.redirectToLogin)();
            };
            if (urlParams.has('code')) {
                const ok = await (0, $58BYB.handleCallback)();
                if (!ok) {
                    await signIn();
                    return;
                }
            }
            let token = (0, $58BYB.getToken)();
            // A new tab or a reopened browser has no access token but may hold the
            // 30-day refresh token: sign in silently from it first (PM-0158).
            if (!token && (0, $58BYB.getRefresh)() && await (0, $58BYB.refreshAccessToken)()) token = (0, $58BYB.getToken)();
            if (!token) {
                await signIn();
                return;
            }
            if ((0, $58BYB.isTokenExpired)(token)) {
                const refreshed = (0, $58BYB.getRefresh)() ? await (0, $58BYB.refreshAccessToken)() : false;
                if (!refreshed) {
                    await signIn();
                    return;
                }
                token = (0, $58BYB.getToken)();
            }
            (0, $58BYB.parseJwt)(token);
            (0, $58BYB.clearRedirectGuard)();
            setAuthReady(true);
        })();
    }, []);
    // Both states are the doctor panel's boot card (BootScreen.jsx), which is
    // the reference for how signing in looks in every Parsina panel.
    if (bootOffline) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bdb11cac4b9e07d6$export$b1b568c16acfe3d1), {
        tone: "warning",
        testId: "boot-offline",
        title: t('errors.auth.offlineTitle'),
        body: t('errors.auth.offlineBody'),
        onAction: ()=>{
            window.location.reload();
        }
    });
    if (authError) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bdb11cac4b9e07d6$export$b1b568c16acfe3d1), {
        testId: "auth-error",
        stateTestId: "auth-error-state",
        title: t('errors.auth.title'),
        body: authError,
        onAction: ()=>{
            window.location.href = '/';
        }
    });
    if (!authReady) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bdb11cac4b9e07d6$export$f5d07be676520812), {
        onManualSignIn: ()=>(0, $58BYB.redirectToLogin)()
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6usBW.ToastProvider), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.BrowserRouter), {
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ciRrJ.ShortcutProvider), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($3712292999d2a2f0$var$LanguageSync, {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($3712292999d2a2f0$var$AppShell, {})
                ]
            })
        })
    });
};
// Before the first render: capture `beforeinstallprompt` (Edge/Chrome on
// Windows can fire it while React is still mounting), take jump-list launches
// into this window, and register the service worker (docs/PWA.md).
(0, $8927aec8e5f774d0$export$1ffc9258e44c4084)();
(0, $0f73dd0c16002d84$export$c6245babf0c60892)();
// I18nProvider is outermost, ABOVE ToastProvider and App, because everything
// below it reads its copy through `t` — including the auth and onboarding
// screens, which render long before `myProfile` resolves. It takes the language
// from the same localStorage cache the pre-paint script in index.html used, so
// `dir` never changes between the first frame and the first render, and the
// server's copy is adopted later by <LanguageSync/> without a reload.
(0, (/*@__PURE__*/$parcel$interopDefault($7e96a608cb33bf79$exports))).createRoot(document.getElementById('root')).render(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $kJBdz.default), {
    children: /*#__PURE__*/ (0, $ayMG0.jsx)($3712292999d2a2f0$var$App, {})
}));


//# sourceMappingURL=app.c233a287.js.map
